(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 80222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ datadogRum; }
});

// UNUSED EXPORTS: DefaultPrivacyLevel

;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var display = function (api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!Object.prototype.hasOwnProperty.call(ConsoleApiName, api)) {
        api = ConsoleApiName.log;
    }
    display[api].apply(display, args);
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
display.debug = globalConsole.debug.bind(globalConsole);
display.log = globalConsole.log.bind(globalConsole);
display.info = globalConsole.info.bind(globalConsole);
display.warn = globalConsole.warn.bind(globalConsole);
display.error = globalConsole.error.bind(globalConsole);
//# sourceMappingURL=display.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(ConsoleApiName.error, e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(ConsoleApiName.error, e);
            }
        }
    }
}
function displayIfDebugEnabled(api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugMode) {
        display.apply(void 0, __spreadArray([api, '[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function polyfills_assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
//# sourceMappingURL=polyfills.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js



function makePublicApi(stub) {
    var publicApi = polyfills_assign({
        version: "4.44.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return catchUserErrors(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
//# sourceMappingURL=getGlobalObject.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
//# sourceMappingURL=byteUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = getGlobalObject();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js



function timer_setTimeout(callback, delay) {
    return getZoneJsOriginalValue(getGlobalObject(), 'setTimeout')(monitor(callback), delay);
}
function timer_clearTimeout(timeoutId) {
    getZoneJsOriginalValue(getGlobalObject(), 'clearTimeout')(timeoutId);
}
function timer_setInterval(callback, delay) {
    return getZoneJsOriginalValue(window, 'setInterval')(monitor(callback), delay);
}
function timer_clearInterval(timeoutId) {
    getZoneJsOriginalValue(window, 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js

// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = timer_setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            timer_clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
//# sourceMappingURL=functionUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/mergeInto.js

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return noop;
}
//# sourceMappingURL=jsonStringify.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * ONE_KIBI_BYTE;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) { maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    display.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/heavyCustomerDataWarning.js


// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * ONE_KIBI_BYTE;
function warnIfCustomerDataLimitReached(bytesCount, customerDataType) {
    if (bytesCount > CUSTOMER_DATA_BYTES_LIMIT) {
        display.warn("The ".concat(customerDataType, " data is over ").concat(CUSTOMER_DATA_BYTES_LIMIT / ONE_KIBI_BYTE, "KiB. On low connectivity, the SDK has the potential to exhaust the user's upload bandwidth."));
        return true;
    }
    return false;
}
//# sourceMappingURL=heavyCustomerDataWarning.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/contextManager.js






var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createContextManager(customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = computeBytesCount; }
    var context = {};
    var bytesCountCache;
    var alreadyWarned = false;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var computeBytesCountThrottled = throttle(function (context) {
        bytesCountCache = computeBytesCountImpl(jsonStringify(context));
        if (!alreadyWarned) {
            alreadyWarned = warnIfCustomerDataLimitReached(bytesCountCache, customerDataType);
        }
    }, BYTES_COMPUTATION_THROTTLING_DELAY).throttled;
    return {
        getBytesCount: function () { return bytesCountCache; },
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
            computeBytesCountThrottled(context);
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
            computeBytesCountThrottled(context);
        },
        getContext: function () { return deepClone(context); },
        setContext: function (newContext) {
            context = sanitize(newContext);
            computeBytesCountThrottled(context);
        },
        setContextProperty: function (key, property) {
            context[key] = sanitize(property);
            computeBytesCountThrottled(context);
        },
        removeContextProperty: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
        },
        clearContext: function () {
            context = {};
            bytesCountCache = 0;
        },
    };
}
//# sourceMappingURL=contextManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!isNumber(duration)) {
        return duration;
    }
    return round(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
//# sourceMappingURL=stringUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js



function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return findCommaSeparatedValue(document.cookie, name);
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat(generateUUID());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, ONE_MINUTE, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat(generateUUID());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || getCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || getCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js


function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || endsWith(currentHost, ".".concat(allowedHost)); }));
}
function getEventBridgeGlobal() {
    return getGlobalObject().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js

var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && startsWith(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=computeStackTrace.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.js





var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = hasUsableStack(isErrorInstance, stackTrace)
        ? toStackTraceString(stackTrace)
        : NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat(jsonStringify(sanitize(originalError)))
            : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            noop();
        }
    }
    callMonitored(function () {
        var stackTrace = computeStackTrace(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = computeStackTrace(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/user/user.js



/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = polyfills_assign({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = getType(newUser) === 'object';
    if (!isValid) {
        display.error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["PAGE_STATES"] = "page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["NO_RESOURCE_DURATION_FROZEN_STATE"] = "no_resource_duration_frozen_state";
    ExperimentalFeature["SCROLLMAP"] = "scrollmap";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js

function shallowClone(object) {
    return polyfills_assign({}, object);
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
//# sourceMappingURL=observable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js

var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
//# sourceMappingURL=sessionConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionState.js




var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
function isSessionInExpiredState(session) {
    return isEmptyObject(session);
}
function expandSessionState(session) {
    session.expire = String(dateNow() + SESSION_EXPIRATION_DELAY);
}
function toSessionString(session) {
    return objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js



var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = getCookie(SESSION_STORE_KEY);
    if (!sessionString) {
        var oldSessionId = getCookie(OLD_SESSION_COOKIE_NAME);
        var oldRumType = getCookie(OLD_RUM_COOKIE_NAME);
        var oldLogsType = getCookie(OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        if (!isSessionInExpiredState(session)) {
            expandSessionState(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js





function selectCookieStrategy(initConfiguration) {
    var cookieOptions = buildCookieOptions(initConfiguration);
    return areCookiesAuthorized(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
function initCookieStrategy(cookieOptions) {
    var cookieStore = {
        persistSession: persistSessionCookie(cookieOptions),
        retrieveSession: retrieveSessionCookie,
        clearSession: deleteSessionCookie(cookieOptions),
    };
    tryOldCookiesMigration(cookieStore);
    return cookieStore;
}
function persistSessionCookie(options) {
    return function (session) {
        setCookie(SESSION_STORE_KEY, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
    };
}
function retrieveSessionCookie() {
    var sessionString = getCookie(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function deleteSessionCookie(options) {
    return function () {
        deleteCookie(SESSION_STORE_KEY, options);
    };
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = getCurrentSite();
    }
    return cookieOptions;
}
//# sourceMappingURL=sessionInCookie.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js



var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        var id = generateUUID();
        var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
function initLocalStorageStrategy() {
    return {
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        clearSession: clearSessionFromLocalStorage,
    };
}
function persistInLocalStorage(sessionState) {
    localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function clearSessionFromLocalStorage() {
    localStorage.removeItem(SESSION_STORE_KEY);
}
//# sourceMappingURL=sessionInLocalStorage.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
function isIE() {
    return Boolean(document.documentMode);
}
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
//# sourceMappingURL=browserDetection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStoreOperations.js




var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    var lockEnabled = isLockEnabled();
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (lockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (lockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = generateUUID();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (lockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if (isSessionInExpiredState(processedSession)) {
            clearSession();
        }
        else {
            expandSessionState(processedSession);
            persistSession(processedSession);
        }
    }
    if (lockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isSessionInExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next(sessionStoreStrategy);
}
/**
 * Lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
 */
var isLockEnabled = function () { return isChromium(); };
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    timer_setTimeout(function () {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js









/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = ONE_SECOND;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = selectLocalStorageStrategy();
    }
    return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new Observable();
    var expireObservable = new Observable();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? initCookieStrategy(sessionStoreStrategyType.cookieOptions)
        : initLocalStorageStrategy();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = timer_setInterval(watchSession, STORAGE_POLL_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        processSessionStoreOperations({
            process: function (sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (isTracked && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (!isActiveSession(sessionState) ? {} : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) {
            sessionState = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = generateUUID();
            sessionState.created = String(dateNow());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((sessionState.created === undefined || dateNow() - Number(sessionState.created) < SESSION_TIME_OUT_DELAY) &&
            (sessionState.expire === undefined || dateNow() < Number(sessionState.expire)));
    }
    return {
        expandOrRenewSession: throttle(expandOrRenewSession, STORAGE_POLL_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function () {
            clearSession();
            synchronizeSession({});
        },
        stop: function () {
            timer_clearInterval(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    var supportedURL = getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat(jsonStringify({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
    if (isURLSupported === undefined) {
        try {
            var url = new originalURL('http://test/path');
            isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            isURLSupported = false;
        }
    }
    return isURLSupported ? originalURL : undefined;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
//# sourceMappingURL=urlPolyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js





var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, endpointType);
    return {
        build: function (api, flushReason, retry) {
            var parameters = buildEndpointParameters(initConfiguration, endpointType, configurationTags, api, flushReason, retry);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        endpointType: endpointType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, endpointType) {
    var path = "/api/v2/".concat(INTAKE_TRACKS[endpointType]);
    var proxy = initConfiguration.proxy, proxyUrl = initConfiguration.proxyUrl;
    if (proxy) {
        var normalizedProxyUrl_1 = normalizeUrl(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    var host = buildEndpointHost(initConfiguration, endpointType);
    if (proxy === undefined && proxyUrl) {
        // TODO: remove this in a future major.
        var normalizedProxyUrl_2 = normalizeUrl(proxyUrl);
        return function (parameters) {
            return "".concat(normalizedProxyUrl_2, "?ddforward=").concat(encodeURIComponent("https://".concat(host).concat(path, "?").concat(parameters)));
        };
    }
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration, endpointType) {
    var _a = initConfiguration.site, site = _a === void 0 ? INTAKE_SITE_US1 : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === INTAKE_SITE_US1) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(INTAKE_SITE_US1);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var subdomain = site !== INTAKE_SITE_AP1 ? "".concat(ENDPOINTS[endpointType], ".") : '';
    return "".concat(subdomain, "browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, endpointType, configurationTags, api, flushReason, retry) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var tags = ["sdk_version:".concat("4.44.0"), "api:".concat(api)].concat(configurationTags);
    if (flushReason && isExperimentalFeatureEnabled(ExperimentalFeature.COLLECT_FLUSH_REASON)) {
        tags.push("flush_reason:".concat(flushReason));
    }
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("4.44.0")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat(generateUUID()),
    ];
    if (endpointType === 'rum') {
        parameters.push("batch_time=".concat(timeStampNow()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = objectValues(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return polyfills_assign({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || INTAKE_SITE_US1,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = polyfills_assign({}, initConfiguration, {
        site: INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, objectValues(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return polyfills_assign({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js










var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    var sessionSampleRate = (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.sampleRate;
    if (sessionSampleRate !== undefined && !isPercentage(sessionSampleRate)) {
        display.error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !isPercentage(initConfiguration.telemetrySampleRate)) {
        display.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !isPercentage(initConfiguration.telemetryConfigurationSampleRate)) {
        display.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) {
        addExperimentalFeatures(initConfiguration.enableExperimentalFeatures.filter(function (flag) {
            return objectHasValue(ExperimentalFeature, flag);
        }));
    }
    return polyfills_assign({
        beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: selectSessionStoreStrategyType(initConfiguration),
        sessionSampleRate: sessionSampleRate !== null && sessionSampleRate !== void 0 ? sessionSampleRate : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * ONE_KIBI_BYTE,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * ONE_SECOND),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * ONE_KIBI_BYTE,
    }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
    var _a, _b;
    var proxy = (_a = initConfiguration.proxy) !== null && _a !== void 0 ? _a : initConfiguration.proxyUrl;
    return {
        session_sample_rate: (_b = initConfiguration.sessionSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.sampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: proxy !== undefined ? !!proxy : undefined,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_resources: initConfiguration.trackResources,
        track_long_task: initConfiguration.trackLongTasks,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
    };
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/matchOption.js



function isMatchOption(item) {
    var itemType = getType(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? startsWith(value, item) : item === value;
            }
        }
        catch (e) {
            display.error(e);
        }
        return false;
    });
}
//# sourceMappingURL=matchOption.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

function isTracingOption(item) {
    var expectedItem = item;
    return (getType(expectedItem) === 'object' &&
        isMatchOption(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = shallowClone(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat(objectEntries(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = find(configuration.allowedTracingUrls, function (tracingOption) {
        return matchList([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !isNumber(configuration.traceSampleRate) || performDraw(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                polyfills_assign(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                polyfills_assign(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                polyfills_assign(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                polyfills_assign(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration.js


function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e, _f;
    if (!initConfiguration.applicationId) {
        display.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !isPercentage(initConfiguration.sessionReplaySampleRate)) {
        display.error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    // TODO remove fallback in next major
    var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;
    if (premiumSampleRate !== undefined && initConfiguration.sessionReplaySampleRate !== undefined) {
        display.warn('Ignoring Premium Sample Rate because Session Replay Sample Rate is set');
        premiumSampleRate = undefined;
    }
    if (premiumSampleRate !== undefined && !isPercentage(premiumSampleRate)) {
        display.error('Premium Sample Rate should be a number between 0 and 100');
        return;
    }
    var traceSampleRate = (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.tracingSampleRate;
    if (traceSampleRate !== undefined && !isPercentage(traceSampleRate)) {
        display.error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    var trackUserInteractions = !!((_c = initConfiguration.trackUserInteractions) !== null && _c !== void 0 ? _c : initConfiguration.trackInteractions);
    var trackFrustrations = !!initConfiguration.trackFrustrations;
    return polyfills_assign({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_e = (_d = initConfiguration.sessionReplaySampleRate) !== null && _d !== void 0 ? _d : premiumSampleRate) !== null && _e !== void 0 ? _e : 100,
        oldPlansBehavior: initConfiguration.sessionReplaySampleRate === undefined,
        traceSampleRate: traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_f = initConfiguration.excludedActivityUrls) !== null && _f !== void 0 ? _f : [],
        trackUserInteractions: trackUserInteractions || trackFrustrations,
        trackFrustrations: trackFrustrations,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: initConfiguration.trackResources,
        trackLongTasks: initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: objectHasValue(DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : DefaultPrivacyLevel.MASK_USER_INPUT,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
/**
 * Handles allowedTracingUrls and processes legacy allowedTracingOrigins
 */
function validateAndBuildTracingOptions(initConfiguration) {
    // Advise about parameters precedence.
    if (initConfiguration.allowedTracingUrls !== undefined && initConfiguration.allowedTracingOrigins !== undefined) {
        display.warn('Both allowedTracingUrls and allowedTracingOrigins (deprecated) have been defined. The parameter allowedTracingUrls will override allowedTracingOrigins.');
    }
    // Handle allowedTracingUrls first
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            display.error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            display.error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: ['datadog'] });
            }
            else if (isTracingOption(option)) {
                tracingOptions_1.push(option);
            }
            else {
                display.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    // Handle conversion of allowedTracingOrigins to allowedTracingUrls
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            display.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            display.error('Service needs to be configured when tracing is enabled');
            return;
        }
        var tracingOptions_2 = [];
        initConfiguration.allowedTracingOrigins.forEach(function (legacyMatchOption) {
            var tracingOption = convertLegacyMatchOptionToTracingOption(legacyMatchOption);
            if (tracingOption) {
                tracingOptions_2.push(tracingOption);
            }
        });
        return tracingOptions_2;
    }
    return [];
}
/**
 * Converts parameters from the deprecated allowedTracingOrigins
 * to allowedTracingUrls. Handles the change from origin to full URLs.
 */
function convertLegacyMatchOptionToTracingOption(item) {
    var match;
    if (typeof item === 'string') {
        match = item;
    }
    else if (item instanceof RegExp) {
        match = function (url) { return item.test(getOrigin(url)); };
    }
    else if (typeof item === 'function') {
        match = function (url) { return item(getOrigin(url)); };
    }
    if (match === undefined) {
        display.warn('Allowed Tracing Origins parameters should be a string, RegExp or function. Ignoring parameter', item);
        return undefined;
    }
    return { match: match, propagatorTypes: ['datadog'] };
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls,
 * and assumes 'datadog' has been selected when using allowedTracingOrigins
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                usedTracingPropagators.add('datadog');
            }
            else if (getType(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    if (Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0) {
        usedTracingPropagators.add('datadog');
    }
    return arrayFrom(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var _a, _b;
    var baseSerializedConfiguration = serializeConfiguration(configuration);
    return polyfills_assign({
        premium_sample_rate: configuration.premiumSampleRate,
        replay_sample_rate: configuration.replaySampleRate,
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        trace_sample_rate: (_a = configuration.traceSampleRate) !== null && _a !== void 0 ? _a : configuration.tracingSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_origins: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        track_frustrations: configuration.trackFrustrations,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: (_b = configuration.trackUserInteractions) !== null && _b !== void 0 ? _b : configuration.trackInteractions,
    }, baseSerializedConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/commonContext.js
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = createContextManager("global context" /* CustomerDataType.GlobalContext */);
    var userContextManager = createContextManager("user" /* CustomerDataType.User */);
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var stopSessionStrategy = noop;
    var getSessionReplayLinkStrategy = function () { return undefined; };
    var bufferApiCalls = new BoundedBuffer();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = timeStampNow(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = clocksNow(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    var addFeatureFlagEvaluationStrategy = function (key, value) {
        bufferApiCalls.add(function () { return addFeatureFlagEvaluationStrategy(key, value); });
    };
    function initRum(initConfiguration) {
        // This function should be available, regardless of initialization success.
        getInitConfigurationStrategy = function () { return deepClone(initConfiguration); };
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
            return;
        }
        var eventBridgeAvailable = canUseEventBridge();
        if (eventBridgeAvailable) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            display.warn('No storage available for session. We will not send any data.');
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(initConfiguration, configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new BoundedBuffer();
            startViewStrategy = function (options) {
                doStartRum(initConfiguration, configuration, options);
            };
            beforeInitCalls.drain();
        }
        isAlreadyInitialized = true;
    }
    function doStartRum(initConfiguration, configuration, initialViewOptions) {
        var startRumResults = startRumImpl(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions);
        getSessionReplayLinkStrategy = function () {
            return recorderApi.getSessionReplayLink(configuration, startRumResults.session, startRumResults.viewContexts);
        };
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, addFeatureFlagEvaluationStrategy = startRumResults.addFeatureFlagEvaluation, getInternalContextStrategy = startRumResults.getInternalContext, stopSessionStrategy = startRumResults.stopSession);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = monitor(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = makePublicApi({
        init: monitor(initRum),
        /** @deprecated: use setGlobalContextProperty instead */
        addRumGlobalContext: monitor(globalContextManager.add),
        setGlobalContextProperty: monitor(globalContextManager.setContextProperty),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeRumGlobalContext: monitor(globalContextManager.remove),
        removeGlobalContextProperty: monitor(globalContextManager.removeContextProperty),
        /** @deprecated: use getGlobalContext instead */
        getRumGlobalContext: monitor(globalContextManager.get),
        getGlobalContext: monitor(globalContextManager.getContext),
        /** @deprecated: use setGlobalContext instead */
        setRumGlobalContext: monitor(globalContextManager.set),
        setGlobalContext: monitor(globalContextManager.setContext),
        clearGlobalContext: monitor(globalContextManager.clearContext),
        getInternalContext: monitor(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: monitor(function () { return getInitConfigurationStrategy(); }),
        addAction: monitor(function (name, context) {
            addActionStrategy({
                name: sanitize(name),
                context: sanitize(context),
                startClocks: clocksNow(),
                type: "custom" /* ActionType.CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: sanitize(context),
                    startClocks: clocksNow(),
                });
            });
        },
        addTiming: monitor(function (name, time) {
            addTimingStrategy(sanitize(name), time);
        }),
        setUser: monitor(function (newUser) {
            if (checkUser(newUser)) {
                userContextManager.setContext(sanitizeUser(newUser));
            }
        }),
        getUser: monitor(userContextManager.getContext),
        setUserProperty: monitor(function (key, property) {
            var _a;
            var sanitizedProperty = sanitizeUser((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: monitor(userContextManager.removeContextProperty),
        /** @deprecated: renamed to clearUser */
        removeUser: monitor(userContextManager.clearContext),
        clearUser: monitor(userContextManager.clearContext),
        startView: startView,
        stopSession: monitor(function () {
            stopSessionStrategy();
        }),
        startSessionReplayRecording: monitor(recorderApi.start),
        stopSessionReplayRecording: monitor(recorderApi.stop),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */
        addFeatureFlagEvaluation: monitor(function (key, value) {
            addFeatureFlagEvaluationStrategy(sanitize(key), sanitize(value));
        }),
        getSessionReplayLink: monitor(function () { return getSessionReplayLinkStrategy(); }),
    });
    return rumPublicApi;
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return polyfills_assign({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sessionSampleRate: 100,
        });
    }
}
//# sourceMappingURL=rumPublicApi.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js


/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(eventTarget, eventName, listener, options) {
    return addEventListeners(eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = monitor(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = getZoneJsOriginalValue(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, wrappedListener, options); });
    function stop() {
        var remove = getZoneJsOriginalValue(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, wrappedListener, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js





var PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable() {
    var observable = new Observable(function () {
        var pagehideEnabled = isExperimentalFeatureEnabled(ExperimentalFeature.PAGEHIDE);
        var stopListeners = addEventListeners(window, ["visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, "freeze" /* DOM_EVENT.FREEZE */, "pagehide" /* DOM_EVENT.PAGE_HIDE */], function (event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ && pagehideEnabled) {
                /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */
                observable.notify({ reason: PageExitReason.PAGEHIDE });
            }
            else if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = noop;
        if (!pagehideEnabled) {
            stopBeforeUnloadListener = addEventListener(window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */, function () {
                observable.notify({ reason: PageExitReason.UNLOADING });
            }).stop;
        }
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
function isPageExitReason(reason) {
    return includes(objectValues(PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js














var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new Observable();
    telemetryConfiguration.telemetryEnabled =
        !includes(TELEMETRY_EXCLUDED_SITES, configuration.site) && performDraw(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate);
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent);
            observable.notify(event_1);
            sendToExtension('telemetry', event_1);
        }
    };
    startMonitorErrorCollection(addTelemetryError);
    polyfills_assign(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event) {
        return combine({
            type: 'telemetry',
            date: timeStampNow(),
            service: telemetryService,
            version: "4.44.0",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: event,
            experimental_features: arrayFrom(getExperimentalFeatures()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
function startFakeTelemetry() {
    var events = [];
    assign(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === INTAKE_SITE_STAGING;
}
function addTelemetryDebug(message, context) {
    displayIfDebugEnabled(ConsoleApiName.debug, message, context);
    addTelemetry(polyfills_assign({
        type: TelemetryType.log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
function addTelemetryError(e) {
    addTelemetry(polyfills_assign({
        type: TelemetryType.log,
        status: "error" /* StatusType.error */,
    }, formatError(e)));
}
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = computeStackTrace(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: toStackTraceString(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: NO_ERROR_STACK_PRESENT_MESSAGE,
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat(jsonStringify(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return startsWith(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new Observable(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver(monitor(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = getZoneJsOriginalValue(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(noop);
            var originalInstance = getZoneJsOriginalValue(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/runOnReadyState.js

function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */ : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */;
        addEventListener(window, eventName, callback, { once: true });
    }
}
//# sourceMappingURL=runOnReadyState.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* ResourceType.DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* ResourceType.XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* ResourceType.FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* ResourceType.BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* ResourceType.CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* ResourceType.JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* ResourceType.IMAGE */,
        function (initiatorType, path) {
            return includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* ResourceType.FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* ResourceType.MEDIA */,
        function (initiatorType, path) {
            return includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!isValidUrl(url)) {
        addTelemetryDebug("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* ResourceType.OTHER */;
    }
    var path = getPathName(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return toServerDuration(elapsed(startTime, responseEnd));
    }
    return toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return polyfills_assign({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: toServerDuration(elapsed(start, end)),
        start: toServerDuration(elapsed(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.js
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function getChildNodes(node) {
    return isNodeShadowHost(node) ? node.shadowRoot.childNodes : node.childNodes;
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js


var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * ONE_MINUTE;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= dateNow() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData(findCommaSeparatedValue(comment, 'trace-id'), findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js



function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        timer_setTimeout(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = monitor(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
        var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({ type: type, buffered: true });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            addEventListener(performance, 'resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent('navigation')) {
        retrieveNavigationTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent('first-input')) {
        retrieveFirstInputTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(callback) {
    runOnReadyState('interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
        };
        if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = polyfills_assign(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = polyfills_assign(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback(polyfills_assign(computeRelativePerformanceTiming(), {
            entryType: 'navigation',
        }));
    }
    runOnReadyState('complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        timer_setTimeout(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(callback) {
    var startTimeStamp = dateNow();
    var timingSent = false;
    var removeEventListeners = addEventListeners(window, ["click" /* DOM_EVENT.CLICK */, "mousedown" /* DOM_EVENT.MOUSE_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */, "touchstart" /* DOM_EVENT.TOUCH_START */, "pointerdown" /* DOM_EVENT.POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: relativeNow(),
            startTime: evt.timeStamp,
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(timing) {
        addEventListeners(window, ["pointerup" /* DOM_EVENT.POINTER_UP */, "pointercancel" /* DOM_EVENT.POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < dateNow() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if (isNumber(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return entry.entryType === 'resource' ||
            entry.entryType === 'navigation' ||
            entry.entryType === 'paint' ||
            entry.entryType === 'longtask' ||
            entry.entryType === 'largest-contentful-paint' ||
            entry.entryType === 'first-input' ||
            entry.entryType === 'layout-shift';
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                timer_setTimeout(function () {
                    eventCount = 0;
                }, ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: ErrorSource.AGENT,
                        startClocks: clocksNow(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.js

function getSyntheticsContext() {
    var testId = getSyntheticsTestId();
    var resultId = getSyntheticsResultId();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: willSyntheticsInjectRum(),
        };
    }
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciTestContext.js
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.js

var viewportObservable;
function initViewportObservable() {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable();
    }
    return viewportObservable;
}
function createViewportObservable() {
    var observable = new Observable(function () {
        var updateDimension = throttle(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return addEventListener(window, "resize" /* DOM_EVENT.RESIZE */, updateDimension, { capture: true, passive: true }).stop;
    });
    return observable;
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.js

var viewport;
var stopListeners;
function getDisplayContext() {
    if (!viewport) {
        viewport = getViewportDimension();
        stopListeners = initViewportObservable().subscribe(function (viewportDimension) {
            viewport = viewportDimension;
        }).unsubscribe;
    }
    return {
        viewport: viewport,
    };
}
function resetDisplayContext() {
    if (stopListeners) {
        stopListeners();
    }
    viewport = undefined;
}
//# sourceMappingURL=displayContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = deepClone(object);
    var result = modifier(clone);
    objectEntries(modifiableFieldPaths).forEach(function (_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = get(clone, fieldPath);
        var newType = getType(newValue);
        if (newType === fieldType) {
            set(object, fieldPath, sanitize(newValue));
        }
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, fieldPath, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObject(current)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObject(object) {
    return getType(object) === 'object';
}
function isValidObjectContaining(object, field) {
    return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/assembly.js





var VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.url': 'string',
    'view.referrer': 'string',
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError) {
    var _a, _b;
    modifiableFieldPathsByEvent = (_a = {},
        _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS,
        _a["error" /* RumEventType.ERROR */] = polyfills_assign({
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["resource" /* RumEventType.RESOURCE */] = polyfills_assign({
            'resource.url': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["action" /* RumEventType.ACTION */] = polyfills_assign({
            'action.target.name': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["long_task" /* RumEventType.LONG_TASK */] = polyfills_assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a);
    var eventRateLimiters = (_b = {},
        _b["error" /* RumEventType.ERROR */] = createEventRateLimiter("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _b["action" /* RumEventType.ACTION */] = createEventRateLimiter("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _b);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || buildCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: currentDrift(),
                    session: {
                        plan: session.plan,
                    },
                    browser_sdk_version: canUseEventBridge() ? "4.44.0" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: timeStampNow(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciTestContext ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: getDisplayContext(),
            };
            var serverRumEvent = combine(rumContext, rawRumEvent);
            serverRumEvent.context = combine(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!isEmptyObject(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if (isEmptyObject(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
            return false;
        }
        if (result === false) {
            display.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.js
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());

//# sourceMappingURL=abstractLifeCycle.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js

var LifeCycle = (AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/valueHistory.js


var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = ONE_MINUTE;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */ (function () {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = timer_setInterval(function () { return _this.clearOldValues(); }, CLEAR_OLD_VALUES_INTERVAL);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ValueHistory.prototype.add = function (value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) {
            this.entries.pop();
        }
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ValueHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    ValueHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    ValueHistory.prototype.findAll = function (startTime, duration) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = addDuration(startTime, duration);
        return this.entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    };
    /**
     * Remove all entries from this collection.
     */
    ValueHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ValueHistory.prototype.stop = function () {
        timer_clearInterval(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function () {
        var oldTimeThreshold = relativeNow() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ValueHistory;
}());

//# sourceMappingURL=valueHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new ValueHistory(VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js



function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                callMonitored(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                callMonitored(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: noop };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        timer_setTimeout(function () {
            after(thisObject, value);
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = noop;
            }
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.js






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
function createXhrObservable() {
    var observable = new Observable(function () {
        var stopInstrumentingStart = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: normalizeUrl(String(url)),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = relativeNow();
    startContext.startClocks = clocksNow();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = instrumentMethodAndCallOriginal(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
        completeContext.status = _this.status;
        observable.notify(shallowClone(completeContext));
    };
    var unsubscribeLoadEndListener = addEventListener(this, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.js





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = instrumentMethod(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = callMonitored(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    callMonitored(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (input instanceof Request && input.method) || 'GET';
    var url = input instanceof Request ? input.url : normalizeUrl(String(input));
    var startClocks = clocksNow();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then(monitor(reportFetch), monitor(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
function isServerError(status) {
    return status >= 500;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then(monitor(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), monitor(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        noop);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = initXhrObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = initFetchObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && tryToClone(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
    }
    else {
        readBytesFromStream(clonedResponse.body, function () {
            callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? noop : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        if (event.type === 'view' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* RumEventType.ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */:
                eventCounts.resourceCount += 1;
                callback();
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = timer_setTimeout(monitor(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration !== undefined
        ? timer_setTimeout(monitor(function () { return complete({ hadActivity: true, end: timeStampNow() }); }), maxDuration)
        : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        timer_clearTimeout(validationTimeoutId);
        timer_clearTimeout(pageActivityEndTimeoutId);
        var lastChangeTime = timeStampNow();
        if (!isBusy) {
            pageActivityEndTimeoutId = timer_setTimeout(monitor(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        timer_clearTimeout(validationTimeoutId);
        timer_clearTimeout(pageActivityEndTimeoutId);
        timer_clearTimeout(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new Observable(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === 'resource' && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(5 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
    return observable;
}
function isExcludedUrl(configuration, requestUrl) {
    return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return instrumentMethodAndCallOriginal(window, 'open', { before: callback });
}
//# sourceMappingURL=waitPageActivityEnd.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/clickChain.js

var MAX_DURATION_BETWEEN_CLICKS = ONE_SECOND;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        timer_clearTimeout(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = timer_setTimeout(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        timer_clearTimeout(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/getActionNameFromElement.js

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                find(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat(safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/getSelectorFromElement.js


/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [
    DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat(cssEscape(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat(element.tagName, ".").concat(cssEscape(className));
        }
    }
}
function getTagNameSelector(element) {
    return element.tagName;
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat(element.tagName, "[").concat(attributeName, "=\"").concat(cssEscape(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat(element.tagName, ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
//# sourceMappingURL=getSelectorFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/listenActionEvents.js

function listenActionEvents(_a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        addEventListener(window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        addEventListener(window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        addEventListener(window, "pointerup" /* DOM_EVENT.POINTER_UP */, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        addEventListener(window, "input" /* DOM_EVENT.INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/computeFrustration.js

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            ONE_SECOND) {
            return true;
        }
    }
    return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !elementMatches(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/trackClickActions.js








// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * ONE_SECOND;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new ValueHistory(ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new Observable();
    var currentClickChain;
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = listenActionEvents({
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            return configuration.trackFrustrations ? history.findAll(startTime) : history.find(startTime);
        },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = createClickChain(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent) {
    if (!configuration.trackFrustrations && history.find()) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
        // action if another one is already occurring.
        return;
    }
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    if (!configuration.trackFrustrations && !clickActionBase.name) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
        // with a blank name
        return;
    }
    var hadActivityOnPointerDown = false;
    waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    if (configuration.trackFrustrations) {
        appendClickToClickChain(click);
    }
    var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
            // Validate or discard the click only if we don't track frustrations. It'll be done when
            // the click chain is finalized.
            if (!configuration.trackFrustrations) {
                if (!pageActivityEndEvent.hadActivity) {
                    // If we are not tracking frustrations, we should discard the click to keep backward
                    // compatibility.
                    click.discard();
                }
                else {
                    click.validate();
                }
            }
        }
    }, CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: getSelectorFromElement(event.target, actionNameAttribute),
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name: getActionNameFromElement(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = generateUUID();
    var startClocks = clocksNow();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? includes(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ClickStatus.ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new Observable();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close(getRelativeTime(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = polyfills_assign({
                type: "click" /* ActionType.CLICK */,
                duration: activityEndTime && elapsed(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = computeFrustration(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop(timeStampNow());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/actionCollection.js


function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
    });
    var actionContexts = { findActionId: noop };
    if (configuration.trackUserInteractions) {
        actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, polyfills_assign({
                savedCommonContext: savedCommonContext,
            }, processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, pageStateHistory) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: toServerDuration(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = combine({
        action: {
            id: generateUUID(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(action.startClocks.relative) },
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event, events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/tracekit.js


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return instrumentMethodAndCallOriginal(window, 'onerror', {
        before: function (messageObj, url, line, column, errorObj) {
            var stackTrace;
            if (errorObj instanceof Error) {
                stackTrace = computeStackTrace(errorObj);
            }
            else {
                var stack = [{ url: url, column: column, line: line }];
                var _a = tryToParseMessage(messageObj), name_1 = _a.name, message = _a.message;
                stackTrace = {
                    name: name_1,
                    message: message,
                    stack: stack,
                };
            }
            callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
        },
    });
}
function tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return instrumentMethodAndCallOriginal(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = computeStackTrace(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=tracekit.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js




function trackRuntimeError(errorObservable) {
    return startUnhandledErrorCollection(function (stackTrace, originalError) {
        errorObservable.notify(computeRawError({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: clocksNow(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: ErrorSource.SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        }));
    });
}
//# sourceMappingURL=trackRuntimeError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js








var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return mergeObservables.apply(void 0, consoleObservables);
}
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
function createConsoleObservable(api) {
    var observable = new Observable(function () {
        var originalConsoleApi = globalConsole[api];
        globalConsole[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            globalConsole[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    if (api === ConsoleApiName.error) {
        var firstErrorParam = find(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
        fingerprint = tryToGetFingerprint(firstErrorParam);
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return sanitize(param);
    }
    if (param instanceof Error) {
        return formatErrorMessage(computeStackTrace(param));
    }
    return jsonStringify(sanitize(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: ErrorSource.CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js






var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if (includes(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = monitor(function (reports, _) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new Observable(function () {
        var stop = addEventListener(document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */, function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? toStackTraceString({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackReportError.js

function trackReportError(errorObservable) {
    var subscription = initReportObservable([RawReportType.cspViolation, RawReportType.intervention]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: ErrorSource.REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/errorCollection.js



function startErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
    var errorObservable = new Observable();
    trackConsoleError(errorObservable);
    trackRuntimeError(errorObservable);
    trackReportError(errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, polyfills_assign({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
            var rawError = computeRawError({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: ErrorSource.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: generateUUID(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
        },
        type: "error" /* RumEventType.ERROR */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(error.startClocks.relative) },
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !isEmptyObject(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/longTask/longTaskCollection.js

function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== 'longtask') {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !session.longTaskAllowed) {
                break;
            }
            var startClocks = relativeToClocks(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: generateUUID(),
                    duration: toServerDuration(entry.duration),
                },
                type: "long_task" /* RumEventType.LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/matchRequestTiming.js


/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
function endTime(timing) {
    return addDuration(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= addDuration(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceCollection.js



function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processRequest(request, configuration, sessionManager, pageStateHistory));
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'resource' && !isRequestKind(entry)) {
                lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry, configuration, sessionManager, pageStateHistory));
            }
        }
    });
}
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? relativeToClocks(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var startClocks = relativeToClocks(entry.startTime);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, entryMetrics, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: polyfills_assign({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
// TODO next major: use directly PerformanceEntry type in domain context
function toPerformanceEntryRepresentation(entry) {
    return entry;
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return isNumber(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeIndexingInfo(sessionManager, resourceStart) {
    var session = sessionManager.findTrackedSession(resourceStart.relative);
    return {
        _dd: {
            discarded: !session || !session.resourceAllowed,
        },
    };
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!isExperimentalFeatureEnabled(ExperimentalFeature.RESOURCE_PAGE_STATES)) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    var _a;
    // TODO remove FF in next major
    if (!isExperimentalFeatureEnabled(ExperimentalFeature.NO_RESOURCE_DURATION_FROZEN_STATE)) {
        return toServerDuration(duration);
    }
    var requestCrossedFrozenState = (_a = pageStateHistory
        .findAll(startClocks.relative, duration)) === null || _a === void 0 ? void 0 : _a.some(function (pageState) { return pageState.state === "frozen" /* PageState.FROZEN */; });
    return !requestCrossedFrozenState ? toServerDuration(duration) : undefined;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/foregroundContexts.js

// Todo: Remove in the next major release
function mapToForegroundPeriods(pageStateServerEntries, duration) {
    var foregroundPeriods = [];
    for (var i = 0; i < pageStateServerEntries.length; i++) {
        var current = pageStateServerEntries[i];
        var next = pageStateServerEntries[i + 1];
        if (current.state === "active" /* PageState.ACTIVE */) {
            var start = current.start >= 0 ? current.start : 0;
            var end = next ? next.start : toServerDuration(duration);
            foregroundPeriods.push({
                start: start,
                duration: (end - start),
            });
        }
    }
    return foregroundPeriods;
}
//# sourceMappingURL=foregroundContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackFirstHidden.js

var trackFirstHiddenSingleton;
var trackFirstHidden_stopListeners;
function trackFirstHidden(eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    if (!trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') {
            trackFirstHiddenSingleton = {
                timeStamp: 0,
            };
        }
        else {
            trackFirstHiddenSingleton = {
                timeStamp: Infinity,
            };
            (trackFirstHidden_stopListeners = addEventListeners(eventTarget, ["pagehide" /* DOM_EVENT.PAGE_HIDE */, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */], function (event) {
                if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
                    trackFirstHiddenSingleton.timeStamp = event.timeStamp;
                    trackFirstHidden_stopListeners();
                }
            }, { capture: true }).stop);
        }
    }
    return trackFirstHiddenSingleton;
}
function resetFirstHidden() {
    if (trackFirstHidden_stopListeners) {
        trackFirstHidden_stopListeners();
    }
    trackFirstHiddenSingleton = undefined;
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackInitialViewTimings.js


// Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var TIMING_MAXIMUM_DELAY = 10 * ONE_MINUTE;
/**
 * The initial view can finish quickly, before some metrics can be produced (ex: before the page load
 * event, or the first input). Also, we don't want to trigger a view update indefinitely, to avoid
 * updates on views that ended a long time ago. Keep watching for metrics after the view ends for a
 * limited amount of time.
 */
var KEEP_TRACKING_TIMINGS_AFTER_VIEW_DELAY = 5 * ONE_MINUTE;
function trackInitialViewTimings(lifeCycle, setLoadEvent, scheduleViewUpdate) {
    var timings = {};
    function setTimings(newTimings) {
        polyfills_assign(timings, newTimings);
        scheduleViewUpdate();
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (newTimings) {
        setLoadEvent(newTimings.loadEvent);
        setTimings(newTimings);
    }).stop;
    var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
        return setTimings({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime;
        setTimings({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
    }
    return {
        stop: stop,
        timings: timings,
        scheduleStop: function () {
            timer_setTimeout(stop, KEEP_TRACKING_TIMINGS_AFTER_VIEW_DELAY);
        },
    };
}
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'navigation') {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= relativeNow() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
function trackFirstContentfulPaintTiming(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = find(entries, function (entry) {
            return entry.entryType === 'paint' &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return { stop: stop };
}
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */
function trackLargestContentfulPaintTiming(lifeCycle, eventTarget, callback) {
    var firstHidden = trackFirstHidden();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = addEventListeners(eventTarget, ["pointerdown" /* DOM_EVENT.POINTER_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = findLast(entries, function (entry) {
            return entry.entryType === 'largest-contentful-paint' &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            callback(lcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInputTimings(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = find(entries, function (entry) {
            return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
                firstInputTime: firstInputEntry.startTime,
            });
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
//# sourceMappingURL=trackInitialViewTimings.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/scroll.js
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=scroll.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViewMetrics.js





/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = ONE_SECOND;
function trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var viewMetrics = {};
    var scrollMetrics;
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        viewMetrics.loadingTime = newLoadingTime;
        // We compute scroll metrics at loading time to ensure we have scroll data when loading the view initially
        // This is to ensure that we have the depth data even if the user didn't scroll or if the view is not scrollable.
        if (isExperimentalFeatureEnabled(ExperimentalFeature.SCROLLMAP)) {
            var _a = computeScrollValues(), scrollHeight = _a.scrollHeight, scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop;
            scrollMetrics = {
                maxDepth: scrollDepth,
                maxDepthScrollHeight: scrollHeight,
                maxDepthTime: newLoadingTime,
                maxDepthScrollTop: scrollTop,
            };
        }
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = trackScrollMetrics(viewStart, function (newScrollMetrics) {
        scrollMetrics = newScrollMetrics;
    }, computeScrollValues).stop;
    var stopCLSTracking;
    if (isLayoutShiftSupported()) {
        viewMetrics.cumulativeLayoutShift = 0;
        (stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
            viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
            scheduleViewUpdate();
        }).stop);
    }
    else {
        stopCLSTracking = noop;
    }
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        setLoadEvent: setLoadEvent,
        viewMetrics: viewMetrics,
        getScrollMetrics: function () { return scrollMetrics; },
    };
}
function trackScrollMetrics(viewStart, callback, getScrollValues) {
    if (getScrollValues === void 0) { getScrollValues = computeScrollValues; }
    if (!isExperimentalFeatureEnabled(ExperimentalFeature.SCROLLMAP)) {
        return { stop: noop };
    }
    var maxDepth = 0;
    var handleScrollEvent = throttle(function () {
        var _a = getScrollValues(), scrollHeight = _a.scrollHeight, scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop;
        if (scrollDepth > maxDepth) {
            var now = relativeNow();
            var maxDepthTime = elapsed(viewStart.relative, now);
            maxDepth = scrollDepth;
            callback({
                maxDepth: maxDepth,
                maxDepthScrollHeight: scrollHeight,
                maxDepthTime: maxDepthTime,
                maxDepthScrollTop: scrollTop,
            });
        }
    }, THROTTLE_SCROLL_DURATION, { leading: false, trailing: true });
    var stop = addEventListener(window, "scroll" /* DOM_EVENT.SCROLL */, handleScrollEvent.throttled, { passive: true }).stop;
    return {
        stop: function () {
            handleScrollEvent.cancel();
            stop();
        },
    };
}
function computeScrollValues() {
    var scrollTop = getScrollY();
    var height = getViewportDimension().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop,
    };
}
function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push(elapsed(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(lifeCycle, callback) {
    var maxClsValue = 0;
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    callback(round(maxClsValue, 4));
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= ONE_SECOND ||
                entry.startTime - startTime >= 5 * ONE_SECOND;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
        },
        value: function () { return value; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent('layout-shift');
}
//# sourceMappingURL=trackViewMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViewEventCounts.js


// Some events are not being counted as they transcend views. To reduce the occurrence;
// an arbitrary delay is added for stopping event counting after the view ends.
//
// Ideally, we would not stop and keep counting events until the end of the session.
// But this might have a small performance impact if there are many many views:
// we would need to go through each event to see if the related view matches.
// So let's have a fairly short delay to avoid impacting performances too much.
//
// In the future, we could have views stored in a data structure similar to ContextHistory. Whenever
// a child event is collected, we could look into this history to find the matching view and
// increase the associated and increase its counter. Having a centralized data structure for it
// would allow us to look for views more efficiently.
//
// For now, having a small cleanup delay will already improve the situation in most cases.
var KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY = 5 * ONE_MINUTE;
function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        scheduleStop: function () {
            timer_setTimeout(stop, KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY);
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViews.js




var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, clocksOrigin(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        return newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
            currentView.end({ sessionIsActive: false });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === PageExitReason.UNLOADING || pageExitEvent.reason === PageExitReason.PAGEHIDE) {
                currentView.end();
            }
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = timeStampNow(); }
            currentView.addTiming(name, time);
        },
        startView: function (options, startClocks) {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            currentView.end();
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = clocksNow(); }
    // Setup initial values
    var id = generateUUID();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = shallowClone(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */, {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    });
    // Update the view every time the measures are changing
    var _a = throttle(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopViewMetricsTracking = _b.stop, viewMetrics = _b.viewMetrics, getScrollMetrics = _b.getScrollMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */
        ? trackInitialViewTimings(lifeCycle, setLoadEvent, scheduleViewUpdate)
        : { scheduleStop: noop, timings: {} }, scheduleStopInitialViewTimingsTracking = _c.scheduleStop, timings = _c.timings;
    var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate), scheduleStopEventCountsTracking = _d.scheduleStop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = timer_setInterval(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? timeStampNow() : endClocks.timeStamp;
        lifeCycle.notify(3 /* LifeCycleEventType.VIEW_UPDATED */, polyfills_assign({
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            timings: timings,
            duration: elapsed(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts,
            scrollMetrics: getScrollMetrics(),
        }, viewMetrics));
    }
    return {
        name: name,
        service: service,
        version: version,
        end: function (options) {
            var _a, _b;
            if (options === void 0) { options = {}; }
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : clocksNow();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(4 /* LifeCycleEventType.VIEW_ENDED */, { endClocks: endClocks });
            timer_clearInterval(keepAliveIntervalId);
            stopViewMetricsTracking();
            scheduleStopInitialViewTimingsTracking();
            scheduleStopEventCountsTracking();
            triggerViewUpdate();
        },
        addTiming: function (name, time) {
            if (endClocks) {
                return;
            }
            var relativeTime = looksLikeRelativeTime(time) ? time : elapsed(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/viewCollection.js



function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    var trackViewResult = trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
    return trackViewResult;
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStatesEnabled = isExperimentalFeatureEnabled(ExperimentalFeature.PAGE_STATES);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStatesEnabled ? pageStates : undefined,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: view.cumulativeLayoutShift,
            first_byte: toServerDuration(view.timings.firstByte),
            dom_complete: toServerDuration(view.timings.domComplete),
            dom_content_loaded: toServerDuration(view.timings.domContentLoaded),
            dom_interactive: toServerDuration(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: toServerDuration(view.timings.firstContentfulPaint),
            first_input_delay: toServerDuration(view.timings.firstInputDelay),
            first_input_time: toServerDuration(view.timings.firstInputTime),
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: toServerDuration(view.timings.largestContentfulPaint),
            load_event: toServerDuration(view.timings.loadEvent),
            loading_time: discardNegativeDuration(toServerDuration(view.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: toServerDuration(view.duration),
            in_foreground_periods: !pageStatesEnabled && pageStates ? mapToForegroundPeriods(pageStates, view.duration) : undefined, // Todo: Remove in the next major release
        },
        feature_flags: featureFlagContext && !isEmptyObject(featureFlagContext) ? featureFlagContext : undefined,
        display: view.scrollMetrics
            ? {
                scroll: {
                    max_depth: view.scrollMetrics.maxDepth,
                    max_depth_scroll_height: view.scrollMetrics.maxDepthScrollHeight,
                    max_depth_scroll_top: view.scrollMetrics.maxDepthScrollTop,
                    max_depth_time: toServerDuration(view.scrollMetrics.maxDepthTime),
                },
            }
            : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false,
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel,
        },
    };
    if (!isEmptyObject(view.customTimings)) {
        viewEvent.view.custom_timings = mapValues(view.customTimings, toServerDuration);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return isNumber(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js






var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
function startSessionManager(sessionStoreStrategyType, productKey, computeSessionState) {
    var sessionStore = startSessionStore(sessionStoreStrategyType, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new ValueHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), relativeNow());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive(relativeNow());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
        expire: sessionStore.expire,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(expandOrRenewSession) {
    var stop = addEventListeners(window, ["click" /* DOM_EVENT.CLICK */, "touchstart" /* DOM_EVENT.TOUCH_START */, "keydown" /* DOM_EVENT.KEY_DOWN */, "scroll" /* DOM_EVENT.SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = addEventListener(document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = timer_setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        timer_clearInterval(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var rumSessionManager_RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = startSessionManager(
    // TODO - Improve configuration type and remove assertion
    configuration.sessionStoreStrategyType, rumSessionManager_RUM_SESSION_KEY, function (rawTrackingType) { return computeSessionState(configuration, rawTrackingType); });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            var plan = session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
                ? 2 /* RumSessionPlan.WITH_SESSION_REPLAY */
                : 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */;
            return {
                id: session.id,
                plan: plan,
                sessionReplayAllowed: plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                longTaskAllowed: configuration.trackLongTasks !== undefined
                    ? configuration.trackLongTasks
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                resourceAllowed: configuration.trackResources !== undefined
                    ? configuration.trackResources
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        plan: 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */,
        sessionReplayAllowed: false,
        longTaskAllowed: true,
        resourceAllowed: true,
    };
    return {
        findTrackedSession: function () { return session; },
        expire: noop,
        expireObservable: new Observable(),
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!performDraw(configuration.sessionSampleRate)) {
        trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
    }
    else if (!performDraw(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/flushController.js


/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var flushObservable = new Observable();
    pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = timer_setTimeout(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        timer_clearTimeout(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         */
        notifyBeforeAddMessage: function (messageBytesCount) {
            if (currentBytesCount + messageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += messageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         */
        notifyAfterAddMessage: function () {
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.js





var Batch = /** @class */ (function () {
    function Batch(request, flushController, messageBytesLimit) {
        var _this = this;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.flushController.flushObservable.subscribe(function (event) { return _this.flush(event); });
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (event) {
        var messages = this.pushOnlyBuffer.concat(objectValues(this.upsertBuffer));
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        var payload = { data: messages.join('\n'), bytesCount: event.bytesCount, flushReason: event.reason };
        if (isPageExitReason(event.reason)) {
            this.request.sendOnExit(payload);
        }
        else {
            this.request.send(payload);
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        this.push(processedMessage, messageBytesCount, key);
    };
    Batch.prototype.process = function (message) {
        var processedMessage = jsonStringify(message);
        var messageBytesCount = computeBytesCount(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 0 ? 1 : 0;
        this.flushController.notifyBeforeAddMessage(messageBytesCount + separatorBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.flushController.notifyAfterAddMessage();
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = computeBytesCount(removedMessage);
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 1 ? 1 : 0;
        this.flushController.notifyAfterRemoveMessage(messageBytesCount + separatorBytesCount);
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}());

//# sourceMappingURL=batch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js





var MAX_ONGOING_BYTES_COUNT = 80 * ONE_KIBI_BYTE;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * ONE_MEBI_BYTE;
var MAX_BACKOFF_TIME = ONE_MINUTE;
var INITIAL_BACKOFF_TIME = ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, endpointType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function scheduleRetry(state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    timer_setTimeout(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, endpointType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, endpointType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / ONE_MEBI_BYTE, "MiB"),
            source: ErrorSource.AGENT,
            startClocks: clocksNow(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            isServerError(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js




function createHttpRequest(endpointBuilder, bytesLimit, reportError) {
    var retryState = newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(endpointBuilder, bytesLimit, _a) {
    var data = _a.data, bytesCount = _a.bytesCount, flushReason = _a.flushReason;
    var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', flushReason);
            var isQueued = navigator.sendBeacon(beaconUrl, data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', flushReason);
    sendXHR(xhrUrl, data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        addTelemetryError(e);
    }
}
function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, _a, onResponse) {
    var data = _a.data, bytesCount = _a.bytesCount, flushReason = _a.flushReason, retry = _a.retry;
    var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', flushReason, retry);
        fetch(fetchUrl, { method: 'POST', body: data, keepalive: true, mode: 'cors' }).then(monitor(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), monitor(function () {
            var xhrUrl = endpointBuilder.build('xhr', flushReason, retry);
            // failed to queue the request
            sendXHR(xhrUrl, data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', flushReason, retry);
        sendXHR(xhrUrl, data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    addEventListener(request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable) {
    var batch = makeRumBatch(configuration, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, isTelemetryReplicationAllowed(configuration)); });
    return batch;
}
function makeRumBatch(configuration, reportError, pageExitObservable, sessionExpireObservable) {
    var _a = createRumBatch(configuration.rumEndpointBuilder), primaryBatch = _a.batch, primaryFlushController = _a.flushController;
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) {
        replicaBatch = createRumBatch(replica.rumEndpointBuilder).batch;
    }
    function createRumBatch(endpointBuilder) {
        var flushController = createFlushController({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable,
        });
        var batch = new Batch(createHttpRequest(endpointBuilder, configuration.batchBytesLimit, reportError), flushController, configuration.messageBytesLimit);
        return {
            batch: batch,
            flushController: flushController,
        };
    }
    function withReplicaApplicationId(message) {
        return combine(message, { application: { id: replica.applicationId } });
    }
    return {
        flushObservable: primaryFlushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(withReplicaApplicationId(message));
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(withReplicaApplicationId(message), key);
            }
        },
    };
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = getEventBridge();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new ValueHistory(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = relativeNow();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(location) {
    var currentLocation = shallowClone(location);
    var observable = new Observable(function () {
        var stopHistoryTracking = trackHistory(onLocationChange).stop;
        var stopHashTracking = trackHash(onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = shallowClone(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(onHistoryChange) {
    var stopInstrumentingPushState = instrumentMethodAndCallOriginal(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = instrumentMethodAndCallOriginal(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = addEventListener(window, "popstate" /* DOM_EVENT.POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(onHashChange) {
    return addEventListener(window, "hashchange" /* DOM_EVENT.HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.js

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
var featureFlagContext_BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = computeBytesCount; }
    if (!isExperimentalFeatureEnabled(ExperimentalFeature.FEATURE_FLAGS)) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            getFeatureFlagBytesCount: function () { return 0; },
            addFeatureFlagEvaluation: noop,
            stop: noop,
        };
    }
    var featureFlagContexts = new ValueHistory(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    var bytesCountCache = 0;
    var alreadyWarned = false;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        bytesCountCache = 0;
    });
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call addFeatureFlagEvaluation API synchronously multiple times in a row
    var _a = throttle(function (context) {
        bytesCountCache = computeBytesCountImpl(jsonStringify(context));
        if (!alreadyWarned) {
            alreadyWarned = warnIfCustomerDataLimitReached(bytesCountCache, "feature flag evaluation" /* CustomerDataType.FeatureFlag */);
        }
    }, featureFlagContext_BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelPendingComputation = _a.cancel;
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        getFeatureFlagBytesCount: function () {
            var currentContext = featureFlagContexts.find();
            if (!currentContext) {
                return 0;
            }
            return bytesCountCache;
        },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                computeBytesCountThrottled(currentContext);
            }
        },
        stop: cancelPendingComputation,
    };
}
//# sourceMappingURL=featureFlagContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.js

var MEASURES_PERIOD_DURATION = 10 * ONE_SECOND;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && performDraw(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, !isEmptyObject(globalContextManager.get()) ? globalContextManager.getBytesCount() : 0);
        updateMeasure(currentBatchMeasures.userContextBytes, !isEmptyObject(userContextManager.get()) ? userContextManager.getBytesCount() : 0);
        var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations();
        var hasFeatureFlagContext = includes(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) &&
            featureFlagContext &&
            !isEmptyObject(featureFlagContext);
        updateMeasure(currentBatchMeasures.featureFlagBytes, hasFeatureFlagContext ? featureFlagContexts.getFeatureFlagBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    timer_setInterval(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    addTelemetryDebug('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.js

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startPageStateHistory(maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) { maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE; }
    var pageStateHistory = new ValueHistory(PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
    var currentPageState;
    addPageState(getPageState(), relativeNow());
    var stopEventListeners = addEventListeners(window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */,
        "focus" /* DOM_EVENT.FOCUS */,
        "blur" /* DOM_EVENT.BLUR */,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */,
        "resume" /* DOM_EVENT.RESUME */,
        "freeze" /* DOM_EVENT.FREEZE */,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */,
    ], function (event) {
        // Only get events fired by the browser to avoid false currentPageState changes done with custom events
        // cf: developer extension auto flush: https://github.com/DataDog/browser-sdk/blob/2f72bf05a672794c9e33965351964382a94c72ba/developer-extension/src/panel/flushEvents.ts#L11-L12
        if (event.isTrusted) {
            addPageState(computePageState(event), event.timeStamp);
        }
    }, { capture: true }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) { startTime = relativeNow(); }
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateHistory.closeActive(startTime);
        pageStateHistory.add({ state: currentPageState, startTime: startTime }, startTime);
    }
    return {
        findAll: function (eventStartTime, duration) {
            var pageStateEntries = pageStateHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) {
                return;
            }
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for (var index = pageStateEntries.length - 1; index >= limit; index--) {
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = elapsed(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: toServerDuration(relativeStartTime),
                });
            }
            return pageStateServerEntries;
        },
        isInActivePageStateAt: function (startTime) {
            var pageStateEntry = pageStateHistory.find(startTime);
            return pageStateEntry !== undefined && pageStateEntry.state === "active" /* PageState.ACTIVE */;
        },
        addPageState: addPageState,
        stop: function () {
            stopEventListeners();
            pageStateHistory.stop();
        },
    };
}
function computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/startRum.js























function startRum(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions) {
    var lifeCycle = new LifeCycle();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) { return sendToExtension('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
    };
    var featureFlagContexts = startFeatureFlagContexts(lifeCycle);
    var pageExitObservable = createPageExitObservable();
    pageExitObservable.subscribe(function (event) {
        lifeCycle.notify(9 /* LifeCycleEventType.PAGE_EXITED */, event);
    });
    var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle) : startRumSessionManagerStub();
    if (!canUseEventBridge()) {
        var batch = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable);
        startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batch.flushObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, function () { return buildCommonContext(globalContextManager, userContextManager, recorderApi); }, reportError), viewContexts = _a.viewContexts, pageStateHistory = _a.pageStateHistory, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction;
    addTelemetryConfiguration(serializeRumConfiguration(initConfiguration));
    startLongTaskCollection(lifeCycle, session);
    startResourceCollection(lifeCycle, configuration, session, pageStateHistory);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView;
    var addError = startErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    startPerformanceCollection(lifeCycle, configuration);
    var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function () { return session.expire(); },
        getInternalContext: internalContext.get,
    };
}
function startRumTelemetry(configuration) {
    var telemetry = startTelemetry("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
    if (canUseEventBridge()) {
        var bridge_1 = getEventBridge();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, buildCommonContext, reportError) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var pageStateHistory = startPageStateHistory();
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory), addAction = _a.addAction, actionContexts = _a.actionContexts;
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            viewContexts.stop();
            pageStateHistory.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getSessionReplayUrl.js

function getSessionReplayUrl(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) {
        parameters.push("error-type=".concat(errorType));
    }
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = getDatadogSiteUrl(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case INTAKE_SITE_US1:
        case INTAKE_SITE_EU1:
            return 'app';
        case INTAKE_SITE_STAGING:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.js










//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/sessionReplayConstants.js
var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
var NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/assembly.js


function assembleIncrementalSnapshot(source, data) {
    return {
        data: polyfills_assign({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: timeStampNow(),
    };
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/constants.js

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: DefaultPrivacyLevel.ALLOW,
    MASK: DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/privacy.js


var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNode = getParentNode(node);
    var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElementNode(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel) &&
        // Style tags are `overruled` (Use `hide` to enforce privacy)
        !isStyle) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializationUtils.js




var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
            return false;
        }
        current = getParentNode(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return buildUrl(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeStyleSheets.js
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttribute.js




function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK &&
        attributeName !== PRIVACY_ATTR_NAME &&
        !STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && startsWith(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
//# sourceMappingURL=serializeAttribute.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttributes.js




function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' &&
        element.sheet &&
        // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
        !(element.innerText || element.textContent || '').trim().length) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, getCssRuleString).join('');
    return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleString(rule) {
    return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeNode.js








function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
function serializeChildNodes(node, options) {
    var result = [];
    node.childNodes.forEach(function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets),
    };
}
function serializeDocumentFragmentNode(element, options) {
    var childNodes = [];
    if (element.childNodes.length) {
        childNodes = serializeChildNodes(element, options);
    }
    var isShadowRoot = isNodeShadowRoot(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: NodeType.DocumentFragment,
        childNodes: childNodes,
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = serializeAttributes(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (element.childNodes.length) {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = polyfills_assign({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    if (isNodeShadowHost(element)) {
        var shadowRoot = serializeNodeWithId(element.shadowRoot, options);
        if (shadowRoot !== null) {
            childNodes.push(shadowRoot);
        }
    }
    return {
        type: NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: NodeType.Text,
        textContent: textContent,
        isStyle: parentTagName === 'STYLE' ? true : undefined,
    };
}
function serializeCDataNode() {
    return {
        type: NodeType.CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeDocument.js

function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
//# sourceMappingURL=serializeDocument.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/eventsUtils.js

function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && isNodeShadowHost(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var getVisualViewport = function (visualViewport) { return ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
}); };
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/moveObserver.js





var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function initMoveObserver(cb) {
    var updatePosition = throttle(function (event) {
        var target = getEventTarget(event);
        if (hasSerializedNode(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return addEventListeners(document, ["mousemove" /* DOM_EVENT.MOUSE_MOVE */, "touchmove" /* DOM_EVENT.TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
function tryToComputeCoordinates(event) {
    var _a = isTouchEvent(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = convertMouseEventToLayoutCoordinates(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            addTelemetryDebug('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
//# sourceMappingURL=moveObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/scrollObserver.js






var SCROLL_OBSERVER_THRESHOLD = 100;
function initScrollObserver(cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = throttle(function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var scrollPositions = target === document
            ? {
                scrollTop: getScrollY(),
                scrollLeft: getScrollX(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD).throttled;
    return addEventListener(document, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
//# sourceMappingURL=scrollObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/mouseInteractionObserver.js
var _a;








var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a["pointerup" /* DOM_EVENT.POINTER_UP */] = MouseInteractionType.MouseUp,
    _a["mousedown" /* DOM_EVENT.MOUSE_DOWN */] = MouseInteractionType.MouseDown,
    _a["click" /* DOM_EVENT.CLICK */] = MouseInteractionType.Click,
    _a["contextmenu" /* DOM_EVENT.CONTEXT_MENU */] = MouseInteractionType.ContextMenu,
    _a["dblclick" /* DOM_EVENT.DBL_CLICK */] = MouseInteractionType.DblClick,
    _a["focus" /* DOM_EVENT.FOCUS */] = MouseInteractionType.Focus,
    _a["blur" /* DOM_EVENT.BLUR */] = MouseInteractionType.Blur,
    _a["touchstart" /* DOM_EVENT.TOUCH_START */] = MouseInteractionType.TouchStart,
    _a["touchend" /* DOM_EVENT.TOUCH_END */] = MouseInteractionType.TouchEnd,
    _a);
function initMouseInteractionObserver(cb, defaultPrivacyLevel, recordIds) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = polyfills_assign({ id: recordIds.getIdForEvent(event) }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
        cb(record);
    };
    return addEventListeners(document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mouseInteractionObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/inputObserver.js





function initInputObserver(cb, defaultPrivacyLevel, target) {
    if (target === void 0) { target = document; }
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = addEventListeners(target, 
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? ["change" /* DOM_EVENT.CHANGE */] : ["input" /* DOM_EVENT.INPUT */, "change" /* DOM_EVENT.CHANGE */], function (event) {
        var target = getEventTarget(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            instrumentSetter(HTMLInputElement.prototype, 'value', onElementChange),
            instrumentSetter(HTMLInputElement.prototype, 'checked', onElementChange),
            instrumentSetter(HTMLSelectElement.prototype, 'value', onElementChange),
            instrumentSetter(HTMLTextAreaElement.prototype, 'value', onElementChange),
            instrumentSetter(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
        ];
        stopPropertySetterInstrumentation = function () {
            instrumentationStoppers_1.forEach(function (stopper) { return stopper.stop(); });
        };
    }
    else {
        stopPropertySetterInstrumentation = noop;
    }
    return function () {
        stopPropertySetterInstrumentation();
        stopEventListeners();
    };
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb(polyfills_assign({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
}
//# sourceMappingURL=inputObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/styleSheetObserver.js


function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
            callback(getSerializedNodeId(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        instrumentMethodAndCallOriginal(CSSStyleSheet.prototype, 'insertRule', {
            before: function (rule, index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
            },
        }),
        instrumentMethodAndCallOriginal(CSSStyleSheet.prototype, 'deleteRule', {
            before: function (index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
            },
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push(instrumentMethodAndCallOriginal(cls.prototype, 'insertRule', {
            before: function (rule, index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index || 0);
                        cb({ id: id, adds: [{ rule: rule, index: path }] });
                    }
                });
            },
        }), instrumentMethodAndCallOriginal(cls.prototype, 'deleteRule', {
            before: function (index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index);
                        cb({ id: id, removes: [{ index: path }] });
                    }
                });
            },
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=styleSheetObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/mediaInteractionObserver.js






function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */ ? MediaInteractionType.Play : MediaInteractionType.Pause,
        });
    };
    return addEventListeners(document, ["play" /* DOM_EVENT.PLAY */, "pause" /* DOM_EVENT.PAUSE */], handler, { capture: true, passive: true }).stop;
}
//# sourceMappingURL=mediaInteractionObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/frustrationObserver.js

function initFrustrationObserver(lifeCycle, frustrationCb, recordIds) {
    return lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ &&
            data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return recordIds.getIdForEvent(e); }),
                },
            });
        }
    }).unsubscribe;
}
//# sourceMappingURL=frustrationObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/viewportResizeObserver.js



var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initViewportResizeObserver(cb) {
    return initViewportObservable().subscribe(cb).unsubscribe;
}
function initVisualViewportResizeObserver(cb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) {
        return noop;
    }
    var _a = throttle(function () {
        cb(getVisualViewport(visualViewport));
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = addEventListeners(visualViewport, ["resize" /* DOM_EVENT.RESIZE */, "scroll" /* DOM_EVENT.SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=viewportResizeObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = noop;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback(monitor(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame(monitor(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/mutationObserver.js






/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function initMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: noop, flush: noop };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController, target);
    });
    var observer = new MutationObserver(monitor(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController, target) {
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return target.contains(mutation.target) &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel) !== NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* SerializationContextStatus.MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = getParentNode(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if (isNodeShadowHost(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    getChildNodes(removedNode).forEach(function (child) { return traverseRemovedShadowDom(child, shadowDomRemovedCallback); });
}
//# sourceMappingURL=mutationObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/focusObserver.js

function initFocusObserver(focusCb) {
    return addEventListeners(window, ["focus" /* DOM_EVENT.FOCUS */, "blur" /* DOM_EVENT.BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
//# sourceMappingURL=focusObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/recordIds.js
function initRecordIds() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function (event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/observers.js











function initObservers(o) {
    var recordIds = initRecordIds();
    var mutationHandler = initMutationObserver(o.mutationCb, o.configuration, o.shadowRootsController, document);
    var mousemoveHandler = initMoveObserver(o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(o.mouseInteractionCb, o.configuration.defaultPrivacyLevel, recordIds);
    var scrollHandler = initScrollObserver(o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = initViewportResizeObserver(o.viewportResizeCb);
    var inputHandler = initInputObserver(o.inputCb, o.configuration.defaultPrivacyLevel);
    var mediaInteractionHandler = initMediaInteractionObserver(o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetCb);
    var focusHandler = initFocusObserver(o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(o.visualViewportResizeCb);
    var frustrationHandler = initFrustrationObserver(o.lifeCycle, o.frustrationCb, recordIds);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
        },
    };
}
//# sourceMappingURL=observers.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/elementsScrollPositions.js
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/shadowRootsController.js

var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = initMutationObserver(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = initInputObserver(inputCb, configuration.defaultPrivacyLevel, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/record.js









function record(options) {
    var emit = options.emit;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var elementsScrollPositions = createElementsScrollPositions();
    var mutationCb = function (mutation) {
        emit(assembleIncrementalSnapshot(IncrementalSource.Mutation, mutation));
    };
    var inputCb = function (s) { return emit(assembleIncrementalSnapshot(IncrementalSource.Input, s)); };
    var shadowRootsController = initShadowRootsController(options.configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = timeStampNow(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = getViewportDimension(), width = _a.width, height = _a.height;
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width,
            },
            type: RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: serializeDocument(document, options.configuration, serializationContext),
                initialOffset: {
                    left: getScrollX(),
                    top: getScrollY(),
                },
            },
            type: RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(window.visualViewport),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var _a = initObservers({
        lifeCycle: options.lifeCycle,
        configuration: options.configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emit(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) { return emit(assembleIncrementalSnapshot(source, { positions: positions })); },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emit(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetCb: function (r) { return emit(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d)); },
        frustrationCb: function (frustrationRecord) { return emit(frustrationRecord); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: RecordType.Focus,
                timestamp: timeStampNow(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: RecordType.VisualViewport,
                timestamp: timeStampNow(),
            });
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
        },
        takeSubsequentFullSnapshot: function (timestamp) {
            flushMutations();
            takeFullSnapshot(timestamp, {
                shadowRootsController: shadowRootsController,
                status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
                elementsScrollPositions: elementsScrollPositions,
            });
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/buildReplayPayload.js

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = polyfills_assign({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return { data: formData, bytesCount: data.byteLength };
}
//# sourceMappingURL=buildReplayPayload.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



var nextId = 0;
var Segment = /** @class */ (function () {
    function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
        var _this = this;
        this.worker = worker;
        this.id = nextId++;
        var viewId = context.view.id;
        this.metadata = polyfills_assign({
            start: initialRecord.timestamp,
            end: initialRecord.timestamp,
            creation_reason: creationReason,
            records_count: 1,
            has_full_snapshot: initialRecord.type === RecordType.FullSnapshot,
            index_in_view: getSegmentsCount(viewId),
            source: 'browser',
        }, context);
        addSegment(viewId);
        addRecord(viewId);
        var removeMessageListener = addEventListener(worker, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored' || data.type === 'initialized') {
                return;
            }
            if (data.id === _this.id) {
                addWroteData(viewId, data.additionalBytesCount);
                if (data.type === 'flushed') {
                    onFlushed(data.result, data.rawBytesCount);
                    removeMessageListener();
                }
                else {
                    onWrote(data.compressedBytesCount);
                }
            }
            else if (data.id > _this.id) {
                // Messages should be received in the same order as they are sent, so if we receive a
                // message with an id superior to this Segment instance id, we know that another, more
                // recent Segment instance is being used.
                //
                // In theory, a "flush" response should have been received at this point, so the listener
                // should already have been removed. But if something goes wrong and we didn't receive a
                // "flush" response, remove the listener to avoid any leak, and send a monitor message to
                // help investigate the issue.
                removeMessageListener();
                addTelemetryDebug("Segment did not receive a 'flush' response before being replaced.");
            }
        }).stop;
        sendToExtension('record', { record: initialRecord, segment: this.metadata });
        this.worker.postMessage({ data: "{\"records\":[".concat(JSON.stringify(initialRecord)), id: this.id, action: 'write' });
    }
    Segment.prototype.addRecord = function (record) {
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        addRecord(this.metadata.view.id);
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        sendToExtension('record', { record: record, segment: this.metadata });
        this.worker.postMessage({ data: ",".concat(JSON.stringify(record)), id: this.id, action: 'write' });
    };
    Segment.prototype.flush = function (reason) {
        this.worker.postMessage({
            data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
            id: this.id,
            action: 'flush',
        });
        this.flushReason = reason;
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



var SEGMENT_DURATION_LIMIT = 30 * ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, applicationId, sessionManager, viewContexts, httpRequest, worker) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(applicationId, sessionManager, viewContexts); }, httpRequest, worker);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, worker) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush(flushReason);
            timer_clearTimeout(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    function createNewSegment(creationReason, initialRecord) {
        var context = getSegmentContext();
        if (!context) {
            return;
        }
        var segment = new Segment(worker, context, creationReason, initialRecord, function (compressedSegmentBytesCount) {
            if (!segment.flushReason && compressedSegmentBytesCount > SEGMENT_BYTES_LIMIT) {
                flushSegment('segment_bytes_limit');
            }
        }, function (data, rawSegmentBytesCount) {
            var payload = buildReplayPayload(data, segment.metadata, rawSegmentBytesCount);
            if (isPageExitReason(segment.flushReason)) {
                httpRequest.sendOnExit(payload);
            }
            else {
                httpRequest.send(payload);
            }
        });
        state = {
            status: 1 /* SegmentCollectionStatus.SegmentPending */,
            segment: segment,
            expirationTimeoutId: timer_setTimeout(function () {
                flushSegment('segment_duration_limit');
            }, SEGMENT_DURATION_LIMIT),
        };
    }
    return {
        addRecord: function (record) {
            switch (state.status) {
                case 0 /* SegmentCollectionStatus.WaitingForInitialRecord */:
                    createNewSegment(state.nextSegmentCreationReason, record);
                    break;
                case 1 /* SegmentCollectionStatus.SegmentPending */:
                    state.segment.addRecord(record);
                    break;
            }
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/deflateWorker.js
var workerURL;
function createDeflateWorker() {
    // Lazily compute the worker URL to allow importing the SDK in NodeJS
    if (!workerURL) {
        workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
    }
    return new Worker(workerURL);
}
function workerCodeFn() {
    monitor(function () {
        var _a = makePakoDeflate(), Deflate = _a.Deflate, constants = _a.constants, string2buf = _a.string2buf;
        var deflate = new Deflate();
        var rawBytesCount = 0;
        self.addEventListener('message', monitor(function (event) {
            var data = event.data;
            switch (data.action) {
                case 'init':
                    self.postMessage({
                        type: 'initialized',
                    });
                    break;
                case 'write': {
                    var additionalBytesCount = pushData(data.data);
                    self.postMessage({
                        type: 'wrote',
                        id: data.id,
                        compressedBytesCount: deflate.chunks.reduce(function (total, chunk) { return total + chunk.length; }, 0),
                        additionalBytesCount: additionalBytesCount,
                    });
                    break;
                }
                case 'flush': {
                    var additionalBytesCount = data.data ? pushData(data.data) : 0;
                    deflate.push('', constants.Z_FINISH);
                    self.postMessage({
                        type: 'flushed',
                        id: data.id,
                        result: deflate.result,
                        additionalBytesCount: additionalBytesCount,
                        rawBytesCount: rawBytesCount,
                    });
                    deflate = new Deflate();
                    rawBytesCount = 0;
                    break;
                }
            }
        }));
        function pushData(data) {
            // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
            var binaryData = string2buf(data);
            deflate.push(binaryData, constants.Z_SYNC_FLUSH);
            rawBytesCount += binaryData.length;
            return binaryData.length;
        }
    })();
    function monitor(fn) {
        return function () {
            try {
                return fn.apply(this, arguments);
            }
            catch (e) {
                try {
                    self.postMessage({
                        type: 'errored',
                        error: e,
                    });
                }
                catch (_) {
                    // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    self.postMessage({
                        type: 'errored',
                        error: "".concat(e),
                    });
                }
            }
        };
    }
    // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js
    function makePakoDeflate() {
        /* eslint-disable camelcase, no-bitwise */
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        /* Public constants ========================================================== */
        /* =========================================================================== */
        // const Z_FILTERED          = 1;
        // const Z_HUFFMAN_ONLY      = 2;
        // const Z_RLE               = 3;
        var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;
        /* Possible values of the data_type field (though see inflate()) */
        var Z_BINARY = 0;
        var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT
        var Z_UNKNOWN = 2;
        /* ============================================================================ */
        function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        } // From zutil.h
        var STORED_BLOCK = 0;
        var STATIC_TREES = 1;
        var DYN_TREES = 2;
        /* The three kinds of block type */
        var MIN_MATCH = 3;
        var MAX_MATCH = 258;
        /* The minimum and maximum match lengths */
        // From deflate.h
        /* ===========================================================================
         * Internal compression state.
         */
        var LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS = 256;
        /* number of literal bytes 0..255 */
        var L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES = 30;
        /* number of distance codes */
        var BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        var MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */
        var Buf_size = 16;
        /* size of bit buffer in bi_buf */
        /* ===========================================================================
         * Constants
         */
        var MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */
        var END_BLOCK = 256;
        /* end of block literal code */
        var REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */
        var REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */
        var REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */
        var extra_lbits = 
        /* extra bits for each length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
        var extra_dbits = 
        /* extra bits for each distance code */
        new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
        var extra_blbits = 
        /* extra bits for each bit length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
        var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        /* eslint-enable comma-spacing,array-bracket-spacing */
        /* The lengths of the bit length codes are sent in order of decreasing
         * probability, to avoid transmitting the lengths for unused bit length codes.
         */
        /* ===========================================================================
         * Local data. These are initialized only once.
         */
        // We pre-fill arrays with 0 to avoid uninitialized gaps
        var DIST_CODE_LEN = 512;
        /* see definition of array dist_code below */
        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        var static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
         * need for the L_CODES extra codes used during heap construction. However
         * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
         * below).
         */
        var static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
         * 5 bits.)
         */
        var _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
         * 3 .. 258, the last 256 values correspond to the top 8 bits of
         * the 15 bit distances.
         */
        var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */
        var base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */
        var base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */
        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree;
            /* static tree or NULL */
            this.extra_bits = extra_bits;
            /* extra bits for each code or NULL */
            this.extra_base = extra_base;
            /* base index for extra_bits */
            this.elems = elems;
            /* max number of elements in the tree */
            this.max_length = max_length;
            /* max bit length for the codes */
            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
        var static_l_desc;
        var static_d_desc;
        var static_bl_desc;
        function TreeDesc(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree;
            /* the dynamic tree */
            this.max_code = 0;
            /* largest code with non zero frequency */
            this.stat_desc = stat_desc;
            /* the corresponding static tree */
        }
        var d_code = function d_code(dist) {
            return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        };
        /* ===========================================================================
         * Output a short LSB first on the stream.
         * IN assertion: there is enough room in pendingBuf.
         */
        var put_short = function put_short(s, w) {
            //    put_byte(s, (uch)((w) & 0xff));
            //    put_byte(s, (uch)((ush)(w) >> 8));
            s.pending_buf[s.pending++] = w & 0xff;
            s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        };
        /* ===========================================================================
         * Send a value on a given number of bits.
         * IN assertion: length <= 16 and value fits in length bits.
         */
        var send_bits = function send_bits(s, value, length) {
            if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
            }
            else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
            }
        };
        var send_code = function send_code(s, c, tree) {
            send_bits(s, tree[c * 2], 
            /* .Code */
            tree[c * 2 + 1]
            /* .Len */
            );
        };
        /* ===========================================================================
         * Reverse the first len bits of a code, using straightforward code (a faster
         * method would use a table)
         * IN assertion: 1 <= len <= 15
         */
        var bi_reverse = function bi_reverse(code, len) {
            var res = 0;
            do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
            } while (--len > 0);
            return res >>> 1;
        };
        /* ===========================================================================
         * Flush the bit buffer, keeping at most 7 bits in it.
         */
        var bi_flush = function bi_flush(s) {
            if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
            }
        };
        /* ===========================================================================
         * Compute the optimal bit lengths for a tree and update the total bit length
         * for the current block.
         * IN assertion: the fields freq and dad are set, heap[heap_max] and
         *    above are the tree nodes sorted by increasing frequency.
         * OUT assertions: the field len is set to the optimal bit length, the
         *     array bl_count contains the frequencies for each bit length.
         *     The length opt_len is updated; static_len is also updated if stree is
         *     not null.
         */
        var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var max_code = desc.max_code;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var extra = desc.stat_desc.extra_bits;
            var base = desc.stat_desc.extra_base;
            var max_length = desc.stat_desc.max_length;
            var h;
            /* heap index */
            var n;
            var m;
            /* iterate over the tree elements */
            var bits;
            /* bit length */
            var xbits;
            /* extra bits */
            var f;
            /* frequency */
            var overflow = 0;
            /* number of elements with bit length too large */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
            }
            /* In a first pass, compute the optimal bit lengths (which may
             * overflow in the case of the bit length tree).
             */
            tree[s.heap[s.heap_max] * 2 + 1] =
                /* .Len */
                0;
            /* root of the heap */
            for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits =
                    tree[tree[n * 2 + 1] *
                        /* .Dad */
                        2 +
                        1] +
                        /* .Len */
                        1;
                if (bits > max_length) {
                    bits = max_length;
                    overflow++;
                }
                tree[n * 2 + 1] =
                    /* .Len */
                    bits;
                /* We overwrite tree[n].Dad which is no longer needed */
                if (n > max_code) {
                    continue;
                }
                /* not a leaf node */
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                    xbits = extra[n - base];
                }
                f = tree[n * 2];
                /* .Freq */
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                    s.static_len +=
                        f *
                            (stree[n * 2 + 1] +
                                /* .Len */
                                xbits);
                }
            }
            if (overflow === 0) {
                return;
            } // Trace((stderr,"\nbit length overflow\n"));
            /* This happens for example on obj2 and pic of the Calgary corpus */
            /* Find the first bit length which could increase: */
            do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                    bits--;
                }
                s.bl_count[bits]--;
                /* move one leaf down the tree */
                s.bl_count[bits + 1] += 2;
                /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
            } while (overflow > 0);
            /* Now recompute all bit lengths, scanning in increasing frequency.
             * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
             * lengths instead of fixing only the wrong ones. This idea is taken
             * from 'ar' written by Haruhiko Okumura.)
             */
            for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                    m = s.heap[--h];
                    if (m > max_code) {
                        continue;
                    }
                    if (tree[m * 2 + 1] !==
                        /* .Len */
                        bits) {
                        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                        s.opt_len +=
                            (bits - tree[m * 2 + 1]) *
                                /* .Len */
                                tree[m * 2];
                        /* .Freq */
                        tree[m * 2 + 1] =
                            /* .Len */
                            bits;
                    }
                    n--;
                }
            }
        };
        /* ===========================================================================
         * Generate the codes for a given tree and bit counts (which need not be
         * optimal).
         * IN assertion: the array bl_count contains the bit length statistics for
         * the given tree and the field len is set for all tree elements.
         * OUT assertion: the field code is set for all tree elements of non
         *     zero code length.
         */
        var gen_codes = function gen_codes(tree, max_code, bl_count
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        ) {
            var next_code = new Array(MAX_BITS + 1);
            /* next code value for each bit length */
            var code = 0;
            /* running code value */
            var bits;
            /* bit index */
            var n;
            /* code index */
            /* The distribution counts are first used to generate the code values
             * without bit reversal.
             */
            for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
            }
            /* Check that the bit counts in bl_count are consistent. The last code
             * must be all ones.
             */
            // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
            //        "inconsistent bit counts");
            // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
            for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1];
                /* .Len */
                if (len === 0) {
                    continue;
                }
                /* Now reverse the bits */
                tree[n * 2] =
                    /* .Code */
                    bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
            }
        };
        /* ===========================================================================
         * Initialize the various 'constant' tables.
         */
        var tr_static_init = function tr_static_init() {
            var n;
            /* iterates over tree elements */
            var bits;
            /* bit counter */
            var length;
            /* length value */
            var code;
            /* code value */
            var dist;
            /* distance index */
            var bl_count = new Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            // do check in _tr_init()
            // if (static_init_done) return;
            /* For some embedded targets, global variables are not initialized: */
            /* #ifdef NO_INIT_GLOBAL_POINTERS
            static_l_desc.static_tree = static_ltree;
            static_l_desc.extra_bits = extra_lbits;
            static_d_desc.static_tree = static_dtree;
            static_d_desc.extra_bits = extra_dbits;
            static_bl_desc.extra_bits = extra_blbits;
          #endif */
            /* Initialize the mapping length (0..255) -> length code (0..28) */
            length = 0;
            for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                    _length_code[length++] = code;
                }
            } // Assert (length == 256, "tr_static_init: length != 256");
            /* Note that the length 255 (match length 258) can be represented
             * in two different ways: code 284 + 5 bits or code 285, so we
             * overwrite length_code[255] to use the best encoding:
             */
            _length_code[length - 1] = code;
            /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
            dist = 0;
            for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                    _dist_code[dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: dist != 256");
            dist >>= 7;
            /* from now on, all distances are divided by 128 */
            for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                    _dist_code[256 + dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: 256+dist != 512");
            /* Construct the codes of the static literal tree */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
            }
            n = 0;
            while (n <= 143) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            while (n <= 255) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    9;
                n++;
                bl_count[9]++;
            }
            while (n <= 279) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    7;
                n++;
                bl_count[7]++;
            }
            while (n <= 287) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            /* Codes 286 and 287 do not exist, but we must include them in the
             * tree construction to get a canonical Huffman tree (longest code
             * all ones)
             */
            gen_codes(static_ltree, L_CODES + 1, bl_count);
            /* The static distance tree is trivial: */
            for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] =
                    /* .Len */
                    5;
                static_dtree[n * 2] =
                    /* .Code */
                    bi_reverse(n, 5);
            } // Now data ready and we can init static trees
            static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
            static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
            static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            // static_init_done = true;
        };
        /* ===========================================================================
         * Initialize a new block.
         */
        var init_block = function init_block(s) {
            var n;
            /* iterates over tree elements */
            /* Initialize the trees. */
            for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] =
                    /* .Freq */
                    0;
            }
            s.dyn_ltree[END_BLOCK * 2] =
                /* .Freq */
                1;
            s.opt_len = s.static_len = 0;
            s.last_lit = s.matches = 0;
        };
        /* ===========================================================================
         * Flush the bit buffer and align the output on a byte boundary
         */
        var bi_windup = function bi_windup(s) {
            if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
            }
            else if (s.bi_valid > 0) {
                // put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
            }
            s.bi_buf = 0;
            s.bi_valid = 0;
        };
        /* ===========================================================================
         * Copy a stored block, storing first the length and its
         * one's complement if requested.
         */
        var copy_block = function copy_block(s, buf, len, header
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        ) {
            bi_windup(s);
            /* align on byte boundary */
            if (header) {
                put_short(s, len);
                put_short(s, ~len);
            }
            //  while (len--) {
            //    put_byte(s, *buf++);
            //  }
            s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
            s.pending += len;
        };
        /* ===========================================================================
         * Compares to subtrees, using the tree depth as tie breaker when
         * the subtrees have equal frequency. This minimizes the worst case length.
         */
        var smaller = function smaller(tree, n, m, depth) {
            var _n2 = n * 2;
            var _m2 = m * 2;
            return (tree[_n2] <
                /* .Freq */
                tree[_m2] ||
                /* .Freq */
                (tree[_n2] ===
                    /* .Freq */
                    tree[_m2] &&
                    /* .Freq */
                    depth[n] <= depth[m]));
        };
        /* ===========================================================================
         * Restore the heap property by moving down the tree starting at node k,
         * exchanging a node with the smallest of its two sons if necessary, stopping
         * when the heap property is re-established (each father smaller than its
         * two sons).
         */
        var pqdownheap = function pqdownheap(s, tree, k
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        ) {
            var v = s.heap[k];
            var j = k << 1;
            /* left son of k */
            while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
                    j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                    break;
                }
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
            }
            s.heap[k] = v;
        }; // inlined manually
        // const SMALLEST = 1;
        /* ===========================================================================
         * Send the block data compressed using the given Huffman trees
         */
        var compress_block = function compress_block(s, ltree, dtree
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        ) {
            var dist;
            /* distance of matched string */
            var lc;
            /* match length or unmatched char (if dist == 0) */
            var lx = 0;
            /* running index in l_buf */
            var code;
            /* the code to send */
            var extra;
            /* number of extra bits to send */
            if (s.last_lit !== 0) {
                do {
                    dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) {
                        send_code(s, lc, ltree);
                        /* send a literal byte */
                        // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                    }
                    else {
                        /* Here, lc is the match length - MIN_MATCH */
                        code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree);
                        /* send the length code */
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra);
                            /* send the extra length bits */
                        }
                        dist--;
                        /* dist is now the match distance - 1 */
                        code = d_code(dist); // Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree);
                        /* send the distance code */
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra);
                            /* send the extra distance bits */
                        }
                    }
                    /* literal or match pair ? */
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                    // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                } while (lx < s.last_lit);
            }
            send_code(s, END_BLOCK, ltree);
        };
        /* ===========================================================================
         * Construct one Huffman tree and assigns the code bit strings and lengths.
         * Update the total bit length for the current block.
         * IN assertion: the field freq is set for all tree elements.
         * OUT assertions: the fields len and code are set to the optimal bit length
         *     and corresponding code. The length opt_len is updated; static_len is
         *     also updated if stree is not null. The field max_code is set.
         */
        var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var elems = desc.stat_desc.elems;
            var n;
            var m;
            /* iterate over heap elements */
            var max_code = -1;
            /* largest code with non zero frequency */
            var node;
            /* new node being created */
            /* Construct the initial heap, with least frequent element in
             * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
             * heap[0] is not used.
             */
            s.heap_len = 0;
            s.heap_max = HEAP_SIZE;
            for (n = 0; n < elems; n++) {
                if (tree[n * 2] !==
                    /* .Freq */
                    0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                }
                else {
                    tree[n * 2 + 1] =
                        /* .Len */
                        0;
                }
            }
            /* The pkzip format requires that at least one distance code exists,
             * and that at least one bit should be sent even if there is only one
             * possible code. So to avoid special checks later on we force at least
             * two codes of non zero frequency.
             */
            while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] =
                    /* .Freq */
                    1;
                s.depth[node] = 0;
                s.opt_len--;
                if (has_stree) {
                    s.static_len -= stree[node * 2 + 1];
                    /* .Len */
                }
                /* node is 0 or 1 so it does not have extra bits */
            }
            desc.max_code = max_code;
            /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
             * establish sub-heaps of increasing lengths:
             */
            for (n = s.heap_len >> 1; 
            /* int /2 */
            n >= 1; n--) {
                pqdownheap(s, tree, n);
            }
            /* Construct the Huffman tree by repeatedly combining the least two
             * frequent nodes.
             */
            node = elems;
            /* next internal node of the tree */
            do {
                // pqremove(s, tree, n);  /* n = node of least frequency */
                /** * pqremove ** */
                n = s.heap[1];
                /* SMALLEST */
                s.heap[1] = s.heap[s.heap_len--];
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
                /***/
                m = s.heap[1];
                /* SMALLEST */
                /* m = node of next least frequency */
                s.heap[--s.heap_max] = n;
                /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
                /* Create a new node father of n and m */
                tree[node * 2] =
                    /* .Freq */
                    tree[n * 2] +
                        /* .Freq */
                        tree[m * 2];
                /* .Freq */
                s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] =
                    /* .Dad */
                    tree[m * 2 + 1] =
                        /* .Dad */
                        node;
                /* and insert the new node in the heap */
                s.heap[1] = node++;
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
            } while (s.heap_len >= 2);
            s.heap[--s.heap_max] = s.heap[1];
            /* SMALLEST */
            /* At this point, the fields freq and dad are set. We can now
             * generate the bit lengths.
             */
            gen_bitlen(s, desc);
            /* The field len is now set, we can generate the bit codes */
            gen_codes(tree, max_code, s.bl_count);
        };
        /* ===========================================================================
         * Scan a literal or distance tree to determine the frequencies of the codes
         * in the bit length tree.
         */
        var scan_tree = function scan_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            tree[(max_code + 1) * 2 + 1] =
                /* .Len */
                0xffff;
            /* guard */
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    s.bl_tree[curlen * 2] +=
                        /* .Freq */
                        count;
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        s.bl_tree[curlen * 2] /* .Freq */++;
                    }
                    s.bl_tree[REP_3_6 * 2] /* .Freq */++;
                }
                else if (count <= 10) {
                    s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
                }
                else {
                    s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Send a literal or distance tree in compressed form, using the codes in
         * bl_tree.
         */
        var send_tree = function send_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            /* tree[max_code+1].Len = -1; */
            /* guard already set */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    do {
                        send_code(s, curlen, s.bl_tree);
                    } while (--count !== 0);
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        send_code(s, curlen, s.bl_tree);
                        count--;
                    } // Assert(count >= 3 && count <= 6, " 3_6?");
                    send_code(s, REP_3_6, s.bl_tree);
                    send_bits(s, count - 3, 2);
                }
                else if (count <= 10) {
                    send_code(s, REPZ_3_10, s.bl_tree);
                    send_bits(s, count - 3, 3);
                }
                else {
                    send_code(s, REPZ_11_138, s.bl_tree);
                    send_bits(s, count - 11, 7);
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Construct the Huffman tree for the bit lengths and return the index in
         * bl_order of the last bit length code to send.
         */
        var build_bl_tree = function build_bl_tree(s) {
            var max_blindex;
            /* index of last bit length code of non zero freq */
            /* Determine the bit length frequencies for literal and distance trees */
            scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
            scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
            /* Build the bit length tree: */
            build_tree(s, s.bl_desc);
            /* opt_len now includes the length of the tree representations, except
             * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
             */
            /* Determine the number of bit length codes to send. The pkzip format
             * requires that at least 4 bit length codes be sent. (appnote.txt says
             * 3 but the actual value used is 4.)
             */
            for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
                    /* .Len */
                    0) {
                    break;
                }
            }
            /* Update opt_len to include the bit length tree and counts */
            s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
            //        s->opt_len, s->static_len));
            return max_blindex;
        };
        /* ===========================================================================
         * Send the header for a block using dynamic Huffman trees: the counts, the
         * lengths of the bit length codes, the literal tree and the distance tree.
         * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
         */
        var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        ) {
            var rank;
            /* index in bl_order */
            // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
            // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
            //        "too many codes");
            // Tracev((stderr, "\nbl counts: "));
            send_bits(s, lcodes - 257, 5);
            /* not +255 as stated in appnote.txt */
            send_bits(s, dcodes - 1, 5);
            send_bits(s, blcodes - 4, 4);
            /* not -3 as stated in appnote.txt */
            for (rank = 0; rank < blcodes; rank++) {
                // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 
                /* .Len */
                3);
            } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_ltree, lcodes - 1);
            /* literal tree */
            // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_dtree, dcodes - 1);
            /* distance tree */
            // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        };
        /* ===========================================================================
         * Check if the data type is TEXT or BINARY, using the following algorithm:
         * - TEXT if the two conditions below are satisfied:
         *    a) There are no non-portable control characters belonging to the
         *       "black list" (0..6, 14..25, 28..31).
         *    b) There is at least one printable character belonging to the
         *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
         * - BINARY otherwise.
         * - The following partially-portable control characters form a
         *   "gray list" that is ignored in this detection algorithm:
         *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
         * IN assertion: the fields Freq of dyn_ltree are set.
         */
        var detect_data_type = function detect_data_type(s) {
            /* black_mask is the bit mask of black-listed bytes
             * set bits 0..6, 14..25, and 28..31
             * 0xf3ffc07f = binary 11110011111111111100000001111111
             */
            var black_mask = 0xf3ffc07f;
            var n;
            /* Check for non-textual ("black-listed") bytes. */
            for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 &&
                    s.dyn_ltree[n * 2] !==
                        /* .Freq */
                        0) {
                    return Z_BINARY;
                }
            }
            /* Check for textual ("white-listed") bytes. */
            if (s.dyn_ltree[9 * 2] !==
                /* .Freq */
                0 ||
                s.dyn_ltree[10 * 2] !==
                    /* .Freq */
                    0 ||
                s.dyn_ltree[13 * 2] !==
                    /* .Freq */
                    0) {
                return Z_TEXT;
            }
            for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] !==
                    /* .Freq */
                    0) {
                    return Z_TEXT;
                }
            }
            /* There are no "black-listed" or "white-listed" bytes:
             * this stream either is empty or has tolerated ("gray-listed") bytes only.
             */
            return Z_BINARY;
        };
        var static_init_done = false;
        /* ===========================================================================
         * Initialize the tree data structures for a new zlib stream.
         */
        var _tr_init = function _tr_init(s) {
            if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
            }
            s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
            s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
            s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
            s.bi_buf = 0;
            s.bi_valid = 0;
            /* Initialize the first block of the first file: */
            init_block(s);
        };
        /* ===========================================================================
         * Send a stored block
         */
        var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
            /* send block type */
            copy_block(s, buf, stored_len, true);
            /* with header */
        };
        /* ===========================================================================
         * Send one empty static block to give enough lookahead for inflate.
         * This takes 10 bits, of which 7 may remain in the bit buffer.
         */
        var _tr_align = function _tr_align(s) {
            send_bits(s, STATIC_TREES << 1, 3);
            send_code(s, END_BLOCK, static_ltree);
            bi_flush(s);
        };
        /* ===========================================================================
         * Determine the best encoding for the current block: dynamic trees, static
         * trees or store, and output the encoded block to the zip file.
         */
        var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            var opt_lenb;
            var static_lenb;
            /* opt_len and static_len in bytes */
            var max_blindex = 0;
            /* index of last bit length code of non zero freq */
            /* Build the Huffman trees unless a stored block is forced */
            if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                    s.strm.data_type = detect_data_type(s);
                }
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
                if (static_lenb <= opt_lenb) {
                    opt_lenb = static_lenb;
                }
            }
            else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5;
                /* force a stored block */
            }
            if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
            }
            else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
            }
            else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
            } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
            /* The above check is made mod 2^32, for files larger than 512 MB
             * and uLong implemented on 32 bits.
             */
            init_block(s);
            if (last) {
                bi_windup(s);
            } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
        };
        /* ===========================================================================
         * Save the match info and tally the frequency counts. Return true if
         * the current block must be flushed.
         */
        var _tr_tally = function _tr_tally(s, dist, lc
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        ) {
            // let out_length, in_length, dcode;
            s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
            s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
            s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
            s.last_lit++;
            if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /* .Freq */++;
            }
            else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--;
                /* dist = match distance - 1 */
                // Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
                s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
            } // (!) This block is disabled in zlib defaults,
            // don't enable it for binary compatibility
            // #ifdef TRUNCATE_BLOCK
            //  /* Try to guess if it is profitable to stop the current block here */
            //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
            //    /* Compute an upper bound for the compressed length */
            //    out_length = s.last_lit*8;
            //    in_length = s.strstart - s.block_start;
            //
            //    for (dcode = 0; dcode < D_CODES; dcode++) {
            //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
            //    }
            //    out_length >>>= 3;
            //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
            //    //       s->last_lit, in_length, out_length,
            //    //       100L - out_length*100L/in_length));
            //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
            //      return true;
            //    }
            //  }
            // #endif
            return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
             * on 16 bit machines and because stored blocks are restricted to
             * 64K-1 bytes.
             */
        };
        var _tr_init_1 = _tr_init;
        var _tr_stored_block_1 = _tr_stored_block;
        var _tr_flush_block_1 = _tr_flush_block;
        var _tr_tally_1 = _tr_tally;
        var _tr_align_1 = _tr_align;
        var trees = {
            _tr_init: _tr_init_1,
            _tr_stored_block: _tr_stored_block_1,
            _tr_flush_block: _tr_flush_block_1,
            _tr_tally: _tr_tally_1,
            _tr_align: _tr_align_1,
        };
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var adler32 = function adler32(adler, buf, len, pos) {
            var s1 = (adler & 0xffff) | 0;
            var s2 = ((adler >>> 16) & 0xffff) | 0;
            var n = 0;
            while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
                do {
                    s1 = (s1 + buf[pos++]) | 0;
                    s2 = (s2 + s1) | 0;
                } while (--n);
                s1 %= 65521;
                s2 %= 65521;
            }
            return s1 | (s2 << 16) | 0;
        };
        var adler32_1 = adler32;
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        // Use ordinary array, since untyped makes no boost here
        var makeTable = function makeTable() {
            var c;
            var table = [];
            for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                    c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
            }
            return table;
        }; // Create table on load. Just 255 signed longs. Not a problem.
        var crcTable = new Uint32Array(makeTable());
        var crc32 = function crc32(crc, buf, len, pos) {
            var t = crcTable;
            var end = pos + len;
            crc ^= -1;
            for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
            }
            return crc ^ -1; // >>> 0;
        };
        var crc32_1 = crc32;
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var messages = {
            2: 'need dictionary',
            /* Z_NEED_DICT       2  */
            1: 'stream end',
            /* Z_STREAM_END      1  */
            0: '',
            /* Z_OK              0  */
            '-1': 'file error',
            /* Z_ERRNO         (-1) */
            '-2': 'stream error',
            /* Z_STREAM_ERROR  (-2) */
            '-3': 'data error',
            /* Z_DATA_ERROR    (-3) */
            '-4': 'insufficient memory',
            /* Z_MEM_ERROR     (-4) */
            '-5': 'buffer error',
            /* Z_BUF_ERROR     (-5) */
            '-6': 'incompatible version',
            /* Z_VERSION_ERROR (-6) */
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var constants = {
            /* Allowed flush values; see deflate() and inflate() below for details */
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_MEM_ERROR: -4,
            Z_BUF_ERROR: -5,
            // Z_VERSION_ERROR: -6,
            /* compression levels */
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            /* Possible values of the data_type field (though see inflate()) */
            Z_BINARY: 0,
            Z_TEXT: 1,
            // Z_ASCII:                1, // = Z_TEXT (deprecated)
            Z_UNKNOWN: 2,
            /* The deflate compression method */
            Z_DEFLATED: 8, // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var _tr_init$1 = trees._tr_init;
        var _tr_stored_block$1 = trees._tr_stored_block;
        var _tr_flush_block$1 = trees._tr_flush_block;
        var _tr_tally$1 = trees._tr_tally;
        var _tr_align$1 = trees._tr_align;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH = constants.Z_NO_FLUSH;
        var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
        var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
        var Z_FINISH = constants.Z_FINISH;
        var Z_BLOCK = constants.Z_BLOCK;
        var Z_OK = constants.Z_OK;
        var Z_STREAM_END = constants.Z_STREAM_END;
        var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
        var Z_DATA_ERROR = constants.Z_DATA_ERROR;
        var Z_BUF_ERROR = constants.Z_BUF_ERROR;
        var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
        var Z_FILTERED = constants.Z_FILTERED;
        var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
        var Z_RLE = constants.Z_RLE;
        var Z_FIXED$1 = constants.Z_FIXED;
        var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
        var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
        var Z_DEFLATED = constants.Z_DEFLATED;
        /* ============================================================================ */
        var MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        var MAX_WBITS = 15;
        /* 32K LZ77 window */
        var DEF_MEM_LEVEL = 8;
        var LENGTH_CODES$1 = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS$1 = 256;
        /* number of literal bytes 0..255 */
        var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES$1 = 30;
        /* number of distance codes */
        var BL_CODES$1 = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
        /* maximum heap size */
        var MAX_BITS$1 = 15;
        /* All codes must not exceed MAX_BITS bits */
        var MIN_MATCH$1 = 3;
        var MAX_MATCH$1 = 258;
        var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
        var PRESET_DICT = 0x20;
        var INIT_STATE = 42;
        var EXTRA_STATE = 69;
        var NAME_STATE = 73;
        var COMMENT_STATE = 91;
        var HCRC_STATE = 103;
        var BUSY_STATE = 113;
        var FINISH_STATE = 666;
        var BS_NEED_MORE = 1;
        /* block not completed, need more input or more output */
        var BS_BLOCK_DONE = 2;
        /* block flush performed */
        var BS_FINISH_STARTED = 3;
        /* finish started, need only more output at next deflate */
        var BS_FINISH_DONE = 4;
        /* finish done, accept no more input or output */
        var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
        var err = function err(strm, errorCode) {
            strm.msg = messages[errorCode];
            return errorCode;
        };
        var rank = function rank(f) {
            return (f << 1) - (f > 4 ? 9 : 0);
        };
        var zero$1 = function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        };
        var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
            return ((prev << s.hash_shift) ^ data) & s.hash_mask;
        }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
        // But breaks binary compatibility
        // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
        var HASH = HASH_ZLIB;
        /* =========================================================================
         * Flush as much pending output as possible. All deflate() output goes
         * through this function so some applications may wish to modify it
         * to avoid allocating a large strm->output buffer and copying into it.
         * (See also read_buf()).
         */
        var flush_pending = function flush_pending(strm) {
            var s = strm.state; // _tr_flush_bits(s);
            var len = s.pending;
            if (len > strm.avail_out) {
                len = strm.avail_out;
            }
            if (len === 0) {
                return;
            }
            strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
            strm.next_out += len;
            s.pending_out += len;
            strm.total_out += len;
            strm.avail_out -= len;
            s.pending -= len;
            if (s.pending === 0) {
                s.pending_out = 0;
            }
        };
        var flush_block_only = function flush_block_only(s, last) {
            _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
            s.block_start = s.strstart;
            flush_pending(s.strm);
        };
        var put_byte = function put_byte(s, b) {
            s.pending_buf[s.pending++] = b;
        };
        /* =========================================================================
         * Put a short in the pending buffer. The 16-bit value is put in MSB order.
         * IN assertion: the stream state is correct and there is enough room in
         * pending_buf.
         */
        var putShortMSB = function putShortMSB(s, b) {
            //  put_byte(s, (Byte)(b >> 8));
            //  put_byte(s, (Byte)(b & 0xff));
            s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
            s.pending_buf[s.pending++] = b & 0xff;
        };
        /* ===========================================================================
         * Read a new buffer from the current input stream, update the adler32
         * and total number of bytes read.  All deflate() input goes through
         * this function so some applications may wish to modify it to avoid
         * allocating a large strm->input buffer and copying from it.
         * (See also flush_pending()).
         */
        var read_buf = function read_buf(strm, buf, start, size) {
            var len = strm.avail_in;
            if (len > size) {
                len = size;
            }
            if (len === 0) {
                return 0;
            }
            strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
            buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
            if (strm.state.wrap === 1) {
                strm.adler = adler32_1(strm.adler, buf, len, start);
            }
            else if (strm.state.wrap === 2) {
                strm.adler = crc32_1(strm.adler, buf, len, start);
            }
            strm.next_in += len;
            strm.total_in += len;
            return len;
        };
        /* ===========================================================================
         * Set match_start to the longest match starting at the given string and
         * return its length. Matches shorter or equal to prev_length are discarded,
         * in which case the result is equal to prev_length and match_start is
         * garbage.
         * IN assertions: cur_match is the head of the hash chain for the current
         *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
         * OUT assertion: the match length is not greater than s->lookahead.
         */
        var longest_match = function longest_match(s, cur_match) {
            var chain_length = s.max_chain_length;
            /* max hash chain length */
            var scan = s.strstart;
            /* current string */
            var match;
            /* matched string */
            var len;
            /* length of current match */
            var best_len = s.prev_length;
            /* best match length so far */
            var nice_match = s.nice_match;
            /* stop if match long enough */
            var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
            /* NIL */
            var _win = s.window; // shortcut
            var wmask = s.w_mask;
            var prev = s.prev;
            /* Stop when cur_match becomes <= limit. To simplify the code,
             * we prevent matches with the string of window index 0.
             */
            var strend = s.strstart + MAX_MATCH$1;
            var scan_end1 = _win[scan + best_len - 1];
            var scan_end = _win[scan + best_len];
            /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
             * It is easy to get rid of this optimization if necessary.
             */
            // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
            /* Do not waste too much time if we already have a good match: */
            if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
            }
            /* Do not look for matches beyond the end of the input. This is necessary
             * to make deflate deterministic.
             */
            if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
            } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
            do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
                if (_win[match + best_len] !== scan_end ||
                    _win[match + best_len - 1] !== scan_end1 ||
                    _win[match] !== _win[scan] ||
                    _win[++match] !== _win[scan + 1]) {
                    continue;
                }
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++; // Assert(*scan == *match, "match[2]?");
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                    /* jshint noempty:false */
                } while (_win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                len = MAX_MATCH$1 - (strend - scan);
                scan = strend - MAX_MATCH$1;
                if (len > best_len) {
                    s.match_start = cur_match;
                    best_len = len;
                    if (len >= nice_match) {
                        break;
                    }
                    scan_end1 = _win[scan + best_len - 1];
                    scan_end = _win[scan + best_len];
                }
            } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
            if (best_len <= s.lookahead) {
                return best_len;
            }
            return s.lookahead;
        };
        /* ===========================================================================
         * Fill the window when the lookahead becomes insufficient.
         * Updates strstart and lookahead.
         *
         * IN assertion: lookahead < MIN_LOOKAHEAD
         * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
         *    At least one byte has been read, or avail_in == 0; reads are
         *    performed for at least two bytes (required for the zip translate_eol
         *    option -- not supported here).
         */
        var fill_window = function fill_window(s) {
            var _w_size = s.w_size;
            var p;
            var n;
            var m;
            var more;
            var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
            do {
                more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                // if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                // }
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                    s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
                    s.match_start -= _w_size;
                    s.strstart -= _w_size;
                    /* we now have strstart >= MAX_DIST */
                    s.block_start -= _w_size;
                    /* Slide the hash table (could be avoided with 32 bit values
                   at the expense of memory usage). We slide even when level == 0
                   to keep the hash table consistent if we switch back to level > 0
                   later. (Using level 0 permanently is not an optimal usage of
                   zlib, so we don't care about this pathological case.)
                   */
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= _w_size ? m - _w_size : 0;
                    } while (--n);
                    n = _w_size;
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
                         * its value will never be used.
                         */
                    } while (--n);
                    more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                    break;
                }
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                // Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH$1) {
                    str = s.strstart - s.insert;
                    s.ins_h = s.window[str];
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
                    //        Call update_hash() MIN_MATCH-3 more times
                    // #endif
                    while (s.insert) {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                        s.insert--;
                        if (s.lookahead + s.insert < MIN_MATCH$1) {
                            break;
                        }
                    }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
            } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
             * written, then zero those bytes in order to avoid memory check reports of
             * the use of uninitialized (or uninitialised as Julian writes) bytes by
             * the longest match routines.  Update the high water mark for the next
             * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
             * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
             */
            //  if (s.high_water < s.window_size) {
            //    const curr = s.strstart + s.lookahead;
            //    let init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
        };
        /* ===========================================================================
         * Copy without compression as much as possible from the input stream, return
         * the current block state.
         * This function does not insert new strings in the dictionary since
         * uncompressible data is probably not useful. This function is used
         * only for the level=0 compression option.
         * NOTE: this function should be optimized to avoid extra copying from
         * window to pending_buf.
         */
        var deflate_stored = function deflate_stored(s, flush) {
            /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
             * to pending_buf_size, and each stored block has a 5 byte header:
             */
            var max_block_size = 0xffff;
            if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
            }
            /* Copy as much as possible from input to output: */
            for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                    // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                    //  s->block_start >= (long)s->w_size, "slide too late");
                    //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                    //        s.block_start >= s.w_size)) {
                    //        throw  new Error("slide too late");
                    //      }
                    fill_window(s);
                    if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                } // Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
                s.strstart += s.lookahead;
                s.lookahead = 0;
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
                if (s.strstart === 0 || s.strstart >= max_start) {
                    /* strstart == 0 is possible when wraparound on 16-bit machine */
                    s.lookahead = s.strstart - max_start;
                    s.strstart = max_start;
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.strstart > s.block_start) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_NEED_MORE;
        };
        /* ===========================================================================
         * Compress as much as possible from the input stream, return the current
         * block state.
         * This function does not perform lazy evaluation of matches and inserts
         * new strings in the dictionary only for unmatched strings or for short
         * matches. It is used only for the fast compression options.
         */
        var deflate_fast = function deflate_fast(s, flush) {
            var hash_head;
            /* head of the hash chain */
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                        /* flush the current block */
                    }
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (hash_head !== 0 &&
                    /* NIL */
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                    /** * _tr_tally_dist(s, s.strstart - s.match_start,
                                 s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    /* Insert new strings in the hash table only if the match length
                     * is not too large. This saves time but degrades compression.
                     */
                    if (s.match_length <= s.max_lazy_match &&
                        /* max_insert_length */
                        s.lookahead >= MIN_MATCH$1) {
                        s.match_length--;
                        /* string at strstart already in table */
                        do {
                            s.strstart++;
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                             * always MIN_MATCH bytes ahead.
                             */
                        } while (--s.match_length !== 0);
                        s.strstart++;
                    }
                    else {
                        s.strstart += s.match_length;
                        s.match_length = 0;
                        s.ins_h = s.window[s.strstart];
                        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        // #endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                         * matter since it will be recomputed at next deflate call.
                         */
                    }
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s.window[s.strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * Same as above, but achieves better compression. We use a lazy
         * evaluation for matches: a match is finally adopted only if there is
         * no better match at the next window position.
         */
        var deflate_slow = function deflate_slow(s, flush) {
            var hash_head;
            /* head of hash chain */
            var bflush;
            /* set if current block must be flushed */
            var max_insert;
            /* Process the input block. */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH$1 - 1;
                if (hash_head !== 0 &&
                    /* NIL */
                    s.prev_length < s.max_lazy_match &&
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                /* MAX_DIST(s) */
                ) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                    if (s.match_length <= 5 &&
                        (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096))
                    /* TOO_FAR */
                    ) {
                        /* If prev_match is also MIN_MATCH, match_start is garbage
                         * but we will ignore the current match anyway.
                         */
                        s.match_length = MIN_MATCH$1 - 1;
                    }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
                    max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
                    /* Do not insert strings in hash table beyond this. */
                    // check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                    /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                                 s.prev_length - MIN_MATCH, bflush);** */
                    bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
                    /* Insert in hash table all strings up to the end of the match.
                     * strstart-1 and strstart are already inserted. If there is not
                     * enough lookahead, the last two strings are not inserted in
                     * the hash table.
                     */
                    s.lookahead -= s.prev_length - 1;
                    s.prev_length -= 2;
                    do {
                        if (++s.strstart <= max_insert) {
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                        }
                    } while (--s.prev_length !== 0);
                    s.match_available = 0;
                    s.match_length = MIN_MATCH$1 - 1;
                    s.strstart++;
                    if (bflush) {
                        /** * FLUSH_BLOCK(s, 0); ** */
                        flush_block_only(s, false);
                        if (s.strm.avail_out === 0) {
                            return BS_NEED_MORE;
                        }
                        /***/
                    }
                }
                else if (s.match_available) {
                    /* If there was no match at the previous position, output a
                     * single literal. If there was a match but the current match
                     * is longer, truncate the previous match to a single literal.
                     */
                    // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                    if (bflush) {
                        /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                        flush_block_only(s, false);
                        /***/
                    }
                    s.strstart++;
                    s.lookahead--;
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                }
                else {
                    /* There is no previous match to compare with, wait for
                     * the next step to decide.
                     */
                    s.match_available = 1;
                    s.strstart++;
                    s.lookahead--;
                }
            } // Assert (flush != Z_NO_FLUSH, "no flush?");
            if (s.match_available) {
                // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                s.match_available = 0;
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_RLE, simply look for runs of bytes, generate matches only of distance
         * one.  Do not maintain a hash table.  (It will be regenerated if this run of
         * deflate switches away from Z_RLE.)
         */
        var deflate_rle = function deflate_rle(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            var prev;
            /* byte at distance one to match */
            var scan;
            var strend;
            /* scan goes up to strend for length of run */
            var _win = s.window;
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH$1) {
                    fill_window(s);
                    if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
                    scan = s.strstart - 1;
                    prev = _win[scan];
                    if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                        strend = s.strstart + MAX_MATCH$1;
                        do {
                            /* jshint noempty:false */
                        } while (prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            scan < strend);
                        s.match_length = MAX_MATCH$1 - (strend - scan);
                        if (s.match_length > s.lookahead) {
                            s.match_length = s.lookahead;
                        }
                    } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.strstart - 1, s.match_length);
                    /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    s.strstart += s.match_length;
                    s.match_length = 0;
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s->window[s->strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
         * (It will be regenerated if this run of deflate switches away from Huffman.)
         */
        var deflate_huff = function deflate_huff(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                    fill_window(s);
                    if (s.lookahead === 0) {
                        if (flush === Z_NO_FLUSH) {
                            return BS_NEED_MORE;
                        }
                        break;
                        /* flush the current block */
                    }
                }
                /* Output a literal byte */
                s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));
                /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* Values for max_lazy_match, good_match and max_chain_length, depending on
         * the desired pack level (0..9). The values given below have been tuned to
         * exclude worst case performance for pathological files. Better values may be
         * found for specific files.
         */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
        var configuration_table = [
            /*      good lazy nice chain */
            new Config(0, 0, 0, 0, deflate_stored),
            /* 0 store only */
            new Config(4, 4, 8, 4, deflate_fast),
            /* 1 max speed, no lazy matches */
            new Config(4, 5, 16, 8, deflate_fast),
            /* 2 */
            new Config(4, 6, 32, 32, deflate_fast),
            /* 3 */
            new Config(4, 4, 16, 16, deflate_slow),
            /* 4 lazy matches */
            new Config(8, 16, 32, 32, deflate_slow),
            /* 5 */
            new Config(8, 16, 128, 128, deflate_slow),
            /* 6 */
            new Config(8, 32, 128, 256, deflate_slow),
            /* 7 */
            new Config(32, 128, 258, 1024, deflate_slow),
            /* 8 */
            new Config(32, 258, 258, 4096, deflate_slow),
            /* 9 max compression */
        ];
        /* ===========================================================================
         * Initialize the "longest match" routines for a new zlib stream
         */
        var lm_init = function lm_init(s) {
            s.window_size = 2 * s.w_size;
            /** * CLEAR_HASH(s); ** */
            zero$1(s.head); // Fill with NIL (= 0);
            /* Set the default configuration parameters:
             */
            s.max_lazy_match = configuration_table[s.level].max_lazy;
            s.good_match = configuration_table[s.level].good_length;
            s.nice_match = configuration_table[s.level].nice_length;
            s.max_chain_length = configuration_table[s.level].max_chain;
            s.strstart = 0;
            s.block_start = 0;
            s.lookahead = 0;
            s.insert = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            s.ins_h = 0;
        };
        function DeflateState() {
            this.strm = null;
            /* pointer back to this zlib stream */
            this.status = 0;
            /* as the name implies */
            this.pending_buf = null;
            /* output still pending */
            this.pending_buf_size = 0;
            /* size of pending_buf */
            this.pending_out = 0;
            /* next pending byte to output to the stream */
            this.pending = 0;
            /* nb of bytes in the pending buffer */
            this.wrap = 0;
            /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null;
            /* gzip header information to write */
            this.gzindex = 0;
            /* where in extra, name, or comment */
            this.method = Z_DEFLATED;
            /* can only be DEFLATED */
            this.last_flush = -1;
            /* value of flush param for previous deflate call */
            this.w_size = 0;
            /* LZ77 window size (32K by default) */
            this.w_bits = 0;
            /* log2(w_size)  (8..16) */
            this.w_mask = 0;
            /* w_size - 1 */
            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null;
            /* Heads of the hash chains or NIL. */
            this.ins_h = 0;
            /* hash index of string to be inserted */
            this.hash_size = 0;
            /* number of elements in hash table */
            this.hash_bits = 0;
            /* log2(hash_size) */
            this.hash_mask = 0;
            /* hash_size-1 */
            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0;
            /* length of best match */
            this.prev_match = 0;
            /* previous match */
            this.match_available = 0;
            /* set if previous match exists */
            this.strstart = 0;
            /* start of string to insert */
            this.match_start = 0;
            /* start of matching string */
            this.lookahead = 0;
            /* number of valid bytes ahead in window */
            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            // this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0;
            /* compression level (1..9) */
            this.strategy = 0;
            /* favor or force Huffman coding */
            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0;
            /* Stop searching when current match exceeds this */
            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
            zero$1(this.dyn_ltree);
            zero$1(this.dyn_dtree);
            zero$1(this.bl_tree);
            this.l_desc = null;
            /* desc. for literal tree */
            this.d_desc = null;
            /* desc. for distance tree */
            this.bl_desc = null;
            /* desc. for bit length tree */
            // ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
            /* number of codes at each bit length for an optimal tree */
            // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(2 * L_CODES$1 + 1);
            /* heap used to build the Huffman trees */
            zero$1(this.heap);
            this.heap_len = 0;
            /* number of elements in the heap */
            this.heap_max = 0;
            /* element of largest frequency */
            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];
            zero$1(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.l_buf = 0;
            /* buffer index for literals or lengths */
            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.last_lit = 0;
            /* running index in l_buf */
            this.d_buf = 0;
            /* Buffer index for distances. To simplify the code, d_buf and l_buf have
             * the same number of elements. To use different lengths, an extra flag
             * array would be necessary.
             */
            this.opt_len = 0;
            /* bit length of current block with optimal trees */
            this.static_len = 0;
            /* bit length of current block with static trees */
            this.matches = 0;
            /* number of string matches in current block */
            this.insert = 0;
            /* bytes at end of window left to insert */
            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            // this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
        var deflateResetKeep = function deflateResetKeep(strm) {
            if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.total_in = strm.total_out = 0;
            strm.data_type = Z_UNKNOWN$1;
            var s = strm.state;
            s.pending = 0;
            s.pending_out = 0;
            if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
            }
            s.status = s.wrap ? INIT_STATE : BUSY_STATE;
            strm.adler =
                s.wrap === 2
                    ? 0 // crc32(0, Z_NULL, 0)
                    : 1; // adler32(0, Z_NULL, 0)
            s.last_flush = Z_NO_FLUSH;
            _tr_init$1(s);
            return Z_OK;
        };
        var deflateReset = function deflateReset(strm) {
            var ret = deflateResetKeep(strm);
            if (ret === Z_OK) {
                lm_init(strm.state);
            }
            return ret;
        };
        var deflateSetHeader = function deflateSetHeader(strm, head) {
            if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
            }
            if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
            }
            strm.state.gzhead = head;
            return Z_OK;
        };
        var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
            if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
            }
            var wrap = 1;
            if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
            }
            if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
            }
            else if (windowBits > 15) {
                wrap = 2;
                /* write gzip wrapper instead */
                windowBits -= 16;
            }
            if (memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED$1) {
                return err(strm, Z_STREAM_ERROR);
            }
            if (windowBits === 8) {
                windowBits = 9;
            }
            /* until 256-byte window bug fixed */
            var s = new DeflateState();
            strm.state = s;
            s.strm = strm;
            s.wrap = wrap;
            s.gzhead = null;
            s.w_bits = windowBits;
            s.w_size = 1 << s.w_bits;
            s.w_mask = s.w_size - 1;
            s.hash_bits = memLevel + 7;
            s.hash_size = 1 << s.hash_bits;
            s.hash_mask = s.hash_size - 1;
            s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
            s.window = new Uint8Array(s.w_size * 2);
            s.head = new Uint16Array(s.hash_size);
            s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
            // s.high_water = 0;  /* nothing written to s->window yet */
            s.lit_bufsize = 1 << (memLevel + 6);
            /* 16K elements by default */
            s.pending_buf_size = s.lit_bufsize * 4;
            // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
            // s->pending_buf = (uchf *) overlay;
            // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
            s.pending_buf = new Uint8Array(s.pending_buf_size);
            // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
            s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
            s.l_buf = (1 + 2) * s.lit_bufsize;
            s.level = level;
            s.strategy = strategy;
            s.method = method;
            return deflateReset(strm);
        };
        var deflateInit = function deflateInit(strm, level) {
            return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        };
        var deflate = function deflate(strm, flush) {
            var beg;
            var val; // for gzip header write only
            if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
            }
            var s = strm.state;
            if (!strm.output || (!strm.input && strm.avail_in !== 0) || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
                return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
            }
            s.strm = strm;
            /* just in case */
            var old_flush = s.last_flush;
            s.last_flush = flush;
            /* Write the header */
            if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                    // GZIP header
                    strm.adler = 0; // crc32(0L, Z_NULL, 0);
                    put_byte(s, 31);
                    put_byte(s, 139);
                    put_byte(s, 8);
                    if (!s.gzhead) {
                        // s->gzhead == Z_NULL
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, OS_CODE);
                        s.status = BUSY_STATE;
                    }
                    else {
                        put_byte(s, (s.gzhead.text ? 1 : 0) +
                            (s.gzhead.hcrc ? 2 : 0) +
                            (!s.gzhead.extra ? 0 : 4) +
                            (!s.gzhead.name ? 0 : 8) +
                            (!s.gzhead.comment ? 0 : 16));
                        put_byte(s, s.gzhead.time & 0xff);
                        put_byte(s, (s.gzhead.time >> 8) & 0xff);
                        put_byte(s, (s.gzhead.time >> 16) & 0xff);
                        put_byte(s, (s.gzhead.time >> 24) & 0xff);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, s.gzhead.os & 0xff);
                        if (s.gzhead.extra && s.gzhead.extra.length) {
                            put_byte(s, s.gzhead.extra.length & 0xff);
                            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                        }
                        if (s.gzhead.hcrc) {
                            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                        }
                        s.gzindex = 0;
                        s.status = EXTRA_STATE;
                    }
                } // DEFLATE header
                else {
                    var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                    var level_flags = -1;
                    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                        level_flags = 0;
                    }
                    else if (s.level < 6) {
                        level_flags = 1;
                    }
                    else if (s.level === 6) {
                        level_flags = 2;
                    }
                    else {
                        level_flags = 3;
                    }
                    header |= level_flags << 6;
                    if (s.strstart !== 0) {
                        header |= PRESET_DICT;
                    }
                    header += 31 - (header % 31);
                    s.status = BUSY_STATE;
                    putShortMSB(s, header);
                    /* Save the adler32 of the preset dictionary: */
                    if (s.strstart !== 0) {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
            } // #ifdef GZIP
            if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                break;
                            }
                        }
                        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                        s.gzindex++;
                    }
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (s.gzindex === s.gzhead.extra.length) {
                        s.gzindex = 0;
                        s.status = NAME_STATE;
                    }
                }
                else {
                    s.status = NAME_STATE;
                }
            }
            if (s.status === NAME_STATE) {
                if (s.gzhead.name
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.name.length) {
                            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.gzindex = 0;
                        s.status = COMMENT_STATE;
                    }
                }
                else {
                    s.status = COMMENT_STATE;
                }
            }
            if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.comment.length) {
                            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.status = HCRC_STATE;
                    }
                }
                else {
                    s.status = HCRC_STATE;
                }
            }
            if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                    if (s.pending + 2 > s.pending_buf_size) {
                        flush_pending(strm);
                    }
                    if (s.pending + 2 <= s.pending_buf_size) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, (strm.adler >> 8) & 0xff);
                        strm.adler = 0; // crc32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                    }
                }
                else {
                    s.status = BUSY_STATE;
                }
            } // #endif
            /* Flush as much pending output as possible */
            if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    /* Since avail_out is 0, deflate will be called again with
                     * more output space, but possibly with both pending and
                     * avail_in equal to zero. There won't be anything to do,
                     * but this is not an error situation so make sure we
                     * return OK instead of BUF_ERROR at next call of deflate:
                     */
                    s.last_flush = -1;
                    return Z_OK;
                }
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
            }
            else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
                return err(strm, Z_BUF_ERROR);
            }
            /* User must not provide more input after the first FINISH: */
            if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
            }
            /* Start a new block or continue the current one.
             */
            if (strm.avail_in !== 0 || s.lookahead !== 0 || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
                var bstate = s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                        ? deflate_rle(s, flush)
                        : configuration_table[s.level].func(s, flush);
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                    s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR next call, see above */
                    }
                    return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                     * of deflate should use the same flush parameter to make sure
                     * that the flush is complete. So we don't have to output an
                     * empty block here, this will be done at next call. This also
                     * ensures that for a very small output buffer, we emit at most
                     * one empty block.
                     */
                }
                if (bstate === BS_BLOCK_DONE) {
                    if (flush === Z_PARTIAL_FLUSH) {
                        _tr_align$1(s);
                    }
                    else if (flush !== Z_BLOCK) {
                        /* FULL_FLUSH or SYNC_FLUSH */
                        _tr_stored_block$1(s, 0, 0, false);
                        /* For a full flush, this empty block will be recognized
                         * as a special marker by inflate_sync().
                         */
                        if (flush === Z_FULL_FLUSH) {
                            /** * CLEAR_HASH(s); ** */
                            /* forget history */
                            zero$1(s.head); // Fill with NIL (= 0);
                            if (s.lookahead === 0) {
                                s.strstart = 0;
                                s.block_start = 0;
                                s.insert = 0;
                            }
                        }
                    }
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR at next call, see above */
                        return Z_OK;
                    }
                }
            } // Assert(strm->avail_out > 0, "bug2");
            // if (strm.avail_out <= 0) { throw new Error("bug2");}
            if (flush !== Z_FINISH) {
                return Z_OK;
            }
            if (s.wrap <= 0) {
                return Z_STREAM_END;
            }
            /* Write the trailer */
            if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
            }
            else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            flush_pending(strm);
            /* If avail_out is zero, the application will call deflate again
             * to flush the rest.
             */
            if (s.wrap > 0) {
                s.wrap = -s.wrap;
            }
            /* write the trailer only once! */
            return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        };
        var deflateEnd = function deflateEnd(strm) {
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var status = strm.state.status;
            if (status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.state = null;
            return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        };
        /* =========================================================================
         * Initializes the compression dictionary from the given byte
         * sequence without producing any compressed output.
         */
        var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
            var dictLength = dictionary.length;
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var s = strm.state;
            var wrap = s.wrap;
            if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
                return Z_STREAM_ERROR;
            }
            /* when using zlib wrappers, compute Adler-32 for provided dictionary */
            if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
            }
            s.wrap = 0;
            /* avoid computing Adler-32 in read_buf */
            /* if dictionary would fill window, just replace the history */
            if (dictLength >= s.w_size) {
                if (wrap === 0) {
                    /* already empty otherwise */
                    /** * CLEAR_HASH(s); ** */
                    zero$1(s.head); // Fill with NIL (= 0);
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                var tmpDict = new Uint8Array(s.w_size);
                tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                dictionary = tmpDict;
                dictLength = s.w_size;
            }
            /* insert dictionary into window and hash */
            var avail = strm.avail_in;
            var next = strm.next_in;
            var input = strm.input;
            strm.avail_in = dictLength;
            strm.next_in = 0;
            strm.input = dictionary;
            fill_window(s);
            while (s.lookahead >= MIN_MATCH$1) {
                var str = s.strstart;
                var n = s.lookahead - (MIN_MATCH$1 - 1);
                do {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH$1 - 1;
                fill_window(s);
            }
            s.strstart += s.lookahead;
            s.block_start = s.strstart;
            s.insert = s.lookahead;
            s.lookahead = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            strm.next_in = next;
            strm.input = input;
            strm.avail_in = avail;
            s.wrap = wrap;
            return Z_OK;
        };
        var deflateInit_1 = deflateInit;
        var deflateInit2_1 = deflateInit2;
        var deflateReset_1 = deflateReset;
        var deflateResetKeep_1 = deflateResetKeep;
        var deflateSetHeader_1 = deflateSetHeader;
        var deflate_2 = deflate;
        var deflateEnd_1 = deflateEnd;
        var deflateSetDictionary_1 = deflateSetDictionary;
        var deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
      module.exports.deflateBound = deflateBound;
      module.exports.deflateCopy = deflateCopy;
      module.exports.deflateParams = deflateParams;
      module.exports.deflatePending = deflatePending;
      module.exports.deflatePrime = deflatePrime;
      module.exports.deflateTune = deflateTune;
      */
        var deflate_1 = {
            deflateInit: deflateInit_1,
            deflateInit2: deflateInit2_1,
            deflateReset: deflateReset_1,
            deflateResetKeep: deflateResetKeep_1,
            deflateSetHeader: deflateSetHeader_1,
            deflate: deflate_2,
            deflateEnd: deflateEnd_1,
            deflateSetDictionary: deflateSetDictionary_1,
            deflateInfo: deflateInfo,
        };
        // Join array of chunks to single array.
        function flattenChunks(chunks) {
            // calculate data length
            var len = 0;
            for (var i = 0, l = chunks.length; i < l; i++) {
                len += chunks[i].length;
            } // join chunks
            var result = new Uint8Array(len);
            for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
                var chunk = chunks[_i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
        // String encode/decode helpers
        //
        // - apply(Array) can fail on Android 2.2
        // - apply(Uint8Array) can fail on iOS 5.1 Safari
        //
        // Table with utf8 lengths (calculated by first byte of sequence)
        // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
        // because max possible codepoint is 0x10ffff
        var _utf8len = new Uint8Array(256);
        for (var q = 0; q < 256; q++) {
            _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
        }
        _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
        // convert string to array (typed, when possible)
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        function ZStream() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = '';
            /* Z_NULL */
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2;
            /* Z_UNKNOWN */
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
        var zstream = ZStream;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var toString = Object.prototype.toString;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
        var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
        var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
        var Z_FINISH$1 = constants.Z_FINISH;
        var Z_OK$1 = constants.Z_OK;
        var Z_STREAM_END$1 = constants.Z_STREAM_END;
        var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
        var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
        var Z_DEFLATED$1 = constants.Z_DEFLATED;
        /* =========================================================================== */
        /**
         * class Deflate
         *
         * Generic JS-style wrapper for zlib calls. If you don't need
         * streaming behaviour - use more simple functions: [[deflate]],
         * [[deflateRaw]] and [[gzip]].
         * */
        /* internal
         * Deflate.chunks -> Array
         *
         * Chunks of output data, if [[Deflate#onData]] not overridden.
         * */
        /**
         * Deflate.result -> Uint8Array
         *
         * Compressed result, generated by default [[Deflate#onData]]
         * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
         * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
         * */
        /**
         * Deflate.err -> Number
         *
         * Error code after deflate finished. 0 (Z_OK) on success.
         * You will not need it in real life, because deflate errors
         * are possible only on wrong options or bad `onData` / `onEnd`
         * custom handlers.
         * */
        /**
         * Deflate.msg -> String
         *
         * Error message, if [[Deflate.err]] != 0
         * */
        /**
         * new Deflate(options)
         * - options (Object): zlib deflate options.
         *
         * Creates new deflator instance with specified params. Throws exception
         * on bad params. Supported options:
         *
         * - `level`
         * - `windowBits`
         * - `memLevel`
         * - `strategy`
         * - `dictionary`
         *
         * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
         * for more information on these.
         *
         * Additional options, for internal needs:
         *
         * * `chunkSize` - size of generated data chunks (16K by default)
         * * `raw` (Boolean) - do raw deflate
         * * `gzip` (Boolean) - create gzip wrapper
         * * `header` (Object) - custom header for gzip
         * ** `text` (Boolean) - true if compressed data believed to be text
         * ** `time` (Number) - modification time, unix timestamp
         * ** `os` (Number) - operation system code
         * ** `extra` (Array) - array of bytes with extra data (max 65536)
         * ** `name` (String) - file name (binary string)
         * ** `comment` (String) - comment (binary string)
         * ** `hcrc` (Boolean) - true if header crc should be added
         *
         * ##### Example:
         *
         * ```javascript
         * const pako = require('pako')
         *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
         *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
         *
         * const deflate = new pako.Deflate({ level: 3});
         *
         * deflate.push(chunk1, false);
         * deflate.push(chunk2, true);  // true -> last chunk
         *
         * if (deflate.err) { throw new Error(deflate.err); }
         *
         * console.log(deflate.result);
         * ```
         * */
        function Deflate() {
            this.options = {
                level: Z_DEFAULT_COMPRESSION$1,
                method: Z_DEFLATED$1,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: Z_DEFAULT_STRATEGY$1,
            };
            var opt = this.options;
            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            }
            else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }
            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ''; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data
            this.strm = new zstream();
            this.strm.avail_out = 0;
            var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
            if (status !== Z_OK$1) {
                throw new Error(messages[status]);
            }
            if (opt.header) {
                deflate_1.deflateSetHeader(this.strm, opt.header);
            }
            if (opt.dictionary) {
                var dict; // Convert data if needed
                if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
                    dict = new Uint8Array(opt.dictionary);
                }
                else {
                    dict = opt.dictionary;
                }
                status = deflate_1.deflateSetDictionary(this.strm, dict);
                if (status !== Z_OK$1) {
                    throw new Error(messages[status]);
                }
                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         * converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         * */
        Deflate.prototype.push = function (data, flush_mode) {
            var strm = this.strm;
            var chunkSize = this.options.chunkSize;
            var status;
            var _flush_mode;
            if (this.ended) {
                return false;
            }
            if (flush_mode === ~~flush_mode) {
                _flush_mode = flush_mode;
            }
            else {
                _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
            } // Convert data if needed
            if (toString.call(data) === '[object ArrayBuffer]') {
                strm.input = new Uint8Array(data);
            }
            else {
                strm.input = data;
            }
            strm.next_in = 0;
            strm.avail_in = strm.input.length;
            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                } // Make sure avail_out > 6 to avoid repeating markers
                if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish
                if (status === Z_STREAM_END$1) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$1;
                } // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                } // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                if (strm.avail_in === 0) {
                    break;
                }
            }
            return true;
        };
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         * */
        Deflate.prototype.onData = function (chunk) {
            this.chunks.push(chunk);
        };
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         * other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         * */
        Deflate.prototype.onEnd = function (status) {
            // On success - join
            if (status === Z_OK$1) {
                this.result = flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        };
        // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26
        function string2buf(str) {
            if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
                return new TextEncoder().encode(str);
            }
            var buf;
            var c;
            var c2;
            var m_pos;
            var i;
            var str_len = str.length;
            var buf_len = 0;
            // count binary size
            for (m_pos = 0; m_pos < str_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
            }
            // allocate buffer
            buf = new Uint8Array(buf_len);
            // convert
            for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                if (c < 0x80) {
                    /* one byte */
                    buf[i++] = c;
                }
                else if (c < 0x800) {
                    /* two bytes */
                    buf[i++] = 0xc0 | (c >>> 6);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else if (c < 0x10000) {
                    /* three bytes */
                    buf[i++] = 0xe0 | (c >>> 12);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else {
                    /* four bytes */
                    buf[i++] = 0xf0 | (c >>> 18);
                    buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
            }
            return buf;
        }
        return { Deflate: Deflate, constants: constants, string2buf: string2buf };
    }
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/startDeflateWorker.js


var state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(callback, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    switch (state.status) {
        case 0 /* DeflateWorkerStatus.Nil */:
            state = { status: 1 /* DeflateWorkerStatus.Loading */, callbacks: [callback] };
            doStartDeflateWorker(createDeflateWorkerImpl);
            break;
        case 1 /* DeflateWorkerStatus.Loading */:
            state.callbacks.push(callback);
            break;
        case 2 /* DeflateWorkerStatus.Error */:
            callback();
            break;
        case 3 /* DeflateWorkerStatus.Initialized */:
            callback(state.worker);
            break;
    }
}
function resetDeflateWorkerState() {
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker_1 = createDeflateWorkerImpl();
        addEventListener(worker_1, 'error', onError);
        addEventListener(worker_1, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(data.error);
            }
            else if (data.type === 'initialized') {
                onInitialized(worker_1);
            }
        });
        worker_1.postMessage({ action: 'init' });
        return worker_1;
    }
    catch (error) {
        onError(error);
    }
}
function onInitialized(worker) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.callbacks.forEach(function (callback) { return callback(worker); });
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: worker };
    }
}
function onError(error) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        display.error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            display.error('Please make sure CSP is correctly configured ' +
                'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
        }
        else {
            addTelemetryError(error);
        }
        state.callbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        addTelemetryError(error);
    }
}
function isMessageCspRelated(message) {
    return (includes(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        includes(message, "requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=startDeflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/startRecording.js




function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
    };
    var replayRequest = httpRequest || createHttpRequest(configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
    var _a = startSegmentCollection(lifeCycle, configuration.applicationId, sessionManager, viewContexts, replayRequest, worker), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = record({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
    }), stopRecording = _b.stop, takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: timeStampNow(),
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        takeSubsequentFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/isBrowserSupported.js
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
//# sourceMappingURL=isBrowserSupported.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/getSessionReplayLink.js


function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return getSessionReplayUrl(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session,
    });
}
function getErrorType(session, isRecordingStarted) {
    if (!isBrowserSupported()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (!session.sessionReplayAllowed) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/recorderApi.js





function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
    if (startDeflateWorkerImpl === void 0) { startDeflateWorkerImpl = startDeflateWorker; }
    if (canUseEventBridge() || !isBrowserSupported()) {
        return {
            start: noop,
            stop: noop,
            getReplayStats: function () { return undefined; },
            onRumStart: noop,
            isRecording: function () { return false; },
            getSessionReplayLink: function () { return undefined; },
        };
    }
    var state = {
        status: 0 /* RecorderStatus.Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* RecorderStatus.IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* RecorderStatus.Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: getReplayStats,
        getSessionReplayLink: function (configuration, sessionManager, viewContexts) {
            return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
        },
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    stopStrategy();
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
                if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    return;
                }
                state = { status: 2 /* RecorderStatus.Starting */ };
                runOnReadyState('interactive', function () {
                    if (state.status !== 2 /* RecorderStatus.Starting */) {
                        return;
                    }
                    startDeflateWorkerImpl(function (worker) {
                        if (state.status !== 2 /* RecorderStatus.Starting */) {
                            return;
                        }
                        if (!worker) {
                            state = {
                                status: 0 /* RecorderStatus.Stopped */,
                            };
                            return;
                        }
                        var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, worker).stop;
                        state = {
                            status: 3 /* RecorderStatus.Started */,
                            stopRecording: stopRecording,
                        };
                    });
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* RecorderStatus.Stopped */) {
                    return;
                }
                if (state.status === 3 /* RecorderStatus.Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* RecorderStatus.Stopped */,
                };
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* RecorderStatus.Started */; },
    };
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts





var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 74444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$s": function() { return /* binding */ calculateBackoffMillis; },
/* harmony export */   "BH": function() { return /* binding */ Deferred; },
/* harmony export */   "L": function() { return /* binding */ base64urlEncodeWithoutPadding; },
/* harmony export */   "LL": function() { return /* binding */ ErrorFactory; },
/* harmony export */   "ZR": function() { return /* binding */ FirebaseError; },
/* harmony export */   "aH": function() { return /* binding */ getDefaultAppConfig; },
/* harmony export */   "eu": function() { return /* binding */ validateIndexedDBOpenable; },
/* harmony export */   "hl": function() { return /* binding */ isIndexedDBAvailable; },
/* harmony export */   "m9": function() { return /* binding */ getModularInstance; },
/* harmony export */   "vZ": function() { return /* binding */ deepEqual; },
/* harmony export */   "zI": function() { return /* binding */ areCookiesEnabled; }
/* harmony export */ });
/* unused harmony exports CONSTANTS, DecodeBase64StringError, MAX_VALUE_MILLIS, RANDOM_FACTOR, Sha1, assert, assertionError, async, base64, base64Decode, base64Encode, contains, createMockUserToken, createSubscribe, decode, deepCopy, deepExtend, errorPrefix, extractQuerystring, getDefaultEmulatorHost, getDefaultEmulatorHostnameAndPort, getDefaults, getExperimentalSetting, getGlobal, getUA, isAdmin, isBrowser, isBrowserExtension, isElectron, isEmpty, isIE, isMobileCordova, isNode, isNodeSdk, isReactNative, isSafari, isUWP, isValidFormat, isValidTimestamp, issuedAtTime, jsonEval, map, ordinal, promiseWithTimeout, querystring, querystringDecode, safeGet, stringLength, stringToByteArray, stringify, uuidv4, validateArgCount, validateCallback, validateContextObject, validateNamespace */
/* provided dependency */ var process = __webpack_require__(34155);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw new DecodeBase64StringError();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (const prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
    if (typeof process === 'undefined' || typeof process.env === 'undefined') {
        return;
    }
    const defaultsJsonString = process.env.__FIREBASE_DEFAULTS__;
    if (defaultsJsonString) {
        return JSON.parse(defaultsJsonString);
    }
};
const getDefaultsFromCookie = () => {
    if (typeof document === 'undefined') {
        return;
    }
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    }
    catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
    try {
        return (getDefaultsFromGlobal() ||
            getDefaultsFromEnvVariable() ||
            getDefaultsFromCookie());
    }
    catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */
const getDefaultEmulatorHost = (productName) => { var _a, _b; return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName]; };
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */
const getDefaultEmulatorHostnameAndPort = (productName) => {
    const host = getDefaultEmulatorHost(productName);
    if (!host) {
        return undefined;
    }
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
        throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    }
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') {
        // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
        return [host.substring(1, separatorIndex - 1), port];
    }
    else {
        return [host.substring(0, separatorIndex), port];
    }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const getDefaultAppConfig = () => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config; };
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */
const getExperimentalSetting = (name) => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`]; };

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    const payload = Object.assign({ 
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`, aud: project, iat, exp: iat + 3600, auth_time: iat, sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') {
        return true;
    }
    else if (forceEnvironment === 'browser') {
        return false;
    }
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    }
    catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */
function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(() => deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams)) {
        if (Array.isArray(value)) {
            value.forEach(arrayVal => {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(token => {
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
    constructor() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (let i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    compress_(buf, offset) {
        if (!offset) {
            offset = 0;
        }
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (let i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (let i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (let i = 16; i < 80; i++) {
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (let i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            const t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */
    digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (let i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for (let i = 0; i < 5; i++) {
            for (let j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    constructor(executor, onNoObservers) {
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(() => {
            executor(this);
        })
            .catch(e => {
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer) => {
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer) => {
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer) => {
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error,
                complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(() => {
                try {
                    if (this.finalError) {
                        observer.error(this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    }
    forEachObserver(fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (let i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            if (this.observers !== undefined && this.observers[i] !== undefined) {
                try {
                    fn(this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    }
    close(err) {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return (...args) => {
        Promise.resolve(true)
            .then(() => {
            fn(...args);
        })
            .catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const method of methods) {
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        const error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */
const uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return `${i}`;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    const dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 86907:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalClipboard =  false ? 0 : __webpack_require__(71313)
module.exports = LexicalClipboard;

/***/ }),

/***/ 71313:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d=__webpack_require__(87592),n=__webpack_require__(89408),r=__webpack_require__(76969),t=__webpack_require__(32998);function z(a){throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?code=${a} for the full message or `+"use the non-minified dev environment for full errors and additional helpful warnings.");}
function A(a){let b=t.$getSelection();if(null==b)throw Error("Expected valid LexicalSelection");return t.$isRangeSelection(b)&&b.isCollapsed()||0===b.getNodes().length?"":d.$generateHtmlFromNodes(a,b)}function B(a){let b=t.$getSelection();if(null==b)throw Error("Expected valid LexicalSelection");return t.$isRangeSelection(b)&&b.isCollapsed()||0===b.getNodes().length?null:JSON.stringify(C(a,b))}
function D(a,b,c){(t.DEPRECATED_$isGridSelection(c)||null!==r.$findMatchingParent(c.anchor.getNode(),f=>t.DEPRECATED_$isGridCellNode(f))&&null!==r.$findMatchingParent(c.focus.getNode(),f=>t.DEPRECATED_$isGridCellNode(f)))&&1===b.length&&t.DEPRECATED_$isGridNode(b[0])?E(b,c,!1,a):H(b,c)}
function H(a,b){let c=[],f=null;for(let e=0;e<a.length;e++){let h=a[e],g=t.$isLineBreakNode(h);if(g||t.$isDecoratorNode(h)&&h.isInline()||t.$isElementNode(h)&&h.isInline()||t.$isTextNode(h)||h.isParentRequired()){if(null===f&&(f=h.createParentElementNode(),c.push(f),g))continue;null!==f&&f.append(h)}else c.push(h),f=null}t.$isRangeSelection(b)?b.insertNodes(c):t.DEPRECATED_$isGridSelection(b)&&(a=b.anchor.getNode(),t.DEPRECATED_$isGridCellNode(a)||z(41),a.append(...c))}
function E(a,b,c,f){1===a.length&&t.DEPRECATED_$isGridNode(a[0])||z(42);var e=a[0];a=e.getChildren();c=e.getFirstChildOrThrow().getChildrenSize();var h=e.getChildrenSize(),g=r.$findMatchingParent(b.anchor.getNode(),l=>t.DEPRECATED_$isGridCellNode(l));b=(e=g&&r.$findMatchingParent(g,l=>t.DEPRECATED_$isGridRowNode(l)))&&r.$findMatchingParent(e,l=>t.DEPRECATED_$isGridNode(l));t.DEPRECATED_$isGridCellNode(g)&&t.DEPRECATED_$isGridRowNode(e)&&t.DEPRECATED_$isGridNode(b)||z(43);var k=e.getIndexWithinParent(),
p=Math.min(b.getChildrenSize()-1,k+h-1);h=g.getIndexWithinParent();g=Math.min(e.getChildrenSize()-1,h+c-1);c=Math.min(h,g);e=Math.min(k,p);h=Math.max(h,g);k=Math.max(k,p);p=b.getChildren();g=0;let m,q;for(let l=e;l<=k;l++){var x=p[l];t.DEPRECATED_$isGridRowNode(x)||z(24);var y=a[g];t.DEPRECATED_$isGridRowNode(y)||z(24);x=x.getChildren();y=y.getChildren();let F=0;for(let u=c;u<=h;u++){let v=x[u];t.DEPRECATED_$isGridCellNode(v)||z(25);let G=y[F];t.DEPRECATED_$isGridCellNode(G)||z(25);l===e&&u===c?m=
v.getKey():l===k&&u===h&&(q=v.getKey());let M=v.getChildren();G.getChildren().forEach(w=>{t.$isTextNode(w)&&t.$createParagraphNode().append(w);v.append(w)});M.forEach(w=>w.remove());F++}g++}m&&q&&(a=t.DEPRECATED_$createGridSelection(),a.set(b.getKey(),m,q),t.$setSelection(a),f.dispatchCommand(t.SELECTION_CHANGE_COMMAND,void 0))}
function I(a,b,c,f=[]){let e=null!=b?c.isSelected(b):!0,h=t.$isElementNode(c)&&c.excludeFromCopy("html");var g=c;if(null!==b){var k=n.$cloneWithProperties(c);g=k=t.$isTextNode(k)&&null!=b?n.$sliceSelectedTextNodeContent(b,k):k}let p=t.$isElementNode(g)?g.getChildren():[];var m=g;k=m.exportJSON();k.type!==m.constructor.getType()&&z(58);var q=k.children;t.$isElementNode(m)&&(Array.isArray(q)||z(59));t.$isTextNode(g)&&(g=g.__text,0<g.length?k.text=g:e=!1);for(g=0;g<p.length;g++)m=p[g],q=I(a,b,m,k.children),
!e&&t.$isElementNode(c)&&q&&c.extractWithChild(m,b,"clone")&&(e=!0);if(e&&!h)f.push(k);else if(Array.isArray(k.children))for(a=0;a<k.children.length;a++)f.push(k.children[a]);return e}function C(a,b){let c=[],f=t.$getRoot().getChildren();for(let e=0;e<f.length;e++)I(a,b,f[e],c);return{namespace:a._config.namespace,nodes:c}}function J(a){let b=[];for(let c=0;c<a.length;c++){let f=t.$parseSerializedNode(a[c]);t.$isTextNode(f)&&n.$addNodeStyle(f);b.push(f)}return b}let K=null;
function L(a,b){var c=window.getSelection();if(!c)return!1;var f=c.anchorNode;c=c.focusNode;if(null!==f&&null!==c&&!t.isSelectionWithinEditor(a,f,c))return!1;b.preventDefault();b=b.clipboardData;f=t.$getSelection();if(null===b||null===f)return!1;c=A(a);a=B(a);let e="";null!==f&&(e=f.getTextContent());null!==c&&b.setData("text/html",c);null!==a&&b.setData("application/x-lexical-editor",a);b.setData("text/plain",e);return!0}exports.$generateJSONFromSelectedNodes=C;
exports.$generateNodesFromSerializedNodes=J;exports.$getHtmlContent=A;exports.$getLexicalContent=B;exports.$insertDataTransferForPlainText=function(a,b){a=a.getData("text/plain")||a.getData("text/uri-list");null!=a&&b.insertRawText(a)};
exports.$insertDataTransferForRichText=function(a,b,c){var f=a.getData("application/x-lexical-editor");if(f)try{let g=JSON.parse(f);if(g.namespace===c._config.namespace&&Array.isArray(g.nodes)){let k=J(g.nodes);return D(c,k,b)}}catch{}if(f=a.getData("text/html"))try{var e=(new DOMParser).parseFromString(f,"text/html"),h=d.$generateNodesFromDOM(c,e);return D(c,h,b)}catch{}a=a.getData("text/plain")||a.getData("text/uri-list");if(null!=a)if(t.$isRangeSelection(b))for(a=a.split(/(\r?\n|\t)/),c=a.length,
e=0;e<c;e++)h=a[e],"\n"===h||"\r\n"===h?b.insertParagraph():"\t"===h?b.insertNodes([t.$createTabNode()]):b.insertText(h);else b.insertRawText(a)};exports.$insertGeneratedNodes=D;
exports.copyToClipboard=async function(a,b){if(null!==K)return!1;if(null!==b)return new Promise(h=>{a.update(()=>{h(L(a,b))})});var c=a.getRootElement();let f=document.getSelection();if(null===c||null===f)return!1;let e=document.createElement("span");e.style.cssText="position: fixed; top: -1000px;";e.append(document.createTextNode("#"));c.append(e);c=new Range;c.setStart(e,0);c.setEnd(e,1);f.removeAllRanges();f.addRange(c);return new Promise(h=>{let g=a.registerCommand(t.COPY_COMMAND,k=>{k instanceof
ClipboardEvent&&(g(),null!==K&&(window.clearTimeout(K),K=null),h(L(a,k)));return!0},t.COMMAND_PRIORITY_CRITICAL);K=window.setTimeout(()=>{g();K=null;h(!1)},50);document.execCommand("copy");e.remove()})}


/***/ }),

/***/ 23277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalCode =  false ? 0 : __webpack_require__(88233)
module.exports = LexicalCode;

/***/ }),

/***/ 88233:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d=__webpack_require__(15660);__webpack_require__(35433);__webpack_require__(39980);__webpack_require__(24335);__webpack_require__(24064);__webpack_require__(4279);__webpack_require__(15251);__webpack_require__(11426);__webpack_require__(35266);__webpack_require__(80366);__webpack_require__(70767);__webpack_require__(90874);
__webpack_require__(96836);__webpack_require__(52503);__webpack_require__(2731);var l=__webpack_require__(76969),r=__webpack_require__(32998);let v=a=>null!=a&&d.languages.hasOwnProperty(a)?a:void 0;function x(a,b){for(let c of a.childNodes){if(l.isHTMLElement(c)&&c.tagName===b)return!0;x(c,b)}return!1}
class y extends r.ElementNode{static getType(){return"code"}static clone(a){return new y(a.__language,a.__key)}constructor(a,b){super(b);this.__language=v(a)}createDOM(a){let b=document.createElement("code");l.addClassNamesToElement(b,a.theme.code);b.setAttribute("spellcheck","false");(a=this.getLanguage())&&b.setAttribute("data-highlight-language",a);return b}updateDOM(a,b){let c=this.__language;a=a.__language;c?c!==a&&b.setAttribute("data-highlight-language",c):a&&b.removeAttribute("data-highlight-language");
return!1}static importDOM(){return{code:a=>null!=a.textContent&&(/\r?\n/.test(a.textContent)||x(a,"BR"))?{conversion:z,priority:1}:null,div:()=>({conversion:aa,priority:1}),pre:()=>({conversion:z,priority:0}),table:a=>A(a)?{conversion:ba,priority:3}:null,td:a=>{let b=a.closest("table");return a.classList.contains("js-file-line")?{conversion:ca,priority:3}:b&&A(b)?{conversion:B,priority:3}:null},tr:a=>(a=a.closest("table"))&&A(a)?{conversion:B,priority:3}:null}}static importJSON(a){let b=C(a.language);
b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return{...super.exportJSON(),language:this.getLanguage(),type:"code",version:1}}insertNewAfter(a,b=!0){var c=this.getChildren(),e=c.length;if(2<=e&&"\n"===c[e-1].getTextContent()&&"\n"===c[e-2].getTextContent()&&a.isCollapsed()&&a.anchor.key===this.__key&&a.anchor.offset===e)return c[e-1].remove(),c[e-2].remove(),a=r.$createParagraphNode(),this.insertAfter(a,b),a;b=a.anchor;c=a.focus;b=(b.isBefore(c)?b:c).getNode();
if(D(b)||r.$isTabNode(b)){b=E(b);for(c=[];;)if(r.$isTabNode(b))c.push(r.$createTabNode()),b=b.getNextSibling();else if(D(b)){e=0;let f=b.getTextContent(),g=b.getTextContentSize();for(;e<g&&" "===f[e];e++);0!==e&&c.push(F(" ".repeat(e)));if(e!==g)break;b=b.getNextSibling()}else break;if(0<c.length)return a.insertNodes([r.$createLineBreakNode(),...c]),c[c.length-1]}return null}canIndent(){return!1}collapseAtStart(){let a=r.$createParagraphNode();this.getChildren().forEach(b=>a.append(b));this.replace(a);
return!0}setLanguage(a){this.getWritable().__language=v(a)}getLanguage(){return this.getLatest().__language}}function C(a){return r.$applyNodeReplacement(new y(a))}function G(a){return a instanceof y}function z(){return{node:C()}}function aa(a){let b=null!==a.style.fontFamily.match("monospace");return b||da(a)?{after:c=>{let e=a.parentNode;null!=e&&a!==e.lastChild&&c.push(r.$createLineBreakNode());return c},node:b?C():null}:{node:null}}function ba(){return{node:C()}}
function B(){return{node:null}}function ca(a){return{after:b=>{a.parentNode&&a.parentNode.nextSibling&&b.push(r.$createLineBreakNode());return b},node:null}}function da(a){for(a=a.parentElement;null!==a;){if(null!==a.style.fontFamily.match("monospace"))return!0;a=a.parentElement}return!1}function A(a){return a.classList.contains("js-file-line-container")}
let H={c:"C",clike:"C-like",cpp:"C++",css:"CSS",html:"HTML",java:"Java",js:"JavaScript",markdown:"Markdown",objc:"Objective-C",plain:"Plain Text",py:"Python",rust:"Rust",sql:"SQL",swift:"Swift",typescript:"TypeScript",xml:"XML"},J={cpp:"cpp",java:"java",javascript:"js",md:"markdown",plaintext:"plain",python:"py",text:"plain",ts:"typescript"};function K(a){return J[a]||a}
class L extends r.TextNode{constructor(a,b,c){super(a,c);this.__highlightType=b}static getType(){return"code-highlight"}static clone(a){return new L(a.__text,a.__highlightType||void 0,a.__key)}getHighlightType(){return this.getLatest().__highlightType}createDOM(a){let b=super.createDOM(a);a=M(a.theme,this.__highlightType);l.addClassNamesToElement(b,a);return b}updateDOM(a,b,c){let e=super.updateDOM(a,b,c);a=M(c.theme,a.__highlightType);c=M(c.theme,this.__highlightType);a!==c&&(a&&l.removeClassNamesFromElement(b,
a),c&&l.addClassNamesToElement(b,c));return e}static importJSON(a){let b=F(a.text,a.highlightType);b.setFormat(a.format);b.setDetail(a.detail);b.setMode(a.mode);b.setStyle(a.style);return b}exportJSON(){return{...super.exportJSON(),highlightType:this.getHighlightType(),type:"code-highlight",version:1}}setFormat(){return this}isParentRequired(){return!0}createParentElementNode(){return C()}}function M(a,b){return b&&a&&a.codeHighlight&&a.codeHighlight[b]}
function F(a,b){return r.$applyNodeReplacement(new L(a,b))}function D(a){return a instanceof L}function E(a){let b=a;for(;D(a)||r.$isTabNode(a);)b=a,a=a.getPreviousSibling();return b}function N(a){let b=a;for(;D(a)||r.$isTabNode(a);)b=a,a=a.getNextSibling();return b}let O={defaultLanguage:"javascript",tokenize(a,b){return d.tokenize(a,d.languages[b||""]||d.languages[this.defaultLanguage])}};
function P(a,b){let c=null;var e=null,f=a;let g=b,k=a.getTextContent();for(;;){if(0===g){f=f.getPreviousSibling();if(null===f)break;if(!(D(f)||r.$isTabNode(f)||r.$isLineBreakNode(f)))throw Error("Expected a valid Code Node: CodeHighlightNode, TabNode, LineBreakNode");if(r.$isLineBreakNode(f)){c={node:f,offset:1};break}g=Math.max(0,f.getTextContentSize()-1);k=f.getTextContent()}else g--;let h=k[g];D(f)&&" "!==h&&(e={node:f,offset:g})}if(null!==e)return e;e=null;b<a.getTextContentSize()?D(a)&&(e=a.getTextContent()[b]):
(f=a.getNextSibling(),D(f)&&(e=f.getTextContent()[0]));if(null!==e&&" "!==e)return c;a:for(e=a,f=a.getTextContent(),a=a.getTextContentSize();;){if(!D(e)||b===a){e=e.getNextSibling();if(null===e||r.$isLineBreakNode(e)){a=null;break a}D(e)&&(b=0,f=e.getTextContent(),a=e.getTextContentSize())}if(D(e)){if(" "!==f[b]){a={node:e,offset:b};break a}b++}}return null!==a?a:c}function Q(a){a=N(a);if(r.$isLineBreakNode(a))throw Error("Unexpected lineBreakNode in getEndOfCodeInLine");return a}
function R(a,b,c){let e=a.getParent();G(e)?S(e,b,c):D(a)&&a.replace(r.$createTextNode(a.__text))}let T=new Set;
function S(a,b,c){let e=a.getKey();T.has(e)||(T.add(e),void 0===a.getLanguage()&&a.setLanguage(c.defaultLanguage),b.update(()=>{ea(e,()=>{var f=r.$getNodeByKey(e);if(!G(f)||!f.isAttached())return!1;var g=f.getTextContent();g=c.tokenize(g,f.getLanguage()||c.defaultLanguage);g=U(g);var k=f.getChildren();for(f=0;f<k.length&&V(k[f],g[f]);)f++;var h=k.length;let m=g.length,q=Math.min(h,m)-f,n=0;for(;n<q;)if(n++,!V(k[h-n],g[m-n])){n--;break}k=f;h-=n;g=g.slice(f,m-n);let {from:p,to:w,nodesForReplacement:u}=
{from:k,nodesForReplacement:g,to:h};return p!==w||u.length?(a.splice(p,w-p,u),!0):!1})},{onUpdate:()=>{T.delete(e)},skipTransforms:!0}))}
function U(a){let b=[];a.forEach(c=>{if("string"===typeof c){c=c.split(/(\n|\t)/);var e=c.length;for(let f=0;f<e;f++){let g=c[f];"\n"===g||"\r\n"===g?b.push(r.$createLineBreakNode()):"\t"===g?b.push(r.$createTabNode()):0<g.length&&b.push(F(g))}}else({content:e}=c),"string"===typeof e?b.push(F(e,c.type)):Array.isArray(e)&&1===e.length&&"string"===typeof e[0]?b.push(F(e[0],c.type)):Array.isArray(e)&&b.push(...U(e))});return b}
function ea(a,b){a=r.$getNodeByKey(a);if(G(a)&&a.isAttached()){var c=r.$getSelection();if(r.$isRangeSelection(c)){c=c.anchor;var e=c.offset,f="element"===c.type&&r.$isLineBreakNode(a.getChildAtIndex(c.offset-1)),g=0;if(!f){let k=c.getNode();g=e+k.getPreviousSiblings().reduce((h,m)=>h+m.getTextContentSize(),0)}b()&&(f?c.getNode().select(e,e):a.getChildren().some(k=>{let h=r.$isTextNode(k);if(h||r.$isLineBreakNode(k)){let m=k.getTextContentSize();if(h&&m>=g)return k.select(g,g),!0;g-=m}return!1}))}else b()}}
function V(a,b){return D(a)&&D(b)&&a.__text===b.__text&&a.__highlightType===b.__highlightType||r.$isTabNode(a)&&r.$isTabNode(b)||r.$isLineBreakNode(a)&&r.$isLineBreakNode(b)}function W(a){if(!r.$isRangeSelection(a))return!1;var b=a.anchor.getNode();a=a.focus.getNode();if(b.is(a)&&G(b))return!0;b=b.getParent();return G(b)&&b.is(a.getParent())}
function X(a){a=a.getNodes();let b=[[]];if(1===a.length&&G(a[0]))return b;let c=b[0];for(let e=0;e<a.length;e++){let f=a[e];if(!(D(f)||r.$isTabNode(f)||r.$isLineBreakNode(f)))throw Error("Expected selection to be inside CodeBlock and consisting of CodeHighlightNode, TabNode and LineBreakNode");r.$isLineBreakNode(f)?0!==e&&0<c.length&&(c=[],b.push(c)):c.push(f)}return b}
function fa(a){var b=r.$getSelection();if(!r.$isRangeSelection(b)||!W(b))return null;let c=a?r.OUTDENT_CONTENT_COMMAND:r.INDENT_CONTENT_COMMAND;a=a?r.OUTDENT_CONTENT_COMMAND:r.INSERT_TAB_COMMAND;if(1<X(b).length)return c;var e=b.getNodes()[0];if(!(G(e)||D(e)||r.$isTabNode(e)||r.$isLineBreakNode(e)))throw Error("Expected selection firstNode to be CodeHighlightNode or TabNode");if(G(e))return c;let f=E(e);e=N(e);var g=b.anchor;let k=b.focus;k.isBefore(g)?b=k:(b=g,g=k);return null!==f&&null!==e&&b.key===
f.getKey()&&0===b.offset&&g.key===e.getKey()&&g.offset===e.getTextContentSize()?c:a}
function Y(a){var b=r.$getSelection();if(!r.$isRangeSelection(b)||!W(b))return!1;var c=X(b);let e=c.length;if(1<c.length){for(b=0;b<e;b++){var f=c[b];0<f.length&&(f=f[0],0===b&&(f=E(f)),null!==f&&(a===r.INDENT_CONTENT_COMMAND?f.insertBefore(r.$createTabNode()):r.$isTabNode(f)&&f.remove()))}return!0}c=b.getNodes()[0];if(!(G(c)||D(c)||r.$isTabNode(c)||r.$isLineBreakNode(c)))throw Error("Expected selection firstNode to be CodeHighlightNode or CodeTabNode");if(G(c))return a===r.INDENT_CONTENT_COMMAND&&
b.insertNodes([r.$createTabNode()]),!0;c=E(c);if(null===c)throw Error("Expected getFirstCodeNodeOfLine to return a valid Code Node");a===r.INDENT_CONTENT_COMMAND?r.$isLineBreakNode(c)?c.insertAfter(r.$createTabNode()):c.insertBefore(r.$createTabNode()):r.$isTabNode(c)&&c.remove();return!0}
function Z(a,b){let c=r.$getSelection();if(!r.$isRangeSelection(c))return!1;let {anchor:e,focus:f}=c,g=e.offset,k=f.offset,h=e.getNode(),m=f.getNode();var q=a===r.KEY_ARROW_UP_COMMAND;if(!W(c)||!D(h)&&!r.$isTabNode(h)||!D(m)&&!r.$isTabNode(m))return!1;if(!b.altKey){if(c.isCollapsed())if(a=h.getParentOrThrow(),q&&0===g&&null===h.getPreviousSibling()){if(null===a.getPreviousSibling())return a.selectPrevious(),b.preventDefault(),!0}else if(!q&&g===h.getTextContentSize()&&null===h.getNextSibling()&&null===
a.getNextSibling())return a.selectNext(),b.preventDefault(),!0;return!1}let n;if(h.isBefore(m)){var p=E(h);n=N(m)}else p=E(m),n=N(h);if(null==p||null==n)return!1;let w=p.getNodesBetween(n);for(let t=0;t<w.length;t++){let I=w[t];if(!D(I)&&!r.$isTabNode(I)&&!r.$isLineBreakNode(I))return!1}b.preventDefault();b.stopPropagation();b=q?p.getPreviousSibling():n.getNextSibling();if(!r.$isLineBreakNode(b))return!0;p=q?b.getPreviousSibling():b.getNextSibling();if(null==p)return!0;q=D(p)||r.$isTabNode(p)||r.$isLineBreakNode(p)?
q?E(p):N(p):null;let u=null!=q?q:p;b.remove();w.forEach(t=>t.remove());a===r.KEY_ARROW_UP_COMMAND?(w.forEach(t=>u.insertBefore(t)),u.insertBefore(b)):(u.insertAfter(b),u=b,w.forEach(t=>{u.insertAfter(t);u=t}));c.setTextNodeRange(h,g,m,k);return!0}
function ha(a,b){let c=r.$getSelection();if(!r.$isRangeSelection(c))return!1;let {anchor:e,focus:f}=c;var g=e.getNode();let k=f.getNode();a=a===r.MOVE_TO_START;if(!D(g)&&!r.$isTabNode(g)||!D(k)&&!r.$isTabNode(k))return!1;if(a)if(g=P(k,f.offset),null!==g){let {node:h,offset:m}=g;r.$isLineBreakNode(h)?h.selectNext(0,0):c.setTextNodeRange(h,m,h,m)}else k.getParentOrThrow().selectStart();else Q(k).select();b.preventDefault();b.stopPropagation();return!0}exports.$createCodeHighlightNode=F;
exports.$createCodeNode=C;exports.$isCodeHighlightNode=D;exports.$isCodeNode=G;exports.CODE_LANGUAGE_FRIENDLY_NAME_MAP=H;exports.CODE_LANGUAGE_MAP=J;exports.CodeHighlightNode=L;exports.CodeNode=y;exports.DEFAULT_CODE_LANGUAGE="javascript";exports.PrismTokenizer=O;exports.getCodeLanguages=()=>Object.keys(d.languages).filter(a=>"function"!==typeof d.languages[a]).sort();exports.getDefaultCodeLanguage=()=>"javascript";exports.getEndOfCodeInLine=Q;exports.getFirstCodeNodeOfLine=E;
exports.getLanguageFriendlyName=function(a){a=K(a);return H[a]||a};exports.getLastCodeNodeOfLine=N;exports.getStartOfCodeInLine=P;exports.normalizeCodeLang=K;
exports.registerCodeHighlighting=function(a,b){if(!a.hasNodes([y,L]))throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");null==b&&(b=O);return l.mergeRegister(a.registerMutationListener(y,c=>{a.update(()=>{for(let [g,k]of c)if("destroyed"!==k){var e=r.$getNodeByKey(g);if(null!==e)a:{var f=e;e=a.getElementByKey(f.getKey());if(null===e)break a;f=f.getChildren();let h=f.length;if(h===e.__cachedChildrenLength)break a;e.__cachedChildrenLength=h;let m="1",q=1;for(let n=
0;n<h;n++)r.$isLineBreakNode(f[n])&&(m+="\n"+ ++q);e.setAttribute("data-gutter",m)}}})}),a.registerNodeTransform(y,c=>S(c,a,b)),a.registerNodeTransform(r.TextNode,c=>R(c,a,b)),a.registerNodeTransform(L,c=>R(c,a,b)),a.registerCommand(r.KEY_TAB_COMMAND,c=>{let e=fa(c.shiftKey);if(null===e)return!1;c.preventDefault();a.dispatchCommand(e,void 0);return!0},r.COMMAND_PRIORITY_LOW),a.registerCommand(r.INSERT_TAB_COMMAND,()=>{let c=r.$getSelection();if(!W(c))return!1;r.$insertNodes([r.$createTabNode()]);
return!0},r.COMMAND_PRIORITY_LOW),a.registerCommand(r.INDENT_CONTENT_COMMAND,()=>Y(r.INDENT_CONTENT_COMMAND),r.COMMAND_PRIORITY_LOW),a.registerCommand(r.OUTDENT_CONTENT_COMMAND,()=>Y(r.OUTDENT_CONTENT_COMMAND),r.COMMAND_PRIORITY_LOW),a.registerCommand(r.KEY_ARROW_UP_COMMAND,c=>Z(r.KEY_ARROW_UP_COMMAND,c),r.COMMAND_PRIORITY_LOW),a.registerCommand(r.KEY_ARROW_DOWN_COMMAND,c=>Z(r.KEY_ARROW_DOWN_COMMAND,c),r.COMMAND_PRIORITY_LOW),a.registerCommand(r.MOVE_TO_END,c=>ha(r.MOVE_TO_END,c),r.COMMAND_PRIORITY_LOW),
a.registerCommand(r.MOVE_TO_START,c=>ha(r.MOVE_TO_START,c),r.COMMAND_PRIORITY_LOW))}


/***/ }),

/***/ 70573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalDragon =  false ? 0 : __webpack_require__(97370)
module.exports = LexicalDragon;

/***/ }),

/***/ 97370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g=__webpack_require__(32998);
exports.registerDragonSupport=function(m){let t=window.location.origin,r=l=>{if(l.origin===t){var h=m.getRootElement();if(document.activeElement===h&&(h=l.data,"string"===typeof h)){try{var a=JSON.parse(h)}catch(k){return}if(a&&"nuanria_messaging"===a.protocol&&"request"===a.type&&(a=a.payload)&&"makeChanges"===a.functionId&&(a=a.args)){const [k,n,p,q,u]=a;m.update(()=>{const f=g.$getSelection();if(g.$isRangeSelection(f)){var e=f.anchor;let b=e.getNode(),c=0,d=0;g.$isTextNode(b)&&0<=k&&0<=n&&(c=k,
d=k+n,f.setTextNodeRange(b,c,b,d));if(c!==d||""!==p)f.insertRawText(p),b=e.getNode();g.$isTextNode(b)&&(c=q,d=q+u,e=b.getTextContentSize(),c=c>e?e:c,d=d>e?e:d,f.setTextNodeRange(b,c,b,d));l.stopImmediatePropagation()}})}}}};window.addEventListener("message",r,!0);return()=>{window.removeEventListener("message",r,!0)}}


/***/ }),

/***/ 48854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalHistory =  false ? 0 : __webpack_require__(54379)
module.exports = LexicalHistory;

/***/ }),

/***/ 54379:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c=__webpack_require__(76969),x=__webpack_require__(32998);
function y(b,a,l,h,n){if(null===b||0===l.size&&0===h.size&&!n)return 0;var f=a._selection,d=b._selection;if(n)return 1;if(!(x.$isRangeSelection(f)&&x.$isRangeSelection(d)&&d.isCollapsed()&&f.isCollapsed()))return 0;n=a._nodeMap;let e=[];for(let m of l)l=n.get(m),void 0!==l&&e.push(l);for(let [m,p]of h)p&&(h=n.get(m),void 0===h||x.$isRootNode(h)||e.push(h));if(0===e.length)return 0;if(1<e.length)return h=a._nodeMap,a=h.get(f.anchor.key),d=h.get(d.anchor.key),a&&d&&!b._nodeMap.has(a.__key)&&x.$isTextNode(a)&&
1===a.__text.length&&1===f.anchor.offset?2:0;a=e[0];b=b._nodeMap.get(a.__key);if(!x.$isTextNode(b)||!x.$isTextNode(a)||b.__mode!==a.__mode)return 0;b=b.__text;a=a.__text;if(b===a)return 0;f=f.anchor;d=d.anchor;if(f.key!==d.key||"text"!==f.type)return 0;f=f.offset;d=d.offset;b=a.length-b.length;return 1===b&&d===f-1?2:-1===b&&d===f+1?3:-1===b&&d===f?4:0}
function z(b,a){let l=Date.now(),h=0;return(n,f,d,e,m,p)=>{let r=Date.now();if(p.has("historic"))return h=0,l=r,2;let q=y(n,f,e,m,b.isComposing()),v=(()=>{var k=null===d||d.editor===b,g=p.has("history-push");if(!g&&k&&p.has("history-merge"))return 0;if(null===n)return 1;var t=f._selection;if(!(0<e.size||0<m.size))return null!==t?0:2;if(!1===g&&0!==q&&q===h&&r<l+a&&k)return 0;if(1===e.size){{g=Array.from(e)[0];k=n._nodeMap.get(g);g=f._nodeMap.get(g);t=n._selection;let u=f._selection,w=!1;x.$isRangeSelection(t)&&
x.$isRangeSelection(u)&&(w="element"===t.anchor.type&&"element"===t.focus.type&&"text"===u.anchor.type&&"text"===u.focus.type);k=!w&&x.$isTextNode(k)&&x.$isTextNode(g)?k.__type===g.__type&&k.__text===g.__text&&k.__mode===g.__mode&&k.__detail===g.__detail&&k.__style===g.__style&&k.__format===g.__format&&k.__parent===g.__parent:!1}if(k)return 0}return 1})();l=r;h=q;return v}}exports.createEmptyHistoryState=function(){return{current:null,redoStack:[],undoStack:[]}};
exports.registerHistory=function(b,a,l){let h=z(b,l);l=({editorState:d,prevEditorState:e,dirtyLeaves:m,dirtyElements:p,tags:r})=>{const q=a.current,v=a.redoStack,k=a.undoStack,g=null===q?null:q.editorState;if(null===q||d!==g){e=h(e,d,q,m,p,r);if(1===e)0!==v.length&&(a.redoStack=[],b.dispatchCommand(x.CAN_REDO_COMMAND,!1)),null!==q&&(k.push({...q}),b.dispatchCommand(x.CAN_UNDO_COMMAND,!0));else if(2===e)return;a.current={editor:b,editorState:d}}};let n=c.mergeRegister(b.registerCommand(x.UNDO_COMMAND,
()=>{let d=a.redoStack,e=a.undoStack;if(0!==e.length){let m=a.current,p=e.pop();null!==m&&(d.push(m),b.dispatchCommand(x.CAN_REDO_COMMAND,!0));0===e.length&&b.dispatchCommand(x.CAN_UNDO_COMMAND,!1);a.current=p||null;p&&p.editor.setEditorState(p.editorState,{tag:"historic"})}return!0},x.COMMAND_PRIORITY_EDITOR),b.registerCommand(x.REDO_COMMAND,()=>{let d=a.redoStack;var e=a.undoStack;if(0!==d.length){let m=a.current;null!==m&&(e.push(m),b.dispatchCommand(x.CAN_UNDO_COMMAND,!0));e=d.pop();0===d.length&&
b.dispatchCommand(x.CAN_REDO_COMMAND,!1);a.current=e||null;e&&e.editor.setEditorState(e.editorState,{tag:"historic"})}return!0},x.COMMAND_PRIORITY_EDITOR),b.registerCommand(x.CLEAR_EDITOR_COMMAND,()=>{a.undoStack=[];a.redoStack=[];a.current=null;return!1},x.COMMAND_PRIORITY_EDITOR),b.registerCommand(x.CLEAR_HISTORY_COMMAND,()=>{a.undoStack=[];a.redoStack=[];a.current=null;b.dispatchCommand(x.CAN_REDO_COMMAND,!1);b.dispatchCommand(x.CAN_UNDO_COMMAND,!1);return!0},x.COMMAND_PRIORITY_EDITOR),b.registerUpdateListener(l)),
f=b.registerUpdateListener(l);return()=>{n();f()}}


/***/ }),

/***/ 87592:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalHtml =  false ? 0 : __webpack_require__(64478)
module.exports = LexicalHtml;

/***/ }),

/***/ 64478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m=__webpack_require__(89408),q=__webpack_require__(32998);
function r(c,d,h,a=null){let e=null!=a?d.isSelected(a):!0,k=q.$isElementNode(d)&&d.excludeFromCopy("html");var f=d;null!==a&&(f=m.$cloneWithProperties(d),f=q.$isTextNode(f)&&null!=a?m.$sliceSelectedTextNodeContent(a,f):f);let g=q.$isElementNode(f)?f.getChildren():[],{element:b,after:l}=f.exportDOM(c);if(!b)return!1;let n=document.createDocumentFragment();for(let p=0;p<g.length;p++){let t=g[p],w=r(c,t,n,a);!e&&q.$isElementNode(d)&&w&&d.extractWithChild(t,a,"html")&&(e=!0)}e&&!k?(b.append(n),h.append(b),
l&&(c=l.call(f,b))&&b.replaceWith(c)):h.append(n);return e}let u=new Set(["STYLE","SCRIPT"]);
function v(c,d,h=new Map,a){let e=[];if(u.has(c.nodeName))return e;let k=null;var f,{nodeName:g}=c,b=d._htmlConversions.get(g.toLowerCase());g=null;if(void 0!==b)for(f of b)b=f(c),null!==b&&(null===g||g.priority<b.priority)&&(g=b);g=(f=null!==g?g.conversion:null)?f(c):null;f=null;if(null!==g){f=g.after;b=g.node;k=Array.isArray(b)?b[b.length-1]:b;if(null!==k){for(var [,l]of h)if(k=l(k,a),!k)break;k&&e.push(...(Array.isArray(b)?b:[k]))}null!=g.forChild&&h.set(c.nodeName,g.forChild)}c=c.childNodes;a=
[];for(l=0;l<c.length;l++)a.push(...v(c[l],d,new Map(h),k));null!=f&&(a=f(a));null==k?e=e.concat(a):q.$isElementNode(k)&&k.append(...a);return e}
exports.$generateHtmlFromNodes=function(c,d){if("undefined"===typeof document||"undefined"===typeof window)throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");let h=document.createElement("div"),a=q.$getRoot().getChildren();for(let e=0;e<a.length;e++)r(c,a[e],h,d);return h.innerHTML};
exports.$generateNodesFromDOM=function(c,d){d=d.body?d.body.childNodes:[];let h=[];for(let e=0;e<d.length;e++){var a=d[e];u.has(a.nodeName)||(a=v(a,c),null!==a&&(h=h.concat(a)))}return h}


/***/ }),

/***/ 73435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalLink =  false ? 0 : __webpack_require__(13906)
module.exports = LexicalLink;

/***/ }),

/***/ 13906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k=__webpack_require__(76969),n=__webpack_require__(32998);let p=new Set(["http:","https:","mailto:","sms:","tel:"]);
class q extends n.ElementNode{static getType(){return"link"}static clone(a){return new q(a.__url,{rel:a.__rel,target:a.__target,title:a.__title},a.__key)}constructor(a,b={},d){super(d);let {target:l=null,rel:h=null,title:e=null}=b;this.__url=a;this.__target=l;this.__rel=h;this.__title=e}createDOM(a){let b=document.createElement("a");b.href=this.sanitizeUrl(this.__url);null!==this.__target&&(b.target=this.__target);null!==this.__rel&&(b.rel=this.__rel);null!==this.__title&&(b.title=this.__title);k.addClassNamesToElement(b,
a.theme.link);return b}updateDOM(a,b){let d=this.__url,l=this.__target,h=this.__rel,e=this.__title;d!==a.__url&&(b.href=d);l!==a.__target&&(l?b.target=l:b.removeAttribute("target"));h!==a.__rel&&(h?b.rel=h:b.removeAttribute("rel"));e!==a.__title&&(e?b.title=e:b.removeAttribute("title"));return!1}static importDOM(){return{a:()=>({conversion:r,priority:1})}}static importJSON(a){let b=t(a.url,{rel:a.rel,target:a.target,title:a.title});b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);
return b}sanitizeUrl(a){try{let b=new URL(a);if(!p.has(b.protocol))return"about:blank"}catch{}return a}exportJSON(){return{...super.exportJSON(),rel:this.getRel(),target:this.getTarget(),title:this.getTitle(),type:"link",url:this.getURL(),version:1}}getURL(){return this.getLatest().__url}setURL(a){this.getWritable().__url=a}getTarget(){return this.getLatest().__target}setTarget(a){this.getWritable().__target=a}getRel(){return this.getLatest().__rel}setRel(a){this.getWritable().__rel=a}getTitle(){return this.getLatest().__title}setTitle(a){this.getWritable().__title=
a}insertNewAfter(a,b=!0){a=this.getParentOrThrow().insertNewAfter(a,b);return n.$isElementNode(a)?(b=t(this.__url,{rel:this.__rel,target:this.__target,title:this.__title}),a.append(b),b):null}canInsertTextBefore(){return!1}canInsertTextAfter(){return!1}canBeEmpty(){return!1}isInline(){return!0}extractWithChild(a,b){if(!n.$isRangeSelection(b))return!1;a=b.anchor.getNode();let d=b.focus.getNode();return this.isParentOf(a)&&this.isParentOf(d)&&0<b.getTextContent().length}}
function r(a){let b=null;if(k.isHTMLAnchorElement(a)){let d=a.textContent;null!==d&&""!==d&&(b=t(a.getAttribute("href")||"",{rel:a.getAttribute("rel"),target:a.getAttribute("target"),title:a.getAttribute("title")}))}return{node:b}}function t(a,b){return n.$applyNodeReplacement(new q(a,b))}function v(a){return a instanceof q}
class w extends q{static getType(){return"autolink"}static clone(a){return new w(a.__url,{rel:a.__rel,target:a.__target,title:a.__title},a.__key)}static importJSON(a){let b=x(a.url,{rel:a.rel,target:a.target,title:a.title});b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}static importDOM(){return null}exportJSON(){return{...super.exportJSON(),type:"autolink",version:1}}insertNewAfter(a,b=!0){a=this.getParentOrThrow().insertNewAfter(a,b);return n.$isElementNode(a)?
(b=x(this.__url,{rel:this._rel,target:this.__target,title:this.__title}),a.append(b),b):null}}function x(a,b){return n.$applyNodeReplacement(new w(a,b))}let y=n.createCommand("TOGGLE_LINK_COMMAND");function z(a,b){for(;null!==a&&null!==(a=a.getParent())&&!b(a););return a}exports.$createAutoLinkNode=x;exports.$createLinkNode=t;exports.$isAutoLinkNode=function(a){return a instanceof w};exports.$isLinkNode=v;exports.AutoLinkNode=w;exports.LinkNode=q;exports.TOGGLE_LINK_COMMAND=y;
exports.toggleLink=function(a,b={}){let {target:d,title:l}=b,h=void 0===b.rel?"noopener":b.rel;b=n.$getSelection();if(n.$isRangeSelection(b))if(b=b.extract(),null===a)b.forEach(m=>{m=m.getParent();if(v(m)){let c=m.getChildren();for(let f=0;f<c.length;f++)m.insertBefore(c[f]);m.remove()}});else{if(1===b.length){var e=b[0];e=v(e)?e:z(e,v);if(null!==e){e.setURL(a);void 0!==d&&e.setTarget(d);null!==h&&e.setRel(h);void 0!==l&&e.setTitle(l);return}}let m=null,c=null;b.forEach(f=>{var g=f.getParent();if(g!==
c&&null!==g&&(!n.$isElementNode(f)||f.isInline()))if(v(g))c=g,g.setURL(a),void 0!==d&&g.setTarget(d),null!==h&&c.setRel(h),void 0!==l&&c.setTitle(l);else if(g.is(m)||(m=g,c=t(a,{rel:h,target:d}),v(g)?null===f.getPreviousSibling()?g.insertBefore(c):g.insertAfter(c):f.insertBefore(c)),v(f)){if(!f.is(c)){if(null!==c){g=f.getChildren();for(let u=0;u<g.length;u++)c.append(g[u])}f.remove()}}else null!==c&&c.append(f)})}}


/***/ }),

/***/ 44783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalList =  false ? 0 : __webpack_require__(19206)
module.exports = LexicalList;

/***/ }),

/***/ 19206:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(32998),k=__webpack_require__(76969);function m(a){throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?code=${a} for the full message or `+"use the non-minified dev environment for full errors and additional helpful warnings.");}function n(a){let b=1;for(a=a.getParent();null!=a;){if(p(a)){a=a.getParent();if(q(a)){b++;a=a.getParent();continue}m(40)}break}return b}
function r(a){a=a.getParent();q(a)||m(40);let b=a;for(;null!==b;)b=b.getParent(),q(b)&&(a=b);return a}function t(a){let b=[];a=a.getChildren().filter(p);for(let c=0;c<a.length;c++){let d=a[c],e=d.getFirstChild();q(e)?b=b.concat(t(e)):b.push(d)}return b}function u(a){return p(a)&&q(a.getFirstChild())}function v(a){for(;null==a.getNextSibling()&&null==a.getPreviousSibling();){let b=a.getParent();if(null==b||!p(a)&&!q(a))break;a=b}a.remove()}function w(a){return y().append(a)}
function z(a,b){return p(a)&&(0===b.length||1===b.length&&a.is(b[0])&&0===a.getChildrenSize())}function B(a,b){a.splice(a.getChildrenSize(),0,b)}
function C(a,b){if(q(a))return a;let c=a.getPreviousSibling(),d=a.getNextSibling(),e=y();e.setFormat(a.getFormatType());e.setIndent(a.getIndent());B(e,a.getChildren());if(q(c)&&b===c.getListType())return c.append(e),a.remove(),q(d)&&b===d.getListType()&&(B(c,d.getChildren()),d.remove()),c;if(q(d)&&b===d.getListType())return d.getFirstChildOrThrow().insertBefore(e),a.remove(),d;b=D(b);b.append(e);a.replace(b);E(b);return b}
function F(a,b){var c=a.getLastChild();let d=b.getFirstChild();c&&d&&u(c)&&u(d)&&(F(c.getFirstChild(),d.getFirstChild()),d.remove());c=b.getChildren();0<c.length&&(a.append(...c),E(a));b.remove()}function E(a,b){a=b||a.getChildren();if(void 0!==a)for(b=0;b<a.length;b++){let f=a[b];if(p(f)){let g=f.getValue();var c=f,d=c.getParent(),e=1;null!=d&&(q(d)?e=d.getStart():m(44));c=c.getPreviousSiblings();for(d=0;d<c.length;d++){let l=c[d];p(l)&&!q(l.getFirstChild())&&e++}g!==e&&f.setValue(e)}}}
function G(a){if(!u(a)){var b=a.getParent(),c=b?b.getParent():void 0,d=c?c.getParent():void 0;if(q(d)&&p(c)&&q(b)){var e=b?b.getFirstChild():void 0,f=b?b.getLastChild():void 0;if(a.is(e))c.insertBefore(a),b.isEmpty()&&c.remove();else if(a.is(f))c.insertAfter(a),b.isEmpty()&&c.remove();else{var g=b.getListType();e=y();let l=D(g);e.append(l);a.getPreviousSiblings().forEach(x=>l.append(x));f=y();g=D(g);f.append(g);B(g,a.getNextSiblings());c.insertBefore(e);c.insertAfter(f);c.replace(a)}E(b);E(d)}}}
class H extends h.ElementNode{static getType(){return"listitem"}static clone(a){return new H(a.__value,a.__checked,a.__key)}constructor(a,b,c){super(c);this.__value=void 0===a?1:a;this.__checked=b}createDOM(a){let b=document.createElement("li"),c=this.getParent();q(c)&&"check"===c.getListType()&&I(b,this,null);b.value=this.__value;J(b,a.theme,this);return b}updateDOM(a,b,c){let d=this.getParent();q(d)&&"check"===d.getListType()&&I(b,this,a);b.value=this.__value;J(b,c.theme,this);return!1}static transform(){return a=>
{let b=a.getParent();q(b)&&(E(b),"check"!==b.getListType()&&null!=a.getChecked()&&a.setChecked(void 0))}}static importDOM(){return{li:()=>({conversion:K,priority:0})}}static importJSON(a){let b=new H(a.value,a.checked);b.setFormat(a.format);b.setDirection(a.direction);return b}exportJSON(){return{...super.exportJSON(),checked:this.getChecked(),type:"listitem",value:this.getValue(),version:1}}append(...a){for(let b=0;b<a.length;b++){let c=a[b];if(h.$isElementNode(c)&&this.canMergeWith(c)){let d=c.getChildren();
this.append(...d);c.remove()}else super.append(c)}return this}replace(a,b){if(p(a))return super.replace(a);this.setIndent(0);let c=this.getParentOrThrow();if(!q(c))return a;if(c.__first===this.getKey())c.insertBefore(a);else if(c.__last===this.getKey())c.insertAfter(a);else{let d=D(c.getListType()),e=this.getNextSibling();for(;e;){let f=e;e=e.getNextSibling();d.append(f)}c.insertAfter(a);a.insertAfter(d)}b&&this.getChildren().forEach(d=>{a.append(d)});this.remove();0===c.getChildrenSize()&&c.remove();
return a}insertAfter(a,b=!0){var c=this.getParentOrThrow();q(c)||m(39);var d=this.getNextSiblings();if(p(a))return b=super.insertAfter(a,b),a=a.getParentOrThrow(),q(a)&&E(a),b;if(q(a)){c=a;a=a.getChildren();for(d=a.length-1;0<=d;d--)c=a[d],this.insertAfter(c,b);return c}c.insertAfter(a,b);if(0!==d.length){let e=D(c.getListType());d.forEach(f=>e.append(f));a.insertAfter(e,b)}return a}remove(a){let b=this.getPreviousSibling(),c=this.getNextSibling();super.remove(a);b&&c&&u(b)&&u(c)?(F(b.getFirstChild(),
c.getFirstChild()),c.remove()):c&&(a=c.getParent(),q(a)&&E(a))}insertNewAfter(a,b=!0){a=y(null==this.__checked?void 0:!1);this.insertAfter(a,b);return a}collapseAtStart(a){let b=h.$createParagraphNode();this.getChildren().forEach(f=>b.append(f));var c=this.getParentOrThrow(),d=c.getParentOrThrow();let e=p(d);1===c.getChildrenSize()?e?(c.remove(),d.select()):(c.insertBefore(b),c.remove(),c=a.anchor,a=a.focus,d=b.getKey(),"element"===c.type&&c.getNode().is(this)&&c.set(d,c.offset,"element"),"element"===
a.type&&a.getNode().is(this)&&a.set(d,a.offset,"element")):(c.insertBefore(b),this.remove());return!0}getValue(){return this.getLatest().__value}setValue(a){this.getWritable().__value=a}getChecked(){return this.getLatest().__checked}setChecked(a){this.getWritable().__checked=a}toggleChecked(){this.setChecked(!this.__checked)}getIndent(){var a=this.getParent();if(null===a)return this.getLatest().__indent;a=a.getParentOrThrow();let b=0;for(;p(a);)a=a.getParentOrThrow().getParentOrThrow(),b++;return b}setIndent(a){"number"===
typeof a&&-1<a||m(117);let b=this.getIndent();for(;b!==a;)if(b<a){a:{var c=new Set;if(u(this)||c.has(this.getKey()))break a;let g=this.getParent();var d=this.getNextSibling(),e=this.getPreviousSibling();if(u(d)&&u(e)){if(e=e.getFirstChild(),q(e)){e.append(this);var f=d.getFirstChild();q(f)&&(f=f.getChildren(),B(e,f),d.remove(),c.add(d.getKey()));E(e)}}else u(d)?(d=d.getFirstChild(),q(d)&&(c=d.getFirstChild(),null!==c&&c.insertBefore(this),E(d))):u(e)?(d=e.getFirstChild(),q(d)&&(d.append(this),E(d))):
q(g)&&(c=y(),f=D(g.getListType()),c.append(f),f.append(this),e?e.insertAfter(c):d?d.insertBefore(c):g.append(c),E(f));q(g)&&E(g)}b++}else G(this),b--;return this}insertBefore(a){if(p(a)){let b=this.getParentOrThrow();if(q(b)){let c=this.getNextSiblings();E(b,c)}}return super.insertBefore(a)}canInsertAfter(a){return p(a)}canReplaceWith(a){return p(a)}canMergeWith(a){return h.$isParagraphNode(a)||p(a)}extractWithChild(a,b){if(!h.$isRangeSelection(b))return!1;a=b.anchor.getNode();let c=b.focus.getNode();
return this.isParentOf(a)&&this.isParentOf(c)&&this.getTextContent().length===b.getTextContent().length}isParentRequired(){return!0}createParentElementNode(){return D("bullet")}}
function J(a,b,c){let d=[],e=[];var f=(b=b.list)?b.listitem:void 0;if(b&&b.nested)var g=b.nested.listitem;void 0!==f&&(f=f.split(" "),d.push(...f));if(b){f=c.getParent();f=q(f)&&"check"===f.getListType();let l=c.getChecked();f&&!l||e.push(b.listitemUnchecked);f&&l||e.push(b.listitemChecked);f&&d.push(l?b.listitemChecked:b.listitemUnchecked)}void 0!==g&&(g=g.split(" "),c.getChildren().some(l=>q(l))?d.push(...g):e.push(...g));0<e.length&&k.removeClassNamesFromElement(a,...e);0<d.length&&k.addClassNamesToElement(a,
...d)}function I(a,b,c){q(b.getFirstChild())?(a.removeAttribute("role"),a.removeAttribute("tabIndex"),a.removeAttribute("aria-checked")):(a.setAttribute("role","checkbox"),a.setAttribute("tabIndex","-1"),c&&b.__checked===c.__checked||a.setAttribute("aria-checked",b.getChecked()?"true":"false"))}function K(a){a=k.isHTMLElement(a)&&"true"===a.getAttribute("aria-checked");return{node:y(a)}}function y(a){return h.$applyNodeReplacement(new H(void 0,a))}function p(a){return a instanceof H}
class L extends h.ElementNode{static getType(){return"list"}static clone(a){return new L(a.__listType||N[a.__tag],a.__start,a.__key)}constructor(a,b,c){super(c);this.__listType=a=N[a]||a;this.__tag="number"===a?"ol":"ul";this.__start=b}getTag(){return this.__tag}setListType(a){let b=this.getWritable();b.__listType=a;b.__tag="number"===a?"ol":"ul"}getListType(){return this.__listType}getStart(){return this.__start}createDOM(a){let b=document.createElement(this.__tag);1!==this.__start&&b.setAttribute("start",
String(this.__start));b.__lexicalListType=this.__listType;O(b,a.theme,this);return b}updateDOM(a,b,c){if(a.__tag!==this.__tag)return!0;O(b,c.theme,this);return!1}static importDOM(){return{ol:()=>({conversion:P,priority:0}),ul:()=>({conversion:P,priority:0})}}static importJSON(a){let b=D(a.listType,a.start);b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportDOM(a){({element:a}=super.exportDOM(a));a&&(1!==this.__start&&a.setAttribute("start",String(this.__start)),
"check"===this.__listType&&a.setAttribute("__lexicalListType","check"));return{element:a}}exportJSON(){return{...super.exportJSON(),listType:this.getListType(),start:this.getStart(),tag:this.getTag(),type:"list",version:1}}canBeEmpty(){return!1}canIndent(){return!1}append(...a){for(let c=0;c<a.length;c++){var b=a[c];if(p(b))super.append(b);else{let d=y();q(b)?d.append(b):h.$isElementNode(b)?(b=h.$createTextNode(b.getTextContent()),d.append(b)):d.append(b);super.append(d)}}E(this);return this}extractWithChild(a){return p(a)}}
function O(a,b,c){let d=[],e=[];var f=b.list;if(void 0!==f){let l=f[`${c.__tag}Depth`]||[];b=n(c)-1;let x=b%l.length;var g=l[x];let M=f[c.__tag],A;f=f.nested;void 0!==f&&f.list&&(A=f.list);void 0!==M&&d.push(M);if(void 0!==g)for(g=g.split(" "),d.push(...g),g=0;g<l.length;g++)g!==x&&e.push(c.__tag+g);void 0!==A&&(c=A.split(" "),1<b?d.push(...c):e.push(...c))}0<e.length&&k.removeClassNamesFromElement(a,...e);0<d.length&&k.addClassNamesToElement(a,...d)}
function Q(a){let b=[];for(let d=0;d<a.length;d++){var c=a[d];p(c)?(b.push(c),c=c.getChildren(),1<c.length&&c.forEach(e=>{q(e)&&b.push(w(e))})):b.push(w(c))}return b}function P(a){let b=a.nodeName.toLowerCase(),c=null;"ol"===b?c=D("number",a.start):"ul"===b&&(c=k.isHTMLElement(a)&&"check"===a.getAttribute("__lexicallisttype")?D("check"):D("bullet"));return{after:Q,node:c}}let N={ol:"number",ul:"bullet"};function D(a,b=1){return h.$applyNodeReplacement(new L(a,b))}
function q(a){return a instanceof L}let R=h.createCommand("INSERT_UNORDERED_LIST_COMMAND"),S=h.createCommand("INSERT_ORDERED_LIST_COMMAND"),T=h.createCommand("INSERT_CHECK_LIST_COMMAND"),U=h.createCommand("REMOVE_LIST_COMMAND");exports.$createListItemNode=y;exports.$createListNode=D;exports.$getListDepth=n;
exports.$handleListInsertParagraph=function(){var a=h.$getSelection();if(!h.$isRangeSelection(a)||!a.isCollapsed())return!1;a=a.anchor.getNode();if(!p(a)||""!==a.getTextContent())return!1;var b=r(a),c=a.getParent();q(c)||m(40);let d=c.getParent(),e;if(h.$isRootOrShadowRoot(d))e=h.$createParagraphNode(),b.insertAfter(e);else if(p(d))e=y(),d.insertAfter(e);else return!1;e.select();b=a.getNextSiblings();if(0<b.length){let f=D(c.getListType());h.$isParagraphNode(e)?e.insertAfter(f):(c=y(),c.append(f),
e.insertAfter(c));b.forEach(g=>{g.remove();f.append(g)})}v(a);return!0};exports.$isListItemNode=p;exports.$isListNode=q;exports.INSERT_CHECK_LIST_COMMAND=T;exports.INSERT_ORDERED_LIST_COMMAND=S;exports.INSERT_UNORDERED_LIST_COMMAND=R;exports.ListItemNode=H;exports.ListNode=L;exports.REMOVE_LIST_COMMAND=U;
exports.insertList=function(a,b){a.update(()=>{var c=h.$getSelection();if(h.$isRangeSelection(c)||h.DEPRECATED_$isGridSelection(c)){var d=c.getNodes();c=c.anchor.getNode();var e=c.getParent();if(z(c,d))d=D(b),h.$isRootOrShadowRoot(e)?(c.replace(d),e=y(),h.$isElementNode(c)&&(e.setFormat(c.getFormatType()),e.setIndent(c.getIndent())),d.append(e)):p(c)&&(c=c.getParentOrThrow(),B(d,c.getChildren()),c.replace(d));else for(c=new Set,e=0;e<d.length;e++){var f=d[e];if(h.$isElementNode(f)&&f.isEmpty()&&!c.has(f.getKey()))C(f,
b);else if(h.$isLeafNode(f))for(f=f.getParent();null!=f;){let l=f.getKey();if(q(f)){if(!c.has(l)){var g=D(b);B(g,f.getChildren());f.replace(g);E(g);c.add(l)}break}else{g=f.getParent();if(h.$isRootOrShadowRoot(g)&&!c.has(l)){c.add(l);C(f,b);break}f=g}}}}})};
exports.removeList=function(a){a.update(()=>{let b=h.$getSelection();if(h.$isRangeSelection(b)){var c=new Set,d=b.getNodes(),e=b.anchor.getNode();if(z(e,d))c.add(r(e));else for(e=0;e<d.length;e++){var f=d[e];h.$isLeafNode(f)&&(f=k.$getNearestNodeOfType(f,H),null!=f&&c.add(r(f)))}for(let g of c){c=g;d=t(g);for(let l of d)d=h.$createParagraphNode(),B(d,l.getChildren()),c.insertAfter(d),c=d,l.__key===b.anchor.key&&b.anchor.set(d.getKey(),0,"element"),l.__key===b.focus.key&&b.focus.set(d.getKey(),0,"element"),
l.remove();g.remove()}}})}


/***/ }),

/***/ 32358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalAutoLinkPlugin =  false ? 0 : __webpack_require__(24990)
module.exports = LexicalAutoLinkPlugin;

/***/ }),

/***/ 24990:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(73435),n=__webpack_require__(84260),p=__webpack_require__(76969),u=__webpack_require__(32998),w=__webpack_require__(67294);function A(a,b){for(let c=0;c<b.length;c++){let d=b[c](a);if(d)return d}return null}let B=/[.,;\s]/;function C(a){a=a.getPreviousSibling();u.$isElementNode(a)&&(a=a.getLastDescendant());var b;!(b=null===a||u.$isLineBreakNode(a))&&(b=u.$isTextNode(a))&&(a=a.getTextContent(),b=B.test(a[a.length-1]));return b}
function E(a){a=a.getNextSibling();u.$isElementNode(a)&&(a=a.getFirstDescendant());return null===a||u.$isLineBreakNode(a)||u.$isTextNode(a)&&B.test(a.getTextContent()[0])}
function F(a,b,c){var d=a.getChildren();let e=d.length;for(let f=0;f<e;f++){let l=d[f];if(!u.$isTextNode(l)||!l.isSimpleText()){G(a);c(null,a.getURL());return}}d=a.getTextContent();b=A(d,b);null===b||b.text!==d?(G(a),c(null,a.getURL())):C(a)&&E(a)?(d=a.getURL(),d!==b.url&&(a.setURL(b.url),c(b.url,d)),b.attributes&&(d=a.getRel(),d!==b.attributes.rel&&(a.setRel(b.attributes.rel||null),c(b.attributes.rel||null,d)),d=a.getTarget(),d!==b.attributes.target&&(a.setTarget(b.attributes.target||null),c(b.attributes.target||
null,d)))):(G(a),c(null,a.getURL()))}function G(a){let b=a.getChildren();var c=b.length;for(--c;0<=c;c--)a.insertAfter(b[c]);a.remove();return b.map(d=>d.getLatest())}
function H(a,b,c){w.useEffect(()=>{if(!a.hasNodes([h.AutoLinkNode]))throw Error("Minified Lexical error #77; visit https://lexical.dev/docs/error?code=77 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");let d=(e,f)=>{c&&c(e,f)};return p.mergeRegister(a.registerNodeTransform(u.TextNode,e=>{var f=e.getParentOrThrow(),l=e.getPreviousSibling();if(h.$isAutoLinkNode(f))F(f,b,d);else if(!h.$isLinkNode(f)){if(e.isSimpleText()&&(B.test(e.getTextContent()[0])||
!h.$isAutoLinkNode(l))){l=f=e.getTextContent();let m=0,v=e;for(var g;(g=A(l,b))&&null!==g;){let r=g.index,x=g.length,y=r+x;var t=m+r,q=m+y,z=f,D=e;if((0<t?B.test(z[t-1]):C(D))&&(q<z.length?B.test(z[q]):E(D))){var k=void 0;0===m+r?[k,v]=v.splitText(m+x):[,k,v]=v.splitText(m+r,m+r+x);t=h.$createAutoLinkNode(g.url,g.attributes);q=u.$createTextNode(g.text);q.setFormat(k.getFormat());q.setDetail(k.getDetail());t.append(q);k.replace(t);c&&c(g.url,null);m=0}else m+=y;l=l.substring(y)}}f=e.getPreviousSibling();
g=e.getNextSibling();k=e.getTextContent();h.$isAutoLinkNode(f)&&!B.test(k[0])&&(f.append(e),F(f,b,d),e=f.getURL(),c&&c(null,e));h.$isAutoLinkNode(g)&&!B.test(k[k.length-1])&&(G(g),F(g,b,d),e=g.getURL(),c&&c(null,e))}}))},[a,b,c])}exports.AutoLinkPlugin=function({matchers:a,onChange:b}){let [c]=n.useLexicalComposerContext();H(c,a,b);return null};exports.createLinkMatcherWithRegExp=function(a,b=c=>c){return c=>{let d=a.exec(c);return null===d?null:{index:d.index,length:d[0].length,text:d[0],url:b(c)}}}


/***/ }),

/***/ 22292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalComposer =  false ? 0 : __webpack_require__(44149)
module.exports = LexicalComposer;

/***/ }),

/***/ 44149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(84260),f=__webpack_require__(32998),g=__webpack_require__(67294);let m="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement;var n=m?g.useLayoutEffect:g.useEffect;let p={tag:"history-merge"};
function q(a,c){if(null!==c)if(void 0===c)a.update(()=>{var b=f.$getRoot();if(b.isEmpty()){let d=f.$createParagraphNode();b.append(d);b=m?document.activeElement:null;(null!==f.$getSelection()||null!==b&&b===a.getRootElement())&&d.select()}},p);else if(null!==c)switch(typeof c){case "string":let b=a.parseEditorState(c);a.setEditorState(b,p);break;case "object":a.setEditorState(c,p);break;case "function":a.update(()=>{f.$getRoot().isEmpty()&&c(a)},p)}}
exports.LexicalComposer=function({initialConfig:a,children:c}){let b=g.useMemo(()=>{const {theme:d,namespace:h,editor__DEPRECATED:r,nodes:t,onError:u,editorState:v}=a,w=e.createLexicalComposerContext(null,d);let k=r||null;if(null===k){const l=f.createEditor({editable:a.editable,namespace:h,nodes:t,onError:x=>u(x,l),theme:d});q(l,v);k=l}return[k,w]},[]);n(()=>{let d=a.editable,[h]=b;h.setEditable(void 0!==d?d:!0)},[]);return g.createElement(e.LexicalComposerContext.Provider,{value:b},c)}


/***/ }),

/***/ 84260:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalComposerContext =  false ? 0 : __webpack_require__(33489)
module.exports = LexicalComposerContext;

/***/ }),

/***/ 33489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c=__webpack_require__(67294);let d=c.createContext(null);exports.LexicalComposerContext=d;exports.createLexicalComposerContext=function(a,e){let b=null;null!=a&&(b=a[1]);return{getTheme:function(){return null!=e?e:null!=b?b.getTheme():null}}};
exports.useLexicalComposerContext=function(){let a=c.useContext(d);if(null==a)throw Error("Minified Lexical error #8; visit https://lexical.dev/docs/error?code=8 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");return a}


/***/ }),

/***/ 6898:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalContentEditable =  false ? 0 : __webpack_require__(15781)
module.exports = LexicalContentEditable;

/***/ }),

/***/ 15781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c=__webpack_require__(84260),h=__webpack_require__(67294);function n(){n=Object.assign?Object.assign.bind():function(g){for(var d=1;d<arguments.length;d++){var e=arguments[d],b;for(b in e)Object.prototype.hasOwnProperty.call(e,b)&&(g[b]=e[b])}return g};return n.apply(this,arguments)}var p="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement?h.useLayoutEffect:h.useEffect;
exports.ContentEditable=function({ariaActiveDescendant:g,ariaAutoComplete:d,ariaControls:e,ariaDescribedBy:b,ariaExpanded:q,ariaLabel:r,ariaLabelledBy:t,ariaMultiline:u,ariaOwns:v,ariaRequired:w,autoCapitalize:x,className:y,id:z,role:l="textbox",spellCheck:A=!0,style:B,tabIndex:C,"data-testid":D,...E}){let [f]=c.useLexicalComposerContext(),[a,m]=h.useState(!1),F=h.useCallback(k=>{f.setRootElement(k)},[f]);p(()=>{m(f.isEditable());return f.registerEditableListener(k=>{m(k)})},[f]);return h.createElement("div",
n({},E,{"aria-activedescendant":a?g:void 0,"aria-autocomplete":a?d:"none","aria-controls":a?e:void 0,"aria-describedby":b,"aria-expanded":a?"combobox"===l?!!q:void 0:void 0,"aria-label":r,"aria-labelledby":t,"aria-multiline":u,"aria-owns":a?v:void 0,"aria-required":w,autoCapitalize:x,className:y,contentEditable:a,"data-testid":D,id:z,ref:F,role:a?l:void 0,spellCheck:A,style:B,tabIndex:C}))}


/***/ }),

/***/ 77943:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalErrorBoundary =  false ? 0 : __webpack_require__(79848)
module.exports = LexicalErrorBoundary;

/***/ }),

/***/ 79848:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(67294);function m(b,c){m=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(g,a){g.__proto__=a;return g};return m(b,c)}function n(b,c){b.prototype=Object.create(c.prototype);b.prototype.constructor=b;m(b,c)}function r(b,c){void 0===b&&(b=[]);void 0===c&&(c=[]);return b.length!==c.length||b.some(function(g,a){return!Object.is(g,c[a])})}
var t={error:null},u=function(b){function c(){for(var a,d=arguments.length,f=Array(d),e=0;e<d;e++)f[e]=arguments[e];a=b.call.apply(b,[this].concat(f))||this;a.state=t;a.resetErrorBoundary=function(){for(var k,p=arguments.length,q=Array(p),l=0;l<p;l++)q[l]=arguments[l];null==a.props.onReset?void 0:(k=a.props).onReset.apply(k,q);a.reset()};return a}n(c,b);c.getDerivedStateFromError=function(a){return{error:a}};var g=c.prototype;g.reset=function(){this.setState(t)};g.componentDidCatch=function(a,d){var f,
e;null==(f=(e=this.props).onError)?void 0:f.call(e,a,d)};g.componentDidUpdate=function(a,d){var f=this.props.resetKeys;if(null!==this.state.error&&null!==d.error&&r(a.resetKeys,f)){var e,k;null==(e=(k=this.props).onResetKeysChange)?void 0:e.call(k,a.resetKeys,f);this.reset()}};g.render=function(){var a=this.state.error,d=this.props,f=d.fallbackRender,e=d.FallbackComponent;d=d.fallback;if(null!==a){a={error:a,resetErrorBoundary:this.resetErrorBoundary};if(h.isValidElement(d))return d;if("function"===
typeof f)return f(a);if(e)return h.createElement(e,a);throw Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");}return this.props.children};return c}(h.Component);module.exports=function({children:b,onError:c}){return h.createElement(u,{fallback:h.createElement("div",{style:{border:"1px solid #f00",color:"#f00",padding:"8px"}},"An error was thrown."),onError:c},b)}


/***/ }),

/***/ 4506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalHistoryPlugin =  false ? 0 : __webpack_require__(548)
module.exports = LexicalHistoryPlugin;

/***/ }),

/***/ 548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c=__webpack_require__(84260),history=__webpack_require__(48854),f=__webpack_require__(67294);function g(a,b,d=1E3){let e=f.useMemo(()=>b||history.createEmptyHistoryState(),[b]);f.useEffect(()=>history.registerHistory(a,e,d),[d,a,e])}exports.createEmptyHistoryState=history.createEmptyHistoryState;exports.HistoryPlugin=function({externalHistoryState:a}){let [b]=c.useLexicalComposerContext();g(b,a);return null}


/***/ }),

/***/ 41589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalHorizontalRuleNode =  false ? 0 : __webpack_require__(47618)
module.exports = LexicalHorizontalRuleNode;

/***/ }),

/***/ 47618:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a=__webpack_require__(84260),f=__webpack_require__(25567),h=__webpack_require__(76969),l=__webpack_require__(32998),n=__webpack_require__(67294);let p=l.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
function q({nodeKey:b}){let [d]=a.useLexicalComposerContext(),[e,g,m]=f.useLexicalNodeSelection(b),k=n.useCallback(c=>{e&&l.$isNodeSelection(l.$getSelection())&&(c.preventDefault(),c=l.$getNodeByKey(b),r(c)&&c.remove(),g(!1));return!1},[e,b,g]);n.useEffect(()=>h.mergeRegister(d.registerCommand(l.CLICK_COMMAND,c=>{let v=d.getElementByKey(b);return c.target===v?(c.shiftKey||m(),g(!e),!0):!1},l.COMMAND_PRIORITY_LOW),d.registerCommand(l.KEY_DELETE_COMMAND,k,l.COMMAND_PRIORITY_LOW),d.registerCommand(l.KEY_BACKSPACE_COMMAND,
k,l.COMMAND_PRIORITY_LOW)),[m,d,e,b,k,g]);n.useEffect(()=>{let c=d.getElementByKey(b);null!==c&&(c.className=e?"selected":"")},[d,e,b]);return null}
class t extends l.DecoratorNode{static getType(){return"horizontalrule"}static clone(b){return new t(b.__key)}static importJSON(){return u()}static importDOM(){return{hr:()=>({conversion:w,priority:0})}}exportJSON(){return{type:"horizontalrule",version:1}}exportDOM(){return{element:document.createElement("hr")}}createDOM(){return document.createElement("hr")}getTextContent(){return"\n"}isInline(){return!1}updateDOM(){return!1}decorate(){return n.createElement(q,{nodeKey:this.__key})}}
function w(){return{node:u()}}function u(){return l.$applyNodeReplacement(new t)}function r(b){return b instanceof t}exports.$createHorizontalRuleNode=u;exports.$isHorizontalRuleNode=r;exports.HorizontalRuleNode=t;exports.INSERT_HORIZONTAL_RULE_COMMAND=p


/***/ }),

/***/ 69421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalLinkPlugin =  false ? 0 : __webpack_require__(86458)
module.exports = LexicalLinkPlugin;

/***/ }),

/***/ 86458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=__webpack_require__(73435),c=__webpack_require__(84260),k=__webpack_require__(76969),l=__webpack_require__(32998),m=__webpack_require__(67294);
exports.LinkPlugin=function({validateUrl:d}){let [e]=c.useLexicalComposerContext();m.useEffect(()=>{if(!e.hasNodes([b.LinkNode]))throw Error("LinkPlugin: LinkNode not registered on editor");return k.mergeRegister(e.registerCommand(b.TOGGLE_LINK_COMMAND,a=>{if(null===a)return b.toggleLink(a),!0;if("string"===typeof a)return void 0===d||d(a)?(b.toggleLink(a),!0):!1;let {url:f,target:g,rel:h,title:n}=a;b.toggleLink(f,{rel:h,target:g,title:n});return!0},l.COMMAND_PRIORITY_LOW),void 0!==d?e.registerCommand(l.PASTE_COMMAND,
a=>{let f=l.$getSelection();if(!l.$isRangeSelection(f)||f.isCollapsed()||!(a instanceof ClipboardEvent)||null==a.clipboardData)return!1;let g=a.clipboardData.getData("text");return d(g)?f.getNodes().some(h=>l.$isElementNode(h))?!1:(e.dispatchCommand(b.TOGGLE_LINK_COMMAND,g),a.preventDefault(),!0):!1},l.COMMAND_PRIORITY_LOW):()=>{})},[e,d]);return null}


/***/ }),

/***/ 38957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalListPlugin =  false ? 0 : __webpack_require__(47336)
module.exports = LexicalListPlugin;

/***/ }),

/***/ 47336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=__webpack_require__(44783),c=__webpack_require__(84260),d=__webpack_require__(67294),e=__webpack_require__(76969),f=__webpack_require__(32998);
function g(a){d.useEffect(()=>e.mergeRegister(a.registerCommand(b.INSERT_ORDERED_LIST_COMMAND,()=>{b.insertList(a,"number");return!0},f.COMMAND_PRIORITY_LOW),a.registerCommand(b.INSERT_UNORDERED_LIST_COMMAND,()=>{b.insertList(a,"bullet");return!0},f.COMMAND_PRIORITY_LOW),a.registerCommand(b.REMOVE_LIST_COMMAND,()=>{b.removeList(a);return!0},f.COMMAND_PRIORITY_LOW),a.registerCommand(f.INSERT_PARAGRAPH_COMMAND,()=>b.$handleListInsertParagraph()?!0:!1,f.COMMAND_PRIORITY_LOW)),[a])}
exports.ListPlugin=function(){let [a]=c.useLexicalComposerContext();d.useEffect(()=>{if(!a.hasNodes([b.ListNode,b.ListItemNode]))throw Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");},[a]);g(a);return null}


/***/ }),

/***/ 86146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalRichTextPlugin =  false ? 0 : __webpack_require__(61827)
module.exports = LexicalRichTextPlugin;

/***/ }),

/***/ 61827:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=__webpack_require__(84260),h=__webpack_require__(9722),l=__webpack_require__(67294),m=__webpack_require__(2977),n=__webpack_require__(76969),p=__webpack_require__(73935),r=__webpack_require__(70573),t=__webpack_require__(2903),u="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement?l.useLayoutEffect:l.useEffect;
function v(a){return a.getEditorState().read(m.$canShowPlaceholderCurry(a.isComposing()))}function w(a){let [d,c]=l.useState(()=>v(a));u(()=>{function e(){let f=v(a);c(f)}e();return n.mergeRegister(a.registerUpdateListener(()=>{e()}),a.registerEditableListener(()=>{e()}))},[a]);return d}
function x(a,d){let [c,e]=l.useState(()=>a.getDecorators());u(()=>a.registerDecoratorListener(f=>{p.flushSync(()=>{e(f)})}),[a]);l.useEffect(()=>{e(a.getDecorators())},[a]);return l.useMemo(()=>{let f=[],q=Object.keys(c);for(let k=0;k<q.length;k++){var g=q[k];let z=l.createElement(d,{onError:y=>a._onError(y)},l.createElement(l.Suspense,{fallback:null},c[g]));g=a.getElementByKey(g);null!==g&&f.push(p.createPortal(z,g))}return f},[d,c,a])}
function A(a){u(()=>n.mergeRegister(t.registerRichText(a),r.registerDragonSupport(a)),[a])}function B({content:a}){var [d]=b.useLexicalComposerContext();d=w(d);let c=h();return d?"function"===typeof a?a(c):a:null}exports.RichTextPlugin=function({contentEditable:a,placeholder:d,ErrorBoundary:c}){let [e]=b.useLexicalComposerContext();c=x(e,c);A(e);return l.createElement(l.Fragment,null,a,l.createElement(B,{content:d}),c)}


/***/ }),

/***/ 13760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalTablePlugin =  false ? 0 : __webpack_require__(68002)
module.exports = LexicalTablePlugin;

/***/ }),

/***/ 68002:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c=__webpack_require__(84260),h=__webpack_require__(91058),n=__webpack_require__(76969),v=__webpack_require__(32998),w=__webpack_require__(67294);
exports.TablePlugin=function({hasCellMerge:q=!0,hasCellBackgroundColor:t=!0}){let [d]=c.useLexicalComposerContext();w.useEffect(()=>{if(!d.hasNodes([h.TableNode,h.TableCellNode,h.TableRowNode]))throw Error("Minified Lexical error #10; visit https://lexical.dev/docs/error?code=10 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");return d.registerCommand(h.INSERT_TABLE_COMMAND,({columns:a,rows:e,includeHeaders:g})=>{a=h.$createTableNodeWithDimensions(Number(e),
Number(a),g);n.$insertNodeToNearestRoot(a);a=a.getFirstDescendant();v.$isTextNode(a)&&a.select();return!0},v.COMMAND_PRIORITY_EDITOR)},[d]);w.useEffect(()=>{let a=new Map,e=b=>{const f=b.getKey(),l=d.getElementByKey(f);l&&!a.has(f)&&(b=h.applyTableHandlers(b,l,d),a.set(f,b))};d.getEditorState().read(()=>{let b=v.$nodesOfType(h.TableNode);for(let f of b)h.$isTableNode(f)&&e(f)});let g=d.registerMutationListener(h.TableNode,b=>{for(const [f,l]of b)"created"===l?d.getEditorState().read(()=>{const m=
v.$getNodeByKey(f);h.$isTableNode(m)&&e(m)}):"destroyed"===l&&(b=a.get(f),void 0!==b&&(b.removeListeners(),a.delete(f)))});return()=>{g();for(let [,b]of a)b.removeListeners()}},[d]);w.useEffect(()=>{if(!q)return d.registerNodeTransform(h.TableCellNode,a=>{if(1<a.getColSpan()||1<a.getRowSpan()){var [,,e]=v.DEPRECATED_$getNodeTriplet(a);[a]=v.DEPRECATED_$computeGridMap(e,a,a);let f=a.length,l=a[0].length;e=e.getFirstChild();if(!v.DEPRECATED_$isGridRowNode(e))throw Error("Expected TableNode first child to be a RowNode");
let m=[];for(let k=0;k<f;k++){if(0!==k&&(e=e.getNextSibling(),!v.DEPRECATED_$isGridRowNode(e)))throw Error("Expected TableNode first child to be a RowNode");let r=null;for(let p=0;p<l;p++){var g=a[k][p],b=g.cell;if(g.startRow===k&&g.startColumn===p)r=b,m.push(b);else if(1<b.getColSpan()||1<b.getRowSpan())if(b=h.$createTableCellNode(b.__headerState),null!==r)r.insertAfter(b);else{g=e;let u=g.getFirstChild();null!==u?u.insertBefore(b):g.append(b)}}}for(let k of m)k.setColSpan(1),k.setRowSpan(1)}})},
[d,q]);w.useEffect(()=>{if(!t)return d.registerNodeTransform(h.TableCellNode,a=>{null!==a.getBackgroundColor()&&a.setBackgroundColor(null)})},[d,t,q]);return null}


/***/ }),

/***/ 9722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const useLexicalEditable =  false ? 0 : __webpack_require__(65836)
module.exports = useLexicalEditable;

/***/ }),

/***/ 65836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=__webpack_require__(84260),k=__webpack_require__(67294),l="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement?k.useLayoutEffect:k.useEffect;
function m(a){let [c]=b.useLexicalComposerContext(),e=k.useMemo(()=>a(c),[c,a]),d=k.useRef(e.initialValueFn()),[n,g]=k.useState(d.current);l(()=>{let {initialValueFn:p,subscribe:q}=e,f=p();d.current!==f&&(d.current=f,g(f));return q(h=>{d.current=h;g(h)})},[e,a]);return n}function r(a){return{initialValueFn:()=>a.isEditable(),subscribe:c=>a.registerEditableListener(c)}}module.exports=function(){return m(r)}


/***/ }),

/***/ 25567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const useLexicalNodeSelection =  false ? 0 : __webpack_require__(99121)
module.exports = useLexicalNodeSelection;

/***/ }),

/***/ 99121:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c=__webpack_require__(84260),f=__webpack_require__(32998),h=__webpack_require__(67294);function k(b,a){return b.getEditorState().read(()=>{let g=f.$getNodeByKey(a);return null===g?!1:g.isSelected()})}
exports.useLexicalNodeSelection=function(b){let [a]=c.useLexicalComposerContext(),[g,l]=h.useState(()=>k(a,b));h.useEffect(()=>{let d=!0,e=a.registerUpdateListener(()=>{d&&l(k(a,b))});return()=>{d=!1;e()}},[a,b]);let m=h.useCallback(d=>{a.update(()=>{let e=f.$getSelection();f.$isNodeSelection(e)||(e=f.$createNodeSelection(),f.$setSelection(e));d?e.add(b):e.delete(b)})},[a,b]),n=h.useCallback(()=>{a.update(()=>{const d=f.$getSelection();f.$isNodeSelection(d)&&d.clear()})},[a]);return[g,m,n]}


/***/ }),

/***/ 2903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalRichText =  false ? 0 : __webpack_require__(40925)
module.exports = LexicalRichText;

/***/ }),

/***/ 40925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c=__webpack_require__(86907),g=__webpack_require__(89408),h=__webpack_require__(76969),k=__webpack_require__(32998);function l(a,b){return"undefined"!==typeof document.caretRangeFromPoint?(a=document.caretRangeFromPoint(a,b),null===a?null:{node:a.startContainer,offset:a.startOffset}):"undefined"!==document.caretPositionFromPoint?(a=document.caretPositionFromPoint(a,b),null===a?null:{node:a.offsetNode,offset:a.offset}):null}
let n="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement,p=n&&"documentMode"in document?document.documentMode:null;n&&/Mac|iPod|iPhone|iPad/.test(navigator.platform);n&&/^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
let q=n&&"InputEvent"in window&&!p?"getTargetRanges"in new window.InputEvent("input"):!1,r=n&&/Version\/[\d.]+.*Safari/.test(navigator.userAgent),t=n&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,u=n&&/^(?=.*Chrome).*/i.test(navigator.userAgent),v=n&&/AppleWebKit\/[\d.]+/.test(navigator.userAgent)&&!u,w=k.createCommand("DRAG_DROP_PASTE_FILE");
class x extends k.ElementNode{static getType(){return"quote"}static clone(a){return new x(a.__key)}constructor(a){super(a)}createDOM(a){let b=document.createElement("blockquote");h.addClassNamesToElement(b,a.theme.quote);return b}updateDOM(){return!1}static importDOM(){return{blockquote:()=>({conversion:y,priority:0})}}exportDOM(a){({element:a}=super.exportDOM(a));a&&this.isEmpty()&&a.append(document.createElement("br"));if(a){var b=this.getFormatType();a.style.textAlign=b;if(b=this.getDirection())a.dir=
b}return{element:a}}static importJSON(a){let b=z();b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return{...super.exportJSON(),type:"quote"}}insertNewAfter(a,b){a=k.$createParagraphNode();let d=this.getDirection();a.setDirection(d);this.insertAfter(a,b);return a}collapseAtStart(){let a=k.$createParagraphNode();this.getChildren().forEach(b=>a.append(b));this.replace(a);return!0}}function z(){return k.$applyNodeReplacement(new x)}
class B extends k.ElementNode{static getType(){return"heading"}static clone(a){return new B(a.__tag,a.__key)}constructor(a,b){super(b);this.__tag=a}getTag(){return this.__tag}createDOM(a){let b=this.__tag,d=document.createElement(b);a=a.theme.heading;void 0!==a&&h.addClassNamesToElement(d,a[b]);return d}updateDOM(){return!1}static importDOM(){return{h1:()=>({conversion:C,priority:0}),h2:()=>({conversion:C,priority:0}),h3:()=>({conversion:C,priority:0}),h4:()=>({conversion:C,priority:0}),h5:()=>({conversion:C,
priority:0}),h6:()=>({conversion:C,priority:0}),p:a=>{a=a.firstChild;return null!==a&&D(a)?{conversion:()=>({node:null}),priority:3}:null},span:a=>D(a)?{conversion:()=>({node:E("h1")}),priority:3}:null}}exportDOM(a){({element:a}=super.exportDOM(a));a&&this.isEmpty()&&a.append(document.createElement("br"));if(a){var b=this.getFormatType();a.style.textAlign=b;if(b=this.getDirection())a.dir=b}return{element:a}}static importJSON(a){let b=E(a.tag);b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);
return b}exportJSON(){return{...super.exportJSON(),tag:this.getTag(),type:"heading",version:1}}insertNewAfter(a,b=!0){a=a?a.anchor.offset:0;a=0<a&&a<this.getTextContentSize()?E(this.getTag()):k.$createParagraphNode();let d=this.getDirection();a.setDirection(d);this.insertAfter(a,b);return a}collapseAtStart(){let a=this.isEmpty()?k.$createParagraphNode():E(this.getTag());this.getChildren().forEach(b=>a.append(b));this.replace(a);return!0}extractWithChild(){return!0}}
function D(a){return"span"===a.nodeName.toLowerCase()?"26pt"===a.style.fontSize:!1}function C(a){a=a.nodeName.toLowerCase();let b=null;if("h1"===a||"h2"===a||"h3"===a||"h4"===a||"h5"===a||"h6"===a)b=E(a);return{node:b}}function y(){return{node:z()}}function E(a){return k.$applyNodeReplacement(new B(a))}
function F(a,b){a.preventDefault();b.update(()=>{let d=k.$getSelection(),e=a instanceof InputEvent||a instanceof KeyboardEvent?null:a.clipboardData;null!=e&&(k.$isRangeSelection(d)||k.DEPRECATED_$isGridSelection(d))&&c.$insertDataTransferForRichText(e,d,b)},{tag:"paste"})}async function G(a,b){await c.copyToClipboard(b,a instanceof ClipboardEvent?a:null);b.update(()=>{let d=k.$getSelection();k.$isRangeSelection(d)?d.removeText():k.$isNodeSelection(d)&&d.getNodes().forEach(e=>e.remove())})}
function H(a){let b=null;a instanceof DragEvent?b=a.dataTransfer:a instanceof ClipboardEvent&&(b=a.clipboardData);if(null===b)return[!1,[],!1];var d=b.types;a=d.includes("Files");d=d.includes("text/html")||d.includes("text/plain");return[a,Array.from(b.files),d]}
function I(a){var b=k.$getSelection();if(!k.$isRangeSelection(b))return!1;let d=new Set;b=b.getNodes();for(let m=0;m<b.length;m++){var e=b[m],f=e.getKey();d.has(f)||(e=h.$getNearestBlockElementAncestorOrThrow(e),f=e.getKey(),e.canIndent()&&!d.has(f)&&(d.add(f),a(e)))}return 0<d.size}function J(a){a=k.$getNearestNodeFromDOMNode(a);return k.$isDecoratorNode(a)}exports.$createHeadingNode=E;exports.$createQuoteNode=z;exports.$isHeadingNode=function(a){return a instanceof B};
exports.$isQuoteNode=function(a){return a instanceof x};exports.DRAG_DROP_PASTE=w;exports.HeadingNode=B;exports.QuoteNode=x;exports.eventFiles=H;
exports.registerRichText=function(a){return h.mergeRegister(a.registerCommand(k.CLICK_COMMAND,()=>{const b=k.$getSelection();return k.$isNodeSelection(b)?(b.clear(),!0):!1},0),a.registerCommand(k.DELETE_CHARACTER_COMMAND,b=>{const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;d.deleteCharacter(b);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.DELETE_WORD_COMMAND,b=>{const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;d.deleteWord(b);return!0},k.COMMAND_PRIORITY_EDITOR),
a.registerCommand(k.DELETE_LINE_COMMAND,b=>{const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;d.deleteLine(b);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.CONTROLLED_TEXT_INSERTION_COMMAND,b=>{const d=k.$getSelection();if("string"===typeof b)k.$isRangeSelection(d)?d.insertText(b):k.DEPRECATED_$isGridSelection(d);else{if(!k.$isRangeSelection(d)&&!k.DEPRECATED_$isGridSelection(d))return!1;const e=b.dataTransfer;null!=e?c.$insertDataTransferForRichText(e,d,a):k.$isRangeSelection(d)&&
(b=b.data)&&d.insertText(b)}return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.REMOVE_TEXT_COMMAND,()=>{const b=k.$getSelection();if(!k.$isRangeSelection(b))return!1;b.removeText();return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.FORMAT_TEXT_COMMAND,b=>{const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;d.formatText(b);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.FORMAT_ELEMENT_COMMAND,b=>{var d=k.$getSelection();if(!k.$isRangeSelection(d)&&!k.$isNodeSelection(d))return!1;
d=d.getNodes();for(const e of d)h.$getNearestBlockElementAncestorOrThrow(e).setFormat(b);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.INSERT_LINE_BREAK_COMMAND,b=>{const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;d.insertLineBreak(b);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.INSERT_PARAGRAPH_COMMAND,()=>{const b=k.$getSelection();if(!k.$isRangeSelection(b))return!1;b.insertParagraph();return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.INSERT_TAB_COMMAND,
()=>{k.$insertNodes([k.$createTabNode()]);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.INDENT_CONTENT_COMMAND,()=>I(b=>{const d=b.getIndent();b.setIndent(d+1)}),k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.OUTDENT_CONTENT_COMMAND,()=>I(b=>{const d=b.getIndent();0<d&&b.setIndent(d-1)}),k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_ARROW_UP_COMMAND,b=>{var d=k.$getSelection();if(k.$isNodeSelection(d)&&!J(b.target)){if(b=d.getNodes(),0<b.length)return b[0].selectPrevious(),!0}else if(k.$isRangeSelection(d)){d=
k.$getAdjacentNode(d.focus,!0);if(k.$isDecoratorNode(d)&&!d.isIsolated()&&!d.isInline())return d.selectPrevious(),b.preventDefault(),!0;if(k.$isElementNode(d)&&!d.isInline()&&!d.canBeEmpty())return d.select(),b.preventDefault(),!0}return!1},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_ARROW_DOWN_COMMAND,b=>{var d=k.$getSelection();if(k.$isNodeSelection(d)){if(b=d.getNodes(),0<b.length)return b[0].selectNext(0,0),!0}else if(k.$isRangeSelection(d)){let e=d.focus;if("root"===e.key&&e.offset===
k.$getRoot().getChildrenSize())return b.preventDefault(),!0;d=k.$getAdjacentNode(d.focus,!1);if(k.$isDecoratorNode(d)&&!d.isIsolated()&&!d.isInline())return d.selectNext(),b.preventDefault(),!0}return!1},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_ARROW_LEFT_COMMAND,b=>{const d=k.$getSelection();if(k.$isNodeSelection(d)){var e=d.getNodes();if(0<e.length)return b.preventDefault(),e[0].selectPrevious(),!0}return k.$isRangeSelection(d)?g.$shouldOverrideDefaultCharacterSelection(d,!0)?(e=b.shiftKey,
b.preventDefault(),g.$moveCharacter(d,e,!0),!0):!1:!1},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_ARROW_RIGHT_COMMAND,b=>{const d=k.$getSelection();if(k.$isNodeSelection(d)&&!J(b.target)){var e=d.getNodes();if(0<e.length)return b.preventDefault(),e[0].selectNext(0,0),!0}if(!k.$isRangeSelection(d))return!1;e=b.shiftKey;return g.$shouldOverrideDefaultCharacterSelection(d,!1)?(b.preventDefault(),g.$moveCharacter(d,e,!1),!0):!1},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_BACKSPACE_COMMAND,
b=>{if(J(b.target))return!1;const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;b.preventDefault();({anchor:b}=d);const e=b.getNode();return d.isCollapsed()&&0===b.offset&&!k.$isRootNode(e)&&0<h.$getNearestBlockElementAncestorOrThrow(e).getIndent()?a.dispatchCommand(k.OUTDENT_CONTENT_COMMAND,void 0):a.dispatchCommand(k.DELETE_CHARACTER_COMMAND,!0)},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_DELETE_COMMAND,b=>{if(J(b.target))return!1;const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;
b.preventDefault();return a.dispatchCommand(k.DELETE_CHARACTER_COMMAND,!1)},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_ENTER_COMMAND,b=>{const d=k.$getSelection();if(!k.$isRangeSelection(d))return!1;if(null!==b){if((t||r||v)&&q)return!1;b.preventDefault();if(b.shiftKey)return a.dispatchCommand(k.INSERT_LINE_BREAK_COMMAND,!1)}return a.dispatchCommand(k.INSERT_PARAGRAPH_COMMAND,void 0)},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.KEY_ESCAPE_COMMAND,()=>{const b=k.$getSelection();if(!k.$isRangeSelection(b))return!1;
a.blur();return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.DROP_COMMAND,b=>{const [,d]=H(b);if(0<d.length){var e=l(b.clientX,b.clientY);if(null!==e){const {offset:m,node:K}=e;var f=k.$getNearestNodeFromDOMNode(K);if(null!==f){e=k.$createRangeSelection();if(k.$isTextNode(f))e.anchor.set(f.getKey(),m,"text"),e.focus.set(f.getKey(),m,"text");else{const A=f.getParentOrThrow().getKey();f=f.getIndexWithinParent()+1;e.anchor.set(A,f,"element");e.focus.set(A,f,"element")}e=k.$normalizeSelection__EXPERIMENTAL(e);
k.$setSelection(e)}a.dispatchCommand(w,d)}b.preventDefault();return!0}b=k.$getSelection();return k.$isRangeSelection(b)?!0:!1},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.DRAGSTART_COMMAND,b=>{[b]=H(b);const d=k.$getSelection();return b&&!k.$isRangeSelection(d)?!1:!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.DRAGOVER_COMMAND,b=>{var [d]=H(b);const e=k.$getSelection();if(d&&!k.$isRangeSelection(e))return!1;d=l(b.clientX,b.clientY);null!==d&&(d=k.$getNearestNodeFromDOMNode(d.node),k.$isDecoratorNode(d)&&
b.preventDefault());return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.COPY_COMMAND,b=>{c.copyToClipboard(a,b instanceof ClipboardEvent?b:null);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.CUT_COMMAND,b=>{G(b,a);return!0},k.COMMAND_PRIORITY_EDITOR),a.registerCommand(k.PASTE_COMMAND,b=>{const [,d,e]=H(b);if(0<d.length&&!e)return a.dispatchCommand(w,d),!0;if(k.isSelectionCapturedInDecoratorInput(b.target))return!1;const f=k.$getSelection();return k.$isRangeSelection(f)||k.DEPRECATED_$isGridSelection(f)?
(F(b,a),!0):!1},k.COMMAND_PRIORITY_EDITOR))}


/***/ }),

/***/ 89408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalSelection =  false ? 0 : __webpack_require__(49235)
module.exports = LexicalSelection;

/***/ }),

/***/ 49235:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k=__webpack_require__(32998);let u=new Map;function v(a){for(;null!=a;){if(a.nodeType===Node.TEXT_NODE)return a;a=a.firstChild}return null}function w(a){let b=a.parentNode;if(null==b)throw Error("Should never happen");return[b,Array.from(b.childNodes).indexOf(a)]}function y(a){let b={};a=a.split(";");for(let c of a)if(""!==c){let [e,d]=c.split(/:([^]+)/);b[e.trim()]=d.trim()}return b}function z(a){let b=u.get(a);void 0===b&&(b=y(a),u.set(a,b));return b}
function A(a){let b="";for(let c in a)c&&(b+=`${c}: ${a[c]};`);return b}function B(a,b){var c=z("getStyle"in a?a.getStyle():a.style);b=Object.entries(b).reduce((e,[d,f])=>{null===f?delete e[d]:e[d]=f;return e},{...c});c=A(b);a.setStyle(c);u.set(c,b)}function C(a){for(;null!==a&&!k.$isRootOrShadowRoot(a);){let b=a.getLatest(),c=a.getParent();0===b.getChildrenSize()&&a.remove(!0);a=c}}
function D(a,b,c,e,d=null){if(0!==b.length){var f=b[0],h=new Map,g=[];f=k.$isElementNode(f)?f:f.getParentOrThrow();f.isInline()&&(f=f.getParentOrThrow());for(var l=!1;null!==f;){var m=f.getPreviousSibling();if(null!==m){f=m;l=!0;break}f=f.getParentOrThrow();if(k.$isRootOrShadowRoot(f))break}m=new Set;for(var q=0;q<c;q++){var p=b[q];k.$isElementNode(p)&&0===p.getChildrenSize()&&m.add(p.getKey())}var n=new Set;for(q=0;q<c;q++){p=b[q];var r=p.getParent();null!==r&&r.isInline()&&(r=r.getParent());if(null!==
r&&k.$isLeafNode(p)&&!n.has(p.getKey())){if(p=r.getKey(),void 0===h.get(p)){let t=e();t.setFormat(r.getFormatType());t.setIndent(r.getIndent());g.push(t);h.set(p,t);r.getChildren().forEach(x=>{t.append(x);n.add(x.getKey());k.$isElementNode(x)&&x.getChildrenKeys().forEach(G=>n.add(G))});C(r)}}else m.has(p.getKey())&&(r=e(),r.setFormat(p.getFormatType()),r.setIndent(p.getIndent()),g.push(r),p.remove(!0))}if(null!==d)for(b=0;b<g.length;b++)d.append(g[b]);b=null;if(k.$isRootOrShadowRoot(f))if(l)if(null!==
d)f.insertAfter(d);else for(d=g.length-1;0<=d;d--)f.insertAfter(g[d]);else if(l=f.getFirstChild(),k.$isElementNode(l)&&(f=l),null===l)if(d)f.append(d);else for(d=0;d<g.length;d++)l=g[d],f.append(l),b=l;else if(null!==d)l.insertBefore(d);else for(f=0;f<g.length;f++)d=g[f],l.insertBefore(d),b=d;else if(d)f.insertAfter(d);else for(d=g.length-1;0<=d;d--)l=g[d],f.insertAfter(l),b=l;g=k.$getPreviousSelection();k.$isRangeSelection(g)&&g.anchor.getNode().isAttached()&&g.focus.getNode().isAttached()?k.$setSelection(g.clone()):
null!==b?b.selectEnd():a.dirty=!0}}function E(a,b,c,e){a.modify(b?"extend":"move",c,e)}function F(a){a=a.anchor.getNode();return"rtl"===(k.$isRootNode(a)?a:a.getParentOrThrow()).getDirection()}exports.$addNodeStyle=function(a){a=a.getStyle();let b=y(a);u.set(a,b)};
exports.$cloneWithProperties=function(a){a=a.getLatest();let b=a.constructor.clone(a);b.__parent=a.__parent;b.__next=a.__next;b.__prev=a.__prev;if(k.$isElementNode(a)&&k.$isElementNode(b))return b.__first=a.__first,b.__last=a.__last,b.__size=a.__size,b.__format=a.__format,b.__indent=a.__indent,b.__dir=a.__dir,b;k.$isTextNode(a)&&k.$isTextNode(b)&&(b.__format=a.__format,b.__style=a.__style,b.__mode=a.__mode,b.__detail=a.__detail);return b};
exports.$getSelectionStyleValueForProperty=function(a,b,c=""){let e=null,d=a.getNodes();var f=a.anchor,h=a.focus,g=a.isBackward();let l=g?h.offset:f.offset;f=g?h.getNode():f.getNode();if(""!==a.style&&(a=z(a.style),null!==a&&b in a))return a[b];for(a=0;a<d.length;a++){var m=d[a];if((0===a||0!==l||!m.is(f))&&k.$isTextNode(m))if(h=b,g=c,m=m.getStyle(),m=z(m),h=null!==m?m[h]||g:g,null===e)e=h;else if(e!==h){e="";break}}return null===e?c:e};
exports.$isAtNodeEnd=function(a){return"text"===a.type?a.offset===a.getNode().getTextContentSize():a.offset===a.getNode().getChildrenSize()};exports.$isParentElementRTL=F;exports.$moveCaretSelection=E;exports.$moveCharacter=function(a,b,c){let e=F(a);E(a,b,c?!e:e,"character")};
exports.$patchStyleText=function(a,b){var c=a.getNodes();let e=c.length-1,d=c[0],f=c[e];if(a.isCollapsed())B(a,b);else{var h=a.anchor,g=a.focus,l=d.getTextContent().length,m=g.offset,q=h.offset,p=h.isBefore(g),n=p?q:m;a=p?m:q;var r=p?h.type:g.type,t=p?g.type:h.type;h=p?g.key:h.key;k.$isTextNode(d)&&n===l&&(g=d.getNextSibling(),k.$isTextNode(g)&&(n=q=0,d=g));if(1===c.length)k.$isTextNode(d)&&(n="element"===r?0:q>m?m:q,a="element"===t?l:q>m?q:m,n!==a&&(0===n&&a===l?(B(d,b),d.select(n,a)):(c=d.splitText(n,
a),c=0===n?c[0]:c[1],B(c,b),c.select(0,a-n))));else for(k.$isTextNode(d)&&n<d.getTextContentSize()&&(0!==n&&(d=d.splitText(n)[1]),B(d,b)),k.$isTextNode(f)&&(n=f.getTextContent().length,f.__key!==h&&0!==a&&(a=n),a!==n&&([f]=f.splitText(a)),0!==a&&B(f,b)),a=1;a<e;a++)n=c[a],l=n.getKey(),k.$isTextNode(n)&&l!==d.getKey()&&l!==f.getKey()&&!n.isToken()&&B(n,b)}};
exports.$selectAll=function(a){let b=a.anchor;a=a.focus;var c=b.getNode().getTopLevelElementOrThrow().getParentOrThrow();let e=c.getFirstDescendant();c=c.getLastDescendant();let d="element",f="element",h=0;k.$isTextNode(e)?d="text":k.$isElementNode(e)||null===e||(e=e.getParentOrThrow());k.$isTextNode(c)?(f="text",h=c.getTextContentSize()):k.$isElementNode(c)||null===c||(c=c.getParentOrThrow());e&&c&&(b.set(e.getKey(),0,d),a.set(c.getKey(),h,f))};
exports.$setBlocksType=function(a,b){if("root"===a.anchor.key){b=b();var c=k.$getRoot();(a=c.getFirstChild())?a.replace(b,!0):c.append(b)}else for(c=a.getNodes(),a=a.anchor.getNode().getParentOrThrow(),-1===c.indexOf(a)&&c.push(a),a.isInline()&&(a=a.getParentOrThrow(),-1===c.indexOf(a)&&c.push(a)),a=0;a<c.length;a++){let f=c[a];var e=f;if(!k.$isElementNode(e)||k.$isRootOrShadowRoot(e))e=!1;else{var d=e.getFirstChild();d=null===d||k.$isTextNode(d)||d.isInline();e=!e.isInline()&&!1!==e.canBeEmpty()&&
d}e&&(e=b(),e.setFormat(f.getFormatType()),e.setIndent(f.getIndent()),f.replace(e,!0))}};exports.$shouldOverrideDefaultCharacterSelection=function(a,b){a=k.$getAdjacentNode(a.focus,b);return k.$isDecoratorNode(a)&&!a.isIsolated()||k.$isElementNode(a)&&!a.isInline()&&!a.canBeEmpty()};
exports.$sliceSelectedTextNodeContent=function(a,b){if(b.isSelected()&&!b.isSegmented()&&!b.isToken()&&(k.$isRangeSelection(a)||k.DEPRECATED_$isGridSelection(a))){var c=a.anchor.getNode(),e=a.focus.getNode(),d=b.is(c),f=b.is(e);if(d||f){d=a.isBackward();let [h,g]=a.getCharacterOffsets();a=c.is(e);f=b.is(d?e:c);e=b.is(d?c:e);c=0;let l=void 0;a?(c=h>g?g:h,l=h>g?h:g):f?(c=d?g:h,l=void 0):e&&(d=d?h:g,c=0,l=d);b.__text=b.__text.slice(c,l)}}return b};
exports.$wrapNodes=function(a,b,c=null){var e=a.getNodes();let d=e.length;var f=a.anchor;if(0===d||1===d&&"element"===f.type&&0===f.getNode().getChildrenSize()){a="text"===f.type?f.getNode().getParentOrThrow():f.getNode();e=a.getChildren();let g=b();g.setFormat(a.getFormatType());g.setIndent(a.getIndent());e.forEach(l=>g.append(l));c&&(g=c.append(g));a.replace(g)}else{f=null;var h=[];for(let g=0;g<d;g++){let l=e[g];k.$isRootOrShadowRoot(l)?(D(a,h,h.length,b,c),h=[],f=l):null===f||null!==f&&k.$hasAncestor(l,
f)?h.push(l):(D(a,h,h.length,b,c),h=[l])}D(a,h,h.length,b,c)}};
exports.createDOMRange=function(a,b,c,e,d){let f=b.getKey(),h=e.getKey(),g=document.createRange(),l=a.getElementByKey(f);a=a.getElementByKey(h);k.$isTextNode(b)&&(l=v(l));k.$isTextNode(e)&&(a=v(a));if(void 0===b||void 0===e||null===l||null===a)return null;"BR"===l.nodeName&&([l,c]=w(l));"BR"===a.nodeName&&([a,d]=w(a));b=l.firstChild;l===a&&null!=b&&"BR"===b.nodeName&&0===c&&0===d&&(d=1);try{g.setStart(l,c),g.setEnd(a,d)}catch(m){return null}!g.collapsed||c===d&&f===h||(g.setStart(a,d),g.setEnd(l,
c));return g};exports.createRectsFromDOMRange=function(a,b){var c=a.getRootElement();if(null===c)return[];a=c.getBoundingClientRect();c=getComputedStyle(c);c=parseFloat(c.paddingLeft)+parseFloat(c.paddingRight);b=Array.from(b.getClientRects());let e=b.length;b.sort((f,h)=>{let g=f.top-h.top;return 3>=Math.abs(g)?f.left-h.left:g});let d;for(let f=0;f<e;f++){let h=b[f],g=h.width+c===a.width;d&&d.top<=h.top&&d.top+d.height>h.top&&d.left+d.width>h.left||g?(b.splice(f--,1),e--):d=h}return b};
exports.getStyleObjectFromCSS=z;
exports.trimTextContentFromAnchor=function(a,b,c){let e=b.getNode();if(k.$isElementNode(e)){var d=e.getDescendantByIndex(b.offset);null!==d&&(e=d)}for(;0<c&&null!==e;){var f=e.getPreviousSibling(),h=0;if(null===f){d=e.getParentOrThrow();for(var g=d.getPreviousSibling();null===g;){d=d.getParent();if(null===d){f=null;break}g=d.getPreviousSibling()}null!==d&&(h=d.isInline()?0:2,f=k.$isElementNode(g)?g.getLastDescendant():g)}g=e.getTextContent();""===g&&k.$isElementNode(e)&&!e.isInline()&&(g="\n\n");
d=e.getTextContentSize();if(!k.$isTextNode(e)||c>=d)g=e.getParent(),e.remove(),null==g||0!==g.getChildrenSize()||k.$isRootNode(g)||g.remove(),c-=d+h,e=f;else{let l=e.getKey();h=a.getEditorState().read(()=>{const q=k.$getNodeByKey(l);return k.$isTextNode(q)&&q.isSimpleText()?q.getTextContent():null});f=d-c;let m=g.slice(0,f);null!==h&&h!==g?(c=k.$getPreviousSelection(),d=e,e.isSimpleText()?e.setTextContent(h):(d=k.$createTextNode(h),e.replace(d)),k.$isRangeSelection(c)&&c.isCollapsed()&&(c=c.anchor.offset,
d.select(c,c))):e.isSimpleText()?(h=b.key===l,g=b.offset,g<c&&(g=d),c=h?g-c:0,d=h?g:f,h&&0===c?([c]=e.splitText(c,d),c.remove()):([,c]=e.splitText(c,d),c.remove())):(c=k.$createTextNode(m),e.replace(c));c=0}}}


/***/ }),

/***/ 91058:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalTable =  false ? 0 : __webpack_require__(59957)
module.exports = LexicalTable;

/***/ }),

/***/ 59957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d=__webpack_require__(32998),q=__webpack_require__(76969);let w=/^(\d+(?:\.\d+)?)px$/,x={BOTH:3,COLUMN:2,NO_STATUS:0,ROW:1};
class z extends d.DEPRECATED_GridCellNode{static getType(){return"tablecell"}static clone(a){let b=new z(a.__headerState,a.__colSpan,a.__width,a.__key);b.__rowSpan=a.__rowSpan;b.__backgroundColor=a.__backgroundColor;return b}static importDOM(){return{td:()=>({conversion:A,priority:0}),th:()=>({conversion:A,priority:0})}}static importJSON(a){let b=a.rowSpan||1,f=B(a.headerState,a.colSpan||1,a.width||void 0);f.__rowSpan=b;f.__backgroundColor=a.backgroundColor||null;return f}constructor(a=x.NO_STATUS,
b=1,f,h){super(b,h);this.__headerState=a;this.__width=f;this.__backgroundColor=null}createDOM(a){let b=document.createElement(this.getTag());this.__width&&(b.style.width=`${this.__width}px`);1<this.__colSpan&&(b.colSpan=this.__colSpan);1<this.__rowSpan&&(b.rowSpan=this.__rowSpan);null!==this.__backgroundColor&&(b.style.backgroundColor=this.__backgroundColor);q.addClassNamesToElement(b,a.theme.tableCell,this.hasHeader()&&a.theme.tableCellHeader);return b}exportDOM(a){({element:a}=super.exportDOM(a));
if(a){var b=this.getParentOrThrow().getChildrenSize();a.style.border="1px solid black";1<this.__colSpan&&(a.colSpan=this.__colSpan);1<this.__rowSpan&&(a.rowSpan=this.__rowSpan);a.style.width=`${this.getWidth()||Math.max(90,700/b)}px`;a.style.verticalAlign="top";a.style.textAlign="start";b=this.getBackgroundColor();null!==b?a.style.backgroundColor=b:this.hasHeader()&&(a.style.backgroundColor="#f2f3f5")}return{element:a}}exportJSON(){return{...super.exportJSON(),backgroundColor:this.getBackgroundColor(),
headerState:this.__headerState,type:"tablecell",width:this.getWidth()}}getTag(){return this.hasHeader()?"th":"td"}setHeaderStyles(a){this.getWritable().__headerState=a;return this.__headerState}getHeaderStyles(){return this.getLatest().__headerState}setWidth(a){this.getWritable().__width=a;return this.__width}getWidth(){return this.getLatest().__width}getBackgroundColor(){return this.getLatest().__backgroundColor}setBackgroundColor(a){this.getWritable().__backgroundColor=a}toggleHeaderStyle(a){let b=
this.getWritable();b.__headerState=(b.__headerState&a)===a?b.__headerState-a:b.__headerState+a;return b}hasHeaderState(a){return(this.getHeaderStyles()&a)===a}hasHeader(){return this.getLatest().__headerState!==x.NO_STATUS}updateDOM(a){return a.__headerState!==this.__headerState||a.__width!==this.__width||a.__colSpan!==this.__colSpan||a.__rowSpan!==this.__rowSpan||a.__backgroundColor!==this.__backgroundColor}isShadowRoot(){return!0}collapseAtStart(){return!0}canBeEmpty(){return!1}canIndent(){return!1}}
function A(a){var b=a.nodeName.toLowerCase();let f=void 0;w.test(a.style.width)&&(f=parseFloat(a.style.width));b=B("th"===b?x.ROW:x.NO_STATUS,a.colSpan,f);b.__rowSpan=a.rowSpan;a=a.style.backgroundColor;""!==a&&(b.__backgroundColor=a);return{forChild:(h,c)=>{if(C(c)&&!d.$isElementNode(h)){c=d.$createParagraphNode();if(d.$isLineBreakNode(h)&&"\n"===h.getTextContent())return null;c.append(h);return c}return h},node:b}}function B(a,b=1,f){return d.$applyNodeReplacement(new z(a,b,f))}
function C(a){return a instanceof z}
class D extends d.DEPRECATED_GridRowNode{static getType(){return"tablerow"}static clone(a){return new D(a.__height,a.__key)}static importDOM(){return{tr:()=>({conversion:aa,priority:0})}}static importJSON(a){return E(a.height)}constructor(a,b){super(b);this.__height=a}exportJSON(){return{...super.exportJSON(),type:"tablerow",version:1}}createDOM(a){let b=document.createElement("tr");this.__height&&(b.style.height=`${this.__height}px`);q.addClassNamesToElement(b,a.theme.tableRow);return b}isShadowRoot(){return!0}setHeight(a){this.getWritable().__height=
a;return this.__height}getHeight(){return this.getLatest().__height}updateDOM(a){return a.__height!==this.__height}canBeEmpty(){return!1}canIndent(){return!1}}function aa(a){let b=void 0;w.test(a.style.height)&&(b=parseFloat(a.style.height));return{node:E(b)}}function E(a){return d.$applyNodeReplacement(new D(a))}function F(a){return a instanceof D}
function G(a){throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?code=${a} for the full message or `+"use the non-minified dev environment for full errors and additional helpful warnings.");}let ba="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement;
class H{constructor(a,b){this.isHighlightingCells=!1;this.focusY=this.focusX=this.anchorY=this.anchorX=-1;this.listenersToRemove=new Set;this.tableNodeKey=b;this.editor=a;this.grid={cells:[],columns:0,rows:0};this.focusCell=this.anchorCell=this.focusCellNodeKey=this.anchorCellNodeKey=this.gridSelection=null;this.hasHijackedSelectionStyles=!1;this.trackTableGrid()}getGrid(){return this.grid}removeListeners(){Array.from(this.listenersToRemove).forEach(a=>a())}trackTableGrid(){let a=new MutationObserver(b=>
{this.editor.update(()=>{var f=!1;for(let h=0;h<b.length;h++){const c=b[h].target.nodeName;if("TABLE"===c||"TR"===c){f=!0;break}}if(f){f=this.editor.getElementByKey(this.tableNodeKey);if(!f)throw Error("Expected to find TableElement in DOM");this.grid=I(f)}})});this.editor.update(()=>{let b=this.editor.getElementByKey(this.tableNodeKey);if(!b)throw Error("Expected to find TableElement in DOM");this.grid=I(b);a.observe(b,{childList:!0,subtree:!0})})}clearHighlight(){let a=this.editor;this.isHighlightingCells=
!1;this.focusY=this.focusX=this.anchorY=this.anchorX=-1;this.focusCell=this.anchorCell=this.focusCellNodeKey=this.anchorCellNodeKey=this.gridSelection=null;this.hasHijackedSelectionStyles=!1;this.enableHighlightStyle();a.update(()=>{var b=d.$getNodeByKey(this.tableNodeKey);if(!J(b))throw Error("Expected TableNode.");b=a.getElementByKey(this.tableNodeKey);if(!b)throw Error("Expected to find TableElement in DOM");b=I(b);K(a,b,null);d.$setSelection(null);a.dispatchCommand(d.SELECTION_CHANGE_COMMAND,
void 0)})}enableHighlightStyle(){let a=this.editor;a.update(()=>{let b=a.getElementByKey(this.tableNodeKey);if(!b)throw Error("Expected to find TableElement in DOM");b.classList.remove("disable-selection");this.hasHijackedSelectionStyles=!1})}disableHighlightStyle(){let a=this.editor;a.update(()=>{let b=a.getElementByKey(this.tableNodeKey);if(!b)throw Error("Expected to find TableElement in DOM");b.classList.add("disable-selection");this.hasHijackedSelectionStyles=!0})}updateTableGridSelection(a){if(null!=
a&&a.gridKey===this.tableNodeKey){let b=this.editor;this.gridSelection=a;this.isHighlightingCells=!0;this.disableHighlightStyle();K(b,this.grid,this.gridSelection)}else null==a&&this.clearHighlight()}setFocusCellForSelection(a,b=!1){let f=this.editor;f.update(()=>{var h=d.$getNodeByKey(this.tableNodeKey);if(!J(h))throw Error("Expected TableNode.");if(!f.getElementByKey(this.tableNodeKey))throw Error("Expected to find TableElement in DOM");h=a.x;let c=a.y;this.focusCell=a;if(null!==this.anchorCell){let l=
ba?(f._window||window).getSelection():null;l&&l.setBaseAndExtent(this.anchorCell.elem,0,this.focusCell.elem,0)}if(!this.isHighlightingCells&&(this.anchorX!==h||this.anchorY!==c||b))this.isHighlightingCells=!0,this.disableHighlightStyle();else if(h===this.focusX&&c===this.focusY)return;this.focusX=h;this.focusY=c;this.isHighlightingCells&&(h=d.$getNearestNodeFromDOMNode(a.elem),null!=this.gridSelection&&null!=this.anchorCellNodeKey&&C(h)&&(h=h.getKey(),this.gridSelection=this.gridSelection.clone()||
d.DEPRECATED_$createGridSelection(),this.focusCellNodeKey=h,this.gridSelection.set(this.tableNodeKey,this.anchorCellNodeKey,this.focusCellNodeKey),d.$setSelection(this.gridSelection),f.dispatchCommand(d.SELECTION_CHANGE_COMMAND,void 0),K(f,this.grid,this.gridSelection)))})}setAnchorCellForSelection(a){this.isHighlightingCells=!1;this.anchorCell=a;this.anchorX=a.x;this.anchorY=a.y;this.editor.update(()=>{var b=d.$getNearestNodeFromDOMNode(a.elem);C(b)&&(b=b.getKey(),this.gridSelection=d.DEPRECATED_$createGridSelection(),
this.anchorCellNodeKey=b)})}formatCells(a){this.editor.update(()=>{let b=d.$getSelection();d.DEPRECATED_$isGridSelection(b)||G(11);let f=d.$createRangeSelection(),h=f.anchor,c=f.focus;b.getNodes().forEach(l=>{C(l)&&0!==l.getTextContentSize()&&(h.set(l.getKey(),0,"element"),c.set(l.getKey(),l.getChildrenSize(),"element"),f.formatText(a))});d.$setSelection(b);this.editor.dispatchCommand(d.SELECTION_CHANGE_COMMAND,void 0)})}clearText(){let a=this.editor;a.update(()=>{let b=d.$getNodeByKey(this.tableNodeKey);
if(!J(b))throw Error("Expected TableNode.");var f=d.$getSelection();d.DEPRECATED_$isGridSelection(f)||G(11);f=f.getNodes().filter(C);f.length===this.grid.columns*this.grid.rows?(b.selectPrevious(),b.remove(),d.$getRoot().selectStart()):(f.forEach(h=>{if(d.$isElementNode(h)){let c=d.$createParagraphNode(),l=d.$createTextNode();c.append(l);h.append(c);h.getChildren().forEach(p=>{p!==c&&p.remove()})}}),K(a,this.grid,null),d.$setSelection(null),a.dispatchCommand(d.SELECTION_CHANGE_COMMAND,void 0))})}}
function L(a){for(;null!=a;){let b=a.nodeName;if("TD"===b||"TH"===b){a=a._cell;if(void 0===a)break;return a}a=a.parentNode}return null}
function I(a){let b=[],f={cells:b,columns:0,rows:0};var h=a.firstChild;let c=a=0;for(b.length=0;null!=h;){var l=h.nodeName;if("TD"===l||"TH"===l)l=h,l={elem:l,hasBackgroundColor:""!==l.style.backgroundColor,highlighted:!1,x:a,y:c},h._cell=l,void 0===b[c]&&(b[c]=[]),b[c][a]=l;else if(l=h.firstChild,null!=l){h=l;continue}l=h.nextSibling;if(null!=l)a++,h=l;else if(l=h.parentNode,null!=l){h=l.nextSibling;if(null==h)break;c++;a=0}}f.columns=a+1;f.rows=c+1;return f}
function K(a,b,f){let h=[],c=new Set(f?f.getNodes():[]);M(b,(l,p)=>{let n=l.elem;c.has(p)?(l.highlighted=!0,N(a,l),h.push(l)):(l.highlighted=!1,O(a,l),n.getAttribute("style")||n.removeAttribute("style"))});return h}function M(a,b){({cells:a}=a);for(let f=0;f<a.length;f++){let h=a[f];for(let c=0;c<h.length;c++){let l=h[c],p=d.$getNearestNodeFromDOMNode(l.elem);null!==p&&b(l,p,{x:c,y:f})}}}function ca(a,b){b.disableHighlightStyle();M(b.grid,f=>{f.highlighted=!0;N(a,f)})}
function da(a,b){b.enableHighlightStyle();M(b.grid,f=>{let h=f.elem;f.highlighted=!1;O(a,f);h.getAttribute("style")||h.removeAttribute("style")})}
let Q=(a,b,f,h,c)=>{const l="forward"===c;switch(c){case "backward":case "forward":return f!==(l?a.grid.columns-1:0)?P(b.getCellNodeFromCordsOrThrow(f+(l?1:-1),h,a.grid)):h!==(l?a.grid.rows-1:0)?P(b.getCellNodeFromCordsOrThrow(l?0:a.grid.columns-1,h+(l?1:-1),a.grid)):l?b.selectNext():b.selectPrevious(),!0;case "up":return 0!==h?P(b.getCellNodeFromCordsOrThrow(f,h-1,a.grid)):b.selectPrevious(),!0;case "down":return h!==a.grid.rows-1?P(b.getCellNodeFromCordsOrThrow(f,h+1,a.grid)):b.selectNext(),!0;
default:return!1}},R=(a,b,f,h,c)=>{const l="forward"===c;switch(c){case "backward":case "forward":return f!==(l?a.grid.columns-1:0)&&a.setFocusCellForSelection(b.getCellFromCordsOrThrow(f+(l?1:-1),h,a.grid)),!0;case "up":return 0!==h?(a.setFocusCellForSelection(b.getCellFromCordsOrThrow(f,h-1,a.grid)),!0):!1;case "down":return h!==a.grid.rows-1?(a.setFocusCellForSelection(b.getCellFromCordsOrThrow(f,h+1,a.grid)),!0):!1;default:return!1}};
function S(a,b){if(d.$isRangeSelection(a)||d.DEPRECATED_$isGridSelection(a)){let f=b.isParentOf(a.anchor.getNode());a=b.isParentOf(a.focus.getNode());return f&&a}return!1}function P(a){let b=a.getChildren().find(f=>d.$isParagraphNode(f));d.$isParagraphNode(b)?b.selectEnd():a.selectEnd()}
function N(a,b){a=b.elem;b=d.$getNearestNodeFromDOMNode(a);if(!C(b))throw Error("Expected to find LexicalNode from Table Cell DOMNode");null===b.getBackgroundColor()?a.style.setProperty("background-color","rgb(172,206,247)"):a.style.setProperty("background-image","linear-gradient(to right, rgba(172,206,247,0.85), rgba(172,206,247,0.85))");a.style.setProperty("caret-color","transparent")}
function O(a,b){a=b.elem;b=d.$getNearestNodeFromDOMNode(a);if(!C(b))throw Error("Expected to find LexicalNode from Table Cell DOMNode");null===b.getBackgroundColor()&&a.style.removeProperty("background-color");a.style.removeProperty("background-image");a.style.removeProperty("caret-color")}
class T extends d.DEPRECATED_GridNode{static getType(){return"table"}static clone(a){return new T(a.__key)}static importDOM(){return{table:()=>({conversion:ea,priority:1})}}static importJSON(){return V()}constructor(a){super(a)}exportJSON(){return{...super.exportJSON(),type:"table",version:1}}createDOM(a){let b=document.createElement("table");q.addClassNamesToElement(b,a.theme.table);return b}updateDOM(){return!1}exportDOM(a){return{...super.exportDOM(a),after:b=>{if(b){let f=b.cloneNode(),h=document.createElement("colgroup"),
c=document.createElement("tbody");c.append(...b.children);b=this.getFirstChildOrThrow();if(!F(b))throw Error("Expected to find row node.");b=b.getChildrenSize();for(let l=0;l<b;l++){let p=document.createElement("col");h.append(p)}f.replaceChildren(h,c);return f}}}}canExtractContents(){return!1}canBeEmpty(){return!1}isShadowRoot(){return!0}getCordsFromCellNode(a,b){let {rows:f,cells:h}=b;for(b=0;b<f;b++){var c=h[b];if(null==c)throw Error(`Row not found at y:${b}`);c=c.findIndex(({elem:l})=>d.$getNearestNodeFromDOMNode(l)===
a);if(-1!==c)return{x:c,y:b}}throw Error("Cell not found in table.");}getCellFromCords(a,b,f){({cells:f}=f);b=f[b];if(null==b)return null;a=b[a];return null==a?null:a}getCellFromCordsOrThrow(a,b,f){a=this.getCellFromCords(a,b,f);if(!a)throw Error("Cell not found at cords.");return a}getCellNodeFromCords(a,b,f){a=this.getCellFromCords(a,b,f);if(null==a)return null;a=d.$getNearestNodeFromDOMNode(a.elem);return C(a)?a:null}getCellNodeFromCordsOrThrow(a,b,f){a=this.getCellNodeFromCords(a,b,f);if(!a)throw Error("Node at cords not TableCellNode.");
return a}canSelectBefore(){return!0}canIndent(){return!1}}function ea(){return{node:V()}}function V(){return d.$applyNodeReplacement(new T)}function J(a){return a instanceof T}function W(a){a=q.$findMatchingParent(a,b=>F(b));if(F(a))return a;throw Error("Expected table cell to be inside of table row.");}function X(a){a=q.$findMatchingParent(a,b=>J(b));if(J(a))return a;throw Error("Expected table cell to be inside of table.");}
function fa(a,b){let f=X(a),{x:h,y:c}=f.getCordsFromCellNode(a,b);return{above:f.getCellNodeFromCords(h,c-1,b),below:f.getCellNodeFromCords(h,c+1,b),left:f.getCellNodeFromCords(h-1,c,b),right:f.getCellNodeFromCords(h+1,c,b)}}function Y(a){a=a.getFirstDescendant();null===a&&G(124);a.getParentOrThrow().selectStart()}function Z(a,b){let f=a.getFirstChild();null!==f?f.insertBefore(b):a.append(b)}let ha=d.createCommand("INSERT_TABLE_COMMAND");exports.$createTableCellNode=B;exports.$createTableNode=V;
exports.$createTableNodeWithDimensions=function(a,b,f=!0){let h=V();for(let l=0;l<a;l++){let p=E();for(let n=0;n<b;n++){var c=x.NO_STATUS;"object"===typeof f?(0===l&&f.rows&&(c|=x.ROW),0===n&&f.columns&&(c|=x.COLUMN)):f&&(0===l&&(c|=x.ROW),0===n&&(c|=x.COLUMN));c=B(c);let r=d.$createParagraphNode();r.append(d.$createTextNode());c.append(r);p.append(c)}h.append(p)}return h};exports.$createTableRowNode=E;
exports.$deleteTableColumn=function(a,b){let f=a.getChildren();for(let c=0;c<f.length;c++){var h=f[c];if(F(h)){h=h.getChildren();if(b>=h.length||0>b)throw Error("Table column target index out of range");h[b].remove()}}return a};
exports.$deleteTableColumn__EXPERIMENTAL=function(){var a=d.$getSelection();d.$isRangeSelection(a)||d.DEPRECATED_$isGridSelection(a)||G(118);var b=a.anchor.getNode();a=a.focus.getNode();let [f,,h]=d.DEPRECATED_$getNodeTriplet(b);[b]=d.DEPRECATED_$getNodeTriplet(a);let [c,l,p]=d.DEPRECATED_$computeGridMap(h,f,b);var {startColumn:n}=l;let {startRow:r,startColumn:u}=p;a=Math.min(n,u);n=Math.max(n+f.__colSpan-1,u+b.__colSpan-1);let t=n-a+1;if(c[0].length===n-a+1)h.selectPrevious(),h.remove();else{var g=
c.length;for(let e=0;e<g;e++)for(let k=a;k<=n;k++){let {cell:m,startColumn:v}=c[e][k];v<a?k===a&&m.setColSpan(m.__colSpan-Math.min(t,m.__colSpan-(a-v))):v+m.__colSpan-1>n?k===n&&m.setColSpan(m.__colSpan-(n-v+1)):m.remove()}a=c[r];b=a[u+b.__colSpan];void 0!==b?({cell:b}=b,Y(b)):({cell:b}=a[u-1],Y(b))}};
exports.$deleteTableRow__EXPERIMENTAL=function(){var a=d.$getSelection();d.$isRangeSelection(a)||d.DEPRECATED_$isGridSelection(a)||G(118);var b=a.anchor.getNode();a=a.focus.getNode();let [f,,h]=d.DEPRECATED_$getNodeTriplet(b);[a]=d.DEPRECATED_$getNodeTriplet(a);let [c,l,p]=d.DEPRECATED_$computeGridMap(h,f,a);({startRow:b}=l);var {startRow:n}=p;a=n+a.__rowSpan-1;if(c.length===a-b+1)h.remove();else{n=c[0].length;var r=c[a+1],u=h.getChildAtIndex(a+1);for(let g=a;g>=b;g--){for(var t=n-1;0<=t;t--){let {cell:e,
startRow:k,startColumn:m}=c[g][t];if(m===t&&(g===b&&k<b&&e.setRowSpan(e.__rowSpan-(k-b)),k>=b&&k+e.__rowSpan-1>a))if(e.setRowSpan(e.__rowSpan-(a-k+1)),null===u&&G(122),0===t)Z(u,e);else{let {cell:v}=r[t-1];v.insertAfter(e)}}t=h.getChildAtIndex(g);d.DEPRECATED_$isGridRowNode(t)||G(123);t.remove()}void 0!==r?({cell:b}=r[0],Y(b)):({cell:b}=c[b-1][0],Y(b))}};exports.$getElementGridForTableNode=function(a,b){a=a.getElementByKey(b.getKey());if(null==a)throw Error("Table Element Not Found");return I(a)};
exports.$getTableCellNodeFromLexicalNode=function(a){a=q.$findMatchingParent(a,b=>C(b));return C(a)?a:null};exports.$getTableColumnIndexFromTableCellNode=function(a){return W(a).getChildren().findIndex(b=>b.is(a))};exports.$getTableNodeFromLexicalNodeOrThrow=X;exports.$getTableRowIndexFromTableCellNode=function(a){let b=W(a);return X(b).getChildren().findIndex(f=>f.is(b))};exports.$getTableRowNodeFromTableCellNodeOrThrow=W;
exports.$insertTableColumn=function(a,b,f=!0,h,c){let l=a.getChildren();for(let r=0;r<l.length;r++){let u=l[r];if(F(u))for(let t=0;t<h;t++){var p=u.getChildren();if(b>=p.length||0>b)throw Error("Table column target index out of range");p=p[b];C(p)||G(12);let {left:g,right:e}=fa(p,c);var n=x.NO_STATUS;if(g&&g.hasHeaderState(x.ROW)||e&&e.hasHeaderState(x.ROW))n|=x.ROW;n=B(n);n.append(d.$createParagraphNode());f?p.insertAfter(n):p.insertBefore(n)}}return a};
exports.$insertTableColumn__EXPERIMENTAL=function(a=!0){function b(){let t=B(x.NO_STATUS).append(d.$createParagraphNode());null===r&&(r=t);return t}var f=d.$getSelection();d.$isRangeSelection(f)||d.DEPRECATED_$isGridSelection(f)||G(118);f=f.focus.getNode();let [h,,c]=d.DEPRECATED_$getNodeTriplet(f),[l,p]=d.DEPRECATED_$computeGridMap(c,h,h);f=l.length;var {startColumn:n}=p;a=a?n+h.__colSpan-1:n-1;n=c.getFirstChild();d.DEPRECATED_$isGridRowNode(n)||G(120);let r=null;var u=n;a:for(n=0;n<f;n++){0!==n&&
(u=u.getNextSibling(),d.DEPRECATED_$isGridRowNode(u)||G(121));let t=l[n];if(0>a){Z(u,b());continue}let {cell:g,startColumn:e,startRow:k}=t[a];if(e+g.__colSpan-1<=a){let m=g,v=k,y=a;for(;v!==n&&1<m.__rowSpan;)if(y-=g.__colSpan,0<=y){let {cell:U,startRow:ia}=t[y];m=U;v=ia}else{u.append(b());continue a}m.insertAfter(b())}else g.setColSpan(g.__colSpan+1)}null!==r&&Y(r)};
exports.$insertTableRow=function(a,b,f=!0,h,c){var l=a.getChildren();if(b>=l.length||0>b)throw Error("Table row target index out of range");b=l[b];if(F(b))for(l=0;l<h;l++){let n=b.getChildren(),r=n.length,u=E();for(let t=0;t<r;t++){var p=n[t];C(p)||G(12);let {above:g,below:e}=fa(p,c);p=x.NO_STATUS;let k=g&&g.getWidth()||e&&e.getWidth()||void 0;if(g&&g.hasHeaderState(x.COLUMN)||e&&e.hasHeaderState(x.COLUMN))p|=x.COLUMN;p=B(p,1,k);p.append(d.$createParagraphNode());u.append(p)}f?b.insertAfter(u):b.insertBefore(u)}else throw Error("Row before insertion index does not exist.");
return a};
exports.$insertTableRow__EXPERIMENTAL=function(a=!0){var b=d.$getSelection();d.$isRangeSelection(b)||d.DEPRECATED_$isGridSelection(b)||G(118);b=b.focus.getNode();let [f,,h]=d.DEPRECATED_$getNodeTriplet(b),[c,l]=d.DEPRECATED_$computeGridMap(h,f,f);b=c[0].length;var {startRow:p}=l;if(a){a=p+f.__rowSpan-1;var n=c[a];p=E();for(var r=0;r<b;r++){let {cell:u,startRow:t}=n[r];t+u.__rowSpan-1<=a?p.append(B(x.NO_STATUS)):u.setRowSpan(u.__rowSpan+1)}b=h.getChildAtIndex(a);d.DEPRECATED_$isGridRowNode(b)||G(119);
b.insertAfter(p)}else{n=c[p];a=E();for(r=0;r<b;r++){let {cell:u,startRow:t}=n[r];t===p?a.append(B(x.NO_STATUS)):u.setRowSpan(u.__rowSpan+1)}b=h.getChildAtIndex(p);d.DEPRECATED_$isGridRowNode(b)||G(119);b.insertBefore(a)}};exports.$isTableCellNode=C;exports.$isTableNode=J;exports.$isTableRowNode=F;exports.$removeTableRowAtIndex=function(a,b){let f=a.getChildren();if(b>=f.length||0>b)throw Error("Expected table cell to be inside of table row.");f[b].remove();return a};
exports.$unmergeCell=function(){var a=d.$getSelection();d.$isRangeSelection(a)||d.DEPRECATED_$isGridSelection(a)||G(118);a=a.anchor.getNode();let [b,f,h]=d.DEPRECATED_$getNodeTriplet(a);a=b.__colSpan;let c=b.__rowSpan;if(1<a){for(var l=1;l<a;l++)b.insertAfter(B(x.NO_STATUS));b.setColSpan(1)}if(1<c){let [r,u]=d.DEPRECATED_$computeGridMap(h,b,b),{startColumn:t,startRow:g}=u;for(l=1;l<c;l++){let e=g+l,k=r[e];var p=f.getNextSibling();d.DEPRECATED_$isGridRowNode(p)||G(125);var n=null;for(let m=0;m<t;m++){let v=
k[m],y=v.cell;v.startRow===e&&(n=y);1<y.__colSpan&&(m+=y.__colSpan-1)}if(null===n)for(n=0;n<a;n++)Z(p,B(x.NO_STATUS));else for(p=0;p<a;p++)n.insertAfter(B(x.NO_STATUS))}b.setRowSpan(1)}};exports.INSERT_TABLE_COMMAND=ha;exports.TableCellHeaderStates=x;exports.TableCellNode=z;exports.TableNode=T;exports.TableRowNode=D;exports.TableSelection=H;
exports.applyTableHandlers=function(a,b,f){let h=f.getRootElement();if(null===h)throw Error("No root element.");let c=new H(f,a.getKey());b.__lexicalTableSelection=c;let l=!1,p=!1;b.addEventListener("dblclick",g=>{let e=L(g.target);null!==e&&(g.preventDefault(),g.stopImmediatePropagation(),g.stopPropagation(),c.setAnchorCellForSelection(e),c.setFocusCellForSelection(e,!0),l=!1)});b.addEventListener("mousedown",g=>{setTimeout(()=>{if(0===g.button){var e=L(g.target);null!==e&&(g.preventDefault(),g.stopPropagation(),
g.stopImmediatePropagation(),c.setAnchorCellForSelection(e))}},0)});b.addEventListener("mousemove",g=>{p&&(g.preventDefault(),g.stopPropagation(),g.stopImmediatePropagation());if(l){let e=L(g.target);if(null!==e){let k=e.x,m=e.y;l&&(c.anchorX!==k||c.anchorY!==m||c.isHighlightingCells)&&(g.preventDefault(),c.setFocusCellForSelection(e))}}});b.addEventListener("mouseleave",()=>{});let n=g=>{0===g.button&&f.update(()=>{var e=d.$getSelection();const k=g.target;if(k instanceof Node){if(d.DEPRECATED_$isGridSelection(e)&&
e.gridKey===c.tableNodeKey&&h.contains(k))return c.clearHighlight();e=d.$getNearestNodeFromDOMNode(k);null!==e&&q.$findMatchingParent(e,d.DEPRECATED_$isGridNode)&&(l=!0)}})};window.addEventListener("mousedown",n);c.listenersToRemove.add(()=>window.removeEventListener("mousedown",n));let r=g=>{var e;if(e=l)e=g.target,e=null!==e&&"SPAN"===e.nodeName?!0:!1,e=!e;e&&(g.preventDefault(),g.stopPropagation());l=!1};window.addEventListener("mouseup",r);c.listenersToRemove.add(()=>window.removeEventListener("mouseup",
r));b.addEventListener("mouseup",r);c.listenersToRemove.add(()=>b.removeEventListener("mouseup",r));c.listenersToRemove.add(f.registerCommand(d.KEY_ARROW_DOWN_COMMAND,g=>{var e=d.$getSelection();if(!S(e,a))return!1;if(d.$isRangeSelection(e)){if(e.isCollapsed()){var k=q.$findMatchingParent(e.anchor.getNode(),v=>C(v));if(!C(k))return!1;var m=a.getCordsFromCellNode(k,c.grid);e=q.$findMatchingParent(e.anchor.getNode(),v=>d.$isElementNode(v));if(null==e)throw Error("Expected BlockNode Parent");if((k=k.getLastChild())&&
e.isParentOf(k)||e===k||g.shiftKey)return g.preventDefault(),g.stopImmediatePropagation(),g.stopPropagation(),g.shiftKey?(c.setAnchorCellForSelection(a.getCellFromCordsOrThrow(m.x,m.y,c.grid)),R(c,a,m.x,m.y,"down")):Q(c,a,m.x,m.y,"down")}}else if(d.DEPRECATED_$isGridSelection(e)&&g.shiftKey){m=e.focus.getNode();if(!C(m))return!1;m=a.getCordsFromCellNode(m,c.grid);g.preventDefault();g.stopImmediatePropagation();g.stopPropagation();return R(c,a,m.x,m.y,"down")}return!1},d.COMMAND_PRIORITY_HIGH));c.listenersToRemove.add(f.registerCommand(d.KEY_ARROW_UP_COMMAND,
g=>{var e=d.$getSelection();if(!S(e,a))return!1;if(d.$isRangeSelection(e)){if(e.isCollapsed()){var k=q.$findMatchingParent(e.anchor.getNode(),v=>C(v));if(!C(k))return!1;var m=a.getCordsFromCellNode(k,c.grid);e=q.$findMatchingParent(e.anchor.getNode(),v=>d.$isElementNode(v));if(null==e)throw Error("Expected BlockNode Parent");if((k=k.getLastChild())&&e.isParentOf(k)||e===k||g.shiftKey)return g.preventDefault(),g.stopImmediatePropagation(),g.stopPropagation(),g.shiftKey?(c.setAnchorCellForSelection(a.getCellFromCordsOrThrow(m.x,
m.y,c.grid)),R(c,a,m.x,m.y,"up")):Q(c,a,m.x,m.y,"up")}}else if(d.DEPRECATED_$isGridSelection(e)&&g.shiftKey){m=e.focus.getNode();if(!C(m))return!1;m=a.getCordsFromCellNode(m,c.grid);g.preventDefault();g.stopImmediatePropagation();g.stopPropagation();return R(c,a,m.x,m.y,"up")}return!1},d.COMMAND_PRIORITY_HIGH));c.listenersToRemove.add(f.registerCommand(d.KEY_ARROW_LEFT_COMMAND,g=>{var e=d.$getSelection();if(!S(e,a))return!1;if(d.$isRangeSelection(e)){if(e.isCollapsed()){var k=q.$findMatchingParent(e.anchor.getNode(),
m=>C(m));if(!C(k))return!1;k=a.getCordsFromCellNode(k,c.grid);if(null==q.$findMatchingParent(e.anchor.getNode(),m=>d.$isElementNode(m)))throw Error("Expected BlockNode Parent");if(0===e.anchor.offset||g.shiftKey)return g.preventDefault(),g.stopImmediatePropagation(),g.stopPropagation(),g.shiftKey?(c.setAnchorCellForSelection(a.getCellFromCordsOrThrow(k.x,k.y,c.grid)),R(c,a,k.x,k.y,"backward")):Q(c,a,k.x,k.y,"backward")}}else if(d.DEPRECATED_$isGridSelection(e)&&g.shiftKey){e=e.focus.getNode();if(!C(e))return!1;
e=a.getCordsFromCellNode(e,c.grid);g.preventDefault();g.stopImmediatePropagation();g.stopPropagation();return R(c,a,e.x,e.y,"backward")}return!1},d.COMMAND_PRIORITY_HIGH));c.listenersToRemove.add(f.registerCommand(d.KEY_ARROW_RIGHT_COMMAND,g=>{var e=d.$getSelection();if(!S(e,a))return!1;if(d.$isRangeSelection(e)){if(e.isCollapsed()){var k=q.$findMatchingParent(e.anchor.getNode(),m=>C(m));if(!C(k))return!1;k=a.getCordsFromCellNode(k,c.grid);if(null==q.$findMatchingParent(e.anchor.getNode(),m=>d.$isElementNode(m)))throw Error("Expected BlockNode Parent");
if(e.anchor.offset===e.anchor.getNode().getTextContentSize()||g.shiftKey)return g.preventDefault(),g.stopImmediatePropagation(),g.stopPropagation(),g.shiftKey?(c.setAnchorCellForSelection(a.getCellFromCordsOrThrow(k.x,k.y,c.grid)),R(c,a,k.x,k.y,"forward")):Q(c,a,k.x,k.y,"forward")}}else if(d.DEPRECATED_$isGridSelection(e)&&g.shiftKey){e=e.focus.getNode();if(!C(e))return!1;e=a.getCordsFromCellNode(e,c.grid);g.preventDefault();g.stopImmediatePropagation();g.stopPropagation();return R(c,a,e.x,e.y,"forward")}return!1},
d.COMMAND_PRIORITY_HIGH));let u=g=>()=>{var e=d.$getSelection();if(!S(e,a))return!1;if(d.DEPRECATED_$isGridSelection(e))return c.clearText(),!0;if(d.$isRangeSelection(e)){const v=q.$findMatchingParent(e.anchor.getNode(),y=>C(y));if(!C(v))return!1;var k=e.anchor.getNode(),m=e.focus.getNode();k=a.isParentOf(k);m=a.isParentOf(m);if(k&&!m||m&&!k)return c.clearText(),!0;k=(m=q.$findMatchingParent(e.anchor.getNode(),y=>d.$isElementNode(y)))&&q.$findMatchingParent(m,y=>d.$isElementNode(y)&&C(y.getParent()));
if(!d.$isElementNode(k)||!d.$isElementNode(m))return!1;if(g===d.DELETE_LINE_COMMAND&&null===k.getPreviousSibling())return!0;if((g===d.DELETE_CHARACTER_COMMAND||g===d.DELETE_WORD_COMMAND)&&e.isCollapsed()&&0===e.anchor.offset&&m!==k){e=m.getChildren();const y=d.$createParagraphNode();e.forEach(U=>y.append(U));m.replace(y);m.getWritable().__parent=v.getKey();return!0}}return!1};[d.DELETE_WORD_COMMAND,d.DELETE_LINE_COMMAND,d.DELETE_CHARACTER_COMMAND].forEach(g=>{c.listenersToRemove.add(f.registerCommand(g,
u(g),d.COMMAND_PRIORITY_CRITICAL))});let t=g=>{const e=d.$getSelection();if(!S(e,a))return!1;if(d.DEPRECATED_$isGridSelection(e))return g.preventDefault(),g.stopPropagation(),c.clearText(),!0;d.$isRangeSelection(e)&&(g=q.$findMatchingParent(e.anchor.getNode(),k=>C(k)),C(g));return!1};c.listenersToRemove.add(f.registerCommand(d.KEY_BACKSPACE_COMMAND,t,d.COMMAND_PRIORITY_CRITICAL));c.listenersToRemove.add(f.registerCommand(d.KEY_DELETE_COMMAND,t,d.COMMAND_PRIORITY_CRITICAL));c.listenersToRemove.add(f.registerCommand(d.FORMAT_TEXT_COMMAND,
g=>{let e=d.$getSelection();if(!S(e,a))return!1;if(d.DEPRECATED_$isGridSelection(e))return c.formatCells(g),!0;d.$isRangeSelection(e)&&(g=q.$findMatchingParent(e.anchor.getNode(),k=>C(k)),C(g));return!1},d.COMMAND_PRIORITY_CRITICAL));c.listenersToRemove.add(f.registerCommand(d.CONTROLLED_TEXT_INSERTION_COMMAND,()=>{var g=d.$getSelection();if(!S(g,a))return!1;d.DEPRECATED_$isGridSelection(g)?c.clearHighlight():d.$isRangeSelection(g)&&(g=q.$findMatchingParent(g.anchor.getNode(),e=>C(e)),C(g));return!1},
d.COMMAND_PRIORITY_CRITICAL));c.listenersToRemove.add(f.registerCommand(d.KEY_TAB_COMMAND,g=>{var e=d.$getSelection();if(!S(e,a))return!1;if(d.$isRangeSelection(e)){let k=q.$findMatchingParent(e.anchor.getNode(),m=>C(m));if(!C(k))return!1;if(e.isCollapsed())return e=a.getCordsFromCellNode(k,c.grid),g.preventDefault(),Q(c,a,e.x,e.y,g.shiftKey?"backward":"forward"),!0}return!1},d.COMMAND_PRIORITY_HIGH));c.listenersToRemove.add(f.registerCommand(d.FOCUS_COMMAND,()=>a.isSelected(),d.COMMAND_PRIORITY_HIGH));
c.listenersToRemove.add(f.registerCommand(d.SELECTION_CHANGE_COMMAND,()=>{let g=d.$getSelection();var e=d.$getPreviousSelection();if(g&&d.$isRangeSelection(g)&&!g.isCollapsed()){var k=g.anchor.getNode(),m=g.focus.getNode();k=a.isParentOf(k);var v=a.isParentOf(m);m=k&&!v||v&&!k;k=k&&v&&!a.isSelected();if(m)return e=g.isBackward(),k=d.$createRangeSelection(),m=a.getKey(),k.anchor.set(g.anchor.key,g.anchor.offset,g.anchor.type),k.focus.set(m,e?0:a.getChildrenSize(),"element"),p=!0,d.$setSelection(k),
ca(f,c),!0;if(k&&({grid:k}=c,g.getNodes().filter(C).length===k.rows*k.columns)){k=d.DEPRECATED_$createGridSelection();m=a.getKey();v=a.getFirstChildOrThrow().getFirstChild();let y=a.getLastChildOrThrow().getLastChild();if(null!=v&&null!=y)return k.set(m,v.getKey(),y.getKey()),d.$setSelection(k),c.updateTableGridSelection(k),!0}}if(g&&!g.is(e)&&(d.DEPRECATED_$isGridSelection(g)||d.DEPRECATED_$isGridSelection(e))&&c.gridSelection&&!c.gridSelection.is(e))return d.DEPRECATED_$isGridSelection(g)&&g.gridKey===
c.tableNodeKey?c.updateTableGridSelection(g):!d.DEPRECATED_$isGridSelection(g)&&d.DEPRECATED_$isGridSelection(e)&&e.gridKey===c.tableNodeKey&&c.updateTableGridSelection(null),!1;c.hasHijackedSelectionStyles&&!a.isSelected()?(da(f,c),p=!1):!c.hasHijackedSelectionStyles&&a.isSelected()&&ca(f,c);return!1},d.COMMAND_PRIORITY_CRITICAL));return c};exports.getCellFromTarget=L;exports.getTableSelectionFromTableElement=function(a){return a.__lexicalTableSelection}


/***/ }),

/***/ 2977:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalText =  false ? 0 : __webpack_require__(28263)
module.exports = LexicalText;

/***/ }),

/***/ 28263:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g=__webpack_require__(32998);function r(c,h=!0){if(c)return!1;c=t();h&&(c=c.trim());return""===c}function t(){return g.$getRoot().getTextContent()}function u(c){if(!r(c,!1))return!1;c=g.$getRoot().getChildren();let h=c.length;if(1<h)return!1;for(let e=0;e<h;e++){var b=c[e];if(g.$isDecoratorNode(b))return!1;if(g.$isElementNode(b)){if(!g.$isParagraphNode(b)||0!==b.__indent)return!1;b=b.getChildren();let n=b.length;for(let q=0;q<n;q++)if(!g.$isTextNode(b[e]))return!1}}return!0}
exports.$canShowPlaceholder=u;exports.$canShowPlaceholderCurry=function(c){return()=>u(c)};exports.$findTextIntersectionFromCharacters=function(c,h){var b=c.getFirstChild();c=0;a:for(;null!==b;){if(g.$isElementNode(b)){var e=b.getFirstChild();if(null!==e){b=e;continue}}else if(g.$isTextNode(b)){e=b.getTextContentSize();if(c+e>h)return{node:b,offset:h-c};c+=e}e=b.getNextSibling();if(null!==e)b=e;else{for(b=b.getParent();null!==b;){e=b.getNextSibling();if(null!==e){b=e;continue a}b=b.getParent()}break}}return null};
exports.$isRootTextContentEmpty=r;exports.$isRootTextContentEmptyCurry=function(c,h){return()=>r(c,h)};exports.$rootTextContent=t;
exports.registerLexicalTextEntity=function(c,h,b,e){let n=a=>{const d=g.$createTextNode(a.getTextContent());d.setFormat(a.getFormat());a.replace(d)},q=c.registerNodeTransform(g.TextNode,a=>{if(a.isSimpleText()){var d=a.getPreviousSibling(),l=a.getTextContent(),m=a;if(g.$isTextNode(d)){var k=d.getTextContent(),f=h(k+l);if(d instanceof b){if(null===f||0!==d.getLatest().__mode){n(d);return}f=f.end-k.length;if(0<f){m=l.slice(0,f);m=k+m;d.select();d.setTextContent(m);f===l.length?a.remove():(d=l.slice(f),
a.setTextContent(d));return}}else if(null===f||f.start<k.length)return}for(;;){a=h(l);l=f=null===a?"":l.slice(a.end);if(""===f){if(k=m.getNextSibling(),g.$isTextNode(k))if(f=m.getTextContent()+k.getTextContent(),f=h(f),null===f){k instanceof b?n(k):k.markDirty();break}else if(0!==f.start)break}else if(k=h(f),null!==k&&0===k.start)break;if(null===a)break;if(0===a.start&&g.$isTextNode(d)&&d.isTextEntity())continue;let p;0===a.start?[p,m]=m.splitText(a.end):[,p,m]=m.splitText(a.start,a.end);a=e(p);a.setFormat(p.getFormat());
p.replace(a);if(null==m)break}}});c=c.registerNodeTransform(b,a=>{var d=a.getTextContent();const l=h(d);null===l||0!==l.start?n(a):d.length>l.end?a.splitText(l.end):(d=a.getPreviousSibling(),g.$isTextNode(d)&&d.isTextEntity()&&(n(d),n(a)),d=a.getNextSibling(),g.$isTextNode(d)&&d.isTextEntity()&&(n(d),a instanceof b&&n(a)))});return[q,c]}


/***/ }),

/***/ 76969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const LexicalUtils =  false ? 0 : __webpack_require__(87502)
module.exports = LexicalUtils;

/***/ }),

/***/ 87502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g=__webpack_require__(89408),n=__webpack_require__(32998);function p(a,b){for(let c of b)if(a.type.startsWith(c))return!0;return!1}function q(a,b){for(;a!==n.$getRoot()&&null!=a;){if(b(a))return a;a=a.getParent()}return null}function t(a){return 1===a.nodeType}exports.$splitNode=n.$splitNode;
exports.$dfs=function(a,b){let c=[];a=(a||n.$getRoot()).getLatest();b=b||(n.$isElementNode(a)?a.getLastDescendant():a);for(var f=a,d=0;null!==(f=f.getParent());)d++;for(f=d;null!==a&&!a.is(b);)if(c.push({depth:f,node:a}),n.$isElementNode(a)&&0<a.getChildrenSize())a=a.getFirstChild(),f++;else for(d=null;null===d&&null!==a;)d=a.getNextSibling(),null===d?(a=a.getParent(),f--):a=d;null!==a&&a.is(b)&&c.push({depth:f,node:a});return c};exports.$findMatchingParent=q;
exports.$getNearestBlockElementAncestorOrThrow=function(a){a=q(a,b=>n.$isElementNode(b)&&!b.isInline());if(!n.$isElementNode(a))throw Error("Minified Lexical error #4; visit https://lexical.dev/docs/error?code=4 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");return a};exports.$getNearestNodeOfType=function(a,b){for(;null!=a;){if(a instanceof b)return a;a=a.getParent()}return null};
exports.$insertNodeToNearestRoot=function(a){var b=n.$getSelection();if(n.$isRangeSelection(b)){var {focus:c}=b;b=c.getNode();c=c.offset;if(n.$isRootOrShadowRoot(b))c=b.getChildAtIndex(c),null==c?b.append(a):c.insertBefore(a),a.selectNext();else{let f,d;n.$isTextNode(b)?(f=b.getParentOrThrow(),d=b.getIndexWithinParent(),0<c&&(d+=1,b.splitText(c))):(f=b,d=c);[,b]=n.$splitNode(f,d);b.insertBefore(a);b.selectStart()}}else n.$isNodeSelection(b)||n.DEPRECATED_$isGridSelection(b)?(b=b.getNodes(),b[b.length-
1].getTopLevelElementOrThrow().insertAfter(a)):n.$getRoot().append(a),b=n.$createParagraphNode(),a.insertAfter(b),b.select();return a.getLatest()};exports.$restoreEditorState=function(a,b){let c=new Map,f=a._pendingEditorState;for(let [d,e]of b._nodeMap){let h=g.$cloneWithProperties(e);n.$isTextNode(h)&&(h.__text=e.__text);c.set(d,h)}f&&(f._nodeMap=c);a._dirtyType=2;a=b._selection;n.$setSelection(null===a?null:a.clone())};exports.$wrapNodeInElement=function(a,b){b=b();a.replace(b);b.append(a);return b};
exports.addClassNamesToElement=function(a,...b){b.forEach(c=>{"string"===typeof c&&(c=c.split(" ").filter(f=>""!==f),a.classList.add(...c))})};exports.isHTMLAnchorElement=function(a){return t(a)&&"A"===a.tagName};exports.isHTMLElement=t;exports.isMimeType=p;
exports.mediaFileReader=function(a,b){let c=a[Symbol.iterator]();return new Promise((f,d)=>{let e=[],h=()=>{const {done:m,value:k}=c.next();if(m)return f(e);const l=new FileReader;l.addEventListener("error",d);l.addEventListener("load",()=>{const r=l.result;"string"===typeof r&&e.push({file:k,result:r});h()});p(k,b)?l.readAsDataURL(k):h()};h()})};exports.mergeRegister=function(...a){return()=>{a.forEach(b=>b())}};
exports.registerNestedElementResolver=function(a,b,c,f){return a.registerNodeTransform(b,d=>{a:{var e=d.getChildren();for(var h=0;h<e.length;h++)if(e[h]instanceof b){e=null;break a}for(e=d;null!==e;)if(h=e,e=e.getParent(),e instanceof b){e={child:h,parent:e};break a}e=null}if(null!==e){const {child:m,parent:k}=e;if(m.is(d)){f(k,d);d=m.getNextSiblings();e=d.length;k.insertAfter(m);if(0!==e){h=c(k);m.insertAfter(h);for(let l=0;l<e;l++)h.append(d[l])}k.canBeEmpty()||0!==k.getChildrenSize()||k.remove()}}})};
exports.removeClassNamesFromElement=function(a,...b){b.forEach(c=>{"string"===typeof c&&a.classList.remove(...c.split(" "))})}


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 54098:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 86559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ defaultLocale; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);

/***/ }),

/***/ 84314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 97621:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["Z"] = (longFormatters);

/***/ }),

/***/ 24262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 33276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCISOWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66979);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59025);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84314);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ isProtectedWeekYearToken; },
/* harmony export */   "Iu": function() { return /* binding */ isProtectedDayOfYearToken; },
/* harmony export */   "qp": function() { return /* binding */ throwProtectedError; }
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 66979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCISOWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 59025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 83946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 29422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ add; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77349);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11640);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);






/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(dirtyDate, duration) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  if (!duration || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(duration.years) : 0;
  var months = duration.months ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(duration.weeks) : 0;
  var days = duration.days ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(duration.days) : 0;
  var hours = duration.hours ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(duration.seconds) : 0;

  // Add years and months
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var dateWithMonths = months || years ? (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_4__["default"])(date, months + years * 12) : date;

  // Add weeks and days
  var dateWithDays = days || weeks ? (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_5__["default"])(dateWithMonths, days + weeks * 7) : dateWithMonths;

  // Add days, hours, minutes and seconds
  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}

/***/ }),

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 78343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_HOUR = 3600000;

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 51820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMilliseconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 58545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_MINUTE = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),

/***/ 11640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 8791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addQuarters; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var months = amount * 3;
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, months);
}

/***/ }),

/***/ 63500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addWeeks; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var days = amount * 7;
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, days);
}

/***/ }),

/***/ 21593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, amount * 12);
}

/***/ }),

/***/ 36948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qk": function() { return /* binding */ millisecondsInSecond; },
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
var daysInYear = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
var minTime = -maxTime;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
var secondsInHour = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
var secondsInDay = secondsInHour * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
var secondsInWeek = secondsInDay * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
var secondsInYear = secondsInDay * daysInYear;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
var secondsInMonth = secondsInYear / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 92300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24262);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 84129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarMonths; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),

/***/ 91857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarYears; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/***/ }),

/***/ 83894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 4135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 67090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfWeek; }
/* harmony export */ });
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 10876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 42298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(86559);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate["default"])(dirtyDate);
  if (!(0,isValid["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 55855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getDate; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),

/***/ 20466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),

/***/ 85817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getHours; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),

/***/ 90259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ getISOWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(584);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,startOfWeek["default"])(dirtyDate, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 39159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getMinutes; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),

/***/ 78966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),

/***/ 56605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getQuarter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),

/***/ 77881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getSeconds; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),

/***/ 28789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getTime; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),

/***/ 95570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getFullYear();
}

/***/ }),

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isBefore; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),

/***/ 71381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return value instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),

/***/ 96843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isEqual; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(dirtyLeftDate, dirtyRightDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyLeftDate);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),

/***/ 3151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 49160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),

/***/ 86117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameQuarter; }
/* harmony export */ });
/* harmony import */ var _startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94431);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),

/***/ 60792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),

/***/ 12274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isValid; }
/* harmony export */ });
/* harmony import */ var _isDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71381);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  if (!(0,_isDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 24257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isWithinInterval; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var time = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var startTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.start).getTime();
  var endTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}

/***/ }),

/***/ 99890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ max; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 37950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ min; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;
    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 91518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ parse; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(86559);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(91218);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(89611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && ((0,esm_typeof/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Setter.js






var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/Parser.js




var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js







var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 140);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * constants/* millisecondsInHour */.vh + minutes * constants/* millisecondsInMinute */.yJ + seconds * constants/* millisecondsInSecond */.qk),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js








// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js










// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0,startOfUTCWeek/* default */.Z)(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js








 // ISO week-numbering year
var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js








var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js








var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js








var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js









var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js









var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js










 // Local week of year
var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js










 // ISO week of year
var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js









var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js









var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate["default"])(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js







 // Day of week
var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js








 // Local day of week
var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js








 // Stand-alone local day of week
var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = (0,toDate["default"])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js








 // ISO day of week
var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js








var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js








var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js







 // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js









var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js









var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js









var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js









var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js









var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 60);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js









var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 50);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js








var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 30);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js








 // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js








 // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js








var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 40);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js








var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 20);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parse/index.js













 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate["default"])(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters/* default */.Z) {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        // Replace two single quote characters with one single quote character
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        }

        // Cut token from string, or, if string doesn't match the token, return Invalid Date
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if ((0,esm_typeof/* default */.Z)(_ret) === "object") return _ret.v;
    }

    // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate["default"])(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      // Result is tuple (date, flags)
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]);
        // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 23855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36948);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var additionalDigits = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 92311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ set; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19013);
/* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16218);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);





/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set(dirtyDate, values) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = (0,_setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, values.month);
  }
  if (values.date != null) {
    date.setDate((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.date));
  }
  if (values.hours != null) {
    date.setHours((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds((0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values.milliseconds));
  }
  return date;
}

/***/ }),

/***/ 37042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(dirtyDate, dirtyHours) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),

/***/ 4543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(dirtyDate, dirtyMinutes) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),

/***/ 16218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ setMonth; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var month = (0,toInteger/* default */.Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),

/***/ 11503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setQuarter; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16218);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(dirtyDate, dirtyQuarter) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return (0,_setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, date.getMonth() + diff * 3);
}

/***/ }),

/***/ 39880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setSeconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(dirtyDate, dirtySeconds) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),

/***/ 44749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setYear; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}

/***/ }),

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 43703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 94431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfQuarter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 38148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var cleanDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subDays; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 91218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subMilliseconds; }
/* harmony export */ });
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51820);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 54559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11640);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 58793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subQuarters; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addQuarters_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8791);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addQuarters_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 77982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subWeeks; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63500);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 59319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);
/* harmony import */ var _addYears_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21593);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addYears_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 284:
/***/ (function(module) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Fallback to standard globalThis if available
	if (typeof globalThis === "object" && globalThis) return globalThis;

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of updates to Object.prototype being restricted
		// via preventExtensions, seal or freeze
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ works, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),

/***/ 62991:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 92806:
/***/ (function(module) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 32998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

const Lexical =  false ? 0 : __webpack_require__(34556)
module.exports = Lexical;

/***/ }),

/***/ 34556:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let ca={},da={},ea={},fa={},ja={},ka={},la={},ma={},oa={},ra={},sa={},ta={},ua={},va={},xa={},ya={},za={},Aa={},Ba={},Ca={},Da={},Ga={},Ha={},Ia={},Ja={},Ka={},La={},Ma={},Na={},Oa={},Pa={},Qa={},Ra={},Sa={},Ta={};function q(a){throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?code=${a} for the full message or `+"use the non-minified dev environment for full errors and additional helpful warnings.");}
let Ua="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement,Va=Ua&&"documentMode"in document?document.documentMode:null,t=Ua&&/Mac|iPod|iPhone|iPad/.test(navigator.platform),Wa=Ua&&/^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent),Xa=Ua&&"InputEvent"in window&&!Va?"getTargetRanges"in new window.InputEvent("input"):!1,Ya=Ua&&/Version\/[\d.]+.*Safari/.test(navigator.userAgent),Za=Ua&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&
!window.MSStream,$a=Ua&&/^(?=.*Chrome).*/i.test(navigator.userAgent),ab=Ua&&/AppleWebKit\/[\d.]+/.test(navigator.userAgent)&&!$a,bb=Ya||Za||ab?"\u00a0":"\u200b",cb=Wa?"\u00a0":bb,db=/^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/,eb=/^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/,
fb={bold:1,code:16,highlight:128,italic:2,strikethrough:4,subscript:32,superscript:64,underline:8},gb={directionless:1,unmergeable:2},hb={center:2,end:6,justify:4,left:1,right:3,start:5},ib={2:"center",6:"end",4:"justify",1:"left",3:"right",5:"start"},jb={normal:0,segmented:2,token:1},kb={0:"normal",2:"segmented",1:"token"},ob=!1,pb=0;function qb(a){pb=a.timeStamp}function rb(a,b,c){return b.__lexicalLineBreak===a||void 0!==a[`__lexicalKey_${c._key}`]}
function sb(a){return a.getEditorState().read(()=>{let b=v();return null!==b?b.clone():null})}
function tb(a,b,c){ob=!0;let d=100<performance.now()-pb;try{w(a,()=>{let e=v()||sb(a);var f=new Map,g=a.getRootElement(),h=a._editorState,k=a._blockCursorElement;let n=!1,m="";for(var p=0;p<b.length;p++){var l=b[p],r=l.type,u=l.target,x=ub(u,h);if(!(null===x&&u!==g||z(x)))if("characterData"===r){if(l=d&&B(x))a:{l=e;r=u;var y=x;if(C(l)){var A=l.anchor.getNode();if(A.is(y)&&l.format!==A.getFormat()){l=!1;break a}}l=3===r.nodeType&&y.isAttached()}l&&(y=E(a._window),r=l=null,null!==y&&y.anchorNode===
u&&(l=y.anchorOffset,r=y.focusOffset),u=u.nodeValue,null!==u&&vb(x,u,l,r,!1))}else if("childList"===r){n=!0;r=l.addedNodes;for(y=0;y<r.length;y++){A=r[y];var aa=wb(A),ba=A.parentNode;null==ba||A===k||null!==aa||"BR"===A.nodeName&&rb(A,ba,a)||(Wa&&(aa=A.innerText||A.nodeValue)&&(m+=aa),ba.removeChild(A))}l=l.removedNodes;r=l.length;if(0<r){y=0;for(A=0;A<r;A++)if(ba=l[A],"BR"===ba.nodeName&&rb(ba,u,a)||k===ba)u.appendChild(ba),y++;r!==y&&(u===g&&(x=h._nodeMap.get("root")),f.set(u,x))}}}if(0<f.size)for(let [pa,
qa]of f)if(F(qa))for(f=qa.getChildrenKeys(),g=pa.firstChild,h=0;h<f.length;h++)k=a.getElementByKey(f[h]),null!==k&&(null==g?(pa.appendChild(k),g=k):g!==k&&pa.replaceChild(k,g),g=g.nextSibling);else B(qa)&&qa.markDirty();f=c.takeRecords();if(0<f.length){for(g=0;g<f.length;g++)for(k=f[g],h=k.addedNodes,k=k.target,p=0;p<h.length;p++)x=h[p],u=x.parentNode,null==u||"BR"!==x.nodeName||rb(x,k,a)||u.removeChild(x);c.takeRecords()}null!==e&&(n&&(e.dirty=!0,xb(e)),Wa&&yb(a)&&e.insertRawText(m))})}finally{ob=
!1}}function zb(a){let b=a._observer;if(null!==b){let c=b.takeRecords();tb(a,c,b)}}function Ab(a){0===pb&&Bb(a).addEventListener("textInput",qb,!0);a._observer=new MutationObserver((b,c)=>{tb(a,b,c)})}let Cb=1,Db="function"===typeof queueMicrotask?queueMicrotask:a=>{Promise.resolve().then(a)};function Eb(a){let b=document.activeElement;if(null===b)return!1;let c=b.nodeName;return z(ub(a))&&("INPUT"===c||"TEXTAREA"===c||"true"===b.contentEditable&&null==b.__lexicalEditor)}
function Fb(a,b,c){let d=a.getRootElement();try{return null!==d&&d.contains(b)&&d.contains(c)&&null!==b&&!Eb(b)&&Gb(b)===a}catch(e){return!1}}function Gb(a){for(;null!=a;){let b=a.__lexicalEditor;if(null!=b)return b;a=Hb(a)}return null}function Ib(a){return a.isToken()||a.isSegmented()}function Jb(a){for(;null!=a;){if(3===a.nodeType)return a;a=a.firstChild}return null}function Kb(a,b,c){b=fb[b];return a&b&&(null===c||0===(c&b))?a^b:null===c||c&b?a|b:a}function Lb(a){return B(a)||Sb(a)||z(a)}
function Tb(a,b){if(null!=b)a.__key=b;else{G();99<Ub&&q(14);b=H();var c=Vb(),d=""+Cb++;c._nodeMap.set(d,a);F(a)?b._dirtyElements.set(d,!0):b._dirtyLeaves.add(d);b._cloneNotNeeded.add(d);b._dirtyType=1;a.__key=d}}
function Wb(a){var b=a.getParent();if(null!==b){let e=a.getWritable();b=b.getWritable();var c=a.getPreviousSibling();a=a.getNextSibling();if(null===c)if(null!==a){var d=a.getWritable();b.__first=a.__key;d.__prev=null}else b.__first=null;else{d=c.getWritable();if(null!==a){let f=a.getWritable();f.__prev=d.__key;d.__next=f.__key}else d.__next=null;e.__prev=null}null===a?null!==c?(a=c.getWritable(),b.__last=c.__key,a.__next=null):b.__last=null:(a=a.getWritable(),null!==c?(c=c.getWritable(),c.__next=
a.__key,a.__prev=c.__key):a.__prev=null,e.__next=null);b.__size--;e.__parent=null}}function Xb(a){99<Ub&&q(14);var b=a.getLatest(),c=b.__parent,d=Vb();let e=H(),f=d._nodeMap;d=e._dirtyElements;if(null!==c)a:for(;null!==c;){if(d.has(c))break a;let g=f.get(c);if(void 0===g)break;d.set(c,!1);c=g.__parent}b=b.__key;e._dirtyType=1;F(a)?d.set(b,!0):e._dirtyLeaves.add(b)}
function I(a){G();var b=H();let c=b._compositionKey;a!==c&&(b._compositionKey=a,null!==c&&(b=J(c),null!==b&&b.getWritable()),null!==a&&(a=J(a),null!==a&&a.getWritable()))}function Yb(){return Zb()?null:H()._compositionKey}function J(a,b){a=(b||Vb())._nodeMap.get(a);return void 0===a?null:a}function wb(a,b){let c=H();a=a[`__lexicalKey_${c._key}`];return void 0!==a?J(a,b):null}function ub(a,b){for(;null!=a;){let c=wb(a,b);if(null!==c)return c;a=Hb(a)}return null}
function $b(a){let b=Object.assign({},a._decorators);return a._pendingDecorators=b}function ac(a){return a.read(()=>bc().getTextContent())}function cc(a,b){w(a,()=>{var c=Vb();if(!c.isEmpty())if("root"===b)bc().markDirty();else{c=c._nodeMap;for(let [,d]of c)d.markDirty()}},null===a._pendingEditorState?{tag:"history-merge"}:void 0)}function bc(){return Vb()._nodeMap.get("root")}function xb(a){G();let b=Vb();null!==a&&(a.dirty=!0,a._cachedNodes=null);b._selection=a}
function dc(a){var b=H(),c;a:{for(c=a;null!=c;){let d=c[`__lexicalKey_${b._key}`];if(void 0!==d){c=d;break a}c=Hb(c)}c=null}return null===c?(b=b.getRootElement(),a===b?J("root"):null):J(c)}function ec(a){return/[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(a)}function fc(a){let b=[];for(;null!==a;)b.push(a),a=a._parentEditor;return b}function gc(){return Math.random().toString(36).replace(/[^a-z]+/g,"").substr(0,5)}
function hc(a,b,c){b=E(b._window);if(null!==b){var d=b.anchorNode,{anchorOffset:e,focusOffset:f}=b;if(null!==d&&(b=3===d.nodeType?d.nodeValue:null,d=ub(d),null!==b&&B(d))){if(b===bb&&c){let g=c.length;b=c;f=e=g}null!==b&&vb(d,b,e,f,a)}}}
function vb(a,b,c,d,e){let f=a;if(f.isAttached()&&(e||!f.isDirty())){var g=f.isComposing();a=b;(g||e)&&b[b.length-1]===bb&&(a=b.slice(0,-1));b=f.getTextContent();if(e||a!==b)if(""===a)if(I(null),Ya||Za||ab)f.remove();else{let n=H();setTimeout(()=>{n.update(()=>{f.isAttached()&&f.remove()})},20)}else{e=f.getParent();b=ic();var h=Yb(),k=f.getKey();f.isToken()||null!==h&&k===h&&!g||null!==e&&C(b)&&!e.canInsertTextBefore()&&0===b.anchor.offset?f.markDirty():(g=v(),C(g)&&null!==c&&null!==d&&(g.setTextNodeRange(f,
c,f,d),f.isSegmented()&&(c=f.getTextContent(),c=K(c),f.replace(c),f=c)),f.setTextContent(a))}}}function jc(a,b){if(b.isSegmented())return!0;if(!a.isCollapsed())return!1;a=a.anchor.offset;let c=b.getParentOrThrow(),d=b.isToken();return 0===a?((a=!b.canInsertTextBefore()||!c.canInsertTextBefore()||d)||(b=b.getPreviousSibling(),a=(B(b)||F(b)&&b.isInline())&&!b.canInsertTextAfter()),a):a===b.getTextContentSize()?!b.canInsertTextAfter()||!c.canInsertTextAfter()||d:!1}
function kc(a,b){var c=a[b];return"string"===typeof c?(c=c.split(" "),a[b]=c):c}function lc(a,b,c,d,e){0!==c.size&&(c=d.__key,b=b.get(d.__type),void 0===b&&q(33),d=b.klass,b=a.get(d),void 0===b&&(b=new Map,a.set(d,b)),a=b.get(c),d="destroyed"===a&&"created"===e,(void 0===a||d)&&b.set(c,d?"updated":e))}function mc(a,b,c){let d=a.getParent(),e=c;null!==d&&(b&&0===c?(e=a.getIndexWithinParent(),a=d):b||c!==a.getChildrenSize()||(e=a.getIndexWithinParent()+1,a=d));return a.getChildAtIndex(b?e-1:e)}
function nc(a,b){var c=a.offset;if("element"===a.type)return a=a.getNode(),mc(a,b,c);a=a.getNode();return b&&0===c||!b&&c===a.getTextContentSize()?(c=b?a.getPreviousSibling():a.getNextSibling(),null===c?mc(a.getParentOrThrow(),b,a.getIndexWithinParent()+(b?0:1)):c):null}function yb(a){a=(a=Bb(a).event)&&a.inputType;return"insertFromPaste"===a||"insertFromPasteAsQuotation"===a}function oc(a){return!L(a)&&!a.isLastChild()&&!a.isInline()}
function pc(a,b){a=a._keyToDOMMap.get(b);void 0===a&&q(75);return a}function Hb(a){a=a.assignedSlot||a.parentElement;return null!==a&&11===a.nodeType?a.host:a}function qc(a,b=0){0!==b&&q(1);b=v();if(!C(b)||!F(a))return b;let {anchor:c,focus:d}=b,e=c.getNode(),f=d.getNode();rc(e,a)&&c.set(a.__key,0,"element");rc(f,a)&&d.set(a.__key,0,"element");return b}function rc(a,b){for(a=a.getParent();null!==a;){if(a.is(b))return!0;a=a.getParent()}return!1}function Bb(a){a=a._window;null===a&&q(78);return a}
function sc(a){for(a=a.getParentOrThrow();null!==a&&!M(a);)a=a.getParentOrThrow();return a}function M(a){return L(a)||F(a)&&a.isShadowRoot()}function tc(a){a=a.constructor.clone(a);Tb(a,null);return a}function uc(a){var b=H();let c=a.constructor.getType();b=b._nodes.get(c);void 0===b&&q(97);b=b.replace;return null!==b?(b=b(a),b instanceof a.constructor||q(98),b):a}function vc(a,b){a=a.getParent();!L(a)||F(b)||z(b)||q(99)}function wc(a){return(z(a)||F(a)&&!a.canBeEmpty())&&!a.isInline()}
function xc(a,b,c){c.style.removeProperty("caret-color");b._blockCursorElement=null;b=a.parentElement;null!==b&&b.removeChild(a)}function E(a){return Ua?(a||window).getSelection():null}function yc(a,b){let c=a.getChildAtIndex(b);null==c&&(c=a);M(a)&&q(102);let d=g=>{const h=g.getParentOrThrow(),k=M(h),n=g!==c||k?tc(g):g;if(k)return g.insertAfter(n),[g,n,n];const [m,p,l]=d(h);g=g.getNextSiblings();l.append(n,...g);return[m,p,n]},[e,f]=d(c);return[e,f]}
function zc(a,b){for(;a!==bc()&&null!=a;){if(b(a))return a;a=a.getParent()}return null}function Ac(a){let b=[],c=[a];for(;0<c.length;){let d=c.pop();void 0===d&&q(112);F(d)&&c.unshift(...d.getChildren());d!==a&&b.push(d)}return b}function Bc(a,b,c,d,e,f){for(a=a.getFirstChild();null!==a;){let g=a.__key;a.__parent===b&&(F(a)&&Bc(a,g,c,d,e,f),c.has(g)||f.delete(g),e.push(g));a=a.getNextSibling()}}
function Cc(a,b,c,d){a=a._nodeMap;b=b._nodeMap;let e=[];for(let [f]of d){let g=b.get(f);void 0===g||g.isAttached()||(F(g)&&Bc(g,f,a,b,e,d),a.has(f)||d.delete(f),e.push(f))}for(let f of e)b.delete(f);for(let f of c)d=b.get(f),void 0===d||d.isAttached()||(a.has(f)||c.delete(f),b.delete(f))}function Dc(a,b){let c=a.__mode,d=a.__format;a=a.__style;let e=b.__mode,f=b.__format;b=b.__style;return(null===c||c===e)&&(null===d||d===f)&&(null===a||a===b)}
function Ec(a,b){let c=a.mergeWithSibling(b),d=H()._normalizedNodes;d.add(a.__key);d.add(b.__key);return c}function Fc(a){if(""===a.__text&&a.isSimpleText()&&!a.isUnmergeable())a.remove();else{for(var b;null!==(b=a.getPreviousSibling())&&B(b)&&b.isSimpleText()&&!b.isUnmergeable();)if(""===b.__text)b.remove();else{Dc(b,a)&&(a=Ec(b,a));break}for(var c;null!==(c=a.getNextSibling())&&B(c)&&c.isSimpleText()&&!c.isUnmergeable();)if(""===c.__text)c.remove();else{Dc(a,c)&&Ec(a,c);break}}}
function Gc(a){Hc(a.anchor);Hc(a.focus);return a}function Hc(a){for(;"element"===a.type;){var b=a.getNode(),c=a.offset;c===b.getChildrenSize()?(b=b.getChildAtIndex(c-1),c=!0):(b=b.getChildAtIndex(c),c=!1);if(B(b)){a.set(b.__key,c?b.getTextContentSize():0,"text");break}else if(!F(b))break;a.set(b.__key,c?b.getChildrenSize():0,"element")}}let N="",O="",Ic="",Jc,R,Kc,Lc=!1,Mc=!1,Nc,Oc=null,Pc,Qc,Zc,$c,ad,bd;
function cd(a,b){let c=Zc.get(a);if(null!==b){let d=dd(a);d.parentNode===b&&b.removeChild(d)}$c.has(a)||R._keyToDOMMap.delete(a);F(c)&&(a=ed(c,Zc),fd(a,0,a.length-1,null));void 0!==c&&lc(bd,Kc,Nc,c,"destroyed")}function fd(a,b,c,d){for(;b<=c;++b){let e=a[b];void 0!==e&&cd(e,d)}}function gd(a,b){a.setProperty("text-align",b)}
function hd(a,b){var c=Jc.theme.indent;if("string"===typeof c){let d=a.classList.contains(c);0<b&&!d?a.classList.add(c):1>b&&d&&a.classList.remove(c)}c=getComputedStyle(a).getPropertyValue("--lexical-indent-base-value")||"40px";a.style.setProperty("padding-inline-start",0===b?"":`calc(${b} * ${c})`)}function id(a,b){a=a.style;0===b?gd(a,""):1===b?gd(a,"left"):2===b?gd(a,"center"):3===b?gd(a,"right"):4===b?gd(a,"justify"):5===b?gd(a,"start"):6===b&&gd(a,"end")}
function jd(a,b,c){let d=$c.get(a);void 0===d&&q(60);let e=d.createDOM(Jc,R);var f=R._keyToDOMMap;e["__lexicalKey_"+R._key]=a;f.set(a,e);B(d)?e.setAttribute("data-lexical-text","true"):z(d)&&e.setAttribute("data-lexical-decorator","true");if(F(d)){a=d.__indent;f=d.__size;0!==a&&hd(e,a);if(0!==f){--f;a=ed(d,$c);var g=O;O="";kd(a,d,0,f,e,null);ld(d,e);O=g}a=d.__format;0!==a&&id(e,a);d.isInline()||md(null,d,e);oc(d)&&(N+="\n\n",Ic+="\n\n")}else f=d.getTextContent(),z(d)?(g=d.decorate(R,Jc),null!==g&&
nd(a,g),e.contentEditable="false"):B(d)&&(d.isDirectionless()||(O+=f)),N+=f,Ic+=f;null!==b&&(null!=c?b.insertBefore(e,c):(c=b.__lexicalLineBreak,null!=c?b.insertBefore(e,c):b.appendChild(e)));lc(bd,Kc,Nc,d,"created");return e}function kd(a,b,c,d,e,f){let g=N;for(N="";c<=d;++c)jd(a[c],e,f);oc(b)&&(N+="\n\n");e.__lexicalTextContent=N;N=g+N}function od(a,b){a=b.get(a);return Sb(a)||z(a)&&a.isInline()}
function md(a,b,c){a=null!==a&&(0===a.__size||od(a.__last,Zc));b=0===b.__size||od(b.__last,$c);a?b||(b=c.__lexicalLineBreak,null!=b&&c.removeChild(b),c.__lexicalLineBreak=null):b&&(b=document.createElement("br"),c.__lexicalLineBreak=b,c.appendChild(b))}
function ld(a,b){var c=b.__lexicalDir;if(b.__lexicalDirTextContent!==O||c!==Oc){let f=""===O;if(f)var d=Oc;else d=O,d=db.test(d)?"rtl":eb.test(d)?"ltr":null;if(d!==c){let g=b.classList,h=Jc.theme;var e=null!==c?h[c]:void 0;let k=null!==d?h[d]:void 0;void 0!==e&&("string"===typeof e&&(e=e.split(" "),e=h[c]=e),g.remove(...e));null===d||f&&"ltr"===d?b.removeAttribute("dir"):(void 0!==k&&("string"===typeof k&&(c=k.split(" "),k=h[d]=c),void 0!==k&&g.add(...k)),b.dir=d);Mc||(a.getWritable().__dir=d)}Oc=
d;b.__lexicalDirTextContent=O;b.__lexicalDir=d}}function ed(a,b){let c=[];for(a=a.__first;null!==a;){let d=b.get(a);void 0===d&&q(101);c.push(a);a=d.__next}return c}
function pd(a,b){var c=Zc.get(a),d=$c.get(a);void 0!==c&&void 0!==d||q(61);var e=Lc||Qc.has(a)||Pc.has(a);let f=pc(R,a);if(c===d&&!e)return F(c)?(d=f.__lexicalTextContent,void 0!==d&&(N+=d,Ic+=d),d=f.__lexicalDirTextContent,void 0!==d&&(O+=d)):(d=c.getTextContent(),B(c)&&!c.isDirectionless()&&(O+=d),Ic+=d,N+=d),f;c!==d&&e&&lc(bd,Kc,Nc,d,"updated");if(d.updateDOM(c,f,Jc))return d=jd(a,null,null),null===b&&q(62),b.replaceChild(d,f),cd(a,null),d;if(F(c)&&F(d)){a=d.__indent;a!==c.__indent&&hd(f,a);a=
d.__format;a!==c.__format&&id(f,a);if(e){a=d;e=O;O="";b=N;var g=c.__size,h=a.__size;N="";if(1===g&&1===h){var k=c.__first,n=a.__first;if(k===n)pd(k,f);else{var m=dd(k);n=jd(n,null,null);f.replaceChild(n,m);cd(k,null)}}else{n=ed(c,Zc);var p=ed(a,$c);if(0===g)0!==h&&kd(p,a,0,h-1,f,null);else if(0===h)0!==g&&(k=null==f.__lexicalLineBreak,fd(n,0,g-1,k?null:f),k&&(f.textContent=""));else{var l=n;n=p;p=g-1;g=h-1;let u=f.firstChild,x=0;for(h=0;x<=p&&h<=g;){var r=l[x];let y=n[h];if(r===y)u=qd(pd(y,f)),x++,
h++;else{void 0===k&&(k=new Set(l));void 0===m&&(m=new Set(n));let A=m.has(r),aa=k.has(y);A?(aa?(r=pc(R,y),r===u?u=qd(pd(y,f)):(null!=u?f.insertBefore(r,u):f.appendChild(r),pd(y,f)),x++):jd(y,f,u),h++):(u=qd(dd(r)),cd(r,f),x++)}}k=x>p;m=h>g;k&&!m?(k=n[g+1],k=void 0===k?null:R.getElementByKey(k),kd(n,a,h,g,f,k)):m&&!k&&fd(l,x,p,f)}}oc(a)&&(N+="\n\n");f.__lexicalTextContent=N;N=b+N;ld(a,f);O=e;L(d)||d.isInline()||md(c,d,f)}oc(d)&&(N+="\n\n",Ic+="\n\n")}else c=d.getTextContent(),z(d)?(e=d.decorate(R,
Jc),null!==e&&nd(a,e)):B(d)&&!d.isDirectionless()&&(O+=c),N+=c,Ic+=c;!Mc&&L(d)&&d.__cachedText!==Ic&&(d=d.getWritable(),d.__cachedText=Ic);return f}function nd(a,b){let c=R._pendingDecorators,d=R._decorators;if(null===c){if(d[a]===b)return;c=$b(R)}c[a]=b}function qd(a){a=a.nextSibling;null!==a&&a===R._blockCursorElement&&(a=a.nextSibling);return a}function dd(a){a=ad.get(a);void 0===a&&q(75);return a}
let rd=Object.freeze({}),yd=[["keydown",sd],["pointerdown",td],["compositionstart",ud],["compositionend",vd],["input",wd],["click",xd],["cut",rd],["copy",rd],["dragstart",rd],["dragover",rd],["dragend",rd],["paste",rd],["focus",rd],["blur",rd],["drop",rd]];Xa&&yd.push(["beforeinput",(a,b)=>zd(a,b)]);let Ad=0,Bd=0,Cd=0,Dd=null,Ed=0,Fd=!1,Gd=!1,Hd=!1,Id=!1,Jd=[0,"",0,"root",0];
function Kd(a,b,c,d,e){let f=a.anchor,g=a.focus,h=f.getNode();var k=H();let n=E(k._window),m=null!==n?n.anchorNode:null,p=f.key;k=k.getElementByKey(p);let l=c.length;return p!==g.key||!B(h)||(!e&&(!Xa||Cd<d+50)||h.isDirty()&&2>l||ec(c))&&f.offset!==g.offset&&!h.isComposing()||Ib(h)||h.isDirty()&&1<l||(e||!Xa)&&null!==k&&!h.isComposing()&&m!==Jb(k)||null!==n&&null!==b&&(!b.collapsed||b.startContainer!==n.anchorNode||b.startOffset!==n.anchorOffset)||h.getFormat()!==a.format||h.getStyle()!==a.style||
jc(a,h)}function Ld(a,b){return null!==a&&null!==a.nodeValue&&3===a.nodeType&&0!==b&&b!==a.nodeValue.length}
function Md(a,b,c){let {anchorNode:d,anchorOffset:e,focusNode:f,focusOffset:g}=a;if(Fd&&(Fd=!1,Ld(d,e)&&Ld(f,g)))return;w(b,()=>{if(!c)xb(null);else if(Fb(b,d,f)){var h=v();if(C(h)){var k=h.anchor,n=k.getNode();if(h.isCollapsed()){"Range"===a.type&&a.anchorNode===a.focusNode&&(h.dirty=!0);var m=Bb(b).event;m=m?m.timeStamp:performance.now();let [p,l,r,u,x]=Jd;m<x+200&&k.offset===r&&k.key===u?(h.format=p,h.style=l):"text"===k.type?(h.format=n.getFormat(),h.style=n.getStyle()):"element"===k.type&&(h.format=
0,h.style="")}else{k=255;n=!1;m=h.getNodes();let p=m.length;for(let l=0;l<p;l++){let r=m[l];if(B(r)&&(n=!0,k&=r.getFormat(),0===k))break}h.format=n?k:0}}S(b,ca,void 0)}})}
function xd(a,b){w(b,()=>{let c=v();var d=E(b._window);let e=ic();if(d)if(C(c)){let g=c.anchor;var f=g.getNode();"element"===g.type&&0===g.offset&&c.isCollapsed()&&!L(f)&&1===bc().getChildrenSize()&&f.getTopLevelElementOrThrow().isEmpty()&&null!==e&&c.is(e)?(d.removeAllRanges(),c.dirty=!0):3!==a.detail||c.isCollapsed()||(d=c.focus.getNode(),f!==d&&(F(f)?f.select(0):f.getParentOrThrow().select(0)))}else"touch"===a.pointerType&&(f=d.anchorNode,null!==f&&(f=f.nodeType,1===f||3===f))&&(d=Nd(e,d,b),xb(d));
S(b,da,a)})}function td(a,b){let c=a.target;a=a.pointerType;c instanceof Node&&"touch"!==a&&w(b,()=>{z(ub(c))||(Gd=!0)})}function Od(a){if(!a.getTargetRanges)return null;a=a.getTargetRanges();return 0===a.length?null:a[0]}function Pd(a,b){return a!==b||F(a)||F(b)||!a.isToken()||!b.isToken()}
function zd(a,b){let c=a.inputType,d=Od(a);"deleteCompositionText"===c||Wa&&yb(b)||"insertCompositionText"!==c&&w(b,()=>{let e=v();if("deleteContentBackward"===c){if(null===e){var f=ic();if(!C(f))return;xb(f.clone())}if(C(e)){229===Bd&&a.timeStamp<Ad+30&&b.isComposing()&&e.anchor.key===e.focus.key?(I(null),Ad=0,setTimeout(()=>{w(b,()=>{I(null)})},30),C(e)&&(f=e.anchor.getNode(),f.markDirty(),e.format=f.getFormat(),e.style=f.getStyle())):(a.preventDefault(),S(b,ea,!0));return}}if(C(e)){f=a.data;null!==
Dd&&hc(!1,b,Dd);e.dirty&&null===Dd||!e.isCollapsed()||L(e.anchor.getNode())||null===d||e.applyDOMRange(d);Dd=null;var g=e.focus,h=e.anchor.getNode();g=g.getNode();if("insertText"===c||"insertTranspose"===c)"\n"===f?(a.preventDefault(),S(b,fa,!1)):"\n\n"===f?(a.preventDefault(),S(b,ja,void 0)):null==f&&a.dataTransfer?(f=a.dataTransfer.getData("text/plain"),a.preventDefault(),e.insertRawText(f)):null!=f&&Kd(e,d,f,a.timeStamp,!0)?(a.preventDefault(),S(b,ka,f)):Dd=f,Cd=a.timeStamp;else switch(a.preventDefault(),
c){case "insertFromYank":case "insertFromDrop":case "insertReplacementText":S(b,ka,a);break;case "insertFromComposition":I(null);S(b,ka,a);break;case "insertLineBreak":I(null);S(b,fa,!1);break;case "insertParagraph":I(null);Hd?(Hd=!1,S(b,fa,!1)):S(b,ja,void 0);break;case "insertFromPaste":case "insertFromPasteAsQuotation":S(b,la,a);break;case "deleteByComposition":Pd(h,g)&&S(b,ma,void 0);break;case "deleteByDrag":case "deleteByCut":S(b,ma,void 0);break;case "deleteContent":S(b,ea,!1);break;case "deleteWordBackward":S(b,
oa,!0);break;case "deleteWordForward":S(b,oa,!1);break;case "deleteHardLineBackward":case "deleteSoftLineBackward":S(b,ra,!0);break;case "deleteContentForward":case "deleteHardLineForward":case "deleteSoftLineForward":S(b,ra,!1);break;case "formatStrikeThrough":S(b,sa,"strikethrough");break;case "formatBold":S(b,sa,"bold");break;case "formatItalic":S(b,sa,"italic");break;case "formatUnderline":S(b,sa,"underline");break;case "historyUndo":S(b,ta,void 0);break;case "historyRedo":S(b,ua,void 0)}}})}
function wd(a,b){a.stopPropagation();w(b,()=>{var c=v(),d=a.data,e=Od(a);if(null!=d&&C(c)&&Kd(c,e,d,a.timeStamp,!1)){Id&&(Qd(b,d),Id=!1);var f=c.anchor,g=f.getNode();e=E(b._window);if(null===e)return;let h=f.offset;if(f=Xa&&!c.isCollapsed()&&B(g)&&null!==e.anchorNode)g=g.getTextContent().slice(0,h)+d+g.getTextContent().slice(h+c.focus.offset),e=e.anchorNode,f=g===(3===e.nodeType?e.nodeValue:null);f||S(b,ka,d);d=d.length;Wa&&1<d&&"insertCompositionText"===a.inputType&&!b.isComposing()&&(c.anchor.offset-=
d);Ya||Za||ab||!b.isComposing()||(Ad=0,I(null))}else hc(!1,b,null!==d?d:void 0),Id&&(Qd(b,d||void 0),Id=!1);G();c=H();zb(c)});Dd=null}function ud(a,b){w(b,()=>{let c=v();if(C(c)&&!b.isComposing()){let d=c.anchor,e=c.anchor.getNode();I(d.key);(a.timeStamp<Ad+30||"element"===d.type||!c.isCollapsed()||e.getFormat()!==c.format||e.getStyle()!==c.style)&&S(b,ka,cb)}})}
function Qd(a,b){var c=a._compositionKey;I(null);if(null!==c&&null!=b){if(""===b){b=J(c);a=Jb(a.getElementByKey(c));null!==a&&null!==a.nodeValue&&B(b)&&vb(b,a.nodeValue,null,null,!0);return}if("\n"===b[b.length-1]&&(c=v(),C(c))){b=c.focus;c.anchor.set(b.key,b.offset,b.type);S(a,Da,null);return}}hc(!0,a,b)}function vd(a,b){Wa?Id=!0:w(b,()=>{Qd(b,a.data)})}
function sd(a,b){Ad=a.timeStamp;Bd=a.keyCode;if(!b.isComposing()){var {keyCode:c,shiftKey:d,ctrlKey:e,metaKey:f,altKey:g}=a;if(!S(b,va,a)){if(39!==c||e||f||g)if(39!==c||g||d||!e&&!f)if(37!==c||e||f||g)if(37!==c||g||d||!e&&!f)if(38!==c||e||f)if(40!==c||e||f)if(13===c&&d)Hd=!0,S(b,Da,a);else if(32===c)S(b,Ga,a);else if(t&&e&&79===c)a.preventDefault(),Hd=!0,S(b,fa,!0);else if(13!==c||d)if(t?g||f?0:8===c||72===c&&e:e||g||f?0:8===c)8===c?S(b,Ha,a):(a.preventDefault(),S(b,ea,!0));else if(27===c)S(b,Ia,
a);else if(t?d||g||f?0:46===c||68===c&&e:e||g||f?0:46===c)46===c?S(b,Ja,a):(a.preventDefault(),S(b,ea,!1));else if(8===c&&(t?g:e))a.preventDefault(),S(b,oa,!0);else if(46===c&&(t?g:e))a.preventDefault(),S(b,oa,!1);else if(t&&f&&8===c)a.preventDefault(),S(b,ra,!0);else if(t&&f&&46===c)a.preventDefault(),S(b,ra,!1);else if(66===c&&!g&&(t?f:e))a.preventDefault(),S(b,sa,"bold");else if(85===c&&!g&&(t?f:e))a.preventDefault(),S(b,sa,"underline");else if(73===c&&!g&&(t?f:e))a.preventDefault(),S(b,sa,"italic");
else if(9!==c||g||e||f)if(90===c&&!d&&(t?f:e))a.preventDefault(),S(b,ta,void 0);else{var h=t?90===c&&f&&d:89===c&&e||90===c&&e&&d;h?(a.preventDefault(),S(b,ua,void 0)):Rd(b._editorState._selection)&&(h=d?!1:67===c?t?f:e:!1,h?(a.preventDefault(),S(b,Pa,a)):(h=d?!1:88===c?t?f:e:!1,h?(a.preventDefault(),S(b,Qa,a)):65===c&&(t?f:e)&&(a.preventDefault(),b.update(()=>{let k=bc();k.select(0,k.getChildrenSize())}))))}else S(b,Ka,a);else Hd=!1,S(b,Da,a);else S(b,Ca,a);else S(b,Ba,a);else S(b,Aa,a);else S(b,
za,a);else S(b,ya,a);else S(b,xa,a);(e||d||g||f)&&S(b,Ta,a)}}}function Sd(a){let b=a.__lexicalEventHandles;void 0===b&&(b=[],a.__lexicalEventHandles=b);return b}let Td=new Map;
function Ud(a){a=a.target;let b=E(null==a?null:9===a.nodeType?a.defaultView:a.ownerDocument.defaultView);if(null!==b){var c=Gb(b.anchorNode);if(null!==c){Gd&&(Gd=!1,w(c,()=>{var g=ic(),h=b.anchorNode;null!==h&&(h=h.nodeType,1===h||3===h)&&(g=Nd(g,b,c),xb(g))}));a=fc(c);a=a[a.length-1];var d=a._key,e=Td.get(d),f=e||a;f!==c&&Md(b,f,!1);Md(b,c,!0);c!==a?Td.set(d,c):e&&Td.delete(d)}}}
function Vd(a,b){0===Ed&&a.ownerDocument.addEventListener("selectionchange",Ud);Ed++;a.__lexicalEditor=b;let c=Sd(a);for(let d=0;d<yd.length;d++){let [e,f]=yd[d],g="function"===typeof f?h=>{!0!==h._lexicalHandled&&(h._lexicalHandled=!0,b.isEditable()&&f(h,b))}:h=>{if(!0!==h._lexicalHandled&&(h._lexicalHandled=!0,b.isEditable()))switch(e){case "cut":return S(b,Qa,h);case "copy":return S(b,Pa,h);case "paste":return S(b,la,h);case "dragstart":return S(b,Ma,h);case "dragover":return S(b,Na,h);case "dragend":return S(b,
Oa,h);case "focus":return S(b,Ra,h);case "blur":return S(b,Sa,h);case "drop":return S(b,La,h)}};a.addEventListener(e,g);c.push(()=>{a.removeEventListener(e,g)})}}
function Wd(a,b,c){G();var d=a.__key;let e=a.getParent();if(null!==e){var f=qc(a),g=!1;if(C(f)&&b){let h=f.anchor,k=f.focus;h.key===d&&(Xd(h,a,e,a.getPreviousSibling(),a.getNextSibling()),g=!0);k.key===d&&(Xd(k,a,e,a.getPreviousSibling(),a.getNextSibling()),g=!0)}C(f)&&b&&!g?(d=a.getIndexWithinParent(),Wb(a),Yd(f,e,d,-1)):Wb(a);c||M(e)||e.canBeEmpty()||!e.isEmpty()||Wd(e,b);b&&L(e)&&e.isEmpty()&&e.selectEnd()}}
class Zd{static getType(){q(64)}static clone(){q(65)}constructor(a){this.__type=this.constructor.getType();this.__next=this.__prev=this.__parent=null;Tb(this,a)}getType(){return this.__type}isAttached(){for(var a=this.__key;null!==a;){if("root"===a)return!0;a=J(a);if(null===a)break;a=a.__parent}return!1}isSelected(a){a=a||v();if(null==a)return!1;let b=a.getNodes().some(c=>c.__key===this.__key);return B(this)?b:C(a)&&"element"===a.anchor.type&&"element"===a.focus.type&&a.anchor.key===a.focus.key&&
a.anchor.offset===a.focus.offset?!1:b}getKey(){return this.__key}getIndexWithinParent(){var a=this.getParent();if(null===a)return-1;a=a.getFirstChild();let b=0;for(;null!==a;){if(this.is(a))return b;b++;a=a.getNextSibling()}return-1}getParent(){let a=this.getLatest().__parent;return null===a?null:J(a)}getParentOrThrow(){let a=this.getParent();null===a&&q(66);return a}getTopLevelElement(){let a=this;for(;null!==a;){let b=a.getParent();if(M(b))return a;a=b}return null}getTopLevelElementOrThrow(){let a=
this.getTopLevelElement();null===a&&q(67);return a}getParents(){let a=[],b=this.getParent();for(;null!==b;)a.push(b),b=b.getParent();return a}getParentKeys(){let a=[],b=this.getParent();for(;null!==b;)a.push(b.__key),b=b.getParent();return a}getPreviousSibling(){let a=this.getLatest().__prev;return null===a?null:J(a)}getPreviousSiblings(){let a=[];var b=this.getParent();if(null===b)return a;for(b=b.getFirstChild();null!==b&&!b.is(this);)a.push(b),b=b.getNextSibling();return a}getNextSibling(){let a=
this.getLatest().__next;return null===a?null:J(a)}getNextSiblings(){let a=[],b=this.getNextSibling();for(;null!==b;)a.push(b),b=b.getNextSibling();return a}getCommonAncestor(a){let b=this.getParents();var c=a.getParents();F(this)&&b.unshift(this);F(a)&&c.unshift(a);a=b.length;var d=c.length;if(0===a||0===d||b[a-1]!==c[d-1])return null;c=new Set(c);for(d=0;d<a;d++){let e=b[d];if(c.has(e))return e}return null}is(a){return null==a?!1:this.__key===a.__key}isBefore(a){if(this===a)return!1;if(a.isParentOf(this))return!0;
if(this.isParentOf(a))return!1;var b=this.getCommonAncestor(a);let c=this;for(;;){var d=c.getParentOrThrow();if(d===b){d=c.getIndexWithinParent();break}c=d}for(c=a;;){a=c.getParentOrThrow();if(a===b){b=c.getIndexWithinParent();break}c=a}return d<b}isParentOf(a){let b=this.__key;if(b===a.__key)return!1;for(;null!==a;){if(a.__key===b)return!0;a=a.getParent()}return!1}getNodesBetween(a){let b=this.isBefore(a),c=[],d=new Set;for(var e=this;;){var f=e.__key;d.has(f)||(d.add(f),c.push(e));if(e===a)break;
f=F(e)?b?e.getFirstChild():e.getLastChild():null;if(null!==f)e=f;else if(f=b?e.getNextSibling():e.getPreviousSibling(),null!==f)e=f;else{e=e.getParentOrThrow();d.has(e.__key)||c.push(e);if(e===a)break;f=e;do null===f&&q(68),e=b?f.getNextSibling():f.getPreviousSibling(),f=f.getParent(),null!==f&&(null!==e||d.has(f.__key)||c.push(f));while(null===e)}}b||c.reverse();return c}isDirty(){let a=H()._dirtyLeaves;return null!==a&&a.has(this.__key)}getLatest(){let a=J(this.__key);null===a&&q(113);return a}getWritable(){G();
var a=Vb(),b=H();a=a._nodeMap;let c=this.__key,d=this.getLatest(),e=d.__parent;b=b._cloneNotNeeded;var f=v();null!==f&&(f._cachedNodes=null);if(b.has(c))return Xb(d),d;f=d.constructor.clone(d);f.__parent=e;f.__next=d.__next;f.__prev=d.__prev;F(d)&&F(f)?(f.__first=d.__first,f.__last=d.__last,f.__size=d.__size,f.__indent=d.__indent,f.__format=d.__format,f.__dir=d.__dir):B(d)&&B(f)&&(f.__format=d.__format,f.__style=d.__style,f.__mode=d.__mode,f.__detail=d.__detail);b.add(c);f.__key=c;Xb(f);a.set(c,f);
return f}getTextContent(){return""}getTextContentSize(){return this.getTextContent().length}createDOM(){q(70)}updateDOM(){q(71)}exportDOM(a){return{element:this.createDOM(a._config,a)}}exportJSON(){q(72)}static importJSON(){q(18)}static transform(){return null}remove(a){Wd(this,!0,a)}replace(a,b){G();var c=v();null!==c&&(c=c.clone());vc(this,a);let d=this.getLatest(),e=this.__key,f=a.__key,g=a.getWritable();a=this.getParentOrThrow().getWritable();let h=a.__size;Wb(g);let k=d.getPreviousSibling(),
n=d.getNextSibling(),m=d.__prev,p=d.__next,l=d.__parent;Wd(d,!1,!0);null===k?a.__first=f:k.getWritable().__next=f;g.__prev=m;null===n?a.__last=f:n.getWritable().__prev=f;g.__next=p;g.__parent=l;a.__size=h;b&&this.getChildren().forEach(r=>{g.append(r)});C(c)&&(xb(c),b=c.anchor,c=c.focus,b.key===e&&$d(b,g),c.key===e&&$d(c,g));Yb()===e&&I(f);return g}insertAfter(a,b=!0){G();vc(this,a);var c=this.getWritable();let d=a.getWritable();var e=d.getParent();let f=v();var g=!1,h=!1;if(null!==e){var k=a.getIndexWithinParent();
Wb(d);C(f)&&(h=e.__key,g=f.anchor,e=f.focus,g="element"===g.type&&g.key===h&&g.offset===k+1,h="element"===e.type&&e.key===h&&e.offset===k+1)}e=this.getNextSibling();k=this.getParentOrThrow().getWritable();let n=d.__key,m=c.__next;null===e?k.__last=n:e.getWritable().__prev=n;k.__size++;c.__next=n;d.__next=m;d.__prev=c.__key;d.__parent=c.__parent;b&&C(f)&&(b=this.getIndexWithinParent(),Yd(f,k,b+1),c=k.__key,g&&f.anchor.set(c,b+2,"element"),h&&f.focus.set(c,b+2,"element"));return a}insertBefore(a,b=
!0){G();vc(this,a);var c=this.getWritable();let d=a.getWritable(),e=d.__key;Wb(d);let f=this.getPreviousSibling(),g=this.getParentOrThrow().getWritable(),h=c.__prev,k=this.getIndexWithinParent();null===f?g.__first=e:f.getWritable().__next=e;g.__size++;c.__prev=e;d.__prev=h;d.__next=c.__key;d.__parent=c.__parent;c=v();b&&C(c)&&(b=this.getParentOrThrow(),Yd(c,b,k));return a}isParentRequired(){return!1}createParentElementNode(){return ae()}selectPrevious(a,b){G();let c=this.getPreviousSibling(),d=this.getParentOrThrow();
return null===c?d.select(0,0):F(c)?c.select():B(c)?c.select(a,b):(a=c.getIndexWithinParent()+1,d.select(a,a))}selectNext(a,b){G();let c=this.getNextSibling(),d=this.getParentOrThrow();return null===c?d.select():F(c)?c.select(0,0):B(c)?c.select(a,b):(a=c.getIndexWithinParent(),d.select(a,a))}markDirty(){this.getWritable()}}
class be extends Zd{static getType(){return"linebreak"}static clone(a){return new be(a.__key)}constructor(a){super(a)}getTextContent(){return"\n"}createDOM(){return document.createElement("br")}updateDOM(){return!1}static importDOM(){return{br:a=>{let b=a.parentElement,c,d;return null!==b&&((c=b.firstChild)===a||c.nextSibling===a&&3===c.nodeType&&null!==(c.textContent||"").match(/^[\s|\r?\n|\t]+$/))&&((d=b.lastChild)===a||d.previousSibling===a&&3===d.nodeType&&null!==(d.textContent||"").match(/^[\s|\r?\n|\t]+$/))?
null:{conversion:ce,priority:0}}}}static importJSON(){return de()}exportJSON(){return{type:"linebreak",version:1}}}function ce(){return{node:de()}}function de(){return uc(new be)}function Sb(a){return a instanceof be}function ee(a,b){return b&16?"code":b&128?"mark":b&32?"sub":b&64?"sup":null}function fe(a,b){return b&1?"strong":b&2?"em":"span"}
function ge(a,b,c,d,e){a=d.classList;d=kc(e,"base");void 0!==d&&a.add(...d);d=kc(e,"underlineStrikethrough");let f=!1,g=b&8&&b&4;var h=c&8&&c&4;void 0!==d&&(h?(f=!0,g||a.add(...d)):g&&a.remove(...d));for(let k in fb)h=fb[k],d=kc(e,k),void 0!==d&&(c&h?!f||"underline"!==k&&"strikethrough"!==k?(0===(b&h)||g&&"underline"===k||"strikethrough"===k)&&a.add(...d):b&h&&a.remove(...d):b&h&&a.remove(...d))}
function he(a,b,c){let d=b.firstChild;c=c.isComposing();a+=c?bb:"";if(null==d)b.textContent=a;else if(b=d.nodeValue,b!==a)if(c||Wa){c=b.length;let e=a.length,f=0,g=0;for(;f<c&&f<e&&b[f]===a[f];)f++;for(;g+f<c&&g+f<e&&b[c-g-1]===a[e-g-1];)g++;a=[f,c-f-g,a.slice(f,e-g)];let [h,k,n]=a;0!==k&&d.deleteData(h,k);d.insertData(h,n)}else d.nodeValue=a}function ie(a,b){b=document.createElement(b);b.appendChild(a);return b}
class je extends Zd{static getType(){return"text"}static clone(a){return new je(a.__text,a.__key)}constructor(a,b){super(b);this.__text=a;this.__format=0;this.__style="";this.__detail=this.__mode=0}getFormat(){return this.getLatest().__format}getDetail(){return this.getLatest().__detail}getMode(){let a=this.getLatest();return kb[a.__mode]}getStyle(){return this.getLatest().__style}isToken(){return 1===this.getLatest().__mode}isComposing(){return this.__key===Yb()}isSegmented(){return 2===this.getLatest().__mode}isDirectionless(){return 0!==
(this.getLatest().__detail&1)}isUnmergeable(){return 0!==(this.getLatest().__detail&2)}hasFormat(a){a=fb[a];return 0!==(this.getFormat()&a)}isSimpleText(){return"text"===this.__type&&0===this.__mode}getTextContent(){return this.getLatest().__text}getFormatFlags(a,b){let c=this.getLatest().__format;return Kb(c,a,b)}createDOM(a){var b=this.__format,c=ee(this,b);let d=fe(this,b),e=document.createElement(null===c?d:c),f=e;null!==c&&(f=document.createElement(d),e.appendChild(f));c=f;he(this.__text,c,this);
a=a.theme.text;void 0!==a&&ge(d,0,b,c,a);b=this.__style;""!==b&&(e.style.cssText=b);return e}updateDOM(a,b,c){let d=this.__text;var e=a.__format,f=this.__format,g=ee(this,e);let h=ee(this,f);var k=fe(this,e);let n=fe(this,f);if((null===g?k:g)!==(null===h?n:h))return!0;if(g===h&&k!==n)return e=b.firstChild,null==e&&q(48),a=g=document.createElement(n),he(d,a,this),c=c.theme.text,void 0!==c&&ge(n,0,f,a,c),b.replaceChild(g,e),!1;k=b;null!==h&&null!==g&&(k=b.firstChild,null==k&&q(49));he(d,k,this);c=c.theme.text;
void 0!==c&&e!==f&&ge(n,e,f,k,c);f=this.__style;a.__style!==f&&(b.style.cssText=f);return!1}static importDOM(){return{"#text":()=>({conversion:ke,priority:0}),b:()=>({conversion:le,priority:0}),code:()=>({conversion:me,priority:0}),em:()=>({conversion:me,priority:0}),i:()=>({conversion:me,priority:0}),s:()=>({conversion:me,priority:0}),span:()=>({conversion:ne,priority:0}),strong:()=>({conversion:me,priority:0}),sub:()=>({conversion:me,priority:0}),sup:()=>({conversion:me,priority:0}),u:()=>({conversion:me,
priority:0})}}static importJSON(a){let b=K(a.text);b.setFormat(a.format);b.setDetail(a.detail);b.setMode(a.mode);b.setStyle(a.style);return b}exportDOM(a){({element:a}=super.exportDOM(a));null!==a&&(this.hasFormat("bold")&&(a=ie(a,"b")),this.hasFormat("italic")&&(a=ie(a,"i")),this.hasFormat("strikethrough")&&(a=ie(a,"s")),this.hasFormat("underline")&&(a=ie(a,"u")));return{element:a}}exportJSON(){return{detail:this.getDetail(),format:this.getFormat(),mode:this.getMode(),style:this.getStyle(),text:this.getTextContent(),
type:"text",version:1}}selectionTransform(){}setFormat(a){let b=this.getWritable();b.__format="string"===typeof a?fb[a]:a;return b}setDetail(a){let b=this.getWritable();b.__detail="string"===typeof a?gb[a]:a;return b}setStyle(a){let b=this.getWritable();b.__style=a;return b}toggleFormat(a){a=fb[a];return this.setFormat(this.getFormat()^a)}toggleDirectionless(){let a=this.getWritable();a.__detail^=1;return a}toggleUnmergeable(){let a=this.getWritable();a.__detail^=2;return a}setMode(a){a=jb[a];if(this.__mode===
a)return this;let b=this.getWritable();b.__mode=a;return b}setTextContent(a){if(this.__text===a)return this;let b=this.getWritable();b.__text=a;return b}select(a,b){G();let c=v();var d=this.getTextContent();let e=this.__key;"string"===typeof d?(d=d.length,void 0===a&&(a=d),void 0===b&&(b=d)):b=a=0;if(C(c))d=Yb(),d!==c.anchor.key&&d!==c.focus.key||I(e),c.setTextNodeRange(this,a,this,b);else return oe(e,a,e,b,"text","text");return c}spliceText(a,b,c,d){let e=this.getWritable(),f=e.__text,g=c.length,
h=a;0>h&&(h=g+h,0>h&&(h=0));let k=v();d&&C(k)&&(a+=g,k.setTextNodeRange(e,a,e,a));b=f.slice(0,h)+c+f.slice(h+b);e.__text=b;return e}canInsertTextBefore(){return!0}canInsertTextAfter(){return!0}splitText(...a){G();var b=this.getLatest(),c=b.getTextContent(),d=b.__key,e=Yb(),f=new Set(a);a=[];var g=c.length,h="";for(var k=0;k<g;k++)""!==h&&f.has(k)&&(a.push(h),h=""),h+=c[k];""!==h&&a.push(h);f=a.length;if(0===f)return[];if(a[0]===c)return[b];var n=a[0];c=b.getParentOrThrow();k=b.getFormat();let m=b.getStyle(),
p=b.__detail;g=!1;b.isSegmented()?(h=K(n),h.__format=k,h.__style=m,h.__detail=p,g=!0):(h=b.getWritable(),h.__text=n);b=v();h=[h];n=n.length;for(let u=1;u<f;u++){var l=a[u],r=l.length;l=K(l).getWritable();l.__format=k;l.__style=m;l.__detail=p;let x=l.__key;r=n+r;if(C(b)){let y=b.anchor,A=b.focus;y.key===d&&"text"===y.type&&y.offset>n&&y.offset<=r&&(y.key=x,y.offset-=n,b.dirty=!0);A.key===d&&"text"===A.type&&A.offset>n&&A.offset<=r&&(A.key=x,A.offset-=n,b.dirty=!0)}e===d&&I(x);n=r;h.push(l)}d=this.getPreviousSibling();
e=this.getNextSibling();null!==d&&Xb(d);null!==e&&Xb(e);d=c.getWritable();e=this.getIndexWithinParent();g?(d.splice(e,0,h),this.remove()):d.splice(e,1,h);C(b)&&Yd(b,c,e,f-1);return h}mergeWithSibling(a){var b=a===this.getPreviousSibling();b||a===this.getNextSibling()||q(50);var c=this.__key;let d=a.__key,e=this.__text,f=e.length;Yb()===d&&I(c);let g=v();if(C(g)){let h=g.anchor,k=g.focus;null!==h&&h.key===d&&(pe(h,b,c,a,f),g.dirty=!0);null!==k&&k.key===d&&(pe(k,b,c,a,f),g.dirty=!0)}c=a.__text;this.setTextContent(b?
c+e:e+c);b=this.getWritable();a.remove();return b}isTextEntity(){return!1}}
function ne(a){let b="700"===a.style.fontWeight,c="line-through"===a.style.textDecoration,d="italic"===a.style.fontStyle,e="underline"===a.style.textDecoration,f=a.style.verticalAlign;return{forChild:g=>{if(!B(g))return g;b&&g.toggleFormat("bold");c&&g.toggleFormat("strikethrough");d&&g.toggleFormat("italic");e&&g.toggleFormat("underline");"sub"===f&&g.toggleFormat("subscript");"super"===f&&g.toggleFormat("superscript");return g},node:null}}
function le(a){let b="normal"===a.style.fontWeight;return{forChild:c=>{B(c)&&!b&&c.toggleFormat("bold");return c},node:null}}let qe=new WeakMap;
function ke(a){if(null===a.parentElement)throw Error("Expected parentElement of Text not to be null");for(var b=a.textContent||"",c,d=a.parentNode,e=[a];null!==d&&void 0===(c=qe.get(d))&&!("PRE"===d.nodeName||1===d.nodeType&&d.style.whiteSpace.startsWith("pre"));)e.push(d),d=d.parentNode;c=void 0===c?d:c;for(d=0;d<e.length;d++)qe.set(e[d],c);if(null!==c){b=b.split(/(\r?\n|\t)/);a=[];e=b.length;for(c=0;c<e;c++)d=b[c],"\n"===d||"\r\n"===d?a.push(de()):"\t"===d?a.push(re()):""!==d&&a.push(K(d));return{node:a}}b=
b.replace(/\r?\n|\t/gm," ").replace("\r","").replace(/\s+/g," ");if(""===b)return{node:null};if(" "===b[0]){e=a;for(c=!0;null!==e&&null!==(e=se(e,!1));)if(d=e.textContent||"",0<d.length){d.match(/(?:\s|\r?\n|\t)$/)&&(b=b.slice(1));c=!1;break}c&&(b=b.slice(1))}if(" "===b[b.length-1]){for(e=!0;null!==a&&null!==(a=se(a,!0));)if(0<(a.textContent||"").replace(/^[\s|\r?\n|\t]+/,"").length){e=!1;break}e&&(b=b.slice(0,b.length-1))}return""===b?{node:null}:{node:K(b)}}
let te=new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/,"i");function se(a,b){for(;;){for(var c=void 0;null===(c=b?a.nextSibling:a.previousSibling);)if(a=a.parentElement,null===a)return null;a=c;if(1===a.nodeType&&(c=a.style.display,""===c&&null===a.nodeName.match(te)||""!==c&&!c.startsWith("inline")))return null;for(;null!==(c=b?a.firstChild:a.lastChild);)a=c;if(3===a.nodeType)return a;if("BR"===a.nodeName)return null}}
let ue={code:"code",em:"italic",i:"italic",s:"strikethrough",strong:"bold",sub:"subscript",sup:"superscript",u:"underline"};function me(a){let b=ue[a.nodeName.toLowerCase()];return void 0===b?{node:null}:{forChild:c=>{B(c)&&!c.hasFormat(b)&&c.toggleFormat(b);return c},node:null}}function K(a=""){return uc(new je(a))}function B(a){return a instanceof je}
class ve extends je{static getType(){return"tab"}static clone(a){let b=new ve(a.__key);b.__text=a.__text;b.__format=a.__format;b.__style=a.__style;return b}constructor(a){super("\t",a);this.__detail=2}static importDOM(){return null}static importJSON(a){let b=re();b.setFormat(a.format);b.setStyle(a.style);return b}exportJSON(){return{...super.exportJSON(),type:"tab",version:1}}setTextContent(){throw Error("TabNode does not support setTextContent");}setDetail(){throw Error("TabNode does not support setDetail");
}setMode(){throw Error("TabNode does not support setMode");}canInsertTextBefore(){return!1}canInsertTextAfter(){return!1}}function re(){return uc(new ve)}
class we{constructor(a,b,c){this._selection=null;this.key=a;this.offset=b;this.type=c}is(a){return this.key===a.key&&this.offset===a.offset&&this.type===a.type}isBefore(a){let b=this.getNode(),c=a.getNode(),d=this.offset;a=a.offset;if(F(b)){var e=b.getDescendantByIndex(d);b=null!=e?e:b}F(c)&&(e=c.getDescendantByIndex(a),c=null!=e?e:c);return b===c?d<a:b.isBefore(c)}getNode(){let a=J(this.key);null===a&&q(20);return a}set(a,b,c){let d=this._selection,e=this.key;this.key=a;this.offset=b;this.type=c;
Zb()||(Yb()===e&&I(a),null!==d&&(d._cachedNodes=null,d.dirty=!0))}}function xe(a,b){let c=b.__key,d=a.offset,e="element";if(B(b))e="text",b=b.getTextContentSize(),d>b&&(d=b);else if(!F(b)){var f=b.getNextSibling();if(B(f))c=f.__key,d=0,e="text";else if(f=b.getParent())c=f.__key,d=b.getIndexWithinParent()+1}a.set(c,d,e)}function $d(a,b){if(F(b)){let c=b.getLastDescendant();F(c)||B(c)?xe(a,c):xe(a,b)}else xe(a,b)}
function ye(a,b,c,d){let e=a.getNode(),f=e.getChildAtIndex(a.offset),g=K(),h=L(e)?ae().append(g):g;g.setFormat(c);g.setStyle(d);null===f?e.append(h):f.insertBefore(h);a.is(b)&&b.set(g.__key,0,"text");a.set(g.__key,0,"text")}function Ie(a,b,c,d){a.key=b;a.offset=c;a.type=d}
class Je{constructor(a){this.dirty=!1;this._nodes=a;this._cachedNodes=null}is(a){if(!Rd(a))return!1;let b=this._nodes,c=a._nodes;return b.size===c.size&&Array.from(b).every(d=>c.has(d))}add(a){this.dirty=!0;this._nodes.add(a);this._cachedNodes=null}delete(a){this.dirty=!0;this._nodes.delete(a);this._cachedNodes=null}clear(){this.dirty=!0;this._nodes.clear();this._cachedNodes=null}has(a){return this._nodes.has(a)}clone(){return new Je(new Set(this._nodes))}extract(){return this.getNodes()}insertRawText(){}insertText(){}insertNodes(a,
b){let c=this.getNodes(),d=c.length;var e=c[d-1];if(B(e))e=e.select();else{let f=e.getIndexWithinParent()+1;e=e.getParentOrThrow().select(f,f)}e.insertNodes(a,b);for(a=0;a<d;a++)c[a].remove();return!0}getNodes(){var a=this._cachedNodes;if(null!==a)return a;var b=this._nodes;a=[];for(let c of b)b=J(c),null!==b&&a.push(b);Zb()||(this._cachedNodes=a);return a}getTextContent(){let a=this.getNodes(),b="";for(let c=0;c<a.length;c++)b+=a[c].getTextContent();return b}}
function C(a){return a instanceof Ke}
class Le{constructor(a,b,c){this.gridKey=a;this.anchor=b;this.focus=c;this.dirty=!1;this._cachedNodes=null;b._selection=this;c._selection=this}is(a){return Me(a)?this.gridKey===a.gridKey&&this.anchor.is(a.anchor)&&this.focus.is(a.focus):!1}set(a,b,c){this.dirty=!0;this.gridKey=a;this.anchor.key=b;this.focus.key=c;this._cachedNodes=null}clone(){return new Le(this.gridKey,this.anchor,this.focus)}isCollapsed(){return!1}isBackward(){return this.focus.isBefore(this.anchor)}getCharacterOffsets(){return Ne(this)}extract(){return this.getNodes()}insertRawText(){}insertText(){}insertNodes(a,b){let c=
this.focus.getNode();return Gc(c.select(0,c.getChildrenSize())).insertNodes(a,b)}getShape(){var a=J(this.anchor.key);null===a&&q(21);var b=a.getIndexWithinParent();a=a.getParentOrThrow().getIndexWithinParent();var c=J(this.focus.key);null===c&&q(22);var d=c.getIndexWithinParent();let e=c.getParentOrThrow().getIndexWithinParent();c=Math.min(b,d);b=Math.max(b,d);d=Math.min(a,e);a=Math.max(a,e);return{fromX:Math.min(c,b),fromY:Math.min(d,a),toX:Math.max(c,b),toY:Math.max(d,a)}}getNodes(){function a(x){let {cell:y,
startColumn:A,startRow:aa}=x;h=Math.min(h,A);k=Math.min(k,aa);n=Math.max(n,A+y.__colSpan-1);m=Math.max(m,aa+y.__rowSpan-1)}var b=this._cachedNodes;if(null!==b)return b;var c=this.anchor.getNode();b=this.focus.getNode();c=zc(c,Oe);var d=zc(b,Oe);Oe(c)||q(103);Oe(d)||q(104);b=c.getParent();Pe(b)||q(105);b=b.getParent();Qe(b)||q(106);let [e,f,g]=Re(b,c,d),h=Math.min(f.startColumn,g.startColumn),k=Math.min(f.startRow,g.startRow),n=Math.max(f.startColumn+f.cell.__colSpan-1,g.startColumn+g.cell.__colSpan-
1),m=Math.max(f.startRow+f.cell.__rowSpan-1,g.startRow+g.cell.__rowSpan-1);c=h;d=k;for(var p=h,l=k;h<c||k<d||n>p||m>l;){if(h<c){var r=l-d;--c;for(var u=0;u<=r;u++)a(e[d+u][c])}if(k<d)for(r=p-c,--d,u=0;u<=r;u++)a(e[d][c+u]);if(n>p)for(r=l-d,p+=1,u=0;u<=r;u++)a(e[d+u][p]);if(m>l)for(r=p-c,l+=1,u=0;u<=r;u++)a(e[l][c+u])}b=[b];c=null;for(d=k;d<=m;d++)for(p=h;p<=n;p++)({cell:l}=e[d][p]),r=l.getParent(),Pe(r)||q(107),r!==c&&b.push(r),b.push(l,...Ac(l)),c=r;Zb()||(this._cachedNodes=b);return b}getTextContent(){let a=
this.getNodes(),b="";for(let c=0;c<a.length;c++)b+=a[c].getTextContent();return b}}function Me(a){return a instanceof Le}
class Ke{constructor(a,b,c,d){this.anchor=a;this.focus=b;this.dirty=!1;this.format=c;this.style=d;this._cachedNodes=null;a._selection=this;b._selection=this}is(a){return C(a)?this.anchor.is(a.anchor)&&this.focus.is(a.focus)&&this.format===a.format&&this.style===a.style:!1}isBackward(){return this.focus.isBefore(this.anchor)}isCollapsed(){return this.anchor.is(this.focus)}getNodes(){var a=this._cachedNodes;if(null!==a)return a;a=this.anchor;var b=this.focus,c=a.isBefore(b),d=c?a:b;c=c?b:a;a=d.getNode();
b=c.getNode();let e=d.offset;d=c.offset;F(a)&&(c=a.getDescendantByIndex(e),a=null!=c?c:a);F(b)&&(c=b.getDescendantByIndex(d),null!==c&&c!==a&&b.getChildAtIndex(d)===c&&(c=c.getPreviousSibling()),b=null!=c?c:b);a=a.is(b)?F(a)&&0<a.getChildrenSize()?[]:[a]:a.getNodesBetween(b);Zb()||(this._cachedNodes=a);return a}setTextNodeRange(a,b,c,d){Ie(this.anchor,a.__key,b,"text");Ie(this.focus,c.__key,d,"text");this._cachedNodes=null;this.dirty=!0}getTextContent(){let a=this.getNodes();if(0===a.length)return"";
let b=a[0],c=a[a.length-1],d=this.anchor,e=this.focus,f=d.isBefore(e),[g,h]=Ne(this),k="",n=!0;for(let m=0;m<a.length;m++){let p=a[m];if(F(p)&&!p.isInline())n||(k+="\n"),n=p.isEmpty()?!1:!0;else if(n=!1,B(p)){let l=p.getTextContent();if(p===b)if(p===c){if("element"!==d.type||"element"!==e.type||e.offset===d.offset)l=g<h?l.slice(g,h):l.slice(h,g)}else l=f?l.slice(g):l.slice(h);else p===c&&(l=f?l.slice(0,h):l.slice(0,g));k+=l}else!z(p)&&!Sb(p)||p===c&&this.isCollapsed()||(k+=p.getTextContent())}return k}applyDOMRange(a){let b=
H(),c=b.getEditorState()._selection;a=Se(a.startContainer,a.startOffset,a.endContainer,a.endOffset,b,c);if(null!==a){var [d,e]=a;Ie(this.anchor,d.key,d.offset,d.type);Ie(this.focus,e.key,e.offset,e.type);this._cachedNodes=null}}clone(){let a=this.anchor,b=this.focus;return new Ke(new we(a.key,a.offset,a.type),new we(b.key,b.offset,b.type),this.format,this.style)}toggleFormat(a){this.format=Kb(this.format,a,null);this.dirty=!0}setStyle(a){this.style=a;this.dirty=!0}hasFormat(a){return 0!==(this.format&
fb[a])}insertRawText(a){a=a.split(/(\r?\n|\t)/);let b=[],c=a.length;for(let d=0;d<c;d++){let e=a[d];"\n"===e||"\r\n"===e?b.push(de()):"\t"===e?b.push(re()):b.push(K(e))}this.insertNodes(b)}insertText(a){var b=this.anchor,c=this.focus,d=this.isCollapsed()||b.isBefore(c),e=this.format,f=this.style;d&&"element"===b.type?ye(b,c,e,f):d||"element"!==c.type||ye(c,b,e,f);var g=this.getNodes(),h=g.length,k=d?c:b;c=(d?b:c).offset;var n=k.offset;b=g[0];B(b)||q(26);d=b.getTextContent().length;var m=b.getParentOrThrow(),
p=g[h-1];if(this.isCollapsed()&&c===d&&(b.isSegmented()||b.isToken()||!b.canInsertTextAfter()||!m.canInsertTextAfter()&&null===b.getNextSibling())){var l=b.getNextSibling();B(l)&&l.canInsertTextBefore()&&!Ib(l)||(l=K(),l.setFormat(e),m.canInsertTextAfter()?b.insertAfter(l):m.insertAfter(l));l.select(0,0);b=l;if(""!==a){this.insertText(a);return}}else if(this.isCollapsed()&&0===c&&(b.isSegmented()||b.isToken()||!b.canInsertTextBefore()||!m.canInsertTextBefore()&&null===b.getPreviousSibling())){l=b.getPreviousSibling();
if(!B(l)||Ib(l))l=K(),l.setFormat(e),m.canInsertTextBefore()?b.insertBefore(l):m.insertBefore(l);l.select();b=l;if(""!==a){this.insertText(a);return}}else if(b.isSegmented()&&c!==d)m=K(b.getTextContent()),m.setFormat(e),b.replace(m),b=m;else if(!(this.isCollapsed()||""===a||(l=p.getParent(),m.canInsertTextBefore()&&m.canInsertTextAfter()&&(!F(l)||l.canInsertTextBefore()&&l.canInsertTextAfter())))){this.insertText("");Te(this.anchor,this.focus,null);this.insertText(a);return}if(1===h)if(b.isToken())a=
K(a),a.select(),b.replace(a);else{g=b.getFormat();h=b.getStyle();if(c===n&&(g!==e||h!==f))if(""===b.getTextContent())b.setFormat(e),b.setStyle(f);else{g=K(a);g.setFormat(e);g.setStyle(f);g.select();0===c?b.insertBefore(g,!1):([h]=b.splitText(c),h.insertAfter(g,!1));g.isComposing()&&"text"===this.anchor.type&&(this.anchor.offset-=a.length);return}b=b.spliceText(c,n-c,a,!0);""===b.getTextContent()?b.remove():"text"===this.anchor.type&&(b.isComposing()?this.anchor.offset-=a.length:(this.format=g,this.style=
h))}else{e=new Set([...b.getParentKeys(),...p.getParentKeys()]);l=F(b)?b:b.getParentOrThrow();f=F(p)?p:p.getParentOrThrow();m=p;if(!l.is(f)&&f.isInline()){do m=f,f=f.getParentOrThrow();while(f.isInline())}"text"===k.type&&(0!==n||""===p.getTextContent())||"element"===k.type&&p.getIndexWithinParent()<n?B(p)&&!p.isToken()&&n!==p.getTextContentSize()?(p.isSegmented()&&(k=K(p.getTextContent()),p.replace(k),p=k),p=p.spliceText(0,n,""),e.add(p.__key)):(k=p.getParentOrThrow(),k.canBeEmpty()||1!==k.getChildrenSize()?
p.remove():k.remove()):e.add(p.__key);k=f.getChildren();n=new Set(g);p=l.is(f);l=l.isInline()&&null===b.getNextSibling()?l:b;for(let r=k.length-1;0<=r;r--){let u=k[r];if(u.is(b)||F(u)&&u.isParentOf(b))break;u.isAttached()&&(!n.has(u)||u.is(m)?p||l.insertAfter(u,!1):u.remove())}if(!p)for(k=f,n=null;null!==k;){f=k.getChildren();p=f.length;if(0===p||f[p-1].is(n))e.delete(k.__key),n=k;k=k.getParent()}b.isToken()?c===d?b.select():(a=K(a),a.select(),b.replace(a)):(b=b.spliceText(c,d-c,a,!0),""===b.getTextContent()?
b.remove():b.isComposing()&&"text"===this.anchor.type&&(this.anchor.offset-=a.length));for(a=1;a<h;a++)b=g[a],e.has(b.__key)||b.remove()}}removeText(){this.insertText("")}formatText(a){if(this.isCollapsed())this.toggleFormat(a),I(null);else{var b=this.getNodes(),c=[];for(var d of b)B(d)&&c.push(d);var e=c.length;if(0===e)this.toggleFormat(a),I(null);else{d=this.anchor;var f=this.focus,g=this.isBackward();b=g?f:d;d=g?d:f;var h=0,k=c[0];f="element"===b.type?0:b.offset;"text"===b.type&&f===k.getTextContentSize()&&
(h=1,k=c[1],f=0);if(null!=k){g=k.getFormatFlags(a,null);var n=e-1,m=c[n];e="text"===d.type?d.offset:m.getTextContentSize();if(k.is(m))f!==e&&(0===f&&e===k.getTextContentSize()?k.setFormat(g):(a=k.splitText(f,e),a=0===f?a[0]:a[1],a.setFormat(g),"text"===b.type&&b.set(a.__key,0,"text"),"text"===d.type&&d.set(a.__key,e-f,"text")),this.format=g);else{0!==f&&([,k]=k.splitText(f),f=0);k.setFormat(g);var p=m.getFormatFlags(a,g);0<e&&(e!==m.getTextContentSize()&&([m]=m.splitText(e)),m.setFormat(p));for(h+=
1;h<n;h++){let l=c[h];if(!l.isToken()){let r=l.getFormatFlags(a,p);l.setFormat(r)}}"text"===b.type&&b.set(k.__key,f,"text");"text"===d.type&&d.set(m.__key,e,"text");this.format=g|p}}}}}insertNodes(a,b){if(!this.isCollapsed()){var c=this.isBackward()?this.anchor:this.focus,d=c.getNode().getNextSibling();d=d?d.getKey():null;c=(c=c.getNode().getPreviousSibling())?c.getKey():null;this.removeText();if(this.isCollapsed()&&"element"===this.focus.type){if(this.focus.key===d&&0===this.focus.offset){var e=
K();this.focus.getNode().insertBefore(e)}else this.focus.key===c&&this.focus.offset===this.focus.getNode().getChildrenSize()&&(e=K(),this.focus.getNode().insertAfter(e));e&&(this.focus.set(e.__key,0,"text"),this.anchor.set(e.__key,0,"text"))}}e=this.anchor;c=e.offset;var f=e.getNode();d=f;"element"===e.type&&(e=e.getNode(),d=e.getChildAtIndex(c-1),d=null===d?e:d);e=[];var g=f.getNextSiblings(),h=M(f)?null:f.getTopLevelElementOrThrow();if(B(f))if(d=f.getTextContent().length,0===c&&0!==d)d=f.getPreviousSibling(),
d=null!==d?d:f.getParentOrThrow(),e.push(f);else if(c===d)d=f;else{if(f.isToken())return!1;[d,f]=f.splitText(c);e.push(f)}f=d;e.push(...g);g=a[0];var k=!1,n=null;for(let r=0;r<a.length;r++){var m=a[r];if(M(d)||z(d)||!F(m)||m.isInline())k&&!F(m)&&!z(m)&&M(d.getParent())&&q(28);else{if(m.is(g)){if(F(d)&&d.isEmpty()&&d.canReplaceWith(m)){d.replace(m);d=m;k=!0;continue}k=m.getFirstDescendant();if(Lb(k)){for(var p=k.getParentOrThrow();p.isInline();)p=p.getParentOrThrow();n=p.getChildren();k=n.length;if(F(d)){var l=
d.getFirstChild();for(let u=0;u<k;u++){let x=n[u];null===l?d.append(x):l.insertAfter(x);l=x}}else{for(l=k-1;0<=l;l--)d.insertAfter(n[l]);d=d.getParentOrThrow()}n=n[k-1];p.remove();k=!0;if(p.is(m))continue}}B(d)&&(null===h&&q(27),d=h)}k=!1;if(F(d)&&!d.isInline())if(n=m,z(m)&&!m.isInline())d=d.insertAfter(m,!1);else if(F(m)){if(m.canBeEmpty()||!m.isEmpty())L(d)?(p=d.getChildAtIndex(c),null!==p?p.insertBefore(m):d.append(m),d=m):m.isInline()?(d.append(m),d=m):d=d.insertAfter(m,!1)}else p=d.getFirstChild(),
null!==p?p.insertBefore(m):d.append(m),d=m;else!F(m)||F(m)&&m.isInline()||z(d)&&!d.isInline()?(n=m,C(this)&&z(m)&&(F(d)||B(d))&&!m.isInline()?(B(d)?(p=d.getParentOrThrow(),[d]=d.splitText(c),d=d.getIndexWithinParent()+1):(p=d,d=c),[,d]=yc(p,d),d=d.insertBefore(m)):d=d.insertAfter(m,!1)):(m=d.getParentOrThrow(),Sb(d)&&d.remove(),d=m,r--)}b&&(B(f)?f.select():(a=d.getPreviousSibling(),B(a)?a.select():(a=d.getIndexWithinParent(),d.getParentOrThrow().select(a,a))));if(F(d)){if(a=B(n)?n:F(n)&&n.isInline()?
n.getLastDescendant():d.getLastDescendant(),b||(null===a?d.select():B(a)?""===a.getTextContent()?a.selectPrevious():a.select():a.selectNext()),0!==e.length)for(b=d,a=e.length-1;0<=a;a--)c=e[a],h=c.getParentOrThrow(),!F(d)||Ue(c)||z(c)&&(!c.isInline()||c.isIsolated())?F(d)||Ue(c)?F(c)&&!c.canInsertAfter(d)?(f=h.constructor.clone(h),F(f)||q(29),f.append(c),d.insertAfter(f)):d.insertAfter(c):(d.insertBefore(c),d=c):(b===d?d.append(c):d.insertBefore(c),d=c),h.isEmpty()&&!h.canBeEmpty()&&h.remove()}else b||
(B(d)?d.select():(b=d.getParentOrThrow(),a=d.getIndexWithinParent()+1,b.select(a,a)));return!0}insertParagraph(){this.isCollapsed()||this.removeText();var a=this.anchor,b=a.offset,c=[];if("text"===a.type){var d=a.getNode();var e=d.getNextSiblings().reverse();var f=d.getParentOrThrow();var g=f.isInline(),h=g?f.getTextContentSize():d.getTextContentSize();0===b?e.push(d):(g&&(c=f.getNextSiblings()),b===h||g&&b===d.getTextContentSize()||([,d]=d.splitText(b),e.push(d)))}else{f=a.getNode();if(M(f)){e=ae();
c=f.getChildAtIndex(b);e.select();null!==c?c.insertBefore(e,!1):f.append(e);return}e=f.getChildren().slice(b).reverse()}d=e.length;if(0===b&&0<d&&f.isInline()){if(c=f.getParentOrThrow(),e=c.insertNewAfter(this,!1),F(e))for(c=c.getChildren(),f=0;f<c.length;f++)e.append(c[f])}else if(g=f.insertNewAfter(this,!1),null===g)this.insertLineBreak();else if(F(g))if(h=f.getFirstChild(),0===b&&(f.is(a.getNode())||h&&h.is(a.getNode()))&&0<d)f.insertBefore(g);else{f=null;b=c.length;a=g.getParentOrThrow();if(0<
b)for(h=0;h<b;h++)a.append(c[h]);if(0!==d)for(c=0;c<d;c++)b=e[c],null===f?g.append(b):f.insertBefore(b),f=b;g.canBeEmpty()||0!==g.getChildrenSize()?g.selectStart():(g.selectPrevious(),g.remove())}}insertLineBreak(a){let b=de();var c=this.anchor;"element"===c.type&&(c=c.getNode(),L(c)&&this.insertParagraph());a?this.insertNodes([b],!0):this.insertNodes([b])&&b.selectNext(0,0)}getCharacterOffsets(){return Ne(this)}extract(){var a=this.getNodes(),b=a.length,c=b-1,d=this.anchor;let e=this.focus;var f=
a[0];let g=a[c],[h,k]=Ne(this);if(0===b)return[];if(1===b)return B(f)&&!this.isCollapsed()?(a=h>k?k:h,c=f.splitText(a,h>k?h:k),a=0===a?c[0]:c[1],null!=a?[a]:[]):[f];b=d.isBefore(e);B(f)&&(d=b?h:k,d===f.getTextContentSize()?a.shift():0!==d&&([,f]=f.splitText(d),a[0]=f));B(g)&&(f=g.getTextContent().length,b=b?k:h,0===b?a.pop():b!==f&&([g]=g.splitText(b),a[c]=g));return a}modify(a,b,c){var d=this.focus,e=this.anchor,f="move"===a,g=nc(d,b);if(z(g)&&!g.isIsolated())f&&g.isKeyboardSelectable()?(b=Ve(),
b.add(g.__key),xb(b)):(a=b?g.getPreviousSibling():g.getNextSibling(),B(a)?(g=a.__key,b=b?a.getTextContent().length:0,d.set(g,b,"text"),f&&e.set(g,b,"text")):(c=g.getParentOrThrow(),F(a)?(c=a.__key,g=b?a.getChildrenSize():0):(g=g.getIndexWithinParent(),c=c.__key,b||g++),d.set(c,g,"element"),f&&e.set(c,g,"element")));else if(e=H(),d=E(e._window)){var h=e._blockCursorElement,k=e._rootElement;null===k||null===h||!F(g)||g.isInline()||g.canBeEmpty()||xc(h,e,k);d.modify(a,b?"backward":"forward",c);if(0<
d.rangeCount&&(g=d.getRangeAt(0),e=this.anchor.getNode(),e=L(e)?e:sc(e),this.applyDOMRange(g),this.dirty=!0,!f)){f=this.getNodes();a=[];c=!1;for(h=0;h<f.length;h++)k=f[h],rc(k,e)?a.push(k):c=!0;c&&0<a.length&&(b?(b=a[0],F(b)?b.selectStart():b.getParentOrThrow().selectStart()):(b=a[a.length-1],F(b)?b.selectEnd():b.getParentOrThrow().selectEnd()));if(d.anchorNode!==g.startContainer||d.anchorOffset!==g.startOffset)b=this.focus,f=this.anchor,d=f.key,g=f.offset,e=f.type,Ie(f,b.key,b.offset,b.type),Ie(b,
d,g,e),this._cachedNodes=null}}}deleteCharacter(a){let b=this.isCollapsed();if(this.isCollapsed()){var c=this.anchor,d=this.focus,e=c.getNode();if(!a&&("element"===c.type&&F(e)&&c.offset===e.getChildrenSize()||"text"===c.type&&c.offset===e.getTextContentSize())){var f=e.getParent();f=e.getNextSibling()||(null===f?null:f.getNextSibling());if(F(f)&&f.isShadowRoot())return}f=nc(d,a);if(z(f)&&!f.isIsolated()){f.isKeyboardSelectable()&&F(e)&&0===e.getChildrenSize()?(e.remove(),a=Ve(),a.add(f.__key),xb(a)):
f.remove();return}if(!a&&F(f)&&F(e)&&e.isEmpty()){e.remove();f.selectStart();return}this.modify("extend",a,"character");if(!this.isCollapsed()){f="text"===d.type?d.getNode():null;e="text"===c.type?c.getNode():null;if(null!==f&&f.isSegmented()){if(c=d.offset,d=f.getTextContentSize(),f.is(e)||a&&c!==d||!a&&0!==c){We(f,a,c);return}}else if(null!==e&&e.isSegmented()&&(c=c.offset,d=e.getTextContentSize(),e.is(f)||a&&0!==c||!a&&c!==d)){We(e,a,c);return}e=this.anchor;f=this.focus;c=e.getNode();d=f.getNode();
if(c===d&&"text"===e.type&&"text"===f.type){var g=e.offset,h=f.offset;let k=g<h;d=k?g:h;h=k?h:g;g=h-1;d!==g&&(c=c.getTextContent().slice(d,h),ec(c)||(a?f.offset=g:e.offset=g))}}else if(a&&0===c.offset&&("element"===c.type?c.getNode():c.getNode().getParentOrThrow()).collapseAtStart(this))return}this.removeText();a&&!b&&this.isCollapsed()&&"element"===this.anchor.type&&0===this.anchor.offset&&(a=this.anchor.getNode(),a.isEmpty()&&L(a.getParent())&&0===a.getIndexWithinParent()&&a.collapseAtStart(this))}deleteLine(a){this.isCollapsed()&&
("text"===this.anchor.type&&this.modify("extend",a,"lineboundary"),0===(a?this.focus:this.anchor).offset&&this.modify("extend",a,"character"));this.removeText()}deleteWord(a){this.isCollapsed()&&this.modify("extend",a,"word");this.removeText()}}function Rd(a){return a instanceof Je}function Xe(a){let b=a.offset;if("text"===a.type)return b;a=a.getNode();return b===a.getChildrenSize()?a.getTextContent().length:0}
function Ne(a){let b=a.anchor;a=a.focus;return"element"===b.type&&"element"===a.type&&b.key===a.key&&b.offset===a.offset?[0,0]:[Xe(b),Xe(a)]}function We(a,b,c){let d=a.getTextContent().split(/(?=\s)/g),e=d.length,f=0,g=0;for(let h=0;h<e;h++){let k=d[h],n=h===e-1;g=f;f+=k.length;if(b&&f===c||f>c||n){d.splice(h,1);n&&(g=void 0);break}}b=d.join("").trim();""===b?a.remove():(a.setTextContent(b),a.select(g,g))}
function Ye(a,b,c,d){var e=b;if(1===a.nodeType){let h=!1;var f=a.childNodes,g=f.length;e===g&&(h=!0,e=g-1);let k=f[e];g=!1;k===d._blockCursorElement?(k=f[e+1],g=!0):null!==d._blockCursorElement&&e--;d=dc(k);if(B(d))e=h?d.getTextContentSize():0;else{f=dc(a);if(null===f)return null;if(F(f)){a=f.getChildAtIndex(e);if(b=F(a))b=a.getParent(),b=null===c||null===b||!b.canBeEmpty()||b!==c.getNode();b&&(c=h?a.getLastDescendant():a.getFirstDescendant(),null===c?(f=a,e=0):(a=c,f=F(a)?a:a.getParentOrThrow()));
B(a)?(d=a,f=null,e=h?a.getTextContentSize():0):a!==f&&h&&!g&&e++}else e=f.getIndexWithinParent(),e=0===b&&z(f)&&dc(a)===f?e:e+1,f=f.getParentOrThrow();if(F(f))return new we(f.__key,e,"element")}}else d=dc(a);return B(d)?new we(d.__key,e,"text"):null}
function Ze(a,b,c){var d=a.offset,e=a.getNode();0===d?(d=e.getPreviousSibling(),e=e.getParent(),b)?(c||!b)&&null===d&&F(e)&&e.isInline()&&(b=e.getPreviousSibling(),B(b)&&(a.key=b.__key,a.offset=b.getTextContent().length)):F(d)&&!c&&d.isInline()?(a.key=d.__key,a.offset=d.getChildrenSize(),a.type="element"):B(d)&&(a.key=d.__key,a.offset=d.getTextContent().length):d===e.getTextContent().length&&(d=e.getNextSibling(),e=e.getParent(),b&&F(d)&&d.isInline()?(a.key=d.__key,a.offset=0,a.type="element"):(c||
b)&&null===d&&F(e)&&e.isInline()&&!e.canInsertTextAfter()&&(b=e.getNextSibling(),B(b)&&(a.key=b.__key,a.offset=0)))}function Te(a,b,c){if("text"===a.type&&"text"===b.type){var d=a.isBefore(b);let e=a.is(b);Ze(a,d,e);Ze(b,!d,e);e&&(b.key=a.key,b.offset=a.offset,b.type=a.type);d=H();d.isComposing()&&d._compositionKey!==a.key&&C(c)&&(d=c.anchor,c=c.focus,Ie(a,d.key,d.offset,d.type),Ie(b,c.key,c.offset,c.type))}}
function Se(a,b,c,d,e,f){if(null===a||null===c||!Fb(e,a,c))return null;b=Ye(a,b,C(f)?f.anchor:null,e);if(null===b)return null;d=Ye(c,d,C(f)?f.focus:null,e);if(null===d||"element"===b.type&&"element"===d.type&&(a=dc(a),c=dc(c),z(a)&&z(c)))return null;Te(b,d,f);return[b,d]}function Ue(a){return F(a)&&!a.isInline()}function oe(a,b,c,d,e,f){let g=Vb();a=new Ke(new we(a,b,e),new we(c,d,f),0,"");a.dirty=!0;return g._selection=a}function Ve(){return new Je(new Set)}
function $e(a){let b=a.getEditorState()._selection,c=E(a._window);return Rd(b)||Me(b)?b.clone():Nd(b,c,a)}
function Nd(a,b,c){var d=c._window;if(null===d)return null;var e=d.event,f=e?e.type:void 0;d="selectionchange"===f;e=!ob&&(d||"beforeinput"===f||"compositionstart"===f||"compositionend"===f||"click"===f&&e&&3===e.detail||"drop"===f||void 0===f);let g;if(!C(a)||e){if(null===b)return null;e=b.anchorNode;f=b.focusNode;g=b.anchorOffset;b=b.focusOffset;if(d&&C(a)&&!Fb(c,e,f))return a.clone()}else return a.clone();c=Se(e,g,f,b,c,a);if(null===c)return null;let [h,k]=c;return new Ke(h,k,C(a)?a.format:0,C(a)?
a.style:"")}function v(){return Vb()._selection}function ic(){return H()._editorState._selection}
function Yd(a,b,c,d=1){var e=a.anchor,f=a.focus,g=e.getNode(),h=f.getNode();if(b.is(g)||b.is(h)){g=b.__key;if(a.isCollapsed()){if(b=e.offset,c<=b&&0<d||c<b&&0>d)c=Math.max(0,b+d),e.set(g,c,"element"),f.set(g,c,"element"),af(a)}else{let n=a.isBackward();h=n?f:e;var k=h.getNode();e=n?e:f;f=e.getNode();b.is(k)&&(k=h.offset,(c<=k&&0<d||c<k&&0>d)&&h.set(g,Math.max(0,k+d),"element"));b.is(f)&&(b=e.offset,(c<=b&&0<d||c<b&&0>d)&&e.set(g,Math.max(0,b+d),"element"))}af(a)}}
function af(a){var b=a.anchor,c=b.offset;let d=a.focus;var e=d.offset,f=b.getNode(),g=d.getNode();if(a.isCollapsed())F(f)&&(g=f.getChildrenSize(),g=(e=c>=g)?f.getChildAtIndex(g-1):f.getChildAtIndex(c),B(g)&&(c=0,e&&(c=g.getTextContentSize()),b.set(g.__key,c,"text"),d.set(g.__key,c,"text")));else{if(F(f)){let h=f.getChildrenSize();c=(a=c>=h)?f.getChildAtIndex(h-1):f.getChildAtIndex(c);B(c)&&(f=0,a&&(f=c.getTextContentSize()),b.set(c.__key,f,"text"))}F(g)&&(c=g.getChildrenSize(),e=(b=e>=c)?g.getChildAtIndex(c-
1):g.getChildAtIndex(e),B(e)&&(g=0,b&&(g=e.getTextContentSize()),d.set(e.__key,g,"text")))}}function bf(a,b){b=b.getEditorState()._selection;a=a._selection;if(C(a)){var c=a.anchor;let d=a.focus,e;"text"===c.type&&(e=c.getNode(),e.selectionTransform(b,a));"text"===d.type&&(c=d.getNode(),e!==c&&c.selectionTransform(b,a))}}
function Xd(a,b,c,d,e){let f=null,g=0,h=null;null!==d?(f=d.__key,B(d)?(g=d.getTextContentSize(),h="text"):F(d)&&(g=d.getChildrenSize(),h="element")):null!==e&&(f=e.__key,B(e)?h="text":F(e)&&(h="element"));null!==f&&null!==h?a.set(f,g,h):(g=b.getIndexWithinParent(),-1===g&&(g=c.getChildrenSize()),a.set(c.__key,g,"element"))}function pe(a,b,c,d,e){"text"===a.type?(a.key=c,b||(a.offset+=e)):a.offset>d.getIndexWithinParent()&&--a.offset}
function Re(a,b,c){let d=[],e=null,f=null;a=a.getChildren();for(let m=0;m<a.length;m++){var g=a[m];Pe(g)||q(108);var h=g.getChildren();g=0;for(let p of h){for(Oe(p)||q(109);void 0!==d[m]&&void 0!==d[m][g];)g++;h=m;var k=g,n=p;let l={cell:n,startColumn:k,startRow:h},r=n.__rowSpan,u=n.__colSpan;for(let x=0;x<r;x++){void 0===d[h+x]&&(d[h+x]=[]);for(let y=0;y<u;y++)d[h+x][k+y]=l}b.is(n)&&(e=l);c.is(n)&&(f=l);g+=p.__colSpan}}null===e&&q(110);null===f&&q(111);return[d,e,f]}
let T=null,Y=null,Z=!1,cf=!1,Ub=0,df={characterData:!0,childList:!0,subtree:!0};function Zb(){return Z||null!==T&&T._readOnly}function G(){Z&&q(13)}function Vb(){null===T&&q(15);return T}function H(){null===Y&&q(16);return Y}function ef(a,b,c){var d=b.__type;let e=a._nodes.get(d);void 0===e&&q(30);a=c.get(d);void 0===a&&(a=Array.from(e.transforms),c.set(d,a));c=a.length;for(d=0;d<c&&(a[d](b),b.isAttached());d++);}
function ff(a,b){b=b._dirtyLeaves;a=a._nodeMap;for(let c of b)b=a.get(c),B(b)&&b.isAttached()&&b.isSimpleText()&&!b.isUnmergeable()&&Fc(b)}
function gf(a,b){let c=b._dirtyLeaves,d=b._dirtyElements;a=a._nodeMap;let e=Yb(),f=new Map;var g=c;let h=g.size;for(var k=d,n=k.size;0<h||0<n;){if(0<h){b._dirtyLeaves=new Set;for(let m of g)g=a.get(m),B(g)&&g.isAttached()&&g.isSimpleText()&&!g.isUnmergeable()&&Fc(g),void 0!==g&&void 0!==g&&g.__key!==e&&g.isAttached()&&ef(b,g,f),c.add(m);g=b._dirtyLeaves;h=g.size;if(0<h){Ub++;continue}}b._dirtyLeaves=new Set;b._dirtyElements=new Map;for(let m of k)if(k=m[0],n=m[1],"root"===k||n)g=a.get(k),void 0!==
g&&void 0!==g&&g.__key!==e&&g.isAttached()&&ef(b,g,f),d.set(k,n);g=b._dirtyLeaves;h=g.size;k=b._dirtyElements;n=k.size;Ub++}b._dirtyLeaves=c;b._dirtyElements=d}function hf(a,b){var c=b.get(a.type);void 0===c&&q(17);c=c.klass;a.type!==c.getType()&&q(18);c=c.importJSON(a);a=a.children;if(F(c)&&Array.isArray(a))for(let d=0;d<a.length;d++){let e=hf(a[d],b);c.append(e)}return c}function jf(a,b){let c=T,d=Z,e=Y;T=a;Z=!0;Y=null;try{return b()}finally{T=c,Z=d,Y=e}}
function kf(a){let b=a._pendingEditorState,c=a._rootElement,d=a._headless||null===c;if(null!==b){var e=a._editorState,f=e._selection,g=b._selection,h=0!==a._dirtyType,k=T,n=Z,m=Y,p=a._updating,l=a._observer,r=null;a._pendingEditorState=null;a._editorState=b;if(!d&&h&&null!==l){Y=a;T=b;Z=!1;a._updating=!0;try{let D=a._dirtyType,P=a._dirtyElements,Q=a._dirtyLeaves;l.disconnect();var u=D,x=P,y=Q;O=Ic=N="";Lc=2===u;Oc=null;R=a;Jc=a._config;Kc=a._nodes;Nc=R._listeners.mutation;Pc=x;Qc=y;Zc=e._nodeMap;
$c=b._nodeMap;Mc=b._readOnly;ad=new Map(a._keyToDOMMap);let ha=new Map;bd=ha;pd("root",null);bd=ad=Jc=$c=Zc=Qc=Pc=Kc=R=void 0;r=ha}catch(D){D instanceof Error&&a._onError(D);if(cf)throw D;lf(a,null,c,b);Ab(a);a._dirtyType=2;cf=!0;kf(a);cf=!1;return}finally{l.observe(c,df),a._updating=p,T=k,Z=n,Y=m}}b._readOnly||(b._readOnly=!0);var A=a._dirtyLeaves,aa=a._dirtyElements,ba=a._normalizedNodes,pa=a._updateTags,qa=a._deferred;h&&(a._dirtyType=0,a._cloneNotNeeded.clear(),a._dirtyLeaves=new Set,a._dirtyElements=
new Map,a._normalizedNodes=new Set,a._updateTags=new Set);var ze=a._decorators,Mb=a._pendingDecorators||ze,Af=b._nodeMap,Rc;for(Rc in Mb)Af.has(Rc)||(Mb===ze&&(Mb=$b(a)),delete Mb[Rc]);var ia=d?null:E(a._window);if(a._editable&&null!==ia&&(h||null===g||g.dirty)){Y=a;T=b;try{null!==l&&l.disconnect();if(h||null===g||g.dirty){let D=a._blockCursorElement;null!==D&&xc(D,a,c);a:{let P=ia.anchorNode,Q=ia.focusNode,ha=ia.anchorOffset,lb=ia.focusOffset,V=document.activeElement;if(!(pa.has("collaboration")&&
V!==c||null!==V&&Eb(V)))if(C(g)){var mb=g.anchor,Sc=g.focus,Ae=mb.key,Bf=Sc.key,Be=pc(a,Ae),Ce=pc(a,Bf),Nb=mb.offset,De=Sc.offset,Tc=g.format,Uc=g.style,Ee=g.isCollapsed(),nb=Be,Ob=Ce,Vc=!1;if("text"===mb.type){nb=Jb(Be);let W=mb.getNode();Vc=W.getFormat()!==Tc||W.getStyle()!==Uc}else C(f)&&"text"===f.anchor.type&&(Vc=!0);"text"===Sc.type&&(Ob=Jb(Ce));if(null!==nb&&null!==Ob){if(Ee&&(null===f||Vc||C(f)&&(f.format!==Tc||f.style!==Uc))){var Cf=performance.now();Jd=[Tc,Uc,Nb,Ae,Cf]}if(ha===Nb&&lb===
De&&P===nb&&Q===Ob&&("Range"!==ia.type||!Ee)&&(null!==V&&c.contains(V)||c.focus({preventScroll:!0}),"element"!==mb.type))break a;try{ia.setBaseAndExtent(nb,Nb,Ob,De)}catch(W){}if(!pa.has("skip-scroll-into-view")&&g.isCollapsed()&&null!==c&&c===document.activeElement){let W=g instanceof Ke&&"element"===g.anchor.type?nb.childNodes[Nb]||null:0<ia.rangeCount?ia.getRangeAt(0):null;if(null!==W){let X;if(W instanceof Text){let U=document.createRange();U.selectNode(W);X=U.getBoundingClientRect()}else X=W.getBoundingClientRect();
let wa=c.ownerDocument,Ea=wa.defaultView;if(null!==Ea)for(var {top:Wc,bottom:Xc}=X,Pb,Qb,na=c;null!==na;){let U=na===wa.body;if(U)Pb=0,Qb=Bb(a).innerHeight;else{let Rb=na.getBoundingClientRect();Pb=Rb.top;Qb=Rb.bottom}let Fa=0;Wc<Pb?Fa=-(Pb-Wc):Xc>Qb&&(Fa=Xc-Qb);if(0!==Fa)if(U)Ea.scrollBy(0,Fa);else{let Rb=na.scrollTop;na.scrollTop+=Fa;let Fe=na.scrollTop-Rb;Wc-=Fe;Xc-=Fe}if(U)break;na=Hb(na)}}}Fd=!0}}else null!==f&&Fb(a,P,Q)&&ia.removeAllRanges()}}a:{let D=a._blockCursorElement;if(C(g)&&g.isCollapsed()&&
"element"===g.anchor.type&&c.contains(document.activeElement)){let P=g.anchor,Q=P.getNode(),ha=P.offset,lb=Q.getChildrenSize(),V=!1,W=null;if(ha===lb){let X=Q.getChildAtIndex(ha-1);wc(X)&&(V=!0)}else{let X=Q.getChildAtIndex(ha);if(wc(X)){let wa=X.getPreviousSibling();if(null===wa||wc(wa))V=!0,W=a.getElementByKey(X.__key)}}if(V){let X=a.getElementByKey(Q.__key);if(null===D){let wa=a._config.theme,Ea=document.createElement("div");Ea.contentEditable="false";Ea.setAttribute("data-lexical-cursor","true");
let U=wa.blockCursor;if(void 0!==U){if("string"===typeof U){let Fa=U.split(" ");U=wa.blockCursor=Fa}void 0!==U&&Ea.classList.add(...U)}a._blockCursorElement=D=Ea}c.style.caretColor="transparent";null===W?X.appendChild(D):X.insertBefore(D,W);break a}}null!==D&&xc(D,a,c)}null!==l&&l.observe(c,df)}finally{Y=m,T=k}}if(null!==r){var Df=r;let D=Array.from(a._listeners.mutation),P=D.length;for(let Q=0;Q<P;Q++){let [ha,lb]=D[Q],V=Df.get(lb);void 0!==V&&ha(V,{dirtyLeaves:A,updateTags:pa})}}C(g)||null===g||
null!==f&&f.is(g)||a.dispatchCommand(ca,void 0);var Yc=a._pendingDecorators;null!==Yc&&(a._decorators=Yc,a._pendingDecorators=null,mf("decorator",a,!0,Yc));var Ef=ac(e),Ge=ac(b);Ef!==Ge&&mf("textcontent",a,!0,Ge);mf("update",a,!0,{dirtyElements:aa,dirtyLeaves:A,editorState:b,normalizedNodes:ba,prevEditorState:e,tags:pa});a._deferred=[];if(0!==qa.length){let D=a._updating;a._updating=!0;try{for(let P=0;P<qa.length;P++)qa[P]()}finally{a._updating=D}}var He=a._updates;if(0!==He.length){let D=He.shift();
if(D){let [P,Q]=D;nf(a,P,Q)}}}}function mf(a,b,c,...d){let e=b._updating;b._updating=c;try{let f=Array.from(b._listeners[a]);for(a=0;a<f.length;a++)f[a].apply(null,d)}finally{b._updating=e}}function S(a,b,c){if(!1===a._updating||Y!==a){let f=!1;a.update(()=>{f=S(a,b,c)});return f}let d=fc(a);for(let f=4;0<=f;f--)for(let g=0;g<d.length;g++){var e=d[g]._commands.get(b);if(void 0!==e&&(e=e[f],void 0!==e)){e=Array.from(e);let h=e.length;for(let k=0;k<h;k++)if(!0===e[k](c,a))return!0}}return!1}
function of(a,b){let c=a._updates;for(b=b||!1;0!==c.length;){var d=c.shift();if(d){let [e,f]=d,g;void 0!==f&&(d=f.onUpdate,g=f.tag,f.skipTransforms&&(b=!0),d&&a._deferred.push(d),g&&a._updateTags.add(g));e()}}return b}
function nf(a,b,c){let d=a._updateTags;var e,f=e=!1;if(void 0!==c){var g=c.onUpdate;e=c.tag;null!=e&&d.add(e);e=c.skipTransforms||!1;f=c.discrete||!1}g&&a._deferred.push(g);c=a._editorState;g=a._pendingEditorState;let h=!1;if(null===g||g._readOnly)g=a._pendingEditorState=new pf(new Map((g||c)._nodeMap)),h=!0;g._flushSync=f;f=T;let k=Z,n=Y,m=a._updating;T=g;Z=!1;a._updating=!0;Y=a;try{h&&(a._headless?null!=c._selection&&(g._selection=c._selection.clone()):g._selection=$e(a));let p=a._compositionKey;
b();e=of(a,e);bf(g,a);0!==a._dirtyType&&(e?ff(g,a):gf(g,a),of(a),Cc(c,g,a._dirtyLeaves,a._dirtyElements));p!==a._compositionKey&&(g._flushSync=!0);let l=g._selection;if(C(l)){let r=g._nodeMap,u=l.focus.key;void 0!==r.get(l.anchor.key)&&void 0!==r.get(u)||q(19)}else Rd(l)&&0===l._nodes.size&&(g._selection=null)}catch(p){p instanceof Error&&a._onError(p);a._pendingEditorState=c;a._dirtyType=2;a._cloneNotNeeded.clear();a._dirtyLeaves=new Set;a._dirtyElements.clear();kf(a);return}finally{T=f,Z=k,Y=n,
a._updating=m,Ub=0}0!==a._dirtyType||qf(g,a)?g._flushSync?(g._flushSync=!1,kf(a)):h&&Db(()=>{kf(a)}):(g._flushSync=!1,h&&(d.clear(),a._deferred=[],a._pendingEditorState=null))}function w(a,b,c){a._updating?a._updates.push([b,c]):nf(a,b,c)}class rf extends Zd{constructor(a){super(a)}decorate(){q(47)}isIsolated(){return!1}isInline(){return!0}isKeyboardSelectable(){return!0}}function z(a){return a instanceof rf}
class sf extends Zd{constructor(a){super(a);this.__last=this.__first=null;this.__indent=this.__format=this.__size=0;this.__dir=null}getFormat(){return this.getLatest().__format}getFormatType(){let a=this.getFormat();return ib[a]||""}getIndent(){return this.getLatest().__indent}getChildren(){let a=[],b=this.getFirstChild();for(;null!==b;)a.push(b),b=b.getNextSibling();return a}getChildrenKeys(){let a=[],b=this.getFirstChild();for(;null!==b;)a.push(b.__key),b=b.getNextSibling();return a}getChildrenSize(){return this.getLatest().__size}isEmpty(){return 0===
this.getChildrenSize()}isDirty(){let a=H()._dirtyElements;return null!==a&&a.has(this.__key)}isLastChild(){let a=this.getLatest(),b=this.getParentOrThrow().getLastChild();return null!==b&&b.is(a)}getAllTextNodes(){let a=[],b=this.getFirstChild();for(;null!==b;){B(b)&&a.push(b);if(F(b)){let c=b.getAllTextNodes();a.push(...c)}b=b.getNextSibling()}return a}getFirstDescendant(){let a=this.getFirstChild();for(;null!==a;){if(F(a)){let b=a.getFirstChild();if(null!==b){a=b;continue}}break}return a}getLastDescendant(){let a=
this.getLastChild();for(;null!==a;){if(F(a)){let b=a.getLastChild();if(null!==b){a=b;continue}}break}return a}getDescendantByIndex(a){let b=this.getChildren(),c=b.length;if(a>=c)return a=b[c-1],F(a)&&a.getLastDescendant()||a||null;a=b[a];return F(a)&&a.getFirstDescendant()||a||null}getFirstChild(){let a=this.getLatest().__first;return null===a?null:J(a)}getFirstChildOrThrow(){let a=this.getFirstChild();null===a&&q(45);return a}getLastChild(){let a=this.getLatest().__last;return null===a?null:J(a)}getLastChildOrThrow(){let a=
this.getLastChild();null===a&&q(96);return a}getChildAtIndex(a){var b=this.getChildrenSize();let c;if(a<b/2){c=this.getFirstChild();for(b=0;null!==c&&b<=a;){if(b===a)return c;c=c.getNextSibling();b++}return null}c=this.getLastChild();for(--b;null!==c&&b>=a;){if(b===a)return c;c=c.getPreviousSibling();b--}return null}getTextContent(){let a="",b=this.getChildren(),c=b.length;for(let d=0;d<c;d++){let e=b[d];a+=e.getTextContent();F(e)&&d!==c-1&&!e.isInline()&&(a+="\n\n")}return a}getTextContentSize(){let a=
0,b=this.getChildren(),c=b.length;for(let d=0;d<c;d++){let e=b[d];a+=e.getTextContentSize();F(e)&&d!==c-1&&!e.isInline()&&(a+=2)}return a}getDirection(){return this.getLatest().__dir}hasFormat(a){return""!==a?(a=hb[a],0!==(this.getFormat()&a)):!1}select(a,b){G();let c=v(),d=a,e=b;var f=this.getChildrenSize();if(!this.canBeEmpty())if(0===a&&0===b){if(a=this.getFirstChild(),B(a)||F(a))return a.select(0,0)}else if(!(void 0!==a&&a!==f||void 0!==b&&b!==f)&&(a=this.getLastChild(),B(a)||F(a)))return a.select();
void 0===d&&(d=f);void 0===e&&(e=f);f=this.__key;if(C(c))c.anchor.set(f,d,"element"),c.focus.set(f,e,"element"),c.dirty=!0;else return oe(f,d,f,e,"element","element");return c}selectStart(){let a=this.getFirstDescendant();return F(a)||B(a)?a.select(0,0):null!==a?a.selectPrevious():this.select(0,0)}selectEnd(){let a=this.getLastDescendant();return F(a)||B(a)?a.select():null!==a?a.selectNext():this.select()}clear(){let a=this.getWritable();this.getChildren().forEach(b=>b.remove());return a}append(...a){return this.splice(this.getChildrenSize(),
0,a)}setDirection(a){let b=this.getWritable();b.__dir=a;return b}setFormat(a){this.getWritable().__format=""!==a?hb[a]:0;return this}setIndent(a){this.getWritable().__indent=a;return this}splice(a,b,c){let d=c.length,e=this.getChildrenSize(),f=this.getWritable(),g=f.__key;var h=[],k=[];let n=this.getChildAtIndex(a+b),m=null,p=e-b+d;if(0!==a)if(a===e)m=this.getLastChild();else{var l=this.getChildAtIndex(a);null!==l&&(m=l.getPreviousSibling())}if(0<b){var r=null===m?this.getFirstChild():m.getNextSibling();
for(l=0;l<b;l++){null===r&&q(100);var u=r.getNextSibling(),x=r.__key;r=r.getWritable();Wb(r);k.push(x);r=u}}l=m;for(u=0;u<d;u++){x=c[u];null!==l&&x.is(l)&&(m=l=l.getPreviousSibling());r=x.getWritable();r.__parent===g&&p--;Wb(r);let y=x.__key;null===l?(f.__first=y,r.__prev=null):(l=l.getWritable(),l.__next=y,r.__prev=l.__key);x.__key===g&&q(76);r.__parent=g;h.push(y);l=x}a+b===e?null!==l&&(l.getWritable().__next=null,f.__last=l.__key):null!==n&&(a=n.getWritable(),null!==l?(b=l.getWritable(),a.__prev=
l.__key,b.__next=n.__key):a.__prev=null);f.__size=p;if(k.length&&(a=v(),C(a))){k=new Set(k);h=new Set(h);let {anchor:y,focus:A}=a;tf(y,k,h)&&Xd(y,y.getNode(),this,m,n);tf(A,k,h)&&Xd(A,A.getNode(),this,m,n);0!==p||this.canBeEmpty()||M(this)||this.remove()}return f}exportJSON(){return{children:[],direction:this.getDirection(),format:this.getFormatType(),indent:this.getIndent(),type:"element",version:1}}insertNewAfter(){return null}canIndent(){return!0}collapseAtStart(){return!1}excludeFromCopy(){return!1}canExtractContents(){return!0}canReplaceWith(){return!0}canInsertAfter(){return!0}canBeEmpty(){return!0}canInsertTextBefore(){return!0}canInsertTextAfter(){return!0}isInline(){return!1}isShadowRoot(){return!1}canMergeWith(){return!1}extractWithChild(){return!1}}
function F(a){return a instanceof sf}function tf(a,b,c){for(a=a.getNode();a;){let d=a.__key;if(b.has(d)&&!c.has(d))return!0;a=a.getParent()}return!1}
class uf extends sf{static getType(){return"root"}static clone(){return new uf}constructor(){super("root");this.__cachedText=null}getTopLevelElementOrThrow(){q(51)}getTextContent(){let a=this.__cachedText;return!Zb()&&0!==H()._dirtyType||null===a?super.getTextContent():a}remove(){q(52)}replace(){q(53)}insertBefore(){q(54)}insertAfter(){q(55)}updateDOM(){return!1}append(...a){for(let b=0;b<a.length;b++){let c=a[b];F(c)||z(c)||q(56)}return super.append(...a)}static importJSON(a){let b=bc();b.setFormat(a.format);
b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return{children:[],direction:this.getDirection(),format:this.getFormatType(),indent:this.getIndent(),type:"root",version:1}}collapseAtStart(){return!0}}function L(a){return a instanceof uf}function qf(a,b){b=b.getEditorState()._selection;a=a._selection;if(null!==a){if(a.dirty||!a.is(b))return!0}else if(null!==b)return!0;return!1}function vf(){return new pf(new Map([["root",new uf]]))}
function wf(a){let b=a.exportJSON();b.type!==a.constructor.getType()&&q(58);let c=b.children;if(F(a)){Array.isArray(c)||q(59);a=a.getChildren();for(let d=0;d<a.length;d++){let e=wf(a[d]);c.push(e)}}return b}
class pf{constructor(a,b){this._nodeMap=a;this._selection=b||null;this._readOnly=this._flushSync=!1}isEmpty(){return 1===this._nodeMap.size&&null===this._selection}read(a){return jf(this,a)}clone(a){a=new pf(this._nodeMap,void 0===a?this._selection:a);a._readOnly=!0;return a}toJSON(){return jf(this,()=>({root:wf(bc())}))}}
class xf extends sf{static getType(){return"paragraph"}static clone(a){return new xf(a.__key)}createDOM(a){let b=document.createElement("p");a=kc(a.theme,"paragraph");void 0!==a&&b.classList.add(...a);return b}updateDOM(){return!1}static importDOM(){return{p:()=>({conversion:yf,priority:0})}}exportDOM(a){({element:a}=super.exportDOM(a));a&&this.isEmpty()&&a.append(document.createElement("br"));if(a){var b=this.getFormatType();a.style.textAlign=b;if(b=this.getDirection())a.dir=b;b=this.getIndent();
0<b&&(a.style.textIndent=`${20*b}px`)}return{element:a}}static importJSON(a){let b=ae();b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return{...super.exportJSON(),type:"paragraph",version:1}}insertNewAfter(a,b){a=ae();let c=this.getDirection();a.setDirection(c);this.insertAfter(a,b);return a}collapseAtStart(){let a=this.getChildren();if(0===a.length||B(a[0])&&""===a[0].getTextContent().trim()){if(null!==this.getNextSibling())return this.selectNext(),
this.remove(),!0;if(null!==this.getPreviousSibling())return this.selectPrevious(),this.remove(),!0}return!1}}function yf(a){let b=ae();a.style&&(b.setFormat(a.style.textAlign),a=parseInt(a.style.textIndent,10)/20,0<a&&b.setIndent(a));return{node:b}}function ae(){return uc(new xf)}
function lf(a,b,c,d){let e=a._keyToDOMMap;e.clear();a._editorState=vf();a._pendingEditorState=d;a._compositionKey=null;a._dirtyType=0;a._cloneNotNeeded.clear();a._dirtyLeaves=new Set;a._dirtyElements.clear();a._normalizedNodes=new Set;a._updateTags=new Set;a._updates=[];a._blockCursorElement=null;d=a._observer;null!==d&&(d.disconnect(),a._observer=null);null!==b&&(b.textContent="");null!==c&&(c.textContent="",e.set("root",c))}
function zf(a){let b=new Map,c=new Set;a.forEach(d=>{d=null!=d.klass.importDOM?d.klass.importDOM.bind(d.klass):null;if(null!=d&&!c.has(d)){c.add(d);var e=d();null!==e&&Object.keys(e).forEach(f=>{let g=b.get(f);void 0===g&&(g=[],b.set(f,g));g.push(e[f])})}});return b}
class Ff{constructor(a,b,c,d,e,f,g){this._parentEditor=b;this._rootElement=null;this._editorState=a;this._compositionKey=this._pendingEditorState=null;this._deferred=[];this._keyToDOMMap=new Map;this._updates=[];this._updating=!1;this._listeners={decorator:new Set,editable:new Set,mutation:new Map,root:new Set,textcontent:new Set,update:new Set};this._commands=new Map;this._config=d;this._nodes=c;this._decorators={};this._pendingDecorators=null;this._dirtyType=0;this._cloneNotNeeded=new Set;this._dirtyLeaves=
new Set;this._dirtyElements=new Map;this._normalizedNodes=new Set;this._updateTags=new Set;this._observer=null;this._key=gc();this._onError=e;this._htmlConversions=f;this._editable=g;this._headless=null!==b&&b._headless;this._blockCursorElement=this._window=null}isComposing(){return null!=this._compositionKey}registerUpdateListener(a){let b=this._listeners.update;b.add(a);return()=>{b.delete(a)}}registerEditableListener(a){let b=this._listeners.editable;b.add(a);return()=>{b.delete(a)}}registerDecoratorListener(a){let b=
this._listeners.decorator;b.add(a);return()=>{b.delete(a)}}registerTextContentListener(a){let b=this._listeners.textcontent;b.add(a);return()=>{b.delete(a)}}registerRootListener(a){let b=this._listeners.root;a(this._rootElement,null);b.add(a);return()=>{a(null,this._rootElement);b.delete(a)}}registerCommand(a,b,c){void 0===c&&q(35);let d=this._commands;d.has(a)||d.set(a,[new Set,new Set,new Set,new Set,new Set]);let e=d.get(a);void 0===e&&q(36);let f=e[c];f.add(b);return()=>{f.delete(b);e.every(g=>
0===g.size)&&d.delete(a)}}registerMutationListener(a,b){void 0===this._nodes.get(a.getType())&&q(37);let c=this._listeners.mutation;c.set(b,a);return()=>{c.delete(b)}}registerNodeTransformToKlass(a,b){a=a.getType();a=this._nodes.get(a);void 0===a&&q(37);a.transforms.add(b);return a}registerNodeTransform(a,b){var c=this.registerNodeTransformToKlass(a,b);let d=[c];c=c.replaceWithKlass;null!=c&&(c=this.registerNodeTransformToKlass(c,b),d.push(c));cc(this,a.getType());return()=>{d.forEach(e=>e.transforms.delete(b))}}hasNodes(a){for(let b=
0;b<a.length;b++){let c=a[b].getType();if(!this._nodes.has(c))return!1}return!0}dispatchCommand(a,b){return S(this,a,b)}getDecorators(){return this._decorators}getRootElement(){return this._rootElement}getKey(){return this._key}setRootElement(a){let b=this._rootElement;if(a!==b){let e=kc(this._config.theme,"root");var c=this._pendingEditorState||this._editorState;this._rootElement=a;lf(this,b,a,c);if(null!==b){if(!this._config.disableEvents){0!==Ed&&(Ed--,0===Ed&&b.ownerDocument.removeEventListener("selectionchange",
Ud));c=b.__lexicalEditor;if(null!==c&&void 0!==c){if(null!==c._parentEditor){var d=fc(c);d=d[d.length-1]._key;Td.get(d)===c&&Td.delete(d)}else Td.delete(c._key);b.__lexicalEditor=null}c=Sd(b);for(d=0;d<c.length;d++)c[d]();b.__lexicalEventHandles=[]}null!=e&&b.classList.remove(...e)}null!==a?(c=(c=a.ownerDocument)&&c.defaultView||null,d=a.style,d.userSelect="text",d.whiteSpace="pre-wrap",d.wordBreak="break-word",a.setAttribute("data-lexical-editor","true"),this._window=c,this._dirtyType=2,Ab(this),
this._updateTags.add("history-merge"),kf(this),this._config.disableEvents||Vd(a,this),null!=e&&a.classList.add(...e)):this._window=null;mf("root",this,!1,a,b)}}getElementByKey(a){return this._keyToDOMMap.get(a)||null}getEditorState(){return this._editorState}setEditorState(a,b){a.isEmpty()&&q(38);zb(this);let c=this._pendingEditorState,d=this._updateTags;b=void 0!==b?b.tag:null;null===c||c.isEmpty()||(null!=b&&d.add(b),kf(this));this._pendingEditorState=a;this._dirtyType=2;this._dirtyElements.set("root",
!1);this._compositionKey=null;null!=b&&d.add(b);kf(this)}parseEditorState(a,b){a="string"===typeof a?JSON.parse(a):a;let c=vf(),d=T,e=Z,f=Y,g=this._dirtyElements,h=this._dirtyLeaves,k=this._cloneNotNeeded,n=this._dirtyType;this._dirtyElements=new Map;this._dirtyLeaves=new Set;this._cloneNotNeeded=new Set;this._dirtyType=0;T=c;Z=!1;Y=this;try{hf(a.root,this._nodes),b&&b(),c._readOnly=!0}catch(m){m instanceof Error&&this._onError(m)}finally{this._dirtyElements=g,this._dirtyLeaves=h,this._cloneNotNeeded=
k,this._dirtyType=n,T=d,Z=e,Y=f}return c}update(a,b){w(this,a,b)}focus(a,b={}){let c=this._rootElement;null!==c&&(c.setAttribute("autocapitalize","off"),w(this,()=>{let d=v(),e=bc();null!==d?d.dirty=!0:0!==e.getChildrenSize()&&("rootStart"===b.defaultSelection?e.selectStart():e.selectEnd())},{onUpdate:()=>{c.removeAttribute("autocapitalize");a&&a()},tag:"focus"}),null===this._pendingEditorState&&c.removeAttribute("autocapitalize"))}blur(){var a=this._rootElement;null!==a&&a.blur();a=E(this._window);
null!==a&&a.removeAllRanges()}isEditable(){return this._editable}setEditable(a){this._editable!==a&&(this._editable=a,mf("editable",this,!0,a))}toJSON(){return{editorState:this._editorState.toJSON()}}}
class Gf extends sf{constructor(a,b){super(b);this.__colSpan=a;this.__rowSpan=1}exportJSON(){return{...super.exportJSON(),colSpan:this.__colSpan,rowSpan:this.__rowSpan}}getColSpan(){return this.__colSpan}setColSpan(a){this.getWritable().__colSpan=a;return this}getRowSpan(){return this.__rowSpan}setRowSpan(a){this.getWritable().__rowSpan=a;return this}}function Oe(a){return a instanceof Gf}class Hf extends sf{}function Qe(a){return a instanceof Hf}class If extends sf{}
function Pe(a){return a instanceof If}exports.$addUpdateTag=function(a){G();H()._updateTags.add(a)};exports.$applyNodeReplacement=uc;exports.$copyNode=tc;exports.$createLineBreakNode=de;exports.$createNodeSelection=Ve;exports.$createParagraphNode=ae;exports.$createRangeSelection=function(){let a=new we("root",0,"element"),b=new we("root",0,"element");return new Ke(a,b,0,"")};exports.$createTabNode=re;exports.$createTextNode=K;exports.$getAdjacentNode=nc;exports.$getNearestNodeFromDOMNode=ub;
exports.$getNearestRootOrShadowRoot=sc;exports.$getNodeByKey=J;exports.$getPreviousSelection=ic;exports.$getRoot=bc;exports.$getSelection=v;exports.$getTextContent=function(){let a=v();return null===a?"":a.getTextContent()};exports.$hasAncestor=rc;exports.$hasUpdateTag=function(a){return H()._updateTags.has(a)};exports.$insertNodes=function(a,b){let c=v();null===c&&(c=bc().selectEnd());return c.insertNodes(a,b)};exports.$isBlockElementNode=Ue;exports.$isDecoratorNode=z;exports.$isElementNode=F;
exports.$isInlineElementOrDecoratorNode=function(a){return F(a)&&a.isInline()||z(a)&&a.isInline()};exports.$isLeafNode=Lb;exports.$isLineBreakNode=Sb;exports.$isNodeSelection=Rd;exports.$isParagraphNode=function(a){return a instanceof xf};exports.$isRangeSelection=C;exports.$isRootNode=L;exports.$isRootOrShadowRoot=M;exports.$isTabNode=function(a){return a instanceof ve};exports.$isTextNode=B;
exports.$nodesOfType=function(a){var b=Vb();let c=b._readOnly,d=a.getType();b=b._nodeMap;let e=[];for(let [,f]of b)f instanceof a&&f.__type===d&&(c||f.isAttached())&&e.push(f);return e};exports.$normalizeSelection__EXPERIMENTAL=Gc;exports.$parseSerializedNode=function(a){return hf(a,H()._nodes)};exports.$setCompositionKey=I;exports.$setSelection=xb;exports.$splitNode=yc;exports.BLUR_COMMAND=Sa;exports.CAN_REDO_COMMAND={};exports.CAN_UNDO_COMMAND={};exports.CLEAR_EDITOR_COMMAND={};
exports.CLEAR_HISTORY_COMMAND={};exports.CLICK_COMMAND=da;exports.COMMAND_PRIORITY_CRITICAL=4;exports.COMMAND_PRIORITY_EDITOR=0;exports.COMMAND_PRIORITY_HIGH=3;exports.COMMAND_PRIORITY_LOW=1;exports.COMMAND_PRIORITY_NORMAL=2;exports.CONTROLLED_TEXT_INSERTION_COMMAND=ka;exports.COPY_COMMAND=Pa;exports.CUT_COMMAND=Qa;exports.DELETE_CHARACTER_COMMAND=ea;exports.DELETE_LINE_COMMAND=ra;exports.DELETE_WORD_COMMAND=oa;exports.DEPRECATED_$computeGridMap=Re;
exports.DEPRECATED_$createGridSelection=function(){let a=new we("root",0,"element"),b=new we("root",0,"element");return new Le("root",a,b)};exports.DEPRECATED_$getNodeTriplet=function(a){a instanceof Gf||(a instanceof Zd?(a=zc(a,Oe),Oe(a)||q(114)):(a=zc(a.getNode(),Oe),Oe(a)||q(114)));let b=a.getParent();Pe(b)||q(115);let c=b.getParent();Qe(c)||q(116);return[a,b,c]};exports.DEPRECATED_$isGridCellNode=Oe;exports.DEPRECATED_$isGridNode=Qe;exports.DEPRECATED_$isGridRowNode=Pe;
exports.DEPRECATED_$isGridSelection=Me;exports.DEPRECATED_GridCellNode=Gf;exports.DEPRECATED_GridNode=Hf;exports.DEPRECATED_GridRowNode=If;exports.DRAGEND_COMMAND=Oa;exports.DRAGOVER_COMMAND=Na;exports.DRAGSTART_COMMAND=Ma;exports.DROP_COMMAND=La;exports.DecoratorNode=rf;exports.ElementNode=sf;exports.FOCUS_COMMAND=Ra;exports.FORMAT_ELEMENT_COMMAND={};exports.FORMAT_TEXT_COMMAND=sa;exports.INDENT_CONTENT_COMMAND={};exports.INSERT_LINE_BREAK_COMMAND=fa;exports.INSERT_PARAGRAPH_COMMAND=ja;
exports.INSERT_TAB_COMMAND={};exports.KEY_ARROW_DOWN_COMMAND=Ca;exports.KEY_ARROW_LEFT_COMMAND=za;exports.KEY_ARROW_RIGHT_COMMAND=xa;exports.KEY_ARROW_UP_COMMAND=Ba;exports.KEY_BACKSPACE_COMMAND=Ha;exports.KEY_DELETE_COMMAND=Ja;exports.KEY_DOWN_COMMAND=va;exports.KEY_ENTER_COMMAND=Da;exports.KEY_ESCAPE_COMMAND=Ia;exports.KEY_MODIFIER_COMMAND=Ta;exports.KEY_SPACE_COMMAND=Ga;exports.KEY_TAB_COMMAND=Ka;exports.LineBreakNode=be;exports.MOVE_TO_END=ya;exports.MOVE_TO_START=Aa;
exports.OUTDENT_CONTENT_COMMAND={};exports.PASTE_COMMAND=la;exports.ParagraphNode=xf;exports.REDO_COMMAND=ua;exports.REMOVE_TEXT_COMMAND=ma;exports.RootNode=uf;exports.SELECTION_CHANGE_COMMAND=ca;exports.TabNode=ve;exports.TextNode=je;exports.UNDO_COMMAND=ta;exports.createCommand=function(){return{}};
exports.createEditor=function(a){var b=a||{},c=Y,d=b.theme||{};let e=void 0===a?c:b.parentEditor||null,f=b.disableEvents||!1,g=vf(),h=b.namespace||(null!==e?e._config.namespace:gc()),k=b.editorState,n=[uf,je,be,ve,xf,...(b.nodes||[])],m=b.onError;b=void 0!==b.editable?b.editable:!0;if(void 0===a&&null!==c)a=c._nodes;else for(a=new Map,c=0;c<n.length;c++){let l=n[c],r=null;var p=null;"function"!==typeof l&&(p=l,l=p.replace,r=p.with,p=p.withKlass?p.withKlass:null);let u=l.getType(),x=l.transform(),
y=new Set;null!==x&&y.add(x);a.set(u,{klass:l,replace:r,replaceWithKlass:p,transforms:y})}d=new Ff(g,e,a,{disableEvents:f,namespace:h,theme:d},m?m:console.error,zf(a),b);void 0!==k&&(d._pendingEditorState=k,d._dirtyType=2);return d};exports.getNearestEditorFromDOMNode=Gb;exports.isSelectionCapturedInDecoratorInput=Eb;exports.isSelectionWithinEditor=Fb


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 55234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = __webpack_require__(53765)


/***/ }),

/***/ 80983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var db = __webpack_require__(55234)
var extname = (__webpack_require__(62520).extname)

/**
 * Module variables.
 * @private
 */

var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/
var TEXT_TYPE_REGEXP = /^text\//i

/**
 * Module exports.
 * @public
 */

exports.charset = charset
exports.charsets = { lookup: charset }
exports.contentType = contentType
exports.extension = extension
exports.extensions = Object.create(null)
exports.lookup = lookup
exports.types = Object.create(null)

// Populate the extensions/types maps
populateMaps(exports.extensions, exports.types)

/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function charset (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)
  var mime = match && db[match[1].toLowerCase()]

  if (mime && mime.charset) {
    return mime.charset
  }

  // default text/* to utf-8
  if (match && TEXT_TYPE_REGEXP.test(match[1])) {
    return 'UTF-8'
  }

  return false
}

/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */

function contentType (str) {
  // TODO: should this even be in this module?
  if (!str || typeof str !== 'string') {
    return false
  }

  var mime = str.indexOf('/') === -1
    ? exports.lookup(str)
    : str

  if (!mime) {
    return false
  }

  // TODO: use content-type or other module
  if (mime.indexOf('charset') === -1) {
    var charset = exports.charset(mime)
    if (charset) mime += '; charset=' + charset.toLowerCase()
  }

  return mime
}

/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function extension (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)

  // get extensions
  var exts = match && exports.extensions[match[1].toLowerCase()]

  if (!exts || !exts.length) {
    return false
  }

  return exts[0]
}

/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */

function lookup (path) {
  if (!path || typeof path !== 'string') {
    return false
  }

  // get the extension ("ext" or ".ext" or full path)
  var extension = extname('x.' + path)
    .toLowerCase()
    .substr(1)

  if (!extension) {
    return false
  }

  return exports.types[extension] || false
}

/**
 * Populate the extensions and types maps.
 * @private
 */

function populateMaps (extensions, types) {
  // source preference (least -> most)
  var preference = ['nginx', 'apache', undefined, 'iana']

  Object.keys(db).forEach(function forEachMimeType (type) {
    var mime = db[type]
    var exts = mime.extensions

    if (!exts || !exts.length) {
      return
    }

    // mime -> extensions
    extensions[type] = exts

    // extension -> mime
    for (var i = 0; i < exts.length; i++) {
      var extension = exts[i]

      if (types[extension]) {
        var from = preference.indexOf(db[types[extension]].source)
        var to = preference.indexOf(mime.source)

        if (types[extension] !== 'application/octet-stream' &&
          (from > to || (from === to && types[extension].substr(0, 12) === 'application/'))) {
          // skip the remapping
          continue
        }
      }

      // set the extension -> mime
      types[extension] = type
    }
  })
}


/***/ }),

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(36616)


/***/ }),

/***/ 73767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41065);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _FormComponents_TextInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42641);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41148);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








var REGION_LABELS = _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].REGION_LABELS */ .Z.REGION_LABELS;
var REGIONS_FRONTENT_MAPPING = {};
var REGIONS = "us,sg,eu,uk,is,global".split(",").map(function (region) {
  var name = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(REGION_LABELS, [region], "");
  var url;

  if (region === "global") {
    url = "https://app.qure.ai";
  } else {
    url = "https://".concat(region, "-app.qure.ai");
  }

  REGIONS_FRONTENT_MAPPING[url] = region;
  return {
    name: name,
    url: url
  };
});

var RegionDropdown = function RegionDropdown(_ref) {
  var selectedRegion = _ref.selectedRegion,
      setSelectedRegion = _ref.setSelectedRegion;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  var isMobile = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([_hooks_useMedia__WEBPACK_IMPORTED_MODULE_5__/* .MediaSizes.MOBILE */ ._.MOBILE], [true], false);

  var onRegionClick = function onRegionClick(e, url) {
    e.preventDefault();
    var selectedRegion = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(REGIONS_FRONTENT_MAPPING, [url]);
    setSelectedRegion(selectedRegion);
    setShowDropdown(false);
  };

  var filteredRegions;
  filteredRegions = REGIONS.filter(function (_ref2) {
    var name = _ref2.name;
    return name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  if (filteredRegions.length === 0) {
    filteredRegions = REGIONS.filter(function (_ref3) {
      var name = _ref3.name;
      return name.toLowerCase().includes("global".toLowerCase());
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "mx-5 relative",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "rounded-8 text-gray-200 ",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_FormComponents_TextInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        label: "Region",
        value: searchTerm,
        onChange: setSearchTerm,
        onClick: function onClick() {
          setShowDropdown(true);
        },
        placeholder: REGION_LABELS[selectedRegion],
        name: "search-region",
        id: "search-region",
        wrapperClassName: "my-5 w-full pr-3 ".concat(showDropdown && "border border-teal-500"),
        leftContent: function leftContent() {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
              d: "M12.9283 21.5511C14.9375 19.0367 19.5198 12.9426 19.5198 9.51964C19.5198 5.36817 16.1516 2 12.0001 2C7.84864 2 4.48047 5.36817 4.48047 9.51964C4.48047 12.9426 9.06275 19.0367 11.0719 21.5511C11.5536 22.1503 12.4466 22.1503 12.9283 21.5511ZM12.0001 7.0131C12.6649 7.0131 13.3024 7.27718 13.7725 7.74725C14.2426 8.21731 14.5067 8.85487 14.5067 9.51964C14.5067 10.1844 14.2426 10.822 13.7725 11.292C13.3024 11.7621 12.6649 12.0262 12.0001 12.0262C11.3353 12.0262 10.6978 11.7621 10.2277 11.292C9.75765 10.822 9.49356 10.1844 9.49356 9.51964C9.49356 8.85487 9.75765 8.21731 10.2277 7.74725C10.6978 7.27718 11.3353 7.0131 12.0001 7.0131Z",
              fill: "#81878D"
            })
          });
        },
        rightContent: function rightContent() {
          var content = showDropdown ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
              d: "M6 15L12 9L18 15",
              stroke: "#00A9A7",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
              d: "M6 9L12 15L18 9",
              stroke: "#D9DBDD",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          });
          return content;
        },
        inputClassName: "placeholder-gray-100 !bg-gray-800",
        labelClassName: "bg-gray-800 text-gray-200",
        readOnly: isMobile
      })
    }), showDropdown && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "fixed top-0 left-0 h-screen w-screen z-[999]",
      onClick: function onClick() {
        setShowDropdown(false);
      }
    }), showDropdown && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "absolute -translate-y-full top-[-10px] md:top-auto md:translate-y-0 w-full grow z-[1000] bg-gray-800 border border-gray-600 rounded-8 divide-gray-700 divide-y-[1px]",
      children: filteredRegions.map(function (region, index) {
        var name = region.name,
            url = region.url;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          onClick: function onClick(e) {
            return onRegionClick(e, url);
          },
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("pl-5 py-3 flex items-center cursor-pointer hover:bg-gray-600 text-gray-200 outline-none", {
            "!border-b-[1px] !border-b-gray-700": index === filteredRegions.length - 1
          }),
          children: name
        }, name);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RegionDropdown);

/***/ }),

/***/ 95811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormCreator; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/FormComponents/SelectInput.tsx
var SelectInput = __webpack_require__(94440);
// EXTERNAL MODULE: ./components/FormComponents/TextInput.tsx
var TextInput = __webpack_require__(42641);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./components/FormComponents/DateTimeInput.jsx
var DateTimeInput = __webpack_require__(40563);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/FormComponents/TextareaInput.jsx




function TextareaInput(_ref) {
  var label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      className = _ref.className,
      required = _ref.required,
      unit = _ref.unit,
      disabled = _ref.disabled,
      type = _ref.type,
      inputMode = _ref.inputMode,
      bg = _ref.bg,
      title = _ref.title,
      rows = _ref.rows,
      isClinicalField = _ref.isClinicalField,
      wrapperClassName = _ref.wrapperClassName,
      inputClassName = _ref.inputClassName;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()("relative rounded-md py-3 px-2 text-gray-900 dark:text-gray-100", (0,defineProperty/* default */.Z)({
      "border border-gray-500": !isClinicalField,
      "opacity-50": disabled
    }, wrapperClassName, !!wrapperClassName)),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("flex text-base pb-4"),
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: classnames_default()("text-md text-left", {
        "dark:bg-gray-800 absolute left-4 -top-3 px-4": !isClinicalField,
        "bg-transparent flex mb-5 text-base": isClinicalField
      }),
      children: [label, " ", !!required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-red-500",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()("rounded border-0", (0,defineProperty/* default */.Z)({
          "bg-gray-100 dark:bg-gray-800 pb-2 px-3": isClinicalField
        }, className, !!className)),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
          type: type || "text",
          value: value,
          onChange: onChange,
          placeholder: placeholder,
          className: classnames_default()("block w-full rounded py-5 px-4 dark:bg-transparent scrollbar-light dark:scrollbar bg-gray-100 dark:border-0 placeholder:text-sm placeholder:sm:text-base resize-none border border-gray-300 focus:border-gray-300", (0,defineProperty/* default */.Z)({}, inputClassName, !!inputClassName)),
          required: required,
          disabled: disabled,
          inputMode: inputMode,
          rows: rows
        })
      }), !!unit && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-sm px-3 text-gray-400",
        children: unit
      })]
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./utils/servicesUtils.ts
var servicesUtils = __webpack_require__(39949);
;// CONCATENATED MODULE: ./hooks/useGetSignedUrlFromS3Url.tsx



var useGetSignedUrlFromS3Url = function useGetSignedUrlFromS3Url(patientUid, s3Url) {
  return (0,es.useQuery)(["signed-url", patientUid, s3Url], function () {
    return servicesUtils/* default.getService */.Z.getService("/patients/".concat(patientUid, "/upload/?s3_path=").concat(s3Url));
  }, {
    enabled: !!s3Url && !!patientUid
  });
};

/* harmony default export */ var hooks_useGetSignedUrlFromS3Url = (useGetSignedUrlFromS3Url);
// EXTERNAL MODULE: ./components/MediaViewer/index.jsx
var MediaViewer = __webpack_require__(61289);
// EXTERNAL MODULE: ./components/AwesomeIcon/index.tsx + 2 modules
var AwesomeIcon = __webpack_require__(38266);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(65735);
;// CONCATENATED MODULE: ./components/FormComponents/FileUpload.jsx













var FileUpload = function FileUpload(_ref) {
  var label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      className = _ref.className,
      required = _ref.required,
      unit = _ref.unit,
      disabled = _ref.disabled,
      type = _ref.type,
      inputMode = _ref.inputMode,
      bg = _ref.bg,
      patientUid = _ref.patientUid,
      inputClassName = _ref.inputClassName,
      subLabel = _ref.subLabel;

  var _useState = (0,react.useState)(),
      selectedFile = _useState[0],
      setSelectedFile = _useState[1];

  var _useState2 = (0,react.useState)(""),
      viewMedia = _useState2[0],
      setViewMedia = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      preview = _useState3[0],
      setPreview = _useState3[1];

  var s3Url = typeof value === "string" ? value : "";

  var _useGetSignedUrlFromS = hooks_useGetSignedUrlFromS3Url(patientUid, s3Url),
      data = _useGetSignedUrlFromS.data;

  var signedUrl = patientUid ? (0,lodash.get)(data, ["url"], "") : s3Url;
  (0,react.useEffect)(function () {
    if (!value) {
      setPreview("");
    }
  }, [value]);
  (0,react.useEffect)(function () {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    var objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    onChange(selectedFile); // free memory when ever this component is unmounted

    return function () {
      return URL.revokeObjectURL(objectUrl);
    };
  }, [selectedFile]);

  var handleUpload = function handleUpload(e) {
    var upload_files = (0,lodash.get)(e, ["target", "files"], {});

    if ((0,lodash.isEmpty)(upload_files)) {
      setSelectedFile(undefined);
      return;
    }

    setSelectedFile(upload_files[0]);
  };

  (0,react.useEffect)(function () {
    if (!(0,lodash.isEmpty)(signedUrl)) {
      setPreview(signedUrl);
    }
  }, [signedUrl]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MediaViewer/* default */.Z, {
      isOpen: !!viewMedia,
      onClose: function onClose() {
        return setViewMedia("");
      },
      url: viewMedia
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex flex-col w-full text-gray-900 dark:text-gray-100", {
        "!text-opacity-50": disabled
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex text-base pb-4"),
        children: [label, " ", !!required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-red-500 pl-2",
          children: "*"
        })]
      }), !!subLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-left text-md pb-4",
        children: subLabel
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()("flex flex-col sm:flex-row space-y-3 sm:space-y-0 justify-between", (0,defineProperty/* default */.Z)({}, className, !!className)),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()("flex cursor-pointer items-center group justify-center h-[150px] w-full rounded-md border border-dotted border-gray-600 dark:border-gray-600 bg-gray-100 dark:bg-gray-800", (0,defineProperty/* default */.Z)({
            "!bg-opacity-50 !border-opacity-50": disabled
          }, inputClassName, !!inputClassName)),
          onClick: function onClick() {
            if (preview) {
              setViewMedia(preview);
            }
          },
          children: preview ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative w-fit h-full",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()("absolute -right-2 -top-1 cursor-pointer ", {
                hidden: disabled
              }),
              onClick: function onClick(e) {
                e.stopPropagation();
                setPreview("");
                setSelectedFile();
                onChange("");
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_regular_svg_icons/* faXmark */.g82,
                size: "sm",
                className: "w-5 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-800 dark:text-white bg-gray-300 dark:bg-gray-500 rounded-full p-1"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: "object-contain h-full w-full mx-auto py-2",
              src: preview
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex w-full items-center h-full justify-center rounded cursor-pointer",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
              htmlFor: id,
              className: "h-full w-full space-x-3 text-gray-700 group-hover:text-gray-600  dark:text-gray-100 dark:group-hover:text-gray-200 flex items-center cursor-pointer justify-center p-4 px-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_light_svg_icons/* faFileArrowUp */.PQh,
                size: "lg",
                className: ""
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-center text-base",
                children: "Upload File"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                type: "file",
                onChange: handleUpload,
                name: name,
                id: id,
                className: "w-full hidden",
                accept: "image/*",
                required: required,
                disabled: disabled,
                inputMode: inputMode
              })]
            })
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var FormComponents_FileUpload = (FileUpload);
;// CONCATENATED MODULE: ./components/FormComponents/NIHSSChoice.jsx







var NIHSSChoice = function NIHSSChoice(props) {
  var choices = props.choices,
      label = props.label,
      description = props.description,
      value = props.value,
      number = props.number,
      onChange = props.onChange,
      disabled = props.disabled;
  var gradiantClass = "";

  if (value) {
    var totalCounts = Object.values(choices).length;
    var selected = Number(value) + 1;

    if (totalCounts / selected === totalCounts) {
      gradiantClass = "border-green-700 from-green-900";
    } else if (totalCounts / selected > 1) {
      gradiantClass = "border-yellow-700 from-yellow-900";
    } else if (totalCounts / selected <= 1) {
      gradiantClass = "border-red-500 from-red-900";
    }
  }

  var onClickOption = function onClickOption(newValue) {
    var _value = "";

    if (value != newValue) {
      _value = newValue;
    }

    onChange(_value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()("flex w-full font-normal", {
      "opacity-40": disabled
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-6 flex justify-end",
      children: number
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col ml-3 w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex justify-between mb-5 pr-3 bg-gradient-to-l", (0,defineProperty/* default */.Z)({
          "border-r-2 opacity-70": !!gradiantClass
        }, gradiantClass, !!gradiantClass)),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex",
            children: label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-gray-600 text-sm text-left",
            children: description
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex items-center",
          children: [value, !value && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-sm italic text-gray-600",
            children: "Select score"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap gap-4",
        children: Object.values(choices).map(function (choiceObj, index) {
          var choice = choiceObj.choice,
              score = choiceObj.score;
          var currentValue = String(score);
          var isSelected = value === currentValue;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              return !disabled && onClickOption(currentValue);
            },
            className: classnames_default()("relative flex flex-col justify-evenly border border-teal-500 rounded-lg w-[80px] h-[80px] cursor-pointer select-none", {
              "bg-teal-900 border-teal-900": isSelected,
              "text-gray-400 border-teal-900": value
            }),
            children: [isSelected && /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
              name: pro_regular_svg_icons/* faXmark */.g82,
              className: "text-teal-500 bg-teal-900 rounded-full absolute -top-2 -right-2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-gray-100",
              children: currentValue
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm text-gray-100",
              children: choice
            })]
          }, currentValue);
        })
      })]
    })]
  });
};

/* harmony default export */ var FormComponents_NIHSSChoice = (NIHSSChoice);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(59275);
// EXTERNAL MODULE: ./components/FormComponents/BloodPressure.jsx
var BloodPressure = __webpack_require__(58485);
;// CONCATENATED MODULE: ./components/FormComponents/BloodGlucose.jsx






var BloodGlucose = function BloodGlucose(props) {
  var value = props.value,
      onChange = props.onChange,
      id = props.id,
      unit = props.unit,
      onChangeUnit = props.onChangeUnit,
      required = props.required,
      disabled = props.disabled;
  var values = value && value.split("/");
  var low = (0,lodash.get)(values, [0], "");
  var high = (0,lodash.get)(values, [1], "");
  var unitOptions = [{
    id: "1",
    value: "mg/dL",
    label: "mg/dL"
  }, {
    id: "2",
    value: "mmol/L",
    label: "mmol/L"
  }];

  var onChangeValue = function onChangeValue(value, type) {
    if (!disabled && (value === "" || /^[0-9\b]+$/.test(value))) {
      var result = {
        low: low,
        high: high
      };
      result[type] = value;
      onChange(id, "".concat(result.low, "/").concat(result.high));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col mb-3",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex mb-5",
      children: ["Blood Glucose ", !!required && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-red-500 pl-2",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex items-center", {
        "opacity-50": disabled
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center bg-gray-800 p-3 rounded-6 w-44",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          className: "w-1/2 bg-transparent mr-4 border-b border-teal-500 text-center focus:outline-none",
          inputMode: "numeric",
          placeholder: "- -",
          value: low,
          maxLength: 3,
          disabled: disabled,
          onChange: function onChange(e) {
            return onChangeValue(e.target.value, "low");
          }
        }), "/", /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          className: "w-1/2 bg-transparent ml-4 border-b border-teal-500 text-center focus:outline-none",
          inputMode: "numeric",
          placeholder: "- -",
          value: high,
          maxLength: 3,
          disabled: disabled,
          onChange: function onChange(e) {
            return onChangeValue(e.target.value, "high");
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectInput/* default */.Z, {
        options: unitOptions,
        value: unit,
        onChange: onChangeUnit,
        disabled: disabled,
        className: "bg-gray-800 border-none ml-3 w-20 py-2"
      })]
    })]
  });
};

BloodGlucose.defaultProps = {
  value: "",
  onChange: function onChange() {},
  id: "",
  required: false,
  disabled: false
};
/* harmony default export */ var FormComponents_BloodGlucose = (BloodGlucose);
// EXTERNAL MODULE: ./components/FormComponents/CheckboxList.jsx
var CheckboxList = __webpack_require__(2446);
// EXTERNAL MODULE: ./components/common/Checkbox.tsx + 2 modules
var Checkbox = __webpack_require__(48831);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(595);
// EXTERNAL MODULE: ./components/FormComponents/RadioList.jsx
var RadioList = __webpack_require__(56222);
// EXTERNAL MODULE: ./utils/index.ts + 4 modules
var utils = __webpack_require__(48032);
// EXTERNAL MODULE: ./utils/Store.ts
var Store = __webpack_require__(54837);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
;// CONCATENATED MODULE: ./components/DynamicForm/FormCreator.jsx








 // import MultiSelectInput from "../FormComponents/MultiSelectInput";
// import { createEmptyFormValueObj, validateForm } from "./services/utlis";

 // import Progressbar from "./Progressbar";














 // select and multiselect --> each options array item requires id, label, value




function FormCreator(_ref) {
  var wrapperClassName = _ref.wrapperClassName,
      className = _ref.className,
      title = _ref.title,
      formSchema = _ref.formSchema,
      response = _ref.response,
      formName = _ref.formName,
      columns = _ref.columns,
      onClose = _ref.onClose,
      onSave = _ref.onSave,
      patientUid = _ref.patientUid,
      isIncomingForm = _ref.isIncomingForm,
      isSignatureForm = _ref.isSignatureForm,
      containerClassName = _ref.containerClassName,
      isButtonLoading = _ref.isButtonLoading;

  var _useState = (0,react.useState)({}),
      formResponse = _useState[0],
      setFormResponse = _useState[1]; // const [isFormDisabled, setFormDisabled] = useState(false);


  var _useState2 = (0,react.useState)(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showResetConfirm = _useState3[0],
      toggleResetConfirm = _useState3[1];

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var score = 0;

  if (formName === constants/* default.FORMS.STROKE_NIHSS */.Z.FORMS.STROKE_NIHSS) {
    score = Object.values(formResponse).reduce(function (prev, cur) {
      return Number(prev) + Number(cur);
    }, 0);
  }

  var hasEmptyRequiredFields = function hasEmptyRequiredFields() {
    return formSchema.some(function (field) {
      if (field.required && !formResponse[field === null || field === void 0 ? void 0 : field.id]) {
        return true;
      }

      return false;
    });
  };

  var isNonEmptyForm = Object.values(formResponse).some(function (val) {
    return !(0,lodash.isEmpty)(val) || (0,isValid["default"])(val) || val === true;
  }) && !hasEmptyRequiredFields();
  (0,react.useEffect)(function () {
    if (!(0,lodash.isEmpty)(formSchema)) {
      setFormResponse(response);
      setIsLoading(false);
    }
  }, [formSchema]);

  var _onChange = function onChange(id, value) {
    var _formResponse = (0,lodash.cloneDeep)(formResponse);

    (0,lodash.set)(_formResponse, [id], value);
    setFormResponse(_formResponse);
  };

  var onReset = function onReset() {
    var _formResponse = (0,lodash.cloneDeep)(formResponse);

    Object.keys(_formResponse).forEach(function (key) {
      (0,lodash.set)(_formResponse, [key], "");
    });
    setFormResponse(_formResponse);
    onCloseResetModal();
  };

  var submitHandler = function submitHandler() {
    if (isNonEmptyForm) {
      onSave(formResponse);
      Store/* default.update */.Z.update(function (s) {
        s.isFormSelectorVisible = false;
      });
    }
  };

  var onCloseResetModal = function onCloseResetModal() {
    toggleResetConfirm(false);
  }; // const calculateProgress = () => {
  //   if (!isEmpty(formSchema)) {
  //     const allFields = Object.values(formSchema)
  //     const emptyFields = allFields.filter((field) => {
  //       return field.value
  //     })
  //     return (emptyFields.length / allFields.length) * 100
  //   }
  //   return 0
  // }
  // const onSetNIHSSScore = (value) => {
  //   setScore(value)
  // }
  // const onToggleNIHSSScore = (isOpen) => {
  //   onReset()
  //   setFormDisabled(isOpen)
  // }


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex items-center justify-between bg-gray-200 dark:bg-gray-800 py-3 rounded-t pr-6 pl-4 text-gray-900 dark:text-white", {
        "pt-8": (0,utils/* isWebView */.vp)()
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center cursor-pointer",
        onClick: onClose,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
          name: pro_regular_svg_icons/* faChevronLeft */.A35,
          className: "w-5 mr-4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "font-semibold flex text-lg",
          children: title
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()("text-md underline cursor-pointer", {
          hidden: isIncomingForm
        }),
        onClick: function onClick() {
          return toggleResetConfirm(true);
        },
        children: "Reset"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("relative flex flex-col h-full text-center text-base bg-gray-100 dark:bg-gray-900 rounded-t overflow-y-auto", (0,defineProperty/* default */.Z)({}, wrapperClassName, !!wrapperClassName)),
      children: [!isLoading && /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        action: "",
        className: "flex flex-col h-full grow overflow-y-auto",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          submitHandler();
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()("flex flex-col h-full overflow-y-auto scrollbar px-5 sm:px-6 pt-4", (0,defineProperty/* default */.Z)({}, containerClassName, !!containerClassName)),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()("grid gap-5 py-5", {
              "grid-cols-1": columns == 1 || !columns,
              "grid-cols-2": columns == 2,
              "grid-cols-3": columns == 3,
              "gap-1 pt-4 pb-0": isSignatureForm
            }),
            children: formSchema.map(function (formItem) {
              var fieldKey = (0,lodash.get)(formItem, ["id"], "");
              var value = (0,lodash.get)(formResponse, [fieldKey], "");

              if (formItem.response_type === "text" || formItem.response_type === "number") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                  label: formItem.observation,
                  subLabel: formItem.subObservation,
                  value: value,
                  onChange: function onChange(val) {
                    return _onChange(fieldKey, val);
                  },
                  placeholder: formItem.placeholder,
                  isClinicalField: true,
                  unit: formItem.unit,
                  inputClassName: classnames_default()("bg-transparent", (0,defineProperty/* default */.Z)({}, formItem.inputClassName, !!formItem.inputClassName)),
                  labelClassName: formItem === null || formItem === void 0 ? void 0 : formItem.labelClassName,
                  parentClassName: formItem === null || formItem === void 0 ? void 0 : formItem.parentClassName,
                  type: formItem.response_type,
                  wrapperClassName: classnames_default()("col-span-1", (0,defineProperty/* default */.Z)({
                    "col-span-1": formItem.columnSpan == 1,
                    "col-span-2": formItem.columnSpan == 2,
                    "col-span-3": formItem.columnSpan == 3
                  }, "".concat(formItem.wrapperClassName), !!formItem.wrapperClassName)),
                  className: "w-40",
                  disabled: formItem.disabled || isIncomingForm,
                  required: formItem.required,
                  bg: "bg-gray-100"
                }, fieldKey);
              }

              if (formItem.response_type === "select") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectInput/* default */.Z, {
                  value: value,
                  onChange: function onChange(val) {
                    return _onChange(fieldKey, val);
                  },
                  options: formItem.options,
                  isClinicalField: true,
                  className: formItem.columnSpan == 1 ? "col-span-1" : formItem.columnSpan == 2 ? "col-span-2" : formItem.columnSpan == 3 ? "col-span-3" : "col-span-1",
                  label: formItem.observation,
                  disabled: formItem.disabled || isIncomingForm,
                  required: formItem.required,
                  placeholder: formItem.placeholder,
                  bg: "bg-gray-100"
                }, fieldKey);
              }

              if (formItem.response_type === "datetime" || formItem.response_type === "date") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(DateTimeInput/* default */.Z, {
                  label: formItem.observation,
                  value: value,
                  isClinicalField: true,
                  onChange: function onChange(val) {
                    return _onChange(fieldKey, val);
                  },
                  dateFormat: "dd/MM/yyyy",
                  datePlaceholder: "DD/MM/YYYY",
                  timeFormat: "h:mm aa",
                  timePlaceholder: "HH:MM aa",
                  hideTime: formItem.response_type === "date",
                  showTimeFirst: formItem.response_type !== "date",
                  className: formItem.columnSpan == 1 ? "col-span-1" : formItem.columnSpan == 2 ? "col-span-2" : formItem.columnSpan == 3 ? "col-span-3" : "col-span-1",
                  disabled: formItem.disabled || isIncomingForm,
                  required: formItem.required,
                  wrapperClassName: "mb-3",
                  unit: formItem.unit
                }, fieldKey);
              }

              if (formItem.response_type === "textarea") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextareaInput, {
                  title: formItem === null || formItem === void 0 ? void 0 : formItem.title,
                  label: formItem.observation,
                  value: value,
                  isClinicalField: true,
                  rows: formItem === null || formItem === void 0 ? void 0 : formItem.row,
                  onChange: function onChange(e) {
                    return _onChange(fieldKey, e.target.value);
                  },
                  placeholder: formItem.placeholder,
                  disabled: formItem.disabled || isIncomingForm,
                  required: formItem.required,
                  className: classnames_default()("w-full", (0,defineProperty/* default */.Z)({}, formItem === null || formItem === void 0 ? void 0 : formItem.className, !!formItem.className)),
                  inputClassName: formItem.inputClassName
                }, fieldKey);
              }

              if (formItem.response_type === "upload") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(FormComponents_FileUpload, {
                  value: value,
                  onChange: function onChange(file) {
                    return _onChange(fieldKey, file);
                  },
                  options: formItem.options,
                  placeholder: formItem.placeholder,
                  className: formItem.columnSpan == 1 ? "col-span-1" : formItem.columnSpan == 2 ? "col-span-2" : formItem.columnSpan == 3 ? "col-span-3" : "col-span-1",
                  inputClassName: formItem.inputClassName,
                  label: formItem.observation,
                  subLabel: formItem === null || formItem === void 0 ? void 0 : formItem.subObservation,
                  disabled: formItem.disabled || isIncomingForm,
                  required: formItem.required,
                  bg: "bg-gray-100",
                  unit: formItem.unit,
                  patientUid: patientUid
                }, fieldKey);
              }

              if (formItem.response_type === "multiple_choice") {
                var options = Object.values((0,lodash.get)(formItem, ["choices"], {})).map(function (choice) {
                  return {
                    value: choice.id,
                    label: choice.choice,
                    disabled: choice.disabled
                  };
                });
                return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxList/* default */.Z, {
                  label: (0,lodash.get)(formItem, ["observation"], ""),
                  subLabel: (0,lodash.get)(formItem, ["subObservation"], ""),
                  value: value,
                  options: options,
                  onChange: function onChange(val) {
                    return _onChange(fieldKey, val);
                  },
                  className: classnames_default()("ml-5", {
                    "grid grid-cols-2": isSignatureForm
                  }),
                  required: formItem.required,
                  disabled: isIncomingForm
                }, fieldKey);
              }

              if (formItem.response_type === "choice") {
                var _options = Object.values((0,lodash.get)(formItem, ["choices"], {})).map(function (choice) {
                  return {
                    value: choice.id,
                    label: choice.choice
                  };
                });

                return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioList/* default */.Z, {
                  label: (0,lodash.get)(formItem, ["observation"], ""),
                  value: value,
                  options: _options,
                  name: fieldKey,
                  onChange: function onChange(val) {
                    _onChange(fieldKey, val);
                  },
                  className: "ml-5",
                  required: formItem.required,
                  disabled: isIncomingForm
                }, fieldKey);
              }

              if (formItem.response_type === "bool") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                  id: fieldKey,
                  checked: value,
                  label: (0,lodash.get)(formItem, ["observation"], ""),
                  onChange: function onChange(val) {
                    return _onChange(fieldKey, val);
                  },
                  className: "py-3",
                  disabled: isIncomingForm
                }, fieldKey);
              }

              if (formItem.response_type === "blood_pressure") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(BloodPressure/* default */.Z, {
                  value: value,
                  title: (0,lodash.get)(formItem, ["observation"], ""),
                  onChange: function onChange(val) {
                    return _onChange(fieldKey, val);
                  },
                  id: fieldKey,
                  unit: (0,lodash.get)(formItem, ["unit"], ""),
                  className: "py-3",
                  required: formItem.required,
                  disabled: isIncomingForm
                }, fieldKey);
              }

              if (formItem.response_type === "blood_glucose") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(FormComponents_BloodGlucose, {
                  value: value,
                  onChange: _onChange,
                  id: fieldKey,
                  unit: (0,lodash.get)(formItem, ["unit"], ""),
                  onChangeUnit: function onChangeUnit() {},
                  required: formItem.required,
                  disabled: isIncomingForm
                }, fieldKey);
              }

              if (formItem.response_type === "nihss_choice") {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(FormComponents_NIHSSChoice, {
                  choices: (0,lodash.get)(formItem, ["choices"], {}),
                  label: (0,lodash.get)(formItem, ["observation"], ""),
                  description: (0,lodash.get)(formItem, ["description"], ""),
                  value: value,
                  number: fieldKey,
                  onChange: function onChange(value) {
                    return _onChange(fieldKey, value);
                  },
                  disabled: isIncomingForm
                }, fieldKey);
              }
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-full flex items-center justify-between p-4 px-6 dark:bg-gray-800 space-x-5 dark:border-0 border-t border-gray-600",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: formName === constants/* default.FORMS.STROKE_NIHSS */.Z.FORMS.STROKE_NIHSS && "Total score: ".concat(score)
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()({
              "flex justify-end space-x-4 w-full dark:border-t border-gray-700 !pt-4": isSignatureForm
            }),
            children: [isSignatureForm && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              isSecondary: true,
              className: "grow-1 flex space-x-2 px-6 py-3 ml-4",
              onClick: onClose,
              isPrimary: false,
              disabled: isButtonLoading,
              children: t("button.cancel")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              isPrimary: true,
              disabled: !isNonEmptyForm || isIncomingForm || (0,lodash.isEqual)(response, formResponse) || isButtonLoading,
              isLoading: isButtonLoading,
              onClick: submitHandler,
              className: "px-8 !py-3",
              children: isSignatureForm ? t("button.save") : t("button.submit")
            })]
          })]
        })]
      }), isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()("absolute h-full w-full z-20 bg-opacity-50 flex items-center justify-center bg-gray-500", (0,defineProperty/* default */.Z)({}, className, !!className)),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "h-8 w-8 border-dotted rounded-full border-gray-500 border-[5px] animate-spin"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default */.Z, {
      show: showResetConfirm,
      onClose: onCloseResetModal,
      title: "Reset this form?",
      className: "w-full sm:w-5/12 lg:w-4/12",
      closeOnClickAway: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "p-6",
        children: "Reseting this form will delete all the inputs entered. Proceed to reset?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center flex-col sm:justify-end sm:flex-row p-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isSecondary: true,
          className: "grow-1 ml-4 w-full sm:w-11",
          onClick: onCloseResetModal,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isPrimary: true,
          className: "mt-3 sm:mt-0 grow-1 ml-4 w-full sm:w-11",
          onClick: onReset,
          children: "Reset"
        })]
      })]
    })]
  });
}

/***/ }),

/***/ 13448:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function forceRenderViewport(viewportGridService, cornerstoneViewportService) {
  var renderingEngine = cornerstoneViewportService.getRenderingEngine();
  var viewports = renderingEngine.getViewports();

  if (viewports.length !== 0) {
    viewports.map(function (viewport) {
      viewport.resetCamera();
      viewport.render();
    });
  }
}

/* harmony default export */ __webpack_exports__["Z"] = (forceRenderViewport);

/***/ }),

/***/ 22169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H8": function() { return /* binding */ useStudiesState; },
/* harmony export */   "e4": function() { return /* binding */ StudiesStateProvider; }
/* harmony export */ });
/* unused harmony export StudiesStateContext */
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var DEFAULT_STATE = {
  loading: true,
  error: false,
  studies: []
};
var StudiesStateContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(DEFAULT_STATE);
function StudiesStateProvider(_ref) {
  var children = _ref.children,
      service = _ref.service;

  var studiesStateReducer = function studiesStateReducer(state, action) {
    switch (action.type) {
      case "loading":
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: action.payload
        });

      case "error":
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          error: action.payload
        });

      case "success":
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          error: false,
          studies: action.payload
        });

      default:
        return state;
    }
  };

  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(studiesStateReducer, DEFAULT_STATE),
      studiesState = _useReducer[0],
      dispatch = _useReducer[1];

  var getState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    return studiesState;
  }, [studiesState]);
  var setState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (type, payload) {
    return dispatch({
      type: type,
      payload: payload
    });
  }, [dispatch]);
  var api = {
    getState: getState,
    setState: setState
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StudiesStateContext.Provider, {
    value: api,
    children: children
  });
}
var useStudiesState = function useStudiesState() {
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(StudiesStateContext);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (StudiesStateProvider)));

/***/ }),

/***/ 63861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$V": function() { return /* reexport */ AppConfigProvider; },
  "Ic": function() { return /* reexport */ state_SidePanelsProvider; },
  "e4": function() { return /* reexport */ StudiesStateProvider/* StudiesStateProvider */.e4; },
  "LA": function() { return /* reexport */ sidePanelContext; },
  "MG": function() { return /* reexport */ useAppConfig; },
  "H8": function() { return /* reexport */ StudiesStateProvider/* useStudiesState */.H8; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/DynamicViewer/state/appConfig.js


var appConfigContext = /*#__PURE__*/(0,react.createContext)(null);
var Provider = appConfigContext.Provider;
var useAppConfig = function useAppConfig() {
  return (0,react.useContext)(appConfigContext);
};
function AppConfigProvider(_ref) {
  var children = _ref.children,
      initAppConfig = _ref.value;

  var _useState = (0,react.useState)(initAppConfig),
      appConfig = _useState[0],
      setAppConfig = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Provider, {
    value: [appConfig],
    children: children
  });
}
/* harmony default export */ var appConfig = ((/* unused pure expression or super */ null && (AppConfigProvider)));
// EXTERNAL MODULE: ./components/DynamicViewer/state/StudiesStateProvider.js
var StudiesStateProvider = __webpack_require__(22169);
// EXTERNAL MODULE: ./components/DynamicViewer/helper/forceRenderViewport.js
var forceRenderViewport = __webpack_require__(13448);
;// CONCATENATED MODULE: ./components/DynamicViewer/state/SidePanelsProvider.js



var sidePanelContext = /*#__PURE__*/(0,react.createContext)(null);
var SidePanelsProvider_Provider = sidePanelContext.Provider;

var SidePanelsProvider = function SidePanelsProvider(_ref) {
  var children = _ref.children,
      initialValue = _ref.value,
      servicesManager = _ref.servicesManager;

  var _useState = (0,react.useState)(initialValue.openStates),
      openStates = _useState[0],
      setOpenStates = _useState[1];

  var _servicesManager$serv = servicesManager.services,
      viewportGridService = _servicesManager$serv.viewportGridService,
      cornerstoneViewportService = _servicesManager$serv.cornerstoneViewportService;
  (0,react.useEffect)(function () {
    setTimeout(function () {
      (0,forceRenderViewport/* default */.Z)(viewportGridService, cornerstoneViewportService);
    }, [800]);
  }, [openStates]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SidePanelsProvider_Provider, {
    value: {
      openStates: openStates,
      setOpenStates: setOpenStates
    },
    children: children
  });
};

/* harmony default export */ var state_SidePanelsProvider = (SidePanelsProvider);
;// CONCATENATED MODULE: ./components/DynamicViewer/state/index.js





/***/ }),

/***/ 35801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ patientsExportService; },
/* harmony export */   "S": function() { return /* binding */ downloadFile; }
/* harmony export */ });
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39949);
/* harmony import */ var _utils_Store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54837);



function patientsExportService(url) {
  return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getService */ .Z.getService(url);
}

var downloadFile = function downloadFile() {
  var url = 'patients_export/get_download_link/';
  patientsExportService(url).then(function (response) {
    var _response$data;

    var link = document.createElement('a');
    link.href = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.csv_link;
    link.setAttribute('download', 'report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    _utils_Store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].update */ .Z.update(function (s) {
      s.showExportUpdate = false;
    });
  })["catch"](function (resp) {
    _utils_Store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].update */ .Z.update(function (s) {
      s.showExportUpdate = true;
      s.exportGenFailed = true;
    });
  });
};



/***/ }),

/***/ 58485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85331);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var BloodPressure = function BloodPressure(props) {
  var value = props.value,
      onChange = props.onChange,
      id = props.id,
      unit = props.unit,
      onChangeUnit = props.onChangeUnit,
      title = props.title,
      required = props.required,
      disabled = props.disabled;
  var values = value && value.split("/");
  var low = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(values, [0], "");
  var high = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(values, [1], "");

  var onChangeValue = function onChangeValue(value, type) {
    if (!disabled && (value === "" || /^[0-9\b]+$/.test(value))) {
      var result = {
        low: low,
        high: high
      };
      result[type] = value;
      onChange("".concat(result.low, "/").concat(result.high));
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: "flex flex-col mb-3",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "flex mb-5",
      children: [title, !!required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        className: "text-red-500 pl-2",
        children: "*"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex items-center", {
        "opacity-50": disabled
      }),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "flex items-center bg-gray-800 p-3 rounded-6 w-44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          id: "".concat(id, "_low"),
          className: "w-1/2 bg-transparent mr-4 border-b border-teal-500 text-center focus:outline-none",
          inputMode: "numeric",
          placeholder: "- -",
          value: low,
          maxLength: 3,
          disabled: disabled,
          onChange: function onChange(e) {
            return onChangeValue(e.target.value, "low");
          }
        }), "/", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
          id: "".concat(id, "_high"),
          className: "w-1/2 bg-transparent ml-4 border-b border-teal-500 text-center focus:outline-none",
          inputMode: "numeric",
          placeholder: "- -",
          value: high,
          maxLength: 3,
          disabled: disabled,
          onChange: function onChange(e) {
            return onChangeValue(e.target.value, "high");
          }
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Unit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        unit: unit,
        onChangeUnit: onChangeUnit
      })]
    })]
  });
};

BloodPressure.defaultProps = {
  value: "",
  onChange: function onChange() {},
  id: "",
  required: false,
  disabled: false
};
/* harmony default export */ __webpack_exports__["Z"] = (BloodPressure);

/***/ }),

/***/ 2446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common_Checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48831);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var CheckboxList = function CheckboxList(props) {
  var label = props.label,
      options = props.options,
      value = props.value,
      onChange = props.onChange,
      className = props.className,
      required = props.required,
      disabled = props.disabled,
      subLabel = props.subLabel;

  var onChangeValue = function onChangeValue(newVal) {
    var result = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.clone)(value) || [];

    if (result.includes(newVal)) {
      result = result.filter(function (r) {
        return r !== newVal;
      });
    } else {
      result.push(newVal);
    }

    onChange(result);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: "flex flex-col w-full text-gray-900 dark:text-gray-100 text-left",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("flex text-base pb-4"),
      children: [label, !!required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        className: "text-red-500 pl-2",
        children: "*"
      })]
    }), !!subLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
      className: "text-left text-md mb-2",
      children: subLabel
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("flex flex-col", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, className, !!className)),
      children: options.map(function (option) {
        var label = option.label,
            currentVal = option.value,
            child = option.child,
            isDisable = option.disabled;
        var isChecked = value.includes(currentVal);
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_common_Checkbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          id: currentVal,
          checked: isChecked,
          label: label,
          child: child,
          onChange: function onChange() {
            return onChangeValue(currentVal);
          },
          className: "py-2",
          disabled: disabled || isDisable
        }, currentVal);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CheckboxList);

/***/ }),

/***/ 40563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18698);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68779);
/* harmony import */ var _AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38266);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var DateTimeInput = function DateTimeInput(_ref) {
  var _classNames4;

  var label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      id = _ref.id,
      dateFormat = _ref.dateFormat,
      datePlaceholder = _ref.datePlaceholder,
      timeFormat = _ref.timeFormat,
      timePlaceholder = _ref.timePlaceholder,
      className = _ref.className,
      required = _ref.required,
      unit = _ref.unit,
      disabled = _ref.disabled,
      isClinicalField = _ref.isClinicalField,
      wrapperClassName = _ref.wrapperClassName,
      inputClassName = _ref.inputClassName,
      showTimeFirst = _ref.showTimeFirst,
      hideTime = _ref.hideTime;

  var onChangeDateTme = function onChangeDateTme(dateTime, isDate, step) {
    var _value = null;

    if (dateTime) {
      if (!!value) {
        _value = new Date(value);
        var newDateTime = new Date(dateTime);

        if (step === "next") {
          newDateTime.setDate(newDateTime.getDate() + 1);
        } else if (step === "prev") {
          newDateTime.setDate(newDateTime.getDate() - 1);
        }

        if (isDate) {
          _value.setDate(newDateTime.getDate());

          _value.setMonth(newDateTime.getMonth());

          _value.setFullYear(newDateTime.getFullYear());
        } else {
          _value.setHours(newDateTime.getHours());

          _value.setMinutes(newDateTime.getMinutes());
        }
      } else {
        _value = new Date(dateTime);
      }
    }

    onChange(_value);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative rounded-md px-2 max-w-lg text-gray-900 dark:text-gray-100", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
      "border border-gray-500": !isClinicalField,
      "opacity-50": disabled
    }, wrapperClassName, !!wrapperClassName)),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("label", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("text-md", {
        "bg-gray-800 absolute left-4 -top-3 px-4": !isClinicalField,
        "bg-transparent flex mb-5 text-base": isClinicalField
      }),
      children: [label, " ", !!required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        className: "text-red-500",
        children: "*"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex items-center gap-3 sm:gap-6", {
        "flex-row-reverse": showTimeFirst
      }),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex grow items-center gap-3", {
          "grow-0": hideTime
        }),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
          className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("h-[39px] w-[39px] dark:bg-gray-800 rounded-6 p-2", {
            "opacity-50 cursor-not-allowed": !value
          }),
          onClick: function onClick(e) {
            onChangeDateTme(value, true, "prev");
            e.preventDefault();
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faChevronLeft */ .A35
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex items-center grow rounded", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            "bg-gray-100 border border-gray-300 dark:border-none dark:bg-gray-800 py-1 px-3": isClinicalField
          }, className, !!className)),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            className: "fill-gray-600 dark:fill-gray-100",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("path", {
              d: "M8.825 16.25C8.14167 16.25 7.56667 16.0167 7.1 15.55C6.63333 15.0833 6.4 14.5083 6.4 13.825C6.4 13.1417 6.63333 12.5667 7.1 12.1C7.56667 11.6333 8.14167 11.4 8.825 11.4C9.50833 11.4 10.0833 11.6333 10.55 12.1C11.0167 12.5667 11.25 13.1417 11.25 13.825C11.25 14.5083 11.0167 15.0833 10.55 15.55C10.0833 16.0167 9.50833 16.25 8.825 16.25ZM4.5 22C4.1 22 3.75 21.85 3.45 21.55C3.15 21.25 3 20.9 3 20.5V5C3 4.6 3.15 4.25 3.45 3.95C3.75 3.65 4.1 3.5 4.5 3.5H6.125V2H7.75V3.5H16.25V2H17.875V3.5H19.5C19.9 3.5 20.25 3.65 20.55 3.95C20.85 4.25 21 4.6 21 5V20.5C21 20.9 20.85 21.25 20.55 21.55C20.25 21.85 19.9 22 19.5 22H4.5ZM4.5 20.5H19.5V9.75H4.5V20.5ZM4.5 8.25H19.5V5H4.5V8.25ZM4.5 8.25V5V8.25Z"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_datepicker__WEBPACK_IMPORTED_MODULE_7___default()), {
            id: id,
            selected: value ? new Date(value) : value,
            onChange: function onChange(val) {
              return onChangeDateTme(val, true);
            },
            placeholderText: datePlaceholder || dateFormat,
            required: required,
            dateFormat: dateFormat,
            disabled: disabled,
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex grow bg-transparent w-full border-0 pb-3", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
              "text-center !p-2 mb-1": isClinicalField
            }, inputClassName, !!inputClassName))
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
          className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("h-[39px] w-[39px] dark:bg-gray-800 rounded-6 p-2 cursor-pointer", {
            "opacity-50 cursor-not-allowed": !value
          }),
          onClick: function onClick(e) {
            onChangeDateTme(value, true, "next");
            e.preventDefault();
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faChevronRight */ ._tD
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex items-center grow rounded w-1/2 sm:w-auto", (_classNames4 = {
          "bg-gray-100 border border-gray-300 dark:border-none dark:bg-gray-800 py-1 px-3": isClinicalField
        }, (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_classNames4, className, !!className), (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_classNames4, "hidden", hideTime), _classNames4)),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          className: "fill-gray-600 dark:fill-gray-100",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("path", {
            d: "M15.675 16.825L16.8 15.7L12.825 11.7V6.675H11.325V12.3L15.675 16.825ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6333 2.2625 9.34167 2.7875 8.125C3.3125 6.90833 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3667 2 14.6583 2.2625 15.875 2.7875C17.0917 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90833 21.2125 8.125C21.7375 9.34167 22 10.6333 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0917 20.6875 15.875 21.2125C14.6583 21.7375 13.3667 22 12 22ZM12 20.5C14.3333 20.5 16.3333 19.6667 18 18C19.6667 16.3333 20.5 14.3333 20.5 12C20.5 9.66667 19.6667 7.66667 18 6C16.3333 4.33333 14.3333 3.5 12 3.5C9.66667 3.5 7.66667 4.33333 6 6C4.33333 7.66667 3.5 9.66667 3.5 12C3.5 14.3333 4.33333 16.3333 6 18C7.66667 19.6667 9.66667 20.5 12 20.5Z"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_datepicker__WEBPACK_IMPORTED_MODULE_7___default()), {
          selected: value ? new Date(value) : value,
          onChange: function onChange(val) {
            return onChangeDateTme(val, false);
          },
          showTimeSelect: true,
          showTimeSelectOnly: true,
          timeIntervals: 5,
          timeCaption: "Time",
          dateFormat: timeFormat,
          placeholderText: timePlaceholder || timeFormat,
          calendarClassName: "flex items-center justify-center",
          className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block bg-transparent w-full border-0 pb-3", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            "text-center !p-2 mb-1": isClinicalField
          }, inputClassName, !!inputClassName))
        })]
      }), !!unit && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        className: "text-md px-3 text-gray-400",
        children: unit
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DateTimeInput);

/***/ }),

/***/ 56222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var RadioList = function RadioList(props) {
  var label = props.label,
      name = props.name,
      options = props.options,
      value = props.value,
      onChange = props.onChange,
      className = props.className,
      required = props.required,
      disabled = props.disabled;

  var onChangeValue = function onChangeValue(newVal) {
    onChange(newVal);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "flex flex-col w-full text-gray-900 dark:text-gray-100 text-left",
    children: [!!label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("flex text-base pb-4"),
      children: [label, !!required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: "text-red-500 pl-2",
        children: "*"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("flex flex-col", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, className, !!className)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "space-y-4",
        children: options.map(function (option) {
          var label = option.label,
              currentVal = option.value;
          var id = name + currentVal;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("flex items-center", {
              "opacity-50": disabled
            }),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
              id: id,
              name: name,
              type: "radio",
              checked: value === currentVal,
              disabled: disabled,
              className: "h-5 w-5 border-gray-300 text-teal-500",
              onChange: function onChange() {
                return onChangeValue(currentVal);
              }
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
              htmlFor: id,
              className: "ml-3 block font-medium text-gray-700 dark:text-gray-200",
              children: label
            })]
          }, id);
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RadioList);

/***/ }),

/***/ 85331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _SelectInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94440);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Unit = function Unit(_ref) {
  var unit = _ref.unit,
      onChangeUnit = _ref.onChangeUnit;

  if (!!unit) {
    if (typeof unit === "string") {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: "text-md px-3 text-gray-400",
        children: unit
      });
    } else if (unit.length > 1) {
      var unitOptions = unit.map(function (un, idx) {
        return {
          id: idx,
          value: un,
          label: un
        };
      });
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SelectInput__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        options: unitOptions,
        value: unit,
        onChange: onChangeUnit,
        className: "bg-gray-800 border-none ml-3 w-20 py-2"
      });
    }
  }

  return null;
};

Unit.defaultProps = {
  unit: "",
  onChangeUnit: function onChangeUnit() {}
};
/* harmony default export */ __webpack_exports__["Z"] = (Unit);

/***/ }),

/***/ 56768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_InviteUsers; }
});

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-multi-email/dist/es6/index.js
var es6 = __webpack_require__(37217);
// EXTERNAL MODULE: ./node_modules/react-multi-email/dist/style.css
var style = __webpack_require__(50803);
// EXTERNAL MODULE: ./utils/index.ts + 4 modules
var utils = __webpack_require__(48032);
// EXTERNAL MODULE: ./components/UserGroupManagement/services/useGetUserGroups.js
var useGetUserGroups = __webpack_require__(85883);
// EXTERNAL MODULE: ./components/common/UserIcon.tsx
var UserIcon = __webpack_require__(48947);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/InviteUsers/inviteesList.jsx






var InviteesList = function InviteesList(_ref) {
  var title = _ref.title,
      list = _ref.list,
      onSelect = _ref.onSelect,
      isLoading = _ref.isLoading;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!!title && (isLoading || !(0,lodash.isEmpty)(list)) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "border-y border-gray-400 dark:border-gray-800 text-md font-medium p-3 mx-3",
      children: title
    }), !(0,lodash.isEmpty)(list) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "divide-y divide-gray-800 py-3",
      children: list.map(function (item) {
        var value = item.value,
            text = item.text,
            description = item.description;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          value: value,
          tabIndex: 0,
          className: "flex items-center justify-start p-2 hover:bg-teal-500 hover:text-white dark:hover:bg-teal-700 cursor-pointer w-full text-left",
          onClick: function onClick(e) {
            e.stopPropagation();
            onSelect(item);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center h-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(UserIcon/* default */.Z, {
              name: text,
              className: "h-7 w-7"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col ml-3",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: text
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm",
              children: description
            })]
          })]
        }, value);
      })
    }), isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex flex-col h-full w-full items-center justify-center overflow-hidden py-3",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-5 h-5 rounded-full text-blue-600 mr-3",
        role: "status"
      })
    })]
  });
};

/* harmony default export */ var InviteUsers_inviteesList = (InviteesList);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/InviteUsers/SelectedTag.jsx




var SelectedTag = function SelectedTag(_ref) {
  var label = _ref.label,
      isGroup = _ref.isGroup,
      onRemove = _ref.onRemove;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-tag": true,
    className: classnames_default()("!bg-gray-800 !rounded-full !text-gray-200", {
      "!bg-yellow-900": isGroup
    }),
    children: [label, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "data-tag-handle": true,
      onClick: onRemove,
      children: "\xD7"
    })]
  });
};

/* harmony default export */ var InviteUsers_SelectedTag = (SelectedTag);
// EXTERNAL MODULE: ./components/InviteUsers/services/useGetUsers.jsx
var useGetUsers = __webpack_require__(81239);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
;// CONCATENATED MODULE: ./components/InviteUsers/index.jsx













var InviteUsers = function InviteUsers(_ref) {
  var hasGroups = _ref.hasGroups,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      allowMultiple = _ref.allowMultiple;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(""),
      text = _useState[0],
      setText = _useState[1];

  var _useState2 = (0,react.useState)([]),
      invitees = _useState2[0],
      setInvitees = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      invalidEmails = _useState3[0],
      setInvalidEmails = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0,react.useState)(true),
      showControl = _useState5[0],
      toggleShowControl = _useState5[1];

  var timeout = null;

  var removeDuplicates = function removeDuplicates(list) {
    return list.filter(function (value, index, self) {
      return index === self.findIndex(function (t) {
        return t.email === value.email && t.id === value.id && t.value === value.value;
      });
    });
  };

  var _useGetUsers = (0,useGetUsers/* default */.Z)(text),
      usersObj = _useGetUsers.data,
      usersLoading = _useGetUsers.isLoading;

  var _useGetUserGroups = (0,useGetUserGroups/* default */.Z)(!!hasGroups),
      userGroupdData = _useGetUserGroups.data,
      groupsLoading = _useGetUserGroups.isLoading;

  var groups = (0,lodash.get)(userGroupdData, ["groups"], []);
  var users = (0,lodash.get)(usersObj, ["users"], []);
  var filteredGroups = groups.filter(function (g) {
    var _g$name, _g$name$toLowerCase;

    return g === null || g === void 0 ? void 0 : (_g$name = g.name) === null || _g$name === void 0 ? void 0 : (_g$name$toLowerCase = _g$name.toLowerCase()) === null || _g$name$toLowerCase === void 0 ? void 0 : _g$name$toLowerCase.includes(text.toLocaleLowerCase());
  });
  var onChangeInput = (0,react.useCallback)((0,lodash.debounce)(function (_text) {
    return setText(_text);
  }, 500), []);

  var onChangeInvitees = function onChangeInvitees(_invitees) {
    setInvitees(_invitees);
    onChange(invitees);

    if (!allowMultiple) {
      submitField(_invitees);
    }
  }; // hacks to solve issue: after selecting email from dropdown, input field is not getting cleared


  (0,react.useEffect)(function () {
    if (showControl) {
      timeout = setTimeout(function () {
        document.getElementById("emails-input").focus();
      }, 50);
    }

    return function () {
      return clearTimeout(timeout);
    };
  }, [showControl]);

  var clearText = function clearText() {
    setText("");
    toggleShowControl(false);
    timeout = setTimeout(function () {
      toggleShowControl(true);
    }, 0);
  };

  var onChangeText = function onChangeText(_text) {
    setOpen(true);
    onChangeInput(_text);
    setInvalidEmails([]);
  };

  var onChangeEmail = function onChangeEmail(_emails) {
    var _newInvitees = _emails.map(function (email) {
      var _inviteeObj = invitees.find(function (i) {
        return i.value === email;
      });

      if (!_inviteeObj) {
        var userObj = users.find(function (u) {
          return u.email === email;
        });

        if (userObj) {
          _inviteeObj = {
            value: userObj.email,
            text: userObj.name,
            description: userObj.email
          };
        } else {
          var groupObj = groups.find(function (g) {
            return g.id === email;
          });

          if (groupObj) {
            _inviteeObj = {
              value: groupObj.id,
              text: groupObj.name,
              description: "".concat(groupObj.id, " members")
            };
          }
        }
      }

      return _inviteeObj;
    });

    onChangeInvitees(removeDuplicates(_newInvitees));
  };

  var Placeholder = function Placeholder() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "text-gray-600 font-normal text-[14px]",
      children: t("share_placeholder")
    });
  };

  var onSelectInvitee = function onSelectInvitee(_invitee) {
    clearText();

    var _invitees = (0,lodash.clone)(invitees);

    _invitees.push(_invitee);

    onChangeInvitees(removeDuplicates(_invitees));
    setOpen(false);
  };

  var submitField = function submitField() {
    var _invitees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : invitees;

    setOpen(false);
    setInvitees([]);
    onSubmit(_invitees);
  };

  var onKeyPress = function onKeyPress(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      submitField();
    }
  };

  var groupsList = filteredGroups.map(function (g) {
    return {
      value: g.id,
      text: g.name,
      description: "".concat((0,lodash.get)(g, ["users", "length"], ""), " members")
    };
  });
  var usersList = users.map(function (u) {
    return {
      value: u.email,
      text: u.name,
      description: u.email
    };
  });
  var isOpen = open && (usersLoading || groupsLoading || !(0,lodash.isEmpty)(usersList) || !(0,lodash.isEmpty)(groupsList));
  var inviteesList = invitees.map(function (inv) {
    return inv.value;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col w-full",
    children: [isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute h-full w-full bg-gray-700 opacity-20 top-0 left-0",
      onClick: function onClick() {
        return setOpen(false);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative flex flex-col w-full rounded-lg !bg-gray-300 dark:!bg-gray-900 px-3",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "realtive flex flex-col w-full pb-3 ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative w-full rounded-lg !bg-gray-900",
          onClick: function onClick() {
            return setOpen(true);
          },
          children: [showControl && /*#__PURE__*/(0,jsx_runtime.jsx)(es6.ReactMultiEmail, {
            placeholder: /*#__PURE__*/(0,jsx_runtime.jsx)(Placeholder, {}),
            emails: inviteesList,
            id: "emails-input",
            className: "emails-input flex items-center justify-start !bg-gray-300 !text-gray-800 dark:!bg-gray-900 dark:!text-gray-200 w-full max-h-9 overflow-y-auto !border-0 !border-b hover:!border-teal-500 !rounded-none !rounded-t-lg !px-0 !pb-0",
            validateEmail: function validateEmail(email) {
              // using this as an "onChange" event and getting rid of old values
              if (invalidEmails !== []) {
                setInvalidEmails([]);
              }

              if (email === "undefined") {
                return false;
              }

              var isValid = (0,utils/* isValidEmail */.vV)(email);

              if (isValid) {
                isValid = !(0,lodash.isEmpty)(users.find(function (u) {
                  return u.email === email;
                }));

                if (!isValid) {
                  var _invalidEmails = (0,lodash.clone)(invalidEmails);

                  _invalidEmails.push(email);

                  setInvalidEmails(Array.from(new Set(_invalidEmails)));
                }
              }

              return isValid;
            },
            onChange: onChangeEmail,
            onChangeInput: onChangeText,
            onKeyDown: onKeyPress,
            getLabel: function getLabel(email, index, removeEmail) {
              var inviteeObj = invitees.find(function (i) {
                return i.value === email;
              });
              var label = (0,lodash.get)(inviteeObj, ["text"], "");
              var isGroup = false;

              if (hasGroups && email) {
                var group = groups.find(function (g) {
                  return +g.id === +email;
                });
                isGroup = !(0,lodash.isEmpty)(group);
              }

              return /*#__PURE__*/(0,jsx_runtime.jsx)(InviteUsers_SelectedTag, {
                label: label,
                isGroup: isGroup,
                onRemove: function onRemove() {
                  return removeEmail(index);
                }
              }, index);
            }
          }), isOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "absolute z-200 bg-gray-200 dark:bg-gray-900 w-full rounded-b-lg border border-gray-200 dark:border-gray-800 max-h-60 overflow-y-auto shadow-2xl text-left",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InviteUsers_inviteesList, {
              list: usersList,
              onSelect: onSelectInvitee,
              isLoading: usersLoading
            }), hasGroups && /*#__PURE__*/(0,jsx_runtime.jsx)(InviteUsers_inviteesList, {
              title: "Groups",
              list: groupsList,
              onSelect: onSelectInvitee,
              isLoading: groupsLoading
            })]
          })]
        })
      })
    }), !(0,lodash.isEmpty)(invalidEmails) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex text-red-600 text-md px-3",
      children: "".concat(invalidEmails.join(","), " ").concat(t("share_not_registered"))
    })]
  });
};

InviteUsers.defaultProps = {
  hasGroups: false,
  onChange: function onChange() {},
  onSubmit: function onSubmit() {},
  allowMultiple: false
};
/* harmony default export */ var components_InviteUsers = (InviteUsers);

/***/ }),

/***/ 81239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39949);



var useGetUsers = function useGetUsers(search) {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(["users", search], function () {
    return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getService */ .Z.getService("/accounts/users/?emails=".concat(search));
  }, {
    enabled: !!search && search.length > 1
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useGetUsers);

/***/ }),

/***/ 61289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44080);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69737);
/* harmony import */ var _AwesomeIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38266);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68779);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48032);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var MediaViewer = function MediaViewer(props) {
  var _url$split$;

  var isOpen = props.isOpen,
      onClose = props.onClose,
      url = props.url,
      className = props.className;
  var img_name = "".concat((_url$split$ = url.split("?")[0]) === null || _url$split$ === void 0 ? void 0 : _url$split$.split("/").slice(-1)[0]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition.Root */ .u.Root, {
    show: isOpen,
    as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog */ .V, {
      as: "div",
      className: "relative z-50",
      onClose: onClose,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition.Child */ .u.Child, {
        as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "fixed inset-0 bg-gray-900 sm:bg-zinc-900 sm:bg-opacity-70 transition-opacity"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "fixed flex flex-col h-full inset-0 z-10",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "flex min-h-full h-full items-center justify-center text-center sm:p-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition.Child */ .u.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            enterTo: "opacity-100 translate-y-0 sm:scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog.Panel */ .V.Panel, {
              className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex flex-col items-center justify-center transform shadow-xl transition-all w-full h-full sm:w-fit sm:h-fit rounded-lg bg-transparent text-white", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, className, !!className)),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("bg-gray-800 w-full p-4 flex justify-between items-center", {
                  "pt-8": (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .isWebView */ .vp)()
                }),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                  children: img_name
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                  onClick: onClose,
                  className: "cursor-pointer",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_8__/* .faXmark */ .g82,
                    size: "xl",
                    className: "w-6 text-white"
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: "p-4 bg-gray-900 h-full w-full",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
                  src: url,
                  className: "!object-contain w-fit h-full sm:h-fit max-w-xs mx-auto sm:max-w-md lg:max-w-lg xl:max-w-2xl"
                })
              })]
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MediaViewer);

/***/ }),

/***/ 58980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_NotificationSettings; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./components/common/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(79175);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(59275);
// EXTERNAL MODULE: ./components/Toast/index.jsx + 2 modules
var Toast = __webpack_require__(10921);
// EXTERNAL MODULE: ./components/Loader/index.tsx
var Loader = __webpack_require__(88741);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./utils/servicesUtils.ts
var servicesUtils = __webpack_require__(39949);
;// CONCATENATED MODULE: ./components/NotificationSettings/hooks/useNotificationSettings.ts



var useNotificationSettings = function useNotificationSettings(isOpen) {
  return (0,react_query_es.useQuery)(["notificationSettings", isOpen], function () {
    return servicesUtils/* default.getService */.Z.getService("/profile/notifications/");
  }, {
    enabled: isOpen,
    staleTime: 0
  });
};

/* harmony default export */ var hooks_useNotificationSettings = (useNotificationSettings);
// EXTERNAL MODULE: ./components/NotificationSettings/hooks/useSaveNotificationSettings.ts
var useSaveNotificationSettings = __webpack_require__(72153);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/common/Checkbox.tsx + 2 modules
var Checkbox = __webpack_require__(48831);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(595);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/NotificationSettings/FindingsTagModal.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var FindingsTagModal = function FindingsTagModal(props) {
  var showFindingModal = props.showFindingModal,
      onCloseModal = props.onCloseModal,
      onChangeFindings = props.onChangeFindings,
      findingDetails = props.findingDetails,
      name = props.name;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    title: t("setting_notification"),
    onClose: onCloseModal,
    show: showFindingModal,
    className: "flex flex-col w-full sm:w-7/12 lg:w-6/12 xl:w-4/12 h-4/5 overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "p-6 overflow-y-auto scrollbar",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "pb-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "font-bold mb-2 text-left",
          children: t("findings_modal_notify")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-gray-700 dark:text-gray-300 text-sm text-left",
          children: t("findings_modal_info")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "font-bold text-left py-3",
        children: t(name)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: findingDetails === null || findingDetails === void 0 ? void 0 : findingDetails.map(function (detail, index) {
          var _detail$findings_list;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
              id: t(detail === null || detail === void 0 ? void 0 : detail.name),
              className: "w-full py-3 pr-2",
              checked: detail === null || detail === void 0 ? void 0 : detail.enabled,
              onChange: function onChange() {
                onChangeFindings(_objectSpread(_objectSpread({}, detail), {}, {
                  enabled: !(detail !== null && detail !== void 0 && detail.enabled)
                }), index);
              },
              label: t(detail.name)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "grid sm:grid-cols-2 ml-6 gap-y-2",
              children: detail === null || detail === void 0 ? void 0 : (_detail$findings_list = detail.findings_list) === null || _detail$findings_list === void 0 ? void 0 : _detail$findings_list.map(function (list, _index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    id: t(list === null || list === void 0 ? void 0 : list.name),
                    className: "w-full my-2 pr-2",
                    disabled: !detail.enabled,
                    checked: list === null || list === void 0 ? void 0 : list.enabled,
                    onChange: function onChange() {
                      onChangeFindings(_objectSpread(_objectSpread({}, list), {}, {
                        enabled: !list.enabled
                      }), index, _index);
                    },
                    label: t(list.name)
                  })
                }, _index);
              })
            })]
          }, index);
        })
      })]
    })
  });
};

FindingsTagModal.defaultProps = {
  onChange: function onChange() {}
};
/* harmony default export */ var NotificationSettings_FindingsTagModal = (FindingsTagModal);
;// CONCATENATED MODULE: ./components/NotificationSettings/Category.js


function Category_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Category_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Category_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Category_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function Category(props) {
  var isDisabled = props.isDisabled,
      categoryDetails = props.categoryDetails,
      onChangeCategory = props.onChangeCategory,
      indexOf = props.indexOf;
  var name = categoryDetails.name,
      enabled = categoryDetails.enabled,
      sub_category = categoryDetails.sub_category; // count of totalFindings and enabledFindings

  var totalFindingsCount = 0;
  var enabledFindingsCount = 0;
  var active_sub_category = (0,lodash.filter)(sub_category, {
    enabled: true
  }); // Iterate through sub_category and count enabled findings_list

  active_sub_category === null || active_sub_category === void 0 ? void 0 : active_sub_category.forEach(function (category) {
    var _category$findings_li;

    if ((category === null || category === void 0 ? void 0 : (_category$findings_li = category.findings_list) === null || _category$findings_li === void 0 ? void 0 : _category$findings_li.length) > 0) {
      var _filter;

      enabledFindingsCount += (_filter = (0,lodash.filter)(category === null || category === void 0 ? void 0 : category.findings_list, {
        enabled: true
      })) === null || _filter === void 0 ? void 0 : _filter.length;
    } else if (category !== null && category !== void 0 && category.enabled) {
      enabledFindingsCount += 1;
    }
  }); // Iterate through sub_category and count total findings_list

  sub_category === null || sub_category === void 0 ? void 0 : sub_category.forEach(function (category) {
    var _category$findings_li2;

    if ((category === null || category === void 0 ? void 0 : (_category$findings_li2 = category.findings_list) === null || _category$findings_li2 === void 0 ? void 0 : _category$findings_li2.length) > 0) {
      var _category$findings_li3;

      totalFindingsCount += category === null || category === void 0 ? void 0 : (_category$findings_li3 = category.findings_list) === null || _category$findings_li3 === void 0 ? void 0 : _category$findings_li3.length;
    } else {
      totalFindingsCount += 1;
    }
  });

  var _useState = (0,react.useState)(false),
      showFindingModal = _useState[0],
      setShowFindingModal = _useState[1];

  var onCloseModal = function onCloseModal() {
    setShowFindingModal(false);
  };

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var onChangeFindings = function onChangeFindings(data, index, nested_index) {
    var _categoryDetails = (0,lodash.cloneDeep)(categoryDetails);

    if (typeof nested_index === "number") {
      (0,lodash.set)(_categoryDetails, ["sub_category", index, "findings_list", nested_index], data);
    } else {
      (0,lodash.set)(_categoryDetails, ["sub_category", index], data);
    }

    onChangeCategory(_categoryDetails, indexOf, true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex justify-start items-center space-x-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        id: name,
        label: t(name),
        checked: enabled,
        disabled: isDisabled,
        className: classnames_default()("py-2", {
          "opacity-50": isDisabled
        }),
        onChange: function onChange() {
          onChangeCategory(Category_objectSpread(Category_objectSpread({}, categoryDetails), {}, {
            enabled: !enabled
          }), indexOf);
        }
      }), (enabledFindingsCount > 0 || (sub_category === null || sub_category === void 0 ? void 0 : sub_category.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: function onClick() {
          setShowFindingModal(true);
        },
        disabled: !enabled || isDisabled,
        className: classnames_default()("text-teal-300", {
          "opacity-50": !enabled || isDisabled
        }),
        children: enabledFindingsCount === totalFindingsCount ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: t("notification_modal.all_findings")
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [enabledFindingsCount, " of ", totalFindingsCount, " findings"]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationSettings_FindingsTagModal, {
      showFindingModal: showFindingModal,
      onCloseModal: onCloseModal,
      onChangeFindings: onChangeFindings,
      findingDetails: sub_category,
      name: name
    })]
  });
}

/* harmony default export */ var NotificationSettings_Category = (Category);
;// CONCATENATED MODULE: ./components/NotificationSettings/SubSection.js


function SubSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SubSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SubSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











function SubSection(props) {
  var subSectionDetails = props.subSectionDetails,
      isDisabled = props.isDisabled,
      selectionType = props.selectionType,
      onChangeSubSection = props.onChangeSubSection,
      indexOf = props.indexOf;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var name = subSectionDetails.name,
      enabled = subSectionDetails.enabled,
      category = subSectionDetails.category;

  var onChangeCategory = function onChangeCategory(data, index, isSkip) {
    var _subSectionDetails = (0,lodash.cloneDeep)(subSectionDetails);

    if (isSkip) {
      (0,lodash.set)(_subSectionDetails, ["category", index], data);
    } else {
      if ((_subSectionDetails === null || _subSectionDetails === void 0 ? void 0 : _subSectionDetails.selection) === "single") {
        forEach(_subSectionDetails["category"], function (item) {
          if (data.name === item.name) {
            item.enabled = true;
          } else {
            item.enabled = false;
          }
        });
      } else {
        (0,lodash.set)(_subSectionDetails, ["category", index], data);
      }
    }

    onChangeSubSection(_subSectionDetails, indexOf, true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-start py-2 pl-6 sm:pl-0",
      children: selectionType === "single" ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()({
          "opacity-50": isDisabled
        }),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          id: name,
          name: t(name),
          type: "radio",
          checked: enabled,
          disabled: isDisabled,
          onChange: function onChange() {
            onChangeSubSection(SubSection_objectSpread(SubSection_objectSpread({}, subSectionDetails), {}, {
              enabled: true
            }), indexOf);
          },
          className: "h-5 w-5 dark:border-gray-300 text-teal-400 bg-transparent cursor-pointer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          htmlFor: name,
          className: "ml-3 dark:text-gray-200 cursor-pointer",
          children: t(name)
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          id: name,
          label: t(name),
          checked: enabled,
          onChange: function onChange() {
            onChangeSubSection(SubSection_objectSpread(SubSection_objectSpread({}, subSectionDetails), {}, {
              enabled: !enabled
            }), indexOf);
          },
          disabled: isDisabled,
          className: classnames_default()("py-2", {
            "opacity-50": isDisabled
          })
        })
      })
    }), category === null || category === void 0 ? void 0 : category.map(function (detail, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sm:px-7 pl-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationSettings_Category, {
          indexOf: index,
          categoryDetails: detail,
          isDisabled: isDisabled || !enabled,
          onChangeCategory: onChangeCategory
        })
      }, index);
    })]
  });
}

/* harmony default export */ var NotificationSettings_SubSection = (SubSection);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/BellAlertIcon.js

function BellAlertIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5"
  }));
}
const ForwardRef = react.forwardRef(BellAlertIcon);
/* harmony default export */ var esm_BellAlertIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/BellSlashIcon.js

function BellSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
  }));
}
const BellSlashIcon_ForwardRef = react.forwardRef(BellSlashIcon);
/* harmony default export */ var esm_BellSlashIcon = (BellSlashIcon_ForwardRef);
;// CONCATENATED MODULE: ./components/NotificationSettings/Section.js


function Section_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Section_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Section_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Section_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













function Section(props) {
  var sectionDetails = props.sectionDetails,
      isDisabled = props.isDisabled,
      onChangeSection = props.onChangeSection,
      indexOf = props.indexOf;
  var name = sectionDetails.name,
      enabled = sectionDetails.enabled,
      sound_alerts_enabled = sectionDetails.sound_alerts_enabled,
      selection = sectionDetails.selection,
      sub_section = sectionDetails.sub_section;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var onChangeSubSection = function onChangeSubSection(data, index, isSkip) {
    var _sectionDetails = (0,lodash.cloneDeep)(sectionDetails);

    if (isSkip) {
      (0,lodash.set)(_sectionDetails, ["sub_section", index], data);
    } else {
      if ((_sectionDetails === null || _sectionDetails === void 0 ? void 0 : _sectionDetails.selection) === "single") {
        (0,lodash.forEach)(_sectionDetails["sub_section"], function (item) {
          if (data.name === item.name) {
            item.enabled = true;
          } else {
            item.enabled = false;
          }
        });
      } else {
        (0,lodash.set)(_sectionDetails, ["sub_section", index], data);
      }
    }

    onChangeSection(_sectionDetails, indexOf);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex justify-between py-3 px-6 sm:px-0 bg-gray-800 sm:bg-transparent", {
        "mb-4 sm:mb-0": sound_alerts_enabled === undefined
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()("flex text-gray-800 dark:text-white text-base font-bold", {
          "opacity-50": isDisabled
        }),
        children: t(name)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center h-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toggle/* default */.Z, {
          value: enabled,
          disabled: isDisabled,
          onChange: function onChange() {
            var fin_data = Section_objectSpread(Section_objectSpread({}, sectionDetails), {}, {
              enabled: !enabled
            });

            if (name === "notify_emergency") {
              fin_data.sound_alerts_enabled = !enabled;
            }

            onChangeSection(fin_data, indexOf);
          }
        })
      })]
    }), sound_alerts_enabled !== undefined && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex justify-between border-y border-gray-700 py-3 mb-5 px-6 md:px-0", {
        "border-b-0": (sectionDetails === null || sectionDetails === void 0 ? void 0 : sectionDetails.name) === "notify_emergency"
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        id: "sound_alerts_enabled_".concat(name),
        className: "",
        disabled: !enabled && name !== "notify_emergency" || isDisabled,
        checked: sound_alerts_enabled,
        onChange: function onChange(val) {
          var fin_data = Section_objectSpread(Section_objectSpread({}, sectionDetails), {}, {
            sound_alerts_enabled: val
          });

          if (name === "notify_emergency") {
            fin_data.enabled = val;
          }

          onChangeSection(fin_data, indexOf);
        },
        label: t("sound_alerts_enabled"),
        labelClassName: "!text-md"
      }), sound_alerts_enabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(esm_BellAlertIcon, {
        className: classnames_default()("w-[20px] h-[20px] dark:text-gray-100", {
          "opacity-50": !enabled || isDisabled
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(esm_BellSlashIcon, {
        className: classnames_default()("w-[20px] h-[20px] dark:text-gray-100", {
          "opacity-50": !enabled || isDisabled
        })
      })]
    }), sub_section === null || sub_section === void 0 ? void 0 : sub_section.map(function (detail, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationSettings_SubSection, {
          indexOf: index,
          subSectionDetails: detail,
          isDisabled: isDisabled || !enabled,
          selectionType: selection,
          onChangeSubSection: onChangeSubSection
        })
      }, index);
    })]
  });
}

/* harmony default export */ var NotificationSettings_Section = (Section);
// EXTERNAL MODULE: ./utils/Store.ts
var Store = __webpack_require__(54837);
// EXTERNAL MODULE: ./node_modules/pullstate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(69196);
// EXTERNAL MODULE: ./utils/pushNotification.ts
var pushNotification = __webpack_require__(80271);
// EXTERNAL MODULE: ./hooks/useAuthService.ts
var useAuthService = __webpack_require__(52315);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
;// CONCATENATED MODULE: ./components/NotificationSettings/index.js



/* eslint-disable */




















var NotificationSettings = function NotificationSettings(props) {
  var _window, _window2, _window3, _window3$Notification;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isModal = props.isModal,
      isVisible = props.isVisible,
      onClose = props.onClose;

  var _useState = (0,react.useState)(true),
      isNotificationOn = _useState[0],
      setIsNotificationOn = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isSubscribeLoading = _useState2[0],
      setSubscribeLoading = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      settings = _useState3[0],
      setSettings = _useState3[1];

  var saveNotificationSettings = (0,useSaveNotificationSettings/* default */.Z)();

  var _useNotificationSetti = hooks_useNotificationSettings(!isModal || isVisible),
      settingsObj = _useNotificationSetti.data,
      isLoading = _useNotificationSetti.isLoading;

  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var isDesktopApp = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.electronAPI;

  var _useAuthService = (0,useAuthService/* default */.Z)(false),
      refetchProfile = _useAuthService.refetch;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      userInfo: s.userInfo,
      RNfcmToken: s.RNfcmToken,
      fcmToken: s.fcmToken
    };
  }),
      userInfo = _useStoreState.userInfo,
      fcmToken = _useStoreState.fcmToken,
      RNfcmToken = _useStoreState.RNfcmToken;

  var hasPermission = isMobileApp && !!RNfcmToken || ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$Notification = _window3.Notification) === null || _window3$Notification === void 0 ? void 0 : _window3$Notification.permission) === "granted";
  var isSubscribed = (0,lodash.get)(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return (0,lodash.get)(tokenObj, ["token"], "") === RNfcmToken || fcmToken;
  });
  var notification_snoozed = (0,lodash.get)(userInfo, ["settings", "notification_snoozed"], false);
  (0,react.useEffect)(function () {
    var notifications = (0,lodash.get)(settingsObj, ["notifications"], []);
    setSettings(notifications);
  }, [settingsObj]);
  (0,react.useEffect)(function () {
    if (!hasPermission || !isSubscribed) {
      setIsNotificationOn(false);
    } else {
      setIsNotificationOn(!notification_snoozed);
    }
  }, [notification_snoozed, hasPermission, isSubscribed]);

  var onChangeSection = function onChangeSection(data, index) {
    var _notifications = (0,lodash.cloneDeep)(settings);

    (0,lodash.set)(_notifications, [index], data);
    setSettings(_notifications);
  };

  var onSave = function onSave() {
    var payload = {
      notification_snoozed: !isNotificationOn,
      notifications: settings
    };
    saveNotificationSettings.mutateAsync(payload).then(function () {
      refetchProfile();
      Toast/* default.success */.Z.success(t("notification_modal.toast.saved_successfully"));
      onCloseModal();
    })["catch"](function () {
      Toast/* default.error */.Z.error(t("notification_modal.toast.saved_failed"));
    });
  };

  var onCloseModal = function onCloseModal() {
    onClose();

    if (isModal) {
      setSettings([]);
    }
  };

  var onUpdateSubscription = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _window4, _window4$ReactNativeW, data, subscription;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(isMobileApp && !hasPermission)) {
                _context.next = 5;
                break;
              }

              data = {
                event: constants/* default.RN_COMM_CONST.OPEN_APP_SETTINGS */.Z.RN_COMM_CONST.OPEN_APP_SETTINGS,
                data: null
              };
              (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$ReactNativeW = _window4.ReactNativeWebView) === null || _window4$ReactNativeW === void 0 ? void 0 : _window4$ReactNativeW.postMessage(JSON.stringify(data));
              _context.next = 14;
              break;

            case 5:
              setSubscribeLoading(true);
              _context.next = 8;
              return (0,pushNotification/* subscribeUserNotification */.Wo)(RNfcmToken);

            case 8:
              subscription = _context.sent;

              if (!subscription) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return refetchProfile();

            case 12:
              setSubscribeLoading(false);

            case 13:
              setSubscribeLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onUpdateSubscription() {
      return _ref.apply(this, arguments);
    };
  }();

  var getLink = function getLink(text, link) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: link,
      target: "_blank",
      className: "dark:text-yellow-500 text-yellow-200 cursor-pointer font-bold pl-2",
      children: text
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "sm:pb-5 overflow-y-auto scrollbar-light dark:scrollbar h-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sm:hidden text-gray-900 dark:text-white font-medium text-xl px-6 mb-6",
        children: t("setting_notification")
      }), !hasPermission || !isSubscribed ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "dark:bg-yellow-900 bg-yellow-600 text-left dark:text-white text-black p-4 px-6",
        children: isSubscribeLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
            size: "medium",
            label: "Please wait",
            className: "mr-3",
            containerClassName: "!py-0 flex !flex-row"
          })
        }) : isDesktopApp ? /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "pr-2 list-decimal list-inside",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: t("notification_modal.no_notification_app")
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [t("notification_modal.use_via"), " ", getLink("app.qure.ai", "https://app.qure.ai")]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [t("notification_modal.download"), " ", getLink("Android", "https://play.google.com/store/apps/details?id=app.qure.ai"), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "lowercase",
              children: t("or_key")
            }), getLink("iOS", "https://apps.apple.com/sg/app/qure-ai/id1631113024"), " ", t("notification_modal.mobile_devices")]
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "pr-2",
          children: [t("notification_modal.no_notifications_setting"), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "dark:text-yellow-500 text-yellow-200 cursor-pointer font-bold pl-2",
            onClick: onUpdateSubscription,
            children: t("notification_modal.update_settings")
          })]
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between dark:bg-gray-700 border-y sm:border sm:rounded-lg border-gray-600 sm:m-5 px-6 sm:px-5 py-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex text-gray-800 dark:text-white text-base font-bold",
            children: t("notifications_turned_on")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex items-center justify-center h-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toggle/* default */.Z, {
            value: isNotificationOn,
            onChange: function onChange() {
              return setIsNotificationOn(!isNotificationOn);
            }
          })
        })]
      }), isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
        size: "large",
        containerClassName: "h-full"
      }) : settings === null || settings === void 0 ? void 0 : settings.map(function (detail, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()("sm:mx-7 mb-2", {
            "sm:border-b border-gray-700 sm:pb-5 mb-5": (settings === null || settings === void 0 ? void 0 : settings.length) !== index + 1,
            "!pb-0": detail.name === "notify_emergency"
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationSettings_Section, {
            indexOf: index,
            sectionDetails: detail,
            isDisabled: !isNotificationOn,
            onChangeSection: onChangeSection
          })
        }, index);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center flex-row justify-end p-4 border-t border-t-gray-600",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        isSecondary: true,
        className: "grow-1 w-full sm:w-40",
        onClick: onCloseModal,
        children: t("button.cancel")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        isPrimary: true,
        disabled: isDesktopApp,
        isLoading: isLoading || saveNotificationSettings.isLoading,
        onClick: onSave,
        className: "sm:mt-0 grow-1 ml-4 w-full sm:w-40",
        children: t("button.save_changes")
      })]
    })]
  });
};

NotificationSettings.defaultProps = {
  onClose: function onClose() {},
  isModal: false,
  isVisible: false
};
/* harmony default export */ var components_NotificationSettings = (NotificationSettings);

/***/ }),

/***/ 6478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




function Tooltip(props) {
  var children = props.children,
      tooltipContainerStyles = props.tooltipContainerStyles,
      tooltipText = props.tooltipText,
      position = props.position,
      verticalPosition = props.verticalPosition,
      tooltipStyles = props.tooltipStyles,
      tooltipBg = props.tooltipBg,
      onMouseEnter_ = props.onMouseEnter,
      onMouseLeave_ = props.onMouseLeave,
      onClick_ = props.onClick;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var arrowBg = tooltipBg.split("-").slice(1, 3).join("-");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(tooltipContainerStyles, {
      relative: !tooltipContainerStyles.includes("absolute") && !tooltipContainerStyles.includes("fixed") && !tooltipContainerStyles.includes("static") && !tooltipContainerStyles.includes("relative")
    }),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("m-2", {}),
      onMouseEnter: function onMouseEnter() {
        if (typeof onMouseEnter_ === "function") onMouseEnter_();
        setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        if (typeof onMouseLeave_ === "function") onMouseLeave_();
        setIsHovered(false);
      },
      onClick: function onClick() {
        if (typeof onClick_ === "function") onClick_();
      },
      children: children
    }), isHovered && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("flex flex-col absolute z-[9999]", {
        "": verticalPosition === "bottom",
        "top-0 translate-y-[-100%]": verticalPosition === "top",
        "left-0": position === "left",
        "right-0": position === "right"
      }),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("w-0 h-0 border-l-[5px] border-l-[transparent] border-r-[5px] border-r-[transparent] border-".concat(arrowBg), {
          "order-1 border-b-[5px]": verticalPosition === "bottom",
          "order-2 border-t-[5px]": verticalPosition === "top",
          "mr-auto ml-4": position === "left",
          "ml-auto mr-4": position === "right"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()("min-w-max ".concat(tooltipStyles, " ").concat(tooltipBg), {
          "order-2": verticalPosition === "bottom",
          "order-1": verticalPosition === "top"
        }),
        children: tooltipText
      })]
    })]
  });
}

/***/ }),

/***/ 42608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27812);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39949);




var getPatients = function getPatients() {
  var apiParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prevData = arguments.length > 1 ? arguments[1] : undefined;
  var prevPage = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(prevData, ["data", "content"], []);
  var prevLastId = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(prevData, ["data", "last_id"], "");
  var search = apiParams.search,
      pagination_id = apiParams.pagination_id;
  return new Promise(function (resolve, reject) {
    _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postService */ .Z.postService("/patients/", apiParams).then(function (data) {
      var newData = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.clone)(data);
      var newPage = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(newData, ["data", "content"], []);
      var newLastId = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.get)(newData, ["data", "last_id"], "");

      if (prevLastId !== newLastId || search) {
        if (pagination_id) {
          newPage = [].concat((0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prevPage), (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newPage));
        }

        (0,lodash__WEBPACK_IMPORTED_MODULE_0__.set)(newData, ["data", "content"], newPage);
      }

      resolve(newData);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (getPatients);

/***/ }),

/***/ 82845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DynamicViewer_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63861);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48032);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_Store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54837);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pullstate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69196);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67421);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);










var PatientBio = function PatientBio(props) {
  var _getGender, _getGender2, _currentPatient$age2;

  var isSimple = props.isSimple;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var _useStudiesState = (0,_DynamicViewer_state__WEBPACK_IMPORTED_MODULE_0__/* .useStudiesState */ .H8)(),
      getState = _useStudiesState.getState;

  var _getState = getState(),
      studies = _getState.studies;

  var age = lodash__WEBPACK_IMPORTED_MODULE_4___default().get(studies, ["age"]);

  var gender = (_getGender = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getGender */ .IF)(lodash__WEBPACK_IMPORTED_MODULE_4___default().get(studies, ["gender"]))) === null || _getGender === void 0 ? void 0 : _getGender.shortLabel;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var _patientMetadata = {
      name: lodash__WEBPACK_IMPORTED_MODULE_4___default().get(studies, ["name"]),
      patientID: lodash__WEBPACK_IMPORTED_MODULE_4___default().get(studies, ["patient_id"])
    };
    _utils_Store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].update */ .Z.update(function (s) {
      s.patient = _patientMetadata;
    });
  }, [studies]);

  var _useStoreState = (0,pullstate__WEBPACK_IMPORTED_MODULE_5__/* .useStoreState */ .Kw)(_utils_Store__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, function (s) {
    return {
      currentPatient: s.patientDetail
    };
  }),
      currentPatient = _useStoreState.currentPatient;

  var _gender = (_getGender2 = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getGender */ .IF)(currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.gender)) === null || _getGender2 === void 0 ? void 0 : _getGender2.shortLabel;

  var __gender = _gender !== null && _gender !== void 0 ? _gender : gender;

  if (isSimple) {
    var _currentPatient$age;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("span", {
        className: "text-left mt-1",
        children: [(_currentPatient$age = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.age) !== null && _currentPatient$age !== void 0 ? _currentPatient$age : age, " Y"]
      }), ' | ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        className: "text-left mt-1",
        children: __gender || "NA"
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: "hidden md:flex items-center justify-start p-5 border-b text-gray-200 border-gray-800",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "mr-5",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "text-sm text-gray-400 font-bold uppercase",
        children: t("gender_label")
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "text-left mt-1",
        children: (_gender !== null && _gender !== void 0 ? _gender : gender) || "NA"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "mr-5",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "text-sm text-gray-400 font-bold uppercase",
        children: t("age_label")
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: "text-left mt-1",
        children: [(_currentPatient$age2 = currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.age) !== null && _currentPatient$age2 !== void 0 ? _currentPatient$age2 : age, " Y"]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PatientBio);

/***/ }),

/***/ 76720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Report_ReportEditor; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/react-speech-recognition/lib/index.js
var lib = __webpack_require__(52515);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalComposer.js
var LexicalComposer = __webpack_require__(22292);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalRichTextPlugin.js
var LexicalRichTextPlugin = __webpack_require__(86146);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalContentEditable.js
var LexicalContentEditable = __webpack_require__(6898);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalHistoryPlugin.js
var LexicalHistoryPlugin = __webpack_require__(4506);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalErrorBoundary.js
var LexicalErrorBoundary = __webpack_require__(77943);
var LexicalErrorBoundary_default = /*#__PURE__*/__webpack_require__.n(LexicalErrorBoundary);
// EXTERNAL MODULE: ./node_modules/@lexical/rich-text/LexicalRichText.js
var LexicalRichText = __webpack_require__(2903);
// EXTERNAL MODULE: ./node_modules/@lexical/table/LexicalTable.js
var LexicalTable = __webpack_require__(91058);
// EXTERNAL MODULE: ./node_modules/@lexical/list/LexicalList.js
var LexicalList = __webpack_require__(44783);
// EXTERNAL MODULE: ./node_modules/@lexical/code/LexicalCode.js
var LexicalCode = __webpack_require__(23277);
// EXTERNAL MODULE: ./node_modules/@lexical/link/LexicalLink.js
var LexicalLink = __webpack_require__(73435);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalLinkPlugin.js
var LexicalLinkPlugin = __webpack_require__(69421);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalListPlugin.js
var LexicalListPlugin = __webpack_require__(38957);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalTablePlugin.js
var LexicalTablePlugin = __webpack_require__(13760);
// EXTERNAL MODULE: ./node_modules/@lexical/html/LexicalHtml.js
var LexicalHtml = __webpack_require__(87592);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalComposerContext.js
var LexicalComposerContext = __webpack_require__(84260);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lexical/Lexical.js
var Lexical = __webpack_require__(32998);
;// CONCATENATED MODULE: ./components/Report/plugins/ListMaxIndentLevelPlugin.js


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






function getElementNodesInSelection(selection) {
  var nodesInSelection = selection.getNodes();

  if (nodesInSelection.length === 0) {
    return new Set([selection.anchor.getNode().getParentOrThrow(), selection.focus.getNode().getParentOrThrow()]);
  }

  return new Set(nodesInSelection.map(function (n) {
    return (0,Lexical.$isElementNode)(n) ? n : n.getParentOrThrow();
  }));
}

function isIndentPermitted(maxDepth) {
  var selection = (0,Lexical.$getSelection)();

  if (!(0,Lexical.$isRangeSelection)(selection)) {
    return false;
  }

  var elementNodesInSelection = getElementNodesInSelection(selection);
  var totalDepth = 0;
  /* eslint-disable */

  var _iterator = _createForOfIteratorHelper(elementNodesInSelection),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var elementNode = _step.value;

      if ((0,LexicalList.$isListNode)(elementNode)) {
        totalDepth = Math.max((0,LexicalList.$getListDepth)(elementNode) + 1, totalDepth);
      } else if ((0,LexicalList.$isListItemNode)(elementNode)) {
        var parent = elementNode.getParent();

        if (!(0,LexicalList.$isListNode)(parent)) {
          throw new Error("ListMaxIndentLevelPlugin: A ListItemNode must have a ListNode for a parent.");
        }

        totalDepth = Math.max((0,LexicalList.$getListDepth)(parent) + 1, totalDepth);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return totalDepth <= maxDepth;
}

function ListMaxIndentLevelPlugin(_ref) {
  var maxDepth = _ref.maxDepth;

  var _useLexicalComposerCo = (0,LexicalComposerContext.useLexicalComposerContext)(),
      _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react.useEffect)(function () {
    return editor.registerCommand(Lexical.INDENT_CONTENT_COMMAND, function () {
      return !isIndentPermitted(maxDepth !== null && maxDepth !== void 0 ? maxDepth : 7);
    }, Lexical.COMMAND_PRIORITY_HIGH);
  }, [editor, maxDepth]);
  return null;
}
;// CONCATENATED MODULE: ./components/Report/plugins/CodeHighlightPlugin.js




function CodeHighlightPlugin() {
  var _useLexicalComposerCo = (0,LexicalComposerContext.useLexicalComposerContext)(),
      _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react.useEffect)(function () {
    return (0,LexicalCode.registerCodeHighlighting)(editor);
  }, [editor]);
  return null;
}
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalAutoLinkPlugin.js
var LexicalAutoLinkPlugin = __webpack_require__(32358);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Report/plugins/AutoLinkPlugin.js



var URL_MATCHER = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
var EMAIL_MATCHER = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
var MATCHERS = [function (text) {
  var match = URL_MATCHER.exec(text);
  return match && {
    index: match.index,
    length: match[0].length,
    text: match[0],
    url: match[0]
  };
}, function (text) {
  var match = EMAIL_MATCHER.exec(text);
  return match && {
    index: match.index,
    length: match[0].length,
    text: match[0],
    url: "mailto:".concat(match[0])
  };
}];
function PlaygroundAutoLinkPlugin() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LexicalAutoLinkPlugin.AutoLinkPlugin, {
    matchers: MATCHERS
  });
}
// EXTERNAL MODULE: ./node_modules/@lexical/selection/LexicalSelection.js
var LexicalSelection = __webpack_require__(89408);
// EXTERNAL MODULE: ./node_modules/@lexical/utils/LexicalUtils.js
var LexicalUtils = __webpack_require__(76969);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./hooks/useMedia.ts
var useMedia = __webpack_require__(41148);
// EXTERNAL MODULE: ./components/FormComponents/SelectInput.tsx
var SelectInput = __webpack_require__(94440);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(59275);
// EXTERNAL MODULE: ./components/Report/nodes/ImageNode.tsx
var ImageNode = __webpack_require__(38292);
;// CONCATENATED MODULE: ./components/Report/plugins/ImagePlugin.ts






var INSERT_IMAGE_COMMAND = (0,Lexical.createCommand)("INSERT_IMAGE_COMMAND");
function ImagesPlugin(_ref) {
  var captionsEnabled = _ref.captionsEnabled;

  var _useLexicalComposerCo = (0,LexicalComposerContext.useLexicalComposerContext)(),
      _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react.useEffect)(function () {
    if (!editor.hasNodes([ImageNode/* ImageNode */.HJ])) {
      throw new Error("ImagesPlugin: ImageNode not registered on editor");
    }

    return (0,LexicalUtils.mergeRegister)(editor.registerCommand(INSERT_IMAGE_COMMAND, function (payload) {
      var imageNode = (0,ImageNode/* $createImageNode */.HB)(payload);
      (0,Lexical.$insertNodes)([imageNode]);

      if ((0,Lexical.$isRootOrShadowRoot)(imageNode.getParentOrThrow())) {
        (0,LexicalUtils.$wrapNodeInElement)(imageNode, Lexical.$createParagraphNode).selectEnd();
      }

      return true;
    }, Lexical.COMMAND_PRIORITY_EDITOR));
  }, [captionsEnabled, editor]);
  return null;
}
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./components/AwesomeIcon/index.tsx + 2 modules
var AwesomeIcon = __webpack_require__(38266);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(65735);
;// CONCATENATED MODULE: ./components/Report/plugins/ToolbarPlugin.js




















var LowPriority = 1;
var supportedBlockTypes = new Set(["paragraph", "quote", "code", "h1", "h2", "ul", "ol"]);
var blockTypeOptions = [{
  id: "paragraph",
  label: "Normal",
  value: "paragraph"
}, {
  id: "h1",
  label: "Large Heading",
  value: "h1"
}, {
  id: "h2",
  label: "Small Heading",
  value: "h2"
}, {
  id: "quote",
  label: "Quote",
  value: "quote"
}, {
  id: "code",
  label: "Code Block",
  value: "code"
}];
function ToolbarPlugin() {
  var _useLexicalComposerCo = (0,LexicalComposerContext.useLexicalComposerContext)(),
      _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  var isMobile = (0,useMedia/* default */.Z)([useMedia/* MediaSizes.MOBILE */._.MOBILE], [true], false);
  var toolbarRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      canUndo = _useState[0],
      setCanUndo = _useState[1];

  var _useState2 = (0,react.useState)(false),
      canRedo = _useState2[0],
      setCanRedo = _useState2[1];

  var _useState3 = (0,react.useState)("paragraph"),
      blockType = _useState3[0],
      setBlockType = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showBlockOptionsDropDown = _useState4[0],
      setShowBlockOptionsDropDown = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isBold = _useState5[0],
      setIsBold = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isItalic = _useState6[0],
      setIsItalic = _useState6[1];

  var _useState7 = (0,react.useState)("left"),
      alignment = _useState7[0],
      setAlignment = _useState7[1];

  var formatBulletList = function formatBulletList() {
    if (blockType !== "ul") {
      editor.dispatchCommand(LexicalList.INSERT_UNORDERED_LIST_COMMAND);
    } else {
      editor.dispatchCommand(LexicalList.REMOVE_LIST_COMMAND);
    }

    setShowBlockOptionsDropDown(false);
  };

  var formatNumberedList = function formatNumberedList() {
    if (blockType !== "ol") {
      editor.dispatchCommand(LexicalList.INSERT_ORDERED_LIST_COMMAND);
    } else {
      editor.dispatchCommand(LexicalList.REMOVE_LIST_COMMAND);
    }

    setShowBlockOptionsDropDown(false);
  };

  var updateToolbar = (0,react.useCallback)(function () {
    var selection = (0,Lexical.$getSelection)();

    if ((0,Lexical.$isRangeSelection)(selection)) {
      var anchorNode = selection.anchor.getNode();
      var element = anchorNode.getKey() === "root" ? anchorNode : anchorNode.getTopLevelElementOrThrow();
      var elementKey = element.getKey();
      var elementDOM = editor.getElementByKey(elementKey);

      if (elementDOM !== null) {
        if ((0,LexicalList.$isListNode)(element)) {
          var parentList = (0,LexicalUtils.$getNearestNodeOfType)(anchorNode, LexicalList.ListNode);
          var type = parentList ? parentList.getTag() : element.getTag();
          setBlockType(type);
        } else {
          var _type = (0,LexicalRichText.$isHeadingNode)(element) ? element.getTag() : element.getType();

          setBlockType(_type);
        }
      } // Update text format


      setIsBold(selection.hasFormat("bold"));
      setIsItalic(selection.hasFormat("italic")); // Update alignment

      setAlignment(element.getFormatType());
    }
  }, [editor]);
  (0,react.useEffect)(function () {
    return (0,LexicalUtils.mergeRegister)(editor.registerUpdateListener(function (_ref) {
      var editorState = _ref.editorState;
      editorState.read(function () {
        updateToolbar();
      });
    }), editor.registerCommand(Lexical.SELECTION_CHANGE_COMMAND, function () {
      updateToolbar();
      return false;
    }, LowPriority), editor.registerCommand(Lexical.CAN_UNDO_COMMAND, function (payload) {
      setCanUndo(payload);
      return false;
    }, LowPriority), editor.registerCommand(Lexical.CAN_REDO_COMMAND, function (payload) {
      setCanRedo(payload);
      return false;
    }, LowPriority));
  }, [editor, updateToolbar]);

  var formatParagraph = function formatParagraph() {
    if (blockType !== "paragraph") {
      editor.update(function () {
        var selection = (0,Lexical.$getSelection)();

        if ((0,Lexical.$isRangeSelection)(selection)) {
          (0,LexicalSelection.$wrapNodes)(selection, function () {
            return (0,Lexical.$createParagraphNode)();
          });
        }
      });
    }

    setShowBlockOptionsDropDown(false);
  };

  var formatLargeHeading = function formatLargeHeading() {
    if (blockType !== "h1") {
      editor.update(function () {
        var selection = (0,Lexical.$getSelection)();

        if ((0,Lexical.$isRangeSelection)(selection)) {
          (0,LexicalSelection.$wrapNodes)(selection, function () {
            return (0,LexicalRichText.$createHeadingNode)("h1");
          });
        }
      });
    }

    setShowBlockOptionsDropDown(false);
  };

  var formatSmallHeading = function formatSmallHeading() {
    if (blockType !== "h2") {
      editor.update(function () {
        var selection = (0,Lexical.$getSelection)();

        if ((0,Lexical.$isRangeSelection)(selection)) {
          (0,LexicalSelection.$wrapNodes)(selection, function () {
            return (0,LexicalRichText.$createHeadingNode)("h2");
          });
        }
      });
    }

    setShowBlockOptionsDropDown(false);
  };

  var formatQuote = function formatQuote() {
    if (blockType !== "quote") {
      editor.update(function () {
        var selection = (0,Lexical.$getSelection)();

        if ((0,Lexical.$isRangeSelection)(selection)) {
          (0,LexicalSelection.$wrapNodes)(selection, function () {
            return (0,LexicalRichText.$createQuoteNode)();
          });
        }
      });
    }

    setShowBlockOptionsDropDown(false);
  };

  var formatCode = function formatCode() {
    if (blockType !== "code") {
      editor.update(function () {
        var selection = (0,Lexical.$getSelection)();

        if ((0,Lexical.$isRangeSelection)(selection)) {
          (0,LexicalSelection.$wrapNodes)(selection, function () {
            return (0,LexicalCode.$createCodeNode)();
          });
        }
      });
    }

    setShowBlockOptionsDropDown(false);
  };

  var onChangeBlockType = function onChangeBlockType(value) {
    switch (value) {
      case "paragraph":
        return formatParagraph();

      case "h1":
        return formatLargeHeading();

      case "h2":
        return formatSmallHeading();

      case "quote":
        return formatQuote();

      case "code":
        return formatCode();
    }
  };

  var alignText = function alignText(align) {
    editor.dispatchCommand(Lexical.FORMAT_ELEMENT_COMMAND, align);
  };

  var onAddImage = function onAddImage() {
    var input = document.createElement("input");
    input.type = "file";
    input.multiple = false;
    input.accept = constants/* default.IMAGE_TYPES.map */.Z.IMAGE_TYPES.map(function (t) {
      return ".".concat(t);
    }).join(",");
    input.click();

    input.onchange = function () {
      var file = (0,lodash.get)(Array.from(input.files), [0], null);

      if (file) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onloadend = function () {
          var payload = {
            altText: "",
            src: fileReader.result,
            showCaption: false,
            captionsEnabled: false
          };
          editor.dispatchCommand(INSERT_IMAGE_COMMAND, payload);
        };
      }
    };
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()("flex items-center sm:justify-end px-2 py-3 border-b border-gray-800 mx-auto w-full flex-wrap"),
    ref: toolbarRef,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        editor.dispatchCommand(Lexical.UNDO_COMMAND);
      },
      disabled: !canUndo,
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        "hover:border": canUndo
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        className: "h-5 w-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        editor.dispatchCommand(Lexical.REDO_COMMAND);
      },
      disabled: !canRedo,
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        "hover:border": canRedo
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        className: "h-5 w-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-6 w-px bg-gray-400 mx-3"
    }), supportedBlockTypes.has(blockType) && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectInput/* default */.Z, {
      value: blockType,
      onChange: onChangeBlockType,
      options: blockTypeOptions,
      className: "w-48 h-7"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        editor.dispatchCommand(Lexical.FORMAT_TEXT_COMMAND, "bold");
      },
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: isBold
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 384 512",
        className: "h-5 w-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        editor.dispatchCommand(Lexical.FORMAT_TEXT_COMMAND, "italic");
      },
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: isItalic
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 384 512",
        className: "h-5 w-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-6 w-px bg-gray-400 mx-3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: formatBulletList,
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: blockType === "ul"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        className: "h-5 w-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: formatNumberedList,
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: blockType === "ol"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        className: "h-5 w-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-6 w-px bg-gray-400 mx-3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        return alignText("left");
      },
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: alignment === "left"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        className: "bi bi-text-left",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          d: "M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        return alignText("center");
      },
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: alignment === "center"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        className: "bi bi-text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          d: "M4 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        return alignText("right");
      },
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: alignment === "right"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        className: "bi bi-text-right",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          d: "M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: function onClick() {
        return alignText("justify");
      },
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: alignment === "justify"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        className: "bi bi-justify",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          d: "M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      onClick: onAddImage,
      className: classnames_default()("!p-3 mx-1 bg-transparent hover:bg-transparent text-gray-800 border-gray-600", {
        border: false
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
        name: pro_light_svg_icons/* faImage */.VmB,
        size: "2xs",
        className: "w-5 h-5 -scale-x-100"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/Report/themes/editorTheme.js
var editorTheme = {
  ltr: "ltr",
  rtl: "rtl",
  placeholder: "editor-placeholder",
  paragraph: "editor-paragraph",
  quote: "py-5 mx-7",
  heading: {
    h1: "text-2xl font-bold",
    h2: "text-xl font-bold",
    h3: "editor-heading-h3",
    h4: "editor-heading-h4",
    h5: "editor-heading-h5"
  },
  list: {
    nested: {
      listitem: "editor-nested-listitem"
    },
    ol: "list-decimal pl-7 my-5",
    ul: "list-disc pl-7 my-5",
    listitem: "editor-listitem"
  },
  image: "editor-image",
  link: "editor-link",
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic",
    overflowed: "editor-text-overflowed",
    hashtag: "editor-text-hashtag",
    underline: "editor-text-underline",
    strikethrough: "editor-text-strikethrough",
    underlineStrikethrough: "editor-text-underlineStrikethrough",
    code: "editor-text-code"
  },
  code: "editor-code",
  codeHighlight: {
    atrule: "editor-tokenAttr",
    attr: "editor-tokenAttr",
    "boolean": "editor-tokenProperty",
    builtin: "editor-tokenSelector",
    cdata: "editor-tokenComment",
    "char": "editor-tokenSelector",
    "class": "editor-tokenFunction",
    "class-name": "editor-tokenFunction",
    comment: "editor-tokenComment",
    constant: "editor-tokenProperty",
    deleted: "editor-tokenProperty",
    doctype: "editor-tokenComment",
    entity: "editor-tokenOperator",
    "function": "editor-tokenFunction",
    important: "editor-tokenVariable",
    inserted: "editor-tokenSelector",
    keyword: "editor-tokenAttr",
    namespace: "editor-tokenVariable",
    number: "editor-tokenProperty",
    operator: "editor-tokenOperator",
    prolog: "editor-tokenComment",
    property: "editor-tokenProperty",
    punctuation: "editor-tokenPunctuation",
    regex: "editor-tokenVariable",
    selector: "editor-tokenSelector",
    string: "editor-tokenSelector",
    symbol: "editor-tokenProperty",
    tag: "editor-tokenProperty",
    url: "editor-tokenOperator",
    variable: "editor-tokenVariable"
  },
  table: 'border',
  tableAddColumns: 'bg-red-500',
  tableAddRows: 'PlaygroundEditorTheme__tableAddRows',
  tableCell: 'border !border-black px-2',
  tableCellActionButton: 'PlaygroundEditorTheme__tableCellActionButton',
  tableCellActionButtonContainer: 'PlaygroundEditorTheme__tableCellActionButtonContainer',
  tableCellEditing: 'PlaygroundEditorTheme__tableCellEditing',
  tableCellHeader: '!bg-transparent',
  tableCellPrimarySelected: 'PlaygroundEditorTheme__tableCellPrimarySelected',
  tableCellResizer: 'PlaygroundEditorTheme__tableCellResizer',
  tableCellSelected: 'PlaygroundEditorTheme__tableCellSelected',
  tableCellSortedIndicator: 'PlaygroundEditorTheme__tableCellSortedIndicator',
  tableResizeRuler: 'PlaygroundEditorTheme__tableCellResizeRuler',
  tableSelected: 'PlaygroundEditorTheme__tableSelected'
};
/* harmony default export */ var themes_editorTheme = (editorTheme);
// EXTERNAL MODULE: ./node_modules/@lexical/react/LexicalHorizontalRuleNode.js
var LexicalHorizontalRuleNode = __webpack_require__(41589);
// EXTERNAL MODULE: ./components/common/DropdownMenu.tsx
var DropdownMenu = __webpack_require__(6039);
;// CONCATENATED MODULE: ./components/Report/plugins/DragDropPastePlugin/index.ts




function DragDropPastePlugin_createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = DragDropPastePlugin_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function DragDropPastePlugin_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return DragDropPastePlugin_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DragDropPastePlugin_arrayLikeToArray(o, minLen);
}

function DragDropPastePlugin_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */








var ACCEPTABLE_IMAGE_TYPES = ['image/', 'image/heic', 'image/heif', 'image/gif', 'image/webp'];
function DragDropPaste() {
  var _useLexicalComposerCo = (0,LexicalComposerContext.useLexicalComposerContext)(),
      _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  (0,react.useEffect)(function () {
    return editor.registerCommand(LexicalRichText.DRAG_DROP_PASTE, function (files) {
      (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var filesResult, _iterator, _step, _step$value, file, result;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,LexicalUtils.mediaFileReader)(files, [ACCEPTABLE_IMAGE_TYPES].flatMap(function (x) {
                  return x;
                }));

              case 2:
                filesResult = _context.sent;
                _iterator = DragDropPastePlugin_createForOfIteratorHelper(filesResult);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _step.value, file = _step$value.file, result = _step$value.result;

                    if ((0,LexicalUtils.isMimeType)(file, ACCEPTABLE_IMAGE_TYPES)) {
                      editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
                        altText: file.name,
                        src: result
                      });
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();

      return true;
    }, Lexical.COMMAND_PRIORITY_LOW);
  }, [editor]);
  return null;
}
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
// EXTERNAL MODULE: ./components/FormComponents/TextInput.tsx
var TextInput = __webpack_require__(42641);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utils/servicesUtils.ts
var servicesUtils = __webpack_require__(39949);
;// CONCATENATED MODULE: ./components/Report/services/getAssist.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var reqObj = axios_default().create({
  timeout: 50000,
  withCredentials: true
});

var getAssist = function getAssist(data) {
  var params = _objectSpread({}, data);

  return servicesUtils/* default.postService */.Z.postService("gpt/gpt_response/", params).then(function (response) {
    return response.data;
  });
};

/* harmony default export */ var services_getAssist = (getAssist);
// EXTERNAL MODULE: ./components/Report/PatientBio.jsx
var PatientBio = __webpack_require__(82845);
;// CONCATENATED MODULE: ./components/Report/ReportEditor.jsx





function ReportEditor_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReportEditor_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReportEditor_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReportEditor_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













































var Placeholder = function Placeholder() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-gray-500 overflow-hidden absolute overflow-ellipsis top-5 left-3 pointer-events-none inline-block select-none"
  });
};

var ReportEditor = function ReportEditor(props) {
  var impression = props.impression,
      gptClinicalSummary = props.gptClinicalSummary,
      onChange = props.onChange,
      isMobile = props.isMobile,
      isFocused = props.isFocused,
      templatesList = props.templatesList,
      saveTemplateMode = props.saveTemplateMode;
  var editorRef = (0,react.useRef)();

  var _useState = (0,react.useState)(""),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = (0,react.useState)([]),
      messagesContext = _useState2[0],
      setMessagesContext = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      aiAssistText = _useState3[0],
      setAIAssistText = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      aiLoading = _useState4[0],
      setAILoading = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      aiGeneratedResponse = _useState5[0],
      setAIGeneratedResponse = _useState5[1];

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var _useState6 = (0,react.useState)(true),
      isAninating = _useState6[0],
      setAnimating = _useState6[1];

  (0,react.useEffect)(function () {
    setTimeout(function () {
      setAnimating(false);
    }, 4000);
  }, []);

  var onFocus = function onFocus() {
    return setFocused(true);
  };

  var onBlur = function onBlur() {
    return setFocused(false);
  };

  var _useSpeechRecognition = (0,lib/* useSpeechRecognition */.x6)(),
      transcript = _useSpeechRecognition.transcript,
      listening = _useSpeechRecognition.listening,
      resetTranscript = _useSpeechRecognition.resetTranscript,
      browserSupportsSpeechRecognition = _useSpeechRecognition.browserSupportsSpeechRecognition;

  var onPressMic = function onPressMic() {
    if (!listening) {
      setAIAssistText('');
      lib/* default.startListening */.ZP.startListening();
    } else {
      lib/* default.stopListening */.ZP.stopListening();
    }
  };

  (0,react.useEffect)(function () {
    if (!listening) {
      setAIAssistText(transcript);
      resetTranscript();
    }
  }, [listening]);

  function iterateWithDelay(inputString) {
    var index = 0;
    var intervalId = setInterval(function () {
      if (index < inputString.length) {
        console.log({
          len: inputString.length,
          str: inputString[index]
        });
        setAIAssistText(aiAssistText + inputString[index]);
        index++;
      } else {
        clearInterval(intervalId); // Stop the interval when iteration is done
      }
    }, 50);
  }

  var editorConfig = {
    namespace: "PlaygroundEditor",
    theme: themes_editorTheme,
    // Handling of errors during update
    onError: function onError(error) {
      throw error;
    },
    // Any custom nodes go here
    nodes: [LexicalRichText.HeadingNode, LexicalList.ListNode, LexicalList.ListItemNode, LexicalRichText.QuoteNode, LexicalCode.CodeNode, LexicalCode.CodeHighlightNode, LexicalTable.TableNode, LexicalTable.TableCellNode, LexicalTable.TableRowNode, LexicalLink.AutoLinkNode, LexicalLink.LinkNode, LexicalHorizontalRuleNode.HorizontalRuleNode, ImageNode/* ImageNode */.HJ]
  };

  var onApplyTemplate = function onApplyTemplate(template) {
    editorRef.current.update(function () {
      var selection = (0,Lexical.$getSelection)();

      if (template && selection && editorRef) {
        var parser = new DOMParser();
        var dom = parser.parseFromString(template, "text/html");
        var nodes = (0,LexicalHtml.$generateNodesFromDOM)(editorRef.current, dom);
        selection.insertNodes(nodes);
      }
    });
    setSearch("");
  };

  var getTemplateSelectMenu = function getTemplateSelectMenu() {
    var _filteredTemplateList;

    var filteredTemplateList = templatesList;

    if (search) {
      filteredTemplateList = templatesList.filter(function (item) {
        return (0,lodash.get)(item, ["name"], "").toLowerCase().includes(search === null || search === void 0 ? void 0 : search.toLowerCase());
      });
    }

    return (_filteredTemplateList = filteredTemplateList) === null || _filteredTemplateList === void 0 ? void 0 : _filteredTemplateList.map(function (item) {
      return {
        name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex px-4 py-3 items-center justify-start",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-md",
            children: item.name
          })
        }),
        onClick: function onClick() {
          return onApplyTemplate(item.template);
        }
      };
    });
  };

  (0,react.useEffect)(function () {
    if (editorRef.current) {
      editorRef.current.update(function () {
        if (impression || aiGeneratedResponse) {
          var parser = new DOMParser();
          var impressionData = aiGeneratedResponse || impression;
          var hasHTML = impressionData.match(/<(?:"[^"]*"['"]|'[^']'['"]*|[^'">])+>/g);
          impressionData = !hasHTML ? impressionData.replace('\n', '<br/>') : impressionData;
          var dom = parser.parseFromString(impressionData, "text/html");
          var nodes = (0,LexicalHtml.$generateNodesFromDOM)(editorRef.current, dom);
          nodes = nodes.map(function (node) {
            if ((0,Lexical.$isTextNode)(node)) {
              return (0,Lexical.$createParagraphNode)().append(node);
            }

            return node;
          });
          (0,Lexical.$getRoot)().clear().select();
          (0,Lexical.$insertNodes)(nodes);
        }
      });
    }
  }, [editorRef, impression, aiGeneratedResponse]);

  var FocusUnfocusPlugin = function FocusUnfocusPlugin() {
    var _useLexicalComposerCo = (0,LexicalComposerContext.useLexicalComposerContext)(),
        _useLexicalComposerCo2 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo, 1),
        editor = _useLexicalComposerCo2[0];

    (0,react.useEffect)(function () {
      if (editor && isMobile) {
        if (isFocused) {
          editor.focus();
        } else {
          editor.blur();
        }
      }
    }, [editor, isFocused]);
    return null;
  };

  var CustomOnChangePlugin = function CustomOnChangePlugin() {
    var _useLexicalComposerCo3 = (0,LexicalComposerContext.useLexicalComposerContext)(),
        _useLexicalComposerCo4 = (0,slicedToArray/* default */.Z)(_useLexicalComposerCo3, 1),
        editor = _useLexicalComposerCo4[0];

    editorRef.current = editor;
    (0,react.useEffect)(function () {
      return editor.registerUpdateListener(function (_ref) {
        var editorState = _ref.editorState;
        editorState.read(function () {
          var md = (0,LexicalHtml.$generateHtmlFromNodes)(editor);
          onChange(md);
        });
      });
    }, [editor]);
    return null;
  };

  var onStopEventBubbling = function onStopEventBubbling(e) {
    e.stopPropagation();
  };

  var onClickMarkNormal = function onClickMarkNormal() {
    onInputEnter('normal');
  };

  var onInputEnter = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var resp, assistantContext, userContext, newMessagesContext;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setAILoading(true);
              _context.prev = 1;
              _context.next = 4;
              return services_getAssist({
                prompt: typeof e === 'string' ? 'Mark report as normal' : aiAssistText,
                report: aiGeneratedResponse || impression,
                messagesContext: messagesContext
              });

            case 4:
              resp = _context.sent;
              setAILoading(false);
              setAIAssistText('');
              assistantContext = (0,lodash.get)(resp, ['answer'], {});
              userContext = (0,lodash.get)(resp, ['context'], {});
              newMessagesContext = [userContext, assistantContext];
              setMessagesContext([].concat((0,toConsumableArray/* default */.Z)(messagesContext), newMessagesContext));
              setAIGeneratedResponse(assistantContext === null || assistantContext === void 0 ? void 0 : assistantContext.content);
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              setAILoading(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    return function onInputEnter(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onClickRevertReport = function onClickRevertReport() {
    setAIGeneratedResponse(impression);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("relative mt-3 flex justify-between items-center mx-6", {
        'hidden': saveTemplateMode
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center mb-3",
        children: [!saveTemplateMode && /*#__PURE__*/(0,jsx_runtime.jsx)(PatientBio/* default */.Z, {
          isSimple: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover */.J, {
          className: "ml-4",
          children: function children(_ref3) {
            var open = _ref3.open;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                className: "focus:outline-none",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: classnames_default()('uppercase p-3 text-teal-400 hover:text-teal-300 text-[14px]', {
                    'text-teal-300': open,
                    'animate-text !text-brand-peach': isAninating
                  }),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                    name: pro_solid_svg_icons/* faSparkles */.JyM,
                    style: '--fa-animation-iteration-count: 2;',
                    className: classnames_default()("mr-3 ", {
                      'fa-beat-fade': open
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: classnames_default()('mr-3 ', {}),
                    children: "Clinical summary"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                    name: pro_solid_svg_icons/* faChevronDown */.ptq,
                    className: classnames_default()('transform transition-transform duration-500', {
                      'rotate-180': open
                    })
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                className: "absolute left-0 w-[70%] z-[99999] translate-x-0 text-gray-300 bg-teal-800 shadow-xl mt-2 rounded-md",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "p-5 max-h-[250px] overflow-y-auto",
                    children: gptClinicalSummary
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "text-teal-400 border-t border-t-teal-500 p-5 text-[12px]",
                    children: "Clinical summary auto-generated using available patient data"
                  })]
                })
              })]
            });
          }
        })]
      }), !(0,lodash.isEmpty)(templatesList) && /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownMenu/* default */.Z, {
        isSearch: true,
        search: search,
        setSearch: setSearch,
        options: getTemplateSelectMenu(),
        Icon: function Icon() {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
            isSecondary: true,
            className: "grow-1 flex space-x-2 px-4 py-2",
            isPrimary: false,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
              name: pro_regular_svg_icons/* faPlus */.r8p,
              size: "sm",
              className: "w-5"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-md",
              children: "Add Template"
            })]
          });
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("w-full h-full", {
        'rounded-md animate-border bg-gradient-to-r from-red-500 via-brand-peach to-transparent bg-[length:400%_400%] p-2': isAninating
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col h-full w-full p-1 overflow-hidden",
        onScroll: onStopEventBubbling,
        onTouchMove: onStopEventBubbling,
        onTouchStart: onStopEventBubbling,
        onTouchEnd: onStopEventBubbling,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LexicalComposer.LexicalComposer, {
          initialConfig: ReportEditor_objectSpread(ReportEditor_objectSpread({}, editorConfig), {}, {
            editable: !aiLoading
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex flex-col bg-gray-50 text-black relative w-full h-full overflow-x-auto text-left rounded-tl rounded-tr overflow-y-hidden editor-shell"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ToolbarPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LexicalRichTextPlugin.RichTextPlugin, {
              contentEditable: /*#__PURE__*/(0,jsx_runtime.jsx)(LexicalContentEditable.ContentEditable, {
                className: "editor-input flex flex-col h-full w-full overflow-y-auto p-3"
              }),
              placeholder: /*#__PURE__*/(0,jsx_runtime.jsx)(Placeholder, {
                template: impression
              }),
              ErrorBoundary: (LexicalErrorBoundary_default())
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(LexicalHistoryPlugin.HistoryPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LexicalTablePlugin.TablePlugin, {
              hasCellBackgroundColor: true
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CodeHighlightPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LexicalListPlugin.ListPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LexicalLinkPlugin.LinkPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(PlaygroundAutoLinkPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FocusUnfocusPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomOnChangePlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ListMaxIndentLevelPlugin, {
              maxDepth: 7
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImagesPlugin, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DragDropPaste, {})]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()('w-full bg-[#cce6e6] p-5', {
            'opacity-70': aiLoading,
            'hidden': saveTemplateMode
          }),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex justify-between text-gray-700 uppercase text-[14px] mb-3 font-bold tracking-wide",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_regular_svg_icons/* faWandMagicSparkles */.Z30,
                className: classnames_default()("text-teal-500 mr-2", {
                  "fa-beat-fade": aiLoading
                })
              }), "Swift editing"]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              onClick: onClickRevertReport,
              className: classnames_default()('text-red-400 cursor-pointer hover:text-red-300 transition-colors duration-300', {
                'pointer-events-none': aiLoading
              }),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_solid_svg_icons/* faArrowRotateLeft */.paY,
                className: "mr-2"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Reset"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex w-full opacity-90",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
              placeholder: "Enter keywords or commands to make changes",
              name: "aiCompletion",
              wrapperClassName: "bg-gray-50 !p-1 w-full !rounded-xl shadow-xl dark:border-teal-500 !text-[14px] text-black",
              required: true,
              readOnly: aiLoading,
              inputClassName: "text-gray-900 placeholder:italic",
              parentClassName: "p-0",
              className: "",
              value: aiAssistText,
              onFocus: onFocus,
              onBlur: onBlur,
              onEnter: onInputEnter,
              onChange: function onChange(val) {
                return setAIAssistText(val);
              },
              rightContent: function rightContent() {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex justify-end text-[14px]",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()('flex justify-end ', {
                      'text-red-900': focused
                    }),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      onClick: onInputEnter,
                      className: classnames_default()("opacity-0 visibility-hidden cursor-pointer transition-transform p-2 flex items-center text-gray-300 hover:text-gray-600 transition-colors duration-300", {
                        'translate-x-[140px] text-gray-600 opacity-100': !(0,lodash.isEmpty)(aiAssistText) || focused || listening
                      }),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                        size: "xl",
                        name: pro_solid_svg_icons/* faPaperPlaneTop */.FzC,
                        className: "block mr-2 cursor-pointer "
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      onClick: onClickMarkNormal,
                      className: classnames_default()("cursor-pointer transition-[transform, colors, opacity] p-2 pl-4 flex items-center  text-teal-600 hover:text-teal-400 duration-200", {
                        'translate-x-[200px] opacity-0 visibility-hidden': focused || !(0,lodash.isEmpty)(aiAssistText) || listening
                      }),
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                        name: pro_solid_svg_icons/* faCheckCircle */.f8k,
                        className: "block mr-2 cursor-pointer"
                      }), "Mark as normal"]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    onClick: onPressMic,
                    className: classnames_default()('bg-teal-500 rounded-r-xl ml-4 hover:bg-teal-600 transition-colors duration-500', {
                      '!bg-brand-peach hover:!bg-brand-peach': listening
                    }),
                    children: listening ? /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                      name: pro_solid_svg_icons/* faWaveformLines */.dlc,
                      className: "fa-beat-fade block mr-2 p-5 cursor-pointer text-slate-100"
                    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                      name: pro_solid_svg_icons/* faMicrophone */.UOM,
                      className: classnames_default()("block mr-2 p-5 cursor-pointer text-slate-100 	", {
                        'opacity-50 pointer-events-none': !browserSupportsSpeechRecognition
                      })
                    })
                  })]
                });
              }
            })
          })]
        })]
      })
    })]
  });
};

ReportEditor.defaultProps = {
  impression: "",
  onChange: function onChange() {}
};
/* harmony default export */ var Report_ReportEditor = (ReportEditor);

/***/ }),

/***/ 51510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39949);



var useAddTemplate = function useAddTemplate() {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function (params) {
    return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postService */ .Z.postService("/report_templates/create/", params);
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useAddTemplate);

/***/ }),

/***/ 41917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39949);



var useGetReport = function useGetReport(isOpen) {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(["reportTemplate", isOpen], function () {
    return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getService */ .Z.getService("/report_templates/");
  }, {
    enabled: isOpen
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useGetReport);

/***/ }),

/***/ 54089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Or": function() { return /* binding */ postSettings; },
/* harmony export */   "T": function() { return /* binding */ getEmergencyPatients; },
/* harmony export */   "Zl": function() { return /* binding */ validateUserConfig; }
/* harmony export */ });
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39949);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41065);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var getEmergencyPatients = function getEmergencyPatients() {
  var apiParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postService */ .Z.postService("/patients/", _objectSpread({
    emergency: true,
    page_size: 30
  }, apiParams));
};

var postSettings = function postSettings(params) {
  return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postService */ .Z.postService("/settings/", params);
};

var validateUserConfig = function validateUserConfig(userSettingsConfig) {
  var isValid = true;
  var worklist = userSettingsConfig.worklist; // worklist validation

  if (worklist) {
    var tags = worklist.tags;

    if (tags) {
      Object.keys(tags).map(function (study) {
        var tagsValueArray = [];

        for (var tagNo in tags[study]) {
          var tag = tags[study][tagNo];
          if (tagsValueArray.includes(tag.value)) isValid = false;
          if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(tag.value)) tagsValueArray.push(tag.value);
        }
      });
    }
  }

  return isValid;
};



/***/ }),

/***/ 10921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Toast; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
;// CONCATENATED MODULE: ./node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
'use client';
const u=t=>"number"==typeof t&&!isNaN(t),d=t=>"string"==typeof t,p=t=>"function"==typeof t,m=t=>d(t)||p(t)?t:null,f=t=>(0,react.isValidElement)(t)||d(t)||p(t)||u(t);function g(t,e,n){void 0===n&&(n=300);const{scrollHeight:o,style:s}=t;requestAnimationFrame(()=>{s.minHeight="initial",s.height=o+"px",s.transition=`all ${n}ms`,requestAnimationFrame(()=>{s.height="0",s.padding="0",s.margin="0",setTimeout(e,n)})})}function h(e){let{enter:a,exit:r,appendPosition:i=!1,collapse:l=!0,collapseDuration:c=300}=e;return function(e){let{children:u,position:d,preventExitTransition:p,done:m,nodeRef:f,isIn:h}=e;const y=i?`${a}--${d}`:a,v=i?`${r}--${d}`:r,T=(0,react.useRef)(0);return (0,react.useLayoutEffect)(()=>{const t=f.current,e=y.split(" "),n=o=>{o.target===f.current&&(t.dispatchEvent(new Event("d")),t.removeEventListener("animationend",n),t.removeEventListener("animationcancel",n),0===T.current&&"animationcancel"!==o.type&&t.classList.remove(...e))};t.classList.add(...e),t.addEventListener("animationend",n),t.addEventListener("animationcancel",n)},[]),(0,react.useEffect)(()=>{const t=f.current,e=()=>{t.removeEventListener("animationend",e),l?g(t,m,c):m()};h||(p?e():(T.current=1,t.className+=` ${v}`,t.addEventListener("animationend",e)))},[h]),react.createElement(react.Fragment,null,u)}}function y(t,e){return null!=t?{content:t.content,containerId:t.props.containerId,id:t.props.toastId,theme:t.props.theme,type:t.props.type,data:t.props.data||{},isLoading:t.props.isLoading,icon:t.props.icon,status:e}:{}}const v={list:new Map,emitQueue:new Map,on(t,e){return this.list.has(t)||this.list.set(t,[]),this.list.get(t).push(e),this},off(t,e){if(e){const n=this.list.get(t).filter(t=>t!==e);return this.list.set(t,n),this}return this.list.delete(t),this},cancelEmit(t){const e=this.emitQueue.get(t);return e&&(e.forEach(clearTimeout),this.emitQueue.delete(t)),this},emit(t){this.list.has(t)&&this.list.get(t).forEach(e=>{const n=setTimeout(()=>{e(...[].slice.call(arguments,1))},0);this.emitQueue.has(t)||this.emitQueue.set(t,[]),this.emitQueue.get(t).push(n)})}},T=e=>{let{theme:n,type:o,...s}=e;return react.createElement("svg",{viewBox:"0 0 24 24",width:"100%",height:"100%",fill:"colored"===n?"currentColor":`var(--toastify-icon-color-${o})`,...s})},E={info:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"}))},warning:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"}))},success:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"}))},error:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"}))},spinner:function(){return react.createElement("div",{className:"Toastify__spinner"})}};function C(t){const[,o]=(0,react.useReducer)(t=>t+1,0),[l,c]=(0,react.useState)([]),g=(0,react.useRef)(null),h=(0,react.useRef)(new Map).current,T=t=>-1!==l.indexOf(t),C=(0,react.useRef)({toastKey:1,displayedToast:0,count:0,queue:[],props:t,containerId:null,isToastActive:T,getToast:t=>h.get(t)}).current;function b(t){let{containerId:e}=t;const{limit:n}=C.props;!n||e&&C.containerId!==e||(C.count-=C.queue.length,C.queue=[])}function I(t){c(e=>null==t?[]:e.filter(e=>e!==t))}function _(){const{toastContent:t,toastProps:e,staleId:n}=C.queue.shift();O(t,e,n)}function L(t,n){let{delay:s,staleId:r,...i}=n;if(!f(t)||function(t){return!g.current||C.props.enableMultiContainer&&t.containerId!==C.props.containerId||h.has(t.toastId)&&null==t.updateId}(i))return;const{toastId:l,updateId:c,data:T}=i,{props:b}=C,L=()=>I(l),N=null==c;N&&C.count++;const M={...b,style:b.toastStyle,key:C.toastKey++,...Object.fromEntries(Object.entries(i).filter(t=>{let[e,n]=t;return null!=n})),toastId:l,updateId:c,data:T,closeToast:L,isIn:!1,className:m(i.className||b.toastClassName),bodyClassName:m(i.bodyClassName||b.bodyClassName),progressClassName:m(i.progressClassName||b.progressClassName),autoClose:!i.isLoading&&(R=i.autoClose,w=b.autoClose,!1===R||u(R)&&R>0?R:w),deleteToast(){const t=y(h.get(l),"removed");h.delete(l),v.emit(4,t);const e=C.queue.length;if(C.count=null==l?C.count-C.displayedToast:C.count-1,C.count<0&&(C.count=0),e>0){const t=null==l?C.props.limit:1;if(1===e||1===t)C.displayedToast++,_();else{const n=t>e?e:t;C.displayedToast=n;for(let t=0;t<n;t++)_()}}else o()}};var R,w;M.iconOut=function(t){let{theme:n,type:o,isLoading:s,icon:r}=t,i=null;const l={theme:n,type:o};return!1===r||(p(r)?i=r(l):(0,react.isValidElement)(r)?i=(0,react.cloneElement)(r,l):d(r)||u(r)?i=r:s?i=E.spinner():(t=>t in E)(o)&&(i=E[o](l))),i}(M),p(i.onOpen)&&(M.onOpen=i.onOpen),p(i.onClose)&&(M.onClose=i.onClose),M.closeButton=b.closeButton,!1===i.closeButton||f(i.closeButton)?M.closeButton=i.closeButton:!0===i.closeButton&&(M.closeButton=!f(b.closeButton)||b.closeButton);let x=t;(0,react.isValidElement)(t)&&!d(t.type)?x=(0,react.cloneElement)(t,{closeToast:L,toastProps:M,data:T}):p(t)&&(x=t({closeToast:L,toastProps:M,data:T})),b.limit&&b.limit>0&&C.count>b.limit&&N?C.queue.push({toastContent:x,toastProps:M,staleId:r}):u(s)?setTimeout(()=>{O(x,M,r)},s):O(x,M,r)}function O(t,e,n){const{toastId:o}=e;n&&h.delete(n);const s={content:t,props:e};h.set(o,s),c(t=>[...t,o].filter(t=>t!==n)),v.emit(4,y(s,null==s.props.updateId?"added":"updated"))}return (0,react.useEffect)(()=>(C.containerId=t.containerId,v.cancelEmit(3).on(0,L).on(1,t=>g.current&&I(t)).on(5,b).emit(2,C),()=>{h.clear(),v.emit(3,C)}),[]),(0,react.useEffect)(()=>{C.props=t,C.isToastActive=T,C.displayedToast=l.length}),{getToastToRender:function(e){const n=new Map,o=Array.from(h.values());return t.newestOnTop&&o.reverse(),o.forEach(t=>{const{position:e}=t.props;n.has(e)||n.set(e,[]),n.get(e).push(t)}),Array.from(n,t=>e(t[0],t[1]))},containerRef:g,isToastActive:T}}function b(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientX:t.clientX}function I(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientY:t.clientY}function _(t){const[o,a]=(0,react.useState)(!1),[r,l]=(0,react.useState)(!1),c=(0,react.useRef)(null),u=(0,react.useRef)({start:0,x:0,y:0,delta:0,removalDistance:0,canCloseOnClick:!0,canDrag:!1,boundingRect:null,didMove:!1}).current,d=(0,react.useRef)(t),{autoClose:m,pauseOnHover:f,closeToast:g,onClick:h,closeOnClick:y}=t;function v(e){if(t.draggable){"touchstart"===e.nativeEvent.type&&e.nativeEvent.preventDefault(),u.didMove=!1,document.addEventListener("mousemove",_),document.addEventListener("mouseup",L),document.addEventListener("touchmove",_),document.addEventListener("touchend",L);const n=c.current;u.canCloseOnClick=!0,u.canDrag=!0,u.boundingRect=n.getBoundingClientRect(),n.style.transition="",u.x=b(e.nativeEvent),u.y=I(e.nativeEvent),"x"===t.draggableDirection?(u.start=u.x,u.removalDistance=n.offsetWidth*(t.draggablePercent/100)):(u.start=u.y,u.removalDistance=n.offsetHeight*(80===t.draggablePercent?1.5*t.draggablePercent:t.draggablePercent/100))}}function T(e){if(u.boundingRect){const{top:n,bottom:o,left:s,right:a}=u.boundingRect;"touchend"!==e.nativeEvent.type&&t.pauseOnHover&&u.x>=s&&u.x<=a&&u.y>=n&&u.y<=o?C():E()}}function E(){a(!0)}function C(){a(!1)}function _(e){const n=c.current;u.canDrag&&n&&(u.didMove=!0,o&&C(),u.x=b(e),u.y=I(e),u.delta="x"===t.draggableDirection?u.x-u.start:u.y-u.start,u.start!==u.x&&(u.canCloseOnClick=!1),n.style.transform=`translate${t.draggableDirection}(${u.delta}px)`,n.style.opacity=""+(1-Math.abs(u.delta/u.removalDistance)))}function L(){document.removeEventListener("mousemove",_),document.removeEventListener("mouseup",L),document.removeEventListener("touchmove",_),document.removeEventListener("touchend",L);const e=c.current;if(u.canDrag&&u.didMove&&e){if(u.canDrag=!1,Math.abs(u.delta)>u.removalDistance)return l(!0),void t.closeToast();e.style.transition="transform 0.2s, opacity 0.2s",e.style.transform=`translate${t.draggableDirection}(0)`,e.style.opacity="1"}}(0,react.useEffect)(()=>{d.current=t}),(0,react.useEffect)(()=>(c.current&&c.current.addEventListener("d",E,{once:!0}),p(t.onOpen)&&t.onOpen((0,react.isValidElement)(t.children)&&t.children.props),()=>{const t=d.current;p(t.onClose)&&t.onClose((0,react.isValidElement)(t.children)&&t.children.props)}),[]),(0,react.useEffect)(()=>(t.pauseOnFocusLoss&&(document.hasFocus()||C(),window.addEventListener("focus",E),window.addEventListener("blur",C)),()=>{t.pauseOnFocusLoss&&(window.removeEventListener("focus",E),window.removeEventListener("blur",C))}),[t.pauseOnFocusLoss]);const O={onMouseDown:v,onTouchStart:v,onMouseUp:T,onTouchEnd:T};return m&&f&&(O.onMouseEnter=C,O.onMouseLeave=E),y&&(O.onClick=t=>{h&&h(t),u.canCloseOnClick&&g()}),{playToast:E,pauseToast:C,isRunning:o,preventExitTransition:r,toastRef:c,eventHandlers:O}}function L(e){let{closeToast:n,theme:o,ariaLabel:s="close"}=e;return react.createElement("button",{className:`Toastify__close-button Toastify__close-button--${o}`,type:"button",onClick:t=>{t.stopPropagation(),n(t)},"aria-label":s},react.createElement("svg",{"aria-hidden":"true",viewBox:"0 0 14 16"},react.createElement("path",{fillRule:"evenodd",d:"M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"})))}function O(e){let{delay:n,isRunning:o,closeToast:s,type:a="default",hide:r,className:i,style:l,controlledProgress:u,progress:d,rtl:m,isIn:f,theme:g}=e;const h=r||u&&0===d,y={...l,animationDuration:`${n}ms`,animationPlayState:o?"running":"paused",opacity:h?0:1};u&&(y.transform=`scaleX(${d})`);const v=clsx_m("Toastify__progress-bar",u?"Toastify__progress-bar--controlled":"Toastify__progress-bar--animated",`Toastify__progress-bar-theme--${g}`,`Toastify__progress-bar--${a}`,{"Toastify__progress-bar--rtl":m}),T=p(i)?i({rtl:m,type:a,defaultClassName:v}):clsx_m(v,i);return react.createElement("div",{role:"progressbar","aria-hidden":h?"true":"false","aria-label":"notification timer",className:T,style:y,[u&&d>=1?"onTransitionEnd":"onAnimationEnd"]:u&&d<1?null:()=>{f&&s()}})}const N=n=>{const{isRunning:o,preventExitTransition:s,toastRef:r,eventHandlers:i}=_(n),{closeButton:l,children:u,autoClose:d,onClick:m,type:f,hideProgressBar:g,closeToast:h,transition:y,position:v,className:T,style:E,bodyClassName:C,bodyStyle:b,progressClassName:I,progressStyle:N,updateId:M,role:R,progress:w,rtl:x,toastId:$,deleteToast:k,isIn:P,isLoading:B,iconOut:D,closeOnClick:A,theme:z}=n,F=clsx_m("Toastify__toast",`Toastify__toast-theme--${z}`,`Toastify__toast--${f}`,{"Toastify__toast--rtl":x},{"Toastify__toast--close-on-click":A}),H=p(T)?T({rtl:x,position:v,type:f,defaultClassName:F}):clsx_m(F,T),S=!!w||!d,q={closeToast:h,type:f,theme:z};let Q=null;return!1===l||(Q=p(l)?l(q):(0,react.isValidElement)(l)?(0,react.cloneElement)(l,q):L(q)),react.createElement(y,{isIn:P,done:k,position:v,preventExitTransition:s,nodeRef:r},react.createElement("div",{id:$,onClick:m,className:H,...i,style:E,ref:r},react.createElement("div",{...P&&{role:R},className:p(C)?C({type:f}):clsx_m("Toastify__toast-body",C),style:b},null!=D&&react.createElement("div",{className:clsx_m("Toastify__toast-icon",{"Toastify--animate-icon Toastify__zoom-enter":!B})},D),react.createElement("div",null,u)),Q,react.createElement(O,{...M&&!S?{key:`pb-${M}`}:{},rtl:x,theme:z,delay:d,isRunning:o,isIn:P,closeToast:h,hide:g,type:f,style:N,className:I,controlledProgress:S,progress:w||0})))},M=function(t,e){return void 0===e&&(e=!1),{enter:`Toastify--animate Toastify__${t}-enter`,exit:`Toastify--animate Toastify__${t}-exit`,appendPosition:e}},R=h(M("bounce",!0)),w=h(M("slide",!0)),x=h(M("zoom")),$=h(M("flip")),k=(0,react.forwardRef)((e,n)=>{const{getToastToRender:o,containerRef:a,isToastActive:r}=C(e),{className:i,style:l,rtl:u,containerId:d}=e;function f(t){const e=clsx_m("Toastify__toast-container",`Toastify__toast-container--${t}`,{"Toastify__toast-container--rtl":u});return p(i)?i({position:t,rtl:u,defaultClassName:e}):clsx_m(e,m(i))}return (0,react.useEffect)(()=>{n&&(n.current=a.current)},[]),react.createElement("div",{ref:a,className:"Toastify",id:d},o((e,n)=>{const o=n.length?{...l}:{...l,pointerEvents:"none"};return react.createElement("div",{className:f(e),style:o,key:`container-${e}`},n.map((e,o)=>{let{content:s,props:a}=e;return react.createElement(N,{...a,isIn:r(a.toastId),style:{...a.style,"--nth":o+1,"--len":n.length},key:`toast-${a.key}`},s)}))}))});k.displayName="ToastContainer",k.defaultProps={position:"top-right",transition:R,autoClose:5e3,closeButton:L,pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,draggable:!0,draggablePercent:80,draggableDirection:"x",role:"alert",theme:"light"};let P,B=new Map,D=[],A=1;function z(){return""+A++}function F(t){return t&&(d(t.toastId)||u(t.toastId))?t.toastId:z()}function H(t,e){return B.size>0?v.emit(0,t,e):D.push({content:t,options:e}),e.toastId}function S(t,e){return{...e,type:e&&e.type||t,toastId:F(e)}}function q(t){return(e,n)=>H(e,S(t,n))}function Q(t,e){return H(t,S("default",e))}Q.loading=(t,e)=>H(t,S("default",{isLoading:!0,autoClose:!1,closeOnClick:!1,closeButton:!1,draggable:!1,...e})),Q.promise=function(t,e,n){let o,{pending:s,error:a,success:r}=e;s&&(o=d(s)?Q.loading(s,n):Q.loading(s.render,{...n,...s}));const i={isLoading:null,autoClose:null,closeOnClick:null,closeButton:null,draggable:null},l=(t,e,s)=>{if(null==e)return void Q.dismiss(o);const a={type:t,...i,...n,data:s},r=d(e)?{render:e}:e;return o?Q.update(o,{...a,...r}):Q(r.render,{...a,...r}),s},c=p(t)?t():t;return c.then(t=>l("success",r,t)).catch(t=>l("error",a,t)),c},Q.success=q("success"),Q.info=q("info"),Q.error=q("error"),Q.warning=q("warning"),Q.warn=Q.warning,Q.dark=(t,e)=>H(t,S("default",{theme:"dark",...e})),Q.dismiss=t=>{B.size>0?v.emit(1,t):D=D.filter(e=>null!=t&&e.options.toastId!==t)},Q.clearWaitingQueue=function(t){return void 0===t&&(t={}),v.emit(5,t)},Q.isActive=t=>{let e=!1;return B.forEach(n=>{n.isToastActive&&n.isToastActive(t)&&(e=!0)}),e},Q.update=function(t,e){void 0===e&&(e={}),setTimeout(()=>{const n=function(t,e){let{containerId:n}=e;const o=B.get(n||P);return o&&o.getToast(t)}(t,e);if(n){const{props:o,content:s}=n,a={delay:100,...o,...e,toastId:e.toastId||t,updateId:z()};a.toastId!==t&&(a.staleId=t);const r=a.render||s;delete a.render,H(r,a)}},0)},Q.done=t=>{Q.update(t,{progress:1})},Q.onChange=t=>(v.on(4,t),()=>{v.off(4,t)}),Q.POSITION={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},Q.TYPE={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"},v.on(2,t=>{P=t.containerId||t,B.set(P,t),D.forEach(t=>{v.emit(0,t.content,t.options)}),D=[]}).on(3,t=>{B.delete(t.containerId||t),0===B.size&&v.off(0).off(1).off(5)});
//# sourceMappingURL=react-toastify.esm.mjs.map

// EXTERNAL MODULE: ./components/AwesomeIcon/index.tsx + 2 modules
var AwesomeIcon = __webpack_require__(38266);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Toast/index.jsx







var Toast = function Toast() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(k, {
    position: "bottom-center",
    hideProgressBar: true,
    autoClose: 3000,
    bodyClassName: "toast-body",
    toastClassName: "rounded-md flex mb-5 last:mb-8",
    theme: "light"
  });
};

Toast.success = function (msg) {
  return Q.success(msg, {
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faCircleCheck */.fV7,
      className: "text-green-600"
    })
  });
};

Toast.warning = function (msg) {
  return Q.warning(msg, {
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faTriangleExclamation */.ik8,
      className: "text-yellow-600"
    })
  });
};

Toast.error = function (msg) {
  return Q.error(msg, {
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faCircleXmark */.WA2,
      className: "text-red-600"
    })
  });
};

/* harmony default export */ var components_Toast = (Toast);

/***/ }),

/***/ 85883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39949);



var useGetUserGroups = function useGetUserGroups(isOpen) {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(["userGroups", isOpen], function () {
    return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getService */ .Z.getService("/accounts/groups/");
  }, {
    enabled: isOpen
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useGetUserGroups);

/***/ }),

/***/ 38266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AwesomeIcon; }
});

;// CONCATENATED MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.mjs
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5;

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_CSS_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var FAMILY_CLASSIC = 'classic';
var FAMILY_SHARP = 'sharp';
var FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];

function familyProxy(obj) {
  // Defaults to the classic family if family is not available
  return new Proxy(obj, {
    get: function get(target, prop) {
      return prop in target ? target[prop] : target[FAMILY_CLASSIC];
    }
  });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
  'fa': 'solid',
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit'
}), _defineProperty(_familyProxy, FAMILY_SHARP, {
  'fa': 'solid',
  'fass': 'solid',
  'fa-solid': 'solid',
  'fasr': 'regular',
  'fa-regular': 'regular',
  'fasl': 'light',
  'fa-light': 'light'
}), _familyProxy));
var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
}), _defineProperty(_familyProxy2, FAMILY_SHARP, {
  'solid': 'fass',
  'regular': 'fasr',
  'light': 'fasl'
}), _familyProxy2));
var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
}), _defineProperty(_familyProxy3, FAMILY_SHARP, {
  'fass': 'fa-solid',
  'fasr': 'fa-regular',
  'fasl': 'fa-light'
}), _familyProxy3));
var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
}), _defineProperty(_familyProxy4, FAMILY_SHARP, {
  'fa-solid': 'fass',
  'fa-regular': 'fasr',
  'fa-light': 'fasl'
}), _familyProxy4));
var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
}), _defineProperty(_familyProxy5, FAMILY_SHARP, {
  '900': 'fass',
  '400': 'fasr',
  '300': 'fasl'
}), _familyProxy5));
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var prefixes = new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-css-prefix', 'cssPrefix'], ['data-family-default', 'familyDefault'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  styleDefault: 'solid',
  familyDefault: 'classic',
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present

if (initial.familyPrefix) {
  initial.cssPrefix = initial.familyPrefix;
}

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_default).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0

Object.defineProperty(config, 'familyPrefix', {
  enumerable: true,
  set: function set(val) {
    _config.cssPrefix = val;

    _onChangeCb.forEach(function (cb) {
      return cb(config);
    });
  },
  get: function get() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dcp = DEFAULT_CSS_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.cssPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dcp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var _LONG_STYLE, _PREFIXES, _PREFIXES_FOR_FAMILY;
var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = (_PREFIXES = {}, _defineProperty(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(cssPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === cssPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$family = params.family,
      family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
  var style = PREFIX_TO_STYLE[family][styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(values) {
  var _famProps;

  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var famProps = (_famProps = {}, _defineProperty(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
  var givenPrefix = null;
  var family = FAMILY_CLASSIC;

  if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v);
  })) {
    family = FAMILY_CLASSIC;
  }

  if (values.includes(famProps[FAMILY_SHARP]) || values.some(function (v) {
    return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v);
  })) {
    family = FAMILY_SHARP;
  }

  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.cssPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES[family].indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls, {
        family: family
      });
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (values.includes('fa-brands') || values.includes('fab')) {
    canonical.prefix = 'fab';
  }

  if (values.includes('fa-duotone') || values.includes('fad')) {
    canonical.prefix = 'fad';
  }

  if (!canonical.prefix && family === FAMILY_SHARP && (styles['fass'] || config.autoFetchSvg)) {
    canonical.prefix = 'fass';
    canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
  }

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change

        var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.4.2\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (_abstract) {
        node.parentNode.insertBefore(convertSVG(_abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
    delete _abstract2[0].attributes.id;

    if (_abstract2[0].attributes.class) {
      var splitClasses = _abstract2[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });

      _abstract2[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = _abstract2.map(function (a) {
      return toHtml(a);
    }).join('\n');

    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

var knownPrefixes = new Set();
FAMILIES.map(function (family) {
  knownPrefixes.add("fa-".concat(family));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = _toConsumableArray(knownPrefixes);

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function (f) {
    return "fa-".concat(f);
  }).concat(Object.keys(styles$2));

  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }

  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.cssPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var family = ~['Sharp'].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var _abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));

          var element = DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = _abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(_abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (_abstract.attributes && (_abstract.attributes.fill || force)) {
    _abstract.attributes.fill = 'black';
  }

  return _abstract;
}

function deGroup(_abstract2) {
  if (_abstract2.tag === 'g') {
    return _abstract2.children;
  } else {
    return [_abstract2];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var fontawesome_svg_core_layer = api.layer;
var fontawesome_svg_core_text = api.text;
var counter = api.counter;



// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js




function index_es_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function index_es_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? index_es_ownKeys(Object(source), !0).forEach(function (key) {
      index_es_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : index_es_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function index_es_typeof(obj) {
  "@babel/helpers - typeof";

  return index_es_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, index_es_typeof(obj);
}

function index_es_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function index_es_toConsumableArray(arr) {
  return index_es_arrayWithoutHoles(arr) || index_es_iterableToArray(arr) || index_es_unsupportedIterableToArray(arr) || index_es_nonIterableSpread();
}

function index_es_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return index_es_arrayLikeToArray(arr);
}

function index_es_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function index_es_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return index_es_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return index_es_arrayLikeToArray(o, minLen);
}

function index_es_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function index_es_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, index_es_defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), index_es_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), index_es_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), index_es_defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded);

  mixins.attrs['style'] = index_es_objectSpread2(index_es_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, index_es_objectSpread2(index_es_objectSpread2({}, mixins.attrs), remaining)].concat(index_es_toConsumableArray(children)));
}

var index_es_PRODUCTION = false;

try {
  index_es_PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!index_es_PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && index_es_typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (parse$1.icon) {
    return parse$1.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && index_es_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? index_es_defineProperty({}, key, value) : {};
}

var FontAwesomeIcon = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(index_es_toConsumableArray(classList(props)), index_es_toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse$1.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, index_es_objectSpread2(index_es_objectSpread2(index_es_objectSpread2(index_es_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: ref
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: (prop_types_default()).bool,
  border: (prop_types_default()).bool,
  beatFade: (prop_types_default()).bool,
  bounce: (prop_types_default()).bool,
  className: (prop_types_default()).string,
  fade: (prop_types_default()).bool,
  flash: (prop_types_default()).bool,
  mask: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).array, (prop_types_default()).string]),
  maskId: (prop_types_default()).string,
  fixedWidth: (prop_types_default()).bool,
  inverse: (prop_types_default()).bool,
  flip: prop_types_default().oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).array, (prop_types_default()).string]),
  listItem: (prop_types_default()).bool,
  pull: prop_types_default().oneOf(['right', 'left']),
  pulse: (prop_types_default()).bool,
  rotation: prop_types_default().oneOf([0, 90, 180, 270]),
  shake: (prop_types_default()).bool,
  size: prop_types_default().oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: (prop_types_default()).bool,
  spinPulse: (prop_types_default()).bool,
  spinReverse: (prop_types_default()).bool,
  symbol: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).string]),
  title: (prop_types_default()).string,
  titleId: (prop_types_default()).string,
  transform: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).object]),
  swapOpacity: (prop_types_default()).bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, react.createElement);



;// CONCATENATED MODULE: ./components/AwesomeIcon/index.tsx
var __jsx = react.createElement;



function AwesomeIcon(_ref) {
  var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "lg" : _ref$size,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/react.createElement(FontAwesomeIcon, {
    icon: name,
    size: size,
    className: className,
    "aria-hidden": "true"
  });
}

/* harmony default export */ var components_AwesomeIcon = (AwesomeIcon);

/***/ }),

/***/ 94440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64729);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44080);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38266);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68779);


var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;







var SelectInput = function SelectInput(props) {
  var label = props.label,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      value = props.value,
      _onChange = props.onChange,
      disabled = props.disabled,
      required = props.required,
      placeholder = props.placeholder,
      multiple = props.multiple,
      isClinicalField = props.isClinicalField;
  var selected = multiple ? value.map(function (opt) {
    return options === null || options === void 0 ? void 0 : options.find(function (op) {
      return op.value = opt;
    });
  }) : options === null || options === void 0 ? void 0 : options.find(function (opt) {
    return opt.value === value;
  });
  var selectedLabel = multiple ? "".concat(selected.length, " selected") : (0,lodash__WEBPACK_IMPORTED_MODULE_2__.get)(selected, ["label"], placeholder);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative flex items-center rounded-md ", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      "opacity-50": disabled,
      "bg-gray-800 mt-7": isClinicalField,
      "border border-gray-500": !isClinicalField
    }, className, !!className))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox */ .R, {
    multiple: multiple,
    disabled: disabled,
    value: selected,
    onChange: function onChange(obj) {
      return _onChange(obj.value);
    }
  }, function (_ref) {
    var open = _ref.open;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !!label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Label */ .R.Label, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("text-md", {
        "dark:bg-gray-800 bg-gray-200 absolute left-4 -top-3 px-4": !isClinicalField,
        "dark:bg-transparent flex mb-5 text-base absolute left-0 -top-7 pt-1": isClinicalField
      })
    }, label, " ", !!required && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: "text-red-500 pl-2"
    }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "relative w-full h-full"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Button */ .R.Button, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative w-full h-full rounded-md py-2 pl-3 text-left cursor-pointer", {
        "cursor-not-allowed": disabled,
        "h-6": !selectedLabel,
        "!py-3": isClinicalField
      })
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block truncate", {
        "text-gray-400": !selected
      }),
      title: selectedLabel
    }, (0,lodash__WEBPACK_IMPORTED_MODULE_2__.truncate)(selectedLabel, {
      length: 30
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faAnglesUpDown */ .dB5,
      size: "xs",
      className: "w-5 text-gray-400"
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Transition */ .u, {
      show: open,
      as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
      leave: "transition ease-in duration-100",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Options */ .R.Options, {
      className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-600 dark:bg-gray-700 text-white text-base shadow-lg border border-gray-600 text-left"
    }, options === null || options === void 0 ? void 0 : options.map(function (option, index) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Option */ .R.Option, {
        key: (option === null || option === void 0 ? void 0 : option.id) || index,
        className: function className(_ref2) {
          var selected = _ref2.selected;
          return classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex justify-between relative cursor-default select-none py-2 px-3 hover:bg-teal-800", {
            "bg-gray-600": selected
          });
        },
        value: option
      }, function (_ref3) {
        var selected = _ref3.selected,
            active = _ref3.active;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
          className: "block truncate"
        }, option === null || option === void 0 ? void 0 : option.label), multiple && selected && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faCheck */ .LEp,
          className: "text-teal-400"
        }) // <CheckIcon className="h-5 w-5 text-teal-400" />
        );
      });
    })))));
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (SelectInput);

/***/ }),

/***/ 42641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Unit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85331);


var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;



var TextInput = function TextInput(props) {
  var label = props.label,
      value = props.value,
      _onChange = props.onChange,
      name = props.name,
      id = props.id,
      placeholder = props.placeholder,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      required = props.required,
      disabled = props.disabled,
      type = props.type,
      inputMode = props.inputMode,
      min = props.min,
      max = props.max,
      maxLength = props.maxLength,
      inputRef = props.inputRef,
      isClinicalField = props.isClinicalField,
      _props$wrapperClassNa = props.wrapperClassName,
      wrapperClassName = _props$wrapperClassNa === void 0 ? "" : _props$wrapperClassNa,
      _props$inputClassName = props.inputClassName,
      inputClassName = _props$inputClassName === void 0 ? "" : _props$inputClassName,
      _props$labelClassName = props.labelClassName,
      labelClassName = _props$labelClassName === void 0 ? "" : _props$labelClassName,
      _props$parentClassNam = props.parentClassName,
      parentClassName = _props$parentClassNam === void 0 ? "" : _props$parentClassNam,
      unit = props.unit,
      onChangeUnit = props.onChangeUnit,
      leftContent = props.leftContent,
      rightContent = props.rightContent,
      defaultValue = props.defaultValue,
      error = props.error,
      _onClick = props.onClick,
      subLabel = props.subLabel,
      readOnly = props.readOnly,
      onEnter = props.onEnter,
      onFocus = props.onFocus,
      onBlur = props.onBlur;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !!subLabel && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-md text-left"
  }, subLabel), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative rounded-md py-3 px-2 text-gray-900 dark:text-gray-100", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      "border border-gray-500": !isClinicalField,
      "opacity-70": disabled
    }, wrapperClassName, !!wrapperClassName))
  }, !!label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("text-md", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      "dark:bg-gray-800 bg-gray-200 absolute left-4 -top-3 px-4": !isClinicalField,
      "dark:bg-transparent flex mb-5 text-base": isClinicalField
    }, labelClassName, !!labelClassName))
  }, label, " ", !!required && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "text-red-500 pl-2"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex items-center", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, parentClassName, !!parentClassName))
  }, leftContent && leftContent(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("rounded dark:border-0 w-full flex-1", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      "bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-none pb-2 px-3": isClinicalField
    }, className, !!className))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    ref: inputRef,
    type: type || "text",
    value: value,
    onChange: function onChange(e) {
      return _onChange ? _onChange(e.target.value) : null;
    },
    onClick: function onClick(e) {
      return _onClick ? _onClick(e) : {};
    },
    name: name,
    id: id,
    onFocus: onFocus,
    onBlur: onBlur,
    defaultValue: defaultValue,
    placeholder: placeholder,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block bg-gray-200 dark:bg-transparent w-full border-0 pb-3", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      "border-b border-gray-400 dark:border-gray-200 hover:!border-teal-500 text-center !pb-0": isClinicalField,
      "!border-red-600": isClinicalField && !!error
    }, inputClassName, !!inputClassName)),
    required: required,
    disabled: disabled,
    inputMode: inputMode,
    maxLength: maxLength,
    min: min,
    max: max,
    onKeyDown: function onKeyDown(e) {
      if (e.key !== 'Enter') {
        return;
      }

      onEnter(e);
    },
    readOnly: readOnly
  }), isClinicalField && !!error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-red-600 pt-2 font-medium text-md"
  }, error)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, rightContent && rightContent()), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Unit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    unit: unit,
    onChangeUnit: onChangeUnit
  }))));
};

/* harmony default export */ __webpack_exports__["Z"] = (TextInput);

/***/ }),

/***/ 88741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;


var Loader = function Loader(props) {
  var _props$containerClass = props.containerClassName,
      containerClassName = _props$containerClass === void 0 ? "" : _props$containerClass,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      _props$size = props.size,
      size = _props$size === void 0 ? "small" : _props$size,
      label = props.label;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex flex-col items-center justify-center py-5", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, containerClassName, !!containerClassName))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("border-solid border-gray-400 border-r-transparent animate-spin inline-block rounded-full", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      "border-2 w-4 h-4": size === "small",
      "border-2 w-6 h-6": size === "medium",
      "border-2 w-8 h-8": size === "large"
    }, className, !!className)),
    role: "status"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "sr-only"
  }, "Loading...")), !!label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("text-gray-500 mt-2", {
      "text-sm": size === "small",
      "text-md": size === "medium",
      "text-base": size === "large"
    })
  }, label));
};

/* harmony default export */ __webpack_exports__["Z"] = (Loader);

/***/ }),

/***/ 21951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Menubar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(44080);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 14 modules
var dialog = __webpack_require__(69737);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/DropdownMenu.tsx
var DropdownMenu = __webpack_require__(6039);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(59275);
// EXTERNAL MODULE: ./utils/Store.ts
var Store = __webpack_require__(54837);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pullstate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(69196);
// EXTERNAL MODULE: ./components/common/UserIcon.tsx
var UserIcon = __webpack_require__(48947);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hooks/useCheckWorklistContainer.ts
var useCheckWorklistContainer = __webpack_require__(34559);
// EXTERNAL MODULE: ./utils/index.ts + 4 modules
var utils = __webpack_require__(48032);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(595);
// EXTERNAL MODULE: ./utils/redirectToLogin.ts
var redirectToLogin = __webpack_require__(47472);
// EXTERNAL MODULE: ./hooks/useMedia.ts
var useMedia = __webpack_require__(41148);
// EXTERNAL MODULE: ./components/AwesomeIcon/index.tsx + 2 modules
var AwesomeIcon = __webpack_require__(38266);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ToggleSwitch/Index.jsx






function ToggleSwitch(_ref) {
  var defaultValue = _ref.defaultValue,
      label = _ref.label,
      onClick = _ref.onClick,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight;

  var _useState = (0,react.useState)(defaultValue),
      value = _useState[0],
      setValue = _useState[1];

  var changeValue = function changeValue() {
    setValue(function (prev) {
      return !prev;
    });
    onClick();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex items-center justify-center w-full",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: "flex items-center cursor-pointer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-gray-100 select-none",
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          type: "checkbox",
          className: "sr-only",
          value: !value,
          onChange: changeValue
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex items-center justify-evenly bg-black border border-gray-600 w-[38px] h-[20px] rounded-full",
          children: [iconLeft, iconRight]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()("absolute top-1 bg-gray-600 w-5 h-5 rounded-full transition flex items-center justify-center", {
            "right-1 !bg-teal-400": !value,
            "left-1": value
          }),
          children: value && /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
            name: pro_regular_svg_icons/* faMinus */.Kl4,
            size: "sm"
          })
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ./hooks/useCheckDashboardContainer.tsx


function useCheckDashboardContainer() {
  var _useRouter = (0,next_router.useRouter)(),
      pathname = _useRouter.pathname;

  if (pathname === "/dashboard") {
    return true;
  }

  return false;
}

/* harmony default export */ var hooks_useCheckDashboardContainer = (useCheckDashboardContainer);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(65735);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./components/Patients/PatientsContext.tsx + 3 modules
var PatientsContext = __webpack_require__(65684);
;// CONCATENATED MODULE: ./node_modules/react-circular-progressbar/dist/index.esm.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var VIEWBOX_WIDTH = 100;
var VIEWBOX_HEIGHT = 100;
var VIEWBOX_HEIGHT_HALF = 50;
var VIEWBOX_CENTER_X = 50;
var VIEWBOX_CENTER_Y = 50;

function Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return ((0,react.createElement)("path", { className: className, style: Object.assign({}, style, getDashStyle({ pathRadius: pathRadius, dashRatio: dashRatio, counterClockwise: counterClockwise })), d: getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise,
        }), strokeWidth: strokeWidth, fillOpacity: 0 }));
}
function getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + VIEWBOX_CENTER_X + "," + VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px",
    };
}

var CircularProgressbar = (function (_super) {
    __extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function () {
        if (!this.props.background) {
            return 0;
        }
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function () {
        return VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function () {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function () {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return ((0,react.createElement)("svg", { className: classes.root + " " + className, style: styles.root, viewBox: "0 0 " + VIEWBOX_WIDTH + " " + VIEWBOX_HEIGHT, "data-test-id": "CircularProgressbar" },
            this.props.background ? ((0,react.createElement)("circle", { className: classes.background, style: styles.background, cx: VIEWBOX_CENTER_X, cy: VIEWBOX_CENTER_Y, r: VIEWBOX_HEIGHT_HALF })) : null,
            (0,react.createElement)(Path, { className: classes.trail, counterClockwise: counterClockwise, dashRatio: circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.trail }),
            (0,react.createElement)(Path, { className: classes.path, counterClockwise: counterClockwise, dashRatio: pathRatio * circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.path }),
            text ? ((0,react.createElement)("text", { className: classes.text, style: styles.text, x: VIEWBOX_CENTER_X, y: VIEWBOX_CENTER_Y }, text)) : null));
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background',
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {},
        },
        text: '',
    };
    return CircularProgressbar;
}(react.Component));

function CircularProgressbarWithChildren(props) {
    var children = props.children, circularProgressbarProps = __rest(props, ["children"]);
    return (createElement("div", { "data-test-id": "CircularProgressbarWithChildren" },
        createElement("div", { style: { position: 'relative', width: '100%', height: '100%' } },
            createElement(CircularProgressbar, __assign({}, circularProgressbarProps)),
            props.children ? (createElement("div", { "data-test-id": "CircularProgressbarWithChildren__children", style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    marginTop: '-100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, props.children)) : null)));
}

function buildStyles(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
    return {
        root: {},
        path: removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s",
        }),
        trail: removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
        }),
        text: removeUndefinedValues({
            fill: textColor,
            fontSize: textSize,
        }),
        background: removeUndefinedValues({
            fill: backgroundColor,
        }),
    };
}
function removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function (key) {
        if (obj[key] == null) {
            delete obj[key];
        }
    });
    return obj;
}


//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./components/TermsAndConditionsModal/index.tsx + 4 modules
var TermsAndConditionsModal = __webpack_require__(6081);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./components/ExportMessage/services/downloadService.js
var downloadService = __webpack_require__(35801);
// EXTERNAL MODULE: ./components/NotificationWidget/Tooltip.jsx
var Tooltip = __webpack_require__(6478);
// EXTERNAL MODULE: ./components/Patients/services/getPatients.js
var getPatients = __webpack_require__(42608);
// EXTERNAL MODULE: ./utils/pushNotification.ts
var pushNotification = __webpack_require__(80271);
// EXTERNAL MODULE: ./hooks/useAuthService.ts
var useAuthService = __webpack_require__(52315);
// EXTERNAL MODULE: ./components/Loader/index.tsx
var Loader = __webpack_require__(88741);
// EXTERNAL MODULE: ./components/common/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(79175);
// EXTERNAL MODULE: ./components/NotificationSettings/hooks/useSaveNotificationSettings.ts
var useSaveNotificationSettings = __webpack_require__(72153);
// EXTERNAL MODULE: ./components/Toast/index.jsx + 2 modules
var Toast = __webpack_require__(10921);
;// CONCATENATED MODULE: ./components/Menubar.tsx


var __jsx = react.createElement;


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







































var Menubar = function Menubar(_ref) {
  var _window, _filter$, _window2, _activePatientDetail$, _activePatientDetail$2, _ref4, _activePatientDetail$3;

  var onToggleThemeClick = _ref.onToggleThemeClick;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isStartingDownload = _useState2[0],
      setDownloadExport = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showSwiftFilter = _useState3[0],
      setShowSwiftFilter = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isSubscribeLoading = _useState4[0],
      setSubscribeLoading = _useState4[1];

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      swiftModeEnabled: s.swiftModeEnabled
    };
  }),
      swiftModeEnabled = _useStoreState.swiftModeEnabled;

  var _useState5 = (0,react.useState)(false),
      showTermsAndConditionsModal = _useState5[0],
      setShowTermsAndConditionsModal = _useState5[1];

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var router = (0,next_router.useRouter)();
  var params = (0,lodash.get)(router, ["query", "params"], []);
  var patient_uid = params && params.length ? Number((params === null || params === void 0 ? void 0 : params.length) > 1 ? params === null || params === void 0 ? void 0 : params[1] : params === null || params === void 0 ? void 0 : params[0]) : "";
  var hideMenubar = !!patient_uid && (0,lodash.get)(router, ["route"], "").includes("/patients/");
  var isWorkList = (0,useCheckWorklistContainer/* default */.Z)();
  var isDashboard = hooks_useCheckDashboardContainer();

  var _useContext = (0,react.useContext)(PatientsContext/* PatientsContext */.w),
      patientsData = _useContext.patientsData,
      setLastId = _useContext.setLastId,
      getFilterParams = _useContext.getFilterParams,
      filters = _useContext.filters,
      count = _useContext.count,
      setFilters = _useContext.setFilters;

  var _useAuthService = (0,useAuthService/* default */.Z)(false),
      refetchProfile = _useAuthService.refetch,
      isProfileLoading = _useAuthService.isFetching;

  var saveNotificationSettings = (0,useSaveNotificationSettings/* default */.Z)();

  var _patientsData = (0,lodash.get)(patientsData, ["data", "content"], []);

  var _patientsUID = (0,lodash.map)(_patientsData, "patient_uid");

  var isNotificationSettings = (0,lodash.get)(router, ["pathname"], "").includes("notification-settings");
  var isMobile = (0,useMedia/* default */.Z)([useMedia/* MediaSizes.MOBILE */._.MOBILE], [true], false);
  var isViewerPage = !isWorkList && !isDashboard || isNotificationSettings;

  var _useStoreState2 = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (store) {
    return {
      user: store.user,
      userInfo: store.userInfo,
      patient: store.patient,
      isGetFullAccessOpen: store.isGetFullAccessOpen,
      currentPatient: store.patientDetail,
      isDarkMode: store.isDarkMode,
      isRNTestBuild: store.isRNTestBuild,
      RNSelectedEnv: store.RNSelectedEnv,
      isExportReady: store.isExportReady,
      downloadProgress: store.downloadProgress,
      exportGenFailed: store.exportGenFailed,
      RNfcmToken: store.RNfcmToken,
      fcmToken: store.fcmToken,
      isNotificationSubscribing: store.isNotificationSubscribing
    };
  }),
      user = _useStoreState2.user,
      patient = _useStoreState2.patient,
      isExportReady = _useStoreState2.isExportReady,
      userInfo = _useStoreState2.userInfo,
      downloadProgress = _useStoreState2.downloadProgress,
      exportGenFailed = _useStoreState2.exportGenFailed,
      isGetFullAccessOpen = _useStoreState2.isGetFullAccessOpen,
      isDarkMode = _useStoreState2.isDarkMode,
      isRNTestBuild = _useStoreState2.isRNTestBuild,
      RNSelectedEnv = _useStoreState2.RNSelectedEnv,
      RNfcmToken = _useStoreState2.RNfcmToken,
      fcmToken = _useStoreState2.fcmToken,
      isNotificationSubscribing = _useStoreState2.isNotificationSubscribing;

  var metabase_enabled = (0,lodash.get)(userInfo, ["metabase_enabled"], false);
  var isLoggedIn = (0,utils/* getIsLoggedIn */.M7)();
  var activePatientDetail = (_filter$ = (0,lodash.filter)(_patientsData, ["patient_uid", patient_uid])[0]) !== null && _filter$ !== void 0 ? _filter$ : {};
  var page_size = (0,lodash.get)(patientsData, ["data", "page_size"]);

  var indexOfCurrentPatient = _patientsUID.indexOf(patient_uid);

  var hasPatientDetails = !(0,lodash.isEmpty)(activePatientDetail) || !(0,lodash.isEmpty)(patient);
  var token = RNfcmToken || fcmToken;
  var hasPermission = isMobileApp && !!RNfcmToken || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Notification) === null || _window2 === void 0 ? void 0 : _window2.permission) === "granted";
  var isSubscribed = isNotificationSubscribing || !isLoggedIn && hasPermission || !token && hasPermission || (0,lodash.get)(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return (0,lodash.get)(tokenObj, ["token"], "") === token;
  });
  var isNotificationOn = !isLoggedIn || !(0,lodash.get)(userInfo, ["settings", "notification_snoozed"], false);
  var urlAuthToken = (0,utils/* getUrlAuthToken */.nm)();
  (0,react.useEffect)(function () {
    if (localStorage.getItem(constants/* default.PERSISTED.isSwiftReportModeEnabled */.Z.PERSISTED.isSwiftReportModeEnabled)) {
      Store/* default.update */.Z.update(function (s) {
        s.swiftModeEnabled = true;
      });
    } else {
      Store/* default.update */.Z.update(function (s) {
        s.swiftModeEnabled = false;
      });
    }
  }, []);
  (0,react.useEffect)(function () {
    if (indexOfCurrentPatient === _patientsUID.length - 2 && page_size === 10) {
      setLastId(_patientsUID[_patientsUID.length - 1]);
    }
  }, [indexOfCurrentPatient]);

  var handleChangeButton = function handleChangeButton(type) {
    if (indexOfCurrentPatient !== -1) {
      if (type === "next" && indexOfCurrentPatient !== _patientsData.length) {
        router.replace("/viewer/quredicom/".concat(_patientsUID[indexOfCurrentPatient + 1]));
      } else if (indexOfCurrentPatient !== 0) {
        router.replace("/viewer/quredicom/".concat(_patientsUID[indexOfCurrentPatient - 1]));
      }
    } else {
      var _filterParams = getFilterParams(filters);

      var _params2 = _objectSpread(_objectSpread({
        page_size: 1
      }, _filterParams), {}, {
        pagination_id: (0,lodash.get)(router, ["query", "params", 1]),
        page: type
      });

      (0,getPatients/* default */.Z)(_params2, {}).then(function (_patientsData) {
        router.replace("/viewer/quredicom/".concat((0,lodash.get)(_patientsData, ["data", "first_id"])));
      })["catch"](function (e) {
        console.log("err", e);
      });
    }
  };

  var onBack = function onBack() {
    router.replace("/patients/".concat(patient_uid));
    Store/* default.update */.Z.update(function (s) {
      s.swiftModeEnabled = false;
    });
    localStorage.removeItem(constants/* default.PERSISTED.isSwiftReportModeEnabled */.Z.PERSISTED.isSwiftReportModeEnabled);

    if (swiftModeEnabled) {
      setFilters(constants/* default.DEEFAULT_FILTER */.Z.DEEFAULT_FILTER);
    }
  };

  var onUpdateSubscription = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _window3, _data, _subscription;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(isMobileApp && !hasPermission)) {
                _context.next = 5;
                break;
              }

              _data = {
                event: constants/* default.RN_COMM_CONST.OPEN_APP_SETTINGS */.Z.RN_COMM_CONST.OPEN_APP_SETTINGS,
                data: null
              };
              (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.ReactNativeWebView) === null || _window3 === void 0 ? void 0 : _window3.postMessage(JSON.stringify(_data));
              _context.next = 14;
              break;

            case 5:
              setSubscribeLoading(true);
              _context.next = 8;
              return (0,pushNotification/* subscribeUserNotification */.Wo)(RNfcmToken);

            case 8:
              _subscription = _context.sent;

              if (!_subscription) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return refetchProfile();

            case 12:
              setSubscribeLoading(false);

            case 13:
              setSubscribeLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onUpdateSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onToggleNotification = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(value) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return saveNotificationSettings.mutateAsync({
                notification_snoozed: !value
              });

            case 3:
              _context2.next = 5;
              return refetchProfile();

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              Toast/* default.error */.Z.error("Something went wrong. Please retry");

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function onToggleNotification(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (userInfo !== null && userInfo !== void 0 && userInfo.patients_export) {
      Store/* default.update */.Z.update(function (s) {
        var _userInfo$patients_ex, _userInfo$patients_ex2, _userInfo$patients_ex3, _userInfo$patients_ex4;

        s.isExportReady = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex = userInfo.patients_export) === null || _userInfo$patients_ex === void 0 ? void 0 : _userInfo$patients_ex.available;
        s.exportTimestamp = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex2 = userInfo.patients_export) === null || _userInfo$patients_ex2 === void 0 ? void 0 : _userInfo$patients_ex2.timestamp;
        s.downloadProgress = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex3 = userInfo.patients_export) === null || _userInfo$patients_ex3 === void 0 ? void 0 : _userInfo$patients_ex3.progress;
        s.exportGenFailed = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex4 = userInfo.patients_export) === null || _userInfo$patients_ex4 === void 0 ? void 0 : _userInfo$patients_ex4.failed;
      });
    }
  }, [userInfo]);

  var startDownload = function startDownload() {
    if (isExportReady) {
      Store/* default.update */.Z.update(function (s) {
        s.showExportUpdate = true;
      });
    } else if ((downloadProgress === 0 || downloadProgress === 100) && !isStartingDownload) {
      setDownloadExport(true);
      var _url = "patients_export/start_generation/";
      (0,downloadService/* patientsExportService */.G)(_url).then(function (response) {
        setDownloadExport(false);

        if (response !== null && response !== void 0 && response.success) {
          Store/* default.update */.Z.update(function (s) {
            s.isExportReady = false;
            s.downloadProgress = 1;
            s.exportGenFailed = false;
          });
        }
      })["catch"](function (resp) {
        setDownloadExport(false);
        Store/* default.update */.Z.update(function (s) {
          s.isExportReady = false;
          s.downloadProgress = 0;
          s.exportGenFailed = true;
        });
      });
    }
  };

  var profileNavigations = [{
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start p-4 bg-gray-700 overflow-hidden rounded-t text-white"
    }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(UserIcon/* default */.Z, {
      name: (0,lodash.get)(user, ["name"], "") || (0,lodash.get)(user, ["preferred_username"], ""),
      className: "h-8 w-8 text-lg"
    })), /*#__PURE__*/react.createElement("div", {
      className: "pl-4 flex flex-col items-start justify-center"
    }, /*#__PURE__*/react.createElement("div", {
      className: "font-medium text-base break-all"
    }, (0,lodash.get)(user, ["name"], "") || (0,lodash.get)(user, ["preferred_username"], "")), /*#__PURE__*/react.createElement("div", {
      className: "text-md text-gray-400 break-all"
    }, (0,lodash.get)(user, ["email"], "")))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start gap-3"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faHandshake */.yOe
    }), /*#__PURE__*/react.createElement("p", null, "Terms of use")),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement("div", {
      className: "h-6 w-6 flex items-center"
    }, /*#__PURE__*/react.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react.createElement("g", {
      clipPath: "url(#clip0_16743_149855)"
    }, /*#__PURE__*/react.createElement("path", {
      d: "M18.125 9.5C18.125 6.39453 15.6055 3.875 12.5 3.875C9.39453 3.875 6.875 6.39453 6.875 9.5C6.875 9.98438 7.05078 10.7344 7.47266 11.7344C7.88281 12.7031 8.46484 13.7734 9.13281 14.8555C10.2461 16.6602 11.5352 18.4023 12.5 19.6445C13.4688 18.4023 14.7578 16.6602 15.8672 14.8555C16.5352 13.7734 17.1172 12.7031 17.5273 11.7344C17.9492 10.7344 18.125 9.98438 18.125 9.5ZM20 9.5C20 12.9141 15.4297 18.9922 13.4258 21.5C12.9453 22.0977 12.0547 22.0977 11.5742 21.5C9.57031 18.9922 5 12.9141 5 9.5C5 5.35938 8.35938 2 12.5 2C16.6406 2 20 5.35938 20 9.5ZM13.75 9.5C13.75 9.16848 13.6183 8.85054 13.3839 8.61612C13.1495 8.3817 12.8315 8.25 12.5 8.25C12.1685 8.25 11.8505 8.3817 11.6161 8.61612C11.3817 8.85054 11.25 9.16848 11.25 9.5C11.25 9.83152 11.3817 10.1495 11.6161 10.3839C11.8505 10.6183 12.1685 10.75 12.5 10.75C12.8315 10.75 13.1495 10.6183 13.3839 10.3839C13.6183 10.1495 13.75 9.83152 13.75 9.5ZM9.375 9.5C9.375 8.6712 9.70424 7.87634 10.2903 7.29029C10.8763 6.70424 11.6712 6.375 12.5 6.375C13.3288 6.375 14.1237 6.70424 14.7097 7.29029C15.2958 7.87634 15.625 8.6712 15.625 9.5C15.625 10.3288 15.2958 11.1237 14.7097 11.7097C14.1237 12.2958 13.3288 12.625 12.5 12.625C11.6712 12.625 10.8763 12.2958 10.2903 11.7097C9.70424 11.1237 9.375 10.3288 9.375 9.5Z",
      fill: "#00D0CD"
    })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
      id: "clip0_16743_149855"
    }, /*#__PURE__*/react.createElement("rect", {
      width: "15",
      height: "20",
      fill: "white",
      transform: "translate(5 2)"
    }))))), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, (0,lodash.get)(constants/* default */.Z, ["REGION_LABELS", (0,utils/* getCurrentRegion */.w9)()], "global"))),
    onClick: function onClick() {},
    className: "block dark:text-gray-200 text-gray-800 cursor-pointer hover:!bg-gray-800 hover:!text-gray-100"
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement("div", {
      className: "h-6 w-6 flex items-center justify-center"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faArrowRightFromBracket */.SJh,
      size: "lg"
    })), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, t("logout_key"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isLogoutOpen = true;
      });
    }
  }];
  var exportMenu = {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-between",
      onClick: startDownload
    }, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()("flex items-center justify-start", {
        "opacity-50": isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady
      })
    }, /*#__PURE__*/react.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react.createElement("path", {
      d: "M6.875 19.5V4.5C6.875 4.15625 7.15625 3.875 7.5 3.875H13.75V7C13.75 7.69141 14.3086 8.25 15 8.25H18.125V19.5C18.125 19.8438 17.8438 20.125 17.5 20.125H7.5C7.15625 20.125 6.875 19.8438 6.875 19.5ZM7.5 2C6.12109 2 5 3.12109 5 4.5V19.5C5 20.8789 6.12109 22 7.5 22H17.5C18.8789 22 20 20.8789 20 19.5V8.03516C20 7.37109 19.7383 6.73438 19.2695 6.26562L15.7305 2.73047C15.2617 2.26172 14.6289 2 13.9648 2H7.5ZM11.875 12V13.875H9.375V12H11.875ZM9.375 15.125H11.875V17H9.375V15.125ZM13.125 15.125H15.625V17H13.125V15.125ZM12.5 18.25H13.125H15.625C16.3164 18.25 16.875 17.6914 16.875 17V15.125V14.5V13.875V12C16.875 11.3086 16.3164 10.75 15.625 10.75H13.125H12.5H11.875H9.375C8.68359 10.75 8.125 11.3086 8.125 12V13.875V14.5V15.125V17C8.125 17.6914 8.68359 18.25 9.375 18.25H11.875H12.5ZM13.125 13.875V12H15.625V13.875H13.125Z"
    })), /*#__PURE__*/react.createElement("p", {
      className: "ml-3"
    }, isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady ? "Preparing export..." : "Export data")), exportGenFailed && /*#__PURE__*/react.createElement("div", {
      className: "flex text-md text-red-600 dark:text-red-400 font-normal"
    }, "Failed,try again"), downloadProgress > 0 && !isExportReady && /*#__PURE__*/react.createElement("div", {
      className: "w-6 h-6"
    }, /*#__PURE__*/react.createElement(CircularProgressbar, {
      value: downloadProgress,
      styles: buildStyles({
        rotation: 0.25,
        strokeLinecap: "butt",
        textSize: "24px",
        pathTransitionDuration: 0.5,
        pathColor: "rgba(0, 130, 128)",
        textColor: "#f88",
        trailColor: isDarkMode ? "white" : "#b6aeae",
        backgroundColor: "white"
      })
    }))),
    onClick: function onClick() {}
  };
  var settingsMenu = [{
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faBell */.qmU,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_notification"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isNotificationSettingsOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_light_svg_icons/* faShareNodes */.M6U,
      size: "xl",
      className: "w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_automated"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isAutomatedSharingOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faUserGroup */.NdV,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_user"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isUserGroupOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faList */.Zrf,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_worklist"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isSettingsModalOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_light_svg_icons/* faFile */.gMD,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_report"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isReportTemplateOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faUsersMedical */.y9Q,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_workspace"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isWorkspaceOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faNetworkWired */.kXW,
      size: "lg",
      className: "w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start ml-3"
    }, t("setting_connection"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isConnectModalityOpen = true;
      });
    }
  }, exportMenu];
  var addPatientmenu = [{
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faCircleUser */.V3X,
      size: "lg",
      className: "w-6 mr-3"
    }), t("add_patient")),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isAddPatientOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_light_svg_icons/* faFileArrowUp */.PQh,
      size: "lg",
      className: "w-6 mr-3"
    }), t("add_import_scans")),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.uploadModal = {
          isOpen: true,
          hasCurrentPatient: false
        };
      });
    }
  }];
  var mobileMenu = [{
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faList */.Zrf,
      size: "lg",
      className: "w-6 mr-5"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_worklist"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isSettingsModalOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faBell */.qmU,
      size: "lg",
      className: "mr-5 w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_notification"))),
    onClick: function onClick() {
      if (isMobile) {
        router.push("/notification-settings");
      } else {
        Store/* default.update */.Z.update(function (s) {
          s.isNotificationSettingsOpen = true;
        });
      }
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_light_svg_icons/* faShareNodes */.M6U,
      size: "xl",
      className: "w-6 mr-5"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_automated"))),
    onClick: function onClick() {
      Store/* default.update */.Z.update(function (s) {
        s.isAutomatedSharingOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faUserGroup */.NdV,
      size: "lg",
      className: "w-6 mr-5"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start"
    }, t("setting_user"))),
    onClick: function onClick() {
      Store/* default.update */.Z.update(function (s) {
        s.isUserGroupOpen = true;
      });
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement("div", {
      className: "h-6 w-6 flex items-center"
    }, /*#__PURE__*/react.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react.createElement("g", {
      clipPath: "url(#clip0_16743_149855)"
    }, /*#__PURE__*/react.createElement("path", {
      d: "M18.125 9.5C18.125 6.39453 15.6055 3.875 12.5 3.875C9.39453 3.875 6.875 6.39453 6.875 9.5C6.875 9.98438 7.05078 10.7344 7.47266 11.7344C7.88281 12.7031 8.46484 13.7734 9.13281 14.8555C10.2461 16.6602 11.5352 18.4023 12.5 19.6445C13.4688 18.4023 14.7578 16.6602 15.8672 14.8555C16.5352 13.7734 17.1172 12.7031 17.5273 11.7344C17.9492 10.7344 18.125 9.98438 18.125 9.5ZM20 9.5C20 12.9141 15.4297 18.9922 13.4258 21.5C12.9453 22.0977 12.0547 22.0977 11.5742 21.5C9.57031 18.9922 5 12.9141 5 9.5C5 5.35938 8.35938 2 12.5 2C16.6406 2 20 5.35938 20 9.5ZM13.75 9.5C13.75 9.16848 13.6183 8.85054 13.3839 8.61612C13.1495 8.3817 12.8315 8.25 12.5 8.25C12.1685 8.25 11.8505 8.3817 11.6161 8.61612C11.3817 8.85054 11.25 9.16848 11.25 9.5C11.25 9.83152 11.3817 10.1495 11.6161 10.3839C11.8505 10.6183 12.1685 10.75 12.5 10.75C12.8315 10.75 13.1495 10.6183 13.3839 10.3839C13.6183 10.1495 13.75 9.83152 13.75 9.5ZM9.375 9.5C9.375 8.6712 9.70424 7.87634 10.2903 7.29029C10.8763 6.70424 11.6712 6.375 12.5 6.375C13.3288 6.375 14.1237 6.70424 14.7097 7.29029C15.2958 7.87634 15.625 8.6712 15.625 9.5C15.625 10.3288 15.2958 11.1237 14.7097 11.7097C14.1237 12.2958 13.3288 12.625 12.5 12.625C11.6712 12.625 10.8763 12.2958 10.2903 11.7097C9.70424 11.1237 9.375 10.3288 9.375 9.5Z",
      fill: "#00D0CD"
    })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
      id: "clip0_16743_149855"
    }, /*#__PURE__*/react.createElement("rect", {
      width: "15",
      height: "20",
      fill: "white",
      transform: "translate(5 2)"
    }))))), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, (0,lodash.get)(constants/* default */.Z, ["REGION_LABELS", (0,utils/* getCurrentRegion */.w9)()], "global"))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start gap-2"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faHandshake */.yOe
    }), /*#__PURE__*/react.createElement("p", null, "Terms of use")),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
    }
  }, {
    name: /*#__PURE__*/react.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faArrowRightFromBracket */.SJh,
      size: "lg",
      className: "mr-5 w-6"
    }), /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-start"
    }, t("logout_key"))),
    onClick: function onClick() {
      return Store/* default.update */.Z.update(function (s) {
        s.isLogoutOpen = true;
      });
    }
  }];

  if (urlAuthToken && !isLoggedIn) {
    var _onClose = function _onClose() {
      Store/* default.update */.Z.update(function (s) {
        s.isGetFullAccessOpen = false;
      });
    };

    var _onOpen = function _onOpen() {
      Store/* default.update */.Z.update(function (s) {
        s.isGetFullAccessOpen = true;
      });
    };

    return /*#__PURE__*/react.createElement("header", {
      className: classnames_default()("flex items-center bg-gray-900 px-5 py-4 border-b border-gray-800", {
        "pt-8": (0,utils/* isWebView */.vp)()
      })
    }, /*#__PURE__*/react.createElement((link_default()), {
      href: "/"
    }, /*#__PURE__*/react.createElement((image_default()), {
      className: "block h-auto w-auto cursor-pointer",
      src: "/assets/images/qureLogo.svg",
      alt: "Qure.ai",
      width: "76",
      height: "25"
    })), /*#__PURE__*/react.createElement("button", {
      className: "bg-teal-500 ml-auto py-3 px-5 rounded-lg",
      onClick: _onOpen
    }, /*#__PURE__*/react.createElement("span", {
      className: "text-gray-200"
    }, t("full_access"))), /*#__PURE__*/react.createElement(Modal/* default */.Z, {
      show: isGetFullAccessOpen,
      onClose: _onClose,
      title: "Get Full Access",
      className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
      closeOnClickAway: true
    }, /*#__PURE__*/react.createElement("div", {
      className: "p-5"
    }, /*#__PURE__*/react.createElement("div", {
      className: "text-lg text-gray-800 dark:text-gray-200 py-3"
    }, t("add_worklist_signin_access")), /*#__PURE__*/react.createElement("div", {
      className: "text-gray-100 text-base space-x-5"
    }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
      onClick: _onClose,
      className: "grow-1 px-6 py-4"
    }, t("no_thanks")), /*#__PURE__*/react.createElement(Button/* default */.Z, {
      isPrimary: true,
      onClick: function onClick() {
        return (0,redirectToLogin/* default */.Z)();
      },
      className: "grow-1 px-6 py-4"
    }, t("add_worklist"))))));
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(transition/* Transition.Root */.u.Root, {
    show: open,
    as: react.Fragment
  }, /*#__PURE__*/react.createElement(dialog/* Dialog */.V, {
    as: "div",
    className: "relative lg:hidden",
    onClose: setOpen
  }, /*#__PURE__*/react.createElement(transition/* Transition.Child */.u.Child, {
    as: react.Fragment,
    enter: "transition-opacity ease-linear duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity ease-linear duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-25"
  })), /*#__PURE__*/react.createElement("div", {
    className: "fixed inset-0 z-50 flex text-gray-200"
  }, /*#__PURE__*/react.createElement(transition/* Transition.Child */.u.Child, {
    as: react.Fragment,
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "-translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "-translate-x-full"
  }, /*#__PURE__*/react.createElement(dialog/* Dialog.Panel */.V.Panel, {
    className: "relative flex w-[290px] max-w-[85%] flex-col overflow-y-auto bg-gray-800 pb-12 shadow-xl"
  }, /*#__PURE__*/react.createElement("div", {
    className: "pb-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("flex flex-col items-start justify-start p-4 bg-gray-700 overflow-hidden", {
      "pt-9": (0,utils/* isWebView */.vp)()
    })
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(UserIcon/* default */.Z, {
    name: (0,lodash.get)(user, ["name"], "") || (0,lodash.get)(user, ["preferred_username"], ""),
    className: "h-8 w-8 text-lg"
  })), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-start justify-center mt-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "font-medium text-base break-all"
  }, (0,lodash.get)(user, ["name"], "") || (0,lodash.get)(user, ["preferred_username"], "")), /*#__PURE__*/react.createElement("div", {
    className: "text-md text-gray-400 break-all"
  }, (0,lodash.get)(user, ["email"], "")))), /*#__PURE__*/react.createElement("div", {
    className: "max-w-3xl"
  }, !hasPermission || !isSubscribed ? /*#__PURE__*/react.createElement("div", {
    className: "bg-yellow-900 text-md p-4 py-5"
  }, isSubscribeLoading ? /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Loader/* default */.Z, {
    size: "medium",
    label: "Please wait",
    className: "mr-3",
    containerClassName: "!py-0 flex !flex-row"
  })) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("p", {
    className: "pr-2"
  }, t("notification_modal.no_notifications_setting")), /*#__PURE__*/react.createElement("span", {
    className: "text-yellow-400 font-bold cursor-pointer",
    onClick: onUpdateSubscription
  }, t("notification_modal.update_settings")))) : /*#__PURE__*/react.createElement("div", {
    className: "flex p-4 items-center justify-between border-b border-gray-700"
  }, /*#__PURE__*/react.createElement("div", null, t("notifications_turned_on")), /*#__PURE__*/react.createElement(Toggle/* default */.Z, {
    value: isNotificationOn,
    onChange: onToggleNotification,
    disabled: saveNotificationSettings.isLoading || isProfileLoading || isNotificationSubscribing
  })), /*#__PURE__*/react.createElement("div", {
    className: "flex p-4 pt-5 text-md text-gray-500 items-center"
  }, t("menu.settings")), mobileMenu.map(function (item, index) {
    return /*#__PURE__*/react.createElement("div", {
      key: index,
      className: "",
      onClick: function onClick() {
        setOpen(false);
        item === null || item === void 0 ? void 0 : item.onClick();
      }
    }, item.name);
  }), !!isRNTestBuild && /*#__PURE__*/react.createElement("div", {
    className: "",
    onClick: function onClick() {
      Store/* default.update */.Z.update(function (s) {
        s.isRNEnvSelectorOpen = true;
      });
      setOpen(false);
    }
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex p-4 items-center justify-start"
  }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
    name: pro_light_svg_icons/* faMobileNotch */.QUp,
    className: "h-6 w-6 mr-5"
  }), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col items-start justify-start"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-start"
  }, "Debug Environment"), /*#__PURE__*/react.createElement("div", {
    className: "flex justify-start text-sm"
  }, RNSelectedEnv))))))))))), /*#__PURE__*/react.createElement("header", {
    className: classnames_default()("bg-gray-900 shadow-sm lg:static lg:overflow-y-visible h-fit border-b-none sm:border-b border-gray-800", {
      "hidden sm:block": hideMenubar,
      "mt-7": (0,utils/* isWebView */.vp)()
    })
  }, /*#__PURE__*/react.createElement("div", {
    className: "mx-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: "relative flex sm:justify-between"
  }, !isNotificationSettings && /*#__PURE__*/react.createElement("div", {
    className: "flex items-center sm:hidden inset-y-0"
  }, /*#__PURE__*/react.createElement("button", {
    onClick: function onClick() {
      return setOpen(true);
    },
    className: "-mx-2 rounded-md p-5 inline-flex items-center justify-center text-gray-200"
  }, /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, t("open_menu")), /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
    name: pro_regular_svg_icons/* faAlignJustify */.z1q,
    size: "lg",
    className: "w-6"
  }))), /*#__PURE__*/react.createElement("div", {
    className: "flex md:left-0 md:inset-y-0 lg:static xl:col-span-2"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex flex-shrink-0"
  }, /*#__PURE__*/react.createElement("span", {
    className: "hidden sm:flex justify-center items-center ml-4 cursor-pointer"
  }, /*#__PURE__*/react.createElement((link_default()), {
    href: "/"
  }, /*#__PURE__*/react.createElement((image_default()), {
    className: "block h-auto w-auto",
    src: "/assets/images/qureLogo.svg",
    alt: "Qure.ai",
    width: "76",
    height: "25"
  }))), (isDashboard || isWorkList) && metabase_enabled && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "text-gray-100 flex items-center ".concat(router.asPath === "/dashboard" ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10 ", "\n                                transition duration-500\n                                hover:bg-teal-500/10 ml-6 px-4")
  }, /*#__PURE__*/react.createElement((link_default()), {
    href: "/dashboard"
  }, t("dashboard_key"))), /*#__PURE__*/react.createElement("div", {
    className: "text-gray-100 flex items-center ".concat(/patients/g.test(router.asPath) ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10", "\n                              transition duration-500 hover:bg-teal-500/10  px-4")
  }, /*#__PURE__*/react.createElement((link_default()), {
    href: "/patients"
  }, t("worklist_key")))), isViewerPage && /*#__PURE__*/react.createElement("span", {
    onClick: onBack,
    className: classnames_default()("flex justify-center items-center text-gray-200 cursor-pointer p-5", {
      "ml-8 border-l border-gray-800": !isWorkList && !isNotificationSettings
    })
  }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
    name: pro_regular_svg_icons/* faAngleLeft */.EyR,
    className: "ml-3 w-5 mr-3"
  }), t("back_key")))), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center text-white md:space-x-8"
  }, /*#__PURE__*/react.createElement(Tooltip/* default */.Z, {
    tooltipContainerStyles: "cursor-pointer",
    tooltipText: /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("p", null, "Previous Patient")),
    position: "right",
    verticalPosition: "bottom",
    tooltipStyles: "text-sm rounded-6 p-3 px-4 text-gray-100",
    tooltipBg: "bg-gray-700"
  }, /*#__PURE__*/react.createElement("button", {
    disabled: (indexOfCurrentPatient === 0 || (0,lodash.isEmpty)(activePatientDetail)) && indexOfCurrentPatient !== -1,
    onClick: function onClick() {
      handleChangeButton("prev");
    },
    className: "disabled:opacity-50 hidden md:block"
  }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
    name: pro_regular_svg_icons/* faChevronLeft */.A35,
    className: classnames_default()("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  }))), /*#__PURE__*/react.createElement("div", {
    className: "items-center text-gray-200 flex"
  }, hasPatientDetails && !isWorkList && !isDashboard && /*#__PURE__*/react.createElement("span", null, (_activePatientDetail$ = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.name) !== null && _activePatientDetail$ !== void 0 ? _activePatientDetail$ : patient === null || patient === void 0 ? void 0 : patient.name, " |", " ", /*#__PURE__*/react.createElement("span", {
    title: (_activePatientDetail$2 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$2 !== void 0 ? _activePatientDetail$2 : patient === null || patient === void 0 ? void 0 : patient.patientID
  }, (_ref4 = (_activePatientDetail$3 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$3 !== void 0 ? _activePatientDetail$3 : patient === null || patient === void 0 ? void 0 : patient.patientID) === null || _ref4 === void 0 ? void 0 : _ref4.slice(0, 10)))), /*#__PURE__*/react.createElement(Tooltip/* default */.Z, {
    tooltipContainerStyles: "cursor-pointer",
    tooltipText: /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("p", null, "Next Patient")),
    position: "left",
    verticalPosition: "bottom",
    tooltipStyles: "text-sm rounded-6 p-3 px-4 text-gray-100",
    tooltipBg: "bg-gray-700"
  }, /*#__PURE__*/react.createElement("button", {
    disabled: (indexOfCurrentPatient === _patientsUID.length - 1 || (0,lodash.isEmpty)(activePatientDetail)) && indexOfCurrentPatient !== -1,
    className: "disabled:opacity-50 hidden md:block",
    onClick: function onClick() {
      handleChangeButton("next");
    }
  }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
    name: pro_solid_svg_icons/* faChevronRight */._tD,
    className: classnames_default()("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  })))), swiftModeEnabled && isViewerPage && /*#__PURE__*/react.createElement("div", {
    className: "border-teal-700 group z-50 relative h-fit my-auto flex items-center border rounded-lg bg-gray-800"
  }, /*#__PURE__*/react.createElement("div", {
    className: "bg-teal-800 py-3 pr-5 pl-2 border-teal-700 border-r rounded-l-lg flex items-center space-x-4"
  }, /*#__PURE__*/react.createElement("svg", {
    onClick: function onClick() {
      setShowSwiftFilter(!showSwiftFilter);
    },
    className: "text-teal-500 dark:text-gray-400 w-6 h-6 cursor-pointer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M14.1406 4.5C15.0273 4.5 15.75 5.22109 15.75 6.10937C15.75 6.51562 15.5977 6.91016 15.2852 7.20703L11.6523 11.1172V18.2266C11.6523 18.9297 11.1172 19.5 10.4141 19.5C10.1289 19.5 9.91797 19.4258 9.71094 19.2891L6.73047 17.3438C6.32422 17.0547 6.0625 16.5625 6.0625 16.0391V11.1172L2.43047 7.20703C2.15375 6.91016 2 6.51562 2 6.10937C2 5.22109 2.72109 4.5 3.61055 4.5H14.1406ZM7.90234 10.75V15.8711L9.77734 17.1094V10.75C9.77734 10.5117 9.90234 10.2852 10.0625 10.1133L13.5312 6.375H4.2168L7.6875 10.1133C7.84766 10.2852 7.90234 10.5117 7.90234 10.75ZM21.0625 17.3125C21.582 17.3125 22 17.7305 22 18.25C22 18.7695 21.582 19.1875 21.0625 19.1875H15.4375C14.918 19.1875 14.5 18.7695 14.5 18.25C14.5 17.7305 14.918 17.3125 15.4375 17.3125H21.0625ZM14.5 12C14.5 11.4805 14.918 11.0625 15.4375 11.0625H21.0625C21.582 11.0625 22 11.4805 22 12C22 12.5195 21.582 12.9375 21.0625 12.9375H15.4375C14.918 12.9375 14.5 12.5195 14.5 12ZM21.0625 4.8125C21.582 4.8125 22 5.23242 22 5.75C22 6.26953 21.582 6.6875 21.0625 6.6875H17.9375C17.418 6.6875 17 6.26953 17 5.75C17 5.23242 17.418 4.8125 17.9375 4.8125H21.0625Z",
    className: "fill-gray-500 dark:fill-gray-400"
  })), /*#__PURE__*/react.createElement("p", {
    className: "font-semibold text-teal-300 "
  }, indexOfCurrentPatient + 1, " of ", count)), /*#__PURE__*/react.createElement("p", {
    className: "text-white font-medium px-5 py-3"
  }, t("swift_report_mode")), /*#__PURE__*/react.createElement("button", {
    title: t("exit_swift_reporting_mode"),
    onClick: function onClick() {
      onBack();
    },
    className: "bg-red-700 invisible group-hover:visible border border-gray-600 rounded-r-lg px-3 py-3"
  }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
    name: pro_regular_svg_icons/* faXmark */.g82,
    className: "w-6 h-6 text-gray-100 stroke-2"
  })), showSwiftFilter && /*#__PURE__*/react.createElement("div", {
    className: "absolute translate-y-[75%] z-50 bg-gray-800 border text-gray-200 gap-4 rounded-xl border-gray-700 flex flex-wrap p-5"
  }, /*#__PURE__*/react.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("negative")), /*#__PURE__*/react.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("screened_by_qure")), /*#__PURE__*/react.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, "CXR"))), /*#__PURE__*/react.createElement("div", {
    className: "hidden sm:flex sm:items-center sm:justify-end xl:col-span-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex mr-6 space-x-3"
  }, /*#__PURE__*/react.createElement(ToggleSwitch, {
    defaultValue: isDarkMode,
    onClick: onToggleThemeClick,
    label: "",
    iconLeft: null,
    iconRight: null
  }), /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
    name: pro_solid_svg_icons/* faSunBright */.x_p,
    size: "lg",
    className: "text-gray-300 dark:text-gray-600"
  })), isWorkList && /*#__PURE__*/react.createElement(DropdownMenu/* default */.Z, {
    options: addPatientmenu,
    hasCustomControl: true,
    Icon: function Icon(_ref5) {
      var open = _ref5.open;
      return /*#__PURE__*/react.createElement("div", {
        className: classnames_default()("inline-flex items-center justify-center text-base font-medium rounded-6 text-gray-100 !px-5 !py-3 mr-3 bg-teal-800 hover:bg-teal-900", {
          "!bg-teal-500": open
        })
      }, t("add_key"), " ", /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
        name: pro_regular_svg_icons/* faAngleDown */.gc2,
        size: "sm",
        className: classnames_default()("block w-4 ml-2", {
          "rotate-180": open
        })
      }));
    }
  }), /*#__PURE__*/react.createElement(DropdownMenu/* default */.Z, {
    options: settingsMenu,
    menuItemClassName: "z-50",
    Icon: function Icon() {
      return /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
        name: pro_regular_svg_icons/* faGear */.gr5,
        size: "lg",
        className: "m-5"
      });
    }
  }), isLoggedIn && /*#__PURE__*/react.createElement(DropdownMenu/* default */.Z, {
    options: profileNavigations,
    Icon: function Icon(_ref6) {
      var open = _ref6.open;
      return /*#__PURE__*/react.createElement(UserIcon/* default */.Z, {
        className: classnames_default()("h-7 w-7 m-4 group-hover:bg-gray-700", {
          "!bg-gray-700": open
        }),
        name: (0,lodash.get)(user, ["name"], "") || (0,lodash.get)(user, ["preferred_username"], "")
      });
    }
  })))), showTermsAndConditionsModal && /*#__PURE__*/react.createElement(TermsAndConditionsModal/* default */.Z, {
    onClose: function onClose() {
      setShowTermsAndConditionsModal(false);
    } // closeOnClickAway
    ,
    mode: "readonly"
  })));
};

/* harmony default export */ var components_Menubar = (Menubar);

/***/ }),

/***/ 72153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39949);



var useSaveNotificationSettings = function useSaveNotificationSettings() {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(function (params) {
    return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postService */ .Z.postService("/profile/notifications/", params);
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useSaveNotificationSettings);

/***/ }),

/***/ 65684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ PatientsContext; },
  "S": function() { return /* binding */ PatientsContextProvider; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/pullstate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(69196);
// EXTERNAL MODULE: ./utils/Store.ts
var Store = __webpack_require__(54837);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/websocket/lib/browser.js
var browser = __webpack_require__(45840);
;// CONCATENATED MODULE: ./hooks/useWebsocket.tsx



var useWebsocket = function useWebsocket(urlPath, isEnabled) {
  var _useState = (0,react.useState)(null),
      wsData = _useState[0],
      setWSData = _useState[1];

  var _useState2 = (0,react.useState)(null),
      socket = _useState2[0],
      setSocket = _useState2[1]; // useful in showing the states for the socket connections


  var _useState3 = (0,react.useState)(false),
      isWSConnectionOpen = _useState3[0],
      setConnectionOpen = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      isWSConnectionLoading = _useState4[0],
      setConnectionLoading = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isWSConnectionClosed = _useState5[0],
      setConnectionClosed = _useState5[1];

  (0,react.useEffect)(function () {
    if (!isEnabled) {
      return;
    }

    var websocket;
    var connectionTimeout;

    var connect = function connect() {
      var socketUrl = "wss://platformapius-rsna.qure.ai/ws" + urlPath;
      websocket = new browser.w3cwebsocket(socketUrl);

      websocket.onopen = function () {
        setConnectionOpen(true);
        setConnectionLoading(false);
        clearTimeout(connectionTimeout);
        setSocket(websocket);
      };

      websocket.onerror = function () {
        setConnectionOpen(false);
        setConnectionLoading(false);
        websocket.close();
      };

      websocket.onmessage = function (event) {
        if (typeof event.data === "string") {
          var _data = JSON.parse(event.data);

          setWSData(_data);
        }
      };

      websocket.onclose = function (e) {
        if (!isWSConnectionClosed) {
          console.log("Socket is closed. Trying to reconnect...");
          connectionTimeout = setTimeout(function () {
            connect();
          }, 5000);
        }
      };
    };

    connect();
    return function () {
      var _websocket;

      if (((_websocket = websocket) === null || _websocket === void 0 ? void 0 : _websocket.readyState) === 1) {
        var _websocket2;

        setConnectionClosed(true);
        setConnectionOpen(false);
        (_websocket2 = websocket) === null || _websocket2 === void 0 ? void 0 : _websocket2.close();
      }
    };
  }, []);
  return {
    socket: socket,
    wsData: wsData,
    isWSConnectionOpen: isWSConnectionOpen,
    isWSConnectionLoading: isWSConnectionLoading
  };
};

/* harmony default export */ var hooks_useWebsocket = (useWebsocket);
// EXTERNAL MODULE: ./hooks/useMedia.ts
var useMedia = __webpack_require__(41148);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./utils/index.ts + 4 modules
var utils = __webpack_require__(48032);
// EXTERNAL MODULE: ./components/Patients/services/getPatients.js
var getPatients = __webpack_require__(42608);
// EXTERNAL MODULE: ./utils/servicesUtils.ts
var servicesUtils = __webpack_require__(39949);
;// CONCATENATED MODULE: ./components/Patients/services/getCounts.js



var getCounts = function getCounts() {
  var apiParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve, reject) {
    servicesUtils/* default.postService */.Z.postService("/patients/counts/", apiParams).then(function (data) {
      resolve(data.data.count);
    })["catch"](function (err) {
      reject(err);
    });
  });
};

/* harmony default export */ var services_getCounts = (getCounts);
// EXTERNAL MODULE: ./components/Settings/utils/index.js
var Settings_utils = __webpack_require__(54089);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
;// CONCATENATED MODULE: ./components/MatchingPatient/services/getMatchingPatient.ts


var getMatchingPatient = function getMatchingPatient(patient_id) {
  return servicesUtils/* default.getService */.Z.getService("/patients/".concat(patient_id, "/match/?threshold=50"));
};

/* harmony default export */ var services_getMatchingPatient = (getMatchingPatient);
// EXTERNAL MODULE: ./components/ExportMessage/services/downloadService.js
var downloadService = __webpack_require__(35801);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Patients/PatientsContext.tsx




var __jsx = react.createElement;


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
















var PatientsContext = /*#__PURE__*/(0,react.createContext)({});
var PatientsContextProvider = function PatientsContextProvider(props) {
  var _localStorage, _localStorage2, _localStorage3;

  var children = props.children;
  var pageSize = constants/* default.PAGE_SIZE */.Z.PAGE_SIZE;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      user: s.user,
      newPatientId: s.newPatientId
    };
  }),
      user = _useStoreState.user,
      newPatientId = _useStoreState.newPatientId;

  var userId = (0,lodash.get)(user, ["sub"], "");
  var isLoggedIn = !(0,lodash.isEmpty)(user);

  var _useState = (0,react.useState)(""),
      lastId = _useState[0],
      setLastId = _useState[1];

  var _useState2 = (0,react.useState)(null),
      patientsData = _useState2[0],
      setPatientsData = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      updatedMessage = _useState3[0],
      setUpdatedMessage = _useState3[1];

  var _useState4 = (0,react.useState)({}),
      unreadMessages = _useState4[0],
      setUnreadMessages = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      currentPatient = _useState5[0],
      setCurrentPatient = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isPatientsLoading = _useState6[0],
      setPatientsLoading = _useState6[1];

  var _useState7 = (0,react.useState)(0),
      count = _useState7[0],
      setCount = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      isCountLoading = _useState8[0],
      setIsCountLoading = _useState8[1];

  var _persistedFilters = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(constants/* default.PERSISTED.filterObj */.Z.PERSISTED.filterObj);

  var _useState9 = (0,react.useState)(_persistedFilters ? JSON.parse(_persistedFilters) : constants/* default.DEEFAULT_FILTER */.Z.DEEFAULT_FILTER),
      filters = _useState9[0],
      setFilters = _useState9[1];

  var _persistedSavedFilters = (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem(constants/* default.PERSISTED.savedFilterData */.Z.PERSISTED.savedFilterData);

  var _useState10 = (0,react.useState)(_persistedSavedFilters ? JSON.parse(_persistedSavedFilters) : null),
      savedFilterData = _useState10[0],
      setSavedFilterData = _useState10[1];

  var _persistedFullWidthWorklist = (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.getItem(constants/* default.PERSISTED.isFullWidthWorklist */.Z.PERSISTED.isFullWidthWorklist);

  var _useState11 = (0,react.useState)(!!_persistedFullWidthWorklist),
      isFullWidthWorklist = _useState11[0],
      setIsFullWidthWorklist = _useState11[1];

  var _useState12 = (0,react.useState)([]),
      matchingPatients = _useState12[0],
      setMatchingPatients = _useState12[1];

  var _useWebsocket = hooks_useWebsocket("/worklist/".concat(userId, "/"), !(0,lodash.isEmpty)(user)),
      socket = _useWebsocket.socket,
      wsData = _useWebsocket.wsData;

  var router = (0,next_router.useRouter)();
  var isMobile = (0,useMedia/* default */.Z)([useMedia/* MediaSizes.MOBILE */._.MOBILE], [true], false);

  var getPatientData = function getPatientData() {
    var filterParams = getFilterParams(filters);

    var params = _objectSpread({
      page_size: pageSize
    }, filterParams);

    if (lastId) {
      params.pagination_id = lastId;
    }

    setPatientsLoading(true);
    (0,getPatients/* default */.Z)(params, patientsData).then( /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_patientsData) {
        var _emergencyPatients, _emergencyPatientsData2, _updatedPatients;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _emergencyPatients = [];

                if (lastId) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return (0,Settings_utils/* getEmergencyPatients */.T)();

              case 4:
                _emergencyPatientsData2 = _context.sent;
                _emergencyPatients = (0,lodash.get)(_emergencyPatientsData2, ["data", "content"], []);

              case 6:
                _updatedPatients = updatePatientList(_patientsData || patientsData, _emergencyPatients);
                setPatientsData(_updatedPatients);
                setPatientsLoading(false);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())["catch"](function (e) {
      setPatientsLoading(false);
    });
  };

  (0,react.useEffect)(function () {
    if (isLoggedIn) {
      getPatientData();
    }
  }, [lastId, pageSize, filters]);
  (0,react.useEffect)(function () {
    /* get total patient count just for display on top on worklist */
    if (isLoggedIn) {
      var _params = getFilterParams(filters);

      setIsCountLoading(true);
      services_getCounts(_params).then(function (_count) {
        setCount(_count);
        setIsCountLoading(false);
      })["catch"](function () {
        setCount(0);
        setIsCountLoading(false);
      });
    }
  }, [filters]);
  (0,react.useEffect)(function () {
    if (!(0,lodash.isEmpty)(currentPatient)) {
      var _currentPatientUid = (0,lodash.get)(currentPatient, ["patient_uid"], 0);

      findMatchingPatient(_currentPatientUid);
    }
  }, [currentPatient]);

  var getFilterParams = function getFilterParams(_filters) {
    var _filters$data;

    var filterParams = _objectSpread({}, (_filters$data = _filters === null || _filters === void 0 ? void 0 : _filters.data) !== null && _filters$data !== void 0 ? _filters$data : {});

    var startDate = (0,lodash.get)(filterParams, ["start_date"], "");
    var endDate = (0,lodash.get)(filterParams, ["end_date"], "");

    if (startDate) {
      var _startDateVal = new Date(startDate);

      var _endDateVal = (0,add/* default */.Z)(new Date(endDate), {
        days: 1
      });

      if ((0,utils/* isValidDate */.qb)(_startDateVal) && (0,utils/* isValidDate */.qb)(_endDateVal)) {
        _startDateVal.setHours(0, 0, 0);

        _endDateVal.setHours(0, 0, 0);

        (0,lodash.set)(filterParams, ["start_date"], _startDateVal.toISOString());
        (0,lodash.set)(filterParams, ["end_date"], _endDateVal.toISOString());
      }
    }

    return filterParams;
  };

  var updatePatientUnreadCount = function updatePatientUnreadCount(currentPatientUid, hasNewMessage) {
    var patients = (0,lodash.get)(patientsData, ["data", "content"], []);
    var currentPatient = patients && patients.find(function (p) {
      return (0,lodash.get)(p, ["patient_uid"], 0) == currentPatientUid;
    });
    var count = 0;

    if (hasNewMessage) {
      count = (0,lodash.get)(currentPatient, ["unread_message_count"], 0) + 1;
    }

    if (currentPatient) {
      (0,lodash.set)(currentPatient, ["unread_message_count"], count);
    }
  };

  var getPatientsByEmergency = function getPatientsByEmergency(_patients) {
    var _emergencyPatients = _patients.filter(function (_pat) {
      return (0,lodash.get)(_pat, ["emergency", "stale"], null) === false;
    });

    var _nonEmergencyPatients = _patients.filter(function (_pat) {
      var stale = (0,lodash.get)(_pat, ["emergency", "stale"], null);
      return stale === true || stale === null;
    });

    return {
      _emergencyPatients: _emergencyPatients,
      _nonEmergencyPatients: _nonEmergencyPatients
    };
  };

  var formPatientStateObject = function formPatientStateObject(_patients, _patientsData) {
    if (_patientsData) {
      var _content = Object.assign(_patientsData, {
        data: _objectSpread(_objectSpread({}, _patientsData.data), {}, {
          content: _patients
        })
      });

      return _content;
    }

    return _patientsData;
  };

  var updatePatientList = function updatePatientList(patientsData, _emergencyPatients) {
    var patientIds = _emergencyPatients.map(function (_pat) {
      return _pat.patient_uid;
    });

    var _patientsData = (0,lodash.clone)(patientsData);

    var _patients = (0,lodash.get)(_patientsData, ["data", "content"], []);

    _patients = _patients.filter(function (_pat) {
      return !patientIds.includes(_pat.patient_uid);
    });
    _patients = [].concat((0,toConsumableArray/* default */.Z)(_emergencyPatients), (0,toConsumableArray/* default */.Z)(_patients));
    return formPatientStateObject(_patients, _patientsData);
  };

  var findMatchingPatient = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_patientUid) {
      var _matches;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_patientUid) {
                _context2.next = 5;
                break;
              }

              _context2.next = 3;
              return services_getMatchingPatient(_patientUid);

            case 3:
              _matches = _context2.sent;
              setMatchingPatients(_matches);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function findMatchingPatient(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (wsData) {
      var _filterObj = localStorage.getItem(constants/* default.PERSISTED.filterObj */.Z.PERSISTED.filterObj);

      var _isFilterApplied = false;

      if (_filterObj) {
        var _JSON$parse;

        _isFilterApplied = (_JSON$parse = JSON.parse(_filterObj)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.isFilterApplied;
      }

      if (wsData.action == "new_message" || wsData.action == "update_message" || wsData.action == "unsubscribe" || wsData.action == "subscribe") {
        var _unreadMessages2 = (0,lodash.clone)(unreadMessages);

        if (wsData.action == "new_message") {
          var _msgContent = (0,lodash.get)(wsData, ["content"], {});

          var _msgPatientUid = (0,lodash.get)(_msgContent, ["patient_uid"], 0);

          var _currentPatientUid2 = (0,lodash.get)(currentPatient, ["patient_uid"], 0); // --- Kept this code for future use ---
          // const msgsList = _unreadMessages[msgPatientUid] || []
          // msgsList.unshift(msgContent)


          (0,lodash.set)(_unreadMessages2, [_msgPatientUid], [_msgContent]); // [...msgsList]

          if ((0,lodash.get)(_msgContent, ["user"], "") !== userId && _msgPatientUid != _currentPatientUid2) {
            updatePatientUnreadCount(_msgPatientUid, true);
          }

          if (((0,lodash.get)(_msgContent, ["image_report_uid"], 0) > 0 || (0,lodash.get)(_msgContent, ["image_study_uid"], 0) > 0) && _msgPatientUid === _currentPatientUid2) {
            Store/* default.update */.Z.update(function (s) {
              s.enableViewerAPICall = false;
            });
            setTimeout(function () {
              Store/* default.update */.Z.update(function (s) {
                s.enableViewerAPICall = true;
              });
            }, 500);
          }
        }

        if (wsData.action == "update_message") {
          var _msgContent2 = (0,lodash.get)(wsData, ["content"], {});

          setUpdatedMessage(_msgContent2);
        }

        if (wsData.action == "unsubscribe") {
          var _msgPatientUid2 = (0,lodash.get)(wsData, ["patient_uid"], 0);

          (0,lodash.set)(_unreadMessages2, [_msgPatientUid2], []);
        }

        if (wsData.action == "subscribe") {
          var _msgPatientUid3 = (0,lodash.get)(wsData, ["patient_uid"], 0);

          updatePatientUnreadCount(_msgPatientUid3);
        }

        setUnreadMessages(_unreadMessages2);
      }

      if (wsData.action == "new_patient" && !_isFilterApplied) {
        var _newPatient = (0,lodash.get)(wsData, ["content"], {});

        var _newPatientId2 = (0,lodash.get)(_newPatient, ["patient_id"], "");

        var _newPatientUid2 = (0,lodash.get)(_newPatient, ["patient_uid"], "");

        var _patientsData2 = (0,lodash.clone)(patientsData);

        var _patients2 = (0,lodash.get)(patientsData, ["data", "content"], []);

        var _getPatientsByEmergen = getPatientsByEmergency(_patients2),
            _emergencyPatients = _getPatientsByEmergen._emergencyPatients,
            _nonEmergencyPatients = _getPatientsByEmergen._nonEmergencyPatients;

        _nonEmergencyPatients.unshift(_newPatient);

        var _updatedPatientData = formPatientStateObject([].concat((0,toConsumableArray/* default */.Z)(_emergencyPatients), (0,toConsumableArray/* default */.Z)(_nonEmergencyPatients)), _patientsData2);

        setPatientsData(_updatedPatientData); // for auto selecting newly registered patient by user

        if (newPatientId && _newPatientId2 && newPatientId === _newPatientId2) {
          if (isMobile) {
            var _workList = document.getElementById("worklist-container");

            if (_workList) {
              _workList["scrollTop"] = 0;
            }
          } else {
            router.push("/patients/".concat(_newPatientUid2));
          }

          Store/* default.update */.Z.update(function (s) {
            s.newPatientId = "";
          });
        }
      }

      if (wsData.action === "new_emergency" || wsData.action === "update_emergency") {
        var _newPatientEmergencyContent = (0,lodash.get)(wsData, ["content"], {});

        var _patientsData3 = (0,lodash.clone)(patientsData);

        var _patients3 = (0,lodash.get)(_patientsData3, ["data", "content"], []);

        var _patientId = (0,lodash.get)(_newPatientEmergencyContent, ["patient_id"]);

        var _stale = (0,lodash.get)(_newPatientEmergencyContent, ["stale"], false);

        if (wsData.action === "update_emergency") {
          var _selectedEmergencyPatient2 = _patients3.find(function (_pat) {
            return _pat.patient_uid === _patientId;
          }); // _selectedEmergencyPatient =
          //   _selectedEmergencyPatient && _selectedEmergencyPatient[0];


          if (_selectedEmergencyPatient2) {
            _selectedEmergencyPatient2.emergency = _stale ? null : _newPatientEmergencyContent;
          }

          _patients3 = _patients3.filter(function (_pat) {
            return _pat.patient_uid !== _patientId;
          });

          var _getPatientsByEmergen2 = getPatientsByEmergency(_patients3),
              _emergencyPatients2 = _getPatientsByEmergen2._emergencyPatients,
              _nonEmergencyPatients2 = _getPatientsByEmergen2._nonEmergencyPatients;

          _patients3 = [].concat((0,toConsumableArray/* default */.Z)(_emergencyPatients2), (0,toConsumableArray/* default */.Z)(_selectedEmergencyPatient2 ? [_selectedEmergencyPatient2] : []), (0,toConsumableArray/* default */.Z)(_nonEmergencyPatients2));

          if (currentPatient && _selectedEmergencyPatient2 && (currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === _selectedEmergencyPatient2.patient_uid) {
            setCurrentPatient(_objectSpread({}, _selectedEmergencyPatient2));
          }
        } else if (wsData.action === "new_emergency") {
          var _updatedPatient = _patients3.filter(function (_pat) {
            return _pat.patient_uid === _patientId;
          }).map(function (_pat) {
            return Object.assign(_pat, {
              emergency: _newPatientEmergencyContent
            });
          });

          _patients3 = _patients3.filter(function (_pat) {
            return _pat.patient_uid !== _patientId;
          });

          _patients3.unshift((0,lodash.get)(_updatedPatient, [0], {}));
        }

        var _updatedPatientData3 = formPatientStateObject(_patients3, _patientsData3);

        setPatientsData(_updatedPatientData3);
      }

      if (wsData.action == "update_patient") {
        var _patientsData4 = (0,lodash.clone)(patientsData);

        var _newPatient2 = (0,lodash.get)(wsData, ["content"], {});

        var _patients4 = (0,lodash.get)(_patientsData4, ["data", "content"], []);

        var _patientToUpdateIdx = _patients4.findIndex(function (p) {
          return p.patient_uid === _newPatient2.patient_uid;
        });

        if (_patientToUpdateIdx >= 0) {
          _patients4[_patientToUpdateIdx] = _newPatient2;
          setPatientsData(_patientsData4);

          if ((currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_uid) === (_newPatient2 === null || _newPatient2 === void 0 ? void 0 : _newPatient2.patient_uid)) {
            setCurrentPatient(_newPatient2);
          }
        }
      }

      if (wsData.action === "export_download_started") {
        Store/* default.update */.Z.update(function (s) {
          s.showExportUpdate = true;
          s.downloadProgress = wsData.progress;
          s.exportGenFailed = false;
        });
      }

      if (wsData.action === "export_download_progress") {
        Store/* default.update */.Z.update(function (s) {
          s.isExportReady = false;
          s.exportGenFailed = false;
          s.downloadProgress = wsData.progress;
        });
      }

      if (wsData.action === "export_generation_complete") {
        Store/* default.update */.Z.update(function (s) {
          s.isExportReady = true;
          s.exportGenFailed = false;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        }); // Api call to download the Export file

        (0,downloadService/* downloadFile */.S)();
      }

      if (wsData.action === "export_download_failed") {
        Store/* default.update */.Z.update(function (s) {
          s.showExportUpdate = true;
          s.isExportReady = false;
          s.exportGenFailed = true;
          s.exportTimestamp = wsData.timestamp;
          s.downloadProgress = wsData.progress;
        });
      }
    }
  }, [wsData]);
  return /*#__PURE__*/react.createElement(PatientsContext.Provider, {
    value: {
      patientsData: patientsData,
      setPatientsData: setPatientsData,
      getPatientData: getPatientData,
      updatePatientUnreadCount: updatePatientUnreadCount,
      updatedMessage: updatedMessage,
      setUpdatedMessage: setUpdatedMessage,
      unreadMessages: unreadMessages,
      setUnreadMessages: setUnreadMessages,
      currentPatient: currentPatient,
      setCurrentPatient: setCurrentPatient,
      getFilterParams: getFilterParams,
      lastId: lastId,
      setLastId: setLastId,
      isPatientsLoading: isPatientsLoading,
      setPatientsLoading: setPatientsLoading,
      filters: filters,
      setFilters: setFilters,
      count: count,
      isCountLoading: isCountLoading,
      setIsFullWidthWorklist: setIsFullWidthWorklist,
      isFullWidthWorklist: isFullWidthWorklist,
      matchingPatients: matchingPatients,
      setMatchingPatients: setMatchingPatients,
      savedFilterData: savedFilterData,
      setSavedFilterData: setSavedFilterData,
      socket: socket,
      wsData: wsData
    }
  }, children);
};

/***/ }),

/***/ 38292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ $createImageNode; },
/* harmony export */   "HJ": function() { return /* binding */ ImageNode; },
/* harmony export */   "dP": function() { return /* binding */ $isImageNode; }
/* harmony export */ });
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92777);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82262);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45959);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32998);
/* harmony import */ var lexical__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lexical__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var __jsx = react__WEBPACK_IMPORTED_MODULE_1__.createElement;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}




var ImageComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.lazy( // @ts-ignore
function () {
  return __webpack_require__.e(/* import() */ 385).then(__webpack_require__.bind(__webpack_require__, 37385));
});

function convertImageElement(domNode) {
  if (domNode instanceof HTMLImageElement) {
    var altText = domNode.alt,
        src = domNode.src,
        height = domNode.height,
        width = domNode.width;

    var _node = $createImageNode({
      altText: altText,
      src: src,
      height: height,
      width: width,
      captionsEnabled: false,
      showCaption: false
    });

    return {
      node: _node
    };
  }

  return null;
}

var ImageNode = /*#__PURE__*/function (_DecoratorNode) {
  (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ImageNode, _DecoratorNode);

  var _super = _createSuper(ImageNode);

  function ImageNode(src, altText, maxWidth, width, height, showCaption, caption, captionsEnabled, key) {
    var _this;

    (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ImageNode);

    _this = _super.call(this, key);
    _this.__src = src;
    _this.__altText = altText;
    _this.__maxWidth = maxWidth;
    _this.__width = width || "inherit";
    _this.__height = height || "inherit";
    _this.__showCaption = showCaption || false;
    _this.__caption = caption || (0,lexical__WEBPACK_IMPORTED_MODULE_3__.createEditor)();
    _this.__captionsEnabled = captionsEnabled || captionsEnabled === undefined;
    return _this;
  }

  (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ImageNode, [{
    key: "exportDOM",
    value: function exportDOM() {
      var element = document.createElement("img");
      element.setAttribute("src", this.__src);
      element.setAttribute("alt", this.__altText);
      element.setAttribute('width', this.__width.toString());
      element.setAttribute('height', this.__height.toString());
      return {
        element: element
      };
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        altText: this.getAltText(),
        caption: this.__caption.toJSON(),
        height: this.__height === "inherit" ? 0 : this.__height,
        maxWidth: this.__maxWidth,
        showCaption: this.__showCaption,
        src: this.getSrc(),
        type: "image",
        version: 1,
        width: this.__width === "inherit" ? 0 : this.__width
      };
    }
  }, {
    key: "setWidthAndHeight",
    value: function setWidthAndHeight(width, height) {
      var writable = this.getWritable();
      writable.__width = typeof width === "number" ? Math.floor(width) : width;
      writable.__height = typeof height === "number" ? Math.floor(height) : height;
    }
  }, {
    key: "setShowCaption",
    value: function setShowCaption(showCaption) {
      var writable = this.getWritable();
      writable.__showCaption = showCaption;
    } // View

  }, {
    key: "createDOM",
    value: function createDOM(config) {
      var span = document.createElement("span");
      var theme = config.theme;
      var className = theme.image;

      if (className !== undefined) {
        span.className = className;
      }

      return span;
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "getSrc",
    value: function getSrc() {
      return this.__src;
    }
  }, {
    key: "getAltText",
    value: function getAltText() {
      return this.__altText;
    }
  }, {
    key: "decorate",
    value: function decorate() {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: null
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(ImageComponent, {
        src: this.__src,
        altText: this.__altText,
        width: this.__width,
        height: this.__height,
        maxWidth: this.__maxWidth,
        nodeKey: this.getKey(),
        showCaption: this.__showCaption,
        caption: this.__caption,
        captionsEnabled: this.__captionsEnabled,
        resizable: true
      }));
    }
  }], [{
    key: "getType",
    value: // Captions cannot yet be used within editor cells
    function getType() {
      return "image";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new ImageNode(node.__src, node.__altText, node.__maxWidth, node.__width, node.__height, node.__showCaption, node.__caption, node.__captionsEnabled, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serializedNode) {
      var altText = serializedNode.altText,
          height = serializedNode.height,
          width = serializedNode.width,
          maxWidth = serializedNode.maxWidth,
          caption = serializedNode.caption,
          src = serializedNode.src,
          showCaption = serializedNode.showCaption;
      var node = $createImageNode({
        altText: altText,
        height: height,
        maxWidth: maxWidth,
        showCaption: showCaption,
        src: src,
        width: width
      });
      var nestedEditor = node.__caption;
      var editorState = nestedEditor.parseEditorState(caption.editorState);

      if (!editorState.isEmpty()) {
        nestedEditor.setEditorState(editorState);
      }

      return node;
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        img: function img(node) {
          return {
            conversion: convertImageElement,
            priority: 0
          };
        }
      };
    }
  }]);

  return ImageNode;
}(lexical__WEBPACK_IMPORTED_MODULE_3__.DecoratorNode);
function $createImageNode(_ref) {
  var altText = _ref.altText,
      height = _ref.height,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 500 : _ref$maxWidth,
      captionsEnabled = _ref.captionsEnabled,
      src = _ref.src,
      width = _ref.width,
      showCaption = _ref.showCaption,
      caption = _ref.caption,
      key = _ref.key;
  return new ImageNode(src, altText, maxWidth, width, height, showCaption, caption, captionsEnabled, key);
}
function $isImageNode(node) {
  return node instanceof ImageNode;
}

/***/ }),

/***/ 6081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TermsAndConditionsModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(595);
// EXTERNAL MODULE: ./hooks/useMedia.ts
var useMedia = __webpack_require__(41148);
// EXTERNAL MODULE: ./utils/index.ts + 4 modules
var utils = __webpack_require__(48032);
// EXTERNAL MODULE: ./utils/Store.ts
var Store = __webpack_require__(54837);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./components/Toast/index.jsx + 2 modules
var Toast = __webpack_require__(10921);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(59275);
// EXTERNAL MODULE: ./components/common/Checkbox.tsx + 2 modules
var Checkbox = __webpack_require__(48831);
;// CONCATENATED MODULE: ./components/TermsAndConditionsModal/PrivacyPolicyContent.tsx
var __jsx = react.createElement;


var PrivacyPolicyContent = function PrivacyPolicyContent() {
  return /*#__PURE__*/react.createElement("div", {
    className: "mx-auto max-w-3xl break-words leading-relaxed"
  }, /*#__PURE__*/react.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "Privacy Notice")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("b", null, "Effective Date: 1"), /*#__PURE__*/react.createElement("b", null, "st"), /*#__PURE__*/react.createElement("b", null, "\xA0September 2022"), "\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "This Privacy Policy explains how we use the personal information that Qure.ai Technologies Private Limited, its subsidiaries and affiliates collects or generates both in relation to our Website\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/"
  }, "https://qure.ai/"), "\xA0along with any webpages and portals thereof and our mobile application, products and services (\u201C", /*#__PURE__*/react.createElement("b", null, "Privacy Policy"), "\u201D) as updated from time to time.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Qure.ai Technologies Private Limited, company registration CIN U74999MH2016PTC283891 having its\xA0registered office at Level 7, Commerz II, International Business Park, Oberoi Garden City, Off. W.E. Highway, Goregaon (E) Mumbai 400063 along with its subsidiaries and affiliates (hereafter \u201C", /*#__PURE__*/react.createElement("b", null, "Qure"), "\u201D, \u201C", /*#__PURE__*/react.createElement("b", null, "we"), "\u201D, \u201C", /*#__PURE__*/react.createElement("b", null, "us"), "\u201D or \u201C", /*#__PURE__*/react.createElement("b", null, "our"), "\u201D) collects, uses or processes your (\u201C", /*#__PURE__*/react.createElement("b", null, "you"), "\u201D or \u201C", /*#__PURE__*/react.createElement("b", null, "your"), "\u201D or \u201C", /*#__PURE__*/react.createElement("b", null, "Customer"), "\u201D or \u201C", /*#__PURE__*/react.createElement("b", null, "User"), "\u201D) personal data. This Privacy Policy is applicable when you use our Website\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/"
  }, "https://qure.ai/"), "\xA0along with any webpages and portals thereof or the Qure mobile application i.e., QureApp (the \u201C", /*#__PURE__*/react.createElement("b", null, "Website"), "\u201D and \u201C", /*#__PURE__*/react.createElement("b", null, "Application"), "\u201D respectively) or Qure\u2019s proprietary software including but not limited to qXR, qER, qCT, qScout POqUS, qTrack and all its allied renditions, Devices etc. (collectively the \u201C", /*#__PURE__*/react.createElement("b", null, "Services"), "\u201D). Our Services also include the\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://app.qure.ai/"
  }, "https://app.qure.ai/"), "\xA0and\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://scan.qure.ai/"
  }, "https://scan.qure.ai"), "\xA0portal, which is a platform for free trial of our products.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "All definitions in this Privacy Policy shall be interpreted in accordance with applicable data protection laws which refers to the General Data Protection Regulation (Regulation no. 2016/679) and the Directive on Privacy and Electronic Communications (Directive 2002/58/EC), as well as the national implementations and related national legislation. All capitalized terms used herein and not otherwise defined are defined as set forth in\xA0the\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/legal/#legal-disclaimer/"
  }, "Universal Terms"), "\xA0and\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/legal/#legal-disclaimer/:~:text=Universal%20Terms-,Data%20Processing%20Agreement,-Legal%20Disclaimer"
  }, "Data Processing Agreement."), "\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "This Privacy Policy shall be construed in accordance with the applicable data protection laws, including but not limited to Data Protection Act 2018, General Data Protection Regulation (GDPR), Children\u2019s Online Privacy Protection Act (COPPA), Information Technology Act 2000 (IT Act), The Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules 2011 (SPDI rules) and Health Insurance Portability and Accountability Act (HIPAA).")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "By visiting our Website, or using our Application or Services, you acknowledge and accept the data processing described in this Privacy Policy, our Website terms and related documents. We will let you know, by posting on our Website or otherwise, if we make any changes to this Privacy Policy from time to time. Your continued use of the Services after notifying such changes will amount to your acknowledgement and acceptance of the amended Privacy Policy.\xA0\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "We strive to treat your personal information as safely and securely as reasonably possible. As described below, your personal data may be collected and used by Qure or disclosed to third parties for use on behalf of Qure. This Privacy Policy describes the information we collect about you and what may happen to that information. You must be at least 18 years old to have our permission to use our Services. Our policy is that we do not knowingly collect, use or disclose Personal data about visitors that are under 18 years of age.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "I. About the service")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "See separate \u2018Universal Terms\u2019\xA0(", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/legal/"
  }, "https://qure.ai/legal/"), ")\xA0for applicable terms and conditions of the Services that Qure provides.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "II. Personal data?")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("b", null, "a. What is personal data?"), "\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\xA0\u201CPersonal data\u201D means any information relating to an identified or identifiable natural person, known as \u2018Data Subject\u2019, who can be identified directly or indirectly; it may include name, address, gender, email address, phone number, IP address, location data, cookies, call records and similar information. It may also include \u201Cspecial categories of personal data\u201D such as racial or ethnic origin, political opinions, religious or philosophical beliefs, or trade union membership, and the processing of genetic data, biometric data for the purpose of uniquely identifying a Data Subject, data concerning health or data concerning a natural person\u2019s sexual orientation.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("b", null, "b. What Personal data does Qure collect and process?"), "\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Qure receives, processes and stores two distinct sets of personal data.\u202F We will process the following personal data on the Services:\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "User profiles"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "First and Last Name\xA0"), /*#__PURE__*/react.createElement("li", null, "E-mail address at the time of sign up\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "Technical usage data"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "such as the URL you are accessing the Services from, your IP address, unique device ID, network and computer performance, browser type, language and identifying information and operating system;\u202F\xA0"), /*#__PURE__*/react.createElement("li", null, "information about your use of the Services, such as what you viewed or searched for; page response times, download errors, length of visits to certain pages, page interaction information (such as scrolling, clicks and mouse-overs), consultation length(s), recurrence of visits and other interaction information, methods used to browse away from the page.\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "A third set of personal data is processed using the QureApp, which you as a User will upload the data on the platform and Qure will act as Data Processor on behalf as of you as Data Controller for this data:"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "Anonymised patient case information pseudonymized DICOM images including embedded metadata;\xA0\xA0"), /*#__PURE__*/react.createElement("li", null, "content that you post, upload and/or contribute to the Services;\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "For the data listed in clause II (b) (3) above, where you as a User of the Services will act as Data Controller and Qure\xA0 as provider of Services, will act as a Data Processor, you hereby acknowledge and agree for\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/legal/"
  }, "Data Processing Agreement"), "\xA0which is effective from the date of your first use of Services. The Data Processing Agreement outlines what kind of processing we are instructed to perform on your behalf regarding Personal data pertaining to Data Subjects where you are the Data Controller.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Information about third parties should only be provided to us if you have demonstrable permission and consent of Data Subjects i.e., your patients, to do so or if the information is available in the public domain.\xA0You shall be solely responsible for receiving all informed, written, explicit or implicit consents as required under applicable laws, from the Data Subjects i.e., your patients or similar data owners. Your use of Services is deemed that such consents have been duly received by you and will be available upon request for Qure to audit. We will rely on you to provide information which is accurate, complete and up to date and you agree to ensure this.\xA0\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "III. Why does Qure process this Personal data?")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Qure will process the Personal data sets described above for the following purposes:\u202F\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "To enable you to verify your account, to administer your account, to enable and provide the Services and integration with third party services, and to provide, personalize and improve your experience with the Services, and to otherwise provide the Services according to the Terms of Service;\u202F\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "to send you alerts or messages by email or otherwise, including to provide you with marketing of our and our related parties\u2019 products and services;\xA0"), /*#__PURE__*/react.createElement("li", null, "to inform you about updates of the Services or the terms and conditions of Services;\xA0"), /*#__PURE__*/react.createElement("li", null, "to improve and develop the Services or new services and to analyse your use of the Services;\xA0"), /*#__PURE__*/react.createElement("li", null, "to ensure the technical functioning of the Services and to prevent the use of the Services in breach of the Terms (including the Universal Terms and any other terms in relation to Application or Services);\xA0"), /*#__PURE__*/react.createElement("li", null, "to enforce the Terms and any additional Terms (including the Universal Terms and any other terms in relation to Application or Services), including to protect our rights, property and safety and the rights, property and safety of third parties if necessary;\u202F\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "to fulfil our obligations as Data Controller and Data Processor;\xA0"), /*#__PURE__*/react.createElement("li", null, "to respect and fulfil our obligations in regards to the Rights of the Data Subject;\xA0"), /*#__PURE__*/react.createElement("li", null, "to respond to any queries you raise with us and to provide customer support; and\u202F\xA0"), /*#__PURE__*/react.createElement("li", null, "to fulfil requirements by law (see clause VIII below).\u202F\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "We will be unable to provide you the Services unless you provide us with the Personal data listed in clause II.b above. The processing of the Personal data above is necessary to enter into the Terms (including Universal Terms) with us and to maintain the contractual relationship between you and us, where Qure will act as Data Processor for the collected data. Some of this collected information is subject to processing of third parties, both within and outside the European Union (third countries).\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "The data listed in clause II.b.2 above is solely collected and used for performance and issue handling pertaining to the platform and will not be used for identifying you as a user, unless this is requested by official legal investigations as in provided in clause VIII below.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "The processing of your Personal data for the purposes listed above is conducted on the basis of the legitimate interest of Qure. Our legitimate interest for the processing is maintaining sufficient IT security through logging data when you use our Services and to evade fraud and to protect the Services from cyber threats. We also log data for the maintenance and improvement of our Services.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "IV. Disclosure of personal data")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "There are circumstances where we may wish to disclose or are compelled to disclose your Personal data to third parties. These scenarios include disclosure to:\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "our affiliates and sister companies;\xA0our service providers who capture and store data collected through the forms that are filled by visitors to our Website;\xA0subject to appropriate legal basis such as consent, our advertising and marketing teams who enable us, for example, to deliver personalized ads to your devices or who may contact you by email, telephone, SMS or by other means;\xA0public authorities where we are required by law to do so; and\xA0other third parties where you have provided your consent.\xA0"), /*#__PURE__*/react.createElement("li", null, "our affiliates and sister companies;\xA0"), /*#__PURE__*/react.createElement("li", null, "our service providers who capture and store data collected through the forms that are filled by visitors to our Website;\xA0"), /*#__PURE__*/react.createElement("li", null, "subject to appropriate legal basis such as consent, our advertising and marketing teams who enable us, for example, to deliver personalized ads to your devices or who may contact you by email, telephone, SMS or by other means;\xA0"), /*#__PURE__*/react.createElement("li", null, "public authorities where we are required by law to do so; and\xA0"), /*#__PURE__*/react.createElement("li", null, "other third parties where you have provided your consent.\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "The service providers are contractually bound not to share Personal data collected from visitors on our Website with anyone else.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "We confirm and acknowledge that we do not commercially exploit or distribute Personal data to any third party for commercial purposes. We share and disclose your Personal data to companies with which we have contracts in place. These companies mainly provide data storage, data analytics, advertising, IT support and other services to be able to run and improve our Services.\xA0\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "When you use our Services, you may be directed to other websites where the Personal data collected is not in our control. The privacy policy of such other websites will govern the Personal data obtained from you on that website.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "V. Cookie Statement")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "In order to collect the information including Personal data as described in this Privacy Policy, we may use cookies and similar technology on our Website. A cookie is a small piece of information which is sent to your browser and stored on your computer\u2019s hard drive, mobile phone or other device (\u201C", /*#__PURE__*/react.createElement("b", null, "Cookies"), "\u201D). Cookies can be first party, i.e. cookies that the website you are visiting places on your device, or third party cookies, i.e. cookies placed on your device through the Website but by third parties, such as, Google.\xA0\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "We use the Cookies for the sole purpose of making it possible to browse the Website and let you use its functionalities. We use third party Cookies like Google Analytics to collect statistical information in an aggregated form on the number of users accessing the Website and generate statistical data on how the visitor uses the Website. We also use third party advertisements on our Website. Some of these advertisers such as Google through Google AdSense program may collect information including your IP address, your ISP, the browser you used to visit our Website, etc. You can refer to the list of cookies used by us along with the purpose of using them below.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "You can choose to disable or selectively turn off our third party cookies in your browser settings, however, this may affect how you are able to interact with our Website as well as other websites.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold"
  }, "VI. Our website")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "table-auto md:hidden"
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Cookie name"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Purpose"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Duration"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Domain"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Category")))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gat")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Used by Google Analytics to throttle request rate")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "2 years\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_ga\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gid")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "csrftoken\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Helps prevent Cross-Site Request Forgery (CSRF) attacks.\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "1 year")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "app.qure.ai/scan.qure.ai portal\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "collect")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Used to send data to Google Analytics about the visitor\u2019s device and behavior. Tracks the visitor across devices and marketing channels.")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "google-analytics.com\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gat")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Used by Google Analytics to throttle request rate\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "2 years ")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_ga")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gid")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.", " ")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))))), /*#__PURE__*/react.createElement("table", {
    className: "hidden table-auto md:block"
  }, /*#__PURE__*/react.createElement("tbody", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Cookie name"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Purpose"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Duration"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Domain"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Category")))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gat")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Used by Google Analytics to throttle request rate")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "2 years\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_ga\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gid")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "csrftoken\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Helps prevent Cross-Site Request Forgery (CSRF) attacks.\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "1 year")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "app.qure.ai/scan.qure.ai portal\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "collect")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Used to send data to Google Analytics about the visitor\u2019s device and behavior. Tracks the visitor across devices and marketing channels.")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "google-analytics.com\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gat")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Used by Google Analytics to throttle request rate\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "2 years ")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_ga")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_gid")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.", " ")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Session")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "qure.ai\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics")))))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "table-auto md:hidden"
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "AUTH_SESSION_ID")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "AUTH_SESSION_ID_LEGACY ")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_IDENTITY")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_IDENTITY_LEGACY")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_SESSION")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "10 Days or Session"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_SESSION_LEGACY")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "10 Days or Session"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "csrftoken")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Helps prevent Cross-Site Request Forgery (CSRF) attacks.\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "platformapi.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "sessionid")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "platformapi.qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_ga_JPCJ0V0E2R")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "mp_290aa5bd816866afa3a 61ec8c43bd26d_mixpanel")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Qure.ai"))), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))))), /*#__PURE__*/react.createElement("table", {
    className: "hidden table-auto md:block"
  }, /*#__PURE__*/react.createElement("tbody", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "AUTH_SESSION_ID")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "AUTH_SESSION_ID_LEGACY ")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_IDENTITY")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_IDENTITY_LEGACY")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Session"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_SESSION")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "10 Days or Session"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "KEYCLOAK_SESSION_LEGACY")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "10 Days or Session"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "accounts.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "csrftoken")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Helps prevent Cross-Site Request Forgery (CSRF) attacks.\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "platformapi.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "sessionid")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Requrired for login")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "platformapi.qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Necessary"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "_ga_JPCJ0V0E2R")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "mp_290aa5bd816866afa3a 61ec8c43bd26d_mixpanel")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Registers a unique ID that is used to generate statistical data on how the visitor uses the Website.\xA0")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "1 year"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/react.createElement("b", null, "Qure.ai"))), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Statistics")))))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "VII. Your consent")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "By contacting us, subscribing to our newsletter, you consent to the processing for the purposes contained in\xA0clause II(b)\xA0above which includes processing of your name,\xA0gender,\xA0contact details and preferences as set out in this Privacy Policy. By accepting\xA0Qure\u2019s\xA0Terms, we process your\xA0Personal data to be able to fulfil our agreement with you for the purposes listed above in\xA0clause III.\xA0Qure will process\xA0Personal data if it has a legal obligation to do so to fulfil requirements by law as pointed out in\xA0clause\xA0VIII\xA0below\u2019.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "VIII. Data Subject Rights")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Data Subjects may have numerous rights in relation to their personal data.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "Right to make a subject access request (SAR): Data Subjects may request in writing copies of their personal data. However, compliance with such requests is subject to certain limitations and exemptions and the rights of other individuals. Each request should make clear that a SAR is being made. You may also be required to submit a proof of your identity and any payment permitted by law, where applicable.\xA0Right to rectification: Data Subjects may request that we rectify any inaccurate or incomplete personal data.\xA0Right to withdraw consent: Data Subjects may at any time withdraw their consent to the processing of their personal data carried out by us on the basis of their previous consent. Such withdrawal will not affect the lawfulness of processing based on such previous consent.\xA0Right to object to processing including automated processing and profiling: We do not make automated decisions about Data Subjects. However, we may rely on information provided by third parties such as credit reference agencies which may score Data Subjects on the basis of automated decisions. Profiling may be carried out for business administration purposes, such as monitoring trends in User visits of our Website. We will comply with valid objection requests unless we have a compelling overriding legitimate ground for the continuation of our processing or we have another lawful reason to refuse such request. We will comply with each valid opt-out request in relation to marketing communications.\xA0Right to erasure: Data Subjects may request that we erase their personal data. We will comply, unless there is a lawful reason for not doing so. For example, there may be an overriding legitimate ground for keeping the personal data, such as, our business record retention obligations that we have to comply with.\xA0Restriction: Data Subjects may request that we restrict our processing of their personal data in various circumstances. We will comply, unless there is a lawful reason for not doing so, such as, a legal obligation to continue processing your personal data in a certain way.\xA0Right to data portability: In certain circumstances, Data Subjects may request the controller to provide a copy of their personal data in a structured, commonly used and machine-readable format and have it transferred to another provider of the same or similar services. We do not consider that this right applies to our Services. However, to the extent it does, we will comply with such transfer request. Please note that a transfer to another provider does not imply erasure of the Data Subject\u2019s personal data which may still be retained for legitimate and lawful purposes.\xA0Right to lodge a complaint with the supervisory authority: We suggest that Data Subjects contact us about any questions or complaints in relation to how we process their personal data. However, each Data Subject has the right to contact the relevant supervisory authority directly.\xA0"), /*#__PURE__*/react.createElement("li", null, "Right to make a subject access request (SAR): Data Subjects may request in writing copies of their personal data. However, compliance with such requests is subject to certain limitations and exemptions and the rights of other individuals. Each request should make clear that a SAR is being made. You may also be required to submit a proof of your identity and any payment permitted by law, where applicable.\xA0"), /*#__PURE__*/react.createElement("li", null, "Right to rectification: Data Subjects may request that we rectify any inaccurate or incomplete personal data.\xA0"), /*#__PURE__*/react.createElement("li", null, "Right to withdraw consent: Data Subjects may at any time withdraw their consent to the processing of their personal data carried out by us on the basis of their previous consent. Such withdrawal will not affect the lawfulness of processing based on such previous consent.\xA0"), /*#__PURE__*/react.createElement("li", null, "Right to object to processing including automated processing and profiling: We do not make automated decisions about Data Subjects. However, we may rely on information provided by third parties such as credit reference agencies which may score Data Subjects on the basis of automated decisions. Profiling may be carried out for business administration purposes, such as monitoring trends in User visits of our Website. We will comply with valid objection requests unless we have a compelling overriding legitimate ground for the continuation of our processing or we have another lawful reason to refuse such request. We will comply with each valid opt-out request in relation to marketing communications.\xA0"), /*#__PURE__*/react.createElement("li", null, "Right to erasure: Data Subjects may request that we erase their personal data. We will comply, unless there is a lawful reason for not doing so. For example, there may be an overriding legitimate ground for keeping the personal data, such as, our business record retention obligations that we have to comply with.\xA0"), /*#__PURE__*/react.createElement("li", null, "Restriction: Data Subjects may request that we restrict our processing of their personal data in various circumstances. We will comply, unless there is a lawful reason for not doing so, such as, a legal obligation to continue processing your personal data in a certain way.\xA0"), /*#__PURE__*/react.createElement("li", null, "Right to data portability: In certain circumstances, Data Subjects may request the controller to provide a copy of their personal data in a structured, commonly used and machine-readable format and have it transferred to another provider of the same or similar services. We do not consider that this right applies to our Services. However, to the extent it does, we will comply with such transfer request. Please note that a transfer to another provider does not imply erasure of the Data Subject\u2019s personal data which may still be retained for legitimate and lawful purposes.\xA0"), /*#__PURE__*/react.createElement("li", null, "Right to lodge a complaint with the supervisory authority: We suggest that Data Subjects contact us about any questions or complaints in relation to how we process their personal data. However, each Data Subject has the right to contact the relevant supervisory authority directly.\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "IX. Responding to Legal Requests")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "We may access,\xA0preserve\xA0and share your\xA0Personal data in response to a legal request (like a search warrant, court order or a subpoena or the like), or when necessary to detect, prevent and address fraud and other illegal activity, to protect ourselves, you and other\xA0users, including as part of investigations described in Article 23(1) in the GDPR.\u202F\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "X. Retention of Personal Data")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Personal data about registered users will be retained for as long as the user has an active profile on the Services. users who have not used our Services will have all personal data deleted after 1 year of inactivity on the Services.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "If you agree to be added to our mailing list, we will keep your personal information for that purpose unless and until you tell us that you want to unsubscribe or be removed from the list. If you advise that you do not want to be added to our mailing list or you ask to be removed, we will delete your Personal data (aside from keeping a record that you have asked us not to send you marketing information).\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "XI. Personal data of children under the age of 18")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "The QureApp and the Services provided under it are not directed at, marketed to, nor intended for, children under 18 years of age. The Website does not knowingly collect or solicit information from anyone under the age of 18 or allow anyone under the age of 18 to sign up for the Service. In the event that you learn that you have gathered personal information from anyone under the age of 18 without the consent of a parent or guardian, you will delete that information as soon as possible.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "You are required under the Children\u2019s Online Privacy Protection Act (\u201C", /*#__PURE__*/react.createElement("b", null, "COPPA"), "\u201D) as well as the GDPR and other Personal Data Protection laws (as those may apply) to obtain verifiable parental consent (or from the child\u2019s legal representative) in order to collect, use or disclose Personal Data pertaining to that child.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "If you are a parent or guardian of a person under the age of 18 and you become aware of that the child has provided personal data to us without your consent, please contact\xA0", /*#__PURE__*/react.createElement("a", {
    href: "mailto:dpo@qure.ai"
  }, "dpo@qure.ai"), "\xA0 to exercise your access, rectification, erasure, limiting of processing and objection rights.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "XII. Security Practices")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "The importance of security for Personal data is of great concern to us. At Qure, we have gone to great lengths to manage the security and integrity of the Services and to ensure that we use best\u2013in-class services when providing secure transmission of information from your device. Personal Data collected via the Services is stored in secure environments that are not available or accessible to the public; only those duly authorised people, officers, employees or agents of Qure who need access to your information in order to do their jobs are allowed access.\xA0\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Anyone who violates our privacy or security policies is subject to disciplinary action, including possible termination of their contract with Qure and civil and/or criminal prosecution. Qure uses the latest technologies to ensure utmost security, including utilising several layers of firewall security and encryption of Personal data to ensure the highest level of security. As a result, while we strive to protect your Personal data, you acknowledge that:\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "(a) there are security and privacy limitations of the Internet which are beyond our control;\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "(b) the security, integrity and privacy of any and all information and data exchanged between you and us through this Website cannot be guaranteed; and\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "(c) any such information and data may be viewed or tampered with in transit by a third party.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "XIII. Grievance Officer")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "To exercise your rights, or if you have any questions\xA0or complaints\xA0regarding our processing of your personal data, please contact us our Data Protection Officer (DPO) at the following\xA0email ID \u2013\xA0", /*#__PURE__*/react.createElement("a", {
    rel: "noreferrer",
    href: "mailto:dpo@qure.ai",
    target: "_blank"
  }, "dpo@qure.ai"), ". In your letter/email please state your full name, your username (if you are a user) and which institution you are linked to. Note that you should sign the request to receive information about the processing of your personal data yourself.\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-semibold text-xl"
  }, "XIV. Notice of Changes to the Privacy Policy\u202F")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "If we make changes to this Privacy Policy, we will notify you by posting a copy of the updated policy on our Services prior to any change becoming effective. We will post a copy of the updated policy on our Services prior to any change becoming effective. If your consent is required due to the changes, we will provide you additional prominent notice as appropriate under the circumstances and ask for your consent in accordance with applicable law."))));
};

/* harmony default export */ var TermsAndConditionsModal_PrivacyPolicyContent = (PrivacyPolicyContent);
;// CONCATENATED MODULE: ./components/TermsAndConditionsModal/TermsAndConditionsContent.tsx
var TermsAndConditionsContent_jsx = react.createElement;


var TermsAndConditionsContentStatic = function TermsAndConditionsContentStatic() {
  return /*#__PURE__*/react.createElement("div", {
    className: "flex-1 space-y-4"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "font-bold text-2xl"
  }, "UNIVERSAL TERMS")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "(v2.0.0 dated 30.09.2022)")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "YOUR RELATIONSHIP WITH QURE")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Your use of Qure\u2019s products, software\xA0(including but not limited to any and all versions, forms or\xA0 renditions of qXR, qER, qCT-Lung, qVH, qMSK qTrack), applications such as the QureApp and its website equivalent i.e.\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://app.qure.ai/"
  }, "https://app.qure.ai/"), ", services, Devices and Website (referred to collectively as the \u201CServices\u201D) excluding any services provided to You (\u201CYou\u201D or \u201CYour\u201D or \u201CCustomer\u201D) by Qure under a separate written agreement,\xA0is subject to the terms of a legal agreement\xA0between You and Qure. \u201CQure\u201D or \u201CUs\u201D or \u201CWe\u201D or \u201COur\u201D means Qure.ai Technologies Private Limited, a company registered under the laws of India, having its registered office at 7th Floor, Oberoi Commerz-II, International, Business Park, Oberoi Garden City, Off Western, Express Highway, Goregaon East, Mumbai, Maharashtra, 400063, India and any of its subsidiaries and affiliates.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "The Terms here explain the legal agreement between You and Qure and sets out the Universal Terms.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Unless otherwise agreed in writing with Qure, Your legal agreement with Qure will always include, at a minimum, the terms and conditions as set out hereinbelow and under\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/legal/#acceptable-use-policy:~:text=Legal%20Disclaimer-,Acceptable%20Use%20Policy,-Acceptable%20Use%20Policy"
  }, "Acceptable Use Policy"), ". These are referred as the \u201CUniversal Terms\u201D. We reserve the right to modify and amend these Universal Terms from time to time at Our sole discretion, in which case the new Universal Terms will supersede prior versions of the Universal Terms. We shall post the modified or amended version of these Universal Terms in this section of the Website. By using Our Services after the changes/modifications have been posted, You agree to automatically accept those changes/modifications and it shall be deemed conclusively that You have agreed to comply with and be bound by all terms and conditions of the modified version of Universal Terms thereafter.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Your agreement with Qure will also include the terms of any agreed terms in writing or otherwise applicable to the Services, in addition to the Universal Terms. All of these are referred to as the \u201CAdditional Terms\u201D. Where Additional Terms apply to a Service, these will be accessible for You to read either within, or through Your use of, that Service or would be under a separate written agreement with You.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "The Universal Terms, together with the Additional Terms, if any, (collectively referred to as \u201CTerms\u201D), form a legally binding agreement between You and Qure in relation to Your use of the Services. It is important that You take the time to read them carefully.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "If there is any contradiction between the Additional Terms and the Universal Terms, then the Additional Terms shall take precedence in relation to that Service.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "ACCEPTING THE TERMS")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "In order to use the Services, You must first agree to the Terms. You shall not use the Services if You do not accept the Terms.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "You can accept the Terms by:")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "clicking accept or agree to the Terms, where this option is made available to You by Qure in the user interface for any Service; or"), /*#__PURE__*/react.createElement("li", null, "by actually using the Services. In this case, You understand and agree that Qure will treat Your use of the Services in any manner whatsoever (including without limitation to login into or accessing Our Services or installing Services on any devices) as acceptance of the Terms from that point onwards."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "By accepting the Terms in writing under a written agreement between You and Qure."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "You shall not use the Services and shall not accept the Terms if (a) You are not of legal age to enter into and form a legally binding contract with Qure, or (b) in the event You are entering into these Terms on behalf of any entity/company or its group or affiliates, You do not possess the requisite authority to bind such entities, company, or its groups and affiliates to these Terms, or (c) You are a person barred from receiving the Services or entering into binding legal contract under the laws of India or other countries including the country in which You are resident or from where You intend to use the Services.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Before You continue, You should print or save a local copy of the Universal Terms for Your records.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "DEFINITIONS"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CData\u201D means any and all information and materials, including without limitation, Data of Users and End Users, submitted to the Services by You through Your Account or any data provided by You / Customer to Qure in connection with Your / Customer\u2019s use of the Services. Data that shall be provided to Qure shall be used for processing and aggregated de-identified Data may be used for testing, improvement and development of the Services. Further, the outputs of the usage of the Data with the Services may be used for publications including in peer reviewed journals and for academic/research purposes.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CDevices\u201D means laptops, desktops, mobile phones, any electronic device capable of using Qure\u2019s proprietary software or any other device which contains Qure\u2019s proprietary software provided by Qure to the Customer. Qure shall have a right to access the Devices periodically to check on the number of scans processed as well as for routine maintenance.\xA0We shall have a right to remove the Qure\u2019s software from the Devices and the Customer shall be obligated to return the Devices to its factory settings, free from Qure\u2019s software and Our intellectual property. Further, the Customer shall be obligated to return the Devices to Us within 30 days from date of such demand as and when raised by Us.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CEligible Data\u201D\xA0means the following:")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "table-auto md:hidden"
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "X-Ray Specifications")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "CT Scans Specifications"))), /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Inclusion Criteria:\xA01. Patient Age: 6 years and above2. Modality: CR/DR/DX3. Study Description: Chest X-ray4. Body Part Examined: Chest5. Image View: AP/PA6. Image Format: DICOM (.dcm)7. Image Resolution: Minimum of 1440\xD71440Exclusion Criteria:1. Lateral X-rays2. X-rays that do not contain the entire lung field3. X-rays of other body parts4. X-rays of patients below 6 years of age")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Inclusion Criteria:1. Non-contrast axial CT scan series with consistently spaced axial slices2. Soft reconstruction kernel covering the complete brain3. Maximum slice thickness of 6mm4. Age is more than 18 yearsExclusion Criteria:1. Scans with obvious postoperative defects, or from patients who previously underwent brain surgery2. Scans with artifacts such as burr holes, shunts or clips3. Scans containing metal artifacts4. Scans containing excessive motion artifacts5. Scans containing improperly ordered slices6. Series containing missing slices"))))), /*#__PURE__*/react.createElement("table", {
    className: "hidden table-auto md:block"
  }, /*#__PURE__*/react.createElement("tbody", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "X-Ray Specifications")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3 font-semibold"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "CT Scans Specifications"))), /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Inclusion Criteria:\xA01. Patient Age: 6 years and above2. Modality: CR/DR/DX3. Study Description: Chest X-ray4. Body Part Examined: Chest5. Image View: AP/PA6. Image Format: DICOM (.dcm)7. Image Resolution: Minimum of 1440\xD71440Exclusion Criteria:1. Lateral X-rays2. X-rays that do not contain the entire lung field3. X-rays of other body parts4. X-rays of patients below 6 years of age")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Inclusion Criteria:1. Non-contrast axial CT scan series with consistently spaced axial slices2. Soft reconstruction kernel covering the complete brain3. Maximum slice thickness of 6mm4. Age is more than 18 yearsExclusion Criteria:1. Scans with obvious postoperative defects, or from patients who previously underwent brain surgery2. Scans with artifacts such as burr holes, shunts or clips3. Scans containing metal artifacts4. Scans containing excessive motion artifacts5. Scans containing improperly ordered slices6. Series containing missing slices")))))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CEnd User\u201D\xA0means any person or entity other than You or Your Users with whom You interact using the Services.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CPersonal Data\u201D\xA0means information relating to an identified or identifiable natural person that is submitted by You to the Services as part of Data. Identified or identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CProcess\u201D\xA0means any operation or set of operations which is performed on Data or on sets of Data, whether or not by automated means, such as collection, recording, organisation, structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making available, alignment or combination, restriction, erasure or destruction.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CUser\u201D\xA0means a designated user within the Services, including an account administrator, employee, shareholder, auditor, lawyer, founder and other designated users")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "\u201CWebsite\u201D means\xA0", /*#__PURE__*/react.createElement("a", {
    href: "http://www.qure.ai/"
  }, "www.qure.ai"), ".")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "2. YOUR / CUSTOMER\u2019S ROLE AND OBLIGATIONS\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "You shall be solely responsible for receiving all explicit or implicit consents, as required under applicable laws, from the patients, Users or similar Data owners and having accepted these Universal Terms, it will be deemed that such consents have been duly received by You and will be available upon request for Us to audit.The responsibility of de-identification and anonymization of the Data shall solely vest with You and the Data shall be de-identified and anonymized by You before being processed on Our Services. Any Data that is processed by You on Our Services shall be presumed to be de-identified or anonymized by You as required under applicable laws. To the maximum extent permitted under applicable laws, Qure is neither responsible for nor does Qure undertakes any lability whatsoever arising from You processing any Personal Data on Our Services.You undertake and represent that You are well aware that (i) the Qure\u2019s Services are supportive medical image analysis tools which support radiologists in the radiology diagnostic process by identifying some abnormalities which may be present in the medical image; (ii) Qure\u2019s Services are intended solely for investigational purposes and is not intended for primary diagnosis; (iii) Qure\u2019s Services are intended for use only by appropriately qualified and trained medical personnel, which are board certified radiologists with a valid license to practice; and (iv) Qure\u2019s Services are intended for use only as a supplement to standard methods of interpreting radiological images. Qure\u2019s Services should not be exclusively relied upon for arriving at a diagnosis, treatment plan, or other decision that may affect patient care. It is clarified that use of Qure\u2019s Services shall not result in any change in clinical protocol, patient management policies, etc. that may be maintained by You.Qure or any other person or party that contributed to this Services makes no representations or warranties in relation to the medical information in these Terms. Reliance on any information provided by the Services or any linked websites is solely at Your own risk.\u202FQure specifically disclaims all responsibility for any liability, loss, or risk, personal or otherwise, which is incurred as a consequence, directly or indirectly, of the use of the Services or the application of any content contained or referenced therein.The ultimate judgment regarding the propriety of any specific medical treatment must be made by the expert medical physician and the patient in light of all the circumstances presented by the individual patient, and the known variability and biological behaviour of the disease."), /*#__PURE__*/react.createElement("li", null, "You shall be solely responsible for receiving all explicit or implicit consents, as required under applicable laws, from the patients, Users or similar Data owners and having accepted these Universal Terms, it will be deemed that such consents have been duly received by You and will be available upon request for Us to audit.The responsibility of de-identification and anonymization of the Data shall solely vest with You and the Data shall be de-identified and anonymized by You before being processed on Our Services. Any Data that is processed by You on Our Services shall be presumed to be de-identified or anonymized by You as required under applicable laws. To the maximum extent permitted under applicable laws, Qure is neither responsible for nor does Qure undertakes any lability whatsoever arising from You processing any Personal Data on Our Services.You undertake and represent that You are well aware that (i) the Qure\u2019s Services are supportive medical image analysis tools which support radiologists in the radiology diagnostic process by identifying some abnormalities which may be present in the medical image; (ii) Qure\u2019s Services are intended solely for investigational purposes and is not intended for primary diagnosis; (iii) Qure\u2019s Services are intended for use only by appropriately qualified and trained medical personnel, which are board certified radiologists with a valid license to practice; and (iv) Qure\u2019s Services are intended for use only as a supplement to standard methods of interpreting radiological images. Qure\u2019s Services should not be exclusively relied upon for arriving at a diagnosis, treatment plan, or other decision that may affect patient care. It is clarified that use of Qure\u2019s Services shall not result in any change in clinical protocol, patient management policies, etc. that may be maintained by You.Qure or any other person or party that contributed to this Services makes no representations or warranties in relation to the medical information in these Terms. Reliance on any information provided by the Services or any linked websites is solely at Your own risk.\u202FQure specifically disclaims all responsibility for any liability, loss, or risk, personal or otherwise, which is incurred as a consequence, directly or indirectly, of the use of the Services or the application of any content contained or referenced therein.The ultimate judgment regarding the propriety of any specific medical treatment must be made by the expert medical physician and the patient in light of all the circumstances presented by the individual patient, and the known variability and biological behaviour of the disease."), /*#__PURE__*/react.createElement("li", null, "You shall be solely responsible for receiving all explicit or implicit consents, as required under applicable laws, from the patients, Users or similar Data owners and having accepted these Universal Terms, it will be deemed that such consents have been duly received by You and will be available upon request for Us to audit."), /*#__PURE__*/react.createElement("li", null, "The responsibility of de-identification and anonymization of the Data shall solely vest with You and the Data shall be de-identified and anonymized by You before being processed on Our Services. Any Data that is processed by You on Our Services shall be presumed to be de-identified or anonymized by You as required under applicable laws. To the maximum extent permitted under applicable laws, Qure is neither responsible for nor does Qure undertakes any lability whatsoever arising from You processing any Personal Data on Our Services."), /*#__PURE__*/react.createElement("li", null, "You undertake and represent that You are well aware that (i) the Qure\u2019s Services are supportive medical image analysis tools which support radiologists in the radiology diagnostic process by identifying some abnormalities which may be present in the medical image; (ii) Qure\u2019s Services are intended solely for investigational purposes and is not intended for primary diagnosis; (iii) Qure\u2019s Services are intended for use only by appropriately qualified and trained medical personnel, which are board certified radiologists with a valid license to practice; and (iv) Qure\u2019s Services are intended for use only as a supplement to standard methods of interpreting radiological images. Qure\u2019s Services should not be exclusively relied upon for arriving at a diagnosis, treatment plan, or other decision that may affect patient care. It is clarified that use of Qure\u2019s Services shall not result in any change in clinical protocol, patient management policies, etc. that may be maintained by You."), /*#__PURE__*/react.createElement("li", null, "Qure or any other person or party that contributed to this Services makes no representations or warranties in relation to the medical information in these Terms. Reliance on any information provided by the Services or any linked websites is solely at Your own risk.\u202FQure specifically disclaims all responsibility for any liability, loss, or risk, personal or otherwise, which is incurred as a consequence, directly or indirectly, of the use of the Services or the application of any content contained or referenced therein."), /*#__PURE__*/react.createElement("li", null, "The ultimate judgment regarding the propriety of any specific medical treatment must be made by the expert medical physician and the patient in light of all the circumstances presented by the individual patient, and the known variability and biological behaviour of the disease."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "3. YOUR / CUSTOMER\u2019S REPRESENTATIONS AND WARRANTIES\xA0")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "i. YOU REPRESENT AND WARRANT THAT YOU SHALL NOT:")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "license, sublicense, sell, resell, rent, lease, transfer, assign, distribute, time share or otherwise commercially exploit or make the Services available to any third-party, other than Users in furtherance of Your internal business purposes and as expressly permitted by these Universal Terms or Additional Terms;modify, adapt, re-engineer, replicate, or hack the Services or otherwise attempt to gain or gain unauthorized access to the Services or related systems or networks;use the Services to Process any Personal Data;violate any law or regulation, including, without limitation, any applicable export control laws, privacy laws or any other purpose not reasonably intended by Qure;use the Services to store or process any content that infringes upon any person\u2019s intellectual property rights or is unlawful, racist, hateful, abusive, libelous, obscene, or discriminatory; or\u201Ccrawl,\u201D \u201Cscrape,\u201D or \u201Cspider\u201D any page, data, or portion of or relating to the Services (through use of manual or automated means)."), /*#__PURE__*/react.createElement("li", null, "license, sublicense, sell, resell, rent, lease, transfer, assign, distribute, time share or otherwise commercially exploit or make the Services available to any third-party, other than Users in furtherance of Your internal business purposes and as expressly permitted by these Universal Terms or Additional Terms;"), /*#__PURE__*/react.createElement("li", null, "modify, adapt, re-engineer, replicate, or hack the Services or otherwise attempt to gain or gain unauthorized access to the Services or related systems or networks;"), /*#__PURE__*/react.createElement("li", null, "use the Services to Process any Personal Data;"), /*#__PURE__*/react.createElement("li", null, "violate any law or regulation, including, without limitation, any applicable export control laws, privacy laws or any other purpose not reasonably intended by Qure;"), /*#__PURE__*/react.createElement("li", null, "use the Services to store or process any content that infringes upon any person\u2019s intellectual property rights or is unlawful, racist, hateful, abusive, libelous, obscene, or discriminatory; or"), /*#__PURE__*/react.createElement("li", null, "\u201Ccrawl,\u201D \u201Cscrape,\u201D or \u201Cspider\u201D any page, data, or portion of or relating to the Services (through use of manual or automated means)."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "ii. You represent and warrant that the electronic Devices, systems and any other hardware or cloud computing provided or used by You for availing the Services are free from:")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "all viruses known in the software industry at the time of its implementation and that could have been detected by the use of the latest commercially available virus detection software;all forms of electronic repossessions and logic bombs as far as those logic bombs could have been avoided by You; andall forms of disabling codes, applications or software that may affect the proper operation of the Services, howsoever placed or manifested."), /*#__PURE__*/react.createElement("li", null, "all viruses known in the software industry at the time of its implementation and that could have been detected by the use of the latest commercially available virus detection software;"), /*#__PURE__*/react.createElement("li", null, "all forms of electronic repossessions and logic bombs as far as those logic bombs could have been avoided by You; and"), /*#__PURE__*/react.createElement("li", null, "all forms of disabling codes, applications or software that may affect the proper operation of the Services, howsoever placed or manifested."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "iii. You further represent and warrant that You shall take all necessary steps to ensure all Your Devices are, up-to-date at all times and possessing the required capabilities to detect and tackle all new forms of viruses, as may be detectable by the use of the latest commercially available virus detection software(s).")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "iv. You represent and warrant that You, Your affiliates, owners, directors, officers, employees and agents will not at any time offer, promise, pay or arrange for payment or indulge in giving of a bribe or any benefit, advantage or anything of value to any public official, individual, entity or any other third party in exchange for an improper advantage in any form either directly or indirectly. You further represent and warrant that You, Your affiliates, owners, directors, officers, employees and agents will act in full compliance with any applicable anti-corruption laws and regulations, industry and professional codes including the\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://en.wikipedia.org/wiki/Prevention_of_Corruption_Act,_1988"
  }, "Prevention of Corruption Act, 1988"), ", FCPA, UK Bribery Act, and any other international or local legislation on the subject matter. You shall ensure and always maintain appropriate records as per standard industrial practices with respect to billing, accounting and other internal controls to ensure compliance with international and other applicable anti-bribery and anti-corruption laws.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "4. USE OF QURE\u2019S PRODUCTS, SOFTWARE, QUREAPP AND DEVICES")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "You acknowledge that the use of Qure\u2019s products, software, applications including the QureApp and Devices will at all times be pursuant to and only as detailed in the User manual provided along with the Qure\u2019s products, software, applications and Devices and as per the terms and conditions contained in Qure\u2019s products, software, applications such as the QureApp and Devices. We may update the User manual and the terms and conditions periodically. We undertake to provide, at Our sole discretion, all necessary support to You in case such an update is done and a requirement for Your identified personnel is deemed fit.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "UPDATE OF SOFTWARE"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "We may update the Qure\u2019s products, software, applications such as the Qure App and Devices (\u201CUpdate\u201D) anytime. However, in case the Update is not accepted, We shall not be responsible for any malfunction in Qure\u2019s product, software and Device, that could have been reasonably rectified through such Update. You shall, within a period of five (5) business days from the Update, report any issues with the Update to us. Upgrades to the Qure\u2019s product, software, Qure App and Devices, which include but are not limited to new features or new findings, shall be provided at an additional cost. It is clarified that providing Updates and upgrades for any offline deployment of Qure\u2019s software via Devices or for any on premise deployment shall be at sole discretion of Qure.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Qure does not promise that it will always Update the Services (including mobile applications like QureApp) so that it is relevant to You and/or works with the Android & iOS versions that You have installed on Your Device. However, You promise to always accept Updates to the Services when offered to You, We may also wish to stop providing the Services, and may terminate use of it at any time without giving notice of termination to You. Unless we tell You otherwise, upon any termination, (a) the rights and licenses granted to You in these terms will end; (b) You must stop using the Services, and (if needed) delete it from Your Device.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Like all forms of online information, the content and quality of these Services may change over time. It is the primary responsibility of the User to use their individual judgment and to consult with their health care professional to ensure that Services are appropriate for their treatment.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "PAYMENT TERMS"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "Each payment or deposit to be made by You to Qure for use of Services shall be made by way of direct transfer into current account of Qure as per details provided by Qure in writing. Customer shall forthwith provide Qure the proof of payment made by way of direct transfer.Each payment and deposit to be made by You to Qure shall be made without set-off or counterclaim and free and clear of and without any deduction or withholding of any kind whatsoever. If You deduct income tax at source or withholding tax, if applicable from the payments to be made to Qure hereunder, You shall do so at rates applicable to Qure and shall issue TDS certificates to Qure forthwith.In the event of any failure or delay by You to pay or deposit any amount on or before the due dates as required under the Services, You shall pay Qure interest at the rate of 1.5% (one point five per cent) per month on the amount delayed, for the period of such delay. Payment of such interest shall be without prejudice to Qure\u2019s other rights and remedies under law or otherwise.All costs and expenditures arising from payment and deposit to be made to Qure by You, including without limitation,\xA0the wire transfer charges, transaction fees, etc. shall be solely borne by You. IMPORTANT: You must inform Your bank/ financial payment partner that \u201CSender pays all fees\" to ensure that the full invoice amount is received by Qure.Any costs, fees, expenses or disbursements incurred by the Qure in recovering any monies payable by the Customer to Qure, including dishonoured cheques, failed wire transfers, debt collection agency fees, legal costs and interest thereon shall be paid by the Customer on a full indemnity basis.You shall submit a payment advice detailing the invoice(s) against which each payment is made along with the details of TDS, if any, simultaneously with the payment. Such payment advice along with a soft copy of the TDS certificate shall be submitted to email id\xA0", /*#__PURE__*/react.createElement("a", {
    href: "mailto:finance@qure.ai"
  }, "finance@qure.ai"), "\xA0. The format of payment advice is as below:"), /*#__PURE__*/react.createElement("li", null, "Each payment or deposit to be made by You to Qure for use of Services shall be made by way of direct transfer into current account of Qure as per details provided by Qure in writing. Customer shall forthwith provide Qure the proof of payment made by way of direct transfer.Each payment and deposit to be made by You to Qure shall be made without set-off or counterclaim and free and clear of and without any deduction or withholding of any kind whatsoever. If You deduct income tax at source or withholding tax, if applicable from the payments to be made to Qure hereunder, You shall do so at rates applicable to Qure and shall issue TDS certificates to Qure forthwith.In the event of any failure or delay by You to pay or deposit any amount on or before the due dates as required under the Services, You shall pay Qure interest at the rate of 1.5% (one point five per cent) per month on the amount delayed, for the period of such delay. Payment of such interest shall be without prejudice to Qure\u2019s other rights and remedies under law or otherwise.All costs and expenditures arising from payment and deposit to be made to Qure by You, including without limitation,\xA0the wire transfer charges, transaction fees, etc. shall be solely borne by You. IMPORTANT: You must inform Your bank/ financial payment partner that \u201CSender pays all fees\" to ensure that the full invoice amount is received by Qure.Any costs, fees, expenses or disbursements incurred by the Qure in recovering any monies payable by the Customer to Qure, including dishonoured cheques, failed wire transfers, debt collection agency fees, legal costs and interest thereon shall be paid by the Customer on a full indemnity basis.You shall submit a payment advice detailing the invoice(s) against which each payment is made along with the details of TDS, if any, simultaneously with the payment. Such payment advice along with a soft copy of the TDS certificate shall be submitted to email id\xA0", /*#__PURE__*/react.createElement("a", {
    href: "mailto:finance@qure.ai"
  }, "finance@qure.ai"), "\xA0. The format of payment advice is as below:"), /*#__PURE__*/react.createElement("li", null, "Each payment or deposit to be made by You to Qure for use of Services shall be made by way of direct transfer into current account of Qure as per details provided by Qure in writing. Customer shall forthwith provide Qure the proof of payment made by way of direct transfer."), /*#__PURE__*/react.createElement("li", null, "Each payment and deposit to be made by You to Qure shall be made without set-off or counterclaim and free and clear of and without any deduction or withholding of any kind whatsoever. If You deduct income tax at source or withholding tax, if applicable from the payments to be made to Qure hereunder, You shall do so at rates applicable to Qure and shall issue TDS certificates to Qure forthwith."), /*#__PURE__*/react.createElement("li", null, "In the event of any failure or delay by You to pay or deposit any amount on or before the due dates as required under the Services, You shall pay Qure interest at the rate of 1.5% (one point five per cent) per month on the amount delayed, for the period of such delay. Payment of such interest shall be without prejudice to Qure\u2019s other rights and remedies under law or otherwise."), /*#__PURE__*/react.createElement("li", null, "All costs and expenditures arising from payment and deposit to be made to Qure by You, including without limitation,\xA0the wire transfer charges, transaction fees, etc. shall be solely borne by You. IMPORTANT: You must inform Your bank/ financial payment partner that \u201CSender pays all fees\" to ensure that the full invoice amount is received by Qure."), /*#__PURE__*/react.createElement("li", null, "Any costs, fees, expenses or disbursements incurred by the Qure in recovering any monies payable by the Customer to Qure, including dishonoured cheques, failed wire transfers, debt collection agency fees, legal costs and interest thereon shall be paid by the Customer on a full indemnity basis."), /*#__PURE__*/react.createElement("li", null, "You shall submit a payment advice detailing the invoice(s) against which each payment is made along with the details of TDS, if any, simultaneously with the payment. Such payment advice along with a soft copy of the TDS certificate shall be submitted to email id\xA0", /*#__PURE__*/react.createElement("a", {
    href: "mailto:finance@qure.ai"
  }, "finance@qure.ai"), "\xA0. The format of payment advice is as below:"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "table-auto md:hidden"
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "InvoiceDate")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Invoice No.")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Gross Amount")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "TDS")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Net Amount")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Payment Date")), /*#__PURE__*/react.createElement("div", {
    className: "px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "UTR No. / NEFT No. / Bank Instrument No."))))), /*#__PURE__*/react.createElement("table", {
    className: "hidden table-auto md:block"
  }, /*#__PURE__*/react.createElement("tbody", {
    className: "p-4"
  }, /*#__PURE__*/react.createElement("tr", {
    className: "border border-gray-700"
  }, /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "InvoiceDate")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Invoice No.")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Gross Amount")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "TDS")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Net Amount")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "Payment Date")), /*#__PURE__*/react.createElement("td", {
    className: "border border-gray-700 px-3 py-3"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-sm"
  }, "UTR No. / NEFT No. / Bank Instrument No.")))))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "PERSONAL DATA PROTECTION"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "We shall not accept any protected health information or Personal Data as defined under the applicable laws, except as set out under these Universal Terms.All Data shall be de-identified by You before being provided to Us or uploaded on Our Services. No Personal Data will be disclosed by You to Us. Nevertheless, it is agreed that in the event that We come into contact with any Personal Data, We shall not use such information for any purpose or disclose it to any third parties, except as required by applicable law.You, including Your authorized personnel shall view and Process the Data only on a need-to-know basis and only to the extent necessary to perform Your obligations under the Universal Terms or as expressly instructed by Qure in writing. You agree to not disclose Data to third parties without having first received express written approval from Qure.The\xA0", /*#__PURE__*/react.createElement("a", {
    rel: "noreferrer",
    href: "https://qure.ai/legal/#legal-disclaimer/:~:text=Data%20Processing%20Agreement%C2%A0,-(v1.0.0%20dated%3A%2031.05.2022",
    target: "_blank"
  }, "Data Processing Agreement"), "\xA0(\u201CDPA\u201C), forms part of and is subject to these Universal Terms. You acknowledge and confirm Your acceptance to the terms and conditions as set forth in the DPA and agree to abide by the Customer (as defined in DPA) obligations under the DPA."), /*#__PURE__*/react.createElement("li", null, "We shall not accept any protected health information or Personal Data as defined under the applicable laws, except as set out under these Universal Terms.All Data shall be de-identified by You before being provided to Us or uploaded on Our Services. No Personal Data will be disclosed by You to Us. Nevertheless, it is agreed that in the event that We come into contact with any Personal Data, We shall not use such information for any purpose or disclose it to any third parties, except as required by applicable law.You, including Your authorized personnel shall view and Process the Data only on a need-to-know basis and only to the extent necessary to perform Your obligations under the Universal Terms or as expressly instructed by Qure in writing. You agree to not disclose Data to third parties without having first received express written approval from Qure.The\xA0", /*#__PURE__*/react.createElement("a", {
    rel: "noreferrer",
    href: "https://qure.ai/legal/#legal-disclaimer/:~:text=Data%20Processing%20Agreement%C2%A0,-(v1.0.0%20dated%3A%2031.05.2022",
    target: "_blank"
  }, "Data Processing Agreement"), "\xA0(\u201CDPA\u201C), forms part of and is subject to these Universal Terms. You acknowledge and confirm Your acceptance to the terms and conditions as set forth in the DPA and agree to abide by the Customer (as defined in DPA) obligations under the DPA."), /*#__PURE__*/react.createElement("li", null, "We shall not accept any protected health information or Personal Data as defined under the applicable laws, except as set out under these Universal Terms."), /*#__PURE__*/react.createElement("li", null, "All Data shall be de-identified by You before being provided to Us or uploaded on Our Services. No Personal Data will be disclosed by You to Us. Nevertheless, it is agreed that in the event that We come into contact with any Personal Data, We shall not use such information for any purpose or disclose it to any third parties, except as required by applicable law."), /*#__PURE__*/react.createElement("li", null, "You, including Your authorized personnel shall view and Process the Data only on a need-to-know basis and only to the extent necessary to perform Your obligations under the Universal Terms or as expressly instructed by Qure in writing. You agree to not disclose Data to third parties without having first received express written approval from Qure."), /*#__PURE__*/react.createElement("li", null, "The\xA0", /*#__PURE__*/react.createElement("a", {
    rel: "noreferrer",
    href: "https://qure.ai/legal/#legal-disclaimer/:~:text=Data%20Processing%20Agreement%C2%A0,-(v1.0.0%20dated%3A%2031.05.2022",
    target: "_blank"
  }, "Data Processing Agreement"), "\xA0(\u201CDPA\u201C), forms part of and is subject to these Universal Terms. You acknowledge and confirm Your acceptance to the terms and conditions as set forth in the DPA and agree to abide by the Customer (as defined in DPA) obligations under the DPA."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "CONFIDENTIALITY"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "You shall at all times, from the date of accepting these Universal Terms maintain the secrecy of and shall keep confidential, any and all information and documents which You may come to know of / acquire in connection with use of Services (collectively \u201CConfidential Information\u201C) and shall not use or disclose such information except for discharge of Your respective obligations any agreement with Qure or if required by law.Confidential Information shall include all information and materials relating to or arising from use of Services in any form whatsoever, and information which is by its nature confidential or which the discloser advises the recipient is confidential.\u202F\u202FConfidential Information shall not include information which is presently in the public domain or subsequently enters the public domain without any lapse on Your part.You shall not disclose any confidential information to any third party except that the disclosure is permitted to Your counsel and advisers and government officials to the extent necessary for the purpose of performing the transactions contemplated with Qure under any agreement. Such disclosure shall require prior written approval of Qure. You shall return information that has been obtained from Qure including (if any) copies that have been made either in paper or in softcopyYou shall keep in Your possession and treat Confidential Information as confidential regardless of when it is disclosed.You acknowledge that any breach of Confidential Information will cost irreparable injury to Qure, which cannot be compensated by monetary damages and as such Qure shall be entitled to seek injunctive relief against You for any threatened or actual breach of confidentiality.You shall return and/or destroy all Confidential Information received (including any copies or reproductions thereof) in Your possession or control file as soon as You permanently stop using Services but not later than seven (7) days from date of last such use of Services and shall cease to use any such Confidential Information. Proof in writing of such return, destruction and cessation shall be provided by You.You shall immediately inform Qure in writing in case of any unauthorized use or disclosure of Confidential Information to any third party.You shall cooperate with Qure in every reasonable way to help Qure regain possession of such Confidential Information and prevent its further unauthorized use."), /*#__PURE__*/react.createElement("li", null, "You shall at all times, from the date of accepting these Universal Terms maintain the secrecy of and shall keep confidential, any and all information and documents which You may come to know of / acquire in connection with use of Services (collectively \u201CConfidential Information\u201C) and shall not use or disclose such information except for discharge of Your respective obligations any agreement with Qure or if required by law.Confidential Information shall include all information and materials relating to or arising from use of Services in any form whatsoever, and information which is by its nature confidential or which the discloser advises the recipient is confidential.\u202F\u202FConfidential Information shall not include information which is presently in the public domain or subsequently enters the public domain without any lapse on Your part.You shall not disclose any confidential information to any third party except that the disclosure is permitted to Your counsel and advisers and government officials to the extent necessary for the purpose of performing the transactions contemplated with Qure under any agreement. Such disclosure shall require prior written approval of Qure. You shall return information that has been obtained from Qure including (if any) copies that have been made either in paper or in softcopyYou shall keep in Your possession and treat Confidential Information as confidential regardless of when it is disclosed.You acknowledge that any breach of Confidential Information will cost irreparable injury to Qure, which cannot be compensated by monetary damages and as such Qure shall be entitled to seek injunctive relief against You for any threatened or actual breach of confidentiality.You shall return and/or destroy all Confidential Information received (including any copies or reproductions thereof) in Your possession or control file as soon as You permanently stop using Services but not later than seven (7) days from date of last such use of Services and shall cease to use any such Confidential Information. Proof in writing of such return, destruction and cessation shall be provided by You.You shall immediately inform Qure in writing in case of any unauthorized use or disclosure of Confidential Information to any third party.You shall cooperate with Qure in every reasonable way to help Qure regain possession of such Confidential Information and prevent its further unauthorized use."), /*#__PURE__*/react.createElement("li", null, "You shall at all times, from the date of accepting these Universal Terms maintain the secrecy of and shall keep confidential, any and all information and documents which You may come to know of / acquire in connection with use of Services (collectively \u201CConfidential Information\u201C) and shall not use or disclose such information except for discharge of Your respective obligations any agreement with Qure or if required by law."), /*#__PURE__*/react.createElement("li", null, "Confidential Information shall include all information and materials relating to or arising from use of Services in any form whatsoever, and information which is by its nature confidential or which the discloser advises the recipient is confidential.\u202F\u202FConfidential Information shall not include information which is presently in the public domain or subsequently enters the public domain without any lapse on Your part."), /*#__PURE__*/react.createElement("li", null, "You shall not disclose any confidential information to any third party except that the disclosure is permitted to Your counsel and advisers and government officials to the extent necessary for the purpose of performing the transactions contemplated with Qure under any agreement. Such disclosure shall require prior written approval of Qure. You shall return information that has been obtained from Qure including (if any) copies that have been made either in paper or in softcopy"), /*#__PURE__*/react.createElement("li", null, "You shall keep in Your possession and treat Confidential Information as confidential regardless of when it is disclosed."), /*#__PURE__*/react.createElement("li", null, "You acknowledge that any breach of Confidential Information will cost irreparable injury to Qure, which cannot be compensated by monetary damages and as such Qure shall be entitled to seek injunctive relief against You for any threatened or actual breach of confidentiality."), /*#__PURE__*/react.createElement("li", null, "You shall return and/or destroy all Confidential Information received (including any copies or reproductions thereof) in Your possession or control file as soon as You permanently stop using Services but not later than seven (7) days from date of last such use of Services and shall cease to use any such Confidential Information. Proof in writing of such return, destruction and cessation shall be provided by You."), /*#__PURE__*/react.createElement("li", null, "You shall immediately inform Qure in writing in case of any unauthorized use or disclosure of Confidential Information to any third party.You shall cooperate with Qure in every reasonable way to help Qure regain possession of such Confidential Information and prevent its further unauthorized use."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "INTELLECTUAL PROPERTY\xA0"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "Under an agreement in writing with You, Qure may grant You certain rights/ license to use Qure\u2019s products, software, or Devices solely for a purpose mentioned in the agreement therein. You shall not directly or indirectly transfer, assign, sub-license to any third party or in any manner permit Qure\u2019s products, software, or Devices to be used outside the designated territory, beyond the designated use and beyond designated Users as mentioned in the agreement. Notwithstanding anything contained herein, You or Your representatives shall not, directly or indirectly, reverse engineer or aid or assist in the reverse engineering of all or any part of Qure\u2019s products, software or Devices. Reverse engineering includes, without limitation, decompiling, disassembly, sniffing, peeling semiconductor components, or otherwise deriving source code.You hereby acknowledge and confirm that all intellectual property rights relating to the trademarks, service-marks, copyrights (including in Services), patent, trade-names including Our corporate name or any part thereof, are owned by, licensed to, possessed by or belong to Qure and nothing contained in herein shall be deemed to authorize You to use or give any rights with respect to Qure\u2019s Intellectual Property."), /*#__PURE__*/react.createElement("li", null, "Under an agreement in writing with You, Qure may grant You certain rights/ license to use Qure\u2019s products, software, or Devices solely for a purpose mentioned in the agreement therein. You shall not directly or indirectly transfer, assign, sub-license to any third party or in any manner permit Qure\u2019s products, software, or Devices to be used outside the designated territory, beyond the designated use and beyond designated Users as mentioned in the agreement. Notwithstanding anything contained herein, You or Your representatives shall not, directly or indirectly, reverse engineer or aid or assist in the reverse engineering of all or any part of Qure\u2019s products, software or Devices. Reverse engineering includes, without limitation, decompiling, disassembly, sniffing, peeling semiconductor components, or otherwise deriving source code.You hereby acknowledge and confirm that all intellectual property rights relating to the trademarks, service-marks, copyrights (including in Services), patent, trade-names including Our corporate name or any part thereof, are owned by, licensed to, possessed by or belong to Qure and nothing contained in herein shall be deemed to authorize You to use or give any rights with respect to Qure\u2019s Intellectual Property."), /*#__PURE__*/react.createElement("li", null, "Under an agreement in writing with You, Qure may grant You certain rights/ license to use Qure\u2019s products, software, or Devices solely for a purpose mentioned in the agreement therein. You shall not directly or indirectly transfer, assign, sub-license to any third party or in any manner permit Qure\u2019s products, software, or Devices to be used outside the designated territory, beyond the designated use and beyond designated Users as mentioned in the agreement. Notwithstanding anything contained herein, You or Your representatives shall not, directly or indirectly, reverse engineer or aid or assist in the reverse engineering of all or any part of Qure\u2019s products, software or Devices. Reverse engineering includes, without limitation, decompiling, disassembly, sniffing, peeling semiconductor components, or otherwise deriving source code."), /*#__PURE__*/react.createElement("li", null, "You hereby acknowledge and confirm that all intellectual property rights relating to the trademarks, service-marks, copyrights (including in Services), patent, trade-names including Our corporate name or any part thereof, are owned by, licensed to, possessed by or belong to Qure and nothing contained in herein shall be deemed to authorize You to use or give any rights with respect to Qure\u2019s Intellectual Property."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "INDEMNIFICATION"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "You\xA0 hereby agree to indemnify, defend and hold harmless Us, Our employees, members, directors, managers and officers from and against any loss, liability, damage, penalty or expense including attorneys\u2019 fees and costs of defense which We may suffer or incur as a result of (i) any gross negligence or willful misconduct or fraud by You, Your employees or agents; (ii) breach of the representation, warranty and undertakings made and agreed by You under these Universal Terms or under any agreement with Qure and policies or documents they incorporates by reference, or Your violation of any law, rules or regulation; (iii) breach of confidentiality (iv) by the use of the Data in the Services.In no event shall Qure have any liability to You or any Users for any damages whatsoever, including direct, indirect, special, incidental, punitive, exemplary or consequential damages, or damages based on lost profits, however caused and, whether in contract, tort or under any other theory of liability, regardless of whether such damages were foreseeable or whether You were advised of the possibility of such damages.The Services may include programs or code that are licensed under an Open-Source Software (\u201COSS\u201C) license model. OSS programs and code are subject to the terms, conditions, and obligations of the applicable OSS license, and are specifically excluded from all warranty and support obligations described elsewhere in these Universal Terms.The Services may contain independent third-party products (software or hardware) which are not manufactured or developed by Qure and rely upon such third-party products (software or hardware) to perform certain functionality. Qure make no warranties either expressed or implied as to the accuracy of any such third-party products (software or hardware). Third party technology that may be appropriate or necessary for use with some software or hardware may be specified in the relevant documentations. The subscriber\u2019s right to use such third-party technology is governed by the terms of the third-party technology license agreement specified by Us and not by these Universal Terms.The Qure App may contain (or You may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability or completeness by us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third party website/app linked through the Qure App. We will not be a party to or in any way responsible for monitoring any transactions between You and third-party providers of products or services."), /*#__PURE__*/react.createElement("li", null, "You\xA0 hereby agree to indemnify, defend and hold harmless Us, Our employees, members, directors, managers and officers from and against any loss, liability, damage, penalty or expense including attorneys\u2019 fees and costs of defense which We may suffer or incur as a result of (i) any gross negligence or willful misconduct or fraud by You, Your employees or agents; (ii) breach of the representation, warranty and undertakings made and agreed by You under these Universal Terms or under any agreement with Qure and policies or documents they incorporates by reference, or Your violation of any law, rules or regulation; (iii) breach of confidentiality (iv) by the use of the Data in the Services.In no event shall Qure have any liability to You or any Users for any damages whatsoever, including direct, indirect, special, incidental, punitive, exemplary or consequential damages, or damages based on lost profits, however caused and, whether in contract, tort or under any other theory of liability, regardless of whether such damages were foreseeable or whether You were advised of the possibility of such damages.The Services may include programs or code that are licensed under an Open-Source Software (\u201COSS\u201C) license model. OSS programs and code are subject to the terms, conditions, and obligations of the applicable OSS license, and are specifically excluded from all warranty and support obligations described elsewhere in these Universal Terms.The Services may contain independent third-party products (software or hardware) which are not manufactured or developed by Qure and rely upon such third-party products (software or hardware) to perform certain functionality. Qure make no warranties either expressed or implied as to the accuracy of any such third-party products (software or hardware). Third party technology that may be appropriate or necessary for use with some software or hardware may be specified in the relevant documentations. The subscriber\u2019s right to use such third-party technology is governed by the terms of the third-party technology license agreement specified by Us and not by these Universal Terms.The Qure App may contain (or You may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability or completeness by us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third party website/app linked through the Qure App. We will not be a party to or in any way responsible for monitoring any transactions between You and third-party providers of products or services."), /*#__PURE__*/react.createElement("li", null, "You\xA0 hereby agree to indemnify, defend and hold harmless Us, Our employees, members, directors, managers and officers from and against any loss, liability, damage, penalty or expense including attorneys\u2019 fees and costs of defense which We may suffer or incur as a result of (i) any gross negligence or willful misconduct or fraud by You, Your employees or agents; (ii) breach of the representation, warranty and undertakings made and agreed by You under these Universal Terms or under any agreement with Qure and policies or documents they incorporates by reference, or Your violation of any law, rules or regulation; (iii) breach of confidentiality (iv) by the use of the Data in the Services."), /*#__PURE__*/react.createElement("li", null, "In no event shall Qure have any liability to You or any Users for any damages whatsoever, including direct, indirect, special, incidental, punitive, exemplary or consequential damages, or damages based on lost profits, however caused and, whether in contract, tort or under any other theory of liability, regardless of whether such damages were foreseeable or whether You were advised of the possibility of such damages."), /*#__PURE__*/react.createElement("li", null, "The Services may include programs or code that are licensed under an Open-Source Software (\u201COSS\u201C) license model. OSS programs and code are subject to the terms, conditions, and obligations of the applicable OSS license, and are specifically excluded from all warranty and support obligations described elsewhere in these Universal Terms."), /*#__PURE__*/react.createElement("li", null, "The Services may contain independent third-party products (software or hardware) which are not manufactured or developed by Qure and rely upon such third-party products (software or hardware) to perform certain functionality. Qure make no warranties either expressed or implied as to the accuracy of any such third-party products (software or hardware). Third party technology that may be appropriate or necessary for use with some software or hardware may be specified in the relevant documentations. The subscriber\u2019s right to use such third-party technology is governed by the terms of the third-party technology license agreement specified by Us and not by these Universal Terms."), /*#__PURE__*/react.createElement("li", null, "The Qure App may contain (or You may be sent through the Site) links to other websites or content belonging to or originating from third parties or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability or completeness by us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third party website/app linked through the Qure App. We will not be a party to or in any way responsible for monitoring any transactions between You and third-party providers of products or services."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "LIMITATION OF LIABILITY"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "To the maximum extent permitted by applicable law, in no event shall Qure be liable to You for any special, incidental, punitive, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits or wrong medical image tag detection or missed image tag detection (both omission and commission) or confidential or other information, for business interruption, for personal injury,\xA0 for loss of privacy, for failure to meet any duty including of reasonable care, for negligence, and for any other pecuniary or other loss whatsoever) arising out of or in any way related to the use of or inability to use the Services, the provision of or failure to provide support or other Services, information, software, and related content through the Services or otherwise arising out of the use of the Services including, but not limited to, any clinical diagnosis, misdiagnosis or consequences to patient well-being and software performance changes or failures to You that may result directly or indirectly from integrating with the Services")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "None of the individual authors, contributors, developers of these Terms nor anyone else connected to Qure in take any responsibility for the results or consequences of any attempt to use or adopt any of the information presented by these Terms.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "12. WARRANTY")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "All information on the Services is provided in good faith, however /Without prejudice to the generality of the foregoing paragraph, Qure does not warrant that the medical information in these Universal Terms is complete, true, accurate, up-to-date, or non-misleading. Neither does Qure assumes legal liability or responsibility for the points mentioned above.Any misuse or abuse of the Qure\u2019s Services, Website and mobile application is strictly prohibited.The Services and documentation are made available to You \u201Cas is\u201D and without warranty of any kind. Qure specifically disclaims all warranties, express or implied, including without limitation, warranties of merchantability, fitness for a particular purpose and non-infringement. Qure does not warrant that Services, documentation, or any other information, materials and/or Data provided hereunder will meet Your requirements or is complete, accurate or error-free. You shall not make any representations or warranties on behalf of Qure. You are solely responsible for backing up any of Your Data."), /*#__PURE__*/react.createElement("li", null, "All information on the Services is provided in good faith, however /Without prejudice to the generality of the foregoing paragraph, Qure does not warrant that the medical information in these Universal Terms is complete, true, accurate, up-to-date, or non-misleading. Neither does Qure assumes legal liability or responsibility for the points mentioned above.Any misuse or abuse of the Qure\u2019s Services, Website and mobile application is strictly prohibited.The Services and documentation are made available to You \u201Cas is\u201D and without warranty of any kind. Qure specifically disclaims all warranties, express or implied, including without limitation, warranties of merchantability, fitness for a particular purpose and non-infringement. Qure does not warrant that Services, documentation, or any other information, materials and/or Data provided hereunder will meet Your requirements or is complete, accurate or error-free. You shall not make any representations or warranties on behalf of Qure. You are solely responsible for backing up any of Your Data."), /*#__PURE__*/react.createElement("li", null, "All information on the Services is provided in good faith, however /Without prejudice to the generality of the foregoing paragraph, Qure does not warrant that the medical information in these Universal Terms is complete, true, accurate, up-to-date, or non-misleading. Neither does Qure assumes legal liability or responsibility for the points mentioned above."), /*#__PURE__*/react.createElement("li", null, "Any misuse or abuse of the Qure\u2019s Services, Website and mobile application is strictly prohibited."), /*#__PURE__*/react.createElement("li", null, "The Services and documentation are made available to You \u201Cas is\u201D and without warranty of any kind. Qure specifically disclaims all warranties, express or implied, including without limitation, warranties of merchantability, fitness for a particular purpose and non-infringement. Qure does not warrant that Services, documentation, or any other information, materials and/or Data provided hereunder will meet Your requirements or is complete, accurate or error-free. You shall not make any representations or warranties on behalf of Qure. You are solely responsible for backing up any of Your Data."))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "13. TESTIMONIAL DISCLAIMER")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "The Site may contain testimonials by Users of Our Services. These testimonials reflect the real-life experiences and opinions of such Users. However, the experiences are personal to those particular Users, and may not necessarily be representative of all Users of Our Services. We do not claim, and You should not assume, that all Users will have the same experiences. YOUR INDIVIDUAL RESULTS MAY VARY.The testimonials on the Site are submitted in various forms such as text, audio and/or video, and are reviewed by Us before being posted. They appear on the Site verbatim as given by the Users, except for the correction of grammar or typing errors. Some testimonials may have been shortened for the sake of brevity where the full testimonial contained extraneous information not relevant to the general public.The views and opinions contained in the testimonials belong solely to the individual User and do not reflect Our views and opinions. We are not affiliated with Users who provide testimonials, and Users are not paid or otherwise compensated for their testimonials"), /*#__PURE__*/react.createElement("li", null, "The Site may contain testimonials by Users of Our Services. These testimonials reflect the real-life experiences and opinions of such Users. However, the experiences are personal to those particular Users, and may not necessarily be representative of all Users of Our Services. We do not claim, and You should not assume, that all Users will have the same experiences. YOUR INDIVIDUAL RESULTS MAY VARY.The testimonials on the Site are submitted in various forms such as text, audio and/or video, and are reviewed by Us before being posted. They appear on the Site verbatim as given by the Users, except for the correction of grammar or typing errors. Some testimonials may have been shortened for the sake of brevity where the full testimonial contained extraneous information not relevant to the general public.The views and opinions contained in the testimonials belong solely to the individual User and do not reflect Our views and opinions. We are not affiliated with Users who provide testimonials, and Users are not paid or otherwise compensated for their testimonials"), /*#__PURE__*/react.createElement("li", null, "The Site may contain testimonials by Users of Our Services. These testimonials reflect the real-life experiences and opinions of such Users. However, the experiences are personal to those particular Users, and may not necessarily be representative of all Users of Our Services. We do not claim, and You should not assume, that all Users will have the same experiences. YOUR INDIVIDUAL RESULTS MAY VARY."), /*#__PURE__*/react.createElement("li", null, "The testimonials on the Site are submitted in various forms such as text, audio and/or video, and are reviewed by Us before being posted. They appear on the Site verbatim as given by the Users, except for the correction of grammar or typing errors. Some testimonials may have been shortened for the sake of brevity where the full testimonial contained extraneous information not relevant to the general public."), /*#__PURE__*/react.createElement("li", null, "The views and opinions contained in the testimonials belong solely to the individual User and do not reflect Our views and opinions. We are not affiliated with Users who provide testimonials, and Users are not paid or otherwise compensated for their testimonials"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "PRIVACY"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Any personal information provided to Qure will be dealt with in accordance with Qure\u2019s\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/privacy-policy/"
  }, "privacy policy"), ". Any information provided may be accessed by any employee of Qure and its related companies in accordance with the requirement of Qure\u2019s\xA0", /*#__PURE__*/react.createElement("a", {
    href: "https://qure.ai/privacy-policy/"
  }, "privacy policy"), ".")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("ul", {
    className: "!list-disc space-y-3"
  }, /*#__PURE__*/react.createElement("li", null, "MISCELLANEOUS"))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Assignment: Any rights or obligations hereunder may be assigned by Qure without Your prior written consent. However, You shall not assign any rights or obligations hereunder without the prior written consent of Qure. These Terms bind, and inure to the benefit of, the Parties and their respective successors and permitted assigns.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Entire Agreement: The Terms together constitute the entire agreement and supersede any and all prior agreements between You and Qure with regard to the subject matter hereof. The Terms shall prevail over the terms or conditions in any purchase order or other order documentation You or any entity that You represent provides (all such terms or conditions being null and void), unless otherwise agreed and accepted in writing by Qure.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Amendment: We may amend these Universal Terms from time to time, in which case the new Universal Terms will supersede prior versions. We will notify You of any material revisions not less than ten (10) days prior to the effective date of any amendments to these Universal Terms and Your continued use of the Services following the effective date of any such amendment may be relied upon by Us as Your acceptance of any such amendment. You can review the most current version of the Universal Terms at any time by visiting this page.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Severability; No Waiver: If any provision in these Universal Terms is held by a court of competent jurisdiction to be unenforceable, such provision shall be modified by the court and interpreted so as to best accomplish the original provision to the fullest extent permitted by applicable law, and the remaining provisions of these Universal Terms shall remain in effect. Qure\u2019s non-exercise of any right under any provision of these Universal Terms does not constitute a waiver of that right or provision of these Universal Terms.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Relationship of the Parties:\u202FThe Parties are independent contractors. These Universal Terms do not create a partnership, franchise, joint venture, agency, fiduciary or employment relationship among the Parties.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Survival:\u202FAll clauses which, by their nature are intended to survive, including without limitation clauses\xA01 (Definitions), 3 (Your / Customer\u2019s Representations And Warranties), 7(Personal Data Protection), 8 (Confidentiality), 9 (Intellectual Property), 10 (Indemnification), 11 (Limitation Of Liability), 12 (Warranty)\xA015 (Miscellaneous),\xA0shall survive any termination of Qure\u2019s agreement with respect to use of the Services by You. Termination shall not limit either Party\u2019s liability for obligations accrued as of or prior to such termination or for any breach of the Terms.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Notices and Consent to Electronic Communications:\u202FAll notices to be provided by Qure to You under these Terms may be delivered in writing (i) by nationally recognized overnight delivery service (\u201CCourier\u201D) or to the contact mailing address provided by You on subscribing to the Services; or (ii) electronic mail to the e-mail address provided by You. Qure\u2019s address for a notice to Qure in writing by Courier is\xA07th Floor, Oberoi Commerz-II, International, Business Park, Oberoi Garden City, Off Western, Express Highway, Goregaon East, Mumbai, Maharashtra, 400063, India\xA0with a CC to\xA0", /*#__PURE__*/react.createElement("a", {
    href: "mailto:partner@qure.ai"
  }, "partner@qure.ai"), "\xA0for electronic mail. All notices shall be deemed to have been given immediately upon delivery by electronic mail, or if otherwise delivered upon receipt of mail or Courier as permitted above.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Publicity Rights:\u202FYou hereby grant Qure the right to identify Yourself as Qure\u2019s Customer on Qure\u2019s websites and/or marketing collateral and to include Your use of the Services in case studies, research. You shall not use the trademark, trade name or the Qure logo or any other mark or logo of Qure, except with the prior written consent and as per the directions of Qure.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Change in Law:\xA0Qure shall not be liable for any increase in costs or reduction in net after Tax return or other financial burden, loss, liability or damage on You arising as a result of Change in Law. You acknowledge and agree that it shall not be entitled to any compensation from Qure in the event of any Change in Law or the operation or enforcement of current applicable laws. \u201CChange in Law\u201D for the purposes of this clause means the enactment, adoption, promulgation, modification or repeal (including any change in interpretation or application by the relevant authorities), of any applicable law.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Governing Law & Jurisdiction:\xA0These Universal Terms and all rights, duties and obligations arising hereunder shall be governed by and in accordance with the laws of India; notwithstanding any conflicts of laws principles. Subject to Dispute Resolution clause below, Parties submit to the exclusive jurisdiction of the courts at Mumbai. The Parties waive any objections to such jurisdiction, including venue and inconvenient forum.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Dispute Resolution:\xA0Any dispute arising under, relating to or in connection with these Universal Terms, or the breach hereof, including any question regarding its existence, validity or termination, shall be resolved by mediation first, failing which they shall be referred to and finally resolved by arbitration in accordance with the arbitration rules of the Mumbai Centre for International Arbitration (\u201CMCIA\xA0Rules\u201D), which rules are deemed to be incorporated by reference in this clause. The award rendered by the arbitrator shall be final and binding on the Parties. The arbitration shall be conducted by a sole arbitrator, who will be appointed by MCIA in accordance with MCIA Rules. The seat and the venue of the arbitration shall be Mumbai. The language to be used in the arbitral proceedings shall be English.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Class Action Waiver:\xA0Any Claim brought by You or Your Users against Qure shall be under individual capacity, and not as a plaintiff or class member in any purported class, collective, representative, multiple plaintiff, or similar proceeding (\u201CClass Action\u201D). You expressly waive any ability to maintain any Class Action in any forum. If the Claim is subject to arbitration, the arbitrator will not have authority to combine or aggregate similar claims or conduct any Class Action nor make an award to any person or entity not a party to the arbitration. Any claim that all or part of this Class Action Waiver is unenforceable, unconscionable, void, or voidable may be determined only by a court of competent jurisdiction and not by an arbitrator. You understand that any right to litigate in court, to have a judge or jury decide their case, or to be a party to a class or representative action, is waived, and that any claims must be decided individually.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Injunctive Relief.\xA0You agree that a breach of Terms will cause irreparable injury to Qure for which monetary damages would not be an adequate remedy and Qure shall be entitled to equitable relief in addition to any remedies it may have hereunder or at law or equity without any proof of damages.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Disclosure:\xA0We reserve the right to access, read, preserve, and disclose any information that We obtain in connection with the Site, and Your use thereof, as We reasonably believe is necessary to (i) satisfy any applicable law, regulation, legal process, subpoena or governmental request, (ii) enforce the Terms, including to investigate potential violations of them, (iii) detect, prevent, or otherwise address fraud, security or technical issues, (iv) respond to User support requests, or (v) protect the rights, property or safety of Qure, its Users or the public.")), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, "Consent to Electronic Communications and Solicitation:\u202FBy downloading the Qure App, and/or opting-in through notification settings, You authorize Qure to send You (including via email and push notifications) information regarding the Services, such as: (a) notices about Your use of the Services, including notices of violations of use; (b) Updates to the Service and App and new features or products; and (c) promotional information and materials regarding Qure\u2019s Services. You can review and/or unsubscribe to such notifications by following instructions as provided by Qure in the Services.")));
};

/* harmony default export */ var TermsAndConditionsModal_TermsAndConditionsContent = (TermsAndConditionsContentStatic);
;// CONCATENATED MODULE: ./components/TermsAndConditionsModal/constants.ts
var DISCLAIMER_CONTENT = "I confirm that I have read and understood the Terms and Conditions. I\nfurther understand that by clicking this checkbox, I will be bound by, and\nwill bind my employer to the Terms and Conditions and my employer will be\nresponsible for the duties and obligations contained therein";
var TERMS_AND_CONDITIONS = "terms_and_conditions";
var PRIVACY_POLICY = "privacy_policy";
var CONFIRMATION_CONTENT = "Are you sure you want to reject the license agreement? By clicking 'Proceed',\nyou acknowledge that you will not be able to use the software.";
var LINKS = [{
  label: "Terms & conditions",
  id: TERMS_AND_CONDITIONS,
  href: "#".concat(TERMS_AND_CONDITIONS)
}, {
  label: "Privacy policy",
  id: PRIVACY_POLICY,
  href: "#".concat(PRIVACY_POLICY)
}];
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./utils/servicesUtils.ts
var servicesUtils = __webpack_require__(39949);
;// CONCATENATED MODULE: ./components/TermsAndConditionsModal/services.ts



function useAgreementService() {
  var url = "/agreement/accept/";
  return (0,es.useMutation)(function (version) {
    return servicesUtils/* default.postService */.Z.postService(url, {
      version: version
    });
  });
}

/* harmony default export */ var services = (useAgreementService);
// EXTERNAL MODULE: ./components/AwesomeIcon/index.tsx + 2 modules
var AwesomeIcon = __webpack_require__(38266);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
;// CONCATENATED MODULE: ./components/TermsAndConditionsModal/index.tsx


var TermsAndConditionsModal_jsx = react.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




















var getDefaultProps = function getDefaultProps(props) {
  var dupeProps = _objectSpread({}, props);

  if (!dupeProps.closeButton) {
    dupeProps.closeButton = props.mode === "readonly" ? undefined : /*#__PURE__*/react.createElement(react.Fragment, null);
  }

  if (dupeProps.closeOnClickAway == null) {
    dupeProps.closeOnClickAway = false;
  }

  return dupeProps;
};

var TermsAndConditionsContent = function TermsAndConditionsContent(props) {
  var _agreement$accepted_t;

  var mode = props.mode,
      onDisagree = props.onDisagree;
  var isInteractive = mode === "interactive"; // hooks

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  var _React$useState3 = react.useState(new Map()),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      viewedMap = _React$useState4[0],
      setViewedMap = _React$useState4[1];

  var termsAndConditionsRef = react.useRef(null);
  var privacyPolicyRef = react.useRef(null);

  var _React$useState5 = react.useState(false),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      disclaimerStatus = _React$useState6[0],
      setDisclaimerStatus = _React$useState6[1];

  var maxScroll = react.useRef(0);

  var _React$useState7 = react.useState(0),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      currentScroll = _React$useState8[0],
      setCurrentScroll = _React$useState8[1]; // custom hooks


  var agreementQuery = services();
  var router = (0,next_router.useRouter)();
  var isMobile = (0,useMedia/* default */.Z)([useMedia/* MediaSizes.MOBILE */._.MOBILE], [true], false);
  var userInfo = Store/* default.useState */.Z.useState(function (s) {
    return s.userInfo;
  });
  var sectionsRead = Array.from(viewedMap.values()).every(function (value) {
    return value;
  });
  var passedCriteria = sectionsRead && disclaimerStatus;

  var agreement = lodash_default().get(userInfo, ["agreement"]);

  var agreementDatetime = (_agreement$accepted_t = agreement === null || agreement === void 0 ? void 0 : agreement.accepted_time) !== null && _agreement$accepted_t !== void 0 ? _agreement$accepted_t : "";
  var contents = [{
    id: "terms_and_conditions",
    ref: termsAndConditionsRef,
    component: TermsAndConditionsModal_TermsAndConditionsContent
  }, {
    id: "privacy_policy",
    ref: privacyPolicyRef,
    component: TermsAndConditionsModal_PrivacyPolicyContent
  }];

  function submitAgreement() {
    var version = constants/* default.TERMS_OF_USE_VERSION */.Z.TERMS_OF_USE_VERSION;
    agreementQuery.mutateAsync(version).then(function () {
      router.push({
        pathname: "/",
        query: {
          invalidate: true
        }
      });
    })["catch"](function (e) {
      Toast/* default.error */.Z.error("Something went wrong. Please try again");
    });
  }

  function handleDisagree() {
    onDisagree();
  }

  function handleScroll(e) {
    var target = e.target;
    var clientHeight = target.clientHeight,
        scrollTop = target.scrollTop;

    if (!termsAndConditionsRef.current || !privacyPolicyRef.current) {
      return;
    }

    var termsAndConditionsNodeHeight = termsAndConditionsRef.current.clientHeight;
    var privacyPolicyNodeHeight = privacyPolicyRef.current.clientHeight;

    if (!maxScroll.current) {
      maxScroll.current = termsAndConditionsNodeHeight + privacyPolicyNodeHeight - clientHeight;
    }

    if (!currentScroll || currentScroll < scrollTop) {
      setCurrentScroll(scrollTop);
    }

    if (termsAndConditionsNodeHeight == null || privacyPolicyNodeHeight == null) {
      return;
    }

    var isTermsAndConditionsViewed = viewedMap.get(termsAndConditionsRef.current.id);
    var isPrivacyPolicyViewed = viewedMap.get(privacyPolicyRef.current.id);
    var hasChanged = false;

    if (scrollTop <= termsAndConditionsNodeHeight - clientHeight) {
      setActiveIndex(0);
    } else {
      setActiveIndex(1);
    }

    if (scrollTop >= termsAndConditionsNodeHeight - clientHeight && !isTermsAndConditionsViewed && scrollTop < termsAndConditionsNodeHeight + privacyPolicyNodeHeight - clientHeight) {
      hasChanged = true;
      viewedMap.set(termsAndConditionsRef.current.id, true);
    }

    if (scrollTop >= termsAndConditionsNodeHeight + privacyPolicyNodeHeight - clientHeight && !isPrivacyPolicyViewed) {
      hasChanged = true;
      viewedMap.set(privacyPolicyRef.current.id, true);
    }

    if (hasChanged) {
      setViewedMap(new Map(viewedMap));
    }
  }

  react.useEffect(function () {
    var map = new Map();
    LINKS.forEach(function (link) {
      map.set(link.id, false);
    });
    setViewedMap(map);
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    className: "py-4"
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("grid pr-6 py-4", {
      "grid-cols-[214px_564px]": !isMobile,
      "pl-6 grid-cols-1": isMobile
    })
  }, mode === "readonly" && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("p", null, ""), /*#__PURE__*/react.createElement("div", null, agreementDatetime !== "" && /*#__PURE__*/react.createElement("div", {
    className: "my-3"
  }, /*#__PURE__*/react.createElement("p", {
    className: "text-left"
  }, "ACCEPTED ON ", (0,utils/* getFormattedDate */.L0)(agreementDatetime))))), !isMobile && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("a", {
    href: "/dummy",
    className: "opacity-0"
  }, ""), /*#__PURE__*/react.createElement("ul", {
    className: "list-none mt-4"
  }, LINKS.map(function (link, index) {
    return /*#__PURE__*/react.createElement("a", {
      href: link.href,
      key: link.id,
      className: classnames_default()({
        "bg-gray-100 dark:bg-gray-900": activeIndex === index,
        "border-b": index === LINKS.length - 1
      }, "border-t border-gray-600 py-4 grid px-5 text-left outline-none", "".concat(isInteractive ? "grid-cols-[30px_1fr]" : "grid-cols-1")),
      onClick: function onClick() {
        setActiveIndex(index);
      }
    }, isInteractive && /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faCircleCheck */.fV7,
      className: classnames_default()("text-green-600 w-6", {
        invisible: !viewedMap.get(link.id)
      })
    }), link.label);
  }))), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    className: "terms-of-use bg-gray-100 dark:bg-gray-900 rounded-md border border-gray-600 relative overflow-hidden"
  }, /*#__PURE__*/react.createElement("div", {
    className: "pb-4 h-[360px] sm:h-[453px]"
  }, /*#__PURE__*/react.createElement("div", {
    className: "pl-5 pr-3 scrollbar-light dark:scrollbar h-full overflow-y-scroll",
    onScroll: handleScroll
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-gray-900 dark:text-gray-100 text-left whitespace-pre-wrap"
  }, contents.map(function (content) {
    return /*#__PURE__*/react.createElement("div", {
      ref: content.ref,
      key: content.id,
      id: content.id,
      className: "py-6"
    }, content.component());
  })))), isInteractive && /*#__PURE__*/react.createElement("progress", {
    className: "w-full h-2 bg-gray-600 rounded-md block sticky bottom-0",
    max: maxScroll.current,
    value: currentScroll
  })), isInteractive && /*#__PURE__*/react.createElement("div", {
    className: "flex gap-2 items-start mt-6"
  }, /*#__PURE__*/react.createElement(Checkbox/* default */.Z, {
    name: "disclaimer",
    checked: disclaimerStatus,
    onChange: function onChange(value) {
      setDisclaimerStatus(value);

      if (value && !sectionsRead) {
        viewedMap.set("terms_and_conditions", true);
        viewedMap.set("privacy_policy", true);
        setViewedMap(new Map(viewedMap));
      }
    }
  }), /*#__PURE__*/react.createElement("p", {
    className: "text-md dark:text-gray-200 text-gray-700 italic text-left"
  }, DISCLAIMER_CONTENT)))), isInteractive && /*#__PURE__*/react.createElement("div", {
    className: "border-t border-gray-600"
  }, /*#__PURE__*/react.createElement("ul", {
    className: "mr-6 gap-5 pt-4 list-none flex"
  }, /*#__PURE__*/react.createElement("li", {
    className: "ml-auto"
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: "w-[156px]",
    onClick: handleDisagree
  }, "Disagree")), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: "w-[156px]",
    isPrimary: true,
    isLoading: agreementQuery.isLoading,
    disabled: !passedCriteria,
    onClick: submitAgreement
  }, "Agree")))));
};

var ConfirmationModal = function ConfirmationModal(props) {
  var setShowConfirmationModal = props.setShowConfirmationModal;

  function onProceed() {
    Store/* default.update */.Z.update(function (s) {
      s.isLogoutOpen = true;
    });
  }

  function onCancel() {
    setShowConfirmationModal(false);
  }

  return /*#__PURE__*/react.createElement(Modal/* default */.Z, {
    className: "sm:w-6/12 lg:w-5/12",
    show: true,
    closeOnClickAway: false,
    onClose: function onClose() {
      setShowConfirmationModal(false);
    },
    title: "Rejecting license agreement"
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("p", {
    className: "text-left px-6 py-4"
  }, CONFIRMATION_CONTENT), /*#__PURE__*/react.createElement("ul", {
    className: "list-none flex gap-5 mr-6 mb-5"
  }, /*#__PURE__*/react.createElement("li", {
    className: "ml-auto"
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: "min-w-[156px]",
    onClick: onProceed
  }, "Proceed")), /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: "min-w-[156px]",
    isPrimary: true,
    onClick: onCancel
  }, "Cancel")))));
};

var TermsAndConditionsModal = function TermsAndConditionsModal(props) {
  var _getDefaultProps = getDefaultProps(props),
      closeButton = _getDefaultProps.closeButton,
      closeOnClickAway = _getDefaultProps.closeOnClickAway,
      mode = _getDefaultProps.mode,
      _onClose = _getDefaultProps.onClose; // hooks


  var _React$useState9 = react.useState(true),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      showModal = _React$useState10[0],
      setShowModal = _React$useState10[1];

  var _React$useState11 = react.useState(false),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      showConfirmationModal = _React$useState12[0],
      setShowConfirmationModal = _React$useState12[1];

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Modal/* default */.Z, {
    className: "max-w-[800px]",
    show: showModal,
    closeButton: closeButton,
    closeOnClickAway: closeOnClickAway,
    onClose: function onClose() {
      _onClose();

      setShowModal(false);
    },
    title: "Terms of use"
  }, /*#__PURE__*/react.createElement(TermsAndConditionsContent, {
    onDisagree: function onDisagree() {
      setShowConfirmationModal(true);
    },
    mode: mode
  })), showConfirmationModal && /*#__PURE__*/react.createElement(ConfirmationModal, {
    setShowConfirmationModal: setShowConfirmationModal
  }));
};

/* harmony default export */ var components_TermsAndConditionsModal = (TermsAndConditionsModal);

/***/ }),

/***/ 38990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getTrimmedId; }
/* harmony export */ });
var getTrimmedId = function getTrimmedId(id) {
  return id && id.slice(-8);
};



/***/ }),

/***/ 59275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;


var Button = function Button(props) {
  var children = props.children,
      onClick = props.onClick,
      isPrimary = props.isPrimary,
      isDanger = props.isDanger,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      disabled = props.disabled,
      isLoading = props.isLoading,
      _props$type = props.type,
      type = _props$type === void 0 ? "button" : _props$type;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    type: type,
    onClick: onClick,
    disabled: disabled || isLoading,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-flex items-center justify-center text-base font-medium rounded-6 text-gray-100 py-4 px-4", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      "bg-teal-500 hover:bg-teal-600": isPrimary,
      "bg-gray-700 hover:bg-gray-600": !isPrimary,
      "bg-red-600 hover:bg-red-500": isDanger,
      "cursor-progress": isLoading,
      "opacity-50": disabled || isLoading
    }, className, !!className))
  }, isLoading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-5 h-5 rounded-full text-blue-600 mr-3",
    role: "status"
  }), !!children && children);
};

/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 48831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./components/FormComponents/BloodPressure.jsx
var BloodPressure = __webpack_require__(58485);
// EXTERNAL MODULE: ./components/FormComponents/CheckboxList.jsx
var CheckboxList = __webpack_require__(2446);
// EXTERNAL MODULE: ./components/FormComponents/DateTimeInput.jsx
var DateTimeInput = __webpack_require__(40563);
// EXTERNAL MODULE: ./components/FormComponents/SelectInput.tsx
var SelectInput = __webpack_require__(94440);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/FormComponents/SingleSelectTab.jsx




var SingleSelectTab = function SingleSelectTab(_ref) {
  var options = _ref.options,
      selected = _ref.selected,
      onChange = _ref.onChange,
      title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex mb-5",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex rounded-6 bg-gray-800 text-gray-100 divide-x divide-teal-500",
      children: options.map(function (option, index) {
        var value = option.value,
            label = option.label;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()("py-3 px-5 cursor-pointer", {
            "bg-teal-500": selected === value,
            "rounded-l-6": index === 0,
            "rounded-r-6": index === options.length - 1
          }),
          onClick: function onClick() {
            onChange(value);
          },
          children: label
        }, value);
      })
    })]
  });
};

/* harmony default export */ var FormComponents_SingleSelectTab = (SingleSelectTab);
// EXTERNAL MODULE: ./components/FormComponents/TextInput.tsx
var TextInput = __webpack_require__(42641);
;// CONCATENATED MODULE: ./components/DynamicForm/FormControl.jsx











var FormControl = function FormControl(_ref) {
  var control = _ref.control;
  var type = control.type,
      title = control.title,
      properties = control.properties;
  var units = (0,lodash.get)(properties, ["units", "one_of"], []);
  var choices = (0,lodash.get)(properties, ["choices"], []);
  var layout = (0,lodash.get)(properties, ["layout"], "");
  var options = choices && choices.map(function (choice) {
    return {
      value: choice.id,
      label: choice.label,
      child: choice.children
    };
  });

  switch (type) {
    case constants/* default.FORM_FIELDS.DUAL_NUMBER */.Z.FORM_FIELDS.DUAL_NUMBER:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BloodPressure/* default */.Z, {
        title: title,
        unit: units.length === 1 ? units[0] : units
      });

    case constants/* default.FORM_FIELDS.NUMBER */.Z.FORM_FIELDS.NUMBER:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        label: title,
        value: "",
        onChange: function onChange(val) {},
        isClinicalField: true,
        unit: units.length === 1 ? units[0] : units,
        className: "w-20",
        wrapperClassName: "py-0",
        disabled: false
      });

    case constants/* default.FORM_FIELDS.MULTISELECT */.Z.FORM_FIELDS.MULTISELECT:
      if (layout === "default") {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxList/* default */.Z, {
          label: title,
          value: [],
          options: options,
          onChange: function onChange(val) {}
        });
      } else if (layout === "dropdown") {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectInput/* default */.Z, {
          value: [],
          multiple: true,
          isClinicalField: true,
          options: options,
          className: "w-full",
          onChange: function onChange(val) {}
        });
      }

    case constants/* default.FORM_FIELDS.CHECKBOX */.Z.FORM_FIELDS.CHECKBOX:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(common_Checkbox, {
        checked: false,
        label: title,
        onChange: function onChange() {},
        className: "py-3"
      });

    case constants/* default.FORM_FIELDS.SINGLESELECT */.Z.FORM_FIELDS.SINGLESELECT:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FormComponents_SingleSelectTab, {
        title: title,
        options: options,
        selected: "ID_LEFT",
        onChange: function onChange() {}
      });

    case constants/* default.FORM_FIELDS.DATETIME */.Z.FORM_FIELDS.DATETIME:
    case constants/* default.FORM_FIELDS.LKWT */.Z.FORM_FIELDS.LKWT:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(DateTimeInput/* default */.Z, {
        label: title,
        value: "",
        isClinicalField: true,
        onChange: function onChange(val) {},
        dateFormat: "dd/MM/yyyy",
        datePlaceholder: "DD/MM/YYYY",
        timeFormat: "h:mm aa",
        timePlaceholder: "HH:MM aa",
        showTimeFirst: true,
        disabled: false,
        required: false
      });

    default:
      return null;
  }
};

/* harmony default export */ var DynamicForm_FormControl = (FormControl);
;// CONCATENATED MODULE: ./components/common/Checkbox.tsx


var __jsx = react.createElement;



var Checkbox = function Checkbox(props) {
  var id = props.id,
      label = props.label,
      checked = props.checked,
      _onChange = props.onChange,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      disabled = props.disabled,
      name = props.name,
      child = props.child,
      _props$labelClassName = props.labelClassName,
      labelClassName = _props$labelClassName === void 0 ? "" : _props$labelClassName;
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("relative flex items-center", (0,defineProperty/* default */.Z)({
      "opacity-50": disabled
    }, className, !!className))
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/react.createElement("input", {
    id: id,
    "aria-describedby": id,
    name: name !== null && name !== void 0 ? name : id,
    type: "checkbox",
    className: classnames_default()("rounded dark:border-gray-400 cursor-pointer text-teal-400 bg-transparent", {
      "!cursor-not-allowed": disabled
    }),
    checked: checked,
    onChange: function onChange(e) {
      return _onChange ? _onChange(e.target.checked) : null;
    },
    disabled: disabled
  })), /*#__PURE__*/react.createElement("label", {
    htmlFor: id,
    className: classnames_default()("ml-3 text-gray-700 dark:text-gray-200 cursor-pointer text-base text-left w-full break-words", (0,defineProperty/* default */.Z)({
      "!cursor-not-allowed": disabled
    }, labelClassName, !!labelClassName))
  }, label), child && /*#__PURE__*/react.createElement(DynamicForm_FormControl, {
    control: child
  }));
};

/* harmony default export */ var common_Checkbox = (Checkbox);

/***/ }),

/***/ 64407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68779);
/* harmony import */ var _AwesomeIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38266);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var _this = undefined;

var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;






var DebounceInput = function DebounceInput(props) {
  var _classNames2;

  var value = props.value,
      onChange = props.onChange,
      placeholder = props.placeholder,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      _props$inputClassName = props.inputClassName,
      inputClassName = _props$inputClassName === void 0 ? "" : _props$inputClassName,
      hasFilters = props.hasFilters,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      setShowFilters = props.setShowFilters,
      isPrimary = props.isPrimary;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      text = _useState[0],
      setText = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (value != text) {
      setText(value);
    }
  }, [value]);

  var debounce = function debounce(func) {
    var timer;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var context = _this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  var handleChange = function handleChange(val) {
    setText(val);
    optimizedFn(val);
  };

  var optimizedFn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(debounce(function (val) {
    onChange ? onChange(val) : null;
  }), []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative text-gray-500 dark:text-gray-400 block w-full", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, className, !!className))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faMagnifyingGlass */ .Y$T,
    size: "lg",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-6 absolute top-1/2 transform -translate-y-1/2 left-3 cursor-pointer text-teal-500 dark:text-gray-100", {
      "dark:text-teal-400": isPrimary
    })
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    value: text,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("form-input w-full p-3 pl-8 pr-8 bg-gray-200 dark:bg-gray-800 rounded-md border-transparent focus:border-transparent text-md", (_classNames2 = {
      " !border-teal-300": !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(text)
    }, (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames2, inputClassName, !!inputClassName), (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames2, "!border-teal-500 dark:!border-teal-300", !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(text) && !!inputClassName), _classNames2)),
    placeholder: placeholder,
    title: placeholder,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    disabled: disabled
  }), hasFilters && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-teal-500 dark:text-gray-400 w-6 h-6 absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer",
    onClick: function onClick() {
      setShowFilters ? setShowFilters() : null;
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faFilterList */ .Ct,
    size: "lg",
    className: "text-teal-500 dark:text-teal-400"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (DebounceInput);

/***/ }),

/***/ 6039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72510);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44080);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _DebounceInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64407);
/* harmony import */ var _AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38266);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68779);


var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;







var DropdownMenu = function DropdownMenu(props) {
  var options = props.options,
      Icon = props.Icon,
      hasArrow = props.hasArrow,
      hasCustomControl = props.hasCustomControl,
      _props$isSearch = props.isSearch,
      isSearch = _props$isSearch === void 0 ? false : _props$isSearch,
      search = props.search,
      setSearch = props.setSearch,
      _props$menuItemClassN = props.menuItemClassName,
      menuItemClassName = _props$menuItemClassN === void 0 ? "" : _props$menuItemClassN,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .v, {
    as: "div",
    className: "flex-shrink-0 relative text-base"
  }, function (_ref) {
    var open = _ref.open,
        close = _ref.close;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu.Button */ .v.Button, {
      disabled: disabled,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex group text-gray-200 border-b-2 relative z-10 border-transparent", {
        "!text-gray-100 bg-teal-900 !border-teal-500": !hasCustomControl && open,
        "hover:text-gray-100 hover:bg-teal-900 ": !hasCustomControl && !open,
        "border-none": isSearch,
        "opacity-50": disabled
      })
    }, !!Icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, {
      open: open
    }), hasArrow && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M16.7071 10.7071C17.0976 10.3166 17.0976 9.68342 16.7071 9.29289C16.3166 8.90237 15.6834 8.90237 15.2929 9.29289L16.7071 10.7071ZM12 14L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L12 14ZM8.70711 9.29289C8.31658 8.90237 7.68342 8.90237 7.29289 9.29289C6.90237 9.68342 6.90237 10.3166 7.29289 10.7071L8.70711 9.29289ZM15.2929 9.29289L11.2929 13.2929L12.7071 14.7071L16.7071 10.7071L15.2929 9.29289ZM12.7071 13.2929L8.70711 9.29289L7.29289 10.7071L11.2929 14.7071L12.7071 13.2929Z",
      fill: "white",
      fillOpacity: "0.5"
    })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .u, {
      as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu.Items */ .v.Items, {
      className: "origin-top-right absolute z-20 max-h-85 overflow-y-auto scrollbar-light dark:scrollbar right-0 mt-3 rounded-md shadow-lg dark:bg-gray-800 bg-gray-100 focus:outline-none border border-gray-700 w-72\n                            after:content[''] after:absolute after:right-6 after:-top-4 after:bottom-auto after:border-6 after:border-transparent after:border-b-gray-700 ".concat(menuItemClassName)
    }, isSearch && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "flex px-4 py-3 items-center border-b border-gray-700 justify-between"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_DebounceInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      value: search,
      onChange: setSearch,
      placeholder: "Search templates",
      className: "rounded-md text-white border w-full border-gray-700"
    }))), options === null || options === void 0 ? void 0 : options.map(function (item, index) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu.Item */ .v.Item, {
        key: index
      }, function (_ref2) {
        var active = _ref2.active;
        var className = item === null || item === void 0 ? void 0 : item.className;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, item !== null && item !== void 0 && item.href ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
          href: item === null || item === void 0 ? void 0 : item.href,
          className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block text-gray-200 hover:bg-teal-800", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, className, !!className))
        }, item === null || item === void 0 ? void 0 : item.name) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block dark:text-gray-200 text-gray-800 cursor-pointer hover:bg-teal-400 hover:text-gray-100", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, className, !!className)),
          onClick: function onClick(e) {
            e.stopPropagation();
            item === null || item === void 0 ? void 0 : item.onClick();
            close();
          }
        }, item === null || item === void 0 ? void 0 : item.name));
      });
    }))));
  });
};

DropdownMenu.defaultProps = {
  Icon: function Icon() {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faXmark */ .g82,
      className: "w-6"
    });
  },
  hasArrow: false,
  hasCustomControl: false
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownMenu);

/***/ }),

/***/ 595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68779);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44080);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69737);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _AwesomeIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38266);


var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;






var Modal = function Modal(props) {
  var children = props.children,
      show = props.show,
      onClose = props.onClose,
      className = props.className,
      title = props.title,
      closeOnClickAway = props.closeOnClickAway,
      closeButton = props.closeButton,
      isAlert = props.isAlert,
      isLoading = props.isLoading,
      bgOpacity = props.bgOpacity;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition.Root */ .u.Root, {
    show: show,
    as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Dialog */ .V, {
    as: "div",
    className: "relative z-50",
    onClose: !!onClose && closeOnClickAway ? onClose : function () {}
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition.Child */ .u.Child, {
    as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("fixed inset-0 bg-zinc-900 bg-opacity-50 transition-opacity", {
      "!bg-black !bg-opacity-50 sm:!bg-zinc-900 sm:!bg-opacity-50": bgOpacity
    })
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fixed flex flex-col h-full inset-0 z-10"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex sm:min-h-full h-full items-end justify-center text-center sm:items-center sm:p-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition.Child */ .u.Child, {
    as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Dialog.Panel */ .V.Panel, {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative transform shadow-xl transition-all w-full rounded-lg bg-gray-200 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 text-gray-800 dark:text-white", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, className, !!className))
  }, (!!title || !!onClose) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex items-center justify-between p-4 border-b border-gray-300 dark:border-gray-600 rounded-t", {
      "bg-gray-300 dark:bg-gray-700": isAlert
    })
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-xl sm:text-lg"
  }, !!title && title), !!onClose || !!closeButton ? !!closeButton ? closeButton : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onClick: onClose
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_AwesomeIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    name: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faXmark */ .g82,
    size: "xl",
    className: "block text-black dark:text-white cursor-pointer w-6"
  })) : null)), children, isLoading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute flex flex-col h-full w-full items-center justify-center overflow-hidden bg-black opacity-30"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-8 h-8 rounded-full text-blue-600 mr-3",
    role: "status"
  }))))))));
};

/* harmony default export */ __webpack_exports__["Z"] = (Modal);

/***/ }),

/***/ 79175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Toggle; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(19946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(61363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(64103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/label/label.js
let d=(0,react.createContext)(null);function u(){let o=(0,react.useContext)(d);if(o===null){let t=new Error("You used a <Label /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,u),t}return o}function H(){let[o,t]=(0,react.useState)([]);return[o.length>0?o.join(" "):void 0,(0,react.useMemo)(()=>function(e){let s=(0,use_event/* useEvent */.z)(r=>(t(l=>[...l,r]),()=>t(l=>{let n=l.slice(),p=n.indexOf(r);return p!==-1&&n.splice(p,1),n}))),a=(0,react.useMemo)(()=>({register:s,slot:e.slot,name:e.name,props:e.props}),[s,e.slot,e.name,e.props]);return react.createElement(d.Provider,{value:a},e.children)},[t])]}let A="label";function h(o,t){let i=(0,use_id/* useId */.M)(),{id:e=`headlessui-label-${i}`,passive:s=!1,...a}=o,r=u(),l=(0,use_sync_refs/* useSyncRefs */.T)(t);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>r.register(e),[e,r.register]);let n={ref:l,...r.props,id:e};return s&&("onClick"in n&&(delete n.htmlFor,delete n.onClick),"onClick"in a&&delete a.onClick),(0,render/* render */.sY)({ourProps:n,theirProps:a,slot:r.slot||{},defaultTag:A,name:r.name||"Label"})}let v=(0,render/* forwardRefWithAs */.yV)(h),M=Object.assign(v,{});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/description/description.js
var description = __webpack_require__(39516);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(14157);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(46045);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/form.js
var utils_form = __webpack_require__(18689);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-controllable.js
var use_controllable = __webpack_require__(31147);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(94192);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/switch/switch.js
let y=(0,react.createContext)(null);y.displayName="GroupContext";let Y=react.Fragment;function Z(s){var d;let[n,p]=(0,react.useState)(null),[c,f]=H(),[r,h]=(0,description/* useDescriptions */.f)(),l=(0,react.useMemo)(()=>({switch:n,setSwitch:p,labelledby:c,describedby:r}),[n,p,c,r]),T={},b=s;return react.createElement(h,{name:"Switch.Description"},react.createElement(f,{name:"Switch.Label",props:{htmlFor:(d=l.switch)==null?void 0:d.id,onClick(t){n&&(t.currentTarget.tagName==="LABEL"&&t.preventDefault(),n.click(),n.focus({preventScroll:!0}))}}},react.createElement(y.Provider,{value:l},(0,render/* render */.sY)({ourProps:T,theirProps:b,defaultTag:Y,name:"Switch.Group"}))))}let ee="button";function te(s,n){let p=(0,use_id/* useId */.M)(),{id:c=`headlessui-switch-${p}`,checked:f,defaultChecked:r=!1,onChange:h,name:l,value:T,form:b,...d}=s,t=(0,react.useContext)(y),u=(0,react.useRef)(null),D=(0,use_sync_refs/* useSyncRefs */.T)(u,n,t===null?null:t.setSwitch),[o,a]=(0,use_controllable/* useControllable */.q)(f,h,r),S=(0,use_event/* useEvent */.z)(()=>a==null?void 0:a(!o)),C=(0,use_event/* useEvent */.z)(e=>{if((0,bugs/* isDisabledReactIssue7711 */.P)(e.currentTarget))return e.preventDefault();e.preventDefault(),S()}),L=(0,use_event/* useEvent */.z)(e=>{e.key===keyboard/* Keys.Space */.R.Space?(e.preventDefault(),S()):e.key===keyboard/* Keys.Enter */.R.Enter&&(0,utils_form/* attemptSubmit */.g)(e.currentTarget)}),v=(0,use_event/* useEvent */.z)(e=>e.preventDefault()),G=(0,react.useMemo)(()=>({checked:o}),[o]),R={id:c,ref:D,role:"switch",type:(0,use_resolve_button_type/* useResolveButtonType */.f)(s,u),tabIndex:0,"aria-checked":o,"aria-labelledby":t==null?void 0:t.labelledby,"aria-describedby":t==null?void 0:t.describedby,onClick:C,onKeyUp:L,onKeyPress:v},k=(0,use_disposables/* useDisposables */.G)();return (0,react.useEffect)(()=>{var w;let e=(w=u.current)==null?void 0:w.closest("form");e&&r!==void 0&&k.addEventListener(e,"reset",()=>{a(r)})},[u,a]),react.createElement(react.Fragment,null,l!=null&&o&&react.createElement(internal_hidden/* Hidden */._,{features:internal_hidden/* Features.Hidden */.A.Hidden,...(0,render/* compact */.oA)({as:"input",type:"checkbox",hidden:!0,readOnly:!0,form:b,checked:o,name:l,value:T})}),(0,render/* render */.sY)({ourProps:R,theirProps:d,slot:G,defaultTag:ee,name:"Switch"}))}let ne=(0,render/* forwardRefWithAs */.yV)(te),re=Z,Ge=Object.assign(ne,{Group:re,Label:M,Description:description/* Description */.d});

;// CONCATENATED MODULE: ./components/common/Toggle.tsx

var __jsx = react.createElement;



var Toggle = function Toggle(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  return /*#__PURE__*/react.createElement(Ge, {
    checked: value,
    onChange: !disabled ? onChange : undefined,
    className: classnames_default()("relative inline-flex h-5 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 border-gray-500 transition-colors duration-200 ease-in-out dark:bg-black", {
      "opacity-50 !cursor-not-allowed": disabled
    })
  }, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()("pointer-events-none relative inline-block h-4 w-4 transform rounded-full bg-gray-500 shadow ring-0 transition duration-200 ease-in-out translate-x-0", {
      "!translate-x-5 bg-teal-500": value
    })
  }, /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true",
    className: classnames_default()("absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 ease-in duration-200", {
      "!opacity-0 !ease-out !duration-100": value
    })
  }, /*#__PURE__*/react.createElement("svg", {
    width: "8",
    height: "2",
    viewBox: "0 0 8 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M1 1H7",
    stroke: "#0C1723",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true",
    className: classnames_default()("absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-0 ease-out duration-100", {
      "!opacity-100 !ease-in !duration-200": value
    })
  })));
};

Toggle.defaultProps = {
  value: false,
  onChange: function onChange() {},
  disabled: false
};
/* harmony default export */ var common_Toggle = (Toggle);

/***/ }),

/***/ 48947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48032);


var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;



var UserIcon = function UserIcon(props) {
  var name = props.name,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("rounded-full bg-gray-300 dark:bg-gray-800 flex items-center justify-center font-[14px] text-gray-800 dark:text-white", (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, className, !!className))
  }, (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getNameInitials */ .Jt)(name));
};

/* harmony default export */ __webpack_exports__["Z"] = (UserIcon);

/***/ }),

/***/ 52315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39949);
/* harmony import */ var _utils_Store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54837);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var useAuthService = function useAuthService(isOpen) {
  return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(["profile", isOpen], function () {
    return _utils_servicesUtils__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getService */ .Z.getService("/profile/").then(function (authData) {
      var isLoggedin = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.get)(authData, ["authenticated"], false);

      if (isLoggedin) {
        _utils_Store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].update */ .Z.update(function (store) {
          // eslint-disable-next-line no-param-reassign
          store.user = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.get)(authData, ["details"], {}); // eslint-disable-next-line no-param-reassign

          store.userInfo = _objectSpread({}, authData);
        });
      }

      return authData;
    });
  }, {
    enabled: isOpen,
    staleTime: 0
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useAuthService);

/***/ }),

/***/ 34559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41065);



function useCheckWorklistContainer() {
  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(),
      pathname = _useRouter.pathname;

  if (pathname.includes(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SCREENS.WORKLIST */ .Z.SCREENS.WORKLIST) || pathname === "/") {
    return true;
  }

  return false;
}

/* harmony default export */ __webpack_exports__["Z"] = (useCheckWorklistContainer);

/***/ }),

/***/ 41148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMedia; },
/* harmony export */   "_": function() { return /* binding */ MediaSizes; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var desktop = 960;
var tablet = 768;
var MediaSizes = {
  MOBILE: "(max-width: 639px)",
  TABLET: "(max-width: 767px)",
  DESKTOP: "(max-width: 1023px)",
  LARGE_DESKTOPS: "(min-width: 1023px)"
}; // Bulma breakpoints reference
// // The container horizontal gap, which acts as the offset for breakpoints
// $gap: 32px !default
// // 960, 1152, and 1344 have been chosen because they are divisible by both 12 and 16
// $tablet: 769px !default
// // 960px container + 4rem
// $desktop: 960px + (2 * $gap) !default
// // 1152px container + 4rem
// $widescreen: 1152px + (2 * $gap) !default
// $widescreen-enabled: true !default
// // 1344px container + 4rem
// $fullhd: 1344px + (2 * $gap) !default
// $fullhd-enabled: true !default
// Hook

function useMedia(queries, values, defaultValue) {
  // Array containing a media query list for each query
  var mediaQueryLists = queries.map(function (q) {
    return window.matchMedia(q);
  }); // Function that gets value based on matching media query

  var getValue = function getValue() {
    // Get index of first media query that matches
    var index = mediaQueryLists.findIndex(function (mql) {
      return mql.matches;
    }); // Return related value or defaultValue if none

    return typeof values[index] !== "undefined" ? values[index] : defaultValue;
  }; // State and setter for matched value


  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getValue),
      value = _useState[0],
      setValue = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Event listener callback
    // Note: By defining getValue outside of useEffect we ensure that it has ...
    // ... current values of hook args (as this hook callback is created once on mount).
    var handler = function handler() {
      return setValue(getValue);
    }; // Set a listener for each media query with above handler as callback.


    mediaQueryLists.forEach(function (mql) {
      return mql.addListener(handler);
    }); // Remove listeners on cleanup

    return function () {
      return mediaQueryLists.forEach(function (mql) {
        return mql.removeListener(handler);
      });
    };
  }, [] // Empty array ensures effect is only run on mount and unmount
  );
  return value;
}



/***/ }),

/***/ 71507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82262);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92777);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);




var LoggedInToken = /*#__PURE__*/(0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function LoggedInToken() {
  var _this = this;

  (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, LoggedInToken);

  (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "key", "loginInProgress");

  (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "setLogInPorgress", function () {
    window.sessionStorage.setItem(_this.key, "yes");
  });

  (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "removeLogInProgress", function () {
    window.sessionStorage.removeItem(_this.key);
  });

  (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "isLoginProgress", function () {
    return window.sessionStorage.getItem(_this.key) === "yes";
  });
});

/* harmony default export */ __webpack_exports__["Z"] = (new LoggedInToken());

/***/ }),

/***/ 54837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var pullstate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69196);

/* harmony default export */ __webpack_exports__["Z"] = (new pullstate__WEBPACK_IMPORTED_MODULE_0__/* .Store */ .yh({
  fcmToken: "",
  RNfcmToken: "",
  user: {},
  userInfo: null,
  uploadModal: {
    isOpen: false,
    hasCurrentPatient: false
  },
  isAddPatientOpen: false,
  isEditPatientOpen: false,
  isConnectModalityOpen: false,
  isLogoutOpen: false,
  sharingPatient: "",
  isGetFullAccessOpen: true,
  enableViewerAPICall: false,
  patient: {},
  patientDetail: {},
  isDarkMode: null,
  isSettingsModalOpen: false,
  isNotificationSettingsOpen: false,
  isChangeRegionModalOpen: false,
  isReportTemplateOpen: false,
  isFindingsSettingsOpen: false,
  isAutomatedSharingOpen: false,
  isAutomatedConditionOpen: false,
  isUserGroupOpen: false,
  isCreateUserGroup: false,
  isAutomatedFindingsOpen: false,
  isMatchingPatientOpen: false,
  isFormSelectorVisible: false,
  formName: "",
  formId: "",
  isIncomingForm: false,
  isWorkspaceOpen: false,
  emergencyPatientId: null,
  isEmergencyModalOpen: false,
  isConfirmationModalOpen: false,
  userSettings: {},
  appConfig: {},
  downloadExport: false,
  isExportReady: false,
  downloadProgress: 0,
  exportTimestamp: "",
  exportGenFailed: false,
  swiftModeEnabled: false,
  isRNTestBuild: false,
  RNSelectedEnv: "PROD",
  isRNEnvSelectorOpen: false,
  showExportUpdate: false,
  isRNAppStateChange: false,
  RNAppVersion: "",
  newPatientId: "",
  isNotificationSubscribing: false,
  showMobileStudySelector: false
}));

/***/ }),

/***/ 46065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80222);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48032);
/* harmony import */ var _servicesUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39949);
/* harmony import */ var _redirectToLogin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47472);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41065);
/* provided dependency */ var process = __webpack_require__(34155);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var TIMEOUT = 180000;
var MAX_RETRIES = 3;
var RETRY_DELAY = 1000;
var axiosConnect = axios__WEBPACK_IMPORTED_MODULE_2___default().create({
  baseURL: "https://platformapius-rsna.qure.ai",
  timeout: TIMEOUT,
  withCredentials: true // exposedHeaders: ["set-cookie"] // there is no such key called exposedHeaders in type AxiosRequestConfig

});
axiosConnect.interceptors.request.use( /*#__PURE__*/function () {
  var _interceptorFunc = (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(config) {
    var _cookies, _csrfToken, qXRProjectURLs, baseURL, url, params, isUserInfoCall, urlAuthToken;

    return _vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (config.method === "post" || config.method === "patch" || config.method === "put" || config.method === "delete") {
              _cookies = (0,___WEBPACK_IMPORTED_MODULE_5__/* .getCookies */ .$1)();
              _csrfToken = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(_cookies, ["csrftoken"], "");

              if (_csrfToken) {
                (0,lodash__WEBPACK_IMPORTED_MODULE_3__.set)(config, ["headers", _servicesUtils__WEBPACK_IMPORTED_MODULE_6__/* ["default"].X_CSRF */ .Z.X_CSRF], _csrfToken);
              }
            }

            qXRProjectURLs = ["/auth/", "/login/", "/logout/", "/csrf/"];

            if (config.url && qXRProjectURLs.indexOf(config.url) === -1) {
              (0,lodash__WEBPACK_IMPORTED_MODULE_3__.set)(config, ["url"], "".concat(config.url));
            }

            baseURL = config.baseURL, url = config.url, params = config.params;
            isUserInfoCall = (url === null || url === void 0 ? void 0 : url.includes("/userinfo")) || (url === null || url === void 0 ? void 0 : url.includes("/profile"));
            urlAuthToken = (0,___WEBPACK_IMPORTED_MODULE_5__/* .getUrlAuthToken */ .nm)();

            if (urlAuthToken && !isUserInfoCall && params) {
              params["url_auth_token"] = urlAuthToken;
            }

            if (!(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(baseURL)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", Promise.reject({
              noValidUrl: true
            }));

          case 9:
            return _context.abrupt("return", config);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function interceptorFunc(_x) {
    return _interceptorFunc.apply(this, arguments);
  }

  return interceptorFunc;
}());
axiosConnect.interceptors.response.use(function (response) {
  return Promise.resolve(response);
}, function (err) {
  var errorStatus = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(err, ["response", "status"]);
  var url = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(err, ["config", "url"], "");
  var config = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(err, "config", {});
  var isUserInfoCall = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(err, ["config", "url"], "").includes("/userinfo");
  var stopRedirectLogin = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.get)(err, ["config", "params", "stopRedirectLogin"], false);
  var isUrlAuthToken = !!(0,___WEBPACK_IMPORTED_MODULE_5__/* .getUrlAuthToken */ .nm)();
  var code = err.code,
      message = err.message; // if ([400, 403, 404, 500, 502, 503, 504].indexOf(errorStatus) !== -1) {
  //   // log 4xx, 5xx errors, not logging 401
  //   SentryIntegration.logError(err)
  // }

  if (code === "ECONNABORTED" || message.includes("timeout")) {
    var _maxRetries = config.maxRetries || MAX_RETRIES;

    var _retryCount = config.retryCount || 0;

    if (_retryCount < _maxRetries) {
      _retryCount++;
      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve(axiosConnect(_objectSpread(_objectSpread({}, config), {}, {
            retryCount: _retryCount
          })));
        }, config.retryDelay || RETRY_DELAY);
      });
    }
  }

  if (errorStatus === 401 && !stopRedirectLogin && window.location.pathname !== "/landing-page" && window.location.pathname !== "/notifications-widget" && !isUrlAuthToken) {
    var _redirectLogin = localStorage.getItem("redirectLogin");

    if (_redirectLogin) {
      localStorage.removeItem("redirectLogin");
      (0,_redirectToLogin__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    } else {
      var _window; // The original URL the user came from


      var _redirectURL = window.location.pathname;
      (_window = window) === null || _window === void 0 || (_window = _window.localStorage) === null || _window === void 0 ? void 0 : _window.setItem(_constants__WEBPACK_IMPORTED_MODULE_8__/* ["default"].PERSISTED.redirectAfterLogin */ .Z.PERSISTED.redirectAfterLogin, _redirectURL);
      window.location.href = window.location.origin + "/landing-page";
    }
  } else {
    /* eslint-disable no-console */
    console.error("Invalid request", err);

    if (process.env.NEXT_PUBLIC_APP_ENV === "production" && window.location.pathname !== "/landing-page") {
      var _error = new Error("XHR Error - ".concat(errorStatus), {
        cause: err
      });

      _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_4__/* .datadogRum.addError */ .v.addError(_error, {
        scope: "xhr-error",
        url: url
      });
    }
  }

  return Promise.reject(err);
});
/* harmony default export */ __webpack_exports__["Z"] = (axiosConnect);

/***/ }),

/***/ 41065:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var PAGE_SIZE = 10;
var GENDERS = [{
  id: 0,
  label: "Male",
  shortLabel: "M",
  value: 0
}, {
  id: 1,
  label: "Female",
  shortLabel: "F",
  value: 1
}, {
  id: 2,
  label: "Other",
  shortLabel: "O",
  value: 2
} // { id: 3, label: "NA", shortLabel: "", value: 3 },
];
var AI_INFERENCE = {
  WAITING_FOR_SCAN: 0,
  PROCESSING: 1,
  NEGATIVE: 2,
  POSITIVE: 3,
  URGENT: 4,
  REJECTED: -1,
  FAILED: -2,
  NA: -3
};
var STATUS_OPTIONS = [// { label: 'Waiting for scan', value: AI_INFERENCE.WAITING_FOR_SCAN },
{
  label: "PROCESSING",
  value: AI_INFERENCE.PROCESSING
}, {
  label: "Negative",
  value: AI_INFERENCE.NEGATIVE
}, {
  label: "Positive",
  value: AI_INFERENCE.POSITIVE
}, {
  label: "Critical",
  value: AI_INFERENCE.URGENT
}, {
  label: "Invalid Scan",
  value: AI_INFERENCE.REJECTED
}, {
  label: "Processing Error",
  value: AI_INFERENCE.FAILED
}, {
  label: "Not Available",
  value: AI_INFERENCE.NA
}];
var RN_COMM_CONST = {
  APP_READY: "APP_READY",
  FLUSH_COOKIES: "FLUSH_COOKIES",
  LOGIN: "LOGIN",
  SHARE: "SHARE",
  ENV_SELECTION: "ENV_SELECTION",
  REGION_URL: "REGION_URL",
  OPEN_APP_SETTINGS: "OPEN_APP_SETTINGS"
};
var SCREENS = {
  WORKLIST: "patients",
  VIEWER: "viewer"
};
var MEDIA_TYPES = {
  IMAGE: "IMAGE",
  DOCUMENT: "DOCUMENT",
  STUDY: "STUDY",
  REPORT: "REPORT",
  FORM: "FORM",
  AUDIO: "AUDIO"
};
var IMAGE_TYPES = ["jpg", "jpeg", "png", "webp"];
var DOC_TYPES = ["pdf", "msword", "doc", "docx", "xls", "xlsx"];
var AUDIO_TYPES = ["mp3", "mpga", "weba", "webm"];
var PLATFORMS = {
  ANDROID: 0,
  PWA: 1,
  IOS: 2
};
var FORMS = {
  STROKE_CLINICAL_INFO: "stroke_clinical",
  STROKE_NIHSS: "nihss",
  TB_SYMPTOMS: "symptoms",
  TB_LABTESTS: "tb_lab_test",
  TB_SPUTUM: "tb-sputum",
  TB_GENEXPERT: "tb-genexpert"
};
var NOTIFICATION_EVENTS = {
  NEW_PATIENT: 0,
  POSITIVE_FINDINGS: 2,
  NEGATIVE_FINDINGS: 3,
  REPORT_UPDATE: 4,
  STROKE_INITIATED: 5,
  PATIENT_SHARED: 7
};
var FORM_FIELDS = {
  DUAL_NUMBER: "dual_number",
  NUMBER: "number",
  MULTISELECT: "multiselect",
  CHECKBOX: "check_box",
  SINGLESELECT: "singleselect",
  DATETIME: "datetime",
  LKWT: "lkwt"
};
var DEEFAULT_FILTER = {
  isFilterApplied: false,
  data: null,
  label: ""
};
var DICOM_METADATA_TAGS = {
  SOPInstanceUID: "x00080018",
  SOPClassUID: "x00080016",
  StudyInstanceUID: "x0020000d",
  SeriesInstanceUID: "x0020000e",
  Modality: "x00080060",
  PatientID: "x00100020",
  AccessionNumber: "x00080050",
  PatientName: "x00100010",
  PatientGender: "x00100040",
  PatientAge: "x00101010",
  StudyDescription: "x00081030",
  SeriesDescription: "x0008103e",
  StudyDate: "x00080020"
};
var REQUIRED_DICOM_METADATA = ["SOPInstanceUID", "SOPClassUID", "SeriesInstanceUID", "StudyInstanceUID", "Modality", "PatientID"];
var REGION_LABELS = {
  global: "Global/Others",
  us: "United States",
  sg: "Singapore",
  uk: "United Kingdom",
  eu: "Europe",
  is: "India Stroke",
  beta2: "Beta 2"
};
var REGIONS = {
  us: "us-app.qure.ai",
  eu: "eu-app.qure.ai",
  sg: "sg-app.qure.ai",
  uk: "uk-app.qure.ai",
  is: "india-stroke.qure.ai",
  beta2: "beta2-app.qure.ai"
};
var PERSISTED = {
  isFullWidthWorklist: "isFullWidthWorklist",
  filterObj: "filterObj",
  savedFilterData: "savedFilterData",
  isDarkMode: "isDarkMode",
  isSwiftReportModeEnabled: "isSwiftReportModeEnabled",
  notificationPromptDismiss: "notificationPromptDismiss",
  fcmToken: "fcmToken",
  redirectAfterLogin: "redirectAfterLogin"
};
var DEFAULT_FILTER_NAME = {
  negativeCXR: "Review Negative CXR"
};
var MPPS_STATUS = {
  DISCONTINUED: "DISCONTINUED",
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN PROGRESS",
  REGISTERED: "REGISTERED"
};
var TERMS_OF_USE_VERSION = "2.0.0";
var UPLOAD_UI_STATE = {
  BROWSE_FILE: "BROWSE_FILE",
  CROP_FILE: "CROP_FILE",
  CROP_COMPLETE: "CROP_COMPLETE"
};
var UPLOAD_STATE = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  FAILED: "FAILED",
  FAILED_LOW_RES: "FAILED_LOW_RES"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  PAGE_SIZE: PAGE_SIZE,
  GENDERS: GENDERS,
  AI_INFERENCE: AI_INFERENCE,
  RN_COMM_CONST: RN_COMM_CONST,
  STATUS_OPTIONS: STATUS_OPTIONS,
  SCREENS: SCREENS,
  MEDIA_TYPES: MEDIA_TYPES,
  IMAGE_TYPES: IMAGE_TYPES,
  DOC_TYPES: DOC_TYPES,
  AUDIO_TYPES: AUDIO_TYPES,
  PLATFORMS: PLATFORMS,
  FORMS: FORMS,
  NOTIFICATION_EVENTS: NOTIFICATION_EVENTS,
  FORM_FIELDS: FORM_FIELDS,
  DEEFAULT_FILTER: DEEFAULT_FILTER,
  DICOM_METADATA_TAGS: DICOM_METADATA_TAGS,
  REQUIRED_DICOM_METADATA: REQUIRED_DICOM_METADATA,
  REGION_LABELS: REGION_LABELS,
  REGIONS: REGIONS,
  PERSISTED: PERSISTED,
  TERMS_OF_USE_VERSION: TERMS_OF_USE_VERSION,
  DEFAULT_FILTER_NAME: DEFAULT_FILTER_NAME,
  MPPS_STATUS: MPPS_STATUS,
  UPLOAD_UI_STATE: UPLOAD_UI_STATE,
  UPLOAD_STATE: UPLOAD_STATE
});

/***/ }),

/***/ 29950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48032);



var onDownloadApp = function onDownloadApp() {
  var userAgent = (0,___WEBPACK_IMPORTED_MODULE_1__/* .getUserAgent */ .ij)();

  var os = lodash__WEBPACK_IMPORTED_MODULE_0___default().get(userAgent, ["os", "name"], "").toLowerCase();

  if (os.includes("mac")) {
    window.open("https://qure-platform-artifacts.s3.ap-south-1.amazonaws.com/desktop/Qure.ai-3.1.16.dmg");
  }

  if (os.includes("win")) {
    window.open("https://qure-platform-artifacts.s3.ap-south-1.amazonaws.com/desktop/Qure.ai+Setup+3.1.16.exe");
  }

  if (os.includes("android")) {
    window.open("https://play.google.com/store/apps/details?id=app.qure.ai");
  }

  if (os.includes("ios")) {
    window.open("https://apps.apple.com/sg/app/qure-ai/id1631113024");
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (onDownloadApp);

/***/ }),

/***/ 48032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CQ": function() { return /* binding */ convertBufferToFile; },
  "Vo": function() { return /* binding */ generatePatientId; },
  "hq": function() { return /* binding */ getAppConfig; },
  "$1": function() { return /* binding */ getCookies; },
  "w9": function() { return /* binding */ getCurrentRegion; },
  "Ev": function() { return /* binding */ getFCMToken; },
  "mD": function() { return /* binding */ getFileExtension; },
  "L0": function() { return /* binding */ getFormattedDate; },
  "IF": function() { return /* binding */ getGender; },
  "M7": function() { return /* binding */ getIsLoggedIn; },
  "V4": function() { return /* binding */ getMediaType; },
  "Jt": function() { return /* binding */ getNameInitials; },
  "Xf": function() { return /* binding */ getPlatform; },
  "nm": function() { return /* binding */ getUrlAuthToken; },
  "ij": function() { return /* binding */ getUserAgent; },
  "nS": function() { return /* binding */ getUserSettings; },
  "zd": function() { return /* binding */ isAndroidWebView; },
  "Ad": function() { return /* binding */ isIOSWebView; },
  "to": function() { return /* binding */ isNonDicomFile; },
  "qb": function() { return /* binding */ isValidDate; },
  "vV": function() { return /* binding */ isValidEmail; },
  "vp": function() { return /* binding */ isWebView; },
  "ro": function() { return /* binding */ truncateMiddle; }
});

// UNUSED EXPORTS: convertMarkdownToHtml, isDemoSource, isDevEnv

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(42238);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/showdown/dist/showdown.js
var dist_showdown = __webpack_require__(53787);
// EXTERNAL MODULE: ./node_modules/mime-types/index.js
var mime_types = __webpack_require__(80983);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./utils/Store.ts
var Store = __webpack_require__(54837);
// EXTERNAL MODULE: ./utils/servicesUtils.ts
var servicesUtils = __webpack_require__(39949);
// EXTERNAL MODULE: ./node_modules/@firebase/installations/dist/esm/index.esm2017.js + 2 modules
var index_esm2017 = __webpack_require__(66292);
// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(8463);
;// CONCATENATED MODULE: ./node_modules/@firebase/messaging/node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ./node_modules/@firebase/messaging/node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction));
        });
    }
    if (blocked)
        request.addEventListener('blocked', () => blocked());
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking)
            db.addEventListener('versionchange', () => blocking());
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked)
        request.addEventListener('blocked', () => blocked());
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(74444);
// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js + 2 modules
var dist_esm_index_esm2017 = __webpack_require__(25816);
;// CONCATENATED MODULE: ./node_modules/@firebase/messaging/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
const DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
const DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
const CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
const CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
const CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */
const CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
var MessageType$1;
(function (MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})(MessageType$1 || (MessageType$1 = {}));

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var MessageType;
(function (MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64ToArray(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */
const OLD_DB_VERSION = 5;
const OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function migrateOldDatabase(senderId) {
    if ('databases' in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map(db => db.name);
        if (!dbNames.includes(OLD_DB_NAME)) {
            // old DB didn't exist, no need to open.
            return null;
        }
    }
    let tokenDetails = null;
    const db = await openDB(OLD_DB_NAME, OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction) => {
            var _a;
            if (oldVersion < 2) {
                // Database too old, skip migration.
                return;
            }
            if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
                // Database did not exist. Nothing to do.
                return;
            }
            const objectStore = upgradeTransaction.objectStore(OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index('fcmSenderId').get(senderId);
            await objectStore.clear();
            if (!value) {
                // No entry in the database, nothing to migrate.
                return;
            }
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
                    return;
                }
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === 'string'
                            ? oldDetails.vapidKey
                            : arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
            else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
            else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await deleteDB(OLD_DB_NAME);
    await deleteDB('fcm_vapid_details_db');
    await deleteDB('undefined');
    return checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) {
        return false;
    }
    const { subscriptionOptions } = tokenDetails;
    return (typeof tokenDetails.createTime === 'number' &&
        tokenDetails.createTime > 0 &&
        typeof tokenDetails.token === 'string' &&
        tokenDetails.token.length > 0 &&
        typeof subscriptionOptions.auth === 'string' &&
        subscriptionOptions.auth.length > 0 &&
        typeof subscriptionOptions.p256dh === 'string' &&
        subscriptionOptions.p256dh.length > 0 &&
        typeof subscriptionOptions.endpoint === 'string' &&
        subscriptionOptions.endpoint.length > 0 &&
        typeof subscriptionOptions.swScope === 'string' &&
        subscriptionOptions.swScope.length > 0 &&
        typeof subscriptionOptions.vapidKey === 'string' &&
        subscriptionOptions.vapidKey.length > 0);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Exported for tests.
const DATABASE_NAME = 'firebase-messaging-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-messaging-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
            upgrade: (upgradeDb, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
                // because if there are multiple versions between the old version and the current version, we
                // want ALL the migrations that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        upgradeDb.createObjectStore(OBJECT_STORE_NAME);
                }
            }
        });
    }
    return dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */
async function dbGet(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tokenDetails = (await db
        .transaction(OBJECT_STORE_NAME)
        .objectStore(OBJECT_STORE_NAME)
        .get(key));
    if (tokenDetails) {
        return tokenDetails;
    }
    else {
        // Check if there is a tokenDetails object in the old DB.
        const oldTokenDetails = await migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
/** Assigns or overwrites the record for the given key with the given value. */
async function dbSet(firebaseDependencies, tokenDetails) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */
async function dbRemove(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function getKey({ appConfig }) {
    return appConfig.appId;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */]: 'This method is available in a Window context.',
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */]: 'This method is available in a service worker context.',
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */]: 'The notification permission was not granted and dismissed instead.',
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */]: 'The notification permission was not granted and blocked instead.',
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */]: 'We are unable to register the default service worker. {$browserErrorMessage}',
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */]: 'FCM returned no token when subscribing the user to push.',
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */]: 'A problem occurred while unsubscribing the ' +
        'user from FCM: {$errorInfo}',
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */]: 'FCM returned no token when updating the user to push.',
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */]: 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.',
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */]: 'The input to setBackgroundMessageHandler() must be a function.',
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */]: 'The public VAPID key must be a string.',
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */]: 'The usePublicVapidKey() method may only be called once and must be ' +
        'called before calling getToken() to ensure your VAPID key is used.'
};
const ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL('messaging', 'Messaging', ERROR_MAP);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await getHeaders(firebaseDependencies);
    const body = getBody(subscriptionOptions);
    const subscribeOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    }
    catch (err) {
        throw ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */, {
            errorInfo: message
        });
    }
    if (!responseData.token) {
        throw ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */);
    }
    return responseData.token;
}
async function requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await getHeaders(firebaseDependencies);
    const body = getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: 'PATCH',
        headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    }
    catch (err) {
        throw ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */, {
            errorInfo: message
        });
    }
    if (!responseData.token) {
        throw ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */);
    }
    return responseData.token;
}
async function requestDeleteToken(firebaseDependencies, token) {
    const headers = await getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: 'DELETE',
        headers
    };
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
                errorInfo: message
            });
        }
    }
    catch (err) {
        throw ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */, {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function getEndpoint({ projectId }) {
    return `${ENDPOINT}/projects/${projectId}/registrations`;
}
async function getHeaders({ appConfig, installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': appConfig.apiKey,
        'x-goog-firebase-installations-auth': `FIS ${authToken}`
    });
}
function getBody({ p256dh, auth, endpoint, vapidKey }) {
    const body = {
        web: {
            endpoint,
            auth,
            p256dh
        }
    };
    if (vapidKey !== DEFAULT_VAPID_KEY) {
        body.web.applicationPubKey = vapidKey;
    }
    return body;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// UpdateRegistration will be called once every week.
const TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
async function getTokenInternal(messaging) {
    const pushSubscription = await getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: arrayToBase64(pushSubscription.getKey('auth')),
        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
    };
    const tokenDetails = await dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) {
        // No token, get a new one.
        return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    }
    else if (!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        }
        catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    }
    else if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
        // Weekly token refresh
        return updateToken(messaging, {
            token: tokenDetails.token,
            createTime: Date.now(),
            subscriptionOptions
        });
    }
    else {
        // Valid token, nothing to do.
        return tokenDetails.token;
    }
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */
async function deleteTokenInternal(messaging) {
    const tokenDetails = await dbGet(messaging.firebaseDependencies);
    if (tokenDetails) {
        await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        await dbRemove(messaging.firebaseDependencies);
    }
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) {
        return pushSubscription.unsubscribe();
    }
    // If there's no SW, consider it a success.
    return true;
}
async function updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), { token: updatedToken, createTime: Date.now() });
        await dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    }
    catch (e) {
        await deleteTokenInternal(messaging);
        throw e;
    }
}
async function getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token,
        createTime: Date.now(),
        subscriptionOptions
    };
    await dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */
async function getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) {
        return subscription;
    }
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */
function isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    propagateNotificationPayload(payload, internalPayload);
    propagateDataPayload(payload, internalPayload);
    propagateFcmOptions(payload, internalPayload);
    return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) {
        return;
    }
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) {
        payload.notification.title = title;
    }
    const body = messagePayloadInternal.notification.body;
    if (!!body) {
        payload.notification.body = body;
    }
    const image = messagePayloadInternal.notification.image;
    if (!!image) {
        payload.notification.image = image;
    }
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) {
        payload.notification.icon = icon;
    }
}
function propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) {
        return;
    }
    payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
    var _a, _b, _c, _d, _e;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions &&
        !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) {
        return;
    }
    payload.fcmOptions = {};
    const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link) {
        payload.fcmOptions.link = link;
    }
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) {
        payload.fcmOptions.analyticsLabel = analyticsLabel;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
_mergeStrings('hts/frbslgigp.ogepscmv/ieo/eaylg', 'tp:/ieaeogn-agolai.o/1frlglgc/o');
_mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
function _mergeStrings(s1, s2) {
    const resultArray = [];
    for (let i = 0; i < s1.length; i++) {
        resultArray.push(s1.charAt(i));
        if (i < s2.length) {
            resultArray.push(s2.charAt(i));
        }
    }
    return resultArray.join('');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration Object');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    const { options } = app;
    for (const keyName of configKeys) {
        if (!options[keyName]) {
            throw getMissingValueError(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MessagingService {
    constructor(app, installations, analyticsProvider) {
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = extractAppConfig(app);
        this.firebaseDependencies = {
            app,
            appConfig,
            installations,
            analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(() => {
            /* it is non blocking and we don't care if it failed */
        });
    }
    catch (e) {
        throw ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */, {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) {
        await registerDefaultSw(messaging);
    }
    if (!swRegistration && !!messaging.swRegistration) {
        return;
    }
    if (!(swRegistration instanceof ServiceWorkerRegistration)) {
        throw ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */);
    }
    messaging.swRegistration = swRegistration;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) {
        messaging.vapidKey = vapidKey;
    }
    else if (!messaging.vapidKey) {
        messaging.vapidKey = DEFAULT_VAPID_KEY;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getToken$1(messaging, options) {
    if (!navigator) {
        throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
    }
    if (Notification.permission === 'default') {
        await Notification.requestPermission();
    }
    if (Notification.permission !== 'granted') {
        throw ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */);
    }
    await updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return getTokenInternal(messaging);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function logToScion(messaging, messageType, data) {
    const eventType = getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */
        message_id: data[CONSOLE_CAMPAIGN_ID],
        message_name: data[CONSOLE_CAMPAIGN_NAME],
        message_time: data[CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
        /* eslint-enable camelcase */
    });
}
function getEventType(messageType) {
    switch (messageType) {
        case MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) {
        return;
    }
    if (messaging.onMessageHandler &&
        internalPayload.messageType === MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === 'function') {
            messaging.onMessageHandler(externalizePayload(internalPayload));
        }
        else {
            messaging.onMessageHandler.next(externalizePayload(internalPayload));
        }
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if (isConsoleMessage(dataPayload) &&
        dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1') {
        await logToScion(messaging, internalPayload.messageType, dataPayload);
    }
}

const index_esm2017_name = "@firebase/messaging";
const version = "0.12.4";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WindowMessagingFactory = (container) => {
    const messaging = new MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
    navigator.serviceWorker.addEventListener('message', e => messageEventListener(messaging, e));
    return messaging;
};
const WindowMessagingInternalFactory = (container) => {
    const messaging = container
        .getProvider('messaging')
        .getImmediate();
    const messagingInternal = {
        getToken: (options) => getToken$1(messaging, options)
    };
    return messagingInternal;
};
function registerMessagingInWindow() {
    (0,dist_esm_index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA('messaging', WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    (0,dist_esm_index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA('messaging-internal', WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
    (0,dist_esm_index_esm2017/* registerVersion */.KN)(index_esm2017_name, version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0,dist_esm_index_esm2017/* registerVersion */.KN)(index_esm2017_name, version, 'esm2017');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */
async function isWindowSupported() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0,dist_index_esm2017/* validateIndexedDBOpenable */.eu)();
    }
    catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return (typeof window !== 'undefined' &&
        (0,dist_index_esm2017/* isIndexedDBAvailable */.hl)() &&
        (0,dist_index_esm2017/* areCookiesEnabled */.zI)() &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteToken$1(messaging) {
    if (!navigator) {
        throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
    }
    if (!messaging.swRegistration) {
        await registerDefaultSw(messaging);
    }
    return deleteTokenInternal(messaging);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function onMessage$1(messaging, nextOrObserver) {
    if (!navigator) {
        throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */);
    }
    messaging.onMessageHandler = nextOrObserver;
    return () => {
        messaging.onMessageHandler = null;
    };
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */
function getMessagingInWindow(app = (0,dist_esm_index_esm2017/* getApp */.Mq)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    isWindowSupported().then(isSupported => {
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) {
            throw ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */);
        }
    }, _ => {
        // If `isWindowSupported()` rejected.
        throw ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */);
    });
    return (0,dist_esm_index_esm2017/* _getProvider */.qX)((0,dist_index_esm2017/* getModularInstance */.m9)(app), 'messaging').getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns an Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If a notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optinoal service worker registration
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */
async function getToken(messaging, options) {
    messaging = (0,dist_index_esm2017/* getModularInstance */.m9)(messaging);
    return getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @public
 */
function deleteToken(messaging) {
    messaging = getModularInstance(messaging);
    return deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */
function onMessage(messaging, nextOrObserver) {
    messaging = getModularInstance(messaging);
    return onMessage$1(messaging, nextOrObserver);
}

/**
 * Firebase Cloud Messaging
 *
 * @packageDocumentation
 */
registerMessagingInWindow();


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/messaging/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./utils/index.ts













var getGender = function getGender(value) {
  return constants/* default.GENDERS.find */.Z.GENDERS.find(function (g) {
    return g.value == value;
  });
};
var getUserAgent = function getUserAgent(providedUserAgent) {
  var parser = new (ua_parser_default())(providedUserAgent);
  return parser.getResult();
};
var isAndroidWebView = function isAndroidWebView() {
  var userAgent = getUserAgent();
  var isAndroidOS = userAgent.os.name === "Android";
  var hasVersion = userAgent.ua.toLowerCase().includes("version");
  return isAndroidOS && hasVersion;
};
var isIOSWebView = function isIOSWebView() {
  var _userAgent$browser$na;

  var userAgent = getUserAgent();
  var hasSupportedModel = userAgent.device.vendor === "Apple" && (userAgent.device.model === "iPhone" || userAgent.device.model === "iPod" || userAgent.device.model === "iPad");
  var hasSupportedEngine = userAgent.engine.name === "WebKit";
  var isNotBrowser = !((_userAgent$browser$na = userAgent.browser.name) !== null && _userAgent$browser$na !== void 0 && _userAgent$browser$na.includes("Safari"));
  return hasSupportedModel && hasSupportedEngine && isNotBrowser;
};
var isWebView = function isWebView() {
  return isAndroidWebView() || isIOSWebView();
};
var getCurrentRegion = function getCurrentRegion() {
  var regionIndex = Object.values(constants/* default.REGIONS */.Z.REGIONS).findIndex(function (url) {
    var _window;

    return url === ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host);
  });
  return (0,lodash.get)(Object.keys(constants/* default.REGIONS */.Z.REGIONS), [regionIndex], "global");
};
var getPlatform = function getPlatform() {
  if (isAndroidWebView()) {
    return constants/* default.PLATFORMS.ANDROID */.Z.PLATFORMS.ANDROID;
  }

  if (isIOSWebView()) {
    return constants/* default.PLATFORMS.IOS */.Z.PLATFORMS.IOS;
  }

  return constants/* default.PLATFORMS.PWA */.Z.PLATFORMS.PWA;
};
var isValidDate = function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
};
var getFormattedDate = function getFormattedDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "E PP hh:mm a";
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "NA";
  var dateVal = new Date(date);
  return date && isValidDate(dateVal) ? (0,format["default"])(dateVal, dateFormat) : defaultValue;
};
var truncateMiddle = function truncateMiddle(fullStr, strLen, separatorParam) {
  if ((0,lodash.isEmpty)(fullStr) || fullStr.length <= strLen) {
    return fullStr;
  }

  var separator = separatorParam || "...";
  var sepLen = separator.length;
  var charsToShow = strLen - sepLen;
  var frontChars = Math.ceil(charsToShow / 2);
  var backChars = Math.floor(charsToShow / 2);
  return fullStr.substr(0, frontChars) + separator + fullStr.substr(fullStr.length - backChars);
};
var getNameInitials = function getNameInitials(name) {
  if (!!name) {
    var _nameSplit = name.split(/\s+|_|(?=[A-Z])/);

    var _first = (0,lodash.get)(_nameSplit, [0, 0], "");

    var _last = (0,lodash.get)(_nameSplit, [1, 0], "");

    return "".concat(_first.toUpperCase()).concat(_last.toUpperCase());
  }

  return "-";
};
var convertMarkdownToHtml = function convertMarkdownToHtml(markdownString) {
  var converter = new showdown.Converter({
    simpleLineBreaks: true,
    underline: true,
    tables: true
  });
  markdownString = markdownString.replaceAll("\n", "<br />");
  var htmlString = converter.makeHtml(markdownString);
  return htmlString;
};
var isDevEnv = function isDevEnv() {
  return false;
};
var getUrlAuthToken = function getUrlAuthToken() {
  var _window2;

  var params = query_string.parse((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.search);
  return (0,lodash.get)(params, ["url_auth_token"], "");
};
var getIsLoggedIn = function getIsLoggedIn() {
  return !(0,lodash.isEmpty)(Store/* default.useState */.Z.useState(function (store) {
    return store.user;
  }));
};
var getMediaType = function getMediaType(mimeType, studyUid, reportUid, formResponseUid) {
  var images = constants/* default.IMAGE_TYPES */.Z.IMAGE_TYPES;
  var docs = constants/* default.DOC_TYPES */.Z.DOC_TYPES;
  var audios = constants/* default.AUDIO_TYPES */.Z.AUDIO_TYPES;
  var extension = mime_types.extension(mimeType);

  if (typeof extension === "string" && images.includes(extension)) {
    return {
      type: constants/* default.MEDIA_TYPES.IMAGE */.Z.MEDIA_TYPES.IMAGE,
      extension: extension
    };
  } else if (typeof extension === "string" && docs.includes(extension)) {
    return {
      type: constants/* default.MEDIA_TYPES.DOCUMENT */.Z.MEDIA_TYPES.DOCUMENT,
      extension: extension
    };
  } else if (typeof extension === "string" && audios.includes(extension)) {
    return {
      type: constants/* default.MEDIA_TYPES.AUDIO */.Z.MEDIA_TYPES.AUDIO,
      extension: extension
    };
  } else if (!!studyUid) {
    return {
      type: constants/* default.MEDIA_TYPES.STUDY */.Z.MEDIA_TYPES.STUDY,
      extension: ""
    };
  } else if (!!reportUid) {
    return {
      type: constants/* default.MEDIA_TYPES.REPORT */.Z.MEDIA_TYPES.REPORT,
      extension: ""
    };
  } else if (!!formResponseUid) {
    return {
      type: constants/* default.MEDIA_TYPES.FORM */.Z.MEDIA_TYPES.FORM,
      extension: ""
    };
  }

  return {
    type: "",
    extension: ""
  };
};
var isNonDicomFile = function isNonDicomFile(fileType) {
  var fileTypes = ["png", "jpg", "jpeg"];
  return fileTypes.some(function (type) {
    return fileType.toLowerCase().includes(type);
  });
};
var isValidEmail = function isValidEmail(text) {
  return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(text);
};
var DEMO_SOURCE_ID = (/* unused pure expression or super */ null && (["demo@qure.ai", "demo.qure.ai"]));
var isDemoSource = function isDemoSource(sourceId) {
  return DEMO_SOURCE_ID.includes(sourceId);
};
var getUserSettings = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var settingsData;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return servicesUtils/* default.getService */.Z.getService("/settings/");

          case 2:
            settingsData = _context.sent;
            Store/* default.update */.Z.update(function (store) {
              // eslint-disable-next-line no-param-reassign
              store.userSettings = settingsData && settingsData.settings ? settingsData : {};
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUserSettings() {
    return _ref.apply(this, arguments);
  };
}();
var getAppConfig = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var configData;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return servicesUtils/* default.getService */.Z.getService("/configs/");

          case 2:
            configData = _context2.sent;
            Store/* default.update */.Z.update(function (store) {
              // eslint-disable-next-line no-param-reassign
              store.appConfig = configData || {};
            });
            return _context2.abrupt("return", configData);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAppConfig() {
    return _ref2.apply(this, arguments);
  };
}();
var convertBufferToFile = function convertBufferToFile(arrayBuffer, fileName) {
  var blob = new Blob([arrayBuffer], {
    type: "application/octet-stream"
  });
  return new File([blob], fileName ? fileName : "anonymous", {
    type: "application/octet-stream"
  });
};
var getFileExtension = function getFileExtension(path) {
  var splitArr = path.split(".");
  return (0,lodash.get)(splitArr, [splitArr.length - 1], "").toLocaleLowerCase();
};
var getCookies = function getCookies() {
  var _cookies = document.cookie.split("; ");

  var allCookies = {};

  _cookies.forEach(function (cookie) {
    var _cookie$split = cookie.split("="),
        _cookie$split2 = (0,slicedToArray/* default */.Z)(_cookie$split, 2),
        key = _cookie$split2[0],
        val = _cookie$split2[1];

    (0,lodash.set)(allCookies, [key], val);
  });

  return allCookies;
};
var generatePatientId = function generatePatientId() {
  return Math.random().toString(36).slice(2).toUpperCase();
};
var getFCMToken = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getToken(getMessagingInWindow(), {
              vapidKey: "BDeSWo_BSmbHxKgxdELBSz612Pyc4LJlBr_pLtq4oVpVCJNz7YOSnKk1O5eaOW-Rkw-gSlWesZxhlo-pa4Uxtrg"
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getFCMToken() {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 80271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wo": function() { return /* binding */ subscribeUserNotification; },
/* harmony export */   "rt": function() { return /* binding */ unRegisterSubscription; }
/* harmony export */ });
/* unused harmony export registerSubscription */
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10921);
/* harmony import */ var _servicesUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39949);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48032);
/* harmony import */ var _Store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54837);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41065);
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36609);








var registerSubscription = function registerSubscription(token) {
  var params = {
    token: token,
    platform: (0,___WEBPACK_IMPORTED_MODULE_3__/* .getPlatform */ .Xf)()
  };
  return _servicesUtils__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postService */ .Z.postService("/subscription/", params).then(function () {
    return true;
  })["catch"](function () {
    _components_Toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error((0,i18next__WEBPACK_IMPORTED_MODULE_6__.t)("unable_to_subscribe"));
    return false;
  });
};
var unRegisterSubscription = function unRegisterSubscription(token) {
  var params = {
    token: token
  };
  return _servicesUtils__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postService */ .Z.postService("/subscription/delete/", params);
};
var subscribeUserNotification = /*#__PURE__*/function () {
  var _ref = (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(RNFcmToken) {
    var _token, _window, _status, _window2, _old_fcmToken, _window3, _isSuccess, _window4;

    return _vercel_path1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _token = RNFcmToken || null;

            if (!(!_token && !(0,___WEBPACK_IMPORTED_MODULE_3__/* .isAndroidWebView */ .zd)() && !(0,___WEBPACK_IMPORTED_MODULE_3__/* .isIOSWebView */ .Ad)())) {
              _context.next = 13;
              break;
            }

            _context.next = 5;
            return (_window = window) === null || _window === void 0 || (_window = _window.Notification) === null || _window === void 0 ? void 0 : _window.requestPermission();

          case 5:
            _status = _context.sent;

            if (!(_status && _status === "granted")) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return (0,___WEBPACK_IMPORTED_MODULE_3__/* .getFCMToken */ .Ev)();

          case 9:
            _token = _context.sent;
            _context.next = 13;
            break;

          case 12:
            if (_status && _status === "denied") {
              _components_Toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"].warning */ .Z.warning((0,i18next__WEBPACK_IMPORTED_MODULE_6__.t)("allow_browser_permission"));
            }

          case 13:
            if (!_token) {
              _context.next = 22;
              break;
            }

            _old_fcmToken = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].PERSISTED.fcmToken */ .Z.PERSISTED.fcmToken);

            if (_old_fcmToken && _token != _old_fcmToken) {
              unRegisterSubscription(_old_fcmToken);
              (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].PERSISTED.fcmToken */ .Z.PERSISTED.fcmToken);
            }

            _context.next = 18;
            return registerSubscription(_token);

          case 18:
            _isSuccess = _context.sent;

            if (_isSuccess) {
              (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"].PERSISTED.fcmToken */ .Z.PERSISTED.fcmToken, _token);
            }

            if (_isSuccess && !RNFcmToken) {
              _Store__WEBPACK_IMPORTED_MODULE_4__/* ["default"].update */ .Z.update(function (s) {
                s.fcmToken = _token;
              });
            }

            return _context.abrupt("return", _isSuccess);

          case 22:
            return _context.abrupt("return", null);

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", null);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 25]]);
  }));

  return function subscribeUserNotification(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 47472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48032);
/* harmony import */ var _LoggedInToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71507);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41065);




var redirectToLogin = function redirectToLogin() {
  /* eslint-disable no-console */
  console.info("Redirecting to login page.");
  var urlAuthToken = (0,___WEBPACK_IMPORTED_MODULE_0__/* .getUrlAuthToken */ .nm)();

  if (urlAuthToken) {
    var _window;

    (_window = window) === null || _window === void 0 || (_window = _window.localStorage) === null || _window === void 0 ? void 0 : _window.setItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PERSISTED.redirectAfterLogin */ .Z.PERSISTED.redirectAfterLogin, window.location.href);
  }

  var next = "".concat(window.location.origin, "/open-app/");
  var apiUrl = "https://platformapius-rsna.qure.ai";
  var loginURL = "".concat(apiUrl, "/accounts/login/?next=").concat(next);
  _LoggedInToken__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setLogInPorgress */ .Z.setLogInPorgress();

  if (window.ReactNativeWebView) {
    var _window2; // react native app


    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.ReactNativeWebView) === null || _window2 === void 0 ? void 0 : _window2.postMessage(JSON.stringify({
      event: _constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].RN_COMM_CONST.LOGIN */ .Z.RN_COMM_CONST.LOGIN,
      data: loginURL
    }));
  } else if (window.electronAPI) {
    // electron app
    window.open(loginURL);
  } else {
    window.location.href = loginURL;
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (redirectToLogin);

/***/ }),

/***/ 39949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _axiosConnect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46065);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_vercel_path1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var X_CSRF = "x-csrftoken"; // simple wrapper around axios connect for simple fetch requests
// you will need to handle the errors from catch

function getService(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var paramsSerializer = arguments.length > 2 ? arguments[2] : undefined;
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20000;
  var options = arguments.length > 4 ? arguments[4] : undefined;
  return _axiosConnect__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(url, _objectSpread({
    params: params,
    paramsSerializer: paramsSerializer,
    timeout: timeout
  }, options)).then(function (response) {
    return response.data;
  });
}

function postService(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _axiosConnect__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post(url, params).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
}

function patchService(url, body) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _axiosConnect__WEBPACK_IMPORTED_MODULE_1__/* ["default"].patch */ .Z.patch(url, body, {
    params: params
  }).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}

function putService(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _axiosConnect__WEBPACK_IMPORTED_MODULE_1__/* ["default"].put */ .Z.put(url, params).then(function (_ref3) {
    var data = _ref3.data;
    return data;
  });
}

function deleteService(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _axiosConnect__WEBPACK_IMPORTED_MODULE_1__/* ["default"]["delete"] */ .Z["delete"](url, params).then(function (_ref4) {
    var data = _ref4.data;
    return data;
  });
}

/* harmony default export */ __webpack_exports__["Z"] = ({
  getService: getService,
  postService: postService,
  patchService: patchService,
  putService: putService,
  deleteService: deleteService,
  X_CSRF: X_CSRF
});

/***/ }),

/***/ 44019:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 78566:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _defineProperty = __webpack_require__(930);

var _slicedToArray = __webpack_require__(85696);

var _toConsumableArray = __webpack_require__(7980);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Image;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _head = _interop_require_default(__webpack_require__(72717));

var _imageConfig = __webpack_require__(48187);

var _useIntersection = __webpack_require__(90639);

var _imageConfigContext = __webpack_require__(89239);

var _utils = __webpack_require__(99475);

var _normalizeTrailingSlash = __webpack_require__(24969);

function Image(_param) {
  var _linkProps;

  var src = _param.src,
      sizes = _param.sizes,
      _param$unoptimized = _param.unoptimized,
      unoptimized = _param$unoptimized === void 0 ? false : _param$unoptimized,
      _param$priority = _param.priority,
      priority = _param$priority === void 0 ? false : _param$priority,
      loading = _param.loading,
      _param$lazyRoot = _param.lazyRoot,
      lazyRoot = _param$lazyRoot === void 0 ? null : _param$lazyRoot,
      lazyBoundary = _param.lazyBoundary,
      className = _param.className,
      quality = _param.quality,
      width = _param.width,
      height = _param.height,
      style = _param.style,
      objectFit = _param.objectFit,
      objectPosition = _param.objectPosition,
      onLoadingComplete = _param.onLoadingComplete,
      _param$placeholder = _param.placeholder,
      placeholder = _param$placeholder === void 0 ? 'empty' : _param$placeholder,
      blurDataURL = _param.blurDataURL,
      all = _object_without_properties_loose(_param, ["src", "sizes", "unoptimized", "priority", "loading", "lazyRoot", "lazyBoundary", "className", "quality", "width", "height", "style", "objectFit", "objectPosition", "onLoadingComplete", "placeholder", "blurDataURL"]);

  var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
  var config = (0, _react).useMemo(function () {
    var c = configEnv || configContext || _imageConfig.imageConfigDefault;
    var allSizes = [].concat(_toConsumableArray(c.deviceSizes), _toConsumableArray(c.imageSizes)).sort(function (a, b) {
      return a - b;
    });
    var deviceSizes = c.deviceSizes.sort(function (a, b) {
      return a - b;
    });
    return _extends({}, c, {
      allSizes: allSizes,
      deviceSizes: deviceSizes
    });
  }, [configContext]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';

  if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread on <img>:

    delete rest.layout;
  }

  var loader = defaultImageLoader;

  if ('loader' in rest) {
    if (rest.loader) {
      var customImageLoader = rest.loader;

      var _tmp;

      _tmp = function _tmp(obj) {
        var _ = obj.config,
            opts = _object_without_properties_loose(obj, ["config"]); // The config object is internal only so we must
        // not pass it to the user-defined loader()


        return customImageLoader(opts);
      }, loader = _tmp, _tmp;
    } // Remove property so it's not spread on <img>


    delete rest.loader;
  }

  var staticSrc = '';

  if (isStaticImport(src)) {
    var staticImageData = isStaticRequire(src) ? src["default"] : src;

    if (!staticImageData.src) {
      throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
    }

    blurDataURL = blurDataURL || staticImageData.blurDataURL;
    staticSrc = staticImageData.src;

    if (!layout || layout !== 'fill') {
      height = height || staticImageData.height;
      width = width || staticImageData.width;

      if (!staticImageData.height || !staticImageData.width) {
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
      }
    }
  }

  src = typeof src === 'string' ? src : staticSrc;
  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src.startsWith('data:') || src.startsWith('blob:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  if ( true && loadedImageURLs.has(src)) {
    isLazy = false;
  }

  if (config.unoptimized) {
    unoptimized = true;
  }

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      blurComplete = _useState2[0],
      setBlurComplete = _useState2[1];

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootRef: lazyRoot,
    rootMargin: lazyBoundary || '200px',
    disabled: !isLazy
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersection = _useIntersection3[0],
      isIntersected = _useIntersection3[1],
      resetIntersected = _useIntersection3[2];

  var isVisible = !isLazy || isIntersected;
  var wrapperStyle = {
    boxSizing: 'border-box',
    display: 'block',
    overflow: 'hidden',
    width: 'initial',
    height: 'initial',
    background: 'none',
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var sizerStyle = {
    boxSizing: 'border-box',
    display: 'block',
    width: 'initial',
    height: 'initial',
    background: 'none',
    opacity: 1,
    border: 0,
    margin: 0,
    padding: 0
  };
  var hasSizer = false;
  var sizerSvgUrl;
  var layoutStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);

  if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }

  var imgStyle = Object.assign({}, style, layoutStyle);
  var blurStyle = placeholder === 'blur' && !blurComplete ? {
    backgroundSize: objectFit || 'cover',
    backgroundPosition: objectPosition || '0% 0%',
    filter: 'blur(20px)',
    backgroundImage: "url(\"".concat(blurDataURL, "\")")
  } : {};

  if (layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle.display = 'block';
    wrapperStyle.position = 'absolute';
    wrapperStyle.top = 0;
    wrapperStyle.left = 0;
    wrapperStyle.bottom = 0;
    wrapperStyle.right = 0;
  } else if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle.display = 'block';
      wrapperStyle.position = 'relative';
      hasSizer = true;
      sizerStyle.paddingTop = paddingTop;
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle.display = 'inline-block';
      wrapperStyle.position = 'relative';
      wrapperStyle.maxWidth = '100%';
      hasSizer = true;
      sizerStyle.maxWidth = '100%';
      sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle.display = 'inline-block';
      wrapperStyle.position = 'relative';
      wrapperStyle.width = widthInt;
      wrapperStyle.height = heightInt;
    }
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: emptyDataURL,
    srcSet: undefined,
    sizes: undefined
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      config: config,
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes,
      loader: loader
    });
  }

  var srcString = src;

  if (false) { var fullUrl; }

  var imageSrcSetPropName = 'imagesrcset';
  var imageSizesPropName = 'imagesizes';

  if (true) {
    imageSrcSetPropName = 'imageSrcSet';
    imageSizesPropName = 'imageSizes';
  }

  var linkProps = (_linkProps = {}, _defineProperty(_linkProps, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_linkProps, imageSizesPropName, imgAttributes.sizes), _defineProperty(_linkProps, "crossOrigin", rest.crossOrigin), _linkProps);
  var useLayoutEffect =  false ? 0 : _react["default"].useLayoutEffect;
  var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
  var previousImageSrc = (0, _react).useRef(src);
  (0, _react).useEffect(function () {
    onLoadingCompleteRef.current = onLoadingComplete;
  }, [onLoadingComplete]);
  useLayoutEffect(function () {
    if (previousImageSrc.current !== src) {
      resetIntersected();
      previousImageSrc.current = src;
    }
  }, [resetIntersected, src]);

  var imgElementArgs = _extends({
    isLazy: isLazy,
    imgAttributes: imgAttributes,
    heightInt: heightInt,
    widthInt: widthInt,
    qualityInt: qualityInt,
    layout: layout,
    className: className,
    imgStyle: imgStyle,
    blurStyle: blurStyle,
    loading: loading,
    config: config,
    unoptimized: unoptimized,
    placeholder: placeholder,
    loader: loader,
    srcString: srcString,
    onLoadingCompleteRef: onLoadingCompleteRef,
    setBlurComplete: setBlurComplete,
    setIntersection: setIntersection,
    isVisible: isVisible,
    noscriptSizes: sizes
  }, rest);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: wrapperStyle
  }, hasSizer ? /*#__PURE__*/_react["default"].createElement("span", {
    style: sizerStyle
  }, sizerSvgUrl ? /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      display: 'block',
      maxWidth: '100%',
      width: 'initial',
      height: 'initial',
      background: 'none',
      opacity: 1,
      border: 0,
      margin: 0,
      padding: 0
    },
    alt: "",
    "aria-hidden": true,
    src: sizerSvgUrl
  }) : null) : null, /*#__PURE__*/_react["default"].createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // Note how we omit the `href` attribute, as it would only be relevant
  // for browsers that do not support `imagesrcset`, and in those cases
  // it would likely cause the incorrect image to be preloaded.
  //
  // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset

  /*#__PURE__*/
  _react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("link", Object.assign({
    key: '__nimg-' + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
    rel: "preload",
    as: "image",
    href: imgAttributes.srcSet ? undefined : imgAttributes.src
  }, linkProps))) : null);
}

'client';

function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":true};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

if (false) {}

var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && (['lazy', 'eager', undefined]));

function imgixLoader(_ref) {
  var config = _ref.config,
      src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
  var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
  var params = url.searchParams; // auto params can be combined with comma separation, or reiteration

  params.set('auto', params.getAll('auto').join(',') || 'format');
  params.set('fit', params.get('fit') || 'max');
  params.set('w', params.get('w') || width.toString());

  if (quality) {
    params.set('q', quality.toString());
  }

  return url.href;
}

function akamaiLoader(_ref2) {
  var config = _ref2.config,
      src = _ref2.src,
      width = _ref2.width;
  return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref3) {
  var config = _ref3.config,
      src = _ref3.src,
      width = _ref3.width,
      quality = _ref3.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}

function customLoader(_ref4) {
  var src = _ref4.src;
  throw new Error("Image with src \"".concat(src, "\" is missing \"loader\" prop.") + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}

function defaultLoader(_ref5) {
  var config = _ref5.config,
      src = _ref5.src,
      width = _ref5.width,
      quality = _ref5.quality;

  if (false) { var _require, hasMatch, parsedSrc, missingValues; }

  if (src.endsWith('.svg') && !config.dangerouslyAllowSVG) {
    // Special case to make svg serve as-is to avoid proxying
    // through the built-in Image Optimization API.
    return src;
  }

  return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

var loaders = new Map([['default', defaultLoader], ['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['custom', customLoader]]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && (['fill', 'fixed', 'intrinsic', 'responsive', undefined]));

function isStaticRequire(src) {
  return src["default"] !== undefined;
}

function isStaticImageData(src) {
  return src.src !== undefined;
}

function isStaticImport(src) {
  return typeof src === 'object' && (isStaticRequire(src) || isStaticImageData(src));
}

function getWidths(_ref6, width, layout, sizes) {
  var deviceSizes = _ref6.deviceSizes,
      allSizes = _ref6.allSizes;

  if (sizes && (layout === 'fill' || layout === 'responsive')) {
    // Find all the "vw" percent sizes used in the sizes prop
    var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
    var percentSizes = [];

    for (var match; match = viewportWidthRe.exec(sizes); match) {
      percentSizes.push(parseInt(match[2]));
    }

    if (percentSizes.length) {
      var smallestRatio = Math.min.apply(Math, percentSizes) * 0.01;
      return {
        widths: allSizes.filter(function (s) {
          return s >= deviceSizes[0] * smallestRatio;
        }),
        kind: 'w'
      };
    }

    return {
      widths: allSizes,
      kind: 'w'
    };
  }

  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: deviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set( // > This means that most OLED screens that say they are 3x resolution,
  // > are actually 3x in the green color, but only 1.5x in the red and
  // > blue colors. Showing a 3x resolution image in the app vs a 2x
  // > resolution image will be visually the same, though the 3x image
  // > takes significantly more data. Even true 3x resolution screens are
  // > wasteful as the human eye cannot see that level of detail without
  // > something like a magnifying glass.
  // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
  [width, width * 2
  /*, width * 3*/
  ].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function generateImgAttrs(_ref7) {
  var config = _ref7.config,
      src = _ref7.src,
      unoptimized = _ref7.unoptimized,
      layout = _ref7.layout,
      width = _ref7.width,
      quality = _ref7.quality,
      sizes = _ref7.sizes,
      loader = _ref7.loader;

  if (unoptimized) {
    return {
      src: src,
      srcSet: undefined,
      sizes: undefined
    };
  }

  var _getWidths = getWidths(config, width, layout, sizes),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  return {
    sizes: !sizes && kind === 'w' ? '100vw' : sizes,
    srcSet: widths.map(function (w, i) {
      return "".concat(loader({
        config: config,
        src: src,
        quality: quality,
        width: w
      }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
    }).join(', '),
    // It's intended to keep `src` the last attribute because React updates
    // attributes in order. If we keep `src` the first one, Safari will
    // immediately start to fetch `src`, before `sizes` and `srcSet` are even
    // updated by React. That causes multiple unnecessary requests if `srcSet`
    // and `sizes` are defined.
    // This bug cannot be reproduced in Chrome or Firefox.
    src: loader({
      config: config,
      src: src,
      quality: quality,
      width: widths[last]
    })
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function defaultImageLoader(loaderProps) {
  var ref;
  var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || 'default';
  var load = loaders.get(loaderKey);

  if (load) {
    return load(loaderProps);
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(loaderKey));
} // See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.


function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
  if (!img || img.src === emptyDataURL || img['data-loaded-src'] === src) {
    return;
  }

  img['data-loaded-src'] = src;
  var p = 'decode' in img ? img.decode() : Promise.resolve();
  p["catch"](function () {}).then(function () {
    if (!img.parentNode) {
      // Exit early in case of race condition:
      // - onload() is called
      // - decode() is called but incomplete
      // - unmount is called
      // - decode() completes
      return;
    }

    loadedImageURLs.add(src);

    if (placeholder === 'blur') {
      setBlurComplete(true);
    }

    if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
      var naturalWidth = img.naturalWidth,
          naturalHeight = img.naturalHeight; // Pass back read-only primitive values but not the
      // underlying DOM element because it could be misused.

      onLoadingCompleteRef.current({
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight
      });
    }

    if (false) { var parent, ref; }
  });
}

var ImageElement = function ImageElement(_param) {
  var imgAttributes = _param.imgAttributes,
      heightInt = _param.heightInt,
      widthInt = _param.widthInt,
      qualityInt = _param.qualityInt,
      layout = _param.layout,
      className = _param.className,
      imgStyle = _param.imgStyle,
      blurStyle = _param.blurStyle,
      isLazy = _param.isLazy,
      placeholder = _param.placeholder,
      loading = _param.loading,
      srcString = _param.srcString,
      config = _param.config,
      unoptimized = _param.unoptimized,
      loader = _param.loader,
      onLoadingCompleteRef = _param.onLoadingCompleteRef,
      setBlurComplete = _param.setBlurComplete,
      setIntersection = _param.setIntersection,
      _onLoad = _param.onLoad,
      _onError = _param.onError,
      isVisible = _param.isVisible,
      noscriptSizes = _param.noscriptSizes,
      rest = _object_without_properties_loose(_param, ["imgAttributes", "heightInt", "widthInt", "qualityInt", "layout", "className", "imgStyle", "blurStyle", "isLazy", "placeholder", "loading", "srcString", "config", "unoptimized", "loader", "onLoadingCompleteRef", "setBlurComplete", "setIntersection", "onLoad", "onError", "isVisible", "noscriptSizes"]);

  loading = isLazy ? 'lazy' : loading;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    "data-nimg": layout,
    className: className,
    style: _extends({}, imgStyle, blurStyle),
    ref: (0, _react).useCallback(function (img) {
      if (false) {}

      setIntersection(img);

      if (img == null ? void 0 : img.complete) {
        handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
      }
    }, [setIntersection, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete]),
    onLoad: function onLoad(event) {
      var img = event.currentTarget;
      handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);

      if (_onLoad) {
        _onLoad(event);
      }
    },
    onError: function onError(event) {
      if (placeholder === 'blur') {
        // If the real image fails to load, this will still remove the placeholder.
        setBlurComplete(true);
      }

      if (_onError) {
        _onError(event);
      }
    }
  })), (isLazy || placeholder === 'blur') && /*#__PURE__*/_react["default"].createElement("noscript", null, /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, rest, generateImgAttrs({
    config: config,
    src: srcString,
    unoptimized: unoptimized,
    layout: layout,
    width: widthInt,
    quality: qualityInt,
    sizes: noscriptSizes,
    loader: loader
  }), {
    decoding: "async",
    "data-nimg": layout,
    style: imgStyle,
    className: className,
    // @ts-ignore - TODO: upgrade to `@types/react@17`
    loading: loading
  }))));
};

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 78000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 9470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react["default"].createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 73579:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadable = _interop_require_default(__webpack_require__(23668));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

'client';
var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 72717:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _sideEffect = _interop_require_default(__webpack_require__(11585));

var _ampContext = __webpack_require__(78000);

var _headManagerContext = __webpack_require__(15850);

var _ampMode = __webpack_require__(9470);

var _utils = __webpack_require__(99475);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _loadableContext = __webpack_require__(3982);

var _ref =  true ? __webpack_require__(67294) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 11585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 26096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/pullstate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(69196);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./utils/Store.ts
var Store = __webpack_require__(54837);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./node_modules/react-idle-timer/dist/index.esm.js
var bt=Object.create,ke=Object.defineProperty;var gt=Object.getOwnPropertyDescriptor;var yt=Object.getOwnPropertyNames;var wt=Object.getPrototypeOf,Lt=Object.prototype.hasOwnProperty;var Pt=t=>ke(t,"__esModule",{value:!0});var Mt=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports);var kt=(t,e,n)=>{if(e&&typeof e=="object"||typeof e=="function")for(let i of yt(e))!Lt.call(t,i)&&i!=="default"&&ke(t,i,{get:()=>e[i],enumerable:!(n=gt(e,i))||n.enumerable});return t},xt=t=>kt(Pt(ke(t!=null?bt(wt(t)):{},"default",t&&t.__esModule&&"default"in t?{get:()=>t.default,enumerable:!0}:{value:t,enumerable:!0})),t);var Je=Mt((he,Ye)=>{(function(t,e){typeof he=="object"&&typeof Ye!="undefined"?e(he):typeof define=="function"&&__webpack_require__.amdO?define(["exports"],e):(t=typeof globalThis!="undefined"?globalThis:t||self,e(t.fastUniqueNumbers={}))})(he,function(t){"use strict";var e=function(d){return function(h){var o=d(h);return h.add(o),o}},n=function(d){return function(h,o){return d.set(h,o),o}},i=Number.MAX_SAFE_INTEGER===void 0?9007199254740991:Number.MAX_SAFE_INTEGER,l=536870912,m=l*2,g=function(d,h){return function(o){var V=h.get(o),w=V===void 0?o.size:V<m?V+1:0;if(!o.has(w))return d(o,w);if(o.size<l){for(;o.has(w);)w=Math.floor(Math.random()*m);return d(o,w)}if(o.size>i)throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");for(;o.has(w);)w=Math.floor(Math.random()*i);return d(o,w)}},R=new WeakMap,B=n(R),p=g(B,R),c=e(p);t.addUniqueNumber=c,t.generateUniqueNumber=p,Object.defineProperty(t,"__esModule",{value:!0})})});function Ct(t){return Ot(function(n,i){let l={...n},m=oe(l);return typeof i=="function"?i(m):i&&(i.current=m),At.createElement(t,{...n,...m})})}var je=class extends (/* unused pure expression or super */ null && (St)){},$e=class extends (/* unused pure expression or super */ null && (je)){constructor(e){super(e);this.onPresenceChange&&e.setOnPresenceChange(this.onPresenceChange.bind(this)),this.onPrompt&&e.setOnPrompt(this.onPrompt.bind(this)),this.onIdle&&e.setOnIdle(this.onIdle.bind(this)),this.onActive&&e.setOnActive(this.onActive.bind(this)),this.onAction&&e.setOnAction(this.onAction.bind(this)),this.onMessage&&e.setOnMessage(this.onMessage.bind(this))}};var se=xt(Je());var ze=t=>t.method!==void 0&&t.method==="call";var Xe=t=>t.error===null&&typeof t.id=="number";var Ke=t=>{let e=new Map([[0,()=>{}]]),n=new Map([[0,()=>{}]]),i=new Map,l=new Worker(t);return l.addEventListener("message",({data:p})=>{if(ze(p)){let{params:{timerId:c,timerType:f}}=p;if(f==="interval"){let d=e.get(c);if(typeof d=="number"){let h=i.get(d);if(h===void 0||h.timerId!==c||h.timerType!==f)throw new Error("The timer is in an undefined state.")}else if(typeof d!="undefined")d();else throw new Error("The timer is in an undefined state.")}else if(f==="timeout"){let d=n.get(c);if(typeof d=="number"){let h=i.get(d);if(h===void 0||h.timerId!==c||h.timerType!==f)throw new Error("The timer is in an undefined state.")}else if(typeof d!="undefined")d(),n.delete(c);else throw new Error("The timer is in an undefined state.")}}else if(Xe(p)){let{id:c}=p,f=i.get(c);if(f===void 0)throw new Error("The timer is in an undefined state.");let{timerId:d,timerType:h}=f;i.delete(c),h==="interval"?e.delete(d):n.delete(d)}else{let{error:{message:c}}=p;throw new Error(c)}}),{clearInterval:p=>{let c=(0,se.generateUniqueNumber)(i);i.set(c,{timerId:p,timerType:"interval"}),e.set(p,c),l.postMessage({id:c,method:"clear",params:{timerId:p,timerType:"interval"}})},clearTimeout:p=>{let c=(0,se.generateUniqueNumber)(i);i.set(c,{timerId:p,timerType:"timeout"}),n.set(p,c),l.postMessage({id:c,method:"clear",params:{timerId:p,timerType:"timeout"}})},setInterval:(p,c)=>{let f=(0,se.generateUniqueNumber)(e);return e.set(f,()=>{p(),typeof e.get(f)=="function"&&l.postMessage({id:null,method:"set",params:{delay:c,now:performance.now(),timerId:f,timerType:"interval"}})}),l.postMessage({id:null,method:"set",params:{delay:c,now:performance.now(),timerId:f,timerType:"interval"}}),f},setTimeout:(p,c)=>{let f=(0,se.generateUniqueNumber)(n);return n.set(f,p),l.postMessage({id:null,method:"set",params:{delay:c,now:performance.now(),timerId:f,timerType:"timeout"}}),f}}};var ae=null,Qe=(t,e)=>()=>{if(ae!==null)return ae;let n=new Blob([e],{type:"application/javascript; charset=utf-8"}),i=URL.createObjectURL(n);return ae=t(i),ae.setTimeout(()=>URL.revokeObjectURL(i),0),ae};var Ze=`(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error('The given type "'.concat(i,'" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error('The given method "'.concat(s.method,'" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error('The given type "'.concat(d,'" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();`;var ve=Qe(Ke,Ze),et=t=>ve().clearInterval(t),tt=t=>ve().clearTimeout(t),rt=(t,e)=>ve().setInterval(t,e),nt=(t,e)=>ve().setTimeout(t,e);var A=(typeof window=="undefined"?"undefined":typeof window)=="object";var E={setTimeout:A?setTimeout.bind(window):setTimeout,clearTimeout:A?clearTimeout.bind(window):clearTimeout,setInterval:A?setInterval.bind(window):setInterval,clearInterval:A?clearInterval.bind(window):clearInterval},le={setTimeout:nt,clearTimeout:tt,setInterval:rt,clearInterval:et};function Rt(){E.setTimeout=setTimeout,E.clearTimeout=clearTimeout,E.setInterval=setInterval,E.clearInterval=clearInterval,le.setTimeout=setTimeout,le.clearTimeout=clearTimeout,le.setInterval=setInterval,le.clearInterval=clearInterval}function it(t){E.setTimeout=t.setTimeout,E.clearTimeout=t.clearTimeout,E.setInterval=t.setInterval,E.clearInterval=t.clearInterval}var Q={},ot=class{constructor(e){this.closed=!1;this.mc=new MessageChannel;this.name=e,Q[e]=Q[e]||[],Q[e].push(this),this.mc.port1.start(),this.mc.port2.start(),this.onStorage=this.onStorage.bind(this),window.addEventListener("storage",this.onStorage)}onStorage(e){if(e.storageArea!==window.localStorage||e.key.substring(0,this.name.length)!==this.name||e.newValue===null)return;let n=JSON.parse(e.newValue);this.mc.port2.postMessage(n)}postMessage(e){if(this.closed)throw new Error("InvalidStateError");let n=JSON.stringify(e),i=`${this.name}:${String(Date.now())}${String(Math.random())}`;window.localStorage.setItem(i,n),E.setTimeout(()=>{window.localStorage.removeItem(i)},500),Q[this.name].forEach(l=>{l!==this&&l.mc.port2.postMessage(JSON.parse(n))})}close(){if(this.closed)return;this.closed=!0,this.mc.port1.close(),this.mc.port2.close(),window.removeEventListener("storage",this.onStorage);let e=Q[this.name].indexOf(this);Q[this.name].splice(e,1)}get onmessage(){return this.mc.port1.onmessage}set onmessage(e){this.mc.port1.onmessage=e}get onmessageerror(){return this.mc.port1.onmessageerror}set onmessageerror(e){this.mc.port1.onmessageerror=e}addEventListener(e,n){return this.mc.port1.addEventListener(e,n)}removeEventListener(e,n){return this.mc.port1.removeEventListener(e,n)}dispatchEvent(e){return this.mc.port1.dispatchEvent(e)}},st=typeof window=="undefined"?void 0:typeof window.BroadcastChannel=="function"?window.BroadcastChannel:ot;function at(t=0){return new Promise(e=>E.setTimeout(e,t))}function Te(){return Math.random().toString(36).substring(2)}var a;(function(o){o[o.APPLY=0]="APPLY",o[o.TELL=1]="TELL",o[o.CLOSE=2]="CLOSE",o[o.REGISTER=3]="REGISTER",o[o.DEREGISTER=4]="DEREGISTER",o[o.IDLE=5]="IDLE",o[o.ACTIVE=6]="ACTIVE",o[o.PROMPT=7]="PROMPT",o[o.START=8]="START",o[o.RESET=9]="RESET",o[o.ACTIVATE=10]="ACTIVATE",o[o.PAUSE=11]="PAUSE",o[o.RESUME=12]="RESUME",o[o.MESSAGE=13]="MESSAGE"})(a||(a={}));var xe=class{constructor(e,n){this.token=Te();this.isLeader=!1;this.isDead=!1;this.isApplying=!1;this.reApply=!1;this.intervals=[];this.listeners=[];this.channel=e,this.options=n,this.apply=this.apply.bind(this),this.awaitLeadership=this.awaitLeadership.bind(this),this.sendAction=this.sendAction.bind(this)}async apply(){if(this.isLeader||this.isDead)return!1;if(this.isApplying)return this.reApply=!0,!1;this.isApplying=!0;let e=!1,n=i=>{let{token:l,action:m}=i.data;l!==this.token&&(m===a.APPLY&&l>this.token&&(e=!0),m===a.TELL&&(e=!0))};this.channel.addEventListener("message",n);try{return this.sendAction(a.APPLY),await at(this.options.responseTime),this.channel.removeEventListener("message",n),this.isApplying=!1,e?this.reApply?this.apply():!1:(this.assumeLead(),!0)}catch{return!1}}awaitLeadership(){if(this.isLeader)return Promise.resolve();let e=!1,n=null;return new Promise(i=>{let l=()=>{if(e)return;e=!0;try{E.clearInterval(n)}catch{}let g=this.intervals.indexOf(n);g>=0&&this.intervals.splice(g,1),this.channel.removeEventListener("message",m),i()};n=E.setInterval(()=>{this.apply().then(()=>{this.isLeader&&l()})},this.options.fallbackInterval),this.intervals.push(n);let m=g=>{let{action:R}=g.data;R===a.CLOSE&&this.apply().then(()=>{this.isLeader&&l()})};this.channel.addEventListener("message",m)})}sendAction(e){this.channel.postMessage({action:e,token:this.token})}assumeLead(){this.isLeader=!0;let e=n=>{let{action:i}=n.data;i===a.APPLY&&this.sendAction(a.TELL)};return this.channel.addEventListener("message",e),this.listeners.push(e),this.sendAction(a.TELL)}waitForLeadership(){return this.deferred?this.deferred:(this.deferred=this.awaitLeadership(),this.deferred)}close(){if(!this.isDead){this.isDead=!0,this.isLeader=!1,this.sendAction(a.CLOSE);try{this.listeners.forEach(e=>this.channel.removeEventListener("message",e)),this.intervals.forEach(e=>E.clearInterval(e))}catch{}}}};var k;(function(i){i[i.PROMPTED=0]="PROMPTED",i[i.ACTIVE=1]="ACTIVE",i[i.IDLE=2]="IDLE"})(k||(k={}));var Ae=class{constructor(e){this.token=Te();this.registry=new Map;this.allIdle=!1;this.isLastActive=!1;let{channelName:n}=e;if(this.options=e,this.channel=new st(n),this.registry.set(this.token,1),e.leaderElection){let i={fallbackInterval:2e3,responseTime:100};this.elector=new xe(this.channel,i),this.elector.waitForLeadership()}this.channel.addEventListener("message",i=>{let{action:l,token:m,data:g}=i.data;switch(l){case a.REGISTER:this.registry.set(m,2);break;case a.DEREGISTER:this.registry.delete(m);break;case a.IDLE:this.idle(m);break;case a.ACTIVE:this.active(m);break;case a.PROMPT:this.prompt(m);break;case a.START:this.start(m);break;case a.RESET:this.reset(m);break;case a.ACTIVATE:this.activate(m);break;case a.PAUSE:this.pause(m);break;case a.RESUME:this.resume(m);break;case a.MESSAGE:this.options.onMessage(g);break}}),this.send(a.REGISTER)}get isLeader(){if(!this.elector)throw new Error('\u274C Leader election is not enabled. To Enable it set the "leaderElection" property to true.');return this.elector.isLeader}prompt(e=this.token){this.registry.set(e,0);let n=[...this.registry.values()].every(i=>i===0);e===this.token&&this.send(a.PROMPT),n&&this.options.onPrompt()}idle(e=this.token){this.registry.set(e,2);let n=[...this.registry.values()].every(i=>i===2);e===this.token&&this.send(a.IDLE),!this.allIdle&&n&&(this.allIdle=!0,this.options.onIdle())}active(e=this.token){this.allIdle=!1,this.registry.set(e,1);let n=[...this.registry.values()].some(i=>i===1);e===this.token&&this.send(a.ACTIVE),n&&this.options.onActive(),this.isLastActive=e===this.token}start(e=this.token){this.allIdle=!1,this.registry.set(e,1),e===this.token?this.send(a.START):this.options.start(!0),this.isLastActive=e===this.token}reset(e=this.token){this.allIdle=!1,this.registry.set(e,1),e===this.token?this.send(a.RESET):this.options.reset(!0),this.isLastActive=e===this.token}activate(e=this.token){this.allIdle=!1,this.registry.set(e,1),e===this.token?this.send(a.ACTIVATE):this.options.activate(!0),this.isLastActive=e===this.token}pause(e=this.token){e===this.token?this.send(a.PAUSE):this.options.pause(!0)}resume(e=this.token){e===this.token?this.send(a.RESUME):this.options.resume(!0)}message(e){try{this.channel.postMessage({action:a.MESSAGE,token:this.token,data:e})}catch{}}send(e){try{this.channel.postMessage({action:e,token:this.token})}catch{}}close(){this.options.leaderElection&&this.elector.close(),this.send(a.DEREGISTER),this.channel.close()}};var lt=A?document:null,Se=["mousemove","keydown","wheel","DOMMouseScroll","mousewheel","mousedown","touchstart","touchmove","MSPointerDown","MSPointerMove","visibilitychange","focus"];function ct(t,e){let n;function i(...l){n&&clearTimeout(n),n=setTimeout(()=>{t(...l),n=null},e)}return i.cancel=function(){clearTimeout(n)},i}function Ie(t,e){let n=0;return function(...i){let l=new Date().getTime();if(!(l-n<e))return n=l,t(...i)}}var T=()=>Date.now();var Z=2147483647;function oe({timeout:t=1e3*60*20,promptTimeout:e=0,promptBeforeIdle:n=0,element:i=lt,events:l=Se,timers:m=void 0,immediateEvents:g=[],onPresenceChange:R=()=>{},onPrompt:B=()=>{},onIdle:p=()=>{},onActive:c=()=>{},onAction:f=()=>{},onMessage:d=()=>{},debounce:h=0,throttle:o=0,eventsThrottle:V=200,startOnMount:w=!0,startManually:_=!1,stopOnIdle:ce=!1,crossTab:Y=!1,name:Oe="idle-timer",syncTimers:ee=0,leaderElection:Ce=!1}={}){let Re=(0,react.useRef)(T()),ue=(0,react.useRef)(T()),L=(0,react.useRef)(null),S=(0,react.useRef)(null),F=(0,react.useRef)(0),te=(0,react.useRef)(0),D=(0,react.useRef)(0),x=(0,react.useRef)(0),v=(0,react.useRef)(!1),b=(0,react.useRef)(!1),H=(0,react.useRef)(!1),U=(0,react.useRef)(!0),re=(0,react.useRef)(!1),N=(0,react.useRef)(null),s=(0,react.useRef)(null),O=(0,react.useRef)(t),G=(0,react.useRef)(0);(0,react.useEffect)(()=>{if(e&&console.warn("\u26A0\uFE0F IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."),n&&e)throw new Error("\u274C Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");if(t>=Z)throw new Error(`\u274C The value for the timeout property must fit in a 32 bit signed integer, ${Z}.`);if(e>=Z)throw new Error(`\u274C The value for the promptTimeout property must fit in a 32 bit signed integer, ${Z}.`);if(n>=Z)throw new Error(`\u274C The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ${Z}.`);if(n>=t)throw new Error(`\u274C The value for the promptBeforeIdle property must be less than the timeout property, ${t}.`);if(n?(O.current=t-n,G.current=n):(O.current=t,G.current=e),!U.current){if(_)return;v.current&&(J.current(null,P),s.current&&s.current.active()),X()}},[t,e,n,_]);let De=(0,react.useRef)(ce);(0,react.useEffect)(()=>{De.current=ce},[ce]);let He=(0,react.useRef)(g),ne=(0,react.useRef)(i),be=(0,react.useRef)([...new Set([...l,...g]).values()]),ie=(0,react.useRef)(R);(0,react.useEffect)(()=>{ie.current=R},[R]);let me=(0,react.useRef)(B);(0,react.useEffect)(()=>{me.current=B},[B]);let de=(0,react.useRef)(p);(0,react.useEffect)(()=>{de.current=p},[p]);let J=(0,react.useRef)(c);(0,react.useEffect)(()=>{J.current=c},[c]);let pe=(0,react.useRef)(f);(0,react.useEffect)(()=>{pe.current=f},[f]);let z=(0,react.useRef)(d);(0,react.useEffect)(()=>{z.current=d},[d]);let q=(0,react.useMemo)(()=>{let r=(M,K)=>pe.current(M,K);return h>0?ct(r,h):o>0?Ie(r,o):r},[o,h]),Ne=(0,react.useRef)();(0,react.useEffect)(()=>{Y&&ee&&(Ne.current=Ie(()=>{s.current.active()},ee))},[Y,ee]);let C=()=>{N.current!==null&&(E.clearTimeout(N.current),N.current=null)},j=(r,M=!0)=>{C(),N.current=E.setTimeout(ye,r||O.current),M&&(S.current=T())},_e=r=>{!b.current&&!v.current&&(me.current(r,P),ie.current({type:"active",prompted:!0},P)),x.current=0,D.current=T(),b.current=!0,j(G.current,!1)},Fe=()=>{C(),v.current||(de.current(null,P),ie.current({type:"idle"},P)),v.current=!0,L.current=T(),De.current?$():b.current&&(D.current=0,b.current=!1)},ge=r=>{C(),(v.current||b.current)&&(J.current(r,P),ie.current({type:"active",prompted:!1},P)),b.current=!1,D.current=0,v.current=!1,F.current+=T()-L.current,te.current+=T()-L.current,W(),j()},ye=r=>{if(!v.current){q.cancel&&q.cancel();let K=T()-S.current;if(!(O.current+G.current<K)&&G.current>0&&!b.current){s.current?s.current.prompt():_e(r);return}s.current?s.current.idle():Fe();return}s.current?s.current.active():ge(r)},we=r=>{if(!w&&!S.current&&(S.current=T(),J.current(null,P)),q(r,P),b.current)return;if(C(),!v.current&&He.current.includes(r.type)){ye(r);return}let M=T()-S.current;if(v.current&&!ce||!v.current&&M>=O.current){ye(r);return}H.current=!1,x.current=0,D.current=0,j(),Y&&ee&&Ne.current()},fe=(0,react.useRef)(we);(0,react.useEffect)(()=>{let r=re.current;r&&$(),V>0?fe.current=Ie(we,V):fe.current=we,r&&W()},[V,o,h,pe,Y,ee]);let W=()=>{!A||!ne.current||re.current||(be.current.forEach(r=>{ne.current.addEventListener(r,fe.current,{capture:!0,passive:!0})}),re.current=!0)},$=(r=!1)=>{!A||!ne.current||(re.current||r)&&(be.current.forEach(M=>{ne.current.removeEventListener(M,fe.current,{capture:!0})}),re.current=!1)},X=(0,react.useCallback)(r=>{C(),W(),v.current=!1,b.current=!1,H.current=!1,x.current=0,D.current=0,s.current&&!r&&s.current.start(),j()},[N,v,O,s]),Le=(0,react.useCallback)(r=>{C(),W(),ue.current=T(),F.current+=T()-L.current,te.current+=T()-L.current,F.current=0,v.current=!1,b.current=!1,H.current=!1,x.current=0,D.current=0,s.current&&!r&&s.current.reset(),_||j()},[N,v,O,_,s]),Ue=(0,react.useCallback)(r=>{C(),W(),(v.current||b.current)&&ge(),v.current=!1,b.current=!1,H.current=!1,x.current=0,D.current=0,ue.current=T(),s.current&&!r&&s.current.activate(),j()},[N,v,b,O,s]),Pe=(0,react.useCallback)((r=!1)=>H.current?!1:(x.current=We(),H.current=!0,$(),C(),s.current&&!r&&s.current.pause(),!0),[N,s]),Me=(0,react.useCallback)((r=!1)=>H.current?(H.current=!1,b.current||W(),v.current||j(x.current),D.current&&(D.current=T()),s.current&&!r&&s.current.resume(),!0):!1,[N,O,x,s]),ut=(0,react.useCallback)((r,M)=>{s.current?(M&&z.current(r,P),s.current.message(r)):M&&z.current(r,P)},[d]),mt=(0,react.useCallback)(()=>v.current,[v]),dt=(0,react.useCallback)(()=>b.current,[b]),pt=(0,react.useCallback)(()=>s.current?s.current.isLeader:null,[s]),ft=(0,react.useCallback)(()=>s.current?s.current.isLastActive:null,[s]),ht=(0,react.useCallback)(()=>s.current?s.current.token:null,[s]),We=(0,react.useCallback)(()=>{if(H.current)return x.current;let r=x.current?x.current:G.current+O.current,M=S.current?T()-S.current:0,K=Math.floor(r-M);return K<0?0:Math.abs(K)},[O,G,b,x,S]),Be=(0,react.useCallback)(()=>Math.round(T()-ue.current),[ue]),Ve=(0,react.useCallback)(()=>Math.round(T()-Re.current),[Re]),vt=(0,react.useCallback)(()=>L.current?new Date(L.current):null,[L]),Tt=(0,react.useCallback)(()=>S.current?new Date(S.current):null,[S]),Ge=(0,react.useCallback)(()=>v.current?Math.round(T()-L.current+F.current):Math.round(F.current),[L,F]),qe=(0,react.useCallback)(()=>v.current?Math.round(T()-L.current+te.current):Math.round(te.current),[L,te]),It=(0,react.useCallback)(()=>{let r=Math.round(Be()-Ge());return r>=0?r:0},[L,F]),Et=(0,react.useCallback)(()=>{let r=Math.round(Ve()-qe());return r>=0?r:0},[L,F]);(0,react.useEffect)(()=>{if(h>0&&o>0)throw new Error("\u274C onAction can either be throttled or debounced, not both.");m&&it(m);let r=()=>{s.current&&s.current.close(),q.cancel&&q.cancel(),C(),$(!0)};return A&&window.addEventListener("beforeunload",r),()=>{A&&window.removeEventListener("beforeunload",r),s.current&&s.current.close(),q.cancel&&q.cancel(),C(),$(!0)}},[]),(0,react.useEffect)(()=>{s.current&&s.current.close(),Y?s.current=new Ae({channelName:Oe,leaderElection:Ce,onPrompt:()=>{_e()},onIdle:()=>{Fe()},onActive:()=>{ge()},onMessage:r=>{z.current(r,P)},start:X,reset:Le,activate:Ue,pause:Pe,resume:Me}):s.current=null},[Y,Oe,Ce,me,de,J,z,X,Le,Pe,Me]),(0,react.useEffect)(()=>{U.current||(C(),$(!0)),!_&&(w?X():W())},[_,w,U]),(0,react.useEffect)(()=>{if(!U.current){let r=[...new Set([...l,...g]).values()];if($(),be.current=r,ne.current=i,He.current=g,_)return;w?X():W()}},[i,JSON.stringify(l),JSON.stringify(g),U,_,w]),(0,react.useEffect)(()=>{U.current&&(U.current=!1)},[U]);let P={message:ut,start:X,reset:Le,activate:Ue,pause:Pe,resume:Me,isIdle:mt,isPrompted:dt,isLeader:pt,isLastActiveTab:ft,getTabId:ht,getRemainingTime:We,getElapsedTime:Be,getTotalElapsedTime:Ve,getLastIdleTime:vt,getLastActiveTime:Tt,getIdleTime:Ge,getTotalIdleTime:qe,getActiveTime:It,getTotalActiveTime:Et,setOnPresenceChange:r=>{R=r,ie.current=r},setOnPrompt:r=>{B=r,me.current=r},setOnIdle:r=>{p=r,de.current=r},setOnActive:r=>{c=r,J.current=r},setOnAction:r=>{f=r,pe.current=r},setOnMessage:r=>{d=r,z.current=r}};return P}var Ee=(0,react.createContext)(null);function Ft(t){let e=oe(t);return Ht.createElement(Ee.Provider,{value:e},t.children)}var Ut=Ee.Consumer;function Wt(){return _t(Ee)}

// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(595);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(59275);
;// CONCATENATED MODULE: ./components/NotificationSettings/findingsLabels.js
var FINDINGS = {
  // main headers
  qxr: "Chest X-ray scans (qXR)",
  qer: "Brain NCCT scans (qER-Quant)",
  qct: "Chest CT Scans {qCT}",
  qmsk: "Fractures",
  forms: "Forms submitted",
  // group headers
  emergent_findings: "Emergent findings",
  other_findings: "Other findings",
  tags: "Tags",
  intra_cranial_hemorrhage: "Intra-cranial hemorrhage",
  // qxr
  abnormal: "Abnormal",
  atelectasis: "Atelectasis",
  bluntedcp: "Blunted costophrenic angle",
  calcification: "Calcification",
  cardiomegaly: "Cardiomegaly",
  cavity: "Cavity",
  consolidation: "Consolidation",
  degenspine: "Degenerative spine",
  diaphragm: "Diaphragm",
  fibrosis: "Fibrosis",
  hilarlymphadenopathy: "Hilar lymph adenopathy",
  nodule: "Nodule",
  opacity: "Opacity",
  peffusion: "Pleural effusion",
  pneumoperitoneum: "Pneumoperitoneum",
  reticulonodularpattern: "Reticulo nodular pattern",
  ribfracture: "Rib fracture",
  scoliosis: "Scoliosis",
  trachealshift: "Tracheal shift",
  clavicle_fracture: "Clavicle fracture",
  pneumothorax: "Pneumothorax",
  tuberculosis: "Tuberculosis",
  lung_nodule_malignancy: "High malignant nodule",
  // qer
  ASPECTS: "ASPECT Score <10",
  ATROPHY: "Cerebral atrophy",
  EDH: "Extradural hemorrhage",
  FRACTURE: "Cranial fracture",
  ICH: "Intracranial hemorrhage",
  ME: "Mass effect",
  INFARCT: "Hypdensity suggestive of infarct",
  IPH: "Intraparenchymal hemorrhage",
  IVH: "Intraventricular hemorrhage",
  MLS: "Midline shift",
  SAH: "Subarachnoid hemorrhage",
  SDH: "Subdural hemorrhage",
  TBR: "Review required (when infarct and bleed are not present)",
  // qct
  lungnodule: "Lung Nodule",
  //qmsk
  qmsk_fracture: "qMSK fracture",
  // forms
  tb_voucher: "TB Voucher",
  symptoms: "Symptoms",
  qtrack_cbnaat_clt: "Confirmatory Lab Test - CBNAAT",
  qtrack_genexpert_clt: "Confirmatory Lab Test - GeneXpert",
  risk_groups: "Risk Groups",
  nihss: "NIHSS Evaluation",
  stroke_clinical: "Clinical History of Stroke Suspects"
};
var GROUPEDFINDINGS = {
  qxr: {
    emergent_findings: ["opacity", "consolidation", "peffusion", "fibrosis", "atelectasis", "clavicle_fracture", "ribfracture", "pneumothorax", "pneumoperitoneum", "lung_nodule_malignancy"],
    other_findings: ["cavity", "hilarlymphadenopathy", "diaphragm", "cardiomegaly", "calcification", "nodule", "degenspine", "reticulonodularpattern", "scoliosis", "trachealshift", "bluntedcp"],
    tags: ["abnormal", "tuberculosis"]
  } // qer: {
  //   intra_cranial_hemorrhage: ["IPH", "SDH", "IVH", "SAH", "EDH"],
  // },

};
/* harmony default export */ var findingsLabels = (FINDINGS);
// EXTERNAL MODULE: ./components/common/Checkbox.tsx + 2 modules
var Checkbox = __webpack_require__(48831);
// EXTERNAL MODULE: ./components/common/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(79175);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var dist_es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/AutomatedShare/FindingsModal.jsx













var FindingsModal = function FindingsModal(_ref) {
  var allFindings = _ref.allFindings,
      selectedFindings = _ref.selectedFindings,
      activeCategory = _ref.activeCategory,
      _onChange = _ref.onChange;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isAutomatedFindingsOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var onCloseModal = function onCloseModal() {
    Store/* default.update */.Z.update(function (s) {
      s.isAutomatedFindingsOpen = false;
    });
  };

  var onChangeMultipleFindings = function onChangeMultipleFindings(value, findings, categoryName) {
    findings.map(function (finding) {
      _onChange(categoryName, finding, value);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    title: activeCategory === "forms" ? "Forms by Qure.ai" : "AI findings by Qure.ai",
    onClose: onCloseModal,
    show: isVisible,
    bgOpacity: true,
    className: "flex flex-col w-full sm:w-7/12 h-[88%] lg:w-6/12 xl:w-5/12 sm:!h-auto sm:!max-h-[80%] overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "overflow-y-auto scrollbar",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "p-6",
        children: Object.keys(allFindings).map(function (categoryName) {
          var findings = allFindings[categoryName];
          var areAllFindingsSelected = (0,lodash.isEmpty)(findings) ? false : Object.keys(findings).every(function (finding) {
            return selectedFindings && selectedFindings[finding];
          });
          var groupFindings = (0,lodash.get)(GROUPEDFINDINGS, categoryName, {});
          var renderedFindings = [];
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex my-3 justify-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "font-bold",
                children: (0,lodash.get)(findingsLabels, [categoryName], categoryName)
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: ["Select All", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mx-4",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                    value: areAllFindingsSelected,
                    onChange: function onChange(value) {
                      return onChangeMultipleFindings(value, Object.keys(findings), categoryName);
                    }
                  })
                })]
              })]
            }), Object.keys(groupFindings).map(function (groupFinding) {
              var findingsInGroup = groupFindings[groupFinding];
              var areAllFindingsInGroupSelected = findingsInGroup.every(function (finding) {
                return selectedFindings && selectedFindings[finding];
              });
              renderedFindings = renderedFindings.concat(findingsInGroup);
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                  id: groupFinding,
                  className: "w-full my-2 pr-2",
                  checked: areAllFindingsInGroupSelected,
                  onChange: function onChange(value) {
                    return onChangeMultipleFindings(value, findingsInGroup, categoryName);
                  },
                  label: (0,lodash.get)(findingsLabels, [groupFinding], groupFinding)
                }, groupFinding), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex flex-wrap px-6",
                  children: findingsInGroup.map(function (finding) {
                    var isSelected = selectedFindings && selectedFindings[finding];
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                      id: finding,
                      name: "aiFind",
                      className: "w-full sm:w-1/2 my-2 pr-2",
                      checked: isSelected,
                      onChange: function onChange(val) {
                        _onChange(categoryName, finding, val);
                      },
                      label: (0,lodash.get)(findingsLabels, [finding], finding)
                    }, finding);
                  })
                })]
              });
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-wrap",
              children: !(0,lodash.isEmpty)(findings) && Object.keys(findings).filter(function (f) {
                return !renderedFindings.includes(f);
              }).map(function (finding) {
                var isSelected = selectedFindings && selectedFindings[finding];
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                  id: finding,
                  name: "aiFind",
                  className: "w-full sm:w-1/2 my-2 pr-2",
                  checked: isSelected,
                  onChange: function onChange(val) {
                    _onChange(categoryName, finding, val);
                  },
                  label: (0,lodash.get)(findingsLabels, [finding], finding)
                }, finding);
              })
            })]
          }, categoryName);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between px-6 py-4 items-center border-t border-gray-900",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-gray-100",
            children: !(0,lodash.isEmpty)(selectedFindings) ? Object.values(selectedFindings).filter(function (item) {
              return item;
            }).length : 0
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-md text-gray-300",
            children: "fields selected"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isPrimary: true,
          onClick: onCloseModal,
          className: "sm:mt-0 grow-1 ml-4 w-24 sm:w-40",
          children: t("button.done")
        })]
      })]
    })
  });
};

FindingsModal.defaultProps = {
  onChange: function onChange() {}
};
/* harmony default export */ var AutomatedShare_FindingsModal = (FindingsModal);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Toast/index.jsx + 2 modules
var Toast = __webpack_require__(10921);
// EXTERNAL MODULE: ./utils/servicesUtils.ts
var servicesUtils = __webpack_require__(39949);
;// CONCATENATED MODULE: ./components/AutomatedShare/services/useAddCondition.js



var useAddCondition = function useAddCondition() {
  return (0,es.useMutation)(function (_ref) {
    var params = _ref.params,
        workspaceId = _ref.workspaceId;
    return servicesUtils/* default.postService */.Z.postService("/workspaces/".concat(workspaceId, "/routing/"), params);
  });
};

/* harmony default export */ var services_useAddCondition = (useAddCondition);
// EXTERNAL MODULE: ./components/common/UserIcon.tsx
var UserIcon = __webpack_require__(48947);
;// CONCATENATED MODULE: ./components/AutomatedShare/services/useDeleteCondition.js



var useDeleteCondition = function useDeleteCondition() {
  return (0,es.useMutation)(function (_ref) {
    var params = _ref.params,
        workspaceId = _ref.workspaceId;
    return servicesUtils/* default.postService */.Z.postService("/workspaces/".concat(workspaceId, "/routing/delete/"), params);
  });
};

/* harmony default export */ var services_useDeleteCondition = (useDeleteCondition);
// EXTERNAL MODULE: ./components/FormComponents/SelectInput.tsx
var SelectInput = __webpack_require__(94440);
// EXTERNAL MODULE: ./components/AwesomeIcon/index.tsx + 2 modules
var AwesomeIcon = __webpack_require__(38266);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
;// CONCATENATED MODULE: ./components/AutomatedShare/DeleteModal.jsx







var DeleteModal = function DeleteModal(_ref) {
  var deleteModal = _ref.deleteModal,
      setDeleteModal = _ref.setDeleteModal,
      onDelete = _ref.onDelete,
      title = _ref.title,
      content = _ref.content;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var onCloseModal = function onCloseModal() {
    setDeleteModal(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    title: title,
    bgOpacity: true,
    onClose: onCloseModal,
    show: deleteModal,
    className: "flex flex-col w-full h-1/3 sm:w-7/12 lg:w-6/12 xl:w-4/12 sm:!h-auto sm:!max-h-[80%] overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "pt-2 flex flex-col h-full pb-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-justify px-4 border-t border-b grow mb-6 pt-6 sm:pb-6 border-gray-700",
        children: content
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center sm:justify-end space-x-4 px-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isSecondary: true,
          className: "grow-1 w-full sm:w-40",
          onClick: onCloseModal,
          children: t("button.cancel")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isPrimary: true,
          onClick: onDelete,
          className: "sm:mt-0 grow-1 ml-4 w-full sm:w-40",
          children: t("button.delete")
        })]
      })]
    })
  });
};

/* harmony default export */ var AutomatedShare_DeleteModal = (DeleteModal);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
;// CONCATENATED MODULE: ./components/AutomatedShare/ConditionsModal.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var ConditionsModal = function ConditionsModal(_ref) {
  var allFindings = _ref.allFindings,
      findings = _ref.findings,
      isVisible = _ref.isVisible,
      onClose = _ref.onClose,
      allGroups = _ref.groups,
      workspaceOptions = _ref.workspaceOptions,
      currentWorkspaceId = _ref.currentWorkspaceId;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isEdit = !(0,lodash.isEmpty)(findings);

  var _useState = (0,react.useState)({}),
      findingState = _useState[0],
      setFindingState = _useState[1];

  var _useState2 = (0,react.useState)([]),
      selectedGroups = _useState2[0],
      setSelectedGroups = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      deleteModal = _useState3[0],
      setDeleteModal = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      activeCategory = _useState4[0],
      setActiveCategory = _useState4[1];

  var _useState5 = (0,react.useState)(currentWorkspaceId),
      selectedWorkspaceId = _useState5[0],
      setSelectedWorkspaceId = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      search = _useState6[0],
      setSearch = _useState6[1];

  var _useState7 = (0,react.useState)(1),
      activeTab = _useState7[0],
      setActiveTab = _useState7[1];

  var saveCondition = services_useAddCondition();
  var deleteCondition = services_useDeleteCondition();
  (0,react.useEffect)(function () {
    if (currentWorkspaceId) {
      setSelectedWorkspaceId(currentWorkspaceId);
    }
  }, [currentWorkspaceId]);
  (0,react.useEffect)(function () {
    if (isVisible) {
      var _findings = (0,lodash.cloneDeep)(findings);

      var _selectedCategory = (0,lodash.find)(Object.keys(_findings), function (f) {
        var findingsList = _findings[f];
        return Object.values(findingsList).some(function (fv) {
          return fv === true;
        });
      });

      setActiveTab(1);
      setFindingState(_findings);
      setActiveCategory(_selectedCategory);
      setSelectedGroups((_findings === null || _findings === void 0 ? void 0 : _findings.group) || []);
    }
  }, [isVisible]);

  var onCloseModal = function onCloseModal() {
    onClose();
    setFindingState({});
    setActiveCategory("");
  };

  var onChangeCategory = function onChangeCategory(value) {
    var _allFindings = (0,lodash.clone)(allFindings);

    var group = findingState.group;
    (0,lodash.forEach)(Object.keys(findingSections), function (key) {
      var findings = _allFindings[key];

      if (findings) {
        Object.keys(findings).forEach(function (f) {
          findings[f] = key === value;
        });
      }
    });
    setFindingState(_objectSpread(_objectSpread({}, _allFindings), {}, {
      group: group
    }));
    setActiveCategory(value);
  };

  var onChangeFindings = function onChangeFindings(categoryName, finding, val) {
    var _findingState = (0,lodash.clone)(findingState);

    (0,lodash.set)(_findingState, [categoryName, finding], val);
    setFindingState(_findingState);
  };

  var onChangeGroup = function onChangeGroup(groupId) {
    var _selectedGroups = (0,lodash.clone)(selectedGroups) || [];

    if (_selectedGroups.includes(groupId)) {
      _selectedGroups = _selectedGroups.filter(function (gId) {
        return gId !== groupId;
      });
    } else {
      _selectedGroups.push(groupId);
    }

    setSelectedGroups(_selectedGroups);
  };

  var onSave = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _findingState, params;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _findingState = (0,lodash.clone)(findingState);

              if (!(0,lodash.isEmpty)(_findingState)) {
                _findingState["group"] = selectedGroups === null || selectedGroups === void 0 ? void 0 : selectedGroups.filter(function (group) {
                  return allGroups.some(function (_ref3) {
                    var id = _ref3.id;
                    return group === id;
                  });
                });
              }

              if (findings !== null && findings !== void 0 && findings.id) {
                _findingState["id"] = findings === null || findings === void 0 ? void 0 : findings.id;
              }

              _context.prev = 3;
              params = {
                condition: _findingState
              };
              _context.next = 7;
              return saveCondition.mutateAsync({
                params: params,
                workspaceId: selectedWorkspaceId
              });

            case 7:
              setActiveTab(1);
              Toast/* default.success */.Z.success(t("rule.toast.saved_successfully"));
              onCloseModal();
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              setActiveTab(1);
              Toast/* default.error */.Z.error(t("rule.toast.saved_failed"));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));

    return function onSave() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onDelete = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var params;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setFindingState({});
              _context2.prev = 1;
              params = {
                condition: {
                  id: findings === null || findings === void 0 ? void 0 : findings.id
                }
              };
              _context2.next = 5;
              return deleteCondition.mutateAsync({
                params: params,
                workspaceId: selectedWorkspaceId
              });

            case 5:
              Toast/* default.success */.Z.success(t("rule.toast.deleted_successfully"));
              onCloseModal();
              setDeleteModal(false);
              setActiveTab(1);
              _context2.next = 16;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);
              setDeleteModal(false);
              setActiveTab(1);
              Toast/* default.error */.Z.error(t("rule.toast.deleted_failed"));

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 11]]);
    }));

    return function onDelete() {
      return _ref4.apply(this, arguments);
    };
  }();

  var filteredGroups = allGroups.filter(function (g) {
    return g.name.toLowerCase().includes(search.toLowerCase());
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      title: t(isEdit ? "conditional_modal.editing_title" : "conditional_modal.adding_title"),
      onClose: onCloseModal,
      show: isVisible,
      className: "flex flex-col w-full sm:w-8/12 xl:w-6/12 h-[90%] sm:h-auto max-h-[90%] overflow-y-auto sm:overflow-hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "m-4 text-left flex flex-col h-full sm:h-auto gap-y-2 sm:gap-y-0 sm:grid sm:grid-cols-12",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()("col-span-12 sm:col-span-5 space-y-3", {
            block: activeTab === 1,
            "hidden sm:block": activeTab === 2
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "space-y-3",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-base hidden sm:block",
              children: t("conditional_modal.from_workspace")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "pb-3 hidden sm:block",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SelectInput/* default */.Z, {
                options: workspaceOptions,
                value: selectedWorkspaceId,
                onChange: setSelectedWorkspaceId,
                disabled: selectedWorkspaceId && (workspaceOptions === null || workspaceOptions === void 0 ? void 0 : workspaceOptions.length) <= 1,
                className: "w-full b-3"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-base",
              children: t("conditional_modal.based_on_ai")
            }), !(0,lodash.isEmpty)(allFindings) && Object.keys(allFindings).map(function (categoryName) {
              var isSelected = categoryName === activeCategory;
              var findings = (0,lodash.get)(allFindings, [categoryName], {});
              var selectedFindings = (0,lodash.get)(findingState, [categoryName], {});
              var selectedCount = 0;

              if (isSelected) {
                selectedCount = Object.values(selectedFindings).filter(function (item) {
                  return item;
                }).length;
              }

              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex space-x-3 items-start py-2",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex flex-col items-center pt-2",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                    id: categoryName,
                    name: "aiFindings",
                    type: "radio",
                    value: categoryName,
                    checked: isSelected,
                    onChange: function onChange() {
                      return onChangeCategory(categoryName);
                    },
                    className: "h-5 w-5 border-gray-600 dark:border-gray-300 text-teal-400 bg-transparent cursor-pointer"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-col items-start",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: categoryName,
                    className: "text-gray-800 dark:text-gray-200 text-base cursor-pointer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: t(findingSections[categoryName])
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("text-teal-300", {
                      "cursor-not-allowed text-teal-500": !isSelected,
                      hidden: Object.keys(findings).length <= 1
                    }),
                    disabled: !isSelected,
                    onClick: function onClick() {
                      Store/* default.update */.Z.update(function (s) {
                        s.isAutomatedFindingsOpen = true;
                      });
                    },
                    children: selectedCount && selectedCount === Object.values(findings).length ? "All ".concat(categoryName === "forms" ? "forms" : "findings") : "".concat(selectedCount, " of ").concat(Object.values(findings).length, " ").concat(categoryName === "forms" ? "forms" : "findings")
                  })]
                })]
              }, categoryName);
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden sm:block sm:col-span-1 border-r mx-auto border-gray-700"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()("col-span-12 sm:col-span-6 space-y-4", {
            "hidden sm:block": activeTab === 1,
            block: activeTab === 2
          }),
          children: [activeTab === 2 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "space-y-3 sm:hidden",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-base",
              children: t("conditional_modal.from_workspace")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "pb-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(SelectInput/* default */.Z, {
                options: workspaceOptions,
                value: selectedWorkspaceId,
                onChange: setSelectedWorkspaceId,
                disabled: selectedWorkspaceId && (workspaceOptions === null || workspaceOptions === void 0 ? void 0 : workspaceOptions.length) <= 1,
                className: "w-full b-3"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-base",
            children: t("conditional_modal.share_with")
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "bg-gray-100 dark:bg-gray-900 py-3 rounded-lg",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "border-b border-gray-800",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                type: "text",
                id: "search",
                value: search,
                placeholder: t("conditional_modal.placeholder"),
                name: "search",
                onChange: function onChange(e) {
                  return setSearch(e.target.value);
                },
                className: "text-md placeholder:text-md bg-transparent placeholder:italic border-none w-full"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-80 sm:h-48 overflow-y-auto scrollbar-light dark:scrollbar",
              children: filteredGroups === null || filteredGroups === void 0 ? void 0 : filteredGroups.map(function (group, index) {
                var description = (0,lodash.get)(group, ["description"], []);
                var isSelected = selectedGroups && selectedGroups.includes(group === null || group === void 0 ? void 0 : group.id);
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center justify-between m-4 border-b border-gray-800 pb-4",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                    htmlFor: group === null || group === void 0 ? void 0 : group.id,
                    className: "flex space-x-2 items-center cursor-pointer w-full overflow-hidden whitespace-nowrap text-ellipsis",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "flex mr-2",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(UserIcon/* default */.Z, {
                        name: group === null || group === void 0 ? void 0 : group.name,
                        className: "h-7 w-7 text-base text-white p-4 dark:!bg-gray-700"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "flex flex-col w-full",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "text-gray-800 dark:text-gray-200 text-md",
                        children: group === null || group === void 0 ? void 0 : group.name
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "text-gray-900 dark:text-gray-400 text-md whitespace-nowrap text-ellipsis overflow-hidden flex",
                        children: description
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex ml-3",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                      id: group === null || group === void 0 ? void 0 : group.id,
                      "aria-describedby": "group",
                      name: "group",
                      type: "checkbox",
                      className: "rounded border-gray-600 dark:border-gray-400 cursor-pointer text-teal-400 bg-transparent",
                      checked: isSelected,
                      onChange: function onChange(e) {
                        return onChangeGroup(group === null || group === void 0 ? void 0 : group.id);
                      }
                    })
                  })]
                }, index);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex justify-end",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
              isSecondary: true,
              className: "sm:grow-1 sm:w-48 space-x-3 flex bg-gray-800 sm:bg-gray-700",
              onClick: function onClick() {
                return Store/* default.update */.Z.update(function (s) {
                  s.isUserGroupOpen = true;
                });
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_solid_svg_icons/* faUsers */.FVb,
                className: "block text-teal-300 sm:text-white cursor-pointer"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-teal-300 sm:text-white",
                children: t("conditional_modal.manage_groups")
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-span-12 border-t border-gray-800 w-full mt-4 flex flex-col justify-end flex-1",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex items-center flex-row justify-between p-4 border-t border-t-gray-600",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex items-center justify-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                // onClick={onDelete}
                onClick: function onClick() {
                  return setDeleteModal(true);
                },
                className: classnames_default()("flex cursor-pointer", {
                  hidden: !isEdit
                }),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                  name: pro_regular_svg_icons/* faTrash */.XAH,
                  className: "dark:text-gray-200 text-gray-700"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "pl-2",
                  children: t("button.delete")
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center justify-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                isSecondary: true,
                className: "grow-1 w-24 sm:w-40",
                onClick: function onClick() {
                  if (activeTab === 2) {
                    setActiveTab(1);
                  } else {
                    onCloseModal();
                  }
                },
                children: activeTab === 2 ? t("back_key") : t("button.cancel")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                isPrimary: true //   isLoading={saveNotificationSettings.isLoading}
                ,
                onClick: function onClick() {
                  return setActiveTab(2);
                },
                className: classnames_default()("sm:mt-0 sm:hidden grow-1 ml-4 w-24 sm:w-40", {
                  hidden: activeTab === 2
                }),
                disabled: (0,lodash.isEmpty)(activeCategory),
                children: t("button.next")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                isPrimary: true //   isLoading={saveNotificationSettings.isLoading}
                ,
                onClick: onSave,
                className: classnames_default()("sm:mt-0 grow-1 ml-4 w-24 sm:w-40", {
                  "hidden sm:block": activeTab === 1
                }),
                disabled: (0,lodash.isEmpty)(activeCategory) || (0,lodash.isEmpty)(selectedGroups),
                children: t("button.save")
              })]
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AutomatedShare_FindingsModal, {
      allFindings: (0,defineProperty/* default */.Z)({}, activeCategory, allFindings[activeCategory]),
      selectedFindings: findingState[activeCategory],
      activeCategory: activeCategory,
      onChange: onChangeFindings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AutomatedShare_DeleteModal, {
      deleteModal: deleteModal,
      onDelete: onDelete,
      setDeleteModal: setDeleteModal,
      title: t("conditional_modal.delete_title"),
      content: t("conditional_modal.delete_content")
    })]
  });
};

ConditionsModal.defaultProps = {
  onChange: function onChange() {}
};
/* harmony default export */ var AutomatedShare_ConditionsModal = (ConditionsModal);
;// CONCATENATED MODULE: ./components/AutomatedShare/services/useGetConditions.js



var useGetConditions = function useGetConditions(isOpen, workspaceId) {
  return (0,es.useQuery)(["userGroups", isOpen, workspaceId], function () {
    return servicesUtils/* default.getService */.Z.getService("/workspaces/".concat(workspaceId, "/routing/"));
  }, {
    enabled: isOpen && !!workspaceId
  });
};

/* harmony default export */ var services_useGetConditions = (useGetConditions);
// EXTERNAL MODULE: ./components/UserGroupManagement/services/useGetUserGroups.js
var useGetUserGroups = __webpack_require__(85883);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useWorkspaceData.ts



function useWorkspacesData(_ref) {
  var isOpen = _ref.isOpen;
  return (0,es.useQuery)("workspaceData", function () {
    return servicesUtils/* default.getService */.Z.getService("/workspaces/");
  }, {
    enabled: isOpen
  });
}

/* harmony default export */ var useWorkspaceData = (useWorkspacesData);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(65735);
;// CONCATENATED MODULE: ./components/AutomatedShare/index.jsx
















var findingSections = {
  qer: "automated_share.qer",
  qxr: "automated_share.qxr",
  qct: "automated_share.qct",
  qmsk: "automated_share.qmsk",
  forms: "automated_share.forms",
  emergency: "automated_share.emergency"
};

function AutomatedShare(_ref) {
  var isVisible = _ref.isVisible;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      isEditConditionOpen = _useState[0],
      toggleEditCondition = _useState[1];

  var _useState2 = (0,react.useState)({}),
      currentCondition = _useState2[0],
      setCurrentCondition = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      selectedWorkspaceId = _useState3[0],
      setSelectedWorkspaceId = _useState3[1];

  var _useGetConditions = services_useGetConditions(isVisible, selectedWorkspaceId),
      conditionsData = _useGetConditions.data,
      refetchConditions = _useGetConditions.refetch;

  var _useWorkspacesData = useWorkspaceData(isVisible),
      workspaceData = _useWorkspacesData.data;

  var _useGetUserGroups = (0,useGetUserGroups/* default */.Z)(isVisible),
      userGroupdData = _useGetUserGroups.data,
      refetchUserGroups = _useGetUserGroups.refetch;

  var groups = (0,lodash.get)(userGroupdData, ["groups"], []);
  var conditions = (0,lodash.get)(conditionsData, ["conditions"], []);
  var allFindings = (0,lodash.get)(conditionsData, ["default_false_keys"], {});
  var ownedWorkspaces = (0,lodash.get)(workspaceData, ["owned_workspaces"], []);
  var workspaceOptions = ownedWorkspaces.map(function (w) {
    return {
      id: w.id,
      label: w.name,
      value: w.id
    };
  });
  (0,react.useEffect)(function () {
    var _selectedWorkspaceId = (0,lodash.get)(workspaceOptions, [0, "id"], 0);

    setSelectedWorkspaceId(_selectedWorkspaceId);
  }, [workspaceData]);

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isUserGroupOpen: s.isUserGroupOpen
    };
  }),
      isUserGroupOpen = _useStoreState.isUserGroupOpen;

  (0,react.useEffect)(function () {
    if (isVisible && window.isUserGroupOpen && !isUserGroupOpen) {
      window.isUserGroupOpen = false;
      refetchUserGroups();
    }

    if (isUserGroupOpen) {
      window.isUserGroupOpen = true;
    }
  }, [isVisible, isUserGroupOpen]);

  var onCloseConditionModel = function onCloseConditionModel() {
    toggleEditCondition(false);
    setCurrentCondition({});
    refetchConditions();
  };

  var getCriteria = function getCriteria(condition) {
    var result = "";

    if (!(0,lodash.isEmpty)(condition)) {
      var categories = Object.keys(condition);
      var checkedCounts = {};
      categories.forEach(function (key) {
        var findings = condition[key];
        var checkedFindings = Object.keys(findings).filter(function (f) {
          return findings[f];
        });

        if (checkedFindings.length) {
          checkedCounts[key] = checkedFindings.length;
        }
      });
      Object.keys(checkedCounts).forEach(function (key, index) {
        if (findingSections[key]) {
          result += "".concat(checkedCounts[key], " ").concat(t(findingSections[key]));
        }
      });
    }

    return result;
  };

  var getGroupNames = function getGroupNames(condition) {
    var result = "";
    var selectedGroups = (0,lodash.get)(condition, ["group"], []);
    selectedGroups.forEach(function (groupId, index) {
      var groupObj = groups.find(function (g) {
        return g.id === groupId;
      });

      if (groupObj) {
        result += "".concat(index != 0 ? "," : "", " ").concat(groupObj === null || groupObj === void 0 ? void 0 : groupObj.name);
      }
    });
    return result;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "m-4 flex flex-col text-left space-y-4 h-full sm:h-[420px]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-base",
          children: t("automated_share.conditional")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-md text-gray-800 dark:text-gray-300",
          children: t("automated_share.text")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center border border-gray-700 rounded-lg pl-3 py-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-base",
          children: [t("workspace_key"), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectInput/* default */.Z, {
          options: workspaceOptions,
          value: selectedWorkspaceId,
          onChange: setSelectedWorkspaceId,
          disabled: selectedWorkspaceId && (workspaceOptions === null || workspaceOptions === void 0 ? void 0 : workspaceOptions.length) <= 1,
          className: "w-full ml-3 border-none"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "space-y-3 flex-1 max-h-80 sm:max-h-96 overflow-y-auto scrollbar-light dark:scrollbar",
        children: conditions && (conditions === null || conditions === void 0 ? void 0 : conditions.map(function (condition, index) {
          var criteria = getCriteria(condition);
          var groups = getGroupNames(condition);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "bg-gray-300 dark:bg-gray-900 flex justify-between px-4 py-5 w-full rounded-lg cursor-pointer",
            onClick: function onClick() {
              setCurrentCondition((0,lodash.clone)(condition));
              toggleEditCondition(true);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "space-y-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "text-gray-700 dark:text-gray-500 uppercase text-base",
                children: [t("automated_share.condition"), " ", index + 1]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "text-md text-gray-800 dark:text-gray-200",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "text-teal-500 dark:text-teal-300",
                  children: [t("automated_share.criteria"), " "]
                }), criteria, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-gray-700",
                  children: "|"
                }), " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "text-teal-500 dark:text-teal-300",
                  children: [t("automated_share.shared_with"), " "]
                }), groups]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
              name: pro_light_svg_icons/* faPenToSquare */.Yai,
              className: "block text-gray-700 darK:text-gray-500"
            })]
          }, index);
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        onClick: function onClick() {
          toggleEditCondition(true);
        },
        className: "inline-flex border bg-gray-600 dark:border-teal-300 dark:hover:border-teal-800 dark:bg-transparent dark:hover:bg-teal-800 hover:bg-teal-800 w-full space-x-4 items-center justify-center text-base font-medium rounded-6 text-gray-100 py-4 px-4 !mb-4 sm:!mb-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
          name: pro_regular_svg_icons/* faPlus */.r8p,
          className: "block text-white cursor-pointer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: t("automated_share.rule_button")
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AutomatedShare_ConditionsModal, {
      allFindings: allFindings,
      isVisible: isEditConditionOpen,
      onClose: onCloseConditionModel,
      findings: currentCondition,
      groups: groups,
      workspaceOptions: workspaceOptions,
      currentWorkspaceId: selectedWorkspaceId
    })]
  });
}

AutomatedShare.defaultProps = {
  onClose: function onClose() {},
  isModal: false,
  isVisible: false
};
/* harmony default export */ var components_AutomatedShare = (AutomatedShare);
;// CONCATENATED MODULE: ./components/AutomatedShare/AutomatedShareModal.jsx







var AutomatedShareModal = function AutomatedShareModal() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isAutomatedSharingOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var onCloseModal = function onCloseModal() {
    Store/* default.update */.Z.update(function (s) {
      s.isAutomatedSharingOpen = false;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    title: t("automated_share.title"),
    onClose: onCloseModal,
    show: isVisible,
    className: "flex flex-col w-full sm:w-7/12 lg:w-6/12 xl:w-4/12 h-auto !max-h-[90%] overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_AutomatedShare, {
      isModal: true,
      isVisible: isVisible,
      onClose: onCloseModal
    })
  });
};

/* harmony default export */ var AutomatedShare_AutomatedShareModal = (AutomatedShareModal);
// EXTERNAL MODULE: ./hooks/useMedia.ts
var useMedia = __webpack_require__(41148);
// EXTERNAL MODULE: ./utils/downloadApp.ts
var downloadApp = __webpack_require__(29950);
;// CONCATENATED MODULE: ./utils/configureDCMIO.ts



var _process$env$NEXT_PUB;



function configureDCMIO_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function configureDCMIO_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? configureDCMIO_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : configureDCMIO_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var axios = __webpack_require__(9669);

var DCMIO_BASE_URL = "http://127.0.0.1:7000";
var PLATFORM_API_URL = "".concat("https://platformapius-rsna.qure.ai").concat(((_process$env$NEXT_PUB = "https://platformapius-rsna.qure.ai") === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.charAt("https://platformapius-rsna.qure.ai".length - 1)) === "/" ? "" : "/"); // putting the base config in code only

var PLATFORM_DCMIO_JSON_TEMPLATE = JSON.stringify({
  version: 1,
  api: {
    base_url: "",
    token: "",
    user: "dcmio_dev",
    source: "dcmio_dev",
    timeout: 180,
    sitename: "",
    num_threads: 5
  },
  sync: {
    enabled: true,
    frequency: 900,
    server: "https://dcsm.qure.ai/",
    token: "0a68ac0ac6d54ff6fa6780437675c83265b6b267",
    timeout: 30,
    api: {
      path: "config/sync/"
    }
  },
  update: {
    enabled: true,
    type: "auto",
    confirmation: true,
    flavour: "standard",
    version: null
  },
  system: {
    groups: {
      series: ["CT", "CR", "DX", "DR"],
      instance: []
    },
    stability: {
      type: "series",
      check_delay: 16,
      process_delay: 15
    }
  },
  filter: {
    query: "True",
    enabled: false
  },
  upload: {
    api: {
      path: "studies"
    },
    batch_size: 32,
    compression: {
      enabled: true,
      options: "+eb"
    },
    anonymization: {
      enabled: false,
      fields: ["PatientID", "PatientName", "InstitutionName", "InstitutionAddress", "ReferringPhysicianName", "OperatorsName", "PatientBirthDate", "StationName", "AdditionalPatientHistory", "PatientComments", "PlateID", "AdmissionID", "ConfidentialityOnPatientDataDescr"],
      algorithms: {
        "default": {
          type: "random"
        },
        PatientID: {
          type: "hash",
          fields: ["PatientID", "StudyID"]
        }
      }
    }
  },
  compute: {
    enabled: false,
    api: {
      path: "compute",
      parameters: {
        recompute: "True"
      }
    }
  },
  results: {
    enabled: true,
    api: {
      path: "results"
    },
    cases: {
      success: [{
        status: 200,
        results: {
          success: true
        }
      }, {
        status: 400,
        results: {
          success: false
        }
      }, {
        status: 500,
        results: {
          success: false
        }
      }],
      try_again: [{
        status: 200,
        results: {
          success: false
        }
      }, {
        status: 202
      }, {
        status: 409
      }]
    }
  },
  publishers: [{
    type: "logging",
    common: {
      enabled: true
    }
  }],
  cleanup: {
    enabled: true,
    frequency: 600,
    all_series: {
      delay: 21600,
      enabled: true
    },
    processed_series: {
      delay: 3600,
      enabled: true,
      creation_delay: 3600
    },
    processing_tasks: {
      delay: 0,
      enabled: true
    },
    registration_tasks: {
      delay: 0,
      enabled: true
    }
  }
});

function populatePlatformJson(platformJson, values) {
  platformJson.api = configureDCMIO_objectSpread(configureDCMIO_objectSpread({}, platformJson.api), values);
}

function postDcmioConfig(_x) {
  return _postDcmioConfig.apply(this, arguments);
} // no error checking, im not sure what the contracts of the API are when it succeeds, please do any checking you want


function _postDcmioConfig() {
  _postDcmioConfig = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(config) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post("".concat(DCMIO_BASE_URL, "/config/"), config);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _postDcmioConfig.apply(this, arguments);
}

function transformedUserDataToDcmioApi(userData) {
  return {
    token: userData.token,
    user: userData.username,
    source: userData.sources[0],
    base_url: PLATFORM_API_URL
  };
}

function getUserData() {
  return _getUserData.apply(this, arguments);
}

function _getUserData() {
  _getUserData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var result;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return servicesUtils/* default.getService */.Z.getService("/accounts/userinfo/");

          case 2:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getUserData.apply(this, arguments);
}

function configureDcmio() {
  return _configureDcmio.apply(this, arguments);
}

function _configureDcmio() {
  _configureDcmio = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var platformJson, userData, api;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            platformJson = JSON.parse(PLATFORM_DCMIO_JSON_TEMPLATE); // please use whatever funciton you use for getUserData

            _context3.next = 3;
            return getUserData();

          case 3:
            userData = _context3.sent;
            api = transformedUserDataToDcmioApi(userData);
            populatePlatformJson(platformJson, api);
            _context3.next = 8;
            return postDcmioConfig(platformJson);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _configureDcmio.apply(this, arguments);
}

/* harmony default export */ var configureDCMIO = (configureDcmio);
;// CONCATENATED MODULE: ./components/ConfigureDCMIO.tsx

var __jsx = react.createElement;






function ConfigureDCMIO() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/react.createElement("p", {
    className: "text-[14px]"
  }, t("enterprise_users"), ",", " ", /*#__PURE__*/react.createElement("span", {
    className: "text-teal-400 hover:text-teal-500 dark:text-teal-200 dark:hover:text-teal-300 cursor-pointer",
    onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return configureDCMIO();

            case 3:
              Toast/* default.success */.Z.success(t("toast.configured_successfully"));
              Store/* default.update */.Z.update(function (s) {
                s.isConnectModalityOpen = false;
              });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              Toast/* default.error */.Z.error(t("error_key"));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))
  }, t("configure_dcmio")));
}
;// CONCATENATED MODULE: ./components/ConnectModality.tsx
var ConnectModality_jsx = react.createElement;













var ConnectModality = function ConnectModality() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isMobile = (0,useMedia/* default */.Z)([useMedia/* MediaSizes.MOBILE */._.MOBILE], [true], false);

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isConnectModalityOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var getIP = function getIP() {
    try {
      return window.electronAPI.getIP();
    } catch (err) {
      return "Refer to System Settings";
    }
  };

  var DesktopAppInstructions = function DesktopAppInstructions() {
    return /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col justify-between h-full pt-6 pb-3 text-left"
    }, /*#__PURE__*/react.createElement("div", {
      className: "h-full pb-6 px-6"
    }, /*#__PURE__*/react.createElement("p", null, t("connection_modality.enter_message")), /*#__PURE__*/react.createElement("div", {
      className: "py-6"
    }, /*#__PURE__*/react.createElement("div", {
      className: "py-2 flex "
    }, /*#__PURE__*/react.createElement("div", {
      className: "min-w-[100px] text-start"
    }, "AE Title:"), /*#__PURE__*/react.createElement("div", {
      className: "bg-gray-700 rounded text-center px-3"
    }, "QUREAI")), /*#__PURE__*/react.createElement("div", {
      className: "py-2 flex"
    }, /*#__PURE__*/react.createElement("div", {
      className: "min-w-[100px] text-start"
    }, "IP:"), /*#__PURE__*/react.createElement("div", {
      className: "bg-gray-700 rounded text-center px-3"
    }, getIP())), /*#__PURE__*/react.createElement("div", {
      className: "py-2 flex"
    }, /*#__PURE__*/react.createElement("div", {
      className: "min-w-[100px] text-start"
    }, "Port:"), /*#__PURE__*/react.createElement("div", {
      className: "bg-gray-700 rounded text-center px-3"
    }, "5253"))), /*#__PURE__*/react.createElement("div", {
      className: "text-md rounded border border-gray-700 p-4"
    }, t("connection_modality.note"), /*#__PURE__*/react.createElement("br", null), t("connection_modality.not_work")), /*#__PURE__*/react.createElement(ConfigureDCMIO, null)), /*#__PURE__*/react.createElement("div", {
      className: "px-6"
    }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
      className: "grow-1 !px-5 py-3",
      onClick: function onClick() {
        return window.location.href = "mailto:support@qure.ai";
      }
    }, /*#__PURE__*/react.createElement(AwesomeIcon/* default */.Z, {
      name: pro_regular_svg_icons/* faCircleQuestion */.FDd,
      className: "w-6 mr-3"
    }), t("connection_modality.request_support"))));
  };

  var OtherInstructions = function OtherInstructions() {
    return /*#__PURE__*/react.createElement("div", {
      className: "flex flex-col justify-center items-center h-full"
    }, /*#__PURE__*/react.createElement("div", {
      className: "p-6 text-left text-gray-600 dark:text-gray-300"
    }, /*#__PURE__*/react.createElement("p", {
      className: "pb-5 font-normal"
    }, t("connection_modality.use_message")), /*#__PURE__*/react.createElement(ConfigureDCMIO, null)), !isMobile && /*#__PURE__*/react.createElement("div", {
      className: "flex items-center justify-end border-t border-t-gray-600 w-full p-4"
    }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
      onClick: function onClick() {
        window.open("/open-app", "_blank");
      },
      className: "grow-1 px-6 py-4 hidden"
    }, t("connection_modality.launch_desktop_app")), /*#__PURE__*/react.createElement("a", {
      href: "/open-app",
      target: "_blank",
      className: "text-gray-600 dark:text-white px-4"
    }, t("installed_qure_app")), /*#__PURE__*/react.createElement(Button/* default */.Z, {
      className: "grow-1 px-6 py-4 ml-4",
      onClick: downloadApp/* default */.Z,
      isPrimary: true
    }, t("connection_modality.download_qure_app"))));
  };

  var onClose = function onClose() {
    Store/* default.update */.Z.update(function (s) {
      s.isConnectModalityOpen = false;
    });
  };

  return /*#__PURE__*/react.createElement(Modal/* default */.Z, {
    show: isVisible,
    onClose: onClose,
    title: t("setting_connection"),
    className: classnames_default()("w-full", {
      "sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12": window.electronAPI,
      "sm:w-9/12 md:w-8/12 lg:w-4/12 xl:w-4/12": !window.electronAPI
    }),
    closeOnClickAway: true
  }, window.electronAPI ? /*#__PURE__*/react.createElement(DesktopAppInstructions, null) : /*#__PURE__*/react.createElement(OtherInstructions, null));
};

/* harmony default export */ var components_ConnectModality = (ConnectModality);
// EXTERNAL MODULE: ./utils/redirectToLogin.ts
var redirectToLogin = __webpack_require__(47472);
;// CONCATENATED MODULE: ./components/Logout/services/logoutService.js



var useLogoutService = function useLogoutService() {
  return (0,es.useMutation)(function () {
    return servicesUtils/* default.getService */.Z.getService("/accounts/logout/", {
      next: window.location.href
    });
  });
};

/* harmony default export */ var services_logoutService = (useLogoutService);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(41065);
// EXTERNAL MODULE: ./utils/pushNotification.ts
var pushNotification = __webpack_require__(80271);
;// CONCATENATED MODULE: ./components/Logout/services/unregisterService.ts



var useUnregisterNotification = function useUnregisterNotification() {
  return (0,es.useMutation)(function (token) {
    return (0,pushNotification/* unRegisterSubscription */.rt)(token);
  });
};

/* harmony default export */ var unregisterService = (useUnregisterNotification);
;// CONCATENATED MODULE: ./components/Logout/index.jsx















var Logout = function Logout() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isLogoutOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var logoutService = services_logoutService();
  var unregisterNotification = unregisterService();

  var _useStoreState2 = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      RNfcmToken: s.RNfcmToken,
      fcmToken: s.fcmToken
    };
  }),
      fcmToken = _useStoreState2.fcmToken,
      RNfcmToken = _useStoreState2.RNfcmToken;

  var onCloseLogout = function onCloseLogout() {
    Store/* default.update */.Z.update(function (s) {
      s.isLogoutOpen = false;
    });
  };

  var onLogout = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _window, _localStorage, _localStorage2, _localStorage3, _localStorage4, _localStorage5, _localStorage6, old_fcmToken, response;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              old_fcmToken = (_window = window) === null || _window === void 0 ? void 0 : _window.localStorage.getItem(constants/* default.PERSISTED.fcmToken */.Z.PERSISTED.fcmToken);

              if (!(RNfcmToken || fcmToken || old_fcmToken)) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return unregisterNotification.mutateAsync(RNfcmToken || fcmToken || old_fcmToken);

            case 5:
              _context.next = 7;
              return logoutService.mutateAsync();

            case 7:
              response = _context.sent;

              // desktop app integration
              if (window.electronAPI) {
                window.electronAPI.setAPISettings({
                  apiURL: null,
                  token: null
                });
              } // localStorage cleanup


              (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.removeItem(constants/* default.PERSISTED.fcmToken */.Z.PERSISTED.fcmToken);
              (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.removeItem(constants/* default.PERSISTED.filterObj */.Z.PERSISTED.filterObj);
              (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.removeItem(constants/* default.PERSISTED.savedFilterData */.Z.PERSISTED.savedFilterData);
              (_localStorage4 = localStorage) === null || _localStorage4 === void 0 ? void 0 : _localStorage4.removeItem(constants/* default.PERSISTED.isFullWidthWorklist */.Z.PERSISTED.isFullWidthWorklist);
              (_localStorage5 = localStorage) === null || _localStorage5 === void 0 ? void 0 : _localStorage5.removeItem(constants/* default.PERSISTED.isSwiftReportModeEnabled */.Z.PERSISTED.isSwiftReportModeEnabled);
              (_localStorage6 = localStorage) === null || _localStorage6 === void 0 ? void 0 : _localStorage6.removeItem(constants/* default.PERSISTED.notificationPromptDismiss */.Z.PERSISTED.notificationPromptDismiss); // keycloak logout

              window.location.replace(response === null || response === void 0 ? void 0 : response.keycloak_logout_url);
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              Toast/* default.error */.Z.error(t("toast.something_went_wrong"));
              (0,redirectToLogin/* default */.Z)();

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    }));

    return function onLogout() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default */.Z, {
    show: isVisible,
    onClose: onCloseLogout,
    title: "Confirm Logout?",
    className: "w-full sm:w-5/12 lg:w-4/12",
    closeOnClickAway: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "p-6",
      children: "Are you sure you want to logout?"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center flex-col sm:justify-end sm:flex-row p-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        isSecondary: true,
        className: "grow-1 ml-4 w-full sm:w-auto",
        onClick: onCloseLogout,
        children: "Cancel"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        isPrimary: true,
        isLoading: logoutService.isLoading || unregisterNotification.isLoading,
        className: "mt-3 sm:mt-0 grow-1 ml-4 w-full sm:w-auto",
        onClick: onLogout,
        children: "Logout"
      })]
    })]
  });
};

/* harmony default export */ var components_Logout = (Logout);
// EXTERNAL MODULE: ./components/Menubar.tsx + 3 modules
var Menubar = __webpack_require__(21951);
// EXTERNAL MODULE: ./components/NotificationSettings/index.js + 7 modules
var NotificationSettings = __webpack_require__(58980);
;// CONCATENATED MODULE: ./components/NotificationSettings/NotificationSettingsModal.jsx







var NotificationSettingsModal = function NotificationSettingsModal() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isNotificationSettingsOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var onCloseModal = function onCloseModal() {
    Store/* default.update */.Z.update(function (s) {
      s.isNotificationSettingsOpen = false;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    title: t("setting_notification"),
    onClose: onCloseModal,
    show: isVisible,
    className: "flex flex-col w-full sm:w-7/12 lg:w-6/12 xl:w-4/12 h-4/5 overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationSettings/* default */.Z, {
      isModal: true,
      isVisible: isVisible,
      onClose: onCloseModal
    })
  });
};

/* harmony default export */ var NotificationSettings_NotificationSettingsModal = (NotificationSettingsModal);
// EXTERNAL MODULE: ./components/Patients/PatientsContext.tsx + 3 modules
var PatientsContext = __webpack_require__(65684);
// EXTERNAL MODULE: ./components/common/DebounceInput.tsx
var DebounceInput = __webpack_require__(64407);
// EXTERNAL MODULE: ./components/Report/ReportEditor.jsx + 8 modules
var ReportEditor = __webpack_require__(76720);
// EXTERNAL MODULE: ./components/ReportTemplate/services/useAddTemplate.js
var useAddTemplate = __webpack_require__(51510);
;// CONCATENATED MODULE: ./components/ReportTemplate/services/useEditTemplate.js




var useEditTemplate = function useEditTemplate() {
  return (0,es.useMutation)(function (_ref) {
    var payload = _ref.payload,
        id = _ref.id;
    return servicesUtils/* default.postService */.Z.postService("/report_templates/".concat(id, "/"), payload);
  });
};

/* harmony default export */ var services_useEditTemplate = (useEditTemplate);
;// CONCATENATED MODULE: ./components/ReportTemplate/PreviewTemplateModal.jsx




function PreviewTemplateModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PreviewTemplateModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PreviewTemplateModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PreviewTemplateModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















function PreviewTemplateModal(_ref) {
  var currentReport = _ref.currentReport,
      isVisible = _ref.isVisible,
      onClose = _ref.onClose,
      updatedDetails = _ref.updatedDetails,
      isPinned = _ref.isPinned,
      refetchReports = _ref.refetchReports;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var addTemplate = (0,useAddTemplate/* default */.Z)();
  var editTemplate = services_useEditTemplate();

  var onCloseModal = function onCloseModal() {
    onClose();
  };

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      userInfo: s.userInfo
    };
  }),
      userInfo = _useStoreState.userInfo;

  var default_filter = (0,lodash.get)(userInfo, ["settings", "saved_filters"], []);
  var cxr_saved_filter_data = default_filter === null || default_filter === void 0 ? void 0 : default_filter.filter(function (filter) {
    return filter.name === constants/* default.DEFAULT_FILTER_NAME.negativeCXR */.Z.DEFAULT_FILTER_NAME.negativeCXR && filter.is_default;
  })[0];

  var onSave = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var name, modality, template, id, payload;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                name = updatedDetails.name, modality = updatedDetails.modality, template = updatedDetails.template, id = updatedDetails.id;
                payload = {
                  name: name,
                  modality: modality,
                  template: template,
                  is_pinned: isPinned
                };

                if (isPinned) {
                  payload = PreviewTemplateModal_objectSpread(PreviewTemplateModal_objectSpread({}, payload), {}, {
                    filter_data: cxr_saved_filter_data === null || cxr_saved_filter_data === void 0 ? void 0 : cxr_saved_filter_data.filter,
                    filter_name: cxr_saved_filter_data === null || cxr_saved_filter_data === void 0 ? void 0 : cxr_saved_filter_data.name
                  });
                }

                if (id) {
                  editTemplate.mutateAsync({
                    payload: payload,
                    id: id
                  }).then(function () {
                    refetchReports();
                    Toast/* default.success */.Z.success(t("report_templates.toast.update_success"));
                  })["catch"](function (err) {
                    Toast/* default.error */.Z.error(t("report_templates.toast.update_failed"));
                  });
                } else {
                  addTemplate.mutateAsync(payload).then(function () {
                    refetchReports();
                    Toast/* default.success */.Z.success(t("report_templates.toast.created_success"));
                  })["catch"](function (err) {
                    Toast/* default.error */.Z.error(t("report_templates.toast.update_failed"));
                  });
                }

                onClose(true);
              } catch (err) {
                onClose(true);
                Toast/* default.error */.Z.error(t("report_templates.toast.update_failed"));
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSave() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    show: isVisible,
    onClose: onCloseModal,
    title: t("setting_report"),
    className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12" // closeOnClickAway
    ,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col mt-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "px-4 bg-white m-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full text-gray-800 text-left h-[345px] overflow-scroll rounded-lg my-4",
          children: currentReport && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lexical-preview",
            dangerouslySetInnerHTML: {
              __html: currentReport
            }
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "border-t px-4 space-x-4 border-gray-700 py-4 flex items-center justify-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isSecondary: true,
          className: "grow-1 flex space-x-2 px-6 py-4 ml-4",
          onClick: function onClick() {
            onClose();
          },
          isPrimary: false,
          children: t("report_templates.back_editing_button")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isSecondary: true,
          className: "grow-1 flex space-x-2 px-6 py-4 ml-4",
          onClick: onSave,
          isPrimary: true,
          children: t("button.save")
        })]
      })]
    })
  });
}

/* harmony default export */ var ReportTemplate_PreviewTemplateModal = (PreviewTemplateModal);
;// CONCATENATED MODULE: ./components/ReportTemplate/services/useDeleteTemplate.js



var useDeleteTemplate = function useDeleteTemplate() {
  return (0,es.useMutation)(function (id) {
    return servicesUtils/* default.postService */.Z.postService("/report_templates/".concat(id, "/delete/"));
  });
};

/* harmony default export */ var services_useDeleteTemplate = (useDeleteTemplate);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/combobox/combobox.js
var combobox = __webpack_require__(94789);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(44080);
// EXTERNAL MODULE: ./utils/regexValidation.js
var regexValidation = __webpack_require__(22687);
;// CONCATENATED MODULE: ./components/ReportTemplate/SaveTemplateModal.jsx



function SaveTemplateModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SaveTemplateModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SaveTemplateModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SaveTemplateModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var modalityList = [{
  id: 1,
  name: "CR/DR/DX",
  value: "CR/DR/DX"
}, {
  id: 2,
  name: "CT",
  value: "CT"
}, {
  id: 3,
  name: "MRI",
  value: "MRI"
}, {
  id: 4,
  name: "CTA",
  value: "CTA"
}, {
  id: 5,
  name: "CTP",
  value: "CTP"
}, {
  id: 6,
  name: "NCCT",
  value: "NCCT"
}, {
  id: 7,
  name: "Other",
  value: "Other"
}];

function SaveTemplateModal(_ref) {
  var _selectedTemplate$tem;

  var selectedTemplate = _ref.selectedTemplate,
      isVisible = _ref.isVisible,
      _onClose = _ref.onClose,
      isPinned = _ref.isPinned,
      refetchReports = _ref.refetchReports;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(),
      templateName = _useState[0],
      setTemplateName = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTemplatePreviewModal = _useState2[0],
      setIsTemplatePreviewModal = _useState2[1];

  var _useState3 = (0,react.useState)(modalityList[0]),
      templateModality = _useState3[0],
      setTemplateModality = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      currentReport = _useState4[0],
      setCurrentReport = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      error = _useState5[0],
      setError = _useState5[1];

  var impression = (_selectedTemplate$tem = selectedTemplate.template) !== null && _selectedTemplate$tem !== void 0 ? _selectedTemplate$tem : "";

  var _useState6 = (0,react.useState)(""),
      query = _useState6[0],
      setQuery = _useState6[1];

  var deleteGroup = services_useDeleteTemplate();

  var onCloseModal = function onCloseModal() {
    _onClose();

    setError("");
  };

  var onClosePreviewModal = function onClosePreviewModal(key) {
    setIsTemplatePreviewModal(false);

    if (key) {
      onCloseModal();
    }
  };

  var filteredModality = query === "" ? modalityList : modalityList.filter(function (modality) {
    return modality.name.toLowerCase().replace(/\s+/g, "").includes(query.toLowerCase().replace(/\s+/g, ""));
  });

  var onDelete = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return deleteGroup.mutateAsync(selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.id);

            case 3:
              onCloseModal();
              Toast/* default.success */.Z.success(t("report_templates.toast.delete_success"));
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              onCloseModal();
              Store/* default.update */.Z.update(function (s) {
                s.isReportTemplateOpen = false;
              });
              Toast/* default.error */.Z.error(t("report_templates.toast.delete_failed"));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onDelete() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (selectedTemplate) {
      setTemplateModality(selectedTemplate.modality);
      setTemplateName(selectedTemplate.name);
    }
  }, [selectedTemplate]);

  var handlePreviewModal = function handlePreviewModal() {
    var validationResults = (0,regexValidation/* validateFields */.Of)([{
      fn: regexValidation/* customRegexValidation */.dc,
      value: templateName,
      err: " ".concat(t("report_templates.validation.special_char"), ",")
    }, {
      fn: regexValidation/* startCharCheckValidation */.UY,
      value: templateName,
      err: " ".concat(t("report_templates.validation.start"), ",")
    }]);

    if (validationResults) {
      setError(validationResults);
    } else {
      setIsTemplatePreviewModal(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: isVisible,
      onClose: function onClose() {
        _onClose();
      },
      title: t("setting_report"),
      className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12" // closeOnClickAway
      ,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col h-full mt-4 pt-6",
        onClick: function onClick(e) {
          return e.preventDefault();
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "px-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex space-x-8 justify-between items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex w-2/3 space-x-6 items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                id: "name",
                className: "text-[14px]",
                children: t("name_key")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                className: "rounded-lg w-full border-none text-gray-800 bg-gray-100 dark:bg-white disabled:bg-gray-300 disabled:dark:bg-gray-300",
                type: "text",
                defaultValue: templateName,
                onChange: function onChange(e) {
                  return setTemplateName(e.target.value);
                },
                disabled: isPinned,
                id: "name"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex space-x-6 items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                id: "modality",
                className: "text-[14px]",
                children: t("modality_key")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "relative z-10",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(combobox/* Combobox */.h, {
                  value: templateModality,
                  onChange: setTemplateModality,
                  disabled: isPinned,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "relative mt-1",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(combobox/* Combobox.Input */.h.Input, {
                        className: "w-full border-none bg-gray-100 disabled:bg-gray-300 disabled:dark:bg-gray-300 text-gray-800 focus:ring-0",
                        displayValue: function displayValue(item) {
                          return item;
                        },
                        onChange: function onChange(event) {
                          return setQuery(event.target.value);
                        }
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(combobox/* Combobox.Button */.h.Button, {
                        className: "absolute inset-y-0 right-0 flex items-center pr-2",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                          name: pro_regular_svg_icons/* faAngleDown */.gc2,
                          className: "h-5 w-5 text-gray-600 hover:text-teal-600"
                        })
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
                      as: react.Fragment,
                      leave: "transition ease-in duration-100",
                      leaveFrom: "opacity-100",
                      leaveTo: "opacity-0",
                      afterLeave: function afterLeave() {
                        return setQuery("");
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(combobox/* Combobox.Options */.h.Options, {
                        className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-100 dark:bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                        children: filteredModality.length === 0 && query !== "" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "relative cursor-default select-none py-2 px-4 text-gray-700",
                          children: t("nothing_found")
                        }) : filteredModality.map(function (item) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)(combobox/* Combobox.Option */.h.Option, {
                            className: function className(_ref3) {
                              var active = _ref3.active;
                              return "relative cursor-default select-none py-2 pr-4 ".concat(active ? "bg-teal-600 text-white" : "text-gray-900");
                            },
                            value: item.value,
                            children: function children(_ref4) {
                              var templateModality = _ref4.templateModality,
                                  active = _ref4.active;
                              return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  className: "block truncate ".concat(templateModality ? "font-medium" : "font-normal"),
                                  children: item.name
                                }), templateModality ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  className: "absolute inset-y-0 left-0 flex items-center pl-3 ".concat(active ? "text-white" : "text-teal-600"),
                                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                                    name: faCheck,
                                    size: "lg",
                                    className: "w-5 p-2"
                                  })
                                }) : null]
                              });
                            }
                          }, item.id);
                        })
                      })
                    })]
                  })
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full h-80 border border-gray-600 dark:border-none rounded-lg my-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReportEditor/* default */.Z, {
              saveTemplateMode: true,
              impression: impression,
              onChange: setCurrentReport,
              isFocused: true
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-red-500 px-6 pb-6 text-left mb-4 sm:mb-0",
          children: error
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "border-t px-4 border-gray-700 py-4 flex items-center justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            onClick: onDelete,
            disabled: !(selectedTemplate !== null && selectedTemplate !== void 0 && selectedTemplate.id),
            className: classnames_default()("flex items-center space-x-3 cursor-pointer", {
              "cursor-not-allowed": !(selectedTemplate !== null && selectedTemplate !== void 0 && selectedTemplate.id)
            }),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
              name: pro_light_svg_icons/* faTrashCan */.Vui,
              size: "sm",
              className: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: t("button.delete")
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex space-x-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              isSecondary: true,
              className: "grow-1 flex space-x-2 px-6 py-4 ml-4",
              onClick: function onClick() {
                _onClose();
              },
              isPrimary: false,
              children: t("button.cancel")
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              isSecondary: true,
              className: "grow-1 flex space-x-2 px-6 py-4 ml-4",
              onClick: handlePreviewModal,
              isPrimary: true,
              disabled: !templateName || !templateModality || !currentReport,
              children: t("button.preview_save")
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReportTemplate_PreviewTemplateModal, {
      isVisible: isTemplatePreviewModal,
      currentReport: currentReport,
      onClose: onClosePreviewModal,
      isPinned: isPinned,
      refetchReports: refetchReports,
      updatedDetails: SaveTemplateModal_objectSpread(SaveTemplateModal_objectSpread({}, selectedTemplate), {}, {
        template: currentReport,
        name: templateName !== null && templateName !== void 0 ? templateName : selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.name,
        modality: templateModality !== null && templateModality !== void 0 ? templateModality : selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.modality
      })
    })]
  });
}

/* harmony default export */ var ReportTemplate_SaveTemplateModal = (SaveTemplateModal);
// EXTERNAL MODULE: ./components/ReportTemplate/services/useGetReport.js
var useGetReport = __webpack_require__(41917);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/DynamicForm/FormCreator.jsx + 5 modules
var FormCreator = __webpack_require__(95811);
// EXTERNAL MODULE: ./utils/axiosConnect.ts
var axiosConnect = __webpack_require__(46065);
;// CONCATENATED MODULE: ./components/ReportTemplate/services/useAddSignature.js
 // import { get } from "lodash";

var prepareUpload = function prepareUpload(data) {
  var formData = new FormData();
  Object.keys(data).map(function (key) {
    if (key === "files") {
      data.files.forEach(function (file) {
        formData.append(file.name, file);
      });
    } else {
      formData.append(key, data[key]);
    }
  });
  return formData;
};

var useAddSignature = function useAddSignature(data, isValidImage) {
  if (isValidImage) {
    var serviceConfig = {
      headers: {
        "content-type": "multipart/form-data"
      },
      timeout: 300000
    };
    var formDatas = prepareUpload(data);
    return axiosConnect/* default.post */.Z.post("profile/settings/report/ ", formDatas, serviceConfig).then(function (res) {
      return res;
    })["catch"](function (err) {
      console.error(err);
    });
  } else {
    return {
      error: "report_signature.toast.invalid_image"
    };
  }
};

/* harmony default export */ var services_useAddSignature = (useAddSignature);
// EXTERNAL MODULE: ./hooks/useAuthService.ts
var useAuthService = __webpack_require__(52315);
// EXTERNAL MODULE: ./utils/index.ts + 4 modules
var utils = __webpack_require__(48032);
;// CONCATENATED MODULE: ./components/ReportTemplate/SignatureModal.jsx

















var observations = [// {
//   id: "study_details",
//   choices: [
//     {
//       id: 0,
//       choice: "Patient Name",
//       disabled: true,
//       defaultValue: true,
//     },
//     {
//       id: 1,
//       choice: "Time of study",
//     },
//     {
//       id: 2,
//       choice: "Age and gender",
//       disabled: true,
//       defaultValue: true,
//     },
//     {
//       id: 3,
//       choice: "Time of reporting",
//     },
//     {
//       id: 4,
//       choice: "Patient ID",
//     },
//     {
//       id: 5,
//       choice: "Referring doctor",
//     },
//     {
//       id: 6,
//       choice: "Location",
//     },
//   ],
//   observation: "1. Study details",
//   subObservation: "Select the dynamic study data to be included in all reports:",
//   response_type: "multiple_choice",
// },
{
  id: "signature",
  observation: "1. Signature",
  response_type: "upload",
  inputClassName: "dark:!bg-gray-900 !h-[100px]",
  subObservation: "Upload an image with your signature against a white background (.jpg, .png)"
}, {
  id: "report_footer_line1",
  observation: "Line 1",
  subObservation: "Enter your name, designation, credentials or registration number below:",
  response_type: "text",
  placeholder: "Name, credentials etc.",
  inputClassName: "dark:!bg-gray-900 placeholder:text-left !text-left",
  labelClassName: "!mb-0 whitespace-nowrap",
  parentClassName: "w-full",
  isClinicalField: true,
  wrapperClassName: "flex space-x-4 items-center"
}, {
  id: "report_footer_line2",
  observation: "Line 2",
  response_type: "text",
  placeholder: "Role or title, registration number etc.",
  inputClassName: "dark:!bg-gray-900 placeholder:text-left !text-left",
  labelClassName: "!mb-0 whitespace-nowrap",
  parentClassName: "w-full",
  isClinicalField: true,
  wrapperClassName: "flex space-x-4 items-center"
}, {
  id: "disclaimer",
  observation: "Edit disclaimer that will appear in the footer (required field)",
  response_type: "textarea",
  className: "w-full bg-gray-200 dark:!bg-gray-900",
  title: "2. Disclaimer text",
  row: 8,
  required: true,
  inputClassName: "text-base dark:text-gray-200 !p-4"
}];

function SignatureModal(_ref) {
  var isVisible = _ref.isVisible,
      onClose = _ref.onClose;

  var _useAuthService = (0,useAuthService/* default */.Z)(false),
      refetchProfile = _useAuthService.refetch;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      userInfo: s.userInfo
    };
  }),
      userInfo = _useStoreState.userInfo;

  var _useState = (0,react.useState)({}),
      formResponse = _useState[0],
      setFormResponse = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  (0,react.useEffect)(function () {
    setFormResponse({
      signature: (0,lodash.get)(userInfo, ["settings", "signature"], ""),
      report_footer_line1: (0,lodash.get)(userInfo, ["settings", "reporting_settings", "report_footer_line1"], ""),
      report_footer_line2: (0,lodash.get)(userInfo, ["settings", "reporting_settings", "report_footer_line2"], ""),
      disclaimer: (0,lodash.get)(userInfo, ["settings", "disclaimer"], "")
    });
  }, [userInfo]);

  var onCloseModal = function onCloseModal() {
    onClose(true);
  };

  var OnSave = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_response) {
      var finData, fileType, isValidImage, response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true); //to get only updated data

              finData = (0,lodash.pickBy)(_response, function (value, key) {
                return formResponse.hasOwnProperty(key) && !(0,lodash.isEqual)(formResponse[key], value);
              });
              fileType = (0,lodash.get)(finData, ["signature", "type"], "");
              isValidImage = finData !== null && finData !== void 0 && finData.signature ? (0,utils/* isNonDicomFile */.to)(fileType) : true;
              _context.next = 6;
              return services_useAddSignature(finData, isValidImage);

            case 6:
              response = _context.sent;

              if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                refetchProfile();
                Toast/* default.success */.Z.success(t("report_signature.toast.success"));
                onClose();
              } else if (response !== null && response !== void 0 && response.error) {
                Toast/* default.error */.Z.error(t(response === null || response === void 0 ? void 0 : response.error));
              } else {
                Toast/* default.error */.Z.error(t("report_signature.toast.failed"));
                onClose();
              }

              setIsLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function OnSave(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: isVisible,
      onClose: onCloseModal,
      title: t("report_signature.title"),
      className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-[45%]",
      closeOnClickAway: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-col h-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "border-r-2 border-gray-400 dark:border-gray-700 p-7",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/images/report-format.png",
              alt: "report-format",
              width: 201,
              height: 285
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex-1 text-left",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCreator/* default */.Z, {
              formSchema: observations,
              response: formResponse,
              formName: "reporting_signature",
              formId: "",
              onClose: onCloseModal,
              onSave: OnSave // patientUid={get(router, ["query", "params", 0])}
              ,
              isIncomingForm: false,
              isSignatureForm: true,
              wrapperClassName: "bg-gray-200 dark:bg-transparent",
              containerClassName: "!p-0 !px-6",
              isButtonLoading: isLoading
            })
          })]
        })
      })
    })
  });
}

/* harmony default export */ var ReportTemplate_SignatureModal = (SignatureModal);
;// CONCATENATED MODULE: ./components/ReportTemplate/index.jsx





















function ReportTemplate(_ref) {
  var _pinnedReportData$edi, _pinnedReportData$edi2, _pinnedReportData$cre, _pinnedReportData$edi3, _pinnedReportData$edi4, _pinnedReportData$cre2;

  var isOpen = _ref.isOpen;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isDarkMode: s.isDarkMode
    };
  }),
      isDarkMode = _useStoreState.isDarkMode;

  var _useState = (0,react.useState)(""),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTemplateSaveModal = _useState2[0],
      setIsTemplateSaveModal = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isPinned = _useState3[0],
      setIsPinned = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isSignatureModal = _useState4[0],
      setIsSignatureModal = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      reportData = _useState5[0],
      setReportData = _useState5[1];

  var _useState6 = (0,react.useState)({}),
      pinnedReportData = _useState6[0],
      setPinnedReportData = _useState6[1];

  var _useState7 = (0,react.useState)(),
      showDeleteIconId = _useState7[0],
      setShowDeleteIconId = _useState7[1];

  var _useState8 = (0,react.useState)({}),
      selectedTemplate = _useState8[0],
      setSelectedTemplate = _useState8[1];

  var deleteGroup = services_useDeleteTemplate();

  var _useGetReport = (0,useGetReport/* default */.Z)(isOpen),
      reportTemplateData = _useGetReport.data,
      isLoading = _useGetReport.isLoading,
      refetchReports = _useGetReport.refetch;

  var templateData = (0,lodash.get)(reportTemplateData, ["all_templates"]);
  (0,react.useEffect)(function () {
    if (search) {
      setReportData(templateData === null || templateData === void 0 ? void 0 : templateData.filter(function (item) {
        return item.name.toLowerCase().includes(search.toLowerCase());
      }));
    } else {
      var pinnedData = templateData === null || templateData === void 0 ? void 0 : templateData.filter(function (data) {
        return data === null || data === void 0 ? void 0 : data.is_pinned;
      });
      var normalData = templateData === null || templateData === void 0 ? void 0 : templateData.filter(function (data) {
        return !(data !== null && data !== void 0 && data.is_pinned);
      });
      setReportData(normalData);

      if ((pinnedData === null || pinnedData === void 0 ? void 0 : pinnedData.length) > 0) {
        setPinnedReportData(pinnedData[0]);
      } else {
        setPinnedReportData({});
      }
    }
  }, [search, templateData]);

  var onCloseSaveModal = function onCloseSaveModal() {
    setSelectedTemplate({});
    setIsPinned(false);
    setIsTemplateSaveModal(false);
  };

  var onCloseSignatureModal = function onCloseSignatureModal() {
    setIsSignatureModal(false);
  };

  var onDelete = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(id) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return deleteGroup.mutateAsync(id);

            case 3:
              refetchReports();
              Toast/* default.success */.Z.success(t("report_templates.toast.delete_success"));
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              Toast/* default.error */.Z.error(t("report_templates.toast.delete_failed"));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onDelete(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col h-full mx-4 pt-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "p-5 rounded-lg border w-full border-gray-700 my-5 flex justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-left space-y-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "font-medium",
            children: t("report_signature.title")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-md dark:text-gray-200",
            children: t("report_signature.subtitle")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          className: "px-6 text-base py-2 bg-teal-800",
          onClick: function onClick() {
            setIsSignatureModal(true);
          },
          isPrimary: isDarkMode,
          children: t("button.edit_preview")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "pb-5 text-left",
        children: t("report_templates.title")
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-1/2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DebounceInput/* default */.Z, {
            value: search,
            inputClassName: "border-none",
            onChange: setSearch,
            placeholder: t("report_templates.search_placeholder"),
            className: "rounded-md text-gray-800 dark:text-white border !py-2 w-full border-gray-700"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Z, {
          isSecondary: isDarkMode,
          className: "grow-1 flex space-x-2 px-4 text-base py-2 ml-4",
          onClick: function onClick() {
            setIsTemplateSaveModal(true);
          },
          isPrimary: !isDarkMode,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
            name: pro_regular_svg_icons/* faPlus */.r8p
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: t("report_templates.new_template")
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "rounded-md my-4 text-left py-3 bg-gray-300 dark:bg-gray-900 max-h-80 overflow-y-auto scrollbar-light dark:scrollbar",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "border-b px-4 uppercase py-3 text-[14px] text-gray-800 dark:text-gray-500 border-gray-800 grid grid-cols-12",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "col-span-1",
            children: "#"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "col-span-2",
            children: t("modality_key")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "col-span-4",
            children: t("template_name_key")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "col-span-5",
            children: t("edited_by_key")
          })]
        }), isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex flex-col h-full w-full items-center justify-center overflow-hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-8 h-8 rounded-full text-blue-600 mr-3",
            role: "status"
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "border border-teal-700 rounded-lg overflow-hidden m-3",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-teal-300 bg-teal-900 p-3 text-sm",
              children: t("ai_assistant_negative_chest_xrays")
            }), (0,lodash.isEmpty)(pinnedReportData) ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              onClick: function onClick(e) {
                setIsTemplateSaveModal(true);
                setSelectedTemplate({
                  modality: "CR/DR/DX",
                  name: constants/* default.DEFAULT_FILTER_NAME.negativeCXR */.Z.DEFAULT_FILTER_NAME.negativeCXR
                });
                setIsPinned(true);
                e.stopPropagation();
              },
              className: "border-b p-4 relative cursor-pointer dark:hover:bg-gradient-to-r from-teal-900 text-[14px] text-gray-800 dark:text-gray-600 border-gray-600 dark:border-gray-800 grid grid-cols-12",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-1",
                children: "--"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-2",
                children: "--"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-4 overflow-hidden mr-6",
                children: t("default_qxr_report")
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "col-span-5 space-x-2 overflow-hidden mr-6 grid grid-cols-12 items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                  name: pro_regular_svg_icons/* faUser */.ILF,
                  size: "xs",
                  className: "col-span-1 text-gray-800 dark:text-white"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "--"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_regular_svg_icons/* faPenToSquare */.Yai,
                size: "xs",
                className: "absolute z-10 right-4 text-gray-800 hover:text-gray-800 cursor-pointer dark:hover:text-teal-100 -top-2 translate-y-[100%] h-5 w-5 dark:text-white"
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              onClick: function onClick(e) {
                setSelectedTemplate(pinnedReportData);
                setIsTemplateSaveModal(true);
                setIsPinned(true);
                e.stopPropagation();
              },
              className: "border-b p-4 relative cursor-pointer dark:hover:bg-gradient-to-r from-teal-900 text-[14px] text-gray-800 dark:text-white border-gray-600 dark:border-gray-800 grid grid-cols-12",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-1",
                children: "1"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-2",
                children: pinnedReportData === null || pinnedReportData === void 0 ? void 0 : pinnedReportData.modality
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-4 overflow-hidden mr-6",
                children: pinnedReportData === null || pinnedReportData === void 0 ? void 0 : pinnedReportData.name
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                title: (_pinnedReportData$edi = pinnedReportData === null || pinnedReportData === void 0 ? void 0 : (_pinnedReportData$edi2 = pinnedReportData.edited_by) === null || _pinnedReportData$edi2 === void 0 ? void 0 : _pinnedReportData$edi2.email) !== null && _pinnedReportData$edi !== void 0 ? _pinnedReportData$edi : pinnedReportData === null || pinnedReportData === void 0 ? void 0 : (_pinnedReportData$cre = pinnedReportData.created_by) === null || _pinnedReportData$cre === void 0 ? void 0 : _pinnedReportData$cre.email,
                className: "col-span-5 space-x-2 overflow-hidden mr-6 grid grid-cols-12 items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                  name: pro_regular_svg_icons/* faUser */.ILF,
                  size: "xs",
                  className: "col-span-1 text-gray-800 dark:text-white"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  children: [" ", (_pinnedReportData$edi3 = pinnedReportData === null || pinnedReportData === void 0 ? void 0 : (_pinnedReportData$edi4 = pinnedReportData.edited_by) === null || _pinnedReportData$edi4 === void 0 ? void 0 : _pinnedReportData$edi4.email) !== null && _pinnedReportData$edi3 !== void 0 ? _pinnedReportData$edi3 : pinnedReportData === null || pinnedReportData === void 0 ? void 0 : (_pinnedReportData$cre2 = pinnedReportData.created_by) === null || _pinnedReportData$cre2 === void 0 ? void 0 : _pinnedReportData$cre2.email]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_regular_svg_icons/* faPenToSquare */.Yai,
                size: "xs",
                className: "absolute z-10 right-4 text-gray-800 hover:text-gray-800 cursor-pointer dark:hover:text-teal-100 -top-2 translate-y-[100%] h-5 w-5 dark:text-white"
              })]
            })]
          }), reportData === null || reportData === void 0 ? void 0 : reportData.map(function (item, index) {
            var _item$edited_by$email, _item$edited_by, _item$created_by, _item$edited_by$email2, _item$edited_by2, _item$created_by2;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              onMouseEnter: function onMouseEnter(e) {
                setShowDeleteIconId(item.id);
                e.stopPropagation();
              },
              onMouseLeave: function onMouseLeave(e) {
                setShowDeleteIconId();
                e.stopPropagation();
              },
              onClick: function onClick() {
                setSelectedTemplate(item);
                setIsTemplateSaveModal(true);
              },
              className: "border-b px-4 relative cursor-pointer py-3 hover:bg-gray-400 dark:hover:bg-teal-800 text-[14px] text-gray-800 dark:text-white border-gray-600 dark:border-gray-800 grid grid-cols-12",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-1",
                children: (0,lodash.isEmpty)(pinnedReportData) ? index + 1 : index + 2
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-2",
                children: item.modality
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "col-span-4 overflow-hidden mr-6",
                children: item.name
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                title: (_item$edited_by$email = item === null || item === void 0 ? void 0 : (_item$edited_by = item.edited_by) === null || _item$edited_by === void 0 ? void 0 : _item$edited_by.email) !== null && _item$edited_by$email !== void 0 ? _item$edited_by$email : item === null || item === void 0 ? void 0 : (_item$created_by = item.created_by) === null || _item$created_by === void 0 ? void 0 : _item$created_by.email,
                className: "col-span-5 space-x-2 overflow-hidden mr-6 grid grid-cols-12 items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                  name: pro_regular_svg_icons/* faUser */.ILF,
                  size: "xs",
                  className: "col-span-1 text-gray-800 dark:text-white"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  children: [" ", (_item$edited_by$email2 = item === null || item === void 0 ? void 0 : (_item$edited_by2 = item.edited_by) === null || _item$edited_by2 === void 0 ? void 0 : _item$edited_by2.email) !== null && _item$edited_by$email2 !== void 0 ? _item$edited_by$email2 : item === null || item === void 0 ? void 0 : (_item$created_by2 = item.created_by) === null || _item$created_by2 === void 0 ? void 0 : _item$created_by2.email]
                })]
              }), showDeleteIconId === item.id && /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_regular_svg_icons/* faTrashCan */.Vui,
                size: "md",
                onClick: function onClick(e) {
                  onDelete(item.id);
                  e.stopPropagation();
                },
                className: "absolute z-10 right-4 text-gray-800 hover:text-gray-800 dark:hover:text-teal-100 -top-2 translate-y-[100%] h-5 w-5 dark:text-white"
              })]
            }, index);
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReportTemplate_SignatureModal, {
      isVisible: isSignatureModal,
      onClose: onCloseSignatureModal,
      selectedTemplate: selectedTemplate
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReportTemplate_SaveTemplateModal, {
      isVisible: isTemplateSaveModal,
      onClose: onCloseSaveModal,
      selectedTemplate: selectedTemplate,
      isPinned: isPinned,
      refetchReports: refetchReports
    })]
  });
}

/* harmony default export */ var components_ReportTemplate = (ReportTemplate);
;// CONCATENATED MODULE: ./components/ReportTemplate/ReportTemplateModal.jsx









var ReportTemplateModal = function ReportTemplateModal() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isReportTemplateOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var onClose = function onClose() {
    Store/* default.update */.Z.update(function (s) {
      s.isReportTemplateOpen = false;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      show: isVisible,
      onClose: onClose,
      title: t("setting_report"),
      className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
      closeOnClickAway: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ReportTemplate, {
        isOpen: isVisible
      })
    })
  });
};

/* harmony default export */ var ReportTemplate_ReportTemplateModal = (ReportTemplateModal);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(19946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(32984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(61363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(84575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-resolve-button-type.js
var use_resolve_button_type = __webpack_require__(14157);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(46045);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/internal/focus-sentinel.js
function p({onFocus:n}){let[r,o]=(0,react.useState)(!0);return r?react.createElement(internal_hidden/* Hidden */._,{as:"button",type:"button",features:internal_hidden/* Features.Focusable */.A.Focusable,onFocus:a=>{a.preventDefault();let e,u=50;function t(){if(u--<=0){e&&cancelAnimationFrame(e);return}if(n()){o(!1),cancelAnimationFrame(e);return}e=requestAnimationFrame(t)}e=requestAnimationFrame(t)}}):null}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/micro-task.js
var micro_task = __webpack_require__(81021);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(15466);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/stable-collection.js
const s=react.createContext(null);function stable_collection_a(){return{groups:new Map,get(n,t){var c;let e=this.groups.get(n);e||(e=new Map,this.groups.set(n,e));let l=(c=e.get(t))!=null?c:0;e.set(t,l+1);let o=Array.from(e.keys()).indexOf(t);function i(){let u=e.get(t);u>1?e.set(t,u-1):e.delete(t)}return[o,i]}}}function stable_collection_C({children:n}){let t=react.useRef(stable_collection_a());return react.createElement(s.Provider,{value:t},n)}function stable_collection_d(n){let t=react.useContext(s);if(!t)throw new Error("You must wrap your component in a <StableCollection>");let e=f(),[l,o]=t.current.get(n,e);return react.useEffect(()=>o,[]),l}function f(){var l,o,i;let n=(i=(o=(l=react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED)==null?void 0:l.ReactCurrentOwner)==null?void 0:o.current)!=null?i:null;if(!n)return Symbol();let t=[],e=n;for(;e;)t.push(e.index),e=e.return;return"$."+t.join(".")}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js
var ue=(t=>(t[t.Forwards=0]="Forwards",t[t.Backwards=1]="Backwards",t))(ue||{}),tabs_Te=(o=>(o[o.Less=-1]="Less",o[o.Equal=0]="Equal",o[o.Greater=1]="Greater",o))(tabs_Te||{}),de=(r=>(r[r.SetSelectedIndex=0]="SetSelectedIndex",r[r.RegisterTab=1]="RegisterTab",r[r.UnregisterTab=2]="UnregisterTab",r[r.RegisterPanel=3]="RegisterPanel",r[r.UnregisterPanel=4]="UnregisterPanel",r))(de||{});let ce={[0](e,n){var u;let t=(0,focus_management/* sortByDomNode */.z2)(e.tabs,T=>T.current),o=(0,focus_management/* sortByDomNode */.z2)(e.panels,T=>T.current),s=t.filter(T=>{var l;return!((l=T.current)!=null&&l.hasAttribute("disabled"))}),r={...e,tabs:t,panels:o};if(n.index<0||n.index>t.length-1){let T=(0,match/* match */.E)(Math.sign(n.index-e.selectedIndex),{[-1]:()=>1,[0]:()=>(0,match/* match */.E)(Math.sign(n.index),{[-1]:()=>0,[0]:()=>0,[1]:()=>1}),[1]:()=>0});return s.length===0?r:{...r,selectedIndex:(0,match/* match */.E)(T,{[0]:()=>t.indexOf(s[0]),[1]:()=>t.indexOf(s[s.length-1])})}}let i=t.slice(0,n.index),b=[...t.slice(n.index),...i].find(T=>s.includes(T));if(!b)return r;let c=(u=t.indexOf(b))!=null?u:e.selectedIndex;return c===-1&&(c=e.selectedIndex),{...r,selectedIndex:c}},[1](e,n){var r;if(e.tabs.includes(n.tab))return e;let t=e.tabs[e.selectedIndex],o=(0,focus_management/* sortByDomNode */.z2)([...e.tabs,n.tab],i=>i.current),s=(r=o.indexOf(t))!=null?r:e.selectedIndex;return s===-1&&(s=e.selectedIndex),{...e,tabs:o,selectedIndex:s}},[2](e,n){return{...e,tabs:e.tabs.filter(t=>t!==n.tab)}},[3](e,n){return e.panels.includes(n.panel)?e:{...e,panels:(0,focus_management/* sortByDomNode */.z2)([...e.panels,n.panel],t=>t.current)}},[4](e,n){return{...e,panels:e.panels.filter(t=>t!==n.panel)}}},X=(0,react.createContext)(null);X.displayName="TabsDataContext";function M(e){let n=(0,react.useContext)(X);if(n===null){let t=new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,M),t}return n}let $=(0,react.createContext)(null);$.displayName="TabsActionsContext";function q(e){let n=(0,react.useContext)($);if(n===null){let t=new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,q),t}return n}function fe(e,n){return (0,match/* match */.E)(n.type,ce,e,n)}let be=react.Fragment;function me(e,n){let{defaultIndex:t=0,vertical:o=!1,manual:s=!1,onChange:r,selectedIndex:i=null,...R}=e;const b=o?"vertical":"horizontal",c=s?"manual":"auto";let u=i!==null,T=(0,use_sync_refs/* useSyncRefs */.T)(n),[l,d]=(0,react.useReducer)(fe,{selectedIndex:i!=null?i:t,tabs:[],panels:[]}),y=(0,react.useMemo)(()=>({selectedIndex:l.selectedIndex}),[l.selectedIndex]),m=(0,use_latest_value/* useLatestValue */.E)(r||(()=>{})),x=(0,use_latest_value/* useLatestValue */.E)(l.tabs),E=(0,react.useMemo)(()=>({orientation:b,activation:c,...l}),[b,c,l]),S=(0,use_event/* useEvent */.z)(p=>(d({type:1,tab:p}),()=>d({type:2,tab:p}))),A=(0,use_event/* useEvent */.z)(p=>(d({type:3,panel:p}),()=>d({type:4,panel:p}))),L=(0,use_event/* useEvent */.z)(p=>{C.current!==p&&m.current(p),u||d({type:0,index:p})}),C=(0,use_latest_value/* useLatestValue */.E)(u?e.selectedIndex:l.selectedIndex),N=(0,react.useMemo)(()=>({registerTab:S,registerPanel:A,change:L}),[]);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{d({type:0,index:i!=null?i:t})},[i]),(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(C.current===void 0||l.tabs.length<=0)return;let p=(0,focus_management/* sortByDomNode */.z2)(l.tabs,a=>a.current);p.some((a,f)=>l.tabs[f]!==a)&&L(p.indexOf(l.tabs[C.current]))});let B={ref:T};return react.createElement(stable_collection_C,null,react.createElement($.Provider,{value:N},react.createElement(X.Provider,{value:E},E.tabs.length<=0&&react.createElement(p,{onFocus:()=>{var p,I;for(let a of x.current)if(((p=a.current)==null?void 0:p.tabIndex)===0)return(I=a.current)==null||I.focus(),!0;return!1}}),(0,render/* render */.sY)({ourProps:B,theirProps:R,slot:y,defaultTag:be,name:"Tabs"}))))}let Pe="div";function ge(e,n){let{orientation:t,selectedIndex:o}=M("Tab.List"),s=(0,use_sync_refs/* useSyncRefs */.T)(n);return (0,render/* render */.sY)({ourProps:{ref:s,role:"tablist","aria-orientation":t},theirProps:e,slot:{selectedIndex:o},defaultTag:Pe,name:"Tabs.List"})}let ye="button";function tabs_xe(e,n){var p,I;let t=(0,use_id/* useId */.M)(),{id:o=`headlessui-tabs-tab-${t}`,...s}=e,{orientation:r,activation:i,selectedIndex:R,tabs:b,panels:c}=M("Tab"),u=q("Tab"),T=M("Tab"),l=(0,react.useRef)(null),d=(0,use_sync_refs/* useSyncRefs */.T)(l,n);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>u.registerTab(l),[u,l]);let y=stable_collection_d("tabs"),m=b.indexOf(l);m===-1&&(m=y);let x=m===R,E=(0,use_event/* useEvent */.z)(a=>{var j;let f=a();if(f===focus_management/* FocusResult.Success */.fE.Success&&i==="auto"){let W=(j=(0,owner/* getOwnerDocument */.r)(l))==null?void 0:j.activeElement,z=T.tabs.findIndex(te=>te.current===W);z!==-1&&u.change(z)}return f}),S=(0,use_event/* useEvent */.z)(a=>{let f=b.map(W=>W.current).filter(Boolean);if(a.key===keyboard/* Keys.Space */.R.Space||a.key===keyboard/* Keys.Enter */.R.Enter){a.preventDefault(),a.stopPropagation(),u.change(m);return}switch(a.key){case keyboard/* Keys.Home */.R.Home:case keyboard/* Keys.PageUp */.R.PageUp:return a.preventDefault(),a.stopPropagation(),E(()=>(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.First */.TO.First));case keyboard/* Keys.End */.R.End:case keyboard/* Keys.PageDown */.R.PageDown:return a.preventDefault(),a.stopPropagation(),E(()=>(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.Last */.TO.Last))}if(E(()=>(0,match/* match */.E)(r,{vertical(){return a.key===keyboard/* Keys.ArrowUp */.R.ArrowUp?(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.Previous */.TO.Previous|focus_management/* Focus.WrapAround */.TO.WrapAround):a.key===keyboard/* Keys.ArrowDown */.R.ArrowDown?(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.Next */.TO.Next|focus_management/* Focus.WrapAround */.TO.WrapAround):focus_management/* FocusResult.Error */.fE.Error},horizontal(){return a.key===keyboard/* Keys.ArrowLeft */.R.ArrowLeft?(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.Previous */.TO.Previous|focus_management/* Focus.WrapAround */.TO.WrapAround):a.key===keyboard/* Keys.ArrowRight */.R.ArrowRight?(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.Next */.TO.Next|focus_management/* Focus.WrapAround */.TO.WrapAround):focus_management/* FocusResult.Error */.fE.Error}}))===focus_management/* FocusResult.Success */.fE.Success)return a.preventDefault()}),A=(0,react.useRef)(!1),L=(0,use_event/* useEvent */.z)(()=>{var a;A.current||(A.current=!0,(a=l.current)==null||a.focus(),u.change(m),(0,micro_task/* microTask */.Y)(()=>{A.current=!1}))}),C=(0,use_event/* useEvent */.z)(a=>{a.preventDefault()}),N=(0,react.useMemo)(()=>({selected:x}),[x]),B={ref:d,onKeyDown:S,onMouseDown:C,onClick:L,id:o,role:"tab",type:(0,use_resolve_button_type/* useResolveButtonType */.f)(e,l),"aria-controls":(I=(p=c[m])==null?void 0:p.current)==null?void 0:I.id,"aria-selected":x,tabIndex:x?0:-1};return (0,render/* render */.sY)({ourProps:B,theirProps:s,slot:N,defaultTag:ye,name:"Tabs.Tab"})}let tabs_Ee="div";function tabs_Ae(e,n){let{selectedIndex:t}=M("Tab.Panels"),o=(0,use_sync_refs/* useSyncRefs */.T)(n),s=(0,react.useMemo)(()=>({selectedIndex:t}),[t]);return (0,render/* render */.sY)({ourProps:{ref:o},theirProps:e,slot:s,defaultTag:tabs_Ee,name:"Tabs.Panels"})}let Re="div",Le=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static;function De(e,n){var E,S,A,L;let t=(0,use_id/* useId */.M)(),{id:o=`headlessui-tabs-panel-${t}`,tabIndex:s=0,...r}=e,{selectedIndex:i,tabs:R,panels:b}=M("Tab.Panel"),c=q("Tab.Panel"),u=(0,react.useRef)(null),T=(0,use_sync_refs/* useSyncRefs */.T)(u,n);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>c.registerPanel(u),[c,u]);let l=stable_collection_d("panels"),d=b.indexOf(u);d===-1&&(d=l);let y=d===i,m=(0,react.useMemo)(()=>({selected:y}),[y]),x={ref:T,id:o,role:"tabpanel","aria-labelledby":(S=(E=R[d])==null?void 0:E.current)==null?void 0:S.id,tabIndex:y?s:-1};return!y&&((A=r.unmount)==null||A)&&!((L=r.static)!=null&&L)?react.createElement(internal_hidden/* Hidden */._,{as:"span",...x}):(0,render/* render */.sY)({ourProps:x,theirProps:r,slot:m,defaultTag:Re,features:Le,visible:y,name:"Tabs.Panel"})}let tabs_Se=(0,render/* forwardRefWithAs */.yV)(tabs_xe),tabs_Ie=(0,render/* forwardRefWithAs */.yV)(me),Fe=(0,render/* forwardRefWithAs */.yV)(ge),he=(0,render/* forwardRefWithAs */.yV)(tabs_Ae),Me=(0,render/* forwardRefWithAs */.yV)(De),tabs_rt=Object.assign(tabs_Se,{Group:tabs_Ie,List:Fe,Panels:he,Panel:Me});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(64103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(16567);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/start-transition.js
var t;let start_transition_a=(t=react.startTransition)!=null?t:function(i){i()};

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure_q=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(disclosure_q||{}),z=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(z||{});let disclosure_Q={[0]:e=>({...e,disclosureState:(0,match/* match */.E)(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId}},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId}}},disclosure_k=(0,react.createContext)(null);disclosure_k.displayName="DisclosureContext";function disclosure_M(e){let n=(0,react.useContext)(disclosure_k);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,disclosure_M),o}return n}let v=(0,react.createContext)(null);v.displayName="DisclosureAPIContext";function w(e){let n=(0,react.useContext)(v);if(n===null){let o=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,w),o}return n}let H=(0,react.createContext)(null);H.displayName="DisclosurePanelContext";function V(){return (0,react.useContext)(H)}function Y(e,n){return (0,match/* match */.E)(n.type,disclosure_Q,e,n)}let disclosure_Z=react.Fragment;function ee(e,n){let{defaultOpen:o=!1,...u}=e,T=(0,react.useRef)(null),l=(0,use_sync_refs/* useSyncRefs */.T)(n,(0,use_sync_refs/* optionalRef */.h)(a=>{T.current=a},e.as===void 0||e.as===react.Fragment)),t=(0,react.useRef)(null),f=(0,react.useRef)(null),s=(0,react.useReducer)(Y,{disclosureState:o?0:1,linkedPanel:!1,buttonRef:f,panelRef:t,buttonId:null,panelId:null}),[{disclosureState:i,buttonId:c},D]=s,d=(0,use_event/* useEvent */.z)(a=>{D({type:1});let r=(0,owner/* getOwnerDocument */.r)(T);if(!r||!c)return;let p=(()=>a?a instanceof HTMLElement?a:a.current instanceof HTMLElement?a.current:r.getElementById(c):r.getElementById(c))();p==null||p.focus()}),P=(0,react.useMemo)(()=>({close:d}),[d]),b=(0,react.useMemo)(()=>({open:i===0,close:d}),[i,d]),y={ref:l};return react.createElement(disclosure_k.Provider,{value:s},react.createElement(v.Provider,{value:P},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(i,{[0]:open_closed/* State.Open */.ZM.Open,[1]:open_closed/* State.Closed */.ZM.Closed})},(0,render/* render */.sY)({ourProps:y,theirProps:u,slot:b,defaultTag:disclosure_Z,name:"Disclosure"}))))}let te="button";function ne(e,n){let o=(0,use_id/* useId */.M)(),{id:u=`headlessui-disclosure-button-${o}`,...T}=e,[l,t]=disclosure_M("Disclosure.Button"),f=V(),s=f===null?!1:f===l.panelId,i=(0,react.useRef)(null),c=(0,use_sync_refs/* useSyncRefs */.T)(i,n,s?null:l.buttonRef);(0,react.useEffect)(()=>{if(!s)return t({type:2,buttonId:u}),()=>{t({type:2,buttonId:null})}},[u,t,s]);let D=(0,use_event/* useEvent */.z)(r=>{var p;if(s){if(l.disclosureState===1)return;switch(r.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:r.preventDefault(),r.stopPropagation(),t({type:0}),(p=l.buttonRef.current)==null||p.focus();break}}else switch(r.key){case keyboard/* Keys.Space */.R.Space:case keyboard/* Keys.Enter */.R.Enter:r.preventDefault(),r.stopPropagation(),t({type:0});break}}),d=(0,use_event/* useEvent */.z)(r=>{switch(r.key){case keyboard/* Keys.Space */.R.Space:r.preventDefault();break}}),P=(0,use_event/* useEvent */.z)(r=>{var p;(0,bugs/* isDisabledReactIssue7711 */.P)(r.currentTarget)||e.disabled||(s?(t({type:0}),(p=l.buttonRef.current)==null||p.focus()):t({type:0}))}),b=(0,react.useMemo)(()=>({open:l.disclosureState===0}),[l]),y=(0,use_resolve_button_type/* useResolveButtonType */.f)(e,i),a=s?{ref:c,type:y,onKeyDown:D,onClick:P}:{ref:c,id:u,type:y,"aria-expanded":e.disabled?void 0:l.disclosureState===0,"aria-controls":l.linkedPanel?l.panelId:void 0,onKeyDown:D,onKeyUp:d,onClick:P};return (0,render/* render */.sY)({ourProps:a,theirProps:T,slot:b,defaultTag:te,name:"Disclosure.Button"})}let disclosure_le="div",disclosure_oe=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static;function re(e,n){let o=(0,use_id/* useId */.M)(),{id:u=`headlessui-disclosure-panel-${o}`,...T}=e,[l,t]=disclosure_M("Disclosure.Panel"),{close:f}=w("Disclosure.Panel"),s=(0,use_sync_refs/* useSyncRefs */.T)(n,l.panelRef,P=>{start_transition_a(()=>t({type:P?4:5}))});(0,react.useEffect)(()=>(t({type:3,panelId:u}),()=>{t({type:3,panelId:null})}),[u,t]);let i=(0,open_closed/* useOpenClosed */.oJ)(),c=(()=>i!==null?(i&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open:l.disclosureState===0)(),D=(0,react.useMemo)(()=>({open:l.disclosureState===0,close:f}),[l,f]),d={ref:s,id:u};return react.createElement(H.Provider,{value:l.panelId},(0,render/* render */.sY)({ourProps:d,theirProps:T,slot:D,defaultTag:disclosure_le,features:disclosure_oe,visible:c,name:"Disclosure.Panel"}))}let disclosure_se=(0,render/* forwardRefWithAs */.yV)(ee),disclosure_ue=(0,render/* forwardRefWithAs */.yV)(ne),ie=(0,render/* forwardRefWithAs */.yV)(re),disclosure_ve=Object.assign(disclosure_se,{Button:disclosure_ue,Panel:ie});

;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/Preview.jsx




var Preview = function Preview(_ref) {
  var tags = _ref.tags,
      labelMappings = _ref.labelMappings,
      tagsList = _ref.tagsList,
      showOptionalTags = _ref.showOptionalTags;
  var tags_ = (0,lodash.cloneDeep)(tags);
  var tag1 = tags_.tag1,
      tag2 = tags_.tag2;
  var allTags = [tag1, tag2];

  if (showOptionalTags) {
    allTags.unshift({
      value: "Review required",
      category: "findings"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "text-left",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-md text-gray-600 dark:text-gray-300 font-semibold",
      children: "PREVIEW"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative border border-gray-500 rounded-md pt-3 max-w-[325px] mt-3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-12",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-span-2 flex items-start justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bg-profile-pic-placeholder bg-no-repeat bg-center rounded bg-contain h-[30px] w-[30px]"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "col-span-10 space-y-3 pl-3 pr-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: "Patient Name"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "space-x-3 text-md",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Age/G"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "ID: xxxxxxxxx"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-wrap gap-3 text-md",
            children: [!tag1.value && !tag2.value && "No tags configured", allTags.map(function (tag) {
              var category = tag.category;
              var isValueObject = category === "risk_groups" || category === "symptoms";

              if (isValueObject) {
                (0,lodash.get)(tagsList, ["qxr", category, category]).map(function (choiceObj) {
                  if (choiceObj.id === tag.value) {
                    tag.value = choiceObj.choice;
                  }
                });
              }

              if (tag.value) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "bg-gray-100 dark:bg-gray-700 border border-gray-400 text-gray-900 dark:text-gray-100 rounded-full px-4 py-1 flex items-center",
                  children: [tag.category === "findings" && tag.value === "Review required" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "bg-yellow-400 mr-3 h-3 w-3 rounded-full"
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "bg-red-500 mr-3 h-3 w-3 rounded-full"
                  }), labelMappings[tag.value] || tag.value]
                }, tag.value);
              } else {
                return "";
              }
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "absolute top-3 right-3 flex items-start justify-end",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            className: "fill-gray-800",
            xmlns: "http://www.w3.org/2000/svg",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M15 13.125C15 11.9513 15.9699 11 17.1667 11H22.7695C23.3451 11 23.8935 11.2239 24.2997 11.6226L27.3669 14.6291C27.7732 15.0275 28 15.5654 28 16.1299V25.875C28 27.0471 27.0284 28 25.8333 28H17.1667C15.9699 28 15 27.0471 15 25.875V13.125ZM26.375 25.875V16.3125H23.6667C23.0674 16.3125 22.5833 15.8377 22.5833 15.25V12.5938H17.1667C16.8674 12.5938 16.625 12.8315 16.625 13.125V25.875C16.625 26.1672 16.8674 26.4062 17.1667 26.4062H25.8333C26.1313 26.4062 26.375 26.1672 26.375 25.875Z",
              fill: "#008280"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
              x: "14",
              y: "19",
              width: "7",
              height: "9",
              className: "fill-[#F6F7F7] dark:fill-gray-800"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M15.8193 26.8662C16.2451 27.292 16.9404 27.292 17.3662 26.8662L22.3662 21.8662C22.792 21.4404 22.792 20.7451 22.3662 20.3193C21.9404 19.8936 21.2451 19.8936 20.8193 20.3193L16.5928 24.5459L14.8662 22.8193C14.4404 22.3936 13.7451 22.3936 13.3193 22.8193C12.8936 23.2451 12.8936 23.9404 13.3193 24.3662L15.8193 26.8662Z",
              fill: "#008280"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-end text-[10px] text-gray-600 dark:text-gray-300 px-3 py-3",
        children: "BIG Hospital | 10 Aug 2022, 7:55 pm"
      })]
    })]
  });
};

/* harmony default export */ var PatientWorklistMenu_Preview = (Preview);
;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/Tag.jsx





var Tag = function Tag(_ref) {
  var tagNo = _ref.tagNo,
      userSettingsConf = _ref.userSettingsConf,
      studyName = _ref.studyName,
      initialUserSettingsConf = _ref.initialUserSettingsConf,
      labelMappings = _ref.labelMappings,
      tagsList = _ref.tagsList;
  var _userSettingsConf$wor = userSettingsConf.worklist.tags[studyName][tagNo],
      category = _userSettingsConf$wor.category,
      value_ = _userSettingsConf$wor.value,
      use_default = _userSettingsConf$wor.use_default;
  var value;
  var isValueObject = category === "risk_groups" || category === "symptoms";

  if (isValueObject) {
    var _get;

    (_get = (0,lodash.get)(tagsList, ["qxr", category, category])) === null || _get === void 0 ? void 0 : _get.map(function (choiceObj) {
      if (choiceObj.id === value_) {
        value = choiceObj.choice;
      }
    });
  } else {
    value = value_;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-full grid grid-cols-12 rounded-md px-5 py-4 cursor-pointer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-span-3 font-semibold text-left flex items-center text-[12px]",
      children: tagNo === "tag1" ? "TAG 01" : tagNo === "tag2" ? "TAG 02" : "TAG 03"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "col-span-8 text-left text-[12px] flex items-center",
      children: [(0,lodash.isEmpty)(category) && (0,lodash.isEmpty)(value) ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "bg-gray-100 dark:bg-gray-600 border border-gray-400 text-gray-900 dark:text-gray-100 rounded-full px-4 py-1 cursor-pointer",
        children: "Not Selected"
      }) : use_default ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "px-4",
        children: "Default"
      }) : !category || !value ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-red-400",
        children: "Invalid configuration"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "bg-gray-200 dark:bg-gray-700 border border-gray-400 text-gray-900 dark:text-gray-100 rounded-full px-4 py-1 cursor-pointer",
        children: labelMappings[value] || value
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()("invisible ml-2", {
          "text-red-400 !visible": (isValueObject ? initialUserSettingsConf.worklist.tags[studyName][tagNo].value !== value_ : initialUserSettingsConf.worklist.tags[studyName][tagNo].value !== value) || initialUserSettingsConf.worklist.tags[studyName][tagNo].category !== category
        }),
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-span-1 flex items-center justify-end",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        className: "stroke-gray-900 dark:stroke-gray-200",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M8 10L12 14L16 10",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    })]
  });
};

/* harmony default export */ var PatientWorklistMenu_Tag = (Tag);
;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/SubCategories.jsx


function SubCategories_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SubCategories_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SubCategories_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubCategories_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SubCategories = function SubCategories(_ref) {
  var studyName = _ref.studyName,
      userSettingsConf = _ref.userSettingsConf,
      dropdownCategory = _ref.dropdownCategory,
      subCategories = _ref.subCategories,
      setUserSettingsConf = _ref.setUserSettingsConf,
      tagNo = _ref.tagNo,
      labelMappings = _ref.labelMappings;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()("h-[1px] grow text-gray-800 dark:text-gray-100 flex flex-col mt-2", {}),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex justify-start space-x-3 my-1"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-[12px] font-semibold",
        children: "TAGS"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()("text-[12px] text-gray-700 dark:text-gray-200 text-left", {}),
        children: "Tags will be displayed on worklist only if selected tag is present in patient."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("flex flex-col overflow-y-auto scrollbar-light px-3 rounded h-full"),
      children: subCategories && Object.keys(subCategories).map(function (subCategory) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-left mb-2 bg-gray-100 dark:bg-gray-800 dark:text-gray-200 text-[12px] sticky top-0 pt-2",
            children: labelMappings[subCategory]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-wrap gap-3 text-[12px] px-3",
            children: subCategories[subCategory].map(function (tag_) {
              var tag;

              if (typeof tag_ === "object") {
                tag = tag_.choice;
              } else {
                tag = tag_;
              }

              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: classnames_default()("bg-gray-200 dark:bg-gray-700 rounded-full px-4 py-2 cursor-pointer hover:bg-teal-400 dark:hover:bg-teal-400 hover:text-gray-100", {
                  "bg-teal-400 dark:bg-teal-400 !text-gray-100": typeof tag_ === "object" ? tag_.id === userSettingsConf.worklist.tags[studyName][tagNo].value : tag === userSettingsConf.worklist.tags[studyName][tagNo].value
                }),
                onClick: function onClick() {
                  var prevValue = (0,lodash.get)(userSettingsConf, ["worklist", "tags", studyName, tagNo, "value"], null);
                  var selectedValue = typeof tag_ === "object" ? tag_.id : tag_;
                  setUserSettingsConf(SubCategories_objectSpread(SubCategories_objectSpread({}, userSettingsConf), {}, {
                    worklist: SubCategories_objectSpread(SubCategories_objectSpread({}, userSettingsConf.worklist), {}, {
                      tags: SubCategories_objectSpread(SubCategories_objectSpread({}, userSettingsConf.worklist.tags), {}, (0,defineProperty/* default */.Z)({}, studyName, SubCategories_objectSpread(SubCategories_objectSpread({}, userSettingsConf.worklist.tags[studyName]), {}, (0,defineProperty/* default */.Z)({}, tagNo, {
                        category: selectedValue === prevValue ? null : dropdownCategory,
                        value: selectedValue === prevValue ? null : selectedValue
                      }))))
                    })
                  }));
                },
                children: labelMappings[tag] || tag
              }, tag);
            })
          })]
        }, subCategory);
      })
    })]
  });
};

/* harmony default export */ var PatientWorklistMenu_SubCategories = (SubCategories);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js
var menu = __webpack_require__(72510);
;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/CategoryDropdown.jsx





var CategoryDropdown = function CategoryDropdown(_ref) {
  var dropdownCategory = _ref.dropdownCategory,
      categories = _ref.categories,
      setDropdownCategory = _ref.setDropdownCategory,
      labelMappings = _ref.labelMappings,
      isSearchClicked = _ref.isSearchClicked,
      setIsSearchClicked = _ref.setIsSearchClicked;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex items-center justify-start text-[12px] bg-gray-100 dark:bg-gray-800",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(menu/* Menu */.v, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Button */.v.Button, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex items-center border border-gray-600 dark:border-gray-500 rounded-md pl-3 py-2 w-52 text-gray-800 dark:text-gray-200"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "",
              children: labelMappings[dropdownCategory] || "---Select Category---"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
              className: "ml-auto mr-2",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                d: "M18 9L12 15L6 9",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "cursor-pointer absolute z-40 w-52 border bg-gray-100 dark:bg-gray-800 space-y-3 py-2 mt-2 rounded-md border-gray-400",
            children: Object.keys(categories).map(function (category) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: classnames_default()("ui-active:bg-gray-200 dark:ui-active:bg-gray-700", {
                    "bg-gray-300 dark:bg-gray-700 pointer-events-none": dropdownCategory === category
                  }),
                  onClick: function onClick() {
                    return setDropdownCategory(category);
                  },
                  children: labelMappings[category]
                })
              }, category);
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("flex items-center justify-center border border-gray-600 rounded-md px-2 py-2 ml-auto cursor-pointer"),
      onClick: function onClick() {
        return setIsSearchClicked(!isSearchClicked);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C11.8487 18 13.551 17.3729 14.9056 16.3199L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L16.3199 14.9056C17.3729 13.551 18 11.8487 18 10C18 5.58172 14.4183 2 10 2Z"
        })
      })
    })]
  });
};

/* harmony default export */ var PatientWorklistMenu_CategoryDropdown = (CategoryDropdown);
;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/TagSearch.jsx


function TagSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TagSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TagSearch_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TagSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var TagSearch = function TagSearch(_ref) {
  var studyName = _ref.studyName,
      isSearchClicked = _ref.isSearchClicked,
      setIsSearchClicked = _ref.setIsSearchClicked,
      categories = _ref.categories,
      labelMappings = _ref.labelMappings,
      userSettingsConf = _ref.userSettingsConf,
      setUserSettingsConf = _ref.setUserSettingsConf,
      tagNo = _ref.tagNo;

  var _useState = (0,react.useState)(""),
      value = _useState[0],
      setValue = _useState[1];

  var inputRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    inputRef.current.focus();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col h-[1px] grow",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("border border-gray-600 rounded-md py-2 px-3 flex items-center text-[12px] bg-gray-100 dark:bg-gray-800 z-[20]"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "currentColor",
          xmlns: "http://www.w3.org/2000/svg",
          className: "h-5 w-5 sm:h-6 sm:w-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C11.8487 18 13.551 17.3729 14.9056 16.3199L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L16.3199 14.9056C17.3729 13.551 18 11.8487 18 10C18 5.58172 14.4183 2 10 2Z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()("leading-0 flex items-center ml-2", {
          hidden: !!value
        }),
        children: "Search |"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-1/2 flex items-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          ref: inputRef,
          type: "text",
          className: "border-0 bg-transparent py-0",
          value: value,
          onChange: function onChange(e) {
            return setValue(e.target.value);
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "ml-auto cursor-pointer text-black",
        onClick: function onClick() {
          return setIsSearchClicked(!isSearchClicked);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
          name: pro_regular_svg_icons/* faXmark */.g82,
          className: "text-gray-900 dark:text-gray-100"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("mt-2 grow shrink scrollbar-light dark:scrollbar overflow-y-auto rounded-md"),
      children: Object.keys(categories).map(function (category) {
        var subCategories = categories[category];
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex flex-col",
          children: Object.keys(subCategories).map(function (subCategory) {
            var tags = subCategories[subCategory];
            var filteredTags = tags.filter(function (tag_) {
              var tag;

              if (typeof tag_ === "object") {
                tag = tag_.choice;
              } else {
                tag = tag_;
              }

              return (labelMappings[tag] || tag).toLowerCase().includes(value.toLowerCase());
            });

            if ((0,lodash.isEmpty)(filteredTags)) {
              return null;
            }

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "text-[12px] mb-5 space-y-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center text-gray-600 dark:text-gray-200 sticky top-0 bg-gray-100 dark:bg-gray-800 px-3",
                children: [labelMappings[category], " | ", labelMappings[subCategory]]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex flex-wrap gap-3 px-5",
                children: filteredTags === null || filteredTags === void 0 ? void 0 : filteredTags.map(function (tag_) {
                  var tag;

                  if (typeof tag_ === "object") {
                    tag = tag_.choice;
                  } else {
                    tag = tag_;
                  }

                  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("bg-gray-200 dark:bg-gray-700 rounded-full px-4 py-2 cursor-pointer hover:bg-teal-400 dark:hover:bg-teal-400 hover:text-gray-100", {
                      "bg-teal-400 dark:bg-teal-400 !text-gray-100": typeof tag_ === "object" ? tag_.id === userSettingsConf.worklist.tags[studyName][tagNo].value : tag === userSettingsConf.worklist.tags[studyName][tagNo].value
                    }),
                    onClick: function onClick() {
                      var prevValue = (0,lodash.get)(userSettingsConf, ["worklist", "tags", studyName, tagNo, "value"], null);
                      var selectedValue = typeof tag_ === "object" ? tag_.id : tag_;
                      setUserSettingsConf(TagSearch_objectSpread(TagSearch_objectSpread({}, userSettingsConf), {}, {
                        worklist: TagSearch_objectSpread(TagSearch_objectSpread({}, userSettingsConf.worklist), {}, {
                          tags: TagSearch_objectSpread(TagSearch_objectSpread({}, userSettingsConf.worklist.tags), {}, (0,defineProperty/* default */.Z)({}, studyName, TagSearch_objectSpread(TagSearch_objectSpread({}, userSettingsConf.worklist.tags[studyName]), {}, (0,defineProperty/* default */.Z)({}, tagNo, {
                            category: selectedValue === prevValue ? null : category,
                            value: selectedValue === prevValue ? null : selectedValue
                          }))))
                        })
                      }));
                      setIsSearchClicked(false);
                    },
                    children: labelMappings[tag] || tag
                  }, tag);
                })
              })]
            }, subCategory);
          })
        }, category);
      })
    })]
  });
};

/* harmony default export */ var PatientWorklistMenu_TagSearch = (TagSearch);
;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/TagSettingsMenu.jsx







var DEFAULT_CATEGORY = "findings";

var TagSettingsMenu = function TagSettingsMenu(_ref) {
  var tagNo = _ref.tagNo,
      studyName = _ref.studyName,
      userSettingsConf = _ref.userSettingsConf,
      setUserSettingsConf = _ref.setUserSettingsConf,
      labelMappings = _ref.labelMappings,
      tagsList = _ref.tagsList;
  var category = userSettingsConf.worklist.tags[studyName][tagNo].category;
  var categories = tagsList[studyName];

  var _useState = (0,react.useState)(category),
      dropdownCategory = _useState[0],
      setDropdownCategory = _useState[1];

  var subCategories = tagsList[studyName][dropdownCategory];

  var _useState2 = (0,react.useState)(false),
      isSearchClicked = _useState2[0],
      setIsSearchClicked = _useState2[1];

  (0,react.useEffect)(function () {
    setDropdownCategory(category);
  }, [userSettingsConf]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-gray-800 dark:text-gray-200 px-5 flex flex-col h-full",
    children: !isSearchClicked ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_CategoryDropdown, {
        categories: categories,
        dropdownCategory: dropdownCategory,
        setDropdownCategory: setDropdownCategory,
        labelMappings: labelMappings,
        setIsSearchClicked: setIsSearchClicked,
        isSearchClicked: isSearchClicked
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_SubCategories, {
        studyName: studyName,
        userSettingsConf: userSettingsConf,
        dropdownCategory: dropdownCategory,
        subCategories: subCategories,
        setUserSettingsConf: setUserSettingsConf,
        tagNo: tagNo,
        labelMappings: labelMappings
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_TagSearch, {
      studyName: studyName,
      isSearchClicked: isSearchClicked,
      setIsSearchClicked: setIsSearchClicked,
      categories: categories,
      labelMappings: labelMappings,
      tagNo: tagNo,
      userSettingsConf: userSettingsConf,
      setUserSettingsConf: setUserSettingsConf
    })
  });
};

/* harmony default export */ var PatientWorklistMenu_TagSettingsMenu = (TagSettingsMenu);
;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/ActiveFindings.jsx


function ActiveFindings_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ActiveFindings_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ActiveFindings_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ActiveFindings_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ActiveFindings = function ActiveFindings(_ref) {
  var subCategories = _ref.subCategories,
      labelMappings = _ref.labelMappings,
      userSettingsConf = _ref.userSettingsConf,
      setUserSettingsConf = _ref.setUserSettingsConf,
      studyName = _ref.studyName;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var optionalTags = ["Review required"];
  var areOptionalTagsEnabled = (0,lodash.get)(userSettingsConf, ["worklist", "tags", studyName, "optional_tags_enabled"], true);

  var handleOptionalTagsChange = function handleOptionalTagsChange(val) {
    setUserSettingsConf(ActiveFindings_objectSpread(ActiveFindings_objectSpread({}, userSettingsConf), {}, {
      worklist: ActiveFindings_objectSpread(ActiveFindings_objectSpread({}, userSettingsConf.worklist), {}, {
        tags: ActiveFindings_objectSpread(ActiveFindings_objectSpread({}, userSettingsConf.worklist.tags), {}, (0,defineProperty/* default */.Z)({}, studyName, ActiveFindings_objectSpread(ActiveFindings_objectSpread({}, userSettingsConf.worklist.tags[studyName]), {}, {
          optional_tags_enabled: val
        })))
      })
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()("h-[1px] grow text-gray-800 dark:text-gray-100 flex flex-col mt-2 overflow-y-auto scrollbar-light h-full", {}),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("flex justify-start space-x-3 my-1 px-5 text-[14px]"),
      children: t("worklist_tags.active_tags")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("flex flex-col px-5 rounded"),
      children: subCategories && Object.keys(subCategories).map(function (subCategory) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-left mb-2 bg-gray-100 dark:bg-gray-800 dark:text-gray-200 text-md sticky top-0 pt-2",
            children: labelMappings[subCategory]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-wrap gap-3 text-md",
            children: subCategories[subCategory].map(function (tag_) {
              var tag;

              if (typeof tag_ === "object") {
                tag = tag_.choice;
              } else {
                tag = tag_;
              }

              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: classnames_default()("bg-gray-200 dark:bg-gray-700 rounded-full px-4 py-2"),
                children: labelMappings[tag] || tag
              }, tag);
            })
          })]
        }, subCategory);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex items-center justify-start space-x-3 my-1 px-5 text-[14px]"),
      children: [t("worklist_tags.optional_tags"), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "ml-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toggle/* default */.Z, {
          value: areOptionalTagsEnabled,
          onChange: function onChange(val) {
            handleOptionalTagsChange(val);
          }
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()("flex flex-col overflow-y-auto scrollbar-light px-5 rounded pt-2"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-wrap gap-3 text-md items-center",
          children: [optionalTags.map(function (tag) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()("bg-gray-200 dark:bg-gray-700 rounded-full px-4 py-2"),
              children: labelMappings[tag] || tag
            }, tag);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "ml-4",
            children: t("worklist_tags.qer.optional_tag_desc")
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var PatientWorklistMenu_ActiveFindings = (ActiveFindings);
;// CONCATENATED MODULE: ./components/Settings/MenuScreens/PatientWorklistMenu/index.jsx












var PatientWorklistMenu = function PatientWorklistMenu(props) {
  var userSettingsConf = props.userSettingsConf,
      setUserSettingsConf = props.setUserSettingsConf,
      initialUserSettingsConf = props.initialUserSettingsConf,
      labelMappings = props.labelMappings,
      tagsList = props.tagsList;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)({
    studyName: "qxr",
    tagNo: null
  }),
      currentDisclosure = _useState[0],
      setCurrentDisclosure = _useState[1];

  var qxrTags = tagsList.qxr ? (0,lodash.get)(userSettingsConf, ["worklist", "tags", "qxr"], null) : null;
  var qerTags = tagsList.qer ? (0,lodash.get)(userSettingsConf, ["worklist", "tags", "qer"], null) : null;
  var qctTags = tagsList.qct ? (0,lodash.get)(userSettingsConf, ["worklist", "tags", "qct"], null) : null;
  var allStudies = [qxrTags && {
    studyName: "qxr",
    tags: qxrTags
  }, qerTags && {
    studyName: "qer",
    tags: qerTags
  }, qctTags && {
    studyName: "qct",
    tags: qctTags
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col h-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "space-y-3 mb-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: "flex items-center text-gray-800 dark:text-gray-100 font-semibold",
        children: t("worklist_tags.selection")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
        className: "flex items-center text-gray-700 dark:text-gray-200 text-[12px] text-left",
        children: t("worklist_tags.tags_text")
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(tabs_rt.Group, {
      as: "div",
      className: "border rounded-md border-gray-400 dark:border-gray-500 grow flex flex-col overflow-hidden",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tabs_rt.List, {
        as: "div",
        className: "border-b border-gray-300 dark:border-b-gray-500 flex items-center px-5 text-[12px] text-gray-800 dark:text-gray-100 font-semibold",
        children: allStudies.map(function (study) {
          return study && /*#__PURE__*/(0,jsx_runtime.jsx)(tabs_rt, {
            as: "div",
            className: "w-28 pt-3 px-4 mx-2 pb-2 border-b-4 border-b-gray-100 dark:border-gray-800 dark:ui-selected:border-teal-400 ui-selected:border-teal-400 cursor-pointer",
            onClick: function onClick() {
              return setCurrentDisclosure({
                studyName: study.studyName,
                tagNo: null
              });
            },
            children: study.studyName === "qxr" ? "X-RAY" : study.studyName === "qer" ? "HEAD CT" : "LUNG CT"
          }, study.studyName);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(tabs_rt.Panels, {
        className: "text-gray-800 dark:text-gray-200 grow flex flex-col overflow-auto",
        children: allStudies.map(function (study) {
          if (!study) return "";
          var tags = study.tags;
          var allTags = [{
            tagName: "Tag 01",
            value: tags.tag1
          }, {
            tagName: "Tag 02",
            value: tags.tag2
          }];

          if (study.studyName === "qer") {
            var areOptionalTagsEnabled = (0,lodash.get)(userSettingsConf, ["worklist", "tags", study.studyName, "optional_tags_enabled"], true);
            var _qerTags = {
              tag1: {
                value: "INFARCT",
                category: "findings"
              },
              tag2: {
                value: "ICH",
                category: "findings"
              }
            };
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(tabs_rt.Panel, {
              as: "div",
              className: classnames_default()("flex flex-col grow"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_ActiveFindings, {
                subCategories: tagsList[study.studyName]["findings"],
                labelMappings: labelMappings,
                userSettingsConf: userSettingsConf,
                setUserSettingsConf: setUserSettingsConf,
                studyName: study.studyName
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "px-5 pb-5 mt-auto pt-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_Preview, {
                  tags: _qerTags,
                  labelMappings: labelMappings,
                  tagsList: tagsList,
                  showOptionalTags: areOptionalTagsEnabled
                })
              })]
            }, study.studyName);
          }

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(tabs_rt.Panel, {
            as: "div",
            className: classnames_default()("flex flex-col grow"),
            children: [allTags.map(function (tag, index) {
              var studyName = study.studyName;
              var tagName = tag.tagName;
              var tagNo = "tag".concat(index + 1);
              return /*#__PURE__*/(0,jsx_runtime.jsx)(disclosure_ve, {
                children: function children(_ref) {
                  var open = _ref.open,
                      close = _ref.close;
                  if (currentDisclosure.tagNo !== tagNo && open) close();
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex flex-col border-b border-gray-300 dark:border-gray-500", {
                      "h-full": open,
                      "!border-b-0": tagNo === "tag2" && !!currentDisclosure.tagNo
                    }),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(disclosure_ve.Button, {
                      as: "div",
                      className: classnames_default()("w-full h-max"),
                      onClick: function onClick() {
                        return setCurrentDisclosure({
                          studyName: studyName,
                          tagNo: currentDisclosure.tagNo === tagNo ? null : tagNo
                        });
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_Tag, {
                        tagNo: tagNo,
                        studyName: studyName,
                        userSettingsConf: userSettingsConf,
                        initialUserSettingsConf: initialUserSettingsConf,
                        labelMappings: labelMappings,
                        tagsList: tagsList
                      }, index)
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(disclosure_ve.Panel, {
                      as: "div",
                      className: "h-[1px] grow pb-3",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_TagSettingsMenu, {
                        tagNo: tagNo,
                        studyName: studyName,
                        userSettingsConf: userSettingsConf,
                        setUserSettingsConf: setUserSettingsConf,
                        labelMappings: labelMappings,
                        tagsList: tagsList
                      })
                    })]
                  });
                }
              }, tagNo);
            }), (0,lodash.isEmpty)(currentDisclosure.tagNo) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "px-5 pb-5 mt-auto",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PatientWorklistMenu_Preview, {
                tags: tags,
                labelMappings: labelMappings,
                tagsList: tagsList
              })
            })]
          }, study.studyName);
        })
      })]
    })]
  });
};

/* harmony default export */ var MenuScreens_PatientWorklistMenu = (PatientWorklistMenu);
// EXTERNAL MODULE: ./components/Settings/utils/index.js
var Settings_utils = __webpack_require__(54089);
;// CONCATENATED MODULE: ./components/Settings/Index.jsx







 // import LeftMenu from "./LeftMenu";










var Settings = function Settings() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(null),
      userSettingsConf = _useState[0],
      setUserSettingsConf = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      initialUserSettingsConf = _useState3[0],
      setInitialUserSettingsConf = _useState3[1];

  var _useState4 = (0,react.useState)({}),
      labelMappings = _useState4[0],
      setLabelMappings = _useState4[1];

  var _useState5 = (0,react.useState)(),
      tagsList = _useState5[0],
      setTagsList = _useState5[1];

  var _useState6 = (0,react.useState)(0),
      currentSettingsMenu = _useState6[0],
      setCurrentSettingsMenu = _useState6[1];

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isSettingsModalOpen,
      appConfig: s.appConfig,
      userSettings: s.userSettings
    };
  }),
      isVisible = _useStoreState.isVisible,
      appConfig = _useStoreState.appConfig,
      userSettings = _useStoreState.userSettings;

  (0,react.useEffect)(function () {
    var _settings = {
      worklist: {
        tags: (0,lodash.get)(appConfig, ["tags_preference"], {})
      }
    };
    var mapping = (0,lodash.get)(appConfig, ["mapping"], {});
    var tags_list = (0,lodash.get)(appConfig, ["tags_list"], {});

    if (!(0,lodash.isEmpty)(userSettings)) {
      _settings = (0,lodash.get)(userSettings, ["settings"], {});
    }

    setUserSettingsConf(_settings);
    setInitialUserSettingsConf(_settings);
    setLabelMappings(mapping);
    setTagsList(tags_list);
    setIsLoading(false);
  }, [isVisible, appConfig, userSettings]);

  var onClose = function onClose() {
    Store/* default.update */.Z.update(function (s) {
      s.isSettingsModalOpen = false;
    });
  }; // const changeSettingsMenu = (changedMenu) => {
  //   setCurrentSettingsMenu(changedMenu);
  // };


  var saveSettings = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var isValid;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              isValid = (0,Settings_utils/* validateUserConfig */.Zl)(userSettingsConf);

              if (!isValid) {
                _context.next = 14;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return (0,Settings_utils/* postSettings */.Or)(userSettingsConf);

            case 6:
              Toast/* default.success */.Z.success(t("settings_saved.toast.success"));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              Toast/* default.error */.Z.error(t("settings_saved.toast.error"));

            case 12:
              _context.next = 15;
              break;

            case 14:
              Toast/* default.error */.Z.error(t("invalid_configuration"));

            case 15:
              _context.prev = 15;
              _context.next = 18;
              return (0,utils/* getUserSettings */.nS)();

            case 18:
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t1 = _context["catch"](15);
              console.error(_context.t1);
              Toast/* default.error */.Z.error("settings_saved.toast.loading_error");

            case 24:
              setIsLoading(false);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9], [15, 20]]);
    }));

    return function saveSettings() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* default */.Z, {
    show: isVisible,
    onClose: onClose,
    title: t("settings_key"),
    className: "w-full sm:w-6/12 !bg-gray-100 dark:!bg-gray-800 sm:h-max",
    closeOnClickAway: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "bg-gray-100 dark:bg-gray-800 rounded-b-md select-none relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-span-12 dark:border-r-0 dark:border-t-0 dark:border-b-0 dark:border-l-gray-600 p-3 sm:p-5 h-[500px]",
          children: currentSettingsMenu === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(MenuScreens_PatientWorklistMenu, {
            userSettingsConf: userSettingsConf,
            setUserSettingsConf: setUserSettingsConf,
            initialUserSettingsConf: initialUserSettingsConf,
            labelMappings: labelMappings,
            tagsList: tagsList
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-end space-x-5 mt-5 p-5 border-t border-t-gray-300 dark:border-t-gray-600",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          className: "w-36",
          onClick: onClose,
          children: t("button.cancel")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isPrimary: true,
          className: "w-36",
          onClick: saveSettings,
          children: t("button.save_changes")
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("absolute w-full h-full visible bg-gray-600 bg-opacity-50 top-0 left-0 rounded-md text-gray-900 flex items-center justify-center z-[20]", {
        visible: isLoading,
        invisible: !isLoading
      }),
      children: [t("loading_key"), "..."]
    })]
  });
};

/* harmony default export */ var Index = (Settings);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/ExclamationTriangleIcon.js

function ExclamationTriangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
  }));
}
const ForwardRef = react.forwardRef(ExclamationTriangleIcon);
/* harmony default export */ var esm_ExclamationTriangleIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronDownIcon.js

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
  }));
}
const ChevronDownIcon_ForwardRef = react.forwardRef(ChevronDownIcon);
/* harmony default export */ var esm_ChevronDownIcon = (ChevronDownIcon_ForwardRef);
;// CONCATENATED MODULE: ./components/NetworkError/index.js






var NetworkError = function NetworkError() {
  var _useState = (0,react.useState)(true),
      isOnline = _useState[0],
      setIsOnline = _useState[1];

  var _useState2 = (0,react.useState)(true),
      showNetworkError = _useState2[0],
      setShowNetworkError = _useState2[1];

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  (0,react.useEffect)(function () {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    updateOnlineStatus();
    return function () {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  var updateOnlineStatus = function updateOnlineStatus() {
    var _navigator;

    if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.onLine) {
      setIsOnline(true);
    } else {
      setIsOnline(false);
    }
  };

  if (isOnline) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "absolute bottom-0 w-full z-50",
    children: [showNetworkError && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-center bg-gradient-to-b from-transparent to-gray-900 backdrop-blur-sm pt-6 pb-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "text-gray-100 flex items-center justify-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm_ExclamationTriangleIcon, {
          className: "h-6 w-6 text-yellow-500 mr-2"
        }), t("network_connection_interrupted")]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "p-2 mt-3 rounded-full bg-gray-100",
        onClick: function onClick() {
          return setShowNetworkError(false);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ChevronDownIcon, {
          className: "h-6 w-6 text-gray-700"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative w-full h-2 bg-yellow-400",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-[30%] absolute h-2 bg-gradient-to-r from-yellow-400 to-gray-800 animate-moveBar"
      })
    })]
  });
};

/* harmony default export */ var components_NetworkError = (NetworkError);
// EXTERNAL MODULE: ./components/FormComponents/TextInput.tsx
var TextInput = __webpack_require__(42641);
;// CONCATENATED MODULE: ./components/UserGroupManagement/services/useSaveGroup.js



var useSaveGroup = function useSaveGroup() {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/accounts/groups/", params);
  });
};

/* harmony default export */ var services_useSaveGroup = (useSaveGroup);
;// CONCATENATED MODULE: ./components/UserGroupManagement/services/useAddUsers.js



var useAddUsers = function useAddUsers() {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/accounts/groups/add_users", params);
  });
};

/* harmony default export */ var services_useAddUsers = (useAddUsers);
;// CONCATENATED MODULE: ./components/UserGroupManagement/services/useRemoveUsers.js



var useRemoveUsers = function useRemoveUsers() {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/accounts/groups/remove_users", params);
  });
};

/* harmony default export */ var services_useRemoveUsers = (useRemoveUsers);
;// CONCATENATED MODULE: ./components/UserGroupManagement/services/useUpdateGroup.js



var useUpdateGroup = function useUpdateGroup() {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/accounts/groups/update", params);
  });
};

/* harmony default export */ var services_useUpdateGroup = (useUpdateGroup);
;// CONCATENATED MODULE: ./components/UserGroupManagement/services/useDeleteGroup.js



var useDeleteGroup = function useDeleteGroup() {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/accounts/groups/delete", params);
  });
};

/* harmony default export */ var services_useDeleteGroup = (useDeleteGroup);
;// CONCATENATED MODULE: ./components/UserGroupManagement/services/useLeaveGroup.js



var useLeaveGroup = function useLeaveGroup() {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/accounts/user/manage/leave_group", params);
  });
};

/* harmony default export */ var services_useLeaveGroup = (useLeaveGroup);
// EXTERNAL MODULE: ./components/InviteUsers/index.jsx + 2 modules
var InviteUsers = __webpack_require__(56768);
;// CONCATENATED MODULE: ./components/UserGroupManagement/UserRow.jsx







var UserRow = function UserRow(props) {
  var user = props.user,
      index = props.index,
      disabled = props.disabled,
      onChange = props.onChange,
      hasUpload = props.hasUpload;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var name = user.name,
      email = user.email,
      selected = user.selected,
      canUpload = user.canUpload;

  var _onClickUpdate = function _onClickUpdate(update) {
    return !disabled ? onChange(user, update) : null;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()("flex items-center justify-between p-4 mb-2 pr-4", {
      "opacity-70": !selected
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex space-x-2 items-center ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UserIcon/* default */.Z, {
        name: name || email,
        className: classnames_default()("h-7 w-7 !text-gray-100 dark:!text-gray-200 text-base mr-2 p-4", {
          "!bg-gray-700": !selected,
          "!bg-teal-700": selected
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-800 dark:text-gray-200 text-md",
          children: name || "-"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-700 dark:text-gray-400 text-md",
          children: email
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("flex items-center justify-end", {}),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        htmlFor: email,
        className: classnames_default()("py-1 px-3 rounded-md border border-gray-700 flex items-center text-[12px] select-none", {
          hidden: !hasUpload
        }),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
          id: email,
          "aria-describedby": "group",
          name: "group",
          type: "checkbox",
          className: "rounded border-gray-400 cursor-pointer text-teal-400 bg-transparent",
          disabled: disabled,
          checked: canUpload,
          onChange: function onChange() {
            return _onClickUpdate({
              "delete": false,
              upload: true
            });
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "ml-3 leading-6",
          children: t("can_upload")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()("cursor-pointer ml-4 flex items-center", {
          hidden: disabled
        }),
        onClick: function onClick() {
          return _onClickUpdate({
            "delete": true,
            upload: false
          });
        },
        children: selected ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/assets/icons/delete.svg",
          alt: "emergency",
          width: "20",
          height: "20"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/assets/icons/addNew.svg",
          alt: "re-add",
          className: "text-white",
          width: "20",
          height: "20"
        })
      })]
    })]
  }, index);
};

/* harmony default export */ var UserGroupManagement_UserRow = (UserRow);
;// CONCATENATED MODULE: ./components/UserGroupManagement/CreateUserModal.jsx




function CreateUserModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CreateUserModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CreateUserModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CreateUserModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


























var CreateUserModal = function CreateUserModal(_ref) {
  var selectedGroup = _ref.selectedGroup,
      isVisible = _ref.isVisible,
      onClose = _ref.onClose;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(""),
      name = _useState[0],
      setName = _useState[1];

  var _useState2 = (0,react.useState)(""),
      description = _useState2[0],
      setDescription = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      collaboratorsList = _useState3[0],
      setCollaboratorsList = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      deleteModal = _useState4[0],
      setDeleteModal = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      error = _useState5[0],
      setError = _useState5[1];

  var isAdmin = (0,lodash.get)(selectedGroup, ["group_admin"], false);
  var saveGroup = services_useSaveGroup();
  var addUsers = services_useAddUsers();
  var removeUsers = services_useRemoveUsers();
  var updateGroup = services_useUpdateGroup();
  var deleteGroup = services_useDeleteGroup();
  var leaveGroup = services_useLeaveGroup();
  var isEdit = !(0,lodash.isEmpty)(selectedGroup);

  var _Store$useState = Store/* default.useState */.Z.useState(function (s) {
    return s.user;
  }),
      usersEmail = _Store$useState.email;

  var removedUsers = collaboratorsList.filter(function (user) {
    return user.saved && !user.selected;
  }).map(function (user) {
    return user.email;
  });
  var addedUsers = collaboratorsList.filter(function (user) {
    return !user.saved && user.selected;
  }).map(function (user) {
    return user.email;
  });
  var disableSave = (0,lodash.isEmpty)(removedUsers) && (0,lodash.isEmpty)(addedUsers) && name === (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.name) && description === (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.description) || (0,lodash.isEmpty)(name) || !isEdit && (0,lodash.isEmpty)(addedUsers);
  (0,react.useEffect)(function () {
    if (!(0,lodash.isEmpty)(selectedGroup)) {
      var defaultUsers = (0,lodash.get)(selectedGroup, ["users"], []).map(function (user) {
        return CreateUserModal_objectSpread(CreateUserModal_objectSpread({}, user), {}, {
          selected: true,
          saved: true
        });
      });
      setCollaboratorsList(defaultUsers);
      setName(selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.name);
      setDescription(selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.description);
    }
  }, [selectedGroup]);

  var onCloseModal = function onCloseModal(updated) {
    setName("");
    setDescription("");
    setCollaboratorsList([]);
    onClose(updated);
    setError();
  };

  var validateForm = function validateForm() {
    if ((0,lodash.isEmpty)(name) || !isEdit && (0,lodash.isEmpty)(addedUsers)) {
      return false;
    }

    return true;
  };

  var onSave = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var validationResults, response, payload, _payload, message, warning, status, errorMsg;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validationResults = (0,regexValidation/* validateFields */.Of)([{
                fn: regexValidation/* customRegexValidation */.dc,
                value: name,
                err: " ".concat(t("group.validation.name_special_char"), ",")
              }, {
                fn: regexValidation/* startCharCheckValidation */.UY,
                value: name,
                err: " ".concat(t("group.validation.name_start"), ",")
              }, {
                fn: regexValidation/* customRegexValidation */.dc,
                value: description,
                err: " ".concat(t("group.validation.description_special_char"), ",")
              }, {
                fn: regexValidation/* startCharCheckValidation */.UY,
                value: description,
                err: " ".concat(t("group.validation.description_start"), ",")
              }]);

              if (validationResults) {
                setError(validationResults);
              }

              _context.prev = 2;

              if (!(validateForm() && !validationResults)) {
                _context.next = 30;
                break;
              }

              response = null;

              if (!isEdit) {
                _context.next = 23;
                break;
              }

              payload = {
                id: (0,lodash.get)(selectedGroup, ["id"], "")
              };

              if ((0,lodash.isEmpty)(addedUsers)) {
                _context.next = 12;
                break;
              }

              // add users
              payload["emails"] = addedUsers;
              _context.next = 11;
              return addUsers.mutateAsync(payload);

            case 11:
              response = _context.sent;

            case 12:
              if ((0,lodash.isEmpty)(removedUsers)) {
                _context.next = 16;
                break;
              }

              // remove users
              payload["emails"] = removedUsers;
              _context.next = 16;
              return removeUsers.mutateAsync(payload);

            case 16:
              if (!(name !== selectedGroup.name || description !== selectedGroup.description)) {
                _context.next = 21;
                break;
              }

              // update group
              payload["description"] = description;
              payload["name"] = name;
              _context.next = 21;
              return updateGroup.mutateAsync(payload);

            case 21:
              _context.next = 26;
              break;

            case 23:
              _payload = {
                name: name,
                description: description,
                emails: addedUsers
              };
              _context.next = 26;
              return saveGroup.mutateAsync(_payload);

            case 26:
              message = (0,lodash.get)(response, ["message"], []);

              if (!(0,lodash.isEmpty)(message) && message.length > 1) {
                warning = message[0];
                message.shift();

                if (message) {
                  warning += message.join(", ");
                }

                Toast/* default.warning */.Z.warning(warning);
              }

              Toast/* default.success */.Z.success(t("group.toast.saved_successfully"));
              onCloseModal(true);

            case 30:
              _context.next = 36;
              break;

            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](2);
              status = (0,lodash.get)(_context.t0, ["response", "status"], 0);

              if (status && (status === 403 || status === 406)) {
                errorMsg = (0,lodash.get)(_context.t0, ["response", "data", "message"], "");
                Toast/* default.error */.Z.error(errorMsg);
              } else {
                Toast/* default.error */.Z.error(t("group.toast.saved_failed"));
              }

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 32]]);
    }));

    return function onSave() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onDelete = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var payload, status, errorMsg;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              payload = {
                id: (0,lodash.get)(selectedGroup, ["id"], "")
              };
              _context2.next = 4;
              return deleteGroup.mutateAsync(payload);

            case 4:
              Toast/* default.success */.Z.success(t("group.toast.deleted_successfully"));
              onCloseModal(true);
              setDeleteModal(false);
              _context2.next = 14;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              status = (0,lodash.get)(_context2.t0, ["response", "status"], 0);

              if (status && status === 403) {
                errorMsg = (0,lodash.get)(_context2.t0, ["response", "data", "message"], "");
                Toast/* default.error */.Z.error(errorMsg);
              } else {
                Toast/* default.error */.Z.error(t("group.toast.deleted_failed"));
              }

              setDeleteModal(false);

            case 14:
              deleteGroup;

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function onDelete() {
      return _ref3.apply(this, arguments);
    };
  }();

  var onExitGroup = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var payload, status, errorMsg;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              payload = {
                id: (0,lodash.get)(selectedGroup, ["id"], "")
              };
              _context3.next = 4;
              return leaveGroup.mutateAsync(payload);

            case 4:
              Toast/* default.success */.Z.success(t("group.toast.exited_successfully"));
              onCloseModal(true);
              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              status = (0,lodash.get)(_context3.t0, ["response", "status"], 0);

              if (status && status === 406) {
                errorMsg = (0,lodash.get)(_context3.t0, ["response", "data", "message"], "");
                Toast/* default.error */.Z.error(errorMsg);
              } else {
                Toast/* default.error */.Z.error(t("group.toast.exited_failed"));
              }

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function onExitGroup() {
      return _ref4.apply(this, arguments);
    };
  }();

  var onToggleCollaborator = function onToggleCollaborator(_ref5, update) {
    var email = _ref5.email;
    var updatedList = collaboratorsList.map(function (item) {
      if (item.email === email) {
        if (update["delete"]) {
          item.selected = !item.selected;
        }

        return item;
      }

      return item;
    });
    setCollaboratorsList(updatedList);
  };

  var onAddNewCollabrators = function onAddNewCollabrators(_collaborators) {
    var _collaboratorsList = (0,lodash.clone)(collaboratorsList);

    _collaborators.forEach(function (_collaborator) {
      if (!_collaboratorsList.some(function (c) {
        return c.email === _collaborator.value;
      })) {
        _collaboratorsList.unshift({
          name: _collaborator.text,
          email: _collaborator.value,
          selected: true,
          saved: false
        });
      }
    });

    setCollaboratorsList(_collaboratorsList);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      title: "".concat(isEdit ? t("edit_group_title") : t("create_group_title")),
      onClose: onCloseModal,
      show: isVisible,
      className: "flex flex-col w-full h-[90%] sm:w-7/12 md:w-7/12 lg:w-5/12 sm:h-5/6 sm:!max-h-[80%] overflow-hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col h-full mt-4 text-left overflow-y-auto scrollbar-light dark:scrollbar",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mx-5",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
              label: t("user_group.name_label"),
              placeholder: t("user_group.name_placeholder"),
              name: "groupName",
              id: "groupName",
              wrapperClassName: "my-5",
              required: true,
              value: name,
              onChange: function onChange(val) {
                return setName(val);
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
              label: t("user_group.description_label"),
              placeholder: t("user_group.description_placeholder"),
              name: "groupDescription",
              id: "groupDescription",
              wrapperClassName: "my-5",
              value: description,
              onChange: function onChange(val) {
                return setDescription(val);
              }
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col h-full mx-5 space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-base",
            children: t("user_group.add_members")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InviteUsers/* default */.Z, {
            onSubmit: onAddNewCollabrators
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "bg-gray-300 dark:bg-gray-900 py-2 rounded-lg",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "max-h-64 sm:max-h-56 overflow-y-auto scrollbar-light dark:scrollbar sm:!scrollbar-group divide-y divide-gray-800",
              children: !(0,lodash.isEmpty)(collaboratorsList) && collaboratorsList.map(function (user, index) {
                var email = user.email;
                var disabled = isEdit && !isAdmin || usersEmail === email;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(UserGroupManagement_UserRow, {
                  user: user,
                  index: index,
                  disabled: disabled,
                  onChange: onToggleCollaborator
                }, email);
              })
            }), (0,lodash.isEmpty)(collaboratorsList) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "flex flex-col justify-center items-center text-center w-full h-full text-gray-600 cursor-default",
              children: t("user_group.please_add_members")
            })]
          })]
        }), error && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-red-500 px-6 py-1 text-left mb-4 sm:mb-0",
          children: error
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "align-bottom border-t h-fit border-gray-800 w-full mt-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-between flex-row p-4 border-t border-t-gray-600",
            children: isEdit && !isAdmin ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "p-4 flex items-center justify-center w-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center cursor-pointer",
                onClick: onExitGroup,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                  name: pro_regular_svg_icons/* faXmark */.g82,
                  className: "w-6"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "pl-2",
                  children: t("user_group.exit")
                })]
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  onClick: function onClick() {
                    return setDeleteModal(true);
                  },
                  className: classnames_default()("flex items-center cursor-pointer", {
                    hidden: !isAdmin
                  }),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                    name: pro_regular_svg_icons/* faTrash */.XAH,
                    className: "dark:text-gray-200 text-gray-700"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "pl-2",
                    children: t("button.delete")
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex space-x-4 flex-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                  isSecondary: true,
                  className: "grow-1 w-24 lg:w-36",
                  onClick: onCloseModal,
                  children: t("button.cancel")
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                  isPrimary: true,
                  isLoading: (saveGroup === null || saveGroup === void 0 ? void 0 : saveGroup.isLoading) || (addUsers === null || addUsers === void 0 ? void 0 : addUsers.isLoading) || (removeUsers === null || removeUsers === void 0 ? void 0 : removeUsers.isLoading) || (updateGroup === null || updateGroup === void 0 ? void 0 : updateGroup.isLoading),
                  onClick: onSave,
                  className: "sm:mt-0 grow-1 ml-4 w-24 lg:w-36",
                  disabled: disableSave,
                  children: t("button.save")
                })]
              })]
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AutomatedShare_DeleteModal, {
      deleteModal: deleteModal,
      onDelete: onDelete,
      setDeleteModal: setDeleteModal,
      title: t("delete_user_group.title"),
      content: t("delete_user_group.text")
    })]
  });
};

CreateUserModal.defaultProps = {};
/* harmony default export */ var UserGroupManagement_CreateUserModal = (CreateUserModal);
;// CONCATENATED MODULE: ./components/UserGroupManagement/index.jsx












function UserGroupManagement(_ref) {
  var isOpen = _ref.isOpen;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      showAddEditUserGroup = _useState[0],
      toggleAddEditUserGroup = _useState[1];

  var _useState2 = (0,react.useState)({}),
      selectedGroup = _useState2[0],
      setSelectedGroup = _useState2[1];

  var _useGetUserGroups = (0,useGetUserGroups/* default */.Z)(isOpen),
      userGroupdData = _useGetUserGroups.data,
      refetchUserGroups = _useGetUserGroups.refetch;

  var groups = (0,lodash.get)(userGroupdData, ["groups"], []);

  var onCloseAddEditModal = function onCloseAddEditModal(updated) {
    if (updated) {
      refetchUserGroups();
    }

    toggleAddEditUserGroup(false);
    setSelectedGroup({});
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-5 sm:my-5 space-y-6 flex flex-col text-left h-full p-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "space-y-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "text-base",
          children: [t("user_group.creating"), " "]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-800 dark:text-gray-300 text-md",
          children: t("user_group.text")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col flex-1 justify-between sm:space-y-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()("max-h-96 sm:max-h-60 mb-6 sm:mb-0 overflow-y-auto scrollbar-light dark:scrollbar space-y-3", {
            hidden: (0,lodash.isEmpty)(groups)
          }),
          children: groups === null || groups === void 0 ? void 0 : groups.map(function (group, index) {
            var usersList = (0,lodash.get)(group, ["users"], []);
            var membersList = usersList.slice(0, 4).map(function (m) {
              return m.email;
            }).join(", ");
            var moreCount = "";

            if (usersList.length > 4) {
              moreCount = "+".concat(usersList.length - 4);
            }

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "bg-gray-300 dark:bg-gray-900 flex justify-between px-4 py-5 w-full rounded-lg cursor-pointer",
              onClick: function onClick() {
                setSelectedGroup(group);
                toggleAddEditUserGroup(true);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-2 w-full",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-gray-800 dark:text-gray-500 text-base",
                  children: group === null || group === void 0 ? void 0 : group.name
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "text-md text-gray-800 dark:text-gray-200 flex-wrap",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "text-teal-600 dark:text-teal-300",
                    children: [t("user_group.members"), " "]
                  }), membersList, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-teal-500 font-semibold",
                    children: moreCount
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                name: pro_regular_svg_icons/* faPenToSquare */.Yai,
                className: "text-gray-600 dark:text-gray-500 w-6"
              })]
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            onClick: function onClick() {
              return toggleAddEditUserGroup(true);
            },
            className: "inline-flex border bg-gray-600 hover:bg-teal-800 dark:bg-transparent dark:border-teal-300 dark:hover:border-teal-800 dark:hover:bg-teal-800 w-full space-x-4 items-center justify-center text-base font-medium rounded-6 text-gray-100 py-4 px-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
              name: pro_regular_svg_icons/* faPlus */.r8p,
              className: "w-6 text-white cursor-pointer"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: t("user_group.new_button")
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UserGroupManagement_CreateUserModal, {
      selectedGroup: selectedGroup,
      isVisible: showAddEditUserGroup,
      onClose: onCloseAddEditModal
    })]
  });
}

/* harmony default export */ var components_UserGroupManagement = (UserGroupManagement);
;// CONCATENATED MODULE: ./components/UserGroupManagement/UserGroupModal.jsx







var UserGroupModal = function UserGroupModal() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isUserGroupOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var onCloseModal = function onCloseModal() {
    Store/* default.update */.Z.update(function (s) {
      s.isUserGroupOpen = false;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    title: t("setting_user"),
    onClose: onCloseModal,
    show: isVisible,
    className: "flex flex-col w-full sm:w-7/12 lg:w-4/12 !h-auto max-h-[90%] sm:!max-h-[80%] overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_UserGroupManagement, {
      isOpen: isVisible
    })
  });
};

/* harmony default export */ var UserGroupManagement_UserGroupModal = (UserGroupModal);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useSingleWorkspace.ts



function useSingleWorkspace(params) {
  var _params$isOpen = params.isOpen,
      isOpen = _params$isOpen === void 0 ? false : _params$isOpen,
      _params$id = params.id,
      id = _params$id === void 0 ? "" : _params$id;
  return (0,es.useQuery)("singleWorkspace", function () {
    return servicesUtils/* default.getService */.Z.getService("/workspaces/".concat(id));
  }, {
    enabled: isOpen && !!id
  });
}

/* harmony default export */ var services_useSingleWorkspace = (useSingleWorkspace);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useMutateSingleWorkspace.ts



function useMutateSingleWorkspace(workspaceId) {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/workspaces/".concat(workspaceId, "/"), params);
  });
}

/* harmony default export */ var services_useMutateSingleWorkspace = (useMutateSingleWorkspace);
;// CONCATENATED MODULE: ./components/ConfirmationModal.tsx


var ConfirmationModal_jsx = react.createElement;





var labelsDefault = {
  title: "Confirmation modal",
  label: "Click yes to confirm",
  yes: "Confirm",
  no: "Cancel"
};

var ConfirmationModal = function ConfirmationModal(props) {
  var onClose = props.onClose,
      onClickConfirm = props.onClickConfirm,
      _props$labels = props.labels,
      labels = _props$labels === void 0 ? labelsDefault : _props$labels,
      isLoading = props.isLoading,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className;
  var _labels$title = labels.title,
      title = _labels$title === void 0 ? "" : _labels$title,
      label = labels.label,
      yes = labels.yes,
      no = labels.no;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isConfirmationModalOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  return /*#__PURE__*/react.createElement(Modal/* default */.Z, {
    show: isVisible,
    onClose: onClose,
    title: title,
    className: classnames_default()("w-full sm:w-4/12 lg:w-3/12", (0,defineProperty/* default */.Z)({}, className, !!className))
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-6 text-left"
  }, label), /*#__PURE__*/react.createElement("div", {
    className: "flex items-center flex-col sm:justify-end sm:flex-row p-4 border-t border-t-gray-700"
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: "grow-1 ml-4 w-full sm:w-auto py-4 px-6",
    onClick: onClose
  }, no), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    isPrimary: true,
    isLoading: isLoading,
    className: "mt-3 sm:mt-0 grow-1 ml-4 w-full sm:w-auto py-4 px-6",
    onClick: onClickConfirm
  }, yes)));
};

ConfirmationModal.defaultProps = {
  isLoading: false,
  onClickConfirm: function onClickConfirm() {
    return null;
  },
  onClose: function onClose() {
    return null;
  },
  labels: labelsDefault
};
/* harmony default export */ var components_ConfirmationModal = (ConfirmationModal);
// EXTERNAL MODULE: ./components/WorkspaceManagementModal/utils.ts
var WorkspaceManagementModal_utils = __webpack_require__(38990);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useCreateNewWorkspace.js



function useCreateNewWorkspace() {
  return (0,es.useMutation)(function (params) {
    return servicesUtils/* default.postService */.Z.postService("/workspaces/create/", params);
  });
}

/* harmony default export */ var services_useCreateNewWorkspace = (useCreateNewWorkspace);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/EditWorkspace.jsx






















var EditWorkspace = function EditWorkspace(props) {
  var data = props.data,
      onCloseModal = props.onCloseModal,
      defaultId = props.defaultId,
      refetchWorkspace = props.refetchWorkspace,
      refetchProfile = props.refetchProfile;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var workspaceId = (0,lodash.get)(data, ["id"]);
  var id = (0,WorkspaceManagementModal_utils/* getTrimmedId */.V)((0,lodash.get)(data, ["uuid"]));
  var patientCount = (0,lodash.get)(data, ["patient_count"]);
  var memberCount = (0,lodash.get)(data, ["member_count"]);
  var name = (0,lodash.get)(data, ["name"]);
  var isEditMode = !(0,lodash.isEmpty)(data);

  var convertResponseToForm = function convertResponseToForm() {
    var users = _.get(data, ["users"], []);

    return users.map(function (u) {
      var permissions = _.get(u, ["permissions"], []);

      return {
        name: _.get(u, ["name"], ""),
        email: _.get(u, ["email"], ""),
        saved: false,
        canUpload: permissions.includes("CREATE_PATIENTS"),
        selected: true
      };
    });
  };

  var _useState = (0,react.useState)(name),
      workspaceName = _useState[0],
      setWorkspaceName = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isFormDirty = _useState3[0],
      setFormDirty = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      collaboratorsList = _useState4[0],
      setCollaboratorsList = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      error = _useState5[0],
      setError = _useState5[1];

  (0,react.useEffect)(function () {
    if (workspaceId === defaultId) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [defaultId, workspaceId]);
  (0,react.useEffect)(function () {
    setCollaboratorsList(convertResponseToForm());
    setWorkspaceName(name);
  }, [data]);
  var mutateSingleWorkspace = services_useMutateSingleWorkspace(workspaceId);
  var createNewWorkspace = services_useCreateNewWorkspace();
  (0,react.useEffect)(function () {
    if (mutateSingleWorkspace.status === "success") {
      var newList = collaboratorsList.filter(function (collab) {
        return collab.selected;
      });
      setCollaboratorsList(newList);
    }
  }, [mutateSingleWorkspace.status]);

  var onClickSave = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var validationResults, payload;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validationResults = (0,regexValidation/* validateFields */.Of)([{
                fn: regexValidation/* emptyFieldValidation */.VK,
                value: workspaceName,
                err: " ".concat(t("workspace_management.validation.empty_field"), ",")
              }, {
                fn: regexValidation/* customRegexValidation */.dc,
                value: workspaceName,
                err: " ".concat(t("workspace_management.validation.special_char"), ",")
              }, {
                fn: regexValidation/* startCharCheckValidation */.UY,
                value: workspaceName,
                err: " ".concat(t("workspace_management.validation.start"), ",")
              }]);

              if (validationResults) {
                setError(validationResults);
              }

              if (isFormDirty && !validationResults) {
                // if its dirty then save it
                // for the payload, call post call
                setError("");
                payload = {
                  name: workspaceName,
                  user_updates: [],
                  is_default: isChecked
                };
                payload.user_updates = collaboratorsList.map(function (collab) {
                  var dot = {
                    email: collab.email
                  };

                  if (!collab.selected) {
                    // means deleting an user
                    dot.permissions = [];
                  } else {
                    dot.permissions = ["WRITE_PATIENTS"];

                    if (collab.canUpload) {
                      dot.permissions.push("CREATE_PATIENTS");
                    }
                  }

                  return dot;
                });

                try {
                  if (isEditMode) {
                    mutateSingleWorkspace.mutateAsync(payload).then(function () {
                      refetchWorkspace();
                      refetchProfile();
                      Toast/* default.success */.Z.success(t("workspace_management.toast.success"));
                    })["catch"](function (err) {
                      Toast/* default.error */.Z.error(t("workspace_management.toast.failed"));
                    });
                  } else {
                    createNewWorkspace.mutateAsync(payload).then(function () {
                      refetchWorkspace();
                      refetchProfile();
                      Toast/* default.success */.Z.success(t("workspace_management.toast.create_success"));
                    })["catch"](function (err) {
                      Toast/* default.error */.Z.error(t("workspace_management.toast.failed"));
                    });
                  }

                  setFormDirty(false);
                  onCloseModal();
                } catch (e) {
                  setFormDirty(false);
                  onCloseModal();
                  Toast/* default.success */.Z.success(t("workspace_management.toast.failed"));
                }
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onClickSave() {
      return _ref.apply(this, arguments);
    };
  }();

  var onChangeWorkspaceName = function onChangeWorkspaceName(val) {
    setWorkspaceName(val);

    if (!isFormDirty) {
      setFormDirty(true);
    }
  };

  var onAddNewCollaborators = function onAddNewCollaborators(_collaborators) {
    var _collaboratorsList = (0,lodash.clone)(collaboratorsList);

    _collaborators.forEach(function (_collaborator) {
      if (!_collaboratorsList.some(function (c) {
        return c.email === _collaborator.value;
      })) {
        _collaboratorsList.unshift({
          name: _collaborator.text,
          email: _collaborator.value,
          selected: true,
          canUpload: true,
          saved: false
        });
      }
    });

    setFormDirty(true);
    setCollaboratorsList(_collaboratorsList);
  };

  var onToggleCollaborator = function onToggleCollaborator(_ref2, update) {
    var email = _ref2.email;
    var hasSet = false;
    var updatedList = collaboratorsList.map(function (item) {
      if (item.email === email) {
        if (update["delete"]) {
          item.selected = !item.selected;
          item.canUpload = false;
          hasSet = true;
        }

        if (update.upload) {
          item.canUpload = !item.canUpload;
          hasSet = true;
        }

        return item;
      }

      return item;
    });

    if (!isFormDirty && hasSet) {
      setFormDirty(true);
    }

    setCollaboratorsList(updatedList);
  };

  var onClickCancel = function onClickCancel() {
    if (isFormDirty) {
      // open confirmation modal and close this
      Store/* default.update */.Z.update(function (s) {
        s.isConfirmationModalOpen = true;
      });
    } else {
      // close the modal
      onCloseModal();
    }
  };

  var onClickConfirmUnsave = function onClickConfirmUnsave() {
    Store/* default.update */.Z.update(function (s) {
      s.isConfirmationModalOpen = false;
    });
    setFormDirty(false);
    onCloseModal();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()("text-left p-5 flex-1", {
        "opacity-60 pointer-events-none": mutateSingleWorkspace.isLoading
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between items-start",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-gray-800 dark:text-gray-200",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: t("workspace_management.edit_text")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-sm",
            children: t("workspace_management.add_remove_text")
          })]
        }), isEditMode && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "rounded-md border border-gray-300 px-4 py-2 text-[12px]",
          children: [patientCount, " ", t("patients_key")]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        label: "Workspace Name",
        placeholder: "Enter workspace Name",
        name: "workspaceName",
        id: "workspaceName",
        wrapperClassName: "my-5",
        required: true,
        value: workspaceName,
        rightContent: function rightContent() {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isEditMode && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex px-2 text-[14px] tracking-wider",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-gray-900 dark:text-gray-100 mr-4",
                children: [memberCount, " ", t("members_key")]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-gray-600 dark:text-gray-300 uppercase",
                children: id
              })]
            })
          });
        },
        onChange: function onChange(val) {
          return onChangeWorkspaceName(val);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col h-full space-y-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex justify-between items-end mb-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-base",
            children: t("workspace_management.master_user_list")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
            name: "defaultWorkspace",
            id: "defaultWorkspace",
            checked: isChecked,
            disabled: workspaceId === defaultId,
            className: "pb-4",
            label: t("workspace_management.default_workspace"),
            onChange: function onChange(value) {
              setFormDirty(true);
              setIsChecked(value);
            }
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InviteUsers/* default */.Z, {
            onSubmit: onAddNewCollaborators
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-sm text-gray-800 dark:text-gray-300 mt-2",
            children: t("workspace_management.all_users_default")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-gray-300 dark:bg-gray-900 py-2 rounded-lg mt-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "h-48 overflow-y-auto scrollbar-light dark:scrollbar divide-y divide-gray-800",
            children: [!(0,lodash.isEmpty)(collaboratorsList) && collaboratorsList.map(function (user, index) {
              var email = user.email;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(UserGroupManagement_UserRow, {
                user: user,
                index: index,
                hasUpload: true,
                onChange: onToggleCollaborator
              }, email);
            }), (0,lodash.isEmpty)(collaboratorsList) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-col h-full w-full items-center justify-center text-gray-700 cursor-default",
              children: t("workspace_management.no_members")
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-red-500 px-6 pb-2 text-left mb-4 sm:mb-0",
      children: error
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-4 p-4 border-t border-t-gray-700 flex items-center justify-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isSecondary: true,
          disabled: mutateSingleWorkspace.isLoading,
          className: "mr-4 px-7 py-4",
          onClick: onClickCancel,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "",
            children: t("button.cancel")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          isPrimary: true,
          isLoading: mutateSingleWorkspace.isLoading,
          className: "px-7 py-4",
          disabled: !isFormDirty,
          onClick: onClickSave,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "",
            children: t("button.save")
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_ConfirmationModal, {
      onClose: function onClose() {
        Store/* default.update */.Z.update(function (s) {
          s.isConfirmationModalOpen = false;
        });
      },
      onClickConfirm: onClickConfirmUnsave,
      labels: {
        title: t("confirmation_modal_unsaved"),
        label: t("confirmation_modal_message"),
        yes: t("yes_key"),
        no: t("no_key")
      }
    })]
  });
};

/* harmony default export */ var WorkspaceManagementModal_EditWorkspace = (EditWorkspace);
// EXTERNAL MODULE: ./components/common/DropdownMenu.tsx
var DropdownMenu = __webpack_require__(6039);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useHideWorkspace.js



function useHideWorkspace() {
  return (0,es.useMutation)(function (id) {
    return servicesUtils/* default.getService */.Z.getService("/workspaces/".concat(id, "/hide/"));
  });
}

/* harmony default export */ var services_useHideWorkspace = (useHideWorkspace);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useUnhideWorkspace.js



function useUnhideWorkspace() {
  return (0,es.useMutation)(function (id) {
    return servicesUtils/* default.getService */.Z.getService("/workspaces/".concat(id, "/unhide/"));
  });
}

/* harmony default export */ var services_useUnhideWorkspace = (useUnhideWorkspace);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useExitWorkspace.js



function useExitWorkspace() {
  return (0,es.useMutation)(function (id) {
    return servicesUtils/* default.getService */.Z.getService("/workspaces/".concat(id, "/exit/"));
  });
}

/* harmony default export */ var services_useExitWorkspace = (useExitWorkspace);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/services/useDefaultWorkspace.js



function useDefaultWorkspace() {
  return (0,es.useMutation)(function (id) {
    return servicesUtils/* default.getService */.Z.getService("/workspaces/".concat(id, "/default/"));
  });
}

/* harmony default export */ var services_useDefaultWorkspace = (useDefaultWorkspace);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/WorkspaceList.jsx























var WorkspaceList = function WorkspaceList(props) {
  var workspaceData = props.workspaceData,
      onClickEditWorkspace = props.onClickEditWorkspace,
      onClickNewWorkspace = props.onClickNewWorkspace,
      defaultId = props.defaultId,
      refetchWorkspace = props.refetchWorkspace,
      refetchProfile = props.refetchProfile;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var sharedWorkspaces = workspaceData.shared_workspaces,
      ownWorkspaces = workspaceData.owned_workspaces;

  var _useContext = (0,react.useContext)(PatientsContext/* PatientsContext */.w),
      getPatientData = _useContext.getPatientData;

  var _useState = (0,react.useState)({}),
      selectedWorkspace = _useState[0],
      setSelectedWorkspace = _useState[1];

  var hideWorkspace = services_useHideWorkspace();
  var unhideWorkspace = services_useUnhideWorkspace();
  var exitWorkspace = services_useExitWorkspace();
  var defaultWorkspace = services_useDefaultWorkspace();

  var refetchAll = function refetchAll() {
    refetchWorkspace();
    getPatientData();
    refetchProfile();
  };

  var sharedWorkspaceMenu = function sharedWorkspaceMenu(isActive, id) {
    if (id == defaultId) {
      return [{
        name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex px-4 py-3 items-center justify-start text-md",
          children: t("workspace_management.exit_workspace")
        }),
        className: "hover:bg-teal-800",
        onClick: function onClick() {
          Store/* default.update */.Z.update(function (s) {
            s.isConfirmationModalOpen = true;
          });
        }
      }];
    } else if (!isActive) {
      return [{
        name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex px-4 py-3 items-center justify-start text-md",
          children: isActive ? t("workspace_management.hide_patients_worklist") : t("workspace_management.show_patients_worklist")
        }),
        className: "hover:bg-teal-800",
        onClick: function onClick() {
          if (isActive) {
            hideWorkspace.mutateAsync(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id).then(function () {
              refetchAll();
              Toast/* default.success */.Z.success(t("workspace_management.toast.hide_success"));
            })["catch"](function (err) {
              Toast/* default.error */.Z.error(t("report_signature.toast.failed"));
            });
          } else {
            unhideWorkspace.mutateAsync(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id).then(function () {
              refetchAll();
              Toast/* default.success */.Z.success(t("workspace_management.toast.unhide_success"));
            })["catch"](function (err) {
              Toast/* default.error */.Z.error(t("report_signature.toast.failed"));
            });
          }
        }
      }, {
        name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex px-4 py-3 items-center justify-start text-md",
          children: t("workspace_management.exit_workspace")
        }),
        className: "hover:bg-teal-800",
        onClick: function onClick() {
          Store/* default.update */.Z.update(function (s) {
            s.isConfirmationModalOpen = true;
          });
        }
      }];
    } else {
      return [{
        name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex px-4 py-3 items-center justify-start text-md",
          children: t("workspace_management.set_default_upload")
        }),
        className: "hover:bg-teal-800",
        onClick: function () {
          var _onClick = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    handleSetDefault();

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onClick() {
            return _onClick.apply(this, arguments);
          }

          return onClick;
        }()
      }, {
        name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex px-4 py-3 items-center justify-start text-md",
          children: isActive ? t("workspace_management.hide_patients_worklist") : t("workspace_management.show_patients_worklist")
        }),
        className: "hover:bg-teal-800",
        onClick: function onClick() {
          if (isActive) {
            hideWorkspace.mutateAsync(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id).then(function () {
              refetchAll();
              Toast/* default.success */.Z.success(t("workspace_management.toast.hide_success"));
            })["catch"](function (err) {
              Toast/* default.error */.Z.error(t("report_signature.toast.failed"));
            });
          } else {
            unhideWorkspace.mutateAsync(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id).then(function () {
              refetchAll();
              Toast/* default.success */.Z.success(t("workspace_management.toast.unhide_success"));
            })["catch"](function (err) {
              Toast/* default.error */.Z.error(t("report_signature.toast.failed"));
            });
          }
        }
      }, {
        name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex px-4 py-3 items-center justify-start text-md",
          children: t("workspace_management.exit_workspace")
        }),
        className: "hover:bg-teal-800",
        onClick: function onClick() {
          Store/* default.update */.Z.update(function (s) {
            s.isConfirmationModalOpen = true;
          });
        }
      }];
    }
  };

  var onClickConfirmExit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              exitWorkspace.mutateAsync(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id).then(function () {
                refetchProfile();
                getPatientData();
                refetchWorkspace();
                Toast/* default.success */.Z.success("workspace_management.toast.exit");
              })["catch"](function () {
                Toast/* default.error */.Z.error(t("report_signature.toast.failed"));
              });
              Store/* default.update */.Z.update(function (s) {
                s.isConfirmationModalOpen = false;
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onClickConfirmExit() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSetDefault = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              defaultWorkspace.mutateAsync(selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id).then(function () {
                refetchProfile();
                Toast/* default.success */.Z.success(t("workspace_management.toast.default_workspace"));
              })["catch"](function (resp) {
                Toast/* default.error */.Z.error((0,lodash.get)(resp, ["response", "data", "detail"], t("report_signature.toast.failed")));
              });

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSetDefault() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-left p-4 flex flex-col h-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "!max-h-1/2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-gray-800 dark:text-gray-200",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: t("workspace_management.welcome_text")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-sm",
            children: t("workspace_management.definition")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "max-h-[180px] scrollbar overflow-y-auto",
          children: ownWorkspaces && !(0,lodash.isEmpty)(ownWorkspaces) && ownWorkspaces.map(function (ws) {
            var workspaceId = (0,lodash.get)(ws, ["uuid"], "");
            workspaceId = (0,WorkspaceManagementModal_utils/* getTrimmedId */.V)(workspaceId);
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "bg-gray-100 dark:bg-gray-900 p-4 rounded-md mt-5 flex items-center justify-between text-[14px] cursor-pointer text-gray-900 dark:text-gray-100",
              onClick: function onClick() {
                return onClickEditWorkspace((0,lodash.get)(ws, ["id"], ""));
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "mr-5 uppercase",
                  children: workspaceId
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [ws.name, " (", ws.count, " ", t("members_key"), ")"]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center space-x-2",
                children: [defaultId === ws.id && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "text-gray-400 text-md italic mr-2",
                  children: t("workspace_management.default")
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  fill: "currentColor",
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                    d: "M9.86788 1.16806C10.5997 0.435843 11.7871 0.435843 12.5189 1.16806L12.834 1.48368C13.5658 2.21597 13.5658 3.40321 12.834 4.13498L7.69861 9.273C7.47205 9.49696 7.1934 9.66102 6.88611 9.74957L4.28194 10.4944C4.06319 10.5569 3.82882 10.4944 3.66736 10.3121C3.5085 10.174 3.446 9.93967 3.5085 9.72092L4.2533 7.11675C4.34184 6.80946 4.5059 6.53082 4.72986 6.30425L9.86788 1.16806ZM11.6127 2.05191C11.3913 1.8079 10.9955 1.8079 10.7507 2.05191L9.99288 2.80946L11.1934 4.00998L11.9512 3.22873C12.196 3.00738 12.196 2.61155 11.9512 2.36754L11.6127 2.05191ZM5.45642 7.4605L5.01892 8.98394L6.54236 8.54644C6.64652 8.51779 6.73767 8.46311 6.81319 8.38759L10.3106 4.8928L9.11007 3.69228L5.61527 7.18967C5.53975 7.26519 5.48507 7.35634 5.45642 7.4605ZM5.36007 2.18446C5.70642 2.18446 5.98507 2.46441 5.98507 2.80946C5.98507 3.15582 5.70642 3.43446 5.36007 3.43446H2.4434C1.86814 3.43446 1.40173 3.90061 1.40173 4.47613V11.5595C1.40173 12.135 1.86814 12.6011 2.4434 12.6011H9.52673C10.1023 12.6011 10.5684 12.135 10.5684 11.5595V8.6428C10.5684 8.29644 10.847 8.0178 11.1934 8.0178C11.5398 8.0178 11.8184 8.29644 11.8184 8.6428V11.5595C11.8184 12.8251 10.7924 13.8511 9.52673 13.8511H2.4434C1.17778 13.8511 0.151733 12.8251 0.151733 11.5595V4.47613C0.151733 3.2105 1.17778 2.18446 2.4434 2.18446H5.36007Z"
                  })
                }), defaultId !== ws.id && /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownMenu/* default */.Z, {
                  options: [{
                    name: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "flex p-4 items-center justify-start text-md",
                      children: t("workspace_management.set_default_upload")
                    }),
                    className: "hover:bg-teal-800",
                    onClick: function onClick() {
                      handleSetDefault();
                    }
                  }],
                  menuItemClassName: "z-50 -top-4 right-5 !w-60",
                  Icon: function Icon() {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      onClick: function onClick() {
                        setSelectedWorkspace(ws);
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                        name: pro_regular_svg_icons/* faEllipsisVertical */.Uwo,
                        size: "sm",
                        className: "w-5 cursor-pointer"
                      })
                    });
                  }
                })]
              })]
            }, workspaceId);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          onClick: onClickNewWorkspace,
          className: "flex space-x-2 items-center border justify-center w-full rounded-lg p-3 mt-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
            name: pro_regular_svg_icons/* faPlus */.r8p,
            className: "w-6"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: t("workspace_management.new_workspace")
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "!max-h-1/2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex items-center my-5 mt-6 w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-2",
            children: t("workspace_management.shared")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-[1px] bg-gray-700 flex-1"
          })]
        }), (0,lodash.isEmpty)(sharedWorkspaces) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "my-8 text-normal text-gray-600 w-7/12 flex items-center gap-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "/assets/icons/workspaceLight.svg",
                alt: "workspace",
                width: "30",
                height: "30"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: t("workspace_management.no_access")
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "min-h-[220px] max-h-[220px] h-auto overflow-y-auto scrollbar-light dark:scrollbar mb-5",
          children: sharedWorkspaces && !(0,lodash.isEmpty)(sharedWorkspaces) && sharedWorkspaces.map(function (ws) {
            var workspaceId = (0,lodash.get)(ws, ["uuid"], "");
            workspaceId = (0,WorkspaceManagementModal_utils/* getTrimmedId */.V)(workspaceId);
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "p-4 rounded-md mt-5 text-md flex items-center justify-between border border-gray-300 dark:border-gray-600 text-[14px] text-gray-900 dark:text-white ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center flex-1",
                children: [!ws.data_hidden ? /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                  name: pro_regular_svg_icons/* faEye */.Mdf,
                  className: "w-5 mr-3"
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                  name: pro_regular_svg_icons/* faEyeSlash */.Aq,
                  className: "w-5 mr-3"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "mr-6 uppercase",
                  children: workspaceId
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [ws.name, " ", ws.count ? "(".concat(ws.count, " members)") : ""]
                })]
              }), ws.owner && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-sm text-gray-600 mr-4 text-right dark:text-gray-400",
                children: [t("owner_key"), ": ", ws.owner]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [defaultId === ws.id && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "text-gray-400 text-md italic mr-2",
                  children: t("workspace_management.default")
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownMenu/* default */.Z, {
                  options: sharedWorkspaceMenu(!ws.data_hidden, ws.id),
                  menuItemClassName: "-top-3 right-6 !h-auto !w-60",
                  Icon: function Icon() {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      onClick: function onClick() {
                        setSelectedWorkspace(ws);
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AwesomeIcon/* default */.Z, {
                        name: pro_regular_svg_icons/* faEllipsisVertical */.Uwo,
                        size: "sm",
                        className: "w-5 cursor-pointer"
                      })
                    });
                  }
                })]
              })]
            }, workspaceId);
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_ConfirmationModal, {
      onClose: function onClose() {
        Store/* default.update */.Z.update(function (s) {
          s.isConfirmationModalOpen = false;
        });
      },
      className: "lg:!w-1/3",
      onClickConfirm: onClickConfirmExit,
      labels: {
        title: t("workspace_management_exit_workspace"),
        label: t("workspace_management.exit_label"),
        yes: t("yes_key"),
        no: t("button.cancel")
      }
    })]
  });
};

/* harmony default export */ var WorkspaceManagementModal_WorkspaceList = (WorkspaceList);
;// CONCATENATED MODULE: ./components/WorkspaceManagementModal/index.js















function WorkspaceManagement() {
  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(null),
      editWorkspaceSelection = _useState[0],
      setEditWorkspaceSelection = _useState[1];

  var _useState2 = (0,react.useState)(false),
      newWorkspaceSelection = _useState2[0],
      setNewWorkspaceSelection = _useState2[1];

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isWorkspaceOpen,
      userInfo: s.userInfo
    };
  }),
      isVisible = _useStoreState.isVisible,
      userInfo = _useStoreState.userInfo;

  var _useAuthService = (0,useAuthService/* default */.Z)(false),
      refetchProfile = _useAuthService.refetch;

  var defaultId = (0,lodash.get)(userInfo, ["default_workspace"], "");

  var _useWorkspacesData = useWorkspaceData({
    isOpen: isVisible
  }),
      workspaceData = _useWorkspacesData.data,
      isErrorWorkspace = _useWorkspacesData.isError,
      isLoadingWorkspace = _useWorkspacesData.isLoading,
      refetchWorkspace = _useWorkspacesData.refetch;

  var _useSingleWorkspace = services_useSingleWorkspace({
    isOpen: isVisible,
    id: editWorkspaceSelection
  }),
      singleWorkspaceData = _useSingleWorkspace.data,
      isErrorSingleWorkspace = _useSingleWorkspace.isError,
      isLoadingSingleWorkspace = _useSingleWorkspace.isLoading,
      error = _useSingleWorkspace.error;

  var onCloseModal = function onCloseModal() {
    if (editWorkspaceSelection || newWorkspaceSelection) {
      setEditWorkspaceSelection("");
      setNewWorkspaceSelection(false);
    } else {
      Store/* default.update */.Z.update(function (s) {
        s.isWorkspaceOpen = false;
      });
    }
  };

  var onClickEditWorkspace = function onClickEditWorkspace(id) {
    setEditWorkspaceSelection(id);
  };

  var onClickNewWorkspace = function onClickNewWorkspace() {
    setEditWorkspaceSelection(null);
    setNewWorkspaceSelection(true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    title: t("setting_workspace"),
    onClose: onCloseModal,
    show: isVisible,
    isLoading: isLoadingSingleWorkspace || isLoadingWorkspace,
    className: classnames_default()("!flex !flex-col sm:w-9/12 lg:w-6/12 xl:w-5/12 !min-h-[60%] overflow-hidden", {
      "!max-h-fit": !editWorkspaceSelection && !newWorkspaceSelection
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "p-4 !h-full flex flex-col",
      children: [!editWorkspaceSelection && !newWorkspaceSelection && (isLoadingWorkspace ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "p-8 text-gray-300",
        children: t("workspace_management.retrieving")
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(WorkspaceManagementModal_WorkspaceList, {
        workspaceData: workspaceData,
        onClickEditWorkspace: onClickEditWorkspace,
        onClickNewWorkspace: onClickNewWorkspace,
        defaultId: defaultId,
        refetchWorkspace: refetchWorkspace,
        refetchProfile: refetchProfile
      })), (editWorkspaceSelection || newWorkspaceSelection) && (isLoadingSingleWorkspace ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "p-8 text-gray-300",
        children: t("workspace_management.loading")
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(WorkspaceManagementModal_EditWorkspace, {
        data: editWorkspaceSelection ? singleWorkspaceData : {},
        onCloseModal: onCloseModal,
        defaultId: defaultId,
        refetchProfile: refetchProfile,
        refetchWorkspace: refetchWorkspace
      }))]
    })
  });
}

/* harmony default export */ var WorkspaceManagementModal = (WorkspaceManagement);
;// CONCATENATED MODULE: ./components/common/Authenticator.tsx
var Authenticator_jsx = react.createElement;










var Authenticator = function Authenticator(props) {
  var children = props.children;

  var _useAuthService = (0,useAuthService/* default */.Z)(true),
      authData = _useAuthService.data,
      isError = _useAuthService.isError,
      isLoading = _useAuthService.isLoading,
      refetch = _useAuthService.refetch;

  var isLoggedIn = !isError && (0,lodash.get)(authData, ["authenticated"], false);
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      urlAuthToken = _useState[0],
      setUrlAuthToken = _useState[1];

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      appConfig: s.appConfig,
      userSettings: s.userSettings
    };
  }),
      appConfig = _useStoreState.appConfig,
      userSettings = _useStoreState.userSettings;

  var allowAppLoad = isLoggedIn && appConfig && userSettings;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)("loading_key", {
    useSuspense: false
  }),
      ready = _useTranslation.ready;

  (0,react.useEffect)(function () {
    if (router.isReady) setUrlAuthToken(router.query.url_auth_token);
  }, [router.isReady]);
  (0,react.useEffect)(function () {
    var _agreement, _agreement2;

    if (!isLoggedIn) {
      return;
    } // this query param is set inside termsandconditionsmodal


    if (router.pathname === "/") {
      var query = router.query;

      if (query.invalidate) {
        refetch();
      }
    }

    var currentVersion = constants/* default.TERMS_OF_USE_VERSION */.Z.TERMS_OF_USE_VERSION; // WARNING: stop gap solution. must be reverted in next release

    var stopGapCheck = currentVersion === "2.0.0" && ((_agreement = authData.agreement) === null || _agreement === void 0 ? void 0 : _agreement.version) === "2.0.4";
    var isCurrentVersion = ((_agreement2 = authData.agreement) === null || _agreement2 === void 0 ? void 0 : _agreement2.version) === currentVersion || stopGapCheck; // const isCurrentVersion = ((authData as any).agreement?.version === currentVersion)

    if ((!authData || isCurrentVersion) && router.pathname === "/terms-and-conditions") {
      router.push("/");
      return;
    }

    if (!isCurrentVersion && router.pathname !== "/terms-and-conditions" && router.pathname !== "/open-app") {
      router.push("/terms-and-conditions");
    }
  }, [authData, isLoggedIn, router]);
  (0,react.useEffect)(function () {
    if (isLoggedIn) {
      (0,utils/* getUserSettings */.nS)();
      (0,utils/* getAppConfig */.hq)();
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    var _window;

    localStorage.removeItem("redirectLogin");

    if ((_window = window) !== null && _window !== void 0 && _window.ReactNativeWebView) {
      var _window2;

      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.ReactNativeWebView) === null || _window2 === void 0 ? void 0 : _window2.postMessage(JSON.stringify({
        event: constants/* default.RN_COMM_CONST.FLUSH_COOKIES */.Z.RN_COMM_CONST.FLUSH_COOKIES
      }));
    } // desktop app integration


    if (window.electronAPI) {
      window.electronAPI.setAPISettings({
        apiURL: "https://platformapius-rsna.qure.ai",
        token: (0,lodash.get)(authData, ["token"], null)
      });
    }

    if (router.pathname === "/landing-page") {
      router.push("/");
      return null;
    }
  }

  if ((allowAppLoad || router.pathname === "/landing-page" || router.pathname === "/open-app" || router.pathname === "/notifications-widget" || urlAuthToken) && !isLoading && ready) {
    return children;
  }

  return /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center bold text-black dark:text-white bg-gray-100 dark:bg-slate-900 w-full h-full"
  }, "Loading...");
};

/* harmony default export */ var common_Authenticator = (Authenticator);
// EXTERNAL MODULE: ./components/ExportMessage/services/downloadService.js
var downloadService = __webpack_require__(35801);
;// CONCATENATED MODULE: ./components/ExportMessage/index.js






var ExportMessage = function ExportMessage() {
  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (store) {
    return {
      showExportUpdate: store.showExportUpdate,
      isExportReady: store.isExportReady,
      downloadProgress: store.downloadProgress,
      exportTimestamp: store.exportTimestamp,
      exportGenFailed: store.exportGenFailed
    };
  }),
      isExportReady = _useStoreState.isExportReady,
      exportTimestamp = _useStoreState.exportTimestamp,
      downloadProgress = _useStoreState.downloadProgress,
      exportGenFailed = _useStoreState.exportGenFailed,
      showExportUpdate = _useStoreState.showExportUpdate;

  var onClose = function onClose() {
    Store/* default.update */.Z.update(function (s) {
      s.showExportUpdate = false;
    });
  };

  if (!showExportUpdate) {
    return null;
  } else {
    setTimeout(function () {
      Store/* default.update */.Z.update(function (s) {
        s.showExportUpdate = false;
      });
    }, 10000);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "aria-hidden": "true",
    className: "absolute bottom-2 left-2 flex w-80 bg-white dark:bg-gray-800 text-black dark:text-white p-3 pl-4 rounded-md cursor-pointer z-50 border border-gray-400",
    children: [downloadProgress > 0 && downloadProgress < 100 && !isExportReady && /*#__PURE__*/(0,jsx_runtime.jsx)(ExportUpdate, {
      message: "Export data file is being downloaded to your system.",
      type: "update"
    }), exportGenFailed && /*#__PURE__*/(0,jsx_runtime.jsx)(ExportUpdate, {
      message: "Export file could not be prepared. Please export file again.",
      type: "error"
    }), isExportReady && /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadExport, {
      timestamp: exportTimestamp
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "py-2",
      onClick: onClose,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "13",
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M11.705 10.4688C12.0563 10.8193 12.0563 11.3879 11.705 11.7384C11.3536 12.0889 10.7835 12.0888 10.4321 11.7384L6.00061 7.28553L1.53765 11.7369C1.18628 12.0873 0.616179 12.0873 0.264768 11.7369C-0.0866433 11.3864 -0.0866058 10.8178 0.264768 10.4673L4.72923 6.01745L0.26353 1.53243C-0.0878435 1.18197 -0.0878435 0.613357 0.26353 0.262859C0.614904 -0.0876384 1.185 -0.087601 1.53641 0.262859L6.00061 4.74938L10.4636 0.298021C10.8149 -0.0524392 11.385 -0.0524392 11.7365 0.298021C12.0879 0.648481 12.0878 1.2171 11.7365 1.56759L7.27199 6.01745L11.705 10.4688Z",
          fill: "#D9DBDD"
        })
      })
    })]
  });
};

var ExportUpdate = function ExportUpdate(_ref) {
  var message = _ref.message,
      type = _ref.type;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "px-1 flex",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "py-1",
      children: type == 'update' ? /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "#00D0CD",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M17.0391 10.6875H15.0537L13.2725 12.375H17.0391C17.3664 12.375 17.6328 12.6274 17.6328 12.9375V15.75C17.6328 16.0601 17.3664 16.3125 17.0391 16.3125H2.78906C2.46168 16.3125 2.19531 16.0601 2.19531 15.75V12.9375C2.19531 12.6281 2.46176 12.375 2.78906 12.375H6.55566L4.77441 10.6875H2.78906C1.47725 10.6875 0.414062 11.6947 0.414062 12.9375V15.75C0.414062 16.9928 1.47725 18 2.78906 18H17.0391C18.3509 18 19.4141 16.9928 19.4141 15.75V12.9375C19.4141 11.6965 18.349 10.6875 17.0391 10.6875ZM16.4453 14.3438C16.4453 13.8776 16.0464 13.5 15.5547 13.5C15.063 13.5 14.6641 13.8762 14.6641 14.3438C14.6641 14.8096 15.063 15.1875 15.5547 15.1875C16.0464 15.1875 16.4453 14.8113 16.4453 14.3438ZM9.2832 12.941C9.45762 13.1379 9.68398 13.2188 9.91406 13.2188C10.1441 13.2188 10.3698 13.1363 10.5438 12.9716L15.5907 8.19032C15.9386 7.86073 15.9386 7.32688 15.5907 6.99711C15.2428 6.66735 14.6793 6.66752 14.3312 6.99711L10.8047 10.3395V0.84375C10.8047 0.37793 10.4076 0 9.91406 0C9.42051 0 9.02344 0.37793 9.02344 0.84375V10.3395L5.46465 6.99609C5.11675 6.6665 4.55324 6.6665 4.20516 6.99609C3.85707 7.32568 3.85726 7.85953 4.20516 8.1893L9.2832 12.941Z"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M12.0004 14.4654C11.3105 14.4654 10.7504 15.0256 10.7504 15.7154C10.7504 16.4053 11.3105 16.9654 12.0004 16.9654C12.6902 16.9654 13.2504 16.4053 13.2504 15.7154C13.2504 15.0256 12.6918 14.4654 12.0004 14.4654ZM11.0629 7.90293V12.2779C11.0629 12.7955 11.4828 13.2154 12.0004 13.2154C12.518 13.2154 12.9379 12.7955 12.9379 12.2779V7.90293C12.9379 7.38535 12.518 6.96543 12.0004 6.96543C11.4828 6.96543 11.0629 7.41855 11.0629 7.90293ZM21.4418 10.6959L13.309 2.52793C12.5664 1.82402 11.3539 1.82402 10.6504 2.52793L2.55781 10.6959C1.81406 11.3982 1.81406 12.6111 2.55781 13.3135L10.6906 21.4424C11.3945 22.1861 12.6066 22.1861 13.3105 21.4424L21.4434 13.3135C22.1879 12.61 22.1879 11.399 21.4418 10.6959ZM12.0004 20.1021L3.90039 12.0045L11.9551 3.87559H11.9664C11.9826 3.87559 11.9976 3.87932 12.0077 3.88306C12.0126 3.88436 12.0151 3.88558 12.0177 3.8868L20.0997 12.004L12.0004 20.1021Z",
          fill: "#E8414E"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "px-2",
      children: message
    })]
  });
};

var DownloadExport = function DownloadExport(_ref2) {
  var timestamp = _ref2.timestamp;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-80",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "py-2 flex",
      onClick: downloadService/* downloadFile */.S,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "px-3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "20",
          height: "18",
          viewBox: "0 0 20 18",
          fill: "#00D0CD",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M17.0391 10.6875H15.0537L13.2725 12.375H17.0391C17.3664 12.375 17.6328 12.6274 17.6328 12.9375V15.75C17.6328 16.0601 17.3664 16.3125 17.0391 16.3125H2.78906C2.46168 16.3125 2.19531 16.0601 2.19531 15.75V12.9375C2.19531 12.6281 2.46176 12.375 2.78906 12.375H6.55566L4.77441 10.6875H2.78906C1.47725 10.6875 0.414062 11.6947 0.414062 12.9375V15.75C0.414062 16.9928 1.47725 18 2.78906 18H17.0391C18.3509 18 19.4141 16.9928 19.4141 15.75V12.9375C19.4141 11.6965 18.349 10.6875 17.0391 10.6875ZM16.4453 14.3438C16.4453 13.8776 16.0464 13.5 15.5547 13.5C15.063 13.5 14.6641 13.8762 14.6641 14.3438C14.6641 14.8096 15.063 15.1875 15.5547 15.1875C16.0464 15.1875 16.4453 14.8113 16.4453 14.3438ZM9.2832 12.941C9.45762 13.1379 9.68398 13.2188 9.91406 13.2188C10.1441 13.2188 10.3698 13.1363 10.5438 12.9716L15.5907 8.19032C15.9386 7.86073 15.9386 7.32688 15.5907 6.99711C15.2428 6.66735 14.6793 6.66752 14.3312 6.99711L10.8047 10.3395V0.84375C10.8047 0.37793 10.4076 0 9.91406 0C9.42051 0 9.02344 0.37793 9.02344 0.84375V10.3395L5.46465 6.99609C5.11675 6.6665 4.55324 6.6665 4.20516 6.99609C3.85707 7.32568 3.85726 7.85953 4.20516 8.1893L9.2832 12.941Z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-teal-300",
          children: "Download export data file"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "flex text-sm text-gray-600 dark:text-gray-400 font-normal",
          children: ["Generated on ", timestamp]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "pt-4 flex",
      onClick: startDownload,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "px-3 py-1",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "#00D0CD",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M19.0625 9.06255C18.5449 9.06255 18.125 9.48247 18.125 10C18.125 12.2399 16.3023 14.0625 14.0625 14.0625H5.69922L8.16133 11.6004C8.52754 11.2342 8.52754 10.6411 8.16133 10.2747C7.79512 9.90825 7.20195 9.90844 6.83555 10.2747L2.77305 14.3371C2.40684 14.7033 2.40684 15.2965 2.77305 15.6629L6.83555 19.7254C7.01953 19.9102 7.25781 20 7.5 20C7.74219 20 7.97969 19.9084 8.16289 19.7254C8.5291 19.3591 8.5291 18.766 8.16289 18.3996L5.69922 15.9375H14.0625C17.3363 15.9375 20 13.2739 20 10C20 9.48052 19.582 9.06255 19.0625 9.06255ZM5.9375 5.93756H14.3008L11.8387 8.39966C11.4725 8.76587 11.4725 9.35903 11.8387 9.72544C12.0195 9.9102 12.2578 10 12.5 10C12.7422 10 12.9797 9.90848 13.1629 9.7254L17.2254 5.66291C17.5916 5.2967 17.5916 4.70354 17.2254 4.33714L13.1629 0.274657C12.7967 -0.0915523 12.2035 -0.0915523 11.8371 0.274657C11.4707 0.640866 11.4709 1.23403 11.8371 1.60043L14.3008 4.06257H5.9375C2.66367 4.06257 0 6.72662 0 9.96489C0 10.5157 0.419922 10.9375 0.9375 10.9375C1.45508 10.9375 1.875 10.5196 1.875 10C1.875 7.76177 3.69766 5.93756 5.9375 5.93756Z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "Export new file"
      })]
    })]
  });
};

var startDownload = function startDownload() {
  var url = "patients_export/start_generation/";
  (0,downloadService/* patientsExportService */.G)(url).then(function (response) {
    if (response !== null && response !== void 0 && response.success) {
      Store/* default.update */.Z.update(function (s) {
        s.isExportReady = false;
        s.downloadProgress = 1;
      });
    }
  })["catch"](function (resp) {
    Store/* default.update */.Z.update(function (s) {
      s.showExportUpdate = true;
      s.exportGenFailed = true;
    });
  });
};

/* harmony default export */ var components_ExportMessage = (ExportMessage);
// EXTERNAL MODULE: ./components/FormComponents/RadioList.jsx
var RadioList = __webpack_require__(56222);
// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js + 2 modules
var index_esm2017 = __webpack_require__(25816);
// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(74444);
// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(8463);
// EXTERNAL MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
var dist_esm_index_esm2017 = __webpack_require__(53333);
// EXTERNAL MODULE: ./node_modules/@firebase/installations/dist/esm/index.esm2017.js + 2 modules
var installations_dist_esm_index_esm2017 = __webpack_require__(66292);
;// CONCATENATED MODULE: ./node_modules/@firebase/remote-config/dist/esm/index.esm2017.js






const index_esm2017_name = "@firebase/remote-config";
const version = "0.4.4";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Shims a minimal AbortSignal.
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */
class RemoteConfigAbortSignal {
    constructor() {
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach(listener => listener());
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const RC_COMPONENT_NAME = 'remote-config';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
    ["registration-window" /* ErrorCode.REGISTRATION_WINDOW */]: 'Undefined window object. This SDK only supports usage in a browser environment.',
    ["registration-project-id" /* ErrorCode.REGISTRATION_PROJECT_ID */]: 'Undefined project identifier. Check Firebase app initialization.',
    ["registration-api-key" /* ErrorCode.REGISTRATION_API_KEY */]: 'Undefined API key. Check Firebase app initialization.',
    ["registration-app-id" /* ErrorCode.REGISTRATION_APP_ID */]: 'Undefined app identifier. Check Firebase app initialization.',
    ["storage-open" /* ErrorCode.STORAGE_OPEN */]: 'Error thrown when opening storage. Original error: {$originalErrorMessage}.',
    ["storage-get" /* ErrorCode.STORAGE_GET */]: 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.',
    ["storage-set" /* ErrorCode.STORAGE_SET */]: 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.',
    ["storage-delete" /* ErrorCode.STORAGE_DELETE */]: 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.',
    ["fetch-client-network" /* ErrorCode.FETCH_NETWORK */]: 'Fetch client failed to connect to a network. Check Internet connection.' +
        ' Original error: {$originalErrorMessage}.',
    ["fetch-timeout" /* ErrorCode.FETCH_TIMEOUT */]: 'The config fetch request timed out. ' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.',
    ["fetch-throttle" /* ErrorCode.FETCH_THROTTLE */]: 'The config fetch request timed out while in an exponential backoff state.' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.' +
        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
    ["fetch-client-parse" /* ErrorCode.FETCH_PARSE */]: 'Fetch client could not parse response.' +
        ' Original error: {$originalErrorMessage}.',
    ["fetch-status" /* ErrorCode.FETCH_STATUS */]: 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.',
    ["indexed-db-unavailable" /* ErrorCode.INDEXED_DB_UNAVAILABLE */]: 'Indexed DB is not supported by current browser'
};
const ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL('remoteconfig' /* service */, 'Remote Config' /* service name */, ERROR_DESCRIPTION_MAP);
// Note how this is like typeof/instanceof, but for ErrorCode.
function hasErrorCode(e, errorCode) {
    return e instanceof dist_index_esm2017/* FirebaseError */.ZR && e.code.indexOf(errorCode) !== -1;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_VALUE_FOR_BOOLEAN = false;
const DEFAULT_VALUE_FOR_STRING = '';
const DEFAULT_VALUE_FOR_NUMBER = 0;
const BOOLEAN_TRUTHY_VALUES = ['1', 'true', 't', 'yes', 'y', 'on'];
class Value {
    constructor(_source, _value = DEFAULT_VALUE_FOR_STRING) {
        this._source = _source;
        this._value = _value;
    }
    asString() {
        return this._value;
    }
    asBoolean() {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_BOOLEAN;
        }
        return BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
    }
    asNumber() {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_NUMBER;
        }
        let num = Number(this._value);
        if (isNaN(num)) {
            num = DEFAULT_VALUE_FOR_NUMBER;
        }
        return num;
    }
    getSource() {
        return this._source;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 * @returns A {@link RemoteConfig} instance.
 *
 * @public
 */
function getRemoteConfig(app = (0,index_esm2017/* getApp */.Mq)()) {
    app = (0,dist_index_esm2017/* getModularInstance */.m9)(app);
    const rcProvider = (0,index_esm2017/* _getProvider */.qX)(app, RC_COMPONENT_NAME);
    return rcProvider.getImmediate();
}
/**
 * Makes the last fetched config available to the getters.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @returns A `Promise` which resolves to true if the current call activated the fetched configs.
 * If the fetched configs were already activated, the `Promise` will resolve to false.
 *
 * @public
 */
async function activate(remoteConfig) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    const [lastSuccessfulFetchResponse, activeConfigEtag] = await Promise.all([
        rc._storage.getLastSuccessfulFetchResponse(),
        rc._storage.getActiveConfigEtag()
    ]);
    if (!lastSuccessfulFetchResponse ||
        !lastSuccessfulFetchResponse.config ||
        !lastSuccessfulFetchResponse.eTag ||
        lastSuccessfulFetchResponse.eTag === activeConfigEtag) {
        // Either there is no successful fetched config, or is the same as current active
        // config.
        return false;
    }
    await Promise.all([
        rc._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
        rc._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
    ]);
    return true;
}
/**
 * Ensures the last activated config are available to the getters.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 *
 * @returns A `Promise` that resolves when the last activated config is available to the getters.
 * @public
 */
function ensureInitialized(remoteConfig) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    if (!rc._initializePromise) {
        rc._initializePromise = rc._storageCache.loadFromStorage().then(() => {
            rc._isInitializationComplete = true;
        });
    }
    return rc._initializePromise;
}
/**
 * Fetches and caches configuration from the Remote Config service.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @public
 */
async function fetchConfig(remoteConfig) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    // Aborts the request after the given timeout, causing the fetch call to
    // reject with an `AbortError`.
    //
    // <p>Aborting after the request completes is a no-op, so we don't need a
    // corresponding `clearTimeout`.
    //
    // Locating abort logic here because:
    // * it uses a developer setting (timeout)
    // * it applies to all retries (like curl's max-time arg)
    // * it is consistent with the Fetch API's signal input
    const abortSignal = new RemoteConfigAbortSignal();
    setTimeout(async () => {
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        abortSignal.abort();
    }, rc.settings.fetchTimeoutMillis);
    // Catches *all* errors thrown by client so status can be set consistently.
    try {
        await rc._client.fetch({
            cacheMaxAgeMillis: rc.settings.minimumFetchIntervalMillis,
            signal: abortSignal
        });
        await rc._storageCache.setLastFetchStatus('success');
    }
    catch (e) {
        const lastFetchStatus = hasErrorCode(e, "fetch-throttle" /* ErrorCode.FETCH_THROTTLE */)
            ? 'throttle'
            : 'failure';
        await rc._storageCache.setLastFetchStatus(lastFetchStatus);
        throw e;
    }
}
/**
 * Gets all config.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @returns All config.
 *
 * @public
 */
function getAll(remoteConfig) {
    const rc = getModularInstance(remoteConfig);
    return getAllKeys(rc._storageCache.getActiveConfig(), rc.defaultConfig).reduce((allConfigs, key) => {
        allConfigs[key] = getValue(remoteConfig, key);
        return allConfigs;
    }, {});
}
/**
 * Gets the value for the given key as a boolean.
 *
 * Convenience method for calling <code>remoteConfig.getValue(key).asBoolean()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a boolean.
 * @public
 */
function getBoolean(remoteConfig, key) {
    return getValue(getModularInstance(remoteConfig), key).asBoolean();
}
/**
 * Gets the value for the given key as a number.
 *
 * Convenience method for calling <code>remoteConfig.getValue(key).asNumber()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a number.
 *
 * @public
 */
function getNumber(remoteConfig, key) {
    return getValue(getModularInstance(remoteConfig), key).asNumber();
}
/**
 * Gets the value for the given key as a string.
 * Convenience method for calling <code>remoteConfig.getValue(key).asString()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a string.
 *
 * @public
 */
function getString(remoteConfig, key) {
    return getValue(getModularInstance(remoteConfig), key).asString();
}
/**
 * Gets the {@link Value} for the given key.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key.
 *
 * @public
 */
function getValue(remoteConfig, key) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    if (!rc._isInitializationComplete) {
        rc._logger.debug(`A value was requested for key "${key}" before SDK initialization completed.` +
            ' Await on ensureInitialized if the intent was to get a previously activated value.');
    }
    const activeConfig = rc._storageCache.getActiveConfig();
    if (activeConfig && activeConfig[key] !== undefined) {
        return new Value('remote', activeConfig[key]);
    }
    else if (rc.defaultConfig && rc.defaultConfig[key] !== undefined) {
        return new Value('default', String(rc.defaultConfig[key]));
    }
    rc._logger.debug(`Returning static value for key "${key}".` +
        ' Define a default or remote value if this is unintentional.');
    return new Value('static');
}
/**
 * Defines the log level to use.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param logLevel - The log level to set.
 *
 * @public
 */
function setLogLevel(remoteConfig, logLevel) {
    const rc = getModularInstance(remoteConfig);
    switch (logLevel) {
        case 'debug':
            rc._logger.logLevel = LogLevel.DEBUG;
            break;
        case 'silent':
            rc._logger.logLevel = LogLevel.SILENT;
            break;
        default:
            rc._logger.logLevel = LogLevel.ERROR;
    }
}
/**
 * Dedupes and returns an array of all the keys of the received objects.
 */
function getAllKeys(obj1 = {}, obj2 = {}) {
    return Object.keys(Object.assign(Object.assign({}, obj1), obj2));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the {@link RemoteConfigClient} abstraction with success response caching.
 *
 * <p>Comparable to the browser's Cache API for responses, but the Cache API requires a Service
 * Worker, which requires HTTPS, which would significantly complicate SDK installation. Also, the
 * Cache API doesn't support matching entries by time.
 */
class CachingClient {
    constructor(client, storage, storageCache, logger) {
        this.client = client;
        this.storage = storage;
        this.storageCache = storageCache;
        this.logger = logger;
    }
    /**
     * Returns true if the age of the cached fetched configs is less than or equal to
     * {@link Settings#minimumFetchIntervalInSeconds}.
     *
     * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
     * native Fetch API.
     *
     * <p>Visible for testing.
     */
    isCachedDataFresh(cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
        // Cache can only be fresh if it's populated.
        if (!lastSuccessfulFetchTimestampMillis) {
            this.logger.debug('Config fetch cache check. Cache unpopulated.');
            return false;
        }
        // Calculates age of cache entry.
        const cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
        const isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
        this.logger.debug('Config fetch cache check.' +
            ` Cache age millis: ${cacheAgeMillis}.` +
            ` Cache max age millis (minimumFetchIntervalMillis setting): ${cacheMaxAgeMillis}.` +
            ` Is cache hit: ${isCachedDataFresh}.`);
        return isCachedDataFresh;
    }
    async fetch(request) {
        // Reads from persisted storage to avoid cache miss if callers don't wait on initialization.
        const [lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse] = await Promise.all([
            this.storage.getLastSuccessfulFetchTimestampMillis(),
            this.storage.getLastSuccessfulFetchResponse()
        ]);
        // Exits early on cache hit.
        if (lastSuccessfulFetchResponse &&
            this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) {
            return lastSuccessfulFetchResponse;
        }
        // Deviates from pure decorator by not honoring a passed ETag since we don't have a public API
        // that allows the caller to pass an ETag.
        request.eTag =
            lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
        // Falls back to service on cache miss.
        const response = await this.client.fetch(request);
        // Fetch throws for non-success responses, so success is guaranteed here.
        const storageOperations = [
            // Uses write-through cache for consistency with synchronous public API.
            this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
        ];
        if (response.status === 200) {
            // Caches response only if it has changed, ie non-304 responses.
            storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
        }
        await Promise.all(storageOperations);
        return response;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Attempts to get the most accurate browser language setting.
 *
 * <p>Adapted from getUserLanguage in packages/auth/src/utils.js for TypeScript.
 *
 * <p>Defers default language specification to server logic for consistency.
 *
 * @param navigatorLanguage Enables tests to override read-only {@link NavigatorLanguage}.
 */
function getUserLanguage(navigatorLanguage = navigator) {
    return (
    // Most reliable, but only supported in Chrome/Firefox.
    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
        // Supported in most browsers, but returns the language of the browser
        // UI, not the language set in browser settings.
        navigatorLanguage.language
    // Polyfill otherwise.
    );
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the Client abstraction for the Remote Config REST API.
 */
class RestClient {
    constructor(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
        this.firebaseInstallations = firebaseInstallations;
        this.sdkVersion = sdkVersion;
        this.namespace = namespace;
        this.projectId = projectId;
        this.apiKey = apiKey;
        this.appId = appId;
    }
    /**
     * Fetches from the Remote Config REST API.
     *
     * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
     * connect to the network.
     * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
     * fetch response.
     * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
     */
    async fetch(request) {
        const [installationId, installationToken] = await Promise.all([
            this.firebaseInstallations.getId(),
            this.firebaseInstallations.getToken()
        ]);
        const urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE ||
            'https://firebaseremoteconfig.googleapis.com';
        const url = `${urlBase}/v1/projects/${this.projectId}/namespaces/${this.namespace}:fetch?key=${this.apiKey}`;
        const headers = {
            'Content-Type': 'application/json',
            'Content-Encoding': 'gzip',
            // Deviates from pure decorator by not passing max-age header since we don't currently have
            // service behavior using that header.
            'If-None-Match': request.eTag || '*'
        };
        const requestBody = {
            /* eslint-disable camelcase */
            sdk_version: this.sdkVersion,
            app_instance_id: installationId,
            app_instance_id_token: installationToken,
            app_id: this.appId,
            language_code: getUserLanguage()
            /* eslint-enable camelcase */
        };
        const options = {
            method: 'POST',
            headers,
            body: JSON.stringify(requestBody)
        };
        // This logic isn't REST-specific, but shimming abort logic isn't worth another decorator.
        const fetchPromise = fetch(url, options);
        const timeoutPromise = new Promise((_resolve, reject) => {
            // Maps async event listener to Promise API.
            request.signal.addEventListener(() => {
                // Emulates https://heycam.github.io/webidl/#aborterror
                const error = new Error('The operation was aborted.');
                error.name = 'AbortError';
                reject(error);
            });
        });
        let response;
        try {
            await Promise.race([fetchPromise, timeoutPromise]);
            response = await fetchPromise;
        }
        catch (originalError) {
            let errorCode = "fetch-client-network" /* ErrorCode.FETCH_NETWORK */;
            if ((originalError === null || originalError === void 0 ? void 0 : originalError.name) === 'AbortError') {
                errorCode = "fetch-timeout" /* ErrorCode.FETCH_TIMEOUT */;
            }
            throw ERROR_FACTORY.create(errorCode, {
                originalErrorMessage: originalError === null || originalError === void 0 ? void 0 : originalError.message
            });
        }
        let status = response.status;
        // Normalizes nullable header to optional.
        const responseEtag = response.headers.get('ETag') || undefined;
        let config;
        let state;
        // JSON parsing throws SyntaxError if the response body isn't a JSON string.
        // Requesting application/json and checking for a 200 ensures there's JSON data.
        if (response.status === 200) {
            let responseBody;
            try {
                responseBody = await response.json();
            }
            catch (originalError) {
                throw ERROR_FACTORY.create("fetch-client-parse" /* ErrorCode.FETCH_PARSE */, {
                    originalErrorMessage: originalError === null || originalError === void 0 ? void 0 : originalError.message
                });
            }
            config = responseBody['entries'];
            state = responseBody['state'];
        }
        // Normalizes based on legacy state.
        if (state === 'INSTANCE_STATE_UNSPECIFIED') {
            status = 500;
        }
        else if (state === 'NO_CHANGE') {
            status = 304;
        }
        else if (state === 'NO_TEMPLATE' || state === 'EMPTY_CONFIG') {
            // These cases can be fixed remotely, so normalize to safe value.
            config = {};
        }
        // Normalize to exception-based control flow for non-success cases.
        // Encapsulates HTTP specifics in this class as much as possible. Status is still the best for
        // differentiating success states (200 from 304; the state body param is undefined in a
        // standard 304).
        if (status !== 304 && status !== 200) {
            throw ERROR_FACTORY.create("fetch-status" /* ErrorCode.FETCH_STATUS */, {
                httpStatus: status
            });
        }
        return { status, eTag: responseEtag, config };
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */
function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject) => {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(() => {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(ERROR_FACTORY.create("fetch-throttle" /* ErrorCode.FETCH_THROTTLE */, {
                throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */
function isRetriableError(e) {
    if (!(e instanceof dist_index_esm2017/* FirebaseError */.ZR) || !e.customData) {
        return false;
    }
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return (httpStatus === 429 ||
        httpStatus === 500 ||
        httpStatus === 503 ||
        httpStatus === 504);
}
/**
 * Decorates a Client with retry logic.
 *
 * <p>Comparable to CachingClient, but uses backoff logic instead of cache max age and doesn't cache
 * responses (because the SDK has no use for error responses).
 */
class RetryingClient {
    constructor(client, storage) {
        this.client = client;
        this.storage = storage;
    }
    async fetch(request) {
        const throttleMetadata = (await this.storage.getThrottleMetadata()) || {
            backoffCount: 0,
            throttleEndTimeMillis: Date.now()
        };
        return this.attemptFetch(request, throttleMetadata);
    }
    /**
     * A recursive helper for attempting a fetch request repeatedly.
     *
     * @throws any non-retriable errors.
     */
    async attemptFetch(request, { throttleEndTimeMillis, backoffCount }) {
        // Starts with a (potentially zero) timeout to support resumption from stored state.
        // Ensures the throttle end time is honored if the last attempt timed out.
        // Note the SDK will never make a request if the fetch timeout expires at this point.
        await setAbortableTimeout(request.signal, throttleEndTimeMillis);
        try {
            const response = await this.client.fetch(request);
            // Note the SDK only clears throttle state if response is success or non-retriable.
            await this.storage.deleteThrottleMetadata();
            return response;
        }
        catch (e) {
            if (!isRetriableError(e)) {
                throw e;
            }
            // Increments backoff state.
            const throttleMetadata = {
                throttleEndTimeMillis: Date.now() + (0,dist_index_esm2017/* calculateBackoffMillis */.$s)(backoffCount),
                backoffCount: backoffCount + 1
            };
            // Persists state.
            await this.storage.setThrottleMetadata(throttleMetadata);
            return this.attemptFetch(request, throttleMetadata);
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_FETCH_TIMEOUT_MILLIS = 60 * 1000; // One minute
const DEFAULT_CACHE_MAX_AGE_MILLIS = 12 * 60 * 60 * 1000; // Twelve hours.
/**
 * Encapsulates business logic mapping network and storage dependencies to the public SDK API.
 *
 * See {@link https://github.com/FirebasePrivate/firebase-js-sdk/blob/master/packages/firebase/index.d.ts|interface documentation} for method descriptions.
 */
class RemoteConfig {
    constructor(
    // Required by FirebaseServiceFactory interface.
    app, 
    // JS doesn't support private yet
    // (https://github.com/tc39/proposal-class-fields#private-fields), so we hint using an
    // underscore prefix.
    /**
     * @internal
     */
    _client, 
    /**
     * @internal
     */
    _storageCache, 
    /**
     * @internal
     */
    _storage, 
    /**
     * @internal
     */
    _logger) {
        this.app = app;
        this._client = _client;
        this._storageCache = _storageCache;
        this._storage = _storage;
        this._logger = _logger;
        /**
         * Tracks completion of initialization promise.
         * @internal
         */
        this._isInitializationComplete = false;
        this.settings = {
            fetchTimeoutMillis: DEFAULT_FETCH_TIMEOUT_MILLIS,
            minimumFetchIntervalMillis: DEFAULT_CACHE_MAX_AGE_MILLIS
        };
        this.defaultConfig = {};
    }
    get fetchTimeMillis() {
        return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
    }
    get lastFetchStatus() {
        return this._storageCache.getLastFetchStatus() || 'no-fetch-yet';
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Converts an error event associated with a {@link IDBRequest} to a {@link FirebaseError}.
 */
function toFirebaseError(event, errorCode) {
    const originalError = event.target.error || undefined;
    return ERROR_FACTORY.create(errorCode, {
        originalErrorMessage: originalError && (originalError === null || originalError === void 0 ? void 0 : originalError.message)
    });
}
/**
 * A general-purpose store keyed by app + namespace + {@link
 * ProjectNamespaceKeyFieldValue}.
 *
 * <p>The Remote Config SDK can be used with multiple app installations, and each app can interact
 * with multiple namespaces, so this store uses app (ID + name) and namespace as common parent keys
 * for a set of key-value pairs. See {@link Storage#createCompositeKey}.
 *
 * <p>Visible for testing.
 */
const APP_NAMESPACE_STORE = 'app_namespace_store';
const DB_NAME = 'firebase_remote_config';
const DB_VERSION = 1;
// Visible for testing.
function openDatabase() {
    return new Promise((resolve, reject) => {
        try {
            const request = indexedDB.open(DB_NAME, DB_VERSION);
            request.onerror = event => {
                reject(toFirebaseError(event, "storage-open" /* ErrorCode.STORAGE_OPEN */));
            };
            request.onsuccess = event => {
                resolve(event.target.result);
            };
            request.onupgradeneeded = event => {
                const db = event.target.result;
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (event.oldVersion) {
                    case 0:
                        db.createObjectStore(APP_NAMESPACE_STORE, {
                            keyPath: 'compositeKey'
                        });
                }
            };
        }
        catch (error) {
            reject(ERROR_FACTORY.create("storage-open" /* ErrorCode.STORAGE_OPEN */, {
                originalErrorMessage: error === null || error === void 0 ? void 0 : error.message
            }));
        }
    });
}
/**
 * Abstracts data persistence.
 */
class Storage {
    /**
     * @param appId enables storage segmentation by app (ID + name).
     * @param appName enables storage segmentation by app (ID + name).
     * @param namespace enables storage segmentation by namespace.
     */
    constructor(appId, appName, namespace, openDbPromise = openDatabase()) {
        this.appId = appId;
        this.appName = appName;
        this.namespace = namespace;
        this.openDbPromise = openDbPromise;
    }
    getLastFetchStatus() {
        return this.get('last_fetch_status');
    }
    setLastFetchStatus(status) {
        return this.set('last_fetch_status', status);
    }
    // This is comparable to a cache entry timestamp. If we need to expire other data, we could
    // consider adding timestamp to all storage records and an optional max age arg to getters.
    getLastSuccessfulFetchTimestampMillis() {
        return this.get('last_successful_fetch_timestamp_millis');
    }
    setLastSuccessfulFetchTimestampMillis(timestamp) {
        return this.set('last_successful_fetch_timestamp_millis', timestamp);
    }
    getLastSuccessfulFetchResponse() {
        return this.get('last_successful_fetch_response');
    }
    setLastSuccessfulFetchResponse(response) {
        return this.set('last_successful_fetch_response', response);
    }
    getActiveConfig() {
        return this.get('active_config');
    }
    setActiveConfig(config) {
        return this.set('active_config', config);
    }
    getActiveConfigEtag() {
        return this.get('active_config_etag');
    }
    setActiveConfigEtag(etag) {
        return this.set('active_config_etag', etag);
    }
    getThrottleMetadata() {
        return this.get('throttle_metadata');
    }
    setThrottleMetadata(metadata) {
        return this.set('throttle_metadata', metadata);
    }
    deleteThrottleMetadata() {
        return this.delete('throttle_metadata');
    }
    async get(key) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readonly');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.get(compositeKey);
                request.onerror = event => {
                    reject(toFirebaseError(event, "storage-get" /* ErrorCode.STORAGE_GET */));
                };
                request.onsuccess = event => {
                    const result = event.target.result;
                    if (result) {
                        resolve(result.value);
                    }
                    else {
                        resolve(undefined);
                    }
                };
            }
            catch (e) {
                reject(ERROR_FACTORY.create("storage-get" /* ErrorCode.STORAGE_GET */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    async set(key, value) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.put({
                    compositeKey,
                    value
                });
                request.onerror = (event) => {
                    reject(toFirebaseError(event, "storage-set" /* ErrorCode.STORAGE_SET */));
                };
                request.onsuccess = () => {
                    resolve();
                };
            }
            catch (e) {
                reject(ERROR_FACTORY.create("storage-set" /* ErrorCode.STORAGE_SET */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    async delete(key) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.delete(compositeKey);
                request.onerror = (event) => {
                    reject(toFirebaseError(event, "storage-delete" /* ErrorCode.STORAGE_DELETE */));
                };
                request.onsuccess = () => {
                    resolve();
                };
            }
            catch (e) {
                reject(ERROR_FACTORY.create("storage-delete" /* ErrorCode.STORAGE_DELETE */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    // Facilitates composite key functionality (which is unsupported in IE).
    createCompositeKey(key) {
        return [this.appId, this.appName, this.namespace, key].join();
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A memory cache layer over storage to support the SDK's synchronous read requirements.
 */
class StorageCache {
    constructor(storage) {
        this.storage = storage;
    }
    /**
     * Memory-only getters
     */
    getLastFetchStatus() {
        return this.lastFetchStatus;
    }
    getLastSuccessfulFetchTimestampMillis() {
        return this.lastSuccessfulFetchTimestampMillis;
    }
    getActiveConfig() {
        return this.activeConfig;
    }
    /**
     * Read-ahead getter
     */
    async loadFromStorage() {
        const lastFetchStatusPromise = this.storage.getLastFetchStatus();
        const lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
        const activeConfigPromise = this.storage.getActiveConfig();
        // Note:
        // 1. we consistently check for undefined to avoid clobbering defined values
        //   in memory
        // 2. we defer awaiting to improve readability, as opposed to destructuring
        //   a Promise.all result, for example
        const lastFetchStatus = await lastFetchStatusPromise;
        if (lastFetchStatus) {
            this.lastFetchStatus = lastFetchStatus;
        }
        const lastSuccessfulFetchTimestampMillis = await lastSuccessfulFetchTimestampMillisPromise;
        if (lastSuccessfulFetchTimestampMillis) {
            this.lastSuccessfulFetchTimestampMillis =
                lastSuccessfulFetchTimestampMillis;
        }
        const activeConfig = await activeConfigPromise;
        if (activeConfig) {
            this.activeConfig = activeConfig;
        }
    }
    /**
     * Write-through setters
     */
    setLastFetchStatus(status) {
        this.lastFetchStatus = status;
        return this.storage.setLastFetchStatus(status);
    }
    setLastSuccessfulFetchTimestampMillis(timestampMillis) {
        this.lastSuccessfulFetchTimestampMillis = timestampMillis;
        return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
    }
    setActiveConfig(activeConfig) {
        this.activeConfig = activeConfig;
        return this.storage.setActiveConfig(activeConfig);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerRemoteConfig() {
    (0,index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA(RC_COMPONENT_NAME, remoteConfigFactory, "PUBLIC" /* ComponentType.PUBLIC */).setMultipleInstances(true));
    (0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version, 'esm2017');
    function remoteConfigFactory(container, { instanceIdentifier: namespace }) {
        /* Dependencies */
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        // The following call will always succeed because rc has `import '@firebase/installations'`
        const installations = container
            .getProvider('installations-internal')
            .getImmediate();
        // Guards against the SDK being used in non-browser environments.
        if (typeof window === 'undefined') {
            throw ERROR_FACTORY.create("registration-window" /* ErrorCode.REGISTRATION_WINDOW */);
        }
        // Guards against the SDK being used when indexedDB is not available.
        if (!(0,dist_index_esm2017/* isIndexedDBAvailable */.hl)()) {
            throw ERROR_FACTORY.create("indexed-db-unavailable" /* ErrorCode.INDEXED_DB_UNAVAILABLE */);
        }
        // Normalizes optional inputs.
        const { projectId, apiKey, appId } = app.options;
        if (!projectId) {
            throw ERROR_FACTORY.create("registration-project-id" /* ErrorCode.REGISTRATION_PROJECT_ID */);
        }
        if (!apiKey) {
            throw ERROR_FACTORY.create("registration-api-key" /* ErrorCode.REGISTRATION_API_KEY */);
        }
        if (!appId) {
            throw ERROR_FACTORY.create("registration-app-id" /* ErrorCode.REGISTRATION_APP_ID */);
        }
        namespace = namespace || 'firebase';
        const storage = new Storage(appId, app.name, namespace);
        const storageCache = new StorageCache(storage);
        const logger = new dist_esm_index_esm2017/* Logger */.Yd(index_esm2017_name);
        // Sets ERROR as the default log level.
        // See RemoteConfig#setLogLevel for corresponding normalization to ERROR log level.
        logger.logLevel = dist_esm_index_esm2017/* LogLevel.ERROR */["in"].ERROR;
        const restClient = new RestClient(installations, 
        // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
        index_esm2017/* SDK_VERSION */.Jn, namespace, projectId, apiKey, appId);
        const retryingClient = new RetryingClient(restClient, storage);
        const cachingClient = new CachingClient(retryingClient, storage, storageCache, logger);
        const remoteConfigInstance = new RemoteConfig(app, cachingClient, storageCache, storage, logger);
        // Starts warming cache.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        ensureInitialized(remoteConfigInstance);
        return remoteConfigInstance;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// This API is put in a separate file, so we can stub fetchConfig and activate in tests.
// It's not possible to stub standalone functions from the same module.
/**
 *
 * Performs fetch and activate operations, as a convenience.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 *
 * @returns A `Promise` which resolves to true if the current call activated the fetched configs.
 * If the fetched configs were already activated, the `Promise` will resolve to false.
 *
 * @public
 */
async function fetchAndActivate(remoteConfig) {
    remoteConfig = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    await fetchConfig(remoteConfig);
    return activate(remoteConfig);
}
/**
 * This method provides two different checks:
 *
 * 1. Check if IndexedDB exists in the browser environment.
 * 2. Check if the current browser context allows IndexedDB `open()` calls.
 *
 * @returns A `Promise` which resolves to true if a {@link RemoteConfig} instance
 * can be initialized in this environment, or false if it cannot.
 * @public
 */
async function isSupported() {
    if (!isIndexedDBAvailable()) {
        return false;
    }
    try {
        const isDBOpenable = await validateIndexedDBOpenable();
        return isDBOpenable;
    }
    catch (error) {
        return false;
    }
}

/**
 * Firebase Remote Config
 *
 * @packageDocumentation
 */
/** register component and version */
registerRemoteConfig();


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/remote-config/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/app/dist/esm/index.esm.js



var index_esm_name = "firebase";
var index_esm_version = "9.22.0";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(0,index_esm2017/* registerVersion */.KN)(index_esm_name, index_esm_version, 'app');
//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./firebase/clientApp.ts

var firebaseApp = null;

if (!(0,index_esm2017/* getApps */.C6)().length) {
  firebaseApp = (0,index_esm2017/* initializeApp */.ZF)({
    apiKey: "AIzaSyB7oURh7O_VJYz82KhQGlrzMHFxeArv4yg",
    authDomain: "qureapp-dev.firebaseapp.com",
    projectId: "qureapp-dev",
    storageBucket: "qureapp-dev.appspot.com",
    messagingSenderId: "65428247041",
    appId: "1:65428247041:web:096ed4a562dd4f6ad52600",
    measurementId: "G-3TCYQCDVK0"
  });
}


;// CONCATENATED MODULE: ./components/RNEnvSelector/index.tsx

var RNEnvSelector_jsx = react.createElement;











var RNEnvSelector = function RNEnvSelector() {
  var _useState = (0,react.useState)([]),
      envOptions = _useState[0],
      setEnvOptions = _useState[1];

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (store) {
    return {
      isRNEnvSelectorOpen: store.isRNEnvSelectorOpen,
      RNSelectedEnv: store.RNSelectedEnv
    };
  }),
      isRNEnvSelectorOpen = _useStoreState.isRNEnvSelectorOpen,
      RNSelectedEnv = _useStoreState.RNSelectedEnv;

  var _useState2 = (0,react.useState)(RNSelectedEnv),
      selectedEnv = _useState2[0],
      setSelectedEnv = _useState2[1];

  (0,react.useEffect)(function () {
    if (firebaseApp) {
      var _remoteConfig = getRemoteConfig(firebaseApp);

      _remoteConfig.settings.minimumFetchIntervalMillis = 30000;
      _remoteConfig.defaultConfig = __webpack_require__(84917);
      fetchAndActivate(_remoteConfig).then(function () {
        var _getValue;

        var envs = JSON.parse((_getValue = getValue(getRemoteConfig(), "ENVIRONMENTS")) === null || _getValue === void 0 ? void 0 : _getValue.asString());

        var _envOptions = Object.keys(envs).map(function (env) {
          return {
            label: /*#__PURE__*/react.createElement("div", {
              className: "flex flex-col"
            }, /*#__PURE__*/react.createElement("div", null, env), /*#__PURE__*/react.createElement("div", {
              className: "text-sm text-gray-400"
            }, envs[env])),
            value: env
          };
        });

        setEnvOptions(_envOptions);
      })["catch"](function (err) {
        Toast/* default.error */.Z.error("Unable to fetch remote config");
      });
    }
  }, []);
  (0,react.useEffect)(function () {
    setSelectedEnv(RNSelectedEnv);
  }, [RNSelectedEnv]);

  var onChange = function onChange(val) {
    setSelectedEnv(val);
  };

  var onClose = function onClose() {
    Store/* default.update */.Z.update(function (s) {
      s.isRNEnvSelectorOpen = false;
    });
  };

  var onSelect = function onSelect() {
    if (selectedEnv) {
      var _window;

      (_window = window) === null || _window === void 0 || (_window = _window.ReactNativeWebView) === null || _window === void 0 ? void 0 : _window.postMessage(JSON.stringify({
        event: constants/* default.RN_COMM_CONST.ENV_SELECTION */.Z.RN_COMM_CONST.ENV_SELECTION,
        data: selectedEnv
      }));
      onClose();
    }
  };

  return /*#__PURE__*/react.createElement(Modal/* default */.Z, {
    show: isRNEnvSelectorOpen,
    onClose: onClose,
    title: "Select environment",
    className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
    closeOnClickAway: true
  }, /*#__PURE__*/react.createElement("div", {
    className: "p-5"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-gray-800 dark:text-gray-200 pb-6"
  }, /*#__PURE__*/react.createElement(RadioList/* default */.Z, {
    options: envOptions,
    value: selectedEnv,
    onChange: onChange
  })), /*#__PURE__*/react.createElement("div", {
    className: "text-gray-100 text-base space-x-5"
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    onClick: onClose,
    className: "grow-1 px-6 py-4"
  }, "Cancel"), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    isPrimary: true,
    disabled: !selectedEnv,
    onClick: onSelect,
    className: "grow-1 px-6 py-4"
  }, "Select"))));
};

/* harmony default export */ var components_RNEnvSelector = (RNEnvSelector);
// EXTERNAL MODULE: ./components/ChangeRegionModal/RegionDropdown.jsx
var RegionDropdown = __webpack_require__(73767);
;// CONCATENATED MODULE: ./components/ChangeRegionModal/Index.jsx






var ChangeRegionDropdown = function ChangeRegionDropdown() {
  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isVisible: s.isChangeRegionModalOpen
    };
  }),
      isVisible = _useStoreState.isVisible;

  var onClose = function onClose() {
    Store/* default.update */.Z.update(function (s) {
      s.isChangeRegionModalOpen = false;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
    show: isVisible,
    onClose: onClose,
    title: "Change Region",
    className: "sm:!w-80 !bg-gray-100 dark:!bg-gray-800 sm:h-max",
    closeOnClickAway: true
  });
};

/* harmony default export */ var ChangeRegionModal_Index = (ChangeRegionDropdown);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js + 165 modules
var main = __webpack_require__(80222);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./components/DatadogProvider.tsx
/* provided dependency */ var process = __webpack_require__(34155);







var DatadogProvider_jsx = react.createElement;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0,getPrototypeOf/* default */.Z)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0,possibleConstructorReturn/* default */.Z)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}






var DatadogProvider = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DatadogProvider, _React$Component);

  var _super = _createSuper(DatadogProvider);

  function DatadogProvider(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, DatadogProvider);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "initialiseDatadog", function () {
      var _process$env$NEXT_PUB;

      var _getConfig = config_default()(),
          publicRuntimeConfig = _getConfig.publicRuntimeConfig;

      var commitHash = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA) === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.substring(0, 7);
      main/* datadogRum.init */.v.init({
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID || "",
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || "",
        site: "datadoghq.eu",
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
        version: "".concat(publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.version, ".").concat(commitHash),
        env: window && window.location && window.location.hostname,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackLongTasks: true,
        trackResources: true,
        trackUserInteractions: true,
        //trackViewsManually: true,
        defaultPrivacyLevel: "mask-user-input"
      });
      main/* datadogRum.startSessionReplayRecording */.v.startSessionReplayRecording();
    });

    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(DatadogProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (process.env.NEXT_PUBLIC_APP_ENV === "production") {
        this.initialiseDatadog();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$user = prevProps.user,
          prevUser = _prevProps$user === void 0 ? {} : _prevProps$user;
      var _this$props = this.props,
          _this$props$user = _this$props.user,
          user = _this$props$user === void 0 ? {} : _this$props$user,
          _this$props$authData = _this$props.authData,
          authData = _this$props$authData === void 0 ? {} : _this$props$authData;
      var organizations = (0,lodash.get)(authData, "authData", {});
      var sources = (0,lodash.get)(authData, "sources", []);
      var readSources = (0,lodash.get)(authData, "read_sources", []);
      var uploadSources = (0,lodash.get)(authData, "upload_sources", []);

      if (prevUser.email !== user.email && process.env.NEXT_PUBLIC_APP_ENV === "production") {
        var _navigator;

        main/* datadogRum.setUser */.v.setUser({
          name: user.name && user.name !== "undefined" ? user.name : user.email,
          email: user.email,
          language: (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language,
          readSources: readSources.map(function (readSource) {
            var name = (0,lodash.get)(readSource, ["name"], "");
            return name;
          }),
          uploadSources: uploadSources.map(function (uploadSource) {
            var name = (0,lodash.get)(uploadSource, ["name"], "");
            return name;
          }),
          sources: sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
            if ((0,lodash.isEmpty)(organizations[source])) {
              return source;
            }

            return organizations[source];
          })
        });
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      if (process.env.NEXT_PUBLIC_APP_ENV === "production") {
        main/* datadogRum.addError */.v.addError(error, {
          scope: "error-boundary"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/react.createElement(Fallback, null);
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return DatadogProvider;
}(react.Component);

var Fallback = function Fallback() {
  return /*#__PURE__*/react.createElement("div", {
    className: "flex h-full bg-black flex-col justify-center items-center"
  }, /*#__PURE__*/react.createElement("div", {
    className: "text-white"
  }, "Application error: a client-side exception has occurred (please reload the browser)"));
};

/* harmony default export */ var components_DatadogProvider = (DatadogProvider);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/XMarkIcon.js

function XMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  }));
}
const XMarkIcon_ForwardRef = react.forwardRef(XMarkIcon);
/* harmony default export */ var esm_XMarkIcon = (XMarkIcon_ForwardRef);
;// CONCATENATED MODULE: ./components/InAppAlert/index.tsx


var InAppAlert_jsx = react.createElement;





var InAppAlert = function InAppAlert(_ref) {
  var show = _ref.show,
      onClose = _ref.onClose,
      title = _ref.title,
      message = _ref.message,
      primaryCTA = _ref.primaryCTA,
      secondaryCTA = _ref.secondaryCTA,
      icon = _ref.icon,
      className = _ref.className;
  return /*#__PURE__*/react.createElement("div", {
    "aria-live": "assertive",
    className: "pointer-events-none absolute top-8 inset-0 flex items-end px-4 py-8 sm:py-6 sm:items-start sm:p-6"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex w-full flex-col items-center space-y-4 sm:items-end"
  }, /*#__PURE__*/react.createElement(transition/* Transition */.u, {
    show: show,
    as: react.Fragment,
    enter: "transform ease-out duration-300 transition",
    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("flex pointer-events-auto w-full h-full items-stretch min-w-sm max-w-md overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-teal-600 ring-opacity-5 z-50 min-h-[80px]", (0,defineProperty/* default */.Z)({}, className, !!className))
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex items-center justify-center flex-shrink-0 bg-teal-500 w-1/5"
  }, icon), /*#__PURE__*/react.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/react.createElement("div", {
    className: "flex h-full w-full p-3"
  }, !!title && /*#__PURE__*/react.createElement("p", {
    className: " font-medium text-gray-900"
  }, title), !!message && /*#__PURE__*/react.createElement("p", {
    className: "mt-1 "
  }, message)), (!!primaryCTA || !!secondaryCTA) && /*#__PURE__*/react.createElement("div", {
    className: "flex justify-start items-center gap-4 ml-4 mb-3"
  }, primaryCTA, secondaryCTA)), !!onClose && /*#__PURE__*/react.createElement("div", {
    className: "m-2 flex flex-shrink-0"
  }, /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
    onClick: onClose
  }, /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, "Close"), /*#__PURE__*/react.createElement(esm_XMarkIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })))))));
};

/* harmony default export */ var components_InAppAlert = (InAppAlert);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  return (0,toDate["default"])(dateLeft).getTime() - (0,toDate["default"])(dateRight).getTime();
}
// EXTERNAL MODULE: ./components/NotificationSettings/hooks/useSaveNotificationSettings.ts
var useSaveNotificationSettings = __webpack_require__(72153);
// EXTERNAL MODULE: ./components/Loader/index.tsx
var Loader = __webpack_require__(88741);
// EXTERNAL MODULE: ./utils/LoggedInToken.ts
var LoggedInToken = __webpack_require__(71507);
;// CONCATENATED MODULE: ./components/NotificationSubscription/index.tsx

var NotificationSubscription_jsx = react.createElement;


















var NotificationSubscription = function NotificationSubscription() {
  var _window, _window2, _window3;

  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var isDesktopApp = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.electronAPI;
  var isApp = isMobileApp || isDesktopApp;

  var _useTranslation = (0,dist_es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(!!localStorage.getItem(constants/* default.PERSISTED.notificationPromptDismiss */.Z.PERSISTED.notificationPromptDismiss)),
      isIgnored = _useState[0],
      setIgnored = _useState[1];

  var saveNotificationSettings = (0,useSaveNotificationSettings/* default */.Z)();

  var _useAuthService = (0,useAuthService/* default */.Z)(false),
      refetchProfile = _useAuthService.refetch;

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      user: s.user,
      userInfo: s.userInfo,
      RNfcmToken: s.RNfcmToken,
      isRNAppStateChange: s.isRNAppStateChange,
      RNAppVersion: s.RNAppVersion,
      fcmToken: s.fcmToken,
      isNotificationSubscribing: s.isNotificationSubscribing
    };
  }),
      user = _useStoreState.user,
      userInfo = _useStoreState.userInfo,
      fcmToken = _useStoreState.fcmToken,
      RNfcmToken = _useStoreState.RNfcmToken,
      isRNAppStateChange = _useStoreState.isRNAppStateChange,
      isNotificationSubscribing = _useStoreState.isNotificationSubscribing;

  var token = RNfcmToken || fcmToken;
  var isLoggedIn = !(0,lodash.isEmpty)(user);
  var hasPermission = isMobileApp && (!!RNfcmToken || RNfcmToken === "") || ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.Notification) === null || _window3 === void 0 ? void 0 : _window3.permission) === "granted";
  var isNotificationsOn = !isLoggedIn || !(0,lodash.get)(userInfo, ["settings", "notification_snoozed"], false);
  var isSubscribed = isNotificationSubscribing || !isLoggedIn && hasPermission || !token && hasPermission || (0,lodash.get)(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return (0,lodash.get)(tokenObj, ["token"], "") === token;
  });
  var alertTimeout;
  (0,react.useEffect)(function () {
    if (isLoggedIn) {
      setDefaultFCMTokens();
      setAlertTimer();

      if (LoggedInToken/* default.isLoginProgress */.Z.isLoginProgress()) {
        LoggedInToken/* default.removeLogInProgress */.Z.removeLogInProgress();
        updateSubscription();
      }
    }

    return function () {
      clearTimeout(alertTimeout);
    };
  }, [isLoggedIn]); // when user change the notification permission of app from device settngs

  (0,react.useEffect)(function () {
    if (isMobileApp && isRNAppStateChange && isLoggedIn) {
      var _hasPermission2 = !!RNfcmToken;

      if (!hasPermission && _hasPermission2) {
        updateSubscription();
      }
    }
  }, [RNfcmToken, isRNAppStateChange]); // To nudge users every 6  hours if user has ignored the popup and not enabled notification yet

  var setAlertTimer = function setAlertTimer() {
    if (hasPermission && isSubscribed && isNotificationsOn) {
      return localStorage.removeItem(constants/* default.PERSISTED.notificationPromptDismiss */.Z.PERSISTED.notificationPromptDismiss);
    }

    var timeStr = localStorage.getItem(constants/* default.PERSISTED.notificationPromptDismiss */.Z.PERSISTED.notificationPromptDismiss);

    if (timeStr) {
      var _ignoredTime = new Date(timeStr);

      _ignoredTime.setHours(_ignoredTime.getHours() + 12);

      var _remainingTime = differenceInMilliseconds(_ignoredTime, new Date());

      alertTimeout = setTimeout(function () {
        clearTimeout(alertTimeout);
        localStorage.removeItem(constants/* default.PERSISTED.notificationPromptDismiss */.Z.PERSISTED.notificationPromptDismiss);
        setIgnored(false);
      }, _remainingTime);
    }
  }; // check if user is subscribed for notification


  var setDefaultFCMTokens = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _window4;

      var _fcmToken2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(((_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.Notification) === null || _window4 === void 0 ? void 0 : _window4.permission) === "granted")) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return (0,utils/* getFCMToken */.Ev)();

            case 3:
              _fcmToken2 = _context.sent;
              Store/* default.update */.Z.update(function (s) {
                s.fcmToken = _fcmToken2;
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setDefaultFCMTokens() {
      return _ref.apply(this, arguments);
    };
  }();

  var onIgnore = function onIgnore() {
    if (isNotificationSubscribing) {
      return;
    }

    clearTimeout(alertTimeout);
    localStorage.setItem(constants/* default.PERSISTED.notificationPromptDismiss */.Z.PERSISTED.notificationPromptDismiss, new Date().toString());
    setIgnored(true);
    setAlertTimer();
  };

  var updateSubscription = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var subscription;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              Store/* default.update */.Z.update(function (s) {
                s.isNotificationSubscribing = true;
              });
              _context2.next = 3;
              return (0,pushNotification/* subscribeUserNotification */.Wo)(RNfcmToken);

            case 3:
              subscription = _context2.sent;

              if (!subscription) {
                _context2.next = 7;
                break;
              }

              _context2.next = 7;
              return refetchProfile();

            case 7:
              Store/* default.update */.Z.update(function (s) {
                s.isNotificationSubscribing = false;
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();

  var enableGlobalNotifications = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return saveNotificationSettings.mutateAsync({
                notification_snoozed: false
              });

            case 3:
              refetchProfile();
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              Toast/* default.error */.Z.error("Something went wrong. Please try again");

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 6]]);
    }));

    return function enableGlobalNotifications() {
      return _ref3.apply(this, arguments);
    };
  }();

  var onEnableNotification = function onEnableNotification() {
    if (isNotificationSubscribing) {
      return;
    }

    if (isMobileApp && !hasPermission) {
      var _window5;

      var _data = {
        event: constants/* default.RN_COMM_CONST.OPEN_APP_SETTINGS */.Z.RN_COMM_CONST.OPEN_APP_SETTINGS,
        data: null
      };
      (_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.ReactNativeWebView) === null || _window5 === void 0 ? void 0 : _window5.postMessage(JSON.stringify(_data));
    } else if (isSubscribed && !isNotificationsOn) {
      enableGlobalNotifications();
    } else {
      updateSubscription();
    }
  };

  return /*#__PURE__*/react.createElement(components_InAppAlert, {
    show: !isNotificationSubscribing && router.pathname != "/open-app" && isLoggedIn && !isIgnored && (!hasPermission || !isSubscribed || !isNotificationsOn),
    message: !hasPermission || !isSubscribed ? t("notification_modal.no_notifications_setting") : t("notification_modal.no_notifications"),
    primaryCTA: /*#__PURE__*/react.createElement("a", {
      className: "text-teal-500 cursor-pointer",
      onClick: onEnableNotification
    }, isMobileApp && !hasPermission ? t("notification_modal.enable_settings") : t("notification_modal.turn_on_notification")),
    secondaryCTA: /*#__PURE__*/react.createElement("a", {
      className: "text-gray-600 cursor-pointer",
      onClick: onIgnore
    }, t("notification_modal.ignore")),
    className: "",
    icon: isNotificationSubscribing ? /*#__PURE__*/react.createElement(Loader/* default */.Z, {
      size: "medium",
      className: "border-teal-200"
    }) : /*#__PURE__*/react.createElement("svg", {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react.createElement("path", {
      d: "M22.1437 4.25V5.50719C26.9989 6.31648 30.7156 10.7328 30.7156 16.0625V18.4109C30.7156 21.6031 31.7536 24.7039 33.6488 27.2L34.6466 28.5078C35.035 29.0141 35.1086 29.7102 34.8408 30.2938C34.5729 30.8773 34.0104 31.25 33.3943 31.25H6.60723C5.98912 31.25 5.42626 30.8773 5.15866 30.2938C4.89099 29.7102 4.96626 29.0141 5.35226 28.5078L6.35075 27.2C8.25062 24.7039 9.28594 21.6031 9.28594 18.4109V16.0625C9.28594 10.7328 13.0026 6.31648 17.8578 5.50719V4.25C17.8578 3.00758 18.8154 2 20.0008 2C21.1861 2 22.1437 3.00758 22.1437 4.25ZM19.465 8.75C15.6211 8.75 12.5004 12.0266 12.5004 16.0625V18.4109C12.5004 21.7789 11.5709 25.0625 9.84244 27.875H30.1597C28.432 25.0625 27.5011 21.7789 27.5011 18.4109V16.0625C27.5011 12.0266 24.3804 8.75 20.5365 8.75H19.465ZM24.2867 33.5C24.2867 34.632 23.838 35.8414 23.0344 36.6852C22.2308 37.5289 21.0789 38 20.0008 38C18.8623 38 17.7707 37.5289 16.9671 36.6852C16.1635 35.8414 15.7148 34.632 15.7148 33.5H24.2867Z",
      fill: "#00D0CD"
    }))
  });
};

/* harmony default export */ var components_NotificationSubscription = (NotificationSubscription);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(36609);
;// CONCATENATED MODULE: ./node_modules/i18next-http-backend/esm/utils.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}
// EXTERNAL MODULE: ./node_modules/i18next-http-backend/esm/getFetch.cjs
var getFetch = __webpack_require__(83154);
var getFetch_namespaceObject = /*#__PURE__*/__webpack_require__.t(getFetch, 2);
;// CONCATENATED MODULE: ./node_modules/i18next-http-backend/esm/request.js
function request_typeof(obj) { "@babel/helpers - typeof"; return request_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, request_typeof(obj); }


var fetchApi;
if (typeof fetch === 'function') {
  if (typeof global !== 'undefined' && global.fetch) {
    fetchApi = global.fetch;
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch;
  } else {
    fetchApi = fetch;
  }
}
var XmlHttpRequestApi;
if (hasXMLHttpRequest()) {
  if (typeof global !== 'undefined' && global.XMLHttpRequest) {
    XmlHttpRequestApi = global.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof global !== 'undefined' && global.ActiveXObject) {
    ActiveXObjectApi = global.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && getFetch_namespaceObject && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = getFetch || getFetch_namespaceObject;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && request_typeof(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback) {
  fetchApi(url, fetchOptions).then(function (response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  }).catch(callback);
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = defaults({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = defaults({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  try {
    fetchIt(url, fetchOptions, callback);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && request_typeof(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if (hasXMLHttpRequest() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};
/* harmony default export */ var esm_request = (request);
;// CONCATENATED MODULE: ./node_modules/i18next-http-backend/esm/index.js
function esm_typeof(obj) { "@babel/helpers - typeof"; return esm_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, esm_typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return esm_typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (esm_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (esm_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: esm_request,
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = makePromise(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message && err.message.indexOf('Failed to fetch') > -1) return callback('failed loading ' + url + ': ' + err.message, true);
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';
/* harmony default export */ var esm = (Backend);
;// CONCATENATED MODULE: ./node_modules/i18next-browser-languagedetector/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function classCallCheck_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/i18next-browser-languagedetector/node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(obj) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, typeof_typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/i18next-browser-languagedetector/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive_toPrimitive(input, hint) {
  if (typeof_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/i18next-browser-languagedetector/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey_toPropertyKey(arg) {
  var key = toPrimitive_toPrimitive(arg, "string");
  return typeof_typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/i18next-browser-languagedetector/node_modules/@babel/runtime/helpers/esm/createClass.js

function createClass_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey_toPropertyKey(descriptor.key), descriptor);
  }
}
function createClass_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) createClass_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) createClass_defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/i18next-browser-languagedetector/dist/esm/i18nextBrowserLanguageDetector.js



var i18nextBrowserLanguageDetector_arr = [];
var i18nextBrowserLanguageDetector_each = i18nextBrowserLanguageDetector_arr.forEach;
var i18nextBrowserLanguageDetector_slice = i18nextBrowserLanguageDetector_arr.slice;
function i18nextBrowserLanguageDetector_defaults(obj) {
  i18nextBrowserLanguageDetector_each.call(i18nextBrowserLanguageDetector_slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

// eslint-disable-next-line no-control-regex
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var serializeCookie = function serializeCookie(name, val, options) {
  var opt = options || {};
  opt.path = opt.path || '/';
  var value = encodeURIComponent(val);
  var str = "".concat(name, "=").concat(value);
  if (opt.maxAge > 0) {
    var maxAge = opt.maxAge - 0;
    if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += "; Max-Age=".concat(Math.floor(maxAge));
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += "; Domain=".concat(opt.domain);
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += "; Path=".concat(opt.path);
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += "; Expires=".concat(opt.expires.toUTCString());
  }
  if (opt.httpOnly) str += '; HttpOnly';
  if (opt.secure) str += '; Secure';
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  return str;
};
var cookie = {
  create: function create(name, value, minutes, domain) {
    var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      path: '/',
      sameSite: 'strict'
    };
    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1000);
    }
    if (domain) cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
  },
  read: function read(name) {
    var nameEQ = "".concat(name, "=");
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  remove: function remove(name) {
    this.create(name, '', -1);
  }
};
var cookie$1 = {
  name: 'cookie',
  lookup: function lookup(options) {
    var found;
    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
  }
};

var querystring = {
  name: 'querystring',
  lookup: function lookup(options) {
    var found;
    if (typeof window !== 'undefined') {
      var search = window.location.search;
      if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) {
        search = window.location.hash.substring(window.location.hash.indexOf('?'));
      }
      var query = search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }
    return found;
  }
};

var hasLocalStorageSupport = null;
var localStorageAvailable = function localStorageAvailable() {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
  } catch (e) {
    hasLocalStorageSupport = false;
  }
  return hasLocalStorageSupport;
};
var i18nextBrowserLanguageDetector_localStorage = {
  name: 'localStorage',
  lookup: function lookup(options) {
    var found;
    if (options.lookupLocalStorage && localStorageAvailable()) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

var hasSessionStorageSupport = null;
var sessionStorageAvailable = function sessionStorageAvailable() {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.sessionStorage.setItem(testKey, 'foo');
    window.sessionStorage.removeItem(testKey);
  } catch (e) {
    hasSessionStorageSupport = false;
  }
  return hasSessionStorageSupport;
};
var sessionStorage = {
  name: 'sessionStorage',
  lookup: function lookup(options) {
    var found;
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
      if (lng) found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
  }
};

var navigator$1 = {
  name: 'navigator',
  lookup: function lookup(options) {
    var found = [];
    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }
    return found.length > 0 ? found : undefined;
  }
};

var htmlTag = {
  name: 'htmlTag',
  lookup: function lookup(options) {
    var found;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }
    return found;
  }
};

var path = {
  name: 'path',
  lookup: function lookup(options) {
    var found;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === 'number') {
          if (typeof language[options.lookupFromPathIndex] !== 'string') {
            return undefined;
          }
          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }
    return found;
  }
};

var subdomain = {
  name: 'subdomain',
  lookup: function lookup(options) {
    // If given get the subdomain index else 1
    var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1;
    // get all matches if window.location. is existing
    // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
    // is the hostname no public domain get the or option of localhost
    var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);

    // if there is no match (null) return undefined
    if (!language) return undefined;
    // return the given group match
    return language[lookupFromSubdomainIndex];
  }
};

function i18nextBrowserLanguageDetector_getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'

    convertDetectedLanguage: function convertDetectedLanguage(l) {
      return l;
    }
  };
}
var Browser = /*#__PURE__*/function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck_classCallCheck(this, Browser);
    this.type = 'languageDetector';
    this.detectors = {};
    this.init(services, options);
  }
  createClass_createClass(Browser, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services || {
        languageUtils: {}
      }; // this way the language detector can be used without i18next
      this.options = i18nextBrowserLanguageDetector_defaults(options, this.options || {}, i18nextBrowserLanguageDetector_getDefaults());
      if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) {
        this.options.convertDetectedLanguage = function (l) {
          return l.replace('-', '_');
        };
      }

      // backwards compatibility
      if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
      this.i18nOptions = i18nOptions;
      this.addDetector(cookie$1);
      this.addDetector(querystring);
      this.addDetector(i18nextBrowserLanguageDetector_localStorage);
      this.addDetector(sessionStorage);
      this.addDetector(navigator$1);
      this.addDetector(htmlTag);
      this.addDetector(path);
      this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: "detect",
    value: function detect(detectionOrder) {
      var _this = this;
      if (!detectionOrder) detectionOrder = this.options.order;
      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);
          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });
      detected = detected.map(function (d) {
        return _this.options.convertDetectedLanguage(d);
      });
      if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
      return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
  }, {
    key: "cacheUserLanguage",
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;
      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);
  return Browser;
}();
Browser.type = 'languageDetector';



;// CONCATENATED MODULE: ./i18n.js





var languageDetector = new Browser(null, {
  order: ["navigator"]
});

function getLanguageCode(i18nObject) {
  var locales = Object.keys(_.get(i18nObject, ["store", "data"], []));
  return i18nObject.languages && i18nObject.languages.find(function (lng) {
    return locales.indexOf(lng) !== -1;
  });
}

function getActiveLanguage() {
  return new Promise(function (resolve) {
    if (!i18n.isInitialized) {
      i18n.on("initialized", function () {
        var locales = Object.keys(_.get(i18n, ["store", "data"], []));
        return resolve(i18n.languages && i18n.languages.find(function (lng) {
          return locales.indexOf(lng) !== -1;
        }));
      });
      return;
    }

    return resolve(getLanguageCode(i18n));
  });
}

var options = {
  load: "languageOnly",
  order: ["navigator", "localStorage"],
  caches: ["localStorage"],
  fallbackLng: "en",
  debug: false,
  keySeparator: ".",
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default

  },
  backend: {
    loadPath: function loadPath(lng) {
      return "".concat("https://app-translations-staging.qure.ai/qureapp", "/").concat(lng, ".json");
    },
    crossDomain: true
  }
};
i18next/* default.use */.ZP.use(esm).use(languageDetector).use(dist_es/* initReactI18next */.Db) // passes i18n down to react-i18next
.init(options);

// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(40906);
// EXTERNAL MODULE: ./node_modules/react-image-crop/dist/ReactCrop.css
var ReactCrop = __webpack_require__(51919);
;// CONCATENATED MODULE: ./pages/_app.js


function _app_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _app_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _app_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _app_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






































var ProductFruits = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 731).then(__webpack_require__.bind(__webpack_require__, 61731)).then(function (mod) {
    return mod.ProductFruits;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61731)];
    }
  }
});
next_router.Router.events.on("routeChangeComplete", function () {
  var _window, _window2, _window2$productFruit, _window3, _window3$productFruit;

  ((_window = window) === null || _window === void 0 ? void 0 : _window.productFruits) && ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$productFruit = _window2.productFruits) === null || _window2$productFruit === void 0 ? void 0 : _window2$productFruit.pageChanged) && ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$productFruit = _window3.productFruits) === null || _window3$productFruit === void 0 ? void 0 : _window3$productFruit.pageChanged());
});

function MyApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  var queryClient = new es.QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false
      }
    }
  });

  var _useStoreState = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (store) {
    return {
      user: store.user,
      authData: store.userInfo
    };
  }),
      user = _useStoreState.user,
      authData = _useStoreState.authData;

  var userInfo = {
    username: (0,lodash.get)(user, ["preferred_username"], null)
  };
  var hideMenu = pageProps.hideMenu,
      hasShare = pageProps.hasShare;

  var onIdle = function onIdle() {
    // Reloading the page when screen is idle after 7.5 Mins
    location.reload();
  };

  var idleTimer = oe({
    onIdle: onIdle,
    timeout: 1000 * 60 * 7.5
  });

  var _useStoreState2 = (0,index_es/* useStoreState */.Kw)(Store/* default */.Z, function (s) {
    return {
      isDarkMode: s.isDarkMode
    };
  }),
      isDarkMode = _useStoreState2.isDarkMode;

  var onToggleThemeClick = function onToggleThemeClick() {
    if (window) {
      localStorage.setItem(constants/* default.PERSISTED.isDarkMode */.Z.PERSISTED.isDarkMode, !isDarkMode);
      Store/* default.update */.Z.update(function (s) {
        s.isDarkMode = !isDarkMode;
      });
    }
  };

  (0,react.useEffect)(function () {
    if (window) {
      var _window4, _window4$location;

      var params = query_string.parse((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$location = _window4.location) === null || _window4$location === void 0 ? void 0 : _window4$location.search);

      if (params["redirectLogin"]) {
        localStorage.setItem("redirectLogin", true);
      }

      var _isDarkMode = JSON.parse(localStorage.getItem(constants/* default.PERSISTED.isDarkMode */.Z.PERSISTED.isDarkMode)); // to set default dark mode


      if (_isDarkMode === null) {
        _isDarkMode = true;
      }

      Store/* default.update */.Z.update(function (s) {
        s.isDarkMode = _isDarkMode;
      });
    }
  }, []);
  (0,react.useEffect)(function () {
    if (isDarkMode) {
      document.querySelector("body").classList.add("dark");
    } else {
      document.querySelector("body").classList.remove("dark");
    }
  }, [isDarkMode]);
  (0,react.useEffect)(function () {
    // Using web workers to pass data from Android and iOS webviews
    if ((0,utils/* isIOSWebView */.Ad)() || (0,utils/* isAndroidWebView */.zd)()) {
      var _window5, _window5$ReactNativeW;

      window.addEventListener("message", onRNMessage); // for iOS

      document.addEventListener("message", onRNMessage); // for Android

      (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$ReactNativeW = _window5.ReactNativeWebView) === null || _window5$ReactNativeW === void 0 ? void 0 : _window5$ReactNativeW.postMessage(JSON.stringify({
        event: constants/* default.RN_COMM_CONST.APP_READY */.Z.RN_COMM_CONST.APP_READY
      }));
    }

    return function () {
      window.removeEventListener("message", onRNMessage);
      document.removeEventListener("message", onRNMessage);
    };
  }, []);

  var onRNMessage = function onRNMessage(e) {
    var messageData = JSON.parse((0,lodash.get)(e, ["data"], ""));
    Store/* default.update */.Z.update(function (store) {
      store.isRNTestBuild = (0,lodash.get)(messageData, ["isRNTestBuild"], store.isRNTestBuild);
      store.RNSelectedEnv = (0,lodash.get)(messageData, ["env"], store.RNSelectedEnv);
      store.RNfcmToken = (0,lodash.get)(messageData, ["fcmToken"], store.RNfcmToken);
      store.isRNAppStateChange = (0,lodash.get)(messageData, ["isRNAppStateChange"], false);
      store.RNAppVersion = (0,lodash.get)(messageData, ["AppVersion"], store.RNAppVersion);
    });
  };

  (0,react.useEffect)(function () {
    // Check the screen width
    var screenWidth = window.innerWidth;

    if (screenWidth > 550) {
      window.onUsersnapCXLoad = function (api) {
        api.init({
          user: {
            app: "qure"
          }
        });
      };
    } // Dynamically create a script element


    var scriptElement = document.createElement("script");

    if (screenWidth > 550) {
      scriptElement.defer = 1;
      scriptElement.src = "https://widget.usersnap.com/global/load/1fec3ff9-9d2e-4d2e-a6b9-74cabf1f548e?onload=onUsersnapCXLoad";
    } // Append the script to the document head


    document.getElementsByTagName("head")[0].appendChild(scriptElement); // Clean up: remove the script element when the component unmounts

    return function () {
      document.getElementsByTagName("head")[0].removeChild(scriptElement);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [hasShare ? /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        charSet: "UTF-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:site_name",
        content: "Qure.ai"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Study shared with you via Qure App"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "View imaging studies and collaborate in real-time"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "View imaging studies and collaborate in real-time"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        itemProp: "image",
        content: "https://app.qure.ai/assets/images/sharingPreview.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:width",
        content: "1070"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:height",
        content: "580"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: "qure, qer, qxr, stroke"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "author",
        content: "Qure.ai"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no"
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        charSet: "UTF-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:site_name",
        content: "Qure.ai"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Qure.ai"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "View imaging studies and collaborate in real-time"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "View imaging studies and collaborate in real-time"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        itemProp: "image",
        content: "https://app.qure.ai/assets/images/pageMeta.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:width",
        content: "1070"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:height",
        content: "580"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: "qure, qer, qxr, stroke"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "author",
        content: "Qure.ai"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      async: true,
      src: "https://www.googletagmanager.com/gtag/js?id=G-JPCJ0V0E2R"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "gtag",
      children: "\n          window.dataLayer = window.dataLayer || []\n          function gtag(){dataLayer.push(arguments)}\n          gtag('js', new Date());\n\n          gtag('config', 'G-JPCJ0V0E2R');\n        "
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_DatadogProvider, {
      user: user,
      authData: authData,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(es.QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "h-full flex bg-gray-100 dark:bg-gray-900",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(common_Authenticator, {
            children: [__webpack_require__.g.window && !(0,lodash.isEmpty)(user) && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductFruits, {
              workspaceCode: "RGZzjWErMsIXZvnY",
              language: "en",
              user: userInfo,
              config: {
                disableLocationChangeDetection: true
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_NotificationSubscription, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(PatientsContext/* PatientsContextProvider */.S, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex-1 min-w-0 flex flex-col w-full h-full overflow-hidden",
                children: [!hideMenu && /*#__PURE__*/(0,jsx_runtime.jsx)(Menubar/* default */.Z, {
                  onToggleThemeClick: onToggleThemeClick
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps))]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_ConnectModality, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Index, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ReportTemplate_ReportTemplateModal, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ChangeRegionModal_Index, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationSettings_NotificationSettingsModal, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(AutomatedShare_AutomatedShareModal, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(WorkspaceManagementModal, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(UserGroupManagement_UserGroupModal, {})]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Logout, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_NetworkError, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_ExportMessage, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_RNEnvSelector, {})]
        })
      })
    })]
  });
}

/* harmony default export */ var _app = (MyApp);

/***/ }),

/***/ 22687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Of": function() { return /* binding */ validateFields; },
/* harmony export */   "UY": function() { return /* binding */ startCharCheckValidation; },
/* harmony export */   "VK": function() { return /* binding */ emptyFieldValidation; },
/* harmony export */   "X2": function() { return /* binding */ whiteSpaceValidation; },
/* harmony export */   "dc": function() { return /* binding */ customRegexValidation; },
/* harmony export */   "lp": function() { return /* binding */ replaceText; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

var customRegexValidation = function customRegexValidation(val) {
  /* eslint-disable */
  var textRegexToSearch = /[\*\+\;<>|]/g;
  /* eslint-enable */

  if (textRegexToSearch.test(val)) {
    return false;
  }

  return true;
};
var startCharCheckValidation = function startCharCheckValidation(val) {
  var tVal = lodash__WEBPACK_IMPORTED_MODULE_0___default().trim(val);

  return ["@", "=", "+"].indexOf(tVal[0]) === -1;
};
var emptyFieldValidation = function emptyFieldValidation(val) {
  if (typeof val === "string") {
    return !lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(val && val.trim());
  }

  if (Array.isArray(val)) {
    return !lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(val);
  } // if its a number, just make it true,
  // if its other than number, array, string then it should return false otherwise


  return typeof val === "number";
};
var whiteSpaceValidation = function whiteSpaceValidation(val) {
  var textRegexToSearch = /[\s]/;
  /* eslint-enable */

  if (textRegexToSearch.test(val)) {
    return false;
  }

  return true;
};
var replaceText = function replaceText(val) {
  var reg = /<([a-z]+)(?:\s+[^>]*?["'=\s]?)?(?:\/?)>/gi;
  var isValid = reg.test(val);

  if (isValid) {
    return val.replace(/[<>]/g, " ");
  }

  return val;
};
var validateFields = function validateFields(fields) {
  var _error = "";
  fields.forEach(function (_ref) {
    var fn = _ref.fn,
        value = _ref.value,
        err = _ref.err;

    if (!fn(value)) {
      _error += err;
    }
  });

  if (_error) {
    _error = _error.slice(0, -1);
  }

  return _error;
};

/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(26096);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 930:
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 18698:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 51919:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50803:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40993:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(78566)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(69898)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 62520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.




var isWindows = process.platform === 'win32';
var util = __webpack_require__(89539);


// resolves . and .. elements in a path array with directory names there
// must be no slashes or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  var res = [];
  for (var i = 0; i < parts.length; i++) {
    var p = parts[i];

    // ignore empty parts
    if (!p || p === '.')
      continue;

    if (p === '..') {
      if (res.length && res[res.length - 1] !== '..') {
        res.pop();
      } else if (allowAboveRoot) {
        res.push('..');
      }
    } else {
      res.push(p);
    }
  }

  return res;
}

// returns an array with empty elements removed from either end of the input
// array or the original array if no elements need to be removed
function trimArray(arr) {
  var lastIndex = arr.length - 1;
  var start = 0;
  for (; start <= lastIndex; start++) {
    if (arr[start])
      break;
  }

  var end = lastIndex;
  for (; end >= 0; end--) {
    if (arr[end])
      break;
  }

  if (start === 0 && end === lastIndex)
    return arr;
  if (start > end)
    return [];
  return arr.slice(start, end + 1);
}

// Regex to split a windows path into three parts: [*, device, slash,
// tail] windows-only
var splitDeviceRe =
    /^([a-zA-Z]:|[\\\/]{2}[^\\\/]+[\\\/]+[^\\\/]+)?([\\\/])?([\s\S]*?)$/;

// Regex to split the tail part of the above into [*, dir, basename, ext]
var splitTailRe =
    /^([\s\S]*?)((?:\.{1,2}|[^\\\/]+?|)(\.[^.\/\\]*|))(?:[\\\/]*)$/;

var win32 = {};

// Function to split a filename into [root, dir, basename, ext]
function win32SplitPath(filename) {
  // Separate device+slash from tail
  var result = splitDeviceRe.exec(filename),
      device = (result[1] || '') + (result[2] || ''),
      tail = result[3] || '';
  // Split the tail into dir, basename and extension
  var result2 = splitTailRe.exec(tail),
      dir = result2[1],
      basename = result2[2],
      ext = result2[3];
  return [device, dir, basename, ext];
}

function win32StatPath(path) {
  var result = splitDeviceRe.exec(path),
      device = result[1] || '',
      isUnc = !!device && device[1] !== ':';
  return {
    device: device,
    isUnc: isUnc,
    isAbsolute: isUnc || !!result[2], // UNC paths are always absolute
    tail: result[3]
  };
}

function normalizeUNCRoot(device) {
  return '\\\\' + device.replace(/^[\\\/]+/, '').replace(/[\\\/]+/g, '\\');
}

// path.resolve([from ...], to)
win32.resolve = function() {
  var resolvedDevice = '',
      resolvedTail = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1; i--) {
    var path;
    if (i >= 0) {
      path = arguments[i];
    } else if (!resolvedDevice) {
      path = process.cwd();
    } else {
      // Windows has the concept of drive-specific current working
      // directories. If we've resolved a drive letter but not yet an
      // absolute path, get cwd for that drive. We're sure the device is not
      // an unc path at this points, because unc paths are always absolute.
      path = process.env['=' + resolvedDevice];
      // Verify that a drive-local cwd was found and that it actually points
      // to our drive. If not, default to the drive's root.
      if (!path || path.substr(0, 3).toLowerCase() !==
          resolvedDevice.toLowerCase() + '\\') {
        path = resolvedDevice + '\\';
      }
    }

    // Skip empty and invalid entries
    if (!util.isString(path)) {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    var result = win32StatPath(path),
        device = result.device,
        isUnc = result.isUnc,
        isAbsolute = result.isAbsolute,
        tail = result.tail;

    if (device &&
        resolvedDevice &&
        device.toLowerCase() !== resolvedDevice.toLowerCase()) {
      // This path points to another device so it is not applicable
      continue;
    }

    if (!resolvedDevice) {
      resolvedDevice = device;
    }
    if (!resolvedAbsolute) {
      resolvedTail = tail + '\\' + resolvedTail;
      resolvedAbsolute = isAbsolute;
    }

    if (resolvedDevice && resolvedAbsolute) {
      break;
    }
  }

  // Convert slashes to backslashes when `resolvedDevice` points to an UNC
  // root. Also squash multiple slashes into a single one where appropriate.
  if (isUnc) {
    resolvedDevice = normalizeUNCRoot(resolvedDevice);
  }

  // At this point the path should be resolved to a full absolute path,
  // but handle relative paths to be safe (might happen when process.cwd()
  // fails)

  // Normalize the tail path
  resolvedTail = normalizeArray(resolvedTail.split(/[\\\/]+/),
                                !resolvedAbsolute).join('\\');

  return (resolvedDevice + (resolvedAbsolute ? '\\' : '') + resolvedTail) ||
         '.';
};


win32.normalize = function(path) {
  var result = win32StatPath(path),
      device = result.device,
      isUnc = result.isUnc,
      isAbsolute = result.isAbsolute,
      tail = result.tail,
      trailingSlash = /[\\\/]$/.test(tail);

  // Normalize the tail path
  tail = normalizeArray(tail.split(/[\\\/]+/), !isAbsolute).join('\\');

  if (!tail && !isAbsolute) {
    tail = '.';
  }
  if (tail && trailingSlash) {
    tail += '\\';
  }

  // Convert slashes to backslashes when `device` points to an UNC root.
  // Also squash multiple slashes into a single one where appropriate.
  if (isUnc) {
    device = normalizeUNCRoot(device);
  }

  return device + (isAbsolute ? '\\' : '') + tail;
};


win32.isAbsolute = function(path) {
  return win32StatPath(path).isAbsolute;
};

win32.join = function() {
  var paths = [];
  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];
    if (!util.isString(arg)) {
      throw new TypeError('Arguments to path.join must be strings');
    }
    if (arg) {
      paths.push(arg);
    }
  }

  var joined = paths.join('\\');

  // Make sure that the joined path doesn't start with two slashes, because
  // normalize() will mistake it for an UNC path then.
  //
  // This step is skipped when it is very clear that the user actually
  // intended to point at an UNC path. This is assumed when the first
  // non-empty string arguments starts with exactly two slashes followed by
  // at least one more non-slash character.
  //
  // Note that for normalize() to treat a path as an UNC path it needs to
  // have at least 2 components, so we don't filter for that here.
  // This means that the user can use join to construct UNC paths from
  // a server name and a share name; for example:
  //   path.join('//server', 'share') -> '\\\\server\\share\')
  if (!/^[\\\/]{2}[^\\\/]/.test(paths[0])) {
    joined = joined.replace(/^[\\\/]{2,}/, '\\');
  }

  return win32.normalize(joined);
};


// path.relative(from, to)
// it will solve the relative path from 'from' to 'to', for instance:
// from = 'C:\\orandea\\test\\aaa'
// to = 'C:\\orandea\\impl\\bbb'
// The output of the function should be: '..\\..\\impl\\bbb'
win32.relative = function(from, to) {
  from = win32.resolve(from);
  to = win32.resolve(to);

  // windows is not case sensitive
  var lowerFrom = from.toLowerCase();
  var lowerTo = to.toLowerCase();

  var toParts = trimArray(to.split('\\'));

  var lowerFromParts = trimArray(lowerFrom.split('\\'));
  var lowerToParts = trimArray(lowerTo.split('\\'));

  var length = Math.min(lowerFromParts.length, lowerToParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (lowerFromParts[i] !== lowerToParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  if (samePartsLength == 0) {
    return to;
  }

  var outputParts = [];
  for (var i = samePartsLength; i < lowerFromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('\\');
};


win32._makeLong = function(path) {
  // Note: this will *probably* throw somewhere.
  if (!util.isString(path))
    return path;

  if (!path) {
    return '';
  }

  var resolvedPath = win32.resolve(path);

  if (/^[a-zA-Z]\:\\/.test(resolvedPath)) {
    // path is local filesystem path, which needs to be converted
    // to long UNC path.
    return '\\\\?\\' + resolvedPath;
  } else if (/^\\\\[^?.]/.test(resolvedPath)) {
    // path is network UNC path, which needs to be converted
    // to long UNC path.
    return '\\\\?\\UNC\\' + resolvedPath.substring(2);
  }

  return path;
};


win32.dirname = function(path) {
  var result = win32SplitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


win32.basename = function(path, ext) {
  var f = win32SplitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


win32.extname = function(path) {
  return win32SplitPath(path)[3];
};


win32.format = function(pathObject) {
  if (!util.isObject(pathObject)) {
    throw new TypeError(
        "Parameter 'pathObject' must be an object, not " + typeof pathObject
    );
  }

  var root = pathObject.root || '';

  if (!util.isString(root)) {
    throw new TypeError(
        "'pathObject.root' must be a string or undefined, not " +
        typeof pathObject.root
    );
  }

  var dir = pathObject.dir;
  var base = pathObject.base || '';
  if (!dir) {
    return base;
  }
  if (dir[dir.length - 1] === win32.sep) {
    return dir + base;
  }
  return dir + win32.sep + base;
};


win32.parse = function(pathString) {
  if (!util.isString(pathString)) {
    throw new TypeError(
        "Parameter 'pathString' must be a string, not " + typeof pathString
    );
  }
  var allParts = win32SplitPath(pathString);
  if (!allParts || allParts.length !== 4) {
    throw new TypeError("Invalid path '" + pathString + "'");
  }
  return {
    root: allParts[0],
    dir: allParts[0] + allParts[1].slice(0, -1),
    base: allParts[2],
    ext: allParts[3],
    name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
  };
};


win32.sep = '\\';
win32.delimiter = ';';


// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var posix = {};


function posixSplitPath(filename) {
  return splitPathRe.exec(filename).slice(1);
}


// path.resolve([from ...], to)
// posix version
posix.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (!util.isString(path)) {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path[0] === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(resolvedPath.split('/'),
                                !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
posix.normalize = function(path) {
  var isAbsolute = posix.isAbsolute(path),
      trailingSlash = path && path[path.length - 1] === '/';

  // Normalize the path
  path = normalizeArray(path.split('/'), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
posix.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
posix.join = function() {
  var path = '';
  for (var i = 0; i < arguments.length; i++) {
    var segment = arguments[i];
    if (!util.isString(segment)) {
      throw new TypeError('Arguments to path.join must be strings');
    }
    if (segment) {
      if (!path) {
        path += segment;
      } else {
        path += '/' + segment;
      }
    }
  }
  return posix.normalize(path);
};


// path.relative(from, to)
// posix version
posix.relative = function(from, to) {
  from = posix.resolve(from).substr(1);
  to = posix.resolve(to).substr(1);

  var fromParts = trimArray(from.split('/'));
  var toParts = trimArray(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};


posix._makeLong = function(path) {
  return path;
};


posix.dirname = function(path) {
  var result = posixSplitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


posix.basename = function(path, ext) {
  var f = posixSplitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


posix.extname = function(path) {
  return posixSplitPath(path)[3];
};


posix.format = function(pathObject) {
  if (!util.isObject(pathObject)) {
    throw new TypeError(
        "Parameter 'pathObject' must be an object, not " + typeof pathObject
    );
  }

  var root = pathObject.root || '';

  if (!util.isString(root)) {
    throw new TypeError(
        "'pathObject.root' must be a string or undefined, not " +
        typeof pathObject.root
    );
  }

  var dir = pathObject.dir ? pathObject.dir + posix.sep : '';
  var base = pathObject.base || '';
  return dir + base;
};


posix.parse = function(pathString) {
  if (!util.isString(pathString)) {
    throw new TypeError(
        "Parameter 'pathString' must be a string, not " + typeof pathString
    );
  }
  var allParts = posixSplitPath(pathString);
  if (!allParts || allParts.length !== 4) {
    throw new TypeError("Invalid path '" + pathString + "'");
  }
  allParts[1] = allParts[1] || '';
  allParts[2] = allParts[2] || '';
  allParts[3] = allParts[3] || '';

  return {
    root: allParts[0],
    dir: allParts[0] + allParts[1].slice(0, -1),
    base: allParts[2],
    ext: allParts[3],
    name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
  };
};


posix.sep = '/';
posix.delimiter = ':';


if (isWindows)
  module.exports = win32;
else /* posix */
  module.exports = posix;

module.exports.posix = posix;
module.exports.win32 = win32;


/***/ }),

/***/ 4279:
/***/ (function() {

Prism.languages.c = Prism.languages.extend('clike', {
	'comment': {
		pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
		greedy: true
	},
	'string': {
		// https://en.cppreference.com/w/c/language/string_literal
		pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
		lookbehind: true
	},
	'keyword': /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
	'function': /\b[a-z_]\w*(?=\s*\()/i,
	'number': /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
	'operator': />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});

Prism.languages.insertBefore('c', 'string', {
	'char': {
		// https://en.cppreference.com/w/c/language/character_constant
		pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
		greedy: true
	}
});

Prism.languages.insertBefore('c', 'string', {
	'macro': {
		// allow for multiline macro definitions
		// spaces after the # character compile fine with gcc
		pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
		lookbehind: true,
		greedy: true,
		alias: 'property',
		inside: {
			'string': [
				{
					// highlight the path of the include statement as a string
					pattern: /^(#\s*include\s*)<[^>]+>/,
					lookbehind: true
				},
				Prism.languages.c['string']
			],
			'char': Prism.languages.c['char'],
			'comment': Prism.languages.c['comment'],
			'macro-name': [
				{
					pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
					lookbehind: true
				},
				{
					pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
					lookbehind: true,
					alias: 'function'
				}
			],
			// highlight macro directives as keywords
			'directive': {
				pattern: /^(#\s*)[a-z]+/,
				lookbehind: true,
				alias: 'keyword'
			},
			'directive-hash': /^#/,
			'punctuation': /##|\\(?=[\r\n])/,
			'expression': {
				pattern: /\S[\s\S]*/,
				inside: Prism.languages.c
			}
		}
	}
});

Prism.languages.insertBefore('c', 'function', {
	// highlight predefined macros as constants
	'constant': /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});

delete Prism.languages.c['boolean'];


/***/ }),

/***/ 35433:
/***/ (function() {

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/***/ }),

/***/ 2731:
/***/ (function() {

(function (Prism) {

	var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
	var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function () { return keyword.source; });

	Prism.languages.cpp = Prism.languages.extend('c', {
		'class-name': [
			{
				pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source
					.replace(/<keyword>/g, function () { return keyword.source; })),
				lookbehind: true
			},
			// This is intended to capture the class name of method implementations like:
			//   void foo::bar() const {}
			// However! The `foo` in the above example could also be a namespace, so we only capture the class name if
			// it starts with an uppercase letter. This approximation should give decent results.
			/\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
			// This will capture the class name before destructors like:
			//   Foo::~Foo() {}
			/\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
			// This also intends to capture the class name of method implementations but here the class has template
			// parameters, so it can't be a namespace (until C++ adds generic namespaces).
			/\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
		],
		'keyword': keyword,
		'number': {
			pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
			greedy: true
		},
		'operator': />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
		'boolean': /\b(?:false|true)\b/
	});

	Prism.languages.insertBefore('cpp', 'string', {
		'module': {
			// https://en.cppreference.com/w/cpp/language/modules
			pattern: RegExp(
				/(\b(?:import|module)\s+)/.source +
				'(?:' +
				// header-name
				/"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source +
				'|' +
				// module name or partition or both
				/<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function () { return modName; }) +
				')'
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'string': /^[<"][\s\S]+/,
				'operator': /:/,
				'punctuation': /\./
			}
		},
		'raw-string': {
			pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
			alias: 'string',
			greedy: true
		}
	});

	Prism.languages.insertBefore('cpp', 'keyword', {
		'generic-function': {
			pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
			inside: {
				'function': /^\w+/,
				'generic': {
					pattern: /<[\s\S]+/,
					alias: 'class-name',
					inside: Prism.languages.cpp
				}
			}
		}
	});

	Prism.languages.insertBefore('cpp', 'operator', {
		'double-colon': {
			pattern: /::/,
			alias: 'punctuation'
		}
	});

	Prism.languages.insertBefore('cpp', 'class-name', {
		// the base clause is an optional list of parent classes
		// https://en.cppreference.com/w/cpp/language/class
		'base-clause': {
			pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
			lookbehind: true,
			greedy: true,
			inside: Prism.languages.extend('cpp', {})
		}
	});

	Prism.languages.insertBefore('inside', 'double-colon', {
		// All untokenized words that are not namespaces should be class names
		'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
	}, Prism.languages.cpp['base-clause']);

}(Prism));


/***/ }),

/***/ 15251:
/***/ (function() {

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));


/***/ }),

/***/ 52503:
/***/ (function() {

(function (Prism) {

	var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;

	// full package (optional) + parent classes (optional)
	var classNamePrefix = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;

	// based on the java naming conventions
	var className = {
		pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
		lookbehind: true,
		inside: {
			'namespace': {
				pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
				inside: {
					'punctuation': /\./
				}
			},
			'punctuation': /\./
		}
	};

	Prism.languages.java = Prism.languages.extend('clike', {
		'string': {
			pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
			lookbehind: true,
			greedy: true
		},
		'class-name': [
			className,
			{
				// variables, parameters, and constructor references
				// this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
				pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
				lookbehind: true,
				inside: className.inside
			},
			{
				// class names based on keyword
				// this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
				pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + classNamePrefix + /[A-Z]\w*\b/.source),
				lookbehind: true,
				inside: className.inside
			}
		],
		'keyword': keywords,
		'function': [
			Prism.languages.clike.function,
			{
				pattern: /(::\s*)[a-z_]\w*/,
				lookbehind: true
			}
		],
		'number': /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
		'operator': {
			pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
			lookbehind: true
		},
		'constant': /\b[A-Z][A-Z_\d]+\b/
	});

	Prism.languages.insertBefore('java', 'string', {
		'triple-quoted-string': {
			// http://openjdk.java.net/jeps/355#Description
			pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
			greedy: true,
			alias: 'string'
		},
		'char': {
			pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
			greedy: true
		}
	});

	Prism.languages.insertBefore('java', 'class-name', {
		'annotation': {
			pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
			lookbehind: true,
			alias: 'punctuation'
		},
		'generics': {
			pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
			inside: {
				'class-name': className,
				'keyword': keywords,
				'punctuation': /[<>(),.:]/,
				'operator': /[?&|]/
			}
		},
		'import': [
			{
				pattern: RegExp(/(\bimport\s+)/.source + classNamePrefix + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
				lookbehind: true,
				inside: {
					'namespace': className.inside.namespace,
					'punctuation': /\./,
					'operator': /\*/,
					'class-name': /\w+/
				}
			},
			{
				pattern: RegExp(/(\bimport\s+static\s+)/.source + classNamePrefix + /(?:\w+|\*)(?=\s*;)/.source),
				lookbehind: true,
				alias: 'static',
				inside: {
					'namespace': className.inside.namespace,
					'static': /\b\w+$/,
					'punctuation': /\./,
					'operator': /\*/,
					'class-name': /\w+/
				}
			}
		],
		'namespace': {
			pattern: RegExp(
				/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/
					.source.replace(/<keyword>/g, function () { return keywords.source; })),
			lookbehind: true,
			inside: {
				'punctuation': /\./,
			}
		}
	});
}(Prism));


/***/ }),

/***/ 39980:
/***/ (function() {

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/***/ }),

/***/ 24064:
/***/ (function() {

(function (Prism) {

	// Allow only one line break
	var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;

	/**
	 * This function is intended for the creation of the bold or italic pattern.
	 *
	 * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
	 *
	 * _Note:_ Keep in mind that this adds a capturing group.
	 *
	 * @param {string} pattern
	 * @returns {RegExp}
	 */
	function createInline(pattern) {
		pattern = pattern.replace(/<inner>/g, function () { return inner; });
		return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
	}


	var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
	var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function () { return tableCell; });
	var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;


	Prism.languages.markdown = Prism.languages.extend('markup', {});
	Prism.languages.insertBefore('markdown', 'prolog', {
		'front-matter-block': {
			pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
			lookbehind: true,
			greedy: true,
			inside: {
				'punctuation': /^---|---$/,
				'front-matter': {
					pattern: /\S+(?:\s+\S+)*/,
					alias: ['yaml', 'language-yaml'],
					inside: Prism.languages.yaml
				}
			}
		},
		'blockquote': {
			// > ...
			pattern: /^>(?:[\t ]*>)*/m,
			alias: 'punctuation'
		},
		'table': {
			pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
			inside: {
				'table-data-rows': {
					pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
					lookbehind: true,
					inside: {
						'table-data': {
							pattern: RegExp(tableCell),
							inside: Prism.languages.markdown
						},
						'punctuation': /\|/
					}
				},
				'table-line': {
					pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
					lookbehind: true,
					inside: {
						'punctuation': /\||:?-{3,}:?/
					}
				},
				'table-header-row': {
					pattern: RegExp('^' + tableRow + '$'),
					inside: {
						'table-header': {
							pattern: RegExp(tableCell),
							alias: 'important',
							inside: Prism.languages.markdown
						},
						'punctuation': /\|/
					}
				}
			}
		},
		'code': [
			{
				// Prefixed by 4 spaces or 1 tab and preceded by an empty line
				pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
				lookbehind: true,
				alias: 'keyword'
			},
			{
				// ```optional language
				// code block
				// ```
				pattern: /^```[\s\S]*?^```$/m,
				greedy: true,
				inside: {
					'code-block': {
						pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
						lookbehind: true
					},
					'code-language': {
						pattern: /^(```).+/,
						lookbehind: true
					},
					'punctuation': /```/
				}
			}
		],
		'title': [
			{
				// title 1
				// =======

				// title 2
				// -------
				pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
				alias: 'important',
				inside: {
					punctuation: /==+$|--+$/
				}
			},
			{
				// # title 1
				// ###### title 6
				pattern: /(^\s*)#.+/m,
				lookbehind: true,
				alias: 'important',
				inside: {
					punctuation: /^#+|#+$/
				}
			}
		],
		'hr': {
			// ***
			// ---
			// * * *
			// -----------
			pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
			lookbehind: true,
			alias: 'punctuation'
		},
		'list': {
			// * item
			// + item
			// - item
			// 1. item
			pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
			lookbehind: true,
			alias: 'punctuation'
		},
		'url-reference': {
			// [id]: http://example.com "Optional title"
			// [id]: http://example.com 'Optional title'
			// [id]: http://example.com (Optional title)
			// [id]: <http://example.com> "Optional title"
			pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
			inside: {
				'variable': {
					pattern: /^(!?\[)[^\]]+/,
					lookbehind: true
				},
				'string': /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
				'punctuation': /^[\[\]!:]|[<>]/
			},
			alias: 'url'
		},
		'bold': {
			// **strong**
			// __strong__

			// allow one nested instance of italic text using the same delimiter
			pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^..)[\s\S]+(?=..$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /\*\*|__/
			}
		},
		'italic': {
			// *em*
			// _em_

			// allow one nested instance of bold text using the same delimiter
			pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^.)[\s\S]+(?=.$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /[*_]/
			}
		},
		'strike': {
			// ~~strike through~~
			// ~strike~
			// eslint-disable-next-line regexp/strict
			pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^~~?)[\s\S]+(?=\1$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /~~?/
			}
		},
		'code-snippet': {
			// `code`
			// ``code``
			pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
			lookbehind: true,
			greedy: true,
			alias: ['code', 'keyword']
		},
		'url': {
			// [example](http://example.com "Optional title")
			// [example][id]
			// [example] [id]
			pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'operator': /^!/,
				'content': {
					pattern: /(^\[)[^\]]+(?=\])/,
					lookbehind: true,
					inside: {} // see below
				},
				'variable': {
					pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
					lookbehind: true
				},
				'url': {
					pattern: /(^\]\()[^\s)]+/,
					lookbehind: true
				},
				'string': {
					pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
					lookbehind: true
				}
			}
		}
	});

	['url', 'bold', 'italic', 'strike'].forEach(function (token) {
		['url', 'bold', 'italic', 'strike', 'code-snippet'].forEach(function (inside) {
			if (token !== inside) {
				Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
			}
		});
	});

	Prism.hooks.add('after-tokenize', function (env) {
		if (env.language !== 'markdown' && env.language !== 'md') {
			return;
		}

		function walkTokens(tokens) {
			if (!tokens || typeof tokens === 'string') {
				return;
			}

			for (var i = 0, l = tokens.length; i < l; i++) {
				var token = tokens[i];

				if (token.type !== 'code') {
					walkTokens(token.content);
					continue;
				}

				/*
				 * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
				 * is optional. But the grammar is defined so that there is only one case we have to handle:
				 *
				 * token.content = [
				 *     <span class="punctuation">```</span>,
				 *     <span class="code-language">xxxx</span>,
				 *     '\n', // exactly one new lines (\r or \n or \r\n)
				 *     <span class="code-block">...</span>,
				 *     '\n', // exactly one new lines again
				 *     <span class="punctuation">```</span>
				 * ];
				 */

				var codeLang = token.content[1];
				var codeBlock = token.content[3];

				if (codeLang && codeBlock &&
					codeLang.type === 'code-language' && codeBlock.type === 'code-block' &&
					typeof codeLang.content === 'string') {

					// this might be a language that Prism does not support

					// do some replacements to support C++, C#, and F#
					var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp');
					// only use the first word
					lang = (/[a-z][\w-]*/i.exec(lang) || [''])[0].toLowerCase();
					var alias = 'language-' + lang;

					// add alias
					if (!codeBlock.alias) {
						codeBlock.alias = [alias];
					} else if (typeof codeBlock.alias === 'string') {
						codeBlock.alias = [codeBlock.alias, alias];
					} else {
						codeBlock.alias.push(alias);
					}
				}
			}
		}

		walkTokens(env.tokens);
	});

	Prism.hooks.add('wrap', function (env) {
		if (env.type !== 'code-block') {
			return;
		}

		var codeLang = '';
		for (var i = 0, l = env.classes.length; i < l; i++) {
			var cls = env.classes[i];
			var match = /language-(.+)/.exec(cls);
			if (match) {
				codeLang = match[1];
				break;
			}
		}

		var grammar = Prism.languages[codeLang];

		if (!grammar) {
			if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
				var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
				env.attributes['id'] = id;

				Prism.plugins.autoloader.loadLanguages(codeLang, function () {
					var ele = document.getElementById(id);
					if (ele) {
						ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
					}
				});
			}
		} else {
			env.content = Prism.highlight(textContent(env.content), grammar, codeLang);
		}
	});

	var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');

	/**
	 * A list of known entity names.
	 *
	 * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
	 *
	 * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
	 */
	var KNOWN_ENTITY_NAMES = {
		'amp': '&',
		'lt': '<',
		'gt': '>',
		'quot': '"',
	};

	// IE 11 doesn't support `String.fromCodePoint`
	var fromCodePoint = String.fromCodePoint || String.fromCharCode;

	/**
	 * Returns the text content of a given HTML source code string.
	 *
	 * @param {string} html
	 * @returns {string}
	 */
	function textContent(html) {
		// remove all tags
		var text = html.replace(tagPattern, '');

		// decode known entities
		text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function (m, code) {
			code = code.toLowerCase();

			if (code[0] === '#') {
				var value;
				if (code[1] === 'x') {
					value = parseInt(code.slice(2), 16);
				} else {
					value = Number(code.slice(1));
				}

				return fromCodePoint(value);
			} else {
				var known = KNOWN_ENTITY_NAMES[code];
				if (known) {
					return known;
				}

				// unable to decode
				return m;
			}
		});

		return text;
	}

	Prism.languages.md = Prism.languages.markdown;

}(Prism));


/***/ }),

/***/ 24335:
/***/ (function() {

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						{
							pattern: /^(\s*)["']|["']$/,
							lookbehind: true
						}
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;


/***/ }),

/***/ 11426:
/***/ (function() {

Prism.languages.objectivec = Prism.languages.extend('c', {
	'string': {
		pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
		greedy: true
	},
	'keyword': /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
	'operator': /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});

delete Prism.languages.objectivec['class-name'];

Prism.languages.objc = Prism.languages.objectivec;


/***/ }),

/***/ 80366:
/***/ (function() {

Prism.languages.python = {
	'comment': {
		pattern: /(^|[^\\])#.*/,
		lookbehind: true,
		greedy: true
	},
	'string-interpolation': {
		pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
		greedy: true,
		inside: {
			'interpolation': {
				// "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
				pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
				lookbehind: true,
				inside: {
					'format-spec': {
						pattern: /(:)[^:(){}]+(?=\}$)/,
						lookbehind: true
					},
					'conversion-option': {
						pattern: /![sra](?=[:}]$)/,
						alias: 'punctuation'
					},
					rest: null
				}
			},
			'string': /[\s\S]+/
		}
	},
	'triple-quoted-string': {
		pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
		greedy: true,
		alias: 'string'
	},
	'string': {
		pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
		greedy: true
	},
	'function': {
		pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
		lookbehind: true
	},
	'class-name': {
		pattern: /(\bclass\s+)\w+/i,
		lookbehind: true
	},
	'decorator': {
		pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
		lookbehind: true,
		alias: ['annotation', 'punctuation'],
		inside: {
			'punctuation': /\./
		}
	},
	'keyword': /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
	'builtin': /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
	'boolean': /\b(?:False|None|True)\b/,
	'number': /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
	'operator': /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
	'punctuation': /[{}[\];(),.:]/
};

Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;

Prism.languages.py = Prism.languages.python;


/***/ }),

/***/ 70767:
/***/ (function() {

(function (Prism) {

	var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
	for (var i = 0; i < 2; i++) {
		// support 4 levels of nested comments
		multilineComment = multilineComment.replace(/<self>/g, function () { return multilineComment; });
	}
	multilineComment = multilineComment.replace(/<self>/g, function () { return /[^\s\S]/.source; });


	Prism.languages.rust = {
		'comment': [
			{
				pattern: RegExp(/(^|[^\\])/.source + multilineComment),
				lookbehind: true,
				greedy: true
			},
			{
				pattern: /(^|[^\\:])\/\/.*/,
				lookbehind: true,
				greedy: true
			}
		],
		'string': {
			pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
			greedy: true
		},
		'char': {
			pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
			greedy: true
		},
		'attribute': {
			pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
			greedy: true,
			alias: 'attr-name',
			inside: {
				'string': null // see below
			}
		},

		// Closure params should not be confused with bitwise OR |
		'closure-params': {
			pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
			lookbehind: true,
			greedy: true,
			inside: {
				'closure-punctuation': {
					pattern: /^\||\|$/,
					alias: 'punctuation'
				},
				rest: null // see below
			}
		},

		'lifetime-annotation': {
			pattern: /'\w+/,
			alias: 'symbol'
		},

		'fragment-specifier': {
			pattern: /(\$\w+:)[a-z]+/,
			lookbehind: true,
			alias: 'punctuation'
		},
		'variable': /\$\w+/,

		'function-definition': {
			pattern: /(\bfn\s+)\w+/,
			lookbehind: true,
			alias: 'function'
		},
		'type-definition': {
			pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
			lookbehind: true,
			alias: 'class-name'
		},
		'module-declaration': [
			{
				pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
				lookbehind: true,
				alias: 'namespace'
			},
			{
				pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
				lookbehind: true,
				alias: 'namespace',
				inside: {
					'punctuation': /::/
				}
			}
		],
		'keyword': [
			// https://github.com/rust-lang/reference/blob/master/src/keywords.md
			/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
			// primitives and str
			// https://doc.rust-lang.org/stable/rust-by-example/primitives.html
			/\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
		],

		// functions can technically start with an upper-case letter, but this will introduce a lot of false positives
		// and Rust's naming conventions recommend snake_case anyway.
		// https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
		'function': /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
		'macro': {
			pattern: /\b\w+!/,
			alias: 'property'
		},
		'constant': /\b[A-Z_][A-Z_\d]+\b/,
		'class-name': /\b[A-Z]\w*\b/,

		'namespace': {
			pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
			inside: {
				'punctuation': /::/
			}
		},

		// Hex, oct, bin, dec numbers with visual separators and type suffix
		'number': /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
		'boolean': /\b(?:false|true)\b/,
		'punctuation': /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
		'operator': /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
	};

	Prism.languages.rust['closure-params'].inside.rest = Prism.languages.rust;
	Prism.languages.rust['attribute'].inside['string'] = Prism.languages.rust['string'];

}(Prism));


/***/ }),

/***/ 35266:
/***/ (function() {

Prism.languages.sql = {
	'comment': {
		pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
		lookbehind: true
	},
	'variable': [
		{
			pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
			greedy: true
		},
		/@[\w.$]+/
	],
	'string': {
		pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
		greedy: true,
		lookbehind: true
	},
	'identifier': {
		pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
		greedy: true,
		lookbehind: true,
		inside: {
			'punctuation': /^`|`$/
		}
	},
	'function': /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, // Should we highlight user defined functions too?
	'keyword': /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
	'boolean': /\b(?:FALSE|NULL|TRUE)\b/i,
	'number': /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
	'operator': /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
	'punctuation': /[;[\]()`,.]/
};


/***/ }),

/***/ 90874:
/***/ (function() {

Prism.languages.swift = {
	'comment': {
		// Nested comments are supported up to 2 levels
		pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
		lookbehind: true,
		greedy: true
	},
	'string-literal': [
		// https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
		{
			pattern: RegExp(
				/(^|[^"#])/.source
				+ '(?:'
				// single-line string
				+ /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source
				+ '|'
				// multi-line string
				+ /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source
				+ ')'
				+ /(?!["#])/.source
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
					lookbehind: true,
					inside: null // see below
				},
				'interpolation-punctuation': {
					pattern: /^\)|\\\($/,
					alias: 'punctuation'
				},
				'punctuation': /\\(?=[\r\n])/,
				'string': /[\s\S]+/
			}
		},
		{
			pattern: RegExp(
				/(^|[^"#])(#+)/.source
				+ '(?:'
				// single-line string
				+ /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source
				+ '|'
				// multi-line string
				+ /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source
				+ ')'
				+ '\\2'
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
					lookbehind: true,
					inside: null // see below
				},
				'interpolation-punctuation': {
					pattern: /^\)|\\#+\($/,
					alias: 'punctuation'
				},
				'string': /[\s\S]+/
			}
		},
	],

	'directive': {
		// directives with conditions
		pattern: RegExp(
			/#/.source
			+ '(?:'
			+ (
				/(?:elseif|if)\b/.source
				+ '(?:[ \t]*'
				// This regex is a little complex. It's equivalent to this:
				//   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
				// where <round> is a general parentheses expression.
				+ /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source
				+ ')+'
			)
			+ '|'
			+ /(?:else|endif)\b/.source
			+ ')'
		),
		alias: 'property',
		inside: {
			'directive-name': /^#\w+/,
			'boolean': /\b(?:false|true)\b/,
			'number': /\b\d+(?:\.\d+)*\b/,
			'operator': /!|&&|\|\||[<>]=?/,
			'punctuation': /[(),]/
		}
	},
	'literal': {
		pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
		alias: 'constant'
	},
	'other-directive': {
		pattern: /#\w+\b/,
		alias: 'property'
	},

	'attribute': {
		pattern: /@\w+/,
		alias: 'atrule'
	},

	'function-definition': {
		pattern: /(\bfunc\s+)\w+/,
		lookbehind: true,
		alias: 'function'
	},
	'label': {
		// https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
		pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
		lookbehind: true,
		alias: 'important'
	},

	'keyword': /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
	'boolean': /\b(?:false|true)\b/,
	'nil': {
		pattern: /\bnil\b/,
		alias: 'constant'
	},

	'short-argument': /\$\d+\b/,
	'omit': {
		pattern: /\b_\b/,
		alias: 'keyword'
	},
	'number': /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,

	// A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
	'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
	'function': /\b[a-z_]\w*(?=\s*\()/i,
	'constant': /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,

	// Operators are generic in Swift. Developers can even create new operators (e.g. +++).
	// https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
	// This regex only supports ASCII operators.
	'operator': /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
	'punctuation': /[{}[\]();,.:\\]/
};

Prism.languages.swift['string-literal'].forEach(function (rule) {
	rule.inside['interpolation'].inside = Prism.languages.swift;
});


/***/ }),

/***/ 96836:
/***/ (function() {

(function (Prism) {

	Prism.languages.typescript = Prism.languages.extend('javascript', {
		'class-name': {
			pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
			lookbehind: true,
			greedy: true,
			inside: null // see below
		},
		'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/,
	});

	// The keywords TypeScript adds to JavaScript
	Prism.languages.typescript.keyword.push(
		/\b(?:abstract|declare|is|keyof|readonly|require)\b/,
		// keywords that have to be followed by an identifier
		/\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
		// This is for `import type *, {}`
		/\btype\b(?=\s*(?:[\{*]|$))/
	);

	// doesn't work with TS because TS is too complex
	delete Prism.languages.typescript['parameter'];
	delete Prism.languages.typescript['literal-property'];

	// a version of typescript specifically for highlighting types
	var typeInside = Prism.languages.extend('typescript', {});
	delete typeInside['class-name'];

	Prism.languages.typescript['class-name'].inside = typeInside;

	Prism.languages.insertBefore('typescript', 'function', {
		'decorator': {
			pattern: /@[$\w\xA0-\uFFFF]+/,
			inside: {
				'at': {
					pattern: /^@/,
					alias: 'operator'
				},
				'function': /^[\s\S]+/
			}
		},
		'generic-function': {
			// e.g. foo<T extends "bar" | "baz">( ...
			pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
			greedy: true,
			inside: {
				'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
				'generic': {
					pattern: /<[\s\S]+/, // everything after the first <
					alias: 'class-name',
					inside: typeInside
				}
			}
		}
	});

	Prism.languages.ts = Prism.languages.typescript;

}(Prism));


/***/ }),

/***/ 15660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* **********************************************
     Begin prism-core.js
********************************************** */

/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if ( true && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof __webpack_require__.g !== 'undefined') {
	__webpack_require__.g.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */


/* **********************************************
     Begin prism-markup.js
********************************************** */

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						{
							pattern: /^(\s*)["']|["']$/,
							lookbehind: true
						}
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;


/* **********************************************
     Begin prism-css.js
********************************************** */

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));


/* **********************************************
     Begin prism-clike.js
********************************************** */

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/* **********************************************
     Begin prism-javascript.js
********************************************** */

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/* **********************************************
     Begin prism-file-highlight.js
********************************************** */

(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	var LOADING_MESSAGE = 'Loading…';
	var FAILURE_MESSAGE = function (status, message) {
		return '✖ Error ' + status + ' while fetching file: ' + message;
	};
	var FAILURE_EMPTY_MESSAGE = '✖ Error: File does not exist or is empty';

	var EXTENSIONS = {
		'js': 'javascript',
		'py': 'python',
		'rb': 'ruby',
		'ps1': 'powershell',
		'psm1': 'powershell',
		'sh': 'bash',
		'bat': 'batch',
		'h': 'c',
		'tex': 'latex'
	};

	var STATUS_ATTR = 'data-src-status';
	var STATUS_LOADING = 'loading';
	var STATUS_LOADED = 'loaded';
	var STATUS_FAILED = 'failed';

	var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])'
		+ ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';

	/**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */
	function loadFile(src, success, error) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', src, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4) {
				if (xhr.status < 400 && xhr.responseText) {
					success(xhr.responseText);
				} else {
					if (xhr.status >= 400) {
						error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
					} else {
						error(FAILURE_EMPTY_MESSAGE);
					}
				}
			}
		};
		xhr.send(null);
	}

	/**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */
	function parseRange(range) {
		var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
		if (m) {
			var start = Number(m[1]);
			var comma = m[2];
			var end = m[3];

			if (!comma) {
				return [start, start];
			}
			if (!end) {
				return [start, undefined];
			}
			return [start, Number(end)];
		}
		return undefined;
	}

	Prism.hooks.add('before-highlightall', function (env) {
		env.selector += ', ' + SELECTOR;
	});

	Prism.hooks.add('before-sanity-check', function (env) {
		var pre = /** @type {HTMLPreElement} */ (env.element);
		if (pre.matches(SELECTOR)) {
			env.code = ''; // fast-path the whole thing and go to complete

			pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading

			// add code element with loading message
			var code = pre.appendChild(document.createElement('CODE'));
			code.textContent = LOADING_MESSAGE;

			var src = pre.getAttribute('data-src');

			var language = env.language;
			if (language === 'none') {
				// the language might be 'none' because there is no language set;
				// in this case, we want to use the extension as the language
				var extension = (/\.(\w+)$/.exec(src) || [, 'none'])[1];
				language = EXTENSIONS[extension] || extension;
			}

			// set language classes
			Prism.util.setLanguage(code, language);
			Prism.util.setLanguage(pre, language);

			// preload the language
			var autoloader = Prism.plugins.autoloader;
			if (autoloader) {
				autoloader.loadLanguages(language);
			}

			// load file
			loadFile(
				src,
				function (text) {
					// mark as loaded
					pre.setAttribute(STATUS_ATTR, STATUS_LOADED);

					// handle data-range
					var range = parseRange(pre.getAttribute('data-range'));
					if (range) {
						var lines = text.split(/\r\n?|\n/g);

						// the range is one-based and inclusive on both ends
						var start = range[0];
						var end = range[1] == null ? lines.length : range[1];

						if (start < 0) { start += lines.length; }
						start = Math.max(0, Math.min(start - 1, lines.length));
						if (end < 0) { end += lines.length; }
						end = Math.max(0, Math.min(end, lines.length));

						text = lines.slice(start, end).join('\n');

						// add data-start for line numbers
						if (!pre.hasAttribute('data-start')) {
							pre.setAttribute('data-start', String(start + 1));
						}
					}

					// highlight code
					code.textContent = text;
					Prism.highlightElement(code);
				},
				function (error) {
					// mark as failed
					pre.setAttribute(STATUS_ATTR, STATUS_FAILED);

					code.textContent = error;
				}
			);
		}
	});

	Prism.plugins.fileHighlight = {
		/**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */
		highlight: function highlight(container) {
			var elements = (container || document).querySelectorAll(SELECTOR);

			for (var i = 0, element; (element = elements[i++]);) {
				Prism.highlightElement(element);
			}
		}
	};

	var logged = false;
	/** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */
	Prism.fileHighlight = function () {
		if (!logged) {
			console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
			logged = true;
		}
		Prism.plugins.fileHighlight.highlight.apply(this, arguments);
	};

}());


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 69196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yh": function() { return /* binding */ Store; },
  "Kw": function() { return /* binding */ useStoreState; }
});

// UNUSED EXPORTS: EAsyncActionInjectType, EAsyncEndTags, EPostActionContext, InjectAsyncAction, InjectStoreState, PullstateContext, PullstateProvider, batch, createAsyncAction, createAsyncActionDirect, createPullstateCore, errorResult, registerInDevtools, setupBatch, successResult, update, useInstance, useLocalStore, useStores

// EXTERNAL MODULE: ./node_modules/fast-deep-equal/es6/index.js
var es6 = __webpack_require__(62991);
var es6_default = /*#__PURE__*/__webpack_require__.n(es6);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s,v){if( false&&0,r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function F(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.g&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.R,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=i[s];"string"!=typeof p&&"number"!=typeof p&&(p=""+p),0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},N:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.R,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.R,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.R=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=N(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.g&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,R:void 0,t:n,k:this,C:!1,g:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.R.set(n,!0),t.o.set(n,r),t.R.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.R.set(n,!1):r.R.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.R=new Map,i(n.t,(function(r){n.R.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=N(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{F:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){F(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?g(c):O(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = ((/* unused pure expression or super */ null && (fn)));
//# sourceMappingURL=immer.esm.js.map

;// CONCATENATED MODULE: ./node_modules/pullstate/dist/index.es.js
function useStoreState(store, getSubState, deps) {
    const updateRef = (0,react.useRef)({ state: undefined, initialized: false });
    if (!updateRef.current.initialized) {
        updateRef.current.state = getSubState ? getSubState(store.getRawState()) : store.getRawState();
        updateRef.current.initialized = true;
    }
    const [, setUpdateTrigger] = (0,react.useState)(0);
    (0,react.useEffect)(() => {
        const effectState = { shouldUpdate: true };
        function update() {
            if (effectState.shouldUpdate) {
                const nextSubState = getSubState
                    ? getSubState(store.getRawState())
                    : store.getRawState();
                if (!es6_default()(updateRef.current.state, nextSubState)) {
                    if (effectState.shouldUpdate) {
                        updateRef.current.state = nextSubState;
                        setUpdateTrigger((val) => val + 1);
                    }
                }
            }
        }
        store._addUpdateListener(update);
        update();
        return () => {
            effectState.shouldUpdate = false;
            store._removeUpdateListener(update);
        };
    }, deps !== null && deps !== void 0 ? deps : []);
    if (deps !== undefined) {
        const prevDeps = (0,react.useRef)(deps);
        if (!es6_default()(deps, prevDeps)) {
            updateRef.current.state = getSubState(store.getRawState());
        }
    }
    return updateRef.current.state;
}function useLocalStore(initialState, deps) {
    const storeRef = (0,react.useRef)();
    if (storeRef.current == null) {
        storeRef.current = new Store(initialState);
    }
    if (deps !== undefined) {
        const prevDeps = (0,react.useRef)(deps);
        if (!es6_default()(deps, prevDeps)) {
            storeRef.current = new Store(initialState);
        }
    }
    return storeRef.current;
}const globalClientState = {
    storeOrdinal: 0,
    batching: false,
    flushStores: {}
};T();
function makeSubscriptionFunction(store, watch, listener) {
    let lastWatchState = watch(store.getRawState());
    return () => {
        const currentState = store.getRawState();
        const nextWatchState = watch(currentState);
        if (!es6_default()(nextWatchState, lastWatchState)) {
            listener(nextWatchState, currentState, lastWatchState);
            lastWatchState = nextWatchState;
        }
    };
}
function makeReactionFunctionCreator(watch, reaction) {
    return (store) => {
        let lastWatchState = watch(store.getRawState());
        return (forceRun = false) => {
            const currentState = store.getRawState();
            const nextWatchState = watch(currentState);
            if (forceRun || !es6_default()(nextWatchState, lastWatchState)) {
                if (store._optListenerCount > 0) {
                    const [nextState, patches, inversePatches] = cn(currentState, (s) => reaction(nextWatchState, s, currentState, lastWatchState));
                    store._updateStateWithoutReaction(nextState);
                    lastWatchState = nextWatchState;
                    if (patches.length > 0) {
                        store._patchListeners.forEach((listener) => listener(patches, inversePatches));
                        return Object.keys(getChangedPathsFromPatches(patches));
                    }
                }
                else {
                    if (store._patchListeners.length > 0) {
                        const [nextState, patches, inversePatches] = cn(currentState, (s) => reaction(nextWatchState, s, currentState, lastWatchState));
                        if (patches.length > 0) {
                            store._patchListeners.forEach((listener) => listener(patches, inversePatches));
                        }
                        store._updateStateWithoutReaction(nextState);
                    }
                    else {
                        store._updateStateWithoutReaction(fn(currentState, (s) => reaction(nextWatchState, s, currentState, lastWatchState)));
                    }
                    lastWatchState = nextWatchState;
                }
            }
            return [];
        };
    };
}
const optPathDivider = "~._.~";
class Store {
    constructor(initialState) {
        this.updateListeners = [];
        this.ssr = false;
        this.reactions = [];
        this.clientSubscriptions = [];
        this.reactionCreators = [];
        this.optimizedUpdateListeners = {};
        this.optimizedUpdateListenerPaths = {};
        this.optimizedListenerPropertyMap = {};
        this._optListenerCount = 0;
        this._patchListeners = [];
        if (initialState instanceof Function) {
            const state = initialState();
            this.currentState = state;
            this.initialState = state;
            this.createInitialState = initialState;
        }
        else {
            this.currentState = initialState;
            this.initialState = initialState;
            this.createInitialState = () => initialState;
        }
        this.internalOrdId = globalClientState.storeOrdinal++;
    }
    _setInternalOptions({ ssr, reactionCreators = [] }) {
        this.ssr = ssr;
        this.reactionCreators = reactionCreators;
        this.reactions = reactionCreators.map((rc) => rc(this));
    }
    _getReactionCreators() {
        return this.reactionCreators;
    }
    _instantiateReactions() {
        this.reactions = this.reactionCreators.map((rc) => rc(this));
    }
    _getInitialState() {
        return this.createInitialState();
    }
    _updateStateWithoutReaction(nextState) {
        this.currentState = nextState;
    }
    _updateState(nextState, updateKeyedPaths = []) {
        this.currentState = nextState;
        this.batchState = undefined;
        for (const runReaction of this.reactions) {
            updateKeyedPaths.push(...runReaction());
        }
        if (!this.ssr) {
            for (const runSubscription of this.clientSubscriptions) {
                runSubscription();
            }
            if (updateKeyedPaths.length > 0) {
                const updateOrds = new Set();
                for (const keyedPath of updateKeyedPaths) {
                    if (this.optimizedListenerPropertyMap[keyedPath]) {
                        for (const ord of this.optimizedListenerPropertyMap[keyedPath]) {
                            updateOrds.add(ord);
                        }
                    }
                }
                for (const ord of updateOrds.values()) {
                    if (this.optimizedUpdateListeners[ord]) {
                        this.optimizedUpdateListeners[ord]();
                    }
                }
            }
            this.updateListeners.forEach((listener) => listener());
        }
    }
    _addUpdateListener(listener) {
        this.updateListeners.push(listener);
    }
    _removeUpdateListener(listener) {
        this.updateListeners = this.updateListeners.filter((f) => f !== listener);
    }
    _removeUpdateListenerOpt(ordKey) {
        const listenerPathsKeyed = this.optimizedUpdateListenerPaths[ordKey];
        for (const keyedPath of listenerPathsKeyed) {
            this.optimizedListenerPropertyMap[keyedPath] = this.optimizedListenerPropertyMap[keyedPath].filter((ord) => ord !== ordKey);
        }
        delete this.optimizedUpdateListenerPaths[ordKey];
        delete this.optimizedUpdateListeners[ordKey];
        this._optListenerCount--;
    }
    listenToPatches(patchListener) {
        this._patchListeners.push(patchListener);
        return () => {
            this._patchListeners = this._patchListeners.filter((f) => f !== patchListener);
        };
    }
    subscribe(watch, listener) {
        if (!this.ssr) {
            const func = makeSubscriptionFunction(this, watch, listener);
            this.clientSubscriptions.push(func);
            return () => {
                this.clientSubscriptions = this.clientSubscriptions.filter((f) => f !== func);
            };
        }
        return () => {
            console.warn(`Pullstate: Subscriptions made on the server side are not registered - so therefor this call to unsubscribe does nothing.`);
        };
    }
    createReaction(watch, reaction, { runNow = false, runNowWithSideEffects = false } = {}) {
        const creator = makeReactionFunctionCreator(watch, reaction);
        this.reactionCreators.push(creator);
        const func = creator(this);
        this.reactions.push(func);
        if (runNow || runNowWithSideEffects) {
            func(true);
            if (runNowWithSideEffects && !this.ssr) {
                this._updateState(this.currentState);
            }
        }
        return () => {
            this.reactions = this.reactions.filter((f) => f !== func);
        };
    }
    getRawState() {
        if (this.batchState !== undefined) {
            return this.batchState;
        }
        else {
            return this.currentState;
        }
    }
    useState(getSubState, deps) {
        return useStoreState(this, getSubState, deps);
    }
    useLocalCopyInitial(deps) {
        return useLocalStore(this.createInitialState, deps);
    }
    useLocalCopySnapshot(deps) {
        return useLocalStore(this.currentState, deps);
    }
    flushBatch(ignoreError = false) {
        if (this.batchState !== undefined) {
            if (this.batchState !== this.currentState) {
                this._updateState(this.batchState);
            }
        }
        else if (!ignoreError) {
            console.error(`Pullstate: Trying to flush batch state which was never created or updated on`);
        }
        this.batchState = undefined;
    }
    update(updater, patchesCallback) {
        if (globalClientState.batching) {
            if (this.batchState === undefined) {
                this.batchState = this.currentState;
                globalClientState.flushStores[this.internalOrdId] = this;
            }
            const func = typeof updater === "function";
            const [nextState, patches, inversePatches] = runUpdates(this.batchState, updater, func);
            if (patches.length > 0 && (this._patchListeners.length > 0 || patchesCallback)) {
                if (patchesCallback) {
                    patchesCallback(patches, inversePatches);
                }
                this._patchListeners.forEach((listener) => listener(patches, inversePatches));
            }
            this.batchState = nextState;
        }
        else {
            this.batchState = undefined;
            update(this, updater, patchesCallback);
        }
    }
    replace(newState) {
        this._updateState(newState);
    }
    replaceFromCurrent(replacer) {
        this._updateState(replacer(this.currentState));
    }
    applyPatches(patches) {
        applyPatchesToStore(this, patches);
    }
}
function applyPatchesToStore(store, patches) {
    const currentState = store.getRawState();
    const nextState = pn(currentState, patches);
    if (nextState !== currentState) {
        store._updateState(nextState, Object.keys(getChangedPathsFromPatches(patches)));
    }
}
function getChangedPathsFromPatches(changePatches, prev = {}) {
    for (const patch of changePatches) {
        let curKey;
        for (const p of patch.path) {
            if (curKey) {
                curKey = `${curKey}${optPathDivider}${p}`;
            }
            else {
                curKey = p;
            }
            prev[curKey] = 1;
        }
    }
    return prev;
}
function runUpdates(currentState, updater, func) {
    return func
        ? cn(currentState, (s) => updater(s, currentState))
        : updater.reduce(([nextState, patches, inversePatches], currentValue) => {
            const resp = cn(nextState, (s) => currentValue(s, nextState));
            patches.push(...resp[1]);
            inversePatches.push(...resp[2]);
            return [resp[0], patches, inversePatches];
        }, [currentState, [], []]);
}
function update(store, updater, patchesCallback) {
    const currentState = store.getRawState();
    const func = typeof updater === "function";
    if (store._optListenerCount > 0) {
        const [nextState, patches, inversePatches] = runUpdates(currentState, updater, func);
        if (patches.length > 0) {
            if (patchesCallback) {
                patchesCallback(patches, inversePatches);
            }
            store._patchListeners.forEach((listener) => listener(patches, inversePatches));
            store._updateState(nextState, Object.keys(getChangedPathsFromPatches(patches)));
        }
    }
    else {
        let nextState;
        if (store._patchListeners.length > 0 || patchesCallback) {
            const [ns, patches, inversePatches] = runUpdates(currentState, updater, func);
            if (patches.length > 0) {
                if (patchesCallback) {
                    patchesCallback(patches, inversePatches);
                }
                store._patchListeners.forEach((listener) => listener(patches, inversePatches));
            }
            nextState = ns;
        }
        else {
            nextState = fn(currentState, (s) => func
                ? updater(s, currentState)
                : updater.reduce((previousValue, currentUpdater) => {
                    return fn(previousValue, (s) => currentUpdater(s, previousValue));
                }, currentState));
        }
        if (nextState !== currentState) {
            store._updateState(nextState);
        }
    }
}function InjectStoreState({ store, on = s => s, children, }) {
    const state = useStoreState(store, on);
    return children(state);
}var EAsyncEndTags;
(function (EAsyncEndTags) {
    EAsyncEndTags["THREW_ERROR"] = "THREW_ERROR";
    EAsyncEndTags["RETURNED_ERROR"] = "RETURNED_ERROR";
    EAsyncEndTags["UNFINISHED"] = "UNFINISHED";
    EAsyncEndTags["DORMANT"] = "DORMANT";
})(EAsyncEndTags || (EAsyncEndTags = {}));
var EPostActionContext;
(function (EPostActionContext) {
    EPostActionContext["WATCH_HIT_CACHE"] = "WATCH_HIT_CACHE";
    EPostActionContext["BECKON_HIT_CACHE"] = "BECKON_HIT_CACHE";
    EPostActionContext["RUN_HIT_CACHE"] = "RUN_HIT_CACHE";
    EPostActionContext["READ_HIT_CACHE"] = "READ_HIT_CACHE";
    EPostActionContext["READ_RUN"] = "READ_RUN";
    EPostActionContext["SHORT_CIRCUIT"] = "SHORT_CIRCUIT";
    EPostActionContext["DIRECT_RUN"] = "DIRECT_RUN";
    EPostActionContext["BECKON_RUN"] = "BECKON_RUN";
    EPostActionContext["CACHE_UPDATE"] = "CACHE_UPDATE";
})(EPostActionContext || (EPostActionContext = {}));const clientAsyncCache = {
    listeners: {},
    results: {},
    actions: {},
    actionOrd: {}
};
let asyncCreationOrdinal = 0;
function keyFromObject(json) {
    if (json === null) {
        return "(n)";
    }
    const typeOf = typeof json;
    if (typeOf !== "object") {
        if (typeOf === "undefined") {
            return "(u)";
        }
        else if (typeOf === "string") {
            return ":" + json + ";";
        }
        else if (typeOf === "boolean" || typeOf === "number") {
            return "(" + json + ")";
        }
    }
    let prefix = "{";
    for (const key of Object.keys(json).sort()) {
        prefix += key + keyFromObject(json[key]);
    }
    return prefix + "}";
}
function notifyListeners(key) {
    if (clientAsyncCache.listeners.hasOwnProperty(key)) {
        for (const watchId of Object.keys(clientAsyncCache.listeners[key])) {
            clientAsyncCache.listeners[key][watchId]();
        }
    }
}
function clearActionCache(key, clearPending = true, notify = true) {
    if (clearPending && clientAsyncCache.actionOrd.hasOwnProperty(key)) {
        clientAsyncCache.actionOrd[key] += 1;
    }
    delete clientAsyncCache.results[key];
    if (notify) {
        notifyListeners(key);
    }
}
function actionOrdUpdate(cache, key) {
    if (!cache.actionOrd.hasOwnProperty(key)) {
        cache.actionOrd[key] = 0;
    }
    else {
        cache.actionOrd[key] += 1;
    }
    return cache.actionOrd[key];
}
function successResult(payload = null, tags = [], message = "") {
    return {
        payload,
        tags,
        message,
        error: false,
        errorPayload: null
    };
}
function errorResult(tags = [], message = "", errorPayload) {
    return {
        payload: null,
        tags: [EAsyncEndTags.RETURNED_ERROR, ...tags],
        message,
        error: true,
        errorPayload: errorPayload
    };
}
class PullstateAsyncError extends Error {
    constructor(message, tags) {
        super(message);
        this.tags = tags;
    }
}
let storeErrorProxy;
try {
    storeErrorProxy = new Proxy({}, {
        get: function (obj, prop) {
            throw new Error(`Pullstate: Trying to access store (${String(prop)}) inside async actions without the correct usage or setup.
If this error occurred on the server:
* If using run(), make use of your created instance for this request: instance.runAsyncAction()
* If using read(), useWatch(), useBeckon() etc. - make sure you have properly set up your <PullstateProvider/>

If this error occurred on the client:
* Make sure you have created your "pullstateCore" object with all your stores, using createPullstateCore(), and are making use of instantiate() before rendering.`);
        }
    });
}
catch {
    storeErrorProxy = {};
}
const startedButUnfinishedResult = [
    true,
    false,
    {
        message: "",
        tags: [EAsyncEndTags.UNFINISHED],
        error: true,
        payload: null,
        errorPayload: null
    },
    false,
    -1
];
function createAsyncActionDirect(action, options = {}) {
    return createAsyncAction(async (args, stores, customContext) => {
        return successResult(await action(args, stores, customContext));
    }, options);
}
function convertCustomCacheBreakHook(cacheBreakHook) {
    if (cacheBreakHook != null) {
        if (typeof cacheBreakHook === "boolean") {
            return () => cacheBreakHook;
        }
        else if (typeof cacheBreakHook === "number") {
            return ({ timeCached, result }) => {
                if (!result.error) {
                    return Date.now() - timeCached > cacheBreakHook;
                }
                return true;
            };
        }
        return cacheBreakHook;
    }
    return undefined;
}
function createAsyncAction(action, { forceContext = false, shortCircuitHook, cacheBreakHook, postActionHook, subsetKey, actionId } = {}) {
    const ordinal = actionId != null ? `_${actionId}` : asyncCreationOrdinal++;
    const onServer = typeof window === "undefined";
    function _createKey(args, customKey) {
        if (customKey != null) {
            return `${ordinal}-c-${customKey}`;
        }
        if (subsetKey !== undefined) {
            return `${ordinal}-${keyFromObject(subsetKey(args))}`;
        }
        return `${ordinal}-${keyFromObject(args)}`;
    }
    const deferWaitingKey = `def_wait_${_createKey({})}`;
    let cacheBreakWatcher = {};
    let watchIdOrd = 0;
    const shouldUpdate = {};
    function runPostActionHook(result, args, stores, context) {
        if (postActionHook !== undefined) {
            postActionHook({ args, result, stores, context });
        }
    }
    function getCachedResult({ args, cache, cacheBreakEnabled, context, fromListener, key, postActionEnabled, stores, customCacheBreak }) {
        const useCacheBreakHook = customCacheBreak !== null && customCacheBreak !== void 0 ? customCacheBreak : cacheBreakHook;
        if (cache.results.hasOwnProperty(key)) {
            const cacheBreakLoop = cacheBreakWatcher.hasOwnProperty(key) && cacheBreakWatcher[key] > 2;
            if (!onServer &&
                !fromListener &&
                cacheBreakEnabled &&
                useCacheBreakHook != null
                && cache.results[key][1] &&
                useCacheBreakHook({
                    args,
                    result: cache.results[key][2],
                    stores,
                    timeCached: cache.results[key][4]
                }) &&
                !cacheBreakLoop) {
                if (cacheBreakWatcher.hasOwnProperty(key)) {
                    cacheBreakWatcher[key]++;
                }
                else {
                    cacheBreakWatcher[key] = 1;
                }
                const previous = cache.results[key];
                delete cache.results[key];
                return { cacheBroke: true, response: undefined, previous };
            }
            else {
                if (cacheBreakLoop) {
                    console.error(`[${key}] Pullstate detected an infinite loop caused by cacheBreakHook()
returning true too often (breaking cache as soon as your action is resolving - hence
causing beckoned actions to run the action again) in one of your AsyncActions - Pullstate prevented
further looping. Fix in your cacheBreakHook() is needed.`);
                }
                else {
                    cacheBreakWatcher[key] = 0;
                }
                if (postActionEnabled && cache.results[key][1] && !fromListener) {
                    runPostActionHook(cache.results[key][2], args, stores, context);
                }
                return {
                    response: cache.results[key],
                    cacheBroke: false,
                    previous: undefined
                };
            }
        }
        return { cacheBroke: false, response: undefined, previous: undefined };
    }
    function createInternalAction(key, cache, args, stores, currentActionOrd, postActionEnabled, executionContext, customContext) {
        return () => action(args, stores, customContext)
            .then((resp) => {
            if (currentActionOrd === cache.actionOrd[key]) {
                if (postActionEnabled) {
                    runPostActionHook(resp, args, stores, executionContext);
                }
                cache.results[key] = [true, true, resp, false, Date.now()];
            }
            return resp;
        })
            .catch((e) => {
            console.error(e);
            const result = {
                payload: null,
                errorPayload: null,
                error: true,
                tags: [EAsyncEndTags.THREW_ERROR],
                message: e.message
            };
            if (currentActionOrd === cache.actionOrd[key]) {
                if (postActionEnabled) {
                    runPostActionHook(result, args, stores, executionContext);
                }
                cache.results[key] = [true, true, result, false, Date.now()];
            }
            return result;
        })
            .then((resp) => {
            if (currentActionOrd === cache.actionOrd[key]) {
                delete cache.actions[key];
                if (!onServer) {
                    notifyListeners(key);
                }
            }
            return resp;
        });
    }
    function checkKeyAndReturnResponse({ key, cache, initiate, ssr, args, stores, fromListener = false, postActionEnabled = true, cacheBreakEnabled = true, holdingResult, customContext, customCacheBreak, holdPrevious }) {
        const cached = getCachedResult({
            key,
            cache,
            args,
            stores,
            context: initiate ? EPostActionContext.BECKON_HIT_CACHE : EPostActionContext.WATCH_HIT_CACHE,
            postActionEnabled,
            cacheBreakEnabled,
            fromListener,
            customCacheBreak
        });
        if (cached.response) {
            return cached.response;
        }
        if (!cache.actions.hasOwnProperty(key)) {
            const currentActionOrd = actionOrdUpdate(cache, key);
            if (initiate) {
                if (shortCircuitHook !== undefined) {
                    const shortCircuitResponse = shortCircuitHook({ args, stores });
                    if (shortCircuitResponse !== false) {
                        runPostActionHook(shortCircuitResponse, args, stores, EPostActionContext.SHORT_CIRCUIT);
                        cache.results[key] = [true, true, shortCircuitResponse, false, Date.now()];
                        return cache.results[key];
                    }
                }
                if (ssr || !onServer) {
                    cache.actions[key] = createInternalAction(key, cache, args, stores, currentActionOrd, postActionEnabled, EPostActionContext.BECKON_RUN, customContext);
                }
                if (!onServer) {
                    cache.actions[key]();
                    cache.results[key] = startedButUnfinishedResult;
                }
                else {
                    return startedButUnfinishedResult;
                }
            }
            else {
                const resp = [
                    false,
                    false,
                    {
                        message: "",
                        tags: [EAsyncEndTags.UNFINISHED],
                        error: true,
                        payload: null,
                        errorPayload: null
                    },
                    false,
                    -1
                ];
                if (!onServer) {
                    cache.results[key] = resp;
                }
                if (holdPrevious) {
                    if (holdingResult) {
                        const response = [...holdingResult];
                        response[3] = true;
                        return response;
                    }
                    if (cached.previous != null) {
                        const response = [...cached.previous];
                        response[3] = true;
                        return response;
                    }
                }
                return resp;
            }
        }
        if (holdPrevious) {
            if (holdingResult) {
                const response = [...holdingResult];
                response[3] = true;
                return response;
            }
            if (cached.previous != null) {
                const response = [...cached.previous];
                response[3] = true;
                return response;
            }
        }
        return startedButUnfinishedResult;
    }
    const read = (args = {}, { cacheBreakEnabled = true, postActionEnabled = true, key: customKey } = {}) => {
        const key = _createKey(args, customKey);
        const cache = onServer ? useContext(PullstateContext)._asyncCache : clientAsyncCache;
        let stores;
        let customContext;
        if (onServer || forceContext) {
            const pullstateContext = useContext(PullstateContext);
            stores = pullstateContext.stores;
            customContext = pullstateContext.customContext;
        }
        else if (clientStores.loaded) {
            stores = clientStores.stores;
        }
        else {
            stores = storeErrorProxy;
        }
        const cached = getCachedResult({
            key,
            cache,
            args,
            stores,
            context: EPostActionContext.READ_HIT_CACHE,
            postActionEnabled,
            cacheBreakEnabled,
            fromListener: false
        });
        if (cached.response) {
            if (!cached.response[2].error) {
                return cached.response[2].payload;
            }
            else {
                throw new PullstateAsyncError(cached.response[2].message, cached.response[2].tags);
            }
        }
        if (!cache.actions.hasOwnProperty(key)) {
            if (shortCircuitHook !== undefined) {
                const shortCircuitResponse = shortCircuitHook({ args, stores });
                if (shortCircuitResponse !== false) {
                    runPostActionHook(shortCircuitResponse, args, stores, EPostActionContext.SHORT_CIRCUIT);
                    cache.results[key] = [true, true, shortCircuitResponse, false, Date.now()];
                    if (!shortCircuitResponse.error) {
                        return shortCircuitResponse.payload;
                    }
                    else {
                        throw new PullstateAsyncError(shortCircuitResponse.message, shortCircuitResponse.tags);
                    }
                }
            }
            const currentActionOrd = actionOrdUpdate(cache, key);
            cache.actions[key] = createInternalAction(key, cache, args, stores, currentActionOrd, postActionEnabled, EPostActionContext.READ_RUN, customContext);
            if (onServer) {
                throw new Error(`Pullstate Async Action: action.read() : Resolve all async state for Suspense actions before Server-side render ( make use of instance.runAsyncAction() )`);
            }
            throw cache.actions[key]();
        }
        if (onServer) {
            throw new Error(`Pullstate Async Action: action.read() : Resolve all async state for Suspense actions before Server-side render ( make use of instance.runAsyncAction() )`);
        }
        const watchOrd = watchIdOrd++;
        throw new Promise((resolve) => {
            cache.listeners[key][watchOrd] = () => {
                delete cache.listeners[key][watchOrd];
                resolve();
            };
        });
    };
    const useWatch = (args = {}, { initiate = false, ssr = true, postActionEnabled = false, cacheBreakEnabled = false, holdPrevious = false, dormant = false, key: customKey, cacheBreak: customCacheBreakIncoming } = {}) => {
        const responseRef = useRef();
        const prevKeyRef = useRef(".");
        const key = dormant ? "." : _createKey(args, customKey);
        let watchId = useRef(-1);
        if (watchId.current === -1) {
            watchId.current = watchIdOrd++;
        }
        if (!dormant) {
            if (!shouldUpdate.hasOwnProperty(key)) {
                shouldUpdate[key] = {
                    [watchId.current]: true
                };
            }
            else {
                shouldUpdate[key][watchId.current] = true;
            }
        }
        const cache = onServer ? useContext(PullstateContext)._asyncCache : clientAsyncCache;
        let stores;
        let customContext;
        if (onServer || forceContext) {
            const pullstateContext = useContext(PullstateContext);
            stores = pullstateContext.stores;
            customContext = pullstateContext.customContext;
        }
        else if (clientStores.loaded) {
            stores = clientStores.stores;
        }
        else {
            stores = storeErrorProxy;
        }
        if (!onServer) {
            const onAsyncStateChanged = () => {
                if (shouldUpdate[key][watchId.current] && !isEqual(responseRef.current, cache.results[key])) {
                    const nextResponse = checkKeyAndReturnResponse({
                        key,
                        cache,
                        initiate,
                        ssr,
                        args,
                        stores,
                        fromListener: true,
                        postActionEnabled,
                        cacheBreakEnabled,
                        holdingResult: undefined,
                        customContext,
                        holdPrevious
                    });
                    if (holdPrevious && !nextResponse[1] && responseRef.current != null && responseRef.current[1]) {
                        responseRef.current = [...responseRef.current];
                        responseRef.current[3] = true;
                    }
                    else {
                        responseRef.current = nextResponse;
                    }
                    setWatchUpdate((prev) => {
                        return prev + 1;
                    });
                }
            };
            if (!dormant) {
                if (!cache.listeners.hasOwnProperty(key)) {
                    cache.listeners[key] = {};
                }
                cache.listeners[key][watchId.current] = onAsyncStateChanged;
                shouldUpdate[key][watchId.current] = true;
            }
            useEffect(() => {
                if (!dormant) {
                    cache.listeners[key][watchId.current] = onAsyncStateChanged;
                    shouldUpdate[key][watchId.current] = true;
                }
                return () => {
                    if (!dormant) {
                        delete cache.listeners[key][watchId.current];
                        shouldUpdate[key][watchId.current] = false;
                    }
                };
            }, [key]);
        }
        const [_, setWatchUpdate] = useState(0);
        if (dormant) {
            responseRef.current =
                holdPrevious && responseRef.current && responseRef.current[1]
                    ? responseRef.current
                    : [
                        false,
                        false,
                        {
                            message: "",
                            tags: [EAsyncEndTags.DORMANT],
                            error: true,
                            payload: null
                        },
                        false,
                        -1
                    ];
            prevKeyRef.current = ".";
        }
        else if (prevKeyRef.current !== key) {
            if (prevKeyRef.current !== null && shouldUpdate.hasOwnProperty(prevKeyRef.current)) {
                delete cache.listeners[prevKeyRef.current][watchId.current];
                shouldUpdate[prevKeyRef.current][watchId.current] = false;
            }
            prevKeyRef.current = key;
            responseRef.current = checkKeyAndReturnResponse({
                key,
                cache,
                initiate,
                ssr,
                args,
                stores,
                fromListener: false,
                postActionEnabled,
                cacheBreakEnabled,
                holdingResult: holdPrevious && responseRef.current && responseRef.current[1] ? responseRef.current : undefined,
                customContext,
                customCacheBreak: convertCustomCacheBreakHook(customCacheBreakIncoming),
                holdPrevious
            });
        }
        return responseRef.current;
    };
    const useBeckon = (args = {}, { ssr = true, postActionEnabled = true, cacheBreakEnabled = true, holdPrevious = false, dormant = false, key } = {}) => {
        const result = useWatch(args, {
            initiate: true,
            ssr,
            postActionEnabled,
            cacheBreakEnabled,
            holdPrevious,
            dormant,
            key
        });
        return [result[1], result[2], result[3]];
    };
    const run = async (args = {}, inputs = {}) => {
        const { treatAsUpdate = false, ignoreShortCircuit = false, respectCache = false, key: customKey, _asyncCache = clientAsyncCache, _stores = clientStores.loaded ? clientStores.stores : storeErrorProxy, _customContext, cacheBreak: customCacheBreak } = inputs;
        const key = _createKey(args, customKey);
        if (respectCache) {
            const cached = getCachedResult({
                key,
                cache: _asyncCache,
                args,
                stores: _stores,
                context: EPostActionContext.RUN_HIT_CACHE,
                postActionEnabled: true,
                cacheBreakEnabled: true,
                fromListener: false,
                customCacheBreak: convertCustomCacheBreakHook(customCacheBreak)
            });
            if (cached.response && cached.response[0]) {
                if (!cached.response[1]) {
                    const watchOrd = watchIdOrd++;
                    if (!_asyncCache.listeners.hasOwnProperty(key)) {
                        _asyncCache.listeners[key] = {};
                    }
                    return new Promise((resolve) => {
                        _asyncCache.listeners[key][watchOrd] = () => {
                            const [, finished, resp] = _asyncCache.results[key];
                            if (finished) {
                                delete _asyncCache.listeners[key][watchOrd];
                                resolve(resp);
                            }
                        };
                    });
                }
                return cached.response[2];
            }
        }
        if (!ignoreShortCircuit && shortCircuitHook !== undefined) {
            const shortCircuitResponse = shortCircuitHook({ args, stores: _stores });
            if (shortCircuitResponse !== false) {
                _asyncCache.results[key] = [true, true, shortCircuitResponse, false, Date.now()];
                runPostActionHook(shortCircuitResponse, args, _stores, EPostActionContext.SHORT_CIRCUIT);
                notifyListeners(key);
                return shortCircuitResponse;
            }
        }
        const [, prevFinished, prevResp, prevUpdate, prevCacheTime] = _asyncCache.results[key] || [
            false,
            false,
            {
                error: true,
                message: "",
                payload: null,
                tags: [EAsyncEndTags.UNFINISHED]
            },
            false,
            -1
        ];
        if (prevFinished && treatAsUpdate) {
            _asyncCache.results[key] = [true, true, prevResp, true, prevCacheTime];
        }
        else {
            _asyncCache.results[key] = [
                true,
                false,
                {
                    error: true,
                    message: "",
                    payload: null,
                    tags: [EAsyncEndTags.UNFINISHED]
                },
                false,
                -1
            ];
        }
        let currentActionOrd = actionOrdUpdate(_asyncCache, key);
        _asyncCache.actions[key] = createInternalAction(key, _asyncCache, args, _stores, currentActionOrd, true, EPostActionContext.DIRECT_RUN, _customContext);
        notifyListeners(key);
        return _asyncCache.actions[key]();
    };
    const clearCache = (args = {}, { key: customKey, notify = true } = {}) => {
        const key = _createKey(args, customKey);
        clearActionCache(key, true, notify);
    };
    const clearAllCache = ({ notify = true } = {}) => {
        for (const key of Object.keys(clientAsyncCache.actionOrd)) {
            if (key.startsWith(`${ordinal}-`)) {
                clearActionCache(key, true, notify);
            }
        }
    };
    const clearAllUnwatchedCache = ({ notify = true } = {}) => {
        for (const key of Object.keys(shouldUpdate)) {
            if (!Object.values(shouldUpdate[key]).some((su) => su)) {
                delete shouldUpdate[key];
                clearActionCache(key, false, notify);
            }
        }
    };
    const setCached = (args, result, options) => {
        const { notify = true, key: customKey } = options || {};
        const key = _createKey(args, customKey);
        const cache = onServer ? useContext(PullstateContext)._asyncCache : clientAsyncCache;
        cache.results[key] = [true, true, result, false, Date.now()];
        if (notify) {
            notifyListeners(key);
        }
    };
    const setCachedPayload = (args, payload, options) => {
        return setCached(args, successResult(payload), options);
    };
    const updateCached = (args, updater, options) => {
        const { notify = true, resetTimeCached = true, runPostActionHook: postAction = false, key: customKey } = options || {};
        const key = _createKey(args, customKey);
        const cache = onServer ? useContext(PullstateContext)._asyncCache : clientAsyncCache;
        if (cache.results.hasOwnProperty(key) && !cache.results[key][2].error) {
            const currentCached = cache.results[key][2].payload;
            const newResult = {
                payload: produce$1(currentCached, (s) => updater(s, currentCached)),
                error: false,
                message: cache.results[key][2].message,
                tags: cache.results[key][2].tags
            };
            if (postAction) {
                runPostActionHook(newResult, args, clientStores.loaded ? clientStores.stores : storeErrorProxy, EPostActionContext.CACHE_UPDATE);
            }
            cache.results[key] = [
                true,
                true,
                newResult,
                cache.results[key][3],
                resetTimeCached ? Date.now() : cache.results[key][4]
            ];
            if (notify) {
                notifyListeners(key);
            }
        }
    };
    const getCached = (args = {}, options) => {
        var _a;
        const { checkCacheBreak = false, key: customKey, cacheBreak: incomingCacheBreak } = options || {};
        const key = _createKey(args, customKey);
        let cacheBreakable = false;
        const cache = clientAsyncCache;
        if (cache.results.hasOwnProperty(key)) {
            const finalizedCacheBreakHook = (_a = convertCustomCacheBreakHook(incomingCacheBreak)) !== null && _a !== void 0 ? _a : cacheBreakHook;
            if (checkCacheBreak && finalizedCacheBreakHook !== undefined) {
                const stores = onServer
                    ? useContext(PullstateContext).stores
                    : clientStores.loaded
                        ? clientStores.stores
                        : storeErrorProxy;
                if (finalizedCacheBreakHook({
                    args,
                    result: cache.results[key][2],
                    stores,
                    timeCached: cache.results[key][4]
                })) {
                    cacheBreakable = true;
                }
            }
            const [started, finished, result, updating, timeCached] = cache.results[key];
            return {
                started,
                finished,
                result: result,
                existed: true,
                cacheBreakable,
                updating,
                timeCached
            };
        }
        else {
            return {
                started: false,
                finished: false,
                result: {
                    message: "",
                    tags: [EAsyncEndTags.UNFINISHED],
                    error: true,
                    payload: null,
                    errorPayload: null
                },
                updating: false,
                existed: false,
                cacheBreakable,
                timeCached: -1
            };
        }
    };
    let delayedRunActionTimeout;
    const delayedRun = (args = {}, { clearOldRun = true, delay, immediateIfCached = true, ...otherRunOptions }) => {
        if (clearOldRun) {
            clearTimeout(delayedRunActionTimeout);
        }
        if (immediateIfCached) {
            const { finished, cacheBreakable } = getCached(args, { checkCacheBreak: true });
            if (finished && !cacheBreakable) {
                run(args, otherRunOptions);
                return () => {
                };
            }
        }
        let ref = { cancelled: false };
        delayedRunActionTimeout = setTimeout(() => {
            if (!ref.cancelled) {
                run(args, otherRunOptions);
            }
        }, delay);
        return () => {
            ref.cancelled = true;
        };
    };
    const use = (args = {}, { initiate = true, ssr = true, postActionEnabled, cacheBreakEnabled, holdPrevious = false, dormant = false, key, onSuccess, cacheBreak: customCacheBreakHook } = {}) => {
        if (postActionEnabled == null) {
            postActionEnabled = initiate;
        }
        if (cacheBreakEnabled == null) {
            cacheBreakEnabled = initiate;
        }
        const raw = useWatch(args, {
            initiate,
            ssr,
            postActionEnabled,
            cacheBreakEnabled,
            holdPrevious,
            dormant,
            key,
            cacheBreak: customCacheBreakHook
        });
        const [isStarted, isFinished, result, isUpdating] = raw;
        const isSuccess = isFinished && !result.error;
        const isFailure = isFinished && result.error;
        if (onSuccess) {
            useEffect(() => {
                if (isSuccess && !dormant) {
                    onSuccess(result.payload, args);
                }
            }, [isSuccess]);
        }
        const renderPayload = (func) => {
            if (!result.error) {
                return func(result.payload);
            }
            return React.Fragment;
        };
        return {
            isStarted,
            isFinished,
            isUpdating,
            isSuccess,
            isFailure,
            isLoading: isStarted && (!isFinished || isUpdating),
            endTags: result.tags,
            error: result.error,
            payload: result.payload,
            errorPayload: result.errorPayload,
            renderPayload,
            message: result.message,
            raw,
            execute: (runOptions) => run(args, runOptions),
            clearCached: () => clearCache(args),
            setCached: (response, options) => {
                setCached(args, response, options);
            },
            setCachedPayload: (payload, options) => {
                setCachedPayload(args, payload, options);
            },
            updateCached: (updater, options) => {
                updateCached(args, updater, options);
            }
        };
    };
    const useDefer = (inputs = {}) => {
        const [argState, setArgState] = useState(() => ({
            key: inputs.key ? inputs.key : deferWaitingKey,
            args: {}
        }));
        const initialResponse = use({}, {
            ...inputs,
            key: argState.key,
            initiate: false
        });
        const hasCached = (args = {}, options = {}) => {
            var _a, _b;
            const executionKey = (_a = inputs.key) !== null && _a !== void 0 ? _a : _createKey(args);
            const { checkCacheBreak = true, successOnly = false } = options;
            const cached = getCached(args, {
                key: executionKey,
                cacheBreak: (_b = options.cacheBreak) !== null && _b !== void 0 ? _b : inputs.cacheBreak,
                checkCacheBreak
            });
            if (cached.existed) {
                if (!checkCacheBreak || !cached.cacheBreakable) {
                    return !successOnly || !cached.result.error;
                }
            }
            return false;
        };
        const unwatchExecuted = () => {
            setArgState({ key: deferWaitingKey, args: {} });
        };
        const execute = (args = {}, runOptions) => {
            var _a;
            const executionKey = (_a = inputs.key) !== null && _a !== void 0 ? _a : _createKey(args);
            if (executionKey !== argState.key) {
                setArgState({ key: executionKey, args });
            }
            return run(args, {
                ...runOptions,
                key: executionKey,
                cacheBreak: inputs.cacheBreak
            }).then(resp => {
                if (inputs.clearOnSuccess) {
                    clearCache({}, { key: executionKey });
                }
                return resp;
            });
        };
        return {
            ...initialResponse,
            clearCached: () => {
                clearCache({}, { key: argState.key });
            },
            unwatchExecuted,
            setCached: (response, options = {}) => {
                options.key = argState.key;
                setCached({}, response, options);
            },
            setCachedPayload: (payload, options = {}) => {
                options.key = argState.key;
                setCachedPayload({}, payload, options);
            },
            updateCached: (updater, options = {}) => {
                options.key = argState.key;
                updateCached({}, updater, options);
            },
            useDebouncedExecution: (args, delay, options = {}) => {
                if (!onServer) {
                    const stateRef = useRef({ update: false });
                    const currentValue = useRef(undefined);
                    const executionOrd = useRef(-1);
                    const timeout = useRef(undefined);
                    useEffect(() => {
                        stateRef.current.update = true;
                        return () => {
                            stateRef.current.update = false;
                        };
                    }, []);
                    const hasEqualityCheck = options.equality != null;
                    if (hasEqualityCheck) {
                        if (typeof options.equality === "function") {
                            if ((currentValue.current === undefined || options.equality(currentValue.current, args))) {
                                currentValue.current = args;
                                executionOrd.current += 1;
                            }
                        }
                        else if (currentValue.current !== options.equality) {
                            currentValue.current = options.equality;
                            executionOrd.current += 1;
                        }
                    }
                    else if (!isEqual(currentValue.current, args)) {
                        currentValue.current = args;
                        executionOrd.current += 1;
                    }
                    useEffect(() => {
                        var _a, _b, _c;
                        clearTimeout(timeout.current);
                        const executeAction = () => {
                            var _a;
                            if (stateRef.current.update) {
                                execute(args, (_a = options.executeOptions) !== null && _a !== void 0 ? _a : { respectCache: true });
                            }
                        };
                        if ((_b = (_a = options.validInput) === null || _a === void 0 ? void 0 : _a.call(options, args)) !== null && _b !== void 0 ? _b : true) {
                            if (hasCached(args)) {
                                executeAction();
                            }
                            else {
                                timeout.current = setTimeout(executeAction, delay);
                            }
                        }
                        else if (!((_c = options.watchLastValid) !== null && _c !== void 0 ? _c : false)) {
                            unwatchExecuted();
                        }
                    }, [executionOrd.current]);
                }
            },
            hasCached,
            execute,
            args: argState.args,
            key: argState.key
        };
    };
    return {
        use,
        useDefer,
        read,
        useBeckon,
        useWatch,
        run,
        delayedRun,
        clearCache,
        clearAllCache,
        clearAllUnwatchedCache,
        getCached,
        setCached,
        setCachedPayload,
        updateCached
    };
}const PullstateContext = react.createContext(null);
const PullstateProvider = ({ instance, children }) => {
    return React.createElement(PullstateContext.Provider, { value: instance }, children);
};
let singleton = null;
const clientStores = {
    internalClientStores: true,
    loaded: false,
    stores: {}
};
class PullstateSingleton {
    constructor(allStores, options = {}) {
        this.options = {};
        if (singleton !== null) {
            console.error(`Pullstate: createPullstate() - Should not be creating the core Pullstate class more than once! In order to re-use pull state, you need to call instantiate() on your already created object.`);
        }
        singleton = this;
        clientStores.stores = allStores;
        clientStores.loaded = true;
        this.options = options;
    }
    instantiate({ hydrateSnapshot, ssr = false, customContext } = {}) {
        if (!ssr) {
            const instantiated = new PullstateInstance(clientStores.stores, false, customContext);
            if (hydrateSnapshot != null) {
                instantiated.hydrateFromSnapshot(hydrateSnapshot);
            }
            instantiated.instantiateReactions();
            return instantiated;
        }
        const newStores = {};
        for (const storeName of Object.keys(clientStores.stores)) {
            if (hydrateSnapshot == null) {
                newStores[storeName] = new Store(clientStores.stores[storeName]._getInitialState());
            }
            else if (hydrateSnapshot.hasOwnProperty(storeName)) {
                newStores[storeName] = new Store(hydrateSnapshot.allState[storeName]);
            }
            else {
                newStores[storeName] = new Store(clientStores.stores[storeName]._getInitialState());
                console.warn(`Pullstate (instantiate): store [${storeName}] didn't hydrate any state (data was non-existent on hydration object)`);
            }
            newStores[storeName]._setInternalOptions({
                ssr,
                reactionCreators: clientStores.stores[storeName]._getReactionCreators()
            });
        }
        return new PullstateInstance(newStores, true, customContext);
    }
    useStores() {
        return useStores();
    }
    useInstance() {
        return useInstance();
    }
    createAsyncActionDirect(action, options = {}) {
        return createAsyncActionDirect(action, options);
    }
    createAsyncAction(action, options = {}) {
        var _a;
        if (((_a = this.options.asyncActions) === null || _a === void 0 ? void 0 : _a.defaultCachingSeconds) && !options.cacheBreakHook) {
            options.cacheBreakHook = (inputs) => inputs.timeCached < Date.now() - this.options.asyncActions.defaultCachingSeconds * 1000;
        }
        return createAsyncAction(action, options);
    }
}
class PullstateInstance {
    constructor(allStores, ssr, customContext) {
        this._ssr = false;
        this._stores = {};
        this._asyncCache = {
            listeners: {},
            results: {},
            actions: {},
            actionOrd: {}
        };
        this._stores = allStores;
        this._ssr = ssr;
        this._customContext = customContext;
    }
    getAllUnresolvedAsyncActions() {
        return Object.keys(this._asyncCache.actions).map((key) => this._asyncCache.actions[key]());
    }
    instantiateReactions() {
        for (const storeName of Object.keys(this._stores)) {
            this._stores[storeName]._instantiateReactions();
        }
    }
    getPullstateSnapshot() {
        const allState = {};
        for (const storeName of Object.keys(this._stores)) {
            allState[storeName] = this._stores[storeName].getRawState();
        }
        return { allState, asyncResults: this._asyncCache.results, asyncActionOrd: this._asyncCache.actionOrd };
    }
    async resolveAsyncState() {
        const promises = this.getAllUnresolvedAsyncActions();
        await Promise.all(promises);
    }
    hasAsyncStateToResolve() {
        return Object.keys(this._asyncCache.actions).length > 0;
    }
    get stores() {
        return this._stores;
    }
    get customContext() {
        return this._customContext;
    }
    async runAsyncAction(asyncAction, args = {}, runOptions = {}) {
        if (this._ssr) {
            runOptions._asyncCache = this._asyncCache;
            runOptions._stores = this._stores;
            runOptions._customContext = this._customContext;
        }
        return await asyncAction.run(args, runOptions);
    }
    hydrateFromSnapshot(snapshot) {
        for (const storeName of Object.keys(this._stores)) {
            if (snapshot.allState.hasOwnProperty(storeName)) {
                this._stores[storeName]._updateStateWithoutReaction(snapshot.allState[storeName]);
            }
            else {
                console.warn(`${storeName} didn't hydrate any state (data was non-existent on hydration object)`);
            }
        }
        clientAsyncCache.results = snapshot.asyncResults || {};
        clientAsyncCache.actionOrd = snapshot.asyncActionOrd || {};
    }
}
function createPullstateCore(allStores = {}, options = {}) {
    return new PullstateSingleton(allStores, options);
}
function useStores() {
    return useContext(PullstateContext).stores;
}
function useInstance() {
    return useContext(PullstateContext);
}var EAsyncActionInjectType;
(function (EAsyncActionInjectType) {
    EAsyncActionInjectType["WATCH"] = "watch";
    EAsyncActionInjectType["BECKON"] = "beckon";
})(EAsyncActionInjectType || (EAsyncActionInjectType = {}));
function InjectAsyncAction(props) {
    if (props.type === EAsyncActionInjectType.BECKON) {
        const response = props.action.useBeckon(props.args, props.options);
        return props.children(response);
    }
    const response = props.action.useWatch(props.args, props.options);
    return props.children(response);
}function registerInDevtools(stores, { namespace = "" } = {}) {
    const devToolsExtension = typeof window !== "undefined" ? window === null || window === void 0 ? void 0 : window.__REDUX_DEVTOOLS_EXTENSION__ : undefined;
    if (devToolsExtension) {
        for (const key of Object.keys(stores)) {
            const store = stores[key];
            const devTools = devToolsExtension.connect({ name: `${namespace}${key}` });
            devTools.init(store.getRawState());
            let ignoreNext = false;
            store.subscribe((s) => s, (watched) => {
                if (ignoreNext) {
                    ignoreNext = false;
                    return;
                }
                devTools.send("Change", watched);
            });
            devTools.subscribe((message) => {
                if (message.type === "DISPATCH" && message.state) {
                    ignoreNext = true;
                    const parsed = JSON.parse(message.state);
                    store.replace(parsed);
                }
            });
        }
    }
}const batchState = {};
function setupBatch({ uiBatchFunction }) {
    batchState.uiBatchFunction = uiBatchFunction;
}
function batch(runUpdates) {
    if (globalClientState.batching) {
        throw new Error("Pullstate: Can't enact two batch() update functions at the same time-\n" +
            "make sure you are not running a batch() inside of a batch() by mistake.");
    }
    globalClientState.batching = true;
    try {
        runUpdates();
    }
    finally {
        if (batchState.uiBatchFunction) {
            batchState.uiBatchFunction(() => {
                Object.values(globalClientState.flushStores).forEach(store => store.flushBatch(true));
            });
        }
        else {
            Object.values(globalClientState.flushStores).forEach(store => store.flushBatch(true));
        }
        globalClientState.flushStores = {};
        globalClientState.batching = false;
    }
}

/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(70610);
const decodeComponent = __webpack_require__(44020);
const splitOnFirst = __webpack_require__(80500);
const filterObject = __webpack_require__(92806);

const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'colon-list-separator':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), ':list='].join('')];
				}

				return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'colon-list-separator':
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ 9198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(67294),__webpack_require__(45697),__webpack_require__(94184),__webpack_require__(71381),__webpack_require__(12274),__webpack_require__(42298),__webpack_require__(58545),__webpack_require__(78343),__webpack_require__(77349),__webpack_require__(63500),__webpack_require__(11640),__webpack_require__(8791),__webpack_require__(21593),__webpack_require__(7069),__webpack_require__(77982),__webpack_require__(54559),__webpack_require__(58793),__webpack_require__(59319),__webpack_require__(77881),__webpack_require__(39159),__webpack_require__(85817),__webpack_require__(20466),__webpack_require__(55855),__webpack_require__(90259),__webpack_require__(78966),__webpack_require__(56605),__webpack_require__(95570),__webpack_require__(28789),__webpack_require__(39880),__webpack_require__(4543),__webpack_require__(37042),__webpack_require__(16218),__webpack_require__(11503),__webpack_require__(44749),__webpack_require__(37950),__webpack_require__(99890),__webpack_require__(92300),__webpack_require__(84129),__webpack_require__(91857),__webpack_require__(69119),__webpack_require__(584),__webpack_require__(43703),__webpack_require__(94431),__webpack_require__(38148),__webpack_require__(83894),__webpack_require__(67090),__webpack_require__(4135),__webpack_require__(10876),__webpack_require__(96843),__webpack_require__(3151),__webpack_require__(49160),__webpack_require__(60792),__webpack_require__(86117),__webpack_require__(42699),__webpack_require__(313),__webpack_require__(24257),__webpack_require__(19013),__webpack_require__(91518),__webpack_require__(23855),__webpack_require__(58949),__webpack_require__(73935),__webpack_require__(36829),__webpack_require__(92311)):0}(this,(function(e,t,r,a,n,o,s,i,p,l,c,d,u,f,h,m,y,v,D,g,w,k,b,S,C,_,M,E,P,Y,N,x,O,I,T,R,L,F,A,q,Q,K,B,W,H,j,V,U,z,$,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe,le){"use strict";function ce(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=ce(t),ue=ce(a),fe=ce(n),he=ce(o),me=ce(s),ye=ce(i),ve=ce(p),De=ce(l),ge=ce(c),we=ce(d),ke=ce(u),be=ce(f),Se=ce(h),Ce=ce(m),_e=ce(y),Me=ce(v),Ee=ce(D),Pe=ce(g),Ye=ce(w),Ne=ce(k),xe=ce(b),Oe=ce(S),Ie=ce(C),Te=ce(_),Re=ce(M),Le=ce(E),Fe=ce(P),Ae=ce(Y),qe=ce(N),Qe=ce(x),Ke=ce(O),Be=ce(I),We=ce(T),He=ce(R),je=ce(L),Ve=ce(F),Ue=ce(A),ze=ce(q),$e=ce(Q),Ge=ce(K),Je=ce(B),Xe=ce(W),Ze=ce(H),et=ce(j),tt=ce(U),rt=ce(z),at=ce($),nt=ce(G),ot=ce(J),st=ce(X),it=ce(Z),pt=ce(ee),lt=ce(te),ct=ce(re),dt=ce(ae),ut=ce(ne),ft=ce(oe),ht=ce(se),mt=ce(ie),yt=ce(le);function vt(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a)}return r}function Dt(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(r),!0).forEach((function(t){St(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):vt(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function gt(e){return gt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},gt(e)}function wt(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function kt(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,Ot(a.key),a)}}function bt(e,t,r){return t&&kt(e.prototype,t),r&&kt(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function St(e,t,r){return(t=Ot(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function Ct(){return Ct=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e},Ct.apply(this,arguments)}function _t(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&Et(e,t)}function Mt(e){return Mt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},Mt(e)}function Et(e,t){return Et=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},Et(e,t)}function Pt(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Yt(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=Mt(e);if(t){var n=Mt(this).constructor;r=Reflect.construct(a,arguments,n)}else r=a.apply(this,arguments);return function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return Pt(e)}(this,r)}}function Nt(e){return function(e){if(Array.isArray(e))return xt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return xt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return xt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function xt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Ot(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var a=r.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}var It=function(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},Tt=function(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},Rt={p:Tt,P:function(e,t){var r,a=e.match(/(P+)(p+)?/)||[],n=a[1],o=a[2];if(!o)return It(e,t);switch(n){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",It(n,t)).replace("{{time}}",Tt(o,t))}},Lt=12,Ft=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function At(e){var t=e?"string"==typeof e||e instanceof String?ft.default(e):dt.default(e):new Date;return qt(t)?t:null}function qt(e,t){return t=t||new Date("1/1/1000"),he.default(e)&&!lt.default(e,t)}function Qt(e,t,r){if("en"===r)return me.default(e,t,{awareOfUnicodeTokens:!0});var a=tr(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&er()&&tr(er())&&(a=tr(er())),me.default(e,t,{locale:a||null,awareOfUnicodeTokens:!0})}function Kt(e,t){var r=t.dateFormat,a=t.locale;return e&&Qt(e,Array.isArray(r)?r[0]:r,a)||""}function Bt(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return Qe.default(qe.default(Ae.default(e,i),o),a)}function Wt(e,t,r){var a=tr(t||er());return Ge.default(e,{locale:a,weekStartsOn:r})}function Ht(e){return Je.default(e)}function jt(e){return Ze.default(e)}function Vt(e){return Xe.default(e)}function Ut(){return $e.default(At())}function zt(e,t){return e&&t?st.default(e,t):!e&&!t}function $t(e,t){return e&&t?ot.default(e,t):!e&&!t}function Gt(e,t){return e&&t?it.default(e,t):!e&&!t}function Jt(e,t){return e&&t?nt.default(e,t):!e&&!t}function Xt(e,t){return e&&t?at.default(e,t):!e&&!t}function Zt(e,t,r){var a,n=$e.default(t),o=et.default(r);try{a=ct.default(e,{start:n,end:o})}catch(e){a=!1}return a}function er(){return("undefined"!=typeof window?window:globalThis).__localeId__}function tr(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function rr(e,t){return Qt(Ke.default(At(),e),"LLLL",t)}function ar(e,t){return Qt(Ke.default(At(),e),"LLL",t)}function nr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return ur(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Jt(e,t)}))||o&&o.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})}))||s&&!s.some((function(t){return Jt(e,t)}))||i&&!i.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})}))||p&&!p(At(e))||!1}function or(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,a=t.excludeDateIntervals;return a&&a.length>0?a.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})})):r&&r.some((function(t){return Jt(e,t)}))||!1}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return ur(e,{minDate:Je.default(r),maxDate:tt.default(a)})||n&&n.some((function(t){return $t(e,t)}))||o&&!o.some((function(t){return $t(e,t)}))||s&&!s(At(e))||!1}function ir(e,t,r,a){var n=Le.default(e),o=Te.default(e),s=Le.default(t),i=Te.default(t),p=Le.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function pr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return ur(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Gt(e,t)}))||o&&!o.some((function(t){return Gt(e,t)}))||s&&!s(At(e))||!1}function lr(e,t,r){if(!he.default(t)||!he.default(r))return!1;var a=Le.default(t),n=Le.default(r);return a<=e&&n>=e}function cr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate,i=new Date(e,0,1);return ur(i,{minDate:Ze.default(r),maxDate:rt.default(a)})||n&&n.some((function(e){return zt(i,e)}))||o&&!o.some((function(e){return zt(i,e)}))||s&&!s(At(i))||!1}function dr(e,t,r,a){var n=Le.default(e),o=Re.default(e),s=Le.default(t),i=Re.default(t),p=Le.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function ur(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&Ve.default(e,r)<0||a&&Ve.default(e,a)>0}function fr(e,t){return t.some((function(t){return Ne.default(t)===Ne.default(e)&&Ye.default(t)===Ye.default(e)}))}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&fr(e,r)||a&&!fr(e,a)||n&&!n(e)||!1}function mr(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=At(),s=Qe.default(qe.default(o,Ye.default(e)),Ne.default(e)),i=Qe.default(qe.default(o,Ye.default(r)),Ne.default(r)),p=Qe.default(qe.default(o,Ye.default(a)),Ne.default(a));try{n=!ct.default(s,{start:i,end:p})}catch(e){n=!1}return n}function yr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=_e.default(e,1);return r&&Ue.default(r,n)>0||a&&a.every((function(e){return Ue.default(e,n)>0}))||!1}function vr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=we.default(e,1);return r&&Ue.default(n,r)>0||a&&a.every((function(e){return Ue.default(n,e)>0}))||!1}function Dr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Ee.default(e,1);return r&&ze.default(r,n)>0||a&&a.every((function(e){return ze.default(e,n)>0}))||!1}function gr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=be.default(e,1);return r&&ze.default(n,r)>0||a&&a.every((function(e){return ze.default(n,e)>0}))||!1}function wr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return Ve.default(e,t)>=0}));return He.default(a)}return r?He.default(r):t}function kr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return Ve.default(e,t)<=0}));return je.default(a)}return r?je.default(r):t}function br(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(fe.default(o)){var s=Qt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i))}else if("object"===gt(o)){var p=Object.keys(o),l=p[0],c=o[p[0]];if("string"==typeof l&&c.constructor===Array)for(var d=0,u=c.length;d<u;d++){var f=Qt(c[d],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h))}}}return r}function Sr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=ye.default(ve.default(e,Ne.default(n[i])),Ye.default(n[i])),l=ye.default(e,(r+1)*a);pt.default(p,t)&&lt.default(p,l)&&s.push(n[i])}return s}function Cr(e){return e<10?"0".concat(e):"".concat(e)}function _r(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Lt,r=Math.ceil(Le.default(e)/t)*t;return{startPeriod:r-(t-1),endPeriod:r}}function Mr(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Le.default(r)<=s),a&&i&&(i=Le.default(a)>=s),i&&n.push(s)}return n}var Er=function(e){_t(a,e);var r=Yt(a);function a(e){var n;wt(this,a),St(Pt(n=r.call(this,e)),"renderOptions",(function(){var e=n.props.year,t=n.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:n.onChange.bind(Pt(n),t),"aria-selected":e===t?"true":void 0},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=n.props.minDate?Le.default(n.props.minDate):null,a=n.props.maxDate?Le.default(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&n.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),St(Pt(n),"onChange",(function(e){n.props.onChange(e)})),St(Pt(n),"handleClickOutside",(function(){n.props.onCancel()})),St(Pt(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),St(Pt(n),"incrementYears",(function(){return n.shiftYears(1)})),St(Pt(n),"decrementYears",(function(){return n.shiftYears(-1)}));var o=e.yearDropdownItemNumber,s=e.scrollableYearDropdown,i=o||(s?10:5);return n.state={yearsList:Mr(n.props.year,i,n.props.minDate,n.props.maxDate)},n.dropdownRef=t.createRef(),n}return bt(a,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2}}},{key:"render",value:function(){var e=ue.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e,ref:this.dropdownRef},this.renderOptions())}}]),a}(de.default.Component),Pr=ht.default(Er),Yr=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),St(Pt(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Le.default(e.props.minDate):1900,r=e.props.maxDate?Le.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),St(Pt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),St(Pt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),St(Pt(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),St(Pt(e),"renderDropdown",(function(){return de.default.createElement(Pr,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),St(Pt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),St(Pt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),St(Pt(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),St(Pt(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),St(Pt(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),St(Pt(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return bt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Nr=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"isSelectedMonth",(function(t){return e.props.month===t})),St(Pt(e),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.isSelectedMonth(r)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(Pt(e),r),"aria-selected":e.isSelectedMonth(r)?"true":void 0},e.isSelectedMonth(r)?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),St(Pt(e),"onChange",(function(t){return e.props.onChange(t)})),St(Pt(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return bt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),xr=ht.default(Nr),Or=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),St(Pt(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),St(Pt(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),St(Pt(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),St(Pt(e),"renderDropdown",(function(t){return de.default.createElement(xr,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),St(Pt(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),St(Pt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),St(Pt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return bt(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return ar(e,t.props.locale)}:function(e){return rr(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function Ir(e,t){for(var r=[],a=Ht(e),n=Ht(t);!pt.default(a,n);)r.push(At(a)),a=we.default(a,1);return r}var Tr,Rr=function(e){_t(r,e);var t=Yt(r);function r(e){var a;return wt(this,r),St(Pt(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Fe.default(e),r=zt(a.props.date,e)&&$t(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(Pt(a),t),"aria-selected":r?"true":void 0},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Qt(e,a.props.dateFormat,a.props.locale))}))})),St(Pt(a),"onChange",(function(e){return a.props.onChange(e)})),St(Pt(a),"handleClickOutside",(function(){a.props.onCancel()})),a.state={monthYearsList:Ir(a.props.minDate,a.props.maxDate)},a}return bt(r,[{key:"render",value:function(){var e=ue.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Lr=ht.default(Rr),Fr=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),St(Pt(e),"renderSelectOptions",(function(){for(var t=Ht(e.props.minDate),r=Ht(e.props.maxDate),a=[];!pt.default(t,r);){var n=Fe.default(t);a.push(de.default.createElement("option",{key:n,value:n},Qt(t,e.props.dateFormat,e.props.locale))),t=we.default(t,1)}return a})),St(Pt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),St(Pt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Fe.default(Ht(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),St(Pt(e),"renderReadView",(function(t){var r=Qt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),St(Pt(e),"renderDropdown",(function(){return de.default.createElement(Lr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),St(Pt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),St(Pt(e),"onChange",(function(t){e.toggleDropdown();var r=At(parseInt(t));zt(e.props.date,r)&&$t(e.props.date,r)||e.props.onChange(r)})),St(Pt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return bt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Ar=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),St(Pt(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),St(Pt(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),St(Pt(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),St(Pt(e),"isSameDay",(function(t){return Jt(e.props.day,t)})),St(Pt(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),St(Pt(e),"isDisabled",(function(){return nr(e.props.day,e.props)})),St(Pt(e),"isExcluded",(function(){return or(e.props.day,e.props)})),St(Pt(e),"getHighLightedClass",(function(){var t=e.props,r=t.day,a=t.highlightDates;if(!a)return!1;var n=Qt(r,"MM.dd.yyyy");return a.get(n)})),St(Pt(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Zt(r,a,n)})),St(Pt(e),"isInSelectingRange",(function(){var t,r=e.props,a=r.day,n=r.selectsStart,o=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,l=r.endDate,c=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return!(!(n||o||s)||!c||!i&&e.isDisabled())&&(n&&l&&(lt.default(c,l)||Xt(c,l))?Zt(a,c,l):(o&&p&&(pt.default(c,p)||Xt(c,p))||!(!s||!p||l||!pt.default(c,p)&&!Xt(c,p)))&&Zt(a,p,c))})),St(Pt(e),"isSelectingRangeStart",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,a=r.day,n=r.startDate,o=r.selectsStart,s=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Jt(a,o?s:n)})),St(Pt(e),"isSelectingRangeEnd",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,a=r.day,n=r.endDate,o=r.selectsEnd,s=r.selectsRange,i=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Jt(a,o||s?i:n)})),St(Pt(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Jt(a,r)})),St(Pt(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Jt(n,r)})),St(Pt(e),"isWeekend",(function(){var t=xe.default(e.props.day);return 0===t||6===t})),St(Pt(e),"isAfterMonth",(function(){return void 0!==e.props.month&&(e.props.month+1)%12===Te.default(e.props.day)})),St(Pt(e),"isBeforeMonth",(function(){return void 0!==e.props.month&&(Te.default(e.props.day)+1)%12===e.props.month})),St(Pt(e),"isCurrentDay",(function(){return e.isSameDay(At())})),St(Pt(e),"isSelected",(function(){return e.isSameDay(e.props.selected)})),St(Pt(e),"getClassNames",(function(t){var r,a=e.props.dayClassName?e.props.dayClassName(t):void 0;return ue.default("react-datepicker__day",a,"react-datepicker__day--"+Qt(e.props.day,"ddd",r),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSelected(),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isCurrentDay(),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isAfterMonth()||e.isBeforeMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),St(Pt(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return"".concat(i," ").concat(Qt(r,"PPPP",e.props.locale))})),St(Pt(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(a)&&Jt(n,a)?0:-1})),St(Pt(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0),e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()&&(r=!1),e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()&&(r=!1)),r&&e.dayEl.current.focus({preventScroll:!0})})),St(Pt(e),"renderDayContents",(function(){return e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()||e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()?null:e.props.renderDayContents?e.props.renderDayContents(Oe.default(e.props.day),e.props.day):Oe.default(e.props.day)})),St(Pt(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"option","aria-disabled":e.isDisabled(),"aria-current":e.isCurrentDay()?"date":void 0,"aria-selected":e.isSelected()||e.isInRange()},e.renderDayContents())})),e}return bt(r,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),r}(de.default.Component),qr=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return bt(r,[{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return de.default.createElement("div",{className:ue.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},t)}}],[{key:"defaultProps",get:function(){return{ariaLabelPrefix:"week "}}}]),r}(de.default.Component),Qr=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),St(Pt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),St(Pt(e),"handleWeekClick",(function(t,r,a){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),St(Pt(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):function(e,t){var r=t&&tr(t)||er()&&tr(er());return Ie.default(e,r?{locale:r}:null)}(t)})),St(Pt(e),"renderDays",(function(){var t=Wt(e.props.day,e.props.locale,e.props.calendarStartDay),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect?e.handleWeekClick.bind(Pt(e),t,a):void 0;r.push(de.default.createElement(qr,{key:"W",weekNumber:a,onClick:n,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=De.default(t,r);return de.default.createElement(Ar,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(Pt(e),a),onMouseEnter:e.handleDayMouseEnter.bind(Pt(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart,locale:e.props.locale})})))})),e}return bt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(de.default.Component),Kr="two_columns",Br="three_columns",Wr="four_columns",Hr=(St(Tr={},Kr,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),St(Tr,Br,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),St(Tr,Wr,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4}),Tr);function jr(e,t){return e?Wr:t?Kr:Br}var Vr=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",Nt(Array(12)).map((function(){return de.default.createRef()}))),St(Pt(e),"QUARTER_REFS",Nt(Array(4)).map((function(){return de.default.createRef()}))),St(Pt(e),"isDisabled",(function(t){return nr(t,e.props)})),St(Pt(e),"isExcluded",(function(t){return or(t,e.props)})),St(Pt(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),St(Pt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),St(Pt(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),St(Pt(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&$t(Ke.default(a,t),n)})),St(Pt(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Gt(Be.default(a,t),n)})),St(Pt(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&$t(Ke.default(a,t),o)})),St(Pt(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Gt(Be.default(a,t),o)})),St(Pt(e),"isInSelectingRangeMonth",(function(t){var r,a=e.props,n=a.day,o=a.selectsStart,s=a.selectsEnd,i=a.selectsRange,p=a.startDate,l=a.endDate,c=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return!(!(o||s||i)||!c)&&(o&&l?ir(c,l,t,n):(s&&p||!(!i||!p||l))&&ir(p,c,t,n))})),St(Pt(e),"isSelectingMonthRangeStart",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return!1;var a=e.props,n=a.day,o=a.startDate,s=a.selectsStart,i=Ke.default(n,t),p=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return $t(i,s?p:o)})),St(Pt(e),"isSelectingMonthRangeEnd",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return!1;var a=e.props,n=a.day,o=a.endDate,s=a.selectsEnd,i=a.selectsRange,p=Ke.default(n,t),l=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return $t(p,s||i?l:o)})),St(Pt(e),"isInSelectingRangeQuarter",(function(t){var r,a=e.props,n=a.day,o=a.selectsStart,s=a.selectsEnd,i=a.selectsRange,p=a.startDate,l=a.endDate,c=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return!(!(o||s||i)||!c)&&(o&&l?dr(c,l,t,n):(s&&p||!(!i||!p||l))&&dr(p,c,t,n))})),St(Pt(e),"isWeekInMonth",(function(t){var r=e.props.day,a=De.default(t,6);return $t(t,r)||$t(a,r)})),St(Pt(e),"isCurrentMonth",(function(e,t){return Le.default(e)===Le.default(At())&&t===Te.default(At())})),St(Pt(e),"isCurrentQuarter",(function(e,t){return Le.default(e)===Le.default(At())&&t===Re.default(At())})),St(Pt(e),"isSelectedMonth",(function(e,t,r){return Te.default(r)===t&&Le.default(e)===Le.default(r)})),St(Pt(e),"isSelectedQuarter",(function(e,t,r){return Re.default(e)===t&&Le.default(e)===Le.default(r)})),St(Pt(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=0,n=!1,o=Wt(Ht(e.props.day),e.props.locale,e.props.calendarStartDay);t.push(de.default.createElement(Qr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:a,day:o,month:Te.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,calendarStartDay:e.props.calendarStartDay,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!n;){a++,o=ge.default(o,1);var s=r&&a>=6,i=!r&&!e.isWeekInMonth(o);if(s||i){if(!e.props.peekNextMonth)break;n=!0}}return t})),St(Pt(e),"onMonthClick",(function(t,r){e.handleDayClick(Ht(Ke.default(e.props.day,r)),t)})),St(Pt(e),"onMonthMouseEnter",(function(t){e.handleDayMouseEnter(Ht(Ke.default(e.props.day,t)))})),St(Pt(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),St(Pt(e),"onMonthKeyDown",(function(t,r){var a=e.props,n=a.selected,o=a.preSelection,s=a.disabledKeyboardNavigation,i=a.showTwoColumnMonthYearPicker,p=a.showFourColumnMonthYearPicker,l=a.setPreSelection,c=t.key;if("Tab"!==c&&t.preventDefault(),!s){var d=jr(p,i),u=Hr[d].verticalNavigationOffset,f=Hr[d].grid;switch(c){case"Enter":e.onMonthClick(t,r),l(n);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,we.default(o,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,_e.default(o,1));break;case"ArrowUp":e.handleMonthNavigation(f[0].includes(r)?r+12-u:r-u,_e.default(o,u));break;case"ArrowDown":e.handleMonthNavigation(f[f.length-1].includes(r)?r-12+u:r+u,we.default(o,u))}}})),St(Pt(e),"onQuarterClick",(function(t,r){e.handleDayClick(Vt(Be.default(e.props.day,r)),t)})),St(Pt(e),"onQuarterMouseEnter",(function(t){e.handleDayMouseEnter(Vt(Be.default(e.props.day,t)))})),St(Pt(e),"handleQuarterNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.QUARTER_REFS[t-1].current&&e.QUARTER_REFS[t-1].current.focus())})),St(Pt(e),"onQuarterKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case"Enter":e.onQuarterClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleQuarterNavigation(4===r?1:r+1,ke.default(e.props.preSelection,1));break;case"ArrowLeft":e.handleQuarterNavigation(1===r?4:r-1,Me.default(e.props.preSelection,1))}})),St(Pt(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,c=r.monthClassName,d=r.excludeDates,u=r.includeDates,f=c?c(Ke.default(a,t)):void 0,h=Ke.default(a,t);return ue.default("react-datepicker__month-text","react-datepicker__month-".concat(t),f,{"react-datepicker__month-text--disabled":(i||p||d||u)&&sr(h,e.props),"react-datepicker__month-text--selected":e.isSelectedMonth(a,t,s),"react-datepicker__month-text--keyboard-selected":!e.props.disabledKeyboardNavigation&&Te.default(l)===t,"react-datepicker__month-text--in-selecting-range":e.isInSelectingRangeMonth(t),"react-datepicker__month-text--in-range":ir(n,o,t,a),"react-datepicker__month-text--range-start":e.isRangeStartMonth(t),"react-datepicker__month-text--range-end":e.isRangeEndMonth(t),"react-datepicker__month-text--selecting-range-start":e.isSelectingMonthRangeStart(t),"react-datepicker__month-text--selecting-range-end":e.isSelectingMonthRangeEnd(t),"react-datepicker__month-text--today":e.isCurrentMonth(a,t)})})),St(Pt(e),"getTabIndex",(function(t){var r=Te.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),St(Pt(e),"getQuarterTabIndex",(function(t){var r=Re.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),St(Pt(e),"getAriaLabel",(function(t){var r=e.props,a=r.chooseDayAriaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=Ke.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return"".concat(l," ").concat(Qt(p,"MMMM yyyy"))})),St(Pt(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection;return ue.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter-text--disabled":(i||p)&&pr(Be.default(a,t),e.props),"react-datepicker__quarter-text--selected":e.isSelectedQuarter(a,t,s),"react-datepicker__quarter-text--keyboard-selected":Re.default(l)===t,"react-datepicker__quarter-text--in-selecting-range":e.isInSelectingRangeQuarter(t),"react-datepicker__quarter-text--in-range":dr(n,o,t,a),"react-datepicker__quarter-text--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter-text--range-end":e.isRangeEndQuarter(t)})})),St(Pt(e),"getMonthContent",(function(t){var r=e.props,a=r.showFullMonthYearPicker,n=r.renderMonthContent,o=r.locale,s=ar(t,o),i=rr(t,o);return n?n(t,s,i):a?i:s})),St(Pt(e),"getQuarterContent",(function(t){var r=e.props,a=r.renderQuarterContent,n=function(e,t){return Qt(Be.default(At(),e),"QQQ",t)}(t,r.locale);return a?a(t,n):n})),St(Pt(e),"renderMonths",(function(){var t=e.props,r=t.showTwoColumnMonthYearPicker,a=t.showFourColumnMonthYearPicker,n=t.day,o=t.selected;return Hr[jr(a,r)].grid.map((function(t,r){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:r},t.map((function(t,r){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:r,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},onMouseEnter:function(){return e.onMonthMouseEnter(t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"option","aria-label":e.getAriaLabel(t),"aria-current":e.isCurrentMonth(n,t)?"date":void 0,"aria-selected":e.isSelectedMonth(n,t,o)},e.getMonthContent(t))})))}))})),St(Pt(e),"renderQuarters",(function(){var t=e.props,r=t.day,a=t.selected;return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,n){return de.default.createElement("div",{key:n,ref:e.QUARTER_REFS[n],role:"option",onClick:function(r){e.onQuarterClick(r,t)},onKeyDown:function(r){e.onQuarterKeyDown(r,t)},onMouseEnter:function(){return e.onQuarterMouseEnter(t)},className:e.getQuarterClassNames(t),"aria-selected":e.isSelectedQuarter(r,t,a),tabIndex:e.getQuarterTabIndex(t),"aria-current":e.isCurrentQuarter(r,t)?"date":void 0},e.getQuarterContent(t))})))})),St(Pt(e),"getClassNames",(function(){var t=e.props,r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker;return ue.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s})})),e}return bt(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(Qt(a,"yyyy-MM")),role:"listbox"},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),Ur=function(e){_t(r,e);var t=Yt(r);function r(){var e;wt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Pt(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),St(Pt(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&mr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&hr(t,e.props)||e.props.onChange(t)})),St(Pt(e),"isSelectedTime",(function(t,r,a){return e.props.selected&&r===Ne.default(t)&&a===Ye.default(t)})),St(Pt(e),"liClasses",(function(t,r,a){var n=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,a):void 0];return e.isSelectedTime(t,r,a)&&n.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&mr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&hr(t,e.props))&&n.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*Ne.default(t)+Ye.default(t))%e.props.intervals!=0&&n.push("react-datepicker__time-list-item--injected"),n.join(" ")})),St(Pt(e),"handleOnKeyDown",(function(t,r){" "===t.key&&(t.preventDefault(),t.key="Enter"),"Enter"===t.key&&e.handleClick(r),e.props.handleOnKeyDown(t)})),St(Pt(e),"renderTimes",(function(){for(var t,r=[],a=e.props.format?e.props.format:"p",n=e.props.intervals,o=(t=At(e.props.selected),$e.default(t)),s=1440/n,i=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),p=e.props.selected||e.props.openToDate||At(),l=Ne.default(p),c=Ye.default(p),d=Qe.default(qe.default(o,c),l),u=0;u<s;u++){var f=ye.default(o,u*n);if(r.push(f),i){var h=Sr(o,f,u,n,i);r=r.concat(h)}}return r.map((function(t,r){return de.default.createElement("li",{key:r,onClick:e.handleClick.bind(Pt(e),t),className:e.liClasses(t,l,c),ref:function(r){(lt.default(t,d)||Xt(t,d))&&(e.centerLi=r)},onKeyDown:function(r){e.handleOnKeyDown(r,t)},tabIndex:"0","aria-selected":e.isSelectedTime(t,l,c)?"true":void 0},Qt(t,a,e.props.locale))}))})),e}return bt(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=this.centerLi&&r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},tabIndex:"0"},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);St(Ur,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var zr=function(e){_t(r,e);var t=Yt(r);function r(e){var a;return wt(this,r),St(Pt(a=t.call(this,e)),"YEAR_REFS",Nt(Array(a.props.yearItemNumber)).map((function(){return de.default.createRef()}))),St(Pt(a),"isDisabled",(function(e){return nr(e,a.props)})),St(Pt(a),"isExcluded",(function(e){return or(e,a.props)})),St(Pt(a),"selectingDate",(function(){var e;return null!==(e=a.props.selectingDate)&&void 0!==e?e:a.props.preSelection})),St(Pt(a),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus()}.bind(Pt(a));window.requestAnimationFrame(t)})),St(Pt(a),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)})),St(Pt(a),"handleYearNavigation",(function(e,t){var r=a.props,n=r.date,o=r.yearItemNumber,s=_r(n,o).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(a.props.setPreSelection(t),e-s==-1?a.updateFocusOnPaginate(o-1):e-s===o?a.updateFocusOnPaginate(0):a.YEAR_REFS[e-s].current.focus())})),St(Pt(a),"isSameDay",(function(e,t){return Jt(e,t)})),St(Pt(a),"isCurrentYear",(function(e){return e===Le.default(At())})),St(Pt(a),"isRangeStart",(function(e){return a.props.startDate&&a.props.endDate&&zt(We.default(At(),e),a.props.startDate)})),St(Pt(a),"isRangeEnd",(function(e){return a.props.startDate&&a.props.endDate&&zt(We.default(At(),e),a.props.endDate)})),St(Pt(a),"isInRange",(function(e){return lr(e,a.props.startDate,a.props.endDate)})),St(Pt(a),"isInSelectingRange",(function(e){var t=a.props,r=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return!(!(r||n||o)||!a.selectingDate())&&(r&&i?lr(e,a.selectingDate(),i):(n&&s||!(!o||!s||i))&&lr(e,s,a.selectingDate()))})),St(Pt(a),"isSelectingRangeStart",(function(e){if(!a.isInSelectingRange(e))return!1;var t=a.props,r=t.startDate,n=t.selectsStart,o=We.default(At(),e);return zt(o,n?a.selectingDate():r)})),St(Pt(a),"isSelectingRangeEnd",(function(e){if(!a.isInSelectingRange(e))return!1;var t=a.props,r=t.endDate,n=t.selectsEnd,o=t.selectsRange,s=We.default(At(),e);return zt(s,n||o?a.selectingDate():r)})),St(Pt(a),"isKeyboardSelected",(function(e){var t=jt(We.default(a.props.date,e));return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!Jt(t,jt(a.props.selected))&&Jt(t,jt(a.props.preSelection))})),St(Pt(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(jt(We.default(r,t)),e)})),St(Pt(a),"onYearKeyDown",(function(e,t){var r=e.key;if(!a.props.disabledKeyboardNavigation)switch(r){case"Enter":a.onYearClick(e,t),a.props.setPreSelection(a.props.selected);break;case"ArrowRight":a.handleYearNavigation(t+1,be.default(a.props.preSelection,1));break;case"ArrowLeft":a.handleYearNavigation(t-1,Ee.default(a.props.preSelection,1))}})),St(Pt(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected,s=t.excludeDates,i=t.includeDates,p=t.filterDate;return ue.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Le.default(o),"react-datepicker__year-text--disabled":(r||n||s||i||p)&&cr(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--range-start":a.isRangeStart(e),"react-datepicker__year-text--range-end":a.isRangeEnd(e),"react-datepicker__year-text--in-range":a.isInRange(e),"react-datepicker__year-text--in-selecting-range":a.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":a.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":a.isSelectingRangeEnd(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})})),St(Pt(a),"getYearTabIndex",(function(e){return a.props.disabledKeyboardNavigation?"-1":e===Le.default(a.props.preSelection)?"0":"-1"})),St(Pt(a),"getYearContainerClassNames",(function(){var e=a.props,t=e.selectingDate,r=e.selectsStart,n=e.selectsEnd,o=e.selectsRange;return ue.default("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(r||n||o)})})),St(Pt(a),"getYearContent",(function(e){return a.props.renderYearContent?a.props.renderYearContent(e):e})),a}return bt(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=r.date,n=r.yearItemNumber,o=r.onYearMouseEnter,s=r.onYearMouseLeave,i=_r(a,n),p=i.startPeriod,l=i.endPeriod,c=function(r){t.push(de.default.createElement("div",{ref:e.YEAR_REFS[r-p],onClick:function(t){e.onYearClick(t,r)},onKeyDown:function(t){e.onYearKeyDown(t,r)},tabIndex:e.getYearTabIndex(r),className:e.getYearClassNames(r),onMouseEnter:function(e){return o(e,r)},onMouseLeave:function(e){return s(e,r)},key:r,"aria-current":e.isCurrentYear(r)?"date":void 0},e.getYearContent(r)))},d=p;d<=l;d++)c(d);return de.default.createElement("div",{className:this.getYearContainerClassNames()},de.default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.clearSelectingDate},t))}}]),r}(de.default.Component),$r=function(e){_t(r,e);var t=Yt(r);function r(e){var a;return wt(this,r),St(Pt(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),St(Pt(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return bt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Gr(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",Ct({className:"react-datepicker__triangle"},o)),r)}var Jr=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Xr=function(e){_t(r,e);var t=Yt(r);function r(e){var a;return wt(this,r),St(Pt(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e)})),St(Pt(a),"setClickOutsideRef",(function(){return a.containerRef.current})),St(Pt(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Jr.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus()})),St(Pt(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=wr(a.props),s=kr(a.props),i=At(),p=n||r||t;return p||(o&&lt.default(i,o)?o:s&&pt.default(i,s)?s:i)})),St(Pt(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:we.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),St(Pt(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:_e.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),St(Pt(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e)})),St(Pt(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),St(Pt(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave()})),St(Pt(a),"handleYearMouseEnter",(function(e,t){a.setState({selectingDate:We.default(At(),t)}),a.props.onYearMouseEnter&&a.props.onYearMouseEnter(e,t)})),St(Pt(a),"handleYearMouseLeave",(function(e,t){a.props.onYearMouseLeave&&a.props.onYearMouseLeave(e,t)})),St(Pt(a),"handleYearChange",(function(e){a.props.onYearChange&&(a.props.onYearChange(e),a.setState({isRenderAriaLiveMessage:!0})),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),St(Pt(a),"handleMonthChange",(function(e){a.handleCustomMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),St(Pt(a),"handleCustomMonthChange",(function(e){a.props.onMonthChange&&(a.props.onMonthChange(e),a.setState({isRenderAriaLiveMessage:!0}))})),St(Pt(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e)})),St(Pt(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}))})),St(Pt(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return{date:Ke.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}))})),St(Pt(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(Ke.default(r,Te.default(e)),Le.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}))})),St(Pt(a),"header",(function(){var e=Wt(arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,a.props.locale,a.props.calendarStartDay),t=[];return a.props.showWeekNumbers&&t.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),t.concat([0,1,2,3,4,5,6].map((function(t){var r=De.default(e,t),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:t,className:ue.default("react-datepicker__day-name",o)},n)})))})),St(Pt(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Qt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Qt(e,"EEE",t)}(e,t):function(e,t){return Qt(e,"EEEEEE",t)}(e,t)})),St(Pt(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return{date:Ee.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),St(Pt(a),"clearSelectingDate",(function(){a.setState({selectingDate:null})})),St(Pt(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=Dr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?Lt:a,o=_r(jt(Ee.default(e,n)),n).endPeriod,s=r&&Le.default(r);return s&&s>o||!1}(a.state.date,a.props);break;default:e=yr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthButtonLabel,i=o.previousYearButtonLabel,p=a.props,l=p.previousMonthAriaLabel,c=void 0===l?"string"==typeof s?s:"Previous Month":l,d=p.previousYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Previous Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:c},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel))}}})),St(Pt(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return{date:be.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),St(Pt(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=gr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?Lt:a,o=_r(be.default(e,n),n).startPeriod,s=r&&Le.default(r);return s&&s<o||!1}(a.state.date,a.props);break;default:e=vr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthButtonLabel,i=o.nextYearButtonLabel,p=a.props,l=p.nextMonthAriaLabel,c=void 0===l?"string"==typeof s?s:"Next Month":l,d=p.nextYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Next Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:c},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel))}}})),St(Pt(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},Qt(e,a.props.dateFormat,a.props.locale))})),St(Pt(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(Yr,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Le.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),St(Pt(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Or,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Te.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),St(Pt(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(Fr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),St(Pt(a),"handleTodayButtonClick",(function(e){a.props.onSelect(Ut(),e),a.props.setPreSelection&&a.props.setPreSelection(Ut())})),St(Pt(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.handleTodayButtonClick(e)}},a.props.todayButton)})),St(Pt(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),St(Pt(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var n=yr(a.state.date,a.props),o=vr(a.state.date,a.props),s=Dr(a.state.date,a.props),i=gr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(Dt(Dt({},a.state),{},{customHeaderCount:r,monthDate:t,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),St(Pt(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=_r(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Le.default(e))})),St(Pt(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),St(Pt(a),"renderMonths",(function(){if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var e=[],t=a.props.showPreviousMonths?a.props.monthsShown-1:0,r=_e.default(a.state.date,t),n=0;n<a.props.monthsShown;++n){var o=n-a.props.monthSelectedIn,s=we.default(r,o),i="month-".concat(n),p=n<a.props.monthsShown-1,l=n>0;e.push(de.default.createElement("div",{key:i,ref:function(e){a.monthContainer=e},className:"react-datepicker__month-container"},a.renderHeader({monthDate:s,i:n}),de.default.createElement(Vr,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,ariaLabelPrefix:a.props.monthAriaLabelPrefix,onChange:a.changeMonthYear,day:s,dayClassName:a.props.dayClassName,calendarStartDay:a.props.calendarStartDay,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnDayKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:n,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,highlightDates:a.props.highlightDates,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:p,monthShowsDuplicateDaysStart:l})))}return e}})),St(Pt(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement(zr,Ct({onDayClick:a.handleDayClick,selectingDate:a.state.selectingDate,clearSelectingDate:a.clearSelectingDate,date:a.state.date},a.props,{onYearMouseEnter:a.handleYearMouseEnter,onYearMouseLeave:a.handleYearMouseLeave}))):void 0})),St(Pt(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(Ur,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,handleOnKeyDown:a.props.handleOnKeyDown,showTimeSelectOnly:a.props.showTimeSelectOnly})})),St(Pt(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=qt(e)&&Boolean(a.props.selected)?"".concat(Cr(e.getHours()),":").concat(Cr(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement($r,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),St(Pt(a),"renderAriaLiveRegion",(function(){var e,t=_r(a.state.date,a.props.yearItemNumber),r=t.startPeriod,n=t.endPeriod;return e=a.props.showYearPicker?"".concat(r," - ").concat(n):a.props.showMonthYearPicker||a.props.showQuarterYearPicker?Le.default(a.state.date):"".concat(rr(Te.default(a.state.date),a.props.locale)," ").concat(Le.default(a.state.date)),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},a.state.isRenderAriaLiveMessage&&e)})),St(Pt(a),"renderChildren",(function(){if(a.props.children)return de.default.createElement("div",{className:"react-datepicker__children-container"},a.props.children)})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:!1},a}return bt(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||Jt(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!Jt(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else{var r=!$t(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}))}}},{key:"render",value:function(){var e=this.props.container||Gr;return de.default.createElement("div",{ref:this.containerRef},de.default.createElement(e,{className:ue.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Lt}}}]),r}(de.default.Component),Zr=function(e){_t(r,e);var t=Yt(r);function r(e){var a;return wt(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return bt(r,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return mt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),ea=function(e){return!e.disabled&&-1!==e.tabIndex},ta=function(e){_t(r,e);var t=Yt(r);function r(e){var a;return wt(this,r),St(Pt(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(ea)})),St(Pt(a),"handleFocusStart",(function(){var e=a.getTabChildren();e&&e.length>1&&e[e.length-1].focus()})),St(Pt(a),"handleFocusEnd",(function(){var e=a.getTabChildren();e&&e.length>1&&e[0].focus()})),a.tabLoopRef=de.default.createRef(),a}return bt(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),r}(de.default.Component),ra=function(e){_t(r,e);var t=Yt(r);function r(){return wt(this,r),t.apply(this,arguments)}return bt(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,c=t.enableTabLoop,d=t.popperOnKeyDown,u=t.portalId,f=t.portalHost;if(!n){var h=ue.default("react-datepicker-popper",r);e=de.default.createElement(pe.Popper,Ct({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(ta,{enableTabLoop:c},de.default.createElement("div",{ref:t,style:r,className:h,"data-placement":a,onKeyDown:d},de.default.cloneElement(o,{arrowProps:n})))}))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(Zr,{portalId:u,portalHost:f},e));var m=ue.default("react-datepicker-wrapper",a);return de.default.createElement(pe.Manager,{className:"react-datepicker-manager"},de.default.createElement(pe.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:m},l)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:[],popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),aa="react-datepicker-ignore-onclickoutside",na=ht.default(Xr);var oa="Date input not valid.",sa=function(e){_t(r,e);var t=Yt(r);function r(e){var a;return wt(this,r),St(Pt(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:At()})),St(Pt(a),"calcInitialState",(function(){var e,t=a.getPreSelection(),r=wr(a.props),n=kr(a.props),o=r&&lt.default(t,$e.default(r))?r:n&&pt.default(t,et.default(n))?n:t;return{open:a.props.startOpen||!1,preventFocus:!1,preSelection:null!==(e=a.props.selectsRange?a.props.startDate:a.props.selected)&&void 0!==e?e:o,highlightDates:br(a.props.highlightDates),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1}})),St(Pt(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout)})),St(Pt(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:!0})})),St(Pt(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput()})),St(Pt(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:pa},(function(){e||a.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null})}))}))})),St(Pt(a),"inputOk",(function(){return fe.default(a.state.preSelection)})),St(Pt(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),St(Pt(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0})})),St(Pt(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null})),St(Pt(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1)})),St(Pt(a),"handleDropdownFocus",(function(){a.cancelFocusInput()})),St(Pt(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1})})),St(Pt(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault()})),St(Pt(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(Pt(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:ia});var o,s,i,p,l,c,d,u,f=(o=n.target.value,s=a.props.dateFormat,i=a.props.locale,p=a.props.strictParsing,l=a.props.minDate,c=null,d=tr(i)||tr(er()),u=!0,Array.isArray(s)?(s.forEach((function(e){var t=ut.default(o,e,new Date,{locale:d});p&&(u=qt(t,l)&&o===Qt(t,e,i)),qt(t,l)&&u&&(c=t)})),c):(c=ut.default(o,s,new Date,{locale:d}),p?u=qt(c)&&o===Qt(c,s,i):qt(c)||(s=s.match(Ft).map((function(e){var t=e[0];return"p"===t||"P"===t?d?(0,Rt[t])(e,d.formatLong):t:e})).join(""),o.length>0&&(c=ut.default(o,s.slice(0,o.length),new Date)),qt(c)||(c=new Date(o))),qt(c)&&u?c:null));a.props.showTimeSelectOnly&&a.props.selected&&!Jt(f,a.props.selected)&&(f=null==f?yt.default(a.props.selected,{hours:Ne.default(a.props.selected),minutes:Ye.default(a.props.selected),seconds:Pe.default(a.props.selected)}):yt.default(a.props.selected,{hours:Ne.default(f),minutes:Ye.default(f),seconds:Pe.default(f)})),!f&&n.target.value||a.setSelected(f,n,!0)}})),St(Pt(a),"handleSelect",(function(e,t,r){if(a.setState({preventFocus:!0},(function(){return a.preventFocusTimeout=setTimeout((function(){return a.setState({preventFocus:!1})}),50),a.preventFocusTimeout})),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.setSelected(e,t,!1,r),a.props.showDateSelect&&a.setState({isRenderAriaLiveMessage:!0}),!a.props.shouldCloseOnSelect||a.props.showTimeSelect)a.setPreSelection(e);else if(!a.props.inline){a.props.selectsRange||a.setOpen(!1);var n=a.props,o=n.startDate,s=n.endDate;!o||s||lt.default(e,o)||a.setOpen(!1)}})),St(Pt(a),"setSelected",(function(e,t,r,n){var o=e;if(a.props.showYearPicker){if(null!==o&&cr(Le.default(o),a.props))return}else if(a.props.showMonthYearPicker){if(null!==o&&sr(o,a.props))return}else if(null!==o&&nr(o,a.props))return;var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,c=s.endDate;if(!Xt(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Bt(o,{hour:Ne.default(a.props.selected),minute:Ye.default(a.props.selected),second:Pe.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var d=l&&!c,u=l&&c;!l&&!c?i([o,null],t):d&&(lt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t)}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}))})),St(Pt(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;if(e){var o=$e.default(e);if(t&&r)n=Zt(e,a.props.minDate,a.props.maxDate);else if(t){var s=$e.default(a.props.minDate);n=pt.default(e,s)||Xt(o,s)}else if(r){var i=et.default(a.props.maxDate);n=lt.default(e,i)||Xt(o,i)}}n&&a.setState({preSelection:e})})),St(Pt(a),"handleTimeChange",(function(e){var t=Bt(a.props.selected?a.props.selected:a.getPreSelection(),{hour:Ne.default(e),minute:Ye.default(e)});a.setState({preSelection:t}),a.props.onChange(t),a.props.shouldCloseOnSelect&&a.setOpen(!1),a.props.showTimeInput&&a.setOpen(!0),(a.props.showTimeSelectOnly||a.props.showTimeSelect)&&a.setState({isRenderAriaLiveMessage:!0}),a.setState({inputValue:null})})),St(Pt(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick()})),St(Pt(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.calendar.componentNode&&a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=At(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===pa?(a.handleSelect(n,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(n)):a.setOpen(!1)):"Escape"===t?(e.preventDefault(),a.setOpen(!1)):"Tab"===t&&e.shiftKey&&a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:oa})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick()})),St(Pt(a),"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),St(Pt(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=At(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:oa});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=Se.default(r,1);break;case"ArrowRight":n=De.default(r,1);break;case"ArrowUp":n=Ce.default(r,1);break;case"ArrowDown":n=ge.default(r,1);break;case"PageUp":n=_e.default(r,1);break;case"PageDown":n=we.default(r,1);break;case"Home":n=Ee.default(r,1);break;case"End":n=be.default(r,1)}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:oa}));if(e.preventDefault(),a.setState({lastPreSelectChange:pa}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Te.default(r),s=Te.default(n),i=Le.default(r),p=Le.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:!0}):a.setState({shouldFocusDayInline:!1})}}})),St(Pt(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),St(Pt(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.props.selectsRange?a.props.onChange([null,null],e):a.props.onChange(null,e),a.setState({inputValue:null})})),St(Pt(a),"clear",(function(){a.onClearClick()})),St(Pt(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(!1):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(!1)})),St(Pt(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement(na,{ref:function(e){a.calendar=e},locale:a.props.locale,calendarStartDay:a.props.calendarStartDay,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,monthAriaLabelPrefix:a.props.monthAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:aa,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showDateSelect:a.props.showDateSelect,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthAriaLabel:a.props.previousMonthAriaLabel,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthAriaLabel:a.props.nextMonthAriaLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearAriaLabel:a.props.previousYearAriaLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearAriaLabel:a.props.nextYearAriaLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,onYearMouseEnter:a.props.onYearMouseEnter,onYearMouseLeave:a.props.onYearMouseLeave,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.props.onKeyDown,handleOnDayKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),St(Pt(a),"renderAriaLiveRegion",(function(){var e,t=a.props,r=t.dateFormat,n=t.locale,o=a.props.showTimeInput||a.props.showTimeSelect?"PPPPp":"PPPP";return e=a.props.selectsRange?"Selected start date: ".concat(Kt(a.props.startDate,{dateFormat:o,locale:n}),". ").concat(a.props.endDate?"End date: "+Kt(a.props.endDate,{dateFormat:o,locale:n}):""):a.props.showTimeSelectOnly?"Selected time: ".concat(Kt(a.props.selected,{dateFormat:r,locale:n})):a.props.showYearPicker?"Selected year: ".concat(Kt(a.props.selected,{dateFormat:"yyyy",locale:n})):a.props.showMonthYearPicker?"Selected month: ".concat(Kt(a.props.selected,{dateFormat:"MMMM yyyy",locale:n})):a.props.showQuarterYearPicker?"Selected quarter: ".concat(Kt(a.props.selected,{dateFormat:"yyyy, QQQ",locale:n})):"Selected date: ".concat(Kt(a.props.selected,{dateFormat:o,locale:n})),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},e)})),St(Pt(a),"renderDateInput",(function(){var e,t=ue.default(a.props.className,St({},aa,a.state.open)),r=a.props.customInput||de.default.createElement("input",{type:"text"}),n=a.props.customInputRef||"ref",o="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:a.props.selectsRange?function(e,t,r){if(!e)return"";var a=Kt(e,r),n=t?Kt(t,r):"";return"".concat(a," - ").concat(n)}(a.props.startDate,a.props.endDate,a.props):Kt(a.props.selected,a.props);return de.default.cloneElement(r,(St(e={},n,(function(e){a.input=e})),St(e,"value",o),St(e,"onBlur",a.handleBlur),St(e,"onChange",a.handleChange),St(e,"onClick",a.onInputClick),St(e,"onFocus",a.handleFocus),St(e,"onKeyDown",a.onInputKeyDown),St(e,"id",a.props.id),St(e,"name",a.props.name),St(e,"form",a.props.form),St(e,"autoFocus",a.props.autoFocus),St(e,"placeholder",a.props.placeholderText),St(e,"disabled",a.props.disabled),St(e,"autoComplete",a.props.autoComplete),St(e,"className",ue.default(r.props.className,t)),St(e,"title",a.props.title),St(e,"readOnly",a.props.readOnly),St(e,"required",a.props.required),St(e,"tabIndex",a.props.tabIndex),St(e,"aria-describedby",a.props.ariaDescribedBy),St(e,"aria-invalid",a.props.ariaInvalid),St(e,"aria-labelledby",a.props.ariaLabelledBy),St(e,"aria-required",a.props.ariaRequired),e))})),St(Pt(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.selected,n=e.startDate,o=e.endDate,s=e.clearButtonTitle,i=e.clearButtonClassName,p=void 0===i?"":i,l=e.ariaLabelClose,c=void 0===l?"Close":l;return!t||null==r&&null==n&&null==o?null:de.default.createElement("button",{type:"button",className:"react-datepicker__close-icon ".concat(p).trim(),"aria-label":c,onClick:a.onClearClick,title:s,tabIndex:-1})})),a.state=a.calcInitialState(),a}return bt(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Te.default(r)!==Te.default(a)||Le.default(r)!==Le.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:br(this.props.highlightDates)}),t.focused||Xt(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"renderInputContainer",value:function(){var e=this.props.showIcon;return de.default.createElement("div",{className:"react-datepicker__input-container".concat(e?" react-datepicker__view-calendar-icon":"")},e&&de.default.createElement("svg",{className:"react-datepicker__calendar-icon",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512"},de.default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"})),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var e=this.renderCalendar();if(this.props.inline)return e;if(this.props.withPortal){var t=this.state.open?de.default.createElement(ta,{enableTabLoop:this.props.enableTabLoop},de.default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},e)):null;return this.state.open&&this.props.portalId&&(t=de.default.createElement(Zr,{portalId:this.props.portalId,portalHost:this.props.portalHost},t)),de.default.createElement("div",null,this.renderInputContainer(),t)}return de.default.createElement(ra,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Lt,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0}}}]),r}(de.default.Component),ia="input",pa="navigate";e.CalendarContainer=Gr,e.default=sa,e.getDefaultLocale=er,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:globalThis;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:globalThis).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));


/***/ }),

/***/ 69590:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 83962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReactMultiEmail = void 0;
const React = __importStar(__webpack_require__(67294));
const isEmail_1 = __webpack_require__(68490);
function ReactMultiEmail(props) {
    const { id, style, getLabel, className = '', noClass, placeholder, autoFocus, enable, onDisabled, validateEmail, onChange, onChangeInput, onFocus, onBlur, onKeyDown, onKeyUp, spinner, delimiter = '[ ,;]', initialInputValue = '', inputClassName, autoComplete, } = props;
    const emailInputRef = React.useRef(null);
    const [focused, setFocused] = React.useState(false);
    const [emails, setEmails] = React.useState([]);
    const [inputValue, setInputValue] = React.useState(initialInputValue);
    const [spinning, setSpinning] = React.useState(false);
    const findEmailAddress = React.useCallback((value, isEnter) => __awaiter(this, void 0, void 0, function* () {
        const validEmails = [];
        let inputValue = '';
        const re = new RegExp(delimiter, 'g');
        const isEmail = validateEmail || isEmail_1.isEmail;
        const addEmails = (email) => {
            for (let i = 0, l = emails.length; i < l; i++) {
                if (emails[i] === email) {
                    return false;
                }
            }
            validEmails.push(email);
            return true;
        };
        if (value !== '') {
            if (re.test(value)) {
                const splitData = value.split(re).filter(n => {
                    return n !== '' && n !== undefined && n !== null;
                });
                const setArr = new Set(splitData);
                const arr = [...setArr];
                do {
                    const validateResult = isEmail('' + arr[0]);
                    if (typeof validateResult === 'boolean') {
                        if (validateResult) {
                            addEmails('' + arr.shift());
                        }
                        else {
                            if (arr.length === 1) {
                                inputValue = '' + arr.shift();
                            }
                            else {
                                arr.shift();
                            }
                        }
                    }
                    else {
                        // handle promise
                        setSpinning(true);
                        if ((yield (validateEmail === null || validateEmail === void 0 ? void 0 : validateEmail(value))) === true) {
                            addEmails('' + arr.shift());
                            setSpinning(false);
                        }
                        else {
                            if (arr.length === 1) {
                                inputValue = '' + arr.shift();
                            }
                            else {
                                arr.shift();
                            }
                        }
                    }
                } while (arr.length);
            }
            else {
                if (enable && !enable({ emailCnt: emails.length })) {
                    onDisabled === null || onDisabled === void 0 ? void 0 : onDisabled();
                    return;
                }
                if (isEnter) {
                    const validateResult = isEmail(value);
                    if (typeof validateResult === 'boolean') {
                        if (validateResult) {
                            addEmails(value);
                        }
                        else {
                            inputValue = value;
                        }
                    }
                    else {
                        // handle promise
                        setSpinning(true);
                        if ((yield (validateEmail === null || validateEmail === void 0 ? void 0 : validateEmail(value))) === true) {
                            addEmails(value);
                            setSpinning(false);
                        }
                        else {
                            inputValue = value;
                        }
                    }
                }
                else {
                    inputValue = value;
                }
            }
        }
        setEmails([...emails, ...validEmails]);
        setInputValue(inputValue);
        if (validEmails.length) {
            onChange === null || onChange === void 0 ? void 0 : onChange([...emails, ...validEmails]);
        }
        if (inputValue !== inputValue) {
            onChangeInput === null || onChangeInput === void 0 ? void 0 : onChangeInput(inputValue);
        }
    }), [delimiter, emails, enable, onChange, onChangeInput, onDisabled, validateEmail]);
    const onChangeInputValue = React.useCallback((value) => __awaiter(this, void 0, void 0, function* () {
        yield findEmailAddress(value);
        onChangeInput === null || onChangeInput === void 0 ? void 0 : onChangeInput(value);
    }), [findEmailAddress, onChangeInput]);
    const removeEmail = React.useCallback((index, isDisabled) => {
        if (isDisabled) {
            return;
        }
        const _emails = [...emails.slice(0, index), ...emails.slice(index + 1)];
        setEmails(_emails);
        onChange === null || onChange === void 0 ? void 0 : onChange(_emails);
    }, [emails, onChange]);
    const handleOnKeydown = React.useCallback((e) => {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        switch (e.key) {
            case 'Enter':
                e.preventDefault();
                break;
            case 'Backspace':
                if (!e.currentTarget.value) {
                    removeEmail(emails.length - 1, false);
                }
                break;
            default:
        }
    }, [emails.length, onKeyDown, removeEmail]);
    const handleOnKeyup = React.useCallback((e) => __awaiter(this, void 0, void 0, function* () {
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
        switch (e.key) {
            case 'Enter':
            case 'Backspace':
                yield findEmailAddress(e.currentTarget.value, true);
                break;
            default:
        }
    }), [findEmailAddress, onKeyUp]);
    const handleOnChange = React.useCallback((e) => __awaiter(this, void 0, void 0, function* () { return yield onChangeInputValue(e.currentTarget.value); }), [onChangeInputValue]);
    const handleOnBlur = React.useCallback((e) => __awaiter(this, void 0, void 0, function* () {
        setFocused(false);
        yield findEmailAddress(e.currentTarget.value, true);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }), [findEmailAddress, onBlur]);
    const handleOnFocus = React.useCallback(() => {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [onFocus]);
    React.useEffect(() => {
        var _a;
        setEmails((_a = props.emails) !== null && _a !== void 0 ? _a : []);
    }, [props.emails]);
    return (React.createElement("div", { className: `${className} ${noClass ? '' : 'react-multi-email'} ${focused ? 'focused' : ''} ${inputValue === '' && emails.length === 0 ? 'empty' : ''}`, style: style, onClick: () => { var _a; return (_a = emailInputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } },
        spinning && (spinner === null || spinner === void 0 ? void 0 : spinner()),
        placeholder ? React.createElement("span", { "data-placeholder": true }, placeholder) : null,
        React.createElement("div", { className: 'data-labels', style: { opacity: spinning ? 0.45 : 1.0, display: 'contents', flexWrap: 'inherit' } }, emails.map((email, index) => getLabel(email, index, removeEmail))),
        React.createElement("input", { id: id, style: { opacity: spinning ? 0.45 : 1.0 }, ref: emailInputRef, type: 'text', value: inputValue, onFocus: handleOnFocus, onBlur: handleOnBlur, onChange: handleOnChange, onKeyDown: handleOnKeydown, onKeyUp: handleOnKeyup, autoFocus: autoFocus, className: inputClassName, autoComplete: autoComplete })));
}
exports.ReactMultiEmail = ReactMultiEmail;


/***/ }),

/***/ 37217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(68490), exports);
__exportStar(__webpack_require__(83962), exports);


/***/ }),

/***/ 68490:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// forked from https://github.com/chriso/validator.js
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isEmail = void 0;
const defaultFqdnOptions = {
    requireTld: true,
    allowUnderscores: false,
    allowTrailingDot: false,
};
const defaultEmailOptions = {
    allowDisplayName: false,
    requireDisplayName: false,
    allowUtf8LocalPart: true,
    requireTld: true,
};
const displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
const emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
const quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
const emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
const quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
    let min = 0;
    let max;
    const len = encodeURI(str).split(/%..|./).length - 1;
    if (options) {
        min = Number(options.min) || 0;
        max = Number(options.max);
    }
    return len >= min && (typeof max === 'undefined' || len <= max);
}
function isFQDN(str, options) {
    options = Object.assign(Object.assign({}, defaultFqdnOptions), options);
    /* Remove the optional trailing dot before checking validity */
    if (options.allowTrailingDot && str[str.length - 1] === '.') {
        str = str.substring(0, str.length - 1);
    }
    const parts = str.split('.');
    if (options.requireTld) {
        const tld = '' + parts.pop();
        if (!parts.length ||
            !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
            return false;
        }
        // disallow spaces
        if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
            return false;
        }
    }
    for (let part, i = 0; i < parts.length; i++) {
        part = parts[i];
        if (options.allowUnderscores) {
            part = part.replace(/_/g, '');
        }
        if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
            return false;
        }
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) {
            return false;
        }
        if (part[0] === '-' || part[part.length - 1] === '-') {
            return false;
        }
    }
    return true;
}
function isEmail(str, options) {
    options = Object.assign(Object.assign({}, defaultEmailOptions), options);
    if (options.requireDisplayName || options.allowDisplayName) {
        const displayEmail = str.match(displayName);
        if (displayEmail) {
            str = displayEmail[1];
        }
        else if (options.requireDisplayName) {
            return false;
        }
    }
    const parts = str.split('@');
    const domain = '' + parts.pop();
    const lowerDomain = domain.toLowerCase();
    let user = parts.join('@');
    if (lowerDomain === 'gmail.com' || lowerDomain === 'googlemail.com') {
        user = user.replace(/\./g, '').toLowerCase();
    }
    if (!isByteLength(user, { max: 64 }) || !isByteLength(domain, { max: 254 })) {
        return false;
    }
    if (!isFQDN(domain, { requireTld: options.requireTld })) {
        return false;
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allowUtf8LocalPart
            ? quotedEmailUserUtf8.test(user)
            : quotedEmailUser.test(user);
    }
    const pattern = options.allowUtf8LocalPart
        ? emailUserUtf8Part
        : emailUserPart;
    const userParts = user.split('.');
    for (let i = 0; i < userParts.length; i++) {
        if (!pattern.test(userParts[i])) {
            return false;
        }
    }
    return true;
}
exports.isEmail = isEmail;


/***/ }),

/***/ 58949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IGNORE_CLASS_NAME": function() { return /* binding */ IGNORE_CLASS_NAME; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, props);
    };

    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_0__.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),

/***/ 36829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": function() { return /* reexport */ Manager; },
  "Popper": function() { return /* reexport */ Popper; },
  "Reference": function() { return /* reexport */ Reference; },
  "usePopper": function() { return /* reexport */ usePopper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Manager.js

var ManagerReferenceNodeContext = react.createContext();
var ManagerReferenceNodeSetterContext = react.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = react.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = react.useRef(false);
  react.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = react.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/react.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/react.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/usePopper.js





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Popper.js





var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var Popper_EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? Popper_EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = react.useContext(ManagerReferenceNodeContext);

  var _React$useState = react.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = react.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  react.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = react.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = react.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Reference.js




function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = react.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = react.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  react.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  react.useEffect(function () {
    warning_default()(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/index.js
// Public components




 // Public types

/***/ }),

/***/ 59852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 46747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89043);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86755);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });














 // Types



/***/ }),

/***/ 41909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 81262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41909);
/* harmony import */ var _notifyManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(101);
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21216);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT).catch(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,_logger__WEBPACK_IMPORTED_MODULE_2__/* .getLogger */ .j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new _retryer__WEBPACK_IMPORTED_MODULE_3__/* .Retryer */ .m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    _notifyManager__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),

/***/ 101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 40068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94578);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52943);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52288);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 89043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var core_mutation = __webpack_require__(81262);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new core_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(40068);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/infiniteQueryBehavior.js


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,utils/* getAbortController */.G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,retryer/* isCancelable */.LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,retryer/* isCancelable */.LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 21216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59852);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40068);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 52943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 86755:
/***/ (function() {



/***/ }),

/***/ 52288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationFn: arg1
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46747);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48073);



/***/ }),

/***/ 48073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useMutation": function() { return /* reexport */ useMutation; },
  "useQuery": function() { return /* reexport */ useQuery; }
});

// UNUSED EXPORTS: Hydrate, QueryErrorResetBoundary, useHydrate, useInfiniteQuery, useIsFetching, useIsMutating, useQueries, useQueryClient, useQueryErrorResetBoundary

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(101);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(41909);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(52288);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/mutation.js
var mutation = __webpack_require__(81262);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(52943);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/mutationObserver.js





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, (0,esm_extends/* default */.Z)({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();

    var result = (0,esm_extends/* default */.Z)({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useMutation.js






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  var queryClient = useQueryClient();
  var obsRef = react.useRef();

  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = react.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(utils/* noop */.ZT);
  }, []);

  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }

  return (0,esm_extends/* default */.Z)({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
// EXTERNAL MODULE: ./node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(59852);
// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(21216);
;// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
;// CONCATENATED MODULE: ./node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 89154:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.isNative = void 0;
var NativeSpeechRecognition = typeof window !== 'undefined' && (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition || window.oSpeechRecognition);

var isNative = function isNative(SpeechRecognition) {
  return SpeechRecognition === NativeSpeechRecognition;
};

exports.isNative = isNative;
var _default = NativeSpeechRecognition;
exports["default"] = _default;

/***/ }),

/***/ 4099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _isAndroid = _interopRequireDefault(__webpack_require__(91983));

var _utils = __webpack_require__(11665);

var _NativeSpeechRecognition = __webpack_require__(89154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RecognitionManager = /*#__PURE__*/function () {
  function RecognitionManager(SpeechRecognition) {
    _classCallCheck(this, RecognitionManager);

    this.recognition = null;
    this.pauseAfterDisconnect = false;
    this.interimTranscript = '';
    this.finalTranscript = '';
    this.listening = false;
    this.isMicrophoneAvailable = true;
    this.subscribers = {};

    this.onStopListening = function () {};

    this.previousResultWasFinalOnly = false;
    this.resetTranscript = this.resetTranscript.bind(this);
    this.startListening = this.startListening.bind(this);
    this.stopListening = this.stopListening.bind(this);
    this.abortListening = this.abortListening.bind(this);
    this.setSpeechRecognition = this.setSpeechRecognition.bind(this);
    this.disableRecognition = this.disableRecognition.bind(this);
    this.setSpeechRecognition(SpeechRecognition);

    if ((0, _isAndroid["default"])()) {
      this.updateFinalTranscript = (0, _utils.debounce)(this.updateFinalTranscript, 250, true);
    }
  }

  _createClass(RecognitionManager, [{
    key: "setSpeechRecognition",
    value: function setSpeechRecognition(SpeechRecognition) {
      var browserSupportsRecogniser = !!SpeechRecognition && ((0, _NativeSpeechRecognition.isNative)(SpeechRecognition) || (0, _utils.browserSupportsPolyfills)());

      if (browserSupportsRecogniser) {
        this.disableRecognition();
        this.recognition = new SpeechRecognition();
        this.recognition.continuous = false;
        this.recognition.interimResults = true;
        this.recognition.onresult = this.updateTranscript.bind(this);
        this.recognition.onend = this.onRecognitionDisconnect.bind(this);
        this.recognition.onerror = this.onError.bind(this);
      }

      this.emitBrowserSupportsSpeechRecognitionChange(browserSupportsRecogniser);
    }
  }, {
    key: "subscribe",
    value: function subscribe(id, callbacks) {
      this.subscribers[id] = callbacks;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(id) {
      delete this.subscribers[id];
    }
  }, {
    key: "emitListeningChange",
    value: function emitListeningChange(listening) {
      var _this = this;

      this.listening = listening;
      Object.keys(this.subscribers).forEach(function (id) {
        var onListeningChange = _this.subscribers[id].onListeningChange;
        onListeningChange(listening);
      });
    }
  }, {
    key: "emitMicrophoneAvailabilityChange",
    value: function emitMicrophoneAvailabilityChange(isMicrophoneAvailable) {
      var _this2 = this;

      this.isMicrophoneAvailable = isMicrophoneAvailable;
      Object.keys(this.subscribers).forEach(function (id) {
        var onMicrophoneAvailabilityChange = _this2.subscribers[id].onMicrophoneAvailabilityChange;
        onMicrophoneAvailabilityChange(isMicrophoneAvailable);
      });
    }
  }, {
    key: "emitTranscriptChange",
    value: function emitTranscriptChange(interimTranscript, finalTranscript) {
      var _this3 = this;

      Object.keys(this.subscribers).forEach(function (id) {
        var onTranscriptChange = _this3.subscribers[id].onTranscriptChange;
        onTranscriptChange(interimTranscript, finalTranscript);
      });
    }
  }, {
    key: "emitClearTranscript",
    value: function emitClearTranscript() {
      var _this4 = this;

      Object.keys(this.subscribers).forEach(function (id) {
        var onClearTranscript = _this4.subscribers[id].onClearTranscript;
        onClearTranscript();
      });
    }
  }, {
    key: "emitBrowserSupportsSpeechRecognitionChange",
    value: function emitBrowserSupportsSpeechRecognitionChange(browserSupportsSpeechRecognitionChange) {
      var _this5 = this;

      Object.keys(this.subscribers).forEach(function (id) {
        var _this5$subscribers$id = _this5.subscribers[id],
            onBrowserSupportsSpeechRecognitionChange = _this5$subscribers$id.onBrowserSupportsSpeechRecognitionChange,
            onBrowserSupportsContinuousListeningChange = _this5$subscribers$id.onBrowserSupportsContinuousListeningChange;
        onBrowserSupportsSpeechRecognitionChange(browserSupportsSpeechRecognitionChange);
        onBrowserSupportsContinuousListeningChange(browserSupportsSpeechRecognitionChange);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect(disconnectType) {
      if (this.recognition && this.listening) {
        switch (disconnectType) {
          case 'ABORT':
            this.pauseAfterDisconnect = true;
            this.abort();
            break;

          case 'RESET':
            this.pauseAfterDisconnect = false;
            this.abort();
            break;

          case 'STOP':
          default:
            this.pauseAfterDisconnect = true;
            this.stop();
        }
      }
    }
  }, {
    key: "disableRecognition",
    value: function disableRecognition() {
      if (this.recognition) {
        this.recognition.onresult = function () {};

        this.recognition.onend = function () {};

        this.recognition.onerror = function () {};

        if (this.listening) {
          this.stopListening();
        }
      }
    }
  }, {
    key: "onError",
    value: function onError(event) {
      if (event && event.error && event.error === 'not-allowed') {
        this.emitMicrophoneAvailabilityChange(false);
        this.disableRecognition();
      }
    }
  }, {
    key: "onRecognitionDisconnect",
    value: function onRecognitionDisconnect() {
      this.onStopListening();
      this.listening = false;

      if (this.pauseAfterDisconnect) {
        this.emitListeningChange(false);
      } else if (this.recognition) {
        if (this.recognition.continuous) {
          this.startListening({
            continuous: this.recognition.continuous
          });
        } else {
          this.emitListeningChange(false);
        }
      }

      this.pauseAfterDisconnect = false;
    }
  }, {
    key: "updateTranscript",
    value: function updateTranscript(_ref) {
      var results = _ref.results,
          resultIndex = _ref.resultIndex;
      var currentIndex = resultIndex === undefined ? results.length - 1 : resultIndex;
      this.interimTranscript = '';
      this.finalTranscript = '';

      for (var i = currentIndex; i < results.length; ++i) {
        if (results[i].isFinal && (!(0, _isAndroid["default"])() || results[i][0].confidence > 0)) {
          this.updateFinalTranscript(results[i][0].transcript);
        } else {
          this.interimTranscript = (0, _utils.concatTranscripts)(this.interimTranscript, results[i][0].transcript);
        }
      }

      var isDuplicateResult = false;

      if (this.interimTranscript === '' && this.finalTranscript !== '') {
        if (this.previousResultWasFinalOnly) {
          isDuplicateResult = true;
        }

        this.previousResultWasFinalOnly = true;
      } else {
        this.previousResultWasFinalOnly = false;
      }

      if (!isDuplicateResult) {
        this.emitTranscriptChange(this.interimTranscript, this.finalTranscript);
      }
    }
  }, {
    key: "updateFinalTranscript",
    value: function updateFinalTranscript(newFinalTranscript) {
      this.finalTranscript = (0, _utils.concatTranscripts)(this.finalTranscript, newFinalTranscript);
    }
  }, {
    key: "resetTranscript",
    value: function resetTranscript() {
      this.disconnect('RESET');
    }
  }, {
    key: "startListening",
    value: function () {
      var _startListening = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref2,
            _ref2$continuous,
            continuous,
            language,
            isContinuousChanged,
            isLanguageChanged,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$continuous = _ref2.continuous, continuous = _ref2$continuous === void 0 ? false : _ref2$continuous, language = _ref2.language;

                if (this.recognition) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                isContinuousChanged = continuous !== this.recognition.continuous;
                isLanguageChanged = language && language !== this.recognition.lang;

                if (!(isContinuousChanged || isLanguageChanged)) {
                  _context.next = 11;
                  break;
                }

                if (!this.listening) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return this.stopListening();

              case 9:
                this.recognition.continuous = isContinuousChanged ? continuous : this.recognition.continuous;
                this.recognition.lang = isLanguageChanged ? language : this.recognition.lang;

              case 11:
                if (this.listening) {
                  _context.next = 22;
                  break;
                }

                if (!this.recognition.continuous) {
                  this.resetTranscript();
                  this.emitClearTranscript();
                }

                _context.prev = 13;
                _context.next = 16;
                return this.start();

              case 16:
                this.emitListeningChange(true);
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](13);

                // DOMExceptions indicate a redundant microphone start - safe to swallow
                if (!(_context.t0 instanceof DOMException)) {
                  this.emitMicrophoneAvailabilityChange(false);
                }

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 19]]);
      }));

      function startListening() {
        return _startListening.apply(this, arguments);
      }

      return startListening;
    }()
  }, {
    key: "abortListening",
    value: function () {
      var _abortListening = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this6 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.disconnect('ABORT');
                this.emitListeningChange(false);
                _context2.next = 4;
                return new Promise(function (resolve) {
                  _this6.onStopListening = resolve;
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function abortListening() {
        return _abortListening.apply(this, arguments);
      }

      return abortListening;
    }()
  }, {
    key: "stopListening",
    value: function () {
      var _stopListening = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this7 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.disconnect('STOP');
                this.emitListeningChange(false);
                _context3.next = 4;
                return new Promise(function (resolve) {
                  _this7.onStopListening = resolve;
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function stopListening() {
        return _stopListening.apply(this, arguments);
      }

      return stopListening;
    }()
  }, {
    key: "getRecognition",
    value: function getRecognition() {
      return this.recognition;
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.recognition && !this.listening)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return this.recognition.start();

              case 3:
                this.listening = true;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (this.recognition && this.listening) {
        this.recognition.stop();
        this.listening = false;
      }
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.recognition && this.listening) {
        this.recognition.abort();
        this.listening = false;
      }
    }
  }]);

  return RecognitionManager;
}();

exports["default"] = RecognitionManager;

/***/ }),

/***/ 25924:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.useSpeechRecognition = void 0;

var _react = __webpack_require__(67294);

var _utils = __webpack_require__(11665);

var _actions = __webpack_require__(53697);

var _reducers = __webpack_require__(8911);

var _RecognitionManager = _interopRequireDefault(__webpack_require__(4099));

var _isAndroid = _interopRequireDefault(__webpack_require__(91983));

var _NativeSpeechRecognition = _interopRequireDefault(__webpack_require__(89154));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _browserSupportsSpeechRecognition = !!_NativeSpeechRecognition["default"];

var _browserSupportsContinuousListening = _browserSupportsSpeechRecognition && !(0, _isAndroid["default"])();

var recognitionManager;

var useSpeechRecognition = function useSpeechRecognition() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$transcribing = _ref.transcribing,
      transcribing = _ref$transcribing === void 0 ? true : _ref$transcribing,
      _ref$clearTranscriptO = _ref.clearTranscriptOnListen,
      clearTranscriptOnListen = _ref$clearTranscriptO === void 0 ? true : _ref$clearTranscriptO,
      _ref$commands = _ref.commands,
      commands = _ref$commands === void 0 ? [] : _ref$commands;

  var _useState = (0, _react.useState)(SpeechRecognition.getRecognitionManager()),
      _useState2 = _slicedToArray(_useState, 1),
      recognitionManager = _useState2[0];

  var _useState3 = (0, _react.useState)(_browserSupportsSpeechRecognition),
      _useState4 = _slicedToArray(_useState3, 2),
      browserSupportsSpeechRecognition = _useState4[0],
      setBrowserSupportsSpeechRecognition = _useState4[1];

  var _useState5 = (0, _react.useState)(_browserSupportsContinuousListening),
      _useState6 = _slicedToArray(_useState5, 2),
      browserSupportsContinuousListening = _useState6[0],
      setBrowserSupportsContinuousListening = _useState6[1];

  var _useReducer = (0, _react.useReducer)(_reducers.transcriptReducer, {
    interimTranscript: recognitionManager.interimTranscript,
    finalTranscript: ''
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      interimTranscript = _useReducer2$.interimTranscript,
      finalTranscript = _useReducer2$.finalTranscript,
      dispatch = _useReducer2[1];

  var _useState7 = (0, _react.useState)(recognitionManager.listening),
      _useState8 = _slicedToArray(_useState7, 2),
      listening = _useState8[0],
      setListening = _useState8[1];

  var _useState9 = (0, _react.useState)(recognitionManager.isMicrophoneAvailable),
      _useState10 = _slicedToArray(_useState9, 2),
      isMicrophoneAvailable = _useState10[0],
      setMicrophoneAvailable = _useState10[1];

  var commandsRef = (0, _react.useRef)(commands);
  commandsRef.current = commands;

  var dispatchClearTranscript = function dispatchClearTranscript() {
    dispatch((0, _actions.clearTranscript)());
  };

  var resetTranscript = (0, _react.useCallback)(function () {
    recognitionManager.resetTranscript();
    dispatchClearTranscript();
  }, [recognitionManager]);

  var testFuzzyMatch = function testFuzzyMatch(command, input, fuzzyMatchingThreshold) {
    var commandToString = _typeof(command) === 'object' ? command.toString() : command;
    var commandWithoutSpecials = commandToString.replace(/[&/\\#,+()!$~%.'":*?<>{}]/g, '').replace(/  +/g, ' ').trim();
    var howSimilar = (0, _utils.compareTwoStringsUsingDiceCoefficient)(commandWithoutSpecials, input);

    if (howSimilar >= fuzzyMatchingThreshold) {
      return {
        command: command,
        commandWithoutSpecials: commandWithoutSpecials,
        howSimilar: howSimilar,
        isFuzzyMatch: true
      };
    }

    return null;
  };

  var testMatch = function testMatch(command, input) {
    var pattern = (0, _utils.commandToRegExp)(command);
    var result = pattern.exec(input);

    if (result) {
      return {
        command: command,
        parameters: result.slice(1)
      };
    }

    return null;
  };

  var matchCommands = (0, _react.useCallback)(function (newInterimTranscript, newFinalTranscript) {
    commandsRef.current.forEach(function (_ref2) {
      var command = _ref2.command,
          callback = _ref2.callback,
          _ref2$matchInterim = _ref2.matchInterim,
          matchInterim = _ref2$matchInterim === void 0 ? false : _ref2$matchInterim,
          _ref2$isFuzzyMatch = _ref2.isFuzzyMatch,
          isFuzzyMatch = _ref2$isFuzzyMatch === void 0 ? false : _ref2$isFuzzyMatch,
          _ref2$fuzzyMatchingTh = _ref2.fuzzyMatchingThreshold,
          fuzzyMatchingThreshold = _ref2$fuzzyMatchingTh === void 0 ? 0.8 : _ref2$fuzzyMatchingTh,
          _ref2$bestMatchOnly = _ref2.bestMatchOnly,
          bestMatchOnly = _ref2$bestMatchOnly === void 0 ? false : _ref2$bestMatchOnly;
      var input = !newFinalTranscript && matchInterim ? newInterimTranscript.trim() : newFinalTranscript.trim();
      var subcommands = Array.isArray(command) ? command : [command];
      var results = subcommands.map(function (subcommand) {
        if (isFuzzyMatch) {
          return testFuzzyMatch(subcommand, input, fuzzyMatchingThreshold);
        }

        return testMatch(subcommand, input);
      }).filter(function (x) {
        return x;
      });

      if (isFuzzyMatch && bestMatchOnly && results.length >= 2) {
        results.sort(function (a, b) {
          return b.howSimilar - a.howSimilar;
        });
        var _results$ = results[0],
            _command = _results$.command,
            commandWithoutSpecials = _results$.commandWithoutSpecials,
            howSimilar = _results$.howSimilar;
        callback(commandWithoutSpecials, input, howSimilar, {
          command: _command,
          resetTranscript: resetTranscript
        });
      } else {
        results.forEach(function (result) {
          if (result.isFuzzyMatch) {
            var _command2 = result.command,
                _commandWithoutSpecials = result.commandWithoutSpecials,
                _howSimilar = result.howSimilar;
            callback(_commandWithoutSpecials, input, _howSimilar, {
              command: _command2,
              resetTranscript: resetTranscript
            });
          } else {
            var _command3 = result.command,
                parameters = result.parameters;
            callback.apply(void 0, _toConsumableArray(parameters).concat([{
              command: _command3,
              resetTranscript: resetTranscript
            }]));
          }
        });
      }
    });
  }, [resetTranscript]);
  var handleTranscriptChange = (0, _react.useCallback)(function (newInterimTranscript, newFinalTranscript) {
    if (transcribing) {
      dispatch((0, _actions.appendTranscript)(newInterimTranscript, newFinalTranscript));
    }

    matchCommands(newInterimTranscript, newFinalTranscript);
  }, [matchCommands, transcribing]);
  var handleClearTranscript = (0, _react.useCallback)(function () {
    if (clearTranscriptOnListen) {
      dispatchClearTranscript();
    }
  }, [clearTranscriptOnListen]);
  (0, _react.useEffect)(function () {
    var id = SpeechRecognition.counter;
    SpeechRecognition.counter += 1;
    var callbacks = {
      onListeningChange: setListening,
      onMicrophoneAvailabilityChange: setMicrophoneAvailable,
      onTranscriptChange: handleTranscriptChange,
      onClearTranscript: handleClearTranscript,
      onBrowserSupportsSpeechRecognitionChange: setBrowserSupportsSpeechRecognition,
      onBrowserSupportsContinuousListeningChange: setBrowserSupportsContinuousListening
    };
    recognitionManager.subscribe(id, callbacks);
    return function () {
      recognitionManager.unsubscribe(id);
    };
  }, [transcribing, clearTranscriptOnListen, recognitionManager, handleTranscriptChange, handleClearTranscript]);
  var transcript = (0, _utils.concatTranscripts)(finalTranscript, interimTranscript);
  return {
    transcript: transcript,
    interimTranscript: interimTranscript,
    finalTranscript: finalTranscript,
    listening: listening,
    isMicrophoneAvailable: isMicrophoneAvailable,
    resetTranscript: resetTranscript,
    browserSupportsSpeechRecognition: browserSupportsSpeechRecognition,
    browserSupportsContinuousListening: browserSupportsContinuousListening
  };
};

exports.useSpeechRecognition = useSpeechRecognition;
var SpeechRecognition = {
  counter: 0,
  applyPolyfill: function applyPolyfill(PolyfillSpeechRecognition) {
    if (recognitionManager) {
      recognitionManager.setSpeechRecognition(PolyfillSpeechRecognition);
    } else {
      recognitionManager = new _RecognitionManager["default"](PolyfillSpeechRecognition);
    }

    var browserSupportsPolyfill = !!PolyfillSpeechRecognition && (0, _utils.browserSupportsPolyfills)();
    _browserSupportsSpeechRecognition = browserSupportsPolyfill;
    _browserSupportsContinuousListening = browserSupportsPolyfill;
  },
  removePolyfill: function removePolyfill() {
    if (recognitionManager) {
      recognitionManager.setSpeechRecognition(_NativeSpeechRecognition["default"]);
    } else {
      recognitionManager = new _RecognitionManager["default"](_NativeSpeechRecognition["default"]);
    }

    _browserSupportsSpeechRecognition = !!_NativeSpeechRecognition["default"];
    _browserSupportsContinuousListening = _browserSupportsSpeechRecognition && !(0, _isAndroid["default"])();
  },
  getRecognitionManager: function getRecognitionManager() {
    if (!recognitionManager) {
      recognitionManager = new _RecognitionManager["default"](_NativeSpeechRecognition["default"]);
    }

    return recognitionManager;
  },
  getRecognition: function getRecognition() {
    var recognitionManager = SpeechRecognition.getRecognitionManager();
    return recognitionManager.getRecognition();
  },
  startListening: function () {
    var _startListening = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _ref3,
          continuous,
          language,
          recognitionManager,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref3 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, continuous = _ref3.continuous, language = _ref3.language;
              recognitionManager = SpeechRecognition.getRecognitionManager();
              _context.next = 4;
              return recognitionManager.startListening({
                continuous: continuous,
                language: language
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function startListening() {
      return _startListening.apply(this, arguments);
    }

    return startListening;
  }(),
  stopListening: function () {
    var _stopListening = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var recognitionManager;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              recognitionManager = SpeechRecognition.getRecognitionManager();
              _context2.next = 3;
              return recognitionManager.stopListening();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function stopListening() {
      return _stopListening.apply(this, arguments);
    }

    return stopListening;
  }(),
  abortListening: function () {
    var _abortListening = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var recognitionManager;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              recognitionManager = SpeechRecognition.getRecognitionManager();
              _context3.next = 3;
              return recognitionManager.abortListening();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function abortListening() {
      return _abortListening.apply(this, arguments);
    }

    return abortListening;
  }(),
  browserSupportsSpeechRecognition: function browserSupportsSpeechRecognition() {
    return _browserSupportsSpeechRecognition;
  },
  browserSupportsContinuousListening: function browserSupportsContinuousListening() {
    return _browserSupportsContinuousListening;
  }
};
var _default = SpeechRecognition;
exports["default"] = _default;

/***/ }),

/***/ 53697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.appendTranscript = exports.clearTranscript = void 0;

var _constants = __webpack_require__(40266);

var clearTranscript = function clearTranscript() {
  return {
    type: _constants.CLEAR_TRANSCRIPT
  };
};

exports.clearTranscript = clearTranscript;

var appendTranscript = function appendTranscript(interimTranscript, finalTranscript) {
  return {
    type: _constants.APPEND_TRANSCRIPT,
    payload: {
      interimTranscript: interimTranscript,
      finalTranscript: finalTranscript
    }
  };
};

exports.appendTranscript = appendTranscript;

/***/ }),

/***/ 40266:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.APPEND_TRANSCRIPT = exports.CLEAR_TRANSCRIPT = void 0;
var CLEAR_TRANSCRIPT = 'CLEAR_TRANSCRIPT';
exports.CLEAR_TRANSCRIPT = CLEAR_TRANSCRIPT;
var APPEND_TRANSCRIPT = 'APPEND_TRANSCRIPT';
exports.APPEND_TRANSCRIPT = APPEND_TRANSCRIPT;

/***/ }),

/***/ 52515:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "x6", ({
  enumerable: true,
  get: function get() {
    return _SpeechRecognition.useSpeechRecognition;
  }
}));
exports.ZP = void 0;

var _SpeechRecognition = _interopRequireWildcard(__webpack_require__(25924));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _SpeechRecognition["default"];
exports.ZP = _default;

/***/ }),

/***/ 91983:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default() {
  return /(android)/i.test(typeof navigator !== 'undefined' ? navigator.userAgent : '');
};

exports["default"] = _default;

/***/ }),

/***/ 8911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.transcriptReducer = void 0;

var _constants = __webpack_require__(40266);

var _utils = __webpack_require__(11665);

var transcriptReducer = function transcriptReducer(state, action) {
  switch (action.type) {
    case _constants.CLEAR_TRANSCRIPT:
      return {
        interimTranscript: '',
        finalTranscript: ''
      };

    case _constants.APPEND_TRANSCRIPT:
      return {
        interimTranscript: action.payload.interimTranscript,
        finalTranscript: (0, _utils.concatTranscripts)(state.finalTranscript, action.payload.finalTranscript)
      };

    default:
      throw new Error();
  }
};

exports.transcriptReducer = transcriptReducer;

/***/ }),

/***/ 11665:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.browserSupportsPolyfills = exports.compareTwoStringsUsingDiceCoefficient = exports.commandToRegExp = exports.concatTranscripts = exports.debounce = void 0;

var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

exports.debounce = debounce;

var concatTranscripts = function concatTranscripts() {
  for (var _len = arguments.length, transcriptParts = new Array(_len), _key = 0; _key < _len; _key++) {
    transcriptParts[_key] = arguments[_key];
  }

  return transcriptParts.map(function (t) {
    return t.trim();
  }).join(' ').trim();
}; // The command matching code is a modified version of Backbone.Router by Jeremy Ashkenas, under the MIT license.


exports.concatTranscripts = concatTranscripts;
var optionalParam = /\s*\((.*?)\)\s*/g;
var optionalRegex = /(\(\?:[^)]+\))\?/g;
var namedParam = /(\(\?)?:\w+/g;
var splatParam = /\*/g;
var escapeRegExp = /[-{}[\]+?.,\\^$|#]/g;

var commandToRegExp = function commandToRegExp(command) {
  if (command instanceof RegExp) {
    return new RegExp(command.source, 'i');
  }

  command = command.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function (match, optional) {
    return optional ? match : '([^\\s]+)';
  }).replace(splatParam, '(.*?)').replace(optionalRegex, '\\s*$1?\\s*');
  return new RegExp('^' + command + '$', 'i');
}; // this is from https://github.com/aceakash/string-similarity


exports.commandToRegExp = commandToRegExp;

var compareTwoStringsUsingDiceCoefficient = function compareTwoStringsUsingDiceCoefficient(first, second) {
  first = first.replace(/\s+/g, '').toLowerCase();
  second = second.replace(/\s+/g, '').toLowerCase();
  if (!first.length && !second.length) return 1; // if both are empty strings

  if (!first.length || !second.length) return 0; // if only one is empty string

  if (first === second) return 1; // identical

  if (first.length === 1 && second.length === 1) return 0; // both are 1-letter strings

  if (first.length < 2 || second.length < 2) return 0; // if either is a 1-letter string

  var firstBigrams = new Map();

  for (var i = 0; i < first.length - 1; i++) {
    var bigram = first.substring(i, i + 2);
    var count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
    firstBigrams.set(bigram, count);
  }

  var intersectionSize = 0;

  for (var _i = 0; _i < second.length - 1; _i++) {
    var _bigram = second.substring(_i, _i + 2);

    var _count = firstBigrams.has(_bigram) ? firstBigrams.get(_bigram) : 0;

    if (_count > 0) {
      firstBigrams.set(_bigram, _count - 1);
      intersectionSize++;
    }
  }

  return 2.0 * intersectionSize / (first.length + second.length - 2);
};

exports.compareTwoStringsUsingDiceCoefficient = compareTwoStringsUsingDiceCoefficient;

var browserSupportsPolyfills = function browserSupportsPolyfills() {
  return typeof window !== 'undefined' && window.navigator !== undefined && window.navigator.mediaDevices !== undefined && window.navigator.mediaDevices.getUserMedia !== undefined && (window.AudioContext !== undefined || window.webkitAudioContext !== undefined);
};

exports.browserSupportsPolyfills = browserSupportsPolyfills;

/***/ }),

/***/ 53787:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;/*! showdown v 2.1.0 - 21-04-2022 */
(function(){
/**
 * Created by Tivie on 13-07-2015.
 */

function getDefaultOpts (simple) {
  'use strict';

  var defaultOptions = {
    omitExtraWLInCodeBlocks: {
      defaultValue: false,
      describe: 'Omit the default extra whiteline added to code blocks',
      type: 'boolean'
    },
    noHeaderId: {
      defaultValue: false,
      describe: 'Turn on/off generated header id',
      type: 'boolean'
    },
    prefixHeaderId: {
      defaultValue: false,
      describe: 'Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic \'section-\' prefix',
      type: 'string'
    },
    rawPrefixHeaderId: {
      defaultValue: false,
      describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
      type: 'boolean'
    },
    ghCompatibleHeaderId: {
      defaultValue: false,
      describe: 'Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)',
      type: 'boolean'
    },
    rawHeaderId: {
      defaultValue: false,
      describe: 'Remove only spaces, \' and " from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids',
      type: 'boolean'
    },
    headerLevelStart: {
      defaultValue: false,
      describe: 'The header blocks level start',
      type: 'integer'
    },
    parseImgDimensions: {
      defaultValue: false,
      describe: 'Turn on/off image dimension parsing',
      type: 'boolean'
    },
    simplifiedAutoLink: {
      defaultValue: false,
      describe: 'Turn on/off GFM autolink style',
      type: 'boolean'
    },
    excludeTrailingPunctuationFromURLs: {
      defaultValue: false,
      describe: 'Excludes trailing punctuation from links generated with autoLinking',
      type: 'boolean'
    },
    literalMidWordUnderscores: {
      defaultValue: false,
      describe: 'Parse midword underscores as literal underscores',
      type: 'boolean'
    },
    literalMidWordAsterisks: {
      defaultValue: false,
      describe: 'Parse midword asterisks as literal asterisks',
      type: 'boolean'
    },
    strikethrough: {
      defaultValue: false,
      describe: 'Turn on/off strikethrough support',
      type: 'boolean'
    },
    tables: {
      defaultValue: false,
      describe: 'Turn on/off tables support',
      type: 'boolean'
    },
    tablesHeaderId: {
      defaultValue: false,
      describe: 'Add an id to table headers',
      type: 'boolean'
    },
    ghCodeBlocks: {
      defaultValue: true,
      describe: 'Turn on/off GFM fenced code blocks support',
      type: 'boolean'
    },
    tasklists: {
      defaultValue: false,
      describe: 'Turn on/off GFM tasklist support',
      type: 'boolean'
    },
    smoothLivePreview: {
      defaultValue: false,
      describe: 'Prevents weird effects in live previews due to incomplete input',
      type: 'boolean'
    },
    smartIndentationFix: {
      defaultValue: false,
      describe: 'Tries to smartly fix indentation in es6 strings',
      type: 'boolean'
    },
    disableForced4SpacesIndentedSublists: {
      defaultValue: false,
      describe: 'Disables the requirement of indenting nested sublists by 4 spaces',
      type: 'boolean'
    },
    simpleLineBreaks: {
      defaultValue: false,
      describe: 'Parses simple line breaks as <br> (GFM Style)',
      type: 'boolean'
    },
    requireSpaceBeforeHeadingText: {
      defaultValue: false,
      describe: 'Makes adding a space between `#` and the header text mandatory (GFM Style)',
      type: 'boolean'
    },
    ghMentions: {
      defaultValue: false,
      describe: 'Enables github @mentions',
      type: 'boolean'
    },
    ghMentionsLink: {
      defaultValue: 'https://github.com/{u}',
      describe: 'Changes the link generated by @mentions. Only applies if ghMentions option is enabled.',
      type: 'string'
    },
    encodeEmails: {
      defaultValue: true,
      describe: 'Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities',
      type: 'boolean'
    },
    openLinksInNewWindow: {
      defaultValue: false,
      describe: 'Open all links in new windows',
      type: 'boolean'
    },
    backslashEscapesHTMLTags: {
      defaultValue: false,
      describe: 'Support for HTML Tag escaping. ex: \<div>foo\</div>',
      type: 'boolean'
    },
    emoji: {
      defaultValue: false,
      describe: 'Enable emoji support. Ex: `this is a :smile: emoji`',
      type: 'boolean'
    },
    underline: {
      defaultValue: false,
      describe: 'Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`',
      type: 'boolean'
    },
    ellipsis: {
      defaultValue: true,
      describe: 'Replaces three dots with the ellipsis unicode character',
      type: 'boolean'
    },
    completeHTMLDocument: {
      defaultValue: false,
      describe: 'Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags',
      type: 'boolean'
    },
    metadata: {
      defaultValue: false,
      describe: 'Enable support for document metadata (defined at the top of the document between `«««` and `»»»` or between `---` and `---`).',
      type: 'boolean'
    },
    splitAdjacentBlockquotes: {
      defaultValue: false,
      describe: 'Split adjacent blockquote blocks',
      type: 'boolean'
    }
  };
  if (simple === false) {
    return JSON.parse(JSON.stringify(defaultOptions));
  }
  var ret = {};
  for (var opt in defaultOptions) {
    if (defaultOptions.hasOwnProperty(opt)) {
      ret[opt] = defaultOptions[opt].defaultValue;
    }
  }
  return ret;
}

function allOptionsOn () {
  'use strict';
  var options = getDefaultOpts(true),
      ret = {};
  for (var opt in options) {
    if (options.hasOwnProperty(opt)) {
      ret[opt] = true;
    }
  }
  return ret;
}

/**
 * Created by Tivie on 06-01-2015.
 */

// Private properties
var showdown = {},
    parsers = {},
    extensions = {},
    globalOptions = getDefaultOpts(true),
    setFlavor = 'vanilla',
    flavor = {
      github: {
        omitExtraWLInCodeBlocks:              true,
        simplifiedAutoLink:                   true,
        excludeTrailingPunctuationFromURLs:   true,
        literalMidWordUnderscores:            true,
        strikethrough:                        true,
        tables:                               true,
        tablesHeaderId:                       true,
        ghCodeBlocks:                         true,
        tasklists:                            true,
        disableForced4SpacesIndentedSublists: true,
        simpleLineBreaks:                     true,
        requireSpaceBeforeHeadingText:        true,
        ghCompatibleHeaderId:                 true,
        ghMentions:                           true,
        backslashEscapesHTMLTags:             true,
        emoji:                                true,
        splitAdjacentBlockquotes:             true
      },
      original: {
        noHeaderId:                           true,
        ghCodeBlocks:                         false
      },
      ghost: {
        omitExtraWLInCodeBlocks:              true,
        parseImgDimensions:                   true,
        simplifiedAutoLink:                   true,
        excludeTrailingPunctuationFromURLs:   true,
        literalMidWordUnderscores:            true,
        strikethrough:                        true,
        tables:                               true,
        tablesHeaderId:                       true,
        ghCodeBlocks:                         true,
        tasklists:                            true,
        smoothLivePreview:                    true,
        simpleLineBreaks:                     true,
        requireSpaceBeforeHeadingText:        true,
        ghMentions:                           false,
        encodeEmails:                         true
      },
      vanilla: getDefaultOpts(true),
      allOn: allOptionsOn()
    };

/**
 * helper namespace
 * @type {{}}
 */
showdown.helper = {};

/**
 * TODO LEGACY SUPPORT CODE
 * @type {{}}
 */
showdown.extensions = {};

/**
 * Set a global option
 * @static
 * @param {string} key
 * @param {*} value
 * @returns {showdown}
 */
showdown.setOption = function (key, value) {
  'use strict';
  globalOptions[key] = value;
  return this;
};

/**
 * Get a global option
 * @static
 * @param {string} key
 * @returns {*}
 */
showdown.getOption = function (key) {
  'use strict';
  return globalOptions[key];
};

/**
 * Get the global options
 * @static
 * @returns {{}}
 */
showdown.getOptions = function () {
  'use strict';
  return globalOptions;
};

/**
 * Reset global options to the default values
 * @static
 */
showdown.resetOptions = function () {
  'use strict';
  globalOptions = getDefaultOpts(true);
};

/**
 * Set the flavor showdown should use as default
 * @param {string} name
 */
showdown.setFlavor = function (name) {
  'use strict';
  if (!flavor.hasOwnProperty(name)) {
    throw Error(name + ' flavor was not found');
  }
  showdown.resetOptions();
  var preset = flavor[name];
  setFlavor = name;
  for (var option in preset) {
    if (preset.hasOwnProperty(option)) {
      globalOptions[option] = preset[option];
    }
  }
};

/**
 * Get the currently set flavor
 * @returns {string}
 */
showdown.getFlavor = function () {
  'use strict';
  return setFlavor;
};

/**
 * Get the options of a specified flavor. Returns undefined if the flavor was not found
 * @param {string} name Name of the flavor
 * @returns {{}|undefined}
 */
showdown.getFlavorOptions = function (name) {
  'use strict';
  if (flavor.hasOwnProperty(name)) {
    return flavor[name];
  }
};

/**
 * Get the default options
 * @static
 * @param {boolean} [simple=true]
 * @returns {{}}
 */
showdown.getDefaultOptions = function (simple) {
  'use strict';
  return getDefaultOpts(simple);
};

/**
 * Get or set a subParser
 *
 * subParser(name)       - Get a registered subParser
 * subParser(name, func) - Register a subParser
 * @static
 * @param {string} name
 * @param {function} [func]
 * @returns {*}
 */
showdown.subParser = function (name, func) {
  'use strict';
  if (showdown.helper.isString(name)) {
    if (typeof func !== 'undefined') {
      parsers[name] = func;
    } else {
      if (parsers.hasOwnProperty(name)) {
        return parsers[name];
      } else {
        throw Error('SubParser named ' + name + ' not registered!');
      }
    }
  }
};

/**
 * Gets or registers an extension
 * @static
 * @param {string} name
 * @param {object|object[]|function=} ext
 * @returns {*}
 */
showdown.extension = function (name, ext) {
  'use strict';

  if (!showdown.helper.isString(name)) {
    throw Error('Extension \'name\' must be a string');
  }

  name = showdown.helper.stdExtName(name);

  // Getter
  if (showdown.helper.isUndefined(ext)) {
    if (!extensions.hasOwnProperty(name)) {
      throw Error('Extension named ' + name + ' is not registered!');
    }
    return extensions[name];

    // Setter
  } else {
    // Expand extension if it's wrapped in a function
    if (typeof ext === 'function') {
      ext = ext();
    }

    // Ensure extension is an array
    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }

    var validExtension = validate(ext, name);

    if (validExtension.valid) {
      extensions[name] = ext;
    } else {
      throw Error(validExtension.error);
    }
  }
};

/**
 * Gets all extensions registered
 * @returns {{}}
 */
showdown.getAllExtensions = function () {
  'use strict';
  return extensions;
};

/**
 * Remove an extension
 * @param {string} name
 */
showdown.removeExtension = function (name) {
  'use strict';
  delete extensions[name];
};

/**
 * Removes all extensions
 */
showdown.resetExtensions = function () {
  'use strict';
  extensions = {};
};

/**
 * Validate extension
 * @param {array} extension
 * @param {string} name
 * @returns {{valid: boolean, error: string}}
 */
function validate (extension, name) {
  'use strict';

  var errMsg = (name) ? 'Error in ' + name + ' extension->' : 'Error in unnamed extension',
      ret = {
        valid: true,
        error: ''
      };

  if (!showdown.helper.isArray(extension)) {
    extension = [extension];
  }

  for (var i = 0; i < extension.length; ++i) {
    var baseMsg = errMsg + ' sub-extension ' + i + ': ',
        ext = extension[i];
    if (typeof ext !== 'object') {
      ret.valid = false;
      ret.error = baseMsg + 'must be an object, but ' + typeof ext + ' given';
      return ret;
    }

    if (!showdown.helper.isString(ext.type)) {
      ret.valid = false;
      ret.error = baseMsg + 'property "type" must be a string, but ' + typeof ext.type + ' given';
      return ret;
    }

    var type = ext.type = ext.type.toLowerCase();

    // normalize extension type
    if (type === 'language') {
      type = ext.type = 'lang';
    }

    if (type === 'html') {
      type = ext.type = 'output';
    }

    if (type !== 'lang' && type !== 'output' && type !== 'listener') {
      ret.valid = false;
      ret.error = baseMsg + 'type ' + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
      return ret;
    }

    if (type === 'listener') {
      if (showdown.helper.isUndefined(ext.listeners)) {
        ret.valid = false;
        ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
        return ret;
      }
    } else {
      if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
        ret.valid = false;
        ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
        return ret;
      }
    }

    if (ext.listeners) {
      if (typeof ext.listeners !== 'object') {
        ret.valid = false;
        ret.error = baseMsg + '"listeners" property must be an object but ' + typeof ext.listeners + ' given';
        return ret;
      }
      for (var ln in ext.listeners) {
        if (ext.listeners.hasOwnProperty(ln)) {
          if (typeof ext.listeners[ln] !== 'function') {
            ret.valid = false;
            ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln +
              ' must be a function but ' + typeof ext.listeners[ln] + ' given';
            return ret;
          }
        }
      }
    }

    if (ext.filter) {
      if (typeof ext.filter !== 'function') {
        ret.valid = false;
        ret.error = baseMsg + '"filter" must be a function, but ' + typeof ext.filter + ' given';
        return ret;
      }
    } else if (ext.regex) {
      if (showdown.helper.isString(ext.regex)) {
        ext.regex = new RegExp(ext.regex, 'g');
      }
      if (!(ext.regex instanceof RegExp)) {
        ret.valid = false;
        ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + typeof ext.regex + ' given';
        return ret;
      }
      if (showdown.helper.isUndefined(ext.replace)) {
        ret.valid = false;
        ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
        return ret;
      }
    }
  }
  return ret;
}

/**
 * Validate extension
 * @param {object} ext
 * @returns {boolean}
 */
showdown.validateExtension = function (ext) {
  'use strict';

  var validateExtension = validate(ext, null);
  if (!validateExtension.valid) {
    console.warn(validateExtension.error);
    return false;
  }
  return true;
};

/**
 * showdownjs helper functions
 */

if (!showdown.hasOwnProperty('helper')) {
  showdown.helper = {};
}

/**
 * Check if var is string
 * @static
 * @param {string} a
 * @returns {boolean}
 */
showdown.helper.isString = function (a) {
  'use strict';
  return (typeof a === 'string' || a instanceof String);
};

/**
 * Check if var is a function
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isFunction = function (a) {
  'use strict';
  var getType = {};
  return a && getType.toString.call(a) === '[object Function]';
};

/**
 * isArray helper function
 * @static
 * @param {*} a
 * @returns {boolean}
 */
showdown.helper.isArray = function (a) {
  'use strict';
  return Array.isArray(a);
};

/**
 * Check if value is undefined
 * @static
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */
showdown.helper.isUndefined = function (value) {
  'use strict';
  return typeof value === 'undefined';
};

/**
 * ForEach helper function
 * Iterates over Arrays and Objects (own properties only)
 * @static
 * @param {*} obj
 * @param {function} callback Accepts 3 params: 1. value, 2. key, 3. the original array/object
 */
showdown.helper.forEach = function (obj, callback) {
  'use strict';
  // check if obj is defined
  if (showdown.helper.isUndefined(obj)) {
    throw new Error('obj param is required');
  }

  if (showdown.helper.isUndefined(callback)) {
    throw new Error('callback param is required');
  }

  if (!showdown.helper.isFunction(callback)) {
    throw new Error('callback param must be a function/closure');
  }

  if (typeof obj.forEach === 'function') {
    obj.forEach(callback);
  } else if (showdown.helper.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      callback(obj[i], i, obj);
    }
  } else if (typeof (obj) === 'object') {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        callback(obj[prop], prop, obj);
      }
    }
  } else {
    throw new Error('obj does not seem to be an array or an iterable object');
  }
};

/**
 * Standardidize extension name
 * @static
 * @param {string} s extension name
 * @returns {string}
 */
showdown.helper.stdExtName = function (s) {
  'use strict';
  return s.replace(/[_?*+\/\\.^-]/g, '').replace(/\s/g, '').toLowerCase();
};

function escapeCharactersCallback (wholeMatch, m1) {
  'use strict';
  var charCodeToEscape = m1.charCodeAt(0);
  return '¨E' + charCodeToEscape + 'E';
}

/**
 * Callback used to escape characters when passing through String.replace
 * @static
 * @param {string} wholeMatch
 * @param {string} m1
 * @returns {string}
 */
showdown.helper.escapeCharactersCallback = escapeCharactersCallback;

/**
 * Escape characters in a string
 * @static
 * @param {string} text
 * @param {string} charsToEscape
 * @param {boolean} afterBackslash
 * @returns {XML|string|void|*}
 */
showdown.helper.escapeCharacters = function (text, charsToEscape, afterBackslash) {
  'use strict';
  // First we have to escape the escape characters so that
  // we can build a character class out of them
  var regexString = '([' + charsToEscape.replace(/([\[\]\\])/g, '\\$1') + '])';

  if (afterBackslash) {
    regexString = '\\\\' + regexString;
  }

  var regex = new RegExp(regexString, 'g');
  text = text.replace(regex, escapeCharactersCallback);

  return text;
};

/**
 * Unescape HTML entities
 * @param txt
 * @returns {string}
 */
showdown.helper.unescapeHTMLEntities = function (txt) {
  'use strict';

  return txt
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
};

var rgxFindMatchPos = function (str, left, right, flags) {
  'use strict';
  var f = flags || '',
      g = f.indexOf('g') > -1,
      x = new RegExp(left + '|' + right, 'g' + f.replace(/g/g, '')),
      l = new RegExp(left, f.replace(/g/g, '')),
      pos = [],
      t, s, m, start, end;

  do {
    t = 0;
    while ((m = x.exec(str))) {
      if (l.test(m[0])) {
        if (!(t++)) {
          s = x.lastIndex;
          start = s - m[0].length;
        }
      } else if (t) {
        if (!--t) {
          end = m.index + m[0].length;
          var obj = {
            left: {start: start, end: s},
            match: {start: s, end: m.index},
            right: {start: m.index, end: end},
            wholeMatch: {start: start, end: end}
          };
          pos.push(obj);
          if (!g) {
            return pos;
          }
        }
      }
    }
  } while (t && (x.lastIndex = s));

  return pos;
};

/**
 * matchRecursiveRegExp
 *
 * (c) 2007 Steven Levithan <stevenlevithan.com>
 * MIT License
 *
 * Accepts a string to search, a left and right format delimiter
 * as regex patterns, and optional regex flags. Returns an array
 * of matches, allowing nested instances of left/right delimiters.
 * Use the "g" flag to return all matches, otherwise only the
 * first is returned. Be careful to ensure that the left and
 * right format delimiters produce mutually exclusive matches.
 * Backreferences are not supported within the right delimiter
 * due to how it is internally combined with the left delimiter.
 * When matching strings whose format delimiters are unbalanced
 * to the left or right, the output is intentionally as a
 * conventional regex library with recursion support would
 * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
 * "<" and ">" as the delimiters (both strings contain a single,
 * balanced instance of "<x>").
 *
 * examples:
 * matchRecursiveRegExp("test", "\\(", "\\)")
 * returns: []
 * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
 * returns: ["t<<e>><s>", ""]
 * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
 * returns: ["test"]
 */
showdown.helper.matchRecursiveRegExp = function (str, left, right, flags) {
  'use strict';

  var matchPos = rgxFindMatchPos (str, left, right, flags),
      results = [];

  for (var i = 0; i < matchPos.length; ++i) {
    results.push([
      str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
      str.slice(matchPos[i].match.start, matchPos[i].match.end),
      str.slice(matchPos[i].left.start, matchPos[i].left.end),
      str.slice(matchPos[i].right.start, matchPos[i].right.end)
    ]);
  }
  return results;
};

/**
 *
 * @param {string} str
 * @param {string|function} replacement
 * @param {string} left
 * @param {string} right
 * @param {string} flags
 * @returns {string}
 */
showdown.helper.replaceRecursiveRegExp = function (str, replacement, left, right, flags) {
  'use strict';

  if (!showdown.helper.isFunction(replacement)) {
    var repStr = replacement;
    replacement = function () {
      return repStr;
    };
  }

  var matchPos = rgxFindMatchPos(str, left, right, flags),
      finalStr = str,
      lng = matchPos.length;

  if (lng > 0) {
    var bits = [];
    if (matchPos[0].wholeMatch.start !== 0) {
      bits.push(str.slice(0, matchPos[0].wholeMatch.start));
    }
    for (var i = 0; i < lng; ++i) {
      bits.push(
        replacement(
          str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
          str.slice(matchPos[i].match.start, matchPos[i].match.end),
          str.slice(matchPos[i].left.start, matchPos[i].left.end),
          str.slice(matchPos[i].right.start, matchPos[i].right.end)
        )
      );
      if (i < lng - 1) {
        bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
      }
    }
    if (matchPos[lng - 1].wholeMatch.end < str.length) {
      bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
    }
    finalStr = bits.join('');
  }
  return finalStr;
};

/**
 * Returns the index within the passed String object of the first occurrence of the specified regex,
 * starting the search at fromIndex. Returns -1 if the value is not found.
 *
 * @param {string} str string to search
 * @param {RegExp} regex Regular expression to search
 * @param {int} [fromIndex = 0] Index to start the search
 * @returns {Number}
 * @throws InvalidArgumentError
 */
showdown.helper.regexIndexOf = function (str, regex, fromIndex) {
  'use strict';
  if (!showdown.helper.isString(str)) {
    throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
  }
  if (regex instanceof RegExp === false) {
    throw 'InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp';
  }
  var indexOf = str.substring(fromIndex || 0).search(regex);
  return (indexOf >= 0) ? (indexOf + (fromIndex || 0)) : indexOf;
};

/**
 * Splits the passed string object at the defined index, and returns an array composed of the two substrings
 * @param {string} str string to split
 * @param {int} index index to split string at
 * @returns {[string,string]}
 * @throws InvalidArgumentError
 */
showdown.helper.splitAtIndex = function (str, index) {
  'use strict';
  if (!showdown.helper.isString(str)) {
    throw 'InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string';
  }
  return [str.substring(0, index), str.substring(index)];
};

/**
 * Obfuscate an e-mail address through the use of Character Entities,
 * transforming ASCII characters into their equivalent decimal or hex entities.
 *
 * Since it has a random component, subsequent calls to this function produce different results
 *
 * @param {string} mail
 * @returns {string}
 */
showdown.helper.encodeEmailAddress = function (mail) {
  'use strict';
  var encode = [
    function (ch) {
      return '&#' + ch.charCodeAt(0) + ';';
    },
    function (ch) {
      return '&#x' + ch.charCodeAt(0).toString(16) + ';';
    },
    function (ch) {
      return ch;
    }
  ];

  mail = mail.replace(/./g, function (ch) {
    if (ch === '@') {
      // this *must* be encoded. I insist.
      ch = encode[Math.floor(Math.random() * 2)](ch);
    } else {
      var r = Math.random();
      // roughly 10% raw, 45% hex, 45% dec
      ch = (
        r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch)
      );
    }
    return ch;
  });

  return mail;
};

/**
 *
 * @param str
 * @param targetLength
 * @param padString
 * @returns {string}
 */
showdown.helper.padEnd = function padEnd (str, targetLength, padString) {
  'use strict';
  /*jshint bitwise: false*/
  // eslint-disable-next-line space-infix-ops
  targetLength = targetLength>>0; //floor if number or convert non-number to 0;
  /*jshint bitwise: true*/
  padString = String(padString || ' ');
  if (str.length > targetLength) {
    return String(str);
  } else {
    targetLength = targetLength - str.length;
    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
    }
    return String(str) + padString.slice(0,targetLength);
  }
};

/**
 * POLYFILLS
 */
// use this instead of builtin is undefined for IE8 compatibility
if (typeof (console) === 'undefined') {
  console = {
    warn: function (msg) {
      'use strict';
      alert(msg);
    },
    log: function (msg) {
      'use strict';
      alert(msg);
    },
    error: function (msg) {
      'use strict';
      throw msg;
    }
  };
}

/**
 * Common regexes.
 * We declare some common regexes to improve performance
 */
showdown.helper.regexes = {
  asteriskDashAndColon: /([*_:~])/g
};

/**
 * EMOJIS LIST
 */
showdown.helper.emojis = {
  '+1':'\ud83d\udc4d',
  '-1':'\ud83d\udc4e',
  '100':'\ud83d\udcaf',
  '1234':'\ud83d\udd22',
  '1st_place_medal':'\ud83e\udd47',
  '2nd_place_medal':'\ud83e\udd48',
  '3rd_place_medal':'\ud83e\udd49',
  '8ball':'\ud83c\udfb1',
  'a':'\ud83c\udd70\ufe0f',
  'ab':'\ud83c\udd8e',
  'abc':'\ud83d\udd24',
  'abcd':'\ud83d\udd21',
  'accept':'\ud83c\ude51',
  'aerial_tramway':'\ud83d\udea1',
  'airplane':'\u2708\ufe0f',
  'alarm_clock':'\u23f0',
  'alembic':'\u2697\ufe0f',
  'alien':'\ud83d\udc7d',
  'ambulance':'\ud83d\ude91',
  'amphora':'\ud83c\udffa',
  'anchor':'\u2693\ufe0f',
  'angel':'\ud83d\udc7c',
  'anger':'\ud83d\udca2',
  'angry':'\ud83d\ude20',
  'anguished':'\ud83d\ude27',
  'ant':'\ud83d\udc1c',
  'apple':'\ud83c\udf4e',
  'aquarius':'\u2652\ufe0f',
  'aries':'\u2648\ufe0f',
  'arrow_backward':'\u25c0\ufe0f',
  'arrow_double_down':'\u23ec',
  'arrow_double_up':'\u23eb',
  'arrow_down':'\u2b07\ufe0f',
  'arrow_down_small':'\ud83d\udd3d',
  'arrow_forward':'\u25b6\ufe0f',
  'arrow_heading_down':'\u2935\ufe0f',
  'arrow_heading_up':'\u2934\ufe0f',
  'arrow_left':'\u2b05\ufe0f',
  'arrow_lower_left':'\u2199\ufe0f',
  'arrow_lower_right':'\u2198\ufe0f',
  'arrow_right':'\u27a1\ufe0f',
  'arrow_right_hook':'\u21aa\ufe0f',
  'arrow_up':'\u2b06\ufe0f',
  'arrow_up_down':'\u2195\ufe0f',
  'arrow_up_small':'\ud83d\udd3c',
  'arrow_upper_left':'\u2196\ufe0f',
  'arrow_upper_right':'\u2197\ufe0f',
  'arrows_clockwise':'\ud83d\udd03',
  'arrows_counterclockwise':'\ud83d\udd04',
  'art':'\ud83c\udfa8',
  'articulated_lorry':'\ud83d\ude9b',
  'artificial_satellite':'\ud83d\udef0',
  'astonished':'\ud83d\ude32',
  'athletic_shoe':'\ud83d\udc5f',
  'atm':'\ud83c\udfe7',
  'atom_symbol':'\u269b\ufe0f',
  'avocado':'\ud83e\udd51',
  'b':'\ud83c\udd71\ufe0f',
  'baby':'\ud83d\udc76',
  'baby_bottle':'\ud83c\udf7c',
  'baby_chick':'\ud83d\udc24',
  'baby_symbol':'\ud83d\udebc',
  'back':'\ud83d\udd19',
  'bacon':'\ud83e\udd53',
  'badminton':'\ud83c\udff8',
  'baggage_claim':'\ud83d\udec4',
  'baguette_bread':'\ud83e\udd56',
  'balance_scale':'\u2696\ufe0f',
  'balloon':'\ud83c\udf88',
  'ballot_box':'\ud83d\uddf3',
  'ballot_box_with_check':'\u2611\ufe0f',
  'bamboo':'\ud83c\udf8d',
  'banana':'\ud83c\udf4c',
  'bangbang':'\u203c\ufe0f',
  'bank':'\ud83c\udfe6',
  'bar_chart':'\ud83d\udcca',
  'barber':'\ud83d\udc88',
  'baseball':'\u26be\ufe0f',
  'basketball':'\ud83c\udfc0',
  'basketball_man':'\u26f9\ufe0f',
  'basketball_woman':'\u26f9\ufe0f&zwj;\u2640\ufe0f',
  'bat':'\ud83e\udd87',
  'bath':'\ud83d\udec0',
  'bathtub':'\ud83d\udec1',
  'battery':'\ud83d\udd0b',
  'beach_umbrella':'\ud83c\udfd6',
  'bear':'\ud83d\udc3b',
  'bed':'\ud83d\udecf',
  'bee':'\ud83d\udc1d',
  'beer':'\ud83c\udf7a',
  'beers':'\ud83c\udf7b',
  'beetle':'\ud83d\udc1e',
  'beginner':'\ud83d\udd30',
  'bell':'\ud83d\udd14',
  'bellhop_bell':'\ud83d\udece',
  'bento':'\ud83c\udf71',
  'biking_man':'\ud83d\udeb4',
  'bike':'\ud83d\udeb2',
  'biking_woman':'\ud83d\udeb4&zwj;\u2640\ufe0f',
  'bikini':'\ud83d\udc59',
  'biohazard':'\u2623\ufe0f',
  'bird':'\ud83d\udc26',
  'birthday':'\ud83c\udf82',
  'black_circle':'\u26ab\ufe0f',
  'black_flag':'\ud83c\udff4',
  'black_heart':'\ud83d\udda4',
  'black_joker':'\ud83c\udccf',
  'black_large_square':'\u2b1b\ufe0f',
  'black_medium_small_square':'\u25fe\ufe0f',
  'black_medium_square':'\u25fc\ufe0f',
  'black_nib':'\u2712\ufe0f',
  'black_small_square':'\u25aa\ufe0f',
  'black_square_button':'\ud83d\udd32',
  'blonde_man':'\ud83d\udc71',
  'blonde_woman':'\ud83d\udc71&zwj;\u2640\ufe0f',
  'blossom':'\ud83c\udf3c',
  'blowfish':'\ud83d\udc21',
  'blue_book':'\ud83d\udcd8',
  'blue_car':'\ud83d\ude99',
  'blue_heart':'\ud83d\udc99',
  'blush':'\ud83d\ude0a',
  'boar':'\ud83d\udc17',
  'boat':'\u26f5\ufe0f',
  'bomb':'\ud83d\udca3',
  'book':'\ud83d\udcd6',
  'bookmark':'\ud83d\udd16',
  'bookmark_tabs':'\ud83d\udcd1',
  'books':'\ud83d\udcda',
  'boom':'\ud83d\udca5',
  'boot':'\ud83d\udc62',
  'bouquet':'\ud83d\udc90',
  'bowing_man':'\ud83d\ude47',
  'bow_and_arrow':'\ud83c\udff9',
  'bowing_woman':'\ud83d\ude47&zwj;\u2640\ufe0f',
  'bowling':'\ud83c\udfb3',
  'boxing_glove':'\ud83e\udd4a',
  'boy':'\ud83d\udc66',
  'bread':'\ud83c\udf5e',
  'bride_with_veil':'\ud83d\udc70',
  'bridge_at_night':'\ud83c\udf09',
  'briefcase':'\ud83d\udcbc',
  'broken_heart':'\ud83d\udc94',
  'bug':'\ud83d\udc1b',
  'building_construction':'\ud83c\udfd7',
  'bulb':'\ud83d\udca1',
  'bullettrain_front':'\ud83d\ude85',
  'bullettrain_side':'\ud83d\ude84',
  'burrito':'\ud83c\udf2f',
  'bus':'\ud83d\ude8c',
  'business_suit_levitating':'\ud83d\udd74',
  'busstop':'\ud83d\ude8f',
  'bust_in_silhouette':'\ud83d\udc64',
  'busts_in_silhouette':'\ud83d\udc65',
  'butterfly':'\ud83e\udd8b',
  'cactus':'\ud83c\udf35',
  'cake':'\ud83c\udf70',
  'calendar':'\ud83d\udcc6',
  'call_me_hand':'\ud83e\udd19',
  'calling':'\ud83d\udcf2',
  'camel':'\ud83d\udc2b',
  'camera':'\ud83d\udcf7',
  'camera_flash':'\ud83d\udcf8',
  'camping':'\ud83c\udfd5',
  'cancer':'\u264b\ufe0f',
  'candle':'\ud83d\udd6f',
  'candy':'\ud83c\udf6c',
  'canoe':'\ud83d\udef6',
  'capital_abcd':'\ud83d\udd20',
  'capricorn':'\u2651\ufe0f',
  'car':'\ud83d\ude97',
  'card_file_box':'\ud83d\uddc3',
  'card_index':'\ud83d\udcc7',
  'card_index_dividers':'\ud83d\uddc2',
  'carousel_horse':'\ud83c\udfa0',
  'carrot':'\ud83e\udd55',
  'cat':'\ud83d\udc31',
  'cat2':'\ud83d\udc08',
  'cd':'\ud83d\udcbf',
  'chains':'\u26d3',
  'champagne':'\ud83c\udf7e',
  'chart':'\ud83d\udcb9',
  'chart_with_downwards_trend':'\ud83d\udcc9',
  'chart_with_upwards_trend':'\ud83d\udcc8',
  'checkered_flag':'\ud83c\udfc1',
  'cheese':'\ud83e\uddc0',
  'cherries':'\ud83c\udf52',
  'cherry_blossom':'\ud83c\udf38',
  'chestnut':'\ud83c\udf30',
  'chicken':'\ud83d\udc14',
  'children_crossing':'\ud83d\udeb8',
  'chipmunk':'\ud83d\udc3f',
  'chocolate_bar':'\ud83c\udf6b',
  'christmas_tree':'\ud83c\udf84',
  'church':'\u26ea\ufe0f',
  'cinema':'\ud83c\udfa6',
  'circus_tent':'\ud83c\udfaa',
  'city_sunrise':'\ud83c\udf07',
  'city_sunset':'\ud83c\udf06',
  'cityscape':'\ud83c\udfd9',
  'cl':'\ud83c\udd91',
  'clamp':'\ud83d\udddc',
  'clap':'\ud83d\udc4f',
  'clapper':'\ud83c\udfac',
  'classical_building':'\ud83c\udfdb',
  'clinking_glasses':'\ud83e\udd42',
  'clipboard':'\ud83d\udccb',
  'clock1':'\ud83d\udd50',
  'clock10':'\ud83d\udd59',
  'clock1030':'\ud83d\udd65',
  'clock11':'\ud83d\udd5a',
  'clock1130':'\ud83d\udd66',
  'clock12':'\ud83d\udd5b',
  'clock1230':'\ud83d\udd67',
  'clock130':'\ud83d\udd5c',
  'clock2':'\ud83d\udd51',
  'clock230':'\ud83d\udd5d',
  'clock3':'\ud83d\udd52',
  'clock330':'\ud83d\udd5e',
  'clock4':'\ud83d\udd53',
  'clock430':'\ud83d\udd5f',
  'clock5':'\ud83d\udd54',
  'clock530':'\ud83d\udd60',
  'clock6':'\ud83d\udd55',
  'clock630':'\ud83d\udd61',
  'clock7':'\ud83d\udd56',
  'clock730':'\ud83d\udd62',
  'clock8':'\ud83d\udd57',
  'clock830':'\ud83d\udd63',
  'clock9':'\ud83d\udd58',
  'clock930':'\ud83d\udd64',
  'closed_book':'\ud83d\udcd5',
  'closed_lock_with_key':'\ud83d\udd10',
  'closed_umbrella':'\ud83c\udf02',
  'cloud':'\u2601\ufe0f',
  'cloud_with_lightning':'\ud83c\udf29',
  'cloud_with_lightning_and_rain':'\u26c8',
  'cloud_with_rain':'\ud83c\udf27',
  'cloud_with_snow':'\ud83c\udf28',
  'clown_face':'\ud83e\udd21',
  'clubs':'\u2663\ufe0f',
  'cocktail':'\ud83c\udf78',
  'coffee':'\u2615\ufe0f',
  'coffin':'\u26b0\ufe0f',
  'cold_sweat':'\ud83d\ude30',
  'comet':'\u2604\ufe0f',
  'computer':'\ud83d\udcbb',
  'computer_mouse':'\ud83d\uddb1',
  'confetti_ball':'\ud83c\udf8a',
  'confounded':'\ud83d\ude16',
  'confused':'\ud83d\ude15',
  'congratulations':'\u3297\ufe0f',
  'construction':'\ud83d\udea7',
  'construction_worker_man':'\ud83d\udc77',
  'construction_worker_woman':'\ud83d\udc77&zwj;\u2640\ufe0f',
  'control_knobs':'\ud83c\udf9b',
  'convenience_store':'\ud83c\udfea',
  'cookie':'\ud83c\udf6a',
  'cool':'\ud83c\udd92',
  'policeman':'\ud83d\udc6e',
  'copyright':'\u00a9\ufe0f',
  'corn':'\ud83c\udf3d',
  'couch_and_lamp':'\ud83d\udecb',
  'couple':'\ud83d\udc6b',
  'couple_with_heart_woman_man':'\ud83d\udc91',
  'couple_with_heart_man_man':'\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc68',
  'couple_with_heart_woman_woman':'\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc69',
  'couplekiss_man_man':'\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc68',
  'couplekiss_man_woman':'\ud83d\udc8f',
  'couplekiss_woman_woman':'\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc69',
  'cow':'\ud83d\udc2e',
  'cow2':'\ud83d\udc04',
  'cowboy_hat_face':'\ud83e\udd20',
  'crab':'\ud83e\udd80',
  'crayon':'\ud83d\udd8d',
  'credit_card':'\ud83d\udcb3',
  'crescent_moon':'\ud83c\udf19',
  'cricket':'\ud83c\udfcf',
  'crocodile':'\ud83d\udc0a',
  'croissant':'\ud83e\udd50',
  'crossed_fingers':'\ud83e\udd1e',
  'crossed_flags':'\ud83c\udf8c',
  'crossed_swords':'\u2694\ufe0f',
  'crown':'\ud83d\udc51',
  'cry':'\ud83d\ude22',
  'crying_cat_face':'\ud83d\ude3f',
  'crystal_ball':'\ud83d\udd2e',
  'cucumber':'\ud83e\udd52',
  'cupid':'\ud83d\udc98',
  'curly_loop':'\u27b0',
  'currency_exchange':'\ud83d\udcb1',
  'curry':'\ud83c\udf5b',
  'custard':'\ud83c\udf6e',
  'customs':'\ud83d\udec3',
  'cyclone':'\ud83c\udf00',
  'dagger':'\ud83d\udde1',
  'dancer':'\ud83d\udc83',
  'dancing_women':'\ud83d\udc6f',
  'dancing_men':'\ud83d\udc6f&zwj;\u2642\ufe0f',
  'dango':'\ud83c\udf61',
  'dark_sunglasses':'\ud83d\udd76',
  'dart':'\ud83c\udfaf',
  'dash':'\ud83d\udca8',
  'date':'\ud83d\udcc5',
  'deciduous_tree':'\ud83c\udf33',
  'deer':'\ud83e\udd8c',
  'department_store':'\ud83c\udfec',
  'derelict_house':'\ud83c\udfda',
  'desert':'\ud83c\udfdc',
  'desert_island':'\ud83c\udfdd',
  'desktop_computer':'\ud83d\udda5',
  'male_detective':'\ud83d\udd75\ufe0f',
  'diamond_shape_with_a_dot_inside':'\ud83d\udca0',
  'diamonds':'\u2666\ufe0f',
  'disappointed':'\ud83d\ude1e',
  'disappointed_relieved':'\ud83d\ude25',
  'dizzy':'\ud83d\udcab',
  'dizzy_face':'\ud83d\ude35',
  'do_not_litter':'\ud83d\udeaf',
  'dog':'\ud83d\udc36',
  'dog2':'\ud83d\udc15',
  'dollar':'\ud83d\udcb5',
  'dolls':'\ud83c\udf8e',
  'dolphin':'\ud83d\udc2c',
  'door':'\ud83d\udeaa',
  'doughnut':'\ud83c\udf69',
  'dove':'\ud83d\udd4a',
  'dragon':'\ud83d\udc09',
  'dragon_face':'\ud83d\udc32',
  'dress':'\ud83d\udc57',
  'dromedary_camel':'\ud83d\udc2a',
  'drooling_face':'\ud83e\udd24',
  'droplet':'\ud83d\udca7',
  'drum':'\ud83e\udd41',
  'duck':'\ud83e\udd86',
  'dvd':'\ud83d\udcc0',
  'e-mail':'\ud83d\udce7',
  'eagle':'\ud83e\udd85',
  'ear':'\ud83d\udc42',
  'ear_of_rice':'\ud83c\udf3e',
  'earth_africa':'\ud83c\udf0d',
  'earth_americas':'\ud83c\udf0e',
  'earth_asia':'\ud83c\udf0f',
  'egg':'\ud83e\udd5a',
  'eggplant':'\ud83c\udf46',
  'eight_pointed_black_star':'\u2734\ufe0f',
  'eight_spoked_asterisk':'\u2733\ufe0f',
  'electric_plug':'\ud83d\udd0c',
  'elephant':'\ud83d\udc18',
  'email':'\u2709\ufe0f',
  'end':'\ud83d\udd1a',
  'envelope_with_arrow':'\ud83d\udce9',
  'euro':'\ud83d\udcb6',
  'european_castle':'\ud83c\udff0',
  'european_post_office':'\ud83c\udfe4',
  'evergreen_tree':'\ud83c\udf32',
  'exclamation':'\u2757\ufe0f',
  'expressionless':'\ud83d\ude11',
  'eye':'\ud83d\udc41',
  'eye_speech_bubble':'\ud83d\udc41&zwj;\ud83d\udde8',
  'eyeglasses':'\ud83d\udc53',
  'eyes':'\ud83d\udc40',
  'face_with_head_bandage':'\ud83e\udd15',
  'face_with_thermometer':'\ud83e\udd12',
  'fist_oncoming':'\ud83d\udc4a',
  'factory':'\ud83c\udfed',
  'fallen_leaf':'\ud83c\udf42',
  'family_man_woman_boy':'\ud83d\udc6a',
  'family_man_boy':'\ud83d\udc68&zwj;\ud83d\udc66',
  'family_man_boy_boy':'\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_man_girl':'\ud83d\udc68&zwj;\ud83d\udc67',
  'family_man_girl_boy':'\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_man_girl_girl':'\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_man_man_boy':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66',
  'family_man_man_boy_boy':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_man_man_girl':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67',
  'family_man_man_girl_boy':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_man_man_girl_girl':'\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_man_woman_boy_boy':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_man_woman_girl':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67',
  'family_man_woman_girl_boy':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_man_woman_girl_girl':'\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_woman_boy':'\ud83d\udc69&zwj;\ud83d\udc66',
  'family_woman_boy_boy':'\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_woman_girl':'\ud83d\udc69&zwj;\ud83d\udc67',
  'family_woman_girl_boy':'\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_woman_girl_girl':'\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'family_woman_woman_boy':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66',
  'family_woman_woman_boy_boy':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66',
  'family_woman_woman_girl':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67',
  'family_woman_woman_girl_boy':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66',
  'family_woman_woman_girl_girl':'\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67',
  'fast_forward':'\u23e9',
  'fax':'\ud83d\udce0',
  'fearful':'\ud83d\ude28',
  'feet':'\ud83d\udc3e',
  'female_detective':'\ud83d\udd75\ufe0f&zwj;\u2640\ufe0f',
  'ferris_wheel':'\ud83c\udfa1',
  'ferry':'\u26f4',
  'field_hockey':'\ud83c\udfd1',
  'file_cabinet':'\ud83d\uddc4',
  'file_folder':'\ud83d\udcc1',
  'film_projector':'\ud83d\udcfd',
  'film_strip':'\ud83c\udf9e',
  'fire':'\ud83d\udd25',
  'fire_engine':'\ud83d\ude92',
  'fireworks':'\ud83c\udf86',
  'first_quarter_moon':'\ud83c\udf13',
  'first_quarter_moon_with_face':'\ud83c\udf1b',
  'fish':'\ud83d\udc1f',
  'fish_cake':'\ud83c\udf65',
  'fishing_pole_and_fish':'\ud83c\udfa3',
  'fist_raised':'\u270a',
  'fist_left':'\ud83e\udd1b',
  'fist_right':'\ud83e\udd1c',
  'flags':'\ud83c\udf8f',
  'flashlight':'\ud83d\udd26',
  'fleur_de_lis':'\u269c\ufe0f',
  'flight_arrival':'\ud83d\udeec',
  'flight_departure':'\ud83d\udeeb',
  'floppy_disk':'\ud83d\udcbe',
  'flower_playing_cards':'\ud83c\udfb4',
  'flushed':'\ud83d\ude33',
  'fog':'\ud83c\udf2b',
  'foggy':'\ud83c\udf01',
  'football':'\ud83c\udfc8',
  'footprints':'\ud83d\udc63',
  'fork_and_knife':'\ud83c\udf74',
  'fountain':'\u26f2\ufe0f',
  'fountain_pen':'\ud83d\udd8b',
  'four_leaf_clover':'\ud83c\udf40',
  'fox_face':'\ud83e\udd8a',
  'framed_picture':'\ud83d\uddbc',
  'free':'\ud83c\udd93',
  'fried_egg':'\ud83c\udf73',
  'fried_shrimp':'\ud83c\udf64',
  'fries':'\ud83c\udf5f',
  'frog':'\ud83d\udc38',
  'frowning':'\ud83d\ude26',
  'frowning_face':'\u2639\ufe0f',
  'frowning_man':'\ud83d\ude4d&zwj;\u2642\ufe0f',
  'frowning_woman':'\ud83d\ude4d',
  'middle_finger':'\ud83d\udd95',
  'fuelpump':'\u26fd\ufe0f',
  'full_moon':'\ud83c\udf15',
  'full_moon_with_face':'\ud83c\udf1d',
  'funeral_urn':'\u26b1\ufe0f',
  'game_die':'\ud83c\udfb2',
  'gear':'\u2699\ufe0f',
  'gem':'\ud83d\udc8e',
  'gemini':'\u264a\ufe0f',
  'ghost':'\ud83d\udc7b',
  'gift':'\ud83c\udf81',
  'gift_heart':'\ud83d\udc9d',
  'girl':'\ud83d\udc67',
  'globe_with_meridians':'\ud83c\udf10',
  'goal_net':'\ud83e\udd45',
  'goat':'\ud83d\udc10',
  'golf':'\u26f3\ufe0f',
  'golfing_man':'\ud83c\udfcc\ufe0f',
  'golfing_woman':'\ud83c\udfcc\ufe0f&zwj;\u2640\ufe0f',
  'gorilla':'\ud83e\udd8d',
  'grapes':'\ud83c\udf47',
  'green_apple':'\ud83c\udf4f',
  'green_book':'\ud83d\udcd7',
  'green_heart':'\ud83d\udc9a',
  'green_salad':'\ud83e\udd57',
  'grey_exclamation':'\u2755',
  'grey_question':'\u2754',
  'grimacing':'\ud83d\ude2c',
  'grin':'\ud83d\ude01',
  'grinning':'\ud83d\ude00',
  'guardsman':'\ud83d\udc82',
  'guardswoman':'\ud83d\udc82&zwj;\u2640\ufe0f',
  'guitar':'\ud83c\udfb8',
  'gun':'\ud83d\udd2b',
  'haircut_woman':'\ud83d\udc87',
  'haircut_man':'\ud83d\udc87&zwj;\u2642\ufe0f',
  'hamburger':'\ud83c\udf54',
  'hammer':'\ud83d\udd28',
  'hammer_and_pick':'\u2692',
  'hammer_and_wrench':'\ud83d\udee0',
  'hamster':'\ud83d\udc39',
  'hand':'\u270b',
  'handbag':'\ud83d\udc5c',
  'handshake':'\ud83e\udd1d',
  'hankey':'\ud83d\udca9',
  'hatched_chick':'\ud83d\udc25',
  'hatching_chick':'\ud83d\udc23',
  'headphones':'\ud83c\udfa7',
  'hear_no_evil':'\ud83d\ude49',
  'heart':'\u2764\ufe0f',
  'heart_decoration':'\ud83d\udc9f',
  'heart_eyes':'\ud83d\ude0d',
  'heart_eyes_cat':'\ud83d\ude3b',
  'heartbeat':'\ud83d\udc93',
  'heartpulse':'\ud83d\udc97',
  'hearts':'\u2665\ufe0f',
  'heavy_check_mark':'\u2714\ufe0f',
  'heavy_division_sign':'\u2797',
  'heavy_dollar_sign':'\ud83d\udcb2',
  'heavy_heart_exclamation':'\u2763\ufe0f',
  'heavy_minus_sign':'\u2796',
  'heavy_multiplication_x':'\u2716\ufe0f',
  'heavy_plus_sign':'\u2795',
  'helicopter':'\ud83d\ude81',
  'herb':'\ud83c\udf3f',
  'hibiscus':'\ud83c\udf3a',
  'high_brightness':'\ud83d\udd06',
  'high_heel':'\ud83d\udc60',
  'hocho':'\ud83d\udd2a',
  'hole':'\ud83d\udd73',
  'honey_pot':'\ud83c\udf6f',
  'horse':'\ud83d\udc34',
  'horse_racing':'\ud83c\udfc7',
  'hospital':'\ud83c\udfe5',
  'hot_pepper':'\ud83c\udf36',
  'hotdog':'\ud83c\udf2d',
  'hotel':'\ud83c\udfe8',
  'hotsprings':'\u2668\ufe0f',
  'hourglass':'\u231b\ufe0f',
  'hourglass_flowing_sand':'\u23f3',
  'house':'\ud83c\udfe0',
  'house_with_garden':'\ud83c\udfe1',
  'houses':'\ud83c\udfd8',
  'hugs':'\ud83e\udd17',
  'hushed':'\ud83d\ude2f',
  'ice_cream':'\ud83c\udf68',
  'ice_hockey':'\ud83c\udfd2',
  'ice_skate':'\u26f8',
  'icecream':'\ud83c\udf66',
  'id':'\ud83c\udd94',
  'ideograph_advantage':'\ud83c\ude50',
  'imp':'\ud83d\udc7f',
  'inbox_tray':'\ud83d\udce5',
  'incoming_envelope':'\ud83d\udce8',
  'tipping_hand_woman':'\ud83d\udc81',
  'information_source':'\u2139\ufe0f',
  'innocent':'\ud83d\ude07',
  'interrobang':'\u2049\ufe0f',
  'iphone':'\ud83d\udcf1',
  'izakaya_lantern':'\ud83c\udfee',
  'jack_o_lantern':'\ud83c\udf83',
  'japan':'\ud83d\uddfe',
  'japanese_castle':'\ud83c\udfef',
  'japanese_goblin':'\ud83d\udc7a',
  'japanese_ogre':'\ud83d\udc79',
  'jeans':'\ud83d\udc56',
  'joy':'\ud83d\ude02',
  'joy_cat':'\ud83d\ude39',
  'joystick':'\ud83d\udd79',
  'kaaba':'\ud83d\udd4b',
  'key':'\ud83d\udd11',
  'keyboard':'\u2328\ufe0f',
  'keycap_ten':'\ud83d\udd1f',
  'kick_scooter':'\ud83d\udef4',
  'kimono':'\ud83d\udc58',
  'kiss':'\ud83d\udc8b',
  'kissing':'\ud83d\ude17',
  'kissing_cat':'\ud83d\ude3d',
  'kissing_closed_eyes':'\ud83d\ude1a',
  'kissing_heart':'\ud83d\ude18',
  'kissing_smiling_eyes':'\ud83d\ude19',
  'kiwi_fruit':'\ud83e\udd5d',
  'koala':'\ud83d\udc28',
  'koko':'\ud83c\ude01',
  'label':'\ud83c\udff7',
  'large_blue_circle':'\ud83d\udd35',
  'large_blue_diamond':'\ud83d\udd37',
  'large_orange_diamond':'\ud83d\udd36',
  'last_quarter_moon':'\ud83c\udf17',
  'last_quarter_moon_with_face':'\ud83c\udf1c',
  'latin_cross':'\u271d\ufe0f',
  'laughing':'\ud83d\ude06',
  'leaves':'\ud83c\udf43',
  'ledger':'\ud83d\udcd2',
  'left_luggage':'\ud83d\udec5',
  'left_right_arrow':'\u2194\ufe0f',
  'leftwards_arrow_with_hook':'\u21a9\ufe0f',
  'lemon':'\ud83c\udf4b',
  'leo':'\u264c\ufe0f',
  'leopard':'\ud83d\udc06',
  'level_slider':'\ud83c\udf9a',
  'libra':'\u264e\ufe0f',
  'light_rail':'\ud83d\ude88',
  'link':'\ud83d\udd17',
  'lion':'\ud83e\udd81',
  'lips':'\ud83d\udc44',
  'lipstick':'\ud83d\udc84',
  'lizard':'\ud83e\udd8e',
  'lock':'\ud83d\udd12',
  'lock_with_ink_pen':'\ud83d\udd0f',
  'lollipop':'\ud83c\udf6d',
  'loop':'\u27bf',
  'loud_sound':'\ud83d\udd0a',
  'loudspeaker':'\ud83d\udce2',
  'love_hotel':'\ud83c\udfe9',
  'love_letter':'\ud83d\udc8c',
  'low_brightness':'\ud83d\udd05',
  'lying_face':'\ud83e\udd25',
  'm':'\u24c2\ufe0f',
  'mag':'\ud83d\udd0d',
  'mag_right':'\ud83d\udd0e',
  'mahjong':'\ud83c\udc04\ufe0f',
  'mailbox':'\ud83d\udceb',
  'mailbox_closed':'\ud83d\udcea',
  'mailbox_with_mail':'\ud83d\udcec',
  'mailbox_with_no_mail':'\ud83d\udced',
  'man':'\ud83d\udc68',
  'man_artist':'\ud83d\udc68&zwj;\ud83c\udfa8',
  'man_astronaut':'\ud83d\udc68&zwj;\ud83d\ude80',
  'man_cartwheeling':'\ud83e\udd38&zwj;\u2642\ufe0f',
  'man_cook':'\ud83d\udc68&zwj;\ud83c\udf73',
  'man_dancing':'\ud83d\udd7a',
  'man_facepalming':'\ud83e\udd26&zwj;\u2642\ufe0f',
  'man_factory_worker':'\ud83d\udc68&zwj;\ud83c\udfed',
  'man_farmer':'\ud83d\udc68&zwj;\ud83c\udf3e',
  'man_firefighter':'\ud83d\udc68&zwj;\ud83d\ude92',
  'man_health_worker':'\ud83d\udc68&zwj;\u2695\ufe0f',
  'man_in_tuxedo':'\ud83e\udd35',
  'man_judge':'\ud83d\udc68&zwj;\u2696\ufe0f',
  'man_juggling':'\ud83e\udd39&zwj;\u2642\ufe0f',
  'man_mechanic':'\ud83d\udc68&zwj;\ud83d\udd27',
  'man_office_worker':'\ud83d\udc68&zwj;\ud83d\udcbc',
  'man_pilot':'\ud83d\udc68&zwj;\u2708\ufe0f',
  'man_playing_handball':'\ud83e\udd3e&zwj;\u2642\ufe0f',
  'man_playing_water_polo':'\ud83e\udd3d&zwj;\u2642\ufe0f',
  'man_scientist':'\ud83d\udc68&zwj;\ud83d\udd2c',
  'man_shrugging':'\ud83e\udd37&zwj;\u2642\ufe0f',
  'man_singer':'\ud83d\udc68&zwj;\ud83c\udfa4',
  'man_student':'\ud83d\udc68&zwj;\ud83c\udf93',
  'man_teacher':'\ud83d\udc68&zwj;\ud83c\udfeb',
  'man_technologist':'\ud83d\udc68&zwj;\ud83d\udcbb',
  'man_with_gua_pi_mao':'\ud83d\udc72',
  'man_with_turban':'\ud83d\udc73',
  'tangerine':'\ud83c\udf4a',
  'mans_shoe':'\ud83d\udc5e',
  'mantelpiece_clock':'\ud83d\udd70',
  'maple_leaf':'\ud83c\udf41',
  'martial_arts_uniform':'\ud83e\udd4b',
  'mask':'\ud83d\ude37',
  'massage_woman':'\ud83d\udc86',
  'massage_man':'\ud83d\udc86&zwj;\u2642\ufe0f',
  'meat_on_bone':'\ud83c\udf56',
  'medal_military':'\ud83c\udf96',
  'medal_sports':'\ud83c\udfc5',
  'mega':'\ud83d\udce3',
  'melon':'\ud83c\udf48',
  'memo':'\ud83d\udcdd',
  'men_wrestling':'\ud83e\udd3c&zwj;\u2642\ufe0f',
  'menorah':'\ud83d\udd4e',
  'mens':'\ud83d\udeb9',
  'metal':'\ud83e\udd18',
  'metro':'\ud83d\ude87',
  'microphone':'\ud83c\udfa4',
  'microscope':'\ud83d\udd2c',
  'milk_glass':'\ud83e\udd5b',
  'milky_way':'\ud83c\udf0c',
  'minibus':'\ud83d\ude90',
  'minidisc':'\ud83d\udcbd',
  'mobile_phone_off':'\ud83d\udcf4',
  'money_mouth_face':'\ud83e\udd11',
  'money_with_wings':'\ud83d\udcb8',
  'moneybag':'\ud83d\udcb0',
  'monkey':'\ud83d\udc12',
  'monkey_face':'\ud83d\udc35',
  'monorail':'\ud83d\ude9d',
  'moon':'\ud83c\udf14',
  'mortar_board':'\ud83c\udf93',
  'mosque':'\ud83d\udd4c',
  'motor_boat':'\ud83d\udee5',
  'motor_scooter':'\ud83d\udef5',
  'motorcycle':'\ud83c\udfcd',
  'motorway':'\ud83d\udee3',
  'mount_fuji':'\ud83d\uddfb',
  'mountain':'\u26f0',
  'mountain_biking_man':'\ud83d\udeb5',
  'mountain_biking_woman':'\ud83d\udeb5&zwj;\u2640\ufe0f',
  'mountain_cableway':'\ud83d\udea0',
  'mountain_railway':'\ud83d\ude9e',
  'mountain_snow':'\ud83c\udfd4',
  'mouse':'\ud83d\udc2d',
  'mouse2':'\ud83d\udc01',
  'movie_camera':'\ud83c\udfa5',
  'moyai':'\ud83d\uddff',
  'mrs_claus':'\ud83e\udd36',
  'muscle':'\ud83d\udcaa',
  'mushroom':'\ud83c\udf44',
  'musical_keyboard':'\ud83c\udfb9',
  'musical_note':'\ud83c\udfb5',
  'musical_score':'\ud83c\udfbc',
  'mute':'\ud83d\udd07',
  'nail_care':'\ud83d\udc85',
  'name_badge':'\ud83d\udcdb',
  'national_park':'\ud83c\udfde',
  'nauseated_face':'\ud83e\udd22',
  'necktie':'\ud83d\udc54',
  'negative_squared_cross_mark':'\u274e',
  'nerd_face':'\ud83e\udd13',
  'neutral_face':'\ud83d\ude10',
  'new':'\ud83c\udd95',
  'new_moon':'\ud83c\udf11',
  'new_moon_with_face':'\ud83c\udf1a',
  'newspaper':'\ud83d\udcf0',
  'newspaper_roll':'\ud83d\uddde',
  'next_track_button':'\u23ed',
  'ng':'\ud83c\udd96',
  'no_good_man':'\ud83d\ude45&zwj;\u2642\ufe0f',
  'no_good_woman':'\ud83d\ude45',
  'night_with_stars':'\ud83c\udf03',
  'no_bell':'\ud83d\udd15',
  'no_bicycles':'\ud83d\udeb3',
  'no_entry':'\u26d4\ufe0f',
  'no_entry_sign':'\ud83d\udeab',
  'no_mobile_phones':'\ud83d\udcf5',
  'no_mouth':'\ud83d\ude36',
  'no_pedestrians':'\ud83d\udeb7',
  'no_smoking':'\ud83d\udead',
  'non-potable_water':'\ud83d\udeb1',
  'nose':'\ud83d\udc43',
  'notebook':'\ud83d\udcd3',
  'notebook_with_decorative_cover':'\ud83d\udcd4',
  'notes':'\ud83c\udfb6',
  'nut_and_bolt':'\ud83d\udd29',
  'o':'\u2b55\ufe0f',
  'o2':'\ud83c\udd7e\ufe0f',
  'ocean':'\ud83c\udf0a',
  'octopus':'\ud83d\udc19',
  'oden':'\ud83c\udf62',
  'office':'\ud83c\udfe2',
  'oil_drum':'\ud83d\udee2',
  'ok':'\ud83c\udd97',
  'ok_hand':'\ud83d\udc4c',
  'ok_man':'\ud83d\ude46&zwj;\u2642\ufe0f',
  'ok_woman':'\ud83d\ude46',
  'old_key':'\ud83d\udddd',
  'older_man':'\ud83d\udc74',
  'older_woman':'\ud83d\udc75',
  'om':'\ud83d\udd49',
  'on':'\ud83d\udd1b',
  'oncoming_automobile':'\ud83d\ude98',
  'oncoming_bus':'\ud83d\ude8d',
  'oncoming_police_car':'\ud83d\ude94',
  'oncoming_taxi':'\ud83d\ude96',
  'open_file_folder':'\ud83d\udcc2',
  'open_hands':'\ud83d\udc50',
  'open_mouth':'\ud83d\ude2e',
  'open_umbrella':'\u2602\ufe0f',
  'ophiuchus':'\u26ce',
  'orange_book':'\ud83d\udcd9',
  'orthodox_cross':'\u2626\ufe0f',
  'outbox_tray':'\ud83d\udce4',
  'owl':'\ud83e\udd89',
  'ox':'\ud83d\udc02',
  'package':'\ud83d\udce6',
  'page_facing_up':'\ud83d\udcc4',
  'page_with_curl':'\ud83d\udcc3',
  'pager':'\ud83d\udcdf',
  'paintbrush':'\ud83d\udd8c',
  'palm_tree':'\ud83c\udf34',
  'pancakes':'\ud83e\udd5e',
  'panda_face':'\ud83d\udc3c',
  'paperclip':'\ud83d\udcce',
  'paperclips':'\ud83d\udd87',
  'parasol_on_ground':'\u26f1',
  'parking':'\ud83c\udd7f\ufe0f',
  'part_alternation_mark':'\u303d\ufe0f',
  'partly_sunny':'\u26c5\ufe0f',
  'passenger_ship':'\ud83d\udef3',
  'passport_control':'\ud83d\udec2',
  'pause_button':'\u23f8',
  'peace_symbol':'\u262e\ufe0f',
  'peach':'\ud83c\udf51',
  'peanuts':'\ud83e\udd5c',
  'pear':'\ud83c\udf50',
  'pen':'\ud83d\udd8a',
  'pencil2':'\u270f\ufe0f',
  'penguin':'\ud83d\udc27',
  'pensive':'\ud83d\ude14',
  'performing_arts':'\ud83c\udfad',
  'persevere':'\ud83d\ude23',
  'person_fencing':'\ud83e\udd3a',
  'pouting_woman':'\ud83d\ude4e',
  'phone':'\u260e\ufe0f',
  'pick':'\u26cf',
  'pig':'\ud83d\udc37',
  'pig2':'\ud83d\udc16',
  'pig_nose':'\ud83d\udc3d',
  'pill':'\ud83d\udc8a',
  'pineapple':'\ud83c\udf4d',
  'ping_pong':'\ud83c\udfd3',
  'pisces':'\u2653\ufe0f',
  'pizza':'\ud83c\udf55',
  'place_of_worship':'\ud83d\uded0',
  'plate_with_cutlery':'\ud83c\udf7d',
  'play_or_pause_button':'\u23ef',
  'point_down':'\ud83d\udc47',
  'point_left':'\ud83d\udc48',
  'point_right':'\ud83d\udc49',
  'point_up':'\u261d\ufe0f',
  'point_up_2':'\ud83d\udc46',
  'police_car':'\ud83d\ude93',
  'policewoman':'\ud83d\udc6e&zwj;\u2640\ufe0f',
  'poodle':'\ud83d\udc29',
  'popcorn':'\ud83c\udf7f',
  'post_office':'\ud83c\udfe3',
  'postal_horn':'\ud83d\udcef',
  'postbox':'\ud83d\udcee',
  'potable_water':'\ud83d\udeb0',
  'potato':'\ud83e\udd54',
  'pouch':'\ud83d\udc5d',
  'poultry_leg':'\ud83c\udf57',
  'pound':'\ud83d\udcb7',
  'rage':'\ud83d\ude21',
  'pouting_cat':'\ud83d\ude3e',
  'pouting_man':'\ud83d\ude4e&zwj;\u2642\ufe0f',
  'pray':'\ud83d\ude4f',
  'prayer_beads':'\ud83d\udcff',
  'pregnant_woman':'\ud83e\udd30',
  'previous_track_button':'\u23ee',
  'prince':'\ud83e\udd34',
  'princess':'\ud83d\udc78',
  'printer':'\ud83d\udda8',
  'purple_heart':'\ud83d\udc9c',
  'purse':'\ud83d\udc5b',
  'pushpin':'\ud83d\udccc',
  'put_litter_in_its_place':'\ud83d\udeae',
  'question':'\u2753',
  'rabbit':'\ud83d\udc30',
  'rabbit2':'\ud83d\udc07',
  'racehorse':'\ud83d\udc0e',
  'racing_car':'\ud83c\udfce',
  'radio':'\ud83d\udcfb',
  'radio_button':'\ud83d\udd18',
  'radioactive':'\u2622\ufe0f',
  'railway_car':'\ud83d\ude83',
  'railway_track':'\ud83d\udee4',
  'rainbow':'\ud83c\udf08',
  'rainbow_flag':'\ud83c\udff3\ufe0f&zwj;\ud83c\udf08',
  'raised_back_of_hand':'\ud83e\udd1a',
  'raised_hand_with_fingers_splayed':'\ud83d\udd90',
  'raised_hands':'\ud83d\ude4c',
  'raising_hand_woman':'\ud83d\ude4b',
  'raising_hand_man':'\ud83d\ude4b&zwj;\u2642\ufe0f',
  'ram':'\ud83d\udc0f',
  'ramen':'\ud83c\udf5c',
  'rat':'\ud83d\udc00',
  'record_button':'\u23fa',
  'recycle':'\u267b\ufe0f',
  'red_circle':'\ud83d\udd34',
  'registered':'\u00ae\ufe0f',
  'relaxed':'\u263a\ufe0f',
  'relieved':'\ud83d\ude0c',
  'reminder_ribbon':'\ud83c\udf97',
  'repeat':'\ud83d\udd01',
  'repeat_one':'\ud83d\udd02',
  'rescue_worker_helmet':'\u26d1',
  'restroom':'\ud83d\udebb',
  'revolving_hearts':'\ud83d\udc9e',
  'rewind':'\u23ea',
  'rhinoceros':'\ud83e\udd8f',
  'ribbon':'\ud83c\udf80',
  'rice':'\ud83c\udf5a',
  'rice_ball':'\ud83c\udf59',
  'rice_cracker':'\ud83c\udf58',
  'rice_scene':'\ud83c\udf91',
  'right_anger_bubble':'\ud83d\uddef',
  'ring':'\ud83d\udc8d',
  'robot':'\ud83e\udd16',
  'rocket':'\ud83d\ude80',
  'rofl':'\ud83e\udd23',
  'roll_eyes':'\ud83d\ude44',
  'roller_coaster':'\ud83c\udfa2',
  'rooster':'\ud83d\udc13',
  'rose':'\ud83c\udf39',
  'rosette':'\ud83c\udff5',
  'rotating_light':'\ud83d\udea8',
  'round_pushpin':'\ud83d\udccd',
  'rowing_man':'\ud83d\udea3',
  'rowing_woman':'\ud83d\udea3&zwj;\u2640\ufe0f',
  'rugby_football':'\ud83c\udfc9',
  'running_man':'\ud83c\udfc3',
  'running_shirt_with_sash':'\ud83c\udfbd',
  'running_woman':'\ud83c\udfc3&zwj;\u2640\ufe0f',
  'sa':'\ud83c\ude02\ufe0f',
  'sagittarius':'\u2650\ufe0f',
  'sake':'\ud83c\udf76',
  'sandal':'\ud83d\udc61',
  'santa':'\ud83c\udf85',
  'satellite':'\ud83d\udce1',
  'saxophone':'\ud83c\udfb7',
  'school':'\ud83c\udfeb',
  'school_satchel':'\ud83c\udf92',
  'scissors':'\u2702\ufe0f',
  'scorpion':'\ud83e\udd82',
  'scorpius':'\u264f\ufe0f',
  'scream':'\ud83d\ude31',
  'scream_cat':'\ud83d\ude40',
  'scroll':'\ud83d\udcdc',
  'seat':'\ud83d\udcba',
  'secret':'\u3299\ufe0f',
  'see_no_evil':'\ud83d\ude48',
  'seedling':'\ud83c\udf31',
  'selfie':'\ud83e\udd33',
  'shallow_pan_of_food':'\ud83e\udd58',
  'shamrock':'\u2618\ufe0f',
  'shark':'\ud83e\udd88',
  'shaved_ice':'\ud83c\udf67',
  'sheep':'\ud83d\udc11',
  'shell':'\ud83d\udc1a',
  'shield':'\ud83d\udee1',
  'shinto_shrine':'\u26e9',
  'ship':'\ud83d\udea2',
  'shirt':'\ud83d\udc55',
  'shopping':'\ud83d\udecd',
  'shopping_cart':'\ud83d\uded2',
  'shower':'\ud83d\udebf',
  'shrimp':'\ud83e\udd90',
  'signal_strength':'\ud83d\udcf6',
  'six_pointed_star':'\ud83d\udd2f',
  'ski':'\ud83c\udfbf',
  'skier':'\u26f7',
  'skull':'\ud83d\udc80',
  'skull_and_crossbones':'\u2620\ufe0f',
  'sleeping':'\ud83d\ude34',
  'sleeping_bed':'\ud83d\udecc',
  'sleepy':'\ud83d\ude2a',
  'slightly_frowning_face':'\ud83d\ude41',
  'slightly_smiling_face':'\ud83d\ude42',
  'slot_machine':'\ud83c\udfb0',
  'small_airplane':'\ud83d\udee9',
  'small_blue_diamond':'\ud83d\udd39',
  'small_orange_diamond':'\ud83d\udd38',
  'small_red_triangle':'\ud83d\udd3a',
  'small_red_triangle_down':'\ud83d\udd3b',
  'smile':'\ud83d\ude04',
  'smile_cat':'\ud83d\ude38',
  'smiley':'\ud83d\ude03',
  'smiley_cat':'\ud83d\ude3a',
  'smiling_imp':'\ud83d\ude08',
  'smirk':'\ud83d\ude0f',
  'smirk_cat':'\ud83d\ude3c',
  'smoking':'\ud83d\udeac',
  'snail':'\ud83d\udc0c',
  'snake':'\ud83d\udc0d',
  'sneezing_face':'\ud83e\udd27',
  'snowboarder':'\ud83c\udfc2',
  'snowflake':'\u2744\ufe0f',
  'snowman':'\u26c4\ufe0f',
  'snowman_with_snow':'\u2603\ufe0f',
  'sob':'\ud83d\ude2d',
  'soccer':'\u26bd\ufe0f',
  'soon':'\ud83d\udd1c',
  'sos':'\ud83c\udd98',
  'sound':'\ud83d\udd09',
  'space_invader':'\ud83d\udc7e',
  'spades':'\u2660\ufe0f',
  'spaghetti':'\ud83c\udf5d',
  'sparkle':'\u2747\ufe0f',
  'sparkler':'\ud83c\udf87',
  'sparkles':'\u2728',
  'sparkling_heart':'\ud83d\udc96',
  'speak_no_evil':'\ud83d\ude4a',
  'speaker':'\ud83d\udd08',
  'speaking_head':'\ud83d\udde3',
  'speech_balloon':'\ud83d\udcac',
  'speedboat':'\ud83d\udea4',
  'spider':'\ud83d\udd77',
  'spider_web':'\ud83d\udd78',
  'spiral_calendar':'\ud83d\uddd3',
  'spiral_notepad':'\ud83d\uddd2',
  'spoon':'\ud83e\udd44',
  'squid':'\ud83e\udd91',
  'stadium':'\ud83c\udfdf',
  'star':'\u2b50\ufe0f',
  'star2':'\ud83c\udf1f',
  'star_and_crescent':'\u262a\ufe0f',
  'star_of_david':'\u2721\ufe0f',
  'stars':'\ud83c\udf20',
  'station':'\ud83d\ude89',
  'statue_of_liberty':'\ud83d\uddfd',
  'steam_locomotive':'\ud83d\ude82',
  'stew':'\ud83c\udf72',
  'stop_button':'\u23f9',
  'stop_sign':'\ud83d\uded1',
  'stopwatch':'\u23f1',
  'straight_ruler':'\ud83d\udccf',
  'strawberry':'\ud83c\udf53',
  'stuck_out_tongue':'\ud83d\ude1b',
  'stuck_out_tongue_closed_eyes':'\ud83d\ude1d',
  'stuck_out_tongue_winking_eye':'\ud83d\ude1c',
  'studio_microphone':'\ud83c\udf99',
  'stuffed_flatbread':'\ud83e\udd59',
  'sun_behind_large_cloud':'\ud83c\udf25',
  'sun_behind_rain_cloud':'\ud83c\udf26',
  'sun_behind_small_cloud':'\ud83c\udf24',
  'sun_with_face':'\ud83c\udf1e',
  'sunflower':'\ud83c\udf3b',
  'sunglasses':'\ud83d\ude0e',
  'sunny':'\u2600\ufe0f',
  'sunrise':'\ud83c\udf05',
  'sunrise_over_mountains':'\ud83c\udf04',
  'surfing_man':'\ud83c\udfc4',
  'surfing_woman':'\ud83c\udfc4&zwj;\u2640\ufe0f',
  'sushi':'\ud83c\udf63',
  'suspension_railway':'\ud83d\ude9f',
  'sweat':'\ud83d\ude13',
  'sweat_drops':'\ud83d\udca6',
  'sweat_smile':'\ud83d\ude05',
  'sweet_potato':'\ud83c\udf60',
  'swimming_man':'\ud83c\udfca',
  'swimming_woman':'\ud83c\udfca&zwj;\u2640\ufe0f',
  'symbols':'\ud83d\udd23',
  'synagogue':'\ud83d\udd4d',
  'syringe':'\ud83d\udc89',
  'taco':'\ud83c\udf2e',
  'tada':'\ud83c\udf89',
  'tanabata_tree':'\ud83c\udf8b',
  'taurus':'\u2649\ufe0f',
  'taxi':'\ud83d\ude95',
  'tea':'\ud83c\udf75',
  'telephone_receiver':'\ud83d\udcde',
  'telescope':'\ud83d\udd2d',
  'tennis':'\ud83c\udfbe',
  'tent':'\u26fa\ufe0f',
  'thermometer':'\ud83c\udf21',
  'thinking':'\ud83e\udd14',
  'thought_balloon':'\ud83d\udcad',
  'ticket':'\ud83c\udfab',
  'tickets':'\ud83c\udf9f',
  'tiger':'\ud83d\udc2f',
  'tiger2':'\ud83d\udc05',
  'timer_clock':'\u23f2',
  'tipping_hand_man':'\ud83d\udc81&zwj;\u2642\ufe0f',
  'tired_face':'\ud83d\ude2b',
  'tm':'\u2122\ufe0f',
  'toilet':'\ud83d\udebd',
  'tokyo_tower':'\ud83d\uddfc',
  'tomato':'\ud83c\udf45',
  'tongue':'\ud83d\udc45',
  'top':'\ud83d\udd1d',
  'tophat':'\ud83c\udfa9',
  'tornado':'\ud83c\udf2a',
  'trackball':'\ud83d\uddb2',
  'tractor':'\ud83d\ude9c',
  'traffic_light':'\ud83d\udea5',
  'train':'\ud83d\ude8b',
  'train2':'\ud83d\ude86',
  'tram':'\ud83d\ude8a',
  'triangular_flag_on_post':'\ud83d\udea9',
  'triangular_ruler':'\ud83d\udcd0',
  'trident':'\ud83d\udd31',
  'triumph':'\ud83d\ude24',
  'trolleybus':'\ud83d\ude8e',
  'trophy':'\ud83c\udfc6',
  'tropical_drink':'\ud83c\udf79',
  'tropical_fish':'\ud83d\udc20',
  'truck':'\ud83d\ude9a',
  'trumpet':'\ud83c\udfba',
  'tulip':'\ud83c\udf37',
  'tumbler_glass':'\ud83e\udd43',
  'turkey':'\ud83e\udd83',
  'turtle':'\ud83d\udc22',
  'tv':'\ud83d\udcfa',
  'twisted_rightwards_arrows':'\ud83d\udd00',
  'two_hearts':'\ud83d\udc95',
  'two_men_holding_hands':'\ud83d\udc6c',
  'two_women_holding_hands':'\ud83d\udc6d',
  'u5272':'\ud83c\ude39',
  'u5408':'\ud83c\ude34',
  'u55b6':'\ud83c\ude3a',
  'u6307':'\ud83c\ude2f\ufe0f',
  'u6708':'\ud83c\ude37\ufe0f',
  'u6709':'\ud83c\ude36',
  'u6e80':'\ud83c\ude35',
  'u7121':'\ud83c\ude1a\ufe0f',
  'u7533':'\ud83c\ude38',
  'u7981':'\ud83c\ude32',
  'u7a7a':'\ud83c\ude33',
  'umbrella':'\u2614\ufe0f',
  'unamused':'\ud83d\ude12',
  'underage':'\ud83d\udd1e',
  'unicorn':'\ud83e\udd84',
  'unlock':'\ud83d\udd13',
  'up':'\ud83c\udd99',
  'upside_down_face':'\ud83d\ude43',
  'v':'\u270c\ufe0f',
  'vertical_traffic_light':'\ud83d\udea6',
  'vhs':'\ud83d\udcfc',
  'vibration_mode':'\ud83d\udcf3',
  'video_camera':'\ud83d\udcf9',
  'video_game':'\ud83c\udfae',
  'violin':'\ud83c\udfbb',
  'virgo':'\u264d\ufe0f',
  'volcano':'\ud83c\udf0b',
  'volleyball':'\ud83c\udfd0',
  'vs':'\ud83c\udd9a',
  'vulcan_salute':'\ud83d\udd96',
  'walking_man':'\ud83d\udeb6',
  'walking_woman':'\ud83d\udeb6&zwj;\u2640\ufe0f',
  'waning_crescent_moon':'\ud83c\udf18',
  'waning_gibbous_moon':'\ud83c\udf16',
  'warning':'\u26a0\ufe0f',
  'wastebasket':'\ud83d\uddd1',
  'watch':'\u231a\ufe0f',
  'water_buffalo':'\ud83d\udc03',
  'watermelon':'\ud83c\udf49',
  'wave':'\ud83d\udc4b',
  'wavy_dash':'\u3030\ufe0f',
  'waxing_crescent_moon':'\ud83c\udf12',
  'wc':'\ud83d\udebe',
  'weary':'\ud83d\ude29',
  'wedding':'\ud83d\udc92',
  'weight_lifting_man':'\ud83c\udfcb\ufe0f',
  'weight_lifting_woman':'\ud83c\udfcb\ufe0f&zwj;\u2640\ufe0f',
  'whale':'\ud83d\udc33',
  'whale2':'\ud83d\udc0b',
  'wheel_of_dharma':'\u2638\ufe0f',
  'wheelchair':'\u267f\ufe0f',
  'white_check_mark':'\u2705',
  'white_circle':'\u26aa\ufe0f',
  'white_flag':'\ud83c\udff3\ufe0f',
  'white_flower':'\ud83d\udcae',
  'white_large_square':'\u2b1c\ufe0f',
  'white_medium_small_square':'\u25fd\ufe0f',
  'white_medium_square':'\u25fb\ufe0f',
  'white_small_square':'\u25ab\ufe0f',
  'white_square_button':'\ud83d\udd33',
  'wilted_flower':'\ud83e\udd40',
  'wind_chime':'\ud83c\udf90',
  'wind_face':'\ud83c\udf2c',
  'wine_glass':'\ud83c\udf77',
  'wink':'\ud83d\ude09',
  'wolf':'\ud83d\udc3a',
  'woman':'\ud83d\udc69',
  'woman_artist':'\ud83d\udc69&zwj;\ud83c\udfa8',
  'woman_astronaut':'\ud83d\udc69&zwj;\ud83d\ude80',
  'woman_cartwheeling':'\ud83e\udd38&zwj;\u2640\ufe0f',
  'woman_cook':'\ud83d\udc69&zwj;\ud83c\udf73',
  'woman_facepalming':'\ud83e\udd26&zwj;\u2640\ufe0f',
  'woman_factory_worker':'\ud83d\udc69&zwj;\ud83c\udfed',
  'woman_farmer':'\ud83d\udc69&zwj;\ud83c\udf3e',
  'woman_firefighter':'\ud83d\udc69&zwj;\ud83d\ude92',
  'woman_health_worker':'\ud83d\udc69&zwj;\u2695\ufe0f',
  'woman_judge':'\ud83d\udc69&zwj;\u2696\ufe0f',
  'woman_juggling':'\ud83e\udd39&zwj;\u2640\ufe0f',
  'woman_mechanic':'\ud83d\udc69&zwj;\ud83d\udd27',
  'woman_office_worker':'\ud83d\udc69&zwj;\ud83d\udcbc',
  'woman_pilot':'\ud83d\udc69&zwj;\u2708\ufe0f',
  'woman_playing_handball':'\ud83e\udd3e&zwj;\u2640\ufe0f',
  'woman_playing_water_polo':'\ud83e\udd3d&zwj;\u2640\ufe0f',
  'woman_scientist':'\ud83d\udc69&zwj;\ud83d\udd2c',
  'woman_shrugging':'\ud83e\udd37&zwj;\u2640\ufe0f',
  'woman_singer':'\ud83d\udc69&zwj;\ud83c\udfa4',
  'woman_student':'\ud83d\udc69&zwj;\ud83c\udf93',
  'woman_teacher':'\ud83d\udc69&zwj;\ud83c\udfeb',
  'woman_technologist':'\ud83d\udc69&zwj;\ud83d\udcbb',
  'woman_with_turban':'\ud83d\udc73&zwj;\u2640\ufe0f',
  'womans_clothes':'\ud83d\udc5a',
  'womans_hat':'\ud83d\udc52',
  'women_wrestling':'\ud83e\udd3c&zwj;\u2640\ufe0f',
  'womens':'\ud83d\udeba',
  'world_map':'\ud83d\uddfa',
  'worried':'\ud83d\ude1f',
  'wrench':'\ud83d\udd27',
  'writing_hand':'\u270d\ufe0f',
  'x':'\u274c',
  'yellow_heart':'\ud83d\udc9b',
  'yen':'\ud83d\udcb4',
  'yin_yang':'\u262f\ufe0f',
  'yum':'\ud83d\ude0b',
  'zap':'\u26a1\ufe0f',
  'zipper_mouth_face':'\ud83e\udd10',
  'zzz':'\ud83d\udca4',

  /* special emojis :P */
  'octocat':  '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
  'showdown': '<span style="font-family: \'Anonymous Pro\', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;">S</span>'
};

/**
 * Created by Estevao on 31-05-2015.
 */

/**
 * Showdown Converter class
 * @class
 * @param {object} [converterOptions]
 * @returns {Converter}
 */
showdown.Converter = function (converterOptions) {
  'use strict';

  var
      /**
       * Options used by this converter
       * @private
       * @type {{}}
       */
      options = {},

      /**
       * Language extensions used by this converter
       * @private
       * @type {Array}
       */
      langExtensions = [],

      /**
       * Output modifiers extensions used by this converter
       * @private
       * @type {Array}
       */
      outputModifiers = [],

      /**
       * Event listeners
       * @private
       * @type {{}}
       */
      listeners = {},

      /**
       * The flavor set in this converter
       */
      setConvFlavor = setFlavor,

      /**
       * Metadata of the document
       * @type {{parsed: {}, raw: string, format: string}}
       */
      metadata = {
        parsed: {},
        raw: '',
        format: ''
      };

  _constructor();

  /**
   * Converter constructor
   * @private
   */
  function _constructor () {
    converterOptions = converterOptions || {};

    for (var gOpt in globalOptions) {
      if (globalOptions.hasOwnProperty(gOpt)) {
        options[gOpt] = globalOptions[gOpt];
      }
    }

    // Merge options
    if (typeof converterOptions === 'object') {
      for (var opt in converterOptions) {
        if (converterOptions.hasOwnProperty(opt)) {
          options[opt] = converterOptions[opt];
        }
      }
    } else {
      throw Error('Converter expects the passed parameter to be an object, but ' + typeof converterOptions +
      ' was passed instead.');
    }

    if (options.extensions) {
      showdown.helper.forEach(options.extensions, _parseExtension);
    }
  }

  /**
   * Parse extension
   * @param {*} ext
   * @param {string} [name='']
   * @private
   */
  function _parseExtension (ext, name) {

    name = name || null;
    // If it's a string, the extension was previously loaded
    if (showdown.helper.isString(ext)) {
      ext = showdown.helper.stdExtName(ext);
      name = ext;

      // LEGACY_SUPPORT CODE
      if (showdown.extensions[ext]) {
        console.warn('DEPRECATION WARNING: ' + ext + ' is an old extension that uses a deprecated loading method.' +
          'Please inform the developer that the extension should be updated!');
        legacyExtensionLoading(showdown.extensions[ext], ext);
        return;
        // END LEGACY SUPPORT CODE

      } else if (!showdown.helper.isUndefined(extensions[ext])) {
        ext = extensions[ext];

      } else {
        throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
      }
    }

    if (typeof ext === 'function') {
      ext = ext();
    }

    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }

    var validExt = validate(ext, name);
    if (!validExt.valid) {
      throw Error(validExt.error);
    }

    for (var i = 0; i < ext.length; ++i) {
      switch (ext[i].type) {

        case 'lang':
          langExtensions.push(ext[i]);
          break;

        case 'output':
          outputModifiers.push(ext[i]);
          break;
      }
      if (ext[i].hasOwnProperty('listeners')) {
        for (var ln in ext[i].listeners) {
          if (ext[i].listeners.hasOwnProperty(ln)) {
            listen(ln, ext[i].listeners[ln]);
          }
        }
      }
    }

  }

  /**
   * LEGACY_SUPPORT
   * @param {*} ext
   * @param {string} name
   */
  function legacyExtensionLoading (ext, name) {
    if (typeof ext === 'function') {
      ext = ext(new showdown.Converter());
    }
    if (!showdown.helper.isArray(ext)) {
      ext = [ext];
    }
    var valid = validate(ext, name);

    if (!valid.valid) {
      throw Error(valid.error);
    }

    for (var i = 0; i < ext.length; ++i) {
      switch (ext[i].type) {
        case 'lang':
          langExtensions.push(ext[i]);
          break;
        case 'output':
          outputModifiers.push(ext[i]);
          break;
        default:// should never reach here
          throw Error('Extension loader error: Type unrecognized!!!');
      }
    }
  }

  /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   */
  function listen (name, callback) {
    if (!showdown.helper.isString(name)) {
      throw Error('Invalid argument in converter.listen() method: name must be a string, but ' + typeof name + ' given');
    }

    if (typeof callback !== 'function') {
      throw Error('Invalid argument in converter.listen() method: callback must be a function, but ' + typeof callback + ' given');
    }

    if (!listeners.hasOwnProperty(name)) {
      listeners[name] = [];
    }
    listeners[name].push(callback);
  }

  function rTrimInputText (text) {
    var rsp = text.match(/^\s*/)[0].length,
        rgx = new RegExp('^\\s{0,' + rsp + '}', 'gm');
    return text.replace(rgx, '');
  }

  /**
   * Dispatch an event
   * @private
   * @param {string} evtName Event name
   * @param {string} text Text
   * @param {{}} options Converter Options
   * @param {{}} globals
   * @returns {string}
   */
  this._dispatch = function dispatch (evtName, text, options, globals) {
    if (listeners.hasOwnProperty(evtName)) {
      for (var ei = 0; ei < listeners[evtName].length; ++ei) {
        var nText = listeners[evtName][ei](evtName, text, this, options, globals);
        if (nText && typeof nText !== 'undefined') {
          text = nText;
        }
      }
    }
    return text;
  };

  /**
   * Listen to an event
   * @param {string} name
   * @param {function} callback
   * @returns {showdown.Converter}
   */
  this.listen = function (name, callback) {
    listen(name, callback);
    return this;
  };

  /**
   * Converts a markdown string into HTML
   * @param {string} text
   * @returns {*}
   */
  this.makeHtml = function (text) {
    //check if text is not falsy
    if (!text) {
      return text;
    }

    var globals = {
      gHtmlBlocks:     [],
      gHtmlMdBlocks:   [],
      gHtmlSpans:      [],
      gUrls:           {},
      gTitles:         {},
      gDimensions:     {},
      gListLevel:      0,
      hashLinkCounts:  {},
      langExtensions:  langExtensions,
      outputModifiers: outputModifiers,
      converter:       this,
      ghCodeBlocks:    [],
      metadata: {
        parsed: {},
        raw: '',
        format: ''
      }
    };

    // This lets us use ¨ trema as an escape char to avoid md5 hashes
    // The choice of character is arbitrary; anything that isn't
    // magic in Markdown will work.
    text = text.replace(/¨/g, '¨T');

    // Replace $ with ¨D
    // RegExp interprets $ as a special character
    // when it's in a replacement string
    text = text.replace(/\$/g, '¨D');

    // Standardize line endings
    text = text.replace(/\r\n/g, '\n'); // DOS to Unix
    text = text.replace(/\r/g, '\n'); // Mac to Unix

    // Stardardize line spaces
    text = text.replace(/\u00A0/g, '&nbsp;');

    if (options.smartIndentationFix) {
      text = rTrimInputText(text);
    }

    // Make sure text begins and ends with a couple of newlines:
    text = '\n\n' + text + '\n\n';

    // detab
    text = showdown.subParser('detab')(text, options, globals);

    /**
     * Strip any lines consisting only of spaces and tabs.
     * This makes subsequent regexs easier to write, because we can
     * match consecutive blank lines with /\n+/ instead of something
     * contorted like /[ \t]*\n+/
     */
    text = text.replace(/^[ \t]+$/mg, '');

    //run languageExtensions
    showdown.helper.forEach(langExtensions, function (ext) {
      text = showdown.subParser('runExtension')(ext, text, options, globals);
    });

    // run the sub parsers
    text = showdown.subParser('metadata')(text, options, globals);
    text = showdown.subParser('hashPreCodeTags')(text, options, globals);
    text = showdown.subParser('githubCodeBlocks')(text, options, globals);
    text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
    text = showdown.subParser('hashCodeTags')(text, options, globals);
    text = showdown.subParser('stripLinkDefinitions')(text, options, globals);
    text = showdown.subParser('blockGamut')(text, options, globals);
    text = showdown.subParser('unhashHTMLSpans')(text, options, globals);
    text = showdown.subParser('unescapeSpecialChars')(text, options, globals);

    // attacklab: Restore dollar signs
    text = text.replace(/¨D/g, '$$');

    // attacklab: Restore tremas
    text = text.replace(/¨T/g, '¨');

    // render a complete html document instead of a partial if the option is enabled
    text = showdown.subParser('completeHTMLDocument')(text, options, globals);

    // Run output modifiers
    showdown.helper.forEach(outputModifiers, function (ext) {
      text = showdown.subParser('runExtension')(ext, text, options, globals);
    });

    // update metadata
    metadata = globals.metadata;
    return text;
  };

  /**
   * Converts an HTML string into a markdown string
   * @param src
   * @param [HTMLParser] A WHATWG DOM and HTML parser, such as JSDOM. If none is supplied, window.document will be used.
   * @returns {string}
   */
  this.makeMarkdown = this.makeMd = function (src, HTMLParser) {

    // replace \r\n with \n
    src = src.replace(/\r\n/g, '\n');
    src = src.replace(/\r/g, '\n'); // old macs

    // due to an edge case, we need to find this: > <
    // to prevent removing of non silent white spaces
    // ex: <em>this is</em> <strong>sparta</strong>
    src = src.replace(/>[ \t]+</, '>¨NBSP;<');

    if (!HTMLParser) {
      if (window && window.document) {
        HTMLParser = window.document;
      } else {
        throw new Error('HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM');
      }
    }

    var doc = HTMLParser.createElement('div');
    doc.innerHTML = src;

    var globals = {
      preList: substitutePreCodeTags(doc)
    };

    // remove all newlines and collapse spaces
    clean(doc);

    // some stuff, like accidental reference links must now be escaped
    // TODO
    // doc.innerHTML = doc.innerHTML.replace(/\[[\S\t ]]/);

    var nodes = doc.childNodes,
        mdDoc = '';

    for (var i = 0; i < nodes.length; i++) {
      mdDoc += showdown.subParser('makeMarkdown.node')(nodes[i], globals);
    }

    function clean (node) {
      for (var n = 0; n < node.childNodes.length; ++n) {
        var child = node.childNodes[n];
        if (child.nodeType === 3) {
          if (!/\S/.test(child.nodeValue) && !/^[ ]+$/.test(child.nodeValue)) {
            node.removeChild(child);
            --n;
          } else {
            child.nodeValue = child.nodeValue.split('\n').join(' ');
            child.nodeValue = child.nodeValue.replace(/(\s)+/g, '$1');
          }
        } else if (child.nodeType === 1) {
          clean(child);
        }
      }
    }

    // find all pre tags and replace contents with placeholder
    // we need this so that we can remove all indentation from html
    // to ease up parsing
    function substitutePreCodeTags (doc) {

      var pres = doc.querySelectorAll('pre'),
          presPH = [];

      for (var i = 0; i < pres.length; ++i) {

        if (pres[i].childElementCount === 1 && pres[i].firstChild.tagName.toLowerCase() === 'code') {
          var content = pres[i].firstChild.innerHTML.trim(),
              language = pres[i].firstChild.getAttribute('data-language') || '';

          // if data-language attribute is not defined, then we look for class language-*
          if (language === '') {
            var classes = pres[i].firstChild.className.split(' ');
            for (var c = 0; c < classes.length; ++c) {
              var matches = classes[c].match(/^language-(.+)$/);
              if (matches !== null) {
                language = matches[1];
                break;
              }
            }
          }

          // unescape html entities in content
          content = showdown.helper.unescapeHTMLEntities(content);

          presPH.push(content);
          pres[i].outerHTML = '<precode language="' + language + '" precodenum="' + i.toString() + '"></precode>';
        } else {
          presPH.push(pres[i].innerHTML);
          pres[i].innerHTML = '';
          pres[i].setAttribute('prenum', i.toString());
        }
      }
      return presPH;
    }

    return mdDoc;
  };

  /**
   * Set an option of this Converter instance
   * @param {string} key
   * @param {*} value
   */
  this.setOption = function (key, value) {
    options[key] = value;
  };

  /**
   * Get the option of this Converter instance
   * @param {string} key
   * @returns {*}
   */
  this.getOption = function (key) {
    return options[key];
  };

  /**
   * Get the options of this Converter instance
   * @returns {{}}
   */
  this.getOptions = function () {
    return options;
  };

  /**
   * Add extension to THIS converter
   * @param {{}} extension
   * @param {string} [name=null]
   */
  this.addExtension = function (extension, name) {
    name = name || null;
    _parseExtension(extension, name);
  };

  /**
   * Use a global registered extension with THIS converter
   * @param {string} extensionName Name of the previously registered extension
   */
  this.useExtension = function (extensionName) {
    _parseExtension(extensionName);
  };

  /**
   * Set the flavor THIS converter should use
   * @param {string} name
   */
  this.setFlavor = function (name) {
    if (!flavor.hasOwnProperty(name)) {
      throw Error(name + ' flavor was not found');
    }
    var preset = flavor[name];
    setConvFlavor = name;
    for (var option in preset) {
      if (preset.hasOwnProperty(option)) {
        options[option] = preset[option];
      }
    }
  };

  /**
   * Get the currently set flavor of this converter
   * @returns {string}
   */
  this.getFlavor = function () {
    return setConvFlavor;
  };

  /**
   * Remove an extension from THIS converter.
   * Note: This is a costly operation. It's better to initialize a new converter
   * and specify the extensions you wish to use
   * @param {Array} extension
   */
  this.removeExtension = function (extension) {
    if (!showdown.helper.isArray(extension)) {
      extension = [extension];
    }
    for (var a = 0; a < extension.length; ++a) {
      var ext = extension[a];
      for (var i = 0; i < langExtensions.length; ++i) {
        if (langExtensions[i] === ext) {
          langExtensions.splice(i, 1);
        }
      }
      for (var ii = 0; ii < outputModifiers.length; ++ii) {
        if (outputModifiers[ii] === ext) {
          outputModifiers.splice(ii, 1);
        }
      }
    }
  };

  /**
   * Get all extension of THIS converter
   * @returns {{language: Array, output: Array}}
   */
  this.getAllExtensions = function () {
    return {
      language: langExtensions,
      output: outputModifiers
    };
  };

  /**
   * Get the metadata of the previously parsed document
   * @param raw
   * @returns {string|{}}
   */
  this.getMetadata = function (raw) {
    if (raw) {
      return metadata.raw;
    } else {
      return metadata.parsed;
    }
  };

  /**
   * Get the metadata format of the previously parsed document
   * @returns {string}
   */
  this.getMetadataFormat = function () {
    return metadata.format;
  };

  /**
   * Private: set a single key, value metadata pair
   * @param {string} key
   * @param {string} value
   */
  this._setMetadataPair = function (key, value) {
    metadata.parsed[key] = value;
  };

  /**
   * Private: set metadata format
   * @param {string} format
   */
  this._setMetadataFormat = function (format) {
    metadata.format = format;
  };

  /**
   * Private: set metadata raw text
   * @param {string} raw
   */
  this._setMetadataRaw = function (raw) {
    metadata.raw = raw;
  };
};

/**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */
showdown.subParser('anchors', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('anchors.before', text, options, globals);

  var writeAnchorTag = function (wholeMatch, linkText, linkId, url, m5, m6, title) {
    if (showdown.helper.isUndefined(title)) {
      title = '';
    }
    linkId = linkId.toLowerCase();

    // Special case for explicit empty url
    if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) {
      url = '';
    } else if (!url) {
      if (!linkId) {
        // lower-case and turn embedded newlines into spaces
        linkId = linkText.toLowerCase().replace(/ ?\n/g, ' ');
      }
      url = '#' + linkId;

      if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
        url = globals.gUrls[linkId];
        if (!showdown.helper.isUndefined(globals.gTitles[linkId])) {
          title = globals.gTitles[linkId];
        }
      } else {
        return wholeMatch;
      }
    }

    //url = showdown.helper.escapeCharacters(url, '*_', false); // replaced line to improve performance
    url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);

    var result = '<a href="' + url + '"';

    if (title !== '' && title !== null) {
      title = title.replace(/"/g, '&quot;');
      //title = showdown.helper.escapeCharacters(title, '*_', false); // replaced line to improve performance
      title = title.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
      result += ' title="' + title + '"';
    }

    // optionLinksInNewWindow only applies
    // to external links. Hash links (#) open in same page
    if (options.openLinksInNewWindow && !/^#/.test(url)) {
      // escaped _
      result += ' rel="noopener noreferrer" target="¨E95Eblank"';
    }

    result += '>' + linkText + '</a>';

    return result;
  };

  // First, handle reference-style links: [link text] [id]
  text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, writeAnchorTag);

  // Next, inline-style links: [link text](url "optional title")
  // cases with crazy urls like ./image/cat1).png
  text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g,
    writeAnchorTag);

  // normal cases
  text = text.replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g,
    writeAnchorTag);

  // handle reference-style shortcuts: [link text]
  // These must come last in case you've also got [link test][1]
  // or [link test](/foo)
  text = text.replace(/\[([^\[\]]+)]()()()()()/g, writeAnchorTag);

  // Lastly handle GithubMentions if option is enabled
  if (options.ghMentions) {
    text = text.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gmi, function (wm, st, escape, mentions, username) {
      if (escape === '\\') {
        return st + mentions;
      }

      //check if options.ghMentionsLink is a string
      if (!showdown.helper.isString(options.ghMentionsLink)) {
        throw new Error('ghMentionsLink option must be a string');
      }
      var lnk = options.ghMentionsLink.replace(/\{u}/g, username),
          target = '';
      if (options.openLinksInNewWindow) {
        target = ' rel="noopener noreferrer" target="¨E95Eblank"';
      }
      return st + '<a href="' + lnk + '"' + target + '>' + mentions + '</a>';
    });
  }

  text = globals.converter._dispatch('anchors.after', text, options, globals);
  return text;
});

// url allowed chars [a-z\d_.~:/?#[]@!$&'()*+,;=-]

var simpleURLRegex  = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi,
    simpleURLRegex2 = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi,
    delimUrlRegex   = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi,
    simpleMailRegex = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gmi,
    delimMailRegex  = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi,

    replaceLink = function (options) {
      'use strict';
      return function (wm, leadingMagicChars, link, m2, m3, trailingPunctuation, trailingMagicChars) {
        link = link.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
        var lnkTxt = link,
            append = '',
            target = '',
            lmc    = leadingMagicChars || '',
            tmc    = trailingMagicChars || '';
        if (/^www\./i.test(link)) {
          link = link.replace(/^www\./i, 'http://www.');
        }
        if (options.excludeTrailingPunctuationFromURLs && trailingPunctuation) {
          append = trailingPunctuation;
        }
        if (options.openLinksInNewWindow) {
          target = ' rel="noopener noreferrer" target="¨E95Eblank"';
        }
        return lmc + '<a href="' + link + '"' + target + '>' + lnkTxt + '</a>' + append + tmc;
      };
    },

    replaceMail = function (options, globals) {
      'use strict';
      return function (wholeMatch, b, mail) {
        var href = 'mailto:';
        b = b || '';
        mail = showdown.subParser('unescapeSpecialChars')(mail, options, globals);
        if (options.encodeEmails) {
          href = showdown.helper.encodeEmailAddress(href + mail);
          mail = showdown.helper.encodeEmailAddress(mail);
        } else {
          href = href + mail;
        }
        return b + '<a href="' + href + '">' + mail + '</a>';
      };
    };

showdown.subParser('autoLinks', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('autoLinks.before', text, options, globals);

  text = text.replace(delimUrlRegex, replaceLink(options));
  text = text.replace(delimMailRegex, replaceMail(options, globals));

  text = globals.converter._dispatch('autoLinks.after', text, options, globals);

  return text;
});

showdown.subParser('simplifiedAutoLinks', function (text, options, globals) {
  'use strict';

  if (!options.simplifiedAutoLink) {
    return text;
  }

  text = globals.converter._dispatch('simplifiedAutoLinks.before', text, options, globals);

  if (options.excludeTrailingPunctuationFromURLs) {
    text = text.replace(simpleURLRegex2, replaceLink(options));
  } else {
    text = text.replace(simpleURLRegex, replaceLink(options));
  }
  text = text.replace(simpleMailRegex, replaceMail(options, globals));

  text = globals.converter._dispatch('simplifiedAutoLinks.after', text, options, globals);

  return text;
});

/**
 * These are all the transformations that form block-level
 * tags like paragraphs, headers, and list items.
 */
showdown.subParser('blockGamut', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('blockGamut.before', text, options, globals);

  // we parse blockquotes first so that we can have headings and hrs
  // inside blockquotes
  text = showdown.subParser('blockQuotes')(text, options, globals);
  text = showdown.subParser('headers')(text, options, globals);

  // Do Horizontal Rules:
  text = showdown.subParser('horizontalRule')(text, options, globals);

  text = showdown.subParser('lists')(text, options, globals);
  text = showdown.subParser('codeBlocks')(text, options, globals);
  text = showdown.subParser('tables')(text, options, globals);

  // We already ran _HashHTMLBlocks() before, in Markdown(), but that
  // was to escape raw HTML in the original Markdown source. This time,
  // we're escaping the markup we've just created, so that we don't wrap
  // <p> tags around block-level tags.
  text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
  text = showdown.subParser('paragraphs')(text, options, globals);

  text = globals.converter._dispatch('blockGamut.after', text, options, globals);

  return text;
});

showdown.subParser('blockQuotes', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('blockQuotes.before', text, options, globals);

  // add a couple extra lines after the text and endtext mark
  text = text + '\n\n';

  var rgx = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;

  if (options.splitAdjacentBlockquotes) {
    rgx = /^ {0,3}>[\s\S]*?(?:\n\n)/gm;
  }

  text = text.replace(rgx, function (bq) {
    // attacklab: hack around Konqueror 3.5.4 bug:
    // "----------bug".replace(/^-/g,"") == "bug"
    bq = bq.replace(/^[ \t]*>[ \t]?/gm, ''); // trim one level of quoting

    // attacklab: clean up hack
    bq = bq.replace(/¨0/g, '');

    bq = bq.replace(/^[ \t]+$/gm, ''); // trim whitespace-only lines
    bq = showdown.subParser('githubCodeBlocks')(bq, options, globals);
    bq = showdown.subParser('blockGamut')(bq, options, globals); // recurse

    bq = bq.replace(/(^|\n)/g, '$1  ');
    // These leading spaces screw with <pre> content, so we need to fix that:
    bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function (wholeMatch, m1) {
      var pre = m1;
      // attacklab: hack around Konqueror 3.5.4 bug:
      pre = pre.replace(/^  /mg, '¨0');
      pre = pre.replace(/¨0/g, '');
      return pre;
    });

    return showdown.subParser('hashBlock')('<blockquote>\n' + bq + '\n</blockquote>', options, globals);
  });

  text = globals.converter._dispatch('blockQuotes.after', text, options, globals);
  return text;
});

/**
 * Process Markdown `<pre><code>` blocks.
 */
showdown.subParser('codeBlocks', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('codeBlocks.before', text, options, globals);

  // sentinel workarounds for lack of \A and \Z, safari\khtml bug
  text += '¨0';

  var pattern = /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=¨0))/g;
  text = text.replace(pattern, function (wholeMatch, m1, m2) {
    var codeblock = m1,
        nextChar = m2,
        end = '\n';

    codeblock = showdown.subParser('outdent')(codeblock, options, globals);
    codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
    codeblock = showdown.subParser('detab')(codeblock, options, globals);
    codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
    codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing newlines

    if (options.omitExtraWLInCodeBlocks) {
      end = '';
    }

    codeblock = '<pre><code>' + codeblock + end + '</code></pre>';

    return showdown.subParser('hashBlock')(codeblock, options, globals) + nextChar;
  });

  // strip sentinel
  text = text.replace(/¨0/, '');

  text = globals.converter._dispatch('codeBlocks.after', text, options, globals);
  return text;
});

/**
 *
 *   *  Backtick quotes are used for <code></code> spans.
 *
 *   *  You can use multiple backticks as the delimiters if you want to
 *     include literal backticks in the code span. So, this input:
 *
 *         Just type ``foo `bar` baz`` at the prompt.
 *
 *       Will translate to:
 *
 *         <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
 *
 *    There's no arbitrary limit to the number of backticks you
 *    can use as delimters. If you need three consecutive backticks
 *    in your code, use four for delimiters, etc.
 *
 *  *  You can use spaces to get literal backticks at the edges:
 *
 *         ... type `` `bar` `` ...
 *
 *       Turns to:
 *
 *         ... type <code>`bar`</code> ...
 */
showdown.subParser('codeSpans', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('codeSpans.before', text, options, globals);

  if (typeof (text) === 'undefined') {
    text = '';
  }
  text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm,
    function (wholeMatch, m1, m2, m3) {
      var c = m3;
      c = c.replace(/^([ \t]*)/g, '');	// leading whitespace
      c = c.replace(/[ \t]*$/g, '');	// trailing whitespace
      c = showdown.subParser('encodeCode')(c, options, globals);
      c = m1 + '<code>' + c + '</code>';
      c = showdown.subParser('hashHTMLSpans')(c, options, globals);
      return c;
    }
  );

  text = globals.converter._dispatch('codeSpans.after', text, options, globals);
  return text;
});

/**
 * Create a full HTML document from the processed markdown
 */
showdown.subParser('completeHTMLDocument', function (text, options, globals) {
  'use strict';

  if (!options.completeHTMLDocument) {
    return text;
  }

  text = globals.converter._dispatch('completeHTMLDocument.before', text, options, globals);

  var doctype = 'html',
      doctypeParsed = '<!DOCTYPE HTML>\n',
      title = '',
      charset = '<meta charset="utf-8">\n',
      lang = '',
      metadata = '';

  if (typeof globals.metadata.parsed.doctype !== 'undefined') {
    doctypeParsed = '<!DOCTYPE ' +  globals.metadata.parsed.doctype + '>\n';
    doctype = globals.metadata.parsed.doctype.toString().toLowerCase();
    if (doctype === 'html' || doctype === 'html5') {
      charset = '<meta charset="utf-8">';
    }
  }

  for (var meta in globals.metadata.parsed) {
    if (globals.metadata.parsed.hasOwnProperty(meta)) {
      switch (meta.toLowerCase()) {
        case 'doctype':
          break;

        case 'title':
          title = '<title>' +  globals.metadata.parsed.title + '</title>\n';
          break;

        case 'charset':
          if (doctype === 'html' || doctype === 'html5') {
            charset = '<meta charset="' + globals.metadata.parsed.charset + '">\n';
          } else {
            charset = '<meta name="charset" content="' + globals.metadata.parsed.charset + '">\n';
          }
          break;

        case 'language':
        case 'lang':
          lang = ' lang="' + globals.metadata.parsed[meta] + '"';
          metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
          break;

        default:
          metadata += '<meta name="' + meta + '" content="' + globals.metadata.parsed[meta] + '">\n';
      }
    }
  }

  text = doctypeParsed + '<html' + lang + '>\n<head>\n' + title + charset + metadata + '</head>\n<body>\n' + text.trim() + '\n</body>\n</html>';

  text = globals.converter._dispatch('completeHTMLDocument.after', text, options, globals);
  return text;
});

/**
 * Convert all tabs to spaces
 */
showdown.subParser('detab', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('detab.before', text, options, globals);

  // expand first n-1 tabs
  text = text.replace(/\t(?=\t)/g, '    '); // g_tab_width

  // replace the nth with two sentinels
  text = text.replace(/\t/g, '¨A¨B');

  // use the sentinel to anchor our regex so it doesn't explode
  text = text.replace(/¨B(.+?)¨A/g, function (wholeMatch, m1) {
    var leadingText = m1,
        numSpaces = 4 - leadingText.length % 4;  // g_tab_width

    // there *must* be a better way to do this:
    for (var i = 0; i < numSpaces; i++) {
      leadingText += ' ';
    }

    return leadingText;
  });

  // clean up sentinels
  text = text.replace(/¨A/g, '    ');  // g_tab_width
  text = text.replace(/¨B/g, '');

  text = globals.converter._dispatch('detab.after', text, options, globals);
  return text;
});

showdown.subParser('ellipsis', function (text, options, globals) {
  'use strict';

  if (!options.ellipsis) {
    return text;
  }

  text = globals.converter._dispatch('ellipsis.before', text, options, globals);

  text = text.replace(/\.\.\./g, '…');

  text = globals.converter._dispatch('ellipsis.after', text, options, globals);

  return text;
});

/**
 * Turn emoji codes into emojis
 *
 * List of supported emojis: https://github.com/showdownjs/showdown/wiki/Emojis
 */
showdown.subParser('emoji', function (text, options, globals) {
  'use strict';

  if (!options.emoji) {
    return text;
  }

  text = globals.converter._dispatch('emoji.before', text, options, globals);

  var emojiRgx = /:([\S]+?):/g;

  text = text.replace(emojiRgx, function (wm, emojiCode) {
    if (showdown.helper.emojis.hasOwnProperty(emojiCode)) {
      return showdown.helper.emojis[emojiCode];
    }
    return wm;
  });

  text = globals.converter._dispatch('emoji.after', text, options, globals);

  return text;
});

/**
 * Smart processing for ampersands and angle brackets that need to be encoded.
 */
showdown.subParser('encodeAmpsAndAngles', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('encodeAmpsAndAngles.before', text, options, globals);

  // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
  // http://bumppo.net/projects/amputator/
  text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, '&amp;');

  // Encode naked <'s
  text = text.replace(/<(?![a-z\/?$!])/gi, '&lt;');

  // Encode <
  text = text.replace(/</g, '&lt;');

  // Encode >
  text = text.replace(/>/g, '&gt;');

  text = globals.converter._dispatch('encodeAmpsAndAngles.after', text, options, globals);
  return text;
});

/**
 * Returns the string, with after processing the following backslash escape sequences.
 *
 * attacklab: The polite way to do this is with the new escapeCharacters() function:
 *
 *    text = escapeCharacters(text,"\\",true);
 *    text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
 *
 * ...but we're sidestepping its use of the (slow) RegExp constructor
 * as an optimization for Firefox.  This function gets called a LOT.
 */
showdown.subParser('encodeBackslashEscapes', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('encodeBackslashEscapes.before', text, options, globals);

  text = text.replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback);
  text = text.replace(/\\([`*_{}\[\]()>#+.!~=|:-])/g, showdown.helper.escapeCharactersCallback);

  text = globals.converter._dispatch('encodeBackslashEscapes.after', text, options, globals);
  return text;
});

/**
 * Encode/escape certain characters inside Markdown code runs.
 * The point is that in code, these characters are literals,
 * and lose their special Markdown meanings.
 */
showdown.subParser('encodeCode', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('encodeCode.before', text, options, globals);

  // Encode all ampersands; HTML entities are not
  // entities within a Markdown code span.
  text = text
    .replace(/&/g, '&amp;')
  // Do the angle bracket song and dance:
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  // Now, escape characters that are magic in Markdown:
    .replace(/([*_{}\[\]\\=~-])/g, showdown.helper.escapeCharactersCallback);

  text = globals.converter._dispatch('encodeCode.after', text, options, globals);
  return text;
});

/**
 * Within tags -- meaning between < and > -- encode [\ ` * _ ~ =] so they
 * don't conflict with their use in Markdown for code, italics and strong.
 */
showdown.subParser('escapeSpecialCharsWithinTagAttributes', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.before', text, options, globals);

  // Build a regex to find HTML tags.
  var tags     = /<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi,
      comments = /<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi;

  text = text.replace(tags, function (wholeMatch) {
    return wholeMatch
      .replace(/(.)<\/?code>(?=.)/g, '$1`')
      .replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
  });

  text = text.replace(comments, function (wholeMatch) {
    return wholeMatch
      .replace(/([\\`*_~=|])/g, showdown.helper.escapeCharactersCallback);
  });

  text = globals.converter._dispatch('escapeSpecialCharsWithinTagAttributes.after', text, options, globals);
  return text;
});

/**
 * Handle github codeblocks prior to running HashHTML so that
 * HTML contained within the codeblock gets escaped properly
 * Example:
 * ```ruby
 *     def hello_world(x)
 *       puts "Hello, #{x}"
 *     end
 * ```
 */
showdown.subParser('githubCodeBlocks', function (text, options, globals) {
  'use strict';

  // early exit if option is not enabled
  if (!options.ghCodeBlocks) {
    return text;
  }

  text = globals.converter._dispatch('githubCodeBlocks.before', text, options, globals);

  text += '¨0';

  text = text.replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function (wholeMatch, delim, language, codeblock) {
    var end = (options.omitExtraWLInCodeBlocks) ? '' : '\n';

    // First parse the github code block
    codeblock = showdown.subParser('encodeCode')(codeblock, options, globals);
    codeblock = showdown.subParser('detab')(codeblock, options, globals);
    codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
    codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing whitespace

    codeblock = '<pre><code' + (language ? ' class="' + language + ' language-' + language + '"' : '') + '>' + codeblock + end + '</code></pre>';

    codeblock = showdown.subParser('hashBlock')(codeblock, options, globals);

    // Since GHCodeblocks can be false positives, we need to
    // store the primitive text and the parsed text in a global var,
    // and then return a token
    return '\n\n¨G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: codeblock}) - 1) + 'G\n\n';
  });

  // attacklab: strip sentinel
  text = text.replace(/¨0/, '');

  return globals.converter._dispatch('githubCodeBlocks.after', text, options, globals);
});

showdown.subParser('hashBlock', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('hashBlock.before', text, options, globals);
  text = text.replace(/(^\n+|\n+$)/g, '');
  text = '\n\n¨K' + (globals.gHtmlBlocks.push(text) - 1) + 'K\n\n';
  text = globals.converter._dispatch('hashBlock.after', text, options, globals);
  return text;
});

/**
 * Hash and escape <code> elements that should not be parsed as markdown
 */
showdown.subParser('hashCodeTags', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('hashCodeTags.before', text, options, globals);

  var repFunc = function (wholeMatch, match, left, right) {
    var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
    return '¨C' + (globals.gHtmlSpans.push(codeblock) - 1) + 'C';
  };

  // Hash naked <code>
  text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '<code\\b[^>]*>', '</code>', 'gim');

  text = globals.converter._dispatch('hashCodeTags.after', text, options, globals);
  return text;
});

showdown.subParser('hashElement', function (text, options, globals) {
  'use strict';

  return function (wholeMatch, m1) {
    var blockText = m1;

    // Undo double lines
    blockText = blockText.replace(/\n\n/g, '\n');
    blockText = blockText.replace(/^\n/, '');

    // strip trailing blank lines
    blockText = blockText.replace(/\n+$/g, '');

    // Replace the element text with a marker ("¨KxK" where x is its key)
    blockText = '\n\n¨K' + (globals.gHtmlBlocks.push(blockText) - 1) + 'K\n\n';

    return blockText;
  };
});

showdown.subParser('hashHTMLBlocks', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('hashHTMLBlocks.before', text, options, globals);

  var blockTags = [
        'pre',
        'div',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'blockquote',
        'table',
        'dl',
        'ol',
        'ul',
        'script',
        'noscript',
        'form',
        'fieldset',
        'iframe',
        'math',
        'style',
        'section',
        'header',
        'footer',
        'nav',
        'article',
        'aside',
        'address',
        'audio',
        'canvas',
        'figure',
        'hgroup',
        'output',
        'video',
        'p'
      ],
      repFunc = function (wholeMatch, match, left, right) {
        var txt = wholeMatch;
        // check if this html element is marked as markdown
        // if so, it's contents should be parsed as markdown
        if (left.search(/\bmarkdown\b/) !== -1) {
          txt = left + globals.converter.makeHtml(match) + right;
        }
        return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
      };

  if (options.backslashEscapesHTMLTags) {
    // encode backslash escaped HTML tags
    text = text.replace(/\\<(\/?[^>]+?)>/g, function (wm, inside) {
      return '&lt;' + inside + '&gt;';
    });
  }

  // hash HTML Blocks
  for (var i = 0; i < blockTags.length; ++i) {

    var opTagPos,
        rgx1     = new RegExp('^ {0,3}(<' + blockTags[i] + '\\b[^>]*>)', 'im'),
        patLeft  = '<' + blockTags[i] + '\\b[^>]*>',
        patRight = '</' + blockTags[i] + '>';
    // 1. Look for the first position of the first opening HTML tag in the text
    while ((opTagPos = showdown.helper.regexIndexOf(text, rgx1)) !== -1) {

      // if the HTML tag is \ escaped, we need to escape it and break


      //2. Split the text in that position
      var subTexts = showdown.helper.splitAtIndex(text, opTagPos),
          //3. Match recursively
          newSubText1 = showdown.helper.replaceRecursiveRegExp(subTexts[1], repFunc, patLeft, patRight, 'im');

      // prevent an infinite loop
      if (newSubText1 === subTexts[1]) {
        break;
      }
      text = subTexts[0].concat(newSubText1);
    }
  }
  // HR SPECIAL CASE
  text = text.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g,
    showdown.subParser('hashElement')(text, options, globals));

  // Special case for standalone HTML comments
  text = showdown.helper.replaceRecursiveRegExp(text, function (txt) {
    return '\n\n¨K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
  }, '^ {0,3}<!--', '-->', 'gm');

  // PHP and ASP-style processor instructions (<?...?> and <%...%>)
  text = text.replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g,
    showdown.subParser('hashElement')(text, options, globals));

  text = globals.converter._dispatch('hashHTMLBlocks.after', text, options, globals);
  return text;
});

/**
 * Hash span elements that should not be parsed as markdown
 */
showdown.subParser('hashHTMLSpans', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('hashHTMLSpans.before', text, options, globals);

  function hashHTMLSpan (html) {
    return '¨C' + (globals.gHtmlSpans.push(html) - 1) + 'C';
  }

  // Hash Self Closing tags
  text = text.replace(/<[^>]+?\/>/gi, function (wm) {
    return hashHTMLSpan(wm);
  });

  // Hash tags without properties
  text = text.replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function (wm) {
    return hashHTMLSpan(wm);
  });

  // Hash tags with properties
  text = text.replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function (wm) {
    return hashHTMLSpan(wm);
  });

  // Hash self closing tags without />
  text = text.replace(/<[^>]+?>/gi, function (wm) {
    return hashHTMLSpan(wm);
  });

  /*showdown.helper.matchRecursiveRegExp(text, '<code\\b[^>]*>', '</code>', 'gi');*/

  text = globals.converter._dispatch('hashHTMLSpans.after', text, options, globals);
  return text;
});

/**
 * Unhash HTML spans
 */
showdown.subParser('unhashHTMLSpans', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('unhashHTMLSpans.before', text, options, globals);

  for (var i = 0; i < globals.gHtmlSpans.length; ++i) {
    var repText = globals.gHtmlSpans[i],
        // limiter to prevent infinite loop (assume 10 as limit for recurse)
        limit = 0;

    while (/¨C(\d+)C/.test(repText)) {
      var num = RegExp.$1;
      repText = repText.replace('¨C' + num + 'C', globals.gHtmlSpans[num]);
      if (limit === 10) {
        console.error('maximum nesting of 10 spans reached!!!');
        break;
      }
      ++limit;
    }
    text = text.replace('¨C' + i + 'C', repText);
  }

  text = globals.converter._dispatch('unhashHTMLSpans.after', text, options, globals);
  return text;
});

/**
 * Hash and escape <pre><code> elements that should not be parsed as markdown
 */
showdown.subParser('hashPreCodeTags', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('hashPreCodeTags.before', text, options, globals);

  var repFunc = function (wholeMatch, match, left, right) {
    // encode html entities
    var codeblock = left + showdown.subParser('encodeCode')(match, options, globals) + right;
    return '\n\n¨G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: codeblock}) - 1) + 'G\n\n';
  };

  // Hash <pre><code>
  text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>', '^ {0,3}</code>\\s*</pre>', 'gim');

  text = globals.converter._dispatch('hashPreCodeTags.after', text, options, globals);
  return text;
});

showdown.subParser('headers', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('headers.before', text, options, globals);

  var headerLevelStart = (isNaN(parseInt(options.headerLevelStart))) ? 1 : parseInt(options.headerLevelStart),

      // Set text-style headers:
      //	Header 1
      //	========
      //
      //	Header 2
      //	--------
      //
      setextRegexH1 = (options.smoothLivePreview) ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm,
      setextRegexH2 = (options.smoothLivePreview) ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;

  text = text.replace(setextRegexH1, function (wholeMatch, m1) {

    var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m1) + '"',
        hLevel = headerLevelStart,
        hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
    return showdown.subParser('hashBlock')(hashBlock, options, globals);
  });

  text = text.replace(setextRegexH2, function (matchFound, m1) {
    var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m1) + '"',
        hLevel = headerLevelStart + 1,
        hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
    return showdown.subParser('hashBlock')(hashBlock, options, globals);
  });

  // atx-style headers:
  //  # Header 1
  //  ## Header 2
  //  ## Header 2 with closing hashes ##
  //  ...
  //  ###### Header 6
  //
  var atxStyle = (options.requireSpaceBeforeHeadingText) ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;

  text = text.replace(atxStyle, function (wholeMatch, m1, m2) {
    var hText = m2;
    if (options.customizedHeaderId) {
      hText = m2.replace(/\s?\{([^{]+?)}\s*$/, '');
    }

    var span = showdown.subParser('spanGamut')(hText, options, globals),
        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m2) + '"',
        hLevel = headerLevelStart - 1 + m1.length,
        header = '<h' + hLevel + hID + '>' + span + '</h' + hLevel + '>';

    return showdown.subParser('hashBlock')(header, options, globals);
  });

  function headerId (m) {
    var title,
        prefix;

    // It is separate from other options to allow combining prefix and customized
    if (options.customizedHeaderId) {
      var match = m.match(/\{([^{]+?)}\s*$/);
      if (match && match[1]) {
        m = match[1];
      }
    }

    title = m;

    // Prefix id to prevent causing inadvertent pre-existing style matches.
    if (showdown.helper.isString(options.prefixHeaderId)) {
      prefix = options.prefixHeaderId;
    } else if (options.prefixHeaderId === true) {
      prefix = 'section-';
    } else {
      prefix = '';
    }

    if (!options.rawPrefixHeaderId) {
      title = prefix + title;
    }

    if (options.ghCompatibleHeaderId) {
      title = title
        .replace(/ /g, '-')
        // replace previously escaped chars (&, ¨ and $)
        .replace(/&amp;/g, '')
        .replace(/¨T/g, '')
        .replace(/¨D/g, '')
        // replace rest of the chars (&~$ are repeated as they might have been escaped)
        // borrowed from github's redcarpet (some they should produce similar results)
        .replace(/[&+$,\/:;=?@"#{}|^¨~\[\]`\\*)(%.!'<>]/g, '')
        .toLowerCase();
    } else if (options.rawHeaderId) {
      title = title
        .replace(/ /g, '-')
        // replace previously escaped chars (&, ¨ and $)
        .replace(/&amp;/g, '&')
        .replace(/¨T/g, '¨')
        .replace(/¨D/g, '$')
        // replace " and '
        .replace(/["']/g, '-')
        .toLowerCase();
    } else {
      title = title
        .replace(/[^\w]/g, '')
        .toLowerCase();
    }

    if (options.rawPrefixHeaderId) {
      title = prefix + title;
    }

    if (globals.hashLinkCounts[title]) {
      title = title + '-' + (globals.hashLinkCounts[title]++);
    } else {
      globals.hashLinkCounts[title] = 1;
    }
    return title;
  }

  text = globals.converter._dispatch('headers.after', text, options, globals);
  return text;
});

/**
 * Turn Markdown link shortcuts into XHTML <a> tags.
 */
showdown.subParser('horizontalRule', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('horizontalRule.before', text, options, globals);

  var key = showdown.subParser('hashBlock')('<hr />', options, globals);
  text = text.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, key);
  text = text.replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, key);
  text = text.replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, key);

  text = globals.converter._dispatch('horizontalRule.after', text, options, globals);
  return text;
});

/**
 * Turn Markdown image shortcuts into <img> tags.
 */
showdown.subParser('images', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('images.before', text, options, globals);

  var inlineRegExp      = /!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,
      crazyRegExp       = /!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g,
      base64RegExp      = /!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,
      referenceRegExp   = /!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g,
      refShortcutRegExp = /!\[([^\[\]]+)]()()()()()/g;

  function writeImageTagBase64 (wholeMatch, altText, linkId, url, width, height, m5, title) {
    url = url.replace(/\s/g, '');
    return writeImageTag (wholeMatch, altText, linkId, url, width, height, m5, title);
  }

  function writeImageTag (wholeMatch, altText, linkId, url, width, height, m5, title) {

    var gUrls   = globals.gUrls,
        gTitles = globals.gTitles,
        gDims   = globals.gDimensions;

    linkId = linkId.toLowerCase();

    if (!title) {
      title = '';
    }
    // Special case for explicit empty url
    if (wholeMatch.search(/\(<?\s*>? ?(['"].*['"])?\)$/m) > -1) {
      url = '';

    } else if (url === '' || url === null) {
      if (linkId === '' || linkId === null) {
        // lower-case and turn embedded newlines into spaces
        linkId = altText.toLowerCase().replace(/ ?\n/g, ' ');
      }
      url = '#' + linkId;

      if (!showdown.helper.isUndefined(gUrls[linkId])) {
        url = gUrls[linkId];
        if (!showdown.helper.isUndefined(gTitles[linkId])) {
          title = gTitles[linkId];
        }
        if (!showdown.helper.isUndefined(gDims[linkId])) {
          width = gDims[linkId].width;
          height = gDims[linkId].height;
        }
      } else {
        return wholeMatch;
      }
    }

    altText = altText
      .replace(/"/g, '&quot;')
    //altText = showdown.helper.escapeCharacters(altText, '*_', false);
      .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
    //url = showdown.helper.escapeCharacters(url, '*_', false);
    url = url.replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
    var result = '<img src="' + url + '" alt="' + altText + '"';

    if (title && showdown.helper.isString(title)) {
      title = title
        .replace(/"/g, '&quot;')
      //title = showdown.helper.escapeCharacters(title, '*_', false);
        .replace(showdown.helper.regexes.asteriskDashAndColon, showdown.helper.escapeCharactersCallback);
      result += ' title="' + title + '"';
    }

    if (width && height) {
      width  = (width === '*') ? 'auto' : width;
      height = (height === '*') ? 'auto' : height;

      result += ' width="' + width + '"';
      result += ' height="' + height + '"';
    }

    result += ' />';

    return result;
  }

  // First, handle reference-style labeled images: ![alt text][id]
  text = text.replace(referenceRegExp, writeImageTag);

  // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")

  // base64 encoded images
  text = text.replace(base64RegExp, writeImageTagBase64);

  // cases with crazy urls like ./image/cat1).png
  text = text.replace(crazyRegExp, writeImageTag);

  // normal cases
  text = text.replace(inlineRegExp, writeImageTag);

  // handle reference-style shortcuts: ![img text]
  text = text.replace(refShortcutRegExp, writeImageTag);

  text = globals.converter._dispatch('images.after', text, options, globals);
  return text;
});

showdown.subParser('italicsAndBold', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('italicsAndBold.before', text, options, globals);

  // it's faster to have 3 separate regexes for each case than have just one
  // because of backtracing, in some cases, it could lead to an exponential effect
  // called "catastrophic backtrace". Ominous!

  function parseInside (txt, left, right) {
    /*
    if (options.simplifiedAutoLink) {
      txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
    }
    */
    return left + txt + right;
  }

  // Parse underscores
  if (options.literalMidWordUnderscores) {
    text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function (wm, txt) {
      return parseInside (txt, '<strong><em>', '</em></strong>');
    });
    text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function (wm, txt) {
      return parseInside (txt, '<strong>', '</strong>');
    });
    text = text.replace(/\b_(\S[\s\S]*?)_\b/g, function (wm, txt) {
      return parseInside (txt, '<em>', '</em>');
    });
  } else {
    text = text.replace(/___(\S[\s\S]*?)___/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong><em>', '</em></strong>') : wm;
    });
    text = text.replace(/__(\S[\s\S]*?)__/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong>', '</strong>') : wm;
    });
    text = text.replace(/_([^\s_][\s\S]*?)_/g, function (wm, m) {
      // !/^_[^_]/.test(m) - test if it doesn't start with __ (since it seems redundant, we removed it)
      return (/\S$/.test(m)) ? parseInside (m, '<em>', '</em>') : wm;
    });
  }

  // Now parse asterisks
  if (options.literalMidWordAsterisks) {
    text = text.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function (wm, lead, txt) {
      return parseInside (txt, lead + '<strong><em>', '</em></strong>');
    });
    text = text.replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function (wm, lead, txt) {
      return parseInside (txt, lead + '<strong>', '</strong>');
    });
    text = text.replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function (wm, lead, txt) {
      return parseInside (txt, lead + '<em>', '</em>');
    });
  } else {
    text = text.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong><em>', '</em></strong>') : wm;
    });
    text = text.replace(/\*\*(\S[\s\S]*?)\*\*/g, function (wm, m) {
      return (/\S$/.test(m)) ? parseInside (m, '<strong>', '</strong>') : wm;
    });
    text = text.replace(/\*([^\s*][\s\S]*?)\*/g, function (wm, m) {
      // !/^\*[^*]/.test(m) - test if it doesn't start with ** (since it seems redundant, we removed it)
      return (/\S$/.test(m)) ? parseInside (m, '<em>', '</em>') : wm;
    });
  }


  text = globals.converter._dispatch('italicsAndBold.after', text, options, globals);
  return text;
});

/**
 * Form HTML ordered (numbered) and unordered (bulleted) lists.
 */
showdown.subParser('lists', function (text, options, globals) {
  'use strict';

  /**
   * Process the contents of a single ordered or unordered list, splitting it
   * into individual list items.
   * @param {string} listStr
   * @param {boolean} trimTrailing
   * @returns {string}
   */
  function processListItems (listStr, trimTrailing) {
    // The $g_list_level global keeps track of when we're inside a list.
    // Each time we enter a list, we increment it; when we leave a list,
    // we decrement. If it's zero, we're not in a list anymore.
    //
    // We do this because when we're not inside a list, we want to treat
    // something like this:
    //
    //    I recommend upgrading to version
    //    8. Oops, now this line is treated
    //    as a sub-list.
    //
    // As a single paragraph, despite the fact that the second line starts
    // with a digit-period-space sequence.
    //
    // Whereas when we're inside a list (or sub-list), that line will be
    // treated as the start of a sub-list. What a kludge, huh? This is
    // an aspect of Markdown's syntax that's hard to parse perfectly
    // without resorting to mind-reading. Perhaps the solution is to
    // change the syntax rules such that sub-lists must start with a
    // starting cardinal number; e.g. "1." or "a.".
    globals.gListLevel++;

    // trim trailing blank lines:
    listStr = listStr.replace(/\n{2,}$/, '\n');

    // attacklab: add sentinel to emulate \z
    listStr += '¨0';

    var rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0| {0,3}([*+-]|\d+[.])[ \t]+))/gm,
        isParagraphed = (/\n[ \t]*\n(?!¨0)/.test(listStr));

    // Since version 1.5, nesting sublists requires 4 spaces (or 1 tab) indentation,
    // which is a syntax breaking change
    // activating this option reverts to old behavior
    if (options.disableForced4SpacesIndentedSublists) {
      rgx = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(¨0|\2([*+-]|\d+[.])[ \t]+))/gm;
    }

    listStr = listStr.replace(rgx, function (wholeMatch, m1, m2, m3, m4, taskbtn, checked) {
      checked = (checked && checked.trim() !== '');

      var item = showdown.subParser('outdent')(m4, options, globals),
          bulletStyle = '';

      // Support for github tasklists
      if (taskbtn && options.tasklists) {
        bulletStyle = ' class="task-list-item" style="list-style-type: none;"';
        item = item.replace(/^[ \t]*\[(x|X| )?]/m, function () {
          var otp = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
          if (checked) {
            otp += ' checked';
          }
          otp += '>';
          return otp;
        });
      }

      // ISSUE #312
      // This input: - - - a
      // causes trouble to the parser, since it interprets it as:
      // <ul><li><li><li>a</li></li></li></ul>
      // instead of:
      // <ul><li>- - a</li></ul>
      // So, to prevent it, we will put a marker (¨A)in the beginning of the line
      // Kind of hackish/monkey patching, but seems more effective than overcomplicating the list parser
      item = item.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function (wm2) {
        return '¨A' + wm2;
      });

      // m1 - Leading line or
      // Has a double return (multi paragraph) or
      // Has sublist
      if (m1 || (item.search(/\n{2,}/) > -1)) {
        item = showdown.subParser('githubCodeBlocks')(item, options, globals);
        item = showdown.subParser('blockGamut')(item, options, globals);
      } else {
        // Recursion for sub-lists:
        item = showdown.subParser('lists')(item, options, globals);
        item = item.replace(/\n$/, ''); // chomp(item)
        item = showdown.subParser('hashHTMLBlocks')(item, options, globals);

        // Colapse double linebreaks
        item = item.replace(/\n\n+/g, '\n\n');
        if (isParagraphed) {
          item = showdown.subParser('paragraphs')(item, options, globals);
        } else {
          item = showdown.subParser('spanGamut')(item, options, globals);
        }
      }

      // now we need to remove the marker (¨A)
      item = item.replace('¨A', '');
      // we can finally wrap the line in list item tags
      item =  '<li' + bulletStyle + '>' + item + '</li>\n';

      return item;
    });

    // attacklab: strip sentinel
    listStr = listStr.replace(/¨0/g, '');

    globals.gListLevel--;

    if (trimTrailing) {
      listStr = listStr.replace(/\s+$/, '');
    }

    return listStr;
  }

  function styleStartNumber (list, listType) {
    // check if ol and starts by a number different than 1
    if (listType === 'ol') {
      var res = list.match(/^ *(\d+)\./);
      if (res && res[1] !== '1') {
        return ' start="' + res[1] + '"';
      }
    }
    return '';
  }

  /**
   * Check and parse consecutive lists (better fix for issue #142)
   * @param {string} list
   * @param {string} listType
   * @param {boolean} trimTrailing
   * @returns {string}
   */
  function parseConsecutiveLists (list, listType, trimTrailing) {
    // check if we caught 2 or more consecutive lists by mistake
    // we use the counterRgx, meaning if listType is UL we look for OL and vice versa
    var olRgx = (options.disableForced4SpacesIndentedSublists) ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm,
        ulRgx = (options.disableForced4SpacesIndentedSublists) ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm,
        counterRxg = (listType === 'ul') ? olRgx : ulRgx,
        result = '';

    if (list.search(counterRxg) !== -1) {
      (function parseCL (txt) {
        var pos = txt.search(counterRxg),
            style = styleStartNumber(list, listType);
        if (pos !== -1) {
          // slice
          result += '\n\n<' + listType + style + '>\n' + processListItems(txt.slice(0, pos), !!trimTrailing) + '</' + listType + '>\n';

          // invert counterType and listType
          listType = (listType === 'ul') ? 'ol' : 'ul';
          counterRxg = (listType === 'ul') ? olRgx : ulRgx;

          //recurse
          parseCL(txt.slice(pos));
        } else {
          result += '\n\n<' + listType + style + '>\n' + processListItems(txt, !!trimTrailing) + '</' + listType + '>\n';
        }
      })(list);
    } else {
      var style = styleStartNumber(list, listType);
      result = '\n\n<' + listType + style + '>\n' + processListItems(list, !!trimTrailing) + '</' + listType + '>\n';
    }

    return result;
  }

  /** Start of list parsing **/
  text = globals.converter._dispatch('lists.before', text, options, globals);
  // add sentinel to hack around khtml/safari bug:
  // http://bugs.webkit.org/show_bug.cgi?id=11231
  text += '¨0';

  if (globals.gListLevel) {
    text = text.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm,
      function (wholeMatch, list, m2) {
        var listType = (m2.search(/[*+-]/g) > -1) ? 'ul' : 'ol';
        return parseConsecutiveLists(list, listType, true);
      }
    );
  } else {
    text = text.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(¨0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm,
      function (wholeMatch, m1, list, m3) {
        var listType = (m3.search(/[*+-]/g) > -1) ? 'ul' : 'ol';
        return parseConsecutiveLists(list, listType, false);
      }
    );
  }

  // strip sentinel
  text = text.replace(/¨0/, '');
  text = globals.converter._dispatch('lists.after', text, options, globals);
  return text;
});

/**
 * Parse metadata at the top of the document
 */
showdown.subParser('metadata', function (text, options, globals) {
  'use strict';

  if (!options.metadata) {
    return text;
  }

  text = globals.converter._dispatch('metadata.before', text, options, globals);

  function parseMetadataContents (content) {
    // raw is raw so it's not changed in any way
    globals.metadata.raw = content;

    // escape chars forbidden in html attributes
    // double quotes
    content = content
      // ampersand first
      .replace(/&/g, '&amp;')
      // double quotes
      .replace(/"/g, '&quot;');

    content = content.replace(/\n {4}/g, ' ');
    content.replace(/^([\S ]+): +([\s\S]+?)$/gm, function (wm, key, value) {
      globals.metadata.parsed[key] = value;
      return '';
    });
  }

  text = text.replace(/^\s*«««+(\S*?)\n([\s\S]+?)\n»»»+\n/, function (wholematch, format, content) {
    parseMetadataContents(content);
    return '¨M';
  });

  text = text.replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function (wholematch, format, content) {
    if (format) {
      globals.metadata.format = format;
    }
    parseMetadataContents(content);
    return '¨M';
  });

  text = text.replace(/¨M/g, '');

  text = globals.converter._dispatch('metadata.after', text, options, globals);
  return text;
});

/**
 * Remove one level of line-leading tabs or spaces
 */
showdown.subParser('outdent', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('outdent.before', text, options, globals);

  // attacklab: hack around Konqueror 3.5.4 bug:
  // "----------bug".replace(/^-/g,"") == "bug"
  text = text.replace(/^(\t|[ ]{1,4})/gm, '¨0'); // attacklab: g_tab_width

  // attacklab: clean up hack
  text = text.replace(/¨0/g, '');

  text = globals.converter._dispatch('outdent.after', text, options, globals);
  return text;
});

/**
 *
 */
showdown.subParser('paragraphs', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('paragraphs.before', text, options, globals);
  // Strip leading and trailing lines:
  text = text.replace(/^\n+/g, '');
  text = text.replace(/\n+$/g, '');

  var grafs = text.split(/\n{2,}/g),
      grafsOut = [],
      end = grafs.length; // Wrap <p> tags

  for (var i = 0; i < end; i++) {
    var str = grafs[i];
    // if this is an HTML marker, copy it
    if (str.search(/¨(K|G)(\d+)\1/g) >= 0) {
      grafsOut.push(str);

    // test for presence of characters to prevent empty lines being parsed
    // as paragraphs (resulting in undesired extra empty paragraphs)
    } else if (str.search(/\S/) >= 0) {
      str = showdown.subParser('spanGamut')(str, options, globals);
      str = str.replace(/^([ \t]*)/g, '<p>');
      str += '</p>';
      grafsOut.push(str);
    }
  }

  /** Unhashify HTML blocks */
  end = grafsOut.length;
  for (i = 0; i < end; i++) {
    var blockText = '',
        grafsOutIt = grafsOut[i],
        codeFlag = false;
    // if this is a marker for an html block...
    // use RegExp.test instead of string.search because of QML bug
    while (/¨(K|G)(\d+)\1/.test(grafsOutIt)) {
      var delim = RegExp.$1,
          num   = RegExp.$2;

      if (delim === 'K') {
        blockText = globals.gHtmlBlocks[num];
      } else {
        // we need to check if ghBlock is a false positive
        if (codeFlag) {
          // use encoded version of all text
          blockText = showdown.subParser('encodeCode')(globals.ghCodeBlocks[num].text, options, globals);
        } else {
          blockText = globals.ghCodeBlocks[num].codeblock;
        }
      }
      blockText = blockText.replace(/\$/g, '$$$$'); // Escape any dollar signs

      grafsOutIt = grafsOutIt.replace(/(\n\n)?¨(K|G)\d+\2(\n\n)?/, blockText);
      // Check if grafsOutIt is a pre->code
      if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) {
        codeFlag = true;
      }
    }
    grafsOut[i] = grafsOutIt;
  }
  text = grafsOut.join('\n');
  // Strip leading and trailing lines:
  text = text.replace(/^\n+/g, '');
  text = text.replace(/\n+$/g, '');
  return globals.converter._dispatch('paragraphs.after', text, options, globals);
});

/**
 * Run extension
 */
showdown.subParser('runExtension', function (ext, text, options, globals) {
  'use strict';

  if (ext.filter) {
    text = ext.filter(text, globals.converter, options);

  } else if (ext.regex) {
    // TODO remove this when old extension loading mechanism is deprecated
    var re = ext.regex;
    if (!(re instanceof RegExp)) {
      re = new RegExp(re, 'g');
    }
    text = text.replace(re, ext.replace);
  }

  return text;
});

/**
 * These are all the transformations that occur *within* block-level
 * tags like paragraphs, headers, and list items.
 */
showdown.subParser('spanGamut', function (text, options, globals) {
  'use strict';

  text = globals.converter._dispatch('spanGamut.before', text, options, globals);
  text = showdown.subParser('codeSpans')(text, options, globals);
  text = showdown.subParser('escapeSpecialCharsWithinTagAttributes')(text, options, globals);
  text = showdown.subParser('encodeBackslashEscapes')(text, options, globals);

  // Process anchor and image tags. Images must come first,
  // because ![foo][f] looks like an anchor.
  text = showdown.subParser('images')(text, options, globals);
  text = showdown.subParser('anchors')(text, options, globals);

  // Make links out of things like `<http://example.com/>`
  // Must come after anchors, because you can use < and >
  // delimiters in inline links like [this](<url>).
  text = showdown.subParser('autoLinks')(text, options, globals);
  text = showdown.subParser('simplifiedAutoLinks')(text, options, globals);
  text = showdown.subParser('emoji')(text, options, globals);
  text = showdown.subParser('underline')(text, options, globals);
  text = showdown.subParser('italicsAndBold')(text, options, globals);
  text = showdown.subParser('strikethrough')(text, options, globals);
  text = showdown.subParser('ellipsis')(text, options, globals);

  // we need to hash HTML tags inside spans
  text = showdown.subParser('hashHTMLSpans')(text, options, globals);

  // now we encode amps and angles
  text = showdown.subParser('encodeAmpsAndAngles')(text, options, globals);

  // Do hard breaks
  if (options.simpleLineBreaks) {
    // GFM style hard breaks
    // only add line breaks if the text does not contain a block (special case for lists)
    if (!/\n\n¨K/.test(text)) {
      text = text.replace(/\n+/g, '<br />\n');
    }
  } else {
    // Vanilla hard breaks
    text = text.replace(/  +\n/g, '<br />\n');
  }

  text = globals.converter._dispatch('spanGamut.after', text, options, globals);
  return text;
});

showdown.subParser('strikethrough', function (text, options, globals) {
  'use strict';

  function parseInside (txt) {
    if (options.simplifiedAutoLink) {
      txt = showdown.subParser('simplifiedAutoLinks')(txt, options, globals);
    }
    return '<del>' + txt + '</del>';
  }

  if (options.strikethrough) {
    text = globals.converter._dispatch('strikethrough.before', text, options, globals);
    text = text.replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function (wm, txt) { return parseInside(txt); });
    text = globals.converter._dispatch('strikethrough.after', text, options, globals);
  }

  return text;
});

/**
 * Strips link definitions from text, stores the URLs and titles in
 * hash references.
 * Link defs are in the form: ^[id]: url "optional title"
 */
showdown.subParser('stripLinkDefinitions', function (text, options, globals) {
  'use strict';

  var regex       = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=¨0))/gm,
      base64Regex = /^ {0,3}\[([^\]]+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=¨0)|(?=\n\[))/gm;

  // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
  text += '¨0';

  var replaceFunc = function (wholeMatch, linkId, url, width, height, blankLines, title) {

    // if there aren't two instances of linkId it must not be a reference link so back out
    linkId = linkId.toLowerCase();
    if (text.toLowerCase().split(linkId).length - 1 < 2) {
      return wholeMatch;
    }
    if (url.match(/^data:.+?\/.+?;base64,/)) {
      // remove newlines
      globals.gUrls[linkId] = url.replace(/\s/g, '');
    } else {
      globals.gUrls[linkId] = showdown.subParser('encodeAmpsAndAngles')(url, options, globals);  // Link IDs are case-insensitive
    }

    if (blankLines) {
      // Oops, found blank lines, so it's not a title.
      // Put back the parenthetical statement we stole.
      return blankLines + title;

    } else {
      if (title) {
        globals.gTitles[linkId] = title.replace(/"|'/g, '&quot;');
      }
      if (options.parseImgDimensions && width && height) {
        globals.gDimensions[linkId] = {
          width:  width,
          height: height
        };
      }
    }
    // Completely remove the definition from the text
    return '';
  };

  // first we try to find base64 link references
  text = text.replace(base64Regex, replaceFunc);

  text = text.replace(regex, replaceFunc);

  // attacklab: strip sentinel
  text = text.replace(/¨0/, '');

  return text;
});

showdown.subParser('tables', function (text, options, globals) {
  'use strict';

  if (!options.tables) {
    return text;
  }

  var tableRgx       = /^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|¨0)/gm,
      //singeColTblRgx = /^ {0,3}\|.+\|\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n(?: {0,3}\|.+\|\n)+(?:\n\n|¨0)/gm;
      singeColTblRgx = /^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|¨0)/gm;

  function parseStyles (sLine) {
    if (/^:[ \t]*--*$/.test(sLine)) {
      return ' style="text-align:left;"';
    } else if (/^--*[ \t]*:[ \t]*$/.test(sLine)) {
      return ' style="text-align:right;"';
    } else if (/^:[ \t]*--*[ \t]*:$/.test(sLine)) {
      return ' style="text-align:center;"';
    } else {
      return '';
    }
  }

  function parseHeaders (header, style) {
    var id = '';
    header = header.trim();
    // support both tablesHeaderId and tableHeaderId due to error in documentation so we don't break backwards compatibility
    if (options.tablesHeaderId || options.tableHeaderId) {
      id = ' id="' + header.replace(/ /g, '_').toLowerCase() + '"';
    }
    header = showdown.subParser('spanGamut')(header, options, globals);

    return '<th' + id + style + '>' + header + '</th>\n';
  }

  function parseCells (cell, style) {
    var subText = showdown.subParser('spanGamut')(cell, options, globals);
    return '<td' + style + '>' + subText + '</td>\n';
  }

  function buildTable (headers, cells) {
    var tb = '<table>\n<thead>\n<tr>\n',
        tblLgn = headers.length;

    for (var i = 0; i < tblLgn; ++i) {
      tb += headers[i];
    }
    tb += '</tr>\n</thead>\n<tbody>\n';

    for (i = 0; i < cells.length; ++i) {
      tb += '<tr>\n';
      for (var ii = 0; ii < tblLgn; ++ii) {
        tb += cells[i][ii];
      }
      tb += '</tr>\n';
    }
    tb += '</tbody>\n</table>\n';
    return tb;
  }

  function parseTable (rawTable) {
    var i, tableLines = rawTable.split('\n');

    for (i = 0; i < tableLines.length; ++i) {
      // strip wrong first and last column if wrapped tables are used
      if (/^ {0,3}\|/.test(tableLines[i])) {
        tableLines[i] = tableLines[i].replace(/^ {0,3}\|/, '');
      }
      if (/\|[ \t]*$/.test(tableLines[i])) {
        tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, '');
      }
      // parse code spans first, but we only support one line code spans
      tableLines[i] = showdown.subParser('codeSpans')(tableLines[i], options, globals);
    }

    var rawHeaders = tableLines[0].split('|').map(function (s) { return s.trim();}),
        rawStyles = tableLines[1].split('|').map(function (s) { return s.trim();}),
        rawCells = [],
        headers = [],
        styles = [],
        cells = [];

    tableLines.shift();
    tableLines.shift();

    for (i = 0; i < tableLines.length; ++i) {
      if (tableLines[i].trim() === '') {
        continue;
      }
      rawCells.push(
        tableLines[i]
          .split('|')
          .map(function (s) {
            return s.trim();
          })
      );
    }

    if (rawHeaders.length < rawStyles.length) {
      return rawTable;
    }

    for (i = 0; i < rawStyles.length; ++i) {
      styles.push(parseStyles(rawStyles[i]));
    }

    for (i = 0; i < rawHeaders.length; ++i) {
      if (showdown.helper.isUndefined(styles[i])) {
        styles[i] = '';
      }
      headers.push(parseHeaders(rawHeaders[i], styles[i]));
    }

    for (i = 0; i < rawCells.length; ++i) {
      var row = [];
      for (var ii = 0; ii < headers.length; ++ii) {
        if (showdown.helper.isUndefined(rawCells[i][ii])) {

        }
        row.push(parseCells(rawCells[i][ii], styles[ii]));
      }
      cells.push(row);
    }

    return buildTable(headers, cells);
  }

  text = globals.converter._dispatch('tables.before', text, options, globals);

  // find escaped pipe characters
  text = text.replace(/\\(\|)/g, showdown.helper.escapeCharactersCallback);

  // parse multi column tables
  text = text.replace(tableRgx, parseTable);

  // parse one column tables
  text = text.replace(singeColTblRgx, parseTable);

  text = globals.converter._dispatch('tables.after', text, options, globals);

  return text;
});

showdown.subParser('underline', function (text, options, globals) {
  'use strict';

  if (!options.underline) {
    return text;
  }

  text = globals.converter._dispatch('underline.before', text, options, globals);

  if (options.literalMidWordUnderscores) {
    text = text.replace(/\b___(\S[\s\S]*?)___\b/g, function (wm, txt) {
      return '<u>' + txt + '</u>';
    });
    text = text.replace(/\b__(\S[\s\S]*?)__\b/g, function (wm, txt) {
      return '<u>' + txt + '</u>';
    });
  } else {
    text = text.replace(/___(\S[\s\S]*?)___/g, function (wm, m) {
      return (/\S$/.test(m)) ? '<u>' + m + '</u>' : wm;
    });
    text = text.replace(/__(\S[\s\S]*?)__/g, function (wm, m) {
      return (/\S$/.test(m)) ? '<u>' + m + '</u>' : wm;
    });
  }

  // escape remaining underscores to prevent them being parsed by italic and bold
  text = text.replace(/(_)/g, showdown.helper.escapeCharactersCallback);

  text = globals.converter._dispatch('underline.after', text, options, globals);

  return text;
});

/**
 * Swap back in all the special characters we've hidden.
 */
showdown.subParser('unescapeSpecialChars', function (text, options, globals) {
  'use strict';
  text = globals.converter._dispatch('unescapeSpecialChars.before', text, options, globals);

  text = text.replace(/¨E(\d+)E/g, function (wholeMatch, m1) {
    var charCodeToReplace = parseInt(m1);
    return String.fromCharCode(charCodeToReplace);
  });

  text = globals.converter._dispatch('unescapeSpecialChars.after', text, options, globals);
  return text;
});

showdown.subParser('makeMarkdown.blockquote', function (node, globals) {
  'use strict';

  var txt = '';
  if (node.hasChildNodes()) {
    var children = node.childNodes,
        childrenLength = children.length;

    for (var i = 0; i < childrenLength; ++i) {
      var innerTxt = showdown.subParser('makeMarkdown.node')(children[i], globals);

      if (innerTxt === '') {
        continue;
      }
      txt += innerTxt;
    }
  }
  // cleanup
  txt = txt.trim();
  txt = '> ' + txt.split('\n').join('\n> ');
  return txt;
});

showdown.subParser('makeMarkdown.codeBlock', function (node, globals) {
  'use strict';

  var lang = node.getAttribute('language'),
      num  = node.getAttribute('precodenum');
  return '```' + lang + '\n' + globals.preList[num] + '\n```';
});

showdown.subParser('makeMarkdown.codeSpan', function (node) {
  'use strict';

  return '`' + node.innerHTML + '`';
});

showdown.subParser('makeMarkdown.emphasis', function (node, globals) {
  'use strict';

  var txt = '';
  if (node.hasChildNodes()) {
    txt += '*';
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '*';
  }
  return txt;
});

showdown.subParser('makeMarkdown.header', function (node, globals, headerLevel) {
  'use strict';

  var headerMark = new Array(headerLevel + 1).join('#'),
      txt = '';

  if (node.hasChildNodes()) {
    txt = headerMark + ' ';
    var children = node.childNodes,
        childrenLength = children.length;

    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
  }
  return txt;
});

showdown.subParser('makeMarkdown.hr', function () {
  'use strict';

  return '---';
});

showdown.subParser('makeMarkdown.image', function (node) {
  'use strict';

  var txt = '';
  if (node.hasAttribute('src')) {
    txt += '![' + node.getAttribute('alt') + '](';
    txt += '<' + node.getAttribute('src') + '>';
    if (node.hasAttribute('width') && node.hasAttribute('height')) {
      txt += ' =' + node.getAttribute('width') + 'x' + node.getAttribute('height');
    }

    if (node.hasAttribute('title')) {
      txt += ' "' + node.getAttribute('title') + '"';
    }
    txt += ')';
  }
  return txt;
});

showdown.subParser('makeMarkdown.links', function (node, globals) {
  'use strict';

  var txt = '';
  if (node.hasChildNodes() && node.hasAttribute('href')) {
    var children = node.childNodes,
        childrenLength = children.length;
    txt = '[';
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '](';
    txt += '<' + node.getAttribute('href') + '>';
    if (node.hasAttribute('title')) {
      txt += ' "' + node.getAttribute('title') + '"';
    }
    txt += ')';
  }
  return txt;
});

showdown.subParser('makeMarkdown.list', function (node, globals, type) {
  'use strict';

  var txt = '';
  if (!node.hasChildNodes()) {
    return '';
  }
  var listItems       = node.childNodes,
      listItemsLenght = listItems.length,
      listNum = node.getAttribute('start') || 1;

  for (var i = 0; i < listItemsLenght; ++i) {
    if (typeof listItems[i].tagName === 'undefined' || listItems[i].tagName.toLowerCase() !== 'li') {
      continue;
    }

    // define the bullet to use in list
    var bullet = '';
    if (type === 'ol') {
      bullet = listNum.toString() + '. ';
    } else {
      bullet = '- ';
    }

    // parse list item
    txt += bullet + showdown.subParser('makeMarkdown.listItem')(listItems[i], globals);
    ++listNum;
  }

  // add comment at the end to prevent consecutive lists to be parsed as one
  txt += '\n<!-- -->\n';
  return txt.trim();
});

showdown.subParser('makeMarkdown.listItem', function (node, globals) {
  'use strict';

  var listItemTxt = '';

  var children = node.childNodes,
      childrenLenght = children.length;

  for (var i = 0; i < childrenLenght; ++i) {
    listItemTxt += showdown.subParser('makeMarkdown.node')(children[i], globals);
  }
  // if it's only one liner, we need to add a newline at the end
  if (!/\n$/.test(listItemTxt)) {
    listItemTxt += '\n';
  } else {
    // it's multiparagraph, so we need to indent
    listItemTxt = listItemTxt
      .split('\n')
      .join('\n    ')
      .replace(/^ {4}$/gm, '')
      .replace(/\n\n+/g, '\n\n');
  }

  return listItemTxt;
});



showdown.subParser('makeMarkdown.node', function (node, globals, spansOnly) {
  'use strict';

  spansOnly = spansOnly || false;

  var txt = '';

  // edge case of text without wrapper paragraph
  if (node.nodeType === 3) {
    return showdown.subParser('makeMarkdown.txt')(node, globals);
  }

  // HTML comment
  if (node.nodeType === 8) {
    return '<!--' + node.data + '-->\n\n';
  }

  // process only node elements
  if (node.nodeType !== 1) {
    return '';
  }

  var tagName = node.tagName.toLowerCase();

  switch (tagName) {

    //
    // BLOCKS
    //
    case 'h1':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 1) + '\n\n'; }
      break;
    case 'h2':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 2) + '\n\n'; }
      break;
    case 'h3':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 3) + '\n\n'; }
      break;
    case 'h4':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 4) + '\n\n'; }
      break;
    case 'h5':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 5) + '\n\n'; }
      break;
    case 'h6':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.header')(node, globals, 6) + '\n\n'; }
      break;

    case 'p':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.paragraph')(node, globals) + '\n\n'; }
      break;

    case 'blockquote':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.blockquote')(node, globals) + '\n\n'; }
      break;

    case 'hr':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.hr')(node, globals) + '\n\n'; }
      break;

    case 'ol':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ol') + '\n\n'; }
      break;

    case 'ul':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.list')(node, globals, 'ul') + '\n\n'; }
      break;

    case 'precode':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.codeBlock')(node, globals) + '\n\n'; }
      break;

    case 'pre':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.pre')(node, globals) + '\n\n'; }
      break;

    case 'table':
      if (!spansOnly) { txt = showdown.subParser('makeMarkdown.table')(node, globals) + '\n\n'; }
      break;

    //
    // SPANS
    //
    case 'code':
      txt = showdown.subParser('makeMarkdown.codeSpan')(node, globals);
      break;

    case 'em':
    case 'i':
      txt = showdown.subParser('makeMarkdown.emphasis')(node, globals);
      break;

    case 'strong':
    case 'b':
      txt = showdown.subParser('makeMarkdown.strong')(node, globals);
      break;

    case 'del':
      txt = showdown.subParser('makeMarkdown.strikethrough')(node, globals);
      break;

    case 'a':
      txt = showdown.subParser('makeMarkdown.links')(node, globals);
      break;

    case 'img':
      txt = showdown.subParser('makeMarkdown.image')(node, globals);
      break;

    default:
      txt = node.outerHTML + '\n\n';
  }

  // common normalization
  // TODO eventually

  return txt;
});

showdown.subParser('makeMarkdown.paragraph', function (node, globals) {
  'use strict';

  var txt = '';
  if (node.hasChildNodes()) {
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
  }

  // some text normalization
  txt = txt.trim();

  return txt;
});

showdown.subParser('makeMarkdown.pre', function (node, globals) {
  'use strict';

  var num  = node.getAttribute('prenum');
  return '<pre>' + globals.preList[num] + '</pre>';
});

showdown.subParser('makeMarkdown.strikethrough', function (node, globals) {
  'use strict';

  var txt = '';
  if (node.hasChildNodes()) {
    txt += '~~';
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '~~';
  }
  return txt;
});

showdown.subParser('makeMarkdown.strong', function (node, globals) {
  'use strict';

  var txt = '';
  if (node.hasChildNodes()) {
    txt += '**';
    var children = node.childNodes,
        childrenLength = children.length;
    for (var i = 0; i < childrenLength; ++i) {
      txt += showdown.subParser('makeMarkdown.node')(children[i], globals);
    }
    txt += '**';
  }
  return txt;
});

showdown.subParser('makeMarkdown.table', function (node, globals) {
  'use strict';

  var txt = '',
      tableArray = [[], []],
      headings   = node.querySelectorAll('thead>tr>th'),
      rows       = node.querySelectorAll('tbody>tr'),
      i, ii;
  for (i = 0; i < headings.length; ++i) {
    var headContent = showdown.subParser('makeMarkdown.tableCell')(headings[i], globals),
        allign = '---';

    if (headings[i].hasAttribute('style')) {
      var style = headings[i].getAttribute('style').toLowerCase().replace(/\s/g, '');
      switch (style) {
        case 'text-align:left;':
          allign = ':---';
          break;
        case 'text-align:right;':
          allign = '---:';
          break;
        case 'text-align:center;':
          allign = ':---:';
          break;
      }
    }
    tableArray[0][i] = headContent.trim();
    tableArray[1][i] = allign;
  }

  for (i = 0; i < rows.length; ++i) {
    var r = tableArray.push([]) - 1,
        cols = rows[i].getElementsByTagName('td');

    for (ii = 0; ii < headings.length; ++ii) {
      var cellContent = ' ';
      if (typeof cols[ii] !== 'undefined') {
        cellContent = showdown.subParser('makeMarkdown.tableCell')(cols[ii], globals);
      }
      tableArray[r].push(cellContent);
    }
  }

  var cellSpacesCount = 3;
  for (i = 0; i < tableArray.length; ++i) {
    for (ii = 0; ii < tableArray[i].length; ++ii) {
      var strLen = tableArray[i][ii].length;
      if (strLen > cellSpacesCount) {
        cellSpacesCount = strLen;
      }
    }
  }

  for (i = 0; i < tableArray.length; ++i) {
    for (ii = 0; ii < tableArray[i].length; ++ii) {
      if (i === 1) {
        if (tableArray[i][ii].slice(-1) === ':') {
          tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii].slice(-1), cellSpacesCount - 1, '-') + ':';
        } else {
          tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount, '-');
        }
      } else {
        tableArray[i][ii] = showdown.helper.padEnd(tableArray[i][ii], cellSpacesCount);
      }
    }
    txt += '| ' + tableArray[i].join(' | ') + ' |\n';
  }

  return txt.trim();
});

showdown.subParser('makeMarkdown.tableCell', function (node, globals) {
  'use strict';

  var txt = '';
  if (!node.hasChildNodes()) {
    return '';
  }
  var children = node.childNodes,
      childrenLength = children.length;

  for (var i = 0; i < childrenLength; ++i) {
    txt += showdown.subParser('makeMarkdown.node')(children[i], globals, true);
  }
  return txt.trim();
});

showdown.subParser('makeMarkdown.txt', function (node) {
  'use strict';

  var txt = node.nodeValue;

  // multiple spaces are collapsed
  txt = txt.replace(/ +/g, ' ');

  // replace the custom ¨NBSP; with a space
  txt = txt.replace(/¨NBSP;/g, ' ');

  // ", <, > and & should replace escaped html entities
  txt = showdown.helper.unescapeHTMLEntities(txt);

  // escape markdown magic characters
  // emphasis, strong and strikethrough - can appear everywhere
  // we also escape pipe (|) because of tables
  // and escape ` because of code blocks and spans
  txt = txt.replace(/([*_~|`])/g, '\\$1');

  // escape > because of blockquotes
  txt = txt.replace(/^(\s*)>/g, '\\$1>');

  // hash character, only troublesome at the beginning of a line because of headers
  txt = txt.replace(/^#/gm, '\\#');

  // horizontal rules
  txt = txt.replace(/^(\s*)([-=]{3,})(\s*)$/, '$1\\$2$3');

  // dot, because of ordered lists, only troublesome at the beginning of a line when preceded by an integer
  txt = txt.replace(/^( {0,3}\d+)\./gm, '$1\\.');

  // +, * and -, at the beginning of a line becomes a list, so we need to escape them also (asterisk was already escaped)
  txt = txt.replace(/^( {0,3})([+-])/gm, '$1\\$2');

  // images and links, ] followed by ( is problematic, so we escape it
  txt = txt.replace(/]([\s]*)\(/g, '\\]$1\\(');

  // reference URIs must also be escaped
  txt = txt.replace(/^ {0,3}\[([\S \t]*?)]:/gm, '\\[$1]:');

  return txt;
});

var root = this;

// AMD Loader
if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    'use strict';
    return showdown;
  }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

// CommonJS/nodeJS Loader
} else {}
}).call(this);

//# sourceMappingURL=showdown.js.map


/***/ }),

/***/ 80500:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 70610:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ 42238:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.35',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 350;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        VIERA   = 'Viera',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish/Huawei Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2| pro)?)/i                                                // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /ios;fbsv\/([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 91496:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 20384:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 89539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(__webpack_require__.g.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(20384);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(91496);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 45840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _globalThis;
if (typeof globalThis === 'object') {
	_globalThis = globalThis;
} else {
	try {
		_globalThis = __webpack_require__(284);
	} catch (error) {
	} finally {
		if (!_globalThis && typeof window !== 'undefined') { _globalThis = window; }
		if (!_globalThis) { throw new Error('Could not determine global this'); }
	}
}

var NativeWebSocket = _globalThis.WebSocket || _globalThis.MozWebSocket;
var websocket_version = __webpack_require__(79387);


/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */
function W3CWebSocket(uri, protocols) {
	var native_instance;

	if (protocols) {
		native_instance = new NativeWebSocket(uri, protocols);
	}
	else {
		native_instance = new NativeWebSocket(uri);
	}

	/**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */
	return native_instance;
}
if (NativeWebSocket) {
	['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'].forEach(function(prop) {
		Object.defineProperty(W3CWebSocket, prop, {
			get: function() { return NativeWebSocket[prop]; }
		});
	});
}

/**
 * Module exports.
 */
module.exports = {
    'w3cwebsocket' : NativeWebSocket ? W3CWebSocket : null,
    'version'      : websocket_version
};


/***/ }),

/***/ 79387:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(19794).version;


/***/ }),

/***/ 83154:
/***/ (function(module, exports, __webpack_require__) {

var fetchApi
if (typeof fetch === 'function') {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
    fetchApi = __webpack_require__.g.fetch
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch
  } else {
    fetchApi = fetch
  }
}

if ( true && (typeof window === 'undefined' || typeof window.document === 'undefined')) {
  var f = fetchApi || __webpack_require__(54098)
  if (f.default) f = f.default
  exports["default"] = f
  module.exports = exports.default
}


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 25816:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jn": function() { return /* binding */ SDK_VERSION; },
  "qX": function() { return /* binding */ _getProvider; },
  "Xd": function() { return /* binding */ _registerComponent; },
  "Mq": function() { return /* binding */ getApp; },
  "C6": function() { return /* binding */ getApps; },
  "ZF": function() { return /* binding */ initializeApp; },
  "KN": function() { return /* binding */ registerVersion; }
});

// UNUSED EXPORTS: FirebaseError, _DEFAULT_ENTRY_NAME, _addComponent, _addOrOverwriteComponent, _apps, _clearComponents, _components, _removeServiceInstance, deleteApp, onLog, setLogLevel

// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var index_esm2017 = __webpack_require__(8463);
// EXTERNAL MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(53333);
// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(74444);
;// CONCATENATED MODULE: ./node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap_idb_value_wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap_idb_value_wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap_idb_value_wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap_idb_value_wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap_idb_value_wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap_idb_value_wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ./node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap_idb_value_wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap_idb_value_wrap(request.result), event.oldVersion, event.newVersion, wrap_idb_value_wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



;// CONCATENATED MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}

const name$o = "@firebase/app";
const version$1 = "0.9.10";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new esm_index_esm2017/* Logger */.Yd('@firebase/app');

const name$n = "@firebase/app-compat";

const name$m = "@firebase/analytics-compat";

const name$l = "@firebase/analytics";

const name$k = "@firebase/app-check-compat";

const name$j = "@firebase/app-check";

const name$i = "@firebase/auth";

const name$h = "@firebase/auth-compat";

const name$g = "@firebase/database";

const name$f = "@firebase/database-compat";

const name$e = "@firebase/functions";

const name$d = "@firebase/functions-compat";

const name$c = "@firebase/installations";

const name$b = "@firebase/installations-compat";

const name$a = "@firebase/messaging";

const name$9 = "@firebase/messaging-compat";

const name$8 = "@firebase/performance";

const name$7 = "@firebase/performance-compat";

const name$6 = "@firebase/remote-config";

const name$5 = "@firebase/remote-config-compat";

const name$4 = "@firebase/storage";

const name$3 = "@firebase/storage-compat";

const name$2 = "@firebase/firestore";

const name$1 = "@firebase/firestore-compat";

const index_esm2017_name = "firebase";
const version = "9.22.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$o]: 'fire-core',
    [name$n]: 'fire-core-compat',
    [name$l]: 'fire-analytics',
    [name$m]: 'fire-analytics-compat',
    [name$j]: 'fire-app-check',
    [name$k]: 'fire-app-check-compat',
    [name$i]: 'fire-auth',
    [name$h]: 'fire-auth-compat',
    [name$g]: 'fire-rtdb',
    [name$f]: 'fire-rtdb-compat',
    [name$e]: 'fire-fn',
    [name$d]: 'fire-fn-compat',
    [name$c]: 'fire-iid',
    [name$b]: 'fire-iid-compat',
    [name$a]: 'fire-fcm',
    [name$9]: 'fire-fcm-compat',
    [name$8]: 'fire-perf',
    [name$7]: 'fire-perf-compat',
    [name$6]: 'fire-rc',
    [name$5]: 'fire-rc-compat',
    [name$4]: 'fire-gcs',
    [name$3]: 'fire-gcs-compat',
    [name$2]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [index_esm2017_name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function _getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call initializeApp() first',
    ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'
};
const ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new index_esm2017/* Component */.wA('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */, { appName: this._name });
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    options || (options = (0,dist_index_esm2017/* getDefaultAppConfig */.aH)());
    if (!options) {
        throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */);
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0,dist_index_esm2017/* deepEqual */.vZ)(options, existingApp.options) &&
            (0,dist_index_esm2017/* deepEqual */.vZ)(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new index_esm2017/* ComponentContainer */.H0(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function getApp(name = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === DEFAULT_ENTRY_NAME && (0,dist_index_esm2017/* getDefaultAppConfig */.aH)()) {
        return initializeApp();
    }
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
    const name = app.name;
    if (_apps.has(name)) {
        _apps.delete(name);
        await Promise.all(app.container
            .getProviders()
            .map(provider => provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new index_esm2017/* Component */.wA(`${library}-version`, () => ({ library, version }), "VERSION" /* ComponentType.VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */);
    }
    setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function setLogLevel(logLevel) {
    setLogLevel$1(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(STORE_NAME);
                }
            }
        }).catch(e => {
            throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const result = await db
            .transaction(STORE_NAME)
            .objectStore(STORE_NAME)
            .get(computeKey(app));
        return result;
    }
    catch (e) {
        if (e instanceof dist_index_esm2017/* FirebaseError */.ZR) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    }
    catch (e) {
        if (e instanceof dist_index_esm2017/* FirebaseError */.ZR) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        const platformLogger = this.container
            .getProvider('platform-logger')
            .getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = getUTCDateString();
        if (this._heartbeatsCache === null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
            this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
            return;
        }
        else {
            // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({ date, agent });
        }
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) {
            await this._heartbeatsCachePromise;
        }
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null ||
            this._heartbeatsCache.heartbeats.length === 0) {
            return '';
        }
        const date = getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0,dist_index_esm2017/* base64urlEncodeWithoutPadding */.L)(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        }
        else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            void this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0,dist_index_esm2017/* isIndexedDBAvailable */.hl)()) {
            return false;
        }
        else {
            return (0,dist_index_esm2017/* validateIndexedDBOpenable */.eu)()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || { heartbeats: [] };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0,dist_index_esm2017/* base64urlEncodeWithoutPadding */.L)(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new index_esm2017/* Component */.wA('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    _registerComponent(new index_esm2017/* Component */.wA('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    // Register `app` package.
    registerVersion(name$o, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name$o, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 8463:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H0": function() { return /* binding */ ComponentContainer; },
/* harmony export */   "wA": function() { return /* binding */ Component; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var _firebase_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74444);


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new _firebase_util__WEBPACK_IMPORTED_MODULE_0__/* .Deferred */ .BH();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 66292:
/***/ (function(__unused_webpack___webpack_module__, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: deleteInstallations, getId, getInstallations, getToken, onIdChange

// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js + 2 modules
var index_esm2017 = __webpack_require__(25816);
// EXTERNAL MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(8463);
// EXTERNAL MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(74444);
;// CONCATENATED MODULE: ./node_modules/@firebase/installations/node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap_idb_value_wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap_idb_value_wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap_idb_value_wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap_idb_value_wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap_idb_value_wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap_idb_value_wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ./node_modules/@firebase/installations/node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap_idb_value_wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap_idb_value_wrap(request.result), event.oldVersion, event.newVersion, wrap_idb_value_wrap(request.transaction));
        });
    }
    if (blocked)
        request.addEventListener('blocked', () => blocked());
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking)
            db.addEventListener('versionchange', () => blocking());
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked)
        request.addEventListener('blocked', () => blocked());
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



;// CONCATENATED MODULE: ./node_modules/@firebase/installations/dist/esm/index.esm2017.js





const index_esm2017_name = "@firebase/installations";
const version = "0.6.4";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */]: "Can't delete installation while there is a pending registration request."
};
const ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof dist_index_esm2017/* FirebaseError */.ZR &&
        error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */, {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) {
        // Internal Server Error. Retry request.
        return fn();
    }
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    }
    else {
        throw await getErrorFromResponse('Create Installation', response);
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 0b01110000 + (fidByteArray[0] % 0b00010000);
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    const key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    const key = getKey(appConfig);
    let callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    const key = getKey(appConfig);
    const callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    for (const callback of callbacks) {
        callback(fid);
    }
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key, fid });
    }
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = e => {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(OBJECT_STORE_NAME);
                }
            }
        });
    }
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
async function set(appConfig, value) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await objectStore.get(key));
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) {
        fidChanged(appConfig, value.fid);
    }
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */
async function remove(appConfig) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
async function update(appConfig, updateFn) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await store.get(key));
    const newValue = updateFn(oldValue);
    if (newValue === undefined) {
        await store.delete(key);
    }
    else {
        await store.put(newValue, key);
    }
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
        fidChanged(appConfig, newValue.fid);
    }
    return newValue;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, oldEntry => {
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) {
        // FID generation failed. Waiting for the FID from the server.
        return { installationEntry: await registrationPromise };
    }
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        return {
            installationEntry,
            registrationPromise: waitUntilFidRegistration(installations)
        };
    }
    else {
        return { installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    }
    catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) {
            // Server returned a "FID can not be used" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            // Registration failed. Set FID as not registered.
            await set(installations.appConfig, {
                fid: installationEntry.fid,
                registrationStatus: 0 /* RequestStatus.NOT_STARTED */
            });
        }
        throw e;
    }
}
/** Call if FID registration is pending in another request. */
async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) {
            return registrationPromise;
        }
        else {
            // if there is no registrationPromise, entry is registered.
            return installationEntry;
        }
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    }
    else {
        throw await getErrorFromResponse('Generate Auth Token', response);
    }
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
            // There is a valid token in the DB.
            return oldEntry;
        }
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        }
        else {
            // No token or token expired.
            if (!navigator.onLine) {
                throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise
        ? await tokenPromise
        : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while (entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        return refreshAuthToken(installations, forceRefresh);
    }
    else {
        return authToken;
    }
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object.assign(Object.assign({}, oldEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken });
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    }
    catch (e) {
        if (isServerError(e) &&
            (e.customData.serverCode === 401 || e.customData.serverCode === 404)) {
            // Server returned a "FID not found" or a "Invalid authentication" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* RequestStatus.COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) {
        registrationPromise.catch(console.error);
    }
    else {
        // If the installation is already registered, update the authentication
        // token if needed.
        refreshAuthToken(installationsImpl).catch(console.error);
    }
    return installationEntry.fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getToken(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) {
        // A createInstallation request is in progress. Wait until it finishes.
        await registrationPromise;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = getDeleteEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (!response.ok) {
        throw await getErrorFromResponse('Delete Installation', response);
    }
}
function getDeleteEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function deleteInstallations(installations) {
    const { appConfig } = installations;
    const entry = await update(appConfig, oldEntry => {
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
            // Delete the unregistered entry without sending a deleteInstallation request.
            return undefined;
        }
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // Can't delete while trying to register.
            throw ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */);
        }
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */) {
            if (!navigator.onLine) {
                throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            else {
                await deleteInstallationRequest(appConfig, entry);
                await remove(appConfig);
            }
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */
function onIdChange(installations, callback) {
    const { appConfig } = installations;
    addCallback(appConfig, callback);
    return () => {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */
function getInstallations(app = getApp()) {
    const installationsImpl = _getProvider(app, 'installations').getImmediate();
    return installationsImpl;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys) {
        if (!app.options[keyName]) {
            throw getMissingValueError(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig(app);
    const heartbeatServiceProvider = (0,index_esm2017/* _getProvider */.qX)(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: () => Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0,index_esm2017/* _getProvider */.qX)(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: () => getId(installations),
        getToken: (forceRefresh) => getToken(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    (0,index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    (0,index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
}

/**
 * Firebase Installations
 *
 * @packageDocumentation
 */
registerInstallations();
(0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version, 'esm2017');


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 53333:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yd": function() { return /* binding */ Logger; },
/* harmony export */   "in": function() { return /* binding */ LogLevel; }
/* harmony export */ });
/* unused harmony exports setLogLevel, setUserLogHandler */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach(inst => {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    for (const instance of instances) {
        let customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = (instance, level, ...args) => {
                const message = args
                    .map(arg => {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(arg => arg)
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message,
                        args,
                        type: instance.name
                    });
                }
            };
        }
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 65735:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M6U": function() { return /* binding */ faShareNodes; },
/* harmony export */   "PQh": function() { return /* binding */ faFileArrowUp; },
/* harmony export */   "QUp": function() { return /* binding */ faMobileNotch; },
/* harmony export */   "UOM": function() { return /* binding */ faMicrophone; },
/* harmony export */   "VmB": function() { return /* binding */ faImage; },
/* harmony export */   "Vui": function() { return /* binding */ faTrashCan; },
/* harmony export */   "Yai": function() { return /* binding */ faPenToSquare; },
/* harmony export */   "_hk": function() { return /* binding */ faImagePolaroidUser; },
/* harmony export */   "_jT": function() { return /* binding */ faCamera; },
/* harmony export */   "eFW": function() { return /* binding */ faArrowRight; },
/* harmony export */   "ej9": function() { return /* binding */ faCircleStop; },
/* harmony export */   "g82": function() { return /* binding */ faXmark; },
/* harmony export */   "gMD": function() { return /* binding */ faFile; },
/* harmony export */   "m08": function() { return /* binding */ faUserCircle; },
/* harmony export */   "nfZ": function() { return /* binding */ faFileLines; },
/* harmony export */   "yOZ": function() { return /* binding */ faAngleRight; }
/* harmony export */ });
/* unused harmony exports fal, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faCalendarAlt, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDown, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faRam, faLandmarkFlag, faLips, faPencil, faPencilAlt, faBackward, faCaretRight, faComments, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faUsersMedical, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faEmptySet, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faCircleExclamation, faExclamationCircle, faSchoolCircleXmark, faArrowRightFromBracket, faSignOut, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faAsterisk, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faCheckSquare, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmSimple, faFilmAlt, faList, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faLock, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faGlobePointer, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faEdit, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faHourglass2, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faUsers, faFacePleading, faEyeSlash, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faFolderBookmark, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faChevronUp, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faArrowDownLeftAndArrowUpRightToCenter, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSparkles, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFaceFrownOpen, faFrownOpen, faSquareDashed, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faAlignJustify, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faRaccoon, faHandPointDown, faArrowUpFromBracket, faHeadSideGear, faTrashPlus, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faWandMagicSparkles, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faUser, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faPersonDressFairy, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faTruckBolt, faPizzaSlice, faMoneyBillWave, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faXRay, faGoalNet, faCoffinCross, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneTop, faPaperPlaneAlt, faSend, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faArrowUpToArc, faStarExclamation, faBooks, faUserGroup, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faSwapArrows, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faSubtitles, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faWindowFrame, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faCaretUp, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faFolderClosed, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faHandshake, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faArrowUpRightAndArrowDownLeftFromCenter, faTablets, fa360Degrees, faEthernet, faEuroSign, faEur, faEuro, faChair, faCircleCheck, faCheckCircle, faSquareDashedCirclePlus, faMoneySimpleFromBracket, faBat, faStopCircle, faHeadSideHeadphones, faPhoneRotary, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faSuitcase, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faLightEmergencyOn, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faMoneyBills, faBlindsRaised, faSmog, faUfoBeam, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMemoPad, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faEnvelopeCircleCheck, faLayerGroup, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faNewspaper, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faSort, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileIphone, faMagnifyingGlassChart, faArrowUpRightFromSquare, faExternalLink, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faSignatureLock, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyStar, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faHeart, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faCirclePause, faPauseCircle, faGaugeCirclePlus, faFolders, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faUserAstronaut, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faBadgeCheck, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faCircleQuestion, faQuestionCircle, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faEye, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faPen, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faFileCode, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faDiploma, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortUp, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommentDots, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faSpinnerThird, faFaceGrinTears, faGrinTears, faPhone, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faTrash, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faArrowLeft, faPersonCircleXmark, faRuler, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faFilePdf, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSparkles, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faComment, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faEnvelope, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleNodes, faParachuteBox, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faCircleInfo, faInfoCircle, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCameraAlt, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faMinus, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileCertificate, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faGear, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformLines, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClock, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faCaretDown, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faFilterList, faOutlet, faSliders, faSlidersH, faCauldron, faPeople, faFolderTree, faNetworkWired, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisVertical, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faSwap, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faDownload, faAnglesUpDown, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faStop, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faPersonSimple, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faAngleDown, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faEnvelopeDot, faEnvelopeBadge, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faMedal, faPersonFairy, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faPodcast, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faBell, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faMapMarkerAlt, faCrab, faBoxOpenFull, faBoxFull, faGreaterThan, faQuotes, faPretzel, faPersonSwimming, faSwimmer, faArrowDown, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faGrillHot, faBallotCheck, faLink, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faPlay, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faRupiahSign, faMagnifyingGlass, faSearch, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFilePen, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faChevronDown, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faTasks, faDiagramSubtask, faJugDetergent, faCircleUser, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faCopy, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faKeynote, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faPlus, faAdd, faExpand, faComputer, faFort, faCloudCheck, faClose, faMultiply, faRemove, faTimes, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faArrowLeftFromArc, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faRocket, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faArrowLeftToArc, faChevronLeft, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faChevronRight, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercent, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faRobot, faPeace, faPartyHorn, faGears, faCogs, faSunBright, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faBuilding, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faSubtitlesSlash, faQrcode, faDiceD10, faFireplace, faBrowser, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faPenLine, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faMusic, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faBoxHeart, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faLighthouse, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faPlusCircle, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faBook, faUserPlus, faIceSkate, faCheck, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faAngleLeft, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronsRight, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faTriangleExclamation, faExclamationTriangle, faWarning, faNoteMedical, faDatabase, faDownLeft, faShare, faArrowTurnRight, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faColumns3, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faCircleXmark, faTimesCircle, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faThumbsUp, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faArrowDownFromArc, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faStickyNote, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faFaceSadSweat, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faShieldKeyhole, faBarcode, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faGraduationCap, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt */
var prefix = "fal";
var fa0 = {
  prefix: 'fal',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 64C89.3 64 32 121.3 32 192V320c0 70.7 57.3 128 128 128s128-57.3 128-128V192c0-70.7-57.3-128-128-128z"]
};
var fa1 = {
  prefix: 'fal',
  iconName: '1',
  icon: [256, 512, [], "31", "M144 48c0-5.9-3.2-11.3-8.5-14.1s-11.5-2.5-16.4 .8l-96 64c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L112 77.9V448l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H128 240c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0V48z"]
};
var fa2 = {
  prefix: 'fal',
  iconName: '2',
  icon: [320, 512, [], "32", "M148 64c-28.8 0-56.9 11.5-77.2 31.8L43.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L48.2 73.1C74.6 46.8 110.9 32 148 32c76.5 0 140 61.9 140 138.8c0 38.4-15.9 75-43.9 101.3L56.5 448H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.6 0-12.5-4-14.9-10.1s-.9-13.1 3.9-17.6L222.2 248.7c21.5-20.2 33.8-48.4 33.8-77.9C256 112 207.2 64 148 64z"]
};
var fa3 = {
  prefix: 'fal',
  iconName: '3',
  icon: [320, 512, [], "33", "M0 48c0-8.8 7.2-16 16-16H288c6.6 0 12.5 4 14.9 10.2s.8 13.1-4 17.6L120.9 224H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H89.4c-36.4 0-69.6-20.5-85.9-53.1l-1.9-3.8c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l1.9 3.8C43 434.3 65.2 448 89.4 448H192c53 0 96-43 96-96s-43-96-96-96H80c-6.6 0-12.5-4-14.9-10.2s-.8-13.1 4-17.6L247.1 64H16C7.2 64 0 56.8 0 48z"]
};
var fa4 = {
  prefix: 'fal',
  iconName: '4',
  icon: [384, 512, [], "34", "M174.3 55.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-144 288c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H288V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V320H41.9L174.3 55.2z"]
};
var fa5 = {
  prefix: 'fal',
  iconName: '5',
  icon: [320, 512, [], "35", "M48.5 44.1C50.3 37 56.7 32 64 32H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H76.5l-40 160H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H84.5c-33.3 0-63.8-18.8-78.7-48.6l-4.1-8.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.1 8.2c9.5 19 28.9 31 50.1 31H192c53 0 96-43 96-96s-43-96-96-96H16c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l48-192z"]
};
var fa6 = {
  prefix: 'fal',
  iconName: '6',
  icon: [320, 512, [], "36", "M288 320c0-70.7-57.3-128-128-128C90.3 192 33.7 247.7 32 316.9c0 1 0 2 0 3.1c0 70.7 57.3 128 128 128s128-57.3 128-128zM126.8 163.5c10.7-2.3 21.8-3.5 33.2-3.5c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-2 0-3.9 .1-5.9C1.5 276.2 16 239.9 41.2 211.5L196 37.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6L126.8 163.5z"]
};
var fa7 = {
  prefix: 'fal',
  iconName: '7',
  icon: [320, 512, [], "37", "M0 48c0-8.8 7.2-16 16-16H304c5.8 0 11.1 3.1 14 8.2s2.7 11.3-.3 16.2l-256 416c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22L275.4 64H16C7.2 64 0 56.8 0 48z"]
};
var fa8 = {
  prefix: 'fal',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 152c0-66.3-53.7-120-120-120H136C69.7 32 16 85.7 16 152c0 41.4 20.9 77.9 52.8 99.4C28.1 270.6 0 312 0 360c0 66.3 53.7 120 120 120h80c66.3 0 120-53.7 120-120c0-48-28.1-89.4-68.8-108.6C283.1 229.9 304 193.4 304 152zM184.1 272H200c48.6 0 88 39.4 88 88s-39.4 88-88 88H120c-48.6 0-88-39.4-88-88s39.4-88 88-88h15.9c0 0 .1 0 .1 0h48c0 0 0 0 .1 0zm0-32c0 0 0 0-.1 0H136c0 0 0 0-.1 0C87.4 240 48 200.6 48 152c0-48.6 39.4-88 88-88l48 0c48.6 0 88 39.4 88 88c0 48.6-39.4 88-87.9 88z"]
};
var fa9 = {
  prefix: 'fal',
  iconName: '9',
  icon: [320, 512, [], "39", "M32 192c0 70.7 57.3 128 128 128c69.7 0 126.3-55.7 128-124.9c0-1 0-2 0-3.1c0-70.7-57.3-128-128-128S32 121.3 32 192zM193.2 348.5c-10.7 2.3-21.8 3.5-33.2 3.5C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 2 0 3.9-.1 5.9c-1.4 37.9-15.9 74.2-41.1 102.6L124 474.6c-5.9 6.6-16 7.2-22.6 1.3s-7.2-16-1.3-22.6l93.2-104.8z"]
};
var faFillDrip = {
  prefix: 'fal',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0l97.4 97.4 64.4-64.4c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L134.1 124.7 36.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm208 230.6l-88-88L53.3 250.7C42.8 261.2 36.7 274.4 35 288H432l19.7-19.7c15.6-15.6 15.6-40.9 0-56.6L300.3 60.3c-15.6-15.6-40.9-15.6-56.6 0l-64.4 64.4 88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0zM39.2 320c3.1 7.7 7.8 15 14.1 21.3L170.7 458.7c25 25 65.5 25 90.5 0L400 320H39.2zM544 448s0 0 0 0v0c0-.1-.1-1.2-.6-3.4c-.6-2.4-1.5-5.4-2.8-9.1c-2.7-7.4-6.8-16.2-11.7-25.8c-5.2-10.2-11.2-20.6-16.9-30.3c-5.8 9.7-11.7 20.1-16.9 30.3c-4.9 9.6-8.9 18.4-11.7 25.8c-1.4 3.7-2.3 6.7-2.8 9.1c-.5 2.2-.6 3.3-.6 3.4c0 0 0 0 0 0c0 17.7 14.3 32 32 32s32-14.3 32-32zm32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448z"]
};
var faArrowsToCircle = {
  prefix: 'fal',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", "M27.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L137.4 160H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4L27.3 4.7zM320 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM464 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H502.6L635.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 137.4V80c0-8.8-7.2-16-16-16zM176 448c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 374.6V432c0 8.8 7.2 16 16 16zm288 0c8.8 0 16-7.2 16-16V374.6L612.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 352H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"]
};
var faCircleChevronRight = {
  prefix: 'fal',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM235.3 379.3l112-112c6.2-6.2 6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L313.4 256 212.7 356.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faChevronCircleRight = faCircleChevronRight;
var faWagonCovered = {
  prefix: 'fal',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M239.4 34.1C250.1 13.8 271.4 0 296 0h48c24.6 0 45.9 13.8 56.6 34.1c13.1-12.6 30.6-20.8 50.1-22.1L565.8 4.4c41.7-2.8 71.7 39.5 55.2 77.9L560.3 224c8.7 .1 15.7 7.2 15.7 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V256h-8H392 376 264 248 104 96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.7 7-15.9 15.7-16L19 82.3C2.5 43.9 32.5 1.6 74.2 4.4l115.1 7.7c19.5 1.3 36.9 9.5 50.1 22.1zM114.6 224H232V91.9c0-25.3-19.6-46.2-44.8-47.9L72.1 36.3C54.2 35.1 41.4 53.2 48.4 69.7L114.6 224zM408 224H525.4L591.6 69.7c7.1-16.5-5.8-34.6-23.7-33.4L452.8 44C427.6 45.7 408 66.6 408 91.9V224zM264 91.9V224H376V64c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32V91.9zM176 512c-61.9 0-112-50.1-112-112s50.1-112 112-112c56.4 0 103.1 41.7 110.9 96h66.3c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112s-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H286.9c-7.8 54.3-54.4 96-110.9 96zm16-33.6c31.3-6.4 56-31.1 62.4-62.4H192v62.4zm-32 0V416H97.6c6.4 31.3 31.1 56 62.4 62.4zM96 399.6l0 .4 0 .4v-.8zM97.6 384H160V321.6c-31.3 6.4-56 31.1-62.4 62.4zM192 321.6V384h62.4c-6.4-31.3-31.1-56-62.4-62.4zM542.4 416H480v62.4c31.3-6.4 56-31.1 62.4-62.4zM448 416H385.6c6.4 31.3 31.1 56 62.4 62.4V416zm-64-16l0-.4v.8l0-.4zm64-16V321.6c-31.3 6.4-56 31.1-62.4 62.4H448zm32 0h62.4c-6.4-31.3-31.1-56-62.4-62.4V384z"]
};
var faLineHeight = {
  prefix: 'fal',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M107.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L80 86.6V425.4L27.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 425.4V86.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM272 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM256 416c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"]
};
var faBagel = {
  prefix: 'fal',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M608 208c0-97.2-78.8-176-176-176c-49.3 0-93.9 20.3-125.8 52.9c-10.5-4.7-21.3-8.7-32.5-11.8C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c5.4-10.2 10-20.7 13.9-31.7C530.5 382.7 608 304.4 608 208zM364.6 84.4l17.6-.5c6.2-.2 12.1-2.1 17.2-5.6l14.5-10c10.9-7.5 25.3-7.5 36.2 0l14.5 10c5.1 3.5 11 5.4 17.2 5.6l17.6 .5c13.2 .4 24.8 8.8 29.3 21.3l5.9 16.6c2.1 5.8 5.8 10.9 10.6 14.6l14 10.7c10.5 8.1 14.9 21.7 11.2 34.4l-5 16.9c-1.7 5.9-1.7 12.2 0 18.1l5 16.9c3.7 12.7-.7 26.3-11.2 34.4l-14 10.7c-4.9 3.8-8.6 8.8-10.6 14.6l-5.9 16.6c-4.4 12.5-16.1 20.9-29.3 21.3l-17.6 .5c-6.2 .2-12.1 2.1-17.2 5.6l-14.5 10c-2.1 1.5-4.4 2.6-6.7 3.5c2.6-13.2 4.2-26.9 4.5-40.8c9.8-6.4 21.3-9.9 33-10.3l17.6-.5 5.9-16.6c4.1-11.6 11.5-21.8 21.3-29.3l14-10.7-5-16.9c-3.5-11.8-3.5-24.4 0-36.2l5-16.9-14-10.7c-9.8-7.5-17.1-17.7-21.3-29.3l-5.9-16.6-17.6-.5c-12.3-.3-24.3-4.2-34.4-11.2L432 94.8l-14.5 10c-10.2 7-22.1 10.8-34.4 11.2l-17.6 .5-1.8 4.9c-8.4-7.2-17.3-13.8-26.6-19.7c5.3-10.2 15.8-16.9 27.5-17.2zM384 304A176 176 0 1 0 32 304a176 176 0 1 0 352 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm208-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTransporter7 = {
  prefix: 'fal',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", "M480 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V48zM64 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V272zm64 224c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faAt = {
  prefix: 'fal',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v24c0 48.6-39.4 88-88 88c-33.4 0-62.5-18.7-77.4-46.1c-20.4 28-53.4 46.1-90.6 46.1c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6V176c0-8.8 7.2-16 16-16s16 7.2 16 16v80 24c0 30.9 25.1 56 56 56s56-25.1 56-56V256C480 132.3 379.7 32 256 32zm80 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faRectanglesMixed = {
  prefix: 'fal',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", "M272 64c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H272zM48 32C21.5 32 0 53.5 0 80V208c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM528 64c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96zM432 32c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H432zM112 336H288c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16zM64 352v80c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V352c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faPhoneArrowUpRight = {
  prefix: 'fal',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M292.7 196.7L457.4 32H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16V144c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L315.3 219.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm36.4 90c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faPhoneArrowUp = faPhoneArrowUpRight;
var faPhoneOutgoing = faPhoneArrowUpRight;
var faTrashCan = {
  prefix: 'fal',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm80 80V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTrashAlt = faTrashCan;
var faCircleL = {
  prefix: 'fal',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 17.7 14.3 32 32 32H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V144z"]
};
var faHeadSideGoggles = {
  prefix: 'fal',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M2.3 256c5.8 40.5 22.4 77.5 46.8 108C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4c-20-25-33.9-55-39.4-88H2.3zM80.9 96C116 56.7 167.1 32 224 32h24c36 0 69.3 11.9 96 32H288c-28.4 0-54 12.4-71.6 32H80.9zm-45.1 6.6C14.6 113 0 134.8 0 160c0 35.3 28.7 64 64 64H216.4c17.6 19.6 43.1 32 71.6 32H400h64c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H400h-8.9C356 24.7 304.9 0 248 0H224C145 0 75.6 40.8 35.7 102.6zM197.5 192H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H197.5c-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32zm313.3 96H477.2c-4.5 9.5-14.2 16-25.4 16H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c29.1 0 53.3-20.6 58.9-48zM288 96h96V224H288c-35.3 0-64-28.7-64-64s28.7-64 64-64zM416 224V96h48c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H416z"]
};
var faHeadVr = faHeadSideGoggles;
var faTextHeight = {
  prefix: 'fal',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M491.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L464 86.6V425.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 425.4V86.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64H144l0 384H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H176l0-384H288v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32z"]
};
var faUserXmark = {
  prefix: 'fal',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM468.7 148.7c-6.2 6.2-6.2 16.4 0 22.6L521.4 224l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L544 246.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L566.6 224l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L544 201.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faUserTimes = faUserXmark;
var faFaceHandYawn = {
  prefix: 'fal',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm233.3 45.3L248 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V352 298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0zM220.5 110c-5.5-6.9-15.6-8-22.5-2.5l-80 64c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l80-64c6.9-5.5 8-15.6 2.5-22.5zM294 132.5l80 64c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5l-80-64c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5z"]
};
var faGaugeSimpleMin = {
  prefix: 'fal',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64z"]
};
var faTachometerSlowest = faGaugeSimpleMin;
var faStethoscope = {
  prefix: 'fal',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M127 10.4c3.1 8.3-1.1 17.5-9.4 20.6L74.4 47.2C68.1 49.5 64 55.5 64 62.2V192c0 70.7 57.3 128 128 128s128-57.3 128-128V62.2c0-6.7-4.1-12.6-10.4-15L266.4 31c-8.3-3.1-12.5-12.3-9.4-20.6s12.3-12.5 20.6-9.4l43.2 16.2c18.7 7 31.1 24.9 31.1 44.9V192c0 83-63.1 151.2-144 159.2v.8c0 70.7 57.3 128 128 128s128-57.3 128-128V254c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62v98c0 88.4-71.6 160-160 160s-160-71.6-160-160v-.8C95.1 343.2 32 275 32 192V62.2c0-20 12.4-37.9 31.1-44.9L106.4 1c8.3-3.1 17.5 1.1 20.6 9.4zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCoffin = {
  prefix: 'fal',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M126.5 32l131 0 91 104c2.3 2.6 3.6 6 3.6 9.5c0 1.4-.2 2.7-.6 4L255.9 480l-127.9 0L32.6 149.4c-.4-1.3-.6-2.6-.6-4c0-3.5 1.3-6.9 3.6-9.5l91-104zM102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1H255.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9z"]
};
var faMessage = {
  prefix: 'fal',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M160 384c17.7 0 32 14.3 32 32v48l98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32h96zM0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V448 416H128 64c-35.3 0-64-28.7-64-64V64z"]
};
var faCommentAlt = faMessage;
var faSalad = {
  prefix: 'fal',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M241.1 32c37.1 0 68.9 22.7 82.3 55c2.8 6.6 9.6 10.6 16.7 9.7c3.9-.5 7.8-.7 11.8-.7c7.4 0 14.6 .8 21.5 2.4C382.1 96.8 391 96 400 96c15.3 0 30 2.4 43.8 6.8C420.5 78.9 388 64 352 64c-1.3 0-2.7 0-4 .1C327.6 26 287.4 0 241.1 0c-46.3 0-86.5 26-106.9 64.1c-2.1-.1-4.1-.1-6.2-.1C57.3 64 0 121.3 0 192c0 23.3 6.2 45.2 17.1 64H56.4C41.2 239 32 216.6 32 192c0-53 43-96 96-96c4.6 0 9.2 .3 13.6 1c7.2 1 14.3-3 17-9.7C172 54.8 203.9 32 241.1 32zM400 160c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16h32.5c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 5.4 .4 10.8 1.1 16h32.5c-1-5.2-1.6-10.5-1.6-16c0-44.2 35.8-80 80-80zM129.3 457.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 417 33.9 372.3 32.1 320H479.9c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 470.4 366.5 480 352 480H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 288C12.3 288 0 300.3 0 315.4c0 67.4 40.6 125.4 98.6 150.8C106.5 492.7 131 512 160 512H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4zM256 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112zM107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80z"]
};
var faBowlSalad = faSalad;
var faInfo = {
  prefix: 'fal',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M64 64a32 32 0 1 1 64 0A32 32 0 1 1 64 64zM16 176c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16V448h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H80V192H32c-8.8 0-16-7.2-16-16z"]
};
var faRobotAstromech = {
  prefix: 'fal',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M256 0C176.5 0 112 64.5 112 144v16H96c-35.3 0-64 28.7-64 64V420.2L2.4 479.5C.8 482.6 0 486 0 489.5C0 501.9 10.1 512 22.5 512H128c8.8 0 16-7.2 16-16V406.6l36.7 36.7c3 3 7.1 4.7 11.3 4.7H320c4.2 0 8.3-1.7 11.3-4.7L368 406.6V496c0 8.8 7.2 16 16 16H489.5c12.4 0 22.5-10.1 22.5-22.5c0-3.5-.8-6.9-2.4-10L480 420.2V224c0-35.3-28.7-64-64-64H400V144C400 64.5 335.5 0 256 0zM400 192h16c17.7 0 32 14.3 32 32V424c0 2.5 .6 4.9 1.7 7.2L474.1 480H400V368 192zm-32 0V361.4L313.4 416H198.6L144 361.4V192H368zm-256 0V368 480H37.9l24.4-48.8c1.1-2.2 1.7-4.7 1.7-7.2V224c0-17.7 14.3-32 32-32h16zm32-48c0-61.9 50.1-112 112-112s112 50.1 112 112v16H144V144zm80-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faRingDiamond = {
  prefix: 'fal',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M136 0c-5.7 0-11 3.1-13.9 8.1l-32 56c-3 5.3-2.8 11.8 .6 16.8l38.4 57.7C54 164.6 0 236 0 320C0 426 86 512 192 512s192-86 192-192c0-84-54-155.4-129.1-181.5l38.4-57.7c3.4-5 3.6-11.6 .6-16.8l-32-56C259 3.1 253.7 0 248 0H136zm85.9 130.3c-9.7-1.5-19.7-2.3-29.9-2.3s-20.2 .8-29.9 2.3l-39.3-59L145.3 32h93.4l22.5 39.4-39.3 59zM32 320a160 160 0 1 1 320 0A160 160 0 1 1 32 320z"]
};
var faFonduePot = {
  prefix: 'fal',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M282.1 32.3c-4.3-1.2-8.7 1.4-9.8 5.6l-24 88c-1.2 4.3 1.4 8.7 5.6 9.8s8.7-1.4 9.8-5.6l24-88c1.2-4.3-1.4-8.7-5.6-9.8zM262.5 167.5L255.1 192H221.7l9.7-32.4c-12.3-9.6-18.4-26-14-42.1l24-88c5.8-21.3 27.8-33.9 49.1-28.1s33.9 27.8 28.1 49.1l-24 88c-4.3 15.6-17.2 26.5-32.1 29zM223.4 256h1.2c-.4 0-.8 0-1.2 0zm88 0h1.1c-.4 0-.7 0-1.1 0zm65.7-88.6L361.5 192H323.6l26.9-42.2c-8.3-12.7-8.9-29.6-.2-43.3l56-88C418.1-.1 442.8-5.6 461.5 6.3s24.1 36.6 12.3 55.2l-56 88c-8.9 14-25.2 20.6-40.6 17.9zM444.3 33.3c-3.7-2.4-8.7-1.3-11 2.5l-56 88c-2.4 3.7-1.3 8.7 2.5 11s8.7 1.3 11-2.5l56-88c2.4-3.7 1.3-8.7-2.5-11zM32 256v64c0 70.7 57.3 128 128 128H288c70.7 0 128-57.3 128-128V256H160v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H32zM0 256c0-17.7 14.3-32 32-32H416h8 24 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v64c0 52.3-25.1 98.8-64 128v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V466.7c-19.6 8.6-41.2 13.3-64 13.3H160c-22.8 0-44.4-4.8-64-13.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V448C25.1 418.8 0 372.3 0 320V256z"]
};
var faTheta = {
  prefix: 'fal',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M48 256c0-58.9 17.1-111.6 43.9-149.1C118.7 69.4 154.3 48 192 48s73.3 21.4 100.1 58.9C318.9 144.4 336 197.1 336 256s-17.1 111.6-43.9 149.1C265.3 442.6 229.7 464 192 464s-73.3-21.4-100.1-58.9C65.1 367.6 48 314.9 48 256zM192 16C141.3 16 96.9 44.8 65.8 88.3C34.7 131.9 16 191.2 16 256s18.7 124.1 49.8 167.7C96.9 467.2 141.3 496 192 496s95.1-28.8 126.2-72.3C349.3 380.1 368 320.8 368 256s-18.7-124.1-49.8-167.7C287.1 44.8 242.7 16 192 16zM112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faFaceHandPeeking = {
  prefix: 'fal',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M185.6 76.8C223 48.7 269.6 32 320 32c66.3 0 125.9 28.8 167 74.7c5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C464 33 395.8 0 320 0C262.4 0 209.2 19.1 166.4 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2zM130.5 375.5c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512c65.6 0 125.4-24.7 170.7-65.2c6.6-5.9 7.1-16 1.3-22.6s-16-7.1-22.6-1.3c-39.6 35.5-91.9 57-149.3 57c-79.8 0-149.8-41.7-189.5-104.5zM415 232c.7-2.6 1-5.2 1-8c0-1.6-.1-3.2-.4-4.8L433.6 232H415zm-53.8 14.5c-5.8 6.9-9.2 15.8-9.2 25.5c0 13.4 6.6 25.3 16.7 32.5c-.5 2.4-.7 4.9-.7 7.5c0 22.1 17.9 40 40 40h8c0 .3 0 .6 0 .9c0 22.1 17.9 40 40 40h64.8c31.6 0 61.9-12.6 84.3-34.9c46.2-46.2 46.5-120.9 1-167.6l0 0-.2-.1-.8-.8-.1-.1L560 144.3c-17.2-17.2-45-17.2-62.2 0c-7.3 7.3-11.5 16.6-12.6 26.2l-37.9-27.1c-18-12.8-43-8.7-55.8 9.3c-8.5 11.9-9.6 26.9-4 39.4c-1.1-.1-2.3-.2-3.4-.2c-17.7 0-32 14.3-32 32c0 8.8 3.5 16.7 9.2 22.5zM289.7 376.7c7.1-5.1 17.8-8.7 30.3-8.7s23.2 3.6 30.3 8.7c7.2 5.1 9.7 10.7 9.7 15.3s-2.5 10.2-9.7 15.3c-7.1 5.1-17.8 8.7-30.3 8.7s-23.2-3.6-30.3-8.7c-7.2-5.1-9.7-10.7-9.7-15.3s2.5-10.2 9.7-15.3zm-18.6-26C258 360.1 248 374.4 248 392s10 31.9 23.1 41.3c13.1 9.4 30.5 14.7 48.9 14.7s35.8-5.3 48.9-14.7C382 423.9 392 409.6 392 392s-10-31.9-23.1-41.3C355.8 341.3 338.4 336 320 336s-35.8 5.3-48.9 14.7zM379.4 144.1c-2-6.3-8.7-9.8-15-7.9C327.1 147.9 300 182.8 300 224c0 20.7 6.8 39.8 18.4 55.2c4 5.3 11.5 6.4 16.8 2.4s6.4-11.5 2.4-16.8C329.1 253.4 324 239.3 324 224c0-30.4 20-56.2 47.6-64.9c6.3-2 9.8-8.7 7.9-15zM96 88.3L34.9 149.4l0 0-.8 .8 0 0-.1 .2c-45.5 46.6-45.2 121.3 1 167.6c22.4 22.4 52.7 34.9 84.3 34.9H184c22.1 0 40-17.9 40-40c0-.3 0-.6 0-.9h8c22.1 0 40-17.9 40-40c0-2.6-.2-5.1-.7-7.5c10.1-7.3 16.7-19.1 16.7-32.5s-6.6-25.3-16.7-32.5c.5-2.4 .7-4.9 .7-7.5c0-22.1-17.9-40-40-40H156.8l1.5-1.5c17.2-17.2 17.2-45 0-62.2s-45-17.2-62.2 0zm92.9 209.3c6.2 2 10.7 7.6 11.1 14.3c0 .3 0 .6 0 .9c0 8.8-7.2 16-16 16H119.2c-25.2 0-49.5-10-67.3-27.9c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8L113 105.3c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L122.8 152l-.5 .5-4.2 4.2-5.7 5.7c-5 5-1.5 13.7 5.7 13.7h8H132h.7H232c8.8 0 16 7.2 16 16v0l0 .2 0 0c-.1 8.8-7.2 15.8-16 15.8l-42.8 0H169.6c-2.2 0-4 1.8-4 4s1.8 4 4 4h19.6H232h16c4.6 0 8.7 1.9 11.6 5c2.7 2.9 4.4 6.8 4.4 11s-1.7 8.2-4.4 11c-2.9 3.1-7 5-11.6 5H232l-42.8 0H169.6c-2.2 0-4 1.8-4 4s1.8 4 4 4h19.6H232c8.8 0 16 7.1 16 15.9l0 0 0 .1v0c0 8.8-7.2 16-16 16H215.3 189.1 184 170c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5h14c1.7 0 3.3 .3 4.9 .8zM376 272c0-8.8 7.2-16 16-16h74.6c7.4 0 13.4-6 13.4-13.4c0-4.3-2.1-8.4-5.6-10.9L414.7 189c-7.2-5.1-8.9-15.1-3.7-22.3s15.1-8.9 22.3-3.7l73.1 52.2 3.6 2.5 3.6 2.5 1.5 1.1c2.3 1.6 5.1 2.3 7.8 2c9.3-1.1 13.2-12.4 6.6-19l-1.3-1.3-3.1-3.1-3.1-3.1-7.3-7.3c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l45.1 45.1 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9H456c-8.8 0-16-7.2-16-16c0-.3 0-.6 0-.9c.5-8.4 7.4-15.1 16-15.1h.5 19c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5h-19H456l-31.3 0H408c-8.8 0-16-7.2-16-16v-.1c0-8.8 7.2-15.9 16-15.9h48.4H476c2.2 0 4-1.8 4-4s-1.8-4-4-4H456.4 408 392c-4.6 0-8.7-1.9-11.6-5c-2.7-2.9-4.4-6.8-4.4-11z"]
};
var faSquareUser = {
  prefix: 'fal',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32c0-70.7-57.3-128-128-128H192c-70.7 0-128 57.3-128 128c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM352 448H96c0-53 43-96 96-96h64c53 0 96 43 96 96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
};
var faDownLeftAndUpRightToCenter = {
  prefix: 'fal',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", "M447 256c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L442.6 172l55.7-55.7c15.6-15.6 15.6-40.9 0-56.6L452.3 13.7C436.7-2 411.3-2 395.7 13.7L340 69.4 312.3 41.7C306.1 35.5 297.7 32 289 32c-18.2 0-33 14.8-33 33l0 159c0 17.7 14.3 32 32 32l159 0zm.7-33.7c.2 .2 .3 .4 .3 .7c0 .5-.4 1-1 1l-159 0 0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l67-67c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-67 67c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39zM65 256c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L69.4 340 13.7 395.7C-2 411.3-2 436.7 13.7 452.3l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L172 442.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33V288c0-17.7-14.3-32-32-32H65zm-1 33c0-.5 .4-1 1-1H224V447c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-67 67c-3.1 3.1-8.2 3.1-11.3 0L36.3 429.7c-3.1-3.1-3.1-8.2 0-11.3l67-67c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7z"]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faExplosion = {
  prefix: 'fal',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M543.4 20.4c2.2-7.7-1.7-15.9-9-19.1s-16-.4-20.1 6.4L342.2 294.6 303.5 140.1C301.7 133 295.3 128 288 128s-13.7 5-15.5 12.1L231.3 304.7l-108-108c-5.2-5.2-13.4-6.2-19.7-2.3s-9.1 11.6-6.8 18.7l39.8 119.5L49.2 320.2c-6.6-.9-13 2.3-16.2 8.1s-2.5 13 1.8 18.1l81 96 4.8 5.7h41.9l-22.2-26.3-54-64 71.5 10.1c5.5 .8 11-1.3 14.5-5.6s4.6-10 2.9-15.3l-26.6-79.7 80.1 80.1c4.1 4.1 10 5.6 15.6 4.1s9.9-5.9 11.3-11.5L288 210l32.5 129.9c1.6 6.3 6.8 11 13.2 11.9s12.7-2 16.1-7.6L479.3 128.3 416.6 347.6c-1.5 5.3-.2 11 3.4 15.1s9.2 6 14.6 5.1l53.5-8.9-52.4 62.9L413.8 448h41.7l4.8-5.8 80-96c4.3-5.1 4.9-12.4 1.6-18.2s-9.9-8.9-16.5-7.8l-71 11.8 89-311.7zM304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H208 368 560c8.8 0 16-7.2 16-16s-7.2-16-16-16H382.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H16zm210 0c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48H226z"]
};
var faFileLines = {
  prefix: 'fal',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faWaveSquare = {
  prefix: 'fal',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M192 64c-8.8 0-16 7.2-16 16V224c0 26.5-21.5 48-48 48H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128c8.8 0 16-7.2 16-16V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V288c0-26.5 21.5-48 48-48H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H512c-8.8 0-16 7.2-16 16V432c0 26.5-21.5 48-48 48H352c-26.5 0-48-21.5-48-48V80c0-8.8-7.2-16-16-16H192z"]
};
var faRing = {
  prefix: 'fal',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M93.1 127.3C133.9 108.2 191.5 96 256 96s122.1 12.2 162.9 31.3C461.1 147 480 171 480 192c0 14.3-8.7 30-27.6 44.8c-6.3-3.7-13-7.2-19.9-10.4C386.5 204.8 324.1 192 256 192s-130.5 12.8-176.5 34.3c-6.9 3.2-13.6 6.7-19.9 10.4C40.7 222 32 206.3 32 192c0-21 18.9-45 61.1-64.7zM480 255.3V320c0 21-18.9 45-61.1 64.7C378.1 403.8 320.5 416 256 416s-122.1-12.2-162.9-31.3C50.9 365 32 341 32 320V255.3c13.2 11.8 29.5 22 47.5 30.4C125.5 307.2 187.9 320 256 320s130.5-12.8 176.5-34.3c18-8.4 34.4-18.6 47.5-30.4zM0 192V320c0 40.8 34.8 72.8 79.5 93.7C125.5 435.2 187.9 448 256 448s130.5-12.8 176.5-34.3C477.2 392.8 512 360.8 512 320V192c0-40.8-34.8-72.8-79.5-93.7C386.5 76.8 324.1 64 256 64S125.5 76.8 79.5 98.3C34.8 119.2 0 151.2 0 192zm93.1 64.7l-1.5-.7 1.5-.7C133.9 236.2 191.5 224 256 224s122.1 12.2 162.9 31.3l1.5 .7-1.5 .7C378.1 275.8 320.5 288 256 288s-122.1-12.2-162.9-31.3z"]
};
var faBuildingUn = {
  prefix: 'fal',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256 224 160 128zM248 224h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H256v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm32 8v32h32V256H96zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDiceThree = {
  prefix: 'fal',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTirePressureWarning = {
  prefix: 'fal',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M416 0c-8.8 0-16 7.2-16 16V27.6c0 42.2 9.8 83.9 28.7 121.6l5 9.9c.2 .3 .3 .6 .5 .9c18 30.9 36.4 73.1 35.8 120.5c-.6 45.5-18.7 97.9-76.2 151.4H118.2C60.7 378.5 42.6 326.1 42 280.6c-.6-47.4 17.8-89.7 35.8-120.5c.2-.3 .3-.6 .5-.9l5-9.9C102.2 111.4 112 69.8 112 27.6V16c0-8.8-7.2-16-16-16S80 7.2 80 16V27.6c0 37.3-8.7 74-25.3 107.3l-4.7 9.5C30.7 177.5 9.3 225.5 10 281c.7 55 23.1 115.3 86 174.1c0 .3 0 .6 0 .9v40c0 8.8 7.2 16 16 16s16-7.2 16-16V464h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V456c0-.3 0-.6 0-.9c63-58.8 85.3-119.1 86-174.1c.7-55.5-20.7-103.5-39.9-136.6l-4.7-9.5C440.7 101.6 432 64.8 432 27.6V16c0-8.8-7.2-16-16-16zM256 96c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faWifiFair = {
  prefix: 'fal',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", "M139.3 298.7C185.6 252.5 249.5 224 320 224s134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0zM288 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faWifi2 = faWifiFair;
var faCalendarDays = {
  prefix: 'fal',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H312v72H416V192zm0 104H312v80H416V296zm0 112H312v72h72c17.7 0 32-14.3 32-32V408zM280 376V296H168v80H280zM168 408v72H280V408H168zm-32-32V296H32v80H136zM32 408v40c0 17.7 14.3 32 32 32h72V408H32zm0-144H136V192H32v72zm136 0H280V192H168v72zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"]
};
var faCalendarAlt = faCalendarDays;
var faMp3Player = {
  prefix: 'fal',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 336a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 112a112 112 0 1 1 0-224 112 112 0 1 1 0 224zM168 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 96v64H288V96H96zM64 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96z"]
};
var faAnchorCircleCheck = {
  prefix: 'fal',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faTally4 = {
  prefix: 'fal',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", "M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48zM384 32c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zM528 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"]
};
var faRectangleHistory = {
  prefix: 'fal',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M480 192c0-17.7-14.3-32-32-32L64 160c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256zm-32-64c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l384 0zm0-64c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0zM400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L112 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L400 0z"]
};
var faBuildingCircleArrowRight = {
  prefix: 'fal',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faVolleyball = {
  prefix: 'fal',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M415.1 413.7c-85.3 20-177.8 6.8-256.2-42.8c-13.5 21.4-24.2 44.4-31.9 68.2c36.5 25.8 81 40.9 129.1 40.9c62.2 0 118.5-25.4 159.1-66.3zm34-44c10.9-18.4 19.2-38.5 24.4-59.8c-72 12.5-148.4 1.8-217.2-35.5c-31 19.1-57.5 43.1-78.9 70.2c83.6 52.2 184.6 59.1 271.7 25zm30.1-93.4c.6-6.7 .9-13.4 .9-20.3c0-99.3-64.6-183.5-154.1-212.9c52.5 65.3 80.6 150 72.9 239.3c27.1 1.5 54.1-.6 80.3-6.2zM272.8 32.6c-5.5-.4-11.1-.6-16.8-.6c-21.5 0-42.3 3-62 8.7c46.8 56.1 75.7 127.6 77.9 205.8C302.4 263 334.5 273.7 367 279c8-95.3-29.1-184.8-94.2-246.4zM162 52.6C85.2 88.2 32 165.9 32 256c0 7.5 .4 14.9 1.1 22.1c34.4-69.3 92.8-127.1 169.6-159.7l3.7-1.6c-12-23.3-27-44.9-44.4-64.2zM45.3 332.3c11.8 32.5 30.9 61.5 55.3 85C125.7 348.8 173.2 288 239.9 247c-1-35.5-8.2-69.5-20.4-100.9l-4.4 1.9C131.4 183.5 71.8 252.2 45.3 332.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faVolleyballBall = faVolleyball;
var faSunHaze = {
  prefix: 'fal',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", "M435.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L320 65.1 229.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L185 121 77.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L129.1 256l0 0h35.4c0-3.2-.9-6.4-2.8-9.1l-54.5-79.1 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-1.9 2.7-2.8 5.9-2.8 9.1h35.4l0 0 62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L455 121 435.1 13.1zM448 256c0-70.7-57.3-128-128-128s-128 57.3-128 128v0h32v0c0-53 43-96 96-96s96 43 96 96v0h32v0zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H496zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faTextSize = {
  prefix: 'fal',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64H176l0 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H208l0-384H352v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32zM352 224c-17.7 0-32 14.3-32 32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256H464l0 192H416c-8.8 0-16 7.2-16 16s7.2 16 16 16H544c8.8 0 16-7.2 16-16s-7.2-16-16-16H496l0-192H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-17.7-14.3-32-32-32H480 352z"]
};
var faUfo = {
  prefix: 'fal',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", "M176.6 238.3c-11.7 11-11.7 11-11.6 11l0 0 0 0 .1 .1 .2 .2c.2 .2 .4 .4 .6 .6c.5 .5 1.1 1.1 1.9 1.8c1.6 1.5 4 3.4 7 5.7c6.1 4.5 15.2 10.3 27.7 16c25 11.4 63.1 22.3 117.5 22.3s92.5-10.9 117.5-22.3c12.5-5.7 21.6-11.5 27.7-16c3.1-2.3 5.4-4.2 7-5.7c.8-.7 1.5-1.3 1.9-1.8c.2-.2 .4-.4 .6-.6l.2-.2 .1-.1 0 0 0 0c0 0 0 0-11.6-11l11.7 11c2.5-2.6 4-6 4.3-9.6c.8-9.6 .8-19 .1-28.1c38.3 10.3 69.8 24.1 92.1 39.7C597.1 269.1 608 287.5 608 304c0 12.2-5.8 25.2-19.2 38.5c-13.5 13.4-33.7 26.2-60.1 37.3C476.1 401.9 402.3 416 320 416s-156.1-14.1-208.8-36.2c-26.3-11.1-46.6-23.9-60.1-37.3C37.8 329.2 32 316.2 32 304c0-16.5 10.9-34.9 36.5-52.8c22.3-15.6 53.7-29.3 92.1-39.7c-.7 9.1-.7 18.5 .1 28.1c.3 3.6 1.8 7 4.3 9.6l11.7-11zm296.3-61.5C452.3 110.2 390.3 64 320 64s-132.3 46.2-152.8 112.9C120 188.1 79.5 204.5 50.1 225C20.7 245.6 0 272.3 0 304c0 23.2 11.2 43.9 28.6 61.2c17.3 17.2 41.6 32 70.2 44.1C156.2 433.4 234.4 448 320 448s163.8-14.6 221.2-38.7c28.7-12.1 52.9-26.9 70.2-44.1c17.4-17.3 28.6-38 28.6-61.2c0-31.7-20.7-58.4-50.1-79c-29.3-20.5-69.9-36.9-117-48.1zm-21.1 50.5l.1-.1 0 0 0 0 0 0 0 0zm-3.9 3.3c-.5 .4-1.1 .8-1.7 1.3c-4.5 3.3-11.7 7.9-22 12.6C403.5 254 370 264 320 264s-83.5-10-104.2-19.4c-10.4-4.7-17.6-9.4-22-12.6c-.6-.5-1.2-.9-1.7-1.3C189.1 154.3 249.4 96 320 96s130.9 58.3 127.9 134.7zM152 312a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFork = {
  prefix: 'fal',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M401.5 28.9c7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4L268.2 86.9c-4.4 3.3-8.6 6.9-12.5 10.7l-1.6 1.6C234.8 118.5 224 144.7 224 172c0 25 9.1 49.1 25.5 67.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272.2 262.5C290.9 278.9 315 288 340 288c27.3 0 53.5-10.8 72.8-30.1l1.6-1.6c3.9-3.9 7.5-8.1 10.7-12.5l83.8-114.3c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L399.3 224.9c-2.3 3.1-4.8 6.1-7.6 8.8l-1.6 1.6C376.8 248.5 358.8 256 340 256s-36.8-7.5-50.1-20.8l-13.1-13.1C263.5 208.8 256 190.8 256 172s7.5-36.8 20.8-50.1l1.6-1.6c2.7-2.7 5.7-5.3 8.8-7.6L401.5 28.9zM442.5 60c6.6-5.8 7.3-15.9 1.5-22.6s-15.9-7.3-22.6-1.5l-128 112c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l128-112zM476 90.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5l-112 128c-5.8 6.7-5.1 16.8 1.5 22.6s16.8 5.1 22.6-1.5l112-128z"]
};
var faUtensilFork = faFork;
var faArrowsUpToLine = {
  prefix: 'fal',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", "M16 64l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16zM4.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 166.6 112 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-297.4 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112zm320 22.6c6.2 6.2 16.4 6.2 22.6 0L432 166.6 432 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-297.4 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faMobileSignal = {
  prefix: 'fal',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", "M96 32H288c17.7 0 32 14.3 32 32V284.3c10.1-8.3 20.8-15.9 32-22.7V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H224V488c0-2.7 0-5.3 .1-8H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 400H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c2.2 0 4.3-.4 6.2-1.3c1.8-8.2 4-16.4 6.6-24.3c-2.9-3.9-7.6-6.4-12.8-6.4zM496 256c-132.5 0-240 107.5-240 240c0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9 93.1-208 208-208c8.8 0 16-7.2 16-16s-7.2-16-16-16zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-144c0-8.8-7.2-16-16-16c-79.5 0-144 64.5-144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9 50.1-112 112-112c8.8 0 16-7.2 16-16z"]
};
var faBarcodeScan = {
  prefix: 'fal',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", "M64 48V192H96V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm0 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H64V464zm96 0V320H128V464c0 8.8 7.2 16 16 16s16-7.2 16-16zM128 48V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H192V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H288V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H352V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H448V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H544V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 256c0 8.8 7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 240c-8.8 0-16 7.2-16 16z"]
};
var faSortDown = {
  prefix: 'fal',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", "M154.4 445.8c1.4 1.3 3.5 2.2 5.6 2.2s4.2-.8 5.6-2.2L285.8 332.3c1.4-1.3 2.2-3.2 2.2-5.2c0-3.9-3.2-7.1-7.1-7.1H39.1c-3.9 0-7.1 3.2-7.1 7.1c0 2 .8 3.8 2.2 5.2L154.4 445.8zm-22 23.3L12.3 355.6C4.4 348.2 0 337.9 0 327.1C0 305.5 17.5 288 39.1 288H280.9c21.6 0 39.1 17.5 39.1 39.1c0 10.8-4.4 21.1-12.3 28.5L187.6 469.1c-7.4 7-17.3 10.9-27.6 10.9s-20.1-3.9-27.6-10.9z"]
};
var faSortDesc = faSortDown;
var faFolderArrowDown = {
  prefix: 'fal',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM272 208c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V208z"]
};
var faFolderDownload = faFolderArrowDown;
var faCircleMinus = {
  prefix: 'fal',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faMinusCircle = faCircleMinus;
var faFaceIcicles = {
  prefix: 'fal',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M256 32C132.3 32 32 132.3 32 256c0 .5 0 .9-.1 1.4L24.2 443.9c-.1 2.3-2 4.1-4.3 4.1c-2.2 0-4.1-1.7-4.2-3.9L.2 258.7c-.1-.9-.2-1.8-.2-2.7C0 114.6 114.6 0 256 0S512 114.6 512 256c0 .7 0 1.4-.1 2L496.2 508.1c-.1 2.2-2 3.9-4.2 3.9c-2.3 0-4.1-1.8-4.2-4.1L480 257c0-.3 0-.7 0-1C480 132.3 379.7 32 256 32zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l-9.3 90.7c-.3 3-2.8 5.3-5.9 5.3s-5.6-2.3-5.9-5.3L354.4 399c-3.4 .6-6.8 1-10.4 1H317.3l-7.1 42.7c-.5 3-3.1 5.3-6.2 5.3s-5.7-2.2-6.2-5.3L290.7 400H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 512c-80.2 0-151.8-36.9-198.7-94.6l2.2-53.7C97.6 433 171.3 480 256 480c11.6 0 23-.9 34.1-2.6c4.3 1.7 9 2.6 13.9 2.6c9.7 0 18.7-3.6 25.5-9.7l.8 7.7c.8 7.7 3.9 14.7 8.5 20.3C312.8 507.2 285 512 256 512zm151.3-49.5l4.7-45.8c15.5-15 28.8-32.2 39.4-51.2l1.7 53.8c-13.4 16.2-28.8 30.7-45.8 43.1z"]
};
var faShovel = {
  prefix: 'fal',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", "M396 34.6L352.9 77.8C342.1 88.6 336 103.2 336 118.5c0 31.8 25.8 57.5 57.5 57.5c15.3 0 29.9-6.1 40.7-16.9L477.4 116 396 34.6zM377.9 7.5C382.7 2.7 389.2 0 396 0s13.3 2.7 18.1 7.5l90.3 90.3c4.8 4.8 7.5 11.3 7.5 18.1s-2.7 13.3-7.5 18.1l-47.6 47.6c-16.8 16.8-39.6 26.2-63.3 26.2c-18.9 0-36.5-5.9-51-15.9L235.3 299.3l62.1 62.1c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32V386.3c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l62.1 62.1L319.9 169.4c-10-14.5-15.9-32-15.9-51c0-23.7 9.4-46.5 26.2-63.3L377.9 7.5zM32 480h93.7c33.9 0 66.5-13.5 90.5-37.5L274.7 384 128 237.3 69.5 295.8c-24 24-37.5 56.6-37.5 90.5V480z"]
};
var faDoorOpen = {
  prefix: 'fal',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", "M288 480H96V86.2c0-7.5 5.1-13.9 12.4-15.6l166-38.3c.8-.2 1.7-.3 2.5-.3C283 32 288 37 288 43.1V480zm32 0V43.1C320 19.3 300.7 0 276.9 0c-3.3 0-6.5 .4-9.7 1.1l-166 38.3C79.4 44.4 64 63.8 64 86.2V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 80 96 288h32V480zM232 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM464 64H352V96H464c8.8 0 16 7.2 16 16V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V112c0-26.5-21.5-48-48-48z"]
};
var faFilms = {
  prefix: 'fal',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M224 272V224H448v48 80H224V272zm0-80V144 64H448v80 48H224zM464 32H448 224 208 192 160c-35.3 0-64 28.7-64 64v32 16 16 96 16 16 32c0 35.3 28.7 64 64 64h32 16 16H448h16 16 32c35.3 0 64-28.7 64-64V288 272 256 160 144 128 96c0-35.3-28.7-64-64-64H480 464zM160 64h32v64H128V96c0-17.7 14.3-32 32-32zm-32 96h64v48 48H128V160zm0 160V288h64v64H160c-17.7 0-32-14.3-32-32zm384 32H480V288h64v32c0 17.7-14.3 32-32 32zm32-96H480V208 160h64v96zm0-128H480V64h32c17.7 0 32 14.3 32 32v32zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faRightFromBracket = {
  prefix: 'fal',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M479.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L347.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16l-120 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L479.2 254.2zM512 256c0-9.5-3.9-18.6-10.8-25.1L369.2 106.5C362 99.8 352.5 96 342.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3-104 0c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.4-3.8 26.5-10.5L501.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z"]
};
var faSignOutAlt = faRightFromBracket;
var faFaceGlasses = {
  prefix: 'fal',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M256 480C132.3 480 32 379.7 32 256c0-22.2 3.2-43.7 9.3-64h7.3c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V200c0-2.7-.2-5.4-.6-8h33.1c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V200c0-2.7-.2-5.4-.6-8h7.3c6 20.3 9.3 41.8 9.3 64c0 123.7-100.3 224-224 224zM224 160.8c-10.2-10.4-24.3-16.8-40-16.8H104c-15.3 0-29.1 6.1-39.2 16H53.6C89.5 84.3 166.6 32 256 32s166.5 52.3 202.4 128H447.2c-10.1-9.9-23.9-16-39.2-16H328c-15.7 0-29.8 6.4-40 16.8V160H224v.8zM256 0C148.6 0 56.6 66.2 18.6 160H16c-8.8 0-16 7.2-16 16c0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c5.1-2.7 8.5-8 8.5-14.2c0-8.8-7.2-16-16-16h-2.6C455.4 66.2 363.4 0 256 0zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 200c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V200zM104 176h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24zm88.4 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faNfc = {
  prefix: 'fal',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 96V384c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32v82.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128H352V384H96V128l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-17.7 0-32 14.3-32 32zM224 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faAtom = {
  prefix: 'fal',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", "M322 421.3c-.3 .7-.6 1.3-.9 1.9C301.4 464.7 278 480 256 480s-45.4-15.3-65.1-56.7c-.3-.6-.6-1.3-.9-1.9c21.1-5 43.3-12.6 66-22.6c22.7 9.9 44.9 17.5 66 22.6zM217.1 379.8c-13.4 4.8-26.4 8.6-38.7 11.4c-4-12.6-7.4-26.3-10.1-40.9c8.4 5.7 17.1 11.2 26 16.6c7.6 4.6 15.2 8.9 22.8 13zm116.4 11.4c-12.3-2.8-25.3-6.5-38.7-11.4c7.6-4.1 15.2-8.4 22.8-13c8.9-5.4 17.6-10.9 26-16.6c-2.8 14.6-6.2 28.3-10.1 40.9zm-32.3-51.8c-15.3 9.2-30.4 17.2-45.2 24.2c-14.8-7-29.9-15.1-45.2-24.2c-17.5-10.5-33.7-21.5-48.5-32.8c-1.5-16.2-2.3-33.1-2.3-50.6s.8-34.4 2.3-50.6c14.8-11.3 31.1-22.3 48.5-32.8c15.3-9.2 30.4-17.2 45.2-24.2c14.8 7 29.9 15.1 45.2 24.2c17.5 10.5 33.7 21.5 48.5 32.8c1.5 16.2 2.3 33.1 2.3 50.6s-.8 34.4-2.3 50.6c-14.8 11.3-31.1 22.3-48.5 32.8zm64.3 56.7c6.6-22.1 11.5-46.6 14.6-72.7c16.7-13.5 31.7-27.5 44.7-41.8l.8 1.2c25 37.7 26.8 66.1 16 85.6c-10.4 18.7-33.6 31-76.1 27.7zm18.1-118.2c.3-7.2 .4-14.5 .4-21.9s-.1-14.7-.4-21.9c7.7 7.3 14.8 14.6 21.3 21.9c-6.5 7.3-13.6 14.7-21.3 21.9zm86 106.1c20.7-37.1 9.4-82.8-23.6-128c33-45.2 44.3-90.9 23.6-128c-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-28-240.4c10.8 19.5 9.1 47.9-16 85.6l-.8 1.2c-13-14.2-28-28.2-44.7-41.8c-3.1-26.1-8-50.6-14.6-72.7c42.6-3.3 65.7 8.9 76.1 27.7zM321.1 88.7c.3 .6 .6 1.3 .9 1.9c-21.1 5-43.3 12.6-66 22.6c-22.7-9.9-44.9-17.5-66-22.6c.3-.7 .6-1.3 .9-1.9C210.6 47.3 234 32 256 32s45.4 15.3 65.1 56.7zm12.5 32.1c4 12.6 7.4 26.3 10.1 40.9c-8.4-5.7-17.1-11.2-26-16.5c-7.6-4.6-15.2-8.9-22.8-13c13.4-4.8 26.4-8.6 38.7-11.3zm-155.1 0c12.3 2.8 25.3 6.5 38.7 11.3c-7.6 4.1-15.2 8.4-22.8 13c-8.9 5.4-17.6 10.9-26 16.5c2.8-14.6 6.2-28.3 10.1-40.9zm-32-4.9c-6.6 22.1-11.5 46.6-14.6 72.7c-16.7 13.5-31.7 27.5-44.7 41.8l-.8-1.2c-25-37.7-26.8-66.1-16-85.6c10.4-18.7 33.6-31 76.1-27.7zM86.3 282.8l.8-1.2c13 14.2 28 28.2 44.7 41.8c3.1 26.1 8 50.6 14.6 72.7c-42.6 3.3-65.7-8.9-76.1-27.7c-10.8-19.5-9.1-47.9 16-85.6zm42.1-48.8c-.3 7.2-.4 14.5-.4 21.9s.1 14.7 .4 21.9c-7.7-7.3-14.8-14.6-21.3-21.9c6.5-7.3 13.6-14.7 21.3-21.9zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSoap = {
  prefix: 'fal',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM96 192H225.3c1.9 11.5 5.9 22.3 11.5 32H96c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H403.2c5.6-9.7 9.6-20.5 11.5-32H416c53 0 96 43 96 96V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V288c0-53 43-96 96-96zm64 80H320h32c44.2 0 80 35.8 80 80s-35.8 80-80 80H160c-44.2 0-80-35.8-80-80s35.8-80 80-80zm-48 80c0 26.5 21.5 48 48 48H352c26.5 0 48-21.5 48-48s-21.5-48-48-48H160c-26.5 0-48 21.5-48 48zM400 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM352 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faIcons = {
  prefix: 'fal',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", "M473.7 4.1C493.5 .2 512 15.3 512 35.5V168h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V35.5L352 61.1V200h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V61.1c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM105.4 54.6l-6-6c-9-9-21.8-13.1-34.4-11c-19 3.2-33 19.6-33 38.9v2.9c0 11.9 4.9 23.2 13.6 31.4L128 187.7l82.4-76.9c8.7-8.1 13.6-19.5 13.6-31.4V76.5c0-19.3-13.9-35.8-33-38.9c-12.6-2.1-25.4 2-34.4 11l-6 6L128 77.3 105.4 54.6zM59.7 6C82.5 2.3 105.7 9.7 122 26l0 0 6 6 6-6C150.3 9.7 173.5 2.3 196.3 6C230.7 11.8 256 41.6 256 76.5v2.9c0 20.8-8.6 40.6-23.8 54.8l-90.4 84.3c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L23.8 134.2C8.6 120 0 100.2 0 79.5V76.5C0 41.6 25.3 11.8 59.7 6zM72 320H48c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H216c-12.1 0-23.2-6.8-28.6-17.7L180.2 288H107.8l-7.2 14.3C95.2 313.2 84.1 320 72 320zm136.8-46.3L216 288h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H72l7.2-14.3c5.4-10.8 16.5-17.7 28.6-17.7h72.4c12.1 0 23.2 6.8 28.6 17.7zM112 392a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM475.3 283.3L390.6 368H480c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L441.4 400H352c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHeartMusicCameraBolt = faIcons;
var faMicrophoneLinesSlash = {
  prefix: 'fal',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM395.5 397.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128V236.5l-32-25.3V256c0 83 63.1 151.2 144 159.2V480H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V415.2c21.3-2.1 41.4-8.4 59.5-18.1zM256 123.9V96c0-35.3 28.7-64 64-64s64 28.7 64 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H336c-8.3 0-15.2 6.4-15.9 14.5L342.2 192H384v32h-1.2L416 250.2V240 176 112 96c0-53-43-96-96-96s-96 43-96 96v2.7l32 25.3zM446.7 274.5l28.1 22.2c3.4-13 5.2-26.6 5.2-40.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 6.3-.5 12.4-1.3 18.5z"]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faClosedCaptioningSlash = {
  prefix: 'fal',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480l-40.5-32H96c-17.7 0-32-14.3-32-32V135.4L32 110.2V416c0 35.3 28.7 64 64 64H500.4zM139.6 32l40.5 32H544c17.7 0 32 14.3 32 32V376.6l32 25.3V96c0-35.3-28.7-64-64-64H139.6zM373.5 216.7c11.7-15 30-24.7 50.5-24.7c17.4 0 33.2 7 44.8 18.3c6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6c-17.3-17-41-27.4-67.2-27.4c-30.7 0-58.1 14.4-75.6 36.9l25.1 19.8zM151.1 204.2C141.6 219.2 136 236.9 136 256c0 53 43 96 96 96c26.2 0 49.9-10.5 67.2-27.4c.7-.6 1.2-1.3 1.8-2l-25.2-19.9C264.3 313.4 249 320 232 320c-35.3 0-64-28.7-64-64c0-11.6 3.1-22.4 8.4-31.8l-25.3-20z"]
};
var faCalculatorSimple = {
  prefix: 'fal',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M256 0c8.8 0 16 7.2 16 16V240H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V16c0-8.8 7.2-16 16-16zm88 96h40V56 48c0-8.8 7.2-16 16-16s16 7.2 16 16v8V96h40 8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8H416v40 8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8V128H344h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8zM53.1 341.1c6.2-6.2 16.4-6.2 22.6 0L112 377.4l36.3-36.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l36.3 36.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6 75.7 458.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400 53.1 363.7c-6.2-6.2-6.2-16.4 0-22.6zM48 96H176c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM336 352H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCalculatorAlt = faCalculatorSimple;
var faBridgeCircleCheck = {
  prefix: 'fal',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", "M48 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h80H256 384 512h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H528V64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 384 256 128 48zM496 64v64H400V64h96zM368 64v64H272V64h96zM240 64v64H144V64h96zM48 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c35.3 0 64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V336c0-35.3 28.7-64 64-64c9 0 17.5 1.8 25.2 5.2c5.6-9.3 12.1-18.1 19.3-26.2C351.2 244 336.1 240 320 240c-53 0-96 43-96 96v96c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-53-43-96-96-96H48zm448 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faSlidersUp = {
  prefix: 'fal',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M96 0c8.8 0 16 7.2 16 16V81.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V238.4C43.5 231 16 198.7 16 160s27.5-71 64-78.4V16C80 7.2 87.2 0 96 0zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V430.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V273.6c36.5 7.4 64 39.7 64 78.4zM464 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V270.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16v97.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4z"]
};
var faSlidersV = faSlidersUp;
var faLocationMinus = {
  prefix: 'fal',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM96 176H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMapMarkerMinus = faLocationMinus;
var faPumpMedical = {
  prefix: 'fal',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", "M176 0h32c26.5 0 48 21.5 48 48h76.1c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L354.7 89.4c-6-6-14.1-9.4-22.6-9.4H256v48H224V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v80H128V48c0-26.5 21.5-48 48-48zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480H285.2c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3H117.4c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM208 288v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V288c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFingerprint = {
  prefix: 'fal',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M32 256C32 132.3 132.3 32 256 32c70.3 0 133 32.4 174.1 83c5.6 6.9 15.6 7.9 22.5 2.4s7.9-15.6 2.4-22.5C408.1 37 336.3 0 256 0C114.6 0 0 114.6 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm470.8-68.3c-2.4-8.5-11.2-13.5-19.7-11.2s-13.5 11.2-11.2 19.7c5.2 19 8.1 39 8.1 59.7v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-23.6-3.2-46.5-9.2-68.3zM256 80c-22.8 0-44.6 4.3-64.6 12.2c-9.7 3.8-12 16.1-5.2 24.1c4.8 5.6 12.8 7.2 19.7 4.6c15.6-5.8 32.5-9 50.1-9c79.5 0 144 64.5 144 144v24.9c0 28.3-1.8 56.6-5.5 84.6c-1.3 9.7 6.2 18.5 16 18.5c7.9 0 14.6-5.8 15.6-13.6c3.9-29.6 5.8-59.5 5.8-89.5V256c0-97.2-78.8-176-176-176zM145.1 142.1c-6-7-16.8-7.6-22.8-.5C95.9 172.3 80 212.3 80 256v24.9c0 27.8-3.4 55.4-10.2 82.3c-2.6 10.4 5 20.8 15.7 20.8c7 0 13.2-4.6 15-11.4c7.7-29.9 11.6-60.7 11.6-91.7V256c0-34.7 12.3-66.5 32.7-91.4c5.4-6.5 5.9-16.1 .3-22.5zM256 160c-53 0-96 43-96 96v24.9c0 38.6-5.4 77-15.9 114c-3 10.4 4.7 21.1 15.5 21.1c6.9 0 13-4.5 14.9-11.1c11.6-40.2 17.5-82 17.5-124V256c0-35.3 28.7-64 64-64s64 28.7 64 64v24.9c0 38.8-3.9 77.5-11.7 115.4c-2.1 10.1 5.5 19.7 15.8 19.7c7.4 0 13.9-5.1 15.4-12.4c8.3-40.3 12.5-81.4 12.5-122.7V256c0-53-43-96-96-96zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v24.9c0 60.9-11.2 121.2-33.1 178.1l-5.9 15.3c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l5.9-15.3C260.1 410 272 345.7 272 280.9V256z"]
};
var faSkiBoot = {
  prefix: 'fal',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M383.7 19.1c1.7-8.7-4-17.1-12.7-18.8s-17.1 4-18.8 12.7L348.6 32H130.3c-22.9 0-42.7 16.2-47.1 38.7L7.8 454.7C2 484.4 24.7 512 54.9 512H464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V403.3c0-17.8-9.9-34.2-25.6-42.5L330 295.4 383.7 19.1zM239.4 64h103L317.5 192H256c-8.8 0-16 7.2-16 16s7.2 16 16 16h55.3l-12.4 64H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c1.2 0 2.3-.1 3.4-.4l132.1 69.5c5.3 2.8 8.5 8.2 8.5 14.2V480H54.9c-10.1 0-17.6-9.2-15.7-19.1l32-163.1c55-23.2 134.1-82.9 168.2-233.8zm-32.9 0C178.6 180.4 122.7 233.7 79 258.4L114.6 76.9c1.5-7.5 8.1-12.9 15.7-12.9h76.2z"]
};
var faStandardDefinition = {
  prefix: 'fal',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 176V336c0 8.8 7.2 16 16 16h64c53 0 96-43 96-96s-43-96-96-96H320c-8.8 0-16 7.2-16 16zm32 16h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H336V192zm-176.4 2.4c10.1-3.3 24.9-3.6 43.9-1.1c5.8 .8 23.7 3.8 29.2 5c8.6 2 17.2-3.4 19.2-12s-3.4-17.2-12-19.2c-6.8-1.6-25.8-4.7-32-5.5c-20.5-2.7-41-3.1-58 2.4c-18.2 5.9-32.3 18.7-36.6 40.1c-.1 .3-.1 .6-.1 .9c-1.6 11.1-.2 21.3 4.6 30.2c4.7 8.8 11.9 15 19.4 19.5c13.9 8.3 32.4 12.6 47.8 16.2l1.4 .3c17.3 4 31 7.4 40.1 12.8c4.2 2.5 6.4 4.9 7.6 7.1c1.1 2 2 5.1 1.2 10.6c-.7 4.6-2.3 7.5-4.2 9.5c-2 2.2-5.2 4.2-10.1 5.8c-10.3 3.3-25.6 3.6-44.5 1c-8.8-1.2-24-5.7-36.3-9.2l0 0c-2.7-.8-5.3-1.5-7.6-2.2c-8.5-2.4-17.4 2.5-19.8 11s2.5 17.4 11 19.8c1.8 .5 3.9 1.1 6.2 1.8l0 0c12.1 3.5 30.6 9 42 10.6l.1 0c20.4 2.7 41.4 3.2 58.5-2.2c8.8-2.8 17.2-7.3 23.8-14.4c6.8-7.2 10.9-16.3 12.5-26.7c1.6-11.1 .2-21.3-4.6-30.2c-4.7-8.8-11.9-15-19.4-19.5c-13.9-8.3-32.4-12.6-47.8-16.2l0 0-1.4-.3c-17.3-4-31-7.4-40.1-12.8c-4.2-2.5-6.4-4.9-7.6-7.1c-1-1.9-1.9-4.9-1.2-10.1c1.8-8.2 6.3-12.8 15.1-15.6z"]
};
var faRectangleSd = faStandardDefinition;
var faH1 = {
  prefix: 'fal',
  iconName: 'h1',
  icon: [576, 512, [], "f313", "M496 80c0-5.7-3-10.9-7.9-13.8s-10.9-2.9-15.9-.2l-72 40c-7.7 4.3-10.5 14-6.2 21.8s14 10.5 21.8 6.2L464 107.2V416H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V80zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80z"]
};
var faHandPointRight = {
  prefix: 'fal',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M456 128c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0-40 0 0-32c0-5.5-.6-10.8-1.6-16L456 128zM240 176l0 0 0 32 0 0 0 24c0 13.2-10.7 24-24 24l0 0c-13.3 0-24-10.7-24-24l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 15.7 6.4 29.8 16.8 40c-10.4 10.2-16.8 24.3-16.8 40c0 13.8 5 26.4 13.2 36.1C160.3 358.4 152 374.2 152 392c0 8.6 1.9 16.7 5.4 24C87.9 414.6 32 357.8 32 288l0-64C32 153.3 89.3 96 160 96l32 0c26.5 0 48 21.5 48 48l0 32zm32 32l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-31.9 0c0 0 0 0-.1 0l-13.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24zm90.6 0l93.4 0c30.9 0 56-25.1 56-56s-25.1-56-56-56L256 96c-14.6-19.4-37.8-32-64-32l-32 0C71.6 64 0 135.6 0 224l0 64c0 88.4 71.6 160 160 160l48 0 32 0 24 0c30.9 0 56-25.1 56-56c0-12.1-3.8-23.3-10.4-32.5C325.5 349.6 336 332 336 312c0-9.7-2.5-18.8-6.8-26.7C351.7 278 368 256.9 368 232c0-8.6-1.9-16.7-5.4-24zM240 288l40 0c13.2 0 24 10.8 24 24c0 13.3-10.7 24-24 24l-16 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l0 0 24 0zm0 128l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0z"]
};
var faMagnifyingGlassLocation = {
  prefix: 'fal',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm26.2-178.4c-8.3 14.5-17.7 28.2-26.2 39.6c-8.5-11.4-17.9-25.1-26.2-39.6c-13.7-24-21.8-45.9-21.8-61.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 15.7-8.1 37.6-21.8 61.6zm-14.8 77c22.1-27 68.6-89.8 68.6-138.6c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0zM232 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faMessageBot = {
  prefix: 'fal',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M224 384c17.7 0 32 14.3 32 32v48l98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4H480c17.7 0 32-14.3 32-32V192 64c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V192 352c0 17.7 14.3 32 32 32h64zM544 64V176h36.3c5.5-9.6 15.9-16 27.7-16c17.7 0 32 14.3 32 32s-14.3 32-32 32c-11.8 0-22.2-6.4-27.7-16H544V352c0 35.3-28.7 64-64 64H373.3L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V448 416H192 160c-35.3 0-64-28.7-64-64V208H59.7c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16H96V64c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64zM208 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H208zm-48 16c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V144zm56 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faForwardStep = {
  prefix: 'fal',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", "M256 80c0-8.8 7.2-16 16-16s16 7.2 16 16V241.9v28.2V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V296.2L77.4 441.8c-5 4-11.2 6.2-17.6 6.2C44.4 448 32 435.6 32 420.2V91.8C32 76.4 44.4 64 59.8 64c6.4 0 12.6 2.2 17.6 6.2L256 215.8V80zM64 100.6V411.4L254.7 256 64 100.6z"]
};
var faStepForward = faForwardStep;
var faFaceSmileBeam = {
  prefix: 'fal',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm-7.6-131c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faSmileBeam = faFaceSmileBeam;
var faLightCeiling = {
  prefix: 'fal',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M256 0c8.8 0 16 7.2 16 16V160.5c123.3 7.6 223 102.5 238 223.6c2.2 17.5-12.4 31.9-30 31.9H32C14.3 416-.2 401.6 2 384.1C17 262.9 116.7 168.1 240 160.5V16c0-8.8 7.2-16 16-16zM34.3 384H477.7C462.2 275.5 368.8 192 256 192S49.8 275.5 34.3 384zM256 512c-38.7 0-71-27.5-78.4-64h33.1c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32h33.1c-7.4 36.5-39.7 64-78.4 64z"]
};
var faMessageExclamation = {
  prefix: 'fal',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM256 80c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommentAltExclamation = faMessageExclamation;
var faBowlScoop = {
  prefix: 'fal',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M416 224H384c0-88.4-71.6-160-160-160S64 135.6 64 224H32C32 118 118 32 224 32s192 86 192 192zm29.9 65.9c-8.5 67.9-63.4 119.9-130.5 125.6c-4.1 .3-8.2 .5-12.4 .5H274.2l26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2H128c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L147.2 448l26.7-32H145c-4.2 0-8.3-.2-12.4-.5c-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6 .8-9.1 3.9-12.6s7.4-5.4 12-5.4H432c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96h28.8 32 36.3 32H303c55.8 0 102.9-41 110.9-96H34.1zM198.4 436.5L162.2 480H285.8l-36.3-43.5L224 405.8l-25.6 30.7z"]
};
var faBowlShavedIce = faBowlScoop;
var faSquareX = {
  prefix: 'fal',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm140.1 37.6L224 231.4l83.9-97.8c5.8-6.7 15.9-7.5 22.6-1.7s7.5 15.9 1.7 22.6L245.1 256l87.1 101.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L224 280.6l-83.9 97.8c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.8-1.7-22.6L202.9 256 115.9 154.4c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7z"]
};
var faUtilityPoleDouble = {
  prefix: 'fal',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96h80V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h15.8c.1 0 .2 0 .3 0H480V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96c0 17.7-14.3 32-32 32H437.5L304 231.8V288h80V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48h15.8c.1 0 .2 0 .3 0H480V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 17.7-14.3 32-32 32H437.5L304 423.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V416.2c0-.1 0-.2 0-.3V320H240v95.9c0 .1 0 .2 0 .3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V423.8L74.5 320H32c-17.7 0-32-14.3-32-32V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48H79.9c.1 0 .2 0 .3 0H96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v48h80V231.8L74.5 128H32C14.3 128 0 113.7 0 96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96H79.9c.1 0 .2 0 .3 0H96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h80V32zm-81.4 96L208 191.3V128H126.6zM240 224.2V288h32V224.2c0-.1 0-.2 0-.3V128H240v95.9c0 .1 0 .2 0 .3zm64-32.9L385.4 128H304v63.3zM126.6 320L208 383.3V320H126.6zM304 383.3L385.4 320H304v63.3zM272 32l-32 0V96h32V32z"]
};
var faFlagCheckered = {
  prefix: 'fal',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V67.8 80 384v20.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V396.2l101.8-27.8c36.4-9.9 75.1-6.1 108.8 10.8c48.7 24.4 105.7 26 155.8 4.6l30.2-12.9c11.8-5 19.4-16.6 19.4-29.4V59.3c0-24.4-26.4-39.8-47.6-27.6l-15.8 9c-40.6 23.2-90.2 24.6-132.1 3.7c-37.9-18.9-81.4-23.2-122.2-12.1L32 59.1V16zm0 76.2L128 66v67.5L32 154.4V92.2zm0 94.9l96-20.9v71.3L32 258.4V187.2zm128-27.8l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3v70.7l-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3V159.3zm160 26.9c17.5 1.3 35.2-.1 52.5-4l43.5-10v71.2L365.3 255c-14.9 3.4-30.2 4.5-45.3 3.1V186.2zm-32 98.6v77.3c-10.6-2.7-21-6.5-31-11.5c-30.2-15.1-63.7-21.6-97-19V263.3l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3zm32 81.8V290.2c17.5 1.3 35.2-.1 52.5-4l43.5-10v65.3l-30.2 12.9c-21 9-43.5 13.1-65.8 12.3zm0-212.6v-63c27.8-.8 55.5-8.4 80.4-22.6L416 59.6v79.7L365.3 151c-14.9 3.4-30.2 4.5-45.3 3.1zM288 89v58.6l-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3V59.1c26.7-3 53.9 1.8 78.2 13.9c15.9 8 32.7 13.3 49.8 16zM32 291.2l96-20.9v66.6c-.9 .2-1.7 .4-2.6 .7L32 363.1V291.2z"]
};
var faChevronsUp = {
  prefix: 'fal',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M267.3 52.7c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 86.6 436.7 267.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192zm192 384l-192-192c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6 436.7 459.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faChevronDoubleUp = faChevronsUp;
var faFootball = {
  prefix: 'fal',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M456.2 55.4c-48.9-8.2-92.4-10.8-130.9-8.7L464.8 186.2c3.4-47.1-.8-92.9-8.6-130.8zM220 67.1C161.1 89 120.4 126.1 93.3 170.3c-21.6 35.2-34.6 74.9-41.3 115L227.3 460.7c.2 .2 .3 .3 .5 .5c23.5-3.6 44.8-9.1 64.2-16.3c58.9-21.9 99.6-58.9 126.7-103.2c21.6-35.2 34.6-74.9 41.3-115L284.7 51.3c-.2-.2-.3-.3-.5-.5C260.7 54.4 239.4 60 220 67.1zM47.2 325.8c-3.4 47.1 .8 92.9 8.6 130.8c48.9 8.2 92.4 10.8 130.9 8.7L47.2 325.8zM208.9 37.1C274.4 12.8 357.6 6.5 461.5 23.8c13 2.2 23.4 12.1 26.1 25.1c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3c-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6c30.6-50 76.8-92 142.9-116.5zm82.4 119.5l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faFootballBall = faFootball;
var faUserVneck = {
  prefix: 'fal',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm128-96A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM185.6 418.1l-57.2-76.3C72.6 358.8 32 410.7 32 472l0 8H416v-8c0-61.3-40.6-113.2-96.4-130.1l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.1z"]
};
var faSchoolCircleExclamation = {
  prefix: 'fal',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V266.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32v96h32 32 8.2c10 12.1 21.7 22.9 34.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faCrop = {
  prefix: 'fal',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M416 118.6l91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L393.4 96 160 96v32l201.4 0L128 361.4V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V368c0 26.5 21.5 48 48 48H352V384H150.6L384 150.6 384 496c0 8.8 7.2 16 16 16s16-7.2 16-16V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H416l0-265.4z"]
};
var faAnglesDown = {
  prefix: 'fal',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M235.3 459.3c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 425.4 372.7 276.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-160 160zm160-352l-160 160c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 372.7 84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faAngleDoubleDown = faAnglesDown;
var faUsersRectangle = {
  prefix: 'fal',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", "M80 0C35.8 0 0 35.8 0 80V432c0 44.2 35.8 80 80 80H560c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80zM32 80c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H320 280zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"]
};
var faPeopleRoof = {
  prefix: 'fal',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M328.5 2.5l304 192c7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5L320 34.9 24.5 221.5c-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1l304-192c5.2-3.3 11.9-3.3 17.1 0zM336 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208h48V289.5c-3.8-1-7.7-1.5-11.8-1.5H307.8c-4 0-8 .5-11.8 1.5V400zm122.4-15.6L376 315.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V315.5l-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V411.5L45.6 480.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 270.4 280 256 307.8 256h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V411.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 385.5V480h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H131.8c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H483.8c-4 0-8 .5-11.8 1.5V480z"]
};
var faSquareArrowRight = {
  prefix: 'fal',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM347.3 267.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 272 112 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l185.4 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6z"]
};
var faArrowSquareRight = faSquareArrowRight;
var faLocationPlus = {
  prefix: 'fal',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM176 288V208H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V96c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faMapMarkerPlus = faLocationPlus;
var faLightbulbExclamationOn = {
  prefix: 'fal',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M55.2 1.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm544 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16zM119.2 318.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm416-28.6l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm-96.8-31.6C454.5 234.8 464 206.6 464 176c0-79.5-64.5-144-144-144s-144 64.5-144 144c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19l0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H370.5c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM320 480c20.9 0 38.7-13.4 45.3-32H274.7c6.6 18.6 24.4 32 45.3 32zm-80-53.3c0-5.9 4.8-10.7 10.7-10.7H389.3c5.9 0 10.7 4.8 10.7 10.7V432c0 44.2-35.8 80-80 80s-80-35.8-80-80v-5.3zM336 112V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPeopleLine = {
  prefix: 'fal',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", "M336 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208h48V177.5c-3.8-1-7.7-1.5-11.8-1.5H307.8c-4 0-8 .5-11.8 1.5V288zm122.4-15.6L376 203.5V288c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V203.5l-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 299.5V368c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V299.5L45.6 368.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 254.4 104 240 131.8 240h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 158.4 280 144 307.8 144h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 299.5V368c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V299.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM16 448H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM144 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 273.5V368h48V273.5c-3.8-1-7.7-1.5-11.8-1.5H131.8c-4 0-8 .5-11.8 1.5zM512 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192h48V273.5c-3.8-1-7.7-1.5-11.8-1.5H483.8c-4 0-8 .5-11.8 1.5V368z"]
};
var faBeerMugEmpty = {
  prefix: 'fal',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", "M352 64H64V416c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V360.4c0-.2 0-.5 0-.7V64zm32 306.5V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h64c35.3 0 64 28.7 64 64V262.1c0 31.8-18.8 60.6-47.9 73.3l-80.1 35zM384 128V335.5l67.2-29.4c17.5-7.6 28.8-24.9 28.8-44V160c0-17.7-14.3-32-32-32H384zm-240 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]
};
var faBeer = faBeerMugEmpty;
var faCrateEmpty = {
  prefix: 'fal',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M480 384v72c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V384H480zm0-32H32V280c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v72zm32 0V280c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v72 16 16 72c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V384 368 352zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faDiagramPredecessor = {
  prefix: 'fal',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M480 352c0-17.7-14.3-32-32-32L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64zm32 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64zM256 96c0-17.7-14.3-32-32-32l-32 0L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64zm23.4-32c5.4 9.4 8.6 20.3 8.6 32l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0 32 0 144 0c35.3 0 64 28.7 64 64l0 89.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L400 185.4 400 96c0-17.7-14.3-32-32-32l-88.6 0zM96 112l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTransporter = {
  prefix: 'fal',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", "M464 0c8.8 0 16 7.2 16 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zM48 64c8.8 0 16 7.2 16 16V96H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V80c0-8.8 7.2-16 16-16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM128 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm64-302.9c-.5 .6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9V304v96 16H288V400 320H224v80 16H192V400 304 193.1zm32-16.8V288h64V176.2c-1.6-.2-3.1-.2-4.7-.2H228.7c-1.6 0-3.2 .1-4.7 .2z"]
};
var faCalendarCircleUser = {
  prefix: 'fal',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM492 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8H403.8c-21.8 0-42.2 9.6-56.1 25.8C330.5 422.1 320 396.2 320 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faArrowUpLong = {
  prefix: 'fal',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M203.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-144 144c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L324.7 171.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-144-144z"]
};
var faLongArrowUp = faArrowUpLong;
var faPersonCarryBox = {
  prefix: 'fal',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM60 176c7 0 13.8 1.5 20 4.2V319.4L39.1 292.2c-4.5-3-7.1-8-7.1-13.3V204c0-15.5 12.5-28 28-28zm52 38.5l37.8 58.8c5.9 9.2 16 14.7 26.9 14.7H224h16H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32V256H176.7l-47.8-74.4C113.9 158.2 87.9 144 60 144c-33.1 0-60 26.9-60 60v74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8V214.5zM224 256V128H352V256H240 224z"]
};
var faPersonCarry = faPersonCarryBox;
var faFireFlameSimple = {
  prefix: 'fal',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4C125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM192 160c9.3 0 18.3 3.7 24.9 10.3l8.9 8.9c28.8 28.8 52.1 62.7 68.6 99.9l1.9 4.3c5 11.3 7.6 23.7 7.6 36C304 381.2 254 432 192 432s-112-50.8-112-112.5c0-12.4 2.6-24.7 7.6-36l1.9-4.3c16.5-37.2 39.8-71.1 68.6-99.9l8.9-8.9c6.6-6.6 15.6-10.3 24.9-10.3zm-2.3 32.9l-8.9 8.9c-26 26-47.1 56.6-62 90.3l-1.9 4.3c-3.2 7.2-4.9 15.1-4.9 23c0 44.3 35.9 80.5 80 80.5s80-36.2 80-80.5c0-7.9-1.7-15.8-4.9-23l-1.9-4.3c-15-33.6-36-64.3-62-90.3l-8.9-8.9c-.6-.6-1.4-.9-2.3-.9s-1.7 .4-2.3 .9z"]
};
var faBurn = faFireFlameSimple;
var faPerson = {
  prefix: 'fal',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L224 202.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128z"]
};
var faMale = faPerson;
var faLaptop = {
  prefix: 'fal',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M512 64H128c-17.7 0-32 14.3-32 32V352H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H544V96c0-17.7-14.3-32-32-32zM76.8 448H563.2c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z"]
};
var faFileCsv = {
  prefix: 'fal',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
};
var faMenorah = {
  prefix: 'fal',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M48 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C16 7.2 23.2 0 32 0s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM32 128c8.8 0 16 7.2 16 16l0 160c0 26.5 21.5 48 48 48h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h64l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16l0 208h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352h16c26.5 0 48-21.5 48-48l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 44.2-35.8 80-80 80H336v96H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 144c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V384H96c-44.2 0-80-35.8-80-80l0-160c0-8.8 7.2-16 16-16z"]
};
var faUnion = {
  prefix: 'fal',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M16 32c8.8 0 16 7.2 16 16V288c0 88.4 71.6 160 160 160s160-71.6 160-160V48c0-8.8 7.2-16 16-16s16 7.2 16 16V288c0 106-86 192-192 192S0 394 0 288V48c0-8.8 7.2-16 16-16z"]
};
var faChevronsLeft = {
  prefix: 'fal',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 267.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-192 192zm384-192l-192 192c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 459.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faChevronDoubleLeft = faChevronsLeft;
var faCircleHeart = {
  prefix: 'fal',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 164.9c-29.4 29.8-29.4 78.2 0 108L233.5 376.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 272.9c29.4-29.8 29.4-78.2 0-108c-27.8-28.2-71.9-29.7-101.5-4.6c-5.8 4.9-11 10.4-16.3 15.9c-2.1 2.2-4.2 4.5-6.4 6.6c-2.1-2.2-4.3-4.4-6.4-6.6c-5.2-5.5-10.5-11-16.3-15.9c-29.6-25.1-73.7-23.6-101.5 4.6zm83.6 22.5l29.1 29.6c6.3 6.4 16.5 6.4 22.8 0l29.1-29.6c16.8-17.1 44-17.1 60.8 0c17.1 17.4 17.1 45.7 0 63.1L256 353.3 154.7 250.4c-17.1-17.4-17.1-45.7 0-63.1c16.8-17.1 44-17.1 60.8 0z"]
};
var faHeartCircle = faCircleHeart;
var faTruckPlane = {
  prefix: 'fal',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M189.2 13.3C198.8 5.7 210.6 0 224 0c26.9 0 47.1 21.6 59.2 41.8c10.4 17.3 17.7 38 20 56.3c-12.3 3.3-23.1 10.2-31.2 19.4v-7.8c0-13.6-5.9-34.2-16.2-51.4C244.9 40.2 233.1 32 224 32c-4.1 0-9 1.7-14.8 6.3c-5.8 4.6-11.5 11.5-16.7 20C182.1 75.6 176 96.2 176 109.7v80c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9v56.2l123.6-35.3c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8l0 57.1c0 5-2.4 9.8-6.4 12.8L112 440v39.4l107.6-30.7c2.9-.8 5.9-.8 8.8 0l38.8 11.1c5.4 7.8 12.5 14.4 20.8 19.2v20l-64-18.3L118.3 510.8l0 0c-2.7 .8-5.5 1.2-8.3 1.2c-16.6 0-30-13.4-30-30V440c0-10.1 4.7-19.6 12.8-25.6L144 376l0-27.9L40.8 377.6C20.3 383.4 0 368 0 346.8V290.6c0-17.2 9.2-33.1 24.2-41.7L144 180.4V109.7c0-20.7 8.4-46.9 21.2-67.9c6.5-10.7 14.5-20.8 24-28.4zM592 160H336c-8.8 0-16 7.2-16 16V312.6c4.3-2.5 8.9-4.5 13.8-5.9l3.5-11.8 12.4-41.2c8.1-27.1 33-45.6 61.3-45.6H517c28.3 0 53.2 18.5 61.3 45.6l12.4 41.2 3.5 11.8c4.9 1.4 9.5 3.4 13.8 5.9V176c0-8.8-7.2-16-16-16zm48 208v48c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V464H352v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V461.3c-18.6-6.6-32-24.4-32-45.3V368 176c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V368zm-32 48V368c0-17.7-14.3-32-32-32H560 368 352c-17.7 0-32 14.3-32 32v48c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16zM560 304l-9.6-32-2.8-9.2C543.6 249.3 531.1 240 517 240H411c-14.1 0-26.6 9.3-30.6 22.8l-2.8 9.2L368 304h33.4H526.6 560zM376 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faRecordVinyl = {
  prefix: 'fal',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBringForward = {
  prefix: 'fal',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 480H448c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H384V160h64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384h32v64c0 17.7 14.3 32 32 32zM64 320H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V288c0 17.7 14.3 32 32 32zm224 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64zm-32-96V96H96V256H256zm32 0c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32V256z"]
};
var faSquareP = {
  prefix: 'fal',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h88c48.6 0 88 39.4 88 88s-39.4 88-88 88H160v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288 144c0-8.8 7.2-16 16-16zm88 144c30.9 0 56-25.1 56-56s-25.1-56-56-56H160V272h72z"]
};
var faFaceGrinStars = {
  prefix: 'fal',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM160 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1 .8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1L160 257.4l39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.5-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2l8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5l-14.5-13.7 19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18zM352 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1 .8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1L352 257.4l39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.4-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2l8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5l-14.5-13.7 19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18z"]
};
var faGrinStars = faFaceGrinStars;
var faSigma = {
  prefix: 'fal',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M1.3 41.6C3.9 35.8 9.6 32 16 32H344c22.1 0 40 17.9 40 40v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c0-4.4-3.6-8-8-8H52.5L219.8 245.1c5.7 6.1 5.7 15.6 0 21.7L52.5 448H344c4.4 0 8-3.6 8-8V368c0-8.8 7.2-16 16-16s16 7.2 16 16v72c0 22.1-17.9 40-40 40H16c-6.4 0-12.1-3.8-14.7-9.6s-1.4-12.6 2.9-17.3L186.2 256 4.2 58.9C-.1 54.2-1.2 47.4 1.3 41.6z"]
};
var faCameraMovie = {
  prefix: 'fal',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M144 0c40.8 0 76.4 21.8 96 54.3C259.6 21.8 295.2 0 336 0c61.9 0 112 50.1 112 112s-50.1 112-112 112H144C82.1 224 32 173.9 32 112S82.1 0 144 0zM64 112c0 44.2 35.8 80 80 80H336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-39.6 0-72.5 28.8-78.9 66.6c-1.3 7.7-8 13.4-15.8 13.4h-2.7c-7.8 0-14.5-5.6-15.8-13.4C216.5 60.8 183.6 32 144 32c-44.2 0-80 35.8-80 80zm80-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 288h-8c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H136zm0-32H352c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V320c0-11.7 3.1-22.6 8.6-32H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128h8zM448 440.9l85.4 38.4c1 .4 2 .7 3.1 .7c4.2 0 7.5-3.4 7.5-7.5V291.9c0-3.2-2.9-5.6-6-5.1c-.4 .1-.9 .2-1.3 .4L448 327.1V292l75.6-34c2.9-1.3 6-2.2 9.1-2.8c22.6-3.8 43.3 13.7 43.3 36.6V472.5c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L448 476V440.9z"]
};
var faBong = {
  prefix: 'fal',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M128 208.5c0 17.4-9.3 32.4-22.5 40.9C79 266.4 58 291 45.3 320H338.7c-12.7-29-33.7-53.6-60.2-70.6c-13.2-8.5-22.5-23.5-22.5-40.9V32H128V208.5zM35.2 352c-2.1 10.3-3.2 21-3.2 32c0 32.9 9.9 63.4 26.9 88.8c2.4 3.5 8 7.2 17.2 7.2H307.9c9.2 0 14.9-3.7 17.2-7.2c17-25.4 26.9-55.9 26.9-88.8c0-11-1.1-21.7-3.2-32H35.2zM96 208.5V32H80c-8.8 0-16-7.2-16-16S71.2 0 80 0h32H272h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H288V208.5c0 5.7 3.1 10.9 7.9 14c13.4 8.6 25.7 18.9 36.5 30.5l45-45-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l32 32 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 230.6l-47.7 47.7C372.3 308.6 384 345 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14z"]
};
var faClarinet = {
  prefix: 'fal',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M224 112c0-8.8 7.2-16 16-16h32 96 96 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v32h44.6c7.9 0 15.6-2.3 22.2-6.7L602.7 116c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136V376c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7H113.4c-8.6 0-17.1-1.3-25.3-3.7L17.1 327C7 323.9 0 314.6 0 304V208c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7H256V128H240c-8.8 0-16-7.2-16-16zm224 16H384v32h64V128zm-96 0H288v32h64V128zm256 22.9l-43.4 29c-11.8 7.9-25.7 12.1-39.9 12.1H113.4c-5.5 0-10.9 .8-16.1 2.4L32 214V298l65.3 19.6c5.2 1.6 10.6 2.4 16.1 2.4H524.6c14.2 0 28.1 4.2 39.9 12.1l43.4 29V150.9zM272 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTruckFlatbed = {
  prefix: 'fal',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", "M408 96c-13.3 0-24 10.7-24 24V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H408zm8 160H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V256zm154.9-32H416V128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224zM96 416a64 64 0 1 1 128 0A64 64 0 1 1 96 416zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSpaghettiMonsterFlying = {
  prefix: 'fal',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm42 80.3c13.5-11.7 22-29 22-48.3c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c4.6 0 9.1-.5 13.4-1.4L219 153.7c-24.9 14.5-43.8 33.5-59.2 52.1c-7.6 9.1-14.4 18.2-20.6 26.4l-.5 .7c-6.4 8.5-12 15.9-17.4 22.2c-11.3 13-18.7 17-25.2 17c-5 0-8.7-1.8-12.7-5.5c-4.5-4.4-8.5-10.5-13.8-18.9l-.5-.7c-4.7-7.5-10.6-16.9-18.3-24.3C42.3 214.2 31 208 16 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c5 0 8.7 1.8 12.7 5.5c4.5 4.4 8.5 10.5 13.8 18.9l.5 .7c4.7 7.5 10.6 16.9 18.3 24.3C69.7 297.8 81 304 96 304c19.4 0 34.1-11.4 45.7-23.9l1 1.5c4.4 6.5 10.2 14.3 17.2 22.6c-3 8.5-5.6 17-8 24.9l0 0-1.3 4.3c-3.4 11.2-6.5 20.8-10.2 28.8c-3.7 8-7.5 13.3-11.7 16.7c-3.8 3-8.8 5.2-16.7 5.2c-11 0-21-5.3-36.8-13.8l-.6-.3c-15-8-34.2-17.9-58.5-17.9c-8.8 0-16 7.2-16 16s7.2 16 16 16c15.6 0 28.5 6.1 43.5 14.1l3.1 1.7C75.9 407 92.7 416 112 416c14.6 0 26.8-4.2 36.7-12.2c9.6-7.6 16-17.9 20.8-28.2c4.8-10.3 8.4-21.9 11.8-32.9l1.3-4.4c.9-2.8 1.7-5.6 2.6-8.4c19.3 17 44.1 33.4 74.6 43.2l-1 3.4 0 0c-5.4 18.4-13 43.8-24.3 65.6c-13 25-27.2 37.9-42.4 37.9c-8.8 0-16 7.2-16 16s7.2 16 16 16c35.1 0 57.3-29.1 70.8-55.1c12.8-24.7 21.2-53.1 26.6-71.2c.5-1.8 1-3.5 1.5-5.1l.1-.3c9.2 1.4 18.9 2.1 29 2.1s19.7-.7 29-2.1l.1 .3c.5 1.6 1 3.3 1.5 5.1l0 0c5.3 18.1 13.8 46.5 26.6 71.2c13.5 26 35.8 55.1 70.8 55.1c8.8 0 16-7.2 16-16s-7.2-16-16-16c-15.2 0-29.4-12.9-42.4-37.9c-11.3-21.8-18.9-47.2-24.3-65.6l0 0 0 0-1-3.4c30.5-9.8 55.3-26.2 74.6-43.2c.9 2.8 1.7 5.6 2.6 8.4l1.3 4.4c3.4 11 7 22.6 11.8 32.9c4.8 10.3 11.2 20.6 20.8 28.2c9.9 7.9 22.1 12.2 36.7 12.2c19.3 0 36.1-9 49.4-16.2l3.1-1.7c15-8 27.8-14.1 43.5-14.1c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.4 0-43.5 9.9-58.5 17.9l-.6 .3C549 378.7 539 384 528 384c-7.9 0-12.9-2.1-16.7-5.2c-4.2-3.3-8-8.6-11.7-16.7c-3.7-8.1-6.8-17.7-10.2-28.8l-1.3-4.3c-2.4-7.9-5-16.4-8-24.9c7.1-8.3 12.8-16.1 17.2-22.6l1-1.5C509.9 292.6 524.6 304 544 304c15 0 26.3-6.2 34.8-14.5c7.7-7.4 13.6-16.8 18.3-24.3l0 0 0 0 .5-.7c5.3-8.4 9.2-14.6 13.8-18.9c3.9-3.8 7.6-5.5 12.7-5.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-15 0-26.3 6.2-34.8 14.5c-7.7 7.4-13.6 16.8-18.3 24.3l0 0 0 0-.5 .7c-5.3 8.4-9.2 14.6-13.8 18.9c-3.9 3.8-7.6 5.5-12.7 5.5c-6.5 0-13.9-4-25.2-17c-5.4-6.2-11-13.6-17.4-22.2l-.5-.7c-6.2-8.2-13-17.3-20.6-26.4c-15.5-18.6-34.4-37.5-59.2-52.1l13.5-27.1c4.3 .9 8.8 1.4 13.4 1.4c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 19.3 8.5 36.5 22 48.3L392.1 140c-20.4-7.5-44.2-12-72.1-12s-51.7 4.5-72.1 12L234 112.3zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm4.6 259.8c-.9 .8-1.7 1.7-2.5 2.6c-2.2 2.4-4.6 4.8-7.1 7.2c-27.3 26.3-67.9 52-123 52s-95.7-25.6-123-52c-2.5-2.4-4.8-4.8-7.1-7.2c-.7-1-1.5-1.8-2.5-2.6c-8.9-9.7-15.9-19-20.9-26.4c-2.3-3.4-4.2-6.4-5.7-8.9l3.4-4.5 .3-.4c6.3-8.4 12.7-16.9 19.8-25.4C212.5 192.3 250.4 160 320 160s107.5 32.3 135.7 66.2c7.1 8.5 13.5 17 19.8 25.4l.3 .4 3.4 4.5c-1.5 2.5-3.4 5.5-5.7 8.9c-5 7.4-12 16.7-20.9 26.4z"]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faArrowDownUpAcrossLine = {
  prefix: 'fal',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M148.7 507.3c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4V272H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L400 54.6V240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144V457.4L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96zM144 192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V192zM432 320H400V464c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"]
};
var faLeafHeart = {
  prefix: 'fal',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M272 128l104 0c37.4 0 71.5-14.3 97.1-37.7c4.5 21.1 6.9 43.3 6.9 66.3c0 149-98.2 258.9-207.2 259.4l-.8 0h0c-79.5 0-144-64.5-144-144c0-79.5 64.5-144 144-144zM463.2 54.3C442.6 79.8 411.2 96 376 96L272 96C174.8 96 96 174.8 96 272c0 2.5 .1 4.9 .2 7.4c-.1-2.4-.2-4.9-.2-7.4c0-4 .1-8 .4-12C41.2 295.7 4 356.9 1.4 427.1L0 463.4c-.3 8.8 6.6 16.3 15.4 16.6s16.3-6.6 16.6-15.4l1.3-36.3C35.3 375.8 60 329.4 98 298.4l0 0C110.7 383.1 183.8 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-33.9-4.8-66.5-13.5-96.8l-.4-1.5c-1.1-3.6-2.2-7.2-3.4-10.8s-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1c-1.4 2.7-3 5.3-4.6 7.8c-2 3.1-4.1 6.1-6.4 8.9l-.6 .8zM97.7 296.6c.1 .6 .2 1.2 .3 1.7l-.3-1.7zm124-53.8c0-11.9 9.6-21.5 21.5-21.5h1.5c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5h1.5c11.9 0 21.5 9.6 21.5 21.5c0 5.8-2.3 11.4-6.5 15.4L288 316.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5z"]
};
var faHouseBuilding = {
  prefix: 'fal',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M320 32H576c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H414.4c-2.4 11.8-7.4 22.7-14.4 32H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64V95.3l32 29.3V64c0-17.7 14.3-32 32-32zM496 208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H496zm0 32h32v32H496V240zM464 368v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V368c0-17.7-14.3-32-32-32H496c-17.7 0-32 14.3-32 32zm64 0v32H496V368h32zM368 80c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H368zm0 32h32v32H368V112zm96 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H496c-17.7 0-32 14.3-32 32zm64 0v32H496V112h32zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V284.2zM0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2V448zM224 288v64H160V288h64zm-64-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H160z"]
};
var faCheeseSwiss = {
  prefix: 'fal',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M480 240.2V256H413.3c-6.6-18.6-24.4-32-45.3-32s-38.7 13.4-45.3 32H32c0-9.3 4.6-18 12.4-23.1l148.7-99.2c-.7 3.3-1.1 6.7-1.1 10.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.6-17-43.2-39.4-47.2l44.1-29.4L274.9 40.7l17.8 26.6c3.3-2.2 7.2-3.4 11.1-3.4C401.1 64 480 142.9 480 240.2zM322.7 288c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32H480V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288H322.7zm-19-256c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256 240.2C512 125.2 418.8 32 303.8 32zM160 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16-240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM352 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSpoon = {
  prefix: 'fal',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M274.7 205.3l32 32c12.5 12.5 28.7 18.7 45.1 18.7c27.5 0 59.3-17 85.5-48.5C463.3 176.4 480 135.5 480 96c0-35.3-28.7-64-64-64c-39.5 0-80.4 16.7-111.5 42.6C273 100.9 256 132.7 256 160.1c0 16.4 6.3 32.6 18.7 45.1zm-22.6 22.6c-18.7-18.7-28.1-43.2-28.1-67.7C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-24.5 0-49-9.4-67.7-28.1l-4.7-4.7L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L256.8 232.6l-4.7-4.7z"]
};
var faUtensilSpoon = faSpoon;
var faJarWheat = {
  prefix: 'fal',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M48 16c0 8.8 7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H64C55.2 0 48 7.2 48 16zM256 96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H256zM64 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm80 384c0 8.8 7.2 16 16 16s16-7.2 16-16V432h8c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16H224c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32H72c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h8v16zm34.7-48c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM96 368c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96zm82.7-176c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM264 144c0-8.8-7.2-16-16-16H224c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32l-24 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h24 24c44.2 0 80-35.8 80-80zM96 160c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96zm82.7 136c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM264 248c0-8.8-7.2-16-16-16H224c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32H72c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80h24 24c44.2 0 80-35.8 80-80zM96 264c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96z"]
};
var faEnvelopesBulk = {
  prefix: 'fal',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", "M112 32H400c8.8 0 16 7.2 16 16V64h32V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48V192H96V48c0-8.8 7.2-16 16-16zM224 144c0-8.8 7.2-16 16-16H592c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H416v32H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v48h32V144zM48 256H336c8.8 0 16 7.2 16 16v5L196.9 391.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6L32 277v-5c0-8.8 7.2-16 16-16zM32 464V316.8L168 417.6c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9L352 316.8V464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16zM48 224c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm448-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H496zm16 64V192h32v32H512z"]
};
var faMailBulk = faEnvelopesBulk;
var faFileCircleExclamation = {
  prefix: 'fal',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBowArrow = {
  prefix: 'fal',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16L397.4 92 153.7 335.7l-59.9-15c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-15-59.9L420 114.6l40.7 40.7c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-49.9 92.3L400.8 50.1 476 36l-14.1 75.2zm-81.2 88C403 234.1 416 275.5 416 320c0 47.9-15 92.3-40.7 128.7L253.3 326.6l-22.6 22.6L388.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13-13C429.5 429.2 448 376.8 448 320c0-53.3-16.3-102.9-44.2-143.9l-23.1 23.1zM4.7 123.3L162.7 281.4l22.6-22.6L63.3 136.7C99.7 111 144.1 96 192 96c44.5 0 85.9 13 120.8 35.3l23.1-23.1C294.9 80.3 245.3 64 192 64C135.2 64 82.8 82.5 40.4 113.7l-13-13c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM99.3 436c-2.9-11.5-11.8-20.4-23.3-23.3l-36.3-9.1 50.8-50.8 54.9 13.7 13.7 54.9-50.8 50.8L99.3 436z"]
};
var faCartXmark = {
  prefix: 'fal',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM379.3 91.3L342.6 128l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 150.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128 260.7 91.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L320 105.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHexagonXmark = {
  prefix: 'fal',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm137-59.3c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesHexagon = faHexagonXmark;
var faXmarkHexagon = faHexagonXmark;
var faCircleH = {
  prefix: 'fal',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96l-160 0V144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96H336v96c0 8.8 7.2 16 16 16s16-7.2 16-16V256 144z"]
};
var faHospitalSymbol = faCircleH;
var faMerge = {
  prefix: 'fal',
  iconName: 'merge',
  icon: [512, 512, [], "e526", "M0 80c0-8.8 7.2-16 16-16H96h47.7c15.4 0 29.8 7.3 38.8 19.8L291.4 233.4c3 4.1 7.8 6.6 12.9 6.6H457.4l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 272H304.3c-5.1 0-9.9 2.4-12.9 6.6L182.5 428.2c-9 12.4-23.5 19.8-38.8 19.8H96 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96h47.7c5.1 0 9.9-2.4 12.9-6.6L265.5 259.8c1-1.3 2-2.6 3-3.8c-1.1-1.2-2.1-2.5-3-3.8L156.6 102.6c-3-4.1-7.8-6.6-12.9-6.6H96 16C7.2 96 0 88.8 0 80z"]
};
var faPager = {
  prefix: 'fal',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M448 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm0 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM96 160H416v96H96l0-96zm-32 0v96c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"]
};
var faCartMinus = {
  prefix: 'fal',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM256 112H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAddressBook = {
  prefix: 'fal',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M96 32C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM272 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H208zM512 80v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 192c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm16 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faContactBook = faAddressBook;
var faPanFrying = {
  prefix: 'fal',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416c53 0 101.6-18.4 140-49.1l77 87c14.7 16.6 35.8 26.1 57.9 26.1c42.5 0 77.2-34.5 77.2-77c0-26.7-13.8-51.5-36.6-65.5L433.3 304c9.5-24.8 14.7-51.8 14.7-80C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448zm240.9 16.7l-77.5-87.6c12.4-13.3 23.3-28 32.2-44l103 63.5c13.3 8.2 21.4 22.7 21.4 38.3c0 24.8-20.2 45-45.2 45c-13 0-25.4-5.6-33.9-15.3zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM152.6 102.3c-14.5 13.9-22.6 32.1-24.3 50.7c-2.1 23.5-8.7 52.4-19.4 71C82.4 269.9 98.1 328.6 144 355.1s104.6 10.8 131.1-35.1c2.9-5.1 8.9-10.9 16.9-15.8c7.9-4.9 16.4-8 23.1-9c12.8-1.8 25.4-6.7 36.5-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.3-27.2-25.5-44.4-29.8c-8.7-2.2-20-7.1-31-13.6s-20.9-13.8-27.1-20.3c-30.6-31.9-81.3-32.9-113.1-2.2zm90 24.4c8.9 9.3 21.4 18.4 34.1 25.8s26.7 13.8 39.2 17c10.3 2.6 19.8 8.7 26.6 17.9c15.8 21.3 11.3 51.4-10 67.1c-6.7 5-14.2 7.9-21.9 9c-11.9 1.7-24.6 6.7-35.4 13.4c-10.8 6.7-21.4 15.9-27.8 27.1c-17.7 30.6-56.8 41.1-87.4 23.4s-41.1-56.8-23.4-87.4c14-24.3 21.3-58.4 23.6-84.2c1-11.2 5.8-22 14.5-30.4c19.1-18.4 49.5-17.8 67.9 1.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
var faGrid = {
  prefix: 'fal',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 224c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 192H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 64h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
};
var faGrid3 = faGrid;
var faFootballHelmet = {
  prefix: 'fal',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M456 198.7L277.1 221.1c-30.3 3.8-53.1 29.6-53.1 60.1c0 9.4 2.2 18.7 6.4 27.1l38.2 76.4c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 17.7-14.3 32-32 32h-2.9c-4.3 0-8.6-.9-12.6-2.6l-93.9-40.2c-8-3.4-16.5-5.2-25.2-5.2H92c-27.6-35.3-44-79.7-44-128C48 141.1 141.1 48 256 48c95 0 175.2 63.7 200 150.7zm6.4 31.4c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9h14c4.3 0 8.6 .9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2H240c35.3 0 64-28.7 64-64v-.9c0-9.9-2.3-19.7-6.8-28.6L288 352h39.7l9.6 50.9c10.1 54 57.2 93.1 112.1 93.1h17c25.2 0 45.6-20.4 45.6-45.6V400 368c0-26.5-21.5-48-48-48H354.3l-14-74.5 122.2-15.3zm-154 19.2L321.7 320H272l-13-26c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l27.4-3.4zM200 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 48H366.3l-6-32H464c8.8 0 16 7.2 16 16v16zM374.7 416H480v34.4c0 7.5-6.1 13.6-13.6 13.6h-17c-32.7 0-61.6-19.3-74.7-48z"]
};
var faHandLove = {
  prefix: 'fal',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M184 32c13.3 0 24 10.7 24 24V200l0 0v96c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56V232 176 120c0-13.3 10.7-24 24-24s24 10.7 24 24V336c0 79.5-64.5 144-144 144h-8.5c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V56c0-13.3 10.7-24 24-24zM288 296c0 13.3-10.7 24-24 24s-24-10.7-24-24V199.9c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24l0 8v24 64zm32-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V232zm48-50.6c-7.3-3.5-15.4-5.4-24-5.4c-9.7 0-18.8 2.5-26.7 6.8C310 160.3 288.9 144 264 144c-8.6 0-16.7 1.9-24 5.4L240 80l0 0V56c0-30.9-25.1-56-56-56s-56 25.1-56 56V288.8L95.6 256.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.2 439.4C166.7 485.9 229.8 512 295.5 512H304c97.2 0 176-78.8 176-176V120c0-30.9-25.1-56-56-56s-56 25.1-56 56v56 5.4z"]
};
var faTrees = {
  prefix: 'fal',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M167.6 11.9c12.8-15 35.9-15 48.7 0L318.5 131.8c4.1 4.8 6.4 11 6.4 17.4c0 14.8-12 26.8-26.8 26.8H286.1l61.4 67.4c4.5 4.9 7 11.3 7 17.9c0 14.7-11.9 26.6-26.6 26.6H312.7l65.6 84.4C382 377.2 384 383 384 389c0 14.9-12.1 27-27 27H235.1 208v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H148.9 27c-14.9 0-27-12.1-27-27c0-6 2-11.8 5.7-16.6L71.3 288H56.2c-14.7 0-26.6-11.9-26.6-26.6c0-6.6 2.5-13 7-17.9L97.9 176H85.9c-14.8 0-26.8-12-26.8-26.8c0-6.4 2.3-12.5 6.4-17.4L167.6 11.9zM235.1 384H346.8L267.4 281.8c-3.7-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9h35.7L238 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5h37L192 32.7 97.1 144h37c6.3 0 12.1 3.7 14.6 9.5s1.5 12.6-2.8 17.2L68.3 256H104c6.1 0 11.7 3.5 14.4 9s2 12-1.7 16.9L37.2 384H148.9 176V208c0-8.8 7.2-16 16-16s16 7.2 16 16V384h27.1zM423.5 12.6c12.7-15.4 36.2-15.6 49.1-.4l102 119.7c4.1 4.8 6.4 11 6.4 17.4c0 14.8-12 26.8-26.8 26.8H542.1l61.4 67.4c4.5 4.9 7 11.3 7 17.9c0 14.7-11.9 26.6-26.6 26.6H568.7l65.6 84.4C638 377.2 640 383 640 389c0 14.9-12.1 27-27 27H464v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400 208c0-8.8 7.2-16 16-16s16 7.2 16 16V384H602.8L523.4 281.8c-3.8-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9h35.7L494 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5h37L448.2 32.9 388 106.2c-5.6 6.8-15.7 7.8-22.5 2.2s-7.8-15.7-2.2-22.5l60.2-73.2z"]
};
var faStrikethrough = {
  prefix: 'fal',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M129.7 132c4.8-25.9 22-44.8 49.7-56.2c28.3-11.7 67-15 111-8.4c13.8 2.1 56.1 10 69.7 13.5c8.6 2.2 17.3-3 19.5-11.5s-3-17.3-11.5-19.5c-15.1-3.9-58.6-12-72.9-14.1c-47.7-7.2-92.7-4.1-127.9 10.5c-35.7 14.7-62.1 41.6-69.1 80.6c-.1 .3-.1 .6-.1 .9c-2.8 22.9 .6 42.7 9.5 59.7c8.8 16.8 22.4 29.6 37.9 39.8c18.7 12.2 41.6 21.2 65.2 28.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H319.4c-18.1-6.6-37-12.1-55.3-17.3l-1.2-.3c-39-11.2-74.8-21.6-100.2-38.1c-12.5-8.1-21.5-17.2-27.1-27.8c-5.4-10.4-8.1-23.3-6.1-40.5zM379 336.8c4.7 10.8 6.6 24.5 3.4 42.7c-4.7 26.1-21.9 45.2-49.8 56.6c-28.3 11.7-66.9 15-110.9 8.4c-22.1-3.5-59.5-15.7-88-25.1l0 0 0 0c-6.1-2-11.8-3.9-16.8-5.5c-8.4-2.7-17.4 1.9-20.1 10.4s1.9 17.4 10.4 20.1c4.4 1.4 9.6 3.1 15.3 5c28.3 9.3 69.3 22.8 94.4 26.7l.1 0c47.7 7.2 92.7 4.1 127.9-10.5c35.7-14.7 62.1-41.6 69.1-80.6c4.2-23.3 2.2-43.7-5.6-61.3c-.6-1.3-1.2-2.7-1.9-4H367.7c4.9 5.2 8.6 10.8 11.3 16.8z"]
};
var faPage = {
  prefix: 'fal',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M64 480H320c17.7 0 32-14.3 32-32V138.5c0-8.5-3.4-16.6-9.4-22.6L268.1 41.4c-6-6-14.1-9.4-22.6-9.4H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zm256 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64z"]
};
var faK = {
  prefix: 'fal',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V336 464c0 8.8 7.2 16 16 16s16-7.2 16-16V342.6l94.1-94.1 165 225c5.2 7.1 15.2 8.7 22.4 3.4s8.7-15.2 3.4-22.4L149 225.6 315.3 59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 297.4V48z"]
};
var faDiagramPrevious = {
  prefix: 'fal',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", "M480 352c0-17.7-14.3-32-32-32l-176 0H240L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32V352zM272 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64H240V182.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 182.6V288zM448 32c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32l384 0z"]
};
var faGaugeMin = {
  prefix: 'fal',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-35.3-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTachometerAltSlowest = faGaugeMin;
var faFolderGrid = {
  prefix: 'fal',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zm48 272V272h32v32H112zM80 264v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24zm160 40V272h32v32H240zm-32-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24zm160 8h32v32H368V272zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H360z"]
};
var faEggplant = {
  prefix: 'fal',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M482.7 51.9C491.1 64.5 496 79.7 496 96v96c0 17.7-14.3 32-32 32h-4c-24.3 0-44-19.7-44-44V170c0-1.1-.9-2-2-2c-38.7 0-70-31.3-70-70c0-1.1-.9-2-2-2H332c-24.3 0-44-19.7-44-44V48c0-17.7 14.3-32 32-32h96c16.3 0 31.5 4.9 44.1 13.3L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L482.7 51.9zM416 48H320v4c0 6.6 5.4 12 12 12h10c18.8 0 34 15.2 34 34c0 21 17 38 38 38c18.8 0 34 15.2 34 34v10c0 6.6 5.4 12 12 12h4V96c0-26.5-21.5-48-48-48zM169.9 139.3c32.9-16 66-32 94.7-52.2c5 9.6 12 18 20.5 24.7c-11.3 8.1-23.1 15.4-34.8 22.2c-21.2 12.2-45.5 24-68.4 35.1l0 0 0 0 0 0 0 0c-14.1 6.8-27.6 13.4-39.5 19.7c-34 17.8-61.7 35.7-80.9 58.3c-18.2 21.5-30 48.8-29.4 88.5C33.1 413.9 98 479.9 176.4 480c66.7 .1 127.2-45.1 176.8-113.6c27.4-37.8 49.9-80.7 66.7-121.9c9 5.6 19.2 9.3 30.1 10.8C400.8 377 304.5 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z"]
};
var faRam = {
  prefix: 'fal',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 56c0-30.9 25.1-56 56-56s56 25.1 56 56V66.8c7.7-1.8 15.7-2.8 24-2.8c14.2 0 27.7 2.8 40 8V56c0-30.9 25.1-56 56-56s56 25.1 56 56v8c0 8.8-7.2 16-16 16s-16-7.2-16-16V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V93c11 10.5 19.7 23.5 25.2 37.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 173.9V240c0 53-43 96-96 96H464c-53 0-96-43-96-96V179.2l-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9c7.3-23.9 22.9-44.2 43.5-57.5V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 8.8-7.2 16-16 16s-16-7.2-16-16V56zM304.2 69.9l.2-.2c1.6 11.3 7.9 21 16.9 27.2c-13.2 8.3-30.7 6-41.2-6c-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4C182.4 90.6 175.6 88 168 88c-15 0-27.7 10.4-31.1 24.3c-3.9 16.1-19.6 26.6-36 24c-1.6-.2-3.2-.4-5-.4c-17.7 0-32 14.3-32 32c0 2.7 .3 5.3 .9 7.8c3.5 14.2-3 29-16 36c-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36c-.6 2.5-.9 5.1-.9 7.8c0 17.7 14.3 32 32 32c1.7 0 3.4-.1 5-.4c16.4-2.5 32 7.9 36 24c3.4 14 16.1 24.3 31.1 24.3c7.6 0 14.4-2.6 19.9-6.9c13.4-10.6 32.8-8.9 44 4c5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4c5.5 4.3 12.3 6.9 19.9 6.9c15 0 27.7-10.4 31.1-24.3c1.4-5.8 4.3-10.8 8.2-14.8c6.2 5.2 13 9.9 20.1 14l20.1 5L397.6 475.6C392.2 497 373 512 351 512H336c-26.5 0-48-21.5-48-48V423.4c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V464c0 26.5-21.5 48-48 48H161c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9zM344 424c-8.5 0-16.6-1.7-24-4.7V464c0 8.8 7.2 16 16 16h15c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zM131.7 412.7l13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1h15c8.8 0 16-7.2 16-16V419.3c-7.4 3-15.5 4.7-24 4.7c-13.5 0-26-4.2-36.3-11.3zM544 168c0-39.8-32.2-72-72-72c-36.1 0-66 26.6-71.2 61.2l.1 .1-.1 .1c-.5 3.5-.8 7-.8 10.6v72c0 35.3 28.7 64 64 64h16c35.3 0 64-28.7 64-64V168zm-96 8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faLandmarkFlag = {
  prefix: 'fal',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M272 32V64h64V32H272zm80 64H272v32H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V96 64 24 16c0-8.8 7.2-16 16-16h8 8 80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16zM48 368c0-8.8 7.2-16 16-16V192H96V352h80V192h32V352h96V192h32V352h80V192h32V352c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM24 432c0-8.8 7.2-16 16-16H472c8.8 0 16 7.2 16 16s-7.2 16-16 16H40c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faLips = {
  prefix: 'fal',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M268.2 126.4c11.6 9.2 28.1 9.2 39.7 0C331.2 107.9 354.3 96 376 96c14.3 0 30.9 5.5 49.4 15.7c18.4 10.1 36 23.4 52.6 36.3c18 14 34.5 29 46.5 42.5l23.9-21.3-23.9 21.3C538.3 206 544 216.3 544 224c0 11.4-5.7 25.3-14.7 43.5C519.5 287 505 310 486 332c-38 44-94 84-166 84H256c-72 0-128-40-166-84c-23.7-27.5-43.6-58.4-54.3-90.6C33.3 234 32 228 32 224c0-7.7 5.7-18 19.5-33.5L28.1 169.7l23.4 20.8C63.5 177 80 162 98 148c16.5-12.8 34.2-26.1 52.6-36.3C169.1 101.5 185.7 96 200 96c21.7 0 44.8 11.9 68.2 30.4zM576 224c0-21.1-14.2-39.7-27.6-54.8c-13.6-15.3-31.7-31.7-50.8-46.5C464.5 97 420 64 376 64c-32.7 0-63 17.5-88 37.3C263 81.5 232.7 64 200 64c-44 0-88.5 33-121.6 58.7c-19.1 14.8-37.1 31.2-50.8 46.5C14.2 184.3 0 202.9 0 224c0 9.2 2.6 19.1 5.3 27.5c12.4 37.3 34.9 71.9 60.4 101.4C107.2 400.9 171.3 448 256 448h64c84.7 0 148.8-47.1 190.2-95.1c20.9-24.2 36.8-49.4 47.7-71.1C566.6 264.3 576 244 576 224zm-219.7-7.1c2-.6 3.8-.9 5.4-.9c38.1 .4 66.1 5.6 84.1 11.1c4.7 1.4 8.5 2.9 11.7 4.2c-.4 .4-.9 .9-1.3 1.3c-7.5 7.4-19 16.9-34.3 26.4c-30.5 18.8-75.6 37-133.9 37s-103.4-18.2-133.9-37c-15.3-9.4-26.8-19-34.3-26.4c-.5-.5-.9-.9-1.3-1.3c3.2-1.3 7-2.7 11.7-4.2c18-5.5 46-10.7 84.1-11.1c1.6 0 3.4 .2 5.4 .9c11.6 3.6 44 13.1 68.3 13.1s56.7-9.5 68.3-13.1zm5.7-32.9c-5.4-.1-10.5 .8-15.3 2.3c-12.1 3.8-40 11.7-58.8 11.7s-46.7-7.9-58.8-11.7c-4.7-1.5-9.9-2.4-15.3-2.3c-40.7 .5-71.7 5.9-93.1 12.5c-10.6 3.3-19.2 6.9-25.5 10.6c-3.1 1.8-6.2 3.9-8.7 6.4C85 215.1 80 220.2 80 228c0 3.1 .9 5.5 1.3 6.6c.5 1.3 1.1 2.5 1.6 3.4c1 1.8 2.3 3.6 3.6 5.4c2.7 3.5 6.4 7.7 11 12.1c9.2 9 22.6 20 39.9 30.7C172 307.6 222.8 328 288 328s116-20.4 150.7-41.8c17.3-10.7 30.7-21.7 39.9-30.7c4.6-4.5 8.3-8.6 11-12.2c1.3-1.7 2.6-3.6 3.6-5.4c.5-.9 1.1-2.1 1.6-3.4c.4-1.1 1.3-3.5 1.3-6.6c0-7.8-5-12.9-6.7-14.5c-2.5-2.5-5.6-4.6-8.7-6.4c-6.3-3.7-14.9-7.3-25.5-10.6c-21.4-6.6-52.4-12-93.1-12.5z"]
};
var faPencil = {
  prefix: 'fal',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6l-219 219V400c0-8.8-7.2-16-16-16H128V352c0-8.8-7.2-16-16-16H99.4l219-219zM66.9 379.5c1.2-4 2.7-7.9 4.7-11.5H96v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7L39.6 472.4l27.3-92.8zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17zM331.3 202.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"]
};
var faPencilAlt = faPencil;
var faBackward = {
  prefix: 'fal',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", "M37.6 256L256 414.1V97.9L37.6 256zM258 64c16.6 0 30 13.5 30 30V197.4L464.3 69.7C469.5 66 475.6 64 482 64c16.6 0 30 13.5 30 30V418c0 16.6-13.4 30-30 30c-6.3 0-12.5-2-17.6-5.7L288 314.6V418c0 16.6-13.5 30-30 30c-6.3 0-12.5-2-17.6-5.7L9.9 275.4C3.7 270.9 0 263.7 0 256s3.7-14.9 9.9-19.4L240.3 69.7C245.5 66 251.6 64 258 64zm30 211.1l192 139V97.9l-192 139v38.2z"]
};
var faCaretRight = {
  prefix: 'fal',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M221.8 250.4c1.3 1.4 2.2 3.5 2.2 5.6s-.8 4.2-2.2 5.6L108.3 381.8c-1.3 1.4-3.2 2.2-5.2 2.2c-3.9 0-7.1-3.2-7.1-7.1l0-241.7c0-3.9 3.2-7.1 7.1-7.1c2 0 3.8 .8 5.2 2.2L221.8 250.4zm23.3-22L131.6 108.3c-7.4-7.8-17.7-12.3-28.4-12.3C81.5 96 64 113.5 64 135.1l0 241.7c0 21.6 17.5 39.1 39.1 39.1c10.8 0 21.1-4.4 28.4-12.3L245.1 283.6c7-7.4 10.9-17.3 10.9-27.6s-3.9-20.1-10.9-27.6z"]
};
var faComments = {
  prefix: 'fal',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", "M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144s-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5c-3.5-.7-7.1-.2-10.2 1.4c-6.1 3.1-12 6-18 8.7c-28.4 12.9-60.2 23.1-91.5 26c14.9-19 26.8-39.7 37.6-59.9c3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110c-11.7 21-24 40.6-39.5 57.5l0 0-.1 .1c-6.5 7-8.2 17.1-4.4 25.8C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.9-2.2 9.6-4.5 14.3-6.8c15.3 2.8 30.9 4.6 47 4.6c114.9 0 208-78.9 208-176S322.9 0 208 0zM447.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6c-4.8 5-5.8 12.5-2.5 18.6c10.9 20.2 22.7 40.8 37.6 59.9c-31.3-3-63.2-13.2-91.5-26c-6-2.7-11.9-5.6-18-8.7c-3.2-1.6-6.8-2.1-10.2-1.4c-15.6 3.1-30.9 5-46.3 5c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6c4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.7 2-18.9-4.4-25.8l-.1-.1 0 0c-15.5-17-27.8-36.5-39.5-57.5c26.2-29.9 46-65.8 46-110c0-94.4-87.8-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3z"]
};
var faPaste = {
  prefix: 'fal',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M160 32c11.6 0 21.3 8.2 23.5 19.2C185 58.6 191.6 64 199.2 64H208c8.8 0 16 7.2 16 16V96H96V80c0-8.8 7.2-16 16-16h8.8c7.6 0 14.2-5.4 15.7-12.8C138.7 40.2 148.4 32 160 32zM64 64h2.7C65 69 64 74.4 64 80V96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V80c0-5.6-1-11-2.7-16H256c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64H210.6c-9-18.9-28.3-32-50.6-32s-41.6 13.1-50.6 32H64C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64H192V416H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM288 480c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h96v56c0 22.1 17.9 40 40 40h56V448c0 17.7-14.3 32-32 32H288zM416 165.3L474.7 224H424c-4.4 0-8-3.6-8-8V165.3zM448 512c35.3 0 64-28.7 64-64V235.9c0-12.7-5.1-24.9-14.1-33.9l-59.9-59.9c-9-9-21.2-14.1-33.9-14.1H288c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448z"]
};
var faFileClipboard = faPaste;
var faDesktopArrowDown = {
  prefix: 'fal',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", "M64 0H240V32H64C46.3 32 32 46.3 32 64V256H544V64c0-17.7-14.3-32-32-32H336V0H512c35.3 0 64 28.7 64 64V256v32 64c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V288 256 64C0 28.7 28.7 0 64 0zM32 288v64c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64zM304 16V169.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 169.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCodePullRequest = {
  prefix: 'fal',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M323.8 5.2c5.9 6.5 5.5 16.7-1.1 22.6L265.4 80H336c61.9 0 112 50.1 112 112V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V192c0-44.2-35.8-80-80-80H265.4l57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1zM432 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM128 80A48 48 0 1 0 32 80a48 48 0 1 0 96 0zM96 158.4V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V158.4C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 38.7-27.5 71-64 78.4zM128 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faPumpkin = {
  prefix: 'fal',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", "M299.1 36.1l20.9 9V98.9c11.1 2 21.8 5.1 32 9.1V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-41.1 94c12.2-3.9 25-6.5 38.3-7.7l26.5-60.5zM166 145.1c9.5-9.2 20.1-17.3 31.5-24.1c-14.3-5.8-29.5-9-45.5-9c-43.8 0-82.2 24.1-109 60.4S0 258.1 0 312s16.1 103.3 43 139.6S108.2 512 152 512c24.7 0 47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9s47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9c43.8 0 82.2-24.1 109-60.4s43-85.7 43-139.6s-16.1-103.3-43-139.6S467.8 112 424 112c-15.9 0-31.2 3.2-45.5 9c11.4 6.8 22 14.9 31.5 24.1c4.6-.8 9.3-1.1 14-1.1c31.3 0 60.9 17.1 83.3 47.4S544 264.3 544 312s-14.3 90.3-36.7 120.6s-52 47.4-83.3 47.4c-20.7 0-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C328.6 472.5 308.7 480 288 480s-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C192.6 472.5 172.7 480 152 480c-31.3 0-60.9-17.1-83.3-47.4S32 359.7 32 312s14.3-90.3 36.7-120.6s52-47.4 83.3-47.4c4.7 0 9.4 .4 14 1.1zM288 160c38.5 0 72.4 19.4 92.6 49c5 7.3 14.9 9.2 22.2 4.2s9.2-14.9 4.2-22.2c-25.9-38-69.6-63-119.1-63s-93.2 25-119.1 63c-5 7.3-3.1 17.3 4.2 22.2s17.3 3.1 22.2-4.2c20.2-29.6 54.1-49 92.6-49z"]
};
var faClipboardList = {
  prefix: 'fal',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPenField = {
  prefix: 'fal',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M582.8 45.5l11.9 11.9c12.5 12.5 12.5 32.8 0 45.2L568 129.4l-57-57 26.4-26.8c12.5-12.6 32.8-12.7 45.4-.1zM346.2 239.2L488.5 95.1 545.4 152 402.3 295.2c-4.4 4.4-10 7.4-16.1 8.7l-61.5 12.9 12.9-61.7c1.3-6 4.2-11.5 8.6-15.9zM514.7 23.1L323.4 216.7c-8.6 8.7-14.6 19.8-17.1 31.8l-18 85.7c-1.1 5.3 .5 10.8 4.3 14.6s9.3 5.5 14.6 4.3l85.5-17.9c12.2-2.6 23.3-8.6 32.1-17.4L617.4 125.3c25-25 25-65.5 0-90.5L605.5 22.8c-25.1-25.1-65.8-25-90.8 .3zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm64 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBlueberries = {
  prefix: 'fal',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M382.7 312.3C439.3 292.9 480 239.2 480 176c0-79.5-64.5-144-144-144c-63.2 0-116.9 40.7-136.3 97.3c-7.8-.9-15.7-1.3-23.7-1.3c-3.2 0-6.3 .1-9.4 .2C187.4 54.2 255.4 0 336 0c97.2 0 176 78.8 176 176c0 80.6-54.2 148.6-128.2 169.4c.1-3.1 .2-6.3 .2-9.4c0-8-.5-15.9-1.3-23.7zM320 336A144 144 0 1 0 32 336a144 144 0 1 0 288 0zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zm176-96v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V240c0-8.8 7.2-16 16-16s16 7.2 16 16zM368 80v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTruckRampBox = {
  prefix: 'fal',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M432 0c-44.2 0-80 35.8-80 80V384c0 1.3 .2 2.5 .4 3.7L11.8 480.6C3.3 482.9-1.8 491.7 .6 500.2s11.1 13.6 19.6 11.2L416.1 403.6C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5 .1L384 379.1V80c0-26.5 21.5-48 48-48H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM84.9 191.2l14.5 54.1c3.4 12.8 16.6 20.4 29.4 17l46.4-12.4c12.8-3.4 20.4-16.6 17-29.4l-14.5-54.1 30.9-8.3L250 312.6 95.4 354 54 199.4l30.9-8.3zm30.9-8.3l30.9-8.3L159.2 221l-30.9 8.3-12.4-46.4zM45.7 168.5c-17.1 4.6-27.2 22.1-22.6 39.2L64.5 362.3c4.6 17.1 22.1 27.2 39.2 22.6l154.5-41.4c17.1-4.6 27.2-22.1 22.6-39.2L239.5 149.7c-4.6-17.1-22.1-27.2-39.2-22.6L45.7 168.5z"]
};
var faTruckLoading = faTruckRampBox;
var faNote = {
  prefix: 'fal',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M384 64c17.7 0 32 14.3 32 32V304H320c-26.5 0-48 21.5-48 48v96H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm18.7 272L304 434.7V352c0-8.8 7.2-16 16-16h82.7zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H277.5c17 0 33.3-6.7 45.3-18.7L429.3 354.7c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zm64 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faArrowDownToSquare = {
  prefix: 'fal',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", "M267.8 330.9l96-104c6-6.5 5.6-16.6-.9-22.6s-16.6-5.6-22.6 .9L272 279.1V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V279.1l-68.2-73.9c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6l96 104c3 3.3 7.3 5.1 11.8 5.1s8.7-1.9 11.8-5.1zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faUserCheck = {
  prefix: 'fal',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zm457-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCloudXmark = {
  prefix: 'fal',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM244.7 212.7c6.2-6.2 16.4-6.2 22.6 0L320 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faVialVirus = {
  prefix: 'fal',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V384c0 53 43 96 96 96c31.4 0 59.3-15.1 76.8-38.4c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2C167.5 438 148.9 448 128 448c-35.3 0-64-28.7-64-64V224H208c8.8 0 16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM192 192H64V64H192V192zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM214.6 326.9c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1zm62.6-50.7c28.6 8.2 60.2-4.9 74.7-30.9c7.2 13 18.8 22.8 32.2 28.3c13.3 5.5 28.3 6.7 42.5 2.6c-8.2 28.6 4.9 60.2 30.9 74.7c-26 14.5-39.1 46.1-30.9 74.7c-28.6-8.2-60.2 4.9-74.7 30.9c-14.5-26-46.1-39.1-74.7-30.9c8.2-28.6-4.9-60.2-30.9-74.7c26-14.5 39.1-46.1 30.9-74.7z"]
};
var faBookBlank = {
  prefix: 'fal',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H96V32H64C46.3 32 32 46.3 32 64l0 328.6zM128 32V384H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H128z"]
};
var faBookAlt = faBookBlank;
var faGolfFlagHole = {
  prefix: 'fal',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M135.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l224 112c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3L160 249.9v61.7c29.6-4.9 62.1-7.6 96-7.6c141.4 0 256 46.6 256 104s-114.6 104-256 104S0 465.4 0 408c0-32.8 37.5-62.1 96-81.2v33.8c-3.1 1.1-6.1 2.3-9 3.5c-20.9 8.5-35.7 17.8-44.7 26.5C33.3 399.2 32 405.1 32 408s1.3 8.8 10.3 17.4c9.1 8.7 23.8 18 44.7 26.5C128.7 468.8 188.4 480 256 480s127.3-11.2 169-28.1c20.9-8.5 35.7-17.8 44.7-26.5c9-8.6 10.3-14.5 10.3-17.4s-1.3-8.8-10.3-17.4c-9.1-8.7-23.8-18-44.7-26.5C383.3 347.2 323.6 336 256 336c-34.5 0-67 2.9-96 8v28.2c17-7.6 39.4-12.2 64-12.2c53 0 96 21.5 96 48s-43 48-96 48s-96-21.5-96-48V350.9 317.9 240 16c0-5.5 2.9-10.7 7.6-13.6zM160 214.1L332.2 128 160 41.9V214.1zM288.4 405.4a0 0 0 1 0 0 .1 0 0 0 1 0 0-.1zm-10.8-2.7c-12.1-6-31-10.7-53.6-10.7s-41.5 4.7-53.6 10.7c-4.3 2.1-6.9 4-8.5 5.3c1.6 1.4 4.2 3.2 8.5 5.3c12.1 6 31 10.7 53.6 10.7s41.5-4.7 53.6-10.7c4.3-2.1 6.9-4 8.5-5.3c-1.6-1.4-4.2-3.2-8.5-5.3zm10.8 7.9a.4 .4 0 1 0 .8-.4 .4 .4 0 1 0 -.8 .4z"]
};
var faMessageArrowDown = {
  prefix: 'fal',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V265.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4V112z"]
};
var faCommentAltArrowDown = faMessageArrowDown;
var faFaceUnamused = {
  prefix: 'fal',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 394.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faSheetPlastic = {
  prefix: 'fal',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M352 64V320H240c-26.5 0-48 21.5-48 48V480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32zm-.5 288c-.7 2.8-2.1 5.4-4.2 7.4L231.4 475.3c-2.1 2.1-4.6 3.5-7.4 4.2V368c0-8.8 7.2-16 16-16H351.5zM0 448c0 35.3 28.7 64 64 64H220.1c12.7 0 24.9-5.1 33.9-14.1L369.9 382.1c9-9 14.1-21.2 14.1-33.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM187.3 68.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z"]
};
var faCircle9 = {
  prefix: 'fal',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-3.7 159.9C201 318 160 275.8 160 224c0-53 43-96 96-96s96 43 96 96c0 30-12.5 58.6-34.4 78.9l-82.7 76.8c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6 .8-22.6l39.1-36.3z"]
};
var faBlog = {
  prefix: 'fal',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M208 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240c0 8.8 7.2 16 16 16s16-7.2 16-16C480 153.8 358.2 32 208 32zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176zM32 120c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c61.9 0 112 50.1 112 112s-50.1 112-112 112S32 429.9 32 368V120z"]
};
var faUserNinja = {
  prefix: 'fal',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128c-63.6 0-116.3-46.3-126.3-107.1L59.3 187.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 112 36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l45.2 45.2C123 34 169.6 0 224 0c70.7 0 128 57.3 128 128zM211.1 452.9L128.6 344.7C72.9 364.8 33 417.7 32 480H231.7l-20.2-26.5c-.1-.2-.3-.4-.4-.6zm33.1-9.4L271.9 480H416c-1-62.3-40.9-115.2-96.6-135.3l-75.3 98.8zM418.3 512H264.2h-.4H29.7C13.3 512 0 498.7 0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7zM176 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPencilSlash = {
  prefix: 'fal',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20L382.4 117 459 193.6l-50.6 50.6 25.3 20L559 138.8zM317.2 335.3L240 412.6V400c0-8.8-7.2-16-16-16H192V352c0-8.8-7.2-16-16-16H163.4l68.2-68.2-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM493.8 39.6l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8c9.4-9.4 24.6-9.4 33.9 0zM135.6 368H160v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7l-92.8 27.3 27.3-92.8c1.2-4 2.7-7.9 4.7-11.6z"]
};
var faBowlingPins = {
  prefix: 'fal',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M128 32c-22.1 0-40 17.9-40 40v4.4c0 6.4 .8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2h48.4c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19V72c0-22.1-17.9-40-40-40zM91.9 230.9L61.1 301.4C52.5 321.1 48 342.5 48 364.1c0 26.2 6.6 51.9 19.1 74.9L89.5 480h77l22.4-41.1c12.5-23 19.1-48.7 19.1-74.9c0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9H102.8c-1.8 13.4-5.4 26.5-10.8 38.9zM56 72C56 32.2 88.2 0 128 0s72 32.2 72 72v4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2v5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5c0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5H84.7c-8.8 0-16.9-4.8-21.1-12.5L39 454.2c-15.1-27.7-23-58.7-23-90.2c0-26 5.4-51.7 15.8-75.5l30.8-70.4C68.8 204 72 188.7 72 173.2v-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4C57.1 94.4 56 85.4 56 76.4V72zM384 32c-22.1 0-40 17.9-40 40v4.4c0 6.4 .8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2h48.4c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19V72c0-22.1-17.9-40-40-40zM347.9 230.9l-30.8 70.4c-8.6 19.8-13.1 41.1-13.1 62.7c0 26.2 6.6 51.9 19.1 74.9L345.5 480h77l22.4-41.1c12.5-23 19.1-48.7 19.1-74.9c0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9H358.8c-1.8 13.4-5.4 26.5-10.8 38.9zM312 72c0-39.8 32.2-72 72-72s72 32.2 72 72v4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2v5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5c0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5H340.7c-8.8 0-16.9-4.8-21.1-12.5L295 454.2c-15.1-27.7-23-58.7-23-90.2c0-26 5.4-51.7 15.8-75.5l30.8-70.4c6.2-14.2 9.4-29.4 9.4-44.9v-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4c-2.2-8.8-3.3-17.7-3.3-26.8V72z"]
};
var faPersonArrowUpFromLine = {
  prefix: 'fal',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H160V164c6-2.6 12.5-4 19.3-4zM160 480V352h64V480H160zm-32 0H16c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0h96l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L275.3 170.3c-13.9-26-41-42.3-70.6-42.3H179.3c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.1V480zM603.3 132.7l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 86.6 480 400c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faDownRight = {
  prefix: 'fal',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", "M312 384c4.4 0 8-3.6 8-8V174.6c0-3.7-3-6.6-6.6-6.6c-1.8 0-3.4 .7-4.7 1.9l-61.4 61.4c-6.2 6.2-16.4 6.2-22.6 0L112 118.6c-4.2-4.2-10-6.6-16-6.6s-11.8 2.4-16 6.6L54.6 144c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16L167.3 288.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3l-61.4 61.4c-1.2 1.2-1.9 2.9-1.9 4.7c0 3.7 3 6.6 6.6 6.6H312zm40-8c0 22.1-17.9 40-40 40H110.6C89.3 416 72 398.7 72 377.4c0-10.2 4.1-20.1 11.3-27.3L133.4 300 32 198.6C21.8 188.4 16 174.5 16 160s5.8-28.4 16-38.6L57.4 96C67.6 85.8 81.5 80 96 80s28.4 5.8 38.6 16L236 197.4l50.1-50.1c7.2-7.2 17.1-11.3 27.3-11.3c21.3 0 38.6 17.3 38.6 38.6V376z"]
};
var faScrollTorah = {
  prefix: 'fal',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", "M96 448V64c0-17.7-14.3-32-32-32S32 46.3 32 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32zM64 0c23.7 0 44.4 12.9 55.4 32H128 512h8.6C531.6 12.9 552.3 0 576 0c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H512 128h-8.6c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM576 480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32zm-64-32V64H128V448H512zM172 322.9c0-4.1 1.1-8.2 3.2-11.8l32.3-55-32.3-55c-2.1-3.6-3.2-7.6-3.2-11.8c0-12.9 10.4-23.3 23.3-23.3h65l36-61.3c4.6-7.9 13.1-12.7 22.2-12.7s17.6 4.8 22.2 12.7l36 61.3h65c12.9 0 23.3 10.4 23.3 23.3c0 4.1-1.1 8.2-3.2 11.8l-32.3 55 32.3 55c2.1 3.6 3.2 7.6 3.2 11.8c0 12.9-10.4 23.3-23.3 23.3h-65l-36 61.3c-4.6 7.9-13.1 12.7-22.2 12.7s-17.6-4.8-22.2-12.7l-36-61.3h-65c-12.9 0-23.3-10.4-23.3-23.3zm146.5 59.2l21.1-35.9H297.4l21.1 35.9zm-39.9-67.9h79.7l34.1-58-34.1-58H278.6l-34.1 58 34.1 58zm147.9 0L411 287.7l-15.5 26.4h31zm0-116.1h-31L411 224.5 426.5 198zm-108-67.9L297.4 166h42.2l-21.1-35.9zM226 224.5L241.5 198h-31L226 224.5zm15.5 89.7L226 287.7l-15.5 26.4h31z"]
};
var faTorah = faScrollTorah;
var faWebhook = {
  prefix: 'fal',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M192 128c0-53 43-96 96-96s96 43 96 96c0 8.8 7.2 16 16 16s16-7.2 16-16C416 57.3 358.7 0 288 0S160 57.3 160 128c0 40 18.4 75.8 47.1 99.2L147.3 323c-6.1-1.9-12.6-3-19.3-3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-17.1-6.7-32.6-17.6-44.1L238 238.2c7.2-11.5 3.2-25.5-6.5-32.7C207.5 188.1 192 159.9 192 128zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64-32c0 35.3 28.7 64 64 64c6.7 0 13.2-1 19.3-3l63.5 101.7c7.2 11.5 21.6 14.1 32.2 8.4C416.5 292 431.7 288 448 288c53 0 96 43 96 96s-43 96-96 96c-18.7 0-36.1-5.3-50.9-14.6c-7.5-4.7-17.4-2.4-22.1 5.1s-2.4 17.4 5.1 22.1c19.7 12.3 43 19.5 67.9 19.5c70.7 0 128-57.3 128-128s-57.3-128-128-128c-19.2 0-37.4 4.2-53.8 11.8l-59.8-95.7c10.9-11.5 17.6-27 17.6-44.1c0-35.3-28.7-64-64-64s-64 28.7-64 64zM73.2 305.2c7.2-5.1 9-15 4-22.3s-15-9-22.3-4C21.7 302.1 0 340.5 0 384c0 70.7 57.3 128 128 128c65.3 0 119.1-48.9 127-112H386c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H248c-13.5 0-23.4 10.8-24.2 22.9C220.2 440.7 178.7 480 128 480c-53 0-96-43-96-96c0-32.6 16.2-61.4 41.2-78.8zM480 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faBlindsOpen = {
  prefix: 'fal',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", "M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96h96V258.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96H480c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 32H480V64H32V32zm96 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V160H16zm176 32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H192v32zM0 496c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c-7-9.3-12-20.2-14.4-32H16zm480 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.4c-2.4 11.8-7.4 22.7-14.4 32H496z"]
};
var faFence = {
  prefix: 'fal',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M64 32c5 0 9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V160h64V117.3c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V160h64V117.3c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V448c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V384H320v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V117.3c0-6.9 2.2-13.7 6.4-19.2L51.2 38.4c3-4 7.8-6.4 12.8-6.4zM288 384V352 192 160 117.3L256 74.7l-32 42.7V448h64V384zm32-32h64V192H320V352zm96 0v32 64h64V117.3L448 74.7l-32 42.7V352zM192 192H128V352h64V192zm-96 0V160 117.3L64 74.7 32 117.3V448H96V384 352 192z"]
};
var faUp = {
  prefix: 'fal',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", "M189.7 64h4.6c4.4 0 8.6 1.8 11.6 5L348.5 218.8c2.2 2.3 3.5 5.4 3.5 8.7c0 6.9-5.6 12.6-12.6 12.6H256c-8.8 0-16 7.2-16 16V432c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V256c0-8.8-7.2-16-16-16H44.6c-6.9 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7L178.1 69c3-3.2 7.2-5 11.6-5zM384 227.4c0-11.4-4.4-22.5-12.3-30.7L229 46.9C220 37.4 207.4 32 194.3 32h-4.6C176.6 32 164 37.4 155 46.9L12.3 196.7C4.4 205 0 216 0 227.4C0 252 20 272 44.6 272H112V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V272h67.4c24.6 0 44.6-20 44.6-44.6z"]
};
var faArrowAltUp = faUp;
var faBroomBall = {
  prefix: 'fal',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M571.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-208 208 45.3 45.3c4.8 4.8 7.4 11.2 7.4 17.9c0 12.4-9 23-21.2 25l-54.7 9.1 1.4 9.8c6.6 46.3-9 93-42 126c-27.8 27.8-65.6 43.5-105 43.5L22.6 512C10.1 512 0 501.9 0 489.4c0-6 2.4-11.8 6.6-16l59.7-59.7 15-15L96 384H81.3c-8.3 0-15.3-5.8-16.9-13.6c-.3-1.2-.4-2.4-.4-3.7c0-29.9 11.9-58.5 33-79.7l10.5-10.5c33.1-33.1 79.7-48.6 126-42l9.8 1.4 9.1-54.7c2-12.2 12.6-21.2 25-21.2c6.7 0 13.2 2.7 17.9 7.4l45.3 45.3 208-208c6.2-6.2 16.4-6.2 22.6 0zm-238 296.6l43.5-7.2-94.9-94.9-7.2 43.5 58.7 58.7zm-79.6-31.6L229 266.2c-36.3-5.2-72.9 7-98.9 33l-10.5 10.5C108 321.3 100.3 336.1 97.3 352c12.4 .5 23.4 8.2 28.2 19.7c5 12 2.2 25.7-6.9 34.9L45.3 480l149.2 0c30.9 0 60.5-12.3 82.4-34.1c25.9-25.9 38.1-62.6 33-98.9l-3.5-24.7-52.6-52.6zM512 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faDrumstick = {
  prefix: 'fal',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M192 272V176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144H240c-26.5 0-48-21.5-48-48zm-32-96v96c0 3 .2 6 .5 8.9L121.4 320l-.1 0c-.1 0-.5 .1-1.2 .1c-1.5-.1-3.5-.7-5.2-2C102.9 309.3 88.1 304 72 304c-39.8 0-72 32.2-72 72c0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72c0-16.1-5.3-30.9-14.2-42.9c-1.2-1.7-1.9-3.7-2-5.2c0-.7 .1-1.1 .1-1.2l0-.1 0 0 39.1-39.1c2.9 .3 5.9 .5 8.9 .5h96c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176zm12.2 138.4c6.4 10.3 15.1 18.9 25.4 25.4L169.3 368c-15 15-9.9 36.5-1.2 48.1c4.9 6.7 7.9 14.9 7.9 23.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9c11.7 8.7 33.2 13.7 48.1-1.2l28.2-28.2z"]
};
var faSquareV = {
  prefix: 'fal',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm126.3 56.8L224 348.2l97.7-195.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-112 224c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8l-112-224c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2z"]
};
var faFaceAwesome = {
  prefix: 'fal',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 208H104V192c0-22.1 17.9-40 40-40c.5 0 .9 0 1.4 0c-.9 2.5-1.4 5.2-1.4 8c0 13.3 10.7 24 24 24c5.2 0 10.1-1.7 14-4.5c1.3 3.9 2 8.1 2 12.5v16zm-40-88c-39.8 0-72 32.2-72 72v16c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V192c0-39.8-32.2-72-72-72zm236.1 53.1c2.5 5.8 3.9 12.2 3.9 18.9v16H288V192c0-26.5 21.5-48 48-48c2 0 3.9 .1 5.8 .3c-3.6 4.2-5.8 9.7-5.8 15.7c0 13.3 10.7 24 24 24c8.4 0 15.8-4.3 20.1-10.9zM256 192v17.9c0 16.6 13.5 30.1 30.1 30.1h99.8c16.6 0 30.1-13.5 30.1-30.1V192c0-44.2-35.8-80-80-80s-80 35.8-80 80zm4.7 224H248c-2 0-4 0-5.9-.1c7.2-27.5 32.2-47.9 61.9-47.9c15.9 0 30.5 5.8 41.7 15.5c-2.8 2.7-5.7 5.2-8.7 7.6c-21.5 15.7-47.9 24.9-76.3 24.9zm-50.6-4.2c-51.5-12.9-91.9-54.6-102.3-107.8H388.8c-2.8 20.6-10.3 39.6-21.5 55.9C350.4 345 328.3 336 304 336c-46.1 0-84.6 32.5-93.9 75.8zm146.2 4.8c36-26.5 60.7-67.7 65-115.3c1.4-15.7-11-29.3-26.8-29.3H92.8c-11.2 0-19.9 9.6-18.9 20.7c8 88 81.7 155.3 170.1 155.3H248h12.7 4.7c34.2 0 65.8-11.7 90.9-31.4z"]
};
var faGaveDandy = faFaceAwesome;
var faDialOff = {
  prefix: 'fal',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 288V415c-63.1-7.9-112-61.7-112-127c0-70.7 57.3-128 128-128s128 57.3 128 128c0 65.3-48.9 119.1-112 127V288c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faToggleOff = {
  prefix: 'fal',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M416 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H160C89.3 384 32 326.7 32 256s57.3-128 128-128H416zM576 256c0-88.4-71.6-160-160-160H160C71.6 96 0 167.6 0 256s71.6 160 160 160H416c88.4 0 160-71.6 160-160zm-352 0A64 64 0 1 1 96 256a64 64 0 1 1 128 0zM64 256a96 96 0 1 0 192 0A96 96 0 1 0 64 256z"]
};
var faFaceSmileHorns = {
  prefix: 'fal',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM552.4 148.6c-12.2-26.4-28.8-50.4-48.8-71c13.1-3 27.6-6.8 42.3-11.2c17.7-5.3 36.2-11.7 53.2-19.1c-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2c-20 20.6-36.6 44.6-48.8 71C65.5 114.3 50.2 76.2 40.9 47.3c17 7.4 35.5 13.8 53.2 19.1zM205.5 347.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 370.2 363.4 392 320 392s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faBoxArchive = {
  prefix: 'fal',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M480 64H32v64H64 448h32V64zm0 96H448 64 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zM160 240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm288-48h32V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192H64V416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192z"]
};
var faArchive = faBoxArchive;
var faGrapes = {
  prefix: 'fal',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", "M447.5 221.1c-4.5-10.7-10.5-20.6-17.9-29.3c21.6-2 40.7-14.9 50.2-22.8l0-.1c.1-.1 .2-.4 .2-.9c0-.4-.1-.7-.1-.8C469.7 159.1 446.4 144 416 144c-14.7 0-22.9 1.8-26.9 3.2c-1.6 .6-2.6 1-2.9 1.2c-6.3 5.2-15.6 4.8-21.4-1.1s-6.2-15.2-1.1-21.4c.2-.4 .7-1.3 1.2-2.9c1.3-4 3.2-12.2 3.2-26.9c0-30.4-15.1-53.7-23.2-63.9c-.1 0-.4-.1-.8-.1c-.5 0-.8 .1-.9 .2l-.1 0c-7.9 9.6-20.8 28.6-22.8 50.2C311.5 75 301.7 69 290.9 64.5c6.1-24.5 20-43.7 27.4-52.7C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1C379.8 24.8 400 55.1 400 96c0 6.3-.3 11.9-.8 16.8c4.9-.5 10.5-.8 16.8-.8c40.9 0 71.2 20.2 83.9 30.2c8.4 6.7 12.1 16.5 12.1 25.8c0 9.2-3.7 19-11.8 25.7c-9 7.4-28.2 21.3-52.7 27.4zM320 456c-18.4 0-35.2-6.9-47.9-18.2c-12.4 25-38.3 42.2-68.1 42.2c-19 0-36.3-7-49.6-18.4C142.6 491.1 113.7 512 80 512c-44.2 0-80-35.8-80-80c0-33.7 20.9-62.6 50.4-74.4C39 344.3 32 327 32 308c0-29.8 17.2-55.7 42.2-68.1C62.9 227.2 56 210.4 56 192c0-39.8 32.2-72 72-72c17.6 0 33.8 6.3 46.3 16.9C186.4 108.1 214.9 88 248 88c44.2 0 80 35.8 80 80c0 6.2-.7 12.2-2 18c5.8-1.3 11.8-2 18-2c44.2 0 80 35.8 80 80c0 33.1-20.1 61.6-48.9 73.7C385.7 350.2 392 366.4 392 384c0 39.8-32.2 72-72 72zM296 168a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 232a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm144 56a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM108 352a44 44 0 1 0 0-88 44 44 0 1 0 0 88zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm124-32a44 44 0 1 0 0-88 44 44 0 1 0 0 88zm156-64a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-16-72a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPersonDrowning = {
  prefix: 'fal',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", "M144 32c8.8 0 16 7.2 16 16V89c0 63.4 41.9 119.2 102.7 137c47.9 14 98.7 14 146.5 0l114.2-33.3c8.5-2.5 17.4 2.4 19.8 10.9s-2.4 17.4-10.9 19.8L418.2 256.7c-16.9 4.9-34.1 8.3-51.5 10.1l-14 111.8c-9.6-3.5-19.1-8.4-28-14.5c-.8-.5-1.5-1-2.3-1.5l11.8-94.2c-27.1-.2-54.2-4.1-80.6-11.7c-5.6-1.6-11.1-3.5-16.4-5.7L218.2 380.3c-8.5 2.6-17.3 4.1-26.2 4.1c-2.2 0-4.5-.1-6.7-.3l22-148.8C158.8 203.7 128 149.2 128 89V48c0-8.8 7.2-16 16-16zM320 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 448c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"]
};
var faDialMax = {
  prefix: 'fal',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm90.5 322.5l-.4 .4 .8-.8-.4 .4zM299.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l89.8 89.8c-50.2 39.1-122.8 35.5-169-10.6c-50-50-50-131 0-181s131-50 181 0c46.2 46.2 49.7 118.8 10.6 169l-89.8-89.8zM401.1 401.1A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleM = {
  prefix: 'fal',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM157.1 134.8c-4-5.7-11.3-8.2-17.9-6.1S128 137 128 144V368c0 8.8 7.2 16 16 16s16-7.2 16-16V194.8l82.9 118.4c3 4.3 7.9 6.8 13.1 6.8s10.1-2.5 13.1-6.8L352 194.8V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-7-4.5-13.2-11.2-15.3s-13.9 .4-17.9 6.1L256 276.1 157.1 134.8z"]
};
var faCalendarImage = {
  prefix: 'fal',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zM230 265.4c12.5-18.1 39.2-18.4 52.2-.6l96.3 132.4c15.4 21.2 .3 50.8-25.9 50.8H95.1c-26 0-41.2-29.4-26-50.6l51-71.3c11.5-16.1 34.7-18 48.7-4l13.1 13.1L230 265.4zM352.6 416L256.3 283.6l-59.2 85.5c-2.7 3.9-7 6.4-11.7 6.8s-9.4-1.3-12.8-4.6L146 344.7 95.1 416H352.6zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleCaretDown = {
  prefix: 'fal',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 352c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7c0-15.2-12.3-27.5-27.5-27.5l-201 0c-15.2 0-27.5 12.3-27.5 27.5c0 6.9 2.6 13.6 7.3 18.7L230.8 341c6.5 7 15.6 11 25.2 11zm1.7-32.7c-.4 .5-1.1 .7-1.7 .7s-1.3-.3-1.7-.7L165.8 224l180.3 0-88.4 95.3z"]
};
var faCaretCircleDown = faCircleCaretDown;
var faArrowDown91 = {
  prefix: 'fal',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M428 64a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6L429.3 200c-.4 0-.9 0-1.3 0c-46.4 0-84-37.6-84-84zM267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM448 304V448h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V326.2l-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13z"]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faFaceGrinTongueSquint = {
  prefix: 'fal',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm104.5-65.7L171.9 208l-35.4 17.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-64-32c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5zm246.2-21.5c-4-7.9-13.6-11.1-21.5-7.2l-64 32c-5.4 2.7-8.8 8.3-8.8 14.3s3.4 11.6 8.8 14.3l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5L340.2 208l35.4-17.7c7.9-4 11.1-13.6 7.2-21.5zM352 416V383.4c20.2-15.7 36.4-36.2 46.9-59.9c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c10.4 23.6 26.6 44.1 46.8 59.8V416c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faShishKebab = {
  prefix: 'fal',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 14.4-4.8 27.7-12.8 38.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c12.1-16 19.2-36 19.2-57.6c0-53-43-96-96-96s-96 43-96 96c0 12.7 2.5 24.9 7 36.1c5.7 14 4.2 26.1-1.5 31.8l-8.8 8.8-30.1-30.1C272.1 128.1 252.5 120 232 120s-40.1 8.1-54.6 22.6l-18.7 18.7C144.1 175.9 136 195.5 136 216c0 6.2 .7 12.3 2.2 18.2c-5.9-1.4-12-2.2-18.2-2.2c-20.5 0-40.1 8.1-54.6 22.6L46.6 273.4C32.1 287.9 24 307.5 24 328s8.1 40.1 22.6 54.6l30.1 30.1-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72 30.1 30.1C143.9 479.9 163.5 488 184 488s40.1-8.1 54.6-22.6l18.7-18.7C271.9 432.1 280 412.5 280 392c0-6.2-.7-12.3-2.2-18.2c5.9 1.4 12 2.2 18.2 2.2c20.5 0 40.1-8.1 54.6-22.6l18.7-18.7C383.9 320.1 392 300.5 392 280s-8.1-40.1-22.6-54.6l-30.1-30.1 8.8-8.8c19.3-19.3 16.2-47.7 8.6-66.4c-3-7.4-4.7-15.5-4.7-24.1zM181.3 248c-8.5-8.5-13.3-20-13.3-32s4.8-23.5 13.3-32L200 165.3c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3L346.7 248c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L328 330.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L181.3 248zM69.3 360C60.8 351.5 56 340 56 328s4.8-23.5 13.3-32L88 277.3c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3L234.7 360c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L216 442.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L69.3 360z"]
};
var faSprayCan = {
  prefix: 'fal',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M192 32V96h32V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32V96h32V32h64zm32 128c35.3 0 64 28.7 64 64V440c0 22.1-17.9 40-40 40H72c-22.1 0-40-17.9-40-40V224c0-35.3 28.7-64 64-64h32 64 32zm64-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 128c-53 0-96 43-96 96V440c0 39.8 32.2 72 72 72H248c39.8 0 72-32.2 72-72V224c0-53-43-96-96-96H192 128 96zm64 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM408 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM408 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faAlarmSnooze = {
  prefix: 'fal',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm-64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L179.5 358c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H225.3L332.5 218c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H192z"]
};
var faScarecrow = {
  prefix: 'fal',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", "M224 176a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 32c-36.8 0-69.2-19.1-87.7-48H61.9c4 7 2.3 15.9-4.3 20.8L42.7 192l14.9 11.2c6.5 4.9 8.3 13.8 4.3 20.8h62.6c20.2 0 35.3 18.5 31.4 38.3L134.6 368.7l25.5-14.6c4.9-2.8 11-2.8 15.9 0L224 381.6l48.1-27.5c4.9-2.8 11-2.8 15.9 0l25.5 14.6L292.1 262.3c-4-19.8 11.2-38.3 31.4-38.3h62.6c-4-7-2.3-15.9 4.3-20.8L405.3 192l-14.9-11.2c-6.5-4.9-8.3-13.8-4.3-20.8H311.7c-18.5 28.9-50.8 48-87.7 48zM328 104c0 8.3-1 16.3-2.8 24H416c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H323.5l28.2 140.9c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3 .9L280 386.4l-48.1 27.5c-4.9 2.8-11 2.8-15.9 0L168 386.4l-48.1 27.5c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1L124.5 256H32c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l7.6-11.4L6.4 204.8C2.4 201.8 0 197 0 192s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5h90.8c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104zM176 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 496V445.3c10.3 3.7 21.7 3.7 32 0V496c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faTruckMonster = {
  prefix: 'fal',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M264 32c-4.4 0-8 3.6-8 8v88H462.4L389.2 37.9c-3-3.7-7.6-5.9-12.4-5.9H264zM96 128H224V40c0-22.1 17.9-40 40-40H376.8c14.5 0 28.1 6.5 37.3 17.7L503.6 128H544c35.3 0 64 28.7 64 64v48h-1c4.4 3.9 8.6 8 12.6 12.2c6.1 6.4 5.8 16.6-.7 22.6s-16.6 5.8-22.6-.7C567.2 243.3 525.8 224 480 224c-56.2 0-105.6 28.9-134.1 72.7c-3 4.5-8 7.3-13.4 7.3H307.5c-5.4 0-10.4-2.7-13.4-7.3C265.6 252.9 216.2 224 160 224c-45.8 0-87.2 19.3-116.4 50.2c-6.1 6.4-16.2 6.7-22.6 .7s-6.7-16.2-.7-22.6c3.7-3.9 7.6-7.7 11.6-11.3V192c0-35.3 28.7-64 64-64zM64 217.7c28.2-16.3 61-25.7 96-25.7c64.3 0 121.1 31.6 156 80H324c34.8-48.4 91.7-80 156-80c35 0 67.8 9.4 96 25.7V192c0-17.7-14.3-32-32-32H496.1h-.3H240 96c-17.7 0-32 14.3-32 32v25.7zM154 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H154zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H154c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6C33.2 411.5 24 397.8 24 382V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM213.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zm252.7-97.6c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H474c-3.9 0-7.1 2.7-7.8 6.4zM474 240h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H474c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6c-13.3-6.5-22.5-20.1-22.5-36V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6c6.5-13.3 20.1-22.5 36-22.5zM458.5 376a21.5 21.5 0 1 0 43 0 21.5 21.5 0 1 0 -43 0zM480 429.5a53.5 53.5 0 1 1 0-107 53.5 53.5 0 1 1 0 107z"]
};
var faGiftCard = {
  prefix: 'fal',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", "M397.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H320h80c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96l-45-72.1C212.8 41 196.5 32 178.9 32H176c-26.5 0-48 21.5-48 48s21.5 48 48 48h80 11.1zM288 101l38.8-62c15.1-24.2 41.7-39 70.3-39H400c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h48c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h48c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80h2.9c28.6 0 55.2 14.7 70.3 39L288 101zM176 160H64c-17.7 0-32 14.3-32 32v96H544V192c0-17.7-14.3-32-32-32H400 322.2l58.1 69.8c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2L288 169l-67.7 81.3c-5.7 6.8-15.7 7.7-22.5 2s-7.7-15.7-2-22.5L253.8 160H176zM32 320v64H544V320H32zM544 448V416H32v32c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32z"]
};
var faW = {
  prefix: 'fal',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M10.5 33c8.3-3 17.5 1.2 20.5 9.5l135.2 370L272.6 43.6c2-6.8 8.2-11.6 15.4-11.6s13.4 4.7 15.4 11.6L409.8 412.5 545 42.5c3-8.3 12.2-12.6 20.5-9.5s12.6 12.2 9.5 20.5l-152 416c-2.4 6.5-8.7 10.7-15.6 10.5s-12.9-4.9-14.8-11.6L288 105.7 183.4 468.4c-1.9 6.7-7.9 11.3-14.8 11.6s-13.2-4-15.6-10.5L1 53.5C-2.1 45.2 2.2 36 10.5 33z"]
};
var faCodePullRequestDraft = {
  prefix: 'fal',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", "M32 80a48 48 0 1 1 96 0A48 48 0 1 1 32 80zm64 78.4c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4V353.6C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4V158.4zM32 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM400 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM368 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSquareB = {
  prefix: 'fal',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 64c0-17.7 14.3-32 32-32h88c39.8 0 72 32.2 72 72c0 19.3-7.6 36.8-19.9 49.7C321.6 262.2 336 285.4 336 312c0 39.8-32.2 72-72 72H160c-17.7 0-32-14.3-32-32V256 160zm160 40c0-22.1-17.9-40-40-40H160v80h88c22.1 0 40-17.9 40-40zM160 352H264c22.1 0 40-17.9 40-40s-17.9-40-40-40H248 160v80z"]
};
var faElephant = {
  prefix: 'fal',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M224 111.8C224 67.7 259.7 32 303.8 32c41.5 0 76.1 31.8 79.6 73.2l.7 8.1c.7 8.8 8.5 15.3 17.3 14.6s15.4-8.5 14.6-17.3l-.7-8.1c-1.1-13-4.4-25.4-9.5-36.7C466.1 76.2 512 128.7 512 192V304c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-88.4-71.6-160-160-160h-1.9c-20.2-19.9-48-32-78.3-32c-30.5 0-58.2 12.3-78.4 32.1C118 35.6 32 123.7 32 232v32 0l0 19.1c0 25.4-8.7 50.1-24.5 70L3.5 358C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90L64 264v0V232c0-82.4 59.3-150.9 137.4-165.2c-6.1 13.8-9.4 29-9.4 45.1c0 58.2 44.6 106.6 102.5 111.4l8.1 .7c8.8 .7 16.5-5.8 17.3-14.6s-5.8-16.5-14.6-17.3l-8.1-.7c-41.4-3.4-73.2-38-73.2-79.6zM413.4 295.3c-2.8-4.4-7.8-7.3-13.4-7.3c-8.8 0-16 7.2-16 16V464c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V384c0-.7 0-1.4-.1-2c.5-3.8-.4-7.8-2.7-11.2c-5.1-7.2-15-9-22.3-4C279.3 377.6 260.4 384 240 384s-39.3-6.4-54.8-17.2c-7.2-5.1-17.2-3.3-22.3 4c-2.4 3.4-3.2 7.4-2.7 11.2c-.1 .7-.1 1.4-.1 2v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V352c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V406.7c14.8 6 31 9.3 48 9.3s33.2-3.3 48-9.3V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V349.6c7.2 7.2 14.7 13.2 22.8 18.1c3 1.9 6.1 3.5 9.2 5v10.4c0 53.5 43.4 96.9 96.9 96.9c44.4 0 83.2-30.2 94-73.4l.7-2.7c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-.7 2.7c-7.2 28.9-33.2 49.1-62.9 49.1C509 448 480 419 480 383.1v-.8c7.6 1.1 15.6 1.7 24 1.7c36.6 0 73.4-10.3 99.4-36.8c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2c-18 18.4-45.3 27.2-76.6 27.2c-20.5 0-35.4-3.6-48.6-11.7c-13.5-8.2-26.6-22-42-45zM480 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faEarthAfrica = {
  prefix: 'fal',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M480 256c0-16.8-1.8-33.1-5.3-48.8l-47.2-11.8c-4.1-1-8.4 .2-11.3 3.1c-2 2-3.6 4.2-4.9 6.7l-.3 .6c-7.9 15.8-22.1 27.3-38.6 31.9l15.1 15.1c8 8 12.5 18.9 12.5 30.2c0 19.5-13.2 36.5-32 41.4v6.2c0 17.3-5.6 34.2-16 48l-25.6 34.1C317.3 424.9 303.1 432 288 432c-26.5 0-48-21.5-48-48V336H208c-35.3 0-64-28.7-64-64V244c0-17.6 8.3-34.2 22.4-44.8l39.4-29.5c8.4-6.3 18.5-9.7 29-9.7c5.2 0 10.3 .8 15.3 2.5l32 10.7c4.3 1.4 9 1.6 13.4 .5l34.3-8.6c3.7-.9 6.3-4.3 6.3-8.1c0-2.8-1.4-5.4-3.7-6.9L306 132.6c-7.6 7.3-17.7 11.4-28.2 11.4c-6.3 0-12.5-1.5-18.2-4.3l-13.2-6.6c-23.9 36.9-83 14.6-74.9-30.2L175 84.3c.4-2 .2-4.1-.4-6.1l-9-27.1C86.9 85.8 32 164.5 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224zm-16.5-84.6C430.1 89.6 349.8 32 256 32c-20.9 0-41.2 2.9-60.4 8.2l9.3 27.8c2.4 7.1 2.9 14.6 1.6 22l-3.4 18.7c-1.9 10.2 12 15.2 17.1 6.1c7.4-13.4 24.1-18.5 37.8-11.7l16 8c1.2 .6 2.5 .9 3.8 .9c2.3 0 4.5-.9 6.1-2.5l3.5-3.5c8.5-8.5 21.7-9.8 31.7-3.1L350 123.5c11.2 7.5 18 20.1 18 33.5c0 18.5-12.6 34.6-30.5 39.1l-34.3 8.6c-10.3 2.6-21.2 2.2-31.3-1.2l-32-10.7c-1.7-.6-3.4-.8-5.1-.8c-3.5 0-7 1.1-9.8 3.3l-39.4 29.5c-6 4.5-9.6 11.6-9.6 19.2v28c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32v48c0 8.8 7.2 16 16 16c5 0 9.8-2.4 12.8-6.4l25.6-34.1c6.2-8.3 9.6-18.4 9.6-28.8V318.6c0-11.2 7.6-21 18.5-23.7l5.3-1.3c4.8-1.2 8.2-5.5 8.2-10.5c0-2.9-1.1-5.6-3.2-7.6l-40.2-40.2c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h19.7c11.3 0 21.6-6.4 26.7-16.5l.3-.6c2.8-5.6 6.4-10.7 10.9-15.1c10.9-10.9 26.8-15.3 41.7-11.6l28.2 7.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faGlobeAfrica = faEarthAfrica;
var faRainbow = {
  prefix: 'fal',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 64C160.9 64 32 192.9 32 352V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352C0 175.3 143.3 32 320 32s320 143.3 320 320V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352C608 192.9 479.1 64 320 64zm0 192c-53 0-96 43-96 96V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-70.7 57.3-128 128-128s128 57.3 128 128V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-53-43-96-96-96zM128 352V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-123.7 100.3-224 224-224s224 100.3 224 224V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-106-86-192-192-192s-192 86-192 192z"]
};
var faCircleNotch = {
  prefix: 'fal',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9c-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z"]
};
var faTabletScreenButton = {
  prefix: 'fal',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M384 32c17.7 0 32 14.3 32 32V320H32V64c0-17.7 14.3-32 32-32H384zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352H416zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM248 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTabletAlt = faTabletScreenButton;
var faPaw = {
  prefix: 'fal',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M197.4 143.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1s4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8S174.4 23.8 142.1 34.3s-46.9 53.9-32.6 96.8s52.1 69.1 84.4 58.5zm-114.1 54c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3s-29.1 51.7-10.2 84.1s54 47.3 78.5 33.3zM256 256c25.7 0 108.2 25.4 156.8 156.3c2.1 5.7 3.2 12.2 3.2 19.4v4.4c0 6.6-5.3 11.9-11.9 11.9c-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5c-6.6 0-11.9-5.3-11.9-11.9v-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 281.4 230.3 256 256 256zm0-32c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0L364.8 474c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.8-5.2-30.5C390.4 259.9 297.3 224 256 224zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3c-.9-7.7 .8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3s14.3-70.1-10.2-84.1s-59.7 .9-78.5 33.3zM307.9 103c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1c-3.5-10.3-4-24.7 1.2-40.2zM277.5 92.9c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9z"]
};
var faMessageQuestion = {
  prefix: 'fal',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168.7 121.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V240c0 8.8 7.2 16 16 16s16-7.2 16-16V220.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2C344 109 315.5 80 280 80H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCloud = {
  prefix: 'fal',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", "M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 53-43 96-96 96H144C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8z"]
};
var faTrowelBricks = {
  prefix: 'fal',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", "M32 128L224 32V224L32 128zM256 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2V144l88 0c0 17.7 14.3 32 32 32h88c26.5 0 48-21.5 48-48s-21.5-48-48-48H376c-17.7 0-32 14.3-32 32l-88 0V32zm208 80c8.8 0 16 7.2 16 16s-7.2 16-16 16H376V112h88zM288 384h16 16H480v8 88H256V384h32zm-64 0v96H32V384H224zm256-32H320V256H480v96zM288 256v64 32H256 32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V392v-8V256c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z"]
};
var faSquare3 = {
  prefix: 'fal',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32H288c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-78.9 67.6 19.9-.1c44.4-.2 80.6 35.7 80.6 80.2c0 44.3-35.9 80.2-80.2 80.2h-36c-27.6 0-53.5-13-70.1-35l-2.5-3.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2l2.5 3.4c10.5 14 27 22.2 44.5 22.2h36c26.6 0 48.2-21.6 48.2-48.2c0-26.7-21.7-48.3-48.4-48.2l-63.5 .3c-6.7 0-12.7-4.1-15.1-10.4s-.5-13.4 4.6-17.7L244.7 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceFlushed = {
  prefix: 'fal',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160.4-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faFlushed = faFaceFlushed;
var faHospitalUser = {
  prefix: 'fal',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H256c3.2 0 6.4-.2 9.5-.7c-5.5-9.2-8.9-19.9-9.4-31.3l-.1 0H64c-17.7 0-32-14.3-32-32V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V64c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32V336v57.4c9.2-10.2 20-18.9 32-25.6V336 271.8 64c0-35.3-28.7-64-64-64H64zm80 80c-13.3 0-24 10.7-24 24v16H104c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h16v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24V200h16c13.3 0 24-10.7 24-24V144c0-13.3-10.7-24-24-24H200V104c0-13.3-10.7-24-24-24H144zm8 56V112h16v24c0 8.8 7.2 16 16 16h24v16H184c-8.8 0-16 7.2-16 16v24H152V184c0-8.8-7.2-16-16-16H112V152h24c8.8 0 16-7.2 16-16zM384 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM320 477.1c0-33.7 27.4-61.1 61.1-61.1H482.9c33.7 0 61.1 27.4 61.1 61.1c0 1.6-1.3 2.9-2.9 2.9H322.9c-1.6 0-2.9-1.3-2.9-2.9zM381.1 384c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H432 381.1z"]
};
var faMicrowave = {
  prefix: 'fal',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M512 64c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H496 80 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM480 448v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480zM464 128V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zM128 320V160H384V320H128zM96 152V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
};
var faChfSign = {
  prefix: 'fal',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M0 112C0 67.8 35.8 32 80 32h4.2c28 0 53.6 15.8 66.1 40.8c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2C114.6 73 100.1 64 84.2 64H80c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h4.2c15.9 0 30.4-9 37.5-23.2c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5c-12.5 25-38.1 40.8-66.1 40.8H80c-44.2 0-80-35.8-80-80V112zM208 32c8.8 0 16 7.2 16 16V224H384V48c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H224V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM448 48c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V224H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48z"]
};
var faTentArrowLeftRight = {
  prefix: 'fal',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M482.8 4.2c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6L518.6 80 57.4 80l57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112l461.2 0-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80zm-185.3 159c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512H459.6c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7v112c0 .2 0 .4 0 .5V480H116.4c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8L272 207.7zm32 168.5L368.2 480H304V376.2zm0-60.8V207.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H405.9l-.3-.4L304 315.4z"]
};
var faCartCircleArrowUp = {
  prefix: 'fal',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0L480 342.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V342.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faTrashClock = {
  prefix: 'fal',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c2 0 4-.1 6-.3c-12.7-9-24.2-19.7-34.2-31.7H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6l-7.6 105.8c10.5-3.6 21.4-6.3 32.6-8l7-97.8H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]
};
var faGavel = {
  prefix: 'fal',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", "M315.3 4.7c6.2 6.2 6.2 16.4 0 22.6L302.6 40 472 209.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24 24-96 96-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 328 184 158.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24 96-96 24-24c6.2-6.2 16.4-6.2 22.6 0zM206.6 136L376 305.4 449.4 232 280 62.6 206.6 136zM144 320L32 432l48 48L192 368l-48-48zm-22.6-22.6c12.5-12.5 32.8-12.5 45.3 0l12.7 12.7 49.8-49.8 22.6 22.6-49.8 49.8 12.7 12.7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112z"]
};
var faLegal = faGavel;
var faSprinklerCeiling = {
  prefix: 'fal',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0H32V83.8L128 110v33.2L11.8 111.4C4.8 109.5 0 103.2 0 96V0zM256 110l96-26.2V0h32V96c0 7.2-4.8 13.5-11.8 15.4L256 143.1V110zM192 32c8.8 0 16 7.2 16 16V224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H192 80c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V48c0-8.8 7.2-16 16-16zM144 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 464a16 16 0 1 1 32 0A16 16 0 1 1 0 464z"]
};
var faBrowsers = {
  prefix: 'fal',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M512 32c17.7 0 32 14.3 32 32V96H256V32H512zM160 32h64V96H128V64c0-17.7 14.3-32 32-32zM128 352V128H240 544V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faTrillium = {
  prefix: 'fal',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M203.3 8.2c11.8-11 29.8-11 41.5 0c12.1 11.3 33.1 32.5 51.2 58.8c17.9 26 34.2 58.9 34.2 93.4c0 9.3-1.2 18.4-3.5 27c10.5 2.3 20.8 6.1 30.5 11.7l0 0c29.9 17.2 50.4 47.6 64.2 75.9c13.9 28.7 21.9 57.3 25.7 73.5c3.8 15.8-5.4 31.5-20.9 36.1c-16 4.8-44.9 12.2-76.8 14.6c-31.5 2.3-68.3-.1-98.2-17.2c-10.5-6-19.6-13.6-27.1-22.2c-7.5 8.7-16.6 16.2-27.1 22.2c-29.9 17.2-66.7 19.6-98.2 17.2c-31.9-2.4-60.9-9.8-76.8-14.6C6.3 380-2.9 364.4 .8 348.5c3.8-16.2 11.8-44.8 25.7-73.5c13.7-28.3 34.2-58.8 64.2-75.9l0 0c9.8-5.6 20.1-9.5 30.6-11.7c-2.3-8.6-3.5-17.7-3.5-27c0-34.4 16.4-67.4 34.2-93.4c18.1-26.3 39.1-47.5 51.2-58.8zM224 32.6c-11.4 10.7-29.8 29.6-45.6 52.5c-16.5 24-28.6 50.4-28.6 75.2c0 12 2.9 23.3 8.1 33.3c2.6 5 2.4 10.9-.6 15.7s-8.1 7.7-13.7 7.7c-12.6 0-25.4 3.2-37 9.9C84.9 239.4 68 263 55.3 289C43.3 314 36 339.2 32.3 354.4c15.1 4.4 40.8 10.9 68.7 12.9c29.1 2.2 58.2-.6 79.9-13.1c12.8-7.3 22.6-17.9 28.8-30.1c2.7-5.3 8.2-8.7 14.2-8.7s11.5 3.3 14.2 8.7c6.3 12.2 16 22.7 28.8 30.1c21.7 12.5 50.8 15.2 79.9 13.1c27.8-2.1 53.6-8.5 68.7-12.9c-3.7-15.2-10.9-40.5-23-65.4c-12.6-26.1-29.6-49.7-51.3-62.1c-11.6-6.7-24.4-9.8-36.9-9.9c-5.6 0-10.8-2.9-13.7-7.7s-3.1-10.7-.6-15.7c5.2-10 8.1-21.3 8.1-33.3c0-24.9-12.1-51.3-28.6-75.2C253.9 62.3 235.4 43.4 224 32.6zM224 216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm-6.2 183.2c-8.2 35.9-22.6 61.3-30.9 73.9c-9.1 13.7-28.8 13.7-37.9 0c-8.3-12.5-22.7-38-30.9-73.9c10.3-3.1 20.4-7.2 30-12.5c4.8 24 12.9 42.9 19.8 55.7c6.9-12.9 15-31.7 19.8-55.7c9.7 5.3 19.8 9.4 30 12.5zM9.9 105.4c14.7-1.9 44.2-2.8 82.7 10c-2.6 10.4-4.2 21.2-4.5 32.3c-25.6-9.3-46.4-11.4-60.4-11.3c6.4 11.1 17.2 26.4 35 42.3c-9.1 6.1-17.4 13.1-24.9 20.6C10.4 173.6-2.5 149.3-8 136.3c-5.8-13.8 3-29.1 17.9-31zm375.4 73.3c17.8-16 28.7-31.2 35.1-42.4c-14 0-34.9 2.1-60.4 11.3c-.3-11.1-2-21.9-4.5-32.3c38.5-12.8 68-11.8 82.7-10c14.9 1.9 23.7 17.1 17.9 31c-5.5 13-18.4 37.4-45.9 63c-7.5-7.6-15.7-14.6-24.9-20.6z"]
};
var faMusicSlash = {
  prefix: 'fal',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", "M575.5 376.2c.3-2.7 .5-5.4 .5-8.2V136.4l0-.3 0-.5V23c0-12.7-10.3-23-23-23c-2.3 0-4.6 .3-6.8 1l-311 95.7c-3 .9-5.6 2.7-7.5 5L256 123.9v-.1L544 35.2v89L337 187.9 367.5 212 544 157.7V308.4c-17-12.7-39.4-20.4-64-20.4c-5.1 0-10.1 .3-15 1l48 37.9c9.6 4.5 17.2 10.7 22.4 17.7l40.1 31.7zM256 287l-32-25.3V372.4c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V287zm-96 97c41.1 0 64 26.7 64 48s-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTruckRamp = {
  prefix: 'fal',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", "M432 0c-44.2 0-80 35.8-80 80V384c0 1.3 .2 2.5 .4 3.7L11.8 480.6C3.3 482.9-1.8 491.7 .6 500.2s11.1 13.6 19.6 11.2L416.1 403.6C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5 .1L384 379.1V80c0-26.5 21.5-48 48-48H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faBinoculars = {
  prefix: 'fal',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M112 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H336zM192 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V356.9c0-28.8 7.8-57.1 22.7-81.9c16-26.6 26.2-56.3 30.1-87.1L90.5 142c1-8 7.8-14 15.9-14H192v16V272 432zm32 0V288h64V432c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V356.9c0-34.6-9.4-68.6-27.2-98.3c-13.7-22.8-22.5-48.2-25.8-74.6L453.3 138c-3-24-23.4-42-47.6-42H312c-13.3 0-24 10.7-24 24v8H224v-8c0-13.3-10.7-24-24-24H106.4c-24.2 0-44.6 18-47.6 42L53 184c-3.3 26.4-12.1 51.8-25.8 74.6C9.4 288.3 0 322.3 0 356.9V432c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48zm0-176V160h64v96H224zm96 16V144 128h85.6c8.1 0 14.9 6 15.9 14l5.7 45.9c3.9 30.8 14.1 60.5 30.1 87.1c14.8 24.7 22.7 53 22.7 81.9V432c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V272z"]
};
var faMicrophoneSlash = {
  prefix: 'fal',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M474.8 296.7c3.4-13 5.2-26.6 5.2-40.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 6.3-.5 12.4-1.3 18.5l28.1 22.2zM416 250.2V96c0-53-43-96-96-96s-96 43-96 96v2.7l32 25.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64V225l32 25.3zM192 236.5l-32-25.3V256c0 83 63.1 151.2 144 159.2V480H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V415.2c21.3-2.1 41.4-8.4 59.5-18.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128V236.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faBoxTissue = {
  prefix: 'fal',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M208 32c12.6 0 17.5 3.4 20.5 6.2c4.7 4.4 8.4 11.1 14.9 24.1l.7 1.5c5.5 11 13.7 27.5 27.4 40.4c16 15.2 37.1 23.8 64.5 23.8h77.5L343.1 304H165L97 32H208zM120 256l12 48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H377.6l19.2-48 12.8-32 36.5-91.2c1.3-3.2 1.9-6.6 1.9-10C448 108 436 96 421.2 96H336c-40 0-52-24-64-48S248 0 208 0H92.5C76.8 0 64 12.8 64 28.5c0 2.3 .3 4.7 .9 6.9L112 224l8 32zm-33 0l-8-32H48c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H444.1l-12.8 32H464c8.8 0 16 7.2 16 16V384H32V272c0-8.8 7.2-16 16-16H87zM32 416H480v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416z"]
};
var faCircleC = {
  prefix: 'fal',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM188.1 323.9c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-37.5 37.5-98.3 37.5-135.8 0z"]
};
var faStarChristmas = {
  prefix: 'fal',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M216.8 205.4L256 55.1l39.2 150.4c1.4 5.5 5.8 9.9 11.3 11.3L456.9 256 306.6 295.2c-5.5 1.4-9.9 5.8-11.3 11.3L256 456.9 216.8 306.6c-1.4-5.5-5.8-9.9-11.3-11.3L55.1 256l150.4-39.2c5.5-1.4 9.9-5.8 11.3-11.3zM256 .2c-10.8 0-20.3 7.3-23.1 17.8l0 0L188.5 188.5 18 232.9l0 0C7.5 235.7 .2 245.2 .2 256s7.3 20.3 17.8 23.1l0 0 170.5 44.5L232.9 494c2.7 10.5 12.2 17.8 23.1 17.8s20.3-7.3 23.1-17.8l44.5-170.5L494 279.1c10.5-2.7 17.8-12.2 17.8-23.1s-7.3-20.3-17.8-23.1L323.5 188.5 279.1 18l0 0C276.3 7.5 266.8 .2 256 .2zM68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm374.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm-288 310.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm201.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faChartBullet = {
  prefix: 'fal',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M272 32c8.8 0 16 7.2 16 16V64H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H48c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64H256V48c0-8.8 7.2-16 16-16zM160 96v96h96V96H160zm128 0v96H464c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H288zM128 96H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h80V96zM368 256c8.8 0 16 7.2 16 16v16h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H352V272c0-8.8 7.2-16 16-16zM224 416H352V320H224v96zm160-96v96h80c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H384zm-192 0H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H192V320z"]
};
var faMotorcycle = {
  prefix: 'fal',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M411.8 96H480V64H453.4L411.8 96zM488 128H412.2L467 232.1c14-5.3 29.2-8.1 45-8.1c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128c0-43.4 21.6-81.8 54.7-104.9l-15-28.5C380.5 247.2 352 296.3 352 352v16c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16v-8c0-92.8-75.2-168-168-168H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h72c41.4 0 79.9 12.6 111.8 34.1l127.4-98L342.3 64H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h70.3c11.9 0 22.8 6.6 28.3 17.1L385 76.3 436.1 37c4.2-3.2 9.3-5 14.6-5H488c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zM257.5 214.7c36.7 34.7 60.2 83.3 62.4 137.3h.2c0-68 35.4-127.8 88.7-161.9l-34.4-65.3L257.5 214.7zM497.8 359.5l-44.1-83.8c-23 17.5-37.8 45.2-37.8 76.3c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-10.5 0-20.5 1.7-29.9 4.8l44.1 83.8c4.1 7.8 1.1 17.5-6.7 21.6s-17.5 1.1-21.6-6.7zM128 256c-53 0-96 43-96 96s43 96 96 96c47.6 0 87.1-34.6 94.7-80h-67c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16h67c-7.6-45.4-47.1-80-94.7-80zM0 352a128 128 0 1 1 256 0A128 128 0 1 1 0 352z"]
};
var faTreeChristmas = {
  prefix: 'fal',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", "M212.3 75c-1.6 4.3-5 7.7-9.4 9.4L171.8 96 203 107.7c4.3 1.6 7.7 5 9.4 9.4L224 148.2 235.7 117c1.6-4.3 5-7.7 9.4-9.4L276.2 96 245 84.3c-4.3-1.6-7.7-5-9.4-9.4L224 43.8 212.3 75zM224 0c10.7 0 20.2 6.6 24 16.6l15.1 40.3L303.4 72c10 3.7 16.6 13.3 16.6 24s-6.6 20.2-16.6 24l-40.3 15.1L248 175.4c-3.7 10-13.3 16.6-24 16.6s-20.2-6.6-24-16.6l-15.1-40.3L144.6 120c-10-3.7-16.6-13.3-16.6-24s6.6-20.2 16.6-24l40.3-15.1L200 16.6C203.8 6.6 213.3 0 224 0zM27.9 307.9l107-157.4 25.1 9.4 2.5 6.8L58.4 320h49.8c5.8 0 11.2 3.2 14 8.3s2.6 11.4-.6 16.3L35 480H413L326.4 344.6c-3.2-4.9-3.4-11.2-.6-16.3s8.2-8.3 14-8.3h48.8L285.3 167.1l2.7-7.2 24.8-9.3L419.4 308.3c2.8 4.2 4.5 9 4.8 14c1 16.1-11.8 29.7-28 29.7H369.1l74.4 116.3c2.9 4.6 4.5 9.9 4.5 15.3c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6c0-5.4 1.6-10.7 4.5-15.3L78.9 352H51.3C35.7 352 23 339.4 23 323.8c0-5.7 1.7-11.2 4.9-15.9zM160 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTireFlat = {
  prefix: 'fal',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M32 460.2c0 10.9 8.9 19.8 19.8 19.8H132 380h80.2c10.9 0 19.8-8.9 19.8-19.8c0-3.1-.7-6.1-2.1-8.8L460.2 416c-5.6-11.1-5.5-23.9-.6-34.7c13-28.4 20.3-60 20.3-93.3C480 164.3 379.7 64 256 64S32 164.3 32 288c0 33.4 7.3 65 20.3 93.3c5 10.8 5 23.6-.6 34.7L34.1 451.4 5.8 437.3l28.3 14.1c-1.4 2.7-2.1 5.8-2.1 8.8zM512 288c0 38.1-8.3 74.2-23.2 106.7c-1 2.2-1 4.8 .1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2c0 28.6-23.2 51.8-51.8 51.8H380 132 51.8C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8 .1-7C8.3 362.2 0 326.1 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256zm-128 0c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2zm-74.1 34.4c-8.6 13.5-22.1 23.5-38 27.6l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zm-70 27.5c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4l0-65zM128 288c0 8.3 .8 16.3 2.3 24.2L192.1 292c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm128-64c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM96 288a160 160 0 1 1 320 0A160 160 0 1 1 96 288zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSunglasses = {
  prefix: 'fal',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M86.3 87.6C89.9 73.7 102.4 64 116.8 64c4.9 0 9.7 1.1 14.1 3.3l22 11c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-22-11c-8.8-4.4-18.5-6.7-28.4-6.7c-29 0-54.2 19.6-61.5 47.6L4.6 276.3C1.6 287.9 0 299.8 0 311.8l0 .2v.2V352v16c0 61.9 50.1 112 112 112h44.3c59.4 0 108.5-46.4 111.8-105.8l3.4-54.2h32.9l3.4 54.2C311.1 433.6 360.2 480 419.7 480H464c61.9 0 112-50.1 112-112V352.5l0-.5V312.2c0-12.1-1.5-24.2-4.6-36L520.7 79.6c-7.2-28-32.5-47.6-61.5-47.6c-9.9 0-19.6 2.3-28.4 6.7l-22 11c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l22-11c4.4-2.2 9.2-3.3 14.1-3.3c14.4 0 26.9 9.7 30.5 23.6l48.2 186.8c-31-12-65-18.4-97.6-18.4c-40.1 0-82.2 9.6-118.5 27.3c-2.6 1.3-4.9 2.9-7 4.7H261.1c-2.1-1.8-4.4-3.4-7-4.7C217.9 265.6 175.8 256 135.7 256c-32.6 0-66.6 6.3-97.6 18.4L86.3 87.6zM32 312.2l0-.2c31.4-15.6 68.6-24 103.7-24c35.3 0 72.5 8.5 104.3 24c0 0 0 0 0 .1l0 0-3.8 60.2 0 0 0 .2c-2.4 42.4-37.4 75.6-79.9 75.6H112c-7.7 0-15.1-1.1-22.1-3.1l9.2-4.6 12-6 24-12 48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-48 24-24 12-12 6-12 6-12 6c-1.4 .7-2.6 1.6-3.7 2.5c-8.1-7.7-14.6-17-19-27.5c.3-.1 .7-.3 1-.5l96-48c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L32 366.1V352 312.2zM544 368c0 44.2-35.8 80-80 80H419.7c-8.5 0-16.7-1.3-24.3-3.8l91.8-45.9c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-96 48-12 6c-.6 .3-1.1 .6-1.7 1c-7.7-7.7-13.9-17-18-27.4l93.9-47c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-85.6 42.8L336 312l0 0c0 0 0 0 0-.1c31.8-15.5 69-24 104.3-24c35.1 0 72.2 8.4 103.7 24v56z"]
};
var faBadge = {
  prefix: 'fal',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M256 32c-28.3 0-53 15.9-65.4 39.4c-3.6 6.8-11.5 10.1-18.8 7.8c-25.4-7.8-54.1-1.6-74.1 18.4s-26.2 48.7-18.4 74.1c2.3 7.3-1 15.2-7.8 18.8C47.9 203 32 227.7 32 256s15.9 53 39.4 65.4c6.8 3.6 10.1 11.5 7.8 18.8c-7.8 25.4-1.6 54.1 18.4 74.1s48.7 26.2 74.1 18.4c7.3-2.3 15.2 1 18.8 7.8C203 464.1 227.7 480 256 480s53-15.9 65.4-39.4c3.6-6.8 11.5-10.1 18.8-7.8c25.4 7.8 54.1 1.6 74.1-18.4s26.2-48.7 18.4-74.1c-2.3-7.3 1-15.2 7.8-18.8C464.1 309 480 284.3 480 256s-15.9-53-39.4-65.4c-6.8-3.6-10.1-11.5-7.8-18.8c7.8-25.4 1.6-54.1-18.4-74.1s-48.7-26.2-74.1-18.4c-7.3 2.3-15.2-1-18.8-7.8C309 47.9 284.3 32 256 32zM168.9 45.6C188 18.1 219.9 0 256 0s68 18.1 87.1 45.6c33-6 68.3 3.8 93.9 29.4s35.3 60.9 29.4 93.9C493.9 188 512 219.9 512 256s-18.1 68-45.6 87.1c6 33-3.8 68.3-29.4 93.9s-60.9 35.3-93.9 29.4C324 493.9 292.1 512 256 512s-68-18.1-87.1-45.6c-33 6-68.3-3.8-93.9-29.4s-35.3-60.9-29.4-93.9C18.1 324 0 292.1 0 256s18.1-68 45.6-87.1c-6-33 3.8-68.3 29.4-93.9s60.9-35.3 93.9-29.4z"]
};
var faMessagePen = {
  prefix: 'fal',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM316.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zM207.1 239.1l60.7-60.7 17.8 17.8L224.8 257c-2.1 2.1-4.6 3.5-7.4 4.2L198 266l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 125l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63c-17.4-17.4-45.7-17.4-63.1 0z"]
};
var faCommentAltEdit = faMessagePen;
var faMessageEdit = faMessagePen;
var faBellConcierge = {
  prefix: 'fal',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48.6C123.8 152.8 32 249.7 32 368v16H64V368c0-106 86-192 192-192s192 86 192 192v16h32V368c0-118.3-91.8-215.2-208-223.4V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 208zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faConciergeBell = faBellConcierge;
var faPenRuler = {
  prefix: 'fal',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", "M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4 417.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L429.8 39.6zM83.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L39.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM82.7 27.3c25-25 65.5-25 90.5 0l70.9 70.9-22.6 22.6L189.7 89l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L167 66.3 150.6 49.9c-12.5-12.5-32.8-12.5-45.3 0L49.9 105.4c-12.5 12.5-12.5 32.8 0 45.3l70.9 70.9L98.2 244.1 27.3 173.3c-25-25-25-65.5 0-90.5L82.7 27.3zm256 457.4l-70.9-70.9 22.6-22.6 70.9 70.9c12.5 12.5 32.8 12.5 45.3 0l55.4-55.4c12.5-12.5 12.5-32.8 0-45.3L445.7 345l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L423 322.3l-31.8-31.8 22.6-22.6 70.9 70.9c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0z"]
};
var faPencilRuler = faPenRuler;
var faArrowProgress = {
  prefix: 'fal',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M281.6 3.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L288 48H112C50.1 48 0 98.1 0 160s50.1 112 112 112H400c44.2 0 80 35.8 80 80c0 39.5-28.7 72.3-66.3 78.8c-7.5-27-32.3-46.8-61.7-46.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c30.1 0 55.4-20.8 62.2-48.9C469.4 456.1 512 409 512 352c0-61.9-50.1-112-112-112H112c-44.2 0-80-35.8-80-80s35.8-80 80-80H288L262.4 99.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48zM351.9 480a32 32 0 1 1 .1-64 32 32 0 1 1 -.1 64zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM126 432c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h66l-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L192 432H126zM32 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faChessRookPiece = {
  prefix: 'fal',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M16 112c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16V224c0 3.7-1.3 7.4-3.7 10.2l-35.9 43.1 4.4 74.6H236.7L232 272.9c-.2-4.1 1.1-8.1 3.7-11.2L272 218.2V128H224v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H128v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H48v90.2l36.3 43.6c2.6 3.1 3.9 7.1 3.7 11.2L83.3 352H51.3l4.4-74.6L19.7 234.2c-2.4-2.9-3.7-6.5-3.7-10.2V112zm144 96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H280.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L254.2 416 65.8 416 33.1 468.7zM254.2 384c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H254.2z"]
};
var faChessRookAlt = faChessRookPiece;
var faSquareRoot = {
  prefix: 'fal',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4L82.9 264.4c-2.8-5.2-8.2-8.4-14.1-8.4H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H68.8c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7C311.9 46.1 330.7 32 352.1 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H352.1z"]
};
var faAlbumCollectionCirclePlus = {
  prefix: 'fal',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", "M32 16c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512H394.8c-12.9-9.1-24.5-19.9-34.6-32H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272C34.6 172.1 45.7 160 59.8 160H452.2c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2c3.9 0 7.8 .1 11.7 .4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1H59.8zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4c-3.9-9.9-6.9-20.2-9-30.8C304.4 410.6 281.7 416 256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9c6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20zm128 24a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faPeopleArrows = {
  prefix: 'fal',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", "M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320h45.2c2.3 6.6 6.1 12.7 11.3 17.9L156.1 352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c28.3 0 53.4 14.8 67.7 37.3c-4.3 2.2-8.4 5.1-12 8.8l-12.6 12.6c-7.9-15.9-24.3-26.7-43-26.7H105.6zM160 496V355.9l32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm288 0V387.9l32-32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96-144H483.9l14.1-14.1c5.2-5.2 9-11.4 11.3-17.9h45.2c18.7 0 33.4-16 31.9-34.7L582.2 236c-2.1-24.9-22.9-44-47.8-44H489.6c-18.7 0-35.1 10.8-43 26.7l-12.6-12.6c-3.6-3.6-7.7-6.5-12-8.8c14.2-22.5 39.3-37.3 67.7-37.3h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352zM512 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM251.3 251.3L214.6 288H425.4l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L425.4 320H214.6l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faFaceAngryHorns = {
  prefix: 'fal',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM552.4 148.6c-12.2-26.4-28.8-50.4-48.8-71c13.1-3 27.6-6.8 42.3-11.2c17.7-5.3 36.2-11.7 53.2-19.1c-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2c-20 20.6-36.6 44.6-48.8 71C65.5 114.3 50.2 76.2 40.9 47.3c17 7.4 35.5 13.8 53.2 19.1zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faMarsAndVenusBurst = {
  prefix: 'fal',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M528 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4l-75.6 75.6C481.1 80.6 442.5 64 400 64c-88.4 0-160 71.6-160 160c0 83 63.1 151.2 144 159.2V416H344c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L608 54.6V104c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H528zM272 224a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM176 8c-6.3 0-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.1 3.4 9.5 4.5 14.5 3.1c-13.9-17.5-24.9-37.4-32-59.1l-31.5-26.1c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l24.2-6c11.2-16.3 24.9-30.8 40.5-43L222.6 87.2 190.5 17.3C187.9 11.6 182.3 8 176 8z"]
};
var faTombstone = {
  prefix: 'fal',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M384 448V192c0-88.4-71.6-160-160-160S64 103.6 64 192V448H32V192C32 86 118 0 224 0S416 86 416 192V448H384zM0 496c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM240 144v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSquareCaretRight = {
  prefix: 'fal',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 9.6-4 18.7-11 25.2L206.2 376.7c-5.1 4.7-11.8 7.3-18.7 7.3c-15.2 0-27.5-12.3-27.5-27.5l0-201c0-15.2 12.3-27.5 27.5-27.5c6.9 0 13.6 2.6 18.7 7.3L309 230.8c7 6.5 11 15.6 11 25.2zm-32.7-1.7L192 165.8l0 180.3 95.3-88.4c.5-.4 .7-1.1 .7-1.7s-.3-1.3-.7-1.7z"]
};
var faCaretSquareRight = faSquareCaretRight;
var faScissors = {
  prefix: 'fal',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M508.2 442.4c5.7-6.7 4.9-16.8-1.8-22.6l-152-129.3c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6l152 129.3c6.7 5.7 16.8 4.9 22.6-1.8zM287 235.1l-78.5-66.1c9.9-16.7 15.5-36.2 15.5-56.9C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c29.5 0 56.4-11.4 76.4-30.1L262.2 256l-73.8 62.1c-20-18.7-46.9-30.1-76.4-30.1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-20.8-5.7-40.3-15.5-56.9L506.3 92.2c6.8-5.7 7.6-15.8 1.9-22.5s-15.8-7.6-22.5-1.9L287 235.1zM112 192a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faCut = faScissors;
var faListMusic = {
  prefix: 'fal',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", "M489.1 0C501.8 0 512 10.2 512 22.9V136c0 6.9-4.5 13.1-11.1 15.2L384 188.9V432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c31.3 0 59.7 9.2 80 24V56c0-6.9 4.4-13 10.9-15.2L481.9 1.2c2.3-.8 4.8-1.2 7.2-1.2zM332.6 401.5C318.3 391.3 297 384 272 384s-46.3 7.3-60.6 17.5C197.1 411.7 192 422.9 192 432s5.1 20.3 19.4 30.5C225.7 472.7 247 480 272 480s46.3-7.3 60.6-17.5C346.9 452.3 352 441.1 352 432s-5.1-20.3-19.4-30.5zM384 155.3l96-30.9V35.5l-96 32v87.8zM16 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSunPlantWilt = {
  prefix: 'fal',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M160.5 0c-5.9 0-11.3 3.2-14.1 8.4l-27.5 51L63.4 42.7c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.6 55.4-51 27.5c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51 27.5L43.5 256.7c-1.7 5.6-.2 11.7 4 15.9s10.3 5.7 15.9 4L118.9 260l27.5 51c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l27.5-51 55.6 16.6c5.6 1.7 11.7 .1 15.9-4s5.7-10.3 4-15.9l-16.6-55.4 51-27.5c5.2-2.8 8.4-8.2 8.4-14.1s-3.2-11.3-8.4-14.1l-51-27.5 16.6-55.4c1.7-5.6 .2-11.7-4-15.9s-10.3-5.7-15.9-4L202.1 59.4l-27.5-51C171.8 3.2 166.4 0 160.5 0zm0 49.7L180.1 86c3.6 6.7 11.4 9.9 18.7 7.7l39.6-11.8-11.9 39.5c-2.2 7.3 1.1 15.1 7.7 18.7l36.3 19.6-36.3 19.6c-6.7 3.6-9.9 11.4-7.7 18.7l11.9 39.5-39.6-11.8c-7.3-2.2-15.1 1.1-18.7 7.7l-19.6 36.3-19.6-36.3c-3.6-6.7-11.4-9.9-18.7-7.7L82.6 237.4l11.9-39.5c2.2-7.3-1.1-15.1-7.7-18.7L50.4 159.7l36.3-19.6c6.7-3.6 9.9-11.4 7.7-18.7L82.6 81.9l39.6 11.8c7.3 2.2 15.1-1.1 18.7-7.7l19.6-36.3zm32.6 111.2a32 32 0 1 0 -63.9 0 32 32 0 1 0 63.9 0zm303.7 .1c0-17.6 14.3-32 32-32s32 14.3 32 32v49.5c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.4 15.1 22.3 30.7 36.5 44.1c6.2 5.8 15.8 5.8 22 0c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2V160.9c0-35.3-28.6-64-64-64s-64 28.6-64 64v43.9c-11.4-7.6-25.2-12.1-39.9-12.1c-39.7 0-71.9 32.2-71.9 71.9v9.6c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.5 15.1 22.3 30.7 36.5 44.1c6.2 5.8 15.8 5.8 22 0c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2v-9.6c0-22.1 17.9-39.9 39.9-39.9s39.9 17.9 39.9 39.9v15.9V480.1H17.3c-8.8 0-16 7.2-16 16s7.2 16 16 16H480.8 624.7c8.8 0 16-7.2 16-16s-7.2-16-16-16H496.8V280.6 264.7 160.9zM368.9 304.6c10.6 0 18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4zM597 302.9c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4s18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3z"]
};
var faToiletsPortable = {
  prefix: 'fal',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", "M64 32H192c17.7 0 32 14.3 32 32V96H32V64c0-17.7 14.3-32 32-32zM32 448V128H224v80H200c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h24V448H32zM256 208V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V480H224v16c0 8.8 7.2 16 16 16s16-7.2 16-16V336 304 240 208zm-32 32v64H200c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8h24zM384 32H512c17.7 0 32 14.3 32 32V96H352V64c0-17.7 14.3-32 32-32zM352 448V128H544v80H520c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h24V448H352zM576 208V64c0-35.3-28.7-64-64-64H384c-35.3 0-64 28.7-64 64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V480H544v16c0 8.8 7.2 16 16 16s16-7.2 16-16V336 304 240 208zm-32 32v64H520c-4.4 0-8-3.6-8-8V248c0-4.4 3.6-8 8-8h24z"]
};
var faHockeyPuck = {
  prefix: 'fal',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M32 184c0 9 4.1 18.9 14.3 29.3c10.2 10.5 25.8 20.7 46.3 29.6c41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 202.9 480 193 480 184s-4.1-18.9-14.3-29.3c-10.2-10.5-25.8-20.7-46.3-29.6C378.4 107.4 320.6 96 256 96s-122.4 11.4-163.3 29.1c-20.5 8.9-36.1 19.1-46.3 29.6C36.1 165.1 32 175 32 184zM0 184c0-19.7 9.3-37.2 23.4-51.7C37.5 117.9 57 105.7 79.9 95.8C125.8 75.9 188.1 64 256 64s130.2 11.9 176.1 31.8c22.9 9.9 42.5 22.2 56.5 36.6c14.1 14.5 23.4 32 23.4 51.7V328c0 19.7-9.3 37.2-23.4 51.7c-14.1 14.4-33.6 26.6-56.5 36.6C386.2 436.1 323.9 448 256 448s-130.2-11.9-176.1-31.8c-22.9-9.9-42.5-22.2-56.5-36.6C9.3 365.2 0 347.7 0 328V184zm480 59.6c-13 11-29.4 20.6-47.9 28.6C386.2 292.1 323.9 304 256 304s-130.2-11.9-176.1-31.8c-18.6-8-34.9-17.6-47.9-28.6V328c0 9 4.1 18.9 14.3 29.3c10.2 10.5 25.8 20.7 46.3 29.6c41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 346.9 480 337 480 328V243.6z"]
};
var faMustache = {
  prefix: 'fal',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M235 112c-31.7 0-62.2 12.6-84.6 35.1c-31.6 31.6-81.9 34.4-116.8 6.5l-7.5-6c-5.1-4.1-12-4.5-17.5-1.6c-1.4 .7-2.7 1.7-3.8 2.8C1.8 151.6 0 155.6 0 160v44C0 312.2 87.8 400 196 400c42.4 0 83.7-13.8 117.6-39.2L320 356l6.4 4.8C360.3 386.2 401.6 400 444 400c108.2 0 196-87.8 196-196V160c0-4.4-1.8-8.4-4.6-11.3c-1.1-1.2-2.4-2.1-3.8-2.8c-5.5-2.9-12.4-2.5-17.5 1.6l-7.5 6c-34.9 27.9-85.2 25.1-116.8-6.5C467.2 124.6 436.8 112 405 112h-3.3c-25.2 0-49.8 7.5-70.8 21.4l-11 7.3-11-7.3c-21-14-45.6-21.4-70.8-21.4H235zm373 78.7V204c0 90.6-73.4 164-164 164c-35.5 0-70-11.5-98.4-32.8l-16-12c-5.7-4.3-13.5-4.3-19.2 0l-16 12C266 356.5 231.5 368 196 368c-90.6 0-164-73.4-164-164V190.7c45.7 24.4 103.1 16.8 140.9-21c16.4-16.4 38.8-25.7 62-25.7h3.3c18.9 0 37.3 5.6 53 16.1l19.9 13.3c5.4 3.6 12.4 3.6 17.8 0l19.9-13.3c15.7-10.5 34.1-16.1 53-16.1H405c23.3 0 45.6 9.2 62 25.7c37.8 37.8 95.3 45.4 140.9 21z"]
};
var faHyphen = {
  prefix: 'fal',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 256c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faTable = {
  prefix: 'fal',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M64 64C46.3 64 32 78.3 32 96l0 64 448 0V96c0-17.7-14.3-32-32-32L64 64zM32 192l0 112 208 0 0-112L32 192zm240 0l0 112H480l0-112-208 0zM240 336L32 336l0 80c0 17.7 14.3 32 32 32l176 0V336zm32 112H448c17.7 0 32-14.3 32-32V336H272V448zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
var faUserChef = {
  prefix: 'fal',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M96 64c0 13.9 8.9 25.8 21.3 30.2c6.4 2.3 10.7 8.3 10.7 15.1V144H320V109.3c0-6.8 4.3-12.8 10.7-15.1C343.1 89.8 352 77.9 352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32zM128 0c19.1 0 36.3 8.4 48 21.7C187.7 8.4 204.9 0 224 0s36.3 8.4 48 21.7C283.7 8.4 300.9 0 320 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V160v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V160 119.4C76.9 108.4 64 87.7 64 64C64 28.7 92.7 0 128 0zm96 272c53 0 96-43 96-96H128c0 53 43 96 96 96zM112 372.6c0 7.1-4.7 13.3-11.4 15.3C60.9 399.8 32 436.5 32 480h96V436.5c0-18.7 10.9-35.7 27.9-43.6l33.4-15.4L112 341.4v31.2zM160 480H416c0-43.5-28.9-80.2-68.6-92c-6.8-2-11.4-8.3-11.4-15.3V345L169.3 421.9c-5.7 2.6-9.3 8.3-9.3 14.5V480zM337.3 309.1l-1.4-3c3-1.4 6.2-2.1 9.5-2.1c12.5 0 22.5 10.1 22.5 22.5v34.8c46.9 19 80 65 80 118.7c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-53.7 33.1-99.7 80-118.7V326.5c0-12.5 10.1-22.5 22.5-22.5c3.3 0 6.5 .7 9.5 2.1L224 358.3l111.9-52.2 1.4 3zM240 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faMessageImage = {
  prefix: 'fal',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm135.9 32.1L380.3 288H131.5l44.6-63.8 19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5zm-25.5-19.4L208 213.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7c-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2c0 15.6 12.6 28.2 28.2 28.2H387.9c15.5 0 28.1-12.6 28.1-28.1c0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2c-10 0-19.4 4.7-25.5 12.7z"]
};
var faCommentAltImage = faMessageImage;
var faUsersMedical = {
  prefix: 'fal',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zM64 80a80 80 0 1 1 160 0A80 80 0 1 1 64 80zM320 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM261.3 384c-54.2 0-98.4 42.5-101.2 96H448c0 11.7 3.1 22.6 8.6 32H154.7c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352H378.7c4.6 0 9.1 .2 13.5 .7c-5.2 9.3-8.2 19.9-8.2 31.3v.1c-1.8-.1-3.5-.1-5.3-.1H261.3zM512 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zm16 224H448c0-11-1.4-21.8-4-32h84c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80zm-336 0H112c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112h84c-2.6 10.2-4 21-4 32zm320 64h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H576v32c0 17.7-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V448H448c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32h32V320c0-17.7 14.3-32 32-32zm0 80c0 8.8-7.2 16-16 16H448v32h48c8.8 0 16 7.2 16 16v48h32V432c0-8.8 7.2-16 16-16h48V384H560c-8.8 0-16-7.2-16-16V320H512v48z"]
};
var faSensorTriangleExclamation = {
  prefix: 'fal',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M64 64H384c17.7 0 32 14.3 32 32v39.4c9.8-4.8 20.7-7.4 32-7.4V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H225c-.6-4-1-8.1-1-12.3c0-6.7 .9-13.3 2.6-19.7H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm291.8 36.9C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3H595.7c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265zM440 196.7c1.6-2.9 4.7-4.7 8-4.7s6.4 1.8 8 4.7l150.4 265c1 1.9 1.6 3.9 1.6 6.1c0 6.8-5.5 12.3-12.3 12.3H300.3c-6.8 0-12.3-5.5-12.3-12.3c0-2.1 .6-4.2 1.6-6.1L440 196.7zM464 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM448 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSensorAlert = faSensorTriangleExclamation;
var faMagnifyingGlassArrowRight = {
  prefix: 'fal',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm27.3-299.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 192H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H265.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faTachographDigital = {
  prefix: 'fal',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm96 32v64H320V160H96zm-32 0c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160zm0 208c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDigitalTachograph = faTachographDigital;
var faFaceMask = {
  prefix: 'fal',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", "M444.8 416C404.4 455.6 349 480 288 480s-116.4-24.4-156.8-64h18.2c9 18.9 28.3 32 50.6 32H376c22.3 0 41.6-13.1 50.6-32h18.2zm27.1-32H432V312c0-3.8-.4-7.5-1.1-11l.6 1.2L512 259.2c-.7 46.4-15.4 89.3-40.1 124.8zm37.9-159.9l-92.9 49.6C406.6 262.8 392.1 256 376 256H200c-16.1 0-30.6 6.8-40.8 17.7L66.2 224.1C81.7 115.5 175.1 32 288 32s206.3 83.5 221.8 192.1zm29.9-15.5C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9c-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6c-3.6-6.8-11.4-9.9-18.5-7.9zM64 259.2l80.4 42.9 .6-1.2c-.7 3.6-1.1 7.3-1.1 11v72H104.1C79.4 348.5 64.7 305.6 64 259.2zM376 288c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V312c0-13.3 10.7-24 24-24H376zM200 328c0 8.8 7.2 16 16 16H360c8.8 0 16-7.2 16-16s-7.2-16-16-16H216c-8.8 0-16 7.2-16 16zm0 48c0 8.8 7.2 16 16 16H360c8.8 0 16-7.2 16-16s-7.2-16-16-16H216c-8.8 0-16 7.2-16 16zm40-200c8.8 0 16-7.2 16-16s-7.2-16-16-16c-55.4 0-93.6 23-107.3 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C162.9 195.7 193 176 240 176zm180.7 27.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C429.6 167 391.4 144 336 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c47 0 77.1 19.7 84.7 27.3z"]
};
var faPickleball = {
  prefix: 'fal',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M363.6 50.7c-25-25-65.6-25-90.6 0L141 182.3 283.5 324.3c-4.5 11.3-7.8 23.2-9.7 35.5l-155.5-155-3.2 3.2c-13.8 13.7-17.9 34.4-10.4 52.3l24.9 59.8c10 23.9 4.5 51.5-13.9 69.8l-63 62.8c-6.3 6.2-6.3 16.3 0 22.6c6.3 6.2 16.4 6.2 22.7 0l63.3-63c18.3-18.2 45.7-23.7 69.6-13.9l58.5 24c3.4 1.4 6.9 2.4 10.5 3c3 11.4 7.3 22.2 12.6 32.4c-11.8 .7-23.9-1.2-35.3-5.8l-58.5-24c-12-4.9-25.7-2.2-34.8 7L98.1 498c-18.8 18.7-49.2 18.7-68 0s-18.8-49.1 0-67.8l63-62.8c9.2-9.2 11.9-22.9 6.9-34.9L75.1 272.7c-12.5-29.9-5.6-64.3 17.3-87.2L250.3 28.1c37.5-37.4 98.4-37.4 135.9 0L499.8 141.3c29.4 29.3 35.8 72.9 19.1 108.4c-8.9-5.8-18.5-10.7-28.5-14.7c10.4-23.5 6-51.9-13.3-71.1L363.6 50.7zm68.4 429.4a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-64 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-64-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faStarSharpHalf = {
  prefix: 'fal',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M272 93.9L239.2 196.9C237.1 203.5 231 208 224 208H75.3l126 91c5.5 4 7.9 11.1 5.9 17.6L163.5 460.6 272 376.2V93.9zm-8.3-79.5C266.5 5.8 274.4 0 283.4 0C294.8 0 304 9.2 304 20.6V384c0 4.9-2.3 9.6-6.2 12.6l-142.7 111c-3.6 2.8-8.1 4.4-12.7 4.4c-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6C32 187.9 43.9 176 58.6 176H212.3L263.7 14.4z"]
};
var faUsersSlash = {
  prefix: 'fal',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M191.5 73l30.7 24.2c1.2-5.5 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-12.5 0-24.3 2.9-34.9 8l30.7 24.2c1.4-.1 2.8-.2 4.2-.2c24.1 0 44.1 17.8 47.5 41zM135.6 192H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h64.2l-40.5-32zM413 247.9c2-7.6 3-15.6 3-23.9c0-53-43-96-96-96c-16.2 0-31.4 4-44.8 11.1l29 22.9c5.1-1.3 10.4-2 15.8-2c35.3 0 64 28.7 64 64l0 1 29 22.9zM338.3 352H320 261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c13.5 0 24.7-10 26.4-23.1l-34.5-27.3c1.4 5.9 2.3 12.1 2.6 18.3H160.1c2.8-53.5 47-96 101.2-96H378.7l.2 0-40.5-32zM464 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM448 224h80c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faClover = {
  prefix: 'fal',
  iconName: 'clover',
  icon: [448, 512, [], "e139", "M171.3 64c-17.1 0-31 13.9-31 31v3.3c0 7.9 2 15.7 5.8 22.6L190 200.3c3.4 6.2 2.4 14-2.7 19.1s-12.8 6.1-19.1 2.7L88.9 178.1c-6.9-3.8-14.7-5.8-22.6-5.8H63c-17.1 0-31 13.9-31 31c0 8.2 3.3 16.1 9.1 21.9l19.5 19.5c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L41.1 286.8c-5.8 5.8-9.1 13.7-9.1 21.9c0 17.1 13.9 31 31 31h3.3c7.9 0 15.7-2 22.6-5.8L168.3 290c6.2-3.4 14-2.4 19.1 2.7s6.1 12.8 2.7 19.1l-43.9 79.4c-3.8 6.9-5.8 14.7-5.8 22.6V417c0 17.1 13.9 31 31 31c8.2 0 16.1-3.3 21.9-9.1l19.5-19.5c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l19.5 19.5c5.8 5.8 13.7 9.1 21.9 9.1c17.1 0 31-13.9 31-31v-3.3c0-7.9-2-15.7-5.8-22.6L258 311.7c-3.4-6.2-2.4-14 2.7-19.1s12.8-6.1 19.1-2.7l79.4 43.9c6.9 3.8 14.7 5.8 22.6 5.8H385c17.1 0 31-13.9 31-31c0-8.2-3.3-16.1-9.1-21.9l-19.5-19.5c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l19.5-19.5c5.8-5.8 9.1-13.7 9.1-21.9c0-17.1-13.9-31-31-31h-3.1c-8 0-15.8 2-22.8 5.9L281 222c-6.2 3.5-14 2.4-19-2.6s-6.2-12.7-2.9-19L302 120.9c3.7-6.9 5.7-14.6 5.7-22.4V95c0-17.1-13.9-31-31-31c-8.2 0-16.1 3.3-21.9 9.1L235.3 92.5c-3 3-7.1 4.7-11.3 4.7s-8.3-1.7-11.3-4.7L193.2 73.1c-5.8-5.8-13.7-9.1-21.9-9.1zm-63 31c0-34.8 28.2-63 63-63c16.7 0 32.7 6.6 44.5 18.5l8.2 8.2 8.2-8.2C244 38.6 260 32 276.7 32c34.8 0 63 28.2 63 63v3.5c0 13.1-3.3 26-9.5 37.6l-16.7 31 30-16.8c11.7-6.6 25-10 38.4-10H385c34.8 0 63 28.2 63 63c0 16.7-6.6 32.7-18.5 44.5l-8.2 8.2 8.2 8.2C441.4 276 448 292 448 308.7c0 34.8-28.2 63-63 63h-3.3c-13.3 0-26.5-3.4-38.1-9.8l-30.8-17 17 30.8c6.5 11.7 9.8 24.8 9.8 38.1V417c0 34.8-28.2 63-63 63c-16.7 0-32.7-6.6-44.5-18.5l-8.2-8.2-8.2 8.2C204 473.4 188 480 171.3 480c-34.8 0-63-28.2-63-63v-3.3c0-13.3 3.4-26.5 9.8-38.1l17-30.8-30.8 17c-11.7 6.5-24.8 9.8-38.1 9.8H63c-34.8 0-63-28.2-63-63C0 292 6.6 276 18.5 264.2l8.2-8.2-8.2-8.2C6.6 236 0 220 0 203.3c0-34.8 28.2-63 63-63h3.3c13.3 0 26.5 3.4 38.1 9.8l30.8 17-17-30.8c-6.5-11.7-9.8-24.8-9.8-38.1V95z"]
};
var faMeat = {
  prefix: 'fal',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M288.9 223.1c30 30 65.3 51.2 99.4 60.2c12.2 3.2 25.2 5 38 4.7l-17.3 17.3c-30 30-70.7 46.8-113.1 46.8H208c-26.5 0-48-21.5-48-48V216c0-42.4 16.9-83.1 46.9-113.1l17.2-17.2c-.3 12.8 1.5 25.8 4.7 38c9 34.1 30.2 69.4 60.2 99.4zm175.8 17.7c-31.2 31.2-99.7 13.1-153.2-40.3s-71.5-122-40.3-153.2c9.9-9.9 23.5-14.8 39.2-15.2c8.9 .2 18.1 1.6 27.1 3.9c28.9 7.6 59.6 25.9 86.1 52.3s44.7 57.2 52.3 86.1c2.3 8.9 3.7 17.9 3.9 26.8c-.4 15.9-5.3 29.6-15.3 39.6zM347.6 4.8c-12-3.2-24.8-5-37.4-4.7c-25.7-.3-52.7 6.9-74 28.2l-52 52c-36 36-56.2 84.8-56.2 135.8v72 16 2.7c0 4.2-1.7 8.3-4.7 11.3l-2 2-.1 0c-.1 0-.5 .1-1.2 .1c-1.5-.1-3.5-.7-5.2-2C102.9 309.3 88.1 304 72 304c-39.8 0-72 32.2-72 72c0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72c0-16.1-5.3-30.9-14.2-42.9c-1.2-1.7-1.9-3.7-2-5.2c0-.7 .1-1.1 .1-1.2l0-.1 2-2c3-3 7.1-4.7 11.3-4.7H208h16 72c50.9 0 99.7-20.2 135.7-56.2l52.1-52.1c21.4-21.4 28.6-48.6 28.1-74.5c.2-12.5-1.6-25-4.7-36.9c-9-34.1-30.2-69.4-60.2-99.4s-65.3-51.2-99.4-60.2zM165.9 372c-10.6 14.6-5.7 33.5 2.2 44.1c4.9 6.7 7.9 14.9 7.9 23.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9c10.7 7.9 29.5 12.8 44.1 2.2c6.5 10.5 15.4 19.4 25.9 25.9zm186-211.9c15.3 15.3 34.9 20.4 43.8 11.5s3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8z"]
};
var faReply = {
  prefix: 'fal',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", "M216 160c-13.3 0-24-10.7-24-24v-8V112 64L32 208 192 352l0-48V288v-8c0-13.3 10.7-24 24-24h8 96c70.7 0 128 57.3 128 128c0 8.3-.7 16.1-2 23.2c18.2-23.4 34-57.1 34-103.2c0-79.5-64.5-144-144-144H224h-8zm8 144v16 32c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2V96v16 16h32 80c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H256 224v16z"]
};
var faMailReply = faReply;
var faStarAndCrescent = {
  prefix: 'fal',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", "M32 256c0 118.4 91.9 215.4 208.3 223.5C151.1 444.4 88 357.6 88 256S151.1 67.6 240.3 32.5C123.9 40.6 32 137.6 32 256zM349.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c33 0 64.6 6.3 93.6 17.7zm16.6 138.5l.3-.5 3.4-6.9 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 3.4 6.9 .3 .5 22.2 45.1c1.4 2.8 4.1 4.8 7.2 5.3l49.7 7.2 .6 .1 7.7 1.1 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-5.5 5.4-.4 .4-36 35.1c-2.3 2.2-3.3 5.4-2.8 8.5l8.5 49.5 .1 .6 1.3 7.6 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-6.8-3.6-.5-.3-44.5-23.4c-2.8-1.5-6.1-1.5-8.9 0L335 361.7l-.5 .3-6.8 3.6-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 1.3-7.6 .1-.6 8.5-49.5c.5-3.1-.5-6.3-2.8-8.5l-36-35.1-.4-.4-5.5-5.4-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 7.7-1.1 .6-.1 49.7-7.2c3.1-.5 5.8-2.4 7.2-5.3l22.2-45.1zm6.5 59.2c-6.1 12.3-17.8 20.8-31.3 22.8l-25.5 3.7 18.4 18c9.8 9.6 14.3 23.3 12 36.8L341.9 322l22.8-12c12.1-6.4 26.6-6.4 38.7 0l22.8 12-4.4-25.4c-2.3-13.5 2.2-27.3 12-36.8l18.4-18-25.5-3.7c-13.5-2-25.3-10.5-31.3-22.8L384 192.3l-11.4 23.1z"]
};
var faEmptySet = {
  prefix: 'fal',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", "M491.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66 66C363.4 52.6 312.1 32 256 32C132.3 32 32 132.3 32 256c0 56.1 20.6 107.4 54.7 146.7l-66 66c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l66-66C148.6 459.4 199.9 480 256 480c123.7 0 224-100.3 224-224c0-56.1-20.6-107.4-54.7-146.7l66-66zM380 109.4L109.4 380C81.1 346.5 64 303.3 64 256C64 150 150 64 256 64c47.3 0 90.5 17.1 124 45.4zM132 402.6L402.6 132c28.3 33.5 45.4 76.7 45.4 124c0 106-86 192-192 192c-47.3 0-90.5-17.1-124-45.4z"]
};
var faHouseFire = {
  prefix: 'fal',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H374.3c-14.2-9.5-27.1-20.9-38.3-33.8V480H240V320h51.6c2.4-10.6 5.9-21.4 10.3-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 408.4 143.6c1.4-1.2 2.7-2.5 4.1-3.7c7.7-6.9 17.2-10.8 26.9-11.7L298.6 4zM509.4 253.5c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2C608 422.4 551 480 480 480c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5C508.6 412 495.7 416 481 416c-19.1 0-35.3-6.1-46.6-16.4C423.3 389.4 416 374.3 416 354c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faSquareMinus = {
  prefix: 'fal',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 240H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMinusSquare = faSquareMinus;
var faHelicopter = {
  prefix: 'fal',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H352v96H144L110.4 83.2C101.3 71.1 87.1 64 72 64H44.8c-21 0-36.3 19.9-30.9 40.2l22.7 85.1c3.7 14 13.6 25.6 26.9 31.5l124.6 55.4c1.8 .8 3.4 1.9 4.8 3.3l90.4 90.4c9 9 21.3 14.1 34 14.1h.5 .5 .5 .5 .5 .4 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4c30.9 0 56-25.1 56-56V272c0-79.5-64.5-144-144-144H384V32H576c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zM72 96c5 0 9.8 2.4 12.8 6.4l38.4 51.2c3 4 7.8 6.4 12.8 6.4H352V352h-.1-.4-.4-.4-.4-.4-.4H349h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H341h-.4-.4-.4-.4-.4-.4H338h-.4-.4-.4-.4-.4-.4H335h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H328h-.4-.4-.4-.4-.4-.4-.4-.4H324h-.4-.4-.4-.4-.4-.4-.4-.5H320h-.4-.5-.5-.5-.5-.5c-4.3 0-8.3-1.7-11.3-4.7l-90.4-90.4c-4.2-4.2-9.1-7.5-14.4-9.9L76.5 191.6c-4.4-2-7.7-5.8-9-10.5L44.8 96H72zM384.4 352H384V160h48c61.9 0 112 50.1 112 112v56c0 13.2-10.8 24-24 24h-.4-.4-.4-.4-.4-.4H517h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H512h-.4-.4-.4-.4H510h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H505h-.4-.4-.4-.4H503h-.4-.4-.4-.4H501h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H489h-.4-.4-.4-.4H487h-.4-.4-.4-.4H485h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H478h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H473h-.4-.4-.4-.4H471h-.4-.4-.4-.4-.4-.4-.4H468h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H463h-.4-.4-.4-.4-.4-.4-.4H460h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H455h-.4-.4-.4-.4-.4-.4-.4H452h-.4-.4-.4-.4-.4-.4-.4H449h-.4-.4-.4-.4-.4-.4-.4H446h-.4-.4-.4-.4-.4-.4-.4H443h-.4-.4-.4-.4-.4-.4-.4H440h-.4-.4-.4-.4-.4-.4-.4H437h-.4-.4-.4-.4-.4-.4-.4H434h-.4-.4-.4-.4-.4-.4-.4H431h-.4-.4-.4-.4-.4-.4-.4H428h-.4-.4-.4-.4-.4-.4-.4H425h-.4-.4-.4-.4-.4-.4-.4H422h-.4-.4-.4-.4-.4-.4-.4H419h-.4-.4-.4-.4-.4-.4-.4H416h-.4-.4-.4-.4-.4-.4-.4H413h-.4-.4-.4-.4-.4-.4-.4H410h-.4-.4-.4-.4-.4-.4-.4H407h-.4-.4-.4-.4-.4-.4-.4H404h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H399h-.4-.4-.4-.4-.4-.4-.4H396h-.4-.4-.4-.4H394h-.4-.4-.4-.4-.4-.4-.4H391h-.4-.4-.4-.4H389h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4zM635.3 475.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-8.6 8.6c-12 12-28.3 18.7-45.3 18.7H240c-8.8 0-16 7.2-16 16s7.2 16 16 16H558.9c25.5 0 49.9-10.1 67.9-28.1l8.6-8.6z"]
};
var faBird = {
  prefix: 'fal',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M32 192H192c35.3 0 64-28.7 64-64V104c0-39.8 32.2-72 72-72s72 32.2 72 72v96c0 101.6-82.4 184-184 184S32 301.6 32 200v-8zM0 188.4V200C0 306.2 76.7 394.6 177.8 412.6l48.1 90.9c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6L215.8 416l.2 0c19.3 0 37.9-2.5 55.7-7.3l50.2 94.7c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-47.9-90.4C378.6 364.8 432 288.6 432 200V185.1l72.2-43.3c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7L425.2 66.8C410.2 27.8 372.3 0 328 0C270.6 0 224 46.6 224 104v24c0 17.7-14.3 32-32 32H28.4C12.7 160 0 172.7 0 188.4zM464.9 128L432 147.7V108.3L464.9 128zM328 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCompass = {
  prefix: 'fal',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm92.6-389.1L202.1 171.8c-14.3 4.8-25.6 16-30.4 30.4L122.9 348.6c-8.3 25 15.5 48.8 40.5 40.5l146.5-48.8c14.3-4.8 25.6-16 30.4-30.4l48.8-146.5c8.3-25-15.5-48.8-40.5-40.5zm10.1 30.4L309.9 299.8c-1.6 4.8-5.3 8.5-10.1 10.1L153.3 358.7l48.8-146.5c1.6-4.8 5.3-8.5 10.1-10.1l146.5-48.8zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareCaretDown = {
  prefix: 'fal',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm224-64c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7c0-15.2-12.3-27.5-27.5-27.5h-201C108.3 192 96 204.3 96 219.5c0 6.9 2.6 13.6 7.3 18.7L198.8 341c6.5 7 15.6 11 25.2 11zm-1.7-32.7L133.8 224H314.2l-88.4 95.3c-.4 .5-1.1 .7-1.7 .7s-1.3-.3-1.7-.7z"]
};
var faCaretSquareDown = faSquareCaretDown;
var faHeartHalfStroke = {
  prefix: 'fal',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M272 126.1l7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3v3.5c0 32.3-13.4 63.1-37 85.1L272 434.7V126.1zM256.3 448c-.1 0-.2 0-.3 0s-.2 0-.3 0h.5zM240 434.7L69.1 275.5C45.4 253.5 32 222.7 32 190.4v-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9V434.7zM393.7 45.1c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5c3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L464.8 299c3.8-3.5 7.3-7.2 10.7-11C498.9 261 512 226.4 512 190.4v-3.5c0-69.6-49.8-129.3-118.3-141.8z"]
};
var faHeartHalfAlt = faHeartHalfStroke;
var faFileCircleQuestion = {
  prefix: 'fal',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16v-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9H409.6c-5.3 0-9.6 4.3-9.6 9.6V336c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.4z"]
};
var faLaptopCode = {
  prefix: 'fal',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M128 64H512c17.7 0 32 14.3 32 32V352h32V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H96V96c0-17.7 14.3-32 32-32zM33.9 416H606.1c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM283.3 171.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 224l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 224l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faJoystick = {
  prefix: 'fal',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M304 112a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm32 0c0 56.4-41.7 103.1-96 110.9V320H208V222.9c-54.3-7.8-96-54.4-96-110.9C112 50.1 162.1 0 224 0s112 50.1 112 112zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM416 416c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V416zM64 352H384c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM208 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrillFire = {
  prefix: 'fal',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", "M408 64H40c-4.4 0-8 3.6-8 8V96c0 106 86 192 192 192c4.7 0 9.4-.2 14-.5c-4.4 10.8-8 21.7-10.5 32.5c-1.2 0-2.4 0-3.6 0c-19.9 0-39.2-2.6-57.6-7.5l-26.1 57.3c4.3 4.2 8.1 8.9 11.1 14.1H227c1.9 11 4.8 21.7 8.5 32H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c5.7 0 11.1 .7 16.4 2.1l23.7-52C56 267.9 0 188.5 0 96V72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40V96c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1l0 0c3.3-14.1 5.1-28.8 5.1-44V72c0-4.4-3.6-8-8-8zM96 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM445.4 253.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C288 422.5 344.2 480 416 480c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C576 440 504.7 512 416 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM381.1 256c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C457.3 442 438.3 448 417 448c-25.9 0-50.2-8.4-68.2-24.8C330.7 406.6 320 382.7 320 354c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L443 351l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C381.7 409.9 397.9 416 417 416c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faRectangleVerticalHistory = {
  prefix: 'fal',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", "M256 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H256zM192 64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zM96 64c0-8.8 7.2-16 16-16s16 7.2 16 16V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V64zM0 112c0-8.8 7.2-16 16-16s16 7.2 16 16V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V112z"]
};
var faSwatchbook = {
  prefix: 'fal',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 416c0 53 43 96 96 96H456c30.9 0 56-25.1 56-56V376c0-30.9-25.1-56-56-56H331.7L419 232.7c21.9-21.9 21.9-57.3 0-79.2L362.4 97c-21.9-21.9-57.3-21.9-79.2 0L192 188.2V56c0-30.9-25.1-56-56-56H56C25.1 0 0 25.1 0 56V416zm456 64H171.7l128-128H456c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24zM396.4 210.1L192 414.5v-181L305.9 119.6c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9zM96 480c-35.3 0-64-28.7-64-64l0-128H160V416c0 35.3-28.7 64-64 64zM32 256V160H160v96H32zm0-128V56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24v72H32zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPrescriptionBottle = {
  prefix: 'fal',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M336 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H336zM48 0C21.5 0 0 21.5 0 48V80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H320V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V320h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V160H32z"]
};
var faBars = {
  prefix: 'fal',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z"]
};
var faNavicon = faBars;
var faKeyboardLeft = {
  prefix: 'fal',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M576 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H576zM224 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm8 88v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H248zM232 344v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V344c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16zM344 136c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H344zM328 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H344c-8.8 0-16 7.2-16 16zM440 136c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H440zM424 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H440c-8.8 0-16 7.2-16 16zM536 136c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H536zM520 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H536c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V344c0-8.8-7.2-16-16-16H536zM320 352c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM107.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256l68.7-68.7z"]
};
var faPeopleGroup = {
  prefix: 'fal',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", "M128 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM0 280c0 43.3 26.4 80.4 64 96v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H96V208.4c2.6-.3 5.3-.4 8-.4h48c9.3 0 18.1 1.7 26.2 4.9c8.2 3.2 17.5-.9 20.7-9.1s-.9-17.5-9.1-20.7c-11.7-4.6-24.5-7.1-37.8-7.1H104C46.6 176 0 222.6 0 280zm64 59.9C44.7 327 32 304.9 32 280c0-25 12.7-47 32-59.9V339.9zM512 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM640 280c0-57.4-46.6-104-104-104H488c-13.3 0-26.1 2.5-37.8 7.1c-8.2 3.2-12.3 12.5-9.1 20.7s12.5 12.3 20.7 9.1c8.1-3.2 16.9-4.9 26.2-4.9h48c2.7 0 5.4 .1 8 .4V416H480V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V376c37.6-15.7 64-52.7 64-96zm-64 59.9V220.1C595.3 233 608 255 608 280c0 24.9-12.7 47-32 59.9zM288 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zm-80 96c-57.4 0-104 46.6-104 104c0 40.1 22.7 74.9 56 92.3V456c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V388.3c33.3-17.3 56-52.1 56-92.3c0-57.4-46.6-104-104-104H304zm-48 50.3V349.7c-14.7-13.2-24-32.4-24-53.7c0-21.3 9.3-40.5 24-53.7zM288 448V225.8c5.1-1.2 10.5-1.8 16-1.8h32c5.5 0 10.9 .6 16 1.8V448H288zm96-98.3V242.3c14.7 13.2 24 32.3 24 53.7c0 21.3-9.3 40.5-24 53.7z"]
};
var faHourglassEnd = {
  prefix: 'fal',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M0 16C0 7.2 7.2 0 16 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V76.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l70.2 91.9C341.6 373 352 403.7 352 435.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V435.3c0-31.6 10.4-62.4 29.6-87.5L131.9 256 61.6 164.1C42.4 139 32 108.3 32 76.7L32 32H16C7.2 32 0 24.8 0 16zM64 32l0 44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68L64 480H320V435.3c0-24.6-8.1-48.5-23-68L219.3 265.7c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64zM205 310.7l80 112c3.5 4.9 3.9 11.3 1.2 16.6s-8.2 8.7-14.2 8.7H192 112c-6 0-11.5-3.4-14.2-8.7S95.5 427.6 99 422.7l80-112c3-4.2 7.9-6.7 13-6.7s10 2.5 13 6.7zM192 416h48.9L192 347.5 143.1 416H192z"]
};
var faHourglass3 = faHourglassEnd;
var faHeartCrack = {
  prefix: 'fal',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M272 126.1l7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3v3.5c0 32.3-13.4 63.1-37 85.1L259 446.8c-.8 .7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L69.1 275.5C45.4 253.5 32 222.7 32 190.4v-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9V144c0 4.2 1.7 8.3 4.7 11.3l34.2 34.2-79.8 53.2c-3.7 2.5-6.2 6.4-6.9 10.9s.5 8.9 3.3 12.4l64 80c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-53.1-66.4 81.5-54.3c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9L272 137.4V126.1zM393.7 45.1c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5c3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L464.8 299c3.8-3.5 7.3-7.2 10.7-11C498.9 261 512 226.4 512 190.4v-3.5c0-69.6-49.8-129.3-118.3-141.8z"]
};
var faHeartBroken = faHeartCrack;
var faFaceBeamHandOverMouth = {
  prefix: 'fal',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm111.5-76.1c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 121.9 194.8 112 176 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm172.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 121.9 354.8 112 336 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zM265.3 301.3L248 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V352 298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faDropletPercent = {
  prefix: 'fal',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM160 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHumidity = faDropletPercent;
var faSquareUpRight = {
  prefix: 'fal',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM304 184V297.4c0 3.7-3 6.6-6.6 6.6c-1.8 0-3.4-.7-4.7-1.9l-25.4-25.4c-6.2-6.2-16.4-6.2-22.6 0l-59.1 59.1c-3.6 3.6-9 4.9-13.9 3.3c-2-.7-3.8-1.8-5.3-3.3l-22.1-22.1c-1.5-1.5-2.6-3.3-3.3-5.3c-1.6-4.9-.4-10.3 3.3-13.9l59.1-59.1c6.2-6.2 6.2-16.4 0-22.6l-25.4-25.4c-1.2-1.2-1.9-2.9-1.9-4.7c0-3.7 3-6.6 6.6-6.6H296c4.4 0 8 3.6 8 8zm-8-40H182.6c-21.3 0-38.6 17.3-38.6 38.6c0 10.2 4.1 20.1 11.3 27.3L169.4 224l-47.7 47.7c-12.2 12.2-16.5 30.3-11 46.7c2.2 6.7 6 12.8 11 17.8l22.1 22.1c5 5 11.1 8.8 17.8 11c16.4 5.5 34.5 1.2 46.7-11L256 310.6l14.1 14.1c7.2 7.2 17.1 11.3 27.3 11.3c21.3 0 38.6-17.3 38.6-38.6V184c0-22.1-17.9-40-40-40z"]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faFaceKissBeam = {
  prefix: 'fal',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm277.4 47.1c-11-5.4-25.7-9.3-39.1-11.2c-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-1.1 .5-2.1 1-3.3 1.5c1.1 .5 2.2 1 3.3 1.5c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-13.9 6.8-31.2 11.3-46.3 13.4c-6.6 .9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8c-10.9-5.4-25.5-9.3-38.8-11.2c-.9-.1-1.8-.3-2.7-.6c-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8 .7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6c13.3-1.9 27.9-5.8 38.8-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zM156.5 194.5c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faKissBeam = faFaceKissBeam;
var faCorn = {
  prefix: 'fal',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-21.9 0-41.2 11-52.7 27.7c7.7 10.3 14.7 21 21 32c0-.2 .1-.4 .1-.6C242.7 99.8 256 88 272 88c3.1 0 6.1 .4 8.9 1.3c7.3 2.1 15.1-1.2 18.6-8C304.9 71 315.7 64 328 64c3.1 0 6.1 .4 8.9 1.3c7.3 2.1 15.1-1.2 18.6-8C360.9 47 371.7 40 384 40c6.9 0 13.2 2.1 18.4 5.8c6.7 4.7 16 3.6 21.3-2.7C429.6 36.3 438.3 32 448 32c17.7 0 32 14.3 32 32c0 9.7-4.3 18.4-11.2 24.3c-6.2 5.4-7.4 14.6-2.6 21.3c3.7 5.2 5.8 11.5 5.8 18.4c0 12.3-7 23.1-17.3 28.4c-6.8 3.5-10.1 11.3-8 18.6c.8 2.8 1.3 5.8 1.3 8.9c0 12.3-7 23.1-17.3 28.4c-6.8 3.5-10.1 11.3-8 18.6c.8 2.8 1.3 5.8 1.3 8.9c0 10.9-5.4 20.5-13.7 26.3c8.7 6.3 17.1 13.4 24.9 21C448 275.6 456 258.7 456 240c0-2-.1-3.9-.3-5.8C470.5 222.5 480 204.3 480 184c0-2-.1-3.9-.3-5.8C494.5 166.5 504 148.3 504 128c0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM163.3 68.7c-3.9-3.9-9.6-5.5-15-4.3s-9.7 5.3-11.5 10.5l-22 65.9c-.7 2-1.7 3.9-3.1 5.5l-76.1 87C12.7 259.5 0 293.2 0 328.1V342c0 36.2 13.6 71.1 38.2 97.7l24 26C89.5 495.2 127.9 512 168 512H179c38.2 0 74.8-15.2 101.8-42.2l69.5-69.5c1.7-1.7 3.6-2.9 5.8-3.7L437.5 367c5.1-1.9 9-6.2 10.2-11.6s-.4-10.9-4.3-14.8l-29.1-29.1C378.6 276 330.3 256 280 256c-10.8 0-21.6 .9-32.1 2.7c-1.9-69.5-30.3-135.7-79.6-185l-5-5zM216 266v1.1c-26.2 9.4-50.2 24.5-70.2 44.5l-94 94C39 387 32 364.8 32 342V328.1c0-27.1 9.8-53.3 27.7-73.8l76.1-87c4.2-4.8 7.4-10.4 9.4-16.4l13.5-40.5C195.6 153.7 216 208.8 216 266zM85.7 444l-13-14.1 95.7-95.7C198 304.6 238.1 288 280 288s82 16.6 111.6 46.2l11.3 11.3-57.7 21c-6.6 2.4-12.6 6.2-17.5 11.2l-69.5 69.5c-21 21-49.5 32.8-79.2 32.8H168c-31.3 0-61.1-13.1-82.3-36z"]
};
var faRollerCoaster = {
  prefix: 'fal',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", "M144 64c-5.4 0-10.8 .4-16 1.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V74.8C58.2 92.8 32 131.3 32 176V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V176C0 96.5 64.5 32 144 32h6.6c46.2 0 89.7 22.2 116.7 59.7L392.7 265.4c24.8 34.3 64.5 54.6 106.8 54.6H512c53 0 96-43 96-96v-5c0-40.9-26.9-75.4-64-86.9V272c-6.7 5-15 8-24 8h-8V128.1c-22.5 .8-44.4 6.8-64 17.5V263.2c-9.2-6.3-17.3-14.2-23.9-23.4L416 228.5V169l-21.4 19L373.4 164l26.4-23.5C432.1 111.9 473.8 96 517 96c67.9 0 123 55.1 123 123v5V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V308.7c-23.5 26.6-57.8 43.3-96 43.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.8c-22.8-2.7-44.6-10.2-64-21.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304.3c-6.2-6.2-12-12.9-17.2-20.2L320 219.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V175l-46.7-64.6c-5.1-7-10.9-13.4-17.3-19V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c-13-5.2-27.1-8-41.4-8H144z"]
};
var faPhotoFilmMusic = {
  prefix: 'fal',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M544 32H224c-17.7 0-32 14.3-32 32V233.4L265.4 160c12.5-12.5 32.8-12.5 45.3 0L352 201.4 457.4 96c12.5-12.5 32.8-12.5 45.3 0l53.8 53.8-33.9 11.3L480 118.6 363.3 235.3 278.6 320H384v32H240h0H224c-35.3 0-64-28.7-64-64V272v0V64c0-35.3 28.7-64 64-64H544c35.3 0 64 28.7 64 64v72c-6.7 0-13.5 1.1-20.2 3.3L576 143.2V64c0-17.7-14.3-32-32-32zM233.4 320l96-96L288 182.6l-96 96V288c0 17.7 14.3 32 32 32h9.4zM232 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 96h16v32 80V336v48 32H308.6c-8.3 8.8-15 19.6-18.3 32H128 112 96 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H96h16zM32 192H96V128H64c-17.7 0-32 14.3-32 32v32zm0 160v32c0 17.7 14.3 32 32 32H96V352H32zm64-32V224H32v96H96zM640 198.2V248 392c0 1.1-.1 2.2-.3 3.2c.2 1.6 .3 3.2 .3 4.8c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V270.2L448 323.5V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V312 251.5c0-13.8 8.8-26 21.9-30.4l160-53.3c20.7-6.9 42.1 8.5 42.1 30.4zm-32 38.3V198.2L448 251.5v38.3l160-53.3zm-5.9 171.9c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7zm-192 64c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7z"]
};
var faRadar = {
  prefix: 'fal',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M32 256C32 132.3 132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7l-34.1 34.1C338.1 95.3 298.8 80 256 80c-72.2 0-134.2 43.5-161.3 105.6c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3c22.2-50.9 73-86.4 132-86.4c34 0 65.2 11.8 89.9 31.5l-34.3 34.3C295.9 166.6 276.7 160 256 160c-53 0-96 43-96 96s43 96 96 96s96-43 96-96c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c11.9 0 23 3.2 32.5 8.9l-43.8 43.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l224-224c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224S32 379.7 32 256zm384-16c-8.8 0-16 7.2-16 16c0 59-35.5 109.8-86.4 132c-8.1 3.5-11.8 13-8.3 21.1s13 11.8 21.1 8.3C388.5 390.2 432 328.2 432 256c0-8.8-7.2-16-16-16zM102.9 305.3c-8.1 3.5-11.8 13-8.3 21.1c17.7 40.6 50.3 73.2 90.9 90.9c8.1 3.5 17.5-.2 21.1-8.3s-.2-17.5-8.3-21.1c-33.2-14.5-59.9-41.2-74.4-74.4c-3.5-8.1-13-11.8-21.1-8.3zM120 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSickle = {
  prefix: 'fal',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M320 0C214 0 128 86 128 192c0 71 38.5 132.9 95.7 166.1c6.3 3.6 14.2 2.6 19.4-2.5l36-36c5.3-5.3 6.2-13.5 2.2-19.9C270.3 282.5 264 262 264 240c0-61.9 50.1-112 112-112c48.1 0 89.1 30.3 105 72.9c2.7 7.2 10.1 11.5 17.7 10.2s13.2-7.8 13.3-15.5c0-1.2 0-2.4 0-3.6C512 86 426 0 320 0zM160 192c0-88.4 71.6-160 160-160c65.7 0 122.1 39.6 146.8 96.2C442 108.1 410.4 96 376 96c-79.5 0-144 64.5-144 144c0 23.6 5.7 45.9 15.8 65.6l-18.3 18.3C187.5 295.1 160 246.7 160 192zM115.3 300.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7L13.2 412.2C4.7 420.6 0 432.1 0 444s4.7 23.4 13.2 31.8l23 23C44.6 507.3 56.1 512 68 512s23.4-4.7 31.8-13.2L184 414.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-64-64-16-16zM35.8 434.8L120 350.6 161.4 392 77.2 476.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8l-23-23c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2z"]
};
var faFilm = {
  prefix: 'fal',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", "M128 448V352 272H384v80 96H128zM384 240H128V160 64H384v96 80zM96 448H64c-17.7 0-32-14.3-32-32V368H96v80zM32 272H96v64H32V272zm64-96v64H32V176H96zM96 64v80H32V96c0-17.7 14.3-32 32-32H96zM416 336V272h64v64H416zm0 112V368h64v48c0 17.7-14.3 32-32 32H416zm0-272h64v64H416V176zm64-80v48H416V64h32c17.7 0 32 14.3 32 32zM448 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"]
};
var faCoconut = {
  prefix: 'fal',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M272.5 40c45.4-14 79.7-8.9 98.6 9.9s23.9 53.2 9.9 98.6C367.2 193 336 244 290 290s-97 77.2-141.6 91c-45.4 14-79.7 8.9-98.6-9.9S26 317.9 40 272.5c13.8-44.6 45-95.6 91-141.6s97-77.2 141.6-91zM393.7 27.2C362.4-4.1 312.8-5.9 263.1 9.4c-50.5 15.6-105.8 50-154.8 98.9S25 212.6 9.4 263.1C-5.9 312.8-4.1 362.4 27.2 393.7l42.4 42.4C118.2 484.7 184.1 512 252.9 512C396 512 512 396 512 252.9c0-68.7-27.3-134.6-75.9-183.2L393.7 27.2zM421 100.1c37.9 41.7 59 96.1 59 152.8c0 4.1-.1 8.2-.3 12.2l-20.4-20.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l37.4 37.4c-8.5 36.5-25.9 69.7-49.7 97.1l-45.1-45.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l45.1 45.1c-27.4 23.8-60.5 41.1-97.1 49.7l-37.4-37.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265 479.7c-4 .2-8.1 .3-12.2 .3c-56.6 0-111-21.1-152.8-59c18.5 .1 38.1-3.3 57.8-9.4c50.5-15.6 105.8-50 154.8-98.9s83.4-104.3 98.9-154.8c6.1-19.7 9.4-39.3 9.4-57.8zm-102.7 3.2c3.5 3.5 9.6 17-1.7 48.8c-10.4 29.4-32.9 64.9-66.2 98.2s-68.9 55.9-98.2 66.2c-31.8 11.2-45.4 5.1-48.8 1.7s-9.6-17 1.7-48.8c10.4-29.4 32.9-64.9 66.2-98.2s68.9-55.9 98.2-66.2c31.8-11.2 45.4-5.1 48.8-1.7zm22.6-22.6c-34.4-34.4-120.5-4-192.3 67.9s-102.2 158-67.9 192.3s120.5 4 192.3-67.9s102.2-158 67.9-192.3z"]
};
var faRulerHorizontal = {
  prefix: 'fal',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", "M32 320c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32l-48 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H432v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H336v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160l-48 0c-17.7 0-32 14.3-32 32l0 128zm32 64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64L64 384z"]
};
var faShieldCross = {
  prefix: 'fal',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H240V400c0 8.8 7.2 16 16 16s16-7.2 16-16V208H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112z"]
};
var faCassetteTape = {
  prefix: 'fal',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H478.1l-23.4-64.4c-6.9-19-24.9-31.6-45.1-31.6H166.4c-20.2 0-38.2 12.6-45.1 31.6L97.9 448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM444.1 448H131.9l19.4-53.5c2.3-6.3 8.3-10.5 15-10.5H409.6c6.7 0 12.7 4.2 15 10.5L444.1 448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32s-3.1-22.6-8.6-32H360.6c-5.4 9.4-8.6 20.3-8.6 32s3.1 22.6 8.6 32H215.4zM160 288H416c35.3 0 64-28.7 64-64s-28.7-64-64-64H160c-35.3 0-64 28.7-64 64s28.7 64 64 64zm256-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSquareTerminal = {
  prefix: 'fal',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM83.9 149.6c-5.8 6.7-5 16.8 1.7 22.6L183.4 256 85.6 339.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faPeopleRobbery = {
  prefix: 'fal',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M400 144c54.3 0 101.9-36.2 116.4-88.5l12.2-43.8c2.4-8.5 11.2-13.5 19.7-11.1s13.5 11.2 11.1 19.7L547.3 64.1c-12.3 44.3-43.4 79.5-83.2 97.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H368V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V162c-39.8-18.4-70.9-53.6-83.3-97.9L240.6 20.3c-2.4-8.5 2.6-17.3 11.1-19.7s17.3 2.6 19.7 11.1l12.2 43.8C298.1 107.8 345.7 144 400 144zm32 28.6c-10.4 2.2-21.1 3.4-32 3.4s-21.6-1.2-32-3.4V320h64V172.6zM85.3 144c21.8 0 42.4 10.3 55.5 27.7L192 240h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-5 0-9.8-2.4-12.8-6.4l-56-74.7c-7.1-9.4-18.1-14.9-29.9-14.9C64.7 176 48 192.7 48 213.3L48 320h64V280c0-8.8 7.2-16 16-16s16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H48l0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-282.7C16 175 47 144 85.3 144zM80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM424 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 344 56z"]
};
var faLightbulb = {
  prefix: 'fal',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M310.3 258.1C326.5 234.8 336 206.6 336 176c0-79.5-64.5-144-144-144S48 96.5 48 176c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19l0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H242.5c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM192 96c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16zM146.7 448c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32H146.7zM112 432v-5.3c0-5.9 4.8-10.7 10.7-10.7H261.3c5.9 0 10.7 4.8 10.7 10.7V432c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
var faCaretLeft = {
  prefix: 'fal',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", "M34.2 261.6c-1.3-1.4-2.2-3.5-2.2-5.6s.8-4.2 2.2-5.6L147.7 130.2c1.3-1.4 3.2-2.2 5.2-2.2c3.9 0 7.1 3.2 7.1 7.1l0 241.7c0 3.9-3.2 7.1-7.1 7.1c-2 0-3.8-.8-5.2-2.2L34.2 261.6zm-23.3 22L124.4 403.7c7.4 7.8 17.7 12.3 28.4 12.3c21.6 0 39.1-17.5 39.1-39.1l0-241.7c0-21.6-17.5-39.1-39.1-39.1c-10.8 0-21.1 4.4-28.5 12.3L10.9 228.4C3.9 235.9 0 245.8 0 256s3.9 20.1 10.9 27.6z"]
};
var faCommentMiddle = {
  prefix: 'fal',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M216.9 394.3L256 472.4l39.1-78.1c4.3-8.6 12.3-14.8 21.7-16.9C415.4 355.5 480 284.4 480 208c0-91.3-93.8-176-224-176S32 116.7 32 208c0 76.4 64.6 147.5 163.3 169.4c9.4 2.1 17.4 8.3 21.7 16.9zm44.5 89s0 0 0 0l-5.5 2.7 5.5-2.7 0 0zm62.2-74.7l-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208C0 93.1 114.6 0 256 0S512 93.1 512 208c0 95.8-79.8 176.5-188.3 200.7z"]
};
var faTrashCanList = {
  prefix: 'fal',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M169.7 32h76.5c5.5 0 10.6 2.8 13.6 7.5L275.1 64H140.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM312.9 64L287 22.6C278.2 8.5 262.8 0 246.3 0H169.7C153.2 0 137.8 8.5 129 22.6L103.1 64H64 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H32V432c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H384 352 312.9zM352 96V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V96H352zM160 160c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm208-32c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H464zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H464zM448 400c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16z"]
};
var faBlock = {
  prefix: 'fal',
  iconName: 'block',
  icon: [448, 512, [], "e46a", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleExclamation = {
  prefix: 'fal',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faExclamationCircle = faCircleExclamation;
var faSchoolCircleXmark = {
  prefix: 'fal',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V266.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32v96h32 32 8.2c10 12.1 21.7 22.9 34.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faArrowRightFromBracket = {
  prefix: 'fal',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 176 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L356.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z"]
};
var faSignOut = faArrowRightFromBracket;
var faFaceFrownSlight = {
  prefix: 'fal',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM347.9 394.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleChevronDown = {
  prefix: 'fal',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM132.7 235.3l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 313.4 155.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faChevronCircleDown = faCircleChevronDown;
var faSidebarFlip = {
  prefix: 'fal',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H288V64H64zm384 0H320V448H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm0-32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448zM432 96c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm16 80c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16zm-16 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64z"]
};
var faUnlockKeyhole = {
  prefix: 'fal',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", "M224 32c-53 0-96 43-96 96v64H368c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96V128C96 57.3 153.3 0 224 0c58 0 107 38.6 122.7 91.4c2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8C304.2 60.9 267.5 32 224 32zM80 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80zM264 368H184c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faUnlockAlt = faUnlockKeyhole;
var faTemperatureList = {
  prefix: 'fal',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M80 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112S32 429.9 32 368c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM144 0C91 0 48 43 48 96V252.7c0 4.6-2.2 9.8-6.8 14.5C15.7 293.1 0 328.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM112 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM320 48c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16z"]
};
var faCloudShowersHeavy = {
  prefix: 'fal',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm120 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm112 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm120 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128z"]
};
var faHeadphonesSimple = {
  prefix: 'fal',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", "M32 288C32 164.3 132.3 64 256 64s224 100.3 224 224V400c0 8.8 7.2 16 16 16s16-7.2 16-16V288C512 146.6 397.4 32 256 32S0 146.6 0 288V400c0 8.8 7.2 16 16 16s16-7.2 16-16V288zm128 0V448H144c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48h16zm-16-32c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H144zm208 32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H352V288zm16-32H352c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80V336c0-44.2-35.8-80-80-80z"]
};
var faHeadphonesAlt = faHeadphonesSimple;
var faSitemap = {
  prefix: 'fal',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", "M320 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304 272 256c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64zM256 192h16v48H112c-26.5 0-48 21.5-48 48v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H96V288c0-8.8 7.2-16 16-16H272v48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H304V272H464c8.8 0 16 7.2 16 16v32H464c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288c0-26.5-21.5-48-48-48H304V192h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48zM48 352h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z"]
};
var faPipeSection = {
  prefix: 'fal',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v32V368v32c0 8.8 7.2 16 16 16s16-7.2 16-16V384H608v16c0 8.8 7.2 16 16 16s16-7.2 16-16V368 144 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H256 32V112zM608 352H32V160H256 608V352z"]
};
var faSpaceStationMoonConstruction = {
  prefix: 'fal',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M32 256C32 132.3 132.3 32 256 32c61 0 116.3 24.4 156.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8C414.1 40.2 339.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c91.2 0 171.3-47.7 216.6-119.5c3.1-4.9 3.3-11.2 .5-16.3s-8.2-8.3-14-8.3H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h11.6c-41.1 48.9-102.7 80-171.6 80c-95.1 0-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3c119.5 0 187-24.3 223.8-37.6c5-1.8 9.4-3.4 13.3-4.7c1.7-.6 3.2-1.4 4.6-2.4l1.7-1.3c3-2.3 5.1-5.5 5.9-9.1c4.4-18.7 6.7-38.3 6.7-58.3c0-5.7-.2-11.4-.6-17.1c-.6-8.4-7.5-14.9-16-14.9H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zm104-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-64 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368z"]
};
var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
var faCircleDollarToSlot = {
  prefix: 'fal',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", "M256 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352H56c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V408c0-30.9-25.1-56-56-56h-8c-8.6 11.5-18.3 22.2-28.8 32H456c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V408c0-13.3 10.7-24 24-24H92.8c-10.5-9.8-20.2-20.5-28.8-32zM272 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16V294.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"]
};
var faDonate = faCircleDollarToSlot;
var faMemory = {
  prefix: 'fal',
  iconName: 'memory',
  icon: [576, 512, [], "f538", "M32 128c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32c-19.4 14.6-32 37.8-32 64s12.6 49.5 32 64v32H32l0-32c19.4-14.6 32-37.8 32-64s-12.6-49.5-32-64zM0 248.6V304 416c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V304 248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6zM544 416H480V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H392V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H304V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H216V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H128V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H32l0-96H544v96zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faFaceSleeping = {
  prefix: 'fal',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", "M32 256C32 132.3 132.3 32 256 32c33.1 0 64.5 7.2 92.7 20c8 3.7 17.5 .1 21.2-7.9s.1-17.5-7.9-21.2C329.6 8.2 293.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.8-8.2-73.6-22.9-105.9c-3.7-8-13.1-11.6-21.2-7.9s-11.6 13.1-7.9 21.2c12.8 28.2 20 59.6 20 92.7c0 123.7-100.3 224-224 224S32 379.7 32 256zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm8-256h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H358.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H320c-8.8 0-16 7.2-16 16s7.2 16 16 16zM416 16c0 8.8 7.2 16 16 16h25.4L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H470.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0H432c-8.8 0-16 7.2-16 16zM387.2 238.4c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm-262.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0z"]
};
var faRoadSpikes = {
  prefix: 'fal',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M93.3 108L160 208l32 48V198.3 116.8c0-15.8 20.5-22 29.3-8.9L288 208l32 48V198.3 116.8c0-15.8 20.5-22 29.3-8.9L416 208l32 48V198.3 116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 480h-6.5H448 384 352h-6.5H320 256 224h-6.5H192 96 64V320 116.8c0-15.8 20.5-22 29.3-8.9zM512 320h68.2L480 169.7V256v64h32zm-90.6-46.2L352 169.7V256v64h32 64 4.2l-30.8-46.2zm-128 0L224 169.7V256v64h32 64 4.2l-30.8-46.2zm-128 0L96 169.7V320h96 4.2l-30.8-46.2zM16 416H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFireBurner = {
  prefix: 'fal',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", "M349.4 93.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C192 262.5 248.2 320 320 320c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zM327.5 37.1c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM285.1 96c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 0 0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C361.3 282 342.3 288 321 288c-25.9 0-50.2-8.4-68.2-24.8C234.7 246.6 224 222.7 224 194c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L347 191l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C285.7 249.9 301.9 256 321 256c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5zM32 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v96H576V288H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16V386.7c18.6 6.6 32 24.4 32 45.3v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V432c0-20.9 13.4-38.7 32-45.3V272zm0 160v32c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm160-8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSquirrel = {
  prefix: 'fal',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M144 32C82.1 32 32 82.1 32 144s50.1 112 112 112c15.7 0 30.2 8.5 37.7 22.3c9.6 17.3 5.2 37-4.3 50.5c-11 15.6-17.4 34.6-17.4 55.2c0 53 43 96 96 96H368c35.3 0 64-28.7 64-64s-28.7-64-64-64c-6.7 0-13.2 1-19.2 2.9c-8.4 2.6-17.4-2-20.1-10.5s2-17.4 10.5-20.1c9.1-2.9 18.8-4.4 28.8-4.4c11.2 0 22 1.9 32 5.5V240c0-8.8 7.2-16 16-16h11.5c21.2 0 40.6-12 50.1-31l2-4.1-.3-3.4C476 152.9 448.5 128 415.6 128H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16V96c49.1 .2 90.2 37.5 95.1 86.4l.8 8c.3 3-.3 6-1.6 8.7l-4.1 8.2c-14.2 28.5-42.7 46.9-74.2 48.5v88.6c19.6 17.6 32 43.1 32 71.6c0 24.6-9.2 47-24.4 64H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H368 256c-70.7 0-128-57.3-128-128c0-27.4 8.6-52.8 23.2-73.6c4.5-6.3 4.6-12.8 2.4-16.7c-1.9-3.5-5.7-5.7-9.7-5.7C64.5 288 0 223.5 0 144S64.5 0 144 0s144 64.5 144 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-61.9-50.1-112-112-112zM352 80v76.2c0 39-7.1 66.6-21.2 91.9c-11.9 21.2-28.6 40.5-48.2 63l0 0 0 0c-2.8 3.2-5.7 6.5-8.6 9.9l-11.2 13C248.5 350.4 240 376.6 240 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-29.6 10.4-63.7 30.6-87l11.2-13c3-3.5 5.9-6.8 8.7-10c19.9-22.9 34.3-39.4 44.4-57.5c11-19.7 17.1-41.6 17.1-76.2V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faArrowUpToLine = {
  prefix: 'fal',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM203.3 132.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 182.6V288 464c0 8.8 7.2 16 16 16s16-7.2 16-16V288 182.6L308.7 283.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128z"]
};
var faArrowToTop = faArrowUpToLine;
var faFlag = {
  prefix: 'fal',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V64 367v33 96c0 8.8 7.2 16 16 16s16-7.2 16-16V392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 73L140.7 61.8c30.7-7.7 63.1-4.1 91.4 10c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v278l-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359V89z"]
};
var faFaceCowboyHat = {
  prefix: 'fal',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M168.1 118.9c5.7-17.2 13-35.7 21.4-51.9c6.9-13.2 13.7-23.2 19.8-29.4c3.5-3.5 5.7-4.9 6.7-5.4c.8 .4 2.2 1.3 4.2 3c20.3 17.8 51.2 17.8 71.5 0c2-1.8 3.4-2.6 4.2-3c1 .5 3.2 1.8 6.7 5.4c6.1 6.2 12.9 16.2 19.8 29.4c8.4 16.2 15.7 34.8 21.4 51.9c-27.7 5.9-57.2 9.1-87.9 9.1s-60.2-3.2-87.9-9.1zM296 0c-8.9 0-17.4 4.2-25.4 11.2c-8.2 7.2-21.1 7.2-29.3 0C233.4 4.2 224.9 0 216 0c-34.2 0-63 62.1-79 110.9C106.5 101.7 78.9 89 55.2 73.6l-.3-.2c-1-.6-2-1.3-2.9-1.9c-2.3-1.6-4.6-3.2-6.9-4.8C42.6 65 39.7 64 36.7 64C27.7 64 21 72.3 23.8 80.7c1.1 3.5 2.4 7 3.8 10.4c.4 1 .8 2 1.3 3l.2 .4C61.5 169.9 150.8 224 256 224s194.5-54.1 227-129.4l.2-.4c.4-1 .9-2 1.3-3c1.4-3.4 2.7-6.9 3.8-10.4C491 72.3 484.3 64 475.3 64c-3 0-6 1-8.4 2.8c-2.3 1.6-4.6 3.2-6.9 4.8c-1 .6-1.9 1.3-2.9 1.9l-.3 .2C433.1 89 405.5 101.7 375 110.9C359 62.1 330.2 0 296 0zM256 192c-69.9 0-129-26.2-166.1-64.1C138.7 148.5 195.7 160 256 160s117.3-11.5 166.1-32.1C385 165.8 325.9 192 256 192zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-8.6 6.2-17.6 12-27 17.2C423.7 242.9 432 272.5 432 304c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-31.5 8.3-61.1 22.8-86.7c-9.4-5.3-18.5-11-27-17.2zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 386.1c25.9 0 51-2.6 74.9-7.4c-19.5 23.7-46.5 37.4-74.9 37.4s-55.4-13.7-74.9-37.4c23.9 4.8 49 7.4 74.9 7.4zm124.5-29.6c4.8-12.1-7.8-22.5-20.2-18.5c-31.7 10.3-67.1 16.1-104.4 16.1s-72.7-5.8-104.4-16.1c-12.3-4-24.9 6.4-20.2 18.5c21.3 54 69 91.6 124.5 91.6s103.3-37.6 124.5-91.6z"]
};
var faHanukiah = {
  prefix: 'fal',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M336 16V48c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 96c8.8 0 16 7.2 16 16V352h48V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V349.3c18.6-6.6 32-24.4 32-45.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16V304c0 44.2-35.8 80-80 80H336v96H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 144c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V384H112c-44.2 0-80-35.8-80-80V176c0-8.8 7.2-16 16-16s16 7.2 16 16V304c0 20.9 13.4 38.7 32 45.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16V352h48V112c0-8.8 7.2-16 16-16z"]
};
var faChartScatter3d = {
  prefix: 'fal',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M272 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V280.6L37.7 451.8c-6.7 5.7-7.6 15.8-1.9 22.6s15.8 7.6 22.5 1.9L256 309 453.7 476.2c6.7 5.7 16.8 4.9 22.6-1.9s4.9-16.8-1.9-22.6L272 280.6V48zM384 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 256A24 24 0 1 0 8 256a24 24 0 1 0 48 0zM256 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDisplayChartUp = {
  prefix: 'fal',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", "M512 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 416H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H373.6l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64h84.9l10.7 64H234.9zM368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16H368z"]
};
var faSquareCode = {
  prefix: 'fal',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM261.4 172c-6.6 5.9-7.2 16-1.3 22.6L314.6 256 260 317.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM188 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L133.4 256 188 194.6z"]
};
var faFeather = {
  prefix: 'fal',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M325.6 163.8L96 393.4 96 330c0-59.4 23.6-116.4 65.6-158.4L265.4 67.9c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l5.5 5.5c23 23 35.9 54.1 35.9 86.6c0 22.8-6.3 44.9-18 64H310.6l37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-47 92.2H434.7l-64 64H214.6l64-64zm60.1 96c-41.8 41-98.1 64-156.8 64H118.6l64-64H338.7zM64 330v95.3L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448H182c67.9 0 133-27 181-75L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330z"]
};
var faVolumeLow = {
  prefix: 'fal',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M151.6 188L288 66.7V445.3L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM409.6 179.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8z"]
};
var faVolumeDown = faVolumeLow;
var faXmarkToSlot = {
  prefix: 'fal',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M144 64c-8.8 0-16 7.2-16 16V384H448V80c0-8.8-7.2-16-16-16H144zM480 80V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 128 96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48zM48 320H64v32H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H512V320h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM212.7 148.7c6.2-6.2 16.4-6.2 22.6 0L288 201.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L310.6 224l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 246.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 224l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesToSlot = faXmarkToSlot;
var faVoteNay = faXmarkToSlot;
var faBoxTaped = {
  prefix: 'fal',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M264 32H184 105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H264zm24 128L270 64h72.4c12.6 0 24.1 7.4 29.2 19l34.2 77H304 288zm-32.6 0H192.6l18-96h26.9l18 96zm.6 32v64H192V192h64zm-96 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192h16H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H144h16zm0-32H144L42.1 160 76.3 83c5.1-11.6 16.6-19 29.2-19H178l-18 96z"]
};
var faBoxAlt = faBoxTaped;
var faCommentSlash = {
  prefix: 'fal',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm377.6 400C378.1 411.5 350 416 320 416c-31.9 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4l6.4 14.7-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6c14.3-23.8 22.6-49.3 25.7-76.3c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100c0-22.9 5.9-45.3 16.7-66.1L87 153.6C72.2 179.9 64 209.2 64 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C249.5 441.3 284 448 320 448c40.6 0 78.9-7.7 113-21.3l-29.4-23.2zM320 32c-51.1 0-98.6 12.1-138.6 33.1L209.2 87C241.3 72.5 278.8 64 320 64c130.2 0 224 84.6 224 176c0 31-10.8 61.2-30.1 87.5l25.3 20C562.6 316.1 576 279.3 576 240C576 125.2 461.5 32 320 32z"]
};
var faSwords = {
  prefix: 'fal',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M130.7 278.6l-15.4 15.4-12.7-12.7c-12.5-12.5-32.8-12.5-45.3 0l-16 16c-9.4 9.4-12 23.5-6.6 35.6l23.1 51.9L9.4 433.4c-12.5 12.5-12.5 32.8 0 45.3l24 24c12.5 12.5 32.8 12.5 45.3 0l48.5-48.5L179 477.2c12.1 5.4 26.3 2.7 35.6-6.6l16-16c12.5-12.5 12.5-32.8 0-45.3l-12.7-12.7 15.4-15.4-22.6-22.6-15.4 15.4-57.4-57.4 15.4-15.4-22.6-22.6zm227.9-67.9l22.6 22.6L491.1 123.5c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6L418.1 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l22.6 22.6L411.1 43.5c2.6-2.6 6.1-4.3 9.9-4.6l57.3-5.2L473.1 91c-.3 3.7-2 7.2-4.6 9.9L358.6 210.7zM64 320l16-16L208 432l-16 16-62-27.5c-6-2.7-13.1-1.4-17.8 3.3L56 480 32 456l56.2-56.2c4.7-4.7 6-11.8 3.3-17.8L64 320zM38.9 91L33.7 33.7 91 38.9c3.7 .3 7.2 2 9.9 4.6L354.7 297.4l22.6-22.6L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4 .1C12.7-.4 8 1.3 4.7 4.7S-.4 12.7 .1 17.4L7 93.9c1 11.2 5.9 21.7 13.9 29.6L274.7 377.4l22.6-22.6L43.5 100.9c-2.6-2.6-4.3-6.1-4.6-9.9zM409.4 281.4l-128 128c-12.5 12.5-12.5 32.8 0 45.3l16 16c9.4 9.4 23.5 12 35.6 6.6l51.9-23.1 48.5 48.5c12.5 12.5 32.8 12.5 45.3 0l24-24c12.5-12.5 12.5-32.8 0-45.3l-48.5-48.5L477.2 333c5.4-12.1 2.7-26.3-6.6-35.6l-16-16c-12.5-12.5-32.8-12.5-45.3 0zM432 304l16 16-27.5 62c-2.7 6.1-1.4 13.1 3.3 17.8L480 456l-24 24-56.2-56.2c-4.7-4.7-11.8-6-17.8-3.3L320 448l-16-16L432 304z"]
};
var faCloudSunRain = {
  prefix: 'fal',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8L303.8 13.4zM208 120c-48.6 0-88 39.4-88 88c0 31 16 58.2 40.1 73.9c.6-12.5 2.9-24.5 6.8-35.7c-9.3-10-15-23.4-15-38.1c0-30.9 25.1-56 56-56c13.2 0 25.4 4.6 35 12.3c2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm87.3 297.7c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c3.9-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c4-7.9 .7-17.5-7.2-21.5zM304 192c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H290.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96z"]
};
var faAlbum = {
  prefix: 'fal',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleN = {
  prefix: 'fal',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM189 134.7c-4-5.7-11.3-8.1-17.9-5.9S160 137 160 144V368c0 8.8 7.2 16 16 16s16-7.2 16-16V193.9L323 377.3c4 5.7 11.3 8.1 17.9 5.9s11.1-8.3 11.1-15.2V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V318.1L189 134.7z"]
};
var faCompress = {
  prefix: 'fal',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16V48zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H128V464c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16H16zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V176c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V48zM304 320c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faWheatAwn = {
  prefix: 'fal',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", "M491 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L319.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L281.8 26.4c-6.2-6.2-16.4-6.2-22.6 0L225.2 60.3c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0L44.3 241.3c-37.5 37.5-37.5 98.3 0 135.8L78.2 411l0 0L4.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.5-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.5-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4L491 145.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L414 176.9c-16.1-5.5-33-7.8-49.8-6.7L491 43.3zM191.6 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5L180 150.8l11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM247.9 82.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zM89.5 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L66.9 354.4c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181l-22.6 22.6c-25 25-65.5 25-90.5 0L123.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5l-22.6 22.6c-25 25-65.5 25-90.5 0l-33.9-33.9c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5l-22.6 22.6c-25 25-65.5 25-90.5 0L304.4 230c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3z"]
};
var faWheatAlt = faWheatAwn;
var faAnkh = {
  prefix: 'fal',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M64 128c0 48.2 25.8 88.6 55 118.7c14.4 14.8 28.8 26.4 39.7 34.2l1.3 .9 1.3-.9c10.9-7.8 25.3-19.3 39.7-34.2c29.2-30.1 55-70.5 55-118.7c0-53-43-96-96-96s-96 43-96 96zm52.1 160C79.1 255.9 32 200.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 72.8-47.1 127.9-84.1 160H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H116.1z"]
};
var faHandsHoldingChild = {
  prefix: 'fal',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M336 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 96c-2.9 0-5.7 .2-8.5 .7L307.8 208h24.4l-3.7-63.3c-2.8-.4-5.6-.7-8.5-.7zM304 272.9c-.5 8.8-8.1 15.6-16.9 15s-15.6-8.1-15-16.9l6.4-108.3L251.3 190c-6.2 6.3-16.4 6.3-22.6 0s-6.3-16.4 0-22.6l29.6-29.7C274.6 121.2 296.8 112 320 112s45.4 9.2 61.7 25.6l29.6 29.7c6.2 6.3 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-27.1-27.2L368 271.1c.5 8.8-6.2 16.4-15 16.9s-16.4-6.2-16.9-15L334.1 240H305.9L304 272.9zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faAsterisk = {
  prefix: 'fal',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", "M192 32c8.8 0 16 7.2 16 16V226.9l151.4-96.4c7.5-4.7 17.3-2.5 22.1 4.9s2.5 17.3-4.9 22.1L221.8 256l154.8 98.5c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L208 285.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V285.1L24.6 381.5c-7.5 4.7-17.3 2.5-22.1-4.9s-2.5-17.3 4.9-22.1L162.2 256 7.4 157.5c-7.5-4.7-9.7-14.6-4.9-22.1s14.6-9.7 22.1-4.9L176 226.9V48c0-8.8 7.2-16 16-16z"]
};
var faKeySkeletonLeftRight = {
  prefix: 'fal',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M608 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128v0H288v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H192l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l212 0C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128zM32 384a96 96 0 1 0 192 0A96 96 0 1 0 32 384zM0 384c0-70.7 57.3-128 128-128s128 57.3 128 128v0h96V320c0-8.8 7.2-16 16-16s16 7.2 16 16v64h64l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 8.8-7.2 16-16 16H252c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z"]
};
var faCommentLines = {
  prefix: 'fal',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM144 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faLuchadorMask = {
  prefix: 'fal',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M288 480H160C89.3 480 32 422.7 32 352V224C32 118 118 32 224 32s192 86 192 192V352c0 70.7-57.3 128-128 128zM224 0C100.3 0 0 100.3 0 224V352c0 88.4 71.6 160 160 160H288c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zM160 352h35.3 57.4H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7H304c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48H304c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80H112c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80h13.3c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8l8-8 4.2-4.2 .4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4 .4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8c0 6.2-5.1 11.3-11.3 11.3H241.4h-6-.6H213.3h-.6-6H195.3zM96 208c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16H144c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H272c-8.8 0-16-7.2-16-16c0-26.5 21.5-48 48-48h32z"]
};
var faLuchador = faLuchadorMask;
var faMaskLuchador = faLuchadorMask;
var faSquareCheck = {
  prefix: 'fal',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM331.3 203.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 297.4 308.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faCheckSquare = faSquareCheck;
var faShredder = {
  prefix: 'fal',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M96 64V192H416V90.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32zM64 192V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64zm0 32c-17.7 0-32 14.3-32 32v96H480V256c0-17.7-14.3-32-32-32H64zm344 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 496V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0V416h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faBookOpenCover = {
  prefix: 'fal',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", "M544 373.8V33.5L336 62.1V415.4l208-41.6zM304 415.4V62.1L96 33.5V373.8l208 41.6zM539.6 1.8C558.9-.8 576 14.1 576 33.5V373.8c0 15.3-10.8 28.4-25.7 31.4L332.6 448.7c-8.3 1.7-16.8 1.7-25.1 0L89.7 405.1c-15-3-25.7-16.1-25.7-31.4V33.5C64 14.1 81.1-.8 100.4 1.8L320 32 539.6 1.8zM0 65.5c0-17.9 14.6-32 32-32l0 32L32 160l0 258.6 281.7 56.3c4.1 .8 8.4 .8 12.6 0L608 418.6V160 65.5v-32c17.4 0 32 14.1 32 32V418.6c0 15.3-10.8 28.4-25.7 31.4L332.6 506.3c-8.3 1.7-16.8 1.7-25.1 0L25.7 449.9C10.8 447 0 433.8 0 418.6V65.5z"]
};
var faBookOpenAlt = faBookOpenCover;
var faSandwich = {
  prefix: 'fal',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M480 96v64H32V96H480zM32 64C14.3 64 0 78.3 0 96v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H32zM0 352v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H392c-2.2 0-4.5 .5-6.5 1.4L320 350.5l-65.5-29.1c-2-.9-4.3-1.4-6.5-1.4H32c-17.7 0-32 14.3-32 32zm244.6 0l68.9 30.6c4.1 1.8 8.9 1.8 13 0L395.4 352H480v64H32V352H244.6zM16 288c10.5 0 20.9-2.6 30.5-5.8c8.5-2.9 17.2-6.6 25.6-10.1l0 0 3.2-1.3C94.6 262.6 111.7 256 128 256c20.4 0 36.7 6.7 56.6 14.8c19.5 8 42.2 17.2 71.4 17.2s51.8-9.2 71.4-17.2c19.9-8.1 36.2-14.8 56.6-14.8c16.3 0 33.4 6.6 52.8 14.7l3.2 1.3c8.3 3.5 17.1 7.2 25.6 10.1c9.6 3.2 20 5.8 30.5 5.8c8.8 0 16-7.2 16-16s-7.2-16-16-16c-5.5 0-12.1-1.4-20.3-4.2c-7.3-2.5-14.9-5.7-23.4-9.3l-3.2-1.3C430.6 233.4 407.7 224 384 224c-26.8 0-48.2 8.8-67 16.5l-1.8 .7c-19.6 8-37 14.8-59.3 14.8s-39.7-6.8-59.3-14.8l-1.8-.7c-18.8-7.7-40.2-16.5-67-16.5c-23.7 0-46.6 9.4-65.2 17.3l-3.2 1.3c-8.5 3.6-16.1 6.8-23.4 9.3C28.1 254.6 21.5 256 16 256c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faPesetaSign = {
  prefix: 'fal',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", "M72.7 32C50.2 32 32 50.2 32 72.7V160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32V304 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320H208c74.1 0 135.2-56 143.1-128H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H351.1c-8-72-69-128-143.1-128H72.7zM318.9 160H64V72.7c0-4.8 3.9-8.7 8.7-8.7H208c56.4 0 103.1 41.7 110.9 96zM64 192H318.9c-7.8 54.3-54.4 96-110.9 96H64V192z"]
};
var faSquareParkingSlash = {
  prefix: 'fal',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM497.4 477.6L459.9 448H160c-17.7 0-32-14.3-32-32V186L96 160.7V416c0 35.3 28.7 64 64 64H480c6 0 11.9-.8 17.4-2.4zM142.6 34.4L180.1 64H480c17.7 0 32 14.3 32 32V326l32 25.3V96c0-35.3-28.7-64-64-64H160c-6 0-11.9 .8-17.4 2.4zm97.4 240V304v64c0 8.8 7.2 16 16 16s16-7.2 16-16V352 320 299.6l-32-25.3zm197.7-7c6.6-13 10.3-27.8 10.3-43.4c0-53-43-96-96-96H264c-.9 0-1.8 0-2.7 .1L301.7 160H352c35.3 0 64 28.7 64 64c0 8.1-1.5 15.8-4.2 22.9l25.9 20.4z"]
};
var faParkingSlash = faSquareParkingSlash;
var faTrainTunnel = {
  prefix: 'fal',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256C512 114.6 397.4 0 256 0S0 114.6 0 256V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm336-48v48H144V208c0-26.5 21.5-48 48-48H320c26.5 0 48 21.5 48 48zM144 368V288H368v80c0 26.5-21.5 48-48 48h0H192h0c-26.5 0-48-21.5-48-48zm16 73.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.6 448H313.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4V208c0-44.2-35.8-80-80-80H192c-44.2 0-80 35.8-80 80V368c0 32.8 19.8 61 48 73.4zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHeading = {
  prefix: 'fal',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 48c0-8.8 7.2-16 16-16H80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H96V224H352V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V240 448h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V256H96V448h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V240 64H16C7.2 64 0 56.8 0 48z"]
};
var faHeader = faHeading;
var faGhost = {
  prefix: 'fal',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M242.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l29.3-33.4c11.6-13.3 32.1-14 44.5-1.5l2.3 2.3c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6V192C384 86 298 0 192 0S0 86 0 192V457.4C0 469.9 10.1 480 22.6 480c6 0 11.8-2.4 16-6.6l2.3-2.3c12.5-12.5 32.9-11.8 44.5 1.5L114.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l26.6-30.5c12.7-14.6 35.4-14.6 48.2 0L242.7 506zM32 438.1V192c0-88.4 71.6-160 160-160s160 71.6 160 160V438.1c-25.1-14-57.6-9.3-77.6 13.4L256 472.5l-15.8-18.1c-25.5-29.1-70.8-29.1-96.3 0L128 472.5l-18.4-21.1C89.6 428.7 57.1 424 32 438.1zM152 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFaceAnguished = {
  prefix: 'fal',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48H318.8c-5.5-27.4-29.6-48-58.6-48zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faHockeySticks = {
  prefix: 'fal',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M301.4 288H266.5L129.8 23.3c-4.1-7.9-1-17.5 6.9-21.6s17.5-1 21.6 6.9L302 286.9l-.6 1.1zm75 64L393 320H584c30.9 0 56 25.1 56 56v80c0 30.9-25.1 56-56 56H421.2c-23.9 0-45.9-13.4-56.9-34.6l-26.4-51 18-34.9 36.8 71.2c5.5 10.6 16.5 17.3 28.4 17.3H512V352H376.4zM544 352V480h40c13.3 0 24-10.7 24-24V376c0-13.3-10.7-24-24-24H544zM503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6H56c-30.9 0-56-25.1-56-56V376c0-30.9 25.1-56 56-56H320.9L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352H128V480h90.8c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H96V352H56z"]
};
var faAbacus = {
  prefix: 'fal',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 64c17.7 0 32 14.3 32 32v96H448V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V64h64zm-96 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H288V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V64H416v64zm-160 0H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H160V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V64h96v64zm-128 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H32V96c0-17.7 14.3-32 32-32h64v64zM32 416V224h96v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H64c-17.7 0-32-14.3-32-32zm128-32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V224h96v64H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H160V384zm128-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V224H416V352H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H288V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V320zm160 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V224h96V416c0 17.7-14.3 32-32 32H448V384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFilmSimple = {
  prefix: 'fal',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", "M128 352v96H384V352 256 160 64H128v96 96 96zM96 368H32v48c0 17.7 14.3 32 32 32H96V368zm0-32V272H32v64H96zm0-96V176H32v64H96zm0-96V64H64C46.3 64 32 78.3 32 96v48H96zM416 272v64h64V272H416zm0 96v80h32c17.7 0 32-14.3 32-32V368H416zm0-128h64V176H416v64zm0-96h64V96c0-17.7-14.3-32-32-32H416v80zM64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32z"]
};
var faFilmAlt = faFilmSimple;
var faList = {
  prefix: 'fal',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M48 112V80H80v32H48zM16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40C26.7 48 16 58.7 16 72zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM48 240H80v32H48V240zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40zm8 224V400H80v32H48zM16 392v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24z"]
};
var faListSquares = faList;
var faTreePalm = {
  prefix: 'fal',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M115.7 128c.7-.7 1.4-1.5 2.2-2.2c20.7-20.7 42.4-35.1 64.1-44.5c8.1-3.5 17.5 .2 21 8.3s-.2 17.5-8.3 21c-17.7 7.7-36.1 19.7-54.1 37.8c-3.6 3.6-6.9 7.1-10 10.7l-1.3 1.5c-51.1 60.1-42 123.1-21.3 156.1L244 180.7c3.2-3.2 7.5-4.9 12-4.7l0 0H432V144c0-8.8 7.2-16 16-16s16 7.2 16 16v32h78.1C532.8 135.5 490 80 400 80c-31.6 0-57.2 6.8-77.4 17.2c-7.2 3.7-16 1.4-20.6-5.3C281.2 60.9 241 32 176 32C86 32 43.2 87.5 33.9 128h81.7zM544 208H448 341.1c8 23.6 15.1 49.1 21 75.4c14.3 64.4 21.4 135.3 15.4 200.1C375.9 500 361.9 512 345.9 512H245.8c-21.7 0-36.7-21-30.8-41.3c27.4-94.3 34-166.1 30.8-216.1c-.6-10-1.7-19.1-3-27.4L129.1 340.8c-11.8 11.8-34.2 13.9-46-3.3C56.3 297.9 44.6 227.5 89.6 160H32c-16.7 0-34-14.3-30.1-34.9C12.3 70.1 67.6 0 176 0c68.6 0 116.2 28.1 144.4 63c22.6-9.4 49.1-15 79.6-15c108.4 0 163.7 70.1 174.1 125.1C578 193.7 560.7 208 544 208zm-272.3 0c2.8 13 4.9 27.8 5.9 44.5c3.5 54.5-3.8 130-32 227.1c0 .1 0 .1 0 .1l0 .1c0 0 0 .1 .1 .2l0 0h99.9c5.5-60.6-1.1-127.9-14.8-189.7c-6.5-29.4-14.6-57.2-23.7-82.3H271.7z"]
};
var faSquarePhoneFlip = {
  prefix: 'fal',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM276.8 144.1l56 12c1.8 .4 3.2 2 3.2 3.9c0 114.9-93.1 208-208 208c-1.9 0-3.5-1.3-3.9-3.2l-12-56c-.4-1.9 .6-3.8 2.3-4.5l56-24c1.6-.7 3.5-.2 4.7 1.1l16.6 20.3c5 6.1 13.6 7.6 20.4 3.7c25.4-14.7 46.6-35.9 61.4-61.4c3.9-6.8 2.4-15.4-3.7-20.4l-20.3-16.6c-1.4-1.1-1.8-3-1.1-4.7l24-56c.8-1.8 2.6-2.7 4.5-2.3zm-33.9-10.3l-24 56c-6.3 14.7-2.1 31.9 10.3 42l9.2 7.5c-8.6 11.9-19.1 22.4-31 31l-7.5-9.2c-10.2-12.4-27.3-16.6-42-10.3l-56 24c-15.8 6.8-24.6 23.8-21 40.6l12 56C96.4 388.1 111 400 128 400c132.5 0 240-107.4 240-240c0-17-11.9-31.6-28.5-35.2l-56-12c-16.8-3.6-33.9 5.2-40.6 21z"]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCartPlus = {
  prefix: 'fal',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H53.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288H466.5c29.4 0 55-20 62.1-48.5L575.5 51.9c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6L497.6 231.8C494 246 481.2 256 466.5 256H145.4L100.9 38.4C96.3 16 76.7 0 53.9 0H16zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM240 128c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V144h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H256c-8.8 0-16 7.2-16 16z"]
};
var faGamepad = {
  prefix: 'fal',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M192 96C103.6 96 32 167.6 32 256s71.6 160 160 160H448c88.4 0 160-71.6 160-160s-71.6-160-160-160H192zM0 256C0 150 86 64 192 64H448c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm208-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V192c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBorderCenterV = {
  prefix: 'fal',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M208 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 416zM56 448A24 24 0 1 0 8 448a24 24 0 1 0 48 0zm384 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM56 352A24 24 0 1 0 8 352a24 24 0 1 0 48 0zm384 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM392 160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM56 160A24 24 0 1 0 8 160a24 24 0 1 0 48 0zm336 96a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM56 256A24 24 0 1 0 8 256a24 24 0 1 0 48 0zM392 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM8 64a24 24 0 1 0 48 0A24 24 0 1 0 8 64zM296 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM344 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM296 448a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM152 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 448a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCircleDot = {
  prefix: 'fal',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faDotCircle = faCircleDot;
var faClipboardMedical = {
  prefix: 'fal',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 208c-17.7 0-32 14.3-32 32v32H112c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V368h32c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H240V240c0-17.7-14.3-32-32-32H176zm0 80V240h32v48c0 8.8 7.2 16 16 16h48v32H224c-8.8 0-16 7.2-16 16v48H176V352c0-8.8-7.2-16-16-16H112V304h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"]
};
var faFaceDizzy = {
  prefix: 'fal',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 96a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faDizzy = faFaceDizzy;
var faEgg = {
  prefix: 'fal',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 464c-85.2 0-160-84.3-160-176c0-50.8 14.7-113.1 43.5-161.7C104.2 77.9 143.4 48 192 48s87.8 29.9 116.5 78.3C337.3 174.9 352 237.2 352 288c0 91.7-74.8 176-160 176zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zM170.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"]
};
var faUpToLine = {
  prefix: 'fal',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M16 64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 32 0 39.2 0 48s7.2 16 16 16zm174.2 96.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L318.2 292.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H256c-8.8 0-16 7.2-16 16V440c0 4.4-3.6 8-8 8H152c-4.4 0-8-3.6-8-8V320c0-8.8-7.2-16-16-16H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L190.2 160.8zM192 128c-9.5 0-18.6 3.9-25.1 10.8L42.5 270.8C35.8 278 32 287.5 32 297.3C32 318.7 49.3 336 70.7 336H112V440c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V336h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L217.1 138.8c-6.5-6.9-15.6-10.8-25.1-10.8z"]
};
var faArrowAltToTop = faUpToLine;
var faHouseMedicalCircleXmark = {
  prefix: 'fal',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H394.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240H336V208c0-17.7-14.3-32-32-32H272c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-121.4 0l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faWatchFitness = {
  prefix: 'fal',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm32 125.3c0 7.8 3.1 15.2 8.6 20.7L192 313.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM141.3 160c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
var faClockNineThirty = {
  prefix: 'fal',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faCampground = {
  prefix: 'fal',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", "M394.3 3.7c6.8 5.7 7.7 15.8 2 22.5L308.9 130.4 532.8 397.2C540 405.8 544 416.7 544 428v36c0 26.5-21.5 48-48 48H288 80c-26.5 0-48-21.5-48-48V428c0-11.3 4-22.2 11.2-30.9L267.1 130.4 179.7 26.3c-5.7-6.8-4.8-16.9 2-22.5s16.9-4.8 22.5 2L288 105.5 371.7 5.7c5.7-6.8 15.8-7.7 22.5-2zM67.7 417.7c-2.4 2.9-3.7 6.5-3.7 10.3v36c0 8.8 7.2 16 16 16h49.9l1.5-1.9 144-184c3-3.9 7.7-6.1 12.6-6.1s9.6 2.3 12.6 6.1l144 184 1.5 1.9H496c8.8 0 16-7.2 16-16V428c0-3.8-1.3-7.4-3.7-10.3L288 155.3 67.7 417.7zM170.6 480H288 405.4L288 330 170.6 480z"]
};
var faFolderPlus = {
  prefix: 'fal',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM240 384c0 8.8 7.2 16 16 16s16-7.2 16-16V304h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faJug = {
  prefix: 'fal',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M176 85V32h96V85c0 14.2 4.7 28.1 13.5 39.3L363.8 225c13.1 16.9 20.2 37.6 20.2 58.9V288H64v-4.1c0-21.3 7.1-42.1 20.2-58.9l78.3-100.7C171.3 113.1 176 99.3 176 85zM128 16c0 8.8 7.2 16 16 16V85c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6V304v96 48c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V400 304 283.9c0-21.8-5.6-43.1-16-61.9c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-23.6 0-44.2 12.8-55.3 31.8l-18-23.1C306.4 99 304 92.1 304 85V32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272 176 144c-8.8 0-16 7.2-16 16zM378.3 191.5l-26.2-33.7c1.1-16.7 15-29.8 31.9-29.8c17.7 0 32 14.3 32 32s-14.3 32-32 32c-2 0-3.9-.2-5.7-.5zM64 384V320H384v64H64zm0 32H384v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416z"]
};
var faFutbol = {
  prefix: 'fal',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M299.3 475.8c.1-.8 .2-1.7 .4-2.6l21.7-85.8c1.5-5.9 1.4-12.4-2.2-17.3l-3.9-5.3c-6.6-9.1-18.5-12.2-29.8-12.2H226.4c-11.3 0-23.1 3.1-29.8 12.2l-3.9 5.3c-3.6 4.9-3.7 11.4-2.2 17.3l21.7 85.8c.2 .9 .4 1.7 .4 2.6c14 2.7 28.5 4.2 43.3 4.2s29.3-1.4 43.3-4.2zm35.3-10c38.3-14.3 71.6-38.8 96.6-70.2l-72.5-4.8c-1.4-.1-2.8 .3-4 1.2s-2 2.1-2.3 3.4l-17.8 70.5zM451.7 365.1c13.9-24.9 23.2-52.7 26.7-82.3c-.8-.3-1.5-.7-2.3-1.2l-74.9-47.1c-5.1-3.2-11.3-5.1-17.1-3.3l-6.3 2c-10.7 3.5-17.3 13.8-20.8 24.5L338.8 314c-3.5 10.7-4.2 22.9 2.4 32l3.9 5.3c3.6 4.9 9.7 7 15.8 7.4l88.3 5.9c.9 .1 1.7 .2 2.6 .4zm28.1-119c-1.8-41.9-15.1-80.7-36.9-113.6l-27 67.5c-.5 1.3-.6 2.7-.2 4.1l0 .1 0 .1c.5 1.3 1.3 2.4 2.5 3.2l61.5 38.7zM420.2 103.6c-19.7-21.2-43.4-38.6-70-50.9c-.6 .6-1.2 1.3-1.9 1.8l-68 56.6c-4.7 3.9-8.4 9.2-8.4 15.3l0 6.6c0 11.2 7.8 20.7 16.9 27.3l47.9 34.8c9.1 6.6 20.5 11.1 31.2 7.6l6.3-2c5.8-1.9 9.7-7.1 11.9-12.7l32.9-82.1c.3-.8 .7-1.6 1.1-2.3zM315.7 40.1c-19-5.3-39.1-8.1-59.7-8.1s-40.7 2.8-59.7 8.1l55.8 46.5c1.1 .9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4l55.8-46.5zm-154 12.7c-26.6 12.3-50.3 29.7-70 50.9c.4 .7 .8 1.5 1.1 2.3L125.8 188c2.3 5.6 6.2 10.8 11.9 12.7l6.3 2c10.7 3.5 22.1-1 31.2-7.6l47.9-34.8c9.1-6.6 16.9-16.1 16.9-27.3l0-6.6c0-6.1-3.7-11.4-8.4-15.3l-68-56.6c-.7-.6-1.3-1.2-1.9-1.8zM69.1 132.5C47.4 165.3 34 204.2 32.2 246.1l61.5-38.7c1.2-.7 2.1-1.9 2.5-3.2l0-.1 0-.1c.4-1.3 .4-2.8-.2-4.1l-27-67.4zM33.6 282.8c3.5 29.6 12.8 57.4 26.7 82.3c.8-.2 1.7-.3 2.6-.4l88.3-5.9c6.1-.4 12.2-2.5 15.8-7.4l3.9-5.3c6.6-9.1 5.9-21.4 2.4-32l-18.3-56.3c-3.5-10.7-10.1-21.1-20.8-24.5l-6.3-2c-5.8-1.9-12 0-17.1 3.3L35.9 281.6c-.7 .5-1.5 .9-2.3 1.2zM80.8 395.6c25 31.4 58.3 55.9 96.6 70.2l-17.8-70.5c-.3-1.4-1.2-2.6-2.3-3.4s-2.6-1.2-4-1.2l-72.5 4.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm241.9-69.8L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8c-8.4-6.1-19.8-6.1-28.2 0z"]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faSnowBlowing = {
  prefix: 'fal',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v41.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L160 166.6v61.7l-53.4-30.8L90.7 138.3c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l7.6 28.3L31.6 154.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 256 90.6 286.8 31.4 271c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6L15.6 330.1C7.9 334.6 5.3 344.3 9.7 352s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2L160 283.7v61.7l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 390.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V390.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 345.4V283.7l53.4 30.8 15.9 59.2c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-7.6-28.3 35.8 20.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-35.8-20.7 28.3-7.6c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-59.2 15.9L208 256l53.4-30.8L320.6 241c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-28.3-7.6 35.8-20.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-35.8 20.7 7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2L192 228.3V166.6l43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 121.4V80zm288 0c0 8.8 7.2 16 16 16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c44.2 0 80-35.8 80-80s-35.8-80-80-80H496c-8.8 0-16 7.2-16 16zm0 352c0 8.8 7.2 16 16 16h64c44.2 0 80-35.8 80-80s-35.8-80-80-80H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c26.5 0 48 21.5 48 48s-21.5 48-48 48H496c-8.8 0-16 7.2-16 16z"]
};
var faPaintbrush = {
  prefix: 'fal',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M295.7 360c-5.4 0-10.6-.5-15.7-1.5l0-.1c-1.3-.3-2.6-.6-3.9-.9l-57.7-57.7c-.3-1.3-.6-2.6-.9-3.9l-.1 0c-1-5.1-1.5-10.3-1.5-15.7c0-25.5 12.2-49.5 32.8-64.5L493.1 38.1c12.7-9.3 30.3-7.9 41.4 3.2s12.5 28.7 3.3 41.4L360.2 327.2c-15 20.6-39 32.8-64.5 32.8zm-42.2 20.1c.3 1.3 .6 2.6 .9 4c1 5.1 1.6 10.4 1.6 15.9c0 44.2-35.8 80-80 80H36.8C58 480 74.3 468.5 84 455.1c9.5-13.1 14.2-30 12.5-46.7c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80c5.4 0 10.7 .5 15.9 1.6c1.3 .3 2.7 .6 4 .9l57.7 57.7zm34.2 11.6c2.6 .2 5.3 .3 8 .3c35.7 0 69.3-17.1 90.4-46L563.7 101.6c18.5-25.5 15.8-60.6-6.5-82.9s-57.4-25-82.9-6.5L230 190c-28.9 21-46 54.6-46 90.3c0 2.7 .1 5.4 .3 8c-2.7-.2-5.5-.3-8.3-.3c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176c61.9 0 112-50.1 112-112c0-2.8-.1-5.5-.3-8.3z"]
};
var faPaintBrush = faPaintbrush;
var faLock = {
  prefix: 'fal',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", "M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96zM32 272V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48z"]
};
var faArrowDownFromLine = {
  prefix: 'fal',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M203.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 425.4V320 144c0-8.8 7.2-16 16-16s16 7.2 16 16V320 425.4L308.7 324.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM16 64C7.2 64 0 56.8 0 48s7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16z"]
};
var faArrowFromTop = faArrowDownFromLine;
var faGasPump = {
  prefix: 'fal',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M256 32c17.7 0 32 14.3 32 32V192H64V64c0-17.7 14.3-32 32-32H256zm32 192V480H64V224H288zM32 64V480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 288h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V157.1c0-17.9-7.5-35.1-20.8-47.2L410.8 36.2c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L416 84.4V160c0 35.3 28.7 64 64 64V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V336c0-44.2-35.8-80-80-80H320V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64zM480 192c-17.7 0-32-14.3-32-32V113.7l21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6V192z"]
};
var faSignalBarsSlash = {
  prefix: 'fal',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", "M448 176c0-26.5-21.5-48-48-48s-48 21.5-48 48v23.7L384 225V176c0-8.8 7.2-16 16-16s16 7.2 16 16v74.2l32 25.3V176zM384 464V388.1l-32-25.3V464c0 26.5 21.5 48 48 48s48-21.5 48-48V438.6l-32-25.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16zM288 312.3l-66.6-52.6C204.1 267 192 284.1 192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V312.3zm256 39V48c0-8.8 7.2-16 16-16s16 7.2 16 16V376.6l32 25.3V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V326l32 25.3zM256 304V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zM96 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faSignalAltSlash = faSignalBarsSlash;
var faMonkey = {
  prefix: 'fal',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-82.3 44.3-154.2 110.4-193.1c4.7 9.7 10.5 18.7 17.1 27.1C230.4 283.2 192 345.1 192 416v64H416V432c0-44.2-35.8-80-80-80H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c31.3 0 59.7 12.9 80 33.6V320 303.1c14.7-1.6 28.7-5.5 41.7-11.2l79.2 84.1c25.1 26.7 39.1 62 39.1 98.7V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V474.8c0-28.5-10.9-56-30.4-76.8L448 328.3V432v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448 416 192 160 144C64.5 512 0 447.5 0 368V103.3C0 46.2 46.2 0 103.3 0c49 0 88.7 39.7 88.7 88.7V96c0 53-43 96-96 96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96c35.3 0 64-28.7 64-64V88.7C160 57.4 134.6 32 103.3 32C63.9 32 32 63.9 32 103.3V368c0 61.9 50.1 112 112 112h16V416zM480 160V144 112c0 20.8-13.2 38.4-31.6 45.1c-4.7 1.7-8.4 5.9-8.4 10.9c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-5-3.7-9.2-8.4-10.9C333.2 150.4 320 132.8 320 112v32 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM336 64s0 0 0 0H464s0 0 0 0c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32zm64 208c-56.4 0-103.1-41.7-110.9-96H288c-35.3 0-64-28.7-64-64s28.7-64 64-64h20.1C328.3 19 361.9 0 400 0s71.7 19 91.9 48H512c35.3 0 64 28.7 64 64s-28.7 64-64 64h-1.1c-7.8 54.3-54.4 96-110.9 96zM544 112c0-17.7-14.3-32-32-32h-4.6c3 10.1 4.6 20.9 4.6 32v32c17.7 0 32-14.3 32-32zM288 144V112c0-11.1 1.6-21.9 4.6-32H288c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faRectanglePro = {
  prefix: 'fal',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H112v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 176c0-8.8 7.2-16 16-16zm48 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v64h32zm96-80c0-8.8 7.2-16 16-16h48c35.3 0 64 28.7 64 64c0 23.2-12.4 43.6-30.9 54.8l35.7 47.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L304 288H272v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 176zm32 80h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H272v64zm208-96c44.2 0 80 35.8 80 80v32c0 44.2-35.8 80-80 80s-80-35.8-80-80V240c0-44.2 35.8-80 80-80zm-48 80v32c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faPro = faRectanglePro;
var faHouseNight = {
  prefix: 'fal',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M127 1c-4.9-.7-9.9-1-15-1C50.1 0 0 50.1 0 112s50.1 112 112 112c30.6 0 58.4-12.3 78.6-32.2c.7-.6 1.3-1.3 1.9-2c2.9-3 5.7-6.2 8.2-9.5c2.3-3 4.5-6.2 6.5-9.5c3.9-6.2-3.2-13.3-10.4-12c-2.4 .4-4.9 .8-7.5 .9c-1.8 .1-3.6 .2-5.4 .2c-2.2 0-4.3-.1-6.5-.3c-.4 0-.8-.1-1.2-.1C140.2 155.8 112 125.2 112 88c0-20.8 8.8-39.5 22.9-52.7c.3-.3 .6-.5 .9-.8c2.9-2.7 6.1-5.1 9.4-7.2c2.1-1.4 4.3-2.6 6.6-3.7c6.6-3.3 8-13.2 1.1-15.9c-3.6-1.4-7.2-2.6-10.9-3.6c-4-1.1-8.1-2-12.3-2.7c-.9-.1-1.8-.3-2.7-.4zM80 88c0 43.9 27.1 81.4 65.5 96.7C135.3 189.4 124 192 112 192c-44.2 0-80-35.8-80-80c0-38.4 27.1-70.5 63.3-78.2C85.6 49.5 80 68.1 80 88zM410.4 99.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L224 283.9V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V283.9l37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256.5L400 133.1 544 256.5zM336 304v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32zm96 0v64H368V304h64zM256 0c-8.8 0-16 7.2-16 16V48H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V16c0-8.8-7.2-16-16-16zM96 320c-8.8 0-16 7.2-16 16v32H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H80v32c0 8.8 7.2 16 16 16s16-7.2 16-16V400h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112V336c0-8.8-7.2-16-16-16z"]
};
var faHotTubPerson = {
  prefix: 'fal',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", "M240 0c-8.8 0-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C307.7 128.4 320 151.4 320 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L288.8 77.3C268.3 63.6 256 40.6 256 16c0-8.8-7.2-16-16-16zM32 336V320 288H272c.5 0 1 0 1.6-.1c1.3 0 2.5 .1 3.8 .1H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm170.7-80H32c0-35.3 28.7-64 64-64c13.8 0 27.3 4.5 38.4 12.8L202.7 256zM0 272v48 16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v16zM384 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C435.7 128.4 448 151.4 448 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L416.8 77.3C396.3 63.6 384 40.6 384 16zM112 336c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zM32 64a32 32 0 1 1 64 0A32 32 0 1 1 32 64zm96 0A64 64 0 1 0 0 64a64 64 0 1 0 128 0z"]
};
var faHotTub = faHotTubPerson;
var faGlobePointer = {
  prefix: 'fal',
  iconName: 'globe-pointer',
  icon: [512, 512, [], "e60e", "M317.9 422.7C296.4 465.6 272.7 480 256 480c-7.9 0-17.3-3.2-27.3-11l-6.9 18.6c-2.9 7.8-7.7 14.7-13.9 19.9c15.6 3 31.6 4.5 48.1 4.5c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 16.4 1.5 32.5 4.5 48.1c5.3-6.2 12.1-11 19.9-13.9l9.6-3.5c-1.4-10-2.1-20.2-2.1-30.6c0-22.2 3.2-43.7 9.3-64H132c-2.5 19.2-3.9 39.3-4 60l32.2-11.9c.5-16.7 1.9-32.8 4.1-48.1H347.7c2.8 20.2 4.3 41.7 4.3 64s-1.5 43.8-4.3 64H283.6l-11.8 32H342c-5.9 27-14.2 50.9-24.1 70.7zM194.1 89.3C215.6 46.4 239.3 32 256 32s40.4 14.4 61.9 57.3c9.9 19.8 18.2 43.7 24.1 70.7H170c5.9-27 14.2-50.9 24.1-70.7zM384 256c0-22.1-1.4-43.5-4-64h90.8c6 20.3 9.3 41.8 9.3 64s-3.2 43.7-9.3 64H380c2.6-20.5 4-41.9 4-64zm-9.3-96c-9.6-47.6-26.2-88-47.2-116.3c57.8 19.5 105 61.8 130.9 116.3H374.7zM53.6 160c25.9-54.5 73.1-96.9 130.9-116.3c-21 28.3-37.5 68.8-47.2 116.3H53.6zM374.7 352h83.8c-25.9 54.5-73.1 96.9-130.9 116.3c21-28.3 37.6-68.8 47.2-116.3zM271 261.5c2.2-5.9 .7-12.4-3.7-16.8s-11-5.9-16.8-3.7l-215 79.2c-6.2 2.3-10.3 8.1-10.5 14.7s3.8 12.6 9.9 15.1l74 30.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L131.5 403.1l30.5 74c2.5 6.1 8.5 10 15.1 9.9s12.4-4.3 14.7-10.5l79.2-215zM143.3 360L85.1 336 229 283 176 426.9l-24-58.2c-1.6-3.9-4.8-7.1-8.7-8.7z"]
};
var faBlanket = {
  prefix: 'fal',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M32 128V312.4C49 297.2 71.4 288 96 288H392c8.6 0 16.7 1.9 24 5.4V128c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zM0 384V128C0 75 43 32 96 32H352c53 0 96 43 96 96V344c0 30.9-25.1 56-56 56H96c-8.8 0-16-7.2-16-16s7.2-16 16-16H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H96c-35.3 0-64 28.7-64 64s28.7 64 64 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-53 0-96-43-96-96z"]
};
var faMapLocation = {
  prefix: 'fal',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", "M376 120c0 7.4-2.7 19-9.4 35c-6.5 15.4-15.7 32.4-26.4 49.7c-17.1 27.8-36.9 54.7-52.2 74.4c-15.3-19.7-35.1-46.6-52.2-74.4c-10.7-17.3-19.9-34.3-26.4-49.7c-6.7-15.9-9.4-27.6-9.4-35c0-48.6 39.4-88 88-88s88 39.4 88 88zm32 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0C334.9 271.9 408 174.6 408 120zm-4.6 103.6c.9-.2 1.7-.4 2.5-.8L544 167.6V421.2L416 472.4V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V474.8L192 419.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V421.2L32 472.4V218.8l115.5-46.2c-3.9-10-7.2-20.4-9.2-30.8L15.1 191.1C6 194.8 0 203.6 0 213.4V484.2c0 17 17.1 28.6 32.9 22.3l144-57.6 218.7 62.5c3.4 1 7 .8 10.3-.5l155-62c9.1-3.6 15.1-12.5 15.1-22.3V155.8c0-17-17.1-28.6-32.9-22.3L425.2 180.7c-6.1 14.2-13.6 28.8-21.8 42.9z"]
};
var faMapMarked = faMapLocation;
var faHouseFloodWater = {
  prefix: 'fal',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", "M297.1 2.8c-5.5-3.8-12.7-3.8-18.2 0l-208 144c-7.3 5-9.1 15-4 22.3s15 9.1 22.3 4L112 157.3V258.5c7.3 1.9 14.4 5.1 20.9 9.6c3.6 2.5 7.3 4.8 11.1 6.8V135.2L288 35.5l144 99.7V275c3.8-2.1 7.6-4.4 11.2-6.8c6.5-4.5 13.5-7.8 20.8-9.6V157.3l22.9 15.8c7.3 5 17.2 3.2 22.3-4s3.2-17.2-4-22.3l-208-144zM133.8 346.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 368.1 0 374.4 0 382.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 385.9 161.7 400 192 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368s-41.7-9.9-58.2-21.2zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faCommentsQuestionCheck = {
  prefix: 'fal',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", "M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144s-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5c-3.5-.7-7.1-.2-10.2 1.4c-6.1 3.1-12 6-18 8.7c-28.4 12.9-60.2 23.1-91.5 26c14.9-19 26.8-39.7 37.6-59.9c3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110c-11.7 21-24 40.6-39.5 57.5l0 0-.1 .1c-6.5 7-8.2 17.1-4.4 25.8C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.9-2.2 9.6-4.5 14.3-6.8c15.3 2.8 30.9 4.6 47 4.6c114.9 0 208-78.9 208-176S322.9 0 208 0zM447.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6c-4.8 5-5.8 12.5-2.5 18.6c10.9 20.2 22.7 40.8 37.6 59.9c-31.3-3-63.2-13.2-91.5-26c-6-2.7-11.9-5.6-18-8.7c-3.2-1.6-6.8-2.1-10.2-1.4c-15.6 3.1-30.9 5-46.3 5c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6c4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.7 2-18.9-4.4-25.8l-.1-.1 0 0c-15.5-17-27.8-36.5-39.5-57.5c26.2-29.9 46-65.8 46-110c0-94.4-87.8-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3zM539.3 266c-6.2-6.2-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L431.4 374c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3c6.2-6.2 6.2-16.4 0-22.6zM147.9 104.1l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3L247.4 160c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7H184.3c-16.4 0-31 10.3-36.4 25.7zM230.7 236a22.7 22.7 0 1 0 -45.3 0 22.7 22.7 0 1 0 45.3 0z"]
};
var faTree = {
  prefix: 'fal',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L72 145.4c-5.1 5.1-8 12.1-8 19.3C64 179.8 76.2 192 91.3 192h17.9L38.7 274.3c-4.3 5-6.7 11.4-6.7 18C32 307.6 44.4 320 59.7 320H77.2L6.7 402.3c-4.3 5-6.7 11.4-6.7 18C0 435.6 12.4 448 27.7 448H160h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h48H420.3c15.3 0 27.7-12.4 27.7-27.7c0-6.6-2.4-13-6.7-18L370.8 320h17.5c15.3 0 27.7-12.4 27.7-27.7c0-6.6-2.4-13-6.7-18L338.8 192h17.9c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L235.3 4.7zM240 416V208c0-8.8-7.2-16-16-16s-16 7.2-16 16V416H160 37.1l87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3H69.1l87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3H102.6L224 38.6 345.4 160H304c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1L378.9 288H336c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1L410.9 416H288 240z"]
};
var faArrowsCross = {
  prefix: 'fal',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", "M288 32c-8.8 0-16 7.2-16 16s7.2 16 16 16H393.4L4.7 452.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6V192c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H288zM27.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L173.1 227.7l22.6-22.6L27.3 36.7zm225 270.2L393.4 448H288c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4L274.9 284.3l-22.6 22.6z"]
};
var faBackpack = {
  prefix: 'fal',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M192 32h64c8.8 0 16 7.2 16 16V64H176V48c0-8.8 7.2-16 16-16zM144 48V64H128C57.3 64 0 121.3 0 192V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192c0-70.7-57.3-128-128-128H304V48c0-26.5-21.5-48-48-48H192c-26.5 0-48 21.5-48 48zm16 48H288h32c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32H368V368 320c0-35.3-28.7-64-64-64H144c-35.3 0-64 28.7-64 64v48V480H64c-17.7 0-32-14.3-32-32V192c0-53 43-96 96-96h32zM112 480V384H336v96H112zm32-320c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM336 352H112V320c0-17.7 14.3-32 32-32H304c17.7 0 32 14.3 32 32v32z"]
};
var faSquareSmall = {
  prefix: 'fal',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M256 128c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H256zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64z"]
};
var faFolderArrowUp = {
  prefix: 'fal',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM272 246.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 246.6V368c0 8.8 7.2 16 16 16s16-7.2 16-16V246.6z"]
};
var faFolderUpload = faFolderArrowUp;
var faBridgeLock = {
  prefix: 'fal',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", "M48 32h80H256 384 512h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H528v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H528 512 384 256 128 48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM320 240c40.6 0 75.4 25.3 89.4 60.9C394 312.6 384 331.2 384 352V336c0-35.3-28.7-64-64-64s-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H64c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-53 43-96 96-96zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM528 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H608V352H448z"]
};
var faCrosshairsSimple = {
  prefix: 'fal',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M479.4 240H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h95.4C471.6 383 383 471.6 272 479.4V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v95.4C129 471.6 40.4 383 32.6 272H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H32.6C40.4 129 129 40.4 240 32.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V32.6C383 40.4 471.6 129 479.4 240zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
var faSackDollar = {
  prefix: 'fal',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M201.5 144h109l5.3 3.4C370.6 182.5 480 268.3 480 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64c0-147.7 109.4-233.5 164.3-268.6l5.3-3.4zm98.4-32H212.1l-6.7-9.8L156.9 32H355.1l-48.4 70.2-6.7 9.8zM152.6 138.5C91.2 183.7 0 273.4 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-142.6-91.2-232.3-152.6-277.5c-9.7-7.1-18.6-13.2-26.4-18.1L351.2 94l38.9-56.4C401 21.7 389.6 0 370.3 0H141.7C122.4 0 111 21.7 121.9 37.6L160.8 94 179 120.4c-7.7 4.9-16.7 11-26.4 18.1zM272 216c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V424c0 8.8 7.2 16 16 16s16-7.2 16-16V406.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V216z"]
};
var faPenToSquare = {
  prefix: 'fal',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", "M454.6 45.3l12.1 12.1c12.5 12.5 12.5 32.8 0 45.3L440 129.4 382.6 72l26.7-26.7c12.5-12.5 32.8-12.5 45.3 0zM189 265.6l171-171L417.4 152l-171 171c-4.2 4.2-9.6 7.2-15.4 8.6l-65.6 15.1L180.5 281c1.3-5.8 4.3-11.2 8.6-15.4zm197.7-243L166.4 243c-8.5 8.5-14.4 19.2-17.1 30.9l-20.9 90.6c-1.2 5.4 .4 11 4.3 14.9s9.5 5.5 14.9 4.3l90.6-20.9c11.7-2.7 22.4-8.6 30.9-17.1L489.4 125.3c25-25 25-65.5 0-90.5L477.3 22.6c-25-25-65.5-25-90.5 0zM80 64C35.8 64 0 99.8 0 144V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faEdit = faPenToSquare;
var faSquareSliders = {
  prefix: 'fal',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 80c0-8.8 7.2-16 16-16l48 0 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 40 0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-48 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM96 336c0-8.8 7.2-16 16-16l112 0 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 40 0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24-112 0c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16z"]
};
var faSlidersHSquare = faSquareSliders;
var faCarSide = {
  prefix: 'fal',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M171.3 64H224V80v96 16H87.6l39.1-97.8C134.1 75.9 151.7 64 171.3 64zM256 192V176 80 64h97.2c14.6 0 28.4 6.6 37.5 18l88 110H256zm263.9 .2L415.7 62c-15.2-19-38.2-30-62.5-30H171.3c-32.7 0-62.1 19.9-74.3 50.3L52.8 193C22.8 198.3 0 224.5 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-68-53.1-123.7-120.1-127.8zM542 400c-7.1 27.6-32.2 48-62 48s-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16zM385.3 368H254.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H32V256c0-17.7 14.3-32 32-32H512c53 0 96 43 96 96v48H574.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80zM160 448c-29.8 0-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16c-7.1 27.6-32.2 48-62 48z"]
};
var faMessageMiddleTop = {
  prefix: 'fal',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M343.5 128H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H168.5c9.5 0 18.5-4.2 24.6-11.5L256 41l62.9 75.5C325 123.8 334 128 343.5 128zM268.3 26.3l0 0L256 16l12.3 10.2s0 0 0 0zM168.5 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H343.5L268.3 5.8C265.3 2.1 260.7 0 256 0s-9.3 2.1-12.3 5.8L168.5 96z"]
};
var faCommentMiddleTopAlt = faMessageMiddleTop;
var faLightbulbOn = {
  prefix: 'fal',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32h90.5c-6.6 18.6-24.4 32-45.3 32zm-80-53.3V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z"]
};
var faKnife = {
  prefix: 'fal',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", "M448 9.7C453.8 3.5 461.8 0 470.3 0c12.3 0 24.1 7.6 28.2 20.4c5 15.9 13.6 49.2 13.6 91.6c0 49.1-15.6 86.8-42.9 123.7c-22.7 30.6-54 61.2-91 97.4c-6.5 6.4-13.2 12.9-20 19.6l-9.8 9.8c-13.9 13.9-32.7 21.7-52.3 21.7s-38.4-7.8-52.3-21.7l-42-42L27.7 506.9c-6 6.5-16.2 6.8-22.6 .8s-6.8-16.2-.8-22.6L189.6 286.5 448 9.7zM223.5 297.1l42.8 42.8c7.9 7.9 18.5 12.3 29.7 12.3s21.8-4.4 29.7-12.3l9.9-9.9 .1-.1 0 0c7.1-7 13.9-13.7 20.5-20.1c37.2-36.4 66.3-64.9 87.3-93.2C467.4 184.2 480 153 480 112c0-34.9-6.5-63-10.9-78L223.5 297.1z"]
};
var faUtensilKnife = faKnife;
var faShareNodes = {
  prefix: 'fal',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", "M448 112c0 44.2-35.8 80-80 80c-22.9 0-43.6-9.6-58.1-25l-151 75.5c.8 4.4 1.1 8.9 1.1 13.5s-.4 9.1-1.1 13.5l151 75.5c14.6-15.4 35.2-25 58.1-25c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-9.7 1.7-19 4.9-27.7L147.2 299.5c-14.3 22-39 36.5-67.2 36.5c-44.2 0-80-35.8-80-80s35.8-80 80-80c28.2 0 52.9 14.5 67.2 36.5l145.7-72.9c-3.2-8.6-4.9-17.9-4.9-27.7c0-44.2 35.8-80 80-80s80 35.8 80 80zM80 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShareAlt = faShareNodes;
var faDisplayChartUpCircleDollar = {
  prefix: 'fal',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M64 32H512c17.7 0 32 14.3 32 32V198.6c11.2 3.2 21.9 7.4 32 12.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h34.8c-12.9-9.1-24.5-19.9-34.6-32H341.1 288 234.9l10.7-64H288h38.6c-2.9-10.3-4.9-21-5.9-32H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM480 192.7V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6v48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.8 335.4c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faWaveSine = {
  prefix: 'fal',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M31.4 244.2l0 0 0 0 0-.1 .1-.3 .4-1.3c.3-1.2 .9-3 1.6-5.2c1.5-4.6 3.7-11.2 6.7-19.1c6-15.9 15.2-37 27.6-58C93.2 117 129.1 80 176 80c36.5 0 61.1 19.2 80.8 52.2c20.2 33.9 33.7 79.7 47.9 128.3l.4 1.3c13.7 47 28.2 96.6 50.7 134.4c23.3 39 56.8 67.8 108.2 67.8c65.1 0 109.2-51 135.8-95.9c13.6-23 23.5-45.9 29.9-63c3.2-8.6 5.6-15.7 7.3-20.8c.8-2.5 1.4-4.5 1.8-5.9c.2-.7 .4-1.2 .5-1.6l.1-.5 0-.1 0 0 0 0s0 0-15.4-4.2l15.4 4.2c2.3-8.5-2.7-17.3-11.2-19.6s-17.3 2.7-19.6 11.2l0 0 0 0 0 .1-.1 .3-.4 1.3c-.3 1.2-.9 3-1.6 5.2c-1.5 4.6-3.7 11.2-6.7 19.1c-6 15.9-15.2 37-27.6 58C546.8 395 510.9 432 464 432c-36.5 0-61.1-19.2-80.8-52.2c-20.2-33.9-33.7-79.7-47.9-128.3l-.4-1.3c-13.7-47-28.2-96.6-50.7-134.4C260.9 76.8 227.5 48 176 48C110.9 48 66.8 99 40.2 143.9c-13.6 23-23.5 45.9-29.9 63C7 215.4 4.6 222.5 3 227.6c-.8 2.5-1.4 4.5-1.8 5.9c-.2 .7-.4 1.2-.5 1.6l-.1 .5 0 .1 0 0 0 0s0 0 15.4 4.2L.6 235.8c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2z"]
};
var faHeartCircleMinus = {
  prefix: 'fal',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faCircleW = {
  prefix: 'fal',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 170.8c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4l72 208c2.3 6.5 8.4 10.8 15.3 10.8s13-4.6 15.1-11.1L256 236.5l48.8 152.4c2.1 6.6 8.2 11 15.1 11.1s13.1-4.3 15.3-10.8l72-208c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9L320.6 333.4 271.2 179.1C269.1 172.5 263 168 256 168s-13.1 4.5-15.2 11.1L191.4 333.4 135.1 170.8z"]
};
var faCircleCalendar = {
  prefix: 'fal',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 96c8.8 0 16 7.2 16 16v16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c26.5 0 48 21.5 48 48v16 32V336c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V224 192 176c0-26.5 21.5-48 48-48h16V112c0-8.8 7.2-16 16-16zm-48 80v16H352V176c0-8.8-7.2-16-16-16H304 208 176c-8.8 0-16 7.2-16 16zm192 48H160V336c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V224z"]
};
var faCalendarCircle = faCircleCalendar;
var faHourglassHalf = {
  prefix: 'fal',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16H32l0-44.7c0-31.6 10.4-62.4 29.6-87.5L131.9 256 61.6 164.1C42.4 139 32 108.3 32 76.7V32H16C7.2 32 0 24.8 0 16S7.2 0 16 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V76.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l70.2 91.9C341.6 373 352 403.7 352 435.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zm304-32V435.3c0-24.6-8.1-48.5-23-68L219.3 265.7c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64l0 44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68L64 480H320zM192 208c-4.9 0-9.5-2.2-12.5-6l-64-80c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1h64 64c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-64 80c-3 3.8-7.6 6-12.5 6zm-30.7-80L192 166.4 222.7 128H192 161.3zM144 352h96c6.1 0 11.6 3.4 14.3 8.8l32 64c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H192 112c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l32-64c2.7-5.4 8.3-8.8 14.3-8.8zm-6.1 64H192h54.1l-16-32H153.9l-16 32z"]
};
var faHourglass2 = faHourglassHalf;
var faMicroscope = {
  prefix: 'fal',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M192 0c-17.7 0-32 14.3-32 32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V160c88.4 0 160 71.6 160 160s-71.6 160-160 160H208 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H208h80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H394.2c51.7-34.4 85.8-93.2 85.8-160c0-106-86-192-192-192V64c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32H192zm0 32h32V48c0 8.8 7.2 16 16 16h16V288H160V64h16c8.8 0 16-7.2 16-16V32zM160 368c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM96 432c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faSunset = {
  prefix: 'fal',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M299.3 219.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 169.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V169.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm94.2 5.9c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448H462.1l38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8L75.2 391.8 113.9 448H75.1L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H164c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSink = {
  prefix: 'fal',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M272 80c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-44.2-35.8-80-80-80s-80 35.8-80 80V288H160V272c0-26.5-21.5-48-48-48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16 7.2 16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144 256 368 496c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V272c0-8.8 7.2-16 16-16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H400c-26.5 0-48 21.5-48 48v16H272V80zM32 352v48c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112V352H448v48c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V352H32z"]
};
var faCalendarExclamation = {
  prefix: 'fal',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zM200 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40-160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTruckContainerEmpty = {
  prefix: 'fal',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M448 160c0-17.7 14.3-32 32-32h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8V256v48 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 240 224 160zm144 64l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H480v64H592zm16 32H480v80c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9V304 256zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faHandHeart = {
  prefix: 'fal',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", "M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8c30.9 0 56 25.1 56 56v13.4c7.3-3.5 15.4-5.4 24-5.4c30.9 0 56 25.1 56 56V336c0 97.2-78.8 176-176 176h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0L128 288.8V88c0-30.9 25.1-56 56-56c9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V327.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H304c79.5 0 144-64.5 144-144V152c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V152.1l0-.1V88c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24V79.9l0 .1V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1zm13.7 250.8c0 5.8 2.3 11.4 6.5 15.4L288 412.4l59.8-58.1c4.2-4 6.5-9.6 6.5-15.4c0-11.9-9.6-21.5-21.5-21.5h-1.5c-6 0-11.7 2.3-16 6.5l-16.1 15.6c-6.2 6-16.1 6-22.3 0l-16.1-15.6c-4.3-4.2-10.1-6.5-16-6.5h-1.5c-11.9 0-21.5 9.6-21.5 21.5zm21.5-53.5h1.5c14.3 0 28.1 5.6 38.4 15.6l4.9 4.8 4.9-4.8c10.3-10 24-15.6 38.4-15.6h1.5c29.5 0 53.5 23.9 53.5 53.5c0 14.4-5.8 28.3-16.2 38.4l-70.9 69c-6.2 6-16.1 6-22.3 0l-70.9-69c-10.4-10.1-16.2-23.9-16.2-38.4c0-29.5 23.9-53.5 53.5-53.5z"]
};
var faBagShopping = {
  prefix: 'fal',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 96v32H288V96c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 64H48c-8.8 0-16 7.2-16 16V416c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V176c0-8.8-7.2-16-16-16H320v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H160v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160zm0-32V96c0-53 43-96 96-96s96 43 96 96v32h80c26.5 0 48 21.5 48 48V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V176c0-26.5 21.5-48 48-48h80z"]
};
var faShoppingBag = faBagShopping;
var faArrowDownZA = {
  prefix: 'fal',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 32H480c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 192H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L446.7 64H352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 256c6.1 0 11.6 3.4 14.3 8.8l63.9 127.7c.1 .2 .2 .4 .3 .6l15.8 31.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L470.1 448H361.9l-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7c.1-.2 .2-.4 .3-.6l63.9-127.7c2.7-5.4 8.2-8.8 14.3-8.8zM377.9 416h76.2L416 339.8 377.9 416z"]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faMitten = {
  prefix: 'fal',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M0 144.2C0 64.6 65.1 0 144.6 0C208 0 264.4 41.5 282.8 102.3l24.6 81.3c15.3-15 36-23.6 57.9-23.6h1.8c44.7 0 80.9 36.2 80.9 80.9c0 18.6-6.4 36.6-18.1 51l-61.8 76H328c.6-1.7 1.5-3.3 2.6-4.7L405 271.8c7.1-8.7 11-19.6 11-30.9c0-27-21.9-48.9-48.9-48.9h-1.8c-17.6 0-34 9.1-43.2 24.1l-7 11.4c-3.3 5.4-9.4 8.3-15.7 7.5s-11.4-5.2-13.3-11.2L252.2 111.6C237.9 64.4 194 32 144.6 32C82.6 32 32 82.4 32 144.2c0 9.2 1.1 18.3 3.3 27.2L84.5 368h-33L4.3 179.2C1.4 167.7 0 156 0 144.2zM64 432l0 48H352V432H64zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432z"]
};
var faReplyClock = {
  prefix: 'fal',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M496 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256A144 144 0 1 0 496 0a144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V80c0-8.8-7.2-16-16-16zm16 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-5.7 0-11.4-.3-17-.8c.6 5.5 1 11.1 1 16.8c0 46.1-15.9 79.7-34 103.2c1.3-7.1 2-14.8 2-23.2c0-70.7-57.3-128-128-128H224h-8c-13.3 0-24 10.7-24 24v8 16l0 48L32 240 192 96v48 16 8c0 13.3 10.7 24 24 24h8H326.6c-2.9-10.3-4.9-21-5.9-32H256 224V144 128 96c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V352 336 320h32 64c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C430.5 499.9 512 449.3 512 336z"]
};
var faReplyTime = faReplyClock;
var faPersonRays = {
  prefix: 'fal',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", "M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0zm502.6 0c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zM27.3 507.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm480 0c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM232 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM243.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H224V164c6-2.6 12.5-4 19.3-4zM224 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L339.3 170.3c-13.9-26-41-42.3-70.6-42.3H243.3c-29.5 0-56.7 16.3-70.6 42.3L113.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L192 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faRight = {
  prefix: 'fal',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M416 253.7l0 4.6c0 4.4-1.8 8.6-5 11.6L261.2 412.5c-2.3 2.2-5.4 3.5-8.7 3.5c-6.9 0-12.6-5.6-12.6-12.6l0-83.4c0-8.8-7.2-16-16-16L48 304c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l176 0c8.8 0 16-7.2 16-16l0-83.4c0-6.9 5.6-12.6 12.6-12.6c3.2 0 6.3 1.2 8.7 3.5L411 242.1c3.2 3 5 7.2 5 11.6zM252.6 448c11.4 0 22.5-4.4 30.7-12.3L433.1 293c9.5-9.1 14.9-21.6 14.9-34.8l0-4.6c0-13.1-5.4-25.7-14.9-34.8L283.3 76.3C275 68.4 264 64 252.6 64C228 64 208 84 208 108.6l0 67.4L48 176c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0 0 67.4c0 24.6 20 44.6 44.6 44.6z"]
};
var faArrowAltRight = faRight;
var faCircleF = {
  prefix: 'fal',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32v96V368c0 8.8 7.2 16 16 16s16-7.2 16-16V272H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V160H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"]
};
var faUsers = {
  prefix: 'fal',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"]
};
var faFacePleading = {
  prefix: 'fal',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280.1 410.7c-4.7-5.3-12.7-10.7-24.1-10.7s-19.4 5.4-24.1 10.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c9.2-10.2 25.2-21.3 47.9-21.3s38.7 11.1 47.9 21.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM331.6 96.6c8.5-2.4 17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8zM191.4 116.4l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18 6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm240-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-272 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z"]
};
var faEyeSlash = {
  prefix: 'fal',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"]
};
var faFlaskVial = {
  prefix: 'fal',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M224 32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 192 64 32 16C7.2 0 0 7.2 0 16s7.2 16 16 16H32V352c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-14.2 3-28.3 8.8-41.2C157.7 410.5 143.5 416 128 416c-35.3 0-64-28.7-64-64V192H192V352c0 4-.4 7.8-1 11.6l33-53.7V32zM64 32H192V160H64V32zM304 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V219.5L201.8 411.6c-6.4 10.4-9.8 22.3-9.8 34.5c0 36.4 29.5 65.9 65.9 65.9H574.1c36.4 0 65.9-29.5 65.9-65.9c0-12.2-3.4-24.1-9.8-34.5L512 219.5V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zM480 32V224c0 3 .8 5.9 2.4 8.4L536.3 320H295.7l53.9-87.6c1.6-2.5 2.4-5.4 2.4-8.4V32H480zM229 428.4L276 352H556l47 76.4c3.3 5.3 5 11.5 5 17.8c0 18.7-15.2 33.9-33.9 33.9H257.9c-18.7 0-33.9-15.2-33.9-33.9c0-6.3 1.7-12.4 5-17.8z"]
};
var faPoliceBox = {
  prefix: 'fal',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96C78.3 32 64 46.3 64 64v.8C45.7 68.5 32 84.6 32 104V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V104c0-19.4-13.7-35.5-32-39.2V64c0-17.7-14.3-32-32-32H208V16zm112 88V480H64V104c0-4.4 3.6-8 8-8h8c8.8 0 16-7.2 16-16V64h96 96V80c0 8.8 7.2 16 16 16h8c4.4 0 8 3.6 8 8zM112 328V280h48v48H112zM88 272v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm24-120h20v20H112V152zm28 0h20v20H140V152zm0 28h20v20H140V180zm-8 20H112V180h20v20zm-28-72c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H104zm120 72V180h20v20H224zm28 0V180h20v20H252zm0-28V152h20v20H252zm-8-20v20H224V152h20zm-44-8v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16z"]
};
var faCucumber = {
  prefix: 'fal',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M195.9 451.9l256-256c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0l-256 256c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0zm21.8 23.4c-50 49.2-130.5 48.9-180.2-.8c-50-50-50-131 0-181l95.2-95.2c-7-9.4-6.2-22.7 2.3-31.2s21.9-9.3 31.2-2.3L293.5 37.5c50-50 131-50 181 0c49.7 49.7 50 130.2 .8 180.2c7 9.4 6.2 22.7-2.3 31.3s-21.8 9.3-31.2 2.3L251.3 441.7c7 9.4 6.2 22.7-2.3 31.2s-21.9 9.3-31.3 2.3zM128 308a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm204-84a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm12-108a20 20 0 1 1 40 0 20 20 0 1 1 -40 0z"]
};
var faHeadSideBrain = {
  prefix: 'fal',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm171.1-99.8c4.1-7.3 12-12.2 20.9-12.2s16.8 4.9 20.9 12.2c4.3 7.6 13.9 10.4 21.6 6.2c2.8-1.5 6-2.4 9.5-2.4c7 0 13.2 3.6 16.8 9.1c3.4 5.2 9.5 8 15.7 7.1c1.1-.2 2.3-.3 3.5-.3c13.3 0 24 10.7 24 24s-10.7 24-24 24H268.7c-5.4 0-10.4 2.7-13.4 7.2s-3.4 10.2-1.3 15.2c1.3 2.9 2 6.2 2 9.6c0 11.6-8.2 21.3-19.2 23.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5c25.6-5.2 44.8-27.8 44.8-54.9h24c30.9 0 56-25.1 56-56c0-30.4-24.2-55.2-54.5-56c-9.5-9.9-22.8-16-37.5-16c-4 0-7.8 .4-11.5 1.3C254.3 86.6 239.9 80 224 80s-30.3 6.6-40.5 17.3C179.8 96.4 176 96 172 96c-22.2 0-41.1 13.9-48.6 33.4C98.6 135.1 80 157.4 80 184c0 19.2 9.7 36.1 24.3 46.2c3.1 28 26.8 49.8 55.7 49.8v24c0 8.8 7.2 16 16 16s16-7.2 16-16V260.7c0-5.4-2.7-10.4-7.2-13.4s-10.2-3.4-15.2-1.3c-2.9 1.3-6.2 2-9.6 2c-13.3 0-24-10.7-24-24c0-.7 0-1.3 .1-2c.6-6.8-3.3-13.3-9.6-16c-8.6-3.7-14.5-12.2-14.5-22c0-13.3 10.7-24 24-24l.2 0c8.2 0 15-6.1 15.9-14.2c1.1-10 9.6-17.8 19.9-17.8c3.5 0 6.7 .9 9.5 2.4c7.7 4.2 17.3 1.4 21.6-6.2z"]
};
var faHand = {
  prefix: 'fal',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M264 0c-24.9 0-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8c-30.9 0-56 25.1-56 56V288.8L95.6 256.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L120.2 439.4C166.7 485.9 229.8 512 295.5 512H304c97.2 0 176-78.8 176-176V152c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C310 16.3 288.9 0 264 0zM184 64c13.3 0 24 10.7 24 24l0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V80l0-.1V56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V87.9C320 74.7 330.8 64 344 64c13.3 0 24 10.7 24 24v64c0 0 0 0 0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V151.9c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24V336c0 79.5-64.5 144-144 144h-8.5c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V88c0-13.3 10.7-24 24-24z"]
};
var faHandPaper = faHand;
var faPersonBikingMountain = {
  prefix: 'fal',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M416 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 336 56zM130 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H130zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H130c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6C9.2 411.5 0 397.8 0 382V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM189.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zM498 272c-3.9 0-7.1 2.7-7.8 6.4c-1.2 5.8-5.5 10.5-11.2 12.2c-6.2 1.8-12.1 4.3-17.7 7.3c-5.2 2.9-11.6 2.6-16.5-.7c-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1c3.3 5 3.6 11.3 .7 16.5c-3 5.6-5.5 11.5-7.3 17.7c-1.7 5.7-6.4 10-12.2 11.2c-3.6 .7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8c5.8 1.2 10.5 5.5 12.2 11.2c1.8 6.2 4.3 12.1 7.3 17.7c2.9 5.2 2.6 11.6-.7 16.5c-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1c5-3.3 11.3-3.6 16.5-.7c5.6 3 11.5 5.5 17.7 7.3c5.7 1.7 10 6.4 11.2 12.2c.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4c1.2-5.8 5.5-10.5 11.2-12.2c6.2-1.8 12.1-4.3 17.7-7.3c5.2-2.9 11.6-2.6 16.5 .7c3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1c-3.3-5-3.6-11.3-.7-16.5c3-5.6 5.5-11.5 7.3-17.7c1.7-5.7 6.4-10 12.2-11.2c3.6-.7 6.4-4 6.4-7.8V370c0-3.9-2.7-7.1-6.4-7.8c-5.8-1.2-10.5-5.5-12.2-11.2c-1.8-6.2-4.3-12.1-7.3-17.7c-2.9-5.2-2.6-11.6 .7-16.5c2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1c-5 3.3-11.3 3.6-16.5 .7c-5.6-3-11.5-5.5-17.7-7.3c-5.7-1.7-10-6.4-11.2-12.2c-.7-3.6-4-6.4-7.8-6.4H498zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5c2.9 1.1 5.8 2.3 8.6 3.6c14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3c1.3 2.8 2.5 5.7 3.6 8.6c13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36c-1.1 2.9-2.3 5.8-3.6 8.6c4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5c-2.8 1.3-5.7 2.5-8.6 3.6c-6.5 13.3-20.1 22.5-36 22.5H498c-15.8 0-29.5-9.2-36-22.5c-2.9-1.1-5.8-2.3-8.6-3.6c-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3c-1.3-2.8-2.5-5.7-3.6-8.6c-13.3-6.5-22.5-20.1-22.5-36V370c0-15.8 9.2-29.5 22.5-36c1.1-2.9 2.3-5.8 3.6-8.6c-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5c2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zM557.5 376a53.5 53.5 0 1 1 -107 0 53.5 53.5 0 1 1 107 0zM330.2 166.7c-6-5.4-15-5.5-21.1-.3L250 217.1c-8 6.8-7.3 19.4 1.3 25.3l93.7 64.4c4.3 3 6.9 7.9 6.9 13.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V328.4l-86.8-59.7c-26-17.9-28-55.5-4-76l59.1-50.6c18.3-15.7 45.4-15.4 63.3 .8L406.1 192H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-4 0-7.8-1.5-10.7-4.1l-59.1-53.2zM169.3 166l69.9-63.1-3.7-3.5c-11.8-11-29.9-11.6-42.3-1.3l-49.6 41.2L169.3 166zm104.3-51l-94.4 85.2c-6.4 5.8-16.3 5.4-22.3-.8l-48.3-50.3c-6.4-6.7-5.8-17.5 1.3-23.4l62.8-52.2c24.8-20.6 61.1-19.5 84.7 2.6l16.4 15.4c6.8 6.4 6.7 17.3-.2 23.5z"]
};
var faBikingMountain = faPersonBikingMountain;
var faUtensilsSlash = {
  prefix: 'fal',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", "M151.8 18.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.5 3L148.4 39l3.4-20.3zM197 77.3l3-60.5C200.4 8 193.6 .5 184.8 0S168.5 6.4 168 15.2L166.1 53 197 77.3zm56.4 44.5L248 15.2C247.5 6.4 240-.4 231.2 0s-15.6 8-15.2 16.8L220 95.5l33.4 26.3zM129.3 187L96.1 160.8c-.1 1.5-.1 3-.1 4.5V176c0 44.2 35.8 80 80 80h16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V261.8L176.2 224H176c-22.7 0-41.8-15.8-46.7-37zM320 174.5v-9.2c0-4.4-.4-8.8-1.1-13.2L295.8 13.4c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l21.5 128.7L320 174.5zM544 351.3V336 320 32c0-17.7-14.3-32-32-32C496 0 384 32 384 176v49l32 25.3V176c0-62.5 23.8-97.7 47-117.8c12-10.4 24.4-17.2 34.5-21.3c7.6-3.1 12.6-4.2 14.3-4.6l.2-.1V320h-7.6L544 351.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPrintMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M160 160V64c0-17.7 14.3-32 32-32H421.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6V160h32V90.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0H192c-35.3 0-64 28.7-64 64v96h32zm-32 64H320c9.1-12.1 19.9-22.9 32-32H128c-35.3 0-64 28.7-64 64V384c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32H480c15.8 0 29-11.5 31.6-26.6L498.2 472c-5.9 1.9-12 3.6-18.2 4.8V480H448 160l0-128H291.2c-2.1-10.3-3.2-21-3.2-32H160c-17.7 0-32 14.3-32 32v32H96V256c0-17.7 14.3-32 32-32zm320 .1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
var faPrintSearch = faPrintMagnifyingGlass;
var faFolderBookmark = {
  prefix: 'fal',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H416V304c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7L336 289.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6V117c-3.3-2.3-6.5-4.8-9.4-7.7L210.7 73.4c-6-6-14.1-9.4-22.6-9.4H64C46.3 64 32 78.3 32 96zm352 32H291.9c-1.3 0-2.6 0-3.9-.1V278.1l40.8-20.4c4.5-2.3 9.8-2.3 14.3 0L384 278.1V128zm16-32h48c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H188.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H400z"]
};
var faOm = {
  prefix: 'fal',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M321.4 33.4l24-24c12.5-12.5 32.8-12.5 45.3 0l24 24c12.5 12.5 12.5 32.8 0 45.3l-24 24c-12.5 12.5-32.8 12.5-45.3 0l-24-24c-12.5-12.5-12.5-32.8 0-45.3zM368 80l1.4-1.4 21.3-21.3L392 56l-1.4-1.4L369.4 33.4 368 32l-1.4 1.4L345.4 54.6 344 56l1.4 1.4 21.3 21.3L368 80zM144 128c-20.9 0-39.5 10-51.2 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C84.7 111.1 112.6 96 144 96c53 0 96 43 96 96c0 24.6-9.2 47-24.4 64h43.5c25.4 0 50.1-8.7 70-24.5l22.2-17.8c17.5-14 39.3-21.7 61.8-21.7c54.6 0 98.9 44.3 98.9 98.9v94c0 52.5-42.6 95.1-95.1 95.1c-36 0-69-20.4-85.1-52.6l-10.1-20.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l10.1 20.3C371.1 434.5 393 448 416.9 448c34.9 0 63.1-28.3 63.1-63.1v-94c0-37-30-66.9-66.9-66.9c-15.2 0-29.9 5.2-41.8 14.7l-22.2 17.8c-25.5 20.4-57.3 31.6-90 31.6H244.7c26.6 23.5 43.3 57.8 43.3 96c0 70.7-57.3 128-128 128H144C64.5 512 0 447.5 0 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 61.9 50.1 112 112 112h16c53 0 96-43 96-96s-43-96-96-96H144c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64s-28.7-64-64-64zm154.4-12.2c.7 .5 1.9 1.3 3.6 2.3c3.2 1.9 8.1 4.6 14.4 7.3c12.6 5.4 30.4 10.7 51.7 10.7s39.1-5.3 51.7-10.7c6.3-2.7 11.1-5.3 14.4-7.3c1.6-1 2.8-1.7 3.6-2.3c.4-.3 .6-.4 .8-.5l.1-.1h0l0 0 0 0-140.9 0 141 0c7.1-5.2 17.1-3.8 22.3 3.3c5.3 7.1 3.8 17.1-3.2 22.4L448 128c9.6 12.8 9.6 12.8 9.6 12.8l0 0 0 0-.1 0-.1 .1-.4 .3c-.3 .2-.8 .6-1.4 1c-1.2 .8-2.9 1.9-5 3.2c-4.3 2.6-10.4 5.9-18.2 9.2C416.8 161.3 394.6 168 368 168s-48.8-6.7-64.2-13.3c-7.8-3.3-13.9-6.7-18.2-9.2c-2.1-1.3-3.8-2.4-5-3.2c-.6-.4-1.1-.7-1.4-1l-.4-.3-.1-.1-.1 0 0 0 0 0s0 0 9.6-12.8l-9.6 12.8c-7.1-5.3-8.5-15.3-3.2-22.4c5.3-7.1 15.3-8.5 22.3-3.3l0 0s0 0 0 0l0 0 .1 .1c.1 .1 .4 .3 .8 .5z"]
};
var faPi = {
  prefix: 'fal',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H128V251c0 61.8-21 121.7-59.6 169.9l-.9 1.1c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l.9-1.1C136.5 387 160 320 160 251V96H320V382.6c0 36.1 29.3 65.4 65.4 65.4c24.8 0 47.4-14 58.5-36.2l2.3-4.7c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-2.3 4.7c-5.7 11.3-17.2 18.5-29.9 18.5C367 416 352 401 352 382.6V96h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faFlaskRoundPotion = {
  prefix: 'fal',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", "M160 32H288V157.7c0 18.2 10.1 33.7 24.4 42C364.8 230.3 400 287 400 351.9c-55.6-1.3-87.4-15.5-115.7-30.1c-2.9-1.5-5.7-3-8.6-4.5C248.3 302.9 220 288 176 288c-47 0-83.5 12.8-108.4 25.8c-6.6 3.5-12.4 6.9-17.4 10.2c8.5-53 40.6-98.1 85.4-124.2c14.3-8.3 24.4-23.9 24.4-42V32zM397.1 383.8c-6.3 34.7-22.8 65.8-46.3 90.2c-3.1 3.2-8.8 5.9-17 5.9H114.2c-8.2 0-13.9-2.7-17-5.9c-27.6-28.6-45.5-66.5-48.7-108.5c1-.6 1.9-1.4 2.8-2.2l0 0 0 0 .2-.2c.3-.2 .7-.6 1.3-1.2c1.2-1.1 3.2-2.7 5.8-4.7c5.2-4 13.2-9.5 23.8-15C103.5 331.2 135 320 176 320c35.8 0 57.7 11.4 85.1 25.8c2.8 1.4 5.6 2.9 8.5 4.4c30.6 15.8 66.7 31.9 127.5 33.6zM51.3 363.4l0 0 0 0c0 0 0 0 0 0zm0 0l0 0s0 0 0 0zM320 157.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304 144 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V157.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z"]
};
var faFlaskPotion = faFlaskRoundPotion;
var faFaceShush = {
  prefix: 'fal',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 45.8-13.7 88.4-37.3 123.9c-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5C496.3 357 512 308.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 83.8 40.2 158.1 102.4 204.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4C67.2 394.3 32 329.3 32 256zM200.4 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm160 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM164.7 228.7c-6.2 6.2-6.2 16.4 0 22.6c10.3 10.3 24.7 20.8 43.3 28v28.4c-32.5 10.2-56 40.5-56 76.3v48c0 44.2 35.8 80 80 80h56 1.5c28.5 0 55.5-12.7 73.7-34.5l25.6-30.7c17-20.4 14.2-50.6-6.1-67.6c-11.6-9.7-26.4-12.9-40.1-10.2c-4.4-23.2-18.8-42.8-38.6-54.2V279.3c18.6-7.2 33.1-17.7 43.3-28c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-5.3 5.3-12.2 10.8-20.7 15.4V240c0-26.5-21.5-48-48-48s-48 21.5-48 48v4.1c-8.5-4.7-15.4-10.1-20.7-15.4c-6.2-6.2-16.4-6.2-22.6 0zM256 224c8.8 0 16 7.2 16 16v64H240V240c0-8.8 7.2-16 16-16zM217.2 378l76.7 69.7c7.9-1.1 15.1-5 20.2-11.2l25.6-30.7c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L338.7 457c-12.2 14.6-30.2 23-49.2 23H288 232c-26.5 0-48-21.5-48-48V384c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-8.8-7.2-16-16-16H232c-6.7 0-12.5 4.1-14.8 10z"]
};
var faWorm = {
  prefix: 'fal',
  iconName: 'worm',
  icon: [512, 512, [], "e599", "M432 192V164.2l-27.5-3.9-31.1-4.4c-30.7-4.4-53.4-30.6-53.4-61.6C320 59.9 347.9 32 382.3 32h40.1C454.2 32 480 57.8 480 89.6V160v48V356c0 68.5-55.5 124-124 124s-124-55.5-124-124V320c0-44.2-35.8-80-80-80c-39.8 0-72 32.2-72 72V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-66.3 53.7-120 120-120c70.7 0 128 57.3 128 128v36c0 42 34 76 76 76s76-34 76-76V192zM382.3 0C330.2 0 288 42.2 288 94.3c0 46.9 34.5 86.7 80.9 93.3L400 192V356c0 24.3-19.7 44-44 44s-44-19.7-44-44V320c0-88.4-71.6-160-160-160C68.1 160 0 228.1 0 312V456c0 30.9 25.1 56 56 56s56-25.1 56-56V312c0-22.1 17.9-40 40-40c26.5 0 48 21.5 48 48v36c0 86.2 69.8 156 156 156s156-69.8 156-156V208 160 89.6C512 40.1 471.9 0 422.4 0H382.3zM408 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHouseCircleXmark = {
  prefix: 'fal',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9H240V480h16 80 24.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faPlug = {
  prefix: 'fal',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c80.9-8 144-76.2 144-159.2V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM192 368c-70.7 0-128-57.3-128-128V176H320v64c0 70.7-57.3 128-128 128z"]
};
var faCalendarCircleExclamation = {
  prefix: 'fal',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faSquareI = {
  prefix: 'fal',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faChevronUp = {
  prefix: 'fal',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"]
};
var faFaceSaluting = {
  prefix: 'fal',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M368.8 32.6c-10.1-.8-20.1-.8-30-.3c-8.8 .5-16.4-6.2-16.9-15.1s6.2-16.4 15-16.9c11.2-.6 22.7-.6 34.2 .3c141 10.6 246.7 133.4 236.1 274.4s-133.4 246.7-274.4 236.1C221.7 503 132.5 424.8 104.9 323c-2.3-8.5 2.7-17.3 11.3-19.6s17.3 2.7 19.6 11.3C159.9 403.7 238 472.1 335.3 479.4c123.4 9.3 230.9-83.3 240.1-206.6s-83.3-230.9-206.6-240.1zM235 345.2c5.2-7.2 15.2-8.8 22.3-3.6c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3zm37.3-160.6a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM257.5 89.4l-38 23.9c5.2 3.6 9.8 8.3 13.4 14.1c14 22.5 7.2 52.2-15.2 66.3l-64 40.1 0 0-.1 .1-29 18.2C80.9 279.4 23.2 259.8 5.2 211.5c-13.6-36.4 .2-77.3 33.1-97.9L206.7 7.8c22.4-14.1 52-7.2 66 15.3s7.2 52.2-15.2 66.3zm-17-27.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L54.7 140.4c-20 12.5-28.4 37.3-20.1 59.4c11 29.3 46 41.2 72.6 24.6l93.3-58.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L128 173.7V132.4L240.5 62.1z"]
};
var faGaugeSimpleLow = {
  prefix: 'fal',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-18.6 7.9-35.3 20.5-47L129.9 151.6c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64z"]
};
var faTachometerSlow = faGaugeSimpleLow;
var faFacePersevering = {
  prefix: 'fal',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM129.3 232.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 272l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 272l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM211.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faCircleCamera = {
  prefix: 'fal',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.2 142.5L191.7 160H184c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56H328c30.9 0 56-25.1 56-56V216c0-30.9-25.1-56-56-56h-7.7l-7.5-17.5c-3.8-8.8-12.5-14.5-22.1-14.5H221.3c-9.6 0-18.3 5.7-22.1 14.5zM226.6 160h58.9l9.6 22.3c2.5 5.9 8.3 9.7 14.7 9.7H328c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h18.3c6.4 0 12.2-3.8 14.7-9.7l9.6-22.3zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCameraCircle = faCircleCamera;
var faHandSpock = {
  prefix: 'fal',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", "M217.4 1.9c29.9-8.1 60.6 9.6 68.7 39.4l41.3 152.7L353.2 68.7c6.2-30.3 35.8-49.8 66.1-43.6s49.8 35.8 43.6 66.1l-2.5 12c12.3-7 27.2-9.3 41.9-5.4c29.9 7.9 47.8 38.5 39.9 68.4L481 398.6c-17.3 65.8-76.2 112-144 113.4c-.3 0-.7 0-1 0h-2.1H318.6c-58.8 0-115.8-20.9-160.6-59L51.7 362.7c-23.6-20-26.4-55.4-6.4-78.9l12 10.2-12-10.2c20-23.6 55.4-26.4 78.9-6.4l31.5 26.8-49-150.8c-9.6-29.4 6.5-61 35.9-70.6c13.3-4.3 27-3.4 39 1.6l-3.7-13.7c-8.1-29.9 9.6-60.6 39.4-68.7zM335.3 480c.2 0 .3 0 .5 0c53.8-.8 100.6-37.4 114.3-89.6l61.1-232.3c3.4-12.8-4.3-25.9-17.1-29.3s-25.9 4.3-29.3 17.1L430.5 276.1c-1.8 7-8.2 11.9-15.5 11.9h-5.8c-4.8 0-9.4-2.2-12.4-5.9s-4.2-8.6-3.3-13.3L431.5 84.8c2.7-13-5.7-25.7-18.7-28.3s-25.7 5.7-28.3 18.7L345.1 266.4c-1.5 7.3-7.8 12.5-15.2 12.8s-14-4.7-15.9-11.8L255.2 49.7c-3.5-12.8-16.6-20.4-29.4-16.9s-20.4 16.6-16.9 29.4l55.6 205.6c1.3 4.8 .3 9.9-2.7 13.9s-7.7 6.3-12.7 6.3h-2.7c-6.9 0-13.1-4.5-15.2-11.1L182.8 128.6c-4.1-12.6-17.6-19.5-30.2-15.4s-19.5 17.6-15.4 30.2l66.5 204.5c2.2 6.8-.4 14.3-6.3 18.2s-13.8 3.5-19.3-1.1l-74.5-63.3c-10.1-8.6-25.2-7.4-33.8 2.7s-7.4 25.2 2.7 33.8l106.2 90.3c39.1 33.2 88.6 51.4 139.9 51.4h15.3 1.4z"]
};
var faSpiderWeb = {
  prefix: 'fal',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M141.6 18.4c2.7-7.3 10.3-11.5 17.9-10.1l73.6 13.8c37 6.9 75 6.9 112 0L418.8 8.3c7.6-1.4 15.2 2.8 17.9 10.1l30.7 81.8c12 32 29.3 61.7 51.1 87.9l48.1 57.7c4.9 5.9 4.9 14.6 0 20.5L518.5 324c-21.8 26.2-39.1 55.9-51.1 87.9l-30.7 81.8c-2.7 7.3-10.3 11.5-17.9 10.1l-73.6-13.8c-37-6.9-75-6.9-112 0l-73.6 13.8c-7.6 1.4-15.2-2.8-17.9-10.1l-30.7-81.8c-12-32-29.3-61.7-51.1-87.9L11.7 266.2c-4.9-5.9-4.9-14.6 0-20.5L59.8 188c21.8-26.2 39.1-55.9 51.1-87.9l30.7-81.8zm17.8 43.7l-18.5 49.2c-13.2 35.3-32.3 68.1-56.5 97.1L58.2 240h70.5l2.6-2.9c25.4-29.1 45.1-62.7 57.9-99.1l5.2-14.7-35-61.2zM187 46l34.2 59.9c44.1 12 90.5 12 134.6 .2L390 46.2l-39 7.3c-40.9 7.7-82.9 7.7-123.8 0L187 46zM418.5 60.9l-35.2 61.7 5.4 15.4c12.8 36.4 32.5 70 57.9 99.1l2.6 2.9h71l-26.2-31.5c-24.1-29-43.2-61.8-56.5-97.1L418.5 60.9zM520.1 272H449l-1.1 1.3c-26.2 30-46.3 64.8-59.1 102.5l-5 14.6 34.7 60.7 18.9-50.5c13.2-35.3 32.3-68.1 56.5-97.1L520.1 272zM390 465.8l-32.2-56.4c-44.2-14.3-91.6-15.5-136.5-3.4L187 466l40.2-7.5c40.9-7.7 82.9-7.7 123.8 0l39 7.3zM159.4 449.9l35-61.2-5.2-14.8c-12.8-36.4-32.5-70-57.9-99.1l-2.4-2.8H58.2l26.2 31.5c24.1 29 43.2 61.8 56.5 97.1l18.5 49.3zM170.2 272c18.6 24.5 33.7 51.5 45 80.1L261 272H170.2zm72.3 96.8c30.9-4.7 62.4-4.1 93.1 1.8l-47.1-82.4-46 80.6zm120.2-15.3c11.1-29.2 26.3-56.6 45-81.6H316.1l46.6 81.6zM407.7 240c-18.8-24.7-34-51.9-45.3-80.9L316.1 240h91.6zm-73.1-96.8c-30.5 4.9-61.6 4.8-92.1-.1l46.1 80.6 46-80.5zM215.2 159.8c-11.3 28.7-26.4 55.7-45.1 80.2H261l-45.8-80.2z"]
};
var faCircleMicrophone = {
  prefix: 'fal',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 35.3-28.7 64-64 64s-64-28.7-64-64V160zm64-32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zM144 224c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V383c-63.1-7.9-112-61.7-112-127V240c0-8.8 7.2-16 16-16z"]
};
var faMicrophoneCircle = faCircleMicrophone;
var faBookArrowUp = {
  prefix: 'fal',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H176V480H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H176V384H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H304v32h80v64H304v32H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zm68.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 182.6 224 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-313.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z"]
};
var faPopsicle = {
  prefix: 'fal',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M288 160c0-70.7-57.3-128-128-128S32 89.3 32 160V336c0 8.8 7.2 16 16 16h96V192c0-8.8 7.2-16 16-16s16 7.2 16 16V352h96c8.8 0 16-7.2 16-16V160zM144 384H48c-26.5 0-48-21.5-48-48V160C0 71.6 71.6 0 160 0s160 71.6 160 160V336c0 26.5-21.5 48-48 48H176V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384z"]
};
var faCommand = {
  prefix: 'fal',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M0 88C0 39.4 39.4 0 88 0s88 39.4 88 88v56H336V88c0-48.6 39.4-88 88-88s88 39.4 88 88s-39.4 88-88 88H368V336h56c48.6 0 88 39.4 88 88s-39.4 88-88 88s-88-39.4-88-88V368H176v56c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88h56V176H88C39.4 176 0 136.6 0 88zm144 56V88c0-30.9-25.1-56-56-56S32 57.1 32 88s25.1 56 56 56h56zm32 192H336V176H176V336zm-32 32H88c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56V368zm224 0v56c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56H368zm0-224h56c30.9 0 56-25.1 56-56s-25.1-56-56-56s-56 25.1-56 56v56z"]
};
var faBlinds = {
  prefix: 'fal',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H160V258.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V96H32C14.3 96 0 81.7 0 64V32zm480 0H32V64H480V32zM96 192v32H20.9C9.3 224 0 214.7 0 203.1c0-2.1 .3-4.1 .9-6.1l21.2-69H55.6L35.9 192H96zm96 32V192H476.1l-19.7-64h33.5l21.2 69c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H192zM65.6 288c-1 5.2-1.6 10.5-1.6 16s.6 10.8 1.6 16H20.9C9.3 320 0 310.7 0 299.1c0-2.1 .3-4.1 .9-6.1l11.4-37H45.8l-9.8 32H65.6zm156.8 32c1-5.2 1.6-10.5 1.6-16s-.6-10.8-1.6-16H476.1l-9.8-32h33.5l11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H222.4zM144 384H476.1l-9.8-32h33.5l11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H20.9C9.3 416 0 406.7 0 395.1c0-2.1 .3-4.1 .9-6.1l11.4-37H45.8l-9.8 32H144zm322.2 64h33.5l11.4 37c.6 2 .9 4.1 .9 6.1c0 11.5-9.3 20.9-20.9 20.9H20.9C9.3 512 0 502.7 0 491.1c0-2.1 .3-4.1 .9-6.1l11.4-37H45.8l-9.8 32H476.1l-9.8-32zM144 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faStopwatch = {
  prefix: 'fal',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", "M128 16c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V96.6c49.4 3.8 94 24.8 127.7 57l37-37c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-38.2 38.2C416 212.6 432 256.4 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-109.5 84.6-199.2 192-207.4V32H144c-8.8 0-16-7.2-16-16zM48 304a176 176 0 1 0 352 0A176 176 0 1 0 48 304zm192-96V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSaxophone = {
  prefix: 'fal',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M521.9 32c-20.8 0-40.8 8.1-55.7 22.6L221.1 292.3c-2.3 2.3-5.4 3.5-8.7 3.5c-6.9 0-12.5-5.6-12.5-12.5v-4.5c0-2.3 .5-4.7 1.4-6.8l49-112.1H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H240 48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H28.3L3.6 277.2C1.2 288.6 0 300.2 0 311.8v5.6C0 407.2 72.8 480 162.6 480c48.8 0 94.9-21.9 125.8-59.6L522.8 133.9c3-3.7 7.6-5.9 12.4-5.9h77.5c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L606.1 55.4c-15-15-35.4-23.4-56.6-23.4H521.9zM61 160H215.5l-43.4 99.3c-2.7 6.2-4.1 12.9-4.1 19.6v4.5c0 24.6 19.9 44.5 44.5 44.5c11.6 0 22.7-4.5 31-12.5L488.5 77.5c9-8.7 20.9-13.5 33.4-13.5h27.6c12.7 0 24.9 5.1 33.9 14.1L601.4 96H535.2c-14.4 0-28 6.5-37.2 17.6L263.6 400.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 448 32 389.5 32 317.4v-5.6c0-9.4 1-18.8 2.9-28L61 160zm43 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40-104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquare2 = {
  prefix: 'fal',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm185 78.4L171 187.7c-6.4 6.1-16.6 5.7-22.6-.7s-5.7-16.6 .7-22.6l14.1-13.2c15.8-14.9 36.8-23 58.5-22.7C267.3 129 304 166.3 304 212c0 22.2-8.8 43.4-24.5 59.1L198.6 352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L256.9 248.5c9.7-9.7 15.1-22.8 15.1-36.5c0-28.2-22.7-51.2-50.9-51.6c-13.4-.2-26.3 4.8-36.1 14z"]
};
var faFieldHockeyStickBall = {
  prefix: 'fal',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", "M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4c-5.3 0-10.5-4.7-10.5-11c0-1.6 .4-3.1 .9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1 .3-84.4 32.7l-17 38.5C4.8 334 .7 352.9 .6 371.8C0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7L500.3 100.9zM474.2 82.4l-54 76.7-51.2-38.4 52.9-75.1C432 31.1 452 27.7 466.4 37.8S484.3 68 474.2 82.4zM401.7 185.3L226.1 434.6c-19.9 28.2-52.2 45-86.7 45.1C79.9 480 32.1 431 32.6 372c.1-14.6 3.2-29.1 9.1-42.5l17-38.5c7.1-16.2 26-23.5 42.2-16.3s23.5 26 16.3 42.2l-17 38.5c-2.4 5.3-3.6 11.2-3.7 17.1c-.2 23.9 19.2 43.3 42.6 43.2c13.8 0 26.7-6.8 34.6-18L350.5 146.9l51.2 38.4zM432 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faFieldHockey = faFieldHockeyStickBall;
var faArrowUpSquareTriangle = {
  prefix: 'fal',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 176V80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm64 147.5L490.7 448H341.3L416 323.5zM320 176c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v96zM307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 301.7c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442z"]
};
var faSortShapesUpAlt = faArrowUpSquareTriangle;
var faFaceScream = {
  prefix: 'fal',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", "M543.2 274.5c.5-6.1 .8-12.3 .8-18.5C544 132.3 443.7 32 320 32S96 132.3 96 256c0 6.2 .3 12.4 .8 18.5c-10.5-2.5-21.4-3.2-32.2-1.9c-.4-5.5-.5-11-.5-16.6C64 114.6 178.6 0 320 0S576 114.6 576 256c0 5.6-.2 11.1-.5 16.6c-10.8-1.3-21.7-.6-32.2 1.9zM407.6 462.2c-2.7 12.2-4.9 24.5-6.4 36.6C375.7 507.4 348.4 512 320 512c-28.4 0-55.6-4.6-81.1-13.1c-1.5-12.2-3.6-24.4-6.4-36.6C259.4 473.7 288.9 480 320 480c31.1 0 60.7-6.3 87.6-17.8zM224.3 164.4c-13.1 5.8-26.4 17.1-36.1 33c-9.7 15.9-13.3 32.2-12.1 45.3c1.2 13 6.9 21.7 14.7 26c8.1 4.4 19.5 4.7 32.7-1.1c13.1-5.8 26.4-17.1 36.1-33c9.7-15.9 13.3-32.2 12.1-45.3c-1.2-13-6.9-21.7-14.7-26c-8.1-4.4-19.5-4.7-32.7 1.1zm-12.9-29.3c19.4-8.6 41.8-10.4 61 .1c19.4 10.6 29.3 30.3 31.2 51.2c1.9 20.8-3.8 43.9-16.6 64.9c-12.8 21-30.9 37-50.5 45.6c-19.4 8.6-41.8 10.4-61-.1c-19.4-10.6-29.3-30.3-31.2-51.2c-1.9-20.8 3.8-43.9 16.6-64.9c12.8-21 30.9-37 50.5-45.6zm204.2 29.3c-13.2-5.8-24.6-5.5-32.7-1.1c-7.9 4.3-13.5 13-14.7 26c-1.2 13.1 2.4 29.4 12.1 45.3c9.7 15.9 23 27.2 36.1 33c13.2 5.8 24.6 5.5 32.7 1.1c7.9-4.3 13.5-13 14.7-26c1.2-13.1-2.4-29.4-12.1-45.3c-9.7-15.9-23-27.2-36.1-33zm12.9-29.3c19.5 8.6 37.7 24.6 50.5 45.6c12.8 21 18.5 44.1 16.6 64.9c-1.9 20.9-11.8 40.6-31.2 51.2c-19.2 10.5-41.5 8.7-61 .1c-19.5-8.6-37.7-24.6-50.5-45.6c-12.8-21-18.5-44.1-16.6-64.9c1.9-20.9 11.8-40.6 31.2-51.2c19.2-10.5 41.5-8.7 61-.1zM352 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM113.6 317.8l0 0c29.4 24.5 52.9 60.4 69 97.8c13.7 31.8 22.5 65.7 24.8 96.4H65.8c-2.8-41.8-18-83.5-40-116.9c-6.6-9.9-9.8-21.2-9.8-32.3c0-19.2 9.5-38 26.9-49.2l0 0c22.5-14.5 51.3-12 70.8 4.2zm500.6 77.3c-22.1 33.4-37.2 75.1-40 116.9H432.6c2.3-30.7 11.1-64.6 24.8-96.4c16.1-37.4 39.6-73.2 69-97.8l0 0c19.5-16.2 48.3-18.8 70.8-4.2l0 0c18.2 11.8 27.7 31.8 26.8 52c-.5 10.2-3.7 20.5-9.7 29.6zM48 362.8c0 5 1.4 10.1 4.4 14.6l0 0C77.7 415.6 95 463.4 97.9 512l77.4 0c-2.3-26-9.9-55.5-22.1-83.8c-14.8-34.3-35.6-65.4-60-85.8c-9.1-7.5-22.5-8.7-32.9-2l0 0c-8 5.2-12.2 13.7-12.2 22.4zM592 364c.4-9.1-3.9-18.2-12.2-23.6l0 0c-10.4-6.7-23.9-5.6-32.9 2c-24.4 20.4-45.3 51.5-60.1 85.8C474.7 456.5 467 486 464.7 512l77.4 0c2.9-48.6 20.2-96.4 45.4-134.6l0 0c2.8-4.2 4.2-8.8 4.4-13.4z"]
};
var faSquareM = {
  prefix: 'fal',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm125.1 38.8L224 276.1l98.9-141.3c4-5.7 11.3-8.2 17.9-6.1s11.2 8.3 11.2 15.3V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V194.8L237.1 313.2c-3 4.3-7.9 6.8-13.1 6.8s-10.1-2.5-13.1-6.8L128 194.8V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1z"]
};
var faCameraWeb = {
  prefix: 'fal',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM357.5 403.9C412.4 363 448 297.7 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 73.7 35.6 139 90.5 179.9L37 473.4c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4H392c9.1 0 17.5-5.2 21.5-13.4s3.1-18-2.5-25.2l-53.5-69.5zm-27.1 17.3L375.8 480H72.2l45.3-58.9C149.2 438.3 185.5 448 224 448s74.8-9.7 106.5-26.9zM224 112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faWebcam = faCameraWeb;
var faCommentArrowDown = {
  prefix: 'fal',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 281.4V144z"]
};
var faLightbulbCfl = {
  prefix: 'fal',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M176 57.7C176 22 142.5-4.1 107.9 4.5L41.5 21.1C17.1 27.2 0 49.2 0 74.3c0 16 6.8 30.1 17.3 40C6.6 124.4 0 138.7 0 154.3c0 16 6.8 30.1 17.3 40C6.6 204.4 0 218.7 0 234.3c0 35.7 33.5 61.8 68.1 53.2l63.7-15.9 .1 0 64-16 0 0 63.8-15.9c14.4-3.6 28.3 7.3 28.3 22.1c0 10.5-7.1 19.6-17.3 22.1l-82.6 20.7C181 306.3 176 312.7 176 320v32H144V309.5l-32 8V352H96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H208V332.5l70.5-17.6c24.4-6.1 41.5-28 41.5-53.2c0-16-6.8-30.1-17.3-40c10.8-10.1 17.3-24.4 17.3-40c0-16-6.8-30.1-17.3-40c10.8-10.1 17.3-24.4 17.3-40c0-35.7-33.5-61.8-68.1-53.2L175.1 67.7c.6-3.3 .9-6.6 .9-10zM96 384h95.9l.1 0 .1 0H224v64H96V384zM270.7 203.8L124.1 240.5 60.3 256.4C45.9 260 32 249.1 32 234.3c0-10.5 7.1-19.6 17.3-22.1l18.6-4.6 .2-.1 191.7-47.9c14.3-3.5 28.2 7.4 28.2 22.2c0 10.5-7.1 19.6-17.3 22.1zm-136.2-93L259.7 79.6C274.1 76 288 86.9 288 101.7c0 10.5-7.1 19.6-17.3 22.1l-18.6 4.6-.2 .1L60.2 176.5C45.8 179.9 32 169.1 32 154.3c0-10.5 7.1-19.6 17.3-22.1L68 127.5l.1 0 66.4-16.6 .1 0zm-7.8-31l0 0L60.3 96.4l0 0C45.9 100 32 89.1 32 74.3c0-10.5 7.1-19.6 17.3-22.1l66.4-16.6C130.1 32 144 42.9 144 57.7c0 10.4-7.1 19.6-17.2 22.1z"]
};
var faWindowFrameOpen = {
  prefix: 'fal',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", "M272 32H416c17.7 0 32 14.3 32 32V256H272V32zM480 288V256 64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V256v32H64 448h32zM240 256H64V64c0-17.7 14.3-32 32-32H240V256zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V320H448V480H64V320H32V480H16z"]
};
var faFaceKiss = {
  prefix: 'fal',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm277.4 39.1c-11-5.4-25.7-9.3-39.1-11.2c-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-1.1 .5-2.1 1-3.3 1.5c1.1 .5 2.2 1 3.3 1.5c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-13.9 6.8-31.2 11.3-46.3 13.4c-6.6 .9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8c-10.9-5.4-25.5-9.3-38.8-11.2c-.9-.1-1.8-.3-2.7-.6c-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8 .7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6c13.3-1.9 27.9-5.8 38.8-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faKiss = faFaceKiss;
var faBridgeCircleXmark = {
  prefix: 'fal',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", "M48 32h80H256 384 512h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H528v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H512 384 256 128 48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM48 240H64c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPeriod = {
  prefix: 'fal',
  iconName: 'period',
  icon: [128, 512, [], "2e", "M64 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faFaceGrinTongue = {
  prefix: 'fal',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm144.4-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM352 416V383.4c20.2-15.7 36.4-36.2 46.9-59.9c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c10.4 23.6 26.6 44.1 46.8 59.8V416c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"]
};
var faGrinTongue = faFaceGrinTongue;
var faUpToDottedLine = {
  prefix: 'fal',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", "M222.2 160.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 292.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7L288 304c-8.8 0-16 7.2-16 16l0 120c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-120c0-8.8-7.2-16-16-16l-57.3 0c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 160.8zM224 128c-9.5 0-18.6 3.9-25.1 10.8L74.5 270.8C67.8 278 64 287.5 64 297.3c0 21.4 17.3 38.7 38.7 38.7l41.3 0 0 104c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-104 41.3 0c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 138.8c-6.5-6.9-15.6-10.8-25.1-10.8zM416 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM296 60a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM224 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM104 60a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faThoughtBubble = {
  prefix: 'fal',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M256 0c-50.7 0-94.4 29.4-115.2 72.1c-1.6-.1-3.2-.1-4.8-.1C60.9 72 0 132.9 0 208s60.9 136 136 136c10.8 0 21.2-1.3 31.3-3.6C187.8 366.9 219.9 384 256 384s68.2-17.1 88.7-43.6c10.1 2.4 20.5 3.6 31.3 3.6c75.1 0 136-60.9 136-136s-60.9-136-136-136c-1.6 0-3.2 0-4.8 .1C350.4 29.4 306.7 0 256 0zM166 94.5C179.6 58 214.8 32 256 32s76.4 26 90 62.5c2.6 7 9.6 11.2 17 10.3c4.3-.5 8.6-.8 13-.8c57.4 0 104 46.6 104 104s-46.6 104-104 104c-11.5 0-22.6-1.9-32.9-5.3c-7.1-2.4-14.8 .5-18.7 6.9C310.3 336.6 284.9 352 256 352s-54.3-15.4-68.4-38.5c-3.9-6.4-11.6-9.2-18.7-6.9c-10.3 3.4-21.4 5.3-32.9 5.3C78.6 312 32 265.4 32 208s46.6-104 104-104c4.4 0 8.8 .3 13 .8c7.4 .9 14.4-3.3 17-10.3zM144 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 0A32 32 0 1 0 0 480a32 32 0 1 0 64 0z"]
};
var faSkeletonRibs = {
  prefix: 'fal',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H254.1c-29.3 0-56.6 16-69.7 42.9c-14.9 30.8-36.9 79.1-55.2 132C111 291.5 96 349.8 96 400v11.2c0 38 30.8 68.8 68.8 68.8c9.6 0 19.1-2 27.9-5.9l81.8-36.3c9.5-4.2 19.4-7 29.5-8.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V429.2c10.1 1.5 20 4.3 29.5 8.5l81.8 36.3c8.8 3.9 18.3 5.9 27.9 5.9c38 0 68.8-30.8 68.8-68.8V400c0-50.2-15-108.5-33.2-161.1c-18.3-52.8-40.3-101.2-55.2-132C442.5 80 415.2 64 385.9 64H336V16zM304 96v82.9L176.2 204.4c13.3-33.2 26.8-62.5 37-83.5c7.4-15.3 23.2-24.9 40.9-24.9H304zM162.8 239.7l.3-.1L304 211.5V284L135.8 333.1c5.7-27.4 14.1-55.9 23.7-83.7c1.1-3.2 2.3-6.5 3.4-9.7zM130 367.9c.8-.1 1.6-.3 2.4-.5l171.5-50V397c-14.5 1.6-28.9 5.5-42.5 11.5l-81.8 36.3c-4.7 2.1-9.8 3.2-14.9 3.2c-20.3 0-36.8-16.5-36.8-36.8V400c0-10.3 .7-21 2-32.1zM336 397V317.3l171.5 50c.8 .2 1.6 .4 2.5 .5c1.3 11.1 2 21.9 2 32.1v11.2c0 20.3-16.5 36.8-36.8 36.8c-5.1 0-10.2-1.1-14.9-3.2l-81.8-36.3c-13.6-6.1-28-9.9-42.5-11.5zm168.2-63.9L336 284V211.5l140.9 28.2 .3 .1c1.1 3.2 2.3 6.4 3.4 9.7c9.6 27.7 18 56.2 23.7 83.7zM463.8 204.4L336 178.9V96h49.9c17.7 0 33.5 9.6 40.9 24.9c10.2 21 23.7 50.3 37 83.5zM0 128V240 496c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.6 4.9-16.6 12.6-20.4l44.5-22.2c23.8-11.9 38.9-36.3 38.9-63V128c0-35.3-28.7-64-64-64S0 92.7 0 128zm32 62.1V128c0-17.7 14.3-32 32-32s32 14.3 32 32v6.4c0 14.5-8.2 27.8-21.2 34.3L32 190.1zM576 64c-35.3 0-64 28.7-64 64v6.4c0 26.7 15.1 51 38.9 63l44.5 22.2c7.7 3.9 12.6 11.8 12.6 20.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V240 128c0-35.3-28.7-64-64-64zM565.2 168.7c-13-6.5-21.2-19.8-21.2-34.3V128c0-17.7 14.3-32 32-32s32 14.3 32 32v62.1l-42.8-21.4z"]
};
var faRaygun = {
  prefix: 'fal',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M39.3 2.6c4.5-3 10.3-3.4 15.2-1.2L195.4 64H272c18 0 34.6 6 48 16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v96 16h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h32c0-6.1 3.4-11.6 8.8-14.3l96-48c5-2.5 10.9-2.2 15.6 .7s7.6 8.1 7.6 13.6V240c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-96-48c-5.4-2.7-8.8-8.3-8.8-14.3H416v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H352v16 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c-12.4 9.3-27.6 15.1-44.2 15.9l0 .1L172.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9l69-137.9C46.1 283.8 0 235.3 0 176c0-30.5 12.2-58.2 32-78.4V16c0-5.4 2.7-10.5 7.3-13.4zM480 176v6.1l64 32V137.9l-64 32V176zM192.3 96c-.2 0-.5 0-.7 0H112c-44.2 0-80 35.8-80 80s35.8 80 80 80h8.2H256h16c26.5 0 48-21.5 48-48V176 144c0-26.5-21.5-48-48-48H192.3zM64 40.6V74.8C78.5 67.9 94.8 64 112 64h4.6L64 40.6zM140 288L64 440l80 40 96-192H140zM112 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFlute = {
  prefix: 'fal',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", "M160 320H576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H160V320zm-32 0V192H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64zM64 160h64 16 16H576c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H160 144 128 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAcorn = {
  prefix: 'fal',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M267.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-3.9 3.9C225.5 23.9 215.1 43.2 210.5 64H96C43 64 0 107 0 160v16c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-53-43-96-96-96H243.6c3.8-12.3 10.6-23.6 19.8-32.8l3.9-3.9zM352 96c35.3 0 64 28.7 64 64v16H32V160c0-35.3 28.7-64 64-64H352zM48.4 240c4.1 78.1 39 189.3 165.5 236.4c6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240h-32c-4 70.6-35.5 165.2-143.5 206C116 405.2 84.4 310.6 80.5 240h-32z"]
};
var faVideoArrowUpRight = {
  prefix: 'fal',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V336.8 175.2 128c0-35.3-28.7-64-64-64H64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2V377.8c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9v36.5zM160 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h73.4L100.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 214.6V288c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H160z"]
};
var faGrateDroplet = {
  prefix: 'fal',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", "M64 64H384c17.7 0 32 14.3 32 32v88.9c7.8-11.1 19.1-19.1 32-22.7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H344.2c-6.6-9.9-12-20.6-16.1-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm320 64c0-17.7-14.3-32-32-32H296 224 152 96c-17.7 0-32 14.3-32 32V256 384c0 17.7 14.3 32 32 32h56 72 72 24.9c-.6-5.3-.9-10.6-.9-16c0-5.4 .3-10.7 .9-16H312V272h40v32l32-60V128zM96 128h40V240H96V128zm72 112V128h40V240H168zm72 0V128h40V240H240zm72 0V128h40V240H312zm-32 32V384H240V272h40zm-72 0V384H168V272h40zm-72 0V384H96V272h40zm257.4 90.4L464 230l70.6 132.4c6.2 11.6 9.4 24.5 9.4 37.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-13.1 3.2-26.1 9.4-37.6zm-28.2-15.1C356.5 363.5 352 381.6 352 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7L487.5 206.1c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1L365.2 347.3z"]
};
var faSealExclamation = {
  prefix: 'fal',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M176 96c8.5 0 16.6-3.4 22.6-9.4l46.1-46.1c6.2-6.2 16.4-6.2 22.6 0l46.1 46.1c6 6 14.1 9.4 22.6 9.4h64c8.8 0 16 7.2 16 16v64c0 8.5 3.4 16.6 9.4 22.6L471 244.2c6.2 6.2 6.2 16.4 0 22.6l-45.6 45.6c-6 6-9.4 14.1-9.4 22.6V400c0 8.8-7.2 16-16 16H335.1c-8.5 0-16.6 3.4-22.6 9.4l-45.1 45.1c-6.2 6.2-16.4 6.2-22.6 0l-45.1-45.1c-6-6-14.1-9.4-22.6-9.4H112c-8.8 0-16-7.2-16-16V335.1c0-8.5-3.4-16.6-9.4-22.6L41 266.8 18.4 289.5 41 266.8c-6.2-6.2-6.2-16.4 0-22.6l45.6-45.6c6-6 9.4-14.1 9.4-22.6V112c0-8.8 7.2-16 16-16h64zM18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448H400c26.5 0 48-21.5 48-48V335.1l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176V112c0-26.5-21.5-48-48-48H336L289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64H112c-26.5 0-48 21.5-48 48v64L18.4 221.6zM240 144V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm40 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faChessBishop = {
  prefix: 'fal',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M104 0C95.2 0 88 7.2 88 16s7.2 16 16 16h11.6C103.6 42.9 89.8 56.7 75.9 72.8C39 115.7 0 177.6 0 248.7c0 53.2 37.2 80 64 92.3V352H96V330.4c0-6.7-4.1-12.7-10.4-15C62.5 306.8 32 288.1 32 248.7c0-59.7 33-114.3 68.1-155c17.4-20.2 34.7-36.4 47.8-47.6c4.7-4 8.8-7.3 12.1-10c3.3 2.6 7.4 6 12.1 10c13.1 11.2 30.4 27.5 47.8 47.6c7.2 8.4 14.3 17.3 21.1 26.7l-76.2 76.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L258.6 148c17.3 30.4 29.4 64.6 29.4 100.7c0 39.4-30.5 58-53.6 66.7c-6.3 2.3-10.4 8.3-10.4 15V352h32V341.1c26.8-12.3 64-39.1 64-92.3c0-71.2-39-133-75.9-175.9C230.2 56.7 216.4 42.9 204.4 32H216c8.8 0 16-7.2 16-16s-7.2-16-16-16H160 104zM254.2 416l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L65.8 416l188.4 0zm0-32H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H280.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faMessageSms = {
  prefix: 'fal',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM202.9 144.8C196.4 147 192 153.1 192 160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm-90.9 38c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C88.6 157.3 80 167.8 80 183c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0 0 0 0 0c-1.3-.4-2.6-.9-4-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4zm256 0c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.3 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0 0 0 0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2 .4 2.6 .9 4 1.4l0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4z"]
};
var faCoffeeBeans = {
  prefix: 'fal',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", "M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-22.6-22.6c-33 33-103.4 32.3-158.4-22.6c-40.6-40.6-51.6-89.6-41.3-125.8c3.9 6.2 8 12 12.3 17.1c27.7 32.7 61.1 44.7 90.6 55.2l1 .3c30.1 10.8 56.2 20.4 78.2 46.3c6.4 7.5 12.6 17.8 18.4 28.7l-.7 .7zm6.3-49.7c-27.7-32.7-61.1-44.7-90.6-55.2l-1-.3c-30.1-10.8-56.2-20.4-78.2-46.3c-6.4-7.5-12.6-17.8-18.4-28.7l.7-.7c33-33 103.4-32.3 158.4 22.6c40.6 40.6 51.6 89.6 41.3 125.8c-3.9-6.2-8-12-12.3-17.1zM128 480c-46.7 0-96-50.3-96-128c0-57.4 26.9-99.8 59.8-118.1c-1.6 7.1-2.8 14.2-3.4 20.8c-3.6 42.7 11.6 74.8 25 103.1l.4 .9c13.7 28.9 25.4 54.2 22.5 88c-.8 9.8-3.6 21.5-7.3 33.3l-1 0zm39.6-30.7c3.6-42.7-11.6-74.8-25-103.1l-.4-.9c-13.7-28.9-25.4-54.2-22.5-88c.8-9.8 3.6-21.5 7.3-33.3l1 0c46.7 0 96 50.3 96 128c0 57.4-26.9 99.8-59.8 118.1c1.6-7.1 2.8-14.2 3.4-20.8zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z"]
};
var faHatWitch = {
  prefix: 'fal',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", "M96 384h34.9l80.9-185c13.8-31.5 37.3-57.7 67.2-74.8L436.8 34.1c2.4-1.4 5.2-2.1 7.9-2.1h1.5c3.8 0 7.5 1.4 10.4 3.9l82.5 70.7c3.1 2.7 4.9 6.5 4.9 10.6c0 2.2-.5 4.3-1.5 6.3L516.7 175l-1.1-4.3C509.4 145.6 486.9 128 461 128c-18.8 0-36.4 9.4-46.9 25.1l-14.3 21.5c-10.3 15.5-15.8 33.6-15.8 52.2c0 13.2 2.8 26.2 8.1 38.2L445 384h35L421.4 252c-3.5-7.9-5.4-16.5-5.4-25.2c0-12.3 3.6-24.3 10.4-34.5l14.3-21.5c4.5-6.8 12.1-10.8 20.2-10.8c11.2 0 20.9 7.6 23.6 18.4l7.1 28.3c2.5 10.2 11.7 17.3 22.2 17.3c8.7 0 16.6-4.9 20.5-12.6l36.8-73.6c3.2-6.4 4.9-13.4 4.9-20.6c0-13.4-5.9-26.2-16.1-34.9L477.5 11.6C468.8 4.1 457.7 0 446.2 0h-1.5c-8.4 0-16.6 2.2-23.8 6.3L263.2 96.5c-35.8 20.5-64.1 51.9-80.6 89.7L96 384zM52.8 448H523.2c-24.5 15.2-61.9 32-107.2 32H160c-45.3 0-82.7-16.8-107.2-32zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512H416c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6H22.6zM304 352c8.8 0 16 7.2 16 16v16h32V368c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48v16h32V368c0-8.8 7.2-16 16-16h32z"]
};
var faFaceGrinWink = {
  prefix: 'fal',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faGrinWink = faFaceGrinWink;
var faClockThreeThirty = {
  prefix: 'fal',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V256c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H272V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faEarDeaf = {
  prefix: 'fal',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M507.3 27.3l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-320 320l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM240 96C160.5 96 96 160.5 96 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176s176 78.8 176 176c0 51.3-21.9 97.4-56.9 129.6c-4.8 4.4-7.1 9.7-7.1 14.4c0 70.7-57.3 128-128 128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c53 0 96-43 96-96c0-15.4 7.4-28.7 17.5-38c28.6-26.3 46.5-64.1 46.5-106c0-79.5-64.5-144-144-144zm0 64c-44.2 0-80 35.8-80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112s112 50.1 112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80z"]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faAlarmClock = {
  prefix: 'fal',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V304c0 5 2.4 9.8 6.4 12.8l64 48c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4L272 296V176z"]
};
var faEclipse = {
  prefix: 'fal',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.6-52.2c-10.3-4.5-20.2-9.9-29.6-15.9l-7 38-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 7 38.1c9.4-6.1 19.3-11.4 29.6-15.9l-9.6-52.2zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2c-6.5-9-12.3-18.4-17.3-28.4c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96c7.6 0 15 .9 22.1 2.6c5-9.9 10.8-19.4 17.3-28.4c-12.4-4-25.7-6.2-39.4-6.2zm64 128a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm320 0a176 176 0 1 0 -352 0 176 176 0 1 0 352 0z"]
};
var faFaceRelieved = {
  prefix: 'fal',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm187.3 92.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 389.2 298.9 408 256 408s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm82.4-131.5c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.8 20.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"]
};
var faRoadCircleCheck = {
  prefix: 'fal',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M157.5 74c9.2-25.2 33.2-42 60.1-42H422.4c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H217.6c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43H339.2c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faDiceFive = {
  prefix: 'fal',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm216 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faOctagonMinus = {
  prefix: 'fal',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMinusOctagon = faOctagonMinus;
var faSquareRss = {
  prefix: 'fal',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240c0 8.8 7.2 16 16 16s16-7.2 16-16c0-150.2-121.8-272-272-272zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176z"]
};
var faRssSquare = faSquareRss;
var faFaceZany = {
  prefix: 'fal',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm272-64c-26.5 0-48-21.5-48-48c0-3.9 .5-7.7 1.4-11.4C261 143.9 271.5 152 284 152c15.5 0 28-12.5 28-28c0-12.5-8.1-23-19.4-26.6c3.6-.9 7.5-1.4 11.4-1.4c26.5 0 48 21.5 48 48s-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM144 184a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm24-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-4.5 166.7c-2.3 6.2-3.5 12.9-3.5 19.9V416c0 53 43 96 96 96s96-43 96-96v-5.4c0-2.3-.1-4.6-.4-6.9c57.3-37.6 82-108 64.4-173.2c-3.7-13.7-19.6-18.7-31.8-11.6L159.8 348.5c-12.3 7.1-15.8 23.4-5.8 33.4c3.1 3.1 6.2 6 9.5 8.8zm175.4-17c-10.8-13.2-27.1-21.6-45.5-21.6h-2c-13.3 0-25.6 4.6-35.4 12.5c-9.7-7.9-22.1-12.5-35.4-12.5h-2c-.3 0-.6 0-.9 0l170.5-98.4c6.9 46-11.6 92.6-49.3 120.1zM291.4 384h2c14.7 0 26.6 11.9 26.6 26.6V416c0 35.3-28.7 64-64 64s-64-28.7-64-64v-5.4c0-14.7 11.9-26.6 26.6-26.6h2c6.7 0 12.8 2.7 17.2 7.2l.2 .3c1.6 1.7 3 3.6 4.1 5.8c.9 1.8 1.6 3.7 2 5.7c2.8 12.6 20.8 12.6 23.6 0c.4-2 1.1-3.9 2-5.7c1.1-2.1 2.5-4.1 4.1-5.8l.2-.3c4.4-4.5 10.6-7.2 17.2-7.2z"]
};
var faTricycle = {
  prefix: 'fal',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M272 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3C372.1 64 384 75.9 384 90.7c0 8.4-4 16.3-10.7 21.3l-42.7 32H303.4c-58.4 0-113.2 24.5-152.1 66.1L117.9 160H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H79.4l51 76.5c-2.7 4-5.2 8.1-7.6 12.3l-4.2 7.4c-2.2-.1-4.4-.2-6.6-.2C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-48-30.1-88.9-72.5-104.8C183 209.2 240.8 176 303.4 176h20.1l14.2 56.6C289.9 251.2 256 297.6 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-5.2 0-10.3 .3-15.3 .9l-14.6-58.5 38.4-28.8c14.8-11.1 23.5-28.5 23.5-46.9C416 58.3 389.7 32 357.3 32H272zm73.5 232l23 91.9c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-23-91.8c2.5-.2 4.9-.3 7.4-.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-39.3 23.7-73.1 57.5-88zM112 288a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faLandMineOn = {
  prefix: 'fal',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", "M320 0c-8.8 0-16 7.2-16 16V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM192 400h32H416h32 0 32.8c6.3 0 12.1 3.7 14.6 9.5L526.8 480H113.2l31.3-70.5c2.6-5.8 8.3-9.5 14.6-9.5H192h0zm32-32V336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32H224zm224 0V336c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v32H160h-.8c-19 0-36.2 11.2-43.9 28.5L84 467c-9.4 21.2 6.1 45 29.2 45H526.8c23.2 0 38.6-23.8 29.2-45l-31.3-70.5C517 379.2 499.8 368 480.8 368H480 448h0zM57.6 131.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4l128 96c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-128-96zm547.2 3.2c-5.3-7.1-15.3-8.5-22.4-3.2l-128 96c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l128-96c7.1-5.3 8.5-15.3 3.2-22.4z"]
};
var faSquareArrowUpLeft = {
  prefix: 'fal',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm280 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H182.6L315.3 324.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16H280z"]
};
var faICursor = {
  prefix: 'fal',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M0 14.9C-.6 23.7 6 31.3 14.9 32l8 .6C73.1 36.1 112 77.9 112 128.3V240H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h48V383.7c0 50.4-38.9 92.2-89.2 95.8l-8 .6C6 480.7-.6 488.3 0 497.1S8.3 512.6 17.1 512l8-.6c44.6-3.2 82.5-29 102.9-65.7c20.4 36.7 58.3 62.5 102.9 65.7l8 .6c8.8 .6 16.5-6 17.1-14.8s-6-16.5-14.8-17.1l-8-.6c-50.2-3.6-89.2-45.4-89.2-95.8V272h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V128.3c0-50.4 38.9-92.2 89.2-95.8l8-.6c8.8-.6 15.4-8.3 14.8-17.1S247.7-.6 238.9 0l-8 .6c-44.6 3.2-82.5 29-102.9 65.7C107.6 29.6 69.7 3.8 25.1 .6l-8-.6C8.3-.6 .7 6 0 14.9z"]
};
var faChartMixedUpCircleDollar = {
  prefix: 'fal',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", "M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h72.2l-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5L191.7 100 326.2 204.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H416zM192 448c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16zm0-224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM408.1 339c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1z"]
};
var faSaltShaker = {
  prefix: 'fal',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M352 453.2c0-1.6-.1-3.2-.4-4.7L305.8 192H78.2L32.4 448.5c-.3 1.6-.4 3.1-.4 4.7C32 468 44 480 58.8 480H325.2c14.8 0 26.8-12 26.8-26.8zM300.1 160l-7.9-44.1C283.5 67.3 241.3 32 192 32s-91.5 35.3-100.2 83.9L83.9 160H300.1zm25.1 352H58.8C26.3 512 0 485.7 0 453.2c0-3.5 .3-6.9 .9-10.3L60.3 110.3C71.7 46.5 127.2 0 192 0s120.3 46.5 131.7 110.3l59.4 332.6c.6 3.4 .9 6.9 .9 10.3c0 32.5-26.3 58.8-58.8 58.8zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM151.9 242l-24 192c-1.1 8.8-9.1 15-17.9 13.9s-15-9.1-13.9-17.9l24-192c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9zm112-4l24 192c1.1 8.8-5.1 16.8-13.9 17.9s-16.8-5.1-17.9-13.9l-24-192c-1.1-8.8 5.1-16.8 13.9-17.9s16.8 5.1 17.9 13.9z"]
};
var faStamp = {
  prefix: 'fal',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M310.4 129.8c6.1-9.8 9.6-21.3 9.6-33.8c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 12.5 3.5 24 9.6 33.8c9.5 15.2 22.4 37.9 22.4 65.1c0 51.4-41.7 93.1-93.1 93.1H112c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H381.1c-51.4 0-93.1-41.7-93.1-93.1c0-27.1 12.9-49.9 22.4-65.1zm27.2 16.9c-9.2 14.8-17.5 30.8-17.5 48.2c0 33.8 27.4 61.1 61.1 61.1H400c61.9 0 112 50.1 112 112c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48c0-61.9 50.1-112 112-112h18.9c33.8 0 61.1-27.4 61.1-61.1c0-17.4-8.3-33.4-17.5-48.2C165.3 132 160 114.6 160 96c0-53 43-96 96-96s96 43 96 96c0 18.6-5.3 36-14.5 50.7zM64 456v8c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-8c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFilePlus = {
  prefix: 'fal',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM176 416c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64z"]
};
var faDrawSquare = {
  prefix: 'fal',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", "M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96c29.8 0 54.9 20.4 62 48H322c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64c0 29.8-20.4 54.9-48 62V354c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64c-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V158C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32zm62 368H322c5.8-22.5 23.5-40.2 46-46V158c-22.5-5.8-40.2-23.5-46-46H126c-5.8 22.5-23.5 40.2-46 46V354c22.5 5.8 40.2 23.5 46 46zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faToiletPaperUnderSlash = {
  prefix: 'fal',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", "M500.4 480H240c-8.8 0-16-7.2-16-16V416H192v48c0 26.5 21.5 48 48 48H528c3.9 0 7.7-.5 11.3-1.3L500.4 480zM544 327.6v23.7l32 25.3V192c0-50.8-11.2-97.5-30.1-132.1C527.4 25.9 499.1 0 464 0H176c-19.3 0-36.5 7.8-51.1 20.4l25.8 20.4c8.5-6 17.1-8.8 25.3-8.8H401.3c-7.2 8.2-13.6 17.7-19.2 27.9C363.2 94.5 352 141.2 352 192c0 2.6 0 5.2 .1 7.8l33.9 26.7c-1.3-11.1-1.9-22.6-1.9-34.5c0-46.5 10.3-87.7 26.2-116.8C426.4 45.5 446.1 32 464 32s37.6 13.5 53.8 43.2C533.7 104.3 544 145.5 544 192s-10.3 87.7-26.2 116.8c-3 5.4-6 10.3-9.2 14.6l25.1 19.8c3.7-4.9 7.1-10.2 10.2-15.7zM64 192c0 50.8 11.2 97.5 30.1 132.1c18.6 34 46.8 59.9 81.9 59.9H378.8l-40.5-32H176c-17.9 0-37.6-13.5-53.8-43.2C106.3 279.7 96 238.5 96 192c0-10.3 .5-20.4 1.5-30.1L68.2 138.8c-2.8 17-4.2 34.8-4.2 53.2zm400 48c-6.4 0-11.9-11.3-14.5-27.6c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6zm0 32c16.2 0 26.6-9.9 31.4-16c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
var faStairs = {
  prefix: 'fal',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M416 48c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H448V176c0 8.8-7.2 16-16 16H304V336c0 8.8-7.2 16-16 16H160V464c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128V336c0-8.8 7.2-16 16-16H272V176c0-8.8 7.2-16 16-16H416V48z"]
};
var faDroneFront = {
  prefix: 'fal',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M144 96c8.8 0 16 7.2 16 16v16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128V112c0-8.8 7.2-16 16-16zm352 0c8.8 0 16 7.2 16 16v16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H480V112c0-8.8 7.2-16 16-16zM128 256V192h32v55.1l12.6 7.9 50.6-33.7C251.9 202.2 285.5 192 320 192s68.1 10.2 96.8 29.3L467.4 255l12.6-7.9V192h32v64c0 5.5-2.8 10.6-7.5 13.6l-58.1 36.3 7.7 9.2c16.8 20.1 26 45.5 26 71.7V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V386.8c0-18.7-6.6-36.8-18.5-51.2L419 323l-42.5 26.6c-2.5 1.6-5.5 2.4-8.5 2.4H272c-3 0-5.9-.8-8.5-2.4L221 323l-10.5 12.6c-12 14.4-18.5 32.5-18.5 51.2V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V386.8c0-26.2 9.2-51.6 26-71.7l7.7-9.2-58.1-36.3c-4.7-2.9-7.5-8.1-7.5-13.6zm309.6 17.6l-38.5-25.7C375.7 232.3 348.1 224 320 224s-55.6 8.3-79.1 23.9l-38.5 25.7L276.6 320h86.8l74.2-46.4z"]
};
var faDroneAlt = faDroneFront;
var faGlassEmpty = {
  prefix: 'fal',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M40.1 32c-4.7 0-8.4 4-8 8.7l34.6 410C68.1 467.3 81.9 480 98.6 480H285.4c16.6 0 30.5-12.7 31.9-29.3l34.6-410c.4-4.7-3.3-8.7-8-8.7H40.1zM.2 43.4C-1.7 20 16.7 0 40.1 0H343.8c23.4 0 41.8 20 39.9 43.4l-34.6 410c-2.8 33.1-30.5 58.6-63.8 58.6H98.6c-33.3 0-61-25.5-63.8-58.6L.2 43.4z"]
};
var faDialHigh = {
  prefix: 'fal',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 248H415c-7.9 63.1-61.7 112-127 112c-70.7 0-128-57.3-128-128s57.3-128 128-128c65.3 0 119.1 48.9 127 112H288c-8.8 0-16 7.2-16 16s7.2 16 16 16zm160-16a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm120 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUserHelmetSafety = {
  prefix: 'fal',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M176 60.8c-28.7 16.6-48 47.6-48 83.2H320c0-35.5-19.3-66.6-48-83.2V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V32H208V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V60.8zM271.2 25C318.5 43.8 352 90 352 144l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c0-54 33.5-100.2 80.8-119C180 10.7 192.7 0 208 0h32c15.3 0 28 10.7 31.2 25zM224 320c-65.3 0-119.1-48.9-127-112h32.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H351c-7.9 63.1-61.7 112-127 112zM415.8 480c-3.3-53.6-47.8-96-102.2-96H134.4C80 384 35.5 426.4 32.2 480H415.8zM0 486.4C0 412.2 60.2 352 134.4 352H224h89.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"]
};
var faUserConstruction = faUserHelmetSafety;
var faUserHardHat = faUserHelmetSafety;
var faI = {
  prefix: 'fal',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H144V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V64H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H160 16z"]
};
var faHryvniaSign = {
  prefix: 'fal',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M99.7 86.1C121.3 71.7 146.7 64 172.6 64H231c40.3 0 73 32.7 73 73c0 21.4-9.3 41.3-25 55H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H220.2L106 281.1c-4.1 2.1-8.1 4.4-11.8 6.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H63.6C53.6 336.2 48 355.2 48 375c0 58 47 105 105 105h58.4c32.3 0 63.8-9.5 90.6-27.4l10.9-7.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-10.9 7.2c-21.6 14.4-46.9 22.1-72.9 22.1H153c-40.3 0-73-32.7-73-73c0-21.4 9.3-41.3 25-55H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H163.8L278 230.9c4.1-2.1 8.1-4.4 11.8-6.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H320.4c10-16.2 15.6-35.2 15.6-55c0-58-47-105-105-105H172.6c-32.3 0-63.8 9.5-90.6 27.4L71.1 66.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l10.9-7.2z"]
};
var faHryvnia = faHryvniaSign;
var faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fal',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 169.4 320 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-105.4 0L507.3 27.3zM4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 342.6 192 448c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16s7.2 16 16 16H169.4L4.7 484.7z"]
};
var faPills = {
  prefix: 'fal',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 64c44.2 0 80 35.8 80 80V256H32V144c0-44.2 35.8-80 80-80zM32 368V288H192v80c0 44.2-35.8 80-80 80s-80-35.8-80-80zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 448c-70.7 0-128-57.3-128-128c0-29.6 10-56.8 26.9-78.5L494.5 421.1C472.8 438 445.6 448 416 448zM337.5 218.9C359.2 202 386.4 192 416 192c70.7 0 128 57.3 128 128c0 29.6-10 56.8-26.9 78.5L337.5 218.9zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"]
};
var faFaceGrinWide = {
  prefix: 'fal',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faGrinAlt = faFaceGrinWide;
var faTooth = {
  prefix: 'fal',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M132 64c14.7 0 29 4.8 40.8 13.6l41.6 31.2 21.3 16c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-5.4-4 16.3-13.9c13-11.1 29.5-17.2 46.6-17.2c39.5 0 71.6 32.1 71.6 71.6v3c0 11.6-2.7 23-7.9 33.4L354 216.3c-6.2 12.3-10.5 25.5-13 39.1L307.4 443.6 279.3 331.2C272.9 305.8 250.1 288 224 288s-48.9 17.8-55.3 43.2L140.6 443.6 107 255.4c-2.4-13.6-6.8-26.7-13-39.1L71.9 172c-5.2-10.4-7.9-21.8-7.9-33.4V132c0-37.6 30.4-68 68-68zm91.3 11.5L192 52c-17.3-13-38.4-20-60-20C76.8 32 32 76.8 32 132v6.6c0 16.6 3.9 32.9 11.3 47.7l22.2 44.3c4.8 9.6 8.2 19.8 10.1 30.4l34.6 193.6c2.6 14.7 15.4 25.4 30.4 25.4c14.1 0 26.5-9.6 29.9-23.4l29.4-117.7c2.8-11.1 12.8-18.9 24.2-18.9s21.5 7.8 24.2 18.9l29.4 117.7c3.4 13.7 15.8 23.4 29.9 23.4c14.9 0 27.7-10.7 30.4-25.4L372.5 261c1.9-10.6 5.3-20.8 10.1-30.4l22.2-44.3c7.4-14.8 11.3-31.1 11.3-47.7v-3C416 78.4 369.6 32 312.4 32c-24.7 0-48.6 8.8-67.4 24.9L223.3 75.5z"]
};
var faBasketballHoop = {
  prefix: 'fal',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", "M35.1 201.9C51.5 170.8 135.3 32 320 32s268.5 138.8 284.9 169.9c2.1 4 3.1 8.4 3.1 13V331.2c0 12.6-7.4 24.1-19 29.2l-79.2 35.2-5 37.2L602 389.7c23.1-10.3 38-33.2 38-58.5V214.9c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9V331.2c0 25.3 14.9 48.2 38 58.5l97.2 43.2-5-37.2L51 360.4c-11.6-5.1-19-16.6-19-29.2V214.9c0-4.6 .9-9 3.1-13zM192 176c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v32h32V176c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v32h32V176zm-48 64H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h18l30.1 226.1c.8 6.2 5.2 11.4 11.3 13.2s12.6-.1 16.7-4.8l48.3-55.7 56.3 56.5c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l56.3-56.5 48.3 55.7c4.1 4.8 10.6 6.7 16.7 4.8s10.4-7 11.3-13.2L494 272h18c8.8 0 16-7.2 16-16s-7.2-16-16-16H496 480.2c-.2 0-.3 0-.5 0H448 400.1c-.1 0-.1 0-.2 0H368.1c0 0-.1 0-.1 0H272.1c0 0-.1 0-.1 0H240.1c-.1 0-.1 0-.2 0H192 160.3c-.2 0-.3 0-.5 0H144zm34.3 32h54.4l1.4 1.7-48.6 53.1L178.3 272zM279 272H361l2.1 2.2-43 49.6-43-49.6L279 272zm128.3 0h54.4l-7.3 54.7-48.6-53.1 1.4-1.7zM320 473.3l-46.6-46.8L320 372.7l46.6 53.8L320 473.3zm-69.3-69.5l-48.1-48.3L255.2 298l43.6 50.3-48.1 55.5zm-21 24.2l-26.5 30.6-8.8-66.1 35.3 35.5zm159.6-24.2l-48.1-55.5L384.8 298l52.6 57.5-48.1 48.3zm21 24.2l35.3-35.5-8.8 66.1-26.5-30.6z"]
};
var faObjectsAlignBottom = {
  prefix: 'fal',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512zM176 352c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16h64zm-64 32c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0h64c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48H112zm288-32c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16h64zm-64 32c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48H336z"]
};
var faV = {
  prefix: 'fal',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M9.8 33.3c8.1-3.4 17.5 .4 21 8.5L192 422.9 353.3 41.8c3.4-8.1 12.8-11.9 21-8.5s11.9 12.8 8.5 21l-176 416c-2.5 5.9-8.3 9.8-14.7 9.8s-12.2-3.8-14.7-9.8L1.3 54.2c-3.4-8.1 .4-17.5 8.5-21z"]
};
var faSparkles = {
  prefix: 'fal',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M432 32c8.8 0 16 7.2 16 16V96h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V48c0-8.8 7.2-16 16-16zm0 288c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V336c0-8.8 7.2-16 16-16zM136.8 216.4L54.2 254.6l82.6 38.1c6.9 3.2 12.4 8.7 15.6 15.6l38.1 82.6 38.1-82.6c3.2-6.9 8.7-12.4 15.6-15.6l82.6-38.1-82.6-38.1c-6.9-3.2-12.4-8.7-15.6-15.6l-38.1-82.6-38.1 82.6c-3.2 6.9-8.7 12.4-15.6 15.6zM123.4 321.8L9.3 269.1C3.6 266.5 0 260.8 0 254.6s3.6-11.9 9.3-14.5l114.1-52.7L176 73.3c2.6-5.7 8.3-9.3 14.5-9.3s11.9 3.6 14.5 9.3l52.7 114.1L371.8 240c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5L257.8 321.8 205.1 435.8c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3L123.4 321.8z"]
};
var faSquid = {
  prefix: 'fal',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M245.6 4.6c3.5-3.4 8.3-5.1 13.2-4.5L391.1 15.8C419.3 9.3 450.4 4.3 484.9 1c15-1.4 27.6 11.2 26.2 26.2c-3.3 34.4-8.4 65.6-14.8 93.7L512.8 254c.6 4.9-1.1 9.8-4.6 13.3s-8.4 5.2-13.3 4.6l-57.9-7.1c-7.3 10.7-14.9 20.4-22.8 29.1c-43.9 48.9-94.7 68.2-136.9 72.9l40.1 40.1c6.1 6.1 15.9 6.3 22.2 .4l66.8-62c18.9-17.6 48.3-17 66.6 1.2l34.2 34.2c6 6 6.3 15.5 .7 21.9l-11 12.5c-30.5 34.8-84.1 36.6-116.8 3.9l-2.9-2.9-15.9 14.7c-18.9 17.6-48.3 17-66.6-1.2l-50.3-50.3-30.1 20.7 38.1 38.1c18.7 18.7 18.7 49.1 0 67.9l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c6.2-6.2 6.2-16.4 0-22.6l-42.3-42.3L153.3 442c-5.8 4-9.1 10.5-9 17.5c.2 11.4 9.5 20.5 20.8 20.5h11.7c8.8 0 16 7.2 16 16s-7.2 16-16 16H165.2c-28.9 0-52.4-23.1-52.8-52c-.3-17.7 8.3-34.4 22.9-44.4l29.5-20.3-48.1-48.1L95.9 377.4C86.2 391.6 70.2 400 53 400C24.2 400 .9 376.7 .9 347.9V336c0-8.8 7.2-16 16-16s16 7.2 16 16v11.9c0 11.1 9 20.1 20.1 20.1c6.6 0 12.8-3.3 16.6-8.7l24.1-35L51.3 281.9c-6.2-6.2-16.4-6.2-22.6 0l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c18.7-18.7 49.1-18.7 67.9 0l38.1 38.1 20.7-30.1L82.5 217.1c-18.3-18.3-18.8-47.7-1.2-66.6L96 134.6l-2.9-2.9C60.3 99 62.1 45.4 96.9 14.9L109.5 4c6.3-5.5 15.9-5.2 21.8 .7l34.2 34.2c18.3 18.3 18.8 47.7 1.2 66.6l-62 66.8c-5.9 6.3-5.7 16.1 .4 22.2l40.1 40.1c4.7-42.2 24-93 72.9-136.9c8.8-7.9 18.5-15.5 29.2-22.8L241 17.8c-.5-4.9 1.2-9.7 4.6-13.1zm31.9 52c11.7-6.2 24.4-12.1 38-17.6L275 34.3l2.5 22.4zM135.1 320.5l56.4 56.4 45.2-31.1c9.5-6.5 20.2-9.5 30.6-10.3c36.3-2.6 82.7-18 123.2-63.1c39.6-44.1 74.6-117.8 87.7-238.7C357.3 46.9 283.6 81.9 239.5 121.5C194.4 162 179 208.4 176.4 244.7c-.7 10.3-3.8 21.1-10.3 30.6l-31.1 45.2zm320.1-85.7l23.3 2.9-5.2-42c-5.6 14.1-11.7 27.1-18.1 39.1zM117.8 111.2l25.5-27.5c5.9-6.3 5.7-16.1-.4-22.2L119.3 37.9 118 39c-20.9 18.3-22 50.4-2.3 70.1l2.1 2.1zm283 283l2.1 2.1c19.6 19.6 51.8 18.6 70.1-2.3l1.1-1.3-23.6-23.6c-6.1-6.1-15.9-6.3-22.2-.4l-27.5 25.5zM208.9 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faLeafyGreen = {
  prefix: 'fal',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M233.8 27c-38-36.5-98.4-36-135.8 1.5C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1v35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6V336.9c-3.3-5-7-9.6-11.3-13.9L58.3 296.7c-4.4-4.4-6.9-10.4-6.9-16.6l0-35.7c0-21.1-8.5-39.3-14.3-51.2c-9.4-19.2-6-42.9 9.8-58.7L25.2 112.6 47 134.4c1.3-1.3 2.7-2.5 4-3.6C72.8 113.2 95.1 90.1 110.5 64c2.7-4.6 6.1-8.9 10.1-13c25.4-25.4 66.6-25.4 92.1 0l14.7-14.7L212.6 51.1c1.7 1.7 3.2 3.4 4.6 5.1c2.8-6.9 6.2-13.6 10.1-19.8c2-3.2 4.2-6.4 6.4-9.4zM68.7 507.3c6.2 6.2 16.4 6.2 22.6 0l0 0 40.6-40.6c12-12 28.3-18.7 45.3-18.7h68.4c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v68.4c0 17-6.7 33.3-18.7 45.3L68.7 484.7c-6.2 6.2-6.2 16.4 0 22.6zM182.6 416L283.3 315.3 342.6 256H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H374.6l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96L288 265.4V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4l-96 96V330.5c0-8.5 3.4-16.6 9.4-22.6l10.5-10.5c18-18 28.1-42.4 28.1-67.9v-43c0-8.5 3.4-16.6 9.4-22.6l29.1-29.1c16.4-16.4 24-37.1 29-51.5C284.1 58 308 40 336 40c2.3 0 4.6 .1 6.8 .4c31.7 3.3 68.1 2.7 101.2-5.8c6.4-1.6 13-2.5 20-2.5c44.2 0 80 35.8 80 80c0 6.9-.9 13.6-2.5 20c-8.5 33.1-9.2 69.5-5.8 101.2c.2 2.2 .4 4.5 .4 6.8c0 28-18 51.9-43.2 60.6c-14.4 4.9-35.2 12.6-51.5 29l-29.1 29.1c-6 6-14.1 9.4-22.6 9.4h-43c-25.5 0-49.9 10.1-67.9 28.1l-10.5 10.5c-6 6-14.1 9.4-22.6 9.4H182.6z"]
};
var faCircleArrowUpRight = {
  prefix: 'fal',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 160H336c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.6L187.3 347.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 192H200c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCalendars = {
  prefix: 'fal',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M208 0c8.8 0 16 7.2 16 16V64H384V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v64V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM160 96c-17.7 0-32 14.3-32 32v32H480V128c0-17.7-14.3-32-32-32H160zm320 96H128V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192zM32 208V384c0 53 43 96 96 96H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V208c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faBangladeshiTakaSign = {
  prefix: 'fal',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M50 32.1C41.2 31 33.2 37.2 32.1 46S37.2 62.8 46 63.9l7.9 1c24 3 42 23.4 42 47.6V192H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V400c0 44.2 35.8 80 80 80h32c97.2 0 176-78.8 176-176V272c0-44.2-35.8-80-80-80H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c26.5 0 48 21.5 48 48v32c0 79.5-64.5 144-144 144H176c-26.5 0-48-21.5-48-48V224h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V112.5c0-40.3-30-74.4-70.1-79.4l-7.9-1z"]
};
var faBicycle = {
  prefix: 'fal',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h38.3l50.5 96H223.5l-33.7-56.2c-2.9-4.8-8.1-7.8-13.7-7.8H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h54.9L197 178.2l-26.5 53.1c-13.3-4.7-27.6-7.2-42.5-7.2C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h65c5.9 0 11.2-3.2 14-8.3l83.4-152.9 21.2 40.3C405.6 270.2 384 308.6 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-15.8 0-31 2.9-45 8.1L368.4 44.8C364.3 36.9 356.1 32 347.2 32H304zM453.8 275.7l44.1 83.8c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-44.1-83.8c9.4-3.1 19.5-4.8 29.9-4.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-31.1 14.8-58.8 37.8-76.3zM156 260.2l-40 80.1c-6.4 12.8 2.9 27.8 17.2 27.8h89.5c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96s43-96 96-96c9.8 0 19.2 1.5 28 4.2zM153.9 336l62.7-125.3L291.7 336H153.9zm88.8-144H389L319.3 319.8 242.7 192z"]
};
var faHammerWar = {
  prefix: 'fal',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V53.2L36.7 32.4C17.7 29.5 0 44.7 0 64V256c0 19.3 17.7 34.5 36.7 31.6l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6V64c0-19.3-17.7-34.5-36.7-31.6L208 53.2V16zm0 283.1l-16-2.4-16 2.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V299.1zM32 255.8V64.2c0 0 .1-.1 .1-.1s.1-.1 .1-.1L182.5 86.6c6.3 .9 12.7 .9 19 0L351.8 64c0 0 .1 .1 .1 .1s.1 .1 .1 .1V255.8c0 0-.1 .1-.1 .1c0 0 0 0-.1 0s0 0-.1 0L201.5 233.4c-6.3-.9-12.7-.9-19 0L32.2 256c0 0-.1-.1-.1-.1s-.1-.1-.1-.1z"]
};
var faCircleD = {
  prefix: 'fal',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160H192V160h64c53 0 96 43 96 96s-43 96-96 96zM190.8 128c-17 0-30.8 13.8-30.8 30.8V353.2c0 17 13.8 30.8 30.8 30.8H256c70.7 0 128-57.3 128-128s-57.3-128-128-128H190.8z"]
};
var faSpiderBlackWidow = {
  prefix: 'fal',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M151.2 1.7c7.9 4 11.1 13.6 7.2 21.5l-46.1 92.2c-3 6-2 13.2 2.6 18L176 199.3V152c0-32.2 19-59.9 46.3-72.6c7.7-3.6 16.8-.5 20.8 6.9L256 110.3l12.9-23.9c4-7.5 13.2-10.5 20.8-6.9C317 92.1 336 119.8 336 152v47.3l61.2-65.9c4.5-4.9 5.6-12.1 2.6-18L353.7 23.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2L428.4 101c8.9 17.9 5.9 39.5-7.8 54.1l-71.1 76.5 101.6-26.7c5.2-1.4 9.4-5.3 11.1-10.4l18.5-55.6c2.8-8.4 11.9-12.9 20.2-10.1s12.9 11.9 10.1 20.2l-18.5 55.6c-5.1 15.4-17.7 27.1-33.3 31.2L382.9 256l76.5 20.1c15.7 4.1 28.2 15.9 33.3 31.2l18.5 55.6c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-18.5-55.6c-1.7-5.1-5.9-9-11.1-10.4l-84-22.1L427 368.7c9.4 13.1 11.5 30.1 5.7 45.1l-33.8 87.9c-3.2 8.2-12.4 12.4-20.7 9.2s-12.4-12.4-9.2-20.7l33.8-87.9c1.9-5 1.2-10.7-1.9-15L367.9 341c-2.6 59.5-51.7 107-111.9 107s-109.3-47.5-111.9-107L111 387.3c-3.1 4.4-3.8 10-1.9 15l33.8 87.9c3.2 8.2-.9 17.5-9.2 20.7s-17.5-.9-20.7-9.2L79.2 413.8c-5.8-15.1-3.6-32 5.7-45.1L144.8 285l-84 22.1c-5.2 1.4-9.4 5.3-11.1 10.4L31.2 373.1c-2.8 8.4-11.9 12.9-20.2 10.1S-2 371.3 .8 362.9l18.5-55.6C24.5 292 37 280.2 52.7 276.1L129.1 256 52.7 235.9C37 231.8 24.5 220 19.3 204.6L.8 149.1c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1l18.5 55.6c1.7 5.1 5.9 9 11.1 10.4l101.6 26.7L91.4 155.1c-13.6-14.7-16.7-36.2-7.8-54.1L129.7 8.8c4-7.9 13.6-11.1 21.5-7.2zM270.1 151.6c-2.8 5.2-8.2 8.4-14.1 8.4s-11.3-3.2-14.1-8.4l-18.7-34.7c-9.4 8.8-15.2 21.3-15.2 35.1V256v0l0 .4c0 4.6-1.9 8.9-5.3 12C186.3 283 176 304.3 176 328v8c0 44.2 35.8 80 80 80s80-35.8 80-80v-8c0-23.7-10.3-45-26.7-59.6c-3.4-3-5.3-7.4-5.3-12l0-.4v0V152c0-13.8-5.9-26.3-15.2-35.1l-18.7 34.7zM218.4 307.2c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12H228c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z"]
};
var faStaffSnake = {
  prefix: 'fal',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M296 48H208V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H120 64C28.7 48 0 76.7 0 112s28.7 64 64 64h8c39.8 0 72-32.2 72-72V80h32V192v32 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V192H128c-35.3 0-64 28.7-64 64s28.7 64 64 64h48v96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v2.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16V450.7 448 416 320h32c26.5 0 48 21.5 48 48s-21.5 48-48 48v32c44.2 0 80-35.8 80-80s-35.8-80-80-80H208V224 192 80h88c30.9 0 56 25.1 56 56s-25.1 56-56 56H240v32h56c48.6 0 88-39.4 88-88s-39.4-88-88-88zM112 80v24c0 22.1-17.9 40-40 40H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h48zM72 120a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faPear = {
  prefix: 'fal',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6L453.1 81.5C470 103.2 480 130.4 480 160c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c29.6 0 56.8 10 78.5 26.9L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0zm-118.6 96l18.9-18.9C391.9 70.6 372.7 64 352 64c-23.1 0-44.2 8.1-60.7 21.6c-37.1 30.3-86.9 65.8-139.7 79.5c-26.6 6.9-51.8 20.8-72.8 41.7c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c20.9-20.9 34.8-46.1 41.7-72.8c13.7-52.8 49.2-102.6 79.5-139.7C439.9 204.2 448 183.1 448 160c0-20.7-6.6-39.9-17.7-55.6l-18.9 18.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM304 336c0 53-43 96-96 96c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHeadSideCoughSlash = {
  prefix: 'fal',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 7.4-2.8 14.1-7.4 19.1l25.2 19.9c8.9-10.5 14.3-24.1 14.3-38.9c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224c-34.8 0-67.7 7.9-97.1 22.1l28.5 22.5C176.8 36.4 199.9 32 224 32zM31.3 109.7C11.4 143.1 0 182.2 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224c0-34.3 9-66.5 24.7-94.3l-25.4-20zM528.5 339.1l33.7 26.6c8.1-3.8 13.8-12.1 13.8-21.7c0-13.3-10.7-24-24-24c-11.6 0-21.2 8.2-23.5 19.1zm63.6 50.2l32 25.3c9.2-3.3 15.8-12.2 15.8-22.6c0-13.3-10.7-24-24-24c-12.3 0-22.5 9.3-23.9 21.3zM432 426l-23.6-18.7-66.5-5.5c-3.3-.3-5.8-3-5.8-6.4c0-3.2 2.3-5.9 5.5-6.3l37.1-5.3-34.7-27.4-7 1c-18.9 2.7-33 18.9-33 38c0 20 15.3 36.6 35.2 38.2l59.9 5C396.2 448.7 387 456 376 456H304c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-8h56c30.9 0 56-25.1 56-56v-6zM640 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTriangle = {
  prefix: 'fal',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", "M235.5 75.8c4.2-7.3 12-11.8 20.5-11.8s16.2 4.5 20.5 11.8l201 344.6c1.6 2.8 2.5 6 2.5 9.3c0 10.2-8.2 18.4-18.4 18.4H50.4C40.2 448 32 439.8 32 429.6c0-3.3 .9-6.4 2.5-9.3l201-344.6zM207.9 59.6L6.9 404.2C2.4 411.9 0 420.7 0 429.6C0 457.4 22.6 480 50.4 480H461.6c27.8 0 50.4-22.6 50.4-50.4c0-8.9-2.4-17.7-6.9-25.4L304.1 59.6C294.1 42.5 275.8 32 256 32s-38.1 10.5-48.1 27.6z"]
};
var faApartment = {
  prefix: 'fal',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M128 128H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H192h32V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32H512c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32V96c0 17.7-14.3 32-32 32zM320 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H192 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H96h32V64c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64v64 32h32 32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384 352 336 240 224zm288-88c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8V384H448v32h32zM136 384H88c-13.3 0-24-10.7-24-24V312c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H96v32h32V320zm384-24c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8V256H448v32h32zM136 256H88c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H96v32h32V192zm208 72c0 13.3-10.7 24-24 24H264c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8V224H272v32h32zm8-96H264c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H272v32h32V96z"]
};
var faTruckMedical = {
  prefix: 'fal',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM416 128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM192 64c-17.7 0-32 14.3-32 32v32l-32 0c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224h32c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H256V96c0-17.7-14.3-32-32-32H192zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H240c-8.8 0-16 7.2-16 16v48H192V208c0-8.8-7.2-16-16-16H128V160h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V96z"]
};
var faAmbulance = faTruckMedical;
var faPepper = {
  prefix: 'fal',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M195.7 5.8c5.7-6.8 15.7-7.7 22.5-2L208 16C218.2 3.7 218.2 3.7 218.3 3.7l0 0 0 0 .1 .1 .2 .2 .6 .5c.5 .4 1.1 1 1.9 1.7c1.6 1.5 3.7 3.6 6.2 6.3c5 5.5 11.7 13.5 18.3 23.9c10.6 16.8 21.2 40 25 69c19.5-9.3 42.2-12.2 64.7-6.5c10.5 2.6 20.1 6.9 28.7 12.4c21.5-13.8 48.5-19.1 75.3-12.4c51.4 12.9 82.7 65 69.8 116.4l-56 224c-12.9 51.4-65 82.7-116.4 69.8c-10.5-2.6-20.1-6.9-28.7-12.4c-5.7 3.7-11.8 6.7-18.3 9.2c-10.6 4-22 6.1-33.7 6.1c-11.7 0-23.1-2.1-33.7-6.1c-6.5-2.4-12.6-5.5-18.3-9.2c-8.6 5.5-18.3 9.8-28.7 12.4C123.8 522 71.7 490.7 58.9 439.3l-56-224C-10 163.8 21.3 111.7 72.7 98.9c26.8-6.7 53.8-1.4 75.3 12.4c7.5-4.9 15.9-8.7 24.9-11.4c.8-.2 1.5-.4 2.3-.6c.5-.1 1.1-.3 1.6-.4c21.2-5.3 42.6-3.1 61.2 4.9c-3.6-20.9-11.5-37.7-19.5-50.3c-5.4-8.5-10.8-15-14.7-19.3c-2-2.1-3.6-3.7-4.6-4.7c-.5-.5-.9-.9-1.2-1.1l-.2-.2c-6.8-5.7-7.7-15.7-2-22.5zM123.4 134.1c-12.9-6.1-28-8-42.9-4.2c-34.3 8.6-55.1 43.3-46.6 77.6l56 224c8.6 34.3 43.3 55.1 77.6 46.6c10-2.5 18.8-7.2 26.1-13.4c6-5.1 14.8-5.1 20.8 0c5.5 4.7 12 8.6 19.1 11.3l0 0c7.1 2.7 14.7 4.1 22.5 4.1h0c7.8 0 15.4-1.4 22.4-4.1l0 0c7.1-2.7 13.6-6.5 19.1-11.3c6-5.1 14.8-5.1 20.8 0c7.3 6.2 16.1 10.9 26.1 13.4c34.3 8.6 69-12.3 77.6-46.6l56-224c8.6-34.3-12.3-69-46.6-77.6c-20.9-5.2-41.9 .4-57.1 13.4c-6 5.1-14.8 5.1-20.8 0c-7.3-6.2-16.1-10.9-26.1-13.4c-22.4-5.6-44.9 1.3-60.3 16.4c-6.2 6.1-16.2 6.1-22.4 0c-15.4-15.1-38-22-60.3-16.4l0 0c-34.3 8.6-55.1 43.3-46.6 77.6L175.5 358c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L106.9 215.3c-7.3-29.3-.3-58.8 16.5-81.1zM256 512h0l0-16 0 16h0z"]
};
var faPiano = {
  prefix: 'fal',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M432 384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H240v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H112v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V384H432zm-16-32h64V327.6c0-12.1-6.8-23.2-17.7-28.6l-58.4-29.2c-31.8-15.9-51.9-48.4-51.9-84C352 100.8 283.2 32 198.3 32H192C103.6 32 32 103.6 32 192V352H96h64 64H352h64zm96-24.4V352v16 16 64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384 368 352 192C0 86 86 0 192 0h6.3C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z"]
};
var faGunSquirt = {
  prefix: 'fal',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M128 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V64C43 64 0 107 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480H168c14.7 0 27.5-10 31-24.2L225 352h63v16c0 8.8 7.2 16 16 16s16-7.2 16-16V336 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H233l16-64H448c35.6 0 66.6-19.3 83.2-48H536c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40h-4.8C514.6 83.3 483.6 64 448 64H128V48zM112 96H448c26.2 0 48.8 15.8 58.7 38.4c2.5 5.8 8.3 9.6 14.7 9.6H536c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H521.3c-6.4 0-12.1 3.8-14.7 9.6C496.8 208.2 474.2 224 448 224H257 224 96c-35.3 0-64-28.7-64-64s28.7-64 64-64h16zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM64 448l48-192H216L168 448H64z"]
};
var faWheatAwnCircleExclamation = {
  prefix: 'fal',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M491.2 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.8 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L319.9 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L281.9 26.4c-6.2-6.2-16.4-6.2-22.6 0L225.4 60.3c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0L44.4 241.3C7 278.8 7 339.6 44.4 377.1L78.4 411l0 0L4.8 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L101 433.6l0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c8.3-.5 16.5-2 24.4-4.6c-2-10.5-3-21.4-3-32.4l0-.7c-23.6 10.9-52.5 6.6-72-12.9l-33.9-33.9c31.8-31.8 80.3-36.6 117.1-14.5c4.5-12 10.3-23.4 17.2-33.9c-3.5-2.3-6.9-5-9.9-8.1L304.6 230c29.9-29.8 74.5-35.9 110.3-18.2c11.6-6.1 24.1-10.9 37-14.2c-2.5-2-5-3.8-7.6-5.6l46.8-46.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-54.3 54.4c-16.1-5.5-33-7.8-49.8-6.7L491.2 43.3zM191.8 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM248 82.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L248 173.4c-25-25-25-65.5 0-90.5zM89.7 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L67.1 354.4c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181L248 444.9c-25 25-65.5 25-90.5 0L123.6 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faSnowman = {
  prefix: 'fal',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", "M256 0C194.1 0 144 50.1 144 112c0 17.6 4 34.2 11.3 49c-5.7 7.3-10.7 15.2-14.7 23.6L96 169.8V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v47.1L21.1 144.8C12.7 142 3.6 146.6 .8 154.9s1.7 17.4 10.1 20.2L130.4 215c-1.6 8.1-2.4 16.4-2.4 25c0 14 2.2 27.4 6.4 40C110.5 308 96 344.3 96 384c0 41.2 15.6 78.8 41.2 107.2c13.7 15.2 33.2 20.8 51 20.8H323.9c17.8 0 37.3-5.7 51-20.8c25.6-28.4 41.2-66 41.2-107.2c0-39.7-14.5-76-38.4-104c4.1-12.6 6.4-26.1 6.4-40c0-8.5-.8-16.9-2.4-25l119.5-39.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1L448 159.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.8l-44.6 14.9c-4.1-8.4-9-16.4-14.7-23.6c7.2-14.8 11.3-31.5 11.3-49C368 50.1 317.9 0 256 0zM176 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 15.6-4.5 30.2-12.2 42.5c-3.9 6.2-3.1 14.2 1.9 19.5C342 191.2 352 214.4 352 240c0 13.3-2.7 25.9-7.5 37.3c-2.5 5.9-1.2 12.8 3.3 17.4C370.2 317.8 384 349.3 384 384c0 33-12.5 63-32.9 85.7c-5.9 6.6-15.6 10.3-27.2 10.3H188.1c-11.6 0-21.3-3.7-27.2-10.3C140.5 447 128 417 128 384c0-34.7 13.8-66.2 36.3-89.3c4.5-4.6 5.8-11.5 3.3-17.4c-4.8-11.5-7.5-24.1-7.5-37.3c0-25.6 10-48.8 26.3-66c5-5.3 5.8-13.3 1.9-19.5C180.5 142.2 176 127.6 176 112zm96 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 43.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V136c0-8.8-7.2-16-16-16s-16 7.2-16 16v3.2z"]
};
var faUserAlien = {
  prefix: 'fal',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M224 32C154.6 32 96 91.1 96 167c0 39.5 21.1 78.5 49.8 112.7c28.3 33.6 60.7 58.7 76 69.6c.1 .1 .8 .5 2.2 .5s2.1-.4 2.2-.5c15.2-10.9 47.7-35.9 76-69.6C330.9 245.5 352 206.5 352 167c0-75.9-58.6-135-128-135zM64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm62.1 185.2c12.8 12.5 25.1 23.2 35.8 31.7H134.4C80 384 35.5 426.4 32.2 480H415.8c-3.3-53.6-47.8-96-102.2-96H286.2c10.6-8.6 23-19.3 35.8-31.7C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 415 55.7 356.6 126.1 352.3zm23-175.4l48 16c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-48-16c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1zm160 30.4l-48 16c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2z"]
};
var faShieldCheck = {
  prefix: 'fal',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm82.3 195.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faMortarPestle = {
  prefix: 'fal',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M478.2 35l0 0c-1.4-1.7-3.3-2.7-5.4-2.9c-1.2-.1-2.4 0-3.5 .4l0 0c-.7 .3-1.4 .6-2.1 1.1l-.3 .2 0 0L292.6 160H238.1L448.2 7.9c3.3-2.4 6.8-4.3 10.5-5.6c5.7-2 11.7-2.7 17.6-2.1c10.2 1.1 20 6.1 26.9 14.7c2.9 3.6 5.1 7.6 6.6 11.8c2 5.7 2.7 11.7 2.1 17.6c-1 9.7-5.6 19-13.4 25.8L398.1 160H350.1L477 46.3l.3-.3 0 0c1.5-1.3 2.4-3.1 2.7-5.2c.1-1.2 0-2.4-.4-3.5l0 0c-.3-.8-.7-1.6-1.3-2.3zM64 224v32c0 69.4 35.3 122.2 102.6 146.1c9.7 3.5 17.2 11.4 20.1 21.4s.7 20.7-5.8 28.7c-6.6 8.3-11.9 17.7-15.4 27.8H346.5c-3.6-10.1-8.8-19.5-15.4-27.8c-6.4-8.1-8.6-18.8-5.8-28.7s10.3-17.9 20.1-21.4C412.7 378.2 448 325.4 448 256V224H64zM352 480h0c.1 0 .1 0 0 0zm-192 0c-.1 0-.1 0 0 0h0zM512 208c0 8.8-7.2 16-16 16H480v32c0 71.6-32.7 130.1-93.8 163c-9.4 5-19.4 9.5-30.1 13.3c6.8 8.5 12.5 17.8 16.9 27.9c2.9 6.5 5.2 13.2 7 20.2c4.4 17.1-10.4 31.7-28.1 31.7H160c-17.7 0-32.4-14.6-28.1-31.7c1.8-7 4.1-13.7 7-20.2c4.5-10 10.2-19.4 16.9-27.9c-10.7-3.8-20.7-8.2-30.1-13.3C64.7 386.1 32 327.6 32 256V224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32 480h16c8.8 0 16 7.2 16 16z"]
};
var faRoadBarrier = {
  prefix: 'fal',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M16 32c8.8 0 16 7.2 16 16V80H608l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32v32V272v32l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 272 112 80 48c0-8.8 7.2-16 16-16zM608 272V112H569.9l-80 160H608zM32 272H70.1l80-160H32V272zM406.1 112H313.9l-80 160h92.2l80-160zm35.8 0l-80 160h92.2l80-160H441.9zm-256 0l-80 160h92.2l80-160H185.9z"]
};
var faChartCandlestick = {
  prefix: 'fal',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm288 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V96c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2v80c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2V136c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8V48zM176 64c-8.8 0-16 7.2-16 16v48c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2V280c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2V168c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8V80c0-8.8-7.2-16-16-16zm144 72v80c0 4.4-3.6 8-8 8H296c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8zm104 88h16c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zm-8-32c0 .3 0 .5 0 .8c-18.3 3.7-32 19.8-32 39.2v48c0 19.4 13.8 35.5 32 39.2c0 .3 0 .5 0 .8v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-.3 0-.5 0-.8c18.3-3.7 32-19.8 32-39.2V232c0-19.4-13.8-35.5-32-39.2c0-.3 0-.5 0-.8V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48zM184 160c4.4 0 8 3.6 8 8V280c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8h16z"]
};
var faBriefcaseBlank = {
  prefix: 'fal',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H144 64c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H368z"]
};
var faSchool = {
  prefix: 'fal',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", "M328.9 2.7c-5.4-3.6-12.4-3.6-17.8 0L171.2 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H256h32 64 32H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H468.8L328.9 2.7zM384 384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H176c3.2 0 6.2-.9 8.9-2.7L320 35.2l135.1 90.1c2.6 1.8 5.7 2.7 8.9 2.7H576c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H384V384zm-32 96H288V384c0-17.7 14.3-32 32-32s32 14.3 32 32v96zM96 192v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm64 0v64H128V192h32zm320-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H480zm0 32h32v64H480V192zM96 352v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm64 0v64H128V352h32zm320-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H480zm0 32h32v64H480V352zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm16-128c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V160z"]
};
var faIgloo = {
  prefix: 'fal',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M576 320v32 64c0 35.3-28.7 64-64 64H384 192 64c-35.3 0-64-28.7-64-64V320C0 160.9 128.9 32 288 32s288 128.9 288 288zm-32 32H480 448 384v96H512c17.7 0 32-14.3 32-32V352zm0-32c0-46.6-12.5-90.3-34.2-128H480V320h64zM352 192H320 128V320h69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H448V192H352zM96 352H32v64c0 17.7 14.3 32 32 32H192V352H128 96zm0-32V192H66.2C44.5 229.7 32 273.4 32 320H96zM487.9 160C453.8 117.5 406.4 86.1 352 72.1V160H487.9zM320 66c-10.5-1.3-21.2-2-32-2c-80.8 0-152.9 37.5-199.9 96H320V66zM288 288c-35.3 0-64 28.7-64 64v96H352V352c0-35.3-28.7-64-64-64z"]
};
var faBracketRound = {
  prefix: 'fal',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M158.1 40.4c4.2 7.8 1.3 17.5-6.4 21.7C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4z"]
};
var faParenthesis = faBracketRound;
var faJoint = {
  prefix: 'fal',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M448 16V43c0 42.4 16.9 83.1 46.9 113.1l21 21c18 18 28.1 42.4 28.1 67.9v27c0 8.8-7.2 16-16 16s-16-7.2-16-16V245c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 272V245c0-42.4-16.9-83.1-46.9-113.1l-21-21C522.1 92.9 512 68.4 512 43V16c0-8.8 7.2-16 16-16s16 7.2 16 16V43c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v27c0 8.8-7.2 16-16 16s-16-7.2-16-16zM116.1 452.3c51.8 14 117 27.7 171.9 27.7h35.2l-71.5-85.8-6.6-7.9c-43.9 4.5-90.2 14.9-129.1 25.3c-22.9 6.2-45.6 12.8-67.8 20.3c22.3 7.4 45 14.2 67.8 20.3zM284.8 384l71.5 85.7 8.5 10.2H483.2l-71.5-85.8L403.2 384H288c-1 0-2.1 0-3.2 0zm160 0l71.5 85.8 8.5 10.2H600c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H444.8zM15.8 409.5c30.1-11 61.1-20.3 92-28.6C160.3 366.7 228.8 352 288 352H600c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H288c-59.2 0-127.7-14.7-180.2-28.8c-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z"]
};
var faHorseSaddle = {
  prefix: 'fal',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M336 144c0-61.9 50.1-112 112-112h24 8 5.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1H432c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L256 304V254.7c45.4-7.6 80-47.1 80-94.7V144zm-96 80c-35.3 0-64-28.7-64-64h16 40 72c0 35.3-28.7 64-64 64zm-16 30.7v42.1l-21.8-4.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1H141.6c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-27.1 21.3-49.2 48-50.6c0 47.5 34.6 87 80 94.6zM192 128H160 146.7c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2V192h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16H485.8 480h-8H448C373.9 0 312.8 56 304.9 128H232 192zM496 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faMugMarshmallows = {
  prefix: 'fal',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", "M357.7 103c6.6 6.6 10.3 15.6 10.3 25H336c0-.9-.3-1.7-1-2.3L277.2 67.8c-2.4-2.4-5.7-3.8-9.2-3.8s-6.7 1.4-9.2 3.8L201 125.7c-.6 .6-1 1.5-1 2.3H168c0-9.4 3.7-18.3 10.3-25l57.9-57.9C244.6 36.7 256.1 32 268 32s23.4 4.7 31.8 13.2L357.7 103zM64 80v48H32V80c0-26.5 21.5-48 48-48H204.1l-32 32H80c-8.8 0-16 7.2-16 16zM32 384c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V192H336 128v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H32V384zm0-224h80H336h16 48c61.9 0 112 50.1 112 112s-50.1 112-112 112H384c0 53-43 96-96 96H96c-53 0-96-43-96-96V192c0-17.7 14.3-32 32-32zM384 352h16c44.2 0 80-35.8 80-80s-35.8-80-80-80H384V352z"]
};
var faFilters = {
  prefix: 'fal',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M231.1 32C209.5 32 192 49.5 192 71.1c0 9.7 3.6 19.1 10.2 26.3L352 262.2v97.7c0 10.2 4.9 19.9 13.2 25.9L445 443.8c3.8 2.7 8.3 4.2 13 4.2c12.2 0 22-9.9 22-22V262.2L629.8 97.4c6.5-7.2 10.2-16.6 10.2-26.3C640 49.5 622.5 32 600.9 32H231.1zM224 71.1c0-3.9 3.2-7.1 7.1-7.1H600.9c3.9 0 7.1 3.2 7.1 7.1c0 1.8-.7 3.5-1.8 4.8l-154 169.4c-2.7 2.9-4.2 6.8-4.2 10.8V406.4l-64-46.5V256c0-4-1.5-7.8-4.2-10.8L225.8 75.8c-1.2-1.3-1.8-3-1.8-4.8zM164.5 96H39.1C17.5 96 0 113.5 0 135.1c0 9.7 3.6 19.1 10.2 26.3L160 326.2v65.7c0 10.2 4.9 19.9 13.2 25.9L253 475.8c3.8 2.7 8.3 4.2 13 4.2c12.2 0 22-9.9 22-22V326.2L320 291V274.6L305.8 259l-45.7 50.3c-2.7 2.9-4.2 6.8-4.2 10.8V438.4l-64-46.5V320c0-4-1.5-7.8-4.2-10.8L33.8 139.8c-1.2-1.3-1.8-3-1.8-4.8c0-3.9 3.2-7.1 7.1-7.1H186.8l-8.3-9.1c-6.1-6.7-10.8-14.5-14-22.9z"]
};
var faBellOn = {
  prefix: 'fal',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M606.3 8.8c4 7.9 .7 17.5-7.2 21.5l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2zM304 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H140.3C115.8 416 96 396.2 96 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8c30.9-30.9 48.3-72.8 48.3-116.6V192c0-83 63.1-151.2 144-159.2V16zm16 48c-70.7 0-128 57.3-128 128v29.1c0 52.2-20.7 102.3-57.7 139.2l-2.8 2.8c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H499.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM289.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C371.6 494.2 347.9 512 320 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM0 176c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm544-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zM40.8 30.3c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32z"]
};
var faAngleRight = {
  prefix: 'fal',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z"]
};
var faDialMed = {
  prefix: 'fal',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm16 232V161c63.1 7.9 112 61.7 112 127c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-65.3 48.9-119.1 112-127V288c0 8.8 7.2 16 16 16s16-7.2 16-16zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHorse = {
  prefix: 'fal',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M336 144c0 8.8-7.2 16-16 16H232 192 146.7c-28 0-50.7 22.7-50.7 50.7c0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5c0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9h33.2c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8c0-4.6-.4-9.2-1.1-13.7c-.9-5.3 .9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4 .3 2.8 .6 4.3 .8c7.7 1.3 13.3 8 13.3 15.8V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311.6c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7c-.1-1.5 0-3.1 .3-4.5V176c0-8.8 7.2-16 16-16h32c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2c10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4H480h-8H448c-61.9 0-112 50.1-112 112zM549.2 31.1c8.9 11.6 14.8 25.7 16.3 41.3l7.7 80.8c2.3 23.9-9.2 47.1-29.6 59.9c-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5H448v40c0 .7-.1 1.5-.1 2.2c.1 1.9 .1 3.9 .1 5.8c0 30.9-12.4 58.4-32 78.4V472c0 22.1-17.9 40-40 40H344c-22.1 0-40-17.9-40-40V347.6l-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7H141.6c-18 0-33.7-12-38.5-29.3L89.6 434.1c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4 .3-.8 .3-1.3c0-.4-.1-.8-.2-1.2L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-41.3 31.3-75.2 71.4-79.5c13-28.6 41.8-48.5 75.3-48.5H192h40 72.9c8-72 69-128 143.1-128h24 8 5.8H544c8.8 0 16 7.2 16 16c0 7-4.5 13-10.8 15.1zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faQ = {
  prefix: 'fal',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M32 256c0 106 86 192 192 192c42.6 0 81.9-13.9 113.8-37.3L227.9 282.4c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7l109.7 128C395.4 355 416 307.9 416 256c0-106-86-192-192-192S32 150 32 256zM358.7 435c-37.5 28.2-84.1 45-134.7 45C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 61.7-24.9 117.5-65.2 158l61.4 71.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L358.7 435z"]
};
var faMonitorWaveform = {
  prefix: 'fal',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", "M64 64C46.3 64 32 78.3 32 96V256H176c5.3 0 10.3 2.7 13.3 7.1l30.8 46.2 53-139c2.3-5.9 7.8-10 14.2-10.3s12.3 3.1 15.1 8.8L345.9 256H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-6.1 0-11.6-3.4-14.3-8.8L290 215.7l-51 134c-2.1 5.6-7.2 9.5-13.2 10.2s-11.8-2-15.1-7L167.4 288H32V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faMonitorHeartRate = faMonitorWaveform;
var faLinkSimple = {
  prefix: 'fal',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C89.3 128 32 185.3 32 256s57.3 128 128 128h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c70.7 0 128-57.3 128-128s-57.3-128-128-128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c88.4 0 160 71.6 160 160zM152 240H424c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWhistle = {
  prefix: 'fal',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M93.4 115.3C79.5 128.1 67.6 143 58 159.4c-14.8-2.8-26-15.8-26-31.4c0-17.7 14.3-32 32-32c13.2 0 24.5 7.9 29.4 19.3zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6h2c9 0 17.6-3.8 23.7-10.5l63.4-69.7c4.6-5 7.1-11.6 7.1-18.4c0-8.5-3.9-16.5-10.6-21.6L500.8 228.2c-5.2-4-12.4-4.5-18-1.1l-17.7 10.6c-10.3 6.2-23.4 5.5-33-1.7c-9.7-7.3-14-19.8-10.8-31.5l5.7-21c1.7-6.2-.5-12.9-5.6-16.9l-62.6-48.4c-.9-.7-1.8-1.3-2.7-1.7C321.6 84 275.2 64 224 64c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM569.5 437.5l-23.4-21.3c-.1 .1-.1 .1-.2 .1h-2c-.1 0-.1 0-.1 0L395.4 338.9c-14-7.3-31.3-3.2-40.5 9.8c-29.1 41-76.9 67.7-130.9 67.7c-88.5 0-160.3-71.8-160.3-160.3s71.8-160.3 160.3-160.3c42.7 0 81.5 16.7 110.3 43.9c1.8 1.7 3.9 3.3 6.1 4.5l53.3 41.3-3 10.9c-6.6 24.2 2.2 50.1 22.3 65.1c19.9 14.9 46.9 16.3 68.3 3.5l8.5-5.1L606.3 350l-60.2 66.2 23.4 21.3zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
var faG = {
  prefix: 'fal',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 64C118 64 32 150 32 256s86 192 192 192c98.5 0 179.8-74.3 190.7-169.9c.2-1.5-.3-2.8-1.4-4c-1.2-1.2-3.1-2.2-5.3-2.2H242.3c-8.8 0-16-7.2-16-16s7.2-16 16-16H408c21.5 0 41.3 17.9 38.5 41.8C433.7 393.4 339 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3C318 82.5 273.2 64 224 64z"]
};
var faWineGlassCrack = {
  prefix: 'fal',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M149.2 32L61.2 32 46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32l-75.1 0 23.2 58.1c3.1 7.7-.3 16.5-7.7 20.3L155 132.4l48.3 48.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-3.6-3.6-5.3-8.8-4.5-13.9s4-9.4 8.6-11.7l50.8-25.4L149.2 32zM160.3 0h98.4c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160 80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7L29.4 29.1C30.9 12.6 44.7 0 61.2 0h98.4c.2 0 .5 0 .7 0z"]
};
var faFragile = faWineGlassCrack;
var faSlotMachine = {
  prefix: 'fal',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M416 416v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416H416zm23.4 64c5.4-9.4 8.6-20.3 8.6-32V416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64H384 528c44.2 0 80-35.8 80-80V221.3c18.6-6.6 32-24.4 32-45.3c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 20.9 13.4 38.7 32 45.3V432c0 26.5-21.5 48-48 48H439.4zM576 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 64V96H96V64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32zm32 64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H448zM112 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L113 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9H112zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L233 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9H232zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L353 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9H352z"]
};
var faNotesMedical = {
  prefix: 'fal',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M128 96c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V293.5c0 8.5-3.4 16.6-9.4 22.6l-58.5 58.5c-6 6-14.1 9.4-22.6 9.4H160c-17.7 0-32-14.3-32-32V96zM96 96V352c0 35.3 28.7 64 64 64H357.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM320 496c0-8.8-7.2-16-16-16H128c-53 0-96-43-96-96l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H304c8.8 0 16-7.2 16-16zM272 112c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272h32c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H336V144c0-17.7-14.3-32-32-32H272zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H320c-8.8 0-16 7.2-16 16v48H272V256c0-8.8-7.2-16-16-16H208V208h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V144z"]
};
var faCarWash = {
  prefix: 'fal',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M76.3 92.5C74.7 93.9 71 96 64 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C78.4 71.7 80 78.3 80 80c0 8.4-2.6 11.4-3.7 12.5zM64 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zM240 80c0 8.4-2.6 11.4-3.7 12.5C234.7 93.9 231 96 224 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C238.4 71.7 240 78.3 240 80zm32 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48s48-16 48-48zM156.2 208H291.8c14.3 0 26.8 9.5 30.8 23.2L338.8 288c-.9 0-1.9 0-2.8 0H112c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zM94.7 222.4L73 298.1C48.6 311.8 32 338 32 368v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H384v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H156.2c-28.6 0-53.7 18.9-61.5 46.4zM384 416v16H64V416 368c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48v48zM112 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 80c0 8.4-2.6 11.4-3.7 12.5C394.7 93.9 391 96 384 96c-8.8 0-16-7.2-16-16c0-1.7 1.6-8.3 8.6-19.6c2.3-3.7 4.8-7.5 7.4-11c2.6 3.6 5.2 7.3 7.4 11C398.4 71.7 400 78.3 400 80zm32 0c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48z"]
};
var faEscalator = {
  prefix: 'fal',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", "M264 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 184 56zm211.3 91.8C409.9 135 428.6 128 448 128H560c44.2 0 80 35.8 80 80s-35.8 80-80 80H478.1L244.7 492.2C230.1 505 211.4 512 192 512H80c-44.2 0-80-35.8-80-80s35.8-80 80-80h81.9L395.3 147.8zM448 160c-11.6 0-22.9 4.2-31.6 11.9L178.5 380c-2.9 2.6-6.7 4-10.5 4H80c-26.5 0-48 21.5-48 48s21.5 48 48 48H192c11.6 0 22.9-4.2 31.6-11.9L461.5 260c2.9-2.6 6.7-4 10.5-4h88c26.5 0 48-21.5 48-48s-21.5-48-48-48H448zM307.9 181.7l-24.6 21.5C275.6 187.1 259.1 176 240 176c-26.5 0-48 21.5-48 48v59.2l-32 28V224c0-44.2 35.8-80 80-80c28.7 0 53.8 15.1 67.9 37.7z"]
};
var faCommentImage = {
  prefix: 'fal',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM184 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104.2 16c.1 0 .2 .1 .3 .1L379.4 288H133.3L175 240.3c.1-.2 .4-.3 .6-.3c.2 0 .5 .1 .6 .3l19 25.3c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.4c.1-.1 .2-.2 .3-.2zm-25.9-19L208 229.3l-6.2-8.2c-6.2-8.3-15.9-13.1-26.2-13.1c-9.5 0-18.4 4.1-24.7 11.2l-48.1 55c-4.4 5-6.8 11.5-6.8 18.2c0 15.3 12.4 27.6 27.6 27.6H388.2c15.4 0 27.8-12.4 27.8-27.8c0-6.4-2.2-12.6-6.2-17.5L313.3 156c-6.2-7.6-15.4-12-25.1-12c-10.2 0-19.8 4.8-25.9 13z"]
};
var faTemperatureHalf = {
  prefix: 'fal',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V208c0-8.8 7.2-16 16-16s16 7.2 16 16v98c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faDongSign = {
  prefix: 'fal',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M304 32c-8.8 0-16 7.2-16 16V64H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V203.3c-23.5-26.6-57.8-43.3-96-43.3c-70.7 0-128 57.3-128 128s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V400c0 8.8 7.2 16 16 16s16-7.2 16-16V288 96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V48c0-8.8-7.2-16-16-16zM96 288a96 96 0 1 1 192 0A96 96 0 1 1 96 288zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faDonut = {
  prefix: 'fal',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M32 208c0-29.2 19-60.4 59.9-86C132.4 96.7 190.3 80 256 80c3.1 0 6.2 0 9.3 .1l-20.6 20.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l39.8-39.8c44.4 6.1 83.3 20 112.9 38.5C461 147.6 480 178.8 480 208v15c-.6 8.5-3.7 16.5-8.8 23.2c-5.3 6.8-12.4 11.9-20.6 14.5l-.3 .1-.3 .1c-6.6 2.5-12.6 6-17.9 10.5c-.1-3.9-1.7-7.8-4.7-10.8l-32-32c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c3.6 3.6 8.6 5.1 13.3 4.6c-7.7 9.5-17.5 17.2-28.7 22.3c-12.6 5.9-26.6 8.3-40.4 7.2l-.6 0-.6 0c-15.9-.2-31.7 2.9-46.4 9l0 0-.1 0c-14.2 6.1-29.6 9.1-45 9v0l-.3 0c-15.5 .1-30.8-2.9-45.1-9l-.1 0c-14.7-6.1-30.5-9.2-46.4-9l-.6 0-.6 0c-13.9 1.1-27.8-1.4-40.4-7.2c-12.5-5.8-23.4-14.8-31.5-26.1c-7-10.6-17.2-18.8-29.1-23.2l-.4-.1-.4-.1c-8.2-2.6-15.3-7.7-20.6-14.5c-5.2-6.7-8.2-14.8-8.8-23.2V208zm0 73.4c5.9 4.1 12.3 7.3 19.2 9.6c5.5 2.1 10.2 6 13.4 10.9l.2 .3 .2 .3c11.3 15.9 26.6 28.5 44.2 36.7c17.5 8.1 36.7 11.6 55.9 10.2c11.4 0 22.7 2.2 33.2 6.6c18.2 7.7 37.9 11.6 57.7 11.5c19.8 .2 39.4-3.7 57.6-11.5c10.5-4.4 21.8-6.6 33.2-6.6c19.2 1.5 38.4-2 55.9-10.1c17.7-8.2 32.9-20.8 44.2-36.6l.2-.3 .2-.3c3.2-5 7.9-8.8 13.4-10.9c6.9-2.3 13.3-5.5 19.2-9.6V304c0 29.2-19 60.4-59.9 86c-40.5 25.3-98.4 42-164.1 42s-123.6-16.7-164.1-42C51 364.4 32 333.2 32 304V281.4zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160V208c0-88.4-114.6-160-256-160zM208 191.9c0 0 0-.1 .1-.3c.1-.3 .4-.9 1.1-1.7c1.5-1.7 4.2-4 8.7-6.2c8.9-4.5 22.4-7.7 38.1-7.7s29.2 3.2 38.1 7.7c4.5 2.2 7.2 4.5 8.7 6.2c.7 .8 1 1.4 1.1 1.7c.1 .2 .1 .3 .1 .3s0 .1 0 .1s0 0 0 .1s0 .1-.1 .3c-.1 .3-.4 .9-1.1 1.7c-1.5 1.7-4.2 4-8.7 6.2c-8.9 4.5-22.4 7.7-38.1 7.7s-29.2-3.2-38.1-7.7c-4.5-2.2-7.2-4.5-8.7-6.2c-.7-.8-1-1.4-1.1-1.7c-.1-.2-.1-.3-.1-.3c0 0 0 0 0-.1s0 0 0 0s0 0 0-.1zm-4.4-36.9C190.3 161.7 176 173.8 176 192s14.3 30.3 27.6 36.9c14.2 7.1 32.8 11.1 52.4 11.1s38.2-3.9 52.4-11.1c13.3-6.6 27.6-18.8 27.6-36.9s-14.3-30.3-27.6-36.9C294.2 147.9 275.6 144 256 144s-38.2 3.9-52.4 11.1zm-32.3-15.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224-6.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm91.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
var faDoughnut = faDonut;
var faCapsules = {
  prefix: 'fal',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M32 240H192V144c0-44.2-35.8-80-80-80s-80 35.8-80 80v96zM0 256V144C0 82.1 50.1 32 112 32s112 50.1 112 112v24.2c3-32.2 19.3-63 47.3-83c50.7-36.2 120.5-23.6 156 28.1L555.7 300.6c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1L243.8 244.4c-11.5-16.8-18-35.7-19.8-54.8V256 368c0 61.9-50.1 112-112 112S0 429.9 0 368V256zm192 16H32v96c0 44.2 35.8 80 80 80s80-35.8 80-80V272zM398.6 413.6c25.5 37.1 75.1 45.8 111 20.1c36.3-26 45.5-77.6 19.7-115.1l-52.7-76.8-2.2 1.6L344.4 334.6l54.2 79.1zm57.5-196.4l2.5-1.7-57.7-84.2c-25.5-37.1-75.1-45.8-111-20.1c-36.3 26-45.5 77.6-19.7 115.1l56.1 81.8 129.8-90.9z"]
};
var faPooStorm = {
  prefix: 'fal',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", "M173.8 6.7c3-4.2 7.9-6.7 13-6.7C257.3 0 326.2 46 335 119.6c28.9 13.3 49 42.5 49 76.4c0 3.5-.2 7-.6 10.4C421.1 220.7 448 257.2 448 300c0 55.2-44.8 100-100 100h-8.9l12.1-11.5c6.7-6.3 11.5-14.2 14.3-22.8C394.6 358 416 331.5 416 300c0-33-23.5-60.5-54.6-66.7c-4.5-.9-8.4-3.7-10.7-7.7s-2.8-8.8-1.3-13.1c1.7-5.2 2.7-10.7 2.7-16.5c0-23.4-15.5-43.2-36.8-49.7c-6.5-2-11-7.9-11.3-14.7c-2-50.8-42.9-88.8-94.2-97.6c.4 1.4 .8 2.7 1.3 4.1c2.3 7.8 5 17.8 5 25.4c0 34.8-17.7 55.5-35.3 66.9c-8.5 5.5-17 8.8-23.2 10.7c-3 .9-5.6 1.6-7.5 2c-1.5 .6-3.2 1-4.9 1.1C117.7 145.6 96 168.3 96 196c0 5.8 .9 11.4 2.7 16.5c1.5 4.4 1 9.1-1.3 13.1s-6.2 6.8-10.7 7.7C55.5 239.5 32 267 32 300c0 32 22.2 58.9 52 66.1c-2.6 6.4-4 13.3-4 20.3c0 4.1 .5 8 1.3 11.8C35 389.5 0 348.8 0 300c0-42.8 26.9-79.3 64.6-93.6c-.4-3.4-.6-6.9-.6-10.4c0-43.7 33.4-79.6 76.1-83.6c.5-.1 1.1-.2 1.6-.3l.2 0c.2 0 .6-.1 1.2-.2c1.1-.2 2.8-.7 5-1.3c4.3-1.3 9.8-3.5 15.3-7c10.4-6.7 20.7-18.2 20.7-40c0-2.2-1.2-7.8-3.7-16.2c-2.3-7.6-5.1-15.6-7.1-21.5l-.1-.2 0 0 0 0c-.6-1.6-1.1-3.1-1.5-4.3c-1.7-4.9-.9-10.3 2.1-14.5zM159.7 376H208c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L288.3 360H240c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L159.7 376zM281.6 224c14.7 0 24.4 15.2 18.2 28.5L265 328h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L180.2 506.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L183 408H133.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L267.8 229.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faPooBolt = faPooStorm;
var faTally1 = {
  prefix: 'fal',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", "M128 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"]
};
var faFaceFrownOpen = {
  prefix: 'fal',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm22 192.1c-22.4-9.5-47.7-14.8-74.5-14.8c-26.8 0-52 5.3-74.4 14.8c-11.2 4.7-23.8 3.1-32.8-3.6c-9.7-7.2-14.9-20.4-9-33.9c19.2-44.1 64.2-74.7 116.2-74.7c52 0 97 30.6 116.2 74.7c5.9 13.6 .8 26.7-9 33.9c-9 6.6-21.5 8.3-32.8 3.5zm-74.4-80.2c-36.9 0-68.5 20.3-83.9 49.5c25.6-10.4 54-16.1 83.9-16.1c29.9 0 58.4 5.8 84 16.1c-15.4-29.2-47.1-49.5-84-49.5z"]
};
var faFrownOpen = faFaceFrownOpen;
var faSquareDashed = {
  prefix: 'fal',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M88 32h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-30.9 0-56 25.1-56 56v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V120C0 71.4 39.4 32 88 32zM16 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm416 0c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0-32c-8.8 0-16-7.2-16-16V120c0-30.9-25.1-56-56-56H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c48.6 0 88 39.4 88 88v24c0 8.8-7.2 16-16 16zm16 208v24c0 48.6-39.4 88-88 88H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c30.9 0 56-25.1 56-56V368c0-8.8 7.2-16 16-16s16 7.2 16 16zM32 368v24c0 30.9 25.1 56 56 56h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-48.6 0-88-39.4-88-88V368c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176zM160 48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
};
var faSquareJ = {
  prefix: 'fal',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 48V288c0 53-43 96-96 96s-96-43-96-96V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 35.3 28.7 64 64 64s64-28.7 64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHandPointUp = {
  prefix: 'fal',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M64 56c0-13.3 10.7-24 24-24s24 10.7 24 24V200v40H80c-5.5 0-10.8 .6-16 1.6V56zm48 216v0h32v0h24c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c13.8 0 26.4-5 36.1-13.2C294.4 351.7 310.2 360 328 360c8.6 0 16.7-1.9 24-5.4C350.6 424.1 293.8 480 224 480H160C89.3 480 32 422.7 32 352V320c0-26.5 21.5-48 48-48h32zm32-32V200c0-13.3 10.7-24 24-24s24 10.7 24 24v31.9c0 0 0 0 0 .1v13.4c-7.3-3.5-15.4-5.4-24-5.4H144zm0-90.6V56c0-30.9-25.1-56-56-56S32 25.1 32 56V256C12.6 270.6 0 293.8 0 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V304 272 248c0-30.9-25.1-56-56-56c-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zM224 272V232c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24v16 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0l0-24zm128 0v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8V248c0-13.3 10.7-24 24-24s24 10.7 24 24v24z"]
};
var faMoneyBill = {
  prefix: 'fal',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", "M480 96c0 35.3 28.7 64 64 64V128c0-17.7-14.3-32-32-32H480zm-32 0H128c0 53-43 96-96 96V320c53 0 96 43 96 96H448c0-53 43-96 96-96V192c-53 0-96-43-96-96zM32 384c0 17.7 14.3 32 32 32H96c0-35.3-28.7-64-64-64v32zm512-32c-35.3 0-64 28.7-64 64h32c17.7 0 32-14.3 32-32V352zM64 96c-17.7 0-32 14.3-32 32v32c35.3 0 64-28.7 64-64H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faArrowUpBigSmall = {
  prefix: 'fal',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", "M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6L75.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v64zm-32 0V368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48zM352 80V208c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80z"]
};
var faSortSizeUp = faArrowUpBigSmall;
var faBarcodeRead = {
  prefix: 'fal',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", "M48 32c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V48C0 21.5 21.5 0 48 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48zm96 96c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm48 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm224 0c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zM272 128c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zM544 48c0-8.8-7.2-16-16-16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c26.5 0 48 21.5 48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zM48 480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-26.5 0-48-21.5-48-48V368c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8 7.2 16 16 16zm496-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 26.5-21.5 48-48 48H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16-7.2 16-16z"]
};
var faBaguette = {
  prefix: 'fal',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M591.9 74.8c-29.4-44.1-89-56-133.1-26.6l-79.2 52.8 47.8 47.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352.4 119l-88 58.7 51 51c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.5-55.5-88 58.7 54.2 54.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L122 272.6 74.7 304.1c-44.1 29.4-56 89-26.6 133.1s89 56 133.1 26.6l384-256c44.1-29.4 56-89 26.6-133.1zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z"]
};
var faBowlSoftServe = {
  prefix: 'fal',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", "M256 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H164c-37.6 0-68 30.4-68 68c0 10.2 2.3 19.9 6.3 28.6C62.7 165.4 32 199.1 32 240c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80c0-41.4-31.4-75.4-71.7-79.6c4.9-9.7 7.7-20.8 7.7-32.4C416 57.3 358.7 0 288 0H256zm32 49.3c0-6-1.1-11.8-3.3-17.3H288c53 0 96 43 96 96c0 13.1-6.3 24.7-16 32H280c-8.8 0-16 7.2-16 16s7.2 16 16 16h92.9H384h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h16 8.3H168c8.8 0 16-7.2 16-16s-7.2-16-16-16H141.4c-8.2-6.6-13.4-16.7-13.4-28c0-19.9 16.1-36 36-36h77.3C267.1 96 288 75.1 288 49.3zM64 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 57.4 46.6 104 104 104h46.1l-20.4 40.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H336c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6L329.9 448H376c57.4 0 104-46.6 104-104v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 39.8-32.2 72-72 72H304c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L310.1 480H201.9l20.4-40.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6H136c-39.8 0-72-32.2-72-72v-8z"]
};
var faFaceHoldingBackTears = {
  prefix: 'fal',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM320.6 116.4c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48s-6 34.6-16 48v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2zM180.4 96.6c8.5 2.4 13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6v32 16 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11zM208 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 208c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32zm160 32c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm1.9 129.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C328.9 410.3 298.8 432 256 432s-72.9-21.7-90.1-41.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C203 384.4 224.9 400 256 400s53-15.6 65.9-30.5z"]
};
var faSquareUp = {
  prefix: 'fal',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 16c9.2 0 18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3H288v80c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V272H134.3C113.1 272 96 254.9 96 233.7c0-10.7 4.5-20.9 12.3-28.1l91-84c6.7-6.2 15.6-9.7 24.7-9.7zm-3 33.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3H176c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2s-2.2 .4-3 1.2z"]
};
var faArrowAltSquareUp = faSquareUp;
var faTrainSubwayTunnel = {
  prefix: 'fal',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256C512 114.6 397.4 0 256 0S0 114.6 0 256V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm336-48v48H272V160h48c26.5 0 48 21.5 48 48zM240 288h32 96v80c0 26.5-21.5 48-48 48H192c-26.5 0-48-21.5-48-48V288h96zm0-128v96H144V208c0-26.5 21.5-48 48-48h48zm-48-32c-44.2 0-80 35.8-80 80V368c0 32.8 19.8 61 48 73.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.6 448H313.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4V208c0-44.2-35.8-80-80-80H192zm8 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm136-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSubwayTunnel = faTrainSubwayTunnel;
var faSquareExclamation = {
  prefix: 'fal',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM200 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faExclamationSquare = faSquareExclamation;
var faSemicolon = {
  prefix: 'fal',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 32 128a64 64 0 1 0 128 0zM128 350.4c0 5.6-1.5 11.1-4.5 15.9L55.4 477.9c-.8 1.3-2.3 2.1-3.8 2.1c-2.8 0-4.9-2.5-4.4-5.2L70.5 343.9C73 330.1 85 320 99 320c16 0 29 13 29 29v1.5zm32 0V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.2-60 50.2L15.7 469.1c-4 22.3 13.2 42.9 35.9 42.9c12.7 0 24.5-6.6 31.1-17.4L150.8 383c6-9.8 9.2-21.1 9.2-32.6z"]
};
var faBookmark = {
  prefix: 'fal',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V489.9c0 12.2-9.9 22.1-22.1 22.1c-4.4 0-8.6-1.3-12.3-3.7L192 403.2 34.4 508.3c-3.6 2.4-7.9 3.7-12.3 3.7C9.9 512 0 502.1 0 489.9V48zM48 32c-8.8 0-16 7.2-16 16V471.4L183.1 370.7c5.4-3.6 12.4-3.6 17.8 0L352 471.4V48c0-8.8-7.2-16-16-16H48z"]
};
var faFanTable = {
  prefix: 'fal',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M416 224A192 192 0 1 0 32 224a192 192 0 1 0 384 0zm32 0c0 118.3-91.8 215.2-208 223.4V480H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H224 80c-8.8 0-16-7.2-16-16s7.2-16 16-16H208V447.4C91.8 439.2 0 342.3 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-55.4-99.7c-32.8 13.2-48.6 50.5-35.4 83.3c9.3 23 30.4 37.7 53.6 39.8c5.8 .5 10.9 4.2 13.2 9.6s1.5 11.6-2.1 16.2l-47.9 61.4c-2.7 3.5-2.1 8.5 1.4 11.2c27.9 21.8 68.1 16.8 89.8-11c15.3-19.5 17.4-45.2 7.6-66.3c-2.5-5.3-1.8-11.6 1.7-16.3s9.3-7.1 15.1-6.3l77.1 10.8c4.4 .6 8.4-2.4 9-6.8c4.9-35-19.5-67.4-54.5-72.3c-24.6-3.5-47.9 7.5-61.3 26.5c-3.4 4.8-9.1 7.3-14.9 6.7s-10.8-4.5-13-9.9L179 112.7c-1.7-4.1-6.3-6.1-10.4-4.4zm60 41.6c19.9-15.9 46-23.9 73.3-20c52.5 7.4 89.1 55.9 81.7 108.4c-3.1 21.9-23.3 37.1-45.2 34L285.8 265c3.8 25.2-2.3 51.8-19.3 73.5c-32.6 41.8-93 49.2-134.8 16.5c-17.4-13.6-20.5-38.7-6.9-56.1L157.6 257c-23.7-9.3-43.7-27.9-54-53.4c-19.9-49.2 3.9-105.1 53-125c20.5-8.3 43.8 1.6 52.1 22.1L228.6 150z"]
};
var faAlignJustify = {
  prefix: 'fal',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 192c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faBatteryLow = {
  prefix: 'fal',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm-448 0v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v96c0 26.5 21.5 48 48 48s48-21.5 48-48V208c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faBattery1 = faBatteryLow;
var faCreditCardFront = {
  prefix: 'fal',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 304c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240zM400 144h64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H400c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40H400c-22.1 0-40 17.9-40 40z"]
};
var faBrainArrowCurvedRight = {
  prefix: 'fal',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2c1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15c2 6.1 .2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3c6.7 4.2 9.3 12.6 6.3 19.8C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8c7.5-1.3 14.9 2.9 17.6 10c6.9 18 24.4 30.8 44.8 30.8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48c-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c20.5 11.8 35.2 32.5 39.1 56.7c-15.4 5.6-27.7 17.3-34.2 32.3c0-1.6 .3-3.2 .8-4.7c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9c-7.3-2.8-11.5-10.4-10-18c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5c-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48V432c0 25.6 20 46.5 45.2 47.9c5 11.8 10.9 22.1 17 30.8c-4.6 .8-9.4 1.3-14.2 1.3c-26.2 0-49.4-12.6-64-32zM526.7 232L635.3 340.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L526.6 472c-5.1 5.1-12 8-19.1 8c-15.1 .1-27.5-12.2-27.5-27.3V400H464c-35.3 0-64 28.7-64 64v32c0 6.4-3.8 12.2-9.8 14.7s-12.8 1.2-17.4-3.2C358.2 493.3 336 459.4 336 416c0-61.9 50.1-112 112-112h32V251.4c0-15 12.1-27.2 27.2-27.3c7.3 0 14.3 2.8 19.5 8zM512 320c0 8.8-7.2 16-16 16H448c-44.2 0-80 35.8-80 80c0 8.5 1.2 16.6 3 24c10.7-41.4 48.2-72 93-72h32c8.8 0 16 7.2 16 16v57.4L601.4 352 512 262.6V320z"]
};
var faMindShare = faBrainArrowCurvedRight;
var faUmbrellaBeach = {
  prefix: 'fal',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", "M471.6 99.4c46.8 45.1 72.2 109 68.3 174.7l-86.3-31.4c15.2-43.2 21.6-89 18.9-134.8c-.2-2.9-.5-5.7-.9-8.5zM402.8 54.3c21.7 10.1 36.3 31.4 37.7 55.6c2.5 41.4-3.3 82.8-17 121.9l-167.6-61c14.6-38.8 36.9-74.2 65.3-104.3c17.5-18.5 44.1-25.2 68.2-17.3c1.1 .4 2.2 .8 3.3 1.2c3.4 1.2 6.7 2.5 10 3.9zm-3.1-35.4c-109.8-38-228.4 3.2-292.6 94c-11.1 15.7-2.8 36.8 15.3 43.4l92.4 33.6 0 0L245 200.9l167.6 61 30.1 10.9 0 0 89.1 32.4c18.1 6.6 38-4.2 39.6-23.4c9-108.1-52-213.2-155.6-256.9c-2.4-1.1-4.9-2.1-7.4-3l-5.9-2.1c-.9-.3-1.8-.6-2.7-.9zM305.9 37c-2.7 2.3-5.4 4.8-7.9 7.5c-31.5 33.3-56 72.5-72.2 115.4l-89.6-32.6C176.5 73 239.2 40.1 305.9 37zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H253.4l77.8-213.7-30.1-10.9L219.4 480H16z"]
};
var faHelmetUn = {
  prefix: 'fal',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M240 32c114.9 0 208 93.1 208 208v16H256c-6.9 0-13 4.4-15.2 10.9L212.5 352H77.2c-25 0-45.2-20.2-45.2-45.2V240C32 125.1 125.1 32 240 32zm96 419.4l-93.6-88.1L267.5 288H336V451.4zM368 480V288H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V240C480 107.5 372.5 0 240 0S0 107.5 0 240v66.8C0 349.4 34.6 384 77.2 384H217.7L349 507.7c3 2.8 6.9 4.3 11 4.3H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM285.3 103.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3v96c0 8.8 7.2 16 16 16s16-7.2 16-16V164.8l34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.2l-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112z"]
};
var faLocationSmile = {
  prefix: 'fal',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM128 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM125.3 247.1C132.1 257.3 156 280 192 280s59.9-22.7 66.7-32.9c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2c-11 16.5-43.9 47.1-93.3 47.1s-82.3-30.6-93.3-47.1c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4z"]
};
var faMapMarkerSmile = faLocationSmile;
var faArrowLeftToLine = {
  prefix: 'fal',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432zM100.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L150.6 272 256 272l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0-105.4 0L251.3 139.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128z"]
};
var faArrowToLeft = faArrowLeftToLine;
var faBullseye = {
  prefix: 'fal',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSushi = {
  prefix: 'fal',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M535.2 288.7L430.5 253.9l59.3-100.4c17.4 20.9 29.7 46.3 34.7 74.7l10.7 60.5zM375.6 96.2c33.9 1.8 65.3 14.3 90.6 34.3L399.4 243.6l-66.2-22c-9.1-3-18.4-5.2-27.8-6.5L375.6 96.2zM268.8 214.1c-13 1.1-25.9 3.9-38.5 8.2L133.2 256 227.7 96H338.6L268.8 214.1zM86.5 272.2L41 287.9l10.5-59.7c12.4-70.1 69.2-122.7 138.4-131L86.5 272.2zM209.1 64C115.9 64 36.2 130.9 20 222.6L9.5 282.4c-4.2 24 18.9 43.8 42 35.8l189.4-65.6c26.6-9.2 55.5-9.4 82.3-.5l202 67.1c23 7.6 45.8-12.1 41.6-35.9L556 222.6C539.8 130.9 460.1 64 366.9 64H209.1zM32 352.9c.5 52.6 43.3 95.1 96 95.1c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c18.8 0 36.4-5.4 51.2-14.8c2.9-1.8 6.6-1.8 9.5 0c14.8 9.4 32.4 14.8 51.2 14.8c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c52.5 0 95.1-42.1 96-94.4c-8.4 .7-17.1-.2-25.8-3.1l-6.2-2V352c0 35.3-28.7 64-64 64c-11.6 0-22.4-3.1-31.7-8.4c-12.6-7.2-28-7.2-40.6 0c-9.3 5.3-20.1 8.4-31.7 8.4c-12.6 0-24.3-3.6-34.1-9.8c-13.4-8.4-30.4-8.4-43.7 0c-9.9 6.2-21.5 9.8-34.1 9.8c-11.6 0-22.4-3.1-31.7-8.4c-12.6-7.2-28-7.2-40.6 0c-9.3 5.3-20.1 8.4-31.7 8.4c-35.3 0-64-28.7-64-64v-4.3l-5.3 1.8c-9 3.1-18 4.1-26.7 3.4z"]
};
var faNigiri = faSushi;
var faMessageCaptions = {
  prefix: 'fal',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]
};
var faCommentAltCaptions = faMessageCaptions;
var faTrashList = {
  prefix: 'fal',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M164.2 39.5L148.9 64H267.1L251.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM279 22.6L304.9 64h47.1H384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H381.7L356.2 452.6C353.9 486.1 326 512 292.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h60.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H292.4c16.8 0 30.7-13 31.9-29.7L349.6 96H66.4zM464 128H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16s7.2-16 16-16zM448 400c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16z"]
};
var faBacon = {
  prefix: 'fal',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", "M566.6 105.4c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-27.5 24.3-48.4 54.6-69 84.7l-.5 .7C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C107 310.7 169.8 247 225.6 165.9c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8c11.2-3.2 23.2-.1 31.4 8.1l96 96zM68.1 420.1l4.8-2.4c122.1-61.1 168.8-129 211.7-191.4l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9c29.9-26.4 67.7-48.5 121.2-64.9L448 32c-56 16-94 38-123.5 64S274 152 252 184C193.2 269.6 126.2 336.9 32 384l36.1 36.1zm23.8 23.8L128 480c125.8-62.9 174.5-133.7 217.8-196.8c22.3-32.5 45-65 74.7-91.2C450 166 488 144 544 128L508.9 92.9l-8.5 2.4c-54 15.4-89.8 36.3-117.3 60.6c-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3c-43.3 63.1-93 135.4-219 199.6z"]
};
var faOption = {
  prefix: 'fal',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M178 107.7c-6.1-7.4-15.2-11.7-24.8-11.7H16C7.2 96 0 88.8 0 80s7.2-16 16-16H153.3c19.2 0 37.4 8.6 49.5 23.5L462 404.3c6.1 7.4 15.2 11.7 24.8 11.7H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H486.7c-19.2 0-37.4-8.6-49.5-23.5L178 107.7zM624 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16H624z"]
};
var faRaccoon = {
  prefix: 'fal',
  iconName: 'raccoon',
  icon: [512, 512, [], "e613", "M283.2 57.1L266.6 77.6c24.6-12.4 53.5-4.7 69.4 15.5c15.9-20.2 44.8-27.9 69.4-15.5L388.8 57.1C375.9 41.2 356.5 32 336 32s-39.9 9.2-52.8 25.1zM336 162.6c-2.6 3.4-5.7 6.5-9.1 9.2l-36.7 29.4c2.2 1.3 4.4 2.7 6.5 4.1L312 215.4c.3-13 10.9-23.4 24-23.4s23.7 10.4 24 23.4l15.3-10.2c2.1-1.4 4.3-2.8 6.6-4.1l-36.7-29.4c-3.4-2.7-6.5-5.8-9.1-9.2zm79.1 24.2l34.4-10.3c8.6-2.6 14.5-10.5 14.5-19.5c0-2.8-.6-5.5-1.7-8.1l-69.6-41.8c-14.4-8.6-32.9-.4-36.2 16c-1.8 8.9 1.5 18 8.6 23.7l50 40zm-108.2-40c7.1-5.7 10.4-14.8 8.6-23.7c-3.3-16.4-21.9-24.7-36.2-16l-69.6 41.8c-1.1 2.5-1.7 5.3-1.7 8.1c0 9 5.9 16.9 14.5 19.5l34.4 10.3 50-40zM336 0c16 0 31.5 3.8 45.3 10.9l44.1-9.8c3.2-.7 6.5-1.1 9.7-1.1h1.3c24 0 43.5 19.5 43.5 43.5c0 4.7-.8 9.3-2.2 13.8L463.9 98.8l20.3 25c7.6 9.3 11.7 21 11.7 33c0 23.1-15.2 43.5-37.3 50.2l-35.8 10.7c-10.6 3.2-20.6 7.9-29.8 14l-18.8 12.6C362.9 252 349.6 256 336 256s-26.9-4-38.2-11.6L279 231.9c-9.2-6.1-19.2-10.9-29.8-14l-35.8-10.7c-22.2-6.6-37.3-27-37.3-50.2c0-12 4.1-23.7 11.7-33l20.3-25L194.2 57.3c-1.5-4.4-2.2-9.1-2.2-13.8C192 19.5 211.5 0 235.5 0h1.3c3.3 0 6.5 .4 9.7 1.1l44.1 9.8C304.5 3.8 320 0 336 0zM239.6 32.3c-.9-.2-1.8-.3-2.8-.3h-1.3c-6.4 0-11.5 5.2-11.5 11.5c0 1.2 .2 2.5 .6 3.6L232 69.4 258.4 37l.3-.4-19.1-4.2zm174 4.6L440 69.4l7.4-22.2c.4-1.2 .6-2.4 .6-3.6c0-6.4-5.2-11.5-11.5-11.5h-1.3c-.9 0-1.9 .1-2.8 .3l-19.1 4.2 .3 .4zM128 267.1c14-16.8 30.6-31.4 49.1-43.1c7.9 6.1 17 10.8 27 13.8l9.3 2.8C153.5 268.6 112 329.5 112 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-16.5 1.9-32.6 5.6-48H32v48c0 44.2 35.8 80 80 80H320c0-17.7-14.3-32-32-32H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c35.3 0 64 28.7 64 64h96c0-17.7-14.3-32-32-32H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16H112C50.1 512 0 461.9 0 400V96C0 60.7 28.7 32 64 32s64 28.7 64 64V267.1zm320 27.2c0-17-6.9-33.1-18.9-44.8c1-.3 2-.6 2.9-.9l30.4-9.1c11.3 15.9 17.6 35 17.6 54.9c0 31.4-15.6 60.7-41.5 78.4L427.6 380c-18.8 12.7-43.9 10.3-60-5.7c-21.1-21.1-17.6-56.2 7.2-72.8l16.3-10.8c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-16.3 10.8c-8 5.3-9.1 16.7-2.3 23.5c5.2 5.2 13.3 6 19.4 1.8l10.8-7.3c17.2-11.7 27.5-31.1 27.5-51.9zM95.9 320l.1-.1V256H32v64H95.9zM96 160H32v64H96V160zm0-32V96c0-17.7-14.3-32-32-32S32 78.3 32 96v32H96zM304.4 374.2c-16.1 16.1-41.3 18.5-60.2 5.7L199 349.2c-7.3-5-9.2-14.9-4.3-22.2s14.9-9.2 22.2-4.3l45.3 30.7c6.1 4.2 14.3 3.4 19.6-1.9c6.8-6.8 5.8-18.2-2.3-23.7L244.3 304c-7.3-5-9.2-14.9-4.3-22.2s14.9-9.2 22.2-4.3l35.3 23.9c24.6 16.7 28 51.7 6.9 72.8zM272 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faHandPointDown = {
  prefix: 'fal',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M64 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144 0-40-32 0c-5.5 0-10.8-.6-16-1.6L64 456zm48-216l0 0 32 0 0 0 24 0c13.2 0 24-10.7 24-24l0 0c0-13.3-10.7-24-24-24l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c15.7 0 29.8 6.4 40 16.8c10.2-10.4 24.3-16.8 40-16.8c13.8 0 26.4 5 36.1 13.2C294.4 160.3 310.2 152 328 152c8.6 0 16.7 1.9 24 5.4C350.6 87.9 293.8 32 224 32l-64 0C89.3 32 32 89.3 32 160l0 32c0 26.5 21.5 48 48 48l32 0zm32 32l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-31.9c0 0 0 0 0-.1l0-13.4c-7.3 3.5-15.4 5.4-24 5.4l-24 0zm0 90.6l0 93.4c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-200C12.6 241.4 0 218.2 0 192l0-32C0 71.6 71.6 0 160 0l64 0c88.4 0 160 71.6 160 160l0 48 0 32 0 24c0 30.9-25.1 56-56 56c-12.1 0-23.3-3.8-32.5-10.4C285.6 325.5 268 336 248 336c-9.7 0-18.8-2.5-26.7-6.8C214 351.7 192.9 368 168 368c-8.6 0-16.7-1.9-24-5.4zM224 240l0 40c0 13.2 10.8 24 24 24c13.3 0 24-10.7 24-24l0-16 0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 0 0 24zm128 0l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24z"]
};
var faArrowUpFromBracket = {
  prefix: 'fal',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L340.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336z"]
};
var faHeadSideGear = {
  prefix: 'fal',
  iconName: 'head-side-gear',
  icon: [512, 512, [], "e611", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm144-96v.7c0 1-.8 3.4-4.1 5.3c-3.2 1.8-5.5 1.4-6.5 .8l-.6-.3c-15.3-8.8-34.9-3.6-43.7 11.7l-16 27.7c-8.8 15.3-3.6 34.9 11.7 43.7l.6 .3c.9 .5 2.6 2.4 2.6 6.1s-1.6 5.6-2.6 6.1l-.6 .3c-15.3 8.8-20.5 28.4-11.7 43.7l16 27.7c8.8 15.3 28.4 20.6 43.7 11.7l.6-.3c.9-.5 3.3-1 6.5 .8c3.3 1.9 4.1 4.3 4.1 5.3v.7c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-.7c0-1 .8-3.4 4.1-5.3c3.2-1.8 5.5-1.4 6.5-.8l.6 .3c15.3 8.8 34.9 3.6 43.7-11.7l16-27.7c8.8-15.3 3.6-34.9-11.7-43.7l-.6-.3c-.9-.5-2.6-2.4-2.6-6.1s1.6-5.6 2.6-6.1l.6-.3c15.3-8.8 20.6-28.4 11.7-43.7l-16-27.7c-8.8-15.3-28.4-20.5-43.7-11.7l-.6 .3c-.9 .5-3.3 1-6.5-.8c-3.3-1.9-4.1-4.3-4.1-5.3V128c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32zm64 0l0 .7c0 15.1 9.4 26.8 20 33c10.7 6.2 25.5 8.3 38.5 .8l.6-.3 16 27.7-.6 .3c-13 7.5-18.5 21.4-18.5 33.8s5.5 26.3 18.5 33.8l.6 .3-16 27.7-.6-.3c-13-7.5-27.8-5.4-38.5 .8c-10.6 6.2-20 17.9-20 33v.7H208v-.7c0-15.1-9.4-26.8-20-33c-10.7-6.2-25.5-8.3-38.5-.8l-.6 .3-16-27.7 .6-.3c13-7.5 18.6-21.4 18.6-33.8s-5.5-26.3-18.6-33.8l-.6-.3 16-27.7 .6 .3c13 7.5 27.8 5.4 38.5-.8c10.6-6.2 20-17.9 20-33V128h32zm8 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTrashPlus = {
  prefix: 'fal',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM208 384V304H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faObjectsAlignTop = {
  prefix: 'fal',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 0zM176 160c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48H112zm288 32c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48H336z"]
};
var faFolder = {
  prefix: 'fal',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H291.9c-17 0-33.3-6.7-45.3-18.7L210.7 73.4c-6-6-14.1-9.4-22.6-9.4H64zM0 96C0 60.7 28.7 32 64 32H188.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faFolderBlank = faFolder;
var faFaceAnxiousSweat = {
  prefix: 'fal',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5c0 .2 0 .2 0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM211.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM283.8 304h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H212.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm67 80c-5.5-27.4-29.6-48-58.6-48h-8.4c-29 0-53.2 20.6-58.6 48H350.8z"]
};
var faCreditCardBlank = {
  prefix: 'fal',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faFileWaveform = {
  prefix: 'fal',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", "M416 448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L318.1 14.1c-9-9-21.2-14.1-33.9-14.1H128C92.7 0 64 28.7 64 64V288H96V64c0-17.7 14.3-32 32-32H256V144c0 26.5 21.5 48 48 48H416V448zm-.5-288H304c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L411.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM270.3 264.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8L189.3 369.7l-32.5-43.3c-3-4-7.8-6.4-12.8-6.4H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H136l43.2 57.6c3.3 4.4 8.7 6.8 14.2 6.3s10.4-3.8 12.9-8.8L256 307.8l17.7 35.4c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H297.9l-27.6-55.2z"]
};
var faFileMedicalAlt = faFileWaveform;
var faMicrochipAi = {
  prefix: 'fal',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M160 0c8.8 0 16 7.2 16 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h16c35.3 0 64 28.7 64 64v16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v16c0 35.3-28.7 64-64 64H368v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H272v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H176v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H128c-35.3 0-64-28.7-64-64V368H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V176H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V128c0-35.3 28.7-64 64-64h16V16c0-8.8 7.2-16 16-16zM128 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H128zm94.7 89.6l56 128c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304H176.5l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l56-128c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9L190.5 272h35.1L208 231.9zM352 192V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMug = {
  prefix: 'fal',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M64 96V352c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V96H368 64zm352 0V256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H416zm0 192v64c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32H368h16 80c61.9 0 112 50.1 112 112s-50.1 112-112 112H416z"]
};
var faPlaneUpSlash = {
  prefix: 'fal',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", "M464 461.4l-32-25.3V440v8 31.4L324.4 448.6c-2.9-.8-5.9-.8-8.8 0L208 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8V317.7c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L96 346.8V290.6c0-5.7 3.1-11 8.1-13.9l73.1-41.7L150 213.6 88.2 248.9c-15 8.5-24.2 24.5-24.2 41.7v56.2c0 21.3 20.3 36.6 40.8 30.8L240 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L320 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c16.6 0 30-13.4 30-30V461.4zm-223.6-360L272 126.4V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C311 33.7 315.9 32 320 32c9.1 0 20.9 8.2 31.8 26.3C362.1 75.5 368 96.1 368 109.7v61.7c0 5.7 3.1 11 8.1 13.9l159.9 91.4c5 2.8 8.1 8.2 8.1 13.9v50.5l27.6 21.8c2.8-4.7 4.4-10.2 4.4-16.2V290.6c0-17.2-9.2-33.1-24.2-41.7L400 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C367.1 21.6 346.9 0 320 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4c-11.1 18.3-19 40.6-20.8 59.7zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faRadiation = {
  prefix: 'fal',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", "M117.4 80L174.6 179c-11.9 12.6-20.9 27.9-26 45L34.3 224c8.3-58.2 39-109.2 83.2-144zm55.4 384.1L230 365c8.4 2 17.1 3 26 3s17.6-1 26-3l57.2 99.1C313.5 474.3 285.4 480 256 480s-57.5-5.7-83.2-15.9zM394.6 80c44.2 34.8 74.9 85.9 83.2 144l-114.4 0c-5.1-17.1-14.1-32.4-26-45L394.6 80zM160 256c8.8 0 15.8-7.2 17.6-15.9c3.5-17.4 12.7-32.8 25.5-44.1c6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l128 0zm48 83.2L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L304 339.2c-4.4-7.7-14.2-10.1-22.6-7.3c-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9l128 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L304 172.9c-4.4 7.6-1.7 17.3 5 23.2c12.8 11.3 22 26.7 25.5 44.1zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faPenCircle = {
  prefix: 'fal',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm331.5-92.7c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L245.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L286.2 140.7z"]
};
var faBagSeedling = {
  prefix: 'fal',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", "M89 96H423l12.6 50.3c8.2 33 12.4 66.9 12.4 100.9v17.7c0 34-4.2 67.9-12.4 100.9L423 416H89L76.4 365.7C68.2 332.7 64 298.9 64 264.8V247.2c0-34 4.2-67.9 12.4-100.9L89 96zM430.9 64H81.1L64.8 39.5c-.5-.8-.8-1.7-.8-2.7c0-2.7 2.2-4.8 4.8-4.8H443.2c2.7 0 4.8 2.2 4.8 4.8c0 1-.3 1.9-.8 2.7L430.9 64zM81.1 448H430.9l16.3 24.5c.5 .8 .8 1.7 .8 2.7c0 2.7-2.2 4.8-4.8 4.8H68.8c-2.7 0-4.8-2.2-4.8-4.8c0-1 .3-1.9 .8-2.7L81.1 448zM38.2 57.3l20 30L45.4 138.5C36.5 174 32 210.5 32 247.2v17.7c0 36.6 4.5 73.1 13.4 108.7l12.8 51.2-20 30c-4 6.1-6.2 13.2-6.2 20.4C32 495.5 48.5 512 68.8 512H443.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4l-20-30 12.8-51.2c8.9-35.5 13.4-72 13.4-108.7V247.2c0-36.6-4.5-73.1-13.4-108.7L453.8 87.3l20-30c4-6.1 6.2-13.2 6.2-20.4C480 16.5 463.5 0 443.2 0H68.8C48.5 0 32 16.5 32 36.8c0 7.3 2.2 14.4 6.2 20.4zM272 319c63.1-7.9 112-61.7 112-127v-1.6c0-16.8-13.6-30.4-30.4-30.4h-8.9c-37.2 0-68.9 17.9-88.7 44.5c-19.8-26.6-51.5-44.5-88.7-44.5h-8.9c-16.8 0-30.4 13.6-30.4 30.4V192c0 65.3 48.9 119.1 112 127v33c0 8.8 7.2 16 16 16s16-7.2 16-16V319zm-32-32.3c-45.4-7.6-80-47.1-80-94.7h7.3c33.6 0 61 20.5 72.7 48.4v46.2zm32 0V240.4c11.7-27.9 39.1-48.4 72.7-48.4H352c0 47.6-34.6 87.1-80 94.7z"]
};
var faChartSimple = {
  prefix: 'fal',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", "M240 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 256c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-96h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-48 16V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faCrutches = {
  prefix: 'fal',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M443.3 4.7l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM290.4 199l34.2-34.2 .1-.1 .1-.1 94-94 22.6 22.6L358.6 176 464 281.4l82.7-82.7 22.6 22.6-94.1 94.1L441 349.6c-11.2 11.2-25.4 18.8-40.9 21.9l-122 24.4c-9.3 1.9-17.8 6.4-24.5 13.1l-98.3 98.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L231 386.4c6.7-6.7 11.3-15.2 13.1-24.5l24.4-122c3.1-15.5 10.7-29.7 21.9-40.9zM313 221.6c-6.7 6.7-11.3 15.2-13.1 24.5L276.4 363.6l117.5-23.5c9.3-1.9 17.8-6.4 24.5-13.1l23-23L336 198.6l-23 23zM196.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L198.6 48l98.7 98.7-22.6 22.6L176 70.6 70.6 176 176 281.4l66.7-66.7c-2.4 6.1-4.2 12.4-5.5 18.9l-8 39.9L198.6 304 219 324.4l-6.2 31.2c-.3 1.4-.8 2.8-1.4 4.1c-4.4-2.9-8.5-6.3-12.3-10.1l-34.3-34.3L48 198.6 27.3 219.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192zM384.5 407.2l21.9-4.4c5.1-1 10.1-2.4 15-4.1l85.9 85.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L386.4 409c-.6-.6-1.2-1.2-1.9-1.8z"]
};
var faCircleParking = {
  prefix: 'fal',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 32h80c35.3 0 64-28.7 64-64s-28.7-64-64-64H208V288zm80 32H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParkingCircle = faCircleParking;
var faMarsStroke = {
  prefix: 'fal',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", "M368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L384 105.4 347.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L361.4 128l-40.7 40.7C290.1 143.3 250.8 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L384 150.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 480 54.6V144c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368zM64 304a144 144 0 1 1 288 0A144 144 0 1 1 64 304z"]
};
var faLeafOak = {
  prefix: 'fal',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", "M300 0c-33.3 0-61.7 23.9-67.3 56.7l-1.4 8.2L217.9 54.8c-23.9-18-57.5-15.7-78.7 5.5c-13.4 13.4-19.7 32.3-17 51l6.7 47.1c-21.5-5.4-44.9 1.3-60.2 18.8l-6.6 7.5C42.9 206.6 38.8 238 51.9 264.1L64.3 289c7.8 15.6 11.8 32.7 11.8 50.1v74.1L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L102 432.6h67.6c17.4 0 34.5 4 50.1 11.8l24.9 12.4c26.1 13.1 57.5 9 79.5-10.2l7.5-6.6c17.5-15.3 24.2-38.7 18.8-60.2l47.1 6.7c18.7 2.7 37.6-3.6 51-17c21.2-21.2 23.5-54.8 5.5-78.7l-10.1-13.4 8.2-1.4c32.8-5.7 56.7-34.1 56.7-67.3c0-22.9-11.4-44.2-30.4-56.9L468 145l5.4-24.8c5.2-23.7-2-48.5-19.2-65.6S412.3 30.1 388.6 35.3l-24.8 5.4-6.9-10.3C344.2 11.4 322.9 0 300 0zM134 400.6L315.3 219.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L108.1 381.2l0-42.1c0-22.4-5.2-44.4-15.2-64.4L80.5 249.8c-7.2-14.5-5-31.9 5.7-44.1l6.6-7.5c9.4-10.7 25.3-12.8 37.2-4.9c15.5 10.3 35.9-2.5 33.3-21l-9.4-65.6c-1.3-8.8 1.7-17.6 8-23.9c9.9-9.9 25.6-11 36.8-2.6l23.9 18c14.3 10.8 35 2.6 38.1-15.1l3.6-21.1C267.2 44.7 282.3 32 300 32c12.2 0 23.5 6.1 30.2 16.2l6.9 10.3c7.3 11 20.6 16.3 33.5 13.5l24.8-5.4c13.1-2.9 26.7 1.1 36.1 10.6s13.4 23.1 10.6 36.1l-5.4 24.8c-2.8 12.9 2.5 26.2 13.5 33.5l10.3 6.9c10.1 6.7 16.2 18.1 16.2 30.2c0 17.7-12.7 32.8-30.2 35.8l-21.1 3.6c-17.7 3.1-25.9 23.8-15.1 38.1l18 23.9c8.4 11.2 7.3 26.9-2.6 36.8c-6.3 6.3-15.1 9.2-23.9 8l-65.6-9.4c-18.4-2.6-31.3 17.8-21 33.3c7.9 11.9 5.8 27.8-4.9 37.2l-7.5 6.6c-12.2 10.7-29.6 12.9-44.1 5.7L234 415.8c-20-10-42-15.2-64.4-15.2H134z"]
};
var faSquareBolt = {
  prefix: 'fal',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM159.7 264H208c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L288.3 248H240c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L159.7 264zM281.6 112c14.7 0 24.4 15.2 18.2 28.5L265 216h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L180.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L183 296H133.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L267.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faVial = {
  prefix: 'fal',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M292.7 4.7c6.2-6.2 16.4-6.2 22.6 0l32 32 128 128 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 198.6l-84.7 84.7L181.8 480.8c-20 20-47.1 31.2-75.3 31.2C47.7 512 0 464.3 0 405.5c0-28.2 11.2-55.3 31.2-75.3l69.5-69.5L313.4 48 292.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM336 70.6L150.6 256H361.4l80-80L336 70.6zM329.4 288H118.6L53.8 352.8c-14 14-21.8 32.9-21.8 52.7c0 41.1 33.4 74.5 74.5 74.5c19.8 0 38.7-7.8 52.7-21.8L329.4 288z"]
};
var faGauge = {
  prefix: 'fal',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64zM144 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faWandMagicSparkles = {
  prefix: 'fal',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M458.3 34.9c3.1-3.1 8.2-3.1 11.3 0l39.4 39.4c3.1 3.1 3.1 8.2 0 11.3L388.7 206.1l-50.7-50.7L458.3 34.9zM66.9 426.3L315.3 177.9l50.7 50.7L117.7 477.1c-3.1 3.1-8.2 3.1-11.3 0L66.9 437.7c-3.1-3.1-3.1-8.2 0-11.3zM435.7 12.3L44.3 403.7c-15.6 15.6-15.6 40.9 0 56.6l39.4 39.4c15.6 15.6 40.9 15.6 56.6 0L531.7 108.3c15.6-15.6 15.6-40.9 0-56.6L492.3 12.3c-15.6-15.6-40.9-15.6-56.6 0zM128 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V80zM464 320c-8.8 0-16 7.2-16 16v48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V336c0-8.8-7.2-16-16-16zM252.2 16c0-6.7-5.4-12.2-12.2-12.2s-12.2 5.4-12.2 12.2V35.8H208c-6.7 0-12.2 5.4-12.2 12.2s5.4 12.2 12.2 12.2h19.8V80c0 6.7 5.4 12.2 12.2 12.2s12.2-5.4 12.2-12.2V60.2H272c6.7 0 12.2-5.4 12.2-12.2s-5.4-12.2-12.2-12.2H252.2V16z"]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faLambda = {
  prefix: 'fal',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H139.5c6.2 0 11.9 3.6 14.5 9.3l7.6 16.5-.3-.1-160 368c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3L179.4 128.3 328.9 452.1c7.8 17 24.9 27.9 43.6 27.9H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H372.5c-6.2 0-11.9-3.6-14.5-9.3L183.1 59.9c-7.8-17-24.9-27.9-43.6-27.9H16z"]
};
var faE = {
  prefix: 'fal',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M48 32C21.5 32 0 53.5 0 80V256 432c0 26.5 21.5 48 48 48H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V272H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V80c0-8.8 7.2-16 16-16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"]
};
var faPizza = {
  prefix: 'fal',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M344.2 389.5C318.9 406.2 288.6 416 256 416c-88.4 0-160-71.6-160-160s71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5l-99.6 99.6c-18.7 18.7-18.7 49.1 0 67.9l99.6 99.6zm24.9-20.4L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L369.1 142.9l22.6-22.6 33.9-33.9C432 80 432 69.9 425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c64.9 0 124.2-24.2 169.4-64c6.6-5.8 6.6-16 .3-22.3l-33.9-33.9-22.6-22.6zm-1.9 43.4l22.9 22.9C352.7 463.4 306.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c50.3 0 96.7 16.6 134.2 44.6L367.2 99.5C335.9 77.1 297.5 64 256 64C150 64 64 150 64 256s86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm132.2-22.4l-22.9-22.9C498.9 335.9 512 297.5 512 256s-13.1-79.9-35.5-111.2l22.9-22.9c28 37.4 44.6 83.8 44.6 134.2s-16.6 96.7-44.6 134.2zM480 256c0 32.6-9.8 62.9-26.5 88.2L365.3 256l88.2-88.2C470.2 193.1 480 223.4 480 256zm32 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L433.1 369.1l22.6 22.6 33.9 33.9c6.2 6.2 16.4 6.3 22.3-.3zM160 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBowlChopsticksNoodles = {
  prefix: 'fal',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", "M499.1 31.7c8.7-1.7 14.3-10.2 12.6-18.8S501.5-1.4 492.9 .3L192 60.5V93.1L499.1 31.7zM160 150.4V99.5 66.9 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V73.3v32.6 46.6 32.1V224v0H96v0V186.7 154.6 112.3 79.7 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V86.1L12.9 96.3C4.2 98-1.4 106.5 .3 115.1s10.2 14.3 18.8 12.6l44.9-9v38L14.9 160c-8.8 .6-15.5 8.2-14.9 17s8.2 15.5 17 14.9L64 188.8V224H50.9C23.3 224 1.4 247.3 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2c7.6 21.9 28.4 37.6 52.9 37.6H328c24.5 0 45.3-15.7 52.9-37.6c71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8H160v0V182.4 150.4zm32 29.9L497.1 160c8.8-.6 15.5-8.2 14.9-17s-8.2-15.5-17-14.9L192 148.2v32.1zM161.3 463.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9H461.1c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1H184c-10.4 0-19.4-6.7-22.7-16.1z"]
};
var faH3 = {
  prefix: 'fal',
  iconName: 'h3',
  icon: [640, 512, [], "f315", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM400 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H560L421 228.4c-4.7 4.5-6.3 11.5-3.8 17.5s8.3 10.1 14.9 10.1h96c44.2 0 80 35.8 80 80s-35.8 80-80 80H455.4c-19.6 0-36.2-14.1-39.5-33.4l-.2-1.2c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l.2 1.2c5.8 34.7 35.8 60.2 71 60.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H472L611 91.6c4.7-4.5 6.3-11.5 3.8-17.5S606.5 64 600 64H400z"]
};
var faPenClip = {
  prefix: 'fal',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", "M385.4 41.9c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L421.7 175 337 90.3l48.4-48.4zM291.7 90.3L99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L492.7 149.3c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0L314.3 67.7 301.3 54.6c-25-25-65.5-25-90.5 0L100.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L233.4 77.3c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1zM314.3 113L399 197.7 206.9 389.8c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4L314.3 113z"]
};
var faPenAlt = faPenClip;
var faBridgeCircleExclamation = {
  prefix: 'fal',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", "M48 32h80H256 384 512h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H528v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H512 384 256 128 48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM48 240H64c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBadgePercent = {
  prefix: 'fal',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm91.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUser = {
  prefix: 'fal',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", "M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480H416c-1.2-79.7-66.2-144-146.3-144H178.3c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"]
};
var faSensor = {
  prefix: 'fal',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 48V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faComma = {
  prefix: 'fal',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M136 352.3c0-17.8-14.4-32.3-32.3-32.3c-16.1 0-29.7 11.8-31.9 27.7l-18 125.8c-.5 3.4 2.2 6.5 5.7 6.5c1.9 0 3.7-1 4.8-2.6l66-101.9c3.8-5.8 5.8-12.6 5.8-19.5v-3.7zm32 0v3.7c0 13.1-3.8 25.9-10.9 36.9l-66 101.9C84.2 505.5 72.3 512 59.5 512c-23 0-40.6-20.3-37.3-43l18-125.8c4.5-31.7 31.6-55.2 63.6-55.2c35.5 0 64.3 28.8 64.3 64.3z"]
};
var faSchoolCircleCheck = {
  prefix: 'fal',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V266.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-2.9 10.2-4.8 20.8-5.8 31.7l-.7 0c-17.7 0-32 14.3-32 32v96h32 32 8.2c10 12.1 21.7 22.9 34.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3c-31.3 16.5-57 42.2-73.5 73.5c-6.5 1.4-13.3 2.2-20.3 2.2c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faToiletPaperUnder = {
  prefix: 'fal',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", "M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32H337.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V464c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V416H128v48c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384H400c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM96 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faToiletPaperReverse = faToiletPaperUnder;
var faLightEmergency = {
  prefix: 'fal',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M352 320V192c0-70.7-57.3-128-128-128S96 121.3 96 192V320H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160V320H352zM48 384c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H48zm0-32H400c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48zM160 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"]
};
var faArrowDownToArc = {
  prefix: 'fal',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 480c123.7 0 224-100.3 224-224c0-8.8 7.2-16 16-16s16 7.2 16 16c0 141.4-114.6 256-256 256S0 397.4 0 256c0-8.8 7.2-16 16-16s16 7.2 16 16c0 123.7 100.3 224 224 224zM396 202.6l-128 144c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4l-128-144c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3L240 293.9 240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 277.9L372 181.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6z"]
};
var faDumpster = {
  prefix: 'fal',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M423.4 32H288l0 0 0 0H152.3c-.2 0-.4 0-.6 0H57c-14.7 0-27.5 10-31 24.2L.9 156.6c-.6 2.3-.9 4.6-.9 6.9C0 179.2 12.8 192 28.5 192h5.3H66h61.7 .6L288 192l159.7 0h.6H510h32.2 5.3c15.7 0 28.5-12.8 28.5-28.5c0-2.3-.3-4.7-.9-6.9L550.1 56.2C546.5 42 533.7 32 519 32H424c-.2 0-.4 0-.6 0zM37.5 224l3.8 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H45.1L64 448.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448.9L530.9 288H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H534.7l3.8-32H506.2L483.7 416H92.3L69.8 224H37.5zm490.2-64H461.2L443 64l76 0 24 96H528.2h-.4zM410.4 64l18.2 96H304V64l106.4 0zM272 64v96H147.3l18-96L272 64zM132.7 64l-18 96H48.2h-.4H33L57 64l75.7 0z"]
};
var faVanShuttle = {
  prefix: 'fal',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", "M32 88V192H160V64H56C42.7 64 32 74.7 32 88zm0 136V328c0 13.3 10.7 24 24 24H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H389.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H584c13.3 0 24-10.7 24-24V224H368 176 32zm160-32H352V64H192V192zm192 0H588.1L477.6 69.3c-3-3.4-7.4-5.3-11.9-5.3H384V192zM584 384h-8c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H56c-30.9 0-56-25.1-56-56V88C0 57.1 25.1 32 56 32H176 368h97.7c13.6 0 26.6 5.8 35.7 15.9L627.7 188.2c7.9 8.8 12.3 20.3 12.3 32.1V328c0 30.9-25.1 56-56 56zm-40 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faShuttleVan = faVanShuttle;
var faBuildingUser = {
  prefix: 'fal',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M64 32H320c17.7 0 32 14.3 32 32V393.4c9.2-10.2 20-18.9 32-25.6V271.8 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c3.2 0 6.4-.2 9.5-.7c-5.5-9.2-8.9-19.9-9.4-31.3l-.1 0H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm192-16a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM384 477.1c0-33.7 27.4-61.1 61.1-61.1H546.9c33.7 0 61.1 27.4 61.1 61.1c0 1.6-1.3 2.9-2.9 2.9H386.9c-1.6 0-2.9-1.3-2.9-2.9zM445.1 384c-51.4 0-93.1 41.7-93.1 93.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H496 445.1z"]
};
var faLightSwitch = {
  prefix: 'fal',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M176 48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H176V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H208V48c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 368c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272H128v96zm0-224v96H256V144c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V144z"]
};
var faSquareCaretLeft = {
  prefix: 'fal',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-9.6 4-18.7 11-25.2l102.8-95.5c5.1-4.7 11.8-7.3 18.7-7.3c15.2 0 27.5 12.3 27.5 27.5l0 201c0 15.2-12.3 27.5-27.5 27.5c-6.9 0-13.6-2.6-18.7-7.3L139 281.2c-7-6.5-11-15.6-11-25.2zm32.7 1.7L256 346.2l0-180.3-95.3 88.4c-.5 .4-.7 1.1-.7 1.7s.3 1.3 .7 1.7z"]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faHighlighter = {
  prefix: 'fal',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M176 296.6v-48c0-5.2 2.5-10 6.7-13l27-19.4L343.7 350.4l-19.4 27c-3 4.2-7.8 6.7-13 6.7h-48c-8.5 0-16.6 3.4-22.6 9.4L197 437.1c-3.1 3.1-8.2 3.1-11.3 0l-62.8-62.8c-3.1-3.1-3.1-8.2 0-11.3l43.7-43.7c6-6 9.4-14.1 9.4-22.6zM523.8 99.5L362.6 324 236 197.4 460.5 36.2c3.8-2.7 8.4-4.2 13-4.2c5.9 0 11.6 2.4 15.8 6.5l32.2 32.2c4.2 4.2 6.5 9.9 6.5 15.8c0 4.7-1.5 9.2-4.2 13zM263.4 416h48c15.5 0 30-7.4 39-20L549.8 118.2C556.4 109 560 97.9 560 86.5c0-14.4-5.7-28.2-15.9-38.4L511.9 15.9C501.7 5.7 487.9 0 473.5 0C462.1 0 451 3.6 441.8 10.2L164 209.6c-12.6 9-20 23.5-20 39v48l-43.7 43.7c-11.4 11.4-14.5 27.9-9.3 42l-84 84c-4.5 4.5-7 10.6-7 17V488c0 13.3 10.7 24 24 24H124.7c6.4 0 12.5-2.5 17-7l36-36c14.2 5.2 30.7 2.1 42-9.3L263.4 416zm-111 33l-31 31H38.6L111 407.6 152.4 449z"]
};
var faWavePulse = {
  prefix: 'fal',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", "M319.6 0c7.5-.2 14.1 4.9 15.9 12.1l84 336 37.6-93.9c7.3-18.2 24.9-30.2 44.6-30.2H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H501.7c-6.5 0-12.4 4-14.9 10.1l-56 139.9c-2.6 6.4-9 10.5-15.9 10s-12.8-5.4-14.4-12.1l-78.7-315-82 410.2c-1.5 7.3-7.8 12.7-15.3 12.9s-14.1-4.9-15.9-12.1L150.5 268.1C148.8 261 142.4 256 135 256H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H135c22 0 41.2 15 46.6 36.4l40.7 162.7 82-410.2C305.8 5.5 312.1 .2 319.6 0z"]
};
var faHeartRate = faWavePulse;
var faKey = {
  prefix: 'fal',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6c-5.4-1.2-11 .4-14.9 4.3L257.4 352H208c-8.8 0-16 7.2-16 16v48H144c-8.8 0-16 7.2-16 16v48H32V398.6L194.8 235.8c4.2-4.2 5.7-10.5 3.9-16.2c-4.4-13.8-6.7-28.4-6.7-43.7zM336 0C238.8 0 160 78.8 160 176c0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3V496c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V384h40c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHatSanta = {
  prefix: 'fal',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", "M357.9 243.4L396.2 320H432l-45.5-90.9c-1.7-3.3-2.5-7-2.5-10.7V216c0-13.3 10.7-24 24-24h4.1c2.6 0 5.1 .4 7.6 1.2l39.5 13.2c1.6-2.1 3.3-4.1 5.2-6c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L76.8 320h34.5l68.1-170.3C200.1 97.9 250.2 64 305.9 64c40.1 0 78.2 17.7 104 48.3l51.9 61.3-32-10.7c-5.7-1.9-11.7-2.9-17.7-2.9H408c-30.9 0-56 25.1-56 56v2.3c0 8.7 2 17.3 5.9 25zM448 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448zM64 352c-35.3 0-64 28.7-64 64s28.7 64 64 64H448c35.3 0 64-28.7 64-64s-28.7-64-64-64H64zm524.7-83.3a40.6 40.6 0 1 1 -57.4-57.4 40.6 40.6 0 1 1 57.4 57.4zm-82.4-82.4c-7.8 7.8-10 18.9-6.8 28.7C490.3 219.5 484 229 484 240s6.3 20.5 15.5 25.1c-3.2 9.7-1 20.9 6.8 28.7s18.9 10 28.7 6.8C539.5 309.7 549 316 560 316s20.5-6.3 25.1-15.5c9.7 3.2 20.9 1 28.7-6.8s10-18.9 6.8-28.7C629.7 260.5 636 251 636 240s-6.3-20.5-15.5-25.1c3.2-9.7 1-20.9-6.8-28.7s-18.9-10-28.7-6.8C580.5 170.3 571 164 560 164s-20.5 6.3-25.1 15.5c-9.7-3.2-20.9-1-28.7 6.8z"]
};
var faTamale = {
  prefix: 'fal',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M296.4 304l23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512s-114-5-150.6-41.3c-7.3-7.3-10.7-17.7-9-27.9L23.6 304l.4 0H52.8L28.8 447.5c-.2 1 .2 2 .9 2.8c12.8 12.6 32.4 21.3 56.8 26.5c24.2 5.2 50.4 6.4 73.4 6.4s49.2-1.2 73.4-6.4c24.5-5.2 44.1-13.9 56.8-26.5c.7-.8 1.1-1.8 .9-2.8L267.2 304H296l.4 0zM319.6 69.3L296.4 208l-.4 0H267.2L291.2 64.5c.2-1-.2-2-.9-2.8c-12.8-12.6-32.4-21.3-56.8-26.5c-24.2-5.2-50.4-6.4-73.4-6.4s-49.2 1.2-73.4 6.4c-24.5 5.2-44 13.9-56.8 26.5c-.7 .8-1.1 1.8-.9 2.8L52.8 208H24l-.4 0L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM8 256c0-8.8 7.2-16 16-16H160 296c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16zM160 56c8.8 0 16 7.2 16 16V208H160 144V72c0-8.8 7.2-16 16-16zm9.6 292.8c1.9 2.6 4.1 4.9 6.4 7V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V355.8c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8zM95.9 78.6L107.7 208H75.6L64.1 81.4c-.8-8.8 5.7-16.6 14.5-17.4s16.6 5.7 17.4 14.5zM83.2 358.4c5.8 4.3 12.2 7.1 18.8 8.6l-6 66.5c-.8 8.8-8.6 15.3-17.4 14.5s-15.3-8.6-14.5-17.4l7.7-84.4c3 4.6 6.8 8.8 11.5 12.2zm153.6 0c4.6-3.5 8.5-7.6 11.5-12.2l7.7 84.4c.8 8.8-5.7 16.6-14.5 17.4s-16.6-5.7-17.4-14.5L218 367c6.6-1.4 13-4.2 18.8-8.6zM212.3 208L224.1 78.6c.8-8.8 8.6-15.3 17.4-14.5s15.3 8.6 14.5 17.4L244.4 208H212.3z"]
};
var faBoxCheck = {
  prefix: 'fal',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM331.3 251.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faBullhorn = {
  prefix: 'fal',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M416 44.2c0-7.2-8.8-10.8-13.8-5.5L378.4 63.9C336.5 108 282.7 138.4 224 151.5V328.5c58.7 13.1 112.5 43.4 154.4 87.6l23.8 25.1c5 5.3 13.8 1.7 13.8-5.5V44.2zM192 323.1V156.9c-5.8 .7-11.6 1.1-17.5 1.5L144.9 160l-.4 0H144 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h80 .4l.4 0 29.7 1.6c5.8 .3 11.7 .8 17.5 1.5zM379 16.7c24.9-26.3 69-8.7 69 27.5V435.8c0 36.2-44.2 53.8-69 27.5l-23.8-25.1c-43.3-45.7-101-74.9-163.1-82.8V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V352c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64l79.6 0 29.2-1.6c69.4-3.9 134.6-34.1 182.4-84.5L379 16.7zM96 352V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V352.9l-16.4-.9H96zM496 192c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16z"]
};
var faSteak = {
  prefix: 'fal',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M368 32c-31 0-57 9.9-77.4 28.9L268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5l21.8 23.4c-18.4 17.1-29.1 39-36.5 55.9c-4.3 9.8-7.8 18.3-11 26l-1.1 2.6c-9.5 23-17.5 42.4-35.9 60.7c-24.6 24.6-52.8 39.8-77.6 52.4c-2.8 1.4-5.5 2.8-8.2 4.2l0 0 0 0c-22.2 11.2-40.9 20.7-57.8 34.3C44.4 311.4 32 332.3 32 360c0 61.4 53 90.2 88.4 102.4C159.3 475.8 205.2 480 240 480c74 0 147.9-28.1 203.5-69.5C497.9 370 544 309.5 544 240c0-52.2-20.6-102.6-50.5-140C464.1 63.3 419.7 32 368 32zM352 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM121.9 297.7c28.3-11.9 65.5-27.6 106.8-69c23.4-23.4 35.6-52.6 47.2-81.3l.1-.2 0 0c2.4-5.9 4.8-11.9 7.3-17.6c7.1-16.3 15.7-32.9 29-45.3c14-13 32-20.3 55.6-20.3c38.6 0 74.7 23.8 100.5 56c26 32.5 43.5 75.9 43.5 120c0 55.2-37.2 107.3-87.6 144.8C373.6 422.6 306.3 448 240 448c-32.9 0-74.9-4.1-109.2-15.9C97.5 420.7 64 399 64 360c0-7.5 1.1-15.6 4.7-23.6c3.7-8.3 9.1-13.9 13.5-17.7c10.2-8.6 24.2-14.6 37.6-20.2l.8-.3 0 0 1.2-.5 0 0zm12.4 29.5l-1.2 .5c-15.2 6.4-24.3 10.5-30.2 15.5C98.6 346.8 96 351 96 360c0 16.7 14.1 31.2 45.2 41.9C170.9 412.1 209 416 240 416c58.6 0 119.4-22.6 165.3-56.8C451.7 324.6 480 280.8 480 240c0-35.9-14.5-72.5-36.5-100c-22.2-27.8-50.1-44-75.5-44c-16.3 0-26.3 4.7-33.9 11.7c-8.2 7.6-14.6 19-21.5 34.7c-2.3 5.3-4.6 11-7.1 17c-11.4 28.1-25.6 63.2-54.3 91.9c-45.8 45.8-87.7 63.5-117 75.8z"]
};
var faLocationCrosshairsSlash = {
  prefix: 'fal',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", "M395.5 397.1C373 409.2 347.3 416 320 416c-88.4 0-160-71.6-160-160c0-14 1.8-27.7 5.2-40.7l-27-21.3c-5 14.6-8.2 30-9.6 46H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48.7c7.7 93.3 82.1 167.6 175.3 175.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.3c31.6-2.6 61-12.9 86.4-28.9l-27-21.3zM304 64.7c-31.6 2.6-61 12.9-86.4 28.9l27 21.3C267 102.8 292.7 96 320 96c88.4 0 160 71.6 160 160c0 14-1.8 27.7-5.2 40.7l27 21.3c5-14.6 8.2-30 9.6-46H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H511.3C503.6 146.7 429.3 72.4 336 64.7V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64.7zM320 352c5.6 0 11.2-.5 16.5-1.4l-55.7-44c-.3-.2-.6-.5-.9-.7l-55.7-44c3 50.3 44.8 90.1 95.8 90.1zM303.5 161.4l55.7 44c.3 .2 .6 .5 .9 .7l55.7 44C412.8 199.8 371 160 320 160c-5.6 0-11.2 .5-16.5 1.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faLocationSlash = faLocationCrosshairsSlash;
var faPersonDolly = {
  prefix: 'fal',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM60 176c7 0 13.8 1.5 20 4.2V319.4L39.1 292.2c-4.5-3-7.1-8-7.1-13.3V204c0-15.5 12.5-28 28-28zm52 38.5l37.8 58.8c5.9 9.2 16 14.7 26.9 14.7h51.8L254 393.7c-18 11.3-30 31.4-30 54.3c0 35.3 28.7 64 64 64c33.8 0 61.5-26.2 63.8-59.5l148-37c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L346 421c-10.2-21.9-32.3-37-58-37c-1.1 0-2.3 0-3.4 .1L231.6 164.2c-2.1-8.6-10.7-13.9-19.3-11.8s-13.9 10.7-11.8 19.3L220.8 256h-44l-47.8-74.4C113.9 158.2 87.9 144 60 144c-33.1 0-60 26.9-60 60v74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8V214.5zM256 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM441.2 322.3l-91.5 22.9-22.9-91.5 91.5-22.9 22.9 91.5zm31-7.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8z"]
};
var faGlobe = {
  prefix: 'fal',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320H347.7c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160H342c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3H374.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"]
};
var faSynagogue = {
  prefix: 'fal',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166v78.1l53.3-48c6.1-5.5 15.3-5.5 21.4 0l69.4 62.5c10.1 9.1 15.9 22.1 15.9 35.7V464c0 26.5-21.5 48-48 48H464 384 352 288 256 176 64c-35.3 0-64-28.7-64-64V294.3c0-13.6 5.8-26.6 15.9-35.7l69.4-62.5c6.1-5.5 15.3-5.5 21.4 0l53.3 48V166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM480 480H592c8.8 0 16-7.2 16-16V294.3c0-4.5-1.9-8.9-5.3-11.9L544 229.5l-58.7 52.8c-3.4 3-5.3 7.4-5.3 11.9V480zM448 166c0-14.2-6.3-27.8-17.3-36.9L320 36.8 209.3 129.1C198.3 138.2 192 151.7 192 166V294.3 480h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96h64V294.3 166zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64V384zM160 294.3c0-4.5-1.9-8.9-5.3-11.9L96 229.5 37.3 282.4c-3.4 3-5.3 7.4-5.3 11.9V448c0 17.7 14.3 32 32 32h96V294.3zM351.5 138.8l26-.2c17-.2 27.5 18.4 18.6 32.9L383.4 192 396 212.6c8.9 14.5-1.6 33-18.6 32.9l-26-.2-12.9 21.9c-8.3 14.2-28.9 14.2-37.3 0l-12.9-21.9-26 .2c-17 .2-27.5-18.4-18.6-32.9L256.6 192 244 171.4c-8.9-14.5 1.6-33 18.6-32.9l26 .2 12.9-21.9c8.3-14.2 28.9-14.2 37.3 0l12.9 21.9zM308 159.3c-2.5 4.2-7 6.8-11.9 6.7l-23.7-.2 11.7 19.1c2.7 4.4 2.7 9.9 0 14.2l-11.7 19.1 23.7-.2c4.9 0 9.4 2.5 11.9 6.7l12 20.5 12-20.5c2.5-4.2 7-6.8 11.9-6.7l23.7 .2-11.7-19.1c-2.7-4.4-2.7-9.9 0-14.2l11.7-19.1-23.7 .2c-4.9 0-9.4-2.5-11.9-6.7l-12-20.5-12 20.5z"]
};
var faFileChartColumn = {
  prefix: 'fal',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM112 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V368z"]
};
var faFileChartLine = faFileChartColumn;
var faPersonHalfDress = {
  prefix: 'fal',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", "M157.3 32.1c.9-.1 1.8-.1 2.7-.1c13.3 0 24 10.7 24 24c0 10.7-7.1 19.8-16.8 22.9c-2.3 .7-4.7 1.1-7.2 1.1c-1.8 0-3.5-.2-5.2-.6C144 77.1 136 67.5 136 56c0-12.3 9.3-22.5 21.3-23.9zm9.2 79.5C194.4 108.4 216 84.7 216 56c0-26.7-18.7-49.1-43.8-54.7C168.3 .5 164.2 0 160 0c-5.9 0-11.6 .9-16.9 2.6C120.4 9.8 104 31 104 56c0 30.9 25.1 56 56 56c1.4 0 2.7 0 4.1-.1c.8-.1 1.6-.1 2.4-.2zM192 320v32h0v64h0v80c0 8.8 7.2 16 16 16c1 0 2-.1 2.9-.3c1.1-.2 2.2-.5 3.3-1c5.7-2.4 9.8-8.1 9.8-14.7V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-10.8-20.2-29.6-34.6-51.3-39.9V164l0 0V320h0zm-65.7-56.8c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H96v96c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 0H112l0 0 0 0 0 0c8.8 0 16-7.2 16-16V400h32V368H112 73.9l52.4-104.8zM160 160V128h0c-37.3 0-71.7 20.6-89.3 53.5L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L99 196.6c12-22.5 35.5-36.6 61-36.6h0z"]
};
var faFolderImage = {
  prefix: 'fal',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zm88 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm135.9 32.1L380.3 352H131.5l44.6-63.8 19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5zm-25.5-19.4L208 277.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7c-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2c0 15.6 12.6 28.2 28.2 28.2H387.9c15.5 0 28.1-12.6 28.1-28.1c0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2c-10 0-19.4 4.7-25.5 12.7z"]
};
var faCalendarPen = {
  prefix: 'fal',
  iconName: 'calendar-pen',
  icon: [512, 512, ["calendar-edit"], "f333", "M144 0c8.8 0 16 7.2 16 16V64H352V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM448 192H64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192zM416 96H96c-17.7 0-32 14.3-32 32v32H448V128c0-17.7-14.3-32-32-32zM327.6 257.9c-6.2-6.2-16.4-6.2-22.6 0l-12.2 12.2 29.1 29.1L334.1 287c6.2-6.2 6.2-16.4 0-22.6l-6.4-6.4zm-28.4 63.9l-29.1-29.1L182 381l-8.6 37.7L211 410l88.2-88.2zm-16.9-86.5c18.7-18.7 49.1-18.7 67.9 0l6.4 6.4c18.7 18.7 18.7 49.1 0 67.9l-123 123c-4.3 4.3-9.6 7.2-15.5 8.6L168 452.7c-17.3 4-32.7-11.5-28.8-28.8l11.5-50.2c1.3-5.9 4.3-11.2 8.6-15.5l123-123z"]
};
var faCalendarEdit = faCalendarPen;
var faRoadBridge = {
  prefix: 'fal',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", "M576 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H496V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H384c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h80V96c0 8.8 7.2 16 16 16s16-7.2 16-16V32h80zm0-32H384c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM480 192c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H80v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H288V192H240V128h48V96H16zM264 288c-48.6 0-88 39.4-88 88v88c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V376c0-48.6-39.4-88-88-88H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c30.9 0 56 25.1 56 56v88c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V376c0-30.9 25.1-56 56-56h24V288H264zM208 128v64H112V128h96z"]
};
var faFaceSmileTear = {
  prefix: 'fal',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm194.3-1.5c5.1-7.7 10.7-15.1 16.2-22c5.5 6.9 11 14.3 16.2 22c11.4 17.1 15.8 29 15.8 34.9c0 12.2-11.7 26.7-32 26.7s-32-14.5-32-26.7c0-5.9 4.4-17.8 15.8-34.9zm7.7-62.3c-1.6 2-3.3 4.1-5.2 6.3c-18.9 23-50.3 61.2-50.3 90.8c0 32.5 28.7 58.7 64 58.7s64-26.2 64-58.7c0-29.2-30.8-66.9-49.6-90l0 0 0 0c-2.1-2.6-4.1-5-5.8-7.2c-4.3-5.5-12.8-5.5-17.1 0zM200.4 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMessagePlus = {
  prefix: 'fal',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM240 304c0 8.8 7.2 16 16 16s16-7.2 16-16V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faCommentAltPlus = faMessagePlus;
var faLocationArrow = {
  prefix: 'fal',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", "M224 224L48 224 400 80 256 432l0-176c0-17.7-14.3-32-32-32zm-32 32h32v32V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H192z"]
};
var faC = {
  prefix: 'fal',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M356.9 120.3c-74.4-75-194.9-75-269.3 0s-74.4 196.5 0 271.4s194.9 75 269.3 0c6.2-6.3 16.3-6.3 22.5 0s6.2 16.4 0 22.7c-86.8 87.5-227.5 87.5-314.4 0s-86.8-229.4 0-316.9s227.5-87.5 314.4 0c6.2 6.3 6.2 16.4 0 22.7s-16.3 6.3-22.5 0z"]
};
var faTabletButton = {
  prefix: 'fal',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPersonDressFairy = {
  prefix: 'fal',
  iconName: 'person-dress-fairy',
  icon: [640, 512, [], "e607", "M320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM304.3 192c-14.3 0-26.8 9.5-30.8 23.2L234.4 352H405.6L366.5 215.2C362.6 201.5 350 192 335.7 192H304.3zm0-32h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H384V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H288V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H234.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4c-9.3 5.3-17.8 12.1-24.9 20.1C185.4 101.7 113.1 64 32 64v48c0 76.5 35.7 144.6 91.5 188.6l12.1 9.5c6.8 5.3 8.1 15 3 22l-9.1 12.4C108.5 373.6 96 409.3 96 448h16c39.2 0 75.4-12.8 104.7-34.5c2.4 .7 4.8 1.2 7.3 1.6v32.1C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32zM407.7 160.5c-7.1-8.1-15.5-14.9-24.9-20.1C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528c-41.2 0-79.7-12-112-32.7V415.2c2.5-.4 5-1 7.3-1.6C452.6 435.2 488.8 448 528 448h16c0-38.7-12.5-74.4-33.6-103.5l-9.1-12.4c-5.1-7-3.7-16.7 3-22l12.1-9.5C572.3 256.6 608 188.5 608 112V64c-81.1 0-153.4 37.7-200.3 96.5z"]
};
var faRectangleHistoryCircleUser = {
  prefix: 'fal',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", "M480 192v.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V192c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zM448 64L64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM556 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8H467.8c-21.8 0-42.2 9.6-56.1 25.8C394.5 422.1 384 396.2 384 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faBuildingLock = {
  prefix: 'fal',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M64 32H320c17.7 0 32 14.3 32 32V272c0-30.5 12.2-58.2 32-78.4V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm208-64c26.5 0 48 21.5 48 48v48H416V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80V480H384V352H544z"]
};
var faChartLineUp = {
  prefix: 'fal',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm288 96c0 8.8 7.2 16 16 16h89.4L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0L448 182.6V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
};
var faMailbox = {
  prefix: 'fal',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M32 208V384c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112S32 146.1 32 208zm256 0V384c0 11.7-3.1 22.6-8.6 32H512c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112H234.5c32.6 26.4 53.5 66.8 53.5 112zM64 448c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64H432c79.5 0 144 64.5 144 144V384c0 35.3-28.7 64-64 64H224 64zm48-256h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0h96 56c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V224H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96h32V224H448v64z"]
};
var faTruckBolt = {
  prefix: 'fal',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM416 128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM251.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h89.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H182.6l68.7-68.7z"]
};
var faPizzaSlice = {
  prefix: 'fal',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M167.5 32.8c-6.1-.4-12.4 3.7-14.4 11.1l-10 37.6C295 96.1 415.9 217 430.5 368.9l37.6-10c7.4-2 11.5-8.3 11.1-14.4C467.7 177.7 334.3 44.3 167.5 32.8zM38.6 473.4l360.5-96.1c-11-140.9-123.5-253.4-264.4-264.4L38.6 473.4zM4.7 507.3c-4-4-5.6-9.9-4.1-15.4L122.2 35.6C127.7 14.9 146.9-.7 169.7 .9C352.5 13.5 498.5 159.5 511.1 342.3c1.6 22.8-14 41.9-34.7 47.5L20.1 511.5c-5.5 1.5-11.4-.1-15.4-4.1zM176 216a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMoneyBillWave = {
  prefix: 'fal',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", "M32 184c35.3 0 64-28.7 64-64v-.5c-18.5-1.4-37.1-4.4-55.8-9.5c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2l0 0 0 0 0 0s0 0 0 0l0 .1V184zm0 192v46.3c0 6.8 3.7 10.4 6.2 11.3C57.3 440.8 76.5 445 96 446.8V440c0-35.3-28.7-64-64-64zm0-32c53 0 96 43 96 96v8c44.7-1 91.1-11.7 141.3-24.5c4.3-1.1 8.6-2.2 13-3.3c51.8-13.3 108-27.6 165.7-28.6c.2-52.8 43.1-95.6 96-95.6V168c-53 0-96-43-96-96V64c-44.7 1-91.1 11.7-141.3 24.5c-4.3 1.1-8.6 2.2-13 3.3c-51.8 13.3-108 27.6-165.7 28.6c-.2 52.8-43.1 95.6-96 95.6V344zm503.8 58c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0s0 0 0-.1V328c-35.3 0-64 28.7-64 64v.5c18.5 1.4 37.1 4.4 55.8 9.5zM480 72c0 35.3 28.7 64 64 64V89.7c0-6.8-3.7-10.4-6.2-11.3C518.7 71.2 499.5 67 480 65.2V72zM0 422.3V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z"]
};
var faChartArea = {
  prefix: 'fal',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM297.4 214.6c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l39.6-39.6 62 72.3c2.5 2.9 3.9 6.6 3.9 10.4V352H128V243.9c0-4.2 1.7-8.3 4.7-11.3L224 141.3l73.4 73.4zm0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V257.8c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-16.9 16.9L320 192l-22.6-22.6z"]
};
var faAreaChart = faChartArea;
var faHouseFlag = {
  prefix: 'fal',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M464 0c-8.8 0-16 7.2-16 16V32 64v96 32V512h32V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480V16c0-8.8-7.2-16-16-16zm16 160V64H608v96H480zm-64-24L281.6 35.2c-5.7-4.3-13.5-4.3-19.2 0l-256 192c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L64 224V440c0 39.8 32.2 72 72 72l272 0c2.7 0 5.4-.2 8-.4V479.2c-2.6 .5-5.3 .8-8 .8H344V352c0-17.7-14.3-32-32-32H232c-17.7 0-32 14.3-32 32V480H136c-22.1 0-40-17.9-40-40V200L272 68 416 176V136zM312 352V480l-80 0V352l80 0z"]
};
var faCircleThreeQuartersStroke = {
  prefix: 'fal',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M477.7 288H272c-26.5 0-48-21.5-48-48V34.3C115.4 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.4 221.7-192zm2.3-32C480 132.3 379.7 32 256 32V240c0 8.8 7.2 16 16 16H480zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPersonCircleMinus = {
  prefix: 'fal',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faScalpel = {
  prefix: 'fal',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", "M200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200zM411.9 45.7L234.4 256h98.2c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5v-4C480 49.3 462.7 32 441.4 32c-11.4 0-22.2 5-29.5 13.7zM4.7 484.7L169.4 320h45.3L59.7 474.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320h32.2c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4z"]
};
var faBan = {
  prefix: 'fal',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M402.7 425.3l-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224c56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256C480 132.3 379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faCancel = faBan;
var faBellExclamation = {
  prefix: 'fal',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM200 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40-176V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCircleBookmark = {
  prefix: 'fal',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 176c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16V334.7l-54-43.2c-5.8-4.7-14.1-4.7-20 0l-54 43.2V176zm16-48c-26.5 0-48 21.5-48 48V368c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4V176c0-26.5-21.5-48-48-48H208z"]
};
var faBookmarkCircle = faCircleBookmark;
var faEggFried = {
  prefix: 'fal',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M461.1 182.8c31.6 42.6 22.6 102.7-19.9 134.3c-13.4 9.9-28.4 15.8-43.8 18c-23.8 3.3-49.1 13.4-70.9 26.8c-21.6 13.3-42.8 31.8-55.7 54.1C235.5 477.2 157.2 498.2 96 462.9S13.8 349.2 49.1 288c28.1-48.6 42.7-116.9 47.2-168.4c2-22.3 11.7-44 29.1-60.8c38.2-36.7 99-35.5 135.7 2.7c17.9 18.6 42.8 36.8 68.2 51.6s53.5 27.6 78.5 33.9c20.6 5.3 39.6 17.4 53.3 35.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 336a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 240a128 128 0 1 0 256 0A128 128 0 1 0 96 240zm88 0c0-22.1 17.9-40 40-40c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faFaceWeary = {
  prefix: 'fal',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c24.2 0 48.2 3.4 71.4 10c-3.5-5.1-7.7-10.3-12.6-15.2c-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2c23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2c9.8 9.8 17.8 20.8 23.4 31.5c5.5 10.4 9.3 21.8 9.3 32.4c0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4c5.6-10.7 13.6-21.6 23.4-31.5c19.5-19.5 47.9-36.2 81.3-36.2zM211.3 164.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faUniformMartialArts = {
  prefix: 'fal',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M176 0c-.9 0-1.8 .1-2.7 .2C135.2 2.6 100.8 24.3 82.2 58L15.8 178.8C5.5 197.7 0 218.9 0 240.4V368c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V288 240.4l32-58.2V288h32V121.2c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V240.4c0-16.2 4.1-32.1 11.9-46.3L110.3 73.4C123.8 49 149 33.3 176.7 32.1c.4 0 .7 0 1.1-.1h52.3l72 144-56 112h35.8l52.4-104.8L409.9 32h52.3c.4 0 .7 .1 1.1 .1c27.7 1.3 53 16.9 66.4 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3V368c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V240.4c0-5.4-1.4-10.7-4-15.4L481.2 118c-1.4-2.6-3.1-5.1-5-7.3c-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15V288h32V182.3l32 58.2V288v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4c0-21.6-5.4-42.8-15.8-61.7L557.8 58c-18.5-33.7-53-55.4-91.1-57.8c-.9-.1-1.8-.2-2.7-.2H400 240 176zm89.9 32H374.1L320 140.2 265.9 32zM448 384v72c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V384H160v72c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V384H448zM144 336c0 8.8 7.2 16 16 16H290.1l-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H320 160c-8.8 0-16 7.2-16 16z"]
};
var faCameraRotate = {
  prefix: 'fal',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", "M255.1 32c-20.7 0-39 13.2-45.5 32.8L199.1 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H440.9L430.5 64.8C423.9 45.2 405.6 32 384.9 32H255.1zM239.9 74.9c2.2-6.5 8.3-10.9 15.2-10.9H384.9c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H512c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h82.7c6.9 0 13-4.4 15.2-10.9l14-42.1zM416 272c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v25.4l-14.1-14.1C368.5 185.8 344.7 176 320 176c-39 0-73.3 19.9-93.3 50.1c-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5C267.7 222.2 292.2 208 320 208c16.2 0 31.8 6.5 43.3 17.9L377.4 240H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64zM224 304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V358.6l14.1 14.1C271.5 390.2 295.3 400 320 400c39 0 73.3-19.9 93.3-50.1c4.9-7.4 2.9-17.3-4.5-22.2s-17.3-2.9-22.2 4.5C372.3 353.8 347.8 368 320 368c-16.2 0-31.8-6.5-43.3-17.9L262.6 336H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H224z"]
};
var faSunDust = {
  prefix: 'fal',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l0 0 25.1-25.1c-2.2-2.2-5.2-3.8-8.4-4.4L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c.6 3.3 2.2 6.2 4.4 8.4L391 121l0 0L371.1 13.1zM256 128c-70.7 0-128 57.3-128 128c0 35.3 14.3 67.3 37.5 90.5l22.6-22.6C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96c26.5 0 50.5 10.7 67.9 28.1l22.6-22.6C323.4 142.3 291.3 128 256 128zm248 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM160 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm160 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM344 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommentText = {
  prefix: 'fal',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48V304c0 8.8 7.2 16 16 16s16-7.2 16-16V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 192z"]
};
var faSprayCanSparkles = {
  prefix: 'fal',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", "M128 32v0 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V33v.1 .1 .1 .1 .1 .1 .1 .1 .1V34v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V35v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V36v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V37v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V38v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V39v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V40v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V41v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V42v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V43v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V44v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V45v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V46v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V47 47v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V48v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V49v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V50v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V51v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V52 52v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V53v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V54v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V55 55v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V56v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V57v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V58v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V59v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V60v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V61v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V62v.1 .1 .1 .1 .1 .1 .1 .1 .1V63v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V64v.1 .1 .1 .1 .1 .1 .1 .1 .1V65v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V66v.1 .1 .1 .1 .1 .1 .1 .1 .1V67v.1 .1 .1 .1 .1 .1 .1 .1 .1V68v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1V69v.1 .1 .1 .1 .1 .1 .1 .1 .1V70v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V72v.1 .1 .1 .1 .1 .1 .1 .1 .1V73v.1 .1 .1 .1 .1 .1 .1 .1 .1V74v.1 .1 .1 .1 .1 .1 .1 .1V75v.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V77v.1 .1 .1 .1 .1 .1 .1 .1V78v.1 .1 .1 .1 .1 .1 .1 .1V79v.1 .1 .1 .1 .1 .1 .1 .1V80 96H96V80v-.1-.1-.1-.1-.1-.1-.1-.1V79v-.1-.1-.1-.1-.1-.1-.1-.1V78v-.1-.1-.1-.1-.1-.1-.1-.1V77v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V75v-.1-.1-.1-.1-.1-.1-.1-.1V74v-.1-.1-.1-.1-.1-.1-.1-.1-.1V73v-.1-.1-.1-.1-.1-.1-.1-.1-.1V72v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V70v-.1-.1-.1-.1-.1-.1-.1-.1-.1V69v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V68v-.1-.1-.1-.1-.1-.1-.1-.1-.1V67v-.1-.1-.1-.1-.1-.1-.1-.1-.1V66v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V65v-.1-.1-.1-.1-.1-.1-.1-.1-.1V64v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V63v-.1-.1-.1-.1-.1-.1-.1-.1-.1V62v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V61v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V60v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V59v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V58v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V57v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V56v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V55 55v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V54v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V53v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V52 52v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V51v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V50v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V49v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V48v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V47 47v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V46v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V45v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V44v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V43v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V42v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V41v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V40v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V39v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V38v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V37v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V36v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V35v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V34v-.1-.1-.1-.1-.1-.1-.1-.1-.1V33v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V80 96H192V80 32H128zM96 160c-35.3 0-64 28.7-64 64V448c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H96zM0 224c0-53 43-96 96-96H224c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224zm208 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 320a80 80 0 1 1 160 0A80 80 0 1 1 80 320zM336 0c8.8 0 16 7.2 16 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zM480 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 192v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64-96v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faAirFreshener = faSprayCanSparkles;
var faSignalBars = {
  prefix: 'fal',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M576 464V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16zM512 48c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V48zM416 176c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V176zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V176zM256 464V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16zM240 256c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V304c0-26.5 21.5-48 48-48zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]
};
var faSignalAlt = faSignalBars;
var faSignalAlt4 = faSignalBars;
var faSignalBarsStrong = faSignalBars;
var faDiamondExclamation = {
  prefix: 'fal',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", "M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faStar = {
  prefix: 'fal',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M226.5 168.8L287.9 42.3l61.4 126.5c4.6 9.5 13.6 16.1 24.1 17.7l137.4 20.3-99.8 98.8c-7.4 7.3-10.8 17.8-9 28.1l23.5 139.5L303 407.7c-9.4-5-20.7-5-30.2 0L150.2 473.2l23.5-139.5c1.7-10.3-1.6-20.7-9-28.1L65 206.8l137.4-20.3c10.5-1.5 19.5-8.2 24.1-17.7zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"]
};
var faDialMin = {
  prefix: 'fal',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM276.7 276.7l-89.8 89.8c-39.1-50.2-35.5-122.9 10.6-169c50-50 131-50 181 0s50 131 0 181c-46.2 46.2-118.8 49.7-169 10.6l89.8-89.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faRepeat = {
  prefix: 'fal',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M15.2 272C6.4 271.5-.4 264 0 255.2l.4-8C5.1 153.5 82.4 80 176.2 80H320V35.6C320 20.3 332.3 8 347.6 8c6.8 0 13.4 2.5 18.4 7.1l76.7 69c3.4 3 5.3 7.4 5.3 11.9s-1.9 8.9-5.3 11.9l-76.7 69c-5.1 4.6-11.6 7.1-18.4 7.1c-15.2 0-27.6-12.3-27.6-27.6V112H176.2c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zM352 146.5L408.1 96 352 45.5l0 100.9zM496.8 240c8.8 .4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2L192 432l0 44.4c0 15.2-12.3 27.6-27.6 27.6c-6.8 0-13.4-2.5-18.4-7.1l-76.7-69c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l76.7-69c5.1-4.6 11.6-7.1 18.4-7.1c15.2 0 27.6 12.3 27.6 27.6l0 44.4 143.8 0c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2zM160 365.5L103.9 416 160 466.5l0-100.9z"]
};
var faCross = {
  prefix: 'fal',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M128 40c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v88h88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H256V472c0 22.1-17.9 40-40 40H168c-22.1 0-40-17.9-40-40V256H40c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40h88V40zm40-8c-4.4 0-8 3.6-8 8V144c0 8.8-7.2 16-16 16H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H144c8.8 0 16 7.2 16 16V472c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V240c0-8.8 7.2-16 16-16H344c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H240c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H168z"]
};
var faPageCaretDown = {
  prefix: 'fal',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H245.5c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6V448zM64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zM180.2 346.8c3 3.3 7.3 5.2 11.8 5.2s8.8-1.9 11.8-5.2l75.7-82.6c14.1-15.4 3.2-40.2-17.7-40.2l-139.6 0c-20.9 0-31.8 24.8-17.7 40.2l75.7 82.6zM140.4 256l103.3 0L192 312.3 140.4 256z"]
};
var faFileCaretDown = faPageCaretDown;
var faBox = {
  prefix: 'fal',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M342.4 64H240v96H405.9L371.7 83c-5.1-11.6-16.6-19-29.2-19zM416 192H240 208 32V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM42.1 160H208V64H105.6c-12.6 0-24.1 7.4-29.2 19L42.1 160zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38H342.4z"]
};
var faVenusMars = {
  prefix: 'fal',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M176 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM352 176c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.3C70.3 343.2 0 267.8 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c9.7-5.1 19-10.9 27.8-17.4C325.6 368.5 361 384 400 384c79.5 0 144-64.5 144-144s-64.5-144-144-144c-10.5 0-20.7 1.1-30.6 3.3c-4.1-10.2-8.9-20.1-14.5-29.4C369.3 66 384.4 64 400 64c42.8 0 82.1 15.3 112.6 40.7L585.4 32H496c-8.8 0-16-7.2-16-16s7.2-16 16-16H624c8.8 0 16 7.2 16 16V144c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6l-72.7 72.7C560.7 157.9 576 197.2 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"]
};
var faClockSevenThirty = {
  prefix: 'fal',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V308.8l-34.7 52c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l64-96c3.9-5.9 11.2-8.5 17.9-6.4s11.4 8.3 11.4 15.3V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faArrowPointer = {
  prefix: 'fal',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", "M0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1H161.5l61.1 137.5c3.6 8.1 0 17.5-8.1 21.1s-17.5 0-21.1-8.1l-61-137.2L38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22zM32 72V400l86.4-100.8c6.1-7.1 15-11.2 24.3-11.2H272L32 72z"]
};
var faMousePointer = faArrowPointer;
var faClockFourThirty = {
  prefix: 'fal',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V285.9l71.1 47.4c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-96-64c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faSignalBarsGood = {
  prefix: 'fal',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", "M416 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16V464zM400 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48zM256 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16V464zM240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM96 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSignalAlt3 = faSignalBarsGood;
var faCactus = {
  prefix: 'fal',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M320 464c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V320 288 256 224 96c0-35.3 28.7-64 64-64s64 28.7 64 64V352v32 32 32 16zm32-112V96c0-53-43-96-96-96s-96 43-96 96V224H112c-8.8 0-16-7.2-16-16V144c0-26.5-21.5-48-48-48S0 117.5 0 144v64c0 61.9 50.1 112 112 112h48V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V448h48c61.9 0 112-50.1 112-112V272c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8-7.2 16-16 16H352zm0 32h48c26.5 0 48-21.5 48-48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 44.2-35.8 80-80 80H352V384zM112 288c-44.2 0-80-35.8-80-80V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5 21.5 48 48 48h48v32H112zM256 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLightbulbGear = {
  prefix: 'fal',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M336 176c0 13.7-1.9 27-5.5 39.5c3.3 1 6.5 2.3 9.5 4v-.9c0-17.8 10.2-35.6 28-43.3C367.6 78.4 289 0 192 0C94.8 0 16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM258.5 443c-5.1-8.8-9.3-17.8-12.8-27h-123c-5.9 0-10.7 4.8-10.7 10.7V432c0 44.2 35.8 80 80 80c35.2 0 65.1-22.8 75.8-54.4c-3.3-4.7-6.4-9.5-9.4-14.6zM192 96c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM399.3 239.8H433c3 16.6 13.9 29.5 26.5 36.7c12.9 7.4 30 9.9 45.9 3.6l17.2 30.5c-12.8 11.4-18.5 27.7-18.5 42.4s5.7 31 18.5 42.4L505.3 426c-15.9-6.3-32.9-3.7-45.9 3.6c-12.6 7.2-23.5 20.2-26.5 36.7H399.3c-3.1-16.6-14-29.5-26.6-36.7c-13-7.4-30-9.9-46-3.7l-17.2-30.5c12.8-11.4 18.5-27.7 18.5-42.4s-5.7-31-18.5-42.4l17.2-30.5c15.9 6.3 33 3.7 46-3.7c12.6-7.2 23.6-20.1 26.6-36.7zm43.5-32H389.4c-11.7 0-21.3 9.5-21.3 21.3v1.4c0 7.6-4.6 14.4-11.3 18.2c-6.6 3.7-14.7 4.2-21.2 .3l-1.6-1c-10.7-6.3-24.4-2.6-30.5 8.2L277 303.1c-5.7 10.2-2.3 23.1 7.8 29c7.3 4.3 11.2 12.6 11.2 21s-3.9 16.7-11.2 21c-10 5.9-13.5 18.8-7.8 29L303.5 450c6.1 10.8 19.9 14.5 30.5 8.2l1.6-1c6.5-3.9 14.6-3.4 21.2 .3c6.6 3.8 11.3 10.6 11.3 18.2v1.4c0 11.7 9.5 21.3 21.3 21.3h53.4c11.8 0 21.4-9.6 21.4-21.4v-1.6c0-7.5 4.6-14.2 11.1-18c6.5-3.7 14.5-4.2 21-.3l1.8 1c10.7 6.3 24.4 2.6 30.5-8.2L555 403.1c5.7-10.2 2.3-23-7.8-29c-7.3-4.3-11.2-12.6-11.2-21s3.9-16.7 11.2-21c10-5.9 13.5-18.8 7.8-29l-26.4-46.9c-6.1-10.8-19.9-14.5-30.5-8.2l-1.8 1c-6.5 3.8-14.5 3.4-21-.3c-6.5-3.7-11.1-10.4-11.1-18v-1.6c0-11.8-9.6-21.4-21.4-21.4zM416.1 409.1a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-24-56a24 24 0 1 1 48.1 0 24 24 0 1 1 -48.1 0z"]
};
var faMaximize = {
  prefix: 'fal',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", "M50.2 196.5l.6 .2c8.2 2 16.8-.4 22.8-6.3l47.1-47.1L233.4 256 120.7 368.7 73.6 321.6c-6-6-14.6-8.4-22.8-6.3l-.6 .2C39.5 318.1 32 327.7 32 338.7V456c0 13.3 10.7 24 24 24l117.3 0c11 0 20.6-7.5 23.3-18.2l.2-.6c2-8.2-.4-16.8-6.3-22.8l-47.1-47.1L256 278.6 368.7 391.3l-47.1 47.1c-6 6-8.4 14.6-6.3 22.8l.2 .6c2.7 10.7 12.3 18.2 23.3 18.2L456 480c13.3 0 24-10.7 24-24l0-117.3c0-11-7.5-20.6-18.2-23.3l-.6-.2c-8.2-2-16.8 .4-22.8 6.3l-47.1 47.1L278.6 256 391.3 143.3l47.1 47.1c6 6 14.6 8.4 22.8 6.3l.6-.2c10.7-2.7 18.2-12.3 18.2-23.3L480 56c0-13.3-10.7-24-24-24H338.7c-11 0-20.6 7.5-23.3 18.2l-.2 .6c-2 8.2 .4 16.8 6.3 22.8l47.1 47.1L256 233.4 143.3 120.7l47.1-47.1c6-6 8.4-14.6 6.3-22.8l-.2-.6C193.9 39.5 184.3 32 173.3 32H56C42.7 32 32 42.7 32 56V173.3c0 11 7.5 20.6 18.2 23.3zM64 154.7L64 64l90.7 0L64 154.7zM154.7 448L64 448l0-90.7L154.7 448zM448 154.7L357.3 64 448 64l0 90.7zM357.3 448L448 357.3l0 90.7-90.7 0z"]
};
var faExpandArrowsAlt = faMaximize;
var faChargingStation = {
  prefix: 'fal',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M256 32c17.7 0 32 14.3 32 32V480H64V64c0-17.7 14.3-32 32-32H256zM32 64V480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 288h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V270.4c36.5-7.4 64-39.7 64-78.4V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v48c0 38.7 27.5 71 64 78.4V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V336c0-44.2-35.8-80-80-80H320V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64zm432 96h64 16v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V160h16zM204.8 121.6c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-72 96c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8h80l-52.8 70.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l72-96c3.6-4.8 4.2-11.3 1.5-16.8s-8.3-8.8-14.3-8.8H152l52.8-70.4z"]
};
var faShapes = {
  prefix: 'fal',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M411.4 175.5c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H192c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160zM288 32L192 192H384L288 32zM472 304H328c-4.4 0-8 3.6-8 8V456c0 4.4 3.6 8 8 8H472c4.4 0 8-3.6 8-8V312c0-4.4-3.6-8-8-8zM328 272H472c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V312c0-22.1 17.9-40 40-40zM224 384A96 96 0 1 0 32 384a96 96 0 1 0 192 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z"]
};
var faTriangleCircleSquare = faShapes;
var faPlaneTail = {
  prefix: 'fal',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M47.7 32H94.1c12.5 0 24.4 4.8 33.4 13.5L345 256H264.4c-7 0-13.9 .9-20.6 2.7L85.9 300.8 32 51.4C29.9 41.4 37.5 32 47.7 32zM.7 58.1L55 309l-6.7 1.8C19.8 318.4 0 344.2 0 373.7c0 27.3 17 51.7 42.7 61.1l197.1 72.3c8.8 3.2 18.1 4.9 27.5 4.9H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H267.4c-5.6 0-11.2-1-16.5-2.9L53.7 404.8C40.7 400 32 387.6 32 373.7c0-15 10.1-28.1 24.6-32L252 289.6c4-1.1 8.2-1.6 12.4-1.6H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H390.3l.4-.4-11.5-11.1L149.7 22.5C134.8 8.1 114.9 0 94.1 0H47.7C17.1 0-5.7 28.2 .7 58.1zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faGaugeSimpleMax = {
  prefix: 'fal',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64z"]
};
var faTachometerFastest = faGaugeSimpleMax;
var faCircleU = {
  prefix: 'fal',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 160c0-8.8-7.2-16-16-16s-16 7.2-16 16V288c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-8.8-7.2-16-16-16s-16 7.2-16 16V288c0 44.2-35.8 80-80 80s-80-35.8-80-80V160z"]
};
var faShieldSlash = {
  prefix: 'fal',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM418 414.9c-23.5 22.9-51.8 43.3-85.4 59.4c-7.9 3.8-17.2 3.8-25.1 0C169.2 408.2 122.9 270.7 113.8 174.7L80.1 148.2c2.6 100.7 45.8 274.7 213.5 355c16.7 8 36.1 8 52.8 0c38.6-18.5 70.6-41.9 97-68.2l-25.4-20zM295 7.8L174 59.2l28.6 22.6L307.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.2 45.8-9.6 108.6-37.1 169.6l25.8 20.4c32.5-68.7 43-139.7 43.3-189.8c.1-26.2-16.3-47.9-38.3-57.2L345 7.8c-16-6.8-34-6.8-50 0z"]
};
var faSquarePhoneHangup = {
  prefix: 'fal',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM81.1 246.7c78.8-72.9 207-72.9 285.7 0c.8 .7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7c-37-11.9-77.4-11.9-114.3 0c-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9L80.4 250.4c-.4-.7-.5-1.2-.4-1.8s.3-1.2 1.1-1.9zm307.5-23.5c-91-84.3-238.2-84.3-329.2 0c-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9c0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1 .5-.1 .7c-1.8 16.6 8.5 31.3 23.3 36.9L327 317.5c16.6 6.3 36.4 .6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z"]
};
var faPhoneSquareDown = faSquarePhoneHangup;
var faArrowUpLeft = {
  prefix: 'fal',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", "M48 96c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V150.6L324.7 411.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 128H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"]
};
var faTransporter1 = {
  prefix: 'fal',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", "M256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM464 128c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16zM48 320c8.8 0 16 7.2 16 16v16H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V336c0-8.8 7.2-16 16-16zm80 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM320 193.1V288H288V176.2c-1.6-.2-3.1-.2-4.7-.2H228.7c-1.6 0-3.2 .1-4.7 .2V288H192V193.1c-.5 .6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9zM176 320H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPeanuts = {
  prefix: 'fal',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", "M297.7 160.7c4.7-18.7 3.4-38.9-5.1-57.9L269.9 51.9c-7.5-16.9-27.4-24.5-44.3-17L174.7 57.6c-11.1 4.9-20.7 11.8-28.5 20.1l0 0c-7.8 8.2-14.2 18-18.5 29.3l-.1 .4 0 0c-4.3 11.3-6.1 22.8-5.8 34.1l0 0c.2 6.2 1 12.5 2.5 18.7l.1 .2 .1 .2c4.9 21.3 9.1 50.3-1.8 78.6s-33.4 47-51.3 59.6l-.2 .1-.2 .1c-5.3 3.6-10.1 7.7-14.3 12.2l0 0c-7.8 8.2-14.2 18.1-18.6 29.5c-4.4 11.4-6.2 23-5.9 34.3l0 0c.3 11.3 2.8 22.9 7.7 34l22.7 50.9c7.4 16.6 26.5 24.2 43.2 17.5c4.4 10 10.3 19.2 17.3 27.3l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2l22.5 50.6c-2.9 8.4-5.1 17.1-6.7 26c-3.9 19.7-9.2 34.7-17.3 45.3zm-42.3 89.1l-.2 0c-8.2 1.5-16 3.8-23.5 6.9l0 0c-13.7 5.6-26.5 14-37.7 25.2c-11.2 11.2-19.5 24-25.2 37.6l0 0c-5.7 13.6-8.8 28.6-8.8 44.4v68c0 26.5 21.5 48 48 48h68c32.4 0 61.6-13.2 82.7-34.6l0 0c10.8-11 19-23.6 24.5-37l0 0c3.1-7.5 5.4-15.3 6.9-23.5l0-.2 0-.2c5.1-25.9 14.4-58.5 39-83.1s57.2-33.9 83.1-39l.2 0 .2 0c8.2-1.5 16-3.8 23.5-6.9l0 0c13.7-5.6 26.5-14 37.7-25.2c11.2-11.2 19.5-24 25.2-37.6l0 0c5.7-13.6 8.8-28.6 8.8-44.4V80c0-26.5-21.5-48-48-48H492c-32.4 0-61.6 13.2-82.7 34.6l0 0c-10.8 11-19 23.6-24.5 37l0 0c-3.1 7.5-5.4 15.3-6.9 23.5l0 .2-.1 .2c-5.1 25.9-14.4 58.5-39 83.1s-57.2 33.9-83.1 39l-.2 0zm126.1 218C354.7 495.1 317.3 512 276 512H208c-44.2 0-80-35.8-80-80V364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30c7.1-17.1 17.5-33.2 31.3-47.2C413.3 16.9 450.7 0 492 0h68c44.2 0 80 35.8 80 80v68c0 20.1-4 39.2-11.2 56.7c-7.2 17.5-17.9 33.8-32.1 48c-14.2 14.2-30.6 24.9-48.1 32.1c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2zM544 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-64 64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-224 224a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM300.8 416a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM544 172.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM300.8 352a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0z"]
};
var faShuffle = {
  prefix: 'fal',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M427.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 112H400 344c-20.1 0-39.1 9.5-51.2 25.6L244 202.7l20 26.7 54.4-72.5c6-8.1 15.5-12.8 25.6-12.8h56 57.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80zM124.8 361.6c-3 4-7.8 6.4-12.8 6.4H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c15.1 0 29.3-7.1 38.4-19.2L204 309.3l-20-26.7-59.2 78.9zM404.7 475.3c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 368H400 344c-10.1 0-19.6-4.7-25.6-12.8l-168-224C141.3 119.1 127.1 112 112 112H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c5 0 9.8 2.4 12.8 6.4l168 224C304.9 390.5 323.9 400 344 400h56 57.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faRandom = faShuffle;
var faPersonRunning = {
  prefix: 'fal',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", "M280 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 280 0zM140.6 116.4c12.7-3.2 26.1-3.2 38.8 0L274 140c16.6 4.2 29.8 16.9 34.5 33.4l20.3 71c2 6.9 8.2 11.6 15.4 11.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H344.1c-21.4 0-40.3-14.2-46.2-34.8l-13.6-47.7L247.2 317.1c-.2 .5-.3 .9-.5 1.3l37.5 21.1c13.6 7.6 19.7 23.9 14.5 38.5L255.1 501.3c-2.9 8.3-12.1 12.7-20.4 9.8s-12.7-12.1-9.8-20.4l43.5-123.3-93.3-52.5c-20-11.3-29.3-35.2-22-57l35.4-106.2-16.9-4.2c-7.6-1.9-15.6-1.9-23.3 0l-1.5 .4c-7.4 1.8-14.2 5.4-20 10.4L74.5 204c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l52.4-45.8c9.6-8.4 21-14.3 33.3-17.4l1.5-.4zm79.1 43.1L183.5 268c-2.4 7.3 .7 15.2 7.3 19l27.5 15.4 44.1-132.3-42.7-10.7zM101.3 384L130 314.1c5.9 10 14.1 18.7 24.1 25.4l-23.3 56.6c-4.9 12-16.6 19.8-29.6 19.8H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85.3z"]
};
var faRunning = faPersonRunning;
var faMobileRetro = {
  prefix: 'fal',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", "M256 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H256zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160v64H96V160H224zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faGripLinesVertical = {
  prefix: 'fal',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M32 32c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16L48 48c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16z"]
};
var faBinBottlesRecycle = {
  prefix: 'fal',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", "M384 16c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zM352 192c0-28.1-12.1-53.4-31.4-71c-17.1-15.5-39.7-25-64.6-25H128c-53 0-96 43-96 96H64c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64h32zm223.1 0c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-11-5.1-23-7.8-35.1-7.8H402.3c-12.1 0-24.1 2.7-35.1 7.8L354.1 78c-7.2 3.4-13.5 8-18.6 13.6c8.4 6.7 16 14.4 22.5 22.9c2.6-3.2 5.9-5.8 9.7-7.6l13.2-6.2c6.7-3.2 14.1-4.8 21.5-4.8h90.6c7.4 0 14.8 1.6 21.5 4.8l13.1 6.2c9.8 4.6 16 14.4 16 25.2c0 5.8-1.7 11.1-4.7 15.5c-7.1 10.6-7.2 24.4-.4 35.1c1.8 2.8 3.2 5.9 4 9.2h32.5zm21.2 32H577.7 62.3 43.7 33.9 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H33.9L55.7 441.3c4.7 40.3 38.9 70.7 79.5 70.7H504.9c40.6 0 74.7-30.4 79.5-70.7L606.1 256H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H606.1h-9.8zM87.5 437.6L66.1 256H573.9L552.5 437.6c-2.8 24.2-23.3 42.4-47.7 42.4H135.1c-24.3 0-44.8-18.2-47.7-42.4zM319.9 320c4.6 0 9 2.3 11.5 6.2l8.5 12.9c4.8 7.3 14.5 9.4 21.8 4.8c7.6-4.8 9.8-14.9 4.9-22.4l-8.5-12.9c-8.5-12.9-22.8-20.6-38.2-20.6c-15.3 0-29.6 7.7-38.1 20.4l-7.6 11.4c-5 7.5-2.8 17.7 4.8 22.4c7.3 4.6 17 2.5 21.8-4.7l7.6-11.4c2.6-3.8 6.9-6.1 11.5-6.1zm-59.4 48.4c-7.3-4.6-17-2.5-21.8 4.7l-7.9 11.9c-4.4 6.7-6.8 14.5-6.8 22.5c0 22.4 18.2 40.6 40.6 40.6h25.2c8.8 0 16-7.2 16-16s-7.2-16-16-16H264.6c-4.7 0-8.6-3.8-8.6-8.6c0-1.7 .5-3.3 1.4-4.7l7.9-11.9c5-7.5 2.8-17.7-4.8-22.4zM337.7 432c0 8.8 7.2 16 16 16h20.9c22.4 0 40.6-18.2 40.6-40.6c0-7.9-2.3-15.7-6.7-22.4l-6.6-10.1c-4.8-7.3-14.5-9.4-21.8-4.8c-7.6 4.8-9.8 14.9-4.9 22.4l6.6 10.1c.9 1.4 1.4 3.1 1.4 4.7c0 4.8-3.9 8.6-8.6 8.6H353.7c-8.8 0-16 7.2-16 16zM160 0c-17.7 0-32 14.3-32 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V32h64V48c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16c0-17.7-14.3-32-32-32H160z"]
};
var faArrowUpFromSquare = {
  prefix: 'fal',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", "M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-104 104c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-104-104zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faFileDashedLine = {
  prefix: 'fal',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", "M480 448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352H128v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352H480v96zm0-256v64h32V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V256h32V64c0-17.7 14.3-32 32-32H320V144c0 26.5 21.5 48 48 48H480zm-.5-32H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM48 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H464z"]
};
var faPageBreak = faFileDashedLine;
var faBracketCurlyRight = {
  prefix: 'fal',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M192 112c0-44.2-35.8-80-80-80H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c26.5 0 48 21.5 48 48v53.5c0 21.2 8.4 41.6 23.4 56.6L217.4 256l-33.9 33.9c-15 15-23.4 35.4-23.4 56.6V400c0 26.5-21.5 48-48 48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c44.2 0 80-35.8 80-80V346.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9V112z"]
};
var faSpider = {
  prefix: 'fal',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M158.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L83.6 101c-8.9 17.9-5.9 39.5 7.8 54.1l71.1 76.5L60.8 204.9c-5.2-1.4-9.4-5.3-11.1-10.4L31.2 138.9c-2.8-8.4-11.9-12.9-20.2-10.1S-2 140.7 .8 149.1l18.5 55.6C24.5 220 37 231.8 52.7 235.9L129.1 256 52.7 276.1C37 280.2 24.5 292 19.3 307.4L.8 362.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l18.5-55.6c1.7-5.1 5.9-9 11.1-10.4l84-22.1L85 368.7c-9.4 13.1-11.5 30.1-5.7 45.1l33.8 87.9c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-33.8-87.9c-1.9-5-1.2-10.7 1.9-15L144.1 341c2.6 59.5 51.7 107 111.9 107s109.3-47.5 111.9-107L401 387.3c3.1 4.4 3.8 10 1.9 15l-33.8 87.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l33.8-87.9c5.8-15.1 3.6-32-5.7-45.1L367.2 285l84 22.1c5.2 1.4 9.4 5.3 11.1 10.4l18.5 55.6c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-18.5-55.6c-5.1-15.4-17.7-27.1-33.3-31.2L382.9 256l76.5-20.1c15.7-4.1 28.2-15.9 33.3-31.2l18.5-55.6c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-18.5 55.6c-1.7 5.1-5.9 9-11.1 10.4L349.6 231.7l71.1-76.5c13.6-14.7 16.7-36.2 7.8-54.1L382.3 8.8c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l46.1 92.2c3 6 2 13.2-2.6 18L336 199.3V152c0-32.2-19-59.9-46.3-72.6c-7.7-3.6-16.8-.5-20.8 6.9L256 110.3 243.1 86.3c-4-7.5-13.2-10.5-20.8-6.9C195 92.1 176 119.8 176 152v47.3l-61.2-65.9c-4.5-4.9-5.6-12.1-2.6-18l46.1-92.2zm130.4 93.8c9.4 8.8 15.2 21.3 15.2 35.1V256v0l0 .4c0 4.6 1.9 8.9 5.3 12C325.7 283 336 304.3 336 328v8c0 44.2-35.8 80-80 80s-80-35.8-80-80v-8c0-23.7 10.3-45 26.7-59.6c3.4-3 5.3-7.4 5.3-12l0-.4v0V152c0-13.8 5.9-26.3 15.2-35.1l18.7 34.7c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l18.7-34.7z"]
};
var faClockThree = {
  prefix: 'fal',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faHandsBound = {
  prefix: 'fal',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", "M16.8 48C16.8 21.2 38.7-.4 65.5 0c26 .4 47.2 23.7 47.2 49.7L112 154.7 173.9 228c7.1 8.4 20.1-1.8 13.6-10.7l-28.6-39.2c-13.4-18.5-13.1-44.6 2.5-61.4c25.5-27.4 60.5-15.2 74.4 4l42.3 58.4c16.6 22.1 25.6 49.1 25.6 76.9V352H336V255.9c0-27.7 9-54.7 25.6-76.9l42.3-58.4c13.9-19.2 48.9-31.4 74.4-4c15.6 16.7 15.9 42.9 2.5 61.4l-28.6 39.2c-6.5 9 6.5 19.1 13.6 10.7l61.9-73.4-.7-104.9c0-26 21.2-49.4 47.2-49.7c26.8-.4 48.7 21.2 48.7 48l.8 138.2c0 11-3.7 21.5-10.5 30L506.4 349.9c-.5 .7-1.1 1.4-1.6 2.1H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h22.9c-.5-.7-1-1.4-1.6-2.1L26.5 216.2c-6.7-8.5-10.5-19-10.5-30L16.8 48zM170.2 352H271.9l-.1-96.1c0-20.6-6.7-41.1-19.5-58L210 139.6c-5.4-7.4-15.4-8.7-22.3-3.5c-7.9 5.6-8.4 15.7-3.5 22.2l30.5 42.2c.2 .2 .5 .5 .5 .8c26.1 39.7-33.8 86.7-70.7 42.4L87.4 175.2c-4.8-5.8-7.5-13.1-7.4-20.7l.6-105.9c0-22.4-32-21.7-32-.7L48 186.2c0 3.6 1.2 7.2 3.5 10L158.3 329.9c5 6.2 9 13.9 11.9 22.1zm311.2-22.1L588.3 196.2c2.2-2.7 3.5-6.4 3.5-10l-.7-138.3c0-21-32-21.6-32 .7l.6 105.9c0 7.5-2.6 14.9-7.4 20.7l-57.1 68.5c-36.8 44.4-96.8-2.6-70.7-42.4c0-.2 .2-.5 .5-.8l30.5-42.2c4.9-6.5 4.4-16.6-3.5-22.2c-7-5.2-17-3.9-22.3 3.5l-42.3 58.4c-12.7 16.9-19.5 37.4-19.5 58l-.1 96.1H469.6c2.9-8.2 6.9-15.9 11.9-22.1zM112 416H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H496v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H368v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H304v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H176v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faScalpelLineDashed = {
  prefix: 'fal',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", "M441.4 32c-11.4 0-22.2 5-29.5 13.7L234.4 256h98.2c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5v-4C480 49.3 462.7 32 441.4 32zm-54-6.9C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320h45.3L59.7 474.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320h32.2c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L169.4 320zM304 480c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm64 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faScalpelPath = faScalpelLineDashed;
var faFileInvoiceDollar = {
  prefix: 'fal',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm144 99.6v13.6c8.3 1.1 16.3 2.7 23.7 4.5c8.6 2 13.9 10.7 11.9 19.3s-10.7 13.9-19.3 11.9c-11.2-2.6-22.2-4.6-32.5-4.8c-8.7-.1-17.9 1.7-24.3 5.1c-6.1 3.2-7.4 6.3-7.4 9.4c0 1.5 .2 3.6 6.6 7c7 3.7 16.8 6.4 29.4 9.8l.5 .1c11.3 3 25.2 6.8 36.1 12.9c11.8 6.6 23.1 17.7 23.4 35.9c.3 18.9-10.6 31.7-23.6 38.9c-7.5 4.1-15.9 6.6-24.4 7.9v13.5c0 8.8-7.2 16-16 16s-16-7.2-16-16V414.4c-10.9-1.9-21.2-5-30.3-7.8l0 0 0 0c-2.1-.7-4.2-1.3-6.2-1.9c-8.5-2.5-13.3-11.4-10.8-19.9s11.4-13.3 19.9-10.8c2.4 .7 4.8 1.4 7.1 2.1c13.6 4.1 24.8 7.5 36.8 7.9c9.4 .3 18.5-1.6 24.4-4.9c5.4-3 7.2-6.2 7.1-10.4c0-2.4-.8-4.9-7-8.4c-6.9-3.9-16.8-6.7-29.2-10l-1.6-.4c-11-3-24.2-6.5-34.6-12.1c-11.5-6.2-23.3-16.9-23.4-35.1c-.1-19 11.9-31.3 24.5-37.9c7.3-3.8 15.4-6.2 23.4-7.5V243.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPipeSmoking = {
  prefix: 'fal',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M586.6 32c-35.2 0-68.4 16.6-89.5 44.7L395 212.5c18.2 15.5 22.4 42.4 8.9 62.8L296 439.8C266.5 484.9 216.2 512 162.3 512H160C71.6 512 0 440.4 0 352V280c0-30.9 25.1-56 56-56H200c28.4 0 51.9 21.2 55.5 48.6l49.5-66c14.9-19.9 42.5-25 63.5-12.1l103-137C498.7 21.3 541.3 0 586.6 0H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H586.6zm-256 193.8L252.8 329.6c-4.1 5.5-11.3 7.8-17.9 5.6S224 326.9 224 320V280c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24v72c0 70.7 57.3 128 128 128h2.3c43.1 0 83.4-21.7 107-57.8L377.2 257.8c4.8-7.3 2.8-17.2-4.5-22.1l-20.4-13.6c-7.1-4.7-16.6-3.1-21.7 3.7z"]
};
var faFaceAstonished = {
  prefix: 'fal',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faWindow = {
  prefix: 'fal',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPlaneCircleExclamation = {
  prefix: 'fal',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faEar = {
  prefix: 'fal',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192V368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-16.4 8.2-32.2 22.5-41.4C322.8 298.1 352 248.5 352 192zm32 0c0 67.8-35.1 127.4-88.2 161.5c-4.9 3.2-7.8 8.6-7.8 14.5c0 79.5-64.5 144-144 144S0 447.5 0 368V192C0 86 86 0 192 0S384 86 384 192zm-272 0v6.3c0 10.7 5.3 20.7 14.2 26.6l8.9 5.9c15.5 10.4 24.9 27.8 24.9 46.5c0 16.6-7.4 32.3-20.1 42.9l-33.7 28c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5l33.7-28c5.4-4.5 8.6-11.2 8.6-18.3c0-8-4-15.4-10.6-19.9l-8.9-5.9C90.7 239.7 80 219.7 80 198.3V192c0-61.9 50.1-112 112-112s112 50.1 112 112v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFileLock = {
  prefix: 'fal',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M384 192H352 320 240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V192zM240 160H351.5c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16zm224 64c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H544V352H384z"]
};
var faDiagramVenn = {
  prefix: 'fal',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M224 448C118 448 32 362 32 256S118 64 224 64c21.5 0 42.1 3.5 61.4 10C228.8 114.7 192 181 192 256s36.8 141.3 93.4 182c-19.3 6.5-39.9 10-61.4 10zM415.3 240H224.7c1.4-16.7 4.9-32.8 10.3-48H405.1c5.4 15.2 8.9 31.3 10.3 48zM224.7 272H415.3c-1.4 16.7-4.9 32.8-10.3 48H234.9c-5.4-15.2-8.9-31.3-10.3-48zm25 80H390.3c-16.9 29.1-41.2 53.5-70.3 70.3c-29.1-16.9-53.5-41.2-70.3-70.3zm0-192c16.9-29.1 41.2-53.5 70.3-70.3c29.1 16.9 53.5 41.2 70.3 70.3H249.7zM224 480c34.4 0 66.9-7.7 96-21.6c29.1 13.8 61.6 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6C290.9 39.7 258.4 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480zM416 64c106 0 192 86 192 192s-86 192-192 192c-21.5 0-42.1-3.5-61.4-10C411.2 397.3 448 331 448 256s-36.8-141.3-93.4-182c19.3-6.5 39.9-10 61.4-10z"]
};
var faXRay = {
  prefix: 'fal',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M0 48c0-8.8 7.2-16 16-16H48 464h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V448h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H464 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V64H16C7.2 64 0 56.8 0 48zM64 64V448H448V64H64zM256 96c8.8 0 16 7.2 16 16v32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v53.5l45.1-17.4c7-2.7 14.4-4.1 21.9-4.1h2.2c32.5 0 58.8 26.3 58.8 58.8c0 13.2-4.4 25.9-12.5 36.3l-18.2 23.2c-12.7 16.2-32.2 25.7-52.9 25.7H195.6c-20.6 0-40.1-9.5-52.9-25.7l-18.2-23.2C116.4 356.8 112 344 112 330.8c0-32.5 26.3-58.8 58.8-58.8H173c7.5 0 14.9 1.4 21.9 4.1L240 293.5V240H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V176H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V112c0-8.8 7.2-16 16-16zM144 330.8c0 6 2 11.8 5.7 16.5l18.2 23.2c6.7 8.5 16.9 13.5 27.7 13.5H316.4c10.8 0 21-5 27.7-13.5l18.2-23.2c3.7-4.7 5.7-10.5 5.7-16.5c0-14.8-12-26.8-26.8-26.8H339c-3.6 0-7.1 .7-10.4 1.9l-55.3 21.3c-11.1 4.3-23.4 4.3-34.5 0l-55.3-21.3c-3.3-1.3-6.9-1.9-10.4-1.9h-2.1C156 304 144 316 144 330.8zM192 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faGoalNet = {
  prefix: 'fal',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", "M32 112c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112V464c0 8.8 7.2 16 16 16s16-7.2 16-16V112zm144 0c-8.8 0-16 7.2-16 16v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V320h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V128c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H384V128c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H288V128c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H192V128c0-8.8-7.2-16-16-16zm16 112h64v64H192V224zm96 0h64v64H288V224zm96 0h64v64H384V224zM192 384V320h64v64H192zm96 0V320h64v64H288zm96 0V320h64v64H384z"]
};
var faCoffinCross = {
  prefix: 'fal',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M35.6 136c-2.3 2.6-3.6 6-3.6 9.5c0 1.4 .2 2.7 .6 4L128.1 480l127.9 0 95.5-330.6c.4-1.3 .6-2.6 .6-4c0-3.5-1.3-6.9-3.6-9.5l-91-104-131 0-91 104zM11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM208 112v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H208V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V208H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSpellCheck = {
  prefix: 'fal',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M126.7 9.7C124.2 3.8 118.4 0 112 0s-12.2 3.8-14.7 9.7l-96 224c-3.5 8.1 .3 17.5 8.4 21s17.5-.3 21-8.4L54 192H170l23.3 54.3c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-96-224zM156.3 160H67.7L112 56.6 156.3 160zM256 16V128 240c0 8.8 7.2 16 16 16H376c39.8 0 72-32.2 72-72c0-31.1-19.7-57.6-47.3-67.6C410.3 104.1 416 88.7 416 72c0-39.8-32.2-72-72-72H272c-8.8 0-16 7.2-16 16zm88 96H288V32h56c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-56 32h56 32c22.1 0 40 17.9 40 40s-17.9 40-40 40H288V144zM571.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L352 473.4 251.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l208-208z"]
};
var faLocationXmark = {
  prefix: 'fal',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM116.7 116.7c6.2-6.2 16.4-6.2 22.6 0L192 169.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 192l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L192 214.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 192l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faMapMarkerTimes = faLocationXmark;
var faMapMarkerXmark = faLocationXmark;
var faCircleQuarterStroke = {
  prefix: 'fal',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M480 256C480 132.3 379.7 32 256 32V208c0 26.5-21.5 48-48 48H32c0 123.7 100.3 224 224 224s224-100.3 224-224zM224 34.3C125.9 48.3 48.3 125.9 34.3 224H208c8.8 0 16-7.2 16-16V34.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faLasso = {
  prefix: 'fal',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 320c141.4 0 256-64.5 256-144S429.4 32 288 32S32 96.5 32 176s114.6 144 256 144z"]
};
var faSlash = {
  prefix: 'fal',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1z"]
};
var faPersonToPortal = {
  prefix: 'fal',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", "M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM179.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L224.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L298 253.2c5.9 20.6 24.7 34.8 46.2 34.8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H344.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L218.3 302.4 190.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1L101.3 384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM458.5 444.2C445.6 480 433.6 480 432 480h0 0c-1.6 0-13.6 0-26.4-35.8c-9.4-26.3-16.8-66.4-19.9-124.2h-32c7.3 140.7 39.7 192 78.4 192c44.2 0 80-66.6 80-256S476.2 0 432 0c-41.6 0-75.8 59-79.6 224h32c1.8-75.3 10.1-125.3 21.2-156.2C418.4 32 430.4 32 432 32l0 0 0 0c1.6 0 13.6 0 26.4 35.8C471.1 102.9 480 162.5 480 256s-8.9 153.1-21.5 188.2z"]
};
var faPortalEnter = faPersonToPortal;
var faCalendarStar = {
  prefix: 'fal',
  iconName: 'calendar-star',
  icon: [512, 512, [], "f736", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H96c-35.3 0-64 28.7-64 64v32 32V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H384V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H160V16zM64 192H448V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zM96 96H416c17.7 0 32 14.3 32 32v32H64V128c0-17.7 14.3-32 32-32zM277.5 231.5c-8.8-17.8-34.2-17.8-43 0l-22 44.6-49.2 7.2c-19.7 2.9-27.5 27.1-13.3 40.9l35.6 34.7-8.4 49c-3.4 19.6 17.2 34.6 34.8 25.3l44-23.2 44 23.2c17.6 9.3 38.2-5.7 34.8-25.3l-8.4-49 35.6-34.7c14.2-13.9 6.4-38.1-13.3-40.9l-49.2-7.2-22-44.6zm-40.1 66.3L256 260.2l18.6 37.6 3.7 7.5 8.3 1.2 41.5 6-30 29.3-6 5.9 1.4 8.3 7.1 41.4-37.1-19.5-7.4-3.9-7.4 3.9-37.1 19.5 7.1-41.4 1.4-8.3-6-5.9-30-29.3 41.5-6 8.3-1.2 3.7-7.5z"]
};
var faComputerMouse = {
  prefix: 'fal',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M192 224H32V352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128V224H192zm192-32v16 16V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V224 208 192 160C0 71.6 71.6 0 160 0h16 16 16 16c88.4 0 160 71.6 160 160v32zM208 32V192H352V160c0-70.7-57.3-128-128-128H208zm-32 0H160C89.3 32 32 89.3 32 160v32H176V32z"]
};
var faMouse = faComputerMouse;
var faArrowRightToBracket = {
  prefix: 'fal',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM336 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c44.2 0 80-35.8 80-80l0-288c0-44.2-35.8-80-80-80l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-96 0z"]
};
var faSignIn = faArrowRightToBracket;
var faPegasus = {
  prefix: 'fal',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M333 153.3c1.1-1.5 1.9-3.3 2.5-5.2c.4-1.4 .6-2.9 .5-4.4C336.1 82 386.2 32 448 32h24 8 5.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1H432c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L202.2 291.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1H141.6c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-21.8 13.8-40.5 33.2-47.6c-4.4-9.4-8.4-19.3-11.8-29.8c-20.4 7.7-37 23.3-46 43.1C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2V192h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16H485.8 480h-8H448C377.4 0 318.7 50.8 306.4 117.8L159.9 34.1c-5-2.8-11-2.8-16 .1s-8 8.1-8 13.8c0 77.2 34.4 132.9 68.3 169c16.9 18 33.9 31.2 46.6 40c6.4 4.4 11.7 7.7 15.5 9.9c1.9 1.1 3.4 2 4.5 2.5c.5 .3 1 .5 1.3 .7l.4 .2 .1 .1 0 0 0 0s0 0 7.2-14.3l-7.2 14.3c7.9 4 17.5 .7 21.5-7.2s.8-17.5-7.1-21.5l0 0 0 0-.2-.1-.9-.5c-.8-.4-2-1.1-3.6-2c-3.2-1.8-7.8-4.7-13.5-8.6c-11.3-7.8-26.4-19.5-41.4-35.5c-25.6-27.2-50.8-66.2-57.8-118.4l142.2 81.2c3 1.7 6.4 2.4 9.6 2c2.3-.2 4.5-1 6.4-2.1s3.6-2.6 5-4.5zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faFilesMedical = {
  prefix: 'fal',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M384 384c17.7 0 32-14.3 32-32V144.8c0-.3 0-.5 0-.8H336c-17.7 0-32-14.3-32-32V32H160c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H384zm6-272L336 57.5V112h54zM96 64c0-35.3 28.7-64 64-64H304c12.8 0 25.1 5.1 34.1 14.2l96 96.8c8.9 9 13.9 21.1 13.9 33.8V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64zM16 96c8.8 0 16 7.2 16 16V384c0 53 43 96 96 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V112c0-8.8 7.2-16 16-16zm245.3 64h21.3c17.7 0 32 14.3 32 32v21.3H336c17.7 0 32 14.3 32 32v21.3c0 17.7-14.3 32-32 32H314.7V320c0 17.7-14.3 32-32 32H261.3c-17.7 0-32-14.3-32-32V298.7H208c-17.7 0-32-14.3-32-32V245.3c0-17.7 14.3-32 32-32h21.3V192c0-17.7 14.3-32 32-32zm0 32v37.3c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7l-37.3 0v21.3h37.3c8.8 0 16 7.2 16 16V320h21.3V282.7c0-8.8 7.2-16 16-16l37.3 0V245.3H298.7c-8.8 0-16-7.2-16-16l0-37.3H261.3z"]
};
var faNfcLock = {
  prefix: 'fal',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H320v32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v65.1c-11.3 1.6-22.1 4.9-32 9.6V96c0-17.7-14.3-32-32-32zm0 64v65.6c-19.8 20.2-32 47.9-32 78.4V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM96 384H320v32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm240-16c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm160 80H384V480H544V352z"]
};
var faPersonSkiLift = {
  prefix: 'fal',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", "M256 0c8.8 0 16 7.2 16 16V210.8c-1.9 .3-3.7 .6-5.6 1.1L240 218.5V16c0-8.8 7.2-16 16-16zM104.8 177.7c7.9-4 17.5-.7 21.5 7.2l42.3 84.5L274.2 243c15.1-3.8 29.8 7.7 29.8 23.3V402.8l150.7-59.7c15.3-6 25.3-20.8 25.3-37.2V304c0-8.8 7.2-16 16-16s16 7.2 16 16v1.9c0 29.5-18 56.1-45.5 66.9l-348.6 138c-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8L272 415.5v-139l-95.7 23.9c-14.6 3.6-29.7-3.3-36.4-16.7L97.7 199.2c-4-7.9-.7-17.5 7.2-21.5zM9.1 161.6c8-3.8 17.5-.5 21.3 7.5L103.3 321c10 20.9 33.5 31.6 55.9 25.5l36.5-10c8.5-2.3 17.3 2.7 19.6 11.2s-2.7 17.3-11.2 19.6l-36.5 10c-37.3 10.2-76.5-7.7-93.2-42.6L1.6 182.9c-3.8-8-.5-17.5 7.5-21.3zM128 88A24 24 0 1 0 80 88a24 24 0 1 0 48 0zM48 88a56 56 0 1 1 112 0A56 56 0 1 1 48 88z"]
};
var faSkiLift = faPersonSkiLift;
var faSquare6 = {
  prefix: 'fal',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-96 64c0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1 .8-22.6s-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9z"]
};
var faShopSlash = {
  prefix: 'fal',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", "M0 185.8C0 206.9 17.1 224 38.2 224H64V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V388.1L338.3 352H96V224h80.2l-40.5-32H80 38.2c-3.4 0-6.2-2.8-6.2-6.2c0-1 .3-2.1 .8-3l27.4-50.3L34.7 112.3 4.7 167.4C1.6 173.1 0 179.4 0 185.8zM139.6 32h376c5.9 0 11.2 3.2 14 8.3l77.7 142.4c.5 .9 .8 1.9 .8 3c0 3.4-2.8 6.2-6.2 6.2H560 342.2l40.5 32H544V351.3l32 25.3V224h25.8c21.1 0 38.2-17.1 38.2-38.2c0-6.4-1.6-12.7-4.7-18.3L557.6 25C549.2 9.6 533.1 0 515.5 0h-391c-7 0-13.8 1.5-20 4.3l35 27.7zM96 464V384H352v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faStoreAltSlash = faShopSlash;
var faWindTurbine = {
  prefix: 'fal',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M302.1 431.2c18.2 29.6 64 13 58.9-21.4L332.7 217.6 425 46.8c16.5-30.6-20.8-61.9-48-40.3L224.8 127.1 30.7 132.6c-34.8 1-43.2 48.9-10.9 61.7l180.6 71.5L240 330.3V480H144c-8.8 0-16 7.2-16 16s7.2 16 16 16H256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V382.3l30.1 49zM301 222.3l28.4 192.1L227.6 249c-3.6-5.9-9-10.4-15.5-13L31.5 164.5l194.1-5.4c6.9-.2 13.6-2.6 19-6.9L396.9 31.6 304.5 202.4c-3.3 6.1-4.5 13.1-3.5 19.9zM272 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSlidersSimple = {
  prefix: 'fal',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M80 320a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm78.4 32L496 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-337.6 0c-7.4 36.5-39.7 64-78.4 64c-44.2 0-80-35.8-80-80s35.8-80 80-80c38.7 0 71 27.5 78.4 64zM384 144a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-30.4-16C361 91.5 393.3 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-38.7 0-71-27.5-78.4-64L16 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l337.6 0z"]
};
var faGridRound = {
  prefix: 'fal',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M96 96A32 32 0 1 1 32 96a32 32 0 1 1 64 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM96 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM256 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z"]
};
var faBadgeSheriff = {
  prefix: 'fal',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", "M224 0c-35.3 0-64 28.7-64 64c0 14.7 5 28.3 13.4 39.1l-18.9 32.4-35.2 .1c-5.4-9.3-13.3-17.4-23.3-23.1C65.4 94.9 26.3 105.4 8.6 136S1.4 205.8 32 223.4c12.3 7.1 25.9 9.6 39 8.2L84.9 256 71 280.4c-13.1-1.4-26.7 1.1-39 8.2C1.4 306.2-9.1 345.4 8.6 376s56.8 41.1 87.4 23.4l-8-13.9 8 13.9c10-5.8 17.8-13.8 23.3-23.1l35.2 .1 18.9 32.4C165 419.7 160 433.3 160 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-14.7-5-28.3-13.4-39.1l18.9-32.4 35.2-.1c5.4 9.3 13.3 17.4 23.3 23.1c30.6 17.7 69.8 7.2 87.4-23.4s7.2-69.8-23.4-87.4c-12.3-7.1-25.9-9.6-39-8.2L363.1 256 377 231.6c13.1 1.4 26.7-1.1 39-8.2c30.6-17.7 41.1-56.8 23.4-87.4s-56.8-41.1-87.4-23.4c-10 5.8-17.8 13.8-23.3 23.1l-35.2-.1-18.9-32.4C283 92.3 288 78.7 288 64c0-35.3-28.7-64-64-64zM192 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 9.9-4.4 18.7-11.5 24.6c-6 5-7.5 13.6-3.6 20.3l24.9 42.8c5.7 9.8 16.2 15.8 27.5 15.9l45.4 .2c6.8 0 12.8-4.2 15.1-10.6c2.5-6.9 7.3-12.9 14.1-16.9c15.3-8.8 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-8.2 4.8-17.7 5.4-26.1 2.7c-7.2-2.4-15.1 .6-18.9 7.2l-19.7 34.5c-5.6 9.8-5.6 21.9 0 31.8L355 306.4c3.8 6.6 11.7 9.6 18.9 7.2c8.4-2.8 17.8-2.1 26.1 2.7c15.3 8.8 20.5 28.4 11.7 43.7s-28.4 20.6-43.7 11.7c-6.8-3.9-11.6-10-14.1-16.9c-2.3-6.4-8.3-10.6-15.1-10.6l-45.4 .2c-11.3 0-21.8 6.1-27.5 15.9L241 403.1c-3.9 6.7-2.4 15.3 3.6 20.3c7 5.9 11.5 14.7 11.5 24.6c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-9.9 4.4-18.7 11.5-24.6c6-5 7.5-13.6 3.6-20.3l-24.9-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-45.4-.2c-6.8 0-12.8 4.2-15.1 10.6c-2.5 6.9-7.3 12.9-14.1 16.9c-15.3 8.8-34.9 3.6-43.7-11.7s-3.6-34.9 11.7-43.7c8.2-4.7 17.7-5.4 26.1-2.7c7.2 2.4 15.1-.6 18.9-7.2l19.7-34.5c5.6-9.8 5.6-21.9 0-31.8L93 205.6c-3.8-6.6-11.7-9.6-18.9-7.2c-8.4 2.8-17.8 2.1-26.1-2.7c-15.3-8.8-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c6.8 3.9 11.6 10 14.1 16.9c2.3 6.4 8.3 10.6 15.1 10.6l45.4-.2c11.3 0 21.8-6.1 27.5-15.9l-13.8-8.1 13.8 8.1L207 108.9c3.9-6.7 2.4-15.3-3.6-20.3C196.4 82.7 192 73.9 192 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
var faServer = {
  prefix: 'fal',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M64 64C46.3 64 32 78.3 32 96v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 320c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H64zM0 352c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352zm304 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faVirusCovidSlash = {
  prefix: 'fal',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", "M503.3 272H544v24c0 8.8 7.2 16 16 16s16-7.2 16-16V216c0-8.8-7.2-16-16-16s-16 7.2-16 16v24H503.3c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 0 0 17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L472.7 46.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17 0 0-28.8 28.8C410.1 91.4 374.8 76 336 72.7V32l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H280c-8.8 0-16 7.2-16 16s7.2 16 16 16h24V72.7c-29 2.5-56.2 11.7-79.8 26.2l27.2 21.5C272 109.9 295.3 104 320 104c83.9 0 152 68.1 152 152c0 12.1-1.4 23.9-4.1 35.2l27.2 21.5c4.2-13 7-26.6 8.2-40.7zM168 256c0-12.1 1.4-23.9 4.1-35.2l-27.2-21.5c-4.2 13-7 26.6-8.2 40.7H96l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h40.7c3.3 38.8 18.7 74.1 42.4 102.3l-28.8 28.8 0 0-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17 0 0 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480H280c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V439.3c29-2.5 56.2-11.8 79.8-26.2l-27.2-21.5C368 402.1 344.7 408 320 408c-83.9 0-152-68.1-152-152zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faIntersection = {
  prefix: 'fal',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M16 480c8.8 0 16-7.2 16-16V224c0-88.4 71.6-160 160-160s160 71.6 160 160V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-106-86-192-192-192S0 118 0 224V464c0 8.8 7.2 16 16 16z"]
};
var faShopLock = {
  prefix: 'fal',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 12.4-5.9 23.3-14.9 30.3c-5.4-9.3-12.1-17.8-19.8-25.2c1.6-1.1 2.7-3 2.7-5.2c0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3h-391c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5 .9-.8 1.9-.8 3c0 3.4 2.8 6.2 6.2 6.2H80 449.6c-9.4 9.2-17.1 20-22.8 32H96V352H352V272c0-8.8 7.2-16 16-16s16 7.2 16 16v79.6l0 .4V464.3c-.2 26.4-21.6 47.7-48 47.7H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zM96 464c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V384H96v80zM528 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H608V352H448z"]
};
var faFamily = {
  prefix: 'fal',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320h59.6c-.7 5.2-1.1 10.6-1.1 16v16H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8 .9 20.2 2.6c-1.7 6.9-2.6 14-2.6 21.4c0 3.9 .3 7.8 .8 11.6c-5.7-2.4-11.9-3.6-18.4-3.6H105.6zM416 384H366.4c1-5.2 1.6-10.5 1.6-16V352H469.6L430.5 215.2C426.6 201.5 414 192 399.7 192H368.3c-11.5 0-21.8 6.1-27.5 15.6c2.1-7.5 3.2-15.4 3.2-23.6c0-6.3-.7-12.5-1.9-18.4c8.1-3.6 17-5.6 26.2-5.6h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V336c0-26.5-21.5-48-48-48zM208 413.3c-18.6-6.6-32-24.4-32-45.3V336c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V413.3z"]
};
var faHourglassStart = {
  prefix: 'fal',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M0 496c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V435.3c0-31.6-10.4-62.4-29.6-87.5L252.1 256l70.2-91.9C341.6 139 352 108.3 352 76.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 0 0 7.2 0 16s7.2 16 16 16H32V76.7c0 31.6 10.4 62.4 29.6 87.5L131.9 256 61.6 347.9C42.4 373 32 403.7 32 435.3L32 480H16c-8.8 0-16 7.2-16 16zm64-16l0-44.7c0-24.6 8.1-48.5 23-68l77.7-101.6c4.4-5.7 4.4-13.7 0-19.4L87 144.7c-14.9-19.5-23-43.4-23-68L64 32H320V76.7c0 24.6-8.1 48.5-23 68L219.3 246.3c-4.4 5.7-4.4 13.7 0 19.4L297 367.3c14.9 19.5 23 43.4 23 68V480H64zM205 201.3l80-112c3.5-4.9 3.9-11.3 1.2-16.6S278 64 272 64H192 112c-6 0-11.5 3.3-14.2 8.7S95.5 84.4 99 89.3l80 112c3 4.2 7.9 6.7 13 6.7s10-2.5 13-6.7zM192 96h48.9L192 164.5 143.1 96H192z"]
};
var faHourglass1 = faHourglassStart;
var faUserHairBuns = {
  prefix: 'fal',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M314.5 96h-32c-12.7 0-24.9-5.1-33.9-14.1L235.3 68.7c-6.2-6.2-16.4-6.2-22.6 0L199.4 81.9c-9 9-21.2 14.1-33.9 14.1h-32c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zm5.5 32v16c0 53-43 96-96 96s-96-43-96-96V128l37.5 0c21.2 0 41.6-8.4 56.6-23.4l1.9-1.9 1.9 1.9c15 15 35.4 23.4 56.6 23.4H320zM224 272c46.7 0 87.5-25 109.9-62.3c8.7 8.8 20.8 14.3 34.1 14.3c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48c-10.6 0-20.4 3.4-28.3 9.2C319.2 29.9 275.1 0 224 0s-95.2 29.9-115.7 73.2C100.4 67.4 90.6 64 80 64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48c13.4 0 25.4-5.5 34.1-14.3C136.5 247 177.3 272 224 272zm128-96V144 128 112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16zM168 336H280c75.1 0 136 60.9 136 136v8H32v-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168zM96 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16 16z"]
};
var faBlenderPhone = {
  prefix: 'fal',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M226.8 32L535 32 519 96H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H511l-16 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H487L455 352H253.4L226.8 32zM487.1 355.4L566.1 39.8C571.1 19.6 555.8 0 535 0H226.8c-18.7 0-33.4 16-31.9 34.7l26.6 319.5c-35.3 8.3-61.5 40-61.5 77.9v32c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V432c0-36.1-24-66.7-56.9-76.6zM240 384H464c26.5 0 48 21.5 48 48v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V432c0-26.5 21.5-48 48-48zm136 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM120.1 116.7L95 114.2c-15.5-1.5-29.9 8.4-34 23.5c-9.6 35.5-9.6 73 0 108.6c4.1 15.1 18.5 25 34 23.5l25.1-2.5 21.8 53.5L96.3 350C10.6 261.5 10.6 122.5 96.3 34l45.6 29.2-21.8 53.5zm45-76.6L108.4 3.8C99-2.2 86-.9 78.1 6.8C-26 109.1-26 274.9 78.1 377.2c7.9 7.8 20.9 9.1 30.3 3.1l56.7-36.4c9.6-6.1 13.4-17.9 9.2-28.3l-26.9-66.1c-3.9-9.7-13.9-15.6-24.5-14.6l-31.1 3c-8.2-30-8.2-61.8 0-91.8l31 3c10.6 1 20.5-4.9 24.5-14.6l26.9-66.1c4.2-10.4 .4-22.2-9.2-28.3z"]
};
var faHourglassClock = {
  prefix: 'fal',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16H32l0-44.7c0-31.6 10.4-62.4 29.6-87.5L131.9 256 61.6 164.1C42.4 139 32 108.3 32 76.7V32H16C7.2 32 0 24.8 0 16S7.2 0 16 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V76.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l23.6 30.9c-5.7 11-10.3 22.7-13.6 34.9l-42.8-56c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64l0 44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68L64 480H296.2c10 12.1 21.7 22.9 34.6 32H16zm176-96h70.6c3.2 11.2 7.4 21.9 12.6 32H192 112c-6 0-11.5-3.4-14.2-8.7S95.5 427.6 99 422.7l80-112c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3L143.1 416H192zm0-208c-4.9 0-9.5-2.2-12.5-6l-64-80c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1h64 64c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-64 80c-3 3.8-7.6 6-12.5 6zm-30.7-80L192 166.4 222.7 128H192 161.3zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faPersonSeatReclined = {
  prefix: 'fal',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", "M160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM63.8 141.4L98.4 349.2c6.4 38.6 39.8 66.8 78.9 66.8H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H177.3c-54.8 0-101.5-39.6-110.5-93.6L32.2 146.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2zm120.4 98.5l11.1 66.7c1.3 7.7 8 13.4 15.8 13.4h42l-12.9-77.2-.1-.4-1.9-11.6c-2.2-13.2-13.6-22.9-27-22.9c-16.9 0-29.8 15.2-27 31.9zm27-63.9c28.5 0 52.9 20.2 58.3 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H274.9l10.7 64h33.2c26.7 0 50.6 16.5 59.9 41.5L410 445l50.2-12.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-64 16c-7.9 2-16-2.3-18.9-9.9l-36.3-96.9c-4.7-12.5-16.6-20.8-30-20.8H272.3c-.2 0-.4 0-.6 0H211.1c-23.5 0-43.5-17-47.3-40.1l-11.1-66.7c-6-36.2 21.9-69.2 58.6-69.2z"]
};
var faPaperPlaneTop = {
  prefix: 'fal',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3zM120 272L32 448 442.7 272H120zm322.7-32L32 64l88 176H442.7z"]
};
var faPaperPlaneAlt = faPaperPlaneTop;
var faSend = faPaperPlaneTop;
var faMessageArrowUp = {
  prefix: 'fal',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM272 304V150.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 150.6V304c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faCommentAltArrowUp = faMessageArrowUp;
var faLightbulbExclamation = {
  prefix: 'fal',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7V432zM192 96c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faLayerMinus = {
  prefix: 'fal',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M408 64H520c8.8 0 16 7.2 16 16s-7.2 16-16 16H408c-8.8 0-16-7.2-16-16s7.2-16 16-16zM266.2 132.7c6.9-3.1 14.3-4.7 21.8-4.7s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l217.4-97.5zM288 160c-3 0-6 .6-8.8 1.9L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1c-2.8-1.2-5.7-1.9-8.8-1.9zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9z"]
};
var faLayerGroupMinus = faLayerMinus;
var faChartPieSimpleCircleCurrency = {
  prefix: 'fal',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M288 224H394.8c-12.9 9.1-24.5 19.9-34.6 32H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5V224zm-32 64h83.2c-5.2 10.1-9.4 20.8-12.6 32H224c-17.7 0-32-14.3-32-32V69.6C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V256v32h32zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm25.4 169.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-9.3 9.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l9.3-9.3c-13.2-21.6-13.2-49.1 0-70.7l-9.3-9.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l9.3 9.3c21.6-13.2 49.1-13.2 70.7 0l9.3-9.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-9.3 9.3c13.2 21.6 13.2 49.1 0 70.7l9.3 9.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-9.3-9.3z"]
};
var faCircleE = {
  prefix: 'fal',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32v96 96c0 17.7 14.3 32 32 32H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V272H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V160H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"]
};
var faBuildingWheat = {
  prefix: 'fal',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M320 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H320zM192 384c17.7 0 32 14.3 32 32v64H160V416c0-17.7 14.3-32 32-32zM64 512h64 32 64 32 64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zM88 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88zm8 64V128h32v32H96zm128-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm32 8h32v32H256V128zM88 224c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88zm8 64V256h32v32H96zm128-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm32 8h32v32H256V256zm368-64H608c-33.4 0-62.8 17-80 42.9C510.8 209 481.4 192 448 192H432c-8.8 0-16 7.2-16 16v16c0 24.6 9.2 47 24.4 64H432c-8.8 0-16 7.2-16 16v16c0 24.6 9.2 47 24.4 64H432c-8.8 0-16 7.2-16 16v16c0 53 43 96 96 96h16 16c53 0 96-43 96-96V400c0-8.8-7.2-16-16-16h-8.4c15.2-17 24.4-39.4 24.4-64V304c0-8.8-7.2-16-16-16h-8.4c15.2-17 24.4-39.4 24.4-64V208c0-8.8-7.2-16-16-16zm-80 96c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64v0zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm16 32h8.4c-3.1 3.4-5.9 7.1-8.4 10.9c-2.6-3.8-5.4-7.5-8.4-10.9H528zm0 106.9c-2.6-3.8-5.4-7.5-8.4-10.9H528h8.4c-3.1 3.4-5.9 7.1-8.4 10.9zM544 384v0c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm32 96c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64v0zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zM528 32c-8.8 0-16 7.2-16 16V160c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm64 48c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM448 144c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"]
};
var faGaugeMax = {
  prefix: 'fal',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-35.3 28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faTachometerAltFastest = faGaugeMax;
var faPersonBreastfeeding = {
  prefix: 'fal',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M176 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM103.3 273.9c20.8-31.2 55.7-49.9 93.2-49.9h68.1c30.9 0 60.5 12.8 81.6 35.3l55.5 59.1c14.6 15.6 14.4 39.9-.4 55.2l-76.8 79.2c-6.2 6.3-6 16.5 .3 22.6s16.5 6 22.6-.3l76.8-79.2c26.8-27.6 27.1-71.4 .8-99.4l-55.5-59.1c-27.2-29-65.2-45.4-105-45.4H196.5c-48.1 0-93.1 24.1-119.8 64.1L23 336.7C-1.5 373.4 12.6 423.4 52.7 442l148.6 68.6c8 3.7 17.5 .2 21.2-7.8s.2-17.5-7.8-21.2L66.1 412.9C43.8 402.6 36 374.8 49.6 354.4l53.7-80.5zM192 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.4c0 6 1.7 11.9 4.9 17c26.3 42.1 72.4 67.6 122 67.6H288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-1.1c-38.6 0-74.4-19.9-94.9-52.6V320zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faApostrophe = {
  prefix: 'fal',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M78.7 320.1c-8.8 .7-15.3 8.5-14.6 17.3s8.5 15.3 17.3 14.6l8-.7c58-4.8 102.7-53.4 102.7-111.6V160 128 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64c11.7 0 22.6-3.1 32-8.6v24.2c0 41.6-31.9 76.3-73.4 79.7l-8 .7zM160 160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32 32z"]
};
var faFireHydrant = {
  prefix: 'fal',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M192 0c8.8 0 16 7.2 16 16V33c57.9 7.2 103.8 53.1 111 111h17c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H65C72.2 86.1 118.1 40.2 176 33V16c0-8.8 7.2-16 16-16zm0 64c-47.6 0-87.1 34.6-94.7 80H286.7c-7.6-45.4-47.1-80-94.7-80zM32 496c0-8.8 7.2-16 16-16H64V400H48c-26.5 0-48-21.5-48-48V288c0-26.5 21.5-48 48-48H64V208H96v48V384v96H288V384 256 208h32v32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H320v80h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H304 80 48c-8.8 0-16-7.2-16-16zM320 368h16c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H320v96zM64 368V272H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H64zm160-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faRightToBracket = {
  prefix: 'fal',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M319.2 257.8c.5-.5 .8-1.1 .8-1.8s-.3-1.4-.8-1.8L187.3 129.8c-1.2-1.2-2.9-1.8-4.6-1.8c-3.7 0-6.7 3-6.7 6.7l0 57.3c0 8.8-7.2 16-16 16L40 208c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l120 0c8.8 0 16 7.2 16 16l0 57.3c0 3.7 3 6.7 6.7 6.7c1.7 0 3.3-.6 4.6-1.8L319.2 257.8zM352 256c0 9.5-3.9 18.6-10.8 25.1L209.2 405.5c-7.2 6.8-16.7 10.5-26.5 10.5c-21.4 0-38.7-17.3-38.7-38.7l0-41.3L40 336c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40l104 0 0-41.3c0-21.4 17.3-38.7 38.7-38.7c9.9 0 19.3 3.8 26.5 10.5L341.2 230.9c6.9 6.5 10.8 15.6 10.8 25.1zM336 448l96 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c44.2 0 80 35.8 80 80l0 288c0 44.2-35.8 80-80 80l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSignInAlt = faRightToBracket;
var faVideoPlus = {
  prefix: 'fal',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V336.8 175.2 128c0-35.3-28.7-64-64-64H64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2V377.8c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9v36.5zM208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V176z"]
};
var faSquareRight = {
  prefix: 'fal',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM368 256c0 9.2-3.5 18-9.7 24.7l-84 91c-7.2 7.8-17.4 12.3-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3l0-25.7-80 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l80 0 0-25.7c0-21.1 17.1-38.3 38.3-38.3c10.7 0 20.9 4.5 28.1 12.3l84 91c6.2 6.7 9.7 15.6 9.7 24.7zm-33.2-3l-84-91c-1.2-1.3-2.9-2-4.6-2c-3.5 0-6.3 2.8-6.3 6.3l0 41.7c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 41.7c0 3.5 2.8 6.3 6.3 6.3c1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3s-.4-2.2-1.2-3z"]
};
var faArrowAltSquareRight = faSquareRight;
var faCommentSmile = {
  prefix: 'fal',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM155.9 284.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 334.5 215.7 352 256 352s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3C314.5 306.6 286.8 320 256 320s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z"]
};
var faVenus = {
  prefix: 'fal',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V416H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V351.3z"]
};
var faPassport = {
  prefix: 'fal',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 400c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm33.3-192h39.1c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 288l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32H279.6c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 96l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8H129.3zM224 320a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faInboxIn = {
  prefix: 'fal',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4V16zM48 352h66.3c6.1 0 11.6 3.4 14.3 8.8L143 389.5c8.1 16.3 24.8 26.5 42.9 26.5H326.1c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3L369 389.5l14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8H464c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm306.7-5.5l-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8H185.9c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H397.7c-18.2 0-34.8 10.3-42.9 26.5z"]
};
var faInboxArrowDown = faInboxIn;
var faHeartPulse = {
  prefix: 'fal',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M244 130.6c3 3.4 7.4 5.4 12 5.4s8.9-2 12-5.4l12-13.5 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8c53.3 9.7 92 56.1 92 110.3v3.5c0 23.8-7.3 46.7-20.5 66c-1.1-.2-2.3-.4-3.5-.4H371.8c-6.1 0-11.6-3.4-14.3-8.8l-23.2-46.3c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-48.9 97.9L198.6 169.4c-2.6-5.8-8.4-9.5-14.8-9.4s-12.1 4-14.5 9.8l-31.8 76.3c-2.5 6-8.3 9.8-14.8 9.8H56c-1.2 0-2.4 .1-3.5 .4C39.3 237.1 32 214.2 32 190.4v-3.5c0-54.2 38.7-100.6 92-110.3c38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 12 13.5zM429.6 288l0 0h45.8l.1-.1C498.9 261 512 226.4 512 190.4v-3.5c0-69.6-49.8-129.3-118.3-141.8c-40.9-7.4-82.6 3.2-114.7 28.4c-1.8 1.4-3.6 2.9-5.4 4.5c-4.7 4.1-9.1 8.4-13.3 13.1L256 95.9l-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6C201 48.4 159.3 37.7 118.3 45.1C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5l.1 .1H82.4l0 0h40.2c19.4 0 36.9-11.7 44.3-29.5l17.6-42.2 56.8 126.3c2.5 5.6 8.1 9.3 14.3 9.4s11.9-3.3 14.6-8.8L320 243.8l8.8 17.7c8.1 16.3 24.8 26.5 42.9 26.5h57.8zM69.8 320L231.2 470.3c6.7 6.3 15.6 9.7 24.8 9.7c8 0 15.8-2.7 22.1-7.5c.9-.7 1.8-1.4 2.6-2.2L442.2 320h-47L259 446.8c-.8 .7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L116.8 320h-47z"]
};
var faHeartbeat = faHeartPulse;
var faCircle8 = {
  prefix: 'fal',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 128c37.6 0 68 30.4 68 68c0 20.2-8.8 38.4-22.9 50.9C331.9 260.7 344 282.9 344 308c0 42-34 76-76 76H244c-42 0-76-34-76-76c0-25.1 12.1-47.3 30.9-61.1c-14-12.5-22.9-30.6-22.9-50.9c0-37.6 30.4-68 68-68h24zM244 232s0 0 0 0h24c19.9 0 36-16.1 36-36s-16.1-36-36-36H244c-19.9 0-36 16.1-36 36s16.1 36 36 36zm24 32H244c-24.3 0-44 19.7-44 44s19.7 44 44 44h24c24.3 0 44-19.7 44-44s-19.7-44-44-44z"]
};
var faCloudsMoon = {
  prefix: 'fal',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", "M384 160c0-57.7 38-106.5 90.3-122.5c-21.2 25.7-33.9 58.8-33.9 94.8c0 72.3 51.4 132.7 119.7 146.1c-14.9 6.2-31.3 9.6-48.5 9.6c-19.9 0-38.7-4.6-55.5-12.7c2.5 6.8 4.5 13.8 5.8 21.1c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160c0 11.5 1.2 22.7 3.5 33.4c12.9 2 25.2 5.9 36.6 11.4c-5.2-14-8-29.1-8-44.8zm-48.1 96c35.3 0 64 28.7 64 64c0 4.4-.4 8.7-1.3 12.8c-1 4.8 .3 9.7 3.4 13.4s7.7 5.8 12.6 5.8c.2 0 .5 0 .7 0c.2 0 .4 0 .6 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-.8 0-1.6 0-2.3 0c-.1 0-.2 0-.3 0c-.1 0-.2 0-.2 0H146.3l-.2 0-.3 0c-.6 0-1.2 0-1.8 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l.2 0 0 0 8.3 0c5.7 0 11-3 13.9-8s2.9-11.1 0-16c-4.1-7-6.4-15.2-6.4-24c0-26.5 21.5-48 48-48c15.7 0 29.6 7.5 38.4 19.2c3.6 4.8 9.7 7.2 15.7 6.1s10.8-5.4 12.5-11.3c7.8-26.6 32.4-46 61.4-46zm96 64c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4c-13-9.1-28.7-14.4-45.8-14.4c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 432c0 44.2 35.8 80 80 80c.9 0 1.8 0 2.7 0H412.7c1.1 0 2.1 .1 3.2 .1c53 0 96-43 96-96c0-47.6-34.6-87-80-94.7l0-1.3zM320 192.1h0c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72l0 0h34.8c5.7-12 13.4-22.8 22.8-32H73.5c-.5 0-.9 0-1.4 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c1.8 0 3.6 .1 5.3 .3c16.8 2.2 32.3-9 35.6-25.6c4.3-22.1 23.8-38.7 47.1-38.7c20.4 0 38 12.8 44.9 30.9c6.2 16.2 24.1 24.6 40.5 18.8c3.3-1.1 6.8-1.8 10.6-1.8c17.7 0 32 14.3 32 32c0 .3 0 .6 0 .9c0 2.9-.3 5.8-.7 8.6c10.3-4.2 21.3-7.2 32.7-8.6l0-.9z"]
};
var faClockTenThirty = {
  prefix: 'fal',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256c0-5.3-2.7-10.3-7.1-13.3l-96-64c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2L240 264.6V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faPeopleCarryBox = {
  prefix: 'fal',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", "M136 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 136 0zM67.8 343.4l25.9 20.3L30.6 502.6c-3.7 8-13.1 11.6-21.2 7.9s-11.6-13.1-7.9-21.2l66.4-146zM96 193.2v87c0 5 2.3 9.7 6.2 12.7L128 312.7V179.4c-4.5-2.2-9.6-3.4-14.8-3.4c-9.5 0-17.2 7.7-17.2 17.2zm87.8 82.1L160 227.8V337.3l29 22.3c6.1 4.7 10.4 11.5 11.9 19.1l22.8 114.1c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6L169.5 385 82.7 318.3c-11.8-9.1-18.7-23.1-18.7-38v-87C64 166 86 144 113.2 144c24.9 0 47.7 14.1 58.9 36.4L212.4 261l11.6 7.7V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V268.8l11.6-7.7 40.3-80.7c11.1-22.3 33.9-36.4 58.9-36.4c27.2 0 49.2 22 49.2 49.2v87c0 14.9-6.9 29-18.7 38L470.5 385 447.7 499.1c-1.7 8.7-10.2 14.3-18.8 12.6s-14.3-10.2-12.6-18.8l22.8-114.1c1.5-7.6 5.7-14.4 11.9-19.1l29-22.3V227.8l-23.8 47.6c-2.5 5-6.2 9.2-10.9 12.3l-44.5 29.6c-3.7 2.5-8.1 3.2-12.2 2.3c-1.5 .2-3.1 .3-4.7 .3H256c-1.6 0-3.2-.1-4.7-.3c-4.1 .9-8.4 .1-12.2-2.3l-44.5-29.6c-4.6-3.1-8.4-7.3-10.9-12.3zM504 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 504 0zm68.2 343.4l66.4 146c3.7 8 .1 17.5-7.9 21.2s-17.5 .1-21.2-7.9L546.3 363.7l25.9-20.3zM544 193.2c0-9.5-7.7-17.2-17.2-17.2c-5.2 0-10.3 1.2-14.8 3.4V312.7l25.8-19.8c3.9-3 6.2-7.7 6.2-12.7v-87zM256 160V288H384V160H256z"]
};
var faPeopleCarry = faPeopleCarryBox;
var faFolderUser = {
  prefix: 'fal',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM256 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64h64c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80H224c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z"]
};
var faTrashCanXmark = {
  prefix: 'fal',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm84.7 116.7c6.2-6.2 16.4-6.2 22.6 0L224 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTemperatureHigh = {
  prefix: 'fal',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faMicrochip = {
  prefix: 'fal',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128c-35.3 0-64 28.7-64 64v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v16c0 35.3 28.7 64 64 64h16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h16c35.3 0 64-28.7 64-64V368h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V272h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V176h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V128c0-35.3-28.7-64-64-64H368V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H272V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H176V16zM416 128V384c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32zm-256 0c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H160zm192 32V352H160V160H352z"]
};
var faLeftLongToLine = {
  prefix: 'fal',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80zM320 216l272 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-272 0c-17.7 0-32 14.3-32 32l0 49.3c0 3.7-3 6.7-6.7 6.7c-1.9 0-3.7-.8-5-2.2L163.8 256 276.3 130.2c1.3-1.4 3.1-2.2 5-2.2c3.7 0 6.7 3 6.7 6.7l0 49.3c0 17.7 14.3 32 32 32zM128 256c0 5.2 1.9 10.1 5.3 14L252.5 403.1c7.3 8.2 17.8 12.9 28.8 12.9c21.4 0 38.7-17.3 38.7-38.7l0-17.3 0-32 32 0 240 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-240 0-32 0 0-32 0-17.3c0-21.4-17.3-38.7-38.7-38.7c-11 0-21.5 4.7-28.8 12.9L133.3 242c-3.4 3.8-5.3 8.8-5.3 14z"]
};
var faCrown = {
  prefix: 'fal',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40l.7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106zM117.9 421.7L78.8 206.4l62.3 49.9c31.8 25.5 79 15.1 97.2-21.4L288 135.6l49.7 99.4c18.2 36.4 65.4 46.8 97.2 21.4l62.3-49.9L458.1 421.7c-2.8 15.2-16 26.3-31.5 26.3H149.4c-15.5 0-28.7-11.1-31.5-26.3z"]
};
var faWeightHanging = {
  prefix: 'fal',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M208 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 48c10-13.4 16-30 16-48c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 18 6 34.6 16 48H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H320zm-64 32H392c7.3 0 13.7 5 15.5 12.1l72 288c1.2 4.8 .1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2H48c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l72-288c1.8-7.1 8.2-12.1 15.5-12.1H256z"]
};
var faXmarksLines = {
  prefix: 'fal',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M16 32H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48s7.2-16 16-16zm0 416H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM228.7 164.7c6.2-6.2 16.4-6.2 22.6 0L320 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 256l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6zM118.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L96 278.6 27.3 347.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L73.4 256 4.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L118.6 256zm334.1-91.3c6.2-6.2 16.4-6.2 22.6 0L544 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L566.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L544 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 256l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFilePrescription = {
  prefix: 'fal',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 224c-8.8 0-16 7.2-16 16v80 64c0 8.8 7.2 16 16 16s16-7.2 16-16V336h41.4l48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 406.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 384l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 361.4l-31.2-31.2C227.3 321.1 240 302 240 280c0-30.9-25.1-56-56-56H112zm72 80h-8H128V256h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faCalendarRange = {
  prefix: 'fal',
  iconName: 'calendar-range',
  icon: [512, 512, [], "e0d6", "M144 0c8.8 0 16 7.2 16 16V64H352V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM448 192H64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192zM416 96H96c-17.7 0-32 14.3-32 32v32H448V128c0-17.7-14.3-32-32-32zm0 176c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16H400c8.8 0 16 7.2 16 16zM272 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16zM128 272a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faFlowerDaffodil = {
  prefix: 'fal',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", "M200 0c-48.6 0-88 39.4-88 88c0 21.3 7.6 40.8 20.1 56c-12.6 15.2-20.1 34.7-20.1 56c0 48.6 39.4 88 88 88c14.4 0 28-3.5 40-9.6V396.6C200.8 331.5 129.5 288 48 288H28c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512h44 16 16 44c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28H464c-81.5 0-152.8 43.5-192 108.6V278.4c12 6.1 25.6 9.6 40 9.6c48.6 0 88-39.4 88-88c0-21.3-7.6-40.8-20.1-56c12.6-15.2 20.1-34.7 20.1-56c0-48.6-39.4-88-88-88c-21.3 0-40.8 7.6-56 20.1C240.8 7.6 221.3 0 200 0zM144 88c0-30.9 25.1-56 56-56c17.6 0 33.3 8.1 43.6 20.8c3 3.8 7.6 5.9 12.4 5.9s9.4-2.2 12.4-5.9C278.7 40.1 294.4 32 312 32c30.9 0 56 25.1 56 56c0 17.6-8.1 33.3-20.8 43.6c-3.8 3-5.9 7.6-5.9 12.4s2.2 9.4 5.9 12.4c12.7 10.3 20.8 26 20.8 43.6c0 30.9-25.1 56-56 56c-17.6 0-33.3-8.1-43.6-20.8c-3-3.8-7.6-5.9-12.4-5.9s-9.4 2.2-12.4 5.9c-10.3 12.7-26 20.8-43.6 20.8c-30.9 0-56-25.1-56-56c0-17.6 8.1-33.3 20.8-43.6c3.8-3 5.9-7.6 5.9-12.4s-2.2-9.4-5.9-12.4C152.1 121.3 144 105.6 144 88zM32 320H48c95.1 0 174.1 69.2 189.3 160H196c-89.2 0-161.8-71.3-164-160zM480 320c-2.1 88.7-74.7 160-164 160H274.7c15.2-90.8 94.2-160 189.3-160h16zM288 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHandBackPointUp = {
  prefix: 'fal',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M136 0C105.1 0 80 25.1 80 56V256.6c-3.2 2-6.4 4.2-9.5 6.5L48 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H304c61.9 0 112-50.1 112-112v-8V304c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-8.5 0-16.6 1.7-24 4.7V56c0-30.9-25.1-56-56-56zM112 56c0-13.3 10.7-24 24-24s24 10.7 24 24V213.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3c15.6 0 28.6 11.2 31.4 25.9c1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32v88 8c0 44.2-35.8 80-80 80H168.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C70.6 442.6 48 404.7 48 363.5V344c0-15.1 7.1-29.3 19.2-38.4L80 296v48c0 8.8 7.2 16 16 16s16-7.2 16-16V265.7 264 56z"]
};
var faWeightScale = {
  prefix: 'fal',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", "M112 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm320 0c0-28.8-6.9-56-19.2-80H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H99.2C86.9 120 80 147.2 80 176c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM320 224c0-20.6-9.7-39-24.9-50.7l23.6-55c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4l-23.6 55c-3.2-.5-6.4-.7-9.7-.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faWeight = faWeightScale;
var faArrowUpToArc = {
  prefix: 'fal',
  iconName: 'arrow-up-to-arc',
  icon: [512, 512, [], "e617", "M256 32c123.7 0 224 100.3 224 224c0 8.8 7.2 16 16 16s16-7.2 16-16C512 114.6 397.4 0 256 0S0 114.6 0 256c0 8.8 7.2 16 16 16s16-7.2 16-16C32 132.3 132.3 32 256 32zM396 309.4l-128-144c-3-3.4-7.4-5.4-12-5.4s-8.9 2-12 5.4l-128 144c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3L240 218.1 240 496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-277.9L372 330.6c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6z"]
};
var faStarExclamation = {
  prefix: 'fal',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M202.4 186.5L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L150.2 473.2l122.6-65.5c9.4-5 20.7-5 30.2 0l122.6 65.5L402.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L373.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L287.9 42.3 226.5 168.8c-4.6 9.5-13.6 16.1-24.1 17.7zM450.2 507.4c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5zM288 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM264 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBooks = {
  prefix: 'fal',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", "M128 416v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416h96zm-16 96c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V416 400 384 193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C400 9.9 374.6-5.2 349.9 1.6L290.3 18.1c-3.5 1-6.8 2.3-9.9 4C271.9 8.8 257 0 240 0H176c-12.3 0-23.5 4.6-32 12.2C135.5 4.6 124.3 0 112 0H48C21.5 0 0 21.5 0 48V96v16 16V384v16 16 48c0 26.5 21.5 48 48 48h64zM288 64.8V63.5c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L288.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6c0 0 0 0 0 0V96H160V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64.2zM176 480c-8.8 0-16-7.2-16-16V416h96v48c0 8.8-7.2 16-16 16H176zM128 128V384H32V128h96zm0-80V96H32V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zM256 384H160V128h96V384zM397.7 128.7l59.8 230.5-87.3 24.2L310.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2z"]
};
var faUserGroup = {
  prefix: 'fal',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zm431 208c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320H417.3c-4.4 0-8.8 .2-13.2 .5c11.3 9.4 21.6 19.9 30.7 31.5h43.9c71 0 128.6 57.2 129.3 128H480c0 .8 0 1.5 0 2.3c0 10.8-2.8 20.9-7.6 29.7H609.3zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c5.2 9.8 9.3 20.3 12.4 31.2C392.3 71.9 411.2 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-25.2 0-47.6-11.6-62.3-29.8c-4.7 10.3-10.4 19.9-17 28.9C373 243.4 401 256 432 256z"]
};
var faUserFriends = faUserGroup;
var faArrowUpAZ = {
  prefix: 'fal',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L339.5 454c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H385.3L492.5 314c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H352zM416 32c-6.1 0-11.6 3.4-14.3 8.8L337.8 168.6c-.1 .2-.2 .4-.3 .6l-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L361.9 192H470.1l11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7c-.1-.2-.2-.4-.3-.6L430.3 40.8c-2.7-5.4-8.2-8.8-14.3-8.8zM377.9 160L416 83.8 454.1 160H377.9z"]
};
var faSortAlphaUp = faArrowUpAZ;
var faLayerPlus = {
  prefix: 'fal',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M480 24c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H408c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v40c0 8.8 7.2 16 16 16s16-7.2 16-16V96h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V24zM288 128c-7.5 0-15 1.6-21.8 4.7L48.8 230.1C38.6 234.7 32 244.8 32 256s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9L309.8 132.7c-6.9-3.1-14.3-4.7-21.8-4.7zm-8.8 33.9c2.8-1.2 5.7-1.9 8.8-1.9s6 .6 8.8 1.9l210 94.1-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 256l210-94.1zM94.7 337.5L48.8 358.1C38.6 362.7 32 372.8 32 384s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9l-45.9-20.6-39.1 17.5L506.7 384l-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 384l64.5-28.9L94.7 337.5z"]
};
var faLayerGroupPlus = faLayerPlus;
var faPlayPause = {
  prefix: 'fal',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", "M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM288 256L96 416 96 96 288 256zM116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z"]
};
var faBlockQuestion = {
  prefix: 'fal',
  iconName: 'block-question',
  icon: [448, 512, [], "e3dd", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM88 368a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136.7 177.8c6.5-24.6 28.7-41.8 54.2-41.8H248c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 276.3V296c0 8.8-7.2 16-16 16s-16-7.2-16-16V266.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H190.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSnooze = {
  prefix: 'fal',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M176 32c-8.8 0-16-7.2-16-16s7.2-16 16-16H304c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L214.6 128H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L265.4 32H176zM0 240c0-8.8 7.2-16 16-16H208c6.1 0 11.6 3.4 14.3 8.8s2.1 11.9-1.5 16.8L48 480H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8L176 256H16c-8.8 0-16-7.2-16-16zm304-16H432c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L337.3 384H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L398.7 256H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faZzz = faSnooze;
var faScannerImage = {
  prefix: 'fal',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5L492.2 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V392 352v-8.4c0-30.3-17.1-58-44.2-71.6L55.2 33.7zM544 352v40 24c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32zM104 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTvRetro = {
  prefix: 'fal',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M154.4 3.9c-6.7-5.8-16.8-5-22.6 1.7s-5 16.8 1.7 22.6L212.7 96H80C35.8 96 0 131.8 0 176V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H299.3l79.2-67.9c6.7-5.8 7.5-15.9 1.7-22.6s-15.8-7.5-22.6-1.7L256 90.9 154.4 3.9zM256 128H432c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H256s0 0 0 0zm80 64c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16H336zM112 160c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112zm320 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareT = {
  prefix: 'fal',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm112 48H224 336c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V176H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFarm = {
  prefix: 'fal',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M48 480c-8.8 0-16-7.2-16-16V192H155.7l17.1-32H32V112c0-44.2 35.8-80 80-80s80 35.8 80 80v12l3-5.7c6.1-11.5 15.6-20.8 27.1-26.7C212.5 39.5 166.9 0 112 0C50.1 0 0 50.1 0 112V464c0 26.5 21.5 48 48 48h96c-7-9.3-12-20.2-14.4-32H48zM380.8 68.1c-8.2-3.6-17.5-3.6-25.7 0l-116.5 51c-6.6 2.9-12 7.9-15.4 14.3L163.8 244.9c-2.5 4.6-3.8 9.8-3.8 15.1V464c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48V260c0-5.3-1.3-10.4-3.8-15.1L512.7 133.4c-3.4-6.4-8.8-11.4-15.4-14.3l-116.5-51zM368 97.5l116.5 51L544 260V464c0 8.8-7.2 16-16 16H448V416c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v64H208c-8.8 0-16-7.2-16-16V260l59.5-111.6L368 97.5zM416 480H320V416c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64zM336 224h64v64H336V224zm0-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H336z"]
};
var faBarnSilo = faFarm;
var faChessKnight = {
  prefix: 'fal',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", "M96 35.8c0-2.1 1.7-3.8 3.8-3.8H230.6C315.3 32 384 100.7 384 185.4c0 8.8-.8 17.6-2.3 26.3L357.3 352h32.5l23.5-134.9c1.8-10.5 2.7-21.1 2.7-31.8C416 83 333 0 230.6 0H99.8C80 0 64 16 64 35.8c0 13.6 7.7 25.9 19.8 32l1.3 .6c-13.5 14.7-21.1 33.9-21.1 54l-.3 104.4c-.1 23.2 11.1 45 30 58.5l1.9 1.4c4.5 3.2 9.3 5.8 14.3 7.8l-6.9 5c-17.8 13-30.4 31.6-35.8 52.5h33.7c4.4-10.5 11.5-19.7 21-26.6l53.8-39.1 89.9-65.4c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5l-89.9 65.4c-12.7 9.2-29.8 9.3-42.6 .2l-1.9-1.4c-10.4-7.5-16.6-19.5-16.6-32.4l.3-104.4c0-12.7 5.1-24.8 14.1-33.8l13.3-13.3c3.6-3.6 5.3-8.8 4.5-13.9s-4-9.4-8.6-11.7L98.1 39.2c-1.3-.6-2.1-1.9-2.1-3.4zM366.2 416l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H55.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L81.8 416l284.4 0zM81.8 384c-11.1 0-21.4 5.7-27.2 15.1L21.9 451.8C18.1 458 16 465.2 16 472.6C16 494.3 33.7 512 55.4 512H392.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1H81.8zM148 168a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faBarsSort = {
  prefix: 'fal',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM192 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H176c8.8 0 16 7.2 16 16z"]
};
var faPalletBoxes = {
  prefix: 'fal',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M304 32H112c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16zM112 0H304c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V48C64 21.5 85.5 0 112 0zM528 128H432c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16zM432 96h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48zM0 368c0-8.8 7.2-16 16-16H80 320 560h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H576v96h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H560 320 80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V384H16c-8.8 0-16-7.2-16-16zM96 480H304V384H96v96zm240 0H544V384H336v96z"]
};
var faPaletteBoxes = faPalletBoxes;
var faPalletAlt = faPalletBoxes;
var faFaceLaughSquint = {
  prefix: 'fal',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm2.9-135.2c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 192l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 192l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faLaughSquint = faFaceLaughSquint;
var faCodeSimple = {
  prefix: 'fal',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", "M203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256 203.3 91.3zm169.4 0L537.4 256 372.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faBoltSlash = {
  prefix: 'fal',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", "M351.4 362.3L236.6 463.6 290 313.9 263.5 293 197.2 478.7c-5.8 16.2 6.2 33.3 23.5 33.3c6.1 0 11.9-2.2 16.5-6.2L376.9 382.4l-25.5-20.2zM216.7 256H170.1L192 236.5l-25.5-20.1-29.8 26.5c-5.5 4.9-8.7 11.9-8.7 19.3c0 14.3 11.6 25.8 25.8 25.8H257.2l-40.5-32zm72.5-105.9L403.3 48.7 350 198.1 376.5 219 442.8 33.3C448.6 17.1 436.6 0 419.4 0c-6.1 0-12 2.2-16.5 6.3L263.7 130l25.5 20.1zM485 224H382.8l40.5 32h48.5l-22.9 20.2 25.5 20.2 28.4-25.1c5.8-5.1 9.1-12.5 9.1-20.3c0-14.9-12.1-27-27-27zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPanelFire = {
  prefix: 'fal',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H314.4c6.6 11.4 14.4 22.2 23.2 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32.2c-11.1-1-22.6 1.9-32 8.8V96c0-17.7-14.3-32-32-32zM327.2 239.5c-2.3 .4-4.7 .5-7.2 .5H128c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48H320c26.5 0 48 21.5 48 48v24.9c-15.5 17.9-29.3 36.3-40.8 54.5zM112 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm96 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM112 160v32c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm397.4 93.3c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1C361.4 305.8 352 334.1 352 352c0 70.3 56.2 127.8 128 127.8c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zM487.5 197c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 87.8-71.3 159.8-160 159.8c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zm-42.5 58.9c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0c-17.5 11.7-36.6 17.7-57.9 17.7c-25.9 0-50.2-8.4-68.2-24.8c-18.2-16.6-28.8-40.5-28.8-69.2c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1l12.6-9.9-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6c11.3 10.3 27.5 16.4 46.6 16.4c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faBinaryCircleCheck = {
  prefix: 'fal',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", "M320 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V16zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304zM0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80C35.8 0 0 35.8 0 80zM80 32h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zM272 288c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h32c24 0 45.6-10.6 60.2-27.3c-7.4-8.3-14-17.3-19.7-27C336 471.1 321.1 480 304 480H272c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h32c7.6 0 14.9 1.8 21.3 5c2.6-10.5 6.2-20.7 10.7-30.3c-9.8-4.3-20.6-6.6-32-6.6H272zm224-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faCommentMinus = {
  prefix: 'fal',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM160 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faBurrito = {
  prefix: 'fal',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 38-26.5 69.8-62 78L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9L33.9 433.9C12.2 412.2 0 382.7 0 352s12.2-60.2 33.9-81.9L242 62zm44-15.9C307.5 78.8 320 117.9 320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c42.1 0 81.2 12.5 113.9 33.9c8.7-8.7 14.1-20.7 14.1-34c0-8.8-2.3-16.9-6.4-24c-2.9-5-2.9-11.1 0-16c4.1-7 6.4-15.2 6.4-24c0-22.8-15.9-41.9-37.2-46.8c-6-1.4-10.6-6-12-12C425.9 47.9 406.8 32 384 32c-8.8 0-16.9 2.3-24 6.4c-5 2.9-11.1 2.9-16 0c-7-4.1-15.2-6.4-24-6.4c-13.3 0-25.3 5.4-33.9 14.1zM56.6 411.3l44.1 44.1C116.4 471.2 137.8 480 160 480s43.6-8.8 59.3-24.6L431.7 243c-23.9-12.2-51-19-79.7-19c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-28.3 0-55.4-5.7-80-15.9c0 22.2 8.9 43.5 24.6 59.3zm0-118.6c-7.9 7.9-14 17.1-18.2 27.2C60.8 330.2 85.7 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-28.7-6.9-55.8-19-79.7L56.6 292.7z"]
};
var faViolin = {
  prefix: 'fal',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M347.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-320 320c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l320-320zm288 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L452.5 164.9c-53.3-45.5-111.2-44.7-152-19C290.6 152 288 164.4 288 176c0 35.3-28.7 64-64 64c-5.2 0-10.2-.6-15.1-1.8c-14.1-3.4-30.2-4-39.8 6.7C143.5 273.3 128 310.8 128 352c0 22.4 4.6 43.7 12.9 63.1l-1.4 .9c-7.2 4.4-11.5 12.2-11.5 20.6c0 6.4 2.6 12.6 7.1 17.1l51.2 51.2c4.5 4.5 10.7 7.1 17.1 7.1c8.4 0 16.2-4.4 20.6-11.5l.9-1.4c19.4 8.3 40.7 12.9 63.1 12.9c41.2 0 78.7-15.5 107-41.1c10.7-9.7 10.1-25.8 6.7-39.8c-1.2-4.8-1.8-9.9-1.8-15.1c0-35.3 28.7-64 64-64c11.6 0 24-2.6 30.1-12.4c25.7-40.9 26.5-98.7-19-152L635.3 27.3zM429.8 187.6L324.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L452.4 210.2c34.2 41.3 32.2 81.8 16.4 109.4l-.4 .1c-1.2 .2-2.6 .3-4.4 .3c-53 0-96 43-96 96c0 7.7 .9 15.3 2.7 22.6c.6 2.4 1 4.6 1.2 6.5c.2 1.6 .2 2.7 .1 3.6C349.5 468.2 320.1 480 288 480c-16.3 0-31.8-3-46.1-8.6l40.4-65.7c5.8-9.5 4.4-21.7-3.5-29.5l-15.1-15.1c-7.9-7.9-20.1-9.3-29.5-3.5l-65.7 40.4C163 383.8 160 368.3 160 352c0-32.1 11.8-61.5 31.4-83.9c.8-.1 2 0 3.6 .1c1.9 .2 4.1 .6 6.5 1.2c7.3 1.8 14.8 2.7 22.6 2.7c53 0 96-43 96-96c0-1.7 .1-3.2 .3-4.4l.1-.4c27.6-15.8 68.1-17.9 109.4 16.4zM496 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM544 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM245.6 388.2l6.1 6.1-49.8 80.9-37.3-37.3 80.9-49.8z"]
};
var faObjectsColumn = {
  prefix: 'fal',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M48 64c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H48zM0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM304 256c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H304zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V272zM144 352H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM48 320h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H304zM256 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80z"]
};
var faSquareChevronDown = {
  prefix: 'fal',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM212.7 347.3l-112-112c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 313.4 324.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faChevronSquareDown = faSquareChevronDown;
var faCommentPlus = {
  prefix: 'fal',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM240 336c0 8.8 7.2 16 16 16s16-7.2 16-16V256h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faTriangleInstrument = {
  prefix: 'fal',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V65.4c-24.6 4.4-46.5 19-60.1 40.5L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94H450c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L443.8 232.1l-23.2 23.2 81.8 129.5c6.3 9.9 9.6 21.4 9.6 33.1c0 34.3-27.8 62-62 62H126c-34.3 0-62-27.8-62-62c0-11.7 3.3-23.2 9.6-33.1L238.9 123.1C249.5 106.2 268.1 96 288 96s38.5 10.2 49.1 27.1l48.5 76.8-65.1 65.1c-9.5-5.6-20.6-8.9-32.5-8.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l59.9-59.9 23.2-23.2 113-113c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L408.8 176.6 364.1 106C350.5 84.4 328.6 69.9 304 65.4V16zm16 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faTriangleMusic = faTriangleInstrument;
var faWheelchair = {
  prefix: 'fal',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M176 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 176 0a56 56 0 1 0 0 112zm-32.4 96c-2-8.6-10.5-14-19.1-12.1C53.2 212.1 0 275.8 0 352c0 88.4 71.6 160 160 160c69.7 0 128.9-44.5 150.9-106.7c2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8C263.1 444.4 215.7 480 160 480C89.3 480 32 422.7 32 352c0-60.9 42.5-111.9 99.5-124.8c8.6-2 14-10.5 12.1-19.1zm56-51.6c-2-8.6-10.5-14-19.1-12.1s-14 10.5-12.1 19.1l34.3 151.1c5 21.9 24.4 37.4 46.8 37.4H358.1l59.6 119.2c1.9 3.8 5.2 6.7 9.3 8s8.4 1 12.2-.9l64-32c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-49.7 24.8L386.7 337.7c-5.4-10.8-16.5-17.7-28.6-17.7H249.5c-7.5 0-13.9-5.2-15.6-12.5L215 224H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H207.7l-8.1-35.5z"]
};
var faUserPilotTie = {
  prefix: 'fal',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M230.9 .8l144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2L368 109.3v1.6c0 15.6-7.6 31.8-23.2 40.1c-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9v-1.6L57.4 86.6C49.1 78.4 46 66.3 49.3 55.1s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3v8.2c0 5.8 2.8 10 6.2 11.8C135.8 132 167.6 144 224 144s88.2-12 105.8-21.3c3.4-1.8 6.2-6 6.2-11.8v-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-6.1l18.4 36.9 51.6-68.7C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6H240 208 25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7L198.1 384H192c-8.8 0-16-7.2-16-16zm48 35.8l-22.9 45.7 2.9 3.8L224 480l0 0 0 0 20-26.7 2.9-3.8L224 403.8zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480H184zm80 0H415.8c-2.9-46.6-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9 .1-5.8 .3-8.7c9.1 4.3 19.6 8.5 31.8 12.1c1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zM183.2 65.7L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z"]
};
var faPianoKeyboard = {
  prefix: 'fal',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M448 224v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V224h32zM416 333.3V416H304V333.3c18.6-6.6 32-24.4 32-45.3V224h48v64c0 20.9 13.4 38.7 32 45.3zM448 416V333.3c18.6-6.6 32-24.4 32-45.3V224h64V384c0 17.7-14.3 32-32 32H448zm-16 32h80c35.3 0 64-28.7 64-64V224 208 192 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v64 16 16V384c0 35.3 28.7 64 64 64h80H288 432zM272 416H160V333.3c18.6-6.6 32-24.4 32-45.3V224h48v64c0 20.9 13.4 38.7 32 45.3V416zm-144 0H64c-17.7 0-32-14.3-32-32V224H96v64c0 20.9 13.4 38.7 32 45.3V416zm16-112c-8.8 0-16-7.2-16-16V224h32v64c0 8.8-7.2 16-16 16zm144 0c-8.8 0-16-7.2-16-16V224h32v64c0 8.8-7.2 16-16 16zM464 192H400 320 256 176 112 32V128c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v64H464z"]
};
var faBedEmpty = {
  prefix: 'fal',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V208 336v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V416H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 336 304c0-61.9-50.1-112-112-112H32V48zM608 320H32V224H528c44.2 0 80 35.8 80 80v16zM32 352H608v32H32V352z"]
};
var faCircleArrowUp = {
  prefix: 'fal',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 228.7l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 182.6V368c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faArrowCircleUp = faCircleArrowUp;
var faToggleOn = {
  prefix: 'fal',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M160 128C89.3 128 32 185.3 32 256s57.3 128 128 128H416c70.7 0 128-57.3 128-128s-57.3-128-128-128H160zM0 256C0 167.6 71.6 96 160 96H416c88.4 0 160 71.6 160 160s-71.6 160-160 160H160C71.6 416 0 344.4 0 256zm480 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faRectangleVertical = {
  prefix: 'fal',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M352 448c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 384zM384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384z"]
};
var faRectanglePortrait = faRectangleVertical;
var faPersonWalking = {
  prefix: 'fal',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", "M200 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 200 0zM121.5 170.2c-1.3 .6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.4 9.6c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4l2.4-9.5c9.8-39 35.4-72.2 70.7-91.5l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2c36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L187.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L209.9 393 109.4 305.8C94.9 293.3 89.3 273.4 95 255.2l26.6-85zm36.6-9.9L125.5 264.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4c-2.5 0-5 .1-7.5 .3zM126.3 375.2L95.5 436.8c-1.5 3.1-3.6 5.9-6 8.3L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"]
};
var faWalking = faPersonWalking;
var faL = {
  prefix: 'fal',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M48 32c8.8 0 16 7.2 16 16V448H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"]
};
var faSignalStream = {
  prefix: 'fal',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M90.3 68.5c6.8 5.7 7.6 15.8 1.9 22.5C54.6 135.6 32 193.1 32 256s22.6 120.4 60.2 165c5.7 6.8 4.8 16.8-1.9 22.5s-16.8 4.8-22.5-1.9C25.5 391.5 0 326.7 0 256S25.5 120.5 67.8 70.4c5.7-6.8 15.8-7.6 22.5-1.9zm395.4 0c6.8-5.7 16.8-4.8 22.5 1.9C550.5 120.5 576 185.3 576 256s-25.5 135.5-67.8 185.6c-5.7 6.8-15.8 7.6-22.5 1.9s-7.6-15.8-1.9-22.5C521.4 376.4 544 318.9 544 256s-22.6-120.4-60.2-165c-5.7-6.8-4.8-16.8 1.9-22.5zM224 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM164.6 154.2C141.7 181.9 128 217.3 128 256s13.7 74.1 36.6 101.8c5.6 6.8 4.7 16.9-2.1 22.5s-16.9 4.7-22.5-2.1C112.5 345 96 302.4 96 256s16.5-89 43.9-122.2c5.6-6.8 15.7-7.8 22.5-2.1s7.8 15.7 2.1 22.5zm271.5-20.4C463.5 167 480 209.6 480 256s-16.5 89-43.9 122.2c-5.6 6.8-15.7 7.8-22.5 2.1s-7.8-15.7-2.1-22.5C434.3 330.1 448 294.7 448 256s-13.7-74.1-36.6-101.8c-5.6-6.8-4.7-16.9 2.1-22.5s16.9-4.7 22.5 2.1z"]
};
var faDownToBracket = {
  prefix: 'fal',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M222.2 319.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 187.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H288c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8V160c0 8.8-7.2 16-16 16H102.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 319.2zM224 352c-9.5 0-18.6-3.9-25.1-10.8L74.5 209.2C67.8 202 64 192.5 64 182.7c0-21.4 17.3-38.7 38.7-38.7H144V40c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V144h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L249.1 341.2c-6.5 6.9-15.6 10.8-25.1 10.8zM32 336v96c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V336c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCircleZ = {
  prefix: 'fal',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H304.9L163 358.7c-3.5 4.9-3.9 11.3-1.2 16.6s8.2 8.7 14.2 8.7H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H207.1L349 153.3c3.5-4.9 3.9-11.3 1.2-16.6s-8.2-8.7-14.2-8.7H176z"]
};
var faStars = {
  prefix: 'fal',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M352 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5L41.2 295.8l63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3L177 432.1c9.3-4.9 20.5-4.9 29.8 0L285 473.3l-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM448 160c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176c0-8.8 7.2-16 16-16z"]
};
var faFire = {
  prefix: 'fal',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M239.7 109.4c6.1 7.7 15.5 12.1 25.3 12s19.1-4.7 25.1-12.5c8.4-11 16.9-21.7 25.6-31.1c27.8 28.8 52.1 65.5 69.8 101.1c19.6 39.4 30.5 75.7 30.5 97.6C416 388.3 328.8 480 224 480C118 480 32 388.4 32 276.5c0-29.9 14.4-70.8 40.9-115.4c24.7-41.6 59.3-85.3 100.2-124.7c23.5 22.7 45.7 47 66.6 73zm25-20c-6.9-8.6-13.9-17-21-25.2C225.6 43.6 206.7 24 187 5.5c-7.8-7.3-19.9-7.3-27.7-.1c-46.5 43.2-86 92.3-113.9 139.3C17.8 191.2 0 238.1 0 276.5C0 404.1 98.4 512 224 512c124.2 0 224-107.8 224-235.5c0-29.3-13.5-71.1-33.8-111.9c-20.7-41.4-49.9-85-84.5-118c-7.8-7.5-20.1-7.5-28-.1c-5.7 5.4-11.2 11.3-16.5 17.4c-7.3 8.4-14.2 17.2-20.5 25.5zM128 306.8c0-23.7 13-46.3 47.1-89.1c16.8 21.3 46.2 58.7 62.6 79.6c12.5 15.9 36.3 16.3 49.4 1l23.4-27.2c17.8 38.8 9.4 86.6-24.9 110.7C267.1 394 247.7 400 225.7 400c-28.2 0-52.6-9-69.8-24.7c-17-15.5-28-38.4-28-68.5zm72-109.2c-12.7-16.1-37-16.2-49.8-.1C116.8 239.4 96 270.3 96 306.8c0 38.5 14.3 70.2 38.4 92.1c23.9 21.8 56.4 33.1 91.3 33.1c28.5 0 54.1-8 77.7-23.7l0 0 .3-.2c51.2-35.7 59.1-104.2 33.9-154.6c-10.7-21.4-37.3-19.7-49.9-5.1l-24.9 29 0 0c-16.5-21-46-58.5-62.8-79.8z"]
};
var faBedPulse = {
  prefix: 'fal',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M478.3 8.8L505.9 64H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-6.1 0-11.6-3.4-14.3-8.8L465.6 55 414.9 181.9c-2.3 5.9-7.9 9.8-14.2 10s-12.2-3.2-15-8.8L342.1 96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16H352c6.1 0 11.6 3.4 14.3 8.8L398.4 137 449.1 10.1c2.3-5.9 7.9-9.8 14.2-10s12.2 3.2 15 8.8zM304 160h34.3l16 32H304c-8.8 0-16 7.2-16 16V352H608V272c0-44.2-35.8-80-80-80H445.3l12.8-32H528c61.9 0 112 50.1 112 112v96 64 64c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368 80c0-8.8 7.2-16 16-16s16 7.2 16 16V352H256V208c0-26.5 21.5-48 48-48zM608 416V384H272 32v32H608zM192 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 240a80 80 0 1 1 160 0A80 80 0 1 1 64 240z"]
};
var faProcedures = faBedPulse;
var faHouseDay = {
  prefix: 'fal',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M192 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM276.7 52.7l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM410.4 99.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L224 283.9V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V283.9l37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256.5L400 133.1 544 256.5zM336 304v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32zm96 0v64H368V304h64zM144 176c0-17.7 14.3-32 32-32c13.9 0 25.8 8.9 30.2 21.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C227.6 129.8 203.9 112 176 112c-35.3 0-64 28.7-64 64c0 27.9 17.8 51.6 42.7 60.4c8.3 2.9 17.5-1.4 20.4-9.8s-1.4-17.5-9.8-20.4C152.9 201.8 144 189.9 144 176zm-36.7 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faShuttleSpace = {
  prefix: 'fal',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", "M245.2 448.1L405.3 352H464c64.7 0 123.5-27.4 164.8-76.3c9.6-11.4 9.6-28 0-39.4C587.5 187.4 528.7 160 464 160H405.3L245.2 63.9C210.4 43 170.6 32 130 32H80C53.5 32 32 53.5 32 80v48c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32v48c0 26.5 21.5 48 48 48h50c40.6 0 80.4-11 115.2-31.9zM64 384h48c5.5 0 10.8-.6 16-1.6V448H80c-8.8 0-16-7.2-16-16V384zm164.7 36.6c-21.2 12.7-44.5 21.2-68.7 25V368c5.5-4.2 10.5-9 14.8-14.5c.6-.7 1.2-1.2 1.6-1.4c.2-.1 .3-.1 .3-.1H343.1L228.7 420.6zM64 352H32V272H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V160H64h48c15.3 0 28.9 7.1 37.7 18.3c5.8 7.3 15.2 13.7 27 13.7H464c54.9 0 104.4 22.9 139.5 64c-35.1 41.1-84.6 64-139.5 64H176.7c-11.8 0-21.2 6.4-27 13.7C140.9 344.9 127.3 352 112 352H64zm0-224V80c0-8.8 7.2-16 16-16h48v65.6c-5.2-1.1-10.5-1.6-16-1.6H64zm110.8 30.5c-4.3-5.4-9.3-10.3-14.8-14.5V66.4c24.2 3.8 47.6 12.3 68.7 25L343.1 160H176.7c0 0-.2 0-.3-.1c-.4-.2-1-.7-1.6-1.4zM464 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"]
};
var faSpaceShuttle = faShuttleSpace;
var faShirtLongSleeve = {
  prefix: 'fal',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", "M110.3 73.4C124.3 47.9 151.2 32 180.4 32H192h4 28.3c4.1 49.3 45.3 88 95.7 88s91.6-38.7 95.7-88H444h4 11.6c29.2 0 56 15.9 70.1 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3V368c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V240.4c0-5.4-1.4-10.7-4-15.4L481.2 118c-1.4-2.6-3.1-5.1-5-7.3c-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15V456c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V121.2c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V240.4c0-16.2 4.1-32.1 11.9-46.3L110.3 73.4zM180.4 0c-40.8 0-78.5 22.2-98.1 58L15.8 178.8C5.5 197.7 0 218.9 0 240.4V368c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V240.4l32-58.2V456c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V182.3l32 58.2V368c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4c0-21.6-5.4-42.8-15.8-61.7L557.8 58C538.1 22.2 500.5 0 459.6 0H448h-4H407.6c-1.5 0-2.9 .1-4.2 .4c-1.1-.2-2.2-.4-3.4-.4H240c-1.2 0-2.3 .1-3.4 .4c-1.3-.2-2.8-.4-4.2-.4H196h-4H180.4zm76.1 32h127c-3.9 31.6-30.9 56-63.5 56s-59.6-24.4-63.5-56z"]
};
var faChartPieSimple = {
  prefix: 'fal',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M256 17.7v9.4V240c0 8.8 7.2 16 16 16H494.3c9.6 0 17.7-7.4 17.7-17.1C512 107 405 0 273.1 0C263.4 0 256 8.1 256 17.7zm32 14.8C390.4 39.8 472.2 121.6 479.5 224H288V32.5zM192 288c0 17.7 14.3 32 32 32H442.4C420.8 411.7 338.3 480 240 480C125.1 480 32 386.9 32 272c0-98.3 68.3-180.8 160-202.4V288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.5 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8H256 224V256 66.7z"]
};
var faChartPieAlt = faChartPieSimple;
var faFaceLaugh = {
  prefix: 'fal',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
  prefix: 'fal',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M448 160v32h32V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384h80c19.6 0 37.3-11.9 44.6-30.2l64-160c5.9-14.8 4.1-31.5-4.8-44.7S543.9 224 528 224H128c-19.6 0-37.3 11.9-44.6 30.2L32 382.8V96c0-17.7 14.3-32 32-32H181.5c8.5 0 16.6 3.4 22.6 9.4l22.6-22.6L204.1 73.4l26.5 26.5c18 18 42.4 28.1 67.9 28.1H416c17.7 0 32 14.3 32 32zM384 448H64c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c2.4-6.1 8.3-10.1 14.9-10.1H528c5.3 0 10.3 2.6 13.2 7s3.6 10 1.6 14.9l-64 160C476.4 444 470.5 448 464 448H384z"]
};
var faAlbumCollectionCircleUser = {
  prefix: 'fal',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", "M32 16c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512H394.8c-12.9-9.1-24.5-19.9-34.6-32H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272C34.6 172.1 45.7 160 59.8 160H452.2c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2c3.9 0 7.8 .1 11.7 .4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1H59.8zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4c-3.9-9.9-6.9-20.2-9-30.8C304.4 410.6 281.7 416 256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9c6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20zM556 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8H467.8c-21.8 0-42.2 9.6-56.1 25.8C394.5 422.1 384 396.2 384 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faCandy = {
  prefix: 'fal',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", "M376.9 405.6C359.2 412.3 340 416 320 416c-4.9 0-9.7-.2-14.4-.6L183.8 171.9c12.8-20.7 30.1-38.2 50.6-51.2L376.9 405.6zm28.6-14.3L263.1 106.4C280.8 99.7 300 96 320 96c4.9 0 9.7 .2 14.4 .6L456.2 340.1c-12.8 20.7-30.1 38.2-50.6 51.2zm-14.2 43.1l0 0c10-4 19.5-8.8 28.6-14.3l0 0c40.9-24.9 71.7-64.7 84.9-111.8l91.9 49c10.5 5.6 23.5 2.7 30.6-6.9c9.1-12.3 3.8-24.5-5.3-35.4c-5.4-6.4-12-12.3-17.9-17.5l0 0c-3.2-2.9-6.3-5.6-8.7-8c2.8-1 5.8-2 9-3c8.3-2.7 17.6-5.7 24.6-10.5c6.5-4.5 11.1-10.7 11.1-19.8s-4.6-15.3-11.1-19.8c-7-4.9-16.2-7.8-24.6-10.5c-3.2-1-6.3-2-9-3c2.4-2.4 5.4-5.1 8.7-8c5.9-5.2 12.6-11.2 17.9-17.5c9.2-10.9 14.4-23.1 5.3-35.4c-7.1-9.6-20.1-12.5-30.6-6.9l-91.9 49C485.2 134.3 427.4 80.7 355.5 67.3l0 0C344 65.1 332.2 64 320.1 64c0 0 0 0-.1 0c-25.2 0-49.2 4.8-71.3 13.7l0 0c-10 4-19.6 8.8-28.6 14.3l0 0c-40.9 24.9-71.7 64.7-84.9 111.8l-91.9-49c-10.5-5.6-23.5-2.7-30.6 6.9c-9.1 12.3-3.8 24.5 5.3 35.4c5.4 6.4 12 12.3 17.9 17.5l0 0c3.2 2.9 6.3 5.6 8.7 8c-2.8 1-5.8 2-9 3l0 0c-8.3 2.7-17.6 5.7-24.6 10.5C4.6 240.7 0 246.9 0 256s4.6 15.3 11.1 19.8c7 4.9 16.2 7.8 24.6 10.5c3.2 1 6.3 2 9 3c-2.4 2.4-5.4 5.1-8.7 8l0 0 0 0 0 0c-5.9 5.2-12.6 11.2-17.9 17.5C8.9 325.8 3.6 338 12.7 350.3c7.1 9.6 20.1 12.5 30.6 6.9l91.9-49c19.6 69.5 77.4 123.1 149.3 136.5l0 0c12.1 2.3 24.6 3.4 37.4 3.3l0 0c24.5-.2 47.9-5.1 69.4-13.7zm-126-27.9C203.9 384.1 160 325.2 160 256c0-16.2 2.4-31.8 6.9-46.5l98.5 196.9zM374.7 105.6C436.1 127.9 480 186.8 480 256c0 16.2-2.4 31.8-6.9 46.5L374.7 105.6zM512 256c0-6.3-.3-12.4-.9-18.5l54.9-29.3c-3.2 6.5-4.2 14-2.6 21.4c2.3 10.8 10 19.8 20.4 23.7c2.8 1.1 5.6 2 8.1 2.8l.1 0-.1 0c-2.4 .8-5.3 1.7-8.1 2.8c-10.4 3.9-18.1 12.8-20.4 23.7c-1.6 7.3-.6 14.8 2.6 21.4l-54.9-29.3c.6-6.1 .9-12.3 .9-18.5zM128.9 237.5c-.6 6.1-.9 12.3-.9 18.5s.3 12.4 .9 18.5L73.9 303.8c3.2-6.5 4.2-14 2.6-21.4c-2.3-10.8-10-19.8-20.4-23.7c-2.8-1.1-5.6-2-8.1-2.8l-.1 0 .1 0c2.4-.8 5.3-1.7 8.1-2.8c10.4-3.9 18.1-12.8 20.4-23.7c1.6-7.3 .6-14.8-2.6-21.4l54.9 29.3z"]
};
var faBowlHot = {
  prefix: 'fal',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M144 0c8.8 0 16 7.2 16 16V32c0 20.1 9.5 39.1 25.6 51.2C209.8 101.3 224 129.8 224 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-20.1-9.5-39.1-25.6-51.2C142.2 90.7 128 62.2 128 32V16c0-8.8 7.2-16 16-16zm.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4c3.3 9.4 12.2 16.1 22.7 16.1H328c10.4 0 19.4-6.7 22.7-16.1c2.8-8.1 8.7-14.7 16.5-18.4c61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9H50.9c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.2 23.3 224 50.9 224H461.1c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-4.9 84.1-55.9 155.1-127.5 189.2C373.3 496.3 352.5 512 328 512H184c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8zM288 16V32c0 20.1 9.5 39.1 25.6 51.2C337.8 101.3 352 129.8 352 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-20.1-9.5-39.1-25.6-51.2C270.2 90.7 256 62.2 256 32V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSoup = faBowlHot;
var faFlatbread = {
  prefix: 'fal',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm363.3-84.7l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHeartCirclePlus = {
  prefix: 'fal',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCodeFork = {
  prefix: 'fal',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V192c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V158.4c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V192c0 44.2-35.8 80-80 80H240v81.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V272H144c-44.2 0-80-35.8-80-80V158.4C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm64 304a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCity = {
  prefix: 'fal',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", "M96 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64 80 96H176 64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H197.5c4.2 11.9 10.7 22.8 19 32H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64V16C64 7.2 71.2 0 80 0s16 7.2 16 16zM512 192c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h32H448 576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H512zm0-128v64 32h32 32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H448 320 288c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64zM320 392V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm32-8h32V352H352v32zM344 64h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm8 64h32V96H352v32zM320 264V216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm32-8h32V224H352v32zM504 448c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H504zm8-64v32h32V384H512zm-32-88V248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H504c-13.3 0-24-10.7-24-24zm32-8h32V256H512v32zM88 352c-13.3 0-24-10.7-24-24V280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88zm8-64v32h32V288H96zM64 200V152c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm32-8h32V160H96v32z"]
};
var faSignalBarsWeak = {
  prefix: 'fal',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", "M96 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16s16 7.2 16 16v32zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAlt1 = faSignalBarsWeak;
var faMicrophoneLines = {
  prefix: 'fal',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M256 160V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c0-35.3-28.7-64-64-64s-64 28.7-64 64V256c0 35.3 28.7 64 64 64s64-28.7 64-64H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h48zm32 16v64 16c0 53-43 96-96 96s-96-43-96-96V96c0-53 43-96 96-96s96 43 96 96v16 64zM48 192c8.8 0 16 7.2 16 16v48c0 70.7 57.3 128 128 128s128-57.3 128-128V208c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 83-63.1 151.2-144 159.2V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192 112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V415.2C95.1 407.2 32 339 32 256V208c0-8.8 7.2-16 16-16z"]
};
var faMicrophoneAlt = faMicrophoneLines;
var faClockTwelve = {
  prefix: 'fal',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPepperHot = {
  prefix: 'fal',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", "M422.9 133.4l11.2 7.5 9.4 9.6C466.1 173.7 480 205.2 480 240c0 3-.1 5.9-.3 8.8C469.4 233.4 452 224 433.2 224H368V152c0-15.7-6.4-29.8-16.8-40l.8 0c26.3 0 50.6 7.9 70.9 21.4zM512 240c0-43.3-17.2-82.6-45.2-111.4l-.4-.4c1.5-3.3 2.9-6.6 4.2-10c9.4-25.6 10.6-53.8 2.7-80.5c-1.1-3.8-2.4-7.6-3.9-11.3l-6.5-16.3 0 0 0 0c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8l0 0 6.5 16.3c2.5 6.3 4.3 12.7 5.4 19.2c.9 5.1 1.4 10.3 1.4 15.5c.1 11.6-1.8 23.1-5.8 34c-9-6-18.6-11.1-28.7-15.2C393.5 84.1 373.2 80 352 80c-24.3 0-47.3 5.4-67.9 15.1c-19.3 9-10.5 32.9 10.8 32.9l17.1 0c13.3 0 24 10.7 24 24v80c0 13.3 10.7 24 24 24h73.2c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c8.2 16.4 30.7 17.5 36.8 .1c5.8-16.5 8.9-34.3 8.9-52.8zM261.7 160L172.4 305.7c-18.1 29.6-47.5 50.5-81.4 58.1l-35.4 7.9C23.1 378.9 0 407.7 0 441c0 39.2 31.8 71 71 71h32.1c141.1 0 269.1-68.1 348.9-176.2l-16.2-32.5C362.9 411.3 239.6 480 103.2 480H71c-21.6 0-39-17.5-39-39c0-18.3 12.7-34.1 30.6-38.1L97.9 395c42.3-9.4 79-35.6 101.7-72.6L299.2 160l-37.5 0z"]
};
var faCitrusSlice = {
  prefix: 'fal',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-400 400c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512h4C378.2 512 512 378.2 512 213.2v-4c0-76.7-30.5-150.2-84.7-204.5zM278.8 175.8l89.4-89.4c21.5 25.2 36.9 55.9 43.7 89.7H279c-.1-.1-.1-.1-.2-.2zM295.6 208H415.8c.1 2.7 .2 5.3 .2 8c0 49.5-18 94.7-47.7 129.7l-82.5-82.5c10.7-16.5 14-36.5 9.8-55.2zm50.1 160.3C310.7 398 265.5 416 216 416c-2.7 0-5.3-.1-8-.2v-122c18.4 4.6 38.2 1.8 54.9-8.4l82.8 82.8zM176 412c-33.7-6.9-64.4-22.2-89.7-43.7L176 278.6V412zM448 216c0-58.3-21.5-111.6-57-152.3L415.6 39C457 85.8 480 146.3 480 209.1v4C480 360.5 360.5 480 213.2 480h-4C146.3 480 85.8 457 39 415.6L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232zM256.2 198.5c13.1 15.7 12.2 39.1-2.5 53.8s-38.1 15.6-53.8 2.5l56.3-56.3z"]
};
var faSheep = {
  prefix: 'fal',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M544 136c0-39.8-32.2-72-72-72c-36.1 0-66 26.6-71.2 61.2l.1 .1-.1 .1c-.5 3.5-.8 7-.8 10.6v72c0 35.3 28.7 64 64 64h16c35.3 0 64-28.7 64-64V136zM372.5 105.8C385.4 63.1 425.1 32 472 32c44.4 0 82.2 27.8 97.2 66.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 141.9V208c0 53-43 96-96 96H464c-53 0-96-43-96-96V147.2l-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9zM448 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 344c9.9 0 18.8-4.5 24.7-11.6c10.1 2.4 20.5 3.6 31.3 3.6c1.1 0 2.2 0 3.4 0c-8.7 21.5-28.8 37.3-52.8 39.7l-25 100C392.2 497 373 512 351 512H336c-26.5 0-48-21.5-48-48V423.4c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V464c0 26.5-21.5 48-48 48H161c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9C315.1 61.2 329 56 344 56c5.7 0 11.2 .7 16.5 2.1c-6.4 9.2-11.7 19.2-15.8 29.9l-.7 0c-7.6 0-14.4 2.6-19.9 6.9c-13.4 10.6-32.8 8.9-44-4c-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4C182.4 90.6 175.6 88 168 88c-15 0-27.7 10.4-31.1 24.3c-3.9 16.1-19.6 26.6-36 24c-1.6-.2-3.2-.4-5-.4c-17.7 0-32 14.3-32 32c0 2.7 .3 5.3 .9 7.8c3.5 14.2-3 29-16 36c-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36c-.6 2.5-.9 5.1-.9 7.8c0 17.7 14.3 32 32 32c1.7 0 3.4-.1 5-.4c16.4-2.5 32 7.9 36 24c3.4 14 16.1 24.3 31.1 24.3c7.6 0 14.4-2.6 19.9-6.9c13.4-10.6 32.8-8.9 44 4c5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4c5.5 4.3 12.3 6.9 19.9 6.9c15 0 27.7-10.4 31.1-24.3c3.9-16.1 19.6-26.6 36-24c1.6 .2 3.2 .4 5 .4zm-72 80c-8.5 0-16.6-1.7-24-4.7V464c0 8.8 7.2 16 16 16h15c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zM131.7 412.7l13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1h15c8.8 0 16-7.2 16-16V419.3c-7.4 3-15.5 4.7-24 4.7c-13.5 0-26-4.2-36.3-11.3z"]
};
var faUnlock = {
  prefix: 'fal',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", "M128 128c0-53 43-96 96-96c43.5 0 80.2 28.9 92 68.6c2.5 8.5 11.4 13.3 19.9 10.8s13.3-11.4 10.8-19.9C331 38.6 282 0 224 0C153.3 0 96 57.3 96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H128V128zM32 272c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272z"]
};
var faColonSign = {
  prefix: 'fal',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M255.6 19.6c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9L212.2 64.6C111.6 72.5 32 154.9 32 256c0 70.8 39 132.4 96.9 165.7l-16.5 70.7c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l14.9-64.1c14.2 5.3 29.1 9 44.6 10.9l-10.7 45.9c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l12.1-51.8c41.1-1.6 79-15.5 109.8-38.2c7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4c-23.6 17.3-52.2 28.6-83.3 31.4l69.2-296.5c4.9 2.9 9.6 6 14.1 9.3c7.1 5.2 17.1 3.7 22.4-3.4s3.7-17.1-3.4-22.4c-8-5.9-16.6-11.2-25.5-15.9l15.6-66.8c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9L290.1 73.8c-14.3-4.7-29.4-7.8-45-9.1l10.5-45.1zm-51.1 78l-68 291.2C92.7 360.1 64 311.2 64 256c0-80.3 60.8-147.3 140.5-158.4zM165.9 404.1L237.7 96.3c15.7 .9 30.9 4 45.1 8.9l-72.3 310c-15.6-1.6-30.6-5.4-44.6-11z"]
};
var faHeadset = {
  prefix: 'fal',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224V400.1c0 26.5-21.5 48-48 48l-82.7-.1c-6.6-18.6-24.4-32-45.3-32H240c-26.5 0-48 21.5-48 48s21.5 48 48 48h64c20.9 0 38.7-13.4 45.3-32l82.7 .1c44.2 0 80.1-35.8 80.1-80V256C512 114.6 397.4 0 256 0S0 114.6 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM320 464c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16M144 224h16V352H144c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zM64 272v32c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H144c-44.2 0-80 35.8-80 80zm288-48h16c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H352V224zm16-32H352c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80z"]
};
var faBadgerHoney = {
  prefix: 'fal',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M459.8 96c-21 0-41.8 4.9-60.6 14.3c-23.3 11.6-48.9 17.7-74.9 17.7H128c-5.3 0-10.5 .4-15.6 1.3C117.1 182.4 161.7 224 216 224h2c17.1 0 34-4.2 49.2-12.1l85.6-44.8C391.7 146.7 435 136 479 136H583.9c-.7-.4-1.5-.7-2.2-1l-61.1-26.7C502.2 100.2 482.3 96 462.2 96h-2.4zM32 224c0 43.2 28.5 79.8 67.8 91.8c8.3 2.6 13.1 11.3 10.7 19.7L99.2 374.9c-1.7 5.9-1.6 12.1 .1 18l13.1 43.7c2 6.8 8.3 11.4 15.3 11.4H149c10.7 0 18.4-10.3 15.3-20.6L156 399.7c-3.2-10.8-2.6-22.4 1.9-32.7l16-37.3c2.5-5.9 8.3-9.7 14.7-9.7H306.7c7.8 0 14.5 5.7 15.8 13.4l16.9 101.3c1.3 7.7 8 13.4 15.8 13.4h23.1c9.9 0 17.4-8.9 15.8-18.6L374.2 310.7c-1-5.8 1.3-11.6 5.9-15.2c42.5-33.4 112.3-71.5 187.8-78.4c11.5-1.1 21.7-5.3 28.7-12.4c7.2-7.2 11.3-17.1 11.3-27.3v-2.2c0-2.4-.2-4.8-.6-7.2H511.6c.3 1.3 .4 2.6 .4 4c0 11-9 20-20 20s-20-9-20-20c0-1.3 .1-2.6 .4-3.9c-36.5 1-72.3 10.3-104.8 27.3L282 240.2c-19.8 10.3-41.7 15.8-64 15.8h-2c-68.3 0-124.9-50.4-134.5-116C52 156.4 32 187.9 32 224zM75.7 340.9C58.9 333.3 44 322.3 32 308.7V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V224C0 153.3 57.3 96 128 96H324.2c21 0 41.8-4.9 60.6-14.3C408.1 70.1 433.8 64 459.8 64h2.4c24.5 0 48.8 5.1 71.2 14.9l61.1 26.7C622.1 117.7 640 145 640 175.2v2.2c0 18.7-7.4 36.7-20.7 49.9c-12.1 12.1-27.6 18.7-43.3 21.1V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V252.9c-53.3 10.6-102.6 36.9-136.6 62.1l18.2 109.1c4.9 29.3-17.7 55.9-47.3 55.9H355.1c-23.5 0-43.5-17-47.3-40.1L293.1 352h-94l-11.8 27.6c-1.5 3.4-1.7 7.3-.6 10.9l8.3 27.7c9.2 30.8-13.8 61.8-46 61.8H127.8c-21.2 0-39.9-13.9-46-34.2L68.7 402.1c-3.5-11.7-3.6-24.2-.2-36l7.2-25.2z"]
};
var faH4 = {
  prefix: 'fal',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", "M447.7 83L411.4 272H608V80c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H392c-4.8 0-9.3-2.1-12.3-5.8s-4.3-8.5-3.4-13.2l40-208c1.7-8.7 10.1-14.4 18.7-12.7s14.4 10.1 12.7 18.7zM16 64c8.8 0 16 7.2 16 16V240H288V80c0-8.8 7.2-16 16-16s16 7.2 16 16V256 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H32V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V256 80c0-8.8 7.2-16 16-16z"]
};
var faStoreSlash = {
  prefix: 'fal',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M544 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v54l32 25.3V272zM385.1 224c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-.7 1.1 25.3 19.9 1.3-2.1H496.4l56.2 88.9 0 0c18.7 29.6 .3 66.6-29.2 70.6c-2.6 .3-5.2 .5-7.9 .5c-16.5 0-31.2-7.2-41.5-18.5c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5c-4 0-7.9 .8-11.6 2.2L382.7 224c.8 0 1.6 0 2.3 0zm-220.9-9.5l-29.7-23.4c-3.3 .6-6.7 .9-10.1 .9c-2.6 0-5.2-.2-7.9-.5c-20.7-2.8-35.9-22.1-36.6-43.5l-29-22.9c-12 43.2 14 91.7 61.3 98.1c4 .5 8.1 .8 12.1 .8c14.4 0 27.9-3.5 39.8-9.5zM378.8 384l-40.5-32H128V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v80 16 16 64c0 35.3 28.7 64 64 64H480c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4H160c-17.7 0-32-14.3-32-32V384H378.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faRoadCircleXmark = {
  prefix: 'fal',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M157.5 74c9.2-25.2 33.2-42 60.1-42H422.4c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H217.6c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43H339.2c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faSignalSlash = {
  prefix: 'fal',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", "M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V363.9l32 25.3V16zM432 496c0 8.8 7.2 16 16 16s16-7.2 16-16V451.2L432 426v70zm32-384c0-8.8-7.2-16-16-16s-16 7.2-16 16V262.9l32 25.3V112zM304 324.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V350.2l-32-25.3zM192 288c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-8.8-7.2-16-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faUserMinus = {
  prefix: 'fal',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM432 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faMarsStrokeUp = {
  prefix: 'fal',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", "M171.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 54.6V128H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32.8C63.1 200.8 0 269 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-83-63.1-151.2-144-159.2V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V54.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zM160 480a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faMarsStrokeV = faMarsStrokeUp;
var faChampagneGlasses = {
  prefix: 'fal',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M98.1 186.2C73.2 233.5 95.7 292 146 310.3s105.1-12 116.5-64.3l10.9-50.1L122 140.8 98.1 186.2zm182.1-21.9l19.2-88.6L179.3 32 137 112.2l143.2 52.1zm-210.4 7L150.9 17.1c7.5-14.2 24.2-20.6 39.3-15.2L310.4 45.7c3.6 1.3 6.8 3.2 9.6 5.6c2.8-2.4 6-4.3 9.6-5.6L449.8 1.9c15-5.5 31.8 1 39.3 15.2l81.2 154.2c31.4 59.7 7.4 132.3-50.6 162.6l42 115.4 56.9-20.7c8.3-3 17.5 1.3 20.5 9.6s-1.3 17.5-9.6 20.5l-71.9 26.2L485.6 511c-8.3 3-17.5-1.3-20.5-9.6s1.3-17.5 9.6-20.5l56.9-20.7-42-115.4c-63.9 14.1-129-26.1-143.3-92L320 131.8l-26.2 121c-14.3 65.9-79.4 106.2-143.3 92l-42 115.4L165.4 481c8.3 3 12.6 12.2 9.6 20.5s-12.2 12.6-20.5 9.6L82.5 484.9 10.5 458.7c-8.3-3-12.6-12.2-9.6-20.5s12.2-12.6 20.5-9.6l56.9 20.7 42-115.4c-58-30.3-82-102.9-50.6-162.6zm472.1 14.9L518 140.8 366.6 195.9 377.5 246c11.3 52.3 66.2 82.5 116.5 64.3s72.8-76.7 47.9-124.1zM359.8 164.3L503 112.2 460.7 32 340.6 75.7l19.2 88.6z"]
};
var faGlassCheers = faChampagneGlasses;
var faTaco = {
  prefix: 'fal',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M257.1 61.2l44.1 34.2 17-22-17 22c10.9 8.5 24.4 12.8 38.2 12.4l55.8-1.7c.8 0 1.6 .5 1.8 1.3l15.6 53.6c3.9 13.3 12.2 24.8 23.6 32.5l46.1 31.4c.7 .5 1 1.4 .7 2.1c-1.4 3.8-3.4 8.3-6.3 14.8c-1.9 4.2-4.1 9.1-6.2 14.2c7.6 8.5 14.6 17.4 21.2 26.7c2.7-10 7.3-20.3 11.5-29.7c2.6-5.8 5.1-11.3 6.8-16.2c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8L424.7 99.3c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1 .2-14.1-2-19.7-6.4L274.8 38.4c-11-8.6-26.5-8.6-37.5 0L193.1 72.6c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1L71.7 152.9c-2 6.8-6.3 12.8-12.2 16.8L13.4 201C1.9 208.9-2.9 223.6 1.8 236.7C3.6 241.6 6 247.1 8.7 253c4.2 9.4 8.8 19.6 11.5 29.7c6.5-9.3 13.6-18.2 21.2-26.7c-2.1-5.1-4.3-10-6.2-14.2c-2.9-6.5-4.9-11-6.3-14.8c-.3-.8 0-1.7 .7-2.1l46.1-31.4c11.4-7.8 19.8-19.3 23.6-32.5L115 107.4c.2-.8 1-1.3 1.8-1.3l55.8 1.7c13.8 .4 27.3-4 38.2-12.4l44.1-34.2c.7-.5 1.6-.5 2.2 0zM256 224c123.7 0 224 100.3 224 224H32c0-123.7 100.3-224 224-224zM32 480H480c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zm80-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHexagonPlus = {
  prefix: 'fal',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM240 352V272H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlusHexagon = faHexagonPlus;
var faClipboard = {
  prefix: 'fal',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M192 32c-22.3 0-41.2 15.3-46.5 36c-1.8 7.1-8.2 12-15.5 12H112c-8.8 0-16 7.2-16 16v32h96 96V96c0-8.8-7.2-16-16-16H254c-7.3 0-13.7-4.9-15.5-12c-5.3-20.7-24.1-36-46.5-36zM118.7 48C131 19.8 159.2 0 192 0s61 19.8 73.3 48H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h2.7C73.3 61.4 91.1 48 112 48h6.7zM320 128c0 17.7-14.3 32-32 32H192 96c-17.7 0-32-14.3-32-32V112c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32v16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faHouseCircleExclamation = {
  prefix: 'fal',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9H240V480h16 80 24.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faFileArrowUp = {
  prefix: 'fal',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 278.6V400c0 8.8 7.2 16 16 16s16-7.2 16-16V278.6z"]
};
var faFileUpload = faFileArrowUp;
var faWifi = {
  prefix: 'fal',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M27.3 184.4C102.4 110 205.8 64 320 64s217.6 46 292.7 120.4c6.3 6.2 16.4 6.2 22.6-.1s6.2-16.4-.1-22.6C554.3 81.5 442.9 32 320 32S85.7 81.5 4.7 161.7c-6.3 6.2-6.3 16.3-.1 22.6s16.3 6.3 22.6 .1zM320 224c70.5 0 134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0C185.6 252.5 249.5 224 320 224zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faMessages = {
  prefix: 'fal',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", "M202.7 288H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V256c0 17.7 14.3 32 32 32H96c17.7 0 32 14.3 32 32v16l55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V352 320H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64zM320 448c-35.3 0-64-28.7-64-64V352h32v32c0 17.7 14.3 32 32 32H437.3c6.9 0 13.7 2.2 19.2 6.4L512 464V448c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H448V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v32 16c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320z"]
};
var faCommentsAlt = faMessages;
var faBath = {
  prefix: 'fal',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M93.3 32C77.1 32 64 45.1 64 61.3V256H448h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 64 32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V61.3C32 27.4 59.4 0 93.3 0c16.2 0 31.8 6.5 43.3 17.9L161.7 43c11.1-7 24.2-11 38.3-11c20.2 0 38.5 8.3 51.6 21.8l1.1-1.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-104 104c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3L113.9 40.6C108.5 35.1 101 32 93.3 32zM32 320H64v48c0 26.2 12.6 49.4 32 64h0v0c13.4 10 30 16 48 16H368c18 0 34.6-6 48-16v0h0c19.4-14.6 32-37.8 32-64V320h32v48c0 30.5-12.2 58.2-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V446.4C44.2 426.2 32 398.5 32 368V320zM200 64c-22.1 0-40 17.9-40 40c0 11.4 4.8 21.7 12.4 29L229 76.4C221.7 68.8 211.4 64 200 64z"]
};
var faBathtub = faBath;
var faUmbrellaSimple = {
  prefix: 'fal',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32.5C116.7 40.1 17 134.9 2 256.1C-.2 273.6 14.3 288 32 288H480c17.7 0 32.2-14.4 30-31.9C495 134.9 395.3 40.1 272 32.5V16zm0 430.6V320H240V446.6c0 18.5-15 33.4-33.4 33.4c-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7C159.1 498 181.8 512 206.6 512c36.1 0 65.4-29.3 65.4-65.4zM256 64c112.8 0 206.2 83.5 221.7 192H34.3C49.8 147.5 143.2 64 256 64z"]
};
var faUmbrellaAlt = faUmbrellaSimple;
var faRectangleHistoryCirclePlus = {
  prefix: 'fal',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", "M480 192v.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V192c0-35.3-28.7-64-64-64L64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64l330.8 0c-12.9-9.1-24.5-19.9-34.6-32L64 480c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zM448 64L64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faUnderline = {
  prefix: 'fal',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M0 48c0-8.8 7.2-16 16-16H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H96V224c0 70.7 57.3 128 128 128s128-57.3 128-128V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V64H16C7.2 64 0 56.8 0 48zM0 464c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faPrescriptionBottlePill = {
  prefix: 'fal',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M336 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H336zM48 0C21.5 0 0 21.5 0 48V80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160V448c0 35.3 28.7 64 64 64H288c11.6 0 22.4-3.1 31.8-8.4c-8.9-7.3-17-15.5-24.3-24.5c-2.4 .6-4.9 .9-7.5 .9H96c-17.7 0-32-14.3-32-32V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V320h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V160H32zm320 0H320v72.2c9.8-8.1 20.6-15.2 32-21V160zm80 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm36.7-84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96z"]
};
var faUserPen = {
  prefix: 'fal',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H322.2l-1 3.8c-2.4 9.5-1.8 19.3 1.4 28.2H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c44.2 0 84.6 16.1 115.8 42.7l-22.7 22.7c-25.3-20.9-57.7-33.4-93.1-33.4H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM582.8 264c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L600.2 304c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L552.7 351.4l-40-40L406.5 417.7zM537.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L537.5 241.4z"]
};
var faUserEdit = faUserPen;
var faBinarySlash = {
  prefix: 'fal',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", "M448 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H368c-6.3 0-11.8 3.7-14.4 9l29.1 23H432h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V16zM320 144V80c0-44.2-35.8-80-80-80H208c-27.2 0-51.2 13.5-65.6 34.2l25.2 19.9C176.1 40.8 191 32 208 32h32c26.5 0 48 21.5 48 48v64c0 1.7-.1 3.4-.3 5l27.6 21.8c3-8.4 4.6-17.4 4.6-26.8zm0 224v64c0 44.2 35.8 80 80 80h32c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9C463.9 471.2 449 480 432 480H400c-26.5 0-48-21.5-48-48V368c0-1.7 .1-3.4 .3-5l-27.6-21.8c-3 8.4-4.6 17.4-4.6 26.8zm-96-64c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V304zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faSquareO = {
  prefix: 'fal',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faSignature = {
  prefix: 'fal',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M160 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L155 243.7c-34.8 9.5-59 41.1-59 77.2v92.6c0 36.7 29.8 66.5 66.5 66.5c24 0 46.2-13 57.9-33.9L247.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H425.9l52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3L314.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V128zm3.4 146.6l109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6c-19 0-34.5-15.4-34.5-34.5V320.9c0-21.6 14.5-40.6 35.4-46.3zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H48c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H336z"]
};
var faStroopwafel = {
  prefix: 'fal',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM142.9 120.2l45.3 45.3 45.3-45.3L210.7 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 45.3-45.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-45.3 45.3 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256 437 278.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 45.3 45.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.3-45.3-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-45.3 45.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l45.3-45.3-45.3-45.3L97.6 301.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3-45.3-45.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm45.3 90.5L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zm181 45.3l-45.3-45.3L278.6 256l45.3 45.3L369.1 256zm-67.9 67.9L256 278.6l-45.3 45.3L256 369.1l45.3-45.3zM210.7 188.1L256 233.4l45.3-45.3L256 142.9l-45.3 45.3z"]
};
var faBold = {
  prefix: 'fal',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M0 48c0-8.8 7.2-16 16-16H48 80 232c66.3 0 120 53.7 120 120c0 38.8-18.4 73.3-46.9 95.2C351.1 264 384 308.1 384 360c0 66.3-53.7 120-120 120H80 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V256 64H16C7.2 64 0 56.8 0 48zM64 448H80 264c48.6 0 88-39.4 88-88s-39.4-88-88-88H232 64V448zm0-208H232c48.6 0 88-39.4 88-88s-39.4-88-88-88H80 64V240z"]
};
var faAnchorLock = {
  prefix: 'fal',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c18.3 0 36-2.8 52.6-8c-3-7.4-4.6-15.5-4.6-24v-8.2c-15 5.3-31.2 8.2-48 8.2H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faBuildingNgo = {
  prefix: 'fal',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", "M320 32H64c-11.8 0-22.2 6.4-27.7 16H2C9.1 20.4 34.2 0 64 0H320c29.8 0 54.9 20.4 62 48H347.7c-5.5-9.6-15.9-16-27.7-16zM0 240H32V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V240h32V448c0 35.3-28.7 64-64 64H256 224 160 128 64c-35.3 0-64-28.7-64-64V240zM192 384c-17.7 0-32 14.3-32 32v64h64V416c0-17.7-14.3-32-32-32zM168 80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V96c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V128zM61.3 87.1l34.7 52V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM208 264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V264zm32 8v32h32V272H240zM104 240h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V264c0-13.3 10.7-24 24-24zm8 64h32V272H112v32z"]
};
var faTransporter3 = {
  prefix: 'fal',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", "M480 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V16zM64 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V160H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V112zM256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zM144 448c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16s7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144zm16-304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.1 16-15.9l0-.1 0-.1c0-8.8-7.2-15.9-16-15.9H112c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faEngineWarning = {
  prefix: 'fal',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M416 80c0 8.8-7.2 16-16 16l-80 0v32h16 60.6c12.6 0 25 3.7 35.5 10.7L483.5 173c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-26.5 0-48-21.5-48-48V272H88 32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80H88h8V176c0-26.5 21.5-48 48-48h16H288V96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H400c8.8 0 16 7.2 16 16zM304 160H160 144c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16h28.8c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12H448c17.7 0 32-14.3 32-32V226.3c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4H336 304l0 0 0 0zm304 64H576V416h32V224zm-32-32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm-272 0c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM280 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faEngineExclamation = faEngineWarning;
var faCircleDownRight = {
  prefix: 'fal',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm80 328c0 4.4-3.6 8-8 8H214.6c-3.7 0-6.6-3-6.6-6.6c0-1.8 .7-3.4 1.9-4.7l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6l-59.1-59.1c-3.6-3.6-4.9-9-3.3-13.9c.7-2 1.8-3.8 3.3-5.3l22.1-22.1c1.5-1.5 3.3-2.6 5.3-3.3c4.9-1.6 10.3-.4 13.9 3.3l59.1 59.1c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c1.2-1.2 2.9-1.9 4.7-1.9c3.7 0 6.6 3 6.6 6.6V328zm-8 40c22.1 0 40-17.9 40-40V214.6c0-21.3-17.3-38.6-38.6-38.6c-10.2 0-20.1 4.1-27.3 11.3L288 201.4l-47.7-47.7c-12.2-12.2-30.3-16.5-46.7-11c-6.7 2.2-12.8 6-17.8 11l-22.1 22.1c-5 5-8.8 11.1-11 17.8c-5.5 16.4-1.2 34.5 11 46.7L201.4 288l-14.1 14.1c-7.2 7.2-11.3 17.1-11.3 27.3c0 21.3 17.3 38.6 38.6 38.6H328z"]
};
var faSquareK = {
  prefix: 'fal',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm315.1 59.5l-87.3 84.3 89 118.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L204.6 262.2 160 305.3V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V298.5 144c0-8.8 7.2-16 16-16s16 7.2 16 16V260.8L292.9 132.5c6.4-6.1 16.5-6 22.6 .4s6 16.5-.4 22.6z"]
};
var faManatSign = {
  prefix: 'fal',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M192 32c-8.8 0-16 7.2-16 16V96.7C77.4 104.8 0 187.3 0 288V464c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-83 63.1-151.2 144-159.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V128.8c80.9 8 144 76.2 144 159.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-100.7-77.4-183.2-176-191.3V48c0-8.8-7.2-16-16-16z"]
};
var faMoneyCheckPen = {
  prefix: 'fal',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M64 96H512c17.7 0 32 14.3 32 32v69.6c10.2-4 21.1-5.9 32-5.6V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.2l8-32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 208c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm486.8 56l17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40L560.2 264c6.2-6.2 16.4-6.2 22.6 0zM406.5 417.7L512.7 311.5l40 40L446.4 457.7c-2.1 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zM537.5 241.4L383.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2L446.8 493c8.4-2.1 16.1-6.5 22.3-12.6L622.8 326.6c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faMoneyCheckEdit = faMoneyCheckPen;
var faNotEqual = {
  prefix: 'fal',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M377.1 34.8c7.3 5 9.1 15 4 22.3L321 144h95c8.8 0 16 7.2 16 16s-7.2 16-16 16H298.8L188.1 336H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H165.9L93.2 473.1c-5 7.3-15 9.1-22.3 4s-9.1-15-4-22.3L127 368H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H149.2L259.9 176H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H282.1L354.8 38.9c5-7.3 15-9.1 22.3-4z"]
};
var faBorderTopLeft = {
  prefix: 'fal',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 448c0 8.8 7.2 16 16 16s16-7.2 16-16L32 96c0-17.7 14.3-32 32-32l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32C28.7 32 0 60.7 0 96L0 448zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-96 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBorderStyle = faBorderTopLeft;
var faMapLocationDot = {
  prefix: 'fal',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M366.6 155c6.7-15.9 9.4-27.6 9.4-35c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 7.4 2.7 19 9.4 35c6.5 15.4 15.7 32.4 26.4 49.7c17.1 27.8 36.9 54.7 52.2 74.4c15.3-19.7 35.1-46.6 52.2-74.4c10.7-17.3 19.9-34.3 26.4-49.7zM302.8 312c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120c0 54.6-73.1 151.9-105.2 192zm103.1-89.1c-.8 .3-1.7 .6-2.5 .8c8.2-14.2 15.7-28.7 21.8-42.9l117.9-47.2c15.8-6.3 32.9 5.3 32.9 22.3V426.6c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 448.9l-144 57.6C17.1 512.8 0 501.2 0 484.2V213.4c0-9.8 6-18.6 15.1-22.3l123.2-49.3c2.1 10.4 5.4 20.8 9.2 30.8L32 218.8V472.4l128-51.2V304c0-8.8 7.2-16 16-16s16 7.2 16 16V419.9l192 54.9V304c0-8.8 7.2-16 16-16s16 7.2 16 16V472.4l128-51.2V167.6L405.9 222.9zM288 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMapMarkedAlt = faMapLocationDot;
var faTilde = {
  prefix: 'fal',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", "M96.8 160C61.2 160 32 188.8 32 224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-53.2 43.9-96 96.8-96c29.4 0 57.6 13.5 75.9 36.7l128 162.8c12.1 15.4 31 24.5 50.7 24.5c35.5 0 64.8-28.8 64.8-64V192c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 53.2-43.9 96-96.8 96c-29.4 0-57.6-13.5-75.9-36.7l-128-162.9c-12.1-15.4-31-24.5-50.7-24.5z"]
};
var faJedi = {
  prefix: 'fal',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M288 0c8.8 0 16 7.2 16 16V280.9l36.1-24.1c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1l-23.9 35.8 42.2 8.4c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8l-42.2 8.4 23.9 35.8c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1L304 359.1v71.7c54.3-7.8 96-54.4 96-110.9c0-36.2-17.1-68.3-43.8-88.8c-4.2-3.2-6.5-8.3-6.2-13.6s3.2-10.1 7.8-12.8C397.5 181 424 137.6 424 88c0-20.3-4.5-39.6-12.4-56.9c-3-6.5-1.3-14.1 4-18.8s13.2-5.2 19.1-1.4C510 59.3 560 143.8 560 240c0 150.2-121.8 272-272 272S16 390.2 16 240C16 143.8 66 59.3 141.3 10.9c6-3.8 13.8-3.3 19.1 1.4s7 12.3 4 18.8C156.5 48.4 152 67.7 152 88c0 49.6 26.5 93 66.2 116.8c4.5 2.7 7.4 7.5 7.8 12.8s-2 10.4-6.2 13.6C193.1 251.7 176 283.8 176 320c0 56.4 41.7 103.1 96 110.9V359.1l-36.1 24.1c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1l23.9-35.8-42.2-8.4c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l42.2-8.4-23.9-35.8c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1L272 280.9V16c0-8.8 7.2-16 16-16zM64.1 153.5l43.2 43.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L53.6 188.2c-2.2 9.9-3.8 20.1-4.7 30.5c.8 .6 1.6 1.2 2.4 2l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L49.2 263.8C61.1 385.2 163.5 480 288 480s226.9-94.8 238.8-216.2l-35.5 35.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l56-56c.7-.7 1.5-1.4 2.4-2c-.9-10.4-2.5-20.5-4.7-30.5l-31.1 31.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l43.2-43.2c-12.7-32.8-32.3-62.1-57.2-86.1C455.6 74.1 456 81 456 88c0 53.6-25.1 101.4-64.2 132.1C416.7 246 432 281.2 432 320c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.8 15.3-74 40.2-99.9C145.1 189.4 120 141.6 120 88c0-7 .4-13.9 1.3-20.6c-24.8 24-44.5 53.3-57.2 86.1z"]
};
var faSquarePollVertical = {
  prefix: 'fal',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 224c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zM320 288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faPoll = faSquarePollVertical;
var faArrowDownSquareTriangle = {
  prefix: 'fal',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v96zm64 147.5L341.3 448H490.7L416 323.5zM320 176V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48zM307.6 442l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9z"]
};
var faSortShapesDownAlt = faArrowDownSquareTriangle;
var faMugHot = {
  prefix: 'fal',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", "M80 0C71.2 0 64 7.2 64 16c0 24.7 9.8 48.5 27.3 65.9l18.7 18.7C121.5 112.2 128 127.8 128 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9L113.9 59.3C102.5 47.8 96 32.2 96 16C96 7.2 88.8 0 80 0zM32 224H336h16V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V224zm352 0h16c44.2 0 80 35.8 80 80s-35.8 80-80 80H384V224zm0 192h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 336 32c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 24.7 9.8 48.5 27.3 65.9l18.7 18.7C249.5 112.2 256 127.8 256 144c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9L241.9 59.3C230.5 47.8 224 32.2 224 16z"]
};
var faDogLeashed = {
  prefix: 'fal',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M67.4 6.1C72.9-.8 82.9-2 89.9 3.4L307 174 331.9 24.8C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32h44.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96H437.3L432 256V456c0 30.9-25.1 56-56 56H360c-30.9 0-56-25.1-56-56V408.7 375.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1v33.3V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V208c0-.7 0-1.4 .1-2c-.7-.2-1.4-.3-2.1-.5c-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6C54.5 169.7 67.6 176 82 176H96h40 24 97.7L70.1 28.6C63.2 23.1 62 13.1 67.4 6.1zM322.9 349.5c8.2 6 13.1 15.6 13.1 25.8V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V261.9l-.1 0L307.6 208c-.3 0-.7 0-1 0H288V346.7c2.1-.6 4.2-1.2 6.3-1.9c9.7-3.1 20.4-1.4 28.6 4.6zM256 351.8V208H160 136 96V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V375.3c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2c2.7 0 5.4-.1 8-.2zM405.8 218.7c2.6-15.4 15.9-26.7 31.6-26.7H480c35.3 0 64-28.7 64-64V112c0-8.8-7.2-16-16-16H496c-8.5 0-16.6-3.4-22.6-9.4L455.4 68.7c-3-3-7.1-4.7-11.3-4.7H400c-10.1 0-19.6-4.7-25.6-12.8L362.5 35.4 338.2 181.3c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faCarBattery = {
  prefix: 'fal',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M64 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm256 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16zM64 160c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM0 192c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm368 16c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V224c0-8.8 7.2-16 16-16zM96 256h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBatteryCar = faCarBattery;
var faFaceDowncastSweat = {
  prefix: 'fal',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M79.8 68.6c5.4 8.5 9.8 16.4 12.8 23.1c2.6 5.8 3.2 8.8 3.4 9.6c0 .2 0 .2 0 .1C96 113.5 84.3 128 64 128s-32-14.5-32-26.7c0 .1 0 .1 0-.1c.2-.7 .8-3.7 3.4-9.5c3-6.7 7.4-14.6 12.8-23.1c5-7.9 10.5-15.8 15.8-23c5.3 7.2 10.8 15.1 15.8 23zM72.5 4.1c-4.3-5.5-12.8-5.5-17.1 0C38.1 25.8 0 76.3 0 101.3C0 133.8 28.7 160 64 160s64-26.2 64-58.7c0-25-37.9-75.5-55.5-97.2zM256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224S32 379.7 32 256c0-20.7 2.8-40.7 8.1-59.7c2.4-8.5-2.6-17.3-11.2-19.7s-17.3 2.6-19.7 11.2C3.2 209.5 0 232.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0c-43.1 0-83.8 10.7-119.5 29.5c-7.8 4.1-10.8 13.8-6.7 21.6S143.7 62 151.5 57.8C182.7 41.3 218.2 32 256 32zM96 272c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zM173.3 411.9c6.6 5.9 16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6C323.8 371.4 295.7 352 256 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6z"]
};
var faMailboxFlagUp = {
  prefix: 'fal',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M352 208V112 56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24l-72 0v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zM448 96V64l-64 0V96l64 0zM320 64V96H234.5c32.6 26.4 53.5 66.8 53.5 112V384c0 11.7-3.1 22.6-8.6 32H512c17.7 0 32-14.3 32-32V208c0-32.7-14-62-36.3-82.5c2.7-6.6 4.3-13.9 4.3-21.5V88.2c38.6 25.8 64 69.8 64 119.8V384c0 35.3-28.7 64-64 64H224 64c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64H320zM224 416c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112S32 146.1 32 208V384c0 17.7 14.3 32 32 32H224zM96 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16z"]
};
var faMemoCircleInfo = {
  prefix: 'fal',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm464 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16V384c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h0c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 416c-8.8 0-16-7.2-16-16z"]
};
var faGift = {
  prefix: 'fal',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M365.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H288h80c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96l-45-72.1C180.8 41 164.5 32 146.9 32H144c-26.5 0-48 21.5-48 48s21.5 48 48 48h80 11.1zM256 101l38.8-62c15.2-24.2 41.7-39 70.3-39H368c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h32c26.5 0 48 21.5 48 48v64c0 20.9-13.4 38.7-32 45.3V288 448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288v-2.7C13.4 278.7 0 260.9 0 240V176c0-26.5 21.5-48 48-48H80C70 114.6 64 98 64 80C64 35.8 99.8 0 144 0h2.9c28.6 0 55.2 14.7 70.3 39L256 101zM144 160H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H64 240V160H224 144zm128 0v96H448h16c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368 288 272zM240 288H64V448c0 17.7 14.3 32 32 32H240V288zm32 192H416c17.7 0 32-14.3 32-32V288H272V480z"]
};
var faDiceTwo = {
  prefix: 'fal',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faVolume = {
  prefix: 'fal',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M320 66.7L183.6 188c-2.9 2.6-6.7 4-10.6 4H88c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h85c3.9 0 7.7 1.4 10.6 4L320 445.3V66.7zM302.4 39.5c5.5-4.8 12.5-7.5 19.8-7.5C338.7 32 352 45.3 352 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L166.9 352H88c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L302.4 39.5zM419.2 182.4c5.3-7.1 15.3-8.5 22.4-3.2C464.9 196.7 480 224.6 480 256s-15.1 59.3-38.4 76.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4C438 295.5 448 276.9 448 256s-10-39.5-25.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4zm87-74.5C548.8 143.1 576 196.4 576 256s-27.2 112.9-69.8 148.1c-6.8 5.6-16.9 4.7-22.5-2.1s-4.7-16.9 2.1-22.5C521.4 350.1 544 305.7 544 256s-22.6-94.1-58.2-123.4c-6.8-5.6-7.8-15.7-2.1-22.5s15.7-7.8 22.5-2.1z"]
};
var faVolumeMedium = faVolume;
var faTransporter5 = {
  prefix: 'fal',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", "M464 0c-8.8 0-16 7.2-16 16V32H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V16c0-8.8-7.2-16-16-16zM48 128c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V144c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zM160 144c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm64 128c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 96c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faGaugeCircleBolt = {
  prefix: 'fal',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356H552c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380H440c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faCoinFront = {
  prefix: 'fal',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm16-272c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"]
};
var faFileSlash = {
  prefix: 'fal',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", "M512 163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-23 0-43.2 12.2-54.5 30.4L163 50.5C168.1 39.6 179.2 32 192 32H320V144c0 26.5 21.5 48 48 48H480V300.8L512 326V163.9zM160 448V211.2L128 186V448c0 35.3 28.7 64 64 64H448c23 0 43.2-12.2 54.5-30.4L477 461.5c-5.1 10.9-16.2 18.5-29 18.5H192c-17.7 0-32-14.3-32-32zM479.5 160H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMessageArrowUpRight = {
  prefix: 'fal',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L172.7 268.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 182.6V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H192z"]
};
var faTreasureChest = {
  prefix: 'fal',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", "M128 64V256h64V224c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32h64V64H128zM320 384H256c-35.3 0-64-28.7-64-64V288H128V448H448V288H384v32c0 35.3-28.7 64-64 64zM96 69.5C58.7 82.6 32 118.2 32 160v96H96V69.5zM32 288V432c0 8.8 7.2 16 16 16H96V288H32zM480 448h48c8.8 0 16-7.2 16-16V288H480V448zm64-192V160c0-41.8-26.7-77.4-64-90.5V256h64zM0 160C0 89.3 57.3 32 128 32H448c70.7 0 128 57.3 128 128V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V160zm320 32H256c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zm-16 48v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessQueen = {
  prefix: 'fal',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zm-95.2 0c-14 0-24.5 10-28 21.3c-9 29.4-36.5 50.8-68.8 50.8c-12.1 0-23.4-3-33.4-8.2c-5.6-3-12.6-3.1-18.6 0c-10.1 5.4-13.5 18.2-7.5 28L97.1 352h37.7L49.3 215.1c4.8 .7 9.7 1 14.7 1c44.8 0 82.9-28.3 97.5-67.9C181.4 179.3 216.3 200 256 200s74.6-20.7 94.5-51.8c14.7 39.6 52.8 67.9 97.5 67.9c5 0 9.9-.4 14.7-1L377.1 352h37.7l92.6-148.2c5.9-9.5 2.8-22.1-7-27.6c-6.1-3.5-13.3-3.4-19.1-.3c-10 5.3-21.4 8.2-33.5 8.2c-32.4 0-59.8-21.4-68.8-50.8c-3.5-11.3-13.9-21.3-28-21.3c-11.3 0-20.6 6.6-25.4 15.2C312 151.6 285.9 168 256 168s-56-16.4-69.8-40.8c-4.8-8.6-14.1-15.2-25.4-15.2zm-31 304l252.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H103.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L129.8 416zm252.4-32H129.8c-11.1 0-21.4 5.7-27.2 15.1L69.9 451.8C66.1 458 64 465.2 64 472.6c0 21.8 17.7 39.4 39.4 39.4H408.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faPaintbrushFine = {
  prefix: 'fal',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M534.5 41.4c-12.5-12.5-32.8-12.5-45.3 0L324.6 206l45.3 45.3L534.5 86.6c12.5-12.5 12.5-32.8 0-45.3zM302 228.6l-36.6 36.6 0 0L224.6 306l45.3 45.3 4.6-4.6 0 0 36.1-36.1 36.6-36.6L302 228.6zM195.9 322.5c-6.3-1.6-13-2.5-19.9-2.5c-44.2 0-80 35.8-80 80c0 2.8 .1 5.6 .4 8.3c1.7 16.7-3 33.6-12.5 46.7C74.3 468.5 58 480 36.8 480H176c44.2 0 80-35.8 80-80c0-6.9-.9-13.5-2.5-19.9l-57.7-57.7zM557.2 109.3L286.3 380.2c1.1 6.4 1.7 13.1 1.7 19.8c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c6.7 0 13.3 .6 19.7 1.7l271-271c25-25 65.5-25 90.5 0s25 65.5 0 90.5z"]
};
var faPaintBrushAlt = faPaintbrushFine;
var faPaintBrushFine = faPaintbrushFine;
var faPaintbrushAlt = faPaintbrushFine;
var faGlasses = {
  prefix: 'fal',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L38.1 274.4c31-12 65-18.4 97.6-18.4c40.1 0 82.2 9.6 118.5 27.3c2.6 1.3 4.9 2.9 7 4.7h53.7c2.1-1.8 4.4-3.4 7-4.7c36.2-17.8 78.4-27.3 118.5-27.3c32.6 0 66.6 6.3 97.6 18.4L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7c29 0 54.2 19.6 61.5 47.6l50.7 196.6c3 11.8 4.6 23.8 4.6 36V352c0 .2 0 .3 0 .5V368c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L304.4 320H271.6l-3.4 54.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 312.2 312l0-.2c0-12 1.6-23.9 4.6-35.5L55.3 79.6C62.5 51.6 87.8 32 116.8 32c9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM32 312l0 .2V352v16c0 44.2 35.8 80 80 80h44.3c42.5 0 77.5-33.2 79.9-75.6l0-.2 0 0L240 312l0 0c0 0 0 0 0-.1c-31.8-15.5-69-24-104.3-24c-35.1 0-72.2 8.4-103.7 24zm512 0c-31.4-15.6-68.6-24-103.7-24c-35.3 0-72.5 8.5-104.3 24c0 0 0 0 0 .1l0 0 3.8 60.2 0 0 0 .2c2.4 42.4 37.4 75.6 79.9 75.6H464c44.2 0 80-35.8 80-80V312z"]
};
var faHoodCloak = {
  prefix: 'fal',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", "M32 480l.4-.4 .2-.2 0 0 .1-.1C81.7 427 96 348.2 96 288c0-128 44-192 90-224c46-32 94-32 102-32H412.6c-1.2 1-2.7 2.2-4.2 3.5c-4.4 3.6-9.8 8-13.7 11.6c-6.7 6.1-10.5 14.7-10.5 23.8s3.9 17.7 10.6 23.7C438.8 134.2 480 195.8 480 288c0 60.2 14.3 139 63.3 191.3l0 0 .1 .1c.2 .2 .4 .4 .6 .6H416V320c0-70.7-57.3-128-128-128s-128 57.3-128 128V480H32zm160 0V320c0-53 43-96 96-96s96 43 96 96V480H192zm381.6 12.2c4.9-11.9 2.2-25.6-6.8-34.7l0 0-.1-.1C525.8 413.8 512 345 512 288c0-87-33.1-150.3-73.1-194.6c-7.4-8.2-15-15.7-22.7-22.6c3.5-3.2 7.4-6.3 11.3-9.5l0 0c4.5-3.7 9.1-7.4 13.3-11.4c4-3.7 7.7-7.7 10.7-11.9c4.7-6.5 5.9-15 2.9-22.7C450.8 6.1 441.9 0 432 0H288c-9.8 0-66 0-120.3 37.7C111.4 76.9 64 151.8 64 288c0 57.1-13.9 125.9-54.6 169.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8H544c12.9 0 24.6-7.8 29.6-19.8z"]
};
var faSquareQuote = {
  prefix: 'fal',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 286.4V232 216 200c0-22.1-17.9-40-40-40H136c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h32c2.7 0 5.4-.3 8-.8v15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4zM176 232c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v16 16zm176 0V216 200c0-22.1-17.9-40-40-40H280c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h32c2.7 0 5.4-.3 8-.8v15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4V232zm-32-16v16c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v16z"]
};
var faUpLeft = {
  prefix: 'fal',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", "M72 128c-4.4 0-8 3.6-8 8V337.4c0 3.7 3 6.6 6.6 6.6c1.8 0 3.4-.7 4.7-1.9l61.4-61.4c6.2-6.2 16.4-6.2 22.6 0L272 393.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6L329.4 368c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16L216.7 223.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l61.4-61.4c1.2-1.2 1.9-2.9 1.9-4.7c0-3.7-3-6.6-6.6-6.6H72zm-40 8c0-22.1 17.9-40 40-40H273.4c21.3 0 38.6 17.3 38.6 38.6c0 10.2-4.1 20.1-11.3 27.3L250.6 212 352 313.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6L326.6 416c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L148 314.6 97.9 364.7C90.7 371.9 80.9 376 70.6 376C49.3 376 32 358.7 32 337.4V136z"]
};
var faBringFront = {
  prefix: 'fal',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", "M64 32H192c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64h64V224H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM448 512H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H512v32h64c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32H384c0 35.3 28.7 64 64 64zM416 128c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H416zM224 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224zm32 96H384V320H256V192zm-32 0V320c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faChessBoard = {
  prefix: 'fal',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0h64 72 72 64c13.3 0 24 10.7 24 24v64 72 72 64c0 13.3-10.7 24-24 24H296 224 152 88c-13.3 0-24-10.7-24-24V328 256 184 120c0-13.3 10.7-24 24-24zm8 72h40V128H96v40zm72 0h40V128H168v40zm72 0h40V128H240v40zm72 0h40V128H312v40zm0 32v40h40V200H312zm0 72v40h40V272H312zm0 72v40h40V344H312zm-32 0H240v40h40V344zm-72 0H168v40h40V344zm-72 0H96v40h40V344zm0-32V272H96v40h40zm0-72V200H96v40h40zm32 0h40V200H168v40zm72 0h40V200H240v40zm0 32v40h40V272H240zm-32 0H168v40h40V272z"]
};
var faBurgerCheese = {
  prefix: 'fal',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M445 221.8C428.9 132.1 350.4 64 256 64S83.1 132.1 67 221.8l0 .1c0 .1 .1 .2 .3 .3c.7 .8 2.4 1.7 4.7 1.7H440c2.4 0 4-1 4.7-1.7c.1-.1 .2-.2 .3-.3l0-.1zM72 256c-22.1 0-40.4-18.1-36.5-39.8C54.3 111.5 145.9 32 256 32s201.7 79.5 220.5 184.2c3.9 21.7-14.4 39.8-36.5 39.8H416 224 72zm358.5 96H448c17.7 0 32 14.3 32 32c0 53-43 96-96 96H128c-53 0-96-43-96-96c0-17.7 14.3-32 32-32H209.5l48 32H64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64H382.5l48-32zM160 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 288H224c3.2 0 6.2 .9 8.9 2.7L320 348.8l87.1-58.1c2.6-1.8 5.7-2.7 8.9-2.7h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H420.8l-92 61.3c-5.4 3.6-12.4 3.6-17.8 0l-92-61.3H32c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCheeseburger = faBurgerCheese;
var faBuildingCircleCheck = {
  prefix: 'fal',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faRepeat1 = {
  prefix: 'fal',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M0 255.2C-.4 264 6.4 271.5 15.2 272s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112H320v44.4c0 15.2 12.3 27.6 27.6 27.6c6.8 0 13.4-2.5 18.4-7.1l76.7-69c3.4-3 5.3-7.4 5.3-11.9s-1.9-8.9-5.3-11.9L366 15.1C360.9 10.5 354.4 8 347.6 8C332.3 8 320 20.3 320 35.6V80H176.2C82.4 80 5.1 153.5 .4 247.2l-.4 8zM408.1 96L352 146.5l0-100.9L408.1 96zM512 256.8c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400L192 400l0-44.4c0-15.2-12.3-27.6-27.6-27.6c-6.8 0-13.4 2.5-18.4 7.1l-76.7 69c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l76.7 69c5.1 4.6 11.6 7.1 18.4 7.1c15.2 0 27.6-12.3 27.6-27.6l0-44.4 143.8 0c93.8 0 171.1-73.5 175.8-167.2l.4-8zM103.9 416L160 365.5l0 100.9L103.9 416zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L256 240v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"]
};
var faArrowDownToLine = {
  prefix: 'fal',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zM203.3 379.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 329.4V224 48c0-8.8 7.2-16 16-16s16 7.2 16 16V224 329.4L308.7 228.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128z"]
};
var faArrowToBottom = faArrowDownToLine;
var faGrid5 = {
  prefix: 'fal',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M24 56H40V72H24V56zM16 32C7.2 32 0 39.2 0 48V80c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm8 120H40v16H24V152zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H16zm8 136V248H40v16H24zM0 240v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM24 344H40v16H24V344zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H16zm8 136V440H40v16H24zM0 432v32c0 8.8 7.2 16 16 16H48c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM120 56h16V72H120V56zm-8-24c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H112zm8 136V152h16v16H120zM96 144v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm24 104h16v16H120V248zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H112zm8 136V344h16v16H120zM96 336v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm24 104h16v16H120V440zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H112zM216 72V56h16V72H216zM192 48V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm24 104h16v16H216V152zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H208zm8 136V248h16v16H216zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm24 104h16v16H216V344zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H208zm8 136V440h16v16H216zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM312 56h16V72H312V56zm-8-24c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H304zm8 136V152h16v16H312zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm24 104h16v16H312V248zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H304zm8 136V344h16v16H312zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm24 104h16v16H312V440zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H304zM408 72V56h16V72H408zM384 48V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zm24 104h16v16H408V152zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H400zm8 136V248h16v16H408zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16zm24 104h16v16H408V344zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H400zm8 136V440h16v16H408zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16z"]
};
var faSwapArrows = {
  prefix: 'fal',
  iconName: 'swap-arrows',
  icon: [640, 512, [], "e60a", "M100.7 20.7c6.2-6.2 16.4-6.2 22.6 0l88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L128 70.6V360c0 48.6 39.4 88 88 88s88-39.4 88-88V152c0-66.3 53.7-120 120-120s120 53.7 120 120V441.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-6.2 6.2-16.4 6.2-22.6 0l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L512 441.4 512 152c0-48.6-39.4-88-88-88s-88 39.4-88 88V360c0 66.3-53.7 120-120 120s-120-53.7-120-120V70.6L35.3 131.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88-88z"]
};
var faRightLongToLine = {
  prefix: 'fal',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M640 80l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-352c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 216L48 216c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l272 0c17.7 0 32 14.3 32 32l0 49.3c0 3.7 3 6.7 6.7 6.7c1.9 0 3.7-.8 5-2.2L476.2 256 363.7 130.2c-1.3-1.4-3.1-2.2-5-2.2c-3.7 0-6.7 3-6.7 6.7l0 49.3c0 17.7-14.3 32-32 32zm192 40c0 5.2-1.9 10.1-5.3 14L387.5 403.1c-7.3 8.2-17.8 12.9-28.8 12.9c-21.4 0-38.7-17.3-38.7-38.7l0-17.3 0-32-32 0L48 328c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l240 0 32 0 0-32 0-17.3c0-21.4 17.3-38.7 38.7-38.7c11 0 21.5 4.7 28.8 12.9L506.7 242c3.4 3.8 5.3 8.8 5.3 14z"]
};
var faPersonChalkboard = {
  prefix: 'fal',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160H224V320H160V164c6-2.6 12.5-4 19.3-4zM160 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V48c0-8.8 7.2-16 16-16H592c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V192H320v80c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 179.3c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faMarsStrokeRight = {
  prefix: 'fal',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M64 256a144 144 0 1 1 288 0A144 144 0 1 1 64 256zm319.3-16C375.2 150.3 299.8 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c91.8 0 167.2-70.3 175.3-160H432v48c0 8.8 7.2 16 16 16s16-7.2 16-16V272h89.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L553.4 240H464V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H383.3z"]
};
var faMarsStrokeH = faMarsStrokeRight;
var faHandBackFist = {
  prefix: 'fal',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", "M96 64c0-35.3 28.7-64 64-64c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c23.9 0 44.8 13.1 55.7 32.5c2.7-.4 5.5-.5 8.3-.5c35.3 0 64 28.7 64 64v80c0 49.6-25.1 93.3-63.2 119.2c-.4 .3-.6 .6-.7 .7c0 .1 0 .1-.1 .1l0 0V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V360.1c0-11.6 6.3-21.5 14.8-27.4C364.5 312.6 384 278.6 384 240V160c0-17.7-14.3-32-32-32c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C315.2 106 302.7 96 288 96c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C251.2 74 238.7 64 224 64c-4.2 0-8.2 .8-11.8 2.2c-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C187.2 42 174.7 32 160 32c-17.7 0-32 14.3-32 32v48 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L78.1 168.6c-9 9-14.1 21.2-14.1 33.9V256c0 44.2 29.9 81.5 70.6 92.6c13.5 3.7 25.4 15.8 25.4 32.1V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V380.7l0 0c0 0-.1-.1-.2-.3c-.3-.4-.8-.8-1.6-1C71.9 364.7 32 315 32 256V202.5c0-21.2 8.4-41.6 23.4-56.6L96 105.4V64z"]
};
var faHandRock = faHandBackFist;
var faGridRound5 = {
  prefix: 'fal',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M40 64A8 8 0 1 1 24 64a8 8 0 1 1 16 0zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm8 128a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM136 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM328 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faTally = {
  prefix: 'fal',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", "M128 32c8.8 0 16 7.2 16 16V297.8l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16V255.1l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16V212.5l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16V169.8l74.9-25c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2L528 203.5V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.2l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V256.9l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V299.5l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.2l-74.9 25c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L112 308.5V48c0-8.8 7.2-16 16-16z"]
};
var faTally5 = faTally;
var faSquareCaretUp = {
  prefix: 'fal',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 64c9.6 0 18.7 4 25.2 11l95.5 102.8c4.7 5.1 7.3 11.8 7.3 18.7c0 15.2-12.3 27.5-27.5 27.5h-201C108.3 320 96 307.7 96 292.5c0-6.9 2.6-13.6 7.3-18.7L198.8 171c6.5-7 15.6-11 25.2-11zm-1.7 32.7L133.8 288H314.2l-88.4-95.3c-.4-.5-1.1-.7-1.7-.7s-1.3 .3-1.7 .7z"]
};
var faCaretSquareUp = faSquareCaretUp;
var faCloudShowersWater = {
  prefix: 'fal',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", "M176.1 99.3C178.6 61.7 209.8 32 248 32c26.4 0 49.4 14.2 62 35.4c2.3 3.8 6 6.5 10.3 7.5s8.9 .1 12.5-2.4c7.7-5.3 17-8.4 27.2-8.4c23 0 42.2 16.1 46.9 37.7c1.6 7.3 8.1 12.6 15.6 12.6h18.6c21.5 0 38.9 17.4 38.9 38.9s-17.4 38.9-38.9 38.9H134.9C113.4 192 96 174.6 96 153.1s17.4-38.9 38.9-38.9h25.3c8.4 0 15.4-6.6 16-15zM248 0c-50 0-91.7 35.3-101.7 82.3H134.9C95.7 82.3 64 114 64 153.1s31.7 70.9 70.9 70.9H441.1c39.1 0 70.9-31.7 70.9-70.9s-31.7-70.9-70.9-70.9h-6.8C422.5 52.8 393.7 32 360 32c-11.1 0-21.7 2.3-31.3 6.4C309.6 15 280.6 0 248 0zM141.3 280.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480zM472.9 258.7c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2zM253.3 280.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zm107.6-22.2c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2z"]
};
var faChartBar = {
  prefix: 'fal',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBarChart = faChartBar;
var faHandsBubbles = {
  prefix: 'fal',
  iconName: 'hands-bubbles',
  icon: [608, 512, ["hands-wash"], "e05e", "M432 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM240 448c0 3.2-.2 6.4-.5 9.5C271.3 491 316.2 512 366.1 512H496c26.5 0 48-21.5 48-48c0-6.2-1.2-12.2-3.4-17.7C561 440.8 576 422.1 576 400c0-6.2-1.2-12.2-3.4-17.7C593 376.8 608 358.1 608 336s-15-40.8-35.4-46.3c2.2-5.5 3.4-11.4 3.4-17.7c0-26.5-21.5-48-48-48H419.8c12.2-13.6 16-33.7 8.1-51.5c-10.8-24.2-39.1-35.1-63.4-24.4l-69.1 30.7C232.5 206.8 192 269.1 192 337.9c0 9.6 .8 19.1 2.3 28.3C221.7 383.1 240 413.4 240 448zM31.9 224.2c-.4 55 25.1 106 67.4 138.8c12.6-6.7 26.9-10.6 42.1-11c-47.7-24.3-77.9-73.6-77.5-127.6l.5-75.7c.1-8.8 7.3-15.9 16.1-15.9s15.9 7.3 15.9 16.1l-.3 46.2c-.1 7.6 5.2 14.1 12.6 15.7s14.9-2.1 18-9L198.1 44.2c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-39.6 87.4c-3.6 8-.1 17.5 8 21.2s17.5 .1 21.2-8l39.6-87.4 13.2-29.1c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2L285.6 83.8l-39.1 86.4c11.1-7.9 23.1-14.8 35.9-20.5l0 0 .4-.2 10.2-4.4L314.7 97c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-7.2 15.9L377 108.6c2.1-20-8.6-40-27.9-48.7c-5.7-2.6-11.6-4-17.5-4.2C335 34.8 324.2 13.4 304 4.3s-43.3-3.2-56.8 13.1c-4.1-4.2-9-7.8-14.7-10.4C208.3-3.9 179.9 6.8 169 31l-44.6 98.6c-7.4-16.7-24.1-28.5-43.6-28.6c-26.5-.2-48.2 21.2-48.3 47.7l-.5 75.6zm345.6-46.9c8.1-3.6 17.5 0 21.1 8.1s0 17.5-8.1 21.1l-42.2 18.8c-6.9 3.1-10.7 10.6-9.2 17.9s8.1 12.7 15.7 12.7H528c8.8 0 16 7.2 16 16c0 8.8-7.1 16-16 16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h96l0 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544l0 0H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h96l0 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 0-15.9 0L432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 0c8.8 0 15.9 7.2 15.9 16c0 8.8-7.2 16-16 16H366.1C287.6 480 224 416.4 224 337.9c0-56.1 33.1-107 84.4-129.8l69.1-30.7zM112 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 80 448a64 64 0 1 0 128 0zM480 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faHandsWash = faHandsBubbles;
var faLessThanEqual = {
  prefix: 'fal',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M406.1 62.8c8.2-3.3 12.1-12.7 8.8-20.9s-12.7-12.1-20.9-8.8l-352 144c-6 2.5-9.9 8.3-9.9 14.8s3.9 12.3 9.9 14.8l352 144c8.2 3.3 17.5-.6 20.9-8.8s-.6-17.5-8.8-20.9L90.3 192 406.1 62.8zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faTrain = {
  prefix: 'fal',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M352 32c35.3 0 64 28.7 64 64V224H32V96c0-35.3 28.7-64 64-64H352zM32 352V256H416v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96V352c0 46 32.4 84.4 75.6 93.8L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L118.6 448H329.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352V96c0-53-43-96-96-96H96zM224 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faUpFromDottedLine = {
  prefix: 'fal',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", "M222.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 196.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H288c-8.8 0-16 7.2-16 16V344c0 4.4-3.6 8-8 8H184c-4.4 0-8-3.6-8-8V224c0-8.8-7.2-16-16-16H102.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 64.8zM224 32c-9.5 0-18.6 3.9-25.1 10.8L74.5 174.8C67.8 182 64 191.5 64 201.3c0 21.4 17.3 38.7 38.7 38.7H144V344c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V240h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 42.8C242.6 35.9 233.5 32 224 32zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faEyeLowVision = {
  prefix: 'fal',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1zM605.5 268.3c-10.3 24.6-28.3 57-53.9 89l-25.1-19.8C550.1 308 566.8 278.1 576 256c-13.3-32-42.1-80-85.2-120C447.7 96 390.4 64 320 64c-39.8 0-75.4 10.2-106.6 26.3L186.1 68.8C224 46.8 268.8 32 320 32c80.8 0 145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6zM448 256c0 6.3-.5 12.4-1.3 18.5l-30.9-24.4C412.8 199.8 371 160 320 160c-5.6 0-11.2 .5-16.5 1.4l-30.9-24.4c14.7-5.8 30.6-9.1 47.4-9.1c70.7 0 128 57.3 128 128zM106 163.5l320 256c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L86 188.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5zM67.5 238c5.5-6.9 15.6-8 22.5-2.5l250 200c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L70 260.5c-6.9-5.5-8-15.6-2.5-22.5zM106 336.3l124 99.2c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L86 361.3c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5z"]
};
var faLowVision = faEyeLowVision;
var faTrafficLightGo = {
  prefix: 'fal',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM160 448a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z"]
};
var faFaceExhaling = {
  prefix: 'fal',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c40.8 0 78.9-10.9 111.8-29.9c7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9C346.2 499.6 302.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C391.7 0 502.7 105.5 511.4 238.9c.6 8.8-6.1 16.4-14.9 17s-16.4-6.1-17-14.9C471.8 124.3 374.7 32 256 32zm.1 376.1a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm60.8-89.6c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm-121.6 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm299.6 49.6c26.1 0 47.4 19.2 51.3 44.1c17.9 10.3 29.9 29.7 29.9 51.9s-12 41.6-29.9 51.8c-3.9 24.9-25.3 44.2-51.3 44.2c-14.2 0-27-5.7-36.4-15c-2.2 .3-4.4 .4-6.6 .4c-27.3 0-49.4-21.1-51.7-47.7l-60.7-18.4c-6.7-2-11.4-8.3-11.4-15.3s4.6-13.3 11.4-15.3l62-18.8c5.5-22.9 25.9-40.1 50.5-40.1l.7 0c9.4-13.2 24.7-21.8 42.2-21.8zm-18.6 44.9c-3 7.7-11.2 11.8-19.2 9.6c-1.6-.5-3.4-.7-5.2-.7c-10.8 0-19.9 8.9-19.9 20.4c0 7-4.6 13.3-11.4 15.3l-21.4 6.5 22.1 6.7c7.8 2.4 12.6 10.3 11.1 18.4c-.2 1.3-.4 2.6-.4 4c0 11.4 9.1 20.4 19.9 20.4c2.5 0 4.8-.4 6.9-1.3c7.1-2.7 15.1 0 19.2 6.4c3.6 5.7 9.8 9.4 16.8 9.4c10.8 0 19.9-8.9 19.9-20.4c0-.4 0-.9 0-1.3c-.4-7.2 4-13.8 10.8-16.1c10.7-3.6 18.5-14 18.5-26.2s-7.8-22.6-18.5-26.2c-6.8-2.3-11.2-8.9-10.8-16.1c0-.4 0-.9 0-1.3c0-11.4-9.1-20.4-19.9-20.4c-8.3 0-15.6 5.2-18.6 12.9z"]
};
var faSensorFire = {
  prefix: 'fal',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M64 64H384c17.7 0 32 14.3 32 32v41c9.4-6.9 20.9-9.8 32-8.8V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H337.6c-8.8-9.8-16.5-20.6-23.2-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM509.4 253.3c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 313.8 608 339.3 608 352c0 70.2-57 127.8-128 127.8c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zM487.5 197c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zm-42.5 58.9c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.1 384 338.2 384 353.9c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5c-12.4 8.2-25.3 12.2-40 12.2c-19.1 0-35.3-6.1-46.6-16.4c-11.1-10.1-18.4-25.2-18.4-45.6c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.5 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0 12.6-9.9-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faUserUnlock = {
  prefix: 'fal',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 336c-80 0-145 64.3-146.3 144H384c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3v39c-26.8-33.5-68-55-114.3-55H178.3zM480 272v48h32 64 32c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272c0-44.2 35.8-80 80-80s80 35.8 80 80H576c0-26.5-21.5-48-48-48s-48 21.5-48 48zM448 480H608V352H448V480z"]
};
var faHexagonDivide = {
  prefix: 'fal',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var fa00 = {
  prefix: 'fal',
  iconName: '00',
  icon: [640, 512, [], "e467", "M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM32 176C32 114.1 82.1 64 144 64s112 50.1 112 112V336c0 61.9-50.1 112-112 112S32 397.9 32 336V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM384 176c0-61.9 50.1-112 112-112s112 50.1 112 112V336c0 61.9-50.1 112-112 112s-112-50.1-112-112V176z"]
};
var faCrow = {
  prefix: 'fal',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M25.7 412.7L63.2 384H272.6l48.6 118.1c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9L307.2 384H320c16 0 31.4-1.9 46.3-5.6l50.9 123.7c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9L396.6 368.1C464.5 338.5 512 270.8 512 192V144l128-32c0-44.2-35.8-80-80-80H487.6C470 12.4 444.4 0 416 0c-53 0-96 43-96 96v51L52.4 352l-8.6 6.6L6.3 387.3c-7 5.4-8.3 15.4-3 22.4s15.4 8.3 22.4 3zM506.5 64H560c18 0 33.7 9.9 41.9 24.5L512 111V96c0-11.2-1.9-22-5.5-32zM132.7 330.8l186.7-143C313.6 250 268 302.1 205.9 315.2l-73.2 15.5zM320 352H186.8l25.7-5.5c81.3-17.2 139.5-89 139.5-172.2V162.8l0 0V147 96c0-35.3 28.7-64 64-64s64 28.7 64 64v32 64c0 88.4-71.6 160-160 160zM440 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCassetteBetamax = {
  prefix: 'fal',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", "M32 160V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V160H32zm0-32H544V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96v32zM576 96v32 16 16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160 144 128 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64zM240 304a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 304a96 96 0 1 1 192 0A96 96 0 1 1 80 304zm72 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-48v96h96V256H352zm-32 0c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V256z"]
};
var faBetamax = faCassetteBetamax;
var faSailboat = {
  prefix: 'fal',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", "M285.1 6.8c-4-5.7-11.3-8.2-17.9-6.1S256 9 256 16V336c0 8.8 7.2 16 16 16H496c6 0 11.4-3.3 14.2-8.6s2.3-11.7-1.1-16.6l-224-320zM288 320V66.8L465.3 320H288zM212.1 96.5c-7-1.9-14.4 1.2-18 7.5l-128 224c-2.8 5-2.8 11 .1 16s8.1 8 13.8 8H208c8.8 0 16-7.2 16-16V112c0-7.3-4.9-13.6-11.9-15.5zM107.6 320L192 172.2V320H107.6zM42.5 416H533.5c-13.5 38.1-49.6 64-90.5 64H133c-40.9 0-77-25.9-90.5-64zM21.1 384c-10.6 0-18.3 10.1-15.4 20.3l4 14.3C25.3 473.9 75.6 512 133 512H443c57.3 0 107.7-38.1 123.2-93.3l4-14.3c2.9-10.2-4.8-20.3-15.4-20.3H21.1z"]
};
var faWindowRestore = {
  prefix: 'fal',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M432 32H208c-26.5 0-48 21.5-48 48V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V352h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM320 160H64c-17.7 0-32 14.3-32 32v64H352V192c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V288H32V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"]
};
var faNfcMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H352c16.6 12.5 35.8 21.8 56.6 27.1c-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v64c-11 0-21.7 1.1-32 3.2V96c0-17.7-14.3-32-32-32zm0 64v45.3c-11.4 5-22.2 11.3-32 18.7V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM320 416H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384H301.3c5 11.4 11.3 22.2 18.7 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM448 416.2a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 32c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 29.6-10 56.8-26.9 78.5l86.2 86.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-86.2-86.2c-21.7 16.9-48.9 26.9-78.5 26.9z"]
};
var faFileBinary = {
  prefix: 'fal',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H112zM96 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V304zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v96H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V272c0-8.8-7.2-16-16-16H240z"]
};
var faCircleV = {
  prefix: 'fal',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM158.3 152.8c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l112 224c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l112-224c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L256 348.2 158.3 152.8z"]
};
var faSquarePlus = {
  prefix: 'fal',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM208 352V272H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlusSquare = faSquarePlus;
var faBowlScoops = {
  prefix: 'fal',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M335.3 64.7c-5-.5-10.1-.7-15.3-.7c-7.8 0-15.5 .6-23 1.6C279.4 45.1 253.2 32 224 32s-55.4 13.1-73 33.6c-7.5-1.1-15.2-1.6-23-1.6c-5.2 0-10.3 .2-15.3 .7C134.7 26.1 176.3 0 224 0s89.3 26.1 111.3 64.7zM200 118.2c-7.1 8-13.3 16.7-18.7 26C166.1 134 147.7 128 128 128c-53 0-96 43-96 96H0C0 153.3 57.3 96 128 96c26.7 0 51.5 8.2 72 22.2zM448 224H416c0-53-43-96-96-96s-96 43-96 96H192c0-70.7 57.3-128 128-128s128 57.3 128 128zm-2.1 65.9c-8.5 67.9-63.4 119.9-130.5 125.6c-4.1 .3-8.2 .5-12.4 .5H274.2l26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2H128c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L147.2 448l26.7-32H145c-4.2 0-8.3-.2-12.4-.5c-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6 .8-9.1 3.9-12.6s7.4-5.4 12-5.4H432c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96h28.8 32 36.3 32H303c55.8 0 102.9-41 110.9-96H34.1zM198.4 436.5L162.2 480H285.8l-36.3-43.5L224 405.8l-25.6 30.7z"]
};
var faMistletoe = {
  prefix: 'fal',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M288 0c8.8 0 16 7.2 16 16V89.4l91.3 91.3c.2 .2 .4 .5 .6 .7l5.9 1.1 82.9 15.9C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-15.9-82.9-1.1-5.9c-.2-.2-.5-.4-.7-.7L304 134.6V277.3l4 5.3 56.8 75.7C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L268 282.7l4-5.3V134.6l-68.7 68.7c-.2 .2-.5 .4-.7 .7l-1.1 5.9-.4 2.2c-7.9-2.6-16.3-4-25.1-4c-18 0-34.6 5.9-48 16l-30.7 5.9C59.4 237.2 32 270.3 32 309c0 23.8 19.3 43 43 43c14.8 0 28.8-4 40.9-11.2c7.5 8.5 16.8 15.4 27.3 20.2c-19.1 14.5-42.8 23-68.2 23c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l82.9-15.9 5.9-1.1c.2-.2 .4-.5 .7-.7L272 89.4V16c0-8.8 7.2-16 16-16zM478.7 229.9l-70.3-13.5 13.5 70.3c7.3 37.9 40.5 65.3 79.1 65.3c23.8 0 43-19.3 43-43c0-38.6-27.4-71.8-65.3-79.1zM236.8 377.6C228.5 388.7 224 402.2 224 416c0 35.3 28.7 64 64 64s64-28.7 64-64c0-13.8-4.5-27.3-12.8-38.4L288 309.3l-51.2 68.3zM368 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM176 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faCustard = {
  prefix: 'fal',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", "M49.8 384l66.3-271.2c7-28.6 32.7-48.8 62.2-48.8H397.8c29.5 0 55.2 20.2 62.2 48.8L526.2 384H493.3L452.7 218c-18.1-5.7-37.2-10-52.7-10c-18.7 0-32.3 6.4-49.1 14.4l-.7 .3C333.8 230.6 314.4 240 288 240s-45.8-9.4-62.2-17.2l-.7-.3c-16.7-8-30.4-14.4-49.1-14.4c-15.5 0-34.6 4.4-52.7 10L82.7 384H49.8zM132 182.3c14.7-3.7 30-6.3 44-6.3c26.4 0 45.8 9.4 62.2 17.2l.7 .3c16.7 8 30.4 14.4 49.1 14.4s32.3-6.4 49.1-14.4l.7-.3c16.4-7.9 35.8-17.2 62.2-17.2c14 0 29.3 2.6 44 6.3l-15.1-61.9C425.3 106.1 412.5 96 397.8 96H178.2c-14.7 0-27.6 10.1-31.1 24.4L132 182.3zM0 432c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faLacrosseStick = {
  prefix: 'fal',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", "M344 32v0l.2 0 .2 0c28.8 0 62.8 18.4 90 45.6c27.2 27.2 45.6 61.2 45.6 90.1l0 .1 0 .2 0 .1c0 44.3-28.4 83.6-70.4 97.6l0 0-.8 .3-1.8 .6c-18.7 6.2-42.9 14.3-64 31.5l-42 34.4c-15.4 12.6-34.7 19.5-54.7 19.5c-47.7 0-86.3-38.7-86.3-86.3c0-19.9 6.9-39.2 19.5-54.7l34.4-42c17.3-21.1 25.4-45.4 31.6-64.2l.8-2.4C260.3 60.4 299.7 32 344 32zM457 55C426.8 24.8 385.1 0 344.3 0L344 0C285.9 0 234.3 37.2 215.9 92.3l-.3 .8 0 0c-6.6 19.8-13 39.1-26.5 55.6l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9c0 26.9 9 51.7 24.1 71.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L174.7 359.9C194.6 375 219.4 384 246.3 384c27.3 0 53.8-9.4 74.9-26.7l42-34.4c16.5-13.5 35.8-19.9 55.6-26.5l.8-.3c55.1-18.4 92.3-70 92.3-128.1l0-.3c0-40.8-24.8-82.5-55-112.7z"]
};
var faHockeyMask = {
  prefix: 'fal',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M32 240c0-59.7 14.9-111.7 44.7-148.1C105.8 56.5 152.1 32 224 32s118.2 24.5 147.3 59.9C401.1 128.3 416 180.3 416 240c0 95.4-12.4 153.6-39.3 188.4C351.6 460.9 308 480 224 480s-127.6-19.1-152.7-51.6C44.4 393.6 32 335.4 32 240zM224 0C64 0 0 111 0 240C0 432 48 512 224 512s224-80 224-272C448 111 384 0 224 0zM160 208c0 17.7-14.3 32-32 32s-32-14.3-32-32V192h64v16zm-32 64c35.3 0 64-28.7 64-64V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64zm192-32c-17.7 0-32-14.3-32-32V192h64v16c0 17.7-14.3 32-32 32zm64-32V192c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64s64-28.7 64-64zM176 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSunrise = {
  prefix: 'fal',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M276.7 4.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L304 54.6V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM393.5 225.2c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448H462.1l38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8L75.2 391.8 113.9 448H75.1L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H164c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSubtitles = {
  prefix: 'fal',
  iconName: 'subtitles',
  icon: [576, 512, [], "e60f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 256H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 352h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 0H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPanelEws = {
  prefix: 'fal',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", "M64 32C46.3 32 32 46.3 32 64V289.6C68.5 297 96 329.3 96 368v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352H144c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-20.9-13.4-38.7-32-45.3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 80h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 144h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM208 320V256H144v64h32 32zm112-64V416h64V256H320zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256z"]
};
var faToriiGate = {
  prefix: 'fal',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", "M32 112c0 17.7 14.3 32 32 32l176 0h32l176 0c17.7 0 32-14.3 32-32V40.9l-23.5 9.4C433.8 59.3 409.6 64 385.2 64H126.8c-24.4 0-48.6-4.7-71.3-13.7L32 40.9V112zm208 64H96v80l144 0V176zM64 176c-35.3 0-64-28.7-64-64V13.4C0 6 6 0 13.4 0c1.7 0 3.4 .3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32H385.2c20.4 0 40.5-3.9 59.4-11.4L493.6 1c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4V112c0 35.3-28.7 64-64 64v80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V288l-160 0L96 288V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V176zm352 0H272v80l144 0V176z"]
};
var faCloudExclamation = {
  prefix: 'fal',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm48 128c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM296 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMessageLines = {
  prefix: 'fal',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faCommentAltLines = faMessageLines;
var faFrog = {
  prefix: 'fal',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M368 64c-26.5 0-48 21.5-48 48c0 .6 0 1.1-.1 1.7c-.8 8-7.6 14.3-15.9 14.3h-3.2C152.3 128 32 248.3 32 396.8V416c0 17.7 14.3 32 32 32H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-4.1 0-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6l8.8-8.8c1.7-1.7 3.2-3.4 4.7-5.3c8.9-11.1 13.8-25 13.8-39.4c0-12.5-3.7-24.2-9.9-34c-11.2-17.5-30.9-29.2-53.3-29.2c-16.8 0-32.8 6.7-44.7 18.5l-40.8 40.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l40.8-40.8C207.3 250 231.6 240 256.8 240c20.7 0 39.9 6.6 55.5 17.9c24 17.3 39.7 45.5 39.7 77.3c0 17.4-4.7 34.2-13.5 48.9c25.3 1.3 45.5 22.3 45.5 47.9c0 26.5-21.5 48-48 48H64c-35.3 0-64-28.7-64-64V396.8C0 234.4 128.6 102.1 289.6 96.2C296.9 59.6 329.2 32 368 32c41.4 0 75.4 31.4 79.6 71.7c38.1 7.3 69.1 18.5 90.1 27.6C562.6 142 576 166.7 576 192c0 25.5-13.4 49.1-35.2 62.2L423.7 324.4 519.8 448H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H512c-4.9 0-9.6-2.3-12.6-6.2l-112-144c-2.8-3.6-3.9-8.3-3.1-12.8s3.6-8.4 7.5-10.8l132.6-79.5c12.2-7.3 19.7-20.5 19.7-34.7c0-14.4-7.5-26.4-19-31.4c-21.5-9.3-54.8-21.1-95.7-27.7c-8.2-1.3-14.1-8.7-13.4-17.1c.1-1.3 .2-2.6 .2-3.9c0-26.5-21.5-48-48-48zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBucket = {
  prefix: 'fal',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M96 144c0 8.8-7.2 16-16 16s-16-7.2-16-16C64 64.5 128.5 0 208 0h32c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112H208C146.1 32 96 82.1 96 144zM0 208c0-8.8 7.2-16 16-16h8H56.2 391.8 424h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H420L389.3 470c-3 24-23.4 42-47.6 42H106.4c-24.2 0-44.6-18-47.6-42L28 224H16c-8.8 0-16-7.2-16-16zm60.2 16L90.5 466c1 8 7.8 14 15.9 14H341.6c8.1 0 14.9-6 15.9-14l30.2-242H60.2z"]
};
var faFloppyDiskPen = {
  prefix: 'fal',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", "M32 96V416c0 17.7 14.3 32 32 32H266.3l-8 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v49.7l-32 32V170.5c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64C46.3 64 32 78.3 32 96zM96 64v96H288V64H96zm80 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM518.8 264.1c-6.2-6.2-16.4-6.2-22.6 0L471.3 289l40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zM342.5 417.8c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49L375 462c2.8-.7 5.4-2.2 7.4-4.2L488.7 351.6l-40-40L342.5 417.8zM473.5 241.5c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.5c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L473.5 241.5z"]
};
var faImage = {
  prefix: 'fal',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M64 64C46.3 64 32 78.3 32 96V329.4l67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4V96c0-17.7-14.3-32-32-32H64zM32 374.6V416c0 17.7 14.3 32 32 32h41.4l96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448H448c17.7 0 32-14.3 32-32V310.6l-90.3-90.3zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faWindowFrame = {
  prefix: 'fal',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", "M240 288V480H64V288H240zm32 192V288H448V480H272zm208 0V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 448h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480zM448 256H272V32H416c17.7 0 32 14.3 32 32V256zM96 32H240V256H64V64c0-17.7 14.3-32 32-32z"]
};
var faMicrophone = {
  prefix: 'fal',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M256 96V256c0 35.3-28.7 64-64 64s-64-28.7-64-64V96c0-35.3 28.7-64 64-64s64 28.7 64 64zM96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM64 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 83 63.1 151.2 144 159.2V480H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V415.2c80.9-8 144-76.2 144-159.2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 70.7-57.3 128-128 128s-128-57.3-128-128V208z"]
};
var faCow = {
  prefix: 'fal',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M128 144V408c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V352.2v-.5V336c0-53 43-96 96-96s96 43 96 96v15.8 .5V408c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V240c0-5.5 2.9-10.7 7.6-13.6s10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3v62.7c0 3 .9 6 2.5 8.6l37.3 58.6c5.6 8.8 15.3 14.1 25.7 14.1c16.8 0 30.5-13.6 30.5-30.5V298c0-3.3-1-6.4-2.8-9.1L594.8 274c-1.9-2.7-2.8-5.9-2.8-9.1V200c0-4.4-3.6-8-8-8c-4 0-7.3 2.9-7.9 6.7c-1.1 6.4-5.9 11.6-12.3 13s-12.9-1.1-16.7-6.5l-51.7-74.7C480.5 108.9 456 96 429.7 96h-30c-1.9 26.9-13.4 52.3-32.5 71.4l-3.1 3.1c-24 24-56.6 37.5-90.5 37.5h-3.2c-33.9 0-66.5-13.5-90.5-37.5l-3.1-3.1c-16.6-16.6-27.4-37.8-31.2-60.5C134.8 115.7 128 129 128 144zm71.4 .8l3.1 3.1c18 18 42.4 28.1 67.9 28.1h3.2c25.5 0 49.9-10.1 67.9-28.1l3.1-3.1c13.2-13.2 21.3-30.4 23.1-48.8H176.4c1.8 18.4 9.9 35.6 23.1 48.8zm8.6 231V408c0 22.1-17.9 40-40 40H136c-22.1 0-40-17.9-40-40V144c0-18 6-34.6 16-48c-26.5 0-48 21.5-48 48v80 16 28.8C64 297.1 41.1 320 12.8 320C5.7 320 0 314.3 0 307.2V288c0-23.7 12.9-44.4 32-55.4V144c0-44.2 35.8-80 80-80h64H429.7c36.8 0 71.2 18 92.1 48.2l38.5 55.6c6.6-4.9 14.9-7.8 23.7-7.8c22.1 0 40 17.9 40 40v59.9l7.5 10.8c5.6 8 8.5 17.6 8.5 27.3v87.5c0 34.5-28 62.5-62.5 62.5c-21.4 0-41.2-10.9-52.7-28.9l-37.3-58.6c-4.9-7.7-7.5-16.6-7.5-25.8V281.9l-32-16V408c0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40V375.8c-6.6 2-14.6 3.8-24 5.3V392c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8.1c-2.6 .1-5.3 .1-8 .1s-5.4 0-8-.1V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V381.1c-9.4-1.5-17.4-3.3-24-5.3zm0-33.8c2.1 .8 4.7 1.8 7.7 2.7c11.4 3.5 29.8 7.3 56.3 7.3s44.9-3.8 56.3-7.3c3-.9 5.6-1.9 7.7-2.7v-6c0-35.3-28.7-64-64-64s-64 28.7-64 64v6zm344-22a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFileZip = {
  prefix: 'fal',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", "M64 480h96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"]
};
var faSquareRing = {
  prefix: 'fal',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM160 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faDownFromLine = {
  prefix: 'fal',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M190.2 447.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L318.2 315.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H256c-8.8 0-16-7.2-16-16V168c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8V288c0 8.8-7.2 16-16 16H70.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L190.2 447.2zM192 480c-9.5 0-18.6-3.9-25.1-10.8L42.5 337.2C35.8 330 32 320.5 32 310.7C32 289.3 49.3 272 70.7 272H112V168c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V272h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.4-10.5 26.5L217.1 469.2c-6.5 6.9-15.6 10.8-25.1 10.8zM16 32H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48s7.2-16 16-16z"]
};
var faArrowAltFromTop = faDownFromLine;
var faCaretUp = {
  prefix: 'fal',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M154.4 162.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 275.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2L154.4 162.2zm-22-23.3L12.3 252.4C4.4 259.8 0 270.1 0 280.9C0 302.5 17.5 320 39.1 320H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 138.9c-7.4-7-17.3-10.9-27.6-10.9s-20.1 3.9-27.6 10.9z"]
};
var faShieldXmark = {
  prefix: 'fal',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faShieldTimes = faShieldXmark;
var faScrewdriver = {
  prefix: 'fal',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", "M447.3 34.6l30.1 30.1L404.1 160H352V107.9l95.3-73.3zM342.7 192c.4 0 .9 0 1.3 0h64c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v64c0 .4 0 .9 0 1.3l-78.9 78.9c4.2 3.2 8.3 6.6 12.1 10.5s7.3 7.9 10.5 12.1L342.7 192zM208 304c17.7 17.7 17.7 46.3 0 64L96 480 32 416 144 304c17.7-17.7 46.3-17.7 64 0zm-86.6-22.6l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"]
};
var faCircleSortDown = {
  prefix: 'fal',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-192 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96zM198.6 320l114.7 0L256 377.4 198.6 320zM148.7 196.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 134.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z"]
};
var faSortCircleDown = faCircleSortDown;
var faFolderClosed = {
  prefix: 'fal',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v32H32V96zm0 128H480V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64z"]
};
var faHouseTsunami = {
  prefix: 'fal',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", "M32 200c0-92 78.8-168 177.9-168c20.6 0 40.4 3.3 58.7 9.4c8.4 2.8 17.4-1.8 20.2-10.2s-1.8-17.4-10.2-20.2C257.1 3.9 233.9 0 209.9 0C94.8 0 0 88.8 0 200C0 309.1 74 400 191.2 400c.1 0 .2 0 .3 0c.3 0 .6 0 .9 0c.2 0 .4 0 .6 0c29.9-.3 56.7-14.2 75.1-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368v0c-66.4-.3-120-53.9-120-120c0-66.2 53.9-120 120.5-120c18.3 0 35.6 4 51 11.3c8 3.7 17.5 .3 21.3-7.7s.3-17.5-7.7-21.3C237.4 101.1 215.5 96 192.5 96C108.3 96 40 164 40 248c0 3 .1 6.1 .3 9.1C34.8 239.3 32 220.1 32 200zm320-56l96-72L543.5 144l.3 141.2c4.9 2.1 9.9 3.8 14.8 4.9c6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5L467.2 46.5c-11.4-8.6-27.1-8.6-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6V265c1.7 1 3.3 2 4.8 3.1c8.6 5.9 17.8 10.7 27.2 14.2V144zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faSquareNfi = {
  prefix: 'fal',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM75.7 160.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"]
};
var faForklift = {
  prefix: 'fal',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", "M160 0c-17.7 0-32 14.3-32 32V160H80c-44.2 0-80 35.8-80 80V384v32c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6V288 259.5c0-4.7-1-9.3-3-13.5L306.8 18.5C301.6 7.2 290.2 0 277.8 0H160zM128 192h19.5l94.8 87.5C248.2 285 256 288 264 288H384v37.5c-10-3.5-20.8-5.5-32-5.5c-41.8 0-77.4 26.7-90.5 64H186.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V240c0-26.5 21.5-48 48-48h48zm136 64L160 160V32l117.8 0L382.3 256H264zm88 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM96 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V16z"]
};
var faArrowUpFromGroundWater = {
  prefix: 'fal',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", "M288 352c8.8 0 16-7.2 16-16V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6V336c0 8.8 7.2 16 16 16zM64 192c-35.3 0-64 28.7-64 64V425c5.3-3.1 11.2-5.4 17.5-6.9c4.8-1.1 9.7-2.8 14.5-4.8V256c0-17.7 14.3-32 32-32H192V192H64zM576 425V256c0-35.3-28.7-64-64-64H384v32H512c17.7 0 32 14.3 32 32V413.3c4.8 2.1 9.7 3.7 14.5 4.8c6.3 1.5 12.1 3.8 17.5 6.9zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faBracketSquareRight = {
  prefix: 'fal',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 80c0-26.5-21.5-48-48-48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48V80z"]
};
var faMartiniGlass = {
  prefix: 'fal',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M32 33c0-.5 .4-1 1-1H479c.5 0 1 .4 1 1c0 .3-.1 .5-.3 .7l-94.4 94.4c-.4 0-.9-.1-1.3-.1H128c-.4 0-.9 0-1.3 .1L32.3 33.7c-.2-.2-.3-.4-.3-.7zM158.6 160H353.4L256 257.4 158.6 160zM9.7 56.3L240 286.6V480H144c-8.8 0-16 7.2-16 16s7.2 16 16 16H256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V286.6L502.3 56.3c6.2-6.2 9.7-14.6 9.7-23.3c0-18.2-14.8-33-33-33H33C14.8 0 0 14.8 0 33c0 8.7 3.5 17.1 9.7 23.3z"]
};
var faGlassMartiniAlt = faMartiniGlass;
var faRotateLeft = {
  prefix: 'fal',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M94.7 360.2c-3.2-5-8.7-8.2-14.7-8.2c-12.3 0-20.3 12.8-13.7 23.2C106 438.2 176.1 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7L78.6 56c-5.1-5.1-12.1-8-19.3-8C44.2 48 32 60.2 32 75.3V176c0 8.8 7.2 16 16 16H148.7c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-36-36C165.5 81.1 208.7 64 256 64c106 0 192 86 192 192s-86 192-192 192c-67.6 0-127.1-35-161.3-87.8zM64 86.6L137.4 160H64V86.6z"]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faTableColumns = {
  prefix: 'fal',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", "M448 64c17.7 0 32 14.3 32 32v64L32 160l0-64c0-17.7 14.3-32 32-32l384 0zM32 416l0-224 208 0 0 256L64 448c-17.7 0-32-14.3-32-32zm240 32l0-256 208 0 0 224c0 17.7-14.3 32-32 32H272zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
var faColumns = faTableColumns;
var faSquareA = {
  prefix: 'fal',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c6.1 0 11.6 3.4 14.3 8.8l112 224c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 320H153.9l-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l112-224c2.7-5.4 8.3-8.8 14.3-8.8zm0 51.8L169.9 288H278.1L224 179.8z"]
};
var faTick = {
  prefix: 'fal',
  iconName: 'tick',
  icon: [128, 512, [], "e32f", "M24.6 256.9C28.9 275.1 45.2 288 64 288s35.1-12.9 39.4-31.1L133.9 129c1.4-6 2.1-12.1 2.1-18.2V104c0-39.8-32.2-72-72-72S-8 64.2-8 104v6.8c0 6.1 .7 12.3 2.1 18.2L24.6 256.9zM24 104c0-22.1 17.9-40 40-40s40 17.9 40 40v6.8c0 3.6-.4 7.3-1.3 10.8L72.3 249.5c-.9 3.8-4.3 6.5-8.3 6.5s-7.4-2.7-8.3-6.5L25.3 121.6c-.8-3.5-1.3-7.2-1.3-10.8V104z"]
};
var faLemon = {
  prefix: 'fal',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M368 64c-5.8 0-11.2 1-16.2 2.8c-18.9 6.8-44.1 12.9-70.1 7.1c-60.7-13.5-128.7 11-178.8 61s-74.5 118.1-61 178.8c5.8 26-.3 51.2-7.1 70.1C33 388.8 32 394.2 32 400c0 26.5 21.5 48 48 48c5.8 0 11.2-1 16.2-2.8c18.9-6.8 44.1-12.9 70.1-7.1c60.7 13.5 128.7-11 178.8-61s74.5-118.1 61-178.8c-5.8-26 .3-51.2 7.1-70.1c1.8-5 2.8-10.5 2.8-16.2c0-26.5-21.5-48-48-48zm0-32c44.2 0 80 35.8 80 80c0 9.5-1.7 18.6-4.7 27.1c-6 16.7-9.8 35-5.9 52.4c16.4 73.7-13.7 152.4-69.6 208.3s-134.7 86-208.3 69.6c-17.3-3.9-35.7-.1-52.4 5.9c-8.4 3-17.6 4.7-27.1 4.7c-44.2 0-80-35.8-80-80c0-9.5 1.7-18.6 4.7-27.1c6-16.7 9.8-35 5.9-52.4C-5.8 246.9 24.3 168.2 80.2 112.2s134.7-86 208.3-69.6c17.3 3.9 35.7 .1 52.4-5.9c8.4-3 17.6-4.7 27.1-4.7zM246.7 134.5L228.3 143c-51.8 23.9-93.4 65.5-117.3 117.3l-8.5 18.4c-3.7 8-13.2 11.5-21.2 7.8s-11.5-13.2-7.8-21.2l8.5-18.4c27.1-58.7 74.3-105.9 133-133l18.4-8.5c8-3.7 17.5-.2 21.2 7.8s.2 17.5-7.8 21.2z"]
};
var faHeadSideMask = {
  prefix: 'fal',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", "M78.7 150.2L276.5 272H288 511.7c-.9-6.6-4.1-12.7-9.2-17.2l-3.2-2.8c-32.6-29-50-70.3-65.4-106.9l0 0 0 0c-2.4-5.8-4.8-11.4-7.2-16.9C402.1 71.5 345.6 32 280 32H256C176.1 32 107.6 80.8 78.7 150.2zm-10 31.4C65.6 195.3 64 209.4 64 224c0 45.4 15.7 87.1 42.1 120c12.5 15.5 21.9 35.3 21.9 57.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V401.4c0-12.8-5.5-25.7-14.9-37.4C50.4 325.6 32 276.9 32 224C32 100.3 132.3 0 256 0h24c78.8 0 146.5 47.5 176.1 115.3c2.7 6.1 5.2 12.1 7.7 18.1l0 0 0 0c15.7 37.1 30.1 70.9 56.8 94.6l3.2 2.8c11.9 10.6 19.1 25.4 20.1 41.2h.1c0 10.6-1.5 21.2-4.4 31.4l-.2 .6L493.3 465.6c-7.8 27.5-33 46.4-61.5 46.4H288c-17.7 0-32-14.3-32-32V304v-7.1L68.7 181.7zM376 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 480H431.7c14.3 0 26.8-9.5 30.8-23.2l4.8-16.8H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H476.4l9.1-32H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H494.7l11.4-40H288V480z"]
};
var faHandshake = {
  prefix: 'fal',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M263.9 64c-33.9 0-66.7 12-92.6 33.7L144 120.7v39.1c2.7-.5 5.3-1.7 7.4-3.5l40.5-34c13.3-11.2 28.9-19 45.5-23.1L272.6 64h-8.7zM112 352.3c8.9 1 17.2 5 23.6 11.4l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6-6.7 10.3-14.4 13-22.5c19.2 4 40-.8 55.7-14.8c11.3-10.1 18.2-23.2 20.6-37H528V368c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48V160c0-17.7-14.3-32-32-32H560 528v32V318.8H473.1c-3.1-8.7-8.1-17-15.1-24l-85.6-85.6 8.1-7.5c6.5-6 6.9-16.1 .9-22.6s-16.1-6.9-22.6-.9l-76.1 70.2c-13.2 12.2-33.6 12.4-47 .4c-15.4-13.7-15.7-37.5-.8-51.6l79.4-75C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7V121.8L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-79.4 75c-28.6 27-27.9 72.7 1.5 98.8c25.8 22.9 64.7 22.5 90-.8l44.5-41 86.5 86.5c13 13 12.4 34.3-1.4 46.5c-10.9 9.7-26.7 10.6-38.6 3c-5-3.3-11.4-3.4-16.6-.5s-8.3 8.6-8 14.6c.4 8.1-2.3 16.3-8.1 22.9c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-12.4-12.4-28.9-19.8-46.3-20.9V160 128H80 32c-17.7 0-32 14.3-32 32V368c0 26.5 21.5 48 48 48H64c26.5 0 48-21.5 48-48V352.3zM80 160V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160H80zm528 0V368c0 8.8-7.2 16-16 16H576c-8.8 0-16-7.2-16-16V160h48z"]
};
var faGem = {
  prefix: 'fal',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M128 32c-5.2 0-10.1 2.5-13.1 6.8l-112 160c-4.3 6.2-3.7 14.6 1.4 20.1l240 256c3 3.2 7.2 5.1 11.7 5.1s8.6-1.8 11.7-5.1l240-256c5.2-5.5 5.8-13.9 1.4-20.1l-112-160c-3-4.3-7.9-6.8-13.1-6.8H128zm.9 42.7L222.7 192H46.7L128.9 74.7zM52.9 224H256 459.1L256 440.6 52.9 224zm412.3-32h-176L383.1 74.7 465.3 192zM350.7 64L256 182.4 161.3 64H350.7z"]
};
var faDolly = {
  prefix: 'fal',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", "M24 0C15.2 0 8 7.2 8 16s7.2 16 16 16H88.9c6.9 0 13 4.4 15.2 10.9L211.6 365.4C190.1 379.8 176 404.2 176 432c0 44.2 35.8 80 80 80c43 0 78-33.9 79.9-76.4L565.5 351c8.3-3.1 12.5-12.3 9.5-20.5s-12.3-12.5-20.5-9.5L330.7 403.4C319.2 373.3 290.1 352 256 352c-5 0-9.9 .5-14.7 1.3L134.5 32.8C127.9 13.2 109.6 0 88.9 0H24zM256 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm96.8-201.1c3 8.3 12.2 12.6 20.5 9.6s12.6-12.2 9.6-20.5l-19.2-52.6 60.1-21.9 54.7 150.4L328.2 302.5 273.5 152.2l60.1-21.9 19.2 52.6zM243.4 163.1l54.7 150.4c6 16.6 24.4 25.2 41 19.1l150.4-54.7c16.6-6 25.2-24.4 19.1-41L453.9 86.5c-6-16.6-24.4-25.2-41-19.1L262.5 122.1c-16.6 6-25.2 24.4-19.1 41z"]
};
var faDollyBox = faDolly;
var faSmoking = {
  prefix: 'fal',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", "M464 0c-8.8 0-16 7.2-16 16V43c0 46.7 18.5 91.4 51.5 124.5l21 21c15 15 23.4 35.4 23.4 56.6v27c0 8.8 7.2 16 16 16s16-7.2 16-16V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C495.2 117.8 480 81.2 480 43V16c0-8.8-7.2-16-16-16zM624 288c8.8 0 16-7.2 16-16V245c0-46.7-18.5-91.4-51.5-124.5l-21-21C552.4 84.5 544 64.2 544 43V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v27c0 8.8 7.2 16 16 16zM64 384H192v96H64c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm160 0H480v96H224V384zM64 512H208 496c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H208 64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64zM560 352c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16z"]
};
var faMinimize = {
  prefix: 'fal',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M507.3 27.3l-108 108 47.1 47.1c6 6 8.4 14.6 6.3 22.8l-.2 .6c-2.7 10.7-12.3 18.2-23.3 18.2H312c-13.3 0-24-10.7-24-24V82.7c0-11 7.5-20.6 18.2-23.3l.6-.2c8.2-2 16.8 .4 22.8 6.3l47.1 47.1 108-108c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM4.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l108 108 47.1-47.1c6-6 14.6-8.4 22.8-6.3l.6 .2C216.5 62.1 224 71.7 224 82.7V200c0 13.3-10.7 24-24 24H82.7c-11 0-20.6-7.5-23.3-18.2l-.2-.6c-2-8.2 .4-16.8 6.3-22.8l47.1-47.1L4.7 27.3zm502.6 480c-6.2 6.2-16.4 6.2-22.6 0l-108-108-47.1 47.1c-6 6-14.6 8.4-22.8 6.3l-.6-.2c-10.7-2.7-18.2-12.3-18.2-23.3V312c0-13.3 10.7-24 24-24H429.3c11 0 20.6 7.5 23.3 18.2l.2 .6c2 8.2-.4 16.8-6.3 22.8l-47.1 47.1 108 108c6.2 6.2 6.2 16.4 0 22.6zM4.7 484.7l108-108L65.6 329.6c-6-6-8.4-14.6-6.3-22.8l.2-.6C62.1 295.5 71.7 288 82.7 288H200c13.3 0 24 10.7 24 24V429.3c0 11-7.5 20.6-18.2 23.3l-.6 .2c-8.2 2-16.8-.4-22.8-6.3l-47.1-47.1-108 108c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM410.7 192L320 101.3V192h90.7zM192 101.3L101.3 192H192V101.3zM410.7 320H320v90.7L410.7 320zM192 410.7V320H101.3L192 410.7z"]
};
var faCompressArrowsAlt = faMinimize;
var faRefrigerator = {
  prefix: 'fal',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M288 32c35.3 0 64 28.7 64 64v64H288V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H32V96c0-35.3 28.7-64 64-64H288zM256 192V368c0 8.8 7.2 16 16 16s16-7.2 16-16V192h64V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H256zM96 0C43 0 0 43 0 96V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96z"]
};
var faMonument = {
  prefix: 'fal',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.2 5.9 4.6 9.4l32 272c1 8.8-5.2 16.7-14 17.8s-16.7-5.2-17.8-14L256.8 103.4 192 38.6l-64.8 64.8L95.9 369.9c-1 8.8-9 15.1-17.8 14s-15.1-9-14-17.8l32-272c.4-3.6 2-6.9 4.6-9.4l80-80zM144 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16zM40 416H344c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V456c0-22.1 17.9-40 40-40zm-8 40v16c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8z"]
};
var faOctagonXmark = {
  prefix: 'fal',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM180.7 180.7c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesOctagon = faOctagonXmark;
var faXmarkOctagon = faOctagonXmark;
var faAlignSlash = {
  prefix: 'fal',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM528 336c8.8 0 16-7.2 16-16s-7.2-16-16-16H484.1l40.5 32H528zm0-128c8.8 0 16-7.2 16-16s-7.2-16-16-16H322l40.5 32H528zm-372.1 0l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h43.9zM528 48H159.8l40.5 32H528c8.8 0 16-7.2 16-16s-7.2-16-16-16zM318 336l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H318zm121.6 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H480.2l-40.5-32z"]
};
var faSnowplow = {
  prefix: 'fal',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M128 32c0-17.7 14.3-32 32-32H298.9c19.2 0 36.6 11.4 44.1 29.1l85.1 198.6c2.6 6 3.9 12.4 3.9 18.9V288h96V240c0-3.7 1.3-7.4 3.7-10.2l80-96c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L560 245.8V394.2l76.3 91.5c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2l-80-96c-2.4-2.9-3.7-6.5-3.7-10.2V320H446.4c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-44.7 26.2-83.2 64-101.2V168c0-22.1 17.9-40 40-40h24V32zM400 256H208c-5.3 0-10.3-2.7-13.3-7.1L135.4 160H104c-4.4 0-8 3.6-8 8V289.1c5.2-.7 10.6-1.1 16-1.1H368c11.1 0 21.9 1.6 32 4.6V256zM160 139.2L216.6 224H391.7L313.6 41.7c-2.5-5.9-8.3-9.7-14.7-9.7H160V139.2zM368 320H112c-44.2 0-80 35.8-80 80s35.8 80 80 80H368c44.2 0 80-35.8 80-80s-35.8-80-80-80zM120 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faAnglesRight = {
  prefix: 'fal',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M459.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 276.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm-352 160l160-160c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 84.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faAngleDoubleRight = faAnglesRight;
var faTruckRampCouch = {
  prefix: 'fal',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", "M352 80c0-44.2 35.8-80 80-80H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-26.5 0-48 21.5-48 48V379.1l35.8-9.8 .5-.1C433.6 322.4 476.8 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112c-60.7 0-110.1-48.2-111.9-108.4L20.2 511.4c-8.5 2.3-17.3-2.7-19.6-11.2s2.7-17.3 11.2-19.6l340.6-92.8c-.3-1.2-.4-2.5-.4-3.7V80zM608 400a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM225.7 128.2c36.4-9.8 73.6 4.8 94.3 33.7v75.5c-3.1-.4-6.3-.3-9.5 .6c-11.1 3-18.3 13.3-17.8 24.3c.8 15.1-9.1 28.6-23.7 32.5L127.6 332.8c-14.6 3.9-29.9-2.9-36.8-16.3c-5-9.9-16.5-15.2-27.6-12.2c-12.8 3.4-20.4 16.6-17 29.4l13.5 50.3c1.1 4.3 5.5 6.8 9.8 5.7l24.8-6.6c1.2-.3 2.4-.6 3.6-.8l180.3-48.3c.7-.2 1.5-.4 2.2-.5L320 322.7v33.1l-2.6 .7-30.9 8.3 0-.1-30.9 8.3L133.5 405.8 102.6 414l-.1-.2-24.8 6.6c-21.3 5.7-43.3-6.9-49-28.3L15.3 341.9c-3.9-14.7-1.6-29.7 5.3-42l-6.4-24C1.7 229 29.5 180.8 76.5 168.2l149.2-40zm8.3 30.9l-149.2 40c-29.9 8-47.6 38.7-39.6 68.6l2.2 8.3c2.4-1 5-1.9 7.6-2.6c26-7 52.6 5.5 64.3 28.5L260.8 264c-1.3-25.8 15.5-49.9 41.4-56.9c.8-.2 1.6-.4 2.4-.6l-2.1-7.8c-8-29.9-38.7-47.6-68.6-39.6z"]
};
var faTruckCouch = faTruckRampCouch;
var faCannabis = {
  prefix: 'fal',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M269.3 7.1c-3-4.4-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1c-14.2 21.2-33.8 60-48 104.1c-10.3 31.7-18.1 67.2-18.7 101.4C124.5 176.5 61.4 156.8 27.1 150c-5.2-1-10.7 .6-14.4 4.4s-5.4 9.2-4.4 14.5c7.1 35.4 28.1 101.4 66.7 153.5c-21.4 8.8-40.3 19.5-52.8 26.6l0 0c-2.2 1.2-4.2 2.4-6 3.4c-5.1 2.8-8.2 8.2-8.2 14s3.2 11.2 8.2 14c14.1 7.8 41.4 22.7 72.2 33.1c20.7 7 44.6 12.7 67.8 11.8l-12.7 33c-2.3 6.1-.8 13 4 17.4s11.7 5.6 17.6 2.9l75-34.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V444.3l75 34.2c5.9 2.7 12.9 1.6 17.6-2.9s6.3-11.3 4-17.4l-12.7-33c23.2 .9 47.1-4.8 67.8-11.8c30.7-10.5 58.1-25.3 72.2-33.1c5.1-2.8 8.2-8.2 8.2-14s-3.2-11.2-8.2-14c-13-7.2-35.1-18.7-60.8-27.3c40-52.5 61.5-120.2 68.7-156.1c1.1-5.2-.6-10.7-4.4-14.5s-9.2-5.4-14.4-4.4c-34.3 6.8-97.4 26.5-148.9 62.6c-.6-34.2-8.4-69.8-18.7-101.4c-14.2-44-33.8-82.9-48-104.1zM272 409.1V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v73.1l-52.5 24 8.8-22.8c2.3-5.8 .9-12.4-3.5-16.9s-10.9-6-16.8-3.9c-20.8 7.4-48.7 3.3-77.2-6.4c-14.9-5-29-11.3-41-17.2c14.3-7.5 31.1-15.5 48.7-21c5.2-1.6 9.2-5.8 10.7-11s.1-10.9-3.5-14.9C79.1 280.5 57 226.4 45.9 187.5c41 11.6 98.7 35.2 137.7 72.3c5 4.8 12.5 5.8 18.6 2.5s9.4-10.1 8.2-16.9c-6.6-37.5 1.2-82.7 14.8-124.5c9.2-28.3 20.6-54.1 30.9-73.5c10.3 19.4 21.7 45.1 30.9 73.5c13.5 41.8 21.4 87 14.8 124.5c-1.2 6.8 2.1 13.6 8.2 16.9s13.6 2.2 18.6-2.5c39-37.1 96.7-60.7 137.7-72.3C454.6 227.7 431.4 284 395 322.7c-3.9 4.2-5.3 10.2-3.6 15.7s6.2 9.7 11.8 10.9c17.9 4 35.2 10.6 49.8 17.2c-11.8 5.7-25.4 11.7-39.7 16.6c-28.5 9.7-56.4 13.8-77.2 6.4c-5.9-2.1-12.5-.6-16.8 3.9s-5.7 11.1-3.5 16.9l8.8 22.8-52.5-24z"]
};
var faCirclePlay = {
  prefix: 'fal',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.7-256L208 329.7V182.3L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"]
};
var faPlayCircle = faCirclePlay;
var faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fal',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M292.7 196.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6V160c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16s7.2 16 16 16H457.4L292.7 196.7zM219.3 315.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 457.4V352c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16H160c8.8 0 16-7.2 16-16s-7.2-16-16-16H54.6L219.3 315.3z"]
};
var faTablets = {
  prefix: 'fal',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M603.9 261.3c-3.4 4.1-6.9 8.1-10.8 11.9s-7.8 7.4-11.9 10.8c-62.8 51.5-155.7 47.9-214.4-10.8s-62.3-151.6-10.8-214.4c3.4-4.1 6.9-8.1 10.8-11.9s7.8-7.4 11.9-10.8c62.8-51.5 155.7-47.9 214.4 10.8s62.3 151.6 10.8 214.4zM570.5 69.5c-46.2-46.2-118.8-49.7-169-10.6L581.1 238.5c39.1-50.2 35.5-122.8-10.6-169zm-12 191.6L378.9 81.5c-39.1 50.2-35.5 122.8 10.6 169s118.8 49.7 169 10.6zM319.2 336c.5 5.3 .8 10.6 .8 16s-.3 10.7-.8 16c-8 80.9-76.2 144-159.2 144S8.8 448.9 .8 368c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16C8.8 255.1 77 192 160 192s151.2 63.1 159.2 144zM160 224C94.7 224 40.9 272.9 33 336H287c-7.9-63.1-61.7-112-127-112zm0 256c65.3 0 119.1-48.9 127-112H33c7.9 63.1 61.7 112 127 112z"]
};
var fa360Degrees = {
  prefix: 'fal',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H127.3L35.4 214.2c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9H80c44.2 0 80 35.8 80 80v16c0 44.2-35.8 80-80 80H74.5c-12.7 0-24.9-5.1-33.9-14.1L27.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l13.3 13.3c15 15 35.4 23.4 56.6 23.4H80c61.9 0 112-50.1 112-112V320c0-61.6-49.8-111.6-111.3-112L172.6 89.8c3.8-4.8 4.4-11.4 1.7-16.9s-8.3-9-14.4-9H16zm432 80c0-26.5 21.5-48 48-48s48 21.5 48 48V368c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zM576 368V144c0-44.2-35.8-80-80-80s-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80zM256 176c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112V288l0 .2V368c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-18 0-34.6 6-48 16V176zm48 48c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48V272c0-26.5 21.5-48 48-48z"]
};
var faEthernet = {
  prefix: 'fal',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M128 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H400 304 208 112 32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H64V160c0-17.7 14.3-32 32-32h32V96zm224 0H160v48c0 8.8-7.2 16-16 16H96v48c0 8.8-7.2 16-16 16H32V416H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V224H432c-8.8 0-16-7.2-16-16V160H368c-8.8 0-16-7.2-16-16V96z"]
};
var faEuroSign = {
  prefix: 'fal',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H41.3C68.8 412.5 154.5 480 256 480h49c8.8 0 16-7.2 16-16s-7.2-16-16-16H256c-83.6 0-154.7-53.4-181.1-128H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H66.7c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H74.9C101.3 117.4 172.4 64 256 64h49c8.8 0 16-7.2 16-16s-7.2-16-16-16H256C154.5 32 68.8 99.5 41.3 192H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H34.3z"]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faChair = {
  prefix: 'fal',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M192 32V224H160V37.5C122.7 50.6 96 86.2 96 128v96H64V128C64 57.3 121.3 0 192 0h64c70.7 0 128 57.3 128 128v96H352V128c0-41.8-26.7-77.4-64-90.5V224H256V32H192zM64 288L32 352l384 0-32-64H64zM35.4 273.7C40.8 262.8 51.9 256 64 256H384c12.1 0 23.2 6.8 28.6 17.7l32 64c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H64V496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l32-64z"]
};
var faCircleCheck = {
  prefix: 'fal',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCheckCircle = faCircleCheck;
var faSquareDashedCirclePlus = {
  prefix: 'fal',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M112 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-30.9 0-56 25.1-56 56v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V120C0 71.4 39.4 32 88 32h24zM0 304V208c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm16 48c8.8 0 16 7.2 16 16v24c0 30.9 25.1 56 56 56h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-48.6 0-88-39.4-88-88V368c0-8.8 7.2-16 16-16zM433.3 192.6c-9.1 .8-17.3-6.1-17.3-15.3V120c0-30.9-25.1-56-56-56H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c48.6 0 88 39.4 88 88v57.4c0 8.1-6.7 14.6-14.7 15.2zM160 464c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zM272 64H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMoneySimpleFromBracket = {
  prefix: 'fal',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", "M80 32C53.5 32 32 53.5 32 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80C0 35.8 35.8 0 80 0H560c44.2 0 80 35.8 80 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5-21.5-48-48-48H80zM496 96c8.8 0 16 7.2 16 16l0 344c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56l0-344c0-8.8 7.2-16 16-16s16 7.2 16 16l0 344c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24l0-344c0-8.8 7.2-16 16-16zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z"]
};
var faBat = {
  prefix: 'fal',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M366.3 187.7c8.9 4.5 19.3 4.6 28.3 .4l71.8-34.2c3.1-1.5 6.8-.7 9 1.9C519.7 207.5 544 273.2 544 341.2v7L507.6 330c-22.4-11.2-49.7-3.3-62.6 18.2l-19.3 32.2-22.1-22.1c-20.5-20.5-54.3-18.3-72 4.7L288 419.5l-43.5-56.6c-17.7-23-51.5-25.2-72-4.7l-22.1 22.1-19.3-32.2c-12.9-21.5-40.2-29.5-62.6-18.2L32 348.2v-7c0-68 24.3-133.7 68.6-185.4c2.2-2.6 5.9-3.4 9-1.9l71.8 34.2c9 4.3 19.4 4.1 28.3-.4s15.1-12.9 16.9-22.6L240.3 92l15.3 10.2c9.6 6.4 20.9 9.8 32.4 9.8s22.8-3.4 32.4-9.8L335.7 92l13.7 73.1c1.8 9.8 8.1 18.1 16.9 22.6zM358.2 77l0 0-9.9-14.9L358.2 77s0 0 0 0zm16.6 49.7L362.2 59.5c-1.3-6.7-7.1-11.5-13.9-11.5c-2.8 0-5.5 .8-7.8 2.4L302.7 75.6c-4.3 2.9-9.4 4.4-14.7 4.4s-10.3-1.5-14.7-4.4L235.6 50.4c-2.3-1.5-5-2.4-7.8-2.4c-6.8 0-12.6 4.8-13.9 11.5l-12.6 67.2-6.1 32.5L165.3 145 123.4 125c-16.2-7.7-35.5-3.6-47.1 10C27.1 192.4 0 265.6 0 341.2v37.6c0 9.7 10.2 16 18.9 11.7l63.8-31.9c7.5-3.7 16.6-1.1 20.9 6.1l29.8 49.7c5.4 8.9 17.7 10.4 25 3.1l36.6-36.6c6.8-6.8 18.1-6.1 24 1.6l56.2 73.1c6.4 8.3 19 8.3 25.4 0l56.2-73.1c5.9-7.7 17.2-8.4 24-1.6l36.6 36.6c7.4 7.4 19.7 5.8 25-3.1l29.8-49.7c4.3-7.2 13.4-9.8 20.9-6.1l63.8 31.9c8.7 4.3 18.9-2 18.9-11.7V341.2c0-75.6-27.1-148.8-76.3-206.2c-11.6-13.6-30.9-17.7-47.1-10L410.7 145l-29.9 14.2-6.1-32.5z"]
};
var faCircleStop = {
  prefix: 'fal',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192zm32 0V320H320V192H192z"]
};
var faStopCircle = faCircleStop;
var faHeadSideHeadphones = {
  prefix: 'fal',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M176 38v62.6c10.1-3 20.9-4.6 32-4.6s21.9 1.6 32 4.6V32H224c-16.6 0-32.7 2.1-48 6zM144 49.4C77.9 79.7 32 146.5 32 224c0 45.4 15.7 87.1 42.1 120C86.5 359.5 96 379.3 96 401.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V401.4c0-12.8-5.5-25.7-14.9-37.4C18.4 325.6 0 276.9 0 224C0 100.3 100.3 0 224 0h16c78.6 0 150.8 47.3 182.7 115.3c3.8 8.1 7.3 16 10.8 23.8l0 0 0 0 0 0c5.9 13.2 11.6 26 18.2 38.7c10.3 19.6 21.7 36.8 36.9 50.3l3.2 2.8c12.8 11.4 20.2 27.8 20.2 45c0 33.2-26.9 60.2-60.2 60.2H448v48c0 35.3-28.7 64-64 64H320v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32V320c0-8.8 7.2-16 16-16h19.8c15.6 0 28.2-12.6 28.2-28.2c0-8-3.4-15.7-9.5-21.1l-3.2-2.8c-19.2-17.1-32.8-38.1-44-59.4c-7-13.5-13.5-28-19.8-42l0 0 0 0 0 0c-3.4-7.5-6.6-14.9-9.9-21.7C371.5 81.4 325.2 45.6 272 35.1v81c29 20.2 48 53.9 48 91.9c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-38.1 19-71.7 48-91.9V49.4zM288 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faPhoneRotary = {
  prefix: 'fal',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M32 142.4V192h72.9L86.6 224H32c-17.7 0-32-14.3-32-32V141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V192c0 17.7-14.3 32-32 32H425.4l-18.3-32H480V142.4C453 120.1 373.2 64 256 64S59 120.1 32 142.4zm0-1.1s0 0 0 0v0zM32 401c0-11.1 2.9-22.1 8.4-31.8l101.1-177c10.5-18.4 29.5-30.4 50.4-32V128c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64V128c0-8.8 7.2-16 16-16s16 7.2 16 16v32.2c21 1.7 39.9 13.6 50.4 32l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V401zM304 192H208 197.1c-11.5 0-22.1 6.2-27.8 16.1L68.2 385.1C65.5 390 64 395.4 64 401v31c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V401c0-5.6-1.5-11-4.2-15.9l-101.1-177c-5.7-10-16.3-16.1-27.8-16.1H304zM208 320a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faCompassDrafting = {
  prefix: 'fal',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M320 96A64 64 0 1 0 192 96a64 64 0 1 0 128 0zm-21.7 86.2c-12.8 6.3-27.1 9.8-42.3 9.8s-29.5-3.5-42.3-9.8L142.2 307.4C176.1 325.6 214.8 336 256 336c88.8 0 166.4-48.2 207.9-120c4.4-7.6 14.2-10.3 21.9-5.8s10.3 14.2 5.8 21.9c-47 81.3-134.9 136-235.6 136c-47 0-91.1-11.9-129.7-32.8L29.9 503.9c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l97-169.8c-32.1-22.7-59-52.1-78.7-86.2c-4.4-7.6-1.8-17.4 5.8-21.9s17.4-1.8 21.9 5.8c16.9 29.2 39.8 54.6 67 74.3l72.5-126.9C170.5 146.1 160 122.3 160 96c0-53 43-96 96-96s96 43 96 96c0 26.3-10.5 50.1-27.6 67.4l48.4 84.7c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-46.7-81.7zM409 375.9c-4.4-7.7-1.7-17.4 6-21.8s17.4-1.7 21.8 6l73.1 128c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L409 375.9z"]
};
var faDraftingCompass = faCompassDrafting;
var faPlateWheat = {
  prefix: 'fal',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M224 112v5.3c-18.6-6.6-32-24.4-32-45.3V66.7c18.6 6.6 32 24.4 32 45.3zM160 48V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm16 96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM336 117.3c-18.6-6.6-32-24.4-32-45.3V66.7c18.6 6.6 32 24.4 32 45.3v5.3zM288 32c-8.8 0-16 7.2-16 16V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80zm160 80v5.3c-18.6-6.6-32-24.4-32-45.3V66.7c18.6 6.6 32 24.4 32 45.3zM384 48V72c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM304 253.3V248c0-20.9 13.4-38.7 32-45.3V208c0 20.9-13.4 38.7-32 45.3zM352 168c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184c0-8.8-7.2-16-16-16zM192 248c0-20.9 13.4-38.7 32-45.3V208c0 20.9-13.4 38.7-32 45.3V248zm64-64c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184zm160 69.3V248c0-20.9 13.4-38.7 32-45.3V208c0 20.9-13.4 38.7-32 45.3zM464 168c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V184c0-8.8-7.2-16-16-16zM129.8 441.1c-5.5-9.5-15.5-15.6-26.5-16C64 423.6 32.5 391.5 32 352H480c-.5 39.5-32 71.6-71.3 73.1c-11 .4-21 6.5-26.5 16c-2.4 4.2-6.9 6.9-11.9 6.9H141.7c-5 0-9.5-2.7-11.9-6.9zM31 320c-17.1 0-31 13.9-31 31c0 57.3 45.3 103.9 102.1 106.1c7.9 13.7 22.7 22.9 39.6 22.9H370.3c17 0 31.8-9.2 39.6-22.9C466.7 454.9 512 408.2 512 351c0-17.1-13.9-31-31-31H31z"]
};
var faCalendarCircleMinus = {
  prefix: 'fal',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faChopsticks = {
  prefix: 'fal',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M43.6 464.5L333.7 42.7C339 36.1 346.9 32 355.7 32C371.1 32 384 44.7 384 61c0 6.7-2.2 12.8-5.9 17.7L43.6 464.5zM355.7 0c-19.4 0-36.5 9.2-47.5 23.4l-.3 .4-.3 .4L6.2 462.4c-10 13.4-7.7 32.4 5.5 42.9c13.3 10.6 32.5 8.3 43-4.8L402.6 99.3l.3-.3 .3-.4C411.2 88.2 416 75.1 416 61c0-33.5-26.8-61-60.3-61zM174.6 467.9L560.4 102.7c5-4.2 11.5-6.7 18.6-6.7c16.2 0 29 12.9 29 28.6c0 8.5-3.7 16.1-9.8 21.4L174.6 467.9zM579 64c-15.1 0-29 5.5-39.6 14.5l-.3 .3-.3 .3L138.5 458c-12.7 11.1-14.1 30.4-3 43.3c11 12.8 30.3 14.3 43.2 3.7L618 171.2l.3-.3 .3-.3c13-11.1 21.4-27.6 21.4-46C640 91 612.5 64 579 64z"]
};
var faCarWrench = {
  prefix: 'fal',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M88 40c22 0 41 12.6 50.2 31.1l4.4 8.9h9.9 207 9.9l4.4-8.9C383 52.6 402 40 424 40c25.4 0 46.8 16.9 53.7 40H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h45.7c-6.9 23.1-28.3 40-53.7 40c-22 0-41-12.6-50.2-31.1l-4.4-8.9h-9.9-207-9.9l-4.4 8.9C129 139.4 110 152 88 152c-25.4 0-46.8-16.9-53.7-40H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H34.3C41.2 56.9 62.6 40 88 40zM0 96c0 48.6 39.4 88 88 88c30.9 0 58.1-15.9 73.8-40H350.2c15.7 24.1 42.9 40 73.8 40c48.6 0 88-39.4 88-88s-39.4-88-88-88c-30.9 0-58.1 15.9-73.8 40H161.8C146.1 23.9 118.9 8 88 8C39.4 8 0 47.4 0 96zM188.2 208H323.8c14.3 0 26.8 9.5 30.8 23.2L370.8 288c-.9 0-1.9 0-2.8 0H144c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H416v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H188.2c-28.6 0-53.7 18.9-61.5 46.4zM416 416v16H96V416 368c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v48zM144 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCarMechanic = faCarWrench;
var faIcicles = {
  prefix: 'fal',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M0 36.6C0 16.4 16.4 0 36.6 0H474.1C495 0 512 17 512 37.9c0 2.4-.2 4.8-.7 7.2L423.7 499c-1.5 7.5-8.1 13-15.8 13s-14.3-5.5-15.7-13.1l-58.5-312-30.2 121c-1.8 7-8.1 12-15.3 12.1s-13.7-4.7-15.6-11.7l-22-79.4L215.7 403.1c-1.5 7.5-8.1 12.9-15.7 12.9s-14.2-5.4-15.7-12.9L148.1 222.2l-28.9 86.8C117 315.6 110.9 320 104 320s-13-4.4-15.2-10.9L1.9 48.2C.6 44.5 0 40.6 0 36.6zM36.6 32c-2.6 0-4.6 2.1-4.6 4.6c0 .5 .1 1 .2 1.5L104 253.4l32.8-98.5c2.3-6.9 8.9-11.4 16.2-10.9s13.3 5.7 14.7 12.8L200 318.4l32.3-161.6c1.5-7.3 7.7-12.6 15.1-12.9s14 4.6 16 11.7l23.8 85.6 33.3-133.2c1.8-7.3 8.5-12.3 16-12.1s13.9 5.7 15.2 13l56.5 301.3L479.9 39c.1-.4 .1-.7 .1-1.1c0-3.3-2.6-5.9-5.9-5.9H36.6z"]
};
var faPersonShelter = {
  prefix: 'fal',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M264.2 2.3c-5.1-3-11.4-3-16.5 0l-240 144C2.9 149.2 0 154.4 0 160V496c0 8.8 7.2 16 16 16s16-7.2 16-16V169.1L256 34.7 480 169.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-5.6-2.9-10.8-7.8-13.7l-240-144zM240 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-72 97.5c3.8-1 7.7-1.5 11.8-1.5h24.5c4 0 8 .5 11.8 1.5V368H232V265.5zM232 400h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V291.5l42.4 68.9c4.6 7.5 14.5 9.9 22 5.2s9.9-14.5 5.2-22l-45.3-73.5C321.8 246.4 296 232 268.2 232H243.8c-27.8 0-53.6 14.4-68.1 38.1l-45.3 73.5c-4.6 7.5-2.3 17.4 5.2 22s17.4 2.3 22-5.2L200 291.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"]
};
var faNeuter = {
  prefix: 'fal',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V351.3z"]
};
var faIdBadge = {
  prefix: 'fal',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm0-144c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zM112 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48z"]
};
var faKazoo = {
  prefix: 'fal',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M416 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM523.3 352c22.8-25.5 36.7-59.1 36.7-96c0-37.3-14.2-71.2-37.4-96.8c.2 .3 .5 .5 .7 .8H576c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H523.3s0 0 0 0zM482 384h94c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H482c-19.8-10.2-42.2-16-66-16s-46.3 5.8-66 16H241.7c-11.8 0-23.4 1.6-34.7 4.8c-39.3 11.1-136.7 38.7-184 52.5C9.4 189.3 0 201.8 0 216v80c0 14.2 9.4 26.7 23 30.7c47.3 13.8 144.7 41.4 184 52.5c11.3 3.2 23 4.8 34.7 4.8H350c19.8 10.2 42.2 16 66 16s46.3-5.8 66-16zM308.7 352h-67c-8.8 0-17.6-1.2-26-3.6L207 379.2l8.7-30.8C176.4 337.3 79.1 309.7 32 296l0-80c47.1-13.7 144.4-41.3 183.7-52.4c8.5-2.4 17.2-3.6 26-3.6h67c-22.8 25.5-36.7 59.1-36.7 96s13.9 70.5 36.7 96zm56-147.3c-6.2 6.2-6.2 16.4 0 22.6L393.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 278.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L438.6 256l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L416 233.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faMarker = {
  prefix: 'fal',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M330.3 97L353 74.3l20.7-20.7c23.4-23.4 61.3-23.4 84.7 0s23.4 61.3 0 84.7L293.7 303 209 218.3 330.3 97zm-144 144L271 325.7l-64.2 64.2c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4L186.3 241zM307.7 74.3L285.1 97 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L481 161c35.9-35.9 35.9-94.1 0-129.9S386.9-4.8 351 31L330.3 51.7 317.3 38.6c-25-25-65.5-25-90.5 0l-94 94 0 0c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l94.1-94.1c9.1-9.1 22.3-11.6 33.6-7.4c4.2 1.5 8.2 4 11.6 7.4l13.1 13.1z"]
};
var faBinBottles = {
  prefix: 'fal',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", "M384 16c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM352 192H320c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64H32c0-53 43-96 96-96H256c24.9 0 47.6 9.5 64.6 25c19.3 17.6 31.4 42.9 31.4 71zm223.1 0H542.6c-.9-3.3-2.2-6.4-4-9.2c-6.9-10.7-6.8-24.5 .4-35.1c3-4.4 4.7-9.7 4.7-15.5c0-10.8-6.2-20.6-16-25.2l-13.1-6.2c-6.7-3.2-14.1-4.8-21.5-4.8H402.3c-7.4 0-14.8 1.6-21.5 4.8L367.6 107c-3.8 1.8-7.1 4.4-9.7 7.6c-6.5-8.5-14.1-16.2-22.5-22.9c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c11-5.1 23-7.8 35.1-7.8h90.6C505 64 517 66.7 528 71.8L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5zm2.6 32h18.6 9.8H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H606.1L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7H135.1c-40.6 0-74.7-30.4-79.5-70.7L33.9 256H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H33.9h9.8H62.3 577.7zM66.1 256L87.5 437.6c2.8 24.2 23.3 42.4 47.7 42.4H504.9c24.3 0 44.8-18.2 47.7-42.4L573.9 256H66.1zM160 0h64c17.7 0 32 14.3 32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V32H160V48c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16c0-17.7 14.3-32 32-32z"]
};
var faFaceLaughBeam = {
  prefix: 'fal',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm30-99.5c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faLaughBeam = faFaceLaughBeam;
var faSquareArrowDownLeft = {
  prefix: 'fal',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm280-64c8.8 0 16-7.2 16-16s-7.2-16-16-16H182.6L315.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 297.4V192c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16H280z"]
};
var faBatteryBolt = {
  prefix: 'fal',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", "M80 384h66.4c1 12.1 6.2 23.4 14.4 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H276l-33.8 32H80c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48zm156 32l33.8-32H432c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H365.6c-1-12.1-6.2-23.4-14.4-32H432c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H236zM560 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM191.7 264H240c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L320.3 248H272c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L191.7 264zM313.6 112c14.7 0 24.4 15.2 18.2 28.5L297 216h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L212.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L215 296H165.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L299.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faTreeLarge = {
  prefix: 'fal',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", "M224 0c4.8 0 9.3 2.2 12.4 5.9L377.7 178.6c4.1 5 6.3 11.2 6.3 17.6c0 15.3-12.4 27.8-27.8 27.8H337.3l72.6 90.8c4 4.9 6.1 11.1 6.1 17.4c0 15.4-12.5 27.8-27.8 27.8H366.9l76 107.6c3.4 4.7 5.2 10.4 5.2 16.2c0 15.5-12.6 28.1-28.1 28.1H288 160 28.1C12.6 512 0 499.4 0 483.9c0-5.8 1.8-11.5 5.2-16.2L81.1 360H59.8C44.5 360 32 347.5 32 332.2c0-6.3 2.2-12.5 6.1-17.4L110.7 224H91.8C76.4 224 64 211.6 64 196.2c0-6.4 2.2-12.6 6.3-17.6L211.6 5.9c3-3.7 7.6-5.9 12.4-5.9zM160 480H288 412.4L322.9 353.2c-3.4-4.9-3.9-11.3-1.1-16.6s8.2-8.6 14.2-8.6h43.5l-88-110c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1h43.3L224 41.3 100.7 192H144c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-88 110H112c6 0 11.5 3.3 14.2 8.6s2.3 11.7-1.1 16.6L35.6 480H160z"]
};
var faHelicopterSymbol = {
  prefix: 'fal',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M469.7 224H502C487.9 110.9 400 20.7 288 3.1V35.6c94.3 17 168.1 93 181.7 188.4zM502 288H469.7C456.1 383.4 382.3 459.4 288 476.4v32.5C400 491.3 487.9 401.1 502 288zM-6 288C8.7 406.5 104.4 499.8 224 510.9V478.7C122.1 467.9 40.7 388.8 26.3 288H-6zm0-64H26.3C40.7 123.2 122.1 44.1 224 33.3V1.1C104.5 12.2 8.8 105.5-6 224zm182-80c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V272H336v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96H176V144z"]
};
var faAperture = {
  prefix: 'fal',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 480c-6.1 0-12.1-.2-18.1-.7L316 344l13.8-23.9c0 0 .1-.1 .1-.1l18.5-32 67 116.1 3.3 5.8C377.9 453.1 320.1 480 256 480zm73.9-288H464h6.7c6 20.3 9.3 41.8 9.3 64c0 47.3-14.6 91.1-39.7 127.3L362.2 248l-13.7-23.7c0-.1-.1-.2-.1-.3l-18.5-32zm-55.2-32c-.1 0-.2 0-.2 0h-37l67-116.1 3.4-5.8C374.6 53.9 429.7 99.5 458.4 160H302.2 274.7zM256 32c6.1 0 12.1 .2 18.1 .7L196 168l-13.9 24-18.5 32 0 0-67-116.1-3.3-5.8C134.1 58.9 191.9 32 256 32zM32 256c0-47.3 14.6-91.1 39.7-127.3L149.8 264l32.3 56H48 41.3c-6-20.3-9.3-41.8-9.3-64zM204.1 473.9C137.4 458.1 82.3 412.5 53.6 352H209.8h64.7l-67 116.1-3.4 5.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm46.1-207.9c-5.7 9.8-16.3 15.9-27.7 15.9H237.5c-11.4 0-22-6.1-27.7-16l-18.5-32c-5.7-9.9-5.7-22.1 0-32l18.5-32c5.7-9.9 16.2-15.9 27.5-16h37.3c11.3 .1 21.7 6.1 27.4 15.8l18.7 32.4c5.6 9.8 5.6 21.9 0 31.7c0 0 0 .1-.1 .1l-18.5 32c0 0 0 .1-.1 .1z"]
};
var faUniversalAccess = {
  prefix: 'fal',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM129.7 200.8c-4 7.9-.7 17.5 7.2 21.5l21.1 10.5c16 8 32.8 14 50.1 17.8v67.7l-15.7 78.4c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6L237.1 336h37.8l13.4 67.1c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L304 318.4V250.7c17.3-3.9 34.1-9.9 50.1-17.8l21.1-10.5c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-21.1 10.5c-26 13-54.7 19.8-83.8 19.8s-57.8-6.8-83.8-19.8l-21.1-10.5c-7.9-4-17.5-.7-21.5 7.2zM240 255.4c5.3 .4 10.7 .6 16 .6s10.7-.2 16-.6V304H240V255.4z"]
};
var faGearComplex = {
  prefix: 'fal',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M215 62.8l4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8C232.9 32.9 244.4 32 256 32s23.1 .9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8L297 62.8c2.9 14.4 13.2 25.2 25.5 30.3l0 0 1.5 .6 0 0c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3c9.1 6.7 17.7 14 25.6 21.9l.8 .8 0 0c7.9 8 15.3 16.5 21.9 25.6c-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5l0 0 .6 1.5 0 0c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5 .3 2.8 1 3.8 1.9c1.7 11.1 2.6 22.4 2.6 34v.4c0 11.6-.9 22.9-2.6 34c-1.1 1-2.4 1.6-3.8 1.9L449.2 297c-14.4 2.9-25.2 13.2-30.3 25.5l0 0-.6 1.5 0 0c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1c-13.6 18.5-29.9 34.9-48.4 48.4c-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3l0 0-1.5 .6 0 0c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8c-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8L215 449.2c-2.9-14.4-13.2-25.2-25.5-30.3l0 0-1.5-.6 0 0c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2 .8-2.6 1.3-4.1 1.3c-18.5-13.6-34.9-29.9-48.4-48.4c.1-1.4 .5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5l0 0-.6-1.5 0 0c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9C32.9 279.1 32 267.6 32 256s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9L62.8 215c14.4-2.9 25.2-13.2 30.3-25.5l0 0 .6-1.5 0 0c5.2-12.3 4.8-27.3-3.3-39.5L76.6 127.7c-.8-1.2-1.3-2.6-1.3-4.1c6.7-9.1 14-17.7 22-25.7l.8-.8 0 0c8-7.9 16.6-15.3 25.7-22c1.4 .1 2.8 .5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3l0 0 1.5-.6 0 0c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7c-2 .3-3.9 1-5.6 2.1c-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9l0 0-.1 0-1.7 .7 0 0-.1 0c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6c-1.9 .5-3.8 1.3-5.4 2.5C96.6 55.2 85.6 64.4 75.4 74.5l0 0-.8 .8 0 0C64.4 85.6 55.2 96.6 46.9 108.3c-1.2 1.6-2 3.5-2.5 5.4c-2.6 10.6-.8 22.1 5.6 31.7l13.8 20.6c1.5 2.2 2 5.7 .4 9.4l0 .1-.7 1.7 0 0 0 .1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6c-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6c5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6 .5 5.4 2.6 6.9 6.3l0 .1 .7 1.7 0 .1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7c.5 1.9 1.3 3.8 2.5 5.4c16.8 23.8 37.6 44.6 61.5 61.5c1.6 1.2 3.5 2 5.4 2.5c10.6 2.6 22.1 .8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4l.1 0 1.7 .7 .1 0c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4c1.7 1 3.6 1.7 5.6 2.1c14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1c9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9l.1 0 1.7-.7 .1 0c3.7-1.5 7.1-1 9.4 .4L366.5 462c9.6 6.4 21.2 8.2 31.7 5.6c1.9-.5 3.8-1.3 5.4-2.5c23.8-16.8 44.6-37.6 61.5-61.4c1.2-1.6 2-3.5 2.5-5.4c2.6-10.6 .8-22.1-5.6-31.7l-13.8-20.6c-1.5-2.2-2-5.7-.4-9.4l0-.1 .7-1.7 0-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6c1-1.7 1.7-3.6 2.1-5.6c2.4-14 3.7-28.5 3.7-43.2v0-.4 0c0-14.7-1.3-29.1-3.7-43.2c-.3-2-1-3.9-2.1-5.6c-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3l0-.1-.7-1.7 0-.1c-1.5-3.7-1-7.1 .4-9.4L462 145.5c6.4-9.6 8.2-21.2 5.6-31.7c-.5-1.9-1.3-3.8-2.5-5.4c-8.3-11.7-17.5-22.7-27.6-32.9l0 0-.9-.9 0 0c-10.1-10.1-21.1-19.3-32.9-27.6c-1.6-1.2-3.5-2-5.4-2.5c-10.6-2.6-22.1-.8-31.7 5.6L345.9 63.7c-2.2 1.5-5.7 2-9.4 .4l-.1 0-1.7-.7-.1 0c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4c-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faFileMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M240 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-8.4 78.3C215.9 409.4 196.7 416 176 416c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l45.1 45.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.1-45.1zM352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
};
var faFileSearch = faFileMagnifyingGlass;
var faUpRight = {
  prefix: 'fal',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", "M312 128c4.4 0 8 3.6 8 8V337.4c0 3.7-3 6.6-6.6 6.6c-1.8 0-3.4-.7-4.7-1.9l-61.4-61.4c-6.2-6.2-16.4-6.2-22.6 0L112 393.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L54.6 368c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16L167.3 223.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-61.4-61.4c-1.2-1.2-1.9-2.9-1.9-4.7c0-3.7 3-6.6 6.6-6.6H312zm40 8c0-22.1-17.9-40-40-40H110.6C89.3 96 72 113.3 72 134.6c0 10.2 4.1 20.1 11.3 27.3L133.4 212 32 313.4C21.8 323.6 16 337.5 16 352s5.8 28.4 16 38.6L57.4 416c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16L236 314.6l50.1 50.1c7.2 7.2 17.1 11.3 27.3 11.3c21.3 0 38.6-17.3 38.6-38.6V136z"]
};
var faCircleChevronUp = {
  prefix: 'fal',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM379.3 276.7l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 198.6 356.7 299.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faChevronCircleUp = faCircleChevronUp;
var faUserPolice = {
  prefix: 'fal',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M217.1 .8l-144 32C61.7 35.3 52.5 43.8 49.3 55.1s-.2 23.3 8.1 31.6L80 109.3v1.6c0 15.6 7.6 31.8 23.2 40.1c22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1v-1.6l22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32c-4.6-1-9.3-1-13.9 0zM224 32L368 64 340.7 91.3c-3 3-4.7 7.1-4.7 11.3v8.2c0 5.8-2.8 10-6.2 11.8c-11.9 6.3-30.3 13.8-58.4 18C284.2 121.1 288 98.9 288 83.2c0-6.5-4-12.4-10.1-14.9l-48-19.2c-3.8-1.5-8.1-1.5-11.9 0l-48 19.2C164 70.8 160 76.7 160 83.2c0 15.7 3.8 37.9 16.5 57.5c-28.1-4.2-46.5-11.7-58.4-18c-3.4-1.8-6.2-6-6.2-11.8v-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64 224 32zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-9.1 4.3-19.6 8.5-31.8 12.1C318.1 246.9 275.9 288 224 288s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1c-.2 2.9-.3 5.8-.3 8.7zm128-49.7C203.5 131 195.1 111 192.7 93.7L224 81.2l31.3 12.5C252.9 111 244.5 131 224 142.3zM191.4 429.5c18.4 17 46.7 17 65.1 0L305.8 384h7.8c54.4 0 98.9 42.4 102.2 96H336V464h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16H32.2c3.3-53.6 47.8-96 102.2-96h7.8l49.3 45.5zM320.3 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352h-7.8c-8 0-15.8 3-21.7 8.5L234.9 406c-6.1 5.7-15.6 5.7-21.7 0l-49.3-45.5c-5.9-5.5-13.7-8.5-21.7-8.5h-7.8C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H319.7c.1 0 .2 0 .3 0s.2 0 .3 0z"]
};
var faLariSign = {
  prefix: 'fal',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M144 32c8.8 0 16 7.2 16 16V98.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v58.9c62.8 22.2 110.7 76.2 124.2 142.7c1.8 8.7-3.8 17.1-12.5 18.9s-17.1-3.8-18.9-12.5c-10.5-51.6-45.7-94.1-92.8-114.7L256 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-140.8c-10.3-2.1-21-3.2-32-3.2s-21.7 1.1-32 3.2L160 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-130.7C71.5 166 32 222.4 32 288c0 88.4 71.6 160 160 160H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H192 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H85.8C34.1 413.6 0 354.8 0 288c0-83.6 53.4-154.7 128-181.1V48c0-8.8 7.2-16 16-16z"]
};
var faVolcano = {
  prefix: 'fal',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M213 58.7c-2.5 5-7.4 8.3-12.9 8.8s-11-2-14.3-6.4c-5.9-7.9-15.2-13-25.8-13c-17.7 0-32 14.3-32 32s14.3 32 32 32c9.7 0 18.3-4.3 24.2-11.1c3.1-3.6 7.7-5.6 12.4-5.5s9.2 2.3 12.2 6l46.7 58.4c.1 .2 .3 .2 .5 .2s.4-.1 .5-.2l46.7-58.4c3-3.7 7.4-5.9 12.2-6s9.3 1.9 12.4 5.5c5.9 6.8 14.5 11.1 24.2 11.1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-10.6 0-19.9 5.1-25.8 13c-3.3 4.5-8.7 6.9-14.3 6.4s-10.5-3.8-12.9-8.8C291.1 42.8 274.8 32 256 32s-35.1 10.8-43 26.7zM256 0c23.9 0 45.3 10.5 60 27.1c10.3-7 22.6-11.1 36-11.1c35.3 0 64 28.7 64 64s-28.7 64-64 64c-12.5 0-24.2-3.6-34.1-9.8l-36.4 45.6c-6.2 7.7-15.6 12.3-25.5 12.3s-19.3-4.5-25.5-12.3l-36.4-45.6c-9.9 6.2-21.5 9.8-34.1 9.8c-35.3 0-64-28.7-64-64s28.7-64 64-64c13.4 0 25.8 4.1 36 11.1C210.7 10.5 232.1 0 256 0zM32 459.8C32 471 41 480 52.2 480H459.8c11.1 0 20.2-9 20.2-20.2c0-4.9-1.8-9.7-5.1-13.4L387 347.5 362 385c-6.3 9.4-16.8 15-28 15c-8.9 0-17.5-3.6-23.8-9.9l-34.5-34.5C263.1 343.1 246 336 228.3 336c-13.2 0-26.1 3.9-37.1 11.2l-17.8 11.9c-8.7 5.8-18.9 8.9-29.3 8.9s-20.6-3.1-29.3-8.9L37.1 446.4c-3.3 3.7-5.1 8.5-5.1 13.4zm303.4-92.6L365 322.8l-40.3-45.3c-12.1-13.7-29.6-21.5-47.8-21.5H235.1c-18.3 0-35.7 7.8-47.8 21.5l-50.8 57.1c2.4 .9 4.9 1.4 7.5 1.4c4.1 0 8.1-1.2 11.6-3.5l17.8-11.9c16.3-10.8 35.4-16.6 54.9-16.6c26.2 0 51.4 10.4 70 29l34.5 34.5c.3 .3 .8 .5 1.2 .5c.6 0 1.1-.3 1.4-.8zm13.3-111l34.7 39.1 0 0 22 24.7 0 0 93.5 105.2c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l74.6-84 21.5-24.1 54.1-60.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2z"]
};
var faTeddyBear = {
  prefix: 'fal',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", "M160 64c0 12.5 7.2 23.4 17.8 28.7c6.9 3.4 10.3 11.2 8.3 18.6c-1.3 4.8-2.1 10.4-2.1 16.7c0 51.3 44.7 96 104 96s104-44.7 104-96c0-6.4-.8-11.9-2.1-16.7c-2-7.4 1.5-15.2 8.3-18.6C408.8 87.4 416 76.5 416 64c0-17.7-14.3-32-32-32c-15.1 0-27.8 10.5-31.2 24.7c-2 8.6-10.5 13.9-19.1 12C319 65.3 303 64 288 64s-31 1.3-45.7 4.6c-8.6 1.9-17.1-3.4-19.1-12C219.8 42.5 207.1 32 192 32c-17.7 0-32 14.3-32 32zM192 0c24.8 0 46.4 14.2 57 34.8c13.3-2 26.6-2.8 39-2.8s25.7 .8 39 2.8C337.6 14.2 359.2 0 384 0c35.3 0 64 28.7 64 64c0 20.6-9.8 38.9-24.9 50.6c.6 4.3 .9 8.8 .9 13.4c0 70.7-60.9 128-136 128s-136-57.3-136-128c0-4.6 .3-9.1 .9-13.4C137.8 102.9 128 84.6 128 64c0-35.3 28.7-64 64-64zm96 184c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM56 190c27.6-22.1 67.9-17.6 90 10l10.8 13.5c67.3 84.1 195.1 84.1 262.4 0L430 200c22.1-27.6 62.4-32.1 90-10s32.1 62.4 10 90l-10.8 13.5c-27 33.7-59.5 59.8-95.1 78.2V384h26c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64c0 35.7-15.5 70.2-25.3 88.7c-8.1 15.3-24 23.3-39.9 23.3H464l-.1 0H112.1l-.1 0H65.1c-15.9 0-31.8-8-39.9-23.3C15.5 470.2 0 435.7 0 400c0-35.3 28.7-64 64-64c29.8 0 54.9 20.4 62 48h26V371.7c-35.6-18.4-68.2-44.5-95.1-78.2L46 280c-22.1-27.6-17.6-67.9 10-90zm55.9 290l.1 0h96V464c0-26.5-21.5-48-48-48v0H112c-8.8 0-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 27.6 12.4 56.4 21.5 73.7c1.9 3.6 6.1 6.3 11.6 6.3h46.8zM184 387.7c4 1.3 7.9 2.8 11.6 4.7C205.7 359.7 236.1 336 272 336h32c35.9 0 66.3 23.7 76.4 56.3c3.7-1.8 7.6-3.4 11.6-4.7V361.8c0-6.2 3.6-11.8 9.2-14.5c34.9-16.5 66.8-41.1 93-73.8L505 260c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-10.8 13.5c-80.1 100.1-232.3 100.1-312.3 0L121 220c-11-13.8-31.2-16-45-5s-16 31.2-5 45l10.8 13.5c26.2 32.7 58.1 57.3 93 73.8c5.6 2.6 9.2 8.3 9.2 14.5v25.9zM224 416c10 13.4 16 30 16 48v16h96V464c0-18 6-34.6 16-48c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48zm192 0c-26.5 0-48 21.5-48 48v16h96l.1 0h46.8c5.5 0 9.7-2.7 11.6-6.3c9.2-17.3 21.5-46.1 21.5-73.7c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16H416v0zM240 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faStocking = {
  prefix: 'fal',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M96 32H352V80H96V32zM64 32V80c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96C78.3 0 64 14.3 64 32zm64 206.9V144H96v94.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V144H320V315.5c0 32.1-16 62.1-42.7 79.9L173.2 464.7c-14.9 9.9-32.4 15.3-50.4 15.3C72.7 480 32 439.3 32 389.2v-2.2c0-31.1 15.6-60.2 41.4-77.4l26.1-17.4c17.8-11.9 28.5-31.9 28.5-53.3z"]
};
var faPersonWalkingDashedLineArrowRight = {
  prefix: 'fal',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zM416 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM538.2 163.7c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5L579.8 240H384c-8.8 0-16 7.2-16 16s7.2 16 16 16H579.8l-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80zM400 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm-16 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V432c0-8.8-7.2-16-16-16z"]
};
var faImageSlash = {
  prefix: 'fal',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 96c0-35.3-28.7-64-64-64H139.6l40.5 32H512c17.7 0 32 14.3 32 32V265.4l-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0l-31 31 25.3 20 28.4-28.4c3.1-3.1 8.2-3.1 11.3 0L544 310.6v40.7l32 25.3V96zM297.6 319.8l-9.6 9.6-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0L96 329.4V160.7L64 135.4V416c0 35.3 28.7 64 64 64H500.4l-40.5-32H214.6L322.8 339.8l-25.3-20zM265.4 352l-96 96H128c-17.7 0-32-14.3-32-32V374.6l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0L265.4 352z"]
};
var faMaskSnorkel = {
  prefix: 'fal',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M560 32c8.8 0 16 7.2 16 16V160H544V48c0-8.8 7.2-16 16-16zM448 480c53 0 96-43 96-96V192h32V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V368c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 53 43 96 96 96zM64 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h79.7c14.3 0 26.8-9.5 30.8-23.2l3.4-11.7c13.3-46.4 79-46.4 92.3 0l3.4 11.7c3.9 13.7 16.5 23.2 30.8 23.2H384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H384c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H304.3c-28.6 0-53.7-18.9-61.5-46.4l-3.4-11.7c-4.4-15.5-26.3-15.5-30.8 0l-3.4 11.7c-7.9 27.5-33 46.4-61.5 46.4H64c-35.3 0-64-28.7-64-64V128z"]
};
var faSmoke = {
  prefix: 'fal',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", "M160 32c-53 0-96 43-96 96c0 28.1 12 53.3 31.2 70.8c-11.2 3.2-21.9 7.5-32.1 12.8C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298.1 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-9.1 5.8-17.5 12.4-25.3 19.8C384.1 81.8 354.1 64 320 64c-20.8 0-40 6.6-55.7 17.8c-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C224.5 50 194.3 32 160 32zM144 256C82.1 256 32 306.1 32 368s50.1 112 112 112H464c44.2 0 80-35.8 80-80s-35.8-80-80-80c-11.7 0-22.7 2.5-32.7 7c-4 1.8-8.6 1.9-12.7 .2s-7.3-5-8.8-9.1c-13.7-36.3-48.8-62-89.8-62c-28.9 0-54.8 12.8-72.4 33c-2.9 3.4-7.1 5.4-11.6 5.5s-8.8-1.6-11.9-4.8C203.7 268.9 175.4 256 144 256zM0 368c0-79.5 64.5-144 144-144c34.5 0 66.2 12.1 90.9 32.3C257.5 236.2 287.3 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112s-50.1 112-112 112H144C64.5 512 0 447.5 0 368zM608 224c0-53-43-96-96-96c-41.3 0-76.6 26.1-90.1 62.8c-2 5.4-6.7 9.3-12.4 10.3s-11.4-1.2-15-5.7C376.8 173.8 350 160 320 160c-38.7 0-72.1 22.9-87.3 56c-9.2-5.4-18.9-9.9-29-13.6C224 158.5 268.4 128 320 128c31.4 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9c-5.5-9.2-11.9-17.8-19.2-25.6C592.6 283.9 608 255.7 608 224z"]
};
var faSterlingSign = {
  prefix: 'fal',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M80 152c0-48.6 39.4-88 88-88h7.1c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2H168C101.7 32 48 85.7 48 152V256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H47.9C46.3 346.2 31 403.1 3.1 454.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H42.1c23.5-50.1 36.4-104.6 37.8-160H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80V152z"]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faBatteryExclamation = {
  prefix: 'fal',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", "M208 96H80C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H216.6c-5.4-9.4-8.6-20.3-8.6-32H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H208V96zM432 416c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H336v32h96c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H336c0 11.7-3.1 22.6-8.6 32H432zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM272 96c-8.8 0-16 7.2-16 16V296c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faViruses = {
  prefix: 'fal',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M78.9 327.8l15.2-15.2c30.2-30.2 81.9-8.8 81.9 33.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V346.5c0-42.8 51.7-64.2 81.9-33.9l15.2 15.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-15.2-15.2c-30.2-30.2-8.8-81.9 33.9-81.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.5c-42.8 0-64.2-51.7-33.9-81.9l15.2-15.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.9 71.4C259.7 101.7 208 80.3 208 37.5V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V37.5c0 42.8-51.7 64.2-81.9 33.9L78.9 56.2c-6.2-6.2-16.4-6.3-22.6 0s-6.2 16.4 0 22.6L71.4 94.1c30.2 30.2 8.8 81.9-33.9 81.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H37.5c42.8 0 64.2 51.7 33.9 81.9L56.2 305.1c-6.2 6.2-6.3 16.4 0 22.6s16.4 6.2 22.6 0zm7-135.8c22.8-17.4 34.9-46.6 31.1-75c28.5 3.8 57.6-8.3 75-31.1c8.4 11 19.5 19.5 32 24.9c13.4 5.8 28.3 8.1 43 6.1c-3.8 28.5 8.3 57.6 31.1 75c-22.8 17.4-34.9 46.6-31.1 75c-28.5-3.8-57.6 8.3-75 31.1c-17.4-22.8-46.6-34.9-75-31.1c3.8-28.5-8.3-57.6-31.1-75zm82.1 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm101.8 95.2C574.5 423.9 591 384 624 384c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C551.9 289.5 512 273 512 240c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C417.5 312.1 401 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C440.1 446.5 480 463 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM579.5 368c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c8.5 10 19.7 17.3 32 21.3c8.7 2.8 17.9 3.9 27.1 3.2c-1.8 22.3 7.4 44.6 24.5 59.1z"]
};
var faSquarePersonConfined = {
  prefix: 'fal',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm296 96c30.9 0 56 25.1 56 56V360c0 30.9-25.1 56-56 56c-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1L240 343.6V248c0-30.9 25.1-56 56-56zm24 168V248c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 13.3 10.7 24 24 24s24-10.7 24-24zM232 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
var faUserTie = {
  prefix: 'fal',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.8l-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-79-56.8-144.7-131.8-158.6c-6.8-1.3-13.4 2.5-16.3 8.8L267.9 401l-21.7-65H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 192zm17.5 160.5l-9.7-21.1L224 370.6l24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3 .7 .7 1.4 1 2.1H32c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480H266.6c.3-.7 .7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z"]
};
var faArrowDownLong = {
  prefix: 'fal',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M180.7 507.3c6.2 6.2 16.4 6.2 22.6 0l144-144c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 457.4 208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 441.4L59.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144z"]
};
var faLongArrowDown = faArrowDownLong;
var faTentArrowDownToLine = {
  prefix: 'fal',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M243.8 117.2c-5.9-6.5-16.1-7-22.6-1.1L160 171.8 160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 155.8L66.8 116.2c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6l88 80c6.1 5.5 15.4 5.5 21.5 0l88-80c6.5-5.9 7-16.1 1.1-22.6zM0 496c0 8.8 7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM393.5 131.1c-5.7-4.2-13.4-4.2-19 0L201 259.3c-10.1 7.5-16.9 18.7-18.9 31.1l-22 139c-1.4 8.7 4.6 16.9 13.3 18.3s16.9-4.6 18.3-13.3l22-139.1c.7-4.1 2.9-7.9 6.3-10.4L368 175.7V287.8c0 .2 0 .3 0 .5V432c0 8.8 7.2 16 16 16s16-7.2 16-16V340.8l66.7 100c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L400 283.2V175.7L547.9 285.1c3.4 2.5 5.6 6.2 6.3 10.4l22 139.1c1.4 8.7 9.6 14.7 18.3 13.3s14.7-9.6 13.3-18.3l-22-139c-2-12.4-8.7-23.6-18.9-31.1L393.5 131.1z"]
};
var faCertificate = {
  prefix: 'fal',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M170.7 108.3c7.5-4.3 12.9-11.5 15-19.8l12.3-48.6 35 36c6 6.2 14.3 9.7 22.9 9.7s16.9-3.5 22.9-9.7l35-36 12.3 48.6c2.1 8.4 7.5 15.5 15 19.8s16.4 5.4 24.7 3.1l48.3-13.6L400.6 146c-2.3 8.3-1.2 17.2 3.1 24.7s11.5 12.9 19.8 15l48.6 12.3-36 35c-6.2 6-9.7 14.3-9.7 22.9s3.5 16.9 9.7 22.9l36 35-48.6 12.3c-8.4 2.1-15.5 7.5-19.8 15s-5.4 16.4-3.1 24.7l13.6 48.3L366 400.6c-8.3-2.3-17.2-1.2-24.7 3.1s-12.9 11.5-15 19.8l-12.3 48.6-35-36c-6-6.2-14.3-9.7-22.9-9.7s-16.9 3.5-22.9 9.7l-35 36-12.3-48.6c-2.1-8.4-7.5-15.5-15-19.8s-16.4-5.4-24.7-3.1L97.8 414.2 111.4 366c2.3-8.3 1.2-17.2-3.1-24.7s-11.5-12.9-19.8-15L39.8 313.9l36-35c6.2-6 9.7-14.3 9.7-22.9s-3.5-16.9-9.7-22.9l-36-35 48.6-12.3c8.4-2.1 15.5-7.5 19.8-15s5.4-16.4 3.1-24.7L97.8 97.8 146 111.4c8.3 2.3 17.2 1.2 24.7-3.1zM49.6 162.6l-31.5 8c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l23.3 22.6L53.5 256 30.5 278.3 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l31.5 8 31 7.9-8.7 30.8-8.8 31.2c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l31.2-8.8 30.8-8.7 7.9 31 8 31.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l22.6-23.3L256 458.5l22.3 22.9L301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l8-31.5 7.9-31 30.8 8.7 31.2 8.8c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-8.8-31.2-8.7-30.8 31-7.9 31.5-8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-23.3-22.6L458.5 256l22.9-22.3L504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-31.5-8-31-7.9 8.7-30.8 8.8-31.2c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-31.2 8.8-30.8 8.7-7.9-31-8-31.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L278.3 30.5 256 53.5 233.7 30.5 211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-8 31.5-7.9 31-30.8-8.7L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l8.8 31.2 8.7 30.8-31 7.9z"]
};
var faCrystalBall = {
  prefix: 'fal',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128H80.9C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM64 384c-5.6 0-10.8 2.9-13.7 7.8l-46.2 77C1.4 473.2 0 478.3 0 483.5C0 499.2 12.8 512 28.5 512H419.5c15.8 0 28.5-12.8 28.5-28.5c0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8H64zM34.7 480l38.4-64H374.9l38.4 64H34.7zM288 144c-8.8 0-16 7.2-16 16v48H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V240h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-8.8-7.2-16-16-16zM144 96c-8.8 0-16 7.2-16 16v16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V112c0-8.8-7.2-16-16-16z"]
};
var faReplyAll = {
  prefix: 'fal',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", "M202.8 59.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1L24.8 178.4c-17.5 15.9-17.5 43.3 0 59.2L181.2 379.8c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L46.3 213.9c-3.5-3.2-3.5-8.7 0-11.8L202.8 59.8zM320 160h80c79.5 0 144 64.5 144 144c0 46.1-15.9 79.7-34 103.2c1.3-7.1 2-14.8 2-23.2c0-70.7-57.3-128-128-128H320l0 0h-8c-13.3 0-24 10.7-24 24v8 16l0 48L128 208 288 64v48 16 8c0 13.3 10.7 24 24 24l8 0zm0 160V304 288h32 32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352 320V112 96 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C99.9 190.3 96 198.9 96 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V320z"]
};
var faMailReplyAll = faReplyAll;
var faSuitcase = {
  prefix: 'fal',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H144 128V448H384V128H368zM64 128c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H96V128H64zM448 448c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H416V448h32z"]
};
var faPersonSkating = {
  prefix: 'fal',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", "M392 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 392 0zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm280.4-10.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4zM274.7 144H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H316.2c28.6 0 51.8 23.2 51.8 51.8c0 18.2-9.5 35-25.1 44.4l-90.1 54L310.6 320c6 6 9.4 14.1 9.4 22.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-70.5-70.5c-11.2-11.2-17.5-26.4-17.5-42.3c0-18.8 8.9-36.5 23.9-47.8L274.7 144zm49.9 1.9c-.9 1.1-1.9 2.1-3 2.9l-78.5 58.9c-7 5.2-11.1 13.5-11.1 22.2c0 2.4 .3 4.7 .9 6.9l93.5-56.1c5.9-3.6 9.6-10 9.6-16.9c0-7.9-4.7-14.8-11.4-17.9zM180.8 276.6c3.9 6.6 8.7 12.8 14.2 18.3l6.4 6.4-94.1 94.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96.1-96.1z"]
};
var faSkating = faPersonSkating;
var faStarShooting = {
  prefix: 'fal',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M315.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm0 192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zM128.7 283.1c10.4-1.5 19.4-8.1 24.1-17.5l39.1-79.4L231 265.5c4.7 9.5 13.7 16 24.1 17.5l87.5 12.7-63.4 61.9c-7.5 7.3-11 17.9-9.2 28.3l15 87.3-78.2-41.2c-9.3-4.9-20.5-4.9-29.8 0L98.8 473.3l15-87.3c1.8-10.4-1.7-20.9-9.2-28.3L41.2 295.8l87.5-12.7zm84.7-125.6c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z"]
};
var faBinaryLock = {
  prefix: 'fal',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", "M313.4 3c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V16c0-5.1-2.5-10-6.6-13zM89.4 291c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304c0-5.1-2.5-10-6.6-13zM80 0C35.8 0 0 35.8 0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80zM32 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM192 368v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V368c0-44.2-35.8-80-80-80H272c-44.2 0-80 35.8-80 80zm80-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm256-96c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faFilterCircleDollar = {
  prefix: 'fal',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", "M0 39.5C0 17.7 17.7 0 39.5 0H472.5C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5H39.5c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 269.8c2.4 2.9 3.7 6.5 3.7 10.2v88.2l34 26.4c2.7 18.1 8.3 35.3 16.1 51.2c-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3V285.8L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM408.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
var faFunnelDollar = faFilterCircleDollar;
var faCameraRetro = {
  prefix: 'fal',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M192 112H64c-17.7 0-32 14.3-32 32v80H145.1c22.1-38.3 63.5-64 110.9-64s88.7 25.7 110.9 64H480V96c0-17.7-14.3-32-32-32H277.3c-6.9 0-13.7 2.2-19.2 6.4l-46.9 35.2c-5.5 4.2-12.3 6.4-19.2 6.4zM32 256V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256H380c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H32zM0 416V144c0-35.3 28.7-64 64-64H192l46.9-35.2C250 36.5 263.5 32 277.3 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM352 288a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM64 48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z"]
};
var faCircleArrowDown = {
  prefix: 'fal',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM363.3 283.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L240 329.4V144c0-8.8 7.2-16 16-16s16 7.2 16 16V329.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowCircleDown = faCircleArrowDown;
var faCommentPen = {
  prefix: 'fal',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm60.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zM207.1 271.1l60.7-60.7 17.8 17.8L224.8 289c-2.1 2.1-4.6 3.5-7.4 4.2L198 298l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 157l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63c-17.4-17.4-45.7-17.4-63.1 0z"]
};
var faCommentEdit = faCommentPen;
var faFileImport = {
  prefix: 'fal',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M480 448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V368H128v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V256h32V64c0-17.7 14.3-32 32-32H320V144c0 26.5 21.5 48 48 48H480V448zm-.5-288H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM283.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 304H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H329.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faArrowRightToFile = faFileImport;
var faBanjo = {
  prefix: 'fal',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M445.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 61.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5L406.6 72l39-39zM376.4 60.5l-15 67.5-62.4 62.4c-25.2-20.8-56.6-34.4-90.9-37.7V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v8.8c-34.4 3.2-65.8 16.9-90.9 37.7l-6.2-6.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l6.2 6.2C41.6 238.2 28 269.6 24.8 304H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.8c3.2 34.4 16.9 65.8 37.7 90.9l-6.2 6.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l6.2-6.2c25.2 20.8 56.6 34.4 90.9 37.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.8c34.4-3.2 65.8-16.9 90.9-37.7l6.2 6.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-6.2-6.2c20.8-25.2 34.4-56.6 37.7-90.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8.8c-3.2-34.4-16.9-65.8-37.7-90.9L384 150.6l67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3L380.7 52.7c-2.2 2.2-3.6 4.9-4.3 7.8zM192 184a136 136 0 1 1 0 272 136 136 0 1 1 0-272zM124.7 316.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faSquareArrowUpRight = {
  prefix: 'fal',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM168 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.4L132.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 214.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H168z"]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faLightEmergencyOn = {
  prefix: 'fal',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zm-112 0V320h32V192c0-88.4-71.6-160-160-160s-160 71.6-160 160V320h32V192c0-70.7 57.3-128 128-128s128 57.3 128 128zM128 400c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V400zm-32 0v32c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48zM320 128c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z"]
};
var faKerning = {
  prefix: 'fal',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", "M454.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l240-480zm-424 81.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l144 288c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l144-288c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L160 364.2 30.3 104.8zm320 302.3L385.9 336H574.1l35.6 71.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-144-288c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-144 288c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2zM480 147.8L558.1 304H401.9L480 147.8z"]
};
var faBoxOpen = {
  prefix: 'fal',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M80.4 49.5L320 77.2 559.6 49.5c14.1-1.6 27.5 6.2 33.1 19.2l32 74.7c9.8 22.9-3.5 49.1-27.8 54.7L437.8 234.8c-18.9 4.4-38.6-3.1-49.9-18.9L320 120.9l-67.9 95.1c-11.3 15.8-30.9 23.2-49.9 18.9L43 198c-24.3-5.6-37.6-31.8-27.8-54.7l32-74.7c5.6-13 19-20.8 33.1-19.2zM76.7 81.3l-32 74.7c-2 4.6 .7 9.8 5.6 10.9l159.2 36.7c6.3 1.5 12.9-1 16.6-6.3l65.1-91.2L76.7 81.3zM544 236.7l32-9.1v151c0 22-15 41.2-36.4 46.6l-208 52c-7.6 1.9-15.6 1.9-23.3 0l-208-52C79 419.7 64 400.5 64 378.5v-151l32 9.1V378.5c0 7.3 5 13.7 12.1 15.5L304 443V208c0-8.8 7.2-16 16-16s16 7.2 16 16V443l195.9-49c7.1-1.8 12.1-8.2 12.1-15.5V236.7zM348.8 106.1l65.1 91.2c3.8 5.3 10.3 7.7 16.6 6.3l159.2-36.7c4.9-1.1 7.5-6.4 5.6-10.9l-32-74.7L348.8 106.1z"]
};
var faSquareF = {
  prefix: 'fal',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256 160c0-17.7 14.3-32 32-32z"]
};
var faScroll = {
  prefix: 'fal',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M32 112c0-26.5 21.5-48 48-48s48 21.5 48 48V400c0 44.2 35.8 80 80 80H504c39.8 0 72-32.2 72-72V352c0-22.1-18-40-40-40h-.6-.6-.6-.6-.5-.6-.5-.5H531h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H524h-.5H523h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H513h-.5H512h-.5H511h-.5H510h-.5H509h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H499h-.5H498h-.5H497h-.5H496h-.5H495h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H485h-.5H484h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H477h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H471h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H466h-.5-.5-.5-.5-.4-.5-.4-.4H462h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H454h-.4-.4-.4-.4-.4-.4-.4-.4H450h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H443h-.4-.4-.4-.4-.4-.4H440h-.4-.4-.4-.4-.4-.4H437h-.4-.4-.4-.4-.4-.4H434h-.4-.4-.4-.4-.4-.4H431h-.4-.4-.4-.4-.4-.4H428h-.4-.4-.4-.4-.4-.4H425h-.4-.4-.4-.4-.4-.4H422h-.4-.4-.4-.4-.4-.4H419h-.4-.4-.4-.4-.4-.4H416h-.4-.4-.4-.4-.4-.4H413h-.4-.4-.4-.4-.4-.4H410h-.4-.4-.4-.4-.4-.4H407h-.4-.4-.4-.4-.4-.4H404h-.4-.4-.4-.4-.4-.4H401h-.4-.4-.4-.4-.4-.4H398h-.4-.4-.4-.4-.4-.4H395h-.4-.4-.4-.4-.4-.4H392h-.4-.4-.4-.4-.4-.4H389h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H382h-.4-.4-.4-.4-.4-.4-.4-.4H378h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H370h-.4-.4-.4-.5-.4-.5-.5-.5H366h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H361h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H355h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H348h-.5H347h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H337h-.5H336h-.5H335h-.5H334h-.5H333h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H323h-.5H322h-.5H321h-.5H320h-.5H319h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H309h-.5H308h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H301h-.5-.5-.5-.5-.5-.5-.6-.6H296c-22.1 0-40 17.9-40 40v48c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-18-6-34.6-16-48H400c26.5 0 48 21.5 48 48V288h32V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v72c0 22.1 17.9 40 40 40H96V192H40c-4.4 0-8-3.6-8-8V112zM504 448H272c10-13.4 16-30 16-48V352c0-4.4 3.6-8 8-8h.6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .4 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .6 .6 .6c4.4 0 8 3.6 8 8v56c0 22.1-17.9 40-40 40z"]
};
var faSpa = {
  prefix: 'fal',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M371.3 219.5c9-6.5 18.5-12.6 28.2-18.1c-27.1-93.1-79.8-147.8-97.5-164.1c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.7 16.4-70.4 71.1-97.5 164.1c9.7 5.5 19.1 11.6 28.2 18.1C225.7 140 267.2 89.6 288 68.3c20.8 21.3 62.3 71.7 83.3 151.2zM192 469.1c24.1 7.1 49.5 10.9 75.9 10.9h40.2c26.4 0 51.8-3.8 75.9-10.9c111-32.7 192-135.4 192-257c0-11.1-9.1-20.1-20.2-20.1c-64.5 0-124.1 21.6-171.8 57.9c-43.6 33.2-77.4 78.7-96 131.2c-18.6-52.6-52.4-98.1-96-131.2C144.2 213.6 84.6 192 20.2 192C9.1 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-34.4C103.7 403.8 37.3 322.6 32.3 224.3c61.5 2.9 117.4 28 159.7 67.4c43 40.1 72 94.9 78.6 156.3c-27.3 0-53.8-4.7-78.6-13.3zm192 0c-24.8 8.6-51.2 13.3-78.6 13.3C312 386.6 341 331.7 384 291.7c42.3-39.4 98.2-64.4 159.7-67.4c-5 98.3-71.4 179.5-159.7 210.4z"]
};
var faArrowLeftFromLine = {
  prefix: 'fal',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 160 272l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0L54.6 240 155.3 139.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128zM416 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352z"]
};
var faArrowFromRight = faArrowLeftFromLine;
var faStrawberry = {
  prefix: 'fal',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", "M495.4 20.4c-11.5 40.2-38.5 68.5-66.7 92.3c34.5 3.5 59.9 20.6 71.2 29.6c8.4 6.7 12.1 16.5 12.1 25.8c0 9.2-3.7 19-11.8 25.7c-9.2 7.6-29 21.9-54.1 27.8c-4-5-8.3-9.9-12.9-14.5l-15-15c1.9 .1 3.8 .1 5.9 .1c23.9 0 45.4-14.5 55.8-23l0-.1c.1-.1 .2-.4 .2-.9c0-.4-.1-.7-.1-.8C469.7 159.1 446.4 144 416 144c-14.7 0-22.9 1.8-26.9 3.2c-1.6 .6-2.6 1-2.9 1.2c-2.4 1.9-5.1 3.1-8 3.5l-18-18c.4-2.9 1.5-5.6 3.5-8c.2-.4 .7-1.3 1.2-2.9c1.3-4 3.2-12.2 3.2-26.9c0-30.4-15.1-53.7-23.2-63.9c-.1 0-.4-.1-.8-.1c-.5 0-.8 .1-.9 .2l-.1 0c-8.5 10.4-23 32-23 55.8c0 2 0 4 .1 5.9l-15-15c-4.6-4.6-9.5-8.9-14.5-12.9c5.9-25.2 20.2-44.9 27.8-54.1C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1c10 12.5 29.8 42.4 30.2 82.7c29.8-24.3 54.6-48.1 64.6-83.1c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zm-206 88L403.6 222.6l6.9 6.9c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l6.9 6.9zM32 336c0 61.3 11.8 94.5 30.6 113.4S114.7 480 176 480c166.1 0 240-88.5 240-160c0-24.6-9.4-49.1-28.1-67.9l-128-128c-18.7-18.7-43.1-28.1-67.7-28.1C120.7 96 32 170 32 336zM189.5 154.5c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm47.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm96.7-66.3c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm24-80c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7zm55.3 90.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-192-80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7s3.2 22.4-8.7 34.3zm-23.3 53.7c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3s28.3-14.6 34.3-8.7z"]
};
var faLocationPinLock = {
  prefix: 'fal',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M192 477.6c16.8-21.1 40.2-51.4 64-85.5v54.8c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-10.9 1.8-21.3 5.2-30.9 9.9C340.6 92.8 273.4 32 192 32C103.6 32 32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140zM144 192a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm208-48c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H480V352H320z"]
};
var faPause = {
  prefix: 'fal',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", "M48 96c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H48zM0 112C0 85.5 21.5 64 48 64H96c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zM224 96c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H224zm-48 16c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V112z"]
};
var faClockEightThirty = {
  prefix: 'fal',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V285.9l-71.1 47.4c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l96-64c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlaneEngines = {
  prefix: 'fal',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-96.9 0-11.1-18.7c15-5.8 25.6-20.3 25.6-37.3V104c0-22.1-17.9-40-40-40H303L274.4 15.7C268.7 6 258.2 0 246.9 0H170.7c-16 0-27.6 15.4-23 30.8l15.2-4.5-15.2 4.5 43 145.2L136 176 97.6 124.8C91.6 116.7 82.1 112 72 112H30c-16.6 0-30 13.4-30 30c0 2.8 .4 5.6 1.2 8.3l21.5 75.1C9.5 229.4 0 241.6 0 256s9.5 26.6 22.6 30.6L1.2 361.7C.4 364.4 0 367.2 0 370c0 16.6 13.4 30 30 30H72c10.1 0 19.6-4.7 25.6-12.8L136 336h54.7l-43 145.2c-4.6 15.4 7 30.8 23 30.8l76.2 0c11.3 0 21.8-6 27.5-15.7L303 448h41c22.1 0 40-17.9 40-40V392c0-17-10.6-31.6-25.6-37.3L369.4 336h96.9c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256zM341 384h3c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H322l19-32zm3-256h-3L322 96h22c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8zm122.3 80c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2h-106c-5.7 0-10.9 3-13.8 7.8L246.9 480l-65.5 0 46.1-155.5c1.4-4.8 .5-10.1-2.5-14.1s-7.8-6.4-12.8-6.4L128 304c-5 0-9.8 2.4-12.8 6.4L72 368H32.6L63.4 260.4c.8-2.9 .8-5.9 0-8.8L32.6 144 72 144l43.2 57.6c3 4 7.8 6.4 12.8 6.4l84.1 0c5 0 9.8-2.4 12.8-6.4s4-9.3 2.5-14.1L181.4 32l65.5 0 99.6 168.2c2.9 4.9 8.1 7.8 13.8 7.8l106 0z"]
};
var faPlaneAlt = faPlaneEngines;
var faHillAvalanche = {
  prefix: 'fal',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M191.7 48c-24.3 0-44.5 18.2-47.5 41.8L448 394.2c17.9 17.9 46.6 18.9 65.6 2.2l4.2-3.7c19.4-17 19.6-47.2 .5-64.5c-14.3-12.9-35.4-14.8-51.7-4.5l-3 1.9c-7.5 4.7-17.3 2.4-22-5.1s-2.4-17.4 5.1-22.1l3-1.9c28.4-17.8 65.2-14.6 90.1 7.9c33.3 30.2 32.9 82.7-.8 112.3l-4.2 3.7c-31.7 27.8-79.5 26.2-109.3-3.6L116.5 107.3c-3.3-3.3-4.9-7.8-4.7-12.2c.4-43.8 36-79.2 79.9-79.2c16.9 0 32.6 5.3 45.5 14.3c14.6-9 31.9-14.3 50.3-14.3c53 0 95.9 43 95.9 96c0 4.2-.3 8.3-.8 12.4c29.1 16.5 48.7 47.7 48.7 83.6c0 21.6-7.1 41.6-19.2 57.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c8-10.7 12.8-24 12.8-38.4c0-27.1-16.8-50.3-40.6-59.6c-7.6-3-11.8-11.3-9.6-19.2c1.5-5.4 2.3-11.2 2.3-17.2c0-35.4-28.6-64-63.9-64c-15.5 0-29.7 5.5-40.7 14.7c-6.3 5.3-15.6 4.9-21.5-.9C216.6 53.2 204.8 48 191.7 48zM415.2 64a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zm31.9 96a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zM54.6 96.1L415.3 457.4c20.1 20.2 5.8 54.6-22.6 54.6H64c-35.3 0-64-28.7-64-64V118.7C0 90.2 34.5 75.9 54.6 96.1zM32 448c0 17.7 14.3 32 32 32H392.6L32 118.7V448z"]
};
var faTemperatureEmpty = {
  prefix: 'fal',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M96 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112S48 429.9 48 368c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM160 0C107 0 64 43 64 96V252.7c0 4.6-2.2 9.8-6.8 14.5C31.7 293.1 16 328.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM128 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 368a64 64 0 1 0 128 0z"]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faBomb = {
  prefix: 'fal',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", "M464 16V48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM301.1 130.9c-8.8 8.8-21.8 11.7-33.5 7.5C249.1 131.7 229 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-21-3.7-41.1-10.4-59.7c-4.2-11.7-1.3-24.7 7.5-33.5L384 208l-80-80-2.9 2.9zm-22.6-22.6l2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l28.7 28.7 17.4-17.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-17.4 17.4 28.7 28.7c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"]
};
var faGaugeLow = {
  prefix: 'fal',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-18.6 7.9-35.3 20.5-47L129.9 151.6c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faTachometerAltSlow = faGaugeLow;
var faRegistered = {
  prefix: 'fal',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176v96 96c0 8.8 7.2 16 16 16s16-7.2 16-16V288h71.4l59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80H208c-26.5 0-48 21.5-48 48zm32 80V176c0-8.8 7.2-16 16-16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H192z"]
};
var faTrashCanPlus = {
  prefix: 'fal',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zM208 384V304H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faAddressCard = {
  prefix: 'fal',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM112 368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM352 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z"]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faScaleUnbalancedFlip = {
  prefix: 'fal',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M112.2 10.9c-2.8 8.4 1.7 17.4 10.1 20.2L256.5 75.9c4.6 24.4 23.1 43.9 46.9 50.1V480h-192c-8.8 0-16 7.2-16 16s7.2 16 16 16h208c8.8 0 16-7.2 16-16V126c10.3-2.6 19.6-7.8 27.2-14.7l143.8 47.9c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L380.3 83.5c2-6.1 3-12.7 3-19.5c0-35.3-28.7-64-64-64c-28 0-51.8 18-60.5 43L132.4 .8C124-2 115 2.6 112.2 10.9zm87.1 319.3C182.2 343.1 157.1 352 128 352s-54.2-8.9-71.3-21.7C39.6 317.5 32 302.2 32 288H224v-1.6l0 .1V288c0 14.2-7.6 29.5-24.7 42.3zM128 115.3L213.7 256H42.3L128 115.3zM256 288v-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2C147.2 85.2 137.9 80 128 80s-19.2 5.2-24.3 13.7l-92 151.2C4 257.4 0 271.8 0 286.4V288c0 53 57.3 96 128 96s128-43 128-96zM608 416c0 14.2-7.6 29.5-24.7 42.3C566.2 471.1 541.1 480 512 480s-54.2-8.9-71.3-21.7C423.6 445.5 416 430.2 416 416H608v-1.6l0 .1V416zm-10.3-32H426.3L512 243.3 597.7 384zM512 512c70.7 0 128-43 128-96v-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2c-5.2-8.5-14.4-13.7-24.3-13.7s-19.2 5.2-24.3 13.7l-92 151.2C388 385.4 384 399.8 384 414.4V416c0 53 57.3 96 128 96zM319.3 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faGlobeSnow = {
  prefix: 'fal',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128H80.9C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM240 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-27.3 44.7l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 198.6v34.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 278.6V352h32V278.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 233.4V198.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM360 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM50.3 391.8l-46.2 77C1.4 473.2 0 478.3 0 483.5C0 499.2 12.8 512 28.5 512H419.5c15.8 0 28.5-12.8 28.5-28.5c0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8H64c-5.6 0-10.8 2.9-13.7 7.8zM73.1 416H374.9l38.4 64H34.7l38.4-64z"]
};
var faSubscript = {
  prefix: 'fal',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H55.2L157 256 55.2 416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H296.8L195 256 296.8 96H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H288c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4C74.6 66.8 69.5 64 64 64H16zM464 336c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H464V336z"]
};
var faDiamondTurnRight = {
  prefix: 'fal',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", "M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm65 137c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 240H232c-13.3 0-24 10.7-24 24v56c0 8.8-7.2 16-16 16s-16-7.2-16-16V264c0-30.9 25.1-56 56-56h97.4l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faDirections = faDiamondTurnRight;
var faIntegral = {
  prefix: 'fal',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M216 32c-22.1 0-40 17.9-40 40V440c0 39.8-32.2 72-72 72s-72-32.2-72-72V416c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 22.1 17.9 40 40 40s40-17.9 40-40V72c0-39.8 32.2-72 72-72s72 32.2 72 72V96c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c0-22.1-17.9-40-40-40z"]
};
var faBurst = {
  prefix: 'fal',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M146.5 211.2c3.3-9.6 1.8-20.1-3.9-28.4L54.9 54.9l127.9 87.7c8.3 5.7 18.9 7.2 28.4 3.9s17-10.8 20.1-20.4L256 50l26.9 83c2.7 8.3 8.6 15.1 16.4 18.9s16.8 4.3 25 1.3l54.3-19.8-19.8 54.3c-3 8.2-2.5 17.2 1.3 25s10.6 13.7 18.9 16.4L462 256l-79.6 25.8c-9 2.9-16.2 9.6-19.8 18.4s-3.1 18.6 1.3 27l40.9 77.8L327.1 364c-8.4-4.4-18.2-4.9-27-1.3s-15.5 10.8-18.4 19.8L256 462l-25.8-79.6c-2.9-9-9.6-16.2-18.4-19.8s-18.6-3.1-27 1.3l-77.8 40.9L148 327.1c4.4-8.4 4.9-18.2 1.3-27s-10.8-15.5-19.8-18.4L50 256l76.1-24.7c9.6-3.1 17.2-10.6 20.4-20.1zM173.4 97.3L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5L97.3 173.4l18.9 27.5L84.5 211.2l-67.9 22C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l72.2 23.4 30.9 10L104.6 341 66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3L171 407.4l28.7-15.1 10 30.9 23.4 72.2c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l23.4-72.2 10-30.9L341 407.4l71.9 37.8c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L407.4 341l-15.1-28.7 30.9-10 72.2-23.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-76.1-24.6-30.5-9.9 11-30.1 14.7-40.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-40.4 14.7-30.1 11-9.9-30.5-24.6-76C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-22 67.9-10.3 31.7L173.4 97.3z"]
};
var faHouseLaptop = {
  prefix: 'fal',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M229.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6c-3.1 3.7-7.6 5.6-12.1 5.6h-.2c-3.7 0-7.3-1.3-10.3-3.9L416 187.9V224H384V160.5L240 37.1 96 160.5V352c0 17.7 14.3 32 32 32H272v32H128c-35.3 0-64-28.7-64-64V187.9L26.4 220.1c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM352 256H544c26.5 0 48 21.5 48 48V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-26.5 21.5-48 48-48zM272 480H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM208 176h64c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V208H208v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32z"]
};
var faLaptopHouse = faHouseLaptop;
var faFaceTired = {
  prefix: 'fal',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c24.2 0 48.2 3.4 71.4 10c-3.5-5.1-7.7-10.3-12.6-15.2c-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2c23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2c9.8 9.8 17.8 20.8 23.4 31.5c5.5 10.4 9.3 21.8 9.3 32.4c0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4c5.6-10.7 13.6-21.6 23.4-31.5c19.5-19.5 47.9-36.2 81.3-36.2zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faTired = faFaceTired;
var faMoneyBills = {
  prefix: 'fal',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", "M576 64c17.7 0 32 14.3 32 32v32c-35.3 0-64-28.7-64-64h32zM224 64H512c0 53 43 96 96 96v96c-53 0-96 43-96 96H224c0-53-43-96-96-96V160c53 0 96-43 96-96zM128 288c35.3 0 64 28.7 64 64H160c-17.7 0-32-14.3-32-32V288zm416 64c0-35.3 28.7-64 64-64v32c0 17.7-14.3 32-32 32H544zM192 64c0 35.3-28.7 64-64 64V96c0-17.7 14.3-32 32-32h32zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 61.9 50.1 112 112 112H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V112z"]
};
var faBlindsRaised = {
  prefix: 'fal',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", "M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96h96V418.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96H480c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 32H480V64H32V32zm96 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM35.9 160l9.8-32H12.3L.9 165c-.6 2-.9 4.1-.9 6.1C0 182.7 9.3 192 20.9 192H96V160H35.9zm0 96l9.8-32H12.3L.9 261c-.6 2-.9 4.1-.9 6.1C0 278.7 9.3 288 20.9 288H96V256H35.9zM192 256v32H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37H466.2l9.8 32H192zm0-96v32H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37H466.2l9.8 32H192z"]
};
var faSmog = {
  prefix: 'fal',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M176 0C96.5 0 32 64.5 32 144s64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM64 144C64 82.1 114.1 32 176 32c31.4 0 59.7 12.9 80.1 33.7c3.1 3.2 7.4 4.9 11.9 4.8s8.7-2.1 11.6-5.5c17.6-20.2 43.5-33 72.4-33c41 0 76.1 25.7 89.8 62c1.6 4.1 4.8 7.4 8.8 9.1s8.7 1.6 12.7-.2c10-4.5 21-7 32.7-7c44.2 0 80 35.8 80 80s-35.8 80-80 80H462.4c-4.2 0-8.2 1.6-11.2 4.6c-17.3 17-41 27.4-67.2 27.4s-49.9-10.4-67.2-27.4c-3-2.9-7-4.6-11.2-4.6H176c-61.9 0-112-50.1-112-112zM80 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faUfoBeam = {
  prefix: 'fal',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M141.3 166.7l11.3-11.4c-11.3 11.4-11.3 11.4-11.3 11.4l0 0 0 0 .1 .1 .2 .2 .6 .5c.5 .4 1.1 1 1.9 1.6c1.6 1.3 3.8 3 6.7 5.1c5.8 4 14.5 9.1 26.3 14.1C200.7 198.4 236.7 208 288 208s87.3-9.6 110.9-19.6c11.8-5 20.4-10.1 26.3-14.1c2.9-2 5.1-3.7 6.7-5.1c.8-.7 1.4-1.2 1.9-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-11.3-11.4l11.3 11.4c2.7-2.7 4.3-6.2 4.7-9.9c.7-8.1 .8-16 .2-23.7c30.2 8 55.1 18.1 73.1 29.4c23.1 14.4 31.2 28.3 31.2 39.1c0 7.9-4.2 17.4-16 27.9c-11.8 10.5-29.7 20.7-53.3 29.5c-47 17.7-113 29-186.7 29s-139.7-11.3-186.7-29c-23.6-8.9-41.5-19-53.3-29.5c-11.8-10.5-16-20-16-27.9c0-10.9 8.2-24.7 31.2-39.1c18-11.3 42.9-21.4 73.1-29.4c-.6 7.7-.5 15.6 .2 23.7c.3 3.7 2 7.3 4.7 9.9zm2.3-68.3c-38.9 8.9-72.5 21.4-97.3 36.9C20.1 151.7 0 173.9 0 201.6c0 20.3 11 37.8 26.7 51.8c15.7 14 37.6 25.9 63.3 35.6c51.4 19.4 121.4 31 198 31s146.5-11.7 198-31c25.7-9.7 47.5-21.6 63.3-35.6c15.7-14 26.7-31.5 26.7-51.8c0-27.7-20.1-49.9-46.3-66.3c-24.8-15.5-58.4-28-97.3-36.9C412.1 39.7 353.1 0 288 0S163.9 39.7 143.5 98.4zM288 32c66.9 0 122 50.8 119.9 115.3l-.8 .6c-4.2 2.9-10.9 6.9-20.7 11.1C366.9 167.2 335.2 176 288 176s-78.9-8.8-98.4-17.1c-9.8-4.2-16.5-8.2-20.7-11.1l-.8-.6C166 82.8 221.1 32 288 32zM103.8 338c-7.7-4.3-17.5-1.5-21.8 6.2L2 488.2C-2.3 496 .5 505.7 8.2 510s17.5 1.5 21.8-6.2l80-144c4.3-7.7 1.5-17.5-6.2-21.8zm368.5 0c-7.7 4.3-10.5 14-6.2 21.8l80 144c4.3 7.7 14 10.5 21.8 6.2s10.5-14 6.2-21.8l-80-144c-4.3-7.7-14-10.5-21.8-6.2zM288 272a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleCaretUp = {
  prefix: 'fal',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352c-9.6 0-18.7 4-25.2 11L135.3 273.8c-4.7 5.1-7.3 11.8-7.3 18.7c0 15.2 12.3 27.5 27.5 27.5h201c15.2 0 27.5-12.3 27.5-27.5c0-6.9-2.6-13.6-7.3-18.7L281.2 171c-6.5-7-15.6-11-25.2-11zm-1.7 32.7c.4-.5 1.1-.7 1.7-.7s1.3 .3 1.7 .7L346.2 288H165.8l88.4-95.3z"]
};
var faCaretCircleUp = faCircleCaretUp;
var faUserVneckHairLong = {
  prefix: 'fal',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM185.6 418.1l-48-64C77.9 365.2 32.6 417.3 32 480H416c-.6-62.7-45.9-114.8-105.6-125.8l-48 64c-19.2 25.6-57.6 25.6-76.8 0zM143.7 321c5.3-.6 10.5 1.9 13.7 6.2l53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2C385.1 329.7 448 398.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 398.2 62.9 329.7 143.7 321z"]
};
var faSquareALock = {
  prefix: 'fal',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M64 64H384c17.7 0 32 14.3 32 32v74.8c9.9-4.7 20.7-8 32-9.6V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.6 0 96V416c0 35.3 28.7 64 64 64H320V448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm174.3 72.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L145.9 336H302.1L320 371.8V352c0-12.2 3.4-23.5 9.3-33.2l-91-181.9zM224 179.8L286.1 304H161.9L224 179.8zM464 224c26.5 0 48 21.5 48 48v48H416V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H544V480H384V352z"]
};
var faCrutch = {
  prefix: 'fal',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M292.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0zM196.6 164.8L162.4 199c-11.2 11.2-18.8 25.4-21.9 40.9l-24.4 122c-1.9 9.3-6.4 17.8-13.1 24.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L125.6 409c6.7-6.7 15.2-11.3 24.5-13.1l122-24.4c15.5-3.1 29.7-10.7 40.9-21.9l34.3-34.3 94.1-94.1-22.6-22.6L336 281.4 230.6 176l82.7-82.7L290.7 70.6l-94 94c0 0-.1 .1-.1 .1s-.1 .1-.1 .1zM208 198.6L313.4 304l-23 23c-6.7 6.7-15.2 11.3-24.5 13.1L148.4 363.6l23.5-117.5c1.9-9.3 6.4-17.8 13.1-24.5l23-23z"]
};
var faGasPumpSlash = {
  prefix: 'fal',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", "M352 362.8V480H128V186L96 160.7V480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32H352h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0V388.1l-32-25.3zM144.6 36c4.6-2.5 9.8-4 15.4-4H320c17.7 0 32 14.3 32 32V199.7L384 225V64c0-35.3-28.7-64-64-64H160c-15.9 0-30.4 5.8-41.6 15.3L144.6 36zM576 157.1c0-17.9-7.5-35.1-20.8-47.2L474.8 36.2c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L480 84.4V160c0 35.3 28.7 64 64 64V351.3l32 25.3V157.1zm-64-43.4l21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6V192c-17.7 0-32-14.3-32-32V113.7zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faFontAwesome = {
  prefix: 'fal',
  iconName: 'font-awesome',
  icon: [448, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16V111.9c25.5-.8 50.8-5.3 75-13.3l35.3-11.8C155.7 82.3 169.8 80 184 80s28.3 2.3 41.7 6.8l46.7 15.6c19.2 6.4 39.4 9.7 59.6 9.7s40.4-3.3 59.6-9.7L416 94.2V216v24V364.5L381.5 376c-16 5.3-32.7 8-49.5 8s-33.5-2.7-49.5-8l-46.7-15.6c-16.7-5.6-34.2-8.4-51.8-8.4s-35.1 2.8-51.8 8.4l-25.2 8.4c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l25.2-8.4c13.4-4.5 27.5-6.8 41.7-6.8s28.3 2.3 41.7 6.8l46.7 15.6c19.2 6.4 39.4 9.7 59.6 9.7s40.4-3.3 59.6-9.7l45.4-15.1 10.9-3.6V376 240 216 72 49.8l-21.1 7L381.5 72c-16 5.3-32.7 8-49.5 8s-33.5-2.7-49.5-8L235.8 56.4C219.1 50.8 201.6 48 184 48s-35.1 2.8-51.8 8.4L96.9 68.2c-21 7-42.8 10.9-64.9 11.7V48z"]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faCloudArrowUp = {
  prefix: 'fal',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM228.7 244.7l80-80c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 214.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faPalette = {
  prefix: 'fal',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M480 258.3c-.1 14.1-13.8 29.7-38.1 29.7H344c-44.2 0-80 35.8-80 80c0 5.6 .6 11.2 1.7 16.6c2.9 13.8 8.9 27.3 13.2 37c.8 1.7 1.5 3.3 2.1 4.8c5 11.6 6.9 18.2 6.9 23.5c0 19.2-12.3 29.6-22.7 30c-3.1 .1-6.2 .2-9.3 .2C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 .8 0 1.6 0 2.3zm32 .3c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48h97.9c36.5 0 69.7-24.8 70.1-61.3zM152 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTransporter4 = {
  prefix: 'fal',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", "M208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm-48 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM464 128c-8.8 0-16 7.2-16 16v16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V144c0-8.8-7.2-16-16-16zM48 352c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V416H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V368c0-8.8-7.2-16-16-16zm80 144c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faChartMixedUpCircleCurrency = {
  prefix: 'fal',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", "M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h72.2l-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5L191.7 100 326.2 204.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H416zM208 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16V432zM192 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM406.6 393.4a35.9 35.9 0 1 1 50.7-50.7 35.9 35.9 0 1 1 -50.7 50.7zm-10 32.6c21.6 13.2 49.1 13.2 70.7 0l9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3z"]
};
var faObjectsAlignRight = {
  prefix: 'fal',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480zM352 176c0 8.8-7.2 16-16 16L48 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 64zm32-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64zM352 400c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 64zm32-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64z"]
};
var faArrowsTurnRight = {
  prefix: 'fal',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", "M292 5.5c5.8-6.7 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84H112c-44.2 0-80 35.8-80 80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-61.9 50.1-112 112-112H389.4l-96-84c-6.6-5.8-7.3-15.9-1.5-22.6zm-96 256c5.8-6.6 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84H80c-26.5 0-48 21.5-48 48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448c0-44.2 35.8-80 80-80H293.4l-96-84c-6.7-5.8-7.3-15.9-1.5-22.6z"]
};
var faVest = {
  prefix: 'fal',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M96 0h18 6.4c20.5 0 36.7 13 46.7 24.7C176 35 192.9 48 224 48s48-13 56.9-23.3C290.9 13 307.1 0 327.6 0H334h18c26.5 0 48 21.5 48 48v80 58.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V296.9c0-7.8 1.4-15.6 4.2-22.9L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9l33.4 87.4-17.1 44.8L128.9 42.3C126.6 36.1 120.6 32 114 32H96c-8.8 0-16 7.2-16 16v80 58.7c0 11.6-3.2 23-9.1 32.9L36.6 276.8c-3 5-4.6 10.7-4.6 16.5V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-.8 .8-1.6 1.4-2.4 2C35.1 475.5 41 480 48 480H161.6c2.4 11.8 7.4 22.7 14.4 32H48c-26.5 0-48-21.5-48-48V293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5V128 48C48 21.5 69.5 0 96 0zM368 48c0-8.8-7.2-16-16-16H334c-6.6 0-12.6 4.1-14.9 10.3l-93 243.1c-1.4 3.6-2.1 7.5-2.1 11.4V464c0 8.8 7.2 16 16 16H400c7 0 12.9-4.5 15.1-10.7c-.9-.6-1.7-1.2-2.4-2l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 425.4V293.3c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9V128 48z"]
};
var faPig = {
  prefix: 'fal',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M484.2 32c-4.4 0-8.7 .7-12.9 1.9L416.6 50.8C399.7 56 385.5 66.4 375.5 80H240C162.6 80 98 135 83.2 208H47.4c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240H80v16c0 53.4 29.1 100 72.2 124.8L180 458.8c4.5 12.7 16.6 21.2 30.1 21.2H256c17.7 0 32-14.3 32-32V416h32 48v32c0 17.7 14.3 32 32 32h45.9c13.5 0 25.6-8.5 30.1-21.2L494 408.5c25.9-9 48.8-25.5 65.3-47.7c.3-.4 .6-.6 .8-.7l.1 0 .1 0H600c22.1 0 40-17.9 40-40V240c0-22.1-17.9-40-40-40H581.3c-5.2-3.5-9.9-7.7-14.1-12.3c25-13.7 40.9-40 40.9-68.9C608 97.3 590.7 80 569.3 80H528V75.8C528 51.6 508.4 32 484.2 32zm40.9 80h44.1c3.7 0 6.7 3 6.7 6.7c0 18.6-11 35.3-28 42.7c-9-11.5-19.1-22-30.2-31.2c3.1-5.7 5.6-11.8 7.3-18.2zM480.7 64.5c1.1-.3 2.3-.5 3.5-.5c6.5 0 11.8 5.3 11.8 11.8V90.1c0 12.5-4.5 24.1-12 33.3c-2.8 3.4-4.1 7.8-3.6 12.2s2.9 8.4 6.5 11c17.9 13 33.5 29.3 45.8 48.5c8.2 12.7 18.9 23.5 31.3 31.9c5.4 3.6 11.4 5.1 17.1 5.1H600c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H560.2c-11.1 0-20.7 5.7-26.6 13.7c-14 18.8-33.8 32.3-56.3 38.5c-5 1.4-9 5.1-10.8 10L445.9 448H400V400c0-8.8-7.2-16-16-16H320 272c-8.8 0-16 7.2-16 16v48H210.1l-29.9-83.7c-1.4-3.8-4.1-7-7.7-8.8c-36-18.7-60.5-56.2-60.5-99.5V240c0-70.7 57.3-128 128-128H380.5c1.1 0 2.2 0 3.4 0c5.9 .1 11.4-3 14.3-8.2c5.9-10.6 15.7-18.8 27.9-22.5l54.7-16.8zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faInboxFull = {
  prefix: 'fal',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M32 327.9V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V327.9c0-2.6-.3-5.2-1-7.8l0-.1H377.9l-23.2 46.3c-5.4 10.8-16.5 17.7-28.6 17.7H185.9c-12.1 0-23.2-6.8-28.6-17.7L134.1 320H33l0 .1c-.6 2.5-1 5.1-1 7.8zM421.1 88.2C417.5 74 404.7 64 390 64H122c-14.7 0-27.5 10-31 24.2L41 288h93.1c12.1 0 23.2 6.8 28.6 17.7L185.9 352H326.1l23.2-46.3c5.4-10.8 16.5-17.7 28.6-17.7H471L421.1 88.2zM0 416V327.9c0-5.2 .6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32H390c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM176 144H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleEnvelope = {
  prefix: 'fal',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm192 48.5V192H160v16.5l88.5 47.1c2.3 1.2 4.9 1.9 7.5 1.9s5.2-.6 7.5-1.9L352 208.5zm0 36.2l-73.4 39.1c-7 3.7-14.7 5.6-22.6 5.6s-15.6-1.9-22.6-5.6L160 244.8V320H352V244.8z"]
};
var faEnvelopeCircle = faCircleEnvelope;
var faTrianglePersonDigging = {
  prefix: 'fal',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", "M320 32c2.8 0 5.4 1.4 6.8 3.8l264.5 432c1.5 2.5 1.6 5.6 .2 8.1s-4.1 4.1-7 4.1H56c-2.9 0-5.6-1.6-7-4.1s-1.4-5.6 .2-8.1l264-432c1.5-2.4 4-3.8 6.8-3.8zm34.1-12.9C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512H584.5c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-37 48c9.9 0 18.6 6.6 21.2 16.2l5.9 21.8-46.5-26.8 1.8-2.4c4.2-5.5 10.7-8.8 17.6-8.8zm66.5 60.7l-14.4-52.9C320.7 256.3 299.3 240 275 240c-17 0-33 8-43.2 21.6l-12.6 16.8c-2.7 3.7-3.8 8.3-2.9 12.8s3.7 8.4 7.7 10.6l155.9 89.9-9.6 16c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h96c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-21.9 36.6-54.8-31.6zm-124.6-12l-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2L272 392.9V416c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8zM451.7 400H412.3L432 367.1 451.7 400z"]
};
var faConstruction = faTrianglePersonDigging;
var faFerry = {
  prefix: 'fal',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", "M224 0c-17.7 0-32 14.3-32 32H124c-17.1 0-28.7 17.4-22.2 33.2L114.7 96H112c-26.5 0-48 21.5-48 48V295.1c0 8.7 2.4 17.2 6.8 24.7l43.4 72.4c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-21.9L108.3 320H467.7l-33.5 55.8c-4.5 7.6-2.1 17.4 5.5 21.9s17.4 2.1 21.9-5.5l43.4-72.4c4.5-7.5 6.8-16 6.8-24.7V144c0-26.5-21.5-48-48-48h-2.7l12.8-30.8c6.6-15.8-5-33.2-22.2-33.2H384c0-17.7-14.3-32-32-32H224zM416 288H160V192H416v96zm32 0V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16V288H96V144c0-8.8 7.2-16 16-16h16H448h16c8.8 0 16 7.2 16 16V288H448zM426.7 96H149.3L136 64h56 32V32H352V64h32 56L426.7 96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faBullseyeArrow = {
  prefix: 'fal',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", "M326.3 9.8C304 3.4 280.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-24.4-3.4-48-9.8-70.3l-22.8 25.4c-1.1 1.2-2.1 2.3-3.3 3.4c2.5 13.5 3.8 27.3 3.8 41.5c0 123.7-100.3 224-224 224S32 379.7 32 256S132.3 32 256 32c14.2 0 28.1 1.3 41.5 3.8c1.1-1.1 2.2-2.2 3.4-3.3L326.3 9.8zM274.6 97.1c-6.1-.7-12.3-1.1-18.6-1.1C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-6.3-.4-12.5-1.1-18.6c-2.7-.2-5.4-.5-8.1-.9l-25-4.2c1.4 7.7 2.2 15.6 2.2 23.7c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c8.1 0 16 .8 23.7 2.2l-4.2-25c-.5-2.7-.8-5.4-.9-8.1zm66.9 96.1l70.4 11.7c16.3 2.7 32.8-3.1 43.8-15.5L499.6 140c11.7-13.1 5.8-33.9-11-38.9L428.9 83.2 410.9 23.4c-5-16.8-25.8-22.7-38.9-11L322.6 56.3c-12.3 11-18.2 27.5-15.5 43.8l11.7 70.4-74.2 74.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l74.2-74.2zm27.8-27.8l51.3-51.3 46.8 14-35.6 40c-3.7 4.1-9.2 6.1-14.6 5.2l-47.9-8zm28.6-73.9l-51.3 51.3-8-47.9c-.9-5.4 1-10.9 5.2-14.6l40-35.6 14 46.8z"]
};
var faArrowsDownToPeople = {
  prefix: 'fal',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", "M128 16c0-8.8 7.2-16 16-16s16 7.2 16 16V145.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L128 145.4V16zm292.7 92.7c6.2-6.2 16.4-6.2 22.6 0L480 145.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V145.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zM336 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 208h48V289.5c-3.8-1-7.7-1.5-11.8-1.5H307.8c-4 0-8 .5-11.8 1.5V400zm122.4-15.6L376 315.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V315.5l-42.4 68.9c-.2 .3-.3 .5-.5 .8c1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V411.5L45.6 480.4c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1C254.2 270.4 280 256 307.8 256h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V411.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9c-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 385.5V480h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H131.8c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm24 192h48V385.5c-3.8-1-7.7-1.5-11.8-1.5H483.8c-4 0-8 .5-11.8 1.5V480z"]
};
var faSeedling = {
  prefix: 'fal',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M480 32c0 95.3-69.4 174.4-160.5 189.4c2.7 10.2 4.7 20.7 6.1 31.4C431.4 234.9 512 142.9 512 32c0-17.7-14.3-32-32-32H448C367 0 296 43 256.6 107.5c7.8 8.3 15.1 17.2 21.8 26.4C310.7 73.3 374.5 32 448 32h32zM64 96c106 0 192 86 192 192H224C118 288 32 202 32 96H64zM32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320h32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V320 304 288C288 164.3 187.7 64 64 64H32z"]
};
var faSprout = faSeedling;
var faClockSeven = {
  prefix: 'fal',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V251.2l-61.3 92c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c1.8-2.6 2.7-5.7 2.7-8.9V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faLeftRight = {
  prefix: 'fal',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M502.3 231.3c6.2 6.7 9.7 15.6 9.7 24.7s-3.5 18-9.7 24.7l-84 91c-7.2 7.8-17.4 12.3-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3l0-25.7-192 0 0 25.7c0 21.1-17.1 38.3-38.3 38.3c-10.7 0-20.9-4.5-28.1-12.3l-84-91C3.5 274 0 265.2 0 256s3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3c21.1 0 38.3 17.1 38.3 38.3l0 25.7 192 0 0-25.7c0-21.1 17.1-38.3 38.3-38.3c10.7 0 20.9 4.5 28.1 12.3l84 91zM480 256c0-1.1-.4-2.2-1.2-3l-84-91c-1.2-1.3-2.8-2-4.6-2c-3.5 0-6.3 2.8-6.3 6.3l0 41.7c0 8.8-7.2 16-16 16l-224 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c-8.8 0-16-7.2-16-16l0-41.7c0-3.5-2.8-6.3-6.3-6.3c-1.7 0-3.4 .7-4.6 2l-84 91c-.8 .8-1.2 1.9-1.2 3s.4 2.2 1.2 3l84 91c1.2 1.3 2.9 2 4.6 2c3.5 0 6.3-2.8 6.3-6.3l0-41.7c0-8.8 7.2-16 16-16l0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 224 0c8.8 0 16 7.2 16 16l0 41.7c0 3.5 2.8 6.3 6.3 6.3c1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3z"]
};
var faArrowsAltH = faLeftRight;
var faBoxesPacking = {
  prefix: 'fal',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", "M592 32H304c-8.8 0-16 7.2-16 16v80H256V48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V480H592c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16zM555.3 316.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 302.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V302.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64zM352 192H32l0 64H64 320h32V192zM0 256V192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-192c-17.7 0-32-14.3-32-32zm64 32V480H320V288H64zm80 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleArrowLeft = {
  prefix: 'fal',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM228.7 148.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272 368 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-185.4 0 68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faFlashlight = {
  prefix: 'fal',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M401.8 325.4l31.5 21c24 16 50.8 27.1 78.7 32.9V132.7c-28 5.8-54.7 16.9-78.7 32.9l-31.5 21-8.1 5.4H384 48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16H384h9.7l8.1 5.4zM544 383.6c4.5 .3 9 .4 13.5 .4H592c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H557.5c-4.5 0-9 .1-13.5 .4V383.6zM0 304V208c0-26.5 21.5-48 48-48H384l31.5-21c42.1-28 91.5-43 142-43H592c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H557.5c-50.5 0-100-15-142-43L384 352H48c-26.5 0-48-21.5-48-48zm224-48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faGroupArrowsRotate = {
  prefix: 'fal',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M207.3 36.7c2.5 8.5-2.3 17.4-10.8 19.9c-14.2 4.2-27.8 10-40.6 17c2.6 7 4 14.5 4 22.4c0 35.3-28.7 64-64 64c-7.9 0-15.4-1.4-22.4-4c-7 12.8-12.7 26.4-17 40.6c-2.5 8.5-11.4 13.3-19.9 10.8s-13.3-11.4-10.8-19.9c5.2-17.6 12.4-34.3 21.3-50C37.7 126.3 32 111.8 32 96c0-35.3 28.7-64 64-64c15.8 0 30.3 5.7 41.5 15.3c15.6-8.9 32.4-16.1 50-21.3c8.5-2.5 17.4 2.3 19.9 10.8zm97.3 0c2.5-8.5 11.4-13.3 19.9-10.8c17.6 5.2 34.3 12.4 50 21.3C385.7 37.7 400.2 32 416 32c35.3 0 64 28.7 64 64c0 15.8-5.7 30.3-15.3 41.5c8.9 15.6 16.1 32.4 21.3 50c2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8c-4.2-14.2-10-27.8-17-40.6c-7 2.6-14.5 4-22.4 4c-35.3 0-64-28.7-64-64c0-7.9 1.4-15.4 4-22.4c-12.8-7-26.4-12.7-40.6-17c-8.5-2.5-13.3-11.4-10.8-19.9zm-268 268c8.5-2.5 17.4 2.3 19.9 10.8c4.2 14.2 10 27.8 17 40.6c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64c0 7.9-1.4 15.4-4 22.4c12.8 7 26.4 12.7 40.6 17c8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8c-17.6-5.2-34.3-12.4-50-21.3C126.3 474.3 111.8 480 96 480c-35.3 0-64-28.7-64-64c0-15.8 5.7-30.3 15.3-41.5c-8.9-15.6-16.1-32.4-21.3-50c-2.5-8.5 2.3-17.4 10.8-19.9zm438.6 0c8.5 2.5 13.3 11.4 10.8 19.9c-5.2 17.6-12.4 34.3-21.3 50c9.5 11.2 15.3 25.7 15.3 41.5c0 35.3-28.7 64-64 64c-15.8 0-30.3-5.7-41.5-15.3c-15.6 8.9-32.4 16.1-50 21.3c-8.5 2.5-17.4-2.3-19.9-10.8s2.3-17.4 10.8-19.9c14.2-4.2 27.8-10 40.6-17c-2.6-7-4-14.5-4-22.4c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4c7-12.8 12.7-26.4 17-40.6c2.5-8.5 11.4-13.3 19.9-10.8zM96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM144.8 168.8c0-8.8 7.2-16 16-16h45.6c14.6 0 26.4 11.8 26.4 26.4v45.6c0 8.8-7.2 16-16 16s-16-7.2-16-16V211.5c-10 12.4-16 28.1-16 45.3c0 28 15.9 52.2 39.3 64.2c7.9 4 11 13.7 7 21.5s-13.7 11-21.5 7c-33.6-17.2-56.7-52.2-56.7-92.7c0-27.6 10.8-52.8 28.4-71.4c.2-.2 .4-.4 .6-.6h-21c-8.8 0-16-7.2-16-16zm208 192H307.2c-14.6 0-26.4-11.8-26.4-26.4V288.8c0-8.8 7.2-16 16-16s16 7.2 16 16v11.7c10-12.4 16-28.1 16-45.3c0-28-15.9-52.2-39.3-64.2c-7.9-4-11-13.7-7-21.5s13.7-11 21.5-7c33.6 17.2 56.7 52.2 56.7 92.7c0 27.6-10.8 52.8-28.4 71.4c-.8 .8-1.6 1.6-2.5 2.2h22.9c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faBowlFood = {
  prefix: 'fal',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M203.8 98.2C213.9 77.5 233.8 64 256 64s42.1 13.5 52.2 34.2c2 4.1 5.6 7.2 10 8.4s9.1 .6 12.9-1.9C340 99.2 350.2 96 361 96c27.8 0 52.1 21.2 57.8 51c1.5 7.7 8.3 13.2 16.1 13c.4 0 .7 0 1.1 0c23.3 0 44 20.5 44 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-39.4-27.5-73.5-64.9-79.2C435 91.6 401.5 64 361 64c-11.4 0-22.3 2.2-32.3 6.2C312.2 47.2 286 32 256 32s-56.2 15.2-72.7 38.2c-10-4-20.9-6.2-32.3-6.2c-40.5 0-74 27.6-86.1 64.8C27.5 134.5 0 168.6 0 208c0 8.8 7.2 16 16 16s16-7.2 16-16c0-27.5 20.7-48 44-48c.4 0 .7 0 1.1 0c7.8 .2 14.7-5.3 16.1-13c5.7-29.8 30-51 57.8-51c10.8 0 21 3.2 29.8 8.7c3.8 2.4 8.6 3.1 12.9 1.9s8-4.3 10-8.4zM129.3 425.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288H479.9c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 438.4 366.5 448 352 448H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4z"]
};
var faSquare9 = {
  prefix: 'fal',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 288a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-3.7 31.9l-39.1 36.3c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8l82.7-76.8c22-20.4 34.4-49 34.4-78.9c0-53-43-96-96-96s-96 43-96 96c0 51.8 41 94 92.3 95.9z"]
};
var faCandyCane = {
  prefix: 'fal',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M361 96c10.1 0 19.5 2.7 27.7 7.5c-.6-.3-1.2-.7-1.7-1l46.2-46.2c.5 .4 .9 .7 1.4 1.1C414.2 41.5 388.7 32 361 32c-11.3 0-22.5 1.6-33.2 4.7L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8c-.2 .1-.3 .2-.5 .3L271 66.9c-15 9.4-19.5 29.1-10.2 44.1s29.1 19.5 44.1 10.2l26.8-16.8 16.1 25.7-16.1-25.7c8.7-5.5 18.9-8.4 29.2-8.4zm48.6 29.1c4.1 7.7 6.5 16.6 6.5 25.9v5.6c0 1.7-.1 3.4-.2 5.1l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c-4.6 6.4-10.4 12-17.3 16.3l-57.8 36.1 60.4 37.7-30.2 18.9-60.4-37.7-77 48.1 60.4 37.7-30.2 18.9-60.4-37.7-73 45.6 60.4 37.7-30.2 18.9L89.1 394.6 47 420.9c-15 9.4-19.5 29.1-10.2 44.1s29.1 19.5 44.1 10.2L421.4 262.4c36.4-22.8 58.6-62.7 58.6-105.7V151c0-36.6-16.5-69.3-42.4-91.1c6.7 5.6 12.8 12 18.1 19l-46.2 46.2zM361 128c-4.3 0-8.6 1.2-12.2 3.5l-26.8 16.8c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23C304.9 8 332.7 0 361 0c83.4 0 151 67.6 151 151v5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L370.5 180.9c8.4-5.2 13.5-14.4 13.5-24.3V151c0-12.7-10.3-23-23-23z"]
};
var faArrowDownWideShort = {
  prefix: 'fal',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 464c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H304z"]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faSquareDollar = {
  prefix: 'fal',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm240 24v23c13.5 1 26.6 4.6 39.6 8.3c1.5 .4 3.1 .9 4.6 1.3c8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2c-2.4-.7-4.8-1.4-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5c-19.1-2.8-36.6-.4-49.3 5.1c-12.9 5.6-18.6 13.1-19.8 19.5c-1.8 9.8 2.1 16.5 10.2 21.7c10.6 6.8 26.5 11.3 45.8 16.8l.3 .1c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9c-8.1-1.3-21.8-5.2-32.4-8.4c-6.9-2.1-13.8-4.3-20.7-6.5c-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3c11.2 3.4 22.7 6.6 28.1 7.4c19.8 2.9 36.5 1.3 48-3.4c11.2-4.5 16.8-11.3 18.3-19.7c1.9-10.5-1.5-18.4-10.2-24.4c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.8-20.7 20-35.1 38.6-43.1c7.4-3.2 15.6-5.6 24.3-7.1V120c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDollarSquare = faSquareDollar;
var faUsdSquare = faSquareDollar;
var faPhoneArrowRight = {
  prefix: 'fal',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", "M411.3 4.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 128H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H457.4L388.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faHandHoldingSeedling = {
  prefix: 'fal',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M125.1 0H144c88.4 0 160 71.6 160 160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V176H242.9C161.8 176 96 110.2 96 29.1C96 13 109 0 125.1 0zM144 32H128c1.5 62.1 52.4 112 114.9 112H271C263.1 80.9 209.3 32 144 32zM336 176V160c0-5.4-.2-10.7-.7-16C396.8 142.8 446.4 93.4 448 32H432c-45.7 0-85.8 23.9-108.4 59.9c-4.3-11.4-9.7-22.3-16-32.5C336.9 23.2 381.7 0 432 0h18.9C467 0 480 13 480 29.1c0 80.2-64.2 145.3-144 146.9zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faMessageCheck = {
  prefix: 'fal',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM363.3 147.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 241.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCommentAltCheck = faMessageCheck;
var faCloudBolt = {
  prefix: 'fal',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H384v23.4c2.6 2.6 5 5.5 7.1 8.6H408c57.4 0 104-46.6 104-104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h53.8l33.8-32H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zm95.7 264l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H191.7zM313.6 224c-5.1 0-10.1 2-13.8 5.5L150.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H215l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L361.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H297l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faThunderstorm = faCloudBolt;
var faChartLineUpDown = {
  prefix: 'fal',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM368 96h57.4L288 233.4l-68.7-68.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 198.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0L448 118.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0 288h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4l-68.7-68.7-22.6 22.6L425.4 352H368c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faTextSlash = {
  prefix: 'fal',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM390.4 64l149.1 0-11 44.1c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l11-44.1c5-20.2-10.2-39.8-31-39.8h-383c-4.7 0-9.2 1-13.3 2.9L180.1 64l177.1 0L325.1 178.5 352.3 200 390.4 64zM287.7 312L249.6 448H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H282.9l32.1-114.5L287.7 312z"]
};
var faRemoveFormat = faTextSlash;
var faWatch = {
  prefix: 'fal',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", "M128 32H256c17.7 0 32 14.3 32 32V89.7C259.8 73.3 227 64 192 64s-67.8 9.3-96 25.7V64c0-17.7 14.3-32 32-32zM64 112h1C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144H64v48c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64V400h-1c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h1V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v48zM288 422.3V448c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32V422.3c28.2 16.3 61 25.7 96 25.7s67.8-9.4 96-25.7zM32 256a160 160 0 1 1 320 0A160 160 0 1 1 32 256zm176-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 5.3 2.7 10.3 7.1 13.3l48 32c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L208 247.4V176z"]
};
var faCircleDownLeft = {
  prefix: 'fal',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM176 328c0 4.4 3.6 8 8 8H297.4c3.7 0 6.6-3 6.6-6.6c0-1.8-.7-3.4-1.9-4.7l-25.4-25.4c-6.2-6.2-6.2-16.4 0-22.6l59.1-59.1c3.6-3.6 4.9-9 3.3-13.9c-.7-2-1.8-3.8-3.3-5.3l-22.1-22.1c-1.5-1.5-3.3-2.6-5.3-3.3c-4.9-1.6-10.3-.4-13.9 3.3l-59.1 59.1c-6.2 6.2-16.4 6.2-22.6 0l-25.4-25.4c-1.2-1.2-2.9-1.9-4.7-1.9c-3.7 0-6.6 3-6.6 6.6V328zm8 40c-22.1 0-40-17.9-40-40V214.6c0-21.3 17.3-38.6 38.6-38.6c10.2 0 20.1 4.1 27.3 11.3L224 201.4l47.7-47.7c12.2-12.2 30.3-16.5 46.7-11c6.7 2.2 12.8 6 17.8 11l22.1 22.1c5 5 8.8 11.1 11 17.8c5.5 16.4 1.2 34.5-11 46.7L310.6 288l14.1 14.1c7.2 7.2 11.3 17.1 11.3 27.3c0 21.3-17.3 38.6-38.6 38.6H184z"]
};
var faText = {
  prefix: 'fal',
  iconName: 'text',
  icon: [448, 512, [], "f893", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H240l0 384h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64l0-384H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64z"]
};
var faProjector = {
  prefix: 'fal',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", "M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM267.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zm320 22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zM288 320a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0c0-36-11.9-69.3-32-96h32c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H560 544c20.1-26.7 32-60 32-96zm0 128c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H512c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16V448H320c26.7 20.1 60 32 96 32c37.3 0 71.6-12.7 98.8-34.1c-.9 .7-1.8 1.4-2.8 2.1h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448zM80 416H64c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32H288c-20.1 26.7-32 60-32 96s11.9 69.3 32 96H80zm16-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFaceSmileWink = {
  prefix: 'fal',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faSmileWink = faFaceSmileWink;
var faTombstoneBlank = {
  prefix: 'fal',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M384 192V448h32V192C416 86 330 0 224 0S32 86 32 192V448H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faTombstoneAlt = faTombstoneBlank;
var faChessKingPiece = {
  prefix: 'fal',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H52.6C41.2 96 32 105.2 32 116.6c0 2.2 .4 4.4 1.1 6.5L66.7 224H56c-8.8 0-16 7.2-16 16s7.2 16 16 16H69.8L56.7 352H89l13.1-96h51.8L167 352h32.3l-13.1-96H200c8.8 0 16-7.2 16-16s-7.2-16-16-16H189.3l33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5c0-11.4-9.2-20.6-20.6-20.6H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zm11.6 208H100.4l-32-96H128h59.6l-32 96zm34.6 160H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H216.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7L65.8 416l124.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9z"]
};
var faChessKingAlt = faChessKingPiece;
var faCircle6 = {
  prefix: 'fal',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm43.7-378.9c-6-6.5-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9c0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1 .8-22.6zM256 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faLeft = {
  prefix: 'fal',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M32 258.3l0-4.6c0-4.4 1.8-8.6 5-11.6L186.8 99.5c2.3-2.2 5.4-3.5 8.7-3.5c6.9 0 12.6 5.6 12.6 12.6l0 83.4c0 8.8 7.2 16 16 16l176 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-176 0c-8.8 0-16 7.2-16 16l0 83.4c0 6.9-5.6 12.6-12.6 12.6c-3.2 0-6.3-1.2-8.7-3.5L37 269.9c-3.2-3-5-7.2-5-11.6zM195.4 64C184 64 173 68.4 164.7 76.3L14.9 219C5.4 228 0 240.6 0 253.7l0 4.6C0 271.4 5.4 284 14.9 293L164.7 435.7C173 443.6 184 448 195.4 448c24.6 0 44.6-20 44.6-44.6l0-67.4 160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-160 0 0-67.4C240 84 220 64 195.4 64z"]
};
var faArrowAltLeft = faLeft;
var faFileWord = {
  prefix: 'fal',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm39.2 235.1c-2.7-8.4-11.7-13.1-20.1-10.4s-13.1 11.7-10.4 20.1l56 176c2.2 6.8 8.5 11.3 15.6 11.1s13.2-4.9 15.1-11.8L192 300.8l32.6 119.4c1.9 6.8 8 11.6 15.1 11.8s13.4-4.4 15.6-11.1l56-176c2.7-8.4-2-17.4-10.4-20.1s-17.4 2-20.1 10.4L241.2 359.5 207.4 235.8c-1.9-7-8.2-11.8-15.4-11.8s-13.5 4.8-15.4 11.8L142.8 359.5 103.2 235.1z"]
};
var faFilePowerpoint = {
  prefix: 'fal',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm64 240c-8.8 0-16 7.2-16 16V368v64c0 8.8 7.2 16 16 16s16-7.2 16-16V384h56c39.8 0 72-32.2 72-72s-32.2-72-72-72H128zm72 112H144V272h56c22.1 0 40 17.9 40 40s-17.9 40-40 40z"]
};
var faSquareDown = {
  prefix: 'fal',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M384 448c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0zm64-32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 400c-9.2 0-18-3.5-24.7-9.7l-91-84c-7.8-7.2-12.3-17.4-12.3-28.1c0-21.1 17.1-38.3 38.3-38.3l25.7 0 0-80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 80 25.7 0c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm3-33.2l91-84c1.3-1.2 2-2.9 2-4.6c0-3.5-2.8-6.3-6.3-6.3L272 272c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-41.7 0c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2z"]
};
var faArrowAltSquareDown = faSquareDown;
var faObjectsAlignCenterVertical = {
  prefix: 'fal',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", "M176 64c8.8 0 16 7.2 16 16l0 176 0 176c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16l0-176 0 0 0 0L96 80c0-8.8 7.2-16 16-16l64 0zm48 176l0-160c0-26.5-21.5-48-48-48l-64 0C85.5 32 64 53.5 64 80l0 160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64l0 160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-160 64 0v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V272h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448l0-96c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48l0 96-64 0zm96 16l0-112c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 112V368c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V256z"]
};
var faArrowsLeftRight = {
  prefix: 'fal',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", "M503.3 271.3c6.1-6.1 6.3-15.9 .4-22.2l-96-104c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6L455.5 244 50.6 244l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L50.6 276l402.7 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
};
var faArrowsH = faArrowsLeftRight;
var faHouseLock = {
  prefix: 'fal',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H392.6c-5.4-9.4-8.6-20.3-8.6-32H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 456.4 185.9c8.6-7.1 18.2-13 28.7-17.4L298.6 4zM336 480H240V320h96V480zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faCloudArrowDown = {
  prefix: 'fal',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM228.7 299.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 329.4V176c0-8.8 7.2-16 16-16s16 7.2 16 16V329.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80z"]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faWreath = {
  prefix: 'fal',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", "M334.9 73.3c-16.3 4.8-33.6-3.9-39.3-20C291.2 40.9 279.3 32 265.4 32c-7.9 0-15.1 2.8-20.7 7.6c-11.9 10.1-29.5 10.1-41.4 0c-5.6-4.8-12.8-7.6-20.7-7.6c-13.9 0-25.8 8.9-30.2 21.3c-5.7 16.1-22.9 24.8-39.3 20c-2.9-.8-5.9-1.3-9.1-1.3c-17.7 0-32 14.3-32 32c0 3.2 .5 6.3 1.3 9.1c4.8 16.3-3.9 33.6-20 39.3C40.9 156.8 32 168.7 32 182.6c0 7.9 2.8 15.1 7.6 20.7c10.1 11.9 10.1 29.5 0 41.4c-4.8 5.6-7.6 12.8-7.6 20.7c0 13.9 8.9 25.8 21.3 30.2c16.1 5.7 24.8 22.9 20 39.3c-.8 2.9-1.3 5.9-1.3 9.1c0 17.7 14.3 32 32 32l.5 0c-5.4 8.2-8.5 18.1-8.5 28.7v2.9c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5v-2.9c0-10.6-3.1-20.4-8.5-28.7l.5 0c17.7 0 32-14.3 32-32c0-3.2-.5-6.3-1.3-9.1c-4.8-16.3 3.9-33.6 20-39.3c12.5-4.4 21.3-16.3 21.3-30.2c0-7.9-2.8-15.1-7.6-20.7c-10.1-11.9-10.1-29.5 0-41.4c4.8-5.6 7.6-12.8 7.6-20.7c0-13.9-8.9-25.8-21.3-30.2c-16.1-5.7-24.8-22.9-20-39.3c.8-2.9 1.3-5.9 1.3-9.1c0-17.7-14.3-32-32-32c-3.2 0-6.3 .5-9.1 1.3zM235.2 458L288 477.8V418.2L235.2 438c-7.2 2.7-15.2 2.7-22.5 0L160 418.2v59.6L212.8 458c7.2-2.7 15.2-2.7 22.5 0zM128 411.1c0-15 12.1-27.1 27.1-27.1c3.2 0 6.5 .6 9.5 1.7L224 408l59.4-22.3c3-1.1 6.3-1.7 9.5-1.7c15 0 27.1 12.1 27.1 27.1v73.8c0 15-12.1 27.1-27.1 27.1c-3.2 0-6.5-.6-9.5-1.7L224 488l-59.4 22.3c-3 1.1-6.3 1.7-9.5 1.7c-15 0-27.1-12.1-27.1-27.1V411.1zm55.5-227.6c-.3 15.1-6.3 29.6-16.8 40.5c10.4 10.9 16.4 25.4 16.8 40.5c15.1 .3 29.6 6.3 40.5 16.8c10.9-10.4 25.4-16.4 40.5-16.8c.3-15.1 6.3-29.6 16.8-40.5c-10.4-10.9-16.4-25.4-16.8-40.5c-8.1-.2-16-2-23.3-5.2c-6.3-2.8-12.2-6.7-17.2-11.6c-10.9 10.4-25.4 16.4-40.5 16.8zM203 142.4c11.3-12.1 30.6-12.1 41.9 0c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1z"]
};
var faChildren = {
  prefix: 'fal',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm416 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 416 64zm64 128c-11.6 0-22.6 3.4-32 9.6V352h64V201.6c-9.4-6.2-20.4-9.6-32-9.6zM448 496c0 8.8-7.2 16-16 16s-16-7.2-16-16V243.3l-42.4 69.1c-4.6 7.5-14.5 9.9-22 5.3s-9.9-14.5-5.3-22L403.2 203c16.4-26.7 45.5-43 76.8-43s60.4 16.3 76.8 43l56.8 92.6c4.6 7.5 2.3 17.4-5.3 22s-17.4 2.3-22-5.3L544 243.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H448V496zM96 400H72c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9l38-141.2L45.3 312.8c-4.9 7.4-14.8 9.4-22.2 4.5s-9.4-14.8-4.5-22.2L79.8 203c16.8-25.3 44.4-41.1 74.5-42.9c1.4-.1 2.9-.2 4.4-.2H160h1.3c1.5 0 2.9 .1 4.4 .2c30.1 1.8 57.7 17.6 74.5 42.9l61.1 92.1c4.9 7.4 2.9 17.3-4.5 22.2s-17.3 2.9-22.2-4.5l-49.2-74.2 38 141.2c1.3 4.8 .3 9.9-2.8 13.9s-7.7 6.3-12.7 6.3H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H128v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400zm60.5-207.9c-10 .9-18.4 7.9-21.1 17.7L92.9 368H227.1L184.5 209.8c-2.6-9.8-11.1-16.8-21.1-17.7c-1.2-.1-2.3-.1-3.5-.1s-2.3 0-3.5 .1z"]
};
var faMeterDroplet = {
  prefix: 'fal',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M256 480c49.7 0 95.5-16.2 132.7-43.5c2.8 10.8 6.9 21.1 12 30.7C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-8.5 5.3-15.7 12.9-20.6 22.1l-3.8 7.1C447 102.5 359.7 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zM176 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm89.4 218.4c-6.2 11.6-9.4 24.5-9.4 37.6c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.1-3.2-26.1-9.4-37.6L528 230 457.4 362.4zm-28.2-15.1l75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z"]
};
var faChalkboard = {
  prefix: 'fal',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M64 88c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24V416h32V88c0-30.9-25.1-56-56-56H88C57.1 32 32 57.1 32 88V416H64V88zM224 400v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V400c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48zm48-16h96c8.8 0 16 7.2 16 16v40H256V400c0-8.8 7.2-16 16-16z"]
};
var faBlackboard = faChalkboard;
var faUserLargeSlash = {
  prefix: 'fal',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", "M541 512l-40.5-32H96c.7-70.8 58.3-128 129.3-128h113l-40.5-32H225.3C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H541zM464 144C464 64.5 399.5 0 320 0C265.6 0 218.2 30.2 193.7 74.8l25.6 20.2C237.5 57.7 275.7 32 320 32c61.9 0 112 50.1 112 112c0 34.9-15.9 66-40.9 86.6l25.6 20.2C445.7 224.4 464 186.3 464 144zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faUserAltSlash = faUserLargeSlash;
var faSignalStrong = {
  prefix: 'fal',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", "M464 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V112zM320 192c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zM208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"]
};
var faSignal4 = faSignalStrong;
var faLollipop = {
  prefix: 'fal',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M192 352c-27 0-52.4-6.7-74.7-18.5c8.7 1.6 17.6 2.5 26.7 2.5h16c75.1 0 136-60.9 136-136v-8c0-57.4-46.6-104-104-104S88 134.6 88 192c0 35.3 28.7 64 64 64s64-28.7 64-64v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-39.8 32.2-72 72-72s72 32.2 72 72v8c0 57.4-46.6 104-104 104H144C82.1 304 32 253.9 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM0 192C0 298 86 384 192 384c47.3 0 90.5-17.1 124-45.4L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L338.6 316c28.3-33.5 45.4-76.7 45.4-124C384 86 298 0 192 0S0 86 0 192z"]
};
var faLollypop = faLollipop;
var faListTree = {
  prefix: 'fal',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M32 112H64V80H32v32zM0 72C0 58.7 10.7 48 24 48H72c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H64v96h64v-8c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-8H64V384c0 8.8 7.2 16 16 16h48v-8c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24v-8H80c-26.5 0-48-21.5-48-48V256 144H24c-13.3 0-24-10.7-24-24V72zM160 96c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zM288 256c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 160c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zM160 432h32V400H160v32zm0-192v32h32V240H160z"]
};
var faEnvelopeOpen = {
  prefix: 'fal',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M241.6 36.8L45 182.4c-8.1 6-13 15.6-13 25.7v3.2l10.2 8.3L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L469.8 219.6l10.2-8.3v-3.2c0-10.1-4.8-19.7-13-25.7L270.4 36.8c-4.2-3.1-9.2-4.8-14.4-4.8s-10.3 1.7-14.4 4.8zM32 252.7V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V252.7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L32 252.7zM222.5 11C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L486.1 156.7c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L222.5 11z"]
};
var faDrawCircle = {
  prefix: 'fal',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", "M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm58.5-6c-10 22.4-32.4 38-58.5 38s-48.6-15.6-58.5-38C147.4 107.6 107.6 147.4 90 197.5c22.4 10 38 32.4 38 58.5s-15.6 48.6-38 58.5c17.7 50.1 57.4 89.9 107.5 107.5c10-22.4 32.4-38 58.5-38s48.6 15.6 58.5 38c50.1-17.7 89.9-57.4 107.5-107.5c-22.4-10-38-32.4-38-58.5s15.6-48.6 38-58.5C404.4 147.4 364.6 107.6 314.5 90zM454.1 192.3c32.5 3.1 57.9 30.4 57.9 63.7s-25.4 60.7-57.9 63.7c-20.5 63.6-70.7 113.9-134.3 134.3C316.7 486.6 289.3 512 256 512s-60.7-25.4-63.7-57.9C128.7 433.6 78.4 383.3 57.9 319.7C25.4 316.7 0 289.3 0 256s25.4-60.7 57.9-63.7C78.4 128.7 128.7 78.4 192.3 57.9C195.3 25.4 222.7 0 256 0s60.7 25.4 63.7 57.9c63.6 20.5 113.9 70.7 134.3 134.3zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCatSpace = {
  prefix: 'fal',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", "M448 288c-70.7 0-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7c0 70.7-57.3 128-128 128zm0-256c25.4 0 49.2 7.4 69.1 20.2L482.4 80H413.6L378.9 52.2C398.8 39.4 422.6 32 448 32zm64 274.7c56.5-24.7 96-81.1 96-146.7C608 71.6 536.4 0 448 0S288 71.6 288 160c0 4.6 .2 9.1 .6 13.6C218.8 192.1 161.5 238.4 128 299.2V176.5c0-40.3-30-74.4-70.1-79.4l-7.9-1C41.2 95 33.2 101.2 32.1 110s5.1 16.8 13.9 17.9l7.9 1c24 3 42 23.4 42 47.6V424v8c0 44.2 35.8 80 80 80h0H304l42.7 0c20.6 0 37.3-16.7 37.3-37.3c0-25.8-16.7-47.7-39.8-55.6L416 379.2V464c0 26.5 21.5 48 48 48s48-21.5 48-48V306.7zm-32 10.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-5.7-3-10.9-7.9-13.8s-10.9-3-15.9-.2L304 404.8V392c0-39.8-32.2-72-72-72h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c22.1 0 40 17.9 40 40v40 0c0 8.8 7.2 16 16 16h37.3c14.7 0 26.7 11.9 26.7 26.7c0 2.9-2.4 5.3-5.3 5.3H304l0 0H176c-26.5 0-48-21.5-48-48v-8c0-103.1 69.2-192 166.5-218.8C314 271.5 375.3 320 448 320c11 0 21.7-1.1 32-3.2zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V16zM384 97.3l14 11.2c2.8 2.3 6.4 3.5 10 3.5h80c3.6 0 7.2-1.2 10-3.5l14-11.2V160c0 35.3-28.7 64-64 64s-64-28.7-64-64V97.3zM416 168a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHandshakeSimpleSlash = {
  prefix: 'fal',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM368.5 212.8l11.9-11c6.5-6 6.9-16.1 .9-22.6s-16.1-6.9-22.6-.9l-15.6 14.4 25.4 20.1zm-81.7-64.5l27.5-26C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.9 2.4 6.5 3.8 10.3 3.8H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H503.3L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-30.9 29.2 25.4 20zm-58.7-46.4c3.1-1 6.2-1.9 9.3-2.7L272.6 64h-8.7c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6zM54.6 128H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H95.1L54.6 128zm139 109.8c.2 .8 .4 1.5 .6 2.2h2.3l-2.8-2.2zM370.4 377.3c1.5 9.3-1.1 19.1-7.8 26.6c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-13.5-13.5-31.8-21.1-50.9-21.1H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h59.4c10.6 0 20.8 4.2 28.3 11.7l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6.5-7.3 11-15.6 13.6-24.4l-29.7-23.5zm132.5-58.5l40.5 32H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H502.9z"]
};
var faHandshakeAltSlash = faHandshakeSimpleSlash;
var faRabbitRunning = {
  prefix: 'fal',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", "M480 224c7.1 0 13.1 4.6 15.2 10.9l1.3-.4c-.4 .2-.8 .4-1.2 .6c.5 1.5 .8 3.2 .8 4.9c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16zm-31-75.8c14.7 2.1 28.9 6.6 42 13.5c-.7-35-15-69-40.8-94.2l-1.4-1.4c-1.9-1.9-4.7-2.7-7.3-2.2l-1.6 .3c-2.3 .4-4.2 1.9-5.3 3.9C427.1 60.4 419 53.4 410.3 47c5.8-7.3 14.1-12.4 23.5-14.2l1.6-.3c13-2.5 26.4 1.5 35.8 10.8l1.4 1.4c37.1 36.4 55 87.5 49.4 138.2l23.7 17.7c19 14.2 30.2 36.5 30.2 60.3c0 41.5-33.7 75.2-75.2 75.2H406.6l-32 32H424c26.5 0 48 21.5 48 48s-21.5 48-48 48H306.5c-21.2 0-41.6-8.4-56.6-23.4L237 427.7l-66.4 44.3c-22.1 14.7-51.9 8.7-66.6-13.3s-8.7-51.9 13.3-66.6l50.4-33.6-55-55c-9.8-9.8-17.6-21.2-23.1-33.7C84 271.2 78.1 272 72 272c-39.8 0-72-32.2-72-72s32.2-72 72-72c16.3 0 31.3 5.4 43.3 14.5c20.1-18.9 47.1-30.5 76.9-30.5h9c17.3 0 34.4 3.7 50.2 10.9l66 30c-2.3-5.4-4.2-11-5.8-16.8l-10.2-37c-5.1-18.5 2.9-38.1 19.5-47.7l7.9 13.7-7.9-13.7 2.1-1.2c9-5.2 19.9-6.3 29.8-3.1c47 15.5 83.1 53.5 96.2 101.1zM81 239c-.7-4.9-1-9.8-1-14.8c0-20.7 5.6-40 15.3-56.7C88.8 162.8 80.7 160 72 160c-22.1 0-40 17.9-40 40s17.9 40 40 40c3.1 0 6.1-.4 9-1zm54.1 179.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L214 404.6l-23.1-23.1-55.8 37.2zm201-18.7c-3.7 0-7.2-1.2-10-3.4c-.6-.5-1.2-1-1.7-1.6c-2.2-2.3-3.8-5.3-4.3-8.7c-.1-.4-.1-.9-.1-1.3l-1.7-24.4c-3.3-46.1-34.6-85.5-78.8-99.1l-20.2-6.2c-8.4-2.6-13.2-11.6-10.6-20s11.6-13.2 20-10.6l20.2 6.2c53.6 16.5 92.4 62.4 100.2 117.3l39.6-39.6c3-3 7.1-4.7 11.3-4.7H500.8c23.9 0 43.2-19.3 43.2-43.2c0-13.6-6.4-26.5-17.4-34.6l-37.3-27.9c-15.7-11.7-34.4-18.4-53.8-19.3c-7-.3-13-5.2-14.8-12.1l-2-7.8c-9.7-38.5-38.4-69.3-76-81.7c-1.2-.4-2.6-.3-3.8 .4m0 0l-2.1 1.2c-4 2.3-5.9 7-4.7 11.5l10.2 37c5.5 20 16.5 37.9 31.4 51.9c5.7 5.4 6.7 14.1 2.4 20.6s-12.8 8.9-19.9 5.7L238.1 152c-11.6-5.3-24.2-8-36.9-8h-9c-44.3 0-80.2 35.9-80.2 80.2c0 21.3 8.4 41.7 23.5 56.7L272.6 417.9c9 9 21.2 14.1 33.9 14.1H424c8.8 0 16-7.2 16-16s-7.2-16-16-16H336.2"]
};
var faRabbitFast = faRabbitRunning;
var faMemoPad = {
  prefix: 'fal',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", "M32 128V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V128H32zm0-32H416V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V96zM448 64V96v16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128 112 96 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64zM112 192H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMattressPillow = {
  prefix: 'fal',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", "M256 96V416H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H256zm32 0H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H288V96zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm112 96c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H112z"]
};
var faAlarmPlus = {
  prefix: 'fal',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 80c-8.8 0-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V192c0-8.8-7.2-16-16-16z"]
};
var faAlicorn = {
  prefix: 'fal',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M335.5 148.1c-.5 1.9-1.3 3.6-2.5 5.2c-1.4 1.9-3.1 3.4-5 4.5s-4.1 1.8-6.4 2.1c-3.2 .3-6.6-.3-9.6-2L169.9 76.6c7 52.2 32.2 91.2 57.8 118.4c15.1 16 30.1 27.8 41.4 35.5c5.6 3.9 10.3 6.7 13.5 8.6c1.6 .9 2.8 1.6 3.6 2l.9 .5 .2 .1 0 0 0 0c7.9 4 11.1 13.6 7.1 21.5s-13.6 11.1-21.5 7.2L280 256c-7.2 14.3-7.2 14.3-7.2 14.3l0 0 0 0-.1-.1-.4-.2c-.3-.2-.7-.4-1.3-.7c-1.1-.6-2.6-1.4-4.5-2.5c-3.8-2.2-9.2-5.5-15.5-9.9c-12.7-8.7-29.6-22-46.6-40C170.4 180.9 136 125.2 136 48c0-5.7 3-11 8-13.8s11-2.9 16-.1l146.4 83.7C318.7 50.8 377.4 0 448 0h24 8 5.8H544c8.8 0 16 7.2 16 16c0 7-4.5 13-10.8 15.1c7.3 9.5 12.5 20.6 15 32.9h66.5c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-65.2 21.7 4.7 49.4c2.3 23.9-9.2 47.1-29.6 59.9c-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5H448v40c0 .7-.1 1.5-.1 2.2c.1 1.9 .1 3.9 .1 5.8c0 30.9-12.4 58.4-32 78.4V472c0 22.1-17.9 40-40 40H344c-22.1 0-40-17.9-40-40V347.6l-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7H141.6c-18 0-33.7-12-38.5-29.3L89.6 434.1c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4 .3-.8 .3-1.3c0-.4-.1-.8-.2-1.2L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-41.3 31.3-75.2 71.4-79.5c9-19.8 25.6-35.4 46-43.1c3.4 10.4 7.4 20.4 11.8 29.8C109.8 170.2 96 188.8 96 210.7c0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5c0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9h33.2c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8c0-4.6-.4-9.2-1.1-13.7c-.9-5.3 .9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4 .3 2.8 .6 4.3 .8c7.7 1.3 13.3 8 13.3 15.8V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311.6c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7c-.1-1.5 0-3.1 .3-4.5V176c0-8.8 7.2-16 16-16h32c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2c10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4H480h-8H448c-61.8 0-111.9 50-112 111.7c0 1.5-.1 2.9-.5 4.4zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faCommentQuestion = {
  prefix: 'fal',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM168.7 153.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V272c0 8.8 7.2 16 16 16s16-7.2 16-16V252.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faGingerbreadMan = {
  prefix: 'fal',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M144 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 20.5-7.7 39.2-20.4 53.3c-4.2 4.7-5.3 11.4-2.7 17.2s8.3 9.5 14.6 9.5H368c26.5 0 48 21.5 48 48s-21.5 48-48 48h-7c-32.4 0-50.3 37.7-29.7 62.8l41.7 50.7c16.8 20.5 13.9 50.7-6.6 67.6s-50.7 13.9-67.6-6.6l-45.3-55c-15.4-18.7-43.9-18.7-59.3 0l-45.3 55c-16.8 20.5-47.1 23.4-67.6 6.6S58.1 422 74.9 401.5l41.7-50.7C137.3 325.7 119.4 288 87 288H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h72.4c6.3 0 12-3.7 14.6-9.5s1.5-12.5-2.7-17.2C151.7 151.2 144 132.5 144 112zM224 0C162.1 0 112 50.1 112 112c0 17.2 3.9 33.4 10.8 48H80c-44.2 0-80 35.8-80 80s35.8 80 80 80h7c5.4 0 8.4 6.3 4.9 10.5L50.2 381.2c-28.1 34.1-23.2 84.5 10.9 112.6l9.1-11.1-9.1 11.1c34.1 28.1 84.5 23.2 112.6-10.9l45.3-55c2.6-3.1 7.3-3.1 9.9 0l45.3 55c28.1 34.1 78.5 39 112.6 10.9s39-78.5 10.9-112.6l-41.7-50.7c-3.4-4.2-.5-10.5 4.9-10.5h7c44.2 0 80-35.8 80-80s-35.8-80-80-80H325.2c6.9-14.6 10.8-30.8 10.8-48C336 50.1 285.9 0 224 0zM192 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faGuaraniSign = {
  prefix: 'fal',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M176 0c-8.8 0-16 7.2-16 16V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c106 0 192-86 192-192c0-8.8-7.2-16-16-16H192V96c43.6 0 83.1 17.4 112 45.7c6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6C291.8 85 244.3 64 192 64l0-48c0-8.8-7.2-16-16-16zM160 99.2V412.8C87 398 32 333.4 32 256s55-142 128-156.8zM192 416V272H351.2c-8 80.9-76.2 144-159.2 144z"]
};
var faBurgerFries = {
  prefix: 'fal',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", "M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3V266.4c-8.5 2.4-19 4.3-32 5.1V57.9l-32-16V271.5c-13-.9-23.5-2.7-32-5.1V16c0-5.5 2.9-10.7 7.6-13.6zM279.1 233.8c-1 4-2.9 9-7.1 14.1V208.6L299.1 84.5 272 89.9V57.3l44.9-9c5.3-1.1 10.8 .6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zm88.7-55.6c-10.2 4.1-19.5 8.8-28.1 13.7h-7.2l19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8l-15.8 79.1zM192 304c27.6 0 48.8-3.7 65.2-9.5c-.9 6.3-1.2 12.4-1.2 18.1c0 5.3 .7 10.3 2.1 15.2c-18.6 5.3-40.4 8.2-66.1 8.2c-49.1 0-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256H34.9L89.2 480H260c3.7 11.9 9.7 22.7 17.6 32H89.2c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H54.3c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304zM21.4 192c-.9 0-1.7 0-2.5 .1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3s17.1 3.9 18.8 12.6L51.5 192H21.4zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7c-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1V53.9L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zm210.7 23.9c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3H602.7c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7H581.3c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3H325.3z"]
};
var faMugTea = {
  prefix: 'fal',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M144 96H64V352c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V272 96H352 176v40.5l36.5 30.4C219.8 173 224 182 224 191.5V256c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V191.5c0-9.5 4.2-18.5 11.5-24.6L144 136.5V96zm16-32H352h32 80c61.9 0 112 50.1 112 112s-50.1 112-112 112H416v64c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h96zM464 96H416V256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80zM128 256h64V191.5l-32-26.7-32 26.7 0 64.5z"]
};
var faBorderTop = {
  prefix: 'fal',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M0 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48zM56 160A24 24 0 1 1 8 160a24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-144 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 352a24 24 0 1 1 48 0A24 24 0 1 1 8 352zm432 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-144 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 448a24 24 0 1 1 48 0A24 24 0 1 1 8 448zm432 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM152 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM296 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faArrowsRotate = {
  prefix: 'fal',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M69.4 210.6C89.8 126.5 165.6 64 256 64c71.1 0 133.1 38.6 166.3 96H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h80.7H464c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v60.6C408.8 75.5 337.5 32 256 32C149.6 32 60.5 106.2 37.7 205.6C35.5 215.2 43.1 224 53 224c7.9 0 14.6-5.7 16.5-13.4zm373.2 90.9C422.2 385.5 346.4 448 256 448c-71.1 0-133.1-38.6-166.3-96h54.5c8.8 0 16-7.2 16-16s-7.2-16-16-16H63.3 48.2c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V371.8C103.4 436.6 174.7 480 256 480c106.4 0 195.5-74.2 218.3-173.6c2.2-9.6-5.4-18.4-15.3-18.4c-7.9 0-14.6 5.7-16.5 13.4z"]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faCircleBookOpen = {
  prefix: 'fal',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-69.7v130l.7-.1c12.3-2.1 29.3-4.2 47.3-4.2c18.4 0 35.4 5.9 48 11.8V186.3c-2.4-1-5.3-2.1-8.5-3.2c-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2zM246 364.5l-.1-.1c-.2-.1-.4-.3-.8-.6c-.7-.5-1.8-1.3-3.3-2.3c-2.9-2-7.2-4.6-12.5-7.3C218.7 348.8 205.3 344 192 344c-15.7 0-30.8 1.9-42 3.8c-5.6 1-10.1 1.9-13.3 2.6c-1.6 .4-2.8 .6-3.6 .8l-.9 .2-.2 0 0 0 0 0c-4.8 1.3-9.9 .2-13.8-2.8s-6.2-7.7-6.2-12.7V176c0-5.9 3.3-11.4 8.5-14.1L128 176c-7.5-14.1-7.5-14.1-7.5-14.1l0 0 0 0 0 0 .1-.1 .4-.2c.3-.2 .7-.4 1.2-.6c1.1-.5 2.5-1.2 4.4-2.1c3.7-1.7 9-3.9 15.5-6c12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c5.7 1.9 10.6 3.9 14.2 5.5c3.6-1.6 8.5-3.5 14.2-5.5c12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c6.4 2.2 11.7 4.4 15.5 6c1.9 .8 3.4 1.5 4.4 2.1c.5 .3 .9 .5 1.2 .6l.4 .2 .1 .1 0 0 0 0 0 0s0 0-7.5 14.1l7.5-14.1c5.2 2.8 8.5 8.2 8.5 14.1V336c0 5-2.3 9.6-6.2 12.7s-9 4.1-13.8 2.8l0 0 0 0-.2 0-.9-.2c-.8-.2-2-.5-3.6-.8c-3.1-.7-7.7-1.6-13.3-2.6c-11.2-1.9-26.3-3.8-42-3.8c-13.3 0-26.7 4.8-37.4 10.3c-5.2 2.7-9.5 5.3-12.5 7.3c-1.5 1-2.6 1.8-3.3 2.3c-.4 .3-.6 .5-.8 .6l-.1 .1c-.3 .3-.7 .5-1 .8c-.3 .2-.6 .4-.9 .5c-2.3 1.4-5 2.1-7.6 2.2c-.4 0-.8 0-1.3 0c-2.7-.1-5.3-1-7.7-2.4c-.5-.3-1-.7-1.5-1zm26-40.7c12.6-6 29.6-11.8 48-11.8c18.1 0 35 2.1 47.3 4.2l.7 .1v-130c-2.4-1-5.3-2.1-8.5-3.2c-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2V323.8z"]
};
var faBookCircle = faCircleBookOpen;
var faArrowsToDottedLine = {
  prefix: 'fal',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", "M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 137.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm384 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM320 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM128 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm107.3 44.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V374.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z"]
};
var faFireExtinguisher = {
  prefix: 'fal',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M320 96V80 64L480 32l0 96L320 96zM288 64H192V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64C104.5 64 55.6 92.3 27 135.1c-7.3 11-13.4 22.9-17.8 35.6c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8c3.6-10.1 8.4-19.7 14.3-28.4C76.5 118.6 115.6 96 160 96v33.1c-54.3 7.8-96 54.4-96 110.9V448c0 35.3 28.7 64 64 64h96c35.3 0 64-28.7 64-64V240c0-56.4-41.7-103.1-96-110.9V96h96v0c0 15.3 10.8 28.4 25.7 31.4l160 32c9.4 1.9 19.1-.6 26.6-6.6s11.7-15.2 11.7-24.7V32c0-9.6-4.3-18.7-11.7-24.7s-17.2-8.5-26.6-6.6l-160 32c-15 3-25.7 16.1-25.7 31.4zM176 160c44.2 0 80 35.8 80 80V384H96V240c0-44.2 35.8-80 80-80zm80 288c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416H256v32z"]
};
var faGarageOpen = {
  prefix: 'fal',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", "M313.8 36c4-1.7 8.4-1.7 12.4 0L588.4 146.4c11.9 5 19.6 16.6 19.6 29.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V175.9c0-25.8-15.4-49-39.2-59L338.6 6.5c-11.9-5-25.3-5-37.3 0L39.2 116.9C15.4 126.9 0 150.1 0 175.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V175.9c0-12.9 7.7-24.5 19.6-29.5L313.8 36zM128 192c-17.7 0-32 14.3-32 32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V288H512V496c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7-14.3-32-32-32H128zm384 64H128V224H512v32zM212.5 320l-10.6 32.8C186.3 362.7 176 380.2 176 400v96c0 8.8 7.2 16 16 16s16-7.2 16-16V480H432v16c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-19.8-10.3-37.3-25.9-47.2L427.5 320H393.8l7.8 24H238.4l7.8-24H212.5zM432 400v48H208V400c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24zM248 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faShelvesEmpty = {
  prefix: 'fal',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V176 432v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V432 176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V160H32V16zm0 176H608V416H32V192z"]
};
var faCruzeiroSign = {
  prefix: 'fal',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M64 256C64 150.1 150.6 64 257.7 64c49.6 0 94.9 18.5 129.2 48.9c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6c-39.9-35.4-92.7-57-150.4-57C133.2 32 32 132.2 32 256s101.2 224 225.7 224c57.7 0 110.5-21.6 150.4-57c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3C352.6 429.5 307.3 448 257.7 448c-11.5 0-22.7-1-33.7-2.9V320c0-26.5 21.5-48 48-48c15.1 0 29.3 7.1 38.4 19.2l4.8 6.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4L336 272c-15.1-20.1-38.8-32-64-32c-18 0-34.6 6-48 16V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v80V436.7C117.3 410 64 339.1 64 256z"]
};
var faWatchApple = {
  prefix: 'fal',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zM192 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56-120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faWatchCalculator = {
  prefix: 'fal',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm16 96H288V160H96v32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144zm64 136a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faListDropdown = {
  prefix: 'fal',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", "M64 64C46.3 64 32 78.3 32 96v64H480V96c0-17.7-14.3-32-32-32H64zM32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"]
};
var faCabinetFiling = {
  prefix: 'fal',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", "M416 240H32V64c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V240zM0 256v16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V272 256 240 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V240v16zM416 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V272H416V448zM160 96c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7-14.3-32-32-32H160zm0 256c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-17.7-14.3-32-32-32H160z"]
};
var faBurgerSoda = {
  prefix: 'fal',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", "M202.4 36.4C207.8 15 227 0 249 0h23c8.8 0 16 7.2 16 16s-7.2 16-16 16H249c-7.3 0-13.7 5-15.5 12.1l-21 83.9H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 192.4c-.2 0-.5 0-.7 0H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H179.5l22.9-91.6zM60.3 468l-23-276H69.4L92.2 465.3c.7 8.3 7.6 14.7 15.9 14.7H260c3.7 11.9 9.7 22.7 17.5 32c-.6 0-1.1 0-1.7 0H108.2c-25 0-45.8-19.1-47.8-44zM330.9 279.4c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3H602.7c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7H581.3c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3H325.3z"]
};
var faSquareArrowUp = {
  prefix: 'fal',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm235.3 36.7l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 182.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V182.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faArrowSquareUp = faSquareArrowUp;
var faGreaterThanEqual = {
  prefix: 'fal',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M41.9 62.8c-8.2-3.3-12.1-12.7-8.8-20.9s12.7-12.1 20.9-8.8l352 144c6 2.5 9.9 8.3 9.9 14.8s-3.9 12.3-9.9 14.8l-352 144c-8.2 3.3-17.5-.6-20.9-8.8s.6-17.5 8.8-20.9L357.7 192 41.9 62.8zM432 448c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432z"]
};
var faPalletBox = {
  prefix: 'fal',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", "M464 32c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64V144c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3V32h64zM272 32h96v80L329.6 83.2c-5.7-4.3-13.5-4.3-19.2 0L272 112V32zM176 0c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zM0 368c0 8.8 7.2 16 16 16H64v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80 320 560h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H560 320 80 16c-8.8 0-16 7.2-16 16zM96 480V384H304v96H96zm240 0V384H544v96H336z"]
};
var faFaceConfounded = {
  prefix: 'fal',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216.9 98.7L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0zM129.3 216.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 256l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 256l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faShieldHalved = {
  prefix: 'fal',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M240 38.8V472.6C86.8 397.1 48.5 233.2 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6L240 38.8zm32 433.8V38.8l173.2 73.5c11.3 4.8 18.9 15.5 18.8 27.6c-.5 93.3-38.8 257.3-192 332.8zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8z"]
};
var faShieldAlt = faShieldHalved;
var faTruckPlow = {
  prefix: 'fal',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M176 64h94.1c5.6 0 10.7 2.9 13.7 7.7L357.2 192H160V80c0-8.8 7.2-16 16-16zM394.8 192l-5.1-8.3L311 55c-8.7-14.3-24.2-23-41-23H176c-26.5 0-48 21.5-48 48V192H56c-30.9 0-56 25.1-56 56v96c0 19.4 13.7 35.5 32 39.2l0 .8c0 53 43 96 96 96s96-43 96-96h48c0 53 43 96 96 96s96-43 96-96h56.5l75.2 90.2c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5L544 362.2V352 213.8l76.3-91.6c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2l-80 96c-2.4 2.9-3.7 6.5-3.7 10.2V352H479.2c.5-2.6 .8-5.3 .8-8V248c0-30.9-25.1-56-56-56H394.8zM448 330.9C430.8 305 401.4 288 368 288c-41.8 0-77.4 26.7-90.5 64H218.5c-13.2-37.3-48.7-64-90.5-64c-41.7 0-77.1 26.5-90.4 63.6c-3.2-1-5.6-4.1-5.6-7.6V248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24v82.9zM64 384a64 64 0 1 1 128 0A64 64 0 1 1 64 384zm304-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faBookAtlas = {
  prefix: 'fal',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM176.5 224h-31c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 208a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 131.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 224H208.6c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z"]
};
var faAtlas = faBookAtlas;
var faVirus = {
  prefix: 'fal',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M75 75c-12.5 12.5-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75zm331.2 30.8C350.8 161.2 390.1 256 468.5 256c-78.4 0-117.7 94.8-62.2 150.2l0 0C350.8 350.8 256 390 256 468.4c0-78.4-94.8-117.6-150.2-62.2C161.2 350.8 121.9 256 43.5 256c78.4 0 117.7-94.8 62.2-150.2l0 0C161.2 161.2 256 121.9 256 43.5c0 78.4 94.8 117.7 150.2 62.2zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faGridRound2 = {
  prefix: 'fal',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", "M128 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 384a96 96 0 1 1 192 0zm96-256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z"]
};
var faCommentMiddleTop = {
  prefix: 'fal',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M216.9 117.7L256 39.6l39.1 78.1c4.3 8.6 12.3 14.8 21.7 16.9C415.4 156.5 480 227.6 480 304c0 91.3-93.8 176-224 176S32 395.3 32 304c0-76.4 64.6-147.5 163.3-169.4c9.4-2.1 17.4-8.3 21.7-16.9zm44.5-89l0 0L256 25.9l5.5 2.7s0 0 0 0zm62.2 74.7l-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304C0 418.9 114.6 512 256 512s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z"]
};
var faEnvelopeCircleCheck = {
  prefix: 'fal',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M64 96H448c17.7 0 32 14.3 32 32v32.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H360.2c-8.1-9.8-15.2-20.6-21-32H64c-17.7 0-32-14.3-32-32V207.6L208.7 337.1c28.2 20.6 66.5 20.6 94.6 0l17.1-12.5c1-16.2 4.3-31.8 9.4-46.6l-45.4 33.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9V128c0-17.7 14.3-32 32-32zM496 224a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 353.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faLayerGroup = {
  prefix: 'fal',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"]
};
var faRestroomSimple = {
  prefix: 'fal',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm96 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM57.8 236c2.1-24.9 22.9-44 47.8-44h44.8c25 0 45.8 19.1 47.8 44l4.1 49.3c1.6 18.7-13.2 34.7-31.9 34.7H85.6c-18.7 0-33.4-16-31.9-34.7L57.8 236zm-31.9-2.7l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 64h31.4c14.3 0 26.8 9.5 30.8 23.2L597.6 352H426.4l39.1-136.8c3.9-13.7 16.5-23.2 30.8-23.2zm0-32c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H448V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h21.6c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H496.3z"]
};
var faArrowsToDot = {
  prefix: 'fal',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4L187.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 137.4 272 16zm16 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm59.3 171.3c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 374.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V374.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0zM84.7 164.7c-6.2 6.2-6.2 16.4 0 22.6L137.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H137.4L84.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0zm342.6 0c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L374.6 272H496c8.8 0 16-7.2 16-16s-7.2-16-16-16l-121.4 0 52.7-52.7c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faBorderOuter = {
  prefix: 'fal',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faHashtagLock = {
  prefix: 'fal',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", "M195.6 32.4c8.6 2 14 10.6 12 19.2L186.3 144H313.4l23-99.6c2-8.6 10.6-14 19.2-12s14 10.6 12 19.2L346.3 144H432c8.8 0 16 7.2 16 16c0 .4 0 .8 0 1.1c-15.1 2.2-29.2 7.3-41.7 14.9H338.9L271.6 467.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2L261.7 368H134.6l-23 99.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2L101.7 368H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h93.1L146 176H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H153.4l23-99.6c2-8.6 10.6-14 19.2-12zM178.9 176L142 336H269.1L306 176H178.9zM464 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H544V352H384z"]
};
var faClockTwoThirty = {
  prefix: 'fal',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V256c0-5.3 2.7-10.3 7.1-13.3l96-64c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2L272 264.6V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faArchway = {
  prefix: 'fal',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M0 48c0-8.8 7.2-16 16-16H48 464h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480V448h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H464 424 368c-8.8 0-16-7.2-16-16V352c0-53-43-96-96-96s-96 43-96 96V464c0 8.8-7.2 16-16 16H88 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V64H16C7.2 64 0 56.8 0 48zM64 64v64H448V64H64zm0 96V448H88h40V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96h40 24V160H64z"]
};
var faHeartCircleCheck = {
  prefix: 'fal',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHouseChimneyCrack = {
  prefix: 'fal',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H274.1l-47.4-71.1c-4.9-7.4-2.9-17.3 4.4-22.2l79.8-53.2-82.2-82.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-82.7 55.1L312.6 480H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7z"]
};
var faHouseDamage = faHouseChimneyCrack;
var faFileZipper = {
  prefix: 'fal',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm32 48h32c7.1 0 13.4 4.7 15.4 11.6L158 318.9c1.3 4.6 2 9.3 2 14V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3.1c0-4.7 .7-9.5 2-14l14.7-51.3c2-6.9 8.2-11.6 15.4-11.6zm.7 71.7c-.5 1.7-.7 3.5-.7 5.2V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-3.1c0-1.8-.2-3.5-.7-5.2L115.9 288h-7.9L96.7 327.7z"]
};
var faFileArchive = faFileZipper;
var faHeartHalf = {
  prefix: 'fal',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M256 451.5v-.3V96L244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L224 465.1l.3 .2 3.5 3.2 9 8.4c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5V456.2v-4.7zm-32-30.2L69.4 277C45.6 254.7 32 223.6 32 190.9v-5.8c0-54.2 39.2-100.5 92.7-109.4c35.3-5.9 71.4 5.6 96.7 31l2.6 2.6v312z"]
};
var faCommentCheck = {
  prefix: 'fal',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM363.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faSquare = {
  prefix: 'fal',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faMemo = {
  prefix: 'fal',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMartiniGlassEmpty = {
  prefix: 'fal',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M33 32c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L256 257.4 479.7 33.7c.2-.2 .3-.4 .3-.7c0-.5-.4-1-1-1H33zM240 286.6L9.7 56.3C3.5 50.1 0 41.7 0 33C0 14.8 14.8 0 33 0H479c18.2 0 33 14.8 33 33c0 8.7-3.5 17.1-9.7 23.3L272 286.6V480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H256 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V286.6z"]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCouch = {
  prefix: 'fal',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M448 64c53 0 96 43 96 96v37.5c10-3.5 20.8-5.5 32-5.5V160c0-70.7-57.3-128-128-128H192C121.3 32 64 89.3 64 160v32c11.2 0 22 1.9 32 5.5V160c0-53 43-96 96-96H448zM96 320v96 16c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32zM80 480c20.9 0 38.7-13.4 45.3-32H514.7c6.6 18.6 24.4 32 45.3 32h32c26.5 0 48-21.5 48-48V288c0-35.3-28.7-64-64-64s-64 28.7-64 64H128c0-35.3-28.7-64-64-64s-64 28.7-64 64V432c0 26.5 21.5 48 48 48H80zm48-64V320H512v96H128zm416 16V416 320 288c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16z"]
};
var faCediSign = {
  prefix: 'fal',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M208 0c8.8 0 16 7.2 16 16V64c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3c7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96c-1.3 0-2.7 0-4 0V416c1.3 0 2.7 0 4 0c37 0 71.1-12 98.5-32.1c7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V444.8C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8V16c0-8.8 7.2-16 16-16zM64 256c0 76 54.5 140.1 128 156.1V99.9C118.5 115.9 64 180 64 256z"]
};
var faItalic = {
  prefix: 'fal',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 48c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H283L135.3 448H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85L248.7 64H144c-8.8 0-16-7.2-16-16z"]
};
var faGlassCitrus = {
  prefix: 'fal',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", "M373.4 255.9C432.7 253.1 480 204 480 144c0-61.9-50.1-112-112-112c-44.7 0-83.2 26.2-101.2 64H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 79-63.6 143.1-142.3 144l3.7-32.1zM40.9 160c-4.8 0-8.5 4.2-7.9 8.9L43 256H309l10-87.1c.5-4.7-3.2-8.9-7.9-8.9H40.9zM65.4 451.7C67.3 467.8 81 480 97.2 480H254.7c16.3 0 29.9-12.2 31.8-28.3L305.3 288H46.6L65.4 451.7zM1.2 172.6C-1.6 148.8 17 128 40.9 128H311c23.9 0 42.5 20.8 39.7 44.6L318.3 455.3c-3.7 32.3-31.1 56.7-63.6 56.7H97.2c-32.5 0-59.9-24.4-63.6-56.7L1.2 172.6z"]
};
var faCalendarLinesPen = {
  prefix: 'fal',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H258.8c-3.1-8.8-3.7-18.4-1.4-27.8l1.1-4.2H64c-17.7 0-32-14.3-32-32V192H384h32 32V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 272c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm422.8-8l17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40L496.2 264c6.2-6.2 16.4-6.2 22.6 0zM342.5 417.7L448.7 311.5l40 40L382.4 457.7c-2.1 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zM473.5 241.4L319.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2L382.8 493c8.4-2.1 16.1-6.5 22.3-12.6L558.8 326.6c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faChurch = {
  prefix: 'fal',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H264c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v39.4l-115.5 77c-17.8 11.9-28.5 31.9-28.5 53.3V480H64c-17.7 0-32-14.3-32-32V378.1c0-10.9 5.5-21 14.6-26.9L128 298.6V260.5L29.2 324.4C11 336.2 0 356.4 0 378.1V448c0 35.3 28.7 64 64 64H184v0h72 32 64 32 72v0H576c35.3 0 64-28.7 64-64V378.1c0-21.7-11-41.9-29.2-53.7L512 260.5v38.1l81.4 52.7c9.1 5.9 14.6 16 14.6 26.9V448c0 17.7-14.3 32-32 32H480V249.7c0-21.4-10.7-41.4-28.5-53.3L336 119.4V80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V16zM448 480H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H192V249.7c0-10.7 5.3-20.7 14.2-26.6L320 147.2l113.8 75.8C442.7 229 448 239 448 249.7V480zm-96-96v96H288V384c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faPersonSnowmobiling = {
  prefix: 'fal',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", "M256 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 176 56zM335.8 74.3c7.6-4.5 17.4-2.1 21.9 5.5l43.8 73 156.8 78.4c10.8 5.4 17.7 16.5 17.7 28.6v59.1c0 10.7-5.3 20.7-14.2 26.6l-76.1 50.8 63.1 82c.4 .6 .8 1.2 1.2 1.8h19.5l43.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-3 3-7.1 4.7-11.3 4.7H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h77.7l-61.5-80H313.3c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l39.2-78.3C76.6 278.8 87.7 272 99.8 272H288l36-48H280c-5 0-9.8-2.4-12.8-6.4l-33.4-44.5c-6.2-8.2-15.9-13.1-26.2-13.1c-12.9 0-24.6 7.6-29.9 19.4l-19.1 43.1c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l19.1-43.1c10.4-23.4 33.6-38.4 59.1-38.4c20.4 0 39.5 9.6 51.8 25.9L288 192h60l22.1-29.4L330.3 96.2c-4.5-7.6-2.1-17.4 5.5-22zM470.3 368L544 318.9V259.8L393.6 184.6l-80 106.6c-6 8.1-15.5 12.8-25.6 12.8H99.8L75.7 352.1c1.4-.1 2.8-.1 4.3-.1H240c18 0 34.6 6 48 16H455.8h.3 14.2zM80 384c-26.5 0-48 21.5-48 48s21.5 48 48 48H240c26.5 0 48-21.5 48-48s-21.5-48-48-48H80z"]
};
var faSnowmobile = faPersonSnowmobiling;
var faFaceHushed = {
  prefix: 'fal',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faCommentsDollar = {
  prefix: 'fal',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPickaxe = {
  prefix: 'fal',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", "M474.7 321.8c16.1-78.2-7.8-162.5-65.3-219.8C352.2 45 268.3 21.2 190.5 37.2c61.8 30 118.3 73 164.8 119.5c46.9 46.9 89.3 103.4 119.4 165.1zM138.5 49.6c-13.4-5-13.7-24.5-.5-29.8C237.7-20.6 355.6 3.2 432 79.3C508.6 155.7 532.7 274 492.2 374c-5.4 13.3-24.9 13-29.8-.5C434.7 301.2 387 233.7 332.7 179.3C278.6 125.2 210.8 76.8 138.5 49.6zM10.1 448.5L271.9 167.3c8 6.6 16.1 13.7 24.1 21.1L33.5 470.3c-1 1.1-1.5 2.5-1.5 3.9c0 3.2 2.6 5.7 5.7 5.7c1.5 0 2.8-.6 3.9-1.5L323.6 216c7.4 8 14.5 16.1 21.1 24.1L63.5 501.9c-7 6.5-16.2 10.1-25.7 10.1C16.9 512 0 495.1 0 474.3c0-9.5 3.6-18.7 10.1-25.7zM443.3 20.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faLinkSimpleSlash = {
  prefix: 'fal',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM608 256c0-88.4-71.6-160-160-160H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c70.7 0 128 57.3 128 128c0 35.5-14.4 67.6-37.7 90.8l25.3 19.9C591.1 338 608 299 608 256zM456 272c8.8 0 16-7.2 16-16s-7.2-16-16-16H403l40.5 32H456zM196.4 240H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h53l-40.5-32zm-94.7-74.8L76.5 145.3C48.9 174 32 213 32 256c0 88.4 71.6 160 160 160h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-70.7 0-128-57.3-128-128c0-35.5 14.4-67.6 37.7-90.8z"]
};
var faDemocrat = {
  prefix: 'fal',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M92.9 0C84.3 0 76 4.6 71.6 12.6c-2.4 4.3-6 11.3-9.2 18.7C59.6 37.9 56 47.5 56 56c0 16 6.9 29.6 14.8 40.1L19.5 155.5C6.9 170 0 188.6 0 207.8v5.4C0 254.5 33.5 288 74.7 288c17.5 0 34.4-6.1 47.8-17.3l13.7-11.4L160 330.6V336 464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V416H432v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V336v-8V208c0-4.9-.4-9.7-1.3-14.4c2.9 2.9 5.5 5.8 8 8.7c9.2 10.9 15.9 21.8 20.2 30.1c2.2 4.1 3.7 7.5 4.7 9.8c.5 1.1 .9 2 1.1 2.6l.2 .6 0 .1 0 0 0 0 0 0 0 0c3 8.3 12.2 12.6 20.5 9.5s12.6-12.2 9.6-20.5L624 240c15-5.5 15-5.5 15-5.5l0 0 0 0 0-.1-.1-.3-.4-1c-.3-.9-.8-2-1.5-3.5c-1.3-2.9-3.2-7.1-5.7-12c-5.1-9.8-13-22.8-24.1-35.9c-22.2-26.2-58.3-53.6-111-53.7c0 0-.1 0-.1 0H277.5c-4.3 0-8.5-1.7-11.5-4.8L225.9 81.9c3.6-7.6 6.1-16.3 6.1-25.9c0-8.5-3.6-18.1-6.4-24.7c-3.1-7.4-6.8-14.4-9.2-18.7C212 4.6 203.7 0 195.1 0c-5.8 0-11.4 2-15.8 5.8L144 35.5 108.7 5.8C104.3 2 98.7 0 92.9 0zm403 160c0 0 0 0 .1 0c.1 0 .1 0 .2 0c26.4 .1 47.8 21.5 47.8 48V320H190.2l-31-93.1c-1.7-5-5.7-8.9-10.8-10.3s-10.6-.3-14.6 3.1l-31.7 26.4c-7.7 6.4-17.4 9.9-27.4 9.9C51.1 256 32 236.9 32 213.3v-5.4c0-11.5 4.1-22.7 11.7-31.4l60.4-69.9c5.5-6.3 5.1-15.9-.8-21.8C94.2 75.6 88 65.5 88 56l0 0s0-.1 0-.3c0-.2 .1-.5 .1-.9c.1-.8 .4-1.7 .7-2.9c.7-2.4 1.7-5.2 3-8.2c1.1-2.5 2.3-5.1 3.4-7.5l37.5 31.5c3.7 3.1 8.5 4.4 13.3 3.5c.6-.1 1.1-.2 1.7-.3c3-.4 5.7-1.7 8-3.6l37-31.1c1.2 2.4 2.3 4.9 3.4 7.5c1.3 3 2.3 5.8 3 8.2c.3 1.2 .6 2.1 .7 2.9c.1 .4 .1 .7 .1 .9c0 .2 0 .3 0 .3l0 0c0 6.1-2.5 12.5-7.2 19.1c-4.4 6.3-3.8 14.9 1.6 20.4l48.7 50c9 9.3 21.4 14.5 34.4 14.5H495.9zM192 464V352H544V464c0 8.8-7.2 16-16 16H480c-8.8 0-16-7.2-16-16V400c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm80-256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V256h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V208zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V256h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V208zm96-16c-8.8 0-16 7.2-16 16v16H448c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V256h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V208c0-8.8-7.2-16-16-16z"]
};
var faFaceConfused = {
  prefix: 'fal',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM171.1 395.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16H341c-61.8 0-121.7 21-169.9 59.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPinball = {
  prefix: 'fal',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM120 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM383.9 448L76.2 348.9l0 0c-8.1-2.6-15.2-6.7-21.3-11.8c-27.1-22.7-30.6-63.2-7.9-90.2s63-30.6 90.1-7.9l0 0L383 447.2l.5 .4 .4 .3 0 .1 0 0zm19.8-25.2l-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1c14.9 4.8 30.7-1.8 37.9-15c7.4-12.8 4.2-30.8-8.4-40.6z"]
};
var faZ = {
  prefix: 'fal',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M0 48c0-8.8 7.2-16 16-16H368c6.2 0 11.9 3.6 14.5 9.3s1.7 12.3-2.3 17.1L50.5 448H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L333.5 64H16C7.2 64 0 56.8 0 48z"]
};
var faPersonSkiing = {
  prefix: 'fal',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", "M424 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 424 0zM1.7 280.8c4-7.9 13.6-11.1 21.5-7.1L236.4 380.9 306.4 297l-95-95c-8-8-12.5-17.9-13.7-28.1l59 28.1L329 274.4c11.7 11.7 12.6 30.4 2 43.1l-65.1 78.2 153.2 77c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 302.3c-7.9-4-11.1-13.6-7.1-21.5zM118.9 65.6L137 74.2l8.7-17.3c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5L165.9 88l67.5 32.2 66.8-35.2c27.6-14.5 61.6 .8 69 31.1l18.9 77.6 66.5 31.8 .2 .1c4.9 2.3 8 6.8 8.9 11.8c.5 3.1 .1 6.5-1.3 9.6c0 0 0 0 0 0c-3.8 8-13.4 11.3-21.3 7.5l-.2-.1L151.6 116.6l-9.3 18.6c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6zm150.6 71.7l81.4 38.8-12.8-52.4c-2.5-10.1-13.8-15.2-23-10.4l-45.6 24z"]
};
var faSkiing = faPersonSkiing;
var faDeer = {
  prefix: 'fal',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 30.9 25.1 56 56 56h8 8 23.2l-40 26.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l13.8-9.2-10 35.9H120 104 99.2c-50.7 0-92.7 39.4-95.8 90L0 319c-.6 8.8 6.2 16.4 15 17s16.4-6.2 17-15l.6-9.9c.7 .8 1.4 1.5 2.2 2.3l3.9 3.9c6 6 9.4 14.1 9.4 22.6v4.3c0 3.4-.6 6.9-1.6 10.1l-8.5 25.4c-4.4 13.1-4.4 27.3 0 40.5l21.5 64.4C64.8 501 80.1 512 97.3 512h29.4c27.3 0 46.6-26.7 37.9-52.6l-11.6-34.8c-3.6-10.7 .5-22.4 9.8-28.6c15.2-10.1 24.4-26.8 25.3-44.6c21.3 10.9 45 16.6 69 16.6H272V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V311c0-3.1 .5-6.2 1.4-9.2L403.9 240h52.5c30.7 0 55.6-24.9 55.6-55.6c0-14.7-5.9-28.9-16.3-39.3L440.8 90.2C459.3 81.1 472 62 472 40V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24H385.4 346.6c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zM385.4 96c10.2 0 20 4.1 27.2 11.3l60.4 60.4c4.4 4.4 6.9 10.4 6.9 16.7c0 13-10.6 23.6-23.6 23.6H392c-7.1 0-13.3 4.6-15.3 11.4l-22 73.3c-1.8 6-2.7 12.2-2.7 18.4V472c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V352c0-8.8-7.2-16-16-16H257.2c-23.7 0-46.9-7-66.6-20.2l-13.7-9.2c-5.3-3.5-12.2-3.6-17.6-.1s-8.1 9.8-7.1 16.1l3.7 21.9c1.6 9.7-2.6 19.4-10.8 24.8c-21.4 14.2-30.5 41-22.4 65.3l11.6 34.8c1.7 5.2-2.1 10.5-7.6 10.5H97.3c-3.4 0-6.5-2.2-7.6-5.5L68.2 410.1c-2.2-6.6-2.2-13.7 0-20.2l8.5-25.4c2.2-6.5 3.3-13.4 3.3-20.2v-4.3c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-6-6-9.4-14.1-9.4-22.6V264c0-30.9 25.1-56 56-56h16H312.9c7.2 0 13.5-4.8 15.4-11.7l20-72.1C353 107.5 368.1 96 385.4 96zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faInputPipe = {
  prefix: 'fal',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm128 48V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faRoadLock = {
  prefix: 'fal',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", "M217.6 32c-26.9 0-50.9 16.8-60.1 42L40.5 394c-15.3 41.8 15.7 86 60.1 86H384V448H336V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H100.6c-22.2 0-37.7-22.1-30.1-43L187.5 85c4.6-12.6 16.6-21 30.1-21H304v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64h86.4c13.4 0 25.4 8.4 30.1 21l30.8 84.3c9.7-4.2 20.1-7.1 31-8.4L482.5 74c-9.2-25.2-33.2-42-60.1-42H217.6zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm192 16c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faA = {
  prefix: 'fal',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M206.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8l-176 416c-3.4 8.1 .4 17.5 8.5 21s17.5-.4 21-8.5L67.2 384H316.8l36.5 86.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21l-176-416zM303.2 352H80.8L192 89.1 303.2 352z"]
};
var faBookmarkSlash = {
  prefix: 'fal',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", "M512 48c0-26.5-21.5-48-48-48H176c-18.9 0-35.2 10.9-43.1 26.8L160 48.1V48c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V300.8L512 326V48zM160 471.4V211.2L128 186V489.9c0 12.2 9.9 22.1 22.1 22.1c4.4 0 8.6-1.3 12.3-3.7L320 403.2 477.6 508.3c3.6 2.4 7.9 3.7 12.3 3.7c12.2 0 22.1-9.9 22.1-22.1v-.7l-32-25.3v7.6L328.9 370.7c-5.4-3.6-12.4-3.6-17.7 0L160 471.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTemperatureArrowDown = {
  prefix: 'fal',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zm116.7 43.3l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L448 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faTemperatureDown = faTemperatureArrowDown;
var faMace = {
  prefix: 'fal',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", "M278.3 95.8L288 66.6l9.7 29.2c3.3 10 11.4 17.7 21.5 20.6c36.8 10.6 65.8 39.7 76.4 76.4c2.9 10.1 10.6 18.1 20.6 21.5l29.2 9.7-29.2 9.7c-10 3.3-17.7 11.4-20.6 21.5c-10.6 36.8-39.7 65.8-76.4 76.4c-10.1 2.9-18.1 10.6-21.5 20.6L288 381.4l-9.7-29.2c-3.3-10-11.4-17.7-21.5-20.6c-36.8-10.6-65.8-39.7-76.4-76.4c-2.9-10.1-10.6-18.1-20.6-21.5L130.6 224l29.2-9.7c10-3.3 17.7-11.4 20.6-21.5c10.6-36.8 39.7-65.8 76.4-76.4c10.1-2.9 18.1-10.6 21.5-20.6zM149.7 183.9L74.9 208.8C68.4 211 64 217.1 64 224s4.4 13 10.9 15.2l74.7 24.9c5.3 18.4 14.2 35.2 25.8 49.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L198.1 336.5c14.6 11.6 31.4 20.5 49.8 25.8l24.9 74.7c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l24.9-74.7c47.3-13.7 84.6-51 98.3-98.3l74.7-24.9c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-74.7-24.9c-13.7-47.3-51-84.6-98.3-98.3L303.2 10.9C301 4.4 294.9 0 288 0s-13 4.4-15.2 10.9L247.9 85.7c-47.3 13.7-84.6 51-98.3 98.3zM288 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
};
var faFeatherPointed = {
  prefix: 'fal',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M102.2 348.1C89.9 302.4 89.8 224.5 160 154.3c40.6-40.6 98.9-69.8 159.1-89.6C379 44.9 438.2 35.3 477.9 32c0 0 .2 0 .4 .1c.3 .1 .6 .3 1 .7s.6 .7 .7 1c.1 .2 .1 .4 .1 .4c-3.3 39.7-12.9 98.9-32.7 158.7c-3.4 10.5-7.2 20.9-11.2 31.1H310.6l37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L116.1 373.3c-7-8.6-11.6-16.9-13.9-25.2zM116 418.6c11.7 9.9 24.7 18 39.6 22c54.1 14.6 144.7 14 224.8-66.1C471.5 283.5 505 120.5 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c4 14.8 12.1 27.8 22 39.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L116 418.6zm22.7-22.7L182.6 352H357.7c-70.2 70.2-148.2 70.1-193.8 57.8c-8.3-2.2-16.6-6.9-25.2-13.9zM385 320H214.6l64-64H422.4c-10.8 22.9-23.2 44.6-37.4 64z"]
};
var faFeatherAlt = faFeatherPointed;
var faSausage = {
  prefix: 'fal',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M400 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM32 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V400zM480 160c0 176.7-143.3 320-320 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c106 0 192-86 192-192c0-35.3 28.7-64 64-64s64 28.7 64 64zm32 0c0-53-43-96-96-96s-96 43-96 96c0 88.4-71.6 160-160 160c-53 0-96 43-96 96s43 96 96 96c194.4 0 352-157.6 352-352zm-112 0c-8.8 0-16 7.2-16 16c0 114.9-93.1 208-208 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240c0-8.8-7.2-16-16-16z"]
};
var faTrashCanClock = {
  prefix: 'fal',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v96.7c-11 1-21.7 3-32 5.9V96H64V432c0 26.5 21.5 48 48 48H296.2c10 12.1 21.7 22.9 34.6 32H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM336 176v44.5c-11.7 7.6-22.4 16.6-32 26.7V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm-192 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faP = {
  prefix: 'fal',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M48 64H176c61.9 0 112 50.1 112 112s-50.1 112-112 112H32V80c0-8.8 7.2-16 16-16zM32 320H176c79.5 0 144-64.5 144-144s-64.5-144-144-144H48C21.5 32 0 53.5 0 80V304 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"]
};
var faBroomWide = {
  prefix: 'fal',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", "M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144-18.6-18.6c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4L392.6 266.2c13.9-25 9.5-56.1-10.7-76.3l-18.6-18.6 144-144zM299.5 152.8l59.7 59.7c10.1 10.1 12.3 25.7 5.3 38.2l-21.2 38.1L223.2 168.6l38.1-21.2c12.5-6.9 28.1-4.8 38.2 5.3zm-105.4 32L327.2 317.9l-90 162.1L113.9 356.7l41.4-41.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L91.3 334.1 32.1 274.8l162.1-90z"]
};
var faSnowflake = {
  prefix: 'fal',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L171.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 134.6v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3S72 100.2 74.3 108.7l13.4 50.1L24.2 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L21.6 200C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4L8.2 362.1C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7L74.3 403.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L208 283.7v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 422.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V422.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4V283.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7L426.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L240 228.3V134.6l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4V16z"]
};
var faStomach = {
  prefix: 'fal',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 61.9 50.1 112 112 112h20c-2.6 10.2-4 21-4 32v48c0 44.2-35.8 80-80 80H112C57.5 352 12 391 2 442.6c-1.3 6.2-2 12.6-2 19.1V464v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464c0-5.2 .5-10.2 1.4-15.1c3.8-16.7 14.9-31.2 30.6-39c24.8-12.4 56.5-5.7 78.4 15.2C181.3 462.3 246.5 512 320 512c106 0 192-86 192-192V224c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64H240c-44.2 0-80-35.8-80-80V16zm4.5 386c-7.4-7.1-15.9-13.2-25-18H176c42.8 0 80-24 98.9-59.4c25.6-11.2 43.6-12.6 57.6-10.2c15.3 2.6 27.6 9.7 42.4 18.4l.5 .3c14.1 8.3 30.9 18.1 52.1 20.7c15.2 1.8 31.7-.2 50.4-7.3C465.2 422.2 399.4 480 320 480c-60.3 0-117.5-41.7-155.5-78zM480 310.5c-21.6 11-36.9 12.9-48.7 11.5c-13.9-1.7-25.4-8.1-40.2-16.8l-1.2-.7c-13.9-8.2-30.7-18-52.1-21.6c-15.1-2.5-31.7-1.8-50.7 3.4c.6-4.7 .9-9.4 .9-14.3V224c0-53 43-96 96-96s96 43 96 96v86.5z"]
};
var faNewspaper = {
  prefix: 'fal',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M160 64c-17.7 0-32 14.3-32 32V416c0 11.7-3.1 22.6-8.6 32H432c26.5 0 48-21.5 48-48V96c0-17.7-14.3-32-32-32H160zM64 480c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64v32c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V400c0 44.2-35.8 80-80 80H64zM384 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM160 304c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm32-144H320V128H192v96zM160 120c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24V232c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V120z"]
};
var faRectangleAd = {
  prefix: 'fal',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm214.6 73.4l72 160c3.6 8.1 0 17.5-8 21.2s-17.5 0-21.2-8L247.3 320H152.7l-10.2 22.6c-3.6 8.1-13.1 11.7-21.2 8s-11.7-13.1-8-21.2l72-160c2.6-5.7 8.3-9.4 14.6-9.4s12 3.7 14.6 9.4zM200 215l-32.9 73h65.7L200 215zm176 25a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm40-19.9V176c0-8.8 7.2-16 16-16s16 7.2 16 16V280v56c0 8.8-7.2 16-16 16c-7.6 0-14-5.3-15.6-12.4C404.9 347.4 391 352 376 352c-39.8 0-72-32.2-72-72s32.2-72 72-72c14.8 0 28.6 4.5 40 12.1z"]
};
var faAd = faRectangleAd;
var faGuitarElectric = {
  prefix: 'fal',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M391.1 67.8l52.6-35L473.3 55c7.6 5.7 8.3 16.7 1.7 23.4c-6.1 6.1-15.9 6.1-22 0l-9.7-9.7c-6.2-6.2-16.4-6.2-22.6 0L384 105.4V81.1c0-5.3 2.7-10.3 7.1-13.3zM352 136c0 .4 0 .9 .1 1.3l-68.2 68.2c-8-10.2-13.4-20.5-12.1-27.7c1.6-8.9 5.8-16.9 9.9-24.7c8.9-16.7 17.2-32.4-3.3-53.1c-15.9-16.1-41.8-16.1-57.7 0l-29.9 30.2c-9.4 9.5-15 21.1-20.6 32.8l0 0c-5.6 11.6-11.1 23.1-20.3 32.3c-16.5 16.7-38.1 23.8-59.8 30.8c-21.8 7.1-43.7 14.3-60.6 31.4c-39.3 39.7-39.3 104 0 143.7l79.9 80.8c39.4 39.9 103.5 39.9 142.9 0c17-17.2 24-39.3 31-61.3c6.9-21.9 13.8-43.7 30.5-60.5c8.7-8.8 19.5-13.8 30.3-18.8c10.9-5.1 21.8-10.1 30.6-19l21.6-21.8c15.8-15.9 15.8-41.7 0-57.6c-16.5-16.7-29.8-12.3-44-7.7c-7.2 2.4-14.7 4.8-22.9 4.6c-5.5-.2-14-4.9-22.8-11.9L432 102.6c18.7 17 47.5 16.5 65.6-1.6c20.5-20.5 18-54.3-5.1-71.6L461 5.7C456 2 450 0 443.8 0c-5.6 0-11.2 1.7-15.9 4.8L373.4 41.2C360 50.1 352 65.1 352 81.1V136zM238.6 172.1c-3 17.4 4.7 32.7 9.4 40.7c5.7 9.7 13.4 18.9 21 26.7c7.7 7.9 16.4 15.4 25.1 21.2c4.3 2.9 9.1 5.8 14.2 8c4.6 2.1 11.7 4.7 20 4.9c11.4 .3 21.1-2.1 27.9-4.1c2.3-.7 4.9-1.5 6.9-2.2l0 0 0 0 1.8-.6c2.4-.8 4-1.2 5.3-1.5l.3-.1c.5 .4 1.1 .9 1.8 1.7c2.8 2.8 2.8 7.5 0 10.3l-21.6 21.8c-3.8 3.9-9.1 6.7-20.8 12.1l-1.4 .7c-10.1 4.7-25.8 11.9-38.8 25c-22.4 22.7-31.5 51.3-37.9 71.8l-.8 2.4c-7.3 23.1-12.4 37.1-22.7 47.6c-26.3 26.6-68.8 26.6-95.1 0L53.4 377.7c-26.3-26.6-26.3-69.8 0-96.5c10.2-10.4 24-15.5 46.9-23l2.4-.8c20.3-6.6 48.7-15.8 71.1-38.4c13.2-13.3 20.9-29.3 26-40.1l.7-1.5c6-12.4 9.4-18.8 14.1-23.6l29.9-30.2c2.8-2.8 7.2-2.8 9.9 0c1.4 1.4 2.2 2.4 2.7 3.1c-.1 .2-.2 .5-.3 .7c-1 2.6-2.2 4.7-4 8.2l0 0 0 0c-1 1.9-2.2 4.1-3.7 7.1c-3.6 6.9-8.4 17.1-10.5 29.2l0 0zm130.9 92.3a.1 .1 0 1 0 0 .2 .1 .1 0 1 0 0-.2zM257.8 128a.1 .1 0 1 0 -.2 0 .1 .1 0 1 0 .2 0zM148.7 276.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm-48 48c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faArrowTurnDownRight = {
  prefix: 'fal',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V224c0 44.2 35.8 80 80 80H457.4L356.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 272H80c-26.5 0-48-21.5-48-48V48z"]
};
var faMoonCloud = {
  prefix: 'fal',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M446.6 66.8C359 82 291.8 156.8 288.1 248c-9.9-4.1-20.5-6.8-31.6-7.7C264.5 124 361.2 32 479.5 32c6.4 0 12.7 .3 19 .8c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3c0 97.2 78.6 176 175.5 176c10.3 0 20.3-.9 30.1-2.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C595 455.8 540 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c7.5-7.8 13.8-16.8 18.6-26.7c34.8 36.2 83.7 58.7 137.8 58.7c34.2 0 66.3-9 94.1-24.7c-106.4-9-189.9-98.4-189.9-207.3c0-58.5 24.1-111.4 62.9-149.2zM144 224c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H64c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64zm0 32c-26.5 0-48 21.5-48 48c0 .7 0 1.4 0 2.1c.2 5.3-2.2 10.4-6.5 13.5s-9.8 4-14.9 2.2c-3.3-1.2-6.9-1.8-10.7-1.8c-17.7 0-32 14.3-32 32s14.3 32 32 32H248c22.1 0 40-17.9 40-40s-17.9-40-40-40c-11.2 0-21.3 4.6-28.6 12c-4.6 4.7-11.5 6.1-17.5 3.6s-9.9-8.4-9.9-14.9l0-.8c0-26.5-21.5-48-48-48z"]
};
var faBreadSliceButter = {
  prefix: 'fal',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M96 256V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V256c0-17.7 14.3-32 32-32s32-14.3 32-32c0-44.3-32.4-76.2-84.6-98.6C344.1 71.4 284.5 64 256 64s-88.1 7.4-139.4 29.4C64.4 115.8 32 147.7 32 192c0 17.7 14.3 32 32 32s32 14.3 32 32zm352 0v32V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V288 256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zM193.9 276.7c-6.2 6.2-6.2 16.4 0 22.6l50.7 50.7c6.2 6.2 16.4 6.2 22.6 0l50.7-50.7c6.2-6.2 6.2-16.4 0-22.6l-50.7-50.7c-6.2-6.2-16.4-6.2-22.6 0l-50.7 50.7zm96-73.4l50.7 50.7c18.7 18.7 18.7 49.1 0 67.9l-50.7 50.7c-18.7 18.7-49.1 18.7-67.9 0l-50.7-50.7c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7c18.7-18.7 49.1-18.7 67.9 0z"]
};
var faCircleArrowRight = {
  prefix: 'fal',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM283.3 363.3l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 240 144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l185.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faArrowCircleRight = faCircleArrowRight;
var faUserGroupCrown = {
  prefix: 'fal',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", "M224 0c5.2 0 10.3 1.5 14.7 4.4l32.5 21.6c5.4 3.6 12.4 3.6 17.8 0L324 2.7c2.6-1.8 5.7-2.7 8.9-2.7H336c8.8 0 16 7.2 16 16V128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128 16c0-8.8 7.2-16 16-16h3.2c3.2 0 6.2 .9 8.9 2.7l35.1 23.4c5.4 3.6 12.4 3.6 17.8 0L209.3 4.4C213.7 1.5 218.8 0 224 0zm96 43.8l-13.4 8.9c-16.1 10.7-37.1 10.7-53.3 0L224 33.1 194.6 52.7c-16.1 10.7-37.1 10.7-53.3 0L128 43.8V112H320V43.8zM224 240c53 0 96-43 96-96H128c0 53 43 96 96 96zM32 472v8H416v-8c0-75.1-60.9-136-136-136H168C92.9 336 32 396.9 32 472zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8zM432 256c-27.7 0-53-10.1-72.6-26.7c1.9-2.9 3.6-6 5.3-9c3.6-6.7 6.8-13.7 9.5-21C388.8 214.5 409.3 224 432 224c44.2 0 80-35.8 80-80s-35.8-80-80-80c-18 0-34.6 6-48 16V42.8C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32H608c-.7-70.8-58.3-128-129.3-128H440c-8.8-11.7-18.8-22.4-29.8-31.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z"]
};
var faUsersCrown = faUserGroupCrown;
var faCircleI = {
  prefix: 'fal',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V352H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 176z"]
};
var faToiletPaperCheck = {
  prefix: 'fal',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", "M16 479c.2-5.3 1.7-10.6 4.5-15.4l0-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192C64 86 107 0 160 0H464h32c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2c2.1-14.2 4.1-29.6 5.7-46c14.2 25.6 33 41.2 53.6 41.2c44.2 0 80-71.6 80-160s-35.8-160-80-160s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7c-.3 2.5-.5 4.9-.8 7.4c-9 82.3-25.6 133.1-36.3 158.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2c-5.7 49.5-17.3 100.7-41.6 144.8c-.2 .3-.4 .6-.5 .9l0 0H317.9c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4c5.7-11.3 12.8-22.6 21.5-32.6H160zM496 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16zM307.3 187.3l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 225.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faFilterCircleXmark = {
  prefix: 'fal',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", "M0 39.5C0 17.7 17.7 0 39.5 0H472.5C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5H39.5c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 269.8c2.4 2.9 3.7 6.5 3.7 10.2v88.2l34 26.4c2.7 18.1 8.3 35.3 16.1 51.2c-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3V285.8L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faLocust = {
  prefix: 'fal',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c106.5 0 194.3 80 206.5 183.2C525.7 232.7 503.9 224 480 224H429.9L382 136.3c-2.6-4.8-7.5-7.9-13-8.3s-10.7 2.1-14 6.5l-45.3 61.4-40.5-60.8c-2.9-4.3-7.7-7-12.9-7.1s-10.1 2.2-13.2 6.4L176 224H102.1C63.4 224 32 255.4 32 294.1c0 27.5 16 52.4 41 63.8l1.9 .9L3.2 454.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l75.9-101.2 51 23.3c4.7 2.2 9.5 4.2 14.4 6l-38.9 52.8c-5.2 7.1-3.7 17.1 3.4 22.4s17.1 3.7 22.4-3.4l45.9-62.3c15.1 3.2 30.5 4.8 46 4.8H281l-22.9 40.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l32-55.9H454.1l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-20.7-41.3c48.5-4.8 86.4-45.8 86.4-95.5l0-.3V272C576 139.5 468.5 32 336 32H304zM480 256c35.3 0 63.9 28.5 64 63.7v.3l0 .1c-.1 35.3-28.7 63.9-64 63.9H464.3c-.1 0-.3 0-.4 0c-.1 0-.2 0-.3 0H248.8c-27.5 0-54.8-5.9-79.8-17.4l-44.6-20.4L192 256H319.8h.5H480zm-328 0L94.5 332.6l-8.3-3.8C72.7 322.6 64 309.1 64 294.1c0-21.1 17.1-38.1 38.1-38.1H152zm137.2-32H216l39.2-52.3 34.4 51.6-.5 .7zm104.2 0H328.9L366 173.7 393.4 224zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSort = {
  prefix: 'fal',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", "M34.2 179.7L154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1H280.9c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3L132.4 469.1c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9L307.7 355.6c7.8-7.4 12.3-17.7 12.3-28.5c0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"]
};
var faUnsorted = faSort;
var faListOl = {
  prefix: 'fal',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M32 48c0 8.8 7.2 16 16 16H64V192H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM58.7 323.9c11.1-11.1 29.2-10.5 39.6 1.3c9.2 10.5 8.9 26.2-.6 36.3L12.3 453.1c-4.3 4.7-5.5 11.5-3 17.3s8.3 9.6 14.7 9.6H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.8l60.3-64.6c20.7-22.2 21.2-56.4 1.3-79.3c-22.5-25.7-62.1-27.1-86.3-2.9L20.7 316.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l15.4-15.4z"]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faChartWaterfall = {
  prefix: 'fal',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 224c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm112-80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-80c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM448 80V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSparkle = {
  prefix: 'fal',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", "M224 32c6.2 0 11.9 3.6 14.5 9.3l63.2 136.9 136.9 63.2c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5L301.8 333.8 238.5 470.7c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3L146.2 333.8 9.3 270.5C3.6 267.9 0 262.2 0 256s3.6-11.9 9.3-14.5l136.9-63.2L209.5 41.3c2.6-5.7 8.3-9.3 14.5-9.3zm0 54.2L172.8 197c-1.6 3.5-4.4 6.2-7.8 7.8L54.2 256 165 307.2c3.5 1.6 6.2 4.4 7.8 7.8L224 425.8 275.2 315c1.6-3.5 4.4-6.2 7.8-7.8L393.8 256 283 204.8c-3.5-1.6-6.2-4.4-7.8-7.8L224 86.2z"]
};
var faFaceParty = {
  prefix: 'fal',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M96 256C96 132.3 196.3 32 320 32c91.8 0 170.8 55.3 205.4 134.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C515.2 63.2 425 0 320 0C263.2 0 210.7 18.5 168.2 49.9L21.1 .8C15.2-1.1 8.7 .5 4.4 4.9S-1.2 16 1.1 21.7L70 200.9c-3.9 17.8-6 36.2-6 55.1c0 141.4 114.6 256 256 256c75.8 0 144-33 190.8-85.3c5.9-6.6 5.3-16.7-1.3-22.6c-3-2.7-6.8-4.1-10.6-4.1h-.1c-4.4 0-8.7 1.8-11.9 5.3c-41 45.9-100.6 74.7-167 74.7C196.3 480 96 379.7 96 256zM139.8 74.1c-22.6 22.4-41.1 49-54.1 78.5L73.9 121.9c.5-.7 1-1.4 1.4-2.1c10.9-19.6 24.1-37.7 39.3-54.1l25.2 8.4zM81.6 54.7c-8 9.4-15.4 19.3-22.2 29.6L43.1 41.9 81.6 54.7zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm160 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-53.8 69.5c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-10.9 5.4-25.5 9.3-38.8 11.2c-.9 .1-1.8 .3-2.7 .6c-1.7 .6-3.2 1.6-4.4 2.8s-2.2 2.7-2.8 4.4c-.5 1.3-.7 2.7-.7 4.1s.2 2.8 .7 4.1c.6 1.7 1.6 3.2 2.8 4.4s2.7 2.2 4.4 2.8c.9 .3 1.7 .5 2.7 .6c13.3 1.9 27.9 5.8 38.8 11.2c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-11 5.4-25.7 9.3-39.1 11.2c-6.6 .9-11.1 7-10.2 13.6s7 11.1 13.6 10.2c15.1-2.1 32.4-6.6 46.3-13.4c6.9-3.4 13.6-7.7 18.7-13c5.2-5.4 9.3-12.6 9.3-21.4c0-8-3.5-14.8-8-20H592c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H560c-26.5 0-48 21.5-48 48s21.5 48 48 48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H412c4.5-5.2 8-12 8-20c0-8.8-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13c-13.9-6.8-31.2-11.3-46.3-13.4c-6.6-.9-12.6 3.6-13.6 10.2s3.7 12.6 10.2 13.6c13.4 1.9 28.1 5.8 39.1 11.2z"]
};
var faKidneys = {
  prefix: 'fal',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M115.7 352c-33.4 0-52.1-14.3-64.3-35.8C37.8 292.5 32 258.9 32 224c0-39 12.1-89.3 35.6-129c23.5-39.6 54.7-63 92.1-63c39.7 0 77.1 22.4 85.8 52.9c6 21.1-2.7 49.4-25.5 75.1c-28.7 32.4-24.6 71.3-22 95.6c.2 1.6 .3 3.2 .5 4.7c4.9 49.1-33.6 91.6-82.7 91.6zm0 32c68.1 0 121.3-58.9 114.6-126.8l-.3-2.8c-.6-6.1-1.2-12.2-1.6-18.3l18.8 9.4c5.4 2.7 8.8 8.3 8.8 14.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V259.8c0-18.2-10.3-34.8-26.5-42.9L231.8 202c2.4-7.2 6.2-14.1 12-20.7c26.6-30 42.6-69.3 32.4-105.1C262.2 26.9 207.7 0 159.7 0C53.7 0 0 135.2 0 224c0 74.9 24.3 160 115.7 160zM394.2 86.1c.1-.4 .3-.8 .4-1.2C403.2 54.4 440.6 32 480.3 32c37.4 0 68.5 23.4 92.1 63C595.9 134.7 608 185 608 224c0 34.9-5.8 68.5-19.4 92.2c-12.2 21.4-31 35.8-64.3 35.8c-49.1 0-87.6-42.5-82.7-91.6c.1-1.5 .3-3 .5-4.7l0 0 0 0c2.6-24.3 6.7-63.2-22-95.6c-23.7-26.7-32.4-54.2-25.9-73.9zm-30.4-10c-11.8 35.8 5.8 75.2 32.4 105.1c5.8 6.6 9.6 13.5 12 20.7l-29.7 14.8C362.3 225 352 241.6 352 259.8V496c0 8.8 7.2 16 16 16s16-7.2 16-16V259.8c0-6.1 3.4-11.6 8.8-14.3l18.8-9.4c-.3 6-.9 12.1-1.6 18.3l-.3 2.8C403 325.1 456.2 384 524.3 384C615.7 384 640 298.9 640 224C640 135.2 586.3 0 480.3 0c-48 0-102.5 26.9-116.5 76.2z"]
};
var faWifiExclamation = {
  prefix: 'fal',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", "M336 48V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16zM4.7 161.7C75.4 91.7 169.4 45 274 34.3c-1.3 4.3-2 8.9-2 13.7V66.7C177 77.7 91.8 120.6 27.3 184.4c-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4 .1-22.6zM116.7 276c41.3-41.2 95.2-69.9 155.3-80v32.5c-51.3 9.7-97.2 34.8-132.7 70.2c-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM368 196c60.1 10.1 114 38.8 155.3 80c6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-35.5-35.4-81.4-60.5-132.7-70.2V196zm0-148c0-4.7-.7-9.3-2-13.7C470.6 45 564.6 91.7 635.3 161.7c6.3 6.2 6.3 16.3 .1 22.6s-16.3 6.3-22.6 .1C548.2 120.6 463 77.7 368 66.7V48zM320 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faChartNetwork = {
  prefix: 'fal',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c4.5 0 8.9-.5 13.1-1.3l38.1 83.2c-26.6 17.2-45.4 45.4-50.1 78.1H126c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h99.2c7.8 54.3 54.4 96 110.9 96c35 0 66.3-16.1 86.8-41.2l91.8 55.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4l-91.8-55.1c5.6-13.3 8.7-28 8.7-43.3c0-18.7-4.6-36.3-12.7-51.8l101.8-73.3c10.8 8.2 24.2 13.1 38.8 13.1c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 9.1 1.9 17.8 5.4 25.7L416.6 226.2c-20.4-21.1-49-34.2-80.6-34.2c-11 0-21.6 1.6-31.7 4.5l-38.5-84.1C279.4 100.7 288 83.4 288 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM576 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM544 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-48a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faPersonDressBurst = {
  prefix: 'fal',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H528 432 393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6L222.6 87.2 190.5 17.3zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z"]
};
var faDiceD4 = {
  prefix: 'fal',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", "M240.1 56.5L35.4 310.6 240.1 465.9V56.5zm32 409.2L476.6 310.6 272.1 56.7V465.8zM256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0z"]
};
var faMoneyCheckDollar = {
  prefix: 'fal',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM272 288H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-80c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm-96-56v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V360c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V152c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faVectorSquare = {
  prefix: 'fal',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", "M408 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM360 32c-22.1 0-40 17.9-40 40v8H128V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h8l0 192H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40v-8H320v8c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40h-8V160h8c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360zM80 352l0-192h8c22.1 0 40-17.9 40-40v-8H320v8c0 22.1 17.9 40 40 40h8V352h-8c-22.1 0-40 17.9-40 40v8H128v-8c0-22.1-17.9-40-40-40H80zM40 384H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm320 0h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM40 64H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8z"]
};
var faBreadSlice = {
  prefix: 'fal',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M64 224c-17.7 0-32-14.3-32-32c0-44.3 32.4-76.2 84.6-98.6C167.9 71.4 227.5 64 256 64s88.1 7.4 139.4 29.4C447.6 115.8 480 147.7 480 192c0 17.7-14.3 32-32 32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V256c0-17.7-14.3-32-32-32zm384 64V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v32V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V288z"]
};
var faLanguage = {
  prefix: 'fal',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M304 96V416H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H304zm32 0H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H336V96zm304 32c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128zM174.9 170.1C172.4 164 166.5 160 160 160s-12.4 4-14.9 10.1l-64 160c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l8.8-21.9h80.7l8.8 21.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-64-160zm-14.9 49L187.6 288H132.4L160 219.1zM496 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 41.2l-.2 .6c-8.2 22.6-21.4 42.9-38.2 59.4l-.8-.8-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.9 20.9c-5 3.2-10.1 6.2-15.5 8.8l-17.3 8.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l17.3-8.6c9.1-4.6 17.8-9.8 26-15.7c5.9 4.4 12.1 8.6 18.4 12.4l18.9 11.3c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-18.9-11.3c-3.4-2-6.7-4.1-9.9-6.4c19.1-19.4 34.1-42.9 43.6-69l4.2-11.6H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H544 496V176z"]
};
var faWheatAwnSlash = {
  prefix: 'fal',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm235.7 288l-37 37c1.9-31.2-7.5-62.9-28.2-88.5l-46.7-36.9c-2.8 .7-5.4 2.1-7.6 4.2l-33.9 33.9c-37.5 37.5-37.5 98.3 0 135.8L142.2 411l0 0L68.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.4-98.5-37.2L287 311.4l-25.3-20zM289.2 60.3C270.5 79 261.2 103.5 261.1 128l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.6 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4L555 145.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L478 176.9c-16.1-5.5-33-7.8-49.8-6.7L555 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L405.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L383.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L345.8 26.4c-6.2-6.2-16.4-6.2-22.6 0L289.2 60.3zM130.9 263.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zm181 181c-25 25-65.5 25-90.5 0L187.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z"]
};
var faFaceKissWinkHeart = {
  prefix: 'fal',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", "M325.2 469.1C303.4 476.2 280.2 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 25.9-4.4 50.8-12.5 73.9c10.9 1.2 21.2 4.5 30.6 9.5c9-26.2 13.9-54.2 13.9-83.4C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c28.6 0 56.1-4.7 81.8-13.4c-4.9-6.5-8.7-14.1-10.8-22.6l-1.8-7zM222.3 291.9c13.4 1.9 28.1 5.8 39.1 11.2c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-10.9 5.4-25.5 9.3-38.8 11.2c-.9 .1-1.8 .3-2.7 .6c-1.7 .6-3.2 1.6-4.4 2.8s-2.2 2.7-2.8 4.4c-.5 1.3-.7 2.7-.7 4.1s.2 2.8 .7 4.1c.6 1.7 1.6 3.2 2.8 4.4s2.7 2.2 4.4 2.8c.9 .3 1.7 .5 2.7 .6c13.3 1.9 27.9 5.8 38.8 11.2c5.5 2.7 9.5 5.5 11.9 8c2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8c-11 5.4-25.7 9.3-39.1 11.2c-6.6 .9-11.1 7-10.2 13.6s7 11.1 13.6 10.2c15.1-2.1 32.4-6.6 46.3-13.4c6.9-3.4 13.6-7.7 18.7-13c5.2-5.4 9.3-12.6 9.3-21.4s-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13c-1.1-.5-2.1-1-3.3-1.5c1.1-.5 2.2-1 3.3-1.5c6.9-3.4 13.6-7.7 18.7-13c5.2-5.4 9.3-12.6 9.3-21.4s-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13c-13.9-6.8-31.2-11.3-46.3-13.4c-6.6-.9-12.6 3.6-13.6 10.2s3.6 12.6 10.2 13.6zm-46-59.9a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm194.8 1.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm70.1 127.5c-7.4-29-36.5-47.3-65.8-39.2c-28.9 8.1-45.1 38.6-37.7 67.4L358 468.1c4.5 17.4 22.3 27.7 39.6 22.9l74.9-21c28.9-8.1 45.1-38.6 37.7-67.4c-7.4-29-36.5-47.3-65.8-39.2l-2.4 .7-.8-3zm-57.1-8.3c10.8-3 22.9 3.5 26.1 16.3l4.8 18.9c1.1 4.2 3.8 7.7 7.5 9.9s8.2 2.7 12.3 1.5l18.1-5.1c10.8-3 22.9 3.5 26.1 16.3c3.3 13-4.2 25.5-15.3 28.6l-74.9 21-20.2-78.8c-3.3-13 4.2-25.5 15.3-28.6z"]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faDagger = {
  prefix: 'fal',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V128H144 112 80 48c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48V160h16 32 48 48 32 16v16c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48H304 272 240 208V16zM48 160H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16zm272 0h16c8.8 0 16 7.2 16 16s-7.2 16-16 16s-16-7.2-16-16V160zM240 397.9c0 4.9-1.5 9.7-4.3 13.8L192 474.1l-43.7-62.4c-2.8-4-4.3-8.8-4.3-13.8V192H112V397.9c0 11.5 3.5 22.7 10.1 32.1l50.2 71.7c4.5 6.4 11.8 10.2 19.7 10.2s15.2-3.8 19.7-10.2L261.9 430c6.6-9.4 10.1-20.6 10.1-32.1V192H240V397.9z"]
};
var faPodium = {
  prefix: 'fal',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M288 32H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zM178.7 64H168c-26.5 0-48 21.5-48 48v48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H88V112c0-44.2 35.8-80 80-80h10.7C185.3 13.4 203.1 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-20.9 0-38.7-13.4-45.3-32zM73.5 455.2L47.3 224H79.5l25.9 227.6c1.8 16.2 15.5 28.4 31.8 28.4H310.9c16.3 0 30-12.2 31.8-28.4L368.5 224h32.2L374.5 455.2c-3.7 32.3-31 56.8-63.6 56.8H137.1c-32.6 0-59.9-24.4-63.6-56.8z"]
};
var faMemoCircleCheck = {
  prefix: 'fal',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm44.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7z"]
};
var faRouteHighway = {
  prefix: 'fal',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M232.2 2.3c-5.1-3-11.4-3-16.5 0L194.6 15c-31.9 19.2-71.5 20.7-104.8 4c-17.7-8.9-39.2-3.8-51.1 12.1L14.5 63.3c-10.7 14.2-11.9 33.5-3 49C24.9 135.9 32 162.5 32 189.7V203c0 22.4-4.3 44.6-12.6 65.4L8 296.9c-5.3 13.2-8 27.4-8 41.6C0 382.2 25.4 422 65.1 440.3l152.2 70.2c4.3 2 9.2 2 13.4 0l152.2-70.2C422.6 422 448 382.2 448 338.5c0-14.3-2.7-28.4-8-41.6l-11.4-28.5c-8.3-20.8-12.6-43-12.6-65.4V189.7c0-27.1 7.1-53.8 20.6-77.4c8.8-15.5 7.6-34.7-3-49L409.3 31.1C397.4 15.2 375.9 10.2 358.2 19c-33.3 16.7-72.8 15.1-104.8-4L232.2 2.3zM211 42.4l13-7.8 13 7.8c41.3 24.8 92.4 26.8 135.5 5.2c3.9-1.9 8.6-.8 11.2 2.6l24.2 32.3c3 4 3.4 9.5 .9 13.9c-11.3 19.7-18.8 41.3-22.4 63.6H61.6c-3.6-22.3-11.1-43.8-22.4-63.6c-2.5-4.4-2.2-9.8 .9-13.9L64.3 50.3c2.6-3.5 7.3-4.6 11.2-2.6c43.1 21.6 94.2 19.6 135.5-5.2zM64 192H384v11c0 26.5 5 52.7 14.9 77.2l11.4 28.5c3.8 9.5 5.7 19.6 5.7 29.8c0 31.2-18.2 59.6-46.5 72.7L224 478.4 78.5 411.2C50.2 398.1 32 369.8 32 338.5c0-10.2 1.9-20.3 5.7-29.8l11.4-28.5C59 255.7 64 229.5 64 203V192z"]
};
var faDownToLine = {
  prefix: 'fal',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M16 448H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm174.2-96.8c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L318.2 219.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H256c-8.8 0-16-7.2-16-16V72c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8V192c0 8.8-7.2 16-16 16H70.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L190.2 351.2zM192 384c-9.5 0-18.6-3.9-25.1-10.8L42.5 241.2C35.8 234 32 224.5 32 214.7C32 193.3 49.3 176 70.7 176H112V72c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V176h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L217.1 373.2c-6.5 6.9-15.6 10.8-25.1 10.8z"]
};
var faArrowAltToBottom = faDownToLine;
var faFilter = {
  prefix: 'fal',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M0 71.5C0 49.7 17.7 32 39.5 32H472.5C494.3 32 512 49.7 512 71.5c0 9.2-3.2 18.1-9.1 25.2L320 317.8V446.1c0 18.7-15.2 33.9-33.9 33.9c-7.5 0-14.8-2.5-20.8-7.1l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3V317.8L9.1 96.7C3.2 89.6 0 80.7 0 71.5zM39.5 64c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 301.8c2.4 2.9 3.7 6.5 3.7 10.2v88.2l61 47.4c.3 .3 .7 .4 1.1 .4c1 0 1.9-.8 1.9-1.9V312c0-3.7 1.3-7.3 3.7-10.2L478.3 76.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5H39.5z"]
};
var faSquareG = {
  prefix: 'fal',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256c0 53 43 96 96 96c47.6 0 87.1-34.6 94.7-80H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3c-17-15.2-39.4-24.4-64-24.4c-53 0-96 43-96 96z"]
};
var faCirclePhone = {
  prefix: 'fal',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.2 144.1c1.9-.4 3.8 .6 4.5 2.3l24 56c.7 1.6 .2 3.5-1.1 4.7l-20.3 16.6c-6.1 5-7.6 13.6-3.7 20.4c14.7 25.4 35.9 46.6 61.4 61.4c6.8 3.9 15.4 2.4 20.4-3.7l16.6-20.3c1.1-1.4 3-1.8 4.7-1.1l56 24c1.8 .8 2.7 2.6 2.3 4.5l-12 56c-.4 1.8-2 3.2-3.9 3.2c-114.9 0-208-93.1-208-208c0-1.9 1.3-3.5 3.2-3.9l56-12zm33.9-10.3c-6.8-15.8-23.8-24.6-40.6-21l-56 12C123.9 128.4 112 143 112 160c0 132.5 107.4 240 240 240c17 0 31.6-11.9 35.2-28.5l12-56c3.6-16.8-5.2-33.9-21-40.6l-56-24c-14.7-6.3-31.9-2.1-42 10.3l-7.5 9.2c-11.9-8.6-22.4-19.1-31-31l9.2-7.5c12.4-10.2 16.6-27.3 10.3-42l-24-56z"]
};
var faPhoneCircle = faCirclePhone;
var faClipboardPrescription = {
  prefix: 'fal',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 208c-8.8 0-16 7.2-16 16v80 64c0 8.8 7.2 16 16 16s16-7.2 16-16V320h41.4l48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 345.4l-31.2-31.2C227.3 305.1 240 286 240 264c0-30.9-25.1-56-56-56H112zm72 80h-8H128V240h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faUserNurseHair = {
  prefix: 'fal',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M128 144V76.9l96-42 96 42V144H128zM96 76.9V144v16 16 0c0 70.7 57.3 128 128 128s128-57.3 128-128v0V160 144 76.9c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176v0c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48h21.5c35.5 0 68.3-18.3 87-48H320zm-112.8 0c-12.4 10.2-28.2 16-44.8 16h-33c-.9-5.2-1.3-10.5-1.3-16v0h79.2zM121.1 356.3l69 69c18.7 18.7 49.1 18.7 67.9 0l69-69c51.4 16.8 88.5 64.9 89.1 121.6H32c.6-56.8 37.7-104.9 89.1-121.6zm21.7-23.5c-7.5-7.5-18.3-11-28.4-7.9C48.2 344.9 0 406.4 0 479.2c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-72.8-48.2-134.3-114.4-154.4c-10.1-3.1-20.9 .4-28.4 7.9l-69.8 69.8c-6.2 6.2-16.4 6.2-22.6 0l-69.8-69.8zM208 56V72H192c-4.4 0-8 3.6-8 8V96c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104h16c4.4 0 8-3.6 8-8V80c0-4.4-3.6-8-8-8H240V56c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]
};
var faQuestion = {
  prefix: 'fal',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M144 64c-53 0-96 43-96 96c0 8.8-7.2 16-16 16s-16-7.2-16-16C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128c0 35.3-16.6 68.4-44.8 89.6l-60.8 45.6C184.3 305.8 176 322.4 176 340v12c0 8.8-7.2 16-16 16s-16-7.2-16-16V340c0-27.7 13-53.8 35.2-70.4L240 224c20.1-15.1 32-38.8 32-64c0-53-43-96-96-96H144zm-8 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFileSignature = {
  prefix: 'fal',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M320 480c17.7 0 32-14.3 32-32V437.3l23.8-5.9c2.8-.7 5.6-1.6 8.2-2.7V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v39.8l-32 32V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320zM240 160H351.5c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16zM144 349l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l12.6 42.1c7.1-8.3 17.5-13.1 28.5-13.1c14.2 0 27.2 8 33.5 20.7l5.6 11.3h41.7l15.7-62.6c2.1-8.4 6.5-16.1 12.6-22.3L473.5 145.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 384.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-2 .5-4.1 .6-6.1 .3H240c-6.1 0-11.6-3.4-14.3-8.8L215.6 387c-.9-1.8-2.8-3-4.9-3c-1.7 0-3.3 .8-4.4 2.2l-17.6 23.4c-3.6 4.8-9.7 7.2-15.6 6.2s-10.8-5.4-12.5-11.2L144 349zM518.8 168c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L536.2 208c6.2-6.2 6.2-16.4 0-22.6L518.8 168zM342.5 321.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L488.7 255.4l-40-40L342.5 321.7z"]
};
var faToggleLargeOn = {
  prefix: 'fal',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M416 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm0 288H160C71.6 416 0 344.4 0 256S71.6 96 160 96H416c88.4 0 160 71.6 160 160s-71.6 160-160 160zm-96-32c-38.9-29.2-64-75.7-64-128s25.1-98.8 64-128H160C89.3 128 32 185.3 32 256s57.3 128 128 128H320z"]
};
var faUpDownLeftRight = {
  prefix: 'fal',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", "M252.9 33.4L196 96H316L259.1 33.4c-.8-.9-1.9-1.4-3.1-1.4s-2.3 .5-3.1 1.4zm29.8-21.5l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8H272V240H384v32H272V384h51.2c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8H240V272H128l0 51.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 51.2H240V128l-51.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM316 416H196l56.9 62.6c.8 .9 1.9 1.4 3.1 1.4s2.3-.5 3.1-1.4L316 416zM478.6 259.1c.9-.8 1.4-1.9 1.4-3.1s-.5-2.3-1.4-3.1L416 196V316l62.6-56.9zm-46.4 85.4c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM33.4 252.9c-.9 .8-1.4 1.9-1.4 3.1s.5 2.3 1.4 3.1L96 316 96 196 33.4 252.9z"]
};
var faArrowsAlt = faUpDownLeftRight;
var faDryerHeat = {
  prefix: 'fal',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336 304a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304zm115.3-75.3l4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm80 0l4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faDryerAlt = faDryerHeat;
var faHouseChimneyUser = {
  prefix: 'fal',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3V56c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24V79.4L298.6 4zM416 107.6V64h64V164.1l-64-56.5zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM248 352h80c22.1 0 40 17.9 40 40v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-39.8-32.2-72-72-72H248c-39.8 0-72 32.2-72 72v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1 17.9-40 40-40z"]
};
var faHandHoldingHeart = {
  prefix: 'fal',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M163.9 28.9C191.7 .7 235.8-.8 265.3 24.3c5.8 4.9 11 10.4 16.3 15.9c2.1 2.2 4.2 4.5 6.4 6.6c2.1-2.2 4.3-4.4 6.4-6.6c5.2-5.5 10.5-11 16.3-15.9C340.2-.8 384.3 .7 412.1 28.9c29.4 29.8 29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0c-17.1 17.4-17.1 45.7 0 63.1L288 217.3 389.3 114.4c17.1-17.4 17.1-45.7 0-63.1c-16.8-17.1-44-17.1-60.8 0L299.4 80.9c-6.3 6.4-16.5 6.4-22.8 0L247.5 51.4zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faArrowUpSmallBig = {
  prefix: 'fal',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", "M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6L75.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 80v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80zm32 352c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16V432zm-32 0V304c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z"]
};
var faSortSizeUpAlt = faArrowUpSmallBig;
var faTrainTrack = {
  prefix: 'fal',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", "M207.1 53.2c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9L158.5 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h35.4l-33.2 96H72c-8.8 0-16 7.2-16 16s7.2 16 16 16h31.1L69.8 352H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H58.8L32.9 458.8c-2.9 8.3 1.5 17.5 9.9 20.4s17.5-1.5 20.4-9.9L92.6 384H483.4l29.5 85.2c2.9 8.3 12 12.8 20.4 9.9s12.8-12 9.9-20.4L517.2 384H544c8.8 0 16-7.2 16-16s-7.2-16-16-16H506.2l-33.2-96H504c8.8 0 16-7.2 16-16s-7.2-16-16-16H461.9l-33.2-96H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H417.5L399.1 42.8c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4L383.7 96H192.3l14.8-42.8zM181.2 128H394.8L428 224H148l33.2-96zM472.3 352H103.7l33.2-96H439.1l33.2 96z"]
};
var faPuzzlePiece = {
  prefix: 'fal',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M169.1 17.3C183.8 6.3 203.2 0 224 0s40.2 6.3 54.9 17.3S304 44.6 304 64c0 19.5-10.6 35.9-25.3 46.8c-5.2 3.8-6.7 7.7-6.7 10c0 4 3.2 7.2 7.2 7.2H336c26.5 0 48 21.5 48 48v56.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7c11-14.7 27.4-25.3 46.8-25.3c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2V464c0 26.5-21.5 48-48 48H279.2c-21.6 0-39.2-17.5-39.2-39.2c0-16.2 9.9-28.4 19.6-35.6c8.6-6.4 12.4-14.1 12.4-21.2c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1c0 7.1 3.8 14.8 12.4 21.2c9.7 7.2 19.6 19.4 19.6 35.6c0 21.7-17.5 39.2-39.2 39.2H48c-26.5 0-48-21.5-48-48V343.2C0 321.5 17.5 304 39.2 304c16.2 0 28.4 9.9 35.6 19.6C81.2 332.2 88.9 336 96 336c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7S103.1 240 96 240c-7.1 0-14.8 3.8-21.2 12.4C67.6 262.1 55.4 272 39.2 272C17.5 272 0 254.5 0 232.8V176c0-26.5 21.5-48 48-48H168.8c4 0 7.2-3.2 7.2-7.2c0-2.3-1.6-6.1-6.7-10C154.6 99.9 144 83.5 144 64c0-19.4 10.5-35.8 25.1-46.7zm19.2 25.6C179.8 49.3 176 56.9 176 64c0 7.1 3.8 14.8 12.4 21.2c9.7 7.2 19.6 19.4 19.6 35.6c0 21.6-17.5 39.2-39.2 39.2H48c-8.8 0-16 7.2-16 16v56.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7C60.1 218.6 76.5 208 96 208c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9S115.4 368 96 368c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2V464c0 8.8 7.2 16 16 16H168.8c4 0 7.2-3.2 7.2-7.2c0-2.3-1.6-6.1-6.7-10c-14.7-11-25.3-27.4-25.3-46.8c0-19.4 10.5-35.8 25.1-46.7s34.1-17.3 54.9-17.3s40.2 6.3 54.9 17.3s25.1 27.3 25.1 46.7c0 19.5-10.6 35.9-25.3 46.8c-5.2 3.8-6.7 7.7-6.7 10c0 4 3.2 7.2 7.2 7.2H336c8.8 0 16-7.2 16-16V343.2c0-21.7 17.5-39.2 39.2-39.2c16.2 0 28.4 9.9 35.6 19.6c6.4 8.6 14.1 12.4 21.2 12.4c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-7.1 0-14.8 3.8-21.2 12.4c-7.2 9.7-19.4 19.6-35.6 19.6c-21.7 0-39.2-17.5-39.2-39.2V176c0-8.8-7.2-16-16-16H279.2c-21.6 0-39.2-17.5-39.2-39.2c0-16.2 9.9-28.4 19.6-35.6C268.2 78.8 272 71.1 272 64c0-7.1-3.8-14.7-12.3-21.1S238.5 32 224 32s-27.1 4.4-35.7 10.9z"]
};
var faMoneyCheck = {
  prefix: 'fal',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm112 96H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM360 176c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8H360zm-40 8c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V184z"]
};
var faStarHalfStroke = {
  prefix: 'fal',
  iconName: 'star-half-stroke',
  icon: [640, 512, ["star-half-alt"], "f5c0", "M234.4 186.5L97 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L182.2 473.2 304 408.1V75.1l-45.5 93.7c-4.6 9.5-13.6 16.1-24.1 17.7zM336 408.2l121.6 65L434.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L405.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L336 75.4V408.2zm146.2 99.2c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L298.3 13.5C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z"]
};
var faStarHalfAlt = faStarHalfStroke;
var faFileExclamation = {
  prefix: 'fal',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 224c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zm24 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCode = {
  prefix: 'fal',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M405.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1l-160 480c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l160-480c2.8-8.4-1.7-17.4-10.1-20.2zM172 117.4c-5.9-6.6-16-7.2-22.6-1.3l-144 128C2 247.1 0 251.4 0 256s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L40.1 256 170.6 140c6.6-5.9 7.2-16 1.3-22.6zm296.1 0c-5.9 6.6-5.3 16.7 1.3 22.6L599.9 256 469.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128c-6.6-5.9-16.7-5.3-22.6 1.3z"]
};
var faWhiskeyGlass = {
  prefix: 'fal',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", "M32 64L60 256H452L480 64H32zM64.7 288L82 406.9c3.4 23.6 23.7 41.1 47.5 41.1h253c23.8 0 44.1-17.5 47.5-41.1L447.3 288H64.7zM7.8 43.1C13.9 36 22.7 32 32 32H480c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z"]
};
var faGlassWhiskey = faWhiskeyGlass;
var faMoonStars = {
  prefix: 'fal',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M304 0c8.8 0 16 7.2 16 16V48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H320v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V16c0-8.8 7.2-16 16-16zM156.6 163.9C85.3 180 32 243.8 32 320.2c0 88.5 71.6 160.2 159.8 160.2c25.7 0 50-6.1 71.5-16.9c-87.6-11.3-155.1-86.4-155.1-177.2c0-47.4 18.4-90.4 48.4-122.4zM0 320.2C0 214.1 85.8 128 191.8 128c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.2c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4C85.8 512.4 0 426.3 0 320.2zM432 160v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H432v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V160c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faBuildingCircleExclamation = {
  prefix: 'fal',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faClothesHanger = {
  prefix: 'fal',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", "M212.2 85.8C220.4 36.3 263.2 0 313.4 0C370.1 0 416 45.9 416 102.6v8.1c0 36.1-17.6 70-47.2 90.7l-20.7 14.5L612.5 396.8C629.7 408.5 640 428 640 448.9c0 34.9-28.3 63.1-63.1 63.1H63.1C28.3 512 0 483.7 0 448.9c0-20.8 10.3-40.3 27.5-52.1L310.9 202.8l39.5-27.7c21-14.7 33.6-38.8 33.6-64.5v-8.1c0-39-31.6-70.6-70.6-70.6c-34.5 0-64 25-69.7 59l-3.9 23.6c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l3.9-23.6zM320 235.4L45.6 423.2C37.1 429 32 438.6 32 448.9C32 466.1 45.9 480 63.1 480H576.9c17.2 0 31.1-13.9 31.1-31.1c0-10.3-5.1-19.9-13.6-25.7L320 235.4z"]
};
var faMobileNotch = {
  prefix: 'fal',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M256 32V48c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32H96C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H256zm-32 0H160V48h64V32zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64z"]
};
var faMobileIphone = faMobileNotch;
var faMagnifyingGlassChart = {
  prefix: 'fal',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM128 224l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64-96V288c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faArrowUpRightFromSquare = {
  prefix: 'fal',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M336 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H457.4L212.7 276.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H336zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faExternalLink = faArrowUpRightFromSquare;
var faCubesStacked = {
  prefix: 'fal',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", "M288 64H224v64h64V64zM224 32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM98.7 234.7l32 55.4 55.4-32-32-55.4-55.4 32zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM352 224H288v64h64V224zm-96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V224zm96 224h64V384H352v64zm-32-64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384zm-64 0H192v64h64V384zm-64-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zM32 384v64H96V384H32zM0 384c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384z"]
};
var faImagesUser = {
  prefix: 'fal',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M512 64H160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h64V336c0-44.2 35.8-80 80-80h32 32c44.2 0 80 35.8 80 80v16h64c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM448 384H416 256 224 160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H448zm-32-32V336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v16H416zM16 96c8.8 0 16 7.2 16 16V352c0 53 43 96 96 96H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 480 0 422.7 0 352V112c0-8.8 7.2-16 16-16zm352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM336 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faWonSign = {
  prefix: 'fal',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", "M31.3 43.3c-2.6-8.4-11.6-13.2-20-10.6S-1.9 44.3 .7 52.7L63.3 256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H73.1l55.6 180.7c2.1 6.8 8.4 11.4 15.6 11.3s13.3-5 15.2-11.8L208 288H304l48.5 180.2c1.9 6.9 8 11.7 15.2 11.8s13.5-4.5 15.6-11.3L438.9 288H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H448.7L511.3 52.7c2.6-8.4-2.1-17.4-10.6-20s-17.4 2.1-20 10.6L415.3 256H328.6L271.5 43.8c-1.9-7-8.2-11.8-15.4-11.8s-13.6 4.9-15.4 11.8L183.4 256H96.7L31.3 43.3zM106.6 288h68.2L143 406.3 106.6 288zm110-32L256 109.5 295.4 256H216.6zm120.6 32h68.2L369 406.3 337.2 288z"]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faImagePolaroidUser = {
  prefix: 'fal',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M336 384H304 144 112 32v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V384H336zm-1.6-32H416V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V352h81.6c7.4-36.5 39.7-64 78.4-64h32 32c38.7 0 71 27.5 78.4 64zm-187.7 0H301.3c-6.6-18.6-24.4-32-45.3-32H192c-20.9 0-38.7 13.4-45.3 32zM448 96V352v16 16 32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384 368 352 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64zM256 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faVirusCovid = {
  prefix: 'fal',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M216 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h24V72.7c-38.8 3.3-74.1 18.7-102.3 42.4L108.9 86.3l0 0 17-17c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L46.7 103.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17-17 0 0 28.8 28.8C91.4 165.9 76 201.2 72.7 240H32l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24H72.7c3.3 38.8 18.7 74.1 42.4 102.3L86.3 403.1l0 0-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17 0 0 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V439.3c38.8-3.3 74.1-18.7 102.3-42.4l28.8 28.8 0 0-17 17c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-17 17 0 0-28.8-28.8c23.7-28.2 39-63.5 42.4-102.3H480v24c0 8.8 7.2 16 16 16s16-7.2 16-16V216c0-8.8-7.2-16-16-16s-16 7.2-16 16v24H439.3c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 0 0 17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L408.7 46.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17 0 0-28.8 28.8C346.1 91.4 310.8 76 272 72.7V32l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H216zm40 104a152 152 0 1 1 0 304 152 152 0 1 1 0-304zM192 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareEllipsis = {
  prefix: 'fal',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM200 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm168-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faPie = {
  prefix: 'fal',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M288 80c-98.6 0-183.4 59.5-220.3 144.6C64.2 232.6 56 240 44.8 240c-8.8 0-16 7.2-16 16s7.2 16 16 16c26 0 46-9.5 59.3-18.9c6.1-4.3 14.1-4.8 20.7-1.2c1.4 .8 2.8 1.5 4.3 2.3c17 8.8 41.6 17.8 70.8 17.8s53.8-9 70.8-17.8c10.8-5.6 23.6-5.6 34.4 0c17 8.8 41.6 17.8 70.8 17.8s53.8-9 70.8-17.8c1.5-.8 2.9-1.5 4.3-2.3c6.6-3.7 14.7-3.1 20.7 1.2c13.3 9.4 33.3 18.9 59.3 18.9c8.8 0 16-7.2 16-16s-7.2-16-16-16c-11.2 0-19.4-7.4-22.9-15.4C471.4 139.5 386.6 80 288 80zM40 208.2C82.6 113.8 177.6 48 288 48s205.4 65.8 248.1 160.2c24.2 2.4 43.1 22.9 43.1 47.8c0 26.5-21.5 48-48 48c-30.2 0-54.2-9.8-71.3-20.5c-20 10.1-49 20.5-83.9 20.5c-35.8 0-65.4-11-85.5-21.3c-1.6-.8-3.5-.8-5 0C265.4 293 235.8 304 200 304c-34.8 0-63.8-10.4-83.9-20.5C99 294.2 75 304 44.8 304c-26.5 0-48-21.5-48-48c0-24.9 18.9-45.3 43.2-47.8zM58.5 335.4c11.4-.9 22-3 31.8-5.8l21.5 64.4c4.4 13.1 16.6 21.9 30.4 21.9H433.9c13.8 0 26-8.8 30.4-21.9l21.5-64.4c9.8 2.8 20.4 4.8 31.8 5.8l-22.9 68.8c-8.7 26.1-33.2 43.8-60.7 43.8H142.1c-27.5 0-52-17.6-60.7-43.8L58.5 335.4zM206.3 151.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessKnightPiece = {
  prefix: 'fal',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", "M53.3 96l80.4 0C210.1 96 272 157.9 272 234.3c0 12.7-1.7 25.3-5.2 37.5L244.3 352h33.2l20.1-71.5c4.2-15 6.4-30.6 6.4-46.2C304 140.3 227.7 64 133.7 64L45.3 64c-16 0-28.9 12.9-28.9 28.9c0 8.2 3.5 16 9.6 21.5l7.7 6.9c-11.1 14-17.3 31.5-17.3 49.5l-.2 65.1c-.1 26.9 17.6 49.7 42.1 57.3c-6.3 11.7-9.8 25-9.8 38.7L48.2 352h32l.2-19.8h0V332c0-15.6 7.4-30.3 19.9-39.7l76.1-46.7c7.5-4.6 9.9-14.5 5.3-22s-14.5-9.9-22-5.3l-36.5 22.4c-1.2 .4-2.3 .9-3.4 1.5L90.3 260c-4.4 2.6-9.4 4-14.5 4c-15.3-.1-27.7-12.6-27.7-27.9l.2-65.1c0-11.7 4.3-23 12.1-31.7l7.6-8.6c5.8-6.6 5.3-16.6-1.3-22.5L53.3 96zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM65.8 416l188.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L65.8 416zm188.4-32H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H280.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faChessKnightAlt = faChessKnightPiece;
var faAustralSign = {
  prefix: 'fal',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L132.2 224H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H118.6L91.6 320H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H78L33.3 457.8c-3.4 8.1 .4 17.5 8.5 21s17.5-.4 21-8.5l50-118.2H335.2l50 118.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21L370 352h62c8.8 0 16-7.2 16-16s-7.2-16-16-16H356.5l-27.1-64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H315.8L238.7 41.8zM281.1 224H166.9L224 89.1 281.1 224zM153.4 256H294.6l27.1 64H126.3l27.1-64z"]
};
var faCloudPlus = {
  prefix: 'fal',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm32 352V304H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faF = {
  prefix: 'fal',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M48 32C21.5 32 0 53.5 0 80V248 464c0 8.8 7.2 16 16 16s16-7.2 16-16V272H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V80c0-8.8 7.2-16 16-16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"]
};
var faLeaf = {
  prefix: 'fal',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M132 238.3c23.6-9.3 49.2-14.3 76-14.3h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-28.8 0-56 6.9-80 19.2C129.7 353.2 193.5 416 272 416h0l.8 0c109-.5 207.2-110.5 207.2-259.4c0-23-2.4-45.2-6.9-66.3C447.5 113.7 413.4 128 376 128l-104 0c-67.9 0-124.9 47-140 110.3zM96.7 256.3C104.7 166.4 180.1 96 272 96l104 0c35.2 0 66.6-16.2 87.2-41.7l.6-.8c2.3-2.9 4.4-5.8 6.4-8.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6s2.3 7.1 3.4 10.8l.4 1.5c8.8 30.3 13.5 62.8 13.5 96.8C512 317.1 405.1 447.3 273 448l-1 0c-89.4 0-163.2-66.7-174.5-153C57.5 327.3 32 376.7 32 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-73.9 38.6-138.9 96.7-175.7z"]
};
var faBedBunk = {
  prefix: 'fal',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V176 431.7 496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.7H240 544V496c0 8.8 7.2 16 16 16s16-7.2 16-16V431.7 272 176 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32V160H32V16zM224 288V415.7H32V192H240 544v64H256c-17.7 0-32 14.3-32 32zM544 112v48H256V32H464c44.2 0 80 35.8 80 80zM256 288l288 0V415.7H256V288zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faRoad = {
  prefix: 'fal',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", "M185.6 32c-26.9 0-50.9 16.8-60.1 42L8.5 394c-15.3 41.8 15.7 86 60.1 86H507.4c44.5 0 75.4-44.2 60.1-86L450.5 74c-9.2-25.2-33.2-42-60.1-42H185.6zM155.5 85c4.6-12.6 16.6-21 30.1-21H272v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64h86.4c13.4 0 25.4 8.4 30.1 21L537.4 405c7.6 20.9-7.8 43-30.1 43H304V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H68.6c-22.2 0-37.7-22.1-30.1-43L155.5 85zM304 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"]
};
var faTaxi = {
  prefix: 'fal',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M192 48V64H320V48c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 64V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V64h.4c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 253.2 512 284.3 512 320v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 432 416 320c0-35.7 19.4-66.8 48.3-83.3l.4-1.3L83 121c10.2-33.8 41.3-57 76.6-57h.4zm-.4 32c-21.2 0-39.9 13.9-46 34.2L85.3 224.6c3.5-.4 7.1-.6 10.7-.6H416c3.6 0 7.2 .2 10.7 .6l-28.3-94.4c-6.1-20.3-24.8-34.2-46-34.2H159.6zM74.7 259.9l-.5-.1C49.6 268.7 32 292.3 32 320v96H480V320c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H96c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3zM80 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCab = faTaxi;
var faPersonCirclePlus = {
  prefix: 'fal',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChartPie = {
  prefix: 'fal',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M511.3 208H336V32.7c93.3 7.7 167.6 82.1 175.3 175.3zM320 240H528.5c8.4 0 15.4-6.5 15.5-14.9l0-1.1C544 100.3 443.7 0 320 0l-1.1 0C310.5 0 304 7.1 304 15.5V224c0 8.8 7.2 16 16 16zm-86.6 70.6L375.3 452.6C344.9 470 309.6 480 272 480C157.1 480 64 386.9 64 272c0-98.3 68.3-180.8 160-202.4V288c0 8.5 3.4 16.6 9.4 22.6zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288V49.6c0-9.2-7.8-16.6-17-15.4zM489.6 412.3L397.3 320H538.4c-8.3 35-25.4 66.6-48.9 92.3zM573.8 305c1.3-9.2-6.1-17-15.4-17H358.6c-14.3 0-21.4 17.2-11.3 27.3L478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3z"]
};
var faPieChart = faChartPie;
var faBoltLightning = {
  prefix: 'fal',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M32 30.9C32 13.8 45.9 0 62.9 0H226.2C242.7 0 256 13.3 256 29.8c0 3.2-.5 6.4-1.5 9.4L214.2 160H355.8c15.6 0 28.2 12.6 28.2 28.2c0 5.7-1.7 11.2-4.9 15.9l-203.2 297c-4.6 6.8-12.3 10.8-20.5 10.8c-16.2 0-28-15.2-24.1-30.9L179.5 288H30.9C13.9 288 0 274.1 0 257.1c0-1.5 .1-2.9 .3-4.4L32 30.9zM64 32c0 1.1-.1 2.2-.3 3.3L32.2 256H200c4.9 0 9.6 2.3 12.6 6.2s4.1 8.9 2.9 13.7L171.9 450.2 348.6 192H192c-5.1 0-10-2.5-13-6.6s-3.8-9.5-2.2-14.4L223.1 32H64z"]
};
var faClockEight = {
  prefix: 'fal',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256c0 5.3-2.7 10.3-7.1 13.3l-96 64c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2L240 247.4V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSackXmark = {
  prefix: 'fal',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M310.5 144h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8l6.7-9.8zM0 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 121.9 37.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96zM256 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 297.4z"]
};
var faFileExcel = {
  prefix: 'fal',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm85.1 246.8c-5.1-7.2-15-9-22.3-3.9s-9 15-3.9 22.3L172.5 336l-49.6 70.8c-5.1 7.2-3.3 17.2 3.9 22.3s17.2 3.3 22.3-3.9L192 363.9l42.9 61.3c5.1 7.2 15 9 22.3 3.9s9-15 3.9-22.3L211.5 336l49.6-70.8c5.1-7.2 3.3-17.2-3.9-22.3s-17.2-3.3-22.3 3.9L192 308.1l-42.9-61.3z"]
};
var faFileContract = {
  prefix: 'fal',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm54.2 253.8L144 349l16.7 55.6c1.7 5.8 6.6 10.1 12.5 11.2s12-1.3 15.6-6.2l17.6-23.4c1-1.4 2.7-2.2 4.4-2.2c2.1 0 4 1.2 4.9 3l10.1 20.1c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H249.9l-5.6-11.3C237.9 360 224.9 352 210.7 352c-11 0-21.4 4.8-28.5 13.1l-12.6-42.1C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z"]
};
var faFishFins = {
  prefix: 'fal',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M247.8 148c13.4-6.2 20.8-20.8 17.9-35.3L256 64l77.6 58.2c4.9 3.7 10.8 5.9 16.9 6.3c47.2 3.4 88 23.2 120.3 47.5c35.5 26.7 60.8 58.7 73.2 80c-12.4 21.3-37.6 53.3-73.2 80c-32.3 24.2-73.1 44.1-120.3 47.5c-6.1 .4-12 2.6-16.9 6.3L256 448l9.7-48.6c2.9-14.5-4.5-29.1-17.9-35.3c-17.1-7.9-32.7-17.6-46.6-28c-13.8-10.4-26.1-21.6-36.8-32.8c-10.2-10.7-26.5-13-39.3-5.5L32 352l45.8-80.1c5.6-9.8 5.6-21.9 0-31.8L32 160l93.1 54.3c12.8 7.5 29 5.2 39.3-5.5c10.7-11.2 23-22.4 36.8-32.8c13.9-10.5 29.6-20.2 46.6-28zM9.5 137.3C-.8 147.5-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleQ = {
  prefix: 'fal',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96s96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l-50.9-50.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l50.9 50.9C295.9 345.4 276.7 352 256 352c-53 0-96-43-96-96zm224 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c29.6 0 56.8-10 78.5-26.9l22.2 22.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-22.2-22.2C374 312.8 384 285.6 384 256z"]
};
var faBuildingFlag = {
  prefix: 'fal',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256 224 160 128zM64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120zm32 8v32h32V128H96zM248 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 64h32V128H256v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm32 8v32h32V256H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H256v32zM432 0c8.8 0 16 7.2 16 16V32H608c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224 192 64 32 16c0-8.8 7.2-16 16-16zm16 192H608V64H448V192z"]
};
var faFaceGrinBeam = {
  prefix: 'fal',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zm-242.4-135c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
  prefix: 'fal',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M0 64c0 29.8 20.4 54.9 48 62V226c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64c29.8 0 54.9-20.4 62-48H322c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62V126c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H126C118.9 20.4 93.8 0 64 0C28.7 0 0 28.7 0 64zM322 80c5.8 22.5 23.5 40.2 46 46V226c-22.5 5.8-40.2 23.5-46 46H126c-5.8-22.5-23.5-40.2-46-46V126c22.5-5.8 40.2-23.5 46-46H322zM480 208H464v32h16 34c5.8 22.5 23.5 40.2 46 46V386c-22.5 5.8-40.2 23.5-46 46H318c-5.8-22.5-23.5-40.2-46-46V352 336H240v16 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64c29.8 0 54.9-20.4 62-48H514c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62V286c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H480zm96 48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM544 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faFaceDisguise = {
  prefix: 'fal',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-16.5 1.8-32.5 5.2-48H72c0 50.1 38.4 91.2 87.3 95.6c-9.6 7.9-15.3 19.7-15.3 32.4c0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4 .7 4.8 1.3 7.2 1.8V432c0 8.8 7.2 16 16 16s16-7.2 16-16V406.8c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6L339.5 418c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4c49-4.4 87.3-45.5 87.3-95.6h34.8c3.4 15.5 5.2 31.5 5.2 48zM218 229.5l-21.4 35.7c-1.1 .6-1.9 1-2.6 1.3c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 2.5-.1 4.9-.4 7.3c-5.4 3.6-10.1 8.4-13.5 14.1zm75.9 0c-3.5-5.8-8.1-10.6-13.5-14.1c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-.6-.3-1.5-.7-2.6-1.3L294 229.5zM465.3 176H434.5c-5.3-14.9-14.1-28-25.4-38.5l5.2-10.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-3.5 7c-4.6-2-9.3-3.6-14.2-4.9V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v16.3c-4.4 .4-8.7 1-13 2l-4.7-9.5c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l3.6 7.3c-16.4 10.2-29.5 25.3-37.3 43.1c-7.8-17.9-20.9-32.9-37.3-43.1l3.6-7.3c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-4.7 9.5c-4.2-.9-8.6-1.6-13-2V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v19c-4.9 1.3-9.6 2.9-14.2 4.9l-3.5-7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l5.2 10.3C91.5 148 82.7 161.1 77.5 176H46.7C78.9 91.8 160.5 32 256 32s177.1 59.8 209.3 144zm34.1 .4C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1c3.3-2.9 5.3-7.2 5.3-11.9c0-7.7-5.4-14.1-12.6-15.6zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4L245.5 246c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleArrowDownRight = {
  prefix: 'fal',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM200 352H336c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16s-16 7.2-16 16V297.4L187.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 320H200c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faAlien8bit = {
  prefix: 'fal',
  iconName: 'alien-8bit',
  icon: [576, 512, [128126, "alien-monster"], "f8f6", "M128 32c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32h32v32H96V144c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32H64v32c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32h96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V384h32c17.7 0 32-14.3 32-32V320h32c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32v16H416V128h32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32H352c-17.7 0-32 14.3-32 32v32H256V96c0-17.7-14.3-32-32-32H192c0-17.7-14.3-32-32-32H128zM480 192v48c0 8.8 7.2 16 16 16s16-7.2 16-16V176 144h32V288H496c-8.8 0-16 7.2-16 16v48H432 368 208 144 96V304c0-8.8-7.2-16-16-16H32V144H64v32 64c0 8.8 7.2 16 16 16s16-7.2 16-16V192h80c8.8 0 16-7.2 16-16V112 96h32v48c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V96h32v16 64c0 8.8 7.2 16 16 16h80zM128 96V64h32V80 96H128zm320 0H416V80 64h32V96zM160 448V384h32v16c0 8.8 7.2 16 16 16h32v32H160zm224-48V384h32v64H336V416h32c8.8 0 16-7.2 16-16zM224 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faAlienMonster = faAlien8bit;
var faHandPointRibbon = {
  prefix: 'fal',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24v8H128V56zM96 64H32c-6.2 0-11.8 3.5-14.4 9.1s-1.9 12.1 1.9 16.9l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H96v80c-19.4 14.6-32 37.8-32 64v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V304 272 248c0-30.9-25.1-56-56-56c-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-9.7 0-18.8 2.5-26.7 6.8C278 160.3 256.9 144 232 144c-8.6 0-16.7 1.9-24 5.4V80 56c0-30.9-25.1-56-56-56S96 25.1 96 56v8zm80 32v48H65.3l11.2-14c4.7-5.8 4.7-14.1 0-20L65.3 96H176zm0 80v24 40H144c-5.5 0-10.8 .6-16 1.6V176h48zm0 96v0h32v0h24c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c13.8 0 26.4-5 36.1-13.2C358.4 351.7 374.2 360 392 360c8.6 0 16.7-1.9 24-5.4C414.6 424.1 357.8 480 288 480H224c-70.7 0-128-57.3-128-128V320c0-26.5 21.5-48 48-48h32zm32-32V200c0-13.3 10.7-24 24-24s24 10.7 24 24v31.9l0 .1v13.4c-7.3-3.5-15.4-5.4-24-5.4H208zm80 32V232c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24v16 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0l0-24zm128 0v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8V248c0-13.3 10.7-24 24-24s24 10.7 24 24v24z"]
};
var faPoop = {
  prefix: 'fal',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M209.2 9.9c2.5-6 8.3-9.9 14.8-9.9h8c71.6 0 131 52.2 142.1 120.7C403.6 134.9 424 165 424 200c0 7.2-.9 14.3-2.5 21.1C455.6 233.2 480 265.7 480 304c0 16-4.3 31-11.7 43.9C494.4 363.2 512 391.5 512 424c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88c0-32.5 17.6-60.8 43.7-76.1C36.3 335 32 320 32 304c0-38.3 24.4-70.8 58.5-82.9C88.9 214.3 88 207.2 88 200c0-48.6 39.4-88 88-88h.9 17.8c20.6 0 37.3-16.7 37.3-37.3V65.8c0-12.3-4.9-24-13.5-32.7l-5.8-5.8c-4.6-4.6-5.9-11.5-3.5-17.4zM257.7 35c4.1 9.6 6.3 20.1 6.3 30.8v8.9c0 38.3-31 69.3-69.3 69.3H176.9 176c-30.9 0-56 25.1-56 56c0 9.1 2.2 17.7 6 25.2c2.4 4.7 2.3 10.2-.2 14.8s-7.1 7.7-12.3 8.3C85.7 251.6 64 275.3 64 304c0 15.3 6.2 29.2 16.2 39.4c4 4 5.5 9.9 4.1 15.4s-5.7 9.8-11.2 11.3c-23.7 6.5-41 28.3-41 54c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56c0-25.7-17.4-47.4-41-54c-5.5-1.5-9.7-5.8-11.2-11.3s.1-11.3 4.1-15.4c10-10.1 16.2-24 16.2-39.4c0-28.7-21.7-52.4-49.5-55.6c-5.2-.6-9.8-3.7-12.3-8.3s-2.6-10.1-.2-14.8c3.8-7.6 6-16.1 6-25.2c0-24.5-15.8-45.4-37.8-53c-5.9-2-10.1-7.4-10.7-13.6C339 85.1 303.8 45.8 257.7 35z"]
};
var faObjectExclude = {
  prefix: 'fal',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M64 32H288c17.7 0 32 14.3 32 32v64h32V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V320H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm96 352v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H384v32h64c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V384H160zm128-32c35.3 0 64-28.7 64-64H320c0 17.7-14.3 32-32 32H256v32h32zm64-160V160H320 288v32h32v64h32V192zM224 352l0-32H192V256H160v64 32h32 32zM160 224h32c0-17.7 14.3-32 32-32h32V160H224c-35.3 0-64 28.7-64 64z"]
};
var faTelescope = {
  prefix: 'fal',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M447.1 35.7L357.9 87.2l96 166.3L543.1 202l-96-166.3zM344 127.2L79.6 295.2c0 0-.1 .1-.1 .1l0 0c0 0 0 .1-.1 .1s0 .1 0 .1l0 0s0 0 0 .1L134 390l0 .1 0 0 0 0c0 0 .1 0 .1 .1l.1 0c0 0 .1 0 .1 0l0 0 0 0 .1 0 97-52.5C226.7 327.5 224 316 224 304c0-44.2 35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80c-10 0-19.6-1.8-28.4-5.2L222.7 502.3c-3.5 8.1-12.9 11.9-21 8.4s-11.9-12.9-8.4-21l53.2-124.1-97 52.4c-15.2 8.2-34.3 2.9-42.9-12.1L52 311.4c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8C446.4-.8 466 4.4 474.8 19.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c-1.7-10.9-5.5-21-11.1-30l37.9-20.5L344 127.2zM304 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm55.7 9.4c-7.8 7.5-17 13.5-27.3 17.4l52.9 123.5c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-55-128.3zM29.9 352.1l32 56c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-32-56c-4.4-7.7-1.7-17.4 6-21.8s17.4-1.7 21.8 6z"]
};
var faLocationPin = {
  prefix: 'fal',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M335.4 255.4c-10.9 25.9-26.2 54-43.6 82.1c-34.1 55.3-74.4 108.2-99.9 140c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1C37.4 229 32 207.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 15.6-5.4 37-16.6 63.4zM215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
var faMapMarker = faLocationPin;
var faSquareList = {
  prefix: 'fal',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faKaaba = {
  prefix: 'fal',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", "M544 112v0L288 192 32 112 288 32l256 80zM22.5 81.5C9.1 85.6 0 98 0 112V400c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400V112c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zM544 191.2L292.8 269.7c-3.1 1-6.4 1-9.5 0L32 191.2V145.5l246.5 77c6.2 1.9 12.9 1.9 19.1 0l246.5-77v45.7zm0 33.5v30.5l-20.8 6.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l11.2-3.5V400L288 480 32 400V288.8l11.2 3.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L32 255.2V224.8l241.7 75.5c9.3 2.9 19.3 2.9 28.6 0L544 224.8zm-427.2 57c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"]
};
var faToiletPaper = {
  prefix: 'fal',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", "M16 479c.2-5.3 1.7-10.6 4.5-15.4l0-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192C64 86 107 0 160 0H464h32c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2c2.1-14.2 4.1-29.6 5.7-46c14.2 25.6 33 41.2 53.6 41.2c44.2 0 80-71.6 80-160s-35.8-160-80-160s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7c-.3 2.5-.5 4.9-.8 7.4c-9 82.3-25.6 133.1-36.3 158.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2c-5.7 49.5-17.3 100.7-41.6 144.8c-.2 .3-.4 .6-.5 .9l0 0H317.9c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4c5.7-11.3 12.8-22.6 21.5-32.6H160zM496 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faHelmetSafety = {
  prefix: 'fal',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M240 80V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16zm-64-1.3v34.7C109.9 143.7 64 210.5 64 288v32H32V288c0-95.5 59.8-177.1 144-209.3zm224 34.7V78.7c83.5 31.9 143 112.4 144 206.9l0 2.4 0 32H512l0-34.3c-.9-76.5-46.5-142.3-112-172.3zM537.3 384H38.7c-3.7 0-6.7 3-6.7 6.7c0 .4 0 .7 .1 1C58.5 408.5 136.6 448 288 448s229.5-39.5 255.9-56.3c0-.2 .1-.6 .1-1c0-3.7-3-6.7-6.7-6.7zM38.7 352H537.3c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.4-13.9 27.3C531.3 437.9 447.1 480 288 480s-243.3-42.1-274.1-61.9C4.7 412.1 0 401.7 0 390.7C0 369.3 17.3 352 38.7 352z"]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faCommentCode = {
  prefix: 'fal',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM219.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L345.4 240l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faSimCards = {
  prefix: 'fal',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M112 368c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V154.5c0-8.5-3.4-16.6-9.4-22.6L316.1 41.4c-6-6-14.1-9.4-22.6-9.4H144c-17.7 0-32 14.3-32 32V368zM80 64c0-35.3 28.7-64 64-64H293.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V368c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V64zM16 96c8.8 0 16 7.2 16 16V384c0 53 43 96 96 96H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V112c0-8.8 7.2-16 16-16zm160 96v16h48V176H192c-8.8 0-16 7.2-16 16zm120 16h56V192c0-8.8-7.2-16-16-16H296 256v32h40zm0 32H240 176v32h56 40 80V240H296zm-8 64v32h48c8.8 0 16-7.2 16-16V304H288zm-56 0H176v16c0 8.8 7.2 16 16 16h40 24V304H232zM192 144h48 56 40c26.5 0 48 21.5 48 48v32 64 32c0 26.5-21.5 48-48 48H272 232 192c-26.5 0-48-21.5-48-48V288 224 192c0-26.5 21.5-48 48-48z"]
};
var faStarship = {
  prefix: 'fal',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M0 112C0 85.5 21.5 64 48 64H208c26.5 0 48 21.5 48 48s-21.5 48-48 48H161.2l47.6 34.6 60.1-8.2C296.8 114.8 366.5 64 448 64c106 0 192 86 192 192s-86 192-192 192c-81.5 0-151.2-50.8-179-122.4l-60.1-8.2L161.2 352H208c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48s21.5-48 48-48h58.8L163 311.1l-21.5-2.9C115.5 304.6 96 282.3 96 256s19.5-48.6 45.5-52.2l21.5-2.9L106.8 160H48c-26.5 0-48-21.5-48-48zM48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm97.9 139.5C135.6 236.9 128 245.7 128 256s7.6 19.1 17.9 20.5l113.5 15.5c-2.2-11.6-3.4-23.7-3.4-35.9s1.2-24.3 3.4-35.9L145.9 235.5zM32 400c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm416 16a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm32-160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faEject = {
  prefix: 'fal',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M224 96c-4.5 0-8.8 1.9-11.8 5.2l-176 192c-4.3 4.7-5.4 11.4-2.9 17.3s8.3 9.6 14.6 9.6H400c6.3 0 12.1-3.7 14.6-9.6s1.4-12.6-2.9-17.3l-176-192c-3-3.3-7.3-5.2-11.8-5.2zm0-32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 69.6 210.5 64 224 64zM16 416H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleRight = {
  prefix: 'fal',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm400 0c0-9.2-3.5-18-9.7-24.7l-84-91c-7.2-7.8-17.4-12.3-28.1-12.3c-21.1 0-38.3 17.1-38.3 38.3l0 25.7-80 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l80 0 0 25.7c0 21.1 17.1 38.3 38.3 38.3c10.7 0 20.9-4.5 28.1-12.3l84-91c6.2-6.7 9.7-15.6 9.7-24.7zm-33.2-3c.8 .8 1.2 1.9 1.2 3s-.4 2.2-1.2 3l-84 91c-1.2 1.3-2.9 2-4.6 2c-3.5 0-6.3-2.8-6.3-6.3l0-41.7c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16l0-41.7c0-3.5 2.8-6.3 6.3-6.3c1.7 0 3.4 .7 4.6 2l84 91z"]
};
var faArrowAltCircleRight = faCircleRight;
var faPlaneCircleCheck = {
  prefix: 'fal',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSeal = {
  prefix: 'fal',
  iconName: 'seal',
  icon: [512, 512, [], "e241", "M199.1 86.6c-6 6-14.1 9.4-22.6 9.4H112c-8.8 0-16 7.2-16 16v64.5c0 8.5-3.4 16.6-9.4 22.6L41 244.7c-6.2 6.2-6.2 16.4 0 22.6L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6c18.7-18.7 49.1-18.7 67.9 0L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48H335.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48V335.5L18.4 289.9 41 267.3l45.6 45.6c6 6 9.4 14.1 9.4 22.6V400c0 8.8 7.2 16 16 16h64.5c8.5 0 16.6 3.4 22.6 9.4L244.7 471c6.2 6.2 16.4 6.2 22.6 0l45.6-45.6c6-6 14.1-9.4 22.6-9.4H400c8.8 0 16-7.2 16-16V335.5c0-8.5 3.4-16.6 9.4-22.6L471 267.3c6.2-6.2 6.2-16.4 0-22.6l-45.6-45.6c-6-6-9.4-14.1-9.4-22.6V112c0-8.8-7.2-16-16-16H335.5c-8.5 0-16.6-3.4-22.6-9.4L267.3 41c-6.2-6.2-16.4-6.2-22.6 0L199.1 86.6z"]
};
var faUserCowboy = {
  prefix: 'fal',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M176.1 32c4.8 0 7.3 .6 8.5 1c1 .3 1.9 .8 3.6 1.8c.1 .1 .4 .3 .7 .5l0 0C192.3 37.9 205.8 48 224 48s31.7-10.1 35.1-12.7c.3-.3 .6-.4 .7-.5c1.6-1.1 2.5-1.5 3.6-1.8c1.1-.4 3.6-1 8.5-1c.6 .2 3 1.2 7 5.7c5.8 6.6 12 17.3 18.1 31.9c6.5 15.4 11.9 33 16.3 50.1c-25 5-54.6 8.3-89.3 8.3s-64.4-3.2-89.3-8.3c4.4-17.1 9.8-34.7 16.3-50.1c6.1-14.6 12.4-25.3 18.1-31.9c4-4.6 6.3-5.6 7-5.7zm168.3 80C330.8 59.3 307.6 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1s-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-35.6 0-58.8 59.3-72.4 112c-7.1-2.2-13.7-4.5-19.8-6.9c-32.4-12.7-49.4-27.2-55-34.7c-4.7-6.3-13.3-8.2-20.2-4.6S-1.7 77.6 .8 85.1c9.3 27.9 35 62.4 72.5 89.9c38 27.7 89.2 49.1 150.6 49.1s112.7-21.4 150.6-49.1c37.6-27.4 63.2-62 72.5-89.9c2.5-7.4-.8-15.6-7.8-19.2s-15.5-1.7-20.2 4.6c-5.6 7.5-22.6 22-55 34.7c-6.1 2.4-12.7 4.7-19.8 6.9zM271.7 32a.1 .1 0 1 0 .1 .1 .1 .1 0 1 0 -.1-.1zm-95.6 0a.1 .1 0 1 0 .3 .1 .1 .1 0 1 0 -.3-.1zM92.2 149.1c-5.5-4-10.7-8.2-15.5-12.4C112.4 149.9 160.9 160 224 160s111.6-10.1 147.3-23.4c-4.8 4.2-10 8.4-15.5 12.4C322.5 173.4 277.8 192 224 192s-98.5-18.6-131.8-42.9zM100.7 416H347.3c32.3 0 59.5 24 63.5 56.1l1 7.9H36.2l1-7.9c4-32 31.2-56.1 63.5-56.1zm0-32c-48.4 0-89.3 36.1-95.3 84.1l-1 7.9C2.1 495.1 17 512 36.2 512H411.8c19.2 0 34.1-16.9 31.8-36l-1-7.9c-6-48-46.8-84.1-95.3-84.1H100.7zM224 352c70 0 126.9-56.2 128-126c-10.5 5.2-21.6 10-33.3 14.1C311 285.4 271.5 320 224 320s-87-34.6-94.7-79.9C117.7 236 106.5 231.3 96 226c1.1 69.8 58 126 128 126z"]
};
var faHexagonVerticalNft = {
  prefix: 'fal',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", "M255.8 496.6c-19.8 11.4-44.2 11.4-64 0L32 404.3C12.2 392.9 0 371.7 0 348.9V164.3c0-22.9 12.2-44 32-55.4L191.8 16.6c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4V348.9c0 22.9-12.2 44-32 55.4L255.8 496.6zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7V164.3c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7l0 184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM94.7 170.6l33.1 82.9V176.6c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L95.8 259.7v76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80-80zm112-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceRollingEyes = {
  prefix: 'fal',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96c26.5 0 48-21.5 48-48c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48s48-21.5 48-48zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faMehRollingEyes = faFaceRollingEyes;
var faBreadLoaf = {
  prefix: 'fal',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", "M64 224c-17.7 0-32-14.3-32-32c0-45.8 30.4-77.3 77.4-98.9C156.4 71.4 211.6 64 240 64s83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16V256c0-17.7-14.3-32-32-32zm352 32H544V432c0 8.8-7.2 16-16 16H413.3c1.8-5 2.7-10.4 2.7-16V288 256zm155.3-31.7c-1.1-.2-2.2-.3-3.3-.3H471.4c5.4-9.4 8.6-20.3 8.6-32c0-64-44-104-96-128h16c28.4 0 83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32c-1.6 0-3.2 .1-4.7 .3zM112 480H320h48H528c26.5 0 48-21.5 48-48V288 256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H272 240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v32V432c0 26.5 21.5 48 48 48z"]
};
var faRingsWedding = {
  prefix: 'fal',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M137.9 32l-8 16 24 48H176h22.1l24-48-8-16H137.9zM254.3 55.2l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 64.4-34.5 120.7-86.1 151.3c-8.6-6.9-16.1-15-22.4-24.1C289 375 320 327.1 320 272c0-27.5-7.7-53.3-21.1-75.2C237.3 213.2 192 269.3 192 336c0 27.5 7.7 53.3 21.1 75.2c6 9.8 13.2 18.8 21.3 26.9c0 0 0 0 0 0C260.5 464 296.4 480 336 480c79.5 0 144-64.5 144-144c0-67.9-47-124.9-110.3-140c-4.9-12.4-10.9-24.2-17.9-35.3C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32C116.4 3.4 121.9 0 128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3zM179.2 416c-12.3-24-19.2-51.2-19.2-80c0-76.7 49.1-142 117.6-166.1C251.5 144 215.6 128 176 128C96.5 128 32 192.5 32 272s64.5 144 144 144c1.1 0 2.1 0 3.2 0z"]
};
var faObjectGroup = {
  prefix: 'fal',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M64 125.3C45.4 118.7 32 100.9 32 80c0-26.5 21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H450.7c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48c0 20.9-13.4 38.7-32 45.3V386.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32H125.3c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V125.3zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zM496 416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 80A16 16 0 1 0 64 80a16 16 0 1 0 32 0zm80 48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48zm-16 48v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm192 64c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16-7.2-16-16z"]
};
var faFrenchFries = {
  prefix: 'fal',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3V266.4c-8.5 2.4-19 4.3-32 5.1V57.9l-32-16V271.5c-13-.9-23.5-2.7-32-5.1V16c0-5.5 2.9-10.7 7.6-13.6zM279.1 233.8c-1 4-2.9 9-7.1 14.1V208.6L299.1 84.5 272 89.9V57.3l44.9-9c5.3-1.1 10.8 .6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zM362.6 192H332.5l19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8l-18.6 92.9c-.8 0-1.7-.1-2.5-.1zM21.4 192c-.9 0-1.7 0-2.5 .1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3s17.1 3.9 18.8 12.6L51.5 192H21.4zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7c-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1V53.9L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zM89.2 480H294.8l54.3-224h-9.8c-5.3 16.4-16.3 35.8-38.2 51.6C276.4 325.3 241.1 336 192 336s-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256H34.9L89.2 480zm-31.1 7.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H54.3c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304s112.4-39 118.2-62.5c2.3-9.2 10-17.5 19.5-17.5h32.9c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5z"]
};
var faChartLine = {
  prefix: 'fal',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM475.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z"]
};
var faLineChart = faChartLine;
var faCalendarArrowDown = {
  prefix: 'fal',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM240 256c0-8.8-7.2-16-16-16s-16 7.2-16 16V377.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 377.4V256z"]
};
var faCalendarDownload = faCalendarArrowDown;
var faSendBack = {
  prefix: 'fal',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", "M192 32c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192zM64 0C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM576 288c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32H576zM448 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zM160 288v64c0 35.3 28.7 64 64 64H352V384H224c-17.7 0-32-14.3-32-32V288H160zM416 96H288v32H416c17.7 0 32 14.3 32 32v64h32V160c0-35.3-28.7-64-64-64zM152 96c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V104c0-4.4 3.6-8 8-8h48zM104 64c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40H104zM488 352h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H488c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V360c0-22.1-17.9-40-40-40H488c-22.1 0-40 17.9-40 40z"]
};
var faMaskVentilator = {
  prefix: 'fal',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M160 300.8c0 44.6 21.7 85.6 56.9 112.9c-5.7-13.6-8.9-28.6-8.9-44.3c0-30.2 11.8-69.3 30.3-100.8c9.3-15.9 20.8-30.7 34.2-41.7c13.4-11 29.5-18.8 47.5-18.8c18 0 34 7.9 47.3 18.8s24.8 25.8 34.2 41.7C420 300 432 339.1 432 369.3c0 15.6-3.1 30.4-8.8 43.9C458.1 386 480 345.4 480 300.8c0-42-19.2-103.3-51.6-154.3C395 93.9 355.3 64 320 64c-35.8 0-75.5 30-108.7 82.4C179 197.4 160 258.8 160 300.8zm80 68.5c0 26.6 12.5 50.1 32 64.9v40.2c-51.6-12.3-94.5-43.9-119.7-86L83.5 370.3C34.3 357.4 0 312.9 0 262V176c0-26.5 21.5-48 48-48H185.1C219.8 73.8 267.4 32 320 32c52.1 0 99.7 41.8 134.5 96H592c26.5 0 48 21.5 48 48v86c0 50.9-34.3 95.4-83.5 108.3l-69 18.2C462.1 430.6 419 462 368 474.3V434c19.3-14.7 32-38 32-64.7c0-23.3-9.8-56.8-26.1-84.6c-8.1-13.7-17.3-25.3-26.9-33.2s-18.7-11.5-27-11.5c-8.4 0-17.6 3.6-27.2 11.5c-9.6 7.9-18.8 19.4-26.9 33.2C249.7 312.4 240 346 240 369.3zm264.4-18.4l43.9-11.6c35.1-9.2 59.6-41 59.6-77.4V176c0-8.8-7.2-16-16-16H472.9C497.4 207.8 512 260.3 512 300.8c0 17.4-2.7 34.3-7.6 50.1zM166.8 160H48c-8.8 0-16 7.2-16 16v86c0 36.3 24.5 68.1 59.6 77.4l43.9 11.6c-4.9-15.9-7.5-32.7-7.5-50.1c0-40.5 14.4-93 38.8-140.8zM304 320c0-8.8 7.2-16 16-16s16 7.2 16 16V512H304V320z"]
};
var faSignatureLock = {
  prefix: 'fal',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", "M64 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L59 243.7c-34.8 9.5-59 41.1-59 77.2v92.6C0 450.2 29.8 480 66.5 480c24 0 46.2-13 57.9-33.9L151.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h88.6c5.6-9.7 13.7-17.8 23.4-23.4V288H329.9l52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3L218.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V128zM240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H384V384H240zM67.4 274.6l109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4L96.5 430.4C90.4 441.3 78.9 448 66.5 448c-19 0-34.5-15.4-34.5-34.5V320.9c0-21.6 14.5-40.6 35.4-46.3zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80V480H448V352H608z"]
};
var faArrowRight = {
  prefix: 'fal',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z"]
};
var faSignsPost = {
  prefix: 'fal',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M240 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32H440.3c4.9 0 9.5 2.2 12.5 6L504 102c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6H272v32H448c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H71.7c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6H240V192H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H240V16zM432.6 64H64v96H432.6L471 112 432.6 64zM79.4 256L41 304l38.4 48H448V256H79.4z"]
};
var faMapSigns = faSignsPost;
var faOctagonPlus = {
  prefix: 'fal',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM240 352V272H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faPlusOctagon = faOctagonPlus;
var faCashRegister = {
  prefix: 'fal',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M272 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H272zM80 0C53.5 0 32 21.5 32 48V80c0 26.5 21.5 48 48 48h80v32H87.5c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V388.5c0-3-.2-6.1-.6-9L487.8 214.9c-4.5-31.5-31.5-54.9-63.4-54.9H192V128h80c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H80zM32 448V416H480v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM456.2 219.5L479.7 384H32.3L55.8 219.5C58.1 203.7 71.6 192 87.5 192h337c15.9 0 29.4 11.7 31.7 27.5zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faPersonCircleQuestion = {
  prefix: 'fal',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6l-23.7 12.5c-1.4 7.4-7.9 12.9-15.7 12.9c-8.8 0-16-7.2-16-16v-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9H409.6c-5.3 0-9.6 4.3-9.6 9.6V336c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.4z"]
};
var faMelonSlice = {
  prefix: 'fal',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L322.6 86.8c-3.6 3.6-5.2 8.6-4.5 13.6c1.3 9 2 18.2 2 27.6c0 106-86 192-192 192c-9.4 0-18.6-.7-27.6-2c-5-.7-10 1-13.6 4.5L4.7 404.7c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512h4C378.2 512 512 378.2 512 213.2v-4c0-76.7-30.5-150.2-84.7-204.5zM391 63.7L415.6 39C457 85.8 480 146.3 480 209.1v4C480 360.5 360.5 480 213.2 480h-4C146.3 480 85.8 457 39 415.6L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232c0-58.3-21.5-111.6-57-152.3zM368.3 86.3C398 121.3 416 166.5 416 216c0 110.5-89.5 200-200 200c-49.5 0-94.7-18-129.7-47.7l17.6-17.6c7.9 .8 16 1.3 24.1 1.3c123.7 0 224-100.3 224-224c0-8.1-.4-16.2-1.3-24.1l17.6-17.6z"]
};
var faSpaceStationMoon = {
  prefix: 'fal',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8l0 0c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zM256 369.4c104.8 0 169.6-18.7 208.8-32.3C432.3 420.8 351.1 480 256 480s-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM136 160a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMessageSmile = {
  prefix: 'fal',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM155.9 252.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 302.5 215.7 320 256 320s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3C314.5 274.6 286.8 288 256 288s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z"]
};
var faCommentAltSmile = faMessageSmile;
var faCupStraw = {
  prefix: 'fal',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M249 0c-22 0-41.2 15-46.6 36.4L179.5 128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H191.7c.2 0 .5 0 .7 0H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H212.5l21-83.9C235.2 37 241.6 32 249 32h23c8.8 0 16-7.2 16-16s-7.2-16-16-16H249zM37.3 192l23 276c2.1 24.9 22.9 44 47.8 44H275.8c25 0 45.8-19.1 47.8-44l23-276H314.6L291.8 465.3c-.7 8.3-7.6 14.7-15.9 14.7H108.2c-8.3 0-15.3-6.4-15.9-14.7L69.4 192H37.3z"]
};
var faLeftFromLine = {
  prefix: 'fal',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", "M32.8 257.8c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L164.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L32.8 257.8zM0 256c0 9.5 3.9 18.6 10.8 25.1L142.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L10.8 230.9C3.9 237.4 0 246.5 0 256zM448 432l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faArrowAltFromRight = faLeftFromLine;
var faH = {
  prefix: 'fal',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M352 256l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-240V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V224L32 224 32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 320 0z"]
};
var faBasketShoppingSimple = {
  prefix: 'fal',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M322.2 24.1c-4.5-7.6-1.9-17.4 5.8-21.9s17.4-1.9 21.9 5.8L457.2 192H511h33 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H536L476.1 463.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L40 224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32 65h53.8L226.2 7.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9L155.9 192H420.1l-98-167.9zM503 224H73l57.9 231.8c3.6 14.2 16.4 24.2 31 24.2H414c14.7 0 27.5-10 31-24.2L503 224zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faShoppingBasketAlt = faBasketShoppingSimple;
var faHandsHoldingHeart = {
  prefix: 'fal',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M195.9 28.9C223.7 .7 267.8-.8 297.3 24.3c5.8 4.9 11 10.4 16.3 15.9c2.1 2.2 4.2 4.5 6.4 6.6c2.1-2.2 4.3-4.4 6.4-6.6c5.2-5.5 10.5-11 16.3-15.9C372.2-.8 416.3 .7 444.1 28.9c29.4 29.8 29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L195.9 136.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0c-17.1 17.4-17.1 45.7 0 63.1L320 217.3 421.3 114.4c17.1-17.4 17.1-45.7 0-63.1c-16.8-17.1-44-17.1-60.8 0L331.4 80.9c-6.3 6.4-16.5 6.4-22.8 0L279.5 51.4zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faHandsHeart = faHandsHoldingHeart;
var faClockNine = {
  prefix: 'fal',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTarp = {
  prefix: 'fal',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", "M32 384l0-256c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32V256H432c-26.5 0-48 21.5-48 48l0 112L64 416c-17.7 0-32-14.3-32-32zm391.4 27.3c-2.1 2.1-4.6 3.5-7.4 4.2L416 304c0-8.8 7.2-16 16-16H543.5c-.7 2.8-2.1 5.4-4.2 7.4L423.4 411.3zM576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l348.1 0c12.7 0 24.9-5.1 33.9-14.1L561.9 318.1c9-9 14.1-21.2 14.1-33.9V128zM96 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFaceSleepy = {
  prefix: 'fal',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c31.9 0 62.2-6.7 89.6-18.6c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1C327 504.4 292.4 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 23.6-3.2 46.5-9.2 68.3c-2.4 8.5-11.2 13.5-19.7 11.2s-13.5-11.2-11.2-19.7c5.2-19 8.1-39 8.1-59.7C480 132.3 379.7 32 256 32zm64.3 285c1.4-7.5 8-13 15.7-13c27.8 0 70.8 13.3 106.7 36.6C478.5 363.7 512 399.9 512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-16.2-.1-39.4-7.2-61.5c-6.9-21.5-20.2-41.1-46.7-51.7c-7.1-2.8-11.2-10.3-9.8-17.9zm76 34.8c4.7 8.1 8.3 16.5 11 25c8.8 27.2 8.8 54.9 8.8 70.8v.5c0 17.7 14.3 32 32 32s32-14.3 32-32c0-31.9-22.5-59.7-54.7-80.6c-9.4-6.1-19.3-11.3-29.1-15.7zm-87.3 78c-16.2-6.1-34-9.4-52.9-9.4c-18.8 0-36.7 3.4-52.9 9.4c-11.2 4.2-23.6 2.3-32.4-4.5c-4.5-3.5-8.4-8.6-10-15.1c-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336c40.1 0 75.2 22.1 92.5 54.7c3.2 6 4.3 12.8 2.7 19.5c-1.6 6.5-5.5 11.6-10 15.1c-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2c18.5-6.4 38.6-9.8 59.6-9.8c21 0 41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2z"]
};
var faHandHorns = {
  prefix: 'fal',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M88 32c13.3 0 24 10.7 24 24V200v40H80c-5.5 0-10.8 .6-16 1.6V56c0-13.3 10.7-24 24-24zm56 117.4V56c0-30.9-25.1-56-56-56S32 25.1 32 56V256C12.6 270.6 0 293.8 0 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V240 120c0-30.9-25.1-56-56-56s-56 25.1-56 56v61.4c-7.3-3.5-15.4-5.4-24-5.4c-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zm0 50.6c0-13.3 10.7-24 24-24s24 10.7 24 24v31.9c0 0 0 0 0 .1v13.4c-7.3-3.5-15.4-5.4-24-5.4H144V200zm80 72V232c0-13.2 10.8-24 24-24c13.3 0 24 10.7 24 24v8 56c0 13.3-10.7 24-24 24s-24-10.7-24-24v0l0-24zm-112 0v0h32v0h24c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56V240v-8V120c0-13.3 10.7-24 24-24s24 10.7 24 24V240 352c0 70.7-57.3 128-128 128H160C89.3 480 32 422.7 32 352V320c0-26.5 21.5-48 48-48h32z"]
};
var faScrewdriverWrench = {
  prefix: 'fal',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", "M64.7 34.6L160 107.9V160H107.9L34.6 64.7 64.7 34.6zM192 169.3c0-.4 0-.9 0-1.3V104c0-7.5-3.5-14.5-9.4-19L78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h64c.4 0 .9 0 1.3 0L271.2 293.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0L480 416l-64 64L304 368c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6c-25.7 0-46.6-20.8-46.6-46.6c0-12.3 4.9-24.2 13.6-32.9L189.1 257l-23.1-23.1L23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C296.1 0 246.9 28.6 218.3 72.1l26 20C266.8 56.3 306.7 32.6 352 32.6c10.3 0 20.2 1.2 29.7 3.5L333.6 84.2c-9.1 9.1-14.2 21.5-14.2 34.4V144c0 26.9 21.8 48.6 48.6 48.6h25.4c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z"]
};
var faTools = faScrewdriverWrench;
var faArrowsToEye = {
  prefix: 'fal',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M43.3 20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L105.4 128H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4L43.3 20.7zm553.4 0L512 105.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H534.6l84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM320 368c-77.3 0-132.6-65-156.7-112c24.1-47 79.4-112 156.7-112s132.6 65 156.7 112C452.6 303 397.3 368 320 368zm0-256c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM596.7 491.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L534.6 384H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H496c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V406.6l84.7 84.7zm-576-22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L128 406.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L20.7 468.7zM272 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faCircleThreeQuarters = {
  prefix: 'fal',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 288c-17.7 0-32-14.3-32-32V34.3C115.5 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.5 221.7-192H256zM224.1 2C241.6-.2 256 14.3 256 32V224v32h32H480c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512C114.6 512 0 397.4 0 256C0 125.4 97.8 17.7 224.1 2z"]
};
var faTrophyStar = {
  prefix: 'fal',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", "M400 32H176c-9 0-15.4 7.3-15.1 15c6.2 163.9 44.9 239.2 76.1 273.5c15.5 17.1 29.9 24.8 39.3 28.3c4.8 1.8 8.5 2.6 10.6 3c.5 .1 .9 .1 1.2 .2c.3 0 .7-.1 1.2-.2c2.1-.3 5.8-1.1 10.6-3c9.4-3.5 23.8-11.3 39.3-28.3c31.2-34.2 69.8-109.6 76.1-273.5c.3-7.8-6.2-15-15.1-15zM176 0H400c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8H528c26 0 49.3 21.6 46.2 49.7c-10.1 94-61.9 158.2-118.1 199.9c-55.9 41.4-117.1 61.3-149.3 66.9l-.1-.3c-.9 .3-1.8 .6-2.7 .8V480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V381.1c-.9-.3-1.8-.5-2.7-.8l-.1 .3c-32.2-5.7-93.4-25.5-149.3-66.9C63.7 272 11.9 207.7 1.8 113.7C-1.3 85.6 22 64 48 64h81.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM377.8 323.2c19.2-9.1 39.6-20.7 59.2-35.3c51.1-37.9 96.4-94.8 105.4-177.6c.8-7-5.1-14.3-14.4-14.3H444.2c-9.8 116.5-37.2 185.9-66.4 227.2zM131.8 96H48c-9.3 0-15.2 7.3-14.4 14.3C42.5 193.2 87.9 250.1 139 287.9c19.6 14.6 40 26.2 59.2 35.3C169 281.9 141.5 212.5 131.8 96zm177.8-.5L322.1 121l28.2 4.1c19.7 2.9 27.5 27.1 13.3 40.9l-20.4 19.9 4.8 28.1c3.4 19.6-17.2 34.6-34.8 25.3L288 226.1l-25.2 13.3c-17.6 9.3-38.2-5.7-34.8-25.3l4.8-28.1-20.4-19.9c-14.2-13.9-6.4-38.1 13.3-40.9l28.2-4.1 12.6-25.6c8.8-17.8 34.2-17.8 43 0zm-28.8 43.5c-3.5 7.1-10.3 12-18.1 13.1l-16.3 2.4L258.1 166c5.7 5.5 8.2 13.5 6.9 21.2l-2.8 16.3 14.6-7.7c7-3.7 15.3-3.7 22.3 0l14.6 7.7L311 187.2c-1.3-7.8 1.2-15.7 6.9-21.2l11.8-11.5-16.3-2.4c-7.8-1.1-14.6-6-18.1-13.1L288 124.2l-7.3 14.8z"]
};
var faTrophyAlt = faTrophyStar;
var faPlugCircleBolt = {
  prefix: 'fal',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H452.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faFaceThermometer = {
  prefix: 'fal',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", "M288 32C164.3 32 64 132.3 64 256s100.3 224 224 224c95.3 0 176.7-59.5 209.1-143.4c3.2-8.2 12.4-12.4 20.7-9.2s12.4 12.4 9.2 20.7C490 444 396.9 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c83.8 0 158.1 40.2 204.8 102.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2C426.3 67.2 361.3 32 288 32zM402.5 396.1c-6.7 5.8-16.8 5.1-22.6-1.6C362 373.8 331.4 352 288 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5c13.5 0 26 1.7 37.5 4.6L477 179.4c19.6-18.8 50.6-18.4 69.8 .7c19.8 19.8 19.4 52.1-.9 71.4L408 382.9c.3 4.8-1.5 9.8-5.5 13.2zm-43.9-58.9c11.3 5.9 21.1 13 29.6 20.3l8.4-8-5.1-5.1c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0L414 333l15.4-14.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3L358.5 337.2zM208.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faGridRound4 = {
  prefix: 'fal',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M44.8 56a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zm44.8 98.7a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM65.6 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM185.1 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM304.5 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z"]
};
var faShirtRunning = {
  prefix: 'fal',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M80 0c8.8 0 16 7.2 16 16V64c0 53 43 96 96 96s96-43 96-96V16c0-8.8 7.2-16 16-16s16 7.2 16 16c0 134.3 29.3 192.6 45.6 214.6c8.9 12 18.4 28.6 18.4 47.6V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V278.2c0-19 9.5-35.7 18.4-47.6C34.7 208.6 64 150.3 64 16C64 7.2 71.2 0 80 0zM44.1 249.6c-7.6 10.2-12.1 20-12.1 28.6V396.3L310.6 195l1.4-1c-5.5-15.9-10.5-34.9-14.6-57.5C274.4 170 235.8 192 192 192s-82.4-22-105.5-55.5c-10.7 59.8-28.4 94.1-42.4 113.1zM32 435.7V456c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24V278.2c0-8.6-4.6-18.4-12.1-28.6c-4.8-6.5-10-14.7-15.2-25.2L41.4 429 32 435.7z"]
};
var faBookCircleArrowUp = {
  prefix: 'fal',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H394.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H326.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V211.2c10.1-5.2 20.8-9.4 32-12.6V48c0-26.5-21.5-48-48-48H64zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0L480 342.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V342.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faFaceNauseated = {
  prefix: 'fal',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM175.6 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm160 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-26.9-60.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM146.2 272.6c4.4-7.6 14.2-10.3 21.9-5.8c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3H206.4c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9z"]
};
var faHeart = {
  prefix: 'fal',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2L443 275.5c23.6-22 37-52.8 37-85.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zm34.9-57.1C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 36-13.1 70.6-36.6 97.5c-3.4 3.8-6.9 7.5-10.7 11l-184 171.3c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5z"]
};
var faFileChartPie = {
  prefix: 'fal',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM176 224v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16c0-61.9-50.1-112-112-112c-8.8 0-16 7.2-16 16zm32 17.6c31.3 6.4 56 31.1 62.4 62.4H208V241.6zm-56-21C105.7 234.4 72 277.3 72 328c0 61.9 50.1 112 112 112c50.7 0 93.6-33.7 107.4-80h-34c-12.3 28.3-40.5 48-73.3 48c-44.2 0-80-35.8-80-80c0-32.8 19.7-61 48-73.3v-34z"]
};
var faMarsAndVenus = {
  prefix: 'fal',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M352 16c0 8.8 7.2 16 16 16h73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64C167.6 64 96 135.6 96 224c0 83 63.1 151.2 144 159.2V416H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faHouseUser = {
  prefix: 'fal',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", "M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM208 392v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-39.8 32.2-72 72-72h80c39.8 0 72 32.2 72 72v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-22.1-17.9-40-40-40H248c-22.1 0-40 17.9-40 40z"]
};
var faHomeUser = faHouseUser;
var faCircleArrowDownLeft = {
  prefix: 'fal',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm56-160H176c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16V297.4L324.7 164.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 320H312c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faDumpsterFire = {
  prefix: 'fal',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M423.4 32c.2 0 .4 0 .6 0h95c14.7 0 27.5 10 31 24.2l18.5 74c-10.5-5.9-22.7-7.5-34.2-4.7L519 64l-76 0 6.1 32.3c-10.7-1.3-21.8 1.2-31.2 7.3L410.4 64 304 64v96h58c-8.8 10.6-17 21.3-24.5 32H288l-159.7 0h-.6H66 33.8 28.5C12.8 192 0 179.2 0 163.5c0-2.3 .3-4.7 .9-6.9L25.9 56.2C29.5 42 42.3 32 57 32h94.7c.2 0 .4 0 .6 0H288l0 0 0 0H423.4zM337.6 448H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448.9L45.1 288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H41.3l-3.8-32H69.8L92.3 416H314.4c6.6 11.4 14.4 22.2 23.2 32zM272 64L165.3 64l-18 96H272V64zM132.7 64L57 64 33 160H47.8h.4 66.5l18-96zM509.4 221.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C352 390.5 408.2 448 480 448c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 408 568.7 480 480 480c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM445.1 224c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C521.3 410 502.3 416 481 416c-25.9 0-50.2-8.4-68.2-24.8C394.7 374.6 384 350.7 384 322c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L507 319l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C445.7 377.9 461.9 384 481 384c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faHexagonMinus = {
  prefix: 'fal',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMinusHexagon = faHexagonMinus;
var faLeftToLine = {
  prefix: 'fal',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", "M32 432L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16zm96.8-174.2c-.5-.5-.8-1.1-.8-1.8s.3-1.4 .8-1.8L260.7 129.8c1.2-1.2 2.9-1.8 4.6-1.8c3.7 0 6.7 3 6.7 6.7l0 57.3c0 8.8 7.2 16 16 16l120 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-120 0c-8.8 0-16 7.2-16 16l0 57.3c0 3.7-3 6.7-6.7 6.7c-1.7 0-3.3-.6-4.6-1.8L128.8 257.8zM96 256c0 9.5 3.9 18.6 10.8 25.1L238.8 405.5c7.2 6.8 16.7 10.5 26.5 10.5c21.4 0 38.7-17.3 38.7-38.7l0-41.3 104 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-104 0 0-41.3c0-21.4-17.3-38.7-38.7-38.7c-9.9 0-19.3 3.8-26.5 10.5L106.8 230.9C99.9 237.4 96 246.5 96 256z"]
};
var faArrowAltToLeft = faLeftToLine;
var faHouseCrack = {
  prefix: 'fal',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H312.6l-50.4-75.6 82.7-55.1c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l82.2 82.2-79.8 53.2c-7.4 4.9-9.3 14.8-4.4 22.2L274.1 480H144c-26.5 0-48-21.5-48-48z"]
};
var faPawSimple = {
  prefix: 'fal',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M152 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm31.2 73.2c7.7-15.5 23.5-25.2 40.8-25.2s33.1 9.8 40.8 25.2l33.8 67.5c8.3 16.5 23.1 25.9 36.8 30c28.1 8.4 48.6 34.4 48.6 65.2c0 37.6-30.4 68-68 68c-14.4 0-27.7-4.5-38.7-12.1c-16-11.1-36.5-14.7-53.3-14.7s-37.3 3.6-53.3 14.7c-11 7.6-24.3 12.1-38.7 12.1c-37.6 0-68-30.4-68-68c0-30.8 20.4-56.8 48.6-65.2c13.7-4.1 28.6-13.5 36.8-30l33.8-67.5zm-62.4 53.2c-3.4 6.9-10 11.5-17.3 13.7C62.1 296.4 32 334.7 32 380c0 55.2 44.8 100 100 100c21.2 0 40.8-6.6 56.9-17.8c17.4-12 52.8-12 70.1 0C275.2 473.4 294.8 480 316 480c55.2 0 100-44.8 100-100c0-45.3-30.1-83.6-71.4-95.9c-7.4-2.2-13.9-6.8-17.3-13.7l-33.8-67.5c-13.2-26.3-40-42.9-69.5-42.9s-56.3 16.6-69.5 42.9l-33.8 67.5zM272 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 240 88a56 56 0 1 0 112 0zm40 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM32 200a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 0 200a56 56 0 1 0 112 0z"]
};
var faPawAlt = faPawSimple;
var faArrowLeftLongToLine = {
  prefix: 'fal',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M0 80V432c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16S0 71.2 0 80zM132.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272 624 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-441.4 0L299.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z"]
};
var faBracketsRound = {
  prefix: 'fal',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M151.6 62.1C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4s1.3 17.5-6.4 21.7zm208.8 0c-7.8-4.2-10.7-13.9-6.4-21.7s13.9-10.7 21.7-6.4C420.8 58.4 512 136.7 512 256s-91.2 197.6-136.4 222.1c-7.8 4.2-17.5 1.3-21.7-6.4s-1.3-17.5 6.4-21.7C400.5 428.2 480 358.6 480 256s-79.5-172.2-119.6-193.9z"]
};
var faParentheses = faBracketsRound;
var faMartiniGlassCitrus = {
  prefix: 'fal',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", "M432 256c-21.7 0-42-6.2-59.2-16.9l-23.1 23.1C373 278.5 401.4 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C369.3 0 316 40.1 296.2 96h34.6c18-37.8 56.5-64 101.2-64c61.9 0 112 50.1 112 112s-50.1 112-112 112zM16 128c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4L192 342.6V480H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96 96c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V342.6L411.3 155.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H16zm345.4 32L208 313.4 54.6 160H361.4z"]
};
var faCocktail = faMartiniGlassCitrus;
var faUserShakespeare = {
  prefix: 'fal',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M304 160V112c0-44.2-35.8-80-80-80s-80 35.8-80 80v48c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1zM114.1 90.5C124.1 38.9 169.5 0 224 0s99.9 38.9 109.9 90.5c11 8.8 18.1 22.3 18.1 37.5v9.5c0 9.5 2.8 18.7 8.1 26.6l16.7 25.1c4.7 7.1 7.2 15.4 7.2 23.8c0 23.7-19.2 43-43 43H281.7c-16.9 10.2-36.6 16-57.7 16s-40.9-5.8-57.7-16H107c-23.7 0-43-19.2-43-43c0-8.5 2.5-16.8 7.2-23.8l16.7-25.1c5.3-7.9 8.1-17.1 8.1-26.6V128c0-15.2 7.1-28.7 18.1-37.5zm219.7 91.9c-3.1 15.2-9.3 29.3-17.8 41.7H341c6.1 0 11-4.9 11-11c0-2.2-.6-4.3-1.8-6.1l-16.4-24.6zM132.1 224c-8.6-12.3-14.8-26.4-17.8-41.7L97.8 206.9c-1.2 1.8-1.8 3.9-1.8 6.1c0 6.1 4.9 11 11 11h25.1zM176 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM0 481.3c0-69.5 44-128.8 105.7-151.4c13.6-24.9 40-41.8 70.3-41.8h48 48c30.4 0 56.8 16.9 70.3 41.8C404 352.5 448 411.8 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3zM176 320c-26.5 0-48 21.5-48 48v3.6c1.6-.8 3.3-1.5 5.1-2.3c17.6-7.6 42.5-15 74.9-16.9V320H176zm64 32.5c32.5 1.9 57.3 9.3 74.9 16.9c1.8 .8 3.5 1.5 5.1 2.3V368c0-26.5-21.5-48-48-48H240v32.5zM224 384c-35.8 0-61.6 7.5-78.2 14.7c-8.3 3.6-14.4 7.1-18.2 9.7c-1.9 1.3-3.3 2.3-4.1 2.9c-.4 .3-.7 .5-.8 .7l-.1 .1c-4.7 4.1-11.4 5.2-17.1 2.6C99.7 412 96 406.3 96 400V369.7C58.1 391.9 32.5 432.9 32 480l176 0c0-8.8 7.2-16 16-16s16 7.2 16 16l176 0c-.5-47.1-26-88.1-64-110.3V400c0 6.3-3.7 12-9.5 14.6c-5.7 2.6-12.4 1.5-17.1-2.6l0 0 0 0-.1-.1-.3-.2-.6-.4c-.8-.6-2.2-1.6-4.1-2.9c-3.8-2.5-9.9-6.1-18.2-9.7C285.6 391.5 259.8 384 224 384zm-16 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faArrowRightToArc = {
  prefix: 'fal',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M480 256C480 132.3 379.7 32 256 32c-8.8 0-16-7.2-16-16s7.2-16 16-16C397.4 0 512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224zM202.6 116l144 128c3.4 3 5.4 7.4 5.4 12s-2 8.9-5.4 12l-144 128c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6L293.9 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H293.9L181.4 140c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3z"]
};
var faFaceSurprise = {
  prefix: 'fal',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faSurprise = faFaceSurprise;
var faBottleWater = {
  prefix: 'fal',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M128 96h2.7 58.6H192V32H128V96zm-32 6.3V96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V96v6.3c6.4 2.4 12.6 5.5 18.4 9.2l13.6 8.6c20 12.7 32.1 34.8 32.1 58.5c0 10.9-2.5 21.2-7 30.4c4.5 9.4 7 19.9 7 31c0 11.5-2.7 22.3-7.5 32c4.8 9.7 7.5 20.5 7.5 32s-2.7 22.3-7.5 32c4.8 9.7 7.5 20.5 7.5 32c0 13.1-3.5 25.4-9.6 36c6.1 10.6 9.6 22.9 9.6 36c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-13.1 3.5-25.4 9.6-36c-6.1-10.6-9.6-22.9-9.6-36c0-11.5 2.7-22.3 7.5-32c-4.8-9.7-7.5-20.5-7.5-32s2.7-22.3 7.5-32c-4.8-9.7-7.5-20.5-7.5-32c0-11.1 2.5-21.6 7-31c-4.5-9.2-7-19.5-7-30.4c0-23.7 12.1-45.8 32.1-58.5l13.6-8.6c5.8-3.7 12-6.8 18.4-9.2zM130.7 128c-12.7 0-25.1 3.6-35.9 10.5l-13.6 8.6C70.5 154 64 165.8 64 178.6c0 8.6 2.9 16.5 7.7 22.8c3.2 4.2 3.3 10.5 .2 14.7c-5 6.7-7.9 14.9-7.9 23.9c0 9.3 3.1 17.8 8.4 24.6c3.3 4.2 3.3 10.7 0 14.9C67.1 286.2 64 294.7 64 304s3.1 17.8 8.4 24.6c3.3 4.2 3.3 10.7 0 14.9C67.1 350.2 64 358.7 64 368c0 9.9 3.6 19 9.6 26c4.3 5.1 4.3 14.9 0 20c-6 7-9.6 16.1-9.6 26c0 22.1 17.9 40 40 40H216c22.1 0 40-17.9 40-40c0-9.9-3.6-19-9.6-26c-4.3-5.1-4.3-14.9 0-20c6-7 9.6-16.1 9.6-26c0-9.3-3.1-17.8-8.4-24.6c-3.3-4.2-3.3-10.7 0-14.9c5.3-6.8 8.4-15.3 8.4-24.6s-3.1-17.8-8.4-24.6c-3.3-4.2-3.3-10.7 0-14.9c5.3-6.8 8.4-15.3 8.4-24.6c0-8.9-2.9-17.2-7.9-23.9c-3.1-4.2-3-10.6 .2-14.7c4.8-6.3 7.7-14.2 7.7-22.8c0-12.8-6.5-24.7-17.3-31.5l-13.6-8.6C214.5 131.6 202 128 189.3 128H130.7zM96 240c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm16 112h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCirclePause = {
  prefix: 'fal',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-80V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPauseCircle = faCirclePause;
var faGaugeCirclePlus = {
  prefix: 'fal',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFolders = {
  prefix: 'fal',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M512 352H160c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H277.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c18 18 42.4 28.1 67.9 28.1H512c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32zM349.3 77.3L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faAngel = {
  prefix: 'fal',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M384 64.2c0 .1-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2s0 .1 0 .2zM288 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM45.3 480C38 480 32 474 32 466.7c0-2.1 .5-4.1 1.4-5.9l39.8-79.7c4.4-8.9 6.8-18.7 6.8-28.6v-.9c0-9.9-2.3-19.7-6.8-28.6L54.9 286.2c-4.5-9-6.9-19.1-6.9-29.3c0-35.8 29-64.9 64.2-64.9c17 0 33.3 6.8 45.4 18.8l67 67c-12 9.3-22.1 21.4-29.1 35.5L112 480H45.3zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3H96h35.8H444.2 480h50.7c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm97.7 15.9l67-67c12-12 28.4-18.8 45.4-18.8c35.1 0 64.2 29.1 64.2 64.9c0 10.2-2.4 20.3-6.9 29.3l-18.4 36.7c-4.4 8.9-6.8 18.7-6.8 28.6v.9c0 9.9 2.3 19.7 6.8 28.6l39.8 79.7c.9 1.8 1.4 3.9 1.4 5.9c0 7.3-6 13.3-13.3 13.3H464L380.6 313.2c-7.1-14.1-17.1-26.2-29.1-35.5zm.5 49.8L428.2 480H147.8L224 327.6c12.1-24.2 36.9-39.6 64-39.6s51.9 15.3 64 39.6z"]
};
var faValueAbsolute = {
  prefix: 'fal',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M16 32C7.2 32 0 39.2 0 48V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zM171.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256l-84.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-84.7-84.7zM512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"]
};
var faRabbit = {
  prefix: 'fal',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M324.1 20.8c6.5 9.4 12.1 19.2 16.9 29.5c3.5-4.4 7.2-8.6 11.2-12.6l3.1-3.1c1.7-1.7 4-2.6 6.4-2.6c4.5 0 8.3 3.3 8.9 7.7l.7 4.9c3.3 22.7 1.2 45.6-5.6 66.8c-12.9-4.8-26.7-7.4-40.7-7.5c-6.3-33.2-22.5-64.4-47.4-89l-3.1-3.1L263.3 23.3l11.3-11.4C266.9 4.3 256.5 0 245.7 0C225.3 0 208 15 205.1 35.2l-.7 4.9c-7.6 53 8.6 106.2 43.6 145.9v37.6c-62.8 17.5-113.6 63.7-137.4 123.6C99.5 340.1 86.2 336 72 336c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.4 0 24.1-3.1 34.3-8.7c13.7 24.2 39.6 40.5 69.3 40.7l.3 0 .1 0H304c26.5 0 48-21.5 48-48c0-25.9-20.5-47-46.2-48l21-22.2 55.9 94.6c13.5 22.8 42.9 30.4 65.7 16.9s30.4-42.9 16.9-65.7L380.5 296h7.3c42.1 0 76.3-34.1 76.3-76.3c0-22.9-10.3-44.6-28.1-59.1L399 130.5c-1.5-1.2-3.1-2.5-4.7-3.6c9.8-27.4 13-57.1 8.7-86.8l-.7-4.9C399.4 15 382.1 0 361.7 0c-10.8 0-21.2 4.3-28.9 11.9L329.7 15c-1.9 1.9-3.8 3.9-5.6 5.8zM96.4 439.7C89.6 444.9 81.2 448 72 448c-22.1 0-40-17.9-40-40s17.9-40 40-40c11.2 0 21.4 4.6 28.6 12.1c-3 14.2-4.6 28.9-4.6 43.9v8c0 2.6 .1 5.2 .4 7.7zm140.4-400c.6-4.4 4.4-7.7 8.9-7.7c2.4 0 4.7 .9 6.3 2.6l3.1 3.1c23.4 23.2 37.3 53.5 40.3 85.2c.4 4.6 2.8 8.7 6.5 11.4s8.4 3.7 12.9 2.7c3.1-.7 6.3-1 9.6-1c19.8 0 39 6.8 54.3 19.3l36.9 30.1c10.3 8.4 16.3 21 16.3 34.3c0 24.4-19.8 44.3-44.3 44.3H352.4c-5.7 0-11 3.1-13.9 8.1s-2.8 11.1 .1 16.1l99.1 167.7c4.5 7.6 2 17.4-5.6 21.9s-17.4 2-21.9-5.6L343.6 359.3c-2.6-4.3-7-7.2-12-7.8s-10 1.3-13.4 4.9L257 421c-4.4 4.6-5.6 11.5-3.1 17.3s8.3 9.7 14.7 9.7H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176h0l-.2 0c-26.4-.1-47.8-21.6-47.8-48v-8c0-84.6 59.7-155.3 139.3-172.2c7.4-1.6 12.7-8.1 12.7-15.7V180.4l0-.4c0-4.1-1.5-8.1-4.4-11.2c-31.3-33.1-46-78.8-39.5-124.2l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faToiletPaperSlash = {
  prefix: 'fal',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M581.2 319.4C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0H464 160c-14.1 0-27.5 6.1-39.5 17l25.7 20.3c5.6-4 10.4-5.3 13.8-5.3H432.3c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 11.3-.1 22.1-.4 32.7l31.2 24.6c.8-18 1.2-37 1.2-57.3c0-88.4 35.8-160 80-160s80 71.6 80 160c0 65.6-19.7 122-48 146.7l25.4 20c11.5-11.3 20.8-25.3 27.8-39.3zM368.6 375.9c-8.3 43.2-18.1 71.7-24.8 87.8c-4.3 10.3-14.5 16.3-25.9 16.3H48l0 0c.2-.3 .4-.6 .5-.9c24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-10.4 .4-20.5 1.3-30.3L67.8 138.4c-2.5 17-3.8 35-3.8 53.6c0 80.2-.4 180.8-36.2 257.3c-2.3 4.9-4.7 9.6-7.3 14.3l0 .1c-2.8 4.7-4.3 10-4.5 15.4c-.2 5.8 1.2 11.6 4.2 16.8C25.8 505.8 36.5 512 48 512H317.9c22.3 0 45.4-12.1 55.4-36.1c6.6-15.9 15.5-41.4 23.4-77.9l-28.1-22.2zM481.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM527.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCircleEuro = {
  prefix: 'fal',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 16h24.2c-.7-5-1-10.1-1-15.2c0-5.7 .4-11.3 1.2-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h34.2c18.2-37.9 56.9-64 101.7-64H305c8.8 0 16 7.2 16 16s-7.2 16-16 16H263.9c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H184.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H198.4c14.7 20.3 38.5 33.5 65.5 33.5H305c8.8 0 16 7.2 16 16s-7.2 16-16 16H263.9c-45.4 0-84.5-26.8-102.4-65.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAppleWhole = {
  prefix: 'fal',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M228.6 96H224V91.4C224 58.6 250.6 32 283.4 32H288v4.6C288 69.4 261.4 96 228.6 96zm-18.3 32h18.3c50.5 0 91.4-40.9 91.4-91.4V18.3C320 8.2 311.8 0 301.7 0H283.4C232.9 0 192 40.9 192 91.4v18.3c0 10.1 8.2 18.3 18.3 18.3zM32 288c0-33.8 8-67.7 22.8-92c14.2-23.5 33-36 57.2-36c21 0 48.7 8.4 71.1 17.1c26.2 10.2 55.6 10.2 81.9 0C287.3 168.4 315 160 336 160c24.3 0 43 12.5 57.2 36C408 220.3 416 254.2 416 288c0 57.5-18 106.6-43.6 140.8C346.4 463.5 315 480 288 480c-13.2 0-32-2.7-45.3-5c-12.3-2.2-25-2.2-37.3 0c-13.3 2.3-32.1 5-45.3 5c-27 0-58.4-16.5-84.4-51.2C50 394.6 32 345.5 32 288zM160 512c16.2 0 37.4-3.2 50.8-5.5c8.7-1.5 17.6-1.5 26.3 0c13.5 2.4 34.6 5.5 50.8 5.5c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128C35.7 128 0 211.7 0 288C0 416 80 512 160 512z"]
};
var faAppleAlt = faAppleWhole;
var faKitchenSet = {
  prefix: 'fal',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm143.1-96c-8 72-69 128-143.1 128C64.5 288 0 223.5 0 144S64.5 0 144 0c74.1 0 135.2 56 143.1 128h67.6c6.6-18.6 24.4-32 45.3-32h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H400c-20.9 0-38.7-13.4-45.3-32H287.1zM272 320h16 32V288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V352H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 0h96V288H352v32zm-32 32V464c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V352H320zM496 128H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zM192 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 144a80 80 0 1 1 160 0A80 80 0 1 1 64 144zM0 496c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM160 352v32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm0-32h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16h80 16 16zm-32 64V352H64v64h64V384z"]
};
var faDiamondHalf = {
  prefix: 'fal',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", "M227.7 11.7C235.5 3.9 245.8 0 256 0V32 480v32c-10.2 0-20.5-3.9-28.3-11.7l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM224 451.3V60.7L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L224 451.3z"]
};
var faLockKeyhole = {
  prefix: 'fal',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", "M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm160 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V312z"]
};
var faLockAlt = faLockKeyhole;
var faR = {
  prefix: 'fal',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M48 32C21.5 32 0 53.5 0 80V272 464c0 8.8 7.2 16 16 16s16-7.2 16-16V288H167.4L290.7 472.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L205.4 287.3C269.8 280.6 320 226.2 320 160c0-70.7-57.3-128-128-128H48zM176 256H32V80c0-8.8 7.2-16 16-16H192c53 0 96 43 96 96s-43 96-96 96H176z"]
};
var faTemperatureQuarter = {
  prefix: 'fal',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V272c0-8.8 7.2-16 16-16s16 7.2 16 16v34c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faSquareInfo = {
  prefix: 'fal',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-16 64h40c8.8 0 16 7.2 16 16V352h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V256H184c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faInfoSquare = faSquareInfo;
var faWifiSlash = {
  prefix: 'fal',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5s-15.5 8.1-22.5 2.6L6.1 28.6C-.8 23.1-2 13 3.4 6.1zm394.7 230l-54.7-43.2c70 5.6 133 36.3 179.9 83.1c6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-28.4-28.3-63.5-50-102.6-62.5zM208.5 249.5c-25.8 12.5-49.1 29.2-69.2 49.2c-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c19-18.9 40.6-35.2 64.2-48.3l27.6 21.8zM201.7 81.1L171.5 57.2C218 40.9 267.9 32 320 32c122.9 0 234.3 49.5 315.3 129.7c6.3 6.2 6.3 16.3 .1 22.6s-16.3 6.3-22.6 .1C537.6 110 434.2 64 320 64c-41.1 0-80.8 6-118.3 17.1zM48.8 123.4l26 20.5C57.9 156.2 42 169.8 27.3 184.4c-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4 .1-22.6c13.8-13.7 28.5-26.5 44-38.3zM268.1 453.5a64 64 0 1 1 103.7-75 64 64 0 1 1 -103.7 75zM352 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faToiletPaperXmark = {
  prefix: 'fal',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32H337.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V464c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V416H128v48c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384H400c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM227.3 132.7c-6.2-6.2-16.4-6.2-22.6 0L168 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L145.4 192l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L168 214.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faHandsHoldingDollar = {
  prefix: 'fal',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M320 0c8.8 0 16 7.2 16 16V32.8c11 1.2 21.6 3.7 31.2 6.3c8.5 2.3 13.5 11.1 11.2 19.7s-11.1 13.5-19.6 11.2c-12.1-3.3-24-5.8-35-5.9c-9.2-.1-19.1 2.1-26.1 6.3c-6.4 3.9-9.6 8.8-9.6 15.8c0 5.1 2 8.7 8.7 12.8c7.6 4.7 18.3 8.1 31.9 12.3l.4 .1c12.3 3.8 27.3 8.5 39.1 16.1c12.9 8.3 23.6 21.3 23.8 40.9c.3 20.6-9.9 35.6-24 44.5c-9.7 6.2-20.9 9.5-32 10.6V240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-18.6c-11-2.4-21.3-6-30.4-9.3c-2.3-.8-4.6-1.6-6.7-2.4c-8.4-2.9-12.8-12-10-20.3s12-12.8 20.3-10c2.6 .9 5.2 1.8 7.7 2.7l0 0 0 0 0 0c14.7 5.1 26.8 9.3 39.7 9.8c10 .3 19.7-1.9 26.2-6.1c5.8-3.7 9.3-8.9 9.2-17.1c-.1-6.1-2.6-10.2-9.2-14.4c-7.6-4.9-18.2-8.4-31.7-12.6l-1.7-.5c-11.9-3.7-26.3-8.1-37.5-15.1c-12.8-7.9-23.7-20.4-23.8-39.9c-.1-20.6 11.1-34.9 25-43.3c7.1-4.3 15-7.2 22.9-8.9V16c0-8.8 7.2-16 16-16zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faHandsUsd = faHandsHoldingDollar;
var faCube = {
  prefix: 'fal',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M261.5 35.1c-3.6-1.3-7.5-1.3-11 0L44.1 110.7 256 194l211.9-83.2L261.5 35.1zM32 385.7c0 6.7 4.2 12.7 10.5 15L240 473.1V222L32 140.3V385.7zm240 87.4l197.5-72.4c6.3-2.3 10.5-8.3 10.5-15V140.3L272 222v251zM239.5 5c10.7-3.9 22.4-3.9 33 0l208 76.3c18.9 6.9 31.5 24.9 31.5 45.1V385.7c0 20.1-12.6 38.1-31.5 45.1L272.5 507c-10.7 3.9-22.4 3.9-33 0l-208-76.3C12.6 423.8 0 405.8 0 385.7V126.4c0-20.1 12.6-38.1 31.5-45.1L239.5 5z"]
};
var faArrowDownTriangleSquare = {
  prefix: 'fal',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v96zM416 67.5L341.3 192H490.7L416 67.5zM307.6 186L391.8 45.7C396.9 37.2 406.1 32 416 32s19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9zM320 432V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z"]
};
var faSortShapesDown = faArrowDownTriangleSquare;
var faBitcoinSign = {
  prefix: 'fal',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M64 16C64 7.2 71.2 0 80 0s16 7.2 16 16V64h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64.3c53.7 4.1 96 49 96 103.7c0 31.3-13.9 59.4-35.8 78.5C291.8 261.2 320 299.3 320 344c0 57.4-46.6 104-104 104H192v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H96v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H41.7C18.7 448 0 429.3 0 406.3V272 240 101.6C0 80.8 16.8 64 37.6 64H64V16zM176 416h40c39.8 0 72-32.2 72-72s-32.2-72-72-72H184 32V406.3c0 5.4 4.4 9.7 9.7 9.7H80h96zm0-320H80 37.6c-3.1 0-5.6 2.5-5.6 5.6V240H184c39.8 0 72-32.2 72-72s-32.2-72-72-72h-8z"]
};
var faShutters = {
  prefix: 'fal',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", "M32 32C14.3 32 0 46.3 0 64V96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32zm0 32H480V96H32V64zM.9 453c-.6 2-.9 4.1-.9 6.1C0 470.7 9.3 480 20.9 480H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-21.2-69H456.4l19.7 64H35.9l19.7-64H22.2L.9 453zM22.2 256L.9 325c-.6 2-.9 4.1-.9 6.1C0 342.7 9.3 352 20.9 352H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-21.2-69H456.4l19.7 64H35.9l19.7-64H22.2zm453.9-64H35.9l9.8-32H12.3L.9 197c-.6 2-.9 4.1-.9 6.1C0 214.7 9.3 224 20.9 224H491.1c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1l-11.4-37H466.2l9.8 32z"]
};
var faShieldDog = {
  prefix: 'fal',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM200 128H178.7c-32.4 0-58.7 26.3-58.7 58.7V216c0 22.6 13.4 42.1 32.7 50.9l-15 29.9c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L186.4 271c26-4.9 45.6-27.7 45.6-55V160h60.2c6.1 0 11.6 3.4 14.3 8.8l7.2 14.3c2.7 5.4 8.2 8.8 14.3 8.8h56v16c0 35.3-28.7 64-64 64H272c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h32c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32H337.9l-2.7-5.5C327 138.3 310.4 128 292.2 128H232 216 200zM175.7 240c-13.1-.1-23.7-10.8-23.7-24V186.7c0-10.9 6.6-20.3 16-24.4c3.3-1.4 6.9-2.2 10.7-2.2H200v32 24c0 13.2-10.6 23.9-23.7 24l-.5 0zM272 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faSolarPanel = {
  prefix: 'fal',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M221.2 0h16.1H402.7h16.1H533.5c26.9 0 50 19.1 55 45.6L613.2 176l3 16L639 312.6c1 5.1 1 10.2 1 15.4c0 30.9-25.1 56-56 56H436 419.9 336v96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V384H220.1 204 56c-30.9 0-56-25.1-56-56c0-5.2 0-10.3 1-15.4L23.8 192l3-16L51.5 45.6C56.5 19.1 79.6 0 106.5 0H221.2zM304 352h32 81.2L404.7 208H235.3L222.8 352H304zM250.5 32L238.1 176H401.9L389.5 32H250.5zM436.8 208l12.5 144H584c13.3 0 24-10.7 24-24c0-5.6-.1-7.8-.4-9.5L586.7 208H436.8zM434 176H580.6L557.1 51.5C554.9 40.2 545 32 533.5 32H421.6L434 176zM203.2 208H53.3L32.4 318.5c-.3 1.7-.4 3.9-.4 9.5c0 13.3 10.7 24 24 24H190.7l12.5-144zm2.8-32L218.4 32H106.5C95 32 85.1 40.2 82.9 51.5L59.4 176H206z"]
};
var faLockOpen = {
  prefix: 'fal',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M352 128c0-53 43-96 96-96s96 43 96 96v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128zm-16 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48H336z"]
};
var faTableTree = {
  prefix: 'fal',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", "M64 64C46.3 64 32 78.3 32 96v64h80H480V96c0-17.7-14.3-32-32-32H64zm64 128v48c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-5.6 0-11-1-16-2.7V336c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-26.5 0-48-21.5-48-48V240 192H32V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H128zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16zm80 80h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHouseChimneyHeart = {
  prefix: 'fal',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM237.3 256c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7L288 377.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6zM176 285.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faTally3 = {
  prefix: 'fal',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", "M128 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM400 48V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faElevator = {
  prefix: 'fal',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M155.3 4.7l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 38.6 91.3 91.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0zm160 0L368 57.4 420.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 160c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM0 192c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm184 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM144 384c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-17.7-14.3-32-32-32H144zm160 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32z"]
};
var faMoneyBillTransfer = {
  prefix: 'fal',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M548.7 27.3L585.4 64l-45.3 0H524.6L384 64l-.3 0H96c-35.3 0-64 28.7-64 64V348.1l14.1-14.1L64 316.1V192c53 0 96-43 96-96H524.3h15.8l45.3 0-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM128 96c0 35.3-28.7 64-64 64V128c0-17.7 14.3-32 32-32h32zM54.6 448l45.3 0 0 0H544c35.3 0 64-28.7 64-64V163.9l-14.1 14.1L576 195.9V320h0c-53 0-96 43-96 96H256.4l-.4 0L54.6 416l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 448zM576 352h0v32c0 17.7-14.3 32-32 32H512c0-35.3 28.7-64 64-64zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faMoneyBillTrendUp = {
  prefix: 'fal',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M352 16c0 8.8 7.2 16 16 16h57.4L287.2 170.2 186.4 83.9c-6-5.1-14.8-5.1-20.8 0l-112 96c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L176 117.1l101.6 87.1c6.3 5.4 15.8 5.1 21.7-.8L448 54.6V112c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM480 304v32c-26.5 0-48-21.5-48-48h32c8.8 0 16 7.2 16 16zM112 288H400c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80V368c44.2 0 80-35.8 80-80zM432 480c0-26.5 21.5-48 48-48v32c0 8.8-7.2 16-16 16H432zM32 432c26.5 0 48 21.5 48 48H48c-8.8 0-16-7.2-16-16V432zM80 288c0 26.5-21.5 48-48 48V304c0-8.8 7.2-16 16-16H80zM48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faHouseFloodWaterCircleArrowRight = {
  prefix: 'fal',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M310.4 86.4c-3.6-10.3-8.1-20.2-13.4-29.6l78-54c5.5-3.8 12.7-3.8 18.2 0l208 144c7.3 5 9.1 15 4 22.3s-15 9.1-22.3 4L560 157.3V276.6c-2.4-1.6-4.6-3.3-6.8-5.1c-7.5-6.3-16.2-10.7-25.2-13V135.2L384 35.5l-73.6 51zM224 368c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C374.3 358 395.1 368 416 368s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C473.5 385.9 446.3 400 416 400s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C281.5 385.9 254.3 400 224 400s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C40 400.1 32 392 32 382.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C182.3 358 203.1 368 224 368zm-58.2 90.8C182.3 470 203.1 480 224 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C374.3 470 395.1 480 416 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C473.5 497.9 446.3 512 416 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C281.5 497.9 254.3 512 224 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C40 512.1 32 504 32 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM144 0a144 144 0 1 1 0 288A144 144 0 1 1 144 0zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSquarePollHorizontal = {
  prefix: 'fal',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM256 160c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16zm80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0zM192 352c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16z"]
};
var faPollH = faSquarePollHorizontal;
var faCircle = {
  prefix: 'fal',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faCartCircleExclamation = {
  prefix: 'fal',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faSword = {
  prefix: 'fal',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", "M507.3 4.7C503.7 1 498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L174.6 234.7l22.6 22.6L396.8 57.8c7.1-7.1 16.2-11.8 26.1-13.4l53.7-8.9-8.9 53.7c-1.6 9.9-6.3 19-13.4 26L254.6 314.7l22.6 22.6L476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zm-392 216c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-5.3 5.3-6.2 13.6-2.2 19.9l49.1 77.2L74.7 382.6l-31.6-6.3c-5.2-1-10.7 .6-14.5 4.4l-24 24c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l24-24c3.8-3.8 5.4-9.2 4.4-14.5l-6.3-31.6 32.9-32.9 77.2 49.1c6.3 4 14.6 3.1 19.9-2.2l32-32c6.2-6.2 6.2-16.4 0-22.6l-176-176zm26.2 122.7L92.4 266.2 104 254.6 257.4 408l-11.6 11.6-77.2-49.1c-6.3-4-14.6-3.1-19.9 2.2l-48 48c-3.8 3.8-5.4 9.2-4.4 14.5l6.3 31.6L96 473.4 38.6 416l6.6-6.6 31.6 6.3c5.2 1 10.7-.6 14.5-4.4l48-48c5.3-5.3 6.2-13.6 2.2-19.9z"]
};
var faBackwardFast = {
  prefix: 'fal',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M16 64c8.8 0 16 7.2 16 16V215.8L210.6 70.2c5-4 11.2-6.2 17.6-6.2C243.6 64 256 76.4 256 91.8V241.9L466.6 70.2c5-4 11.2-6.2 17.6-6.2C499.6 64 512 76.4 512 91.8V420.2c0 15.4-12.4 27.8-27.8 27.8c-6.4 0-12.6-2.2-17.6-6.2L256 270.1V420.2c0 15.4-12.4 27.8-27.8 27.8c-6.4 0-12.6-2.2-17.6-6.2L32 296.2V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V270.1 241.9 80c0-8.8 7.2-16 16-16zM33.3 256L224 411.4V100.6L33.3 256zM480 100.6L289.3 256 480 411.4V100.6z"]
};
var faFastBackward = faBackwardFast;
var faRecycle = {
  prefix: 'fal',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", "M193.7 35C206.9 13.3 230.5 0 256 0s49.1 13.3 62.3 35l77.8 127.8 11.1-54c1.8-8.7 10.2-14.2 18.9-12.4s14.2 10.2 12.4 18.9l-19.4 94.4c-.9 4.5-3.7 8.3-7.7 10.6s-8.7 2.8-13 1.3L307 191.2c-8.4-2.8-12.9-11.8-10.1-20.2s11.8-12.9 20.2-10.1l50.5 16.8L291 51.7C283.5 39.4 270.3 32 256 32s-27.5 7.4-35 19.7l-31.1 51.2c-4.6 7.5-14.4 9.9-21.9 5.4c-7.6-4.6-10-14.5-5.4-22L193.7 35zM435.2 257.8c7.5-4.5 17.3-2.1 21.9 5.4l46 75.6c5.8 9.5 8.8 20.3 8.9 31.4c.3 34.1-27.3 61.9-61.4 61.9l-184.5 0 40.5 36c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3l-72-64c-3.4-3-5.4-7.4-5.4-12s2-8.9 5.4-12l72-64c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L266.1 400l184.6 0c16.3 0 29.5-13.3 29.4-29.6c0-5.3-1.5-10.5-4.3-15l-46-75.6c-4.6-7.6-2.2-17.5 5.4-22zm-300-.2l-10-48.4L36.3 355.3c-2.8 4.5-4.2 9.7-4.3 15C31.9 386.7 45.1 400 61.4 400l82.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-82.7 0C27.3 432-.3 404.2 0 370.1c.1-11.1 3.2-21.9 8.9-31.4l92.4-151.9L45 205.5c-8.4 2.8-17.4-1.8-20.2-10.1S26.6 178 35 175.2l91.4-30.4c4.3-1.4 9.1-1 13 1.3s6.7 6.2 7.7 10.6l19.4 94.4c1.8 8.7-3.8 17.1-12.4 18.9s-17.1-3.8-18.9-12.4z"]
};
var faUserAstronaut = {
  prefix: 'fal',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M368 176A144 144 0 1 0 80 176a144 144 0 1 0 288 0zM48 176a176 176 0 1 1 352 0A176 176 0 1 1 48 176zM16 112c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm432 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 482.3c0-64.2 33.9-120.4 84.7-151.8c8.6 7.8 17.9 14.8 27.7 21.1C65.4 375.4 32.9 423.8 32 480H96V448c0-26.5 21.5-48 48-48H304c26.5 0 48 21.5 48 48v32h64c-.9-56.2-33.4-104.6-80.5-128.4c9.8-6.3 19.1-13.3 27.7-21.1c50.8 31.4 84.7 87.6 84.7 151.8c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM288 480h32V448c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v32h32V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16zM205.3 162.7l21.2 6c3.3 .9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5l6 21.2zM160 128c-17.7 0-32 14.3-32 32v16c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V160c0-17.7-14.3-32-32-32H160zM96 160c0-35.3 28.7-64 64-64H288c35.3 0 64 28.7 64 64v16c0 61.9-50.1 112-112 112H208c-61.9 0-112-50.1-112-112V160z"]
};
var faInterrobang = {
  prefix: 'fal',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M48 160c0-53 43-96 96-96h32c53 0 96 43 96 96c0 25.2-11.9 48.9-32 64l-60.8 45.6c-1.1 .8-2.2 1.7-3.2 2.5V160c0-8.8-7.2-16-16-16s-16 7.2-16 16V340v4 8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8-4c0-17.6 8.3-34.2 22.4-44.8l60.8-45.6C287.4 228.4 304 195.3 304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 8.8 7.2 16 16 16s16-7.2 16-16zM160 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPlaneSlash = {
  prefix: 'fal',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M347.6 359.4L283.3 471.9c-2.8 5-8.2 8.1-13.9 8.1l-56.2 0 44.5-155.6c1.4-4.8 .4-10-2.6-14s-7.8-6.4-12.8-6.4H160c-5 0-9.8 2.4-12.8 6.4L104 368H64.6L95.4 260.4c.8-2.9 .8-5.9 0-8.8L64.6 144H74.8L43 118.8c-6.7 5.5-11 13.9-11 23.2c0 2.8 .4 5.6 1.2 8.3L63.4 256 33.2 361.7c-.8 2.7-1.2 5.5-1.2 8.2c0 16.6 13.4 30 30 30h42c10.1 0 19.6-4.7 25.6-12.8L168 336h53.1L182.4 471.2c-5.8 20.4 9.5 40.8 30.8 40.8l56.2 0c17.2 0 33.1-9.2 41.7-24.2L373 379.4l-25.4-20.1zM182.4 40.8l9.2 32.4 43 33.9L213.2 32l56.2 0c5.7 0 11 3.1 13.9 8.1l13.9-7.9-13.9 7.9 91.4 159.9c2.9 5 8.2 8.1 13.9 8.1l109.7 0c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2H484.1l37.1 29.3c15.2-3.4 31.2-9.7 45.1-18C586.4 303.1 608 282.9 608 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-100.5 0L311.1 24.2C302.6 9.2 286.7 0 269.4 0H213.2C192 0 176.6 20.3 182.4 40.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCircleDashed = {
  prefix: 'fal',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M18.8 232c8.2 0 15.1-6.2 16.5-14.3C41 184.4 54.1 153.6 72.8 127c4.7-6.7 4.3-16-1.5-21.8C64.6 98.5 53.5 99 48 106.7c-22.5 31.4-38.2 68-44.6 107.7C1.8 223.8 9.3 232 18.8 232zM127 72.8c26.5-18.7 57.3-31.8 90.6-37.6C225.8 33.9 232 27 232 18.8c0-9.5-8.2-17-17.5-15.4C174.7 9.8 138.1 25.5 106.7 48c-7.7 5.5-8.2 16.6-1.5 23.3c5.8 5.8 15.1 6.3 21.8 1.5zM280 493.2c0 9.5 8.2 17 17.5 15.4c39.7-6.5 76.4-22.1 107.7-44.6c7.7-5.5 8.2-16.6 1.5-23.3c-5.8-5.8-15.1-6.3-21.8-1.5c-26.5 18.7-57.3 31.8-90.6 37.6c-8.1 1.4-14.3 8.2-14.3 16.5zM439.2 385c-4.7 6.7-4.3 16 1.5 21.8c6.7 6.7 17.8 6.2 23.3-1.5c22.5-31.4 38.2-68 44.6-107.7c1.5-9.4-5.9-17.5-15.4-17.5c-8.2 0-15.1 6.2-16.5 14.3c-5.7 33.3-18.8 64.1-37.6 90.6zM105.2 440.7c-6.7 6.7-6.2 17.8 1.5 23.3c31.4 22.5 68 38.2 107.7 44.6c9.4 1.5 17.5-5.9 17.5-15.4c0-8.2-6.2-15.1-14.3-16.5c-33.3-5.7-64.1-18.8-90.6-37.6c-6.7-4.7-16-4.3-21.8 1.5zM48 405.3c5.5 7.7 16.6 8.2 23.3 1.5c5.8-5.8 6.3-15.1 1.5-21.8C54.1 358.4 41 327.6 35.3 294.3C33.9 286.2 27 280 18.8 280c-9.5 0-17 8.2-15.4 17.5C9.8 337.3 25.5 373.9 48 405.3zm358.8-334c6.7-6.7 6.2-17.8-1.5-23.3c-31.4-22.5-68-38.2-107.7-44.6C288.2 1.8 280 9.3 280 18.8c0 8.2 6.2 15.1 14.3 16.5C327.6 41 358.4 54.1 385 72.8c6.7 4.7 16 4.3 21.8-1.5zM439.2 127c18.7 26.5 31.8 57.3 37.6 90.6c1.4 8.1 8.2 14.3 16.5 14.3c9.5 0 17-8.2 15.4-17.5c-6.5-39.7-22.1-76.4-44.6-107.7c-5.5-7.7-16.6-8.2-23.3-1.5c-5.8 5.8-6.3 15.1-1.5 21.8z"]
};
var faTrademark = {
  prefix: 'fal',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M0 112c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM112 400c0 8.8 7.2 16 16 16s16-7.2 16-16V128H112V400zM316.3 101.8c-4.3-5.2-11.4-7.1-17.7-4.8s-10.6 8.3-10.6 15V400c0 8.8 7.2 16 16 16s16-7.2 16-16V156.2L451.7 314.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L608 156.2V400c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-6.7-4.2-12.8-10.6-15s-13.4-.4-17.7 4.8L464 279 316.3 101.8z"]
};
var faBasketball = {
  prefix: 'fal',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M290.7 477.3c-1.8-9.5-2.7-19.3-2.7-29.3c0-38.4 13.5-73.7 36.1-101.3l78.6 78.6c-31 26.9-69.5 45.4-112 52zm-32 2.7c-.9 0-1.8 0-2.7 0c-56.1 0-107.4-20.6-146.7-54.7L256 278.6 301.4 324C273.1 357.5 256 400.7 256 448c0 10.9 .9 21.6 2.7 32zM324 301.4L278.6 256 425.3 109.3C459.4 148.6 480 199.9 480 256c0 .9 0 1.8 0 2.7c-10.4-1.7-21.1-2.7-32-2.7c-47.3 0-90.5 17.1-124 45.4zm22.7 22.7C374.3 301.5 409.6 288 448 288c10 0 19.8 .9 29.3 2.7c-6.6 42.5-25.1 81-52 112l-78.6-78.6zM256 233.4L210.6 188C238.9 154.5 256 111.3 256 64c0-10.9-.9-21.6-2.7-32c.9 0 1.8 0 2.7 0c56.1 0 107.4 20.6 146.7 54.7L256 233.4zm-68.1-68.1L109.3 86.7c31-26.9 69.5-45.4 112-52C223.1 44.2 224 54 224 64c0 38.4-13.5 73.7-36.1 101.3zm-22.6 22.6C137.7 210.5 102.4 224 64 224c-10 0-19.8-.9-29.3-2.7c6.6-42.5 25.1-81 52-112l78.6 78.6zM32 253.3c10.4 1.7 21.1 2.7 32 2.7c47.3 0 90.5-17.1 124-45.4L233.4 256 86.7 402.7C52.6 363.4 32 312.1 32 256c0-.9 0-1.8 0-2.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faBasketballBall = faBasketball;
var faForkKnife = {
  prefix: 'fal',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M64 9.7L273.7 234.4 251.1 257 42.9 34C38.4 49 32 77.1 32 112c0 41 12.6 72.2 36.6 104.6c21 28.3 50.1 56.9 87.3 93.2l0 0 0 0c6.6 6.4 13.4 13.1 20.5 20.1l0 0 .1 .1 .8 .8-22.6 22.6-.8-.8c-6.8-6.7-13.5-13.3-20-19.6l0 0 0 0c-37-36.2-68.3-66.8-91-97.4C15.6 198.8 0 161.1 0 112C0 69.6 8.6 36.2 13.6 20.4C17.6 7.6 29.4 0 41.7 0C50.2 0 58.2 3.5 64 9.7zM484.3 506.9L316.6 327.3l22.6-22.6L507.7 485.1c6 6.5 5.7 16.6-.8 22.6s-16.6 5.7-22.6-.8zM468.9 6.5c5.2 7.1 3.7 17.1-3.4 22.4L351.1 112.7c-3.1 2.3-6.1 4.8-8.8 7.6l-1.6 1.6C327.5 135.2 320 153.2 320 172s7.5 36.8 20.8 50.1l13.1 13.1C367.2 248.5 385.2 256 404 256s36.8-7.5 50.1-20.8l1.6-1.6c2.7-2.7 5.3-5.7 7.6-8.8l83.8-114.3c5.2-7.1 15.2-8.7 22.4-3.4s8.7 15.2 3.4 22.4L489.1 243.8c-3.3 4.4-6.9 8.6-10.7 12.5l-1.6 1.6C457.5 277.2 431.3 288 404 288c-25 0-49.1-9.1-67.8-25.5L91.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L313.5 239.8C297.1 221.1 288 197 288 172c0-27.3 10.8-53.5 30.1-72.8l1.6-1.6c3.9-3.9 8.1-7.5 12.5-10.7L446.5 3.1c7.1-5.2 17.1-3.7 22.4 3.4zM508 37.5c5.8 6.7 5.1 16.8-1.5 22.6l-128 112c-6.6 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l128-112c6.7-5.8 16.8-5.1 22.6 1.5zM538.5 68c6.7 5.8 7.3 15.9 1.5 22.6l-112 128c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l112-128c5.8-6.7 15.9-7.3 22.6-1.5z"]
};
var faUtensilsAlt = faForkKnife;
var faSatelliteDish = {
  prefix: 'fal',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M208 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c150.2 0 272 121.8 272 272c0 8.8 7.2 16 16 16s16-7.2 16-16C512 136.1 375.9 0 208 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c97.2 0 176 78.8 176 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9-93.1-208-208-208zM32 304c0-24.5 5-47.7 13.9-68.8L276.8 466.1C255.7 475 232.5 480 208 480c-97.2 0-176-78.8-176-176zm33.5-94.5c-14-14-37.3-12.1-45.7 5.8C7.1 242.2 0 272.3 0 304C0 418.9 93.1 512 208 512c31.7 0 61.8-7.1 88.7-19.8c17.9-8.4 19.8-31.8 5.8-45.7L195.3 339.3l24-24c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7l-24 24L65.5 209.5zM224 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faBadgeCheck = {
  prefix: 'fal',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCircleUp = {
  prefix: 'fal',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-9.2 0-18 3.5-24.7 9.7l-91 84c-7.8 7.2-12.3 17.4-12.3 28.1c0 21.1 17.1 38.3 38.3 38.3H192v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272h25.7c21.1 0 38.3-17.1 38.3-38.3c0-10.7-4.5-20.9-12.3-28.1l-91-84c-6.7-6.2-15.6-9.7-24.7-9.7zm-3 33.2c.8-.8 1.9-1.2 3-1.2s2.2 .4 3 1.2l91 84c1.3 1.2 2 2.9 2 4.6c0 3.5-2.8 6.3-6.3 6.3H304c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V256c0-8.8-7.2-16-16-16H166.3c-3.5 0-6.3-2.8-6.3-6.3c0-1.7 .7-3.4 2-4.6l91-84z"]
};
var faArrowAltCircleUp = faCircleUp;
var faSlider = {
  prefix: 'fal',
  iconName: 'slider',
  icon: [512, 512, [], "e252", "M352 128c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h32zM320 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V160c0-35.3-28.7-64-64-64H320zM0 256c0 8.8 7.2 16 16 16H224V240H16c-8.8 0-16 7.2-16 16z"]
};
var faMobileScreenButton = {
  prefix: 'fal',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M288 32c17.7 0 32 14.3 32 32V320H64V64c0-17.7 14.3-32 32-32H288zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352H320zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM216 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faMobileAlt = faMobileScreenButton;
var faClockOneThirty = {
  prefix: 'fal',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V260.8l61.3-92c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-1.8 2.6-2.7 5.7-2.7 8.9V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faInboxOut = {
  prefix: 'fal',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M272 54.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V304c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6zM48 352h66.3c6.1 0 11.6 3.4 14.3 8.8L143 389.5c8.1 16.3 24.8 26.5 42.9 26.5H326.1c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3L369 389.5l14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8H464c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm306.7-5.5l-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8H185.9c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H397.7c-18.2 0-34.8 10.3-42.9 26.5z"]
};
var faInboxArrowUp = faInboxOut;
var faCloudSlash = {
  prefix: 'fal',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 352c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8C384.1 61.5 331.5 32 272 32c-35.5 0-68.6 10.5-96.2 28.6l26.8 21.2C223.2 70.5 246.8 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 15.1-3.5 29.4-9.7 42.2l25.6 20.2C634.1 395.9 640 374.6 640 352zM101.3 164.9c-2.9 11.3-4.6 23.1-5.1 35.2C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144H500.4l-40.5-32H144C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8c.2-4.9 .7-9.7 1.4-14.4l-28.2-22.2z"]
};
var faVolumeHigh = {
  prefix: 'fal',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M151.6 188L288 66.7V445.3L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM409.6 179.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8zm42-69.2c-5.6 6.8-4.7 16.9 2.1 22.5C489.4 161.9 512 206.3 512 256s-22.6 94.1-58.2 123.4c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1C516.8 368.9 544 315.6 544 256s-27.2-112.9-69.8-148.1c-6.8-5.6-16.9-4.7-22.5 2.1zm86.7-73.6c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6c55.3 47 90.4 117 90.4 195.2s-35.1 148.2-90.4 195.2c-6.7 5.7-7.6 15.8-1.8 22.6s15.8 7.6 22.6 1.8C600.5 422.8 640 344 640 256s-39.5-166.8-101.6-219.6z"]
};
var faVolumeUp = faVolumeHigh;
var faUsersRays = {
  prefix: 'fal',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm630.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zM27.3 507.3l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm608 0c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H320 280zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"]
};
var faWallet = {
  prefix: 'fal',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M80 32C35.8 32 0 67.8 0 112V400c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM384 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faOctagonCheck = {
  prefix: 'fal',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM363.3 203.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 297.4 340.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faFlatbreadStuffed = {
  prefix: 'fal',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M256.8 32l59.9 32.9c11.7 6.4 25.1 9 38.4 7.5l51.5-6.1 17.9-17.9c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3L101.8 371l-.2-7.1c-.3-13.3-4.7-26.3-12.7-37L48 272.1l42.8-53.3c8.4-10.4 13.3-23.2 14-36.5l3.8-68.3 67.1-13.3c13.1-2.6 25-9.2 34.2-19L256.8 32zM426.7 136.7l36.6-36.6c29.7 39.8 48.8 87 48.8 139.9c0 132.5-107.5 240-240 240c-52.9 0-100.1-19.1-139.9-48.8l79.6-79.6 86-86 86-86 43-43zm56.1-63.6c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9zM272 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM232 144c-66.3 0-120 53.7-120 120c0 27.2 9.1 52.3 24.3 72.5l22.9-22.9C149.6 299.4 144 282.4 144 264c0-48.6 39.4-88 88-88c18.4 0 35.4 5.6 49.5 15.3l22.9-22.9C284.3 153.1 259.2 144 232 144z"]
};
var faClipboardCheck = {
  prefix: 'fal',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm91.3 171.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
};
var faCartCirclePlus = {
  prefix: 'fal',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faTruckClock = {
  prefix: 'fal',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", "M64 32C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V64c0-17.7-14.3-32-32-32H64zm0 384c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h65.3c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zM416 128v96H570.9l-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6H416zm0 128v88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64H576V256H416zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM208 256a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm16 64v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faShippingTimed = faTruckClock;
var faPool8Ball = {
  prefix: 'fal',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm368-64a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm37.3 14.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 11.5-4 22-10.7 30.2zM256 192a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faFileAudio = {
  prefix: 'fal',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM258 226.3c-7.6-4.6-17.4-2.1-22 5.4s-2.1 17.4 5.4 22C269.4 270.5 288 301.1 288 336s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22s14.4 10 22 5.4c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7zm-18.3 67c-5.9-6.6-16-7.1-22.6-1.3s-7.1 16-1.3 22.6c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C249.8 367.4 256 352.4 256 336s-6.2-31.4-16.3-42.7zm-56.9-43.8c-5.6-2.6-12.3-1.8-17 2.2L122.2 288H80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h42.2l43.6 36.3c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5V264c0-6.2-3.6-11.9-9.2-14.5zM160 298.2v75.7l-21.8-18.1c-2.9-2.4-6.5-3.7-10.2-3.7H96V320h32c3.7 0 7.4-1.3 10.2-3.7L160 298.2z"]
};
var faTurnDownLeft = {
  prefix: 'fal',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M160 208l0-57.3c0-3.7-3-6.7-6.7-6.7c-1.9 0-3.7 .8-5 2.2L35.8 272 148.3 397.8c1.3 1.4 3.1 2.2 5 2.2c3.7 0 6.7-3 6.7-6.7l0-57.3c0-17.7 14.3-32 32-32l176 0c61.9 0 112-50.1 112-112l0-112c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 112c0 26.5-21.5 48-48 48l-176 0c-17.7 0-32-14.3-32-32zM5.3 286C1.9 282.1 0 277.2 0 272s1.9-10.1 5.3-14L124.5 124.9c7.3-8.2 17.8-12.9 28.8-12.9c21.4 0 38.7 17.3 38.7 38.7l0 25.3 0 32 32 0 144 0c8.8 0 16-7.2 16-16l0-112c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 112c0 79.5-64.5 144-144 144l-144 0-32 0 0 32 0 25.3c0 21.4-17.3 38.7-38.7 38.7c-11 0-21.5-4.7-28.8-12.9L5.3 286z"]
};
var faLockHashtag = {
  prefix: 'fal',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", "M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96zM32 272V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48zm144-32c8.8 0 16 7.2 16 16v32h64V256c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H288v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H288v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V320H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V256c0-8.8 7.2-16 16-16zm16 144h64V320H192v64z"]
};
var faChartRadar = {
  prefix: 'fal',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM312 160c0 17.8-8.3 33.6-21.2 43.9l24.1 60.3c1.7-.2 3.4-.2 5.1-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56c-29.2 0-53.2-22.3-55.8-50.8l-54.7-10.9c-9.4 17.7-28 29.8-49.5 29.8c-30.9 0-56-25.1-56-56s25.1-56 56-56c6.8 0 13.4 1.2 19.4 3.5L211 193.3c-6.9-9.3-11-20.8-11-33.3c0-30.9 25.1-56 56-56s56 25.1 56 56zM270.5 293.8c3.6-6.9 8.7-12.9 14.7-17.7l-24.1-60.3c-1.7 .2-3.4 .2-5.1 .2c-6.8 0-13.4-1.2-19.4-3.5L205 254.7c5.9 8 9.8 17.7 10.8 28.2l54.7 10.9zM256 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-184-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faStaff = {
  prefix: 'fal',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M284.2 44.2l-7.2 14.3c-11.9 23.7-2.2 52.5 21.5 64.4s52.5 2.2 64.4-21.5c1.7-3.4 5.1-5.5 8.8-5.5H400c8.8 0 16 7.2 16 16v47.7c0 7.1-4.7 13.4-11.6 15.4L234.8 223.6c-13.1 3.7-25 10.7-34.6 20.4l-39.4 39.4c-3 3-7.1 4.7-11.3 4.7H112c-8.8 0-16 7.2-16 16v37.5c0 4.2-1.7 8.3-4.7 11.3L14.1 430.1c-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0L262.2 317.7c1.9-1.9 4.3-3.3 6.9-4.1l85.5-24.4c4.1-1.2 8.5-.7 12.3 1.5l32.8 18.5c7.7 4.3 17.5 1.6 21.8-6.1l19-33.6c2.1-3.7 5.5-6.4 9.5-7.5l3.9-1.1c34.3-9.8 58-41.2 58-76.9V80c0-44.2-35.8-80-80-80H355.8c-30.3 0-58 17.1-71.6 44.2zM355.8 32H432c26.5 0 48 21.5 48 48V183.9c0 21.4-14.2 40.3-34.8 46.2l-3.9 1.1c-12.1 3.5-22.4 11.6-28.6 22.6l-11.1 19.7-18.9-10.7c-11.2-6.3-24.4-7.9-36.8-4.4l-85.5 24.4c-7.8 2.2-15 6.4-20.8 12.2L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l77.3-77.3c9-9 14.1-21.2 14.1-33.9V320h21.5c12.7 0 24.9-5.1 33.9-14.1l39.4-39.4c5.8-5.8 12.9-10 20.8-12.2l169.6-48.5c20.6-5.9 34.8-24.7 34.8-46.2V112c0-26.5-21.5-48-48-48H371.8c-15.9 0-30.4 9-37.5 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l7.2-14.3C321 42.3 337.6 32 355.8 32z"]
};
var faBurger = {
  prefix: 'fal',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M256 64c94.4 0 172.9 68.1 189 157.8l0 .1c0 .1-.1 .2-.3 .3c-.7 .8-2.4 1.7-4.7 1.7H72c-2.4 0-4-1-4.7-1.7c-.1-.1-.2-.2-.3-.3l0-.1C83.1 132.1 161.6 64 256 64zM440 256c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2C31.6 237.9 49.9 256 72 256H440zM128 448c-35.3 0-64-28.7-64-64H448c0 35.3-28.7 64-64 64H128zM32 384c0 53 43 96 96 96H384c53 0 96-43 96-96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM16 304c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zM160 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faHamburger = faBurger;
var faUtilityPole = {
  prefix: 'fal',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96h80V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h15.8c.1 0 .2 0 .3 0H480V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96c0 17.7-14.3 32-32 32H437.5L304 231.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224.2c0-.1 0-.2 0-.3V128H240v95.9c0 .1 0 .2 0 .3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V231.8L74.5 128H32C14.3 128 0 113.7 0 96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96H79.9c.1 0 .2 0 .3 0H96V48c0-8.8 7.2-16 16-16s16 7.2 16 16V96h80V32zm-81.4 96L208 191.3V128H126.6zM304 191.3L385.4 128H304v63.3zM272 32l-32 0V96h32V32z"]
};
var faTransporter6 = {
  prefix: 'fal',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", "M48 0C39.2 0 32 7.2 32 16V32H16C7.2 32 0 39.2 0 48s7.2 16 16 16H32V80c0 8.8 7.2 16 16 16s16-7.2 16-16V64H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V16C64 7.2 56.8 0 48 0zM464 352c-8.8 0-16 7.2-16 16v16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V416h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V368c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm32 224c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faWrench = {
  prefix: 'fal',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M480 160c0-10.7-1.3-21.1-3.8-31l-48.9 48.9c-9 9-21.2 14.1-33.9 14.1H368c-26.5 0-48-21.5-48-48V118.6c0-12.7 5.1-24.9 14.1-33.9L383 35.8c-9.9-2.5-20.3-3.8-31-3.8c-70.7 0-128 57.3-128 128c0 9.2 1 18.1 2.8 26.7c3.2 15.2-.6 32.4-13.1 44.9L45.8 399.4C37 408.3 32 420.3 32 432.8C32 458.9 53.1 480 79.2 480c12.5 0 24.5-5 33.4-13.8L280.5 298.3c12.4-12.4 29.7-16.3 44.9-13.1c8.6 1.8 17.5 2.8 26.7 2.8c70.7 0 128-57.3 128-128zm32 0c0 88.4-71.6 160-160 160c-11.4 0-22.6-1.2-33.3-3.5c-5.6-1.2-11.5 .3-15.6 4.4L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L191.1 208.9c4.1-4.1 5.6-10 4.4-15.6c-2.3-10.7-3.5-21.9-3.5-33.3C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3V144c0 8.8 7.2 16 16 16h25.4c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBugs = {
  prefix: 'fal',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M156.7 102.8l34-80.6c3.4-8.1-.4-17.5-8.5-21s-17.5 .4-21 8.5L128 88.6 94.7 9.8c-3.4-8.1-12.8-12-21-8.5s-12 12.8-8.5 21l34 80.6c-13.8 7-24.8 18.8-30.6 33.2H37.1l-5.4-27.1C30 100.2 21.5 94.6 12.9 96.3S-1.4 106.5 .3 115.1l8 40C9.8 162.6 16.4 168 24 168H64v49.8l-45.1 15c-5.7 1.9-9.9 6.9-10.8 12.9l-8 56c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l6.6-46.2 30.9-10.3C79.3 272.3 101.8 288 128 288s48.7-15.7 58.6-38.3l30.9 10.3 6.6 46.2c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1l-8-56c-.9-6-5-11-10.8-12.9l-45.1-15V168h40c7.6 0 14.2-5.4 15.7-12.9l8-40c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6L218.9 136H187.3c-5.8-14.4-16.8-26.2-30.6-33.2zM160 224c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v64zm332.3 55.4l69.7-52.8c7-5.3 8.4-15.4 3.1-22.4s-15.4-8.4-22.4-3.1l-68.2 51.6 10.6-84.9c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-10.8 86.8c-15.4-.9-30.8 3.9-43.1 13.4l-27.3-15.8 8.9-26.2c2.8-8.4-1.7-17.5-10-20.3s-17.5 1.7-20.3 10l-13.1 38.6c-2.4 7.2 .6 15.2 7.2 19l34.6 20-24.9 43.1L308 323.1c-5.9-1.2-12.1 1-15.8 5.8l-34.9 44.5c-5.5 7-4.2 17 2.7 22.5s17 4.2 22.5-2.7l28.8-36.7 32 6.5c-2.7 24.5 8.9 49.4 31.6 62.4s50 10.7 69.9-3.8L466.4 446 449 489.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l21.1-52.5c2.3-5.6 1.1-12-2.9-16.6l-31.5-35.5 24.9-43.1 34.6 20c6.6 3.8 15 2.4 20-3.3l26.9-30.6c5.8-6.6 5.2-16.7-1.5-22.6s-16.7-5.2-22.6 1.5l-18.3 20.8-27.3-15.8c2.2-15.4-1.4-31.1-9.9-44.1zM434.6 386c-8.8 15.3-28.4 20.5-43.7 11.7s-20.6-28.4-11.7-43.7l32-55.4c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7l-32 55.4z"]
};
var faVectorPolygon = {
  prefix: 'fal',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", "M408 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM360 32c-22.1 0-40 17.9-40 40v8H128V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h8l0 192H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40v-8H320v8c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H364.3l-25.4-42.3c8.1-7.3 13.2-17.9 13.2-29.7V232c0-11.8-5.1-22.3-13.2-29.7L364.3 160H408c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360zM307.7 320l25.4 42.3c-8.1 7.3-13.2 17.9-13.2 29.7v8H128v-8c0-22.1-17.9-40-40-40H80l0-192h8c22.1 0 40-17.9 40-40v-8H320v8c0 11.8 5.1 22.3 13.2 29.7L307.7 192H264c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h43.7zM40 384H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm320 0h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM264 224h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zM88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H88z"]
};
var faDiagramNested = {
  prefix: 'fal',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M144 64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112 80 48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96zM112 224h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48H80v96c0 44.2 35.8 80 80 80h96v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v32H160c-26.5 0-48-21.5-48-48V224zM288 368V336c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V400 368z"]
};
var faRupeeSign = {
  prefix: 'fal',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 80C0 53.5 21.5 32 48 32h64c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 80zM32 288h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V288zm264.8-27.6c-1.5 9.7-.4 16.5 1.8 21.6c2.2 5.1 5.9 9.7 11.5 14c12.1 9.2 29.9 15.2 51.4 22.6l.1 0c20 6.8 43.6 14.8 60.7 28.8c8.9 7.3 16.6 16.6 21.2 28.4c4.6 11.9 5.7 25.3 3.4 40.3c-3.9 25.5-19 44-40.2 54.2c-20.6 9.9-46.3 11.8-72.8 7.2l-.1 0c-9-1.6-20.6-5.5-31-9.3c-7-2.5-14.2-5.3-20.2-7.6l0 0c-3-1.2-5.8-2.2-8.1-3.1c-8.3-3.1-12.5-12.3-9.4-20.6s12.3-12.5 20.6-9.4c2.7 1 5.7 2.2 8.8 3.4l0 0c5.8 2.2 12.3 4.7 19.1 7.2c10.5 3.8 19.8 6.8 25.9 7.9c22 3.9 40.4 1.7 53.3-4.5c12.3-5.9 20.2-15.7 22.5-30.3c1.6-10.6 .6-18.2-1.6-23.9c-2.2-5.7-6-10.7-11.6-15.2c-11.8-9.7-29.5-16-50.8-23.3l-2.8-1c-19.2-6.5-41.4-14-57.7-26.5c-9-6.8-16.8-15.6-21.6-27c-4.8-11.5-6.1-24.4-3.9-38.9c3.7-23.9 19-42 39.7-52.6c20.5-10.4 46.3-13.6 73.3-8.8c7.7 1.4 31 6.4 39.4 8.9c8.5 2.5 13.3 11.4 10.7 19.9s-11.4 13.3-19.9 10.7c-6.7-2-28.7-6.8-35.8-8.1c-21.4-3.8-40-.9-53.2 5.8c-13 6.6-20.7 16.8-22.6 28.9z"]
};
var faRupee = faRupeeSign;
var faFileImage = {
  prefix: 'fal',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM181.3 368.9c-2.9 4.3-7.7 7-12.9 7.1s-10.1-2.2-13.2-6.4l-14.4-19.3L99 416H285.1L219.7 311.3l-38.4 57.6zM219.9 272c8 0 15.5 4.1 19.8 11l76 121.5c2.8 4.5 4.3 9.7 4.3 15.1c0 15.7-12.7 28.4-28.4 28.4H92.4C76.7 448 64 435.3 64 419.6c0-5.4 1.5-10.7 4.4-15.2l51.8-81.4c4.3-6.8 11.9-10.9 19.9-10.9c7.4 0 14.4 3.5 18.9 9.4l8.1 10.9 33.3-49.9c4.3-6.5 11.6-10.4 19.4-10.4z"]
};
var faCircleQuestion = {
  prefix: 'fal',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8H280c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H222.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faQuestionCircle = faCircleQuestion;
var faImageUser = {
  prefix: 'fal',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM299.4 320H212.6c-18.6 0-34 14-36.3 32H335.7c-2.2-18-17.6-32-36.3-32zm-86.9-32H256h43.4c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4c0-37.9 30.7-68.6 68.6-68.6z"]
};
var faBuoy = {
  prefix: 'fal',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", "M192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h12.3L147 304H96c-17.7 0-32 14.3-32 32v16c0 13.3 1.8 26.1 5.2 38.3c10-4.6 20.9-6.5 31.7-5.7C97.7 374.3 96 363.4 96 352l0-16H480v16c0 11.4-1.7 22.3-4.8 32.6c10.8-.8 21.7 1.1 31.7 5.7c3.4-12.2 5.2-25.1 5.2-38.3V336c0-17.7-14.3-32-32-32H429L371.7 32H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H192zM339 32l9.8 46.4-60.8 76-60.8-76L237 32H339zM218.7 119l48.8 61L183.8 284.6 218.7 119zM288 205.6L366.7 304H209.3L288 205.6zm104.2 79L308.5 180l48.8-61 34.9 165.7zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faPlaneDeparture = {
  prefix: 'fal',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M158.7 105.4c11.5-5.2 24.5-5.7 36.4-1.4L375 170c4.2 1.5 8.8 1.3 12.8-.8l88-45c15.8-8.1 33.3-12.3 51-12.3h61c12.7 0 21.1 13.1 15.8 24.6c-15.4 33.4-41.7 60.5-74.6 77L255.6 350.3c-2.2 1.1-4.7 1.7-7.2 1.7H109.3c-4.2 0-8.3-1.7-11.3-4.7L34.1 283.5l23.7-13.6c4.4-2.5 9.8-2.8 14.4-.7l57.2 25.4c4.4 2 9.5 1.8 13.8-.4l115-58.8c5.1-2.6 8.5-7.8 8.7-13.6s-2.6-11.2-7.5-14.3L121.9 122.2l-6.6-14.6 6.6 14.6 36.9-16.8zM206.1 74c-19.7-7.2-41.5-6.4-60.6 2.3L108.6 93.1c-23.3 10.6-25.4 42.8-3.6 56.3l113.5 70.5-83 42.4L85.3 240l-6.1 13.7L85.3 240c-14-6.2-30-5.4-43.3 2.2L18.2 255.7c-18.3 10.5-21.7 35.5-6.8 50.4l63.8 63.8c9 9 21.2 14.1 33.9 14.1H248.4c7.5 0 14.8-1.7 21.5-5.1L543.3 242.2c39.4-19.7 70.9-52.2 89.3-92.2c15.1-32.7-8.8-70-44.8-70h-61c-22.8 0-45.2 5.4-65.5 15.8l-81.8 41.8L206.1 74zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faHandshakeSlash = {
  prefix: 'fal',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 368V160c0-17.7-14.3-32-32-32H560 528v32V338.7l32 25.3V160h48V368c0 8.8-7.2 16-16 16h-6.6L617 409c13.8-8.4 23-23.6 23-41zM403.3 403.3L371 377.8c-.2 1.1-.2 2.2-.2 3.3c.4 8.1-2.3 16.3-8.1 22.9c-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8c-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6c-12.4-12.4-28.9-19.8-46.3-20.9V173.3L54.6 128H32c-17.7 0-32 14.3-32 32V368c0 26.5 21.5 48 48 48H64c26.5 0 48-21.5 48-48V352.3c8.9 1 17.2 5 23.6 11.4l28.6 28.6 15.4 15.4 .1 .1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6c.8-.7 1.6-1.4 2.3-2.2c26.3 21.3 65.3 18.6 88.4-7.3c6-6.7 10.3-14.4 13-22.5c1.2 .3 2.5 .5 3.8 .7zM196.4 240l-2.8-2.2c.2 .8 .4 1.5 .6 2.2h2.3zM292.3 99l-30.9 29.2 25.4 20 27.5-26C332.2 105.4 355.8 96 380.4 96c22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7V121.8L462.9 94.1C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35zm-54.9 .2L272.6 64h-8.7c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6c3.1-1 6.2-1.9 9.3-2.7zm121.4 79.1l-15.6 14.4L366.3 211l18-14.6c2.4-5.6 1.5-12.4-2.9-17.2c-6-6.5-16.1-6.9-22.6-.9zM80 160V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160H80z"]
};
var faBookBookmark = {
  prefix: 'fal',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M0 64C0 28.7 28.7 0 64 0H176 336h64c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM320 32H192V206.7l54-43.2c5.8-4.7 14.1-4.7 20 0l54 43.2V32zM160 32H64C46.3 32 32 46.3 32 64l0 328.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H352V240c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4V32zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64z"]
};
var faBorderCenterH = {
  prefix: 'fal',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 240zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM416 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-384a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCanFood = {
  prefix: 'fal',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M336 432V285.6c-12.8 6.5-27.7 11.9-43.7 16.2c-6.5 1.7-13.3 3.3-20.4 4.7c-1.3 43-36.6 77.6-80 77.6s-78.7-34.5-80-77.6c-7-1.4-13.8-3-20.4-4.7c-16-4.3-30.8-9.7-43.7-16.2V432c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C111.4 473.1 149.3 480 192 480s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1c6.1-5.8 7.6-10.3 7.6-13.3zm0-183.7V127.6c-7.4 4.7-15.9 8.9-24.9 12.5C279.8 152.6 237.7 160 192 160s-87.8-7.4-119.1-19.9c-9.1-3.6-17.5-7.8-24.9-12.5V248.3c11.7 8.5 29.3 16.4 51.9 22.5c5.6 1.5 11.4 2.9 17.5 4.1C129.1 245.1 158.1 224 192 224s62.9 21.1 74.5 50.9c6.1-1.2 11.9-2.6 17.5-4.1c22.7-6.1 40.3-14 51.9-22.5zM48 80c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C111.4 121.1 149.3 128 192 128s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1C334.5 87.5 336 83 336 80s-1.5-7.5-7.6-13.3c-6.1-5.8-15.9-11.8-29.2-17.1C272.6 38.9 234.7 32 192 32s-80.6 6.9-107.2 17.6C71.4 54.9 61.7 60.9 55.6 66.7C49.5 72.5 48 77 48 80zm320 0V432v8c0 39.8-78.8 72-176 72s-176-32.2-176-72v-8V80 72C16 32.2 94.8 0 192 0s176 32.2 176 72v8zM192 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faTypewriter = {
  prefix: 'fal',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", "M128 32c-17.7 0-32 14.3-32 32v96H64V64C64 28.7 92.7 0 128 0H356.1c17 0 33.3 6.7 45.3 18.7l27.9 27.9c12 12 18.7 28.3 18.7 45.3V160H416V91.9c0-8.5-3.4-16.6-9.4-22.6L378.7 41.4c-6-6-14.1-9.4-22.6-9.4H128zM32 224v64H64 448h32V224H365.3L352 237.3c-12 12-28.3 18.7-45.3 18.7H205.3c-17 0-33.3-6.7-45.3-18.7l22.6-22.6c6 6 14.1 9.4 22.6 9.4H306.7c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V320c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H146.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3L160 237.3 146.7 224 32 224zm32 96V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V320H64zm96 96H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z"]
};
var faArrowRightFromArc = {
  prefix: 'fal',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", "M32 256C32 132.3 132.3 32 256 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.6 0 0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM362.6 116c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6L453.9 240H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H453.9L341.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128z"]
};
var faCircleK = {
  prefix: 'fal',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm91.1-356.5c6.4-6.1 6.5-16.3 .4-22.6s-16.3-6.5-22.6-.4L192 260.8V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V298.5 368c0 8.8 7.2 16 16 16s16-7.2 16-16V305.3l44.6-43.1 86.6 115.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4l-89-118.6 87.3-84.3z"]
};
var faFaceHandOverMouth = {
  prefix: 'fal',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm144.4-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-95 125.3L248 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L280 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L312 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V352 298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34zm-11.3-79.2L207 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v32.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faPopcorn = {
  prefix: 'fal',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", "M178.9 22.9c-8-4.4-17.1-6.9-26.9-6.9c-25.5 0-47 17-53.8 40.3C70 59.2 48 83 48 112c0 4.4 .5 8.6 1.5 12.7C34.5 131.3 23 144.2 18.3 160H54.1c4.4-4.9 10.8-8 17.9-8c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8c-3-4-4.8-9-4.8-14.4c0-13.3 10.7-24 24-24c1.7 0 3.3 .2 4.8 .5c4.7 1 9.6-.3 13.4-3.3s5.9-7.7 5.8-12.5l0-.7C128 58.7 138.8 48 152 48c8.1 0 15.2 4 19.6 10.1c3.7 5.3 10.2 7.8 16.5 6.4s11.1-6.4 12.3-12.8C202.4 40.5 212.2 32 224 32s21.6 8.5 23.6 19.7c1.1 6.3 6 11.4 12.3 12.8s12.8-1.1 16.5-6.4C280.8 52 287.9 48 296 48c13.2 0 24 10.7 24 23.9l0 .7c0 4.8 2.1 9.4 5.8 12.5s8.6 4.3 13.4 3.3c1.5-.3 3.2-.5 4.8-.5c13.3 0 24 10.7 24 24c0 3.5-.7 6.8-2.1 9.7c-2.1 4.7-1.8 10 .7 14.5s7 7.4 12.1 8c9.2 1 16.9 7.4 19.9 15.8h32.8c-2.7-19-14.9-34.9-31.7-42.7c.2-1.7 .2-3.5 .2-5.3c0-29-22-52.8-50.2-55.7C343 33 321.5 16 296 16c-9.7 0-18.9 2.5-26.9 6.9C258.9 9 242.5 0 224 0s-34.9 9-45.1 22.9zM33.2 224H98.1l30 210.3c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1L130.4 224H208V432c0 8.8 7.2 16 16 16s16-7.2 16-16V224h77.6L288.2 429.7c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l30-210.3h64.9L346.9 468.3c-1.9 6.9-8.2 11.7-15.4 11.7h-215c-7.2 0-13.5-4.8-15.4-11.7L33.2 224zM224 192H112.3h-.5H28.2C12.6 192 0 204.6 0 220.2c0 2.5 .3 5.1 1 7.5L70.2 476.8C76 497.6 94.9 512 116.5 512h215c21.6 0 40.5-14.4 46.2-35.2L447 227.7c.7-2.5 1-5 1-7.5c0-15.6-12.6-28.2-28.2-28.2H336.2h-.5H224z"]
};
var faHouseWater = {
  prefix: 'fal',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V393c9.9-5.7 20.9-8.6 32-8.6V206.7L288 37.3 480 206.7V384.5c11.1 0 22.1 2.9 32 8.6V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM208 208v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32zm128 0v96H240V208h96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"]
};
var faHouseFlood = faHouseWater;
var faObjectSubtract = {
  prefix: 'fal',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M64 32l32 0V0H64C28.7 0 0 28.7 0 64V96H32l0-32c0-17.7 14.3-32 32-32zm160 0V0H128V32l96 0zM32 128H0v96H32l0-96zm0 128H0v32c0 35.3 28.7 64 64 64H96V320H64c-17.7 0-32-14.3-32-32l0-32zm96 96h32l32 0h32V320H192 160 128v32zm32 32l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64l-64 0v32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-64H160zM352 192l0-32V128H320v32 32 32h32V192zm0-128c0-35.3-28.7-64-64-64H256V32l32 0c17.7 0 32 14.3 32 32V96h32V64zM256 320v32h32c35.3 0 64-28.7 64-64V256H320v32c0 17.7-14.3 32-32 32H256z"]
};
var faCodeBranch = {
  prefix: 'fal',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V273.6c20.3-20.7 48.7-33.6 80-33.6h96c44.2 0 80-35.8 80-80v-1.6c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V160c0 61.9-50.1 112-112 112H176c-44.2 0-80 35.8-80 80v1.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V352 158.4C27.5 151 0 118.7 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWarehouseFull = {
  prefix: 'fal',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zM352 400v80h80c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H352zm-32 80V400H192v64c0 8.8 7.2 16 16 16H320zm0-176c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64H320V304zm112 64c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v32 32h32 48z"]
};
var faWarehouseAlt = faWarehouseFull;
var faHatCowboy = {
  prefix: 'fal',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M249.7 64c4.3 .2 6.7 1.1 8.2 1.8c2.1 1 4.3 2.6 8.5 6.3c.6 .5 1.2 1.1 1.9 1.7l0 0C276.7 81.3 293 96 320 96s43.3-14.7 51.7-22.2l0 0c.7-.6 1.3-1.2 1.9-1.7c4.2-3.7 6.4-5.2 8.5-6.3c1.5-.7 3.9-1.6 8.2-1.8c.5 .4 1.2 1 2.3 1.9c3.9 3.7 8.8 10.5 14.4 21c11.1 21 21.4 50.4 30.2 81.7c8.7 30.9 15.5 62 20.2 85.5c.8 4 1.5 7.9 2.2 11.4c10.8-3.7 21-7.6 30.3-11.7C476.4 184.2 441.4 32 392 32c-21.3 0-31.6 9.1-41.2 17.6C342.3 57 334.4 64 320 64s-22.3-7-30.8-14.4C279.6 41.1 269.3 32 248 32c-49.3 0-84.4 152.2-97.9 221.9c9.4 4.1 19.5 8 30.3 11.7c.7-3.5 1.4-7.3 2.2-11.3c4.7-23.5 11.5-54.6 20.2-85.5C211.6 137.4 221.9 108 233 87c5.6-10.5 10.6-17.3 14.4-21c1-1 1.8-1.6 2.3-1.9zm139.9-.5a.1 .1 0 1 0 0 .2 .1 .1 0 1 0 0-.2zm-139.3 .1a.1 .1 0 1 0 .3 .1 .1 .1 0 1 0 -.3-.1zm-239 156c-9.5 5.9-13.5 17.9-9.9 28.5c13.5 37.7 38.4 72.3 66.1 100.6C116.4 398.9 196.4 448 320 448s203.7-49.1 252.6-99.2c27.7-28.3 52.6-62.9 66.1-100.6c3.6-10.6-.4-22.6-9.9-28.5c-9.5-5.9-21.7-4.5-29.6 3.3c-20.4 19.4-45.3 34.8-70.1 47.7C481.8 295.2 411.6 320 320.1 320s-161.8-24.8-209-49.3C86.3 257.8 61.3 242.4 40.9 223c-7.9-7.9-20.2-9.2-29.6-3.3zm533.1 80.6c14.9-7.7 30.5-16.6 45.5-27.1c-11.3 18.7-25.4 36.4-41.1 52.4c-43.3 44.4-115.1 89.2-228.8 89.2c-113.7 0-185.4-44.8-228.7-89.2c-15.6-16-29.8-33.7-41.1-52.4c15 10.4 30.6 19.3 45.5 27.1c51.1 26.6 126.7 53 224.4 53c97.7 0 173.2-26.5 224.3-53z"]
};
var faBridge = {
  prefix: 'fal',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H80v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96 224 352 480h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 352 224 96 16zM464 64v64H368V64h96zM336 64v64H240V64h96zM208 64v64H112V64h96zM16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H32c35.3 0 64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V336c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V336c0-35.3 28.7-64 64-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H544c-53 0-96 43-96 96v96c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V336c0-53-43-96-96-96s-96 43-96 96v96c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-53-43-96-96-96H16z"]
};
var faPhoneFlip = {
  prefix: 'fal',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4 .9l112 24C498.8 28.8 512 45.1 512 64v0c0 236.7-183.5 430.5-416 446.9c-4.5 .3-9.1 .6-13.7 .8c0 0 0 0 0 0c0 0-.1 0-.1 0c-6.1 .2-12.1 .4-18.3 .4l0 0c-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM64.3 480C293.9 479.8 480 293.7 480 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0-3.8-2.6-7-6.3-7.8l-112-24c-3.7-.8-7.5 1.2-9 4.7l-48 112c-1.4 3.3-.5 7.1 2.3 9.3l40.6 33.2c12.1 9.9 15.3 27.2 7.4 40.8c-29.5 50.9-71.9 93.3-122.7 122.7c-13.6 7.9-30.9 4.7-40.8-7.4l-33.2-40.6c-2.3-2.8-6.1-3.7-9.3-2.3l-112 48c-3.5 1.5-5.5 5.3-4.7 9l24 112c.8 3.7 4 6.3 7.8 6.3c.1 0 .2 0 .3 0z"]
};
var faPhoneAlt = faPhoneFlip;
var faArrowDownFromDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", "M235.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 425.4V320 176c0-8.8 7.2-16 16-16s16 7.2 16 16V320 425.4L340.7 324.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFileDoc = {
  prefix: 'fal',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
};
var faSquareQuarters = {
  prefix: 'fal',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M55.7 65.1L224 233.4 392.3 65.1c-2.6-.7-5.4-1.1-8.3-1.1H64c-2.9 0-5.6 .4-8.3 1.1zM33.1 87.7C32.4 90.4 32 93.1 32 96V416c0 2.9 .4 5.6 1.1 8.3L201.4 256 33.1 87.7zM55.7 446.9c2.6 .7 5.4 1.1 8.3 1.1H384c2.9 0 5.6-.4 8.3-1.1L224 278.6 55.7 446.9zm359.2-22.6c.7-2.6 1.1-5.4 1.1-8.3V96c0-2.9-.4-5.6-1.1-8.3L246.6 256 414.9 424.3zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faTruckFront = {
  prefix: 'fal',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M80 32C53.5 32 32 53.5 32 80V248.4c10.8-9.7 23.9-17 38.3-21l31.3-88.8c9-25.6 33.2-42.7 60.4-42.7H350c27.1 0 51.3 17.1 60.4 42.7l31.3 88.8c14.4 4 27.4 11.3 38.3 21V80c0-26.5-21.5-48-48-48H80zM32 320v48c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V320c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zM0 320V80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V320v48c0 26.2-12.6 49.4-32 64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V446.4c-5.2 1-10.5 1.6-16 1.6H80c-5.5 0-10.8-.6-16-1.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V432C12.6 417.4 0 394.2 0 368V320zm105.4-96H406.6l-26.3-74.7C375.7 136.6 363.6 128 350 128H162c-13.6 0-25.7 8.6-30.2 21.3L105.4 224zM80 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCat = {
  prefix: 'fal',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M352 33V144c0 44.2 35.8 80 80 80s80-35.8 80-80V33c0-.5-.4-1-1-1c-.3 0-.5 .1-.7 .3L472 70.6c-6 6-14.1 9.4-22.6 9.4H414.6c-8.5 0-16.6-3.4-22.6-9.4L353.7 32.3c-.2-.2-.4-.3-.7-.3c-.5 0-1 .4-1 1zm1-33c8.7 0 17.1 3.5 23.3 9.7L414.6 48h34.7L487.7 9.7C493.9 3.5 502.3 0 511 0c18.2 0 33 14.8 33 33V144c0 61.9-50.1 112-112 112s-112-50.1-112-112V33c0-18.2 14.8-33 33-33zM128 299.2c33.8-61.5 92.1-108.2 162.9-126.2c2.2 10.6 5.5 20.9 9.9 30.5C200.2 228.2 128 318.7 128 424v8c0 26.5 21.5 48 48 48H304l0 0h42.6c2.9 0 5.3-2.4 5.3-5.3c0-14.7-11.9-26.7-26.7-26.7H288c-8.8 0-16-7.2-16-16v0V392c0-22.1-17.9-40-40-40h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c39.8 0 72 32.2 72 72v4.4L421.4 292c3-2.6 6.7-4 10.5-4l.1 0 .1 0c2.2 0 4.4 .5 6.4 1.4c5.7 2.6 9.4 8.3 9.4 14.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V279.8c11.4-4 22.1-9.4 32-16.1V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V339.6l-86.1 76.5c30.3 2.3 54.1 27.6 54.1 58.5c0 20.6-16.7 37.3-37.3 37.3L304 512H176l-.1 0c-44.1-.1-79.9-35.9-79.9-80v-8V176.5c0-24.2-18-44.6-42-47.6l-7.9-1c-8.8-1.1-15-9.1-13.9-17.9s9.1-15 17.9-13.9l7.9 1c40 5 70.1 39 70.1 79.4V299.2zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTrashXmark = {
  prefix: 'fal',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zm82.3 116.7c6.2-6.2 16.4-6.2 22.6 0L224 265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 288l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faCircleCaretLeft = {
  prefix: 'fal',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-352 0c0 9.6 4 18.7 11 25.2l102.8 95.5c5.1 4.7 11.8 7.3 18.7 7.3c15.2 0 27.5-12.3 27.5-27.5l0-201c0-15.2-12.3-27.5-27.5-27.5c-6.9 0-13.6 2.6-18.7 7.3L171 230.8c-7 6.5-11 15.6-11 25.2zm32.7 1.7c-.5-.4-.7-1.1-.7-1.7s.3-1.3 .7-1.7L288 165.8l0 180.3-95.3-88.4z"]
};
var faCaretCircleLeft = faCircleCaretLeft;
var faFiles = {
  prefix: 'fal',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M160 384c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H304v80c0 17.7 14.3 32 32 32h80c0 .3 0 .5 0 .8V352c0 17.7-14.3 32-32 32H160zM336 57.5L390 112H336V57.5zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V144.8c0-12.7-5-24.8-13.9-33.8l-96-96.8C329.1 5.1 316.8 0 304 0H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faAnchorCircleExclamation = {
  prefix: 'fal',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faFaceClouds = {
  prefix: 'fal',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M99.8 54.9C97.2 60.4 91.6 64 85.4 64H64C46.3 64 32 78.3 32 96s14.3 32 32 32H216c22.1 0 40-17.9 40-40s-17.9-40-40-40c-8.7 0-16.6 2.7-23.2 7.4c-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C162.9 39.5 150.3 32 136 32c-15.9 0-29.7 9.3-36.2 22.9zM136 0c20.3 0 38.6 8.4 51.6 21.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H64C28.7 160 0 131.3 0 96S28.7 32 64 32H76.1C89 12.7 111 0 136 0zM288.3 1.9C298.7 .7 309.3 0 320 0C461.4 0 576 114.6 576 256c0 7.3-.3 14.5-.9 21.7c-9.4-6-20-10.2-31.3-12.2c.1-3.1 .2-6.3 .2-9.4C544 132.3 443.7 32 320 32c-3.6 0-7.1 .1-10.7 .2C304 21 296.9 10.8 288.3 1.9zM96 256c0 90.7 54 168.9 131.6 204.1c4 15.5 11.2 29.7 20.9 41.8C141.9 470.9 64 372.6 64 256c0-22.1 2.8-43.5 8.1-64h33.2c-6 20.3-9.3 41.8-9.3 64zm120.4-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 304c-35.3 0-64 28.7-64 64c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48s21.5 48 48 48H560c26.5 0 48-21.5 48-48c0-24.7-18.6-45-42.5-47.7c-4.4-.5-8.4-2.8-11-6.3s-3.7-8-2.9-12.4c.3-1.8 .5-3.7 .5-5.6c0-17.7-14.3-32-32-32c-9.2 0-17.6 3.9-23.4 10.2c-3.4 3.7-8.4 5.5-13.4 5s-9.5-3.4-12-7.8C459.9 316.6 439.4 304 416 304zm-94.9 49.4c7-46.1 46.8-81.4 94.9-81.4c28.7 0 54.5 12.6 72 32.5c9.4-5.4 20.3-8.5 32-8.5c33.9 0 61.6 26.3 63.9 59.6C616.4 365.8 640 396.1 640 432c0 44.2-35.8 80-80 80H336c-44.2 0-80-35.8-80-80c0-39.1 28-71.6 65.1-78.6z"]
};
var faUserCrown = {
  prefix: 'fal',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M238.7 4.4C234.3 1.5 229.2 0 224 0s-10.3 1.5-14.7 4.4L176.9 26.1c-5.4 3.6-12.4 3.6-17.8 0L124 2.7C121.4 .9 118.3 0 115.2 0H112c-8.8 0-16 7.2-16 16V128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128 16c0-8.8-7.2-16-16-16h-3.2c-3.2 0-6.2 .9-8.9 2.7L288.9 26.1c-5.4 3.6-12.4 3.6-17.8 0L238.7 4.4zM320 112H128V43.8l13.4 8.9c16.1 10.7 37.1 10.7 53.3 0L224 33.1l29.4 19.6c16.1 10.7 37.1 10.7 53.3 0L320 43.8V112zM128 144H320c0 53-43 96-96 96s-96-43-96-96zm40 192H280c75.1 0 136 60.9 136 136v8H32v-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168z"]
};
var faTruckField = {
  prefix: 'fal',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M320 64c17.7 0 32 14.3 32 32v96 32V352H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64V288 128 96c0-17.7 14.3-32 32-32H320zM32 128c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64c0 53 43 96 96 96s96-43 96-96h96 32c0 53 43 96 96 96s96-43 96-96h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V256c0-35.3-28.7-64-64-64H521.6l-42.4-78.8C470.8 97.7 454.5 88 436.9 88H383.5c-3.9-31.6-30.9-56-63.5-56H96C60.7 32 32 60.7 32 96v32zm352 64V120h52.9c5.9 0 11.3 3.2 14.1 8.4L485.2 192H384zm5.5 160H384V224H511.7c.2 0 .4 0 .6 0H544c17.7 0 32 14.3 32 32v96h-5.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64zM96 384a64 64 0 1 1 128 0A64 64 0 1 1 96 384zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faRoute = {
  prefix: 'fal',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M452.1 164.2c-11.7 18.7-25 36.5-36.1 50.4c-11.1-13.9-24.4-31.7-36.1-50.4C362.1 135.7 352 111.2 352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15.2-10.1 39.7-27.9 68.2zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 38.7 35 91.9 62.7 128H336c-44.2 0-80 35.8-80 80s35.8 80 80 80h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H166c-9.4 12.3-18.6 23.2-26.4 32H432c44.2 0 80-35.8 80-80s-35.8-80-80-80H336c-26.5 0-48-21.5-48-48s21.5-48 48-48h76.9c5.1 1.1 10.7-.6 14.5-5zM132.2 417.2C120.5 435 107.1 451.7 96 464.6C84.9 451.7 71.5 435 59.8 417.2C41.9 390.3 32 367 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15-9.9 38.3-27.8 65.2zm-7.6 63.1C152.9 446.7 192 392.8 192 352c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0c1.6-1.7 3.3-3.6 5.1-5.6c1.8-2 3.8-4.2 5.8-6.6c2.2-2.5 4.4-5.1 6.7-7.9zM440 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCartCircleCheck = {
  prefix: 'fal',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faClipboardQuestion = {
  prefix: 'fal',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM104.7 233.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H216c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V352c0 8.8 7.2 16 16 16s16-7.2 16-16V332.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H158.9c-25.5 0-47.7 17.2-54.2 41.8zM216 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPanorama = {
  prefix: 'fal',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", "M45.6 64C38.1 64 32 70.1 32 77.6V434.4c0 7.5 6.1 13.6 13.6 13.6c1.6 0 3-.2 4.5-.7c2.5-.8 7.1-2.3 13.6-4.3l3.4-4.6L198.4 263.5c12.8-17.1 38.4-17.1 51.2 0L280 304l78.4-104.5c12.8-17.1 38.4-17.1 51.2 0L588.8 438.4l7.1 9.5c6.8-.8 12.1-6.5 12.1-13.5V77.6c0-7.5-6.1-13.6-13.6-13.6c-1.6 0-3 .2-4.5 .7C573.6 70.2 467.1 104 320 104S66.4 70.2 50.2 64.7c-1.5-.5-3-.7-4.5-.7zM546.1 434.9L384 218.7 292.8 340.3l-53.3 71.1c25.1-2.1 52-3.4 80.5-3.4c98.6 0 179 15.2 226.1 26.9zM196 415.9l64-85.3-36-48L113.3 430.3c22.7-5 50.6-10.2 82.8-14.4zM60.4 477.6c-4.7 1.6-9.7 2.4-14.7 2.4C20.4 480 0 459.6 0 434.4V77.6C0 52.4 20.4 32 45.6 32c5.1 0 10 .8 14.7 2.4C74.6 39.2 177.6 72 320 72s245.4-32.8 259.6-37.6c4.7-1.6 9.7-2.4 14.7-2.4C619.6 32 640 52.4 640 77.6V434.4c0 25.2-20.4 45.6-45.6 45.6c-5 0-10-.8-14.7-2.4C565.4 472.8 462.4 440 320 440s-245.4 32.8-259.6 37.6zM112 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCommentMedical = {
  prefix: 'fal',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-16 96c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H304V160c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V272c0-8.8-7.2-16-16-16H176V224h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V160z"]
};
var faTeethOpen = {
  prefix: 'fal',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", "M96 64H480c35.3 0 64 28.7 64 64v64c0 17.7-14.3 32-32 32V192c0-35.3-28.7-64-64-64c-14 0-27 4.5-37.6 12.2C399.5 114.2 373.9 96 344 96c-22.6 0-42.8 10.4-56 26.7C274.8 106.4 254.6 96 232 96c-29.9 0-55.5 18.2-66.4 44.2C155 132.5 142 128 128 128c-35.3 0-64 28.7-64 64l0 32c-17.7 0-32-14.3-32-32V128c0-35.3 28.7-64 64-64zM416 224V192c0-17.7 14.3-32 32-32s32 14.3 32 32v32H416zm-112 0V168c0-22.1 17.9-40 40-40s40 17.9 40 40v24 32H304zm-72-96c22.1 0 40 17.9 40 40v56H192V192 168c0-22.1 17.9-40 40-40zM176 256H288 400h96 16c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H80h96zm-16-64v32H96V192c0-17.7 14.3-32 32-32s32 14.3 32 32zM480 448H96c-35.3 0-64-28.7-64-64V352c0-17.7 14.3-32 32-32l0 32c0 35.3 28.7 64 64 64c16.8 0 32-6.5 43.5-17c12.8 19.9 35.1 33 60.5 33c22.6 0 42.8-10.4 56-26.7c13.2 16.3 33.4 26.7 56 26.7c25.4 0 47.7-13.2 60.5-33c11.4 10.6 26.7 17 43.5 17c35.3 0 64-28.7 64-64V320c17.7 0 32 14.3 32 32v32c0 35.3-28.7 64-64 64zM272 360c0 22.1-17.9 40-40 40s-40-17.9-40-40v-8V320h80v40zm16-72H176 80 64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H496 400 288zm128 32h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320zm-32 32v8c0 22.1-17.9 40-40 40s-40-17.9-40-40V320h80v32zm-224 0c0 17.7-14.3 32-32 32s-32-14.3-32-32V320h64v32z"]
};
var faUserTieHairLong = {
  prefix: 'fal',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM180.4 477.9L124.7 357.2C71.5 372.9 32.6 421.9 32 480H181.4c-.3-.7-.7-1.4-1-2.1zM416 480c-.6-58.1-39.5-107.1-92.7-122.8L267.6 477.9c-.3 .7-.7 1.4-1 2.1H416zM131.8 322.7c6.8-1.3 13.4 2.5 16.3 8.8L180.1 401l21.7-65H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-9.8l21.7 65 32.1-69.5c2.9-6.3 9.5-10 16.3-8.8c75 13.8 131.8 79.6 131.8 158.6c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-79 56.8-144.7 131.8-158.6zM248.3 443.4L224 370.6l-24.3 72.8 9.7 21.1c5.7 12.4 23.3 12.4 29.1 0l9.7-21.1z"]
};
var faFileCircleMinus = {
  prefix: 'fal',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faHeadSideMedical = {
  prefix: 'fal',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zM224 96c-17.7 0-32 14.3-32 32v32H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H288V128c0-17.7-14.3-32-32-32H224zm0 80V128h32v48c0 8.8 7.2 16 16 16h48v32H272c-8.8 0-16 7.2-16 16v48H224V240c0-8.8-7.2-16-16-16H160V192h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"]
};
var faTags = {
  prefix: 'fal',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", "M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9V80C0 53.5 21.5 32 48 32H204.1zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7H48c-8.8 0-16 7.2-16 16V236.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faWineGlass = {
  prefix: 'fal',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M49.6 160H270.4l3.2 35.6C279.7 262.4 227.1 320 160 320S40.3 262.4 46.4 195.6L49.6 160zm2.9-32l8.7-96 197.6 0 8.7 96H52.5zM29.4 29.1L14.5 192.7C7.2 272.8 65.9 342.7 144 351.1V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V351.1c78.1-8.5 136.8-78.3 129.5-158.5L290.6 29.1C289.1 12.6 275.3 0 258.8 0H61.2C44.7 0 30.9 12.6 29.4 29.1z"]
};
var faForwardFast = {
  prefix: 'fal',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M496 64c-8.8 0-16 7.2-16 16V215.8L301.4 70.2c-5-4-11.2-6.2-17.6-6.2C268.4 64 256 76.4 256 91.8V241.9L45.4 70.2c-5-4-11.2-6.2-17.6-6.2C12.4 64 0 76.4 0 91.8V420.2C0 435.6 12.4 448 27.8 448c6.4 0 12.6-2.2 17.6-6.2L256 270.1V420.2c0 15.4 12.4 27.8 27.8 27.8c6.4 0 12.6-2.2 17.6-6.2L480 296.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V270.1 241.9 80c0-8.8-7.2-16-16-16zM478.7 256L288 411.4V100.6L478.7 256zM32 100.6L222.7 256 32 411.4V100.6z"]
};
var faFastForward = faForwardFast;
var faFaceMehBlank = {
  prefix: 'fal',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMehBlank = faFaceMehBlank;
var faUserRobot = {
  prefix: 'fal',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H144c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H240V16zM96 144c0-26.5 21.5-48 48-48H304c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H240V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H176V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c-26.5 0-48-21.5-48-48V144zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM160 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm192 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM96 384H352c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16H368V448c0-17.7-14.3-32-32-32H288 224 112c-17.7 0-32 14.3-32 32v32H48c-8.8 0-16-7.2-16-16V448c0-35.3 28.7-64 64-64zm112 64v32H176V448h32zm-96 0h32v32H112V448zm112 64h64 48 32 32c26.5 0 48-21.5 48-48V448c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48H80h32 48 64zm16-64h32v32H240V448zm96 0v32H304V448h32z"]
};
var faSquareParking = {
  prefix: 'fal',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM176 288h80c35.3 0 64-28.7 64-64s-28.7-64-64-64H176V288zm80 32H176v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParking = faSquareParking;
var faCardDiamond = {
  prefix: 'fal',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm203.3 84.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM192 329.4L265.4 256 192 182.6 118.6 256 192 329.4z"]
};
var faFaceZipper = {
  prefix: 'fal',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9c-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c32.4 0 63.5-6 92.1-17.1c8.2-3.2 12.4-12.4 9.2-20.7s-12.4-12.4-20.7-9.2c-25 9.6-52.1 14.9-80.6 14.9C132.3 480 32 379.7 32 256zm192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm48-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zM160 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm40.4-128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm34.7 84.7l-22.5 22.5c-9.6 9.6-12.1 24.1-6.3 36.3l29.2 61.8c21.7 45.9 82.3 56.4 118.2 20.5s25.4-96.5-20.5-118.2l-61.8-29.2c-12.2-5.8-26.7-3.2-36.3 6.3zm84.4 51.8c25.9 12.2 31.8 46.4 11.6 66.6s-54.4 14.3-66.6-11.6l-29.2-61.8 22.5-22.5 61.8 29.2zm1 40c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0l-16 16c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0l16-16z"]
};
var faFaceRaisedEyebrow = {
  prefix: 'fal',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200.4 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm29.4-118.5l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5c10.7-10.7 28.5-8.9 36.9 3.7zM112 160c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm64 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faHouseSignal = {
  prefix: 'fal',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M325.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6s-15.8 7.5-22.6 1.7L512 187.9V352c0 35.3-28.7 64-64 64H278.1c-3.1-11-6.9-21.7-11.3-32H448c17.7 0 32-14.3 32-32V160.5L336 37.1 192 160.5V284.3c-10.1-8.3-20.8-15.9-32-22.7V187.9l-37.6 32.2c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM304 176h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V208c0-17.7 14.3-32 32-32zm0 32v64h64V208H304zM16 256c132.5 0 240 107.5 240 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 368c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16z"]
};
var faSquareChevronUp = {
  prefix: 'fal',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm235.3 68.7l112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 198.6 123.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l112-112c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faChevronSquareUp = faSquareChevronUp;
var faNfcSymbol = {
  prefix: 'fal',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M367.2 475.6c5.1 4.9 12.9 5.8 19 2.2C462.2 433.9 513.1 349.8 513.1 256s-50.9-177.9-126.8-221.8c-7.6-4.4-17.4-1.8-21.9 5.8s-1.8 17.4 5.8 21.9C436.4 100.1 481.1 173.8 481.1 256c0 78-40.2 148.2-100.8 187.9L203 276.4c-6.4-6.1-16.5-5.8-22.6 .6s-5.8 16.5 .6 22.6l186.2 176zM145.9 36.4c-5.1-4.9-12.9-5.8-19-2.3C50.9 78.1 0 162.2 0 256s50.9 177.9 126.8 221.8c7.6 4.4 17.4 1.8 21.9-5.8s1.8-17.4-5.8-21.9C76.7 411.9 32 338.2 32 256c0-77.9 40.2-148.2 100.8-187.9L309 235.6c6.4 6.1 16.5 5.8 22.6-.6s5.8-16.5-.6-22.6L145.9 36.4z"]
};
var faBarsProgress = {
  prefix: 'fal',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", "M464 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H320V96H464zM48 96H288v96H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm0-32C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM464 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H192V320H464zM48 320H160v96H48c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"]
};
var faTasksAlt = faBarsProgress;
var faFaucetDrip = {
  prefix: 'fal',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H208v48H189.3c-12.7 0-24.9 5.1-33.9 14.1L121.4 160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H128c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7H224h34.7c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16c0-26.5-21.5-48-48-48H307.2c-5.7 0-11 3-13.8 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H132.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48c0-79.5-64.5-144-144-144H326.6l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H240V64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V16zM448 431.6l13.3 21.3c1.8 2.8 2.7 6.1 2.7 9.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-1.7c0-3.3 .9-6.6 2.7-9.4L448 431.6zm-12.2-40.8l-28.2 45.1c-4.9 7.9-7.6 17-7.6 26.4V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-1.7c0-9.3-2.6-18.5-7.6-26.4l-28.2-45.1c-2.6-4.2-7.3-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z"]
};
var faArrowsToLine = {
  prefix: 'fal',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", "M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 137.4 208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 121.4 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM0 256c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm235.3 68.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V374.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z"]
};
var faDolphin = {
  prefix: 'fal',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M176 32h49.1c40.5 0 78.7 9.4 112.7 26.2c4 2 8.5 2.2 12.7 .7c32.4-12.1 73.2-24.6 105.2-26.6c-.8 3.3-2.2 7.6-4.2 13c-7.2 18.6-20.2 42.3-31.2 61.1c-3.4 5.8-2.8 13.1 1.5 18.3C458.1 168.8 480 225.2 480 286.9c0 54.4-33.6 100.9-81.2 119.9C409.7 391.3 416 372.4 416 352c0-46.5-33-85.2-76.8-94.1c-4.7-1-9.6 .3-13.3 3.3s-5.9 7.6-5.9 12.4V325c0 6.1-4.9 11-11 11c-2.9 0-5.6-1.1-7.7-3.1l-73.8-72.3c-3-2.9-7-4.6-11.2-4.6H216 176 50.2c-10 0-18.2-8.1-18.2-18.2c0-6.5 3.4-12.4 9-15.7l25.1-14.6c6.9-4.1 9.8-12.6 6.7-20c-5.6-13.4-8.8-28-8.8-43.5C64 82.1 114.1 32 176 32zm280.6-6.3a.1 .1 0 1 0 -.2 .1 .1 .1 0 1 0 .2-.1zM320 416H281.9l-1-2.1C261.9 376 223.1 352 180.7 352H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h4.7c42.4 0 81.2-24 100.2-61.9l1-2.1H320h30.9c89 0 161.1-72.1 161.1-161.1c0-65.3-21.8-125.6-58.6-173.8c10-17.5 21-38.4 27.9-56.2c3.9-10.2 7.4-21.4 7.3-30.9c0-4.8-1-11.5-5.6-17.3C477.9 2.3 470.6 0 464 0c-37 0-83.5 13.9-118.3 26.5C309 9.5 268.2 0 225.1 0H176C96.5 0 32 64.5 32 144c0 14.8 2.2 29.1 6.4 42.6l-13.5 7.9C9.5 203.5 0 220 0 237.8C0 265.5 22.5 288 50.2 288H176h33.8l69.1 67.7c8 7.9 18.8 12.3 30.1 12.3c23.7 0 43-19.2 43-43V296.6c19.1 11.1 32 31.8 32 55.4c0 35.3-28.7 64-64 64zM203.6 387.3c20.9 6.2 38.6 20.8 48.7 40.9l1.9 3.8-1.9 3.8c-10 20.1-27.8 34.7-48.7 40.9l18.8-37.5c2.3-4.5 2.3-9.8 0-14.3l-18.8-37.5zM152 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowUpRight = {
  prefix: 'fal',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", "M336 96c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L59.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H336z"]
};
var faCircleR = {
  prefix: 'fal',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 128c-17.7 0-32 14.3-32 32V272v96c0 8.8 7.2 16 16 16s16-7.2 16-16V288h71.4l59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80H192zm80 128H192V160h80c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faCartFlatbed = {
  prefix: 'fal',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", "M0 16C0 7.2 7.2 0 16 0H80c26.5 0 48 21.5 48 48V368c0 8.8 7.2 16 16 16h80H512 624c8.8 0 16 7.2 16 16s-7.2 16-16 16H567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 64H240c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H480V192c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L400 164l-54.4 40.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.3-8.8-14.3V64zm32 0v96l38.4-28.8c5.7-4.3 13.5-4.3 19.2 0L448 160V64H352zM240 32H560c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"]
};
var faDollyFlatbed = faCartFlatbed;
var faBanSmoking = {
  prefix: 'fal',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M86.7 109.3L201.4 224l32 32 32 32 32 32L402.7 425.3C363.4 459.4 312.1 480 256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7zM278.6 256H384v32H310.6l-32-32zm64 64H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H246.6L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L342.6 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM220.1 288H128V256h60.1l-32-32H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H252.1l-32-32z"]
};
var faSmokingBan = faBanSmoking;
var faCircleSortUp = {
  prefix: 'fal',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192l114.7 0L256 134.6 198.6 192zM148.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 377.4l84.7-84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96z"]
};
var faSortCircleUp = faCircleSortUp;
var faTerminal = {
  prefix: 'fal',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M5.1 59.7c-6.5-6-6.9-16.1-.8-22.6s16.1-6.9 22.6-.8l224 208c3.3 3 5.1 7.3 5.1 11.7s-1.9 8.7-5.1 11.7l-224 208c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6 .8-22.6L216.5 256 5.1 59.7zM240 448H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileButton = {
  prefix: 'fal',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M96 32C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHouseMedicalFlag = {
  prefix: 'fal',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M480 16V32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H480V512H448V192 160 64 32 16c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 160V64H480v96H608zM281.6 35.2L416 136v40L272 68 96 200V440c0 22.1 17.9 40 40 40l272 0c2.7 0 5.4-.3 8-.8v32.4c-2.6 .3-5.3 .4-8 .4l-272 0c-39.8 0-72-32.2-72-72V224L25.6 252.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l256-192c5.7-4.3 13.5-4.3 19.2 0zM256 176h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H320v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V336H192c-17.7 0-32-14.3-32-32V272c0-17.7 14.3-32 32-32h32V208c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H192v32h48c8.8 0 16 7.2 16 16v48h32V320c0-8.8 7.2-16 16-16h48V272H304c-8.8 0-16-7.2-16-16V208H256z"]
};
var faBasketShopping = {
  prefix: 'fal',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M327.9 2.2c-7.6 4.5-10.2 14.2-5.8 21.9l98 167.9H155.9l98-167.9c4.5-7.6 1.9-17.4-5.8-21.9s-17.4-1.9-21.9 5.8L118.8 192H65 32 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H40L99.9 463.5C107 492 132.6 512 162 512H414c29.4 0 55-20 62.1-48.5L536 224h24c8.8 0 16-7.2 16-16s-7.2-16-16-16H544 511 457.2L349.8 7.9c-4.5-7.6-14.2-10.2-21.9-5.8zM73 224H503L445.1 455.8C441.5 470 428.7 480 414 480H162c-14.7 0-27.5-10-31-24.2L73 224zm151 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm64-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm96 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"]
};
var faShoppingBasket = faBasketShopping;
var faTape = {
  prefix: 'fal',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M224 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM339.4 448C404.5 408.8 448 337.5 448 256C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H339.4zM224 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faChestnut = {
  prefix: 'fal',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M328.7 163.3c-14.2-14.2-29.7-27.3-46.4-41c-2.8-2.3-5.6-4.5-8.4-6.9l0 0c-13.9-11.4-28.5-23.3-42.5-36c-2.5-2.3-5-4.6-7.4-7c-2.4 2.3-4.8 4.7-7.4 7c-14 12.7-28.6 24.6-42.5 36l0 0c-2.8 2.3-5.6 4.6-8.4 6.9c-16.6 13.7-32.2 26.8-46.4 41C72.8 209.8 32 270 32 352H416c0-82-40.8-142.2-87.3-188.7zM37.5 384c13.2 37.3 48.7 64 90.5 64H320c41.8 0 77.4-26.7 90.5-64H37.5zM351.3 140.7C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128H128C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3c18.1-18.1 37.7-34.1 57.3-50.2c13.9-11.4 27.8-22.7 41.1-34.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c13.3 12.1 27.2 23.4 41.1 34.8c19.6 16.1 39.3 32.1 57.3 50.2z"]
};
var faBusSimple = {
  prefix: 'fal',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M33.2 90C49.2 70.2 106.1 32 224 32c126.8 0 175.9 38.1 190.7 57.5c.6 .8 1.3 2.5 1.3 5.6V96H32v-.8c0-3.2 .8-4.6 1.2-5.1zM32 128H416V256H32V128zM416 288v96c0 17.7-14.3 32-32 32H303.2 64c-17.7 0-32-14.3-32-32V288H416zM224 0C100.2 0 32.5 40.1 8.3 69.9C1.8 77.9 0 87.4 0 95.2V384c0 23.7 12.9 44.4 32 55.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48H303.2 384v48c0 8.8 7.2 16 16 16s16-7.2 16-16V439.4c19.1-11.1 32-31.7 32-55.4V95.2c0-7.8-1.8-17-7.8-25C417.2 40 356.6 0 224 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBusAlt = faBusSimple;
var faEye = {
  prefix: 'fal',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faFaceSadCry = {
  prefix: 'fal',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M384 439.8V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V458.4c-29.1 13.8-61.6 21.6-96 21.6s-66.9-7.7-96-21.6V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V439.8C70 399.4 32 332.1 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 76.1-38 143.4-96 183.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32V328c0-17.7 14.3-32 32-32s32 14.3 32 32v24zm-32-88c-35.3 0-64 28.7-64 64v24c0 35.3 28.7 64 64 64s64-28.7 64-64V328c0-35.3-28.7-64-64-64z"]
};
var faSadCry = faFaceSadCry;
var faHeat = {
  prefix: 'fal',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M176 32c8.8 0 16 7.2 16 16v96c0 38.1 12.4 75.1 35.2 105.6l19.2 25.6c27 36 41.6 79.8 41.6 124.8v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-38.1-12.4-75.1-35.2-105.6l-19.2-25.6C174.6 232.8 160 189 160 144V48c0-8.8 7.2-16 16-16zM16 96c8.8 0 16 7.2 16 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6L34.9 273.2C12.2 239.1 0 198.9 0 157.9V112c0-8.8 7.2-16 16-16zm336 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3C332.2 239.1 320 198.9 320 157.9V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTicketAirline = {
  prefix: 'fal',
  iconName: 'ticket-airline',
  icon: [640, 512, [], "e29a", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V334.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64v66.4c0 8-8 13.6-16 13.6c-26.5 0-48 21.5-48 48s21.5 48 48 48c8 0 16 5.6 16 13.6V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm464 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM217.8 218.9c1.6 4.9 .8 10.2-2.2 14.4s-7.8 6.6-13 6.6H160c-5 0-9.8-2.4-12.8-6.4L128 208h-3.5l10.1 40.2c1.3 5.1 1.3 10.4 0 15.5L124.5 304H128l19.2-25.6c3-4 7.8-6.4 12.8-6.4h42.7c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4L198.2 352h20c2.8 0 5.5-1.5 6.9-4l39.7-68.1c2.9-4.9 8.1-7.9 13.8-7.9h40.3c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13H278.7c-5.7 0-11-3-13.8-7.9L225.1 164c-1.4-2.5-4.1-4-6.9-4h-20l19.6 58.9zM187.1 128h31.1c14.2 0 27.4 7.6 34.6 19.8L287.9 208h31.1c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2c-14.4 14.4-33.8 22.4-54.1 22.4H287.9l-35.1 60.2c-7.2 12.3-20.3 19.8-34.6 19.8H187.1c-16.4 0-27.9-16-22.8-31.6L180.5 304H168l-14.4 19.2c-6 8.1-15.5 12.8-25.6 12.8H114.2c-15.6 0-27.1-14.7-23.3-29.8L103.5 256 91 205.8c-3.8-15.1 7.7-29.8 23.3-29.8H128c10.1 0 19.6 4.7 25.6 12.8L168 208h12.5l-16.1-48.4c-5.2-15.5 6.4-31.6 22.8-31.6z"]
};
var faBootHeeled = {
  prefix: 'fal',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", "M37 0C16.5 0 0 16.5 0 37c0 3.5 .5 7 1.5 10.3C6.5 65.1 32 158.5 32 232c0 15.4-3.7 37.3-9 60C17.9 314.4 11.6 336.3 7 351.5C2.6 366 0 381.3 0 396.9V432v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V449.5l118.9 52.8c14.3 6.4 29.8 9.7 45.5 9.7H464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V445.7c0-24.2-13.7-46.4-35.4-57.2L300.2 316.2C273.1 302.7 256 275 256 244.7V40c0-22.1-17.9-40-40-40H112 37zM96 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32h88c4.4 0 8 3.6 8 8V244.7c0 42.4 24 81.2 61.9 100.2L430.3 417c10.8 5.4 17.7 16.5 17.7 28.6V480H292.4c-11.2 0-22.3-2.3-32.5-6.9L134.5 417.4c-2-.9-4.3-1.4-6.5-1.4H112 32V396.9c0-12.1 2-24.2 5.6-36.1c4.7-15.5 11.3-38.2 16.6-61.6c5.3-23 9.8-47.9 9.8-67.2C64 153.5 37.2 56.2 32.2 38.5c-.2-.6-.2-1.1-.2-1.6c0-2.7 2.2-5 5-5H96zm0 448H32V448H96v32z"]
};
var faArrowsMinimize = {
  prefix: 'fal',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M36.7 36.7c6.2-6.2 16.4-6.2 22.6 0L192 169.4V64c0-8.8 7.2-16 16-16s16 7.2 16 16V208c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16H169.4L36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6zm416 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 192H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16s16 7.2 16 16V169.4L452.7 36.7zM48 304c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 320H64c-8.8 0-16-7.2-16-16zm240 0c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H342.6L475.3 452.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 342.6V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V304z"]
};
var faCompressArrows = faArrowsMinimize;
var faAudioDescription = {
  prefix: 'fal',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm192 64c6.1 0 11.6 3.4 14.3 8.8l80 160c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L238.1 304H145.9l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l80-160c2.7-5.4 8.3-8.8 14.3-8.8zm30.1 112L192 211.8 161.9 272h60.2zM304 176c0-8.8 7.2-16 16-16h64c53 0 96 43 96 96s-43 96-96 96H320c-8.8 0-16-7.2-16-16V176zm32 16V320h48c35.3 0 64-28.7 64-64s-28.7-64-64-64H336z"]
};
var faPersonMilitaryToPerson = {
  prefix: 'fal',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M176 33.1V46.8H88V44.9l88-11.7zM180.8 .2L76.8 14.1C64.9 15.6 56 25.8 56 37.8V54.8c0 13.3 10.7 24 24 24H184c13.3 0 24-10.7 24-24V24C208 9.5 195.2-1.7 180.8 .2zM352 96.6a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM320 256.5c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v31.8H320V256.5zm-32 0v31.8c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256.5c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64zm-171.5-32H160c17.7 0 32 14.3 32 32v13.2l-75.5-45.2zm44.2 63.8H64V256.5c0-8.2 3.1-15.6 8.1-21.3l88.7 53.1zM96 192.5c-35.3 0-64 28.7-64 64v31.8c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V256.5c0-35.3-28.7-64-64-64H96zM64 96.6c0 35.3 28.7 63.9 64 63.9s64-28.6 64-63.9H160c0 17.6-14.3 31.9-32 31.9s-32-14.3-32-31.9H64zm82.6 259.6c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6l40.5 35.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H165.9l-40.5 35.9c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l72-63.9c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-72-63.9zm218.8 0l-72 63.9c-3.4 3-5.4 7.4-5.4 12s2 8.9 5.4 12l72 63.9c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6l-40.5-35.9H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.1l40.5-35.9c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3z"]
};
var faFileShield = {
  prefix: 'fal',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M320 480c1.3 0 2.6-.1 3.9-.2c7.9 8.6 16.6 16.9 26.3 24.7c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V207l-32 12.8V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320zm31.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM320.1 301.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L448 263V471.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"]
};
var faHexagon = {
  prefix: 'fal',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", "M16 224c-11.4 19.8-11.4 44.2 0 64l92.3 159.8c11.4 19.8 32.6 32 55.4 32l184.6 0c22.9 0 44-12.2 55.4-32L496 288c11.4-19.8 11.4-44.2 0-64L403.7 64.2c-11.4-19.8-32.6-32-55.4-32l-184.6 0c-22.9 0-44 12.2-55.4 32L16 224zm27.7 48c-5.7-9.9-5.7-22.1 0-32L136 80.2c5.7-9.9 16.3-16 27.7-16l184.6 0c11.4 0 22 6.1 27.7 16L468.3 240c5.7 9.9 5.7 22.1 0 32L376 431.8c-5.7 9.9-16.3 16-27.7 16l-184.6 0c-11.4 0-22-6.1-27.7-16L43.7 272z"]
};
var faManhole = {
  prefix: 'fal',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM201.6 122.6C215.8 135.9 235 144 256 144s40.2-8.1 54.4-21.4C363 144.1 400 195.8 400 256s-37 111.9-89.6 133.4C296.2 376.1 277 368 256 368s-40.2 8.1-54.4 21.4C149 367.9 112 316.2 112 256s37-111.9 89.6-133.4zm-1-33.7C130.5 112.1 80 178.2 80 256s50.5 143.9 120.6 167.1c7.1 2.4 14.6-1.4 19.6-7C229 406.2 241.8 400 256 400s27 6.2 35.8 16.1c5 5.6 12.4 9.4 19.6 7C381.5 399.9 432 333.8 432 256s-50.5-143.9-120.6-167.1c-7.1-2.4-14.6 1.4-19.6 7C283 105.8 270.2 112 256 112s-27-6.2-35.8-16.1c-5-5.6-12.4-9.4-19.6-7zM176 192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48-112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
var faUserSlash = {
  prefix: 'fal',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M448 128C448 57.3 390.7 0 320 0C266.1 0 219.9 33.4 201.1 80.6l26.6 21C239.2 61.4 276.1 32 320 32c53 0 96 43 96 96c0 35.9-19.7 67.2-48.9 83.7l26.6 21C426.6 209.5 448 171.2 448 128zm52.4 352H128c1.2-79.7 66.2-144 146.3-144H318l-40.5-32h-3.2C175.8 304 96 383.8 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c7 0 13.4-2.4 18.5-6.5L500.4 480zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPen = {
  prefix: 'fal',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6 159.6 428.9c-7.6 7.6-16.9 13.1-27.2 16.1L39.6 472.4l27.3-92.8c3-10.3 8.6-19.6 16.1-27.2L318.4 117zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17z"]
};
var faTowerObservation = {
  prefix: 'fal',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", "M248.8 1.7c4.5-2.3 9.8-2.3 14.3 0l176 88c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-8.8-4.4V192c0 26.5-21.5 48-48 48h-7.8l39.6 237.4c.1 .9 .2 1.8 .2 2.6h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c0-.9 .1-1.7 .2-2.6L151.8 240H144c-26.5 0-48-21.5-48-48V113.9l-8.8 4.4c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l176-88zM256 33.9l-128 64V128H384V97.9l-128-64zM128 160v32c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V160H128zM359.4 480L256 391.4 152.6 480H359.4zM184 240c0 .9-.1 1.7-.2 2.6l-6.5 39.1L256 349.2l78.7-67.5-6.5-39.1c-.1-.9-.2-1.8-.2-2.6H184zm-12.9 78.6L151 439.2l80.4-68.9-60.3-51.7zm109.5 51.7L361 439.2 340.9 318.6l-60.3 51.7z"]
};
var faFloppyDisks = {
  prefix: 'fal',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M128 352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V138.5c0-8.5-3.4-16.6-9.4-22.6L396.1 41.4c-3.4-3.4-7.6-6-12.1-7.6V112c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V32c-17.7 0-32 14.3-32 32V352zM352 32H192v80H352V32zM192 0H373.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h32zM32 112V368c0 61.9 50.1 112 112 112H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H144C64.5 512 0 447.5 0 368V112c0-8.8 7.2-16 16-16s16 7.2 16 16zM296 304a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-112a72 72 0 1 1 0 144 72 72 0 1 1 0-144z"]
};
var faToiletPaperBlankUnder = {
  prefix: 'fal',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", "M58.2 75.2C42.3 104.3 32 145.5 32 192s10.3 87.7 26.2 116.8C74.4 338.5 94.1 352 112 352H337.3c-7.2-8.2-13.6-17.7-19.2-27.9C299.2 289.5 288 242.8 288 192s11.2-97.5 30.1-132.1c5.6-10.2 12-19.6 19.2-27.9H112C94.1 32 74.4 45.5 58.2 75.2zM400 32c-17.9 0-37.6 13.5-53.8 43.2C330.3 104.3 320 145.5 320 192s10.3 87.7 26.2 116.8C362.4 338.5 382.1 352 400 352s37.6-13.5 53.8-43.2C469.7 279.7 480 238.5 480 192s-10.3-87.7-26.2-116.8C437.6 45.5 417.9 32 400 32zm80 432V327.6c-18.6 32.3-46.1 56.4-80 56.4H112c-35.1 0-63.4-25.9-81.9-59.9C11.2 289.5 0 242.8 0 192S11.2 94.5 30.1 59.9C48.6 25.9 76.9 0 112 0H400c35.1 0 63.4 25.9 81.9 59.9C500.8 94.5 512 141.2 512 192V464c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V416h32v48c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16zM400 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16z"]
};
var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
var faFileCode = {
  prefix: 'fal',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm91.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L118.6 336l36.7-36.7zm144 25.4l-48-48c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 336l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSignal = {
  prefix: 'fal',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", "M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM448 96c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM192 288c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-8.8-7.2-16-16-16z"]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faPump = {
  prefix: 'fal',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M76.9 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V208H32V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v32V384v32c0 8.8 7.2 16 16 16s16-7.2 16-16V400H320V368H32V240h80c8.8 0 16-7.2 16-16V32H256V224c0 8.8 7.2 16 16 16h48V208H288V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H272 112 76.9zM449.6 133.4c5.3-3.5 11.4-5.4 17.8-5.4H576c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H467.4c-6.3 0-12.5-1.9-17.8-5.4l-51.4-34.3c-8.9-5.9-14.2-15.9-14.2-26.6V194.3c0-10.7 5.3-20.7 14.2-26.6l51.4-34.3zM431.9 501.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3V413.7c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16z"]
};
var faBus = {
  prefix: 'fal',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", "M288 32C170.1 32 113.2 70.2 97.2 90c-.4 .5-1.2 1.9-1.2 5.1V128H480V95.2c0-3.1-.8-4.9-1.3-5.6C463.9 70.1 414.8 32 288 32zM96 256H272V160H96v96zm208 0H480V160H304v96zM96 384c0 17.7 14.3 32 32 32H367.2 448c17.7 0 32-14.3 32-32V288H96v96zM72.3 69.9C96.5 40.1 164.2 0 288 0C420.6 0 481.2 40 504.2 70.2c6 7.9 7.8 17.2 7.8 25V384c0 23.7-12.9 44.4-32 55.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H367.2 128l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V439.4C76.9 428.4 64 407.7 64 384V95.2c0-7.7 1.8-17.2 8.3-25.3zM136 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM240 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 144v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm544 0v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHeartCircleXmark = {
  prefix: 'fal',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowUpLeftFromCircle = {
  prefix: 'fal',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M176 0H16C7.2 0 0 7.2 0 16V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L300.7 323.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 32H176c8.8 0 16-7.2 16-16s-7.2-16-16-16zM288 64c-8.8 0-16 7.2-16 16s7.2 16 16 16c106 0 192 86 192 192s-86 192-192 192S96 394 96 288c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z"]
};
var faHouseChimney = {
  prefix: 'fal',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V480h64c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM336 320H240V480h96V320z"]
};
var faHomeLg = faHouseChimney;
var faWindowMaximize = {
  prefix: 'fal',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M64 64C46.3 64 32 78.3 32 96v96H480V96c0-17.7-14.3-32-32-32H64zM32 224V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V224H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faDryer = {
  prefix: 'fal',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 96A24 24 0 1 0 80 96a24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 296c-56.4 0-103.1-41.7-110.9-96H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H113.1c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112s-50.1 112-112 112zM80 304a144 144 0 1 0 288 0A144 144 0 1 0 80 304z"]
};
var faFaceFrown = {
  prefix: 'fal',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faFrown = faFaceFrown;
var faChessBishopPiece = {
  prefix: 'fal',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", "M96 32h32 32c8.8 0 16 7.2 16 16c0 6-3.3 11.2-8.1 13.9c4 4.2 8.2 8.8 12.4 13.8C201.4 101.1 224 138.7 224 184c0 16.6-4.4 30.1-10.8 40.9C219.5 227 224 233 224 240c0 8.8-7.2 16-16 16H196.1l9.6 96H173.5l-9.6-96H92.1l-9.6 96H50.3l9.6-96H48c-8.8 0-16-7.2-16-16c0-7 4.5-13 10.8-15.1C36.4 214.1 32 200.6 32 184c0-45.3 22.6-82.9 43.7-108.2c4.2-5 8.4-9.7 12.4-13.8C83.3 59.2 80 54 80 48c0-8.8 7.2-16 16-16zm75.5 192c10.2-7.5 20.5-19.8 20.5-40c0-18.9-5.2-36.6-13-52.4l-31.7 31.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l37-37c-2-2.6-3.9-5.1-5.9-7.5C146.4 85.1 137 76.2 130 70.1c-.7-.6-1.4-1.2-2-1.7c-.6 .5-1.3 1.1-2 1.7c-7 6.1-16.4 15-25.7 26.2C81.4 118.9 64 149.3 64 184c0 20.2 10.3 32.5 20.5 40h87.1zm45.9 175.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H190.2c11.1 0 21.4 5.7 27.2 15.1zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H216.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416z"]
};
var faChessBishopAlt = faChessBishopPiece;
var faShirtTankTop = {
  prefix: 'fal',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M96 16C96 7.2 88.8 0 80 0S64 7.2 64 16c0 134.3-29.3 192.6-45.6 214.6C9.5 242.5 0 259.2 0 278.2V456c0 30.9 25.1 56 56 56H328c30.9 0 56-25.1 56-56V278.2c0-19-9.5-35.7-18.4-47.6C349.3 208.6 320 150.3 320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64c0 53-43 96-96 96s-96-43-96-96V16zM86.5 136.5C109.6 170 148.2 192 192 192s82.4-22 105.5-55.5c10.7 59.8 28.4 94.1 42.4 113.1c7.6 10.2 12.1 20 12.1 28.6V456c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V278.2c0-8.6 4.6-18.4 12.1-28.6c14-19 31.7-53.3 42.4-113.1z"]
};
var faDiploma = {
  prefix: 'fal',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M253.2 80.8C245 70.2 232.4 64 219 64h-3c-22.1 0-40 17.9-40 40s17.9 40 40 40h40 45.8L253.2 80.8zm-97 63.2c-7.7-11.4-12.1-25.2-12.1-40c0-39.8 32.2-72 72-72h3c23.3 0 45.3 10.8 59.5 29.3L320 115.2l41.5-53.9C375.7 42.8 397.7 32 421 32h3c39.8 0 72 32.2 72 72c0 14.8-4.5 28.6-12.1 40H544c65.1 .3 96 71.5 96 128c0 56.9-24.1 119.2-81 140.7c-10.5 4-22.5 4.2-33.4 1.8L400 386.6V464c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7L320 449.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6V386.6L114.4 414.5l-6.9-31.2L240 353.8V176H216 96.1c-18.9 .1-33.9 9.9-45.5 28.1C38.5 223.1 32 248.8 32 272c0 50.8 21.4 96.1 60.3 110.8c3.5 1.3 9.1 1.8 15.1 .5l6.9 31.2c-10.9 2.4-22.9 2.2-33.4-1.8C24.1 391.2 0 328.9 0 272c0-56.5 30.9-127.7 96-128h60.1zM400 176V353.8l132.6 29.5c6 1.3 11.6 .9 15.1-.5c38.9-14.7 60.3-60 60.3-110.8c0-23.2-6.5-48.9-18.6-67.9c-11.6-18.2-26.6-28-45.5-28.1H424 400zm24-32c22.1 0 40-17.9 40-40s-17.9-40-40-40h-3c-13.4 0-26 6.2-34.1 16.8L338.2 144H384h40zm-88 32H304 272V438.1l40.8-20.4c4.5-2.3 9.8-2.3 14.3 0L368 438.1V176H336z"]
};
var faScrollRibbon = faDiploma;
var faScreencast = {
  prefix: 'fal',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", "M512 64H64C46.3 64 32 78.3 32 96v96.1c-2.7-.1-5.3-.1-8-.1H0V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H288V456c0-2.7 0-5.3-.1-8H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM16 224c132.5 0 240 107.5 240 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 336c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16z"]
};
var faWalker = {
  prefix: 'fal',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M178.8 32H320c26.5 0 48 21.5 48 48V192H103.4L132 69.1C137.1 47.4 156.5 32 178.8 32zM368 224V386c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V80c0-44.2-35.8-80-80-80H178.8c-37.2 0-69.5 25.6-77.9 61.8L.4 492.4c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9L96 223.6v.4H368zm48 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faPrescription = {
  prefix: 'fal',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M31.1 0C13.9 0 0 13.9 0 31.1V208v96c0 8.8 7.2 16 16 16s16-7.2 16-16V224H137.4l128 128L132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 374.6 420.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L310.6 352 443.3 219.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L288 329.4 182.4 223.8C241.3 220.5 288 171.7 288 112C288 50.1 237.9 0 176 0H31.1zM144 192s0 0 0 0H32V32H176c44.2 0 80 35.8 80 80s-35.8 80-80 80H144z"]
};
var faShop = {
  prefix: 'fal',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 21.1-17.1 38.2-38.2 38.2H576V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H96V352H352V272 256h32v16V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zM80 192H560h41.8c3.4 0 6.2-2.8 6.2-6.2c0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3h-391c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5 .9-.8 1.9-.8 3c0 3.4 2.8 6.2 6.2 6.2H80zM96 464c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V384H96v80z"]
};
var faStoreAlt = faShop;
var faFloppyDisk = {
  prefix: 'fal',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V65.8c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM96 64H288v96H96V64zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
};
var faSave = faFloppyDisk;
var faVihara = {
  prefix: 'fal',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M309.8 3.7l-26.3 21c-33.9 27.1-72.3 48-113.5 61.8l-31 10.3c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l10.9-3.6v47.2c-28.9 33.7-67.6 57.6-110.7 68.4l-4.8 1.2c-1.3 .3-2.5 .7-3.6 1.3c-2.1 1.1-4 2.6-5.4 4.4s-2.5 4-3 6.3c-.4 1.8-.5 3.6-.3 5.5s.8 3.6 1.6 5.2c1.1 2.1 2.6 4 4.4 5.4s4 2.5 6.3 3c1.2 .3 2.5 .4 3.9 .4H96v61.6c-14.7 31.3-38.9 57.3-69.2 74.1L8.5 417.9c-.6 .3-1.2 .7-1.7 1.1c-1.9 1.3-3.5 3-4.6 5s-1.9 4.1-2.1 6.4c-.2 1.9-.1 3.8 .4 5.7s1.3 3.6 2.4 5.2c1.3 1.9 3 3.5 5 4.6s4.1 1.9 6.4 2.1c.7 .1 1.3 .1 2 .1H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448H224v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64 64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448H544v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h47.7c.7 0 1.4 0 2-.1c2.3-.2 4.5-1 6.4-2.1s3.6-2.7 5-4.6c1.1-1.6 1.9-3.3 2.4-5.2s.6-3.8 .4-5.7c-.2-2.3-1-4.5-2.1-6.4s-2.7-3.6-4.6-5c-.6-.4-1.1-.7-1.7-1.1l-18.3-10.2c-30.3-16.8-54.5-42.8-69.2-74.1V272h47.7c1.3 0 2.6-.1 3.9-.4c2.3-.5 4.5-1.6 6.3-3s3.4-3.3 4.4-5.4c.8-1.6 1.4-3.4 1.6-5.2s.1-3.7-.3-5.5c-.5-2.3-1.6-4.5-3-6.3s-3.3-3.4-5.4-4.4c-1.1-.6-2.4-1-3.6-1.3l-4.8-1.2c-43.2-10.8-81.8-34.7-110.7-68.4V123.5l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L470 86.5c-41.2-13.7-79.6-34.6-113.5-61.8l-26.3-21c-1.1-.9-2.2-1.6-3.4-2.2C324.7 .5 322.3 0 320 0s-4.7 .5-6.8 1.5c-1.2 .6-2.4 1.3-3.4 2.2zM128 352H320 512h5.4c12.5 24.8 30 46.6 51.3 64H320 71.3c21.3-17.4 38.8-39.2 51.3-64H128zm0-32V272H320 512v48H320 128zm64-160V112.7c40.3-14.9 77.9-36.1 111.5-62.9L320 36.5l16.5 13.2c33.6 26.8 71.2 48.1 111.5 62.9V160H320 192zm128 80H128.1c20.8-13 39.7-29.2 55.9-48H320 456c16.2 18.8 35.1 35 55.9 48H320z"]
};
var faFaceKissClosedEyes = {
  prefix: 'fal',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm277.4 47.1c-11-5.4-25.7-9.3-39.1-11.2c-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-1.1 .5-2.1 1-3.3 1.5c1.1 .5 2.2 1 3.3 1.5c6.9 3.4 13.6 7.7 18.7 13c5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13c-13.9 6.8-31.2 11.3-46.3 13.4c-6.6 .9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8c-10.9-5.4-25.5-9.3-38.8-11.2c-.9-.1-1.8-.3-2.7-.6c-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8 .7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6c13.3-1.9 27.9-5.8 38.8-11.2c5.5-2.7 9.5-5.5 11.9-8c2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zm-66.2-69.5c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faScaleUnbalanced = {
  prefix: 'fal',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M527.8 10.9c2.8 8.4-1.7 17.4-10.1 20.2L383.5 75.9c-4.6 24.4-23.1 43.9-46.9 50.1V480h192c8.8 0 16 7.2 16 16s-7.2 16-16 16h-208c-8.8 0-16-7.2-16-16V126c-10.3-2.6-19.6-7.8-27.2-14.7L133.7 159.2c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L259.7 83.5c-2-6.1-3-12.7-3-19.5c0-35.3 28.7-64 64-64c28 0 51.8 18 60.5 43L507.6 .8C516-2 525 2.6 527.8 10.9zM440.7 330.3C457.8 343.1 482.9 352 512 352s54.2-8.9 71.3-21.7C600.4 317.5 608 302.2 608 288H416v-1.6l0 .1V288c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 256H597.7L512 115.3zM384 288v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2C492.8 85.2 502.1 80 512 80s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V288c0 53-57.3 96-128 96s-128-43-128-96zM32 416c0 14.2 7.6 29.5 24.7 42.3C73.8 471.1 98.9 480 128 480s54.2-8.9 71.3-21.7C216.4 445.5 224 430.2 224 416H32v-1.6l0 .1V416zm10.3-32H213.7L128 243.3 42.3 384zM128 512C57.3 512 0 469 0 416v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V416c0 53-57.3 96-128 96zM320.7 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faFileUser = {
  prefix: 'fal',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M320 480H304V464c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80v16H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zm-48-16v16H112V464c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faUserPoliceTie = {
  prefix: 'fal',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M230.9 .8l144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2L368 109.3v1.6c0 15.6-7.6 31.8-23.2 40.1c-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9v-1.6L57.4 86.6C49.1 78.4 46 66.3 49.3 55.1s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3v8.2c0 5.8 2.8 10 6.2 11.8c11.9 6.3 30.3 13.8 58.4 18C163.8 121.1 160 98.9 160 83.2c0-6.5 4-12.4 10.1-14.9l48-19.2c3.8-1.5 8.1-1.5 11.9 0l48 19.2C284 70.8 288 76.7 288 83.2c0 15.7-3.8 37.9-16.5 57.5c28.1-4.2 46.5-11.7 58.4-18c3.4-1.8 6.2-6 6.2-11.8v-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-6.1l18.4 36.9 51.6-68.7C391.2 355.4 448 414.3 448 486.4c0 14.1-11.5 25.6-25.6 25.6H240 208 25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7L198.1 384H192c-8.8 0-16-7.2-16-16zm48 35.8l-22.9 45.7 2.9 3.8L224 480l0 0 0 0 20-26.7 2.9-3.8L224 403.8zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480H184zm80 0H415.8c-2.9-46.5-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9 .1-5.8 .3-8.7c9.1 4.3 19.6 8.5 31.8 12.1c1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128zm128-49.7c20.5-11.3 28.9-31.3 31.3-48.5L224 81.2 192.7 93.7c2.3 17.3 10.8 37.3 31.3 48.5z"]
};
var faFaceTongueMoney = {
  prefix: 'fal',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm96 32c-17.1 0-33.2 14.3-31 33.7c4.8 43.9 27.4 82.4 60.3 108.2l4.3 3.4C169.7 478 208.9 512 256 512s86.3-34 94.5-78.7l4.3-3.4c32.9-25.8 55.4-64.3 60.3-108.2c2.1-19.4-13.9-33.7-31-33.7H352 320 192 160 128zm160 32h32v32 64c0 35.3-28.7 64-64 64s-64-28.7-64-64V352 320h32 64zm-159 0h31v68.7c-16.6-18.8-27.8-42.5-31-68.7zm254 0c-3.3 26.1-14.4 49.9-31 68.7V320h31zM192 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.3 9 27.2 11.2l1.1 .3c9.6 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V248c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V104zM336 88c-8.8 0-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.4 9 27.2 11.2l1.1 .3c9.5 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V248c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V104c0-8.8-7.2-16-16-16zM267.2 347.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6v6.8c-4.3 .8-8.7 2.4-12.7 5.2c-5.6 4-9.5 9.8-10.8 17.2c-.9 5.3-.5 10.6 1.7 15.4c2.2 4.8 5.7 8.2 9.3 10.6c6.3 4.2 14.5 6.5 20.4 8.1l.8 .2c7.2 2 11.5 3.3 14.1 5.1c1.9 1.3 1.6 4.6-.4 5.8l0 0c-.9 .5-2.8 1.1-6.6 1.1c-7.6-.1-16.9-2.9-24-5.2c-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4v7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6v-6.5c3.6-.6 7.3-1.8 10.8-3.8c6.8-4 11.2-10.5 12.7-18.9c.9-5.3 .5-10.6-1.7-15.4c-2.2-4.8-5.7-8.2-9.3-10.6c-5.4-3.6-11.7-5.2-17.9-6.8c-6.2-1.6-12.3-3.2-17.5-6.6c-1.8-1.2-1.8-3.9 .2-5.2c.7-.5 2.3-1.2 5.3-1.5c6.1-.6 14 .7 20.2 2.3c6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2v-7.2z"]
};
var faTennisBall = {
  prefix: 'fal',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M256.6 480c-4.5-58.4 15.6-118.4 60.3-163.1s104.6-64.8 163.1-60.3c0-.2 0-.4 0-.6C480 132.3 379.7 32 256 32c-.2 0-.4 0-.6 0c4.5 58.4-15.6 118.4-60.3 163.1S90.4 259.9 32 255.4c0 .2 0 .4 0 .6c0 123.7 100.3 224 224 224c.2 0 .4 0 .6 0zm31.9-2.3c97.7-14.2 174.9-91.4 189.1-189.1c-49.5-3.8-100.3 13.2-138.1 51s-54.8 88.6-51 138.1zM223.5 34.3C125.8 48.6 48.6 125.8 34.3 223.5c49.5 3.8 100.3-13.2 138.1-51s54.8-88.6 51-138.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSquareL = {
  prefix: 'fal',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48V352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSortUp = {
  prefix: 'fal',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", "M154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2L154.4 66.2zm-22-23.3L12.3 156.4C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.5L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9z"]
};
var faSortAsc = faSortUp;
var faCalendarArrowUp = {
  prefix: 'fal',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM208 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 294.6 208 416z"]
};
var faCalendarUpload = faCalendarArrowUp;
var faCommentDots = {
  prefix: 'fal',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM128 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommenting = faCommentDots;
var faPlantWilt = {
  prefix: 'fal',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M288 96c0-35.3 28.7-64 64-64s64 28.7 64 64v33.1c-38.4 5.7-64 32.2-64 73.9c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-41.7-25.6-68.3-64-73.9V96c0-53-43-96-96-96s-96 43-96 96v65.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112v17.1c-38.4 5.7-64 32.2-64 73.9C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-41.7-25.6-68.3-64-73.9V240c0-44.2 35.8-80 80-80s80 35.8 80 80v40V496c0 8.8 7.2 16 16 16s16-7.2 16-16V280 240 96zm128 65.7V192c0 8.8 7.2 16 16 16s16-7.2 16-16V161.7c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 5.8-3.3 18.8-13.5 36.5c-8.3 14.5-20.1 30-34.5 44.3c-14.4-14.3-26.2-29.9-34.5-44.3c-10.2-17.7-13.5-30.7-13.5-36.5c0-15.8 5.3-25.6 11.9-31.6c4.6-4.2 11.2-7.8 20.1-9.8zM43.9 299.5c4.6-4.2 11.2-7.8 20.1-9.8v30.6c0 8.8 7.2 16 16 16s16-7.2 16-16V289.7c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 5.8-3.3 18.8-13.5 36.5c-8.3 14.5-20.1 30-34.5 44.3C65.6 397.6 53.8 382 45.5 367.6C35.3 349.8 32 336.9 32 331.1c0-15.8 5.3-25.6 11.9-31.6z"]
};
var faScarf = {
  prefix: 'fal',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", "M221.4 32h69.1c17.3 0 33.3 9.4 41.8 24.5l41.5 73.8c6.6 11.8 10.1 25.1 10.1 38.6c0 20.9-8.3 40.9-23 55.6l-9 9L246.6 128H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H227.3c-21.4 0-32.1 25.9-17 41L340.7 267.3 385.4 312 312 385.4l-161-161c-14.8-14.7-23-34.8-23-55.6c0-13.5 3.5-26.8 10.1-38.6l41.5-73.8C188.1 41.4 204.1 32 221.4 32zM374.6 256l9-9c20.8-20.8 32.4-48.9 32.4-78.2c0-19-4.9-37.7-14.2-54.2L360.3 40.8C346.1 15.6 319.5 0 290.6 0H221.4c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8C100.9 131.1 96 149.8 96 168.8c0 29.3 11.7 57.5 32.4 78.2L300.7 419.3l8 8 0 0 3.3 3.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L334.6 408 360 382.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L382.6 360 408 334.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L430.6 312l-3.3-3.3 0 0-8-8L374.6 256zM233.4 397.3l-22.6-22.6L100.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L233.4 397.3zm-48-48l-22.6-22.6L52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L185.4 349.3zm-48-48l-22.6-22.6L4.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L137.4 301.3z"]
};
var faAlbumCirclePlus = {
  prefix: 'fal',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faUserNurseHairLong = {
  prefix: 'fal',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M128 144V76.9l96-42 96 42V144H128zM96 76.9V144v16c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2C37.5 259.9 32 270.9 32 282.7C32 303.3 48.7 320 69.3 320H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H69.3c-2.9 0-5.3-2.4-5.3-5.3c0-1.7 .8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.3C129.5 274.6 173.3 304 224 304s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.3l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3c0 2.9-2.4 5.3-5.3 5.3H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h58.7c20.6 0 37.3-16.7 37.3-37.3c0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 228.4 352 195.3 352 160V144 76.9c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176v0c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48h21.5c35.5 0 68.3-18.3 87-48H320zm-112.8 0c-12.4 10.2-28.2 16-44.8 16h-33c-.9-5.2-1.3-10.5-1.3-16v0h79.2zM130.8 382l59.3 59.3c18.7 18.7 49.1 18.7 67.9 0L317.2 382c52.8 1.8 95.4 43.5 98.6 95.9H32.2c3.2-52.4 45.9-94.1 98.6-95.9zm20-25.3c-4.3-4.3-10.2-6.8-16.4-6.8C60.2 349.9 0 410.1 0 484.3c0 14.1 11.5 25.6 25.6 25.6H422.4c14.1 0 25.6-11.5 25.6-25.6c0-74.2-60.2-134.4-134.4-134.4c-6.1 0-12 2.4-16.4 6.8l-61.9 61.9c-6.2 6.2-16.4 6.2-22.6 0l-61.9-61.9zM208 56V72H192c-4.4 0-8 3.6-8 8V96c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104h16c4.4 0 8-3.6 8-8V80c0-4.4-3.6-8-8-8H240V56c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]
};
var faDiamond = {
  prefix: 'fal',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", "M250.3 34.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0l-216-216c-3.1-3.1-3.1-8.2 0-11.3l216-216zm33.9-22.6c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"]
};
var faSquareLeft = {
  prefix: 'fal',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM80 256c0-9.2 3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3c21.1 0 38.3 17.1 38.3 38.3l0 25.7 80 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-80 0 0 25.7c0 21.1-17.1 38.3-38.3 38.3c-10.7 0-20.9-4.5-28.1-12.3l-84-91C83.5 274 80 265.2 80 256zm33.2 3l84 91c1.2 1.3 2.9 2 4.6 2c3.5 0 6.3-2.8 6.3-6.3l0-41.7c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-41.7c0-3.5-2.8-6.3-6.3-6.3c-1.7 0-3.4 .7-4.6 2l-84 91c-.8 .8-1.2 1.9-1.2 3s.4 2.2 1.2 3z"]
};
var faArrowAltSquareLeft = faSquareLeft;
var faFaceGrinSquint = {
  prefix: 'fal',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faGrinSquint = faFaceGrinSquint;
var faCircleEllipsisVertical = {
  prefix: 'fal',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHandHoldingDollar = {
  prefix: 'fal',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M304 24V41.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.3 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V232c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.2c-11.2-2.1-21.7-5.7-30.9-8.9c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3C224 71.1 234.9 57.7 247.9 50c7.5-4.4 15.8-7.2 24.1-8.7V24c0-8.8 7.2-16 16-16s16 7.2 16 16zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faGridDividers = {
  prefix: 'fal',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", "M0 16C0 7.2 7.2 0 16 0H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM64 128v64h64V128H64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128zM64 416v64h64V416H64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V416zM288 128H224v64h64V128zM224 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 320v64h64V416H224zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416zM448 128H384v64h64V128zM384 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 320v64h64V416H384zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V416zM16 288H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBacterium = {
  prefix: 'fal',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M415.4 20.4c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-6 20.9c-11.7-1.1-23.8-.4-35.8 2.4c-13.7 3.2-26.9 6.8-39.5 10.8l-8.6-20c-3.5-8.1-12.9-11.9-21-8.4s-11.9 12.9-8.4 21l7.8 18.2c-27.3 10.9-51.7 23.8-73.5 38L189.3 79.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l10.8 16.2c-24.5 19-45 39.8-62.1 61.1L98 163.5c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5L92.4 200c-3.7 5.5-7.1 10.9-10.4 16.4c-10.4 17.4-19.8 36-27.5 55.4l-16.5-6.6c-8.2-3.3-17.5 .7-20.8 8.9s.7 17.5 8.9 20.8L43.9 302c-5.5 18.4-9.4 37.2-11.4 55.9c-.9 9.7-.5 19.3 1 28.5l-21.9 6.2C3.1 395-1.8 403.9 .6 412.4s11.3 13.4 19.8 11l22.8-6.5c10.9 22.5 29.2 40.9 51.9 51.9l-6.5 22.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l6.3-21.9c2.7 .4 5.4 .8 8.2 1c26.6 2.4 51.9-4.7 72.5-18.5l14.3 14.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13.1-13.1c13.6-16.4 22.7-36.8 25.2-59.4c1.1-7.5 3.2-15 5.9-22.2l20.5 8.8c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21l-18.8-8.1c10.8-17.2 28.2-37.7 58.4-54.3l2.7 9.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-3.9-13.8c9.1-3.3 19-6.2 29.7-8.7c17.6-4.1 33.3-12.1 46.4-22.9l13.1 13.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L461 206.4c15.4-23 22.3-51.7 17.5-80.7l21.9-6.3c8.5-2.4 13.4-11.3 11-19.8s-11.3-13.4-19.8-11l-22.8 6.5c-12.3-25.4-33.6-44.8-59-55.1l5.6-19.7zm-74.9 216c-.3 .1-.6 .1-.9 .2c-1.7 .5-3.2 1.2-4.6 2.2c-47.2 21.1-73.2 51-88.4 76.4c-10.1 16.9-19.5 37.7-22.9 60.1c-.1 .5-.1 .9-.2 1.4c-4.7 43.3-43.2 74.9-86.8 71c-43.9-4-76.3-42.8-72.4-86.7C69 317.1 86 271.9 109.4 232.8C149.4 166.1 222.8 95.4 350 66c43.1-9.9 86 16.9 95.9 60s-16.9 86-60 95.9c-16.9 3.9-32 8.8-45.5 14.4zM264 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 320a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]
};
var faHandPointer = {
  prefix: 'fal',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24V188.2c0 6.3 3.7 12 9.5 14.6s12.5 1.5 17.2-2.7c5.7-5.1 13.1-8.1 21.3-8.1c16.8 0 30.7 13 31.9 29.5c.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2c16.8 0 30.7 13 31.9 29.5c.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2c17.7 0 32 14.3 32 32v32 16 64c0 44.2-35.8 80-80 80H272 256 205.7c-36.1 0-70.3-16.3-93.1-44.3L37.4 343.1c-8.4-10.3-6.8-25.4 3.5-33.8s25.4-6.8 33.8 3.5l25 30.7c4.3 5.3 11.4 7.3 17.8 5s10.6-8.3 10.6-15.1V56zM152 0C121.1 0 96 25.1 96 56V288.8c-20-20.5-52.7-22.7-75.3-4.3C-3.3 304-7 339.3 12.5 363.3l75.2 92.5c28.9 35.5 72.2 56.2 118 56.2H256h16 64c61.9 0 112-50.1 112-112V336 320 288c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2V56c0-30.9-25.1-56-56-56zm72 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"]
};
var faDrumSteelpan = {
  prefix: 'fal',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M544 160c0-19.9-16.1-43.9-64.8-64.5C454.6 85.1 424.5 77 390.3 71.6c-21.4 61.1-16.2 121.3 21.2 173c25.5-5.2 48.4-11.9 67.7-20.1C527.9 203.9 544 179.9 544 160zM348.3 174.5C333.1 182.9 311.5 192 288 192s-45.1-9.1-60.3-17.5c-4.2 26.2-13.5 51.7-28.6 75.9c27.5 3.7 57.4 5.6 88.8 5.6s61.3-2 88.8-5.6c-15-24.2-24.4-49.7-28.6-75.9zm-2.6-36.1c.4-23.5 4.5-47.4 12.2-71C335.8 65.2 312.4 64 288 64s-47.8 1.2-69.9 3.4c7.7 23.6 11.8 47.5 12.2 71c3.3 2.3 7.4 5 12.2 7.6C255.6 153.5 272 160 288 160s32.4-6.5 45.5-13.9c4.7-2.7 8.9-5.3 12.2-7.7zM96.8 224.5c19.3 8.2 42.2 14.9 67.7 20.1c37.5-51.8 42.6-112 21.2-173C151.5 77 121.4 85.1 96.8 95.5C48.1 116.1 32 140.1 32 160s16.1 43.9 64.8 64.5zM576 160V344c0 47.6-38.6 81.6-89.5 102.9C434.7 468.6 364.4 480 288 480s-146.7-11.4-198.5-33.1C38.6 425.6 0 391.6 0 344V160C0 80 128.9 32 288 32s288 48 288 128zm-32 62.8C496.1 264.4 399.5 288 288 288s-208.1-23.6-256-65.2V344c0 27.4 22.3 53.4 69.9 73.4C148.5 436.9 214.2 448 288 448s139.5-11.1 186.2-30.6c47.6-19.9 69.8-46 69.8-73.4V222.8z"]
};
var faHandScissors = {
  prefix: 'fal',
  iconName: 'hand-scissors',
  icon: [544, 512, [], "f257", "M4.2 284.4c-2.4-33 22.4-61.8 55.5-64.2l72.8-5.3-76.3-21c-32-8.8-50.7-41.8-41.9-73.8s41.8-50.7 73.8-41.9l177.4 48.8c1.8-2.9 3.8-5.7 5.8-8.4L288 96c15.1-20.1 38.8-32 64-32l19.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L520 336c0 70.7-57.3 128-128 128l-40 0-40 0-8 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-2.2 .1-4.3 .3-6.4L68.4 339.8c-33 2.4-61.8-22.4-64.2-55.5zM62 252.1c-15.4 1.1-27 14.5-25.9 30s14.5 27 30 25.9L229.3 296c5.9-.4 11.6 2.4 14.7 7.5s3.3 11.4 .3 16.5c-2.7 4.7-4.3 10.2-4.3 16c0 14.7 10 27.2 23.6 30.9c4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8 .6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8c0 17.7 14.3 32 32 32l8 0 40 0 40 0c53 0 96-43 96-96l0-119.7c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C450.6 118.6 412.7 96 371.5 96L352 96c-15.1 0-29.3 7.1-38.4 19.2L297 137.4l51.6 15.3c8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8L206.6 144 79.4 109c-14.9-4.1-30.3 4.7-34.4 19.6s4.7 30.3 19.6 34.4l165.8 45.6c7.5 2.1 12.4 9.2 11.7 17s-7 13.8-14.8 14.4L62 252.1z"]
};
var faHandsPraying = {
  prefix: 'fal',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M283.4 32c-6.8 0-13.2 3.4-17.1 9L179.5 168.4C166.8 187 160 209 160 231.5v50.3c0 20-12.4 37.9-31.1 44.9L21.6 367c-8.3 3.1-17.5-1.1-20.6-9.4s1.1-17.5 9.4-20.6l107.2-40.2c6.2-2.3 10.4-8.3 10.4-15V231.5c0-28.9 8.7-57.2 25-81.1L239.9 23C249.7 8.6 266 0 283.4 0c14.2 0 27.2 5.7 36.6 14.8C329.5 5.7 342.4 0 356.6 0c17.4 0 33.7 8.6 43.5 23L487 150.4c16.3 23.9 25 52.2 25 81.1v50.3c0 6.7 4.1 12.6 10.4 15L629.6 337c8.3 3.1 12.5 12.3 9.4 20.6s-12.3 12.5-20.6 9.4L511.1 326.8c-18.7-7-31.1-24.9-31.1-44.9V231.5c0-22.5-6.8-44.5-19.5-63.1L373.7 41c-3.8-5.6-10.2-9-17.1-9C345.2 32 336 41.2 336 52.6V59c0 5.3 1.6 10.5 4.5 15l51.3 76.9c15.8 23.7 24.2 51.4 24.2 79.9V232v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v74.2c0 48.9 31.7 92.1 78.3 106.8l214.5 67.8c8.4 2.7 13.1 11.6 10.4 20.1s-11.6 13.1-20.1 10.4L404.6 443.5c-37.5-11.8-67.4-38-84.6-71.3c-17.2 33.3-47.2 59.5-84.6 71.3L20.8 511.3c-8.4 2.7-17.4-2-20.1-10.4s2-17.4 10.4-20.1L225.7 413c46.6-14.7 78.3-57.9 78.3-106.8V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V232v-1.2c0-28.4 8.4-56.2 24.2-79.9L299.5 74c3-4.4 4.5-9.6 4.5-15V52.6c0-11.4-9.2-20.6-20.6-20.6zM320 100.8l-45.2 67.8c-1.8 2.7-3.5 5.5-5 8.3c3.3-.6 6.7-.9 10.2-.9c15.7 0 29.8 6.4 40 16.8c10.2-10.4 24.3-16.8 40-16.8c3.5 0 6.9 .3 10.2 .9c-1.6-2.8-3.2-5.6-5-8.3L320 100.8z"]
};
var faPrayingHands = faHandsPraying;
var faFacePensive = {
  prefix: 'fal',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 384h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM387.2 270.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM81.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5 .7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"]
};
var faUserMusic = {
  prefix: 'fal',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H289.4c2.5 12.2 8.2 23 16.1 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.5 0 83.3 15.6 114.3 41.4v40.2c-1.5 0-2.9 0-4.4 .1C352.8 355.3 313.5 336 269.7 336H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm501.9 39.8c20.7-6.9 42.1 8.5 42.1 30.4V248 392c0 1.1-.1 2.2-.3 3.2c.2 1.6 .3 3.2 .3 4.8c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V270.2L448 323.5V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V312 251.5c0-13.8 8.8-26 21.9-30.4l160-53.3zM448 289.8l160-53.3V198.2L448 251.5v38.3zM608 400c0-.9-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3zM416 464c0-.9-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3z"]
};
var faArrowRotateRight = {
  prefix: 'fal',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M464 192c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H464z"]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faMessagesDollar = {
  prefix: 'fal',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", "M183.5 294.4L128 336V320c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H202.7c-6.9 0-13.7 2.2-19.2 6.4zM202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v32 16c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320zM256 384c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V480 448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448v32H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H544c-17.7 0-32 14.3-32 32v16l-55.5-41.6c-5.5-4.2-12.3-6.4-19.2-6.4H320c-17.7 0-32-14.3-32-32V352H256v32zM224 79.1c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.6c-6 1.3-12.1 3.4-17.6 6.6c-11.1 6.4-20.9 17.8-20.8 34.7c.1 16.2 9.8 26.2 19.9 32.2c8.8 5.1 19.7 8.4 28.4 10.9l1.4 .4c10.1 3 17.4 5.3 22.5 8.4c4.2 2.5 4.5 4.1 4.5 5.9c0 3.5-1.2 5.7-4.6 7.7c-4 2.4-10.4 3.9-17.3 3.7c-9-.3-17.3-3-28.2-6.6l0 0 0 0c-1.8-.6-3.8-1.2-5.8-1.9c-8.4-2.7-17.4 1.9-20.2 10.3s1.9 17.4 10.3 20.2c1.6 .5 3.2 1 4.9 1.6l0 0 0 0c6.6 2.2 14.3 4.8 22.5 6.5v10.9c0 8.8 7.2 16 16 16s16-7.2 16-16V230.6c6.4-1.3 12.7-3.5 18.4-7c11.4-6.9 20.2-18.8 20-35.5c-.2-16.2-9.6-26.5-19.8-32.8c-9.2-5.6-20.7-9-29.6-11.6l-.5-.2c-10.2-3-17.6-5.2-22.7-8.2c-4.1-2.4-4.1-3.6-4.1-4.6l0-.1c0-2.5 .9-4.5 4.8-6.8c4.4-2.5 11-4 17.4-3.9c7.7 .1 16.2 1.8 25 4c8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-5.2-1.3-10.9-2.7-16.8-3.6V79.1z"]
};
var faCommentsAltDollar = faMessagesDollar;
var faSensorOn = {
  prefix: 'fal',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 96c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zM600.2 93.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-21.9-5.5l-80 48c-7.6 4.5-10 14.4-5.5 22s14.4 10 21.9 5.5l80-48zM528 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H528zm-7.8 130.3c-7.6-4.5-17.4-2.1-21.9 5.5s-2.1 17.4 5.5 21.9l80 48c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-80-48z"]
};
var faBalloon = {
  prefix: 'fal',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M205.6 405.8l0 0 0 0 0 0L192 415.3l-13.6-9.5 0 0 0 0 0 0 0 0-.2-.2-1.1-.8c-1-.7-2.6-1.9-4.6-3.4c-4-3-9.9-7.6-17-13.5c-14.2-11.8-33.1-28.8-51.8-49.4C65 295.9 32 243.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 51.6-33 103.9-71.7 146.5c-18.8 20.6-37.6 37.6-51.8 49.4c-7.1 5.9-12.9 10.5-17 13.5c-2 1.5-3.6 2.7-4.6 3.4l-1.1 .8-.2 .2 0 0zM192 439.6l3.4 6.8L212.2 480H171.8l16.8-33.7 3.4-6.8zM0 192C0 320 160 432 160 432l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H243.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L224 432s160-112 160-240C384 86 298 0 192 0S0 86 0 192zm112-16c0-35.3 28.7-64 64-64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faBiohazard = {
  prefix: 'fal',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M147.2 6.4c3-4 7.8-6.4 12.8-6.4h.9c4.6 0 8.9 1.9 11.9 5.3s4.5 7.9 4 12.4c-3.5 30.8 4.4 62.5 22.7 86.3c18 23.3 47 40 88.5 40s70.4-16.6 88.5-40c18.4-23.7 26.2-55.5 22.7-86.3c-.5-4.5 .9-9.1 4-12.4s7.4-5.3 11.9-5.3h.9c5 0 9.8 2.4 12.8 6.4C450.9 35.8 464 72.4 464 112c0 18.6-2.9 36.5-8.2 53.3c15.5 3.9 30.6 10 45.1 18.3c34.3 19.8 59.4 49.4 73.9 83.3c2 4.6 1.7 9.9-.9 14.3l-.5 .8c-2.3 3.9-6.1 6.7-10.6 7.7s-9.1-.1-12.8-2.8c-24.9-18.4-56.3-27.5-86.1-23.4c-29.2 4-58.1 20.7-78.8 56.6s-20.8 69.3-9.6 96.6c11.4 27.8 35 50.4 63.3 62.8c4.2 1.8 7.4 5.3 8.8 9.7s.9 9.1-1.3 13l-.5 .8c-2.5 4.4-6.9 7.3-11.9 7.9c-36.5 4.4-74.8-2.5-109.1-22.3c-13.8-8-26.1-17.5-36.9-28.3c-10.7 10.8-23.1 20.4-36.9 28.3c-34.3 19.8-72.5 26.8-109.1 22.3c-5-.6-9.4-3.5-11.9-7.9l-.5-.8c-2.3-3.9-2.8-8.7-1.3-13s4.6-7.8 8.8-9.7c28.4-12.4 51.9-35 63.3-62.8c11.2-27.3 11.1-60.7-9.6-96.6s-49.6-52.7-78.8-56.6c-29.8-4-61.1 5.1-86.1 23.4c-3.7 2.7-8.3 3.7-12.8 2.8s-8.3-3.7-10.6-7.7l-.5-.8c-2.5-4.4-2.8-9.6-.9-14.3c14.4-33.8 39.6-63.5 73.9-83.3c14.5-8.3 29.6-14.4 45.1-18.3c-5.3-16.8-8.2-34.7-8.2-53.3c0-39.6 13.1-76.2 35.2-105.6zm2.2 66.5C145.9 85.3 144 98.4 144 112c0 21 4.5 40.9 12.5 58.8c2.1 4.6 1.8 9.9-.6 14.3s-6.9 7.4-11.9 8.1c-18.1 2.4-36.1 8.3-52.9 18.1C79.4 218.1 69 226.3 60 235.5c18.2-4.9 37.4-6.4 56.3-3.8c39.4 5.3 76.8 28.2 102.3 72.3s26.6 87.9 11.5 124.7c-7.3 17.7-18.1 33.5-31.5 46.9c12.5-3.2 24.8-8.1 36.5-14.9c16-9.2 29.5-21 40.4-34.6c3-3.8 7.6-6 12.5-6s9.4 2.2 12.5 6c10.9 13.5 24.4 25.4 40.4 34.6c11.7 6.8 24 11.7 36.5 14.9c-13.3-13.3-24.2-29.2-31.5-46.9c-15.1-36.8-14-80.6 11.5-124.7s62.9-67 102.3-72.3c19-2.6 38.1-1.1 56.3 3.8c-9-9.2-19.4-17.4-31.2-24.2c-16.8-9.7-34.8-15.6-52.9-18.1c-5-.7-9.4-3.7-11.9-8.1s-2.7-9.7-.6-14.3c8-17.9 12.5-37.9 12.5-58.9c0-13.6-1.9-26.7-5.4-39.1c-4.9 18.2-13.1 35.5-24.9 50.7C377.5 155.1 339 176 288 176s-89.5-20.9-113.8-52.4c-11.7-15.1-20-32.5-24.9-50.7zm5.1 358.6c-40.1-33.6-67.4-82.1-73.3-136.9c9-1.8 18.1-2.2 26.7-1.1c1.8 .2 3.7 .6 5.5 1c5.6 43.9 27.3 82.7 59 110.3l-.1 .3c-3.9 9.6-10.1 18.6-17.9 26.4zM288 96c-15.9 0-31.3 2.1-45.9 6.1c-7.6-4.6-13.7-10.4-18.5-16.6c-2.2-2.9-4.2-6-6.1-9.2C239.5 68.3 263.3 64 288 64s48.5 4.3 70.5 12.2c-1.8 3.2-3.8 6.3-6.1 9.2c-4.8 6.2-10.9 12-18.5 16.6c-14.6-3.9-30-6.1-45.9-6.1zM462.6 294.5c1.8-.4 3.7-.7 5.5-1c8.6-1.2 17.7-.8 26.7 1.1c-5.9 54.9-33.2 103.3-73.3 136.9c-7.8-7.8-13.9-16.8-17.9-26.4l-.1-.3c31.7-27.6 53.5-66.4 59.1-110.3zM288 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faChessQueenPiece = {
  prefix: 'fal',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", "M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm67.8 41.4c6.5 1.2 11.6 6.2 12.8 12.7C187.4 92.9 200.4 104 216 104c5.6 0 10.7-1.4 15.3-3.9c6.1-3.3 13.7-2.3 18.8 2.5s6.3 12.4 3.2 18.7L201.9 224H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.7l4.4 96h-32l-4.4-96H95.3l-4.4 96h-32l4.4-96H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h6.1L2.8 121.3C-.3 115.1 1 107.5 6 102.7s12.6-5.9 18.8-2.5c4.5 2.5 9.7 3.9 15.3 3.9c15.6 0 28.6-11.1 31.4-25.9c1.3-6.5 6.3-11.5 12.8-12.7s13 1.7 16.5 7.3C106.4 81.9 116.5 88 128 88s21.6-6.1 27.3-15.2c3.5-5.6 10-8.5 16.5-7.3zM89.9 224h76.2l44.1-88.3c-19.2-1.7-35.9-11.9-46.4-26.7c-10.2 6.9-22.5 11-35.8 11s-25.6-4-35.8-11c-10.6 14.8-27.3 25-46.4 26.7L89.9 224zM190.2 384c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H190.2zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H216.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416z"]
};
var faChessQueenAlt = faChessQueenPiece;
var faLocationCrosshairs = {
  prefix: 'fal',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", "M256 0c8.8 0 16 7.2 16 16V64.7c93.3 7.7 167.6 82.1 175.3 175.3H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H447.3c-7.7 93.3-82.1 167.6-175.3 175.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V447.3C146.7 439.6 72.4 365.3 64.7 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64.7C72.4 146.7 146.7 72.4 240 64.7V16c0-8.8 7.2-16 16-16zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm224 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faLocation = faLocationCrosshairs;
var faMarsDouble = {
  prefix: 'fal',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M304 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16V160c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6L311.3 191.4C336.7 221.9 352 261.2 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c42.8 0 82.1 15.3 112.6 40.7L393.4 64H320c-8.8 0-16-7.2-16-16zM176 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM469.4 190.1c4.5-5.6 7.8-12.3 9.5-19.6L585.4 64H512c-8.8 0-16-7.2-16-16s7.2-16 16-16H624c8.8 0 16 7.2 16 16V160c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-100 100c22.6 30.6 36 68.4 36 109.4c0 101.6-82.4 184-184 184c-20.7 0-40.5-3.4-59.1-9.7c10.1-7.6 19.5-16.2 28.1-25.5c10 2.1 20.3 3.2 30.9 3.2c83.9 0 152-68.1 152-152c0-38.3-14.1-73.3-37.5-100l-5.1-5.9z"]
};
var faHousePersonLeave = {
  prefix: 'fal',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9V352c0 35.3 28.7 64 64 64H336.8L354 398.8l7.4-14.8H352 320 128c-17.7 0-32-14.3-32-32V160.5L240 37.1 358.2 138.4c8.3-7.2 17.2-13.6 26.7-19.2L250.4 3.9zM192 192h64v64H192V192zm-8-32c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H184zM496 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 464 56a56 56 0 1 0 112 0zM437.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L529.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L560.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L507.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5z"]
};
var faHouseLeave = faHousePersonLeave;
var faHousePersonDepart = faHousePersonLeave;
var faRulerTriangle = {
  prefix: 'fal',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", "M32 45.3V448c0 17.7 14.3 32 32 32H466.7c7.3 0 13.3-5.9 13.3-13.3c0-3.5-1.4-6.9-3.9-9.4l-39.4-39.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4L116.7 97.9 91.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L94.1 75.3 54.6 35.9c-2.5-2.5-5.9-3.9-9.4-3.9C37.9 32 32 37.9 32 45.3zm45.3-32L498.7 434.7c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3H64c-35.3 0-64-28.7-64-64V45.3C0 20.3 20.3 0 45.3 0c12 0 23.5 4.8 32 13.3zm44.6 228c6-2.5 12.9-1.1 17.4 3.5l128 128c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H128c-8.8 0-16-7.2-16-16V256c0-6.5 3.9-12.3 9.9-14.8zM144 294.6V368h73.4L144 294.6z"]
};
var faCardClub = {
  prefix: 'fal',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M320 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM208 331.9c7.5 2.7 15.6 4.1 24 4.1c39.8 0 72-32.2 72-72c0-28.3-16.3-52.7-40-64.5c-.3-39.5-32.4-71.5-72-71.5s-71.7 32-72 71.5C96.3 211.3 80 235.7 80 264c0 39.8 32.2 72 72 72c8.4 0 16.5-1.4 24-4.1V352H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V331.9zM152 200c0-22.1 17.9-40 40-40s40 17.9 40 40c0 2.5-.2 4.9-.6 7.2c-1.5 8.1 3.5 16 11.4 18.3c16.9 4.7 29.2 20.2 29.2 38.5c0 22.1-17.9 40-40 40c-11.2 0-21.3-4.6-28.6-12c-3-3.1-7.1-4.8-11.4-4.8s-8.4 1.7-11.4 4.8c-7.3 7.4-17.4 12-28.6 12c-22.1 0-40-17.9-40-40c0-18.3 12.3-33.8 29.2-38.5c8-2.2 12.9-10.1 11.4-18.3c-.4-2.3-.6-4.7-.6-7.2z"]
};
var faChildDress = {
  prefix: 'fal',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M160 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM96 400H72c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9L98 225.8 28.6 313.9c-5.5 6.9-15.5 8.1-22.5 2.7S-2 301 3.4 294.1l74.3-94.2c18.8-23.9 47.1-38.3 77.3-39.8c1.2-.1 2.5-.1 3.7-.1H160h1.3c1.2 0 2.5 0 3.7 .1c30.2 1.5 58.4 15.9 77.3 39.8l74.3 94.2c5.5 6.9 4.3 17-2.7 22.5s-17 4.3-22.5-2.7L222 225.8l41.5 154c1.3 4.8 .3 9.9-2.8 13.9s-7.7 6.3-12.7 6.3H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H128v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400zm60.8-207.9c-10.1 .8-18.7 7.8-21.4 17.7L92.9 368H227.1L184.5 209.8c-2.7-9.9-11.3-16.9-21.4-17.7c-1.1 0-2.1-.1-3.2-.1s-2.1 0-3.2 .1z"]
};
var faUsersBetweenLines = {
  prefix: 'fal',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", "M0 16C0 7.2 7.2 0 16 0H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM0 496c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM147.2 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 320h-96c-35.3 0-64 28.7-64 64h224c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96h96c53 0 96 43 96 96c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-35.3 28.7-64 64-64h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-17.7 0-32 14.3-32 32zm480-32H456c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-17.7-14.3-32-32-32z"]
};
var faLungsVirus = {
  prefix: 'fal',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M320 0c8.8 0 16 7.2 16 16V146.7c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7V16c0-8.8 7.2-16 16-16zm96 181.8c-11-1.3-22.4 1.3-32 7.7V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c12.2 1.4 24.9-2 35-10c7 5.5 15.2 9.7 24.2 11.9l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7c31.5 0 57-25.5 57-57v-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1c-20.6 0-37.3 16.7-37.3 37.3v16.5zM234.8 458.2c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-9.6-6.4-21-8.9-32-7.7V165.3c0-20.6-16.7-37.3-37.3-37.3c-11.8 0-22.8 5.5-29.5 15.1c-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416v7c0 31.5 25.5 57 57 57c4.7 0 9.3-.6 13.8-1.7l72.7-18.2c9.1-2.3 17.3-6.4 24.2-11.9c10.2 8 22.8 11.4 35 10zm187-59c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2zM403.5 320a83.5 83.5 0 1 0 -167.1 0 83.5 83.5 0 1 0 167.1 0zM304 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 72a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSpinnerThird = {
  prefix: 'fal',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1c17.1-34.3 26.7-73 26.7-113.9C512 120 405.9 8.8 272 .5c-8.8-.5-16 6.7-16 15.5v0c0 8.8 7.2 15.9 16 16.6C388.2 40.8 480 137.7 480 256c0 35.1-8.1 68.3-22.5 97.9c-3.9 8-1.3 17.7 6.4 22.2v0z"]
};
var faFaceGrinTears = {
  prefix: 'fal',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2zm19.5 200c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512s171.3-47.7 216.6-119.5c4.7-7.5 2.5-17.4-5-22.1s-17.4-2.5-22.1 5C469.8 438.3 399.8 480 320 480s-149.8-41.7-189.5-104.5zM320 354.1c31.2 0 61.4-2.9 89.9-8.3c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3zm142.8-30.7c5.2-11.7-6.8-22.4-19.1-18.7c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7c24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7zm-242.4-129c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C273.6 161.9 258.8 152 240 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C433.6 161.9 418.8 152 400 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm180.1 39.7c7.5 1.2 15.4 2.7 23 4.4c9.2 2.1 17.3 4.4 23.5 6.8c5 1.9 7.3 3.3 8 3.7c.1 .1 .2 .1 .2 .1s0 0 0 0c7.2 7.3 9.2 23.4-3.6 36.2c-12.8 12.8-28.8 10.8-36.2 3.6c0 0 0 0 0 0s0-.1-.1-.2c-.4-.6-1.8-2.9-3.7-7.9c-2.4-6.3-4.7-14.4-6.7-23.6c-1.7-7.6-3.2-15.5-4.4-23.1zm-35.5-24.2c2.9 26 11.1 84.8 27.7 101.4c21.6 21.6 58.1 19.9 81.5-3.5s25.1-60 3.5-81.5c-16.6-16.6-75.3-24.9-101.4-27.7c-6.5-.8-12.1 4.9-11.3 11.3zM88 282.6c-2.1 9.2-4.3 17.3-6.7 23.6c-1.9 5-3.3 7.3-3.7 7.9c-.1 .1-.1 .2-.1 .2s0 0 0 0c-7.3 7.2-23.4 9.1-36.2-3.6s-10.8-28.8-3.6-36.2c0 0 0 0 0 0s0 0 0 0s.1 0 .2-.1c.6-.4 2.9-1.8 8-3.7c6.3-2.4 14.4-4.7 23.5-6.8c7.6-1.7 15.5-3.2 23-4.4c-1.2 7.5-2.7 15.4-4.4 23.1zm12.2 54.2c16.6-16.6 24.8-75.4 27.7-101.4c.8-6.5-4.9-12.1-11.3-11.3c-26.1 2.8-84.8 11.1-101.4 27.7c-21.6 21.6-19.9 58.1 3.5 81.5s60 25.1 81.5 3.5z"]
};
var faGrinTears = faFaceGrinTears;
var faPhone = {
  prefix: 'fal',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z"]
};
var faComputerMouseScrollwheel = {
  prefix: 'fal',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M352 352V160c0-70.7-57.3-128-128-128H160C89.3 32 32 89.3 32 160V352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128zM0 160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V160zm208-48v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMouseAlt = faComputerMouseScrollwheel;
var faCalendarXmark = {
  prefix: 'fal',
  iconName: 'calendar-xmark',
  icon: [512, 512, ["calendar-times"], "f273", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H96c-35.3 0-64 28.7-64 64v32 32V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H384V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H160V16zM64 192H448V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zM96 96H416c17.7 0 32 14.3 32 32v32H64V128c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 336l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 358.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 336l52.7-52.7z"]
};
var faCalendarTimes = faCalendarXmark;
var faChildReaching = {
  prefix: 'fal',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM112 188c-27.8-14.9-51.4-37.4-67.5-65.8L34.1 103.9c-4.4-7.7-1.7-17.5 6-21.8s17.5-1.7 21.8 6l10.4 18.3c24.4 43 70.1 69.6 119.5 69.6c48.9 0 94.1-26 118.7-68.2l11.6-19.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9l-11.6 19.9c-16 27.5-39.1 49.4-66.2 63.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H144V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V188zm32 13.1V352h96V201c-15.4 4.6-31.6 7-48.1 7c-16.4 0-32.5-2.4-47.9-6.9z"]
};
var faTableLayout = {
  prefix: 'fal',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", "M448 64c17.7 0 32 14.3 32 32v64L32 160l0-64c0-17.7 14.3-32 32-32l384 0zM32 416l0-224 128 0 0 256H64c-17.7 0-32-14.3-32-32zm160 32l0-256 288 0 0 224c0 17.7-14.3 32-32 32H192zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
var faNarwhal = {
  prefix: 'fal',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M630.6 1.4c8 3.7 11.6 13.1 7.9 21.2L562.2 190.6C609 222.3 640 275.6 640 336c0 97.2-78.8 176-176 176H240c-88.4 0-160-71.6-160-160V328.3 280 264.3L34.1 232.2C12.7 217.2 0 192.8 0 166.7L0 112c0-6 3.3-11.4 8.6-14.2s11.7-2.3 16.6 1.1L96 148.5l70.8-49.6c4.9-3.4 11.3-3.8 16.6-1.1s8.6 8.2 8.6 14.2l0 54.7c0 26.1-12.7 50.6-34.1 65.5L112 264.3V280v48.3c0 13.1 10.6 23.7 23.7 23.7c5.4 0 10.6-1.8 14.8-5.2L323.1 208.7c39.4-31.6 89.1-48.7 139.6-48.7c25.4 0 49.6 5.4 71.5 15L609.4 9.4c3.7-8 13.1-11.6 21.2-7.9zM464 480c79.5 0 144-64.5 144-144c0-79.2-65.5-144-145.4-144c-43.3 0-85.9 14.8-119.6 41.7L170.5 371.8c-9.9 7.9-22.1 12.2-34.8 12.2c-7.3 0-14.2-1.4-20.6-3.9C127.9 437.3 178.9 480 240 480H464zm40-208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 166.7c0 15.7 7.6 30.3 20.5 39.3L96 236.5 139.5 206c12.8-9 20.5-23.7 20.5-39.3l0-23.9-54.8 38.4c-5.5 3.9-12.8 3.9-18.4 0L32 142.7l0 23.9z"]
};
var faRampLoading = {
  prefix: 'fal',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", "M96 32H352c17.7 0 32 14.3 32 32V341.7l32 58.7V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V400.4l32-58.7V64c0-17.7 14.3-32 32-32zm67.1 256c-17.6 0-33.8 9.6-42.2 25.1L38.7 464.8C27.2 486.1 42.6 512 66.9 512H381.1c24.2 0 39.7-25.9 28.1-47.2L327.1 313.1c-8.4-15.5-24.6-25.1-42.2-25.1H163.1zM149 328.4c2.8-5.2 8.2-8.4 14.1-8.4H284.9c5.9 0 11.3 3.2 14.1 8.4L381.1 480H66.9L149 328.4z"]
};
var faCalendarCirclePlus = {
  prefix: 'fal',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192H352h64 16 16V160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faToothbrush = {
  prefix: 'fal',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32H288c24.8 0 45.1-9.9 57.7-28.9c6.6-10.1 10.1-21.2 11.9-31.6c14.8 3.6 27.9 9.7 37.9 17.8C408.3 95.7 416 109.4 416 128c0 35.3-28.7 64-64 64H64zM0 160c0 35.3 28.7 64 64 64H352c53 0 96-43 96-96c0-58.5-51.6-89.9-104-95.2c-8.8-.9-15.8 6.4-16.4 15.2c-1.5 25.3-8.4 48-39.6 48H64C28.7 96 0 124.7 0 160zM64 272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48h64 64 64 64 64H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H320V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H256V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H192V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H128V272c0-8.8-7.2-16-16-16s-16 7.2-16 16V448H64V272z"]
};
var faBorderInner = {
  prefix: 'fal',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M224 480c-8.8 0-16-7.2-16-16l0-192L16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0 0-192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 192 192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0 0 192c0 8.8-7.2 16-16 16zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM8 64a24 24 0 1 1 48 0A24 24 0 1 1 8 64zm288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPawClaws = {
  prefix: 'fal',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M313.7 8.8c-4 7.9-.7 17.5 7.2 21.5c8.5 4.2 21.6 15.4 31.8 34c-30-3.5-62.2 21.7-75.2 60.5c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1h0c0-69.9-37.9-112.8-64.8-126.3c-7.9-4-17.5-.7-21.5 7.2zM307.9 135c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1c-3.5-10.3-4-24.7 1.2-40.2zM205.4 175.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1s4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8c-13-38.8-45.2-64-75.2-60.5c10.2-18.6 23.3-29.8 31.8-34c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C149.9 15.2 112 58.1 112 128h0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5zm-122.1 54c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1C85.9 205.6 61.7 191.1 40.2 192c10.4-28.1 28.3-44.4 39-49.7c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C37.9 127.2 0 170.1 0 240H0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3zM256 288c25.7 0 108.2 25.4 156.8 156.3c2.1 5.7 3.2 12.2 3.2 19.4v4.4c0 6.6-5.3 11.9-11.9 11.9c-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5c-6.6 0-11.9-5.3-11.9-11.9v-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 313.4 230.3 288 256 288zm0-32c-41.3 0-134.4 35.9-186.8 177.2c-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9c13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0L364.8 506c12.7 4 26 6 39.3 6c24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.7-5.2-30.5C390.4 291.9 297.3 256 256 256zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3c-.9-7.7 .8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4h0c0-69.9-37.9-112.8-64.8-126.3c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5c10.7 5.3 28.6 21.6 39 49.7c-21.5-1-45.7 13.6-60.2 38.5z"]
};
var faKiwiFruit = {
  prefix: 'fal',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M416 176c0-25.2-15.9-52.4-50.9-74.9C330.4 78.8 280.6 64 224 64s-106.4 14.8-141.1 37.1C47.9 123.6 32 150.8 32 176s15.9 52.4 50.9 74.9C117.6 273.2 167.4 288 224 288s106.4-14.8 141.1-37.1c35-22.5 50.9-49.7 50.9-74.9zm32 0v80c0 123.7-100.3 224-224 224S0 379.7 0 256V176C0 96.5 100.3 32 224 32s224 64.5 224 144zm-32 74.2C376.8 292 305.5 320 224 320s-152.8-28-192-69.8V256c0 106 86 192 192 192s192-86 192-192v-5.8zM280 176c0 13.3-25.1 24-56 24s-56-10.7-56-24s25.1-24 56-24s56 10.7 56 24zM240 88v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V88c0-8.8 7.2-16 16-16s16 7.2 16 16zm-84.7 12.7l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm160 0c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zM96 160h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16s7.2-16 16-16zM171.3 235.3l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm128-22.6l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM240 240v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTrafficLightSlow = {
  prefix: 'fal',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0-136a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z"]
};
var faRectangleCode = {
  prefix: 'fal',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM293.4 172c-6.6 5.9-7.2 16-1.3 22.6L346.6 256 292 317.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM220 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L165.4 256 220 194.6z"]
};
var faHeadSideVirus = {
  prefix: 'fal',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm293.8 63.2C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM307.5 208c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c6.6 7.8 14.8 13.9 24 18.1c10.9 5 23 7.3 35.1 6.3c-1.8 22.3 7.4 44.6 24.5 59.1zM208 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 24a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faKeyboardBrightness = {
  prefix: 'fal',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M115.3 172.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88zM304 224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V224zm132.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l88-88c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-88 88zM0 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H528z"]
};
var faBooksMedical = {
  prefix: 'fal',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", "M192 464c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V416h96v48zm-16 48c12.3 0 23.5-4.6 32-12.2c8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V416 400 384 193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2C464 9.9 438.6-5.2 413.9 1.6L354.3 18.1c-3.5 1-6.8 2.3-9.9 4C335.9 8.8 321 0 304 0H240c-12.3 0-23.5 4.6-32 12.2C199.5 4.6 188.3 0 176 0H112C85.5 0 64 21.5 64 48V96v16 16H96h80 16v48h32V128h96V384H224V336H192v48H176 96 64v16 16 48c0 26.5 21.5 48 48 48h64zM352 64.8V63.5c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2L352.6 68.6c-.3-1.3-.5-2.6-.6-3.8zm-32-.6v0V96H224V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64.2zM240 480c-8.8 0-16-7.2-16-16V416h96v48c0 8.8-7.2 16-16 16H240zM192 48V96H96V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zm269.7 80.7l59.8 230.5-87.3 24.2L374.4 152.8l87.3-24.2zm67.9 261.5l13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2zM80 160c-17.7 0-32 14.3-32 32v16H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H48v16c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V304h16c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H144V192c0-17.7-14.3-32-32-32H80zm0 32h32v32c0 8.8 7.2 16 16 16h32v32H128c-8.8 0-16 7.2-16 16v32H80V288c0-8.8-7.2-16-16-16H32V240H64c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V192z"]
};
var faLightbulbSlash = {
  prefix: 'fal',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", "M438.3 258.1c-3.3 4.7-6.9 9.7-10.7 15l25.2 19.9c4-5.5 8-11 11.8-16.6c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C260.6 0 208 29.4 176.2 74.5l25.2 19.9C227.3 56.7 270.8 32 320 32c79.5 0 144 64.5 144 144c0 30.6-9.5 58.8-25.7 82.1zM226.5 114.3l25.2 19.9C265.8 111.3 291.1 96 320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39 0-73.4 20-93.5 50.3zm-25.4 143l-52.6-41.6c5.1 22.1 14.3 42.5 26.9 60.5c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19l-.5-.7zM274.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM240 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7V432zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faHouseBlank = {
  prefix: 'fal',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", "M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7z"]
};
var faHomeBlank = faHouseBlank;
var faSquare5 = {
  prefix: 'fal',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H188.5L172 225.9l80.4 8.1c38.4 3.9 67.6 36.2 67.6 74.8c0 41.5-33.7 75.2-75.2 75.2h-44c-27.4 0-53-13.7-68.3-36.4l-1.8-2.7c-4.9-7.3-3-17.3 4.4-22.2s17.3-3 22.2 4.4l1.8 2.7c9.3 13.9 25 22.3 41.8 22.3h44c23.8 0 43.2-19.3 43.2-43.2c0-22.2-16.8-40.7-38.8-42.9l-98.8-10c-4.6-.5-8.8-2.9-11.5-6.7s-3.6-8.6-2.4-13.1l24-96c1.8-7.1 8.2-12.1 15.5-12.1z"]
};
var faSquareHeart = {
  prefix: 'fal',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm99.9 68.9c27.8-28.2 71.9-29.7 101.5-4.6c5.8 4.9 11 10.4 16.3 15.9c2.1 2.2 4.2 4.5 6.4 6.6c2.1-2.2 4.3-4.4 6.4-6.6c5.2-5.5 10.5-11 16.3-15.9c29.6-25.1 73.7-23.6 101.5 4.6c29.4 29.8 29.4 78.2 0 108L246.5 376.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 272.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0c-17.1 17.4-17.1 45.7 0 63.1L224 353.3 325.3 250.4c17.1-17.4 17.1-45.7 0-63.1c-16.8-17.1-44-17.1-60.8 0l-29.1 29.6c-6.3 6.4-16.5 6.4-22.8 0l-29.1-29.6z"]
};
var faHeartSquare = faSquareHeart;
var faPuzzle = {
  prefix: 'fal',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M320 0c-17.7 0-32 14.3-32 32V56c0 17.7 14.3 32 32 32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-17.7 0-32 14.3-32 32v24c0 17.7 14.3 32 32 32h32c0 26.5 21.5 48 48 48s48-21.5 48-48h32c17.7 0 32-14.3 32-32V64c0-35.3-28.7-64-64-64H320zm0 32H448c17.7 0 32 14.3 32 32V176H432c-8.8 0-16 7.2-16 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8-7.2-16-16-16H320V152h16c26.5 0 48-21.5 48-48s-21.5-48-48-48H320V32zM64 64C28.7 64 0 92.7 0 128V288 448c0 35.3 28.7 64 64 64H224 384c35.3 0 64-28.7 64-64V304c0-17.7-14.3-32-32-32H368c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-17.7-14.3-32-32-32H240V96c0-17.7-14.3-32-32-32H64zM208 96V272H176V256c0-26.5-21.5-48-48-48s-48 21.5-48 48v16H32V128c0-17.7 14.3-32 32-32H208zM80 304c17.7 0 32-14.3 32-32V256c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 17.7 14.3 32 32 32h32v32H192c-26.5 0-48 21.5-48 48s21.5 48 48 48h16v48H64c-17.7 0-32-14.3-32-32V304H80zM240 432c0-17.7-14.3-32-32-32H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c17.7 0 32-14.3 32-32V304h32v16c0 26.5 21.5 48 48 48s48-21.5 48-48V304h48V448c0 17.7-14.3 32-32 32H240V432z"]
};
var faUserGear = {
  prefix: 'fal',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H351c15.6 13.1 36.9 13.7 53 4.8v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-1.6 13.7 3.2 26.6 11.6 36.1c-14.5-4.8-30-7.4-46.2-7.4H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM373.5 394.1l17.2 30.5c15.9-6.3 33-3.7 46 3.7c12.6 7.2 23.6 20.1 26.6 36.7H497c3-16.6 13.9-29.5 26.5-36.7c12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6C510.8 268 499.9 255 497 238.4H463.3c-3.1 16.6-14 29.5-26.6 36.7c-13 7.4-30 9.9-46 3.7l-17.2 30.5C386.3 320.7 392 337 392 351.7s-5.7 31-18.5 42.4zm26.1 61.7l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 401.7c-5.7-10.2-2.3-23.1 7.8-29c7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3c6.6-3.8 11.3-10.6 11.3-18.2v-1.4c0-11.7 9.5-21.3 21.3-21.3h53.4c11.8 0 21.4 9.6 21.4 21.4v1.6c0 7.5 4.6 14.2 11.1 18c6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2L619 301.7c5.7 10.2 2.3 23-7.8 29c-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29l-26.4 46.9c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3c-6.5 3.7-11.1 10.4-11.1 18v1.6c0 11.8-9.6 21.4-21.4 21.4H453.4c-11.7 0-21.3-9.5-21.3-21.3v-1.4c0-7.6-4.6-14.4-11.3-18.2c-6.6-3.7-14.7-4.2-21.2-.3zm80.5-160.1a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUserCog = faUserGear;
var faPipeCircleCheck = {
  prefix: 'fal',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", "M16 96c8.8 0 16 7.2 16 16v16H256 448V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32 48.7c-11 1-21.7 3-32 5.9V160H256 32V352H320.7c-.5 5.3-.7 10.6-.7 16s.2 10.7 .7 16H32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V368 144 112c0-8.8 7.2-16 16-16zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faArrowUp19 = {
  prefix: 'fal',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M448 48c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V48zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM428 392a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c.4 0 .9 0 1.3 0l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5C504.4 385.8 512 365.2 512 344h-.1c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84z"]
};
var faSortNumericUp = faArrowUp19;
var faOctagonExclamation = {
  prefix: 'fal',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM256 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faDialLow = {
  prefix: 'fal',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 360c-65.3 0-119.1-48.9-127-112H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H161c7.9-63.1 61.7-112 127-112c70.7 0 128 57.3 128 128s-57.3 128-128 128zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm440 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDoorClosed = {
  prefix: 'fal',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M416 32c17.7 0 32 14.3 32 32V480H128V64c0-17.7 14.3-32 32-32H416zm64 448V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32H448h32 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H480zM408 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faLaptopMobile = {
  prefix: 'fal',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", "M128 32H448c17.7 0 32 14.3 32 32V96h32V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H352V352H76.8c-20.3 0-37.4-13.5-42.9-32H64 96 352V288H96V64c0-17.7 14.3-32 32-32zM416 176c0-8.8 7.2-16 16-16H592c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V176zm-32 0V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z"]
};
var faPhoneLaptop = faLaptopMobile;
var faConveyorBeltBoxes = {
  prefix: 'fal',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M304 32c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H304zM112 0C85.5 0 64 21.5 64 48V240c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H112zM528 96c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h96zM432 64c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H432zM608 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H544c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faConveyorBeltAlt = faConveyorBeltBoxes;
var faShieldVirus = {
  prefix: 'fal',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm76.8 311.4C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM339.5 240c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c6.6 7.8 14.8 13.9 24 18.1c10.9 5 23 7.3 35.1 6.3c-1.8 22.3 7.4 44.6 24.5 59.1zM240 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm48 24a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fal',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", "M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L36.7 145.9c-3 3-4.7 7.1-4.7 11.3v40.4l148.6-20.3C208.1 128.8 260.2 96 320 96s111.9 32.8 139.4 81.4L608 197.7V157.3c0-4.2-1.7-8.3-4.7-11.3L484.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L625.9 123.3c9 9 14.1 21.2 14.1 33.9V202v14 80 14 44.8c0 12.7-5.1 24.9-14.1 33.9L507.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L603.3 366.1c3-3 4.7-7.1 4.7-11.3V314.3L459.4 334.6C431.9 383.2 379.8 416 320 416s-111.9-32.8-139.4-81.4L32 314.3v40.4c0 4.2 1.7 8.3 4.7 11.3L155.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L14.1 388.7c-9-9-14.1-21.2-14.1-33.9V310 296 216 202 157.3c0-12.7 5.1-24.9 14.1-33.9L132.7 4.7zm341.1 207c4.1 14.1 6.2 29 6.2 44.3s-2.2 30.3-6.2 44.3L608 282V230L473.8 211.7zM32 282l134.2 18.3c-4.1-14.1-6.2-29-6.2-44.3s2.2-30.3 6.2-44.3L32 230V282zM320 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-16-66c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160c0-8.8 7.2-16 16-16s16 7.2 16 16v34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5h34c8.8 0 16 7.2 16 16s-7.2 16-16 16H382c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8v34c0 8.8-7.2 16-16 16s-16-7.2-16-16V318zm16-30a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
var faDiceSix = {
  prefix: 'fal',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM296 160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faStarfighterTwinIonEngine = {
  prefix: 'fal',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", "M16 32c8.8 0 16 7.2 16 16V197.1l116.4-19.4C175.8 128.9 228.1 96 288 96s112.2 32.9 139.6 81.7L544 197.1V48c0-8.8 7.2-16 16-16s16 7.2 16 16V202.4 216v80 13.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V314.9L427.6 334.3C400.2 383.1 347.9 416 288 416s-112.2-32.9-139.6-81.7L32 314.9V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V309.6 296 216 202.4 48c0-8.8 7.2-16 16-16zM448 256c0 15.1-2.1 29.6-6 43.4l102-17V229.6l-102-17c3.9 13.8 6 28.4 6 43.4zM32 282.4l102 17c-3.9-13.8-6-28.4-6-43.4s2.1-29.6 6-43.4l-102 17v52.9zM416 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM226 272H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160c0-8.8 7.2-16 16-16s16 7.2 16 16v34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5h34c8.8 0 16 7.2 16 16s-7.2 16-16 16H350c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8v34c0 8.8-7.2 16-16 16s-16-7.2-16-16V318c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5zm62 16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faStarfighterAlt = faStarfighterTwinIonEngine;
var faRocketLaunch = {
  prefix: 'fal',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M219.3 292.7c-10-10-21.4-18.1-33.8-24.1C215.6 146.3 269 86.7 321.1 58.1c53.5-29.4 111.4-29.4 154.6-21.8c7.6 43.2 7.7 101.1-21.8 154.6C425.3 243 365.7 296.4 243.4 326.5c-6-12.4-14.1-23.9-24.1-33.8zM256 381.3c0-8.2-.8-16.3-2.4-24.3c37.8-9.5 70.4-21.3 98.4-34.7v80.1c0 12.1-6.8 23.2-17.7 28.6L256 470.1l0-88.9zm128 21.1l0-97.4C515.7 225.1 520.5 102.5 506.7 28.1c-2.2-11.6-11.2-20.7-22.8-22.8C409.5-8.5 286.9-3.7 207 128l-97.4 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H130.7c24.7 0 48.5 9.8 65.9 27.3s27.3 41.2 27.3 65.9V496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2zm-229-144c-7.9-1.6-16.1-2.4-24.3-2.4H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7h80.1c-13.5 28-25.2 60.5-34.7 98.4zm-11.2 189c-11 11-29.4 19.4-52.6 24.9c-20.6 4.9-42.1 6.8-59 7.4c.6-17 2.5-38.4 7.4-59c5.5-23.2 13.9-41.6 24.9-52.6c21.9-21.9 57.4-21.9 79.3 0s21.9 57.4 0 79.3zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"]
};
var faMosquitoNet = {
  prefix: 'fal',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M161.7 440.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l32-64c1.1-2.2 1.7-4.7 1.7-7.2l0-41.4 20-20v38c0 24.3 19.7 44 44 44s44-19.7 44-44v-38l30.9 30.9c3-3.7 6.6-6.9 10.6-9.5c-12.9-8.6-21.5-23.3-21.5-40c0-2.1 .1-4.2 .4-6.2L332 277.4V252.7l28.2 24.5c6.1-9.1 15.2-15.9 25.9-19.2l.2-.6-51.8-45.1 86.3 12.9c3.6-.9 7.3-1.3 11.2-1.3c8.9 0 17.2 2.4 24.3 6.6l25.8 3.8c8.2-6.5 18.6-10.5 29.9-10.5c16.7 0 31.4 8.5 40 21.5c2.1-3.1 4.5-6 7.3-8.6c-12.9-16.9-32.2-28.6-54.7-31.4L344.7 181.6l49.6-41.3c5.1-4.2 7-11.1 4.9-17.4L385.3 81.2l29-58.1c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-32 64c-1.9 3.8-2.2 8.2-.9 12.2l12.5 37.6L332 150.5V137.9c0-21.5-15.4-39.4-35.8-43.2v-31c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2v31c-20.4 3.8-35.8 21.7-35.8 43.2v12.6l-33.4-27.8 12.5-37.6c1.3-4 1-8.4-.9-12.2l-32-64c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l29 58.1-13.9 41.7c-2.1 6.2-.1 13.1 4.9 17.4l49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6L244 252.7v24.7l-47.3 47.3c-3 3-4.7 7.1-4.7 11.3l0 44.2-30.3 60.6zm-43.5-121c-.6 .5-1.1 1-1.6 1.5c-31.2 31.2-84.6 9.1-84.6-35c0-25 18.6-46 43.4-49.1l.8-.1 165.4-24.7L118.2 319.8zM528 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H448V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16V480h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V400h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H528V272zm0 48h48v48H528V320zm0 80h48v48H528V400zm-80-32V320h48v48H448zm0 80V400h48v48H448zM272 360.6l0-222.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 222.7c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faVentDamper = {
  prefix: 'fal',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M512 96H128c-17.7 0-32 14.3-32 32v16V368v16c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V368 144 128c0-17.7-14.3-32-32-32zM48 128l16 0c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64h16c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H576c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48zM592 352c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H576V352h16zM48 352H64V160H48c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16zM176 160H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBridgeWater = {
  prefix: 'fal',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", "M544 96H32l0 80.1c53.3 1.9 96 45.7 96 99.5V361c-9.9-5.7-21-8.6-32-8.6V275.6C96 238.2 65.8 208 28.4 208C12.7 208 0 195.3 0 179.6V96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v83.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6v76.9c-11 0-22.1 2.8-32 8.6V275.6c0-53.8 42.7-97.6 96-99.5V96zM192 384.5h0V272c0-53 43-96 96-96s96 43 96 96V384.5c-10.4 0-21.3-2.2-32-6.1V272c0-35.3-28.7-64-64-64s-64 28.7-64 64V378.4c-10.3 3.8-21.1 6.1-32 6.1zm0 63.5c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"]
};
var faBanBug = {
  prefix: 'fal',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm79.5-167.1c.3-2.9 .5-5.9 .5-8.9v-5.9l46 5.8c8.8 1.1 16.8-5.1 17.9-13.9s-5.1-16.8-13.9-17.9l-50-6.2V244.5l51.9-13c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-44.1 11V208c0-7.4-1-14.7-2.9-21.5l43.8-29.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-40.8 27.2C303.7 139.7 281.2 128 256 128c-28.6 0-53.7 15-67.8 37.6L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l-89.8-89.8zM304 281.4l-92.2-92.2C219.1 172 236.2 160 256 160c26.5 0 48 21.5 48 48v23.7 .5V280v.1 1.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 265.9l-50 6.2c-8.8 1.1-15 9.1-13.9 17.9s9.1 15 17.9 13.9l46-5.8V304c0 7.4 1 14.7 2.9 21.5l-43.8 29.2c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l40.8-27.2C208.3 372.3 230.8 384 256 384c17 0 32.8-5.3 45.8-14.4l-23.2-23.2c-6.7 3.6-14.4 5.6-22.5 5.6c-26.5 0-48-21.5-48-48V280.3c0-.2 0-.4 0-.7v-3.8l-32-32v22z"]
};
var faDebug = faBanBug;
var faPersonBooth = {
  prefix: 'fal',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM32 223.4c0 .2 0 .4 0 .6l0 55.7c.2 5.1 2.7 9.7 6.9 12.6L80 320.6V180.2c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28v19.4zm0 103L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 280.2c0-.3 0-.7 0-1V204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H176.7c-10.9 0-21-5.5-26.9-14.7L112 214.5V342.6L146.1 366c8.7 6 13.9 15.8 13.9 26.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V392.4l-96-66zM256 32c-8.8 0-16 7.2-16 16V224H208V48c0-26.5 21.5-48 48-48h24H528c26.5 0 48 21.5 48 48V384 496c0 8.8-7.2 16-16 16s-16-7.2-16-16V439.4c-9.4 5.4-20.3 8.6-32 8.6c-15.1 0-29.1-5.3-40-14c-10.9 8.8-24.9 14-40 14s-29.1-5.3-40-14c-10.9 8.8-24.9 14-40 14c-35.3 0-64-28.7-64-64v-2.9c0-10.8 2.2-21.6 6.5-31.5L335 255 268.1 32H256zm45.5 0l65.8 219.4c1.1 3.6 .9 7.5-.6 10.9l-42.8 99.9c-2.6 6-3.9 12.4-3.9 18.9V384c0 17.7 14.3 32 32 32c11.1 0 20.9-5.7 26.7-14.3c3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3s20.9-5.7 26.7-14.3c3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3c17.7 0 32-14.3 32-32V48c0-8.8-7.2-16-16-16H301.5zM240 320V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V320h32z"]
};
var faTextWidth = {
  prefix: 'fal',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64H208l0 192H160c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H240l0-192H416v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32zM4.7 372.7c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400H393.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 368H54.6l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80z"]
};
var faGarageCar = {
  prefix: 'fal',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zm156.9 75.1L238.4 344H401.6l-14.6-44.9c-2.1-6.6-8.3-11.1-15.2-11.1H268.2c-6.9 0-13.1 4.5-15.2 11.1zm164.6-9.9l20.6 63.6c15.6 9.9 25.9 27.4 25.9 47.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H208v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-19.8 10.3-37.3 25.9-47.2l20.6-63.6c6.4-19.8 24.9-33.2 45.7-33.2H371.8c20.8 0 39.2 13.4 45.7 33.2zM208 448H432V400c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24v48zm24-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSquareKanban = {
  prefix: 'fal',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zM128 288c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16zm176 48c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V336zm-80-80c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"]
};
var faHatWizard = {
  prefix: 'fal',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M408.6 368L348.2 227c-9.3-21.6-10.3-45.9-2.8-68.2l37.3-112L246.5 124.6c-29.6 16.9-53 42.8-66.8 73.9L104.4 368h-35l81.1-182.5c16.6-37.4 44.7-68.4 80.2-88.7l165-94.3C398.5 .9 401.7 0 405 0c10.5 0 19 8.5 19 19v1.7c0 2.2-.4 4.4-1.1 6.5L375.7 168.9c-5 14.9-4.3 31 1.9 45.4L443.4 368H408.6zM480 456c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24zM56 400H456c30.9 0 56 25.1 56 56s-25.1 56-56 56H56c-30.9 0-56-25.1-56-56s25.1-56 56-56zM288 176v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zM240 304v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H240 208 176c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPenFancy = {
  prefix: 'fal',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", "M392.1 48.7C401.7 38.1 415.3 32 429.6 32C457.4 32 480 54.6 480 82.4c0 14.3-6.1 27.9-16.7 37.5L256.6 306 206 255.4 392.1 48.7zM429.6 0c-23.4 0-45.6 9.9-61.3 27.3L175.1 242 98.9 265.4c-19.8 6.1-35.4 21.3-41.9 40.9L2.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L205.6 455c19.6-6.5 34.9-22.1 40.9-41.9L270 336.9 484.7 143.7c17.4-15.6 27.3-37.9 27.3-61.3C512 36.9 475.1 0 429.6 0zM237.9 332.5L216 403.7c-3 9.9-10.7 17.7-20.5 20.9L67.2 467.4 134.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L44.6 444.8 87.4 316.5c3.3-9.8 11.1-17.4 20.9-20.5l71.2-21.9 58.4 58.4z"]
};
var faCoffeePot = {
  prefix: 'fal',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M80 64c-26.5 0-48 21.5-48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V112C0 67.8 35.8 32 80 32h42.4H128 453.6C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L98.3 69.1c-.7-1.6-1.3-3.4-1.7-5.1H80zm365 0H131l49.8 112H395.2L445 64zM416 208H160l0 0c-26.4 19.9-46.5 47.7-56.7 80H472.7c-10.1-32.3-30.2-60.1-56.7-80l0 0zm63.2 112H96.8c-.5 5.3-.8 10.6-.8 16v8c0 42.6 27.2 78.8 46.8 98.8c2.7 2.8 7.7 5.2 15.2 5.2H418c7.5 0 12.5-2.4 15.2-5.2c19.6-20 46.8-56.2 46.8-98.8v-8c0-5.4-.3-10.7-.8-16z"]
};
var faMouseField = {
  prefix: 'fal',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M379.4 36.6c6.2-3 13.2-4.6 20.6-4.6c26.5 0 48 21.5 48 48c0 9.6-2.8 18.6-7.7 26.1c-12.5-5.5-26-8.9-40.3-9.8V96c0-22.4-7.7-43-20.6-59.4zm88.2 86.2C475.4 110.4 480 95.7 480 80c0-44.2-35.8-80-80-80c-16.9 0-32.7 5.3-45.6 14.3C339.7 5.2 322.5 0 304 0c-53.1 0-96 43.4-96 96.3c0 25.7 10.2 49.8 27.5 67.5C155.8 180.6 96 251.3 96 336c0 18 6 34.6 16 48H64c-35.3 0-64 28.7-64 64s28.7 64 64 64H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H176 344h12.1c24.2 0 43.9-19.7 43.9-43.9c0-18.9-12.1-35.7-30-41.6l-12.8-4.3L378.8 272H464c26.5 0 48-21.5 48-48v-8c0-37.6-17.3-71.2-44.4-93.2zM176 384c-26.5 0-48-21.5-48-48c0-79.5 64.5-144 144-144h16c7.7 0 14.4-5.5 15.7-13.1s-2.9-15.1-10.1-17.8l-12.1-4.5c-24.9-9.3-41.5-33.4-41.5-60.2C240 60.9 268.7 32 304 32c35.3 0 64 28.7 64 64v16c0 8.8 7.2 16 16 16h8c48.6 0 88 39.4 88 88v8c0 8.8-7.2 16-16 16H368c-6.5 0-12.4 4-14.9 10.1l-26.4 66-33.7-11.2c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l76.9 25.6c4.9 1.6 8.1 6.2 8.1 11.3c0 6.6-5.3 11.9-11.9 11.9H344 176zM336 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16V80zm96 108a20 20 0 1 0 -40 0 20 20 0 1 0 40 0z"]
};
var faPersonDigging = {
  prefix: 'fal',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", "M256 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32A64 64 0 1 1 192 64a64 64 0 1 1 128 0zM440.1 322.2L373.9 439.8c-2.8 5-8.2 8.2-13.9 8.2H313.9l-16 32H533.4L440.1 322.2zm-26.1-18.9c5.3-9.4 15.2-15.2 26-15.2c10.6 0 20.3 5.6 25.7 14.7L564 468.9c2.6 4.4 4 9.4 4 14.5c0 15.8-12.8 28.6-28.6 28.6H292.9c-16 0-28.9-13-28.9-28.9c0-4.5 1-8.9 3.1-12.9l18.2-36.4c5.4-10.8 16.5-17.7 28.6-17.7h36.8l13.8-24.5L24.3 206c-7.8-4.2-10.6-14-6.4-21.7s14-10.6 21.7-6.4l33.6 18.3 13.1-24c14.9-27.4 44.4-43.6 75.6-41.5l13.9 .9c45.9 3.1 85.3 33.9 99.3 77.8l36.2 113.7-3.4 1.1 72.3 39.4 34-60.4zm-142.3 1.3l-27.2-85.4c-10-31.3-38.1-53.4-70.9-55.6l-13.9-.9c-18.7-1.2-36.4 8.5-45.3 24.9l-13.1 24 170.4 92.9zM57.6 289.3c4.6-2 9.8-1.7 14.1 .7l127.5 70.9c15.2 8.5 24.7 24.5 24.7 42V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V402.8c0-5.8-3.2-11.2-8.2-14L74.5 328.1 31.5 499.9c-2.1 8.6-10.8 13.8-19.4 11.6S-1.7 500.7 .5 492.1l48-192c1.2-4.8 4.6-8.8 9.2-10.8z"]
};
var faDigging = faPersonDigging;
var faShowerDown = {
  prefix: 'fal',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M192 0c8.8 0 16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H336 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32C32 109 95.1 40.8 176 32.8V16c0-8.8 7.2-16 16-16zm0 64C121.3 64 64 121.3 64 192H320c0-70.7-57.3-128-128-128zm50.7 388.9c-1.8 2.8-2.7 6.1-2.7 9.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L256 431.6l-13.3 21.3zm-27.1-17l28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V464c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4zM320 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L320 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM114.7 452.9c-1.8 2.8-2.7 6.1-2.7 9.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L128 431.6l-13.3 21.3zm-27.1-17l28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V464c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4zM192 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L192 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM50.7 324.9c-1.8 2.8-2.7 6.1-2.7 9.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L64 303.6 50.7 324.9zm-27.1-17l28.2-45.1C54.4 258.6 59 256 64 256s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4z"]
};
var faShowerAlt = faShowerDown;
var faBoxCircleCheck = {
  prefix: 'fal',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H352h64 16 16v-2.4c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H296.2c-8.1-9.8-15.2-20.6-21-32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zm224 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faBrightness = {
  prefix: 'fal',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M240 104c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v88zm16 88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 160c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16zM0 256c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm408-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H408zM75 437c6.2 6.2 16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L75 414.4c-6.2 6.2-6.2 16.4 0 22.6zM352.2 137.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L437 97.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-62.2 62.2zM75 75c-6.2 6.2-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L97.6 75c-6.2-6.2-16.4-6.2-22.6 0zM374.8 352.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L414.4 437c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2z"]
};
var faCarSideBolt = {
  prefix: 'fal',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M126.8 94.2L87.6 192H160v32H64c-17.7 0-32 14.3-32 32V368H65.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H385.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H608V320c0-53-43-96-96-96H448V192h30.7l-88-110c-9.1-11.4-22.9-18-37.5-18H171.3c-19.6 0-37.3 11.9-44.6 30.2zM52.8 193L97.1 82.3C109.2 51.9 138.6 32 171.3 32H353.2c24.3 0 47.3 11 62.5 30L519.9 192.2C586.9 196.3 640 252 640 320v48c0 17.7-14.3 32-32 32H574.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H32c-17.7 0-32-14.3-32-32V256c0-31.5 22.8-57.7 52.8-63zM418 368c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48zM96 384c0 5.5 .7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48c-1.3 5.1-2 10.5-2 16zM347.3 123.3L278.6 192H368c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 224H240c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faOrnament = {
  prefix: 'fal',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", "M192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm45.3 32c1.8-5 2.7-10.4 2.7-16c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 5.6 1 11 2.7 16H128c-17.7 0-32 14.3-32 32v48 9.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3V144 96c0-17.7-14.3-32-32-32H237.3zm24.6 112c23 11.2 43 27.7 58.2 48H64c15.2-20.3 35.2-36.8 58.2-48H128 256h5.8zM192 96h64v48H128V96h64zM32 320c0-22.8 4.8-44.4 13.3-64H338.7c8.6 19.6 13.3 41.2 13.3 64s-4.7 44.4-13.3 64H45.3C36.8 364.4 32 342.8 32 320zM192 480c-52.3 0-98.8-25.1-128-64H320c-29.2 38.9-75.7 64-128 64z"]
};
var faPhoneArrowDownLeft = {
  prefix: 'fal',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M507.3 27.3L342.6 192H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faPhoneArrowDown = faPhoneArrowDownLeft;
var faPhoneIncoming = faPhoneArrowDownLeft;
var faCloudWord = {
  prefix: 'fal',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", "M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7c44.2 0 80 35.8 80 80c0 7.7-1.1 15-3 22c-4.1 14.5 2.5 30 15.8 37.1C587.3 283.2 608 315.2 608 352c0 53-43 96-96 96H144C82.1 448 32 397.9 32 336c0-48.8 31.2-90.3 74.8-105.7c12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2c9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-49.1-27.7-91.8-68.3-113.2c2.8-9.8 4.3-20.1 4.3-30.8c0-61.9-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8zM512 368c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16zM240 352H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zM128 304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H400z"]
};
var faHandFingersCrossed = {
  prefix: 'fal',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M189.8 4.4c-28.5-12.1-61.3 1.3-73.4 29.8L112 44.6l-4.4-10.5C95.5 5.7 62.7-7.6 34.2 4.4S-7.6 49.3 4.4 77.8L51.2 188.4 28.4 242.2 15.6 272.6C5.8 285.8 0 302.2 0 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V312 248v-8c0-3.2-.9-6.1-2.5-8.6C374.4 208.6 353.2 192 328 192c-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-30.9 0-56 25.1-56 56v1.7l-19.2-45.4L219.6 77.8c12.1-28.5-1.3-61.3-29.8-73.4zm-34.4 225l4.5 10.6H151l4.5-10.6zM68.6 147.3L33.9 65.4c-5.2-12.2 .5-26.3 12.8-31.5s26.3 .5 31.5 12.8L94.6 85.7 68.6 147.3zM80 240c-5.7 0-11.3 .6-16.6 1.7L145.9 46.6c5.2-12.2 19.2-17.9 31.5-12.8s17.9 19.2 12.8 31.5L116.2 240H80zm168-32c13.3 0 24 10.7 24 24v16 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0V232c0-13.3 10.7-24 24-24zm32.5 133.6C290.4 357.5 308 368 328 368c8.4 0 16.4-1.9 23.5-5.2C346.1 428.5 291 480 224 480H160C89.3 480 32 422.7 32 352V320c0-26.5 21.5-48 48-48h88c13.2 0 24 10.7 24 24v0c0 13.3-10.7 24-24 24H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c12.1 0 23.3-3.8 32.5-10.4zM352 312c0 13.3-10.7 24-24 24s-24-10.7-24-24V296 248c0-13.3 10.7-24 24-24s24 10.7 24 24v64z"]
};
var faTrash = {
  prefix: 'fal',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6z"]
};
var faGaugeSimple = {
  prefix: 'fal',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64z"]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faArrowDownSmallBig = {
  prefix: 'fal',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", "M171.3 475.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4L75.3 356.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zm-32 0v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zm32 352V304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V432z"]
};
var faSortSizeDownAlt = faArrowDownSmallBig;
var faBookMedical = {
  prefix: 'fal',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM224 96h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H288v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V256H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h32V128c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H160v32h48c8.8 0 16 7.2 16 16v48h32V240c0-8.8 7.2-16 16-16h48V192H272c-8.8 0-16-7.2-16-16V128H224z"]
};
var faFaceMelting = {
  prefix: 'fal',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M544 256c0 21.5-3 42.3-8.7 62c-6.5 22.7-2.1 46.4 9.5 64.6c.6 .9 1.2 1.9 1.9 2.8c-29 6.1-50.7 31.8-50.7 62.6c0 11.7 3.1 22.6 8.6 32H320 101.3c7.3-9.4 12.9-19.6 16.7-28.9c11.5-27.7 16.2-65.6 1.3-95.4c-15-30-23.4-63.8-23.4-99.8C96 132.3 196.3 32 320 32s224 100.3 224 224zM16 512H41.4 320 560c8.8 0 16-7.2 16-16s-7.2-16-16-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h44.1H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H604.1c-27.7 0-45.6-30.6-38-57.2c6.5-22.5 9.9-46.2 9.9-70.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 41 9.6 79.7 26.7 114c18.4 37-8 110-49.3 110H16c-8.8 0-16 7.2-16 16s7.2 16 16 16zM249.3 212.2a24 24 0 1 0 12.4-46.4 24 24 0 1 0 -12.4 46.4zm183.9 24.4a24 24 0 1 0 -46.4-12.4 24 24 0 1 0 46.4 12.4zm-220 46.7c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z"]
};
var faPoo = {
  prefix: 'fal',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M224 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l5.8 5.8c8.7 8.7 13.5 20.4 13.5 32.7v8.9c0 20.6-16.7 37.3-37.3 37.3H176.9 176c-48.6 0-88 39.4-88 88c0 7.2 .9 14.3 2.5 21.1C56.4 233.2 32 265.7 32 304c0 16 4.3 31 11.7 43.9C17.6 363.2 0 391.5 0 424c0 48.6 39.4 88 88 88H424c48.6 0 88-39.4 88-88c0-32.5-17.6-60.8-43.7-76.1C475.7 335 480 320 480 304c0-38.3-24.4-70.8-58.5-82.9c1.7-6.8 2.5-13.8 2.5-21.1c0-35-20.4-65.1-49.9-79.3C363 52.2 303.6 0 232 0h-8zm40 65.8c0-10.7-2.2-21.2-6.3-30.8c46.1 10.8 81.3 50.2 85.8 98.4c.6 6.3 4.8 11.6 10.7 13.6c22 7.6 37.8 28.4 37.8 53c0 9.1-2.2 17.7-6 25.2c-2.4 4.7-2.3 10.2 .2 14.8s7.1 7.7 12.3 8.3c27.9 3.2 49.5 26.9 49.5 55.6c0 15.3-6.2 29.2-16.2 39.4c-4 4-5.5 9.9-4.1 15.4s5.7 9.8 11.2 11.3c23.7 6.5 41 28.3 41 54c0 30.9-25.1 56-56 56H88c-30.9 0-56-25.1-56-56c0-25.7 17.4-47.4 41-54c5.5-1.5 9.7-5.8 11.2-11.3s-.1-11.3-4.1-15.4C70.2 333.2 64 319.3 64 304c0-28.7 21.7-52.4 49.5-55.6c5.2-.6 9.8-3.7 12.3-8.3s2.6-10.1 .2-14.8c-3.8-7.6-6-16.1-6-25.2c0-30.9 25.1-56 56-56h.9 17.8C233 144 264 113 264 74.7V65.8zM192 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM172.3 352c-15.6 0-28.3 12.7-28.3 28.3c0 5.5 1.6 11.5 5.6 16.6C159 408.8 194.4 448 256 448s97-39.2 106.4-51.1c4-5.1 5.6-11.1 5.6-16.6c0-15.6-12.7-28.3-28.3-28.3H172.3zM256 416c-38.2 0-63.3-19.8-75.1-32H331.1c-11.8 12.2-36.9 32-75.1 32z"]
};
var faPenClipSlash = {
  prefix: 'fal',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM556.7 149.3c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0L378.3 67.7 365.3 54.6c-25-25-65.5-25-90.5 0l-47 47 25.3 20 44.3-44.3c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1L293 153.1l25.3 20L378.3 113 463 197.7l-50.1 50.1 25.3 20L556.7 149.3zM321.8 338.9l-50.9 50.9c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4l40.9-40.9-25.3-20-38.3 38.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L347 358.9l-25.3-20zm127.6-297c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L485.7 175 401 90.3l48.4-48.4z"]
};
var faPenAltSlash = faPenClipSlash;
var faQuoteRight = {
  prefix: 'fal',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 304c0 61.9-50.1 112-112 112H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c44.2 0 80-35.8 80-80V279.4c-9.4 5.4-20.3 8.6-32 8.6H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 80zM416 192V160c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192zM192 304c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H80c44.2 0 80-35.8 80-80V279.4c-9.4 5.4-20.3 8.6-32 8.6H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 80zM160 192V160c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V192z"]
};
var faQuoteRightAlt = faQuoteRight;
var faScrollOld = {
  prefix: 'fal',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M80 64c-26.5 0-48 21.5-48 48v72c0 4.4 3.6 8 8 8H96v32H40c-22.1 0-40-17.9-40-40V112C0 67.8 35.8 32 80 32H400c44.2 0 80 35.8 80 80V288H448V256H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V160H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V112c0-26.5-21.5-48-48-48H144c10 13.4 16 30 16 48V224h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160V400c0 26.5 21.5 48 48 48s48-21.5 48-48V352c0-22.1 18-40 40-40h.6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .5 .4 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .6 .6 .6c22.1 0 40 17.9 40 40v56c0 39.8-32.2 72-72 72H208c-44.2 0-80-35.8-80-80V240 112c0-26.5-21.5-48-48-48zM272 448H504c22.1 0 40-17.9 40-40V352c0-4.4-3.6-8-8-8h-.6-.6-.6-.6-.5-.6-.5-.5H531h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H524h-.5H523h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H513h-.5H512h-.5H511h-.5H510h-.5H509h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H499h-.5H498h-.5H497h-.5H496h-.5H495h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H485h-.5H484h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H477h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H471h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H466h-.5-.5-.5-.5-.4-.5-.4-.4H462h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H454h-.4-.4-.4-.4-.4-.4-.4-.4H450h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H443h-.4-.4-.4-.4-.4-.4H440h-.4-.4-.4-.4-.4-.4H437h-.4-.4-.4-.4-.4-.4H434h-.4-.4-.4-.4-.4-.4H431h-.4-.4-.4-.4-.4-.4H428h-.4-.4-.4-.4-.4-.4H425h-.4-.4-.4-.4-.4-.4H422h-.4-.4-.4-.4-.4-.4H419h-.4-.4-.4-.4-.4-.4H416h-.4-.4-.4-.4-.4-.4H413h-.4-.4-.4-.4-.4-.4H410h-.4-.4-.4-.4-.4-.4H407h-.4-.4-.4-.4-.4-.4H404h-.4-.4-.4-.4-.4-.4H401h-.4-.4H400v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V344h-.2-.5-.5-.5H366h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H361h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H355h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H348h-.5H347h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H337h-.5H336h-.5H335h-.5H334h-.5H333h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H323h-.5H322h-.5H321h-.5H320h-.5H319h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H309h-.5H308h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H301h-.5-.5-.5-.5-.5-.5-.6-.6H296c-4.4 0-8 3.6-8 8v48c0 18-6 34.6-16 48z"]
};
var faGuitars = {
  prefix: 'fal',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", "M80 32V83.2c0 6.3 1.9 12.5 5.4 17.8L112 140.8v36C57.7 183 16 219.7 16 264c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c29.3 0 56.3-8 77.8-21.4c-5.4-9.4-9.3-19.7-11.6-30.6c-16.3 12-38.8 20.1-66.2 20.1c-59.5 0-96-38.1-96-72c0-14.1 5.6-27.9 16.5-40c20.9-23.2 21.3-58 6.2-82c-4.5-7.1-6.7-14.5-6.7-22c0-21.6 22.4-49.2 64-54.9v65.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V209.1c41.6 5.7 64 33.4 64 54.9c0 7.5-2.2 14.9-6.7 22c-15.1 23.9-14.7 58.8 6.2 82c.4 .5 .9 1 1.3 1.5c1.9-4.6 3.9-8.9 5.7-13l.3-.7c3.7-8.4 6.9-15.6 9.5-22c-3-10.1-1.5-21.8 4.1-30.7c1.1-1.7 2.1-3.5 3.1-5.3c-.9-4.9-2.7-10.7-5.7-19.2l-.5-1.4c-3.7-10.7-9.3-26.7-9.3-44.6v-23c-17.4-17.3-42.9-29.4-72-32.7v-36l26.6-39.9c3.5-5.3 5.4-11.4 5.4-17.8V32c0-17.7-14.3-32-32-32H112C94.3 0 80 14.3 80 32zm64 288a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM128 107.2l-16-24V32h32V83.2l-16 24zM344.9 50.8C347.3 39.8 357 32 368.2 32H372c10.9 0 20 9 20 20.2c0 10.9-8.9 19.8-19.6 19.8C361.2 72 352 81.2 352 92.4v57l-17.4-19.9c-3.3-3.8-4.7-8.9-3.6-13.9l13.9-64.8zm-34.4 99.8L352 198v42h-8c-43.3 0-57.3-29.2-61.8-48.2c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16v40.6c0 12.4 4 24 8 35.5c4 11.6 8 23.3 8 35.9c0 20-9.3 40.9-19 62.5c-10.3 23.2-21 47.1-21 71.7c0 40.8 33 73.8 73.8 73.8H438.2c40.8 0 73.8-33 73.8-73.8c0-24.5-10.7-48.5-21-71.7c-9.6-21.6-19-42.5-19-62.5c0-12 4-22.9 8.1-33.8l0 0c4-10.7 7.9-21.4 7.9-33V208c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5c-5.7 14-20.8 32.5-60.5 32.5h-8V192 102.7c23-5.3 40-26.1 40-50.5C424 23.6 400.8 0 372 0h-3.8c-26.3 0-49.1 18.4-54.6 44.1L299.7 109c-3.2 14.8 .8 30.3 10.8 41.7zm54.3 121.1c1 .2 2.1 .3 3.2 .3s2.2-.1 3.2-.3H392c24.2 0 44-5.6 59.5-15.6c-.4 1.1-.8 2.2-1.2 3.3l-.4 1.2c-3.8 10.1-9.5 25.6-9.5 43.4c0 27 12 53.8 20.9 73.6l1.8 4.1c10.5 23.5 17.3 40.6 17.3 56.5c0 23.3-18.9 42.1-42.1 42.1H297.8c-23.3 0-42.1-18.9-42.1-42.1c0-15.9 6.8-33 17.3-56.5l1.8-4.1c8.9-19.9 20.9-46.6 20.9-73.6c0-18-5.5-34-9.3-44.8l-.4-1.3c-.7-1.9-1.3-3.7-1.8-5.3c15.1 11.9 35 19.2 59.9 19.2h20.8zM320 352c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
};
var faPhoneXmark = {
  prefix: 'fal',
  iconName: 'phone-xmark',
  icon: [640, 512, [], "e227", "M420.7 4.7c6.2-6.2 16.4-6.2 22.6 0L496 57.4 548.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 80l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 102.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 80 420.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zM393 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C247.5 494.5 64 300.7 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L393 286.7zM512 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faHose = {
  prefix: 'fal',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M288 112c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.9l96.1-12c1 7.8 7.7 13.9 15.9 13.9c8.8 0 16-7.2 16-16V94.1 80 48 33.9 32c0-8.8-7.2-16-16-16c-8.1 0-14.8 6.1-15.9 13.9L320 17.9V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64v48zm32-61.9l96 12v3.8l-96 12V64 50.1zM48 448H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM12.2 432C4.6 440.5 0 451.7 0 464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48H152c-30.9 0-56-25.1-56-56s25.1-56 56-56H256V80H152c-48.6 0-88 39.4-88 88s39.4 88 88 88H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H152C85.7 288 32 234.3 32 168S85.7 48 152 48H256V16H152C68.1 16 0 84.1 0 168c0 48.8 23 92.2 58.7 120H48c-26.5 0-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32C4.6 376.5 0 387.7 0 400s4.6 23.5 12.2 32zM152 320H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H152zM48 384H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faClockSix = {
  prefix: 'fal',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faShirt = {
  prefix: 'fal',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M211.4 0c-27.7 0-54.5 9.6-76 27.1L56.3 91.9 12.9 127.4c-13.7 11.2-15.7 31.4-4.5 45l70.9 86.7c11.2 13.7 31.4 15.7 45 4.5L160 234.4V456c0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56V234.4l35.6 29.1c13.7 11.2 33.8 9.2 45-4.5l70.9-86.7c11.2-13.7 9.2-33.8-4.5-45l-10.1 12.4 10.1-12.4L583.7 91.9 504.6 27.1C483.1 9.6 456.3 0 428.6 0h-6.3c-1.3 0-2.5 .1-3.7 .2c-.8-.1-1.7-.2-2.6-.2H224c-.9 0-1.7 .1-2.6 .2c-1.2-.1-2.4-.2-3.7-.2h-6.3zm40.7 32H387.9C378 60 351.3 80 320 80s-58-20-67.9-48zM155.7 51.9C171.4 39 191.1 32 211.4 32h6.3l0 0c0 0 .2 .1 .4 .3c.5 .4 1 1.2 1.3 2.2C231.1 79.1 271.7 112 320 112s88.9-32.9 100.6-77.5c.3-1 .8-1.8 1.3-2.2c.2-.2 .4-.2 .4-.3l0 0h6.3c20.3 0 40 7 55.7 19.9l79.2 64.8 43.3 35.5-70.9 86.7-43.3-35.5-18.4-15.1c-4.8-3.9-11.4-4.7-17-2.1s-9.1 8.3-9.1 14.5V456c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V200.7c0-6.2-3.6-11.8-9.1-14.5s-12.2-1.8-17 2.1l-18.4 15.1-43.3 35.5L33.2 152.1l43.3-35.5 79.2-64.8z"]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faBillboard = {
  prefix: 'fal',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", "M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H240V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H80C53.5 32 32 53.5 32 80V352H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 64 304V488c0 8.8 7.2 16 16 16s16-7.2 16-16V384H576h32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V80c0-26.5-21.5-48-48-48H432V16zM320 352H64V80c0-8.8 7.2-16 16-16H208v64H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64H400v64H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432V64H560c8.8 0 16 7.2 16 16V352H320z"]
};
var faSquareR = {
  prefix: 'fal',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32h80c44.2 0 80 35.8 80 80c0 34.8-22.2 64.4-53.2 75.4l50.5 75.7c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L231.4 288H160v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 160c0-17.7 14.3-32 32-32zm80 128c26.5 0 48-21.5 48-48s-21.5-48-48-48H160v96h80z"]
};
var faCubes = {
  prefix: 'fal',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", "M293.4 32.8c-3.5-1.2-7.3-1.2-10.8 0l-104 37.1c-2.3 .8-4.4 2.2-6.1 3.9L288 118 403.4 73.8c-1.7-1.7-3.7-3-6.1-3.9l-104-37.1zM168 212.8l.1 0L272 249.9V146.2L168 106.3V212.8zm136 37.1l103.9-37.1 .1 0V106.3L304 146.2V249.9zM440 85V212.8l.1 0 104 37.1c19.1 6.8 31.9 24.9 31.9 45.2V421.4c0 19.4-11.7 36.9-29.6 44.4l-104 43c-11.8 4.9-25 4.9-36.7 0L288 460.1 170.4 508.8c-11.8 4.9-25 4.9-36.7 0l-104-43C11.7 458.3 0 440.8 0 421.4V295.2c0-20.3 12.8-38.4 31.9-45.2l104-37.1 .1 0V85c0-20.3 12.8-38.4 31.9-45.2l104-37.1c10.4-3.7 21.8-3.7 32.3 0l104 37.1C427.2 46.6 440 64.7 440 85zM272 308.2L160 348.6V478.4l112-46.3V308.2zM41.9 436.2L128 471.8V348.1L32 308.9V421.4c0 6.5 3.9 12.3 9.9 14.8zM416 478.4V348.6L304 308.2V432.1l112 46.3zm32-6.6l86.1-35.6c6-2.5 9.9-8.3 9.9-14.8V308.9l-96 39.2V471.8zM157.4 243c-3.5-1.2-7.3-1.2-10.8 0L44.6 279.4l99.8 40.8 114.1-41.1L157.4 243zm261.2 0L317.5 279.1l114.1 41.1 99.8-40.8L429.4 243c-3.5-1.2-7.3-1.2-10.8 0z"]
};
var faEnvelopeOpenDollar = {
  prefix: 'fal',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", "M392 32H120c-13.3 0-24 10.7-24 24V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zM272 88v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V296c0 8.8-7.2 16-16 16s-16-7.2-16-16V278.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V88c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDivide = {
  prefix: 'fal',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 272c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H416z"]
};
var faSunCloud = {
  prefix: 'fal',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.4-50.9c-11-.4-21.6-2.6-31.4-6.5l-5 27.3-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.9l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-17.1 24.8c4-.4 8.2-.7 12.3-.7c8.6 0 17 1 25.1 2.8l20.1-29.2c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1c-2.5-8.5-3.8-17.6-3.8-26.9c0-1.9 .1-3.7 .2-5.5c-10.1 3.6-20.9 5.5-32.2 5.5c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 1.9-.1 3.7-.2 5.5c3.2-1.1 6.4-2.1 9.7-2.9c4.9-11 11.5-21.1 19.5-29.9C368.6 171.1 317.3 128 256 128zm208 96c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64H568c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224zm0 32c26.5 0 48 21.5 48 48l0 .8c0 6.5 3.9 12.4 9.9 14.9s13 1.1 17.5-3.6c7.3-7.4 17.4-12 28.6-12c22.1 0 40 17.9 40 40s-17.9 40-40 40H384c-17.7 0-32-14.3-32-32s14.3-32 32-32c3.8 0 7.4 .6 10.7 1.8c5 1.8 10.6 1 14.9-2.2s6.7-8.2 6.5-13.5c0-.7 0-1.4 0-2.1c0-26.5 21.5-48 48-48z"]
};
var faLampFloor = {
  prefix: 'fal',
  iconName: 'lamp-floor',
  icon: [640, 512, [], "e015", "M224 32L160 192H480L416 32 224 32zM194.3 20.1C199.1 8 210.9 0 224 0H416c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM208 480h96V256h32V480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 208c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSquare7 = {
  prefix: 'fal',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32H304c5.7 0 11 3 13.8 8s2.9 11 .1 16l-128 224c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8L276.4 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTengeSign = {
  prefix: 'fal',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 48c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48zM0 176c0-8.8 7.2-16 16-16H192 368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H16c-8.8 0-16-7.2-16-16z"]
};
var faTenge = faTengeSign;
var faHeadphones = {
  prefix: 'fal',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", "M32.6 271.6C41 155.5 137.8 64 256 64s215 91.5 223.4 207.6C466.1 261.8 449.7 256 432 256c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80V368 336 288C512 146.6 397.4 32 256 32S0 146.6 0 288v48 32 32c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48c-17.7 0-34.1 5.8-47.4 15.6zM32 336c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48V368 336zm448 0v32 32c0 26.5-21.5 48-48 48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16c26.5 0 48 21.5 48 48z"]
};
var faHandsHolding = {
  prefix: 'fal',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M128 128c0-35.3-28.7-64-64-64S0 92.7 0 128V344.2c0 29.7 11.8 58.2 32.8 79.2l83.9 83.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L55.4 400.8c-15-15-23.4-35.4-23.4-56.6V128c0-17.7 14.3-32 32-32s32 14.3 32 32V252.3c0 27.1 10.8 53.1 29.9 72.2l10.7 10.8s0 0 0 0l44 44s0 0 0 0l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-44-44c-9.2-9.2-9.2-24.2 0-33.4s24.2-9.2 33.4 0L284 370.6c12.8 12.8 20 30.2 20 48.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V418.9c0-18.1 7.2-35.5 20-48.3l91.3-91.3c9.2-9.2 24.2-9.2 33.4 0s9.2 24.2 0 33.4l0 0-44 44 0 0-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16 44-44 10.8-10.8c19.2-19.2 29.9-45.1 29.9-72.2V128c0-17.7 14.3-32 32-32s32 14.3 32 32V344.2c0 21.2-8.4 41.6-23.4 56.6l-83.9 83.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l83.9-83.9c21-21 32.8-49.5 32.8-79.2V128c0-35.3-28.7-64-64-64s-64 28.7-64 64V252.3c0 4.6-.4 9.1-1.3 13.5c-2.1-3.2-4.6-6.3-7.4-9.1c-21.7-21.7-56.9-21.7-78.6 0L333.4 348c-5.1 5.1-9.6 10.6-13.4 16.6c-3.8-5.9-8.3-11.5-13.4-16.6l-91.3-91.3c-21.7-21.7-56.9-21.7-78.6 0c-2.8 2.8-5.3 5.9-7.4 9.1c-.9-4.4-1.3-8.9-1.3-13.5V128z"]
};
var faCampfire = {
  prefix: 'fal',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4c-3.2 0-6.4 1.1-9 3.4c-29.9 27-55.3 57.7-73.2 87.1c-17.7 29-29.2 60.2-29.2 84.2C112 254.5 175.3 320 256 320c79.9 0 144-65.5 144-145.3c0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0c-1.5 1.4-3.1 2.9-4.6 4.4c-6.9 7-13.4 15-19.2 22.4c-6.3-7.7-12.8-15.1-19.5-22.3C252.9 23.1 242.7 13 232.2 3.4zM282.4 85c8.8-.1 17.1-4.2 22.5-11.1c3.4-4.3 6.8-8.5 10.1-12.3c14.6 16.1 27.5 35.6 37.3 54.6c12.2 23.7 18.5 46.9 18.5 58.5c0 64.1-51.5 116.2-114.9 116.2c-64.2 0-114.9-52-114.9-116.2c0-16.4 8.4-42.1 24.9-69c14.3-23.4 34-48 57.3-70.7c12.8 12.4 24.9 25.5 36.4 39.5c5.6 6.8 14 10.7 22.8 10.6zm-57.9 .8c-4.9 0-9.5 2.2-12.5 6c-13.4 16.7-24.3 30.8-31.8 43.7c-7.6 13.3-12.3 26.3-12.3 40.8c0 26.4 9.7 48.5 26.4 63.9c16.5 15.3 38.8 23 62.5 23c19.5 0 37-5.6 53-16.4l0 0 .3-.2c34.3-24.2 42.4-71.4 23-107.7l0-.1c-1.7-3.5-4.1-8.2-7.6-13c-2.9-3.9-7.4-6.3-12.3-6.5s-9.6 1.9-12.7 5.6l-19.6 23.2-14.5-18.6c-13.5-17.3-27.5-35.4-29.3-37.7c-3-3.8-7.6-6.1-12.5-6.1zM292.5 184l16.7-19.7c6.4 21.2-.5 44.2-17.3 56.2c-10.9 7.3-22.2 10.8-35 10.8c-16.8 0-31-5.4-40.8-14.5c-9.6-8.9-16.1-22.2-16.1-40.4c0-7.2 2.1-14.7 8-24.8c4-6.9 9.4-14.5 16.4-23.8l16.7 21.5 18.3 23.6 6 7.7 1.7 2.1 .4 .6 .1 .1 0 0 0 0 0 0 12.6-9.8-12.6 9.8c3 3.8 7.5 6.1 12.3 6.2s9.4-2 12.5-5.6zM21.9 289.1c-8.2-3.3-17.5 .7-20.8 8.9s.7 17.5 8.9 20.8L212.9 400 10.1 481.1c-8.2 3.3-12.2 12.6-8.9 20.8s12.6 12.2 20.8 8.9L256 417.2l234.1 93.6c8.2 3.3 17.5-.7 20.8-8.9s-.7-17.5-8.9-20.8L299.1 400l202.9-81.1c8.2-3.3 12.2-12.6 8.9-20.8s-12.6-12.2-20.8-8.9L256 382.8 21.9 289.1z"]
};
var faCircleAmpersand = {
  prefix: 'fal',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 184c0-13.3 10.7-24 24-24h16.8c12.8 0 23.2 10.4 23.2 23.2c0 10.2-5 19.8-13.5 25.6l-21.8 15-22.1-23.3c-4.3-4.5-6.6-10.4-6.6-16.6zm68.7 51.2c17.1-11.8 27.3-31.2 27.3-52c0-30.5-24.7-55.2-55.2-55.2H232c-30.9 0-56 25.1-56 56c0 14.4 5.5 28.2 15.4 38.6l18.6 19.5-38.7 26.6C154.2 280.5 144 300 144 320.8c0 34.9 28.3 63.2 63.2 63.2h36c23.3 0 45.1-11.2 58.6-30.2l6.3-8.8 32.4 34c6.1 6.4 16.2 6.6 22.6 .6s6.6-16.2 .6-22.6L327 318.5l38-53.2c5.1-7.2 3.5-17.2-3.7-22.3s-17.2-3.5-22.3 3.7l-34.5 48.2-45.4-47.7 17.5-12.1zm-87.1 59.9l42.9-29.5 53.2 55.8-9.8 13.8c-7.5 10.5-19.6 16.8-32.5 16.8h-36C190 352 176 338 176 320.8c0-10.3 5.1-19.9 13.5-25.7z"]
};
var faSnowflakes = {
  prefix: 'fal',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M507.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L513.4 56 484.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L536 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L558.6 56l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L536 33.4 507.3 4.7zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L171.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 134.6v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3S72 100.2 74.3 108.7l13.4 50.1L24.1 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L21.6 200C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4L8.1 362.1C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7L74.3 403.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L208 283.7v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 422.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V422.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4V283.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7L426.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L240 228.3V134.6l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4V16zM532.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L561.4 264l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L584 286.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L606.6 264l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L584 241.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faHandsClapping = {
  prefix: 'fal',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM215.1 18.7c-7.4 4.9-9.3 14.8-4.4 22.2l32 48c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-32-48c-4.9-7.4-14.8-9.3-22.2-4.4zm209.8 0c-7.4-4.9-17.3-2.9-22.2 4.4l-32 48c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l32-48c4.9-7.4 2.9-17.3-4.4-22.2zM153.9 152c4.8 0 9.3 1.9 12.7 5.3L292.7 283.3c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16V337.6C352 416.2 288.2 480 209.6 480c-37.8 0-74-15-100.7-41.7L75.3 404.7l-16-16 0 0-22-22c-3.4-3.4-5.3-7.9-5.3-12.7C32 344 40 336 49.9 336c4.8 0 9.3 1.9 12.7 5.2l0 0 38.1 38.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L85.3 318.6l0 0-48-48c-3.4-3.4-5.3-7.9-5.3-12.7C32 248 40 240 49.9 240c4.8 0 9.3 1.9 12.7 5.3l86.1 86.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L85.3 222.6l0 0-24-24c-3.4-3.4-5.3-7.9-5.3-12.7C56 176 64 168 73.9 168c4.8 0 9.3 1.9 12.7 5.3l32 32 0 0 78.1 78.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-78.1-78.1 0 0c-3.4-3.4-5.2-7.9-5.2-12.7c0-9.9 8-17.9 17.9-17.9zM31.1 211.7C12.9 219.1 0 237 0 257.9c0 13.2 5.3 25.9 14.6 35.3l15 15C12.2 316.1 0 333.6 0 353.9c0 13.2 5.3 25.9 14.6 35.3l22 22 0 0 16 16 0 0 33.6 33.6C119 493.6 163.4 512 209.6 512C305.9 512 384 433.9 384 337.6V208c0-26.5-21.5-48-48-48s-48 21.5-48 48v25.4l-98.7-98.7c-9.4-9.4-22.1-14.6-35.3-14.6c-20.4 0-37.9 12.2-45.7 29.7C99 140.9 86.7 136 73.9 136C46.4 136 24 158.4 24 185.9c0 9.1 2.5 18 7.1 25.7zM360.8 478.1c-11.7 12.6-25 23.7-39.5 33.1c5.4 .5 10.9 .8 16.4 .8C433.9 512 512 433.9 512 337.6V208c0-26.5-21.5-48-48-48s-48 21.5-48 48v25.4 45.3l4.7 4.7c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16V337.6c0 70.7-51.6 129.4-119.2 140.5z"]
};
var faRepublican = {
  prefix: 'fal',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M0 176C0 96.5 64.5 32 144 32H368c79.5 0 144 64.5 144 144v96 64 32c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 61.9-50.1 112-112 112c-32.2 0-61.2-13.6-81.7-35.4C440.8 465 422.1 480 400 480H336c-26.5 0-48-21.5-48-48V384H160v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272 176zM480 288H32V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V368c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 44.2 35.8 80 80 80s80-35.8 80-80V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V336 288zm0-32V176c0-61.9-50.1-112-112-112H144C82.1 64 32 114.1 32 176v80H480zM160 144v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16zm128 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faLeafMaple = {
  prefix: 'fal',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", "M336.9 7.4C334 2.9 329.1 .1 323.7 0s-10.4 2.4-13.5 6.8L248.6 94.5 248 60.6c-.1-4.9-2.4-9.5-6.3-12.4s-8.9-4-13.7-2.8L179.3 57.9 140.9 13.1c-2.9-3.4-7.1-5.4-11.5-5.6s-8.8 1.5-11.9 4.6L70.1 59 18 52.5c-5.3-.7-10.5 1.3-14 5.3S-.8 67.3 .5 72.4L42.9 234.8 5.7 266.2c-4.1 3.4-6.2 8.7-5.6 14s3.8 10 8.5 12.4L132 357.4 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L154.6 380l64.7 123.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 14-5.6l31.4-37.2 162.4 42.4c5.1 1.3 10.6 0 14.6-3.5s6-8.7 5.3-14l-5.6-44.4c-.6-4.9 1.1-9.8 4.5-13.2l41.4-41.9c3.1-3.2 4.8-7.5 4.6-11.9s-2.2-8.6-5.6-11.5l-44.8-38.4L466.6 284c1.2-4.7 .2-9.8-2.8-13.7s-7.5-6.2-12.4-6.3l-33.9-.6 87.7-61.6c4.7-3.3 7.3-8.9 6.7-14.7s-4.2-10.7-9.5-13.1l-41.1-18.1c-7.6-3.3-11.3-11.9-8.7-19.7L481.2 51c1.9-5.6 .5-11.9-3.6-16.2s-10.3-6-16-4.3L379.9 53.9c-6.8 1.9-14.1-.8-17.9-6.8L336.9 7.4zM178.3 356.3L316.2 218.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L155.7 333.7 44.5 275.3l19-16.1c9.4-8 13.4-20.6 10.3-32.5L37.4 87.2l36.4 4.6c4.9 .6 9.8-1.1 13.2-4.5L127.8 47l33.7 39.3c4 4.6 10.2 6.6 16.1 5.1l38.7-9.9 1.2 62.6c.1 6.9 4.7 13 11.3 15s13.8-.4 17.8-6.1l76-108.1L335 64.2c11.4 18 33.3 26.3 53.7 20.5l52.5-15-18.9 56.2c-7.9 23.5 3.4 49.2 26.1 59.2l15.2 6.7L359.1 265.4c-5.7 4-8.1 11.2-6.1 17.8s8.1 11.2 15 11.3l62.6 1.2-9.9 38.7c-1.5 5.9 .5 12.2 5.1 16.1L465 384.2l-29.3 29.6c-10.4 10.5-15.4 25.1-13.5 39.7l2.6 21L285.3 438.2c-11.9-3.1-24.6 .9-32.5 10.3l-16.1 19L178.3 356.3z"]
};
var faArrowLeft = {
  prefix: 'fal',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z"]
};
var faPersonCircleXmark = {
  prefix: 'fal',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z"]
};
var faRuler = {
  prefix: 'fal',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", "M51.9 390.6c-12.5-12.5-12.5-32.8 0-45.3l39.4-39.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L305.9 91.3l39.4-39.4c12.5-12.5 32.8-12.5 45.3 0l69.5 69.5c12.5 12.5 12.5 32.8 0 45.3L166.6 460.1c-12.5 12.5-32.8 12.5-45.3 0L51.9 390.6zm46.9 92.1c25 25 65.5 25 90.5 0L482.7 189.3c25-25 25-65.5 0-90.5L413.3 29.3c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z"]
};
var faCupStrawSwoosh = {
  prefix: 'fal',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M202.4 36.4C207.8 15 227 0 249 0h23c8.8 0 16 7.2 16 16s-7.2 16-16 16H249c-7.3 0-13.7 5-15.5 12.1l-21 83.9H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.4c-.2 0-.5 0-.7 0H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H179.5l22.9-91.6zM60.3 468l-23-276H69.4L83.9 365.1c29-3.7 48.3-10.6 62.3-18.6c17.1-9.8 27.6-22 39.1-36.1l2-2.5c10.8-13.4 23.2-28.6 42.5-41c19.3-12.3 44.4-21.2 80.6-24.9l4.2-50h32.1l-23 276c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44zM307.7 274.5c-29 3.6-47.5 10.9-60.7 19.4c-14.8 9.5-24.2 21.1-35.5 35l-1.4 1.7c-11.8 14.5-25.4 30.7-48 43.7C143.4 385 119.4 392.9 86.5 397l5.7 68.3c.7 8.3 7.6 14.7 15.9 14.7H275.8c8.3 0 15.3-6.4 15.9-14.7l15.9-190.9z"]
};
var faTemperatureSun = {
  prefix: 'fal',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", "M336 101.1l-18.1-3L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l69 48.3c-3.2-13.7-4.9-27.9-5-42.6l-54.8-38.4c-5.5-3.9-12.8-3.9-18.4 0l-59.2 41.4-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l34.6 5.8V101.1zM208 264a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-88-56a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zM400 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM464 0c-53 0-96 43-96 96V252.7c0 4.6-2.2 9.8-6.8 14.5C335.7 293.1 320 328.8 320 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM432 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTemperatureHot = faTemperatureSun;
var faAlignLeft = {
  prefix: 'fal',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faDiceD6 = {
  prefix: 'fal',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M220.1 35.6L47.9 136.2l176 101.2L400 133l-172-97.5 11.6-20.4L228.1 35.5c-2.5-1.4-5.5-1.4-8 .1zM32 164V366.6c0 2.9 1.6 5.6 4.1 7L208 469.9V265.3L32 164zM240 469.9l171.9-96.3c2.5-1.4 4.1-4.1 4.1-7V160.8L240 265.1V469.9zM203.9 7.9c12.3-7.2 27.5-7.3 39.9-.3L427.7 112c12.5 7.1 20.3 20.4 20.3 34.8V366.6c0 14.5-7.8 27.8-20.5 34.9l-184 103c-12.1 6.8-26.9 6.8-39.1 0l-184-103C7.8 394.4 0 381.1 0 366.6V150.1c0-14.2 7.5-27.4 19.8-34.5L203.9 7.9z"]
};
var faRestroom = {
  prefix: 'fal',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM112 164V320h64V164c-6-2.6-12.5-4-19.3-4H131.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L30.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L60.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L208 202.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H112zM496 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 496 0zM455.2 241.7c7.9 4 11.1 13.6 7.2 21.5L409.9 368H448h96 38.1L529.7 263.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H560v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H464v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H384c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM435 196.6l-52.9 98.9c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9C424.3 148.6 458.7 128 496 128s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L557 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6zM336 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHighDefinition = {
  prefix: 'fal',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM320 176V336c0 8.8 7.2 16 16 16h48c53 0 96-43 96-96s-43-96-96-96H336c-8.8 0-16 7.2-16 16zm64 16c35.3 0 64 28.7 64 64s-28.7 64-64 64H352V192h32zM144 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V256 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H144V176z"]
};
var faRectangleHd = faHighDefinition;
var faJ = {
  prefix: 'fal',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M304 32c8.8 0 16 7.2 16 16V320c0 88.4-71.6 160-160 160S0 408.4 0 320V272c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 70.7 57.3 128 128 128s128-57.3 128-128V48c0-8.8 7.2-16 16-16z"]
};
var faGalaxy = {
  prefix: 'fal',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M144 184c0-83.9 68.1-152 152-152h12.8C272 59.2 246.6 98.6 236.7 142.5c-1.4 6 .9 12.3 5.8 16.1s11.5 4.5 17.1 1.7C280.1 149.9 303.3 144 328 144c83.9 0 152 68.1 152 152v12.8c-27.2-36.9-66.6-62.2-110.5-72.1c-6-1.4-12.3 .9-16.2 5.8s-4.5 11.5-1.7 17.1C362.1 280.1 368 303.3 368 328c0 83.9-68.1 152-152 152H203.2c36.9-27.2 62.2-66.6 72.1-110.5c1.4-6-.9-12.3-5.8-16.2s-11.5-4.5-17.1-1.7C231.9 362.1 208.7 368 184 368c-83.9 0-152-68.1-152-152V203.2c27.2 36.9 66.6 62.2 110.5 72.1c6 1.4 12.3-.9 16.1-5.8s4.5-11.5 1.7-17.1C149.9 231.9 144 208.7 144 184zM296 0C194.4 0 112 82.4 112 184c0 17.2 2.4 33.9 6.8 49.7C94.5 222.6 73.1 205.4 57 183.2L48.1 171c-5-6.9-13-11-21.5-11C11.9 160 0 171.9 0 186.6V216C0 317.6 82.4 400 184 400c17.2 0 33.9-2.4 49.7-6.8c-11.1 24.3-28.4 45.7-50.6 61.8l9.4 12.9L183.2 455 171 463.9c-6.9 5-11 13-11 21.5c0 14.7 11.9 26.6 26.6 26.6H216c101.6 0 184-82.4 184-184c0-17.2-2.4-33.9-6.8-49.7c24.3 11.1 45.7 28.4 61.8 50.6l8.9 12.2c5 6.9 13 11 21.5 11c14.7 0 26.6-11.9 26.6-26.6V296c0-101.6-82.4-184-184-184c-17.2 0-33.9 2.4-49.7 6.8c11.1-24.3 28.4-45.7 50.6-61.8L341 48.1c6.9-5 11-13 11-21.5C352 11.9 340.1 0 325.4 0H296zM256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faUsersViewfinder = {
  prefix: 'fal',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", "M32 32h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H24C10.7 0 0 10.7 0 24V128c0 8.8 7.2 16 16 16s16-7.2 16-16V32zm576 0v96c0 8.8 7.2 16 16 16s16-7.2 16-16V24c0-13.3-10.7-24-24-24H512c-8.8 0-16 7.2-16 16s7.2 16 16 16h96zM128 480H32V384c0-8.8-7.2-16-16-16s-16 7.2-16 16V488c0 13.3 10.7 24 24 24H128c8.8 0 16-7.2 16-16s-7.2-16-16-16zm480 0H512c-8.8 0-16 7.2-16 16s7.2 16 16 16H616c13.3 0 24-10.7 24-24V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM360 320c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H320 280zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zM464.2 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM488 288c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"]
};
var faFileVideo = {
  prefix: 'fal',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 288v24 48 24H96V288H208zm32 96v-.4l58.1 23.2c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V280c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L240 288.4V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H208c17.7 0 32-14.3 32-32zm48-15.6l-48-19.2V322.8l48-19.2v64.7z"]
};
var faCherries = {
  prefix: 'fal',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", "M288 16l8.2-13.7c-4.7-2.8-10.5-3-15.4-.6s-8.2 7.3-8.7 12.7l0 0 0 0 0 .1 0 .3-.1 1.2c-.1 1.1-.3 2.8-.6 5c-.6 4.4-1.5 10.8-2.8 18.7c-2.7 16-7.1 38.2-13.9 63c-13.8 50.2-37 109.3-74.4 150.5c-.2 .2-.3 .3-.4 .5C163.8 241.9 133.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-32 192-176c0-112-96-112-96-112c-21.3 0-40.2 5.8-55.6 12.9c25.7-40.5 42.3-86.8 53-125.7C292.6 85.1 297.2 61.8 300 45l.2-1.2c1 .7 2 1.5 3.1 2.3c14.5 11 33.7 27.1 53 47.8c36.2 39 71 92.5 75.3 156.9c-13.2-9.1-33.5-20.4-58.3-24.9c12.6 11.5 23.6 26.5 31.3 45.5c4.6 2.7 8.7 5.5 12.1 8c18.4 13.7 44.3 13.7 62.7 0c13.5-10 37-23.4 64.4-23.5l.1 0c.3 0 .8 0 1.6 .1c1.6 .1 4.2 .4 7.4 1.1c6.5 1.3 14.9 3.8 23 8.5C590 273.9 608 291.3 608 336c0 68-29.4 101.7-61.9 120.2c-35 20-76.5 23.8-98.1 23.8c-14.6 0-42.6-4-71.1-15.9c-7 9.2-14.8 17.4-23 24.8C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-35 0-63.7 15.6-80.3 27.3c-4.1-75.9-44.8-137.1-83.9-179.2c-20.8-22.3-41.5-39.7-57-51.5c-7.8-5.9-14.3-10.4-18.9-13.5c-2.3-1.5-4.1-2.7-5.4-3.5c-.6-.4-1.1-.7-1.5-.9l-.4-.3-.1-.1 0 0 0 0s0 0-8.2 13.7zm-.3 243.2l0 0c.2 0 .7 0 1.5 .1c1.5 .1 4 .4 7.1 1c6.3 1.2 14.3 3.6 22 8.1c13.1 7.6 30.5 24 30.5 67.6c0 57.7-27.7 91.3-61.3 112.1c-35.5 22-76.8 28.7-95.5 28.7s-60-6.8-95.5-28.7C62.9 427.3 35.2 393.7 35.2 336c0-43.6 17.5-60 30.5-67.6c7.7-4.5 15.7-6.9 22-8.1c3.1-.6 5.5-.9 7.1-1c.8-.1 1.3-.1 1.5-.1l0 0c19.6 .1 37.2 7.1 50.9 15.1c6.7 3.9 12 7.9 15.6 10.8c1.8 1.4 3 2.5 3.8 3.2c.4 .3 .6 .6 .7 .7l0 0 0 0 0 0c13.7 13.5 35.8 13.5 49.5 0l0 0 0 0c.1-.1 .3-.3 .7-.7c.8-.7 2-1.8 3.8-3.2c3.5-2.9 8.8-6.8 15.6-10.8c13.6-8 31.3-15.1 50.9-15.1z"]
};
var faUpRightFromSquare = {
  prefix: 'fal',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M320 33c0-18.2 14.8-33 33-33H480c17.7 0 32 14.3 32 32V159c0 18.2-14.8 33-33 33c-8.7 0-17.1-3.5-23.3-9.7L404 130.6 235.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L381.4 108 329.7 56.3C323.5 50.1 320 41.7 320 33zm33-1c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L478.3 159.7c.2 .2 .4 .3 .7 .3c.5 0 1-.4 1-1V32H353zM0 96C0 60.7 28.7 32 64 32H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64C46.3 64 32 78.3 32 96V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V304c0-8.8 7.2-16 16-16s16 7.2 16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faCircleSort = {
  prefix: 'fal',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM244.7 100.7c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192l114.7 0L256 134.6 198.6 192zM148.7 315.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96zM256 377.4L313.4 320l-114.7 0L256 377.4z"]
};
var faSortCircle = faCircleSort;
var faTableCells = {
  prefix: 'fal',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", "M352 64v96H480V96c0-17.7-14.3-32-32-32H352zm-32 0H192v96H320V64zM160 64H64C46.3 64 32 78.3 32 96v64H160V64zM32 192V320H160V192H32zm0 160v64c0 17.7 14.3 32 32 32h96V352H32zm160 96H320V352H192v96zm160 0h96c17.7 0 32-14.3 32-32V352H352v96zM480 320V192H352V320H480zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM192 320H320V192H192V320z"]
};
var faTh = faTableCells;
var faFilePdf = {
  prefix: 'fal',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
};
var faSiren = {
  prefix: 'fal',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M363.8 320H396L375 152.1C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1L52 320H84.2l20.5-164c2-16 15.6-28 31.8-28h175c16.1 0 29.8 12 31.8 28l20.5 164zm-185.6 0l13.8-110c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L145.9 320h32.2zM48 384H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16zM0 400v32c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"]
};
var faArrowUpToDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", "M363.3 292.7l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 214.6V320 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320 214.6L340.7 315.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm384 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM152 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM344 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faImageLandscape = {
  prefix: 'fal',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M512 96c17.7 0 32 14.3 32 32V384c0 6.1-1.7 11.8-4.6 16.6L377 197.6c-12.8-16-37.2-16-50 0L244.4 300.9l-27.3-37.5c-12.3-17-37.4-17.7-50.6-1.4L45.3 410C37.3 404.2 32 394.7 32 384V128c0-17.7 14.3-32 32-32H512zm-1.3 320H193.3l63-78.8L352 217.6 510.7 416zM160.1 448H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64h95.9c.1 0 .2 0 .3 0zm-7.8-32H81.8L191.3 282.2l32.4 44.6L152.3 416zM144 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faLandscape = faImageLandscape;
var faTankWater = {
  prefix: 'fal',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M269.6 64H384c17.7 0 32 14.3 32 32V352c-20.9 0-41.7-10-58.2-21.2c-7.3-5-13.7-10.3-19.8-15.9c-10.2-9.5-25.9-9.5-36.1 0c-6.1 5.6-12.5 11-19.8 15.9C265.6 342.1 244.9 352 224 352s-41.7-9.9-58.2-21.2c-7.3-5-13.7-10.3-19.8-15.9c-10.2-9.5-25.9-9.5-36.1 0c-6.1 5.6-12.5 11-19.8 15.9C73.6 342.1 52.9 352 32 352V96c0-17.7 14.3-32 32-32H178.4l6.1-10 13.6-22H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H249.9l13.6 22 6.1 10zM32 384c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C166.4 369.9 193.7 384 224 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C358.5 369.9 385.7 384 416 384v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384zM236.4 70.7C233.7 66.5 229 64 224 64s-9.7 2.5-12.4 6.7l-47.2 70.8c-8.1 12.1-12.4 26.3-12.4 40.9V184c0 39.8 32.2 72 72 72s72-32.2 72-72v-1.7c0-14.5-4.3-28.8-12.4-40.9L236.4 70.7zm-12.4 39l33 49.5c4.6 6.8 7 14.9 7 23.1V184c0 22.1-17.9 40-40 40s-40-17.9-40-40v-1.7c0-8.2 2.4-16.3 7-23.1l33-49.5z"]
};
var faCurlingStone = {
  prefix: 'fal',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", "M192 112c0-26.5 21.5-48 48-48H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-44.2 0-80 35.8-80 80v48c-35.3 0-64 28.7-64 64v1.1C41.7 232.9 0 279.6 0 336v32c0 61.9 50.1 112 112 112H464c61.9 0 112-50.1 112-112V336c0-56.4-41.7-103.1-96-110.9V224c0-35.3-28.7-64-64-64H192V112zM448 224H128c0-17.7 14.3-32 32-32h16H416c17.7 0 32 14.3 32 32zM112 448c-44.2 0-80-35.8-80-80H544c0 44.2-35.8 80-80 80H112zM32 336c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80H32z"]
};
var faCurling = faCurlingStone;
var faGamepadModern = {
  prefix: 'fal',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 352H424c14.7 0 27.5 10 31 24.2l3.6 14.3c8.4 33.8 38.8 57.4 73.6 57.4c41.9 0 75.8-33.9 75.8-75.8v-2.8c0-4.5-.4-8.9-1.1-13.3L574.1 165.3c-7-40.7-32.2-71.3-66.5-79.9C464.1 74.5 401.1 64 320 64s-144.1 10.5-187.6 21.4C98 93.9 72.8 124.5 65.9 165.3L33.1 356.1c-.8 4.4-1.1 8.8-1.1 13.3v2.8c0 41.9 33.9 75.8 75.8 75.8c34.8 0 65.1-23.7 73.6-57.4l3.6-14.3c3.6-14.2 16.4-24.2 31-24.2zm211.6 46.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM208 160v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGamepadAlt = faGamepadModern;
var faMessagesQuestion = {
  prefix: 'fal',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", "M202.7 288H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V256c0 17.7 14.3 32 32 32H96c17.7 0 32 14.3 32 32v16l55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V352 320H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64zM320 448c-35.3 0-64-28.7-64-64V352h32v32c0 17.7 14.3 32 32 32H437.3c6.9 0 13.7 2.2 19.2 6.4L512 464V448c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H448V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v32 16c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320zM184.3 70.3c-16.4 0-31 10.3-36.4 25.7l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3L247.4 152c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7H184.3zM208 250.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3z"]
};
var faBookBible = {
  prefix: 'fal',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM224 72h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H288v80c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V232H160c-17.7 0-32-14.3-32-32V168c0-17.7 14.3-32 32-32h32V104c0-17.7 14.3-32 32-32zm0 32v48c0 8.8-7.2 16-16 16H160v32h48c8.8 0 16 7.2 16 16v96h32V216c0-8.8 7.2-16 16-16h48V168H272c-8.8 0-16-7.2-16-16V104H224z"]
};
var faBible = faBookBible;
var faO = {
  prefix: 'fal',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 64a192 192 0 1 0 0 384 192 192 0 1 0 0-384zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"]
};
var faSuitcaseMedical = {
  prefix: 'fal',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M176 32H336c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm256 80V448H128V128h16H368h16zM96 128V448H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H96zM416 448V128h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H416zM240 176c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H304V208c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V320c0-8.8-7.2-16-16-16H176V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faMedkit = faSuitcaseMedical;
var faBriefcaseArrowRight = {
  prefix: 'fal',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M176 32H336c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H368h80c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h80zm155.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L329.4 272H144c-8.8 0-16 7.2-16 16s7.2 16 16 16H329.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faExpandWide = {
  prefix: 'fal',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M144 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H32V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16H144zM0 304c0-8.8 7.2-16 16-16s16 7.2 16 16V416H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V304zM496 64c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496zM480 304c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H480V304z"]
};
var faClockElevenThirty = {
  prefix: 'fal',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V260.8l-61.3-92c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4l64 96c1.8 2.6 2.7 5.7 2.7 8.9V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faRv = {
  prefix: 'fal',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H496c61.9 0 112 50.1 112 112v8c0 22.1-17.9 40-40 40H549.6L628 254.7c7.6 6.1 12 15.3 12 25V384c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H400 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2L18.7 329.4C6.7 317.4 0 301.1 0 284.1V96C0 60.7 28.7 32 64 32H224V24zM64 64C46.3 64 32 78.3 32 96V284.1c0 8.5 3.4 16.6 9.4 22.6l73.6 73.6C129.6 363 151.5 352 176 352c26.2 0 49.4 12.6 64 32H384V176c0-8.8 7.2-16 16-16H568c4.4 0 8-3.6 8-8v-8c0-44.2-35.8-80-80-80H384 352V32H256V64H224 64zM176 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-64 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h48V288H416v96h16zM416 192v64H578.4l-80-64H416zM128 224H288V160H128v64zM96 152c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V152z"]
};
var faUserSecret = {
  prefix: 'fal',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M169.1 37.7c-5.8 6.6-12 17.3-18.1 31.9c-6.1 14.5-11.3 31-15.5 47.2c24.4 6.4 54 11.2 88.6 11.2c33.4 0 63.3-5.2 88.3-12.1c-4.2-15.9-9.3-32-15.3-46.3c-6.1-14.6-12.4-25.3-18.1-31.9c-4-4.6-6.3-5.6-7-5.7c-4.8 0-7.3 .6-8.5 1c-1 .3-1.9 .8-3.6 1.8c-.1 .1-.4 .3-.7 .5C255.7 37.9 242.2 48 224 48s-31.7-10.1-35.1-12.7l0 0c-.3-.3-.6-.4-.7-.5c-1.6-1.1-2.5-1.5-3.6-1.8c-1.1-.4-3.6-1-8.5-1c-.6 .2-3 1.2-7 5.7zM272 0c34.2 0 57 54.9 70.8 106c.8-.3 1.6-.6 2.4-.9c14.8-5.7 26.5-11.4 34.3-15.7c3.9-2.1 6.9-3.9 8.9-5c1-.6 1.7-1 2.2-1.3l.5-.3 .1 0 0 0 0 0c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2L400 96c8.9 13.3 8.9 13.3 8.9 13.3l0 0 0 0-.1 0-.2 .1-.8 .5c-.7 .4-1.6 1-2.8 1.7c-2.4 1.4-5.8 3.5-10.3 5.8c-8.9 4.8-21.7 11.1-37.9 17.3C324.4 147.4 278.4 160 224 160c-58.3 0-104.3-12.5-135.9-25.1c-15.8-6.3-28-12.7-36.3-17.5c-4.2-2.4-7.4-4.5-9.6-6c-1.1-.7-2-1.3-2.6-1.8l-.7-.5-.2-.2-.1-.1 0 0 0 0s0 0 9.6-12.8l-9.6 12.8c-7.1-5.3-8.5-15.3-3.2-22.4c5.3-7.1 15.3-8.5 22.4-3.2l.1 0 .4 .3c.4 .3 1 .7 1.8 1.3c1.7 1.1 4.4 2.8 7.9 4.9c7.2 4.2 18 9.8 32.2 15.5c1.6 .6 3.3 1.3 5 1.9C118.7 55.7 141.5 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0zm-.3 32a.1 .1 0 1 0 .1 .1 .1 .1 0 1 0 -.1-.1zm-95.6 0a.1 .1 0 1 0 .3 .1 .1 .1 0 1 0 -.3-.1zM100 224c-2.6-10.2-4-21-4-32c0-6.7 .5-13.3 1.5-19.7c9.6 3.1 19.9 6.1 31.1 8.8c-.4 3.6-.6 7.2-.6 10.9c0 53 43 96 96 96s96-43 96-96c0-4-.2-7.9-.7-11.7c11.1-2.8 21.5-5.8 31-9c1.1 6.8 1.7 13.7 1.7 20.8c0 11-1.4 21.8-4 32h71.2c7.1 0 12.8 5.7 12.8 12.8c0 2.1-.5 4.1-1.5 6l-45.7 86.8C423.6 364.8 448 415.5 448 472v8c0 17.7-14.3 32-32 32H272.4c-.2 0-.5 0-.7 0H176.4c-.2 0-.5 0-.7 0H32c-17.7 0-32-14.3-32-32v-8c0-56.5 24.4-107.2 63.2-142.4L17.5 242.8c-1-1.8-1.5-3.9-1.5-6c0-7.1 5.7-12.8 12.8-12.8H100zm234.8 32c-22.1 38.3-63.5 64-110.9 64s-88.7-25.7-110.9-64H60.6l30.9 58.7c6.8 12.9 4 28.8-6.8 38.6C52.3 382.7 32 424.9 32 472l0 8H154.8l-26.2-91.6c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l20.3 70.9L201.8 384H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h32 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-9.8l22.2 66.5 20.3-70.9c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8L293.2 480H416v-8c0-47.1-20.3-89.3-52.7-118.6c-10.8-9.8-13.6-25.7-6.8-38.6L387.4 256H334.9zM203.5 480h40.9L224 418.6 203.5 480zM144 184.4c10.1 2 20.8 3.6 32 4.9V198c0 7 5.7 12.7 12.7 12.7c5.5 0 10.3-3.5 12-8.7l3.5-10.5c6.5 .3 13.1 .5 19.8 .5c6.7 0 13.3-.2 19.8-.5l3.5 10.5c1.7 5.2 6.6 8.7 12 8.7c7 0 12.7-5.7 12.7-12.7v-9c11.2-1.4 21.8-3.2 32-5.3V198c0 24.7-20 44.7-44.7 44.7c-14.1 0-27-6.6-35.3-17.3c-8.3 10.7-21.2 17.3-35.3 17.3c-24.7 0-44.7-20-44.7-44.7V184.4z"]
};
var faOtter = {
  prefix: 'fal',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M145.7 211.4l-12.9 6.4c-8.1 4.1-17.1 6.2-26.2 6.2C74.2 224 48 197.8 48 165.4V144c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v21.4c0 32.4-26.2 58.6-58.6 58.6c-9.1 0-18.1-2.1-26.2-6.2l-12.9-6.4c-9-4.5-19.6-4.5-28.6 0zM16 144v21.4c0 19.1 5.9 36.8 16 51.4V240v16.6C32 380 132 480 255.4 480H414.9C539.2 480 640 379.2 640 254.9c0-90.7-64-168.8-153-186.6l-19.9-4c-8.3-1.7-16.4 3.4-18.6 11.6s2.4 16.6 10.4 19.3l21.6 7.2c37.9 12.6 63.4 48.1 63.4 88c0 16.4-6 31.4-16 42.9V192c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v0H359.9l.1 0h8c26.5 0 48-21.5 48-48s-21.5-48-48-48h-8c-20.9 0-40.4 6.2-56.7 16.8c.5-3.7 .7-7.6 .7-11.4V144c0-5.4-.4-10.8-1.1-16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H293.2c-18-37.8-56.5-64-101.2-64H128C83.3 32 44.8 58.2 26.8 96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h1.1c-.7 5.2-1.1 10.6-1.1 16zm96 144c-24.6 0-44.9-18.6-47.7-42.5c12.6 6.7 27 10.5 42.3 10.5c14.1 0 27.9-3.3 40.5-9.6L160 240l12.9 6.4c12.6 6.3 26.5 9.6 40.5 9.6c16.7 0 32.3-4.5 45.7-12.3c8.3 25.7 32.4 44.3 60.9 44.3h56.4c-15.2 17-24.4 39.4-24.4 64H269.3c1.8-5 2.7-10.4 2.7-16c0-26.5-21.5-48-48-48H112zm207.8-32c-11.8-.1-22.2-6.6-27.6-16.2c9.9-27.9 36.6-47.8 67.8-47.8h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8c-19.4 0-35.5 13.7-39.2 32h-1zM528 333.7V274.5c28.7-17 48-48.3 48-84.1c0-13.3-2.1-26.3-6.1-38.5c23.9 27.9 38.1 64 38.1 103C608 361.5 521.5 448 414.9 448H255.4c-87.6 0-161.4-58.9-184.2-139.2C83.1 315.9 97.1 320 112 320H224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 16H368c8.8 0 16-7.2 16-16V352c0-35.3 28.5-63.9 63.7-64h.3v0c8.8 0 16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3v123c0 16.1-8 31-21.4 39.9l-19.5 13c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l19.5-13c22.3-14.8 35.6-39.8 35.6-66.6zM112 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-72-16c-13.3 0-24 10.7-24 24v8c0 6.1 3.4 11.6 8.8 14.3l16 8c4.5 2.3 9.8 2.3 14.3 0l16-8c5.4-2.7 8.8-8.3 8.8-14.3v-8c0-13.3-10.7-24-24-24H152z"]
};
var faDreidel = {
  prefix: 'fal',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", "M443.3 36.7c6.2 6.2 6.2 16.4 0 22.6L321.9 180.7l73.4 73.4c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l73.4 73.4L420.7 36.7c6.2-6.2 16.4-6.2 22.6 0zm-240 70.6c-6.2-6.2-16.4-6.2-22.6 0l-57.4 57.4 192 192 57.4-57.4c6.2-6.2 6.2-16.4 0-22.6L203.3 107.3zm89.4 272l-192-192L41.4 246.6c-6 6-9.4 14.1-9.4 22.6V416c0 17.7 14.3 32 32 32H210.7c8.5 0 16.6-3.4 22.6-9.4l59.3-59.3z"]
};
var faPersonDress = {
  prefix: 'fal',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM119.2 241.7c7.9 4 11.1 13.6 7.2 21.5L73.9 368H112h96 38.1L193.7 263.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H128v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H48c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM99 196.6L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9C88.3 148.6 122.7 128 160 128s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L221 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6z"]
};
var faFemale = faPersonDress;
var faCommentDollar = {
  prefix: 'fal',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V344c0 8.8 7.2 16 16 16s16-7.2 16-16V326.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V136z"]
};
var faBusinessTime = {
  prefix: 'fal',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64v32.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V160c0-17.7-14.3-32-32-32H368 144 64c-17.7 0-32 14.3-32 32v96H176h32H352h8.2c-8.1 9.8-15.2 20.6-21 32H208v48H322.9c-1.9 10.4-2.9 21.1-2.9 32H208c-17.7 0-32-14.3-32-32V288H32V416c0 17.7 14.3 32 32 32H339.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBriefcaseClock = faBusinessTime;
var faFlowerTulip = {
  prefix: 'fal',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", "M268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4L189.5 66.7 121.2 18.9c-4.9-3.4-11.3-3.8-16.6-1.1S96 26 96 32V160c0 70.7 57.3 128 128 128h16V396.6C200.8 331.5 129.5 288 48 288H28c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512h44 16 16 44c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28H464c-81.5 0-152.8 43.5-192 108.6V288h16c70.7 0 128-57.3 128-128V32c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L322.5 66.7 268 5.4zM256 256H224c-53 0-96-43-96-96V62.7l54.8 38.4c6.7 4.7 15.7 3.6 21.1-2.5l52-58.5 52 58.5c5.4 6.1 14.5 7.1 21.1 2.5L384 62.7V160c0 53-43 96-96 96H256zM196 480c-89.2 0-161.8-71.3-164-160H48c95.1 0 174.1 69.2 189.3 160H196zm120 0H274.7c15.2-90.8 94.2-160 189.3-160h16c-2.1 88.7-74.7 160-164 160z"]
};
var faPeoplePantsSimple = {
  prefix: 'fal',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44H105.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-6.2 172l-4.1 49.3C308.1 304 322.8 320 341.6 320h84.9c18.7 0 33.4-16 31.9-34.7L454.2 236c-2.1-24.9-22.9-44-47.8-44H361.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"]
};
var faCloudDrizzle = {
  prefix: 'fal',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM64 376c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16V376zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16V376zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16V376zM160 448c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448z"]
};
var faTableCellsLarge = {
  prefix: 'fal',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", "M272 64V240H480V96c0-17.7-14.3-32-32-32H272zm-32 0H64C46.3 64 32 78.3 32 96V240H240V64zM32 272V416c0 17.7 14.3 32 32 32H240V272H32zM272 448H448c17.7 0 32-14.3 32-32V272H272V448zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faThLarge = faTableCellsLarge;
var faBookTanakh = {
  prefix: 'fal',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M384 0c35.3 0 64 28.7 64 64l0 384 0 0c0 35.3-28.7 64-64 64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V413.3C13.4 406.7 0 388.9 0 368V48C0 21.5 21.5 0 48 0H384zM64 416v64H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32H48c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H384zM146.7 232l-13.9 24h27.7l-13.9-24zm-13.9-24l-27.7-48c-6.2-10.7 1.5-24 13.9-24h55.4l27.7-48c6.2-10.7 21.6-10.7 27.7 0l27.7 48H313c12.3 0 20 13.3 13.9 24l-27.7 48 27.7 48c6.2 10.7-1.5 24-13.9 24H257.6l-27.7 48c-6.2 10.7-21.6 10.7-27.7 0l-27.7-48H119c-12.3 0-20-13.3-13.9-24l27.7-48zm27.7 0l27.7 48h55.4l27.7-48-27.7-48H188.3l-27.7 48zm0-48H132.9l13.9 24 13.9-24zm41.6-24h27.7L216 112l-13.9 24zm69.3 24l13.9 24 13.9-24H271.4zm13.9 72l-13.9 24h27.7l-13.9-24zm-55.4 48H202.1L216 304l13.9-24z"]
};
var faTanakh = faBookTanakh;
var faSolarSystem = {
  prefix: 'fal',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M32 256c0 123.7 100.3 224 224 224c31.4 0 61.4-6.5 88.5-18.2c4.2 8.8 9.9 17.1 17.3 24.4c.7 .7 1.4 1.4 2.1 2C331.1 503.5 294.5 512 256 512C114.6 512 0 397.4 0 256c0-50.9 14.9-98.4 40.5-138.3C35.1 109.1 32 98.9 32 88c0-30.9 25.1-56 56-56c10.9 0 21.1 3.1 29.7 8.5c3.5 2.2 6.8 4.8 9.7 7.7l0 0 .2 .2L139 64.9c-2.8-6.1-6.6-11.7-11.3-16.4l0 0c4.9 4.9 8.6 10.5 11.3 16.4l0 0c3.2 7 5 14.8 5 23.1c0 30.9-25.1 56-56 56c-8.2 0-16-1.8-23.1-5C44 173.1 32 213.1 32 256zM394.3 471.5l0 0c-3.5-2.2-6.8-4.8-9.9-7.9l-.1-.1c-4.9-4.9-8.6-10.5-11.3-16.4l0 0c-3.2-7-5-14.9-5-23.1c0-30.9 25.1-56 56-56c8.2 0 16 1.8 23.1 5c20.9-34 32.9-74.1 32.9-117C480 132.3 379.7 32 256 32c-31.4 0-61.4 6.5-88.5 18.2c-4.2-8.8-10-17.1-17.3-24.4c-.7-.7-1.4-1.4-2.1-2C180.9 8.5 217.5 0 256 0C397.4 0 512 114.6 512 256c0 50.9-14.9 98.4-40.5 138.3c5.4 8.6 8.5 18.8 8.5 29.7c0 30.9-25.1 56-56 56c-10.9 0-21.1-3.1-29.7-8.5zM112 88A24 24 0 1 0 64 88a24 24 0 1 0 48 0zM365.5 189.7c-4.2 1.5-8.8 2.3-13.5 2.3c-22.1 0-40-17.9-40-40c0-3.6 .5-7.1 1.4-10.4C296.1 132.9 276.6 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-24.3-6.8-47-18.5-66.3zM389 167.1c17 25.4 27 56 27 88.9c0 88.4-71.6 160-160 160s-160-71.6-160-160s71.6-160 160-160c28.3 0 54.9 7.4 78 20.3c5.4-2.7 11.5-4.3 18-4.3c22.1 0 40 17.9 40 40c0 5.3-1 10.4-3 15.1zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM424 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSealQuestion = {
  prefix: 'fal',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M176 96c8.5 0 16.6-3.4 22.6-9.4l46.1-46.1c6.2-6.2 16.4-6.2 22.6 0l46.1 46.1c6 6 14.1 9.4 22.6 9.4h64c8.8 0 16 7.2 16 16v64c0 8.5 3.4 16.6 9.4 22.6L471 244.2c6.2 6.2 6.2 16.4 0 22.6l-45.6 45.6c-6 6-9.4 14.1-9.4 22.6V400c0 8.8-7.2 16-16 16H335.1c-8.5 0-16.6 3.4-22.6 9.4l-45.1 45.1c-6.2 6.2-16.4 6.2-22.6 0l-45.1-45.1c-6-6-14.1-9.4-22.6-9.4H112c-8.8 0-16-7.2-16-16V335.1c0-8.5-3.4-16.6-9.4-22.6L41 266.8 18.4 289.5 41 266.8c-6.2-6.2-6.2-16.4 0-22.6l45.6-45.6c6-6 9.4-14.1 9.4-22.6V112c0-8.8 7.2-16 16-16h64zM18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448H400c26.5 0 48-21.5 48-48V335.1l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176V112c0-26.5-21.5-48-48-48H336L289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64H112c-26.5 0-48 21.5-48 48v64L18.4 221.6zm150.3-51.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V288c0 8.8 7.2 16 16 16s16-7.2 16-16V268.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPhoneVolume = {
  prefix: 'fal',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", "M272 0C404.5 0 512 107.5 512 240c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-80c0-8.8 7.2-16 16-16c79.5 0 144 64.5 144 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112c-8.8 0-16-7.2-16-16zm73 174.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faVolumeControlPhone = faPhoneVolume;
var faDiscDrive = {
  prefix: 'fal',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M96 64H416c17.7 0 32 14.3 32 32V448H64V96c0-17.7 14.3-32 32-32zM480 448V96c0-35.3-28.7-64-64-64H96C60.7 32 32 60.7 32 96V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H480zM256 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHatCowboySide = {
  prefix: 'fal',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M416.6 64.2L195.1 107c-7.1 1.4-12.4 7.3-12.9 14.6l-5 70.6c36.3 1.7 71.2 15.2 99.4 38.4L307.5 256H462.7L428.2 72.1c-.9-4.7-5-8.1-9.8-8.1c-.6 0-1.3 .1-1.9 .2zM145 193.7l5.3-74.4c1.5-21.7 17.4-39.6 38.8-43.7L410.5 32.8c2.6-.5 5.3-.8 8-.8c20.2 0 37.5 14.4 41.2 34.2l25 133.5c3.4 1.6 7.2 3.4 11.4 5.5c15.5 7.7 36.2 19.1 57 33.7c20.7 14.5 42.2 32.6 58.5 53.9C628.1 314 640 339.4 640 368c0 44.2-35.8 80-80 80H512.3c-.2 0-.4 0-.6 0H496 464 60.8C27.2 448 0 420.8 0 387.2V361.1c0-85.2 63-155.7 145-167.4zM525.3 416H560c26.5 0 48-21.5 48-48c0-19.4-8.1-38-21.7-55.7c-13.7-17.7-32.2-33.7-51.5-47.1c-14.9-10.5-29.9-19.2-42.7-26L525.3 416zm-34.2-8.8L468.7 288H346.3L491.1 407.2zM32 361.1v26.1C32 403.1 44.9 416 60.8 416H451.4L256.2 255.3c-24.5-20.2-55.3-31.3-87.1-31.3C93.4 224 32 285.4 32 361.1z"]
};
var faTableRows = {
  prefix: 'fal',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", "M32 96c0-17.7 14.3-32 32-32l64 0 0 176 0 32 0 176-64 0c-17.7 0-32-14.3-32-32L32 96zM160 272l320 0 0 144c0 17.7-14.3 32-32 32l-288 0 0-176zm320-32l-320 0 0-176 288 0c17.7 0 32 14.3 32 32l0 144zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z"]
};
var faRows = faTableRows;
var faLocationExclamation = {
  prefix: 'fal',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 96c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM168 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMapMarkerExclamation = faLocationExclamation;
var faFaceFearful = {
  prefix: 'fal',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48H318.8c-5.5-27.4-29.6-48-58.6-48zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faClipboardUser = {
  prefix: 'fal',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM192 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64h64c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z"]
};
var faBusSchool = {
  prefix: 'fal',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", "M256 32c105.1 0 146.3 31.1 158.8 47c.4 .6 1.2 2.1 1.2 5.3V128H96V84.3c0-3.3 .8-4.5 1-4.8C110.9 63.2 158.3 32 256 32zM96 245.5V160H240v80H128c-11.2 0-22 1.9-32 5.5zM272 240V160H416v85.5c-10-3.5-20.8-5.5-32-5.5H272zm176 24.4V84.3c0-7.7-1.8-17.1-8.1-25.1C419.2 32.9 366.9 0 256 0C152.4 0 94.5 33 72.6 58.8C65.8 66.9 64 76.6 64 84.3V264.4C44.4 282 32 307.6 32 336v56c0 22.3 13.1 41.6 32 50.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V448H416v48c0 8.8 7.2 16 16 16s16-7.2 16-16V442.6c18.9-9 32-28.3 32-50.6V336c0-28.4-12.4-54-32-71.6zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 336c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64v56c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V336zM192 80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm480 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faFilmSlash = {
  prefix: 'fal',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480L448 438.6V448H192V352 256 240H160 96V176 160.7L64 135.4V416c0 35.3 28.7 64 64 64H500.4zM139.6 32L192 73.4V64H448v96 96 16h32 64v64 15.3l32 25.3V96c0-35.3-28.7-64-64-64H139.6zM160 448H128c-17.7 0-32-14.3-32-32V368h64v80zM96 272h64v64H96V272zm384-96h64v64H480V176zm0-32V64h32c17.7 0 32 14.3 32 32v48H480z"]
};
var faSquareArrowDownRight = {
  prefix: 'fal',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM168 352c-8.8 0-16-7.2-16-16s7.2-16 16-16h97.4L132.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 297.4V192c0-8.8 7.2-16 16-16s16 7.2 16 16V336c0 8.8-7.2 16-16 16H168z"]
};
var faBookSparkles = {
  prefix: 'fal',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H64zM265.9 170.9l-16.5 38.6-38.6 16.5c-19.4 8.3-19.4 35.8 0 44.1l38.6 16.5 16.5 38.6c8.3 19.4 35.8 19.4 44.1 0l16.5-38.6 38.6-16.5c19.4-8.3 19.4-35.8 0-44.1l-38.6-16.5-16.5-38.6c-8.3-19.4-35.8-19.4-44.1 0zM288 200.6l11.7 27.3c1.6 3.8 4.6 6.8 8.4 8.4L335.4 248l-27.3 11.7c-3.8 1.6-6.8 4.6-8.4 8.4L288 295.4l-11.7-27.3c-1.6-3.8-4.6-6.8-8.4-8.4L240.6 248l27.3-11.7c3.8-1.6 6.8-4.6 8.4-8.4L288 200.6zM153 121.8l7-14 7 14c1.5 3.1 4.1 5.6 7.2 7.2l14 7-14 7c-3.1 1.5-5.6 4.1-7.2 7.2l-7 14-7-14c-1.5-3.1-4.1-5.6-7.2-7.2l-14-7 14-7c3.1-1.5 5.6-4.1 7.2-7.2zm28.5-42.7c-8.8-17.7-34.1-17.7-42.9 0l-11.8 23.6-23.6 11.8c-17.7 8.8-17.7 34.1 0 42.9l23.6 11.8 11.8 23.6c8.8 17.7 34.1 17.7 42.9 0l11.8-23.6 23.6-11.8c17.7-8.8 17.7-34.1 0-42.9l-23.6-11.8L181.5 79.2z"]
};
var faBookSpells = faBookSparkles;
var faWashingMachine = {
  prefix: 'fal',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM325.7 351c-7 .7-14.3 1-21.7 1c-41.8 0-72.9-20.8-95.7-36l-2.1-1.4c-25-16.7-41.3-26.6-62.2-26.6c-9.8 0-20.6 1.6-31.4 4c-.4 3.9-.6 7.9-.6 12c0 61.9 50.1 112 112 112c45.1 0 84-26.6 101.7-65zm9.5-33.4c.5-4.4 .8-8.9 .8-13.5c0-61.9-50.1-112-112-112c-45.3 0-84.4 27-102 65.7c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304z"]
};
var faWasher = faWashingMachine;
var faChild = {
  prefix: 'fal',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM73.9 240.2c1.9-3.1 3.9-6 6.1-8.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h96V496c0 8.8 7.2 16 16 16s16-7.2 16-16V231.3c2.2 2.8 4.2 5.8 6.1 8.9l44.3 72.2c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-44.3-72.2C249.2 184 206.3 160 160 160s-89.2 24-113.4 63.5L2.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3l44.3-72.2zM208 352H112V204.1c14.5-7.8 31-12.1 48-12.1s33.5 4.3 48 12.1V352z"]
};
var faLiraSign = {
  prefix: 'fal',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M80 152c0-48.6 39.4-88 88-88h7.1c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2H168C101.7 32 48 85.7 48 152v72H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48v22.1c0 14-.8 28-2.4 41.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H40.5c-7.3 35.6-19.9 70.1-37.4 102.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H42.1c14.4-30.6 24.8-62.9 31-96H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H77.8c1.5-13.9 2.2-27.9 2.2-41.9V256H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80V152z"]
};
var faUserVisor = {
  prefix: 'fal',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M224 224c41.8 0 77.4-26.7 90.5-64H133.5c13.2 37.3 48.7 64 90.5 64zm0 32c-60.6 0-111.3-42.1-124.6-98.6C88 152.5 80 141.2 80 128V96c0-17.7 14.3-32 32-32h1.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64H336c17.7 0 32 14.3 32 32v32c0 13.2-8 24.5-19.4 29.4C335.3 213.9 284.6 256 224 256zM152.4 64H295.6C278 44.4 252.4 32 224 32s-54 12.4-71.6 32zm25.8 272c-80 0-145 64.3-146.3 144H416c-1.2-79.7-66.2-144-146.3-144H178.3zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM336 96H112v32H336V96zm-7.1 341.4c-9.5 0-22.5 11.4-31.7 19.5c-2.6 2.2-4.8 4.2-6.6 5.6c-2.8 2-6.8 .1-6.5-3.5c3.9-36.5 15.9-66.5 35.7-89.5c1.5-1.8 4.9-1.9 6.1 .1c18.9 24.6 29 55 30.1 90.2c0 3.9-4.9 5.7-7.3 2.5c-12.2-17.3-17.6-23-19.9-25z"]
};
var faFilePlusMinus = {
  prefix: 'fal',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V240zM128 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faChessClockFlip = {
  prefix: 'fal',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", "M400 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H480V64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H464 400zM96 80c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm480 80c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H576zM464 224a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM119.4 247.4A80 80 0 1 1 232.6 360.6 80 80 0 1 1 119.4 247.4zM255.2 383.2A112 112 0 1 0 96.8 224.8 112 112 0 1 0 255.2 383.2zM464 240c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-8.8-7.2-16-16-16zM221.3 281.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9z"]
};
var faChessClockAlt = faChessClockFlip;
var faSatellite = {
  prefix: 'fal',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", "M224 35.3l62.3 62.3L185.7 198.3 123.3 136 224 35.3zM309 75L241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l47.6 47.6c-45.3-3.8-92 10.2-128.7 42.3c-3.8 3.3-5.9 8-5.9 13v.5c0 4.9 1.9 9.6 5.4 13L116.7 372.7l-16 16c-6.3-3-13.3-4.7-20.7-4.7c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l16-16L242.6 498.6c3.5 3.5 8.1 5.4 13 5.4h.5c5 0 9.8-2.2 13-5.9c32.1-36.7 46.1-83.3 42.3-128.7L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68L463 177c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L417 49c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17L309 75zM414.3 225.7L476.7 288 376 388.7l-62.3-62.3L414.3 225.7zm26.1-71.3L292 302.8c-7.9-14.9-18.1-28.9-30.7-41.5l-10.6-10.6c-12.5-12.5-26.5-22.8-41.5-30.7L357.7 71.6c4.9-4.9 11.5-7.6 18.3-7.6s13.5 2.7 18.3 7.6l46.1 46.1c4.9 4.9 7.6 11.5 7.6 18.3s-2.7 13.5-7.6 18.3zM238.7 283.9c49 49 54.8 125.7 15.7 181.2L46.8 257.6c55.5-39.1 132.2-33.3 181.2 15.7l10.6 10.6zM80 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPlaneLock = {
  prefix: 'fal',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.1 .6 4.2 1 6.3 1.1V479.4L260.4 448.6c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l106.9 61.1c2.5-10.7 6.5-20.8 11.9-30.1L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm80 376V338.9l48 13.7V352c0-11 2.8-21.4 7.7-30.4l-67.3-19.2c-4.8-1.4-10-.4-14 2.6s-6.4 7.8-6.4 12.8V384c0 5 2.4 9.8 6.4 12.8L368 440V400l-32-24zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faSteeringWheel = {
  prefix: 'fal',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M240 384v95.4C134.4 472 49.1 391.4 34.3 288H140.4c2.2 4.2 5.1 8.1 8.6 11.6l73.1 73.1c5.2 5.2 11.4 9 17.9 11.3zm32 0c6.6-2.3 12.7-6.1 17.9-11.3L363 299.6c3.5-3.5 6.3-7.4 8.6-11.6H477.7C462.9 391.4 377.6 472 272 479.4V384zM376.1 256c-.8-4-2.2-8-4.1-11.8l-12.8-25.7C351 202.3 334.4 192 316.2 192H195.8c-18.2 0-34.8 10.3-42.9 26.5L140 244.2c-1.9 3.8-3.3 7.8-4.1 11.8H32C32 132.3 132.3 32 256 32s224 100.3 224 224H376.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM181.5 232.8c2.7-5.4 8.3-8.8 14.3-8.8H316.2c6.1 0 11.6 3.4 14.3 8.8l12.8 25.7c3.1 6.2 1.9 13.6-3 18.5l-73.1 73.1c-6.2 6.2-16.4 6.2-22.6 0L171.6 277c-4.9-4.9-6.1-12.3-3-18.5l12.8-25.7z"]
};
var faTag = {
  prefix: 'fal',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", "M32 229.5V80c0-8.8 7.2-16 16-16H197.5c8.5 0 16.6 3.4 22.6 9.4l176 176c12.5 12.5 12.5 32.8 0 45.3L262.6 428.1c-12.5 12.5-32.8 12.5-45.3 0l-176-176L18.7 274.7l22.6-22.6c-6-6-9.4-14.1-9.4-22.6zm-32 0c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80V229.5zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faStretcher = {
  prefix: 'fal',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M27.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L145.9 232.6c15 15 35.4 23.4 56.6 23.4H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H528.2h-.4H208.2h-.4-5.3c-12.7 0-24.9-5.1-33.9-14.1L27.3 68.7zM224 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-8.8-1.8-17.3-5-24.9l53-40.6 53 40.6c-3.2 7.7-5 16.1-5 24.9c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.9 0-28.6 5.1-39.5 13.6l-46.2-35.3L491.6 288H438.9L368 342.2 297.1 288H244.4l97.2 74.4-46.2 35.3C284.6 389.1 270.9 384 256 384c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBookSection = {
  prefix: 'fal',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM224.7 254.1c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9c7.9 2.5 12.3 10.9 9.9 18.8c-2.5 7.9-11 12.3-18.8 9.9c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8c2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26l-7-1.8zM222 185.9c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26c0 0-8.8-2.3-9.7-2.6z"]
};
var faBookLaw = faBookSection;
var faInboxes = {
  prefix: 'fal',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M34.7 192l-1.4 3.4c-.8 2-1.2 4-1.2 6.2V272c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V201.6c0-2.1-.4-4.2-1.2-6.2l-1.4-3.4H403.8c-6.1 0-11.6 3.4-14.3 8.8l-14.3 28.6C367 245.7 350.4 256 332.2 256H179.8c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8H34.7zM48 160h60.2c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8H332.2c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464L414.8 41.8l29-12.1-29 12.1c-2.5-6-8.3-9.8-14.8-9.8H112c-6.5 0-12.3 3.9-14.8 9.8L48 160zM3.7 183.1l64-153.6C75.1 11.7 92.6 0 112 0H400c19.4 0 36.9 11.7 44.3 29.5l64 153.6c2.4 5.8 3.7 12.1 3.7 18.5V272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V201.6c0-6.3 1.3-12.6 3.7-18.5zM114.3 384H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H397.7c-6.1 0-11.6 3.4-14.3 8.8L369 421.5l-28.6-14.3 14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48h66.3c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8H326.1c6.1 0 11.6-3.4 14.3-8.8L369 421.5c-8.1 16.3-24.8 26.5-42.9 26.5H185.9c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8z"]
};
var faCoffeeBean = {
  prefix: 'fal',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M388.3 108.6c21.2 27.9 29.6 65.9 23.5 108.9c-7 49.3-33.2 102.9-78.3 148s-98.7 71.3-148 78.3c-40.4 5.8-76.5-1.4-103.8-19.8c.1-.1 .1-.3 .2-.4c16.5-34.5 37.5-72.2 57.4-92.3c29.7-29.9 59.7-44.9 91.8-61l.5-.3 0 0c32-15.9 66.1-32.9 99.7-66.8c22.8-22.9 42.6-61.6 56.9-94.7zM363.6 84.8c-.6 1.4-1.2 2.9-1.8 4.4c-14.5 34.5-33.5 71.8-53.1 91.5c-29.7 29.9-59.7 44.9-91.8 61l-.5 .3c-32 15.9-66.1 32.9-99.7 66.8c-22.2 22.4-43.4 59.9-59.5 92.6c-22.6-28.1-31.8-67.1-25.5-111.4c7-49.3 33.2-102.9 78.3-148s98.7-71.3 148-78.3c41.4-5.9 78.1 1.7 105.7 21.1zM390 64.7C313.6 2.4 181.6 25 87.3 119.3c-98.9 98.9-119 239.2-44.9 313.5c0 0 .1 .1 .1 .1c7.5 7.5 15.8 14.1 24.5 19.7c.4 .3 .8 .5 1.2 .8c77.8 48.6 199.4 23.2 287.8-65.3c99-99 119-239.4 44.8-313.6c-3.5-3.5-7.1-6.8-10.9-9.8z"]
};
var faCircleYen = {
  prefix: 'fal',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM165.2 148.2c6.5-5.9 16.7-5.5 22.6 1.1l68.2 75 68.2-75c5.9-6.5 16.1-7 22.6-1.1s7 16.1 1.1 22.6L271 255.2h1v.8h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V288H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-.8h1l-76.8-84.5c-5.9-6.5-5.5-16.7 1.1-22.6z"]
};
var faBracketsCurly = {
  prefix: 'fal',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M144 32c-44.2 0-80 35.8-80 80v53.5c0 12.7-5.1 24.9-14.1 33.9L4.7 244.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l45.3 45.3c9 9 14.1 21.2 14.1 33.9V400c0 44.2 35.8 80 80 80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-26.5 0-48-21.5-48-48V346.5c0-21.2-8.4-41.6-23.4-56.6L38.6 256l33.9-33.9c15-15 23.4-35.4 23.4-56.6V112c0-26.5 21.5-48 48-48h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm288 0H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c26.5 0 48 21.5 48 48v53.5c0 21.2 8.4 41.6 23.4 56.6L537.4 256l-33.9 33.9c-15 15-23.4 35.4-23.4 56.6V400c0 26.5-21.5 48-48 48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c44.2 0 80-35.8 80-80V346.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9V112c0-44.2-35.8-80-80-80z"]
};
var faEllipsisStrokeVertical = {
  prefix: 'fal',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", "M96 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96A64 64 0 1 1 96 32a64 64 0 1 1 0 128zm32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 256zm96 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 416z"]
};
var faEllipsisVAlt = faEllipsisStrokeVertical;
var faComment = {
  prefix: 'fal',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M256 64C125.8 64 32 148.6 32 240c0 37.1 15.5 70.6 40 100c5.2 6.3 8.4 14.8 7.4 23.9c-3.1 27-11.4 52.5-25.7 76.3c-.5 .9-1.1 1.8-1.6 2.6c11.1-2.9 22.2-7 32.7-11.5L91.2 446l-6.4-14.7c17-7.4 33-16.7 48.4-27.4c8.5-5.9 19.4-7.5 29.2-4.2C193 410.1 224 416 256 416c130.2 0 224-84.6 224-176s-93.8-176-224-176zM0 240C0 125.2 114.5 32 256 32s256 93.2 256 208s-114.5 208-256 208c-36 0-70.5-6.7-103.8-17.9c-.2-.1-.5 0-.7 .1c-16.9 11.7-34.7 22.1-53.9 30.5C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.8s-1.1-12.8 3.4-17.4c8.1-8.2 15.2-18.2 21.7-29c11.7-19.6 18.7-40.6 21.3-63.1c0 0-.1-.1-.1-.2C19.6 327.1 0 286.6 0 240z"]
};
var faSquare1 = {
  prefix: 'fal',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm168 98.2c-4.9-2.9-11-2.9-16-.1l-56 32c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6L208 171.6V352H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V144c0-5.7-3-11-8-13.8z"]
};
var faCakeCandles = {
  prefix: 'fal',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M82.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8C80 88.8 87.4 96 96 96s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L96 49.7 82.5 70.9zm-27-17.1L86.2 5.4C88.3 2 92 0 96 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26zM384 256H368v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H240v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H112v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H64c-17.7 0-32 14.3-32 32l0 80c13.3 0 26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4C81.9 342.7 89 336 96 336s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4C209.9 342.7 217 336 224 336s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4c6-5.7 13-12.3 19.8-12.4c7.2-.2 15.1 6.8 21.8 12.5c2.8 2.4 5.3 4.6 7.5 6c10.3 6.7 22.7 12.4 35.2 13.3V288c0-17.7-14.3-32-32-32zM32 400l0 80H416V399.9c-21.1-.9-39.8-10.2-52.6-18.5c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C73.8 390 54.6 400 32 400zM64 224H80V176c0-8.8 7.2-16 16-16s16 7.2 16 16v48h96V176c0-8.8 7.2-16 16-16s16 7.2 16 16v48h96V176c0-8.8 7.2-16 16-16s16 7.2 16 16v48h16c35.3 0 64 28.7 64 64V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V288c0-35.3 28.7-64 64-64zM224 49.7L210.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8c0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L224 49.7zM214.2 5.4C216.3 2 220 0 224 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26L214.2 5.4zM338.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8c0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L352 49.7 338.5 70.9zm-27-17.1L342.2 5.4C344.3 2 348 0 352 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26c0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26z"]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faHeadSide = {
  prefix: 'fal',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faEnvelope = {
  prefix: 'fal',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 96c-17.7 0-32 14.3-32 32v39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faDollyEmpty = {
  prefix: 'fal',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", "M8 16C8 7.2 15.2 0 24 0H88.9c20.7 0 39 13.2 45.5 32.8L241.3 353.3c4.8-.9 9.7-1.3 14.7-1.3c34.1 0 63.2 21.3 74.7 51.4L554.5 321c8.3-3.1 17.5 1.2 20.5 9.5s-1.2 17.5-9.5 20.5L335.9 435.6C334 478.1 299 512 256 512c-44.2 0-80-35.8-80-80c0-27.8 14.1-52.2 35.6-66.6L104.1 42.9C101.9 36.4 95.8 32 88.9 32H24C15.2 32 8 24.8 8 16zM304 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faFaceTissue = {
  prefix: 'fal',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", "M256 32C132.3 32 32 132.3 32 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224S379.7 32 256 32zm39.1 306.7c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 371.2l-39.1 26.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l48-32zM136.5 190.3c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L171.9 208l-35.4-17.7zm246.2-21.5c4 7.9 .7 17.5-7.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2zM223.8 306.6l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5s5.3 8.8 4.5 13.9zM79.9 354.1c6.2 3.6 9.3 10.8 7.6 17.8L70 442l70.1-17.5c7-1.7 14.2 1.4 17.8 7.6l9.7 17 20.9-125.6L62.9 344.4l17 9.7z"]
};
var faAnglesUp = {
  prefix: 'fal',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M235.3 52.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 86.6 372.7 235.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-160-160zm160 352l-160-160c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 278.6 372.7 427.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"]
};
var faAngleDoubleUp = faAnglesUp;
var faBinRecycle = {
  prefix: 'fal',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M536 64c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H511.9 64.1 40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H536zM0 88c0 20.3 15.1 37 34.6 39.6l0 .4L59.1 421.3c2.8 33.2 30.5 58.7 63.8 58.7H453.1c33.3 0 61-25.5 63.8-58.7L541.3 128l0-.4C560.9 125 576 108.3 576 88V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72V88zM91 418.7L66.8 128H509.2L485 418.7c-1.4 16.6-15.2 29.3-31.9 29.3H122.9c-16.6 0-30.5-12.8-31.9-29.3zM288 192c5 0 9.7 2.4 12.6 6.4l31 42.1c5 6.7 14.3 8.5 21.4 4.1c7.9-4.9 9.9-15.6 4.4-23.1l-31-42.1c-9-12.2-23.2-19.4-38.4-19.4s-29.4 7.2-38.4 19.4l-31 42.1c-5.5 7.5-3.5 18.1 4.4 23.1c7.1 4.4 16.4 2.7 21.4-4.1l31-42.1c3-4 7.6-6.4 12.6-6.4zm-86.1 77.1c-7.1-4.4-16.4-2.7-21.4 4.1L153 310.5c-5.8 7.9-9 17.5-9 27.4c0 25.5 20.6 46.1 46.1 46.1H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H190.1c-7.8 0-14.1-6.3-14.1-14.1c0-3 1-5.9 2.8-8.4l27.6-37.4c5.5-7.5 3.5-18.1-4.4-23.1zM304 368c0 8.8 7.2 16 16 16h65.9c25.5 0 46.1-20.6 46.1-46.1c0-9.8-3.1-19.4-9-27.4l-27.6-37.4c-5-6.7-14.3-8.5-21.4-4.1c-7.9 4.9-9.9 15.6-4.4 23.1l27.6 37.4c1.8 2.4 2.7 5.4 2.7 8.4c0 7.8-6.3 14.1-14.1 14.1H320c-8.8 0-16 7.2-16 16z"]
};
var faPaperclip = {
  prefix: 'fal',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", "M380.7 67.3c-29.1-29.1-76.3-29.1-105.4 0l-192 192c-46.8 46.8-46.8 122.6 0 169.4s122.6 46.8 169.4 0l152-152c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-152 152c-59.3 59.3-155.4 59.3-214.6 0S1.4 296 60.7 236.7l192-192c41.6-41.6 109-41.6 150.6 0s41.6 109 0 150.6L219.5 379.1c-28.2 28.2-74.6 25.6-99.6-5.5c-21.3-26.6-19.2-65 4.9-89.1L276.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L147.5 307.1c-12.6 12.6-13.7 32.6-2.6 46.5c13 16.2 37.2 17.6 51.9 2.9L380.7 172.7c29.1-29.1 29.1-76.3 0-105.4z"]
};
var faChartLineDown = {
  prefix: 'fal',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM320 336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4L331.3 180.7c-6.2-6.2-16.4-6.2-22.6 0L224 265.4 123.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0L320 214.6 425.4 320H336c-8.8 0-16 7.2-16 16z"]
};
var faArrowRightToCity = {
  prefix: 'fal',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M320 48c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V208c0 8.8 7.2 16 16 16h64 32c8.8 0 16 7.2 16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-26.5-21.5-48-48-48H576V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H512V48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V496c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm32 48v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm64 0v32H384V96h32zm96 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H512zm0 32h32v32H512V288zM480 416v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32zm64 0v32H512V416h32zM384 192c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H384zm0 32h32v32H384V224zM352 352v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm64 0v32H384V352h32zM155.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L201.4 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H201.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faLockA = {
  prefix: 'fal',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", "M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm49.7 200.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 400h92.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5L238.4 265c-.8-1.6-1.8-3-3.1-4.3c-1.4-1.4-3.1-2.6-5-3.4c-2.1-.9-4.2-1.3-6.4-1.3s-4.3 .4-6.4 1.3c-1.8 .8-3.5 1.9-5 3.4c-1.3 1.3-2.3 2.7-3 4.3L129.7 424.8zM193.9 368L224 307.8 254.1 368H193.9z"]
};
var faRibbon = {
  prefix: 'fal',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", "M228 0c-1.3 0-2.6 0-4 0V.1c-13.3 .2-29.2 .7-38.3 1.4s-17 1.7-23.5 2.6c-18.3 2.7-33.3 13.3-43.6 26.7L70.8 92.9c-14.8 19.2-22.8 42.7-22.8 67c0 27.9 10.6 54.8 29.7 75.1L332.3 506.9c5.4 5.8 14.3 6.7 20.9 2.2l80-56c3.8-2.6 6.2-6.8 6.7-11.3s-1-9.1-4.1-12.5L172.4 139.5c-2.8-3-4.3-7-4.3-11.1c0-9.1 7.4-16.5 16.5-16.5H224h16 23.5c9.1 0 16.5 7.4 16.5 16.5c0 4.1-1.5 8-4.3 11.1l-30 33 21.6 23.8 32.1-35.3c8.1-8.9 12.6-20.5 12.6-32.6c0-26.8-21.7-48.5-48.5-48.5H240 224 184.5c-26.8 0-48.5 21.7-48.5 48.5c0 12.1 4.5 23.7 12.6 32.6L399.9 437.3l-53.7 37.6L101.1 213.2c-13.5-14.4-21-33.5-21-53.2c0-17.2 5.7-33.9 16.1-47.5l47.7-62.1c6.3-8.2 14.4-13.3 23-14.6c5.8-.9 12.9-1.7 21.4-2.4c9-.7 26.1-1.3 39.7-1.4c12.1 .1 22.8 .6 31.9 1.4c8.5 .7 15.6 1.6 21.4 2.4c8.6 1.3 16.7 6.4 23 14.6l47.7 62.1c10.5 13.6 16.1 30.3 16.1 47.5c0 19.8-7.5 38.8-21 53.2L314.3 248l21.6 23.8L370.3 235c19.1-20.4 29.7-47.2 29.7-75.1c0-24.2-8-47.8-22.8-67L329.5 30.9c-10.3-13.4-25.3-24-43.6-26.7c-6.5-1-14.3-1.9-23.5-2.6C253.5 .8 243.4 .2 232 .1V0c-1.3 0-2.6 0-4 0zM112.5 319L12.2 429.2c-3.1 3.4-4.6 8-4.1 12.5s3 8.7 6.7 11.3l80 56c6.5 4.6 15.4 3.6 20.9-2.2l86.4-92.2-21.9-23.4-78.3 83.7L48.2 437.3l86.3-94.9L112.5 319z"]
};
var faLungs = {
  prefix: 'fal',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", "M320 0c8.8 0 16 7.2 16 16V180.1c0 21.9 11.2 42.2 29.6 54L384 245.8V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V321.6L416 342v56c0 29.4 20 55 48.5 62.1l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7c31.5 0 57-25.5 57-57v-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1c-20.6 0-37.3 16.7-37.3 37.3V266.1l88.6 56.4c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L416 304.1l-32-20.4-35.5-22.6c-11.5-7.3-21.1-16.9-28.5-27.9c-7.3 11-16.9 20.6-28.5 27.9L256 283.7l-32 20.4-71.4 45.4c-7.5 4.7-17.3 2.5-22.1-4.9s-2.5-17.3 4.9-22.1L224 266.1V165.3c0-20.6-16.7-37.3-37.3-37.3c-11.8 0-22.8 5.5-29.5 15.1c-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416v7c0 31.5 25.5 57 57 57c4.7 0 9.3-.6 13.8-1.7l72.7-18.2C204 453 224 427.4 224 398V342l32-20.4V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v80.4l18.4-11.7c18.5-11.7 29.6-32.1 29.6-54V16c0-8.8 7.2-16 16-16z"]
};
var faPersonPinball = {
  prefix: 'fal',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", "M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm8 168l0 55.7c.2 5.1 2.7 9.7 6.9 12.6L80 320.6V180.2c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28v19.4c0 .2 0 .4 0 .6zm96 168.4l-96-66L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 280.2c0-.3 0-.7 0-1V204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256h29.7l316.4-60.8L481.6 71.5c-1.1-3.3-1.6-6.7-1.6-10.1V32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32V192 400v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H224v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400 288H176.7c-10.9 0-21-5.5-26.9-14.7L112 214.5V342.6L146.1 366c8.7 6 13.9 15.8 13.9 26.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V392.4zM608 178.8V32H512V61.4l42.6 127.7L608 178.8zM608 384V211.4L224 285.2V384H608zM288 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faArrowUp91 = {
  prefix: 'fal',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M428 168a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c.4 0 .9 0 1.3 0l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5C504.4 161.8 512 141.2 512 120h-.1c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM448 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V448H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faSortNumericUpAlt = faArrowUp91;
var faAppleCore = {
  prefix: 'fal',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M196.6 96C229.4 96 256 69.4 256 36.6V32h-4.6C218.6 32 192 58.6 192 91.4V96h4.6zm-18.3 32c-10.1 0-18.3-8.2-18.3-18.3V91.4C160 40.9 200.9 0 251.4 0h18.3C279.8 0 288 8.2 288 18.3V36.6c0 50.5-40.9 91.4-91.4 91.4H178.3zM128 480c13.2 0 32-2.7 45.3-5c12.3-2.2 25-2.2 37.3 0c13.3 2.3 32.1 5 45.3 5c19.7 0 41.8-8.8 62.6-27.3C280 415 256 362.3 256 304c0-55.6 21.8-106.1 57.3-143.4c-3-.4-6.1-.6-9.3-.6c-21 0-48.7 8.4-71.1 17.1c-26.2 10.2-55.6 10.2-81.9 0C128.7 168.4 101 160 80 160c-3.2 0-6.3 .2-9.3 .6C106.2 197.9 128 248.4 128 304c0 58.3-24 111-62.6 148.7C86.2 471.2 108.3 480 128 480zM29.9 462.4c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.2 0-37.4-3.2-50.8-5.5c-8.7-1.5-17.6-1.5-26.3 0c-13.5 2.4-34.6 5.5-50.8 5.5c-34.9 0-69.8-18.3-98.1-49.6z"]
};
var faCircleY = {
  prefix: 'fal',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM156 149.5c-5.8-6.7-15.9-7.3-22.6-1.5s-7.3 15.9-1.5 22.6L240 294v90c0 8.8 7.2 16 16 16s16-7.2 16-16V294L380 170.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5L256 263.7 156 149.5z"]
};
var faH6 = {
  prefix: 'fal',
  iconName: 'h6',
  icon: [640, 512, [], "e413", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM505.4 67.1c-7.1-5.2-17.2-3.6-22.4 3.5L383.3 207.8C363 235.7 352 269.4 352 304c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-15 0-29.6 2.3-43.2 6.6l56.1-77.2c5.2-7.1 3.6-17.2-3.5-22.4zM496 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faLitecoinSign = {
  prefix: 'fal',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M96 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V227.5l-51.9 13C3.5 242.6-1.7 251.3 .5 259.9s10.8 13.8 19.4 11.6l44.1-11V440c0 22.1 17.9 40 40 40H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H104c-4.4 0-8-3.6-8-8V252.5l179.9-45c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L96 219.5V48z"]
};
var faCircleSmall = {
  prefix: 'fal',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M288 256A128 128 0 1 0 32 256a128 128 0 1 0 256 0zM0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
var faBorderNone = {
  prefix: 'fal',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M32 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-240a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM320 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-432a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM416 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faArrowTurnDownLeft = {
  prefix: 'fal',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", "M480 48c0-8.8 7.2-16 16-16s16 7.2 16 16V224c0 44.2-35.8 80-80 80H54.6L155.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272H432c26.5 0 48-21.5 48-48V48z"]
};
var faCircleNodes = {
  prefix: 'fal',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M376.2 121.7l0 0c7 4 15.2 6.3 23.8 6.3c2.6 0 5.2-.2 7.6-.6l0 0C430.5 123.7 448 103.9 448 80c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 .7 0 1.3 0 2l0 0c.5 11.4 4.9 21.7 11.9 29.7l0 0c3.5 4 7.6 7.4 12.2 10zm-5.9 32.6c-15.2-6.1-28.2-16.8-37.1-30.3L158.7 193.7c.8 4.6 1.3 9.4 1.3 14.3c0 14.4-3.8 27.9-10.5 39.6l138 120.8c13-9.9 29.2-16 46.7-16.3l36-197.7zm-4.5 203.4C395.2 369.5 416 398.3 416 432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-14.4 3.8-27.9 10.5-39.6l-138-120.8C115 281.9 98.2 288 80 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c27.9 0 52.5 14.3 66.8 36L321.3 94.3c-.8-4.6-1.3-9.4-1.3-14.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 43.6-34.9 79.1-78.3 80l-36 197.7zm-246-122.9c.7-1 1.3-2 1.9-3.1c4-7 6.3-15.1 6.3-23.8c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c8.5 0 16.6-2.2 23.5-6.2l0 0c6.5-3.7 12.1-8.8 16.3-15zM291.4 414.2c-2.2 5.5-3.4 11.5-3.4 17.8c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48c-14 0-26.6 6-35.3 15.5c-2.7 2.9-5 6.1-6.9 9.6c-.9 1.6-1.7 3.4-2.4 5.1l0 0z"]
};
var faParachuteBox = {
  prefix: 'fal',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M256.1 0H256C86.6 0 8.7 114.4 .7 208c-.8 8.8 6.5 16 15.3 16H49.1L165 346.7c-3.2 6.4-5 13.7-5 21.3v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.7-1.8-14.9-5-21.3L462.9 224H496c8.8 0 16.1-7.2 15.3-16c-8-93.6-85.8-208-255.2-208zM418.9 224L324.1 324.4c-6.1-2.8-12.9-4.4-20.1-4.4H272V224h95.5 32 19.3zM240 224v96H208c-7.2 0-14 1.6-20.1 4.4L93.1 224h19.3 32H240zm0 128h32 32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32zM35.2 192C46.4 135.7 86.8 73.5 165.5 46.2c-29.9 35-50 87-53.1 145.8H35.2zM180.5 79.1C202.5 47.4 229.7 32 256 32s53.5 15.4 75.5 47.1c19.6 28.3 33.4 67.8 36 112.9H144.5c2.7-45.1 16.4-84.5 36-112.9zM476.8 192H399.6c-3.1-58.8-23.1-110.8-53.1-145.8C425.2 73.5 465.6 135.7 476.8 192z"]
};
var faMessageMedical = {
  prefix: 'fal',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM240 96c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H304V128c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V240c0-8.8-7.2-16-16-16H176V192h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V128z"]
};
var faCommentAltMedical = faMessageMedical;
var faRugbyBall = {
  prefix: 'fal',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M336 16h32c70.7 0 128 57.3 128 128v32c0 176.7-143.3 320-320 320H144C73.3 496 16 438.7 16 368V336C16 159.3 159.3 16 336 16zm27.9 32H336c-77.3 0-147.5 30.4-199.2 80c-3 2.9-5.9 5.8-8.8 8.8C78.4 188.5 48 258.7 48 336v31.9c3.5-10.8 8-22.1 13.5-33.6c23.1-48.3 64-104.5 117.2-157.6S288 82.6 336.3 59.5C345.7 55 355 51.2 363.9 48zM143.1 464c.3 0 .6 0 .9 0h32c77.3 0 147.5-30.4 199.2-80c3-2.9 5.9-5.8 8.8-8.8c49.6-51.7 80-121.9 80-199.2V147.2c-3.2 9.2-7.1 18.6-11.7 28.2c-23.1 48.3-64 104.5-117.2 157.6S225.8 427.2 177.5 450.2c-11.8 5.6-23.3 10.3-34.3 13.8zM79.2 432.5c4.6 4.6 13.1 7.9 28.2 6.6c15-1.3 34.1-7.1 56.3-17.7c44.3-21.1 97.5-59.7 148.8-110.9s89.8-104.5 110.9-148.8c10.6-22.2 16.4-41.3 17.7-56.3c1.3-15.1-2-23.6-6.6-28.2s-13.1-7.9-28.2-6.6c-15 1.3-34.1 7.1-56.3 17.7c-44.3 21.1-97.5 59.7-148.8 110.9s-89.8 104.5-110.9 148.8C79.8 370.3 74 389.4 72.7 404.4c-1.3 15.1 2 23.6 6.6 28.2z"]
};
var faCommentMusic = {
  prefix: 'fal',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm89.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V187.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V128c0-5.2-2.6-10.2-6.9-13.2zM320 276c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 308c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faIndent = {
  prefix: 'fal',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 64c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 80 0 72.8 0 64zM192 192c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 112H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM0 448c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM32 211.8v88.4L85.7 256 32 211.8zm89 31.8c7.8 6.4 7.8 18.3 0 24.7L26.2 346.4C15.7 355 0 347.6 0 334.1V177.9c0-13.5 15.7-20.9 26.2-12.4L121 243.6z"]
};
var faTreeDeciduous = {
  prefix: 'fal',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M177.7 95.6c-.9 4.5-3.8 8.4-7.8 10.6s-8.8 2.7-13.1 1.2c-6.5-2.2-13.5-3.5-20.8-3.5c-35.3 0-64 28.7-64 64c0 13.2 4 25.4 10.8 35.6c2.8 4.1 3.5 9.3 1.9 14s-5.2 8.4-9.9 10C49.9 236.3 32 260.1 32 288c0 35.3 28.7 64 64 64H240V320 256 144c0-8.8 7.2-16 16-16s16 7.2 16 16V256v64 32H416c35.3 0 64-28.7 64-64c0-27.9-17.9-51.7-42.8-60.4c-4.7-1.6-8.3-5.3-9.9-10s-.9-9.9 1.9-14C436 193.4 440 181.2 440 168c0-35.3-28.7-64-64-64c-7.3 0-14.3 1.2-20.8 3.5c-4.3 1.5-9.1 1-13.1-1.2s-6.8-6.1-7.8-10.6C326.8 59.3 294.5 32 256 32s-70.8 27.3-78.3 63.6zM240 384H96c-53 0-96-43-96-96c0-35.3 19.1-66.2 47.5-82.8c-4.8-11.4-7.5-24-7.5-37.2c0-53 43-96 96-96c5.1 0 10.1 .4 14.9 1.2C166.7 30.4 207.8 0 256 0s89.3 30.4 105.1 73.2c4.9-.8 9.9-1.2 14.9-1.2c53 0 96 43 96 96c0 13.2-2.7 25.7-7.5 37.2C492.9 221.8 512 252.7 512 288c0 53-43 96-96 96H272V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384z"]
};
var faTreeAlt = faTreeDeciduous;
var faPuzzlePieceSimple = {
  prefix: 'fal',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M176 96c-8.8 0-16 7.2-16 16v88.8c0 21.6-17.5 39.2-39.2 39.2c-16.2 0-28.4-9.9-35.6-19.6C78.8 211.8 71.1 208 64 208c-7.1 0-14.7 3.8-21.1 12.3S32 241.5 32 256s4.4 27.1 10.9 35.7S56.9 304 64 304c7.1 0 14.8-3.8 21.2-12.4c7.2-9.7 19.4-19.6 35.6-19.6c21.6 0 39.2 17.5 39.2 39.2V400c0 8.8 7.2 16 16 16h93.7C252 403.1 240 383.1 240 360c0-41.7 37.9-72 80-72s80 30.3 80 72c0 23.1-12 43.1-29.7 56H464c8.8 0 16-7.2 16-16V311.2c0-21.6 17.5-39.2 39.2-39.2c16.2 0 28.4 9.9 35.6 19.6c6.4 8.6 14.1 12.4 21.2 12.4c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-7.1 0-14.8 3.8-21.2 12.4c-7.2 9.7-19.4 19.6-35.6 19.6c-21.7 0-39.2-17.5-39.2-39.2V112c0-8.8-7.2-16-16-16H370.3C388 108.8 400 128.9 400 152c0 41.7-37.9 72-80 72s-80-30.3-80-72c0-23.1 12-43.2 29.7-56H176zm-48 16c0-26.5 21.5-48 48-48h97.5C290.3 64 304 77.7 304 94.5c0 11.9-6.8 21.3-14.6 26.7c-11.2 7.7-17.4 19-17.4 30.8c0 20.2 19.4 40 48 40s48-19.8 48-40c0-11.8-6.3-23.1-17.4-30.8c-7.8-5.4-14.6-14.8-14.6-26.7C336 77.7 349.7 64 366.6 64H464c26.5 0 48 21.5 48 48v88.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7c11-14.7 27.4-25.3 46.8-25.3c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2V400c0 26.5-21.5 48-48 48H366.6c-16.9 0-30.6-13.7-30.6-30.6c0-11.9 6.8-21.3 14.6-26.7c11.2-7.7 17.4-19 17.4-30.8c0-20.2-19.4-40-48-40s-48 19.8-48 40c0 11.8 6.3 23.1 17.4 30.8c7.8 5.4 14.6 14.8 14.6 26.7c0 16.9-13.7 30.6-30.5 30.6H176c-26.5 0-48-21.5-48-48V311.2c0-4-3.2-7.2-7.2-7.2c-2.3 0-6.1 1.6-10 6.7C99.9 325.4 83.5 336 64 336c-19.4 0-35.8-10.5-46.7-25.1S0 276.8 0 256s6.3-40.2 17.3-54.9S44.6 176 64 176c19.5 0 35.9 10.6 46.8 25.3c3.8 5.2 7.7 6.7 10 6.7c4 0 7.2-3.2 7.2-7.2V112z"]
};
var faPuzzlePieceAlt = faPuzzlePieceSimple;
var faTruckFieldUn = {
  prefix: 'fal',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M96 64C78.3 64 64 78.3 64 96v32V288v64h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H352V224 192 96c0-17.7-14.3-32-32-32H96zM0 160c0-17.7 14.3-32 32-32V96c0-35.3 28.7-64 64-64H320c32.6 0 59.6 24.4 63.5 56h53.4c17.7 0 33.9 9.7 42.3 25.2L521.6 192H544c35.3 0 64 28.7 64 64v96h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608 576c0 53-43 96-96 96s-96-43-96-96H352 256c0 53-43 96-96 96s-96-43-96-96H32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V288c-17.7 0-32-14.3-32-32V160zm384-40v72H485.2L451 128.4c-2.8-5.2-8.2-8.4-14.1-8.4H384zm0 232h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H576V256c0-17.7-14.3-32-32-32H512.3c-.2 0-.4 0-.6 0H384V352zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 240A64 64 0 1 0 96 384a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faNfcTrash = {
  prefix: 'fal',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", "M64 64H384c17.7 0 32 14.3 32 32V200.2l2.5-7.4c4.8-14.3 15.9-25.2 29.5-30.1V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H381.6l-2.3-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM384 208V128c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32v82.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128H352v80h32zM352 384H96V128l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H352c9.7 0 18.4-4.3 24.3-11.1L369.1 304H352v80zM240 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm208.8-53.1L436.5 240H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H576h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H587.5l-12.4-37.1C573 196.4 566.9 192 560 192H464c-6.9 0-13 4.4-15.2 10.9zM470.2 240l5.3-16h72.9l5.3 16H470.2zm-69 64.1l12.7 178.2C415.1 499 429 512 445.8 512H578.2c16.8 0 30.7-13 31.9-29.7l12.7-178.2H590.8L578.2 480H445.8L433.2 304.1H401.1z"]
};
var faHourglass = {
  prefix: 'fal',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H32l0 44.7c0 31.6 10.4 62.4 29.6 87.5L131.9 256 61.6 347.9C42.4 373 32 403.7 32 435.3V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V435.3c0-31.6-10.4-62.4-29.6-87.5L252.1 256l70.2-91.9C341.6 139 352 108.3 352 76.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM320 32V76.7c0 24.6-8.1 48.5-23 68L219.3 246.3c-4.4 5.7-4.4 13.7 0 19.4L297 367.3c14.9 19.5 23 43.4 23 68V480H64l0-44.7c0-24.6 8.1-48.5 23-68l77.7-101.6c4.4-5.7 4.4-13.7 0-19.4L87 144.7c-14.9-19.5-23-43.4-23-68L64 32H320z"]
};
var faHourglassEmpty = faHourglass;
var faMountain = {
  prefix: 'fal',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", "M480 424.1c0 13.2-10.7 23.9-23.9 23.9H55.9C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7L140.2 244.8 195.5 314c3.1 3.9 7.8 6.1 12.7 6s9.6-2.4 12.6-6.4L264 256H378.9l97.5 155.4c2.4 3.8 3.7 8.2 3.7 12.7zM358.8 224H256c-5 0-9.8 2.4-12.8 6.4l-35.6 47.5-49.4-61.8L252.4 66c.8-1.3 2.2-2 3.6-2s2.9 .8 3.6 2l99.1 158zM55.9 480H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z"]
};
var faFileXmark = {
  prefix: 'fal',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm52.7 260.7c-6.2 6.2-6.2 16.4 0 22.6L169.4 336l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 358.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 336l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faFileTimes = faFileXmark;
var faHouseHeart = {
  prefix: 'fal',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM208 285.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L288 377.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM237.3 224c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faHomeHeart = faHouseHeart;
var faHouseChimneyBlank = {
  prefix: 'fal',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3V56c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24V79.4L298.6 4zM416 107.6V64h64V164.1l-64-56.5zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48z"]
};
var faMeterBolt = {
  prefix: 'fal',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M480 256c0 5.7-.2 11.4-.6 17l32.3-30.6C504.6 107.4 392.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c69.2 0 132-27.5 178.1-72.1c-12.4-.8-23.7-5.8-32.4-13.7C362.5 459.7 311.6 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm95.7 232l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H463.7zM585.6 224c-5.1 0-10.1 2-13.8 5.5L422.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H487l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L633.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H569l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faUserDoctor = {
  prefix: 'fal',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm48 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32-45.3V336l1.2 0h93.6c5.8 0 11.5 .3 17.2 1v33.3c-23.1 6.9-40 28.3-40 53.7v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-25.4-16.9-46.8-40-53.7V344.5c55.6 20 95.5 73 96 135.5H32c.5-68.2 48.2-125.3 112-140.2v30.9c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3zm1.2-66.7C79.3 304 0 383.3 0 481.2c0 17 13.8 30.8 30.8 30.8H417.2c17 0 30.8-13.8 30.8-30.8C448 383.3 368.7 304 270.8 304H177.2z"]
};
var faUserMd = faUserDoctor;
var faSlashBack = {
  prefix: 'fal',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", "M7.8 2.3c-7.6 4.5-10 14.4-5.5 22l288 480c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-22L29.7 7.8c-4.5-7.6-14.4-10-22-5.5z"]
};
var faCircleInfo = {
  prefix: 'fal',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faInfoCircle = faCircleInfo;
var faFishingRod = {
  prefix: 'fal',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M280.4 32c-4 0-7.9 .6-11.7 1.8L204.2 53.6C130.4 76.3 80 144.5 80 221.8V288h8c22.1 0 40 17.9 40 40V472c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328c0-22.1 17.9-40 40-40h8V221.8C48 130.5 107.6 49.9 194.8 23L259.3 3.2C266.1 1.1 273.2 0 280.4 0C319.9 0 352 32.1 352 71.6V136c0 8.8-7.2 16-16 16s-16-7.2-16-16V71.6C320 49.7 302.3 32 280.4 32zm48.5 145.7c4.5-2.3 9.8-2.3 14.3 0c17.9 8.9 43.7 27.1 65.2 53.4C430 257.5 448 292.9 448 336c0 33.5-15.1 80.9-58.2 115.8l23.5 35.3c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H272c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l23.5-35.3C239.1 416.9 224 369.5 224 336c0-43.1 18-78.5 39.6-104.9c21.5-26.3 47.4-44.4 65.2-53.4zM256 336c0 27.3 13.9 70 56.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2L301.9 480h68.2l-15.4-23.1c-4.9-7.4-2.9-17.3 4.4-22.2C402.1 406 416 363.3 416 336c0-33.7-14-62.3-32.4-84.7c-15.6-19-33.8-33-47.6-41.1c-13.8 8.1-32 22.1-47.6 41.1C270 273.7 256 302.3 256 336zM88 320H40c-4.4 0-8 3.6-8 8V472c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zm272-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHammerCrash = {
  prefix: 'fal',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M283.7 379.4l11.9-48.2c10.4 4.3 21.3 5.6 31.9 4.4l-4.4 17.7 71.3-35.9c6.9-3.5 15.2-1.6 19.9 4.5L463 385.2 479.3 307c1.6-7.5 8.3-12.9 15.9-12.7l79.8 1.4-50.9-61.5c-4.9-5.9-4.9-14.5 0-20.4l50.9-61.5-79.8 1.4c-7.7 .1-14.4-5.2-15.9-12.7L463 62.8l-30.4 39.5c-5.4-6.3-12.1-11.6-20-15.6l-6.1-3 52.3-68c3.8-5 10.2-7.2 16.2-5.8s10.8 6.2 12.1 12.3l20.8 99.3 101.4-1.8c6.2-.1 12 3.4 14.7 9.1s1.9 12.3-2.1 17.1L557.3 224 622 302.1c4 4.8 4.8 11.5 2.1 17.1s-8.5 9.2-14.7 9.1l-101.4-1.8-20.8 99.3c-1.3 6.1-6 10.9-12.1 12.3s-12.4-.9-16.2-5.8L397 351.8l-90.6 45.7c-5.6 2.8-12.3 2.1-17.2-1.8s-7.1-10.3-5.6-16.4zM72 48L32 128 320 272l64-128L192 48 72 48zM43.4 33.7C48.8 22.8 59.9 16 72 16H192c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3l-97.9-48.9 0 0-28.6-14.3 0 0-28.6-14.3 0 0L122 208.8l0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80zM5.1 442.5L107.7 237.4l28.6 14.3L33.7 456.9c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L164.9 266l28.6 14.3L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.3 5.1 442.5z"]
};
var faMessageHeart = {
  prefix: 'fal',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 173.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 265.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 112c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faCloudMeatball = {
  prefix: 'fal',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M96 117.6c0-47.6 36.5-84.8 80-84.8c31.7 0 59.6 19.7 72.5 48.9c2.2 4.9 6.6 8.4 11.9 9.3s10.7-.9 14.4-4.8c11.7-12.4 27.7-19.9 45.2-19.9c34.6 0 64 29.7 64 68l0 .3c0 4.5 1.9 8.8 5.2 11.9s7.8 4.5 12.3 4.1c2.1-.2 4.3-.3 6.5-.3c39 0 72 33.5 72 76.4s-33 76.4-72 76.4h0l0 0H388.8c2.5 7.9 3.7 16.1 3.7 24.2c2.4 2.4 4.7 5 6.8 7.8h8.5 0l0 0c58.2 0 104-49.3 104-108.4c0-56.8-42.3-104.5-97.2-108.2c-7.2-47.2-46.3-84.2-94.8-84.2c-19.3 0-37.3 6-52.3 16.1C247.6 20.7 214.2 .8 176 .8c-62.6 0-112 53-112 116.8c0 3 .1 6 .3 9C26.3 142.9 0 181.9 0 226.8c0 59.1 45.8 108.4 104 108.4l0 0h0 8.5c2.1-2.7 4.4-5.3 6.8-7.8c0-8.2 1.2-16.4 3.7-24.2H104.1l0 0h0c-39 0-72-33.5-72-76.4c0-36.1 23.4-65.7 54-74c8.1-2.2 13.1-10.2 11.5-18.4c-1-5.4-1.6-11-1.6-16.8zM32 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0A48 48 0 1 0 0 400a48 48 0 1 0 96 0zm352 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM240 304c0-8.8 7.2-16 16-16s16 7.2 16 16c0 .5 0 1.1-.1 1.6c-.7 7 3.3 13.6 9.8 16.3s14 .8 18.5-4.6c.3-.4 .7-.8 1.1-1.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-.4 .4-.8 .7-1.2 1.1c-5.4 4.5-7.3 12-4.6 18.5s9.3 10.5 16.3 9.8c.5 0 1-.1 1.6-.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-.5 0-1.1 0-1.6-.1c-7-.7-13.6 3.3-16.3 9.8s-.8 14 4.6 18.5c.4 .3 .8 .7 1.2 1.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-.4-.4-.7-.8-1.1-1.2c-4.5-5.4-12-7.3-18.5-4.6s-10.5 9.3-9.8 16.3c0 .5 .1 1 .1 1.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.5 0-1.1 .1-1.6c.7-7-3.3-13.6-9.8-16.3s-14-.8-18.5 4.6c-.3 .4-.7 .8-1.1 1.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c.4-.4 .8-.7 1.2-1.1c5.4-4.5 7.3-12 4.6-18.5s-9.3-10.5-16.3-9.8c-.5 0-1 .1-1.6 .1c-8.8 0-16-7.2-16-16s7.2-16 16-16c.5 0 1.1 0 1.6 .1c7 .7 13.6-3.3 16.3-9.8s.8-14-4.6-18.5c-.4-.3-.8-.7-1.2-1.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l8.5-8.5-8.5 8.5c.4 .4 .7 .8 1.1 1.2c4.5 5.4 12 7.3 18.5 4.6s10.5-9.3 9.8-16.3c0-.5-.1-1-.1-1.6zm144 80c0-18.4-10.4-34.4-25.5-42.4c5-16.4 1.1-35.1-11.9-48.1s-31.6-17-48.1-11.9c-8.1-15.2-24-25.5-42.4-25.5s-34.4 10.4-42.4 25.5c-16.4-5-35.1-1.1-48.1 11.9s-17 31.6-11.9 48.1c-15.2 8.1-25.5 24-25.5 42.4s10.4 34.4 25.5 42.4c-5 16.4-1.1 35.1 11.9 48.1s31.6 17 48.1 11.9c8.1 15.2 24 25.5 42.4 25.5s34.4-10.4 42.4-25.5c16.4 5 35.1 1.1 48.1-11.9s17-31.6 11.9-48.1c15.2-8.1 25.5-24 25.5-42.4z"]
};
var faCameraPolaroid = {
  prefix: 'fal',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M64 448H512c17.7 0 32-14.3 32-32V371.4c0-6.3-1.9-12.5-5.4-17.8l-1.1-1.6H38.5l-1.1 1.6c-3.5 5.3-5.4 11.4-5.4 17.8V416c0 17.7 14.3 32 32 32zM516.2 320l-28.1-42.2c-5.3-7.9-8.1-17.1-8.1-26.6V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V251.2c0 9.5-2.8 18.7-8.1 26.6L59.8 320H516.2zM512 480H64c-35.3 0-64-28.7-64-64V371.4c0-12.6 3.7-25 10.7-35.5L61.3 260c1.8-2.6 2.7-5.7 2.7-8.9V96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V251.2c0 3.2 .9 6.2 2.7 8.9l50.6 75.8c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64zM416 152a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-128-8a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM112 384H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCamera = {
  prefix: 'fal',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M191.1 32c-20.7 0-39 13.2-45.5 32.8L135.1 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H376.9L366.5 64.8C359.9 45.2 341.6 32 320.9 32H191.1zM175.9 74.9c2.2-6.5 8.3-10.9 15.2-10.9H320.9c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h82.7c6.9 0 13-4.4 15.2-10.9l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faCameraAlt = faCamera;
var faSquareVirus = {
  prefix: 'fal',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM86.6 230.9c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24s24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24zm62.6-50.7c8.2 28.6-4.9 60.2-30.9 74.7c26 14.5 39.1 46.1 30.9 74.7c28.6-8.2 60.2 4.9 74.7 30.9c14.5-26 46.1-39.1 74.7-30.9c-8.2-28.6 4.9-60.2 30.9-74.7c-26-14.5-39.1-46.1-30.9-74.7c-16.4 4.7-33.9 2.4-48.5-5.4c-10.8-5.7-20.1-14.5-26.2-25.5c-14.5 26-46.1 39.1-74.7 30.9z"]
};
var faCartArrowUp = {
  prefix: 'fal',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM304 208V86.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 86.6V208c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faMeteor = {
  prefix: 'fal',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8C0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4L498.6 242.7c15.3-21.2 .2-50.7-25.9-50.7H446.6L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4V32zm154.6 .3c.5-.2 1-.3 1.5-.3c2.1 0 3.8 1.7 3.8 3.8c0 .5-.1 1.1-.3 1.5L407.4 201.6c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3h50.6L338.5 409.8C306.7 453.9 255.6 480 201.3 480C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32V89.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2L474.6 32.3zM296 312a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM200 184a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM184 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faCarOn = {
  prefix: 'fal',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M272 24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V24zM188.2 208H323.8c14.3 0 26.8 9.5 30.8 23.2L370.8 288c-.9 0-1.9 0-2.8 0H144c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H416v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H188.2c-28.6 0-53.7 18.9-61.5 46.4zM416 416v16H96V416 368c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v48zM144 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0zm400 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faSleigh = {
  prefix: 'fal',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V256c0 59.6 40.8 109.8 96 124v68H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H568c39.8 0 72-32.2 72-72V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 22.1-17.9 40-40 40H448V384c70.7 0 128-57.3 128-128V128h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H576 544 488c-22.1 0-40 17.9-40 40v35.8c0 28.8-23.4 52.2-52.2 52.2c-72 0-139-37.1-177.1-98.2l-7.2-11.5C179.6 63.4 124 32.4 64 32l-1 0H56 32 16zM416 448H160V384H416v64zm72-320h56V256c0 53-43 96-96 96H160c-53 0-96-43-96-96V64c48.9 .4 94.3 25.7 120.3 67.2l7.2 11.5C235.5 213.2 312.7 256 395.8 256c46.5 0 84.2-37.7 84.2-84.2V136c0-4.4 3.6-8 8-8z"]
};
var faArrowDown19 = {
  prefix: 'fal',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M448 48V192h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V70.2l-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13zM171.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zM428 288a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6L429.3 424c-.4 0-.9 0-1.3 0c-46.4 0-84-37.6-84-84z"]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faBuoyMooring = {
  prefix: 'fal',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", "M272 16c0-8.8 7.2-16 16-16s16 7.2 16 16V65.1c46.7 6.7 85.5 42.3 94.6 89.9l45.8 240.3c-.4 .3-.8 .5-1.2 .8c-8.8 6.1-18.5 11.1-28.5 14.6L397.4 320H178.6l-17.3 90.7c-9.9-3.5-19.7-8.5-28.4-14.6c-.4-.3-.8-.6-1.2-.8L177.4 155c9.1-47.6 47.8-83.2 94.6-89.9V16zM208.9 161L184.7 288H391.3L367.1 161C360 123.4 326.5 96 288 96s-72 27.4-79.1 65zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"]
};
var faSquare4 = {
  prefix: 'fal',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm133.9 97.1c-8.2-3.3-17.5 .7-20.8 8.9l-64 160c-2 4.9-1.4 10.5 1.6 14.9s7.9 7 13.2 7H256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H151.6l55.2-138.1c3.3-8.2-.7-17.5-8.9-20.8z"]
};
var faHandHoldingDroplet = {
  prefix: 'fal',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M235.6 121.1C228 132.1 224 145.1 224 158.3V160c0 35.3 28.7 64 64 64s64-28.7 64-64v-1.7c0-13.3-4-26.3-11.6-37.2L288 44.8l-52.4 76.3zM209.2 103L275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faTricycleAdult = {
  prefix: 'fal',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M304 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h39c5.3 0 10.3 2.6 13.3 7L440 226.7l-53.2 70.9c-6.8 9-17.4 14.3-28.7 14.3c-2.8 0-5.6-.3-8.3-1L19.7 232.4c-8.6-2-17.2 3.3-19.3 11.9s3.3 17.2 11.9 19.3l31.9 7.6C17.6 288.2 0 318.1 0 352c0 53 43 96 96 96c18 0 34.8-4.9 49.1-13.5c-.4 .2-.8 .5-1.1 .7c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-8.1-1-16-2.9-23.5l57.3 13.6c5.1 1.2 10.4 1.8 15.7 1.8c21.4 0 41.5-10.1 54.3-27.1l46.6-62.1 18.8 27.8C459.4 300 448 324.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-14.2 0-27.7 3.1-39.8 8.6L382.8 85.1C373.8 71.9 359 64 343 64H304zM480 352c0-16.2 6.1-31.1 16-42.4L530.8 361c5 7.3 14.9 9.2 22.2 4.3s9.2-14.9 4.3-22.2l-34.7-51.3c6.7-2.4 13.9-3.7 21.5-3.7c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM247.1 319.5c5.6 9.5 8.9 20.6 8.9 32.5c0 35.3-28.7 64-64 64c-7.5 0-14.7-1.3-21.3-3.6C184 395.9 192 374.9 192 352c0-17.8-4.9-34.5-13.3-48.8l68.5 16.3zM62.9 106.1c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8l23.3 58.3c7.3 18.3 22.6 32.1 41.4 37.7l89.6 26.2c8.5 2.5 17.4-2.4 19.9-10.9s-2.4-17.4-10.9-19.8l-89.6-26.2c-9.4-2.8-17.1-9.7-20.7-18.8L62.9 106.1zM94.4 416C59.8 415.1 32 386.8 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c0 0 0 0 0 0"]
};
var faWaveform = {
  prefix: 'fal',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", "M320 0c8 0 14.8 5.9 15.9 13.9l49.3 369.5L432.2 77.6c1.2-7.9 8-13.6 16-13.6s14.6 6 15.7 13.8l34.6 254 29.8-158.8c1.4-7.3 7.6-12.7 15-13s14.1 4.5 16.1 11.6L588.1 272H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H576c-7.1 0-13.4-4.7-15.4-11.6l-13.4-46.8L511.7 434.9c-1.4 7.7-8.3 13.2-16.1 13s-14.4-6.1-15.5-13.8L447 191.4l-47.2 307c-1.2 7.9-8 13.6-16 13.6s-14.6-6-15.7-13.9L320 137.1 271.9 498.1c-1.1 7.9-7.7 13.8-15.7 13.9s-14.8-5.7-16-13.6L193 191.4 159.9 434.2c-1.1 7.8-7.6 13.6-15.5 13.8s-14.7-5.3-16.1-13L92.8 245.6 79.4 292.4c-2 6.9-8.2 11.6-15.4 11.6H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H51.9L80.6 171.6c2-7.1 8.7-11.9 16.1-11.6s13.6 5.7 15 13l29.8 158.8 34.6-254c1.1-7.9 7.8-13.8 15.7-13.8s14.7 5.7 16 13.6l47.1 305.9L304.1 13.9C305.2 5.9 312 0 320 0z"]
};
var faWater = {
  prefix: 'fal',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M133.8 106.8C150.3 118 171.1 128 192 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 118 363.1 128 384 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 145.9 414.3 160 384 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 145.9 222.3 160 192 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 160.1 0 152 0 142.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zm0 288C150.3 406 171.1 416 192 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 406 363.1 416 384 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 433.9 414.3 448 384 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 433.9 222.3 448 192 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 448.1 0 440 0 430.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM192 272c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 262 363.1 272 384 272s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 289.9 414.3 304 384 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 289.9 222.3 304 192 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 304.1 0 296 0 286.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 262 171.1 272 192 272z"]
};
var faStarSharpHalfStroke = {
  prefix: 'fal',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M272 93.9V376.2L163.5 460.6l43.8-143.9c2-6.5-.4-13.6-5.9-17.6l-126-91H224c7 0 13.1-4.5 15.2-11.1L272 93.9zm32 282.3V93.9l32.8 102.9c2.1 6.6 8.3 11.1 15.2 11.1H500.7l-126 91c-5.5 4-7.9 11.1-5.9 17.6l43.8 143.9L304 376.2zM288 0c-11.7 0-22.1 7.6-25.7 18.8L212.3 176H58.6C43.9 176 32 187.9 32 202.6c0 8.5 4.1 16.6 11 21.6l130.3 94.1-50.8 167c-4.1 13.3 5.9 26.8 19.8 26.8c4.6 0 9.1-1.5 12.7-4.4L288 404.3 420.9 507.6c3.6 2.8 8.1 4.4 12.7 4.4c13.9 0 23.9-13.4 19.8-26.8l-50.8-167L533 224.1c6.9-5 11-13 11-21.6c0-14.7-11.9-26.6-26.6-26.6H363.7l-50-157.2C310.1 7.6 299.7 0 288 0z"]
};
var faStarSharpHalfAlt = faStarSharpHalfStroke;
var faNfcSignal = {
  prefix: 'fal',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H227c-1.6 10.5-2.6 21.2-2.9 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V227c-10.9 1.7-21.6 4-32 6.9V96c0-17.7-14.3-32-32-32zm0 64V245.3c-11.1 4.8-21.8 10.2-32 16.4V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM233.9 416H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384H245.3c-4.4 10.3-8.2 21-11.3 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm272 16c8.8 0 16 7.2 16 16s-7.2 16-16 16c-114.9 0-208 93.1-208 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-132.5 107.5-240 240-240zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-80c0 8.8-7.2 16-16 16c-61.9 0-112 50.1-112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-79.5 64.5-144 144-144c8.8 0 16 7.2 16 16z"]
};
var faPlaneProp = {
  prefix: 'fal',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M270 0c-16 0-29.6 11.9-31.7 27.8L235.6 48H224c-26.5 0-48 21.5-48 48c0 26.1 20.8 47.3 46.8 48l-4.9 37-67.1 9-3.9-27.6C144 142.6 127.1 128 107.2 128H84.8c-19.9 0-36.8 14.6-39.6 34.3l-6.1 42.9C16.3 211.2 0 231.9 0 256s16.3 44.8 39.1 50.8l6.1 42.9C48 369.4 64.9 384 84.8 384h22.4c19.9 0 36.8-14.6 39.6-34.3l3.9-27.6 67.1 9 4.9 37c-26 .6-46.8 21.9-46.8 48c0 26.5 21.5 48 48 48h11.6l2.7 20.2C240.4 500.1 254 512 270 512h36c16 0 29.6-11.9 31.7-27.8l7-52.2H368v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H348.9l8.5-64 108.8 0c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2H357.5l-8.5-64H368v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c8.8 0 16-7.2 16-16s-7.2-16-16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V80H344.7l-7-52.2C335.6 11.9 322 0 306 0H270zM224 400h3.1l4.3 32H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0-320h7.3l-4.3 32H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm101.2 96H256c-.7 0-1.4 0-2.1 .1l-3.2 .4L270 32h36l19.2 144zm0 160L306 480H270L250.7 335.4l3.2 .4c.7 .1 1.4 .1 2.1 .1h69.2zM76.9 166.9c.6-3.9 3.9-6.9 7.9-6.9h22.4c4 0 7.4 2.9 7.9 6.9l6.2 43.2c1.2 8.7 9.3 14.8 18 13.6L257.1 208H466.3c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2l-209.3 0L139.2 288.3c-8.7-1.2-16.7 4.9-18 13.6l-6.2 43.2c-.6 3.9-3.9 6.9-7.9 6.9H84.8c-4 0-7.4-2.9-7.9-6.9l-7.8-54.4c-1-7.1-6.6-12.6-13.7-13.6l-5.6-.7C39.6 275 32 266.3 32 256s7.6-19 17.8-20.4l5.6-.7c7.1-.9 12.7-6.5 13.7-13.6l7.8-54.4z"]
};
var faCalendarCheck = {
  prefix: 'fal',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112z"]
};
var faClockDesk = {
  prefix: 'fal',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M32 224a192 192 0 1 1 384 0A192 192 0 1 1 32 224zM416 339.4V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V339.4C71.2 404.5 142.5 448 224 448s152.8-43.5 192-108.6zM0 224V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V224C448 100.3 347.7 0 224 0S0 100.3 0 224zM224 96c-8.8 0-16 7.2-16 16V224c0 4.2 1.7 8.3 4.7 11.3l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 217.4V112c0-8.8-7.2-16-16-16z"]
};
var faCalendarClock = {
  prefix: 'fal',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32 .7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V192H32V448c0 17.7 14.3 32 32 32H296.2c10 12.1 21.7 22.9 34.6 32H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zm48 384a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faCalendarTime = faCalendarClock;
var faBraille = {
  prefix: 'fal',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M64 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm160 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 256a64 64 0 1 0 128 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 160 96a64 64 0 1 0 128 0zM416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM544 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 512 96a64 64 0 1 0 128 0zM576 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM240 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faPrescriptionBottleMedical = {
  prefix: 'fal',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M336 32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H336zM48 0C21.5 0 0 21.5 0 48V80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H320V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160H32zm149.3 32c-17.7 0-32 14.3-32 32v21.3H128c-17.7 0-32 14.3-32 32v21.3c0 17.7 14.3 32 32 32h21.3V352c0 17.7 14.3 32 32 32h21.3c17.7 0 32-14.3 32-32V330.7H256c17.7 0 32-14.3 32-32V277.3c0-17.7-14.3-32-32-32H234.7V224c0-17.7-14.3-32-32-32H181.3zm0 32h21.3l0 37.3c0 8.8 7.2 16 16 16H256v21.3l-37.3 0c-8.8 0-16 7.2-16 16V352H181.3V314.7c0-8.8-7.2-16-16-16H128V277.3h37.3c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V224z"]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faPlateUtensils = {
  prefix: 'fal',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M16 16C7.2 16 0 23.2 0 32V176c0 26.5 21.5 48 48 48H64V480c0 8.8 7.2 16 16 16s16-7.2 16-16V224h16c26.5 0 48-21.5 48-48V32c0-8.8-7.2-16-16-16s-16 7.2-16 16V176c0 8.8-7.2 16-16 16H96V32c0-8.8-7.2-16-16-16s-16 7.2-16 16V192H48c-8.8 0-16-7.2-16-16V32c0-8.8-7.2-16-16-16zM498 78.9C455.3 39.8 398.4 16 336 16c-54 0-103.9 17.9-144 48v41.9C229.4 70 280.1 48 336 48c58.9 0 112 24.5 149.9 63.8c3.1-12 7.2-22.9 12.1-32.9zm24.5 269.4C488.5 416.9 417.7 464 336 464c-73.8 0-138.6-38.4-175.5-96.4c-8.5 6.5-18.3 11.3-29 14C173.7 450.2 249.5 496 336 496c98.4 0 183-59.2 220-144H544c-7.6 0-14.8-1.3-21.5-3.7zM480 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-256 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM608 54.4V288H544V160c0-61.3 39.4-92.2 64-105.6zM640 288V36.9c0-11.5-9.3-20.9-20.9-20.9c-2.1 0-4.1 .3-6.1 1C596.2 23.2 512 59.2 512 160V288c0 17.7 14.3 32 32 32h64V480c0 8.8 7.2 16 16 16s16-7.2 16-16V320 304 288z"]
};
var faFamilyPants = {
  prefix: 'fal',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h59.6c-.7 5.2-1.1 10.6-1.1 16v16H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8 .9 20.2 2.6c-1.7 6.9-2.6 14-2.6 21.4c0 3.9 .3 7.8 .8 11.6c-5.7-2.4-11.9-3.6-18.4-3.6H105.6c-25 0-45.8 19.1-47.8 44zM416 352H368V336c0-5.4-.4-10.8-1.1-16h59.6c18.7 0 33.4-16 31.9-34.7L454.2 236c-2.1-24.9-22.9-44-47.8-44H361.6c-6.5 0-12.7 1.3-18.4 3.6c.5-3.8 .8-7.7 .8-11.6c0-7.4-.9-14.6-2.6-21.4c6.5-1.7 13.3-2.6 20.2-2.6h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352zm0-288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V336c0-26.5-21.5-48-48-48zM208 413.3c-18.6-6.6-32-24.4-32-45.3V336c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H240v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V413.3z"]
};
var faHoseReel = {
  prefix: 'fal',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", "M96 256C96 132.3 196.3 32 320 32s224 100.3 224 224v96H512c-8.8 0-16 7.2-16 16s7.2 16 16 16h1.9l12 96.1c-7.8 1-13.9 7.7-13.9 15.9c0 8.8 7.2 16 16 16h1.9H544h32 14.1H592c8.8 0 16-7.2 16-16c0-8.1-6.1-14.8-13.9-15.9l12-96.1H608c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V256C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c57.6 0 110.8-19 153.6-51.2c7.1-5.3 8.5-15.3 3.2-22.4s-15.3-8.5-22.4-3.2C417 463.3 370.4 480 320 480C196.3 480 96 379.7 96 256zM573.9 384l-12 96h-3.8l-12-96H560h13.9zM464 256a144 144 0 1 1 -288 0 144 144 0 1 1 288 0zM320 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zm0 240a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z"]
};
var faHouseWindow = {
  prefix: 'fal',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM240 192c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H240zm0 32h96v96H240V224z"]
};
var faLandmark = {
  prefix: 'fal',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192H480.8c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM256 34.4L477.7 160H34.3L256 34.4zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM24 432c0 8.8 7.2 16 16 16H472c8.8 0 16-7.2 16-16s-7.2-16-16-16H40c-8.8 0-16 7.2-16 16zM0 496c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16z"]
};
var faTruck = {
  prefix: 'fal',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", "M64 32C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V64c0-17.7-14.3-32-32-32H64zm0 384c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h65.3c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zM416 224H570.9l-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6H416v96zm0 32v88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64H576V256H416zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faCrosshairs = {
  prefix: 'fal',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M256 0c8.8 0 16 7.2 16 16V48.6C374.1 56.4 455.6 137.9 463.4 240H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H463.4C455.6 374.1 374.1 455.6 272 463.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V463.4C137.9 455.6 56.4 374.1 48.6 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H48.6C56.4 137.9 137.9 56.4 240 48.6V16c0-8.8 7.2-16 16-16zM80.7 272c7.6 84.4 74.8 151.7 159.3 159.3V384c0-8.8 7.2-16 16-16s16 7.2 16 16v47.3c84.4-7.6 151.7-74.8 159.3-159.3H384c-8.8 0-16-7.2-16-16s7.2-16 16-16h47.3C423.7 155.6 356.4 88.3 272 80.7V128c0 8.8-7.2 16-16 16s-16-7.2-16-16V80.7C155.6 88.3 88.3 155.6 80.7 240H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80.7zM256 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCloudRainbow = {
  prefix: 'fal',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M284.8 196.9C337.4 98.8 440.9 32 560 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C427.8 0 313.1 74.5 255.5 183.9c7.2 4.8 13.9 10.1 20.1 16c3-1.1 6.1-2.1 9.3-3zm155.4 78.9c6 1.5 11.8 3.3 17.5 5.5c21.1-34.4 59-57.3 102.4-57.3c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-99.6 27.1-126.8 68.2c2.7 5 5 10.3 7 15.6zm-51.2-63.7C428.4 161 490.4 128 560 128c8.8 0 16-7.2 16-16s-7.2-16-16-16c-82.5 0-155.5 40.2-200.6 102.2c10.5 3.4 20.4 8.1 29.5 13.9zM96 304c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 408c0-55.2-43-100.3-97.3-103.8C407.2 258.7 367.6 224 320 224c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112c0 2.6 .1 5.3 .3 7.9C26.6 327.5 0 364.6 0 408c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104z"]
};
var faPersonCane = {
  prefix: 'fal',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M248 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 168 56zM144 164V320h64V161.2c-3.4-.8-6.9-1.2-10.5-1.2H163.3c-6.8 0-13.3 1.4-19.3 4zm-32 38.1L62.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L92.7 170.3c13.9-26 41-42.3 70.6-42.3h34.2c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8L240 183.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H144V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.2zM368 352c-8.8 0-16 7.2-16 16v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-26.5 21.5-48 48-48s48 21.5 48 48V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8-7.2-16-16-16z"]
};
var faAlien = {
  prefix: 'fal',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M224 32C118 32 32 118 32 224c0 56.2 31.2 110.7 72.2 157.4c40.4 46.1 86.7 80.4 108.6 95.4c2.8 1.9 6.6 3.2 11.2 3.2s8.4-1.3 11.2-3.2c21.9-15 68.1-49.3 108.6-95.4C384.8 334.7 416 280.2 416 224c0-106-86-192-192-192zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 135.3-148.8 247.7-194.7 279.2c-8.6 5.9-18.9 8.8-29.3 8.8s-20.7-2.9-29.3-8.8C148.8 471.7 0 359.3 0 224zm350 16H336c-29.8 0-54.9 20.4-62 48h14c29.8 0 54.9-20.4 62-48zm-14-32h32c8.8 0 16 7.2 16 16c0 53-43 96-96 96H256c-8.8 0-16-7.2-16-16c0-53 43-96 96-96zM112 240H98c7.1 27.6 32.2 48 62 48h14c-7.1-27.6-32.2-48-62-48zm96 64c0 8.8-7.2 16-16 16H160c-53 0-96-43-96-96c0-8.8 7.2-16 16-16h32c53 0 96 43 96 96z"]
};
var faTent = {
  prefix: 'fal',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", "M278.9 2.8c5.5-3.8 12.7-3.8 18.2 0L517.3 154.7c11.3 7.8 18.7 20 20.4 33.6L571.4 458c3.6 28.6-18.8 54-47.6 54H52.2C23.4 512 1 486.7 4.6 458L38.3 188.2c1.7-13.6 9.1-25.8 20.4-33.6L278.9 2.8zM76.9 181c-3.8 2.6-6.2 6.7-6.8 11.2L36.4 462c-1.2 9.5 6.3 18 15.9 18H272V46.5L76.9 181zM405.4 480L304 288.4V480H405.4zm36.2 0h82.1c9.6 0 17.1-8.4 15.9-18L505.9 192.2c-.6-4.5-3-8.6-6.8-11.2L304 46.5V220L441.6 480z"]
};
var faLaptopBinary = {
  prefix: 'fal',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M128 64H512c17.7 0 32 14.3 32 32V352h32V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H96V96c0-17.7 14.3-32 32-32zM33.9 416H606.1c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM200 128c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H200zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V168zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H304zm80 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H424c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16v48h32V288c0-8.8-7.2-16-16-16H192zm256 16c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16s7.2 16 16 16v48h32V288zm-80 24c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40v40h32V312c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40h32V312z"]
};
var faVestPatches = {
  prefix: 'fal',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M173.4 69.1l33.4 87.4-17.1 44.8L125.3 32.8c-1.7-.5-3.3-.8-4.9-.8H96c-8.8 0-16 7.2-16 16v80 58.7c0 11.6-3.2 23-9.1 32.9L36.6 276.8c-3 5-4.6 10.7-4.6 16.5V464c0 8.8 7.2 16 16 16H161.6c2.4 11.8 7.4 22.7 14.4 32H48c-26.5 0-48-21.5-48-48V293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5V128 48l0-.3C48.2 21.3 69.6 0 96 0h24.4H125c6.3 0 12.3 1.8 17.4 5.1C152.6 10 161 17.6 167.1 24.7C176 35 192.9 48 224 48s48-13 56.9-23.3C287 17.6 295.4 10 305.6 5.1C310.7 1.8 316.7 0 323 0h4.6H352c26.5 0 48 21.5 48 48v80 58.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V296.9c0-7.8 1.4-15.6 4.2-22.9L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9zM322.7 32.8L226.1 285.4c-1.4 3.6-2.1 7.5-2.1 11.4V464c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V293.3c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9V128 48c0-7.7-5.5-14.2-12.8-15.7c-1-.2-2.1-.3-3.2-.3H327.6c-1.6 0-3.2 .3-4.9 .8zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-4.7-107.3L120 257.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 280l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 302.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 280 84.7 267.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM312 240c19.6 0 35.9 14.1 39.3 32.7c18.6 3.4 32.7 19.7 32.7 39.3c0 22.1-17.9 40-40 40h-8H288c-8.8 0-16-7.2-16-16V288v-8c0-22.1 17.9-40 40-40zm-8 40v8 32h32 8c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8c-8.8 0-16-7.2-16-16v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8z"]
};
var faPeopleDressSimple = {
  prefix: 'fal',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM81.5 215.2L42.4 352H213.6L174.5 215.2C170.6 201.5 158 192 143.7 192H112.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm17.5 151.2L298.4 352H469.6L430.5 215.2C426.6 201.5 414 192 399.7 192H368.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]
};
var faCheckDouble = {
  prefix: 'fal',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M331.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 201.4 91.3 132.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l160-160zm112 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 425.4 27.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0l272-272z"]
};
var faArrowDownAZ = {
  prefix: 'fal',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M267.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm163-338.5l63.9 127.7c.1 .2 .2 .4 .3 .6l15.8 31.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L470.1 192H361.9l-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7c.1-.2 .2-.4 .3-.6L401.7 40.8c2.7-5.4 8.2-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM416 83.8L377.9 160h76.2L416 83.8zM352 288H480c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 448H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L446.7 320H352c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faBowlingBallPin = {
  prefix: 'fal',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", "M464 32c22.1 0 40 17.9 40 40v4.4c0 6.4-.8 12.8-2.3 19l-9.4 37.4c-2.2 8.9-3.6 18-4.1 27.2H439.8c-.5-9.2-1.9-18.3-4.1-27.2l-9.4-37.4c-1.6-6.2-2.3-12.6-2.3-19V72c0-22.1 17.9-40 40-40zM432.5 219c3-8.8 5-17.8 6.2-27h50.5c1.8 13.4 5.4 26.5 10.8 38.9l30.8 70.4c8.6 19.8 13.1 41.1 13.1 62.7c0 26.2-6.6 51.9-19.1 74.9L502.5 480h-77l-20.9-38.3c-6.6 9.5-13.9 18.4-21.8 26.8l16.9 31c4.2 7.7 12.3 12.5 21.1 12.5h86.5c8.8 0 16.9-4.8 21.1-12.5L553 454.2c15.1-27.7 23-58.7 23-90.2c0-26-5.4-51.7-15.8-75.5l-30.8-70.4c-6.2-14.2-9.4-29.4-9.4-44.9v-5.5c0-9.2 1.1-18.3 3.3-27.2l9.4-37.4c2.2-8.8 3.3-17.7 3.3-26.8V72c0-39.8-32.2-72-72-72s-72 32.2-72 72v4.4c0 9 1.1 18 3.3 26.8l9.4 37.4c2.2 8.9 3.3 18 3.3 27.2v3.5c9.9 14.8 18.1 30.8 24.5 47.7zM208 128a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm-8-224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBellSchoolSlash = {
  prefix: 'fal',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", "M480 208C480 93.1 386.9 0 272 0c-45.8 0-88.1 14.8-122.5 39.9l26.3 20.7C203.4 42.5 236.5 32 272 32c97.2 0 176 78.8 176 176c0 20.8-3.6 40.8-10.3 59.4L464 288.1c10.3-24.7 16-51.7 16-80.1zM96 208c0-14.9 1.8-29.3 5.3-43.1L74.2 143.5C67.6 163.8 64 185.5 64 208c0 59 24.6 112.2 64 150.1V448c0 35.3 28.7 64 64 64H336h16H480c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4H407.4c5.4-9.4 8.6-20.3 8.6-32V413.3l-32-25.3V448c0 17.7-14.3 32-32 32H336 192c-17.7 0-32-14.3-32-32V383.3C192.3 404 230.8 416 272 416c39.8 0 77-11.2 108.6-30.6L353.5 364c-24.4 12.8-52.1 20-81.5 20c-97.2 0-176-78.8-176-176zm176-80c-3.4 0-6.8 .2-10.1 .6l89.6 70.7C347.2 159.2 313.3 128 272 128zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faPlusLarge = {
  prefix: 'fal',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 224L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0 0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224 224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0 0-224z"]
};
var faMoneyBillWheat = {
  prefix: 'fal',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M224 80v5.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3zM160 16V40c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80v-8V104 80c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm16 96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM336 85.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3v5.3zM288 0c-8.8 0-16 7.2-16 16V40c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80v-8V104 80c0-44.2-35.8-80-80-80zM448 80v5.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3zM384 16V40c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80v-8V104 80c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM304 189.3V184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3zM192 184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3V184zm224 5.3V184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3zM480 304v32c-26.5 0-48-21.5-48-48h32c8.8 0 16 7.2 16 16zM32 368c44.2 0 80-35.8 80-80H400c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80V368zM432 480c0-26.5 21.5-48 48-48v32c0 8.8-7.2 16-16 16H432zM32 432c26.5 0 48 21.5 48 48H48c-8.8 0-16-7.2-16-16V432zM80 288c0 26.5-21.5 48-48 48V304c0-8.8 7.2-16 16-16H80zM48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faCameraViewfinder = {
  prefix: 'fal',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M0 48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C21.5 0 0 21.5 0 48zM216.6 96c-16.7 0-31.6 10.3-37.5 26l-2.3 6H152c-30.9 0-56 25.1-56 56V328c0 30.9 25.1 56 56 56H360c30.9 0 56-25.1 56-56V184c0-30.9-25.1-56-56-56H335.1l-2.3-6C327 106.3 312 96 295.4 96H216.6zm-7.5 37.2c1.2-3.1 4.2-5.2 7.5-5.2h78.7c3.3 0 6.3 2.1 7.5 5.2l6.2 16.4c2.3 6.2 8.3 10.4 15 10.4h36c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24h36c6.7 0 12.6-4.1 15-10.4l6.2-16.4zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM464 0H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zm464 48c26.5 0 48-21.5 48-48V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96z"]
};
var faScreenshot = faCameraViewfinder;
var faMessageMusic = {
  prefix: 'fal',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM345.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V155.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V96c0-5.2-2.6-10.2-6.9-13.2zM320 244c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 276c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faCommentAltMusic = faMessageMusic;
var faCarBuilding = {
  prefix: 'fal',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", "M64 32H288c17.7 0 32 14.3 32 32V165.2c9.4-7.6 20.3-13.4 32-17V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H224V448H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM264 192H216c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h41.6c3.7-3.7 7.7-7.1 11.9-10.2l18.3-64.2C286.7 201.5 276.5 192 264 192zM88 64C74.7 64 64 74.7 64 88v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H88zm8 64V96h32v32H96zm96-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zm32 8h32v32H224V96zM88 192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H88zm8 64V224h32v32H96zm128-32h32v32H224V224zM88 320c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H88zm8 64V352h32v32H96zM380.2 208H515.8c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0H336c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H380.2c-28.6 0-53.7 18.9-61.5 46.4zM608 416v16H288V416 368c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48v48zM336 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBorderBottomRight = {
  prefix: 'fal',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 17.7-14.3 32-32 32L32 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c35.3 0 64-28.7 64-64l0-352zM320 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faBorderStyleAlt = faBorderBottomRight;
var faOctagon = {
  prefix: 'fal',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M163.2 43.8c7.5-7.5 17.7-11.7 28.3-11.7h129c10.6 0 20.8 4.2 28.3 11.7L468.2 163.2c7.5 7.5 11.7 17.7 11.7 28.3v129c0 10.6-4.2 20.8-11.7 28.3L348.8 468.2c-7.5 7.5-17.7 11.7-28.3 11.7h-129c-10.6 0-20.8-4.2-28.3-11.7L43.8 348.8 21.2 371.4l22.6-22.6c-7.5-7.5-11.7-17.7-11.7-28.3v-129c0-10.6 4.2-20.8 11.7-28.3L163.2 43.8zM.1 320.5c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1h-129c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5v129z"]
};
var faCommentArrowUpRight = {
  prefix: 'fal',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM192 152c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L172.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 206.6V296c0 8.8 7.2 16 16 16s16-7.2 16-16V168c0-8.8-7.2-16-16-16H192z"]
};
var faOctagonDivide = {
  prefix: 'fal',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6L163.2 468.2c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7L468.2 348.8c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 240H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCookie = {
  prefix: 'fal',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M242.7 48.7c-15.4-2.2-31.1 .6-44.8 7.9l-74 39.5C110.1 103.4 99.1 115 92.2 129L55.5 204.6c-6.8 14.1-9.1 30-6.4 45.4l14.5 82.8c2.7 15.4 10.2 29.6 21.4 40.4l60.3 58.4c11.2 10.9 25.5 17.9 40.9 20l83 11.7c15.4 2.2 31.1-.6 44.8-7.9l74-39.5c13.7-7.3 24.8-18.8 31.7-32.9l36.7-75.5c6.8-14.1 9.1-30 6.4-45.4l-14.6-82.8c-2.7-15.4-10.2-29.6-21.4-40.4L366.6 80.5c-11.2-10.9-25.5-17.9-40.9-20l-83-11.7zM182.8 28.4c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1 .7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5c-19.7 10.5-42.3 14.5-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7L62.8 396.2C46.8 380.6 36 360.3 32.2 338.3L17.6 255.5c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM160 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faArrowRotateLeft = {
  prefix: 'fal',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M48 192c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v92.6C103.2 75.5 174.5 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-79.9 0-150-41.8-189.7-104.8C59.8 364.8 67.7 352 80 352c6 0 11.4 3.2 14.7 8.2C128.9 413 188.4 448 256 448c106 0 192-86 192-192s-86-192-192-192c-71.1 0-133.1 38.6-166.3 96H176c8.8 0 16 7.2 16 16s-7.2 16-16 16H48z"]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faTvMusic = {
  prefix: 'fal',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", "M576 32c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H576zM64 0C28.7 0 0 28.7 0 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 496c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM409.1 98.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V171.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V112c0-5.2-2.6-10.2-6.9-13.2zM384 260c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM256 292c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faHardDrive = {
  prefix: 'fal',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", "M64 64C46.3 64 32 78.3 32 96V264.6c9.4-5.4 20.3-8.6 32-8.6H448c11.7 0 22.6 3.1 32 8.6V96c0-17.7-14.3-32-32-32H64zM32 320v96c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm320 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHdd = faHardDrive;
var faReel = {
  prefix: 'fal',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M0 16C0 7.2 7.2 0 16 0H80 368h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V32H16C7.2 32 0 24.8 0 16zM96 32V80H352V32H96zM64 160c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V416c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H368 80 16zm80-80v48H352V432H96z"]
};
var faFaceGrinSquintTears = {
  prefix: 'fal',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", "M421 91.1c1.3-6.5 2.8-13.3 4.5-19.8c2.3-9.2 4.9-17.3 7.5-23.6c2.3-5.7 4-8.1 4.4-8.7c.1-.1 .1-.2 0-.1c9-9 24.7-9.5 35 .9s9.8 26 .9 35c.1-.1 0 0-.1 0c-.5 .4-3 2-8.7 4.4c-6.4 2.6-14.5 5.1-23.6 7.5c-6.6 1.7-13.3 3.2-19.8 4.5zm-36.9 26c-1 6.4 4.4 11.8 10.8 10.8c25.8-3.5 84-13.6 100.9-30.5c22-22 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9c-16.9 16.9-26.9 75.2-30.5 100.9zM32 256C32 132.3 132.3 32 256 32c31.4 0 61.2 6.4 88.3 18.1c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21C325.9 7.4 291.8 0 256 0C114.6 0 0 114.6 0 256c0 36.4 7.6 71 21.3 102.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C38.7 318.2 32 287.9 32 256zM490.7 153.6c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c12 27.4 18.6 57.7 18.6 89.6c0 123.7-100.3 224-224 224c-32.4 0-63.1-6.9-90.9-19.2c-8.1-3.6-17.5 0-21.1 8.1s0 17.5 8.1 21.1c31.8 14.1 66.9 22 103.9 22c141.4 0 256-114.6 256-256c0-36.4-7.6-71-21.3-102.4zM325.4 325.4c22.1-22 41.4-45.4 57.7-69.5c.7 32.6-11.4 65.6-36.5 90.7s-58 37.2-90.7 36.5c24-16.3 47.4-35.6 69.5-57.7zm79.3-122.7c-4.6-11.9-20.6-11.1-26.7 .2c-18.5 34.3-43.8 68.4-75.2 99.8s-65.5 56.7-99.8 75.2c-11.3 6.1-12.2 22.1-.2 26.7c55.6 21.5 121.4 9.7 166.5-35.5s57-110.9 35.5-166.5zM104.8 284c2.8 8.4 11.9 12.9 20.2 10.1l37.5-12.5L150 319.1c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1L203 261.3c1.9-5.7 .4-12.1-3.9-16.4s-10.6-5.8-16.4-3.9l-67.9 22.6c-8.4 2.8-12.9 11.9-10.1 20.2zM294.1 125c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-22.6 67.9c-1.9 5.7-.4 12.1 3.9 16.4s10.6 5.8 16.4 3.9l67.9-22.6c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-37.5 12.5L294.1 125zM71.2 425.4c6.6-1.7 13.3-3.2 19.8-4.5c-1.3 6.5-2.8 13.3-4.5 19.8c-2.3 9.2-4.9 17.3-7.5 23.6c-2.3 5.7-4 8.1-4.4 8.7c-.1 .1-.1 .1 0 .1c-9 9-24.7 9.5-35-.9s-9.8-26-.9-35c-.1 .1 0 0 .1 0c.5-.4 3-2 8.7-4.4c6.4-2.6 14.5-5.1 23.6-7.5zm45.9-41.3c-25.8 3.5-84 13.6-100.9 30.5c-22 22-21.5 57.9 .9 80.3s58.3 22.8 80.3 .9c16.9-16.9 26.9-75.2 30.5-100.9c1-6.4-4.4-11.8-10.8-10.8z"]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faDumbbell = {
  prefix: 'fal',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M208 64c8.8 0 16 7.2 16 16V256 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V368 144 80c0-8.8 7.2-16 16-16h32zM128 413.3V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272H384V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V413.3c5 1.8 10.4 2.7 16 2.7h32c26.5 0 48-21.5 48-48V272h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V144c0-26.5-21.5-48-48-48H528c-5.6 0-11 1-16 2.7V80c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48V240H256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48V98.7C123 97 117.6 96 112 96H80c-26.5 0-48 21.5-48 48v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v96c0 26.5 21.5 48 48 48h32c5.6 0 11-1 16-2.7zM512 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V256 368c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V144zM480 368v64c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64V368zM128 144V368c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V256 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"]
};
var faRectangleList = {
  prefix: 'fal',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faListAlt = faRectangleList;
var faTarpDroplet = {
  prefix: 'fal',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", "M328 113.5l0 0s0 0 0 0c0-.1-.1-1.1-.6-3.1c-.6-2.3-1.7-5.3-3.2-8.9c-3.2-7.4-7.9-16-13.7-25.3c-7-11.3-15-22.6-22.4-32.6c-7.4 10-15.4 21.3-22.4 32.6c-5.8 9.3-10.5 17.9-13.7 25.3c-1.6 3.6-2.6 6.6-3.2 8.9c-.5 2-.6 3-.6 3.1c0 0 0 0 0 0l0 0c0 17.7 15.9 35.5 40 35.5s40-17.8 40-35.5zm32 0c0 37.3-32.2 67.5-72 67.5s-72-30.2-72-67.5c0-27.7 39.7-81.3 60.2-107c6.1-7.7 17.5-7.7 23.7 0c20.4 25.7 60.2 79.3 60.2 107zM64 128H193.3c1.9 11.5 5.9 22.3 11.5 32L64 160c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l320 0 0-112c0-26.5 21.5-48 48-48H544V192c0-17.7-14.3-32-32-32H371.2c5.6-9.7 9.6-20.5 11.5-32H512c35.3 0 64 28.7 64 64V348.1c0 12.7-5.1 24.9-14.1 33.9L446.1 497.9c-9 9-21.2 14.1-33.9 14.1L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM423.4 475.3L539.3 359.4c2.1-2.1 3.5-4.6 4.2-7.4H432c-8.8 0-16 7.2-16 16l0 111.5c2.8-.7 5.4-2.1 7.4-4.2zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAlarmExclamation = {
  prefix: 'fal',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5c4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1c6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zM357.1 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6 .8C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3c-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 64c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHouseMedicalCircleCheck = {
  prefix: 'fal',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H394.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240H336V208c0-17.7-14.3-32-32-32H272c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm128 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faTrafficCone = {
  prefix: 'fal',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M248.2 32h15.5c3.3 0 6.2 2 7.4 5l49.2 123H191.6L240.8 37c1.2-3 4.2-5 7.4-5zm84.9 160l51.2 128H127.6l51.2-128H333.2zm64 160l51.2 128H63.6l51.2-128H397.2zM211.1 25.1L29.2 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H482.8L300.9 25.1C294.8 10 280.1 0 263.8 0H248.2c-16.4 0-31.1 10-37.1 25.1z"]
};
var faGrate = {
  prefix: 'fal',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 0h56 72 72 56c17.7 0 32 14.3 32 32V256 384c0 17.7-14.3 32-32 32H296 224 152 96c-17.7 0-32-14.3-32-32V256 128c0-17.7 14.3-32 32-32zm0 32V240h40V128H96zm72 112h40V128H168V240zm72 0h40V128H240V240zm72 0h40V128H312V240zm0 32V384h40V272H312zm-32 0H240V384h40V272zm-72 0H168V384h40V272zm-72 0H96V384h40V272z"]
};
var faArrowDownRight = {
  prefix: 'fal',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", "M336 416c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V361.4L59.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H336z"]
};
var faPersonSkiingNordic = {
  prefix: 'fal',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", "M320 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 288 56a56 56 0 1 0 112 0zM243.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L117.5 180c-6.7 5.8-7.3 15.9-1.5 22.6c1.5 1.7 3.3 3.1 5.3 4L64.3 476.7c-.2 1.1-.3 2.2-.3 3.3H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H143.7c.2 0 .4 0 .6 0H303.6c.2 0 .5 0 .7 0H512c35.3 0 64-28.7 64-64V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 17.7-14.3 32-32 32H432.2l29.5-192H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H448.2h-.5H408.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zM96.4 480L158 187l32.9-28.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L217.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L292.7 480H167.2l52.9-139.2c-10.2-6.4-18.6-14.9-24.8-24.7L133 480H96.4zm303.8-2.4c-.1 .8-.2 1.6-.2 2.4H326.6l36-102c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L362 253.2c5.9 20.6 24.7 34.8 46.2 34.8h21.2L400.2 477.6zM326.4 170.1L282.3 302.4 254.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7z"]
};
var faSkiingNordic = faPersonSkiingNordic;
var faCalendarPlus = {
  prefix: 'fal',
  iconName: 'calendar-plus',
  icon: [512, 512, [], "f271", "M144 0c8.8 0 16 7.2 16 16V64H352V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zM448 192H64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192zM416 96H96c-17.7 0-32 14.3-32 32v32H448V128c0-17.7-14.3-32-32-32zM352 336c0 8.8-7.2 16-16 16H272v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V256c0-8.8 7.2-16 16-16s16 7.2 16 16v64h64c8.8 0 16 7.2 16 16z"]
};
var faPersonFromPortal = {
  prefix: 'fal',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", "M128 256c0 37.2-1.4 69-3.9 96h32.1c2.5-27.7 3.8-59.6 3.8-96c0-17-.3-33-.8-48c4 .2 8.1-1.1 11.4-3.9l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L249.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L320.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L394 253.2c5.9 20.6 24.7 34.8 46.2 34.8H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H440.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4l-44.6 39C148.1 46.7 117 0 80 0C35.8 0 0 66.6 0 256S35.8 512 80 512c23.3 0 44.3-18.6 59-64H105c-12.3 32-23.5 32-25 32h0 0c-1.6 0-13.6 0-26.4-35.8C40.9 409.1 32 349.5 32 256s8.9-153.1 21.5-188.2C66.4 32 78.4 32 80 32l0 0 0 0c1.6 0 13.6 0 26.4 35.8C119.1 102.9 128 162.5 128 256zM352 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 320 56a56 56 0 1 0 112 0zM358.4 170.1L314.3 302.4 286.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1L197.3 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4z"]
};
var faPortalExit = faPersonFromPortal;
var faPlaneArrival = {
  prefix: 'fal',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", "M253.3 32c5.8 0 11.1 3.1 13.9 8.2L388.5 255.7c2.1 3.7 5.6 6.4 9.7 7.6l91.5 25.4c15.9 4.4 30.7 12.3 43.2 23.2l26.7 23.1c11.5 9.9 6.7 28.7-8.1 32c-27.1 6-55.3 5.1-82-2.5L170.5 279.5c-1.8-.5-3.5-1.3-5-2.4L70.9 208.7c-4.2-3-6.6-7.8-6.6-12.9L64 100l34.2 7.6c5.7 1.3 10.2 5.5 11.9 11l18.6 62c1.6 5.3 5.7 9.3 11 10.8l101.8 28.3c5.6 1.6 11.6 0 15.6-4.1s5.6-10.1 4-15.7L213.2 32l40.1 0zm41.8-7.5C286.6 9.4 270.6 0 253.3 0H213.2C192 0 176.6 20.3 182.4 40.8l40.1 140.4-65.8-18.3-16.1-53.6c-5-16.6-18.6-29.3-35.6-33.1L71 68.7C51 64.3 32 79.5 32 100l.2 95.8c0 15.4 7.4 29.8 19.9 38.8L146.8 303c4.5 3.3 9.6 5.7 15 7.3l4.4-15.4-4.4 15.4 298.8 84.9c31.8 9 65.4 10 97.7 2.9c40.6-8.9 53.6-60.3 22.1-87.5l-26.7-23.1c-16.1-13.9-35.1-24.1-55.6-29.8l-85.1-23.7L295.1 24.5zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM176 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCowbellCirclePlus = {
  prefix: 'fal',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M176 32h96c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H262.6c-2.9-10.3-4.9-21-5.9-32H48c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6h32H304h32c7.1 0 13.4 4.7 15.4 11.6l18.2 63.8c9.9-3.7 20.2-6.6 30.8-8.6l-18.3-64C376.3 110.2 357.4 96 336 96H320V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zM256 448c0 17.7-14.3 32-32 32s-32-14.3-32-32H160c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6H256zm64-80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faCowbellMore = faCowbellCirclePlus;
var faCircleLeft = {
  prefix: 'fal',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-400 0c0 9.2 3.5 18 9.7 24.7l84 91c7.2 7.8 17.4 12.3 28.1 12.3c21.1 0 38.3-17.1 38.3-38.3l0-25.7 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-25.7c0-21.1-17.1-38.3-38.3-38.3c-10.7 0-20.9 4.5-28.1 12.3l-84 91c-6.2 6.7-9.7 15.6-9.7 24.7zm33.2 3c-.8-.8-1.2-1.9-1.2-3s.4-2.2 1.2-3l84-91c1.2-1.3 2.9-2 4.6-2c3.5 0 6.3 2.8 6.3 6.3l0 41.7c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16l0 41.7c0 3.5-2.8 6.3-6.3 6.3c-1.7 0-3.4-.7-4.6-2l-84-91z"]
};
var faArrowAltCircleLeft = faCircleLeft;
var faDistributeSpacingVertical = {
  prefix: 'fal',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M512 464c0-8.8-7.2-16-16-16L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16zM144 320c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-224 0zm224 32c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l224 0zM496 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l480 0z"]
};
var faSignalBarsFair = {
  prefix: 'fal',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", "M240 288c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V304zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]
};
var faSignalAlt2 = faSignalBarsFair;
var faSportsball = {
  prefix: 'fal',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M436.9 52.4l-94.2 94.3c-23.7-27.4-41-60.6-49.2-97.2c41.2-5.3 88.7-4.8 143.5 2.9zM261.9 55c9.5 43.2 29.8 82.4 58.1 114.4l-64 64L138.4 115.8c22.2-19.9 49.1-36.6 81.6-48.7c13-4.8 27-8.9 41.9-12.2zM116.1 138.8L233.4 256l-64 64c-31.6-27.9-70.2-48.1-112.7-57.7c7.5-32.2 19.3-63.5 36.7-92c6.7-11 14.3-21.6 22.8-31.6zm-65.5 155c36.1 8.4 68.9 25.4 96 48.9L52.2 437.2c-6.9-42.8-8.9-93.2-1.5-143.4zM75 459.6l94.3-94.3c23.7 27.4 41 60.6 49.2 97.2c-41.2 5.3-88.7 4.8-143.5-2.9zm175-2.5c-9.5-43.2-29.8-82.4-58.1-114.4l64-64L373.6 396.2c-22.2 19.9-49.1 36.6-81.6 48.7c-13 4.8-27 8.9-41.9 12.2zm145.8-83.8L278.6 256l64-64c31.6 27.9 70.2 48.1 112.8 57.7c-7.5 32.2-19.3 63.5-36.7 92c-6.7 11-14.3 21.6-22.8 31.6zm65.5-155c-36.1-8.4-68.9-25.5-96-48.9l94.5-94.5c6.9 42.8 8.9 93.2 1.5 143.4zm.2-194.4c-103.9-17.4-187-11-252.6 13.3C142.9 61.6 96.7 103.6 66 153.6C5.8 251.8 6.9 378.3 24.4 463.1c2.7 12.9 13 22.9 26.1 25.1c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5c-2.7-12.9-13-22.9-26.1-25.1z"]
};
var faGameConsoleHandheldCrank = {
  prefix: 'fal',
  iconName: 'game-console-handheld-crank',
  icon: [576, 512, [], "e5b9", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V272 96c0-17.7-14.3-32-32-32H64zM448 96V256h32V208 160c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H512v48c0 8.8-7.2 16-16 16H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64zM96 128V256H352V128H96zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zm448 64h32V160H512v32zM128 336v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTrainSubway = {
  prefix: 'fal',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M208 32l0 192H32V96c0-35.3 28.7-64 64-64H208zm32 0H352c35.3 0 64 28.7 64 64V224H240l0-192zM32 352V256H416v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96V352c0 46 32.4 84.4 75.6 93.8L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L118.6 448H329.4l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352V96c0-53-43-96-96-96H96zm24 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm232-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSubway = faTrainSubway;
var faChartGantt = {
  prefix: 'fal',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm80 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceSmileUpsideDown = {
  prefix: 'fal',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM164.1 186.5C182 165.8 212.6 144 256 144s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6s7.4-15.9 1.6-22.6C349.8 139.9 311.1 112 256 112s-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6zM200.4 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faBallPile = {
  prefix: 'fal',
  iconName: 'ball-pile',
  icon: [576, 512, [], "f77e", "M352 96A64 64 0 1 0 224 96a64 64 0 1 0 128 0zm-35.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 416A64 64 0 1 0 32 416a64 64 0 1 0 128 0zm224-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faBadgeDollar = {
  prefix: 'fal',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm16.9 140.4c0-8.8-7.2-16-16-16s-16 7.2-16 16v20.8c-9.5 1.5-19.2 4.6-27.7 9.7c-14.1 8.3-25.7 22.7-25.6 43.4c.1 19.6 11.4 32.1 24.4 39.9c11.5 6.9 26.1 11.3 38.4 15l1.7 .5c13.8 4.2 24.8 7.7 32.7 12.6c6.9 4.3 9.3 8.4 9.4 14.3c.1 8.1-3.4 13.2-9.5 17c-6.8 4.3-16.9 6.5-27.3 6.2c-13.4-.4-25.8-4.7-40.9-9.8l0 0 0 0c-2.5-.9-5.2-1.8-7.9-2.7c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2.2 .7 4.6 1.5 6.9 2.4c10.6 3.7 22.7 7.8 35.4 10.1v21.3c0 8.8 7.2 16 16 16s16-7.2 16-16V351c10-1.5 20-4.6 28.7-10.1c14.3-8.9 24.9-23.9 24.6-44.6c-.3-19.8-11.3-32.7-24.4-41c-12-7.6-27.4-12.2-40-16l-.4-.1c-13.9-4.2-25-7.6-32.8-12.3c-6.9-4.2-8.9-7.8-8.9-12.7c0-6.8 3.2-11.8 9.9-15.7c7.3-4.3 17.5-6.5 27.1-6.4c11.4 .2 23.7 2.7 36.1 6c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.7-2.3-18.3-4.5-28.1-5.8V140.4z"]
};
var faMoneyBillsSimple = {
  prefix: 'fal',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", "M576 64c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H576zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 61.9 50.1 112 112 112H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V112z"]
};
var faMoneyBillsAlt = faMoneyBillsSimple;
var faListTimeline = {
  prefix: 'fal',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M213.3 128H416V64L213.3 64l-32 32 32 32zM190.6 41.4c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm181.3 32H416V384H213.3l-32 32 32 32zm-22.6-86.6c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM181.3 256l32 32H480V224l-266.7 0-32 32zm-33.9-11.3l43.3-43.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faIndianRupeeSign = {
  prefix: 'fal',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 48c0-8.8 7.2-16 16-16h96H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H202.5c28.7 23.2 48.3 57.3 52.6 96H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H255.1c-8 72-69 128-143.1 128H65.9L249.3 451c7.2 5.1 8.9 15.1 3.7 22.3s-15.1 8.9-22.3 3.7L6.7 317C1 313-1.4 305.7 .8 299.1S9 288 16 288h96c56.4 0 103.1-41.7 110.9-96H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H222.9c-7.8-54.3-54.4-96-110.9-96H16C7.2 64 0 56.8 0 48z"]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faCropSimple = {
  prefix: 'fal',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96V368c0 26.5 21.5 48 48 48H352V384H144c-8.8 0-16-7.2-16-16V16zM384 496c0 8.8 7.2 16 16 16s16-7.2 16-16V416h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H416l0-240c0-26.5-21.5-48-48-48L160 96v32l208 0c8.8 0 16 7.2 16 16l0 352z"]
};
var faCropAlt = faCropSimple;
var faMoneyBill1 = {
  prefix: 'fal',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", "M512 96c17.7 0 32 14.3 32 32v32c-35.3 0-64-28.7-64-64h32zM128 96H448c0 53 43 96 96 96V320c-53 0-96 43-96 96H128c0-53-43-96-96-96V192c53 0 96-43 96-96zM32 352c35.3 0 64 28.7 64 64H64c-17.7 0-32-14.3-32-32V352zm448 64c0-35.3 28.7-64 64-64v32c0 17.7-14.3 32-32 32H480zM96 96c0 35.3-28.7 64-64 64V128c0-17.7 14.3-32 32-32H96zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM256 208c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm-64 48a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faMoneyBillAlt = faMoneyBill1;
var faLeftLong = {
  prefix: 'fal',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", "M160 328l0 49.3c0 3.7-3 6.7-6.7 6.7c-1.9 0-3.7-.8-5-2.2L35.8 256 148.3 130.2c1.3-1.4 3.1-2.2 5-2.2c3.7 0 6.7 3 6.7 6.7l0 49.3c0 17.7 14.3 32 32 32l272 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-272 0c-17.7 0-32 14.3-32 32zM5.3 242C1.9 245.9 0 250.8 0 256s1.9 10.1 5.3 14L124.5 403.1c7.3 8.2 17.8 12.9 28.8 12.9c21.4 0 38.7-17.3 38.7-38.7l0-17.3 0-32 32 0 240 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-240 0-32 0 0-32 0-17.3c0-21.4-17.3-38.7-38.7-38.7c-11 0-21.5 4.7-28.8 12.9L5.3 242z"]
};
var faLongArrowAltLeft = faLeftLong;
var faKeyboardDown = {
  prefix: 'fal',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M64 32C46.3 32 32 46.3 32 64V224c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm184 8h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zM72 184c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V184zM88 72h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zM264 88c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V88zM376 72h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H376c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V88zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V184c0-8.8 7.2-16 16-16zM160 192c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zM288 473.4L404.7 356.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 473.4z"]
};
var faCircleUpRight = {
  prefix: 'fal',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm80 184c0-4.4-3.6-8-8-8H214.6c-3.7 0-6.6 3-6.6 6.6c0 1.8 .7 3.4 1.9 4.7l25.4 25.4c6.2 6.2 6.2 16.4 0 22.6l-59.1 59.1c-3.6 3.6-4.9 9-3.3 13.9c.7 2 1.8 3.8 3.3 5.3l22.1 22.1c1.5 1.5 3.3 2.6 5.3 3.3c4.9 1.6 10.3 .4 13.9-3.3l59.1-59.1c6.2-6.2 16.4-6.2 22.6 0l25.4 25.4c1.2 1.2 2.9 1.9 4.7 1.9c3.7 0 6.6-3 6.6-6.6V184zm-8-40c22.1 0 40 17.9 40 40V297.4c0 21.3-17.3 38.6-38.6 38.6c-10.2 0-20.1-4.1-27.3-11.3L288 310.6l-47.7 47.7c-12.2 12.2-30.3 16.5-46.7 11c-6.7-2.2-12.8-6-17.8-11l-22.1-22.1c-5-5-8.8-11.1-11-17.8c-5.5-16.4-1.2-34.5 11-46.7L201.4 224l-14.1-14.1c-7.2-7.2-11.3-17.1-11.3-27.3c0-21.3 17.3-38.6 38.6-38.6H328z"]
};
var faCloudBoltMoon = {
  prefix: 'fal',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", "M387.7 101.7c7.9-27.6 28-50.1 54.2-61.6c-12.8 19-20.3 41.8-20.3 66.3c0 53.9 35.9 99.2 85.1 114.2c-8.2 2.2-16.7 3.4-25.6 3.4c-4.2 0-8.3-.3-12.4-.8c4.9 10.2 8.3 21.2 10 32.8c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9c9.8 5.9 18.7 13.3 26.3 21.8zM112 160c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H343c5.7 8.5 9 18.7 9 29.7c0 .8 0 1.5-.1 2.3h13.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 82.6 210.9 64 176 64c-53 0-96 43-96 96l0 1.3C34.6 168.9 0 208.4 0 256c0 46.9 33.6 85.9 78 94.3c.9-1 1.8-1.9 2.7-2.8l29.1-27.6H98.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 216l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H143.7zM265.6 224c-5.1 0-10.1 2-13.8 5.5L102.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H167l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L313.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H249l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faThunderstormMoon = faCloudBoltMoon;
var faDna = {
  prefix: 'fal',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", "M400 0c8.8 0 16 7.2 16 16c0 120.2-94.2 188.6-179.7 250.9l-2.8 2.1c-37.8 27.5-73.9 54-102.9 83.1h187c-19.8-19.8-42.8-38.4-67.5-57c3.2-2.3 6.4-4.6 9.7-6.9c5.9-4.2 11.7-8.4 17.6-12.7C349.4 330.4 416 394.9 416 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.5-.2-10.8-.7-16H64.7c-.4 5.2-.7 10.5-.7 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-113.2 83.6-180.5 164.8-240C115.6 196.5 32 129.2 32 16C32 7.2 39.2 0 48 0s16 7.2 16 16c0 5.5 .2 10.8 .7 16H383.3c.4-5.2 .7-10.5 .7-16c0-8.8 7.2-16 16-16zM377.6 64H70.4c6.5 23.4 17.6 44.5 32.2 64H345.5c14.6-19.5 25.7-40.6 32.2-64zm-60.1 96h-187c26.6 26.7 59.1 51.1 93.5 76.2c34.4-25.1 66.9-49.5 93.5-76.2zM70.4 448H377.6c-6.5-23.5-17.6-44.5-32.2-64.1c-.5 0-.9 .1-1.4 .1H104c-.5 0-.9 0-1.4-.1C88 403.5 76.8 424.5 70.4 448z"]
};
var faVirusSlash = {
  prefix: 'fal',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M532.5 288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 36.4-32.2 59.6-63.3 55.7L259.9 127C293.3 115.8 320 85.2 320 43.5c0 78.4 94.8 117.7 150.2 62.2C414.8 161.2 454.1 256 532.5 256c-29.1 0-52.8 13-68.3 32.3l25.1 19.9c9.9-12 24.8-20.1 43.1-20.1zM107.5 256c29.1 0 52.8-13 68.3-32.3l-25.1-19.9c-9.9 12-24.8 20.1-43.1 20.1H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-36.4 32.2-59.6 63.3-55.7L380.1 385c-33.4 11.2-60.1 41.8-60.1 83.4c0-78.4-94.8-117.6-150.2-62.2C225.2 350.8 185.9 256 107.5 256zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faBracketRoundRight = {
  prefix: 'fal',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M33.9 40.4c-4.2 7.8-1.3 17.5 6.4 21.7C80.5 83.8 160 153.4 160 256s-79.5 172.2-119.6 193.9c-7.8 4.2-10.7 13.9-6.4 21.7s13.9 10.7 21.7 6.4C100.8 453.6 192 375.3 192 256S100.8 58.4 55.6 33.9c-7.8-4.2-17.5-1.3-21.7 6.4z"]
};
var faCircleSterling = {
  prefix: 'fal',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM259.6 144c-20.2 0-36.5 16.5-36.4 36.7l.3 43.3H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H223.6c-.9 22.5-7.1 44.4-18 64H328c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-5.9 0-11.4-3.3-14.2-8.5s-2.4-11.6 1-16.5l9.2-13.5c11.7-17 18.4-36.9 19.5-57.5H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h15.5l-.3-43.1c-.3-38 30.4-68.9 68.4-68.9c10.6 0 21.1 2.5 30.6 7.2l20.9 10.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-20.9-10.5c-5.1-2.5-10.6-3.8-16.3-3.8z"]
};
var faCircle5 = {
  prefix: 'fal',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128c-7.3 0-13.7 5-15.5 12.1l-24 96c-1.1 4.5-.2 9.3 2.4 13.1s6.9 6.3 11.5 6.7l98.8 10c22.1 2.2 38.8 20.8 38.8 42.9c0 23.8-19.3 43.2-43.2 43.2h-44c-16.8 0-32.4-8.3-41.8-22.3l-1.8-2.7c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2l1.8 2.7c15.3 22.8 40.9 36.4 68.3 36.4h44c41.5 0 75.2-33.7 75.2-75.2c0-38.6-29.2-70.9-67.6-74.8L204 225.9 220.5 160H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faMinus = {
  prefix: 'fal',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"]
};
var faSubtract = faMinus;
var faFireFlame = {
  prefix: 'fal',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4C125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM187.4 206v.6c0 16.1 6.3 31.6 17.5 43.3l8.2 8.5c9.9 10.3 15.5 24.1 15.5 38.4c0 30.5-24.7 55.3-55.3 55.3h-2.5c-31.9 0-57.7-25.8-57.7-57.7V272.1c-11 12.2-17.1 28.1-17.1 44.7V320c0 53 43 96 96 96h7.3c49 0 88.7-39.7 88.7-88.7c0-27.9-12.2-54.3-33.4-72.4l-44.6-38.1c-9.7-8.3-16.4-19.6-19-31.9c-2.4 6.8-3.6 13.9-3.6 21.1zm9.9-78c13.5 0 24.4 10.9 24.4 24.4v20.2c0 7.6 3.3 14.9 9.1 19.8l44.6 38.1c28.3 24.2 44.6 59.5 44.6 96.7C320 393.9 265.9 448 199.3 448H192c-70.7 0-128-57.3-128-128v-3.2c0-27.9 11.8-54.6 32.6-73.3l5.3-4.8c4.8-4.3 10.9-6.7 17.4-6.7c14.3 0 25.9 11.6 25.9 25.9v36.4c0 14.2 11.5 25.7 25.7 25.7h2.5c12.8 0 23.3-10.4 23.3-23.3c0-6-2.3-11.8-6.5-16.1l-8.2-8.5c-17-17.6-26.4-41.1-26.4-65.5V206c0-13.9 3-27.6 8.9-40.2l10.9-23.6c4-8.6 12.6-14.1 22.1-14.1z"]
};
var faFlame = faFireFlame;
var faRightToLine = {
  prefix: 'fal',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", "M416 80l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352c0-8.8-7.2-16-16-16s-16 7.2-16 16zM319.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L187.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16L40 304c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L319.2 254.2zM352 256c0-9.5-3.9-18.6-10.8-25.1L209.2 106.5C202 99.8 192.5 96 182.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3L40 176c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.3-3.8 26.5-10.5L341.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1z"]
};
var faArrowAltToRight = faRightToLine;
var faGif = {
  prefix: 'fal',
  iconName: 'gif',
  icon: [576, 512, [], "e190", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm48 16v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM128 256c0-35.3 28.7-64 64-64c14.4 0 27.7 4.8 38.4 12.8c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4c-16-12.1-36-19.2-57.6-19.2c-53 0-96 43-96 96s43 96 96 96c21.6 0 41.6-7.1 57.6-19.2c4-3 6.4-7.8 6.4-12.8V256c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v39.4c-9.4 5.4-20.3 8.6-32 8.6c-35.3 0-64-28.7-64-64z"]
};
var faChess = {
  prefix: 'fal',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H52.6C41.2 96 32 105.2 32 116.6c0 2.2 .4 4.4 1.1 6.5L66.7 224H56c-8.8 0-16 7.2-16 16s7.2 16 16 16H69.8L56.7 352H89l13.1-96h51.8L167 352h32.3l-13.1-96H200c8.8 0 16-7.2 16-16s-7.2-16-16-16H189.3l33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5c0-11.4-9.2-20.6-20.6-20.6H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zm11.6 208H100.4l-32-96H128h59.6l-32 96zm34.6 160H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6C0 494.3 17.7 512 39.4 512H216.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7L65.8 416l124.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9zM452.5 416L479 467.2c.6 1.2 1 2.6 1 4c0 4.8-3.9 8.8-8.8 8.8H328.8c-4.8 0-8.8-3.9-8.8-8.8c0-1.4 .3-2.8 1-4L347.5 416l105 0zm-105-32c-12 0-22.9 6.7-28.4 17.3l-26.5 51.2c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H471.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3h-105zM304 160c-8.8 0-16 7.2-16 16v80c0 3.7 1.3 7.4 3.7 10.2L328 309.8V336v16h32V336 304c0-3.7-1.3-7.4-3.7-10.2L320 250.2V192h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V192h32v58.2l-36.3 43.5c-2.4 2.9-3.7 6.5-3.7 10.2v32 16h32V336 309.8l36.3-43.5c2.4-2.9 3.7-6.5 3.7-10.2V176c0-8.8-7.2-16-16-16H432 368 304z"]
};
var faTrashSlash = {
  prefix: 'fal',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", "M509.7 96H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 479.9 432.9L407 22.6C398.2 8.5 382.8 0 366.3 0H273.7C257.2 0 241.8 8.5 233 22.6L207.1 64h-27l40.5 32h257L463.9 288.1l30.4 24L509.7 96zM452.9 442.5l-.6 7.8C451.1 467 437.2 480 420.4 480H219.6c-16.8 0-30.7-13-31.9-29.7L171.2 220.1l-34-26.8 18.5 259.3c2.4 33.5 30.3 59.4 63.8 59.4H420.4c29.1 0 54-19.5 61.6-46.6l-29.1-23zM273.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L395.1 64H244.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faArrowLeftLong = {
  prefix: 'fal',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 496 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 171.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z"]
};
var faLongArrowLeft = faArrowLeftLong;
var faPlugCircleCheck = {
  prefix: 'fal',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faFontCase = {
  prefix: 'fal',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", "M190.9 42.3C188.6 36.1 182.6 32 176 32s-12.6 4.1-14.9 10.3l-160 416c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2L76.2 352H275.8l45.3 117.7c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-160-416zM263.5 320H88.5L176 92.6 263.5 320zM624 160c-8.8 0-16 7.2-16 16v34.7C585.4 179.9 549 160 508 160c-68.5 0-124 55.5-124 124v72c0 68.5 55.5 124 124 124c41 0 77.4-19.9 100-50.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zM416 284c0-50.8 41.2-92 92-92s92 41.2 92 92v72c0 50.8-41.2 92-92 92s-92-41.2-92-92V284z"]
};
var faStreetView = {
  prefix: 'fal',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M256 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 256 0a64 64 0 1 0 0 128zM192 280l0 0V224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v56l0 0c-14.4 2.1-25.6 13.8-27.2 28.3l-8.9 84.5c-.4 4.1-3.9 7.2-8 7.2H236c-4.1 0-7.5-3.1-8-7.2l-8.9-84.5c-1.5-14.5-12.7-26.2-27.2-28.3zm-32-56v56c0 16.1 11.9 29.4 27.3 31.7l8.9 84.5c2.1 20.4 19.3 35.8 39.8 35.8h40c20.5 0 37.6-15.5 39.8-35.8l8.9-84.5c15.5-2.3 27.3-15.6 27.3-31.7V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64zM126.6 383.7c8.7-1.7 14.4-10.1 12.7-18.7s-10.1-14.4-18.7-12.7c-33.2 6.4-61.8 15.3-82.6 26.2C27.6 384 18.5 390.4 11.8 398C4.9 405.6 0 415.1 0 426.2c0 17.6 12.2 31 25.8 40.3c14.1 9.7 33.5 17.8 56 24.4C127.1 504.1 188.7 512 256 512s128.9-7.9 174.2-21.1c22.5-6.6 41.9-14.7 56-24.4c13.6-9.4 25.8-22.7 25.8-40.3c0-11.1-4.9-20.6-11.8-28.3c-6.7-7.5-15.9-13.9-26.2-19.4c-20.8-11-49.4-19.8-82.6-26.2c-8.7-1.7-17.1 4-18.7 12.7s4 17.1 12.7 18.7c31.6 6.1 56.8 14.2 73.6 23.1c8.4 4.5 14 8.7 17.3 12.5c3.2 3.6 3.6 5.9 3.6 6.9c0 1.6-1.3 6.6-11.9 14c-10.2 7-25.9 13.9-46.8 20C379.6 472.3 321.2 480 256 480s-123.6-7.7-165.2-19.8c-20.9-6.1-36.7-13-46.8-20c-10.7-7.3-11.9-12.3-11.9-14c0-1.1 .4-3.3 3.6-6.9c3.3-3.7 8.9-8 17.3-12.5c16.8-8.9 42-17 73.6-23.1z"]
};
var faArrowDownLeft = {
  prefix: 'fal',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", "M48 416c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16V361.4L324.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 384H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H48z"]
};
var faFrancSign = {
  prefix: 'fal',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M104 32C81.9 32 64 49.9 64 72V208 320H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V224H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V72c0-4.4 3.6-8 8-8H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H104z"]
};
var faFlaskRoundPoison = {
  prefix: 'fal',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", "M160 32H288V157.7c0 18.2 10.1 33.7 24.4 42C364.9 230.3 400 287.1 400 352c0 47.4-18.7 90.4-49.2 122.1c-3.1 3.2-8.8 5.9-17 5.9H114.2c-8.2 0-13.9-2.7-17-5.9C66.7 442.4 48 399.4 48 352c0-64.9 35.1-121.7 87.6-152.2c14.3-8.3 24.4-23.9 24.4-42V32zM320 157.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304 144 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V157.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4zM128 312c0-36.4 39.2-72 96-72s96 35.6 96 72c0 20.5-11.7 40.1-32.7 54c-8.7 5.8-15.3 15.8-15.3 27.7V416H176V393.7c0-11.9-6.6-21.9-15.3-27.7c-21-13.9-32.7-33.5-32.7-54zm96-104c-66.9 0-128 43.2-128 104c0 33.6 19.3 62.3 47.1 80.7c.5 .3 .7 .6 .9 .9c.1 .1 .1 .2 .1 .2V416c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V393.7c0 0 0-.1 .1-.2c.1-.2 .4-.6 .9-.9C332.7 374.3 352 345.6 352 312c0-60.8-61.1-104-128-104zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFlaskPoison = faFlaskRoundPoison;
var faVolumeOff = {
  prefix: 'fal',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M288 66.7L151.6 188c-2.9 2.6-6.7 4-10.6 4H56c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h85c3.9 0 7.7 1.4 10.6 4L288 445.3V66.7zM270.4 39.5c5.5-4.8 12.5-7.5 19.8-7.5C306.7 32 320 45.3 320 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L134.9 352H56c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L270.4 39.5z"]
};
var faBookCircleArrowRight = {
  prefix: 'fal',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H394.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H326.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V211.2c10.1-5.2 20.8-9.4 32-12.6V48c0-26.5-21.5-48-48-48H64zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faChartUser = {
  prefix: 'fal',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M576 32H224c-17.7 0-32 14.3-32 32v36c-10.2-2.6-21-4-32-4V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-5.3-11.4-11.8-22.2-19.5-32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM400 128c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V166.6L395.3 267.3c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L384 233.4 473.4 144H416c-8.8 0-16-7.2-16-16zM160 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 384c-54.2 0-98.4 42.5-101.2 96H287.9c-2.8-53.5-47-96-101.2-96H133.3zm0-32h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"]
};
var faUserChart = faChartUser;
var faHandsAslInterpreting = {
  prefix: 'fal',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M146.5 3.7C122-6.5 93.9 5.1 83.7 29.5L9.8 206.8C3.3 222.4 0 239.1 0 256c0 70.7 57.3 128 128 128h80c41.5 0 77.7-22.6 97-56c10.7-18.4 7.7-41-5.8-56c13.5-15 16.4-37.6 5.8-56c-5.5-9.5-12.4-18.2-20.4-25.6l31-7.8c25.7-6.4 41.4-32.5 34.9-58.2s-32.5-41.4-58.2-34.9l-16.8 4.2 10-7.8c20.9-16.3 24.6-46.5 8.2-67.4l-12.6 9.9 12.6-9.9c-16.3-20.9-46.5-24.6-67.4-8.2L176 49.7c.7-19.4-10.5-38.1-29.5-46zM263.8 256l-.3 0-.3 0c-5.5-.1-10.7-3-13.6-8c-8.3-14.4-23.9-24-41.6-24c-26.5 0-48 21.5-48 48s21.5 48 48 48c17.7 0 33.3-9.6 41.6-24c2.9-5 8.1-7.9 13.6-8l.3 0 .3 0c2.6 0 5.2 .7 7.7 2.2c7.6 4.4 10.3 14.2 5.8 21.9c-13.8 23.9-39.7 40-69.3 40H128c-53 0-96-43-96-96c0-12.7 2.5-25.2 7.4-36.9L113.2 41.8c3.4-8.2 12.8-12 20.9-8.6s12 12.8 8.6 20.9L127.9 89.9c-2.8 6.7-.7 14.5 5.1 18.9s13.8 4.4 19.6-.1l93.6-73.3c7-5.4 17-4.2 22.5 2.7s4.2 17-2.7 22.5l-69.3 54.2c-5.9 4.7-7.8 12.8-4.5 19.6s10.9 10.3 18.3 8.5l89.8-22.4c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-66.3 16.6c-6.7 1.7-11.5 7.4-12.1 14.3s3.4 13.3 9.7 16c16 6.8 29.4 18.7 38 33.7c4.4 7.6 1.8 17.4-5.8 21.9c-2.5 1.4-5.1 2.1-7.7 2.2zm-41.9 8c1.7 2.9 3.6 5.6 5.8 8c-2.1 2.4-4.1 5.1-5.8 8c-2.8 4.9-8 8-13.9 8c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.9 0 11.1 3.2 13.9 8zM493.5 508.3c24.5 10.2 52.6-1.4 62.8-25.8l73.8-177.2c6.5-15.6 9.8-32.3 9.8-49.2c0-70.7-57.3-128-128-128H432c-41.5 0-77.7 22.6-97 56c-10.7 18.4-7.7 41 5.8 56c-13.5 15-16.4 37.6-5.8 56c5.5 9.5 12.4 18.2 20.4 25.6l-31 7.8c-25.7 6.4-41.4 32.5-34.9 58.2s32.5 41.4 58.2 34.9l16.8-4.2-10 7.8c-20.9 16.3-24.6 46.5-8.2 67.4s46.5 24.6 67.4 8.2L464 462.3c-.7 19.4 10.6 38.1 29.5 46zM376.2 256l.3 0 .3 0c5.5 .1 10.7 3 13.6 8c8.3 14.4 23.9 24 41.6 24c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.7 0-33.3 9.6-41.6 24c-2.9 5-8.1 7.9-13.6 8l-.3 0-.3 0c-2.6 0-5.2-.7-7.7-2.2c-7.6-4.4-10.3-14.2-5.8-21.9c13.8-23.9 39.7-40 69.3-40h80c53 0 96 43 96 96c0 12.7-2.5 25.2-7.4 36.9L526.8 470.2c-3.4 8.2-12.8 12-20.9 8.6s-12-12.8-8.6-20.9l14.9-35.8c2.8-6.7 .7-14.5-5.1-18.9s-13.8-4.4-19.6 .1l-93.6 73.3c-7 5.4-17 4.2-22.5-2.7s-4.2-17 2.7-22.5l69.3-54.2c5.9-4.7 7.8-12.8 4.5-19.6s-10.9-10.3-18.3-8.5l-89.8 22.4c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l66.3-16.6c6.7-1.7 11.5-7.4 12.1-14.3s-3.4-13.3-9.7-16c-16-6.8-29.4-18.7-38-33.7c-4.4-7.6-1.8-17.4 5.8-21.9c2.5-1.4 5.1-2.1 7.7-2.2zm41.9-8c-1.7-2.9-3.6-5.6-5.8-8c2.1-2.4 4.1-5.1 5.8-8c2.8-4.9 8-8 13.9-8c8.8 0 16 7.2 16 16s-7.2 16-16 16c-5.9 0-11.1-3.2-13.9-8z"]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faPresentationScreen = {
  prefix: 'fal',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM32 64V288c0 35.3 28.7 64 64 64H272v41.4l-91.3 91.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 422.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L304 393.4V352H480c35.3 0 64-28.7 64-64V64H512V288c0 17.7-14.3 32-32 32H288 96c-17.7 0-32-14.3-32-32V64H32z"]
};
var faPresentation = faPresentationScreen;
var faCircleBolt = {
  prefix: 'fal',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm191.7 8H240c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9L320.3 248H272c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9L191.7 264zM313.6 112c14.7 0 24.4 15.2 18.2 28.5L297 216h49.4c11.9 0 21.6 9.7 21.6 21.6c0 5.9-2.4 11.6-6.7 15.7L212.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5c-14.7 0-24.4-15.2-18.2-28.5L215 296H165.6c-11.9 0-21.6-9.7-21.6-21.6c0-5.9 2.4-11.6 6.7-15.7L299.8 117.5c3.7-3.5 8.7-5.5 13.8-5.5z"]
};
var faFaceSmileHalo = {
  prefix: 'fal',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M480.3 78.1a.1 .1 0 1 0 -.2 0 .1 .1 0 1 0 .2 0zm-7.4-3.5c3.2 2.4 5 4.2 6.1 5.4c-1.1 1.2-2.9 3-6.1 5.4c-9 6.6-24 13.9-45.4 20.6C385 119.3 324.4 128 256 128s-129-8.7-171.5-22C63.1 99.3 48.1 92 39.1 85.4c-3.2-2.4-5-4.2-6.1-5.4c1.1-1.2 2.9-3 6.1-5.4c9-6.6 24-13.9 45.4-20.6C127 40.7 187.6 32 256 32s129 8.7 171.5 22c21.4 6.7 36.4 14 45.4 20.6zM31.7 78.1a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zm0 3.8a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zm448.5-.1a.2 .2 0 1 0 -.1 .3 .2 .2 0 1 0 .1-.3zM512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-9.5 3.9-19.7 7.6-30.5 11C453.8 198.2 464 233.9 464 272c0 114.9-93.1 208-208 208S48 386.9 48 272c0-38.1 10.2-73.8 28.1-104.5c-10.9-3.4-21.1-7.1-30.5-11zm110.9 94c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 217.9 194.8 208 176 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-14.9 89.4c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm162-64c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 217.9 354.8 208 336 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6z"]
};
var faCartCircleArrowDown = {
  prefix: 'fal',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM608 368a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-256 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm211.3-3.3c-6.2-6.2-16.4-6.2-22.6 0L512 393.4V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56 56c6.2 6.2 16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faHousePersonReturn = {
  prefix: 'fal',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9V352c0 35.3 28.7 64 64 64H348.6l9.1-32H352 320 128c-17.7 0-32-14.3-32-32V160.5L240 37.1 367.9 146.7c5.8-9.1 12.6-17.4 20.4-24.7L250.4 3.9zM192 192h64v64H192V192zm-8-32c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H184zM464 56a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-80 0a56 56 0 1 0 112 0A56 56 0 1 0 384 56zM522.4 172.3l12.7 6.9c27.5 15 47.4 40.8 55 71.2l2.4 9.6c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-2.4-9.5c-9.8-39-35.4-72.2-70.7-91.5l-12.7-6.9c-19.4-10.6-41.2-16.2-63.4-16.2c-36.9 0-69.7 23.6-81.4 58.7l-17.1 51.4c-3.4 10.1-10 18.8-18.9 24.8l-29.7 19.8c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l29.7-19.8c14.8-9.9 25.9-24.4 31.5-41.3l8.8-26.4L452.7 331l-43.6 37.8c-4.7 4.1-8.1 9.4-9.8 15.4L368.6 491.6c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11L430.1 393l100.6-87.2c14.4-12.5 20.1-32.4 14.4-50.6l-26.6-85c1.3 .6 2.6 1.3 3.9 2zm-7.9 92.5c1.9 6.1 0 12.7-4.8 16.9l-30.9 26.8-45-130c10-11.5 24.7-18.4 40.6-18.4c2.5 0 5 .1 7.5 .3l32.7 104.5zm6.4 88.9c-7.9 4-11.1 13.6-7.2 21.5l30.8 61.7c1.5 3.1 3.6 5.9 6 8.3l62.2 62.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2-30.8-61.7c-4-7.9-13.6-11.1-21.5-7.2z"]
};
var faHousePersonArrive = faHousePersonReturn;
var faHouseReturn = faHousePersonReturn;
var faMessageXmark = {
  prefix: 'fal',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM180.7 132.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 230.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 208l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 185.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faCommentAltTimes = faMessageXmark;
var faMessageTimes = faMessageXmark;
var faFileCertificate = {
  prefix: 'fal',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", "M480 448c0 17.7-14.3 32-32 32H224v16c0 5.5-1 10.9-2.7 16H448c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v71.1l.1-.1c1.5-.7 4-2 6.6-3c8.2-3.4 16.9-4.6 25.3-4V64c0-17.7 14.3-32 32-32H320V144c0 26.5 21.5 48 48 48H480V448zm-.5-288H368c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L475.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zM69.8 358.5l-2.1 15.2 2.1-15.2L59 357l-1.5-10.8c-1.4-10.4-6.9-19.8-15.1-26.2L22.8 345.2 42.4 320l-8.6-6.7 4.1-10.1c4-9.7 4-20.6 0-30.3l-4.1-10.1 8.6-6.7L22.8 230.7 9.3 241.2c-8.5 6.6-11.6 18.1-7.5 28L8.2 285c.8 1.9 .8 4.1 0 6L1.8 306.8c-4.1 10-1 21.4 7.5 28l13.5 10.4c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.8 19.1 20.5 20.5L64 390V496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V390l15.4-2.1c10.7-1.5 19.1-9.8 20.5-20.5l2.3-16.9-31.7-4.3L197 357l-10.8 1.5c-10.4 1.4-19.8 6.9-26.2 15.1l-6.7 8.6-10.1-4.1c-9.7-4-20.6-4-30.3 0l-10.1 4.1L96 373.6c-6.4-8.3-15.8-13.7-26.2-15.1zm-47-127.7L42.4 256c8.3-6.4 13.7-15.8 15.1-26.2L29.3 226l28.2 3.8L59 219l10.8-1.5c10.4-1.4 19.8-6.9 26.2-15.1l6.7-8.6 10.1 4.1c9.7 4 20.6 4 30.3 0l-11.3-27.6 11.3 27.6 10.1-4.1 6.7 8.6c6.4 8.3 15.8 13.7 26.2 15.1L197 219l1.5 10.8c1.4 10.4 6.9 19.8 15.1 26.2l8.6 6.7-4.1 10.1c-4 9.7-4 20.6 0 30.3l4.1 10.1-8.6 6.7c-8.3 6.4-13.7 15.8-15.1 26.2l31.7 4.3c.3-2.1 1.4-4 3-5.2l13.5-10.4c8.5-6.6 11.6-18.1 7.5-28L247.8 291c-.8-1.9-.8-4.1 0-6l6.5-15.8c4.1-10 1-21.4-7.5-28l-13.5-10.4c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.8-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.4-13.5c-6.6-8.5-18.1-11.6-28-7.5L131 168.2c-1.9 .8-4.1 .8-6 0l-15.8-6.5c-10-4.1-21.4-1-28 7.5L70.7 182.8c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.8-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2zM160 466.1l-23.1-15.4c-5.4-3.6-12.4-3.6-17.8 0L96 466.1V415.6c4.3 .8 8.9 .3 13.2-1.4l15.8-6.5c1.9-.8 4.1-.8 6 0l15.8 6.5c4.3 1.8 8.9 2.2 13.2 1.4v50.5z"]
};
var faFileAward = faFileCertificate;
var faUserDoctorHairLong = {
  prefix: 'fal',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M320 144c0 53-43 96-96 96s-96-43-96-96V128l34.3 0c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4h30.1c.9 5.2 1.3 10.5 1.3 16v16zm32-16C352 57.3 294.7 0 224 0S96 57.3 96 128c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2C37.5 227.9 32 238.9 32 250.7C32 271.3 48.7 288 69.3 288H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H69.3c-2.9 0-5.3-2.4-5.3-5.3c0-1.7 .8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.4C129.5 242.6 173.3 272 224 272s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.4l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3c0 2.9-2.4 5.3-5.3 5.3H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h58.7c20.6 0 37.3-16.7 37.3-37.3c0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 196.4 352 163.3 352 128zM225.5 57.1C213.5 81 189.1 96 162.3 96H133.5c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48H288.6c-6.4 0-12.5-2.5-17-7L251.3 52.7c-6.2-6.2-16.4-6.2-22.6 0c-1.3 1.3-2.4 2.8-3.1 4.5zM270.8 336c5.8 0 11.5 .3 17.2 1v33.3c-23.1 6.9-40 28.3-40 53.7v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-25.4-16.9-46.8-40-53.7V344.5c55.6 20 95.5 73 96 135.5H32c.5-68.2 48.2-125.3 112-140.2v30.9c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V336l1.2 0h93.6zM176 416a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM0 481.2c0 17 13.8 30.8 30.8 30.8H417.2c17 0 30.8-13.8 30.8-30.8C448 383.3 368.7 304 270.8 304H177.2C79.3 304 0 383.3 0 481.2z"]
};
var faCameraSecurity = {
  prefix: 'fal',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M384 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H324.2 123.8 64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM343.9 416H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h40.1L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3H360c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416zm-202.2 0H306.3l39.4 64H102.3l39.4-64zM224 304a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 208a128 128 0 1 0 256 0A128 128 0 1 0 96 208z"]
};
var faCameraHome = faCameraSecurity;
var faGear = {
  prefix: 'fal',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.1-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]
};
var faCog = faGear;
var faDropletSlash = {
  prefix: 'fal',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c2.8-6.4 5.8-13 9.1-19.7l-25.7-20.3C141.8 252.1 128 290.3 128 320c0 106 86 192 192 192c56.1 0 106.7-24.1 141.8-62.5l-25.2-19.9C407.4 460.6 366 480 320 480zM461.7 252.5c7.6 17.6 12.8 33.1 15.7 46.2L511.9 326c.1-2 .1-4 .1-6c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7c-13.3 16.8-39 50.2-66.4 90.3l25.2 19.9c27-39.7 52.6-73 66-89.9h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8zM240 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTintSlash = faDropletSlash;
var faBookHeart = {
  prefix: 'fal',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM160 173.3c0 7.8 3.1 15.2 8.6 20.7L240 265.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM189.3 112c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
var faMosque = {
  prefix: 'fal',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.4 54.5-29.8 73.5c34.3 1.2 61.8 29.3 61.8 64v96c0 35.3-28.7 64-64 64H544 512 464 432 368 336 288 256 224c-35.3 0-64-28.7-64-64V352c0-34.6 27.5-62.8 61.8-64c-18.5-19-29.8-44.9-29.8-73.5c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zm32 480V424c0-10.1-4.7-19.6-12.8-25.6L400 384l-19.2 14.4c-8.1 6-12.8 15.5-12.8 25.6v56h64zm32 0h48V400c0-8.8 7.2-16 16-16s16 7.2 16 16v80h32c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H502.6 400 297.4 224c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h32V400c0-8.8 7.2-16 16-16s16 7.2 16 16v80h48V424c0-20.1 9.5-39.1 25.6-51.2L400 344l38.4 28.8C454.5 384.9 464 403.9 464 424v56zM576 214.6c0-24-11.7-46.3-31.4-59.4c-5.6-3.7-11.1-7.3-16.5-10.9l0 0 0 0 0 0 0 0 0 0 0 0c-48.6-32.1-92.1-60.7-128-102.7c-35.9 41.9-79.4 70.6-128 102.7l0 0c-5.5 3.6-11 7.2-16.6 10.9c-19.7 13.1-31.4 35.4-31.4 59.4c0 40.6 32.9 73.4 73.4 73.4H400 502.6c40.6 0 73.4-32.9 73.4-73.4zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2 32V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H32v16V448c0 17.7 14.3 32 32 32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V176 126C0 83.2 20.2 42.9 54.4 17.2l16-12zM32 128h96v-2c0-32.7-15.4-63.6-41.6-83.2L80 38l-6.4 4.8C47.4 62.4 32 93.3 32 126v2z"]
};
var faDuck = {
  prefix: 'fal',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M368 259V235.4c0-17.3 7.1-31.9 15.3-42.5L402.7 208l-19.4-15.1C393.8 179.4 400 162.5 400 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.5 32.2 64.2c9.8 7.3 14.5 19.5 12.3 31.5s-11.1 21.7-22.8 25l-165 46.2c-7 2-14.5 1.5-21.2-1.4L32.2 290.9C36.5 378 108.4 448 196 448H312c53 0 96-43 96-96c0-27.5-11.5-52.2-30-69.7c-6.4-6-10-14.4-10-23.2zm32-19v19c24.6 23.3 40 56.3 40 93c0 70.7-57.3 128-128 128H196C87.8 480 0 391 0 282.7C0 268.1 11.9 256 26.6 256c3.6 0 7.2 .7 10.5 2.1L88 280l128.4-36L253 233.8c-9.8-7.3-18.3-16.1-25.2-26.2c-12.5-18.1-19.8-40-19.8-63.6c0-61.9 50.1-112 112-112c54.1 0 99.3 38.4 109.7 89.4c9.6 1.3 19.3 1.3 28.9 .1l24.2-3c15.5-1.9 29.2 10.1 29.2 25.8c0 52.9-42.9 95.7-95.7 95.7H400zm31.6-86.2c-1.7 20-8.8 38.6-19.7 54.2h4.4c32.9 0 59.9-24.9 63.3-56.8l-17 2.1c-10.3 1.3-20.7 1.5-31 .5zM312 152a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm13.2 159.7c-6.2 46.7-41.4 87-90.7 99.3c-40.4 10.1-81.2-.9-109.7-26.2c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3c20.7 18.3 50.6 26.6 80.7 19.1c36.8-9.2 62.3-39 66.7-72.5c1.2-8.8 9.2-14.9 18-13.7s14.9 9.2 13.7 18z"]
};
var faMosquito = {
  prefix: 'fal',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", "M182.4 3.4c-6.9 5.5-8.2 15.7-2.8 22.7l41.9 55.7L194 136.5c-3.2 6.3-2 14.1 3 19l45.1 45.1L79.3 226.2C34 232.1 0 272.5 0 320.3c0 84.5 97.6 126.9 154.6 67.1L272 280.4v23.9L228 357c-2.5 2.9-3.8 6.7-3.8 10.6v58.3l-44.7 59.5c-5.3 7.1-4.1 17.3 2.8 22.7s16.8 4.2 22.1-2.9l48-63.9c2.1-2.8 3.3-6.3 3.3-9.9V373.5L272 354.1v45.4c0 26.5 21.5 48 48 48s48-21.5 48-48V354.1l16.2 19.4 0 57.9c0 3.6 1.2 7.1 3.3 9.9l48 63.9c5.3 7.1 15.2 8.4 22.1 2.9s8.2-15.7 2.8-22.7l-44.7-59.5V367.5c0-3.9-1.4-7.6-3.8-10.6l-44-52.7V280.4L485.4 387.4C542.4 447.2 640 404.9 640 320.3c0-47.9-34-88.2-79.4-94.2L397.9 200.7 443 155.6c5-5 6.2-12.7 3-19L418.6 81.8l41.9-55.7c5.3-7.1 4.1-17.3-2.8-22.7s-16.8-4.2-22.1 2.9l-48 63.9c-3.7 5-4.3 11.7-1.5 17.3l26.7 53.2L368 185.4v-9.5c0-23.8-17.3-43.5-40-47.3V63.8c0-4.4-3.6-8-8-8s-8 3.6-8 8v64.8c-22.7 3.8-40 23.6-40 47.3v9.5l-44.6-44.7L254 87.5c2.8-5.6 2.2-12.4-1.5-17.3l-48-63.9c-5.3-7.1-15.2-8.4-22.1-2.9zM272 237.1L133.1 363.8c-.5 .5-1.1 1-1.6 1.5C96.6 401.9 32 379.3 32 320.3c0-32.9 23.2-58.7 51.5-62.4c.3 0 .5-.1 .8-.1l185.8-29.1 1.9 1.9 0 6.4zM506.9 363.8L368 237l0-6.4 1.9-1.9 185.8 29.1c.3 0 .5 .1 .8 .1c28.3 3.7 51.5 29.5 51.5 62.4c0 58.9-64.6 81.6-99.5 45c-.5-.5-1-1-1.6-1.5zM304 399.5l0-223.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 223.6c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faStarOfDavid = {
  prefix: 'fal',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M418.3 286.6l-50 81.4h90.2c3 0 5.4-2.4 5.4-5.4c0-1-.3-2-.8-2.8l-44.9-73.1zM399.5 256L330.8 144H181.2L112.5 256l68.7 112H330.8l68.7-112zm37.5 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zM368.4 144l50 81.4 44.9-73.1c.5-.9 .8-1.8 .8-2.8c0-3-2.4-5.4-5.4-5.4H368.4zm-57.2-32L265.3 37.2c-2-3.2-5.5-5.2-9.3-5.2s-7.3 2-9.3 5.2L200.8 112H311.2zM143.6 144H53.4c-3 0-5.4 2.4-5.4 5.4c0 1 .3 2 .8 2.8l44.9 73.1 50-81.4zm-50 142.6L48.8 359.7c-.5 .9-.8 1.8-.8 2.8c0 3 2.4 5.4 5.4 5.4h90.2l-50-81.4zM200.8 400l45.9 74.8c2 3.2 5.5 5.2 9.3 5.2s7.3-2 9.3-5.2L311.2 400H200.8z"]
};
var faFlagSwallowtail = {
  prefix: 'fal',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V32 64 320v32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H32V16zm0 48H408L326.4 172.8c-8.5 11.4-8.5 27 0 38.4L408 320H32V64z"]
};
var faFlagAlt = faFlagSwallowtail;
var faPersonMilitaryRifle = {
  prefix: 'fal',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M192 64V59.1L320 37.8V64v0H192v0zm160 8V28.3c0-14.8-13.3-26.1-27.9-23.7l-144 24C168.5 30.6 160 40.6 160 52.3V72c0 11.1 7.5 20.4 17.8 23.2c-1.2 5.4-1.8 11-1.8 16.8c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.8-.6-11.4-1.8-16.8C344.5 92.4 352 83.1 352 72zM210.7 96h90.5c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16zM192 296c0-2.3 .2-4.6 .6-6.7L301.6 480H208c-8.8 0-16-7.2-16-16V296zM320 447.8l-106.9-187c5.6-3 12.1-4.7 18.9-4.7h48c22.1 0 40 17.9 40 40V447.8zM352 464V300.2l98.1 171.7c4.4 7.7 14.2 10.3 21.8 6s10.3-14.2 6-21.8L384 291.7l46.9-81.2c8.8-15.3 3.6-34.9-11.7-43.7l16-27.7 32-55.4 8-13.9c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l-16 27.7-16 27.7-16 27.7c-15.3-8.8-34.9-3.6-43.7 11.7L309.9 228c-9.5-2.6-19.5-4-29.6-4H280 232h-.3c-40.2 0-77.3 21.5-97.2 56.4L34.1 456.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6L160 300.2V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zM339.4 240.9l36-62.3 27.7 16-38.9 67.3c-7.3-8.2-15.6-15.3-24.8-21zM288 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCarGarage = {
  prefix: 'fal',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M328.5 2.5c-5.2-3.3-11.9-3.3-17.1 0l-304 192c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5L320 34.9 615.5 221.5c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1l-304-192zM252.2 208H387.8c14.3 0 26.8 9.5 30.8 23.2L434.8 288c-.9 0-1.9 0-2.8 0H208c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L169 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H480v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H252.2c-28.6 0-53.7 18.9-61.5 46.4zM480 416v16H160V416 368c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48v48zM208 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCartShopping = {
  prefix: 'fal',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H53.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288H466.5c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8H99.1C92.5 13 74.4 0 53.9 0H16zm90.1 64H539.5L497.6 231.8C494 246 481.2 256 466.5 256H145.4L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faShoppingCart = faCartShopping;
var faBookFont = {
  prefix: 'fal',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM254.3 104.8l63.9 127.7c.1 .2 .2 .4 .3 .6l31.8 63.7c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L294.1 256H185.9l-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l31.8-63.7c.1-.2 .2-.4 .3-.6l63.9-127.7c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM278.1 224L240 147.8 201.9 224h76.2z"]
};
var faShieldPlus = {
  prefix: 'fal',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faVials = {
  prefix: 'fal',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V272 400c0 44.2 35.8 80 80 80s80-35.8 80-80V272 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H176 48 16zM64 256V64h96V256H64zm0 32h96V400c0 26.5-21.5 48-48 48s-48-21.5-48-48V288zM304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V272 400c0 44.2 35.8 80 80 80s80-35.8 80-80V272 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H464 336 304zm48 224V64h96V256H352zm0 32h96V400c0 26.5-21.5 48-48 48s-48-21.5-48-48V288z"]
};
var faEyeDropperFull = {
  prefix: 'fal',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l0 0-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4 0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 39.9c-6.2-6.2-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-112-112zM78.1 344.6L176 246.6 265.4 336l-97.9 97.9c-9 9-21.2 14.1-33.9 14.1H88 83.8l-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7V424 378.5c0-12.7 5.1-24.9 14.1-33.9z"]
};
var faDistributeSpacingHorizontal = {
  prefix: 'fal',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", "M464 0c-8.8 0-16 7.2-16 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16l0-480c0-8.8-7.2-16-16-16zM320 368c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 224zm32-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM64 16C64 7.2 56.8 0 48 0S32 7.2 32 16l0 480c0 8.8 7.2 16 16 16s16-7.2 16-16L64 16z"]
};
var faTabletRugged = {
  prefix: 'fal',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M64.5 58.4C67.1 43.4 80.2 32 96 32H352c15.8 0 28.9 11.4 31.5 26.4c.9 5 4.1 9.3 8.6 11.5L416 81.9v60.2l-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3v32c0 6.1 3.4 11.6 8.8 14.3L416 225.9v60.2l-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3v32c0 6.1 3.4 11.6 8.8 14.3L416 369.9v60.2l-23.9 11.9c-4.5 2.3-7.7 6.6-8.6 11.5c-2.6 15-15.8 26.4-31.5 26.4H96c-15.8 0-28.9-11.4-31.5-26.4c-.9-5-4.1-9.3-8.6-11.5L32 430.1V369.9l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3V312c0-6.1-3.4-11.6-8.8-14.3L32 286.1V225.9l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V168c0-6.1-3.4-11.6-8.8-14.3L32 142.1V81.9L55.9 69.9c4.5-2.3 7.7-6.5 8.6-11.5zM96 0C67.4 0 43.2 18.7 35 44.6L8.8 57.7C3.4 60.4 0 65.9 0 72v80c0 6.1 3.4 11.6 8.8 14.3L32 177.9v12.2L8.8 201.7C3.4 204.4 0 209.9 0 216v80c0 6.1 3.4 11.6 8.8 14.3L32 321.9v12.2L8.8 345.7C3.4 348.4 0 353.9 0 360v80c0 6.1 3.4 11.6 8.8 14.3L35 467.4C43.2 493.3 67.4 512 96 512H352c28.6 0 52.8-18.7 61-44.6l26.1-13.1c5.4-2.7 8.8-8.2 8.8-14.3V360c0-6.1-3.4-11.6-8.8-14.3L416 334.1V321.9l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V216c0-6.1-3.4-11.6-8.8-14.3L416 190.1V177.9l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V72c0-6.1-3.4-11.6-8.8-14.3L413 44.6C404.8 18.7 380.6 0 352 0H96zm32 96H320V416H128V96zM96 96V416c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z"]
};
var faTemperatureSnow = {
  prefix: 'fal',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M368 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM432 0c-53 0-96 43-96 96V252.7c0 4.6-2.2 9.8-6.8 14.5C303.7 293.1 288 328.8 288 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM400 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM284.6 142.8l7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2L192 196.3V134.6l43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 89.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L160 134.6v61.7l-53.4-30.8L90.7 106.3C88.5 97.8 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l7.6 28.3L31.6 122.1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 224 90.6 254.8 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6L15.6 298.1C7.9 302.6 5.3 312.3 9.7 320s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2L160 251.7v61.7l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 358.6V400c0 8.8 7.2 16 16 16s16-7.2 16-16V358.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 313.4V251.7l53.4 30.8 13.8 51.7c6.5-33.3 22.4-63.3 44.8-87v-3.8l-42.6 11.4L208 224l53.4-30.8L304 204.6V171.5l-3.4-.9 3.4-2v-37l-19.4 11.2z"]
};
var faTemperatureFrigid = faTemperatureSnow;
var faMoped = {
  prefix: 'fal',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", "M336 48c0-8.8 7.2-16 16-16h40.9c20.7 0 39 13.2 45.5 32.8l5.2 15.5L500.3 52c5.2-2.6 11-4 16.9-4C532 48 544 60 544 74.9v74.3c0 14.8-12 26.9-26.9 26.9c-5.9 0-11.6-1.4-16.9-4L469 156.4 494.5 233c5.7-.7 11.6-1 17.5-1c41.5 0 79.1 16.6 106.5 43.5c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C574.4 277.1 544.7 264 512 264c-56.5 0-104 39.1-116.7 91.8c-1.1 4.6-2 9.3-2.5 14.1c-.9 8.1-7.8 14.1-15.9 14.1H336 288 256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32V320c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h32 16 16 11.4c.3-1.3 .6-2.5 .9-3.8c12.2-50.8 50-91.6 98.9-108.2l-55-165.1c-2.2-6.5-8.3-10.9-15.2-10.9H352c-8.8 0-16-7.2-16-16zm118.7 65.5c.2 .1 .3 .1 .5 .2L512 142.1V81.9l-56.8 28.4c-.4 .2-.9 .4-1.3 .6l.9 2.6zM112 128H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96H128c-53 0-96 43-96 96l0 32H69.5h35.1H215.4h17.1c-5.4-9.4-8.6-20.3-8.6-32V224zM160 448c35.3 0 64-28.7 64-64H96c0 35.3 28.7 64 64 64zm352 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faFaceSmilePlus = {
  prefix: 'fal',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M560 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H464c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM416 288A192 192 0 1 0 32 288a192 192 0 1 0 384 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM126.9 330.1c4.5 11.2 15.1 29.1 31.8 44C175.1 388.7 196.8 400 224 400s48.9-11.3 65.3-25.9c16.7-14.9 27.3-32.8 31.8-44c3.3-8.2 12.6-12.2 20.8-8.9s12.2 12.6 8.9 20.8c-6.2 15.4-19.5 37.5-40.2 56C289.8 416.6 260.8 432 224 432s-65.8-15.4-86.7-34.1c-20.7-18.5-34-40.6-40.2-56c-3.3-8.2 .7-17.5 8.9-20.8s17.5 .7 20.8 8.9z"]
};
var faSmilePlus = faFaceSmilePlus;
var faRadioTuner = {
  prefix: 'fal',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6s-11-13.6-19.6-11.3L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66C.3 185.2 0 188.5 0 192v1.2V240 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H138.1l362-96.5zM32 193.2c0-2.2 .1-4.3 .4-6.4C34.9 171.6 48.1 160 64 160H448c17.7 0 32 14.3 32 32v32H32V193.2zM32 448V256H480V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm272 32a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
};
var faRadioAlt = faRadioTuner;
var faFaceSwear = {
  prefix: 'fal',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M534.7 192C507.2 99.5 421.5 32 320 32S132.8 99.5 105.3 192H72.1C100.5 81.6 200.7 0 320 0S539.5 81.6 567.9 192H534.7zM264.4 176c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-8.1 4-15.3 10.2-19.6l-39.6-13.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-19.7-6.6c.8 2.3 1.2 4.8 1.2 7.4zm136 24c-13.3 0-24-10.7-24-24c0-2.7 .4-5.3 1.3-7.7l-20.6 6.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-39.1 13c6.3 4.3 10.4 11.6 10.4 19.8c0 13.3-10.7 24-24 24zM32 288V448c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM0 288c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288zm400 64H384v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V352H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V304c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32V304c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32V352H320zm250.4-52.1c6.7 5.8 7.5 15.9 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM184 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 304v1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-.6 .4-1.2 .9-1.5 2.9c-.2 1-.1 1.6-.1 1.8c.1 .1 .5 .6 1.5 1.3c3.7 2.5 9.6 4.4 19.2 7.3l.7 .2c8 2.4 19.1 5.8 27.6 11.9c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c.5-.3 1.4-.9 2-4c.2-1.2 .2-1.9 .2-2.3c0-.4-.1-.6-.1-.6l0 0c0-.1-.3-.6-1.6-1.6c-3.5-2.5-9.3-4.6-18.7-7.4L106 382l0 0c-7.7-2.3-18.3-5.5-26.4-11c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7V304c0-8.8 7.2-16 16-16s16 7.2 16 16zM96.1 343.4s0 0 0-.1l0 .1c0 0 0 0 0 0z"]
};
var faWaterArrowDown = {
  prefix: 'fal',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", "M288 0c8.8 0 16 7.2 16 16V185.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 185.4V16c0-8.8 7.2-16 16-16zM133.8 458.8C150.3 470 171.1 480 192 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM192 352c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 342 363.1 352 384 352s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 369.9 414.3 384 384 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 369.9 222.3 384 192 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 384.1 0 376 0 366.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 342 171.1 352 192 352z"]
};
var faWaterLower = faWaterArrowDown;
var faScannerTouchscreen = {
  prefix: 'fal',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M128 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM400 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H288zM64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 96H248c4.4 0 8 3.6 8 8V408c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm-40 8V408c0 22.1 17.9 40 40 40H248c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"]
};
var faCircle7 = {
  prefix: 'fal',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H308.4L194.1 360.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l128-224c2.8-5 2.8-11-.1-16s-8.1-8-13.8-8H176z"]
};
var faPlugCirclePlus = {
  prefix: 'fal',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", "M432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16zM112 0c8.8 0 16 7.2 16 16v96H96V16c0-8.8 7.2-16 16-16zM272 0c8.8 0 16 7.2 16 16v96H256V16c0-8.8 7.2-16 16-16zM0 160c0-8.8 7.2-16 16-16H32 64 320h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v35.2c-11.4 5.9-22.2 12.9-32 21V176H64v64c0 70.7 57.3 128 128 128c23.7 0 45.8-6.4 64.9-17.6c-.6 5.8-.9 11.7-.9 17.6c0 6.2 .3 12.3 .9 18.3c-15.2 6.8-31.7 11.2-48.9 12.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V399.2C95.1 391.2 32 323 32 240V176H16c-8.8 0-16-7.2-16-16z"]
};
var faPersonSkiJumping = {
  prefix: 'fal',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", "M432 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 352 56zM112 112c0-8.8 7.2-16 16-16H288h19.2c24.8 0 44.8 20.1 44.8 44.8c0 18.1-10.8 34.3-27.5 41.3L207 231.5c-1.6 2.4-3 4.9-4.2 7.5L142.6 374.5c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l60.2-135.4c2.6-5.9 6-11.5 9.9-16.6c.5-.7 1-1.3 1.5-1.9c.3-.4 .6-.7 .9-1.1L253.2 128H128c-8.8 0-16-7.2-16-16zm183.4 16l-42.5 49.6 59.3-24.9c4.8-2 7.9-6.7 7.9-11.8c0-7.1-5.7-12.8-12.8-12.8H295.4zM496 176c8.8 0 16 7.2 16 16v7.3c0 35.9-20 68.8-51.9 85.3L23.3 510.2c-7.9 4.1-17.5 1-21.6-6.9s-1-17.5 6.9-21.6L445.4 256.1c21.3-11 34.6-32.9 34.6-56.9V192c0-8.8 7.2-16 16-16z"]
};
var faSkiJump = faPersonSkiJumping;
var faPlaceOfWorship = {
  prefix: 'fal',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M320 0c4.2 0 8.3 1.7 11.3 4.7L406.6 80c6 6 9.4 14.1 9.4 22.6v89.3L457 217c14.3 8.7 23 24.2 23 41V480h96c17.7 0 32-14.3 32-32V378.1c0-10.9-5.5-21-14.6-26.9L512 298.6V260.5l98.8 63.9c18.2 11.8 29.2 32 29.2 53.7V448c0 35.3-28.7 64-64 64H416v0H384 352 288 256 224v0H64c-35.3 0-64-28.7-64-64V378.1c0-21.7 11-41.9 29.2-53.7L128 260.5v38.1L46.6 351.2c-9.1 5.9-14.6 16-14.6 26.9V448c0 17.7 14.3 32 32 32h96V257.9c0-16.7 8.7-32.2 23-41l41-25.1V102.6c0-8.5 3.4-16.6 9.4-22.6L308.7 4.7c3-3 7.1-4.7 11.3-4.7zM448 257.9c0-5.6-2.9-10.7-7.7-13.7l-48.7-29.8c-4.8-2.9-7.7-8.1-7.7-13.7l0-98.3-64-64-64 64v98.3c0 5.6-2.9 10.7-7.7 13.7l-48.7 29.8c-4.8 2.9-7.7 8.1-7.7 13.7V480h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96h64V257.9zM352 480V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64z"]
};
var faWaterArrowUp = {
  prefix: 'fal',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", "M288 240c8.8 0 16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6V224c0 8.8 7.2 16 16 16zM133.8 458.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2zM192 352c-20.9 0-41.7-9.9-58.2-21.2c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 352.1 0 358.4 0 366.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 369.9 161.7 384 192 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 369.9 353.7 384 384 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 342 404.9 352 384 352s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 342 212.9 352 192 352z"]
};
var faWaterRise = faWaterArrowUp;
var faWaveformLines = {
  prefix: 'fal',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", "M320 0c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM512 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM224 96c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm192 32c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM128 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM32 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm576 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16z"]
};
var faWaveformPath = faWaveformLines;
var faSplit = {
  prefix: 'fal',
  iconName: 'split',
  icon: [512, 512, [], "e254", "M404.7 36.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 144H400 339.9c-8.5 0-16.6 3.4-22.6 9.4L214.6 256 317.3 358.6c6 6 14.1 9.4 22.6 9.4H400h57.4l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 400H400 339.9c-17 0-33.3-6.7-45.3-18.7L190.1 276.7c-3-3-7.1-4.7-11.3-4.7H48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H48 178.7c4.2 0 8.3-1.7 11.3-4.7L294.6 130.7c12-12 28.3-18.7 45.3-18.7H400h57.4L404.7 59.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFilmCanister = {
  prefix: 'fal',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H32V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 304h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304 48 16zM64 480V96H288V480H64zM384 200v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H392c-4.4 0-8 3.6-8 8zm8 152c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8H392zm88-152v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8zM352 160H528c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48v32c0 8.8-7.2 16-16 16H352v32H464c26.5 0 48-21.5 48-48V368c0-8.8 7.2-16 16-16c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H352v32z"]
};
var faFilmCannister = faFilmCanister;
var faFolderXmark = {
  prefix: 'fal',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM180.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 288l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 310.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 288l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 265.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faFolderTimes = faFolderXmark;
var faToiletPaperBlank = {
  prefix: 'fal',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", "M20.5 463.6c-2.8 4.7-4.3 10-4.5 15.4c-.2 5.8 1.2 11.6 4.2 16.8C25.8 505.8 36.5 512 48 512H317.9c22.3 0 45.4-12.1 55.4-36.1c10.7-25.8 27.3-76.6 36.3-158.9c.3-2.4 .5-4.9 .8-7.4c3.4-33.9 5.6-73 5.6-117.7c0-88.4 35.8-160 80-160s80 71.6 80 160s-35.8 160-80 160c-20.6 0-39.4-15.6-53.6-41.2c-1.6 16.4-3.6 31.8-5.7 46C452.2 372.7 471.9 384 496 384c40.7 0 69-32.2 85.2-64.6C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0H464 160C107 0 64 86 64 192c0 80.2-.4 180.8-36.2 257.3c-2.3 4.9-4.7 9.6-7.3 14.3l0 .1zM432.3 32c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 155.1-26.7 239-40.2 271.7c-4.3 10.3-14.5 16.3-25.9 16.3H48l0 0c.2-.3 .4-.6 .5-.9c24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-49.1 10-92 24.7-121.5C136.4 39.2 152.1 32 160 32H432.3zm49.2 180.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM527.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16z"]
};
var faToiletPaperAlt = faToiletPaperBlank;
var faTabletScreen = {
  prefix: 'fal',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M384 32c17.7 0 32 14.3 32 32V320H32V64c0-17.7 14.3-32 32-32H384zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352H416zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
};
var faTabletAndroidAlt = faTabletScreen;
var faHexagonVerticalNftSlanted = {
  prefix: 'fal',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", "M255.8 496.6c-19.8 11.4-44.2 11.4-64 0L32 404.3C12.2 392.9 0 371.7 0 348.9V164.3c0-22.9 12.2-44 32-55.4L191.8 16.6c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4V348.9c0 22.9-12.2 44-32 55.4L255.8 496.6zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7V164.3c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7l0 184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM272 123.5c0 12.3-13.3 20-23.9 13.9l-24.2-13.8v117h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144V96.3c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6l.1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3c5 2.8 8.1 8.2 8.1 13.9zm16 27.4c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3V352.6c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.4l-23.8-13.6c-5-2.8-8.1-8.2-8.1-13.9zM143.8 128.6c8.8 0 16 7.2 16 16v224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2v61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270V144.6c0-8.8 7.2-16 16-16z"]
};
var faFolderMusic = {
  prefix: 'fal',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM345.1 178.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V251.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V192c0-5.2-2.6-10.2-6.9-13.2zM320 340c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zM192 372c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12z"]
};
var faDisplayMedical = {
  prefix: 'fal',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", "M512 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 416H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H373.6l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64h84.9l10.7 64H234.9zM272 96c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H336V128c0-17.7-14.3-32-32-32H272zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H320c-8.8 0-16 7.2-16 16v48H272V240c0-8.8-7.2-16-16-16H208V192h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V128z"]
};
var faDesktopMedical = faDisplayMedical;
var faShareAll = {
  prefix: 'fal',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", "M373.2 59.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1L551.2 178.4c17.5 15.9 17.5 43.3 0 59.2L394.8 379.8c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L529.7 213.9c3.5-3.2 3.5-8.7 0-11.8L373.2 59.8zM256 160H176C96.5 160 32 224.5 32 304c0 46.1 15.9 79.7 34 103.2c-1.3-7.1-2-14.8-2-23.2c0-70.7 57.3-128 128-128h64l0 0h8c13.3 0 24 10.7 24 24v8 16l0 48L448 208 288 64v48 16 8c0 13.3-10.7 24-24 24l-8 0zm0 160V304 288H224 192c-53 0-96 43-96 96c0 30.4 12.8 47.9 22.2 56.7c5.5 5.1 9.8 12 9.8 19.5c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h48 32V112 96 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V320z"]
};
var faPeapod = {
  prefix: 'fal',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M416 32C203.9 32 32 203.9 32 416v48c0 8.8 7.2 16 16 16H96c212.1 0 384-171.9 384-384V48c0-8.8-7.2-16-16-16H416zm0-32h48c26.5 0 48 21.5 48 48V96c0 229.8-186.2 416-416 416H48c-26.5 0-48-21.5-48-48V416C0 186.2 186.2 0 416 0zM368 112a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM224 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM112 368a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
var faChessClock = {
  prefix: 'fal',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", "M240 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H192v64H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h96V64H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 64zM544 80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H528c8.8 0 16 7.2 16 16zM64 160c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM176 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM520.6 360.6A80 80 0 1 0 407.4 247.4 80 80 0 1 0 520.6 360.6zM384.8 224.8A112 112 0 1 1 543.2 383.2 112 112 0 1 1 384.8 224.8zM176 240c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm333.3 41.4l-33.9 33.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faAxe = {
  prefix: 'fal',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M502.6 182.6L352 32l-96 96L406.6 278.6c6 6 9.4 14.1 9.4 22.6V384c106 0 192-86 192-192H525.3c-8.5 0-16.6-3.4-22.6-9.4zM473.3 108l52 52H608c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224c-17.7 0-32-14.3-32-32V301.3L233.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0L404 38.7 433.4 9.4c12.5-12.5 32.8-12.5 45.3 0l24 24c12.5 12.5 12.5 32.8 0 45.3L473.3 108zM450.6 85.4L480 56 456 32 426.6 61.4l24 24zM262.7 225.3L32 456l24 24L286.7 249.3l22.6 22.6L78.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-24-24c-12.5-12.5-12.5-32.8 0-45.3L240.1 202.6l22.6 22.6z"]
};
var faSquareD = {
  prefix: 'fal',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM160 352h64c53 0 96-43 96-96s-43-96-96-96H160V352zm-1.2-224H224c70.7 0 128 57.3 128 128s-57.3 128-128 128H158.8c-17 0-30.8-13.8-30.8-30.8V158.8c0-17 13.8-30.8 30.8-30.8z"]
};
var faGripVertical = {
  prefix: 'fal',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M32 440l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm184-40l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM32 232c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM0 280c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48zm224 0l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM32 72c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48zm224 0l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8zm8 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40z"]
};
var faMobileSignalOut = {
  prefix: 'fal',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", "M96 32H224V0H96C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V288H320V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm64 368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zM272 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c114.9 0 208 93.1 208 208c0 8.8 7.2 16 16 16s16-7.2 16-16C512 107.5 404.5 0 272 0zm16 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 112c0 8.8 7.2 16 16 16c61.9 0 112 50.1 112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-79.5-64.5-144-144-144c-8.8 0-16 7.2-16 16z"]
};
var faArrowTurnUp = {
  prefix: 'fal',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c44.2 0 80-35.8 80-80l0-377.4L308.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6 176 432c0 26.5-21.5 48-48 48L16 480z"]
};
var faLevelUp = faArrowTurnUp;
var faU = {
  prefix: 'fal',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M16 32c8.8 0 16 7.2 16 16V288c0 88.4 71.6 160 160 160s160-71.6 160-160V48c0-8.8 7.2-16 16-16s16 7.2 16 16V288c0 106-86 192-192 192S0 394 0 288V48c0-8.8 7.2-16 16-16z"]
};
var faArrowUpFromDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", "M235.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 86.6V192 336c0 8.8 7.2 16 16 16s16-7.2 16-16V192 86.6L340.7 187.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM152 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareRootVariable = {
  prefix: 'fal',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4L82.9 264.4c-2.8-5.2-8.2-8.4-14.1-8.4H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H68.8c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7C311.9 46.1 330.7 32 352.1 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H352.1zm52.6 180.7c6.2-6.2 16.4-6.2 22.6 0L480 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSquareRootAlt = faSquareRootVariable;
var faLightSwitchOn = {
  prefix: 'fal',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M176 48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H176V464c0-8.8 7.2-16 16-16s16 7.2 16 16v16H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H208V48c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM176 168h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48-24v96H256V144c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm0 224c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272H128v96zM96 144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V144z"]
};
var faArrowDownArrowUp = {
  prefix: 'fal',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M203.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm352-342.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96z"]
};
var faSortAlt = faArrowDownArrowUp;
var faRaindrops = {
  prefix: 'fal',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M160 85.6l-27.8 53c-2.7 5.2-4.2 11-4.2 16.9V160c0 17.7 14.3 32 32 32s32-14.3 32-32v-4.5c0-5.9-1.4-11.7-4.2-16.9L160 85.6zM148.3 39.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8V160c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM64 277.6l-27.8 53c-2.7 5.2-4.2 11-4.2 16.9V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-4.5c0-5.9-1.4-11.7-4.2-16.9L64 277.6zM52.3 231.1c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8V352c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM239 301.5c-9.8 15.3-15 33.1-15 51.3c0 52.3 43.2 95.2 96 95.2s96-42.9 96-95.2c0-18.2-5.2-36-15-51.3L320 174.9 239 301.5zm-27-17.2l95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5C441 304.7 448 328.5 448 352.8C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z"]
};
var faDash = {
  prefix: 'fal',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 256c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faMinusLarge = faDash;
var faClock = {
  prefix: 'fal',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faClockFour = faClock;
var faInputNumeric = {
  prefix: 'fal',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", "M576 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM96 176c0 8.8 7.2 16 16 16h16V320H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V176c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm168.7 27.4c9.4-11.3 26.2-12.6 37.2-2.9c10.8 9.5 11.9 25.9 2.5 36.7l-76.6 88.3c-4.1 4.7-5.1 11.4-2.5 17.1s8.3 9.4 14.6 9.4h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H275l53.6-61.9c20.9-24.2 18.4-60.7-5.6-81.8c-24.6-21.5-62-18.5-82.9 6.5l-12.4 14.9c-5.7 6.8-4.7 16.9 2 22.5s16.9 4.7 22.5-2l12.4-14.9z"]
};
var faTruckTow = {
  prefix: 'fal',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M96 64V176c0 26.5-21.5 48-48 48s-48-21.5-48-48V160c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 20.2 70.4 9.8 80 4.3C84.7 1.6 90.2 0 96 0h3.8 45.9c9.1 0 17.8 3.9 23.9 10.7L384 252V144c0-26.5 21.5-48 48-48h56.5c19.8 0 38.4 9.1 50.5 24.7l90.8 116.8c6.6 8.4 10.1 18.8 10.1 29.5V368c0 26.5-21.5 48-48 48H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48H192L96 64zM250.5 384H389.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H592c8.8 0 16-7.2 16-16V288H416 384 373.2 208 48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM416 416a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm97.8-275.6c-6.1-7.8-15.4-12.4-25.3-12.4H432c-8.8 0-16 7.2-16 16V256H603.7L513.8 140.4zM145.6 32l-29.9 0 112 224h117L145.6 32zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0z"]
};
var faBackwardStep = {
  prefix: 'fal',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", "M64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V241.9v28.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V296.2L242.6 441.8c5 4 11.2 6.2 17.6 6.2c15.4 0 27.8-12.4 27.8-27.8V91.8C288 76.4 275.6 64 260.2 64c-6.4 0-12.6 2.2-17.6 6.2L64 215.8V80zm192 20.6V411.4L65.3 256 256 100.6z"]
};
var faStepBackward = faBackwardStep;
var faPallet = {
  prefix: 'fal',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M16 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80 320 560h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H560 320 80 16zm80 32H304v96H96V384zm240 0H544v96H336V384z"]
};
var faCarBolt = {
  prefix: 'fal',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M113.6 98.2L85.3 192.6c3.5-.4 7.1-.6 10.7-.6h32v32H96c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3-.5-.1C49.6 236.7 32 260.3 32 288v96H480V288c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H384V192h32c3.6 0 7.2 .2 10.7 .6L398.4 98.2c-6.1-20.3-24.8-34.2-46-34.2H159.6c-21.2 0-39.9 13.9-46 34.2zM48.3 204.7l.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57H352.4c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 221.2 512 252.3 512 288v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416 400 384 288c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM299.3 123.3L230.6 192H320c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 224H192c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowsMaximize = {
  prefix: 'fal',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", "M336 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L256 233.4 86.6 64H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16V176c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6L233.4 256 64 425.4V336c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H86.6L256 278.6 425.4 448H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4L278.6 256 448 86.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H336z"]
};
var faExpandArrows = faArrowsMaximize;
var faFaucet = {
  prefix: 'fal',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H208v48H189.3c-12.7 0-24.9 5.1-33.9 14.1L121.4 256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H128c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7h69.5c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48c61.9 0 112 50.1 112 112c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16c0-26.5-21.5-48-48-48H307.2c-5.7 0-11 3-13.8 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H132.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48c0-79.5-64.5-144-144-144H326.6l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H240V160H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V80z"]
};
var faCloudSleet = {
  prefix: 'fal',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zm256 0c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l64-128zM192 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V368zm240-16c-8.8 0-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0V368c0-8.8-7.2-16-16-16z"]
};
var faLampStreet = {
  prefix: 'fal',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M32 168C32 92.9 92.9 32 168 32c72.7 0 132 57 135.8 128.7c-83.1 6.9-151.1 66.7-170.3 145.6C127.3 331.8 148.3 352 171 352H469c22.7 0 43.7-20.2 37.5-45.7c-19.3-79-87.5-138.9-170.7-145.7C332 71.3 258.3 0 168 0C75.2 0 0 75.2 0 168V496c0 8.8 7.2 16 16 16s16-7.2 16-16V168zm288 24c75.2 0 138.4 51.9 155.4 121.9c.3 1.4 0 2.6-1 3.8c-1.1 1.3-3 2.3-5.5 2.3H171c-2.4 0-4.4-1-5.5-2.3c-1-1.1-1.3-2.4-1-3.8C181.6 243.9 244.8 192 320 192zM241.6 384c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H365.3c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32H241.6z"]
};
var faListRadio = {
  prefix: 'fal',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M32 96a32 32 0 1 1 64 0A32 32 0 1 1 32 96zm96 0A64 64 0 1 0 0 96a64 64 0 1 0 128 0zm64 0c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z"]
};
var faPenNibSlash = {
  prefix: 'fal',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM478.3 232.3l75.1-75.1c25-25 25-65.5 0-90.5L509.3 22.6c-25-25-65.5-25-90.5 0L343.7 97.7l-80.3 21.9 31.2 24.7 52.6-14.4 98.9 98.9-7.9 28.9 27.3 21.5 12.8-46.9zM379 394.3c-.5 .2-1.1 .4-1.7 .5L129.3 469.3 239.5 359.1c9.5 5.6 20.6 8.9 32.5 8.9c18.7 0 35.6-8 47.3-20.8L294 327.2c-5.7 5.4-13.5 8.8-22 8.8c-17.7 0-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L219.1 268c-7 10.2-11.1 22.6-11.1 36c0 11.9 3.2 23 8.9 32.5L106.7 446.7l64.8-216.1-27-21.3L67.9 464.6c-3.7 12.3-.3 25.7 8.8 34.7s22.4 12.5 34.7 8.8l275.2-82.5c7.2-2.2 14-5.3 20.2-9.3L379 394.3zM441.4 45.3c12.5-12.5 32.8-12.5 45.3 0l44.1 44.1c12.5 12.5 12.5 32.8 0 45.3L464 201.4 374.6 112l66.7-66.7z"]
};
var faBaseballBatBall = {
  prefix: 'fal',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", "M416 0c-14.5 0-28.4 5.8-38.6 16L226.1 167.2c-9.7 9.7-18.4 20.3-26 31.7L125.2 311.3c-6.4 9.6-13.8 18.6-22 26.8L32 409.4l-4.7-4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L9.4 432l11.3 11.3 48 48L80 502.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-4.7-4.7 71.2-71.2c8.2-8.2 17.2-15.6 26.8-22l112.4-74.9c11.4-7.6 22-16.3 31.7-26L496 134.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L454.6 16C444.4 5.8 430.5 0 416 0zM80 457.4L54.6 432l71.2-71.2c.7-.7 1.4-1.4 2.1-2.1L153.4 384c-.7 .7-1.4 1.4-2.1 2.1L80 457.4zm98.1-93.9l-29.6-29.6c1.1-1.6 2.2-3.2 3.3-4.8l74.9-112.4c6.4-9.6 13.8-18.6 22-26.8L400 38.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L473.4 80c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L322.1 263.2c-8.2 8.2-17.2 15.6-26.8 22L182.9 360.1c-1.6 1.1-3.2 2.2-4.8 3.3zM384 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faSquareUpLeft = {
  prefix: 'fal',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 88V297.4c0 3.7 3 6.6 6.6 6.6c1.8 0 3.4-.7 4.7-1.9l25.4-25.4c6.2-6.2 16.4-6.2 22.6 0l59.1 59.1c3.6 3.6 9 4.9 13.9 3.3c2-.7 3.8-1.8 5.3-3.3l22.1-22.1c1.5-1.5 2.6-3.3 3.3-5.3c1.6-4.9 .4-10.3-3.3-13.9l-59.1-59.1c-6.2-6.2-6.2-16.4 0-22.6l25.4-25.4c1.2-1.2 1.9-2.9 1.9-4.7c0-3.7-3-6.6-6.6-6.6H152c-4.4 0-8 3.6-8 8zm8-40H265.4c21.3 0 38.6 17.3 38.6 38.6c0 10.2-4.1 20.1-11.3 27.3L278.6 224l47.7 47.7c12.2 12.2 16.5 30.3 11 46.7c-2.2 6.7-6 12.8-11 17.8l-22.1 22.1c-5 5-11.1 8.8-17.8 11c-16.4 5.5-34.5 1.2-46.7-11L192 310.6l-14.1 14.1c-7.2 7.2-17.1 11.3-27.3 11.3c-21.3 0-38.6-17.3-38.6-38.6V184c0-22.1 17.9-40 40-40z"]
};
var faOverline = {
  prefix: 'fal',
  iconName: 'overline',
  icon: [448, 512, [], "f876", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm208 96c-88.4 0-160 71.6-160 160v32c0 88.4 71.6 160 160 160s160-71.6 160-160V288c0-88.4-71.6-160-160-160zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v32c0 70.7-57.3 128-128 128s-128-57.3-128-128V288z"]
};
var faS = {
  prefix: 'fal',
  iconName: 's',
  icon: [320, 512, [115], "53", "M83.4 75.8c-27.8 11.5-45.1 30.6-49.8 56.6c-3.3 18.2-1.2 31.7 3.6 42.3c4.9 10.7 13.4 19.8 25.5 27.9c25 16.7 61.4 27 101.5 38c.6 .2 1.1 .3 1.7 .5c38 10.5 79.3 21.8 109.1 41.8c15.5 10.4 28.7 23.6 36.8 41.1c8.1 17.5 10.3 37.9 6.1 61.3c-7 39-33.3 65.8-69.1 80.6c-35.3 14.5-80.2 17.7-127.9 10.5l-.1 0c-25-3.9-66.1-17.4-94.4-26.7c-5.7-1.9-10.9-3.6-15.3-5c-8.4-2.7-13-11.7-10.4-20.1s11.7-13 20.1-10.4c5 1.6 10.7 3.5 16.8 5.5c28.5 9.3 65.9 21.6 88 25.1c44 6.6 82.6 3.2 110.9-8.4c27.8-11.5 45.1-30.6 49.8-56.6c3.3-18.2 1.2-31.7-3.6-42.3c-4.9-10.7-13.4-19.8-25.5-27.9c-25-16.7-61.4-27-101.5-38l-1.7-.5c-38-10.5-79.3-21.8-109.1-41.8c-15.5-10.4-28.7-23.6-36.8-41.1C.1 170.5-2.1 150.2 2.1 126.8c7-39 33.3-65.8 69.1-80.6c35.3-14.5 80.2-17.7 127.9-10.5C213.4 37.9 256.9 46 272 49.8c8.6 2.2 13.7 10.9 11.5 19.5S272.6 83 264 80.8c-13.6-3.5-55.9-11.4-69.7-13.5l2.4-15.8-2.4 15.8c-44-6.6-82.7-3.3-111 8.4z"]
};
var faTimeline = {
  prefix: 'fal',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", "M144 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 94c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62V256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H320v82c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V288H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V142c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62V256H160V142zM336 464a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM496 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faKeyboard = {
  prefix: 'fal',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm88 8h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V152c0-8.8 7.2-16 16-16zM72 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V248zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V344c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H376c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H376c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V152zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V248c0-8.8 7.2-16 16-16zM456 344c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V344zm-280-8H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faArrowsFromDottedLine = {
  prefix: 'fal',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", "M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM8 256a24 24 0 1 0 48 0A24 24 0 1 0 8 256zm384 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM200 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm96 280c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4 240 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z"]
};
var faUsbDrive = {
  prefix: 'fal',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", "M64 128c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H416V128H64zM0 160c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160zM480 384V352H608V160H480V128H608c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H480zm96-176a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM560 320a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faBallot = {
  prefix: 'fal',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H88zM72 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zM88 360c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V376c0-8.8-7.2-16-16-16H88z"]
};
var faCaretDown = {
  prefix: 'fal',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M165.6 349.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 236.3c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1l241.7 0c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 349.8zm22 23.3L307.7 259.6c7.8-7.4 12.3-17.7 12.3-28.4c0-21.6-17.5-39.1-39.1-39.1L39.1 192C17.5 192 0 209.5 0 231.1c0 10.8 4.4 21.1 12.3 28.4L132.4 373.1c7.4 7 17.3 10.9 27.6 10.9s20.1-3.9 27.6-10.9z"]
};
var faLocationDotSlash = {
  prefix: 'fal',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", "M385.8 389.5c-24.4 35.2-48.5 66.5-65.8 88.1c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0c17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9zM320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 15.6-5.4 37-16.6 63.4c-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192C512 86 426 0 320 0zm80 192c0-44.2-35.8-80-80-80c-20.5 0-39.2 7.7-53.3 20.4l25.8 20.3c7.8-5.5 17.3-8.7 27.6-8.7c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7L390.4 230c6.1-11.3 9.6-24.3 9.6-38zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMapMarkerAltSlash = faLocationDotSlash;
var faCards = {
  prefix: 'fal',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", "M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6c0 0 .1 0 .1-.1L427.4 365.5c0 0 .1 0 .1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3c0 .1 .1 .1 .1 .2l167 289.3c0 .1 .1 .1 .1 .2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9c-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8c-.2 .1-.5 .3-.7 .4l-192.3 111c-.2 .1-.5 .3-.7 .4c-26.4 14.9-59.8 6-75.3-20zM360 512c-13.7 0-26.2-4.9-35.9-13l33.2-19.1c.9 .1 1.8 .2 2.7 .2H584c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H373L354.7 64.2c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360zM469.4 162.8l-.1 .1 0 0c-6.7 5.7-7 16-1.1 22.2l0 0 35.9 37 35.7-37 0 0c5.9-6.1 5.6-16.4-.9-22.2c-5.1-4.2-13.4-4-19.1 1.7l-3.9 4.3c-3 3.3-7.2 5.2-11.7 5.3s-8.7-1.7-11.8-5l-4.3-4.5c-5.9-5.9-14.4-5.8-18.9-1.9zm-21-24.2c16.5-14.3 39.3-13.3 55.6-2.2c16.2-11.1 38.9-11.9 55.6 2.1l.2 .2 0 0c20.5 17.9 21.5 49.4 3 68.6l0 0L520.6 251l-.2 .2 0 0c-8.8 8.8-23.7 9.5-33-.3l-42.3-43.6 0 0c-18.5-19.2-17.6-50.8 3.2-68.7zM252.2 340.4l48.2-27.8c7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9l-48.2 27.8c-7.7 4.4-17.4 1.8-21.9-5.9s-1.8-17.4 5.9-21.9zm-27-40.1l5.9-27.4c.9-4.4 3.6-8.1 7.5-10.4s8.4-2.9 12.7-1.6l27.6 8.1c12.9 3.5 26.2-3.2 29.6-13.2l0-.1c5-14.2-3.4-30-17.5-34l0 0-90.2-25.7-22.6 90.8 0 0c-3.5 14.2 5.8 29.3 20.3 32.3c10.9 1.8 23-5.6 26.7-18.9zm31 7.9c-7.4 27.8-34.3 47.5-63.4 42.5l-.4-.1 0 0c-32.7-6.5-53.3-39.7-45.3-71.5l26.6-106.9c1-4.2 3.8-7.8 7.5-10s8.2-2.7 12.4-1.5L299.9 191l0 0c31.5 9.1 50 43.5 38.8 75.4c-10.1 29.4-42.9 40.6-68.5 33.6l-.3-.1 0 0-11.2-3.3-2.4 10.9c-.1 .2-.1 .5-.2 .7z"]
};
var faHouseChimneyMedical = {
  prefix: 'fal',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM272 176h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H336v32c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V336H208c-17.7 0-32-14.3-32-32V272c0-17.7 14.3-32 32-32h32V208c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H208v32h48c8.8 0 16 7.2 16 16v48h32V320c0-8.8 7.2-16 16-16h48V272H320c-8.8 0-16-7.2-16-16V208H272z"]
};
var faClinicMedical = faHouseChimneyMedical;
var faBoxingGlove = {
  prefix: 'fal',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M32 112c0-44.2 35.8-80 80-80H272c44.2 0 80 35.8 80 80v16H336c-38.7 0-71 27.5-78.4 64H144c-26.5 0-48-21.5-48-48v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 44.2 35.8 80 80 80H257.6c7.4 36.5 39.7 64 78.4 64c8.8 0 16-7.2 16-16s-7.2-16-16-16c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c26.5 0 48 21.5 48 48v38.9c0 17-6.7 33.3-18.7 45.3L336.4 353c-10.5 10.5-16.4 24.7-16.4 39.6V456c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V351.6c0-4.6-1.9-8.9-5.3-11.9C42.3 325 32 303.7 32 280V112zM112 0C50.1 0 0 50.1 0 112V280c0 30.5 12.2 58.2 32 78.4V456c0 30.9 25.1 56 56 56H296c30.9 0 56-25.1 56-56V392.6c0-6.4 2.5-12.5 7-17l60.9-60.9c18-18 28.1-42.4 28.1-67.9V208c0-38.7-27.5-71-64-78.4V112C384 50.1 333.9 0 272 0H112zm40.9 338.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 403.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 364.8l-39.1-26.1z"]
};
var faGloveBoxing = faBoxingGlove;
var faTemperatureThreeQuarters = {
  prefix: 'fal',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V144c0-8.8 7.2-16 16-16s16 7.2 16 16V306c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faBellSchool = {
  prefix: 'fal',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", "M208 384a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0 32c-41.2 0-79.7-12-112-32.7V448c0 17.7 14.3 32 32 32H272h16c17.7 0 32-14.3 32-32V383.3C287.7 404 249.2 416 208 416zm64 96H128c-35.3 0-64-28.7-64-64V358.1C24.6 320.2 0 267 0 208C0 93.1 93.1 0 208 0S416 93.1 416 208c0 59-24.6 112.2-64 150.1V448c0 11.7-3.1 22.6-8.6 32H416c17.7 0 32-14.3 32-32v-2.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3V448c0 35.3-28.7 64-64 64H288 272zM256 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM464 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faMobileScreen = {
  prefix: 'fal',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M288 32c17.7 0 32 14.3 32 32V320H64V64c0-17.7 14.3-32 32-32H288zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352H320zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm48 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16z"]
};
var faMobileAndroidAlt = faMobileScreen;
var faPlaneUp = {
  prefix: 'fal',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M221.2 13.3C230.8 5.7 242.6 0 256 0c26.9 0 47.1 21.6 59.2 41.8C327.9 62.9 336 89.1 336 109.7v52.5l151.8 86.8c15 8.5 24.2 24.5 24.2 41.7v56.2c0 21.3-20.3 36.6-40.8 30.8L336 338.9V376l51.2 38.4c8.1 6 12.8 15.5 12.8 25.6v42c0 16.6-13.4 30-30 30c-2.8 0-5.6-.4-8.2-1.2l0 0L256 480.6 150.3 510.8l0 0c-2.7 .8-5.5 1.2-8.3 1.2c-16.6 0-30-13.4-30-30V440c0-10.1 4.7-19.6 12.8-25.6L176 376l0-37.1L40.8 377.6C20.3 383.4 0 368 0 346.8V290.6c0-17.2 9.2-33.1 24.2-41.7L176 162.1V109.7c0-20.7 8.4-46.9 21.2-67.9c6.5-10.7 14.5-20.8 24-28.4zm3.3 45C214.1 75.6 208 96.2 208 109.7v61.7c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9v56.2l155.6-44.5c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8l0 66.3c0 5-2.4 9.8-6.4 12.8L144 440v39.4l107.6-30.7c2.9-.8 5.9-.8 8.8 0L368 479.4V440l-57.6-43.2c-4-3-6.4-7.8-6.4-12.8V317.7c0-5 2.4-9.8 6.4-12.8s9.2-4 14-2.6L480 346.8V290.6c0-5.7-3.1-11-8.1-13.9L312.1 185.3c-5-2.8-8.1-8.2-8.1-13.9V109.7c0-13.6-5.9-34.2-16.2-51.4C276.9 40.2 265.1 32 256 32c-4.1 0-9 1.7-14.8 6.3c-5.8 4.6-11.5 11.5-16.7 20z"]
};
var faFolderHeart = {
  prefix: 'fal',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM176 253.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 345.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 192c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faCircleLocationArrow = {
  prefix: 'fal',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm127.7 27c-11.7 0-21.9-8.3-24.2-19.8c-2.4-11.4 3.7-23.1 14.5-27.7L338.5 141c9.5-3.9 20.2-1.9 27.3 5.3c7.2 7.1 9.2 17.8 5.2 27.2L276.5 394c-3.9 9.1-12.9 15-22.8 15c-1.6 0-3.3-.1-4.9-.5C237.3 406.2 229 396 229 384.2V315 283H197 127.7zm35.3-32H229c17.7 0 32 14.3 32 32v66l73.5-171.4L163.1 251z"]
};
var faLocationCircle = faCircleLocationArrow;
var faFaceHeadBandage = {
  prefix: 'fal',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M288 32c2.4 0 4.9 0 7.3 .1c-29.3 9.7-57.6 21.4-84.8 35c-17.1 1.4-34.1 3.2-51 5.4C195.8 47 240.2 32 288 32zm80.1-19.2C342.9 4.5 316 0 288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2c-8.2 2-15.3 7.1-19.7 14.3C26.9 130.6 15 158.9 7.8 189c-2.4 10.2 .3 20.9 7.2 28.7c-2.5 2.8-4.9 5.6-7.3 8.5c-4.7 5.5-7.3 12.4-7.6 19.6C.1 249.2 0 252.6 0 256c0 31.4 5 61.7 14.4 90.1c3.8 11.6 13.9 20 26 21.7s24.1-3.7 30.9-13.8c31.3-46.3 69.9-87.2 114.1-121c-.7 2.2-1.1 4.6-1.1 7.1c0 13.3 10.7 24 24 24s24-10.7 24-24c0-13.1-10.5-23.7-23.5-24c12-8.2 24.4-15.8 37.2-23c13.9-.7 27.9-1 41.9-1c83.4 0 163.9 12.3 239.8 35.1c11 3.3 22.8 .5 31.2-7.4s11.8-19.6 9.2-30.7c-7.2-30.1-19.1-58.4-34.9-84.1c-3.3-5.3-8-9.5-13.5-12.1c-.6-6-2.9-11.9-6.9-16.8c-21.2-26.5-47-49.1-76.2-66.8c-6.1-3.7-13.4-5.2-20.5-4.4c-16.2 2-32.2 4.6-48.1 7.9zM506.3 122.2c7.3 11.9 13.7 24.4 19 37.5c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26c-.3 0-.5 0-.8 0c-9.1-.3-18.3-.4-27.5-.4c-17.1 0-34.1 .5-51 1.5c-48.2 2.8-95.4 9.6-141.2 20c-7 1.6-13.9 3.3-20.9 5c-12.1 3.1-24.1 6.4-36 10c.5-2 1-4 1.5-6c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38c23.2-5.6 46.8-10.3 70.7-14.1c0 0 0 0 0 0c.8-.1 1.6-.3 2.5-.4c25-3.9 50.4-6.9 76.1-8.7c0 0 0 0 0 0s0 0 0 0C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4c2.2 .3 4.4 .6 6.6 .9c31.7 4.3 62.9 10.1 93.5 17.5c.1 .2 .2 .3 .3 .5zM177 199.3c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5c41-12.2 83.3-21.3 126.6-27.1zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2C419.3 71.1 360.6 64.9 300.6 64.1zm242.8 209c.6-8.8-6.1-16.4-14.9-17s-16.4 6.1-17 14.9C503.8 387.7 406.7 480 288 480c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C129.9 471.8 204.2 512 288 512c135.7 0 246.7-105.5 255.4-238.9zM373.2 397.5c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6C373.2 354.3 340.2 336 296 336c-16.4 0-31.4 2.5-44.8 6.8c-8.4 2.7-13.1 11.6-10.5 20.1s11.6 13.1 20.1 10.5c10.4-3.3 22.1-5.3 35.2-5.3c34.8 0 60.4 14.2 77.2 29.5zM392.4 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSushiRoll = {
  prefix: 'fal',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M448 136c0-22.4-12.2-39.9-25.9-52C408.5 71.9 390.5 62.4 371 55.1C331.8 40.4 279.8 32 224 32s-107.8 8.4-147 23.1C57.5 62.4 39.5 71.9 25.9 84C12.2 96.1 0 113.6 0 136V352c0 45.2 35.8 77.4 73.9 96.5C114 468.5 167.1 480 224 480s110-11.5 150.1-31.5C412.2 429.4 448 397.2 448 352V136zm-32 0c0 14.8-11.9 28.6-32.3 40c-89.2-.1-143.5-58.9-143.7-111.8c98.6 3 176 34 176 71.8zM32 136c0-37.7 77.4-68.7 176-71.8c0 12.5 2.1 24.9 6 36.7c-17.9 4.6-39.3 11.9-60.8 22.7c-26.7 13.4-54.4 32.6-75.2 59.1C49.3 170.2 32 153.9 32 136zm78.4 58.1c16.1-17.5 36.3-31.3 57.2-41.8c22-11 43.8-18 60.5-21.8c19.3 30.3 51.4 55 92 67.8C291.8 204.5 259 208 224 208c-42.5 0-81.8-5.2-113.6-13.9zM32 193c12.7 9.7 28.3 17.6 45 23.8c39.2 14.7 91.2 23.1 147 23.1s107.8-8.4 147-23.1c16.7-6.3 32.3-14.1 45-23.8V352c0 53-86 96-192 96s-192-43-192-96V193z"]
};
var faMakiRoll = faSushiRoll;
var faMakizushi = faSushiRoll;
var faCarBump = {
  prefix: 'fal',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", "M131.7 88.2L304.3 41.9c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6 .5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8C39.5 271.5 30.2 304.8 39 337.6l22 82.1L65.3 436l0 0 15.8 58.8c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6L98.7 442.8l1.5-.4L508.7 332.9l1.5-.4L522 376.6c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1 0 0-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4L384.8 46.2C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9L60.9 243.3zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0 -44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zM420.4 262a22.8 22.8 0 1 0 -11.8-44.1A22.8 22.8 0 1 0 420.4 262zm43.4 236.2c4.1-28.4 28.5-50.3 58.1-50.3s54 21.8 58.1 50.3c1.3 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1c-6.3-44-44.1-77.7-89.8-77.7s-83.5 33.8-89.8 77.7c-1.3 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6z"]
};
var faPiggyBank = {
  prefix: 'fal',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M272 32c34.8 0 64.5 22.2 75.5 53.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C362.3 31.2 320.8 0 272 0C216.5 0 170.4 40.4 161.5 93.4c-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1C199.5 60.8 232.4 32 272 32zM55.2 190.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L36.2 164C14 175.1 0 197.8 0 222.6c0 35.7 28.5 64.7 64 65.4c0 0 0 0 0 0c0 52.4 25.2 98.8 64 128v48c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V448h64v16c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V434.7c25.5-11.1 47.5-28.7 64-50.7h32c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H530.7c-10.7-24.6-27.4-45.9-48.3-62.2l7.2-25C495.4 116.3 480 96 458.8 96H456c-30.5 0-58.2 12.2-78.4 32H224c-77.4 0-142 55-156.8 128H65.4C47 256 32 241 32 222.6c0-12.7 7.2-24.2 18.5-29.9l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM396.4 154.7C411 138.3 432.3 128 456 128h2.8l-10.2 35.8c-1.9 6.7 .7 13.8 6.5 17.7c22.8 15.2 40.4 37.6 49.7 63.8c2.3 6.4 8.3 10.7 15.1 10.7H544v96H503.8c-5.3 0-10.3 2.7-13.3 7.1c-15.2 22.8-37.6 40.4-63.8 49.6C420.3 411 416 417 416 423.8V464c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V432c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V407.8c0-5.3-2.7-10.3-7.1-13.3C118.6 371.5 96 332.4 96 288c0-70.7 57.3-128 128-128H384h0l.4 0c4.6 0 8.9-1.9 11.9-5.3z"]
};
var faRacquet = {
  prefix: 'fal',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", "M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7c7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3c72.5 39.4 169.9 17.5 234.7-47.4c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32L64 480 32 448l72-72z"]
};
var faCarMirrors = {
  prefix: 'fal',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M191.6 64c-21.2 0-39.9 13.9-46 34.2l-28.3 94.4c3.5-.4 7.1-.6 10.7-.6H448c3.6 0 7.2 .2 10.7 .6L430.4 98.2c-6.1-20.3-24.8-34.2-46-34.2H191.6zM106.7 227.9l-.5-.1C81.6 236.7 64 260.3 64 288v96H512V288c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H128c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3zM56.4 224H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H84.1L115 89c10.2-33.8 41.3-57 76.6-57H384.4c35.3 0 66.5 23.2 76.6 57l30.9 103H544c8.8 0 16 7.2 16 16s-7.2 16-16 16H519.6c15.2 17 24.4 39.4 24.4 64v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416 400 384 288c0-24.6 9.2-47 24.4-64zM112 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faIndustryWindows = {
  prefix: 'fal',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", "M64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V229.3c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l138.7-92.5c5.3-3.5 12.4 .3 12.4 6.7v81.9c0 6 3.4 11.5 8.7 14.2s11.8 2.3 16.6-1.3l138-99.3c5.3-3.8 12.7 0 12.7 6.5V304v16 96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352 304 80zM80 32C53.5 32 32 53.5 32 80V304v48 64c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64V320 304 158.9c0-32.6-36.9-51.5-63.4-32.5L368 207.5V156.8c0-31.9-35.6-51-62.2-33.3L192 199.4V80c0-26.5-21.5-48-48-48H80zm56 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H136zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H264c-13.3 0-24 10.7-24 24zm32 40V336h32v32H272zm120-64c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24H392zm40 64H400V336h32v32zm-288 0V336h32v32H144z"]
};
var faIndustryAlt = faIndustryWindows;
var faBoltAuto = {
  prefix: 'fal',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M291.4 0c-6.1 0-12 2.2-16.5 6.3L8.7 242.9C3.2 247.8 0 254.8 0 262.2C0 276.4 11.6 288 25.8 288H137.3L69.2 478.7C63.4 494.9 75.4 512 92.6 512c6.1 0 11.9-2.2 16.5-6.2L374.9 271.3c5.8-5.1 9.1-12.5 9.1-20.3c0-14.9-12.1-27-27-27H246.7L314.8 33.3C320.6 17.1 308.6 0 291.4 0zM42.1 256L275.3 48.7l-66.4 186c-1.8 4.9-1 10.3 2 14.6s7.9 6.8 13.1 6.8H343.8L108.6 463.6l66.5-186.2c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8H42.1zM464 288c-6.1 0-11.6 3.4-14.3 8.8l-96 192c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L401.9 464H526.1l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-96-192c-2.7-5.4-8.2-8.8-14.3-8.8zm0 51.8L510.1 432H417.9L464 339.8z"]
};
var faBatteryHalf = {
  prefix: 'fal',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192H240c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112z"]
};
var faBattery3 = faBatteryHalf;
var faFluxCapacitor = {
  prefix: 'fal',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM292.7 255.2c3.7 .5 7.5 .8 11.3 .8c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c3.8 0 7.6-.3 11.3-.8l-45.3-45.3c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0L224 188.1l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-45.3 45.3zM173.8 273.7C155.6 288.4 144 310.8 144 336c0 44.2 35.8 80 80 80s80-35.8 80-80c0-25.2-11.6-47.6-29.8-62.3l-2.2 2.2V336c0 26.5-21.5 48-48 48s-48-21.5-48-48V275.9l-2.2-2.2zm-18.5-109c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V262.6l75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z"]
};
var faMountainCity = {
  prefix: 'fal',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M320 48c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V208c0 8.8 7.2 16 16 16h64 32c8.8 0 16 7.2 16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-26.5-21.5-48-48-48H576V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H512V48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v92.1l32 53V48zM226 161.2L302.5 288H223c-5 0-9.8 2.4-12.8 6.4l-34.7 46.2-33-47.7L222 161.2c.5-.9 1.3-1.2 2-1.2s1.5 .3 2 1.2zM32.5 475.4l92-152.4 37.4 54.1c2.9 4.2 7.7 6.8 12.9 6.9s10-2.3 13.1-6.4L231 320h90.8l93.8 155.4c.6 1 .6 2.2 .1 3.3c-.5 1-1.4 1.3-2.1 1.3H34.5c-.7 0-1.5-.4-2.1-1.3c-.6-1-.5-2.3 .1-3.3zM253.4 144.7C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7zM352 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm64 0v32H384V96h32zm-32 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7-14.3-32-32-32H384zm96 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32zm64 0v32H512V288h32zm-32 96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H512zm0 32h32v32H512V416z"]
};
var faCoins = {
  prefix: 'fal',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M160 80c0 2.4 1.3 6.8 8.3 12.8c1.4 1.2 2.9 2.4 4.6 3.6c-15.4 .6-30.4 1.9-44.9 3.9V80c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C224.1 7.3 270 0 320 0s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2C503.4 52.3 512 64.7 512 80l0 104 0 0 0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4c-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V231.7c-8.7 5.6-18.8 10.5-29.9 14.7c-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V126.1c-8.8 5.4-19 10.1-30.1 14.1c-17.3 6.3-37.6 11.3-60 14.6c-1.9-1.9-3.8-3.8-5.7-5.5c-10.1-9.1-21.7-16.4-33.8-22.5c34.8-2.3 65.4-8.4 88.5-16.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C409.3 39 367.2 32 320 32s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM32 208c0 2.4 1.3 6.8 8.3 12.8c6.9 5.9 17.8 12 32.8 17.4C102.7 249 144.8 256 192 256s89.3-7 119-17.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C281.3 167 239.2 160 192 160s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM0 208c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C96.1 135.3 142 128 192 128s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2c10.9 9.3 19.4 21.8 19.4 37l0 104 0 0 0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4C288.1 501.3 242 509 192 509s-96.1-7.7-130.1-20.7c-17-6.5-31.8-14.6-42.7-24.4S0 441.3 0 425.9V312 208zm352 46.1c-8.8 5.4-19 10.1-30.1 14.1C287.9 280.7 242 288 192 288s-95.9-7.3-129.9-19.7c-11.1-4-21.3-8.7-30.1-14.1V312c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 355.7 144.8 363 192 363s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V254.1zM32 425.9c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 469.6 144.8 477 192 477s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V359.7c-8.7 5.6-18.8 10.5-29.9 14.7C288.1 387.4 242 395 192 395s-96.1-7.7-130.1-20.7c-11-4.2-21.1-9.1-29.9-14.7v66.2z"]
};
var faHoneyPot = {
  prefix: 'fal',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M128 64h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V64h32H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 224v32h96c53 0 96 43 96 96H32c0-53 43-96 96-96V96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h48zM447.8 237.2c.2-4.3 .2-8.7 .2-13.2c0-42.9-21.1-80.8-53.4-104c12.9-8.6 21.4-23.3 21.4-40c0-26.5-21.5-48-48-48H176 80C53.5 32 32 53.5 32 80c0 16.7 8.5 31.4 21.4 40C21.1 143.2 0 181.1 0 224c0 4.5 .1 8.9 .2 13.2C.1 238.1 0 239 0 240c0 1.5 .2 2.9 .6 4.3c7.2 126.3 80.7 199 112.7 224.9c9.3 7.5 21.1 10.9 33.1 10.9H301.6c12 0 23.7-3.3 33.1-10.9c32-25.9 105.5-98.6 112.7-224.9c.4-1.4 .6-2.8 .6-4.3c0-1-.1-1.9-.2-2.8zM414.4 256c-2.4 23.5-7.3 44.9-13.9 64c-.2 0-.3 0-.5 0H48c-.2 0-.3 0-.5 0C41 300.9 36 279.5 33.6 256H414.4zm-27.1 96c-23.4 47.9-55.2 78.1-72.7 92.3c-2.5 2-6.7 3.7-12.9 3.7H146.4c-6.3 0-10.5-1.7-12.9-3.7c-17.5-14.1-49.4-44.4-72.7-92.3H387.3z"]
};
var faOlive = {
  prefix: 'fal',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M160 448C89.3 448 32 390.7 32 320c0-84.8 39.8-148.3 91.7-191.4C176.5 84.7 239.5 64 280 64c18.4 0 39.8 9.7 59.3 22.6c9.2 6.1 16.9 12.3 22.3 16.9c2.7 2.3 4.8 4.2 6.1 5.4c.7 .6 1.2 1.1 1.5 1.4l.3 .3 .3 .3c.3 .3 .7 .8 1.4 1.5c1.3 1.3 3.1 3.4 5.4 6.1c4.6 5.4 10.8 13.1 16.9 22.3C406.3 160.2 416 181.6 416 200c0 40.5-20.7 103.5-64.6 156.3C308.3 408.2 244.8 448 160 448zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM260.4 132.4c3.6-3.6 11.2-6.2 24.2-3c12.6 3.2 27.6 11.5 41 24.9s21.8 28.4 24.9 41c3.2 13 .6 20.6-3 24.2s-11.2 6.2-24.2 3c-12.6-3.2-27.6-11.5-41-24.9s-21.8-28.4-24.9-41c-3.2-13-.6-20.6 3-24.2zm87.8-.7c-16.9-16.9-36.7-28.6-55.9-33.4c-18.8-4.7-39.9-3.2-54.5 11.4s-16.1 35.8-11.4 54.5c4.8 19.1 16.5 39 33.4 55.9s36.7 28.6 55.9 33.4c18.8 4.7 39.9 3.2 54.5-11.4s16.1-35.8 11.4-54.5c-4.8-19.1-16.5-39-33.4-55.9z"]
};
var faKhanda = {
  prefix: 'fal',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M266.2 3.7c-5.9-4.9-14.6-4.9-20.5 0l-48 40c-5.9 4.9-7.5 13.2-3.8 19.9l0 0 0 0 0 0 .1 .1 .3 .6c.3 .5 .7 1.3 1.2 2.3c1 2 2.6 5 4.4 8.6c.5 .9 .9 1.9 1.4 2.9C167.1 97.4 144 134 144 176s23.1 78.6 57.3 97.8c-.5 1-1 2-1.4 2.9c-1.8 3.7-3.3 6.6-4.4 8.6c-.5 1-.9 1.8-1.2 2.3l-.3 .6-.1 .1 0 0 0 0 0 0c-3.6 6.7-2 15 3.8 19.9L240 343.5v19.1l-34.6-23.8-41.1-28.2c-42.8-29.4-68.4-78-68.4-130c0-31.1 9.2-61.6 26.5-87.5l2.8-4.2c4-6 3.5-14-1.3-19.5s-12.7-7-19.2-3.7L112 80c-7.2-14.3-7.2-14.3-7.2-14.3l0 0 0 0-.1 0-.3 .2-1 .5c-.8 .4-2 1.1-3.5 1.9C97 70 93 72.5 88.1 75.7c-9.7 6.4-22.5 16.1-35.4 29C26.9 130.4 0 170.3 0 224c0 53.1 26.4 100.5 51.2 133.6c12.6 16.7 25.1 30.3 34.5 39.7c4.7 4.7 8.7 8.4 11.5 10.9c1.4 1.3 2.5 2.2 3.3 2.9l.9 .8 .3 .2 .1 .1 0 0 0 0s0 0 10.3-12.3l-10.2 12.3c5.1 4.3 12.4 4.9 18.2 1.6l75.6-43 32.7 22.5-45.8 31.5c-2.1-.6-4.2-.9-6.5-.9c-13.3 0-24 10.7-24 24s10.7 24 24 24c11.9 0 21.8-8.7 23.7-20.1L240 424.1v28.1c-9.6 5.5-16 15.9-16 27.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7V423.4L312.2 451c1.5 11.8 11.6 21 23.8 21c13.3 0 24-10.7 24-24s-10.7-24-24-24c-2 0-3.9 .2-5.7 .7l-45.5-31.3 32.7-22.5 75.6 43c5.8 3.3 13 2.7 18.2-1.6L401.1 400c10.2 12.3 10.2 12.3 10.2 12.3l0 0 0 0 .1-.1 .3-.2 .9-.8c.8-.7 1.9-1.7 3.3-2.9c2.8-2.5 6.7-6.2 11.5-10.9c9.4-9.4 21.9-23 34.5-39.7c24.8-33.1 51.2-80.5 51.2-133.6c0-53.7-26.9-93.6-52.7-119.3c-12.9-12.9-25.8-22.6-35.4-29c-4.8-3.2-8.9-5.7-11.8-7.3c-1.5-.8-2.6-1.5-3.5-1.9l-1-.5-.3-.2-.1 0 0 0 0 0s0 0-7.2 14.3l7.2-14.3c-6.5-3.2-14.3-1.7-19.2 3.7s-5.3 13.4-1.3 19.5l2.8 4.2c17.3 25.9 26.5 56.4 26.5 87.5c0 51.9-25.6 100.6-68.4 130l-41.1 28.2L272 363.3V343.5l42.2-35.2c5.9-4.9 7.5-13.2 3.8-19.9l0 0 0 0-.1-.1-.3-.6c-.3-.5-.7-1.3-1.2-2.3c-1-2-2.6-5-4.4-8.6c-.5-.9-.9-1.9-1.4-2.9C344.9 254.6 368 218 368 176s-23.1-78.6-57.3-97.8c.5-1 1-2 1.4-2.9c1.8-3.7 3.3-6.6 4.4-8.6c.5-1 .9-1.8 1.2-2.3l.3-.6 .1-.1 0 0 0 0 0 0 0 0c3.6-6.7 2-15-3.8-19.9l-48-40zm31.3 103.9c23 14 38.4 39.4 38.4 68.4s-15.4 54.3-38.4 68.4C288.1 221 280 195 280 176s8.1-45 17.6-68.4zM214.4 244.4c-23-14-38.4-39.4-38.4-68.4s15.4-54.3 38.4-68.4C223.9 131 232 157 232 176s-8.1 45-17.6 68.4zM228.6 61.2l-.5-1.1L256 36.8l27.9 23.3-.5 1.1c-3.9 7.8-9 18.8-14.2 31.3c-4.6 11-9.3 23.7-13.2 36.8c-3.9-13.1-8.7-25.8-13.2-36.8C237.6 80 232.5 69 228.6 61.2zm14.2 198.4c4.6-11 9.3-23.7 13.2-36.8c3.9 13.1 8.7 25.8 13.2 36.8c5.2 12.5 10.3 23.5 14.2 31.3l.5 1.1L256 315.2l-27.9-23.3 .5-1.1c3.9-7.8 9-18.8 14.2-31.3zM70.2 132.7c-4.1 15.6-6.2 31.7-6.2 47.9c0 62.5 30.8 121 82.2 156.4l20 13.8-52.1 29.7c-1.7-1.6-3.7-3.5-5.8-5.7c-8.6-8.6-20.1-21-31.5-36.3C53.6 307.5 32 266.9 32 224c0-39 17.9-69.4 38.2-91.3zM481.1 224c0 42.9-21.6 83.5-44.8 114.4c-11.4 15.3-22.9 27.7-31.5 36.3c-2.1 2.1-4.1 4-5.8 5.7l-52.1-29.7 20-13.8c51.5-35.4 82.2-93.9 82.2-156.4c0-16.3-2.1-32.4-6.2-47.9c20.2 21.9 38.2 52.3 38.2 91.3z"]
};
var faFilterList = {
  prefix: 'fal',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", "M27.6 64C12.4 64 0 76.4 0 91.6c0 6.7 2.4 13.2 6.8 18.2L112 230V360c0 10 4.7 19.5 12.7 25.5l76.2 57.5c4.2 3.2 9.4 4.9 14.7 4.9c13.5 0 24.4-10.9 24.4-24.4V230L345.2 109.8c4.4-5 6.8-11.5 6.8-18.2C352 76.4 339.6 64 324.4 64H27.6zM140 213.5L37.3 96H314.7L212 213.5c-2.6 2.9-4 6.7-4 10.5V408.3L144 360V224c0-3.9-1.4-7.6-4-10.5zM336 400c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336zM320 256c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM400 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H400z"]
};
var faOutlet = {
  prefix: 'fal',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 256c0 49.2 24.6 79.3 39.5 93.1c1.2 1.1 4.3 2.9 10.9 2.9H301.6c6.6 0 9.7-1.8 10.9-2.9C327.4 335.3 352 305.2 352 256s-24.6-79.3-39.5-93.1c-1.2-1.1-4.3-2.9-10.9-2.9H146.4c-6.6 0-9.7 1.8-10.9 2.9C120.6 176.7 96 206.8 96 256zm-32 0c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4H301.6c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm112-64c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm-48 96c13.3 0 24 10.7 24 24v16c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8V312c0-13.3 10.7-24 24-24z"]
};
var faSliders = {
  prefix: 'fal',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"]
};
var faSlidersH = faSliders;
var faCauldron = {
  prefix: 'fal',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 24a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM60.1 244.9C72 223 85.2 204.3 94.9 192H224 353.1c9.7 12.3 22.9 31 34.8 52.9C404.3 275 416 307.1 416 334.4c0 45.1-21.4 80.4-56.1 105.5C324.5 465.5 275.4 480 224 480s-100.5-14.5-135.9-40.1C53.4 414.8 32 379.5 32 334.4c0-27.3 11.7-59.4 28.1-89.5zM55.2 192C30.2 228.1 0 283.9 0 334.4c0 37.4 11.9 69.4 32 95.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V461.8C106.3 494.6 164.6 512 224 512s117.7-17.4 160-50.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V429.9c20.1-26.1 32-58.1 32-95.5c0-50.5-30.2-106.3-55.2-142.4H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H368 224 80 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H55.2z"]
};
var faPeople = {
  prefix: 'fal',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM147.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H128V164c6-2.6 12.5-4 19.3-4zM128 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-13.9-26-41-42.3-70.6-42.3H147.3c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H528 432 393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6z"]
};
var faFolderTree = {
  prefix: 'fal',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16v96V368c0 26.5 21.5 48 48 48H256V384H48c-8.8 0-16-7.2-16-16V128H256V96H32V16zM394.7 32l21.7 21.7C423 60.3 432 64 441.3 64H544V192H320V32l74.7 0zM288 32V192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9L417.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm32 288h74.7l21.7 21.7C423 348.3 432 352 441.3 352H544V480H320V320zm-32 0V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z"]
};
var faNetworkWired = {
  prefix: 'fal',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M400 32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H336 304 240c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16H400zM336 192h64c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h64v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H144v48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H176V272H464v48H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H496V272H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V192zM496 352h64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h64 32zm-320 0h64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h64 32z"]
};
var faCroissant = {
  prefix: 'fal',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M32 288c0-15.3 1.3-30.2 3.9-44.7l169.6 68.4-124 96.4-11.7 8.3c-.9 .2-1.7 .3-2.3 .2c-.6-.1-.9-.2-1-.3l0 0c-.1 0-.2-.2-.5-.6C44.4 378.1 32 334.6 32 288zM7.4 222.9C2.6 243.8 0 265.6 0 288c0 52.3 14 101.4 38.4 143.7c9.3 16.2 28.9 20.8 45.3 13.7c25.7 27.9 57.4 50 93.2 64.3c3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6c0-1.6-.1-3.3-.4-4.9L208 384V350.2l34.1-26.5c18.9 2 38.1-4.5 51.9-18.4L305.3 294c13.9-13.9 20.4-33 18.4-51.9L350.2 208H384l93.6 15.6c1.6 .3 3.2 .4 4.9 .4c16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2c-14.3-35.8-36.5-67.5-64.3-93.2c7.1-16.4 2.5-36-13.7-45.3C389.4 14 340.3 0 288 0c-22.4 0-44.2 2.6-65.1 7.4C215.6 2.7 207 0 197.9 0c-5 0-10 .8-14.6 2.5C99.6 33.2 33.2 99.6 2.5 183.3C.8 188 0 193 0 197.9c0 9.1 2.7 17.7 7.4 24.9zm235.9-187C257.8 33.3 272.7 32 288 32c46.6 0 90.1 12.4 127.7 34.1c.4 .2 .5 .4 .6 .5l0 0c.1 .1 .2 .4 .3 1c.1 .6 .1 1.4-.2 2.3l-8.3 11.7-96.4 124L243.3 35.9zM188.6 480c-30-12-56.8-30.4-78.8-53.4L176 375.1V384v2.6l.4 2.6L191.6 480H189c-.1 0-.2 0-.3 0c-.1 0-.1 0-.1 0zM375.1 176l51.4-66.1c23 21.9 41.4 48.7 53.4 78.8c0 .1 0 .2 0 .4v2.5l-90.7-15.1-2.6-.4H384h-8.9zM32.5 194.3C60 119.5 119.5 60 194.3 32.5c.8-.3 2-.5 3.6-.5c5.6 0 10.6 3.4 12.7 8.6l79.1 196.2c4.8 11.9 2 25.5-7.1 34.6l-11.3 11.3c-9.1 9.1-22.7 11.8-34.6 7.1L40.6 210.7c-5.2-2.1-8.6-7.1-8.6-12.7c0-1.6 .3-2.8 .5-3.6z"]
};
var faMapPin = {
  prefix: 'fal',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M160 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM304 144c0 74.1-56 135.2-128 143.1V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V287.1c-72-8-128-69-128-143.1C16 64.5 80.5 0 160 0s144 64.5 144 144zm-192 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faHamsa = {
  prefix: 'fal',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M256 32c17.7 0 32 14.3 32 32V96 208c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-17.7 14.3-32 32-32s32 14.3 32 32V272c0 8.8 7.2 16 16 16h50.7c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7l-90.2 90.2C348 461.3 303 480 256 480s-92-18.7-125.3-51.9L40.6 337.9C35.1 332.5 32 325 32 317.3C32 301.1 45.1 288 61.3 288H112c8.8 0 16-7.2 16-16V96c0-17.7 14.3-32 32-32s32 14.3 32 32V208c0 8.8 7.2 16 16 16s16-7.2 16-16V96 64c0-17.7 14.3-32 32-32zm0-32c-27.9 0-51.7 17.9-60.4 42.8C185.4 36 173.2 32 160 32c-35.3 0-64 28.7-64 64V256H61.3C27.4 256 0 283.4 0 317.3c0 16.2 6.5 31.8 17.9 43.3l90.2 90.2C147.3 490 200.5 512 256 512s108.7-22 147.9-61.3l90.2-90.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3H416V96c0-35.3-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C307.7 17.9 283.9 0 256 0zM176.9 349.3c6.5-6.7 18.7-18.4 33.5-28.2c15.1-10.1 31.1-17 45.6-17s30.5 6.9 45.6 17c14.8 9.9 27 21.5 33.5 28.2c.4 .5 .9 1.3 .9 2.7s-.5 2.3-.9 2.7c-6.5 6.7-18.7 18.4-33.5 28.2c-15.1 10.1-31.1 17-45.6 17s-30.5-6.9-45.6-17c-14.8-9.9-27-21.5-33.5-28.2c-.4-.5-.9-1.3-.9-2.7s.5-2.3 .9-2.7zM256 272c-23.8 0-46.2 11-63.4 22.4c-17.4 11.6-31.4 25.1-38.7 32.7c-6.7 7-9.9 16.1-9.9 25s3.2 18 9.9 25c7.3 7.6 21.3 21 38.7 32.7C209.8 421 232.2 432 256 432s46.2-11 63.4-22.4c17.4-11.6 31.4-25.1 38.7-32.7c6.7-7 9.9-16.1 9.9-25s-3.2-18-9.9-25c-7.3-7.6-21.3-21-38.7-32.7C302.2 283 279.8 272 256 272zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCentSign = {
  prefix: 'fal',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M208 0c8.8 0 16 7.2 16 16V64c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3c7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96C137.1 96 64 168 64 256s73.1 160 164 160c37 0 71.1-12 98.5-32.1c7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V444.8C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8V16c0-8.8 7.2-16 16-16z"]
};
var faSwordsLaser = {
  prefix: 'fal',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M393.9 177.2c-4.8 2-8.2 6.1-9.4 10.9L185.1 8.2C179.3 2.9 171.6 0 163.7 0L160 0c-17.7 0-32 14.3-32 32v3.7c0 7.9 2.9 15.6 8.2 21.4L384 331.7v7.1c0 12.7 5.1 24.9 14.1 33.9L524.2 498.8c8.4 8.4 19.9 13.2 31.8 13.2s23.4-4.7 31.8-13.2l39-39c8.4-8.4 13.2-19.9 13.2-31.8s-4.7-23.4-13.2-31.8L411.3 180.7c-4.6-4.6-11.5-5.9-17.4-3.5zM160 35.7l0-3.7h3.7L384 230.8v53.1L160 35.7zM513.4 328l-28.7 28.7L456 385.4l-35.3-35.3c-3-3-4.7-7.1-4.7-11.3V230.6L513.4 328zM536 350.6l68.2 68.2c2.4 2.4 3.8 5.7 3.8 9.2s-1.4 6.7-3.8 9.2l-8.2 8.2L518.6 368 536 350.6zM573.4 468l-8.2 8.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8L478.6 408 496 390.6 573.4 468zm-375-228.3l-11-11c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7-57.9 57.9c-6-3.2-13.7-2.3-18.8 2.8L16 393.4C5.8 403.6 0 417.5 0 432s5.8 28.4 16 38.6L41.4 496c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16l76.7-76.7c3-3 4.7-7.1 4.7-11.3c0-2.6-.7-5.2-1.9-7.5L256 342.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-11-11 26.2-29-21.6-23.9L249.6 291 221 262.4l31.6-28.5-21.4-23.8-32.8 29.6zM480 35.7L382.7 143.5l3 2.7c11.8-3.7 24.4-2.6 35.3 2.7l82.8-91.7c5.3-5.9 8.2-13.5 8.2-21.4V32c0-17.7-14.3-32-32-32h-3.7c-7.9 0-15.6 2.9-21.4 8.2l-111 100.2L367.8 130 476.3 32l3.7 0v3.7zM152 318.6L193.4 360 176 377.4 134.6 336 152 318.6zM174.6 296L192 278.6 233.4 320 216 337.4 174.6 296zM38.6 416L104 350.6 161.4 408 96 473.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L38.6 448c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16z"]
};
var faFlask = {
  prefix: 'fal',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M288 196.8V32H160V196.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320H347.1l-44.8-72.9C292.9 232 288 214.6 288 196.8zM128 32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h48H288h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V196.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V32zM37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480H378.6c20.7 0 37.4-16.7 37.4-37.4c0-6.9-1.9-13.7-5.5-19.6l-43.7-71H81.2L37.5 423z"]
};
var faPersonPregnant = {
  prefix: 'fal',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M192 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 192 0zm0 352h48 64 16V320c0-31.1-22.3-57.1-51.7-62.8c-12.9-2.5-23-12.6-25.4-25.5l-6.1-32.5c-4.3-22.7-24.1-39.2-47.2-39.2H176c-26.5 0-48 21.5-48 48V352h16 48zm1.9-223.9c36.6 2 67.5 28.7 74.3 65.1l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 256V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H192 160V496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c-17.7 0-32-14.3-32-32V232.1L62.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L88.2 178.8c16.7-31.3 49.2-50.8 84.7-50.8H176h13.6H192c.7 0 1.3 0 1.9 .1z"]
};
var faSquareU = {
  prefix: 'fal',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 64V288c0 44.2 35.8 80 80 80s80-35.8 80-80V160c0-8.8 7.2-16 16-16s16 7.2 16 16V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V160c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWandSparkles = {
  prefix: 'fal',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M472.8 0c-9.6 0-18.9 3.5-26 9.9L169.9 256H136c-22.1 0-40 17.9-40 40v27.1L17.7 393C6.5 403.1 0 417.5 0 432.6c0 14.1 5.6 27.6 15.6 37.6l26.2 26.2c10 10 23.5 15.6 37.6 15.6c15.1 0 29.5-6.4 39.6-17.6L391.1 192H416c17.7 0 32-14.3 32-32V133.6l55.3-69.1c5.6-7 8.7-15.8 8.7-24.8v-.5C512 17.5 494.5 0 472.8 0zM468 33.8c1.3-1.2 3-1.8 4.8-1.8c4 0 7.2 3.2 7.2 7.2v.5c0 1.7-.6 3.4-1.7 4.8L419.5 118c-2.3 2.8-3.5 6.4-3.5 10v32H384c-4.5 0-8.9 1.9-11.9 5.3L95.2 473c-4 4.5-9.8 7-15.8 7c-5.6 0-11-2.2-15-6.2L38.2 447.6c-4-4-6.2-9.3-6.2-14.9c0-6 2.6-11.7 7.1-15.8l83.6-74.6c3.4-3 5.3-7.4 5.3-11.9V296c0-4.4 3.6-8 8-8h40c3.9 0 7.7-1.4 10.6-4L468 33.8zM256 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V32zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V80zM448 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faRouter = {
  prefix: 'fal',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M352 32c62.9 0 120.4 22.6 165 60.2c6.8 5.7 16.8 4.8 22.5-1.9s4.8-16.8-1.9-22.5C487.5 25.5 422.7 0 352 0S216.5 25.5 166.4 67.8c-6.8 5.7-7.6 15.8-1.9 22.5s15.8 7.6 22.5 1.9C231.6 54.6 289.1 32 352 32zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H368V240zM64 352H512c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm40 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm42.2-251.4C277.9 141.7 313.3 128 352 128s74.1 13.7 101.8 36.6c6.8 5.6 16.9 4.7 22.5-2.1s4.7-16.9-2.1-22.5C441 112.5 398.4 96 352 96s-89 16.5-122.2 43.9c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1z"]
};
var faEllipsisVertical = {
  prefix: 'fal',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"]
};
var faEllipsisV = faEllipsisVertical;
var faSwordLaserAlt = {
  prefix: 'fal',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", "M353.2 224L503.8 57.1c5.3-5.9 8.2-13.5 8.2-21.4V32c0-17.7-14.3-32-32-32h-3.7c-7.9 0-15.6 2.9-21.4 8.2L215.8 224h47.8L476.3 32l3.7 0v3.7L310.1 224h43.1zM139.3 270.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2L331.3 283.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H173.3c-12.7 0-24.9 5.1-33.9 14.1zM281.4 288L184 385.4l-28.7-28.7L126.6 328l35.3-35.3c3-3 7.1-4.7 11.3-4.7H281.4zM144 390.6L161.4 408 93.2 476.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8L66.6 468 144 390.6zM121.4 368L44 445.4l-8.2-8.2c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2L104 350.6 121.4 368z"]
};
var faTicket = {
  prefix: 'fal',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M64 64C28.7 64 0 92.7 0 128v66c0 7.3 4.9 13.7 12 15.5c20.7 5.3 36 24.1 36 46.5s-15.3 41.2-36 46.5C4.9 304.3 0 310.7 0 318v66c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V318c0-7.3-4.9-13.7-12-15.5c-20.7-5.3-36-24.1-36-46.5s15.3-41.2 36-46.5c7.1-1.8 12-8.2 12-15.5V128c0-35.3-28.7-64-64-64H64zM32 128c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v54.7c-28.2 12.3-48 40.5-48 73.3s19.8 61 48 73.3V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V329.3C60.2 317 80 288.8 80 256s-19.8-61-48-73.3V128zm128 64H416V320H160V192zm-32 0V320c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"]
};
var faPowerOff = {
  prefix: 'fal',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM164.3 78.2c7.8-4.1 10.9-13.7 6.9-21.6s-13.7-10.9-21.6-6.9C75 88.3 24 166.2 24 256c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2c-7.8-4.1-17.5-1-21.6 6.9s-1 17.5 6.9 21.6C412.1 111.5 456 178.6 456 256c0 110.5-89.5 200-200 200S56 366.5 56 256c0-77.4 43.9-144.5 108.3-177.8z"]
};
var faCoin = {
  prefix: 'fal',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M256 320c66.2 0 124.6-15.2 165.3-38.1C463 258.5 480 231.1 480 208s-17-50.5-58.7-73.9C380.6 111.2 322.2 96 256 96s-124.6 15.2-165.3 38.1C49 157.5 32 184.9 32 208s17 50.5 58.7 73.9C131.4 304.8 189.8 320 256 320zm-80 24.8l0 64.3c20 3.6 41.5 5.8 64 6.6l0-64c-22.2-.8-43.7-3.1-64-6.9zm-32-7.3c-17.2-4.7-33.2-10.5-48-17.1l0 64.7c14.2 6.5 30.3 12.3 48 17l0-64.6zM32 277.8L32 320c0 12.9 8.5 29.9 32 46.8l0-63.6c-12.2-7.8-23-16.3-32-25.5zm240 74l0 64c22.5-.7 44-3 64-6.6l0-64.3c-20.3 3.8-41.8 6.1-64 6.9zm208-74c-9 9.2-19.8 17.7-32 25.5l0 63.6c23.5-16.9 32-34 32-46.8l0-42.2zM368 337.5l0 64.6c17.7-4.7 33.8-10.5 48-17l0-64.7c-14.8 6.7-30.8 12.4-48 17.1zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 32 0 80c0 70.7-114.6 128-256 128S0 390.7 0 320l0-80 0-32zm256-56c-47.1 0-89.1 7.4-118.7 18.8c-14.8 5.7-25.8 12.2-32.7 18.5C97.7 195.7 96 200.6 96 204s1.7 8.3 8.6 14.7c6.9 6.3 17.8 12.8 32.7 18.5C166.9 248.6 208.9 256 256 256s89.1-7.4 118.7-18.8c14.8-5.7 25.8-12.2 32.7-18.5c6.9-6.3 8.6-11.3 8.6-14.7s-1.7-8.3-8.6-14.7c-6.9-6.3-17.8-12.8-32.7-18.5C345.1 159.4 303.1 152 256 152zm192 52c0 15.4-8.2 28.3-19 38.3c-10.9 9.9-25.7 18.2-42.7 24.7c-34.1 13.2-80.2 21-130.2 21s-96.1-7.8-130.2-21c-17-6.6-31.9-14.8-42.7-24.7c-10.9-9.9-19-22.9-19-38.3s8.2-28.3 19-38.3c10.9-9.9 25.7-18.2 42.7-24.7c34.1-13.2 80.2-21 130.2-21s96.1 7.8 130.2 21c17 6.6 31.9 14.8 42.7 24.7c10.9 9.9 19 22.9 19 38.3z"]
};
var faLaptopSlash = {
  prefix: 'fal',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.3 480l-40.5-32H76.8c-20.3 0-37.4-13.5-42.9-32H419.2l-40.5-32H19.2C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H500.3zM544 351.5l.7 .5H576V96c0-35.3-28.7-64-64-64H139.4l40.5 32H512c17.7 0 32 14.3 32 32V351.5zM64 135.6V352H96V160.8L64 135.6z"]
};
var faRightLong = {
  prefix: 'fal',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", "M352 184l0-49.3c0-3.7 3-6.7 6.7-6.7c1.9 0 3.7 .8 5 2.2L476.2 256 363.7 381.8c-1.3 1.4-3.1 2.2-5 2.2c-3.7 0-6.7-3-6.7-6.7l0-49.3c0-17.7-14.3-32-32-32L48 296c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l272 0c17.7 0 32-14.3 32-32zm154.7 86c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 108.9c-7.3-8.2-17.8-12.9-28.8-12.9c-21.4 0-38.7 17.3-38.7 38.7l0 17.3 0 32-32 0L48 184c-26.5 0-48 21.5-48 48l0 48c0 26.5 21.5 48 48 48l240 0 32 0 0 32 0 17.3c0 21.4 17.3 38.7 38.7 38.7c11 0 21.5-4.7 28.8-12.9L506.7 270z"]
};
var faLongArrowAltRight = faRightLong;
var faCircleB = {
  prefix: 'fal',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 160v96 96c0 17.7 14.3 32 32 32H296c39.8 0 72-32.2 72-72c0-26.6-14.4-49.8-35.9-62.3C344.4 236.8 352 219.3 352 200c0-39.8-32.2-72-72-72H192c-17.7 0-32 14.3-32 32zm160 40c0 22.1-17.9 40-40 40H192V160h88c22.1 0 40 17.9 40 40zM192 352V272h88 16c22.1 0 40 17.9 40 40s-17.9 40-40 40H192z"]
};
var faPersonDressSimple = {
  prefix: 'fal',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM81.5 215.2L42.4 352H213.6L174.5 215.2C170.6 201.5 158 192 143.7 192H112.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z"]
};
var faPipeCollar = {
  prefix: 'fal',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M68.3 166.3c5.9-12.2 3.4-26.8-6.2-36.4l-16-16c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0l16 16c9.6 9.6 24.2 12.1 36.4 6.2C193.5 55.3 223.8 48 256 48s62.5 7.3 89.7 20.3c12.2 5.9 26.8 3.4 36.4-6.2l16-16c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-16 16c-9.6 9.6-12.1 24.2-6.2 36.4c13 27.1 20.3 57.5 20.3 89.7s-7.3 62.5-20.3 89.7c-5.9 12.2-3.4 26.8 6.2 36.4l16 16c18.7 18.7 18.7 49.1 0 67.9s-49.1 18.7-67.9 0l-16-16c-9.6-9.6-24.2-12.1-36.4-6.2c-27.1 13-57.5 20.3-89.7 20.3s-62.5-7.3-89.7-20.3c-12.2-5.9-26.8-3.4-36.4 6.2l-16 16c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l16-16c9.6-9.6 12.1-24.2 6.2-36.4C55.3 318.5 48 288.2 48 256s7.3-62.5 20.3-89.7zM136.6 23.4C105.3-7.8 54.7-7.8 23.4 23.4s-31.2 81.9 0 113.1l16 16C24.4 183.9 16 218.9 16 256s8.4 72.1 23.4 103.5l-16 16c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l16-16c31.3 15 66.4 23.4 103.5 23.4s72.1-8.4 103.5-23.4l16 16c31.2 31.2 81.9 31.2 113.1 0s31.2-81.9 0-113.1l-16-16c15-31.3 23.4-66.4 23.4-103.5s-8.4-72.1-23.4-103.5l16-16c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-16 16C328.1 24.4 293.1 16 256 16s-72.1 8.4-103.5 23.4l-16-16zM128 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM448 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLightsHoliday = {
  prefix: 'fal',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", "M23.8 66C16 61.7 6.3 64.5 2 72.2S.5 89.7 8.2 94l13.5 7.5C109.7 150.4 208.7 176 309.3 176H320h10.7c100.6 0 199.6-25.6 287.5-74.5L631.8 94c7.7-4.3 10.5-14 6.2-21.8s-14-10.5-21.8-6.2l-13.5 7.5c-83.2 46.2-176.8 70.5-272 70.5H320 309.3c-95.2 0-188.8-24.3-272-70.5L23.8 66zm99.8 156.2C86.7 217 50 238.2 37 274.6C20.9 319.9 46.9 414 69.5 422.1s102.2-48.6 118.3-93.8c13-36.5-2.1-76.1-34-95.3l14.6-41.1c-10.4-2.4-20.8-5.1-31.1-8.1l-13.7 38.4zM304 257.6c-36.5 7.4-64 39.7-64 78.4c0 48 56 128 80 128s80-80 80-128c0-38.7-27.5-71-64-78.4V208c-1.8 0-3.5 0-5.3 0H320 309.3c-1.8 0-3.5 0-5.3 0v49.6zM486.3 233c-31.9 19.2-47 58.9-34 95.3c16.1 45.2 95.7 101.8 118.3 93.8s48.6-102.2 32.5-147.4c-13-36.5-49.7-57.7-86.6-52.4l-13.7-38.4c-10.3 3-20.7 5.6-31.1 8.1L486.3 233zM128.5 256.2c25 8.9 38 36.3 29.1 61.3c-4.9 13.7-22.6 34.4-45.9 52.1c-11 8.4-21.5 14.7-29.6 18.3l-.6 .3-.3-.6c-4-7.9-8.1-19.4-11.4-32.8c-6.9-28.4-7.5-55.7-2.7-69.4c8.9-25 36.3-38 61.3-29.1zM320 288c26.5 0 48 21.5 48 48c0 14.5-9.8 40-25.8 64.5c-7.6 11.6-15.3 21-21.7 27.1l-.5 .5-.5-.5c-6.4-6.1-14.2-15.6-21.7-27.1c-16-24.5-25.8-50-25.8-64.5c0-26.5 21.5-48 48-48zm-6.5 145.2c0 0 .1-.1 .2-.1l-.2 .1c-.1 0-.1 .1-.1 .1l.1 0zm12.8-.1a.4 .4 0 1 0 .8-.5 .4 .4 0 1 0 -.8 .5zM572.9 285.4c4.9 13.7 4.2 41-2.7 69.4c-3.2 13.4-7.4 24.9-11.4 32.8l-.3 .6-.6-.3c-8.1-3.6-18.6-9.9-29.6-18.3c-23.3-17.7-41-38.5-45.9-52.1c-8.9-25 4.2-52.4 29.1-61.3s52.4 4.2 61.3 29.1z"]
};
var faCitrus = {
  prefix: 'fal',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M384 96c35.3 0 64-28.7 64-64H384c-35.3 0-64 28.7-64 64h64zm0 32H304c-8.8 0-16-7.2-16-16V96c0-10 1.5-19.7 4.4-28.8c-11.8-2.1-24-3.2-36.4-3.2C141.1 64 48 157.1 48 272s93.1 208 208 208s208-93.1 208-208c0-44.3-13.9-85.5-37.5-119.2c10.3-3.6 20-8.5 28.9-14.5C481 176.5 496 222.5 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272S123.5 32 256 32c17.8 0 35.1 1.9 51.8 5.6C325.3 14.7 353 0 384 0h80c8.8 0 16 7.2 16 16V32c0 53-43 96-96 96z"]
};
var faFlagUsa = {
  prefix: 'fal',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V64 367v33 96c0 8.8 7.2 16 16 16s16-7.2 16-16V392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 298.6l107.1-23c33.6-7.2 68.6-4.4 100.7 8.1l25.8 10c45.2 17.6 95.1 18.8 141.2 3.5l9.2-3.1v35.6l-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359V314.6zm0-32.7V242.6l102.2-21.9c36.4-7.8 74.3-3.9 108.4 11.3l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v34.4l-19.3 6.4c-38.9 13-81.2 11.9-119.4-2.9l-25.8-10c-37.9-14.7-79.2-18-119-9.5L32 281.9zm0-72V89L140.7 61.8c6.4-1.6 12.8-2.7 19.3-3.3V185.1c-10.9 .6-21.7 2-32.5 4.3L32 209.9zm160-24l0-47.8c17.4 2.1 34.4 6.7 50.6 13.9l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v45.7l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zm0-80l0-46.6c13.9 2 27.4 6.2 40.1 12.6c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v59.9l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zM88 120a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM88 168a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLaptopFile = {
  prefix: 'fal',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", "M448 32H128c-17.7 0-32 14.3-32 32V288H320v32H96 64 33.9c5.5 18.5 22.7 32 42.9 32H320v32H76.8C34.4 384 0 349.6 0 307.2C0 296.6 8.6 288 19.2 288H64V64C64 28.7 92.7 0 128 0H448c35.3 0 64 28.7 64 64V96H480V64c0-17.7-14.3-32-32-32zM384 464c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V288H528c-26.5 0-48-21.5-48-48V160H400c-8.8 0-16 7.2-16 16V464zM512 160.5V240c0 8.8 7.2 16 16 16h79.5c-.7-2.8-2.1-5.4-4.2-7.4l-83.9-83.9c-2.1-2.1-4.6-3.5-7.4-4.2zm30.1-18.4l83.9 83.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48H400c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H508.1c12.7 0 24.9 5.1 33.9 14.1z"]
};
var faTty = {
  prefix: 'fal',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M354 164.8v29.8c0 8.1 6.1 14.9 14.1 15.9l78.7 9.4c7.3 .9 14.2-3.3 16.8-10.1L473.9 183c6.4-16.6 2.5-31.1-6.1-38.7C426.2 107.6 352.1 64 256 64s-170.2 43.6-211.9 80.3c-8.6 7.6-12.5 22.1-6.1 38.7l10.3 26.7c2.6 6.8 9.6 11 16.8 10.1l78.7-9.4c8-1 14.1-7.8 14.1-15.9V164.8c0-13 7.9-24.7 20-29.6c50-20.3 106-20.3 156.1 0c12.1 4.9 20 16.6 20 29.6zm-32 29.8V164.8c-42.3-17.2-89.7-17.2-132 0v29.8c0 24.3-18.2 44.8-42.3 47.7L69 251.6c-21.8 2.6-42.5-9.9-50.4-30.3L8.2 194.5c-10.1-26-6.2-55.8 14.8-74.2C68.7 79.9 150 32 256 32s187.3 47.9 233 88.3c20.9 18.4 24.8 48.2 14.8 74.2l-10.3 26.7c-7.9 20.4-28.7 32.9-50.4 30.3l-78.7-9.4c-24.1-2.9-42.3-23.3-42.3-47.7zM72 291.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H72c-15.9 0-28.8-12.9-28.8-28.8V320c0-15.9 12.9-28.8 28.8-28.8zM68.8 320v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H72c-1.8 0-3.2 1.4-3.2 3.2zM72 403.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H72c-15.9 0-28.8-12.9-28.8-28.8V432c0-15.9 12.9-28.8 28.8-28.8zM68.8 432v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V432c0-1.8-1.4-3.2-3.2-3.2H72c-1.8 0-3.2 1.4-3.2 3.2zM408 403.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H408c-15.9 0-28.8-12.9-28.8-28.8V432c0-15.9 12.9-28.8 28.8-28.8zM404.8 432v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V432c0-1.8-1.4-3.2-3.2-3.2H408c-1.8 0-3.2 1.4-3.2 3.2zm-249.6 0c0-15.9 12.9-28.8 28.8-28.8H328c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H184c-15.9 0-28.8-12.9-28.8-28.8V432zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2H328c1.8 0 3.2-1.4 3.2-3.2V432c0-1.8-1.4-3.2-3.2-3.2H184zM155.2 320c0-15.9 12.9-28.8 28.8-28.8h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H184c-15.9 0-28.8-12.9-28.8-28.8V320zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H184zm112-25.6h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H296c-15.9 0-28.8-12.9-28.8-28.8V320c0-15.9 12.9-28.8 28.8-28.8zM292.8 320v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H296c-1.8 0-3.2 1.4-3.2 3.2zm86.4 0c0-15.9 12.9-28.8 28.8-28.8h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H408c-15.9 0-28.8-12.9-28.8-28.8V320zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2V320c0-1.8-1.4-3.2-3.2-3.2H408z"]
};
var faTeletype = faTty;
var faChartTreeMap = {
  prefix: 'fal',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M176 64c8.8 0 16 7.2 16 16V192c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H176zM48 32C21.5 32 0 53.5 0 80V192c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM176 304c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16H176zM48 272c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H48zM304 64H464c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 80v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM464 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16H464zM304 192c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H304zm0 192H464c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16zm-48 16v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48z"]
};
var faDiagramNext = {
  prefix: 'fal',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", "M480 160c0 17.7-14.3 32-32 32l-176 0H240L64 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32v64zM272 224H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H240V329.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V224zM448 480c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0z"]
};
var faPersonRifle = {
  prefix: 'fal',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", "M260.7 192c28.3 0 55.1 10.7 75.3 29.1V496.2c-.1 8.7-7.2 15.8-16 15.8c-8.8 0-16-7.2-16-16V236.7c-12.7-8.2-27.7-12.7-43.3-12.7H219.3c-15.7 0-30.7 4.6-43.3 12.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V275.8L62.3 439.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l85.5-170.9c19-37.9 57.8-61.9 100.2-61.9h41.3zM288 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM480 336v14.2l3.9 17.8h7.1H528c8.8 0 16 7.2 16 16s-7.2 16-16 16h-4.2H491.1l7.1 32 9.1 41.1 4.3 19.5c1.1 4.7-.1 9.7-3.1 13.5s-7.6 6-12.5 6H476.1 416 400c-8.8 0-16-7.2-16-16V480 393.9l-2.7-1.4c-8.1-4.1-13.3-12.4-13.3-21.5v-4.9V225.9v-4.9c0-9.1 5.1-17.4 13.3-21.5l2.7-1.4V160c0-17.7 14.3-32 32-32V96 64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16V32 96v32c17.7 0 32 14.3 32 32v48 47 1 24 8l32-8V256 208c0-8.8 7.2-16 16-16s16 7.2 16 16v72 12.5c0 6.9-4.4 13-10.9 15.2l-.9 .3L480 325.3V336zm-27.3 38.9l-1.5-6.9-2.4-10.8-.4-1.7 0 0c-.3-1.1-.4-2.3-.4-3.5v-1.8V336v-7-3.7V302.3 296v-8V256 208 192 160H416v32 6.1V208c0 6-3.4 11.6-8.8 14.3l0 0-7.2 3.6V366.1l7.2 3.6 0 0c5.4 2.7 8.8 8.2 8.8 14.3v9.9V448v32h27.3H448h28.1l-7.1-32-9.1-41.1-1.5-6.9-5.6-25.1z"]
};
var faClockFiveThirty = {
  prefix: 'fal',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V308.8l34.7 52c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-64-96c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faPipeValve = {
  prefix: 'fal',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M272 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V80H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v80H32V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v32V432v32c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480v16c0 8.8 7.2 16 16 16s16-7.2 16-16V432 208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H272V112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V32zM256 224H480V416H32V224H256z"]
};
var faArrowUpFromArc = {
  prefix: 'fal',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 480C132.3 480 32 379.7 32 256c0-8.8-7.2-16-16-16s-16 7.2-16 16C0 397.4 114.6 512 256 512s256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224zM116 149.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3L240 58.1 240 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-277.9L372 170.6c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4l-128 144z"]
};
var faFaceSpiralEyes = {
  prefix: 'fal',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.9 374.9l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-139-263.3c.3 6.6-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5c6.6-.3 12.2 4.9 12.5 11.5zM349.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z"]
};
var faCompressWide = {
  prefix: 'fal',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M128 80c0-8.8 7.2-16 16-16s16 7.2 16 16V208c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H128V80zm16 208c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H144zM352 80c0-8.8 7.2-16 16-16s16 7.2 16 16V192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zM496 288c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16H496z"]
};
var faCirclePhoneHangup = {
  prefix: 'fal',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM112 248.6c.1-.5 .3-1.2 1.1-1.9c78.8-72.9 207-72.9 285.7 0c.8 .7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7c-37-11.9-77.4-11.9-114.3 0c-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9l-21.7-35.2c-.4-.7-.5-1.2-.4-1.8zm308.6-25.4c-91-84.3-238.2-84.3-329.2 0c-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9c0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1 .5-.1 .7c-1.8 16.6 8.5 31.3 23.3 36.9L359 317.5c16.6 6.3 36.4 .6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z"]
};
var faPhoneCircleDown = faCirclePhoneHangup;
var faGearComplexCode = {
  prefix: 'fal',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M215 62.8l4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8C232.9 32.9 244.4 32 256 32s23.1 .9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8L297 62.8c2.9 14.4 13.2 25.2 25.5 30.3l0 0 1.5 .6 0 0c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3c9.1 6.7 17.7 14 25.6 21.9l.8 .8 0 0c7.9 8 15.3 16.5 21.9 25.6c-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5l0 0 .6 1.5 0 0c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5 .3 2.8 1 3.8 1.9c1.7 11.1 2.6 22.4 2.6 34v.4c0 11.6-.9 22.9-2.6 34c-1.1 1-2.4 1.6-3.8 1.9L449.2 297c-14.4 2.9-25.2 13.2-30.3 25.5l0 0-.6 1.5 0 0c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1c-13.6 18.5-29.9 34.9-48.4 48.4c-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3l0 0-1.5 .6 0 0c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8c-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8L215 449.2c-2.9-14.4-13.2-25.2-25.5-30.3l0 0-1.5-.6 0 0c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2 .8-2.6 1.3-4.1 1.3c-18.5-13.6-34.9-29.9-48.4-48.4c.1-1.4 .5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5l0 0-.6-1.5 0 0c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9C32.9 279.1 32 267.6 32 256s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9L62.8 215c14.4-2.9 25.2-13.2 30.3-25.5l0 0 .6-1.5 0 0c5.2-12.3 4.8-27.3-3.3-39.5L76.6 127.7c-.8-1.2-1.3-2.6-1.3-4.1c6.7-9.1 14-17.7 22-25.7l.8-.8 0 0c8-7.9 16.6-15.3 25.7-22c1.4 .1 2.8 .5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3l0 0 1.5-.6 0 0c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7c-2 .3-3.9 1-5.6 2.1c-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9l0 0-.1 0-1.7 .7 0 0-.1 0c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6c-1.9 .5-3.8 1.3-5.4 2.5C96.6 55.2 85.6 64.4 75.4 74.5l0 0-.8 .8 0 0C64.4 85.6 55.2 96.6 46.9 108.3c-1.2 1.6-2 3.5-2.5 5.4c-2.6 10.6-.8 22.1 5.6 31.7l13.8 20.6c1.5 2.2 2 5.7 .4 9.4l0 .1-.7 1.7 0 0 0 .1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6c-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6c5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6 .5 5.4 2.6 6.9 6.3l0 .1 .7 1.7 0 .1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7c.5 1.9 1.3 3.8 2.5 5.4c16.8 23.8 37.6 44.6 61.5 61.5c1.6 1.2 3.5 2 5.4 2.5c10.6 2.6 22.1 .8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4l.1 0 1.7 .7 .1 0c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4c1.7 1 3.6 1.7 5.6 2.1c14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1c9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9l.1 0 1.7-.7 .1 0c3.7-1.5 7.1-1 9.4 .4L366.5 462c9.6 6.4 21.2 8.2 31.7 5.6c1.9-.5 3.8-1.3 5.4-2.5c23.8-16.8 44.6-37.6 61.5-61.4c1.2-1.6 2-3.5 2.5-5.4c2.6-10.6 .8-22.1-5.6-31.7l-13.8-20.6c-1.5-2.2-2-5.7-.4-9.4l0-.1 .7-1.7 0-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6c1-1.7 1.7-3.6 2.1-5.6c2.4-14 3.7-28.5 3.7-43.2v0-.4 0c0-14.7-1.3-29.1-3.7-43.2c-.3-2-1-3.9-2.1-5.6c-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3l0-.1-.7-1.7 0-.1c-1.5-3.7-1-7.1 .4-9.4L462 145.5c6.4-9.6 8.2-21.2 5.6-31.7c-.5-1.9-1.3-3.8-2.5-5.4c-8.3-11.7-17.5-22.7-27.6-32.9l0 0-.9-.9 0 0c-10.1-10.1-21.1-19.3-32.9-27.6c-1.6-1.2-3.5-2-5.4-2.5c-10.6-2.6-22.1-.8-31.7 5.6L345.9 63.7c-2.2 1.5-5.7 2-9.4 .4l-.1 0-1.7-.7-.1 0c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4c-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zm31.8 162.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zM187.3 227.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L353.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z"]
};
var faHouseMedicalCircleExclamation = {
  prefix: 'fal',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H394.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3 466.1 194.5c9.7-1.7 19.7-2.5 29.9-2.5c5.6 0 11.1 .3 16.5 .8L298.6 4zM368 240H336V208c0-17.7-14.3-32-32-32H272c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5c-1.3-8.6-2-17.5-2-26.5c0-22.6 4.3-44.2 12-64H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3c-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faBadminton = {
  prefix: 'fal',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7c7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3c72.5 39.4 169.9 17.5 234.7-47.4c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32L64 480 32 448l72-72zm352.9 88l-8.2 27.4c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7l11-36.6H456.9zM496 496c0 8.8 7.2 16 16 16s16-7.2 16-16V464H496v32zm37.7-32l11 36.6c2.5 8.5 11.5 13.3 19.9 10.7s13.3-11.5 10.7-19.9L567.1 464H533.7zM496 400c0-8.8 7.2-16 16-16s16 7.2 16 16v16H496V400zm64 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v16 32h32 32 32V416 400z"]
};
var faClosedCaptioning = {
  prefix: 'fal',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 96c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3c6.3-6.2 16.4-6.1 22.6 .2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4c-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C233.2 199 217.4 192 200 192zm192 0c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3c6.3-6.2 16.4-6.1 22.6 .2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4c-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4c6.3 6.2 6.4 16.3 .2 22.6s-16.3 6.4-22.6 .2C425.2 199 409.4 192 392 192z"]
};
var faPersonHiking = {
  prefix: 'fal',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", "M288 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 208 56zM102.9 128.4c-19 2.5-35 16.1-40.1 35L40.2 246.3l31.9 5.3 30.8-123.2zm-1.5 138.1c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8L101.4 266.5zM368 160c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H312.8c-10.9 0-21.1-5.6-27-14.8l-20.7-32.5L237.2 333.5l36.6 24.4c8.9 5.9 14.2 15.9 14.2 26.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384.6l-95-63.3c-16.3-10.8-24.3-30.4-20.4-49.6l19.8-96.5c6.1-29.9 35.1-49.3 65-43.7c20.6 3.9 38.7 16.1 50 33.8L312.8 224H352V176c0-8.8 7.2-16 16-16zM123.7 334.8c.5 .4 1.1 .8 1.6 1.1l26.4 17.6L111.4 500.2c-2.3 8.5-11.1 13.5-19.7 11.2s-13.5-11.2-11.2-19.7l43.2-157zm68.1-153.2L172 278.1c-1.3 6.4 1.4 12.9 6.8 16.5l29.8 19.9L240.3 173c-5.8-5.1-13-8.6-20.7-10c-12.8-2.4-25.1 5.9-27.8 18.6z"]
};
var faHiking = faPersonHiking;
var faRightFromLine = {
  prefix: 'fal',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", "M415.2 254.2c.5 .5 .8 1.1 .8 1.8s-.3 1.4-.8 1.8L283.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-8.8-7.2-16-16-16l-120 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l120 0c8.8 0 16-7.2 16-16l0-57.3c0-3.7 3-6.7 6.7-6.7c1.7 0 3.3 .7 4.6 1.8L415.2 254.2zM448 256c0-9.5-3.9-18.6-10.8-25.1L305.2 106.5C298 99.8 288.5 96 278.7 96c-21.4 0-38.7 17.3-38.7 38.7l0 41.3-104 0c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l104 0 0 41.3c0 21.4 17.3 38.7 38.7 38.7c9.9 0 19.3-3.8 26.5-10.5L437.2 281.1c6.9-6.5 10.8-15.6 10.8-25.1zM0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80z"]
};
var faArrowAltFromLeft = faRightFromLine;
var faVenusDouble = {
  prefix: 'fal',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM368 176c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.3C86.3 343.2 16 267.8 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c7.3-7.8 14-16.2 20-25c23.6 17 52.6 27 84 27c79.5 0 144-64.5 144-144s-64.5-144-144-144c-31.3 0-60.3 10-84 27c-6-8.9-12.7-17.2-20-25C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.3c-32.7-3-62.9-14.9-88-33.3z"]
};
var faImages = {
  prefix: 'fal',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M160 64H512c17.7 0 32 14.3 32 32V201.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4V96c0-17.7 14.3-32 32-32zM576 96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V304v16c0 35.3 28.7 64 64 64h80 0H512c35.3 0 64-28.7 64-64V240 240 96zM464 166.6l80 80V320c0 17.7-14.3 32-32 32H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H160c-17.7 0-32-14.3-32-32v-9.4l80-80L281.4 304zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCalculator = {
  prefix: 'fal',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M352 160V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160H352zm0-32H32V64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64zm32 0V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v64 16 16V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160 144 128zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faShuttlecock = {
  prefix: 'fal',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M241.9 0c-12.1 0-23.2 6.8-28.6 17.7L92.2 259.8 73.4 278.6 33.1 318.9C11.9 340.1 0 368.9 0 398.9C0 461.3 50.7 512 113.1 512c30 0 58.8-11.9 80-33.1l40.2-40.2 18.9-18.9 242.1-121c10.8-5.4 17.7-16.5 17.7-28.6V224c0-17.7-14.3-32-32-32H424V120c0-17.7-14.3-32-32-32H320V32c0-17.7-14.3-32-32-32H241.9zm67.2 355.6l-75.7 37.8 0 0-46.1-46.1 77.2-77.2 103-32.5-58.4 118zm47.5-23.7l53.3-107.6 .6-.2H480v46.1L356.5 331.8zM288 101.5l-.2 .6L180.2 155.5 241.9 32 288 32v69.5zm-13.6 43l-32.5 103-77.2 77.2-46.1-46.1 0 0 37.8-75.7 118-58.4zm6.1 87L315.7 120H392v76.3L280.5 231.5zM61.9 335.3L96 301.3 210.7 416l-34.1 34.1L61.9 335.3zm89.7 135c-11.7 6.3-24.9 9.7-38.5 9.7C68.3 480 32 443.7 32 398.9c0-13.6 3.4-26.8 9.7-38.5L151.6 470.3z"]
};
var faUserHair = {
  prefix: 'fal',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM307.2 80C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM32 480H416c-1.9-71-60-128-131.5-128H163.6C92.1 352 33.9 409 32 480zM0 483.6C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"]
};
var faEyeEvil = {
  prefix: 'fal',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M258.1 126.1c-11.2 3.2-21.8 7.3-31.7 12.1c-8.6 4.1-18.4 4.8-27.4 2l-55.9-17.5L161.7 151c8.3 12.6 8.2 29-.2 41.5c-4.5 6.7-8.3 13.7-11.3 20.8c-4.1 9.7-12 17.2-21.9 20.7L66.5 256l61.8 22.1c9.9 3.5 17.8 11 21.9 20.7c3 7.1 6.8 14.1 11.3 20.8c8.4 12.5 8.5 28.9 .2 41.5l-18.6 28.3L199 371.8c9.1-2.8 18.9-2.1 27.4 2c9.9 4.8 20.5 8.8 31.7 12.1c8.9 2.6 16.5 8.3 21.3 16.1L320 467l40.6-64.9c4.9-7.8 12.5-13.6 21.3-16.1c11.2-3.2 21.8-7.3 31.7-12.1c8.6-4.1 18.4-4.8 27.4-2l55.9 17.5L478.3 361c-8.3-12.6-8.2-29 .2-41.5c4.5-6.7 8.3-13.7 11.3-20.8c4.1-9.7 12-17.2 21.9-20.7L573.5 256l-61.8-22.1c-9.9-3.5-17.8-11-21.9-20.7c-3-7.1-6.8-14.1-11.3-20.8c-8.4-12.5-8.5-28.9-.2-41.5l18.6-28.3L441 140.2c-9.1 2.8-18.9 2.1-27.4-2c-9.9-4.8-20.5-8.8-31.7-12.1c-8.9-2.6-16.5-8.3-21.3-16.1L320 45l-40.6 64.9c-4.9 7.8-12.5 13.6-21.3 16.1zM0 256c0-9.6 6-18.2 15.1-21.4l100.6-35.9c4-9.4 8.9-18.5 14.7-27.1L89.2 108.8c-5.3-8-4.9-18.5 .8-26.1s15.7-10.9 24.9-8l95.3 29.8c11.8-5.7 24.4-10.5 37.5-14.3l47.8-76.5C300.8 5.1 310 0 320 0s19.2 5.1 24.5 13.6l47.8 76.5c13.1 3.8 25.7 8.6 37.5 14.3l95.3-29.8c9.2-2.9 19.1 .3 24.9 8s6.1 18.1 .8 26.1l-41.3 62.7c5.8 8.6 10.7 17.7 14.7 27.1l100.6 35.9c9 3.2 15.1 11.8 15.1 21.4s-6 18.2-15.1 21.4L524.3 313.3c-4 9.4-8.9 18.5-14.7 27.1l41.3 62.7c5.3 8 4.9 18.5-.8 26.1s-15.7 10.9-24.9 8l-95.3-29.8c-11.8 5.7-24.4 10.5-37.5 14.3l-47.8 76.5C339.2 506.9 330 512 320 512s-19.2-5.1-24.5-13.6l-47.8-76.5c-13.1-3.8-25.7-8.6-37.5-14.3l-95.3 29.8c-9.2 2.9-19.1-.3-24.9-8s-6.1-18.1-.8-26.1l41.3-62.7c-5.8-8.6-10.7-17.7-14.7-27.1L15.1 277.4C6 274.2 0 265.6 0 256zm249.2-21.5c-.8 4.3-1.2 8.8-1.2 13.5c0 39.8 32.2 72 72 72s72-32.2 72-72c0-4.6-.4-9.1-1.2-13.5l-.4 .1c-13.6 5.3-27.9 9.2-42.7 11.3c.2 3-.2 6.1-1.4 9.3c-5.5 14.4-13.5 24.4-18.1 29.3c-2.1 2.3-5.1 3.4-8.2 3.4s-6.1-1.1-8.2-3.4c-4.5-4.9-12.6-14.9-18.1-29.3c-1.2-3.2-1.6-6.3-1.4-9.3c-14.8-2.1-29.1-6-42.7-11.3l-.4-.1zM220.1 219c4.9-16.8 25-20.6 41.3-14.1c18.2 7.2 37.9 11.1 58.6 11.1s40.5-3.9 58.6-11.1c16.3-6.4 36.4-2.7 41.3 14.1c2.7 9.2 4.1 18.9 4.1 29c0 57.4-46.6 104-104 104s-104-46.6-104-104c0-10 1.4-19.8 4.1-29z"]
};
var faPeoplePulling = {
  prefix: 'fal',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm9.5 113.3c-.9 2-1.5 4.3-1.5 6.7V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-26.5 21.5-48 48-48h62.6c16.7 0 32.9 5.2 46.5 14.9l121.7 86.8c11.8-33.4 35.5-61.5 66.9-78.6l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2c36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L443.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L465.9 393 365.4 305.8c-14.4-12.5-20.1-32.4-14.4-50.6l26.6-85c-1.3 .6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.3 9.2c-.2 1-.5 1.9-.9 2.8c-.8 2-2.1 3.7-3.5 5.1c-3.3 3.2-7.8 4.9-12.5 4.5c-1.9-.2-3.8-.6-5.5-1.5c-1-.5-1.9-1-2.7-1.6L148.2 175.9l75.3 316.4c2 8.6-3.3 17.2-11.9 19.3s-17.2-3.3-19.3-11.9L157.3 352H100.9l26.9 141c1.7 8.7-4 17.1-12.7 18.7s-17.1-4-18.7-12.7L33.5 169.3zm79-5.6c-.3-1.2-.4-2.5-.4-3.7c-.5 0-.9 0-1.4 0H64.3L94.8 320h54.9L112.4 163.7zM480 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 400 56zM381.5 264.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4c-2.5 0-5 .1-7.5 .3L381.5 264.8zm-6.4 88.9c7.9 4 11.1 13.6 7.2 21.5l-30.8 61.7c-1.5 3.1-3.6 5.9-6 8.3l-62.2 62.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2z"]
};
var faN = {
  prefix: 'fal',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M10.5 33c6.3-2.3 13.4-.4 17.7 4.7L352 420.3V48c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 6.7-4.2 12.7-10.5 15s-13.4 .4-17.7-4.7L32 91.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-6.7 4.2-12.7 10.5-15z"]
};
var faSwap = {
  prefix: 'fal',
  iconName: 'swap',
  icon: [640, 512, [], "e609", "M208 126.7c0 18.4-14.9 33.3-33.3 33.3H128V360c0 48.6 39.4 88 88 88s88-39.4 88-88V152c0-66.3 53.7-120 120-120s120 53.7 120 120V352h46.7c18.4 0 33.3 14.9 33.3 33.3c0 8.3-3.1 16.3-8.7 22.4l-75.5 83c-3 3.3-7.3 5.2-11.8 5.2s-8.8-1.9-11.8-5.2l-75.5-83c-5.6-6.1-8.7-14.1-8.7-22.4c0-18.4 14.9-33.3 33.3-33.3H512V152c0-48.6-39.4-88-88-88s-88 39.4-88 88V360c0 66.3-53.7 120-120 120s-120-53.7-120-120V160H49.3C30.9 160 16 145.1 16 126.7c0-8.3 3.1-16.3 8.7-22.4l75.5-83c3-3.3 7.3-5.2 11.8-5.2s8.8 1.9 11.8 5.2l75.5 83c5.6 6.1 8.7 14.1 8.7 22.4zM112 128s0 0 0 0s0 0 0 0h62.7c.7 0 1.3-.6 1.3-1.3c0-.3-.1-.6-.3-.9L112 55.8l-63.7 70c-.2 .2-.3 .6-.3 .9c0 .7 .6 1.3 1.3 1.3H112zM528 384H465.3c-.7 0-1.3 .6-1.3 1.3c0 .3 .1 .6 .3 .9l63.7 70 63.7-70c.2-.2 .3-.6 .3-.9c0-.7-.6-1.3-1.3-1.3H528z"]
};
var faGarage = {
  prefix: 'fal',
  iconName: 'garage',
  icon: [640, 512, [], "e009", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zm32 96H512V224H128v96zm144 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCableCar = {
  prefix: 'fal',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-72 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 256v96H192V256h48 32 48zm32 0h64c17.7 0 32 14.3 32 32v64H352V256zm96 128v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V384H176 336 448zM64 352V288c0-17.7 14.3-32 32-32h64v96H64zM416 224H272V141.1L499.1 95.7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-240 48-240 48C4.2 162-1.4 170.5 .3 179.1s10.2 14.3 18.8 12.6L240 147.5V224H96c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64z"]
};
var faTram = faCableCar;
var faShovelSnow = {
  prefix: 'fal',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", "M419.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L358.9 42.5C344.2 57.1 336 77 336 97.8c0 15.8 4.7 30.5 12.8 42.8L272 217.4l-41.8-41.8c-16.4-16.4-42.3-18.7-61.4-5.5L20.6 273.3C7.7 282.3 0 297 0 312.7v2c0 12.7 5.1 24.9 14.1 33.9L163.3 497.9c9 9 21.2 14.1 33.9 14.1h2c15.7 0 30.4-7.7 39.4-20.6L341.8 343.1c13.3-19.1 11-44.9-5.5-61.4L294.6 240l76.8-76.8c12.3 8.1 27 12.8 42.8 12.8c20.7 0 40.6-8.2 55.3-22.9l37.8-37.8c6.2-6.2 6.2-16.4 0-22.6l-88-88zM381.5 65.1L408 38.6 473.4 104l-26.5 26.5c-8.7 8.7-20.4 13.5-32.7 13.5c-25.5 0-46.2-20.7-46.2-46.2c0-12.3 4.9-24 13.5-32.7zM187.2 196.4c6.4-4.4 15-3.7 20.5 1.8L313.8 304.4c5.5 5.5 6.2 14.1 1.8 20.4L212.4 473.1c-3 4.3-7.9 6.9-13.1 6.9h-2c-4.2 0-8.3-1.7-11.3-4.7L36.7 326.1c-3-3-4.7-7.1-4.7-11.3v-2c0-5.2 2.6-10.1 6.9-13.1L187.2 196.4zm16.2 70.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z"]
};
var faCloudRain = {
  prefix: 'fal',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM82.3 451.9L96 426.7l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2 .8-6.3 2.3-9.1zM54.2 436.6C50.1 444.1 48 452.5 48 461v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L102.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8L54.2 436.6zm188.1 15.3L256 426.7l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2 .8-6.3 2.3-9.1zm-28.1-15.3c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8-23.6 43.5zm201.8-10l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2 .8-6.3 2.3-9.1L416 426.7zm-18.2-33.5l-23.6 43.5c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4 .8z"]
};
var faFaceLying = {
  prefix: 'fal',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.8 0 149.8-41.7 189.5-104.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1C427.3 464.3 347.2 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C373.8 0 472.9 79.5 502.8 187.7c2.3 8.5-2.6 17.3-11.2 19.7s-17.3-2.6-19.7-11.2C445.8 101.5 359 32 256 32zM152.4 176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm160 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6zM288 224H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSprinkler = {
  prefix: 'fal',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M496 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 144A16 16 0 1 1 0 144a16 16 0 1 1 32 0zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm192 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm400 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 272A16 16 0 1 1 0 272a16 16 0 1 1 32 0zM96 80A16 16 0 1 1 64 80a16 16 0 1 1 32 0zM32 16A16 16 0 1 1 0 16a16 16 0 1 1 32 0zM256 64c8.8 0 16 7.2 16 16V256H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89V472c0 22.1-17.9 40-40 40H232c-22.1 0-40-17.9-40-40V385.9l-89-89c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H240V80c0-8.8 7.2-16 16-16zM139.3 288l75.3 75.3c6 6 9.4 14.1 9.4 22.6V472c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V385.9c0-8.5 3.4-16.6 9.4-22.6L372.7 288H256 139.3z"]
};
var faBuildingCircleXmark = {
  prefix: 'fal',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", "M64 32H320c17.7 0 32 14.3 32 32V266.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64h64 32 64 32 64c19.5 0 37-8.7 48.7-22.5c-7.7-8-14.6-16.8-20.6-26.1c-5.4 9.9-16 16.6-28.1 16.6H256V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM224 416v64H160V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V128zM248 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H248zm8 64V128h32v32H256zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96V256zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H248zm8 64V256h32v32H256zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-121.4 0l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faPersonSledding = {
  prefix: 'fal',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", "M392 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM1.7 248.8c4-7.9 13.6-11.1 21.5-7.1L419 440.6c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 270.3c-7.9-4-11.1-13.6-7.1-21.5zM160 144H320c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L230.6 272 344 272c13.3 0 24 10.7 24 24v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H230.6c-28.5 0-42.8-34.5-22.6-54.6L281.4 176H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSledding = faPersonSledding;
var faGameConsoleHandheld = {
  prefix: 'fal',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M64 32C46.3 32 32 46.3 32 64V416c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zM96 224H288V96H96V224zM64 80c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V80zM208 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 304c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V304z"]
};
var faShip = {
  prefix: 'fal',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", "M240 0c-26.5 0-48 21.5-48 48V64H144c-26.5 0-48 21.5-48 48V237.3L62.7 248.1C27.9 259.3 18 303.8 44.6 328.8l88.4 82.9c6.4 6 16.6 5.7 22.6-.7s5.7-16.6-.7-22.6L66.5 305.4c-8.9-8.3-5.6-23.1 6-26.9L272 214V384c0 8.8 7.2 16 16 16s16-7.2 16-16V214l199.5 64.5c11.6 3.8 14.9 18.6 6 26.9l-88.4 82.9c-6.4 6-6.8 16.2-.7 22.6s16.2 6.8 22.6 .7l88.4-82.9c26.7-25 16.7-69.4-18.1-80.7L480 237.3V112c0-26.5-21.5-48-48-48H384V48c0-26.5-21.5-48-48-48H240zM352 64H224V48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16V64zM192 96h16H368h16 48c8.8 0 16 7.2 16 16V226.9L302.8 180c-9.6-3.1-19.9-3.1-29.6 0L128 226.9V112c0-8.8 7.2-16 16-16h48zM133.8 458.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2z"]
};
var faClockSixThirty = {
  prefix: 'fal',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faBatterySlash = {
  prefix: 'fal',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384H112c-26.5 0-48-21.5-48-48V176c0-12 4.4-22.9 11.7-31.4L50.5 124.8C39 138.7 32 156.5 32 176V336c0 44.2 35.8 80 80 80H419.4l-40.5-32zM464 96H220.6l40.5 32H464c26.5 0 48 21.5 48 48V326l30.7 24.3c.8-4.6 1.3-9.4 1.3-14.3V176c0-44.2-35.8-80-80-80zm128 96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
};
var faTugrikSign = {
  prefix: 'fal',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H176V211.5l-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27v63l-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27V456c0 8.8 7.2 16 16 16s16-7.2 16-16V332.5l115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L208 299.5v-63l115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L208 203.5V64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H192 16z"]
};
var faArrowsDownToLine = {
  prefix: 'fal',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", "M560 448L16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm11.3-164.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L464 345.4 464 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 297.4-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112zm-320-22.6c-6.2-6.2-16.4-6.2-22.6 0L144 345.4 144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 297.4L27.3 260.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faDownload = {
  prefix: 'fal',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V16zM140.1 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H371.9l-32 32H448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H172.1l-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faAnglesUpDown = {
  prefix: 'fal',
  iconName: 'angles-up-down',
  icon: [448, 512, [], "e60d", "M234 19.5c-5.8-4.7-14.1-4.7-20 0L54 147.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l150-120 150 120c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5L234 19.5zm160 345c6.9-5.5 8-15.6 2.5-22.5s-15.6-8-22.5-2.5l-150 120L74 339.5c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5l160 128c5.8 4.7 14.1 4.7 20 0l160-128z"]
};
var faShelves = {
  prefix: 'fal',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", "M16 0c8.8 0 16 7.2 16 16V160H608V16c0-8.8 7.2-16 16-16s16 7.2 16 16V176 432v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 176 16C0 7.2 7.2 0 16 0zM32 416H608V192H32V416zM448 32H384V96h64V32zM384 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM128 288v64h64V288H128zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V288zm192 0v64h64V288H288zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V288z"]
};
var faInventory = faShelves;
var faCloudSnow = {
  prefix: 'fal',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM64 352c-8.8 0-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80V368c0-8.8-7.2-16-16-16zm384 0c-8.8 0-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V432h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H464V368c0-8.8-7.2-16-16-16zM272 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v32l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V400z"]
};
var faFaceGrin = {
  prefix: 'fal',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrin = faFaceGrin;
var faDeleteLeft = {
  prefix: 'fal',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", "M544 128c0-17.7-14.3-32-32-32H205.3c-8.5 0-16.6 3.4-22.6 9.4L32 256 182.6 406.6c6 6 14.1 9.4 22.6 9.4H512c17.7 0 32-14.3 32-32V128zM512 64c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H205.3c-17 0-33.3-6.7-45.3-18.7L9.4 278.6c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6L160 82.7c12-12 28.3-18.7 45.3-18.7H512zM427.3 180.7c6.2 6.2 6.2 16.4 0 22.6L374.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBackspace = faDeleteLeft;
var faOven = {
  prefix: 'fal',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M96 32C60.7 32 32 60.7 32 96v64H416V96c0-35.3-28.7-64-64-64H96zM32 192V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192H32zM0 96C0 43 43 0 96 0H352c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM264 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 256V416H352V256H96zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 48c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z"]
};
var faCloudBinary = {
  prefix: 'fal',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM176 216c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H216c-22.1 0-40-17.9-40-40V216zm40-8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H216zm72-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c-8.8 0-16-7.2-16-16zm120-16h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H408c-22.1 0-40-17.9-40-40V216c0-22.1 17.9-40 40-40zm-8 40v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V216c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8zM192 320c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c-8.8 0-16-7.2-16-16zm80 24c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H312c-22.1 0-40-17.9-40-40V344zm40-8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V344c0-4.4-3.6-8-8-8H312zm88-32h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faEyeDropper = {
  prefix: 'fal',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l0 0-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4 0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L167.4 433.9c-9 9-21.2 14.1-33.9 14.1H88 83.8l-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7V424 378.5c0-12.7 5.1-24.9 14.1-33.9L187.3 235.3z"]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faCommentCaptions = {
  prefix: 'fal',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]
};
var faCommentsQuestion = {
  prefix: 'fal',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM147.9 104.1c5.5-15.4 20.1-25.7 36.4-25.7h41.3c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 173.4v.3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7H184.3c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 236a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z"]
};
var faScribble = {
  prefix: 'fal',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M196.6 19.5C210.2 7 228 0 246.5 0h.9C287.5 0 320 32.5 320 72.6c0 19.2-7.6 37.7-21.3 51.3L75.9 346.7C68.3 354.4 64 364.7 64 375.4c0 22.4 18.2 40.6 40.6 40.6c10.8 0 21.1-4.3 28.7-11.9L388.1 149.3c13.6-13.6 32.1-21.3 51.3-21.3c40.1 0 72.6 32.5 72.6 72.6c0 19.2-7.6 37.7-21.3 51.3L370.5 372.1c-11.8 11.8-18.5 28-18.5 44.8c0 34.8 28.2 63.1 63 63.1c8.7 0 17.3-2 25.1-5.9l48.8-24.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48.8 24.4c-12.2 6.1-25.8 9.3-39.4 9.3c-52.5 0-95-42.7-95-95.1c0-25.2 10-49.5 27.9-67.4L468.1 229.3c7.6-7.6 11.9-17.9 11.9-28.7c0-22.4-18.2-40.6-40.6-40.6c-10.8 0-21.1 4.3-28.7 11.9L155.9 426.7c-13.6 13.6-32.1 21.3-51.3 21.3C64.5 448 32 415.5 32 375.4c0-19.2 7.6-37.7 21.3-51.3L276.1 101.3c7.6-7.6 11.9-17.9 11.9-28.7C288 50.2 269.8 32 247.4 32h-.9c-10.4 0-20.5 3.9-28.2 11L26.9 219.8c-6.5 6-16.6 5.6-22.6-.9s-5.6-16.6 .9-22.6L196.6 19.5z"]
};
var faRotateExclamation = {
  prefix: 'fal',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M403.5 133.1C368.3 90.9 315.3 64 256 64C165.2 64 89.1 127 69.1 211.7c-2 8.6-10.6 13.9-19.2 11.9s-13.9-10.6-11.9-19.2C61.3 105.5 150.1 32 256 32c69.2 0 131 31.4 172.1 80.6L464 154.9V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16s7.2-16 16-16h55.9l-36.3-42.8 0 0-.1-.1zM272 144V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM256 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 432c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H72.1l36.3 42.8 0 0 .1 .1C143.7 421.1 196.7 448 256 448c90.8 0 166.9-63 186.9-147.7c2-8.6 10.7-13.9 19.3-11.9s13.9 10.6 11.9 19.2C450.7 406.5 361.9 480 256 480c-69.2 0-131-31.4-172.1-80.6L48 357.1V416c0 8.8-7.2 16-16 16z"]
};
var faFileCircleCheck = {
  prefix: 'fal',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faGlass = {
  prefix: 'fal',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7L347.1 96H36.8L32.1 40.7zM39.5 128h305L317.2 450.7C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3L39.5 128zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"]
};
var faLoader = {
  prefix: 'fal',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M272 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 384v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm400-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16zM437 75c6.2 6.2 6.2 16.4 0 22.6l-67.9 67.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0zM165.5 369.1L97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l67.9-67.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM75 75c6.2-6.2 16.4-6.2 22.6 0l67.9 67.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zM369.1 346.5L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-67.9-67.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faForward = {
  prefix: 'fal',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", "M474.4 256L256 414.1V97.9L474.4 256zM254 64c-16.6 0-30 13.5-30 30V197.4L47.7 69.7C42.5 66 36.4 64 30 64C13.5 64 0 77.5 0 94V418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L224 314.6V418c0 16.6 13.5 30 30 30c6.3 0 12.5-2 17.6-5.7L502.1 275.4c6.2-4.5 9.9-11.7 9.9-19.4s-3.7-14.9-9.9-19.4L271.7 69.7C266.5 66 260.4 64 254 64zM224 275.1L32 414.1V97.9l192 139v38.2z"]
};
var faUserPilot = {
  prefix: 'fal',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M230.9 .8c-4.6-1-9.3-1-13.9 0l-144 32C61.7 35.3 52.5 43.8 49.3 55.1s-.2 23.3 8.1 31.6L80 109.3v1.6c0 15.6 7.6 31.8 23.2 40.1c22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1v-1.6l22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32zM80 64L224 32 368 64 340.7 91.3c-3 3-4.7 7.1-4.7 11.3v8.2c0 5.8-2.8 10-6.2 11.8C312.2 132 280.4 144 224 144s-88.2-12-105.8-21.3c-3.4-1.8-6.2-6-6.2-11.8v-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64zm41.5 320.8l70.9 62.1c18.1 15.8 45.1 15.8 63.2 0l70.9-62.1c48.4 6.1 86.2 45.9 89.3 95.2H32.2c3-49.3 40.9-89.1 89.3-95.2zm15.7-28.8c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6c0-71.6-55.9-130.1-126.5-134.2c-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0l-76.3-66.7zM304 432c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-9.1 4.3-19.6 8.5-31.8 12.1C318.1 246.9 275.9 288 224 288s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1c-.2 2.9-.3 5.8-.3 8.7zM183.2 65.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7z"]
};
var faMobile = {
  prefix: 'fal',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M96 32C78.3 32 64 46.3 64 64V448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM160 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faCodePullRequestClosed = {
  prefix: 'fal',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", "M160 80A48 48 0 1 0 64 80a48 48 0 1 0 96 0zm32 0c0 38.7-27.5 71-64 78.4V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V158.4C59.5 151 32 118.7 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM64 432a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm336 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM384 353.6V208c0-8.8 7.2-16 16-16s16 7.2 16 16V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4zM332.7 12.7c6.2-6.2 16.4-6.2 22.6 0L400 57.4l44.7-44.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L422.6 80l44.7 44.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 102.6l-44.7 44.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L377.4 80 332.7 35.3c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFaceMeh = {
  prefix: 'fal',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 336c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faMeh = faFaceMeh;
var faAlignCenter = {
  prefix: 'fal',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM96 320c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faBookSkull = {
  prefix: 'fal',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM240 96c-38.9 0-64 24.6-64 48c0 14.1 8.4 28 24.2 37.5c4.8 2.9 7.8 8.1 7.8 13.7V208h64V195.2c0-5.6 2.9-10.8 7.8-13.7C295.6 172 304 158.1 304 144c0-23.4-25.1-48-64-48zm-96 48c0-47.3 46.5-80 96-80s96 32.7 96 80c0 24.6-13 45.6-32 59.7V216c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V203.7c-19-14.1-32-35.1-32-59.7zm56 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM129.2 249.8c3.4-8.2 12.8-12 20.9-8.6L240 278.7l89.8-37.4c8.2-3.4 17.5 .5 20.9 8.6s-.5 17.5-8.6 20.9L281.6 296l60.6 25.2c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6L240 313.3l-89.8 37.4c-8.2 3.4-17.5-.5-20.9-8.6s.5-17.5 8.6-20.9L198.4 296l-60.6-25.2c-8.2-3.4-12-12.8-8.6-20.9z"]
};
var faBookDead = faBookSkull;
var faIdCard = {
  prefix: 'fal',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M64 64C46.3 64 32 78.3 32 96l512 0c0-17.7-14.3-32-32-32H64zM0 112V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64v16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V112zm544 16H32V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM160 352c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H160zM336 208c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16z"]
};
var faDriversLicense = faIdCard;
var faFaceDotted = {
  prefix: 'fal',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M256 0c-17.1 0-33.8 1.7-49.9 4.9c-8.7 1.7-14.3 10.1-12.6 18.8s10.1 14.3 18.8 12.6C226.4 33.5 241 32 256 32s29.6 1.5 43.7 4.3c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8C289.8 1.7 273.1 0 256 0zM398.2 43.1c-7.3-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2c24.4 16.4 45.5 37.4 61.8 61.8c4.9 7.3 14.9 9.3 22.2 4.4s9.3-14.9 4.4-22.2c-18.7-27.9-42.7-51.9-70.6-70.6zM131.6 69.7c7.3-4.9 9.3-14.9 4.4-22.2s-14.9-9.3-22.2-4.4C85.8 61.8 61.8 85.8 43.1 113.8c-4.9 7.3-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4c16.4-24.4 37.4-45.5 61.8-61.8zM36.3 212.3c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6C1.7 222.2 0 238.9 0 256s1.7 33.8 4.9 49.9c1.7 8.7 10.1 14.3 18.8 12.6s14.3-10.1 12.6-18.8C33.5 285.6 32 271 32 256s1.5-29.6 4.3-43.7zm470.9-6.2c-1.7-8.7-10.1-14.3-18.8-12.6s-14.3 10.1-12.6 18.8c2.8 14.1 4.3 28.8 4.3 43.7s-1.5 29.6-4.3 43.7c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6c3.2-16.2 4.9-32.9 4.9-49.9s-1.7-33.8-4.9-49.9zM69.7 380.4c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2c18.7 27.9 42.7 51.9 70.6 70.6c7.3 4.9 17.3 3 22.2-4.4s2.9-17.3-4.4-22.2c-24.4-16.4-45.5-37.4-61.8-61.8zm399.2 17.8c4.9-7.3 3-17.3-4.4-22.2s-17.3-2.9-22.2 4.4c-16.4 24.4-37.4 45.5-61.8 61.8c-7.3 4.9-9.3 14.9-4.4 22.2s14.9 9.3 22.2 4.4c27.9-18.7 51.9-42.7 70.6-70.6zM212.3 475.7c-8.7-1.7-17.1 3.9-18.8 12.6s3.9 17.1 12.6 18.8c16.2 3.2 32.9 4.9 49.9 4.9s33.8-1.7 49.9-4.9c8.7-1.7 14.3-10.1 12.6-18.8s-10.1-14.3-18.8-12.6C285.6 478.5 271 480 256 480s-29.6-1.5-43.7-4.3zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336c-8.8 0-16 7.2-16 16s7.2 16 16 16H328c8.8 0 16-7.2 16-16s-7.2-16-16-16H184z"]
};
var faFaceWorried = {
  prefix: 'fal',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM308.9 429.8c-16.2-6.1-34-9.4-52.9-9.4c-18.8 0-36.7 3.4-52.9 9.4c-11.2 4.2-23.6 2.3-32.4-4.5c-4.5-3.5-8.4-8.6-10-15.1c-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336c40.1 0 75.2 22.1 92.5 54.7c3.2 6 4.3 12.8 2.7 19.5c-1.6 6.5-5.5 11.6-10 15.1c-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2c18.5-6.4 38.6-9.8 59.6-9.8c21 0 41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zM152.4 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faOutdent = {
  prefix: 'fal',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", "M0 64c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 48 0 55.2 0 64zM192 192c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zM0 448c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM96 211.8v88.4L42.3 256 96 211.8zM7 243.6C-.8 250-.8 262 7 268.4l94.8 78.1c10.4 8.6 26.2 1.2 26.2-12.4V177.9c0-13.5-15.7-20.9-26.2-12.4L7 243.6z"]
};
var faDedent = faOutdent;
var faHeartCircleExclamation = {
  prefix: 'fal',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faHouse = {
  prefix: 'fal',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48zm144 48V320h96V480H240z"]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faVectorCircle = {
  prefix: 'fal',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", "M280 32c4.4 0 8 3.6 8 8l0 10.4V82.9l0 5.1c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8V40c0-4.4 3.6-8 8-8h48zm40 26V40c0-22.1-17.9-40-40-40H232c-22.1 0-40 17.9-40 40V58C128.6 78.5 78.5 128.6 58 192H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H58c20.5 63.4 70.6 113.5 134 134v18c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V454c63.4-20.5 113.5-70.6 134-134h18c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H454C433.5 128.6 383.4 78.5 320 58zm-.2 33.9c45.9 17.9 82.4 54.4 100.3 100.3c-20.2 2-36.1 19-36.1 39.8v48c0 20.8 15.8 37.8 36.1 39.8c-17.9 45.9-54.4 82.4-100.3 100.3c-2-20.2-19-36.1-39.8-36.1H232c-20.8 0-37.8 15.8-39.8 36.1c-45.9-17.9-82.4-54.4-100.3-100.3c20.2-2 36.1-19 36.1-39.8V232c0-20.8-15.8-37.8-36.1-39.8c17.9-45.9 54.4-82.4 100.3-100.3c2 20.2 19 36.1 39.8 36.1h48c20.8 0 37.8-15.8 39.8-36.1zM429.1 224s0 0 0 0h32.5s0 0 0 0H472c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h5.1zM288 429.1v32.5l0 10.4c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8V424c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8l0 5.1zM50.4 224s0 0 0 0H82.9s0 0 0 0H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8H50.4z"]
};
var faCarCircleBolt = {
  prefix: 'fal',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M113.6 98.2c6.1-20.3 24.8-34.2 46-34.2H352.4c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6H96c-3.6 0-7.2 .2-10.7 .6l28.3-94.4zM74.3 227.8l.5 .1 .1-.3c6.6-2.3 13.8-3.6 21.2-3.6H394.8c19.5-13.7 41.9-23.6 66.2-28.5L429 89c-10.2-33.8-41.3-57-76.6-57H159.6C124.3 32 93.1 55.2 83 89L48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288v96 16 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V416H326.6c-2.9-10.3-4.9-21-5.9-32H32V288c0-27.7 17.6-51.3 42.3-60.2zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faCalendarWeek = {
  prefix: 'fal',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm40 160H344c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V264c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"]
};
var faFlyingDisc = {
  prefix: 'fal',
  iconName: 'flying-disc',
  icon: [448, 512, [], "e3a9", "M401.7 78.3c14.5 14.5 21.3 46 4.4 96.7c-16.2 48.7-52 105.9-104.6 158.5S191.8 421.9 143.1 438.1c-50.8 16.9-82.3 10-96.7-4.4c-12.1-12.1-18.9-36.1-10.9-73.4c3 5.8 7 11.5 12.3 16.8c20 20 45.9 21.8 63.4 19.8c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c2-17.5 .2-43.4-19.8-63.4c-5.3-5.3-11-9.3-16.8-12.3c37.2-8 61.3-1.2 73.4 10.9zM105.1 175.5C8.3 282-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.1 356.2S479.6 111 424.3 55.7C372.2 3.6 250 40.3 143.6 137c-6.7 6-13.3 12.3-19.8 18.8c-6.5 6.5-12.8 13.1-18.7 19.7zM128.8 197c5.7-6.2 11.5-12.4 17.6-18.5c6.1-6.1 12.3-12 18.5-17.7c26.8-24.2 54-43.2 78.1-55.2c14.8-7.3 29.2-12.4 42.2-13.9c13-1.5 27 .5 37.2 10.6s12.1 24.2 10.6 37.2c-1.5 13-6.5 27.4-13.9 42.2c-14.7 29.7-40.3 64.1-72.8 96.7s-67 58.1-96.7 72.8c-14.8 7.3-29.2 12.4-42.2 13.9c-13 1.5-27-.5-37.2-10.6s-12.1-24.2-10.6-37.2c1.5-13 6.5-27.4 13.9-42.2c12-24.1 31-51.3 55.2-78.1z"]
};
var faLaptopMedical = {
  prefix: 'fal',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M128 64H512c17.7 0 32 14.3 32 32V352h32V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V352H96V96c0-17.7 14.3-32 32-32zM33.9 416H606.1c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM304 112c-17.7 0-32 14.3-32 32v32H240c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272h32c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H368V144c0-17.7-14.3-32-32-32H304zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H352c-8.8 0-16 7.2-16 16v48H304V256c0-8.8-7.2-16-16-16H240V208h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V144z"]
};
var faSquareDownRight = {
  prefix: 'fal',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM304 328V214.6c0-3.7-3-6.6-6.6-6.6c-1.8 0-3.4 .7-4.7 1.9l-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0l-59.1-59.1c-3.6-3.6-9-4.9-13.9-3.3c-2 .7-3.8 1.8-5.3 3.3l-22.1 22.1c-1.5 1.5-2.6 3.3-3.3 5.3c-1.6 4.9-.4 10.3 3.3 13.9l59.1 59.1c6.2 6.2 6.2 16.4 0 22.6l-25.4 25.4c-1.2 1.2-1.9 2.9-1.9 4.7c0 3.7 3 6.6 6.6 6.6H296c4.4 0 8-3.6 8-8zm-8 40H182.6c-21.3 0-38.6-17.3-38.6-38.6c0-10.2 4.1-20.1 11.3-27.3L169.4 288l-47.7-47.7c-12.2-12.2-16.5-30.3-11-46.7c2.2-6.7 6-12.8 11-17.8l22.1-22.1c5-5 11.1-8.8 17.8-11c16.4-5.5 34.5-1.2 46.7 11L256 201.4l14.1-14.1c7.2-7.2 17.1-11.3 27.3-11.3c21.3 0 38.6 17.3 38.6 38.6V328c0 22.1-17.9 40-40 40z"]
};
var faB = {
  prefix: 'fal',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M48 32C21.5 32 0 53.5 0 80V240 432c0 26.5 21.5 48 48 48H192c70.7 0 128-57.3 128-128c0-52.8-32-98.2-77.7-117.7C270 213.9 288 181 288 144c0-61.9-50.1-112-112-112H48zM192 256c53 0 96 43 96 96s-43 96-96 96H48c-8.8 0-16-7.2-16-16V256H176h16zm-16-32H32V80c0-8.8 7.2-16 16-16H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faSeatAirline = {
  prefix: 'fal',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V142.3c0 14 3.1 27.9 9 40.6l87.3 187C109.4 398 137.7 416 168.8 416H224v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V416H358.2c27 0 51.2-17 60.3-42.5l28.6-80.1c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8H85.9L63.5 224H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H48.6L38 169.3c-4-8.5-6-17.7-6-27.1V16zM240 384H168.8c-18.6 0-35.6-10.8-43.5-27.7L100.9 304H409.3l-21 58.8c-4.6 12.7-16.6 21.2-30.1 21.2H240z"]
};
var faMoonOverSun = {
  prefix: 'fal',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM265.1 97.7l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8l-17.4 94.5-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0zM174.2 256c0-43.2 33.9-78.7 77-81.6c-19.3 15.2-31.7 38.7-31.7 65.1c0 46 37.6 83.2 83.9 83.2l1.2 0c-13.5 9.5-30 15.1-47.8 15.1c-45.7 0-82.6-36.6-82.6-81.8zm82.6-113.8c-63 0-114.6 50.7-114.6 113.8s51.6 113.8 114.6 113.8c31 0 59.1-12.2 79.8-32.1c8.9-8.5 11.1-21.8 5.6-32.8s-17.6-17-29.7-15c-2.9 .5-5.9 .8-9 .8c-28.9 0-51.9-23.2-51.9-51.2c0-18.9 10.5-35.6 26.3-44.5c10.7-6 16.3-18.3 13.7-30.4s-12.8-20.9-25-22c-3.2-.3-6.4-.4-9.7-.4z"]
};
var faEclipseAlt = faMoonOverSun;
var faPipe = {
  prefix: 'fal',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M32 0c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C16 7.2 23.2 0 32 0z"]
};
var faFileMedical = {
  prefix: 'fal',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM176 224c-17.7 0-32 14.3-32 32v32H112c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384h32c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H240V256c0-17.7-14.3-32-32-32H176zm0 80V256h32v48c0 8.8 7.2 16 16 16h48v32H224c-8.8 0-16 7.2-16 16v48H176V368c0-8.8-7.2-16-16-16H112V320h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"]
};
var faPotato = {
  prefix: 'fal',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M480 144c0-61.9-50.1-112-112-112c-31 0-59 12.5-79.3 32.9c-29.6 29.7-65.7 56.7-102.4 76.8c-18.8 10.3-34.3 25.8-44.6 44.6C121.6 223 94.6 259.1 64.9 288.7C44.5 309 32 337 32 368c0 61.9 50.1 112 112 112c23.6 0 45.4-7.3 63.4-19.6c30.5-21 65.4-38.4 100.4-50.2c34.4-11.6 62.4-39.6 72.4-77.2c10.7-39.9 34.1-78.9 64.3-107.2C466.4 205.3 480 176.3 480 144zm32 0c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM180 264a20 20 0 1 1 0-40 20 20 0 1 1 0 40zM168 396a20 20 0 1 1 -40 0 20 20 0 1 1 40 0zM364 200a20 20 0 1 1 0-40 20 20 0 1 1 0 40z"]
};
var faDiceOne = {
  prefix: 'fal',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleA = {
  prefix: 'fal',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-6.1 0-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L185.9 304H326.1l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-112-224c-2.7-5.4-8.3-8.8-14.3-8.8zm0 51.8L310.1 272H201.9L256 163.8z"]
};
var faHelmetBattle = {
  prefix: 'fal',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M84.4 .6C75.9-1.8 67 3.1 64.6 11.6l-53 185.5C3.2 226.6 25.3 256 56 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-9.4 0-16.2-9-13.6-18.1l53-185.5C97.8 11.9 92.9 3 84.4 .6zM295.7 2c-4.8-2.6-10.6-2.6-15.4 0L288 16l7.7-14zM511.5 403.9l0 0 0 0 0-.1-.1-.2-.3-1c-.2-.9-.6-2.2-1-3.9c-.9-3.4-2.1-8.3-3.6-14.5c-3-12.3-6.9-29.6-10.9-49.4c-8-39.8-15.7-88.5-15.7-126.9c0-28.6-13.1-55.9-30.6-79.6c-17.6-24-40.7-45.9-63.2-64.4c-22.6-18.6-45.2-34-62-44.8c-8.4-5.4-15.5-9.7-20.4-12.6c-2.5-1.5-4.4-2.6-5.8-3.4l-1.6-.9-.4-.2-.1-.1 0 0 0 0s0 0-7.7 14c-7.7-14-7.7-14-7.7-14l0 0 0 0-.1 .1-.4 .2-1.6 .9c-1.4 .8-3.3 1.9-5.8 3.4c-5 2.9-12 7.2-20.4 12.6c-16.8 10.8-39.4 26.2-62 44.8c-22.5 18.5-45.7 40.5-63.2 64.4C109.1 152.1 96 179.4 96 208c0 38.3-7.7 87.1-15.7 126.9c-4 19.8-7.9 37.1-10.9 49.4c-1.5 6.2-2.7 11.1-3.6 14.5c-.4 1.7-.8 3-1 3.9l-.3 1-.1 .2 0 .1 0 0 0 0 0 0c-1.9 7.2 1.4 14.8 8 18.3l166.9 87.4c2.6 1.4 5.5 2.2 8.5 2.5c13 1.1 24.1-9.1 24.1-22.1V285.1c0-15.3-10.8-28.4-25.7-31.4l-45.9-9.2c-4.9-1-8.3-5.2-8.3-10.2c0-5.7 4.6-10.4 10.4-10.4H373.6c5.7 0 10.4 4.6 10.4 10.4c0 4.9-3.5 9.2-8.3 10.2l-45.9 9.2c-15 3-25.7 16.1-25.7 31.4V489.9c0 13 11.1 23.2 24.1 22.1c3-.2 5.8-1.1 8.5-2.5l166.9-87.4c6.6-3.5 10-11.1 8-18.3l0 0zm-34.1-4.2L336 473.7V285.1l45.9-9.2c19.8-4 34.1-21.4 34.1-41.6c0-23.4-19-42.4-42.4-42.4H202.4C179 192 160 211 160 234.4c0 20.2 14.3 37.6 34.1 41.6l45.9 9.2V473.7L98.6 399.7c.6-2.4 1.2-5 1.9-8c3-12.6 7.1-30.4 11.1-50.6c8-40.2 16.3-91.5 16.3-133.1c0-19 8.9-39.5 24.4-60.7c15.4-21 36.3-41 57.8-58.6c21.4-17.5 42.8-32.2 59-42.6c7.7-5 14.2-8.9 18.9-11.6c4.6 2.7 11.1 6.7 18.9 11.6c16.2 10.3 37.6 25 59 42.6c21.4 17.6 42.3 37.7 57.8 58.6C439.1 168.5 448 189 448 208c0 41.7 8.3 92.9 16.3 133.1c4 20.2 8.1 37.9 11.1 50.6c.7 2.9 1.4 5.6 1.9 8zm34-388.1C509 3.1 500.1-1.8 491.6 .6s-13.4 11.3-11 19.8l53 185.5c2.6 9.1-4.2 18.1-13.6 18.1c-8.8 0-16 7.2-16 16s7.2 16 16 16c30.7 0 52.8-29.4 44.4-58.9l-53-185.5z"]
};
var faButter = {
  prefix: 'fal',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M480 96V288H448V96H128c-17.7 0-32 14.3-32 32V288H64V128c0-35.3 28.7-64 64-64H448h16 16 32c35.3 0 64 28.7 64 64V288H544V128c0-17.7-14.3-32-32-32H480zM0 336c0-8.8 7.2-16 16-16H32 64 576h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V352H16c-8.8 0-16-7.2-16-16zm64 16v48c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V352H64z"]
};
var faBlanketFire = {
  prefix: 'fal',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M32 96c0-35.3 28.7-64 64-64H352c35.3 0 64 28.7 64 64v41c9.4-6.9 20.9-9.8 32-8.8V96c0-53-43-96-96-96H96C43 0 0 43 0 96V352c0 53 43 96 96 96H314.4c-5.9-10.1-10.9-20.9-14.9-32H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H301.8c4.4-10.9 9.7-21.6 15.5-32H96c-24.6 0-47 9.2-64 24.4V96zM288 350.1c0-4.6 .3-9.3 .8-14.1H96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288.8c-.5-5.9-.8-11.9-.8-17.9zm221.4-96.6c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2C608 422.4 551 480 480 480c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5C508.6 412 495.7 416 481 416c-19.1 0-35.3-6.1-46.6-16.4C423.3 389.4 416 374.3 416 354c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faKiwiBird = {
  prefix: 'fal',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M192 384c33.9 0 65.3-10.5 91.2-28.5c33.7-23.4 78.2-51.5 130.4-51.5H464c44.2 0 80-35.8 80-80s-35.8-80-80-80H413.6c-52.2 0-96.7-28.1-130.4-51.5C257.3 74.5 225.9 64 192 64C103.6 64 32 135.6 32 224s71.6 160 160 160zm311.3-55.1L544 402.3V302.4c-11.4 11.6-25.2 20.7-40.7 26.5zM546 471.8l-75.5-136c-2.1 .1-4.3 .2-6.5 .2H413.6c-41.2 0-78.3 22.3-112.1 45.8c-13.9 9.7-29.2 17.5-45.4 23.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V413.3c-10.4 1.7-21.1 2.7-32 2.7c-22.4 0-44-3.8-64-10.9V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V390.3C38.6 357.1 0 295.1 0 224C0 118 86 32 192 32c40.7 0 78.4 12.6 109.4 34.2c33.8 23.5 71 45.8 112.1 45.8H464c61.9 0 112 50.1 112 112V464c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCastle = {
  prefix: 'fal',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", "M128 40c0-22.1 17.9-40 40-40h24c22.1 0 40 17.9 40 40V64h32V40c0-22.1 17.9-40 40-40h32c22.1 0 40 17.9 40 40V64h32V40c0-22.1 17.9-40 40-40h24c22.1 0 40 17.9 40 40V224h32V200c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V200c0-22.1 17.9-40 40-40H56c22.1 0 40 17.9 40 40v24h32V40zm40-8c-4.4 0-8 3.6-8 8V224H480V40c0-4.4-3.6-8-8-8H448c-4.4 0-8 3.6-8 8V80c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H304c-4.4 0-8 3.6-8 8V80c0 8.8-7.2 16-16 16H216c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8H168zM496 256H144 80c-8.8 0-16-7.2-16-16V200c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8V432c0 26.5 21.5 48 48 48H224V400c0-53 43-96 96-96s96 43 96 96v80H560c26.5 0 48-21.5 48-48V200c0-4.4-3.6-8-8-8H584c-4.4 0-8 3.6-8 8v40c0 8.8-7.2 16-16 16H496zM384 400c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H384V400z"]
};
var faGolfClub = {
  prefix: 'fal',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", "M510.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L303.5 365.1l-243-65.7C30 291.2 0 314.2 0 345.8V464c0 26.5 21.5 48 48 48H226.3c24.2 0 46.4-13.7 57.2-35.4l42.7-85.5 184-368zM52.2 330.4l236.8 64-34 68c-5.4 10.8-16.5 17.7-28.6 17.7H48c-8.8 0-16-7.2-16-16V448H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V400H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V345.8c0-10.5 10-18.2 20.2-15.4z"]
};
var faArrowRightArrowLeft = {
  prefix: 'fal',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", "M443.3 139.3c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 112 16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96zm-342.6 352c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400 432 400c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 368l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96z"]
};
var faExchange = faArrowRightArrowLeft;
var faRotateRight = {
  prefix: 'fal',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3V176c0 8.8-7.2 16-16 16H363.3c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160H448V86.6z"]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faUtensils = {
  prefix: 'fal',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M42.6 .2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9V176c0 26.5 21.5 48 48 48h32 32c26.5 0 48-21.5 48-48V165.3c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2V176c0 44.2-35.8 80-80 80H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H80c-44.2 0-80-35.8-80-80V165.3c0-4.4 .4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6 .2zM88.8 0c8.8 .4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0C144-.4 151.5 6.4 152 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4 .5 135.2 0zM320 176V288c0 17.7 14.3 32 32 32h64V32.2l-.2 .1c-1.7 .4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32V320v16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H352c-35.3 0-64-28.7-64-64V176C288 32 400 0 416 0z"]
};
var faCutlery = faUtensils;
var faArrowUpWideShort = {
  prefix: 'fal',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 464h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faSortAmountUp = faArrowUpWideShort;
var faChartPieSimpleCircleDollar = {
  prefix: 'fal',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M288 224H394.8c-12.9 9.1-24.5 19.9-34.6 32H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5V224zm-32 64h83.2c-5.2 10.1-9.4 20.8-12.6 32H224c-17.7 0-32-14.3-32-32V69.6C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V256v32h32zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8 16H480v-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288 272h32v16 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
var faBalloons = {
  prefix: 'fal',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", "M172.8 342.4l0 0 0 0 0 0L160 352l-12.8-9.6 0 0 0 0 0 0 0 0-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8c-3.1-2.6-7.8-6.4-13.3-11.4c-11.2-10-26.1-24.5-40.9-42C58 249.1 32 204.5 32 160C32 89.3 89.3 32 160 32s128 57.3 128 128c0 44.5-26 89.1-56.5 125.4c-14.8 17.6-29.7 32-40.9 42c-5.6 5-10.2 8.8-13.3 11.4c-1.6 1.3-2.8 2.2-3.6 2.8l-.8 .6-.1 .1 0 0zm-9.4 39.9L180.2 416H139.8l16.8-33.7 3.4-6.8 3.4 6.8zM192 368s128-96 128-208C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368L97.4 429.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H211.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L192 368zm139.2-84.9C362.3 367.8 448 432 448 432l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H531.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L512 432s128-96 128-208c0-88.4-71.6-160-160-160c-46.1 0-87.7 19.5-116.9 50.8c3.2 14.6 4.9 29.7 4.9 45.2c0 .7 0 1.3 0 2c21.8-39.4 63.8-66 112-66c70.7 0 128 57.3 128 128c0 44.5-26 89.1-56.5 125.4c-14.8 17.6-29.7 32-40.9 42c-5.6 5-10.2 8.8-13.3 11.4c-1.6 1.3-2.8 2.2-3.6 2.8l-.8 .6-.1 .1 0 0 0 0 0 0 0 0L480 416l-12.8-9.6 0 0 0 0 0 0 0 0-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8c-3.1-2.6-7.8-6.4-13.3-11.4c-11.2-10-26.1-24.5-40.9-42C381.2 317 357.6 278 352.9 238.3c-6.1 16-13.6 31-21.7 44.7zM480 439.6l3.4 6.8L500.2 480H459.8l16.8-33.7 3.4-6.8zM112 160c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zm320 64c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faMillSign = {
  prefix: 'fal',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M287.2 21.1c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1L222.7 113.2c-12.3 8.2-22.8 18.9-30.7 31.4C173.6 115.4 141.1 96 104 96c-27.9 0-53.3 11-72 29V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H.3c-.2 2.6-.3 5.3-.3 8V432c0 8.8 7.2 16 16 16s16-7.2 16-16V200c0-39.8 32.2-72 72-72s72 32.2 72 72v53.4L96.8 490.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1L176 354.6V416v16c0 8.8 7.2 16 16 16s16-7.2 16-16V416 258.6l41.2-123.7c9.3-4.4 19.8-6.9 30.8-6.9c39.8 0 72 32.2 72 72V432c0 8.8 7.2 16 16 16s16-7.2 16-16V200c0-57.4-46.6-104-104-104c-6.3 0-12.4 .6-18.3 1.6l25.5-76.6z"]
};
var faBowlRice = {
  prefix: 'fal',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M176 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H192zM48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm81.3 233.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288H479.9c-1.8 52.3-33.9 97-79.4 116.9c-8.6 3.8-15.2 11.2-17.8 20.2C378.7 438.4 366.5 448 352 448H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4zM224 208c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm-96 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm224 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288zm128 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384zM288 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288z"]
};
var faTimelineArrow = {
  prefix: 'fal',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M144 80A32 32 0 1 0 80 80a32 32 0 1 0 64 0zm32 0c0 29.8-20.4 54.9-48 62V256H352V142c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62V256H579.8l-62.1-51.7c-6.8-5.7-7.7-15.7-2-22.5s15.7-7.7 22.5-2l95.9 79.9c.6 .5 1.1 1 1.6 1.5c2.6 2.8 4.2 6.7 4.2 10.8c0 .3 0 .7 0 1c-.2 3.5-1.5 6.7-3.6 9.2c-.6 .8-1.3 1.5-2.1 2.1l-.1 .1-95.9 79.9c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5L579.8 288H256v82c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-29.8 20.4-54.9 48-62V288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V142c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64zm32 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM400 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSkull = {
  prefix: 'fal',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M384 399.6c-.2-10.7 4.9-20.8 13.6-26.9c51.3-36 82.4-89.8 82.4-148.7c0-102.2-96.1-192-224-192S32 121.8 32 224c0 58.8 31.1 112.7 82.4 148.7c8.8 6.1 13.9 16.2 13.6 26.9l0 .4v64c0 8.8 7.2 16 16 16h48V432c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V432c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16-7.2 16-16V400l0-.4zm32-.7c0 .4 0 .7 0 1.1v64c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V400c0-.4 0-.7 0-1.1C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faGameBoardSimple = {
  prefix: 'fal',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 240H208V128H96V240zM240 120V240H360c13.3 0 24 10.7 24 24V392c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V272H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24H216c13.3 0 24 10.7 24 24zm0 264H352V272H240V384z"]
};
var faGameBoardAlt = faGameBoardSimple;
var faCircleVideo = {
  prefix: 'fal',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-320v32 64 32H160V192H288zm32 9.8V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32v-9.8l74.9 25c4.9 1.6 10.2 .8 14.4-2.2s6.6-7.8 6.6-13V192c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-74.9 25zm0 33.7l64-21.3v83.6l-64-21.3V235.5z"]
};
var faVideoCircle = faCircleVideo;
var faChartScatterBubble = {
  prefix: 'fal',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM176 323.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm208 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-48-92.8a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHouseTurret = {
  prefix: 'fal',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", "M288 448V284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zM256 284.2V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L276.8 237c-13.2 12.1-20.8 29.2-20.8 47.2zM416 288h64v64H416V288zm-32 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32zM32 48c0-8.8 7.2-16 16-16H96V96c0 8.8 7.2 16 16 16s16-7.2 16-16V32h96V96c0 8.8 7.2 16 16 16s16-7.2 16-16V32h48c8.8 0 16 7.2 16 16V153.9l32-29.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V203.8c0 11.8 4.3 23.1 12.1 31.9L64 294.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-3.9-1.4-7.7-4-10.6L36 214.5c-2.6-2.9-4-6.7-4-10.6V48zM192 224H160V192c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm-16-80c-26.5 0-48 21.5-48 48v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V192c0-26.5-21.5-48-48-48z"]
};
var faBanana = {
  prefix: 'fal',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", "M336 144c0 41.2-8.7 80.4-24.3 115.9c-8-7.6-17-14.2-26.5-19.5C297.3 210.7 304 178.1 304 144c0-31.4-5.6-61.3-15.9-89c-9.5-25.5 8.6-55 38-55c9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 11-.6 21.8-1.8 32.5c-11.4 1-22.6 3.6-33.3 7.5c2.1-13.1 3.1-26.4 3.1-40.1c0-75.3-32.5-143-84.3-189.9c-1.5-1.4-3.5-2.1-5.6-2.1c-3.3 0-5.5 1.4-7 3.6c-1.7 2.6-2 5.6-1.1 8.2C329.7 75 336 108.8 336 144zM253.9 296.2c-9.7-5.3-20.7-8.2-32-8.2c-11.6 0-22.9 3-32.9 8.7l-37 21.1c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l37-21.1c14.9-8.5 31.7-13 48.8-13c26.1 0 51.1 10.4 69.6 28.8l48 48 77.8-35.9c12.7-5.9 26.5-8.9 40.5-8.9c34.4 0 66.1 18.2 83.4 47.9l32.7 56c4.5 7.6 1.9 17.4-5.8 21.9s-17.4 1.9-21.9-5.8l-32.7-56c-11.6-19.8-32.8-32.1-55.8-32.1c-9.3 0-18.6 2-27.1 5.9l-1.4 .7C387.8 435 282.9 512 160 512L48 512c-26.5 0-48-21.5-48-48V448c0-26.5 21.5-48 48-48c84.4 0 159.2-40.8 205.9-103.8zm130.6 51.1l-41.7 19.3c-6.1 2.8-13.3 1.5-18-3.2l-46.4-46.4C225.8 386.8 142.2 432 48 432c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16l112 0c96.7 0 180.9-53.6 224.4-132.7z"]
};
var faHandHoldingSkull = {
  prefix: 'fal',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M176 128c0 33.3 20 63.5 51.9 81c6.4 3.5 9.6 10.9 7.8 17.9L228.5 256h119l-7.3-29.1c-1.8-7.1 1.5-14.4 7.8-17.9C380 191.5 400 161.3 400 128c0-51.1-48.1-96-112-96s-112 44.9-112 96zM288 0c77.5 0 144 55.4 144 128c0 42.6-23.3 79.6-57.9 102.6l9.4 37.5c1.2 4.8 .1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2H208c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l9.4-37.5c-34.6-23-57.9-60-57.9-102.6C144 55.4 210.5 0 288 0zM248 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faPeopleDress = {
  prefix: 'fal',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM126.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H96v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L246.1 368H208 112 73.9l52.4-104.8zM160 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C231.7 148.6 197.3 128 160 128s-71.7 20.6-89.3 53.5L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L99 196.6c12-22.5 35.5-36.6 61-36.6zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6 .7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H528 432 393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9C551.7 148.6 517.3 128 480 128s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L419 196.6c12-22.5 35.5-36.6 61-36.6z"]
};
var faLoveseat = {
  prefix: 'fal',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M320 64c53 0 96 43 96 96v37.5c10-3.5 20.8-5.5 32-5.5V160c0-70.7-57.3-128-128-128H192C121.3 32 64 89.3 64 160v32c11.2 0 22 1.9 32 5.5V160c0-53 43-96 96-96H320zM96 320v96 16c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32zM80 480c20.9 0 38.7-13.4 45.3-32H386.7c6.6 18.6 24.4 32 45.3 32h32c26.5 0 48-21.5 48-48V288c0-35.3-28.7-64-64-64s-64 28.7-64 64H128c0-35.3-28.7-64-64-64s-64 28.7-64 64V432c0 26.5 21.5 48 48 48H80zm48-64V320H384v96H128zm288 16V416 320 288c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16z"]
};
var faCouchSmall = faLoveseat;
var faTowerBroadcast = {
  prefix: 'fal',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M46.7 1.4c-8.1-3.6-17.5-.1-21.2 8C9.1 45.6 0 85.8 0 128s9.1 82.4 25.5 118.6c3.6 8.1 13.1 11.6 21.2 8s11.6-13.1 8-21.2C40.1 201.3 32 165.6 32 128s8.1-73.3 22.6-105.4c3.6-8.1 .1-17.5-8-21.2zm482.7 0c-8.1 3.6-11.6 13.1-8 21.2C535.9 54.7 544 90.4 544 128s-8.1 73.3-22.6 105.4c-3.6 8.1-.1 17.5 8 21.2s17.5 .1 21.2-8C566.9 210.4 576 170.2 576 128s-9.1-82.4-25.5-118.6c-3.6-8.1-13.1-11.6-21.2-8zM256 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm48 62c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62V496c0 8.8 7.2 16 16 16s16-7.2 16-16V190zM138.9 69.8c3.2-8.2-.9-17.5-9.1-20.7s-17.5 .9-20.7 9.1C100.6 79.8 96 103.4 96 128s4.6 48.2 13.1 69.8c3.2 8.2 12.5 12.3 20.7 9.1s12.3-12.5 9.1-20.7c-7-18-10.9-37.6-10.9-58.2s3.9-40.2 10.9-58.2zm328-11.6c-3.2-8.2-12.5-12.3-20.7-9.1s-12.3 12.5-9.1 20.7c7 18 10.9 37.6 10.9 58.2s-3.9 40.2-10.9 58.2c-3.2 8.2 .9 17.5 9.1 20.7s17.5-.9 20.7-9.1c8.5-21.7 13.1-45.2 13.1-69.8s-4.6-48.2-13.1-69.8z"]
};
var faBroadcastTower = faTowerBroadcast;
var faTruckPickup = {
  prefix: 'fal',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M256 80V192H485.3L389 70.1c-3-3.8-7.7-6.1-12.6-6.1H272c-8.8 0-16 7.2-16 16zM524.6 190.1l1.5 1.9H552c30.9 0 56 25.1 56 56V352h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608 576 560c0 53-43 96-96 96s-96-43-96-96H272c0 53-43 96-96 96s-96-43-96-96H64 32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V248c0-30.9 25.1-56 56-56H224V80c0-26.5 21.5-48 48-48H376.5c14.7 0 28.6 6.7 37.7 18.3L524.6 190.1zM64 352H85.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H373.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H576V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24V352zm176 32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm224 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faBlockQuote = {
  prefix: 'fal',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M16 80C7.2 80 0 87.2 0 96s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM128 416c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16V432z"]
};
var faUpLong = {
  prefix: 'fal',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", "M88 160H38.7c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L160 35.8 285.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7H232c-17.7 0-32 14.3-32 32V464c0 8.8-7.2 16-16 16H136c-8.8 0-16-7.2-16-16V192c0-17.7-14.3-32-32-32zM174 5.3C170.1 1.9 165.2 0 160 0s-10.1 1.9-14 5.3L12.9 124.5C4.7 131.8 0 142.3 0 153.3C0 174.7 17.3 192 38.7 192H56 88v32V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V224 192h32 17.3c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L174 5.3z"]
};
var faLongArrowAltUp = faUpLong;
var faStop = {
  prefix: 'fal',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faCodeMerge = {
  prefix: 'fal',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M80 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96.9 158.2C133 150.5 160 118.4 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4V353.6C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4V234.5c26.4 32.6 66.8 53.5 112 53.5h81.6c7.4 36.5 39.7 64 78.4 64c44.2 0 80-35.8 80-80s-35.8-80-80-80c-38.7 0-71 27.5-78.4 64H208c-57 0-104.1-42.6-111.1-97.8zM416 272a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM128 432a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faMoneyCheckDollarPen = {
  prefix: 'fal',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M512 96H64c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H338.2l-8 32H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c-10.9-.3-21.8 1.5-32 5.6V128c0-17.7-14.3-32-32-32zM256 304c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm16-112H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM144 144c8.8 0 16 7.2 16 16v9.6c5.9 1 19 3.5 24.1 4.9c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2 0 0c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V352c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.6c-9.4-1.7-23.5-6.6-32.4-9.6l0 0 0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6 0 0c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V160c0-8.8 7.2-16 16-16zM582.8 264c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L600.2 304c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L552.7 351.4l-40-40L406.5 417.7zM537.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L537.5 241.4z"]
};
var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
var faUpFromLine = {
  prefix: 'fal',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M190.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L318.2 196.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H256c-8.8 0-16 7.2-16 16V344c0 4.4-3.6 8-8 8H152c-4.4 0-8-3.6-8-8V224c0-8.8-7.2-16-16-16H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L190.2 64.8zM192 32c-9.5 0-18.6 3.9-25.1 10.8L42.5 174.8C35.8 182 32 191.5 32 201.3C32 222.7 49.3 240 70.7 240H112V344c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V240h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L217.1 42.8C210.6 35.9 201.5 32 192 32zM16 480H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faArrowAltFromBottom = faUpFromLine;
var faUpload = {
  prefix: 'fal',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M272 54.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H304V320H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H208v32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHurricane = {
  prefix: 'fal',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M32 208C32 118.9 98.2 45.3 184 33.6V98.8c0 16.4 12.1 29.1 26.8 32.1C291.3 147 352 218.1 352 303.4c0 89.1-66.2 162.7-152 174.4V412.6c0-16.4-12.1-29.1-26.8-32.1C92.7 364.4 32 293.3 32 208zM216 32.8c0-17.8-15.1-33.6-34.6-31.1C79.1 14.8 0 102.2 0 208C0 308.8 71.7 392.9 166.9 411.9c.5 .1 .8 .3 1 .5c.1 .1 .1 .1 .1 .1c0 0 0 0 0 0v65.9c0 17.8 15.1 33.6 34.6 31.1C304.9 496.6 384 409.3 384 303.4c0-100.8-71.7-184.9-166.9-203.9c-.5-.1-.8-.3-1-.5c-.1-.1-.1-.2-.1-.2V32.8zM240 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
};
var faGridRound2Plus = {
  prefix: 'fal',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", "M64 128a64 64 0 1 0 128 0A64 64 0 1 0 64 128zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM64 384a64 64 0 1 0 128 0A64 64 0 1 0 64 384zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V288c0-8.8 7.2-16 16-16z"]
};
var faPeoplePants = {
  prefix: 'fal',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM147.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H128V164c6-2.6 12.5-4 19.3-4zM128 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L243.3 170.3c-13.9-26-41-42.3-70.6-42.3H147.3c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM467.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H448V164c6-2.6 12.5-4 19.3-4zM448 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L563.3 170.3c-13.9-26-41-42.3-70.6-42.3H467.3c-29.5 0-56.6 16.3-70.6 42.3L337.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L416 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faMound = {
  prefix: 'fal',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M512.7 384L63.3 384 171.9 195.2C195.8 153.6 240.1 128 288 128s92.2 25.6 116.1 67.2L512.7 384zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48H512.7c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z"]
};
var faWindsock = {
  prefix: 'fal',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M16 0c8.8 0 16 7.2 16 16V128H96V86.7c0-20.1 18.3-35.2 38-31.4L486 123c15.1 2.9 26 16.1 26 31.4V261.6c0 15.3-10.9 28.5-26 31.4L134 360.7c-19.7 3.8-38-11.3-38-31.4V288H32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V272 144 16C0 7.2 7.2 0 16 0zM32 160v96H96V160H32zm96-73.3V329.3l96-18.5V105.2L128 86.7zm128 24.6V304.6L384 280V136L256 111.4zm160 30.8V273.9l64-12.3 0-107.1-64-12.3z"]
};
var faCircleHalf = {
  prefix: 'fal',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M224 34.3C115.5 49.8 32 143.2 32 256s83.5 206.2 192 221.7V34.3zM224.1 2C241.6-.2 256 14.3 256 32V480c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z"]
};
var faBrakeWarning = {
  prefix: 'fal',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M320 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm16-336c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM320 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM77.5 100.6c4.8-7.4 2.6-17.3-4.8-22.1s-17.3-2.6-22.1 4.8C18.5 133.2 0 192.4 0 256s18.5 122.8 50.5 172.7c4.8 7.4 14.7 9.6 22.1 4.8s9.6-14.7 4.8-22.1C48.7 366.6 32 313.3 32 256s16.7-110.6 45.5-155.4zm512-17.3c-4.8-7.4-14.7-9.6-22.1-4.8s-9.6 14.7-4.8 22.1C591.3 145.4 608 198.7 608 256s-16.7 110.6-45.5 155.4c-4.8 7.4-2.6 17.3 4.8 22.1s17.3 2.6 22.1-4.8C621.4 378.8 640 319.6 640 256s-18.6-122.8-50.5-172.7z"]
};
var faToiletPortable = {
  prefix: 'fal',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M32 64V96H288V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64zm0 64V448H288V336H264c-22.1 0-40-17.9-40-40V248c0-22.1 17.9-40 40-40h24V128H32zM320 64V208v32 64 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64zM264 240c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24V240H264z"]
};
var faCompactDisc = {
  prefix: 'fal',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm72 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-120 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144 64.5-144 144z"]
};
var faFileArrowDown = {
  prefix: 'fal',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4V240z"]
};
var faFileDownload = faFileArrowDown;
var faSaxophoneFire = {
  prefix: 'fal',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M151.6 81.2c9.6-.1 18.7-4.5 24.7-12.1c1.5-1.9 2.9-3.6 4.3-5.4c10.7 12.6 20.2 27.2 27.6 41.5l25.2-13-25.2 13C218.9 125.8 224 145 224 153.7c0 13.6-2.8 26.5-8 38.3h34.1c3.8-12.1 5.9-25 5.9-38.3c0-16.1-7.7-40.7-19.3-63.2c-11.8-22.8-28.5-46.8-48.3-64.9c-4.3-4-11-4.1-15.5-.4c-.2 .1-.3 .3-.5 .4c-7.7 7-14.9 15.7-21.2 23.6c-7-8.4-14.2-16.4-21.6-24.2c-7.3-7.6-14.9-15-22.8-22c-2.2-2-5-3-7.8-3c-2.9 0-5.7 1-8 3C64.4 26.7 41.9 53.7 25.9 79.6C10.2 105.2 0 132.6 0 153.7C0 167 2 179.9 5.8 192H39.9c-5.1-11.7-7.9-24.7-7.9-38.3c0-12.6 6.8-34.1 21.2-57.3C64.7 77.7 80.4 58 98.9 39.5c9.7 9.5 18.9 19.6 27.7 30.1c6.2 7.4 15.3 11.6 25 11.5zM200 192c10.6-21.7 10.2-48.4-1.8-70.6l0-.1 0 0c-1.5-3.1-3.7-7.4-7-11.7c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-16.1 18.8-11.6-14.7c-12-15.2-24.4-31.1-26.1-33.2c-3-3.8-7.6-6-12.4-6s-9.4 2.2-12.5 5.9c-11.9 14.7-21.7 27.2-28.4 38.7c-6.9 11.9-11.2 23.7-11.2 37c0 13.7 2.9 26.1 8.3 36.8H97c-1.2-.9-2.3-1.8-3.3-2.7C85.5 181.8 80 170.6 80 155.2c0-5.9 1.7-12.1 6.8-20.8c3.2-5.5 7.5-11.6 13.1-18.9l13.5 17.2 16.3 20.8 5.3 6.8 1.5 1.9 .4 .5 .1 .1 0 0 0 0 0 0 12.6-9.9L137 162.7c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l12.7-14.8c3.8 16.7-2 34.1-15 43.6H200zM521.9 64c-20.8 0-40.8 8.1-55.7 22.6L221.1 324.3c-2.3 2.3-5.4 3.5-8.7 3.5c-6.7 0-12.5-5.6-12.5-12.7c0-.9 .1-1.9 .3-2.8L212.8 256H224c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0H32l-16 0c-8.8 0-16 7.2-16 16c0 7.8 5.5 14.2 12.9 15.7L2.7 311.5C.9 321.5 0 331.7 0 341.9v7.6C0 439.2 72.8 512 162.6 512c48.8 0 94.9-21.9 125.8-59.6L522.8 165.9c3-3.7 7.6-5.9 12.4-5.9h77.5c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3L606.1 87.4c-15-15-35.4-23.4-56.6-23.4H521.9zM45.4 256H180.1l-11 49.5c-.7 3.2-1.1 6.5-1.1 9.7c0 24.4 19.8 44.7 44.5 44.7c11.6 0 22.7-4.5 31-12.5L488.5 109.5c9-8.7 20.9-13.5 33.4-13.5h27.6c12.7 0 24.9 5.1 33.9 14.1L601.4 128H535.2c-14.4 0-28 6.5-37.2 17.6L263.6 432.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 480 32 421.5 32 349.4v-7.6c0-8.3 .7-16.6 2.2-24.7L45.4 256zM120 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSaxHot = faSaxophoneFire;
var faCameraWebSlash = {
  prefix: 'fal',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", "M544 224C544 100.3 443.7 0 320 0C262.8 0 210.5 21.5 170.9 56.8L196.5 77C229.9 48.9 273 32 320 32c106 0 192 86 192 192c0 30.9-7.3 60.1-20.3 86l25.6 20.2c17-31.6 26.7-67.8 26.7-106.2zM427.4 422.3l7.4 9.7h4.8l-12.3-9.7zm-29.1-23C374.4 410.1 347.9 416 320 416c-106 0-192-86-192-192c0-12.1 1.1-24 3.3-35.5l-27.8-22C98.6 184.9 96 204.1 96 224c0 73.7 35.6 139 90.5 179.9L133 473.4c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4H488c9.1 0 17.5-5.2 21.5-13.4c1.5-3 2.3-6.3 2.4-9.5L500.4 480H416l-247.8 0 45.3-58.9C245.2 438.3 281.5 448 320 448c38.4 0 74.5-9.7 106.1-26.7l-27.8-22zM176 224c0 79.5 64.5 144 144 144c11.6 0 22.8-1.4 33.6-3.9L318 336c-51.4-.9-94.3-36.3-106.5-84.1l-35.5-28 0 .1zm256 0c0 12.1-1.9 23.7-5.4 34.6L453 279.4c7.1-17.1 11-35.8 11-55.4c0-79.5-64.5-144-144-144c-31.7 0-61 10.2-84.7 27.6l26.4 20.8c17-10.4 37-16.4 58.4-16.4c61.9 0 112 50.1 112 112zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faWebcamSlash = faCameraWebSlash;
var faFolderMedical = {
  prefix: 'fal',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM240 176c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H304V208c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V320c0-8.8-7.2-16-16-16H176V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faFolderGear = {
  prefix: 'fal',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM208 192v.7c0 1-.8 3.4-4.1 5.3c-3.2 1.8-5.5 1.4-6.5 .8l-.6-.3c-15.3-8.8-34.9-3.6-43.7 11.7l-16 27.7c-8.8 15.3-3.6 34.9 11.7 43.7l.6 .3c.9 .5 2.6 2.4 2.6 6.1s-1.6 5.6-2.6 6.1l-.6 .3c-15.3 8.8-20.5 28.4-11.7 43.7l16 27.7c8.8 15.3 28.4 20.6 43.7 11.7l.6-.3c.9-.5 3.3-1 6.5 .8c3.3 1.9 4.1 4.3 4.1 5.3v.7c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-.7c0-1 .8-3.4 4.1-5.3c3.2-1.8 5.5-1.4 6.5-.8l.6 .3c15.3 8.8 34.9 3.6 43.7-11.7l16-27.7c8.8-15.3 3.6-34.9-11.7-43.7l-.6-.3c-.9-.5-2.6-2.4-2.6-6.1s1.6-5.6 2.6-6.1l.6-.3c15.3-8.8 20.6-28.4 11.7-43.7l-16-27.7c-8.8-15.3-28.4-20.5-43.7-11.7l-.6 .3c-.9 .5-3.3 1-6.5-.8c-3.3-1.9-4.1-4.3-4.1-5.3V192c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32zm64 0v.7c0 15.1 9.4 26.8 20 33c10.7 6.2 25.5 8.3 38.5 .8l.6-.3 16 27.7-.6 .3c-13 7.5-18.6 21.4-18.6 33.8s5.5 26.3 18.6 33.8l.6 .3-16 27.7-.6-.3c-13-7.5-27.8-5.4-38.5 .8c-10.6 6.2-20 17.9-20 33v.7H240v-.7c0-15.1-9.4-26.8-20-33c-10.7-6.2-25.5-8.3-38.5-.8l-.6 .3-16-27.7 .6-.3c13-7.5 18.6-21.4 18.6-33.8s-5.5-26.3-18.6-33.8l-.6-.3 16-27.7 .6 .3c13 7.5 27.8 5.4 38.5-.8c10.6-6.2 20-17.9 20-33V192h32zm8 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFolderCog = faFolderGear;
var faHandWave = {
  prefix: 'fal',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", "M354.3 95.8c8.7-1.2 14.8-9.4 13.6-18.1l-1.2-8.5c-5-35.2-32.7-62.9-67.9-67.9L290.3 .2c-8.7-1.2-16.9 4.8-18.1 13.6s4.8 16.9 13.6 18.1l8.5 1.2c21.1 3 37.7 19.6 40.7 40.7l1.2 8.5c1.3 8.7 9.4 14.8 18.1 13.6zM13.7 368.2C5 369.4-1.1 377.5 .2 386.3l1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2c8.7 1.2 16.9-4.8 18.1-13.6s-4.8-16.9-13.6-18.1L73.8 431c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5c-1.2-8.7-9.4-14.8-18.1-13.6zM150.4 62.4c-21-10.8-47.5-7.3-65.1 10.3s-21 44.1-10.3 65.1c-8.7 2.6-16.8 7.3-23.7 14.1c-21.9 21.9-21.9 57.3 0 79.2l9.5 9.5c-7.6 2.7-14.8 7.1-20.9 13.2c-21.8 21.8-21.9 57.2-.2 79.1L162.9 457.1c34.8 35.1 82.2 54.9 131.7 54.9C397 512 480 429 480 326.6l0-13.8 0 0 0-.7 0 0L480 152c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 11L243.7 38.7c-21.9-21.9-57.3-21.9-79.2 0c-6.8 6.8-11.5 15-14.1 23.7zM108 95.3c9.4-9.4 24.6-9.4 33.9 0l8.8 8.8 .1 .1L288 241.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L187.1 95.3l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0L372.7 212.9c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-49.6c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160 0 0 0 .7 0 0 0 13.8C448 411.3 379.3 480 294.6 480c-40.9 0-80.1-16.4-109-45.4L62.6 310.3c-9.3-9.4-9.3-24.6 .1-34c9.4-9.4 24.7-9.4 34.1 0l36 36 .1 .1 42.1 42.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-42.2-42.2L105.6 240l-.1-.1L74 208.4c-9.4-9.4-9.4-24.6 0-33.9c9.3-9.3 24.4-9.4 33.8-.1L231.4 297.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-46.5-46.5-.1-.1L108 129.2c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faArrowUpArrowDown = {
  prefix: 'fal',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zm352 342.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96z"]
};
var faSortUpDown = faArrowUpArrowDown;
var faCaravan = {
  prefix: 'fal',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M416 64c70.7 0 128 57.3 128 128V384H480V168c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40V384H282.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48H416zM80 416H96c0 53 43 96 96 96s96-43 96-96h64 96 96 32l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0V192c0-88.4-71.6-160-160-160H80C35.8 32 0 67.8 0 112V336c0 44.2 35.8 80 80 80zM448 224H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h32V384H352V168c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v56zM128 160H256v64H128V160zm-32 0v64c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm96 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faShieldCat = {
  prefix: 'fal',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM171.3 132.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V272c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5L281.4 192H230.6l-59.3-59.3zM176 272V182.6l36.7 36.7c3 3 7.1 4.7 11.3 4.7h64c4.2 0 8.3-1.7 11.3-4.7L336 182.6V272c0 44.2-35.8 80-80 80s-80-35.8-80-80zm56 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faMessageSlash = {
  prefix: 'fal',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M378.8 384h-5.5c-6.9 0-13.7 2.2-19.2 6.4L256 464V416c0-17.7-14.3-32-32-32H128c-17.7 0-32-14.3-32-32V160.7L64 135.4V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h46l-40.5-32zM128 0c-8.3 0-16.1 1.6-23.4 4.4L139.6 32H512c17.7 0 32 14.3 32 32V351.3l28.3 22.3c2.4-6.8 3.7-14 3.7-21.6V64c0-35.3-28.7-64-64-64H128zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCommentAltSlash = faMessageSlash;
var faBolt = {
  prefix: 'fal',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", "M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"]
};
var faZap = faBolt;
var faTrashCanCheck = {
  prefix: 'fal',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zM331.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 329.4 308.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faGlassWater = {
  prefix: 'fal',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7l-8.2 97.7-38 19c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3l-38.1-19L32.1 40.7zm11.4 135L64.1 186c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l20.5-10.3-23.2 275C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3L43.5 175.6zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"]
};
var faOilWell = {
  prefix: 'fal',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M497.4 69.6c-6.9-25.6-33.2-40.8-58.8-33.9l-15.5 4.1L489.4 287l15.5-4.1c25.6-6.9 40.8-33.2 33.9-58.8L497.4 69.6zM430.4 4.7c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6L429.2 185.8 96 272.2V480h36.5L200 277.3l36.9-9.6L208.9 352H335.1L301.5 251l31-8 79 237.1H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V176c0-8.8 7.2-16 16-16s16 7.2 16 16v63.2L223.8 206l33-99.1C259 100.4 265.1 96 272 96s13 4.4 15.2 10.9L312.5 183l108.4-28.1L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM281.5 191.1L272 162.6l-11.3 33.9 20.8-5.4zM377.8 480l-32-96H198.2l-32 96H377.8z"]
};
var faPersonSimple = {
  prefix: 'fal',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44H105.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"]
};
var faVault = {
  prefix: 'fal',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", "M64 32C46.3 32 32 46.3 32 64V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c-35.3 0-64-28.7-64-64V64zM352 240A128 128 0 1 0 96 240a128 128 0 1 0 256 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0c0 20.9-13.4 38.7-32 45.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48z"]
};
var faMars = {
  prefix: 'fal',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L288.6 168.7C258.1 143.3 218.8 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L416 86.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H304zM32 304a144 144 0 1 1 288 0A144 144 0 1 1 32 304z"]
};
var faToilet = {
  prefix: 'fal',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M0 16C0 7.2 7.2 0 16 0H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM64 196.8c5-1.6 10.2-3.2 15.4-4.6C121 181.2 174.5 176 224 176s103 5.2 144.6 16.3c5.3 1.4 10.4 2.9 15.4 4.6V64h32V210.6c2.1 1.2 4.2 2.5 6.1 3.8c13.9 9.4 25.9 23 25.9 41.6c0 69.8-35.8 118.1-81 148.5l15.2 51c1.2 4.1 1.8 8.3 1.8 12.5c0 24.3-19.7 43.9-43.9 43.9H107.9C83.7 512 64 492.3 64 468.1c0-4.2 .6-8.5 1.8-12.5l15.2-51C35.8 374.1 0 325.8 0 256c0-18.5 12-32.2 25.9-41.6c1.9-1.3 4-2.6 6.1-3.8V64H64V196.8zM40.3 305.7c11.3 31.6 33.2 55.4 59.7 72.9C139.4 404.7 188.2 416 224 416s84.6-11.3 124.1-37.3c26.5-17.5 48.4-41.3 59.7-72.9c-11.5 5.6-24.9 10.2-39.2 14C327 330.8 273.5 336 224 336s-103-5.2-144.6-16.3c-14.3-3.8-27.6-8.4-39.2-14zM416 256c0-3.1-1.8-8.3-11.8-15c-9.8-6.6-24.7-12.7-43.9-17.8C322.2 213.1 271.7 208 224 208s-98.2 5.1-136.3 15.2c-19.2 5.1-34.1 11.2-43.9 17.8C33.8 247.7 32 252.9 32 256s1.8 8.3 11.8 15c9.8 6.6 24.7 12.7 43.9 17.8C125.8 298.9 176.3 304 224 304s98.2-5.1 136.3-15.2c19.2-5.1 34.1-11.2 43.9-17.8c9.9-6.7 11.8-11.9 11.8-15zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM351.5 464.7l-13.1-43.8C299.6 439.7 257.3 448 224 448s-75.6-8.3-114.4-27.2L96.5 464.7c-.3 1.1-.5 2.3-.5 3.4c0 6.6 5.3 11.9 11.9 11.9H340.1c6.6 0 11.9-5.3 11.9-11.9c0-1.2-.2-2.3-.5-3.4z"]
};
var faPlaneCircleXmark = {
  prefix: 'fal',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9l0 37.1-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30c2.8 0 5.6-.4 8.3-1.2l0 0L256 480.6l105.7 30.2 0 0c2.7 .8 5.5 1.2 8.2 1.2c6.5 0 12.5-2 17.4-5.5c-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8l0-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8V290.6c0-5.7 3.1-11 8.1-13.9l159.9-91.4c5-2.8 8.1-8.2 8.1-13.9V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
var faYenSign = {
  prefix: 'fal',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M29 38.7C23.8 31.5 13.8 29.9 6.7 35S-2.1 50.2 3 57.4L123 224H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v64H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V256h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H197L317 57.4c5.2-7.2 3.5-17.2-3.6-22.3s-17.2-3.5-22.3 3.6l-131 182L29 38.7z"]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faGearCode = {
  prefix: 'fal',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M225.7 34c-1.1 1-1.9 2.3-2.4 3.8L209.6 85.5c-3.5 12.1-12.2 21.1-22.5 26.1c-7.6 3.6-14.8 7.8-21.7 12.5c-9.4 6.5-21.7 9.5-33.9 6.5l-48.2-12c-1.5-.4-3-.3-4.4 .2c-5.4 6.9-10.4 14.2-15 21.8l-4.2 7.3c-4.2 7.5-7.9 15.3-11.2 23.4c.3 1.5 1 2.9 2.1 4L85.2 211c8.7 9 12.2 21.1 11.3 32.5c-.3 4.1-.5 8.3-.5 12.5s.2 8.4 .5 12.5c.9 11.4-2.6 23.5-11.3 32.5L50.7 336.8c-1.1 1.1-1.8 2.5-2.1 4c3.3 8 7 15.8 11.2 23.4l4.2 7.3c4.6 7.6 9.6 14.8 15 21.8c1.4 .5 2.9 .5 4.4 .2l48.2-12c12.2-3 24.4 0 33.9 6.5c6.9 4.7 14.1 8.9 21.7 12.5c10.3 4.9 19.1 14 22.5 26.1l13.7 47.7c.4 1.5 1.3 2.8 2.4 3.8c9.9 1.3 20 2 30.3 2s20.4-.7 30.3-2c1.1-1 1.9-2.3 2.4-3.8l13.7-47.7c3.5-12.1 12.2-21.1 22.5-26.1c7.6-3.6 14.8-7.8 21.7-12.5c9.4-6.5 21.7-9.5 33.9-6.5l48.2 12c1.5 .4 3 .3 4.4-.2c5.4-6.9 10.4-14.2 14.9-21.8l4.2-7.3c4.2-7.5 7.9-15.3 11.2-23.4c-.3-1.5-1-2.9-2.1-4L426.8 301c-8.7-9-12.2-21.1-11.3-32.5c.3-4.1 .5-8.3 .5-12.5s-.2-8.4-.5-12.5c-.9-11.4 2.6-23.5 11.3-32.5l34.5-35.7c1.1-1.1 1.8-2.5 2.1-4c-3.3-8-7-15.8-11.2-23.3l-4.3-7.4c-4.6-7.6-9.5-14.8-14.9-21.8c-1.4-.5-2.9-.5-4.4-.2l-48.2 12c-12.2 3-24.4 0-33.9-6.5c-6.9-4.7-14.1-8.9-21.7-12.5c-10.3-4.9-19.1-14-22.5-26.1L288.7 37.8c-.4-1.5-1.3-2.8-2.4-3.8c-9.9-1.3-20-2-30.3-2s-20.4 .7-30.3 2zM217.6 2.9C230.1 1 243 0 256 0s25.9 1 38.4 2.9c1.7 .3 3.4 .8 5 1.6c9.5 4.9 16.9 13.6 20 24.5l13.7 47.7c.6 2.2 2.5 4.5 5.6 6c9.1 4.3 17.8 9.4 26 15c2.8 1.9 5.8 2.4 8 1.8l48.2-12c10.9-2.7 22.1-.7 31.1 5.1c1.5 .9 2.8 2.1 3.9 3.5c7.1 8.9 13.6 18.2 19.5 28l.1 .3L480 132l.1 .3c5.4 9.7 10.2 19.9 14.3 30.4c.6 1.6 1 3.3 1.1 5c.5 10.8-3.3 21.6-11.2 29.8l-34.5 35.7c-1.6 1.7-2.7 4.4-2.4 7.8c.4 5 .6 10 .6 15s-.2 10.1-.6 15c-.3 3.4 .8 6.2 2.4 7.8l34.5 35.7c7.9 8.2 11.7 19 11.2 29.8c-.1 1.7-.5 3.4-1.1 5c-4.1 10.5-8.9 20.6-14.3 30.4l-.1 .3-4.4 7.6-.1 .3c-5.9 9.8-12.4 19.2-19.5 28c-1.1 1.4-2.4 2.6-3.9 3.5c-9 5.7-20.2 7.8-31.1 5.1l-48.2-12c-2.2-.6-5.2-.1-8 1.8c-8.2 5.7-16.9 10.7-26 15c-3.1 1.5-4.9 3.8-5.6 6L319.4 483c-3.1 10.8-10.5 19.5-20 24.5c-1.6 .8-3.2 1.4-5 1.6C281.9 511 269 512 256 512s-25.9-1-38.4-2.9c-1.7-.3-3.4-.8-5-1.6c-9.5-4.9-16.9-13.6-20-24.5l-13.7-47.7c-.6-2.2-2.5-4.5-5.6-6c-9.1-4.3-17.8-9.4-26-15c-2.8-1.9-5.8-2.4-8-1.8l-48.2 12c-10.9 2.7-22.1 .7-31.1-5.1c-1.5-.9-2.8-2.1-3.9-3.5C49 407 42.4 397.6 36.5 387.8l-.1-.3L32 380l-.1-.3c-5.4-9.8-10.2-19.9-14.3-30.4c-.6-1.6-1-3.3-1.1-5c-.5-10.8 3.3-21.6 11.2-29.8l34.5-35.7c1.6-1.7 2.7-4.4 2.4-7.8c-.4-5-.6-10-.6-15s.2-10.1 .6-15c.3-3.4-.8-6.2-2.4-7.8L27.7 197.4c-7.9-8.2-11.7-19-11.2-29.8c.1-1.7 .5-3.4 1.1-5c4.1-10.5 8.9-20.6 14.3-30.4l.1-.3 4.4-7.6 .1-.3C42.4 114.3 49 105 56.1 96.1c1.1-1.4 2.4-2.6 3.9-3.5c9-5.7 20.2-7.8 31.1-5.1l48.2 12c2.2 .6 5.2 .1 8-1.8c8.2-5.7 16.9-10.7 26-15c3.1-1.5 4.9-3.8 5.6-6L192.6 29c3.1-10.8 10.5-19.5 20-24.5c1.6-.8 3.2-1.4 5-1.6zm70.2 159.8l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM187.3 227.3L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faNotes = {
  prefix: 'fal',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M128 96c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V256H368c-26.5 0-48 21.5-48 48v80H160c-17.7 0-32-14.3-32-32V96zM446.2 288c-1.6 4.5-4.2 8.7-7.6 12.1l-74.5 74.5c-3.4 3.4-7.6 6-12.1 7.6V304c0-8.8 7.2-16 16-16h78.2zM96 96V352c0 35.3 28.7 64 64 64H341.5c17 0 33.3-6.7 45.3-18.7l74.5-74.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM320 496c0-8.8-7.2-16-16-16H128c-53 0-96-43-96-96l0-240c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H304c8.8 0 16-7.2 16-16z"]
};
var faRubleSign = {
  prefix: 'fal',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", "M104.7 32C82.2 32 64 50.2 64 72.7V288H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H104.7zM96 288V72.7c0-4.8 3.9-8.7 8.7-8.7H240c61.9 0 112 50.1 112 112s-50.1 112-112 112H96z"]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faTrashUndo = {
  prefix: 'fal',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6zM219.9 189.3c-5.9-6.6-16-7.1-22.6-1.2l-80 72c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l80 72c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6l-49-44.1H240c26.5 0 48 21.5 48 48v40c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-44.2-35.8-80-80-80H169.7l49-44.1c6.6-5.9 7.1-16 1.2-22.6z"]
};
var faTrashArrowTurnLeft = faTrashUndo;
var faChampagneGlass = {
  prefix: 'fal',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", "M74.5 160h171l7.3 53.6C260.5 269.9 216.8 320 160 320s-100.5-50.1-92.8-106.4L74.5 160zm4.4-32L91.9 32l136.1 0 13.1 96H78.8zM60.2 27.7L35.5 209.3C25.9 279.4 75.8 342.4 144 351V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V351c68.2-8.6 118.1-71.6 108.5-141.7L259.8 27.7C257.6 11.8 244.1 0 228.1 0H91.9c-16 0-29.5 11.8-31.7 27.7z"]
};
var faGlassChampagne = faChampagneGlass;
var faObjectsAlignCenterHorizontal = {
  prefix: 'fal',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", "M448 176c0 8.8-7.2 16-16 16l-176 0L80 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l176 0 0 0 0 0 176 0c8.8 0 16 7.2 16 16l0 64zM272 224l160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L272 64l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0 0 64-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0 0-64zm-16 96l112 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-112 0-112 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l112 0z"]
};
var faSun = {
  prefix: 'fal',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM265.1 97.7l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8l-17.4 94.5-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8L43.2 344.1l54.5-79.1c3.8-5.5 3.8-12.7 0-18.2L43.2 167.8l94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5 79.1 54.5c5.5 3.8 12.7 3.8 18.2 0zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faTrashCanSlash = {
  prefix: 'fal',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", "M512 96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 480 432.9L407 22.6C398.2 8.5 382.8 0 366.3 0H273.7C257.2 0 241.8 8.5 233 22.6L207.1 64h-27l40.5 32H480V300.8L512 326V96zM472.4 457.9C463.9 471.2 449 480 432 480H208c-26.5 0-48-21.5-48-48V211.2L128 186V432c0 44.2 35.8 80 80 80H432c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9zM208 400c0 8.8 7.2 16 16 16s16-7.2 16-16V274.4l-32-25.3V400zm96 0c0 8.8 7.2 16 16 16s16-7.2 16-16V350.2l-32-25.3V400zm96-162.4l32 25.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v61.6zM260.2 39.5c2.9-4.7 8.1-7.5 13.6-7.5h92.5c5.5 0 10.6 2.8 13.6 7.5L395.1 64H244.9l15.3-24.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTrashAltSlash = faTrashCanSlash;
var faScreenUsers = {
  prefix: 'fal',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M544 32H96C78.3 32 64 46.3 64 64V229.5c-11.9 4.2-22.8 10.7-32 19V64C32 28.7 60.7 0 96 0H544c35.3 0 64 28.7 64 64V248.4c-9.2-8.3-20.1-14.8-32-19V64c0-17.7-14.3-32-32-32zM96 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm256-32c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-17.7-14.3-32-32-32H288zm192 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32z"]
};
var faUsersClass = faScreenUsers;
var faGuitar = {
  prefix: 'fal',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M445.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 61.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5L406.6 72l39-39zM376.4 60.5l-15 67.5-35.5 35.5c-51.7-42.9-120-48-158.3-9.6c-12 12-19.7 26.8-23.4 43.2c-4.1 18.1-20.8 33.5-39.4 34.5C76.9 233 51 243.2 31.4 262.8C-17.4 311.7-8.3 400 51.8 460.2s148.5 69.3 197.4 20.4c19.6-19.6 29.8-45.5 31.2-73.4c.9-18.5 16.4-35.3 34.5-39.4c16.4-3.7 31.2-11.4 43.2-23.4c38.3-38.3 33.3-106.6-9.6-158.3L384 150.6l67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3L380.7 52.7c-2.2 2.2-3.6 4.9-4.3 7.8zM303.1 186.2l-74.4 74.4c-6.3-3-13.3-4.7-20.7-4.7c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l74.4-74.4c34.5 42.9 31.7 91 9.7 113c-7.3 7.3-16.6 12.3-27.6 14.8c-30.7 6.9-57.7 34.7-59.4 69c-1.1 21-8.6 39.1-21.9 52.4c-32.2 32.2-99.9 31.8-152.1-20.4S21.8 317.6 54 285.4c13.3-13.3 31.4-20.9 52.4-21.9c34.3-1.7 62.1-28.7 69-59.4c2.5-11 7.5-20.3 14.8-27.6c22-22 70.1-24.8 113 9.7zM208 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSquareArrowLeft = {
  prefix: 'fal',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm36.7-235.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L150.6 240 336 240c8.8 0 16 7.2 16 16s-7.2 16-16 16l-185.4 0 68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faArrowSquareLeft = faSquareArrowLeft;
var faSquare8 = {
  prefix: 'fal',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm172 96H212c-37.6 0-68 30.4-68 68c0 20.2 8.8 38.4 22.9 50.9C148.1 260.7 136 282.9 136 308c0 42 34 76 76 76h24c42 0 76-34 76-76c0-25.1-12.1-47.3-30.9-61.1c14-12.5 22.9-30.6 22.9-50.9c0-37.6-30.4-68-68-68zM212 232c-19.9 0-36-16.1-36-36s16.1-36 36-36h24c19.9 0 36 16.1 36 36s-16.1 36-36 36H212s0 0 0 0zm0 32s0 0 0 0h24c24.3 0 44 19.7 44 44s-19.7 44-44 44H212c-24.3 0-44-19.7-44-44s19.7-44 44-44z"]
};
var faFaceSmileHearts = {
  prefix: 'fal',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M422.7 21.4C391.3 7.7 356.5 0 320 0C178.6 0 64 114.6 64 256c0 11.1 .7 22 2.1 32.7c10.4 1.4 20.5 4.6 30 9.7c1.2-.6 2.4-1.3 3.6-1.8C97.3 283.4 96 269.9 96 256C96 132.3 196.3 32 320 32c34.4 0 66.9 7.7 96 21.6c.2-10.9 2.4-21.9 6.7-32.1zM534.5 191.3c6.2 20.5 9.5 42.2 9.5 64.7c0 24.2-3.8 47.6-11 69.4c3.8 1.4 7.4 3.1 11 5c7.4-4 15.3-6.8 23.4-8.5c5.6-21 8.6-43.1 8.6-65.9c0-23.6-3.2-46.4-9.1-68c-10.4 3.8-21.5 4.9-32.3 3.3zM428.5 452c-32.1 17.8-69.1 28-108.5 28c-46.7 0-90.1-14.3-126-38.7l-22.9 23c41.9 30 93.3 47.7 148.9 47.7c47.3 0 91.6-12.8 129.6-35.2l-8.3-8.3c-5-5.1-9.3-10.6-12.9-16.5zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-69.7 90.3c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm159.3-90.3c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM486.7 38.7c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0L486.7 71.4c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0c-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 94c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0L544 18.6l-2.4-2.4zm-448 320c-21.4-21.6-56.2-21.6-77.6 0C-5.3 357.7-5.3 392.5 16 414l55.5 55.8c13.5 13.6 35.5 13.6 49 0L176 414c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0L96 338.6l-2.4-2.4zM38.7 358.7c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7L97.9 447.2c-1 1-2.6 1-3.6 0L38.7 391.4c-9-9-9-23.7 0-32.7zm448 32c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0c9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0l-55.5-55.8c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0c-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 446c21.4-21.5 21.4-56.3 0-77.8c-21.4-21.6-56.2-21.6-77.6 0l-2.3 2.3-2.4-2.4z"]
};
var faBracketsSquare = {
  prefix: 'fal',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M48 32C21.5 32 0 53.5 0 80V432c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm352 0H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
};
var faBrackets = faBracketsSquare;
var faLaptopArrowDown = {
  prefix: 'fal',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M128 32H272V64H128c-17.7 0-32 14.3-32 32V352H64V96c0-35.3 28.7-64 64-64zM512 64H368V32H512c35.3 0 64 28.7 64 64V352H544V96c0-17.7-14.3-32-32-32zM76.8 448H563.2c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM336 48V265.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 265.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHockeyStickPuck = {
  prefix: 'fal',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6H56c-30.9 0-56-25.1-56-56V376c0-30.9 25.1-56 56-56H320.9L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352H128V480h90.8c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H96V352H56zm376 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V448c0-8.8-7.2-16-16-16H432zm-48 16c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v16c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V448z"]
};
var faHouseTree = {
  prefix: 'fal',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M404.1 37.1c6.4-7.1 17.4-7.1 23.8 0L538.5 160H480c-6.2 0-11.8 3.6-14.5 9.1s-1.8 12.2 2.1 17L575.8 318.6c.1 .2 .2 .3 .2 .5c0 .5-.4 .9-.9 .9H496c-6.3 0-12.1 3.7-14.6 9.5s-1.4 12.6 2.8 17.2L606 480H414.4c-2.4 11.8-7.4 22.7-14.4 32H609.6c16.8 0 30.4-13.6 30.4-30.4c0-7.6-2.8-14.9-8-20.5L532.3 352h42.8c18.1 0 32.9-14.7 32.9-32.9c0-7.6-2.6-14.9-7.4-20.8L513.7 192h34.7c15.2 0 27.6-12.3 27.6-27.6c0-6.8-2.5-13.4-7.1-18.4L451.7 15.7c-19.1-21.2-52.3-21.2-71.4 0l-95.4 106 23.6 21.6L404.1 37.1zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V284.2zM0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2V448zM224 288v64H160V288h64zm-64-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H160z"]
};
var faSignalFair = {
  prefix: 'fal',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", "M208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"]
};
var faSignal2 = faSignalFair;
var faFaceLaughWink = {
  prefix: 'fal',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288H385.5c14.2 0 25.4 12.3 21.8 26c-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faLaughWink = faFaceLaughWink;
var faCircleDollar = {
  prefix: 'fal',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 120v23c13.5 1 26.6 4.6 39.6 8.3c1.5 .4 3.1 .9 4.6 1.3c8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2c-2.4-.7-4.8-1.4-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5c-19.1-2.8-36.6-.4-49.3 5.1c-12.9 5.6-18.6 13.1-19.8 19.5c-1.8 9.8 2.1 16.5 10.2 21.7c10.6 6.8 26.5 11.3 45.8 16.8l.3 .1c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9c-8.1-1.3-21.8-5.2-32.4-8.4c-6.9-2.1-13.8-4.3-20.7-6.5c-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3c11.2 3.4 22.7 6.6 28.1 7.4c19.8 2.9 36.5 1.3 48-3.4c11.2-4.5 16.8-11.3 18.3-19.7c1.9-10.5-1.5-18.4-10.2-24.4c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.8-20.7 20-35.1 38.6-43.1c7.4-3.2 15.6-5.6 24.3-7.1V120c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDollarCircle = faCircleDollar;
var faUsdCircle = faCircleDollar;
var faHorseHead = {
  prefix: 'fal',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", "M404 40.2c13.7-4.8 28 5.4 28 19.9c0 7-3.5 13.6-9.4 17.5l-31.5 21c-5.3 3.5-8 9.8-6.9 16s5.7 11.3 11.9 12.8l7 1.8c32.1 8 59.4 28.9 75.6 57.8l54.4 97.2c13.9 24.9 10.6 55.9-8.4 77.2c-12.7 14.3-30.9 22.5-50.1 22.5H467c-22.2 0-43.2-10.3-56.8-27.8l-26-33.5c-7.4-9.5-21.1-11.2-30.6-3.8c-31.5 24.5-76.6 20.7-103.5-8.7l-30.3-33c-6-6.5-16.1-7-22.6-1s-7 16.1-1 22.6l30.3 33c22.3 24.3 53.2 36.3 84 35.2c.2 .6 .5 1.2 .8 1.7l35.9 66.4c3.1 5.8 4.8 12.3 4.8 18.9c0 14.3-11.6 25.9-25.9 25.9H128c-17.7 0-32-14.3-32-32V318c0-102.2 64.7-193.1 161.2-226.7L404 40.2zM375.4 420l-32-59.3c7.4-2.7 14.7-6.2 21.6-10.6l20 25.8c19.7 25.3 50 40.2 82.1 40.2h7.7c28.3 0 55.2-12.1 74-33.2c28-31.5 33-77.3 12.4-114.1l-54.4-97.2c-16-28.7-40.8-51.1-70.4-64.4l4.1-2.7C455.1 94.5 464 77.9 464 60.2C464 23.6 428-2 393.5 10L246.6 61.1C137.3 99.1 64 202.2 64 318V448c0 35.3 28.7 64 64 64H326.1c32 0 57.9-25.9 57.9-57.9c0-11.9-3-23.7-8.6-34.2zM400 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsRepeat = {
  prefix: 'fal',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M15.2 272C6.4 271.5-.4 264 0 255.2l.4-8C5.1 153.5 82.4 80 176.2 80H390.6L333.2 27.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L390.6 112H176.2c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zm481.6-32c8.8 .4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2H121.4l57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6L121.4 400H335.8c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2z"]
};
var faRepeatAlt = faArrowsRepeat;
var faBoreHole = {
  prefix: 'fal',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M256 0c-8.8 0-16 7.2-16 16V258c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V16c0-8.8-7.2-16-16-16zm32 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM80 160h48V320c0 70.7 57.3 128 128 128s128-57.3 128-128V160h48c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zm80 0c0-17.7-14.3-32-32-32H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V208c0-44.2-35.8-80-80-80H384c-17.7 0-32 14.3-32 32V320c0 53-43 96-96 96s-96-43-96-96V160z"]
};
var faIndustry = {
  prefix: 'fal',
  iconName: 'industry',
  icon: [576, 512, [], "f275", "M80 64c-8.8 0-16 7.2-16 16V304v48 64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V320 304 158.9c0-6.5-7.4-10.3-12.7-6.5l-138 99.3c-4.9 3.5-11.3 4-16.6 1.3s-8.7-8.2-8.7-14.2V156.8c0-6.4-7.1-10.2-12.4-6.7L184.9 242.6c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V80c0-8.8-7.2-16-16-16H80zM32 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V199.4l113.8-75.9c26.6-17.7 62.2 1.3 62.2 33.3v50.6l112.6-81.1c26.5-19.1 63.4-.1 63.4 32.5V304v16 96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V352 304 80z"]
};
var faImagePolaroid = {
  prefix: 'fal',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M416 384v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384H416zM105.4 352H32v-9.4l96-96L169.4 288l-60.7 60.7-3.3 3.3zm45.3 0l52.7-52.7L288 214.6l128 128V352H150.6zM416 297.4L310.6 192c-12.5-12.5-32.8-12.5-45.3 0L192 265.4 150.6 224c-12.5-12.5-32.8-12.5-45.3 0L32 297.4V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V297.4zM448 336V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V336s0 0 0 0v16 16 16 32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384 368 352 336s0 0 0 0zM128 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faWaveTriangle = {
  prefix: 'fal',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", "M176.1 32c5.2 0 10.1 2.6 13 6.9l275 397.3L611 230.7c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-160 224c-3 4.2-7.9 6.7-13.1 6.7s-10.1-2.6-13-6.9L175.8 75.8 29 281.3c-5.1 7.2-15.1 8.9-22.3 3.7s-8.9-15.1-3.7-22.3l160-224c3-4.2 7.9-6.7 13.1-6.7z"]
};
var faPersonRunningFast = {
  prefix: 'fal',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", "M352 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 320 56a56 56 0 1 0 112 0zM275.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L149.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L249.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L320.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L394 253.2c5.9 20.6 24.7 34.8 46.2 34.8H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H440.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L314.3 302.4 286.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1L197.3 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm-16 80c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faCircleDown = {
  prefix: 'fal',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm0-112c-9.2 0-18-3.5-24.7-9.7l-91-84c-7.8-7.2-12.3-17.4-12.3-28.1c0-21.1 17.1-38.3 38.3-38.3H192V160c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v80h25.7c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm-3-33.2c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.9 2-4.6c0-3.5-2.8-6.3-6.3-6.3H304c-8.8 0-16-7.2-16-16V160c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16H166.3c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84z"]
};
var faArrowAltCircleDown = faCircleDown;
var faGrill = {
  prefix: 'fal',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M408 64c4.4 0 8 3.6 8 8V96c0 106-86 192-192 192S32 202 32 96V72c0-4.4 3.6-8 8-8H408zM40 32C17.9 32 0 49.9 0 72V96c0 92.5 56 171.9 136 206.1l-23.7 52c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64H328.6l24.8 54.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L312 302.1C392 267.9 448 188.5 448 96V72c0-22.1-17.9-40-40-40H40zM140.4 369.9l26.1-57.3c18.4 4.9 37.7 7.5 57.6 7.5s39.2-2.6 57.6-7.5L314.1 384H151.4c-3-5.2-6.8-10-11.1-14.1zM96 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faArrowsTurnToDots = {
  prefix: 'fal',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", "M260.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L230.6 112 432 112c44.2 0 80 35.8 80 80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-26.5-21.5-48-48-48l-201.4 0 52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6l80-80zm-9.4 256l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 400 80 400c-26.5 0-48 21.5-48 48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448c0-44.2 35.8-80 80-80l201.4 0-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM448 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM32 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0A64 64 0 1 1 0 128a64 64 0 1 1 128 0z"]
};
var faChartMixed = {
  prefix: 'fal',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", "M507.8 37.2c5.9 6.5 5.5 16.7-1.1 22.6l-176 160c-6.3 5.7-16 5.5-22.1-.5L190.4 101 25.4 220.9c-7.1 5.2-17.2 3.6-22.4-3.5s-3.6-17.2 3.5-22.4l176-128c6.4-4.6 15.2-3.9 20.7 1.6L320.5 185.9 485.2 36.2c6.5-5.9 16.7-5.5 22.6 1.1zM80 432V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16zM64 320c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm144-48c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V272zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48V432c0 26.5-21.5 48-48 48s-48-21.5-48-48V272zM336 432V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16zM320 288c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48V336c0-26.5 21.5-48 48-48zm144-16c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V272zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48V432c0 26.5-21.5 48-48 48s-48-21.5-48-48V272z"]
};
var faAnalytics = faChartMixed;
var faFlorinSign = {
  prefix: 'fal',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M322.4 32c-32.1 0-61.2 19.2-73.7 48.8L188.2 224H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H174.6L105.8 418.7C98.3 436.5 80.9 448 61.6 448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H61.6c32.1 0 61.2-19.2 73.7-48.8L209.4 256H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.9L278.2 93.3C285.7 75.5 303.1 64 322.4 64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H322.4z"]
};
var faArrowDownShortWide = {
  prefix: 'fal',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faLessThan = {
  prefix: 'fal',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", "M382.3 72.8c4 7.9 .7 17.5-7.2 21.5L51.8 256 375.2 417.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-352-176C3.4 267.6 0 262.1 0 256s3.4-11.6 8.8-14.3l352-176c7.9-4 17.5-.7 21.5 7.2z"]
};
var faDisplayCode = {
  prefix: 'fal',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", "M512 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 416H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H373.6l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64h84.9l10.7 64H234.9zm16.4-324.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L377.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faDesktopCode = faDisplayCode;
var faFaceDrooling = {
  prefix: 'fal',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM352 370.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V344.2c4.6-4.7 8.7-9.5 12.5-14.2c5.5-6.9 4.4-17-2.5-22.5s-17-4.4-22.5 2.5c-22.8 28.5-61.3 58-115.5 58s-92.7-29.5-115.5-58c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c26.7 33.4 73.5 70 140.5 70c11.2 0 21.9-1 32-2.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V387.8c11.7-4.7 22.3-10.4 32-16.9zM158.6 189.6c8.2-7.8 19.1-13.6 33.4-13.6c8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.1 0-42.5 10.2-55.4 22.4c-12.6 12-20.4 26.3-23.8 36.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1c1.9-5.8 7-15.4 15.4-23.5zm210.2 23.5c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2c-3.4-10.2-11.1-24.6-23.8-36.5C362.5 154.2 344.1 144 320 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c14.3 0 25.2 5.8 33.4 13.6c8.4 8 13.5 17.7 15.4 23.5z"]
};
var faOilTemperature = {
  prefix: 'fal',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", "M272 32c0-17.7 14.3-32 32-32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304V96h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v97.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V112 32zm16 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM133.8 314.8c13.5 9.2 29.7 17.5 46.6 20.2c3.4 11.9 8.8 23 15.7 32.9c-1.3 .1-2.7 .1-4 .1c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 368.1 0 360 0 350.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9zM384 368c-1.3 0-2.7 0-4-.1c6.9-9.9 12.2-21 15.7-32.9c16.8-2.8 33.1-11.1 46.5-20.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 353.9 414.3 368 384 368zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"]
};
var faOilTemp = faOilTemperature;
var faSquareQuestion = {
  prefix: 'fal',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136.7 73.8c6.5-24.6 28.7-41.8 54.2-41.8H248c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H190.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faQuestionSquare = faSquareQuestion;
var faAirConditioner = {
  prefix: 'fal',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M64 32C46.3 32 32 46.3 32 64V192c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 64H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 288V432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-29.6 16.1-55.5 40-69.3c7.6-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48V288h32zm64 112V288h32V400c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.7-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8c23.9 13.8 40 39.7 40 69.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
var faAngleDown = {
  prefix: 'fal',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M212.7 331.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4 75.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z"]
};
var faMountains = {
  prefix: 'fal',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M480 424.1c0 13.2-10.7 23.9-23.9 23.9H55.9C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7L252.4 66c.8-1.3 2.2-2 3.6-2s2.9 .8 3.6 2L476.3 411.4c2.4 3.8 3.7 8.2 3.7 12.7zm-480 0C0 455 25 480 55.9 480H456.1 578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1zM431.7 280L480 200.9 603.7 403.7c2.8 4.6 4.3 9.8 4.3 15.2c0 16.1-13 29.1-29.1 29.1H506.6c3.4-7.3 5.4-15.4 5.4-23.9c0-10.5-3-20.8-8.6-29.7L431.7 280z"]
};
var faOmega = {
  prefix: 'fal',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 64C118 64 32 150 32 256c0 69.5 36.9 130.4 92.3 164.1c9.4 5.7 15.9 16.1 15.9 27.9c0 17.7-14.3 32-32 32H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h92.2l0 0c0 0 0 0 0-.1c-.1-.1-.2-.3-.5-.5C43.1 408.2 0 337.1 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 81.1-43.1 152.1-107.6 191.4c-.3 .2-.4 .3-.5 .5c0 0 0 .1 0 .1l0 0H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H339.8c-17.7 0-32-14.3-32-32c0-11.8 6.5-22.2 15.9-27.9C379.1 386.4 416 325.5 416 256c0-106-86-192-192-192z"]
};
var faCarTunnel = {
  prefix: 'fal',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 32C132.3 32 32 132.3 32 256V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256C0 114.6 114.6 0 256 0S512 114.6 512 256V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256C480 132.3 379.7 32 256 32zM174.7 266.7l-19 54.3c4-.7 8.1-1 12.2-1H344c4.2 0 8.3 .4 12.2 1l-19-54.3C335 260.3 329 256 322.2 256H189.8c-6.8 0-12.9 4.3-15.1 10.7zm-61.2 78.2l31-88.7c6.7-19.3 24.9-32.2 45.3-32.2H322.2c20.4 0 38.6 12.9 45.3 32.2l31 88.7C409.4 357.5 416 374 416 392V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V392c0-18 6.6-34.5 17.5-47.1zM128 448H384V392c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40v56zm32-48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPersonDollyEmpty = {
  prefix: 'fal',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM0 340.3c.5 .4 1.1 .9 1.6 1.3L32 365.5 32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 340.3zM32 204v74.9c0 5.3 2.7 10.3 7.1 13.3L80 319.4V180.2c-6.2-2.7-13-4.2-20-4.2c-15.5 0-28 12.5-28 28zm117.8 69.3L112 214.5V340.8L139.4 359c7.1 4.7 12 12 13.6 20.3l22.7 113.5c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6L121.6 385.6 21.4 318.8C8 309.9 0 294.9 0 278.9V204c0-33.1 26.9-60 60-60c27.9 0 53.9 14.2 69 37.6L176.7 256h44l-20.3-84.2c-2.1-8.6 3.2-17.2 11.8-19.3s17.2 3.2 19.3 11.8l53.1 219.8c1.1-.1 2.2-.1 3.4-.1c25.7 0 47.9 15.1 58 37l146.1-36.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-148 37c-2.3 33.2-30 59.5-63.8 59.5c-35.3 0-64-28.7-64-64c0-22.9 12-42.9 30-54.3L228.5 288H176.7c-10.9 0-21-5.5-26.9-14.7zM288 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPanFood = {
  prefix: 'fal',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M522.4 352c4.5-9.4 8.3-19.3 11.5-29.4c.3-.9 .5-1.7 .8-2.6c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64c-3.1-10.6-7-20.8-11.6-30.7l-.6-1.3C486.5 84.3 409.4 32 320 32s-166.5 52.3-202.4 128c-4.9 10.2-9 20.9-12.3 32l0 0c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64c3.1 10.6 7 20.8 11.6 30.7l.6 1.3c36 75.7 113.1 128 202.4 128s166.5-52.3 202.4-128zm34.9 0c-38 93.8-130 160-237.4 160s-199.4-66.2-237.4-160H40c-22.1 0-40-17.9-40-40V200c0-22.1 17.9-40 40-40H82.6C120.6 66.2 212.6 0 320 0S519.4 66.2 557.4 160H600c22.1 0 40 17.9 40 40V312c0 22.1-17.9 40-40 40H557.4zm10.5-160c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H600c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H567.9zM72.1 192H40c-4.4 0-8 3.6-8 8V312c0 4.4 3.6 8 8 8H72.1c-5.3-20.5-8.1-41.9-8.1-64s2.8-43.5 8.1-64zM417.6 336c-21.5 0-42.2-8.6-57.4-23.8c-4.5-4.5-4.5-11.9 0-16.4l95.6-95.6c4.5-4.5 11.9-4.5 16.5 .1C487.4 215.4 496 236 496 257.3v2.4c0 27.4-14.7 52.6-38.4 66.2c-11.5 6.6-24.6 10-37.8 10l-2.1 0zM464 257.3c0-5.8-1.1-11.5-3.1-17l-60.5 60.5c5.5 2 11.3 3.1 17.3 3.1l2.1 0c7.7 0 15.3-2 22-5.8c13.8-7.9 22.3-22.5 22.3-38.4v-2.4zm-260.7-54l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM235.3 299.3c-2.6 2.6-2.6 6.8 0 9.4l6.6 6.6c3 3 7.1 4.7 11.3 4.7H256h32c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64V352v-2.7c0-4.2-1.7-8.3-4.7-11.3l-6.6-6.6c-2.6-2.6-6.8-2.6-9.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM320 384c0-17.7-14.3-32-32-32H272c-8.8 0-16 7.2-16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32zm0-288c-20.9 0-38.7 13.4-45.3 32h90.5c-6.6-18.6-24.4-32-45.3-32zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16z"]
};
var faHeadSideCough = {
  prefix: 'fal',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v8 8 10.1l-79 11.3c-18.9 2.7-33 18.9-33 38c0 20 15.3 36.6 35.2 38.2l59.9 5C396.2 448.7 387 456 376 456H304c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-8h56c30.9 0 56-25.1 56-56v-8c0-8.3-6.4-15.3-14.7-15.9l-75.5-6.3c-3.3-.3-5.8-3-5.8-6.4c0-3.2 2.3-5.9 5.5-6.3l92.8-13.3c7.9-1.1 13.7-7.9 13.7-15.8V336v0h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM512 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 368a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faGripLines = {
  prefix: 'fal',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M448 192c0-8.8-7.2-16-16-16L16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16zm0 128c0-8.8-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16z"]
};
var faThumbsDown = {
  prefix: 'fal',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M288.8 430.3c3.5 12.8 16.7 20.3 29.5 16.8s20.3-16.7 16.8-29.5l-4.5-16.4c-5.5-20.2-13.9-39.3-24.7-56.9c-3.1-4.9-3.2-11.1-.4-16.2s8.2-8.2 14-8.2H448c17.7 0 32-14.3 32-32c0-11.3-5.9-21.3-14.8-27c-7.2-4.6-9.5-13.9-5.3-21.3c2.6-4.6 4.1-10 4.1-15.7c0-12.4-7-23.1-17.3-28.5c-4.2-2.2-7.3-6.1-8.3-10.8s.1-9.5 3-13.2c4.2-5.4 6.7-12.2 6.7-19.5c0-14.2-9.2-26.3-22.1-30.4c-7.8-2.5-12.4-10.6-10.7-18.6c.5-2.2 .7-4.5 .7-6.9c0-17.7-14.3-32-32-32H294.5c-15.8 0-31.2 4.7-44.4 13.4l-38.5 25.7c-9 6-16.6 13.7-22.4 22.6c-4.9 7.4-14.8 9.4-22.2 4.6s-9.4-14.8-4.6-22.2c8.1-12.3 18.7-23.1 31.4-31.6l38.5-25.7c18.4-12.3 40-18.8 62.1-18.8H384c35.3 0 64 28.7 64 64l0 .6c19.1 11.1 32 31.7 32 55.4c0 8.7-1.8 17.1-4.9 24.7C487.9 188.4 496 205.2 496 224c0 6.5-1 12.8-2.8 18.7C504.8 254.3 512 270.3 512 288c0 35.3-28.7 64-64 64H346.4c6.2 13.1 11.3 26.7 15.1 40.9l4.5 16.4c8.1 29.8-9.5 60.6-39.3 68.8s-60.6-9.5-68.8-39.3l-4.5-16.4c-8.9-32.6-29.6-60.8-58.2-79l-3.1-2 8.2-12.9-8.2 12.9c-11.8-7.5-21.7-17.1-29.5-28.2c-5.1-7.2-3.3-17.2 4-22.3s17.2-3.3 22.3 4c5.4 7.7 12.2 14.4 20.4 19.5l3.1 2c35.3 22.4 60.9 57.2 71.9 97.5l4.5 16.4zM32 352H96V128H32V352zM0 352V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faUserLock = {
  prefix: 'fal',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H384c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3v39c-26.8-33.5-68-55-114.3-55H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm432 96c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm0 80V480H608V352H448z"]
};
var faArrowRightLong = {
  prefix: 'fal',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-144-144c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l441.4 0L340.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l144-144z"]
};
var faLongArrowRight = faArrowRightLong;
var faTicketsAirline = {
  prefix: 'fal',
  iconName: 'tickets-airline',
  icon: [640, 512, [], "e29b", "M128 96V320c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V272.5c-23.7-11.8-40-36.2-40-64.5s16.3-52.8 40-64.5V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm484.1 45.6c.1 0 .1 0 .1 0l0 0-.1 0zm.1 132.9l-.1 0c.1 0 .1 0 .1 0zM160 32H576c35.3 0 64 28.7 64 64v56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1v56c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 96c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112C50.1 480 0 429.9 0 368V112c0-8.8 7.2-16 16-16zm274.3 74.9c1.6 4.9 .8 10.2-2.2 14.4s-7.8 6.6-13 6.6H229.8c-4.2 0-8.3-1.7-11.3-4.7L207.1 176H196l7.3 21.9c2.2 6.6 2.2 13.7 0 20.2L196 240h11.2l11.3-11.3c3-3 7.1-4.7 11.3-4.7h45.3c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4L276 288h20c2.8 0 5.5-1.5 6.9-4l30.4-52.1c2.9-4.9 8.1-7.9 13.8-7.9h41.6c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13H347.1c-5.7 0-11-3-13.8-7.9L302.9 132c-1.4-2.5-4.1-4-6.9-4H276l14.3 42.9zM264.9 96H296c14.2 0 27.4 7.6 34.6 19.8l-13.8 8.1 13.8-8.1L356.3 160h32.4c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2C428.4 247.9 409 256 388.7 256H356.3l-25.8 44.2C323.4 312.4 310.2 320 296 320H264.9c-16.4 0-27.9-16-22.8-31.6L252.9 256H236.4l-6.6 6.6c-6 6-14.1 9.4-22.6 9.4H184.9c-16.4 0-27.9-16-22.8-31.6L172.9 208l-10.8-32.4c-5.2-15.5 6.4-31.6 22.8-31.6h22.3c8.5 0 16.6 3.4 22.6 9.4l6.6 6.6h16.5l-10.8-32.4C236.9 112 248.5 96 264.9 96z"]
};
var faAnchorCircleXmark = {
  prefix: 'fal',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c17.2 0 33.8-2.5 49.5-7c-9.8-7.9-18.8-16.9-26.7-26.7c-7.4 1.2-15 1.8-22.8 1.8H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
var faEllipsis = {
  prefix: 'fal',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faEllipsisH = faEllipsis;
var faNfcSlash = {
  prefix: 'fal',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM544 351.3V96c0-35.3-28.7-64-64-64H160c-6 0-11.9 .8-17.4 2.4L180.1 64H192h64H480c17.7 0 32 14.3 32 32V326l32 25.3zm-64-50.5V128c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32v33.8l32 25.3V128H448V275.5l32 25.3zM378.8 384H192V236.5l-32-25.3V384c0 17.7 14.3 32 32 32H419.4l-40.5-32zM128 186L96 160.7V416c0 35.3 28.7 64 64 64H480c6 0 11.9-.8 17.4-2.4L459.9 448H160c-17.7 0-32-14.3-32-32V186z"]
};
var faChessPawn = {
  prefix: 'fal',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", "M240 144A80 80 0 1 0 80 144a80 80 0 1 0 160 0zm16 112H235.4L254 352H221.4l-18.6-96H160 117.2L98.6 352H66l18.6-96H64c-8.8 0-16-7.2-16-16s7.2-16 16-16H81.6C60.9 203.7 48 175.3 48 144C48 82.1 98.1 32 160 32s112 50.1 112 112c0 31.3-12.9 59.7-33.6 80H256c8.8 0 16 7.2 16 16s-7.2 16-16 16zM65.8 416L33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H280.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L254.2 416 65.8 416zm188.4-32c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H254.2z"]
};
var faKitMedical = {
  prefix: 'fal',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", "M128 448H448V64H128V448zm-32 0V64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H96zM64 32H96h16 16H448h16 16 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H480 464 448 128 112 96 64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32zM480 448h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H480V448zM272 144h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H336v32c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V304H208c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h32V176c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H208v32h48c8.8 0 16 7.2 16 16v48h32V288c0-8.8 7.2-16 16-16h48V240H320c-8.8 0-16-7.2-16-16V176H272z"]
};
var faFirstAid = faKitMedical;
var faGrid2Plus = {
  prefix: 'fal',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", "M176 64H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 288H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H336zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V288c0-8.8 7.2-16 16-16z"]
};
var faBells = {
  prefix: 'fal',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M282.6 40.1C214 15.1 138 50.4 112.8 119L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c2.6-9.1 4.4-18.4 5.4-27.7l-226-82.3 8.2-5.4c40.3-26.5 71.1-65.2 87.7-110.4l14.7-40c18.7-51 74.5-77.7 125.7-60.9c8.4-8.6 17.7-16.3 27.9-23c-4.5-2.2-9.1-4.2-13.9-6zm8.3 183.6c-20.1-54.7 8.1-115.2 62.8-135.2s115.4 8.3 135.5 63L508 202.6c16.3 44.6 46.4 82.8 85.9 109.2l13.7 9.2 0 0L310.1 429.3l4.6-15.8c13.1-45.6 11.3-94.1-5-138.7l-18.8-51.2zM342.8 58.4c-71.4 26-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2C493.2 69.2 414.1 32.5 342.8 58.4zm92 379.2c-6.7 5.8-7.4 15.9-1.6 22.6C450.5 480.1 479 488 505 477.8s41.5-35.5 40.5-61.8c-.3-8.8-7.7-15.7-16.6-15.4s-15.7 7.7-15.4 16.6c.5 13.2-7.3 25.8-20.3 30.9s-27.2 1.2-35.9-8.8c-5.8-6.7-15.9-7.4-22.6-1.6zM179.9 406.7c-8.7 10-23 13.9-35.9 8.8s-20.7-17.7-20.3-30.9c.3-8.8-6.6-16.2-15.4-16.6s-16.2 6.6-16.6 15.4c-.9 26.3 14.6 51.6 40.5 61.8s54.5 2.3 71.8-17.6c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6z"]
};
var faPersonThroughWindow = {
  prefix: 'fal',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M48 32c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16h80l0-70.4c0-70.6 41.2-134.7 105.3-164.1c52.8-24.2 86.7-77 86.7-135.1L320 32 48 32zM352 46.4c0 63.8-33.6 122.3-87.4 154.7L328.1 288l64.5 0c9.3 0 18.2 4.1 24.3 11.2l91.2 106.4 8.9 10.4H592c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16L352 32V46.4zM367 416H474.9l-82.3-96-51.3 0-54 40.5 93.5 126c5.3 7.1 3.8 17.1-3.3 22.4s-17.1 3.8-22.4-3.3L312.5 448H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0H592c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H390.5L367 416zm-98.7-81.2l35.1-26.3-67.6-92.4c-13.2 7.4-25.1 16.7-35.2 27.5l67.7 91.2zm-87.8-64.6c-13.2 22.4-20.6 48.3-20.6 75.4l0 70.4H288.7L180.6 270.2zM168 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 88 136z"]
};
var faToolbox = {
  prefix: 'fal',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M176 64H336c8.8 0 16 7.2 16 16v48H160V80c0-8.8 7.2-16 16-16zM128 80v48H106.5c-17 0-33.3 6.7-45.3 18.7L18.7 189.3C6.7 201.3 0 217.5 0 234.5V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V234.5c0-17-6.7-33.3-18.7-45.3l-42.5-42.5c-12-12-28.3-18.7-45.3-18.7H384V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H368h37.5c8.5 0 16.6 3.4 22.6 9.4l42.5 42.5c6 6 9.4 14.1 9.4 22.6V304H352V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H192V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H32V234.5c0-8.5 3.4-16.6 9.4-22.6l42.5-42.5c6-6 14.1-9.4 22.6-9.4H144zM32 336H160v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336H320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336H480v80c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336z"]
};
var faEnvelopeDot = {
  prefix: 'fal',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M448 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 416 80a80 80 0 1 0 160 0zM512 384V190.9c-5.2 .7-10.6 1.1-16 1.1c-13.8 0-27-2.5-39.2-7.1L284.4 311.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9V128c0-17.7 14.3-32 32-32H385.1c-.7-5.2-1.1-10.6-1.1-16s.4-10.8 1.1-16H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64zM32 207.6L208.7 337.1c28.2 20.6 66.5 20.6 94.6 0L480 207.6V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V207.6z"]
};
var faEnvelopeBadge = faEnvelopeDot;
var faHandsHoldingCircle = {
  prefix: 'fal',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M416 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-224 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faBug = {
  prefix: 'fal',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M256 32c-35.3 0-64 28.7-64 64H320c0-35.3-28.7-64-64-64zM160 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zM36.7 100.7c6.2-6.2 16.4-6.2 22.6 0L138.6 180c17.2-12.6 38.4-20 61.4-20H312c22.9 0 44.2 7.4 61.4 20l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L396 202.6c12.6 17.2 20 38.4 20 61.4v8h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v16c0 30.2-8.4 58.4-22.9 82.5l82.2 82.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79-79C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-79 79c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l82.2-82.2C104.4 378.4 96 350.2 96 320V304H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96v-8c0-22.9 7.4-44.2 20-61.4L36.7 123.3c-6.2-6.2-6.2-16.4 0-22.6zM128 320c0 65.3 48.9 119.1 112 127V256c0-8.8 7.2-16 16-16s16 7.2 16 16V447c63.1-7.9 112-61.7 112-127V288 264c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v24 32z"]
};
var faBowlChopsticks = {
  prefix: 'fal',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M499.1 31.7l-480 96C10.5 129.4 2 123.8 .3 115.1S4.2 98 12.9 96.3l480-96c8.7-1.7 17.1 3.9 18.8 12.6s-3.9 17.1-12.6 18.8zM512 142.9c.6 8.8-6.1 16.4-14.9 17l-480 32c-8.8 .6-16.4-6.1-17-14.9s6.1-16.4 14.9-17l480-32c8.8-.6 16.4 6.1 17 14.9zM144.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4c3.3 9.4 12.2 16.1 22.7 16.1H328c10.4 0 19.4-6.7 22.7-16.1c2.8-8.1 8.7-14.7 16.5-18.4c61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9H50.9c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.3 23.3 224 50.9 224H461.1c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-5 84.1-55.9 155.1-127.5 189.2C373.3 496.3 352.5 512 328 512H184c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8z"]
};
var faCreditCard = {
  prefix: 'fal',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 64C46.3 64 32 78.3 32 96v32H544V96c0-17.7-14.3-32-32-32H64zM32 160v64H544V160H32zm0 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V256H32zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faCreditCardAlt = faCreditCard;
var faCircleS = {
  prefix: 'fal',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192.7 190c2-10.7 9.2-19.1 23.1-24.4c14.3-5.5 34.5-7.2 57.9-3.8c7 1 23.4 4.5 31 6.4c8.6 2.2 17.3-3 19.4-11.6s-3-17.3-11.6-19.4c-8.2-2.1-25.7-5.8-34.1-7c-26.9-4-53.1-2.6-74.1 5.6c-21.5 8.3-38.6 24.2-43.1 48.5c-2.5 13.9-1.2 26.6 4 37.7c5.2 11 13.6 19.1 23 25.2c17.5 11.5 41.3 18.1 62 23.8l0 0 1.5 .4c22.6 6.3 41.6 11.7 54.4 20.1c6 4 9.7 8 11.7 12.3c1.9 4.1 3 9.7 1.5 18.2c-2 10.7-9.2 19.1-23.1 24.4c-14.3 5.5-34.5 7.2-57.9 3.8c-14.3-2.2-41.3-10-56.4-14.8c-8.4-2.7-17.4 2-20.1 10.5s2 17.4 10.5 20.1c15 4.7 44.2 13.3 61.2 15.9l0 0 .1 0c26.9 4 53.1 2.6 74.1-5.6c21.5-8.3 38.6-24.2 43.1-48.5c2.5-13.9 1.2-26.6-4-37.7c-5.2-11-13.6-19.1-23-25.2c-17.5-11.5-41.3-18.1-62-23.8l-1.5-.4c-22.6-6.3-41.6-11.7-54.4-20.1c-6-4-9.7-8-11.7-12.3c-1.9-4.1-3-9.7-1.5-18.2z"]
};
var faBoxBallot = {
  prefix: 'fal',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", "M160 32V224H416V32H160zm-32 0c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32zM48 160H96v32H48c-8.8 0-16 7.2-16 16V320H544V208c0-8.8-7.2-16-16-16H480V160h48c26.5 0 48 21.5 48 48V320v16 16V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352 336 320 208c0-26.5 21.5-48 48-48zM544 352H32V464c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16V352z"]
};
var faCar = {
  prefix: 'fal',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M113.6 98.2L85.3 192.6c3.5-.4 7.1-.6 10.7-.6H416c3.6 0 7.2 .2 10.7 .6L398.4 98.2c-6.1-20.3-24.8-34.2-46-34.2H159.6c-21.2 0-39.9 13.9-46 34.2zM74.3 227.8C49.6 236.7 32 260.3 32 288v96H480V288c0-27.7-17.6-51.3-42.3-60.2l-.5 .1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H96c-7.4 0-14.5 1.3-21.2 3.6l-.1 .3-.5-.1zm-26-23.1l.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57H352.4c35.3 0 66.5 23.2 76.6 57l34.3 114.4 .4 1.3C492.6 221.2 512 252.3 512 288v96 16 16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V416 400 384 288c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faAutomobile = faCar;
var faHandHoldingHand = {
  prefix: 'fal',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", "M425 226.6c-13.1 8.8-28.6 13.4-44.4 13.4H232c-30.9 0-56-25.1-56-56c0-8.6 1.9-16.7 5.4-24h-5.6L81.1 216.4c-8.3 4.9-17.8 7.6-27.5 7.6H52.3C23.4 224 0 200.6 0 171.7c0-17.7 9-34.2 23.8-43.9L143.4 50.1c18.2-11.8 39.4-18.1 61-18.1H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H204.5c-15.5 0-30.6 4.5-43.6 12.9L41.2 154.7c-5.8 3.7-9.2 10.1-9.2 17c0 11.2 9.1 20.3 20.3 20.3h1.3c3.9 0 7.7-1.1 11.1-3l98.5-58.7c2.5-1.5 5.3-2.3 8.2-2.3H232h24 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H256 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H380.6c9.5 0 18.7-2.8 26.6-8.1l79.9-53.3c2.6-1.8 5.7-2.7 8.9-2.7h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H500.8L425 226.6zM151 285.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 461.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 365.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 285.4z"]
};
var faUserTieHair = {
  prefix: 'fal',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M320 128v16c0 53-43 96-96 96s-96-43-96-96V128l34.3 0c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4h30.1c.9 5.2 1.3 10.5 1.3 16zM228.7 52.7c-1.3 1.3-2.4 2.8-3.1 4.5C213.5 81 189.1 96 162.3 96H133.5c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48H288.6c-6.4 0-12.5-2.5-17-7L251.3 52.7c-6.2-6.2-16.4-6.2-22.6 0zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.8l-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-79-56.8-144.7-131.8-158.6c-6.8-1.3-13.4 2.5-16.3 8.8L267.9 401l-21.7-65H256c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 192zm17.5 160.5l-9.7-21.1L224 370.6l24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3 .7 .7 1.4 1 2.1H32c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480H266.6c.3-.7 .7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z"]
};
var faPodiumStar = {
  prefix: 'fal',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M224 32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H224c-20.9 0-38.7 13.4-45.3 32H168c-44.2 0-80 35.8-80 80v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H120V112c0-26.5 21.5-48 48-48h10.7c6.6 18.6 24.4 32 45.3 32zM47.3 224L73.5 455.2c3.7 32.3 31 56.8 63.6 56.8H310.9c32.5 0 59.9-24.4 63.6-56.8L400.7 224H368.5L342.7 451.6c-1.8 16.2-15.5 28.4-31.8 28.4H137.1c-16.3 0-30-12.2-31.8-28.4L79.5 224H47.3zm214.2 58.8l-16.2-36.8c-8.2-18.6-34.2-18.6-42.4 0l-16.2 36.8-38.2 4.7c-20.5 2.5-26.6 27.4-13.2 40.4l28.7 27.8L156.2 396c-3.4 18 15.6 35.9 34.4 24.8L224 401.3l33.4 19.6c18.8 11 37.8-6.9 34.4-24.8l-7.6-40.3 28.7-27.8c13.4-13 7.3-37.9-13.2-40.4l-38.2-4.7zm-47.5 17.4l10.1-23 10.1 23c3.2 7.3 10 12.7 18.4 13.8l25.5 3.2-19.4 18.7c-5.8 5.6-8.2 13.8-6.8 21.5l5 26.1L235.6 371c-7.2-4.2-16-4.2-23.2 0l-21.2 12.4 5-26.1c1.5-7.7-1-15.9-6.8-21.5L170 317.1l25.5-3.2c8.3-1 15.2-6.5 18.4-13.8z"]
};
var faUserHairMullet = {
  prefix: 'fal',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M320 144c0 53-43 96-96 96s-96-43-96-96V128c0-5.5 .5-10.8 1.3-16h11.3c32.1 0 62.3-13.7 83.4-37.2c21.1 23.5 51.3 37.2 83.4 37.2h11.3c.9 5.2 1.3 10.5 1.3 16v16zM97.2 110.5c-.8 5.7-1.2 11.6-1.2 17.5v16c0 15.6 2.8 30.6 7.9 44.5c-.7 26.5-7.7 46.3-21.3 66.6c-2.5 3.8-3.3 8.5-2.2 13s4.2 8.2 8.3 10.2l16 8c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-.6-.3c4.6-8.7 8.3-17.6 11.1-26.9c5.7 6.3 12.1 12 19 17l-11.8 35.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l10-29.9c14.5 5.7 30.3 8.8 46.9 8.8s32.3-3.1 46.9-8.8l10 29.9c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-11.8-35.5c6.9-5 13.2-10.7 19-17c2.8 9.3 6.5 18.2 11.1 26.9l-.6 .3c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l16-8c4.1-2.1 7.1-5.8 8.3-10.2s.4-9.2-2.2-13c-13.5-20.3-20.6-40.2-21.3-66.6c5.1-13.9 7.9-28.8 7.9-44.5V128c0-5.9-.4-11.8-1.2-17.5c5.4-2.6 9.2-8.1 9.2-14.5c0-8.8-7.2-16-16-16h-1.3c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80H104c-8.8 0-16 7.2-16 16c0 6.4 3.8 11.9 9.2 14.5zM140.8 80c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48c-26.7-.1-51.5-13.4-66.3-35.6l-3.5-5.3c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-3.5 5.3C192.4 66.6 167.5 79.9 140.8 80zm22.7 272H284.4c71.5 0 129.6 57 131.5 128H32c1.9-71 60-128 131.5-128zm0-32C73.2 320 0 393.2 0 483.6C0 499.3 12.7 512 28.4 512H419.6c15.7 0 28.4-12.7 28.4-28.4C448 393.2 374.8 320 284.4 320H163.6z"]
};
var faBusinessFront = faUserHairMullet;
var faPartyBack = faUserHairMullet;
var faTrianBalbot = faUserHairMullet;
var faMicrophoneStand = {
  prefix: 'fal',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M449.5 186.9L325.1 62.5l4.7-4.7c34.4-34.4 90.1-34.4 124.4 0s34.4 90.1 0 124.5l-4.7 4.7zm-22.6 22.6l-4.7 4.7c-17.5 17.5-40.6 26.1-63.6 25.8L272 153.4c-.4-23 8.2-46.1 25.8-63.6l4.7-4.7L426.9 209.5zM358.3 272c31.3 .4 62.7-11.3 86.5-35.1l4.7-4.7 11.3-11.3 11.3-11.3 4.7-4.7c46.9-46.9 46.9-122.8 0-169.7S354-11.7 307.1 35.1l-4.7 4.7L291.1 51.1 279.8 62.5l-4.7 4.7C251.3 91 239.6 122.4 240 153.7L15 393.7c-9.6 10.3-15 23.9-15 38c0 14.7 5.8 28.8 16.3 39.3l24.8 24.8C51.5 506.2 65.6 512 80.4 512c14.1 0 27.7-5.4 38-15L256 367.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V337.9L358.3 272zM96.5 473.6c-4.4 4.1-10.1 6.4-16.1 6.4c-6.2 0-12.2-2.5-16.6-6.9L38.9 448.3c-4.4-4.4-6.9-10.4-6.9-16.6c0-6 2.3-11.7 6.4-16.1L256.4 183 329 255.6 96.5 473.6z"]
};
var faBookOpenReader = {
  prefix: 'fal',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-56.8-42.6-224-47.5C14.4 191.9 0 206.3 0 224V432c0 17.7 14.4 31.9 32 32.7c114.9 4.7 186.9 33.7 208.8 43.8c4.8 2.2 9.9 3.5 15.1 3.5s10.4-1.3 15.1-3.5c21.9-10.1 93.9-39.1 208.8-43.8c17.7-.7 32-15 32-32.7V224c0-17.7-14.4-32.1-32-31.5C312.8 197.4 256 240 256 240zm-18.9 25.8L240 268V473.3c-34-13.8-104.4-36.4-206.7-40.6c-.5 0-.9-.2-1.2-.5c-.1-.1-.1-.1-.1-.2l0 0 0 0 0 0 0 0 0 0 0 0V224.5c80.5 2.4 133.2 13.9 164.9 24.1c15.9 5.1 26.7 9.9 33 13.2c3.2 1.6 5.3 2.9 6.4 3.6c.4 .3 .7 .5 .9 .6zM272 268l2.9-2.2c.1-.1 .4-.3 .9-.6c1.1-.7 3.2-1.9 6.4-3.6c6.3-3.3 17-8.1 33-13.2c31.8-10.2 84.5-21.6 164.9-24.1V432v0l0 .1c0 0-.1 .1-.1 .1c-.3 .3-.7 .5-1.2 .5C376.4 436.9 306 459.5 272 473.3V268z"]
};
var faBookReader = faBookOpenReader;
var faFamilyDress = {
  prefix: 'fal',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 64h31.4c11.5 0 21.8 6.1 27.5 15.6c-2.1-7.5-3.2-15.4-3.2-23.6c0-6.3 .7-12.5 1.9-18.4c-8.1-3.6-16.9-5.6-26.2-5.6H112.3c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h49.6c-1-5.2-1.6-10.5-1.6-16V352H42.4L81.5 215.2C85.4 201.5 98 192 112.3 192zM366.4 384H416V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3c-9.3 0-18.1 2-26.2 5.6c1.3 5.9 1.9 12.1 1.9 18.4c0 8.2-1.1 16.1-3.2 23.6c5.7-9.5 16-15.6 27.5-15.6h31.4c14.3 0 26.8 9.5 30.8 23.2L469.6 352H368v16c0 5.5-.6 10.8-1.6 16zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM256 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c26.5 0 48 21.5 48 48v32c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V336c0-26.5 21.5-48 48-48zM208 413.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V416h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V413.3c18.6-6.6 32-24.4 32-45.3V336c0-44.2-35.8-80-80-80s-80 35.8-80 80v32c0 20.9 13.4 38.7 32 45.3z"]
};
var faCircleX = {
  prefix: 'fal',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM172.1 133.6c-5.8-6.7-15.9-7.5-22.6-1.7s-7.5 15.9-1.7 22.6L234.9 256 147.9 357.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7L256 280.6l83.9 97.8c5.8 6.7 15.8 7.5 22.6 1.7s7.5-15.8 1.7-22.6L277.1 256l87.1-101.6c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7L256 231.4l-83.9-97.8z"]
};
var faCabin = {
  prefix: 'fal',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M237.1 10c11.3-8.3 26.6-8.3 37.8 0L352 66.6V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V160h-.6l13 9.6c12.3 9 19.6 23.3 19.6 38.6c0 21.4-14 39.5-33.3 45.6c.9 3.3 1.3 6.7 1.3 10.2v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V456c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V392c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V328c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V264c0-2.7 .3-5.4 .8-8H191.2c.5 2.6 .8 5.3 .8 8v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 9-3 17.3-8 24c5 6.7 8 15 8 24v16c0 22.1-17.9 40-40 40H72c-22.1 0-40-17.9-40-40V456c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V392c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V328c0-9 3-17.3 8-24c-5-6.7-8-15-8-24V264c0-3.5 .5-7 1.3-10.2C14 247.6 0 229.5 0 208.1c0-15.2 7.3-29.6 19.6-38.6L237.1 10zM360 416h80c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm80 32H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8zm8-104V328c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zM360 224h80 24.1c8.8 0 15.9-7.1 15.9-15.9c0-5.1-2.4-9.8-6.5-12.8L256 35.8 38.5 195.4c-4.1 3-6.5 7.7-6.5 12.8c0 8.8 7.1 15.9 15.9 15.9H72h80H360zm0 32c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V264c0-4.4-3.6-8-8-8H360zM72 416h80c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm80 32H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8zm8-104V328c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zM72 256c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V264c0-4.4-3.6-8-8-8H72zM448 137V64H384V90L448 137zm-192-9a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faMountainSun = {
  prefix: 'fal',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", "M608 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM480 80a80 80 0 1 1 160 0A80 80 0 1 1 480 80zM456.1 480c13.2 0 23.9-10.7 23.9-23.9c0-4.5-1.3-8.9-3.7-12.7L259.6 98c-.8-1.3-2.2-2-3.6-2s-2.9 .8-3.6 2L35.7 443.4c-2.4 3.8-3.7 8.2-3.7 12.7C32 469.3 42.7 480 55.9 480H456.1zM55.9 512C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1 55.9zm447.5-85.6c5.6 8.9 8.6 19.2 8.6 29.7c0 8.6-1.9 16.7-5.4 23.9h72.2c16.1 0 29.1-13 29.1-29.1c0-5.3-1.5-10.6-4.3-15.2L480 232.9 431.7 312l71.7 114.3z"]
};
var faChartSimpleHorizontal = {
  prefix: 'fal',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M416 240c0-8.8-7.2-16-16-16L48 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-32zm32 32c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 32zM224 400c0-8.8-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-32zm32 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32zm96-320l0-32c0-8.8-7.2-16-16-16L48 64c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16zm-16 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48z"]
};
var faBluetooth = {
  prefix: 'fal',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M185.4 1.4c5.7-2.6 12.5-1.5 17.2 2.6l144 128c3.6 3.2 5.5 7.7 5.4 12.5s-2.4 9.2-6.2 12.1L218.1 256l127.8 99.4c3.8 2.9 6 7.4 6.2 12.1s-1.8 9.3-5.4 12.5l-144 128c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V288.7L57.8 380.6c-7 5.4-17 4.2-22.5-2.8s-4.2-17 2.8-22.5L165.9 256 38.2 156.6c-7-5.4-8.2-15.5-2.8-22.5s15.5-8.2 22.5-2.8L176 223.3V16c0-6.3 3.7-12 9.4-14.6zM208 288.7V460.4l103-91.6L208 288.7zm0-65.4l103-80.1L208 51.6V223.3z"]
};
var faArrowsLeftRightToLine = {
  prefix: 'fal',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", "M16 64c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm203.3 84.7c6.2 6.2 6.2 16.4 0 22.6L150.6 240l338.7 0-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L489.4 272l-338.7 0 68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM640 80V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHandBackPointLeft = {
  prefix: 'fal',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 168c0-30.9 25.1-56 56-56l200.6 0c2-3.2 4.2-6.4 6.5-9.5L280 80c15.1-20.1 38.8-32 64-32l19.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L512 336c0 61.9-50.1 112-112 112l-8 0-88 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-5.3 .7-10.5 1.9-15.5c-20.2-10.8-33.9-32-33.9-56.5c0-8.5 1.7-16.6 4.7-24L56 224c-30.9 0-56-25.1-56-56zm56-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l157.5 0c7.1 0 13.3 4.6 15.3 11.4s-.6 14-6.5 18c-8.7 5.8-14.3 15.6-14.3 26.7c0 15.6 11.2 28.6 25.9 31.4c5.1 1 9.5 4.4 11.6 9.2s1.8 10.3-.9 14.8c-2.9 4.8-4.6 10.5-4.6 16.6c0 14.7 10 27.2 23.6 30.9c4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8 .6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8c0 17.7 14.3 32 32 32l88 0 8 0c44.2 0 80-35.8 80-80l0-135.7c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C442.6 102.6 404.7 80 363.5 80L344 80c-15.1 0-29.3 7.1-38.4 19.2L296 112l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-78.3 0-1.7 0L56 144z"]
};
var faMessageDots = {
  prefix: 'fal',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCommentAltDots = faMessageDots;
var faMessaging = faMessageDots;
var faFileHeart = {
  prefix: 'fal',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm61.7 306.8c0-11.9 9.6-21.5 21.5-21.5h1.5c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5h1.5c11.9 0 21.5 9.6 21.5 21.5c0 5.8-2.3 11.4-6.5 15.4L192 380.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5z"]
};
var faBeerMug = {
  prefix: 'fal',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", "M208 0c-26.3 0-50.2 10.6-67.6 27.8l0 0 0 0c0 0-.1 .1-.2 .1c-.2 .1-.4 .2-.8 .2c-.7 .1-1.3-.1-1.6-.3C125.7 20.3 111.3 16 96 16C51.8 16 16 51.8 16 96s35.8 80 80 80c15.3 0 29.7-4.3 41.9-11.8c.3-.2 .8-.4 1.6-.3c.3 0 .6 .1 .8 .2c.1 0 .1 .1 .2 .1l0 0 0 0C157.8 181.4 181.7 192 208 192s50.2-10.6 67.6-27.8l0 0 0 0c0 0 0 0 .1 0c0 0 .1 0 .1 0c.2-.1 .4-.2 .8-.2c.7-.1 1.3 .1 1.6 .3c12.2 7.5 26.6 11.8 41.9 11.8c44.2 0 80-35.8 80-80s-35.8-80-80-80c-15.3 0-29.7 4.3-41.9 11.8c-.3 .2-.8 .4-1.6 .3c-.3 0-.6-.1-.8-.2c-.1 0-.1-.1-.2-.1l0 0 0 0C258.2 10.6 234.3 0 208 0zM163 50.5C174.5 39.1 190.4 32 208 32s33.5 7.1 45 18.5c11.3 11.2 29 12.4 41.8 4.5c7.3-4.5 15.9-7.1 25.1-7.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-9.2 0-17.8-2.6-25.1-7.1c-12.8-7.9-30.5-6.7-41.8 4.5c-11.6 11.5-27.5 18.5-45 18.5s-33.5-7.1-45-18.5c-11.3-11.2-29-12.4-41.8-4.5c-7.3 4.5-15.9 7.1-25.1 7.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.2 0 17.8 2.6 25.1 7.1c12.8 7.9 30.5 6.7 41.8-4.5zM32 187.9V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V434.5l80.1-35c29.1-12.7 47.9-41.5 47.9-73.3V272c0-44.2-35.8-80-80-80H384v-4.1c-9.7 6.7-20.4 12-32 15.4V423.7c0 .2 0 .5 0 .7V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V203.4c-11.6-3.4-22.3-8.7-32-15.4zM208 224c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zm224 0c26.5 0 48 21.5 48 48v54.1c0 19.1-11.3 36.3-28.8 44L384 399.5V224h48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faBeerFoam = faBeerMug;
var faDiceD20 = {
  prefix: 'fal',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M217.5 56.4L77.9 140.2l61.4 44.7L217.5 56.4zM64 169.6V320.3l59.2-107.6L64 169.6zM104.8 388L240 469.1V398.8L104.8 388zM272 469.1L407.2 388 272 398.8v70.3zM448 320.3V169.6l-59.2 43L448 320.3zM434.1 140.2L294.5 56.4l78.2 128.4 61.4-44.7zM243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6V368c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368V144c0-8.4 4.4-16.2 11.7-20.6l200-120zM225.3 365.5L145 239.4 81.9 354l143.3 11.5zM338.9 224H173.1L256 354.2 338.9 224zM256 54.8L172.5 192H339.5L256 54.8zm30.7 310.7L430.1 354 367 239.4 286.7 365.5z"]
};
var faDrone = {
  prefix: 'fal',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M112 32c39.6 0 72.5 28.8 78.9 66.6c1.5 8.7 9.7 14.6 18.4 13.1s14.6-9.7 13.1-18.4C213.6 40.4 167.5 0 112 0C50.1 0 0 50.1 0 112c0 55.5 40.4 101.6 93.4 110.5c8.7 1.5 17-4.4 18.4-13.1s-4.4-17-13.1-18.4C60.8 184.5 32 151.6 32 112c0-44.2 35.8-80 80-80zm286.7 0c44.2 0 80 35.8 80 80c0 39.6-28.8 72.5-66.6 78.9c-8.7 1.5-14.6 9.7-13.1 18.4s9.7 14.6 18.4 13.1c53-8.9 93.4-54.9 93.4-110.5c0-61.9-50.1-112-112-112C343.2 0 297.1 40.4 288.2 93.4c-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1C326.1 60.8 359 32 398.7 32zM32 398.7c0-39.6 28.8-72.5 66.6-78.9c8.7-1.5 14.6-9.7 13.1-18.4s-9.7-14.6-18.4-13.1C40.4 297.1 0 343.2 0 398.7c0 61.9 50.1 112 112 112c55.5 0 101.6-40.4 110.5-93.4c1.5-8.7-4.4-17-13.1-18.4s-17 4.4-18.4 13.1c-6.3 37.8-39.3 66.6-78.9 66.6c-44.2 0-80-35.8-80-80zm366.7 80c-39.6 0-72.5-28.8-78.9-66.6c-1.5-8.7-9.7-14.6-18.4-13.1s-14.6 9.7-13.1 18.4c8.9 53 54.9 93.4 110.5 93.4c61.9 0 112-50.1 112-112c0-55.5-40.4-101.6-93.4-110.5c-8.7-1.5-17 4.4-18.4 13.1s4.4 17 13.1 18.4c37.8 6.3 66.6 39.3 66.6 78.9c0 44.2-35.8 80-80 80zM112 432c17.7 0 32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3L182.6 352H329.4l39.7 39.7c-.7 2.6-1.1 5.4-1.1 8.3c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32c-2.9 0-5.6 .4-8.3 1.1L352 329.4V182.6l39.7-39.7c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L329.4 160H182.6l-39.7-39.7c.7-2.6 1.1-5.4 1.1-8.3c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c2.9 0 5.6-.4 8.3-1.1L160 182.6V329.4l-39.7 39.7c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-112V192H320V320H192z"]
};
var faTruckDroplet = {
  prefix: 'fal',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM416 128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM256 211c0 23.7-20.3 45-48 45s-48-21.3-48-45c0-1.7 .9-7.2 5-17.4c3.9-9.5 9.5-20.4 16.1-32.1c8.5-14.8 18.1-29.7 26.8-42.6c8.7 12.8 18.4 27.8 26.8 42.6c6.7 11.6 12.3 22.6 16.1 32.1c4.1 10.2 5 15.7 5 17.4zm32 0c0-32-45.2-98.9-67.6-130.2c-6.1-8.6-18.6-8.6-24.8 0C173.2 112.1 128 179 128 211c0 42.5 35.8 77 80 77s80-34.5 80-77z"]
};
var faFileCircleXmark = {
  prefix: 'fal',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faTemperatureArrowUp = {
  prefix: 'fal',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM420.7 36.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faTemperatureUp = faTemperatureArrowUp;
var faMedal = {
  prefix: 'fal',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", "M106.4 191.5c7.5-7.8 15.6-14.9 24.2-21.4L38.5 32l103.4 0 61.6 102.7c10.9-2.8 22.2-4.8 33.8-5.9l-68-113.3C163.5 5.9 153.1 0 141.9 0H24.6C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6L106.4 191.5zm168.3-62.7c11.6 1 22.9 3 33.8 5.9L370.1 32l103.4 0L381.5 170.1c8.6 6.5 16.7 13.7 24.2 21.4L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0H370.1c-11.2 0-21.7 5.9-27.4 15.5l-68 113.3zM256 192a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm38.8-229.5l-17.3-35.1c-8.8-17.8-34.2-17.8-43 0l-17.3 35.1-38.7 5.6c-19.7 2.9-27.5 27.1-13.3 40.9l28 27.3L186.5 395c-3.4 19.6 17.2 34.6 34.8 25.3L256 402.1l34.6 18.2c17.6 9.3 38.2-5.7 34.8-25.3l-6.6-38.6 28-27.3c14.2-13.9 6.4-38.1-13.3-40.9l-38.7-5.6zM244 300.5l12-24.3 12 24.3c3.5 7.1 10.3 12 18.1 13.1l26.8 3.9-19.4 18.9c-5.7 5.5-8.2 13.5-6.9 21.2l4.6 26.7-24-12.6c-7-3.7-15.3-3.7-22.3 0l-24 12.6 4.6-26.7c1.3-7.8-1.2-15.7-6.9-21.2l-19.4-18.9 26.8-3.9c7.8-1.1 14.6-6 18.1-13.1z"]
};
var faPersonFairy = {
  prefix: 'fal',
  iconName: 'person-fairy',
  icon: [640, 512, [], "e608", "M320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM297.6 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C244.1 304 258.8 320 277.6 320h84.9c18.7 0 33.4-16 31.9-34.7L390.2 236c-2.1-24.9-22.9-44-47.8-44H297.6zm0-32h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H288V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4zM32 32c89.4 0 169.4 40.8 222.2 104.7c-10.1 4.2-19.4 9.9-27.7 16.8C179.5 98.7 109.8 64 32 64v48c0 76.5 35.7 144.6 91.5 188.6l12.1 9.5c6.8 5.3 8.1 15 3 22l-9.1 12.4C108.5 373.6 96 409.3 96 448h16c42.5 0 81.6-15.1 112-40.2v39.5C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32zM413.5 153.5c-8.3-6.9-17.7-12.5-27.7-16.8C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528c-41.2 0-79.7-12-112-32.7V407.8c30.4 25.1 69.5 40.2 112 40.2h16c0-38.7-12.5-74.4-33.6-103.5l-9.1-12.4c-5.1-7-3.7-16.7 3-22l12.1-9.5C572.3 256.6 608 188.5 608 112V64c-77.8 0-147.5 34.7-194.5 89.5z"]
};
var faBed = {
  prefix: 'fal',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V336v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V416H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 336 240c0-61.9-50.1-112-112-112H304c-26.5 0-48 21.5-48 48V320H32V48zM608 384H32V352H272 608v32zm0-144v80H288V176c0-8.8 7.2-16 16-16H528c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z"]
};
var faBookCopy = {
  prefix: 'fal',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M224 64c0-17.7 14.3-32 32-32H528c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H256c-11.7 0-22.6 3.1-32 8.6V64zm-32 0V352c0 35.3 28.7 64 64 64H528h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H544V317.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H256c-35.3 0-64 28.7-64 64zm64 320c-17.7 0-32-14.3-32-32s14.3-32 32-32H512v64H256zm96 96V448H320v32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H184.4c-8.3-9.2-14.8-20.1-19-32H64c-11.7 0-22.6 3.1-32 8.6V160c0-17.7 14.3-32 32-32h96V96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H336h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z"]
};
var faSquareH = {
  prefix: 'fal',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm336 48V256 368c0 8.8-7.2 16-16 16s-16-7.2-16-16V272l-160 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16v96l160 0V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHSquare = faSquareH;
var faSquareC = {
  prefix: 'fal',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm156.1 92.1c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-37.5-37.5-98.3-37.5-135.8 0z"]
};
var faClockTwo = {
  prefix: 'fal',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V226.1l71.1-47.4c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSquareEllipsisVertical = {
  prefix: 'fal',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCalendarUsers = {
  prefix: 'fal',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M208 0c8.8 0 16 7.2 16 16V64H416V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32H528 512 128 112 96V160 128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm39.4 512c5.4-9.4 8.6-20.3 8.6-32H384c0 11.7 3.1 22.6 8.6 32H247.4zM480 96H160c-17.7 0-32 14.3-32 32v32H512V128c0-17.7-14.3-32-32-32zm48 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM480 448c-17.7 0-32 14.3-32 32H608c0-17.7-14.3-32-32-32H480zm-64 32c0-35.3 28.7-64 64-64h48 48c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32zM160 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 304a80 80 0 1 1 160 0A80 80 0 1 1 32 304zm0 176H192c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm32-64h48 48c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64z"]
};
var faPodcast = {
  prefix: 'fal',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M416 224c0 71.3-38.8 133.5-96.5 166.6c-1.4 11.5-3.2 23.4-5 34.8l-.6 3.8C392.8 394.7 448 315.8 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-1.9-11.5-3.7-23.5-5.1-35C70.8 357.5 32 295.3 32 224C32 118 118 32 224 32s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9c1.6-7.1 4.3-13.9 8.1-20.3c2.1-3.5 4.5-6.7 7-9.7c-19-20.1-30.6-47.1-30.6-76.9c0-61.9 50.1-112 112-112s112 50.1 112 112c0 29.8-11.6 56.8-30.6 76.9c2.5 2.9 4.9 6.1 7 9.7c3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zM224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM209.5 478.2c-3.6-13.6-8.6-37.7-12.7-63c-4.3-26.4-7.3-51.3-7.3-65.7c0-4.3 .9-5.8 1.1-6.1c.2-.3 .7-1.2 2.8-2.3c5.2-2.9 15.3-5.1 30.7-5.1s25.5 2.2 30.7 5.1c2.1 1.1 2.6 2 2.8 2.3c.2 .3 1.1 1.8 1.1 6.1c0 14.3-2.9 39.2-7.3 65.6c-4.1 25.2-9.1 49.4-12.8 63.1c-1 .4-2.5 .8-4.9 1.2c-2.7 .4-5.9 .6-9.7 .6s-7-.2-9.7-.6c-2.3-.4-3.9-.8-4.9-1.2zm-30.6 9.5c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2c0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2z"]
};
var faBee = {
  prefix: 'fal',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", "M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2c0-5.7 .3-11.4 .8-17C66.7 280.9 32 247.6 32 208c0-43.8 42.5-80 96-80c40.8 0 75.2 21.1 89.3 50.5C173.5 203.3 144 250.2 144 304c0 83.8 103.6 179.7 129.9 202.8c3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-53.8-29.5-100.7-73.3-125.5c14-29.5 48.5-50.5 89.3-50.5c53.5 0 96 36.2 96 80c0 39.6-34.7 72.9-80.8 79c.5 5.6 .8 11.3 .8 17c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zM288 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM177.1 288c1.6-11.3 4.9-22.1 9.6-32H389.2c4.7 9.9 8 20.7 9.6 32H177.1zm32.5-64c20.2-19.8 47.9-32 78.4-32s58.2 12.2 78.4 32H209.6zm188.7 96c-2 10.2-5.7 20.9-10.9 32H188.5c-5.2-11.1-8.9-21.8-10.9-32H398.4zm-29 64c-5.4 8.1-11.3 16.3-17.6 24.5c-2 2.6-4 5.1-6 7.5H230.3c-2-2.5-4-5-6-7.5c-6.4-8.1-12.3-16.3-17.6-24.5H369.3zm-52.1 64c-11.4 11.8-21.7 21.6-29.2 28.5c-7.6-6.9-17.9-16.6-29.2-28.5h58.5z"]
};
var faTemperatureFull = {
  prefix: 'fal',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M160 32c-35.3 0-64 28.7-64 64V252.7c0 14.9-7 27.7-16 36.9C60.2 309.8 48 337.5 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4c-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96V252.7c0 4.6 2.2 9.8 6.8 14.5c25.5 26 41.2 61.6 41.2 100.8c0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8c4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V96c0-8.8 7.2-16 16-16s16 7.2 16 16V306c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z"]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faBell = {
  prefix: 'fal',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"]
};
var faCandyBar = {
  prefix: 'fal',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M155.5 74.7c2.3-6.4 8.3-10.7 15.1-10.7H320h16 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H352 336 320 64c-35.3 0-64-28.7-64-64V234.5c0-6.8 4.3-12.8 10.7-15.1C41.8 208.5 64 178.8 64 144c0-8.8 7.2-16 16-16c34.8 0 64.5-22.2 75.5-53.3zM192 96v96H320V96H192zm-32 30.4c-17 17.4-39.7 29.2-65 32.6c-1.6 11.7-4.9 22.8-9.8 33H160V126.4zm-96 96c-9.2 9.4-20 17.1-32 22.8V320H160V224H64v-1.6zM32 352v32c0 17.7 14.3 32 32 32h96V352H32zm160 64H320V352H192v64zm128-96V224H192v96H320zm32 96H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H352V416z"]
};
var faChocolateBar = faCandyBar;
var faXmarkLarge = {
  prefix: 'fal',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M420.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256 443.3 452.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6 27.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256 4.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 420.7 36.7z"]
};
var faPinata = {
  prefix: 'fal',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M160 48c0-26.5 21.5-48 48-48s48 21.5 48 48V224H416c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V448c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v16c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V225.9L38.9 197.3C15.1 185.4 0 161 0 134.4C0 95.5 31.5 64 70.4 64H160V48zm96 336h96 3.7c10.2 0 20.3 1.9 29.7 5.7l23.1 9.2 36.9-12.3c7.2-2.4 15-2.2 22 .6l12.6 5V342.5c-4.7-.1-9.3-1.2-13.6-3.4l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6L128 342v50.3l12.6-5c7-2.8 14.8-3 22-.6L199.5 399l23.1-9.2c9.4-3.8 19.5-5.7 29.7-5.7H256zM128 307.6l19.4-7.8c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l17.6 8.8C474.2 279.3 447.8 256 416 256H240c-3.5 0-6.7-1.1-9.4-3l-19.3 7.7c-7 2.8-14.8 3-22 .6L152.5 249 128 258.8v48.7zM224 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V80c0 8.8-7.2 16-16 16H70.4C49.2 96 32 113.2 32 134.4c0 14.5 8.2 27.8 21.2 34.3l65.9 33c5.4 2.7 8.8 8.3 8.8 14.3v8.4l12.6-5c7-2.8 14.8-3 22-.6L199.5 231l24.5-9.8V48zM128 426.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448c0-6 .8-11.9 2.4-17.4c-1.7-.3-3.4-.7-5-1.2L152.5 417 128 426.8zm352 0L455.5 417l-36.9 12.3c-1.6 .6-3.3 1-5 1.2c1.6 5.5 2.4 11.4 2.4 17.4v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V426.8zM152 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faArrowsFromLine = {
  prefix: 'fal',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", "M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM0 256c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM224 512c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4 240 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z"]
};
var faSuperscript = {
  prefix: 'fal',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M464 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V160H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H464V16zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H55.2L157 256 55.2 416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H296.8L195 256 296.8 96H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H288c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4C74.6 66.8 69.5 64 64 64H16z"]
};
var faBowlSpoon = {
  prefix: 'fal',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M112 160c-49 0-80-33.1-80-64s31-64 80-64s80 33.1 80 64s-31 64-80 64zm0 32c55.5 0 101.6-34.6 110.5-80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.5C213.6 34.6 167.5 0 112 0C50.1 0 0 43 0 96s50.1 96 112 96zm49.3 271.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9H461.1c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1H184c-10.4 0-19.4-6.7-22.7-16.1zM50.9 224C23.3 224 1.4 247.2 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2c7.6 21.9 28.4 37.6 52.9 37.6H328c24.5 0 45.3-15.7 52.9-37.6c71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8H50.9z"]
};
var faHexagonCheck = {
  prefix: 'fal',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm319.6-36.7l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 297.4 340.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPlugCircleXmark = {
  prefix: 'fal',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faStarOfLife = {
  prefix: 'fal',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M192 48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v97.1l84.1-48.6c23-13.3 52.3-5.4 65.6 17.6l16 27.7c13.3 23 5.4 52.3-17.6 65.6L384 256l84.1 48.6c23 13.3 30.8 42.6 17.6 65.6l-16 27.7c-13.3 23-42.6 30.8-65.6 17.6L320 366.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V366.9l-84.1 48.6c-23 13.3-52.3 5.4-65.6-17.6l-16-27.7c-13.3-23-5.4-52.3 17.6-65.6L128 256 43.9 207.4 51.6 194l-7.7 13.4c-23-13.3-30.8-42.6-17.6-65.6l16-27.7c13.3-23 42.6-30.8 65.6-17.6L192 145.1V48zm48-16c-8.8 0-16 7.2-16 16V172.9c0 5.7-3 11-8 13.9s-11 2.9-16 0L91.9 124.3c-7.7-4.4-17.4-1.8-21.9 5.9L54 157.9c-4.4 7.7-1.8 17.4 5.9 21.9L168 242.1c5 2.9 8 8.1 8 13.9s-3 11-8 13.9L59.9 332.3c-7.7 4.4-10.3 14.2-5.9 21.9l16 27.7c4.4 7.7 14.2 10.3 21.9 5.9L200 325.3c5-2.9 11-2.9 16 0s8 8.1 8 13.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V339.1c0-5.7 3-11 8-13.9s11-2.9 16 0l108.1 62.4c7.7 4.4 17.4 1.8 21.9-5.9l16-27.7c4.4-7.7 1.8-17.4-5.9-21.9L344 269.9c-5-2.9-8-8.1-8-13.9s3-11 8-13.9l108.1-62.4c7.7-4.4 10.3-14.2 5.9-21.9l-16-27.7c-4.4-7.7-14.2-10.3-21.9-5.9L312 186.7c-5 2.9-11 2.9-16 0s-8-8.1-8-13.9V48c0-8.8-7.2-16-16-16H240z"]
};
var faPhoneSlash = {
  prefix: 'fal',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M480 510.9c-95.4-6.7-182.6-43.3-252.2-100.5L253.5 390c70.9 56.3 160.6 89.9 258.1 90l.3 0c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-8.7-5-17.1-10.4-25.3-16.2L344.8 318c4.9 3.2 9.9 6.3 15 9.3L393 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8zM141.2 315.6C92.5 243.9 64 157.3 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c1.9 3.3 3.9 6.6 6 9.8l-25.2 19.9c-2.9-4.5-5.7-9.1-8.4-13.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 85.8 26 165.5 70.4 231.7l-25.2 19.9zM614.1 3.4c6.9-5.5 17-4.3 22.5 2.6s4.3 17-2.6 22.5l-608 480c-6.9 5.5-17 4.3-22.5-2.6s-4.3-17 2.6-22.5l608-480z"]
};
var faTrafficLightStop = {
  prefix: 'fal',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-136a56 56 0 1 1 0-112 56 56 0 1 1 0 112z"]
};
var faPaintRoller = {
  prefix: 'fal',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M352 32c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zm64 32c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V96c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V64zM240 352c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32zm-32-32c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48V288c0-17.7 14.3-32 32-32H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64V96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H272c-35.3 0-64 28.7-64 64v32z"]
};
var faAccentGrave = {
  prefix: 'fal',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M64 65.3C64 46.9 78.9 32 97.3 32c16.1 0 30 11.6 32.8 27.5l22.5 126.2c.6 3.3-1.9 6.3-5.3 6.3c-1.7 0-3.4-.8-4.4-2.3L70.4 86.9C66.2 81 64 74 64 66.8V65.3zm-32 0v1.5c0 13.8 4.3 27.3 12.2 38.5l72.6 102.9c7 9.9 18.4 15.8 30.5 15.8c23.3 0 40.9-21 36.8-43.9L161.6 53.8C156.1 22.7 129 0 97.3 0C61.2 0 32 29.2 32 65.3z"]
};
var faHandshakeAngle = {
  prefix: 'fal',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6L452.7 81.9c-9 9-21.2 14.1-33.9 14.1H304c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V168c0-8.8 7.2-16 16-16s16 7.2 16 16v24H448c35.3 0 64 28.7 64 64c0 24.5-13.7 45.7-33.9 56.5c1.2 5 1.9 10.2 1.9 15.5c0 29.9-20.5 55-48.3 62.1C428.7 422.6 401.3 448 368 448H237.3c-4.2 0-8.3 1.7-11.3 4.7l-54.6 54.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l54.6-54.6c9-9 21.2-14.1 33.9-14.1H368c17.7 0 32-14.3 32-32c0-1.8-.2-3.6-.4-5.4c-.8-4.7 .5-9.5 3.6-13.1s7.6-5.6 12.4-5.6l.4 0c17.7 0 32-14.3 32-32c0-6.1-1.7-11.7-4.6-16.6c-2.7-4.5-3.1-10-.9-14.8s6.5-8.2 11.6-9.2c14.8-2.8 25.9-15.8 25.9-31.4c0-17.7-14.3-32-32-32H336v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V160c0-53 43-96 96-96H418.7c4.2 0 8.3-1.7 11.3-4.7L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0zM125.6 190.3c9.2-24.5 27.6-43.5 50.4-53.8v37.1c-9.1 7.1-16.3 16.7-20.5 27.9l-26.1 69.6c-2.4 6.4-6.2 12.2-11 17.1L27.3 379.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l91.1-91.1c1.6-1.6 2.9-3.6 3.7-5.7l26.1-69.6zm509.8-57.6c6.2 6.2 6.2 16.4 0 22.6L543.6 247c-1.2-12.5-4.7-24.4-10.2-35l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHandsHelping = faHandshakeAngle;
var faCircle0 = {
  prefix: 'fal',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96V224c0-53-43-96-96-96zm-64 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V224z"]
};
var faDialMedLow = {
  prefix: 'fal',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM197.5 378.5c-46.2-46.2-49.7-118.8-10.6-169l89.8 89.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-89.8-89.8c50.2-39.1 122.9-35.5 169 10.6c50 50 50 131 0 181s-131 50-181 0zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faLocationDot = {
  prefix: 'fal',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faMapMarkerAlt = faLocationDot;
var faCrab = {
  prefix: 'fal',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M112 32C73.3 32 41 59.5 33.6 96h97.1c4.2 0 8.3-1.7 11.3-4.7l6.6-6.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-6.6 6.6c-9 9-21.2 14.1-33.9 14.1H32v20.1c0 11.5 6.2 22.1 16.1 27.8l78.8 45C145.1 206 167.5 196 192 193V144c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v49c24.5 3.1 46.9 13.1 65.1 28l78.8-45c10-5.7 16.1-16.3 16.1-27.8V128H381.3c-12.7 0-24.9-5.1-33.9-14.1l-6.6-6.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l6.6 6.6c3 3 7.1 4.7 11.3 4.7h97.1C471 59.5 438.7 32 400 32H384l25.6 19.2c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-64-48c-5.5-4.1-7.8-11.3-5.6-17.9S329.1 0 336 0h64c61.9 0 112 50.1 112 112v36.1c0 23-12.3 44.2-32.2 55.6l-72.1 41.2c6 8.3 11.1 17.4 15 27.1h37.5l28.6-14.3c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-2.2 1.1-4.7 1.7-7.2 1.7H431c.7 5.2 1 10.6 1 16v8l22.2 9.2c1.9 .8 3.7 2 5.2 3.5l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-29.8-29.8-25.7-10.7-31.1 31.1L421.7 401c2.1 .8 4 2 5.6 3.6l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-29.6-29.6-49.8-19-15.1 15.1L377.3 451c4.2 3 6.7 7.9 6.7 13v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V472.2L318.1 448H193.9L160 472.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V464c0-5.2 2.5-10 6.7-13l35.2-25.1-15.1-15.1-49.8 19L75.3 459.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.6-1.6 3.5-2.8 5.6-3.6l39.6-15.1L98.8 354.8 73.1 365.6 43.3 395.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.5-1.5 3.2-2.6 5.2-3.5L80 328v-8c0-5.4 .3-10.8 1-16H48c-2.5 0-4.9-.6-7.2-1.7l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2L51.8 272H89.3c3.9-9.7 9-18.8 15-27.1L32.2 203.7C12.3 192.3 0 171.1 0 148.1V112C0 50.1 50.1 0 112 0h64c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-64 48c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4L128 32H112zM304 224H208c-53 0-96 43-96 96v2.7L205.3 416H306.7L400 322.7V320c0-53-43-96-96-96z"]
};
var faBoxOpenFull = {
  prefix: 'fal',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M256 32c53 0 96 43 96 96c0 8.8 7.2 16 16 16s16-7.2 16-16C384 57.3 326.7 0 256 0S128 57.3 128 128c0 8.8 7.2 16 16 16s16-7.2 16-16c0-53 43-96 96-96zM80.4 161.5c-14.1-1.6-27.5 6.2-33.1 19.2l-32 74.7C5.4 278.2 18.7 304.4 43 310l159.2 36.7c18.9 4.4 38.6-3.1 49.9-18.9L320 232.9l67.9 95.1c11.3 15.8 31 23.2 49.9 18.9L597 310c24.3-5.6 37.6-31.8 27.8-54.7l-32-74.7c-5.6-13-19-20.8-33.1-19.2L320 189.2 80.4 161.5zm-3.7 31.8l214.5 24.8-65.1 91.2c-3.8 5.3-10.3 7.7-16.6 6.3L50.2 278.9c-4.9-1.1-7.5-6.4-5.6-10.9l32-74.7zM544 348.7v61.8c0 7.3-5 13.7-12.1 15.5L336 475V336c0-8.8-7.2-16-16-16s-16 7.2-16 16V475L108.1 426C101 424.3 96 417.9 96 410.5V348.7l-32-9.1v71c0 22 15 41.2 36.4 46.6l208 52c7.6 1.9 15.6 1.9 23.3 0l208-52c21.4-5.3 36.4-24.5 36.4-46.6v-71l-32 9.1zM348.8 218.1l214.5-24.8 32 74.7c2 4.6-.7 9.8-5.6 10.9L430.6 315.6c-6.3 1.5-12.9-1-16.6-6.3l-65.1-91.2zm146.4-181c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-32 96c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l32-96z"]
};
var faBoxFull = faBoxOpenFull;
var faFile = {
  prefix: 'fal',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
};
var faGreaterThan = {
  prefix: 'fal',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", "M1.7 72.8c-4 7.9-.7 17.5 7.2 21.5L332.2 256 8.8 417.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l352-176c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-352-176c-7.9-4-17.5-.7-21.5 7.2z"]
};
var faQuotes = {
  prefix: 'fal',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M0 88C0 39.4 39.4 0 88 0h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H88C57.1 32 32 57.1 32 88V98.7C37 97 42.4 96 48 96H80c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-8V144 88zm32 56v24 8c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM160 88c0-48.6 39.4-88 88-88h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8c-30.9 0-56 25.1-56 56V98.7c5-1.8 10.4-2.7 16-2.7h32c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48v-8V144 88zm32 80v8c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v24zM576 424c0 48.6-39.4 88-88 88h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c30.9 0 56-25.1 56-56V413.3c-5 1.8-10.4 2.7-16 2.7H496c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v8 24 56zm-32-56V344v-8c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM416 424c0 48.6-39.4 88-88 88h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c30.9 0 56-25.1 56-56V413.3c-5 1.8-10.4 2.7-16 2.7H336c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v8 24 56zm-32-80v-8c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V344z"]
};
var faPretzel = {
  prefix: 'fal',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M149.4 64C84.6 64 32 116.6 32 181.4c0 64.6 28 122.7 72.7 162.8l27.6-39.9C100.1 273.3 80 229.7 80 181.4c0-38.3 31.1-69.4 69.4-69.4H156c42 0 76 34 76 76v3.6c0 16.2-4.9 32-14.2 45.3l-18.2 26.3-33 47.6 0 0-45.6 65.8 0 0L92.3 418.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1l34.5-49.8c4-5.8 11.3-8.3 18-6.1c20.9 6.7 43.2 10.3 66.4 10.3H256h5.4c15.5 0 30.6-1.6 45.1-4.7l-30.4-44c-4.8 .4-9.7 .6-14.7 .6H256h-5.4c-8.4 0-16.6-.6-24.7-1.8c-5.5-.8-10.2-4.4-12.4-9.4s-1.6-10.9 1.5-15.5l27.8-40.1c3-4.3 7.9-6.9 13.2-6.9s10.2 2.6 13.2 6.9l13 18.8 14.7 21.3 48.9 70.6 34.5 49.8 0 0c7.5 10.9 22.5 13.6 33.4 6.1s13.6-22.5 6.1-33.4l-28.8-41.6c-4.9-7-3.4-16.6 3.4-21.8C446.5 315 480 252.1 480 181.4C480 116.6 427.4 64 362.6 64H356c-34.7 0-66 14.2-88.6 37.2c-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8C222 78.2 190.7 64 156 64h-6.6zM326.1 423.6c-20.6 5.5-42.3 8.4-64.7 8.4H256h-5.4c-22.3 0-44-2.9-64.7-8.4L158 463.9c-17.6 25.4-52.5 31.8-77.9 14.2S48.4 425.6 66 400.1l0 0 20.4-29.5C33.5 324.7 0 257 0 181.4C0 98.9 66.9 32 149.4 32H156c38 0 72.9 13.6 100 36.3C283.1 45.6 318 32 356 32h6.6C445.1 32 512 98.9 512 181.4c0 75.6-33.5 143.3-86.3 189.3L446 400.1c17.6 25.4 11.3 60.3-14.2 77.9s-60.3 11.3-77.9-14.2l0 0-27.9-40.3zM173.3 245l18.2-26.3c5.5-8 8.5-17.4 8.5-27.1V188c0-24.3-19.7-44-44-44h-6.6c-20.7 0-37.4 16.7-37.4 37.4c0 37.3 14.8 71.2 38.8 96.2L173.3 245zM356 144c-24.3 0-44 19.7-44 44v3.6c0 9.7 3 19.1 8.5 27.1l40.7 58.8c24-24.9 38.8-58.8 38.8-96.2c0-20.7-16.7-37.4-37.4-37.4H356zm-76 44c0-42 34-76 76-76h6.6c38.3 0 69.4 31.1 69.4 69.4c0 53.7-24.8 101.5-63.5 132.8c-3.5 2.8-7.9 4-12.3 3.4s-8.3-3.1-10.9-6.7L294.2 237c-9.2-13.3-14.2-29.1-14.2-45.3V188z"]
};
var faPersonSwimming = {
  prefix: 'fal',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", "M104 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm29.8 122.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 384.1 0 390.4 0 398.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 401.9 161.7 416 192 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 401.9 353.7 416 384 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 374 404.9 384 384 384s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 374 212.9 384 192 384s-41.7-9.9-58.2-21.2zM258.4 185L412.3 315.5c10.7-3.5 21.4-8.8 30.9-15.4l.2-.2-163-138.3C309.5 140.5 345.3 128 384 128h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-114.9 0-208 93.1-208 208v14.8c5.5 1.1 10.9 1.7 16 1.7c5.4 0 10.7-.5 16-1.6V304c0-46.8 18.3-89.4 48.1-121l2.3 2z"]
};
var faSwimmer = faPersonSwimming;
var faArrowDown = {
  prefix: 'fal',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M180.7 475.3c6.2 6.2 16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 425.4 208 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4L27.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176z"]
};
var faUserRobotXmarks = {
  prefix: 'fal',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H144c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H240V16zM96 144c0-26.5 21.5-48 48-48H304c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H240V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H176V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c-26.5 0-48-21.5-48-48V144zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM96 384H352c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16H368V448c0-17.7-14.3-32-32-32H288 224 160 112c-17.7 0-32 14.3-32 32v32H48c-8.8 0-16-7.2-16-16V448c0-35.3 28.7-64 64-64zm16 64h32v32H112V448zm96 0v32H176V448h32zm16 64h64 48 32 32c26.5 0 48-21.5 48-48V448c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48H80h32 48 64zm16-64h32v32H240V448zm96 0v32H304V448h32zM137.3 118.7c-5.2-5.2-13.5-5.2-18.7 0s-5.2 13.5 0 18.7L141.3 160l-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0L160 178.7l22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L178.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L160 141.3l-22.7-22.7zm109.3 0c-5.2 5.2-5.2 13.5 0 18.7L269.3 160l-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0L288 178.7l22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L306.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L288 141.3l-22.7-22.7c-5.2-5.2-13.5-5.2-18.7 0z"]
};
var faMessageQuote = {
  prefix: 'fal',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM208 144v24 24H160V144h48zm-48 80h48c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 290.7 240 258.7 240 222V192 168 144c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm144-80h48v24 24H304V144zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 290.7 384 258.7 384 222V192 168 144c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48z"]
};
var faCommentAltQuote = faMessageQuote;
var faCandyCorn = {
  prefix: 'fal',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", "M480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 20.1-7 52-15.6 84c-9.1 33.8-21.4 73-34.7 110.4c-13.2 37.2-27.9 73.6-41.6 101.3c-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3C357 213 344.7 173.8 335.6 140C327 108 320 76.1 320 56c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM602.6 48.4C564.9 36.1 522.3 32 480 32c-42.1 0-84.4 4.2-122.2 16.3C354.2 49.6 352 53 352 56c0 13.3 4.4 36.2 11.3 63.4c1.2-.2 2.6-.3 4.1-.5c6.2-.8 15.2-1.8 26.2-2.8c22-2 52.6-4.1 86.4-4.1s64.3 2 86.4 4.1c11 1 20 2 26.2 2.8c1.6 .2 2.9 .4 4.1 .5C603.6 92.2 608 69.3 608 56c0-3.4-2.2-6.5-5.4-7.6zM371.8 150.6c8.1 28.2 18.1 59.3 28.7 89.1l1.3 3.7c21.1-1.8 48.4-3.4 78.2-3.4s57.1 1.6 78.2 3.4l1.3-3.7c10.6-29.8 20.6-60.9 28.7-89.1c-5.9-.7-14.4-1.7-24.8-2.6c-21.4-2-50.9-3.9-83.4-3.9s-62.1 2-83.4 3.9c-10.4 1-18.9 1.9-24.8 2.6zm68.8 186.9c6.9 13.8 13.5 26.4 21.5 35.7c7.6 8.8 13.1 10.9 17.9 10.9s10.4-2.1 17.9-10.9c8-9.2 14.6-21.8 21.5-35.7c8.8-17.6 18.1-39.3 27.2-62.9c-19-1.4-41.9-2.5-66.6-2.5s-47.6 1.1-66.6 2.5c9.1 23.6 18.4 45.3 27.2 62.9zM85.1 203.3c31.2-31.2 67-61 106.6-81c15.4-7.7 34-4.7 46.2 7.5c14.2 14.2 31.8 41.8 48.3 70.4c17.5 30.3 36.5 66.8 53.6 102.6c16.9 35.7 32.4 71.8 42.2 101c9.6 28.6 22.2 68.7-2.7 93.6s-65 12.2-93.6 2.7c-29.3-9.8-65.4-25.2-101-42.2c-35.9-17-72.3-36.1-102.6-53.5c-28.7-16.5-56.2-34.2-70.4-48.3c-12.2-12.2-15-31.2-7.3-46.6c20.3-39.4 49.7-75 80.8-106.2zM206 150.9c-35.4 17.9-68.4 45.2-98.3 75.1C78 255.7 51 288.6 32.9 323.9c-1.7 3.4-.8 7.4 1.4 9.5c9.4 9.4 28.8 22.5 52.8 36.8c.7-1 1.6-2.1 2.6-3.3c3.8-4.9 9.5-12 16.5-20.5c14.2-17 34.3-40 58.2-63.9s46.9-44 63.9-58.2c8.5-7.1 15.6-12.7 20.5-16.5c1.2-1 2.3-1.8 3.3-2.6c-14.3-24.1-27.4-43.4-36.8-52.8c-2.4-2.4-6.1-3-9.2-1.5zm-91 235.4c25.7 14.2 54.7 29.1 83.3 42.7l3.5 1.7c13.7-16.2 31.9-36.6 52.9-57.7s41.5-39.2 57.7-52.9l-1.7-3.5c-13.6-28.6-28.5-57.6-42.7-83.3c-4.7 3.7-11.4 9-19.4 15.7c-16.5 13.7-38.7 33.2-61.8 56.2s-42.5 45.3-56.2 61.8c-6.7 8.1-12 14.7-15.7 19.4zm180.8 83.5c14.7 4.9 28.2 9.1 40.4 10c11.6 .9 17-1.6 20.4-5s5.8-8.8 5-20.4c-.9-12.2-5.1-25.7-10-40.4c-6.3-18.6-15.1-40.6-25.3-63.7c-14.4 12.4-31.4 27.8-48.9 45.3s-32.9 34.5-45.3 48.9c23.1 10.2 45.1 19 63.7 25.3z"]
};
var faFolderMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zM240 208a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160c20.7 0 39.9-6.6 55.6-17.7l45.1 45.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-45.1-45.1C329.4 311.9 336 292.7 336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96z"]
};
var faFolderSearch = faFolderMagnifyingGlass;
var faNotebook = {
  prefix: 'fal',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M192 32H128c-17.7 0-32 14.3-32 32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v48c0 17.7 14.3 32 32 32h64V32zm32 448H416c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224V480zm-16 32H128c-35.3 0-64-28.7-64-64V400H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V144H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V64C64 28.7 92.7 0 128 0h80H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H208z"]
};
var faDroplet = {
  prefix: 'fal',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"]
};
var faTint = faDroplet;
var faBullseyePointer = {
  prefix: 'fal',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M256 480c123.7 0 224-100.3 224-224S379.7 32 256 32S32 132.3 32 256c0 10.4 .7 20.6 2.1 30.6l-9.6 3.5c-7.8 2.9-14.7 7.7-19.9 13.9C1.5 288.5 0 272.4 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-16.4 0-32.5-1.5-48.1-4.5c6.2-5.3 11-12.1 13.9-19.9l3.5-9.6c10 1.4 20.2 2.1 30.6 2.1zm-7.7-64.2L260 383.9c68.8-2.1 124-58.6 124-127.9c0-70.7-57.3-128-128-128c-69.3 0-125.8 55.1-127.9 124L96.2 263.7c-.1-2.6-.2-5.1-.2-7.7c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-2.6 0-5.2-.1-7.7-.2zM271 261.5l-79.2 215c-2.3 6.2-8.1 10.3-14.7 10.5s-12.6-3.8-15.1-9.9l-30.5-74L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L108.9 380.5 34.9 350c-6.1-2.5-10-8.5-9.9-15.1s4.3-12.4 10.5-14.7l215-79.2c5.9-2.2 12.4-.7 16.8 3.7s5.9 11 3.7 16.8zM143.3 360c3.9 1.6 7.1 4.8 8.7 8.7l24 58.2L229 283 85.1 336l58.2 24z"]
};
var faEraser = {
  prefix: 'fal',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", "M353 74.3c-9.4-9.4-24.6-9.4-33.9 0l-111 111L390.6 368l111-111c9.4-9.4 9.4-24.6 0-33.9L353 74.3zM74.3 319c-9.4 9.4-9.4 24.6 0 33.9l88 88c4.5 4.5 10.6 7 17 7H300.7c6.4 0 12.5-2.5 17-7L368 390.6 185.4 208 74.3 319zM296.4 51.7c21.9-21.9 57.3-21.9 79.2 0L524.3 200.4c21.9 21.9 21.9 57.3 0 79.2L355.9 448H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v-.1c-1.1 .1-2.2 .1-3.3 .1H179.3c-14.9 0-29.1-5.9-39.6-16.4l-88-88c-21.9-21.9-21.9-57.3 0-79.2L296.4 51.7z"]
};
var faHexagonImage = {
  prefix: 'fal',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32l29.6 51.3L116 280.6c15.4-15.4 40.4-15.6 56.1-.5l55.3 53.4 95.4-101.8c15.8-16.9 42.6-16.9 58.4 0l68.3 72.8L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zm92 191.3l69.8-74.4-55.6-53.8c-3.1-3-8.1-3-11.2 .1L89.9 352l45.8 79.4zm297.1-97.8l-74.9-79.9c-3.2-3.4-8.5-3.4-11.7 0L164.1 447.8H348.3c11.4 0 22-6.1 27.7-16l56.8-98.3zM208 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faEarthAmericas = {
  prefix: 'fal',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M256 480C132.3 480 32 379.7 32 256c0-11.8 .9-23.3 2.7-34.6l3 6.7c9.3 21 27.3 37 49.2 43.9l63 19.7c15.5 4.9 26.1 19.2 26.1 35.5v15c0 17 9.6 32.6 24.8 40.2c4.4 2.2 7.2 6.7 7.2 11.6v22.7c0 26.2 21.2 47.4 47.4 47.4c21.8 0 40.7-14.8 46-35.9l4.4-17.6c2.6-10.2 9.2-19 18.3-24.2l11.6-6.6c19.9-11.4 32.2-32.6 32.2-55.6v-8.3c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-12-12-28.3-18.7-45.3-18.7H251.3c-5 0-9.9-1.2-14.3-3.4l-45.9-22.9c-2.1-1-3.8-2.7-4.8-4.8l-.7-1.4c-2.3-4.6-.4-10.2 4.2-12.5c2.2-1.1 4.8-1.3 7.1-.5l24.2 8.1c15 5 31.5-.7 40.3-13.8c8.6-12.9 7.7-30-2.2-41.9l-17.9-21.5c-2.5-3-2.5-7.4 .1-10.3l20.1-23.5c13.2-15.4 15.3-37.4 5.2-55.1L259.6 32C337.1 33.2 405 73.8 444.3 134.6l-38.2 15.3c-23.6 9.4-35.7 35.6-27.7 59.7l16.9 50.7c5.2 15.6 18 27.4 33.9 31.4L475 303.2C453.3 404.3 363.5 480 256 480zM48 172.7C77.3 99.7 143.8 45.7 224 34.3l14.9 26.1c3.4 5.9 2.7 13.2-1.7 18.4l-20.1 23.5c-12.7 14.8-12.9 36.6-.4 51.6l17.9 21.5c.9 1.1 1 2.6 .2 3.7c-.8 1.2-2.2 1.7-3.6 1.2L207 172.1c-10.4-3.5-21.7-2.7-31.5 2.2c-20.4 10.2-28.7 35-18.5 55.4l.7 1.4c4.1 8.3 10.9 15 19.2 19.2l45.9 22.9c8.9 4.4 18.7 6.8 28.6 6.8h48.8c8.5 0 16.6 3.4 22.6 9.4l3.9 3.9c6 6 9.4 14.1 9.4 22.6v8.3c0 11.5-6.2 22.1-16.1 27.8l-11.6 6.6c-16.7 9.6-28.8 25.5-33.5 44.2l-4.4 17.6c-1.7 6.9-7.9 11.7-15 11.7c-8.5 0-15.4-6.9-15.4-15.4V393.9c0-17-9.6-32.6-24.8-40.2c-4.4-2.2-7.2-6.7-7.2-11.6v-15c0-30.3-19.7-57-48.6-66.1l-63-19.7c-13.2-4.1-23.9-13.7-29.5-26.3L48 172.7zM480 256c0 5.2-.2 10.3-.5 15.4l-42.6-10.6c-5.3-1.3-9.6-5.3-11.3-10.5l-16.9-50.7c-2.7-8 1.4-16.8 9.2-19.9l41.8-16.7c13 28.3 20.2 59.9 20.2 93.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faCrateApple = {
  prefix: 'fal',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M219.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM75 126c6.3-10.4 13.1-14 21-14c9.3 0 23.1 3.9 35.6 8.8c18.2 7.1 38.5 7.1 56.7 0c12.5-4.9 26.4-8.8 35.6-8.8c7.9 0 14.7 3.6 21 14c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6h32.3c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6H65.5c-1-6.6-1.5-13.4-1.5-20.6c0-17.5 4.2-34.2 11-45.5zm403.7 66c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0c-12.4-4.8-29.6-10.3-44.6-11c3.4 4 6.4 8.3 9 12.7c4.5 7.4 8.2 15.3 11.1 23.6c4.3 1.3 8.6 2.8 12.8 4.5c18.2 7.1 38.5 7.1 56.7 0c12.5-4.9 26.4-8.8 35.6-8.8c7.9 0 14.7 3.6 21 14c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6h32.3zM32 384H480v72c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V384zm0-32V280c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v72H32zm480 0V280c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v72 16 16 72c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V384 368 352zM96 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAppleCrate = faCrateApple;
var faPersonBurst = {
  prefix: 'fal',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM467.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H448V164c6-2.6 12.5-4 19.3-4zM448 496V352h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L563.3 170.3c-13.9-26-41-42.3-70.6-42.3H467.3c-29.5 0-56.6 16.3-70.6 42.3L337.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L416 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6L222.6 87.2 190.5 17.3zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z"]
};
var faGameBoard = {
  prefix: 'fal',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 16v32h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H240v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V272H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V112c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128h64V176H144v64zm96 0h64V176H240v64zm0 32v64h64V272H240zm-32 0H144v64h64V272z"]
};
var faHatChef = {
  prefix: 'fal',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M170.9 83.4C187 52.8 219.1 32 256 32s69 20.8 85 51.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 13.9-5.5C379.1 72.7 396.5 64 416 64c35.3 0 64 28.7 64 64c0 4-.4 7.8-1 11.6l-.1 .5c-3.5 22.8-14.2 58.4-26.1 93.5c-11.8 34.7-24.3 67.7-31 84.7c-.4 1-1.4 1.8-2.8 1.8H373.8l25.9-141.1c1.6-8.7-4.2-17-12.8-18.6s-17 4.2-18.6 12.8l-26.4 144c-.2 1-.3 1.9-.3 2.9H272V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V320H170.4c0-1-.1-1.9-.3-2.9l-26.4-144c-1.6-8.7-9.9-14.4-18.6-12.8s-14.4 9.9-12.8 18.6L138.2 320H93c-1.4 0-2.4-.8-2.8-1.8c-6.6-17-19.2-50-31-84.7C47.3 198.4 36.6 162.8 33.1 140l-.1-.5c-.7-3.7-1-7.6-1-11.6c0-35.3 28.7-64 64-64c19.5 0 36.9 8.7 48.6 22.4c3.5 4 8.7 6.1 13.9 5.5s9.9-3.8 12.4-8.5zM256 0c-41.9 0-79.1 20.1-102.4 51.2c-16-12-36-19.2-57.6-19.2C43 32 0 75 0 128c0 5.8 .5 11.5 1.5 17.1c4 25.9 15.6 63.8 27.4 98.7c12 35.3 24.7 68.8 31.4 86C65.6 343.4 78.7 352 93 352H419c14.3 0 27.4-8.6 32.6-22.2c6.7-17.2 19.4-50.7 31.4-86c11.8-34.9 23.4-72.8 27.4-98.7c1-5.5 1.5-11.2 1.5-17.1c0-53-43-96-96-96c-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0zM64 384v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384H416v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64z"]
};
var faHandBackPointRight = {
  prefix: 'fal',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 168c0-30.9-25.1-56-56-56l-200.6 0c-2-3.2-4.2-6.4-6.5-9.5L232 80c-15.1-20.1-38.8-32-64-32l-19.5 0c-53 0-101.7 29.1-126.8 75.7L17.2 132C5.9 153 0 176.4 0 200.3L0 336c0 61.9 50.1 112 112 112l8 0 88 0c35.3 0 64-28.7 64-64c0-2.8-.2-5.6-.5-8.3c19.4-11 32.5-31.8 32.5-55.7c0-5.3-.7-10.5-1.9-15.5c20.2-10.8 33.9-32 33.9-56.5c0-8.5-1.7-16.6-4.7-24L456 224c30.9 0 56-25.1 56-56zm-56-24c13.3 0 24 10.7 24 24s-10.7 24-24 24l-157.5 0c-7.1 0-13.3 4.6-15.3 11.4s.6 14 6.5 18c8.7 5.8 14.3 15.6 14.3 26.7c0 15.6-11.2 28.6-25.9 31.4c-5.1 1-9.5 4.4-11.6 9.2s-1.8 10.3 .9 14.8c2.9 4.8 4.6 10.5 4.6 16.6c0 14.7-10 27.2-23.6 30.9c-4.4 1.2-8.1 4.2-10.1 8.3s-2.2 8.8-.6 13.1c1.4 3.6 2.2 7.6 2.2 11.8c0 17.7-14.3 32-32 32l-88 0-8 0c-44.2 0-80-35.8-80-80l0-135.7c0-18.5 4.6-36.8 13.4-53.1l-14.1-7.6 14.1 7.6 4.5-8.3C69.4 102.6 107.3 80 148.5 80L168 80c15.1 0 29.3 7.1 38.4 19.2L216 112l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l78.3 0 1.7 0 208 0z"]
};
var faDove = {
  prefix: 'fal',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", "M273 128.8c-.7 5-1 10.1-1 15.2l0 21.6c-5.2-1.6-10.5-3.4-15.9-5.3c-22.5-30-40.1-66.5-45.7-109.4c-9.9 15.5-21.1 37.2-30.5 65c-9.1-8.3-17.2-17.4-24-27.5C171 50.2 188.8 23.8 201.2 9.3c5.2-6 13.4-7.8 21-5.8c10.9 2.9 18 13.1 18.4 24.4c1.3 38.9 13.9 72.5 32.4 100.8zM64.7 42.2C68.8 35.5 76 32 83.2 32c10.7 0 19.3 7.6 21.5 17.2c12.8 56.5 50.9 94.7 94.7 119.9c36.2 20.8 75.4 32.1 104.7 36.8l0-61.9c0-44.2 35.8-80 80-80h99.7C499.3 64 512 76.7 512 92.3c0 5.6-1.7 11-4.7 15.7L480 148.8V288c0 88.4-71.6 160-160 160H248.6l-78.9 60.7c-2.8 2.2-6.2 3.3-9.8 3.3C77.3 512 21.7 466.2 3.2 441.6c-3-4.1-4-9.3-2.5-14.2s5.1-8.7 9.9-10.5l123-44.3C89.2 341.3 32 282.5 32 184C32 108.2 52 62.6 64.7 42.2zM80.9 81.6C72.5 103 64 136.5 64 184c0 103.8 74 156.5 113.7 178.6c5.5 3.1 8.7 9 8.2 15.3s-4.6 11.6-10.5 13.8l-130.7 47c21.4 18.2 59.2 39.8 110 41.2l78.8-60.6c2.8-2.2 6.2-3.3 9.8-3.3H320c70.7 0 128-57.3 128-128V144c0-3.2 .9-6.2 2.7-8.9L476.8 96H384c-26.5 0-48 21.5-48 48l0 80c0 4.5-1.9 8.7-5.2 11.8s-7.7 4.5-12.2 4.2c-33.6-2.8-86.6-15.1-135.3-43c-42.5-24.4-82.7-61.4-102.5-115.3zM360 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSnowflakeDroplets = {
  prefix: 'fal',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V89.4L267.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L304 134.6v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l13.4 50.1-63.5-36.7c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L117.6 200c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l81-21.7L288 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S109 309.7 117.6 312l50.1 13.4-45.1 26L137.2 380l46.5-26.8-13.4 50.1c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81L304 283.7v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 422.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V422.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L336 377.4V283.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1L502.8 380l14.7-28.5-45.1-26L522.4 312c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L352 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81L336 228.3V134.6l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L336 89.4V16zM576 377.5l28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9c0 17.9-14.5 32.3-32 32.3s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9L576 377.5zm-18-35l-38.9 75.6c-4.7 9.1-7.1 19.3-7.1 29.5c0 35.3 28.7 64.3 64 64.3s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L594 342.5l-.1-.1-1.9-3.7-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1 .1zM35.6 432.8L64 377.5l28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9C96 465.6 81.5 480 64 480s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9zM7.1 418.1C2.4 427.2 0 437.4 0 447.7C0 483 28.7 512 64 512s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L82 342.5l-.1-.1L80 338.7l-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1 .1L7.1 418.1z"]
};
var faBatteryEmpty = {
  prefix: 'fal',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", "M80 128c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H80zM0 176c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm560 16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16z"]
};
var faBattery0 = faBatteryEmpty;
var faGrid4 = {
  prefix: 'fal',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M24 97.6V56H65.6V97.6H24zm0 119.5V175.5H65.6v41.6H24zm0 119.5V294.9H65.6v41.6H24zM24 456V414.4H65.6V456H24zM16 32C7.2 32 0 39.2 0 48v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H16zM0 286.9v57.6c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 390.4c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H16zM143.5 97.6V56h41.6V97.6H143.5zm0 119.5V175.5h41.6v41.6H143.5zm0 119.5V294.9h41.6v41.6H143.5zm0 119.5V414.4h41.6V456H143.5zm-8-424c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H135.5zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H135.5zm-16 135.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H135.5c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H135.5zM262.9 56h41.6V97.6H262.9V56zm0 119.5h41.6v41.6H262.9V175.5zm0 119.5h41.6v41.6H262.9V294.9zm0 119.5h41.6V456H262.9V414.4zM238.9 48v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm0 119.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H254.9zm-16 135.5V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16zM382.4 97.6V56H424V97.6H382.4zm0 119.5V175.5H424v41.6H382.4zm0 119.5V294.9H424v41.6H382.4zm0 119.5V414.4H424V456H382.4zm-8-424c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H374.4zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V167.5c0-8.8-7.2-16-16-16H374.4zm-16 135.5v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V286.9c0-8.8-7.2-16-16-16H374.4c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V406.4c0-8.8-7.2-16-16-16H374.4z"]
};
var faSocks = {
  prefix: 'fal',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M140.8 465.9C129 475 114.4 480 99.5 480H96c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C143.4 300.4 160 267.3 160 232V128H288V96H160V48c0-8.8 7.2-16 16-16H289.6C292 20.2 297 9.4 303.9 .1c-1-.1-2-.1-3-.1H176c-26.5 0-48 21.5-48 48V232c0 25.2-11.9 48.9-32 64L38.4 339.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96h3.5c22 0 43.4-7.3 60.8-20.8l16.1-12.4c-5.4-9.6-9.6-19.9-12.4-30.8H164l-23.2 17.9zM368 0c-26.5 0-48 21.5-48 48V232c0 25.2-11.9 48.9-32 64l-57.6 43.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96h3.5c22 0 43.4-7.3 60.8-20.8l116.1-89.7c27.4-21.2 43.5-53.9 43.5-88.6V48c0-26.5-21.5-48-48-48H368zM352 48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16V96H352V48zm0 80H480V312.9c0 24.8-11.5 48.2-31.1 63.3L332.8 465.9C321 475 306.4 480 291.5 480H288c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C335.4 300.4 352 267.3 352 232V128z"]
};
var faFaceSunglasses = {
  prefix: 'fal',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", "M256 480C132.3 480 32 379.7 32 256c0-16.4 1.8-32.5 5.1-47.9l4.4 26.4c5.1 30.9 31.8 53.5 63.1 53.5h78.7c31.3 0 58-22.6 63.1-53.5l8-48c.6-3.5 .9-7.1 .9-10.5h1.3c0 3.5 .3 7 .9 10.5l8 48c5.1 30.9 31.8 53.5 63.1 53.5h78.7c31.3 0 58-22.6 63.1-53.5l4.4-26.4c3.4 15.4 5.1 31.5 5.1 47.9c0 123.7-100.3 224-224 224zm-9.2-336c-11-19-31.5-32-55.4-32H96.7c-4.6 0-9.1 .5-13.4 1.4C124.3 63.7 186.5 32 256 32s131.7 31.7 172.8 81.4c-4.3-.9-8.8-1.4-13.4-1.4H320.7c-24 0-44.5 13-55.4 32H246.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM289.1 181.3c-3.3-19.5 11.8-37.3 31.6-37.3h40.7l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4L316 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48zM358.6 256l52.7-52.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H374.6l32-32h8.7c19.8 0 34.8 17.8 31.6 37.3l-8 48C436.3 244.7 423 256 407.3 256H358.6zM96.7 144h40.7l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4L92 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48C61.8 161.8 76.9 144 96.7 144zm90.7 59.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H150.6l32-32h8.7c19.8 0 34.8 17.8 31.6 37.3l-8 48C212.3 244.7 199 256 183.3 256H134.6l52.7-52.7z"]
};
var faInbox = {
  prefix: 'fal',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M32 416V327.9c0-2.6 .3-5.2 1-7.8l0-.1H134.1l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7H326.1c12.1 0 23.2-6.8 28.6-17.7L377.9 320H479l0 .1c.6 2.5 1 5.1 1 7.8V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM471 288H377.9c-12.1 0-23.2 6.8-28.6 17.7L326.1 352H185.9l-23.2-46.3c-5.4-10.8-16.5-17.7-28.6-17.7H41L90.9 88.2C94.5 74 107.3 64 122 64H390c14.7 0 27.5 10 31 24.2L471 288zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
};
var faSquare0 = {
  prefix: 'fal',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-64 96v64c0 35.3 28.7 64 64 64s64-28.7 64-64V224c0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
};
var faSection = {
  prefix: 'fal',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M32.5 84.7c3.6-20.1 16.3-34.6 36.9-43.4c21.2-9.1 50.6-11.9 84.4-6.6c10.7 1.7 43.5 8.1 54 10.9c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-12-3.2-46-9.8-57.3-11.6C121-2.9 85.1-.3 56.7 11.9C27.8 24.3 6.5 47 .9 79.7c0 .3-.1 .6-.1 .8c-2.2 19 .4 35.7 7.6 50c7.1 14.2 18.1 25 30.7 33.6c4.6 3.1 9.6 6 14.7 8.7c-26.7 12-46.7 33-52.1 63.1c-.1 .3-.1 .6-.1 .9c-2.3 18.3 .4 34.3 7.8 48.1c7.2 13.6 18.3 23.9 30.8 32c23.3 15 54.8 24 83.1 32.1l3.3 .9c30.8 8.8 57.7 16.8 75.9 29.5c8.7 6.1 14.6 12.7 18 20.3c3.3 7.5 4.8 17.2 2.3 30.6c-3.4 18.5-15.7 32.3-36.5 40.8c-21.3 8.7-50.7 11.3-84.4 6.3c-16.9-2.6-45.6-11.9-67.8-19.1l0 0 0 0c-4.8-1.5-9.2-3-13.2-4.3c-8.4-2.7-17.4 2-20.1 10.4s2 17.4 10.4 20.1c3.4 1.1 7.4 2.4 11.8 3.8C44.9 495.5 77.2 506 97 509.1l.1 0c37.5 5.6 73.1 3.2 101.3-8.3c28.6-11.7 50.2-33.2 55.9-64.7c3.4-18.6 1.8-35-4.6-49.4c-6.3-14.3-16.8-25.1-28.9-33.6c-1.7-1.2-3.5-2.4-5.4-3.5c20-13.1 34.4-32.5 38.9-58.7c3.3-19.4 1.8-36.4-4.5-51.3c-6.2-14.8-16.6-26.2-28.8-35.2c-23.6-17.4-56.4-27.3-85.9-36.1l-.5-.1c-30.8-9.3-58.3-17.5-77.6-30.6c-9.4-6.3-16-13.4-20.1-21.4c-4-7.9-6-17.9-4.5-31.5zM178 332.3c-14.1-5.1-28.8-9.3-42.7-13.2l-.5-.1 0 0c-30.7-8.7-58.1-16.6-77.4-29c-9.3-6-15.9-12.6-19.8-20c-3.8-7.2-5.8-16.3-4.3-28.8c3.5-18.3 15.8-32 36.4-40.4c10.1-4.1 22-6.9 35.4-8.1c5.9 1.8 11.8 3.6 17.5 5.3l0 0 3.3 1c30.9 9.3 57.9 17.8 76.1 31.2c8.7 6.4 14.8 13.5 18.3 21.8c3.5 8.2 4.9 18.9 2.5 33.4c-3.8 22.2-19.1 38.5-44.8 46.8z"]
};
var faSquareThisWayUp = {
  prefix: 'fal',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 368H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-256c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V170.6l-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5zm160 0c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V170.6l-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5z"]
};
var faBoxUp = faSquareThisWayUp;
var faGaugeHigh = {
  prefix: 'fal',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm344-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faSquareAmpersand = {
  prefix: 'fal',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 88c0 6.2 2.4 12.1 6.6 16.6l22.1 23.3 21.8-15C235 203 240 193.5 240 183.2c0-12.8-10.4-23.2-23.2-23.2H200c-13.3 0-24 10.7-24 24zm68.7 51.2l-17.5 12.1 45.4 47.7L307 246.7c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-38 53.2L331.6 357c6.1 6.4 5.8 16.5-.6 22.6s-16.5 5.8-22.6-.6l-32.4-34-6.3 8.8c-13.5 18.9-35.3 30.2-58.6 30.2h-36c-34.9 0-63.2-28.3-63.2-63.2c0-20.8 10.2-40.3 27.4-52.1l38.7-26.6-18.6-19.5C149.5 212.2 144 198.4 144 184c0-30.9 25.1-56 56-56h16.8c30.5 0 55.2 24.7 55.2 55.2c0 20.8-10.2 40.2-27.3 52zm-87.1 59.9c-8.5 5.8-13.5 15.4-13.5 25.7c0 17.2 14 31.2 31.2 31.2h36c12.9 0 25-6.2 32.5-16.8l9.8-13.8-53.2-55.8-42.9 29.5z"]
};
var faEnvelopeOpenText = {
  prefix: 'fal',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M392 32H120c-13.3 0-24 10.7-24 24V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zM176 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faLampDesk = {
  prefix: 'fal',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M381.3 96L480 96 288 288V189.3c0-8.5-3.4-16.6-9.4-22.6l-38.1-38.1C230 118 224 103.6 224 88.6C224 57.3 249.3 32 280.6 32c15 0 29.4 6 40 16.6l38.1 38.1c6 6 14.1 9.4 22.6 9.4zm0-32L343.2 25.9C326.6 9.3 304.1 0 280.6 0C231.7 0 192 39.7 192 88.6c0 21.7 7.9 42.5 22.2 58.6l-97.5 97.5c-4 4-5.6 9.9-4.1 15.4L171.2 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H192 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H204.3L145.8 260.8l90.8-90.8L256 189.3V288c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l192-192c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H381.3zm-2.6 223.9C391 298 406.8 304 424 304c39.8 0 72-32.2 72-72c0-17.2-6-33-16.1-45.4L457 209.5c4.4 6.4 7 14.2 7 22.5c0 22.1-17.9 40-40 40c-8.4 0-16.1-2.6-22.5-7l-22.8 22.8z"]
};
var faHospital = {
  prefix: 'fal',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M160 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V96h96c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H416v0H352 288 224v0H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96V64zM480 336V480h96c17.7 0 32-14.3 32-32V320H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V224H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V160c0-17.7-14.3-32-32-32H480V336zM160 128H64c-17.7 0-32 14.3-32 32v32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v64h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H32V448c0 17.7 14.3 32 32 32h96V128zM448 336V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32V480h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64V336zm-96 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zM304 64h32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H360v16c0 13.3-10.7 24-24 24H304c-13.3 0-24-10.7-24-24V184H264c-13.3 0-24-10.7-24-24V128c0-13.3 10.7-24 24-24h16V88c0-13.3 10.7-24 24-24zm8 56c0 8.8-7.2 16-16 16H272v16h24c8.8 0 16 7.2 16 16v24h16V168c0-8.8 7.2-16 16-16h24V136H344c-8.8 0-16-7.2-16-16V96H312v24z"]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faPollPeople = {
  prefix: 'fal',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", "M80 48a16 16 0 1 1 32 0A16 16 0 1 1 80 48zm64 0A48 48 0 1 0 48 48a48 48 0 1 0 96 0zM592 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512V64h80zM272 64H480v96H272c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zM592 352c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H384V352H592zm-320 0h80v96H272c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H272zM1.1 486.1L.1 494C-1 502.8 5.2 510.8 14 511.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42h31c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1h-31c-40.3 0-74.4 30-79.4 70.1zm0-288L.1 206C-1 214.8 5.2 222.8 14 223.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42h31c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1h-31c-40.3 0-74.4 30-79.4 70.1zM80 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faWhiskeyGlassIce = {
  prefix: 'fal',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", "M480 64L430 406.9c-3.4 23.6-23.7 41.1-47.5 41.1h-253c-23.8 0-44.1-17.5-47.5-41.1L32 64H480zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM255.4 195.3l.6-.6c-5-1.8-10.4-2.7-16-2.7H144c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h73.8l-19-19c-4-4-7.6-8.4-10.6-13H144c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h82.7l28.7-28.7zm67.9 45.3l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0zm-45.3-22.6l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9L278.1 399c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9l-56.6-56.6c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faGlassWhiskeyRocks = faWhiskeyGlassIce;
var faWineBottle = {
  prefix: 'fal',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6c-4.4 4.4-10.6 5.7-16.1 4l-86.6 86.6c-8 8-10.9 19.6-9.6 30.9c4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l22.6 22.6c-12.5 12.5-12.5 32.8 0 45.3l88 88c12.5 12.5 32.8 12.5 45.3 0l24.7-24.7L66.1 312.7 41.4 337.4 18.7 314.7 180.2 153.3c28.1-28.1 66.3-40.2 103-36.2c11.3 1.2 22.9-1.6 30.9-9.6l86.6-86.6c-1.7-5.5-.4-11.7 4-16.1zM88.7 290.1L221.9 423.3l89.4-89.4L178.1 200.7 88.7 290.1zm112-112L333.9 311.3l2.2-2.2c21-21 30-49.4 27-76.9c-2-18.3 2.3-40.5 18.8-57l13.3-13.3-45.3-45.3L336.7 130c-16.5 16.5-38.7 20.8-57 18.8c-27.5-3-55.9 6-76.9 27l-2.2 2.2zm172-84l45.3 45.3 49.4-49.4L422.1 44.7 372.7 94.1z"]
};
var faChessRook = {
  prefix: 'fal',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", "M64 32C46.3 32 32 46.3 32 64V185.3c0 14 6.1 27.3 16.8 36.4L87.6 255l-5.1 97h32L120 248.8c.3-5-1.8-9.8-5.6-13L69.6 197.4c-3.5-3-5.6-7.5-5.6-12.1V64h80v40c0 8.8 7.2 16 16 16s16-7.2 16-16V64h96v40c0 8.8 7.2 16 16 16s16-7.2 16-16V64h80V185.3c0 4.7-2 9.1-5.6 12.1l-44.8 38.4c-3.8 3.2-5.8 8-5.6 13L333.5 352h32l-5.1-97 38.8-33.3c10.6-9.1 16.8-22.4 16.8-36.4V64c0-17.7-14.3-32-32-32H64zM224 160c-26.5 0-48 21.5-48 48v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v48H208V208zM97.8 416l252.4 0 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H71.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L97.8 416zm252.4-32H97.8c-11.1 0-21.4 5.7-27.2 15.1L37.9 451.8C34.1 458 32 465.2 32 472.6C32 494.3 49.7 512 71.4 512H376.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"]
};
var faUserBountyHunter = {
  prefix: 'fal',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M80 0C71.2 0 64 7.2 64 16V264c0 1 .1 2 .3 3l-.2 3.5c-.8 12 7.5 22.7 19.2 25.1l114.6 22.9c16.2 3.2 36.1 3.2 52.3 0l114.6-22.9c11.8-2.4 20-13.1 19.2-25.1l-8.3-128.2C370.5 62.2 304.1 0 224 0C170.5 0 123.1 27.7 96 70V32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm21.1 193.1c7.3 4.5 15.8 10.5 24.4 17.9c18.8 16.4 36.3 39.1 41.2 68.5l-70.2-14 4.7-72.4zm98.5 93.1c-3.3-45.3-28.9-78.1-53.1-99.2c-13-11.4-25.9-19.7-35.6-25.2c-1.1-.6-2.1-1.2-3.1-1.7H208V287.7c-1.3-.2-2.6-.4-3.9-.7l-4.5-.9zm40.4 1.6V160H340.2c-1 .5-2 1.1-3.1 1.7c-9.7 5.5-22.6 13.9-35.6 25.2c-24.2 21.1-49.8 53.9-53.1 99.2l-4.5 .9c-1.3 .3-2.5 .5-3.9 .7zm41.3-8.2c4.9-29.5 22.4-52.1 41.2-68.5c8.5-7.4 17.1-13.4 24.4-17.9l4.7 72.4-70.2 14zM341.6 128H224 106.4C117.6 72.9 166.3 32 224 32s106.4 40.9 117.6 96zM134.4 384H313.6c54.4 0 98.9 42.4 102.2 96H310.6L241 410.3c-9.4-9.4-24.6-9.4-33.9 0L137.4 480H32.2c3.3-53.6 47.8-96 102.2-96zM224 438.6L265.4 480H182.6L224 438.6zM25.6 512H144 304 422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512z"]
};
var faBarsStaggered = {
  prefix: 'fal',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z"]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faDiagramSankey = {
  prefix: 'fal',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M354.1 64c-5.6 0-10.8 2.9-13.7 7.8L263 200.7c-8.7 14.5-24.3 23.3-41.2 23.3H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H221.9c5.6 0 10.8-2.9 13.7-7.8L313 55.3C321.6 40.8 337.3 32 354.1 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H354.1zM201.7 320l74.5 120.4c2.9 4.7 8.1 7.6 13.6 7.6H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H289.8c-16.6 0-32.1-8.6-40.8-22.7L164 320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H180.9l.7-.4 .3 .4H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H201.7z"]
};
var faCloudHailMixed = {
  prefix: 'fal',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM24 512a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM183.9 370.1c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm192 0c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm-282 21.8c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32z"]
};
var faCircleUpLeft = {
  prefix: 'fal',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 184c0-4.4 3.6-8 8-8H297.4c3.7 0 6.6 3 6.6 6.6c0 1.8-.7 3.4-1.9 4.7l-25.4 25.4c-6.2 6.2-6.2 16.4 0 22.6l59.1 59.1c3.6 3.6 4.9 9 3.3 13.9c-.7 2-1.8 3.8-3.3 5.3l-22.1 22.1c-1.5 1.5-3.3 2.6-5.3 3.3c-4.9 1.6-10.3 .4-13.9-3.3l-59.1-59.1c-6.2-6.2-16.4-6.2-22.6 0l-25.4 25.4c-1.2 1.2-2.9 1.9-4.7 1.9c-3.7 0-6.6-3-6.6-6.6V184zm8-40c-22.1 0-40 17.9-40 40V297.4c0 21.3 17.3 38.6 38.6 38.6c10.2 0 20.1-4.1 27.3-11.3L224 310.6l47.7 47.7c12.2 12.2 30.3 16.5 46.7 11c6.7-2.2 12.8-6 17.8-11l22.1-22.1c5-5 8.8-11.1 11-17.8c5.5-16.4 1.2-34.5-11-46.7L310.6 224l14.1-14.1c7.2-7.2 11.3-17.1 11.3-27.3c0-21.3-17.3-38.6-38.6-38.6H184z"]
};
var faDharmachakra = {
  prefix: 'fal',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M256 0c8.8 0 16 7.2 16 16V48.6c45.4 3.5 86.7 21.5 119.3 49.4L414.4 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414 120.7c27.9 32.6 46 73.9 49.4 119.3H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H463.4c-3.5 45.4-21.5 86.7-49.4 119.3L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L391.3 414c-32.6 27.9-73.9 46-119.3 49.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V463.4c-45.4-3.5-86.7-21.5-119.3-49.4L97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L98 391.3c-27.9-32.6-46-73.9-49.4-119.3H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H48.6c3.5-45.4 21.5-86.7 49.4-119.3L75 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L120.7 98c32.6-27.9 73.9-46 119.3-49.4V16c0-8.8 7.2-16 16-16zM120.7 143.4c-22.2 26.7-36.7 60-40 96.6h80.6c2.4-14.4 8.1-27.9 16.4-39.6l-57-57zm79.6 34.4c11.4-8.1 24.9-13.9 39.6-16.4V80.7c-36.6 3.3-69.9 17.8-96.6 40l57 57zM210.5 211c-11.5 11.6-18.4 27.5-18.5 44.5l0 .5 0 .5c0 3.3 .3 6.7 .9 10.1c2.3 13.5 8.6 25.3 17.6 34.4c.1 .1 .2 .2 .3 .3s.2 .2 .2 .3c11.6 11.5 27.5 18.4 44.5 18.5l.5 0 .5 0c3.3 0 6.7-.3 10.1-.9c13.5-2.3 25.3-8.6 34.4-17.6c.1-.1 .2-.2 .3-.3s.2-.2 .2-.2c14-14.1 21.2-34.5 17.6-55.6c-2.3-13.5-8.6-25.3-17.6-34.4c-.1-.1-.2-.2-.3-.3s-.2-.2-.2-.2c-11.6-11.5-27.5-18.4-44.5-18.5l-.5 0-.5 0c-3.3 0-6.7 .3-10.1 .9c-13.5 2.3-25.3 8.6-34.4 17.6c-.1 .1-.2 .2-.3 .3s-.2 .2-.3 .2zM177.7 311.6c-8.1-11.4-13.9-24.9-16.4-39.6H80.7c3.3 36.6 17.8 69.9 40 96.6l57-57zm-34.4 79.6c26.7 22.2 60 36.7 96.6 40V350.7c-14.4-2.4-27.9-8.1-39.6-16.4l-57 57zm168.3-57c-11.4 8.1-24.9 13.9-39.6 16.4v80.6c36.6-3.3 69.9-17.8 96.6-40l-57-57zm79.6 34.4c22.2-26.7 36.7-60 40-96.6H350.7c-2.4 14.4-8.1 27.9-16.4 39.6l57 57zm-57-168.3c8.1 11.4 13.9 24.9 16.4 39.6h80.6c-3.3-36.6-17.8-69.9-40-96.6l-57 57zm34.4-79.6c-26.7-22.2-60-36.7-96.6-40v80.6c14.4 2.4 27.9 8.1 39.6 16.4l57-57z"]
};
var faObjectsAlignLeft = {
  prefix: 'fal',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 16C0 7.2 7.2 0 16 0s16 7.2 16 16l0 480c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 16zM160 176c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L176 96c-8.8 0-16 7.2-16 16l0 64zm-32-64c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm32 288c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16l0 64zm-32-64c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z"]
};
var faOilCanDrip = {
  prefix: 'fal',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 80c0 8.8-7.2 16-16 16l-64 0v64h96.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V340L31.1 315.7C12.4 308.7 0 290.7 0 270.7V208c0-26.5 21.5-48 48-48H96h32H240V96l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H336c8.8 0 16 7.2 16 16zM454.7 223.3c-7.1 1.5-14.5 .6-21-2.7l-50.5-25.2c-4.4-2.2-9.3-3.4-14.3-3.4H128V317.8 352v16c0 8.8 7.2 16 16 16H403.1c9.2 0 17.9-3.9 24-10.8L583.8 195.6 454.7 223.3zM96 192H48c-8.8 0-16 7.2-16 16v62.7c0 6.7 4.1 12.6 10.4 15L96 305.8V192zM608 400l0-.1 0-.2c0-.1 0-.3 0-.6c-.1-.5-.2-1.2-.3-2.1c-.3-1.8-.9-4.2-1.7-7c-1.7-5.7-4.2-12.5-7.4-20c-2-4.7-4.2-9.5-6.5-14.3c-2.3 4.8-4.4 9.6-6.5 14.3c-7.1 16.6-9.5 26.7-9.5 29.9c0 8.8 7.2 16 16 16c7 0 10.7-2.1 12.3-3.5c1.2-1.1 3.7-4 3.7-12.5zm32 0c0 32-21.5 48-48 48s-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400z"]
};
var faFaceSmilingHands = {
  prefix: 'fal',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2zM290.1 478c-8.8-1.2-16.8 5-18 13.7s5 16.8 13.7 18c11.2 1.5 22.6 2.3 34.1 2.3s22.9-.8 34.1-2.3c8.8-1.2 14.9-9.2 13.7-18s-9.2-14.9-18-13.7c-9.8 1.3-19.7 2-29.9 2s-20.1-.7-29.9-2zM384 384.8V352v-2.4V298.4c0-11 9-20 20-20c9.1 0 16.8 6.1 19.2 14.5c.2 .8 .4 1.7 .6 2.5c.1 1 .2 2 .2 3v11.7 8c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 0 0 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8c.7 .5 1.4 1.1 2.1 1.8c6.2 6.2 6.2 16.4 0 22.6l0 0-34 34L488 318.6l0 0c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7s4.7 7.2 4.7 11.3s-1.6 8.2-4.7 11.3l0 0-16 16-34 34L520 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l0 0 17.3-17.3 34-34 0 0 0 0c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5l0 0-5.1 5.1-26.9 26.9-2 2L552 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0c.7 .7 1.3 1.4 1.8 2.1c4.4 6.2 3.8 14.9-1.8 20.5L584 414.6l-37.5 37.5C528.7 470 504.4 480 479.2 480c-52.6 0-95.2-42.6-95.2-95.2zM320 400c11.6 0 22.4-1.2 32.5-3.4C358.5 461.3 412.9 512 479.2 512c33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L447 269.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V352v11.8c-9.8 2.7-20.4 4.2-32 4.2s-22.2-1.5-32-4.2V352 298.4c0-28.7-23.3-52-52-52c-17.9 0-33.6 9-43 22.7l-47.1-47.1c-18.7-18.7-49.1-18.7-67.9 0c-1 1-2 2.1-3 3.2c-15.7-3.7-32.8 .5-45 12.8s-16.5 29.4-12.8 45c-1.1 .9-2.2 1.9-3.2 3C-4.1 304.2-4.7 333.2 12.2 352c-16.9 18.8-16.3 47.8 1.8 65.9l56.8 56.8c23.9 23.9 56.2 37.3 89.9 37.3c66.3 0 120.7-50.7 126.7-115.4c10.1 2.2 21 3.4 32.5 3.4zM220.5 178.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C273.6 145.9 258.8 136 240 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C433.6 145.9 418.8 136 400 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zM100.7 267.3l0 0c-6.2-6.2-6.2-16.4 0-22.6c.7-.7 1.4-1.3 2.1-1.8c6.2-4.4 14.9-3.8 20.5 1.8L174.6 296l0 0 9.4 9.4 2.3 2.3 10.4 10.4 5.7 5.7c5 5 13.7 1.5 13.7-5.7v-8V298.4c0-1 .1-2 .2-3c.1-.9 .3-1.7 .6-2.5c2.4-8.4 10.1-14.5 19.2-14.5c11 0 20 9 20 20v51.2V352v32.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L56 414.6 36.7 395.3c-5.6-5.6-6.2-14.3-1.8-20.5c.5-.7 1.1-1.4 1.8-2.1c6.2-6.2 16.4-6.2 22.6 0l2 2L78.6 392c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4L70.7 365.3l-2-2L41.8 336.4l-5.1-5.1 0 0c-5.6-5.6-6.2-14.3-1.8-20.5c.5-.7 1.1-1.4 1.8-2.1c6.2-6.2 16.4-6.2 22.6 0l0 0 0 0 34 34L110.6 360l0 0c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-17.3-17.3-34-34-16-16 0 0c-3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3s7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7l16 16 34 34L142.6 328l0 0c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l0 0-17.3-17.3-34-34z"]
};
var faBroccoli = {
  prefix: 'fal',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88c0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96h8s47.7 54.5 80.2 138.3c5 12.8 17.1 21.7 30.9 21.7h81.9c13.8 0 25.9-8.9 30.9-21.7C360.3 406.5 408 352 408 352h8c53 0 96-43 96-96c0-40.8-25.5-75.7-61.4-89.6c3.5-9.5 5.4-19.7 5.4-30.4c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zm19.2 352l-2 4.9L256 400l-17.2-43.1-2-4.9h38.4zm-72.9 0l24 59.9C231.1 424 242.9 432 256 432s24.9-8 29.7-20.1l24-59.9 57.7 0c-4.1 5.6-8.9 12.3-13.9 20c-16.9 25.5-38.2 62.1-55.4 106.7c-.2 .6-.6 1-.9 1.2c-.1 .1-.2 .1-.2 .1H215.1c0 0-.1 0-.2-.1c-.3-.2-.6-.6-.9-1.2c-17.3-44.6-38.5-81.2-55.4-106.7c-5.1-7.7-9.8-14.4-13.9-20h57.7zM194.6 77.8C202.5 51.3 227 32 256 32s53.5 19.3 61.4 45.8c1.4 4.7 4.8 8.5 9.3 10.3s9.6 1.5 13.9-.9C348.7 82.6 358 80 368 80c30.9 0 56 25.1 56 56c0 11.8-3.6 22.7-9.8 31.7c-3.1 4.6-3.7 10.4-1.5 15.5s6.9 8.6 12.4 9.4c31 4.4 54.9 31.1 54.9 63.4c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64c0-32.3 23.9-59 54.9-63.4c5.5-.8 10.2-4.3 12.4-9.4s1.7-10.9-1.5-15.5c-6.2-9-9.8-19.9-9.8-31.7c0-30.9 25.1-56 56-56c10 0 19.3 2.6 27.4 7.2c4.2 2.4 9.3 2.7 13.9 .9s8-5.6 9.3-10.3z"]
};
var faRouteInterstate = {
  prefix: 'fal',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M53.7 63.9C113 85.7 195.6 75.8 256 35.6c60.4 40.2 143 50.1 202.3 28.3c3.3 34.5 5.1 66.4 5.1 96.1H256 48.2c.2-29.8 2.2-61.8 5.5-96.1zM48.7 192h414c-2.3 44.8-9.9 84.2-24.8 119.4c-27.8 66-82.2 119.8-182.3 167.1C154.1 435.2 99.9 381.6 72.6 314.8c-14.8-36.1-22-76.7-23.9-122.8zM270 6.4c-8.4-5.9-19.7-5.9-28.1 0C186.2 45.5 107.2 53 57.4 30.9C43.2 24.6 24.6 33 22.8 50.6C11.9 158.8 11.7 250.5 43 326.9c31.7 77.4 94.5 136.7 203.5 182.5c6.2 2.6 13.4 2.5 19.5-.4c106.7-49.8 169.3-109 201.4-185.2c31.8-75.4 32.7-165 21.8-273.2c-1.8-17.6-20.4-26.1-34.6-19.7C404.8 53 325.8 45.5 270 6.4z"]
};
var faEarMuffs = {
  prefix: 'fal',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", "M320 32c-91.9 0-167.4 70.5-175.3 160.3c-11.7 1-22.7 4.2-32.6 9.2C115.5 89.7 207.3 0 320 0S524.5 89.7 527.9 201.5c-9.9-5.1-20.9-8.3-32.6-9.2C487.4 102.5 411.9 32 320 32zM496 224.6c9 1.3 17.2 4.7 24.3 9.7c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-30.9 25.1-56 56-56c2.7 0 5.4 .2 8 .6zM152 224c30.9 0 56 25.1 56 56c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2c7.1-5 15.3-8.4 24.3-9.7c2.6-.4 5.3-.6 8-.6zm20.8 100c-5.7-9.9-5.7-22.1 0-32c2-3.5 3.2-7.6 3.2-12c0-13.3-10.7-24-24-24c-5.2 0-9.9 1.6-13.8 4.4c-8 5.6-18.1 7.3-27.4 4.6c-2.1-.6-4.4-1-6.8-1c-8.5 0-16 4.4-20.3 11.2c-4.2 6.7-10.7 11.5-18.3 13.7C55.3 291.8 48 301.1 48 312c0 2.3 .3 4.4 .9 6.4c3.2 11.5-.4 23.9-9.1 32C34.9 354.8 32 361 32 368s2.9 13.2 7.7 17.6c8.8 8.1 12.3 20.4 9.1 32c-.5 2-.9 4.1-.9 6.4c0 10.9 7.3 20.2 17.4 23.1c7.6 2.2 14.1 7 18.3 13.7C88 467.6 95.5 472 104 472c2.4 0 4.6-.3 6.8-1c9.4-2.7 19.5-1 27.4 4.6c3.9 2.8 8.6 4.4 13.8 4.4c13.3 0 24-10.7 24-24c0-4.4-1.2-8.5-3.2-12c-5.7-9.9-5.7-22.1 0-32c2-3.5 3.2-7.6 3.2-12c0-5.1-1.6-9.8-4.3-13.7c-7.7-11-7.7-25.6 0-36.6c2.7-3.9 4.3-8.6 4.3-13.7c0-4.4-1.2-8.5-3.2-12zM464 280c0 4.4 1.2 8.5 3.2 12c5.7 9.9 5.7 22.1 0 32c-2 3.5-3.2 7.6-3.2 12c0 5.1 1.6 9.8 4.3 13.7c7.7 11 7.7 25.6 0 36.6c-2.7 3.9-4.3 8.6-4.3 13.7c0 4.4 1.2 8.5 3.2 12c5.7 9.9 5.7 22.1 0 32c-2 3.5-3.2 7.6-3.2 12c0 13.3 10.7 24 24 24c5.2 0 9.9-1.6 13.8-4.4c8-5.6 18.1-7.3 27.4-4.6c2.1 .6 4.4 1 6.8 1c8.5 0 16-4.4 20.3-11.2c4.2-6.7 10.7-11.5 18.3-13.7c10.1-2.9 17.4-12.2 17.4-23.1c0-2.3-.3-4.4-.9-6.4c-3.2-11.5 .4-23.9 9.1-32c4.8-4.4 7.7-10.7 7.7-17.6s-2.9-13.2-7.7-17.6c-8.8-8.1-12.3-20.4-9.1-32c.5-2 .9-4.1 .9-6.4c0-10.9-7.3-20.2-17.4-23.1c-7.6-2.2-14.1-7-18.3-13.7C552 268.4 544.5 264 536 264c-2.4 0-4.6 .3-6.8 1c-9.4 2.7-19.5 1-27.4-4.6c-3.9-2.8-8.6-4.4-13.8-4.4c-13.3 0-24 10.7-24 24z"]
};
var faHotdog = {
  prefix: 'fal',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", "M458.9 154.9l-304 304c-28.1 28.1-73.7 28.1-101.8 0S25 385.2 53.1 357.1l304-304c28.1-28.1 73.7-28.1 101.8 0s28.1 73.7 0 101.8zm22.6 22.6c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-60.9c-6.2-6.2-16.4-6.2-22.6 0c-7 7-12.5 10.8-17 13.1c-4.5 2.3-8.5 3.4-13.6 4.7l-1.5 .4c-4.7 1.2-10.9 2.7-17.3 5.6c-7.4 3.4-14.8 8.4-22.7 16.3c-16.2 16.2-20.5 30.7-24 42.7l0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.5 7.8-12.4 9.1c-3 1.3-5.8 1.7-10.6 2.4l-.4 .1c-4.6 .6-10.9 1.6-18 4.5c-7.4 3.1-14.8 8.1-22.6 15.9c-16.2 16.2-20.5 30.7-24 42.7l0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.7 8.1-13.3 9.8c-3.6 1.6-6.9 2.5-12 3.7l-1.2 .3c-5.6 1.4-12.6 3.2-20.4 7.3c-7.9 4-16 9.9-25 18.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1c4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4 0 0c4.7-1.2 10.9-2.7 17.3-5.6c7.4-3.4 14.8-8.4 22.7-16.3c16.2-16.2 20.5-30.7 24-42.7l0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.5-7.8 12.4-9.1c3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5c7.4-3.1 14.8-8.1 22.6-15.9c16.2-16.2 20.5-30.7 24-42.7l0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.7-8.1 13.3-9.8c3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3c7.9-4 16-9.9 25-18.9c6.2-6.2 6.2-16.4 0-22.6zM264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8l22.6-22.6C34.3 276.4 32 270.3 32 264c0-6.9 2.7-13.5 7.6-18.3L17.2 223.2l22.4 22.4L245.7 39.6c4.9-4.9 11.5-7.6 18.3-7.6c6.3 0 12.4 2.3 17.2 6.5l22.6-22.6C293.1 5.7 278.8 0 264 0zM208.2 496.2c10.7 10.2 25 15.8 39.8 15.8c15.4 0 30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41c0-14.8-5.7-29.1-15.8-39.8l-22.6 22.6c4.2 4.7 6.5 10.8 6.5 17.2c0 6.9-2.7 13.5-7.6 18.3L266.3 472.4c-4.9 4.9-11.5 7.6-18.3 7.6c-6.3 0-12.4-2.3-17.2-6.5l-22.6 22.6z"]
};
var faTransporterEmpty = {
  prefix: 'fal',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", "M144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144z"]
};
var faPersonWalkingWithCane = {
  prefix: 'fal',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", "M184 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 184 0a56 56 0 1 0 0 112zm-30.4 32c-31.6 0-60.3 18.6-73.1 47.5l-47.1 106c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l47.1-106c2.5-5.6 6-10.6 10.3-14.8v96c0 17 9 32.7 23.7 41.4L256 393.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V393.2c0-11.3-6-21.8-15.8-27.6l-32.2-19V190.4c2.1 2.1 4 4.5 5.7 7l77 115.5c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-77-115.5c-14.8-22.3-39.8-35.6-66.6-35.6H153.6zM152 285.7V176c.5 0 1.1 0 1.6 0h52.2c.8 0 1.5 0 2.3 .1V327.8l-48.1-28.3c-4.9-2.9-7.9-8.1-7.9-13.8zM96.6 491.8c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2l34.2-125.4L133.1 358 96.6 491.8zm354.3 13.3c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L372.3 335.4c-2.8 3.2-6 6.1-9.7 8.5c-5.7 3.8-11.9 6.2-18.3 7.3L450.8 505.1z"]
};
var faBlind = faPersonWalkingWithCane;
var faAngle90 = {
  prefix: 'fal',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V48zm160.8 75c-29.9-13.2-62.2-21.9-96-25.3c-9.1-.9-16.8 6.4-16.8 15.6c0 8.5 6.7 15.5 15.1 16.4c29.3 3.2 57.3 10.7 83.3 22c7.6 3.3 16.6 .8 21-6.3c4.9-8 2-18.5-6.6-22.3zM297.5 247.4c5.1 7.1 14.8 9.3 22.2 4.7c7.6-4.7 10-14.8 4.7-22.1c-20.6-28.8-45.8-54-74.6-74.6c-7.3-5.2-17.4-2.9-22.1 4.7c-4.6 7.4-2.3 17.1 4.7 22.2c24.9 18 46.9 40 64.9 64.9zm30.8 54.1c11.3 26 18.8 54 22 83.3c.9 8.5 7.9 15.1 16.4 15.1c9.2 0 16.5-7.7 15.6-16.8c-3.4-33.9-12.2-66.1-25.3-96c-3.8-8.6-14.3-11.6-22.3-6.6c-7.1 4.4-9.6 13.4-6.3 21z"]
};
var faRectangleTerminal = {
  prefix: 'fal',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM99.9 149.6c-5.8 6.7-5 16.8 1.7 22.6L199.4 256l-97.8 83.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM224 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H224z"]
};
var faKite = {
  prefix: 'fal',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M338.2 50.8L273 344.4 457.4 160 341.1 43.7c-1.3 2.2-2.3 4.5-2.8 7.1zM258.9 407.9l-5.4 1.2-88.2 88.2c-9.4 9.4-22.1 14.6-35.3 14.6C102.4 512 80 489.6 80 462.1V316.3L24.2 349.7c-4.9 3-11.1 3-16.1 .2S0 341.8 0 336V240c0-5.8 3.1-11.1 8.1-13.9s11.2-2.8 16.1 .2L80 259.7V208c0-26.5-21.5-48-48-48H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32c44.2 0 80 35.8 80 80v51.7l55.8-33.5c4.9-3 11.1-3 16.1-.2s8.1 8.2 8.1 13.9v96c0 5.8-3.1 11.1-8.1 13.9s-11.2 2.8-16.1-.2L112 316.3V462.1c0 9.9 8 17.9 17.9 17.9c4.8 0 9.3-1.9 12.7-5.3l88.2-88.2 1.2-5.4L307 43.9C312.7 18.2 335.4 0 361.7 0H584c30.9 0 56 25.1 56 56V278.3c0 26.2-18.2 49-43.9 54.7L258.9 407.9zM480 182.6L295.6 367l293.6-65.2c2.6-.6 4.9-1.5 7.1-2.8L480 182.6zM608 56c0-.4 0-.9 0-1.3L502.6 160 608 265.4V56zM584 32H374.6L480 137.4 585.3 32c-.4 0-.9 0-1.3 0zM32 268.3v39.5L64.9 288 32 268.3zm128 39.5V268.3L127.1 288 160 307.7z"]
};
var faDrum = {
  prefix: 'fal',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", "M509.6 39.5c4.7 7.5 2.4 17.4-5.1 22l-86.3 53.9C475.4 133 512 162.8 512 208V368c0 22.6-13.6 41.6-32.3 56.2c-18.8 14.7-44.9 26.8-75.1 35.9C362.8 472.7 311.3 480 256 480s-106.8-7.3-148.6-19.9C77.1 451 51.1 439 32.3 424.2C13.6 409.6 0 390.6 0 368V208C0 128 114.6 96 256 96c42.7 0 82.9 2.9 118.3 9.2L487.5 34.4c7.5-4.7 17.4-2.4 22 5.1zM332 131.6c-23.5-2.4-49-3.6-76-3.6c-69 0-128.5 7.9-169.4 23.8C45.3 167.9 32 187.6 32 208c0 11.2 11.3 31.5 55.7 50.6C129 276.5 188.5 288 256 288s127-11.5 168.3-29.4C468.7 239.5 480 219.2 480 208c0-20.4-13.3-40.1-54.6-56.2c-13.1-5.1-28.2-9.4-44.8-12.8L248.5 221.6c-7.5 4.7-17.4 2.4-22-5.1s-2.4-17.4 5.1-22L332 131.6zM480 263.2c-16.2 12.8-38.1 24-64 32.9l0 126.4c18.3-7 33.2-15 44-23.5c14.8-11.5 20-22.2 20-31V263.2zm-96 42.3c-33.3 8.2-71.4 13.3-112 14.3v128c41.5-1.1 79.7-6.6 112-15.1l0-127.2zM240 319.8c-40.6-1.1-78.7-6.1-112-14.3V432.7c32.3 8.5 70.5 14 112 15.1v-128zM96 296.1c-25.9-8.9-47.8-20.1-64-32.9V368c0 8.8 5.3 19.5 20 31c10.8 8.5 25.6 16.5 44 23.5V296.1z"]
};
var faScrubber = {
  prefix: 'fal',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faIceCream = {
  prefix: 'fal',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", "M224 0C139.7 0 70.6 65.2 64.4 147.9C36.2 157.7 16 184.5 16 216c0 39.8 32.2 72 72 72h45.5 181H360c39.8 0 72-32.2 72-72c0-31.5-20.2-58.3-48.4-68.1C377.4 65.2 308.3 0 224 0zM96 160v0C96 89.3 153.3 32 224 32s128 57.3 128 128l0 .5c0 8 5.8 14.7 13.7 15.9c19.4 2.8 34.3 19.5 34.3 39.6c0 22.1-17.9 40-40 40H314.5h-181H88c-22.1 0-40-17.9-40-40c0-20.1 14.9-36.8 34.3-39.6c7.9-1.1 13.8-7.9 13.7-15.9l0-.5zM200.1 498.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320H312.9L224 475.5 135.1 320H98.3L200.1 498.1z"]
};
var faHeartCircleBolt = {
  prefix: 'fal',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M244 130.6l-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8c-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8 .7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8 .8-1.7 1.5-2.6 2.2c-6.3 4.9-14.1 7.5-22.1 7.5c-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4c6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1c1.8-1.5 3.6-3 5.4-4.5C311 48.4 352.7 37.7 393.7 45.1C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1c-9.8-4.9-20.2-8.9-30.9-12c.2-2.7 .3-5.4 .3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3c-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faFishBones = {
  prefix: 'fal',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M42.4 141.5l27.3 22.8c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L44.8 101.8C40.3 98.1 34.6 96 28.7 96c-17.1 0-29.3 16.7-24 33L46 256 4.7 383c-5.3 16.3 6.8 33 24 33c5.9 0 11.6-2.1 16.1-5.8L34.6 397.9l10.2 12.3 45.4-37.9c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2L42.4 370.5l32-98.5H144v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V272h48V392.9c0 11.3 11.4 19 21.4 13.8c20.1-10.3 38.2-22.9 54-36.3c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8c-15.8-13.4-33.9-26-54-36.3c-10.1-5.1-21.4 2.5-21.4 13.8V240H368V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H176V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H74.5l-32-98.5zM447.7 259.2c.2-1 .3-2.1 .3-3.2s-.1-2.2-.3-3.2V148.1c8.2 5.6 16 11.5 23.4 17.7c35.6 30 60.9 66.1 73.2 90.1c0 .1 0 .2 0 .3c-12.4 24-37.7 60.1-73.2 90.1c-7.3 6.2-15.1 12.1-23.4 17.7V259.2z"]
};
var faDeerRudolph = {
  prefix: 'fal',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M240 0c8.8 0 16 7.2 16 16V40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 8.6-1.9 16.7-5.4 24h38.8H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 22-12.7 41.1-31.2 50.2l35 35C483.1 108 500.2 96 520 96c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.9 0-5.7-.3-8.4-.7c-3.4 27.5-26.8 48.7-55.2 48.7H403.9l-18.6 61.8c-.9 3-1.4 6.1-1.4 9.2V472c0 22.1-17.9 40-40 40H312c-22.1 0-40-17.9-40-40V368H257.2c-24.1 0-47.7-5.7-69-16.6c-.9 17.8-10.1 34.4-25.3 44.6c-9.3 6.2-13.4 17.9-9.8 28.6l11.6 34.8c8.6 25.9-10.6 52.6-37.9 52.6H97.3c-17.2 0-32.5-11-37.9-27.4L37.9 420.2c-4.4-13.1-4.4-27.3 0-40.5l8.5-25.4c1.1-3.3 1.6-6.7 1.6-10.1v-4.3c0-8.5-3.4-16.6-9.4-22.6l-3.9-3.9c-.7-.7-1.5-1.5-2.2-2.3L32 321c-.6 8.8-8.1 15.5-17 15s-15.5-8.1-15-17l3.3-53c3.2-50.6 45.1-90 95.8-90H104h16H300.7l10-35.9-13.8 9.2c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l40-26.7H296h-8-8c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zM348.3 124.2l-20 72.1c-1.9 6.9-8.2 11.7-15.4 11.7H120 104c-30.9 0-56 25.1-56 56v4.1c0 8.5 3.4 16.6 9.4 22.6l3.9 3.9c12 12 18.7 28.3 18.7 45.3v4.3c0 6.9-1.1 13.7-3.3 20.2l-8.5 25.4c-2.2 6.6-2.2 13.7 0 20.2l21.5 64.4c1.1 3.3 4.1 5.5 7.6 5.5h29.4c5.5 0 9.3-5.4 7.6-10.5l-11.6-34.8c-8.1-24.3 1.1-51.1 22.4-65.3c8.2-5.4 12.4-15.1 10.8-24.8l-3.7-21.9c-1-6.3 1.7-12.6 7.1-16.1s12.3-3.4 17.6 .1l13.7 9.2C210.3 329 233.5 336 257.2 336H288c8.8 0 16 7.2 16 16V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311c0-6.2 .9-12.4 2.7-18.4l22-73.3c2-6.8 8.3-11.4 15.3-11.4h64.4c13 0 23.6-10.6 23.6-23.6c0-6.3-2.5-12.3-6.9-16.7l-60.4-60.4c-7.2-7.2-17-11.3-27.2-11.3c-17.3 0-32.5 11.5-37.1 28.2zM400 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm136 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faFax = {
  prefix: 'fal',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M160 64c0-17.7 14.3-32 32-32H388.1c8.5 0 16.6 3.4 22.6 9.4l27.9 27.9c6 6 9.4 14.1 9.4 22.6V160h32V91.9c0-17-6.7-33.3-18.7-45.3L433.4 18.7C421.4 6.7 405.1 0 388.1 0H192c-35.3 0-64 28.7-64 64v72.6c-9.4-5.4-20.3-8.6-32-8.6H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H96c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7H448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H160V64zm0 160H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V224zm-32-32v16V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32zM296 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faParagraph = {
  prefix: 'fal',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160h64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384l0 400c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-400H288V464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112H192c-88.4 0-160-71.6-160-160zM256 320V64H192C121.3 64 64 121.3 64 192s57.3 128 128 128h64z"]
};
var faHeadSideHeart = {
  prefix: 'fal',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M32 224C32 118 118 32 224 32h16c66.1 0 127.1 40 153.8 96.9c3.2 6.9 6.5 14.2 9.9 21.7l0 0 0 0c6.2 13.9 12.7 28.5 19.8 42c11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1c0 15.6-12.6 28.2-28.2 28.2H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32H304c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64V336h3.8c33.2 0 60.2-26.9 60.2-60.2c0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3c-6.7-12.7-12.3-25.5-18.2-38.7l0 0c-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0H224C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140C58.5 375.6 64 388.6 64 401.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V401.4c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm112-34.7c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L224 281.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM173.3 128c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faSquareE = {
  prefix: 'fal',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-17.7 0-32-14.3-32-32V256 160c0-17.7 14.3-32 32-32z"]
};
var faMeterFire = {
  prefix: 'fal',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M256 32c76.2 0 143.5 38 183.9 96.1c12.4-1 25.2 3 35 11.9c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-8.5-7.8-16.3-16.3-23.2-25.5C305.3 475.9 281.1 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32zM368 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 4.4 1.8 8.5 4.7 11.4c8.3-11.6 17.4-23.1 27.3-34.4V144zm-192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM509.4 253.5c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2C608 422.4 551 480 480 480c-71.8 0-128-57.5-128-127.8c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1c14.3 13.7 27.9 28.3 40.8 43.7c6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2c18 16.5 42.3 24.8 68.2 24.8c21.3 0 40.3-6 57.9-17.7l0 0 .3-.2c37.3-26.1 46.3-77.2 25-116.5l0-.1c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5C508.6 412 495.7 416 481 416c-19.1 0-35.3-6.1-46.6-16.4C423.3 389.4 416 374.3 416 354c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"]
};
var faCloudHail = {
  prefix: 'fal',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M176 32c-44.2 0-80 35.8-80 80c0 5.4 .5 10.6 1.5 15.7c1.7 8.3-3.5 16.5-11.7 18.6c-31 8-53.9 36.2-53.9 69.7c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72s-32.2-72-72-72c-2.2 0-4.4 .1-6.6 .3c-4.5 .4-8.9-1.1-12.2-4.1s-5.2-7.3-5.2-11.8l0-.3c0-35.3-28.7-64-64-64c-17.8 0-33.9 7.2-45.5 19c-3.7 3.7-9 5.4-14.1 4.5s-9.6-4.3-11.8-9C235.9 51 208.2 32 176 32zm238.7 80.2C469 115.7 512 160.8 512 216c0 57.4-46.6 104-104 104H104C46.6 320 0 273.4 0 216c0-43.4 26.6-80.5 64.3-96.1c-.2-2.6-.3-5.2-.3-7.9C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c47.6 0 87.2 34.7 94.7 80.2zM96 392a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCheckToSlot = {
  prefix: 'fal',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M144 64c-8.8 0-16 7.2-16 16V384H448V80c0-8.8-7.2-16-16-16H144zM480 80V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 128 96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16H96V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48zM48 320H64v32H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H528c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H512V320h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM379.3 174L272.6 280.6c-6.2 6.2-16.4 6.2-22.6 0l-53.3-53.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l42 42 95.4-95.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faVoteYea = faCheckToSlot;
var faMoneyFromBracket = {
  prefix: 'fal',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", "M80 32C53.5 32 32 53.5 32 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80C0 35.8 35.8 0 80 0H560c44.2 0 80 35.8 80 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5-21.5-48-48-48H80zM496 96c8.8 0 16 7.2 16 16l0 344c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56l0-344c0-8.8 7.2-16 16-16s16 7.2 16 16l0 272c53 0 96 43 96 96H384c0-53 43-96 96-96V112c0-8.8 7.2-16 16-16zM224 480c0-35.3-28.7-64-64-64l0 40c0 13.3 10.7 24 24 24h40zm232 0c13.3 0 24-10.7 24-24l0-40c-35.3 0-64 28.7-64 64h40zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z"]
};
var faStarHalf = {
  prefix: 'fal',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M226.5 168.8c-4.6 9.5-13.6 16.1-24.1 17.7L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L150.2 473.2l129.7-69.3V58.8l-53.4 110zM293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9z"]
};
var faCarBus = {
  prefix: 'fal',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", "M45.8 70.1C38.8 75.7 34.7 84.5 33 96H192 351c-1.7-11.5-5.9-20.3-12.9-25.9C316.2 52.8 271 32 192 32S67.8 52.8 45.8 70.1zM32 128v96H176V128H32zm0 128v96c0 17.7 14.3 32 32 32H224v32H64l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V407.4C12.9 396.4 0 375.7 0 352V110.2C0 88.9 4.5 62.1 26 45C54.8 22.2 107.5 0 192 0s137.2 22.2 166 45c21.5 17 26 43.9 26 65.2V144h-3.8c-9.8 0-19.2 1.5-28.2 4.2V128H208v96h76.9l-9.1 32H192 32zm72 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm276.2-80c-14.3 0-26.8 9.5-30.8 23.2L333.2 288c.9 0 1.9 0 2.8 0H560c.9 0 1.9 0 2.8 0l-16.2-56.8c-3.9-13.7-16.5-23.2-30.8-23.2H380.2zm-61.5 14.4c7.8-27.5 33-46.4 61.5-46.4H515.8c28.6 0 53.7 18.9 61.5 46.4L599 298.1c24.5 13.7 41 39.9 41 69.9v48 16 32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16V464H288v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V464 432 416 368c0-30 16.6-56.2 41-69.9l21.6-75.7zM608 416V368c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v48 16H608V416zM336 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSpeaker = {
  prefix: 'fal',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM272 336a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM80 336a112 112 0 1 1 224 0A112 112 0 1 1 80 336zm88 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56-208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faTimer = {
  prefix: 'fal',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M256 0c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V32.6C388.2 40.8 480 137.7 480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-46.6 14.2-89.9 38.6-125.8c5-7.3 3.1-17.3-4.2-22.2s-17.3-3.1-22.2 4.2C16.3 153.2 0 202.7 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM171.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z"]
};
var faBoxesStacked = {
  prefix: 'fal',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", "M384 32c17.7 0 32 14.3 32 32V192h32V64c0-35.3-28.7-64-64-64H320 256 192c-35.3 0-64 28.7-64 64V192h32V64c0-17.7 14.3-32 32-32h32V88c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V32h32zM256 32h64V88c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V32zm71.6 480H512c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H448 384 327.6c8.3 9.2 14.8 20.1 19 32H352v31.9 .1 24c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V256h32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H346.5c-4.2 11.9-10.7 22.8-19 32zM384 256h64v56c0 4.4-3.6 8-8 8H392c-4.4 0-8-3.6-8-8V256zm-128 0c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32H96v56c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V256h32zM128 312V256h64v56c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8zm128-88H224 192 128 96 64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64z"]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faGrillHot = {
  prefix: 'fal',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M112 0c-8.8 0-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16c0-8.8-7.2-16-16-16zM256 352H192c-88.4 0-160-71.6-160-160H416c0 88.4-71.6 160-160 160zM32 160c-17.7 0-32 14.3-32 32c0 80.5 49.5 149.4 119.7 177.9l-7.4 16.2c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48H335.9l17.6 38.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L328.3 369.9C398.5 341.4 448 272.5 448 192c0-17.7-14.3-32-32-32H32zM140.4 401.9l10.2-22.4c13.4 2.9 27.2 4.5 41.5 4.5h64c14.2 0 28.1-1.5 41.5-4.5L321.3 432H158c-3-11.7-9.2-22-17.6-30.1zM64 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16z"]
};
var faBallotCheck = {
  prefix: 'fal',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", "M384 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 384c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H88zM72 376v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V376c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zm91.3-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L104 257.4 91.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z"]
};
var faLink = {
  prefix: 'fal',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"]
};
var faChain = faLink;
var faEarListen = {
  prefix: 'fal',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M350 8.2c-4.3 7.7-1.5 17.5 6.2 21.8C430.1 71 480 149.7 480 240c0 8.8 7.2 16 16 16s16-7.2 16-16C512 137.6 455.4 48.4 371.8 2C364.1-2.3 354.3 .5 350 8.2zM96 240c0-79.5 64.5-144 144-144s144 64.5 144 144c0 41.9-17.9 79.7-46.5 106c-10.1 9.2-17.5 22.6-17.5 38c0 53-43 96-96 96H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c70.7 0 128-57.3 128-128c0-4.8 2.4-10 7.1-14.4C394.1 337.4 416 291.3 416 240c0-97.2-78.8-176-176-176S64 142.8 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM52.7 372.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM160 240c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faAssistiveListeningSystems = faEarListen;
var faFileMinus = {
  prefix: 'fal',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM96 320c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
};
var faTreeCity = {
  prefix: 'fal',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M336 32c-8.8 0-16 7.2-16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V192h32V112c0-8.8 7.2-16 16-16s16 7.2 16 16v80h16c26.5 0 48 21.5 48 48V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8-7.2-16-16-16H560 496c-8.8 0-16-7.2-16-16V48c0-8.8-7.2-16-16-16H336zm48 32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm0 32v32h32V96H384zm96 192c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V288zm64 0H512v32h32V288zm-32 96h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm0 32v32h32V416H512zM352 224c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V224zm64 0H384v32h32V224zm-32 96h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32zm0 32v32h32V352H384zM128 224c8.8 0 16 7.2 16 16v48h32c26.5 0 48-21.5 48-48c0-16-7.8-30.2-19.9-38.9l-8-5.8c-4.9-3.5-7.4-9.5-6.4-15.5l.4-2.6c1.1-6.7 1.9-11.9 1.9-17.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.3 .8 10.5 1.9 17.2l.4 2.6c.9 6-1.5 11.9-6.4 15.5l-8 5.8C39.8 209.8 32 224 32 240c0 26.5 21.5 48 48 48h32V240c0-8.8 7.2-16 16-16zm-16 96H80c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9l0 0c-.7-4.7-1.2-9.9-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.2-.5 10.4-1.2 15.1l0 0C242.9 189.7 256 213.3 256 240c0 44.2-35.8 80-80 80H144V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V320z"]
};
var faPlay = {
  prefix: 'fal',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", "M56.3 66.3c-4.9-3-11.1-3.1-16.2-.3s-8.2 8.2-8.2 14V432c0 5.8 3.1 11.1 8.2 14s11.2 2.7 16.2-.3l288-176c4.8-2.9 7.7-8.1 7.7-13.7s-2.9-10.7-7.7-13.7l-288-176zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432V80C0 62.6 9.4 46.6 24.5 38.1z"]
};
var faFont = {
  prefix: 'fal',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L37.4 448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H72.1l40.6-96H335.2l40.6 96H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H410.6L238.7 41.8zm83 278.2H126.3L224 89.1 321.7 320z"]
};
var faCupTogo = {
  prefix: 'fal',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M87.9 42.9L70.2 96H377.8L360.1 42.9c-2.2-6.5-8.3-10.9-15.2-10.9H103.1c-6.9 0-13 4.4-15.2 10.9zM47.6 128H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H36.5L57.5 32.8C64.1 13.2 82.4 0 103.1 0H344.9c20.7 0 39 13.2 45.5 32.8L411.5 96H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H400.4c-.2 0-.5 0-.7 0H48.4c-.2 0-.5 0-.7 0zm27 325.9L47.4 160H79.5l5.9 64H362.5l5.9-64h32.1L373.4 453.9c-3 32.9-30.7 58.1-63.7 58.1H138.3c-33.1 0-60.7-25.2-63.7-58.1zM359.6 256H88.4l11.9 128H347.7l11.9-128zM344.8 416H103.2l3.2 35c1.5 16.5 15.3 29 31.9 29H309.7c16.5 0 30.3-12.6 31.9-29l3.2-35z"]
};
var faCoffeeTogo = faCupTogo;
var faSquareDownLeft = {
  prefix: 'fal',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm144-88V214.6c0-3.7 3-6.6 6.6-6.6c1.8 0 3.4 .7 4.7 1.9l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0l59.1-59.1c3.6-3.6 9-4.9 13.9-3.3c2 .7 3.8 1.8 5.3 3.3l22.1 22.1c1.5 1.5 2.6 3.3 3.3 5.3c1.6 4.9 .4 10.3-3.3 13.9l-59.1 59.1c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c1.2 1.2 1.9 2.9 1.9 4.7c0 3.7-3 6.6-6.6 6.6H152c-4.4 0-8-3.6-8-8zm8 40H265.4c21.3 0 38.6-17.3 38.6-38.6c0-10.2-4.1-20.1-11.3-27.3L278.6 288l47.7-47.7c12.2-12.2 16.5-30.3 11-46.7c-2.2-6.7-6-12.8-11-17.8l-22.1-22.1c-5-5-11.1-8.8-17.8-11c-16.4-5.5-34.5-1.2-46.7 11L192 201.4l-14.1-14.1c-7.2-7.2-17.1-11.3-27.3-11.3c-21.3 0-38.6 17.3-38.6 38.6V328c0 22.1 17.9 40 40 40z"]
};
var faBurgerLettuce = {
  prefix: 'fal',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M256 64c94.4 0 172.9 68.1 189 157.8l0 .1c0 .1-.1 .2-.3 .3c-.7 .8-2.4 1.7-4.7 1.7H72c-2.4 0-4-1-4.7-1.7c-.1-.1-.2-.2-.3-.3l0-.1C83.1 132.1 161.6 64 256 64zM35.5 216.2C31.6 237.9 49.9 256 72 256H440c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2zM128 448c-35.3 0-64-28.7-64-64H448c0 35.3-28.7 64-64 64H128zM32 384c0 53 43 96 96 96H384c53 0 96-43 96-96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zM176 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 334.4c19.6 0 35.2-9.4 47.6-16.8l2.1-1.3c13.5-8.1 24.4-14 38.3-14c13.5 0 22.2 5.5 34.9 13.7c12.7 8.2 28.6 18.3 53.1 18.3c24.4 0 39.5-10.1 51.6-18.1l.4-.3c11.8-7.9 20.7-13.6 36-13.6c15.7 0 26.7 6 39.5 13.9l2.6 1.6c11.7 7.3 26.6 16.5 45.9 16.5c18.5 0 32.7-4.6 42.4-9.5c4.9-2.4 8.6-4.9 11.2-6.9c1.3-1 2.3-1.8 3.1-2.5c.4-.3 .7-.6 .9-.8l.3-.3 .1-.1 .1 0 0 0 0 0s0 0-10.2-10.2l10.2 10.2c5.6-5.6 5.6-14.7 0-20.4c-5.6-5.6-14.6-5.6-20.2-.1l-.2 .2c-.2 .2-.7 .6-1.4 1.1c-1.4 1-3.7 2.6-6.8 4.1c-6.2 3.1-16 6.5-29.6 6.5c-10.9 0-19.2-5.1-32.6-13.4l-.8-.5c-13.3-8.2-30.3-18.1-54.5-18.1c-24.4 0-39.5 10.1-51.6 18.1l-.4 .3c-11.8 7.9-20.7 13.6-36 13.6c-15.5 0-25.3-5.9-37.5-13.7l-1.4-.9c-11.9-7.7-26.9-17.4-49.1-17.4c-22.7 0-39.8 10.1-53.1 18c-14.2 8.5-23.6 14-34.9 14c-13.5 0-23.3-3.4-29.6-6.5c-3.1-1.6-5.4-3.1-6.8-4.1c-.7-.5-1.2-.9-1.4-1.1l-.2-.2c-5.6-5.5-14.7-5.4-20.2 .1c-5.6 5.6-5.6 14.7 0 20.4L32 304c-10.2 10.2-10.2 10.2-10.2 10.2l0 0 0 0 0 0 .1 .1 .3 .3c.2 .2 .6 .5 .9 .8c.8 .7 1.8 1.5 3.1 2.5c2.6 2 6.3 4.4 11.2 6.9c9.8 4.9 24 9.5 42.4 9.5z"]
};
var faRupiahSign = {
  prefix: 'fal',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 80C0 53.5 21.5 32 48 32h64c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 80zM32 288h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V288zm288-80V352h80c44.2 0 80-35.8 80-80s-35.8-80-80-80H336c-8.8 0-16 7.2-16 16zm16-48h64c61.9 0 112 50.1 112 112s-50.1 112-112 112H320V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-26.5 21.5-48 48-48z"]
};
var faMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"]
};
var faSearch = faMagnifyingGlass;
var faTableTennisPaddleBall = {
  prefix: 'fal',
  iconName: 'table-tennis-paddle-ball',
  icon: [512, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M423.8 88.2c56.7 56.7 70.5 139.9 41.5 209.6c10 4.2 19.4 9.6 27.9 16.1c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7c-24 24-37.5 56.6-37.5 90.5V219c0 33.9 13.5 66.5 37.5 90.5l9.8 9.8c13.1 13.1 12.4 34.6-1.7 46.8L11 423.8C4.3 429.6 .3 438 0 446.9s3.1 17.5 9.4 23.8l32 32c6.3 6.3 14.9 9.7 23.8 9.4s17.2-4.3 23-11l57.7-66.6c12.2-14 33.7-14.8 46.8-1.7l9.8 9.8c24 24 56.6 37.5 90.5 37.5h2.7c3.1 0 6.1-.1 9.2-.3c-5.6-9.8-10-20.4-12.9-31.7c-25.1-.3-49.1-10.3-66.9-28.1l-9.8-9.8c-26.3-26.3-69.3-24.7-93.6 3.3L64 480 32 448l66.6-57.7c28.1-24.3 29.6-67.4 3.3-93.6l-9.8-9.8C74.1 268.9 64 244.4 64 219v-2.7c0-18.2 5.2-35.8 14.6-51L293.2 379.8c3.3-11.1 8-21.6 14-31.3L99.5 140.9l52.7-52.7c75-75 196.5-75 271.5 0zM352 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faPersonDotsFromLine = {
  prefix: 'fal',
  iconName: 'person-dots-from-line',
  icon: [576, 512, ["diagnoses"], "f470", "M344 88A56 56 0 1 0 232 88a56 56 0 1 0 112 0zM200 88a88 88 0 1 1 176 0A88 88 0 1 1 200 88zM80 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 256V256.6c-21.4 6.5-40.2 14.2-56.3 21.9c-20 9.6-35.5 19.2-45.9 26.3c-5.2 3.6-9.2 6.5-11.7 8.5c-1.3 1-2.2 1.8-2.9 2.3l-.6 .5-.1 .1 0 0 0 0c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6L48 304c-10.4-12.1-10.4-12.1-10.4-12.1l0 0 0 0 .1-.1 .3-.2 1-.8c.8-.7 2-1.6 3.5-2.8c3.1-2.4 7.5-5.7 13.3-9.6c11.6-7.9 28.5-18.3 50.1-28.7C149.1 228.8 211.5 208 288 208s138.9 20.8 182.1 41.6c21.6 10.4 38.5 20.8 50.1 28.7c5.8 3.9 10.2 7.3 13.3 9.6c1.5 1.2 2.7 2.1 3.5 2.8l1 .8 .3 .2 .1 .1 0 0 0 0s0 0-10.4 12.1l10.4-12.1c6.7 5.8 7.4 15.9 1.7 22.6s-15.9 7.4-22.5 1.7l0 0 0 0 0 0 0 0-.1-.1-.6-.5c-.6-.5-1.6-1.3-2.9-2.3c-2.6-2-6.5-4.9-11.7-8.5c-10.4-7.1-25.9-16.7-45.9-26.3c-16-7.7-34.9-15.4-56.3-21.9V448H368V248.4c-24.3-5.1-51-8.4-80-8.4s-55.7 3.2-80 8.4V448H176zM0 496c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM304 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM464 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDiagnoses = faPersonDotsFromLine;
var faChevronsDown = {
  prefix: 'fal',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M52.7 75.3l192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4 75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm0 192l192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 425.4 75.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"]
};
var faChevronDoubleDown = faChevronsDown;
var faTrashCanArrowUp = {
  prefix: 'fal',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm160 80c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V230.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z"]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faSignalGood = {
  prefix: 'fal',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", "M336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM192 288c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400c0-8.8-7.2-16-16-16z"]
};
var faSignal3 = faSignalGood;
var faLocationQuestion = {
  prefix: 'fal',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM104.7 137.8c6.5-24.6 28.7-41.8 54.2-41.8H216c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L208 236.3V256c0 8.8-7.2 16-16 16s-16-7.2-16-16V226.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H158.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM168 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMapMarkerQuestion = faLocationQuestion;
var faFloppyDiskCircleXmark = {
  prefix: 'fal',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V170.5c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64C46.3 64 32 78.3 32 96zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96H288V64H96zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm166.6 0l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z"]
};
var faFloppyDiskTimes = faFloppyDiskCircleXmark;
var faSaveCircleXmark = faFloppyDiskCircleXmark;
var faSaveTimes = faFloppyDiskCircleXmark;
var faNairaSign = {
  prefix: 'fal',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M93.2 38.9c-4-5.8-11.2-8.3-17.9-6.2S64 41 64 48V256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64V464c0 8.8 7.2 16 16 16s16-7.2 16-16V288H226.7L354.8 473.1c4 5.8 11.2 8.3 17.9 6.2s11.2-8.3 11.2-15.3V288h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V256H243.5L93.2 38.9zM265.6 288H352V412.8L265.6 288zm-61.1-32H96V99.2L204.5 256z"]
};
var faPeach = {
  prefix: 'fal',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M128 0C101.5 0 80 21.5 80 48c0 17 3.8 33.1 10.6 47.5c9.9-4.1 20.1-7.5 30.7-10.1C115.4 74.3 112 61.5 112 48c0-8.8 7.2-16 16-16h32c37.2 0 68.5 25.4 77.4 59.9c12.1 2.8 25 2.8 37.1 0C283.5 57.4 314.8 32 352 32h32c8.8 0 16 7.2 16 16c0 13.5-3.4 26.3-9.3 37.5c10.6 2.5 20.9 5.9 30.7 10.1C428.2 81.1 432 65 432 48c0-26.5-21.5-48-48-48H352c-40.7 0-76.4 21.8-96 54.3C236.4 21.8 200.7 0 160 0H128zm40 144c69.7 0 127.2 52.4 135.1 120c1 8.8 8.1 16 16.9 16s16.1-7.2 15.2-16c-4-42.8-24.1-80.9-54.1-108.2c6.9-1.2 13.8-2.9 20.5-5.1c13.3-4.4 27.5-6.7 42.4-6.7c75.1 0 136 60.9 136 136c0 51.7-38.2 97-91.1 134c-51.5 36.1-108.6 58.2-128.2 65.3c-1.1 .4-2.6 .7-4.7 .7s-3.5-.3-4.7-.7c-19.6-7-76.7-29.2-128.2-65.3C70.2 377 32 331.7 32 280c0-75.1 60.9-136 136-136zm123.7-23.7c-23 7.5-48.4 7.5-71.4 0c-16.5-5.4-34-8.3-52.3-8.3C75.2 112 0 187.2 0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-92.8-75.2-168-168-168c-18.3 0-35.9 2.9-52.3 8.3z"]
};
var faTaxiBus = {
  prefix: 'fal',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", "M192 32c79 0 124.2 20.8 146.2 38.1c7 5.5 11.1 14.4 12.9 25.9H192 33c1.7-11.5 5.9-20.3 12.9-25.9C67.8 52.8 113 32 192 32zM32 224V128H176v96H32zm0 128V256H192h83.8l9.1-32H208V128H344.6c8.4-14.5 22.3-25.4 38.9-29.8C381.8 79.5 375.6 59 358 45C329.2 22.2 276.5 0 192 0S54.8 22.2 26 45C4.5 62.1 0 88.9 0 110.2V352c0 23.7 12.9 44.4 32 55.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48H224V384H64c-17.7 0-32-14.3-32-32zm96-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM488 160c4.4 0 8 3.6 8 8v8H400v-8c0-4.4 3.6-8 8-8h80zm-120 8v9.2c-23.3 4.5-42.6 21.8-49.3 45.2L297 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-6.7-23.5-26-40.7-49.3-45.2V168c0-22.1-17.9-40-40-40H408c-22.1 0-40 17.9-40 40zm16 40H512h3.8c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0H336c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2H384zM608 432H288V416 368c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48v48 16zM360 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm200 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBracketCurly = {
  prefix: 'fal',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M64 112c0-44.2 35.8-80 80-80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-26.5 0-48 21.5-48 48v53.5c0 21.2-8.4 41.6-23.4 56.6L38.6 256l33.9 33.9c15 15 23.4 35.4 23.4 56.6V400c0 26.5 21.5 48 48 48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-44.2 0-80-35.8-80-80V346.5c0-12.7-5.1-24.9-14.1-33.9L4.7 267.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l45.3-45.3c9-9 14.1-21.2 14.1-33.9V112z"]
};
var faBracketCurlyLeft = faBracketCurly;
var faLobster = {
  prefix: 'fal',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M32 80c0-19.2 11.3-35.8 27.6-43.4L48.3 92.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l16-80c.9-4.7-.3-9.6-3.3-13.3S84.8 0 80 0C35.8 0 0 35.8 0 80v48c0 35.3 28.7 64 64 64c6.2 0 12.2-.9 17.9-2.5l26.9 20.1c19.4 14.5 43 22.4 67.2 22.4v24H143.1c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H176v16H122.4c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H176v16h-.9c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1h.9v0l18.5 51.7C169.7 444.6 152 468.2 152 496c0 8.8 7.2 16 16 16H344c8.8 0 16-7.2 16-16c0-27.8-17.7-51.4-42.5-60.3L336 384v0h.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H336V336h53.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H336V288h32.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H336V232c24.2 0 47.8-7.9 67.2-22.4l26.9-20.1c5.7 1.7 11.7 2.5 17.9 2.5c35.3 0 64-28.7 64-64V80c0-44.2-35.8-80-80-80c-4.8 0-9.3 2.1-12.4 5.9s-4.3 8.6-3.3 13.3l16 80c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L452.4 36.6C468.7 44.2 480 60.8 480 80v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 16.7 6.4 31.9 16.9 43.3L384 184c-13.8 10.4-30.7 16-48 16c0-25.6-14.7-48.9-32-67.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7v25c-3.2-2.2-6.3-4.1-9-5.8c-4.3-2.6-9.7-2.6-14 0c-2.8 1.6-5.8 3.6-9 5.8v-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v52.1c-17.3 18.3-32 41.6-32 67.2c-17.3 0-34.2-5.6-48-16l-16.9-12.7C121.6 159.9 128 144.7 128 128V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V80zM304 200v32 40 27.6c-1 .2-2.1 .4-3.3 .6c-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6V272 232 200v0c0-12.1 6.5-26.2 19.3-40.9c9-10.4 19.7-19.2 28.7-25.7c9.1 6.4 19.7 15.3 28.7 25.7C297.5 173.8 304 187.9 304 200v0zM208 332.2c11.6 2 27.7 3.8 48 3.8s36.4-1.8 48-3.8v15.4c-1 .2-2.1 .4-3.3 .6c-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6V332.2zM256 384c20 0 35.8-1.7 47.3-3.7l-5.5 15.5c-12.9 2.1-29.3 4.2-41.8 4.2s-28.9-2.1-41.8-4.2l-5.5-15.5c11.5 1.9 27.4 3.7 47.3 3.7zm-30.1 45.8c10 1.2 20.7 2.2 30.1 2.2s20.1-1 30.1-2.2c-2.9 15.2 5.7 30.7 20.7 36.1c7.2 2.6 13.2 7.6 17 14.2H188.3c3.8-6.5 9.7-11.6 17-14.2c15-5.4 23.6-20.8 20.7-36.1z"]
};
var faCartFlatbedEmpty = {
  prefix: 'fal',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", "M0 16C0 7.2 7.2 0 16 0H80c26.5 0 48 21.5 48 48V368c0 8.8 7.2 16 16 16h80H512 624c8.8 0 16 7.2 16 16s-7.2 16-16 16H567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faDollyFlatbedEmpty = faCartFlatbedEmpty;
var faColon = {
  prefix: 'fal',
  iconName: 'colon',
  icon: [192, 512, [], "3a", "M128 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 128zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 32 384z"]
};
var faCartArrowDown = {
  prefix: 'fal',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M0 16C0 7.2 7.2 0 16 0H53.9c22.8 0 42.5 16 47 38.4L145.4 256H466.5c14.7 0 27.5-10 31-24.2L544.5 44.1c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4L528.6 239.5C521.5 268 495.9 288 466.5 288H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2L69.6 44.8C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zM192 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM336 16l0 137.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L304 153.4 304 16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWand = {
  prefix: 'fal',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M446.8 9.9C454 3.5 463.2 0 472.8 0C494.5 0 512 17.5 512 39.2v.5c0 9-3.1 17.8-8.7 24.8L448 133.6V160c0 17.7-14.3 32-32 32H391.1L119 494.4C108.9 505.6 94.5 512 79.4 512c-14.1 0-27.7-5.6-37.6-15.6L15.6 470.2C5.6 460.2 0 446.7 0 432.6c0-15.1 6.5-29.5 17.7-39.6L96 323.1V296c0-22.1 17.9-40 40-40h33.9L446.8 9.9zm26 22.1c-1.8 0-3.5 .6-4.8 1.8L186.6 284c-2.9 2.6-6.7 4-10.6 4H136c-4.4 0-8 3.6-8 8v34.3c0 4.6-1.9 8.9-5.3 11.9L39.1 416.9c-4.5 4-7.1 9.7-7.1 15.8c0 5.6 2.2 11 6.2 14.9l26.2 26.2c4 4 9.4 6.2 15 6.2c6 0 11.8-2.6 15.8-7L372.1 165.3c3-3.4 7.4-5.3 11.9-5.3h32V128c0-3.6 1.2-7.2 3.5-10l58.8-73.5c1.1-1.4 1.7-3.1 1.7-4.8v-.5c0-4-3.2-7.2-7.2-7.2z"]
};
var faWalkieTalkie = {
  prefix: 'fal',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M96 16C96 7.2 88.8 0 80 0S64 7.2 64 16V96H56C25.1 96 0 121.1 0 152V302.1c0 10.6 4.2 20.8 11.7 28.3l17.9 17.9c1.5 1.5 2.3 3.5 2.3 5.7V456c0 30.9 25.1 56 56 56H296c30.9 0 56-25.1 56-56V353.9c0-2.1 .8-4.2 2.3-5.7l17.9-17.9c7.5-7.5 11.7-17.7 11.7-28.3V152c0-30.9-25.1-56-56-56H96V16zM80 128H328c13.3 0 24 10.7 24 24V302.1c0 2.1-.8 4.2-2.3 5.7l-17.9 17.9c-7.5 7.5-11.7 17.7-11.7 28.3V456c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V353.9c0-10.6-4.2-20.8-11.7-28.3L34.3 307.7c-1.5-1.5-2.3-3.5-2.3-5.7V152c0-13.3 10.7-24 24-24H80zm96-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM96 192c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faFilePen = {
  prefix: 'fal',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", "M64 480H258.6l-1.1 4.5c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V285.7l-32 32V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zm167 104c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 39.9 39.9 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L518.6 264zM342.4 417.5c-2.1 2.1-3.5 4.6-4.2 7.4L326 473.9l48.9-12.2c2.8-.7 5.4-2.2 7.4-4.2L488.5 351.3l-39.9-39.9L342.4 417.5zM473.3 241.4c18.7-18.7 49.1-18.7 67.9 0l17.3 17.3c18.7 18.7 18.7 49.1 0 67.9L405 480.1c-6.2 6.2-13.9 10.5-22.3 12.6l-74.8 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.8c2.1-8.4 6.5-16.2 12.6-22.3L473.3 241.4z"]
};
var faFileEdit = faFilePen;
var faReceipt = {
  prefix: 'fal',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M26.5 4C21.8-.2 15.1-1.2 9.4 1.4S0 9.7 0 16V496c0 6.3 3.7 12 9.4 14.6s12.4 1.6 17.1-2.5l52.7-46.1 45.4 45.4c6.2 6.2 16.4 6.2 22.6 0L192 462.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0l45.4-45.4L357.5 508c4.7 4.1 11.4 5.1 17.1 2.5s9.4-8.3 9.4-14.6V16c0-6.3-3.7-12-9.4-14.6S362.2-.2 357.5 4L304.7 50.1 259.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L192 49.4 147.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L79.3 50.1 26.5 4zM32 460.7V51.3L69.5 84c6.3 5.5 15.9 5.2 21.8-.7L136 38.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0L248 38.6l44.7 44.7c6 6 15.5 6.3 21.8 .7L352 51.3V460.7L314.5 428c-6.3-5.5-15.9-5.2-21.8 .7L248 473.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0L136 473.4 91.3 428.7c-6-6-15.5-6.3-21.8-.7L32 460.7zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
};
var faTablePicnic = {
  prefix: 'fal',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M191.6 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h88.2L115.8 224H16c-8.8 0-16 7.2-16 16s7.2 16 16 16l86.7 0h34.6H374.7h34.6l86.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H396.2L343.8 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H320.4c-.2 0-.5 0-.7 0H192.4c-.2 0-.5 0-.7 0zM309.3 96l52.4 128H150.4L202.7 96H309.3zM89.6 288L33.2 425.9c-3.3 8.2 .6 17.5 8.8 20.9s17.5-.6 20.9-8.8L124.2 288H89.6zm332.8 0H387.8l61.4 150.1c3.3 8.2 12.7 12.1 20.9 8.8s12.1-12.7 8.8-20.9L422.4 288z"]
};
var faSquarePen = {
  prefix: 'fal',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm299.5 67.3c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L213.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L254.2 140.7z"]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faCircleMicrophoneLines = {
  prefix: 'fal',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64s64-28.7 64-64V240 176 160c0-35.3-28.7-64-64-64zm32 64H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16V383c63.1-7.9 112-61.7 112-127V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96V240z"]
};
var faMicrophoneCircleAlt = faCircleMicrophoneLines;
var faDisplaySlash = {
  prefix: 'fal',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M32 110.3V352c0 35.3 28.7 64 64 64H245.1l-10.7 64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H392h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H405.6l-10.7-64h24.3l-40.5-32h-2.4c-.2 0-.4 0-.6 0H264.3c-.2 0-.4 0-.6 0H96c-17.7 0-32-14.3-32-32V135.6L32 110.3zm562.5 281C603 380.5 608 366.8 608 352V64c0-35.3-28.7-64-64-64H96c-1.5 0-3 .1-4.4 .2H99L139.4 32H544c17.7 0 32 14.3 32 32V352c0 7.3-2.5 14.1-6.6 19.5l25.1 19.8zM277.6 416h84.9l10.7 64H266.9l10.7-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faDesktopSlash = faDisplaySlash;
var faSuitcaseRolling = {
  prefix: 'fal',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M128 48v80H256V48c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 128V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v80h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H96zM80 448H304h16c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H272 112 64c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H80zM96 256c0-8.8 7.2-16 16-16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16z"]
};
var faPersonCircleExclamation = {
  prefix: 'fal',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faTransporter2 = {
  prefix: 'fal',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", "M64 16V32H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H16C7.2 64 0 56.8 0 48s7.2-16 16-16H32V16C32 7.2 39.2 0 48 0s16 7.2 16 16zM480 336v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s-7.2-16-16-16H144zM383.7 224H343.5l-22-29c-.5-.7-1-1.3-1.5-1.9V224H288V176.2c-1.6-.2-3.1-.2-4.7-.2H228.7c-1.6 0-3.2 .1-4.7 .2V224H192V193.1c-.5 .6-1 1.3-1.5 1.9l-22 29H128.3L165 175.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7L383.7 224zM96 272c0-8.8 7.2-16 16-16H400c8.8 0 16 7.1 16 15.9l0 .1 0 .1c0 8.8-7.2 15.9-16 15.9H112c-8.8 0-16-7.2-16-16zm64 64c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
};
var faHandsHoldingDiamond = {
  prefix: 'fal',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M342.6 9.4l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM224 128l96 96 96-96L320 32l-96 96zM64 64c35.3 0 64 28.7 64 64V252.3c0 4.6 .4 9.1 1.3 13.5c2.1-3.2 4.6-6.3 7.4-9.1c21.7-21.7 56.9-21.7 78.6 0L306.6 348c5.1 5.1 9.6 10.6 13.4 16.6c3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0c2.8 2.8 5.3 5.9 7.4 9.1c.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64V344.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V252.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 0 0 44-44 0 0c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.9c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16 0 0-44-44 0 0-10.7-10.8C106.8 305.4 96 279.4 96 252.3V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V344.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L32.8 423.4C11.8 402.4 0 373.9 0 344.2V128C0 92.7 28.7 64 64 64z"]
};
var faHandReceiving = faHandsHoldingDiamond;
var faMoneyBillSimpleWave = {
  prefix: 'fal',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", "M32 422.3c0 6.8 3.7 10.4 6.2 11.3c72.8 27.2 146.7 11.3 231.1-10.2c4.3-1.1 8.6-2.2 13-3.3c77.8-19.9 165.3-42.3 253.5-18.2c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0s0 0 0-.1V89.7c0-6.8-3.7-10.4-6.2-11.3C465 51.2 391.1 67.1 306.7 88.5c-4.3 1.1-8.6 2.2-13 3.3C215.9 111.7 128.4 134.1 40.2 110c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2c0 0 0 0 0 0l0 .1V422.3zm-32 0V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z"]
};
var faChevronDown = {
  prefix: 'fal',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"]
};
var faBatteryFull = {
  prefix: 'fal',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192H400c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM64 208v96c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faBellPlus = {
  prefix: 'fal',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM224 160c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V176c0-8.8 7.2-16 16-16z"]
};
var faBookArrowRight = {
  prefix: 'fal',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V272H416v96c0 8.8-7.2 16-16 16H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16v96h32V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM539.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L585.4 192H272c-8.8 0-16 7.2-16 16s7.2 16 16 16H585.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faHospitals = {
  prefix: 'fal',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M512 32H320c-17.7 0-32 14.3-32 32V80c-9.3-7-20.2-12-32-14.4V64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H320c-5.1 0-10-.6-14.7-1.7c6.3-8.9 10.9-19.2 13.2-30.3c.5 0 1.1 0 1.6 0H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM224 128H64c-17.7 0-32 14.3-32 32V352H256V160c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V384H32v64zM64 96H224c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM320 320V288H544v32H320zm0 96V384H544v32H320zM136 176h16c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H160v40c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8V256H88c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h40V184c0-4.4 3.6-8 8-8zM416 88c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H448v40c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V160H376c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h40V88z"]
};
var faClub = {
  prefix: 'fal',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M358.3 154.9c1.1-6.1 1.7-12.4 1.7-18.9c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 6.5 .6 12.8 1.7 18.9c1.6 8.8-.5 17.9-5.9 25s-13.5 11.7-22.4 12.6C73 197.8 32 242.1 32 296c0 57.4 46.6 104 104 104c39.7 0 74.2-22.2 91.8-55c5.6-10.4 16.4-16.9 28.2-16.9s22.6 6.5 28.2 16.9c17.6 32.8 52.1 55 91.8 55c57.4 0 104-46.6 104-104c0-53.9-41-98.2-93.4-103.5c-8.9-.9-17-5.5-22.4-12.6s-7.5-16.2-5.9-25zm31.5 5.8c7.4 .7 14.7 2.1 21.7 4C469.4 180.3 512 233.1 512 296c0 75.1-60.9 136-136 136c-39.4 0-74.9-16.8-99.7-43.5c-1.5-1.6-2.9-3.2-4.3-4.8V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V383.6c-1.4 1.6-2.8 3.3-4.3 4.8C210.9 415.2 175.4 432 136 432C60.9 432 0 371.1 0 296c0-62.9 42.6-115.8 100.6-131.3c7-1.9 14.3-3.2 21.7-4c-1.3-7.1-2.1-14.5-2.2-22c0-.9 0-1.8 0-2.7C120 60.9 180.9 0 256 0s136 60.9 136 136c0 .9 0 1.8 0 2.7c-.1 7.5-.9 14.8-2.2 22z"]
};
var faSkullCrossbones = {
  prefix: 'fal',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", "M300.1 198.4c-7.6 6.1-12.1 15.3-12.1 25V240c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V223.4c0-9.8-4.4-19-12.1-25C125.1 180.2 112 155 112 128c0-49.6 46.5-96 112-96s112 46.4 112 96c0 27-13.1 52.2-35.9 70.4zM320 240V223.4c29.5-23.4 48-57.5 48-95.4C368 57.3 303.5 0 224 0S80 57.3 80 128c0 37.9 18.5 72 48 95.4V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zm126.5 57.3c-3.7-8-13.2-11.5-21.2-7.8L224 382.4 22.7 289.5c-8-3.7-17.5-.2-21.2 7.8s-.2 17.5 7.8 21.2L185.8 400 9.3 481.5c-8 3.7-11.5 13.2-7.8 21.2s13.2 11.5 21.2 7.8L224 417.6l201.3 92.9c8 3.7 17.5 .2 21.2-7.8s.2-17.5-7.8-21.2L262.2 400l176.5-81.5c8-3.7 11.5-13.2 7.8-21.2zM208 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDropletDegree = {
  prefix: 'fal',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", "M192 480c-88.4 0-160-71.6-160-160c0-16.2 6.1-39.2 18.3-67.5c11.9-27.6 28.5-57.5 46.6-86.8c35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7c18.1 29.2 34.6 59.1 46.6 86.8C345.9 280.8 352 303.8 352 320c0 88.4-71.6 160-160 160zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zM384 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faDewpoint = faDropletDegree;
var faCodeCompare = {
  prefix: 'fal',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M322.8 484.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6L265.4 400H336c44.2 0 80-35.8 80-80V158.4c-36.5-7.4-64-39.7-64-78.4c0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V320c0 61.9-50.1 112-112 112H265.4l57.4 52.2zM384 80a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM189.2 27.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6L246.6 112H176c-44.2 0-80 35.8-80 80V353.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V192c0-61.9 50.1-112 112-112h70.6L189.2 27.8zM128 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faListUl = {
  prefix: 'fal',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM176 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faListDots = faListUl;
var faHandHoldingMagic = {
  prefix: 'fal',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M160 80c0 26.5 21.5 48 48 48h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-44.2 0-80-35.8-80-80s35.8-80 80-80H328c66.3 0 120 53.7 120 120s-53.7 120-120 120H272v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.5c0-16.3 13.2-29.5 29.5-29.5H328c48.6 0 88-39.4 88-88s-39.4-88-88-88H208c-26.5 0-48 21.5-48 48zm-9 237.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faWatermelonSlice = {
  prefix: 'fal',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0C481.5 58.9 512 132.5 512 209.1v4C512 378.2 378.2 512 213.2 512h-4c-76.7 0-150.2-30.5-204.5-84.7c-6.2-6.2-6.2-16.4 0-22.6l400-400zm11 34.3L391 63.7c35.5 40.8 57 94 57 152.3c0 128.1-103.9 232-232 232c-58.3 0-111.6-21.5-152.3-57L39 415.6C85.8 457 146.3 480 209.1 480h4C360.5 480 480 360.5 480 213.2v-4c0-62.8-23-123.3-64.4-170.2zM86.3 368.3C121.3 398 166.5 416 216 416c110.5 0 200-89.5 200-200c0-49.5-18-94.7-47.7-129.7L86.3 368.3zm261-203.6l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-168 72l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faCircleEllipsis = {
  prefix: 'fal',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM184 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faSchoolLock = {
  prefix: 'fal',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64V272c0-30.5-12.2-58.2-32-78.4V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2 184.9 125.3c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 11.7 3.1 22.6 8.6 32H384 352 288 256 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H171.2l140-93.3zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64V384zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm0 32v64h32V192H128zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V352zm64 0H128v64h32V352zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm16 64v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 64c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272zm160 80H448V480H608V352z"]
};
var faTowerCell = {
  prefix: 'fal',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M40.9 9.1c-8.2-3.2-17.5 .9-20.7 9.2C7.2 52.2 0 89.2 0 128s7.2 75.8 20.3 109.8c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C38.4 196 32 162.8 32 128s6.4-67.9 18.1-98.2c3.2-8.2-.9-17.5-9.2-20.7zm494.1 0c-8.2 3.2-12.4 12.4-9.2 20.7C537.6 60.1 544 93.2 544 128s-6.4 67.9-18.1 98.2c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2c13.1-33.9 20.3-71 20.3-109.8s-7.2-75.8-20.3-109.8c-3.2-8.2-12.4-12.4-20.7-9.2zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm47.3 75.1C345.7 159.7 352 144.6 352 128c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 16.6 6.3 31.7 16.7 43.1L97.4 489.4c-3.6 8.1 0 17.5 8 21.2s17.5 0 21.2-8l39-86.6H410.5l39 86.6c3.6 8.1 13.1 11.7 21.2 8s11.7-13.1 8-21.2L335.3 171.1zM396.1 384H179.9l28.8-64H367.3l28.8 64zM308.2 188.8L352.9 288H223.1l44.7-99.2c6.3 2.1 13.1 3.3 20.2 3.3s13.8-1.1 20.2-3.3zM140 70.4c3.5-8.1-.2-17.5-8.3-21.1s-17.5 .2-21.1 8.3C101.2 79.2 96 103 96 128s5.2 48.8 14.7 70.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1c-7.7-17.6-12-37.1-12-57.6s4.3-40 12-57.6zM465.3 57.6c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c7.7 17.6 12 37.1 12 57.6s-4.3 40-12 57.6c-3.5 8.1 .2 17.5 8.3 21.1s17.5-.2 21.1-8.3C474.8 176.8 480 153 480 128s-5.2-48.8-14.7-70.4z"]
};
var faSdCards = {
  prefix: 'fal',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M416 368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V154.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4H384c17.7 0 32 14.3 32 32V368zM448 64c0-35.3-28.7-64-64-64H234.5c-17 0-33.3 6.7-45.3 18.7L98.7 109.3c-12 12-18.7 28.3-18.7 45.3V368c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64zM240 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faJugBottle = {
  prefix: 'fal',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", "M128 64V32h64V64H128zM96 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32 64 32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24V64zm32 96H256c53 0 96 43 96 96v8h0v9.7V296v80 20.2V408h0v40c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48s48-21.5 48-48V256c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256zM404 494.6c13.2 10.9 30.1 17.4 48.4 17.4H564c42 0 76-34 76-76c0-19.5-7.4-37.3-19.5-50.8C632.6 372.3 640 355 640 336c0-18.8-7.2-35.9-19-48.8c11.8-13.2 19-30.6 19-49.7c0-28.9-16.7-55.2-42.9-67.5l-4.7-2.2c-11-5.1-23-7.8-35.1-7.8H468.8c-13.5 0-26.9 3-39.1 8.7l-9.6 4.5c-7.4 3.5-14.1 8.1-19.8 13.7c5.7 11.8 9.9 24.4 12.6 37.7c3.7-9.7 11.1-17.8 20.8-22.3l9.6-4.5c8-3.7 16.7-5.7 25.5-5.7h88.5c7.4 0 14.8 1.6 21.5 4.8l4.7 2.2c14.9 7 24.5 22 24.5 38.5c0 10.9-4.1 20.8-10.9 28.4c-11 12.3-10.9 30.9 .3 43.1C604 316.1 608 325.5 608 336c0 10.6-4.1 20.2-10.8 27.3c-11.4 12.1-11.6 30.9-.5 43.3c7 7.8 11.3 18.1 11.3 29.4c0 24.3-19.7 44-44 44H452.4c-15.5 0-29.3-8-37.1-20.4c-1.5 12.5-5.5 24.3-11.3 34.9zM480 104c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v24h32V104c0-22.1-17.9-40-40-40H488c-22.1 0-40 17.9-40 40v24h32V104z"]
};
var faDownLong = {
  prefix: 'fal',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", "M88 352H38.7c-3.7 0-6.7 3-6.7 6.7c0 1.9 .8 3.7 2.2 5L160 476.2 285.8 363.7c1.4-1.3 2.2-3.1 2.2-5c0-3.7-3-6.7-6.7-6.7H232c-17.7 0-32-14.3-32-32V48c0-8.8-7.2-16-16-16H136c-8.8 0-16 7.2-16 16V320c0 17.7-14.3 32-32 32zm86 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L12.9 387.5C4.7 380.2 0 369.7 0 358.7C0 337.3 17.3 320 38.7 320H56 88V288 48c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V288v32h32 17.3c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.5-12.9 28.8L174 506.7z"]
};
var faLongArrowAltDown = faDownLong;
var faEnvelopes = {
  prefix: 'fal',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M512 64c17.7 0 32 14.3 32 32v19.6L364.4 247.3c-16.9 12.4-39.9 12.4-56.8 0L128 115.6V96c0-17.7 14.3-32 32-32H512zM128 320V155.3L288.7 273.1c28.2 20.7 66.5 20.7 94.6 0L544 155.3V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"]
};
var faPhoneOffice = {
  prefix: 'fal',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", "M176 32c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h32zM144 0C120.3 0 99.6 12.9 88.6 32H64C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480 320 231.4C220.4 12.9 199.7 0 176 0H144zM288 64v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V64c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32l16 0V368c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V64h48zm192 0v64H320V64H480zM352 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM480 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
};
var faRankingStar = {
  prefix: 'fal',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", "M300.5 77.2l-3.7 7.5-8.3 1.2L245 92.2 276.6 123l6 5.9-1.4 8.3-7.4 43.3 39-20.6 7.4-3.9 7.5 3.9 38.7 20.3-7.4-43.3-1.4-8.3 6.1-5.9 31.4-30.3-43.4-6.3-8.3-1.2-3.7-7.5L320 37.8 300.5 77.2zm-5-62c10.3-20.6 39.4-19.9 49.1 .1l19.9 40.2 44 6.3 .2 0 0 0c22.1 3.4 31.5 30.6 15.3 46.9l-.2 .2 0 0-31.9 30.8 7.5 43.7 0 .3 0 0c3.4 22-19.5 39.1-39.8 28.9l-.3-.1 0 0L320.2 192l-39.5 20.9-.3 .2 0 0c-20.3 10.2-43.2-6.9-39.8-28.9l0-.3 0 0 7.5-43.8-31.9-31.1-.2-.2 0 0c-16.2-16.2-6.7-43.5 15.3-46.9l.2 0 0 0 44-6.3 19.9-40.2 0 0zM192 368v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm224 64v32c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V368 304c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432zM256 304V464c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM32 368v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm448 64v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16zm16-48h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48z"]
};
var faChessKing = {
  prefix: 'fal',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48H168c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v48H59.6C26.7 128 0 154.7 0 187.6c0 8.2 1.7 16.3 4.9 23.8L66.1 352H101L34.3 198.6c-1.5-3.5-2.3-7.2-2.3-11C32 172.4 44.4 160 59.6 160H224 388.4c15.2 0 27.6 12.4 27.6 27.6c0 3.8-.8 7.5-2.3 11L347 352h34.9l61.1-140.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H240V80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V16zM382.9 468.7c.7 1.2 1.1 2.5 1.1 3.9c0 4.1-3.3 7.4-7.4 7.4H71.4c-4.1 0-7.4-3.3-7.4-7.4c0-1.4 .4-2.7 1.1-3.9L97.8 416l252.4 0 32.7 52.7zM97.8 384c-11.1 0-21.4 5.7-27.2 15.1L37.9 451.8C34.1 458 32 465.2 32 472.6C32 494.3 49.7 512 71.4 512H376.6c21.8 0 39.4-17.7 39.4-39.4c0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1H97.8z"]
};
var faNfcPen = {
  prefix: 'fal',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H266.3l-8 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V220.2l-32 32V96c0-17.7-14.3-32-32-32zm0 64V284.2l-32 32V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32zM276.2 408.3l-1.9 7.7H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0V384H286.7c-4.8 7.4-8.4 15.6-10.5 24.3zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm294.8 24c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40L536.2 304c6.2-6.2 6.2-16.4 0-22.6L518.8 264zM342.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2L488.7 351.4l-40-40L342.5 417.7zM473.5 241.4c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3L473.5 241.4z"]
};
var faPersonHarassing = {
  prefix: 'fal',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M216 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zM112 320h64V161.2c-3.4-.8-6.9-1.2-10.5-1.2H131.3c-6.8 0-13.3 1.4-19.3 4V320zm179.8-37.6L208 183.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H112V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.2L30.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L60.7 170.3c13.9-26 41-42.3 70.6-42.3h34.2c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8zM304 32h56c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 272a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm88 96c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1L464 439.6V344c0-30.9 25.1-56 56-56zm0 192c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z"]
};
var faHatWinter = {
  prefix: 'fal',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M256 32c7.2 11.3 20.8 16.9 33.9 14l0 0 0 0C287 59.2 292.6 72.8 304 80l0 0 0 0c-11.3 7.2-16.9 20.8-14 33.9l0 0 0 0c-13.1-2.9-26.7 2.7-33.9 14l0 0 0 0c-7.2-11.3-20.8-16.9-33.9-14l0 0 0 0c2.9-13.1-2.7-26.7-14-33.9l0 0 0 0c11.3-7.2 16.9-20.8 14-33.9l0 0 0 0c13.1 2.9 26.7-2.7 33.9-14l0 0 0 0zm56.5-8.6c-8-8-19.3-10.9-29.6-8.6C277.3 5.9 267.3 0 256 0s-21.3 5.9-27 14.8c-10.3-2.3-21.5 .6-29.6 8.6s-10.9 19.3-8.6 29.6C181.9 58.7 176 68.7 176 80s5.9 21.3 14.8 27c-2.3 10.3 .6 21.5 8.6 29.6s19.3 10.9 29.6 8.6c5.7 8.9 15.7 14.8 27 14.8s21.3-5.9 27-14.8c10.3 2.3 21.5-.6 29.6-8.6s10.9-19.3 8.6-29.6c8.9-5.7 14.8-15.7 14.8-27s-5.9-21.3-14.8-27c2.3-10.3-.6-21.5-8.6-29.6zM32 456c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM0 456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56s-25.1-56-56-56H56c-30.9 0-56 25.1-56 56zM162.5 134.6C64.3 188.2 39.4 321.8 33.6 368H65.9c.8-5.8 1.9-12.8 3.3-20.6c.5-2.9 1.1-5.9 1.8-9l8.2-4.1L127.8 310c4.8-2.4 10.4-2.2 15.1 .4l26.3 15c13.9 8 30.9 8.4 45.3 1.3l34.4-17.2c4.5-2.3 9.8-2.3 14.3 0l34.4 17.2c14.4 7.2 31.3 6.7 45.3-1.3l26.3-15c4.6-2.7 10.3-2.8 15.1-.4l48.7 24.3 8.2 4.1c.6 3.1 1.2 6.1 1.8 9c1.5 7.9 2.5 14.8 3.3 20.6h32.3c-5.8-46.2-30.7-179.8-128.8-233.4c-2.5 9-7.3 17.5-14.4 24.6c-.9 .9-1.8 1.8-2.8 2.6c40.1 21.1 66.4 58.5 84.3 99.1c5.4 12.2 9.9 24.5 13.6 36.4l-31.9-15.9c-14.4-7.2-31.3-6.7-45.3 1.3l-26.3 15c-4.6 2.7-10.3 2.8-15.1 .4l-34.4-17.2c-13.5-6.8-29.4-6.8-42.9 0L200.2 298c-4.8 2.4-10.4 2.2-15.1-.4l-26.3-15c-13.9-8-30.9-8.4-45.3-1.3L81.6 297.3c3.7-11.9 8.2-24.2 13.6-36.4c17.9-40.6 44.3-78 84.3-99.1c-1-.8-1.9-1.7-2.8-2.6c-7.1-7.1-11.9-15.6-14.4-24.6z"]
};
var faBrazilianRealSign = {
  prefix: 'fal',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M400 0c8.8 0 16 7.2 16 16V64.5c16.8 1.4 33.3 5.4 48.9 11.9L478.2 82c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6l-13.3-5.6C436.9 99.4 420 96 403 96H387.3c-37.2 0-67.3 30.1-67.3 67.3c0 28.6 18.1 54.1 45.1 63.6l80.3 28c39.9 13.9 66.6 51.5 66.6 93.8c0 53.7-42.7 97.5-96 99.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V447.5c-22.1-1.8-43.5-8.6-62.6-20l-25.6-15.3c-7.6-4.5-10-14.4-5.5-21.9s14.4-10.1 21.9-5.5l25.6 15.3c17.4 10.4 37.3 15.9 57.5 15.9h17.3c37.2 0 67.3-30.1 67.3-67.3c0-28.6-18.1-54.1-45.1-63.6l-80.3-28c-39.9-13.9-66.6-51.5-66.6-93.8c0-53.7 42.7-97.5 96-99.3V16c0-8.8 7.2-16 16-16zM0 80C0 53.5 21.5 32 48 32h64c79.5 0 144 64.5 144 144c0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3L119.9 319.8c-2.6 .1-5.3 .2-7.9 .2H32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 80zM32 288h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V288z"]
};
var faLandmarkDome = {
  prefix: 'fal',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M256 0c8.8 0 16 7.2 16 16V32.7c87.9 7.2 159 73.7 173.3 159.3H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H448 416 96 64 48c-8.8 0-16-7.2-16-16s7.2-16 16-16H66.7C81 106.3 152.1 39.9 240 32.7V16c0-8.8 7.2-16 16-16zM99.2 192H412.8C398 119 333.4 64 256 64s-142 55-156.8 128zM64 352V256H96v96h80V256h32v96h96V256h32v96h80V256h32v96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM24 432c0-8.8 7.2-16 16-16H472c8.8 0 16 7.2 16 16s-7.2 16-16 16H40c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faLandmarkAlt = faLandmarkDome;
var faBoneBreak = {
  prefix: 'fal',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M320 0c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM164.7 68.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm310.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zM270.7 244.3c-2.3-8.5-11.1-13.6-19.6-11.3l-73.4 19.7c-4 1.1-8.1-1.1-9.9-4.9c-17.7-38.1-60.6-59.1-102.6-47.8C18.3 212.6-9.6 260.8 3 307.8C9.7 332.6 26.3 352 47.4 363c4.9 2.6 6.7 9.1 3.7 13.8c-12.8 20.1-17.4 45.3-10.8 70.1c12.6 46.9 60.8 74.8 107.8 62.2c41.9-11.2 68.6-50.9 64.9-92.7c-.4-4.1 2.1-8.1 6.1-9.1l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-73.4 19.7c-20.6 5.5-31.3 24.9-29.7 42.9c2.4 26.6-14.7 51.8-41.3 59c-29.9 8-60.6-9.7-68.6-39.6c-4.2-15.8-1.3-31.8 6.9-44.6c13.1-20.5 5.7-48.1-15.9-59.3c-13.5-7-24-19.4-28.2-35.2c-8-29.9 9.7-60.6 39.6-68.6c26.6-7.1 54 6.2 65.3 30.4c7.6 16.3 26.6 27.8 47.2 22.3l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6zM388.9 233c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6L454 283.6c20.6 5.5 39.6-5.9 47.2-22.3c11.2-24.2 38.6-37.5 65.3-30.4c29.9 8 47.6 38.7 39.6 68.6c-4.2 15.8-14.7 28.2-28.2 35.2c-21.6 11.2-28.9 38.8-15.9 59.3c8.2 12.8 11.1 28.8 6.9 44.6c-8 29.9-38.7 47.6-68.6 39.6c-26.6-7.1-43.7-32.4-41.3-59c1.6-18-9.1-37.4-29.7-42.9l-73.4-19.7c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l73.4 19.7c4 1.1 6.5 5 6.1 9.1c-3.7 41.8 23 81.5 64.9 92.7c46.9 12.6 95.2-15.3 107.8-62.2c6.6-24.8 2-50-10.8-70.1c-3-4.7-1.2-11.2 3.7-13.8c21.1-11 37.7-30.5 44.4-55.3c12.6-46.9-15.3-95.2-62.2-107.8c-41.9-11.2-84.9 9.8-102.6 47.8c-1.7 3.8-5.9 5.9-9.9 4.9L388.9 233z"]
};
var faArrowUp = {
  prefix: 'fal',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6L356.7 235.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-176-176z"]
};
var faDownFromDottedLine = {
  prefix: 'fal',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", "M222.2 447.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 315.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7H288c-8.8 0-16-7.2-16-16V168c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8V288c0 8.8-7.2 16-16 16H102.7c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 447.2zM224 480c-9.5 0-18.6-3.9-25.1-10.8L74.5 337.2C67.8 330 64 320.5 64 310.7c0-21.4 17.3-38.7 38.7-38.7H144V168c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40V272h41.3c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.4-10.5 26.5L249.1 469.2c-6.5 6.9-15.6 10.8-25.1 10.8zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTv = {
  prefix: 'fal',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 32C46.3 32 32 46.3 32 64V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faBorderLeft = {
  prefix: 'fal',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M16 480c-8.8 0-16-7.2-16-16L0 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 416c0 8.8-7.2 16-16 16zm112-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 472a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM224 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 472a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM224 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192 48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 184a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faCircleDivide = {
  prefix: 'fal',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-96 56c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zM280 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faShrimp = {
  prefix: 'fal',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M0 96C0 60.7 28.7 32 64 32H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H64C46.3 64 32 78.3 32 96s14.3 32 32 32H336c97.2 0 176 78.8 176 176s-78.8 176-176 176H240c-8.8 0-16-7.2-16-16c0-4.4 1.8-8.4 4.7-11.3L265.4 416l-36.7-36.7c-5-5-6.1-12.7-2.7-19s10.5-9.5 17.4-8L348.9 375c3.2 .7 6.4 1 9.7 1c14 0 25.4-11.4 25.4-25.4V348c0-15.5-12.5-28-28-28H240c-91.8 0-167.2-70.3-175.3-160H64C28.7 160 0 131.3 0 96zM336 448V404.9L289.6 395l9.7 9.7c6.2 6.2 6.2 16.4 0 22.6L278.6 448H336zm32-3.6c33-7.5 61.7-26.3 81.7-52.1l-39.8-15.9c-8.1 16.1-23.5 27.8-41.9 30.8v37.2zm98.7-79.8c8.6-18.4 13.3-39 13.3-60.6c0-9.3-.9-18.3-2.5-27.1l-67.4 45c3.3 6.9 5.4 14.4 5.9 22.4l50.8 20.3zm.8-119.5C447 199.6 403.6 166.6 352 160.9V288h4c12 0 23.3 3.6 32.7 9.7l78.8-52.5zM320 160H96.9c8 72 69 128 143.1 128h80V160zM208 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faListCheck = {
  prefix: 'fal',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", "M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTasks = faListCheck;
var faDiagramSubtask = {
  prefix: 'fal',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", "M448 64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H144 112 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM144 224H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h48v96c0 44.2 35.8 80 80 80h32v16c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H288c-35.3 0-64 28.7-64 64v16H192c-26.5 0-48-21.5-48-48V224zm304 96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H448z"]
};
var faJugDetergent = {
  prefix: 'fal',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M128 64V32h64V64H128zM96 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H96h32 64 32 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V24c0-13.3-10.7-24-24-24H120C106.7 0 96 10.7 96 24V64zm32 96H256c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48s48-21.5 48-48V256c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256z"]
};
var faCircleUser = {
  prefix: 'fal',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
};
var faUserCircle = faCircleUser;
var faSquareY = {
  prefix: 'fal',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm124 53.5L224 263.7 324 149.5c5.8-6.7 15.9-7.3 22.6-1.5s7.3 15.9 1.5 22.6L240 294v90c0 8.8-7.2 16-16 16s-16-7.2-16-16V294L100 170.5c-5.8-6.7-5.1-16.8 1.5-22.6s16.8-5.1 22.6 1.5z"]
};
var faUserDoctorHair = {
  prefix: 'fal',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM228.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm80 208v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V339.8C80.2 354.7 32.6 411.8 32 480H416c-.5-62.4-40.4-115.4-96-135.5v25.8c23.1 6.9 40 28.3 40 53.7v24c0 8.8-7.2 16-16 16H328c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V424c0-25.4 16.9-46.8 40-53.7V337c-5.6-.7-11.4-1-17.2-1H177.2l-1.2 0zm-32 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2z"]
};
var faPlanetRinged = {
  prefix: 'fal',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", "M480 32c-2.5 0-6.6 .4-12.8 1.9c-15.8 3.9-37.7 13.4-64.7 29.3l-2 1.2c-9.5-7.2-19.5-13.6-29.8-19.2c63.8-40.5 113.9-56.2 133.1-37c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208c-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1c5.6 10.3 12 20.2 19.2 29.8l-1.2 2c-15.9 27-25.5 48.9-29.3 64.7C32.4 473.5 32 477.5 32 480c2.5 0 6.6-.4 12.8-1.9c15.8-3.9 37.7-13.4 64.7-29.3c9.9-5.9 20.3-12.5 31.1-19.7C84.7 391.7 48 328.2 48 256C48 141.1 141.1 48 256 48c72.2 0 135.7 36.7 173 92.5c7.3-10.8 13.9-21.1 19.7-31.1c15.9-26.9 25.5-48.9 29.3-64.7c1.5-6.3 1.9-10.3 1.9-12.8zM408.9 168.8C378.6 115.8 321.5 80 256 80C158.8 80 80 158.8 80 256c0 65.5 35.8 122.6 88.8 152.9C209 379.1 253 341.1 297.1 297.1s82-88.1 111.9-128.2zM202.3 423.7c16.9 5.4 34.9 8.3 53.7 8.3c97.2 0 176-78.8 176-176c0-18.7-2.9-36.7-8.3-53.7c-29 37.6-64.2 77.6-104 117.3s-79.8 74.9-117.3 104z"]
};
var faMushroom = {
  prefix: 'fal',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M130.8 105c17.5 23.6 45.6 39 77.2 39c46.1 0 84.6-32.5 93.9-75.9c41 8.6 77.3 30.1 104.3 60.2c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64c22.4 0 42.1-11.5 53.5-28.9c1.6 10.1 2.5 20.5 2.5 31c0 16.5-13.4 29.9-29.9 29.9H288 224 85.9C69.4 288 56 274.6 56 258.1c0-62.2 29.3-117.6 74.8-153.1zM116.1 75.9C60.3 117.1 24 183.4 24 258.1C24 292.3 51.7 320 85.9 320H191.4 224h64 32.6H426.1c34.2 0 61.9-27.7 61.9-61.9C488 133.2 386.8 32 261.9 32H250.1c-38 0-73.9 9.4-105.3 26c0 0 0 0 0 0c-10 5.3-19.6 11.3-28.6 18c0 0 0 0 0 0zm41.5 11.5c27.5-14.9 59-23.4 92.5-23.4h11.8c2.7 0 5.4 .1 8 .2C262.8 91.7 237.8 112 208 112c-20.5 0-38.7-9.6-50.4-24.6zM326.6 352H294l18 96-112 0 18-96H185.4l-16.9 90.1c-1.8 9.4 .7 19 6.8 26.3s15.1 11.6 24.6 11.6H312c9.5 0 18.5-4.2 24.6-11.6s8.6-17 6.8-26.3L326.6 352zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm208-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserShield = {
  prefix: 'fal',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480H388.1c10.3 11.3 22.1 21.9 35.5 31.5c-1.7 .3-3.5 .5-5.3 .5H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c17.6 0 34.6 2.6 50.7 7.3c.6 11 1.9 22.9 4.1 35.3c-16.9-6.9-35.5-10.6-54.9-10.6H178.3c-80 0-145 64.3-146.3 144zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384.1 301.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L512 263V471.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C634 277.4 640 286.2 640 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C377.9 464.8 352 359.3 352 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"]
};
var faMegaphone = {
  prefix: 'fal',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", "M560 32c-8.8 0-16 7.2-16 16V59.5L32 187.5V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v19.5V208v96 12.5V336c0 8.8 7.2 16 16 16s16-7.2 16-16V324.5l131.7 32.9c-2.4 8.4-3.7 17.4-3.7 26.6c0 53 43 96 96 96c46.2 0 84.7-32.6 93.9-76L544 452.5V464c0 8.8 7.2 16 16 16s16-7.2 16-16V440 72 48c0-8.8-7.2-16-16-16zM544 419.5L32 291.5v-71l512-128v327zM192 384c0-6.5 1-12.9 2.8-18.8l124 31C313.1 425.7 287.2 448 256 448c-35.3 0-64-28.7-64-64z"]
};
var faWreathLaurel = {
  prefix: 'fal',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M384 32c44.2 0 80 35.8 80 80c-44.2 0-80-35.8-80-80zM494.6 94C486 40.7 439.7 0 384 0H368c-8.8 0-16 7.2-16 16V32c0 61.9 50.1 112 112 112h8.1c25.7 31.5 39.9 71 39.9 112c0 72.8-40.5 136.1-100.2 168.7c9.4 2.3 18.7 5 27.8 8.2l0 0c12.3 4.3 24.3 9.3 36 15.2l4.6 2.3c51.5 9 105.4-14.2 133-62.1L630 359c3.9-6.8 1.6-15.5-5.2-19.4c-11.4-6.6-23.6-11-35.9-13.3c31-23.4 51-60.5 51-102.3V190.2c0-7.9-6.4-14.2-14.2-14.2c-13.2 0-25.9 2.3-37.7 6.4c15.2-35.7 14-77.9-6.9-114.1L564.2 39c-3.9-6.8-12.6-9.1-19.4-5.2c-24.3 14-41.5 35.7-50.2 60.2zM319.8 480l.2 0h19.6c37.3 0 74 8.7 107.3 25.3l9.9 5c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-9.9-5C423.4 457.8 381.8 448 339.6 448H320c-106 0-192-86-192-192c0-41 14.2-80.5 39.9-112H176c61.9 0 112-50.1 112-112V16c0-8.8-7.2-16-16-16H256C200.3 0 154 40.7 145.4 94c-8.8-24.5-25.9-46.2-50.2-60.2c-6.8-3.9-15.5-1.6-19.4 5.2L58.9 68.3C38 104.5 36.8 146.7 51.9 182.4c-11.8-4.1-24.5-6.4-37.7-6.4C6.4 176 0 182.4 0 190.2V224c0 41.8 20 78.9 51 102.3c-12.3 2.3-24.4 6.7-35.9 13.3C8.4 343.5 6.1 352.2 10 359l16.9 29.3c29.8 51.7 90.2 74.7 145.1 59.4c6.9-1.9 13.7-4.4 20.3-7.6c10.2 7.1 21 13.4 32.4 18.7c-15.8 4.6-31.1 10.6-45.9 18l-9.9 5c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l9.9-5c33.3-16.7 70.1-25.3 107.3-25.3h19.3zM176 112c0-21.6 8.5-41.2 22.4-55.5C213 41.4 233.4 32 256 32c0 44.2-35.8 80-80 80zM96 289.8v24.8C58.7 301.4 32 265.8 32 224V209.9c36.6 8.1 64 40.8 64 79.8zm448 24.8V289.8c0-39.1 27.4-71.7 64-79.8V224c0 41.8-26.7 77.4-64 90.5zM142.9 397.3l12.4 21.4c-38.9 7.2-79.8-10.2-100.7-46.4l-7-12.2c35.8-11.3 75.8 3.3 95.3 37.1zM96.7 194.7C71 164.6 65.7 120.5 86.6 84.3l7-12.2c27.7 25.3 35 67.3 15.5 101.1L96.7 194.7zm434.1-21.4c-19.5-33.8-12.1-75.8 15.5-101.1l7 12.2c20.9 36.2 15.5 80.4-10.2 110.4l-12.4-21.4zm-33.8 224c19.5-33.8 59.6-48.4 95.3-37.1l-7 12.2c-20.9 36.2-61.8 53.6-100.7 46.4l12.4-21.4z"]
};
var faCircleExclamationCheck = {
  prefix: 'fal',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M32 256C32 132.3 132.3 32 256 32c95.3 0 176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C458 68 364.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c75.8 0 144-33 190.8-85.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3c-41 45.9-100.6 74.7-167 74.7C132.3 480 32 379.7 32 256zM272 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM256 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM619.3 180.7c-6.2-6.2-16.4-6.2-22.6 0L480 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faWind = {
  prefix: 'fal',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 16c0 8.8 7.2 16 16 16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c44.2 0 80-35.8 80-80s-35.8-80-80-80H304c-8.8 0-16 7.2-16 16zm64 384c0 8.8 7.2 16 16 16h56c48.6 0 88-39.4 88-88s-39.4-88-88-88H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H424c30.9 0 56 25.1 56 56s-25.1 56-56 56H368c-8.8 0-16 7.2-16 16zM112 512h64c44.2 0 80-35.8 80-80s-35.8-80-80-80H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H176c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16z"]
};
var faBoxDollar = {
  prefix: 'fal',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM240 216c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V424c0 8.8 7.2 16 16 16s16-7.2 16-16V406.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V216z"]
};
var faBoxUsd = faBoxDollar;
var faCarBurst = {
  prefix: 'fal',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M190.5 17.3C187.9 11.6 182.2 8 176 8s-11.9 3.6-14.5 9.3L129.4 87.2 54.7 68.7c-6.1-1.5-12.5 .7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6L10.3 206.9c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l25.7-21.3c.3-2.9 .8-5.8 1.6-8.7l11.8-43.9-32.7 27 1-55.3c.1-7.7-5.2-14.4-12.7-15.9L57.4 211.1l43.8-33.7c6.1-4.7 8-13 4.5-19.9L80.9 108.1l53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l48.2-11.9 23.2-38.7L222.6 87.2 190.5 17.3zM380.9 86.9l164.4 44c13.8 3.7 23.5 16.1 23.7 30.4l1.3 75.7-264-70.7 38.9-64.9c7.3-12.3 21.9-18.2 35.7-14.5zm-63.2-2l-46.2 77c-32.6 2.9-61.4 25.6-70.3 59L175 318.8c-.3 1.3-.6 2.6-.7 3.8l-.3-.1L159.1 378c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l9.7-36 360.5 96.6-9.7 36.1c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l15.4-57.5-.1 0c.2-.6 .4-1.1 .5-1.7l26.2-97.8c8.9-33.4-4.6-67.5-31.4-86.3L601 160.8c-.5-28.6-19.8-53.4-47.4-60.8L389.2 56c-27.6-7.4-56.8 4.4-71.5 28.9zM569 269.8c25.6 6.9 40.8 33.2 33.9 58.8l-24.1 90.1L208 319.3l24.1-90.1c6.9-25.6 33.2-40.8 58.8-33.9l278 74.5zM278.3 294a28 28 0 1 0 14.5-54.1A28 28 0 1 0 278.3 294zm286.6 47.8a28 28 0 1 0 -54.1-14.5 28 28 0 1 0 54.1 14.5z"]
};
var faCarCrash = faCarBurst;
var faY = {
  prefix: 'fal',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M28.9 38.5c-5.2-7.1-15.2-8.7-22.4-3.4S-2.1 50.3 3.1 57.5L176 293.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V293.2L380.9 57.5c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L192 260.9 28.9 38.5z"]
};
var faUserHeadset = {
  prefix: 'fal',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.4c15.2-17 24.4-39.4 24.4-64c0-53-43-96-96-96s-96 43-96 96c0 24.6 9.3 47.1 24.5 64.1c-5.4 9.4-8.5 20.3-8.5 31.9c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352h16 16 64 9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352H208zm105.6 32H134.4C80 384 35.5 426.4 32.2 480H415.8c-3.3-53.6-47.8-96-102.2-96z"]
};
var faArrowsRetweet = {
  prefix: 'fal',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M116.7 68.7c6.2-6.2 16.4-6.2 22.6 0l88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 118.6V336c0 26.5 21.5 48 48 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-44.2 0-80-35.8-80-80V118.6L51.3 179.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88-88zM528 393.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-6.2 6.2-16.4 6.2-22.6 0l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 393.4V176c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c44.2 0 80 35.8 80 80V393.4z"]
};
var faRetweetAlt = faArrowsRetweet;
var faPersonSnowboarding = {
  prefix: 'fal',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", "M221.3 7.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l40.6 61c7.1 10.6 18 17.9 30.5 20.4l37 7.4-83.3 39.2c-16.8 7.9-27.6 24.8-27.6 43.4l0 83.1-88.9 59.3c-4.2 2.8-6.6 7.2-7.1 11.8l-18.9-7.4c-7.5-3-14.2-7.8-19.4-14L28.3 293.8c-5.7-6.8-15.7-7.7-22.5-2s-7.7 15.7-2 22.5l29.5 35.4C41.8 360 52.9 368 65.5 372.9L406.9 506.5c9.3 3.6 19.2 5.5 29.2 5.5H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H436.1c-6 0-11.9-1.1-17.5-3.3l-92.9-36.4c.4-.6 .7-1.3 1-1.9l41-93.8c11.7-26.8 3.8-58.2-19.3-76.2l-38.8-30.2 96.1-54.1 80 68c6.7 5.7 16.8 4.9 22.6-1.8s4.9-16.8-1.8-22.6l-141-119.9c-3.7-3.1-7.6-6-11.6-8.6c-.8-.6-1.6-1.1-2.4-1.5c-11.2-6.9-23.6-11.7-36.6-14.3l-42.6-8.5c-4.2-.8-7.8-3.3-10.2-6.8l-40.6-61zm60.8 209.8l-46.6-36.2 106.8-50.3c.8 .6 1.5 1.2 2.2 1.8l35 29.8-97.5 54.8zM224 212.3l104.7 81.4c11.6 9 15.5 24.7 9.7 38.1l-41 93.8c-.5 1.1-.8 2.2-1 3.3L125.7 362.1l84-56c8.9-5.9 14.2-15.9 14.2-26.6l0-67.2zM424 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 424 0a56 56 0 1 0 0 112z"]
};
var faSnowboarding = faPersonSnowboarding;
var faSquareChevronRight = {
  prefix: 'fal',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M416 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM315.3 267.3l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 256 180.7 155.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l112 112c6.2 6.2 6.2 16.4 0 22.6z"]
};
var faChevronSquareRight = faSquareChevronRight;
var faLacrosseStickBall = {
  prefix: 'fal',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M344 32v0c-44.3 0-83.7 28.4-97.7 70.4l-.8 2.4c-6.2 18.8-14.3 43-31.6 64.2l-34.4 42c-12.6 15.4-19.5 34.7-19.5 54.7c0 47.7 38.7 86.3 86.3 86.3c19.9 0 39.2-6.9 54.7-19.5l42-34.4c21.1-17.3 45.2-25.3 64-31.5l1.8-.6 .8-.3 0 0c42-14 70.4-53.3 70.4-97.6l0-.1 0-.2 0-.1c0-28.8-18.4-62.8-45.6-90.1C407.2 50.4 373.2 32 344.4 32l-.2 0-.2 0zm.3-32C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3c0 58.1-37.2 109.7-92.3 128.1l-.8 .3c-19.8 6.6-39.1 13-55.6 26.5l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7c-26.9 0-51.7-9-71.6-24.1L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152.1 337.3C137 317.4 128 292.6 128 265.7c0-27.3 9.5-53.8 26.7-74.9l34.4-42c13.5-16.5 19.9-35.8 26.5-55.6l0 0 .3-.8C234.3 37.2 285.9 0 344 0l.3 0zM544 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faTruckFast = {
  prefix: 'fal',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M128 32H352c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V288H64v96 32c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V64c0-17.7 14.3-32 32-32zM570.9 224H416V128h65.3c4.7 0 9.1 2 12.1 5.6L570.9 224zM416 256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V256zM96 416a64 64 0 1 1 128 0A64 64 0 1 1 96 416zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM48 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM16 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faShippingFast = faTruckFast;
var faUserMagnifyingGlass = {
  prefix: 'fal',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM32 480c1.2-79.7 66.2-144 146.3-144h91.4c6.5 0 12.9 .4 19.2 1.2c-.6-5.7-.9-11.4-.9-17.2c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3H416 192 32zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm224-31.9a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
var faStarSharp = {
  prefix: 'fal',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M288 43.6L239.2 196.9C237.1 203.5 231 208 224 208H75.3l126 91c5.5 4 7.9 11.1 5.9 17.6L163.5 460.6l114.7-89.2c5.8-4.5 13.9-4.5 19.6 0l114.7 89.2L368.7 316.7c-2-6.5 .4-13.6 5.9-17.6l126-91H352c-7 0-13.1-4.5-15.2-11.1L288 43.6zM262.3 18.8C265.9 7.6 276.3 0 288 0s22.1 7.6 25.7 18.8l50 157.2H517.4c14.7 0 26.6 11.9 26.6 26.6c0 8.5-4.1 16.6-11 21.6L402.6 318.3l50.8 167c4.1 13.3-5.9 26.8-19.8 26.8c-4.6 0-9.1-1.5-12.7-4.4L288 404.3 155.1 507.6c-3.6 2.8-8.1 4.4-12.7 4.4c-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6C32 187.9 43.9 176 58.6 176H212.3l50-157.2z"]
};
var faCommentHeart = {
  prefix: 'fal',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM176 221.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L256 313.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM205.3 160c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faCircle1 = {
  prefix: 'fal',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 130.2c4.9 2.9 8 8.1 8 13.8V352h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H256 192c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V171.6l-32.1 18.3c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l56-32c5-2.8 11-2.8 16 .1z"]
};
var faCircleStar = {
  prefix: 'fal',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.3-399.1c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4zm-40 95.1L256 156.2l25.6 51.9c2.3 4.7 6.8 8 12 8.8l57.3 8.3-41.5 40.4c-3.8 3.7-5.5 9-4.6 14.2l9.8 57.1-51.2-26.9c-4.7-2.5-10.2-2.5-14.9 0l-51.2 26.9 9.8-57.1c.9-5.2-.8-10.5-4.6-14.2L161 225.1l57.3-8.3c5.2-.8 9.7-4 12-8.8z"]
};
var faStarCircle = faCircleStar;
var faFish = {
  prefix: 'fal',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M162.4 306.8c11.1 13.4 24.1 26.8 38.7 39.2c35.5 30 81.4 54 134.8 54s99.3-24 134.8-54c35.5-30 60.8-66 73.2-90c-12.4-24-37.6-60-73.2-90c-35.5-30-81.4-54-134.8-54s-99.3 24-134.8 54c-14.6 12.4-27.6 25.8-38.7 39.2L145.1 226l-23.4-13.6L32 160l45.8 80.1L86.9 256l-9.1 15.9L32 352l89.7-52.3L145.1 286l17.3 20.8zM4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1zM416 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCloudFog = {
  prefix: 'fal',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", "M160 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H168c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM576 216c0-55.2-43-100.3-97.3-103.8C471.2 66.7 431.6 32 384 32c-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0C178.1 0 128 50.1 128 112c0 2.6 .1 5.3 .3 7.9C90.6 135.5 64 172.6 64 216c0 57.4 46.6 104 104 104H472c57.4 0 104-46.6 104-104zM0 400c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm64 96c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm224 0c0 8.8 7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]
};
var faFog = faCloudFog;
var faWaffle = {
  prefix: 'fal',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 80v64h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H272v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V272H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V176H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32l64 0V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm-96 96v64h64V176l-64 0zm0 96v64h64V272H176zm96 0v64h64V272H272zm0-32h64V176H272v64z"]
};
var faMusicNote = {
  prefix: 'fal',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384 23.1C384 10.3 373.7 0 360.9 0c-2 0-4 .3-5.9 .8L203.9 40.5c-7 1.8-11.9 8.2-11.9 15.5V376c-20.3-14.8-48.7-24-80-24C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80V189.1l147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5V23.1zM192 432c0 9.1-5.1 20.3-19.4 30.5C158.3 472.7 137 480 112 480s-46.3-7.3-60.6-17.5C37.1 452.3 32 441.1 32 432s5.1-20.3 19.4-30.5C65.7 391.3 87 384 112 384s46.3 7.3 60.6 17.5C186.9 411.7 192 422.9 192 432zM352 123.6L224 156.1V68.3L352 34.6v88.9z"]
};
var faMusicAlt = faMusicNote;
var faHexagonExclamation = {
  prefix: 'fal',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", "M16 288c-11.4-19.8-11.4-44.2 0-64L108.3 64.2c11.4-19.8 32.6-32 55.4-32H348.3c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64L403.7 447.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16H348.3c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16l-184.6 0c-11.4 0-22 6.1-27.7 16L43.7 240zM256 128c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCartShoppingFast = {
  prefix: 'fal',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M64 16C64 7.2 71.2 0 80 0h37.9c20.6 0 38.6 13 45.3 32H603.5c20.8 0 36.1 19.6 31 39.8L592.6 239.5C585.5 268 559.9 288 530.5 288H216l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H255.2c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C132 37.3 125.5 32 117.9 32H80c-8.8 0-16-7.2-16-16zM530.5 256c14.7 0 27.5-10 31-24.2L603.5 64H170.1l39.3 192H530.5zM256 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM16 128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faObjectUnion = {
  prefix: 'fal',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M160 320c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H352c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V288c0 17.7 14.3 32 32 32h96zm-32 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v64 32h32 64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384 352H128z"]
};
var faUserGraduate = {
  prefix: 'fal',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M228.7 .7c-3.1-.9-6.3-.9-9.4 0l-208 64C4.6 66.8 0 73 0 80s4.6 13.2 11.3 15.3L32 101.7v71.7L.8 266.9C-.8 271.8 0 277.2 3 281.4s7.8 6.6 13 6.6H80c5.1 0 10-2.5 13-6.6s3.8-9.5 2.2-14.4L64 173.4V111.5l155.3 47.8c3.1 .9 6.3 .9 9.4 0l208-64C443.4 93.2 448 87 448 80s-4.6-13.2-11.3-15.3l-208-64zM224 127.3L70.4 80 224 32.7 377.6 80 224 127.3zM188.1 439.8c19.1 21.5 52.7 21.5 71.8 0l71.1-80c49.2 18 84.4 65 85 120.2H32c.5-55.2 35.7-102.3 85-120.2l71.1 80zM109.6 328.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-71-45.9-131.3-109.6-152.8c-10.9-3.7-22.7 .4-30.3 9L236 418.5c-6.4 7.2-17.6 7.2-23.9 0l-72.1-81.1c-7.6-8.6-19.4-12.7-30.3-9zM48 226.6L57.8 256H38.2L48 226.6zm48-71.8V176c0 70.7 57.3 128 128 128s128-57.3 128-128V154.8l-32 9.8V176c0 53-43 96-96 96s-96-43-96-96V164.7l-32-9.8z"]
};
var faStarfighter = {
  prefix: 'fal',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M269.6 35.2L240.1 278.1l-.1 1v1V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V280v-1l-.1-1L370.4 35.2C368 15.1 351 0 330.7 0H309.3C289 0 272 15.1 269.6 35.2zM309.3 32h21.5c4 0 7.5 3 7.9 7L368 281V432c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V281L301.3 39c.5-4 3.9-7 7.9-7zM64 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32V448c0 8.8 7.2 16 16 16s16-7.2 16-16V428.7l72.1 30c8.6 12.8 23.3 21.3 39.9 21.3h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V464c0-8.8-7.2-16-16-16H176c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-26.5 0-48 21.5-48 48v16H64V160H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V96zm0 298V352h64v68.7L64 394zM608 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V320H512V304c0-26.5-21.5-48-48-48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V480h16c16.6 0 31.3-8.4 39.9-21.3l72.1-30V448c0 8.8 7.2 16 16 16s16-7.2 16-16V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V96zM512 352h64v42l-64 26.7V352zM320 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"]
};
var faCircleHalfStroke = {
  prefix: 'fal',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M240 479.4V32.6C123.8 40.8 32 137.7 32 256s91.8 215.2 208 223.4zM480 256c0-118.3-91.8-215.2-208-223.4V479.4C388.2 471.2 480 374.3 480 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faAdjust = faCircleHalfStroke;
var faArrowRightLongToLine = {
  prefix: 'fal',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M640 80V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM507.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 272 16 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l441.4 0L340.7 123.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l144 144z"]
};
var faSquareArrowDown = {
  prefix: 'fal',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm235.3-36.7l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 329.4V144c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0z"]
};
var faArrowSquareDown = faSquareArrowDown;
var faDiamondHalfStroke = {
  prefix: 'fal',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", "M272 44.7V467.3L477.7 261.7c3.1-3.1 3.1-8.2 0-11.3L272 44.7zM240 467.3V44.7L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L240 467.3zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216z"]
};
var faClapperboard = {
  prefix: 'fal',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zm350.6-32H480V96c0-9.2-3.9-17.5-10.1-23.3L382.6 160zm-45.3 0l96-96H326.6l-96 96H337.4zm-56-96H174.6l-96 96H185.4l96-96zm-152 0H64C46.3 64 32 78.3 32 96v64h1.4l96-96zM512 96v64 16 16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 176 160 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64z"]
};
var faSquareChevronLeft = {
  prefix: 'fal',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M32 416c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 320zm32 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm68.7-235.3l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L166.6 256 267.3 356.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faChevronSquareLeft = faSquareChevronLeft;
var faPhoneIntercom = {
  prefix: 'fal',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M80 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16H80zM48 32C21.5 32 0 53.5 0 80V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zM224 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H224zm32 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32-32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM256 128H416v96H256V128zm-32 0v96c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faLinkHorizontal = {
  prefix: 'fal',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M128 64C57.3 64 0 121.3 0 192s57.3 128 128 128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96s43-96 96-96H304.1c52.9 0 95.9 42.9 95.9 95.9c0 50.3-38.9 92-89 95.6l-8.1 .6c-8.8 .6-15.4 8.3-14.8 17.1s8.3 15.4 17.1 14.8l8.1-.6C380.2 314.6 432 258.9 432 191.9C432 121.2 374.8 64 304.1 64H128zM512 448c70.7 0 128-57.3 128-128s-57.3-128-128-128H480c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c53 0 96 43 96 96s-43 96-96 96H335.9c-52.9 0-95.9-42.9-95.9-95.9c0-50.3 38.9-92 89-95.6l8.1-.6c8.8-.6 15.4-8.3 14.8-17.1s-8.3-15.4-17.1-14.8l-8.1 .6C259.8 197.4 208 253.1 208 320.1C208 390.8 265.2 448 335.9 448H512z"]
};
var faChainHorizontal = faLinkHorizontal;
var faMango = {
  prefix: 'fal',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M416 112c-24.6 0-47-9.2-64-24.4v42.9 32.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c-41.3 0-82.7 14.5-114 43.4l-1.2 1.1-1.3 1c-39 29.3-58.5 59.9-78 92l-2.9 4.7c-18.6 30.9-39.6 65.5-79.4 93.2c-4.7 3.4-8 7.8-9.8 12.7c-4.3 11.8 1.8 27.7 19.9 33.3l1.3 .4 1.2 .5 0 0 0 0 0 0 0 0 .1 0 .6 .2c.6 .2 1.6 .6 2.9 1.1c2.7 1 6.8 2.4 12.2 4.2c10.9 3.5 27 8.2 47.6 13C160.3 470.4 218.9 480 288 480c73.4 0 120.4-29.5 149.7-65.2c30.3-37 42.3-81.4 42.3-109.6c0-36.4-15-73.2-45.9-101.8c-14.8-13.7-31.8-24.1-50.1-31.3V140c4 1 8 1.9 12.1 2.5c21.7 8.6 42 21.1 59.7 37.4c37.5 34.6 56.2 80 56.2 125.3C512 375.9 454.5 512 288 512c-144 0-244.1-39.9-244.1-39.9C10.3 461.8-7.9 428.4 3.3 397.4c4.1-11.5 11.8-21.1 21.4-28c34.3-23.8 52.1-53.2 71.2-84.7c20.6-34 42.6-70.4 88.4-104.8C221.7 145.3 270.9 128 320 128V16c0-8.8 7.2-16 16-16h24 60.7C471.1 0 512 40.9 512 91.3c0 11.4-9.3 20.7-20.7 20.7H472 416zm16 208c0 61.9-50.1 112-112 112c-8.8 0-16-7.2-16-16s7.2-16 16-16c44.2 0 80-35.8 80-80c0-8.8 7.2-16 16-16s16 7.2 16 16zM354 32c7.1 27.6 32.2 48 62 48h56 6.9c-5.3-27.3-29.3-48-58.2-48H360h-6z"]
};
var faMusicNoteSlash = {
  prefix: 'fal',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", "M352 189.1l147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5V23.1C512 10.3 501.7 0 488.9 0c-2 0-4 .3-5.9 .8L331.9 40.5c-7 1.8-11.9 8.2-11.9 15.5V174.5l32 25.3V189.1zM320 337.5V376c-20.3-14.8-48.7-24-80-24c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V362.8l-32-25.3zm0 94.5c0 9.1-5.1 20.3-19.4 30.5C286.3 472.7 265 480 240 480s-46.3-7.3-60.6-17.5C165.1 452.3 160 441.1 160 432s5.1-20.3 19.4-30.5C193.7 391.3 215 384 240 384s46.3 7.3 60.6 17.5C314.9 411.7 320 422.9 320 432zM480 123.6L352 156.1V68.3L480 34.6v88.9zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMusicAltSlash = faMusicNoteSlash;
var faCircleRadiation = {
  prefix: 'fal',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160.6 148.1c2.4-2.1 5.3-2.8 8.4-2c3.3 .8 6.9 3.2 9.1 7.1l37.2 64.4c7.4-7.8 16.9-13.5 27.7-16l-37.2-64.4c-12.7-22-43.9-32.9-66.4-13c-28.1 24.9-48.2 58.6-56 96.9c-5.9 29.4 19.1 51 44.5 51h74.3c-1.5-5.1-2.3-10.4-2.3-16s.8-10.9 2.3-16H128c-4.5 0-8.4-1.9-10.7-4.4c-2.2-2.3-3.1-5.1-2.5-8.3c6.3-31.3 22.7-58.9 45.8-79.3zm54.7 146.4l-37.2 64.4c-12.7 22-6.6 54.4 21.9 64c17.6 5.9 36.5 9.1 56 9.1s38.4-3.2 56-9.1c28.5-9.6 34.6-42 21.9-64l-37.2-64.4c-7.4 7.8-16.9 13.5-27.7 16l37.2 64.4c2.3 3.9 2.6 8.2 1.6 11.4c-.9 3.1-2.9 5.2-5.9 6.2c-14.4 4.8-29.8 7.4-45.8 7.4s-31.5-2.6-45.8-7.4c-3-1-5-3.2-5.9-6.2c-1-3.3-.7-7.5 1.6-11.4L243 310.5c-10.8-2.6-20.3-8.2-27.7-16zM309.7 272H384c25.4 0 50.5-21.5 44.5-51c-7.7-38.3-27.8-72.1-56-96.9c-22.5-19.9-53.7-9-66.4 13L269 201.5c10.8 2.6 20.3 8.2 27.7 16l37.2-64.4c2.3-3.9 5.8-6.3 9.1-7.1c3.1-.7 6-.1 8.4 2c23.1 20.4 39.5 48 45.8 79.3c.6 3.1-.3 5.9-2.5 8.3c-2.3 2.5-6.2 4.4-10.7 4.4H309.7c1.5 5.1 2.3 10.4 2.3 16s-.8 10.9-2.3 16zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faRadiationAlt = faCircleRadiation;
var faFaceTongueSweat = {
  prefix: 'fal',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256c0 83.8-40.2 158.1-102.4 204.8C398.8 492.9 345.6 512 288 512s-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2c15.6 11.8 32.9 21.5 51.3 28.9c-8.1-13.9-12.8-30.1-12.9-47.3c-10.2-7.2-16-15.7-16-24.7c0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7c-.1 17.2-4.8 33.4-12.9 47.3c18.4-7.4 35.7-17.1 51.3-28.9C476.8 394.3 512 329.3 512 256C512 132.3 411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5c0 .2 0 .2 0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM211.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM224 417.6c0 34.5 27.9 62.4 62.4 62.4h3.2c34.5 0 62.4-27.9 62.4-62.4V403c0-14.9-12.1-27-27-27h-2.5c-10.9 0-20.4 7.4-23 18c-3 12-20 12-23 0c-2.6-10.6-12.1-18-23-18H251c-14.9 0-27 12.1-27 27v14.6z"]
};
var faGlobeStand = {
  prefix: 'fal',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M28.7 348.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l10-10C99 394.1 145.1 412.1 192 415.4V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V415.4c51.9-3.7 102.7-25.4 142.4-65c83.7-83.7 87.3-217.1 10.9-305.1l10-10c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L343.8 33.6c-6.2 6.2-6.2 16.4 0 22.6c75 75 75 196.5 0 271.5s-196.5 75-271.5 0c-6.2-6.2-16.4-6.2-22.6 0L28.7 348.7zM80 192a128 128 0 1 1 256 0A128 128 0 1 1 80 192zm288 0A160 160 0 1 0 48 192a160 160 0 1 0 320 0z"]
};
var faBaseball = {
  prefix: 'fal',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M256.6 480c-.4-5.3-.6-10.6-.6-16c0-5.8 .2-11.6 .7-17.3c.7-8.8 8.5-15.4 17.3-14.6s15.4 8.5 14.6 17.3c-.4 4.8-.6 9.7-.6 14.7c0 4.6 .2 9.1 .5 13.7c97.7-14.2 174.9-91.5 189.1-189.1c-4.5-.3-9.1-.5-13.7-.5c-4.9 0-9.8 .2-14.7 .6c-8.8 .7-16.5-5.8-17.3-14.6s5.8-16.5 14.6-17.3c5.7-.5 11.5-.7 17.3-.7c5.4 0 10.7 .2 16 .6c0-.2 0-.4 0-.6C480 132.3 379.7 32 256 32c-.2 0-.4 0-.6 0c.4 5.3 .6 10.6 .6 16c0 5.8-.2 11.6-.7 17.3c-.7 8.8-8.5 15.4-17.3 14.6s-15.4-8.5-14.6-17.3c.4-4.8 .6-9.7 .6-14.7c0-4.6-.2-9.1-.5-13.7C125.8 48.6 48.6 125.8 34.3 223.5c4.5 .3 9.1 .5 13.7 .5c4.9 0 9.8-.2 14.7-.6c8.8-.7 16.5 5.8 17.3 14.6s-5.8 16.5-14.6 17.3c-5.7 .5-11.5 .7-17.3 .7c-5.4 0-10.7-.2-16-.6c0 .2 0 .4 0 .6c0 123.7 100.3 224 224 224c.2 0 .4 0 .6 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm121.3-48c38.3-17.6 69.2-48.5 86.7-86.7c3.7-8 13.2-11.6 21.2-7.9s11.6 13.2 7.9 21.2c-20.8 45.2-57.2 81.7-102.5 102.5c-8 3.7-17.5 .2-21.2-7.9s-.2-17.5 7.9-21.2zM390.7 304c-38.3 17.6-69.2 48.5-86.7 86.7c-3.7 8-13.2 11.6-21.2 7.9s-11.6-13.2-7.9-21.2c20.8-45.2 57.2-81.7 102.5-102.5c8-3.7 17.5-.2 21.2 7.9s.2 17.5-7.9 21.2z"]
};
var faBaseballBall = faBaseball;
var faCircleP = {
  prefix: 'fal',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16V288v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H176zm88 144H192V160h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z"]
};
var faAwardSimple = {
  prefix: 'fal',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", "M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM88 390c9.7 4.3 20.3 6.6 31.3 6.8l-16.6 72 83-35.6c4-1.7 8.6-1.7 12.6 0l83 35.6-16.6-72c10.9-.2 21.5-2.5 31.3-6.8l23.6 102.4c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9L88 390z"]
};
var faJetFighterUp = {
  prefix: 'fal',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M270.6 9.5C268.1 3.7 262.3 0 256 0s-12.1 3.7-14.6 9.5L181.5 144.2c-3.6 8.2-5.5 17-5.5 26v40l-.4 .3L32 299.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v56 40 32c0 8.8 7.2 16 16 16s16-7.2 16-16V384H176v3.4l-42.2 66.8c-3.8 6-5.8 13-5.8 20.1c0 20.8 16.9 37.7 37.7 37.7H346.3c20.8 0 37.7-16.9 37.7-37.7c0-7.1-2-14.1-5.8-20.1L336 387.4V384H480v16c0 8.8 7.2 16 16 16s16-7.2 16-16V368 328 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v27.3L336.4 210.4l-.4-.3v-40c0-9-1.9-17.8-5.5-26L270.6 9.5zM480 352H336V247.8l144 89.1V352zm-304 0H32V336.9l144-89.1V352zm34.8-194.8L256 55.4l45.2 101.8c1.8 4.1 2.8 8.5 2.8 13V392c0 3 .9 6 2.5 8.5l44.6 70.7c.6 .9 .9 2 .9 3.1c0 3.2-2.6 5.7-5.7 5.7H272V416c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H165.7c-3.2 0-5.7-2.6-5.7-5.7c0-1.1 .3-2.1 .9-3.1l44.6-70.7c1.6-2.6 2.5-5.5 2.5-8.5V170.2c0-4.5 .9-8.9 2.8-13z"]
};
var faDiagramProject = {
  prefix: 'fal',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", "M136 64c13.3 0 24 10.7 24 24v24 32 24c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h80zm56 104V144H384v24c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56H440c-30.9 0-56 25.1-56 56v24H192V88c0-30.9-25.1-56-56-56H56C25.1 32 0 57.1 0 88v80c0 30.9 25.1 56 56 56h80c8.6 0 16.7-1.9 24-5.4l72.2 96.3c-5.2 8.5-8.2 18.5-8.2 29.1v80c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V344c0-30.9-25.1-56-56-56H280c-8.6 0-16.7 1.9-24 5.4l-72.2-96.3c5.2-8.5 8.2-18.5 8.2-29.1zm224 0V144 112 88c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zM360 320c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H280c-13.3 0-24-10.7-24-24V344c0-13.3 10.7-24 24-24h80z"]
};
var faProjectDiagram = faDiagramProject;
var faPedestal = {
  prefix: 'fal',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M352 32H96C78.3 32 64 46.3 64 64V448H32V64C32 28.7 60.7 0 96 0H352c35.3 0 64 28.7 64 64V448H384V64c0-17.7-14.3-32-32-32zM16 480H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM320 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faChartPyramid = {
  prefix: 'fal',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", "M269.8 87.7c-6.2-10.6-21.5-10.6-27.6 0L181.3 192H330.7L269.8 87.7zM106.7 320H405.3l-56-96H162.7l-56 96zM88 352L46 423.9C39.8 434.6 47.5 448 59.9 448H452.1c12.3 0 20-13.4 13.8-24.1L424 352H88zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0L493.6 407.8c18.7 32-4.4 72.2-41.5 72.2H59.9c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z"]
};
var faSidebar = {
  prefix: 'fal',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H224V64H448zM64 64H192V448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm0-32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM64 176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faSnowmanHead = {
  prefix: 'fal',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M128 32H320c17.7 0 32 14.3 32 32v96h32V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v96H96V64c0-17.7 14.3-32 32-32zM352 224h.7c29.3 31.4 47.3 73.6 47.3 120c0 52-22.5 98.8-58.5 131c-3 2.7-8.3 5-15.8 5H122.2c-7.5 0-12.7-2.2-15.8-5C70.5 442.8 48 396 48 344c0-46.4 17.9-88.6 47.3-120H96 352zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H54.1C30.1 257.9 16 299.3 16 344c0 61.5 26.7 116.8 69.1 154.8c10.1 9.1 23.6 13.2 37.1 13.2H325.8c13.6 0 27-4.1 37.1-13.2C405.3 460.8 432 405.5 432 344c0-44.7-14.1-86.1-38.1-120H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H384 352 96 64 16zM144 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 320c-26.5 0-48 21.5-48 48v1c0 6.9 1.4 13.6 4.2 19.9l29.2 65.6c2.6 5.8 8.3 9.5 14.6 9.5s12.1-3.7 14.6-9.5l29.2-65.6c2.8-6.3 4.2-13 4.2-19.9v-1c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v1c0 2.4-.5 4.7-1.5 6.9L224 408.6l-14.5-32.7c-1-2.2-1.5-4.5-1.5-6.9v-1z"]
};
var faFrostyHead = faSnowmanHead;
var faCopy = {
  prefix: 'fal',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M384 352H224c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H332.1c4.2 0 8.3 1.7 11.3 4.7l67.9 67.9c3 3 4.7 7.1 4.7 11.3V320c0 17.7-14.3 32-32 32zM433.9 81.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H224c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V416H256v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h64V128H64z"]
};
var faBurgerGlass = {
  prefix: 'fal',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", "M32.1 40.7L42.2 160H341.7L351.8 40.7c.4-4.7-3.3-8.7-8-8.7H40.1c-4.7 0-8.4 4-8 8.7zM44.9 192L66.7 450.7C68.1 467.3 81.9 480 98.6 480H260c3.7 11.9 9.7 22.7 17.6 32H98.6c-33.3 0-61-25.5-63.8-58.6L.2 43.4C-1.7 20 16.7 0 40.1 0H343.8c23.4 0 41.8 20 39.9 43.4L372.5 176.5c-12.2 4.7-23.4 10.1-33.5 16l0-.4H44.9zm286.1 87.4c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4c-8.3-9-20.6-20.1-37.1-30.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9c14.6 15.7 19.5 36.1 19.5 54.7c0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4c0-18.7 4.9-39.1 19.5-54.7c24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3H602.7c20.6 0 37.3 16.7 37.3 37.3c0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3c0 14.7 11.9 26.7 26.7 26.7H581.3c14.7 0 26.7-11.9 26.7-26.7c0-2.9-2.4-5.3-5.3-5.3H325.3z"]
};
var faVolumeXmark = {
  prefix: 'fal',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M151.6 188L288 66.7V445.3L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM411.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 256l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 278.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 256l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 233.4l-68.7-68.7z"]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faHandSparkles = {
  prefix: 'fal',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M328 0c-24.9 0-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8c-30.9 0-56 25.1-56 56V288.8l-32.4-32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2L184.2 439.4C230.7 485.9 293.8 512 359.5 512H368c37.3 0 71.8-11.6 100.3-31.3c-9.6-5.5-17.4-13.7-22.3-23.6C423.5 471.6 396.7 480 368 480h-8.5c-57.3 0-112.2-22.8-152.7-63.3L103 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V80l0-.1V56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V87.9C384 74.7 394.8 64 408 64c13.3 0 24 10.7 24 24v64l0 .1V240c0 8.8 7.2 16 16 16s16-7.2 16-16V151.9c0-13.2 10.8-23.9 24-23.9c13.3 0 24 10.7 24 24V336c0 1.1 0 2.1 0 3.2c7.1-11.9 18.5-20.9 32-24.9V152c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C374 16.3 352.9 0 328 0zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V80zM336 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V304zm240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H496c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H576V368z"]
};
var faBarsFilter = {
  prefix: 'fal',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM288 400c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16z"]
};
var faPaintbrushPencil = {
  prefix: 'fal',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M534.5 86.6L369.9 251.3 324.6 206 489.3 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM347.3 273.9l-36.6 36.6-36.1 36.1 0 0-4.6 4.6L224.6 306l40.7-40.7 0 0L302 228.6l45.3 45.3zM176 320c6.9 0 13.5 .9 19.9 2.5l57.7 57.7c1.6 6.3 2.5 13 2.5 19.9c0 44.2-35.8 80-80 80H36.8C58 480 74.3 468.5 84 455.1c9.5-13.1 14.2-30 12.5-46.7c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80zm110.3 60.2L557.2 109.3c25-25 25-65.5 0-90.5s-65.5-25-90.5 0l-271 271c-6.4-1.1-13-1.7-19.7-1.7c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176c61.9 0 112-50.1 112-112c0-6.8-.6-13.4-1.7-19.8zM170.8 17C148.9-4.9 113.5-4.9 91.6 17L49 59.6c-21.9 21.9-21.9 57.3 0 79.2L166.5 256.3c3.1-.2 6.3-.3 9.5-.3c2.7 0 5.3 .1 7.9 .2l13.9-13.9L149 193.6 225.6 117l48.8 48.8L297 143.2 170.8 17zM410.1 301.6l50.8 50.8c7.6 7.6 13.1 16.9 16.1 27.2l27.3 92.8-92.8-27.3c-10.3-3-19.6-8.6-27.2-16.1l-50.8-50.8-13.8 13.8c.1 2.7 .2 5.4 .2 8.1c0 3.2-.1 6.4-.3 9.5l42 42c11.4 11.4 25.4 19.7 40.8 24.2l121 35.6c5.6 1.7 11.7 .1 15.8-4s5.7-10.2 4-15.8l-35.6-121c-4.5-15.4-12.9-29.4-24.2-40.8l-50.8-50.8-22.6 22.6zM114.2 39.6c9.4-9.4 24.6-9.4 33.9 0L203 94.4 126.4 171 71.6 116.2c-9.4-9.4-9.4-24.6 0-33.9l42.6-42.6z"]
};
var faPartyBell = {
  prefix: 'fal',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M32 224C32 118 118 32 224 32c30.3 0 59 7 84.5 19.6c7.1 3.5 11.5 11 11.5 19.1c0 6-2.4 11.7-6.6 15.9L86.6 313.4c-4.2 4.2-9.9 6.6-15.9 6.6c-8.1 0-15.6-4.3-19.1-11.5C39 283 32 254.3 32 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zM480 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM352 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 480a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM364.7 172.7c-6.2 6.2-6.2 16.4 0 22.6l8.3 8.3c23.1 23.1 53.4 37.7 85.9 41.3l27.4 3c8.8 1 16.7-5.4 17.7-14.1s-5.4-16.7-14.1-17.7l-27.4-3c-25.3-2.8-48.8-14.1-66.8-32.1l-8.2-8.3c-6.2-6.2-16.4-6.2-22.6 0zm-169.4 192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l8.3 8.2c18 18 29.3 41.6 32.1 66.8l3 27.4c1 8.8 8.9 15.1 17.7 14.1s15.1-8.9 14.1-17.7l-3-27.4c-3.6-32.5-18.2-62.8-41.3-85.9l-8.3-8.3zm303 135.5c6.7-5.7 7.6-15.8 1.9-22.6l-8.5-10c-6.2-7.3-9.4-16.6-9.2-26.1c1-38.2-28.5-70.4-66.6-72.6l-30-1.8c-20.9-1.2-37.1-18.8-36.5-39.8c.5-17.4-5.5-34.4-16.7-47.7l-8.5-10c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5l8.5 10c6.2 7.3 9.4 16.6 9.2 26.1c-1 38.2 28.5 70.4 66.6 72.6l30 1.8c20.9 1.2 37.1 18.8 36.5 39.8c-.5 17.4 5.5 34.4 16.7 47.7l8.5 10c5.7 6.7 15.8 7.6 22.6 1.9z"]
};
var faUserVneckHair = {
  prefix: 'fal',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM228.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm89.6 290.1l-57.2-76.3C72.6 358.8 32 410.7 32 472l0 8H416v-8c0-61.3-40.6-113.2-96.4-130.2l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zM132.1 307.8c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z"]
};
var faJackOLantern = {
  prefix: 'fal',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", "M272.6 96.7c-13.2 1.1-26.1 3.8-38.3 7.7l41.1-94c2.8-6.3 9-10.4 15.8-10.4h1.2c2.3 0 4.7 .5 6.8 1.4l42.3 18.1c6.4 2.7 10.5 9 10.5 15.9V108c-10.2-4-20.9-7.1-32-9.1V45.1l-20.9-9L272.6 96.7zm-94.7 38c-4 3.2-7.3 6.9-10 10.9c-5.3-1-10.6-1.5-16-1.5c-31.3 0-60.9 17.1-83.3 47.4S32 264.3 32 312s14.3 90.3 36.7 120.6s52 47.4 83.3 47.4c20.7 0 40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C247.4 472.5 267.3 480 288 480s40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C383.4 472.5 403.3 480 424 480c31.3 0 60.9-17.1 83.3-47.4S544 359.7 544 312s-14.3-90.3-36.7-120.6s-52-47.4-83.3-47.4c-5.4 0-10.8 .5-16 1.5c-2.7-4-6-7.7-10-10.9c-6.2-4.9-12.7-9.5-19.5-13.6c14.3-5.8 29.5-9 45.5-9c43.8 0 82.2 24.1 109 60.4s43 85.7 43 139.6s-16.1 103.3-43 139.6S467.8 512 424 512c-24.7 0-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9s-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9c-43.8 0-82.2-24.1-109-60.4S0 365.9 0 312s16.1-103.3 43-139.6S108.2 112 152 112c15.9 0 31.2 3.2 45.5 9c-6.8 4.1-13.3 8.6-19.5 13.6zm40 49.9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5c24.6-19.8 56-31.6 90-31.6s65.4 11.8 90 31.6c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5c-19.2-15.4-43.5-24.6-70-24.6s-50.8 9.2-70 24.6zm2.5 29.4l32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L208 249.6 188.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm160 0l32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L368 249.6 348.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm55.3 76c12.7-7.5 30.1-6.6 41.6 4.9c7.1 7.1 11.3 18.1 8 29.6c-4.3 14.8-16 44-46.1 69.4C409 419.4 361.5 440 288 440s-121-20.6-151.4-46.2c-30.1-25.4-41.9-54.6-46.1-69.4c-3.3-11.5 1-22.5 8-29.6c11.5-11.5 28.9-12.4 41.6-4.9c21.5 12.6 73.9 38 147.8 38s126.4-25.4 147.8-38zm18.1 27.2c-.6-.1-1.3 .1-1.9 .4C427.3 332.1 369.3 360 288 360c-5.4 0-10.8-.1-16-.4V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V356.7c-56.2-7.8-96.5-27.6-116.1-39.1c-.6-.3-1.3-.5-1.9-.4c-.1 0-.2 0-.3 .1c3.5 11.3 12.8 33 35.5 52.2c5.4 4.5 11.6 9 18.8 13.2c.7-8.2 7.6-14.6 15.9-14.6c8.8 0 16 7.2 16 16v12.7c21 6.8 47.3 11.3 80 11.3c17.9 0 33.8-1.3 48-3.6V384c0-8.8 7.2-16 16-16s16 7.2 16 16v12.7c22.2-7.2 38.6-17.1 50.7-27.4c22.8-19.2 32-40.9 35.5-52.2c-.1 0-.1 0-.2 0c0 0-.1 0-.1 0z"]
};
var faGrip = {
  prefix: 'fal',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", "M408 384c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM408 192c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM200 384l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8zm48 32l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM40 384l48 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8zm48 32l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l48 0zm40-8c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48z"]
};
var faGripHorizontal = faGrip;
var faShareFromSquare = {
  prefix: 'fal',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M400 280V240 224c0-8.8-7.2-16-16-16H368 352 336 289.5c-53.8 0-97.5 43.6-97.5 97.5c0 5.3 .7 10.3 1.9 15C175.5 301.9 160 276 160 240c0-70.7 57.3-128 128-128h48 32 16c8.8 0 16-7.2 16-16V80 40c0-4.4 3.6-8 8-8c2.1 0 4 .8 5.5 2.2l128.8 122c1 1 1.6 2.3 1.6 3.8s-.6 2.8-1.6 3.8l-128.8 122c-1.5 1.4-3.5 2.2-5.5 2.2c-4.5 0-8-3.6-8-8zm-32-40v32 8c0 22.1 18 40 40 40c10.2 0 20.1-3.9 27.5-11L564.4 187c7.4-7 11.6-16.8 11.6-27s-4.2-20-11.6-27L435.6 11c-7.4-7-17.3-11-27.5-11C386 0 368 17.9 368 40v8V80H336 288c-88.4 0-160 71.6-160 160c0 93.4 82.8 134.8 100.6 142.6c2.2 1 4.6 1.4 7.1 1.4c11.2 0 20.3-9.1 20.3-20.3v-.9c0-6.8-3.3-13.1-8.3-17.7c-9.5-8.6-23.7-24.1-23.7-39.7c0-36.1 29.3-65.5 65.5-65.5H336h16 16zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V400c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"]
};
var faShareSquare = faShareFromSquare;
var faKeynote = {
  prefix: 'fal',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", "M304 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zM240 0c-20.9 0-38.7 13.4-45.3 32H184c-44.2 0-80 35.8-80 80v48H93.7c-18.2 0-34.8 10.3-42.9 26.5L5.1 277.9c-3.3 6.7-5.1 14-5.1 21.5V304v48c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V304v-4.7c0-7.5-1.7-14.8-5.1-21.5l-45.7-91.3c-8.1-16.3-24.8-26.5-42.9-26.5H136V112c0-26.5 21.5-48 48-48h10.7c6.6 18.6 24.4 32 45.3 32h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H240zM32 352V320H480v32H32zm3.8-64l43.6-87.2c2.7-5.4 8.3-8.8 14.3-8.8H418.3c6.1 0 11.6 3.4 14.3 8.8L476.2 288H35.8zM144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V416H240v64H144z"]
};
var faChildCombatant = {
  prefix: 'fal',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M144 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM480 336V325.3l52.2-17.4 .9-.3c6.5-2.2 10.9-8.3 10.9-15.2V280 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 24l-32 8v-8V256v-1V208 160c0-17.7-14.3-32-32-32V96 32 16c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16s7.2 16 16 16V64 96v32c-17.7 0-32 14.3-32 32v34.7c-18.6 6.6-32 24.4-32 45.3V352c0 19.9 12.1 36.9 29.3 44.2c.9 .4 1.8 .7 2.7 1V480v16c0 8.8 7.2 16 16 16h16 60.1H496c4.9 0 9.4-2.2 12.5-6s4.2-8.7 3.1-13.5l-4.3-19.5L498.2 432l-7.1-32h32.8H528c8.8 0 16-7.2 16-16s-7.2-16-16-16H491.1h-7.1L480 350.2V336zm-27.3 38.9l5.6 25.1 1.5 6.9 9.1 41.1 7.1 32H448h-4.7H416V448 397.3 384c0-4.2-1.6-8-4.3-10.9c-2.9-3.2-7.1-5.1-11.7-5.1c-6.4 0-12-3.8-14.5-9.3c-.7-1.6-1.2-3.3-1.4-5.1c-.1-.5-.1-1-.1-1.6V240c0-2.4 .5-4.7 1.5-6.7c2.5-5.5 8.1-9.3 14.5-9.3c4.6 0 8.8-2 11.7-5.1c2.6-2.9 4.3-6.7 4.3-10.9V194.7 192 160h32v32 16 48 32 8 6.3 23.1V329v7 14.2V352c0 1.2 .1 2.3 .4 3.5l0 0 .4 1.7 2.4 10.8 1.5 6.9zM144 199.9c7.7-5.1 16.8-7.9 26.3-7.9h11.3c9.5 0 18.6 2.8 26.3 7.9l0 .1V352H144V200l0-.1zM144 384h64V496c0 8.8 7.2 16 16 16s16-7.2 16-16V243.3l42.4 69.1c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-59.8-97.5c-14.5-23.7-40.4-38.2-68.2-38.2H170.3c-27.8 0-53.7 14.5-68.2 38.2L42.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3L112 243.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384z"]
};
var faChildRifle = faChildCombatant;
var faGun = {
  prefix: 'fal',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M496 32c8.8 0 16 7.2 16 16V64h32c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H486.6L464 230.6c-6 6-14.1 9.4-22.6 9.4H395.3l-28.6 80.1c-6.8 19.1-24.9 31.9-45.2 31.9H233L207 455.8C203.5 470 190.7 480 176 480H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L73.1 279.8c5-20.2-10.2-39.8-31-39.8H32c-17.7 0-32-14.3-32-32V96C0 78.3 14.3 64 32 64H480V48c0-8.8 7.2-16 16-16zM241 320h80.5c6.8 0 12.8-4.3 15.1-10.6L361.3 240H261l-20 80zM32 96l0 112H42 57.2 235h1 14.9H267 441.4L464 185.4c6-6 14.1-9.4 22.6-9.4H544V96H496 32zM228 240H97.5c8 13.7 10.9 30.5 6.7 47.5L64 448l112 0 52-208z"]
};
var faSquarePhone = {
  prefix: 'fal',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm171.2 48.1l-56 12c-1.8 .4-3.2 2-3.2 3.9c0 114.9 93.1 208 208 208c1.9 0 3.5-1.3 3.9-3.2l12-56c.4-1.9-.6-3.8-2.3-4.5l-56-24c-1.6-.7-3.5-.2-4.7 1.1l-16.6 20.3c-5 6.1-13.6 7.6-20.4 3.7c-25.4-14.7-46.6-35.9-61.4-61.4c-3.9-6.8-2.4-15.4 3.7-20.4l20.3-16.6c1.4-1.1 1.8-3 1.1-4.7l-24-56c-.8-1.8-2.6-2.7-4.5-2.3zm33.9-10.3l24 56c6.3 14.7 2.1 31.9-10.3 42l-9.2 7.5c8.6 11.9 19.1 22.4 31 31l7.5-9.2c10.2-12.4 27.3-16.6 42-10.3l56 24c15.8 6.8 24.6 23.8 21 40.6l-12 56C351.6 388.1 337 400 320 400C187.5 400 80 292.6 80 160c0-17 11.9-31.6 28.5-35.2l56-12c16.8-3.6 33.9 5.2 40.6 21z"]
};
var faPhoneSquare = faSquarePhone;
var faHatBeach = {
  prefix: 'fal',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M192 224v10.8 3.9c.3 .5 1.1 1.5 2.6 2.9c4.2 4 11.9 9 24.2 13.9C243.1 265.3 278.8 272 320 272c11.5 0 22.6-.5 33.1-1.5c-.7-3.8-1.1-7.7-1.1-11.8c0-12.5 3.8-24.6 10.8-34.7c-.5-.7-1-1.4-1.4-2.2c-13.2 1.4-27.1 2.2-41.4 2.2c-44.2 0-84.2-7.2-113.1-18.7c-4.4-1.8-8.6-3.7-12.5-5.6c-1.5 7.9-2.3 16-2.3 24.4zm160-34.7c0-31.1 23.2-56.8 53.3-60.7C382.6 108.3 352.7 96 320 96c-50.9 0-94.9 29.7-115.5 72.8c3.8 2.2 8.6 4.5 14.2 6.8C243.1 185.3 278.8 192 320 192c11.1 0 21.8-.5 32-1.4c0-.4 0-.9 0-1.3zM320 64c55.7 0 104.7 28.4 133.3 71.5c8.9-4.9 19-7.5 29.4-7.5c33.8 0 61.3 27.4 61.3 61.3c0 12.5-3.8 24.6-10.8 34.7c5.2 7.6 8.7 16.2 10.1 25.3l67 26.8c17.9 7.2 29.7 24.6 29.7 43.9c0 17.7-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7C8.9 354.5 0 337.7 0 320c0-19.3 11.8-36.7 29.7-43.9L160 224c0-88.4 71.6-160 160-160zM482.7 320c-12.5 0-24.6-3.8-34.7-10.8c-10.1 7-22.2 10.8-34.7 10.8c-17.5 0-33.2-7.3-44.4-19c-15.4 2-31.8 3-48.9 3c-44.2 0-84.2-7.2-113.1-18.7c-14.5-5.8-26.2-12.7-34.3-20.3c-2.9-2.8-5.4-5.6-7.3-8.6L41.6 305.8c-5.8 2.3-9.6 7.9-9.6 14.2c0 6.1 2.9 15 15.1 26.6c12.3 11.6 31.8 23.5 58.5 34.2C158.9 402.1 234.7 416 320 416s161.1-13.9 214.4-35.2c26.7-10.7 46.2-22.6 58.5-34.2C605.1 335 608 326.1 608 320c0-6.2-3.8-11.9-9.6-14.2l-59.1-23.6c-9.2 22.2-31.1 37.8-56.6 37.8zM413.3 160c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7l2.7 2.7c6.2 6.2 6.2 16.4 0 22.6l-2.7 2.7c-5.5 5.5-8.6 12.9-8.6 20.7c0 16.2 13.1 29.3 29.3 29.3c7.8 0 15.2-3.1 20.7-8.6l2.7-2.7c6.2-6.2 16.4-6.2 22.6 0l2.7 2.7c5.5 5.5 12.9 8.6 20.7 8.6c16.2 0 29.3-13.1 29.3-29.3c0-7.8-3.1-15.2-8.6-20.7l-2.7-2.7c-6.2-6.2-6.2-16.4 0-22.6l2.7-2.7c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-2.7 2.7c-6.2 6.2-16.4 6.2-22.6 0l-2.7-2.7c-5.5-5.5-12.9-8.6-20.7-8.6zM448 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPlus = {
  prefix: 'fal',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H208V448c0 8.8 7.2 16 16 16s16-7.2 16-16V272H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64z"]
};
var faAdd = faPlus;
var faExpand = {
  prefix: 'fal',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M144 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H32V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16H144zM0 336c0-8.8 7.2-16 16-16s16 7.2 16 16V448H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V336zM432 32c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zM416 336c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H416V336z"]
};
var faComputer = {
  prefix: 'fal',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", "M384 64c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H275.5 264 184 172.5 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 384h97.8l-21.3 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h49.8H152 296h22.2H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H307.5l-21.3-64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64zm110.2 64l21.3-64h56.9l21.3 64H174.2zM528 64h64c8.8 0 16 7.2 16 16v48H512V80c0-8.8 7.2-16 16-16zm-16 96h96v32H512V160zm0 272V224h96V432c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16zM480 80V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFort = {
  prefix: 'fal',
  iconName: 'fort',
  icon: [640, 512, [], "e486", "M32 96H96h32 64v16 48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V112 96zM0 160c0 23.7 12.9 44.4 32 55.4V224 448c0 35.3 28.7 64 64 64H240h32 96 32H544c35.3 0 64-28.7 64-64V224v-8.6c19.1-11.1 32-31.7 32-55.4V112 96 64 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H576 544V32 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H480 448V32 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64 96v16 48c0 11.7 3.1 22.6 8.6 32H215.4c5.4-9.4 8.6-20.3 8.6-32V112 96 64 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H160 128V32 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32 64H64 32V32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V64 96v16 48zM400 480V400c0-44.2-35.8-80-80-80s-80 35.8-80 80v80H192V224H448V480H400zm80-256h96V448c0 17.7-14.3 32-32 32H480V224zM64 448l0-224h96V480H96c-17.7 0-32-14.3-32-32zm304 32H272V400c0-26.5 21.5-48 48-48s48 21.5 48 48v80zM608 160c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V112 96h64 32 64v16 48z"]
};
var faCloudCheck = {
  prefix: 'fal',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM427.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 329.4 404.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faXmark = {
  prefix: 'fal',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faFaceSmirking = {
  prefix: 'fal',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm375.8 82.6l-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2H192c-8.8 0-16-7.2-16-16s7.2-16 16-16H304.6c19.6 0 36.2-14.1 39.5-33.4l.2-1.2c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faArrowsUpDownLeftRight = {
  prefix: 'fal',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", "M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V240H54.6l44.7-44.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272H240V457.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 457.4V272H457.4l-44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6l-72-72c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240H272V54.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72-72z"]
};
var faArrows = faArrowsUpDownLeftRight;
var faChalkboardUser = {
  prefix: 'fal',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M576 32H224c-17.7 0-32 14.3-32 32v36c-10.2-2.6-21-4-32-4V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H560 400 384 336.8c-5.3-11.4-11.8-22.2-19.5-32H384V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v48c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM544 384V336c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16v48H544zM224 224A64 64 0 1 0 96 224a64 64 0 1 0 128 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM32.1 480H287.9c-2.8-53.5-47-96-101.2-96H133.3c-54.2 0-98.4 42.5-101.2 96zM0 485.3C0 411.7 59.7 352 133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"]
};
var faChalkboardTeacher = faChalkboardUser;
var faRhombus = {
  prefix: 'fal',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M438.5 230.1l-184-216C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9zM230.1 34.8l184 216c2.5 3 2.5 7.4 0 10.4l-184 216c-1.5 1.8-3.7 2.8-6.1 2.8s-4.6-1-6.1-2.8l-184-216c-2.5-3-2.5-7.4 0-10.4l184-216c1.5-1.8 3.7-2.8 6.1-2.8s4.6 1 6.1 2.8z"]
};
var faClawMarks = {
  prefix: 'fal',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0L170.9 116.3c13.5 13.5 21.1 31.8 21.1 50.9V192h24.8c19.1 0 37.4 7.6 50.9 21.1l95.2 95.2c13.5 13.5 21.1 31.8 21.1 50.9V384h24.8c19.1 0 37.4 7.6 50.9 21.1l79.6 79.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79.6-79.6c-7.5-7.5-17.7-11.7-28.3-11.7H368c-8.8 0-16-7.2-16-16V359.2c0-10.6-4.2-20.8-11.7-28.3l-95.2-95.2c-7.5-7.5-17.7-11.7-28.3-11.7H176c-8.8 0-16-7.2-16-16V167.2c0-10.6-4.2-20.8-11.7-28.3L36.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm0 224c6.2-6.2 16.4-6.2 22.6 0l81.9 81.9c12 12 18.7 28.3 18.7 45.3V384h28.1c17 0 33.3 6.7 45.3 18.7l81.9 81.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-81.9-81.9c-6-6-14.1-9.4-22.6-9.4H144c-8.8 0-16-7.2-16-16V355.9c0-8.5-3.4-16.6-9.4-22.6L36.7 251.3c-6.2-6.2-6.2-16.4 0-22.6zM283.3 4.7l17.9 17.9c12 12 18.7 28.3 18.7 45.3V96h28.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c12 12 18.7 28.3 18.7 45.3V224h28.1c17 0 33.3 6.7 45.3 18.7l17.9 17.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-17.9-17.9c-6-6-14.1-9.4-22.6-9.4H432c-8.8 0-16-7.2-16-16V195.9c0-8.5-3.4-16.6-9.4-22.6l-35.9-35.9c-6-6-14.1-9.4-22.6-9.4H304c-8.8 0-16-7.2-16-16V67.9c0-8.5-3.4-16.6-9.4-22.6L260.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faPesoSign = {
  prefix: 'fal',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", "M71.4 32C49.6 32 32 49.6 32 71.4V128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v80V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352H192c65.6 0 122-39.5 146.7-96H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H348.8c2.1-10.3 3.2-21 3.2-32s-1.1-21.7-3.2-32H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H338.7C314 71.5 257.6 32 192 32H71.4zm231.5 96H64V71.4c0-4.1 3.3-7.4 7.4-7.4H192c47.4 0 88.7 25.7 110.9 64zM64 160H316c2.6 10.2 4 21 4 32s-1.4 21.8-4 32H64V160zm238.9 96c-22.1 38.3-63.5 64-110.9 64H64V256H302.9z"]
};
var faFaceSmileTongue = {
  prefix: 'fal',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 8.8 7.2 16 16 16s16-7.2 16-16C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c36.4 0 71-7.6 102.4-21.3c8.1-3.5 11.8-13 8.3-21.1s-13-11.8-21.1-8.3c-27.4 12-57.7 18.6-89.6 18.6C132.3 480 32 379.7 32 256zm124.5-61.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 161.9 194.8 152 176 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm160 0c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 161.9 354.8 152 336 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-224.6 78c-8.5 2.3-13.6 11.1-11.3 19.6C102 372.3 171.9 432 256 432c31 0 60.1-8.1 85.5-22.4l45.3 29.6c36.8 24 86.2 12.2 108.2-25.8l1.4-2.4c21.4-37.1 9.8-84.4-26.3-107.5l-45.2-28.8c-1.4-1-3-1.7-4.8-2.2c-8.5-2.3-17.3 2.8-19.6 11.3C382.5 351.5 324.1 400 256 400s-126.5-48.5-144.5-116.1c-2.3-8.5-11.1-13.6-19.6-11.3zm278 117.4C394 369.6 413 343 424.8 312.6l28.1 17.9c21.7 13.8 28.6 42.2 15.8 64.5l-1.4 2.4c-12.8 22.2-41.6 29-63 15l-34.4-22.5z"]
};
var faCartCircleXmark = {
  prefix: 'fal',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H67.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5H320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32L151 256 107.3 64l434.4 0L505.7 192.3c10.9 .6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100L95.6 12.5C93.9 5.2 87.5 0 80 0H16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
var faBuildingShield = {
  prefix: 'fal',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c1.3 0 2.6-.1 3.9-.2c7.9 8.6 16.6 16.9 26.3 24.7c-9 4.8-19.3 7.6-30.2 7.6H256 224 160 128 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V207l-32 12.8V64c0-17.7-14.3-32-32-32zM272 240c-8.8 0-16 7.2-16 16v32 8.2V320h-8c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24h48c8.2 0 15.4 4.1 19.7 10.3L301.6 240H272zM192 384c-17.7 0-32 14.3-32 32v64h64V416c0-17.7-14.3-32-32-32zM88 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 64h32V128H96v32zm128-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V120zm32 8v32h32V128H256zM88 224h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H96v32zm224.1 13.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L448 263V471.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"]
};
var faCirclePhoneFlip = {
  prefix: 'fal',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm52.8 144.1c-1.9-.4-3.8 .6-4.5 2.3l-24 56c-.7 1.6-.2 3.5 1.1 4.7l20.3 16.6c6.1 5 7.6 13.6 3.7 20.4c-14.7 25.4-35.9 46.6-61.4 61.4c-6.8 3.9-15.4 2.4-20.4-3.7l-16.6-20.3c-1.1-1.4-3-1.8-4.7-1.1l-56 24c-1.8 .8-2.7 2.6-2.3 4.5l12 56c.4 1.8 2 3.2 3.9 3.2c114.9 0 208-93.1 208-208c0-1.9-1.3-3.5-3.2-3.9l-56-12zm-33.9-10.3c6.8-15.8 23.8-24.6 40.6-21l56 12C388.1 128.4 400 143 400 160c0 132.5-107.4 240-240 240c-17 0-31.6-11.9-35.2-28.5l-12-56c-3.6-16.8 5.2-33.9 21-40.6l56-24c14.7-6.3 31.9-2.1 42 10.3l7.5 9.2c11.9-8.6 22.4-19.1 31-31l-9.2-7.5c-12.4-10.2-16.6-27.3-10.3-42l24-56z"]
};
var faPhoneCircleAlt = faCirclePhoneFlip;
var faBaby = {
  prefix: 'fal',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M224 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM46.1 146.8c20.5-23.1 55.9-25.2 79.1-4.7l24.2 21.5C169.9 181.9 196.5 192 224 192s54.1-10.1 74.6-28.4l24.2-21.5c23.1-20.5 58.5-18.5 79.1 4.7s18.5 58.5-4.7 79.1L373 247.3c-16.1 14.3-33.9 26-53 35.1v32.3l49.9 56.1c16.9 19 18.9 47.1 4.7 68.3l-32 48c-17.2 25.7-51.9 32.7-77.7 15.5s-32.7-51.9-15.5-77.7l8-12L238.9 392H209.1l-18.6 20.9 8 12c17.2 25.7 10.2 60.5-15.5 77.7s-60.5 10.2-77.7-15.5l-32-48c-14.1-21.2-12.2-49.2 4.7-68.3L128 314.7V288.1c0 0 0 0 0-.1s0 0 0-.1v-5.5c-19.1-9-37-20.8-53-35.1L50.8 225.9c-23.1-20.5-25.2-55.9-4.7-79.1zM160 304v16.8c0 .2 0 .4 0 .6l38.9 38.9c1-.2 2-.3 3-.3H246c1 0 2 .1 3 .3L288 321.4c0-.2 0-.4 0-.6V304H160zm128-32c0-6.5 3.9-12.3 9.9-14.7c19.6-8.1 37.8-19.5 53.9-33.8l24.2-21.5c9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2l-24.2 21.5C293.5 211 259.3 224 224 224s-69.5-13-95.9-36.5l-24.2-21.5c-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9l24.2 21.5c16.1 14.3 34.4 25.7 53.9 33.8c6 2.5 9.8 8.3 9.9 14.7H288zm18.7 75.9l-34 34 16.8 19c4.8 5.4 5.4 13.4 1.4 19.5L276 442.7c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c6.1-9.1 5.2-21.1-2-29.3l-39.2-44.1zm-131.4 34l-34-34-39.2 44.1c-7.2 8.2-8.1 20.2-2 29.3l32 48c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-14.9-22.3c-4-6.1-3.5-14.1 1.4-19.5l16.8-19z"]
};
var faUsersLine = {
  prefix: 'fal',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", "M147.2 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 288h-96c-35.3 0-64 28.7-64 64h224c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96h96c53 0 96 43 96 96c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-35.3 28.7-64 64-64h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-17.7 0-32 14.3-32 32zm480-32H456c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-17.7-14.3-32-32-32zM16 448H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faQuoteLeft = {
  prefix: 'fal',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 208C0 146.1 50.1 96 112 96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-44.2 0-80 35.8-80 80v24.6c9.4-5.4 20.3-8.6 32-8.6h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 208zm32 80v32 32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm352-32H320c-17.7 0-32 14.3-32 32v32 32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32zM256 320V288 208c0-61.9 50.1-112 112-112h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-44.2 0-80 35.8-80 80v24.6c9.4-5.4 20.3-8.6 32-8.6h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320z"]
};
var faQuoteLeftAlt = faQuoteLeft;
var faTractor = {
  prefix: 'fal',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", "M128 48V159.2c6.9-18.3 24.5-31.2 45-31.2H211c21.7 0 40.3 14.5 46.1 34.7c12.6-7 27.6-7.8 40.7-2.7h.4 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .4L289.9 41.4c-2.6-5.7-8.3-9.4-14.6-9.4H144c-8.8 0-16 7.2-16 16zM96 157.3V48c0-26.5 21.5-48 48-48H275.3c18.9 0 36 11.1 43.8 28.3L378.3 160h.3 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .2V119.8c0-29.7 11.8-58.2 32.8-79.2l3.9-3.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-3.9 3.9c-15 15-23.4 35.4-23.4 56.6V160h.2 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3c22.2 0 39.9 18 39.9 40v60.5c0 12.2-5.5 23.6-15 31.2L567.1 338c-11.3 9.1-25.4 14-40 14H382.2c-4.4 15.9-16.9 28.5-32.9 33.2c10.2 18.4 7.3 41.8-8.1 57.1l-26.9 26.9c-15.3 15.4-38.7 18.3-57.1 8.1C251.3 497.5 232.7 512 211 512H173c-21.7 0-40.3-14.5-46.1-34.7c-18.4 10.2-41.8 7.3-57.1-8.1L42.8 442.3l11-11-11 11c-15.3-15.4-18.3-38.7-8.1-57.1C14.5 379.3 0 360.7 0 339V301c0-21.7 14.5-40.3 34.7-46.1c-10.2-18.4-7.3-41.8 8.1-57.1l26.9-26.9c7.4-7.4 16.6-11.9 26.3-13.4zM384 320H527.2c7.3 0 14.3-2.5 20-7L605 266.7c1.9-1.5 3-3.8 3-6.2V200c0-4.5-3.6-8-7.9-8h-.3-.3-.3-.3-.3-.3-.3-.3-.3H597h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H591h-.3-.3H590h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H586h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H580h-.4-.4-.4-.4H578h-.4-.4-.4-.4H576h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H571h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H564h-.4-.5-.5-.5-.5-.5-.5-.5-.5-.5H559h-.5H558h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H548h-.5H547h-.5H546h-.5H545h-.5H544h-.5H543h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H531h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H525h-.5-.5-.6-.6-.6-.6-.6-.6-.6-.6H519h-.6-.6-.6-.6-.6-.6H515h-.6-.6-.6-.6-.6-.6H511h-.6-.6-.6-.6-.6-.6H507h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H486h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H476h-.6-.6-.6-.6-.6-.6-.6H471h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H462h-.6-.7H460h-.6-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H432h-.7-.7H430h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H421h-.7-.7H419h-.7-.7-.7-.7-.7-.7-.7-.7-.7H412h-.7-.7-.7-.7-.7-.7-.7-.7-.7H405h-.7-.7-.7-.7-.7-.7H400h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H380h-.7-.7-.7-.7-.7-.7H375h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.1c-.2 0-.5 0-.7 0H367h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H359h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H348h-.7-.7-.7H345h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.6l5.7 5.7c15.4 15.4 18.3 38.7 8.1 57.1c20.2 5.8 34.7 24.4 34.7 46.1v19zM512 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM157 174.4l-1.3 12.9c-.6 6-4.5 11.1-10.1 13.3c-1.8 .7-3.5 1.4-5.2 2.2c-5.5 2.4-11.9 1.6-16.6-2.3l-10.1-8.2c-6.4-5.2-15.6-4.7-21.4 1.1L65.4 220.3c-5.8 5.8-6.3 15.1-1.1 21.4l8.2 10.1c3.8 4.7 4.7 11.1 2.3 16.6c-.8 1.7-1.5 3.5-2.2 5.2c-2.2 5.6-7.3 9.5-13.3 10.1L46.4 285C38.2 285.9 32 292.7 32 301V339c0 8.2 6.2 15.1 14.4 15.9l12.9 1.3c6 .6 11.1 4.5 13.3 10.1c.7 1.8 1.4 3.5 2.2 5.2c2.4 5.5 1.6 11.9-2.3 16.6l-8.2 10.1c-5.2 6.4-4.7 15.6 1.1 21.4l26.9 26.9c5.8 5.8 15.1 6.3 21.4 1.1l10.1-8.2c4.7-3.8 11.1-4.7 16.6-2.3c1.7 .8 3.5 1.5 5.2 2.2c5.6 2.2 9.5 7.3 10.1 13.3l1.3 12.9c.8 8.2 7.7 14.4 15.9 14.4H211c8.2 0 15.1-6.2 15.9-14.4l1.3-12.9c.6-6 4.5-11.1 10.1-13.3c1.8-.7 3.5-1.4 5.2-2.2c5.5-2.4 11.9-1.6 16.6 2.3l10.1 8.2c6.4 5.2 15.6 4.7 21.4-1.1l26.9-26.9c5.8-5.8 6.3-15.1 1.1-21.4l-8.2-10.1c-3.8-4.7-4.7-11.1-2.3-16.6c.8-1.7 1.5-3.4 2.2-5.2c2.2-5.6 7.3-9.5 13.3-10.1l12.9-1.3c8.2-.8 14.4-7.7 14.4-15.9V301c0-8.2-6.2-15.1-14.4-15.9l-12.9-1.3c-6-.6-11.1-4.5-13.3-10.1c-.7-1.8-1.4-3.5-2.2-5.2c-2.4-5.5-1.6-11.9 2.3-16.6l8.2-10.1c5.2-6.4 4.7-15.6-1.1-21.4l-26.9-26.9c-5.8-5.8-15.1-6.3-21.4-1.1l-10.1 8.2c-4.7 3.8-11.1 4.7-16.6 2.3c-1.7-.8-3.5-1.5-5.2-2.2c-5.6-2.2-9.5-7.3-10.1-13.3L227 174.4c-.8-8.2-7.7-14.4-15.9-14.4H173c-8.2 0-15.1 6.2-15.9 14.4zM137.6 320a54.4 54.4 0 1 0 108.8 0 54.4 54.4 0 1 0 -108.8 0zM192 406.4a86.4 86.4 0 1 1 0-172.8 86.4 86.4 0 1 1 0 172.8z"]
};
var faKeySkeleton = {
  prefix: 'fal',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 34 11.8 65.2 31.5 89.9L4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 432 80 390.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L102.6 368 214.1 256.5C238.8 276.2 270 288 304 288z"]
};
var faTrashArrowUp = {
  prefix: 'fal',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM224 176c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V230.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z"]
};
var faTrashRestore = faTrashArrowUp;
var faArrowDownUpLock = {
  prefix: 'fal',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", "M139.3 507.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L144 457.4V272H304h32l80 0c0-11.1 1.6-21.9 4.6-32H336V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 54.6V240H144 112 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V457.4L43.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM144 200V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V200h32zM336 312H304V464c0 8.8 7.2 16 16 16s16-7.2 16-16V312zm192-88c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faArrowDownToBracket = {
  prefix: 'fal',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M363.3 219.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16V297.4L340.7 196.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 336v96c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V336c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faLinesLeaning = {
  prefix: 'fal',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.9 53.7c3.2-8.2-.9-17.5-9.2-20.7s-17.5 .9-20.7 9.2l-160 416c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l160-416zm84.7-21.3c-8.6-2-17.2 3.4-19.2 12l-96 416c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l96-416c2-8.6-3.4-17.2-12-19.2zM368 32c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16z"]
};
var faSquareQ = {
  prefix: 'fal',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256c0 53 43 96 96 96c20.7 0 39.9-6.6 55.6-17.7l-50.9-50.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l50.9 50.9C313.4 295.9 320 276.7 320 256c0-53-43-96-96-96s-96 43-96 96zm224 0c0 29.6-10 56.8-26.9 78.5l22.2 22.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.2-22.2C280.8 374 253.6 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
var faRulerCombined = {
  prefix: 'fal',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M192 192V128l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-17.7-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 288 0 96c0 1.1 .1 2.2 .2 3.3C33.8 467.4 47.5 480 64 480h96l288 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32H416v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H320v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H224v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V224l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm64 96H448c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64l-288 0H64C30.9 512 3.6 486.8 .3 454.5c-.2-2.2-.3-4.3-.3-6.5V352 64C0 28.7 28.7 0 64 0h96c35.3 0 64 28.7 64 64l0 192v32h32z"]
};
var faSymbols = {
  prefix: 'fal',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", "M16 0H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16S7.2 0 16 0zm0 64H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H128V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16zM473.7 4.1C493.5 .2 512 15.3 512 35.5V168h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V35.5L352 61.1V200h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V61.1c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zm16 148a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm171.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0zM480 464a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM76.4 256h8.6c32.6 0 59.1 26.4 59.1 59.1c0 18.1-8.3 35.2-22.6 46.4l-20.2 15.8 49.8 45.3 47.3-35.5c7.1-5.3 17.1-3.9 22.4 3.2s3.9 17.1-3.2 22.4l-42.4 31.8 43.5 39.6c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-48.1-43.7-46.8 35.1C91.3 507.5 77.8 512 64 512c-35.5 0-64-29.1-64-64.3c0-19.7 9-38.6 24.6-50.8l27.1-21.3L35.8 361C23.2 349.6 16 333.4 16 316.4C16 283 43 256 76.4 256zm25.3 80.4c6.5-5.1 10.3-13 10.3-21.3c0-14.9-12.1-27.1-27.1-27.1H76.4C60.7 288 48 300.7 48 316.4c0 8 3.4 15.6 9.3 21l20 18.2 24.4-19.2zM44.4 422C36.6 428.2 32 437.7 32 447.7C32 465.5 46.5 480 64 480c6.9 0 13.7-2.2 19.2-6.4L125 442.2 75.8 397.4 44.4 422z"]
};
var faIconsAlt = faSymbols;
var faCopyright = {
  prefix: 'fal',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm67.9-188.1c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8s98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faFlaskGear = {
  prefix: 'fal',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", "M288 196.8V32H160V196.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320H304.6c2.2 13.3 10.3 25 21.2 32H81.2L37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480H351c15.6 13.1 36.9 13.7 53 4.8v.9c0 6.7 1.5 13.5 4.2 19.7c-9 4.3-19 6.6-29.7 6.6H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h48H288h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V196.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3c-1.9 3.3-3.7 6.6-5.4 10l-14.8-24.1C292.9 232 288 214.6 288 196.8zm175.3 43c-3.1 16.6-14 29.5-26.6 36.7c-13 7.4-30 9.9-46 3.7l-17.2 30.5c12.8 11.4 18.5 27.7 18.5 42.4s-5.7 31-18.5 42.4L390.7 426c15.9-6.3 33-3.7 46 3.7c12.6 7.2 23.6 20.1 26.6 36.7H497c3-16.6 13.9-29.5 26.5-36.7c12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6c-12.6-7.2-23.5-20.2-26.5-36.7H463.3zm43.5-32c11.8 0 21.4 9.6 21.4 21.4v1.6c0 7.5 4.6 14.2 11.1 18c6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2L619 303.1c5.7 10.2 2.3 23.1-7.8 29c-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29L592.5 450c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3c-6.5 3.7-11.1 10.4-11.1 18V477c0 11.8-9.6 21.4-21.4 21.4H453.4c-11.7 0-21.3-9.5-21.3-21.3v-1.4c0-7.6-4.6-14.4-11.3-18.2c-6.6-3.7-14.7-4.2-21.2-.3l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 403.1c-5.7-10.2-2.3-23.1 7.8-29c7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3c6.6-3.8 11.3-10.6 11.3-18.2v-1.4c0-11.7 9.5-21.3 21.3-21.3h53.4zM424.1 353.1a56 56 0 1 1 112.1 0 56 56 0 1 1 -112.1 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHighlighterLine = {
  prefix: 'fal',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M166.6 319.2L122.9 363c-3.1 3.1-3.1 8.2 0 11.3l62.8 62.8c3.1 3.1 8.2 3.1 11.3 0l43.7-43.7c6-6 14.1-9.4 22.6-9.4h48c5.2 0 10-2.5 13-6.7l19.4-27L209.6 216.3l-27 19.4c-4.2 3-6.7 7.8-6.7 13v48c0 8.5-3.4 16.6-9.4 22.6zm196 4.8L523.8 99.5c2.7-3.8 4.2-8.4 4.2-13c0-5.9-2.4-11.6-6.5-15.8L489.3 38.5c-4.2-4.2-9.9-6.5-15.8-6.5c-4.7 0-9.2 1.5-13 4.2L236 197.4 362.6 324zm-51.3 92h-48l-43.7 43.7c-11.4 11.4-27.9 14.5-42 9.3l-36 36c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17l84-84c-5.2-14.2-2.1-30.7 9.3-42L144 296.6v-48c0-15.5 7.4-30 20-39L441.8 10.2C451 3.6 462.1 0 473.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4c0 11.4-3.6 22.5-10.2 31.7L350.4 396c-9 12.6-23.5 20-39 20zM111 407.6L38.6 480h82.7l31-31L111 407.6zM240 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBracketSquare = {
  prefix: 'fal',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 80C0 53.5 21.5 32 48 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-26.5 0-48-21.5-48-48V80z"]
};
var faBracket = faBracketSquare;
var faBracketLeft = faBracketSquare;
var faIslandTropical = {
  prefix: 'fal',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M150.8 96H66.9C76.3 68.3 109.1 32 176 32c45.5 0 75.1 16.8 92.3 35.9c4.4 4.9 11.2 6.6 17.4 4.3C299.5 67.2 316.2 64 336 64c66.9 0 99.7 36.3 109.1 64H260.8c-4.2 0-8.3 1.7-11.3 4.7L133.9 248.2c-13-26.2-15.4-75 31.8-122.3l.1-.1c11.4-11.4 22.8-19.8 33.9-26c7.7-4.3 10.5-14 6.3-21.7s-14-10.5-21.7-6.3C173 78.1 161.8 86 150.8 96zM176 0C91.6 0 45.8 49.5 34.7 92.2C29.1 113.6 47.7 128 64 128h58.1c-37.5 52.8-32.9 107.4-13.7 140.3c11.2 19.1 34.5 16.2 46.1 4.6l83.1-83.1c-.4 3.9-.9 7.9-1.4 12.1c-5.3 40.7-17 94.1-42.4 150.1H160C89.3 352 32 409.3 32 480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32c0-65-48.4-118.6-111.1-126.9c19.6-64.1 20.6-123.6 16.1-168.7c-.9-8.7-1.9-16.8-3.1-24.4H448c16.3 0 34.9-14.4 29.3-35.8C466.2 81.5 420.4 32 336 32c-19 0-36.1 2.5-51.4 6.9C260.8 16.5 224.7 0 176 0zM285.4 160c1.4 8.4 2.7 17.6 3.7 27.6c4.4 44 3.2 102.1-17.4 164.4h-43c23-54.6 34-106.1 39.2-145.9c2.3-18 3.5-33.6 4-46.1h13.5zM288 384c53 0 96 43 96 96H64c0-53 43-96 96-96H288z"]
};
var faIslandTreePalm = faIslandTropical;
var faArrowRightFromLine = {
  prefix: 'fal',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", "M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 288 240l-176 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 105.4 0L292.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80z"]
};
var faArrowFromLeft = faArrowRightFromLine;
var faH2 = {
  prefix: 'fal',
  iconName: 'h2',
  icon: [640, 512, [], "f314", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zm400.1 41.5c19.2-16.5 43.7-25.5 69-25.5H507c47 0 85 38.1 85 85c0 23.1-9.4 45.2-26.1 61.2l-185 178.2c-4.7 4.5-6.2 11.5-3.7 17.5s8.3 10 14.8 10H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H431.7L588.1 265.3C611.1 243.3 624 212.8 624 181c0-64.6-52.4-117-117-117h-5.8c-33 0-64.8 11.8-89.9 33.2l-21.7 18.6c-6.7 5.8-7.5 15.9-1.7 22.6s15.8 7.5 22.6 1.7l21.7-18.6z"]
};
var faEquals = {
  prefix: 'fal',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M32 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H32zm0 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H32z"]
};
var faCakeSlice = {
  prefix: 'fal',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M296 64L52.3 256H480c0-64-28-112-65-144s-83-48-119-48zM0 272c0-9.8 4.5-19.1 12.2-25.1l264-208c5.6-4.4 12.6-6.9 19.8-6.9c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v.5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .1 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .1 .1 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2c0 35.4-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V368 272zm32 80H480v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V346v-.3-.3V345v-.3-.3V344v-.3-.3V343v-.3-.3V342v-.3-.3V341v-.3-.3V340v-.3-.3V339v-.3-.3V338v-.3-.3V337v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4V330v-.4-.4V329v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V325v-.4-.4V324v-.4-.4-.4-.4-.4-.4-.4V321v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V312v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V307v-.4-.4-.4-.4V305v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V297v-.4-.4-.4-.4V295v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V290v-.4-.4-.4-.4V288H32l0 64zm0 32l0 32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32v-.2-.2-.2-.2-.2V415v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V413v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V411v-.2-.2-.2-.2V410v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V406v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V401v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V398v-.2-.2-.2-.2-.2-.2-.2-.2V396v-.2-.2-.2-.2-.2-.2-.2-.2V394v-.2-.2-.2V393v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V390v-.2-.2-.2V389v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V384H32z"]
};
var faShortcake = faCakeSlice;
var faPeanut = {
  prefix: 'fal',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M127.1 249.9l.2 0 .2 0c25.9-5.1 58.5-14.4 83.1-39s33.9-57.2 39-83.1l0-.2 0-.2c1.5-8.2 3.8-16 6.9-23.5l0 0c5.5-13.4 13.7-26 24.5-37l0 0C302.4 45.2 331.6 32 364 32h68c26.5 0 48 21.5 48 48v68c0 15.8-3.1 30.8-8.8 44.4l0 0c-5.6 13.6-14 26.4-25.2 37.6c-11.2 11.2-24 19.6-37.7 25.2l0 0c-7.5 3.1-15.3 5.4-23.5 6.9l-.2 0-.2 0c-25.9 5.1-58.5 14.4-83.1 39s-33.9 57.2-39 83.1l0 .2 0 .2c-1.5 8.2-3.8 16-6.9 23.5l0 0c-5.5 13.4-13.7 26-24.5 37l0 0C209.6 466.8 180.4 480 148 480H80c-26.5 0-48-21.5-48-48V364c0-15.8 3.1-30.8 8.8-44.4l0 0c5.6-13.6 14-26.4 25.2-37.6c11.2-11.2 24-19.6 37.7-25.2l0 0c7.5-3.1 15.3-5.4 23.5-6.9zM148 512c41.3 0 78.7-16.9 105.5-44.2c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.5-7.2 33.9-17.9 48.1-32.1c14.2-14.2 24.9-30.5 32.1-48C508 187.2 512 168.1 512 148V80c0-44.2-35.8-80-80-80H364c-41.3 0-78.7 16.9-105.5 44.2c-13.8 14-24.2 30.1-31.3 47.2c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68zM435.2 128a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-64 64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm-224 224a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM192 435.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM435.2 192a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM192 371.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4z"]
};
var faWrenchSimple = {
  prefix: 'fal',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M137 2.8c4.4 3 7 7.9 7 13.2V168l48 36 48-36V16c0-5.3 2.6-10.2 7-13.2s9.9-3.6 14.8-1.7C332.9 28.9 384 94.1 384 176c0 71.1-38.6 133.1-96 166.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V332.8c0-6 3.4-11.5 8.7-14.2C316.6 292.1 352 238.2 352 176c0-58.9-31.9-107.7-80-134.8V176c0 5-2.4 9.8-6.4 12.8l-64 48c-5.7 4.3-13.5 4.3-19.2 0l-64-48c-4-3-6.4-7.8-6.4-12.8V41.2C63.9 68.3 32 117.1 32 176c0 62.2 35.4 116.1 87.3 142.6c5.4 2.7 8.7 8.2 8.7 14.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.3C38.6 309.1 0 247.1 0 176C0 94.1 51.1 28.9 122.2 1.1C127.1-.8 132.7-.2 137 2.8z"]
};
var faBlender = {
  prefix: 'fal',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 72C0 32.2 32.2 0 72 0h56 24 8.1H471c20.8 0 36.1 19.6 31 39.8L423.1 355.4C456 365.3 480 395.9 480 432v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-37.8 26.2-69.5 61.5-77.9L148 240H72c-39.8 0-72-32.2-72-72V72zM128 432v32c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V432c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zM423 224H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H431l16-64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H455l16-64H162.8l26.7 320H391l32-128zM72 32C49.9 32 32 49.9 32 72v96c0 22.1 17.9 40 40 40h73.3L130.7 32H72zM288 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTeeth = {
  prefix: 'fal',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", "M96 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H96zM0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h64V224zM96 288v32c0 17.7 14.3 32 32 32s32-14.3 32-32V288H96zm75.5 79c-11.4 10.6-26.7 17-43.5 17c-35.3 0-64-28.7-64-64V272 224c0-35.3 28.7-64 64-64c14 0 27 4.5 37.6 12.2c10.9-26 36.5-44.2 66.4-44.2c22.6 0 42.8 10.4 56 26.7c13.2-16.3 33.4-26.7 56-26.7c29.9 0 55.5 18.2 66.4 44.2C421 164.5 434 160 448 160c35.3 0 64 28.7 64 64v48 48c0 35.3-28.7 64-64 64c-16.8 0-32-6.5-43.5-17c-12.8 19.9-35.1 33-60.5 33c-22.6 0-42.8-10.4-56-26.7c-13.2 16.3-33.4 26.7-56 26.7c-25.4 0-47.7-13.2-60.5-33zM232 160c-22.1 0-40 17.9-40 40v24 32h80V200c0-22.1-17.9-40-40-40zM192 320v8c0 22.1 17.9 40 40 40s40-17.9 40-40V288H192v32zm224-64h64V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v32zm0 64c0 17.7 14.3 32 32 32s32-14.3 32-32V288H416v32zm-72 48c22.1 0 40-17.9 40-40v-8V288H304v40c0 22.1 17.9 40 40 40zm40-112V224 200c0-22.1-17.9-40-40-40s-40 17.9-40 40v56h80z"]
};
var faTally2 = {
  prefix: 'fal',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", "M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"]
};
var faShekelSign = {
  prefix: 'fal',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M80 32C53.5 32 32 53.5 32 80V464c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16H192c44.2 0 80 35.8 80 80V336c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-61.9-50.1-112-112-112H80zM304 480c61.9 0 112-50.1 112-112V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 44.2-35.8 80-80 80H192c-8.8 0-16-7.2-16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 26.5 21.5 48 48 48H304z"]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faCars = {
  prefix: 'fal',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", "M124.2 32H259.8c14.3 0 26.8 9.5 30.8 23.2L306.8 112c-.9 0-1.9 0-2.8 0H80c-.9 0-1.9 0-2.8 0L93.4 55.2C97.4 41.5 109.9 32 124.2 32zM62.7 46.4L41 122.1C16.6 135.8 0 162 0 192v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V288H257.6c3.7-3.7 7.7-7.1 11.9-10.2l6.2-21.8H32V240 192c0-26.5 21.5-48 48-48H304c11.8 0 22.6 4.3 31 11.3c10.3-5.5 21.6-9.2 33.6-10.6c-6.8-9.2-15.5-17-25.6-22.6L321.3 46.4C313.5 18.9 288.4 0 259.8 0H124.2C95.6 0 70.5 18.9 62.7 46.4zM80 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm300.2-16H515.8c14.3 0 26.8 9.5 30.8 23.2L562.8 288c-.9 0-1.9 0-2.8 0H336c-.9 0-1.9 0-2.8 0l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9v48 16 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16V464H608v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464 432 416 368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H380.2c-28.6 0-53.7 18.9-61.5 46.4zM608 416v16H288V416 368c0-26.5 21.5-48 48-48H560c26.5 0 48 21.5 48 48v48zM336 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faAxeBattle = {
  prefix: 'fal',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M73.6 52.1C47.4 93.7 32 144.4 32 192c0 48.6 16.1 100.9 43.5 142.9c7.2-15 16.3-28.9 26.1-41c22.1-27.2 56.1-54.2 106.4-65v32.9c-38.6 9.9-64.4 31.2-81.6 52.3c-13.6 16.8-25 36.8-30.9 57.8c-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3C25.5 327.7 0 257.4 0 192C0 126.4 25.6 56.5 67.7 5.7C71.8 .9 78.4-1.1 84.5 .7c6.1 1.8 10.5 7 11.3 13.3c2.9 20.2 12.8 40.3 24.9 56.4c15.9 21.3 42.5 43.5 87.2 52.9v32.6c-56.2-10.1-91.3-37.7-112.8-66.3C87 78.7 79.4 66 73.6 52.1zM304 261.8V228.9c50.3 10.8 84.4 37.8 106.5 65c9.9 12.1 18.9 26 26.1 41c20.8-32.1 35.2-70.2 40.8-108.2l-12.1-12.1c-12.5-12.5-12.5-32.8 0-45.3l12.1-12.1c-5.4-36.8-19.2-73.7-39-105.2C432.7 66 425 78.7 416.9 89.6c-21.5 28.6-56.7 56.2-112.9 66.3V123.3c44.8-9.4 71.3-31.7 87.3-52.9c12.1-16.1 22-36.2 24.9-56.4c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.7 .2 16.8 5.1c37.2 44.9 61.5 104.6 66.7 163.2l-.4 .4L488 192l22.6 22.6 .4 .4c-5.2 58.5-29.4 118.6-66.7 163.2c-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8c-17.2-21.1-43-42.4-81.7-52.3zM272 48V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faUserHairLong = {
  prefix: 'fal',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M320 128c0-5.5-.5-10.8-1.3-16H288.6c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128L128 128v16c0 53 43 96 96 96s96-43 96-96V128zM224 0c70.7 0 128 57.3 128 128c0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9c0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3c0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3c0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128C96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9c.8-1.6 1.8-3.1 3.1-4.5zM32 480H416c-1.9-71-60-128-131.5-128H163.6C92.1 352 33.9 409 32 480zM0 483.6C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"]
};
var faMap = {
  prefix: 'fal',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", "M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8V440.4l128-51.2V71.6L32 122.8zm352 320V124.1L192 69.2V387.9l192 54.9zm32-2.4l128-51.2V71.6L416 122.8V440.4z"]
};
var faArrowLeftFromArc = {
  prefix: 'fal',
  iconName: 'arrow-left-from-arc',
  icon: [512, 512, [], "e615", "M480 256C480 132.3 379.7 32 256 32c-8.8 0-16-7.2-16-16s7.2-16 16-16C397.4 0 512 114.6 512 256s-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224zM149.4 116c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L58.1 240H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H58.1L170.6 372c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3L5.4 268C2 264.9 0 260.6 0 256s2-8.9 5.4-12l144-128z"]
};
var faFileCircleInfo = {
  prefix: 'fal',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16V384c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h0c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 416c-8.8 0-16-7.2-16-16z"]
};
var faFaceDisappointed = {
  prefix: 'fal',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faLassoSparkles = {
  prefix: 'fal',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", "M336 0c8.8 0 16 7.2 16 16V64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V16c0-8.8 7.2-16 16-16zM0 176C0 85.4 112 10.8 256 1.1v32C129.7 42 32 102.6 32 176c0 47.1 40.2 88.9 102.4 115.2l0 0c5.5 2.3 11.2 4.5 17 6.6l0 0C190.9 311.9 237.8 320 288 320c141.4 0 256-64.5 256-144c0-45.5-37.5-86-96-112.4V29.6C525.2 61.2 576 115 576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176zM512 368v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V368c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faClockEleven = {
  prefix: 'fal',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112v91.2l-34.7-52c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l64 96c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faRocket = {
  prefix: 'fal',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M188.9 372l-50.4-50.4c18.6-42.6 61.7-137.7 95.1-187C304.6 30.1 409 24.6 475.7 36.3c11.7 66.7 6.2 171.1-98.4 242c-49.4 33.5-145.5 75.6-188.4 93.7zm-79.9-62.8c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2V312.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-90.2 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6H118.5c-3.6 8-6.8 15.2-9.4 21.2zM256 470.1l0-92.5c30.3-13.7 65.4-30.3 96-47v71.7c0 12.1-6.8 23.2-17.7 28.6L256 470.1zM109.7 160h71.5c-16.9 30.7-34 65.8-48.1 96H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"]
};
var faSirenOn = {
  prefix: 'fal',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M55.2 33.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm544 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 192H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16zM492 320H459.8L439.3 156c-2-16-15.6-28-31.8-28h-175c-16.1 0-29.8 12-31.8 28L180.2 320H148l21-167.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L492 320zm-250.1 0l14.2-114c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9L274.1 320H241.9zM496 384H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16zM144 352H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faClockTen = {
  prefix: 'fal',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V226.1l-71.1-47.4c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l96 64c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faCandleHolder = {
  prefix: 'fal',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", "M112 112c0 26.5 21.5 48 48 48s48-21.5 48-48c0-8.8-6.5-24-20.5-43.1C178.4 56.4 168 45.1 160 36.8c-8 8.3-18.4 19.6-27.5 32.1C118.5 88 112 103.2 112 112zm48 80c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zM0 496c0-8.8 7.2-16 16-16H64V272c0-26.5 21.5-48 48-48h32 64c26.5 0 48 21.5 48 48V480h72.6c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64H256 224 96 64 16c-8.8 0-16-7.2-16-16zM128 256H112c-8.8 0-16 7.2-16 16V480H224V272c0-8.8-7.2-16-16-16H160v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256zM384 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faVideoArrowDownLeft = {
  prefix: 'fal',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M320 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V336.8 175.2 128c0-35.3-28.7-64-64-64H64zM416 354.4l103.4 56.9c5.6 3.1 12 4.7 18.4 4.7c21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2V377.8c0 3.4-2.8 6.2-6.2 6.2c-1 0-2.1-.3-3-.8L416 317.9v36.5zM224 352c8.8 0 16-7.2 16-16s-7.2-16-16-16H150.6L283.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 297.4V224c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16H224z"]
};
var faPhotoFilm = {
  prefix: 'fal',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M576 32H256c-17.7 0-32 14.3-32 32V233.4L297.4 160c12.5-12.5 32.8-12.5 45.3 0L384 201.4 489.4 96c12.5-12.5 32.8-12.5 45.3 0L608 169.4V64c0-17.7-14.3-32-32-32zm64 176c0 0 0 0 0 .1v80c0 35.3-28.7 64-64 64H272c0 0 0 0 0 0H256c-35.3 0-64-28.7-64-64V272s0 0 0 0V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V208zm-32 6.7l-96-96L395.3 235.3 310.6 320H576c17.7 0 32-14.3 32-32V214.6zM265.4 320l96-96L320 182.6l-96 96V288c0 17.7 14.3 32 32 32h9.4zM296 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 160h32v32H128v80V400v80H384V384h32v96h32c17.7 0 32-14.3 32-32V384h32v64c0 35.3-28.7 64-64 64H416 400 384 128 112 96 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H96h16 16zM32 256H96V192H64c-17.7 0-32 14.3-32 32v32zm0 160v32c0 17.7 14.3 32 32 32H96V416H32zm64-32V288H32v96H96z"]
};
var faPhotoVideo = faPhotoFilm;
var faFloppyDiskCircleArrowRight = {
  prefix: 'fal',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V170.5c0-8.5-3.4-16.6-9.4-22.6L332.1 73.4c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64C46.3 64 32 78.3 32 96zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96H288V64H96zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
var faFolderMinus = {
  prefix: 'fal',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M32 96c0-17.7 14.3-32 32-32H188.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4L233.4 50.7c-12-12-28.3-18.7-45.3-18.7H64zm96 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faPlanetMoon = {
  prefix: 'fal',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 480C118 480 32 394 32 288c0-8.1 .5-16.1 1.5-24H92.1c8.5 0 16.6 3.4 22.6 9.4L152 310.6v31.5c0 17 9.6 32.6 24.8 40.2c4.4 2.2 7.2 6.7 7.2 11.6v15.3C184 435 205 456 230.8 456c16.2 0 31.3-8.4 39.9-22.3l45.5-73.9c7.8-12.6 11.9-27.1 11.9-41.9V296c0-26.5-21.5-48-48-48H218.5c-5.2 0-10-3-12.4-7.7c-2.2-4.4-1.9-9.7 .9-13.9L249.3 163c9.8-14.7 14.4-32.1 13.3-49.7l-.9-13.6C349.6 117.2 416 194.8 416 288c0 106-86 192-192 192zM40.3 232C64.3 153.3 137.4 96 224 96c1.8 0 3.5 0 5.3 .1l1.3 19.3c.7 10.5-2.1 21-8 29.8l-42.3 63.5c-9.1 13.7-10.2 31.2-2.9 45.9c7.8 15.5 23.6 25.3 41 25.3H280c8.8 0 16 7.2 16 16v21.9c0 8.9-2.5 17.6-7.1 25.2L243.4 417c-2.7 4.4-7.5 7-12.6 7c-8.2 0-14.8-6.6-14.8-14.8V393.9c0-17-9.6-32.6-24.8-40.2c-4.4-2.2-7.2-6.7-7.2-11.6V304v-6.6l-4.7-4.7-41.9-41.9c-12-12-28.3-18.7-45.3-18.7H40.3zM227.2 64c-1.1 0-2.1 0-3.2 0C100.3 64 0 164.3 0 288S100.3 512 224 512s224-100.3 224-224c0-111.7-81.7-204.2-188.6-221.2l0 0c-10.5-1.7-21.3-2.6-32.3-2.8l0 0z"]
};
var faFaceEyesXmarks = {
  prefix: 'fal',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8c0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2c0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48H318.8c-5.5-27.4-29.6-48-58.6-48zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faChartScatter = {
  prefix: 'fal',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDisplayArrowDown = {
  prefix: 'fal',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", "M64 0H240V32H64C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H336V0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM245.6 416l-10.7 64H341.1l-10.7-64H245.6zM304 16V233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L272 233.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faStore = {
  prefix: 'fal',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M520.6 120.9l0 0c18.7 29.6 .3 66.6-29.2 70.6c-2.6 .3-5.2 .5-7.9 .5c-16.5 0-31.2-7.2-41.5-18.5c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5c-29.3-4-47.7-41-29.1-70.6l0 0L111.6 32H464.4l56.2 88.9zM483.4 224c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2zM80 256c-8.8 0-16 7.2-16 16v80 16 16 64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 368 352 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H96V272c0-8.8-7.2-16-16-16zM96 384H480v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384z"]
};
var faArrowTrendUp = {
  prefix: 'fal',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", "M368 112c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L331.3 363.3c-6.2 6.2-16.4 6.2-22.6 0L192 246.6 27.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l176-176c6.2-6.2 16.4-6.2 22.6 0L320 329.4 521.4 128H384c-8.8 0-16-7.2-16-16z"]
};
var faPlugCircleMinus = {
  prefix: 'fal',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faOliveBranch = {
  prefix: 'fal',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M128 96C89.1 96 59.2 78.1 41.6 64C59.2 49.9 89.1 32 128 32s68.8 17.9 86.4 32C196.8 78.1 166.9 96 128 96zm0-96C59.2 0 14.1 44.2 2.8 56.6C.9 58.6 0 61.2 0 64s.9 5.4 2.8 7.4c8.2 8.9 34 34.5 73.8 48C30.6 147.6 0 198.2 0 256v16c0 8.8 7.2 16 16 16H48c88.4 0 160-71.6 160-160V114.4L330.4 55.6C362.8 40.1 398.3 32 434.3 32H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H434.3c-40.7 0-81 9.2-117.7 26.8L253.6 57c-.1-.2-.3-.3-.4-.4C241.9 44.2 196.8 0 128 0zm47.7 128c.1 0 .2 0 .3 0c0 70.7-57.3 128-128 128H32c0-70.7 57.3-128 128-128h15.7zM412.2 436.6C390.7 465.2 363.4 480 336 480s-54.7-14.8-76.2-43.4S224 366.8 224 320s14.3-87.9 35.8-116.6C281.3 174.8 308.6 160 336 160s54.7 14.8 76.2 43.4C433.7 232.1 448 273.2 448 320s-14.3 87.9-35.8 116.6zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c13.6 10.4 25.7 22.9 36.2 36.9c.5 .7 1 1.4 1.5 2c28.3 9 57.7 26.8 83.4 53.5c33.1 34.4 52.4 75.3 57.5 112.6c5.2 37.5-3.9 68.9-23.6 89.3c-19.5 20.2-48.9 29.2-84 24c-5-.7-10.1-1.8-15.2-3.1c-5.2 10-11 19.5-17.4 28.3z"]
};
var faAngle = {
  prefix: 'fal',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", "M238.3 55.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-208 416c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H41.9L238.3 55.2zM295 238.9c-16.3-20.5-35-39.1-55.6-55.2c-7.7-6.1-19-3.2-23.4 5.6c-3.5 7.1-1.4 15.6 4.8 20.5c17.8 14.1 34 30.2 48.2 47.9c5.3 6.6 14.7 8.4 21.9 3.9c7.8-4.9 9.9-15.4 4.1-22.7zm14.5 84.9c9.9 22.2 17.3 45.7 21.7 70.3c1.4 8 8.2 14 16.3 14c9.6 0 17.2-8.4 15.5-17.9c-4.9-28.4-13.4-55.5-25-81c-3.9-8.6-14.5-11.4-22.5-6.4c-7 4.4-9.4 13.5-6 21z"]
};
var faVacuumRobot = {
  prefix: 'fal',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM356.7 155.3c-55.6-55.6-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c55.6-55.6 55.6-145.8 0-201.4zm-144 57.4c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"]
};
var faSignHanging = {
  prefix: 'fal',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M80 0c8.8 0 16 7.2 16 16V64l400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16l48 0V16C64 7.2 71.2 0 80 0zm80 160l0 192H448V160H160zm-32 0c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160z"]
};
var faSign = faSignHanging;
var faSquareDivide = {
  prefix: 'fal',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 240H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSignalStreamSlash = {
  prefix: 'fal',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-70.7-25.5-135.5-67.8-185.6c-5.7-6.8-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5C521.4 135.6 544 193.1 544 256c0 29.5-5 57.8-14.1 84.1L556.3 361C569 328.5 576 293 576 256zm-96 0c0-46.4-16.5-89-43.9-122.2c-5.6-6.8-15.7-7.8-22.5-2.1s-7.8 15.7-2.1 22.5C434.3 181.9 448 217.3 448 256c0 6.3-.4 12.5-1.1 18.7l28.6 22.6c2.9-13.3 4.4-27.1 4.4-41.3zM139.9 195.3l-26-20.5C102.4 199.5 96 227 96 256c0 46.4 16.5 89 43.9 122.2c5.6 6.8 15.7 7.8 22.5 2.1s7.8-15.7 2.1-22.5C141.7 330.1 128 294.7 128 256c0-21.5 4.2-42 11.9-60.7zm-77.2-61L37.2 114.3C13.5 156.1 0 204.5 0 256c0 70.7 25.5 135.5 67.8 185.6c5.7 6.8 15.8 7.6 22.5 1.9s7.6-15.8 1.9-22.5C54.6 376.4 32 318.9 32 256c0-44 11.1-85.4 30.7-121.6z"]
};
var faBezierCurve = {
  prefix: 'fal',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M352 64c8.8 0 16 7.2 16 16v21.2V112v22 10c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V134 112 101.2 80c0-8.8 7.2-16 16-16h64zm83.4 64H514c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H400V80c0-26.5-21.5-48-48-48H288c-26.5 0-48 21.5-48 48V96H126c-7.1-27.6-32.2-48-62-48C28.7 48 0 76.7 0 112s28.7 64 64 64c29.8 0 54.9-20.4 62-48h78.6C139.5 167.2 96 238.5 96 320l-16 0c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48l-16 0c0-77.5 45.9-144.3 112-174.6c.7 25.9 21.9 46.6 48 46.6h64c26 0 47.2-20.7 48-46.6c66.1 30.3 112 97.1 112 174.6l-16 0c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48l-16 0c0-81.5-43.5-152.8-108.6-192zM544 352l16 0c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16l16 0h32zm-416 0l16 0c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16l16 0h32zM32 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm512 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faEyeDropperHalf = {
  prefix: 'fal',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l0 0-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4 0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H102.6l84.7-84.7zM64 378.5c0-9.5 2.8-18.7 8-26.5H249.4l-81.9 81.9c-9 9-21.2 14.1-33.9 14.1H88 83.8l-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7V424 378.5z"]
};
var faStoreLock = {
  prefix: 'fal',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M520.6 120.9l0 0c8.1 12.7 9.2 26.8 5.6 39.1c.6 0 1.2 0 1.8 0c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c1.2 .9 2.5 1.8 3.8 2.7c6.1-9.1 13.5-17.2 22-24.1c-5.7-3.1-10.8-7.1-15.1-11.8c-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4c-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5c-29.3-4-47.7-41-29.1-70.6l0 0L111.6 32H464.4l56.2 88.9zM96 352V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v80 16 16 64c0 35.3 28.7 64 64 64H392.6c-5.4-9.4-8.6-20.3-8.6-32l-256 0c-17.7 0-32-14.3-32-32V384H384V352L96 352zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z"]
};
var faBellSlash = {
  prefix: 'fal',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", "M378.8 384H140.3c-6.8 0-12.3-5.5-12.3-12.3c0-3.3 1.3-6.4 3.6-8.7l2.8-2.8c33.4-33.4 53.5-77.5 57.1-124.2L160 211.2v9.9c0 43.7-17.4 85.6-48.3 116.6l-2.8 2.8c-8.3 8.3-13 19.6-13 31.3c0 24.5 19.8 44.3 44.3 44.3H419.4l-40.5-32zM304 32.8C264.5 36.7 229.2 55 203.4 82.4l25.2 19.9C251.9 78.7 284.2 64 320 64c70.7 0 128 57.3 128 128v29.1c0 21.4 3.5 42.5 10.2 62.4l75.1 59.3c-.7-.8-1.5-1.7-2.3-2.5l-2.8-2.8C497.4 306.7 480 264.8 480 221.1V192c0-83-63.1-151.2-144-159.2V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32.8zM289.8 458.7c-2.9-8.3-12.1-12.7-20.4-9.8s-12.7 12.1-9.8 20.4c8.8 24.8 32.5 42.7 60.4 42.7s51.6-17.8 60.4-42.7c2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8C345.8 471.1 333.9 480 320 480s-25.8-8.9-30.2-21.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCloudBoltSun = {
  prefix: 'fal',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8L303.8 13.4zM208 120c-48.6 0-88 39.4-88 88c0 31 16 58.2 40.1 73.9c.6-12.5 2.9-24.5 6.8-35.7c-9.3-10-15-23.4-15-38.1c0-30.9 25.1-56 56-56c13.2 0 25.4 4.6 35 12.3c2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm96 72c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H543.9c-.5 11.8-4.9 23-12.4 32h25.7c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 42 27 77.7 64.6 90.7c1.6-10.9 6.5-21.1 14.1-29.1C243.7 342 224 317.3 224 288c0-35.3 28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 184l85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4H335.7zM457.6 224c-5.1 0-10.1 2-13.8 5.5L294.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7c0 11.9 9.7 21.6 21.6 21.6H359l-34.9 75.5c-6.1 13.3 3.6 28.5 18.2 28.5c5.1 0 10.1-2 13.8-5.5L505.3 365.3c4.3-4.1 6.7-9.7 6.7-15.7c0-11.9-9.7-21.6-21.6-21.6H441l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"]
};
var faThunderstormSun = faCloudBoltSun;
var faCameraSlash = {
  prefix: 'fal',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 376.6V160c0-35.3-28.7-64-64-64H440.9L430.5 64.8C423.9 45.2 405.6 32 384.9 32H255.1c-20.7 0-39 13.2-45.5 32.8l-5.9 17.8 26.7 21.1 9.6-28.7c2.2-6.5 8.3-10.9 15.2-10.9H384.9c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H512c17.7 0 32 14.3 32 32V351.3l32 25.3zM96 160.7L67.7 138.4c-2.4 6.8-3.7 14-3.7 21.6V416c0 35.3 28.7 64 64 64H500.4l-40.5-32H128c-17.7 0-32-14.3-32-32V160.7zM378.4 383.6l-27.6-21.8c-9.5 4-19.9 6.1-30.8 6.1c-44.2 0-80-35.8-80-80c0-4.4 .3-8.6 1-12.8l-27.6-21.8c-3.5 10.9-5.4 22.5-5.4 34.6c0 61.9 50.1 112 112 112c21.4 0 41.4-6 58.4-16.4z"]
};
var faCommentQuote = {
  prefix: 'fal',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM208 176v24 24H160V176h48zm-48 80h48c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 322.7 240 290.7 240 254V224 200 176c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm144-80h48v24 24H304V176zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 322.7 384 290.7 384 254V224 200 176c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48z"]
};
var faTablet = {
  prefix: 'fal',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTabletAndroid = faTablet;
var faSchoolFlag = {
  prefix: 'fal',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M304 64h80V32H304V64zM272 16c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H315.5l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H352 320 256 224 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H170.9L272 87.8V64 16zm48 400c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm32 64H512c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H400c-3.3 0-6.6-1-9.3-3L288 115.7 185.3 189c-2.7 1.9-6 3-9.3 3H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H224V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64zM256 240a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM64 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 0H96v32h32V256zm320-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v32h32V256H448zM64 384c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V384zm64 0H96v32h32V384zm320-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm0 32v32h32V384H448z"]
};
var faMessageCode = {
  prefix: 'fal',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM219.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L345.4 208l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faGlassHalf = {
  prefix: 'fal',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7L336 228.1V224H48v5.1L32.1 40.7zM50.3 256H333.6L317.2 450.7C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3L50.3 256zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"]
};
var faGlassHalfEmpty = faGlassHalf;
var faGlassHalfFull = faGlassHalf;
var faFill = {
  prefix: 'fal',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M59.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l97.4 97.4L30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0l-64.4 64.4L59.3 4.7zm97.4 142.6l88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88 64.4-64.4c15.6-15.6 40.9-15.6 56.6 0L451.7 211.7c15.6 15.6 15.6 40.9 0 56.6L432 288H35c1.7-13.6 7.8-26.8 18.2-37.3L156.7 147.3zM53.3 341.3C47 335 42.3 327.7 39.2 320H400L261.3 458.7c-25 25-65.5 25-90.5 0L53.3 341.3z"]
};
var faMessageMinus = {
  prefix: 'fal',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faCommentAltMinus = faMessageMinus;
var faAngleUp = {
  prefix: 'fal',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z"]
};
var faDinosaur = {
  prefix: 'fal',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M417.6 19.2C426.7 7.1 440.9 0 456 0h13C563.5 0 640 76.5 640 170.9v50.9c0 76.5-39.4 147.6-104.3 188.2L512 424.9V464c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V453c-3.5 .9-7.5 1.8-11.7 2.6c-14.2 3-32.3 6-52.4 7.5c-.5-11.2-3.4-21.9-8.2-31.5c20.5-1.1 39.4-4.1 54-7.2c9.1-1.9 16.5-3.8 21.6-5.3c2.5-.7 4.5-1.3 5.8-1.7c.6-.2 1.1-.4 1.4-.5l.3-.1 .1 0 0 0c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416.3c0-2.8 .6-5.6 2-8s3.4-4.5 5.8-6l31-19.4c55.5-34.7 89.2-95.6 89.2-161V170.9C608 94.2 545.8 32 469.1 32H456c-5.1 0-9.8 2.4-12.8 6.4l-6.8 9.1c-6.7 8.9-15.8 15.9-26.1 20c-11 4.4-18.2 15.1-18.2 26.9v1.8c0 17.5 14.2 31.7 31.7 31.7h74.5c34.1 0 61.8 27.7 61.8 61.8v23c0 32.7-26.5 59.1-59.1 59.1c-27.3 0-53.9-8.5-76.2-24.4l-26-18.6c-33.7-24.1-74-37-115.4-37c-49.6 0-97.3 18.5-133.9 51.9L61.1 324.4C42.6 341.4 32 365.4 32 390.5c0 49.4 40.1 89.5 89.5 89.5h121c7.5 0 13.5-6.1 13.5-13.5c0-6.4-4.4-11.9-10.7-13.2l-97.6-21.1C117.5 425.6 96 398.9 96 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 15.8 11 29.5 26.5 32.8L252.1 422C273 426.5 288 445 288 466.5c0 25.1-20.4 45.5-45.5 45.5h-121C54.4 512 0 457.6 0 390.5c0-34.1 14.4-66.7 39.6-89.7l88.2-80.5c42.5-38.8 97.9-60.3 155.5-60.3c48.1 0 94.9 15 134 43l26 18.6c16.8 12 36.9 18.4 57.6 18.4c15 0 27.1-12.1 27.1-27.1v-23c0-16.5-13.4-29.8-29.8-29.8H423.7c-35.2 0-63.7-28.5-63.7-63.7V94.5c0-24.9 15.2-47.4 38.3-56.6c4.9-2 9.2-5.3 12.4-9.5l6.8-9.1zM448 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faDrumstickBite = {
  prefix: 'fal',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M192 272c0 26.5 21.5 48 48 48h88.2c-5.3-15-8.2-31.2-8.2-48c0-79.5 64.5-144 144-144c2.6 0 5.3 .1 7.9 .2C452.2 72.2 398.8 32 336 32c-79.5 0-144 64.5-144 144v96zm-32 0V176C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1H240c-3 0-6-.2-8.9-.5L192 390.6l0 0 0 .1c0 .1-.1 .5-.1 1.2c.1 1.5 .7 3.5 2 5.2c8.9 12 14.2 26.9 14.2 42.9c0 39.8-32.2 72-72 72c-37.2 0-67.8-28.2-71.6-64.4C28.2 443.8 0 413.2 0 376c0-39.8 32.2-72 72-72c16.1 0 30.9 5.3 42.9 14.2c1.7 1.2 3.7 1.9 5.2 2c.7 0 1.1-.1 1.2-.1l.1 0 39.1-39.1c-.3-2.9-.5-5.9-.5-8.9zm12.2 42.4L144 342.7c-15 15-36.5 9.9-48.1 1.2C89.2 338.9 81 336 72 336c-22.1 0-40 17.9-40 40s17.9 40 40 40c13.1 0 24 10.9 24 24c0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.8c-8.7-11.7-13.7-33.2 1.2-48.1l28.2-28.2c-10.3-6.4-18.9-15.1-25.4-25.4z"]
};
var faLinkHorizontalSlash = {
  prefix: 'fal',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 320c0-70.7-57.3-128-128-128H480c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c53 0 96 43 96 96c0 24.2-8.9 46.3-23.7 63.1L609.5 403c19-22.3 30.5-51.3 30.5-83zM459.9 448l-40.5-32H335.9c-52.9 0-95.9-42.9-95.9-95.9c0-13.9 3-27.2 8.4-39.2l-25.7-20.3c-9.4 17.8-14.6 38.1-14.6 59.5C208 390.8 265.2 448 335.9 448H459.9zM400 191.9c0 13.9-3 27.2-8.4 39.2l25.7 20.3c9.4-17.8 14.6-38.1 14.6-59.5C432 121.2 374.8 64 304.1 64H180.1l40.5 32h83.5c52.9 0 95.9 42.9 95.9 95.9zm-344.3-63L30.5 109C11.5 131.4 0 160.3 0 192c0 70.7 57.3 128 128 128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96c0-24.2 8.9-46.3 23.7-63.1z"]
};
var faChainHorizontalSlash = faLinkHorizontalSlash;
var faHollyBerry = {
  prefix: 'fal',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M288 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 0a64 64 0 1 0 0 128A64 64 0 1 0 256 0zM128 289.3V268.4l2.3 .8c24 8 49.8 8.7 74.2 2.1l5.9-1.6-1.6 5.9c-6.6 24.4-5.9 50.2 2.1 74.2l1 2.9C164.6 358 128 398.1 128 446.7l0 20.9-2.3-.8c-24-8-49.8-8.7-74.2-2.1l-5.9 1.6 1.6-5.9c6.6-24.4 5.9-50.2-2.1-74.2l-1-2.9C91.4 378 128 337.9 128 289.3zM115.6 497.2l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4c-4.9 17.9 11.6 34.4 29.5 29.5L60 495.6c18.3-5 37.6-4.5 55.6 1.5zm46-415.6c-28.4 6.5-49.6 32-49.6 62.4c0 35.3 28.7 64 64 64c30.4 0 55.8-21.2 62.4-49.6c-10.9-2-21.2-5.9-30.5-11.3C206.3 163.3 192.6 176 176 176c-17.7 0-32-14.3-32-32c0-16.6 12.7-30.3 28.9-31.9c-5.4-9.3-9.3-19.6-11.3-30.5zm112 76.8c6.5 28.4 32 49.6 62.4 49.6c35.3 0 64-28.7 64-64c0-30.4-21.2-55.8-49.6-62.4c-2 10.9-5.9 21.2-11.3 30.5c16.2 1.5 28.9 15.2 28.9 31.9c0 17.7-14.3 32-32 32c-16.6 0-30.3-12.7-31.9-28.9c-9.3 5.4-19.6 9.3-30.5 11.3zM384 289.3c0 48.6 36.6 88.7 83.8 94.1l-1 2.9c-8 24-8.7 49.8-2.1 74.2l1.6 5.9-5.9-1.6c-24.4-6.6-50.2-5.9-74.2 2.1l-2.3 .8 0-20.9c0-48.6-36.6-88.7-83.8-94.1l1-2.9c8-24 8.7-49.8 2.1-74.2l-1.6-5.9 5.9 1.6c24.4 6.6 50.2 5.9 74.2-2.1l2.3-.8v20.9zm12.4 207.9c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.7 452c-5-18.3-4.5-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-19.4-5.3c-17.9-4.9-34.4 11.6-29.5 29.5l5.3 19.4c5 18.3 4.4 37.6-1.5 55.6l-4.3 12.8c-5.2 15.5 6.4 31.6 22.8 31.6c34.6 0 62.7 28.1 62.7 62.7v32c0 16.4 16 27.9 31.6 22.8l12.8-4.3z"]
};
var faNose = {
  prefix: 'fal',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M190.2 8.6c-4.1-7.8-13.7-10.9-21.6-6.8s-10.9 13.7-6.8 21.6c74 142.4 171.9 248.6 223.7 299.3c19.1 18.7 30.5 43.7 30.5 69.6c0 48.5-39.3 87.7-87.7 87.7h-34l-2.3-2.6-38.7-43.5c-19.1-21.5-46.5-33.8-75.3-33.8c-27.6 0-49.9 22.3-49.9 49.9V456c0 30.9 25.1 56 56 56H328.3C394.4 512 448 458.4 448 392.3c0-35.3-15.5-68.3-40.1-92.4c-50.5-49.5-145.8-153-217.7-291.2zm39.1 446.5L251.5 480H184c-13.3 0-24-10.7-24-24v-6.1c0-9.9 8-17.9 17.9-17.9c19.7 0 38.4 8.4 51.4 23.1zm-98-151.4c8.6-1.9 14.1-10.4 12.3-19s-10.4-14.1-19-12.3l-22.8 4.9C42.4 290 0 342.4 0 403.2c0 38.2 17 74.5 46.3 98.9l7.4 6.2c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5l-7.4-6.2C44.8 459.1 32 431.9 32 403.2c0-45.6 31.9-85.1 76.5-94.6l22.8-4.9z"]
};
var faArrowLeftToArc = {
  prefix: 'fal',
  iconName: 'arrow-left-to-arc',
  icon: [512, 512, [], "e616", "M32 256C32 132.3 132.3 32 256 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.6 0 0 114.6 0 256S114.6 512 256 512c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zM309.4 116l-144 128c-3.4 3-5.4 7.4-5.4 12s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L218.1 272H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H218.1L330.6 140c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3z"]
};
var faChevronLeft = {
  prefix: 'fal',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"]
};
var faBacteria = {
  prefix: 'fal',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M310.4 1.3c8.1 3.5 11.8 12.9 8.3 21.1L314 33.1C329.7 41 342.7 53.8 350.9 70l10.7-4.7c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c1.7 20.2-4 39.8-15.3 55.6l6 3.7c7.5 4.7 9.8 14.5 5.2 22s-14.5 9.8-22 5.2l-13.3-8.2c-7.6 4.7-16.2 8.3-25.4 10.5c-6.8 1.6-13.2 3.4-19.1 5.4l3.8 17.3c1.9 8.6-3.5 17.2-12.1 19.1s-17.2-3.5-19.1-12.1L246 208.8c-19.4 11.6-31.2 25.3-38.8 37.2l7.6 3.6c8 3.8 11.4 13.3 7.6 21.3s-13.3 11.4-21.3 7.6l-7.4-3.5c-1 3.3-1.7 6.7-2.3 10.1c-1.5 14.1-6.5 27.1-14 38.1L187.6 334c6.1 6.4 5.8 16.6-.6 22.6s-16.6 5.8-22.6-.6l-9.6-10.2c-15.3 10.2-34 15.6-53.7 13.9l-6.4 14.7c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1L70 350.9c-16-8.1-28.9-21.1-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1L24.3 283c-.4-4.8-.4-9.6 .1-14.6c1.1-12.1 3.8-24.2 7-35.9c.2-.9 .5-1.7 .7-2.6l-15.2-7.6c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l11.6 5.8c4.8-11.7 11-24.2 18.8-37.2c1.9-3.2 3.9-6.4 6.1-9.6l-5.1-3.8c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2l5 3.7c10.9-13.1 23.5-25.8 38.1-37.8L114.4 72.4c-4.6-7.5-2.3-17.4 5.2-22s17.4-2.3 22 5.2l9 14.7c14.5-9.4 30.6-18 48.3-25.5l-3.6-8.5c-3.5-8.1 .3-17.5 8.4-21s17.5 .3 21 8.4L229 33.8c9-2.8 18.3-5.4 28.1-7.6c8.7-2 17.4-2.6 25.8-1.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3zM192 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm31.7 81.6c.1-.5 .1-.9 .2-1.4c2.8-18.2 10.3-34.8 18.2-48c16-26.7 46.7-59.1 109.6-73.6c28-6.5 45.4-34.4 39-62.4s-34.4-45.4-62.4-39c-93.1 21.5-146.4 73-175.4 121.4C74.8 202.3 66.7 224.5 62.2 241c-2.9 10.6-5.1 20.8-6 30.3c-2.6 28.6 18.5 53.8 47.1 56.4c28.3 2.6 53.3-18 56.4-46.1zm161.6 208l4.7-10.7c-15.6-7.9-28.7-20.7-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1l14.7-6.4c-1.7-20.2 4-39.8 15.3-55.6l-6-3.7c-7.5-4.6-9.8-14.5-5.2-22s14.5-9.8 22-5.2l13.3 8.2c7.6-4.7 16.2-8.3 25.4-10.5c6.8-1.6 13.2-3.4 19.1-5.4l-3.8-17.3c-1.9-8.6 3.5-17.2 12.1-19.1s17.2 3.5 19.1 12.1l2.4 10.7c19.4-11.6 31.2-25.3 38.8-37.2l-7.6-3.6c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6l7.4 3.5c1-3.3 1.7-6.7 2.3-10.1c1.5-14.1 6.5-27.1 14-38.1L452.4 178c-6.1-6.4-5.8-16.6 .6-22.6s16.6-5.8 22.6 .6l9.6 10.2c15.3-10.2 34-15.6 53.7-13.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3s11.8 12.9 8.3 21.1L570 161.1c16 8.1 28.9 21.1 36.9 36.9l10.7-4.7c8.1-3.5 17.5 .2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c.4 4.8 .4 9.6-.1 14.6c-1.1 12.1-3.8 24.2-7 35.9c-.2 .9-.5 1.7-.7 2.6l15.2 7.6c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-11.6-5.8c-4.8 11.7-11 24.2-18.8 37.2c-1.9 3.2-3.9 6.4-6.1 9.6l5.1 3.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-5-3.7c-10.9 13.1-23.5 25.8-38.1 37.8l10.3 16.8c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2l-9-14.7c-14.5 9.4-30.6 18-48.3 25.5l3.6 8.5c3.5 8.1-.3 17.5-8.4 21s-17.5-.3-21-8.4L411 478.2c-9 2.8-18.3 5.4-28.1 7.6c-8.7 2-17.4 2.6-25.8 1.9l-6.4 14.6c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1zM416 408a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm64.3-177.6c0 .5-.1 .9-.2 1.4c-2.8 18.2-10.3 34.8-18.2 48c-16 26.7-46.7 59.1-109.6 73.6c-28 6.5-45.4 34.4-39 62.4s34.4 45.4 62.4 39c93.1-21.5 146.4-73 175.4-121.4c14.2-23.6 22.2-45.8 26.7-62.3c2.9-10.6 5.1-20.8 6-30.3c2.6-28.6-18.5-53.8-47.1-56.4c-28.3-2.6-53.3 18-56.4 46.1z"]
};
var faClouds = {
  prefix: 'fal',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", "M208 32c39.9 0 73 29.2 79 67.4c.9 5.6 4.7 10.3 9.9 12.4s11.2 1.2 15.7-2.3C323.5 101 337.1 96 352 96c35.3 0 64 28.7 64 64c0 14.7-5 28.3-13.3 39.1l.9 .8c12.2-4.5 25.3-7.2 39-7.8c3.6-10 5.5-20.8 5.5-32.1c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192s43 96 96 96h64.9c1.2-11.1 3.7-21.8 7.3-32H96c-35.3 0-64-28.7-64-64s28.7-64 64-64c4.4 0 8.7 .4 12.8 1.3c4.8 1 9.7-.3 13.4-3.4s5.9-7.7 5.8-12.6c0-.4 0-.9 0-1.3c0-44.2 35.8-80 80-80zm16 272c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H232c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM640 408c0-55.2-43-100.3-97.3-103.8C535.2 258.7 495.6 224 448 224c-19.3 0-37.3 5.7-52.4 15.5C375.3 210.8 341.9 192 304 192c-61.9 0-112 50.1-112 112c0 2.6 .1 5.3 .3 7.9C154.6 327.5 128 364.6 128 408c0 57.4 46.6 104 104 104H536c57.4 0 104-46.6 104-104z"]
};
var faMoneyBillSimple = {
  prefix: 'fal',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faHandLizard = {
  prefix: 'fal',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M0 120C0 89.1 25.1 64 56 64H286.6c36.2 0 70.1 17.5 91.1 46.9L491.1 269.7c13.6 19 20.9 41.8 20.9 65.1V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V334.8c0-16.7-5.2-32.9-14.9-46.5L351.7 129.5c-15-21-39.3-33.5-65.1-33.5H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H256c35.3 0 64 28.7 64 64s-28.7 64-64 64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H272c3.2 0 6.2 .9 8.9 2.7l96 64c4.4 3 7.1 8 7.1 13.3v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V408.6L267.2 352H120c-30.9 0-56-25.1-56-56s25.1-56 56-56H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H56c-30.9 0-56-25.1-56-56z"]
};
var faTablePivot = {
  prefix: 'fal',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", "M160 64v96H480V96c0-17.7-14.3-32-32-32H160zm0 128V448H448c17.7 0 32-14.3 32-32V192H160zM128 64H64C46.3 64 32 78.3 32 96v64h96V64zM32 416c0 17.7 14.3 32 32 32h64V192H32V416zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM446.8 278.1c-2.5 6-8.3 9.9-14.8 9.9H416v48c0 26.5-21.5 48-48 48H320v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16V288H368c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z"]
};
var faFilterSlash = {
  prefix: 'fal',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm541 93.3c5.9-7.1 9.1-16 9.1-25.2C576 49.7 558.3 32 536.5 32H139.6l40.5 32H536.5c4.2 0 7.5 3.4 7.5 7.5c0 1.8-.6 3.4-1.7 4.8l-137 165.5 25.1 19.8L566.9 96.7zM352 362.8v83.3c0 1-.8 1.9-1.9 1.9c-.4 0-.8-.1-1.1-.4l-61-47.4V312.3L256 287V400.2c0 9.9 4.6 19.2 12.4 25.3l61 47.4c5.9 4.6 13.3 7.1 20.8 7.1c18.7 0 33.9-15.2 33.9-33.9V388.1l-32-25.3z"]
};
var faTrashCanUndo = {
  prefix: 'fal',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm155.9 93.3c5.9 6.6 5.4 16.7-1.2 22.6l-49 44.1H240c44.2 0 80 35.8 80 80v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-26.5-21.5-48-48-48H169.7l49 44.1c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-80-72c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l80-72c6.6-5.9 16.7-5.4 22.6 1.2z"]
};
var faTrashCanArrowTurnLeft = faTrashCanUndo;
var faTrashUndoAlt = faTrashCanUndo;
var faNotdef = {
  prefix: 'fal',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M32 452.5L172.3 256 32 59.5V452.5zM51.7 480H332.3L192 283.5 51.7 480zm160-224L352 452.5V59.5L211.7 256zM332.3 32H51.7L192 228.5 332.3 32zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]
};
var faDisease = {
  prefix: 'fal',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M64.1 280.3c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42zM253.6 93.2c-28.3 42.4-78.9 64.3-129.2 56l-59.6-9.9c-17.2-2.9-32.8 10.4-32.8 27.8c0 7.5 3 14.6 8.3 19.9l29.2 29.2c17 17 26.6 40.1 26.6 64.1c0 24.4-9.8 47.8-27.3 64.8L55.7 357.9c-4.9 4.8-7.7 11.4-7.7 18.3c0 16.4 15.1 28.5 31.1 25l62.3-13.8c10-2.2 20.3-3.4 30.5-3.4h10c34.5 0 68 11.7 94.9 33.3L307.8 442c4.8 3.9 10.8 6 17 6c15.1 0 27.3-12.2 27.3-27.3l0-25.2c0-48.1 29.5-91.2 74.3-108.6l36.9-14.3c10.1-3.9 16.8-13.7 16.8-24.5c0-12.7-9.1-23.6-21.6-25.9l-28-5.1c-49.1-9-88.1-46.4-99-95.2l-7.1-31.5C320.9 75 307.2 64 291.3 64c-11.3 0-21.9 5.7-28.2 15.1l-9.4 14.1zM304 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM136 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPersonToDoor = {
  prefix: 'fal',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", "M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM179.4 116.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5 .4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L224.9 490.7c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4 .4-.9 .5-1.3l37.2-111.6L298 253.2c5.9 20.6 24.7 34.8 46.2 34.8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H344.1c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7L218.3 302.4 190.9 287c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1L101.3 384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM528 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V317.3c-5 1.8-10.4 2.7-16 2.7H384V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48V224h16c5.6 0 11 1 16 2.7V48c0-8.8 7.2-16 16-16h96z"]
};
var faTurntable = {
  prefix: 'fal',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M512 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm160 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 17.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V288.5c-16 1.4-30.9 10.8-38.6 26.2l-16 32c-11.8 23.6-2.2 52.2 21.3 64s52.2 2.2 64-21.3l16-32c10.6-21.2 3.9-46.5-14.6-59.9zM452.3 320c2.3 0 4.6 .6 6.8 1.7c7.9 4 11.1 13.6 7.2 21.5l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c2.7-5.5 8.2-8.7 14-8.8h.7z"]
};
var faBriefcaseMedical = {
  prefix: 'fal',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M176 32H336c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H368h80c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h80zm96 48c-17.7 0-32 14.3-32 32v32H176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H304V208c0-17.7-14.3-32-32-32H240zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H288c-8.8 0-16 7.2-16 16v48H240V320c0-8.8-7.2-16-16-16H176V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faGenderless = {
  prefix: 'fal',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
var faChevronRight = {
  prefix: 'fal',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"]
};
var faSignalWeak = {
  prefix: 'fal',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", "M64 384c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-8.8 7.2-16 16-16z"]
};
var faSignal1 = faSignalWeak;
var faClockFive = {
  prefix: 'fal',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V251.2l61.3 92c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-64-96c-1.8-2.6-2.7-5.7-2.7-8.9V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faRetweet = {
  prefix: 'fal',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", "M96 103.9L146.5 160 45.5 160 96 103.9zm88 60.5c0-6.8-2.5-13.4-7.1-18.4l-69-76.7c-3-3.4-7.4-5.3-11.9-5.3s-8.9 1.9-11.9 5.3L15.1 146C10.5 151.1 8 157.6 8 164.4C8 179.7 20.3 192 35.6 192H80V336c0 44.2 35.8 80 80 80H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-26.5 0-48-21.5-48-48V192h44.4c15.2 0 27.6-12.3 27.6-27.6zM480 408.1L429.5 352l100.9 0L480 408.1zm-88-60.5c0 6.8 2.5 13.4 7.1 18.4l69 76.7c3 3.4 7.4 5.3 11.9 5.3s8.9-1.9 11.9-5.3l69-76.7c4.6-5.1 7.1-11.6 7.1-18.4c0-15.2-12.3-27.6-27.6-27.6H496V176c0-44.2-35.8-80-80-80H272c-8.8 0-16 7.2-16 16s7.2 16 16 16H416c26.5 0 48 21.5 48 48V320H419.6c-15.2 0-27.6 12.3-27.6 27.6z"]
};
var faCarRear = {
  prefix: 'fal',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M159.6 64H352.4c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6H96c-3.6 0-7.2 .2-10.7 .6l28.3-94.4c6.1-20.3 24.8-34.2 46-34.2zM74.7 227.9l.1-.3c6.6-2.3 13.8-3.6 21.2-3.6H416c7.4 0 14.5 1.3 21.2 3.6l.1 .3 .5-.1c24.6 8.9 42.3 32.5 42.3 60.2H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 17.7-14.3 32-32 32H352V352c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v32H64c-17.7 0-32-14.3-32-32V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c0-27.7 17.6-51.3 42.3-60.2l.5 .1zM320 384H192V352H320v32zM48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288v64c0 23.7 12.9 44.4 32 55.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16V416H448v48c0 8.8 7.2 16 16 16s16-7.2 16-16V407.4c19.1-11.1 32-31.7 32-55.4V288c0-35.7-19.4-66.8-48.3-83.3l-.4-1.3L429 89c-10.2-33.8-41.3-57-76.6-57H159.6C124.3 32 93.1 55.2 83 89L48.7 203.4z"]
};
var faCarAlt = faCarRear;
var faPumpSoap = {
  prefix: 'fal',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", "M128 48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48h76.1c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L354.7 89.4c-6-6-14.1-9.4-22.6-9.4H256v48H224V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v80H128V48zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480H285.2c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3H117.4c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM156.2 345.1c-2.7 5.3-4.2 11.2-4.2 17.2c0 20.8 16.9 37.7 37.7 37.7h4.7c20.8 0 37.7-16.9 37.7-37.7c0-6-1.4-11.9-4.2-17.2L192 275.4l-35.8 69.7zM192 240c10.9 0 20.9 6.1 25.9 15.8l38.4 74.7c5.1 9.9 7.7 20.8 7.7 31.9c0 38.5-31.2 69.7-69.7 69.7h-4.7c-38.5 0-69.7-31.2-69.7-69.7c0-11.1 2.6-22 7.7-31.9l38.4-74.7c5-9.7 15-15.8 25.9-15.8z"]
};
var faComputerClassic = {
  prefix: 'fal',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M384 32c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H384zM64 0C28.7 0 0 28.7 0 64V368c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V423.4c19.1-11.1 32-31.7 32-55.4V64c0-35.3-28.7-64-64-64H64zm0 432H384v48H64l0-48zM352 96V224H96V96H352zM96 64C78.3 64 64 78.3 64 96V224c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM224 336c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM96 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFrame = {
  prefix: 'fal',
  iconName: 'frame',
  icon: [448, 512, [], "e495", "M448 112c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L96 96l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 256-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 256 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-256 48 0c8.8 0 16-7.2 16-16zM96 384l0-256 256 0 0 256L96 384z"]
};
var faVideoSlash = {
  prefix: 'fal',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM416 175.2V128c0-35.3-28.7-64-64-64H180.1l40.5 32H352c17.7 0 32 14.3 32 32v97l32 25.3v-75zM64 384V135.4L34.1 111.8C32.7 117 32 122.4 32 128V384c0 35.3 28.7 64 64 64H352c26.4 0 49-16 58.8-38.8l-27.1-21.4C381.8 403.7 368.4 416 352 416H96c-17.7 0-32-14.3-32-32zM576 134.2V376.6l26.5 20.9c3.5-5.8 5.5-12.5 5.5-19.7V134.2c0-21.1-17.1-38.2-38.2-38.2c-6.4 0-12.8 1.6-18.4 4.7L448 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8c3.4 0 6.2 2.8 6.2 6.2z"]
};
var faBatteryQuarter = {
  prefix: 'fal',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192h32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM64 208v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faBattery2 = faBatteryQuarter;
var faEllipsisStroke = {
  prefix: 'fal',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM256 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM128 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-96 0a64 64 0 1 0 128 0A64 64 0 1 0 32 256z"]
};
var faEllipsisHAlt = faEllipsisStroke;
var faRadio = {
  prefix: 'fal',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6s-11-13.6-19.6-11.3L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66C.3 185.2 0 188.5 0 192v1.2V240 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H138.1l362-96.5zM32 193.2c0-2.2 .1-4.3 .4-6.4C34.9 171.6 48.1 160 64 160H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V240 193.2zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm256 16a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z"]
};
var faBabyCarriage = {
  prefix: 'fal',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M.7 224c-.2-2.9-.4-5.7-.5-8.6C0 212.9 0 210.5 0 208V192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192h8v0H416V144c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16 7.2-16 16v48 16 8h-.2c-.1 2.7-.3 5.3-.5 8c-1.8 22.2-7.5 44-16.8 64.5c-11.5 25.4-28.2 48.3-49.2 67.5c-20.9 19.2-45.6 34.2-72.6 44.5S253 416 224 416s-57.9-5.2-84.8-15.5s-51.6-25.3-72.6-44.5C45.7 336.9 28.9 314 17.5 288.5C8.2 268 2.5 246.2 .7 224zm216.4-32L113.7 42.8C66.3 76.2 34.7 130.4 32.2 192H217.1zM32.8 224c1.8 17.6 6.4 34.9 13.8 51.4c9.6 21.4 23.8 40.8 41.6 57.1s39 29.3 62.3 38.2s48.3 13.4 73.5 13.4s50.2-4.6 73.5-13.4s44.5-21.8 62.3-38.2s32-35.7 41.6-57.1c7.4-16.4 12.1-33.7 13.8-51.4H256c-.1 0-.1 0-.2 0H32.8zM80 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm304 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCarriageBaby = faBabyCarriage;
var faFaceExpressionless = {
  prefix: 'fal',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 80H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM128 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faDownToDottedLine = {
  prefix: 'fal',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", "M222.2 351.2c.5 .5 1.1 .8 1.8 .8s1.4-.3 1.8-.8L350.2 219.3c1.2-1.2 1.8-2.9 1.8-4.6c0-3.7-3-6.7-6.7-6.7L288 208c-8.8 0-16-7.2-16-16l0-120c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8l0 120c0 8.8-7.2 16-16 16l-57.3 0c-3.7 0-6.7 3-6.7 6.7c0 1.7 .7 3.3 1.8 4.6L222.2 351.2zM224 384c-9.5 0-18.6-3.9-25.1-10.8L74.5 241.2C67.8 234 64 224.5 64 214.7c0-21.4 17.3-38.7 38.7-38.7l41.3 0 0-104c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 104 41.3 0c21.4 0 38.7 17.3 38.7 38.7c0 9.9-3.8 19.3-10.5 26.5L249.1 373.2c-6.5 6.9-15.6 10.8-25.1 10.8zm192 44a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 428a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm312 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 428a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-72 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faCloudMusic = {
  prefix: 'fal',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM409.1 186.8c4.3 3 6.9 7.9 6.9 13.2V328c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V223.1l-96 36V360c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V248c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8zM384 332c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12zM256 364c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12z"]
};
var faTrafficLight = {
  prefix: 'fal',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M64 32C46.3 32 32 46.3 32 64V352c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z"]
};
var faCloudMinus = {
  prefix: 'fal',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM224 272H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faThermometer = {
  prefix: 'fal',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M352.8 53.8L310.6 96l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 118.6 246.6 160l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 182.6 224l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 246.6l-22.6 22.6c-6 6-9.4 14.1-9.4 22.6V384h92.1c8.5 0 16.6-3.4 22.6-9.4L458.2 159.2c14-14 21.8-32.9 21.8-52.7C480 65.4 446.6 32 405.5 32c-19.8 0-38.7 7.8-52.7 21.8zM276.7 84.7l53.5-53.5c20-20 47.1-31.2 75.3-31.2C464.3 0 512 47.7 512 106.5c0 28.2-11.2 55.3-31.2 75.3L265.4 397.3c-12 12-28.3 18.7-45.3 18.7H118.6L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L96 393.4V291.9c0-17 6.7-33.3 18.7-45.3l33.9-33.9 64-64 64-64s0 0 0 0s0 0 0 0z"]
};
var faShieldMinus = {
  prefix: 'fal',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faVrCardboard = {
  prefix: 'fal',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M576 96H64c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H200.4c12.1 0 23.2-6.8 28.6-17.7L268.2 320c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l-21.5 10.7L371.8 320l39.2 78.3c5.4 10.8 16.5 17.7 28.6 17.7H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H439.6c-24.2 0-46.4-13.7-57.2-35.4l-39.2-78.3c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-39.2 78.3c-10.8 21.7-33 35.4-57.2 35.4H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm336 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faCarTilt = {
  prefix: 'fal',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", "M131.7 88.2L304.3 41.9c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6 .5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8C39.5 271.5 30.2 304.8 39 337.6l22 82.1L65.3 436l0 0 11.8 44L16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l608 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-515.4 0-10-37.2 1.5-.4L508.7 332.9l1.5-.4L522 376.6c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4L384.8 46.2C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9L60.9 243.3zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0 -44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zM420.4 262a22.8 22.8 0 1 0 -11.8-44.1A22.8 22.8 0 1 0 420.4 262z"]
};
var faGaugeCircleMinus = {
  prefix: 'fal',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194c0-8.8 7.2-16 16-16s16 7.2 16 16l0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16z"]
};
var faBrightnessLow = {
  prefix: 'fal',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", "M280 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM432 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm96-128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM408 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm0-256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 384a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faHandMiddleFinger = {
  prefix: 'fal',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M224 56c0-13.3 10.7-24 24-24s24 10.7 24 24V226.7c0 5.2 2.5 10.1 6.8 13.1s9.7 3.8 14.6 2c3.3-1.2 6.9-1.8 10.7-1.8c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32v88 8c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C86.6 442.6 64 404.7 64 363.5V344c0-15.1 7.1-29.3 19.2-38.4l22.5-16.9c2-1.5 4.1-3 6.3-4.4V344c0 8.8 7.2 16 16 16s16-7.2 16-16V264c0-.9-.1-1.9-.2-2.8c.2-.9 .2-1.8 .2-2.8V256c0-17.7 14.3-32 32-32c8.2 0 15.7 3.1 21.3 8.1c4.7 4.2 11.4 5.3 17.2 2.7s9.5-8.3 9.5-14.6V56zM248 0c-30.9 0-56 25.1-56 56V194c-5.1-1.3-10.5-2-16-2c-32.5 0-59.3 24.2-63.4 55.6c-9.1 4.2-17.8 9.4-26 15.5L64 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112v-8V304c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5V56c0-30.9-25.1-56-56-56z"]
};
var faPercent = {
  prefix: 'fal',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z"]
};
var faPercentage = faPercent;
var faTruckMoving = {
  prefix: 'fal',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M72 64c-22.1 0-40 17.9-40 40V304v32c13.4-10 30-16 48-16c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 224 104c0-22.1-17.9-40-40-40H72zM480 336c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9V304 256H480v80zm0-176v64H592l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H480zm160 90.7V256v48 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80V368 304 104C0 64.2 32.2 32 72 32H408c39.8 0 72 32.2 72 72v24h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faGlassWaterDroplet = {
  prefix: 'fal',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7H343.8c4.7 0 8.4 4 8 8.7L329.5 305.4l-23.9 12c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3l-24-12L32.1 40.7zm25.4 302l6.6 3.3c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l6.5-3.2-9.1 108C315.8 467.3 302 480 285.4 480H98.6c-16.6 0-30.5-12.7-31.9-29.3l-9.1-108zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410C37.6 486.5 65.3 512 98.6 512H285.4c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1zM192 216c-19.6 0-32-14.5-32-28c0 .1 0 .1 0-.1l0 0c.1-.6 .6-3.3 2.9-8.8c2.6-6.1 6.5-13.4 11.4-21.3c5.4-8.8 11.6-17.8 17.6-26c6 8.2 12.1 17.1 17.6 26c4.9 8 8.8 15.2 11.4 21.3c2.3 5.5 2.8 8.2 2.9 8.8l0 0c0 .1 0 .2 0 .1c0 13.5-12.4 28-32 28zm0 32c35.3 0 64-26.9 64-60c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 117.9 128 164 128 188c0 33.1 28.7 60 64 60z"]
};
var faConveyorBelt = {
  prefix: 'fal',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M464 32c8.8 0 16 7.2 16 16V240c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64V144c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3V32h64zM272 32h96v80L329.6 83.2c-5.7-4.3-13.5-4.3-19.2 0L272 112V32zM176 0c-26.5 0-48 21.5-48 48V240c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zM608 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H544c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faLocationCheck = {
  prefix: 'fal',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-84.7-52.7l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 233.4 276.7 116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faMapMarkerCheck = faLocationCheck;
var faCoinVertical = {
  prefix: 'fal',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M256 256c0-66.2-15.2-124.6-38.1-165.3C194.5 49 167.1 32 144 32s-50.5 17-73.9 58.7C47.2 131.4 32 189.8 32 256s15.2 124.6 38.1 165.3C93.5 463 120.9 480 144 480s50.5-17 73.9-58.7C240.8 380.6 256 322.2 256 256zm24.8 80h64.3c3.6-20 5.8-41.5 6.6-64h-64c-.8 22.2-3.1 43.7-6.9 64zm-7.3 32c-4.7 17.2-10.5 33.2-17.1 48h64.7c6.5-14.2 12.3-30.3 17-48H273.5zM213.8 480H256c12.8 0 29.9-8.5 46.8-32H239.2c-7.8 12.2-16.3 23-25.5 32zm74-240h64c-.7-22.5-3-44-6.6-64H280.8c3.8 20.3 6.1 41.8 6.9 64zm-74-208c9.2 9 17.7 19.8 25.5 32h63.6c-16.9-23.5-34-32-46.8-32H213.8zm59.8 112h64.6c-4.7-17.7-10.5-33.8-17-48H256.4c6.7 14.8 12.4 30.8 17.1 48zM144 512C64.5 512 0 397.4 0 256S64.5 0 144 0h32 80c70.7 0 128 114.6 128 256s-57.3 256-128 256H176 144zM88 256c0 47.1 7.4 89.1 18.8 118.7c5.7 14.8 12.2 25.8 18.5 32.7c6.3 6.9 11.3 8.6 14.7 8.6s8.3-1.7 14.7-8.6c6.3-6.9 12.8-17.8 18.5-32.7C184.6 345.1 192 303.1 192 256s-7.4-89.1-18.8-118.7c-5.7-14.8-12.2-25.8-18.5-32.7C148.3 97.7 143.4 96 140 96s-8.3 1.7-14.7 8.6c-6.3 6.9-12.8 17.8-18.5 32.7C95.4 166.9 88 208.9 88 256zM140 64c15.4 0 28.3 8.2 38.3 19c9.9 10.9 18.2 25.7 24.7 42.7c13.2 34.1 21 80.2 21 130.2s-7.8 96.1-21 130.2c-6.6 17-14.8 31.9-24.7 42.7c-9.9 10.9-22.9 19-38.3 19s-28.3-8.2-38.3-19c-9.9-10.9-18.2-25.7-24.7-42.7C63.8 352.1 56 306.1 56 256s7.8-96.1 21-130.2c6.6-17 14.8-31.9 24.7-42.7c9.9-10.9 22.9-19 38.3-19z"]
};
var faDisplay = {
  prefix: 'fal',
  iconName: 'display',
  icon: [576, 512, [], "e163", "M64 32C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM213.1 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64zm32.4 0l-10.7 64H341.1l-10.7-64H245.6z"]
};
var faPersonSign = {
  prefix: 'fal',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", "M421.5 1c8.3 3.1 12.5 12.3 9.5 20.5l-7.3 19.8 70.3 25.6c12.5 4.5 18.9 18.3 14.3 30.8L470.1 202.9c-4.5 12.5-18.3 18.9-30.8 14.3l-70.9-25.8L319 325.5c-3.1 8.3-12.3 12.5-20.5 9.5s-12.5-12.3-9.5-20.5l20.5-55.8-33.9-11.3c-18.9-6.3-35.8-17.5-48.9-32.5L208 193.4V331.6l41.2 68.6c4.5 7.5 6.8 16 6.8 24.7V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V424.9c0-2.9-.8-5.7-2.3-8.2L182.9 352H112V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V336 211.8L30.3 311.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5L56 188.2C69.6 161.1 97.3 144 127.6 144H171c23.1 0 45 10 60.2 27.3l19.7 22.5c9.4 10.7 21.4 18.7 34.9 23.2l34.8 11.6 17.7-48.2-64.4-23.4c-12.5-4.5-18.9-18.3-14.3-30.8L297.9 21.1c4.5-12.5 18.3-18.9 30.8-14.3l65 23.7L401 10.5C404 2.2 413.2-2.1 421.5 1zM112 178.6V320h64V176.3c-1.7-.2-3.3-.3-5-.3H127.6c-5.4 0-10.6 .9-15.6 2.6zM144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM325.2 39.5l-32.8 90.2 150.4 54.7 32.8-90.2L325.2 39.5z"]
};
var faFaceSmile = {
  prefix: 'fal',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSmile = faFaceSmile;
var faPhoneHangup = {
  prefix: 'fal',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M320 128C185.6 128 85.9 196.7 38.8 245c-7.2 7.4-8.9 19.3-3.5 30.5l38.3 78.6c3.3 6.7 10.7 10.3 18 8.6l88-20.5c7.2-1.7 12.4-8.1 12.4-15.6V240c0-7.1 4.7-13.4 11.6-15.4l32.9-9.4c54.6-15.6 112.4-15.6 167 0l32.9 9.4c6.9 2 11.6 8.2 11.6 15.4v86.6c0 7.4 5.1 13.9 12.4 15.6l88 20.5c7.3 1.7 14.7-1.9 18-8.6l38.3-78.6c5.5-11.2 3.7-23.2-3.5-30.5C554.1 196.7 454.4 128 320 128zM15.9 222.6C67.2 170.1 174.6 96 320 96s252.8 74.1 304.1 126.6c18.1 18.5 19.8 45.6 9.3 66.9l-38.3 78.6c-9.8 20.1-32.2 30.8-54 25.7l-88-20.5c-21.7-5.1-37.1-24.4-37.1-46.8V252.1L394.7 246c-48.8-14-100.6-14-149.4 0L224 252.1v74.5c0 22.3-15.4 41.7-37.1 46.8l-88 20.5c-21.8 5.1-44.2-5.6-54-25.7L6.5 289.5c-10.4-21.3-8.7-48.4 9.3-66.9z"]
};
var faSignatureSlash = {
  prefix: 'fal',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h83.4l-40.5-32zm85-96l40.5 32H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H463.8zm162 127.9c8-.9 14.2-7.7 14.2-15.9c0-8.8-7.2-16-16-16H585.4l40.4 31.9zM478.3 183.2c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3l-117 31.9L374 217.1l59.7-16.3L411 246.3l25.7 20.3 41.7-83.4zM320 131.4V128c0-53-43-96-96-96c-22.2 0-42.6 7.5-58.9 20.2l26.3 20.7c9.6-5.7 20.7-8.9 32.6-8.9c35.3 0 64 28.7 64 64v3.4c0 5.8-.1 11.7-.4 17.5L318.1 173c1.3-13.8 1.9-27.7 1.9-41.6zM155 243.7c-34.8 9.5-59 41.1-59 77.2v92.6c0 36.7 29.8 66.5 66.5 66.5c24 0 46.2-13 57.9-33.9L247.5 398c15.6-27.7 28.7-56.8 39-86.9L259.8 290c-10.2 32-23.7 63-40.2 92.3l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6c-19 0-34.5-15.4-34.5-34.5V320.9c0-21.6 14.5-40.6 35.4-46.3L220.5 259l-31.2-24.7L155 243.7zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H48c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faThumbtack = {
  prefix: 'fal',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M119.9 34.5L107.8 191.4c-.7 9.7-5.9 18.6-13.9 24c-27 18.3-47.3 46.2-55.6 79.6L32 320l144 0V224c0-8.8 7.2-16 16-16s16 7.2 16 16v96l144 0-6.2-25c-8.3-33.4-28.6-61.3-55.6-79.6c-8.1-5.5-13.2-14.3-13.9-24L264.1 34.5c-.1-.8-.1-1.6-.1-2.5H120c0 .8 0 1.6-.1 2.5zM176 352H32c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L85.5 64 88 32H64c-2.9 0-5.6-.8-7.9-2.1C51.2 27.1 48 21.9 48 16C48 7.2 55.2 0 64 0H88 296h24c8.8 0 16 7.2 16 16c0 5.9-3.2 11.1-8.1 13.9c-2.3 1.3-5 2.1-7.9 2.1H296l2.5 32 9.6 124.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3H208V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352z"]
};
var faThumbTack = faThumbtack;
var faWheatSlash = {
  prefix: 'fal',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM523.5 278.5l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-18-18-40-29.5-63.2-34.6l16.9-.8c45.1-2.3 81.2-38.4 83.5-83.5l2.7-54c.7-14.2-11-25.9-25.2-25.2L495.5 4C450.4 6.3 414.3 42.4 412 87.5l-.9 17.7c-4.9-23.5-16.5-46-34.8-64.2L353.8 18.4c-6.2-6.2-16.4-6.2-22.6 0L297.2 52.3C278.5 71 269.2 95.5 269.1 120l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.5 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7zM286.9 311.4l-25.3-20-29 29c1.3-20.6-2.4-41.5-11-60.6l-73.7-58.2-31.6 31.6c-37.5 37.5-37.5 98.3 0 135.8L150.2 403 68.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l81.5-81.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.4-98.6-37.2l31.7-31.7zM542.3 33.7L540 78.9c-1.4 28.7-24.4 51.7-53.1 53.1l-45.2 2.3L444 89.1c1.4-28.7 24.4-51.7 53.1-53.1l45.2-2.3zM172.8 380.3l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.2 37.2 37.5 97.4 .8 135l-.8 .8zm147.1 56.5c-25 25-65.5 25-90.5 0L195.5 403c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z"]
};
var faTrophy = {
  prefix: 'fal',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M176 32H400c9 0 15.4 7.3 15.1 15c-6.2 163.9-44.9 239.2-76.1 273.5c-15.5 17.1-29.9 24.8-39.3 28.3c-4.8 1.8-8.5 2.6-10.6 3c-.5 .1-.9 .1-1.2 .2c-.3 0-.7-.1-1.2-.2c-2.1-.3-5.8-1.1-10.6-3c-9.4-3.5-23.8-11.3-39.3-28.3C205.8 286.2 167.1 210.9 160.9 47c-.3-7.8 6.2-15 15.1-15zM400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H48C22 64-1.3 85.6 1.8 113.7c10.1 94 61.9 158.2 118.1 199.9c55.9 41.4 117.1 61.3 149.3 66.9l.1-.3c.9 .3 1.8 .6 2.7 .8V480H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H288 400c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V381.1c.9-.3 1.8-.5 2.7-.8l.1 .3c32.2-5.7 93.4-25.5 149.3-66.9c56.2-41.7 108-105.9 118.1-199.9C577.3 85.6 554 64 528 64H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm44.2 96H528c9.3 0 15.2 7.3 14.4 14.3c-8.9 82.9-54.3 139.8-105.4 177.6c-19.6 14.6-40 26.2-59.2 35.3C407 281.9 434.5 212.5 444.2 96zm-246 227.2c-19.2-9.1-39.6-20.7-59.2-35.3C87.9 250.1 42.5 193.2 33.6 110.3C32.8 103.3 38.7 96 48 96h83.8c9.8 116.5 37.2 185.9 66.4 227.2z"]
};
var faCloudsSun = {
  prefix: 'fal',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l10.4 1.7c9.9-11.5 22.5-20.6 36.8-26.3l-30.7-5.1L303.8 13.4zM291.6 217.2c-2.1-7.9-3.3-16.3-3.3-24.9c0-5.7 .5-11.3 1.5-16.7C276.9 143 245.2 120 208 120c-48.6 0-88 39.4-88 88s39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6c7.3-28.9 24.5-53.9 47.7-71.1zM264 208a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm309.9 47.6c8.2 8 15.2 17.2 20.7 27.4c26.6-10.6 45.4-36.5 45.4-66.9c0-39.8-32.2-72-72-72c-3.2 0-6.4 .2-9.5 .6C551.4 107.9 519 80.1 480 80.1c-34.2 0-63.3 21.4-74.8 51.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c9.9-3.9 20.4-6.7 31.4-8l0-.5 0-.4c0-17.7 14.3-32 32-32c3.8 0 7.3 .6 10.6 1.8c16.4 5.7 34.3-2.6 40.5-18.8c6.9-18.1 24.4-30.9 44.9-30.9c23.3 0 42.8 16.7 47.1 38.7c3.2 16.6 18.8 27.8 35.6 25.6c1.7-.2 3.5-.3 5.3-.3c22.1 0 40 17.9 40 40c0 20.1-14.8 36.7-34.1 39.5zM304 320c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H290.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.9 224 368 224z"]
};
var faPersonPraying = {
  prefix: 'fal',
  iconName: 'person-praying',
  icon: [448, 512, [128720, "pray"], "f683", "M256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM200.5 176h.9c12.4 0 23.7 7.2 29 18.5l3.1 6.7c-.1 .2-.2 .5-.3 .7L157.1 384.6l-26.7-16.8c-13.1-8.2-18.4-24.6-12.7-39l53.1-132.7c4.9-12.1 16.6-20.1 29.7-20.1zm112 306.5l-128-80.6 67.3-161.5 12.4 26.5c9.2 19.7 34.9 24.7 50.8 9.9l95.9-89.1c6.5-6 6.9-16.1 .8-22.6s-16.1-6.9-22.6-.8l-95.9 89.1-33.8-72.4c-10.5-22.5-33.1-36.9-58-36.9h-.9c-26.2 0-49.7 15.9-59.4 40.2L88 316.9c-11.5 28.7-.8 61.5 25.3 77.9L248.6 480H48c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c7.1 0 13.4-4.7 15.4-11.6s-.8-14.2-6.8-18z"]
};
var faPray = faPersonPraying;
var faHammer = {
  prefix: 'fal',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", "M398.5 206.8c8.6-.1 16.8 3.3 22.9 9.4L472 266.7 514.7 224l-48.3-48.3c-6.5-6.5-9.9-15.4-9.3-24.5c1-17-5.2-34.2-18.5-46.7L394 62.4C373.2 42.9 345.8 32 317.2 32H299.2c-15.7 0-31.2 3.3-45.5 9.7l-17.6 7.8 51.2 27.9C297.6 83 304 93.8 304 105.5v12.1c0 12.6 5 24.7 13.9 33.7l38.1 38.1c11.7 11.7 27.1 17.5 42.4 17.4zm138.8-5.4l3.3 3.3 8-8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16-3.3-3.3-50.6-50.6c-23.6 .2-47.3-8.7-65.4-26.7l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c20.5 19.3 30.1 45.9 28.5 72l48.3 48.3zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l9.7 9.7L47.9 401.7c-10.1 8.4-15.9 20.9-15.9 34C32 460.2 51.8 480 76.3 480c13.1 0 25.6-5.8 34-15.9L305.7 229.6l5.1 5.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"]
};
var faFaceVomit = {
  prefix: 'fal',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M288 32C164.3 32 64 132.3 64 256c0 57.4 21.6 109.7 57 149.3c5.9 6.6 5.3 16.7-1.3 22.6s-16.7 5.3-22.6-1.3C56.7 381.4 32 321.6 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256c0 65.6-24.7 125.4-65.2 170.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c35.5-39.6 57-91.9 57-149.3C512 132.3 411.7 32 288 32zM161.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5L203.9 208l-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L372.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 488a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm520-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm92.5-47.6c8.6-1.9 17.2 3.5 19.1 12.1l6.1 27.4c5.2 23.5 20.8 43.4 42.3 54.2l39.1 19.6c6.6 3.3 10.1 10.8 8.4 18s-8.2 12.3-15.6 12.3H112c-7.4 0-13.9-5.1-15.6-12.3s1.8-14.7 8.4-18L144 462.1c21.5-10.8 37.1-30.7 42.3-54.2l6.1-27.4c1.9-8.6 10.5-14.1 19.1-12.1s14.1 10.5 12.1 19.1l-6.1 27.4c-5.8 26.2-20.8 49.2-41.9 65.1H400.4c-21.1-15.9-36.1-38.9-41.9-65.1l-6.1-27.4c-1.9-8.6 3.5-17.2 12.1-19.1zm-189.1 4c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c5.6-19.8 24.1-38.7 48-52.1C217.3 297.6 250 288 288 288s70.7 9.6 95.4 23.5c24 13.5 42.4 32.3 48 52.1c2.4 8.5-2.5 17.3-11 19.8s-17.3-2.5-19.8-11c-2.4-8.3-12.6-21.5-32.9-33C348 328.3 320.7 320 288 320s-60 8.3-79.7 19.4c-20.4 11.5-30.6 24.7-32.9 33z"]
};
var faSpeakers = {
  prefix: 'fal',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", "M256 257.6V336v78.4c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6zm0 78.4A80 80 0 1 0 96 336a80 80 0 1 0 160 0zm5.5 144c4.2 11.9 10.7 22.8 19 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H280.4c-8.3 9.2-14.8 20.1-19 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H261.5zM176 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM152 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM288 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H352c-35.3 0-64-28.7-64-64V64zm176 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM440 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTtyAnswer = {
  prefix: 'fal',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0zM312 64h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H312c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0 96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H312c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V80zM504 64h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H504c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16H600c-8.8 0-16-7.2-16-16V80zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H600c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm-200 0H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTeletypeAnswer = faTtyAnswer;
var faMugTeaSaucer = {
  prefix: 'fal',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", "M240 64H416h16 16V224v32 32c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V64h80v40.5l-36.5 30.4C164.2 141 160 150 160 159.5V224c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V159.5c0-9.5-4.2-18.5-11.5-24.6L240 104.5V64zM224 32H128c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96V256h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H448 432 416 224zM480 224V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80H480zM0 464c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM192 224V159.5l32-26.7 32 26.7V224H192z"]
};
var faDiagramLeanCanvas = {
  prefix: 'fal',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", "M512 64V320h96V96c0-17.7-14.3-32-32-32H512zm-32 0H384V192h96V64zM352 64H288V320h64V64zm-96 0H160V192h96V64zM128 64H64C46.3 64 32 78.3 32 96V320h96V64zM32 352v64c0 17.7 14.3 32 32 32H304V352H32zm304 96H576c17.7 0 32-14.3 32-32V352H336v96zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM256 320V224H160v96h96zm224-96H384v96h96V224z"]
};
var faAlt = {
  prefix: 'fal',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M462 107.7c6.1-7.4 15.2-11.7 24.8-11.7H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H486.7c-19.2 0-37.4 8.6-49.5 23.5L178 404.3c-6.1 7.4-15.2 11.7-24.8 11.7H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H153.3c19.2 0 37.4-8.6 49.5-23.5L462 107.7zM432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faDial = {
  prefix: 'fal',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm11.3 243.3l89.8-89.8c39.1 50.2 35.5 122.9-10.6 169c-50 50-131 50-181 0s-50-131 0-181c46.2-46.2 118.8-49.7 169-10.6l-89.8 89.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM401.1 174.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9zM568 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 96A24 24 0 1 0 72 96a24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDialMedHigh = faDial;
var faHandPeace = {
  prefix: 'fal',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", "M253.4 .3c-30.8-3-58.2 19.6-61.1 50.3L177.9 199 123.8 66.8c-11.7-28.6-44.4-42.3-73-30.6s-42.3 44.4-30.6 73L84.5 266.5C71.8 280.7 64 299.4 64 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V312.1l0-.1V248l0-.1V240c0-3.2-.9-6.1-2.5-8.6C438.4 208.6 417.2 192 392 192c-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-6.9 0-13.6 1.3-19.7 3.6L303.7 61.4c3-30.8-19.6-58.2-50.3-61.1zM111.1 247L49.8 97.1c-5-12.3 .9-26.3 13.1-31.3s26.3 .9 31.3 13.1L160.1 240H144c-11.7 0-22.8 2.5-32.9 7zM232 240H206.1l18-186.3c1.3-13.2 13-22.9 26.2-21.6s22.9 13 21.6 26.2l-18 186.1c-6.7-2.9-14.1-4.4-21.9-4.4zm80-32c13.3 0 24 10.7 24 24l0 16 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24v0V232c0-13.3 10.7-24 24-24zm32.5 133.6C354.4 357.5 372 368 392 368c8.4 0 16.4-1.9 23.5-5.2C410.1 428.5 355 480 288 480H224c-70.7 0-128-57.3-128-128V320c0-26.5 21.5-48 48-48h88c13.2 0 24 10.7 24 24l0 0c0 13.3-10.7 24-24 24H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8c10.2 10.4 24.3 16.8 40 16.8c12.1 0 23.3-3.8 32.5-10.4zM416 312c0 13.2-10.8 24-24 24c-13.3 0-24-10.7-24-24l0-16 0-48c0-13.3 10.7-24 24-24c13.2 0 24 10.7 24 24l0 0v64l0 0z"]
};
var faCircleTrash = {
  prefix: 'fal',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 144h32.1 9.3l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7L310.6 144h9.3H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-2.1L338 354.1c-1.1 16.8-15.1 29.9-31.9 29.9H205.9c-16.8 0-30.8-13.1-31.9-29.9L162.1 176H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm157.8 32H194.2l11.7 176H306.1l11.7-176z"]
};
var faTrashCircle = faCircleTrash;
var faRotate = {
  prefix: 'fal',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M426.1 301.2C406.2 376.5 337.6 432 256 432c-51 0-96.9-21.7-129-56.3l41-41c5.1-5.1 8-12.1 8-19.3c0-15.1-12.2-27.3-27.3-27.3H48c-8.8 0-16 7.2-16 16V404.7C32 419.8 44.2 432 59.3 432c7.2 0 14.2-2.9 19.3-8l25.7-25.7C142.3 438.7 196.2 464 256 464c97.4 0 179.2-67 201.8-157.4c2.4-9.7-5.2-18.6-15.2-18.6c-7.8 0-14.5 5.6-16.5 13.2zM385 136.3l-41 41c-5.1 5.1-8 12.1-8 19.3c0 15.1 12.2 27.3 27.3 27.3H464c8.8 0 16-7.2 16-16V107.3C480 92.2 467.8 80 452.7 80c-7.2 0-14.2 2.9-19.3 8l-25.7 25.7C369.7 73.3 315.8 48 256 48C158.6 48 76.8 115 54.2 205.4c-2.4 9.7 5.2 18.6 15.2 18.6c7.8 0 14.5-5.6 16.5-13.2C105.8 135.5 174.4 80 256 80c51 0 96.9 21.7 129.1 56.3zM448 192H374.6L448 118.6V192zM64 320h73.4L64 393.4V320z"]
};
var faSyncAlt = faRotate;
var faCircleQuarters = {
  prefix: 'fal',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M402.7 425.3L256 278.6 109.3 425.3C148.6 459.4 199.9 480 256 480s107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256s-20.6-107.4-54.7-146.7L278.6 256 425.3 402.7zm-22.6-316C363.4 52.6 312.1 32 256 32s-107.4 20.6-146.7 54.7L256 233.4 402.7 86.7zm-316 22.6C52.6 148.6 32 199.9 32 256s20.6 107.4 54.7 146.7L233.4 256 86.7 109.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSpinner = {
  prefix: 'fal',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"]
};
var faTowerControl = {
  prefix: 'fal',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", "M160 16c0-8.8 7.2-16 16-16h48 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H240V64h48c17.7 0 32 14.3 32 32v32h80.9c26.2 0 45.3 24.8 38.7 50.1L402.6 320.2c7.6 1.2 13.4 7.8 13.4 15.8c0 8.8-7.2 16-16 16H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352l-192 0V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H48c-8.8 0-16-7.2-16-16c0-8 5.8-14.6 13.4-15.8L8.4 178.1C1.8 152.8 20.9 128 47.1 128H128V96c0-17.7 14.3-32 32-32h48V32H176c-8.8 0-16-7.2-16-16zM128 160.2c0-.1 0-.1 0-.2H47.1c-5.2 0-9.1 5-7.7 10L78.5 320H128V160.2zM160 320H288V160.2c0-.1 0-.1 0-.2H160V320zM320 160V320l49.6 0 39.1-150c1.3-5.1-2.5-10-7.7-10H320zm-32-32V96H160v32H288z"]
};
var faArrowUpTriangleSquare = {
  prefix: 'fal',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 432V336c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zM416 67.5L490.7 192H341.3L416 67.5zM307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32s-19.1 5.2-24.2 13.7L307.6 186zM320 432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v96z"]
};
var faSortShapesUp = faArrowUpTriangleSquare;
var faWhale = {
  prefix: 'fal',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M164.9 .8c5.7 1.8 9.9 6.7 10.9 12.6l14.1 84.7 84.7 14.1c5.9 1 10.8 5.2 12.6 10.9s.3 12-3.9 16.2L242.6 180c-18.3 18.3-44.2 26.6-69.7 22.3L111 192 70.8 250.4c-9.2 13.3-10.4 30.6-3.1 45c7.5 15.1 22.9 24.6 39.7 24.6h3.2c11.3 0 22.2-3.8 31-10.9L270.9 205.7C333.8 155.4 411.8 128 492.3 128C573.9 128 640 194.1 640 275.7V384c0 53-43 96-96 96H162.4C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l46.5-46.5 3.4-3.4-7.9-47.4C81.4 89.6 89.7 63.7 108 45.4L148.7 4.7c4.2-4.2 10.5-5.8 16.2-3.9zM149.3 49.3L130.6 68c-11 11-16 26.5-13.4 41.8l8.7 52.2 52.2 8.7c15.3 2.5 30.9-2.4 41.8-13.4l18.7-18.7-65.3-10.9c-6.7-1.1-12-6.4-13.2-13.2L149.3 49.3zM368 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-334.1 .5c-1.3 6.9-1.9 14-1.9 21.2C32 389.6 90.4 448 162.4 448H544c35.3 0 64-28.7 64-64V275.7C608 211.8 556.2 160 492.3 160c-73.2 0-144.2 24.9-201.4 70.7L161.6 334.1c-14.5 11.6-32.4 17.9-50.9 17.9h-3.2c-28.9 0-55.4-16.4-68.4-42.2c-2.2-4.3-3.9-8.8-5.2-13.3z"]
};
var faRobot = {
  prefix: 'fal',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M320 0c8.8 0 16 7.2 16 16V96H448c53 0 96 43 96 96V416c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96H304V16c0-8.8 7.2-16 16-16zM192 128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H320 192zm16 256h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16zM224 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM48 224H64v32H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16H64v32H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zM592 384c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H576V224h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V384h16z"]
};
var faPeace = {
  prefix: 'fal',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M240 479.4V289.8L93.2 409.9c37.4 39.6 89.1 65.5 146.8 69.6zM72.9 385.1L240 248.4V32.6C123.8 40.8 32 137.7 32 256c0 48.1 15.1 92.6 40.9 129.1zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm16-32.6c57.7-4.1 109.4-30 146.8-69.6L272 289.8V479.4zm167.1-94.3c25.8-36.5 40.9-81 40.9-129.1c0-118.3-91.8-215.2-208-223.4V248.4L439.1 385.1z"]
};
var faPartyHorn = {
  prefix: 'fal',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M40 32a24 24 0 1 1 48 0A24 24 0 1 1 40 32zM456 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM172.7 147.3c-6.2-6.2-6.2-16.4 0-22.6l8.3-8.3c18-18 29.3-41.6 32.1-66.8l3-27.4c1-8.8 8.9-15.1 17.7-14.1s15.1 8.9 14.1 17.7l-3 27.4c-3.6 32.5-18.2 62.8-41.3 85.9l-8.3 8.3c-6.2 6.2-16.4 6.2-22.6 0zm192 169.4l8.3-8.3c23.1-23.1 53.4-37.7 85.9-41.3l27.4-3c8.8-1 16.7 5.4 17.7 14.1s-5.4 16.7-14.1 17.7l-27.4 3c-25.3 2.8-48.8 14.1-66.8 32.1l-8.2 8.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm135.5-303c5.7 6.7 4.9 16.8-1.9 22.5l-10 8.5C475 55.9 458.1 61.9 440.7 61.4c-21-.6-38.6 15.6-39.8 36.5l-1.8 30c-2.2 38.2-34.4 67.7-72.6 66.6c-9.5-.3-18.8 3-26.1 9.2l-10 8.5c-6.7 5.7-16.8 4.9-22.5-1.9s-4.9-16.8 1.9-22.5l10-8.5c13.3-11.2 30.3-17.2 47.7-16.7c21 .6 38.6-15.6 39.8-36.5l1.8-30c2.2-38.2 34.4-67.7 72.6-66.6c9.5 .3 18.8-3 26.1-9.2l10-8.5c6.7-5.7 16.8-4.9 22.6 1.9zM32.1 479.6c0 0 .1 .1 .1 .1s.1 .1 .1 .1l76.2-28.6L60.7 403.4 32.1 479.6zm169.6-63.2L95.6 310.3 73 370.7c.8 .6 1.6 1.2 2.3 1.9l64 64c.7 .7 1.4 1.5 2 2.4l60.5-22.7zM234.7 404l53.3-20c0-.1 0-.1 .1-.2s0-.1 0-.2L128.3 224c-.1 0-.1 0-.2 0l-.1 0-.1 0-20 53.3L234.7 404zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4L310.9 361.3c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18 519.4-7.4 494 2 468.8L98.1 212.6z"]
};
var faGears = {
  prefix: 'fal',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M146.2 40.7l-6.9 25.1c-1.4 5.2-5.4 9.4-10.6 11c-14.6 4.6-27.9 12.4-39 22.5c-4 3.7-9.6 5.1-14.9 3.7L49.7 96.4c-2.2 3.1-4.3 6.3-6.3 9.6l-2.4 4.2c-1.8 3.3-3.5 6.6-5 10l18.3 18.5c3.8 3.9 5.4 9.4 4.2 14.7C56.8 160.7 56 168.2 56 176s.8 15.3 2.4 22.5c1.2 5.3-.4 10.8-4.2 14.7L35.9 231.8c1.5 3.4 3.2 6.7 5 10l2.5 4.3c2 3.3 4.1 6.5 6.3 9.6L74.9 249c5.3-1.4 10.9 0 14.9 3.7c11.1 10.2 24.3 17.9 39 22.5c5.2 1.6 9.2 5.8 10.6 11l6.9 25.1c4.5 .5 9.1 .7 13.8 .7s9.2-.2 13.8-.7l6.9-25.1c1.4-5.2 5.4-9.4 10.6-11c14.6-4.6 27.9-12.4 39-22.5c4-3.7 9.6-5.1 14.9-3.7l25.2 6.6c2.2-3 4.2-6.1 6.1-9.3l2.8-4.8c1.7-3.2 3.4-6.4 4.8-9.7l-18.3-18.5c-3.8-3.9-5.4-9.4-4.2-14.7c1.6-7.2 2.4-14.8 2.4-22.6s-.8-15.3-2.4-22.6c-1.2-5.3 .4-10.8 4.2-14.7l18.3-18.5c-1.5-3.3-3.1-6.5-4.8-9.7l-2.8-4.8c-1.9-3.2-4-6.3-6.1-9.3L245.1 103c-5.3 1.4-10.9 0-14.9-3.7c-11.1-10.2-24.3-17.9-39-22.5c-5.2-1.6-9.2-5.8-10.6-11l-6.9-25.1c-4.5-.5-9.1-.7-13.8-.7s-9.2 .2-13.8 .7zM130.8 10.5C140.3 8.9 150.1 8 160 8s19.7 .9 29.1 2.5c6.1 1.1 11 5.6 12.7 11.5l7.5 27.2c13.1 5.1 25.1 12.1 35.9 20.7l27.3-7.1c6-1.6 12.3 .5 16.3 5.2c5.6 6.7 10.7 13.8 15.2 21.3l.2 .3 0 0 2.9 5.1 .2 .3 0 0c4.1 7.5 7.7 15.4 10.7 23.6c2.1 5.8 .7 12.3-3.6 16.7l-19.8 20.1c1 6.8 1.6 13.7 1.6 20.7s-.5 13.9-1.6 20.7l19.8 20.1c4.3 4.4 5.8 10.9 3.6 16.7c-3 8.2-6.6 16-10.7 23.6l-.2 .3 0 0-3 5.1-.2 .3 0 0c-4.5 7.5-9.6 14.6-15.2 21.3c-4 4.7-10.3 6.8-16.3 5.2l-27.3-7.1c-10.7 8.6-22.8 15.6-35.8 20.7L201.8 330c-1.6 6-6.6 10.5-12.7 11.5c-9.5 1.7-19.2 2.5-29.1 2.5s-19.7-.9-29.2-2.5c-6.1-1.1-11-5.6-12.7-11.5l-7.5-27.2c-13.1-5.1-25.1-12.1-35.8-20.7l-27.3 7.1c-6 1.6-12.3-.5-16.3-5.2c-5.7-6.8-10.9-14-15.4-21.6l-.1-.2 0 0-2.6-4.5-.1-.2 0 0c-4.2-7.6-7.9-15.6-10.9-23.9c-2.1-5.8-.7-12.3 3.6-16.7l19.8-20.1C24.5 189.9 24 183 24 176s.5-13.9 1.6-20.7L5.7 135.2c-4.3-4.4-5.8-10.9-3.6-16.7c3-8.3 6.7-16.3 10.9-23.9l.1-.2 0 0 2.6-4.5 .1-.2 0 0C20.4 82 25.6 74.8 31.3 68c4-4.7 10.3-6.8 16.3-5.2l27.3 7.1c10.7-8.6 22.8-15.6 35.8-20.7L118.2 22c1.6-6 6.6-10.5 12.7-11.5zM104 176a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328.7 365.8l25.1 6.9c5.2 1.4 9.4 5.4 11 10.6c4.6 14.6 12.4 27.9 22.5 39c3.7 4 5.1 9.6 3.7 14.9l-6.6 25.2c3.1 2.2 6.3 4.3 9.6 6.3l4.2 2.4c3.3 1.8 6.6 3.5 10 5l18.5-18.3c3.9-3.8 9.4-5.4 14.7-4.2c7.2 1.6 14.8 2.4 22.5 2.4s15.3-.8 22.5-2.4c5.3-1.2 10.8 .4 14.7 4.2l18.5 18.3c3.4-1.5 6.7-3.2 10-5l4.3-2.5c3.3-2 6.5-4.1 9.6-6.3L537 437.1c-1.4-5.3 0-10.9 3.7-14.9c10.2-11.1 17.9-24.3 22.5-39c1.6-5.2 5.8-9.2 11-10.6l25.1-6.9c.5-4.5 .7-9.1 .7-13.8s-.2-9.2-.7-13.8l-25.1-6.9c-5.2-1.4-9.4-5.4-11-10.6c-4.6-14.7-12.4-27.9-22.5-39c-3.7-4-5.1-9.6-3.7-14.9l6.6-25.2c-3-2.2-6.1-4.2-9.3-6.1l-4.8-2.8c-3.2-1.7-6.4-3.4-9.7-4.8l-18.5 18.3c-3.9 3.8-9.4 5.4-14.7 4.2c-7.2-1.6-14.8-2.4-22.6-2.4s-15.3 .8-22.6 2.4c-5.3 1.2-10.8-.4-14.7-4.2l-18.5-18.3c-3.3 1.5-6.5 3.1-9.7 4.8l-4.8 2.8c-3.2 1.9-6.3 4-9.3 6.1l6.6 25.2c1.4 5.3 0 10.9-3.7 14.9c-10.2 11.1-17.9 24.3-22.5 39c-1.6 5.2-5.8 9.2-11 10.6l-25.1 6.9c-.5 4.5-.7 9.1-.7 13.8s.2 9.2 .7 13.8zm-30.2 15.4c-1.7-9.5-2.5-19.2-2.5-29.2s.9-19.7 2.5-29.1c1.1-6.1 5.6-11 11.5-12.7l27.2-7.5c5.1-13.1 12.1-25.1 20.7-35.9l-7.1-27.3c-1.6-6 .5-12.3 5.2-16.3c6.7-5.6 13.8-10.7 21.3-15.2l.3-.2 0 0 5.1-2.9 .3-.2 0 0c7.5-4.1 15.4-7.7 23.6-10.7c5.8-2.1 12.3-.7 16.7 3.6l20.1 19.8c6.8-1 13.7-1.6 20.7-1.6s13.9 .5 20.7 1.6l20.1-19.8c4.4-4.3 10.9-5.8 16.7-3.6c8.2 3 16 6.6 23.6 10.7l.3 .2 0 0 5.1 3 .3 .2 0 0c7.5 4.5 14.6 9.6 21.3 15.2c4.7 4 6.7 10.3 5.2 16.3l-7.1 27.3c8.6 10.7 15.6 22.8 20.7 35.8l27.2 7.5c6 1.6 10.5 6.6 11.5 12.7c1.7 9.5 2.5 19.2 2.5 29.1s-.9 19.7-2.5 29.2c-1.1 6.1-5.6 11-11.5 12.7l-27.2 7.5c-5.1 13.1-12.1 25.1-20.7 35.8l7.1 27.3c1.6 6-.5 12.3-5.2 16.3c-6.8 5.7-14 10.9-21.6 15.4l-.2 .1 0 0-4.5 2.6-.2 .1 0 0c-7.6 4.2-15.6 7.9-23.9 10.9c-5.8 2.1-12.3 .7-16.7-3.6l-20.1-19.8c-6.8 1-13.7 1.6-20.7 1.6s-13.9-.5-20.7-1.6l-20.1 19.8c-4.4 4.3-10.9 5.8-16.7 3.6c-8.3-3-16.3-6.7-23.9-10.9l-.2-.1 0 0-4.5-2.6-.2-.1 0 0c-7.6-4.6-14.9-9.8-21.6-15.4c-4.7-4-6.8-10.3-5.2-16.3l7.1-27.3c-8.6-10.7-15.6-22.8-20.7-35.8L310 393.8c-6-1.6-10.5-6.6-11.5-12.7zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCogs = faGears;
var faSunBright = {
  prefix: 'fal',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M256 0c8.8 0 16 7.2 16 16V96c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM0 256c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm400 0c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416c-8.8 0-16-7.2-16-16zM256 400c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V416c0-8.8 7.2-16 16-16zM75 75c6.2-6.2 16.4-6.2 22.6 0l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zm0 362c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L97.6 437c-6.2 6.2-16.4 6.2-22.6 0zM357.8 154.2c-6.2-6.2-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0zm0 203.6c6.2-6.2 16.4-6.2 22.6 0L437 414.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z"]
};
var faSunAlt = faSunBright;
var faWarehouse = {
  prefix: 'fal',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V496c0 8.8-7.2 16-16 16c-.1 0-.2 0-.2 0H112.2c-.1 0-.2 0-.2 0c-8.8 0-16-7.2-16-16V224zm32 256H512V416H128v64zM512 320H128v64H512V320zM128 288H512V224H128v64z"]
};
var faConveyorBeltArm = {
  prefix: 'fal',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M128 16c0 8.8 7.2 16 16 16h77.1l-5.5 32.7C193.1 68.7 176 88.3 176 112c0 26.5 21.5 48 48 48c18.6 0 34.8-10.6 42.8-26.2L448 158v50c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8-5.9-14.8-13.9-15.9L271 102.1c-2.9-13.8-11.8-25.5-23.8-32.1l6.3-38H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm72 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM448 288h32v32H448V288zm-32-8v40H352V280c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24v40H192V280c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24l0 40c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H512V280c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zM96 352h24 48H280h48H440h48 56c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64zm64-64v32H128V288h32zm128 32V288h32v32H288zM128 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faLockKeyholeOpen = {
  prefix: 'fal',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M448 32c-53 0-96 43-96 96v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H320V128C320 57.3 377.3 0 448 0s128 57.3 128 128v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-53-43-96-96-96zM80 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H336 80zM264 368H184c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faLockOpenAlt = faLockKeyholeOpen;
var faSquareFragile = {
  prefix: 'fal',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32v80c0 44.2 35.8 80 80 80s80-35.8 80-80V128H230.6l20.7 20.7c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-30.2 20.1 31.5 26.3c6.8 5.7 7.7 15.7 2 22.5s-15.7 7.7-22.5 2l-48-40c-3.9-3.2-6-8.1-5.7-13.1s2.9-9.7 7.1-12.5l31.8-21.2L185.4 128H144zm-1.1-32H305.1c17.1 0 30.9 13.8 30.9 30.9V208c0 56.4-41.7 103.1-96 110.9V384h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V318.9c-54.3-7.8-96-54.4-96-110.9V126.9c0-17.1 13.8-30.9 30.9-30.9z"]
};
var faBoxFragile = faSquareFragile;
var faSquareWineGlassCrack = faSquareFragile;
var faArrowUpRightDots = {
  prefix: 'fal',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H265.4L4.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H144zM528 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 464a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM528 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faSquareN = {
  prefix: 'fal',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm157 38.7L288 318.1V144c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 7-4.5 13.1-11.1 15.2s-13.9-.3-17.9-5.9L160 193.9V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7 4.5-13.1 11.1-15.2s13.9 .3 17.9 5.9z"]
};
var faSplotch = {
  prefix: 'fal',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M189.1 416.1L86.4 425.5C65.8 427.3 48 411.1 48 390.4c0-7.6 2.5-15 7-21.1l18.8-25c14.5-19.4 22.1-43.1 21.6-67.3c-.5-20.2-6.6-39.8-17.6-56.6L37.3 158.5c-3.4-5.2-5.3-11.4-5.3-17.6c0-20.1 18.2-35.2 37.9-31.6l42.8 7.8c47 8.5 94.9-8.8 125.4-45.5l22.3-26.8c6.7-8 16.6-12.7 27.1-12.7c15.2 0 28.7 9.7 33.5 24.1l15 45.1c14.2 42.6 46.9 76.5 88.9 92.3l32.3 12.1c13.7 5.1 22.7 18.2 22.7 32.8c0 11-5.2 21.4-14 28L404 313c-33.4 25-51 65.8-46.4 107.3l2.5 22.7c2.2 19.8-13.3 37.1-33.2 37.1c-7.6 0-14.9-2.6-20.9-7.3L269 443c-21.8-17.5-49-27-77-27c-1 0-1.9 0-2.9 .1zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3c39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6c0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46c-20 0-38.9 8.9-51.7 24.2L213.5 51C190.3 78.8 154 92 118.4 85.5L75.6 77.7C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z"]
};
var faFaceGrinHearts = {
  prefix: 'fal',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM195.1 144.6c-9.3-2.5-18.8 3-21.3 12.3l-4.3 16.1c-2.3 8.5-11.1 13.6-19.6 11.3l-16.1-4.3c-9.3-2.5-18.8 3-21.3 12.3s3 18.8 12.3 21.3L190 230.9l17.4-65c2.5-9.3-3-18.8-12.3-21.3zm-52.2 4c7.1-26.3 34.1-42 60.4-34.9s42 34.1 34.9 60.4l-17.4 65c-4.6 17.1-22.1 27.2-39.2 22.6l-65.1-17.4c-26.3-7.1-42-34.1-34.9-60.4s34.1-42 60.4-34.9l.7 .2 .2-.6zm226.1 0l.2 .6 .7-.2c26.3-7.1 53.4 8.6 60.4 34.9s-8.6 53.4-34.9 60.4l-65.1 17.4c-17.1 4.6-34.6-5.6-39.2-22.6l-17.4-65c-7.1-26.3 8.6-53.4 34.9-60.4s53.4 8.6 60.4 34.9zm-52.2-4c-9.3 2.5-14.8 12-12.3 21.3l17.4 65 65.1-17.4c9.3-2.5 14.8-12 12.3-21.3s-12-14.8-21.3-12.3L362 184.2c-8.5 2.3-17.3-2.8-19.6-11.3l-4.3-16.1c-2.5-9.3-12-14.8-21.3-12.3z"]
};
var faGrinHearts = faFaceGrinHearts;
var faMeter = {
  prefix: 'fal',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMandolin = {
  prefix: 'fal',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M459.3 4.7C454.3-.4 446.5-1.5 440.2 2l-72 40c-4 2.2-6.8 6-7.8 10.4l-23 99.5-38.6 38.6C227.4 187.1 0 187.6 0 336c0 97.2 78.8 176 176 176c148.4 0 148.9-227.4 145.4-298.8l38.6-38.6 99.5-23c4.4-1 8.2-3.9 10.4-7.8l40-72c3.5-6.2 2.4-14-2.7-19.1l-48-48zm-191.7 217l-43.1 43.1c-9.5-5.6-20.6-8.9-32.5-8.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l43.1-43.1c.2 28.6-1.4 65.6-7.8 102.1c-6.6 37.9-18 72.4-35.6 96.7C230.3 466.1 208.4 480 176 480C96.5 480 32 415.5 32 336c0-32.4 13.9-54.3 36.8-70.8c24.3-17.6 58.8-29 96.7-35.6c36.5-6.4 73.5-7.9 102.1-7.8zM445.5 122l-72.1 16.6L390 66.5l55.2-30.7 30.9 30.9L445.5 122zM192 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDiceFour = {
  prefix: 'fal',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSimCard = {
  prefix: 'fal',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V154.5c0-8.5-3.4-16.6-9.4-22.6L252.1 41.4c-6-6-14.1-9.4-22.6-9.4H64C46.3 32 32 46.3 32 64zM0 448V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM64 280V240c0-26.5 21.5-48 48-48h48 16 16 40 40c26.5 0 48 21.5 48 48v40 80 40c0 26.5-21.5 48-48 48H224 208 192 112c-26.5 0-48-21.5-48-48V360 280zM96 400c0 8.8 7.2 16 16 16h80V376H152 96v24zm176 16c8.8 0 16-7.2 16-16V376H224v40h48zm-64-72h80V296H232 176 96v48h56 56zm80-104c0-8.8-7.2-16-16-16H232 192v40h40 56V240zM160 224H112c-8.8 0-16 7.2-16 16v24h64V224z"]
};
var faTransgender = {
  prefix: 'fal',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", "M144 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H32C23.2 0 16 7.2 16 16V128c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L89.4 96l-4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l4.7-4.7 13.2 13.2C106.8 157.9 96 189.7 96 224c0 83 63.1 151.2 144 159.2V416H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64s-81.1 16.6-109.8 43.6L134.6 96l4.7-4.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 73.4 70.6 32H144zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faTransgenderAlt = faTransgender;
var faMercury = {
  prefix: 'fal',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M89.2 4.8C83-1.5 72.8-1.6 66.5 4.6s-6.4 16.3-.2 22.6C81.2 42.4 98.9 55 118.6 64C58 91.8 16 153 16 224c0 91.8 70.3 167.2 160 175.3V432H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V399.3c89.7-8.1 160-83.5 160-175.3c0-71-42-132.2-102.6-160c19.6-9 37.3-21.6 52.3-36.8c6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6 .2C268.7 31.5 232.3 48 192 48S115.3 31.5 89.2 4.8zM192 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z"]
};
var faUpFromBracket = {
  prefix: 'fal',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M222.2 32.8c.5-.5 1.1-.8 1.8-.8s1.4 .3 1.8 .8L350.2 164.7c1.2 1.2 1.8 2.9 1.8 4.6c0 3.7-3 6.7-6.7 6.7H288c-8.8 0-16 7.2-16 16V312c0 4.4-3.6 8-8 8H184c-4.4 0-8-3.6-8-8V192c0-8.8-7.2-16-16-16H102.7c-3.7 0-6.7-3-6.7-6.7c0-1.7 .7-3.3 1.8-4.6L222.2 32.8zM224 0c-9.5 0-18.6 3.9-25.1 10.8L74.5 142.8C67.8 150 64 159.5 64 169.3c0 21.4 17.3 38.7 38.7 38.7H144V312c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V208h41.3c21.4 0 38.7-17.3 38.7-38.7c0-9.9-3.8-19.3-10.5-26.5L249.1 10.8C242.6 3.9 233.5 0 224 0zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336z"]
};
var faKnifeKitchen = {
  prefix: 'fal',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M485.7 33l-175 175 76.2 76.2 45-25c5.1-2.8 8.2-8.2 8.2-14V213.3c0-12.7 5.1-24.9 14.1-33.9l89-89c.6-.6 1-1.5 1-2.3s-.3-1.7-1-2.3L490.3 33c-.6-.6-1.5-1-2.3-1s-1.7 .3-2.3 1zM488 0c9.4 0 18.3 3.7 25 10.3L565.7 63c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-89 89c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42l-45 25c-12.5 6.9-28.1 4.8-38.2-5.3L288 230.6c-12.5-12.5-12.5-32.8 0-45.3l175-175C469.7 3.7 478.6 0 488 0zM4.7 468.7L242.7 230.6l22.6 22.6L46.6 472c21.7 5.1 43.9 8 65.4 8c99.8 0 165.6-39.9 232.5-102.4l-9-9c-12.5-12.5-12.5-32.7 0-45.2l33 33c11.5 12.6 11.3 32.2-1.3 43.9C296.6 466.3 223.2 512 112 512c-33.9 0-68.6-6.3-100.8-16.8C0 491.5-3.7 477.1 4.7 468.7zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBorderRight = {
  prefix: 'fal',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M432 32c8.8 0 16 7.2 16 16l0 416c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-416c0-8.8 7.2-16 16-16zM320 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192-48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm192-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faArrowTurnDown = {
  prefix: 'fal',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0L128 0c44.2 0 80 35.8 80 80l0 377.4L308.7 356.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 457.4 176 80c0-26.5-21.5-48-48-48L16 32z"]
};
var faLevelDown = faArrowTurnDown;
var faSpade = {
  prefix: 'fal',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M449.2 231.8c43.3 44.9 41 119.4-6.8 161.2c-41.5 34.7-104.2 29.3-143.7-10.6l-18.5-20.5c-6-6.6-14.4-10.4-23.3-10.5s-17.4 3.5-23.6 9.9l-19.8 20.8C173.6 422.6 110 427.4 70.7 393.2l-.2-.2 0 0c-48.7-41.8-51.1-116.3-7.8-161.2l0 0L256.4 32.1c.1 0 .2 .1 .3 .2L449.2 231.8l0 0zm23-22.2L279.4 9.7c-13-13-34-13-45.9 0L39.7 209.5c-55.9 57.9-52.9 153.8 10 207.8c53.1 46.3 134.4 38.2 184.6-10.8c.7-.7 1.5-1.5 2.2-2.2l3.5-3.7V480H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V400.6l3.4 3.8c.9 .9 1.8 1.8 2.7 2.7c50.2 48.6 130.1 56.4 185.1 10.3c61.9-53.9 64.9-149.8 9-207.8z"]
};
var faCardSpade = {
  prefix: 'fal',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 68.2c6.2-6.2 16.4-6.2 22.6 0l33.9 33.9L297 225.9c25 25 25 65.5 0 90.5c-24.5 24.5-63.9 25-89 1.5V352h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V317.8c-25.1 23.5-64.5 23-89-1.5c-25-25-25-65.5 0-90.5l59.7-59.7 33.9-33.9zM192 166.1l-22.6 22.6-59.7 59.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.8-25.8c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l25.8 25.8c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-59.7-59.7L192 166.1z"]
};
var faLineColumns = {
  prefix: 'fal',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM288 192c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zM304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zM288 320c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faArrowRightToLine = {
  prefix: 'fal',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352zM347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 192 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 105.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"]
};
var faArrowToRight = faArrowRightToLine;
var faPersonFallingBurst = {
  prefix: 'fal',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", "M240 0c8.8 0 16 7.2 16 16l0 10.8c0 55.4-29.2 105.8-75.2 133.7l67.3 102.6 59.4-5.9c13.2-1.3 25.9 5.7 31.8 17.5l43.1 86.1c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L310.6 289l-64.4 6.4-57.5 44.7 96.6 147.1c4.9 7.4 2.8 17.3-4.6 22.2s-17.3 2.8-22.2-4.6L79.8 232.6C69.6 250.7 64 271.5 64 293.2L64 368c0 8.8-7.2 16-16 16s-16-7.2-16-16V293.2c0-67.3 43.1-127.1 106.9-148.4c3.2-1.1 6.2-2.2 9.3-3.5c.2-.1 .4-.3 .6-.4c1.6-1.1 3.4-1.8 5.2-2.2c42.4-20.6 70-63.8 70-111.9L224 16c0-8.8 7.2-16 16-16zM171.1 313.3l47.4-36.9L151.6 174.3c-.8 .3-1.7 .6-2.5 .9c-18.9 6.3-35.5 16.8-48.9 30.4c.4 .5 .9 1.1 1.3 1.7l69.7 106.1zM56 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 56 32zM464 291.5l-57 47.2-27.6-55.2L380 251l-21.4-4.5c-13.2-15-32.9-23.2-53.3-21.5l-11.8 1c-.4-.9-.7-1.9-1-2.9c-1.4-6.1 .9-12.4 5.8-16.2l60.9-46.8L324.6 91.4c-2.8-5.6-2.1-12.3 1.8-17.2s10.3-7.1 16.3-5.6l74.6 18.4 32.1-69.8C452.1 11.6 457.8 8 464 8s11.9 3.6 14.5 9.3l32.1 69.8 74.6-18.4c6.1-1.5 12.5 .7 16.3 5.6s4.6 11.6 1.8 17.2l-34.6 68.6 60.9 46.8c5 3.8 7.2 10.2 5.8 16.2s-6.2 10.8-12.3 12.1L548 251l1.4 76.8c.1 6.2-3.4 12-9.1 14.7s-12.3 1.9-17.1-2.1l-59.2-49zm0-229.2l-23.1 50.2c-3.2 7-10.9 10.7-18.4 8.9l-53.7-13.3 24.9 49.4c3.5 6.9 1.6 15.2-4.5 19.9l-43.8 33.7 54.1 11.3c7.5 1.6 12.9 8.3 12.7 15.9l-1 55.3 42.6-35.2c5.9-4.9 14.5-4.9 20.4 0l42.6 35.2-1-55.3c-.1-7.7 5.2-14.4 12.7-15.9l54.1-11.3-43.8-33.7c-6.1-4.7-8-13-4.5-19.9l24.9-49.4-53.7 13.3c-7.5 1.8-15.2-1.9-18.4-8.9L464 62.3z"]
};
var faFlagPennant = {
  prefix: 'fal',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V32 64 320v32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V350.9L432.9 213.2c9.1-3.1 15.1-11.6 15.1-21.2s-6.1-18.1-15.1-21.2L32 33.1V16zm0 50.9L396.1 192 32 317.1V66.9z"]
};
var faPennant = faFlagPennant;
var faConveyorBeltEmpty = {
  prefix: 'fal',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M96 352c-35.3 0-64 28.7-64 64s28.7 64 64 64H544c35.3 0 64-28.7 64-64s-28.7-64-64-64H96zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm128-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUserGroupSimple = {
  prefix: 'fal',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", "M88 136a72 72 0 1 1 144 0A72 72 0 1 1 88 136zm176 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm144 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm176 0a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM208 320c53 0 96 43 96 96v16c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416c0-53 43-96 96-96h80zm-80-32C57.3 288 0 345.3 0 416v16c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V416c0-32.4-12-61.9-31.8-84.4C280.7 304.9 246.3 288 208 288H128zM432 480h80c70.7 0 128-57.3 128-128V336c0-26.5-21.5-48-48-48H352c-12.7 0-24.2 4.9-32.8 13c7.7 7.4 14.7 15.7 20.8 24.5c2.9-3.4 7.2-5.5 12.1-5.5H592c8.8 0 16 7.2 16 16v16c0 53-43 96-96 96H432c-24.6 0-47-9.2-64-24.4V432c0 9.8-1.8 19.2-5 27.8c19.9 12.8 43.6 20.2 69 20.2z"]
};
var faAward = {
  prefix: 'fal',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM1.3 441.8l41.2-97.9c1.5 1.8 3.6 4.8 6.9 10.8c4 7.4 9.1 14 15 19.6L41.8 428l38.1-5.7c6.2-.9 12.3 1.8 15.7 7.1L116.9 462l26-61.8c1.8 .9 4.1 2.2 6.9 3.9c7 4.3 14.5 7.4 22.2 9.3l-37.3 88.7c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4l-37.3-88.7c7.7-2 15.2-5.1 22.2-9.3c2.8-1.7 5.1-3 6.9-3.9l26 61.8 21.3-32.6c3.4-5.2 9.6-8 15.7-7.1l38.1 5.7-22.6-53.7c5.9-5.6 11-12.2 15-19.6c3.3-6 5.4-9 6.9-10.8l41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"]
};
var faTicketSimple = {
  prefix: 'fal',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v66c0 7.3-4.9 13.7-12 15.5c-20.7 5.3-36 24.1-36 46.5s15.3 41.2 36 46.5c7.1 1.8 12 8.2 12 15.5v66c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V318c0-7.3 4.9-13.7 12-15.5c20.7-5.3 36-24.1 36-46.5s-15.3-41.2-36-46.5C4.9 207.7 0 201.3 0 194V128zM64 96c-17.7 0-32 14.3-32 32v54.7C60.2 195 80 223.2 80 256s-19.8 61-48 73.3V384c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V329.3c-28.2-12.3-48-40.5-48-73.3s19.8-61 48-73.3V128c0-17.7-14.3-32-32-32H64z"]
};
var faTicketAlt = faTicketSimple;
var faBuilding = {
  prefix: 'fal',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32h64V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM224 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256 224 160 128zM64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120zm32 8v32h32V128H96zM248 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 64h32V128H256v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V248zm32 8v32h32V256H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm8 64h32V256H256v32z"]
};
var faAnglesLeft = {
  prefix: 'fal',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 235.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160zm352-160l-160 160c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 427.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faAngleDoubleLeft = faAnglesLeft;
var faCamcorder = {
  prefix: 'fal',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M96 112c0-26.5 21.5-48 48-48H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-44.2 0-80 35.8-80 80v48c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V399 241 224c0-35.3-28.7-64-64-64H96V112zM80 192H320c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H80zM520.3 460.5c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5v-209c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 226.4v35.1l117.4-52.8c1-.4 2-.7 3.1-.7c4.2 0 7.5 3.4 7.5 7.5v209c0 4.2-3.4 7.5-7.5 7.5c-1.1 0-2.1-.2-3.1-.7L416 378.5v35.1l104.3 46.9zM64 240c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"]
};
var faVideoHandheld = faCamcorder;
var faPancakes = {
  prefix: 'fal',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M73.8 100c8.5-6.2 21.9-12.5 39.9-18c13.7-4.2 29.6-7.9 47.2-10.7c-.5 2.8-.8 5.7-.8 8.7c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48c0-3-.3-5.9-.8-8.7c17.5 2.9 33.4 6.5 47.2 10.7c18 5.5 31.3 11.8 39.9 18c8.9 6.5 9.8 10.7 9.8 12c0 1.1-.6 4.3-6.6 9.5c-5.9 5.1-15.5 10.5-29 15.7c-26.7 10.2-65.3 18-110.4 21.2c-25.2 1.8-46.1 22.4-46.1 48.7V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.3c0-25.1-20.7-43.9-43.1-46.7c-28.5-3.5-52.9 18.5-52.9 47V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V166.1c0-19-11.4-33.8-23.4-43c-7.9-6-8.6-9.9-8.6-11.1c0-1.3 .9-5.5 9.8-12zM199.5 66.5C217.3 64.9 236.3 64 256 64s38.7 .9 56.5 2.5C317 69.3 320 74.3 320 80c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16c0-5.7 3-10.7 7.5-13.5zm-95.3-15C84.5 57.5 67.5 65 54.9 74.1C42.8 83 32 95.6 32 112c0 15.6 9.8 27.8 21.1 36.5c7.4 5.7 10.9 12.1 10.9 17.6V336c0 26.5 21.5 48 48 48s48-21.5 48-48V202.5c0-9.5 7.8-16.3 17-15.2c8.9 1.1 15 8.5 15 14.9V288c0 26.5 21.5 48 48 48s48-21.5 48-48V207.1c0-8.5 6.9-16.1 16.4-16.8c47-3.4 88.9-11.6 119.5-23.3c15.2-5.8 28.6-12.9 38.4-21.3C472 137.4 480 126.1 480 112c0-16.4-10.8-29-22.9-37.9c-12.5-9.1-29.6-16.6-49.3-22.7C368.2 39.3 314.6 32 256 32s-112.2 7.3-151.8 19.5zM426.8 210.7c-28.1 9.5-64.7 15.9-106.8 19v32.1c64.8-4.6 119.7-16.7 153.9-37.3c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7c-28.4 9.6-65.4 16-108 19.1c-2.1 12.1-7 23.3-13.9 32.9c71.3-3.8 132.1-16.1 169-38.3c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7C385.2 368.8 325.1 376 256 376c-25.8 0-50.3-1-73.1-3c-6.2 11.9-15.3 22-26.3 29.4c30.6 3.8 64.1 5.6 99.4 5.6c92.1 0 172.8-12.4 217.9-39.5c4.6 5.8 6.1 11.2 6.1 15.5c0 10.8-8.9 27.7-53.2 42.7C385.2 440.8 325.1 448 256 448s-129.2-7.2-170.8-21.3C40.9 411.7 32 394.8 32 384c0-4.4 1.4-9.7 6.1-15.5l1.1 .6C34.6 359 32 347.8 32 336V312 240 172.6c-8.9-7.1-18.9-17.3-25.3-30.9C2.3 149.8 0 158.5 0 168c0 13.5 4.7 25.5 13.4 36C4.7 214.5 0 226.5 0 240s4.7 25.5 13.4 36C4.7 286.5 0 298.5 0 312s4.7 25.5 13.4 36C4.7 358.5 0 370.5 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-13.5-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36c0-9.5-2.3-18.3-6.7-26.3c-5.8 12.1-14.3 21.6-22.2 28.3c-1.2 1-2.5 2.1-3.7 3.1c-2.7 10.6-14.7 24.8-52.6 37.6z"]
};
var faAlbumCircleUser = {
  prefix: 'fal',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M384 64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM492 462.6c-7.8-9.1-19.4-14.6-31.8-14.6H403.8c-12.4 0-23.9 5.5-31.8 14.6c17.3 11 37.9 17.4 60 17.4s42.7-6.4 60-17.4zm24.3-20.8C533.5 422.1 544 396.2 544 368c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 28.2 10.5 54.1 27.7 73.8c13.8-16.1 34.2-25.8 56.1-25.8h56.4c21.8 0 42.2 9.6 56.1 25.8zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faSubtitlesSlash = {
  prefix: 'fal',
  iconName: 'subtitles-slash',
  icon: [640, 512, [], "e610", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM459.9 448H96c-17.7 0-32-14.3-32-32V135.4L32 110.2V416c0 35.3 28.7 64 64 64H500.4l-40.5-32zM544 32H139.6l40.5 32H544c17.7 0 32 14.3 32 32V376.6l32 25.3V96c0-35.3-28.7-64-64-64zM423.3 256l40.5 32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H423.3zM144 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H257.2l-40.5-32H144zm160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h74.8l-40.5-32H304zm-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faQrcode = {
  prefix: 'fal',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M144 64H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32zm96 288H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16zM48 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H304zM256 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80zm0 224c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v68h64V304c0-8.8 7.2-16 16-16s16 7.2 16 16v84c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V320H288V472c0 8.8-7.2 16-16 16s-16-7.2-16-16V304zM88 104h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16zM72 376c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V376zM344 104h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H344c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16zM320 448c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V448zm96-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V448c0-8.8 7.2-16 16-16z"]
};
var faDiceD10 = {
  prefix: 'fal',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", "M213.8 84.1L55.6 264.1l92.7-21.8L213.8 84.1zM48.6 298.6L240 463.6V328.6l-83.1-55.4L48.6 298.6zM272 463.6l191.4-165L355.1 273.2 272 328.6V463.6zM456.4 264.1L298.2 84.1l65.4 158.2 92.7 21.8zM256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2L238 8.2C242.5 3 249.1 0 256 0zm0 300.8L332.2 250 256 65.8 179.8 250 256 300.8z"]
};
var faFireplace = {
  prefix: 'fal',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", "M32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352c0-88.4 71.6-160 160-160s160 71.6 160 160V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM576 128V480H512V352c0-106-86-192-192-192s-192 86-192 192V480H64V128H576zM32 32H608V96H32V32zM341.4 332.7c9.6-.1 18.7-4.5 24.7-12.1l1.7-2.1c8.7 10.6 16.4 22.6 22.5 34.5c9.6 18.5 14 35.5 14 42.7c0 46.3-37.6 84.3-84.4 84.3c-47.3 0-84.4-37.9-84.4-84.3c0-10.7 5.9-29.6 18.8-50.6c9.9-16.1 23.3-33.1 39.1-49.2c8 8 15.6 16.4 22.9 25.2c6.2 7.4 15.3 11.6 25 11.5zm77.3 5.6c-10.7-20.7-25.9-42.5-43.9-59c-3.2-2.9-7.8-3.6-11.6-1.9c-1.1 .5-2.1 1.1-2.9 1.9c-7 6.4-13.5 14.3-19.2 21.5c-7-8.4-14.2-16.4-21.7-24.1c-6-6.2-12.3-12.1-18.6-17.9c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4zM307 353.4c-3.1-3.9-7.8-6.2-12.7-6.1s-9.6 2.4-12.6 6.3c-4.7 6.2-8.6 11.8-11.8 17.2c-5.5 9.4-8.2 17.5-8.2 26.3c0 8.8 7.2 16 16 16s16-7.2 16-16c0-1 .1-2.8 1.8-6.4l18.8 24 0 0c5.9 7.5 14.9 12 24.5 12.2s18.8-3.9 25-11.2l9.6-11.2c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7l-9.6 11.2 0 0-21.5-27.4 0 0L307 353.4z"]
};
var faBrowser = {
  prefix: 'fal',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M160 64v64H480V96c0-17.7-14.3-32-32-32H160zm-32 0H64C46.3 64 32 78.3 32 96v32h96V64zM32 160V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V160H144 32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faPenPaintbrush = {
  prefix: 'fal',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M320.5 410c4.9 39.5 38.6 70 79.4 70H539.1c-21.2 0-37.5-11.5-47.2-24.9c-9.5-13.1-14.2-30-12.5-46.7c.3-2.7 .4-5.5 .4-8.3c0-40.8-30.5-74.5-70-79.4l26.5-26.5c43.9 15.1 75.5 56.8 75.5 105.9c0 3.9-.2 7.8-.6 11.6c-1.8 17.5 10.2 36.4 27.8 36.4h4.8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-144c-49.1 0-90.8-31.6-105.9-75.5L320.5 410zm-187-186L18.7 109.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0L224 133.5l-22.6 22.6L86.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L156.1 201.4 133.5 224zM461.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L373 94.4 449.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L461.8 39.6zM115.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L71.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L427 193.6 350.4 117 115.1 352.4zM405.2 17c21.9-21.9 57.3-21.9 79.2 0L527 59.6c21.9 21.9 21.9 57.3 0 79.2L214.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L405.2 17z"]
};
var faPencilPaintbrush = faPenPaintbrush;
var faFishCooked = {
  prefix: 'fal',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M143.4 191.2c21.4-23.6 49.6-47.6 80.7-65.6C255.3 107.5 288.4 96 320 96c51.6 0 108.2 26.5 152.4 61.5c22 17.4 40.2 36.4 52.9 54.3c13 18.4 18.7 33.7 18.7 44.2s-5.7 25.8-18.7 44.2c-12.6 17.9-30.9 36.9-52.9 54.3C428.2 389.5 371.6 416 320 416c-31.6 0-64.7-11.5-95.9-29.6c-31.1-18-59.3-42-80.7-65.6c-5.4-5.9-14.3-7-20.9-2.4L37.6 376.8 62.1 266.4c1.5-6.9 1.5-14 0-20.8L37.6 135.2l84.9 58.4c6.6 4.5 15.5 3.5 20.9-2.4zM320 64c-39.1 0-77.8 14.1-111.9 33.9c-29.8 17.2-56.8 39.3-78.7 61.6L43.7 100.6c-4.4-3-9.6-4.6-14.9-4.6C12 96-.5 111.6 3.2 128L30.8 252.5c.5 2.3 .5 4.7 0 6.9L3.2 384c-3.6 16.4 8.8 32 25.6 32c5.3 0 10.5-1.6 14.9-4.6l-9.1-13.2 9.1 13.2 85.6-58.9c21.9 22.4 49 44.4 78.7 61.6C242.2 433.9 280.9 448 320 448c61.4 0 124.8-30.9 172.3-68.5c23.9-18.9 44.4-40.1 59.2-60.9C565.8 298.2 576 276.2 576 256s-10.2-42.2-24.5-62.6c-14.7-20.8-35.2-42-59.2-60.9C444.8 94.9 381.4 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z"]
};
var faChairOffice = {
  prefix: 'fal',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M288 32c17.7 0 32 14.3 32 32V224h32V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V224h32V64c0-17.7 14.3-32 32-32H288zM64 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm352 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM352 288l32 64-160 0H64l32-64H352zM240 384H384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-32-64C375.2 262.8 364.1 256 352 256H96c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-5 9.9-4.4 21.7 1.4 31.1S52.9 384 64 384H208v48H192c-35.3 0-64 28.7-64 64c0 8.8 7.2 16 16 16s16-7.2 16-16c0-17.7 14.3-32 32-32h16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V464h16c17.7 0 32 14.3 32 32c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-28.7-64-64-64H240V384z"]
};
var faNestingDolls = {
  prefix: 'fal',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M192 32c53 0 96 43 96 96v80 16h32V208 128C320 57.3 262.7 0 192 0S64 57.3 64 128v80 16H96V208 128c0-53 43-96 96-96zm64.6 448H74.5c-9.2 0-14-3.5-15.9-6.4C46.9 455.7 32 424.8 32 384c0-32.6 13.6-63.3 30-96H312.2c5.4-11.4 12.1-22.2 19.9-32H51.9c-5.9 0-11.3 3.3-14 8.6C20.2 299.6 0 339.6 0 384c0 48.8 17.9 85.7 31.8 107.1C41.1 505.3 57.5 512 74.5 512H261.4c-4.8-10.1-6.4-21.3-4.8-32zM148.2 131.8c17.1-5.3 32.2-15.2 43.8-28.3c11.5 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2zm65.1-52.7c-5.6-7.3-14.1-10.2-21.3-10.2s-15.7 2.9-21.3 10.2c-9.2 11.9-22.4 20.4-37.5 23.5c-10.8 2.3-22.6 13.4-18.8 28.7c3.4 13.6 10.4 26.5 21.1 37.2c31.2 31.2 81.9 31.2 113.1 0c10.6-10.6 17.7-23.5 21.1-37.2c3.8-15.4-8-26.5-18.8-28.7c-15.1-3.2-28.3-11.7-37.5-23.5zM464 343.5c11.5 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2c17.1-5.3 32.2-15.2 43.8-28.3zm0-34.6c-7.3 0-15.7 2.9-21.3 10.2c-9.2 11.9-22.4 20.4-37.5 23.5c-10.8 2.3-22.6 13.4-18.8 28.7c3.4 13.6 10.4 26.6 21.1 37.2c31.2 31.2 81.9 31.2 113.1 0c10.6-10.6 17.7-23.5 21.1-37.2c3.8-15.4-8-26.5-18.8-28.7c-15.1-3.2-28.3-11.7-37.5-23.5c-5.6-7.3-14.1-10.2-21.3-10.2zM588.7 455.3c3.7 8.1 7.8 16.4 12.7 24.7H326.6c4.9-8.3 9-16.6 12.7-24.7C353.1 425 360 393.3 360 360c0-57.4 46.6-104 104-104s104 46.6 104 104c0 33.3 6.9 65 20.7 95.3zm46.8 18.7c-7-10-12.6-20.9-17.7-32C605.9 415.9 600 388.7 600 360c0-75.1-60.9-136-136-136s-136 60.9-136 136c0 28.7-5.9 55.9-17.8 82.1c-5 11.1-10.7 22-17.7 32l0 0c-5.2 7.3-5.9 16.9-1.8 24.9c4.1 8 12.3 13 21.3 13H616c9 0 17.2-5 21.3-13s3.4-17.6-1.8-24.9z"]
};
var faClockRotateLeft = {
  prefix: 'fal',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", "M32 132V48c0-8.8-7.2-16-16-16S0 39.2 0 48V176c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H53.6C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16V256c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4V144c0-8.8-7.2-16-16-16z"]
};
var faHistory = faClockRotateLeft;
var faTrumpet = {
  prefix: 'fal',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M608 96.8V383.2c-10-14.3-33.6-45.3-67.1-73.1C507 282.1 461.3 256 408 256H368h-5.3H288 208 160 32V224H208h80 80 40c53.3 0 99-26.1 132.9-54.1C574.4 142.1 598 111 608 96.8zM352 288V416H304V288h48zm32 128V288h24c42.8 0 81.4 21 112.5 46.8c30.9 25.6 52.8 54.6 61.7 67.4c5.9 8.5 15.6 13.9 26.4 13.9c17.4 0 31.4-14.1 31.4-31.4V95.4C640 78.1 625.9 64 608.6 64c-10.8 0-20.5 5.4-26.4 13.9c-8.9 12.8-30.8 41.8-61.7 67.4C489.4 171 450.8 192 408 192H384V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H304V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H224V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H32c0-8.8-7.2-16-16-16s-16 7.2-16 16v16 64 16c0 8.8 7.2 16 16 16s16-7.2 16-16H88.4C73.2 305 64 327.4 64 352c0 53 43 96 96 96h48 80 80 48c47.4 0 86.7-34.3 94.6-79.4c-3.4-3.1-6.9-6.2-10.5-9.2c-6.7-5.5-13.5-10.6-20.5-15.2c.3 2.6 .5 5.2 .5 7.8c0 35.3-28.7 64-64 64H384zm-112 0H224V288h48V416zm-80 0H160c-35.3 0-64-28.7-64-64s28.7-64 64-64h32V416z"]
};
var faFaceGrinBeamSweat = {
  prefix: 'fal',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", "M432.2 68.6c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.6c0 .2 0 .2 0 .1c0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.2-.7-.8-3.7-3.4-9.5c-3-6.7-7.4-14.6-12.8-23.1c-5-7.9-10.5-15.8-15.8-23c-5.3 7.2-10.8 15.1-15.8 23zm7.3-64.5c4.3-5.5 12.8-5.5 17.1 0C473.9 25.8 512 76.3 512 101.3c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 37.9-75.5 55.5-97.2zM256 32C132.3 32 32 132.3 32 256s100.3 224 224 224s224-100.3 224-224c0-20.7-2.8-40.7-8.1-59.7c-2.4-8.5 2.6-17.3 11.2-19.7s17.3 2.6 19.7 11.2c6 21.7 9.2 44.6 9.2 68.3c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c43.1 0 83.8 10.7 119.5 29.5c7.8 4.1 10.8 13.8 6.7 21.6S368.3 62 360.5 57.8C329.3 41.3 293.8 32 256 32zm90 313.8c-28.5 5.4-58.7 8.3-89.9 8.3s-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3zm33.8-41.1c12.3-3.7 24.2 7 19.1 18.7c-24.1 54.6-79 92.7-142.8 92.7s-118.7-38.1-142.8-92.7c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4zM143.5 219.9c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4zm172.9-25.4c-6.2 7.2-10.8 16.8-12.9 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5z"]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faFireSmoke = {
  prefix: 'fal',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", "M349.4 93.5c9.6-.1 18.7-4.5 24.7-12.1c3.9-4.9 7.8-9.6 11.6-14c16.4 17.8 30.9 39.4 41.8 60.5C441 154 448 179.4 448 192.2c0 25.3-7.4 48.9-20.1 68.8c7.4 5.8 14.3 12.1 20.7 18.9c2.7-1.8 5.5-3.5 8.4-5.2c14.6-24.1 23-52.4 23-82.5c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-1.8 1.6-3.5 3.3-5.2 5c-7.7 7.7-14.8 16.4-21.2 24.5c-7-8.4-14.1-16.5-21.5-24.4c-10.9-11.6-22.2-22.8-34-33.4c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 30 8.2 58.3 22.7 82.4c3 1.7 5.9 3.5 8.7 5.3c6.3-6.8 13.2-13.1 20.6-18.8c-12.7-19.9-20-43.6-20-68.9c0-17.9 9.4-46.2 27.6-75.8c15.9-25.8 37.9-53.1 64-78.1C298 51.9 311.6 66.5 324.4 82c6.2 7.4 15.3 11.6 25 11.5zM224 194c0 19.2 4.8 36.3 13.5 50.5c9.5-5.1 19.6-9.3 30.1-12.6c-7.1-9.6-11.5-22.2-11.5-38c0-8.3 2.5-16.8 9.1-28.1c4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.5 1.8 2.4 .5 .6 .1 .2 0 0 0 0 0 0L347 191l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1c6.9 19 3.9 39.8-7 54.8c10.5 3.3 20.5 7.5 30 12.6c16.2-27 17-62.2 1.3-91.1l0-.1 0 0 0 0 0 0c-1.9-3.9-4.5-9-8.3-14.1c-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5c-3-3.8-7.6-6-12.4-6s-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C229 164.3 224 178.3 224 194zM213.9 364c15-44.2 56.9-76 106.1-76s91.1 31.8 106.1 76c2.1 6.2 7.7 10.5 14.2 10.8s12.6-3.2 15.4-9.1C468.6 338.7 496.1 320 528 320c44.2 0 80 35.8 80 80s-35.8 80-80 80H404.7 235.3 112c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.9 0 59.4 18.7 72.3 45.7c2.8 5.9 8.9 9.5 15.4 9.1s12.1-4.7 14.2-10.8zM320 256c-52.6 0-98.6 28.2-123.7 70.3C175.8 302.8 145.6 288 112 288C50.1 288 0 338.1 0 400s50.1 112 112 112H235.3 404.7 528c61.9 0 112-50.1 112-112s-50.1-112-112-112c-33.6 0-63.8 14.8-84.3 38.3C418.6 284.2 372.6 256 320 256z"]
};
var faPhoneMissed = {
  prefix: 'fal',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M112 0c-8.8 0-16 7.2-16 16V144c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l98.7 98.7C251.5 178.1 285 192 320 192s68.5-13.9 93.3-38.6L523.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L390.6 130.7C371.9 149.5 346.5 160 320 160s-51.9-10.5-70.6-29.3L150.6 32H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM39.1 366.5C86.8 320.1 186.2 255.1 320 255.1s233.2 65 280.9 111.3c7.6 7.4 9.5 19.8 3.7 31.3l-37.4 73.5c-3.3 6.5-10.6 10-17.7 8.4l-88.7-19.8c-7.3-1.6-12.5-8.1-12.5-15.6V362.2c0-7.2-4.8-13.5-11.8-15.4l-36.1-9.9c-52.6-14.4-108.1-14.4-160.7 0l-36.1 9.9c-7 1.9-11.8 8.2-11.8 15.4v82.1c0 7.5-5.2 14-12.5 15.6L90.6 479.7c-7.1 1.6-14.4-1.9-17.7-8.4L35.5 397.8c-5.8-11.5-3.9-23.9 3.7-31.3zM320 223.1C175.8 223.1 68.8 293 16.8 343.5c-19.3 18.7-21 46.8-9.9 68.7l37.4 73.5c9.9 19.5 31.8 29.9 53.2 25.1l88.7-19.8c21.9-4.9 37.5-24.4 37.5-46.9V374.4l24.4-6.7c47.1-12.9 96.7-12.9 143.8 0l24.4 6.7v69.8c0 22.5 15.6 42 37.5 46.9l88.7 19.8c21.4 4.8 43.3-5.6 53.2-25.1l37.4-73.5c11.1-21.9 9.4-50-9.9-68.7c-52-50.5-159-120.4-303.2-120.4z"]
};
var faFileExport = {
  prefix: 'fal',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352v64h32V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V368H352v80zm-.5-288H240c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4zm123.8 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L521.4 304H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H521.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faArrowRightFromFile = faFileExport;
var faShield = {
  prefix: 'fal',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M268.5 37.3c-8-3.4-17-3.4-25 0l-176.7 75C55.5 117 47.9 127.7 48 139.8c.5 94 39.3 259.8 195.4 334.5c7.9 3.8 17.2 3.8 25.1 0c156.1-74.7 195-240.4 195.5-334.5c.1-12.1-7.5-22.8-18.8-27.6l-176.7-75zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z"]
};
var faShieldBlank = faShield;
var faArrowUpShortWide = {
  prefix: 'fal',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faArrowsRepeat1 = {
  prefix: 'fal',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M0 255.2C-.4 264 6.4 271.5 15.2 272s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112H390.6l-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6L390.6 80H176.2C82.4 80 5.1 153.5 .4 247.2l-.4 8zm512 1.6c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400H121.4l57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80c-3.3 3-5.2 7.3-5.2 11.8s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L121.4 432H335.8c93.8 0 171.1-73.5 175.8-167.2l.4-8zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L256 240v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"]
};
var faRepeat1Alt = faArrowsRepeat1;
var faGunSlash = {
  prefix: 'fal',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM473.4 240c8.5 0 16.6-3.4 22.6-9.4L518.6 208H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H544V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H180.1l40.5 32H528h48v80H518.6c-8.5 0-16.6 3.4-22.6 9.4L473.4 208H362.5L403 240h70.4zM249.5 281.9L208 448 96 448l40.1-160.5c4.3-17 1.3-33.8-6.7-47.5h67l-40.5-32H89.2 74 64l0-72.6L32 110.2V208c0 17.7 14.3 32 32 32H74c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480H208c14.7 0 27.5-10 31-24.2l38-152.1-27.5-21.7z"]
};
var faAvocado = {
  prefix: 'fal',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M480 144c0 34.8-15.9 66-40.9 86.6c-22.3 18.4-42.7 44.7-49.1 77.6c-9.4 47.7-31 93.8-57.5 120.3c-68.7 68.7-180.2 68.7-248.9 0s-68.7-180.2 0-248.9c26.5-26.5 72.5-48.1 120.3-57.5c32.9-6.4 59.3-26.8 77.6-49.1C302 47.9 333.2 32 368 32c61.9 0 112 50.1 112 112zM421.3 314.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zM176.1 240.1c38.2-38.2 88.1-40.4 112.1-16.4s21.8 73.9-16.4 112.1s-88.1 40.4-112.1 16.4s-21.8-73.9 16.4-112.1zm134.8-39c-41.4-41.4-112.1-28.8-157.4 16.4s-57.8 116-16.4 157.4s112.1 28.8 157.4-16.4s57.8-116 16.4-157.4z"]
};
var faBinary = {
  prefix: 'fal',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M320 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V16zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304zM0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80C35.8 0 0 35.8 0 80zM80 32h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zM272 288c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V368c0-44.2-35.8-80-80-80H272zm-48 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V368z"]
};
var faGlassesRound = {
  prefix: 'fal',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L46.6 241.5C70.5 220.6 101.8 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c34.2 0 65.5 12.6 89.4 33.5L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7c29 0 54.2 19.6 61.5 47.6l48.7 188.8c4.4 17 6.6 34.4 6.6 52V344c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-8.2 .7-16.2 2.1-24H269.9c1.4 7.8 2.1 15.8 2.1 24c0 75.1-60.9 136-136 136S0 419.1 0 344V320.4c0-17.5 2.2-35 6.6-52L55.3 79.6C62.5 51.6 87.8 32 116.8 32c9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM544 344a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM136 448a104 104 0 1 0 0-208 104 104 0 1 0 0 208z"]
};
var faGlassesAlt = faGlassesRound;
var faPhonePlus = {
  prefix: 'fal',
  iconName: 'phone-plus',
  icon: [640, 512, [], "f4d2", "M448 208V128H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V16c0-8.8 7.2-16 16-16s16 7.2 16 16V96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm-55 78.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0h0c-4.6-.2-9.1-.4-13.7-.8C247.5 494.5 64 300.7 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L393 286.7zM512 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
};
var faDitto = {
  prefix: 'fal',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M96 98.3V96c0-17.7-14.3-32-32-32S32 78.3 32 96v2.3c0 2 .2 3.9 .5 5.9L58 251c.5 2.9 3 5 6 5s5.5-2.1 6-5L95.5 104.2l30.9 5.4-30.9-5.4c.3-1.9 .5-3.9 .5-5.9zm-96 0V96C0 60.7 28.7 32 64 32s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L101.5 256.5C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4zm288 0V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v2.3c0 2 .2 3.9 .5 5.9L250 251c.5 2.9 3 5 6 5s5.5-2.1 6-5l25.5-146.8 30.9 5.4-30.9-5.4c.3-1.9 .5-3.9 .5-5.9zm-96 0V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L293.5 256.5c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L193 109.6c-.7-3.8-1-7.5-1-11.4z"]
};
var faPersonSeat = {
  prefix: 'fal',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", "M176 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM152 32a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 61.9 50.1 112 112 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V144zm116 64c15.5 0 28 12.5 28 28v4 88H136c-8.8 0-16-7.2-16-16V236c0-15.5 12.5-28 28-28zm58.8 16c-5.6-27.4-29.8-48-58.8-48c-33.1 0-60 26.9-60 60v76c0 26.5 21.5 48 48 48h56 40.6c15.3 0 28.4 10.8 31.4 25.7l16.3 81.4c1.5 7.5 8.1 12.9 15.7 12.9h72c8.8 0 16-7.2 16-16s-7.2-16-16-16H309.1l-13.7-68.6c-6-29.9-32.2-51.4-62.8-51.4H208V256h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H206.8z"]
};
var faHouseMedical = {
  prefix: 'fal',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zM272 176c-17.7 0-32 14.3-32 32v32H208c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V336h32c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H336V208c0-17.7-14.3-32-32-32H272zm0 32h32v48c0 8.8 7.2 16 16 16h48v32H320c-8.8 0-16 7.2-16 16v48H272V320c0-8.8-7.2-16-16-16H208V272h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V208z"]
};
var faGolfBallTee = {
  prefix: 'fal',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M288 320c38.9-29.2 64-75.7 64-128c0-88.4-71.6-160-160-160S32 103.6 32 192c0 52.3 25.1 98.8 64 128H48.9C18.5 286 0 241.2 0 192C0 86 86 0 192 0S384 86 384 192c0 49.2-18.5 94-48.9 128H288zM80 352H192 304c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM226.1 248.6c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5zm-52.3-49.3c18.5 0 33.5-15 33.5-33.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4zm113.5-17.5c0-4.9 5.1-9.1 8.4-5.4c5.2 5.9 8.4 13.7 8.4 22.1c0 18.5-15 33.5-33.5 33.5c-8.5 0-16.2-3.2-22.1-8.4c-3.7-3.3 .5-8.4 5.4-8.4c18.5 0 33.5-15 33.5-33.5z"]
};
var faGolfBall = faGolfBallTee;
var faCircleChevronLeft = {
  prefix: 'fal',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM276.7 132.7l-112 112c-6.2 6.2-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 256 299.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faHouseChimneyWindow = {
  prefix: 'fal',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V192.3L570.6 244c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM480 164.1V64H416v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM240 192h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm0 32v96h96V224H240z"]
};
var faScythe = {
  prefix: 'fal',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M639.7 19.1c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6L550.1 304H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H543.7L512.3 492.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l96-480zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224H533.4l6.4-32H37.2C64.7 149.7 158.7 32 352 32H571.8l5.1-25.4c.5-2.3 1.1-4.5 1.8-6.6H352z"]
};
var faPenNib = {
  prefix: 'fal',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", "M377.4 45.3L310.6 112 400 201.4l66.7-66.7c12.5-12.5 12.5-32.8 0-45.3L422.6 45.3c-12.5-12.5-32.8-12.5-45.3 0zM279.7 97.7l75.1-75.1c25-25 65.5-25 90.5 0l44.1 44.1c25 25 25 65.5 0 90.5l-75.1 75.1L376.8 370c-7.3 26.6-27.7 47.6-54.2 55.6L47.4 508.1c-12.3 3.7-25.7 .3-34.7-8.8s-12.5-22.4-8.8-34.7L86.5 189.4c7.9-26.4 28.9-46.9 55.6-54.2L279.7 97.7zm3.6 32.2L150.5 166.1c-16 4.4-28.6 16.6-33.3 32.5L42.7 446.7 152.9 336.5c-5.6-9.5-8.9-20.6-8.9-32.5c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-11.9 0-23-3.2-32.5-8.9L65.3 469.3l248.1-74.4c15.9-4.8 28.2-17.4 32.5-33.3l36.2-132.8-98.9-98.9zM208 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faBanParking = {
  prefix: 'fal',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm76-170.6c30.9-16 52-48.2 52-85.4c0-53-43-96-96-96H200c-13.3 0-24 10.7-24 24v1.4L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L332 309.4zM307.6 285L208 185.4V160h80c35.3 0 64 28.7 64 64c0 28.5-18.7 52.7-44.4 61zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 257.9V304v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320h30.1L176 257.9z"]
};
var faParkingCircleSlash = faBanParking;
var faTentArrowTurnLeft = {
  prefix: 'fal',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M114.8 27.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112 464 112c44.2 0 80 35.8 80 80v48c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-61.9-50.1-112-112-112L57.4 80l57.4-52.2zM297.5 163.1c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512H459.6c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7v112c0 .2 0 .4 0 .5V480H116.4c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8L272 207.7zm32 168.5L368.2 480H304V376.2zm0-60.8V207.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H405.9l-.3-.4L304 315.4z"]
};
var faFaceDiagonalMouth = {
  prefix: 'fal',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm372.4 63.4l-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faDiagramCells = {
  prefix: 'fal',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", "M480 160c0 17.7-14.3 32-32 32L64 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32v64zm-32 64c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64l384 0zm64 192V352c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zm-64 32L64 448c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32z"]
};
var faCricketBatBall = {
  prefix: 'fal',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-151 151 30.1 30.1c21.9 21.9 21.9 57.3 0 79.2L178 495.9c-10 10-24.4 16.7-40.4 15.6c-11.3-.8-28.6-2.8-46.4-8.2C73.9 498.2 54.1 489.1 39 473c-16.2-15-25.2-34.9-30.4-52.2l30.6-9.3c4.4 14.5 11.2 28.4 21.6 38c.6 .5 1.1 1.1 1.6 1.6c9.6 10.4 23.5 17.2 38 21.6c14.7 4.4 29.3 6.2 39.3 6.9c5.6 .4 11.2-1.9 15.6-6.3L308.7 320H240c-26.5 0-48-21.5-48-48V203.3L38.7 356.6c-4.4 4.4-6.7 10.1-6.3 15.6c.7 10 2.4 24.6 6.9 39.3L8.6 420.8C3.2 403 1.2 385.7 .5 374.4C-.6 358.4 6.1 344 16.1 334L224.4 125.7c21.9-21.9 57.3-21.9 79.2 0l30.1 30.1 151-151c6.2-6.2 16.4-6.2 22.6 0zM224 171.3V272c0 8.8 7.2 16 16 16H340.7l23-23c9.4-9.4 9.4-24.6 0-33.9L281 148.3c-9.4-9.4-24.6-9.4-33.9 0l-23 23zM480 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faCricket = faCricketBatBall;
var faTents = {
  prefix: 'fal',
  iconName: 'tents',
  icon: [640, 512, [], "e582", "M425.5 3.1c-5.7-4.2-13.4-4.2-19 0L236 129.1c9.5 1.8 18.7 5.8 26.8 12l5.4 4.1L416 35.9 579.5 156.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H456.7l4.8 32h126c29 0 51.3-25.5 47.6-54.2L617.6 163.4c-1.7-12.9-8.6-24.6-19.1-32.4L425.5 3.1zm-192 160c-5.7-4.2-13.4-4.2-19 0L41.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L4.8 457.8C1.1 486.5 23.5 512 52.4 512H395.6c29 0 51.3-25.5 47.6-54.2L425.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM60.5 316.8L208 207.7V480H52.4c-9.7 0-17.1-8.5-15.9-18.1L54.1 327.6c.6-4.3 2.9-8.2 6.4-10.8zM240 309.9V207.7L387.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H345.4l-.2-.4-104-168c-.4-.6-.7-1.1-1.2-1.6zM240 480V370.5L307.8 480H240z"]
};
var faWandMagic = {
  prefix: 'fal',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", "M305.9 155.3l50.7 50.7L477.1 85.7c3.1-3.1 3.1-8.2 0-11.3L437.7 34.9c-3.1-3.1-8.2-3.1-11.3 0L305.9 155.3zm-22.6 22.6L34.9 426.3c-3.1 3.1-3.1 8.2 0 11.3l39.4 39.4c3.1 3.1 8.2 3.1 11.3 0L334.1 228.7l-50.7-50.7zM12.3 403.7L403.7 12.3c15.6-15.6 40.9-15.6 56.6 0l39.4 39.4c15.6 15.6 15.6 40.9 0 56.6L108.3 499.7c-15.6 15.6-40.9 15.6-56.6 0L12.3 460.3c-15.6-15.6-15.6-40.9 0-56.6z"]
};
var faMagic = faWandMagic;
var faDog = {
  prefix: 'fal',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M322.9 349.5c8.2 6 13.1 15.6 13.1 25.8V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V261.9l-.1 0L307.6 208c-.3 0-.7 0-1 0H160 136 96V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V375.3c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2s31.7-2.5 46.3-7.2c9.7-3.1 20.4-1.4 28.6 4.6zm82.9-130.7c2.6-15.4 15.9-26.7 31.6-26.7H480c35.3 0 64-28.7 64-64V112c0-8.8-7.2-16-16-16H496c-8.5 0-16.6-3.4-22.6-9.4L455.4 68.7c-3-3-7.1-4.7-11.3-4.7H400c-10.1 0-19.6-4.7-25.6-12.8L362.5 35.4 338.2 181.3c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM45.6 159.3C54.5 169.7 67.6 176 82 176H96h40 24H306.7L331.9 24.8C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32h44.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96H437.3L432 256V456c0 30.9-25.1 56-56 56H360c-30.9 0-56-25.1-56-56V408.7 375.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1v33.3V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V208c0-.7 0-1.4 .1-2c-.7-.2-1.4-.3-2.1-.5c-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPenLine = {
  prefix: 'fal',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", "M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4 417.6 171l54.8-54.8c9.4-9.4 9.4-24.6 0-33.9L429.8 39.6zM83.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2L39.6 472.4l92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7 .1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM240 480H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAtomSimple = {
  prefix: 'fal',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", "M175.1 438.1c-50.8 16.9-82.3 10.1-96.7-4.4s-21.3-46-4.4-96.7c5.4-16.2 12.9-33.3 22.5-50.9c16.8 23.8 36.7 47.4 59.4 70.1s46.3 42.6 70.1 59.4c-17.6 9.6-34.7 17.2-50.9 22.5zM55.7 55.7C16.5 94.9 27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zM178.5 333.5c-25.3-25.3-46.6-51.6-63.8-77.5c17.2-25.9 38.6-52.3 63.8-77.5s51.6-46.6 77.5-63.8c25.9 17.2 52.3 38.6 77.5 63.8s46.6 51.6 63.8 77.5c-17.2 25.9-38.6 52.3-63.8 77.5s-51.6 46.6-77.5 63.8c-25.9-17.2-52.3-38.6-77.5-63.8zM155.8 155.8c-22.7 22.7-42.6 46.3-59.4 70.1c-9.6-17.6-17.2-34.7-22.5-50.9c-16.9-50.8-10-82.3 4.4-96.7s46-21.3 96.7-4.4c16.2 5.4 33.3 12.9 50.9 22.5c-23.8 16.8-47.4 36.7-70.1 59.4zm200.3 0c-22.7-22.7-46.3-42.6-70.1-59.4c17.6-9.6 34.7-17.2 50.9-22.5c50.8-16.9 82.3-10 96.7 4.4s21.3 46 4.4 96.7c-5.4 16.2-12.9 33.3-22.5 50.9c-16.8-23.8-36.7-47.4-59.4-70.1zm0 200.3c22.7-22.7 42.6-46.3 59.4-70.1c9.6 17.6 17.2 34.7 22.5 50.9c16.9 50.8 10.1 82.3-4.4 96.7s-46 21.3-96.7 4.4c-16.2-5.4-33.3-12.9-50.9-22.5c23.8-16.8 47.4-36.7 70.1-59.4zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faAtomAlt = faAtomSimple;
var faAmpersand = {
  prefix: 'fal',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M175.2 64h33.9c34.7 0 62.9 28.2 62.9 62.9c0 20.5-10 39.8-26.8 51.5L181.6 223l-51.1-51.1C118.7 160 112 144 112 127.2C112 92.3 140.3 64 175.2 64zm29.4 181.9l59-41.3c25.4-17.8 40.5-46.8 40.5-77.8C304 74.5 261.5 32 209.1 32H175.2C122.6 32 80 74.6 80 127.2c0 25.2 10 49.5 27.9 67.3L155 241.6 72.9 299C47.3 317 32 346.3 32 377.7V384c0 53 43 96 96 96h80c35.3 0 68.4-16.6 89.6-44.8l21.8-29.1 69.2 69.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72.5-72.5 74-98.6c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-71.2 95L204.6 245.9zm-26.6 18.6L296.6 383.2 272 416c-15.1 20.1-38.8 32-64 32H128c-35.3 0-64-28.7-64-64v-6.3c0-20.9 10.2-40.5 27.3-52.4l86.6-60.7z"]
};
var faCarrot = {
  prefix: 'fal',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", "M320 88c0-23.9 14.5-45.4 23-55.8l.1 0c.1-.1 .4-.2 .9-.2c.4 0 .7 .1 .8 .1C352.9 42.3 368 65.6 368 96c0 14.7-1.8 22.9-3.2 26.9c-.6 1.6-1 2.6-1.2 2.9c-5.2 6.3-4.8 15.6 1.1 21.4s15.2 6.2 21.4 1.1c.4-.2 1.3-.7 2.9-1.2c4-1.3 12.2-3.2 26.9-3.2c30.4 0 53.7 15.1 63.9 23.2c0 .1 .1 .4 .1 .8c0 .5-.1 .8-.2 .9l0 .1c-10.4 8.5-32 23-55.8 23c-17.7 0-28.7-3.3-37.7-8.6c-9.8-5.7-18.3-14-31-26.7s-21.1-21.2-26.7-31c-5.3-9.1-8.6-20-8.6-37.7zm96 24c-6.3 0-11.9 .3-16.8 .8c.5-4.9 .8-10.5 .8-16.8c0-40.9-20.2-71.2-30.2-83.9C363.1 3.7 353.2 0 344 0s-19 3.7-25.7 11.8C308.7 23.6 288 52.5 288 88c0 19.5 3.3 34.8 9.9 48.2c-14.3-5.3-29.7-8.2-45.8-8.2c-50.9 0-97.2 29.3-119.1 75.2L2.3 477.7C-2 486.9-.2 497.8 7 505s18.1 9.1 27.3 4.7L308.8 379c45.9-21.9 75.2-68.2 75.2-119.1c0-16.1-2.9-31.5-8.2-45.8c13.4 6.6 28.6 9.9 48.2 9.9c35.5 0 64.4-20.7 76.2-30.3C508.3 187 512 177.2 512 168c0-9.2-3.7-19.1-12.1-25.8c-12.7-10.1-43-30.2-83.9-30.2zM252.1 160c55.2 0 99.9 44.7 99.9 99.9c0 38.5-22.2 73.6-56.9 90.2L174.2 407.6l-34.9-34.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l26.9 26.9L40.9 471.1 151.7 238.4l29 29c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.6-36.6c18-29.6 50.3-48.1 85.4-48.1z"]
};
var faArrowUpFromLine = {
  prefix: 'fal',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6V192 368c0 8.8 7.2 16 16 16s16-7.2 16-16V192 86.6L308.7 187.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faArrowFromBottom = faArrowUpFromLine;
var faMoon = {
  prefix: 'fal',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M190.6 66.8c-38.8 37.8-62.9 90.7-62.9 149.2c0 108.9 83.5 198.3 189.9 207.3C289.8 439 257.7 448 223.5 448C117.7 448 32 362.1 32 256c0-94.8 68.5-173.5 158.6-189.2zm66.1-21.5c-1.5-6.9-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3z"]
};
var faPenSlash = {
  prefix: 'fal',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20L382.4 117 459 193.6l-50.6 50.6 25.3 20L559 138.8zM317.2 335.4l-93.6 93.6c-7.6 7.6-16.9 13.1-27.2 16.1l-92.8 27.3 27.3-92.8c3-10.3 8.6-19.6 16.1-27.2l84.6-84.6-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM459.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8z"]
};
var faWineGlassEmpty = {
  prefix: 'fal',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32 61.2 32 46.4 195.6zm-31.9-2.9L29.4 29.1C30.9 12.6 44.7 0 61.2 0H258.8c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160 80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7z"]
};
var faWineGlassAlt = faWineGlassEmpty;
var faSquareStar = {
  prefix: 'fal',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm238.3 16.9l36.2 73.4 81.1 11.8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-58.6 57.2 13.8 80.7c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 342.1l-72.5 38.1c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.6l13.8-80.7L83.5 225.4c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l81-11.8 36.2-73.4c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9zm-40 95.1c-2.3 4.7-6.8 8-12 8.8L129 225.1l41.5 40.4c3.8 3.7 5.5 9 4.6 14.2l-9.8 57.1 51.2-26.9c4.7-2.5 10.2-2.5 14.9 0l51.2 26.9-9.8-57.1c-.9-5.2 .8-10.5 4.6-14.2L319 225.1l-57.3-8.3c-5.2-.8-9.7-4-12-8.8L224 156.2l-25.6 51.9z"]
};
var faCheese = {
  prefix: 'fal',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M480 240.2V256H32c0-9.3 4.6-18 12.4-23.1L292.6 67.4 274.9 40.7l17.8 26.6c3.3-2.2 7.2-3.4 11.1-3.4C401.1 64 480 142.9 480 240.2zM32 288H480V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288zM303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256 240.2C512 125.2 418.8 32 303.8 32z"]
};
var faSendBackward = {
  prefix: 'fal',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M64 32H288c17.7 0 32 14.3 32 32v64h32V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V320H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM288 96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96V256c0 17.7 14.3 32 32 32h32V256H96V96H256v32h32V96zm-64 96H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm-64 32V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"]
};
var faYinYang = {
  prefix: 'fal',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M480 256c0 123.7-100.3 224-224 224c-57.4 0-104-46.6-104-104s46.6-104 104-104c75.1 0 136-60.9 136-136c0-26.5-7.6-51.2-20.6-72C436.5 103.1 480 174.5 480 256zM256 32c57.4 0 104 46.6 104 104s-46.6 104-104 104c-75.1 0-136 60.9-136 136c0 26.5 7.6 51.2 20.6 72C75.5 408.9 32 337.5 32 256C32 132.3 132.3 32 256 32zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMusic = {
  prefix: 'fal',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M512 23c0-12.7-10.3-23-23-23c-2.3 0-4.6 .3-6.8 1l-311 95.7C164.6 98.8 160 105 160 112V232 372.4C143 359.7 120.6 352 96 352c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V246.3l288-88.6V308.4c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V136.4c0-.2 0-.5 0-.7V23zM480 368c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM160 432c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM480 124.2L192 212.8v-89L480 35.2v89z"]
};
var faCompassSlash = {
  prefix: 'fal',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", "M448.8 439.3C412.4 464.9 368 480 320 480C196.3 480 96 379.7 96 256c0-29.3 5.6-57.2 15.8-82.8L85.7 152.6C71.8 184.2 64 219.2 64 256c0 141.4 114.6 256 256 256c58.2 0 111.9-19.4 154.9-52.2l-26.1-20.6zM320 0C261.8 0 208.1 19.4 165.1 52.2l26.1 20.6C227.6 47.1 272 32 320 32c123.7 0 224 100.3 224 224c0 29.3-5.6 57.2-15.8 82.8l26.1 20.6c14-31.6 21.7-66.6 21.7-103.4C576 114.6 461.4 0 320 0zM186.9 348.6c-8.3 25 15.5 48.8 40.5 40.5l111-37-30-23.7-91.1 30.4 27-80.9-26.7-21.1-30.6 91.9zM301.6 159.9l30 23.7 91.1-30.4-27 80.9 26.7 21.1 30.6-91.9c8.3-25-15.5-48.8-40.5-40.5l-111 37zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faClockOne = {
  prefix: 'fal',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112v91.2l34.7-52c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-64 96c-3.9 5.9-11.2 8.5-17.9 6.4s-11.4-8.3-11.4-15.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFileMusic = {
  prefix: 'fal',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM304 232c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V291.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V232zM256 392c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12zM128 424c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12z"]
};
var faCodeCommit = {
  prefix: 'fal',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", "M320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm127-80c-7.9 63.1-61.7 112-127 112s-119.1-48.9-127-112H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H193c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H447z"]
};
var faTemperatureLow = {
  prefix: 'fal',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64V252.7c0 14.9 7 27.7 16 36.9c19.8 20.2 32 47.9 32 78.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4c9-9.2 16-22 16-36.9V96zM176 0C123 0 80 43 80 96V252.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8c-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faPersonBiking = {
  prefix: 'fal',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", "M392 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 392 0a56 56 0 1 0 0 112zM224 384A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM608 384a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM309.1 166.4c6.1-5.2 15.1-5.1 21.1 .3l59.1 53.2c2.9 2.6 6.8 4.1 10.7 4.1h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H406.1l-54.5-49.1c-17.9-16.1-45-16.5-63.3-.8l-59.1 50.6c-23.9 20.5-21.9 58.1 4 76L320 328.4V416c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-5.3-2.6-10.2-6.9-13.2l-93.7-64.4c-8.7-6-9.3-18.5-1.3-25.3l59.1-50.6z"]
};
var faBiking = faPersonBiking;
var faDisplayChartUpCircleCurrency = {
  prefix: 'fal',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M64 32H512c17.7 0 32 14.3 32 32V198.6c11.2 3.2 21.9 7.4 32 12.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H213.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h72H360h34.8c-12.9-9.1-24.5-19.9-34.6-32H341.1 288 234.9l10.7-64H288h38.6c-2.9-10.3-4.9-21-5.9-32H232.3c-.2 0-.4 0-.6 0H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM480 192.7V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6v48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM470.6 342.6a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3c21.6 13.2 49.1 13.2 70.7 0z"]
};
var faSkeleton = {
  prefix: 'fal',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M256 0c8.8 0 16 7.2 16 16V64H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v64H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v64H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v75.4l86.6-24.7c6.3-1.8 12.8-2.7 19.3-2.7c38.8 0 70.2 31.4 70.2 70.2v5.2c0 18.5-6.8 36.3-19 50.1l-26.9 30.2c-11.5 12.9-28 20.3-45.3 20.3H155.2c-17.3 0-33.8-7.4-45.3-20.3L83 461.4c-12.3-13.8-19-31.6-19-50.1v-5.2c0-38.8 31.4-70.2 70.2-70.2c6.5 0 13 .9 19.3 2.7L240 363.4V288H128c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V192H32c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V96H96c-8.8 0-16-7.2-16-16s7.2-16 16-16H240V16c0-8.8 7.2-16 16-16zM96 406.2v5.2c0 10.6 3.9 20.9 11 28.8l26.9 30.2c5.4 6.1 13.2 9.6 21.4 9.6H356.8c8.2 0 15.9-3.5 21.4-9.6L405 440.2c7.1-7.9 11-18.2 11-28.8v-5.2c0-21.1-17.1-38.2-38.2-38.2c-3.5 0-7.1 .5-10.5 1.5l-93.8 26.8c-11.5 3.3-23.7 3.3-35.2 0l-93.8-26.8c-3.4-1-6.9-1.5-10.5-1.5C113.1 368 96 385.1 96 406.2zM160 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCircleG = {
  prefix: 'fal',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96c24.6 0 47 9.2 64 24.4c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h62.7c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96z"]
};
var faCircleArrowUpLeft = {
  prefix: 'fal',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-352H176c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16s16-7.2 16-16V214.6L324.7 347.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 192H312c8.8 0 16-7.2 16-16s-7.2-16-16-16z"]
};
var faCoinBlank = {
  prefix: 'fal',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M90.7 281.9C49 258.5 32 231.1 32 208s17-50.5 58.7-73.9C131.4 111.2 189.8 96 256 96s124.6 15.2 165.3 38.1C463 157.5 480 184.9 480 208s-17 50.5-58.7 73.9C380.6 304.8 322.2 320 256 320s-124.6-15.2-165.3-38.1zM240 351.7l0 64c-22.5-.7-44-3-64-6.6l0-64.3c20.3 3.8 41.8 6.1 64 6.9zM96 320.4c14.8 6.7 30.8 12.4 48 17.1l0 64.6c-17.7-4.7-33.8-10.5-48-17l0-64.7zM64 303.2l0 63.6c-23.5-16.9-32-34-32-46.8l0-42.2c9 9.2 19.8 17.7 32 25.5zM272 415.7l0-64c22.2-.8 43.7-3.1 64-6.9l0 64.3c-20 3.6-41.5 5.8-64 6.6zM448 303.2c12.2-7.8 23-16.3 32-25.5l0 42.2c0 12.9-8.5 29.9-32 46.8l0-63.6zm-32 17.2l0 64.7c-14.2 6.5-30.3 12.3-48 17l0-64.6c17.2-4.7 33.2-10.5 48-17.1zM256 64C114.6 64 0 128.5 0 208l0 32 0 80c0 70.7 114.6 128 256 128s256-57.3 256-128l0-80 0-32c0-79.5-114.6-144-256-144z"]
};
var faBroom = {
  prefix: 'fal',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M571.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-208 208-45.3-45.3c-4.8-4.8-11.2-7.4-17.9-7.4c-12.4 0-23 9-25 21.2l-9.1 54.7-9.8-1.4c-46.3-6.6-93 9-126 42L97 287c-21.1 21.1-33 49.8-33 79.7c0 1.3 .1 2.5 .4 3.7C66.1 378.2 73 384 81.3 384H96L81.3 398.7l-15 15L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512l171.9 0c39.4 0 77.2-15.6 105-43.5c33.1-33.1 48.6-79.7 42-126l-1.4-9.8 54.7-9.1c12.2-2 21.2-12.6 21.2-25c0-6.7-2.7-13.2-7.4-17.9l-45.3-45.3 208-208zM274.7 242.7l7.2-43.5 94.9 94.9-43.5 7.2-58.7-58.7zM229 266.2l24.7 3.5 52.6 52.6 3.5 24.7c5.2 36.3-7 72.9-33 98.9C255 467.7 225.4 480 194.5 480L45.3 480l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9c-4.8-11.5-15.8-19.2-28.2-19.7c2.9-16 10.7-30.8 22.3-42.4l10.5-10.5c25.9-25.9 62.6-38.1 98.9-33z"]
};
var faVacuum = {
  prefix: 'fal',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M192.4 89.2C203.2 37.2 249 0 302.1 0H528c61.9 0 112 50.1 112 112c0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320V448c0 35.3-28.7 64-64 64H468.7c10.4-9.2 19.2-20 26.2-32H544c17.7 0 32-14.3 32-32V320c0-88.4-71.6-160-160-160c-17.7 0-32 14.3-32 32v96c-11 0-21.8 1.4-32 4V192c0-35.3 28.7-64 64-64c54.6 0 103.9 22.8 138.8 59.4c31-11 53.2-40.6 53.2-75.4c0-44.2-35.8-80-80-80H302.1c-37.9 0-70.6 26.6-78.3 63.7L197 224H164.3L192.4 89.2zM157.7 256h32.7L163.7 384.1C197.3 386 224 413.9 224 448c0 35.3-28.7 64-64 64H24.2C10.8 512 0 501.2 0 487.8c0-5.2 .8-10.4 2.5-15.3l7.6-22.9C23.2 410.4 59.9 384 101.2 384H131l26.7-128zM144.3 416c-.2 0-.4 0-.6 0H101.2c-27.5 0-52 17.6-60.7 43.8L33.7 480H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H144.3zM448 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faShieldHeart = {
  prefix: 'fal',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM162.3 214.2c0-19.6 15.9-35.5 35.5-35.5c9.5 0 18.7 3.8 25.4 10.7l21.4 21.9c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8l21.4-21.9c6.7-6.8 15.8-10.7 25.4-10.7c19.6 0 35.5 15.9 35.5 35.5v1.5c0 9.7-3.8 19-10.6 25.9L256 326.5l-83.1-84.9c-6.8-6.9-10.6-16.2-10.6-25.9v-1.5zm35.5-67.5c-37.3 0-67.5 30.2-67.5 67.5v1.5c0 18.1 7.1 35.4 19.7 48.3l94.6 96.5c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8L362 264c12.6-12.9 19.7-30.2 19.7-48.3v-1.5c0-37.3-30.2-67.5-67.5-67.5c-18.1 0-35.5 7.3-48.2 20.3l-10 10.2-10-10.2c-12.7-13-30.1-20.3-48.2-20.3z"]
};
var faCardHeart = {
  prefix: 'fal',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 221.3c0 7.8 3.1 15.2 8.6 20.7L192 313.4l71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0l-18.7-18.7c-5.5-5.5-12.9-8.6-20.7-8.6c-16.2 0-29.3 13.1-29.3 29.3zM141.3 160c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
var faLightbulbCflOn = {
  prefix: 'fal',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M23.2 1.7l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32C.9 26.4-2.3 16.7 1.7 8.8S15.3-2.3 23.2 1.7zm608 28.6l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-8.8 0-16-7.2-16-16s7.2-16 16-16zM87.2 318.3l-64 32c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm480-28.6l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM267.9 4.5C302.5-4.1 336 22 336 57.7c0 3.4-.3 6.8-.9 10l76.8-19.2C446.5 39.9 480 66 480 101.7c0 15.6-6.6 29.9-17.3 40c10.6 9.9 17.3 24 17.3 40c0 15.6-6.6 29.9-17.3 40c10.6 9.9 17.3 24 17.3 40c0 25.1-17.1 47.1-41.5 53.2L368 332.5V352h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H336v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H256c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32h16V317.5l32-8V352h32V320c0-7.3 5-13.7 12.1-15.5l82.6-20.7c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.9-25.7-28.3-22.1l-63.8 15.9-64 16-.1 0-63.7 15.9C193.5 296.1 160 270 160 234.3c0-15.6 6.6-29.9 17.3-40c-10.6-9.9-17.3-24-17.3-40c0-15.6 6.6-29.9 17.3-40c-10.6-9.9-17.3-24-17.3-40c0-25.1 17.1-47.1 41.5-53.2L267.9 4.5zm84 379.5H256v64H384V384H352.1l-.1 0-.1 0zM284.1 240.5l146.6-36.7c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.8-25.6-28.2-22.2L228.1 207.5l-.2 .1-18.6 4.6c-10.2 2.5-17.3 11.7-17.3 22.1c0 14.8 13.9 25.7 28.3 22.1l63.8-15.9zm10.4-129.6l-66.4 16.6-.1 0-18.8 4.7c-10.2 2.5-17.3 11.7-17.3 22.1c0 14.8 13.8 25.6 28.2 22.2l191.7-47.9 .2-.1 18.6-4.6c10.2-2.5 17.3-11.7 17.3-22.1c0-14.8-13.9-25.7-28.3-22.1L294.6 110.9l-.1 0zM304 57.7c0-14.8-13.9-25.7-28.3-22.1L209.3 52.2C199.1 54.7 192 63.8 192 74.3c0 14.8 13.9 25.7 28.3 22.1l0 0 66.4-16.6 0 0C296.9 77.3 304 68.2 304 57.7z"]
};
var faMelon = {
  prefix: 'fal',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M480 256c0-35.8-8.4-69.7-23.4-99.7c-8.4 56.6-47.7 127.6-110.2 190.1S212.9 448.2 156.3 456.6c30 14.9 63.9 23.4 99.7 23.4c123.7 0 224-100.3 224-224zM55.4 355.7c8.4-56.6 47.7-127.6 110.2-190.1S299.1 63.8 355.7 55.4C325.7 40.4 291.8 32 256 32C132.3 32 32 132.3 32 256c0 35.8 8.4 69.7 23.4 99.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM414.3 97.7c-11.8-11.8-38.7-18.4-84.2-3.2c-43.5 14.5-94.7 46.5-142 93.8s-79.3 98.5-93.8 142c-15.2 45.5-8.6 72.4 3.2 84.2s38.7 18.4 84.2 3.2c43.5-14.5 94.7-46.5 142-93.8s79.3-98.5 93.8-142c15.2-45.5 8.6-72.4-3.2-84.2z"]
};
var faGopuram = {
  prefix: 'fal',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M112 0c8.8 0 16 7.2 16 16V32h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V32h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V32h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16V32 64 80v48 2.7c18.6 6.6 32 24.4 32 45.3v48c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3v80c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3v64c0 26.5-21.5 48-48 48H320 288 224 192 48c-26.5 0-48-21.5-48-48V400c0-20.9 13.4-38.7 32.1-45.3c-.1-.9-.1-1.8-.1-2.7V272c0-20.9 13.4-38.8 32.1-45.3c-.1-.9-.1-1.8-.1-2.7V176c0-20.9 13.4-38.7 32-45.3V128 80 64 32 16c0-8.8 7.2-16 16-16zM224 480h64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 0h64V384H352 304 272 240 208 160 128v96h64c0-35.3 28.7-64 64-64s64 28.7 64 64zM128 80v48H384V80 64H128V80zm-16 80c-8.8 0-16 7.2-16 16l0 48h64V160H128 112zm48 96v96h48V336c0-26.5 21.5-48 48-48s48 21.5 48 48v16h48V256H320 272 240 192 160zm112-48v16h48V160H192v64h48V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 144V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h32zM416 224V176c0-8.8-7.2-16-16-16H384 352v64h64zm0 32H384v96h64V272c0-8.8-7.2-16-16-16H416zm0 224h48c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H448 416v96zM128 256H96 80c-8.8 0-16 7.2-16 16v80h64V256zM96 384H64 48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H96V384z"]
};
var faEarthOceania = {
  prefix: 'fal',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm16.7-303.5c-5-1.3-10.3 0-14.3 3.3l-25.2 21.5c-1.9 1.6-4.4 2.2-6.8 1.7l-.3-.1-4-5.3C211.8 216 195.8 208 178.7 208s-33.1 8-43.4 21.7l-5.3 7L94.7 253.5C66 267.1 54.4 302 69.2 330.1l3.3 6.2c12.6 24 40.6 35.5 66.5 27.3l20.4-6.5L205.2 373l27 17.4c9.6 6.2 20.9 9.5 32.3 9.5c18.4 0 35.7-8.4 47-22.9l12.1-15.4c8-10.2 12.4-22.9 12.4-35.9s-4.4-25.6-12.4-35.9l-18-22.9c-3.8-4.9-6.9-10.3-9.2-16.1l-12.8-32.7c-1.9-4.8-6-8.4-11-9.7zm-94 31.5c7 0 13.6 3.3 17.8 8.9l4 5.3c4.7 6.2 11.5 10.6 19.2 12.1l.3 .1c12.1 2.5 24.6-.8 34-8.7l8.1-6.9 4.6 11.8c3.4 8.7 8 16.8 13.8 24.2l17.9 22.9c3.6 4.6 5.6 10.3 5.6 16.1s-2 11.5-5.6 16.1l-12.1 15.4c-5.2 6.7-13.3 10.6-21.8 10.6c-5.3 0-10.5-1.5-15-4.4l-28.7-18.5c-1.1-.7-2.2-1.3-3.5-1.7l-52.7-18.2c-3.3-1.1-6.8-1.2-10.1-.1l-25.4 8.1c-11.1 3.5-23.1-1.4-28.5-11.7l-3.3-6.2c-6.3-12.1-1.4-27 10.9-32.8l35.3-16.8c4.7-2.2 8.7-5.5 11.8-9.7l5.3-7c4.2-5.6 10.8-8.9 17.8-8.9zm103-114.6c-12.4-14.4-32.1-20.2-50.2-14.7l-43.1 12.9c-19.8 5.9-23.3 32.4-5.8 43.3l39.4 24.6c9.4 5.8 20.4 8.3 31.4 6.9l37.9-4.7c19-2.4 27.7-24.9 15.2-39.4l-24.8-28.9zm-41 15.9c6.1-1.8 12.6 .1 16.7 4.9l15.1 17.6-23.2 2.9c-3.6 .5-7.3-.4-10.5-2.3l-24.4-15.2 26.2-7.9zM248 432c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H264c-8.8 0-16 7.2-16 16zM431.2 306.9c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l8 24c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-8-24zm-19.9 80.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
var faGlobeOceania = faEarthOceania;
var faContainerStorage = {
  prefix: 'fal',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H32V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 592h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H592 48 16zM64 448V64H576V448H64zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faFacePouting = {
  prefix: 'fal',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm85.3-102.7c4.5-3.5 8.4-8.6 10-15.1c1.6-6.7 .5-13.5-2.7-19.5C331.2 342 296.1 320 256 320c-40.1 0-75.1 22-92.5 54.7c-3.2 6-4.3 12.8-2.7 19.5c1.6 6.5 5.4 11.6 10 15.1c8.8 6.8 21.2 8.7 32.4 4.5c16.2-6.1 34-9.4 52.9-9.4c18.9 0 36.7 3.4 52.9 9.4c11.2 4.2 23.6 2.4 32.4-4.5zm-25.7-27.1c-18.5-6.4-38.6-9.9-59.6-9.9c-20.9 0-41 3.5-59.6 9.8C209.4 364 231.1 352 256 352s46.7 12.1 59.6 30.2zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faSquareXmark = {
  prefix: 'fal',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm148.7 84.7c6.2-6.2 16.4-6.2 22.6 0L224 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faFaceExplode = {
  prefix: 'fal',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M296 32c-11.2 0-21.3 4.6-28.6 12c-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8c-7.3-7.4-17.4-12-28.6-12c-22.1 0-40 17.9-40 40v4.2c0 6.3-3.7 12-9.5 14.6s-12.5 1.5-17.2-2.7C143.7 83.1 136.2 80 128 80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 16 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H221.3c1.8 5 2.7 10.4 2.7 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8-7.2-16-16-16H160 128c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.7 0 13.1 1 19.1 2.9C156.2 21.4 183.6 0 216 0c14.8 0 28.6 4.5 40 12.1C267.4 4.5 281.2 0 296 0c32.4 0 59.8 21.4 68.9 50.9c6-1.9 12.5-2.9 19.1-2.9c35.3 0 64 28.7 64 64s-28.7 64-64 64H336c-8.8 0-16 7.2-16 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-26.5 21.5-48 48-48h48c17.7 0 32-14.3 32-32s-14.3-32-32-32c-8.2 0-15.7 3.1-21.3 8.1c-4.7 4.2-11.4 5.3-17.2 2.7s-9.5-8.3-9.5-14.6V72c0-22.1-17.9-40-40-40zM32 260.3c3.1-.7 6.1-1.8 9-3.4l28.7-16.1c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0L411 240.8c9.7-5.5 21.6-5.5 31.4 0L471 256.9c2.8 1.6 5.8 2.7 9 3.4c5.7 1.2 11.6 .9 17.2-1l9.5-3.3 5.3-1.8 0 1.8c0 11.1-.7 22-2.1 32.7C493.9 414.7 386.3 512 256 512S18.1 414.7 2.1 288.7C.7 278 0 267.1 0 256l0-1.8L5.3 256l9.5 3.3c5.6 1.9 11.5 2.3 17.2 1zm53.3 8.4L56.7 284.8c-6.8 3.8-14.2 6.3-21.8 7.5C52.3 398.8 144.7 480 256 480s203.7-81.2 221.1-187.7c-7.6-1.2-14.9-3.7-21.8-7.5l-28.7-16.1-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.5-14.4-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.5-14.4-25.5 14.4c-19.5 11-43.3 11-62.8 0L85.3 268.7zm91 43.3a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 352c35.3 0 64 28.7 64 64v5.3c0 14.7-11.9 26.7-26.7 26.7H218.7c-14.7 0-26.7-11.9-26.7-26.7V416c0-35.3 28.7-64 64-64zm-32 64h64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faExplodingHead = faFaceExplode;
var faHashtag = {
  prefix: 'fal',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", "M207.6 51.6c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h98L109.1 336H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.7L80.4 460.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H261.7l-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H302l36.9-160H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.3l21.3-92.4c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H186.3l21.3-92.4zM178.9 176H306L269.1 336H142l36.9-160z"]
};
var faUpRightAndDownLeftFromCenter = {
  prefix: 'fal',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M321 0c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L428 186.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33V32c0-17.7-14.3-32-32-32H321zm-1 33c0-.5 .4-1 1-1H480V191c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512H191c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4 56.3 297.7C50.1 291.5 41.7 288 33 288c-18.2 0-33 14.8-33 33V480c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1H32V321c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2 .2 .3 .4 .3 .7z"]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faOilCan = {
  prefix: 'fal',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M336 96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0v64H128 96 48c-26.5 0-48 21.5-48 48v62.7c0 20 12.4 37.9 31.1 44.9L96 340v28c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H272V96l64 0zm97.7 124.6c6.5 3.2 13.9 4.2 21 2.7l129.1-27.7L427.1 373.2c-6.1 6.9-14.8 10.8-24 10.8H144c-8.8 0-16-7.2-16-16V352 317.8 192H368.9c5 0 9.9 1.2 14.3 3.4l50.5 25.2zM96 305.8L42.4 285.7c-6.2-2.3-10.4-8.3-10.4-15V208c0-8.8 7.2-16 16-16H96V305.8z"]
};
var faT = {
  prefix: 'fal',
  iconName: 't',
  icon: [384, 512, [116], "54", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16H176V464c0 8.8 7.2 16 16 16s16-7.2 16-16V64H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H192 16z"]
};
var faTransformerBolt = {
  prefix: 'fal',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V16zM48 112c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H32V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H48 336h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H352V192h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H336 48 16zM64 480V192H320V480H64zm78.6-144l61.9-61.9-4.4 44.3c-.4 4.5 1 9 4.1 12.3s7.3 5.3 11.9 5.3h25.4l-61.9 61.9 4.4-44.3c.4-4.5-1-9-4.1-12.3s-7.3-5.3-11.9-5.3H142.6zm75.6-112c-5.6 0-11 2.2-15 6.2L102.3 331c-4.1 4.1-6.3 9.6-6.3 15.3c0 12 9.7 21.7 21.7 21.7h32.7l-5.7 56.6c-1.3 12.5 8.6 23.4 21.2 23.4c5.6 0 11-2.2 15-6.2L281.7 341c4.1-4.1 6.3-9.6 6.3-15.3c0-12-9.7-21.7-21.7-21.7H233.7l5.7-56.6c1.3-12.5-8.6-23.4-21.2-23.4z"]
};
var faHippo = {
  prefix: 'fal',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M427.3 44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l12.1 12.1c-4.4 3.2-8.4 6.8-12 10.8L382 81.2C353.6 69.8 323.4 64 292.9 64H224C118 64 32 150 32 256v8 0l0 19.1c0 25.4-8.7 50.1-24.5 70L3.5 358C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90L64 264v0-8c0-88.4 71.6-160 160-160h68.9c26.5 0 52.7 5 77.2 14.9l18.2 7.3c-2.8 8.1-4.3 16.8-4.3 25.9v5c0 9.5-4.5 18.4-10.8 25.6C360 190.1 352 210.1 352 232c0 45.9 35.1 83.6 80 87.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V320h88c2.7 0 5.4-.1 8-.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16V310.4c28.5-14.6 48-44.2 48-78.4c0-30.8-15.8-57.8-39.7-73.6c-4.9-3.2-8.3-8.5-8.3-14.4c0-22.4-9.2-42.7-24.1-57.3l11.4-11.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L540.2 69.1C531.5 65.8 521.9 64 512 64H464c-5.4 0-10.7 .5-15.8 1.6L427.3 44.7zM448 288h-8c-30.9 0-56-25.1-56-56c0-14 5.1-26.7 13.5-36.5c9.2-10.7 18.5-26.7 18.5-46.5v-5c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48c0 13.4 5.5 24.7 13.2 33c-25.7 5.1-45.2 27.7-45.2 55c0 8.8 7.2 16 16 16s16-7.2 16-16c0-13.3 10.7-24 24-24s24 10.7 24 24c0 30.9-25.1 56-56 56H448zm-32 83.8V424c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V363.9c0-5.1-2.4-9.9-6.5-12.9s-9.4-3.9-14.3-2.4l-11.3 3.6c-31.2 9.8-64.6 9.8-95.8 0l-11.3-3.6c-4.9-1.5-10.2-.6-14.3 2.4s-6.5 7.8-6.5 12.9V424c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V352c0-8.8-7.2-16-16-16s-16 7.2-16 16v72c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V385.4c31.5 8.1 64.5 8.1 96 0V424c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V384c-12.3 0-23.5-4.6-32-12.2zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-40 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c13.3 0 24 10.7 24 24c0 8.8 7.2 16 16 16s16-7.2 16-16c0-30.9-25.1-56-56-56zm88-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faChartColumn = {
  prefix: 'fal',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 256c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16zM256 144V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 48c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112-80V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCassetteVhs = {
  prefix: 'fal',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", "M32 160V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V160H32zm0-32H544V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96v32zM576 96v32 16 16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160 144 128 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64zM136 208h72H368h72c3.5 0 6.9 1.1 9.7 3.3L440 224c9.7-12.7 9.7-12.7 9.7-12.7l0 0 0 0 .1 0 .2 .1 .5 .4c.4 .3 1 .8 1.6 1.3c1.3 1.1 3.2 2.7 5.3 4.8c4.3 4.1 9.9 10.2 15.6 18c11.3 15.5 23 38.8 23 68s-11.8 52.5-23 68c-5.7 7.8-11.3 13.8-15.6 18c-2.1 2.1-4 3.7-5.3 4.8c-.7 .6-1.2 1-1.6 1.3l-.5 .4-.2 .1-.1 0 0 0 0 0s0 0-9.7-12.7l9.7 12.7c-2.8 2.1-6.2 3.3-9.7 3.3H368 208 136c-3.5 0-6.9-1.1-9.7-3.3L136 384c-9.7 12.7-9.7 12.7-9.7 12.7l0 0 0 0-.1 0-.2-.1-.5-.4c-.4-.3-1-.8-1.6-1.3c-1.3-1.1-3.2-2.7-5.3-4.8c-4.3-4.1-9.9-10.2-15.6-18c-11.3-15.5-23-38.8-23-68s11.8-52.5 23-68c5.7-7.8 11.3-13.8 15.6-18c2.1-2.1 4-3.7 5.3-4.8c.7-.6 1.2-1 1.6-1.3l.5-.4 .2-.1 .1 0 0 0 0 0s0 0 9.7 12.7l-9.7-12.7c2.8-2.1 6.2-3.3 9.7-3.3zm4.9 33c-3.2 3.1-7.6 7.8-11.9 13.7c-8.7 12.1-17 28.8-17 49.2s8.2 37.2 17 49.2c4.3 6 8.7 10.6 11.9 13.7c.4 .4 .7 .7 1.1 1H192V336c-17.7 0-32-14.3-32-32s14.3-32 32-32V240H141.9c-.3 .3-.7 .7-1.1 1zM352 368V240H224V368H352zm82.1 0c.3-.3 .7-.7 1.1-1c3.2-3.1 7.6-7.8 11.9-13.7c8.7-12.1 17-28.8 17-49.2s-8.2-37.2-17-49.2c-4.3-6-8.7-10.6-11.9-13.7c-.4-.4-.7-.7-1.1-1H384v32c17.7 0 32 14.3 32 32s-14.3 32-32 32v32h50.1z"]
};
var faVhs = faCassetteVhs;
var faInfinity = {
  prefix: 'fal',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 233.5C0 157.5 61.5 96 137.5 96c39.3 0 76.7 16.8 102.7 46.1L320 231.9l79.8-89.8C425.9 112.8 463.3 96 502.5 96C578.5 96 640 157.5 640 233.5v45.1C640 354.5 578.5 416 502.5 416c-39.3 0-76.7-16.8-102.7-46.1L320 280.1l-79.8 89.8C214.1 399.2 176.7 416 137.5 416C61.5 416 0 354.5 0 278.5V233.5zM298.6 256l-82.3-92.6c-20-22.5-48.7-35.4-78.8-35.4C79.2 128 32 175.2 32 233.5v45.1C32 336.8 79.2 384 137.5 384c30.1 0 58.8-12.9 78.8-35.4L298.6 256zm42.8 0l82.3 92.6c20 22.5 48.7 35.4 78.8 35.4C560.8 384 608 336.8 608 278.5V233.5C608 175.2 560.8 128 502.5 128c-30.1 0-58.8 12.9-78.8 35.4L341.4 256z"]
};
var faVialCircleCheck = {
  prefix: 'fal',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M0 48c0-8.8 7.2-16 16-16H32 64 192h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H224V266.8c-20.2 28.6-32 63.5-32 101.2V224H64V384c0 35.3 28.7 64 64 64s64-28.7 64-64V368c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V64H16C7.2 64 0 56.8 0 48zM64 64V192H192V64H64zM368 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faChimney = {
  prefix: 'fal',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M32 64H416v64H400 176 48 32V64zm0 96l0 112V400v64c0 8.8 7.2 16 16 16s16-7.2 16-16V416h96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h80H384v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 272 160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32zm352 0v96H272 192V160H384zm-224 0v96H64V160h96zm16 224H64V288H176h80v96H176zm112 0V288h96v96H288z"]
};
var faObjectIntersect = {
  prefix: 'fal',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M96 32H64C46.3 32 32 46.3 32 64V96H0V64C0 28.7 28.7 0 64 0H96V32zm32 0V0h96V32H128zM0 128H32v96H0V128zM288 32H256V0h32c35.3 0 64 28.7 64 64v64H320V64c0-17.7-14.3-32-32-32zm32 128h32v32 64 32c0 35.3-28.7 64-64 64H224 192 160V320 256 224c0-35.3 28.7-64 64-64h64 32zM160 384h32v64c0 17.7 14.3 32 32 32h32v32H224c-35.3 0-64-28.7-64-64V384zm-32-32H64c-35.3 0-64-28.7-64-64V256H32v32c0 17.7 14.3 32 32 32h64v32zM384 192V160h64c35.3 0 64 28.7 64 64v32H480V224c0-17.7-14.3-32-32-32H384zM288 512V480h96v32H288zm160 0H416V480h32c17.7 0 32-14.3 32-32V416h32v32c0 35.3-28.7 64-64 64zm64-128H480V288h32v96zM224 192c-17.7 0-32 14.3-32 32v96h96c17.7 0 32-14.3 32-32V192H224z"]
};
var faPersonArrowDownToLine = {
  prefix: 'fal',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM179.3 160h25.4c6.8 0 13.3 1.4 19.3 4V320H160V164c6-2.6 12.5-4 19.3-4zM160 480V352h64V480H160zm-32 0H16c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0h96l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7L275.3 170.3c-13.9-26-41-42.3-70.6-42.3H179.3c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L128 202.1V480zM480 48l0 313.4-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L512 361.4 512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faVoicemail = {
  prefix: 'fal',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM288 240c0 45.2-20.9 85.6-53.5 112h171C372.9 325.6 352 285.2 352 240c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144H144C64.5 384 0 319.5 0 240S64.5 96 144 96s144 64.5 144 144zM496 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faBlockBrick = {
  prefix: 'fal',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M136 64v64h72 32 72V64H136zm-32 0H64C46.3 64 32 78.3 32 96v32h72V64zM32 160v80h72 32 72V160H32zm0 192h72V272H32v80zm0 32v32c0 17.7 14.3 32 32 32H208V384H136 104 32zm104-32H312V272H136v80zm208 0h72V272H344v80zm72 32H344 312 240v64H384c17.7 0 32-14.3 32-32V384zm0-224H240v80h72 32 72V160zm0-32V96c0-17.7-14.3-32-32-32H344v64h72zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faWallBrick = faBlockBrick;
var faFan = {
  prefix: 'fal',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M242.5 134.2c-1.1 10.6 3.2 21 11.4 27.8s19.2 9.1 29.4 6.1c16.9-4.9 39.3-8.2 68.8-8.2l.1 0c59.5-.2 108.2 37.9 123.1 92.2l-97.5-9.7c-10.6-1.1-21 3.2-27.8 11.4s-9.1 19.2-6.2 29.4c4.9 16.9 8.2 39.3 8.2 68.8l0 .1c.2 59.5-37.9 108.2-92.2 123.1l9.7-97.5c1.1-10.6-3.2-21-11.4-27.8s-19.2-9.1-29.4-6.1c-16.9 4.9-39.3 8.2-68.8 8.2l-.1 0c-59.5 .2-108.2-37.9-123.1-92.2l97.5 9.7c10.6 1.1 21-3.2 27.8-11.4s9.1-19.2 6.1-29.4c-4.9-16.9-8.2-39.3-8.2-68.8l0-.1c-.2-59.5 37.9-108.2 92.2-123.1l-9.7 97.5zM480.1 252.7s0 0 0 0l0 0zM32 259.3l0 0c0 0 0 0 0 0zM252.7 32l0 0c0 0 0 0 0 0zm21.6 105.5l3.4-33.9 6.8-68.3c1.9-18.8-13.1-35.5-31.6-31.5C179.9 19.2 127.7 82.7 128 160c0 16.6 1 31.5 2.7 44.9c1.6 12.2 3.9 23.1 6.7 32.8l-33.9-3.4-68.3-6.8C16.4 225.6-.3 240.6 3.7 259.1C19.2 332.2 82.8 384.3 160 384c16.6 0 31.5-1 44.9-2.7c12.2-1.6 23.1-3.9 32.8-6.7l-3.4 33.9-6.8 68.3c-1.9 18.8 13.1 35.5 31.6 31.5C332.2 492.8 384.3 429.3 384 352c0-16.6-1-31.5-2.7-44.9c-1.6-12.2-3.9-23.1-6.7-32.8l33.9 3.4 68.3 6.8c18.8 1.9 35.5-13.1 31.5-31.6C492.8 179.8 429.3 127.7 352 128c-16.6 0-31.5 1-44.9 2.7c-12.2 1.6-23.1 3.9-32.8 6.7zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBagsShopping = {
  prefix: 'fal',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M160 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64H160V96zm-32 64H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64h96V448H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64H320V96c0-53-43-96-96-96s-96 43-96 96v64zM512 288c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32H512zM192 320V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64zm128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 35.3-28.7 64-64 64s-64-28.7-64-64V336z"]
};
var faParagraphLeft = {
  prefix: 'fal',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", "M320 32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H224 208 176 144C82.1 0 32 50.1 32 112s50.1 112 112 112h48v80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80V208 32h64V304c0 8.8 7.2 16 16 16s16-7.2 16-16V32zM192 32V192H144c-44.2 0-80-35.8-80-80s35.8-80 80-80h32 16zM122.2 348.3c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80C2.1 406.7 0 411.3 0 416s2.1 9.3 5.8 12.3l96 80c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L60.2 432H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.2l62.1-51.7z"]
};
var faParagraphRtl = faParagraphLeft;
var faPersonWalkingLuggage = {
  prefix: 'fal',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M400 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 368 56a56 56 0 1 0 112 0zM341.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L433.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L464.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L411.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm-94.8-63.4c-7.5-4.6-17.4-2.2-22 5.3l-25.2 41.4c-.6-.4-1.1-.7-1.7-1.1L144 304c-15.3-8.8-34.9-3.6-43.7 11.7l-64 110.9c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l36.3-62.9 70.2-115.3c4.6-7.5 2.2-17.4-5.3-22zM118 473.7L64 442.6l64-110.9 55.4 32-27.5 47.6-38 62.4z"]
};
var faCaravanSimple = {
  prefix: 'fal',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M80 64c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h21.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H544V192c0-70.7-57.3-128-128-128H80zM96 416H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V384l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0H544 288c0 53-43 96-96 96s-96-43-96-96zM256 160H128v64H256V160zM128 128H256c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm224 32v64h64V160H352zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V160zM256 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faCaravanAlt = faCaravanSimple;
var faTurtle = {
  prefix: 'fal',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M200 64C124.9 64 64 124.9 64 200v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-92.8 75.2-168 168-168s168 75.2 168 168v40c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-75.1-60.9-136-136-136zM400 188.6c0-42.3 34.3-76.6 76.6-76.6c54.9 0 99.4 44.5 99.4 99.4V224c0 35.3-28.7 64-64 64H491.5c-20.3 57.4-74.7 96-135.8 96H352v48c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V384H192v48c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384H48c-26.5 0-48-21.5-48-48s21.5-48 48-48H360c22.1 0 40-17.9 40-40V188.6zM256 416v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416 384 352h35.7c48.2 0 91-30.8 106.3-76.6l2.8-8.5c2.2-6.5 8.3-10.9 15.2-10.9h32c17.7 0 32-14.3 32-32V211.4c0-37.2-30.2-67.4-67.4-67.4C452 144 432 164 432 188.6V248c0 39.8-32.2 72-72 72H320 256 160 96 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v32 32 16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416 384 352h96v32 32zM480 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPencilMechanical = {
  prefix: 'fal',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", "M440 0c-9.4 0-18.3 3.7-25 10.3L376.4 48.9c-2.7-.6-5.6-.9-8.4-.9c-10.2 0-20.1 4.1-27.3 11.3L311.3 88.7 281.9 59.3c-18.7-18.7-49.1-18.7-67.9 0L108.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L236.7 81.9c6.2-6.2 16.4-6.2 22.6 0l29.4 29.4L80.4 319.7c-5.5 5.5-9.6 12.2-11.9 19.6L32 456l.7 .7-28 28c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28-28 .7 .7 116.7-36.5c7.4-2.3 14.1-6.4 19.6-11.9L452.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3c0-2.9-.3-5.7-.9-8.4L501.7 97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L465 10.3C458.3 3.7 449.4 0 440 0zm4.7 108.7L403.3 67.3 437.7 33c.6-.6 1.5-1 2.3-1s1.7 .3 2.3 1L479 69.7c.6 .6 1 1.5 1 2.3s-.3 1.7-1 2.3l-34.3 34.3zm-14.6 30.6c1.2 1.2 1.9 2.9 1.9 4.7s-.7 3.4-1.9 4.7L188.7 390.1l-66.7-66.7L363.3 81.9c1.2-1.2 2.9-1.9 4.7-1.9s3.4 .7 4.7 1.9l57.4 57.4zM99 348.8c.2-.8 .5-1.5 .9-2.3l65.5 65.5c-.7 .4-1.5 .7-2.3 .9L69.9 442.1 99 348.8z"]
};
var faUpDown = {
  prefix: 'fal',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M103.3 9.7C110 3.5 118.8 0 128 0s18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3H192V352h25.7c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7s-18-3.5-24.7-9.7l-91-84C4.5 411.1 0 400.9 0 390.3C0 369.1 17.1 352 38.3 352H64V160H38.3C17.1 160 0 142.9 0 121.7c0-10.7 4.5-20.9 12.3-28.1l91-84zM128 32c-1.1 0-2.2 .4-3 1.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3H80c8.8 0 16 7.2 16 16V368v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 8.8-7.2 16-16 16H38.3c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.8 2-4.6c0-3.5-2.8-6.3-6.3-6.3H176c-8.8 0-16-7.2-16-16v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0V144c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2z"]
};
var faArrowsAltV = faUpDown;
var faCloudMoonRain = {
  prefix: 'fal',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M357.5 109.6c10.8-32.9 36.5-59.3 69.4-71c-17.1 22.5-27.3 50.4-27.3 80.8c0 63.2 44.1 116.1 103.2 130.4c-10.6 3.7-21.9 5.8-33.7 6.2c4.6 9.8 7.9 20.4 9.5 31.5c34-3.1 64.7-17.8 87.8-40.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-5.8 1-11.7 1.5-17.8 1.5c-57.2 0-103.4-45.9-103.4-102.2c0-38.1 21.1-71.4 52.5-89c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-4.1-.3-8.2-.5-12.3-.5C401.2 0 346.7 41.2 327.4 98.5c10.7 2.3 20.7 6.1 30 11.1zM88.6 418.5c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zM112 192c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H98.9c-.1 0-.3 0-.4 0c-.1 0-.1 0-.2 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3C34.6 200.9 0 240.4 0 288c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H365.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 114.6 210.9 96 176 96z"]
};
var faBoothCurtain = {
  prefix: 'fal',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", "M0 32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V32l32 0V0H32C14.3 0 0 14.3 0 32zm288 0V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zM256 448c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c11.7 0 22.6-3.1 32-8.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384 48 32c0-17.7-14.3-32-32-32H208 128C110.3 0 96 14.3 96 32V384c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7zM480 48V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64V48zM384 32V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zM192 384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64V384z"]
};
var faCalendar = {
  prefix: 'fal',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"]
};
var faBoxHeart = {
  prefix: 'fal',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M240 64H342.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128H416V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H208h32zm-32-32H42.1L76.3 83c5.1-11.6 16.6-19 29.2-19H208v96zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM146.7 264.5c14.3-14.3 37.4-14.3 51.7 0l14.3 14.3c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l14.3-14.3c14.3-14.3 37.4-14.3 51.7 0s14.3 37.4 0 51.7L224 393.4l-77.3-77.3c-14.3-14.3-14.3-37.4 0-51.7zM221 241.8c-26.8-26.8-70.2-26.8-96.9 0s-26.8 70.2 0 96.9L201.4 416c12.5 12.5 32.8 12.5 45.3 0l77.3-77.3c26.8-26.8 26.8-70.2 0-96.9s-70.2-26.8-96.9 0l-3 3-3-3z"]
};
var faTrailer = {
  prefix: 'fal',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M56 64H456c13.3 0 24 10.7 24 24V352H282.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H56c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM288 384H616c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V88c0-30.9-25.1-56-56-56H56C25.1 32 0 57.1 0 88V328c0 30.9 25.1 56 56 56H96c0 53 43 96 96 96s96-43 96-96zm-32 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM112 96c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16z"]
};
var faUserDoctorMessage = {
  prefix: 'fal',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", "M128 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 128A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM160 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-96v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V339.8C80.2 354.7 32.6 411.8 32 480H416c-.5-62.4-40.4-115.4-96-135.5v25.8c23.1 6.9 40 28.3 40 53.7v24c0 8.8-7.2 16-16 16H328c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V424c0-25.4 16.9-46.8 40-53.7V337c-5.6-.7-11.4-1-17.2-1H177.2l-1.2 0zM0 481.2C0 383.3 79.3 304 177.2 304h93.6C368.7 304 448 383.3 448 481.2c0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2zM544 192h48c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16V176c0 8.8 7.2 16 16 16h16c17.7 0 32 14.3 32 32v8l44.8-33.6c5.5-4.2 12.3-6.4 19.2-6.4zm-65.1 80.8l-9.6 7.2-8.5 6.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2V269.3v-12V256 224H432c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H544l-64 48-1.1 .8z"]
};
var faUserMdChat = faUserDoctorMessage;
var faBahai = {
  prefix: 'fal',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M287.7 0c7.2 0 13.6 4.9 15.5 11.9l32.2 120.7L437.8 60.8c5.9-4.2 13.9-3.8 19.5 .8s7.3 12.5 4.2 19l-53 113.1 124.6 10.7c7.2 .6 13.1 6 14.4 13.2s-2.4 14.2-9 17.3L425 287.7l88.5 88.2c5.1 5.1 6.2 13 2.6 19.3s-11 9.3-18 7.5L377.3 370.2l11 124.4c.6 7.2-3.7 14-10.5 16.4s-14.4 .1-18.6-5.9L287.7 402.7 216.1 505.2c-4.2 5.9-11.8 8.3-18.6 5.9s-11.1-9.2-10.5-16.4l11-124.4L77.3 402.6c-7 1.9-14.4-1.2-18-7.5s-2.6-14.2 2.6-19.3l88.5-88.2L37 235c-6.6-3.1-10.3-10.1-9-17.3s7.2-12.5 14.4-13.2l124.6-10.7L114 80.7c-3.1-6.6-1.4-14.4 4.2-19s13.5-5 19.5-.8L240 132.6 272.2 11.9c1.9-7 8.2-11.9 15.5-11.9zm0 78L265 162.9c-1.3 5-5.1 9.1-10 10.9s-10.4 1.1-14.7-1.9l-72-50.5L205.6 201c2.2 4.7 2 10.3-.6 14.8s-7.3 7.5-12.5 7.9l-87.6 7.5 79.7 37c4.7 2.2 8.1 6.6 9 11.7s-.8 10.4-4.5 14.1l-62.2 62 84.9-22.8c5-1.4 10.4-.2 14.4 3.2s6.1 8.5 5.7 13.7l-7.8 87.5 50.4-72.1c3-4.3 7.9-6.8 13.1-6.8s10.1 2.6 13.1 6.8l50.4 72.1-7.8-87.5c-.5-5.2 1.6-10.3 5.7-13.7s9.4-4.6 14.4-3.2l84.9 22.8-62.2-62c-3.7-3.7-5.4-9-4.5-14.1s4.3-9.5 9-11.7l79.7-37-87.6-7.5c-5.2-.4-9.9-3.4-12.5-7.9s-2.9-10-.6-14.8L407 121.4l-72 50.5c-4.3 3-9.8 3.7-14.7 1.9s-8.6-5.9-10-10.9L287.7 78z"]
};
var faHaykal = faBahai;
var faLighthouse = {
  prefix: 'fal',
  iconName: 'lighthouse',
  icon: [640, 512, [], "e612", "M23.2 1.7C15.3-2.3 5.6 .9 1.7 8.8s-.7 17.5 7.2 21.5l128 64c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-128-64zm128 188.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-128 64c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l128-64zM312.1 2.1l-112 64c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l8.1-4.6V128h32V71l64-36.6L384 71v57h32V89.3l8.1 4.6c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-112-64c-4.9-2.8-11-2.8-15.9 0zM250.2 192H389.8l57.6 288H384V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H192.6l57.6-288zm-32.6 0l-57 285.2c-.2 .9-.3 1.9-.4 2.8H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h45.1H256h32 64 32 66.9H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H479.9c-.1-.9-.2-1.9-.4-2.8L422.4 192H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 224 208c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.6zM352 416v64H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32zM638.3 8.9c-4-7.9-13.6-11.1-21.5-7.2l-128 64c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l128-64c7.9-4 11.1-13.6 7.2-21.5zm-156.6 160c-4 7.9-.7 17.5 7.2 21.5l128 64c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-128-64c-7.9-4-17.5-.7-21.5 7.2z"]
};
var faAmpGuitar = {
  prefix: 'fal',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M139.6 51.9C168.3 27.2 210.1 0 256 0s87.7 27.2 116.4 51.9c4.8 4.1 9.3 8.2 13.4 12.1H448c35.3 0 64 28.7 64 64V256v16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288 272 256 128C0 92.7 28.7 64 64 64h62.2c4.2-4 8.7-8.1 13.4-12.1zm36 12.1H336.4C312.1 46 284 32 256 32s-56.1 14-80.4 32zM480 288H32V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V288zm0-32V128c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32V256H480zM80 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSdCard = {
  prefix: 'fal',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M352 64V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V154.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4H320c17.7 0 32 14.3 32 32zm32 384V64c0-35.3-28.7-64-64-64H154.5c-17 0-33.3 6.7-45.3 18.7L18.7 109.3C6.7 121.3 0 137.5 0 154.5V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zM192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80z"]
};
var faVolumeSlash = {
  prefix: 'fal',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-59.6-27.2-112.9-69.8-148.1c-6.8-5.6-16.9-4.7-22.5 2.1s-4.7 16.9 2.1 22.5C521.4 161.9 544 206.3 544 256c0 28.7-7.5 55.6-20.8 78.9l25.4 20C566 326 576 292.2 576 256zM472 294.4c5.2-11.8 8-24.8 8-38.4c0-31.4-15.1-59.3-38.4-76.8c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C438 216.5 448 235.1 448 256c0 6.1-.9 12-2.4 17.6L472 294.4zM352 61.8C352 45.3 338.7 32 322.2 32c-7.3 0-14.3 2.7-19.8 7.5l-72.1 64.1 25.5 20.1L320 66.7V174.5l32 25.3V61.8zM88 192h47.6L95.1 160H88c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L302.4 472.5l10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V362.8l-32-25.3V445.3L183.6 324c-2.9-2.6-6.7-4-10.6-4H88c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24z"]
};
var faBorderBottom = {
  prefix: 'fal',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 464c0 8.8-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16zM392 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 352A24 24 0 1 1 8 352a24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM440 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 160a24 24 0 1 1 48 0A24 24 0 1 1 8 160zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm144 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 256A24 24 0 1 1 8 256a24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM440 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM8 64a24 24 0 1 1 48 0A24 24 0 1 1 8 64zm240 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm48 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM104 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm48 192a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faWifiWeak = {
  prefix: 'fal',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", "M320 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faWifi1 = faWifiWeak;
var faDragon = {
  prefix: 'fal',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M288.8 10.9C291 4.4 297.1 0 304 0H432h16 35.8c32.7 0 63.8 14.3 85 39.1l56 65.4c9.7 11.4 15.1 25.8 15.1 40.8c0 34.6-28.1 62.7-62.7 62.7H554.5c-21.2 0-41.6-8.4-56.6-23.4l-8.6-8.6H480v12c0 17.6 8.3 34.2 22.4 44.8l90.7 68C622.6 323 640 357.7 640 394.7c0 62-48 112.7-108.9 117c-1 .2-2 .3-3.1 .3h-5.3H440 48.4c-24.7 .2-45.9-18.5-48.2-43.6c-2.4-26.4 17-49.8 43.4-52.2l378.3-35-29-34.9C366.4 314.7 352 274.8 352 233.7V188.3v0l0-.3v0V153.9l-55.2-27.6c-5-2.5-8.3-7.4-8.8-12.9s1.9-10.9 6.3-14.2L341.3 64 294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9zM525.9 480c.4-.1 .8-.1 1.3-.1c45-2.3 80.8-39.6 80.8-85.2c0-26.9-12.6-52.2-34.1-68.3l-90.7-68C461 241.8 448 215.7 448 188V160c0-8.8 7.2-16 16-16h32c4.2 0 8.3 1.7 11.3 4.7l13.3 13.3c9 9 21.2 14.1 33.9 14.1h22.8c17 0 30.7-13.8 30.7-30.7c0-7.3-2.6-14.4-7.4-20l-56-65.4C529.4 42.2 507.2 32 483.8 32H448 432 352l25.6 19.2c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-43.3 32.5 40.8 20.4c5.4 2.7 8.8 8.3 8.8 14.3v44 0l0 .3v0 45.4c0 33.7 11.8 66.3 33.4 92.2L459 375.8c3.2 3.9 5 8.8 5 13.9c0 11.2-8.5 20.6-19.7 21.6L46.5 448.1c-8.8 .8-15.3 8.6-14.5 17.4c.8 8.4 7.8 14.6 16.1 14.5l.2 0v0H440h82.7 3.2zM320 199.4v34.2c0 1.4 0 2.8 0 4.3L171.7 139c-6.1-4-14.1-3.5-19.5 1.4L63 219.7l127.6-11.6c6.7-.6 13.1 3 15.9 9.1s1.6 13.3-3.2 18.1L150.6 288H327.2c3 11 6.8 21.7 11.5 32H112c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l48.8-48.8-132 12c-6.9 .6-13.4-3.2-16.1-9.6S.2 232.6 5.4 228L130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87zM495.2 57.7l32 16c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z"]
};
var faShoePrints = {
  prefix: 'fal',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M319.9 47c31.6-7.9 68.4-15 96.1-15c43.5 0 94.5 11 133.7 30.6c41 20.5 58.3 44.3 58.3 65.4c0 19.6-13.4 35.6-46.2 48.1C529.9 188.2 490.2 192 464 192c-39.2 0-61-12.3-88.1-27.8l-.5-.3c-22.9-13.1-49.1-28.1-87.4-33.7V55.7c8.8-2.6 19.8-5.6 31.9-8.6zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32v96 32h0zm-64-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V32H192c-35.3 0-64 28.7-64 64s28.7 64 64 64h32V128H192zm-.1 337c-12.1-3-23-6-31.9-8.6V381.7c38.2-5.6 64.5-20.6 87.4-33.7l.5-.3C275 332.3 296.8 320 336 320c26.2 0 65.9 3.8 97.8 15.9C466.6 348.4 480 364.4 480 384c0 21.1-17.4 44.9-58.3 65.4C382.5 469 331.5 480 288 480c-27.7 0-64.5-7.2-96.1-15zM128 352h0v32 96s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM64 384H96V352H64c-35.3 0-64 28.7-64 64s28.7 64 64 64H96V448H64c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faCirclePlus = {
  prefix: 'fal',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faPlusCircle = faCirclePlus;
var faFaceGrinTongueWink = {
  prefix: 'fal',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M256 32C132.3 32 32 132.3 32 256c0 79.8 41.7 149.8 104.5 189.5c7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5C47.7 427.3 0 347.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 91.2-47.7 171.3-119.5 216.6c-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1C438.3 405.8 480 335.8 480 256C480 132.3 379.7 32 256 32zm96 351.4V416c0 53-43 96-96 96s-96-43-96-96V383.3c-20.2-15.7-36.3-36.2-46.8-59.8c-5.2-11.7 6.8-22.4 19.1-18.7c37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7c-10.4 23.6-26.6 44.2-46.9 59.9zm-32-4.7c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64V378.6zM336 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM124.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM336.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faHandHolding = {
  prefix: 'fal',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M195.4 304c-15.8 0-31.2 4.7-44.4 13.4L75.2 368H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c3.2 0 6.2-.9 8.9-2.7l79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 24 60.6c2.9 0 5.7-.8 8.2-2.3L511.3 355c3.4-2 7.2-3 11.1-3h1.3c11.2 0 20.3 9.1 20.3 20.3c0 6.9-3.5 13.3-9.2 17L415.1 467.1c-13 8.4-28.1 12.9-43.6 12.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H371.5c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3h-1.3c-9.7 0-19.1 2.6-27.5 7.6L400.2 384h-5.6c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56H195.4z"]
};
var faPlugCircleExclamation = {
  prefix: 'fal',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faLinkSlash = {
  prefix: 'fal',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L492 310.3l25.3 20L591.5 256zM414.6 412.2l-33.4-26.3c-26.1 1.3-52.5-8.1-72.5-28c-14.2-14.2-23-31.7-26.4-50.1L249 281.5c-2.4 35.7 10.1 72 37.2 99.1c34.8 34.8 84.6 45.3 128.5 31.7zM331.2 154.1c14.2 14.2 23 31.7 26.4 50.1L391 230.5c2.4-35.7-10.1-72-37.2-99.1c-34.8-34.8-84.6-45.3-128.5-31.7l33.4 26.3c26.1-1.3 52.5 8.1 72.5 28zM148 201.7l-25.3-20L48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L148 201.7z"]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faClone = {
  prefix: 'fal',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M64 480H288c17.7 0 32-14.3 32-32V384h32v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v32H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32zM224 320H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32zm-64-32V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"]
};
var faPersonWalkingArrowLoopLeft = {
  prefix: 'fal',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm334.6 90.6c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L412.2 368l75.8 0c83.9 0 152-68.1 152-152s-68.1-152-152-152L336 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l152 0c66.3 0 120 53.7 120 120s-53.7 120-120 120l-75.8 0 62.1-51.7c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80c-3.6 3-5.8 7.5-5.8 12.3s2.1 9.3 5.8 12.3l96 80z"]
};
var faArrowUpZA = {
  prefix: 'fal',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L339.5 198c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H385.3L492.5 58c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H352zm64 256c-6.1 0-11.6 3.4-14.3 8.8L337.8 424.6c-.1 .2-.2 .4-.3 .6l-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L361.9 448H470.1l11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7c-.1-.2-.2-.4-.3-.6L430.3 296.8c-2.7-5.4-8.2-8.8-14.3-8.8zM377.9 416L416 339.8 454.1 416H377.9z"]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faFireFlameCurved = {
  prefix: 'fal',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M53.9 186.1C19.4 220.6 0 267.4 0 316.2v11.5C0 429.5 82.5 512 184.3 512h15.1C301.4 512 384 429.4 384 327.4c0-66.1-27.1-129.2-74.9-174.8L230.9 78.2C221.4 69.1 216 56.6 216 43.4V21.3C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5l-19.5 26c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.9 11.3-.4 22.5 1.6 33.5c2.8 15.3 8.3 29.9 16.4 43.3c.6 1.1 1.3 2.1 2 3.2c1.6 2.5 3.4 5 5.2 7.5l32 42.7c7 9.3 10.8 20.7 10.8 32.4v14c0 22.1-17.9 40-40 40s-40-17.9-40-40V200.3v-12c0-10.8-6.1-20.2-15-25c-4-2.1-8.5-3.3-13.3-3.3c-7.5 0-14.7 3-20 8.3L53.9 186.1zM184.5 52.6c2.1 18.5 10.7 35.8 24.3 48.7L287 175.8c41.5 39.5 65 94.3 65 151.6C352 411.7 283.7 480 199.4 480H184.3C100.2 480 32 411.8 32 327.7V316.2c0-40.3 16-79 44.5-107.5L88 197.3V288c0 39.8 32.2 72 72 72s72-32.2 72-72V274c0-18.6-6-36.7-17.2-51.6l-32-42.7c-14.1-18.8-20.8-42.1-18.9-65.6l.9-10.8c1.5-18 8-35.2 18.9-49.6l.8-1.1zm18.7-24.9l0 0-8.5-6.4 8.5 6.4s0 0 0 0z"]
};
var faFireAlt = faFireFlameCurved;
var faTornado = {
  prefix: 'fal',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M352 122.6c0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9c0 39.7-15.8 77.8-43.9 105.9l-78.2 78.2c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l5.9-35.7c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6V32C0 14.3 14.3 0 32 0H393.4C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16L370.8 77.2c-12 12-18.8 28.4-18.8 45.4zM32 45.6c0 28.7 5.5 56.6 15.7 82.4H320.2c-.1-1.8-.2-3.6-.2-5.4c0-25.5 10.1-50 28.2-68L370.7 32H32V45.6zM142.4 238.7L200 272.5V272H404.9c-3.4-7.3-7.6-14.2-12.5-20.8l-53.2-70.9c-4.7-6.3-8.6-13.1-11.7-20.3H63.4c19 31.9 45.9 59.2 79 78.7zM253.5 304l5.3 3.1c24.5 14.4 44.3 35.6 57 61c13.8 27.5 18.5 58.6 13.7 89l51.9-51.9c22.1-22.1 34.5-52.1 34.5-83.3c0-6-.5-12-1.4-17.9H253.5z"]
};
var faFileCirclePlus = {
  prefix: 'fal',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M64 480H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDeleteRight = {
  prefix: 'fal',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", "M32 128c0-17.7 14.3-32 32-32H370.7c8.5 0 16.6 3.4 22.6 9.4L544 256 393.4 406.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V128zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H370.7c17 0 33.3-6.7 45.3-18.7L566.6 278.6c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6L416 82.7C404 70.7 387.7 64 370.7 64H64zm84.7 116.7c-6.2 6.2-6.2 16.4 0 22.6L201.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L246.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faBookQuran = {
  prefix: 'fal',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M384 0c35.3 0 64 28.7 64 64l0 384 0 0c0 35.3-28.7 64-64 64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V413.3C13.4 406.7 0 388.9 0 368V48C0 21.5 21.5 0 48 0H384zM64 416v64H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32H48c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H384zM298.1 166.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L328 215.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L304 233.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zM126.4 208c0 62.7 50.9 113.6 113.6 113.6c11.7 0 23-1.8 33.6-5c-53.3-5.9-98.3-51.6-98.3-108.6s45-102.6 98.3-108.6c-10.6-3.3-21.9-5-33.6-5c-62.7 0-113.6 50.9-113.6 113.6zM240 65.6c28.5 0 55 8.4 77.3 22.8c10.5 6.8 11.8 18.8 8.4 27.2s-12.8 16-25 13.6c-48.6-9.9-96.6 28.8-96.6 78.8s48 88.7 96.6 78.8c12.3-2.5 21.6 5.2 25 13.6s2.1 20.4-8.4 27.2C295 342 268.5 350.4 240 350.4c-78.6 0-142.4-63.8-142.4-142.4s63.8-142.4 142.4-142.4z"]
};
var faQuran = faBookQuran;
var faCircleQuarter = {
  prefix: 'fal',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M224 34.3V224L34.3 224C48.3 125.9 125.9 48.3 224 34.3zM2 224.1C-.2 241.6 14.3 256 32 256l192 0c17.7 0 32-14.3 32-32V32c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z"]
};
var faAnchor = {
  prefix: 'fal',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64.1 78.4c-.1 .5-.1 1-.1 1.6v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V480H240c-79.5 0-144-64.5-144-144V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h48 48c97.2 0 176-78.8 176-176V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V336c0 79.5-64.5 144-144 144H304V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H304V160c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80z"]
};
var faBorderAll = {
  prefix: 'fal',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 64c17.7 0 32 14.3 32 32V240H240V64H384zm32 208V416c0 17.7-14.3 32-32 32H240V272H416zM208 240H32V96c0-17.7 14.3-32 32-32H208V240zM32 272H208V448H64c-17.7 0-32-14.3-32-32V272zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFunction = {
  prefix: 'fal',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M80 80c0-44.2 35.8-80 80-80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-26.5 0-48 21.5-48 48V192h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112V398.1c0 41.1-31.1 75.5-72 79.6l-22.4 2.2C8.8 480.8 1 474.4 .1 465.6s5.5-16.6 14.3-17.5l22.4-2.2C61.3 443.4 80 422.7 80 398.1V224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H80V80zm221.5 80.5C272.8 206.1 256 260.9 256 320s16.8 113.9 45.5 159.5c4.7 7.5 2.5 17.4-5 22.1s-17.4 2.5-22.1-5C242.5 445.9 224 385.2 224 320s18.5-125.9 50.5-176.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1zm260.9 0c-4.7-7.5-2.5-17.4 5-22.1s17.4-2.5 22.1 5C621.5 194.1 640 254.8 640 320s-18.5 125.9-50.5 176.5c-4.7 7.5-14.6 9.7-22.1 5s-9.7-14.6-5-22.1C591.2 433.9 608 379.1 608 320s-16.8-113.9-45.5-159.5zM379.3 244.7L432 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faFaceAngry = {
  prefix: 'fal',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm82.7-116.1c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faAngry = faFaceAngry;
var faPeopleSimple = {
  prefix: 'fal',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.8 236l-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7L198.2 236c-2.1-24.9-22.9-44-47.8-44H105.6c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm17.5 151.2L298.4 352H469.6L430.5 215.2C426.6 201.5 414 192 399.7 192H368.3c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H352V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]
};
var faCookieBite = {
  prefix: 'fal',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M182.8 28.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4zm46.3 19.7c15 58.3 62 103.6 121.2 116.4c15.6 54.1 59 96.4 113.7 110.5c0 11.2-2.5 22.3-7.5 32.5L419.8 383c-6.8 14.1-17.9 25.6-31.7 32.9l-74 39.5c-13.7 7.3-29.4 10.1-44.8 7.9l-83-11.7c-15.4-2.2-29.7-9.2-40.9-20L85.1 373.2c-11.2-10.9-18.7-25-21.4-40.4L49.1 250c-2.7-15.4-.5-31.3 6.4-45.4L92.2 129c6.8-14.1 17.9-25.6 31.7-32.9l74-39.5c9.7-5.2 20.4-8.1 31.2-8.6zM184 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowTrendDown = {
  prefix: 'fal',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", "M368 400c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16s-16 7.2-16 16V361.4L331.3 148.7c-6.2-6.2-16.4-6.2-22.6 0L192 265.4 27.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0L320 182.6 521.4 384H384c-8.8 0-16 7.2-16 16z"]
};
var faRss = {
  prefix: 'fal',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16c220.9 0 400 179.1 400 400c0 8.8 7.2 16 16 16s16-7.2 16-16C448 225.4 254.6 32 16 32zm0 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c141.4 0 256 114.6 256 256c0 8.8 7.2 16 16 16s16-7.2 16-16c0-159.1-128.9-288-288-288zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z"]
};
var faFeed = faRss;
var faFaceMonocle = {
  prefix: 'fal',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M448 371.4V224c0-8.8-7.2-16-16-16c-.9 0-1.8 .1-2.7 .2c-10.7-46-52-80.2-101.3-80.2c-57.4 0-104 46.6-104 104s46.6 104 104 104c37.1 0 69.6-19.4 88-48.5V393.9c0 5.9 .4 11.8 1.2 17.6C376.5 453.7 319.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 42.2-11.7 81.7-32 115.4zm3.9 49.4C489.4 376.3 512 318.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM176.4 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328 160a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM160 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C221.3 339.5 193.7 336 176 336c-8.8 0-16 7.2-16 16zM305.2 105.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L376.3 77c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 99.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z"]
};
var faDrawPolygon = {
  prefix: 'fal',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0zM80 158V354c22.5 5.8 40.2 23.5 46 46H322c2.9-11.1 8.6-21 16.4-28.9l-32.2-53.7c-5.8 1.7-11.9 2.6-18.2 2.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.3 0 12.4 .9 18.2 2.6l32.2-53.7c-7.8-7.9-13.5-17.8-16.4-28.9H126c-5.8 22.5-23.5 40.2-46 46zM365.8 354.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64s-28.7 64-64 64c-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V158C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32c29.8 0 54.9 20.4 62 48H322c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.4-.9-18.2-2.6l-32.2 53.7C345 222.6 352 238.5 352 256s-7 33.4-18.4 44.9l32.2 53.7zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM352 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faScaleBalanced = {
  prefix: 'fal',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M384 64c0 29.8-20.4 54.9-48 62V480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V126c-27.6-7.1-48-32.2-48-62H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H264.6C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32H512c8.8 0 16 7.2 16 16s-7.2 16-16 16H384zm56.7 298.3C457.8 375.1 482.9 384 512 384s54.2-8.9 71.3-21.7C600.4 349.5 608 334.2 608 320H416v-1.6l0 .1V320c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288H597.7L512 147.3zM384 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96s-128-43-128-96zM32 320c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7C216.4 349.5 224 334.2 224 320H32v-1.6l0 .1V320zm10.3-32H213.7L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBalanceScale = faScaleBalanced;
var faCalendarLines = {
  prefix: 'fal',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H32V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32zM96 368c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm16-112H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCalendarNote = faCalendarLines;
var faArrowDownBigSmall = {
  prefix: 'fal',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", "M171.3 475.3l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V425.4L75.3 356.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 432V368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v64zM352 80c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zm-32 0V208c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faSortSizeDown = faArrowDownBigSmall;
var faGaugeSimpleHigh = {
  prefix: 'fal',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64z"]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faDoNotEnter = {
  prefix: 'fal',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm112-16v32c0 4.4 3.6 8 8 8H392c4.4 0 8-3.6 8-8V240c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8zm-32 0c0-22.1 17.9-40 40-40H392c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H120c-22.1 0-40-17.9-40-40V240z"]
};
var faShower = {
  prefix: 'fal',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M32 115.9C32 87.2 55.2 64 83.9 64c13.8 0 27 5.5 36.7 15.2l28.1 28.1c.5 .5 1.1 1 1.7 1.5c-33 43.9-29.5 106.5 10.4 146.4l4.7 4.7-16.8 16.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16.8 16.8-4.7-4.7C279.3 56.9 216.7 53.4 172.8 86.4c-.4-.6-.9-1.2-1.5-1.7L143.2 56.6C127.5 40.8 106.1 32 83.9 32C37.6 32 0 69.6 0 115.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V115.9zm151.4 3.5c31.2-31.2 81.9-31.2 113.1 0l4.7 4.7L188.1 237.3l-4.7-4.7c-31.2-31.2-31.2-81.9 0-113.1zM416 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM424 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faDiceD8 = {
  prefix: 'fal',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", "M240 51.3L44.3 247.1l195.7 81V51.3zM72.8 293.5L240 460.7v-98L72.8 293.5zM272 460.7L439.2 293.5 272 362.7v98zM467.8 247.1L272 51.3V328.1l195.8-81zM239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7z"]
};
var faDesktop = {
  prefix: 'fal',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 32H64C46.3 32 32 46.3 32 64V256H544V64c0-17.7-14.3-32-32-32zm64 224v32 64c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V288 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM32 288v64c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64z"]
};
var faDesktopAlt = faDesktop;
var faM = {
  prefix: 'fal',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M11.3 32.7c6.7-2.1 14 .5 17.9 6.3L224 323.7 418.8 39c4-5.8 11.2-8.3 17.9-6.3S448 41 448 48V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V99.7L237.2 361c-3 4.4-7.9 7-13.2 7s-10.2-2.6-13.2-7L32 99.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-7 4.6-13.2 11.3-15.3z"]
};
var faGripDotsVertical = {
  prefix: 'fal',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", "M64 96A16 16 0 1 0 32 96a16 16 0 1 0 32 0zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faFaceViewfinder = {
  prefix: 'fal',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M48 0C21.5 0 0 21.5 0 48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM464 0H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zm464 48c26.5 0 48-21.5 48-48V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 280c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z"]
};
var faSoftServe = {
  prefix: 'fal',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M192 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H116c-37.6 0-68 30.4-68 68c0 11.5 2.8 22.2 7.8 31.7C23.5 174 0 204.2 0 240c0 32.8 19.7 61 48 73.3V352c0 22.2 15.1 41 35.7 46.4L92.6 470c3 24 23.4 42 47.6 42H243.8c24.2 0 44.6-18 47.6-42l8.9-71.6C320.9 393 336 374.2 336 352V313.3c28.3-12.3 48-40.5 48-73.3c0-37.2-25.4-68.5-59.8-77.4c7.5-12.1 11.8-26.3 11.8-41.6C336 54.2 281.8 0 215 0H192zM304 288H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h8.3H112c8.8 0 16-7.2 16-16s-7.2-16-16-16H93.4C85.2 153.4 80 143.3 80 132c0-19.9 16.1-36 36-36h61.3C203.1 96 224 75.1 224 49.3c0-5.9-1.1-11.7-3.2-17.1c46.5 3 83.2 41.6 83.2 88.8c0 16.2-8.2 30.5-20.8 39H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h47.7 .3 16c26.5 0 48 21.5 48 48s-21.5 48-48 48zM80 320H304v32c0 8.8-7.2 16-16 16h-2c-8.1 0-14.9 6-15.9 14l-10.5 84c-1 8-7.8 14-15.9 14H140.2c-8.1 0-14.9-6-15.9-14l-10.5-84c-1-8-7.8-14-15.9-14H96c-8.8 0-16-7.2-16-16V320z"]
};
var faCreemee = faSoftServe;
var faH5 = {
  prefix: 'fal',
  iconName: 'h5',
  icon: [640, 512, [], "e412", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM432 64c-7.6 0-14.2 5.4-15.7 12.9l-32 160c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9H528c44.2 0 80 35.8 80 80s-35.8 80-80 80H456.4c-17.2 0-32.5-11-37.9-27.4l-3.2-9.7c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l3.2 9.7c9.8 29.4 37.3 49.2 68.3 49.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H419.5L445.1 96H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
};
var faHandBackPointDown = {
  prefix: 'fal',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M136 512c-30.9 0-56-25.1-56-56V255.4c-3.2-2-6.4-4.2-9.5-6.5L48 232c-20.1-15.1-32-38.8-32-64V148.5c0-53 29.1-101.7 75.7-126.8l8.3-4.5C121 5.9 144.4 0 168.3 0H304c61.9 0 112 50.1 112 112v8 88c0 35.3-28.7 64-64 64c-2.8 0-5.6-.2-8.3-.5c-11 19.4-31.8 32.5-55.7 32.5c-5.3 0-10.5-.7-15.5-1.9c-10.8 20.2-32 33.9-56.5 33.9c-8.5 0-16.6-1.7-24-4.7V456c0 30.9-25.1 56-56 56zm-24-56c0 13.3 10.7 24 24 24s24-10.7 24-24V298.5c0-7.1 4.6-13.3 11.4-15.3s14 .6 18 6.5c5.8 8.7 15.6 14.3 26.7 14.3c15.6 0 28.6-11.2 31.4-25.9c1-5.1 4.4-9.5 9.2-11.6s10.3-1.8 14.8 .9c4.8 2.9 10.5 4.6 16.6 4.6c14.7 0 27.2-10 30.9-23.6c1.2-4.4 4.2-8.1 8.3-10.1s8.8-2.2 13.1-.6c3.6 1.4 7.6 2.2 11.8 2.2c17.7 0 32-14.3 32-32V120v-8c0-44.2-35.8-80-80-80H168.3c-18.5 0-36.8 4.6-53.1 13.4l-7.6-14.1 7.6 14.1-8.3 4.5C70.6 69.4 48 107.3 48 148.5V168c0 15.1 7.1 29.3 19.2 38.4L80 216V168c0-8.8 7.2-16 16-16s16 7.2 16 16v78.3V248 456z"]
};
var faTableList = {
  prefix: 'fal',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", "M192 64v96H480V96c0-17.7-14.3-32-32-32H192zm-32 0H64C46.3 64 32 78.3 32 96v64H160V64zM32 192V320H160V192H32zm0 160v64c0 17.7 14.3 32 32 32h96V352H32zm160 96H448c17.7 0 32-14.3 32-32V352H192v96zM480 320V192H192V320H480zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faThList = faTableList;
var faCommentSms = {
  prefix: 'fal',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM202.9 176.8C196.4 179 192 185.1 192 192v96c0 8.8 7.2 16 16 16s16-7.2 16-16V240l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240v48c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm-90.9 38c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C88.6 189.3 80 199.8 80 215c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0 0 0c-1.3-.4-2.7-.9-4.1-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4zm256 0c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.3 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0 0 0 0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2 .4 2.6 .9 4 1.4l0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4z"]
};
var faSms = faCommentSms;
var faRectangle = {
  prefix: 'fal',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M448 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faRectangleLandscape = faRectangle;
var faClipboardListCheck = {
  prefix: 'fal',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM171.3 235.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4 99.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTurkey = {
  prefix: 'fal',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", "M496 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 2.7-.3 5.4-1 7.9c-1.3 5.2-.5 11.1 2.9 16c3.7 5.2 9.4 8 15.2 8.2c17.1 .6 30.9 14.7 30.9 32c0 17.7-14.3 32-32 32c-6 0-12.6-.6-20.3-1.5l-3.9-.5c-6.3-.7-13.2-1.5-19.9-2c-15.9-1-35.4-.4-51.5 11l-41.6 29.3c-18.8 13.2-30.5 32-39.1 50.6c-5.3 11.3-10 24.3-14.4 36.2c-2.5 6.7-4.8 13.1-7.1 18.8c-4.9 12.2-12.9 23.3-23.9 32.2C320 362 269.6 356.7 241.8 322.3S219.3 237.6 253.7 209.8c17.2-13.9 38.3-19.5 58.7-17.4c14.5 1.5 31.2 3.1 47.6 2c16.5-1.2 33.7-5.3 48.9-16l63.6-44.9c12.8-9 18.4-22.7 20.9-34.8C495.9 86.7 496 73.8 496 64zM528 0c-35.3 0-64 28.7-64 64c0 10.1-.2 19.7-1.9 28.1c-1.8 8.3-4.6 12.9-8.1 15.3l-40.3 28.4C370.6 110.5 325.7 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-60.3-25-116.1-62.2-162.2l-26.2 18.5C522 282.3 544 332 544 384c0 24.6-7.4 40.5-18.3 52c-11.6 12.3-29.6 22.1-54.5 29.2C420.4 479.7 353.4 480 288 480s-132.4-.3-183.2-14.8c-24.9-7.1-42.9-16.9-54.5-29.2C39.4 424.5 32 408.6 32 384c0-68 37.6-132 91.4-180.2C177.6 155.2 242.3 128 288 128c27.3 0 61.5 9.7 96.1 28c-7.6 3.8-16.4 5.8-26.5 6.5c-13.1 .9-27.2-.3-41.9-1.9c-28.5-3-58.2 4.9-82.2 24.3c-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c15.3-12.4 26.5-28 33.4-45.1c3.1-7.7 5.7-14.9 8.3-21.9l0 0c4-10.8 7.7-21.1 12.6-31.6c7.6-16.4 16.3-29.3 28.5-37.9l41.6-29.3c6.7-4.7 16.5-6.2 31-5.2c5.8 .4 11.7 1.1 18 1.8l4.3 .5c7.6 .9 15.9 1.7 23.9 1.7c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64z"]
};
var faBook = {
  prefix: 'fal',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H96V384H64zm64 0V32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H128zm48-240c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
};
var faUserPlus = {
  prefix: 'fal',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zM512 304c0 8.8 7.2 16 16 16s16-7.2 16-16V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H544V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faIceSkate = {
  prefix: 'fal',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v7.4l-4.1 1.1L67.6 82.2C46.6 87.8 32 106.8 32 128.6V336c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V306c0-36.7-25-68.7-60.6-77.6L320 195.5V144 16zM75.9 113.1L288 56.6V128H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h62l141.6 35.4C465 264.7 480 283.9 480 306v30c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V128.6c0-7.2 4.9-13.6 11.9-15.5zM128 432V416H96v16 48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96H400h96c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 26.5-21.5 48-48 48H416V432 416H384v16 48H128V432z"]
};
var faCheck = {
  prefix: 'fal',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBatteryThreeQuarters = {
  prefix: 'fal',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", "M432 128c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H432zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zM576 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM112 192H304c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM64 208v96c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"]
};
var faBattery4 = faBatteryThreeQuarters;
var faTomato = {
  prefix: 'fal',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M235.3 4.7L224 16C235.3 4.7 235.3 4.7 235.3 4.7l0 0 0 0 .1 .1 .2 .2 .4 .5c.4 .4 .8 .9 1.4 1.5c1.1 1.3 2.6 3.1 4.4 5.4c3.5 4.7 8 11.5 12.5 20.4c6 12 11.9 27.8 15.1 47.4c52.9 1.7 102.9 13.6 145.6 35.3c13.2 6.7 20.1 21.6 16.6 36s-16.3 24.5-31.1 24.5h-4.8c6.7 11.5 5.5 26.1-3.1 36.5c-9.1 10.9-24.2 14.5-37.2 8.9L256 178.8l-99.4 42.6c-13 5.6-28.2 1.9-37.2-8.9c-8.7-10.5-9.8-25.2-2.9-36.8l-.2 0c-13.3 2-26.9-4.5-33.4-17.1c-8-15.8-1.7-35 14-43l0 0 .8-.4 0 0c41-20.6 88.6-32.3 139.1-34.6c-2.8-13.8-7.1-24.9-11.3-33.3c-3.5-7-7-12.2-9.5-15.6c-1.2-1.7-2.2-2.8-2.9-3.6c-.3-.4-.5-.6-.6-.7l-.1-.1c-6.2-6.3-6.1-16.3 .1-22.5c6.2-6.2 16.4-6.2 22.6 0zM240 112.3c-47.2 2-90.9 12.7-127.7 31.3l0 0-.8 .4 0 0 0 0c1.2-.3 2.4-.4 3.6-.4l31.3 .2c5.9 0 11.3 3.3 14 8.5s2.4 11.5-.8 16.4L144 192l105.7-45.3c4-1.7 8.6-1.7 12.6 0L368 192l-15.4-23.1c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5h34.6c-37-18.8-81-29.7-128.5-31.7c-.2 8.7-7.3 15.7-16 15.7s-15.8-7-16-15.7zM73.4 195.4C47.3 223.5 32 259.8 32 304c0 55 23.6 97.8 62.5 127.7C134.1 462.2 190.8 480 256 480s121.9-17.8 161.5-48.3C456.4 401.8 480 359 480 304c0-44.2-15.3-80.5-41.4-108.6c8.7-6.4 15.7-15 20.3-25.1C492.2 204.5 512 249.6 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304c0-54.4 19.8-99.6 53.1-133.7c.4 .9 .8 1.8 1.3 2.7c4.7 9.2 11.2 16.7 18.9 22.4z"]
};
var faSwordLaser = {
  prefix: 'fal',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", "M503.8 57.1l-210 232.7-22.7-22.7L480 35.7V32l-3.7 0L244.8 240.9l-22.7-22.7L454.9 8.2C460.7 2.9 468.4 0 476.3 0H480c17.7 0 32 14.3 32 32v3.7c0 7.9-2.9 15.6-8.2 21.4zM187.3 228.7l16 16 64 64 0 0 0 0 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7-57.9 57.9c1.2 2.3 1.9 4.9 1.9 7.5c0 4.2-1.7 8.3-4.7 11.3L118.6 496c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L16 470.6C5.8 460.4 0 446.5 0 432s5.8-28.4 16-38.6l76.7-76.7c5.1-5.1 12.8-6 18.8-2.8L169.4 256l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM152 318.6L134.6 336 176 377.4 193.4 360 152 318.6zM174.6 296L216 337.4 233.4 320 192 278.6 174.6 296zM38.6 416c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16L64 473.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6L161.4 408 104 350.6 38.6 416z"]
};
var faHouseCircleCheck = {
  prefix: 'fal',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9H240V480h16 80 24.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBuildings = {
  prefix: 'fal',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M448 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448zM288 0c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H288zM192 128H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H216.4c-8.3-9.2-14.8-20.1-19-32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H192V128zM88 320c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H88zm8 64V352h32v32H96zm224 8c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24v48zm32-8V352h32v32H352zM88 192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H88zm8 64V224h32v32H96zM320 88v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zm32 8h32v32H352V96zm-8 192h48c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24zm8-64h32v32H352V224z"]
};
var faAngleLeft = {
  prefix: 'fal',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256 235.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z"]
};
var faCartFlatbedBoxes = {
  prefix: 'fal',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H80c8.8 0 16 7.2 16 16V368c0 26.5 21.5 48 48 48h24.6c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32H456.6c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H512 224 144c-8.8 0-16-7.2-16-16V48c0-26.5-21.5-48-48-48H16zM544 448a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-416H352V288H224l0-224zm-32 0V288c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zm320 0v64H448V64h64zM448 32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H448zm0 192H576v64H448V224zm-32 0v64c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32z"]
};
var faDollyFlatbedAlt = faCartFlatbedBoxes;
var faDiagramSuccessor = {
  prefix: 'fal',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M480 352c0-17.7-14.3-32-32-32L64 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64zm32 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64zM256 96c0-17.7-14.3-32-32-32l-32 0L64 64C46.3 64 32 78.3 32 96l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64zm23.4-32c5.4 9.4 8.6 20.3 8.6 32l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0 32 0 144 0c35.3 0 64 28.7 64 64l0 89.4 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L400 185.4 400 96c0-17.7-14.3-32-32-32l-88.6 0zM96 368l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTruckArrowRight = {
  prefix: 'fal',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", "M352 32c17.7 0 32 14.3 32 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H352zM0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8C508.6 102.1 495.3 96 481.3 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352zM481.3 128c4.7 0 9.1 2 12.1 5.6L570.9 224H416V128h65.3zM416 344.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM235.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L265.4 160H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H265.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faSquareW = {
  prefix: 'fal',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm103.1 58.8l56.3 162.6 49.4-154.2c2.1-6.6 8.3-11.1 15.2-11.1s13.1 4.5 15.2 11.1l49.4 154.2 56.3-162.6c2.9-8.4 12-12.8 20.4-9.9s12.8 12 9.9 20.4l-72 208c-2.3 6.5-8.4 10.8-15.3 10.8s-13-4.6-15.1-11.1L224 220.5 175.2 372.9c-2.1 6.6-8.2 11-15.1 11.1s-13.1-4.3-15.3-10.8l-72-208c-2.9-8.4 1.5-17.5 9.9-20.4s17.5 1.5 20.4 9.9z"]
};
var faArrowsSplitUpAndLeft = {
  prefix: 'fal',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", "M235.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 54.6V384v16c0 44.2 35.8 80 80 80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416c-61.9 0-112-50.1-112-112V384c0-44.2-35.8-80-80-80H54.6l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272H224c31.3 0 59.7 12.9 80 33.6V54.6l-68.7 68.7z"]
};
var faLamp = {
  prefix: 'fal',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M112 32L32 224H416L336 32 112 32zM82.5 19.7C87.4 7.8 99.1 0 112 0H336c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 312.2V288h32v24.2c0 14.8-6.7 27.8-16.5 36.6c-6.8 6.1-19.3 18.4-29.8 34.1C135 398.9 128 415.8 128 432c0 17.1 5.8 31.8 12.1 42.6c1 1.7 4.8 5.4 14.4 5.4h139c9.7 0 13.5-3.7 14.4-5.4c6.3-10.8 12.1-25.5 12.1-42.6c0-16.2-7-33.1-17.7-49.1c-10.5-15.7-23-28-29.8-34.1c-9.8-8.8-16.5-21.8-16.5-36.6V288h32v24.2c0 4.9 2.2 9.5 5.9 12.8C309.7 339.3 352 382 352 432c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-50 42.3-92.7 58.1-107c3.6-3.3 5.9-7.9 5.9-12.8z"]
};
var faAirplay = {
  prefix: 'fal',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", "M480 64H96c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64h37.5l-18.7 18.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L442.5 384H480c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM162.2 435.7c-1.4 1.3-2.2 3.2-2.2 5.2c0 3.9 3.2 7.1 7.1 7.1H408.9c3.9 0 7.1-3.2 7.1-7.1c0-2-.8-3.8-2.2-5.2L293.6 322.2c-1.4-1.3-3.5-2.2-5.6-2.2s-4.2 .8-5.6 2.2L162.2 435.7zm-22-23.3L260.4 298.9c7.4-7 17.4-10.9 27.6-10.9s20.1 3.9 27.6 10.9L435.7 412.4c7.8 7.4 12.3 17.7 12.3 28.5c0 21.6-17.5 39.1-39.1 39.1H167.1c-21.6 0-39.1-17.5-39.1-39.1c0-10.8 4.4-21.1 12.3-28.5z"]
};
var faHandFist = {
  prefix: 'fal',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", "M254.2 233.7c7.7 4 16.5 6.3 25.8 6.3c12.1 0 23.3-3.8 32.5-10.4C322.4 245.5 340 256 360 256c8.6 0 16.7-1.9 24-5.4V256c0 38.6-19.5 72.6-49.2 92.7c-8.6 5.8-14.8 15.7-14.8 27.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V376.1l0-.1 .1-.1c.1-.2 .3-.5 .7-.7C390.9 349.3 416 305.6 416 256V200v-8V152c0-30.9-25.1-56-56-56c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56c-9.7 0-18.8 2.5-26.7 6.8C246 16.3 224.9 0 200 0s-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8C89.1 32 64 57.1 64 88V200c0 2.6 .2 5.1 .5 7.6C44.8 222.2 32 245.6 32 272c0 59 39.9 108.7 94.2 123.5c.8 .2 1.3 .6 1.6 1c.1 .2 .2 .3 .2 .3l0 0V496c0 8.8 7.2 16 16 16s16-7.2 16-16V396.7c0-16.3-11.9-28.4-25.4-32.1C93.9 353.5 64 316.2 64 272c0-26.5 21.5-48 48-48h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c30.9 0 56-25.1 56-56c0-4.9-.6-9.7-1.8-14.3zM224 197.4c-7.3-3.5-15.4-5.4-24-5.4H176V88 56c0-13.3 10.7-24 24-24s24 10.7 24 24V88v96 13.4zM144 192H112c-5.5 0-10.8 .6-16 1.6V88c0-13.3 10.7-24 24-24s24 10.7 24 24V192zm240 0v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V184 152c0-13.3 10.7-24 24-24s24 10.7 24 24v40zM256 88c0-13.3 10.7-24 24-24s24 10.7 24 24v64 32c0 13.3-10.7 24-24 24s-24-10.7-24-24V88z"]
};
var faFistRaised = faHandFist;
var faShieldQuartered = {
  prefix: 'fal',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M66.8 112.3C55.5 117 47.9 127.7 48 139.8c.1 20 1.9 43.2 6.3 68.2H240V38.8L66.8 112.3zM61.1 240C82.3 324.6 133.3 420.1 240 472.6V240H61.1zM272 240V472.6c106.7-52.5 157.7-148 179-232.6H272zm185.8-32c4.3-24.9 6.2-48.2 6.3-68.2c.1-12.1-7.5-22.8-18.8-27.6L272 38.8V208H457.8zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z"]
};
var faSlashForward = {
  prefix: 'fal',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", "M312.2 2.3c7.6 4.5 10 14.4 5.5 22l-288 480c-4.5 7.6-14.4 10-22 5.5s-10-14.4-5.5-22l288-480c4.5-7.6 14.4-10 22-5.5z"]
};
var faLocationPen = {
  prefix: 'fal',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM252.3 131.7c-4.9-4.9-12.9-4.9-17.8 0l-8.1 8.1 17.8 17.8 8.1-8.1c4.9-4.9 4.9-12.9 0-17.8zM143.1 223.1c-2 2.1-3.5 4.6-4.2 7.4L134 250l19.4-4.9c2.8-.7 5.4-2.2 7.4-4.2l60.7-60.7-17.8-17.8-60.7 60.7zM211.8 109c17.4-17.4 45.7-17.4 63.1 0c17.4 17.4 17.4 45.6 0 63l-91.4 91.5c-6.2 6.2-13.9 10.5-22.3 12.6l-45.3 11.3c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l11.3-45.3c2.1-8.4 6.5-16.1 12.6-22.3L211.8 109z"]
};
var faMapMarkerEdit = faLocationPen;
var faCloudMoon = {
  prefix: 'fal',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M460.6 35.9c-30 32-48.4 75-48.4 122.4c0 90.8 67.6 165.8 155.1 177.2c-21.5 10.8-45.8 16.9-71.5 16.9c-24.6 0-47.9-5.6-68.7-15.5c17.7 11 32.1 26.8 41.3 45.6c8.9 1.3 18.1 1.9 27.4 1.9c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7C389.8 0 304 86.1 304 192.2c0 10.8 .9 21.5 2.6 31.8c11.8 .3 23.2 2.4 33.9 6.1c-2.9-12.2-4.5-24.8-4.5-37.9C336 115.8 389.3 52 460.6 35.9zM112 320c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H98.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3C34.6 328.9 0 368.4 0 416c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H365.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.4 242.6 210.9 224 176 224z"]
};
var faPotFood = {
  prefix: 'fal',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7l.4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8c0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C131.7 51.6 128 38.2 128 16zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7l0 0 0 0 0 0 .4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8c0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C227.7 51.6 224 38.2 224 16zM32 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H67.8c5.9 82.9 56.5 152.7 127.3 186.4c7.6 21.9 28.4 37.6 52.9 37.6H392c24.5 0 45.3-15.7 52.9-37.6C515.7 440.7 566.3 370.9 572.2 288H608c8.8 0 16-7.2 16-16s-7.2-16-16-16H570.4c-6.6-18.6-24.3-32-45.3-32H114.9c-21 0-38.7 13.4-45.3 32H32zm507.4-64c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80h34c12.3-28.3 40.5-48 73.3-48s61 19.7 73.3 48h34zM225.3 463.9c-2.8-8.1-8.7-14.7-16.5-18.4c-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9H525.1c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2c-7.7 3.7-13.7 10.3-16.5 18.4c-3.3 9.4-12.2 16.1-22.7 16.1H248c-10.4 0-19.4-6.7-22.7-16.1z"]
};
var faBriefcase = {
  prefix: 'fal',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M160 48V96H352V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM128 96V48c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H144 64c-17.7 0-32 14.3-32 32v96H176h32 96 32H480V160c0-17.7-14.3-32-32-32H368zM480 288H336v48c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V288H32V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V288zm-272 0v48h96V288H208z"]
};
var faPersonFalling = {
  prefix: 'fal',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 10.8c0 48.1-27.6 91.3-70 111.9c-1.8 .4-3.6 1.1-5.2 2.2c-.2 .1-.4 .3-.6 .4c-3 1.3-6.1 2.4-9.3 3.5C139.1 166.1 96 225.9 96 293.2V368c0 8.8 7.2 16 16 16s16-7.2 16-16l0-74.8c0-21.7 5.6-42.5 15.8-60.6L322.6 504.8c4.9 7.4 14.8 9.4 22.2 4.6s9.4-14.8 4.6-22.2L252.7 340.1l57.5-44.7 67-6.7 74.6 89.5c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5l-74.6-89.5c-6.8-8.2-17.2-12.4-27.8-11.4l-61.9 6.2L244.8 160.5c46-27.9 75.2-78.2 75.2-133.7L320 16zM282.5 276.4l-47.4 36.9L165.4 207.2c-.4-.6-.8-1.1-1.3-1.7c13.4-13.5 30-24.1 48.9-30.4c.8-.3 1.7-.6 2.5-.9l66.9 102.1zM96 88a24 24 0 1 1 48 0A24 24 0 1 1 96 88zm80 0A56 56 0 1 0 64 88a56 56 0 1 0 112 0z"]
};
var faImagePortrait = {
  prefix: 'fal',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM235.4 320H148.6c-18.6 0-34 14-36.3 32H271.7c-2.2-18-17.6-32-36.3-32zm-86.9-32H192h43.4c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6c0-37.9 30.7-68.6 68.6-68.6z"]
};
var faPortrait = faImagePortrait;
var faUserTag = {
  prefix: 'fal',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM416 480c0-2.4-.1-4.8-.3-7.2l26.8 26.8c-5.4 7.5-14.2 12.5-24.2 12.5H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4c17.5 0 34.3 2.5 50.3 7.2v33l0 .7c-15.7-5.7-32.6-8.9-50.3-8.9H178.3c-80 0-145 64.3-146.3 144H416zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM545.9 491.3c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3V256c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4zM384 256v82.7c0 8.5 3.4 16.6 9.4 22.6L500.7 468.7c6.2 6.2 16.4 6.2 22.6 0l73.4-73.4c6.2-6.2 6.2-16.4 0-22.6L489.4 265.4c-6-6-14.1-9.4-22.6-9.4H384zm24 40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRug = {
  prefix: 'fal',
  iconName: 'rug',
  icon: [640, 512, [], "e569", "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16H32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32 48 64 576h16 16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V352h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V272h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V192h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H608 592 576 64 48 32 16zM64 96h64V416H64V336 256 176 96zm448 0h64v80 80 80 80H512V96zm-32 0V416H160V96H480z"]
};
var faPrintSlash = {
  prefix: 'fal',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", "M480 463.9V480H160V352H338.3l-40.5-32H160c-17.7 0-32 14.3-32 32v32H96V256c0-17.7 14.3-32 32-32h48.2l-40.5-32H128c-35.3 0-64 28.7-64 64V384c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32H480c14.8 0 27.3-10.1 30.9-23.7L480 463.9zM137.5 30.4L163 50.5C168.1 39.6 179.2 32 192 32H421.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6V160h32V90.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0H192c-23 0-43.2 12.2-54.5 30.4zM512 192H342.2l40.5 32H512c17.7 0 32 14.3 32 32v95.3l32 25.3V256c0-35.3-28.7-64-64-64zM496 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faEarthEurope = {
  prefix: 'fal',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M477.7 288H439.4c-6.2 0-12.3-2.2-17.1-6.2l-15.9-13.2c-4.6-3.8-5.2-10.5-1.5-15.2c14.6-18.3 1.6-45.4-21.8-45.4h-3.7c-6.3 0-11.4-5.1-11.4-11.4v-9.4c0-18.4-22.2-27.6-35.2-14.6l-32.1 32.1c-2.6 2.6-6.8 2.6-9.4 0l-2.8-2.8c-6.3-6.3-14.8-9.8-23.7-9.8c-10.5 0-20.5 5-26.8 13.4l-10.7 14.3c-2 2.7-5.2 4.3-8.5 4.3c-5.9 0-10.7-4.8-10.7-10.7v-1.6c0-3.3 1.3-6.4 3.6-8.7l18.7-18.7c6.2-6.2 9.7-14.7 9.7-23.5c0-4.3 2.4-8.2 6.2-10.1l59.2-29.6c20.2-10.1 26.9-35.6 14.2-54.3c-8.9-13.2-25.1-19.1-40-15.3l4.5-17.8C394.5 47.5 480 141.8 480 256c0 10.9-.8 21.5-2.3 32zm-7 32c-3.3 11-7.4 21.7-12.3 32H438.6c-10.2 0-20.1-4.1-27.3-11.3l-4-4C396.6 326 382.2 320 367.1 320c-5.9 0-11.7-2.1-16.1-6l-26.6-22.8c-14.5-12.4-33-19.3-52.1-19.3H251.4c-15.8 0-31.2 4.7-44.4 13.4l-27.4 18.3c-22.3 14.8-35.6 39.8-35.6 66.6v3.2c0 21.2 8.4 41.6 23.4 56.6l16 16c11.5 11.5 27.1 17.9 43.3 17.9c11.4 0 21.2 6.5 26.1 16C130.6 478.3 32 378.6 32 256C32 133.8 129.9 34.4 251.5 32l-6.9 27.6c-4.9 19.7 15.4 36.2 33.7 27.3l8.1-3.9c2.4-1.2 5.3-.4 6.8 1.8c1.8 2.7 .8 6.3-2 7.8l-59.2 29.6c-14.7 7.3-23.9 22.3-23.9 38.7c0 .3-.1 .6-.4 .9L189 180.4c-8.3 8.3-13 19.6-13 31.3v1.6c0 23.6 19.1 42.7 42.7 42.7c13.4 0 26.1-6.3 34.1-17.1l10.7-14.3c.3-.4 .7-.6 1.2-.6c.4 0 .8 .2 1.1 .4l2.8 2.8c15.1 15.1 39.6 15.1 54.7 0l15.4-15.4c5.8 15.3 20 26.5 36.9 28c-9.5 17.6-5.6 40 10.3 53.3l15.9 13.2c10.5 8.8 23.8 13.6 37.5 13.6h31.3zm-30.9 64c-35.1 50.3-90.2 85.5-153.8 94c-6.8-26.4-30.8-46-59.3-46c-7.8 0-15.2-3.1-20.7-8.6l-16-16c-9-9-14.1-21.2-14.1-33.9v-3.2c0-16.1 8-31 21.4-39.9l27.4-18.3c7.9-5.3 17.1-8.1 26.6-8.1h20.9c11.5 0 22.5 4.1 31.2 11.6l26.6 22.8c10.3 8.8 23.4 13.7 37 13.7c6.6 0 12.9 2.6 17.5 7.3l4 4c13.2 13.2 31.2 20.7 49.9 20.7h1.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGlobeEurope = faEarthEurope;
var faCartFlatbedSuitcase = {
  prefix: 'fal',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", "M0 16C0 7.2 7.2 0 16 0H80c26.5 0 48 21.5 48 48V368c0 8.8 7.2 16 16 16h80H512 624c8.8 0 16 7.2 16 16s-7.2 16-16 16H567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM336 32c-8.8 0-16 7.2-16 16V80H448V48c0-8.8-7.2-16-16-16H336zM480 80h32c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h32V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V80zM272 112H256c-17.7 0-32 14.3-32 32V256c0 17.7 14.3 32 32 32h16V112zm32 176H464V112H304V288zm192 0h16c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H496V288z"]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faHandBackPointRibbon = {
  prefix: 'fal',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M152 0C121.1 0 96 25.1 96 56v8H16C9.8 64 4.2 67.5 1.6 73.1S-.3 85.2 3.5 90l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9S9.8 176 16 176H96v80.6c-3.2 2-6.4 4.2-9.5 6.5L64 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112v-8V304c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-8.5 0-16.6 1.7-24 4.7V56c0-30.9-25.1-56-56-56zM128 176h48v37.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3c15.6 0 28.6 11.2 31.4 25.9c1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6c14.7 0 27.2 10 30.9 23.6c1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1 .6c3.6-1.4 7.6-2.2 11.8-2.2c17.7 0 32 14.3 32 32v88 8c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-8.3-4.5C86.6 442.6 64 404.7 64 363.5V344c0-15.1 7.1-29.3 19.2-38.4L96 296v48c0 8.8 7.2 16 16 16s16-7.2 16-16V265.7 264 176zm48-32H49.3l11.2-14c4.7-5.8 4.7-14.1 0-20L49.3 96H176v48zm0-80H128V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8z"]
};
var faRectangleXmark = {
  prefix: 'fal',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0L256 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faTireRugged = {
  prefix: 'fal',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M229.8 32c-8.2 0-15.1 6.3-15.9 14.5l-.3 3.1c-.6 6.6-5.2 12.1-11.6 13.9c-15.5 4.3-30.2 10.5-43.9 18.2c-5.8 3.2-12.9 2.6-18-1.6l-2.4-2c-6.4-5.2-15.7-4.8-21.5 1L79.1 116.1c-5.8 5.8-6.3 15.1-1 21.5l2 2.4c4.2 5.1 4.8 12.3 1.6 18c-7.7 13.7-13.9 28.4-18.2 43.9c-1.8 6.4-7.3 11-13.9 11.6l-3.1 .3c-8.2 .8-14.5 7.7-14.5 15.9v52.4c0 8.2 6.3 15.1 14.5 15.9l3.1 .3c6.6 .6 12.1 5.2 13.9 11.6c4.3 15.5 10.5 30.2 18.2 43.9c3.2 5.8 2.6 12.9-1.6 18l-2 2.4c-5.2 6.4-4.8 15.7 1 21.5l37.1 37.1c5.8 5.8 15.1 6.3 21.5 1l2.4-2c5.1-4.2 12.3-4.8 18-1.6c13.7 7.7 28.4 13.9 43.9 18.2c6.4 1.8 11 7.3 11.6 13.9l.3 3.1c.8 8.2 7.7 14.5 15.9 14.5h52.4c8.2 0 15.1-6.3 15.9-14.5l.3-3.1c.6-6.6 5.2-12.1 11.6-13.9c15.5-4.3 30.2-10.5 43.9-18.2c5.8-3.2 12.9-2.6 18 1.6l2.4 2c6.4 5.2 15.7 4.8 21.5-1l37.1-37.1c5.8-5.8 6.3-15.1 1-21.5l-2-2.4c-4.2-5.1-4.8-12.3-1.6-18c7.7-13.7 13.9-28.4 18.2-43.9c1.8-6.4 7.3-11 13.9-11.6l3.1-.3c8.2-.8 14.5-7.7 14.5-15.9V229.8c0-8.2-6.3-15.1-14.5-15.9l-3.1-.3c-6.6-.6-12.1-5.2-13.9-11.6c-4.3-15.5-10.5-30.2-18.2-43.9c-3.2-5.8-2.6-12.9 1.6-18l2-2.4c5.2-6.4 4.8-15.7-1-21.5L395.8 79.1c-5.8-5.8-15.1-6.3-21.5-1L372 80c-5.1 4.2-12.3 4.8-18 1.6c-13.7-7.7-28.4-13.9-43.9-18.2c-6.4-1.8-11-7.3-11.6-13.9l-.3-3.1c-.8-8.2-7.7-14.5-15.9-14.5H229.8zm-46.4 3.6C188.9 14.9 207.7 0 229.8 0h52.4c22 0 40.9 14.9 46.4 35.6c11 3.6 21.7 8.1 31.9 13.2c18.5-10.7 42.4-8 58 7.6l37.1 37.1c15.6 15.6 18.3 39.4 7.6 58c5.2 10.2 9.6 20.9 13.2 31.9c20.7 5.5 35.6 24.3 35.6 46.4v52.4c0 22-14.9 40.9-35.6 46.4c-3.6 11-8.1 21.7-13.2 31.9c10.7 18.5 8 42.4-7.6 58l-37.1 37.1c-15.6 15.6-39.4 18.3-58 7.6c-10.2 5.2-20.9 9.6-31.9 13.2c-5.5 20.7-24.3 35.6-46.4 35.6H229.8c-22 0-40.9-14.9-46.4-35.6c-11-3.6-21.7-8.1-31.9-13.2c-18.5 10.7-42.4 8-58-7.6L56.4 418.5c-15.6-15.6-18.3-39.5-7.6-58c-5.2-10.2-9.6-20.9-13.2-31.9C14.9 323.1 0 304.3 0 282.2V229.8c0-22 14.9-40.9 35.6-46.4c3.6-11 8.1-21.7 13.2-31.9c-10.7-18.5-8-42.4 7.6-58L93.5 56.4c15.6-15.6 39.5-18.3 58-7.6c10.2-5.2 20.9-9.6 31.9-13.2zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-75.9 96.6a24 24 0 1 1 14.8-45.7 24 24 0 1 1 -14.8 45.7zm167.2-30.2a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8zm-29.6 73.8a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zM199.6 333.7a24 24 0 1 1 28.2-38.8 24 24 0 1 1 -28.2 38.8z"]
};
var faLightbulbDollar = {
  prefix: 'fal',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7V432zM208 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V296c0 8.8 7.2 16 16 16s16-7.2 16-16V278.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V88z"]
};
var faCowbell = {
  prefix: 'fal',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", "M176 32h96c8.8 0 16 7.2 16 16V96H160V48c0-8.8 7.2-16 16-16zM128 48V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H400c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96H320V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80H304h32c7.1 0 13.4 4.7 15.4 11.6l64 224c1.4 4.8 .4 10-2.6 14s-7.8 6.4-12.8 6.4H48c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6h32zm80 384c35.3 0 64-28.7 64-64H256c0 17.7-14.3 32-32 32s-32-14.3-32-32H160c0 35.3 28.7 64 64 64z"]
};
var faBahtSign = {
  prefix: 'fal',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M144 0c-8.8 0-16 7.2-16 16V64H37.6C16.8 64 0 80.8 0 101.6V240v32V406.3c0 23 18.7 41.7 41.7 41.7H128v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h56c57.4 0 104-46.6 104-104c0-44.7-28.2-82.8-67.8-97.5C274.1 227.4 288 199.3 288 168c0-57.4-46.6-104-104-104H160V16c0-8.8-7.2-16-16-16zM128 96V240H32V101.6c0-3.1 2.5-5.6 5.6-5.6H128zm32 144V96h24c39.8 0 72 32.2 72 72s-32.2 72-72 72H160zm-32 32V416H41.7c-5.4 0-9.7-4.4-9.7-9.7V272h96zm32 144V272h24 32c39.8 0 72 32.2 72 72s-32.2 72-72 72H160z"]
};
var faCorner = {
  prefix: 'fal',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", "M0 176c0-8.8 7.2-16 16-16H400c26.5 0 48 21.5 48 48V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8-7.2-16-16-16H16c-8.8 0-16-7.2-16-16z"]
};
var faChevronsRight = {
  prefix: 'fal',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M75.3 459.3l192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm192 0l192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 244.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
};
var faChevronDoubleRight = faChevronsRight;
var faBookOpen = {
  prefix: 'fal',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M156 32c44.6 0 89.7 8.6 132 22.6C330.3 40.6 375.4 32 420 32c55.4 0 107.2 14.6 128.9 21.6C565.7 59 576 74.5 576 91.1V402.5c0 26.9-25.1 44.8-49 40.6c-18.5-3.2-51.3-7.2-99-7.2c-58.9 0-97.8 24.3-111.2 34.1c-7.5 5.5-17.2 9.6-28.2 9.9c-.2 0-.5 0-.7 0c-.1 0-.1 0-.2 0c-.1 0-.2 0-.3 0c-10.2 0-19.6-3.4-27-8.4C245.5 461.5 202 436 148 436c-45.2 0-80.1 4.4-100 7.7c-24 4-48-14.1-48-40.2V91.1C0 74.5 10.3 59 27.1 53.6C48.8 46.6 100.6 32 156 32zM304 440c20.3-13.5 63.1-36 124-36c49.5 0 84.1 4.2 104.4 7.6c2.5 .4 5.7-.3 8.2-2.3c2.2-1.8 3.4-4 3.4-6.8V91.1c0-3.5-2.1-6.1-4.9-7C518.6 77.5 470.5 64 420 64c-38.6 0-78.1 7.1-116 19V440zM272 83c-37.9-12-77.4-19-116-19C105.5 64 57.4 77.5 36.9 84c-2.8 .9-4.9 3.6-4.9 7V403.5c0 2.7 1.1 4.9 3.1 6.5c2.2 1.8 5.1 2.5 7.6 2.1c21.3-3.6 58-8.2 105.3-8.2c56.8 0 102.8 23.7 124 36.9V83z"]
};
var faBookJournalWhills = {
  prefix: 'fal',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V413.3c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H400c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H64zM190.5 86.3c-3.6-4.2-9.7-5.4-14.6-2.8C130.8 106.8 100 153.8 100 208c0 77.3 62.7 140 140 140s140-62.7 140-140c0-54.2-30.8-101.2-75.9-124.5c-4.9-2.5-11-1.4-14.6 2.8s-3.9 10.3-.7 14.8C295.9 111 300 123 300 136c0 17.8-7.7 33.7-20 44.7c-4.9 4.4-5.4 11.9-1 16.9c8.1 9.2 13 21.2 13 34.4c0 23.2-15.2 42.9-36.3 49.6l-.9-23.4 2.2 2.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-9-9H272c4.4 0 8-3.6 8-8s-3.6-8-8-8H259.3l9-9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-4.2 4.2L248 87.7c-.2-4.3-3.7-7.7-8-7.7s-7.8 3.4-8 7.7l-4.8 120.2-4.2-4.2c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l9 9H208c-4.4 0-8 3.6-8 8s3.6 8 8 8h12.7l-9 9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l2.2-2.2-.9 23.4c-21-6.7-36.3-26.3-36.3-49.6c0-13.2 4.9-25.2 13-34.4c4.4-4.9 3.9-12.5-1-16.9c-12.3-11-20-27-20-44.7c0-13 4.1-25 11.1-34.8c3.2-4.5 2.9-10.6-.7-14.8zm133.1 41.2c11 11.4 19.7 25.1 25.3 40.3l-18.5 18.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l12.2-12.2c1.4 7.3 2.2 14.8 2.2 22.5l0 .7-25.7 25.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L353 234.3C341.1 285.7 295 324 240 324s-101.1-38.3-113-89.7l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L124 208.7l0-.7c0-7.7 .8-15.2 2.2-22.5l12.2 12.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-18.5-18.5c5.6-15.2 14.3-28.8 25.3-40.3c-.3 2.8-.4 5.6-.4 8.4c0 20.9 7.6 40 20.2 54.7C168.5 202.6 164 216.8 164 232c0 42 34 76 76 76s76-34 76-76c0-15.2-4.5-29.4-12.2-41.3C316.4 176 324 156.9 324 136c0-2.8-.1-5.7-.4-8.4z"]
};
var faJournalWhills = faBookJournalWhills;
var faInhaler = {
  prefix: 'fal',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", "M542.5 93.5L429.5 65.3l-16.7 62.2-25.8-25.8 14-51.8c3.4-12.6 16.3-20.2 29-17l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248l-25.8-25.8L542.5 93.5zM380.7 186l-9.3 34.5c-5.6 21-24.6 35.5-46.4 35.5H232c-4.4 0-8 3.6-8 8V440c0 4.4 3.6 8 8 8H456c3.6 0 6.8-2.4 7.7-5.9l37.1-136L380.7 186zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480H232c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40h93.1c7.2 0 13.6-4.9 15.4-11.8L357 150.9c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM8 256a24 24 0 1 1 48 0A24 24 0 1 1 8 256zm96 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHandcuffs = {
  prefix: 'fal',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", "M248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-32 72c13.3 0 24 10.7 24 24c22.1 0 40 17.9 40 40v21.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7V184c0-22.1 17.9-40 40-40c0-13.3 10.7-24 24-24zm32 75.2V184c0-4.4-3.6-8-8-8H136c-4.4 0-8 3.6-8 8v11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2zM288 352A128 128 0 1 0 32 352a128 128 0 1 0 256 0zm-64 0A64 64 0 1 0 96 352a64 64 0 1 0 128 0zM64 352a96 96 0 1 1 192 0A96 96 0 1 1 64 352zm416 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-64-72c0-22.1 17.9-40 40-40c0-13.3 10.7-24 24-24s24 10.7 24 24c22.1 0 40 17.9 40 40v21.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160c-47.4 0-90-20.6-119.3-53.3c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3C408 463.5 442.1 480 480 480c70.7 0 128-57.3 128-128s-57.3-128-128-128c-37.9 0-72 16.5-95.4 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c15.2-17 34-30.7 55.3-40V184zm32 11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2V184c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v11.2zM368 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm80 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSnake = {
  prefix: 'fal',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M293.9 88H277 180C115.9 88 64 139.9 64 204s51.9 116 116 116H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H256.1h0l-.1 0 0 0-140.8 0c-8.4 0-16.8 1.7-24.6 4.9L44.8 456l45.8 19.1c7.8 3.3 16.2 4.9 24.6 4.9h60.7 0l.1 0 0 0 168 0c57.4 0 104-46.6 104-104s-46.6-104-104-104H180c-37.6 0-68-30.4-68-68s30.4-68 68-68h92 17.1l9.5 14.2c14.1 21.1 37.7 33.8 63.1 33.8h4.5c12.3 0 24.5-2.7 35.6-7.9L455 151.3c15.3-7.1 25-22.5 25-39.3s-9.8-32.2-25-39.3L400.5 47.3C390.2 42.5 379 40 367.7 40c-25.8 0-49.9 12.8-64.2 34l-9.5 14zM176 512l-.1 0H115.2c-12.7 0-25.2-2.5-36.9-7.4L14.8 478.2C5.8 474.4 0 465.7 0 456s5.8-18.4 14.8-22.2l63.5-26.5c11.7-4.9 24.2-7.4 36.9-7.4H256l.1 0H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H180C98.3 352 32 285.7 32 204S98.3 56 180 56h97c20.3-29.9 54.2-48 90.7-48c16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-53.1 24.8c-8.7 4-17.8 7-27.1 8.8c-7.2 1.4-14.6 2.1-22 2.1h-4.5c-6 0-11.9-.5-17.7-1.5c-8-1.3-15.7-3.5-23.1-6.5c-19.7-8-36.8-21.8-48.9-40H180c-19.9 0-36 16.1-36 36s16.1 36 36 36H315.1 344c6 0 11.9 .4 17.7 1.1c1.5 .2 3 .4 4.5 .7c6.8 1.1 13.5 2.8 19.9 4.8C440.6 264.4 480 315.6 480 376c0 75.1-60.9 136-136 136H176zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTriangleExclamation = {
  prefix: 'fal',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M34.5 420.4c-1.6 2.8-2.5 6-2.5 9.3c0 10.2 8.2 18.4 18.4 18.4H461.6c10.2 0 18.4-8.2 18.4-18.4c0-3.3-.9-6.4-2.5-9.3L276.5 75.8C272.2 68.5 264.4 64 256 64s-16.2 4.5-20.5 11.8L34.5 420.4zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faNoteMedical = {
  prefix: 'fal',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M384 64c17.7 0 32 14.3 32 32V309.5c0 3.6-.6 7.2-1.8 10.5H336c-26.5 0-48 21.5-48 48v78.2c-3.3 1.2-6.9 1.8-10.5 1.8H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm2.7 288L320 418.7V368c0-8.8 7.2-16 16-16h50.7zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H277.5c17 0 33.3-6.7 45.3-18.7L429.3 354.7c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zM176 144v32H144c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V272h32c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H272V144c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32zm64 0v48c0 8.8 7.2 16 16 16h48v32H256c-8.8 0-16 7.2-16 16v48H208V256c0-8.8-7.2-16-16-16H144V208h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V144h32z"]
};
var faDatabase = {
  prefix: 'fal',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M416 80.4V182.1c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 218.9 270 224 224 224s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3V80.4c.3-.8 1.6-3.2 6.2-7.1c7.3-6.2 19.9-13.2 38.1-19.7C112.6 40.6 164.8 32 224 32s111.4 8.6 147.6 21.6c18.3 6.5 30.8 13.5 38.1 19.7c4.7 4 6 6.4 6.2 7.1zm0 139.1v90.6c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 346.9 270 352 224 352s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3V219.5c17.2 8.9 38.1 16.3 61.2 21.9C130.7 250.7 175.8 256 224 256s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9zM32 431.6v-84c17.2 8.9 38.1 16.3 61.2 21.9C130.7 378.7 175.8 384 224 384s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9v84c-.3 .8-1.6 3.2-6.2 7.1c-7.3 6.2-19.9 13.2-38.1 19.7C335.4 471.4 283.2 480 224 480s-111.4-8.6-147.6-21.6c-18.3-6.5-30.8-13.5-38.1-19.7c-4.7-4-6-6.4-6.2-7.1zm384.1-.3a.1 .1 0 1 0 -.2 0 .1 .1 0 1 0 .2 0zm-384.2 0a.1 .1 0 1 0 .1 0 .1 .1 0 1 0 -.1 0zm0-350.6a.1 .1 0 1 0 .1-.1 .1 .1 0 1 0 -.1 .1zM416 80.6a.1 .1 0 1 0 -.1 .3 .1 .1 0 1 0 .1-.3zM448 432V80C448 35.8 347.7 0 224 0S0 35.8 0 80V432c0 44.2 100.3 80 224 80s224-35.8 224-80z"]
};
var faDownLeft = {
  prefix: 'fal',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", "M72 384c-4.4 0-8-3.6-8-8V174.6c0-3.7 3-6.6 6.6-6.6c1.8 0 3.4 .7 4.7 1.9l61.4 61.4c6.2 6.2 16.4 6.2 22.6 0L272 118.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L329.4 144c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L216.7 288.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l61.4 61.4c1.2 1.2 1.9 2.9 1.9 4.7c0 3.7-3 6.6-6.6 6.6H72zm-40-8c0 22.1 17.9 40 40 40H273.4c21.3 0 38.6-17.3 38.6-38.6c0-10.2-4.1-20.1-11.3-27.3L250.6 300 352 198.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L326.6 96C316.4 85.8 302.5 80 288 80s-28.4 5.8-38.6 16L148 197.4 97.9 147.3C90.7 140.1 80.9 136 70.6 136C49.3 136 32 153.3 32 174.6V376z"]
};
var faShare = {
  prefix: 'fal',
  iconName: 'share',
  icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M296 160c13.3 0 24-10.7 24-24v-8V112 64L480 208 320 352l0-48V288v-8c0-13.3-10.7-24-24-24h-8H192c-70.7 0-128 57.3-128 128c0 8.3 .7 16.1 2 23.2C47.9 383.7 32 350.1 32 304c0-79.5 64.5-144 144-144H288h8zm-8 144v16 32c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V96v16 16H256 176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h64 32v16z"]
};
var faArrowTurnRight = faShare;
var faMailForward = faShare;
var faFaceThinking = {
  prefix: 'fal',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 108.4-76.9 198.8-179.2 219.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5C424 483.2 512 379.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 23.6 3.2 46.5 9.2 68.3c2.4 8.5 11.2 13.5 19.7 11.2s13.5-11.2 11.2-19.7c-5.2-19-8.1-39-8.1-59.7zm165.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l70.5 23.5L160 348.8V320c0-26.5-21.5-48-48-48s-48 21.5-48 48V440c0 39.8 32.2 72 72 72h47.8c29.4 0 55.9-17.9 66.9-45.3l23.9-59.6 47-18.4c20.9-8.2 32.8-29.4 30.1-50.7c-2.3-18.7-15.1-34.7-33.3-40.8L197.1 256.8zM320 342.7c0 .4 0 .9 0 1.3h0c0 6.4-3.9 12.4-10.2 14.9l-53.5 20.9c-4.3 1.7-7.7 5.2-9.2 9.5c-.1 .2-.1 .4-.2 .6l-26 64.9C214.8 470 200.1 480 183.8 480H136c-22.1 0-40-17.9-40-40V320c0-8.8 7.2-16 16-16s16 7.2 16 16v52.2c0 5.3 2.6 10.2 7 13.2s9.9 3.6 14.9 1.7l148.3-58c8.2-3.2 17.5 .8 20.7 9.1c.6 1.5 .9 3 1.1 4.5zM200.4 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-120-87.2l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 94.1 162.3 90 127.1 110.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4c23.5-13.4 52.9-10.6 73.4 7z"]
};
var faTurnDownRight = {
  prefix: 'fal',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M352 208l0-57.3c0-3.7 3-6.7 6.7-6.7c1.9 0 3.7 .8 5 2.2L476.2 272 363.7 397.8c-1.3 1.4-3.1 2.2-5 2.2c-3.7 0-6.7-3-6.7-6.7l0-57.3c0-17.7-14.3-32-32-32l-176 0C82.1 304 32 253.9 32 192L32 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 112c0 26.5 21.5 48 48 48l176 0c17.7 0 32-14.3 32-32zm154.7 78c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 124.9c-7.3-8.2-17.8-12.9-28.8-12.9c-21.4 0-38.7 17.3-38.7 38.7l0 25.3 0 32-32 0-144 0c-8.8 0-16-7.2-16-16l0-112c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 192c0 79.5 64.5 144 144 144l144 0 32 0 0 32 0 25.3c0 21.4 17.3 38.7 38.7 38.7c11 0 21.5-4.7 28.8-12.9L506.7 286z"]
};
var faBottleDroplet = {
  prefix: 'fal',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M72 16C72 7.2 79.2 0 88 0l8 0V0h32 64 32 8c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0V145.1c38.3 22.1 64 63.5 64 110.9V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V256c0-47.4 25.7-88.7 64-110.9V32l-8 0c-8.8 0-16-7.2-16-16zM192 32l-64 0V145.1c0 11.4-6.1 22-16 27.7C83.2 189.5 64 220.5 64 256V448c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-35.5-19.2-66.5-48-83.2c-9.9-5.7-16-16.3-16-27.7V32zm0 305c0-5.6-4-17.2-14.6-33.5c-5.4-8.3-11.5-16.5-17.4-23.6c-5.9 7.2-12 15.3-17.4 23.6C132 319.8 128 331.4 128 337c0 16.6 13.8 31 32 31c11.5 0 19.3-3.4 23.8-7.5c4-3.6 8.2-10.3 8.2-23.5zm32 0c0 42-28.7 63-64 63s-64-28.2-64-63c0-31 34.9-73.5 53.2-93.6c5.9-6.5 15.8-6.5 21.6 0C189.1 263.5 224 306 224 337z"]
};
var faMaskFace = {
  prefix: 'fal',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M320 96c20.9 0 41.3 6.2 58.6 17.8l37.1 24.8c21 14 45.7 21.5 71 21.5H504h8v64c0 106-86 192-192 192s-192-86-192-192V160h8 16 1.2c25.3 0 50-7.5 71-21.5l37.1-24.8C278.7 102.2 299.1 96 320 96zM153.2 128H152 136h-8H48c-26.5 0-48 21.5-48 48v85c0 51.4 35 96.2 84.8 108.7l71.3 17.8 14.9 3.7c39.6 35.3 91.8 56.8 149 56.8s109.4-21.5 149-56.8l14.9-3.7 71.3-17.8C605 357.2 640 312.4 640 261V176c0-26.5-21.5-48-48-48H512h-8H486.8c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1zM48 160H96v64c0 46.3 14 89.3 38.1 125L92.6 338.7C57 329.8 32 297.8 32 261V176c0-8.8 7.2-16 16-16zM547.4 338.7L505.9 349c24.1-35.7 38.1-78.7 38.1-125V160h48c8.8 0 16 7.2 16 16v85c0 36.7-25 68.7-60.6 77.6zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16 80c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]
};
var faHillRockslide = {
  prefix: 'fal',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M238.5 127.7c-5.5-9.7-5.5-21.6 0-31.4l27-48C271.1 38.2 281.8 32 293.4 32h53.3c11.6 0 22.2 6.2 27.9 16.3l27 48c5.5 9.7 5.5 21.6 0 31.4l-27 48c-5.7 10.1-16.3 16.3-27.9 16.3H293.4c-11.6 0-22.2-6.2-27.9-16.3l-27-48zM293.4 64l-27 48 27 48 53.3 0 27-48-27-48-53.3 0zM32 118.6L32 448c0 17.7 14.3 32 32 32H393.4L32 118.6zm-32 0C0 90.1 34.5 75.8 54.6 96L416 457.4c20.2 20.2 5.9 54.6-22.6 54.6H64c-35.3 0-64-28.7-64-64V118.6zM432.3 406.5c-10.1-5.7-16.3-16.3-16.3-27.9V325.4c0-11.6 6.2-22.2 16.3-27.9l48-27c9.7-5.5 21.6-5.5 31.4 0l48 27c10.1 5.7 16.3 16.3 16.3 27.9v53.3c0 11.6-6.2 22.2-16.3 27.9l-48 27c-9.7 5.5-21.6 5.5-31.4 0l-48-27zm63.7-.9l48-27V325.4l-48-27-48 27v53.3l48 27zM128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faScannerKeyboard = {
  prefix: 'fal',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M128 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16V48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM400 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM496 0c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H288zM64 96C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 96H248c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40H248c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40zM80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zM64 400c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faCircleO = {
  prefix: 'fal',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-256a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]
};
var faGridHorizontal = {
  prefix: 'fal',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", "M40 160c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H40zM0 168c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V168zM40 320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8H40zM0 328c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328zM248 160H200c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm-48-32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8H200zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V328zM408 160H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm-48-32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8H360zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V328z"]
};
var faMessageDollar = {
  prefix: 'fal',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM272 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16V294.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"]
};
var faCommentAltDollar = faMessageDollar;
var faRightLeft = {
  prefix: 'fal',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M352 222.7c0 18.4 14.9 33.3 33.3 33.3c8.4 0 16.4-3.1 22.6-8.8l99-91.4c3.3-3 5.1-7.3 5.1-11.8s-1.9-8.7-5.1-11.8l-99-91.4c-6.1-5.7-14.2-8.8-22.6-8.8C366.9 32 352 46.9 352 65.3V128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H352v62.7zm33.3 1.3c-.7 0-1.3-.6-1.3-1.3V65.3c0-.7 .6-1.3 1.3-1.3c.3 0 .6 .1 .9 .3L472.4 144l-86.3 79.7c-.2 .2-.5 .3-.9 .3zM126.7 480c18.4 0 33.3-14.9 33.3-33.3V384H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V289.3c0-18.4-14.9-33.3-33.3-33.3c-8.4 0-16.4 3.1-22.6 8.8l-99 91.4C1.9 359.3 0 363.5 0 368s1.9 8.7 5.1 11.8l99 91.4c6.1 5.7 14.2 8.8 22.6 8.8zm1.3-33.3c0 .7-.6 1.3-1.3 1.3c-.3 0-.6-.1-.9-.3L39.6 368l86.3-79.7c.2-.2 .5-.3 .9-.3c.7 0 1.3 .6 1.3 1.3V446.7z"]
};
var faExchangeAlt = faRightLeft;
var faColumns3 = {
  prefix: 'fal',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", "M448 64V448H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H448zm-32 0H224V448H416V64zM192 448V64H64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H192zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faPaperPlane = {
  prefix: 'fal',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", "M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8 .1 290s8.4 22.9 19.6 27.6L160 376v93c0 23.8 19.3 43 43 43c13.1 0 25.4-5.9 33.6-16.1l52.8-66 .1 0 114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2l-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1c-6.1 0-11-4.9-11-11V389.3l66.6 27.8zm43.1-16.7l-96.6-40.3L474.1 70.5 416 448 301.8 400.4zM450.5 48.8L173.6 347 32 288 450.5 48.8z"]
};
var faRoadCircleExclamation = {
  prefix: 'fal',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M157.5 74c9.2-25.2 33.2-42 60.1-42H422.4c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7c-1.5 0-2.9 0-4.4 .1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H217.6c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43H339.2c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86L157.5 74zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8c-2.1 1.1-4.6 1.7-7.1 1.7c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faDungeon = {
  prefix: 'fal',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M319.3 163.6c6.2 4.2 11.9 9.1 17.1 14.4c6.1 6.3 14 11 22.7 13.5c-1.6 8.9-.8 18 2.2 26.2c3 8.2 5 16.9 6 25.9c1.1 10.4 5.7 20.5 12.9 28.5c-7.6 8.5-12.2 19.7-12.2 32v48c0 12.3 4.6 23.5 12.2 32c-7.6 8.5-12.2 19.7-12.2 32v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V416c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32V304c0-12.3-4.6-23.5-12.2-32c7.9-8.8 12.6-20.7 11.6-34.2c-2.1-30.4-9.6-59.3-21.4-85.8c-6.1-13.8-17.3-22.4-29.8-25.8c2.1-12.8-1-26.6-10.8-37.9c-17.9-20.6-39-38.3-62.5-52.3c-13-7.7-27.1-8.3-39.3-3.9c-5.7-11.7-16.2-21.1-30.8-24.7C297.2 2.5 276.9 0 256 0s-41.2 2.5-60.7 7.2c-14.6 3.6-25.1 13-30.8 24.7c-12.2-4.4-26.3-3.8-39.3 3.9c-23.6 14-44.7 31.7-62.5 52.3c-9.8 11.3-13 25.1-10.8 37.9c-12.5 3.5-23.7 12.1-29.8 25.8C10.2 178.5 2.8 207.4 .6 237.8c-1 13.5 3.7 25.4 11.6 34.2C4.6 280.5 0 291.7 0 304v48c0 12.3 4.6 23.5 12.2 32C4.6 392.5 0 403.7 0 416v48c0 26.5 21.5 48 48 48H96c26.5 0 48-21.5 48-48V416c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32V304c0-12.3-4.6-23.5-12.2-32c7.2-8 11.7-18.1 12.9-28.5c1-9 3.1-17.7 6-25.9c3-8.2 3.8-17.4 2.2-26.2c8.7-2.4 16.6-7.2 22.7-13.5c5.2-5.3 10.9-10.2 17.1-14.4c7.2-4.9 13.2-11.9 17.1-20c8.5 3 17.6 3.8 26.2 2.2c6.5-1.2 13.2-1.8 20-1.8s13.5 .6 20 1.8c8.6 1.5 17.7 .8 26.2-2.2c3.9 8.1 9.9 15.1 17.1 20zm62-5l0 0c-6.9 4.6-16.2 3.1-22-2.9c-6.7-6.9-14-13.1-21.9-18.5c-6.7-4.6-9.8-13.1-6.8-20.6l.2-.6 0 0 17.9-44.8c3.5-8.7 13.6-12.6 21.6-7.8c20.6 12.3 39.1 27.8 54.8 45.8c6 6.9 4.2 17.4-3.5 22.5l-1 .7 0 0-39.4 26.2zm16.2 27.6l1.5-1 0 0L438.4 159l0 0c7.8-5.2 18.5-2.6 22.3 6c10.3 23.2 16.8 48.5 18.7 75.1c.6 8.8-6.6 16-15.4 16H416c-8.8 0-15.9-7.2-16.9-16c-1.3-11.6-3.9-22.7-7.8-33.3c-2.7-7.5-.5-16.1 6.2-20.5zM416 400h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16zM193 59.3l0 0-.2-.4c-3.4-8.6 1.1-18.3 10.1-20.5c17-4.1 34.8-6.3 53.1-6.3s36.1 2.2 53.1 6.3c9 2.2 13.5 11.9 10.1 20.5l-.2 .4 0 .1-17.9 44.8 0 0c-3.1 7.6-11.4 11.6-19.4 10.1c-8.3-1.5-16.9-2.3-25.7-2.3s-17.3 .8-25.7 2.3c-8.1 1.5-16.4-2.5-19.4-10.1l0 0L193 59.3zm-51.3 4.1c8-4.8 18.2-.9 21.6 7.8l0 0L181.2 116l0 0 .2 .6c3 7.5-.1 16-6.8 20.6c-7.9 5.4-15.3 11.6-21.9 18.5c-5.8 6-15.1 7.5-22 2.9L91.4 132.3l0 0-1-.7c-7.6-5.1-9.5-15.6-3.5-22.5c15.7-18 34.1-33.5 54.8-45.8zM51.3 165c3.8-8.6 14.5-11.2 22.3-6L113 185.2l0 0 1.5 1c6.6 4.4 8.9 13 6.2 20.5c-3.9 10.6-6.5 21.7-7.8 33.3c-1 8.8-8 16-16.9 16H48c-8.8 0-16.1-7.2-15.4-16c1.9-26.6 8.4-51.9 18.7-75.1zM112 304v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16zm288 0c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V304zM32 416c0-8.8 7.2-16 16-16H96c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V416zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"]
};
var faHandHoldingBox = {
  prefix: 'fal',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M208 32v96c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7L288 113.9l56.8 28.4c5 2.5 10.9 2.2 15.6-.7s7.6-8.1 7.6-13.6V32h64c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64zM224 0H144C117.5 0 96 21.5 96 48V208c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H352 224zm16 32h96v70.1L295.2 81.7c-4.5-2.3-9.8-2.3-14.3 0L240 102.1V32zM195.4 304c-15.8 0-31.2 4.7-44.4 13.4L75.2 368H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c3.2 0 6.2-.9 8.9-2.7l79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h64 24 60.6c2.9 0 5.7-.8 8.2-2.3L511.3 355c3.4-2 7.2-3 11.1-3h1.3c11.2 0 20.3 9.1 20.3 20.3c0 6.9-3.5 13.3-9.2 17L415.1 467.1c-13 8.4-28.1 12.9-43.6 12.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H371.5c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3h-1.3c-9.7 0-19.1 2.6-27.5 7.6L400.2 384h-5.6c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56H195.4z"]
};
var faInputText = {
  prefix: 'fal',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm176 32c6.5 0 12.4 4 14.9 10.1l64 160c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9L216.4 320l-.4 0H136l-.4 0-8.8 21.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l64-160c2.4-6.1 8.3-10.1 14.9-10.1zm0 59.1L148.4 288h55.1L176 219.1zM288 176c0-8.8 7.2-16 16-16h56c30.9 0 56 25.1 56 56c0 12.1-3.8 23.3-10.4 32.5C421.5 258.4 432 276 432 296c0 30.9-25.1 56-56 56H304c-8.8 0-16-7.2-16-16V320 256 192 176zm72 96H320v48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H360zm0-32c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48h40z"]
};
var faWindowFlip = {
  prefix: 'fal',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M448 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H448zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zm-96 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM296 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faWindowAlt = faWindowFlip;
var faAlignRight = {
  prefix: 'fal',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm16 144c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432z"]
};
var faScannerGun = {
  prefix: 'fal',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M112 64c-44.2 0-80 35.8-80 80s35.8 80 80 80H242.9 280h24c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112zM80 251.4C33.8 237.6 0 194.7 0 144C0 82.1 50.1 32 112 32H304c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H261.2L144.3 454.6c-13.4 22.8-42.9 30.5-65.7 17L25.2 440.2C2.4 426.8-5.2 397.5 8.1 374.7L80 251.4zm34.3 4.6L35.7 390.8c-4.4 7.6-1.9 17.4 5.7 21.9l53.4 31.4c7.6 4.5 17.4 1.9 21.9-5.7L224.1 256H114.4zM432 32H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 80H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 48H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zM416 464c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16z"]
};
var faScanner = faScannerGun;
var faTire = {
  prefix: 'fal',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm319.9 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-9.9 30.4c-8.6 13.5-22.1 23.5-38 27.6l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zM240 383l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4zM130.3 280.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2zm102.1-83.7c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"]
};
var faEngine = {
  prefix: 'fal',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", "M416 80c0 8.8-7.2 16-16 16l-80 0v32h16 60.6c12.6 0 25 3.7 35.5 10.7L483.5 173c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-26.5 0-48-21.5-48-48V272H88 32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80H88h8V176c0-26.5 21.5-48 48-48h16H288V96l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H400c8.8 0 16 7.2 16 16zM304 160H160 144c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16h28.8c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12H448c17.7 0 32-14.3 32-32V226.3c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4H336 304l0 0 0 0zM168 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-32V416h32V224H576zm-32 0c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224z"]
};
var faMoneyBill1Wave = {
  prefix: 'fal',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", "M32 112.5l0-.1s0 0 0 0l0 0 0 0 0 0c.1-.1 .4-.6 1.3-1.2c2-1.3 4.7-1.8 6.9-1.2c18.7 5.1 37.3 8.1 55.8 9.5v.5c0 35.3-28.7 64-64 64V112.5zm0 309.9V376c35.3 0 64 28.7 64 64v6.8c-19.5-1.9-38.7-6-57.8-13.2c-2.5-.9-6.2-4.5-6.2-11.3zM128 440c0-53-43-96-96-96V216c52.9 0 95.8-42.8 96-95.6c57.8-1 113.9-15.3 165.7-28.6c4.4-1.1 8.7-2.2 13-3.3C356.9 75.8 403.3 65 448 64v8c0 53 43 96 96 96V296c-52.9 0-95.8 42.8-96 95.6c-57.8 1-113.9 15.3-165.7 28.6c-4.4 1.1-8.7 2.2-13 3.3C219.1 436.2 172.7 447 128 448v-8zm352-47.5V392c0-35.3 28.7-64 64-64v71.5c0 .1 0 .1 0 .1s0 0 0 0c-.1 .1-.4 .6-1.3 1.2c-2 1.3-4.7 1.8-6.9 1.2c-18.6-5.1-37.3-8.1-55.8-9.5zm0-327.3c19.5 1.9 38.7 6 57.8 13.2c2.5 .9 6.2 4.5 6.2 11.3V136c-35.3 0-64-28.7-64-64V65.2zM0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM400 256c0-65-44.9-128-112-128s-112 63-112 128s44.9 128 112 128s112-63 112-128zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM272 192c-8.8 0-16 7.2-16 16s7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272z"]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLifeRing = {
  prefix: 'fal',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M402.7 425.3C363.4 459.4 312.1 480 256 480s-107.4-20.6-146.7-54.7l91.1-91C216.1 345.4 235.3 352 256 352s39.9-6.6 55.6-17.7l91.1 91zm22.6-22.6l-91-91.1C345.4 295.9 352 276.7 352 256s-6.6-39.9-17.7-55.6l91-91.1C459.4 148.6 480 199.9 480 256s-20.6 107.4-54.7 146.7zM448 425.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0S131.8 24.2 86.6 64L75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L64 86.6C24.2 131.8 0 191.1 0 256s24.2 124.2 64 169.4L52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448c45.1 39.8 104.4 64 169.4 64s124.2-24.2 169.4-64l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L448 425.4zM402.7 86.7l-91.1 91.1C295.9 166.6 276.7 160 256 160s-39.9 6.6-55.6 17.7L109.3 86.7C148.6 52.6 199.9 32 256 32s107.4 20.6 146.7 54.7zM177.7 311.6L86.7 402.7C52.6 363.4 32 312.1 32 256s20.6-107.4 54.7-146.7l91.1 91.1C166.6 216.1 160 235.3 160 256s6.6 39.9 17.7 55.6zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHands = {
  prefix: 'fal',
  iconName: 'hands',
  icon: [608, 512, ["sign-language", "signing"], "f2a7", "M439.9 395.4c11.5-2.6 22.9-6.3 34-11.4c62.7-28.4 102.7-91 102.2-159.8l-.5-75.6c-.2-26.5-21.8-47.8-48.3-47.7c-19.5 .1-36.2 11.9-43.6 28.6L439 31C428.1 6.8 399.7-3.9 375.5 7c-5.7 2.6-10.6 6.1-14.7 10.4C347.3 1.1 324.2-4.8 304 4.3s-31 30.5-27.6 51.3c-5.9 .3-11.8 1.7-17.5 4.2c-19.3 8.8-30 28.7-27.9 48.7l40.4 17.5-7.2-15.9c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8L315.1 145l10.2 4.4 .4 .2 0 0c12.8 5.7 24.8 12.6 35.9 20.5L322.4 83.8 309.2 54.6c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l13.2 29.1L391.2 158c3.6 8 13.1 11.6 21.2 8s11.6-13.1 8-21.2L380.7 57.4c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l71.5 157.8c3.1 6.9 10.6 10.6 18 9s12.6-8.2 12.6-15.7l-.3-46.2c-.1-8.8 7.1-16 15.9-16.1s16.1 7.1 16.1 15.9l.5 75.7c.4 56.1-32.3 107.3-83.5 130.4c-4.6 2.1-9.2 3.9-13.9 5.4c-1.3 12-3.6 23.8-6.9 35.1zm-209.4-218l69.1 30.7c51.3 22.8 84.4 73.7 84.4 129.8C384 416.4 320.4 480 241.9 480H112c-8.8 0-16-7.2-16-16c0-8.8 7.1-16 16-16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64.1 0L96 416l0 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0 0h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64l0 0H48c-8.8 0-16-7.2-16-16s7.2-16 16-16H80l0 0h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16-7.2-16-16c0-8.8 7.2-16 16-16H253.2c7.6 0 14.1-5.3 15.7-12.7s-2.2-14.9-9.2-17.9l-42.2-18.8c-8.1-3.6-11.7-13-8.1-21.1s13-11.7 21.1-8.1zM67.4 446.3C65.2 451.8 64 457.8 64 464c0 26.5 21.5 48 48 48H241.9C338.1 512 416 434.1 416 337.9c0-68.8-40.5-131.1-103.4-159.1l-69.1-30.7c-24.2-10.8-52.6 .1-63.4 24.4c-7.9 17.8-4.1 37.8 8.1 51.5H80c-26.5 0-48 21.5-48 48c0 6.2 1.2 12.2 3.4 17.7C15 295.2 0 313.9 0 336s15 40.8 35.4 46.3C33.2 387.8 32 393.8 32 400c0 22.1 15 40.8 35.4 46.3z"]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faCircleCaretRight = {
  prefix: 'fal',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm352 0c0-9.6-4-18.7-11-25.2L238.2 135.3c-5.1-4.7-11.8-7.3-18.7-7.3c-15.2 0-27.5 12.3-27.5 27.5l0 201c0 15.2 12.3 27.5 27.5 27.5c6.9 0 13.6-2.6 18.7-7.3L341 281.2c7-6.5 11-15.6 11-25.2zm-32.7-1.7c.5 .4 .7 1.1 .7 1.7s-.3 1.3-.7 1.7L224 346.2l0-180.3 95.3 88.4z"]
};
var faCaretCircleRight = faCircleCaretRight;
var faWheat = {
  prefix: 'fal',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", "M433.1 36c-28.7 1.4-51.7 24.4-53.1 53.1l-2.3 45.2 45.2-2.3c28.7-1.4 51.7-24.4 53.1-53.1l2.3-45.2L433.1 36zM348 87.5C350.3 42.4 386.4 6.3 431.5 4l54-2.7c14.2-.7 25.9 11 25.2 25.2l-2.7 54c-2.3 45.1-38.3 81.2-83.5 83.5l-16.9 .8c23.1 5 45.2 16.6 63.2 34.6L493.4 222c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-17.4 17.4-39.8 26.7-62.6 28l6 6c6.2 6.2 6.2 16.4 0 22.6L369 369c-17.4 17.4-39.8 26.7-62.5 28l6 6c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-37.5 37.5-98.3 37.5-135.8 0l-33.9-33.9 0 0L27.3 507.1c-6.2 6.2-16.4 6.3-22.6 0s-6.2-16.4 0-22.6L86.2 403 52.3 369.1c-37.5-37.5-37.5-98.3 0-135.8l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0L312.4 41c18.3 18.3 29.9 40.7 34.8 64.2l.9-17.7zm88.8 168.4l22.6-22.6L448.1 222c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm-181-90.5l33.9 33.9 1.5-1.5c36-37.6 35.5-97.3-1.5-134.3L278.5 52.3 255.9 74.9c-25 25-25 65.5 0 90.5zm-56.6-11.3L188 142.8l-22.6 22.6c-25 25-25 65.5 0 90.5l33.9 33.9 1.3-1.3c36.2-37.6 35.8-97.4-1.3-134.5zM108.8 380.3l.8-.8c36.7-37.6 36.4-97.7-.8-135L97.5 233.3 74.9 255.9c-25 25-25 65.5 0 90.5l33.9 33.9zm147.1 56.5l22.6-22.6L267.2 403c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm90.5-90.5l22.6-22.6-11.3-11.3c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0z"]
};
var faFileSpreadsheet = {
  prefix: 'fal',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM96 384h80v32H96V384zm0-32V320h80v32H96zm112 64V384h80v32H208zm0-64V320h80v32H208zm112 16V352 320 304 288 256c0-17.7-14.3-32-32-32H192 96c-17.7 0-32 14.3-32 32v32 16 16 32 16 16 32c0 17.7 14.3 32 32 32h80 16 16 80c17.7 0 32-14.3 32-32V384 368zM288 256v32H192 96V256h96 96z"]
};
var faAudioDescriptionSlash = {
  prefix: 'fal',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM459.9 448H96c-17.7 0-32-14.3-32-32V135.4L32 110.2V416c0 35.3 28.7 64 64 64H500.4l-40.5-32zM544 32H139.6l40.5 32H544c17.7 0 32 14.3 32 32V376.6l32 25.3V96c0-35.3-28.7-64-64-64zM512 256c0-53-43-96-96-96H352c-8.8 0-16 7.2-16 16v11.1l32 25.3V192h48c35.3 0 64 28.7 64 64c0 13.4-4.1 25.8-11.1 36l25.2 19.9c11.3-15.7 17.9-35 17.9-55.9zM129.7 328.8c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L177.9 304h92.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2c5.1-2.6 8.3-7.5 8.8-12.8L237 272H193.9l12.2-24.4-25.7-20.3L129.7 328.8z"]
};
var faCalendarDay = {
  prefix: 'fal',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm40 160h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V264c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"]
};
var faWaterLadder = {
  prefix: 'fal',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", "M128 112c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-26.5-21.5-48-48-48s-48 21.5-48 48V224.2H384V112c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-26.5-21.5-48-48-48s-48 21.5-48 48V240.2 378.2c-10.8 4-21.8 6.2-32 6.2h0V256.2H160V378.2c-9.5-3.5-18.8-8.3-27.1-14.1c-1.6-1.1-3.2-2.2-4.9-3.1V240.2 112zm64 336c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faArrowsUpDown = {
  prefix: 'fal',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M171.3 4.7c-6.1-6.1-15.9-6.3-22.2-.4l-104 96c-6.5 6-6.9 16.1-.9 22.6s16.1 6.9 22.6 .9L144 52.5V457.4L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z"]
};
var faArrowsV = faArrowsUpDown;
var faChessPawnPiece = {
  prefix: 'fal',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", "M176 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16 80h-6.1l10.7 96H164.3l-10.7-96H128 102.3L91.6 352H59.5l10.7-96H64c-8.8 0-16-7.2-16-16s7.2-16 16-16c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 18-6 34.6-16 48c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-1.8 128c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8c0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1H190.2zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9c0 4.1 3.3 7.4 7.4 7.4H216.6c4.1 0 7.4-3.3 7.4-7.4c0-1.4-.4-2.7-1.1-3.9L190.2 416 65.8 416 33.1 468.7z"]
};
var faChessPawnAlt = faChessPawnPiece;
var faFaceGrimace = {
  prefix: 'fal',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrimace = faFaceGrimace;
var faWheelchairMove = {
  prefix: 'fal',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M368 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 368 0zM199.5 106.9c-11.9-4.9-25.6-2.1-34.7 7l-41.4 41.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l41.4-41.4c18.2-18.2 45.6-23.7 69.5-14L313.5 119c31.7 13 40 54.1 15.8 78.4l-49.1 49.1c6.9 7.9 13.1 16.4 18.4 25.6H412.1c20.5 0 35.7 19 31.2 38.9L415.6 435.5c-1.9 8.6-10.5 14.1-19.1 12.1s-14.1-10.5-12.1-19.1L412.1 304H312.7c4.8 15.2 7.3 31.3 7.3 48c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c5.6 0 11.1 .3 16.5 .8l67.7-67.7-44.7-18.3zm107.2 67.8c8.1-8.1 5.3-21.8-5.3-26.1l-25.1-10.3-62.8 62.8c15.7 5.6 30.3 13.5 43.3 23.4l49.9-49.9zM160 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faWheelchairAlt = faWheelchairMove;
var faTurnDown = {
  prefix: 'fal',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M128 352H70.7c-3.7 0-6.7 3-6.7 6.7c0 1.9 .8 3.7 2.2 5L192 476.2 317.8 363.7c1.4-1.3 2.2-3.1 2.2-5c0-3.7-3-6.7-6.7-6.7H256c-17.7 0-32-14.3-32-32V144c0-61.9-50.1-112-112-112H48c-8.8 0-16 7.2-16 16V80c0 8.8 7.2 16 16 16l64 0c26.5 0 48 21.5 48 48V320c0 17.7-14.3 32-32 32zm78 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L44.9 387.5C36.7 380.2 32 369.7 32 358.7C32 337.3 49.3 320 70.7 320H96h32V288 144c0-8.8-7.2-16-16-16l-64 0C21.5 128 0 106.5 0 80V48C0 21.5 21.5 0 48 0h64c79.5 0 144 64.5 144 144V288v32h32 25.3c21.4 0 38.7 17.3 38.7 38.7c0 11-4.7 21.5-12.9 28.8L206 506.7z"]
};
var faLevelDownAlt = faTurnDown;
var faSquareS = {
  prefix: 'fal',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160.7 94c-1.5 8.5-.5 14.1 1.5 18.2c2 4.2 5.7 8.3 11.7 12.3c12.8 8.4 31.8 13.9 54.4 20.1l1.5 .4c20.7 5.7 44.5 12.3 62 23.8c9.3 6.1 17.7 14.3 23 25.2c5.3 11.1 6.6 23.8 4 37.7c-4.5 24.3-21.6 40.2-43.1 48.5c-21.1 8.1-47.2 9.5-74.1 5.6l-.1 0 0 0c-17-2.6-46.2-11.2-61.2-15.9c-8.4-2.6-13.1-11.6-10.5-20.1s11.6-13.1 20.1-10.5c15.2 4.8 42.2 12.6 56.4 14.8c23.4 3.4 43.6 1.8 57.9-3.8c13.9-5.4 21.2-13.8 23.1-24.4c1.5-8.5 .5-14.1-1.5-18.2c-2-4.2-5.7-8.3-11.7-12.3c-12.8-8.4-31.8-13.9-54.4-20.1l-1.5-.4 0 0c-20.7-5.7-44.5-12.3-62-23.8c-9.3-6.1-17.7-14.3-23-25.2c-5.3-11.1-6.6-23.8-4-37.7c4.5-24.3 21.6-40.2 43.1-48.5c21.1-8.1 47.2-9.5 74.1-5.6c8.4 1.2 25.9 5 34.1 7c8.6 2.2 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6c-7.6-1.9-24-5.4-31-6.4c-23.4-3.5-43.6-1.8-57.9 3.8c-13.9 5.4-21.2 13.8-23.1 24.4z"]
};
var faRectangleBarcode = {
  prefix: 'fal',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 48c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm288 0c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm80-16c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM160 144c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm80-16c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144z"]
};
var faBarcodeAlt = faRectangleBarcode;
var faPersonWalkingArrowRight = {
  prefix: 'fal',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M176 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 144 56a56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8L240.7 384.2c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7c-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5l32.7-104.5c2.5-.2 5-.3 7.5-.3c15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2L66.9 422.5 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9 .7-17.5-7.2-21.5zm419.1-190c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5L579.8 240H384c-8.8 0-16 7.2-16 16s7.2 16 16 16H579.8l-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80z"]
};
var faSquareEnvelope = {
  prefix: 'fal',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM352 160v29.2L231.3 255.6c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9L96 189.2V160H352zm0 65.7V352H96V225.7l105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8L352 225.7zM96 128c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96z"]
};
var faEnvelopeSquare = faSquareEnvelope;
var faDice = {
  prefix: 'fal',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", "M252.3 57c-15.6-15.6-40.9-15.6-56.6 0L57 195.7c-15.6 15.6-15.6 40.9 0 56.6L195.7 391c15.6 15.6 40.9 15.6 56.6 0L391 252.3c15.6-15.6 15.6-40.9 0-56.6L252.3 57zM173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 448V413.8l32-32V448c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H466.7c0-10.8-1.7-21.6-5-32H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM120 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 152a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUnicorn = {
  prefix: 'fal',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M448 32h24 8 5.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7c-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1H432c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5c.2 2.2 .3 4.4 .3 6.7c0 24-10.4 45.1-26.7 59.6c-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8H344c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8c-1.4-.2-2.8-.5-4.3-.8L202.2 291.9c-5.2-1.2-10.6 .3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7c0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1H141.6c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9c0-4.6-.9-9.3-2.7-13.5L99.9 230.2C97.3 224 96 217.4 96 210.7c0-28 22.7-50.7 50.7-50.7H192h40 88c8.8 0 16-7.2 16-16c0-61.9 50.1-112 112-112zM564.2 64c-2.5-12.2-7.7-23.4-15-32.9C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16H485.8 480h-8H448C373.9 0 312.8 56 304.9 128H232 192 146.7c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2 .4 .2 .8 .2 1.2c0 .4-.1 .9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7l-15.9-57.2c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4L304 347.6V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4c0-1.9-.1-3.9-.1-5.8c.1-.7 .1-1.4 .1-2.2V192h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6c20.4-12.7 31.8-35.9 29.6-59.9l-4.7-49.4 65.2-21.7c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3H564.2zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faBowlingBall = {
  prefix: 'fal',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-120-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM240 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPompebled = {
  prefix: 'fal',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M257.2 22.7c53.3 36.8 58 117.1 21.4 183.5l-.4 .7-.5 .7c-.6 .9-.4 2 .3 2.5c.2 .2 .4 .2 .4 .2s.2 0 .2 0s.2 0 .3-.1s.3-.2 .4-.5l.4-.6 .4-.5c47.8-58 123.3-82.4 176.4-44.3c64 45.3 72.1 140.1 25.2 209.7l0 0c-83.4 123.2-257.1 185-380.5 96.5l9.3-13-9.3 13c0 0 0 0 0 0C-21.9 382.3-27.4 196.3 56.1 73.1c0 0 0 0 0 0L69.3 82 56.1 73c0 0 0 0 0 0C103.1 2.9 192.9-22.8 257.2 22.7zM238.8 48.8C192.6 16.1 122.2 31.9 82.6 90.9l0 .1C5.7 204.5 15 369.3 120.1 444.4l0 0C224.2 519 378.6 469.5 455.5 356c39.6-58.7 29.4-132.7-17.2-165.7l-.1-.1c-33.4-24-90.3-12.8-132.7 38.3c-10.7 14.7-31 18.3-46 7.5c-14.7-10.6-18.2-30.8-8.5-45.8C283.1 131.4 273.1 72.4 239 49l-.2-.1 0 0z"]
};
var faBrain = {
  prefix: 'fal',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2c1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15c2 6.1 .2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3c6.7 4.2 9.3 12.6 6.3 19.8C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8c7.5-1.3 14.9 2.9 17.6 10c6.9 18 24.4 30.8 44.8 30.8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48c-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c23.9 13.8 40 39.7 40 69.3c0 5.1-.5 10.1-1.4 15c15.8 17.1 25.4 40 25.4 65c0 29.8-13.6 56.4-34.8 74c1.8 7.1 2.8 14.4 2.8 22c0 48.6-39.4 88-88 88c-.9 0-1.8 0-2.7 0c-13.8 23.9-39.7 40-69.3 40c-26.2 0-49.4-12.6-64-32zm16-48c0 26.5 21.5 48 48 48c20.4 0 37.9-12.8 44.8-30.8c2.7-7.1 10.1-11.3 17.6-10c3.1 .5 6.3 .8 9.5 .8c30.9 0 56-25.1 56-56c0-7.8-1.6-15.2-4.4-21.8c-3.1-7.2-.4-15.7 6.3-19.8C468 331 480 310.9 480 288c0-19.1-8.4-36.3-21.7-48.1c-4.8-4.2-6.6-10.9-4.6-17c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9c-7.3-2.8-11.5-10.4-10-18c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5c-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48V432z"]
};
var faWatchSmart = {
  prefix: 'fal',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M96 48V64H288V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16V448H96v16zM80 96c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm128 80v71.4l40.9 27.2c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-48-32c-4.5-3-7.1-8-7.1-13.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faBookUser = {
  prefix: 'fal',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M0 64C0 28.7 28.7 0 64 0H400c26.5 0 48 21.5 48 48V368c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H400c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64C46.3 32 32 46.3 32 64l0 328.6zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM208 272c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H208z"]
};
var faSensorCloud = {
  prefix: 'fal',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", "M64 64H384c17.7 0 32 14.3 32 32V225c11.2 1.4 21.9 4.2 32 8.3V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H237.8c-5.2-9.9-9.1-20.7-11.4-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM336 352c0-35.3 28.7-64 64-64c24.4 0 45.7 13.7 56.5 33.9c2.5 4.6 7 7.7 12.1 8.3s10.3-1.3 13.8-5.1C489.8 317 500.3 312 512 312c22.1 0 40 17.9 40 40c0 .4 0 .9 0 1.3c-.2 7.7 5 14.4 12.5 16.1c24.9 5.7 43.6 28 43.6 54.6c0 30.9-25.1 56-56 56H344c-30.9 0-56-25.1-56-56c0-24.4 15.6-45.2 37.4-52.8c6.7-2.4 11-8.8 10.7-15.9c-.1-1.1-.1-2.2-.1-3.3zm64-96c-50.8 0-92.4 39.5-95.8 89.5C275.6 360 256 389.7 256 424c0 48.6 39.4 88 88 88H552c48.6 0 88-39.4 88-88c0-37.6-23.6-69.7-56.7-82.3c-5-34.9-35-61.7-71.3-61.7c-13.9 0-27 4-38 10.8c-17.6-21.3-44.2-34.8-74-34.8z"]
};
var faSensorSmoke = faSensorCloud;
var faClapperboardPlay = {
  prefix: 'fal',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", "M480 192V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H480zm0-32H382.6l87.3-87.3C476.1 78.5 480 86.8 480 96v64zm-249.4 0l96-96H433.4l-96 96H230.6zm-45.3 0H78.6l96-96H281.4l-96 96zM64 64h65.4l-96 96H32V96c0-17.7 14.3-32 32-32zm448 96V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64 16 16V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192 176 160zM216.1 226.2c-4.9-2.9-11.1-2.9-16.1-.1s-8.1 8.1-8.1 13.9V400c0 5.7 3.1 11 8.1 13.9s11.1 2.8 16.1-.1l136-80c4.9-2.9 7.9-8.1 7.9-13.8s-3-10.9-7.9-13.8l-136-80zM312.4 320L224 372V268l88.4 52z"]
};
var faBandage = {
  prefix: 'fal',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", "M480 128V384h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H480zm-32 0H192V384H448V128zM160 384V128H80c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h80zm0-288h32H448h32 80c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H480 448 192 160 80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h80zm112 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBandAid = faBandage;
var faCalendarMinus = {
  prefix: 'fal',
  iconName: 'calendar-minus',
  icon: [512, 512, [], "f272", "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H96c-35.3 0-64 28.7-64 64v32 32V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H384V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H160V16zM64 192H448V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zM96 96H416c17.7 0 32 14.3 32 32v32H64V128c0-17.7 14.3-32 32-32zM336 352c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336z"]
};
var faCircleXmark = {
  prefix: 'fal',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faCircle4 = {
  prefix: 'fal',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM229.9 129.1c8.2 3.3 12.2 12.6 8.9 20.8L183.6 288H288V208c0-8.8 7.2-16 16-16s16 7.2 16 16v80h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H160c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c3.3-8.2 12.6-12.2 20.8-8.9z"]
};
var faGifts = {
  prefix: 'fal',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M193.1 21.3c3-8.3-1.4-17.5-9.7-20.4s-17.5 1.4-20.4 9.7L144.5 62.8 127.2 10.9C124.4 2.6 115.3-2 106.9 .8S94 12.7 96.8 21.1L113 69.7 65.4 35.1c-7.1-5.2-17.2-3.6-22.4 3.5s-3.6 17.2 3.5 22.4L94.8 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H200.6c-5.4-9.4-8.6-20.3-8.6-32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H224c13.5 0 25.1 8.4 29.8 20.3c5.7-10 13.1-18.9 21.6-26.4C263.8 106.2 245.1 96 224 96H193.2l48.2-35.1c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5L176.3 68.7l16.8-47.4zM361.8 172.6L401.4 224H392 336c-17.7 0-32-14.3-32-32c0-17.6 14.4-32 32.2-32c10 0 19.6 4.7 25.6 12.6zM272 192c0 11.7 3.1 22.6 8.6 32H272c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-8.6c5.4-9.4 8.6-20.3 8.6-32c0-35.4-28.9-64-64.2-64c-19.9 0-38.8 9.2-51 25.1L432 211.4l-44.8-58.3c-12.2-15.8-31.1-25.1-51-25.1c-35.3 0-64.2 28.6-64.2 64zm-16 80c0-8.8 7.2-16 16-16h64 56 24v96H256V272zm0 192V384H416v96H272c-8.8 0-16-7.2-16-16zm352 0c0 8.8-7.2 16-16 16H448V384H608v80zm0-192v80H448V256h24 56 64c8.8 0 16 7.2 16 16zM472 224h-9.4l39.6-51.4c6.1-7.9 15.6-12.6 25.6-12.6c17.7 0 32.2 14.4 32.2 32c0 17.7-14.3 32-32 32H472z"]
};
var faAlbumCollection = {
  prefix: 'fal',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M32 16c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C39.2 0 32 7.2 32 16zM16 80c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272C31.4 489.9 55.6 512 84.5 512H427.5c29 0 53.1-22.1 55.8-50.9l24.7-272c3-32.8-22.8-61.1-55.8-61.1H59.8zM35.9 186.2C34.6 172.1 45.7 160 59.8 160H452.2c14.1 0 25.2 12.1 23.9 26.2l-24.7 272c-1.1 12.4-11.5 21.8-23.9 21.8H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272zM256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96s128 49.3 128 96s-50.3 96-128 96zm0 32c88.4 0 160-57.3 160-128s-71.6-128-160-128s-160 57.3-160 128s71.6 128 160 128zm0-104c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20z"]
};
var faHotel = {
  prefix: 'fal',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16H32V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H240h32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM272 432v48H240V432c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H64V32H448V480H304V432zM320 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm64 0v32H352V96h32zM240 64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H240zm0 32h32v32H240V96zM208 224v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32zm64 0v32H240V224h32zm80-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H352zm0 32h32v32H352V224zM96 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm64 0v32H128V96h32zm-32 96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H128zm0 32h32v32H128V224zm68.4 154.7C211 362.3 232.3 352 256 352s45 10.3 59.6 26.7c5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C319 334.4 289.2 320 256 320s-63 14.4-83.5 37.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3z"]
};
var faEarthAsia = {
  prefix: 'fal',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M480 256c0-91.8-55.2-170.7-134.2-205.3l-22.3 55.8c-4.8 11.9-15 20.8-27.4 24l-17 4.3c-5.6 1.4-7.9 8-4.5 12.6l16.1 21.5c10.2 13.6 10.7 32.1 1.3 46.2l-10.7 16.1c-10.4 15.6-27.9 24.9-46.6 24.9h-2.3c-5.4 0-9.2 5.2-7.7 10.3l6 19.9c7.4 24.8-11.1 49.8-37 49.8c-16.8 0-32.2-9.5-39.7-24.5l-9.3-18.5c-2.4-4.9-9-5.9-12.8-2.1l-15.4 15.4c-9.5 9.5-23 13.6-36.1 10.9l-42-8.4C62 407 150.5 480 256 480c47.4 0 91.4-14.7 127.6-39.9l-8.5-6.1-10.6 3.9c-27.7 10.3-58.6-2.7-70.6-29.6L288.4 396c-11.9-26.5-1.5-57.7 23.8-71.8L348.4 304l6.1-9.5c9-14 24.4-22.5 41.1-22.5s32.1 8.5 41.1 22.5l1.9 2.9 15.7-4.4c7.5-2.1 15.4-1.9 22.8 .4c2-12.2 3.1-24.7 3.1-37.4zm-11.6 68.4c-1.8-.9-3.8-1-5.6-.5l-15.8 4.4c-13.4 3.8-27.8-1.7-35.3-13.5l-2-3.1c-3.1-4.8-8.4-7.7-14.1-7.7s-11 2.9-14.1 7.7l-6.1 9.5c-2.8 4.4-6.7 8.1-11.4 10.7l-36.2 20.2c-10.9 6.1-15.3 19.4-10.2 30.8l5.5 12.4c5.2 11.5 18.4 17.1 30.3 12.7L372 401c5-1.9 10.6-1.1 15 2l22.4 16.2c27.3-25.6 48.1-58 59.9-94.5l-.9-.4zM315.6 40c-19-5.2-38.9-8-59.6-8C132.3 32 32 132.3 32 256c0 6.4 .3 12.8 .8 19l53.7 10.7c2.6 .5 5.3-.3 7.2-2.2l15.4-15.4c19.3-19.3 51.9-14 64.1 10.4l9.3 18.5c2.1 4.2 6.4 6.8 11 6.8c4.5 0 7.7-4.3 6.4-8.6l-6-19.9c-7.7-25.7 11.5-51.5 38.3-51.5h2.3c8 0 15.5-4 20-10.7l10.7-16.1c1.9-2.8 1.8-6.5-.3-9.2l-16.1-21.5c-17.2-22.9-5.5-55.9 22.3-62.8l17-4.3c2.5-.6 4.5-2.4 5.5-4.8L315.6 40zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm163.9 88.5l32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 3c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zM366.3 143.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"]
};
var faGlobeAsia = faEarthAsia;
var faIdCardClip = {
  prefix: 'fal',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M320 32H256V96h64V32zM256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zm64 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM208 432c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48zM64 64H192V96H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H384V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64z"]
};
var faIdCardAlt = faIdCardClip;
var faMagnifyingGlassPlus = {
  prefix: 'fal',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 304c0 8.8 7.2 16 16 16s16-7.2 16-16V224h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faThumbsUp = {
  prefix: 'fal',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M288.8 81.7c3.5-12.8 16.7-20.3 29.5-16.8s20.3 16.7 16.8 29.5l-4.5 16.4c-5.5 20.2-13.9 39.3-24.7 56.9c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2H448c17.7 0 32 14.3 32 32c0 11.3-5.9 21.3-14.8 27c-7.2 4.6-9.5 13.9-5.3 21.3c2.6 4.6 4.1 10 4.1 15.7c0 12.4-7 23.1-17.3 28.5c-4.2 2.2-7.3 6.1-8.3 10.8s.1 9.5 3 13.2c4.2 5.4 6.7 12.2 6.7 19.5c0 14.2-9.2 26.3-22.1 30.4c-7.8 2.6-12.4 10.6-10.7 18.6c.5 2.2 .7 4.5 .7 6.9c0 17.7-14.3 32-32 32H294.5c-15.8 0-31.2-4.7-44.4-13.4l-38.5-25.7c-9-6-16.6-13.7-22.4-22.6c-4.9-7.4-14.8-9.4-22.2-4.6s-9.4 14.8-4.6 22.2c8.1 12.3 18.7 23.1 31.4 31.6l38.5 25.7c18.4 12.3 40 18.8 62.1 18.8H384c35.3 0 64-28.7 64-64l0-.6c19.1-11.1 32-31.7 32-55.4c0-8.7-1.8-17.1-4.9-24.7C487.9 323.6 496 306.8 496 288c0-6.5-1-12.8-2.8-18.7C504.8 257.7 512 241.7 512 224c0-35.3-28.7-64-64-64H346.4c6.2-13.1 11.3-26.7 15.1-40.9l4.5-16.4c8.1-29.8-9.5-60.6-39.3-68.8s-60.6 9.5-68.8 39.3l-4.5 16.4c-8.9 32.6-29.6 60.8-58.2 79l-3.1 2c-11.8 7.5-21.7 17.1-29.5 28.2c-5.1 7.2-3.3 17.2 4 22.3s17.2 3.3 22.3-4c5.4-7.7 12.2-14.4 20.4-19.5l3.1-2c35.3-22.4 60.9-57.2 71.9-97.5l4.5-16.4zM32 224H96V448H32V224zM0 224V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
};
var faCloudShowers = {
  prefix: 'fal',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M96 112c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4c2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19c35.3 0 64 28.7 64 64l0 .3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3c39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72c0-33.5 22.9-61.7 53.9-69.7c8.2-2.1 13.3-10.3 11.7-18.6c-1-5.1-1.5-10.3-1.5-15.7zM512 216c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112c0 2.6 .1 5.3 .3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104zM128 384c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V384zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V384zm-96 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V416zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V416z"]
};
var faUserClock = {
  prefix: 'fal',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM32 480c1.2-79.7 66.2-144 146.3-144h91.4c18.2 0 35.6 3.3 51.7 9.4c1.4-10.8 3.8-21.4 7-31.5c-18.4-6.4-38.2-9.9-58.8-9.9H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H394.8c-12.9-9.1-24.5-19.9-34.6-32H32zM352 128A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]
};
var faOnion = {
  prefix: 'fal',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M195.8 0c2.7 0 5.3 .5 7.7 1.5l.1 0c3.2 1.4 6 3.5 8.1 6.3l0 0c.7 .9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3l0 0c2.1-2.8 4.9-5 8.1-6.3l.1 0c2.4-1 5-1.5 7.7-1.5c10.9 0 19.6 9 21.3 19.8c2.1 13.6 6.5 25.6 12.4 36.6l.1 0 0 0 0 0 .1 .1 .2 .4 .7 1.4 1.2 2.2c15.3 25.7 39.5 45.4 64.5 65.7C399 163.7 448 203.5 448 288c0 83.4-62.5 139.3-140.4 163.1l-.1 .1-.6 .6-.2 .2-.1 .1 0 0 0 0s0 0-.1-.1c-.1-.1-.2-.2-.3-.4l-.1 0 13.1 39.4c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-14-42c-11.5 2.1-23.1 3.5-34.8 4.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V463.4c-11.7-.8-23.3-2.2-34.8-4.3l-14 42c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2L142 451.5C63.4 428 0 372 0 288c0-84.5 49-124.3 95.3-162C120.5 105.6 144.8 85.8 160 60l1-1.8 .7-1.3 .2-.3 .1-.1 0 0 0 0 .1 0c6-11 10.3-23 12.5-36.6C176.2 9 184.9 0 195.8 0zM119.2 147.9l-4.8 3.9 0 0c-4.5 3.7-8.9 7.3-13.1 10.7C62 195.3 32 227 32 288c0 43.8 21.5 78.3 56.8 103.3c6 4.3 12.5 8.3 19.2 11.9C93.2 378.7 80 345.3 80 304c0-48.4 19.7-108.4 39.2-156.1zm48 277.2c14.6 3.4 29.6 5.5 44.9 6.4c-2.2-4.5-4.5-9.4-6.8-14.9C194.6 391.3 184 355.2 184 312c0-61.9 6.1-128.6 12.1-179.6c3-25.6 6-47.3 8.3-62.6c1.1-7.7 2.1-13.8 2.7-17.9l.2-1.3c-2.3-1-4.4-2.3-6.5-3.7c-3.4 10.4-7.7 19.9-12.9 28.7l-1.2 2.4c-2.1 4.1-5.2 10.1-8.9 17.6c-7.4 15-17.2 35.9-27.1 59.7C130.8 203.4 112 260.8 112 304c0 39.4 14.5 70.3 29.2 91.5c7.3 10.6 14.7 18.7 20.1 24.1c2.4 2.4 4.4 4.2 5.9 5.5zm80.7 5.5c14.7-1.5 29.2-4.2 43.1-8c.8-.8 1.6-1.7 2.6-2.7c5.1-5.6 12-13.8 18.9-24.3c13.8-21 27-49.9 27-83.6c0-44.9-19.7-104.3-40.5-154.1c-10.3-24.6-20.5-46.2-28.2-61.6c-3.8-7.7-7-13.9-9.3-18.1l-1.2-2.2c-5.2-8.9-9.7-18.6-13.1-29.1c-2.3 1.7-4.8 3-7.4 4.1l0 .1-.2 1.2c-.2 1-.4 2.6-.7 4.6c-.6 4.1-1.6 10-2.7 17.6c-2.2 15.1-5.2 36.5-8.2 61.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c4.7 11.2 9.4 19.9 12.8 25.8l.3 .5zm81.9-282c20.5 49.6 41.7 112.6 41.7 163.4c0 34.3-10.9 63.9-23.6 86.7c3.9-2.4 7.7-4.9 11.4-7.4c35.3-25 56.8-59.5 56.8-103.3c0-61-30-92.7-69.3-125.5c-4.1-3.5-8.5-7-13.1-10.7l-3.9-3.2z"]
};
var faClockTwelveThirty = {
  prefix: 'fal',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 144V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faArrowDownToDottedLine = {
  prefix: 'fal',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", "M363.3 219.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4V192 48c0-8.8 7.2-16 16-16s16 7.2 16 16V192 297.4L340.7 196.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHandDots = {
  prefix: 'fal',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8c30.9 0 56 25.1 56 56v13.4c7.3-3.5 15.4-5.4 24-5.4c30.9 0 56 25.1 56 56V336c0 97.2-78.8 176-176 176h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0L128 288.8V88c0-30.9 25.1-56 56-56c9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V327.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H304c79.5 0 144-64.5 144-144V152c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V152.1l0-.1V88c0-13.3-10.7-24-24-24c-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24V79.9l0 .1V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88.1l0-.1zm32 232a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faAllergies = faHandDots;
var faFileInvoice = {
  prefix: 'fal',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM224 432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm64-96H96V272H288v64zM96 240c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H96z"]
};
var faWindowMinimize = {
  prefix: 'fal',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faRectangleWide = {
  prefix: 'fal',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M576 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faCommentArrowUp = {
  prefix: 'fal',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 150.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 182.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6z"]
};
var faGarlic = {
  prefix: 'fal',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M192 48c0-8.8 7.2-16 16-16h32V70.2c0 51.4 18.4 101.1 51.9 140.2l17.1 19.9c17.5 20.4 27.1 46.5 27.1 73.3C336 365.6 285.8 416 224 416c-61.9 0-112-50.1-112-112v-5.3c0-24.4 7.6-48.3 21.8-68.2L149 209.3c24.6-34.5 39.2-75 42.3-117.1c.4-3.6 .6-7.3 .6-11V75.2 56 48zm-32 0v8V75.2c0 4.7-.2 9.3-.5 14c-2.1 16.4-10.4 31.6-23.5 42L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448H144v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h3.5C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2c-15.2-12.1-24-30.5-24-50V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48zM72.7 222.8l61-48.8c-3.3 5.7-6.8 11.3-10.7 16.7l-15.2 21.2C89.7 237.3 80 267.6 80 298.7V304c0 45.1 20.7 85.4 53.2 111.8C76.7 412 32 365 32 307.5c0-33 15-64.1 40.7-84.7zM371.5 416H314.3c32.7-26.5 53.7-67.1 53.7-112.3c0-34.5-12.3-68-34.8-94.2l-17.1-19.9C287.7 156.4 272 114 272 70.2V32h32c8.8 0 16 7.2 16 16V81.2c0 29.2 13.3 56.7 36 75l83.3 66.6C465 243.4 480 274.6 480 307.5C480 367.4 431.4 416 371.5 416z"]
};
var faMugSaucer = {
  prefix: 'fal',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", "M416 64h16 16V224v32 32c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V64H416zm64 224V256h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H448 432 416 128c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96zm48-64H480V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faCoffee = faMugSaucer;
var faBrush = {
  prefix: 'fal',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M256 352c-17.7 0-32 14.3-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7-14.3-32-32-32H80c-26.5 0-48-21.5-48-48V288H352v16c0 26.5-21.5 48-48 48H256zm96-96H32V64c0-17.7 14.3-32 32-32H96V144c0 8.8 7.2 16 16 16s16-7.2 16-16V32h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V32h96c17.7 0 32 14.3 32 32V256zM80 384H96h32v32 32c0 35.3 28.7 64 64 64s64-28.7 64-64V416 384h32 16c44.2 0 80-35.8 80-80V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V304c0 44.2 35.8 80 80 80z"]
};
var faTreeDecorated = {
  prefix: 'fal',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", "M236.4 5.9C233.3 2.2 228.8 0 224 0s-9.3 2.2-12.4 5.9L70.3 178.6c-4.1 5-6.3 11.2-6.3 17.6C64 211.6 76.4 224 91.8 224h18.9L38.1 314.8c-3.9 4.9-6.1 11.1-6.1 17.4C32 347.5 44.5 360 59.8 360H81.1L5.2 467.6C1.8 472.4 0 478 0 483.9C0 499.4 12.6 512 28.1 512H160 288 419.9c15.5 0 28.1-12.6 28.1-28.1c0-5.8-1.8-11.5-5.2-16.2L366.9 360h21.3c15.4 0 27.8-12.5 27.8-27.8c0-6.3-2.2-12.5-6.1-17.4L337.3 224h18.9c15.4 0 27.8-12.4 27.8-27.8c0-6.4-2.2-12.6-6.3-17.6L236.4 5.9zM412.4 480H288 160 35.6l89.5-126.8c3.4-4.9 3.9-11.3 1.1-16.6s-8.2-8.6-14.2-8.6H68.5l88-110c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H100.7L224 41.3 347.3 192H304c-6.2 0-11.8 3.5-14.4 9.1s-1.9 12.1 1.9 16.9l88 110H336c-6 0-11.5 3.3-14.2 8.6s-2.3 11.7 1.1 16.6L412.4 480zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMask = {
  prefix: 'fal',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M80.9 150.2C46 180.3 32 222.2 32 272c0 47.9 16.9 83.2 41.9 106.7C99.2 402.4 135 416 176 416h8.4c12.1 0 23.2-6.8 28.6-17.7L236.2 352l28.6 14.3-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4H176C80 448 0 384 0 272S64 64 288 64s288 96 288 208s-80 176-176 176h-8.4c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3L236.2 352c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7H400c41 0 76.8-13.6 102.1-37.3c25-23.4 41.9-58.7 41.9-106.7c0-49.8-14-91.7-48.9-121.8C459.3 119.3 396.2 96 288 96s-171.3 23.3-207.1 54.2zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm288 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faCalendarHeart = {
  prefix: 'fal',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm80 205.3c0-16.2 13.1-29.3 29.3-29.3c7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6c16.2 0 29.3 13.1 29.3 29.3c0 7.8-3.1 15.2-8.6 20.7L224 393.4l-71.4-71.4c-5.5-5.5-8.6-12.9-8.6-20.7zM173.3 240c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faMagnifyingGlassMinus = {
  prefix: 'fal',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM112 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faFlower = {
  prefix: 'fal',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM203.3 88.7C185.1 73.3 161.7 64 136 64C78.6 64 32 110.6 32 168c0 25.7 9.3 49.1 24.7 67.3c10.1 11.9 10.1 29.5 0 41.4C41.3 294.9 32 318.3 32 344c0 57.4 46.6 104 104 104c25.7 0 49.1-9.3 67.3-24.7c11.9-10.1 29.5-10.1 41.4 0C262.9 438.7 286.3 448 312 448c57.4 0 104-46.6 104-104c0-25.7-9.3-49.1-24.7-67.3c-10.1-11.9-10.1-29.5 0-41.4C406.7 217.1 416 193.7 416 168c0-57.4-46.6-104-104-104c-25.7 0-49.1 9.3-67.3 24.7c-11.9 10.1-29.5 10.1-41.4 0zM272 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faArrowDownFromArc = {
  prefix: 'fal',
  iconName: 'arrow-down-from-arc',
  icon: [512, 512, [], "e614", "M116 362.6c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3L240 453.9 240 176c0-8.8 7.2-16 16-16s16 7.2 16 16V453.9L372 341.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6l-128 144c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4l-128-144zM256 32C132.3 32 32 132.3 32 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C0 114.6 114.6 0 256 0S512 114.6 512 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C480 132.3 379.7 32 256 32z"]
};
var faRightLeftLarge = {
  prefix: 'fal',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M205.2 496c-12.4 0-24.4-4.6-33.7-12.8L49.3 374.6C38.3 364.8 32 350.7 32 336s6.3-28.8 17.3-38.6L171.5 188.8c9.3-8.3 21.3-12.8 33.7-12.8c28 0 50.8 22.7 50.8 50.8V240h32 64l32 0h16c8.8 0 16 7.2 16 16l0 16v13.2c0 10.4 8.4 18.8 18.8 18.8c4.6 0 9-1.7 12.5-4.7L569.4 190.7c4.2-3.7 6.6-9.1 6.6-14.7s-2.4-10.9-6.6-14.7L447.3 52.7c-3.4-3.1-7.9-4.7-12.5-4.7C424.4 48 416 56.4 416 66.8V80 96c0 8.8-7.2 16-16 16H384 288c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V66.8c0-28 22.7-50.8 50.8-50.8c12.4 0 24.4 4.6 33.7 12.8L590.7 137.4c11 9.8 17.3 23.8 17.3 38.6s-6.3 28.8-17.3 38.6L468.5 323.2c-9.3 8.3-21.3 12.8-33.7 12.8c-28 0-50.8-22.7-50.8-50.8V272l-32 0H288 256 240c-8.8 0-16-7.2-16-16V240 226.8c0-10.4-8.4-18.8-18.8-18.8c-4.6 0-9 1.7-12.5 4.7L70.6 321.3c-4.2 3.7-6.6 9.1-6.6 14.7s2.4 10.9 6.6 14.7L192.7 459.3c3.4 3.1 7.9 4.7 12.5 4.7c10.4 0 18.8-8.4 18.8-18.8V432 416c0-8.8 7.2-16 16-16h16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0v13.2c0 28-22.7 50.8-50.8 50.8z"]
};
var faRulerVertical = {
  prefix: 'fal',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M192 32c17.7 0 32 14.3 32 32V96H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]
};
var faCirclesOverlap = {
  prefix: 'fal',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", "M232 415.8c-25.2-36.2-40-80.3-40-127.8c0-99.1 64.3-183.1 153.5-212.7C312.4 48.2 270.1 32 224 32C118 32 32 118 32 224s86 192 192 192c2.7 0 5.4-.1 8-.2zm36.4-5C353 390.8 416 314.7 416 224c0-46.7-16.7-89.5-44.4-122.8C287 121.2 224 197.3 224 288c0 46.7 16.7 89.5 44.4 122.8zm-11.6 34.8c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4zM408 96.2c25.2 36.3 40 80.3 40 127.8c0 99.1-64.3 183.1-153.5 212.7C327.6 463.8 369.9 480 416 480c106 0 192-86 192-192s-86-192-192-192c-2.7 0-5.4 .1-8 .2z"]
};
var faUserLarge = {
  prefix: 'fal',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", "M368 144a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM32 480H480c-.7-70.8-58.3-128-129.3-128H161.3C90.3 352 32.7 409.2 32 480zM0 481.3C0 392.2 72.2 320 161.3 320H350.7C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"]
};
var faUserAlt = faUserLarge;
var faStarshipFreighter = {
  prefix: 'fal',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M377.1 371.9L315.5 285c2.9-9.2 4.5-18.9 4.5-29c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c.6 0 1.1 0 1.7 0l60.7 85.7C266.8 444.4 245.8 448 224 448C118 448 32 362 32 256S118 64 224 64c104.4 0 189.3 83.3 191.9 187c0 1.6 .1 3.3 .1 5c0 1.7 0 3.5-.1 5.2c-1.1 41.5-15.4 79.8-38.9 110.7zM405.4 400H397l-.6-.9c22.5-27.1 38.7-59.5 46.5-95.1h4.6H544v42.1L405.4 400zM460 413.1l95.6-37.2c12.3-4.8 20.4-16.6 20.4-29.8V304c0-17.7-14.3-32-32-32H479.5 447.4c.4-5.3 .6-10.6 .6-16c0-5.3-.2-10.6-.6-15.8l0-.2h32.1H544c17.7 0 32-14.3 32-32V165.9c0-13.2-8.1-25-20.4-29.8L347.6 55.2C308.2 39.9 266.3 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480c28.7 0 57.1-3.6 84.8-10.7l13.5 19.1C332.8 503.2 349.8 512 368 512h56c30.9 0 56-25.1 56-56c0-17.2-7.8-32.6-20-42.9zM447.4 208h-4.6c-8.4-38.6-26.8-73.5-52.3-101.8L544 165.9l0 42.1H447.4zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM348.2 469.6L262.3 344.1c15-6.5 28-16.8 37.9-29.6L380.7 432H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H368c-7.9 0-15.3-3.9-19.8-10.4z"]
};
var faTrainTram = {
  prefix: 'fal',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", "M41.3 50c9.1-11.4 22.9-18 37.5-18H208V96H160c-53 0-96 43-96 96V352c0 28.9 12.8 54.8 33 72.4L36.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l65.8-65.8c10.8 4.2 22.6 6.5 34.9 6.5H288c12.3 0 24-2.3 34.9-6.5l65.8 65.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L351 424.4c20.2-17.6 33-43.5 33-72.4V192c0-53-43-96-96-96H240V32H369.2c14.6 0 28.4 6.6 37.5 18l12.8 16c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5L431.7 30C416.5 11 393.5 0 369.2 0H78.8C54.5 0 31.5 11 16.3 30L3.5 46C-2 52.9-.9 63 6 68.5S23 72.9 28.5 66L41.3 50zM160 128h48 32 48c35.3 0 64 28.7 64 64v64H96V192c0-35.3 28.7-64 64-64zM96 288H352v64c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V288zm96 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBridgeSuspension = {
  prefix: 'fal',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", "M128 0c6.4 0 11.9 3.7 14.5 9.2l6.6 13.2C181.4 87.1 247.6 128 320 128s138.6-40.9 170.9-105.6l6.6-13.2C500.1 3.7 505.6 0 512 0c7.2 0 13.3 4.7 15.3 11.3c14.5 43 58.7 87.5 102.6 104.9c8.2 3.3 12.2 12.6 9 20.8s-12.6 12.2-20.8 9c-33-13.1-66-38.6-90.1-69.1V256h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V76.8c-24.1 30.5-57.1 56-90.1 69.1c-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8C54 98.7 98.2 54.3 112.7 11.3C114.7 4.7 120.8 0 128 0zm16 256h64V129.9c-24.5-14.2-46.3-33.1-64-55.8V256zm96 0h64V159.4c-22.2-1.6-43.7-6.5-64-14.3V256zm96 0h64V145.2c-20.3 7.8-41.8 12.7-64 14.3V256zm96 0h64V74c-17.7 22.7-39.5 41.6-64 55.8V256zM16 320H32c53 0 96 43 96 96v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448c0-70.7 57.3-128 128-128s128 57.3 128 128v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V416c0-53 43-96 96-96h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608c-35.3 0-64 28.7-64 64v48c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V448c0-53-43-96-96-96s-96 43-96 96v16c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V416c0-35.3-28.7-64-64-64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTrashCheck = {
  prefix: 'fal',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64h47.1H416h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H413.7L388.2 452.6C385.9 486.1 358 512 324.4 512H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64.1h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96L91.7 450.3C92.9 467 106.8 480 123.6 480H324.4c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM331.3 235.3l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L192 329.4 308.7 212.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faUserNurse = {
  prefix: 'fal',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M128 128v16H320V128 70.2l-96-36-96 36V128zM96 160V128 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128v32 16c0 70.7-57.3 128-128 128s-128-57.3-128-128V160zm224 16H128c0 53 43 96 96 96s96-43 96-96zM119 359.1C68.7 376.5 32.5 424 32 480H416c-.5-56-36.7-103.5-86.9-120.9L259 433.6c-19 20.1-51 20.1-69.9 0L119 359.1zm22.4-22.9l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6c10.5-3.4 21.8 .4 29.4 8.5zM216 48h16c4.4 0 8 3.6 8 8V72h16c4.4 0 8 3.6 8 8V96c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V104H192c-4.4 0-8-3.6-8-8V80c0-4.4 3.6-8 8-8h16V56c0-4.4 3.6-8 8-8z"]
};
var faBoombox = {
  prefix: 'fal',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", "M144 32H496c26.5 0 48 21.5 48 48v80H96V80c0-26.5 21.5-48 48-48zM64 80v80c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64V80c0-44.2-35.8-80-80-80H144C99.8 0 64 35.8 64 80zM80 192H560h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H80zM96 336a80 80 0 1 1 160 0A80 80 0 1 1 96 336zm192 0A112 112 0 1 0 64 336a112 112 0 1 0 224 0zm176-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM208 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400z"]
};
var faSyringe = {
  prefix: 'fal',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", "M404.7 4.7c-6.2 6.2-6.2 16.4 0 22.6L433.4 56 384 105.4 315.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80 80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 456 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-40-40-40-40c-6.2-6.2-16.4-6.2-22.6 0zm-272 224L82.7 278.6c-12 12-18.7 28.3-18.7 45.3V425.4L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448H188.1c17 0 33.3-6.7 45.3-18.7l192-192-22.6-22.6-192 192c-6 6-14.1 9.4-22.6 9.4H96V323.9c0-8.5 3.4-16.6 9.4-22.6L144 262.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240 208 198.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 176l66.7-66.7L274.7 86.6l-78.1 78.1s0 0 0 0s0 0 0 0l-64 64s0 0 0 0s0 0 0 0z"]
};
var faCloudSun = {
  prefix: 'fal',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4L43.7 139.6l71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71 59.2 41.4c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l71 11.8-40.2 57.5c11.4-3.3 23.4-5.1 35.8-5.1c2.2 0 4.5 .1 6.7 .2l38.5-55c3.1-4.5 3.8-10.3 1.6-15.4s-6.7-8.7-12.1-9.6L317.9 98.1 303.8 13.4zm-59.9 275c7.8-30.6 26.5-56.8 51.9-74.1c.1-2.1 .2-4.2 .2-6.3c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6zM264 208a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm40 112c0-35.3 28.7-64 64-64c29.1 0 53.7 19.4 61.4 46c1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2c26.5 0 48 21.5 48 48c0 8.8-2.3 16.9-6.4 24c-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8l8.3 0 0 0 .2 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.2 0-1.8 0l-.3 0-.2 0H290.9c-.2 0-.4 0-.6 0c-.8 0-1.6 0-2.3 0c-35.3 0-64-28.7-64-64s28.7-64 64-64c.4 0 .8 0 1.3 0c4.9 .1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.7c0 53 43 96 96 96c1.1 0 2.1 0 3.2-.1H557.3c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-39.4-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.4 242.6 402.9 224 368 224z"]
};
var faShieldExclamation = {
  prefix: 'fal',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 128c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faStopwatch20 = {
  prefix: 'fal',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64V96.6C100.6 104.8 16 194.5 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-47.6-16-91.4-42.9-126.5l38.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-37 37c-33.7-32.3-78.3-53.3-127.7-57V32h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm80 480a176 176 0 1 1 0-352 176 176 0 1 1 0 352zm16-240V368c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48-16c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM151.8 235.3c2.3-6.8 8.6-11.3 15.7-11.3c9.1 0 16.5 7.4 16.5 16.5v14.8c0 7.1-2.4 14-6.9 19.6l-32.6 40.7c-15.9 19.9-24.5 44.5-24.5 70V400c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H152c.4-17.6 6.5-34.6 17.5-48.3L202.1 295c9-11.2 13.9-25.2 13.9-39.6V240.5c0-26.8-21.7-48.5-48.5-48.5c-20.9 0-39.4 13.4-46.1 33.2l-.6 1.7c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l.6-1.7z"]
};
var faSquareFull = {
  prefix: 'fal',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M480 32V480H32V32H480zM32 0H0V32 480v32H32 480h32V480 32 0H480 32z"]
};
var faGripDots = {
  prefix: 'fal',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", "M384 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 176a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM384 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM208 336a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCommentExclamation = {
  prefix: 'fal',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm0 80c-8.8 0-16 7.2-16 16V256c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPenSwirl = {
  prefix: 'fal',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", "M454.8 45.5c-12.6-12.6-32.9-12.5-45.4 .1L383 72.4l57 57 26.7-26.8c12.5-12.5 12.5-32.8 0-45.2L454.8 45.5zM218.2 239.2c-4.3 4.4-7.3 9.9-8.6 15.9l-12.9 61.7 61.5-12.9c6.1-1.3 11.7-4.3 16.1-8.7L417.4 152 360.5 95.1 218.2 239.2zM386.7 23.1c24.9-25.3 65.7-25.4 90.8-.3l11.9 11.9c25 25 25 65.5 0 90.5L296.9 317.8c-8.8 8.8-20 14.8-32.1 17.4l-85.5 17.9c-5.3 1.1-10.8-.5-14.6-4.3s-5.5-9.3-4.3-14.6l18-85.7c2.5-12 8.5-23.1 17.1-31.8L386.7 23.1zM301.1 52.9C286.5 49.7 271.5 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c8.8 0 16 7.2 16 16s-7.2 16-16 16C123.5 496 16 388.5 16 256S123.5 16 256 16c24.7 0 48.5 3.7 71 10.7L301.1 52.9zM485.5 185.7c6.8 22.2 10.5 45.8 10.5 70.3c0 79.5-64.5 144-144 144c-12.4 0-24.5-1.6-36-4.5c-8.6-2.2-13.7-10.9-11.5-19.5s10.9-13.7 19.5-11.5c8.9 2.3 18.3 3.5 28 3.5c61.9 0 112-50.1 112-112c0-15.1-1.6-29.9-4.7-44.1l26.2-26.2z"]
};
var faFalafel = {
  prefix: 'fal',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M160.4 177.7c-11.7-15.9-11.2-38 1.5-53.4c2.3-2.7 3.1-6.5 2.2-10.1c-5.1-20.1 4.7-41.3 23.7-50c3.1-1.4 5.4-4.3 6.1-7.9C198 35.9 216 21 237 21.6c3.3 .1 6.5-1.4 8.6-4.3C258 .5 280.7-4.9 299.3 4.9c3 1.6 6.5 1.6 9.4 0C327.3-4.9 350 .5 362.4 17.3c2.1 2.9 5.3 4.4 8.6 4.3c21-.6 39 14.3 42.9 34.7c.7 3.6 3.1 6.5 6.1 7.9c19 8.7 28.8 29.9 23.7 50c-.9 3.6 0 7.4 2.2 10.1c13.2 16 13.2 39.3 0 55.3c-2.3 2.7-3.1 6.5-2.2 10.1c.2 1 .5 2 .6 3c-4.2 .6-8.4 1.6-12.5 3c-6.6-2.2-13.4-3.4-20.2-3.7c-1.4-11.7 2-23.6 9.6-32.8c3.5-4.2 3.5-10.4 0-14.5c-8.8-10.7-12-25-8.6-38.4c1.4-5.5-1.4-10.9-6-13c-12.6-5.8-21.6-17.4-24.2-30.9c-1.1-5.5-5.7-9-10.6-8.9c-13.9 .4-27-6.1-35.3-17.3c-3.1-4.3-8.6-5.4-13-3.1c-12.3 6.5-27 6.5-39.3 0c-4.4-2.3-9.9-1.2-13 3.1C263.1 47.5 250 54 236 53.6c-4.9-.1-9.5 3.4-10.6 8.9c-2.6 13.6-11.6 25.2-24.2 30.9c-4.6 2.1-7.4 7.5-6 13c3.4 13.4 .2 27.7-8.6 38.4c-3.5 4.2-3.5 10.4 0 14.5c4.7 5.6 7.8 12.3 9.1 19.3c-11.4-3.1-23.5-3.5-35.3-.9zM240 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm27.2 182.2c-.5-3.7-2.8-7.1-6.5-8.8c-12.8-5.7-22-17.2-24.7-30.9c-1.1-5.3-5.8-9.1-11.3-8.9c-14 .4-27.3-6-35.7-17.1c-3.3-4.3-9.2-5.7-14.1-3.2c-12.4 6.4-27.2 6.4-39.6 0c-4.9-2.5-10.8-1.1-14.1 3.2c-8.4 11.2-21.7 17.5-35.7 17.1c-5.5-.2-10.2 3.7-11.3 8.9c-2.7 13.7-12 25.2-24.7 30.9c-5 2.2-7.6 7.7-6.2 12.9c3.5 13.5 .2 27.9-8.8 38.6c-3.5 4.1-3.5 10.1 0 14.3c9 10.7 12.3 25 8.8 38.6c-1.3 5.2 1.3 10.6 6.2 12.9c12.8 5.7 22 17.2 24.7 30.9c1.1 5.3 5.8 9.1 11.3 8.9c14-.4 27.3 6 35.7 17.1c3.3 4.3 9.2 5.7 14.1 3.2c12.4-6.4 27.2-6.4 39.6 0c4.9 2.5 10.8 1.1 14.1-3.2c8.4-11.1 21.7-17.5 35.7-17.1c5.5 .2 10.2-3.7 11.3-8.9c2.7-13.7 12-25.2 24.7-30.9c2.5-1.1 4.4-3 5.5-5.3c-.1 12 2.8 23.7 8.2 34.2l-.7 .3c-3.3 1.5-5.7 4.4-6.4 8c-4.1 20.6-22.5 35.2-43.5 34.6c-3.6-.1-7.1 1.6-9.2 4.4c-12.7 16.8-35.6 22-54.3 12.4c-3.2-1.7-7.1-1.7-10.3 0c-18.7 9.6-41.6 4.4-54.3-12.4c-2.2-2.9-5.6-4.5-9.2-4.4c-21 .6-39.4-14-43.5-34.6c-.7-3.5-3.1-6.5-6.4-8c-19.2-8.6-29.4-29.7-24.2-50.1c.9-3.5 .1-7.1-2.3-9.9c-13.6-16.1-13.6-39.6 0-55.6c2.3-2.7 3.2-6.4 2.3-9.9c-5.3-20.4 5-41.5 24.2-50.1c3.3-1.5 5.7-4.4 6.4-8c4.1-20.6 22.5-35.2 43.5-34.6c3.6 .1 7.1-1.6 9.2-4.4c12.7-16.8 35.6-22 54.3-12.4c3.2 1.7 7.1 1.7 10.3 0c18.7-9.6 41.6-4.4 54.3 12.4c2.2 2.9 5.6 4.5 9.2 4.4c21-.6 39.4 14 43.5 34.6c.7 3.5 3.1 6.5 6.4 8c2.9 1.3 5.6 2.9 8.1 4.7c-7.6 9.7-12.6 21.2-14.6 33.3zM64 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm13.1-159c-3.7-2-8.4-1-11.1 2.7c-7.9 10.8-20.6 17-34 16.6c-4.1-.1-8.1 2.8-9 7.6c-2.5 13.1-11.2 24.2-23.3 29.8c-3.9 1.8-6.3 6.4-5.1 11.2c3.3 12.9 .2 26.7-8.3 36.9c-3 3.6-3 8.9 0 12.5c8.5 10.3 11.5 24 8.3 36.9c-1.2 4.7 1.2 9.4 5.1 11.2c12.2 5.6 20.8 16.7 23.3 29.8c.9 4.7 4.9 7.7 9 7.6c13.4-.4 26.1 5.9 34 16.6c2.7 3.6 7.4 4.6 11.1 2.7c11.9-6.3 26-6.3 37.8 0c3.7 2 8.4 1 11.1-2.7c7.9-10.8 20.6-17 34-16.6c4.1 .1 8.1-2.8 9-7.6c2.5-13.1 11.2-24.2 23.3-29.8c3.9-1.8 6.3-6.4 5.1-11.2c-2.5-9.7-1.3-19.9 3-28.8c-25.6-4.9-53-20.9-75.5-43.4c-24.1-24.1-40.5-53.5-44.2-80.3c-1.3-.5-2.5-1.1-3.7-1.7zM428 228.7c1.3 .7 2.6 1 4 1c4.3 0 8.5 1.7 11.5 4.8s4.6 7.3 4.5 11.6c-.5 18.2 11 45.6 35.6 70.2c26.8 26.8 56.4 37.7 74.2 35.3c4.5-.6 9.1 .7 12.6 3.7s5.5 7.3 5.6 11.9c.2 9.7-3 19.5-9.6 27.4c-1.9 2.3-2.7 5.6-1.9 8.7c4.9 19.4-4.5 39.7-22.8 48.1c-2.6 1.2-4.6 3.7-5.2 6.8c-3.8 19.6-21.1 34-41.4 33.4c-2.8-.1-5.5 1.2-7.3 3.7c-12 16.2-33.8 21.4-51.8 12c-2.5-1.3-5.5-1.3-8 0c-17.9 9.4-39.8 4.2-51.8-12c-1.8-2.4-4.6-3.7-7.3-3.7c-20.2 .6-37.5-13.8-41.4-33.4c-.6-3.1-2.6-5.6-5.2-6.8c-18.3-8.4-27.7-28.8-22.8-48.1c.8-3.1 0-6.3-1.9-8.7c-12.8-15.4-12.8-37.9 0-53.3c1.9-2.3 2.7-5.6 1.9-8.7c-4.9-19.4 4.5-39.7 22.8-48.1c2.6-1.2 4.6-3.7 5.2-6.8c3.8-19.6 21.1-34 41.4-33.4c2.8 .1 5.5-1.2 7.3-3.7c12-16.2 33.8-21.4 51.8-12z"]
};
var faCircle2 = {
  prefix: 'fal',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM217 174.4c9.8-9.2 22.7-14.2 36.1-14c28.2 .4 50.9 23.4 50.9 51.6c0 13.7-5.4 26.8-15.1 36.5L180.7 356.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H230.6l80.9-80.9c15.7-15.7 24.5-37 24.5-59.1c0-45.7-36.7-83-82.4-83.6c-21.7-.3-42.7 7.8-58.5 22.7L181 164.3c-6.4 6.1-6.7 16.2-.7 22.6s16.2 6.7 22.6 .7L217 174.4z"]
};
var faMagnet = {
  prefix: 'fal',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M48 64c-8.8 0-16 7.2-16 16v48h80V80c0-8.8-7.2-16-16-16H48zM32 256c0 106 86 192 192 192s192-86 192-192V160H336v96c0 61.9-50.1 112-112 112s-112-50.1-112-112V160H32v96zM416 128V80c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v48h80zM0 80C0 53.5 21.5 32 48 32H96c26.5 0 48 21.5 48 48V256c0 44.2 35.8 80 80 80s80-35.8 80-80V80c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V256c0 123.7-100.3 224-224 224S0 379.7 0 256V80z"]
};
var faJar = {
  prefix: 'fal',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M64 0H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16S55.2 0 64 0zm0 96c-17.7 0-32 14.3-32 32v64H288V128c0-17.7-14.3-32-32-32H64zM32 224V352H288V224H32zm0 160v64c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V384H32zM0 128C0 92.7 28.7 64 64 64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faGramophone = {
  prefix: 'fal',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M67.2 278c-.5 1.8 .2 3.7 1.8 4.7c1.5 1 3.6 1.1 5.4-.2c80.8-56.9 145.7-73.7 193.6-73.9C183.4 144.5 145 62.6 133.2 32.8c-.1-.3-.3-.6-.5-.7c-.2-.1-.3-.1-.3-.1L67.2 278zm300.8-.3c0 1.1 0 2.1-.1 3.2c0 1.1 .1 2.3 .1 3.4c0 37.4-30.3 67.7-67.7 67.7l-6.4 0-.2 0H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H293.7l.2 0c22.3-.1 40.5-17.4 42-39.3c-1-17.2-9.2-29.6-21.1-33.4C279.3 236 205 229.7 92.8 308.7c-12.2 8.6-28.8 9.2-41.6 .7c-12.9-8.6-19-24.5-15-39.5l65.1-246C105.1 9.8 117.8 0 132.3 0c13.9 0 25.7 8.8 30.6 21c12.5 31.4 58 127.5 163.5 188c24.1 13.8 41.6 39.2 41.6 68.7zM304 416H80c-8.8 0-16 7.2-16 16v48H320V432c0-8.8-7.2-16-16-16zM80 384H304c26.5 0 48 21.5 48 48v48 0h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32v0V432c0-26.5 21.5-48 48-48z"]
};
var faDiceD12 = {
  prefix: 'fal',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M200.3 32c-2.8 0-5.6 .7-8 2.1L128.7 70.9 256 111.2 383.3 70.9 319.7 34.1c-2.4-1.4-5.2-2.1-8-2.1L200.3 32zM92 92.8c-.8 .9-1.6 1.9-2.2 2.9L34.2 192.2c.6 .5 1.2 1 1.7 1.6l95.8 106.4L240 246.1V139.7L92 92.8zM32 237.3l0 74.4c0 2.8 .7 5.6 2.1 8l55.7 96.5c1.4 2.4 3.4 4.5 5.9 5.9l62.7 36.2-44.5-130L32 237.3zM199.7 480c.2 0 .4 0 .6 0H311.7c.7 0 1.4 0 2.1-.1l50.6-151.8L256 273.9 147.7 328.1l52 151.9zM355 457.5l61.2-35.4c2.4-1.4 4.5-3.4 5.9-5.9l55.7-96.5c1.4-2.4 2.1-5.2 2.1-8V237.3l-81.9 90.9L355 457.5zM477.8 192.2L422.1 95.7c-.6-1.1-1.3-2-2.2-2.9L272 139.7V246.1l108.3 54.1 95.8-106.4c.5-.6 1.1-1.1 1.7-1.6zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4H311.7c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24V311.7c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4H200.3c-8.4 0-16.7-2.2-24-6.4L79.7 449.8c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24V200.3c0-8.4 2.2-16.7 6.4-24L62.2 79.7c4.2-7.3 10.3-13.4 17.6-17.6L176.3 6.4z"]
};
var faNoteSticky = {
  prefix: 'fal',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H272V352c0-26.5 21.5-48 48-48h96V96c0-17.7-14.3-32-32-32H64zM304 434.7L402.7 336H320c-8.8 0-16 7.2-16 16v82.7zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V309.5c0 17-6.7 33.3-18.7 45.3L322.7 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V96z"]
};
var faStickyNote = faNoteSticky;
var faDown = {
  prefix: 'fal',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", "M189.7 448h4.6c4.4 0 8.6-1.8 11.6-5L348.5 293.2c2.2-2.3 3.5-5.4 3.5-8.7c0-6.9-5.6-12.6-12.6-12.6H256c-8.8 0-16-7.2-16-16V80c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16V256c0 8.8-7.2 16-16 16H44.6c-6.9 0-12.6 5.6-12.6 12.6c0 3.2 1.2 6.3 3.5 8.7L178.1 443c3 3.2 7.2 5 11.6 5zM384 284.6c0 11.4-4.4 22.5-12.3 30.7L229 465.1c-9.1 9.5-21.6 14.9-34.8 14.9h-4.6c-13.1 0-25.7-5.4-34.8-14.9L12.3 315.3C4.4 307 0 296 0 284.6C0 260 20 240 44.6 240H112V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V240h67.4c24.6 0 44.6 20 44.6 44.6z"]
};
var faArrowAltDown = faDown;
var faHundredPoints = {
  prefix: 'fal',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M177.4 93.3c5-35.2 35.2-61.3 70.7-61.3c43.5 0 76.9 38.5 70.7 81.5L302.6 226.7c-5 35.2-35.2 61.3-70.7 61.3c-43.5 0-76.9-38.5-70.7-81.5L177.4 93.3zM248.1 64c-19.6 0-36.3 14.4-39 33.9L192.9 211c-3.4 23.8 15 45 39 45c19.6 0 36.3-14.4 39-33.9L287.1 109c3.4-23.8-15-45-39-45zM129.8 35.2c4.6 3.5 6.9 9.2 6 15l-40 256c-1.4 8.8-9.6 14.9-18.3 13.6s-14.7-9.3-13.3-18.1L99.7 74.4 54.3 94.6c-8.1 3.6-17.5 0-21-8.1s.3-17.5 8.4-21.1l72-32c5.4-2.4 11.5-1.7 16.1 1.8zM425.6 32c42.8 0 76.1 37.3 71.2 79.8l-11.2 96.7c-4.2 36.1-34.8 63.4-71.2 63.4c-42.8 0-76.1-37.3-71.2-79.8l11.2-96.7C358.6 59.3 389.2 32 425.6 32zM386.2 99.1L375 195.8c-2.7 23.5 15.7 44.2 39.4 44.2c20.1 0 37.1-15.1 39.4-35.1L465 108.2C467.7 84.6 449.3 64 425.6 64c-20.1 0-37.1 15.1-39.4 35.1zM511.9 333.9c1.2 8.8-5 16.8-13.7 18l-480 64c-8.8 1.2-16.8-5-18-13.7s5-16.8 13.7-18l480-64c8.8-1.2 16.8 5 18 13.7zM466 447.9l-256 32c-8.8 1.1-16.8-5.1-17.9-13.9s5.1-16.8 13.9-17.9l256-32c8.8-1.1 16.8 5.1 17.9 13.9s-5.1 16.8-13.9 17.9z"]
};
var fa100 = faHundredPoints;
var faPaperclipVertical = {
  prefix: 'fal',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", "M64 96c0-53 43-96 96-96s96 43 96 96V352c0 35.3-28.7 64-64 64s-64-28.7-64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16V352c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3-28.7-64-64-64s-64 28.7-64 64V384c0 53 43 96 96 96s96-43 96-96V144c0-8.8 7.2-16 16-16s16 7.2 16 16V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V96z"]
};
var faWindWarning = {
  prefix: 'fal',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M390.3 352c-33.2 57.4-95.2 96-166.3 96C118 448 32 362 32 256S118 64 224 64s192 86 192 192h32C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480c89.4 0 166.5-52.3 202.4-128H390.3zM224 128c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM496 480h48c53 0 96-43 96-96s-43-96-96-96H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H544c35.3 0 64 28.7 64 64s-28.7 64-64 64H496c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48-256c53 0 96-43 96-96s-43-96-96-96H496c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H471.9c2.7 10.4 4.7 21.1 6.1 32h66z"]
};
var faWindCircleExclamation = faWindWarning;
var faLocationPinSlash = {
  prefix: 'fal',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", "M512 192C512 86 426 0 320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 15.6-5.4 37-16.6 63.4c-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192zM176.6 255.4c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0c17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9c-24.4 35.2-48.5 66.5-65.8 88.1c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faMapMarkerSlash = faLocationPinSlash;
var faFaceSadSweat = {
  prefix: 'fal',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23c-5.4 8.5-9.8 16.4-12.8 23.1c-2.6 5.8-3.2 8.8-3.4 9.5c0 .2 0 .2 0 .1C32 385.5 43.7 400 64 400s32-14.5 32-26.7c0 .1 0 .1 0-.1c-.1-.7-.8-3.7-3.4-9.6c-3-6.7-7.4-14.5-12.8-23.1c-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0c17.6 21.7 55.5 72.2 55.5 97.2c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 38.1-75.5 55.5-97.2zM348.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM391.6 272a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.7-99.3c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm153.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faBugSlash = {
  prefix: 'fal',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", "M560 304c8.8 0 16-7.2 16-16s-7.2-16-16-16H480v-8c0-22.9-7.4-44.2-20-61.4l79.3-79.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L437.4 180c-17.2-12.6-38.4-20-61.4-20H301.7l40.5 32H376c39.8 0 72 32.2 72 72v11.5L484.1 304H560zM411.4 409.7c-19.7 20.1-46 33.7-75.4 37.4V350.2l-32-25.3V447c-63.1-7.9-112-61.7-112-127V288 264c0-8.5 1.5-16.6 4.2-24.2l-26.1-20.6C163.6 232.8 160 248 160 264v8H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v16c0 30.2 8.4 58.4 22.9 82.5l-82.2 82.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l79-79C231.5 460.1 273.4 480 320 480c46 0 87.4-19.4 116.6-50.4l-25.2-19.9zM224 98.7L261.2 128H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96s-96 43-96 96v2.7zM320 32c35.3 0 64 28.7 64 64H256c0-35.3 28.7-64 64-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faCupcake = {
  prefix: 'fal',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M208 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H148c-36.2 0-65.8 28.3-67.9 64H80c-44.2 0-80 35.8-80 80s35.8 80 80 80H368c44.2 0 80-35.8 80-80s-35.8-80-80-80C368 57.3 310.7 0 240 0H208zm32 49.3c0-6-1.1-11.8-3.3-17.3H240c53 0 96 43 96 96c0 4-.6 7.8-1.7 11.4c-1.4 4.8-.5 10.1 2.5 14.1s7.8 6.4 12.8 6.4H368c26.5 0 48 21.5 48 48s-21.5 48-48 48H80c-26.5 0-48-21.5-48-48s21.5-48 48-48H97.4c4.9 0 9.5-2.2 12.5-6.1s4.1-8.8 3-13.6c-.6-2.7-1-5.4-1-8.3c0-19.9 16.1-36 36-36h45.3C219.1 96 240 75.1 240 49.3zM89.7 471.4c3.7 23.4 23.8 40.6 47.4 40.6h46.7 .3 79.7 .3 46.7c23.6 0 43.8-17.2 47.4-40.6L382 320H349.6L326.7 466.5c-1.2 7.8-7.9 13.5-15.8 13.5H281.4l13.3-160H262.6L249.3 480H198.7L185.4 320H153.3l13.3 160H137.1c-7.9 0-14.6-5.7-15.8-13.5L98.4 320H66L89.7 471.4z"]
};
var faLightSwitchOff = {
  prefix: 'fal',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M176 464v16H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H176V48c0 8.8 7.2 16 16 16s16-7.2 16-16V32H320c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H208V464c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM176 344h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16zm-48 24V272H256v96c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm0-224c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96H128V144zM96 368c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48V368z"]
};
var faToggleLargeOff = {
  prefix: 'fal',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M160 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 32H416c88.4 0 160-71.6 160-160s-71.6-160-160-160H160C71.6 96 0 167.6 0 256s71.6 160 160 160zm96-32c38.9-29.2 64-75.7 64-128s-25.1-98.8-64-128H416c70.7 0 128 57.3 128 128s-57.3 128-128 128H256z"]
};
var faPenFancySlash = {
  prefix: 'fal',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", "M548.7 143.7c17.4-15.6 27.3-37.9 27.3-61.3C576 36.9 539.1 0 493.6 0c-23.4 0-45.6 9.9-61.3 27.3L308.2 165.2 333.4 185 456.1 48.7C465.7 38.1 479.3 32 493.6 32C521.4 32 544 54.6 544 82.4c0 14.3-6.1 27.9-16.7 37.5L398.1 236.1l25.5 20.1L548.7 143.7zM304.2 325L280 403.7c-3 9.9-10.7 17.7-20.5 20.9L131.2 467.4 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3l-67.4 67.4 42.8-128.3c3.3-9.8 11.1-17.4 20.9-20.5L240.7 275l-30.5-24.1-47.3 14.6c-19.8 6.1-35.4 21.3-41.9 40.9L66.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L269.6 455c19.6-6.5 34.9-22.1 40.9-41.9l20.6-66.8L304.2 325zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"]
};
var faTruckContainer = {
  prefix: 'fal',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M64 32H352c35.3 0 64 28.7 64 64V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-17.7-14.3-32-32-32H64C46.3 64 32 78.3 32 96V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V96C0 60.7 28.7 32 64 32zM448 160c0-17.7 14.3-32 32-32h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8V256v48 56c0 19.4-13.7 35.5-32 39.2l0 .8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 240 224 160zm144 64l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4H480v64H592zm16 32H480v80c13.4-10 30-16 48-16c32.8 0 60.9 19.7 73.3 47.9c3.8-.6 6.7-3.9 6.7-7.9V304 256zM112 96c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faBoot = {
  prefix: 'fal',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", "M32 32H352V96H32V32zM0 32V96v32H32 352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM240 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v32H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h90.8c3.4 3 7.4 5.3 12 6.7l91.6 27.5c27.1 8.1 45.6 33 45.6 61.3V384H32V160H0V384v31.7 .3 41.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16H69.5c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h14.9c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6V416v-.3V384 351.4c0-42.4-27.8-79.8-68.4-92L352 232V176c0-8.8-7.2-16-16-16H240zM480.3 416v41.4c0 6.1-2.4 11.9-6.7 16.2s-10.1 6.7-16.2 6.7H442.5c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l22.4 22.4-22.4-22.4-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5h-11c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5h-11c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6L134.3 485l21.8-21.8c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5H54.6c-6.1 0-11.9-2.4-16.2-6.7s-6.7-10.1-6.7-16.2V416H32 480h.3z"]
};
var faArrowUpFromWaterPump = {
  prefix: 'fal',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", "M112 32c-8.8 0-16 7.2-16 16V256H256V48c0-8.8-7.2-16-16-16H112zM288 48V256H432V54.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 54.6V256h48c35.3 0 64 28.7 64 64V425c-5.3-3.1-11.2-5.4-17.5-6.9c-4.8-1.1-9.7-2.8-14.5-4.8V320c0-17.7-14.3-32-32-32H448 288 256 96 64c-17.7 0-32 14.3-32 32v93.3c-4.8 2.1-9.7 3.7-14.5 4.8C11.2 419.6 5.3 421.9 0 425V320c0-35.3 28.7-64 64-64V48C64 21.5 85.5 0 112 0H240c26.5 0 48 21.5 48 48zM192 480c20.9 0 41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.5 23.7 0c7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.7 0c7.9 7.9 16.2 15.2 26 21.9c12.8 8.7 28.1 16.6 44.1 19.8c7.7 1.5 14.1 7.8 14.1 15.7c0 9.8-8 17.9-17.7 16.2c-23.1-4-43.6-15-58.5-25.2c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3c-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7c15.9-3.1 31.3-11.1 44-19.8c9.8-6.7 18-14 25.9-21.9c6.6-6.5 17.2-6.6 23.8 0c7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"]
};
var faFileCheck = {
  prefix: 'fal',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM283.3 294c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-95.4 95.4-42-42c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L154 400.6c6.2 6.2 16.4 6.2 22.6 0L283.3 294z"]
};
var faBone = {
  prefix: 'fal',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", "M143.2 174.3C138.6 148 115.6 128 88 128c-30.9 0-56 25.1-56 56c0 16.3 7 31 18.2 41.3c17.9 16.4 17.9 45 0 61.4C39 297 32 311.7 32 328c0 30.9 25.1 56 56 56c27.6 0 50.6-20 55.2-46.3C146.3 320 161.7 304 183 304H393c21.3 0 36.7 16 39.8 33.7C437.4 364 460.4 384 488 384c30.9 0 56-25.1 56-56c0-16.3-7-31-18.2-41.3c-17.9-16.4-17.9-45 0-61.4C537 215 544 200.3 544 184c0-30.9-25.1-56-56-56c-27.6 0-50.6 20-55.2 46.3C429.7 192 414.3 208 393 208H183c-21.3 0-36.7-16-39.8-33.7zm31.5-5.5c.7 4.1 4.1 7.3 8.3 7.3H393c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88c0 25.7-11 48.8-28.5 64.9c-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88c-43.4 0-79.5-31.4-86.7-72.7c-.7-4.1-4.1-7.3-8.3-7.3H183c-4.1 0-7.6 3.2-8.3 7.3C167.5 384.6 131.4 416 88 416c-48.6 0-88-39.4-88-88c0-25.7 11-48.8 28.5-64.9c4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88c43.4 0 79.5 31.4 86.7 72.7z"]
};
var faCardsBlank = {
  prefix: 'fal',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", "M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6c0 0 .1 0 .1-.1L427.4 365.5c0 0 .1 0 .1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3c0 .1 .1 .1 .1 .2l167 289.3c0 .1 .1 .1 .1 .2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9c-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8c-.2 .1-.5 .3-.7 .4l-192.3 111c-.2 .1-.5 .3-.7 .4c-26.4 14.9-59.8 6-75.3-20zM324.1 499l33.2-19.1c.9 .1 1.8 .2 2.7 .2H584c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H373L354.7 64.2c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13z"]
};
var faCircle3 = {
  prefix: 'fal',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H276.7l-79.2 67.9c-5.1 4.4-6.9 11.5-4.6 17.7s8.4 10.4 15.1 10.4l63.5-.3c26.7-.1 48.4 21.5 48.4 48.2c0 26.6-21.6 48.2-48.2 48.2h-36c-17.5 0-34-8.2-44.5-22.2l-2.5-3.4c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4l2.5 3.4c16.5 22.1 42.5 35 70.1 35h36c44.3 0 80.2-35.9 80.2-80.2c0-44.4-36.1-80.4-80.6-80.2l-19.9 .1 78.9-67.6c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H176z"]
};
var faBenchTree = {
  prefix: 'fal',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M575.2 106.1c-1.9 11.9 3.1 23.9 12.9 30.9C600.2 145.8 608 160 608 176c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48c0-16 7.8-30.2 19.9-38.9c9.8-7.1 14.7-19 12.9-30.9c-.5-3.3-.8-6.7-.8-10.1c0-35.3 28.7-64 64-64s64 28.7 64 64c0 3.5-.3 6.8-.8 10.1zm31.6 5c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1C397.1 125.7 384 149.3 384 176c0 44.2 35.8 80 80 80h32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c44.2 0 80-35.8 80-80c0-26.7-13.1-50.3-33.2-64.9zM64 224H320v64H304 80 64V224zm0 96l0 48H48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400H80 304h16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H336 320V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32zm224 0v48H96V320H288z"]
};
var faKeyboardBrightnessLow = {
  prefix: 'fal',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", "M320 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zM184 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSkiBootSki = {
  prefix: 'fal',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M415.6 19.4c1.9-8.6-3.7-17.1-12.3-19s-17.1 3.7-19 12.3L380.2 32H168c-7.6 0-14.2 5.3-15.7 12.8L88.2 358.4c-6.1 29.8 16.7 57.6 47 57.6H432c26.5 0 48-21.5 48-48V315.8c0-18.2-10.3-34.8-26.5-42.9l-83.2-41.6L415.6 19.4zM279.2 64h94.2l-20.6 96c-.3 0-.5 0-.8 0H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h41.9l-6.9 32H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h60.2l90.9 45.5c5.4 2.7 8.8 8.3 8.8 14.3V368c0 8.8-7.2 16-16 16H135.2c-10.1 0-17.7-9.3-15.7-19.2l25.2-123.3c43.6-20 107.6-67.2 134.4-177.5zm-33 0c-20.3 76-60 115.7-93 136.6L181.1 64h65.1zM640 416c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H544c53 0 96-43 96-96z"]
};
var faBrainCircuit = {
  prefix: 'fal',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M192 32c26.5 0 48 21.5 48 48v48H212.7c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24H240V272H192c-24.9 0-45.4 19-47.8 43.2C130 321.3 120 335.5 120 352c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.2-9.6-30.1-23.4-36.4c1.9-6.7 8.1-11.6 15.4-11.6h48V432c0 26.5-21.5 48-48 48c-20.4 0-37.9-12.8-44.8-30.8c-2.7-7.1-10.1-11.3-17.6-10c-3.1 .5-6.3 .8-9.5 .8c-30.9 0-56-25.1-56-56c0-7.8 1.6-15.2 4.4-21.8c3.1-7.2 .4-15.7-6.3-19.8C44 331 32 310.9 32 288c0-19.1 8.4-36.3 21.7-48.1c4.8-4.2 6.6-10.9 4.6-17c-1.5-4.7-2.4-9.7-2.4-15c0-20.4 12.8-38 30.9-44.9c7.3-2.8 11.5-10.4 10-18c-.6-3-.9-6-.9-9.2c0-22.4 15.4-41.3 36.2-46.5c6.6-1.7 11.4-7.3 12-14C146.5 51.1 167 32 192 32zm80 128h48c8.8 0 16 7.2 16 16v11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V176c0-26.5-21.5-48-48-48H272V80c0-26.5 21.5-48 48-48c25 0 45.5 19.1 47.8 43.4c.6 6.7 5.4 12.4 12 14C400.6 94.7 416 113.6 416 136c0 3.1-.3 6.2-.9 9.2c-1.5 7.6 2.7 15.2 10 18C443.2 170 456 187.6 456 208c0 5.2-.8 10.3-2.4 15c-2 6.1-.2 12.8 4.6 17C471.6 251.7 480 268.9 480 288c0 22.9-12 43-30.2 54.3c-6.7 4.2-9.3 12.6-6.3 19.8c2.8 6.7 4.4 14.1 4.4 21.8c0 30.9-25.1 56-56 56c-3.3 0-6.5-.3-9.5-.8c-7.5-1.3-14.9 2.9-17.6 10c-6.9 18-24.4 30.8-44.8 30.8c-26.5 0-48-21.5-48-48V384h59.3c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24H272V160zM192 512c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c29.6 0 55.5-16.1 69.3-40c.9 0 1.8 0 2.7 0c48.6 0 88-39.4 88-88c0-7.6-1-15-2.8-22c21.2-17.6 34.8-44.2 34.8-74c0-25.1-9.6-48-25.4-65c.9-4.9 1.4-9.9 1.4-15c0-29.6-16.1-55.5-40-69.3c0-.9 0-1.8 0-2.7c0-33.6-20.7-62.4-50.1-74.2C389.7 26.4 357.9 0 320 0c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0c-37.9 0-69.7 26.4-77.9 61.8C84.7 73.6 64 102.4 64 136c0 .9 0 1.8 0 2.7C40.1 152.5 24 178.4 24 208c0 5.1 .5 10.1 1.4 15C9.6 240 0 262.9 0 288c0 29.8 13.6 56.4 34.8 74C33 369 32 376.4 32 384c0 48.6 39.4 88 88 88c.9 0 1.8 0 2.7 0c13.8 23.9 39.7 40 69.3 40zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faUserInjured = {
  prefix: 'fal',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M320 128c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16H192 318.7c.9 5.2 1.3 10.5 1.3 16zM307.2 80H237.6l39.8-31.8c12.2 8.2 22.4 19.1 29.8 31.8zM243.8 34L186.4 80H140.8c16.6-28.7 47.6-48 83.2-48c6.8 0 13.4 .7 19.8 2zM352 128A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM32 480c.5-33.7 12.4-64.6 32-89v89H32zm64 0V361.3c12.9-8.8 27.3-15.6 42.7-19.9L226.9 480H96zm224-32c0 17.7-14.3 32-32 32H264.8l-40.7-64H288c17.7 0 32 14.3 32 32zM80 512h80 16H288 418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H80zm336-32H343.4c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64H203.7l-30.5-47.9c1.7-.1 3.4-.1 5.1-.1h91.4c80 0 145 64.3 146.3 144z"]
};
var faBlockBrickFire = {
  prefix: 'fal',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M168 64v64h72 32 72V64H168zm-32 0H96C78.3 64 64 78.3 64 96v32h72V64zM64 160v80h72 32 72V160H64zm0 192h72V272H64v80zm0 32v32c0 17.7 14.3 32 32 32H240V384H168 136 64zm104-32H288c.1 10.9 1.1 21.6 3 32H272v64h42.4c6.6 11.4 14.4 22.2 23.2 32H96c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64v48.6c-1.7-1.5-3.3-3.1-5-4.6c-7.7-7-17.2-10.9-27-11.8V96c0-17.7-14.3-32-32-32H376v64 32H272v80h54.9c-.6 .9-1.1 1.8-1.7 2.7c-5.8 9.5-11.3 19.3-16.2 29.3H168v80zm341.4-98.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C352 422.5 408.2 480 480 480c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM445.1 256c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C521.3 442 502.3 448 481 448c-25.9 0-50.2-8.4-68.2-24.8C394.7 406.6 384 382.7 384 354c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L507 351l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C445.7 409.9 461.9 416 481 416c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5z"]
};
var faFirewall = faBlockBrickFire;
var faFaceSadTear = {
  prefix: 'fal',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM160 300.4c-5.5 6.9-11 14.3-16.2 22c-11.4 17.1-15.8 29-15.8 34.9c0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7c0-5.9-4.4-17.8-15.8-34.9c-5.1-7.7-10.7-15.1-16.2-22zm-8.6-40.3c4.3-5.5 12.8-5.5 17.1 0c1.6 2 3.3 4.1 5.2 6.3c18.9 23 50.3 61.2 50.3 90.8c0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-29.2 30.8-66.9 49.6-90l0 0 0 0c2.1-2.6 4.1-5 5.8-7.2zM256 320c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16s7.2-16 16-16zM359.6 208a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSadTear = faFaceSadTear;
var faPlane = {
  prefix: 'fal',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M562.7 221.2c7.6 9.5 13.3 21.3 13.3 34.8c0 26.9-21.6 47.1-41.8 59.2c-21.1 12.7-47.3 20.8-67.9 20.8H365.9L279.1 487.8c-8.5 15-24.5 24.2-41.7 24.2H181.2c-21.3 0-36.6-20.3-30.8-40.8L189.1 336H136L97.6 387.2C91.6 395.3 82.1 400 72 400H30c-16.6 0-30-13.4-30-30c0-2.8 .4-5.6 1.2-8.2L31.4 256 1.2 150.3C.4 147.6 0 144.8 0 142c0-16.6 13.4-30 30-30H72c10.1 0 19.6 4.7 25.6 12.8L136 176l53.1 0L150.4 40.8C144.6 20.3 160 0 181.2 0l56.2 0c17.2 0 33.1 9.2 41.7 24.2L365.9 176H466.3c20.7 0 46.9 8.4 68 21.2c10.7 6.5 20.8 14.5 28.4 24zm-45 3.3c-17.3-10.5-37.9-16.6-51.3-16.6H356.6c-5.7 0-11-3.1-13.9-8.1L251.3 40.1l13.9-7.9-13.9 7.9c-2.8-5-8.2-8.1-13.9-8.1l-56.2 0 44.5 155.6c1.4 4.8 .4 10-2.6 14s-7.8 6.4-12.8 6.4L128 208c-5 0-9.8-2.4-12.8-6.4L72 144H32.6L63.4 251.6c.8 2.9 .8 5.9 0 8.8L32.6 368H72l43.2-57.6c3-4 7.8-6.4 12.8-6.4h82.3c5 0 9.8 2.4 12.8 6.4s4 9.2 2.6 14L181.2 480h56.2c5.7 0 11-3.1 13.9-8.1l91.4-159.9c2.9-5 8.2-8.1 13.9-8.1H466.3c13.6 0 34.2-5.9 51.4-16.2C535.8 276.9 544 265.1 544 256c0-4.1-1.7-9-6.3-14.8c-4.6-5.8-11.5-11.5-20-16.7z"]
};
var faTentArrowsDown = {
  prefix: 'fal',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M203.9 117.3c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48L128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 148.1-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zm352 0c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V164.1l-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zM297.5 163.1c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8C65.1 486.5 87.5 512 116.4 512H459.6c29 0 51.3-25.5 47.6-54.2L489.6 323.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM124.5 316.8L272 207.7v112 .5V480H116.4c-9.7 0-17.1-8.5-15.9-18.1l17.5-134.4c.6-4.3 2.9-8.2 6.4-10.8zM304 315.4V207.7L451.5 316.8c3.5 2.6 5.8 6.5 6.4 10.8l17.5 134.4c1.2 9.6-6.2 18.1-15.9 18.1H405.9l-.3-.4L304 315.4zM304 480V376.2L368.2 480H304z"]
};
var faExclamation = {
  prefix: 'fal',
  iconName: 'exclamation',
  icon: [64, 512, [10069, 10071, 61738], "21", "M48 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V48zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsSpin = {
  prefix: 'fal',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M257.1 79.5c-11.3 0-22.4 1.1-33.1 3.1V50.2c10.8-1.7 21.9-2.6 33.1-2.6c53.8 0 102.8 20.4 139.7 53.9l27.1-27.1c15.1-15.1 41-4.4 41 17l0 86.1c0 8.8-7.2 16-16 16l-86.1 0c-21.4 0-32.1-25.9-17-41l28.3-28.3c-31.1-27.7-72.1-44.6-117-44.6zM124.2 140.2c-26.8 30.9-43.1 71.2-43.1 115.3c0 11.1 1 21.9 3 32.5H51.7c-1.7-10.6-2.5-21.4-2.5-32.5c0-53 19.8-101.3 52.4-138L74.3 90.3c-15.1-15.1-4.4-41 17-41l86.1 0c8.8 0 16 7.2 16 16v86.1c0 21.4-25.9 32.1-41 17l-28.2-28.2zM433.1 255.5c0-10.8-1-21.3-2.8-31.5h32.4c1.6 10.3 2.4 20.8 2.4 31.5c0 53.8-20.4 102.8-53.9 139.7l28.7 28.7c15.1 15.1 4.4 41-17 41H336.9c-8.8 0-16-7.2-16-16V362.8c0-21.4 25.8-32.1 41-17l26.7 26.7c27.7-31.1 44.6-72.1 44.6-117zM288 428.8v32.4c-10.1 1.5-20.4 2.3-30.9 2.3c-53 0-101.3-19.8-138-52.4L90.3 439.9c-15.1 15.1-41 4.4-41-17l0-86.1c0-8.8 7.2-16 16-16l86.1 0c21.4 0 32.1 25.9 17 41l-26.6 26.6c30.9 26.8 71.2 43.1 115.3 43.1c10.5 0 20.8-.9 30.9-2.7zm115.6 4.1l-50.7-50.7v50.7h50.7zM161.4 132.1V81.4l-50.7 0 50.7 50.7zm-80 271.5l50.7-50.7H81.4l0 50.7zM382.2 161.4l50.7 0V110.6l-50.7 50.7z"]
};
var faFaceSmileRelaxed = {
  prefix: 'fal',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faCommentXmark = {
  prefix: 'fal',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM180.7 164.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 240l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 262.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 240l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 217.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faCommentTimes = faCommentXmark;
var faPrint = {
  prefix: 'fal',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M96 160H64V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H416V90.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32v96zm352 64H64c-17.7 0-32 14.3-32 32V384H64V352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32h32V256c0-17.7-14.3-32-32-32zm0 192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 17.7-14.3 32-32 32H448zM96 352l0 128H416V352H96zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTurkishLiraSign = {
  prefix: 'fal',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", "M80 32c8.8 0 16 7.2 16 16v77.1L251.6 80.6c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 158.4v62.7l155.6-44.5c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 254.4V448h95.2C277 448 347.5 380.4 351 294.7l1-23.3c.4-8.8 7.8-15.7 16.7-15.3s15.7 7.8 15.3 16.7L383 296c-4.3 102.8-88.9 184-191.8 184H80c-8.8 0-16-7.2-16-16V263.5l-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 230.2V167.5l-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 134.2V48c0-8.8 7.2-16 16-16z"]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faFaceNoseSteam = {
  prefix: 'fal',
  iconName: 'face-nose-steam',
  icon: [512, 512, [], "e382", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9c-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 11.6 .8 22.9 2.3 34.1c1.2 8.8 9.2 14.9 18 13.7s14.9-9.2 13.7-18c-1.3-9.8-2-19.7-2-29.9zM211.2 475.5c-8.7-1.8-17.1 3.8-18.9 12.5s3.8 17.1 12.5 18.9c16.6 3.4 33.7 5.1 51.2 5.1s34.6-1.8 51.2-5.1c8.7-1.8 14.3-10.2 12.5-18.9s-10.2-14.3-18.9-12.5c-14.5 2.9-29.5 4.5-44.8 4.5s-30.3-1.5-44.8-4.5zm-7.2-163.3c3.8-6.3 2.8-14.4-2.4-19.5s-13.2-6.2-19.5-2.4l-67.1 40.3c-1.1-1.4-2.3-2.8-3.7-4.1c-18.7-18.7-49.1-18.7-67.9 0c-2.7 2.7-5 5.6-6.9 8.8C22.7 334 8.6 338.6-1.9 349.1c-17.9 17.9-18.7 46.4-2.5 65.2c-10.3 23.4-5.8 51.8 13.4 70.9s47.5 23.6 70.9 13.4c18.9 16.2 47.3 15.4 65.2-2.5c10.5-10.5 15.1-24.6 13.9-38.3c3.1-1.9 6.1-4.2 8.8-6.9c18.7-18.7 18.7-49.1 0-67.9c-1.3-1.3-2.7-2.5-4.1-3.7l40.3-67.1zm124.3-21.1c-6.3-3.8-14.4-2.8-19.5 2.4s-6.2 13.3-2.4 19.5l40.3 67.1c-1.4 1.1-2.8 2.4-4.1 3.7c-18.7 18.7-18.7 49.1 0 67.9c2.7 2.7 5.6 5 8.8 6.9c-1.2 13.7 3.4 27.8 13.9 38.3c17.9 17.9 46.4 18.7 65.2 2.5c23.4 10.3 51.8 5.8 70.9-13.4s23.6-47.5 13.4-70.9c16.2-18.9 15.4-47.3-2.5-65.2c-10.5-10.5-24.6-15.1-38.3-13.9c-1.9-3.1-4.2-6.1-6.9-8.8c-18.7-18.7-49.1-18.7-67.9 0c-1.3 1.3-2.5 2.7-3.7 4.1l-67.1-40.3zM116.6 366.8l26.9-16.2-16.2 26.9c-2.6 4.4-3 9.8-1 14.5s6.1 8.2 11.1 9.3c2.8 .7 5.4 2.1 7.6 4.3c6.2 6.2 6.2 16.4 0 22.6c-2.3 2.3-5.2 3.8-8.2 4.4c-4.9 1-9 4.1-11.2 8.5s-2.3 9.6-.1 14.1c2.9 6 1.8 13.3-3.1 18.2c-6.2 6.2-16.4 6.2-22.6 0c-1-1-1.9-2.2-2.6-3.4c-2.3-4-6.2-6.8-10.7-7.7s-9.2 .2-12.9 3c-12.5 9.6-30.6 8.7-42.1-2.8s-12.4-29.5-2.8-42.1c2.8-3.7 3.9-8.4 3-12.9s-3.7-8.4-7.7-10.7c-1.2-.7-2.3-1.5-3.4-2.6c-6.2-6.2-6.2-16.4 0-22.6c4.9-4.9 12.3-6 18.2-3.1c4.5 2.1 9.7 2.1 14.1-.1s7.6-6.4 8.5-11.2c.6-3 2-5.8 4.4-8.2c6.2-6.2 16.4-6.2 22.6 0c2.2 2.2 3.6 4.8 4.3 7.6c1.2 5 4.6 9.1 9.3 11.1s10.1 1.6 14.5-1zm266.2 11.7l-16.2-26.9 26.9 16.2c4.4 2.6 9.8 3 14.5 1s8.2-6.1 9.3-11.1c.7-2.8 2.1-5.4 4.3-7.6c6.2-6.2 16.4-6.2 22.6 0c2.3 2.3 3.8 5.2 4.4 8.2c1 4.9 4.1 9 8.5 11.2s9.6 2.3 14.1 .1c6-2.9 13.3-1.8 18.2 3.1c6.2 6.2 6.2 16.4 0 22.6c-1 1-2.2 1.9-3.4 2.6c-4 2.3-6.8 6.2-7.7 10.7s.2 9.2 3 12.9c9.6 12.5 8.7 30.6-2.8 42.1s-29.5 12.4-42.1 2.8c-3.7-2.8-8.4-3.9-12.9-3s-8.4 3.7-10.7 7.7c-.7 1.2-1.5 2.3-2.6 3.4c-6.2 6.2-16.4 6.2-22.6 0c-4.9-4.9-6-12.3-3.1-18.2c2.1-4.5 2.1-9.7-.1-14.1s-6.4-7.6-11.2-8.5c-3-.6-5.8-2-8.2-4.4c-6.2-6.2-6.2-16.4 0-22.6c2.2-2.2 4.9-3.6 7.6-4.3c5-1.2 9.1-4.6 11.1-9.3s1.6-10.1-1-14.5zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm192 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm101.1-96.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1zm-266.1 0c35.5 11.8 64.4 34.8 73.7 44.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2z"]
};
var faCircleWaveformLines = {
  prefix: 'fal',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 144V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 176V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24V312c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16zM224 216v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V216c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWaveformCircle = faCircleWaveformLines;
var faDollarSign = {
  prefix: 'fal',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V63.5c-6.3 .1-12.6 .3-18.8 .9c-24 2-47.9 7.8-67.4 20.6C37.7 98.1 23.2 118 17.9 146c-3.8 20.3-1.9 38.2 5.7 53.7C31 215 43.1 226.5 57.1 235.4c26.7 17 63.6 26.7 97.2 35.5l1.7 .4c35.7 9.4 67.8 17.9 89.8 31.9c10.6 6.8 17.8 14.2 21.9 22.6c4 8.3 5.8 19 3 33.8c-3.9 20.7-18.4 36.4-42.9 46c-24.9 9.8-59.1 12.6-98 7c-24.4-3.6-61-12.1-91.3-25.2c-8.1-3.5-17.5 .2-21 8.4s.2 17.5 8.4 21c33.6 14.5 73.1 23.5 99.3 27.4l.1 0c6.4 .9 12.7 1.6 18.9 2.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.4c23.2-.7 44.8-4.7 63.4-11.9c32-12.5 56.2-35.7 62.7-69.9c3.8-20.3 1.9-38.2-5.7-53.7c-7.4-15.3-19.6-26.8-33.5-35.6c-26.7-17-63.6-26.7-97.2-35.5l-1.7-.4c-35.7-9.4-67.8-17.9-89.8-31.9c-10.6-6.8-17.8-14.2-21.9-22.6c-4-8.3-5.8-19-3-33.8c3.6-19.3 13.1-31.8 26-40.2c13.4-8.8 31.5-13.7 52.6-15.5c42.3-3.5 91.3 6 124.3 14c8.6 2.1 17.2-3.2 19.3-11.8s-3.2-17.2-11.8-19.3c-21.9-5.3-52.1-11.7-83.8-14.4V16z"]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faFerrisWheel = {
  prefix: 'fal',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M272 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM211.8 66.7c-20.4 4.8-39.6 12.9-56.9 23.7c3.3 6.5 5.2 13.9 5.2 21.7c0 7.4-1.7 14.4-4.7 20.7l68.2 68.2c5.1-3 10.6-5.3 16.5-6.8V93.3c-12.7-4.5-23-14.2-28.2-26.6zM272 194c5.9 1.5 11.4 3.8 16.5 6.8l68.2-68.2c-3-6.3-4.7-13.3-4.7-20.7c0-7.8 1.9-15.2 5.2-21.7c-17.3-10.8-36.5-18.8-56.9-23.7C295 79 284.7 88.8 272 93.3V194zm39.1 29.5c3 5.1 5.3 10.6 6.8 16.5H418.7c4.3-12.1 13.3-22 24.9-27.5c-4.5-20.5-12.2-39.8-22.7-57.3c-6.3 3.1-13.4 4.8-20.9 4.8c-7.4 0-14.4-1.7-20.7-4.7l-68.2 68.2zM418.7 272H318c-4.6 17.9-16.7 32.7-32.8 41l81.4 176.3c2.3 5 1.9 10.7-1 15.3s-8 7.4-13.5 7.4H160c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3L226.8 313c-16.1-8.2-28.2-23.1-32.8-41H93.3c-4.2 11.8-12.8 21.5-23.9 27c4.9 20.4 13.1 39.5 24 56.8c5.7-2.4 12-3.7 18.6-3.7c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48c0-8.1 2-15.7 5.5-22.3c-14.9-22.4-26-47.7-32.1-74.8C16 298 0 278.9 0 256c0-22.5 15.5-41.4 36.3-46.6C42 181.2 53 154.8 68.1 131.5c-2.7-6-4.1-12.6-4.1-19.5c0-26.5 21.5-48 48-48c6.7 0 13 1.4 18.8 3.8c23.6-15.9 50.4-27.5 79.2-33.5C215.9 14.5 234.3 0 256 0s40.1 14.5 46 34.3c28.8 6 55.6 17.6 79.2 33.5C387 65.4 393.3 64 400 64c26.5 0 48 21.5 48 48c0 6.9-1.5 13.6-4.1 19.5c15.2 23.3 26.1 49.7 31.8 77.9c20.9 5.2 36.3 24.1 36.3 46.6c0 22.9-16 42-37.4 46.8c-6.1 27.1-17.1 52.4-32.1 74.8c3.5 6.7 5.5 14.3 5.5 22.3c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c6.6 0 12.9 1.3 18.6 3.7c10.9-17.3 19.1-36.4 24-56.8c-11.1-5.5-19.7-15.2-23.9-27zM194 240c1.5-5.9 3.8-11.4 6.8-16.5l-68.2-68.2c-6.3 3-13.3 4.7-20.7 4.7c-7.5 0-14.6-1.7-20.9-4.8C80.6 172.7 72.9 192 68.4 212.5C79.9 218 89 227.9 93.3 240H194zm254 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64-144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-89.8L185 480H327L256 326.2zm0-38.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faComputerSpeaker = {
  prefix: 'fal',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", "M64 384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H293.5c4.2-11.9 10.7-22.8 19-32H64C28.7 32 0 60.7 0 96V352c0 35.3 28.7 64 64 64H288V384H64zm48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H312.4c-8.3-9.2-14.8-20.1-19-32H112zM576 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H576zM384 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H384zm96 352a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM496 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM480 96a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSkullCow = {
  prefix: 'fal',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M55.6 1.9c6.8 3.7 10 11.8 7.5 19.1L52 54.5c-2.5 7.5-3.4 15.4-2.6 23.2C52.3 106.3 76.3 128 105 128h79.4C202 108.4 227.6 96 256 96H384c28.4 0 54 12.4 71.6 32H535c28.7 0 52.7-21.7 55.6-50.3c.8-7.8-.1-15.8-2.6-23.2L576.8 21.1c-2.5-7.4 .7-15.4 7.5-19.1s15.3-2 20.1 4.1l7.5 9.3c18.2 22.7 28 50.9 28 80V112c0 70.7-57.3 128-128 128H480v48c0 41.8-26.7 77.3-64 90.5l-26.4 87.9c-8.1 27.1-33 45.6-61.3 45.6H311.6c-28.3 0-53.2-18.5-61.3-45.6L224 378.5c-37.3-13.2-64-48.7-64-90.5V240H128C57.3 240 0 182.7 0 112V95.3C0 66.2 9.9 38 28 15.3L35.5 6C40.3 0 48.8-1.8 55.6 1.9zM480 208h32c49.7 0 90.6-37.8 95.5-86.3C591.6 145 564.9 160 535 160H474.5c3.5 10 5.5 20.8 5.5 32v16zM105 160c-29.9 0-56.6-15-72.5-38.3C37.4 170.2 78.3 208 128 208h32V192c0-11.2 1.9-22 5.5-32H105zM234.6 348.4c9.6 3.4 17 11.2 20 21L281 457.2c4.1 13.5 16.5 22.8 30.7 22.8h16.8c14.1 0 26.6-9.3 30.7-22.8l26.4-87.9c2.9-9.8 10.4-17.6 20-21c24.9-8.8 42.6-32.6 42.6-60.4V192c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64v96c0 27.8 17.7 51.5 42.6 60.4zM232 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faX = {
  prefix: 'fal',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M380.2 58.3c5.7-6.7 4.9-16.8-1.9-22.5s-16.8-4.9-22.6 1.9L192 231.2 28.2 37.7c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5L171 256 3.8 453.7c-5.7 6.7-4.9 16.8 1.9 22.6s16.8 4.9 22.5-1.9L192 280.8 355.8 474.3c5.7 6.7 15.8 7.6 22.6 1.9s7.6-15.8 1.9-22.6L213 256 380.2 58.3z"]
};
var faMagnifyingGlassDollar = {
  prefix: 'fal',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm16-312c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16V294.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faUsersGear = {
  prefix: 'fal',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M144 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm112 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm119.2 78.5c12-8.4 21.9-19.5 29-32.5c7.5-13.7 11.8-29.4 11.8-46.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c20.6 0 39.6-6.5 55.2-17.5zM360.1 352H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H445.6c-1.1-2-2.1-4-3-6c-19.6 2.1-40.8-4.6-55.4-23.1c-.7-.9-1.5-1.9-2.2-2.8H160.1c2.8-53.5 47-96 101.2-96H372.1l0 0c-6.7-9.1-11.1-20.1-12-32zm278.2-67.4C629.1 232 583.2 192 528 192H444c2.6 10.2 4 21 4 32h65 15c28.7 0 53.9 15.2 68 37.9c15.5 1.4 30.9 8.5 42.3 22.7zM464 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM196 192H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80c0-11 1.4-21.8 4-32zM501 289.3v-.6c3.9-.5 7.9-.7 12-.7s8.1 .3 12 .7v.6c0 16.5 10.6 29.2 22 35.8c11.5 6.7 27.7 9.4 41.9 1.2l.5-.3c2.1 2.7 4 5.6 5.8 8.5l1.9 3.2c1.6 2.9 3.1 5.9 4.4 9l-.5 .3c-14.3 8.2-20 23.7-20 36.9s5.7 28.7 20 36.9l.5 .3c-1.3 3.1-2.7 6.1-4.3 9l-1.9 3.4c-1.8 2.9-3.7 5.7-5.7 8.4l-.5-.3c-14.2-8.2-30.4-5.5-41.9 1.2c-11.4 6.6-22 19.2-22 35.8v.6c-3.9 .5-7.9 .7-12 .7s-8.1-.3-12-.7v-.6c0-16.5-10.6-29.2-22-35.8c-11.5-6.7-27.7-9.4-41.9-1.2l-.5 .3c-2.1-2.7-4-5.5-5.7-8.4l-1.9-3.3c-1.6-2.9-3.1-5.9-4.4-9l.5-.3c14.3-8.2 20-23.7 20-36.9s-5.7-28.7-20-36.9l-.5-.3c1.3-3.1 2.8-6.1 4.4-9.1l1.8-3.2c1.8-2.9 3.7-5.8 5.8-8.5l.5 .3c14.2 8.2 30.4 5.5 41.9-1.2c11.4-6.6 22-19.2 22-35.8zM513 256c-6.1 0-12.2 .4-18.1 1.3c-16.2 2.3-25.9 16.5-25.9 30.7v1.4c0 2-1.5 5.4-6.1 8.1c-4.5 2.6-8.1 2.2-9.9 1.1l-1.2-.7c-12.2-7.1-29.4-5.8-39.5 7.1c-3.3 4.2-6.3 8.6-9.1 13.2l0 0-.1 .2-2 3.4 0 0-.1 .2c-2.5 4.6-4.8 9.4-6.8 14.3c-6.1 15.2 1.4 30.7 13.6 37.7l1.2 .7c1.8 1 4 4 4 9.2s-2.2 8.2-4 9.2l-1.2 .7c-12.2 7.1-19.7 22.6-13.6 37.7c2 4.9 4.2 9.6 6.7 14.2l0 0 .1 .3 2.1 3.6 0 0 .2 .3c2.7 4.6 5.8 8.9 9 13.1c10.1 12.8 27.3 14.1 39.5 7.1l1.2-.7c1.8-1 5.4-1.5 9.9 1.1c4.6 2.7 6.1 6.1 6.1 8.1v1.4c0 14.1 9.7 28.4 25.9 30.7c5.9 .8 12 1.3 18.1 1.3s12.2-.4 18.1-1.3c16.2-2.3 25.9-16.5 25.9-30.7v-1.4c0-2 1.5-5.4 6.1-8.1c4.5-2.6 8.1-2.2 9.9-1.1l1.2 .7c12.2 7.1 29.4 5.8 39.5-7.1c3.3-4.2 6.3-8.5 9-13.1l0 0 .2-.3 2.1-3.6 0 0 .1-.3c2.5-4.6 4.8-9.3 6.7-14.1c6.1-15.2-1.4-30.7-13.6-37.7l-1.2-.7c-1.8-1-4-4-4-9.2s2.2-8.2 4-9.2l1.2-.7c12.2-7.1 19.7-22.6 13.6-37.7c-2-4.9-4.2-9.7-6.8-14.2l0 0-.1-.2-2-3.5 0 0-.1-.2c-2.8-4.6-5.8-9-9.1-13.2c-10.1-12.8-27.3-14.1-39.5-7.1l-1.2 .7c-1.8 1-5.4 1.5-9.9-1.1c-4.6-2.7-6.1-6.1-6.1-8.1v-1.4c0-14.1-9.7-28.4-25.9-30.7c-5.9-.8-12-1.3-18.1-1.3zm15 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faUsersCog = faUsersGear;
var faPersonMilitaryPointing = {
  prefix: 'fal',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M256 59.1V64v0H384v0V37.8L256 59.1zM398.2 95.2c1.2 5.4 1.8 11 1.8 16.8c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.8 .6-11.4 1.8-16.8C231.5 92.4 224 83.1 224 72V52.3c0-11.7 8.5-21.7 20.1-23.7l144-24C402.7 2.2 416 13.5 416 28.3V72c0 11.1-7.5 20.4-17.8 23.2zm-33 .8H274.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16zM32 240c0-8.8 7.2-16 16-16H240h16 88 .3c40.2 0 77.3 21.5 97.2 56.4L541.9 456.1c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L416 300.2V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V432.4c0-.2 0-.5 0-.7V256H48c-8.8 0-16-7.2-16-16zM256 464c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V448H256v16zM384 296c0-4.3-.7-8.5-1.9-12.4L273.8 416H384V296zm-40-40H256V387.2L360.4 259.5c-5-2.3-10.6-3.5-16.4-3.5z"]
};
var faBuildingColumns = {
  prefix: 'fal',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192H256 480.8c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24H34.3L256 34.4 477.7 160H306.6zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM40 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H472c8.8 0 16-7.2 16-16s-7.2-16-16-16H40zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faCircleT = {
  prefix: 'fal',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96V368c0 8.8 7.2 16 16 16s16-7.2 16-16V176h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 144z"]
};
var faSack = {
  prefix: 'fal',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M310.5 144h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8l6.7-9.8zM0 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 121.9 37.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96z"]
};
var faGrid2 = {
  prefix: 'fal',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", "M80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80zM32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM80 320c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H80zM32 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336zM432 64H336c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM336 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 288c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H336zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336z"]
};
var faCameraCctv = {
  prefix: 'fal',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M128 32L32 200 320 320 512 192 128 32zM100.2 16.1c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9l-85.6-35.7L175 437.7c-2.4 6.2-8.3 10.3-15 10.3H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368c0-8.8 7.2-16 16-16s16 7.2 16 16v48H149l43.6-114.4-172.9-72c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168zM396.9 345.6l31.4-20.9 83.3 37.9 27.6-66.3-41-18.2 31.5-21 36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-3.3 8-13.5 12-21.4 8.4L396.9 345.6z"]
};
var faCctv = faCameraCctv;
var faUmbrella = {
  prefix: 'fal',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V48.4C132.8 55.6 18.9 156 2.1 285.9c-2 15.6 17.3 24.4 27.8 12.7C43.9 283 71.2 272 96 272c38.7 0 71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C217 299.5 249.3 272 288 272s71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C409 299.5 441.3 272 480 272c24.8 0 52.1 11 66.1 26.7c10.5 11.7 29.8 2.9 27.8-12.7C557.1 156 443.2 55.6 304 48.4V16zm80 278.3c-19.6-32.5-55.2-54.3-96-54.3s-76.4 21.8-96 54.3C172.4 261.8 136.8 240 96 240c-17.6 0-36.7 4.1-53.7 11.8C73.3 153 171 80 288 80s214.7 73 245.7 171.8C516.7 244.1 497.6 240 480 240c-40.8 0-76.4 21.8-96 54.3zM272 306.7V446.6c0 18.5-15 33.4-33.4 33.4c-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7C191.1 498 213.8 512 238.6 512c36.1 0 65.4-29.3 65.4-65.4V306.7c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7z"]
};
var faTrowel = {
  prefix: 'fal',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", "M491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-11-11-102 102 75.5 75.5c12.6 12.6 7.5 34.1-9.4 39.7L36.2 506.1C17.5 512.4-.4 494.5 5.9 475.8L92.7 215.2c5.6-16.9 27.1-22 39.7-9.4L208 281.4l102-102-11-11c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zM321.6 138.2c-2.1 2.1-2.1 5.5 0 7.5l44.7 44.7c2.1 2.1 5.5 2.1 7.5 0L469.2 95c14.4-14.4 14.4-37.8 0-52.2s-37.8-14.4-52.2 0l-95.4 95.4zM41.3 470.7L274.4 393 119 237.6 41.3 470.7z"]
};
var faHorizontalRule = {
  prefix: 'fal',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 256c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
};
var faBedFront = {
  prefix: 'fal',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M64 96v40.6c9.4-5.4 20.3-8.6 32-8.6H208c19.1 0 36.3 8.4 48 21.7c11.7-13.3 28.9-21.7 48-21.7H416c11.7 0 22.6 3.1 32 8.6V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96zm416 96v48c19.4 14.6 32 37.8 32 64v96 64c0 8.8-7.2 16-16 16s-16-7.2-16-16V416H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V400 304c0-26.2 12.6-49.4 32-64V192 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64v96zm-32 33.6V192c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v32H432c5.5 0 10.8 .6 16 1.6zM240 224V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v33.6c5.2-1 10.5-1.6 16-1.6H240zm240 80c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v80H480V304z"]
};
var faBedAlt = faBedFront;
var faD = {
  prefix: 'fal',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M48 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H160c106 0 192-86 192-192s-86-192-192-192H48zM0 80C0 53.5 21.5 32 48 32H160c123.7 0 224 100.3 224 224s-100.3 224-224 224H48c-26.5 0-48-21.5-48-48V80z"]
};
var faStapler = {
  prefix: 'fal',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M448 352v32H80c-26.5 0-48 21.5-48 48s21.5 48 48 48H592c26.5 0 48-21.5 48-48V416 384 336 304v-4.7c0-36.4-20.5-69.6-53.1-85.9L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L11.5 144.7C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L72 242v78c0 17.7 14.3 32 32 32H448zm-64-32H104V250l280 70zm224 64H480V336c0-14.7-10-27.5-24.2-31L51.3 203.8C39.9 201 32 190.8 32 179.1c0-5.5 1.8-10.9 5.1-15.3l32.3-43.1C96.2 85 138.3 64 182.9 64c22 0 43.8 5.1 63.5 15L572.6 242.1c21.7 10.8 35.4 33 35.4 57.2V304v32 48zM480 416H608v16c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448h32z"]
};
var faMasksTheater = {
  prefix: 'fal',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M371.6 28c1.7 1.2 3.2 2.5 4.5 4c-23 .4-42.7 2.7-59.5 6.3c-26.4-6.7-68.1-10.5-131.4-.1C76.9 56.1 41.9 92.8 32.6 105.7l0 .1c-.1 .8-.2 2.4 .3 5L60.8 274.5c5.4 31.5 19.5 58.8 41.8 76.9c20.8 16.8 46.9 35.3 74 48.2c16.9 8.1 32.9 13.4 47.4 15.5c6.8 10.4 14.5 21.4 23 32.5c-58 4.9-123.3-37.8-165-71.7c-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28zM159 286.9c9.4-7.6 22-15.8 37.8-21.8l-1.7 10.2c-1.5 9-2.5 18.2-2.9 27.5c-4.7 2.8-8.9 5.8-12.4 8.7c-5.7 4.7-11.3 9.9-15.7 15.9c-5 7.2-15.1 9.1-22.5 4.2c-7.4-4.9-9.4-14.8-4.4-22.1c5.9-8.6 13.8-16 21.8-22.6zm-3.9-122.6c3.1-8.2 12.5-12.4 20.9-9.3s12.7 12.3 9.5 20.5c-5.9 15.4-19.8 27.5-37.6 30.4s-35-4-45.7-16.7c-5.7-6.8-4.7-16.8 2.2-22.4s17.2-4.6 22.9 2.1c7.8 9.3 23.5 6.7 27.8-4.6zm230 346.3c-60-9.8-110.5-74.6-140.1-122c-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9C289.5 76.8 344 51.8 460.2 70.9S619.5 131 634.5 152.1c5.8 8.1 6.4 18.2 4.7 28L611.3 343.8c-6.4 37.2-23.5 72.2-53.2 96.2c-43.7 35.4-113.1 80.5-173 70.7zm-58.5-69.5c21.7 21.3 43.5 34.7 63.8 38s45.4-2.4 73-15.6c27.1-13 53.2-31.4 74-48.2c22.3-18.1 36.4-45.4 41.8-76.9l27.9-163.7c.4-2.5 .4-4.2 .3-5l0-.1c-9.4-12.9-44.3-49.7-152.6-67.5s-153.6 5.9-166.7 15.1l0 .1c-.4 .7-1 2.2-1.4 4.8L258.7 285.9c-5.4 31.5-1.1 61.9 14 86.1c14.1 22.6 32.6 48.3 53.9 69.2zm24.7-202.5c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.5-10.1s-11.6 1.3-15.2 5.6zm147.8 85.7l.6-.2c3.1-1 6.1-2 9.1-3.1c3.7-1.4 7.3-2.9 10.9-4.5c6.2-2.8 13.5 1.6 12.4 8.3c-.7 4.2-1.7 8.3-2.8 12.3c-1 3.5-2.2 7-3.6 10.4c-.2 .5-.4 1-.6 1.5c-19.7 47-70.6 76.1-123.9 67.4s-91.7-52.5-94.8-103.3c0-.5-.1-1.1-.1-1.6c-.2-3.6-.1-7.3 .1-11c.2-4.1 .7-8.3 1.4-12.5c1.1-6.6 9.5-8.5 14.5-3.9c2.8 2.6 5.8 5.2 8.8 7.7c2.5 2 5 4 7.6 5.9l.5 .4c22 15.9 48 27.2 76.8 31.9s57.1 2.4 83.2-5.6zm-20.7 37.4c-21.9 3.4-44.8 3.4-67.8-.4s-44.6-11.1-64.2-21.3c10.9 22.9 32.8 40.4 60.2 44.9s53.9-5 71.8-23.2zm1.2-102c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.6-10.1s-11.6 1.3-15.2 5.6z"]
};
var faTheaterMasks = faMasksTheater;
var faKipSign = {
  prefix: 'fal',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M80 32c8.8 0 16 7.2 16 16V222.4L325.9 35.6c6.9-5.6 16.9-4.5 22.5 2.3s4.5 16.9-2.3 22.5L125.1 240H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H125.1l221 179.6c6.9 5.6 7.9 15.6 2.3 22.5s-15.7 7.9-22.5 2.3L96 289.6V465c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V48c0-8.8 7.2-16 16-16z"]
};
var faFaceWoozy = {
  prefix: 'fal',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM205.3 120.9c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2zm6.6 118.6l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM327.7 169.9c-4.5 8.9-7.7 22.4-7.7 38.1s3.2 29.2 7.7 38.1c2.2 4.5 4.5 7.2 6.2 8.7c.8 .7 1.4 1 1.7 1.1c.2 .1 .3 .1 .3 .1s.1 0 .1 0s0 0 0 0s0 0 .1 0c0 0 .1 0 .3-.1c.3-.1 .9-.4 1.7-1.1c1.7-1.5 4-4.2 6.2-8.7c4.5-8.9 7.7-22.4 7.7-38.1s-3.2-29.2-7.7-38.1c-2.2-4.5-4.5-7.2-6.2-8.7c-.8-.7-1.4-1-1.7-1.1c-.2-.1-.3-.1-.3-.1l0 0 0 0s0 0 0 0s0 0 0 0c0 0-.1 0-.3 .1c-.3 .1-.9 .4-1.7 1.1c-1.7 1.5-4 4.2-6.2 8.7zm-28.6-14.3c6.6-13.3 18.8-27.6 36.9-27.6s30.3 14.3 36.9 27.6c7.1 14.2 11.1 32.8 11.1 52.4s-3.9 38.2-11.1 52.4C366.3 273.7 354.2 288 336 288s-30.3-14.3-36.9-27.6C291.9 246.2 288 227.6 288 208s3.9-38.2 11.1-52.4z"]
};
var faCloudQuestion = {
  prefix: 'fal',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112H512c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM232.7 201.8c6.5-24.6 28.7-41.8 54.2-41.8H344c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L336 300.3V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V290.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H286.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM296 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faPineapple = {
  prefix: 'fal',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M387.4 2.6c-12 5.2-21.8 13-29.1 22.5c-12.5-12.2-32.5-12-44.9 .3c-17.1 17.1-26.7 38.9-28.8 61.2c11 3.3 21.7 7.9 31.7 13.6C315.1 81.4 321.7 62.3 336 48l14.7 14.7c3.9 3.9 9.6 5.5 15 4.3s9.7-5.2 11.5-10.4C380.8 46 388.5 36.9 400 32l3.6 14.3c1.2 4.8 4.6 8.9 9.2 10.8s9.8 1.7 14.2-.8c9.5-5.4 20.4-8.3 31.5-8.3H464v5.5c0 11.2-2.9 22-8.3 31.5c-2.5 4.3-2.8 9.6-.8 14.2s6 8 10.8 9.2L480 112c-4.9 11.5-14 19.2-24.6 22.8c-5.2 1.8-9.2 6.1-10.4 11.5s.4 11 4.3 15L464 176c-14.3 14.3-33.4 20.9-52.1 19.8c5.7 10 10.2 20.7 13.6 31.7c22.3-2.1 44.1-11.7 61.2-28.8c12.4-12.4 12.5-32.4 .3-44.9c9.4-7.3 17.3-17.1 22.5-29.1c3.7-8.6 3.4-18.4-.7-26.8c-3.6-7.2-9.7-12.7-17.1-15.6c2.9-9.2 4.4-18.9 4.4-28.7V48c0-17.7-14.3-32-32-32h-5.5c-9.8 0-19.5 1.5-28.7 4.4c-2.9-7.4-8.4-13.5-15.6-17.1c-8.4-4.2-18.2-4.4-26.8-.7zM67.9 406.6C44.9 383.7 32 352.5 32 320s12.9-63.7 35.9-86.6l85.5-85.5c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l37.5 37.5c23 23 35.9 54.1 35.9 86.6s-12.9 63.7-35.9 86.6l-85.5 85.5c-23 23-54.1 35.9-86.6 35.9s-63.7-12.9-86.6-35.9L67.9 406.6zM45.3 429.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3l85.5-85.5c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-37.5-37.5C320.3 96.3 281 80 240 80s-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3zM148.7 212.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm128 0c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 409.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faHandPointLeft = {
  prefix: 'fal',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M56 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0 40 0 0-32c0-5.5 .6-10.8 1.6-16L56 128zm216 48l0 0 0 32 0 0 0 24c0 13.2 10.7 24 24 24l0 0c13.3 0 24-10.7 24-24l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 15.7-6.4 29.8-16.8 40c10.4 10.2 16.8 24.3 16.8 40c0 13.8-5 26.4-13.2 36.1C351.7 358.4 360 374.2 360 392c0 8.6-1.9 16.7-5.4 24C424.1 414.6 480 357.8 480 288l0-64c0-70.7-57.3-128-128-128l-32 0c-26.5 0-48 21.5-48 48l0 32zm-32 32l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l31.9 0c0 0 0 0 .1 0l13.4 0c-3.5-7.3-5.4-15.4-5.4-24l0-24zm-90.6 0L56 208c-30.9 0-56-25.1-56-56s25.1-56 56-56l200 0c14.6-19.4 37.8-32 64-32l32 0c88.4 0 160 71.6 160 160l0 64c0 88.4-71.6 160-160 160l-48 0-32 0-24 0c-30.9 0-56-25.1-56-56c0-12.1 3.8-23.3 10.4-32.5C186.5 349.6 176 332 176 312c0-9.7 2.5-18.8 6.8-26.7C160.3 278 144 256.9 144 232c0-8.6 1.9-16.7 5.4-24zM272 288l-40 0c-13.2 0-24 10.8-24 24c0 13.3 10.7 24 24 24l16 0 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l0 0-24 0zm0 128l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0z"]
};
var faGalleryThumbnails = {
  prefix: 'fal',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M512 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 448v32H32l0-32H64zM32 416c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32zm160 32h32v32H192V448zm-32 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm224 0v32H352V448h32zm-32-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352zm160 32h32v32H512V448zm-32 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512c-17.7 0-32 14.3-32 32z"]
};
var faCircleJ = {
  prefix: 'fal',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-368c0-8.8-7.2-16-16-16s-16 7.2-16 16V288c0 35.3-28.7 64-64 64s-64-28.7-64-64V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96V144z"]
};
var faEyes = {
  prefix: 'fal',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", "M304 256c0 55.6-16.9 104.7-42.8 139.2C235.3 429.7 202.1 448 168 448s-67.3-18.3-93.2-52.8c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C100.7 82.3 133.9 64 168 64s67.3 18.3 93.2 52.8C287.1 151.3 304 200.4 304 256zm16-95.5C293.1 84.5 235.2 32 168 32C75.2 32 0 132.3 0 256S75.2 480 168 480c67.2 0 125.1-52.5 152-128.5C346.9 427.5 404.8 480 472 480c92.8 0 168-100.3 168-224s-75.2-224-168-224c-67.2 0-125.1 52.5-152 128.5zm58.8 234.7c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C404.7 82.3 437.9 64 472 64s67.3 18.3 93.2 52.8C591.1 151.3 608 200.4 608 256s-16.9 104.7-42.8 139.2S506.1 448 472 448s-67.3-18.3-93.2-52.8zM32 288a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm352-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faHandshakeSimple = {
  prefix: 'fal',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", "M263.9 64h8.7L237.4 99.2c-16.6 4.1-32.2 11.9-45.5 23.1l-40.5 34c-2.9 2.4-6.5 3.8-10.3 3.8H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87.3l36-30.3C197.2 76 230 64 263.9 64zm28.4 35c23.8-22.5 55.3-35 88.1-35c30.2 0 59.4 10.6 82.5 30.1L503.3 128H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H497.5c-3.8 0-7.4-1.3-10.3-3.8l-44.8-37.7C425 104 403.1 96 380.4 96c-24.6 0-48.2 9.4-66.1 26.3l-79.4 75c-14.9 14.1-14.6 38 .8 51.6c13.5 12 33.8 11.8 47-.4l76.1-70.2c6.5-6 16.6-5.6 22.6 .9s5.6 16.6-.9 22.6l-8.1 7.5L458 294.8c7 7 12.1 15.2 15.1 24H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H475.8c-2.3 13.8-9.2 27-20.6 37c-15.7 14-36.5 18.8-55.7 14.8c-2.7 8.1-7 15.8-13 22.5c-23 25.9-62 28.6-88.4 7.3c-.8 .7-1.5 1.5-2.3 2.2c-26.4 23.6-66.7 22.5-91.8-2.6l-24.3-24.3c0 0-.1-.1-.1-.1l-15.4-15.4-28.6-28.6c-7.5-7.5-17.7-11.7-28.3-11.7H48c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.4 0c19.1 0 37.4 7.6 50.9 21.1l28.6 28.6 39.9 39.8c13.1 13.1 34 13.6 47.8 1.3c3.2-2.9 5.8-6.2 7.6-9.8c2.4-4.5 6.7-7.6 11.8-8.4s10.1 .9 13.7 4.5l8.1 8.1c13.1 13.1 34.6 12.5 46.9-1.4c5.8-6.5 8.5-14.7 8.1-22.9c-.3-6 2.8-11.6 8-14.6s11.6-2.8 16.6 .5c11.8 7.6 27.6 6.7 38.6-3c13.7-12.2 14.4-33.5 1.4-46.5L348.9 231l-44.5 41c-25.3 23.4-64.2 23.7-90 .8C185 246.7 184.3 201 212.9 174l79.4-75z"]
};
var faHandshakeAlt = faHandshakeSimple;
var faPageCaretUp = {
  prefix: 'fal',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H245.5c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6V448zM64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64zM203.8 197.2c-3-3.3-7.3-5.2-11.8-5.2s-8.8 1.9-11.8 5.2l-75.7 82.6c-14.1 15.4-3.2 40.2 17.7 40.2H261.8c20.9 0 31.8-24.8 17.7-40.2l-75.7-82.6zM192 231.7L243.6 288H140.4L192 231.7z"]
};
var faFileCaretUp = faPageCaretUp;
var faJetFighter = {
  prefix: 'fal',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", "M224 32h23.9L352.6 176H224V32zM384.2 208h106c1.9 0 3.8 .3 5.6 1l107.6 40.3c2.8 1 4.6 3.7 4.6 6.6s-1.8 5.6-4.6 6.6L495.8 303c-1.8 .7-3.7 1-5.6 1h-106-.4H208 160c-4.2 0-8.3 1.7-11.3 4.7l-38.6 38.6c-3 3-7.1 4.7-11.3 4.7H80c-8.8 0-16-7.2-16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V176c0-8.8 7.2-16 16-16H98.7c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48H383.8h.4zM32 272v64c0 26.5 21.5 48 48 48H98.7c12.7 0 24.9-5.1 33.9-14.1L166.6 336H192V480c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 47.8 .4H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H287.4L392.1 336h98.1c5.8 0 11.5-1 16.9-3.1l107.6-40.3c15.3-5.7 25.4-20.3 25.4-36.6s-10.1-30.9-25.4-36.6L507.1 179.1c-5.4-2-11.1-3.1-16.9-3.1H392.1L287.4 32H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H256.2h-.4H208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16V176H166.6l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H80c-26.5 0-48 21.5-48 48v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H32zM224 480V336H352.6L247.9 480H224z"]
};
var faFighterJet = faJetFighter;
var faComet = {
  prefix: 'fal',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8C0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4L498.6 242.7c15.3-21.2 .2-50.7-25.9-50.7H446.6L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4V32zm154.6 .3c.5-.2 1-.3 1.5-.3c2.1 0 3.8 1.7 3.8 3.8c0 .5-.1 1.1-.3 1.5L407.4 201.6c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3h50.6L338.5 409.8C306.7 453.9 255.6 480 201.3 480C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32V89.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2L474.6 32.3zM169.1 283.7c10.4-1.5 19.4-8.1 24.1-17.5L208 236.2l14.8 30.1c4.7 9.4 13.7 16 24.1 17.5l33.2 4.8-24 23.4c-7.5 7.4-11 17.9-9.2 28.3l5.7 33.1-29.7-15.6c-9.3-4.9-20.5-4.9-29.8 0l-29.7 15.6 5.7-33.1c1.8-10.4-1.7-21-9.2-28.3l-24-23.4 33.2-4.8zm53.3-90.8c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L208 386.1l58.4 30.7c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z"]
};
var faSquareShareNodes = {
  prefix: 'fal',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-18.4 0-35.1-7.8-46.7-20.3l-81.7 44.6c.3 2.5 .5 5.1 .5 7.7s-.2 5.2-.5 7.7l81.7 44.6C284.9 295.8 301.6 288 320 288c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-5.4 .7-10.6 1.9-15.6l-78.2-42.7C168.1 309.6 149.2 320 128 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c21.2 0 40.1 10.4 51.7 26.3l78.2-42.7c-1.3-5-1.9-10.2-1.9-15.6c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faShareAltSquare = faSquareShareNodes;
var faShieldKeyhole = {
  prefix: 'fal',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6c-.5 94-39.4 259.8-195.5 334.5c-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 25.4 16.9 46.8 40 53.7V336c0 8.8 7.2 16 16 16s16-7.2 16-16V261.7c23.1-6.9 40-28.3 40-53.7z"]
};
var faBarcode = {
  prefix: 'fal',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M0 48c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm64 0c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm80-16c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm80-16c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zM496 32c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"]
};
var faPlusMinus = {
  prefix: 'fal',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M176 208V352c0 8.8 7.2 16 16 16s16-7.2 16-16V208H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V32c0-8.8-7.2-16-16-16s-16 7.2-16 16V176H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H176zM16 464c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16z"]
};
var faSquareSlidersVertical = {
  prefix: 'fal',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M384 64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 96c-8.8 0-16 7.2-16 16v48H104c-8.8 0-16 7.2-16 16s7.2 16 16 16h40 40c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V144c0-8.8-7.2-16-16-16zm0 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V272c0-8.8-7.2-16-16-16zM304 128c-8.8 0-16 7.2-16 16V256H264c-8.8 0-16 7.2-16 16s7.2 16 16 16h40 40c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16zm0 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16z"]
};
var faSlidersVSquare = faSquareSlidersVertical;
var faVideo = {
  prefix: 'fal',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64v47.2V336.8 384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM519.4 411.3L416 354.4V317.9l118.8 65.4c.9 .5 1.9 .8 3 .8c3.4 0 6.2-2.8 6.2-6.2V134.2c0-3.4-2.8-6.2-6.2-6.2c-1 0-2.1 .3-3 .8L416 194.1V157.6l103.4-56.9c5.6-3.1 12-4.7 18.4-4.7c21.1 0 38.2 17.1 38.2 38.2V377.8c0 21.1-17.1 38.2-38.2 38.2c-6.4 0-12.8-1.6-18.4-4.7z"]
};
var faVideoCamera = faVideo;
var faMessageMiddle = {
  prefix: 'fal',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M343.5 384H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64C46.3 32 32 46.3 32 64V352c0 17.7 14.3 32 32 32H168.5c9.5 0 18.5 4.2 24.6 11.5L256 471l62.9-75.5C325 388.2 334 384 343.5 384zM268.3 485.7s0 0 0 0L256 496l12.3-10.2 0 0zM168.5 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H343.5l-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z"]
};
var faCommentMiddleAlt = faMessageMiddle;
var faGraduationCap = {
  prefix: 'fal',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M307.2 66.2L47.6 160l74 26.7c10.3-6.9 21.5-12.6 33.4-17.1l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6L166.2 199.6c-1.5 .5-2.9 1.1-4.3 1.7l145.3 52.5c4.1 1.5 8.4 2.2 12.8 2.2s8.7-.8 12.8-2.2L592.4 160 332.8 66.2c-4.1-1.5-8.4-2.2-12.8-2.2s-8.7 .8-12.8 2.2zM296.3 283.9L126.9 222.7C99.4 246 82.1 279.9 80.2 316.9c5.9 13.2 10.2 27.5 13.4 41.5c6.4 27.6 10.7 65.9 2.1 108.7c-.9 4.3-3.4 8-7.1 10.4s-8.2 3.1-12.4 2l-64-16c-5.2-1.3-9.4-5.1-11.2-10.2s-.9-10.7 2.3-14.9c8.6-11.7 16-24.6 22.5-37.6C37.2 377.8 48 348.4 48 320c0-.6 0-1.2 .1-1.8c1.4-41 18-79.1 45.1-107.7L15.8 182.6C6.3 179.1 0 170.1 0 160s6.3-19.1 15.8-22.6L296.3 36.1c7.6-2.7 15.6-4.1 23.7-4.1s16.1 1.4 23.7 4.1L624.2 137.4c9.5 3.4 15.8 12.5 15.8 22.6s-6.3 19.1-15.8 22.6L343.7 283.9c-7.6 2.7-15.6 4.1-23.7 4.1s-16.1-1.4-23.7-4.1zm-122-10L160.4 406.3c.7 .8 1.8 2.1 3.7 3.7c6 5.2 16.5 11.5 31.9 17.5C226.4 439.4 270.3 448 320 448s93.6-8.6 124.1-20.6c15.4-6 25.8-12.3 31.9-17.5c1.9-1.6 3-2.8 3.7-3.7L465.7 273.8l31-11.2L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.3-145.4 31 11.2zM480.5 405a.2 .2 0 1 0 -.3-.1 .2 .2 0 1 0 .3 .1zm-321 0a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zM67 444.2c2.5-20.7 1.7-40-.5-56.7c-3.8 10-8 19.3-12.1 27.6c-3.8 7.6-7.9 15.2-12.5 22.8L67 444.2z"]
};
var faMortarBoard = faGraduationCap;
var faHandHoldingMedical = {
  prefix: 'fal',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M266.7 0h42.7c17.7 0 32 14.3 32 32V74.7H384c17.7 0 32 14.3 32 32v42.7c0 17.7-14.3 32-32 32H341.3V224c0 17.7-14.3 32-32 32H266.7c-17.7 0-32-14.3-32-32V181.3H192c-17.7 0-32-14.3-32-32V106.7c0-17.7 14.3-32 32-32h42.7V32c0-17.7 14.3-32 32-32zm0 32V90.7c0 8.8-7.2 16-16 16l-58.7 0v42.7h58.7c8.8 0 16 7.2 16 16V224h42.7V165.3c0-8.8 7.2-16 16-16l58.7 0V106.7H325.3c-8.8 0-16-7.2-16-16l0-58.7-42.7 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H371.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H344 320 256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64 24c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H75.2L151 317.4z"]
};
var faPersonCircleCheck = {
  prefix: 'fal',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM128 164V320h64V164c-6-2.6-12.5-4-19.3-4H147.3c-6.8 0-13.3 1.4-19.3 4zm0 188V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1L46.1 295.5c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7L76.7 170.3c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faSquareZ = {
  prefix: 'fal',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32H304c6 0 11.5 3.3 14.2 8.7s2.3 11.7-1.2 16.6L175.1 352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-6 0-11.5-3.4-14.2-8.7s-2.3-11.7 1.2-16.6L272.9 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMessageText = {
  prefix: 'fal',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48V272c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 192z"]
};
var faCommentAltText = faMessageText;
var faTurnUp = {
  prefix: 'fal',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M128 160H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L192 35.8 317.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7H256c-17.7 0-32 14.3-32 32V368c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48V192c0-17.7-14.3-32-32-32zM206 5.3C202.1 1.9 197.2 0 192 0s-10.1 1.9-14 5.3L44.9 124.5C36.7 131.8 32 142.3 32 153.3C32 174.7 49.3 192 70.7 192H96h32v32V368c0 8.8-7.2 16-16 16l-64 0c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h64c79.5 0 144-64.5 144-144V224 192h32 25.3c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L206 5.3z"]
};
var faLevelUpAlt = faTurnUp;
var icons = {
  fa0: fa0,
  fa1: fa1,
  fa2: fa2,
  fa3: fa3,
  fa4: fa4,
  fa5: fa5,
  fa6: fa6,
  fa7: fa7,
  fa8: fa8,
  fa9: fa9,
  faFillDrip: faFillDrip,
  faArrowsToCircle: faArrowsToCircle,
  faCircleChevronRight: faCircleChevronRight,
  faChevronCircleRight: faChevronCircleRight,
  faWagonCovered: faWagonCovered,
  faLineHeight: faLineHeight,
  faBagel: faBagel,
  faTransporter7: faTransporter7,
  faAt: faAt,
  faRectanglesMixed: faRectanglesMixed,
  faPhoneArrowUpRight: faPhoneArrowUpRight,
  faPhoneArrowUp: faPhoneArrowUp,
  faPhoneOutgoing: faPhoneOutgoing,
  faTrashCan: faTrashCan,
  faTrashAlt: faTrashAlt,
  faCircleL: faCircleL,
  faHeadSideGoggles: faHeadSideGoggles,
  faHeadVr: faHeadVr,
  faTextHeight: faTextHeight,
  faUserXmark: faUserXmark,
  faUserTimes: faUserTimes,
  faFaceHandYawn: faFaceHandYawn,
  faGaugeSimpleMin: faGaugeSimpleMin,
  faTachometerSlowest: faTachometerSlowest,
  faStethoscope: faStethoscope,
  faCoffin: faCoffin,
  faMessage: faMessage,
  faCommentAlt: faCommentAlt,
  faSalad: faSalad,
  faBowlSalad: faBowlSalad,
  faInfo: faInfo,
  faRobotAstromech: faRobotAstromech,
  faRingDiamond: faRingDiamond,
  faFonduePot: faFonduePot,
  faTheta: faTheta,
  faFaceHandPeeking: faFaceHandPeeking,
  faSquareUser: faSquareUser,
  faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
  faCompressAlt: faCompressAlt,
  faExplosion: faExplosion,
  faFileLines: faFileLines,
  faFileAlt: faFileAlt,
  faFileText: faFileText,
  faWaveSquare: faWaveSquare,
  faRing: faRing,
  faBuildingUn: faBuildingUn,
  faDiceThree: faDiceThree,
  faTirePressureWarning: faTirePressureWarning,
  faWifiFair: faWifiFair,
  faWifi2: faWifi2,
  faCalendarDays: faCalendarDays,
  faCalendarAlt: faCalendarAlt,
  faMp3Player: faMp3Player,
  faAnchorCircleCheck: faAnchorCircleCheck,
  faTally4: faTally4,
  faRectangleHistory: faRectangleHistory,
  faBuildingCircleArrowRight: faBuildingCircleArrowRight,
  faVolleyball: faVolleyball,
  faVolleyballBall: faVolleyballBall,
  faSunHaze: faSunHaze,
  faTextSize: faTextSize,
  faUfo: faUfo,
  faFork: faFork,
  faUtensilFork: faUtensilFork,
  faArrowsUpToLine: faArrowsUpToLine,
  faMobileSignal: faMobileSignal,
  faBarcodeScan: faBarcodeScan,
  faSortDown: faSortDown,
  faSortDesc: faSortDesc,
  faFolderArrowDown: faFolderArrowDown,
  faFolderDownload: faFolderDownload,
  faCircleMinus: faCircleMinus,
  faMinusCircle: faMinusCircle,
  faFaceIcicles: faFaceIcicles,
  faShovel: faShovel,
  faDoorOpen: faDoorOpen,
  faFilms: faFilms,
  faRightFromBracket: faRightFromBracket,
  faSignOutAlt: faSignOutAlt,
  faFaceGlasses: faFaceGlasses,
  faNfc: faNfc,
  faAtom: faAtom,
  faSoap: faSoap,
  faIcons: faIcons,
  faHeartMusicCameraBolt: faHeartMusicCameraBolt,
  faMicrophoneLinesSlash: faMicrophoneLinesSlash,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faClosedCaptioningSlash: faClosedCaptioningSlash,
  faCalculatorSimple: faCalculatorSimple,
  faCalculatorAlt: faCalculatorAlt,
  faBridgeCircleCheck: faBridgeCircleCheck,
  faSlidersUp: faSlidersUp,
  faSlidersV: faSlidersV,
  faLocationMinus: faLocationMinus,
  faMapMarkerMinus: faMapMarkerMinus,
  faPumpMedical: faPumpMedical,
  faFingerprint: faFingerprint,
  faSkiBoot: faSkiBoot,
  faStandardDefinition: faStandardDefinition,
  faRectangleSd: faRectangleSd,
  faH1: faH1,
  faHandPointRight: faHandPointRight,
  faMagnifyingGlassLocation: faMagnifyingGlassLocation,
  faSearchLocation: faSearchLocation,
  faMessageBot: faMessageBot,
  faForwardStep: faForwardStep,
  faStepForward: faStepForward,
  faFaceSmileBeam: faFaceSmileBeam,
  faSmileBeam: faSmileBeam,
  faLightCeiling: faLightCeiling,
  faMessageExclamation: faMessageExclamation,
  faCommentAltExclamation: faCommentAltExclamation,
  faBowlScoop: faBowlScoop,
  faBowlShavedIce: faBowlShavedIce,
  faSquareX: faSquareX,
  faUtilityPoleDouble: faUtilityPoleDouble,
  faFlagCheckered: faFlagCheckered,
  faChevronsUp: faChevronsUp,
  faChevronDoubleUp: faChevronDoubleUp,
  faFootball: faFootball,
  faFootballBall: faFootballBall,
  faUserVneck: faUserVneck,
  faSchoolCircleExclamation: faSchoolCircleExclamation,
  faCrop: faCrop,
  faAnglesDown: faAnglesDown,
  faAngleDoubleDown: faAngleDoubleDown,
  faUsersRectangle: faUsersRectangle,
  faPeopleRoof: faPeopleRoof,
  faSquareArrowRight: faSquareArrowRight,
  faArrowSquareRight: faArrowSquareRight,
  faLocationPlus: faLocationPlus,
  faMapMarkerPlus: faMapMarkerPlus,
  faLightbulbExclamationOn: faLightbulbExclamationOn,
  faPeopleLine: faPeopleLine,
  faBeerMugEmpty: faBeerMugEmpty,
  faBeer: faBeer,
  faCrateEmpty: faCrateEmpty,
  faDiagramPredecessor: faDiagramPredecessor,
  faTransporter: faTransporter,
  faCalendarCircleUser: faCalendarCircleUser,
  faArrowUpLong: faArrowUpLong,
  faLongArrowUp: faLongArrowUp,
  faPersonCarryBox: faPersonCarryBox,
  faPersonCarry: faPersonCarry,
  faFireFlameSimple: faFireFlameSimple,
  faBurn: faBurn,
  faPerson: faPerson,
  faMale: faMale,
  faLaptop: faLaptop,
  faFileCsv: faFileCsv,
  faMenorah: faMenorah,
  faUnion: faUnion,
  faChevronsLeft: faChevronsLeft,
  faChevronDoubleLeft: faChevronDoubleLeft,
  faCircleHeart: faCircleHeart,
  faHeartCircle: faHeartCircle,
  faTruckPlane: faTruckPlane,
  faRecordVinyl: faRecordVinyl,
  faBringForward: faBringForward,
  faSquareP: faSquareP,
  faFaceGrinStars: faFaceGrinStars,
  faGrinStars: faGrinStars,
  faSigma: faSigma,
  faCameraMovie: faCameraMovie,
  faBong: faBong,
  faClarinet: faClarinet,
  faTruckFlatbed: faTruckFlatbed,
  faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
  faPastafarianism: faPastafarianism,
  faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
  faLeafHeart: faLeafHeart,
  faHouseBuilding: faHouseBuilding,
  faCheeseSwiss: faCheeseSwiss,
  faSpoon: faSpoon,
  faUtensilSpoon: faUtensilSpoon,
  faJarWheat: faJarWheat,
  faEnvelopesBulk: faEnvelopesBulk,
  faMailBulk: faMailBulk,
  faFileCircleExclamation: faFileCircleExclamation,
  faBowArrow: faBowArrow,
  faCartXmark: faCartXmark,
  faHexagonXmark: faHexagonXmark,
  faTimesHexagon: faTimesHexagon,
  faXmarkHexagon: faXmarkHexagon,
  faCircleH: faCircleH,
  faHospitalSymbol: faHospitalSymbol,
  faMerge: faMerge,
  faPager: faPager,
  faCartMinus: faCartMinus,
  faAddressBook: faAddressBook,
  faContactBook: faContactBook,
  faPanFrying: faPanFrying,
  faGrid: faGrid,
  faGrid3: faGrid3,
  faFootballHelmet: faFootballHelmet,
  faHandLove: faHandLove,
  faTrees: faTrees,
  faStrikethrough: faStrikethrough,
  faPage: faPage,
  faK: faK,
  faDiagramPrevious: faDiagramPrevious,
  faGaugeMin: faGaugeMin,
  faTachometerAltSlowest: faTachometerAltSlowest,
  faFolderGrid: faFolderGrid,
  faEggplant: faEggplant,
  faRam: faRam,
  faLandmarkFlag: faLandmarkFlag,
  faLips: faLips,
  faPencil: faPencil,
  faPencilAlt: faPencilAlt,
  faBackward: faBackward,
  faCaretRight: faCaretRight,
  faComments: faComments,
  faPaste: faPaste,
  faFileClipboard: faFileClipboard,
  faDesktopArrowDown: faDesktopArrowDown,
  faCodePullRequest: faCodePullRequest,
  faPumpkin: faPumpkin,
  faClipboardList: faClipboardList,
  faPenField: faPenField,
  faBlueberries: faBlueberries,
  faTruckRampBox: faTruckRampBox,
  faTruckLoading: faTruckLoading,
  faNote: faNote,
  faArrowDownToSquare: faArrowDownToSquare,
  faUserCheck: faUserCheck,
  faCloudXmark: faCloudXmark,
  faVialVirus: faVialVirus,
  faBookBlank: faBookBlank,
  faBookAlt: faBookAlt,
  faGolfFlagHole: faGolfFlagHole,
  faMessageArrowDown: faMessageArrowDown,
  faCommentAltArrowDown: faCommentAltArrowDown,
  faFaceUnamused: faFaceUnamused,
  faSheetPlastic: faSheetPlastic,
  faCircle9: faCircle9,
  faBlog: faBlog,
  faUserNinja: faUserNinja,
  faPencilSlash: faPencilSlash,
  faBowlingPins: faBowlingPins,
  faPersonArrowUpFromLine: faPersonArrowUpFromLine,
  faDownRight: faDownRight,
  faScrollTorah: faScrollTorah,
  faTorah: faTorah,
  faWebhook: faWebhook,
  faBlindsOpen: faBlindsOpen,
  faFence: faFence,
  faUp: faUp,
  faArrowAltUp: faArrowAltUp,
  faBroomBall: faBroomBall,
  faQuidditch: faQuidditch,
  faQuidditchBroomBall: faQuidditchBroomBall,
  faDrumstick: faDrumstick,
  faSquareV: faSquareV,
  faFaceAwesome: faFaceAwesome,
  faGaveDandy: faGaveDandy,
  faDialOff: faDialOff,
  faToggleOff: faToggleOff,
  faFaceSmileHorns: faFaceSmileHorns,
  faBoxArchive: faBoxArchive,
  faArchive: faArchive,
  faGrapes: faGrapes,
  faPersonDrowning: faPersonDrowning,
  faDialMax: faDialMax,
  faCircleM: faCircleM,
  faCalendarImage: faCalendarImage,
  faCircleCaretDown: faCircleCaretDown,
  faCaretCircleDown: faCaretCircleDown,
  faArrowDown91: faArrowDown91,
  faSortNumericDesc: faSortNumericDesc,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faFaceGrinTongueSquint: faFaceGrinTongueSquint,
  faGrinTongueSquint: faGrinTongueSquint,
  faShishKebab: faShishKebab,
  faSprayCan: faSprayCan,
  faAlarmSnooze: faAlarmSnooze,
  faScarecrow: faScarecrow,
  faTruckMonster: faTruckMonster,
  faGiftCard: faGiftCard,
  faW: faW,
  faCodePullRequestDraft: faCodePullRequestDraft,
  faSquareB: faSquareB,
  faElephant: faElephant,
  faEarthAfrica: faEarthAfrica,
  faGlobeAfrica: faGlobeAfrica,
  faRainbow: faRainbow,
  faCircleNotch: faCircleNotch,
  faTabletScreenButton: faTabletScreenButton,
  faTabletAlt: faTabletAlt,
  faPaw: faPaw,
  faMessageQuestion: faMessageQuestion,
  faCloud: faCloud,
  faTrowelBricks: faTrowelBricks,
  faSquare3: faSquare3,
  faFaceFlushed: faFaceFlushed,
  faFlushed: faFlushed,
  faHospitalUser: faHospitalUser,
  faMicrowave: faMicrowave,
  faChfSign: faChfSign,
  faTentArrowLeftRight: faTentArrowLeftRight,
  faCartCircleArrowUp: faCartCircleArrowUp,
  faTrashClock: faTrashClock,
  faGavel: faGavel,
  faLegal: faLegal,
  faSprinklerCeiling: faSprinklerCeiling,
  faBrowsers: faBrowsers,
  faTrillium: faTrillium,
  faMusicSlash: faMusicSlash,
  faTruckRamp: faTruckRamp,
  faBinoculars: faBinoculars,
  faMicrophoneSlash: faMicrophoneSlash,
  faBoxTissue: faBoxTissue,
  faCircleC: faCircleC,
  faStarChristmas: faStarChristmas,
  faChartBullet: faChartBullet,
  faMotorcycle: faMotorcycle,
  faTreeChristmas: faTreeChristmas,
  faTireFlat: faTireFlat,
  faSunglasses: faSunglasses,
  faBadge: faBadge,
  faMessagePen: faMessagePen,
  faCommentAltEdit: faCommentAltEdit,
  faMessageEdit: faMessageEdit,
  faBellConcierge: faBellConcierge,
  faConciergeBell: faConciergeBell,
  faPenRuler: faPenRuler,
  faPencilRuler: faPencilRuler,
  faArrowProgress: faArrowProgress,
  faChessRookPiece: faChessRookPiece,
  faChessRookAlt: faChessRookAlt,
  faSquareRoot: faSquareRoot,
  faAlbumCollectionCirclePlus: faAlbumCollectionCirclePlus,
  faPeopleArrows: faPeopleArrows,
  faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
  faFaceAngryHorns: faFaceAngryHorns,
  faMarsAndVenusBurst: faMarsAndVenusBurst,
  faTombstone: faTombstone,
  faSquareCaretRight: faSquareCaretRight,
  faCaretSquareRight: faCaretSquareRight,
  faScissors: faScissors,
  faCut: faCut,
  faListMusic: faListMusic,
  faSunPlantWilt: faSunPlantWilt,
  faToiletsPortable: faToiletsPortable,
  faHockeyPuck: faHockeyPuck,
  faMustache: faMustache,
  faHyphen: faHyphen,
  faTable: faTable,
  faUserChef: faUserChef,
  faMessageImage: faMessageImage,
  faCommentAltImage: faCommentAltImage,
  faUsersMedical: faUsersMedical,
  faSensorTriangleExclamation: faSensorTriangleExclamation,
  faSensorAlert: faSensorAlert,
  faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
  faTachographDigital: faTachographDigital,
  faDigitalTachograph: faDigitalTachograph,
  faFaceMask: faFaceMask,
  faPickleball: faPickleball,
  faStarSharpHalf: faStarSharpHalf,
  faUsersSlash: faUsersSlash,
  faClover: faClover,
  faMeat: faMeat,
  faReply: faReply,
  faMailReply: faMailReply,
  faStarAndCrescent: faStarAndCrescent,
  faEmptySet: faEmptySet,
  faHouseFire: faHouseFire,
  faSquareMinus: faSquareMinus,
  faMinusSquare: faMinusSquare,
  faHelicopter: faHelicopter,
  faBird: faBird,
  faCompass: faCompass,
  faSquareCaretDown: faSquareCaretDown,
  faCaretSquareDown: faCaretSquareDown,
  faHeartHalfStroke: faHeartHalfStroke,
  faHeartHalfAlt: faHeartHalfAlt,
  faFileCircleQuestion: faFileCircleQuestion,
  faLaptopCode: faLaptopCode,
  faJoystick: faJoystick,
  faGrillFire: faGrillFire,
  faRectangleVerticalHistory: faRectangleVerticalHistory,
  faSwatchbook: faSwatchbook,
  faPrescriptionBottle: faPrescriptionBottle,
  faBars: faBars,
  faNavicon: faNavicon,
  faKeyboardLeft: faKeyboardLeft,
  faPeopleGroup: faPeopleGroup,
  faHourglassEnd: faHourglassEnd,
  faHourglass3: faHourglass3,
  faHeartCrack: faHeartCrack,
  faHeartBroken: faHeartBroken,
  faFaceBeamHandOverMouth: faFaceBeamHandOverMouth,
  faDropletPercent: faDropletPercent,
  faHumidity: faHumidity,
  faSquareUpRight: faSquareUpRight,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faFaceKissBeam: faFaceKissBeam,
  faKissBeam: faKissBeam,
  faCorn: faCorn,
  faRollerCoaster: faRollerCoaster,
  faPhotoFilmMusic: faPhotoFilmMusic,
  faRadar: faRadar,
  faSickle: faSickle,
  faFilm: faFilm,
  faCoconut: faCoconut,
  faRulerHorizontal: faRulerHorizontal,
  faShieldCross: faShieldCross,
  faCassetteTape: faCassetteTape,
  faSquareTerminal: faSquareTerminal,
  faPeopleRobbery: faPeopleRobbery,
  faLightbulb: faLightbulb,
  faCaretLeft: faCaretLeft,
  faCommentMiddle: faCommentMiddle,
  faTrashCanList: faTrashCanList,
  faBlock: faBlock,
  faCircleExclamation: faCircleExclamation,
  faExclamationCircle: faExclamationCircle,
  faSchoolCircleXmark: faSchoolCircleXmark,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faSignOut: faSignOut,
  faFaceFrownSlight: faFaceFrownSlight,
  faCircleChevronDown: faCircleChevronDown,
  faChevronCircleDown: faChevronCircleDown,
  faSidebarFlip: faSidebarFlip,
  faUnlockKeyhole: faUnlockKeyhole,
  faUnlockAlt: faUnlockAlt,
  faTemperatureList: faTemperatureList,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faHeadphonesSimple: faHeadphonesSimple,
  faHeadphonesAlt: faHeadphonesAlt,
  faSitemap: faSitemap,
  faPipeSection: faPipeSection,
  faSpaceStationMoonConstruction: faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt: faSpaceStationMoonAlt,
  faCircleDollarToSlot: faCircleDollarToSlot,
  faDonate: faDonate,
  faMemory: faMemory,
  faFaceSleeping: faFaceSleeping,
  faRoadSpikes: faRoadSpikes,
  faFireBurner: faFireBurner,
  faSquirrel: faSquirrel,
  faArrowUpToLine: faArrowUpToLine,
  faArrowToTop: faArrowToTop,
  faFlag: faFlag,
  faFaceCowboyHat: faFaceCowboyHat,
  faHanukiah: faHanukiah,
  faChartScatter3d: faChartScatter3d,
  faDisplayChartUp: faDisplayChartUp,
  faSquareCode: faSquareCode,
  faFeather: faFeather,
  faVolumeLow: faVolumeLow,
  faVolumeDown: faVolumeDown,
  faXmarkToSlot: faXmarkToSlot,
  faTimesToSlot: faTimesToSlot,
  faVoteNay: faVoteNay,
  faBoxTaped: faBoxTaped,
  faBoxAlt: faBoxAlt,
  faCommentSlash: faCommentSlash,
  faSwords: faSwords,
  faCloudSunRain: faCloudSunRain,
  faAlbum: faAlbum,
  faCircleN: faCircleN,
  faCompress: faCompress,
  faWheatAwn: faWheatAwn,
  faWheatAlt: faWheatAlt,
  faAnkh: faAnkh,
  faHandsHoldingChild: faHandsHoldingChild,
  faAsterisk: faAsterisk,
  faKeySkeletonLeftRight: faKeySkeletonLeftRight,
  faCommentLines: faCommentLines,
  faLuchadorMask: faLuchadorMask,
  faLuchador: faLuchador,
  faMaskLuchador: faMaskLuchador,
  faSquareCheck: faSquareCheck,
  faCheckSquare: faCheckSquare,
  faShredder: faShredder,
  faBookOpenCover: faBookOpenCover,
  faBookOpenAlt: faBookOpenAlt,
  faSandwich: faSandwich,
  faPesetaSign: faPesetaSign,
  faSquareParkingSlash: faSquareParkingSlash,
  faParkingSlash: faParkingSlash,
  faTrainTunnel: faTrainTunnel,
  faHeading: faHeading,
  faHeader: faHeader,
  faGhost: faGhost,
  faFaceAnguished: faFaceAnguished,
  faHockeySticks: faHockeySticks,
  faAbacus: faAbacus,
  faFilmSimple: faFilmSimple,
  faFilmAlt: faFilmAlt,
  faList: faList,
  faListSquares: faListSquares,
  faTreePalm: faTreePalm,
  faSquarePhoneFlip: faSquarePhoneFlip,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faCartPlus: faCartPlus,
  faGamepad: faGamepad,
  faBorderCenterV: faBorderCenterV,
  faCircleDot: faCircleDot,
  faDotCircle: faDotCircle,
  faClipboardMedical: faClipboardMedical,
  faFaceDizzy: faFaceDizzy,
  faDizzy: faDizzy,
  faEgg: faEgg,
  faUpToLine: faUpToLine,
  faArrowAltToTop: faArrowAltToTop,
  faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
  faWatchFitness: faWatchFitness,
  faClockNineThirty: faClockNineThirty,
  faCampground: faCampground,
  faFolderPlus: faFolderPlus,
  faJug: faJug,
  faFutbol: faFutbol,
  faFutbolBall: faFutbolBall,
  faSoccerBall: faSoccerBall,
  faSnowBlowing: faSnowBlowing,
  faPaintbrush: faPaintbrush,
  faPaintBrush: faPaintBrush,
  faLock: faLock,
  faArrowDownFromLine: faArrowDownFromLine,
  faArrowFromTop: faArrowFromTop,
  faGasPump: faGasPump,
  faSignalBarsSlash: faSignalBarsSlash,
  faSignalAltSlash: faSignalAltSlash,
  faMonkey: faMonkey,
  faRectanglePro: faRectanglePro,
  faPro: faPro,
  faHouseNight: faHouseNight,
  faHotTubPerson: faHotTubPerson,
  faHotTub: faHotTub,
  faGlobePointer: faGlobePointer,
  faBlanket: faBlanket,
  faMapLocation: faMapLocation,
  faMapMarked: faMapMarked,
  faHouseFloodWater: faHouseFloodWater,
  faCommentsQuestionCheck: faCommentsQuestionCheck,
  faTree: faTree,
  faArrowsCross: faArrowsCross,
  faBackpack: faBackpack,
  faSquareSmall: faSquareSmall,
  faFolderArrowUp: faFolderArrowUp,
  faFolderUpload: faFolderUpload,
  faBridgeLock: faBridgeLock,
  faCrosshairsSimple: faCrosshairsSimple,
  faSackDollar: faSackDollar,
  faPenToSquare: faPenToSquare,
  faEdit: faEdit,
  faSquareSliders: faSquareSliders,
  faSlidersHSquare: faSlidersHSquare,
  faCarSide: faCarSide,
  faMessageMiddleTop: faMessageMiddleTop,
  faCommentMiddleTopAlt: faCommentMiddleTopAlt,
  faLightbulbOn: faLightbulbOn,
  faKnife: faKnife,
  faUtensilKnife: faUtensilKnife,
  faShareNodes: faShareNodes,
  faShareAlt: faShareAlt,
  faDisplayChartUpCircleDollar: faDisplayChartUpCircleDollar,
  faWaveSine: faWaveSine,
  faHeartCircleMinus: faHeartCircleMinus,
  faCircleW: faCircleW,
  faCircleCalendar: faCircleCalendar,
  faCalendarCircle: faCalendarCircle,
  faHourglassHalf: faHourglassHalf,
  faHourglass2: faHourglass2,
  faMicroscope: faMicroscope,
  faSunset: faSunset,
  faSink: faSink,
  faCalendarExclamation: faCalendarExclamation,
  faTruckContainerEmpty: faTruckContainerEmpty,
  faHandHeart: faHandHeart,
  faBagShopping: faBagShopping,
  faShoppingBag: faShoppingBag,
  faArrowDownZA: faArrowDownZA,
  faSortAlphaDesc: faSortAlphaDesc,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faMitten: faMitten,
  faReplyClock: faReplyClock,
  faReplyTime: faReplyTime,
  faPersonRays: faPersonRays,
  faRight: faRight,
  faArrowAltRight: faArrowAltRight,
  faCircleF: faCircleF,
  faUsers: faUsers,
  faFacePleading: faFacePleading,
  faEyeSlash: faEyeSlash,
  faFlaskVial: faFlaskVial,
  faPoliceBox: faPoliceBox,
  faCucumber: faCucumber,
  faHeadSideBrain: faHeadSideBrain,
  faHand: faHand,
  faHandPaper: faHandPaper,
  faPersonBikingMountain: faPersonBikingMountain,
  faBikingMountain: faBikingMountain,
  faUtensilsSlash: faUtensilsSlash,
  faPrintMagnifyingGlass: faPrintMagnifyingGlass,
  faPrintSearch: faPrintSearch,
  faFolderBookmark: faFolderBookmark,
  faOm: faOm,
  faPi: faPi,
  faFlaskRoundPotion: faFlaskRoundPotion,
  faFlaskPotion: faFlaskPotion,
  faFaceShush: faFaceShush,
  faWorm: faWorm,
  faHouseCircleXmark: faHouseCircleXmark,
  faPlug: faPlug,
  faCalendarCircleExclamation: faCalendarCircleExclamation,
  faSquareI: faSquareI,
  faChevronUp: faChevronUp,
  faFaceSaluting: faFaceSaluting,
  faGaugeSimpleLow: faGaugeSimpleLow,
  faTachometerSlow: faTachometerSlow,
  faFacePersevering: faFacePersevering,
  faCircleCamera: faCircleCamera,
  faCameraCircle: faCameraCircle,
  faHandSpock: faHandSpock,
  faSpiderWeb: faSpiderWeb,
  faCircleMicrophone: faCircleMicrophone,
  faMicrophoneCircle: faMicrophoneCircle,
  faBookArrowUp: faBookArrowUp,
  faPopsicle: faPopsicle,
  faCommand: faCommand,
  faBlinds: faBlinds,
  faStopwatch: faStopwatch,
  faSaxophone: faSaxophone,
  faSquare2: faSquare2,
  faFieldHockeyStickBall: faFieldHockeyStickBall,
  faFieldHockey: faFieldHockey,
  faArrowUpSquareTriangle: faArrowUpSquareTriangle,
  faSortShapesUpAlt: faSortShapesUpAlt,
  faFaceScream: faFaceScream,
  faSquareM: faSquareM,
  faCameraWeb: faCameraWeb,
  faWebcam: faWebcam,
  faCommentArrowDown: faCommentArrowDown,
  faLightbulbCfl: faLightbulbCfl,
  faWindowFrameOpen: faWindowFrameOpen,
  faFaceKiss: faFaceKiss,
  faKiss: faKiss,
  faBridgeCircleXmark: faBridgeCircleXmark,
  faPeriod: faPeriod,
  faFaceGrinTongue: faFaceGrinTongue,
  faGrinTongue: faGrinTongue,
  faUpToDottedLine: faUpToDottedLine,
  faThoughtBubble: faThoughtBubble,
  faSkeletonRibs: faSkeletonRibs,
  faRaygun: faRaygun,
  faFlute: faFlute,
  faAcorn: faAcorn,
  faVideoArrowUpRight: faVideoArrowUpRight,
  faGrateDroplet: faGrateDroplet,
  faSealExclamation: faSealExclamation,
  faChessBishop: faChessBishop,
  faMessageSms: faMessageSms,
  faCoffeeBeans: faCoffeeBeans,
  faHatWitch: faHatWitch,
  faFaceGrinWink: faFaceGrinWink,
  faGrinWink: faGrinWink,
  faClockThreeThirty: faClockThreeThirty,
  faEarDeaf: faEarDeaf,
  faDeaf: faDeaf,
  faDeafness: faDeafness,
  faHardOfHearing: faHardOfHearing,
  faAlarmClock: faAlarmClock,
  faEclipse: faEclipse,
  faFaceRelieved: faFaceRelieved,
  faRoadCircleCheck: faRoadCircleCheck,
  faDiceFive: faDiceFive,
  faOctagonMinus: faOctagonMinus,
  faMinusOctagon: faMinusOctagon,
  faSquareRss: faSquareRss,
  faRssSquare: faRssSquare,
  faFaceZany: faFaceZany,
  faTricycle: faTricycle,
  faLandMineOn: faLandMineOn,
  faSquareArrowUpLeft: faSquareArrowUpLeft,
  faICursor: faICursor,
  faChartMixedUpCircleDollar: faChartMixedUpCircleDollar,
  faSaltShaker: faSaltShaker,
  faStamp: faStamp,
  faFilePlus: faFilePlus,
  faDrawSquare: faDrawSquare,
  faToiletPaperUnderSlash: faToiletPaperUnderSlash,
  faToiletPaperReverseSlash: faToiletPaperReverseSlash,
  faStairs: faStairs,
  faDroneFront: faDroneFront,
  faDroneAlt: faDroneAlt,
  faGlassEmpty: faGlassEmpty,
  faDialHigh: faDialHigh,
  faUserHelmetSafety: faUserHelmetSafety,
  faUserConstruction: faUserConstruction,
  faUserHardHat: faUserHardHat,
  faI: faI,
  faHryvniaSign: faHryvniaSign,
  faHryvnia: faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter: faArrowDownLeftAndArrowUpRightToCenter,
  faPills: faPills,
  faFaceGrinWide: faFaceGrinWide,
  faGrinAlt: faGrinAlt,
  faTooth: faTooth,
  faBasketballHoop: faBasketballHoop,
  faObjectsAlignBottom: faObjectsAlignBottom,
  faV: faV,
  faSparkles: faSparkles,
  faSquid: faSquid,
  faLeafyGreen: faLeafyGreen,
  faCircleArrowUpRight: faCircleArrowUpRight,
  faCalendars: faCalendars,
  faBangladeshiTakaSign: faBangladeshiTakaSign,
  faBicycle: faBicycle,
  faHammerWar: faHammerWar,
  faCircleD: faCircleD,
  faSpiderBlackWidow: faSpiderBlackWidow,
  faStaffSnake: faStaffSnake,
  faRodAsclepius: faRodAsclepius,
  faRodSnake: faRodSnake,
  faStaffAesculapius: faStaffAesculapius,
  faPear: faPear,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faTriangle: faTriangle,
  faApartment: faApartment,
  faTruckMedical: faTruckMedical,
  faAmbulance: faAmbulance,
  faPepper: faPepper,
  faPiano: faPiano,
  faGunSquirt: faGunSquirt,
  faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
  faSnowman: faSnowman,
  faUserAlien: faUserAlien,
  faShieldCheck: faShieldCheck,
  faMortarPestle: faMortarPestle,
  faRoadBarrier: faRoadBarrier,
  faChartCandlestick: faChartCandlestick,
  faBriefcaseBlank: faBriefcaseBlank,
  faSchool: faSchool,
  faIgloo: faIgloo,
  faBracketRound: faBracketRound,
  faParenthesis: faParenthesis,
  faJoint: faJoint,
  faHorseSaddle: faHorseSaddle,
  faMugMarshmallows: faMugMarshmallows,
  faFilters: faFilters,
  faBellOn: faBellOn,
  faAngleRight: faAngleRight,
  faDialMed: faDialMed,
  faHorse: faHorse,
  faQ: faQ,
  faMonitorWaveform: faMonitorWaveform,
  faMonitorHeartRate: faMonitorHeartRate,
  faLinkSimple: faLinkSimple,
  faWhistle: faWhistle,
  faG: faG,
  faWineGlassCrack: faWineGlassCrack,
  faFragile: faFragile,
  faSlotMachine: faSlotMachine,
  faNotesMedical: faNotesMedical,
  faCarWash: faCarWash,
  faEscalator: faEscalator,
  faCommentImage: faCommentImage,
  faTemperatureHalf: faTemperatureHalf,
  faTemperature2: faTemperature2,
  faThermometer2: faThermometer2,
  faThermometerHalf: faThermometerHalf,
  faDongSign: faDongSign,
  faDonut: faDonut,
  faDoughnut: faDoughnut,
  faCapsules: faCapsules,
  faPooStorm: faPooStorm,
  faPooBolt: faPooBolt,
  faTally1: faTally1,
  faFaceFrownOpen: faFaceFrownOpen,
  faFrownOpen: faFrownOpen,
  faSquareDashed: faSquareDashed,
  faSquareJ: faSquareJ,
  faHandPointUp: faHandPointUp,
  faMoneyBill: faMoneyBill,
  faArrowUpBigSmall: faArrowUpBigSmall,
  faSortSizeUp: faSortSizeUp,
  faBarcodeRead: faBarcodeRead,
  faBaguette: faBaguette,
  faBowlSoftServe: faBowlSoftServe,
  faFaceHoldingBackTears: faFaceHoldingBackTears,
  faSquareUp: faSquareUp,
  faArrowAltSquareUp: faArrowAltSquareUp,
  faTrainSubwayTunnel: faTrainSubwayTunnel,
  faSubwayTunnel: faSubwayTunnel,
  faSquareExclamation: faSquareExclamation,
  faExclamationSquare: faExclamationSquare,
  faSemicolon: faSemicolon,
  faBookmark: faBookmark,
  faFanTable: faFanTable,
  faAlignJustify: faAlignJustify,
  faBatteryLow: faBatteryLow,
  faBattery1: faBattery1,
  faCreditCardFront: faCreditCardFront,
  faBrainArrowCurvedRight: faBrainArrowCurvedRight,
  faMindShare: faMindShare,
  faUmbrellaBeach: faUmbrellaBeach,
  faHelmetUn: faHelmetUn,
  faLocationSmile: faLocationSmile,
  faMapMarkerSmile: faMapMarkerSmile,
  faArrowLeftToLine: faArrowLeftToLine,
  faArrowToLeft: faArrowToLeft,
  faBullseye: faBullseye,
  faSushi: faSushi,
  faNigiri: faNigiri,
  faMessageCaptions: faMessageCaptions,
  faCommentAltCaptions: faCommentAltCaptions,
  faTrashList: faTrashList,
  faBacon: faBacon,
  faOption: faOption,
  faRaccoon: faRaccoon,
  faHandPointDown: faHandPointDown,
  faArrowUpFromBracket: faArrowUpFromBracket,
  faHeadSideGear: faHeadSideGear,
  faTrashPlus: faTrashPlus,
  faObjectsAlignTop: faObjectsAlignTop,
  faFolder: faFolder,
  faFolderBlank: faFolderBlank,
  faFaceAnxiousSweat: faFaceAnxiousSweat,
  faCreditCardBlank: faCreditCardBlank,
  faFileWaveform: faFileWaveform,
  faFileMedicalAlt: faFileMedicalAlt,
  faMicrochipAi: faMicrochipAi,
  faMug: faMug,
  faPlaneUpSlash: faPlaneUpSlash,
  faRadiation: faRadiation,
  faPenCircle: faPenCircle,
  faBagSeedling: faBagSeedling,
  faChartSimple: faChartSimple,
  faCrutches: faCrutches,
  faCircleParking: faCircleParking,
  faParkingCircle: faParkingCircle,
  faMarsStroke: faMarsStroke,
  faLeafOak: faLeafOak,
  faSquareBolt: faSquareBolt,
  faVial: faVial,
  faGauge: faGauge,
  faDashboard: faDashboard,
  faGaugeMed: faGaugeMed,
  faTachometerAltAverage: faTachometerAltAverage,
  faWandMagicSparkles: faWandMagicSparkles,
  faMagicWandSparkles: faMagicWandSparkles,
  faLambda: faLambda,
  faE: faE,
  faPizza: faPizza,
  faBowlChopsticksNoodles: faBowlChopsticksNoodles,
  faH3: faH3,
  faPenClip: faPenClip,
  faPenAlt: faPenAlt,
  faBridgeCircleExclamation: faBridgeCircleExclamation,
  faBadgePercent: faBadgePercent,
  faUser: faUser,
  faSensor: faSensor,
  faComma: faComma,
  faSchoolCircleCheck: faSchoolCircleCheck,
  faToiletPaperUnder: faToiletPaperUnder,
  faToiletPaperReverse: faToiletPaperReverse,
  faLightEmergency: faLightEmergency,
  faArrowDownToArc: faArrowDownToArc,
  faDumpster: faDumpster,
  faVanShuttle: faVanShuttle,
  faShuttleVan: faShuttleVan,
  faBuildingUser: faBuildingUser,
  faLightSwitch: faLightSwitch,
  faSquareCaretLeft: faSquareCaretLeft,
  faCaretSquareLeft: faCaretSquareLeft,
  faHighlighter: faHighlighter,
  faWavePulse: faWavePulse,
  faHeartRate: faHeartRate,
  faKey: faKey,
  faHatSanta: faHatSanta,
  faTamale: faTamale,
  faBoxCheck: faBoxCheck,
  faBullhorn: faBullhorn,
  faSteak: faSteak,
  faLocationCrosshairsSlash: faLocationCrosshairsSlash,
  faLocationSlash: faLocationSlash,
  faPersonDolly: faPersonDolly,
  faGlobe: faGlobe,
  faSynagogue: faSynagogue,
  faFileChartColumn: faFileChartColumn,
  faFileChartLine: faFileChartLine,
  faPersonHalfDress: faPersonHalfDress,
  faFolderImage: faFolderImage,
  faCalendarPen: faCalendarPen,
  faCalendarEdit: faCalendarEdit,
  faRoadBridge: faRoadBridge,
  faFaceSmileTear: faFaceSmileTear,
  faMessagePlus: faMessagePlus,
  faCommentAltPlus: faCommentAltPlus,
  faLocationArrow: faLocationArrow,
  faC: faC,
  faTabletButton: faTabletButton,
  faPersonDressFairy: faPersonDressFairy,
  faRectangleHistoryCircleUser: faRectangleHistoryCircleUser,
  faBuildingLock: faBuildingLock,
  faChartLineUp: faChartLineUp,
  faMailbox: faMailbox,
  faTruckBolt: faTruckBolt,
  faPizzaSlice: faPizzaSlice,
  faMoneyBillWave: faMoneyBillWave,
  faChartArea: faChartArea,
  faAreaChart: faAreaChart,
  faHouseFlag: faHouseFlag,
  faCircleThreeQuartersStroke: faCircleThreeQuartersStroke,
  faPersonCircleMinus: faPersonCircleMinus,
  faScalpel: faScalpel,
  faBan: faBan,
  faCancel: faCancel,
  faBellExclamation: faBellExclamation,
  faCircleBookmark: faCircleBookmark,
  faBookmarkCircle: faBookmarkCircle,
  faEggFried: faEggFried,
  faFaceWeary: faFaceWeary,
  faUniformMartialArts: faUniformMartialArts,
  faCameraRotate: faCameraRotate,
  faSunDust: faSunDust,
  faCommentText: faCommentText,
  faSprayCanSparkles: faSprayCanSparkles,
  faAirFreshener: faAirFreshener,
  faSignalBars: faSignalBars,
  faSignalAlt: faSignalAlt,
  faSignalAlt4: faSignalAlt4,
  faSignalBarsStrong: faSignalBarsStrong,
  faDiamondExclamation: faDiamondExclamation,
  faStar: faStar,
  faDialMin: faDialMin,
  faRepeat: faRepeat,
  faCross: faCross,
  faPageCaretDown: faPageCaretDown,
  faFileCaretDown: faFileCaretDown,
  faBox: faBox,
  faVenusMars: faVenusMars,
  faClockSevenThirty: faClockSevenThirty,
  faArrowPointer: faArrowPointer,
  faMousePointer: faMousePointer,
  faClockFourThirty: faClockFourThirty,
  faSignalBarsGood: faSignalBarsGood,
  faSignalAlt3: faSignalAlt3,
  faCactus: faCactus,
  faLightbulbGear: faLightbulbGear,
  faMaximize: faMaximize,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faChargingStation: faChargingStation,
  faShapes: faShapes,
  faTriangleCircleSquare: faTriangleCircleSquare,
  faPlaneTail: faPlaneTail,
  faGaugeSimpleMax: faGaugeSimpleMax,
  faTachometerFastest: faTachometerFastest,
  faCircleU: faCircleU,
  faShieldSlash: faShieldSlash,
  faSquarePhoneHangup: faSquarePhoneHangup,
  faPhoneSquareDown: faPhoneSquareDown,
  faArrowUpLeft: faArrowUpLeft,
  faTransporter1: faTransporter1,
  faPeanuts: faPeanuts,
  faShuffle: faShuffle,
  faRandom: faRandom,
  faPersonRunning: faPersonRunning,
  faRunning: faRunning,
  faMobileRetro: faMobileRetro,
  faGripLinesVertical: faGripLinesVertical,
  faBinBottlesRecycle: faBinBottlesRecycle,
  faArrowUpFromSquare: faArrowUpFromSquare,
  faFileDashedLine: faFileDashedLine,
  faPageBreak: faPageBreak,
  faBracketCurlyRight: faBracketCurlyRight,
  faSpider: faSpider,
  faClockThree: faClockThree,
  faHandsBound: faHandsBound,
  faScalpelLineDashed: faScalpelLineDashed,
  faScalpelPath: faScalpelPath,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faPipeSmoking: faPipeSmoking,
  faFaceAstonished: faFaceAstonished,
  faWindow: faWindow,
  faPlaneCircleExclamation: faPlaneCircleExclamation,
  faEar: faEar,
  faFileLock: faFileLock,
  faDiagramVenn: faDiagramVenn,
  faXRay: faXRay,
  faGoalNet: faGoalNet,
  faCoffinCross: faCoffinCross,
  faSpellCheck: faSpellCheck,
  faLocationXmark: faLocationXmark,
  faMapMarkerTimes: faMapMarkerTimes,
  faMapMarkerXmark: faMapMarkerXmark,
  faCircleQuarterStroke: faCircleQuarterStroke,
  faLasso: faLasso,
  faSlash: faSlash,
  faPersonToPortal: faPersonToPortal,
  faPortalEnter: faPortalEnter,
  faCalendarStar: faCalendarStar,
  faComputerMouse: faComputerMouse,
  faMouse: faMouse,
  faArrowRightToBracket: faArrowRightToBracket,
  faSignIn: faSignIn,
  faPegasus: faPegasus,
  faFilesMedical: faFilesMedical,
  faNfcLock: faNfcLock,
  faPersonSkiLift: faPersonSkiLift,
  faSkiLift: faSkiLift,
  faSquare6: faSquare6,
  faShopSlash: faShopSlash,
  faStoreAltSlash: faStoreAltSlash,
  faWindTurbine: faWindTurbine,
  faSlidersSimple: faSlidersSimple,
  faGridRound: faGridRound,
  faBadgeSheriff: faBadgeSheriff,
  faServer: faServer,
  faVirusCovidSlash: faVirusCovidSlash,
  faIntersection: faIntersection,
  faShopLock: faShopLock,
  faFamily: faFamily,
  faHourglassStart: faHourglassStart,
  faHourglass1: faHourglass1,
  faUserHairBuns: faUserHairBuns,
  faBlenderPhone: faBlenderPhone,
  faHourglassClock: faHourglassClock,
  faPersonSeatReclined: faPersonSeatReclined,
  faPaperPlaneTop: faPaperPlaneTop,
  faPaperPlaneAlt: faPaperPlaneAlt,
  faSend: faSend,
  faMessageArrowUp: faMessageArrowUp,
  faCommentAltArrowUp: faCommentAltArrowUp,
  faLightbulbExclamation: faLightbulbExclamation,
  faLayerMinus: faLayerMinus,
  faLayerGroupMinus: faLayerGroupMinus,
  faChartPieSimpleCircleCurrency: faChartPieSimpleCircleCurrency,
  faCircleE: faCircleE,
  faBuildingWheat: faBuildingWheat,
  faGaugeMax: faGaugeMax,
  faTachometerAltFastest: faTachometerAltFastest,
  faPersonBreastfeeding: faPersonBreastfeeding,
  faApostrophe: faApostrophe,
  faFireHydrant: faFireHydrant,
  faRightToBracket: faRightToBracket,
  faSignInAlt: faSignInAlt,
  faVideoPlus: faVideoPlus,
  faSquareRight: faSquareRight,
  faArrowAltSquareRight: faArrowAltSquareRight,
  faCommentSmile: faCommentSmile,
  faVenus: faVenus,
  faPassport: faPassport,
  faInboxIn: faInboxIn,
  faInboxArrowDown: faInboxArrowDown,
  faHeartPulse: faHeartPulse,
  faHeartbeat: faHeartbeat,
  faCircle8: faCircle8,
  faCloudsMoon: faCloudsMoon,
  faClockTenThirty: faClockTenThirty,
  faPeopleCarryBox: faPeopleCarryBox,
  faPeopleCarry: faPeopleCarry,
  faFolderUser: faFolderUser,
  faTrashCanXmark: faTrashCanXmark,
  faTemperatureHigh: faTemperatureHigh,
  faMicrochip: faMicrochip,
  faLeftLongToLine: faLeftLongToLine,
  faCrown: faCrown,
  faWeightHanging: faWeightHanging,
  faXmarksLines: faXmarksLines,
  faFilePrescription: faFilePrescription,
  faCalendarRange: faCalendarRange,
  faFlowerDaffodil: faFlowerDaffodil,
  faHandBackPointUp: faHandBackPointUp,
  faWeightScale: faWeightScale,
  faWeight: faWeight,
  faArrowUpToArc: faArrowUpToArc,
  faStarExclamation: faStarExclamation,
  faBooks: faBooks,
  faUserGroup: faUserGroup,
  faUserFriends: faUserFriends,
  faArrowUpAZ: faArrowUpAZ,
  faSortAlphaUp: faSortAlphaUp,
  faLayerPlus: faLayerPlus,
  faLayerGroupPlus: faLayerGroupPlus,
  faPlayPause: faPlayPause,
  faBlockQuestion: faBlockQuestion,
  faSnooze: faSnooze,
  faZzz: faZzz,
  faScannerImage: faScannerImage,
  faTvRetro: faTvRetro,
  faSquareT: faSquareT,
  faFarm: faFarm,
  faBarnSilo: faBarnSilo,
  faChessKnight: faChessKnight,
  faBarsSort: faBarsSort,
  faPalletBoxes: faPalletBoxes,
  faPaletteBoxes: faPaletteBoxes,
  faPalletAlt: faPalletAlt,
  faFaceLaughSquint: faFaceLaughSquint,
  faLaughSquint: faLaughSquint,
  faCodeSimple: faCodeSimple,
  faBoltSlash: faBoltSlash,
  faPanelFire: faPanelFire,
  faBinaryCircleCheck: faBinaryCircleCheck,
  faCommentMinus: faCommentMinus,
  faBurrito: faBurrito,
  faViolin: faViolin,
  faObjectsColumn: faObjectsColumn,
  faSquareChevronDown: faSquareChevronDown,
  faChevronSquareDown: faChevronSquareDown,
  faCommentPlus: faCommentPlus,
  faTriangleInstrument: faTriangleInstrument,
  faTriangleMusic: faTriangleMusic,
  faWheelchair: faWheelchair,
  faUserPilotTie: faUserPilotTie,
  faPianoKeyboard: faPianoKeyboard,
  faBedEmpty: faBedEmpty,
  faCircleArrowUp: faCircleArrowUp,
  faArrowCircleUp: faArrowCircleUp,
  faToggleOn: faToggleOn,
  faRectangleVertical: faRectangleVertical,
  faRectanglePortrait: faRectanglePortrait,
  faPersonWalking: faPersonWalking,
  faWalking: faWalking,
  faL: faL,
  faSignalStream: faSignalStream,
  faDownToBracket: faDownToBracket,
  faCircleZ: faCircleZ,
  faStars: faStars,
  faFire: faFire,
  faBedPulse: faBedPulse,
  faProcedures: faProcedures,
  faHouseDay: faHouseDay,
  faShuttleSpace: faShuttleSpace,
  faSpaceShuttle: faSpaceShuttle,
  faShirtLongSleeve: faShirtLongSleeve,
  faChartPieSimple: faChartPieSimple,
  faChartPieAlt: faChartPieAlt,
  faFaceLaugh: faFaceLaugh,
  faLaugh: faLaugh,
  faFolderOpen: faFolderOpen,
  faAlbumCollectionCircleUser: faAlbumCollectionCircleUser,
  faCandy: faCandy,
  faBowlHot: faBowlHot,
  faSoup: faSoup,
  faFlatbread: faFlatbread,
  faHeartCirclePlus: faHeartCirclePlus,
  faCodeFork: faCodeFork,
  faCity: faCity,
  faSignalBarsWeak: faSignalBarsWeak,
  faSignalAlt1: faSignalAlt1,
  faMicrophoneLines: faMicrophoneLines,
  faMicrophoneAlt: faMicrophoneAlt,
  faClockTwelve: faClockTwelve,
  faPepperHot: faPepperHot,
  faCitrusSlice: faCitrusSlice,
  faSheep: faSheep,
  faUnlock: faUnlock,
  faColonSign: faColonSign,
  faHeadset: faHeadset,
  faBadgerHoney: faBadgerHoney,
  faH4: faH4,
  faStoreSlash: faStoreSlash,
  faRoadCircleXmark: faRoadCircleXmark,
  faSignalSlash: faSignalSlash,
  faUserMinus: faUserMinus,
  faMarsStrokeUp: faMarsStrokeUp,
  faMarsStrokeV: faMarsStrokeV,
  faChampagneGlasses: faChampagneGlasses,
  faGlassCheers: faGlassCheers,
  faTaco: faTaco,
  faHexagonPlus: faHexagonPlus,
  faPlusHexagon: faPlusHexagon,
  faClipboard: faClipboard,
  faHouseCircleExclamation: faHouseCircleExclamation,
  faFileArrowUp: faFileArrowUp,
  faFileUpload: faFileUpload,
  faWifi: faWifi,
  faWifi3: faWifi3,
  faWifiStrong: faWifiStrong,
  faMessages: faMessages,
  faCommentsAlt: faCommentsAlt,
  faBath: faBath,
  faBathtub: faBathtub,
  faUmbrellaSimple: faUmbrellaSimple,
  faUmbrellaAlt: faUmbrellaAlt,
  faRectangleHistoryCirclePlus: faRectangleHistoryCirclePlus,
  faUnderline: faUnderline,
  faPrescriptionBottlePill: faPrescriptionBottlePill,
  faUserPen: faUserPen,
  faUserEdit: faUserEdit,
  faBinarySlash: faBinarySlash,
  faSquareO: faSquareO,
  faSignature: faSignature,
  faStroopwafel: faStroopwafel,
  faBold: faBold,
  faAnchorLock: faAnchorLock,
  faBuildingNgo: faBuildingNgo,
  faTransporter3: faTransporter3,
  faEngineWarning: faEngineWarning,
  faEngineExclamation: faEngineExclamation,
  faCircleDownRight: faCircleDownRight,
  faSquareK: faSquareK,
  faManatSign: faManatSign,
  faMoneyCheckPen: faMoneyCheckPen,
  faMoneyCheckEdit: faMoneyCheckEdit,
  faNotEqual: faNotEqual,
  faBorderTopLeft: faBorderTopLeft,
  faBorderStyle: faBorderStyle,
  faMapLocationDot: faMapLocationDot,
  faMapMarkedAlt: faMapMarkedAlt,
  faTilde: faTilde,
  faJedi: faJedi,
  faSquarePollVertical: faSquarePollVertical,
  faPoll: faPoll,
  faArrowDownSquareTriangle: faArrowDownSquareTriangle,
  faSortShapesDownAlt: faSortShapesDownAlt,
  faMugHot: faMugHot,
  faDogLeashed: faDogLeashed,
  faCarBattery: faCarBattery,
  faBatteryCar: faBatteryCar,
  faFaceDowncastSweat: faFaceDowncastSweat,
  faMailboxFlagUp: faMailboxFlagUp,
  faMemoCircleInfo: faMemoCircleInfo,
  faGift: faGift,
  faDiceTwo: faDiceTwo,
  faVolume: faVolume,
  faVolumeMedium: faVolumeMedium,
  faTransporter5: faTransporter5,
  faGaugeCircleBolt: faGaugeCircleBolt,
  faCoinFront: faCoinFront,
  faFileSlash: faFileSlash,
  faMessageArrowUpRight: faMessageArrowUpRight,
  faTreasureChest: faTreasureChest,
  faChessQueen: faChessQueen,
  faPaintbrushFine: faPaintbrushFine,
  faPaintBrushAlt: faPaintBrushAlt,
  faPaintBrushFine: faPaintBrushFine,
  faPaintbrushAlt: faPaintbrushAlt,
  faGlasses: faGlasses,
  faHoodCloak: faHoodCloak,
  faSquareQuote: faSquareQuote,
  faUpLeft: faUpLeft,
  faBringFront: faBringFront,
  faChessBoard: faChessBoard,
  faBurgerCheese: faBurgerCheese,
  faCheeseburger: faCheeseburger,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faRepeat1: faRepeat1,
  faArrowDownToLine: faArrowDownToLine,
  faArrowToBottom: faArrowToBottom,
  faGrid5: faGrid5,
  faSwapArrows: faSwapArrows,
  faRightLongToLine: faRightLongToLine,
  faPersonChalkboard: faPersonChalkboard,
  faMarsStrokeRight: faMarsStrokeRight,
  faMarsStrokeH: faMarsStrokeH,
  faHandBackFist: faHandBackFist,
  faHandRock: faHandRock,
  faGridRound5: faGridRound5,
  faTally: faTally,
  faTally5: faTally5,
  faSquareCaretUp: faSquareCaretUp,
  faCaretSquareUp: faCaretSquareUp,
  faCloudShowersWater: faCloudShowersWater,
  faChartBar: faChartBar,
  faBarChart: faBarChart,
  faHandsBubbles: faHandsBubbles,
  faHandsWash: faHandsWash,
  faLessThanEqual: faLessThanEqual,
  faTrain: faTrain,
  faUpFromDottedLine: faUpFromDottedLine,
  faEyeLowVision: faEyeLowVision,
  faLowVision: faLowVision,
  faTrafficLightGo: faTrafficLightGo,
  faFaceExhaling: faFaceExhaling,
  faSensorFire: faSensorFire,
  faUserUnlock: faUserUnlock,
  faHexagonDivide: faHexagonDivide,
  fa00: fa00,
  faCrow: faCrow,
  faCassetteBetamax: faCassetteBetamax,
  faBetamax: faBetamax,
  faSailboat: faSailboat,
  faWindowRestore: faWindowRestore,
  faNfcMagnifyingGlass: faNfcMagnifyingGlass,
  faFileBinary: faFileBinary,
  faCircleV: faCircleV,
  faSquarePlus: faSquarePlus,
  faPlusSquare: faPlusSquare,
  faBowlScoops: faBowlScoops,
  faMistletoe: faMistletoe,
  faCustard: faCustard,
  faLacrosseStick: faLacrosseStick,
  faHockeyMask: faHockeyMask,
  faSunrise: faSunrise,
  faSubtitles: faSubtitles,
  faPanelEws: faPanelEws,
  faToriiGate: faToriiGate,
  faCloudExclamation: faCloudExclamation,
  faMessageLines: faMessageLines,
  faCommentAltLines: faCommentAltLines,
  faFrog: faFrog,
  faBucket: faBucket,
  faFloppyDiskPen: faFloppyDiskPen,
  faImage: faImage,
  faWindowFrame: faWindowFrame,
  faMicrophone: faMicrophone,
  faCow: faCow,
  faFileZip: faFileZip,
  faSquareRing: faSquareRing,
  faDownFromLine: faDownFromLine,
  faArrowAltFromTop: faArrowAltFromTop,
  faCaretUp: faCaretUp,
  faShieldXmark: faShieldXmark,
  faShieldTimes: faShieldTimes,
  faScrewdriver: faScrewdriver,
  faCircleSortDown: faCircleSortDown,
  faSortCircleDown: faSortCircleDown,
  faFolderClosed: faFolderClosed,
  faHouseTsunami: faHouseTsunami,
  faSquareNfi: faSquareNfi,
  faForklift: faForklift,
  faArrowUpFromGroundWater: faArrowUpFromGroundWater,
  faBracketSquareRight: faBracketSquareRight,
  faMartiniGlass: faMartiniGlass,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faRotateLeft: faRotateLeft,
  faRotateBack: faRotateBack,
  faRotateBackward: faRotateBackward,
  faUndoAlt: faUndoAlt,
  faTableColumns: faTableColumns,
  faColumns: faColumns,
  faSquareA: faSquareA,
  faTick: faTick,
  faLemon: faLemon,
  faHeadSideMask: faHeadSideMask,
  faHandshake: faHandshake,
  faGem: faGem,
  faDolly: faDolly,
  faDollyBox: faDollyBox,
  faSmoking: faSmoking,
  faMinimize: faMinimize,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faRefrigerator: faRefrigerator,
  faMonument: faMonument,
  faOctagonXmark: faOctagonXmark,
  faTimesOctagon: faTimesOctagon,
  faXmarkOctagon: faXmarkOctagon,
  faAlignSlash: faAlignSlash,
  faSnowplow: faSnowplow,
  faAnglesRight: faAnglesRight,
  faAngleDoubleRight: faAngleDoubleRight,
  faTruckRampCouch: faTruckRampCouch,
  faTruckCouch: faTruckCouch,
  faCannabis: faCannabis,
  faCirclePlay: faCirclePlay,
  faPlayCircle: faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter: faArrowUpRightAndArrowDownLeftFromCenter,
  faTablets: faTablets,
  fa360Degrees: fa360Degrees,
  faEthernet: faEthernet,
  faEuroSign: faEuroSign,
  faEur: faEur,
  faEuro: faEuro,
  faChair: faChair,
  faCircleCheck: faCircleCheck,
  faCheckCircle: faCheckCircle,
  faSquareDashedCirclePlus: faSquareDashedCirclePlus,
  faMoneySimpleFromBracket: faMoneySimpleFromBracket,
  faBat: faBat,
  faCircleStop: faCircleStop,
  faStopCircle: faStopCircle,
  faHeadSideHeadphones: faHeadSideHeadphones,
  faPhoneRotary: faPhoneRotary,
  faCompassDrafting: faCompassDrafting,
  faDraftingCompass: faDraftingCompass,
  faPlateWheat: faPlateWheat,
  faCalendarCircleMinus: faCalendarCircleMinus,
  faChopsticks: faChopsticks,
  faCarWrench: faCarWrench,
  faCarMechanic: faCarMechanic,
  faIcicles: faIcicles,
  faPersonShelter: faPersonShelter,
  faNeuter: faNeuter,
  faIdBadge: faIdBadge,
  faKazoo: faKazoo,
  faMarker: faMarker,
  faBinBottles: faBinBottles,
  faFaceLaughBeam: faFaceLaughBeam,
  faLaughBeam: faLaughBeam,
  faSquareArrowDownLeft: faSquareArrowDownLeft,
  faBatteryBolt: faBatteryBolt,
  faTreeLarge: faTreeLarge,
  faHelicopterSymbol: faHelicopterSymbol,
  faAperture: faAperture,
  faUniversalAccess: faUniversalAccess,
  faGearComplex: faGearComplex,
  faFileMagnifyingGlass: faFileMagnifyingGlass,
  faFileSearch: faFileSearch,
  faUpRight: faUpRight,
  faCircleChevronUp: faCircleChevronUp,
  faChevronCircleUp: faChevronCircleUp,
  faUserPolice: faUserPolice,
  faLariSign: faLariSign,
  faVolcano: faVolcano,
  faTeddyBear: faTeddyBear,
  faStocking: faStocking,
  faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
  faImageSlash: faImageSlash,
  faMaskSnorkel: faMaskSnorkel,
  faSmoke: faSmoke,
  faSterlingSign: faSterlingSign,
  faGbp: faGbp,
  faPoundSign: faPoundSign,
  faBatteryExclamation: faBatteryExclamation,
  faViruses: faViruses,
  faSquarePersonConfined: faSquarePersonConfined,
  faUserTie: faUserTie,
  faArrowDownLong: faArrowDownLong,
  faLongArrowDown: faLongArrowDown,
  faTentArrowDownToLine: faTentArrowDownToLine,
  faCertificate: faCertificate,
  faCrystalBall: faCrystalBall,
  faReplyAll: faReplyAll,
  faMailReplyAll: faMailReplyAll,
  faSuitcase: faSuitcase,
  faPersonSkating: faPersonSkating,
  faSkating: faSkating,
  faStarShooting: faStarShooting,
  faBinaryLock: faBinaryLock,
  faFilterCircleDollar: faFilterCircleDollar,
  faFunnelDollar: faFunnelDollar,
  faCameraRetro: faCameraRetro,
  faCircleArrowDown: faCircleArrowDown,
  faArrowCircleDown: faArrowCircleDown,
  faCommentPen: faCommentPen,
  faCommentEdit: faCommentEdit,
  faFileImport: faFileImport,
  faArrowRightToFile: faArrowRightToFile,
  faBanjo: faBanjo,
  faSquareArrowUpRight: faSquareArrowUpRight,
  faExternalLinkSquare: faExternalLinkSquare,
  faLightEmergencyOn: faLightEmergencyOn,
  faKerning: faKerning,
  faBoxOpen: faBoxOpen,
  faSquareF: faSquareF,
  faScroll: faScroll,
  faSpa: faSpa,
  faArrowLeftFromLine: faArrowLeftFromLine,
  faArrowFromRight: faArrowFromRight,
  faStrawberry: faStrawberry,
  faLocationPinLock: faLocationPinLock,
  faPause: faPause,
  faClockEightThirty: faClockEightThirty,
  faPlaneEngines: faPlaneEngines,
  faPlaneAlt: faPlaneAlt,
  faHillAvalanche: faHillAvalanche,
  faTemperatureEmpty: faTemperatureEmpty,
  faTemperature0: faTemperature0,
  faThermometer0: faThermometer0,
  faThermometerEmpty: faThermometerEmpty,
  faBomb: faBomb,
  faGaugeLow: faGaugeLow,
  faTachometerAltSlow: faTachometerAltSlow,
  faRegistered: faRegistered,
  faTrashCanPlus: faTrashCanPlus,
  faAddressCard: faAddressCard,
  faContactCard: faContactCard,
  faVcard: faVcard,
  faScaleUnbalancedFlip: faScaleUnbalancedFlip,
  faBalanceScaleRight: faBalanceScaleRight,
  faGlobeSnow: faGlobeSnow,
  faSubscript: faSubscript,
  faDiamondTurnRight: faDiamondTurnRight,
  faDirections: faDirections,
  faIntegral: faIntegral,
  faBurst: faBurst,
  faHouseLaptop: faHouseLaptop,
  faLaptopHouse: faLaptopHouse,
  faFaceTired: faFaceTired,
  faTired: faTired,
  faMoneyBills: faMoneyBills,
  faBlindsRaised: faBlindsRaised,
  faSmog: faSmog,
  faUfoBeam: faUfoBeam,
  faCircleCaretUp: faCircleCaretUp,
  faCaretCircleUp: faCaretCircleUp,
  faUserVneckHairLong: faUserVneckHairLong,
  faSquareALock: faSquareALock,
  faCrutch: faCrutch,
  faGasPumpSlash: faGasPumpSlash,
  faFontAwesome: faFontAwesome,
  faFontAwesomeFlag: faFontAwesomeFlag,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faCloudArrowUp: faCloudArrowUp,
  faCloudUpload: faCloudUpload,
  faCloudUploadAlt: faCloudUploadAlt,
  faPalette: faPalette,
  faTransporter4: faTransporter4,
  faChartMixedUpCircleCurrency: faChartMixedUpCircleCurrency,
  faObjectsAlignRight: faObjectsAlignRight,
  faArrowsTurnRight: faArrowsTurnRight,
  faVest: faVest,
  faPig: faPig,
  faInboxFull: faInboxFull,
  faCircleEnvelope: faCircleEnvelope,
  faEnvelopeCircle: faEnvelopeCircle,
  faTrianglePersonDigging: faTrianglePersonDigging,
  faConstruction: faConstruction,
  faFerry: faFerry,
  faBullseyeArrow: faBullseyeArrow,
  faArrowsDownToPeople: faArrowsDownToPeople,
  faSeedling: faSeedling,
  faSprout: faSprout,
  faClockSeven: faClockSeven,
  faLeftRight: faLeftRight,
  faArrowsAltH: faArrowsAltH,
  faBoxesPacking: faBoxesPacking,
  faCircleArrowLeft: faCircleArrowLeft,
  faArrowCircleLeft: faArrowCircleLeft,
  faFlashlight: faFlashlight,
  faGroupArrowsRotate: faGroupArrowsRotate,
  faBowlFood: faBowlFood,
  faSquare9: faSquare9,
  faCandyCane: faCandyCane,
  faArrowDownWideShort: faArrowDownWideShort,
  faSortAmountAsc: faSortAmountAsc,
  faSortAmountDown: faSortAmountDown,
  faSquareDollar: faSquareDollar,
  faDollarSquare: faDollarSquare,
  faUsdSquare: faUsdSquare,
  faPhoneArrowRight: faPhoneArrowRight,
  faHandHoldingSeedling: faHandHoldingSeedling,
  faMessageCheck: faMessageCheck,
  faCommentAltCheck: faCommentAltCheck,
  faCloudBolt: faCloudBolt,
  faThunderstorm: faThunderstorm,
  faChartLineUpDown: faChartLineUpDown,
  faTextSlash: faTextSlash,
  faRemoveFormat: faRemoveFormat,
  faWatch: faWatch,
  faCircleDownLeft: faCircleDownLeft,
  faText: faText,
  faProjector: faProjector,
  faFaceSmileWink: faFaceSmileWink,
  faSmileWink: faSmileWink,
  faTombstoneBlank: faTombstoneBlank,
  faTombstoneAlt: faTombstoneAlt,
  faChessKingPiece: faChessKingPiece,
  faChessKingAlt: faChessKingAlt,
  faCircle6: faCircle6,
  faLeft: faLeft,
  faArrowAltLeft: faArrowAltLeft,
  faFileWord: faFileWord,
  faFilePowerpoint: faFilePowerpoint,
  faSquareDown: faSquareDown,
  faArrowAltSquareDown: faArrowAltSquareDown,
  faObjectsAlignCenterVertical: faObjectsAlignCenterVertical,
  faArrowsLeftRight: faArrowsLeftRight,
  faArrowsH: faArrowsH,
  faHouseLock: faHouseLock,
  faCloudArrowDown: faCloudArrowDown,
  faCloudDownload: faCloudDownload,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faWreath: faWreath,
  faChildren: faChildren,
  faMeterDroplet: faMeterDroplet,
  faChalkboard: faChalkboard,
  faBlackboard: faBlackboard,
  faUserLargeSlash: faUserLargeSlash,
  faUserAltSlash: faUserAltSlash,
  faSignalStrong: faSignalStrong,
  faSignal4: faSignal4,
  faLollipop: faLollipop,
  faLollypop: faLollypop,
  faListTree: faListTree,
  faEnvelopeOpen: faEnvelopeOpen,
  faDrawCircle: faDrawCircle,
  faCatSpace: faCatSpace,
  faHandshakeSimpleSlash: faHandshakeSimpleSlash,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faRabbitRunning: faRabbitRunning,
  faRabbitFast: faRabbitFast,
  faMemoPad: faMemoPad,
  faMattressPillow: faMattressPillow,
  faAlarmPlus: faAlarmPlus,
  faAlicorn: faAlicorn,
  faCommentQuestion: faCommentQuestion,
  faGingerbreadMan: faGingerbreadMan,
  faGuaraniSign: faGuaraniSign,
  faBurgerFries: faBurgerFries,
  faMugTea: faMugTea,
  faBorderTop: faBorderTop,
  faArrowsRotate: faArrowsRotate,
  faRefresh: faRefresh,
  faSync: faSync,
  faCircleBookOpen: faCircleBookOpen,
  faBookCircle: faBookCircle,
  faArrowsToDottedLine: faArrowsToDottedLine,
  faFireExtinguisher: faFireExtinguisher,
  faGarageOpen: faGarageOpen,
  faShelvesEmpty: faShelvesEmpty,
  faCruzeiroSign: faCruzeiroSign,
  faWatchApple: faWatchApple,
  faWatchCalculator: faWatchCalculator,
  faListDropdown: faListDropdown,
  faCabinetFiling: faCabinetFiling,
  faBurgerSoda: faBurgerSoda,
  faSquareArrowUp: faSquareArrowUp,
  faArrowSquareUp: faArrowSquareUp,
  faGreaterThanEqual: faGreaterThanEqual,
  faPalletBox: faPalletBox,
  faFaceConfounded: faFaceConfounded,
  faShieldHalved: faShieldHalved,
  faShieldAlt: faShieldAlt,
  faTruckPlow: faTruckPlow,
  faBookAtlas: faBookAtlas,
  faAtlas: faAtlas,
  faVirus: faVirus,
  faGridRound2: faGridRound2,
  faCommentMiddleTop: faCommentMiddleTop,
  faEnvelopeCircleCheck: faEnvelopeCircleCheck,
  faLayerGroup: faLayerGroup,
  faRestroomSimple: faRestroomSimple,
  faArrowsToDot: faArrowsToDot,
  faBorderOuter: faBorderOuter,
  faHashtagLock: faHashtagLock,
  faClockTwoThirty: faClockTwoThirty,
  faArchway: faArchway,
  faHeartCircleCheck: faHeartCircleCheck,
  faHouseChimneyCrack: faHouseChimneyCrack,
  faHouseDamage: faHouseDamage,
  faFileZipper: faFileZipper,
  faFileArchive: faFileArchive,
  faHeartHalf: faHeartHalf,
  faCommentCheck: faCommentCheck,
  faSquare: faSquare,
  faMemo: faMemo,
  faMartiniGlassEmpty: faMartiniGlassEmpty,
  faGlassMartini: faGlassMartini,
  faCouch: faCouch,
  faCediSign: faCediSign,
  faItalic: faItalic,
  faGlassCitrus: faGlassCitrus,
  faCalendarLinesPen: faCalendarLinesPen,
  faChurch: faChurch,
  faPersonSnowmobiling: faPersonSnowmobiling,
  faSnowmobile: faSnowmobile,
  faFaceHushed: faFaceHushed,
  faCommentsDollar: faCommentsDollar,
  faPickaxe: faPickaxe,
  faLinkSimpleSlash: faLinkSimpleSlash,
  faDemocrat: faDemocrat,
  faFaceConfused: faFaceConfused,
  faPinball: faPinball,
  faZ: faZ,
  faPersonSkiing: faPersonSkiing,
  faSkiing: faSkiing,
  faDeer: faDeer,
  faInputPipe: faInputPipe,
  faRoadLock: faRoadLock,
  faA: faA,
  faBookmarkSlash: faBookmarkSlash,
  faTemperatureArrowDown: faTemperatureArrowDown,
  faTemperatureDown: faTemperatureDown,
  faMace: faMace,
  faFeatherPointed: faFeatherPointed,
  faFeatherAlt: faFeatherAlt,
  faSausage: faSausage,
  faTrashCanClock: faTrashCanClock,
  faP: faP,
  faBroomWide: faBroomWide,
  faSnowflake: faSnowflake,
  faStomach: faStomach,
  faNewspaper: faNewspaper,
  faRectangleAd: faRectangleAd,
  faAd: faAd,
  faGuitarElectric: faGuitarElectric,
  faArrowTurnDownRight: faArrowTurnDownRight,
  faMoonCloud: faMoonCloud,
  faBreadSliceButter: faBreadSliceButter,
  faCircleArrowRight: faCircleArrowRight,
  faArrowCircleRight: faArrowCircleRight,
  faUserGroupCrown: faUserGroupCrown,
  faUsersCrown: faUsersCrown,
  faCircleI: faCircleI,
  faToiletPaperCheck: faToiletPaperCheck,
  faFilterCircleXmark: faFilterCircleXmark,
  faLocust: faLocust,
  faSort: faSort,
  faUnsorted: faUnsorted,
  faListOl: faListOl,
  faList12: faList12,
  faListNumeric: faListNumeric,
  faChartWaterfall: faChartWaterfall,
  faSparkle: faSparkle,
  faFaceParty: faFaceParty,
  faKidneys: faKidneys,
  faWifiExclamation: faWifiExclamation,
  faChartNetwork: faChartNetwork,
  faPersonDressBurst: faPersonDressBurst,
  faDiceD4: faDiceD4,
  faMoneyCheckDollar: faMoneyCheckDollar,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faVectorSquare: faVectorSquare,
  faBreadSlice: faBreadSlice,
  faLanguage: faLanguage,
  faWheatAwnSlash: faWheatAwnSlash,
  faFaceKissWinkHeart: faFaceKissWinkHeart,
  faKissWinkHeart: faKissWinkHeart,
  faDagger: faDagger,
  faPodium: faPodium,
  faMemoCircleCheck: faMemoCircleCheck,
  faRouteHighway: faRouteHighway,
  faDownToLine: faDownToLine,
  faArrowAltToBottom: faArrowAltToBottom,
  faFilter: faFilter,
  faSquareG: faSquareG,
  faCirclePhone: faCirclePhone,
  faPhoneCircle: faPhoneCircle,
  faClipboardPrescription: faClipboardPrescription,
  faUserNurseHair: faUserNurseHair,
  faQuestion: faQuestion,
  faFileSignature: faFileSignature,
  faToggleLargeOn: faToggleLargeOn,
  faUpDownLeftRight: faUpDownLeftRight,
  faArrowsAlt: faArrowsAlt,
  faDryerHeat: faDryerHeat,
  faDryerAlt: faDryerAlt,
  faHouseChimneyUser: faHouseChimneyUser,
  faHandHoldingHeart: faHandHoldingHeart,
  faArrowUpSmallBig: faArrowUpSmallBig,
  faSortSizeUpAlt: faSortSizeUpAlt,
  faTrainTrack: faTrainTrack,
  faPuzzlePiece: faPuzzlePiece,
  faMoneyCheck: faMoneyCheck,
  faStarHalfStroke: faStarHalfStroke,
  faStarHalfAlt: faStarHalfAlt,
  faFileExclamation: faFileExclamation,
  faCode: faCode,
  faWhiskeyGlass: faWhiskeyGlass,
  faGlassWhiskey: faGlassWhiskey,
  faMoonStars: faMoonStars,
  faBuildingCircleExclamation: faBuildingCircleExclamation,
  faClothesHanger: faClothesHanger,
  faMobileNotch: faMobileNotch,
  faMobileIphone: faMobileIphone,
  faMagnifyingGlassChart: faMagnifyingGlassChart,
  faArrowUpRightFromSquare: faArrowUpRightFromSquare,
  faExternalLink: faExternalLink,
  faCubesStacked: faCubesStacked,
  faImagesUser: faImagesUser,
  faWonSign: faWonSign,
  faKrw: faKrw,
  faWon: faWon,
  faImagePolaroidUser: faImagePolaroidUser,
  faVirusCovid: faVirusCovid,
  faSquareEllipsis: faSquareEllipsis,
  faPie: faPie,
  faChessKnightPiece: faChessKnightPiece,
  faChessKnightAlt: faChessKnightAlt,
  faAustralSign: faAustralSign,
  faCloudPlus: faCloudPlus,
  faF: faF,
  faLeaf: faLeaf,
  faBedBunk: faBedBunk,
  faRoad: faRoad,
  faTaxi: faTaxi,
  faCab: faCab,
  faPersonCirclePlus: faPersonCirclePlus,
  faChartPie: faChartPie,
  faPieChart: faPieChart,
  faBoltLightning: faBoltLightning,
  faClockEight: faClockEight,
  faSackXmark: faSackXmark,
  faFileExcel: faFileExcel,
  faFileContract: faFileContract,
  faFishFins: faFishFins,
  faCircleQ: faCircleQ,
  faBuildingFlag: faBuildingFlag,
  faFaceGrinBeam: faFaceGrinBeam,
  faGrinBeam: faGrinBeam,
  faObjectUngroup: faObjectUngroup,
  faFaceDisguise: faFaceDisguise,
  faCircleArrowDownRight: faCircleArrowDownRight,
  faAlien8bit: faAlien8bit,
  faAlienMonster: faAlienMonster,
  faHandPointRibbon: faHandPointRibbon,
  faPoop: faPoop,
  faObjectExclude: faObjectExclude,
  faTelescope: faTelescope,
  faLocationPin: faLocationPin,
  faMapMarker: faMapMarker,
  faSquareList: faSquareList,
  faKaaba: faKaaba,
  faToiletPaper: faToiletPaper,
  faHelmetSafety: faHelmetSafety,
  faHardHat: faHardHat,
  faHatHard: faHatHard,
  faCommentCode: faCommentCode,
  faSimCards: faSimCards,
  faStarship: faStarship,
  faEject: faEject,
  faCircleRight: faCircleRight,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faPlaneCircleCheck: faPlaneCircleCheck,
  faSeal: faSeal,
  faUserCowboy: faUserCowboy,
  faHexagonVerticalNft: faHexagonVerticalNft,
  faFaceRollingEyes: faFaceRollingEyes,
  faMehRollingEyes: faMehRollingEyes,
  faBreadLoaf: faBreadLoaf,
  faRingsWedding: faRingsWedding,
  faObjectGroup: faObjectGroup,
  faFrenchFries: faFrenchFries,
  faChartLine: faChartLine,
  faLineChart: faLineChart,
  faCalendarArrowDown: faCalendarArrowDown,
  faCalendarDownload: faCalendarDownload,
  faSendBack: faSendBack,
  faMaskVentilator: faMaskVentilator,
  faSignatureLock: faSignatureLock,
  faArrowRight: faArrowRight,
  faSignsPost: faSignsPost,
  faMapSigns: faMapSigns,
  faOctagonPlus: faOctagonPlus,
  faPlusOctagon: faPlusOctagon,
  faCashRegister: faCashRegister,
  faPersonCircleQuestion: faPersonCircleQuestion,
  faMelonSlice: faMelonSlice,
  faSpaceStationMoon: faSpaceStationMoon,
  faMessageSmile: faMessageSmile,
  faCommentAltSmile: faCommentAltSmile,
  faCupStraw: faCupStraw,
  faLeftFromLine: faLeftFromLine,
  faArrowAltFromRight: faArrowAltFromRight,
  faH: faH,
  faBasketShoppingSimple: faBasketShoppingSimple,
  faShoppingBasketAlt: faShoppingBasketAlt,
  faHandsHoldingHeart: faHandsHoldingHeart,
  faHandsHeart: faHandsHeart,
  faClockNine: faClockNine,
  faTarp: faTarp,
  faFaceSleepy: faFaceSleepy,
  faHandHorns: faHandHorns,
  faScrewdriverWrench: faScrewdriverWrench,
  faTools: faTools,
  faArrowsToEye: faArrowsToEye,
  faCircleThreeQuarters: faCircleThreeQuarters,
  faTrophyStar: faTrophyStar,
  faTrophyAlt: faTrophyAlt,
  faPlugCircleBolt: faPlugCircleBolt,
  faFaceThermometer: faFaceThermometer,
  faGridRound4: faGridRound4,
  faShirtRunning: faShirtRunning,
  faBookCircleArrowUp: faBookCircleArrowUp,
  faFaceNauseated: faFaceNauseated,
  faHeart: faHeart,
  faFileChartPie: faFileChartPie,
  faMarsAndVenus: faMarsAndVenus,
  faHouseUser: faHouseUser,
  faHomeUser: faHomeUser,
  faCircleArrowDownLeft: faCircleArrowDownLeft,
  faDumpsterFire: faDumpsterFire,
  faHexagonMinus: faHexagonMinus,
  faMinusHexagon: faMinusHexagon,
  faLeftToLine: faLeftToLine,
  faArrowAltToLeft: faArrowAltToLeft,
  faHouseCrack: faHouseCrack,
  faPawSimple: faPawSimple,
  faPawAlt: faPawAlt,
  faArrowLeftLongToLine: faArrowLeftLongToLine,
  faBracketsRound: faBracketsRound,
  faParentheses: faParentheses,
  faMartiniGlassCitrus: faMartiniGlassCitrus,
  faCocktail: faCocktail,
  faUserShakespeare: faUserShakespeare,
  faArrowRightToArc: faArrowRightToArc,
  faFaceSurprise: faFaceSurprise,
  faSurprise: faSurprise,
  faBottleWater: faBottleWater,
  faCirclePause: faCirclePause,
  faPauseCircle: faPauseCircle,
  faGaugeCirclePlus: faGaugeCirclePlus,
  faFolders: faFolders,
  faAngel: faAngel,
  faValueAbsolute: faValueAbsolute,
  faRabbit: faRabbit,
  faToiletPaperSlash: faToiletPaperSlash,
  faCircleEuro: faCircleEuro,
  faAppleWhole: faAppleWhole,
  faAppleAlt: faAppleAlt,
  faKitchenSet: faKitchenSet,
  faDiamondHalf: faDiamondHalf,
  faLockKeyhole: faLockKeyhole,
  faLockAlt: faLockAlt,
  faR: faR,
  faTemperatureQuarter: faTemperatureQuarter,
  faTemperature1: faTemperature1,
  faThermometer1: faThermometer1,
  faThermometerQuarter: faThermometerQuarter,
  faSquareInfo: faSquareInfo,
  faInfoSquare: faInfoSquare,
  faWifiSlash: faWifiSlash,
  faToiletPaperXmark: faToiletPaperXmark,
  faHandsHoldingDollar: faHandsHoldingDollar,
  faHandsUsd: faHandsUsd,
  faCube: faCube,
  faArrowDownTriangleSquare: faArrowDownTriangleSquare,
  faSortShapesDown: faSortShapesDown,
  faBitcoinSign: faBitcoinSign,
  faShutters: faShutters,
  faShieldDog: faShieldDog,
  faSolarPanel: faSolarPanel,
  faLockOpen: faLockOpen,
  faTableTree: faTableTree,
  faHouseChimneyHeart: faHouseChimneyHeart,
  faTally3: faTally3,
  faElevator: faElevator,
  faMoneyBillTransfer: faMoneyBillTransfer,
  faMoneyBillTrendUp: faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal: faSquarePollHorizontal,
  faPollH: faPollH,
  faCircle: faCircle,
  faCartCircleExclamation: faCartCircleExclamation,
  faSword: faSword,
  faBackwardFast: faBackwardFast,
  faFastBackward: faFastBackward,
  faRecycle: faRecycle,
  faUserAstronaut: faUserAstronaut,
  faInterrobang: faInterrobang,
  faPlaneSlash: faPlaneSlash,
  faCircleDashed: faCircleDashed,
  faTrademark: faTrademark,
  faBasketball: faBasketball,
  faBasketballBall: faBasketballBall,
  faForkKnife: faForkKnife,
  faUtensilsAlt: faUtensilsAlt,
  faSatelliteDish: faSatelliteDish,
  faBadgeCheck: faBadgeCheck,
  faCircleUp: faCircleUp,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faSlider: faSlider,
  faMobileScreenButton: faMobileScreenButton,
  faMobileAlt: faMobileAlt,
  faClockOneThirty: faClockOneThirty,
  faInboxOut: faInboxOut,
  faInboxArrowUp: faInboxArrowUp,
  faCloudSlash: faCloudSlash,
  faVolumeHigh: faVolumeHigh,
  faVolumeUp: faVolumeUp,
  faUsersRays: faUsersRays,
  faWallet: faWallet,
  faOctagonCheck: faOctagonCheck,
  faFlatbreadStuffed: faFlatbreadStuffed,
  faClipboardCheck: faClipboardCheck,
  faCartCirclePlus: faCartCirclePlus,
  faTruckClock: faTruckClock,
  faShippingTimed: faShippingTimed,
  faPool8Ball: faPool8Ball,
  faFileAudio: faFileAudio,
  faTurnDownLeft: faTurnDownLeft,
  faLockHashtag: faLockHashtag,
  faChartRadar: faChartRadar,
  faStaff: faStaff,
  faBurger: faBurger,
  faHamburger: faHamburger,
  faUtilityPole: faUtilityPole,
  faTransporter6: faTransporter6,
  faWrench: faWrench,
  faBugs: faBugs,
  faVectorPolygon: faVectorPolygon,
  faDiagramNested: faDiagramNested,
  faRupeeSign: faRupeeSign,
  faRupee: faRupee,
  faFileImage: faFileImage,
  faCircleQuestion: faCircleQuestion,
  faQuestionCircle: faQuestionCircle,
  faImageUser: faImageUser,
  faBuoy: faBuoy,
  faPlaneDeparture: faPlaneDeparture,
  faHandshakeSlash: faHandshakeSlash,
  faBookBookmark: faBookBookmark,
  faBorderCenterH: faBorderCenterH,
  faCanFood: faCanFood,
  faTypewriter: faTypewriter,
  faArrowRightFromArc: faArrowRightFromArc,
  faCircleK: faCircleK,
  faFaceHandOverMouth: faFaceHandOverMouth,
  faPopcorn: faPopcorn,
  faHouseWater: faHouseWater,
  faHouseFlood: faHouseFlood,
  faObjectSubtract: faObjectSubtract,
  faCodeBranch: faCodeBranch,
  faWarehouseFull: faWarehouseFull,
  faWarehouseAlt: faWarehouseAlt,
  faHatCowboy: faHatCowboy,
  faBridge: faBridge,
  faPhoneFlip: faPhoneFlip,
  faPhoneAlt: faPhoneAlt,
  faArrowDownFromDottedLine: faArrowDownFromDottedLine,
  faFileDoc: faFileDoc,
  faSquareQuarters: faSquareQuarters,
  faTruckFront: faTruckFront,
  faCat: faCat,
  faTrashXmark: faTrashXmark,
  faCircleCaretLeft: faCircleCaretLeft,
  faCaretCircleLeft: faCaretCircleLeft,
  faFiles: faFiles,
  faAnchorCircleExclamation: faAnchorCircleExclamation,
  faFaceClouds: faFaceClouds,
  faUserCrown: faUserCrown,
  faTruckField: faTruckField,
  faRoute: faRoute,
  faCartCircleCheck: faCartCircleCheck,
  faClipboardQuestion: faClipboardQuestion,
  faPanorama: faPanorama,
  faCommentMedical: faCommentMedical,
  faTeethOpen: faTeethOpen,
  faUserTieHairLong: faUserTieHairLong,
  faFileCircleMinus: faFileCircleMinus,
  faHeadSideMedical: faHeadSideMedical,
  faTags: faTags,
  faWineGlass: faWineGlass,
  faForwardFast: faForwardFast,
  faFastForward: faFastForward,
  faFaceMehBlank: faFaceMehBlank,
  faMehBlank: faMehBlank,
  faUserRobot: faUserRobot,
  faSquareParking: faSquareParking,
  faParking: faParking,
  faCardDiamond: faCardDiamond,
  faFaceZipper: faFaceZipper,
  faFaceRaisedEyebrow: faFaceRaisedEyebrow,
  faHouseSignal: faHouseSignal,
  faSquareChevronUp: faSquareChevronUp,
  faChevronSquareUp: faChevronSquareUp,
  faNfcSymbol: faNfcSymbol,
  faBarsProgress: faBarsProgress,
  faTasksAlt: faTasksAlt,
  faFaucetDrip: faFaucetDrip,
  faArrowsToLine: faArrowsToLine,
  faDolphin: faDolphin,
  faArrowUpRight: faArrowUpRight,
  faCircleR: faCircleR,
  faCartFlatbed: faCartFlatbed,
  faDollyFlatbed: faDollyFlatbed,
  faBanSmoking: faBanSmoking,
  faSmokingBan: faSmokingBan,
  faCircleSortUp: faCircleSortUp,
  faSortCircleUp: faSortCircleUp,
  faTerminal: faTerminal,
  faMobileButton: faMobileButton,
  faHouseMedicalFlag: faHouseMedicalFlag,
  faBasketShopping: faBasketShopping,
  faShoppingBasket: faShoppingBasket,
  faTape: faTape,
  faChestnut: faChestnut,
  faBusSimple: faBusSimple,
  faBusAlt: faBusAlt,
  faEye: faEye,
  faFaceSadCry: faFaceSadCry,
  faSadCry: faSadCry,
  faHeat: faHeat,
  faTicketAirline: faTicketAirline,
  faBootHeeled: faBootHeeled,
  faArrowsMinimize: faArrowsMinimize,
  faCompressArrows: faCompressArrows,
  faAudioDescription: faAudioDescription,
  faPersonMilitaryToPerson: faPersonMilitaryToPerson,
  faFileShield: faFileShield,
  faHexagon: faHexagon,
  faManhole: faManhole,
  faUserSlash: faUserSlash,
  faPen: faPen,
  faTowerObservation: faTowerObservation,
  faFloppyDisks: faFloppyDisks,
  faToiletPaperBlankUnder: faToiletPaperBlankUnder,
  faToiletPaperReverseAlt: faToiletPaperReverseAlt,
  faFileCode: faFileCode,
  faSignal: faSignal,
  faSignal5: faSignal5,
  faSignalPerfect: faSignalPerfect,
  faPump: faPump,
  faBus: faBus,
  faHeartCircleXmark: faHeartCircleXmark,
  faArrowUpLeftFromCircle: faArrowUpLeftFromCircle,
  faHouseChimney: faHouseChimney,
  faHomeLg: faHomeLg,
  faWindowMaximize: faWindowMaximize,
  faDryer: faDryer,
  faFaceFrown: faFaceFrown,
  faFrown: faFrown,
  faChessBishopPiece: faChessBishopPiece,
  faChessBishopAlt: faChessBishopAlt,
  faShirtTankTop: faShirtTankTop,
  faDiploma: faDiploma,
  faScrollRibbon: faScrollRibbon,
  faScreencast: faScreencast,
  faWalker: faWalker,
  faPrescription: faPrescription,
  faShop: faShop,
  faStoreAlt: faStoreAlt,
  faFloppyDisk: faFloppyDisk,
  faSave: faSave,
  faVihara: faVihara,
  faFaceKissClosedEyes: faFaceKissClosedEyes,
  faScaleUnbalanced: faScaleUnbalanced,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faFileUser: faFileUser,
  faUserPoliceTie: faUserPoliceTie,
  faFaceTongueMoney: faFaceTongueMoney,
  faTennisBall: faTennisBall,
  faSquareL: faSquareL,
  faSortUp: faSortUp,
  faSortAsc: faSortAsc,
  faCalendarArrowUp: faCalendarArrowUp,
  faCalendarUpload: faCalendarUpload,
  faCommentDots: faCommentDots,
  faCommenting: faCommenting,
  faPlantWilt: faPlantWilt,
  faScarf: faScarf,
  faAlbumCirclePlus: faAlbumCirclePlus,
  faUserNurseHairLong: faUserNurseHairLong,
  faDiamond: faDiamond,
  faSquareLeft: faSquareLeft,
  faArrowAltSquareLeft: faArrowAltSquareLeft,
  faFaceGrinSquint: faFaceGrinSquint,
  faGrinSquint: faGrinSquint,
  faCircleEllipsisVertical: faCircleEllipsisVertical,
  faHandHoldingDollar: faHandHoldingDollar,
  faHandHoldingUsd: faHandHoldingUsd,
  faGridDividers: faGridDividers,
  faBacterium: faBacterium,
  faHandPointer: faHandPointer,
  faDrumSteelpan: faDrumSteelpan,
  faHandScissors: faHandScissors,
  faHandsPraying: faHandsPraying,
  faPrayingHands: faPrayingHands,
  faFacePensive: faFacePensive,
  faUserMusic: faUserMusic,
  faArrowRotateRight: faArrowRotateRight,
  faArrowRightRotate: faArrowRightRotate,
  faArrowRotateForward: faArrowRotateForward,
  faRedo: faRedo,
  faMessagesDollar: faMessagesDollar,
  faCommentsAltDollar: faCommentsAltDollar,
  faSensorOn: faSensorOn,
  faBalloon: faBalloon,
  faBiohazard: faBiohazard,
  faChessQueenPiece: faChessQueenPiece,
  faChessQueenAlt: faChessQueenAlt,
  faLocationCrosshairs: faLocationCrosshairs,
  faLocation: faLocation,
  faMarsDouble: faMarsDouble,
  faHousePersonLeave: faHousePersonLeave,
  faHouseLeave: faHouseLeave,
  faHousePersonDepart: faHousePersonDepart,
  faRulerTriangle: faRulerTriangle,
  faCardClub: faCardClub,
  faChildDress: faChildDress,
  faUsersBetweenLines: faUsersBetweenLines,
  faLungsVirus: faLungsVirus,
  faSpinnerThird: faSpinnerThird,
  faFaceGrinTears: faFaceGrinTears,
  faGrinTears: faGrinTears,
  faPhone: faPhone,
  faComputerMouseScrollwheel: faComputerMouseScrollwheel,
  faMouseAlt: faMouseAlt,
  faCalendarXmark: faCalendarXmark,
  faCalendarTimes: faCalendarTimes,
  faChildReaching: faChildReaching,
  faTableLayout: faTableLayout,
  faNarwhal: faNarwhal,
  faRampLoading: faRampLoading,
  faCalendarCirclePlus: faCalendarCirclePlus,
  faToothbrush: faToothbrush,
  faBorderInner: faBorderInner,
  faPawClaws: faPawClaws,
  faKiwiFruit: faKiwiFruit,
  faTrafficLightSlow: faTrafficLightSlow,
  faRectangleCode: faRectangleCode,
  faHeadSideVirus: faHeadSideVirus,
  faKeyboardBrightness: faKeyboardBrightness,
  faBooksMedical: faBooksMedical,
  faLightbulbSlash: faLightbulbSlash,
  faHouseBlank: faHouseBlank,
  faHomeBlank: faHomeBlank,
  faSquare5: faSquare5,
  faSquareHeart: faSquareHeart,
  faHeartSquare: faHeartSquare,
  faPuzzle: faPuzzle,
  faUserGear: faUserGear,
  faUserCog: faUserCog,
  faPipeCircleCheck: faPipeCircleCheck,
  faArrowUp19: faArrowUp19,
  faSortNumericUp: faSortNumericUp,
  faOctagonExclamation: faOctagonExclamation,
  faDialLow: faDialLow,
  faDoorClosed: faDoorClosed,
  faLaptopMobile: faLaptopMobile,
  faPhoneLaptop: faPhoneLaptop,
  faConveyorBeltBoxes: faConveyorBeltBoxes,
  faConveyorBeltAlt: faConveyorBeltAlt,
  faShieldVirus: faShieldVirus,
  faStarfighterTwinIonEngineAdvanced: faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced: faStarfighterAltAdvanced,
  faDiceSix: faDiceSix,
  faStarfighterTwinIonEngine: faStarfighterTwinIonEngine,
  faStarfighterAlt: faStarfighterAlt,
  faRocketLaunch: faRocketLaunch,
  faMosquitoNet: faMosquitoNet,
  faVentDamper: faVentDamper,
  faBridgeWater: faBridgeWater,
  faBanBug: faBanBug,
  faDebug: faDebug,
  faPersonBooth: faPersonBooth,
  faTextWidth: faTextWidth,
  faGarageCar: faGarageCar,
  faSquareKanban: faSquareKanban,
  faHatWizard: faHatWizard,
  faPenFancy: faPenFancy,
  faCoffeePot: faCoffeePot,
  faMouseField: faMouseField,
  faPersonDigging: faPersonDigging,
  faDigging: faDigging,
  faShowerDown: faShowerDown,
  faShowerAlt: faShowerAlt,
  faBoxCircleCheck: faBoxCircleCheck,
  faBrightness: faBrightness,
  faCarSideBolt: faCarSideBolt,
  faOrnament: faOrnament,
  faPhoneArrowDownLeft: faPhoneArrowDownLeft,
  faPhoneArrowDown: faPhoneArrowDown,
  faPhoneIncoming: faPhoneIncoming,
  faCloudWord: faCloudWord,
  faHandFingersCrossed: faHandFingersCrossed,
  faTrash: faTrash,
  faGaugeSimple: faGaugeSimple,
  faGaugeSimpleMed: faGaugeSimpleMed,
  faTachometerAverage: faTachometerAverage,
  faArrowDownSmallBig: faArrowDownSmallBig,
  faSortSizeDownAlt: faSortSizeDownAlt,
  faBookMedical: faBookMedical,
  faFaceMelting: faFaceMelting,
  faPoo: faPoo,
  faPenClipSlash: faPenClipSlash,
  faPenAltSlash: faPenAltSlash,
  faQuoteRight: faQuoteRight,
  faQuoteRightAlt: faQuoteRightAlt,
  faScrollOld: faScrollOld,
  faGuitars: faGuitars,
  faPhoneXmark: faPhoneXmark,
  faHose: faHose,
  faClockSix: faClockSix,
  faShirt: faShirt,
  faTShirt: faTShirt,
  faTshirt: faTshirt,
  faBillboard: faBillboard,
  faSquareR: faSquareR,
  faCubes: faCubes,
  faEnvelopeOpenDollar: faEnvelopeOpenDollar,
  faDivide: faDivide,
  faSunCloud: faSunCloud,
  faLampFloor: faLampFloor,
  faSquare7: faSquare7,
  faTengeSign: faTengeSign,
  faTenge: faTenge,
  faHeadphones: faHeadphones,
  faHandsHolding: faHandsHolding,
  faCampfire: faCampfire,
  faCircleAmpersand: faCircleAmpersand,
  faSnowflakes: faSnowflakes,
  faHandsClapping: faHandsClapping,
  faRepublican: faRepublican,
  faLeafMaple: faLeafMaple,
  faArrowLeft: faArrowLeft,
  faPersonCircleXmark: faPersonCircleXmark,
  faRuler: faRuler,
  faCupStrawSwoosh: faCupStrawSwoosh,
  faTemperatureSun: faTemperatureSun,
  faTemperatureHot: faTemperatureHot,
  faAlignLeft: faAlignLeft,
  faDiceD6: faDiceD6,
  faRestroom: faRestroom,
  faHighDefinition: faHighDefinition,
  faRectangleHd: faRectangleHd,
  faJ: faJ,
  faGalaxy: faGalaxy,
  faUsersViewfinder: faUsersViewfinder,
  faFileVideo: faFileVideo,
  faCherries: faCherries,
  faUpRightFromSquare: faUpRightFromSquare,
  faExternalLinkAlt: faExternalLinkAlt,
  faCircleSort: faCircleSort,
  faSortCircle: faSortCircle,
  faTableCells: faTableCells,
  faTh: faTh,
  faFilePdf: faFilePdf,
  faSiren: faSiren,
  faArrowUpToDottedLine: faArrowUpToDottedLine,
  faImageLandscape: faImageLandscape,
  faLandscape: faLandscape,
  faTankWater: faTankWater,
  faCurlingStone: faCurlingStone,
  faCurling: faCurling,
  faGamepadModern: faGamepadModern,
  faGamepadAlt: faGamepadAlt,
  faMessagesQuestion: faMessagesQuestion,
  faBookBible: faBookBible,
  faBible: faBible,
  faO: faO,
  faSuitcaseMedical: faSuitcaseMedical,
  faMedkit: faMedkit,
  faBriefcaseArrowRight: faBriefcaseArrowRight,
  faExpandWide: faExpandWide,
  faClockElevenThirty: faClockElevenThirty,
  faRv: faRv,
  faUserSecret: faUserSecret,
  faOtter: faOtter,
  faDreidel: faDreidel,
  faPersonDress: faPersonDress,
  faFemale: faFemale,
  faCommentDollar: faCommentDollar,
  faBusinessTime: faBusinessTime,
  faBriefcaseClock: faBriefcaseClock,
  faFlowerTulip: faFlowerTulip,
  faPeoplePantsSimple: faPeoplePantsSimple,
  faCloudDrizzle: faCloudDrizzle,
  faTableCellsLarge: faTableCellsLarge,
  faThLarge: faThLarge,
  faBookTanakh: faBookTanakh,
  faTanakh: faTanakh,
  faSolarSystem: faSolarSystem,
  faSealQuestion: faSealQuestion,
  faPhoneVolume: faPhoneVolume,
  faVolumeControlPhone: faVolumeControlPhone,
  faDiscDrive: faDiscDrive,
  faHatCowboySide: faHatCowboySide,
  faTableRows: faTableRows,
  faRows: faRows,
  faLocationExclamation: faLocationExclamation,
  faMapMarkerExclamation: faMapMarkerExclamation,
  faFaceFearful: faFaceFearful,
  faClipboardUser: faClipboardUser,
  faBusSchool: faBusSchool,
  faFilmSlash: faFilmSlash,
  faSquareArrowDownRight: faSquareArrowDownRight,
  faBookSparkles: faBookSparkles,
  faBookSpells: faBookSpells,
  faWashingMachine: faWashingMachine,
  faWasher: faWasher,
  faChild: faChild,
  faLiraSign: faLiraSign,
  faUserVisor: faUserVisor,
  faFilePlusMinus: faFilePlusMinus,
  faChessClockFlip: faChessClockFlip,
  faChessClockAlt: faChessClockAlt,
  faSatellite: faSatellite,
  faPlaneLock: faPlaneLock,
  faSteeringWheel: faSteeringWheel,
  faTag: faTag,
  faStretcher: faStretcher,
  faBookSection: faBookSection,
  faBookLaw: faBookLaw,
  faInboxes: faInboxes,
  faCoffeeBean: faCoffeeBean,
  faCircleYen: faCircleYen,
  faBracketsCurly: faBracketsCurly,
  faEllipsisStrokeVertical: faEllipsisStrokeVertical,
  faEllipsisVAlt: faEllipsisVAlt,
  faComment: faComment,
  faSquare1: faSquare1,
  faCakeCandles: faCakeCandles,
  faBirthdayCake: faBirthdayCake,
  faCake: faCake,
  faHeadSide: faHeadSide,
  faEnvelope: faEnvelope,
  faDollyEmpty: faDollyEmpty,
  faFaceTissue: faFaceTissue,
  faAnglesUp: faAnglesUp,
  faAngleDoubleUp: faAngleDoubleUp,
  faBinRecycle: faBinRecycle,
  faPaperclip: faPaperclip,
  faChartLineDown: faChartLineDown,
  faArrowRightToCity: faArrowRightToCity,
  faLockA: faLockA,
  faRibbon: faRibbon,
  faLungs: faLungs,
  faPersonPinball: faPersonPinball,
  faArrowUp91: faArrowUp91,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faAppleCore: faAppleCore,
  faCircleY: faCircleY,
  faH6: faH6,
  faLitecoinSign: faLitecoinSign,
  faCircleSmall: faCircleSmall,
  faBorderNone: faBorderNone,
  faArrowTurnDownLeft: faArrowTurnDownLeft,
  faCircleNodes: faCircleNodes,
  faParachuteBox: faParachuteBox,
  faMessageMedical: faMessageMedical,
  faCommentAltMedical: faCommentAltMedical,
  faRugbyBall: faRugbyBall,
  faCommentMusic: faCommentMusic,
  faIndent: faIndent,
  faTreeDeciduous: faTreeDeciduous,
  faTreeAlt: faTreeAlt,
  faPuzzlePieceSimple: faPuzzlePieceSimple,
  faPuzzlePieceAlt: faPuzzlePieceAlt,
  faTruckFieldUn: faTruckFieldUn,
  faNfcTrash: faNfcTrash,
  faHourglass: faHourglass,
  faHourglassEmpty: faHourglassEmpty,
  faMountain: faMountain,
  faFileXmark: faFileXmark,
  faFileTimes: faFileTimes,
  faHouseHeart: faHouseHeart,
  faHomeHeart: faHomeHeart,
  faHouseChimneyBlank: faHouseChimneyBlank,
  faMeterBolt: faMeterBolt,
  faUserDoctor: faUserDoctor,
  faUserMd: faUserMd,
  faSlashBack: faSlashBack,
  faCircleInfo: faCircleInfo,
  faInfoCircle: faInfoCircle,
  faFishingRod: faFishingRod,
  faHammerCrash: faHammerCrash,
  faMessageHeart: faMessageHeart,
  faCloudMeatball: faCloudMeatball,
  faCameraPolaroid: faCameraPolaroid,
  faCamera: faCamera,
  faCameraAlt: faCameraAlt,
  faSquareVirus: faSquareVirus,
  faCartArrowUp: faCartArrowUp,
  faMeteor: faMeteor,
  faCarOn: faCarOn,
  faSleigh: faSleigh,
  faArrowDown19: faArrowDown19,
  faSortNumericAsc: faSortNumericAsc,
  faSortNumericDown: faSortNumericDown,
  faBuoyMooring: faBuoyMooring,
  faSquare4: faSquare4,
  faHandHoldingDroplet: faHandHoldingDroplet,
  faHandHoldingWater: faHandHoldingWater,
  faTricycleAdult: faTricycleAdult,
  faWaveform: faWaveform,
  faWater: faWater,
  faStarSharpHalfStroke: faStarSharpHalfStroke,
  faStarSharpHalfAlt: faStarSharpHalfAlt,
  faNfcSignal: faNfcSignal,
  faPlaneProp: faPlaneProp,
  faCalendarCheck: faCalendarCheck,
  faClockDesk: faClockDesk,
  faCalendarClock: faCalendarClock,
  faCalendarTime: faCalendarTime,
  faBraille: faBraille,
  faPrescriptionBottleMedical: faPrescriptionBottleMedical,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPlateUtensils: faPlateUtensils,
  faFamilyPants: faFamilyPants,
  faHoseReel: faHoseReel,
  faHouseWindow: faHouseWindow,
  faLandmark: faLandmark,
  faTruck: faTruck,
  faCrosshairs: faCrosshairs,
  faCloudRainbow: faCloudRainbow,
  faPersonCane: faPersonCane,
  faAlien: faAlien,
  faTent: faTent,
  faLaptopBinary: faLaptopBinary,
  faVestPatches: faVestPatches,
  faPeopleDressSimple: faPeopleDressSimple,
  faCheckDouble: faCheckDouble,
  faArrowDownAZ: faArrowDownAZ,
  faSortAlphaAsc: faSortAlphaAsc,
  faSortAlphaDown: faSortAlphaDown,
  faBowlingBallPin: faBowlingBallPin,
  faBellSchoolSlash: faBellSchoolSlash,
  faPlusLarge: faPlusLarge,
  faMoneyBillWheat: faMoneyBillWheat,
  faCameraViewfinder: faCameraViewfinder,
  faScreenshot: faScreenshot,
  faMessageMusic: faMessageMusic,
  faCommentAltMusic: faCommentAltMusic,
  faCarBuilding: faCarBuilding,
  faBorderBottomRight: faBorderBottomRight,
  faBorderStyleAlt: faBorderStyleAlt,
  faOctagon: faOctagon,
  faCommentArrowUpRight: faCommentArrowUpRight,
  faOctagonDivide: faOctagonDivide,
  faCookie: faCookie,
  faArrowRotateLeft: faArrowRotateLeft,
  faArrowLeftRotate: faArrowLeftRotate,
  faArrowRotateBack: faArrowRotateBack,
  faArrowRotateBackward: faArrowRotateBackward,
  faUndo: faUndo,
  faTvMusic: faTvMusic,
  faHardDrive: faHardDrive,
  faHdd: faHdd,
  faReel: faReel,
  faFaceGrinSquintTears: faFaceGrinSquintTears,
  faGrinSquintTears: faGrinSquintTears,
  faDumbbell: faDumbbell,
  faRectangleList: faRectangleList,
  faListAlt: faListAlt,
  faTarpDroplet: faTarpDroplet,
  faAlarmExclamation: faAlarmExclamation,
  faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
  faTrafficCone: faTrafficCone,
  faGrate: faGrate,
  faArrowDownRight: faArrowDownRight,
  faPersonSkiingNordic: faPersonSkiingNordic,
  faSkiingNordic: faSkiingNordic,
  faCalendarPlus: faCalendarPlus,
  faPersonFromPortal: faPersonFromPortal,
  faPortalExit: faPortalExit,
  faPlaneArrival: faPlaneArrival,
  faCowbellCirclePlus: faCowbellCirclePlus,
  faCowbellMore: faCowbellMore,
  faCircleLeft: faCircleLeft,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faDistributeSpacingVertical: faDistributeSpacingVertical,
  faSignalBarsFair: faSignalBarsFair,
  faSignalAlt2: faSignalAlt2,
  faSportsball: faSportsball,
  faGameConsoleHandheldCrank: faGameConsoleHandheldCrank,
  faTrainSubway: faTrainSubway,
  faSubway: faSubway,
  faChartGantt: faChartGantt,
  faFaceSmileUpsideDown: faFaceSmileUpsideDown,
  faBallPile: faBallPile,
  faBadgeDollar: faBadgeDollar,
  faMoneyBillsSimple: faMoneyBillsSimple,
  faMoneyBillsAlt: faMoneyBillsAlt,
  faListTimeline: faListTimeline,
  faIndianRupeeSign: faIndianRupeeSign,
  faIndianRupee: faIndianRupee,
  faInr: faInr,
  faCropSimple: faCropSimple,
  faCropAlt: faCropAlt,
  faMoneyBill1: faMoneyBill1,
  faMoneyBillAlt: faMoneyBillAlt,
  faLeftLong: faLeftLong,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faKeyboardDown: faKeyboardDown,
  faCircleUpRight: faCircleUpRight,
  faCloudBoltMoon: faCloudBoltMoon,
  faThunderstormMoon: faThunderstormMoon,
  faDna: faDna,
  faVirusSlash: faVirusSlash,
  faBracketRoundRight: faBracketRoundRight,
  faCircleSterling: faCircleSterling,
  faCircle5: faCircle5,
  faMinus: faMinus,
  faSubtract: faSubtract,
  faFireFlame: faFireFlame,
  faFlame: faFlame,
  faRightToLine: faRightToLine,
  faArrowAltToRight: faArrowAltToRight,
  faGif: faGif,
  faChess: faChess,
  faTrashSlash: faTrashSlash,
  faArrowLeftLong: faArrowLeftLong,
  faLongArrowLeft: faLongArrowLeft,
  faPlugCircleCheck: faPlugCircleCheck,
  faFontCase: faFontCase,
  faStreetView: faStreetView,
  faArrowDownLeft: faArrowDownLeft,
  faFrancSign: faFrancSign,
  faFlaskRoundPoison: faFlaskRoundPoison,
  faFlaskPoison: faFlaskPoison,
  faVolumeOff: faVolumeOff,
  faBookCircleArrowRight: faBookCircleArrowRight,
  faChartUser: faChartUser,
  faUserChart: faUserChart,
  faHandsAslInterpreting: faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAslInterpreting: faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen: faPresentationScreen,
  faPresentation: faPresentation,
  faCircleBolt: faCircleBolt,
  faFaceSmileHalo: faFaceSmileHalo,
  faCartCircleArrowDown: faCartCircleArrowDown,
  faHousePersonReturn: faHousePersonReturn,
  faHousePersonArrive: faHousePersonArrive,
  faHouseReturn: faHouseReturn,
  faMessageXmark: faMessageXmark,
  faCommentAltTimes: faCommentAltTimes,
  faMessageTimes: faMessageTimes,
  faFileCertificate: faFileCertificate,
  faFileAward: faFileAward,
  faUserDoctorHairLong: faUserDoctorHairLong,
  faCameraSecurity: faCameraSecurity,
  faCameraHome: faCameraHome,
  faGear: faGear,
  faCog: faCog,
  faDropletSlash: faDropletSlash,
  faTintSlash: faTintSlash,
  faBookHeart: faBookHeart,
  faMosque: faMosque,
  faDuck: faDuck,
  faMosquito: faMosquito,
  faStarOfDavid: faStarOfDavid,
  faFlagSwallowtail: faFlagSwallowtail,
  faFlagAlt: faFlagAlt,
  faPersonMilitaryRifle: faPersonMilitaryRifle,
  faCarGarage: faCarGarage,
  faCartShopping: faCartShopping,
  faShoppingCart: faShoppingCart,
  faBookFont: faBookFont,
  faShieldPlus: faShieldPlus,
  faVials: faVials,
  faEyeDropperFull: faEyeDropperFull,
  faDistributeSpacingHorizontal: faDistributeSpacingHorizontal,
  faTabletRugged: faTabletRugged,
  faTemperatureSnow: faTemperatureSnow,
  faTemperatureFrigid: faTemperatureFrigid,
  faMoped: faMoped,
  faFaceSmilePlus: faFaceSmilePlus,
  faSmilePlus: faSmilePlus,
  faRadioTuner: faRadioTuner,
  faRadioAlt: faRadioAlt,
  faFaceSwear: faFaceSwear,
  faWaterArrowDown: faWaterArrowDown,
  faWaterLower: faWaterLower,
  faScannerTouchscreen: faScannerTouchscreen,
  faCircle7: faCircle7,
  faPlugCirclePlus: faPlugCirclePlus,
  faPersonSkiJumping: faPersonSkiJumping,
  faSkiJump: faSkiJump,
  faPlaceOfWorship: faPlaceOfWorship,
  faWaterArrowUp: faWaterArrowUp,
  faWaterRise: faWaterRise,
  faWaveformLines: faWaveformLines,
  faWaveformPath: faWaveformPath,
  faSplit: faSplit,
  faFilmCanister: faFilmCanister,
  faFilmCannister: faFilmCannister,
  faFolderXmark: faFolderXmark,
  faFolderTimes: faFolderTimes,
  faToiletPaperBlank: faToiletPaperBlank,
  faToiletPaperAlt: faToiletPaperAlt,
  faTabletScreen: faTabletScreen,
  faTabletAndroidAlt: faTabletAndroidAlt,
  faHexagonVerticalNftSlanted: faHexagonVerticalNftSlanted,
  faFolderMusic: faFolderMusic,
  faDisplayMedical: faDisplayMedical,
  faDesktopMedical: faDesktopMedical,
  faShareAll: faShareAll,
  faPeapod: faPeapod,
  faChessClock: faChessClock,
  faAxe: faAxe,
  faSquareD: faSquareD,
  faGripVertical: faGripVertical,
  faMobileSignalOut: faMobileSignalOut,
  faArrowTurnUp: faArrowTurnUp,
  faLevelUp: faLevelUp,
  faU: faU,
  faArrowUpFromDottedLine: faArrowUpFromDottedLine,
  faSquareRootVariable: faSquareRootVariable,
  faSquareRootAlt: faSquareRootAlt,
  faLightSwitchOn: faLightSwitchOn,
  faArrowDownArrowUp: faArrowDownArrowUp,
  faSortAlt: faSortAlt,
  faRaindrops: faRaindrops,
  faDash: faDash,
  faMinusLarge: faMinusLarge,
  faClock: faClock,
  faClockFour: faClockFour,
  faInputNumeric: faInputNumeric,
  faTruckTow: faTruckTow,
  faBackwardStep: faBackwardStep,
  faStepBackward: faStepBackward,
  faPallet: faPallet,
  faCarBolt: faCarBolt,
  faArrowsMaximize: faArrowsMaximize,
  faExpandArrows: faExpandArrows,
  faFaucet: faFaucet,
  faCloudSleet: faCloudSleet,
  faLampStreet: faLampStreet,
  faListRadio: faListRadio,
  faPenNibSlash: faPenNibSlash,
  faBaseballBatBall: faBaseballBatBall,
  faSquareUpLeft: faSquareUpLeft,
  faOverline: faOverline,
  faS: faS,
  faTimeline: faTimeline,
  faKeyboard: faKeyboard,
  faArrowsFromDottedLine: faArrowsFromDottedLine,
  faUsbDrive: faUsbDrive,
  faBallot: faBallot,
  faCaretDown: faCaretDown,
  faLocationDotSlash: faLocationDotSlash,
  faMapMarkerAltSlash: faMapMarkerAltSlash,
  faCards: faCards,
  faHouseChimneyMedical: faHouseChimneyMedical,
  faClinicMedical: faClinicMedical,
  faBoxingGlove: faBoxingGlove,
  faGloveBoxing: faGloveBoxing,
  faTemperatureThreeQuarters: faTemperatureThreeQuarters,
  faTemperature3: faTemperature3,
  faThermometer3: faThermometer3,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faBellSchool: faBellSchool,
  faMobileScreen: faMobileScreen,
  faMobileAndroidAlt: faMobileAndroidAlt,
  faPlaneUp: faPlaneUp,
  faFolderHeart: faFolderHeart,
  faCircleLocationArrow: faCircleLocationArrow,
  faLocationCircle: faLocationCircle,
  faFaceHeadBandage: faFaceHeadBandage,
  faSushiRoll: faSushiRoll,
  faMakiRoll: faMakiRoll,
  faMakizushi: faMakizushi,
  faCarBump: faCarBump,
  faPiggyBank: faPiggyBank,
  faRacquet: faRacquet,
  faCarMirrors: faCarMirrors,
  faIndustryWindows: faIndustryWindows,
  faIndustryAlt: faIndustryAlt,
  faBoltAuto: faBoltAuto,
  faBatteryHalf: faBatteryHalf,
  faBattery3: faBattery3,
  faFluxCapacitor: faFluxCapacitor,
  faMountainCity: faMountainCity,
  faCoins: faCoins,
  faHoneyPot: faHoneyPot,
  faOlive: faOlive,
  faKhanda: faKhanda,
  faFilterList: faFilterList,
  faOutlet: faOutlet,
  faSliders: faSliders,
  faSlidersH: faSlidersH,
  faCauldron: faCauldron,
  faPeople: faPeople,
  faFolderTree: faFolderTree,
  faNetworkWired: faNetworkWired,
  faCroissant: faCroissant,
  faMapPin: faMapPin,
  faHamsa: faHamsa,
  faCentSign: faCentSign,
  faSwordsLaser: faSwordsLaser,
  faFlask: faFlask,
  faPersonPregnant: faPersonPregnant,
  faSquareU: faSquareU,
  faWandSparkles: faWandSparkles,
  faRouter: faRouter,
  faEllipsisVertical: faEllipsisVertical,
  faEllipsisV: faEllipsisV,
  faSwordLaserAlt: faSwordLaserAlt,
  faTicket: faTicket,
  faPowerOff: faPowerOff,
  faCoin: faCoin,
  faLaptopSlash: faLaptopSlash,
  faRightLong: faRightLong,
  faLongArrowAltRight: faLongArrowAltRight,
  faCircleB: faCircleB,
  faPersonDressSimple: faPersonDressSimple,
  faPipeCollar: faPipeCollar,
  faLightsHoliday: faLightsHoliday,
  faCitrus: faCitrus,
  faFlagUsa: faFlagUsa,
  faLaptopFile: faLaptopFile,
  faTty: faTty,
  faTeletype: faTeletype,
  faChartTreeMap: faChartTreeMap,
  faDiagramNext: faDiagramNext,
  faPersonRifle: faPersonRifle,
  faClockFiveThirty: faClockFiveThirty,
  faPipeValve: faPipeValve,
  faArrowUpFromArc: faArrowUpFromArc,
  faFaceSpiralEyes: faFaceSpiralEyes,
  faCompressWide: faCompressWide,
  faCirclePhoneHangup: faCirclePhoneHangup,
  faPhoneCircleDown: faPhoneCircleDown,
  faGearComplexCode: faGearComplexCode,
  faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
  faBadminton: faBadminton,
  faClosedCaptioning: faClosedCaptioning,
  faPersonHiking: faPersonHiking,
  faHiking: faHiking,
  faRightFromLine: faRightFromLine,
  faArrowAltFromLeft: faArrowAltFromLeft,
  faVenusDouble: faVenusDouble,
  faImages: faImages,
  faCalculator: faCalculator,
  faShuttlecock: faShuttlecock,
  faUserHair: faUserHair,
  faEyeEvil: faEyeEvil,
  faPeoplePulling: faPeoplePulling,
  faN: faN,
  faSwap: faSwap,
  faGarage: faGarage,
  faCableCar: faCableCar,
  faTram: faTram,
  faShovelSnow: faShovelSnow,
  faCloudRain: faCloudRain,
  faFaceLying: faFaceLying,
  faSprinkler: faSprinkler,
  faBuildingCircleXmark: faBuildingCircleXmark,
  faPersonSledding: faPersonSledding,
  faSledding: faSledding,
  faGameConsoleHandheld: faGameConsoleHandheld,
  faShip: faShip,
  faClockSixThirty: faClockSixThirty,
  faBatterySlash: faBatterySlash,
  faTugrikSign: faTugrikSign,
  faArrowsDownToLine: faArrowsDownToLine,
  faDownload: faDownload,
  faAnglesUpDown: faAnglesUpDown,
  faShelves: faShelves,
  faInventory: faInventory,
  faCloudSnow: faCloudSnow,
  faFaceGrin: faFaceGrin,
  faGrin: faGrin,
  faDeleteLeft: faDeleteLeft,
  faBackspace: faBackspace,
  faOven: faOven,
  faCloudBinary: faCloudBinary,
  faEyeDropper: faEyeDropper,
  faEyeDropperEmpty: faEyeDropperEmpty,
  faEyedropper: faEyedropper,
  faCommentCaptions: faCommentCaptions,
  faCommentsQuestion: faCommentsQuestion,
  faScribble: faScribble,
  faRotateExclamation: faRotateExclamation,
  faFileCircleCheck: faFileCircleCheck,
  faGlass: faGlass,
  faLoader: faLoader,
  faForward: faForward,
  faUserPilot: faUserPilot,
  faMobile: faMobile,
  faMobileAndroid: faMobileAndroid,
  faMobilePhone: faMobilePhone,
  faCodePullRequestClosed: faCodePullRequestClosed,
  faFaceMeh: faFaceMeh,
  faMeh: faMeh,
  faAlignCenter: faAlignCenter,
  faBookSkull: faBookSkull,
  faBookDead: faBookDead,
  faIdCard: faIdCard,
  faDriversLicense: faDriversLicense,
  faFaceDotted: faFaceDotted,
  faFaceWorried: faFaceWorried,
  faOutdent: faOutdent,
  faDedent: faDedent,
  faHeartCircleExclamation: faHeartCircleExclamation,
  faHouse: faHouse,
  faHome: faHome,
  faHomeAlt: faHomeAlt,
  faHomeLgAlt: faHomeLgAlt,
  faVectorCircle: faVectorCircle,
  faCarCircleBolt: faCarCircleBolt,
  faCalendarWeek: faCalendarWeek,
  faFlyingDisc: faFlyingDisc,
  faLaptopMedical: faLaptopMedical,
  faSquareDownRight: faSquareDownRight,
  faB: faB,
  faSeatAirline: faSeatAirline,
  faMoonOverSun: faMoonOverSun,
  faEclipseAlt: faEclipseAlt,
  faPipe: faPipe,
  faFileMedical: faFileMedical,
  faPotato: faPotato,
  faDiceOne: faDiceOne,
  faCircleA: faCircleA,
  faHelmetBattle: faHelmetBattle,
  faButter: faButter,
  faBlanketFire: faBlanketFire,
  faKiwiBird: faKiwiBird,
  faCastle: faCastle,
  faGolfClub: faGolfClub,
  faArrowRightArrowLeft: faArrowRightArrowLeft,
  faExchange: faExchange,
  faRotateRight: faRotateRight,
  faRedoAlt: faRedoAlt,
  faRotateForward: faRotateForward,
  faUtensils: faUtensils,
  faCutlery: faCutlery,
  faArrowUpWideShort: faArrowUpWideShort,
  faSortAmountUp: faSortAmountUp,
  faChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar,
  faBalloons: faBalloons,
  faMillSign: faMillSign,
  faBowlRice: faBowlRice,
  faTimelineArrow: faTimelineArrow,
  faSkull: faSkull,
  faGameBoardSimple: faGameBoardSimple,
  faGameBoardAlt: faGameBoardAlt,
  faCircleVideo: faCircleVideo,
  faVideoCircle: faVideoCircle,
  faChartScatterBubble: faChartScatterBubble,
  faHouseTurret: faHouseTurret,
  faBanana: faBanana,
  faHandHoldingSkull: faHandHoldingSkull,
  faPeopleDress: faPeopleDress,
  faLoveseat: faLoveseat,
  faCouchSmall: faCouchSmall,
  faTowerBroadcast: faTowerBroadcast,
  faBroadcastTower: faBroadcastTower,
  faTruckPickup: faTruckPickup,
  faBlockQuote: faBlockQuote,
  faUpLong: faUpLong,
  faLongArrowAltUp: faLongArrowAltUp,
  faStop: faStop,
  faCodeMerge: faCodeMerge,
  faMoneyCheckDollarPen: faMoneyCheckDollarPen,
  faMoneyCheckEditAlt: faMoneyCheckEditAlt,
  faUpFromLine: faUpFromLine,
  faArrowAltFromBottom: faArrowAltFromBottom,
  faUpload: faUpload,
  faHurricane: faHurricane,
  faGridRound2Plus: faGridRound2Plus,
  faPeoplePants: faPeoplePants,
  faMound: faMound,
  faWindsock: faWindsock,
  faCircleHalf: faCircleHalf,
  faBrakeWarning: faBrakeWarning,
  faToiletPortable: faToiletPortable,
  faCompactDisc: faCompactDisc,
  faFileArrowDown: faFileArrowDown,
  faFileDownload: faFileDownload,
  faSaxophoneFire: faSaxophoneFire,
  faSaxHot: faSaxHot,
  faCameraWebSlash: faCameraWebSlash,
  faWebcamSlash: faWebcamSlash,
  faFolderMedical: faFolderMedical,
  faFolderGear: faFolderGear,
  faFolderCog: faFolderCog,
  faHandWave: faHandWave,
  faArrowUpArrowDown: faArrowUpArrowDown,
  faSortUpDown: faSortUpDown,
  faCaravan: faCaravan,
  faShieldCat: faShieldCat,
  faMessageSlash: faMessageSlash,
  faCommentAltSlash: faCommentAltSlash,
  faBolt: faBolt,
  faZap: faZap,
  faTrashCanCheck: faTrashCanCheck,
  faGlassWater: faGlassWater,
  faOilWell: faOilWell,
  faPersonSimple: faPersonSimple,
  faVault: faVault,
  faMars: faMars,
  faToilet: faToilet,
  faPlaneCircleXmark: faPlaneCircleXmark,
  faYenSign: faYenSign,
  faCny: faCny,
  faJpy: faJpy,
  faRmb: faRmb,
  faYen: faYen,
  faGearCode: faGearCode,
  faNotes: faNotes,
  faRubleSign: faRubleSign,
  faRouble: faRouble,
  faRub: faRub,
  faRuble: faRuble,
  faTrashUndo: faTrashUndo,
  faTrashArrowTurnLeft: faTrashArrowTurnLeft,
  faChampagneGlass: faChampagneGlass,
  faGlassChampagne: faGlassChampagne,
  faObjectsAlignCenterHorizontal: faObjectsAlignCenterHorizontal,
  faSun: faSun,
  faTrashCanSlash: faTrashCanSlash,
  faTrashAltSlash: faTrashAltSlash,
  faScreenUsers: faScreenUsers,
  faUsersClass: faUsersClass,
  faGuitar: faGuitar,
  faSquareArrowLeft: faSquareArrowLeft,
  faArrowSquareLeft: faArrowSquareLeft,
  faSquare8: faSquare8,
  faFaceSmileHearts: faFaceSmileHearts,
  faBracketsSquare: faBracketsSquare,
  faBrackets: faBrackets,
  faLaptopArrowDown: faLaptopArrowDown,
  faHockeyStickPuck: faHockeyStickPuck,
  faHouseTree: faHouseTree,
  faSignalFair: faSignalFair,
  faSignal2: faSignal2,
  faFaceLaughWink: faFaceLaughWink,
  faLaughWink: faLaughWink,
  faCircleDollar: faCircleDollar,
  faDollarCircle: faDollarCircle,
  faUsdCircle: faUsdCircle,
  faHorseHead: faHorseHead,
  faArrowsRepeat: faArrowsRepeat,
  faRepeatAlt: faRepeatAlt,
  faBoreHole: faBoreHole,
  faIndustry: faIndustry,
  faImagePolaroid: faImagePolaroid,
  faWaveTriangle: faWaveTriangle,
  faPersonRunningFast: faPersonRunningFast,
  faCircleDown: faCircleDown,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faGrill: faGrill,
  faArrowsTurnToDots: faArrowsTurnToDots,
  faChartMixed: faChartMixed,
  faAnalytics: faAnalytics,
  faFlorinSign: faFlorinSign,
  faArrowDownShortWide: faArrowDownShortWide,
  faSortAmountDesc: faSortAmountDesc,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faLessThan: faLessThan,
  faDisplayCode: faDisplayCode,
  faDesktopCode: faDesktopCode,
  faFaceDrooling: faFaceDrooling,
  faOilTemperature: faOilTemperature,
  faOilTemp: faOilTemp,
  faSquareQuestion: faSquareQuestion,
  faQuestionSquare: faQuestionSquare,
  faAirConditioner: faAirConditioner,
  faAngleDown: faAngleDown,
  faMountains: faMountains,
  faOmega: faOmega,
  faCarTunnel: faCarTunnel,
  faPersonDollyEmpty: faPersonDollyEmpty,
  faPanFood: faPanFood,
  faHeadSideCough: faHeadSideCough,
  faGripLines: faGripLines,
  faThumbsDown: faThumbsDown,
  faUserLock: faUserLock,
  faArrowRightLong: faArrowRightLong,
  faLongArrowRight: faLongArrowRight,
  faTicketsAirline: faTicketsAirline,
  faAnchorCircleXmark: faAnchorCircleXmark,
  faEllipsis: faEllipsis,
  faEllipsisH: faEllipsisH,
  faNfcSlash: faNfcSlash,
  faChessPawn: faChessPawn,
  faKitMedical: faKitMedical,
  faFirstAid: faFirstAid,
  faGrid2Plus: faGrid2Plus,
  faBells: faBells,
  faPersonThroughWindow: faPersonThroughWindow,
  faToolbox: faToolbox,
  faEnvelopeDot: faEnvelopeDot,
  faEnvelopeBadge: faEnvelopeBadge,
  faHandsHoldingCircle: faHandsHoldingCircle,
  faBug: faBug,
  faBowlChopsticks: faBowlChopsticks,
  faCreditCard: faCreditCard,
  faCreditCardAlt: faCreditCardAlt,
  faCircleS: faCircleS,
  faBoxBallot: faBoxBallot,
  faCar: faCar,
  faAutomobile: faAutomobile,
  faHandHoldingHand: faHandHoldingHand,
  faUserTieHair: faUserTieHair,
  faPodiumStar: faPodiumStar,
  faUserHairMullet: faUserHairMullet,
  faBusinessFront: faBusinessFront,
  faPartyBack: faPartyBack,
  faTrianBalbot: faTrianBalbot,
  faMicrophoneStand: faMicrophoneStand,
  faBookOpenReader: faBookOpenReader,
  faBookReader: faBookReader,
  faFamilyDress: faFamilyDress,
  faCircleX: faCircleX,
  faCabin: faCabin,
  faMountainSun: faMountainSun,
  faChartSimpleHorizontal: faChartSimpleHorizontal,
  faBluetooth: faBluetooth,
  faArrowsLeftRightToLine: faArrowsLeftRightToLine,
  faHandBackPointLeft: faHandBackPointLeft,
  faMessageDots: faMessageDots,
  faCommentAltDots: faCommentAltDots,
  faMessaging: faMessaging,
  faFileHeart: faFileHeart,
  faBeerMug: faBeerMug,
  faBeerFoam: faBeerFoam,
  faDiceD20: faDiceD20,
  faDrone: faDrone,
  faTruckDroplet: faTruckDroplet,
  faFileCircleXmark: faFileCircleXmark,
  faTemperatureArrowUp: faTemperatureArrowUp,
  faTemperatureUp: faTemperatureUp,
  faMedal: faMedal,
  faPersonFairy: faPersonFairy,
  faBed: faBed,
  faBookCopy: faBookCopy,
  faSquareH: faSquareH,
  faHSquare: faHSquare,
  faSquareC: faSquareC,
  faClockTwo: faClockTwo,
  faSquareEllipsisVertical: faSquareEllipsisVertical,
  faCalendarUsers: faCalendarUsers,
  faPodcast: faPodcast,
  faBee: faBee,
  faTemperatureFull: faTemperatureFull,
  faTemperature4: faTemperature4,
  faThermometer4: faThermometer4,
  faThermometerFull: faThermometerFull,
  faBell: faBell,
  faCandyBar: faCandyBar,
  faChocolateBar: faChocolateBar,
  faXmarkLarge: faXmarkLarge,
  faPinata: faPinata,
  faArrowsFromLine: faArrowsFromLine,
  faSuperscript: faSuperscript,
  faBowlSpoon: faBowlSpoon,
  faHexagonCheck: faHexagonCheck,
  faPlugCircleXmark: faPlugCircleXmark,
  faStarOfLife: faStarOfLife,
  faPhoneSlash: faPhoneSlash,
  faTrafficLightStop: faTrafficLightStop,
  faPaintRoller: faPaintRoller,
  faAccentGrave: faAccentGrave,
  faHandshakeAngle: faHandshakeAngle,
  faHandsHelping: faHandsHelping,
  faCircle0: faCircle0,
  faDialMedLow: faDialMedLow,
  faLocationDot: faLocationDot,
  faMapMarkerAlt: faMapMarkerAlt,
  faCrab: faCrab,
  faBoxOpenFull: faBoxOpenFull,
  faBoxFull: faBoxFull,
  faFile: faFile,
  faGreaterThan: faGreaterThan,
  faQuotes: faQuotes,
  faPretzel: faPretzel,
  faPersonSwimming: faPersonSwimming,
  faSwimmer: faSwimmer,
  faArrowDown: faArrowDown,
  faUserRobotXmarks: faUserRobotXmarks,
  faMessageQuote: faMessageQuote,
  faCommentAltQuote: faCommentAltQuote,
  faCandyCorn: faCandyCorn,
  faFolderMagnifyingGlass: faFolderMagnifyingGlass,
  faFolderSearch: faFolderSearch,
  faNotebook: faNotebook,
  faDroplet: faDroplet,
  faTint: faTint,
  faBullseyePointer: faBullseyePointer,
  faEraser: faEraser,
  faHexagonImage: faHexagonImage,
  faEarthAmericas: faEarthAmericas,
  faEarth: faEarth,
  faEarthAmerica: faEarthAmerica,
  faGlobeAmericas: faGlobeAmericas,
  faCrateApple: faCrateApple,
  faAppleCrate: faAppleCrate,
  faPersonBurst: faPersonBurst,
  faGameBoard: faGameBoard,
  faHatChef: faHatChef,
  faHandBackPointRight: faHandBackPointRight,
  faDove: faDove,
  faSnowflakeDroplets: faSnowflakeDroplets,
  faBatteryEmpty: faBatteryEmpty,
  faBattery0: faBattery0,
  faGrid4: faGrid4,
  faSocks: faSocks,
  faFaceSunglasses: faFaceSunglasses,
  faInbox: faInbox,
  faSquare0: faSquare0,
  faSection: faSection,
  faSquareThisWayUp: faSquareThisWayUp,
  faBoxUp: faBoxUp,
  faGaugeHigh: faGaugeHigh,
  faTachometerAlt: faTachometerAlt,
  faTachometerAltFast: faTachometerAltFast,
  faSquareAmpersand: faSquareAmpersand,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faLampDesk: faLampDesk,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalWide: faHospitalWide,
  faPollPeople: faPollPeople,
  faWhiskeyGlassIce: faWhiskeyGlassIce,
  faGlassWhiskeyRocks: faGlassWhiskeyRocks,
  faWineBottle: faWineBottle,
  faChessRook: faChessRook,
  faUserBountyHunter: faUserBountyHunter,
  faBarsStaggered: faBarsStaggered,
  faReorder: faReorder,
  faStream: faStream,
  faDiagramSankey: faDiagramSankey,
  faCloudHailMixed: faCloudHailMixed,
  faCircleUpLeft: faCircleUpLeft,
  faDharmachakra: faDharmachakra,
  faObjectsAlignLeft: faObjectsAlignLeft,
  faOilCanDrip: faOilCanDrip,
  faFaceSmilingHands: faFaceSmilingHands,
  faBroccoli: faBroccoli,
  faRouteInterstate: faRouteInterstate,
  faEarMuffs: faEarMuffs,
  faHotdog: faHotdog,
  faTransporterEmpty: faTransporterEmpty,
  faPersonWalkingWithCane: faPersonWalkingWithCane,
  faBlind: faBlind,
  faAngle90: faAngle90,
  faRectangleTerminal: faRectangleTerminal,
  faKite: faKite,
  faDrum: faDrum,
  faScrubber: faScrubber,
  faIceCream: faIceCream,
  faHeartCircleBolt: faHeartCircleBolt,
  faFishBones: faFishBones,
  faDeerRudolph: faDeerRudolph,
  faFax: faFax,
  faParagraph: faParagraph,
  faHeadSideHeart: faHeadSideHeart,
  faSquareE: faSquareE,
  faMeterFire: faMeterFire,
  faCloudHail: faCloudHail,
  faCheckToSlot: faCheckToSlot,
  faVoteYea: faVoteYea,
  faMoneyFromBracket: faMoneyFromBracket,
  faStarHalf: faStarHalf,
  faCarBus: faCarBus,
  faSpeaker: faSpeaker,
  faTimer: faTimer,
  faBoxesStacked: faBoxesStacked,
  faBoxes: faBoxes,
  faBoxesAlt: faBoxesAlt,
  faGrillHot: faGrillHot,
  faBallotCheck: faBallotCheck,
  faLink: faLink,
  faChain: faChain,
  faEarListen: faEarListen,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faFileMinus: faFileMinus,
  faTreeCity: faTreeCity,
  faPlay: faPlay,
  faFont: faFont,
  faCupTogo: faCupTogo,
  faCoffeeTogo: faCoffeeTogo,
  faSquareDownLeft: faSquareDownLeft,
  faBurgerLettuce: faBurgerLettuce,
  faRupiahSign: faRupiahSign,
  faMagnifyingGlass: faMagnifyingGlass,
  faSearch: faSearch,
  faTableTennisPaddleBall: faTableTennisPaddleBall,
  faPingPongPaddleBall: faPingPongPaddleBall,
  faTableTennis: faTableTennis,
  faPersonDotsFromLine: faPersonDotsFromLine,
  faDiagnoses: faDiagnoses,
  faChevronsDown: faChevronsDown,
  faChevronDoubleDown: faChevronDoubleDown,
  faTrashCanArrowUp: faTrashCanArrowUp,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faSignalGood: faSignalGood,
  faSignal3: faSignal3,
  faLocationQuestion: faLocationQuestion,
  faMapMarkerQuestion: faMapMarkerQuestion,
  faFloppyDiskCircleXmark: faFloppyDiskCircleXmark,
  faFloppyDiskTimes: faFloppyDiskTimes,
  faSaveCircleXmark: faSaveCircleXmark,
  faSaveTimes: faSaveTimes,
  faNairaSign: faNairaSign,
  faPeach: faPeach,
  faTaxiBus: faTaxiBus,
  faBracketCurly: faBracketCurly,
  faBracketCurlyLeft: faBracketCurlyLeft,
  faLobster: faLobster,
  faCartFlatbedEmpty: faCartFlatbedEmpty,
  faDollyFlatbedEmpty: faDollyFlatbedEmpty,
  faColon: faColon,
  faCartArrowDown: faCartArrowDown,
  faWand: faWand,
  faWalkieTalkie: faWalkieTalkie,
  faFilePen: faFilePen,
  faFileEdit: faFileEdit,
  faReceipt: faReceipt,
  faTablePicnic: faTablePicnic,
  faSquarePen: faSquarePen,
  faPenSquare: faPenSquare,
  faPencilSquare: faPencilSquare,
  faCircleMicrophoneLines: faCircleMicrophoneLines,
  faMicrophoneCircleAlt: faMicrophoneCircleAlt,
  faDisplaySlash: faDisplaySlash,
  faDesktopSlash: faDesktopSlash,
  faSuitcaseRolling: faSuitcaseRolling,
  faPersonCircleExclamation: faPersonCircleExclamation,
  faTransporter2: faTransporter2,
  faHandsHoldingDiamond: faHandsHoldingDiamond,
  faHandReceiving: faHandReceiving,
  faMoneyBillSimpleWave: faMoneyBillSimpleWave,
  faChevronDown: faChevronDown,
  faBatteryFull: faBatteryFull,
  faBattery: faBattery,
  faBattery5: faBattery5,
  faBellPlus: faBellPlus,
  faBookArrowRight: faBookArrowRight,
  faHospitals: faHospitals,
  faClub: faClub,
  faSkullCrossbones: faSkullCrossbones,
  faDropletDegree: faDropletDegree,
  faDewpoint: faDewpoint,
  faCodeCompare: faCodeCompare,
  faListUl: faListUl,
  faListDots: faListDots,
  faHandHoldingMagic: faHandHoldingMagic,
  faWatermelonSlice: faWatermelonSlice,
  faCircleEllipsis: faCircleEllipsis,
  faSchoolLock: faSchoolLock,
  faTowerCell: faTowerCell,
  faSdCards: faSdCards,
  faJugBottle: faJugBottle,
  faDownLong: faDownLong,
  faLongArrowAltDown: faLongArrowAltDown,
  faEnvelopes: faEnvelopes,
  faPhoneOffice: faPhoneOffice,
  faRankingStar: faRankingStar,
  faChessKing: faChessKing,
  faNfcPen: faNfcPen,
  faPersonHarassing: faPersonHarassing,
  faHatWinter: faHatWinter,
  faBrazilianRealSign: faBrazilianRealSign,
  faLandmarkDome: faLandmarkDome,
  faLandmarkAlt: faLandmarkAlt,
  faBoneBreak: faBoneBreak,
  faArrowUp: faArrowUp,
  faDownFromDottedLine: faDownFromDottedLine,
  faTv: faTv,
  faTelevision: faTelevision,
  faTvAlt: faTvAlt,
  faBorderLeft: faBorderLeft,
  faCircleDivide: faCircleDivide,
  faShrimp: faShrimp,
  faListCheck: faListCheck,
  faTasks: faTasks,
  faDiagramSubtask: faDiagramSubtask,
  faJugDetergent: faJugDetergent,
  faCircleUser: faCircleUser,
  faUserCircle: faUserCircle,
  faSquareY: faSquareY,
  faUserDoctorHair: faUserDoctorHair,
  faPlanetRinged: faPlanetRinged,
  faMushroom: faMushroom,
  faUserShield: faUserShield,
  faMegaphone: faMegaphone,
  faWreathLaurel: faWreathLaurel,
  faCircleExclamationCheck: faCircleExclamationCheck,
  faWind: faWind,
  faBoxDollar: faBoxDollar,
  faBoxUsd: faBoxUsd,
  faCarBurst: faCarBurst,
  faCarCrash: faCarCrash,
  faY: faY,
  faUserHeadset: faUserHeadset,
  faArrowsRetweet: faArrowsRetweet,
  faRetweetAlt: faRetweetAlt,
  faPersonSnowboarding: faPersonSnowboarding,
  faSnowboarding: faSnowboarding,
  faSquareChevronRight: faSquareChevronRight,
  faChevronSquareRight: faChevronSquareRight,
  faLacrosseStickBall: faLacrosseStickBall,
  faTruckFast: faTruckFast,
  faShippingFast: faShippingFast,
  faUserMagnifyingGlass: faUserMagnifyingGlass,
  faStarSharp: faStarSharp,
  faCommentHeart: faCommentHeart,
  faCircle1: faCircle1,
  faCircleStar: faCircleStar,
  faStarCircle: faStarCircle,
  faFish: faFish,
  faCloudFog: faCloudFog,
  faFog: faFog,
  faWaffle: faWaffle,
  faMusicNote: faMusicNote,
  faMusicAlt: faMusicAlt,
  faHexagonExclamation: faHexagonExclamation,
  faCartShoppingFast: faCartShoppingFast,
  faObjectUnion: faObjectUnion,
  faUserGraduate: faUserGraduate,
  faStarfighter: faStarfighter,
  faCircleHalfStroke: faCircleHalfStroke,
  faAdjust: faAdjust,
  faArrowRightLongToLine: faArrowRightLongToLine,
  faSquareArrowDown: faSquareArrowDown,
  faArrowSquareDown: faArrowSquareDown,
  faDiamondHalfStroke: faDiamondHalfStroke,
  faClapperboard: faClapperboard,
  faSquareChevronLeft: faSquareChevronLeft,
  faChevronSquareLeft: faChevronSquareLeft,
  faPhoneIntercom: faPhoneIntercom,
  faLinkHorizontal: faLinkHorizontal,
  faChainHorizontal: faChainHorizontal,
  faMango: faMango,
  faMusicNoteSlash: faMusicNoteSlash,
  faMusicAltSlash: faMusicAltSlash,
  faCircleRadiation: faCircleRadiation,
  faRadiationAlt: faRadiationAlt,
  faFaceTongueSweat: faFaceTongueSweat,
  faGlobeStand: faGlobeStand,
  faBaseball: faBaseball,
  faBaseballBall: faBaseballBall,
  faCircleP: faCircleP,
  faAwardSimple: faAwardSimple,
  faJetFighterUp: faJetFighterUp,
  faDiagramProject: faDiagramProject,
  faProjectDiagram: faProjectDiagram,
  faPedestal: faPedestal,
  faChartPyramid: faChartPyramid,
  faSidebar: faSidebar,
  faSnowmanHead: faSnowmanHead,
  faFrostyHead: faFrostyHead,
  faCopy: faCopy,
  faBurgerGlass: faBurgerGlass,
  faVolumeXmark: faVolumeXmark,
  faVolumeMute: faVolumeMute,
  faVolumeTimes: faVolumeTimes,
  faHandSparkles: faHandSparkles,
  faBarsFilter: faBarsFilter,
  faPaintbrushPencil: faPaintbrushPencil,
  faPartyBell: faPartyBell,
  faUserVneckHair: faUserVneckHair,
  faJackOLantern: faJackOLantern,
  faGrip: faGrip,
  faGripHorizontal: faGripHorizontal,
  faShareFromSquare: faShareFromSquare,
  faShareSquare: faShareSquare,
  faKeynote: faKeynote,
  faChildCombatant: faChildCombatant,
  faChildRifle: faChildRifle,
  faGun: faGun,
  faSquarePhone: faSquarePhone,
  faPhoneSquare: faPhoneSquare,
  faHatBeach: faHatBeach,
  faPlus: faPlus,
  faAdd: faAdd,
  faExpand: faExpand,
  faComputer: faComputer,
  faFort: faFort,
  faCloudCheck: faCloudCheck,
  faXmark: faXmark,
  faClose: faClose,
  faMultiply: faMultiply,
  faRemove: faRemove,
  faTimes: faTimes,
  faFaceSmirking: faFaceSmirking,
  faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  faArrows: faArrows,
  faChalkboardUser: faChalkboardUser,
  faChalkboardTeacher: faChalkboardTeacher,
  faRhombus: faRhombus,
  faClawMarks: faClawMarks,
  faPesoSign: faPesoSign,
  faFaceSmileTongue: faFaceSmileTongue,
  faCartCircleXmark: faCartCircleXmark,
  faBuildingShield: faBuildingShield,
  faCirclePhoneFlip: faCirclePhoneFlip,
  faPhoneCircleAlt: faPhoneCircleAlt,
  faBaby: faBaby,
  faUsersLine: faUsersLine,
  faQuoteLeft: faQuoteLeft,
  faQuoteLeftAlt: faQuoteLeftAlt,
  faTractor: faTractor,
  faKeySkeleton: faKeySkeleton,
  faTrashArrowUp: faTrashArrowUp,
  faTrashRestore: faTrashRestore,
  faArrowDownUpLock: faArrowDownUpLock,
  faArrowDownToBracket: faArrowDownToBracket,
  faLinesLeaning: faLinesLeaning,
  faSquareQ: faSquareQ,
  faRulerCombined: faRulerCombined,
  faSymbols: faSymbols,
  faIconsAlt: faIconsAlt,
  faCopyright: faCopyright,
  faFlaskGear: faFlaskGear,
  faHighlighterLine: faHighlighterLine,
  faBracketSquare: faBracketSquare,
  faBracket: faBracket,
  faBracketLeft: faBracketLeft,
  faIslandTropical: faIslandTropical,
  faIslandTreePalm: faIslandTreePalm,
  faArrowRightFromLine: faArrowRightFromLine,
  faArrowFromLeft: faArrowFromLeft,
  faH2: faH2,
  faEquals: faEquals,
  faCakeSlice: faCakeSlice,
  faShortcake: faShortcake,
  faPeanut: faPeanut,
  faWrenchSimple: faWrenchSimple,
  faBlender: faBlender,
  faTeeth: faTeeth,
  faTally2: faTally2,
  faShekelSign: faShekelSign,
  faIls: faIls,
  faShekel: faShekel,
  faSheqel: faSheqel,
  faSheqelSign: faSheqelSign,
  faCars: faCars,
  faAxeBattle: faAxeBattle,
  faUserHairLong: faUserHairLong,
  faMap: faMap,
  faArrowLeftFromArc: faArrowLeftFromArc,
  faFileCircleInfo: faFileCircleInfo,
  faFaceDisappointed: faFaceDisappointed,
  faLassoSparkles: faLassoSparkles,
  faClockEleven: faClockEleven,
  faRocket: faRocket,
  faSirenOn: faSirenOn,
  faClockTen: faClockTen,
  faCandleHolder: faCandleHolder,
  faVideoArrowDownLeft: faVideoArrowDownLeft,
  faPhotoFilm: faPhotoFilm,
  faPhotoVideo: faPhotoVideo,
  faFloppyDiskCircleArrowRight: faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight: faSaveCircleArrowRight,
  faFolderMinus: faFolderMinus,
  faPlanetMoon: faPlanetMoon,
  faFaceEyesXmarks: faFaceEyesXmarks,
  faChartScatter: faChartScatter,
  faDisplayArrowDown: faDisplayArrowDown,
  faStore: faStore,
  faArrowTrendUp: faArrowTrendUp,
  faPlugCircleMinus: faPlugCircleMinus,
  faOliveBranch: faOliveBranch,
  faAngle: faAngle,
  faVacuumRobot: faVacuumRobot,
  faSignHanging: faSignHanging,
  faSign: faSign,
  faSquareDivide: faSquareDivide,
  faSignalStreamSlash: faSignalStreamSlash,
  faBezierCurve: faBezierCurve,
  faEyeDropperHalf: faEyeDropperHalf,
  faStoreLock: faStoreLock,
  faBellSlash: faBellSlash,
  faCloudBoltSun: faCloudBoltSun,
  faThunderstormSun: faThunderstormSun,
  faCameraSlash: faCameraSlash,
  faCommentQuote: faCommentQuote,
  faTablet: faTablet,
  faTabletAndroid: faTabletAndroid,
  faSchoolFlag: faSchoolFlag,
  faMessageCode: faMessageCode,
  faGlassHalf: faGlassHalf,
  faGlassHalfEmpty: faGlassHalfEmpty,
  faGlassHalfFull: faGlassHalfFull,
  faFill: faFill,
  faMessageMinus: faMessageMinus,
  faCommentAltMinus: faCommentAltMinus,
  faAngleUp: faAngleUp,
  faDinosaur: faDinosaur,
  faDrumstickBite: faDrumstickBite,
  faLinkHorizontalSlash: faLinkHorizontalSlash,
  faChainHorizontalSlash: faChainHorizontalSlash,
  faHollyBerry: faHollyBerry,
  faNose: faNose,
  faArrowLeftToArc: faArrowLeftToArc,
  faChevronLeft: faChevronLeft,
  faBacteria: faBacteria,
  faClouds: faClouds,
  faMoneyBillSimple: faMoneyBillSimple,
  faHandLizard: faHandLizard,
  faTablePivot: faTablePivot,
  faFilterSlash: faFilterSlash,
  faTrashCanUndo: faTrashCanUndo,
  faTrashCanArrowTurnLeft: faTrashCanArrowTurnLeft,
  faTrashUndoAlt: faTrashUndoAlt,
  faNotdef: faNotdef,
  faDisease: faDisease,
  faPersonToDoor: faPersonToDoor,
  faTurntable: faTurntable,
  faBriefcaseMedical: faBriefcaseMedical,
  faGenderless: faGenderless,
  faChevronRight: faChevronRight,
  faSignalWeak: faSignalWeak,
  faSignal1: faSignal1,
  faClockFive: faClockFive,
  faRetweet: faRetweet,
  faCarRear: faCarRear,
  faCarAlt: faCarAlt,
  faPumpSoap: faPumpSoap,
  faComputerClassic: faComputerClassic,
  faFrame: faFrame,
  faVideoSlash: faVideoSlash,
  faBatteryQuarter: faBatteryQuarter,
  faBattery2: faBattery2,
  faEllipsisStroke: faEllipsisStroke,
  faEllipsisHAlt: faEllipsisHAlt,
  faRadio: faRadio,
  faBabyCarriage: faBabyCarriage,
  faCarriageBaby: faCarriageBaby,
  faFaceExpressionless: faFaceExpressionless,
  faDownToDottedLine: faDownToDottedLine,
  faCloudMusic: faCloudMusic,
  faTrafficLight: faTrafficLight,
  faCloudMinus: faCloudMinus,
  faThermometer: faThermometer,
  faShieldMinus: faShieldMinus,
  faVrCardboard: faVrCardboard,
  faCarTilt: faCarTilt,
  faGaugeCircleMinus: faGaugeCircleMinus,
  faBrightnessLow: faBrightnessLow,
  faHandMiddleFinger: faHandMiddleFinger,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faTruckMoving: faTruckMoving,
  faGlassWaterDroplet: faGlassWaterDroplet,
  faConveyorBelt: faConveyorBelt,
  faLocationCheck: faLocationCheck,
  faMapMarkerCheck: faMapMarkerCheck,
  faCoinVertical: faCoinVertical,
  faDisplay: faDisplay,
  faPersonSign: faPersonSign,
  faFaceSmile: faFaceSmile,
  faSmile: faSmile,
  faPhoneHangup: faPhoneHangup,
  faSignatureSlash: faSignatureSlash,
  faThumbtack: faThumbtack,
  faThumbTack: faThumbTack,
  faWheatSlash: faWheatSlash,
  faTrophy: faTrophy,
  faCloudsSun: faCloudsSun,
  faPersonPraying: faPersonPraying,
  faPray: faPray,
  faHammer: faHammer,
  faFaceVomit: faFaceVomit,
  faSpeakers: faSpeakers,
  faTtyAnswer: faTtyAnswer,
  faTeletypeAnswer: faTeletypeAnswer,
  faMugTeaSaucer: faMugTeaSaucer,
  faDiagramLeanCanvas: faDiagramLeanCanvas,
  faAlt: faAlt,
  faDial: faDial,
  faDialMedHigh: faDialMedHigh,
  faHandPeace: faHandPeace,
  faCircleTrash: faCircleTrash,
  faTrashCircle: faTrashCircle,
  faRotate: faRotate,
  faSyncAlt: faSyncAlt,
  faCircleQuarters: faCircleQuarters,
  faSpinner: faSpinner,
  faTowerControl: faTowerControl,
  faArrowUpTriangleSquare: faArrowUpTriangleSquare,
  faSortShapesUp: faSortShapesUp,
  faWhale: faWhale,
  faRobot: faRobot,
  faPeace: faPeace,
  faPartyHorn: faPartyHorn,
  faGears: faGears,
  faCogs: faCogs,
  faSunBright: faSunBright,
  faSunAlt: faSunAlt,
  faWarehouse: faWarehouse,
  faConveyorBeltArm: faConveyorBeltArm,
  faLockKeyholeOpen: faLockKeyholeOpen,
  faLockOpenAlt: faLockOpenAlt,
  faSquareFragile: faSquareFragile,
  faBoxFragile: faBoxFragile,
  faSquareWineGlassCrack: faSquareWineGlassCrack,
  faArrowUpRightDots: faArrowUpRightDots,
  faSquareN: faSquareN,
  faSplotch: faSplotch,
  faFaceGrinHearts: faFaceGrinHearts,
  faGrinHearts: faGrinHearts,
  faMeter: faMeter,
  faMandolin: faMandolin,
  faDiceFour: faDiceFour,
  faSimCard: faSimCard,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faMercury: faMercury,
  faUpFromBracket: faUpFromBracket,
  faKnifeKitchen: faKnifeKitchen,
  faBorderRight: faBorderRight,
  faArrowTurnDown: faArrowTurnDown,
  faLevelDown: faLevelDown,
  faSpade: faSpade,
  faCardSpade: faCardSpade,
  faLineColumns: faLineColumns,
  faArrowRightToLine: faArrowRightToLine,
  faArrowToRight: faArrowToRight,
  faPersonFallingBurst: faPersonFallingBurst,
  faFlagPennant: faFlagPennant,
  faPennant: faPennant,
  faConveyorBeltEmpty: faConveyorBeltEmpty,
  faUserGroupSimple: faUserGroupSimple,
  faAward: faAward,
  faTicketSimple: faTicketSimple,
  faTicketAlt: faTicketAlt,
  faBuilding: faBuilding,
  faAnglesLeft: faAnglesLeft,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faCamcorder: faCamcorder,
  faVideoHandheld: faVideoHandheld,
  faPancakes: faPancakes,
  faAlbumCircleUser: faAlbumCircleUser,
  faSubtitlesSlash: faSubtitlesSlash,
  faQrcode: faQrcode,
  faDiceD10: faDiceD10,
  faFireplace: faFireplace,
  faBrowser: faBrowser,
  faPenPaintbrush: faPenPaintbrush,
  faPencilPaintbrush: faPencilPaintbrush,
  faFishCooked: faFishCooked,
  faChairOffice: faChairOffice,
  faNestingDolls: faNestingDolls,
  faClockRotateLeft: faClockRotateLeft,
  faHistory: faHistory,
  faTrumpet: faTrumpet,
  faFaceGrinBeamSweat: faFaceGrinBeamSweat,
  faGrinBeamSweat: faGrinBeamSweat,
  faFireSmoke: faFireSmoke,
  faPhoneMissed: faPhoneMissed,
  faFileExport: faFileExport,
  faArrowRightFromFile: faArrowRightFromFile,
  faShield: faShield,
  faShieldBlank: faShieldBlank,
  faArrowUpShortWide: faArrowUpShortWide,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faArrowsRepeat1: faArrowsRepeat1,
  faRepeat1Alt: faRepeat1Alt,
  faGunSlash: faGunSlash,
  faAvocado: faAvocado,
  faBinary: faBinary,
  faGlassesRound: faGlassesRound,
  faGlassesAlt: faGlassesAlt,
  faPhonePlus: faPhonePlus,
  faDitto: faDitto,
  faPersonSeat: faPersonSeat,
  faHouseMedical: faHouseMedical,
  faGolfBallTee: faGolfBallTee,
  faGolfBall: faGolfBall,
  faCircleChevronLeft: faCircleChevronLeft,
  faChevronCircleLeft: faChevronCircleLeft,
  faHouseChimneyWindow: faHouseChimneyWindow,
  faScythe: faScythe,
  faPenNib: faPenNib,
  faBanParking: faBanParking,
  faParkingCircleSlash: faParkingCircleSlash,
  faTentArrowTurnLeft: faTentArrowTurnLeft,
  faFaceDiagonalMouth: faFaceDiagonalMouth,
  faDiagramCells: faDiagramCells,
  faCricketBatBall: faCricketBatBall,
  faCricket: faCricket,
  faTents: faTents,
  faWandMagic: faWandMagic,
  faMagic: faMagic,
  faDog: faDog,
  faPenLine: faPenLine,
  faAtomSimple: faAtomSimple,
  faAtomAlt: faAtomAlt,
  faAmpersand: faAmpersand,
  faCarrot: faCarrot,
  faArrowUpFromLine: faArrowUpFromLine,
  faArrowFromBottom: faArrowFromBottom,
  faMoon: faMoon,
  faPenSlash: faPenSlash,
  faWineGlassEmpty: faWineGlassEmpty,
  faWineGlassAlt: faWineGlassAlt,
  faSquareStar: faSquareStar,
  faCheese: faCheese,
  faSendBackward: faSendBackward,
  faYinYang: faYinYang,
  faMusic: faMusic,
  faCompassSlash: faCompassSlash,
  faClockOne: faClockOne,
  faFileMusic: faFileMusic,
  faCodeCommit: faCodeCommit,
  faTemperatureLow: faTemperatureLow,
  faPersonBiking: faPersonBiking,
  faBiking: faBiking,
  faDisplayChartUpCircleCurrency: faDisplayChartUpCircleCurrency,
  faSkeleton: faSkeleton,
  faCircleG: faCircleG,
  faCircleArrowUpLeft: faCircleArrowUpLeft,
  faCoinBlank: faCoinBlank,
  faBroom: faBroom,
  faVacuum: faVacuum,
  faShieldHeart: faShieldHeart,
  faCardHeart: faCardHeart,
  faLightbulbCflOn: faLightbulbCflOn,
  faMelon: faMelon,
  faGopuram: faGopuram,
  faEarthOceania: faEarthOceania,
  faGlobeOceania: faGlobeOceania,
  faContainerStorage: faContainerStorage,
  faFacePouting: faFacePouting,
  faSquareXmark: faSquareXmark,
  faTimesSquare: faTimesSquare,
  faXmarkSquare: faXmarkSquare,
  faFaceExplode: faFaceExplode,
  faExplodingHead: faExplodingHead,
  faHashtag: faHashtag,
  faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  faExpandAlt: faExpandAlt,
  faOilCan: faOilCan,
  faT: faT,
  faTransformerBolt: faTransformerBolt,
  faHippo: faHippo,
  faChartColumn: faChartColumn,
  faCassetteVhs: faCassetteVhs,
  faVhs: faVhs,
  faInfinity: faInfinity,
  faVialCircleCheck: faVialCircleCheck,
  faChimney: faChimney,
  faObjectIntersect: faObjectIntersect,
  faPersonArrowDownToLine: faPersonArrowDownToLine,
  faVoicemail: faVoicemail,
  faBlockBrick: faBlockBrick,
  faWallBrick: faWallBrick,
  faFan: faFan,
  faBagsShopping: faBagsShopping,
  faParagraphLeft: faParagraphLeft,
  faParagraphRtl: faParagraphRtl,
  faPersonWalkingLuggage: faPersonWalkingLuggage,
  faCaravanSimple: faCaravanSimple,
  faCaravanAlt: faCaravanAlt,
  faTurtle: faTurtle,
  faPencilMechanical: faPencilMechanical,
  faUpDown: faUpDown,
  faArrowsAltV: faArrowsAltV,
  faCloudMoonRain: faCloudMoonRain,
  faBoothCurtain: faBoothCurtain,
  faCalendar: faCalendar,
  faBoxHeart: faBoxHeart,
  faTrailer: faTrailer,
  faUserDoctorMessage: faUserDoctorMessage,
  faUserMdChat: faUserMdChat,
  faBahai: faBahai,
  faHaykal: faHaykal,
  faLighthouse: faLighthouse,
  faAmpGuitar: faAmpGuitar,
  faSdCard: faSdCard,
  faVolumeSlash: faVolumeSlash,
  faBorderBottom: faBorderBottom,
  faWifiWeak: faWifiWeak,
  faWifi1: faWifi1,
  faDragon: faDragon,
  faShoePrints: faShoePrints,
  faCirclePlus: faCirclePlus,
  faPlusCircle: faPlusCircle,
  faFaceGrinTongueWink: faFaceGrinTongueWink,
  faGrinTongueWink: faGrinTongueWink,
  faHandHolding: faHandHolding,
  faPlugCircleExclamation: faPlugCircleExclamation,
  faLinkSlash: faLinkSlash,
  faChainBroken: faChainBroken,
  faChainSlash: faChainSlash,
  faUnlink: faUnlink,
  faClone: faClone,
  faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
  faArrowUpZA: faArrowUpZA,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faFireFlameCurved: faFireFlameCurved,
  faFireAlt: faFireAlt,
  faTornado: faTornado,
  faFileCirclePlus: faFileCirclePlus,
  faDeleteRight: faDeleteRight,
  faBookQuran: faBookQuran,
  faQuran: faQuran,
  faCircleQuarter: faCircleQuarter,
  faAnchor: faAnchor,
  faBorderAll: faBorderAll,
  faFunction: faFunction,
  faFaceAngry: faFaceAngry,
  faAngry: faAngry,
  faPeopleSimple: faPeopleSimple,
  faCookieBite: faCookieBite,
  faArrowTrendDown: faArrowTrendDown,
  faRss: faRss,
  faFeed: faFeed,
  faFaceMonocle: faFaceMonocle,
  faDrawPolygon: faDrawPolygon,
  faScaleBalanced: faScaleBalanced,
  faBalanceScale: faBalanceScale,
  faCalendarLines: faCalendarLines,
  faCalendarNote: faCalendarNote,
  faArrowDownBigSmall: faArrowDownBigSmall,
  faSortSizeDown: faSortSizeDown,
  faGaugeSimpleHigh: faGaugeSimpleHigh,
  faTachometer: faTachometer,
  faTachometerFast: faTachometerFast,
  faDoNotEnter: faDoNotEnter,
  faShower: faShower,
  faDiceD8: faDiceD8,
  faDesktop: faDesktop,
  faDesktopAlt: faDesktopAlt,
  faM: faM,
  faGripDotsVertical: faGripDotsVertical,
  faFaceViewfinder: faFaceViewfinder,
  faSoftServe: faSoftServe,
  faCreemee: faCreemee,
  faH5: faH5,
  faHandBackPointDown: faHandBackPointDown,
  faTableList: faTableList,
  faThList: faThList,
  faCommentSms: faCommentSms,
  faSms: faSms,
  faRectangle: faRectangle,
  faRectangleLandscape: faRectangleLandscape,
  faClipboardListCheck: faClipboardListCheck,
  faTurkey: faTurkey,
  faBook: faBook,
  faUserPlus: faUserPlus,
  faIceSkate: faIceSkate,
  faCheck: faCheck,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBattery4: faBattery4,
  faTomato: faTomato,
  faSwordLaser: faSwordLaser,
  faHouseCircleCheck: faHouseCircleCheck,
  faBuildings: faBuildings,
  faAngleLeft: faAngleLeft,
  faCartFlatbedBoxes: faCartFlatbedBoxes,
  faDollyFlatbedAlt: faDollyFlatbedAlt,
  faDiagramSuccessor: faDiagramSuccessor,
  faTruckArrowRight: faTruckArrowRight,
  faSquareW: faSquareW,
  faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  faLamp: faLamp,
  faAirplay: faAirplay,
  faHandFist: faHandFist,
  faFistRaised: faFistRaised,
  faShieldQuartered: faShieldQuartered,
  faSlashForward: faSlashForward,
  faLocationPen: faLocationPen,
  faMapMarkerEdit: faMapMarkerEdit,
  faCloudMoon: faCloudMoon,
  faPotFood: faPotFood,
  faBriefcase: faBriefcase,
  faPersonFalling: faPersonFalling,
  faImagePortrait: faImagePortrait,
  faPortrait: faPortrait,
  faUserTag: faUserTag,
  faRug: faRug,
  faPrintSlash: faPrintSlash,
  faEarthEurope: faEarthEurope,
  faGlobeEurope: faGlobeEurope,
  faCartFlatbedSuitcase: faCartFlatbedSuitcase,
  faLuggageCart: faLuggageCart,
  faHandBackPointRibbon: faHandBackPointRibbon,
  faRectangleXmark: faRectangleXmark,
  faRectangleTimes: faRectangleTimes,
  faTimesRectangle: faTimesRectangle,
  faWindowClose: faWindowClose,
  faTireRugged: faTireRugged,
  faLightbulbDollar: faLightbulbDollar,
  faCowbell: faCowbell,
  faBahtSign: faBahtSign,
  faCorner: faCorner,
  faChevronsRight: faChevronsRight,
  faChevronDoubleRight: faChevronDoubleRight,
  faBookOpen: faBookOpen,
  faBookJournalWhills: faBookJournalWhills,
  faJournalWhills: faJournalWhills,
  faInhaler: faInhaler,
  faHandcuffs: faHandcuffs,
  faSnake: faSnake,
  faTriangleExclamation: faTriangleExclamation,
  faExclamationTriangle: faExclamationTriangle,
  faWarning: faWarning,
  faNoteMedical: faNoteMedical,
  faDatabase: faDatabase,
  faDownLeft: faDownLeft,
  faShare: faShare,
  faArrowTurnRight: faArrowTurnRight,
  faMailForward: faMailForward,
  faFaceThinking: faFaceThinking,
  faTurnDownRight: faTurnDownRight,
  faBottleDroplet: faBottleDroplet,
  faMaskFace: faMaskFace,
  faHillRockslide: faHillRockslide,
  faScannerKeyboard: faScannerKeyboard,
  faCircleO: faCircleO,
  faGridHorizontal: faGridHorizontal,
  faMessageDollar: faMessageDollar,
  faCommentAltDollar: faCommentAltDollar,
  faRightLeft: faRightLeft,
  faExchangeAlt: faExchangeAlt,
  faColumns3: faColumns3,
  faPaperPlane: faPaperPlane,
  faRoadCircleExclamation: faRoadCircleExclamation,
  faDungeon: faDungeon,
  faHandHoldingBox: faHandHoldingBox,
  faInputText: faInputText,
  faWindowFlip: faWindowFlip,
  faWindowAlt: faWindowAlt,
  faAlignRight: faAlignRight,
  faScannerGun: faScannerGun,
  faScanner: faScanner,
  faTire: faTire,
  faEngine: faEngine,
  faMoneyBill1Wave: faMoneyBill1Wave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faLifeRing: faLifeRing,
  faHands: faHands,
  faSignLanguage: faSignLanguage,
  faSigning: faSigning,
  faCircleCaretRight: faCircleCaretRight,
  faCaretCircleRight: faCaretCircleRight,
  faWheat: faWheat,
  faFileSpreadsheet: faFileSpreadsheet,
  faAudioDescriptionSlash: faAudioDescriptionSlash,
  faCalendarDay: faCalendarDay,
  faWaterLadder: faWaterLadder,
  faLadderWater: faLadderWater,
  faSwimmingPool: faSwimmingPool,
  faArrowsUpDown: faArrowsUpDown,
  faArrowsV: faArrowsV,
  faChessPawnPiece: faChessPawnPiece,
  faChessPawnAlt: faChessPawnAlt,
  faFaceGrimace: faFaceGrimace,
  faGrimace: faGrimace,
  faWheelchairMove: faWheelchairMove,
  faWheelchairAlt: faWheelchairAlt,
  faTurnDown: faTurnDown,
  faLevelDownAlt: faLevelDownAlt,
  faSquareS: faSquareS,
  faRectangleBarcode: faRectangleBarcode,
  faBarcodeAlt: faBarcodeAlt,
  faPersonWalkingArrowRight: faPersonWalkingArrowRight,
  faSquareEnvelope: faSquareEnvelope,
  faEnvelopeSquare: faEnvelopeSquare,
  faDice: faDice,
  faUnicorn: faUnicorn,
  faBowlingBall: faBowlingBall,
  faPompebled: faPompebled,
  faBrain: faBrain,
  faWatchSmart: faWatchSmart,
  faBookUser: faBookUser,
  faSensorCloud: faSensorCloud,
  faSensorSmoke: faSensorSmoke,
  faClapperboardPlay: faClapperboardPlay,
  faBandage: faBandage,
  faBandAid: faBandAid,
  faCalendarMinus: faCalendarMinus,
  faCircleXmark: faCircleXmark,
  faTimesCircle: faTimesCircle,
  faXmarkCircle: faXmarkCircle,
  faCircle4: faCircle4,
  faGifts: faGifts,
  faAlbumCollection: faAlbumCollection,
  faHotel: faHotel,
  faEarthAsia: faEarthAsia,
  faGlobeAsia: faGlobeAsia,
  faIdCardClip: faIdCardClip,
  faIdCardAlt: faIdCardAlt,
  faMagnifyingGlassPlus: faMagnifyingGlassPlus,
  faSearchPlus: faSearchPlus,
  faThumbsUp: faThumbsUp,
  faCloudShowers: faCloudShowers,
  faUserClock: faUserClock,
  faOnion: faOnion,
  faClockTwelveThirty: faClockTwelveThirty,
  faArrowDownToDottedLine: faArrowDownToDottedLine,
  faHandDots: faHandDots,
  faAllergies: faAllergies,
  faFileInvoice: faFileInvoice,
  faWindowMinimize: faWindowMinimize,
  faRectangleWide: faRectangleWide,
  faCommentArrowUp: faCommentArrowUp,
  faGarlic: faGarlic,
  faMugSaucer: faMugSaucer,
  faCoffee: faCoffee,
  faBrush: faBrush,
  faTreeDecorated: faTreeDecorated,
  faMask: faMask,
  faCalendarHeart: faCalendarHeart,
  faMagnifyingGlassMinus: faMagnifyingGlassMinus,
  faSearchMinus: faSearchMinus,
  faFlower: faFlower,
  faArrowDownFromArc: faArrowDownFromArc,
  faRightLeftLarge: faRightLeftLarge,
  faRulerVertical: faRulerVertical,
  faCirclesOverlap: faCirclesOverlap,
  faUserLarge: faUserLarge,
  faUserAlt: faUserAlt,
  faStarshipFreighter: faStarshipFreighter,
  faTrainTram: faTrainTram,
  faBridgeSuspension: faBridgeSuspension,
  faTrashCheck: faTrashCheck,
  faUserNurse: faUserNurse,
  faBoombox: faBoombox,
  faSyringe: faSyringe,
  faCloudSun: faCloudSun,
  faShieldExclamation: faShieldExclamation,
  faStopwatch20: faStopwatch20,
  faSquareFull: faSquareFull,
  faGripDots: faGripDots,
  faCommentExclamation: faCommentExclamation,
  faPenSwirl: faPenSwirl,
  faFalafel: faFalafel,
  faCircle2: faCircle2,
  faMagnet: faMagnet,
  faJar: faJar,
  faGramophone: faGramophone,
  faDiceD12: faDiceD12,
  faNoteSticky: faNoteSticky,
  faStickyNote: faStickyNote,
  faDown: faDown,
  faArrowAltDown: faArrowAltDown,
  faHundredPoints: faHundredPoints,
  fa100: fa100,
  faPaperclipVertical: faPaperclipVertical,
  faWindWarning: faWindWarning,
  faWindCircleExclamation: faWindCircleExclamation,
  faLocationPinSlash: faLocationPinSlash,
  faMapMarkerSlash: faMapMarkerSlash,
  faFaceSadSweat: faFaceSadSweat,
  faBugSlash: faBugSlash,
  faCupcake: faCupcake,
  faLightSwitchOff: faLightSwitchOff,
  faToggleLargeOff: faToggleLargeOff,
  faPenFancySlash: faPenFancySlash,
  faTruckContainer: faTruckContainer,
  faBoot: faBoot,
  faArrowUpFromWaterPump: faArrowUpFromWaterPump,
  faFileCheck: faFileCheck,
  faBone: faBone,
  faCardsBlank: faCardsBlank,
  faCircle3: faCircle3,
  faBenchTree: faBenchTree,
  faKeyboardBrightnessLow: faKeyboardBrightnessLow,
  faSkiBootSki: faSkiBootSki,
  faBrainCircuit: faBrainCircuit,
  faUserInjured: faUserInjured,
  faBlockBrickFire: faBlockBrickFire,
  faFirewall: faFirewall,
  faFaceSadTear: faFaceSadTear,
  faSadTear: faSadTear,
  faPlane: faPlane,
  faTentArrowsDown: faTentArrowsDown,
  faExclamation: faExclamation,
  faArrowsSpin: faArrowsSpin,
  faFaceSmileRelaxed: faFaceSmileRelaxed,
  faCommentXmark: faCommentXmark,
  faCommentTimes: faCommentTimes,
  faPrint: faPrint,
  faTurkishLiraSign: faTurkishLiraSign,
  faTry: faTry,
  faTurkishLira: faTurkishLira,
  faFaceNoseSteam: faFaceNoseSteam,
  faCircleWaveformLines: faCircleWaveformLines,
  faWaveformCircle: faWaveformCircle,
  faDollarSign: faDollarSign,
  faDollar: faDollar,
  faUsd: faUsd,
  faFerrisWheel: faFerrisWheel,
  faComputerSpeaker: faComputerSpeaker,
  faSkullCow: faSkullCow,
  faX: faX,
  faMagnifyingGlassDollar: faMagnifyingGlassDollar,
  faSearchDollar: faSearchDollar,
  faUsersGear: faUsersGear,
  faUsersCog: faUsersCog,
  faPersonMilitaryPointing: faPersonMilitaryPointing,
  faBuildingColumns: faBuildingColumns,
  faBank: faBank,
  faInstitution: faInstitution,
  faMuseum: faMuseum,
  faUniversity: faUniversity,
  faCircleT: faCircleT,
  faSack: faSack,
  faGrid2: faGrid2,
  faCameraCctv: faCameraCctv,
  faCctv: faCctv,
  faUmbrella: faUmbrella,
  faTrowel: faTrowel,
  faHorizontalRule: faHorizontalRule,
  faBedFront: faBedFront,
  faBedAlt: faBedAlt,
  faD: faD,
  faStapler: faStapler,
  faMasksTheater: faMasksTheater,
  faTheaterMasks: faTheaterMasks,
  faKipSign: faKipSign,
  faFaceWoozy: faFaceWoozy,
  faCloudQuestion: faCloudQuestion,
  faPineapple: faPineapple,
  faHandPointLeft: faHandPointLeft,
  faGalleryThumbnails: faGalleryThumbnails,
  faCircleJ: faCircleJ,
  faEyes: faEyes,
  faHandshakeSimple: faHandshakeSimple,
  faHandshakeAlt: faHandshakeAlt,
  faPageCaretUp: faPageCaretUp,
  faFileCaretUp: faFileCaretUp,
  faJetFighter: faJetFighter,
  faFighterJet: faFighterJet,
  faComet: faComet,
  faSquareShareNodes: faSquareShareNodes,
  faShareAltSquare: faShareAltSquare,
  faShieldKeyhole: faShieldKeyhole,
  faBarcode: faBarcode,
  faPlusMinus: faPlusMinus,
  faSquareSlidersVertical: faSquareSlidersVertical,
  faSlidersVSquare: faSlidersVSquare,
  faVideo: faVideo,
  faVideoCamera: faVideoCamera,
  faMessageMiddle: faMessageMiddle,
  faCommentMiddleAlt: faCommentMiddleAlt,
  faGraduationCap: faGraduationCap,
  faMortarBoard: faMortarBoard,
  faHandHoldingMedical: faHandHoldingMedical,
  faPersonCircleCheck: faPersonCircleCheck,
  faSquareZ: faSquareZ,
  faMessageText: faMessageText,
  faCommentAltText: faCommentAltText,
  faTurnUp: faTurnUp,
  faLevelUpAlt: faLevelUpAlt
};




/***/ }),

/***/ 68779:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A35": function() { return /* binding */ faChevronLeft; },
/* harmony export */   "Aq": function() { return /* binding */ faEyeSlash; },
/* harmony export */   "Ct": function() { return /* binding */ faFilterList; },
/* harmony export */   "DBf": function() { return /* binding */ faCircleInfo; },
/* harmony export */   "Dy0": function() { return /* binding */ faChevronsRight; },
/* harmony export */   "EyR": function() { return /* binding */ faAngleLeft; },
/* harmony export */   "FDd": function() { return /* binding */ faCircleQuestion; },
/* harmony export */   "FU$": function() { return /* binding */ faEnvelope; },
/* harmony export */   "FVb": function() { return /* binding */ faUsers; },
/* harmony export */   "ILF": function() { return /* binding */ faUser; },
/* harmony export */   "Kl4": function() { return /* binding */ faMinus; },
/* harmony export */   "Krp": function() { return /* binding */ faLayerGroup; },
/* harmony export */   "LEp": function() { return /* binding */ faCheck; },
/* harmony export */   "Mdf": function() { return /* binding */ faEye; },
/* harmony export */   "NdV": function() { return /* binding */ faUserGroup; },
/* harmony export */   "SJh": function() { return /* binding */ faArrowRightFromBracket; },
/* harmony export */   "Uwo": function() { return /* binding */ faEllipsisVertical; },
/* harmony export */   "V3X": function() { return /* binding */ faCircleUser; },
/* harmony export */   "VmB": function() { return /* binding */ faImage; },
/* harmony export */   "Vui": function() { return /* binding */ faTrashCan; },
/* harmony export */   "WA2": function() { return /* binding */ faCircleXmark; },
/* harmony export */   "Wdf": function() { return /* binding */ faArrowUpRightAndArrowDownLeftFromCenter; },
/* harmony export */   "XAH": function() { return /* binding */ faTrash; },
/* harmony export */   "Xcf": function() { return /* binding */ faEdit; },
/* harmony export */   "Xig": function() { return /* binding */ faMusic; },
/* harmony export */   "Y$T": function() { return /* binding */ faMagnifyingGlass; },
/* harmony export */   "YIN": function() { return /* binding */ faClose; },
/* harmony export */   "Yai": function() { return /* binding */ faPenToSquare; },
/* harmony export */   "Z30": function() { return /* binding */ faWandMagicSparkles; },
/* harmony export */   "Z6I": function() { return /* binding */ faCommentDots; },
/* harmony export */   "Zrf": function() { return /* binding */ faList; },
/* harmony export */   "_3l": function() { return /* binding */ faFilePen; },
/* harmony export */   "_tD": function() { return /* binding */ faChevronRight; },
/* harmony export */   "dB5": function() { return /* binding */ faAnglesUpDown; },
/* harmony export */   "fV7": function() { return /* binding */ faCircleCheck; },
/* harmony export */   "g82": function() { return /* binding */ faXmark; },
/* harmony export */   "g9M": function() { return /* binding */ faFolders; },
/* harmony export */   "gc2": function() { return /* binding */ faAngleDown; },
/* harmony export */   "gr5": function() { return /* binding */ faGear; },
/* harmony export */   "ik8": function() { return /* binding */ faTriangleExclamation; },
/* harmony export */   "kXW": function() { return /* binding */ faNetworkWired; },
/* harmony export */   "kZ_": function() { return /* binding */ faCopy; },
/* harmony export */   "mDN": function() { return /* binding */ faFolderClosed; },
/* harmony export */   "mTx": function() { return /* binding */ faChevronUp; },
/* harmony export */   "nNP": function() { return /* binding */ faLink; },
/* harmony export */   "nv$": function() { return /* binding */ faArrowDownLeftAndArrowUpRightToCenter; },
/* harmony export */   "ptq": function() { return /* binding */ faChevronDown; },
/* harmony export */   "qmU": function() { return /* binding */ faBell; },
/* harmony export */   "r5q": function() { return /* binding */ faArrowDown; },
/* harmony export */   "r8p": function() { return /* binding */ faPlus; },
/* harmony export */   "s0r": function() { return /* binding */ faMemoPad; },
/* harmony export */   "vzq": function() { return /* binding */ faLightEmergencyOn; },
/* harmony export */   "wlW": function() { return /* binding */ faArrowUpRightFromSquare; },
/* harmony export */   "xHz": function() { return /* binding */ faCircleExclamation; },
/* harmony export */   "y9Q": function() { return /* binding */ faUsersMedical; },
/* harmony export */   "yOe": function() { return /* binding */ faHandshake; },
/* harmony export */   "z1q": function() { return /* binding */ faAlignJustify; }
/* harmony export */ });
/* unused harmony exports far, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileLines, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faCalendarAlt, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDown, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faRam, faLandmarkFlag, faLips, faPencil, faPencilAlt, faBackward, faCaretRight, faComments, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faEmptySet, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faExclamationCircle, faSchoolCircleXmark, faSignOut, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faAsterisk, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faCheckSquare, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmSimple, faFilmAlt, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faLock, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faGlobePointer, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareNodes, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faHourglass2, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faFacePleading, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faFolderBookmark, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSparkles, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faAngleRight, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFaceFrownOpen, faFrownOpen, faSquareDashed, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faRaccoon, faHandPointDown, faArrowUpFromBracket, faHeadSideGear, faTrashPlus, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faPersonDressFairy, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faTruckBolt, faPizzaSlice, faMoneyBillWave, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faXRay, faGoalNet, faCoffinCross, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneTop, faPaperPlaneAlt, faSend, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faArrowUpToArc, faStarExclamation, faBooks, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileArrowUp, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faSwapArrows, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faSubtitles, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faWindowFrame, faMicrophone, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faCaretUp, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faTablets, fa360Degrees, faEthernet, faEuroSign, faEur, faEuro, faChair, faCheckCircle, faSquareDashedCirclePlus, faMoneySimpleFromBracket, faBat, faCircleStop, faStopCircle, faHeadSideHeadphones, faPhoneRotary, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faSuitcase, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faMoneyBills, faBlindsRaised, faSmog, faUfoBeam, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faEnvelopeCircleCheck, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faNewspaper, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faSort, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileNotch, faMobileIphone, faMagnifyingGlassChart, faExternalLink, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faImagePolaroidUser, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faSignatureLock, faArrowRight, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyStar, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faHeart, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faCirclePause, faPauseCircle, faGaugeCirclePlus, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faUserAstronaut, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faBadgeCheck, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faQuestionCircle, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faPen, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faFileCode, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faDiploma, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortUp, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faSpinnerThird, faFaceGrinTears, faGrinTears, faPhone, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faArrowLeft, faPersonCircleXmark, faRuler, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faFilePdf, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSparkles, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faComment, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleNodes, faParachuteBox, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faInfoCircle, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCamera, faCameraAlt, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileCertificate, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformLines, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClock, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faCaretDown, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faOutlet, faSliders, faSlidersH, faCauldron, faPeople, faFolderTree, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faSwap, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faDownload, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faStop, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faPersonSimple, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faEnvelopeDot, faEnvelopeBadge, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faMedal, faPersonFairy, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faPodcast, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faMapMarkerAlt, faCrab, faBoxOpenFull, faBoxFull, faFile, faGreaterThan, faQuotes, faPretzel, faPersonSwimming, faSwimmer, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faGrillHot, faBallotCheck, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faPlay, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faRupiahSign, faSearch, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faTasks, faDiagramSubtask, faJugDetergent, faUserCircle, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faKeynote, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faAdd, faExpand, faComputer, faFort, faCloudCheck, faMultiply, faRemove, faTimes, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faArrowLeftFromArc, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faRocket, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faArrowLeftToArc, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercent, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faRobot, faPeace, faPartyHorn, faGears, faCogs, faSunBright, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faBuilding, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faSubtitlesSlash, faQrcode, faDiceD10, faFireplace, faBrowser, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faPenLine, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faBoxHeart, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faLighthouse, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faPlusCircle, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faBook, faUserPlus, faIceSkate, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faExclamationTriangle, faWarning, faNoteMedical, faDatabase, faDownLeft, faShare, faArrowTurnRight, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faColumns3, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faTimesCircle, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faThumbsUp, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faArrowDownFromArc, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faStickyNote, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faFaceSadSweat, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faShieldKeyhole, faBarcode, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faGraduationCap, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt */
var prefix = "far";
var fa0 = {
  prefix: 'far',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 80C98.1 80 48 130.1 48 192V320c0 61.9 50.1 112 112 112s112-50.1 112-112V192c0-61.9-50.1-112-112-112z"]
};
var fa1 = {
  prefix: 'far',
  iconName: '1',
  icon: [256, 512, [], "31", "M152 56c0-8.7-4.7-16.7-12.3-21s-16.9-4-24.3 .5l-104 64c-11.3 6.9-14.8 21.7-7.9 33s21.7 14.8 33 7.9L104 98.9V432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H128 232c13.3 0 24-10.7 24-24s-10.7-24-24-24H152V56z"]
};
var fa2 = {
  prefix: 'far',
  iconName: '2',
  icon: [320, 512, [], "32", "M147.5 80c-26.6 0-52.2 10.6-71 29.4L41 145c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L42.6 75.5C70.4 47.6 108.2 32 147.5 32h7.3C232.8 32 296 95.2 296 173.2c0 39.1-16.2 76.4-44.7 103.1L84.8 432H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-9.9 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L218.5 241.2c18.8-17.6 29.5-42.2 29.5-68c0-51.5-41.7-93.2-93.2-93.2h-7.3z"]
};
var fa3 = {
  prefix: 'far',
  iconName: '3',
  icon: [320, 512, [], "33", "M0 56C0 42.7 10.7 32 24 32H280c9.8 0 18.6 6 22.3 15.1s1.4 19.5-5.7 26.3L147.7 216H188c72.9 0 132 59.1 132 132s-59.1 132-132 132H97.4c-39.4 0-75.4-22.3-93-57.5l-1.9-3.8c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l1.9 3.8c9.5 19 28.9 31 50.1 31H188c46.4 0 84-37.6 84-84s-37.6-84-84-84H88c-9.8 0-18.6-6-22.3-15.1s-1.4-19.5 5.7-26.3L220.3 80H24C10.7 80 0 69.3 0 56z"]
};
var fa4 = {
  prefix: 'far',
  iconName: '4',
  icon: [384, 512, [], "34", "M189.2 67.2c6.2-11.7 1.7-26.2-10-32.4s-26.2-1.7-32.4 10l-144 272c-3.9 7.4-3.7 16.4 .6 23.6S15.6 352 24 352H272V456c0 13.3 10.7 24 24 24s24-10.7 24-24V352h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H320V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V304H63.9L189.2 67.2z"]
};
var fa5 = {
  prefix: 'far',
  iconName: '5',
  icon: [320, 512, [], "35", "M32.4 51.9C34.4 40.4 44.3 32 56 32H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H76.2L52.5 216H188c72.9 0 132 59.1 132 132s-59.1 132-132 132H92.5c-36.4 0-69.6-20.5-85.9-53.1l-4.1-8.2c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l4.1 8.2C57.7 421.7 74.3 432 92.5 432H188c46.4 0 84-37.6 84-84s-37.6-84-84-84H24c-7.1 0-13.8-3.1-18.4-8.6S-.9 242.9 .4 235.9l32-184z"]
};
var fa6 = {
  prefix: 'far',
  iconName: '6',
  icon: [320, 512, [], "36", "M272 320c0-61.9-50.1-112-112-112c-32.3 0-61.5 13.7-81.9 35.6l-5.1 6.3C56.8 269.7 48 294.5 48 320c0 61.9 50.1 112 112 112s112-50.1 112-112zM145.7 160.6c4.7-.4 9.5-.6 14.3-.6c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-41.5 15.8-79.4 41.8-107.8L181.4 40.8c8.4-10.3 23.5-11.8 33.8-3.4s11.8 23.5 3.4 33.8l-72.9 89.5z"]
};
var fa7 = {
  prefix: 'far',
  iconName: '7',
  icon: [320, 512, [], "37", "M0 56C0 42.7 10.7 32 24 32H296c8.6 0 16.6 4.7 20.9 12.2s4.1 16.8-.3 24.2l-240 400c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9L253.6 80H24C10.7 80 0 69.3 0 56z"]
};
var fa8 = {
  prefix: 'far',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 156c0-68.5-55.5-124-124-124H140C71.5 32 16 87.5 16 156c0 37.7 16.8 71.4 43.3 94.2C23.7 272 0 311.2 0 356c0 68.5 55.5 124 124 124h72c68.5 0 124-55.5 124-124c0-44.8-23.7-84-59.3-105.8C287.2 227.4 304 193.7 304 156zM180.1 280H196c42 0 76 34 76 76s-34 76-76 76H124c-42 0-76-34-76-76s34-76 76-76h15.9c0 0 0 0 .1 0h40c0 0 0 0 .1 0zm0-48c0 0 0 0 0 0H140c0 0 0 0 0 0c-42 0-76-34-76-76c0-42 34-76 76-76l40 0c42 0 76 34 76 76c0 42-34 76-76 76z"]
};
var fa9 = {
  prefix: 'far',
  iconName: '9',
  icon: [320, 512, [], "39", "M48 192c0 61.9 50.1 112 112 112c32.3 0 61.5-13.7 81.9-35.6l5.1-6.3C263.2 242.3 272 217.5 272 192c0-61.9-50.1-112-112-112S48 130.1 48 192zM174.3 351.4c-4.7 .4-9.5 .6-14.3 .6C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 41.5-15.8 79.4-41.8 107.8L138.6 471.2c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l72.9-89.5z"]
};
var faFillDrip = {
  prefix: 'far',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M39 7C48.4-2.3 63.6-2.3 73 7l89.4 89.4 58.7-58.7c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8l97.8-97.8L39 41C29.7 31.6 29.7 16.4 39 7zM231 233l-68.7-68.7L64.6 262.1c-7.3 7.3-11.8 16.4-13.4 25.9H409.4l31-31c9.4-9.4 9.4-24.6 0-33.9L289 71.6c-9.4-9.4-24.6-9.4-33.9 0l-58.7 58.7L265 199c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"]
};
var faArrowsToCircle = {
  prefix: 'far',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", "M7 7C16.4-2.3 31.6-2.3 41 7l119 119V88c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h38.1L7 41C-2.3 31.6-2.3 16.4 7 7zM633 7c9.4 9.4 9.4 24.6 0 33.9l-119 119H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24v38.1L599 7c9.4-9.4 24.6-9.4 33.9 0zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM432 424V328c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H513.9L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119V424c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-224 0c0 13.3-10.7 24-24 24s-24-10.7-24-24V385.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96z"]
};
var faCircleChevronRight = {
  prefix: 'far',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377L345 273c9.4-9.4 9.4-24.6 0-33.9L241 135c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
var faChevronCircleRight = faCircleChevronRight;
var faWagonCovered = {
  prefix: 'far',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M569.8 4.1c45.9-3.1 79.9 41.8 64.6 85.2L567.8 278c5 4.4 8.2 10.9 8.2 18c0 12.9-10.2 23.5-23 24l0 0H542.4c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H286.9c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80H87l0 0c-12.8-.5-23-11.1-23-24c0-7.2 3.2-13.6 8.2-18L5.6 89.3C-9.7 45.9 24.3 1 70.2 4.1l119.7 8c21.6 1.4 41 10.6 55.5 24.7C258.4 23.9 276.3 16 296 16h48c19.7 0 37.6 7.9 50.6 20.8c14.5-14.1 33.9-23.3 55.5-24.7l119.7-8zM519 272L589.2 73.3C593 62.4 584.5 51.2 573 52L453.3 60c-21 1.4-37.3 18.9-37.3 39.9L416 272H519zM186.7 60L67 52c-11.5-.8-20 10.5-16.2 21.3L121 272H224V99.9c0-21.1-16.3-38.5-37.3-39.9zM368 272V88c0-13.3-10.7-24-24-24H296c-13.3 0-24 10.7-24 24V99.9 272h96zM160 416H114c5.8 22.5 23.5 40.2 46 46V416zm0-32V338c-22.5 5.8-40.2 23.5-46 46h46zm32 78c22.5-5.8 40.2-23.5 46-46H192v46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46zM448 462V416H402c5.8 22.5 23.5 40.2 46 46zm-46-78h46V338c-22.5 5.8-40.2 23.5-46 46zm124 32H480v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46z"]
};
var faLineHeight = {
  prefix: 'far',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M113.8 39.9c-4.6-5.1-11-7.9-17.8-7.9s-13.3 2.9-17.8 7.9l-72 80c-8.9 9.9-8.1 25 1.8 33.9s25 8.1 33.9-1.8L72 118.5V393.5L41.8 359.9c-8.9-9.9-24-10.7-33.9-1.8s-10.7 24-1.8 33.9l72 80c4.6 5.1 11 7.9 17.8 7.9s13.3-2.9 17.8-7.9l72-80c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L120 393.5V118.5l30.2 33.5c8.9 9.9 24 10.7 33.9 1.8s10.7-24 1.8-33.9l-72-80zM248 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H248zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H248zM224 416c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24z"]
};
var faBagel = {
  prefix: 'far',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zm-144 0c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64zM48 304a160 160 0 1 0 320 0A160 160 0 1 0 48 304zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm144-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 368a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
var faTransporter7 = {
  prefix: 'far',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", "M480 64l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288 6.6 295.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zm56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]
};
var faAt = {
  prefix: 'far',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c13.3 0 24 10.7 24 24s-10.7 24-24 24C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v28c0 50.8-41.2 92-92 92c-31.1 0-58.7-15.5-75.3-39.2C322.7 360.9 291.1 376 256 376c-66.3 0-120-53.7-120-120s53.7-120 120-120c28.8 0 55.2 10.1 75.8 27c4.3-6.6 11.7-11 20.2-11c13.3 0 24 10.7 24 24v80 28c0 24.3 19.7 44 44 44s44-19.7 44-44V256c0-114.9-93.1-208-208-208zm72 208a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faRectanglesMixed = {
  prefix: 'far',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", "M256 80c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H256zM64 32C28.7 32 0 60.7 0 96v96c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM512 80c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h64zM448 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H448zM128 352H272c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM64 368v48c0 35.3 28.7 64 64 64H272c35.3 0 64-28.7 64-64V368c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64z"]
};
var faPhoneArrowUpRight = {
  prefix: 'far',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M295 183l135-135H376c-13.3 0-24-10.7-24-24s10.7-24 24-24H488c13.3 0 24 10.7 24 24V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm34 103.6c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.2-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2z"]
};
var faPhoneArrowUp = faPhoneArrowUpRight;
var faPhoneOutgoing = faPhoneArrowUpRight;
var faTrashCan = {
  prefix: 'far',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTrashAlt = faTrashCan;
var faCircleL = {
  prefix: 'far',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H208V152z"]
};
var faHeadSideGoggles = {
  prefix: 'far',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M.6 240H48.7C52 275.9 66 308.7 87.5 335.1c13.6 16.6 24.5 38.5 24.5 63.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V398.6c0-10.7-4.8-22.2-13.7-33.1C22 330.8 3.9 287.4 .6 240zM122.8 80h93.7C234 60.4 259.6 48 288 48H257.5L256 48H224c-37.7 0-72.6 11.8-101.2 32zM64 80H52.4C93.5 31.1 155.1 0 224 0h32c48.7 0 93.2 18.1 127 48h1 24 24 32c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432 408 384 288c-28.4 0-54-12.4-71.6-32H64c-35.3 0-64-28.7-64-64s28.7-64 64-64zM464 272.4l0-.4h48l0 .4c0 35.1-28.5 63.6-63.6 63.6H448v48c0 35.3-28.7 64-64 64H320v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V424c0-13.3 10.7-24 24-24h88c8.8 0 16-7.2 16-16V312c0-13.3 10.7-24 24-24h24.4c8.6 0 15.6-7 15.6-15.6zM64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H193.3c-.9-5.2-1.3-10.5-1.3-16s.5-10.8 1.3-16H64zM384 96H288c-26.5 0-48 21.5-48 48s21.5 48 48 48h96V96zm48 0v96h32V96H432z"]
};
var faHeadVr = faHeadSideGoggles;
var faTextHeight = {
  prefix: 'far',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M48 128V80h88l0 352H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H184l0-352h88v48c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v56c0 13.3 10.7 24 24 24s24-10.7 24-24zM497 39c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23V398.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V113.9l23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L497 39z"]
};
var faUserXmark = {
  prefix: 'far',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H224 178.3zM455 143c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faUserTimes = faUserXmark;
var faFaceHandYawn = {
  prefix: 'far',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59.4-24.9 113-64.9 150.9c2.9 15.1-1.5 31.3-13.2 43l-49 49C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5V406.1C72.6 368.2 48 315 48 256zm208-48c-44.2 0-81.3 29.8-92.5 70.4l.5 0c17.9 0 33.6 9 43 22.7l47.1-47.1c18.7-18.7 49.1-18.7 67.9 0c1 1 2 2.1 3 3.2c4.7-1.1 9.5-1.5 14.3-1.2C322.6 227.4 291.6 208 256 208zM226.7 105c-8.3-10.4-23.4-12-33.7-3.7l-80 64c-10.4 8.3-12 23.4-3.7 33.7s23.4 12 33.7 3.7l80-64c10.4-8.3 12-23.4 3.7-33.7zM289 138.7l80 64c10.3 8.3 25.5 6.6 33.7-3.7s6.6-25.5-3.8-33.7l-80-64c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7zm10.3 137.9c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGaugeSimpleMin = {
  prefix: 'far',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-30.9-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56s56-25.1 56-56z"]
};
var faTachometerSlowest = faGaugeSimpleMin;
var faStethoscope = {
  prefix: 'far',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M142.5 15.6c4.7 12.4-1.6 26.2-14 30.9L85.2 62.7c-3.1 1.2-5.2 4.2-5.2 7.5V200c0 57.4 46.6 104 104 104h8 8c57.4 0 104-46.6 104-104V70.2c0-3.3-2.1-6.3-5.2-7.5L255.6 46.5c-12.4-4.7-18.7-18.5-14-30.9s18.5-18.7 30.9-14l43.2 16.2C337.5 25.9 352 46.8 352 70.2V200c0 78.5-59.5 143.1-135.8 151.1C219.9 414.1 272.1 464 336 464c66.3 0 120-53.7 120-120V268.3c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V344c0 92.8-75.2 168-168 168c-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200V70.2c0-23.3 14.5-44.2 36.3-52.4L111.6 1.5c12.4-4.7 26.2 1.6 30.9 14zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faCoffin = {
  prefix: 'far',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M48.2 145.8L133.8 48H250.2l85.6 97.8L243.9 464H140.1L48.2 145.8zM102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1H255.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9z"]
};
var faMessage = {
  prefix: 'far',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"]
};
var faCommentAlt = faMessage;
var faSalad = {
  prefix: 'far',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M416 96c-70.7 0-128 57.3-128 128c0 11 1.4 21.8 4 32H240V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V249.4L107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256H96c-53 0-96-43-96-96s43-96 96-96c8.7 0 17.2 1.2 25.3 3.4C138.5 27.7 178 0 224 0s85.5 27.7 102.7 67.4c8-2.2 16.5-3.4 25.3-3.4c28.5 0 54.2 12.5 71.8 32.2c-2.6-.2-5.2-.2-7.8-.2zM117.9 422.3c12.9 5.7 22.7 16.7 26.8 30.3c2 6.6 8.2 11.4 15.3 11.4H352c7.2 0 13.4-4.8 15.3-11.4c4-13.5 13.8-24.6 26.8-30.3c35.2-15.4 61.2-47.6 68.1-86.3H49.8c6.9 38.7 32.9 70.9 68.1 86.3zM0 315.4C0 300.3 12.3 288 27.4 288H484.6c15.1 0 27.4 12.3 27.4 27.4c0 67.4-40.6 125.4-98.6 150.8C405.5 492.7 381 512 352 512H160c-29 0-53.5-19.3-61.4-45.7C40.6 440.8 0 382.9 0 315.4zM464 224c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32H325.5c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96c0 11.2-1.9 22-5.5 32H451.8c7.6-8.5 12.2-19.7 12.2-32z"]
};
var faBowlSalad = faSalad;
var faInfo = {
  prefix: 'far',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M56 72a40 40 0 1 1 80 0A40 40 0 1 1 56 72zM16 200c0-13.3 10.7-24 24-24H96c13.3 0 24 10.7 24 24V464h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H72V224H40c-13.3 0-24-10.7-24-24z"]
};
var faRobotAstromech = {
  prefix: 'far',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M256 0C185.3 0 128 57.3 128 128v16H88c-30.9 0-56 25.1-56 56V410.9L2.1 478.3c-3.3 7.4-2.6 16 1.8 22.8S15.9 512 24 512H136c13.3 0 24-10.7 24-24V415.1l22.1 24.8c4.6 5.1 11.1 8.1 17.9 8.1H312c6.9 0 13.4-2.9 17.9-8.1L352 415.1V488c0 13.3 10.7 24 24 24H488c8.1 0 15.7-4.1 20.1-10.9s5.1-15.4 1.8-22.8L480 410.9V200c0-30.9-25.1-56-56-56H384V128C384 57.3 326.7 0 256 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM88 192h24V352 464H60.9l17-38.3c1.4-3.1 2.1-6.4 2.1-9.7V200c0-4.4 3.6-8 8-8zm72 0H352V342.9L301.2 400H210.8L160 342.9V192zm240 0h24c4.4 0 8 3.6 8 8V416c0 3.4 .7 6.7 2.1 9.7l17 38.3H400V352 192zM208 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faRingDiamond = {
  prefix: 'far',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M144 0c-8 0-15.5 4-20 10.7l-32 48c-5 7.5-5.4 17.1-1 25l31.8 57.2C51 168.6 0 238.4 0 320C0 426 86 512 192 512s192-86 192-192c0-81.6-51-151.4-122.8-179.1L293 83.7c4.4-7.9 4-17.5-1-25l-32-48C255.5 4 248 0 240 0H144zm68.8 129.1C206 128.4 199 128 192 128s-14 .4-20.8 1.1l-31.1-56L156.8 48h70.3l16.8 25.1-31.1 56zM48 320a144 144 0 1 1 288 0A144 144 0 1 1 48 320z"]
};
var faFonduePot = {
  prefix: 'far',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M319 39.8l-24 96c-2.9 11.5-11.6 20-22.2 23L264.5 192h-33l10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zm62.9 120.2L360.6 192H322.1l33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM48 320c0 61.9 50.1 112 112 112H288c61.9 0 112-50.1 112-112V272H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V280c0-4.4-3.6-8-8-8s-8 3.6-8 8v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H48v48zM0 256c0-17.7 14.3-32 32-32H400h16 32 40c13.3 0 24 10.7 24 24s-10.7 24-24 24H448v48c0 52.3-25.1 98.8-64 128v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V472.7c-15.2 4.8-31.3 7.3-48 7.3H160c-16.7 0-32.8-2.6-48-7.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V448C25.1 418.8 0 372.3 0 320V256z"]
};
var faTheta = {
  prefix: 'far',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M56 256c0-55 16.6-103.9 42.1-138.4S157.2 64 192 64s68.3 19 93.9 53.6S328 201 328 256s-16.6 103.9-42.1 138.5S226.8 448 192 448s-68.3-19-93.9-53.5S56 311 56 256zM192 16C138.4 16 91.9 45.4 59.6 89S8 191.7 8 256s19.3 123.4 51.6 167s78.9 73 132.4 73s100.1-29.4 132.4-73S376 320.3 376 256s-19.3-123.4-51.6-167S245.6 16 192 16zM120 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]
};
var faFaceHandPeeking = {
  prefix: 'far',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M496.4 145.7c.4-.5 .9-1 1.4-1.4c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0C248.5 0 183.8 29.3 137.3 76.6c7.7 1.8 14.9 5.7 20.9 11.7c6.6 6.6 10.6 14.7 12.2 23.2C208.2 72.3 261.3 48 320 48c74.4 0 139.6 39 176.4 97.7zm40.7 246c-5.4 .7-10.8 1.1-16.3 1.1H476.6C438.5 436.5 382.5 464 320 464c-79.9 0-149.3-45-184.1-111.1H119.2c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2zM352.8 264c-10.4-10.2-16.8-24.3-16.8-40c0-28.5 21.2-52 48.7-55.5c1-5.5 3.3-10.9 6.7-15.7c5.1-7.1 12.1-12.1 19.7-14.6c-6.2-1.4-12.6-2.1-19.2-2.1c-48.6 0-88 39.4-88 88c0 40.3 27.1 74.3 64.1 84.7c.1-1.4 .3-2.8 .6-4.2C358.6 297.3 352 285.4 352 272c0-2.7 .3-5.4 .8-8zM320 432c35.3 0 64-21.5 64-48s-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48zm90.3-192c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16h35.8zM248 192c0-8.8-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9H184c8.8 0 16-7.2 16-16s-7.2-16-16-16H170c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9c0 7.4-6 13.4-13.4 13.4L392 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h84c2.2 0 4 1.8 4 4s-1.8 4-4 4H408c-8.8 0-16 7.2-16 16s7.2 16 16 16l67.5 0c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5H456c-8.8 0-16 7.2-16 16s7.2 16 16 16h64.8c25.2 0 49.5-10 67.3-27.9c36.9-36.9 37.2-96.6 .8-133.8l-.8-.8L543 161.3c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19c-2.8 .3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z"]
};
var faSquareUser = {
  prefix: 'far',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16h-1c-7.9-63.1-61.7-112-127-112H192c-65.3 0-119.1 48.9-127 112H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM334.4 432H113.6c7.4-36.5 39.7-64 78.4-64h64c38.7 0 71 27.5 78.4 64zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 240a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"]
};
var faDownLeftAndUpRightToCenter = {
  prefix: 'far',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", "M296 256H444.7c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25L441.9 168 496 113.9c18.7-18.7 18.7-49.1 0-67.9L465.9 16c-18.7-18.7-49.1-18.7-67.9 0L344 70.1 316.3 42.3c-6.6-6.6-15.6-10.3-25-10.3C271.8 32 256 47.8 256 67.3V216c0 22.1 17.9 40 40 40zm95-71l23 23H304V97.9l23 23c9.4 9.4 24.6 9.4 33.9 0l71-71L462.1 80l-71 71c-9.4 9.4-9.4 24.6 0 33.9zM67.3 256C47.8 256 32 271.8 32 291.3c0 9.4 3.7 18.3 10.3 25L70.1 344 16 398.1c-18.7 18.7-18.7 49.1 0 67.9L46.1 496c18.7 18.7 49.1 18.7 67.9 0L168 441.9l27.7 27.7c6.6 6.6 15.6 10.3 25 10.3c19.5 0 35.3-15.8 35.3-35.3V296c0-22.1-17.9-40-40-40H67.3zM121 327l-23-23H208V414.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0l-71 71L49.9 432l71-71c9.4-9.4 9.4-24.6 0-33.9z"]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faExplosion = {
  prefix: 'far',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M543.2 30.2c3.1-11.6-2.8-23.7-13.9-28.3s-23.9-.4-30 9.9L344.7 274.1 311.2 145.9C308.5 135.4 298.9 128 288 128s-20.5 7.4-23.2 17.9L227.4 289.4 145 207c-7.6-7.6-19.4-9.2-28.8-3.9s-14.1 16.2-11.5 26.7l23.9 95.7-70.8-5.4c-9.2-.7-18 4-22.7 12s-4.2 18 1.1 25.6L87.7 432h58.4l-41.7-60.2 53.7 4.1c7.7 .6 15.2-2.6 20.2-8.4s6.8-13.8 4.9-21.3l-11-43.9L223 353c6.1 6.1 15 8.4 23.3 6.2s14.8-8.8 16.9-17.1l24.8-95 24.8 95c2.4 9.4 10.3 16.4 19.9 17.7s19.1-3.2 24-11.6L451.2 188 408.8 345.8c-2 7.6-.2 15.7 4.8 21.7s12.7 9.2 20.5 8.4l36.9-3.4L429.9 432h58.4l51.5-74.3c5.3-7.7 5.7-17.7 1-25.8s-13.6-12.7-22.9-11.8L464.1 325 543.2 30.2zM465.9 464H430.1l0 0H389.2c-10.8-45.9-52-80-101.2-80s-90.4 34.1-101.2 80H145.9l0 0H110.1l0 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H465.9l0 0zm-228.5 0c9-18.9 28.3-32 50.6-32s41.6 13.1 50.6 32H237.4zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24z"]
};
var faFileLines = {
  prefix: 'far',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faWaveSquare = {
  prefix: 'far',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M136 56c0-13.3 10.7-24 24-24H320c13.3 0 24 10.7 24 24V432H456V256c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H504V456c0 13.3-10.7 24-24 24H320c-13.3 0-24-10.7-24-24V80H184V256c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H136V56z"]
};
var faRing = {
  prefix: 'far',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M59.7 168c8.9-9.4 22.9-19 42.1-27.6C140 123.2 194.5 112 256 112s116 11.2 154.2 28.4c19.1 8.6 33.2 18.2 42.1 27.6c8.8 9.3 11.7 17.4 11.7 24s-2.9 14.7-11.7 24c-.8 .9-1.7 1.7-2.5 2.6C402.4 191.8 332.2 176 256 176s-146.4 15.8-193.8 42.6c-.9-.9-1.7-1.7-2.5-2.6C50.9 206.7 48 198.6 48 192s2.9-14.7 11.7-24zM464 268.6V320c0 6.6-2.9 14.7-11.7 24c-8.9 9.4-22.9 19-42.1 27.6C372 388.8 317.5 400 256 400s-116-11.2-154.2-28.4c-19.1-8.6-33.2-18.2-42.1-27.6C50.9 334.7 48 326.6 48 320V268.6c10.3 7.1 21.8 13.3 34.1 18.9C127.9 307.9 189.4 320 256 320s128.1-12.1 173.9-32.6c12.4-5.5 23.9-11.8 34.1-18.9zM0 192V320c0 22.1 10.1 41.4 24.8 57c14.6 15.4 34.5 28.2 57.4 38.5C127.9 435.9 189.4 448 256 448s128.1-12.1 173.9-32.6c22.8-10.2 42.8-23 57.4-38.5c14.7-15.6 24.8-34.9 24.8-57V192c0-22.1-10.1-41.4-24.8-57c-14.6-15.4-34.5-28.2-57.4-38.5C384.1 76.1 322.6 64 256 64S127.9 76.1 82.1 96.6C59.3 106.8 39.3 119.6 24.8 135C10.1 150.6 0 169.9 0 192zm256 80c-56.1 0-106.4-9.3-143.8-24c37.1-14.5 87.3-24 143.8-24s106.7 9.5 143.8 24c-37.4 14.7-87.7 24-143.8 24z"]
};
var faBuildingUn = {
  prefix: 'far',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM104 248h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V264c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V264zM237.3 87.1l34.7 52V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDiceThree = {
  prefix: 'far',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faTirePressureWarning = {
  prefix: 'far',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M424 0c-13.3 0-24 10.7-24 24V54.5c0 30.1 4.9 60 14.4 88.5l2.5 7.4c6.1 18.4 14.4 35.6 22.2 51.5c15 30.5 26.3 66.3 22 105.3c-4 36.7-22.3 79.2-70.5 124.8H121.4c-48.2-45.6-66.4-88.1-70.5-124.8c-4.3-39 7-74.8 22-105.3c7.8-15.8 16.1-33 22.2-51.5l2.5-7.4c9.5-28.6 14.4-58.4 14.4-88.5V24c0-13.3-10.7-24-24-24S64 10.7 64 24V54.5c0 24.9-4 49.7-11.9 73.4l-2.5 7.4c-5 15-11.9 29.6-19.7 45.4C12.7 215.5-2.5 260.9 3.2 312.4c5.5 49.7 30 102.1 84.8 154.1V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V480h48v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V466.5c54.8-51.9 79.3-104.3 84.8-154.1c5.7-51.5-9.5-96.9-26.7-131.8c-7.8-15.8-14.7-30.4-19.7-45.4l-2.5-7.4C452 104.2 448 79.4 448 54.5V24c0-13.3-10.7-24-24-24zM256 96c-13.3 0-24 10.7-24 24V232c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faWifiFair = {
  prefix: 'far',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", "M152.4 321.2C196.5 280.7 255.4 256 320 256s123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5zM320 480a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faWifi2 = faWifiFair;
var faCalendarDays = {
  prefix: 'far',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"]
};
var faCalendarAlt = faCalendarDays;
var faMp3Player = {
  prefix: 'far',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M320 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM192 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM112 80c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32H272c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H112z"]
};
var faAnchorCircleCheck = {
  prefix: 'far',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V464H240c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h48 48c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5H312V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faTally4 = {
  prefix: 'far',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", "M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 13.3 10.7 24 24 24s24-10.7 24-24V64zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 13.3 10.7 24 24 24s24-10.7 24-24V64zM384 40c-13.3 0-24 10.7-24 24V448c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM536 64c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 13.3 10.7 24 24 24s24-10.7 24-24V64z"]
};
var faRectangleHistory = {
  prefix: 'far',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M464 224c0-8.8-7.2-16-16-16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224zm-16-64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0zm-8-80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0z"]
};
var faBuildingCircleArrowRight = {
  prefix: 'far',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", "M64 48H320c8.8 0 16 7.2 16 16V294.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1V448c0 8.8-7.2 16-16 16H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H232zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faVolleyball = {
  prefix: 'far',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M371.5 429c-71.4 7-145.1-8.2-210-47.1c-8.8 14.8-16.2 30.3-22.3 46.3C172.5 450.8 212.7 464 256 464c42.7 0 82.5-12.9 115.5-35zm60.1-61.5c9.2-14.4 16.6-30.1 22.1-46.7c-65.9 7.3-134.5-4.3-197.1-37.1c-25.9 16.5-48.4 36.5-67.2 58.9c75.2 43.8 163.6 51 242.3 24.9zm31.8-96.4c.4-5 .5-10 .5-15.1c0-77.9-42.8-145.8-106.3-181.5c35.6 58.4 54.2 127.7 49.6 200.3c18.8 .5 37.6-.7 56.1-3.8zM101 394.7C127.6 334 172 280.5 231.7 242.7c-1.3-30-7.1-58.9-16.8-85.9C140.2 189.5 85.7 249.6 58.1 320.3c9 27.9 23.8 53.1 42.9 74.5zm-52-159.9C84.1 182.9 133.8 140 195.2 113c-8.7-15.7-18.7-30.4-29.9-44.2C101.9 99.6 56.5 161.6 49.1 234.8zM213.3 52.4c39.3 53.4 63.5 118.6 66.4 189.2c25.7 13.4 52.6 22.6 79.9 27.9c4.6-84.1-26.8-163-81.5-220.4c-7.2-.8-14.6-1.2-22.1-1.2c-14.6 0-28.9 1.5-42.7 4.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 0l0 0h0l0 0z"]
};
var faVolleyballBall = faVolleyball;
var faSunHaze = {
  prefix: 'far',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", "M439.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L320 61.1 237.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L83.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L125.1 256l0 0h53.2c0-4.8-1.4-9.5-4.2-13.6l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L306.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L466 242.4c-2.8 4.1-4.2 8.9-4.2 13.6h53.2l0 0 56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L439.7 19.7zM432 256c0-61.9-50.1-112-112-112s-112 50.1-112 112v0h48v0c0-35.3 28.7-64 64-64s64 28.7 64 64v0h48v0zm184 32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-208 0H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H408c13.3 0 24-10.7 24-24s-10.7-24-24-24zM576 400c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24zM88 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zm208 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H296z"]
};
var faTextSize = {
  prefix: 'far',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M48 128V80H168l0 352H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H216l0-352H336v48c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v56c0 13.3 10.7 24 24 24s24-10.7 24-24zM360 296V272h96l0 160H424c-13.3 0-24 10.7-24 24s10.7 24 24 24H536c13.3 0 24-10.7 24-24s-10.7-24-24-24H504l0-160h88v24c0 13.3 10.7 24 24 24s24-10.7 24-24V264c0-22.1-17.9-40-40-40H352c-22.1 0-40 17.9-40 40v32c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faUfo = {
  prefix: 'far',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", "M176.6 246.3c-17.5 16.4-17.5 16.4-17.5 16.5l0 0 0 .1 .1 .1 .3 .3c.2 .2 .4 .4 .7 .7c.6 .5 1.3 1.2 2.2 2.1c1.8 1.6 4.3 3.7 7.6 6.2c6.6 4.8 16.1 10.9 29.1 16.8c26.1 11.9 65.3 23 120.8 23s94.7-11.1 120.8-23c13-5.9 22.6-12 29.1-16.8c3.3-2.4 5.8-4.5 7.6-6.2c.9-.8 1.6-1.5 2.2-2.1c.3-.3 .5-.5 .7-.7l.3-.3 .1-.1 0-.1 0 0c0 0 0 0-17.5-16.5l17.5 16.4c3.7-3.9 6-9 6.4-14.4c.5-5.8 .7-11.6 .6-17.2c30 8.9 54.6 19.9 72.5 31.8c24.1 16.2 31.5 30.9 31.5 41.6c0 7.9-3.8 17.7-15.8 29.1c-12 11.5-30.8 23-55.8 33.1C470.3 387 399.4 400 320 400s-150.3-13-200.3-33.2c-25.1-10.1-43.8-21.6-55.8-33.1C51.8 322.2 48 312.4 48 304.5c0-10.7 7.4-25.4 31.5-41.6c17.9-12 42.4-23 72.5-31.8c-.1 5.7 .1 11.4 .6 17.2c.5 5.4 2.7 10.5 6.4 14.4l17.5-16.4zm302.8-67.2C456.8 110.9 392.6 64 320 64s-136.8 46.9-159.4 115.1c-42.7 10.5-80 25.4-107.8 44C23.4 242.9 0 270.2 0 304.5c0 25.1 12.7 46.7 30.7 63.9c17.9 17.1 42.6 31.4 71 42.9C158.8 434.3 236 448 320 448s161.2-13.7 218.3-36.7c28.5-11.5 53.1-25.8 71-42.9c18-17.1 30.7-38.7 30.7-63.9c0-34.3-23.4-61.7-52.8-81.4c-27.8-18.6-65.1-33.5-107.8-44zM440 234.6c-4.1 2.9-10.4 6.8-19.1 10.8c-19.6 8.9-52 18.7-100.9 18.7s-81.3-9.7-100.9-18.7c-8.7-4-15-7.9-19.1-10.8C199.2 164.7 255 112 320 112s120.8 52.7 120 122.6zM152 312a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFork = {
  prefix: 'far',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M398.4 43.2c10.6-8 12.8-23 4.8-33.6s-23-12.8-33.6-4.8l-122.7 92c-4.4 3.3-8.6 7-12.6 10.9l-1.9 1.9c-20.8 20.8-32.5 49-32.5 78.4c0 24.5 8.1 48.1 22.8 67.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L256.7 289.2C275.9 303.9 299.5 312 324 312c29.4 0 57.6-11.7 78.4-32.5l1.9-1.9c3.9-3.9 7.6-8.1 10.9-12.6l92-122.7c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8l-92 122.7c-2 2.6-4.1 5.1-6.4 7.4l-1.9 1.9C356.7 257.4 340.7 264 324 264s-32.7-6.6-44.5-18.4l-6.5-6.5c0 0 0 0 0 0s0 0 0 0l-6.5-6.5C254.6 220.7 248 204.7 248 188s6.6-32.7 18.4-44.5l1.9-1.9c2.3-2.3 4.8-4.5 7.4-6.4l122.7-92zM457 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L307 171c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L457 89z"]
};
var faUtensilFork = faFork;
var faArrowsUpToLine = {
  prefix: 'far',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", "M24 80l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80zM7 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63L104 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 135c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7L7 239zM327 273c9.4 9.4 24.6 9.4 33.9 0l63-63L424 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 135c-9.4-9.4-24.6-9.4-33.9 0L327 239c-9.4 9.4-9.4 24.6 0 33.9z"]
};
var faMobileSignal = {
  prefix: 'far',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", "M64 48H288c8.8 0 16 7.2 16 16V298.7c14.5-14.1 30.6-26.5 48-37V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H224V488c0-8.1 .4-16.1 1.1-24H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM488 256c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24z"]
};
var faBarcodeScan = {
  prefix: 'far',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", "M88 32C74.7 32 64 42.7 64 56V192h48V56c0-13.3-10.7-24-24-24zM64 456c0 13.3 10.7 24 24 24s24-10.7 24-24V320H64V456zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16V320H160V464zm64-8c0 13.3 10.7 24 24 24s24-10.7 24-24V320H224V456zm0-400V192h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zM336 456c0 13.3 10.7 24 24 24s24-10.7 24-24V320H336V456zm0-400V192h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zM464 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320H464V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24s24-10.7 24-24V320H528V456zm0-400V192h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zM160 192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V192zM0 256c0 13.3 10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232c-13.3 0-24 10.7-24 24z"]
};
var faSortDown = {
  prefix: 'far',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", "M160 425.4L70.6 336H249.4L160 425.4zm-22.6 45.3c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
};
var faSortDesc = faSortDown;
var faFolderArrowDown = {
  prefix: 'far',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24V302.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V200z"]
};
var faFolderDownload = faFolderArrowDown;
var faCircleMinus = {
  prefix: 'far',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faMinusCircle = faCircleMinus;
var faFaceIcicles = {
  prefix: 'far',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M256 48C141.1 48 48 141.1 48 256c0 1.4-.1 2.7-.3 4l-15 180c-.4 4.5-4.1 8-8.7 8s-8.3-3.5-8.7-8L.3 260c-.2-1.3-.3-2.6-.3-4C0 114.6 114.6 0 256 0S512 114.6 512 256c0 1-.1 2-.2 3L496.5 504c-.3 4.5-4 8-8.5 8s-8.2-3.5-8.5-8L464.2 259c-.1-1-.2-2-.2-3c0-114.9-93.1-208-208-208zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l-8.9 86.7c-.5 5.3-5 9.3-10.3 9.3s-9.7-4-10.3-9.3l-7.3-70.8c-.8 0-1.6 .1-2.5 .1H317.3l-6.5 38.8c-.9 5.3-5.5 9.2-10.9 9.2s-10-3.9-10.9-9.2L282.7 400H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 512c-75.5 0-143.3-32.7-190.2-84.6L72 353.1C106.9 419.1 176.2 464 256 464c3.5 0 6.9-.1 10.3-.3c7.9 10 20.2 16.3 33.7 16.3c7.9 0 15.4-2.2 21.9-6c1 10.1 5.6 19.1 12.4 25.8c-24.7 7.9-51 12.2-78.3 12.2zm151.3-49.5l7.4-72c8.9-10.5 16.8-21.9 23.5-34.1l4.7 74.6c-10.8 11.6-22.8 22.2-35.6 31.6z"]
};
var faShovel = {
  prefix: 'far',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", "M375 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9l-44.1 44.1c-17.2 17.2-40.6 26.9-65 26.9c-16.7 0-32.3-4.4-45.8-12.2L241 305l56.4 56.4c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32V386.3c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0L207 271 316.2 161.9c-7.8-13.5-12.2-29.1-12.2-45.8c0-24.4 9.7-47.7 26.9-65L375 7zm17 50.9L364.9 85.1c-8.2 8.2-12.9 19.4-12.9 31c0 24.2 19.6 43.9 43.9 43.9c11.6 0 22.8-4.6 31-12.9L454.1 120 392 57.9zM125.7 464c29.7 0 58.2-11.8 79.2-32.8L252.1 384 128 259.9 80.8 307.1c-21 21-32.8 49.5-32.8 79.2V464h77.7z"]
};
var faDoorOpen = {
  prefix: 'far',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", "M272 49.7V464H112l0-371.2L272 49.7zM320 464V42.4C320 19 301 0 277.6 0c-3.7 0-7.4 .5-11 1.5L99.5 46.4C78.6 52.1 64 71.1 64 92.8V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64 96h16H272h48V464zM224 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM352 112H456c4.4 0 8 3.6 8 8V488c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H512V120c0-30.9-25.1-56-56-56H352v48z"]
};
var faFilms = {
  prefix: 'far',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M256 264V232H416v32 72H256V264zm0-80V152 80H416v72 32H256zM440 32H416 256 232 208 160c-35.3 0-64 28.7-64 64v32 24 24 64 24 24 32c0 35.3 28.7 64 64 64h48 24 24H416h24 24 48c35.3 0 64-28.7 64-64V288 264 240 176 152 128 96c0-35.3-28.7-64-64-64H464 440zM160 80h48v48H144V96c0-8.8 7.2-16 16-16zm-16 96h64v32 32H144V176zm0 112h64v48H160c-8.8 0-16-7.2-16-16V288zm368 48H464V288h64v32c0 8.8-7.2 16-16 16zm16-96H464V208 176h64v64zm0-112H464V80h48c8.8 0 16 7.2 16 16v32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faRightFromBracket = {
  prefix: 'far',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M352 146.2L462 256 352 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM512 256c0-11.5-4.6-22.5-12.7-30.6L383.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L499.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z"]
};
var faSignOutAlt = faRightFromBracket;
var faFaceGlasses = {
  prefix: 'far',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M256 464C141.1 464 48 370.9 48 256c0-1.8 0-3.5 .1-5.3C49.5 280.4 74 304 104 304h80c30.9 0 56-25.1 56-56V200c0-2.7-.2-5.4-.6-8h33.1c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30 0 54.5-23.6 55.9-53.3c0 1.8 .1 3.5 .1 5.3c0 114.9-93.1 208-208 208zM224 160.8c-10.2-10.4-24.3-16.8-40-16.8H104c-10.1 0-19.6 2.7-27.8 7.4C112.2 89.6 179.3 48 256 48s143.8 41.6 179.8 103.4c-8.2-4.7-17.7-7.4-27.8-7.4H328c-15.7 0-29.8 6.4-40 16.8V160H224v.8zM256 512c141.4 0 256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c5.1-2.7 8.5-8 8.5-14.2c0-8.8-7.2-16-16-16h-2.6C455.4 66.2 363.4 0 256 0S56.6 66.2 18.6 160H16c-8.8 0-16 7.2-16 16c0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256C0 397.4 114.6 512 256 512zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zM304 200c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V200zM104 176h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24zm88.4 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faNfc = {
  prefix: 'far',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM272 256c0-17.8-9.7-33.3-24-41.6V160h72V352H128V160h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-22.1 0-40 17.9-40 40V360c0 22.1 17.9 40 40 40H328c22.1 0 40-17.9 40-40V152c0-22.1-17.9-40-40-40H240c-22.1 0-40 17.9-40 40v62.4c-14.3 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48z"]
};
var faAtom = {
  prefix: 'far',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", "M306.3 417.2c-16.3-4.7-33.1-10.9-50.3-18.4c-17.1 7.5-34 13.6-50.3 18.4C224.1 455.5 243.1 464 256 464s31.9-8.5 50.3-46.8zM293 325.7c14.8-8.9 28.7-18.1 41.4-27.6c1-13.5 1.6-27.6 1.6-42.1s-.5-28.6-1.6-42.1c-12.8-9.4-26.6-18.7-41.4-27.6c-12.5-7.5-24.9-14.2-37-20.2c-12.1 6-24.5 12.7-37 20.2c-14.8 8.9-28.7 18.1-41.4 27.6c-1 13.5-1.6 27.6-1.6 42.1s.5 28.6 1.6 42.1c12.8 9.4 26.6 18.7 41.4 27.6c12.5 7.5 24.9 14.2 37 20.2c12.1-6 24.5-12.7 37-20.2zm120.5-32.2c-10.2 10.2-21.3 20.2-33.4 29.9c-2.4 20.1-5.8 39.2-10.3 57c37.2 2.2 51.9-9.1 57.8-19.7c6.5-11.7 8.2-32.8-14.1-67.2zM469.6 128c20.7 37.1 9.4 82.8-23.6 128c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2zM84.4 360.7c5.9 10.6 20.6 22 57.8 19.7c-4.5-17.8-7.9-36.9-10.3-57c-12-9.7-23.2-19.8-33.4-29.9C76.2 327.8 77.8 349 84.4 360.7zM98.5 218.5c10.2-10.2 21.3-20.2 33.4-29.9c2.4-20.1 5.8-39.2 10.3-57c-37.2-2.3-51.9 9.1-57.8 19.7c-6.5 11.7-8.2 32.8 14.1 67.2zM256 113.2c17.1-7.5 34-13.6 50.3-18.4C287.9 56.5 268.9 48 256 48s-31.9 8.5-50.3 46.8c16.3 4.7 33.1 10.9 50.3 18.4zm124.2 75.4c12 9.7 23.2 19.8 33.4 29.9c22.3-34.3 20.6-55.5 14.1-67.2c-5.9-10.6-20.6-22-57.8-19.7c4.5 17.8 7.9 36.9 10.3 57zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSoap = {
  prefix: 'far',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96 192H209.1c2.5 17.7 9.2 34 18.9 48H96c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48V288c0-26.5-21.5-48-48-48h-4.1c9.6-13.7 16.1-29.6 18.8-46.9c46 7.1 81.3 46.9 81.3 94.9V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V288c0-53 43-96 96-96zm224 96h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H160c-35.3 0-64-28.7-64-64s28.7-64 64-64H320zM128 352c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM320 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faIcons = {
  prefix: 'far',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", "M59.6 54.4c11.1-9.4 30.8-8.7 43.5 3.7l8 8.1 17.5 17.8 17.1-18.3 7.3-7.8c12.5-12 31.7-13.1 43.8-3.4c14.2 12.1 14.8 33.3 2 46.2l0 0-70.7 70.8-71-70.8 0 0C44.3 87.9 44.9 66.6 59.5 54.5l0 0 .1-.1zM28.8 17.6C-7.7 47.9-9.4 102 23.1 134.6l0 0L101.7 213c14.7 15.1 38.3 14.1 52.5 .4l0 0 .3-.3 78.3-78.5 0 0C265.4 102 263.6 48 227.6 17.7l0 0-.3-.3c-29.9-24.3-71-21.9-99.3-1C99.7-4.4 58.2-7 28.8 17.6zM512 24c0-7.2-3.2-14-8.8-18.6s-12.9-6.4-19.9-5l-160 32C312.1 34.7 304 44.6 304 56V161.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V75.7L464 53.3v76.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V24zM106.9 309.5l2.7-5.5h68.7l2.7 5.5c8.1 16.3 24.8 26.5 42.9 26.5c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16c18.2 0 34.8-10.3 42.9-26.5zM224 288l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H99.8c-12.1 0-23.2 6.8-28.6 17.7L64 288c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64zM192 392a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM473.4 259.1c-6-4.4-14.3-4-19.9 .9l-128 112c-5 4.4-6.8 11.4-4.4 17.7s8.3 10.4 15 10.4h55.7l-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7s-8.3-10.4-15-10.4H440.3l38.4-89.7c2.9-6.9 .7-14.9-5.3-19.2z"]
};
var faHeartMusicCameraBolt = faIcons;
var faMicrophoneLinesSlash = {
  prefix: 'far',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", "M472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7zM272 187.9V96c0-26.5 21.5-48 48-48s48 21.5 48 48H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64c0 2.3-.2 4.6-.5 6.8L272 187.9zm86.2 190.3C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z"]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faClosedCaptioningSlash = {
  prefix: 'far',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80H544c8.8 0 16 7.2 16 16V413.6l-92.1-72.2c10.5-5.4 19.9-12.7 27.7-21.4c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-1.4 0-2.7-.1-4.1-.2l-41.4-32.5c-1.6-4.8-2.5-10-2.5-15.4c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-45.4 0-83.4 31.5-93.4 73.8l-22.4-17.5c2.9-8.1 1.5-17.4-4.7-24.3c-16.6-18.5-40.4-30.6-67-31.9L134.4 80zm353 400l-60.9-48H96c-8.8 0-16-7.2-16-16V159L32 121.2V416c0 35.3 28.7 64 64 64H487.4zM295 328.4l-39.1-30.8c-7 4.1-15.2 6.4-23.9 6.4c-26.5 0-48-21.5-48-48c0-4.7 .7-9.2 1.9-13.5l-39.1-30.8C139.9 224.9 136 240 136 256c0 53 43 96 96 96c24.1 0 46.2-8.9 63-23.6z"]
};
var faCalculatorSimple = {
  prefix: 'far',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M256 0c13.3 0 24 10.7 24 24V232H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H232V24c0-13.3 10.7-24 24-24zM400 32c13.3 0 24 10.7 24 24V88h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H424v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V136H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V56c0-13.3 10.7-24 24-24zM55.4 343.4c9.4-9.4 24.6-9.4 33.9 0L112 366.1l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L145.9 400l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L112 433.9 89.4 456.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L78.1 400 55.4 377.4c-9.4-9.4-9.4-24.6 0-33.9zM64 88h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H64c-13.3 0-24-10.7-24-24s10.7-24 24-24zM352 336h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCalculatorAlt = faCalculatorSimple;
var faBridgeCircleCheck = {
  prefix: 'far',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H256 496h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H536V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240H304c-57.4 0-104 46.6-104 104v88H152V336c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48V440c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V344c0-30.9 25.1-56 56-56h32c1.1 0 2.1 0 3.1 .1zM488 80v64H408V80h80zM360 80v64H280V80h80zM232 80v64H152V80h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
var faSlidersUp = {
  prefix: 'far',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M96 0c13.3 0 24 10.7 24 24V83.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V236.3C39.5 226.1 16 195.8 16 160s23.5-66.1 56-76.3V24C72 10.7 82.7 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V428.3c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3V24c0-13.3 10.7-24 24-24s24 10.7 24 24V275.7c32.5 10.2 56 40.5 56 76.3zM448 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8 76.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V268.3c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3V24c0-13.3 10.7-24 24-24s24 10.7 24 24v91.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3z"]
};
var faSlidersV = faSlidersUp;
var faLocationMinus = {
  prefix: 'far',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM120 168H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMapMarkerMinus = faLocationMinus;
var faPumpMedical = {
  prefix: 'far',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", "M168 0h48c25.4 0 46.8 16.9 53.7 40h46.4c19.1 0 37.4 7.6 50.9 21.1L409 103c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L333.1 95c-4.5-4.5-10.6-7-17-7H272v40H224V56c0-4.4-3.6-8-8-8H168c-4.4 0-8 3.6-8 8v72H112V56c0-30.9 25.1-56 56-56zM101.5 222.7l-18.7 224C82.1 456 89.4 464 98.8 464H285.2c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7H117.4c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM216 296v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V296c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFingerprint = {
  prefix: 'far',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM352 256c0-53-43-96-96-96s-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256zm-96-24c-13.3 0-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256c0-13.3-10.7-24-24-24z"]
};
var faSkiBoot = {
  prefix: 'far',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M364.1 .3c13.1 2.2 21.8 14.6 19.6 27.7l-45 262.4L449 345.7c19 9.5 31 28.9 31 50.1V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H456 63.2c-35.4 0-61.9-32.5-54.9-67.2L88.5 51.2C90.8 40 100.6 32 112 32H334.3l2.1-12.1C338.6 6.9 351-1.9 364.1 .3zM202.4 80H131.6L97.7 246.4c37.7-27.1 79.9-76.4 104.7-166.4zm33.1 0C203.5 204.3 140 262.5 88.9 289.4l-33.6 165c-1 5 2.8 9.6 7.8 9.6H432V395.8c0-3-1.7-5.8-4.4-7.2L301.3 325.5c-2.8-1.4-5.2-3.3-7.2-5.5H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.4l11-64H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h50.8L326.1 80H235.5z"]
};
var faStandardDefinition = {
  prefix: 'far',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 184V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328c-13.3 0-24 10.7-24 24zm48 24h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208zm-189.8 4.5c.7-.7 2.1-1.9 5.4-2.9c7.1-2.3 18.8-2.9 35.5-.6c5.1 .7 21 3.3 25.6 4.4c12.9 2.9 25.8-5.1 28.7-18.1s-5.1-25.8-18.1-28.7c-6.6-1.5-24.1-4.4-29.9-5.2c-19-2.5-39.3-3.1-56.7 2.5c-19.2 6.2-34.9 20.3-39.6 43.5c-.1 .4-.2 .9-.2 1.3c-1.7 11.7-.3 23 5.2 33.2c5.3 9.9 13.3 16.7 21.1 21.3c13.9 8.3 32 12.5 45.5 15.6l1.8 .4c16.1 3.8 26.9 6.5 33.6 10.5c1.4 .8 2.2 1.5 2.7 2c.5 .4 .6 .7 .6 .7c0 0 .1 .1 .1 .5c.1 .4 .1 1.4-.1 3.2c-.4 2.4-1 3.2-1.3 3.5c-.4 .5-1.8 1.6-5.1 2.7c-7.3 2.3-19.5 2.8-36.2 .6c-7.2-1-20-4.7-31.1-8l0 0 0 0c-2.6-.7-5-1.5-7.3-2.1c-12.7-3.6-26 3.7-29.7 16.5s3.7 26 16.5 29.7c1.4 .4 3.2 .9 5.3 1.5c10.8 3.2 28.6 8.4 39.7 9.9l.1 0c19 2.5 39.6 3.2 57.1-2.4c9.1-2.9 18.2-7.7 25.6-15.6c7.6-8.1 12.1-18.1 13.8-29.3c1.7-11.7 .3-23-5.2-33.2c-5.3-9.9-13.3-16.7-21.1-21.3c-13.9-8.3-32-12.5-45.5-15.6l-1.8-.4c-16.1-3.8-26.9-6.5-33.6-10.5c-1.4-.8-2.2-1.5-2.7-2c-.5-.4-.6-.7-.6-.7l0 0c0 0-.1-.1-.1-.5s-.1-1.2 0-2.5c.5-2.3 1.3-3.3 1.8-3.8z"]
};
var faRectangleSd = faStandardDefinition;
var faH1 = {
  prefix: 'far',
  iconName: 'h1',
  icon: [576, 512, [], "f313", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zm456 0c0-8.5-4.5-16.4-11.8-20.7s-16.4-4.4-23.8-.3l-72 40c-11.6 6.4-15.8 21-9.3 32.6s21 15.8 32.6 9.3L456 128.8V400H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H504V88z"]
};
var faHandPointRight = {
  prefix: 'far',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"]
};
var faMagnifyingGlassLocation = {
  prefix: 'far',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm80-240c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faMessageBot = {
  prefix: 'far',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M272 368H224 160c-8.8 0-16-7.2-16-16V192 64c0-8.8 7.2-16 16-16H480c8.8 0 16 7.2 16 16V192 352c0 8.8-7.2 16-16 16H373.3h-16l-12.8 9.6L272 432V416 368zM96 208V352c0 35.3 28.7 64 64 64h16 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76H480c35.3 0 64-28.7 64-64V208h36.3c5.5 9.6 15.9 16 27.7 16c17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H544V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V176H59.7c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16H96zm80-80V256c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32zm32 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faForwardStep = {
  prefix: 'far',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", "M240 88c0-13.3 10.7-24 24-24s24 10.7 24 24V226.7v58.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V318.9L63.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4C29.5 448 16 434.5 16 417.9V94.1C16 77.5 29.5 64 46.1 64c6.2 0 12.2 1.9 17.3 5.4L240 193.1V88zm0 172.3v-8.6L64 128.5v255L240 260.3z"]
};
var faStepForward = faForwardStep;
var faFaceSmileBeam = {
  prefix: 'far',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faSmileBeam = faFaceSmileBeam;
var faLightCeiling = {
  prefix: 'far',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V161.1C112.4 172.2 16.7 265.6 2 384.1C-.2 401.6 14.3 416 32 416H480c17.7 0 32.2-14.4 30-31.9c-14.7-118.5-110.5-211.8-230-223V24zM458.4 368H53.6C75.2 276.3 157.7 208 256 208s180.8 68.3 202.4 160zM256 512c35.3 0 64-28.7 64-64H192c0 35.3 28.7 64 64 64z"]
};
var faMessageExclamation = {
  prefix: 'far',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCommentAltExclamation = faMessageExclamation;
var faBowlScoop = {
  prefix: 'far',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M32 224H416c0-106-86-192-192-192S32 118 32 224zM173.8 368h-2.2H145c-41.4 0-77.2-26.3-90.5-64H393.5c-13.3 37.7-49.1 64-90.5 64H276.3h-2.2H173.8zm36.9 78.7L224 430.8l13.3 15.9L251.7 464H196.3l14.4-17.3zm92.3 3.9L274.2 416H303c10.6 0 20.9-1.1 30.9-3.3c58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8c10 2.2 20.3 3.3 30.9 3.3h28.8L145 450.6l-10.9 13.1-.3 .3-.4 .5L128 471l-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2h19.2 8.5 .6H291.7h.6 8.5H320c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3L303 450.6z"]
};
var faBowlShavedIce = faBowlScoop;
var faSquareX = {
  prefix: 'far',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm154.3 40.5L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"]
};
var faUtilityPoleDouble = {
  prefix: 'far',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V80H128V56c0-13.3-10.7-24-24-24S80 42.7 80 56V80H64.2c-.2 0-.3 0-.5 0H48V56c0-13.3-10.7-24-24-24S0 42.7 0 56V88c0 22.1 17.9 40 40 40H83.2L232 227.2V272H128V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H64.2c-.2 0-.3 0-.5 0H48V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 22.1 17.9 40 40 40H83.2L232 419.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V419.2L428.8 320H472c22.1 0 40-17.9 40-40V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H448.2c-.2 0-.3 0-.5 0H432V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H280V227.2L428.8 128H472c22.1 0 40-17.9 40-40V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V80H448.2c-.2 0-.3 0-.5 0H432V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V80H280V24zm91.2 104L280 188.8V128h91.2zM232 188.8L140.8 128H232v60.8zM371.2 320L280 380.8V320h91.2zM232 380.8L140.8 320H232v60.8z"]
};
var faFlagCheckered = {
  prefix: 'far',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M24 0C37.3 0 48 10.7 48 24V52l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 388V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V400 350.5 64 24C0 10.7 10.7 0 24 0zM48 150.7l80-17.4V81.5l-80 20v49.3zm0 49.1v46.9l80-17.4V182.5L48 199.9zm0 96v42.7l68.6-17.2c3.8-.9 7.6-1.8 11.4-2.5V278.5L48 295.9zm128 18.8c33.1 .7 65.9 8.7 96 23.7V288.5l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v46zm144 37c18.7 1.5 37.7-1.1 55.6-7.8l24.4-9.1V288L374.3 294c-17.9 4.1-36.1 5.5-54.3 4.3v53.5zm80-113V192L374.3 198c-17.9 4.1-36.1 5.5-54.3 4.3v47.8c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zm0-96V92.9c-25.6 10.4-52.8 15.6-80 15.6v45.5c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zM272 103.1c-16.1-3.7-31.9-9.4-47-16.9c-15.3-7.7-32.1-11.8-49-12.3v50.6c18.2-1.3 36.5 .6 54.1 5.8L272 142.5V103.1zm0 89.5l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6v47.8c18.2-1.3 36.5 .6 54.1 5.8L272 238.5v-46z"]
};
var faChevronsUp = {
  prefix: 'far',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M273 47c-9.4-9.4-24.6-9.4-33.9 0L47 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 47zM465 431L273 239c-9.4-9.4-24.6-9.4-33.9 0L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
var faChevronDoubleUp = faChevronsUp;
var faFootball = {
  prefix: 'far',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M442.6 69.4c-32.9-5-63.1-7.4-90.7-7.4l98 98c.5-32.1-2.4-63.1-7.3-90.6zm-217 12.7c-55.4 20.5-93.3 55.2-118.6 96.5c-20.6 33.7-33 72-39.5 110.9L223.6 445.6c23.2-3.4 44.1-8.8 62.8-15.8c55.4-20.5 93.3-55.2 118.6-96.5c20.6-33.7 33-72 39.5-110.9L288.4 66.4c-23.2 3.4-44.1 8.8-62.8 15.8zM62.1 352c-.5 32.1 2.4 63.1 7.3 90.6c32.9 5 63.1 7.4 90.7 7.4l-98-98zm4-198.4c30.6-50 76.8-92 142.9-116.5C274.4 12.8 357.6 6.5 461.5 23.8c13 2.2 23.4 12.1 26.1 25.1c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3c-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6zM297 151l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faFootballBall = faFootball;
var faUserVneck = {
  prefix: 'far',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM48.3 464H399.7c-3.1-47.3-33.7-87.3-76-103.8L274 422.4c-25.6 32-74.3 32-100 0l-49.7-62.2C82 376.7 51.4 416.7 48.3 464zm85-156.4c5.6-1.2 11.3 1.1 14.9 5.6l63.4 79.2c6.4 8 18.6 8 25 0l63.4-79.2c3.6-4.5 9.3-6.7 14.9-5.6C390.9 323.6 448 391.1 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.9 57.1-148.4 133.3-164.4z"]
};
var faSchoolCircleExclamation = {
  prefix: 'far',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92H72C32.2 96 0 128.2 0 168V440c0 39.8 32.2 72 72 72H256 384h10.8C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V168c0-13.3 10.7-24 24-24H176c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4H568c13.3 0 24 10.7 24 24v52.5c18.8 12.3 35.1 28 48 46.3V168c0-39.8-32.2-72-72-72H471.3L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H112zM320 144c8.8 0 16 7.2 16 16v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faCrop = {
  prefix: 'far',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M80 24C80 10.7 90.7 0 104 0s24 10.7 24 24V350.1L350.1 128 160 128V80l238.1 0L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-73 73L432 384h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H432v56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-326.1L161.9 384H352v48H136c-30.9 0-56-25.1-56-56V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80H80V24z"]
};
var faAnglesDown = {
  prefix: 'far',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M401 113L241 273c-9.4 9.4-24.6 9.4-33.9 0L47 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 79c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm0 192L241 465c-9.4 9.4-24.6 9.4-33.9 0L47 305c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faAngleDoubleDown = faAnglesDown;
var faUsersRectangle = {
  prefix: 'far',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", "M88 0C39.4 0 0 39.4 0 88V424c0 48.6 39.4 88 88 88H552c48.6 0 88-39.4 88-88V88c0-48.6-39.4-88-88-88H88zM48 88c0-22.1 17.9-40 40-40H552c22.1 0 40 17.9 40 40V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V88zm272 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM268.4 274c-1.1 .2-2.2 .5-3.3 .7c-25.7 6.3-47.4 22.9-60.3 45.3c-8.2 14.1-12.8 30.5-12.8 48c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32c0-17.5-4.7-33.9-12.8-48c-1.1-1.8-2.2-3.6-3.3-5.4c-13.1-19.6-33.3-34.1-56.9-39.9c-1.1-.3-2.2-.5-3.3-.7c-6.3-1.3-12.9-2-19.6-2H320 288c-6.7 0-13.3 .7-19.6 2zm7-49.5a72 72 0 1 0 89.2-113.1A72 72 0 1 0 275.4 224.5zM397.3 352H242.7c6.6-18.6 24.4-32 45.3-32h64c20.9 0 38.7 13.4 45.3 32zM223.8 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 293.3c0 14.7 11.9 26.7 26.7 26.7h46.6c13.7-33.9 41.5-60.6 76.2-72.8c-7.9-4.6-17-7.2-26.8-7.2H149.3C119.9 240 96 263.9 96 293.3zM470.7 320h46.6c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.8 0-18.9 2.6-26.8 7.2c34.6 12.2 62.5 38.9 76.2 72.8zM512 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faPeopleRoof = {
  prefix: 'far',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M332.3 3.4l296 176c11.4 6.8 15.1 21.5 8.4 32.9s-21.5 15.1-32.9 8.4L320 51.9 36.3 220.6c-11.4 6.8-26.1 3-32.9-8.4s-3-26.1 8.4-32.9l296-176c7.6-4.5 17-4.5 24.5 0zM496 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM480 464h32V400.5c-2-.3-4.1-.5-6.2-.5H486.2c-2.1 0-4.2 .2-6.2 .5V464zm98.9 27.4l-18.9-35V480c0 17.7-14.3 32-32 32H464c-17.7 0-32-14.3-32-32V456.3l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35V400c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V360.3l-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35V480c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V456.3l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm24 104.5V384h32V304.5c-2-.3-4.1-.5-6.2-.5H310.2c-2.1 0-4.2 .2-6.2 .5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 464h32V400.5c-2-.3-4.1-.5-6.2-.5H134.2c-2.1 0-4.2 .2-6.2 .5V464z"]
};
var faSquareArrowRight = {
  prefix: 'far',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM345 273l-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l150.1 0-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9z"]
};
var faArrowSquareRight = faSquareArrowRight;
var faLocationPlus = {
  prefix: 'far',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM168 280V216H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V104c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faMapMarkerPlus = faLocationPlus;
var faLightbulbExclamationOn = {
  prefix: 'far',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM425.2 248.9C439.6 228.3 448 203.2 448 176c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H354.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM336 128v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 256a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPeopleLine = {
  prefix: 'far',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM304 176.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2 .2 6.2 .5V256H304V176.5zm80 55.8l18.9 35c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35V352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V328.3l18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.4-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.4-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35V352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V328.3l18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8l18.9-35V272c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V232.3zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM480 336V272.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2 .2 6.2 .5V336H480zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM128 336V272.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2 .2 6.2 .5V336H128z"]
};
var faBeerMugEmpty = {
  prefix: 'far',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", "M80 80V416c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V368.6c0-.4 0-.7 0-1.1V80H80zM384 383.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h59.2c38 0 68.8 30.8 68.8 68.8V282.7c0 27.3-16.2 52.1-41.2 63l-86.8 38zM384 144V331.3l67.5-29.5c7.6-3.3 12.5-10.8 12.5-19.1V164.8c0-11.5-9.3-20.8-20.8-20.8H384zM144 128c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]
};
var faBeer = faBeerMugEmpty;
var faCrateEmpty = {
  prefix: 'far',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M56 272c-4.4 0-8 3.6-8 8v64H464V280c0-4.4-3.6-8-8-8H56zM48 392v64c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8V392H48zM0 280c0-30.9 25.1-56 56-56H456c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V280zm400 24a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDiagramPredecessor = {
  prefix: 'far',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M464 416l0-64c0-8.8-7.2-16-16-16L64 336c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16zm-16 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c39.8 0 72 32.2 72 72l0 38.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23 0-38.1c0-13.3-10.7-24-24-24l-82 0c1.3 5.1 2 10.5 2 16l0 64z"]
};
var faTransporter = {
  prefix: 'far',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", "M472.7 6.6L480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6zm-416 64L64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128 6.6 120.7C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4C40.4 66.7 43.9 64 48 64s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zM208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 272V432H192V208.8l-52.9 69.7c-8 10.6-23.1 12.6-33.6 4.6s-12.6-23.1-4.6-33.6l65.7-86.7c16.6-21.9 42.6-34.8 70.1-34.8h38.6c27.5 0 53.5 12.9 70.1 34.8l65.7 86.7c8 10.6 5.9 25.6-4.6 33.6s-25.6 5.9-33.6-4.6L320 208.8V432H272V320H240zm0-48h32V176H240v96z"]
};
var faCalendarCircleUser = {
  prefix: 'far',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H432 400 352 48V448c0 8.8 7.2 16 16 16H284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7H399.4c-21 0-38.9 13.7-45.1 32.7C374.5 468.1 401.8 480 432 480s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faArrowUpLong = {
  prefix: 'far',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M209 7c-9.4-9.4-24.6-9.4-33.9 0L39 143c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l95-95V488c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l95 95c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7z"]
};
var faLongArrowUp = faArrowUpLong;
var faPersonCarryBox = {
  prefix: 'far',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM0 488L0 340.3c.5 .4 1.1 .9 1.6 1.3L48 378.1 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24zM59.2 176C53 176 48 181 48 187.2v85.3c0 2.5 1.1 4.8 3.1 6.3L72 295.2V179c-3.9-1.9-8.3-3-12.8-3zM120 246.2v86.7l25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4L113.6 388.9 21.4 316.5C7.9 305.9 0 289.6 0 272.4V187.2C0 154.5 26.5 128 59.2 128c26.1 0 50.5 13.3 64.6 35.3L173.1 240H192V128c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H232h-8H168.7c-13.6 0-26.3-6.9-33.6-18.4L120 246.2zM240 240h96V144H240v96z"]
};
var faPersonCarry = faPersonCarryBox;
var faFireFlameSimple = {
  prefix: 'far',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9c-5.7 15.6-8.6 32.1-8.6 48.7C48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2C132.3 118.8 86.3 191.2 57.3 271L12.2 254.6C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zm72.6 281.4c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"]
};
var faBurn = faFireFlameSimple;
var faPerson = {
  prefix: 'far',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1H146.3c-.8 0-1.5 0-2.3 .1zM144 352V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144z"]
};
var faMale = faPerson;
var faLaptop = {
  prefix: 'far',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M512 80H128c-8.8 0-16 7.2-16 16V320H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320H528V96c0-8.8-7.2-16-16-16zM96 432H544c20.9 0 38.7-13.4 45.3-32H50.7c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32c0 53-43 96-96 96H96c-53 0-96-43-96-96z"]
};
var faFileCsv = {
  prefix: 'far',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
};
var faMenorah = {
  prefix: 'far',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M2.7 49.7L20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1zm96 0L116.8 7.4C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L212.8 7.4zm77.8 42.4L308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L404.8 7.4zm77.8 42.4L500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L596.8 7.4zM24 128c13.3 0 24 10.7 24 24V280c0 22.1 17.9 40 40 40H296V152c0-13.3 10.7-24 24-24s24 10.7 24 24V320H552c22.1 0 40-17.9 40-40V152c0-13.3 10.7-24 24-24s24 10.7 24 24V280c0 48.6-39.4 88-88 88H344v96H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 152c-13.3 0-24-10.7-24-24s10.7-24 24-24H296V368H88c-48.6 0-88-39.4-88-88V152c0-13.3 10.7-24 24-24zm128 24V264v24H104V264 152c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264v24H200V264 152c0-13.3 10.7-24 24-24s24 10.7 24 24zm192 0V264v24H392V264 152c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264v24H488V264 152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faUnion = {
  prefix: 'far',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M24 32c13.3 0 24 10.7 24 24V288c0 79.5 64.5 144 144 144s144-64.5 144-144V56c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 106-86 192-192 192S0 394 0 288V56C0 42.7 10.7 32 24 32z"]
};
var faChevronsLeft = {
  prefix: 'far',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
var faChevronDoubleLeft = faChevronsLeft;
var faCircleHeart = {
  prefix: 'far',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9L233.5 384.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 280.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108z"]
};
var faHeartCircle = faCircleHeart;
var faTruckPlane = {
  prefix: 'far',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M183.3 18.7C192.9 8.8 206.6 0 224 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9c7.8 17.9 13 38.3 15.3 56c-23.5 14.1-40.5 37.9-45.3 65.9c-.9-2.6-1.4-5.3-1.4-8.1V128c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2l0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1v39.4c0 7.3-3.3 14.2-9 18.8L53.7 289.3c-.7 .5-1.3 1-2 1.5c-2.3 1.5-3.7 4-3.7 6.7v28.7l111-44.8c7.4-3 15.8-2.1 22.4 2.4s10.6 11.9 10.6 19.9l0 72.3c0 7.6-3.6 14.7-9.6 19.2L128 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c9.1 2.8 21.9 6.7 35.5 10.8c5.4 10.5 12.7 19.9 21.4 27.7V488c0 4.4 .5 8.7 1.5 12.9l-7.6-2.3c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0 0 0 0 0 0 0-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C97 512 80 495 80 474.1V432c0-12.6 5.9-24.4 16-32l48-36V339.2L53.9 375.6c-.5 .2-1.1 .4-1.7 .6C26.4 384.4 0 365.2 0 338.1V297.5c0-18.6 9.2-36 24.6-46.4L144 155.8V128c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zM288 192c0-16.2 6-31.1 16-42.3c11.7-13.3 28.9-21.7 48-21.7H576c35.3 0 64 28.7 64 64V376v24c0 23.7-12.9 44.4-32 55.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V464H368v10.1V488c0 13.3-10.7 24-24 24c-2.1 0-4.2-.3-6.1-.8c-4.9-1.3-9.2-4.1-12.3-7.9c0 0 0 0 0 0c-3.4-4.2-5.5-9.5-5.5-15.3V459.9v-4.5c-15.5-9-26.9-24.3-30.7-42.4c-.9-4.2-1.3-8.5-1.3-13V376 281.1 204.5 192zM400 304h11.2 6.4 16.8H448h45.6 23.2H544l-11.9-37c-2.5-6.5-8.4-11-15.3-11H429.6 411.2c-6.9 0-12.9 4.5-15.3 11l-1.6 5-4.4 13.8L384 304h16zm-50.3-50.3l.5-1.4 .4-1.2 .5-1.2c.2-.6 .5-1.2 .7-1.8c3.6-8.7 9.2-16.7 16.3-23.3c3.5-3.3 7.5-6.2 11.7-8.6c9.1-5.2 19.8-8.3 31.5-8.3H516.8c28.8 0 51.4 18.7 60.2 41.9l.5 1.2 .4 1.2 11.9 37 2.3 7.2V192c0-8.8-7.2-16-16-16H352c-5.7 0-10.6 2.9-13.5 7.4c-1.6 2.5-2.5 5.4-2.5 8.6v20.5 30.3 53.7l2.3-7.2 11.4-35.6zM445.5 352H422 384h-8H360c-5.1 0-9.8 1.6-13.7 4.3c-6.2 4.3-10.3 11.5-10.3 19.7v12 12c0 8.3 6.3 15.1 14.4 15.9c.5 .1 1.1 .1 1.6 .1h12.7H576c8.8 0 16-7.2 16-16V376c0-13.3-10.7-24-24-24H544 445.5zM368 406.6a24 24 0 1 1 16-45.3 24 24 0 1 1 -16 45.3zM552 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faRecordVinyl = {
  prefix: 'far',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm120 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBringForward = {
  prefix: 'far',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 464H448c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H384V160h64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384h48v64c0 8.8 7.2 16 16 16zm64-112H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64z"]
};
var faSquareP = {
  prefix: 'far',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H176v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H176v88h68z"]
};
var faFaceGrinStars = {
  prefix: 'far',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"]
};
var faGrinStars = faFaceGrinStars;
var faSigma = {
  prefix: 'far',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M1.8 46.8C5.5 37.8 14.3 32 24 32H328c30.9 0 56 25.1 56 56v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-4.4-3.6-8-8-8H81.9L241 239c9.4 9.4 9.4 24.6 0 33.9L81.9 432H328c4.4 0 8-3.6 8-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 30.9-25.1 56-56 56H24c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l183-183L7 73C.2 66.1-1.9 55.8 1.8 46.8z"]
};
var faCameraMovie = {
  prefix: 'far',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M224 120A72 72 0 1 0 80 120a72 72 0 1 0 144 0zM344 240H152C85.7 240 32 186.3 32 120S85.7 0 152 0c39.3 0 74.1 18.8 96 48c21.9-29.1 56.7-48 96-48c66.3 0 120 53.7 120 120s-53.7 120-120 120zM272 120a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zM112 336V448c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H144 128c-8.8 0-16 7.2-16 16zm32-64H352c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V336c0-5.5 .7-10.9 2-16H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128h16zm384 36.6l-80 36V292l75.6-34c2.9-1.3 6-2.2 9.1-2.8c22.6-3.8 43.3 13.7 43.3 36.6V472.5c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L448 476V423.4l80 36V308.6z"]
};
var faBong = {
  prefix: 'far',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M144 208.5c0 23.3-12.4 43.2-29.9 54.4C92.3 276.9 74.5 296.7 63 320H321c-11.6-23.3-29.3-43.1-51.2-57.2c-17.4-11.2-29.9-31.1-29.9-54.4V48H144V208.5zM288 48V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V48H88C74.7 48 64 37.3 64 24S74.7 0 88 0h24H272h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8z"]
};
var faClarinet = {
  prefix: 'far',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M224 112c0-8.8 7.2-16 16-16h32 96 96 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v32h44.6c7.9 0 15.6-2.3 22.2-6.7L602.7 116c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136V376c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7H113.4c-8.6 0-17.1-1.3-25.3-3.7L17.1 327C7 323.9 0 314.6 0 304V208c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7H256V128H240c-8.8 0-16-7.2-16-16zm64 48h64V128H288v32zm96 0h64V128H384v32zM248 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm133.4-62.8C559 202.9 542 208 524.6 208H113.4c-3.9 0-7.8 .6-11.5 1.7L48 225.9v60.3l53.9 16.2c3.7 1.1 7.6 1.7 11.5 1.7H524.6c17.4 0 34.4 5.1 48.8 14.8L592 331.2V180.8l-18.6 12.4z"]
};
var faTruckFlatbed = {
  prefix: 'far',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", "M368 120c0-13.3 10.7-24 24-24h66.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c0 53-43 96-96 96s-96-43-96-96h-8H256c0 53-43 96-96 96s-96-43-96-96H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H368V120zM557.7 239.6l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96H558l-.2-.2-.2-.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSpaghettiMonsterFlying = {
  prefix: 'far',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 58.3c10-11.3 16-26.1 16-42.3c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c1.7 0 3.4-.1 5.1-.2L212.2 158c-21.1 13.6-37.7 30.2-51.4 46.4c-7.1 8.3-13.5 16.6-19.3 24l-1.4 1.8c-6.3 8.1-11.6 14.8-16.7 20.4C112.7 262.3 107.3 264 104 264c-2.5 0-4.3-.6-7.1-3.3c-3.7-3.5-7.1-8.8-12.5-17.4l-.6-.9c-4.6-7.4-11-17.6-19.4-25.7C54.7 207.4 41.5 200 24 200c-13.3 0-24 10.7-24 24s10.7 24 24 24c2.5 0 4.3 .6 7.1 3.3c3.7 3.5 7.1 8.8 12.5 17.4l.6 .9c4.6 7.4 11 17.6 19.4 25.7C73.3 304.6 86.5 312 104 312c18.5 0 32.9-8.5 44.3-18.6c3.1 4 6.6 8.3 10.5 12.7c-2.4 7.1-4.5 14.2-6.5 20.6L151 331c-3.4 11.2-6.4 20.3-9.8 27.8c-3.5 7.5-6.6 11.5-9.4 13.8c-2.3 1.8-5.5 3.4-11.7 3.4c-8.7 0-16.9-4.2-33.7-13.2c-15-8-35.7-18.8-62.3-18.8c-13.3 0-24 10.7-24 24s10.7 24 24 24c13.4 0 24.7 5.2 39.7 13.2c1 .6 2.1 1.1 3.2 1.7l0 0C80.1 414 98.6 424 120 424c16.2 0 30.2-4.8 41.7-13.9c10.9-8.7 18-20.2 23-31.1c5-10.9 8.8-22.9 12.2-34l.8-2.7c16.4 12.2 36.1 23.6 58.9 31.3c-5.6 16.6-13.8 37.5-24.6 55.5C217.2 454 203.2 464 192 464c-13.3 0-24 10.7-24 24s10.7 24 24 24c39.1 0 65.6-32 81.2-58.2c14.5-24.2 24.6-51.4 30.7-70.4c5.2 .4 10.6 .6 16 .6s10.8-.2 16-.6c6.1 19 16.3 46.3 30.7 70.4C382.4 480 408.9 512 448 512c13.3 0 24-10.7 24-24s-10.7-24-24-24c-11.2 0-25.2-10-40-34.8c-10.8-18-19-39-24.6-55.5c22.8-7.7 42.5-19 58.9-31.3l.8 2.7c3.4 11 7.2 23.1 12.2 34c5.1 10.9 12.1 22.4 23 31.1c11.5 9.1 25.5 13.9 41.7 13.9c21.4 0 39.9-10 53.1-17.1c1.1-.6 2.2-1.2 3.2-1.7c15-8 26.3-13.2 39.7-13.2c13.3 0 24-10.7 24-24s-10.7-24-24-24c-26.6 0-47.3 10.8-62.3 18.8c-16.8 9-25 13.2-33.7 13.2c-6.3 0-9.5-1.6-11.7-3.4c-2.8-2.2-6-6.3-9.4-13.8c-3.5-7.5-6.4-16.6-9.8-27.8l-1.3-4.2c-2-6.5-4.1-13.5-6.5-20.6c3.9-4.5 7.4-8.8 10.5-12.7C503.1 303.5 517.5 312 536 312c17.5 0 30.7-7.4 40.4-16.7c8.4-8.1 14.8-18.3 19.4-25.7l.6-.9c5.4-8.6 8.8-13.9 12.5-17.4c2.8-2.7 4.6-3.3 7.1-3.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-17.5 0-30.7 7.4-40.4 16.7c-8.4 8.1-14.8 18.3-19.4 25.7l-.6 .9c-5.4 8.6-8.8 13.9-12.5 17.4c-2.8 2.7-4.6 3.3-7.1 3.3c-3.3 0-8.7-1.7-19.4-13.4c-5.1-5.6-10.4-12.3-16.7-20.4l-1.4-1.8c-5.8-7.4-12.2-15.7-19.3-24c-13.8-16.2-30.4-32.8-51.4-46.4l15.1-30.2c1.7 .1 3.4 .2 5.1 .2c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 16.2 6 31.1 16 42.3l-15.6 31.2c-18.7-6-39.9-9.5-64.4-9.5s-45.8 3.5-64.4 9.5L240 106.3zM459.4 256.3c-.4 .6-.9 1.3-1.4 2c-6.3 8.8-15.8 20.5-28.3 32.2C404.5 313.8 368 336 320 336s-84.5-22.2-109.7-45.6c-12.6-11.7-22-23.4-28.3-32.2c-.5-.7-1-1.3-1.4-2c5.4-6.9 10.8-13.8 16.7-20.7c26.4-31 60.4-59.6 122.7-59.6s96.3 28.6 122.7 59.6c5.9 6.9 11.3 13.8 16.7 20.7zM448 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faArrowDownUpAcrossLine = {
  prefix: 'far',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M143 505c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V280H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H440V81.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V232H184 136 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H136V430.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm-7-313h48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V192zM440 320H392V456c0 13.3 10.7 24 24 24s24-10.7 24-24V320z"]
};
var faLeafHeart = {
  prefix: 'far',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M272 144l104 0c31.6 0 61-9.1 85.7-24.9c1.5 12.2 2.3 24.7 2.3 37.5c0 143.2-93.8 242.9-191.2 243.4l-.1 0-.8 0h-.1C201.3 400 144 342.7 144 272c0-70.7 57.3-128 128-128zM450.6 67.5C430.8 85.2 404.7 96 376 96L272 96c-93.2 0-169.5 72.5-175.6 164.1C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.6 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-26.4-2.9-51.9-8.3-76.2c-.4-1.9-.9-3.8-1.3-5.6c-2.2-9.3-4.8-18.3-7.8-27.2c-1.2-3.6-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1c-1.4 2.7-3 5.3-4.6 7.8c-4.9 7.7-10.8 14.7-17.4 20.9c-.7 .7-1.4 1.3-2.1 1.9zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"]
};
var faHouseBuilding = {
  prefix: 'far',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M352 48H576c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H416c0 18-6 34.6-16 48H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v60.6l48 44V64c0-8.8 7.2-16 16-16zm61.2 208H432c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v4.6l6.1 5.6c11.2 10.3 19.2 23.4 23.1 37.9zm2.8 96h16c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H416v64zm64-144v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H496zM400 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H400zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16zM20.8 237C7.5 249.1 0 266.2 0 284.2V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V284.2zM144 296v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24z"]
};
var faCheeseSwiss = {
  prefix: 'far',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M464 256V240.2C464 151.7 392.3 80 303.8 80c-.8 0-1.6 .2-2.3 .7l-35 23.3c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48c-23.4 0-42.9-16.7-47.1-38.9L53.3 246.2C50 248.4 48 252.1 48 256H322.7c6.6-18.6 24.4-32 45.3-32s38.7 13.4 45.3 32H464zM48 304V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V304H403.8c-8.8 9.8-21.6 16-35.8 16s-27-6.2-35.8-16H48zm464-63.8V256 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zM176 320a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSpoon = {
  prefix: 'far',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M286.1 193.9l32 32c9.3 9.4 21.5 14 33.8 14.1c21.1 0 48.8-13.5 73.2-42.7C449 168.6 464 131.2 464 96c0-26.5-21.5-48-48-48c-35.2 0-72.6 15-101.3 38.9C285.5 111.3 272 139 272 160.1c0 12.3 4.7 24.5 14.1 33.8zm-34.9 33c-18.1-18.6-27.1-42.6-27.2-66.7C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-24.1 0-48.2-9.1-66.7-27.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L251.2 226.9z"]
};
var faUtensilSpoon = faSpoon;
var faJarWheat = {
  prefix: 'far',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M32 24c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM256 128c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16H256zM64 80C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H64zm192 85.8c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2zM250.2 256H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8zM256 357.8c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v16c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2z"]
};
var faEnvelopesBulk = {
  prefix: 'far',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", "M112 48H432V96h48V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48V192h48V48zM48 272H336v6.9L192.1 385.4c0 0-.1 0-.1 0s-.1 0-.1 0L48 278.9V272zm0 66.6L163.3 424c8.3 6.2 18.4 9.5 28.7 9.5s20.4-3.3 28.7-9.5L336 338.6V464H48V338.6zM0 272V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zm272-80V176H592V368H416v48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H272c-26.5 0-48 21.5-48 48v16h48zm240 16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H512z"]
};
var faMailBulk = faEnvelopesBulk;
var faFileCircleExclamation = {
  prefix: 'far',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M64 464H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faBowArrow = {
  prefix: 'far',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L144.6 333.4 93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zM132.2 379.8l9.2 36.8L117 441.1l-5.7-22.9c-2.1-8.6-8.9-15.3-17.5-17.5L70.9 395l24.4-24.4 36.8 9.2zm-79.5-265L49 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L151.4 281.4l33.9-33.9-98-98c61.2-37.6 138.2-39.2 200.8-4.9l35.1-35.1c-82.8-51.7-189.4-50-270.6 5.2zm314.7 109c34.3 62.6 32.7 139.6-4.9 200.8l-98-98-33.9 33.9L367 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-3.7-3.7c55.2-81.2 57-187.8 5.2-270.6l-35.1 35.1z"]
};
var faCartXmark = {
  prefix: 'far',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3L575.2 62.2c3.4-12.8-4.1-26-16.9-29.4s-26 4.1-29.4 16.9L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8H161.6l-37-194.5C119.5 19.1 96.4 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257.8 65.8c-9.4 9.4-9.4 24.6 0 33.9L286.1 128l-28.3 28.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L320 161.9l28.3 28.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L353.9 128l28.3-28.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L320 94.1 291.7 65.8c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faHexagonXmark = {
  prefix: 'far',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12H344.3c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesHexagon = faHexagonXmark;
var faXmarkHexagon = faHexagonXmark;
var faCircleH = {
  prefix: 'far',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v80H192V152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80H320v80c0 13.3 10.7 24 24 24s24-10.7 24-24V256 152z"]
};
var faHospitalSymbol = faCircleH;
var faMerge = {
  prefix: 'far',
  iconName: 'merge',
  icon: [512, 512, [], "e526", "M0 88C0 74.7 10.7 64 24 64H96h48.2c17.5 0 34 8.2 44.5 22.1L297.5 228.8c1.5 2 3.9 3.2 6.4 3.2H430.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H303.8c-2.5 0-4.9 1.2-6.4 3.2L188.7 425.9c-10.6 13.9-27.1 22.1-44.5 22.1H96 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96h48.2c2.5 0 4.9-1.2 6.4-3.2L257.8 256 150.5 115.2c-1.5-2-3.9-3.2-6.4-3.2H96 24C10.7 112 0 101.3 0 88z"]
};
var faPager = {
  prefix: 'far',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M448 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM96 192v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm16 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H112zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faCartMinus = {
  prefix: 'far',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", "M0 24C0 10.7 10.7 0 24 0H69.5c26.9 0 50 19.1 55 45.5l37 194.5H459.2c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM256 96H384c13.3 0 24 10.7 24 24s-10.7 24-24 24H256c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faAddressBook = {
  prefix: 'far',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"]
};
var faContactBook = faAddressBook;
var faPanFrying = {
  prefix: 'far',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9C566.7 409.2 576 427.1 576 448c0 35.3-28.7 64-64 64c-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3zM528 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8zM272 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faGrid = {
  prefix: 'far',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M88 72v48H40V72H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 232v48H40V232H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 200H88v48H40V392zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 72v48H200V72h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 200h48v48H200V232zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 160v48H200V392h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 72h48v48H360V72zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 160v48H360V232h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 200h48v48H360V392zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
};
var faGrid3 = faGrid;
var faFootballHelmet = {
  prefix: 'far',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M434.6 185.3L275.1 205.2c-38.3 4.8-67.1 37.4-67.1 76c0 11.9 2.8 23.6 8.1 34.3L254.3 392c1.1 2.2 1.7 4.7 1.7 7.2v.9c0 8.8-7.2 16-16 16h-2.9c-2.2 0-4.3-.4-6.3-1.3l-93.9-40.2c-10-4.3-20.7-6.5-31.5-6.5H100c-22.7-31.5-36-70.1-36-112C64 150 150 64 256 64c81 0 150.4 50.2 178.6 121.3zm27.9 44.9c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9h14c4.3 0 8.6 .9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2H240c35.3 0 64-28.7 64-64v-.9c0-9.9-2.3-19.7-6.8-28.6L288 352h39.7l9.6 50.9c10.1 54 57.2 93.1 112.1 93.1h17c25.2 0 45.6-20.4 45.6-45.6V400 368c0-26.5-21.5-48-48-48H354.3l-14-74.5 122.2-15.3zM321.7 320H272l-13-26c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l27.4-3.4L321.7 320zm44.6 64l-6-32H464c8.8 0 16 7.2 16 16v16H366.3zM480 416v34.4c0 7.5-6.1 13.6-13.6 13.6h-17c-32.7 0-61.6-19.3-74.7-48H480zM176 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHandLove = {
  prefix: 'far',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M176 48c8.8 0 16 7.2 16 16V79.9l0 .1V207.8l0 .2v96c0 35.3 28.7 64 64 64c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c35.3 0 64-28.7 64-64V256 240 216h0V128c0-8.8 7.2-16 16-16s16 7.2 16 16V337.9c-.3 1.2-.5 2.5-.7 3.7c-6.6 66.5-61.1 118.9-128.5 122.2c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V64c0-8.8 7.2-16 16-16zM352 256v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16v16zm0-104v26c-5.1-1.3-10.5-2-16-2c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2V64c0-35.3-28.7-64-64-64s-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c87.6-5.9 158.3-72.9 169.9-158.8c1.1-2.7 1.7-5.7 1.7-8.8V128c0-35.3-28.7-64-64-64s-64 28.7-64 64v23.9l0 .1zM240 216v-8.2c.1-8.8 7.2-15.8 16-15.8c8.8 0 16 7.2 16 16v32 64c0 8.8-7.2 16-16 16s-16-7.2-16-16V216h0z"]
};
var faTrees = {
  prefix: 'far',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M177.4 15.1c16-19 45.2-19 61.2 0L354.4 152.5c6 7.1 7.3 17.1 3.4 25.6s-12.4 13.9-21.8 13.9H321.9l64.8 81c5.8 7.2 6.9 17.1 2.9 25.4s-12.4 13.6-21.6 13.6H342.3l62.1 88H408V216c0-13.3 10.7-24 24-24s24 10.7 24 24V400H569.7l-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13h22.1l-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6h12.4L432 53.3l-59.9 71.1L339.9 88.1l61.5-73c16-19 45.2-19 61.2 0L578.4 152.5c6 7.1 7.3 17.1 3.4 25.6s-12.4 13.9-21.8 13.9H545.9l64.8 81c5.8 7.2 6.9 17.1 2.9 25.4s-12.4 13.6-21.6 13.6H566.3l69.3 98.2c5.2 7.3 5.8 16.9 1.7 24.9s-12.3 13-21.3 13H456v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H392 368 256 232v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H144 24c-9 0-17.2-5-21.3-13s-3.5-17.6 1.7-24.9L73.7 312H48c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64.8-81H80c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L177.4 15.1zM256 400h89.7l-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13h22.1l-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6h12.4L208 53.3 131.6 144H144c9.2 0 17.6 5.3 21.6 13.6s2.9 18.2-2.9 25.4L97.9 264H120c9 0 17.2 5 21.3 13s3.5 17.6-1.7 24.9L70.3 400H144h40V216c0-13.3 10.7-24 24-24s24 10.7 24 24V400h24z"]
};
var faStrikethrough = {
  prefix: 'far',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8c12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6l0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4c-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7H351.6c5.7 5.3 9.7 11 12.3 17.1z"]
};
var faPage = {
  prefix: 'far',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M64 464H320c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zm256 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64z"]
};
var faK = {
  prefix: 'far',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V328 456c0 13.3 10.7 24 24 24s24-10.7 24-24V337.9l79.6-79.6L276.4 469.8c7.6 10.8 22.6 13.5 33.4 5.8s13.4-22.6 5.8-33.4L162.1 223.9 313 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 270.1V56z"]
};
var faDiagramPrevious = {
  prefix: 'far',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", "M464 416c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16v64zm48-64c0-35.3-28.7-64-64-64H280V201.9l23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23V288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352zM64 224l74.3 0c-5.7-19.1-1-40.5 14.1-55.6l64-64c21.9-21.9 57.3-21.9 79.2 0l64 64c15 15 19.7 36.5 14.1 55.6l74.3 0c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64z"]
};
var faGaugeMin = {
  prefix: 'far',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56s-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltSlowest = faGaugeMin;
var faFolderGrid = {
  prefix: 'far',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM104 240c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H104zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H232zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H360z"]
};
var faEggplant = {
  prefix: 'far',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9V192c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48c0-5.8-4-10.7-9.4-12.7c-13.3-4.8-25.4-13-35.1-22.8c-9.7-9.8-17.9-21.9-22.8-35.2c-2-5.4-6.9-9.4-12.6-9.4c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16H462.1l9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6c8.4 14.1 20.9 25.5 36 32.3c-19.3 17.1-40.4 31-61.2 42.9c-21.5 12.3-47 24.8-70.4 36.2l0 0c-13.9 6.8-27 13.2-38 18.9c-33.6 17.6-59 34.3-76.1 54.5c-15.7 18.5-26.2 42-25.6 77.9c1 70 59 128.7 128.5 128.7c59 .1 115.4-40.1 163.9-107c33.3-46 59.2-99.9 76.2-148.5c10.2 13.3 24.4 23.3 40.8 28.2C410.6 362.7 311.1 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z"]
};
var faRam = {
  prefix: 'far',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-8.8 7.2-16 16-16s16 7.2 16 16V88.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2V240c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V167.8l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3V64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM306.5 88.7c-8-10.3-19-18-31.8-21.9C268.8 65 262.5 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40H456c-14.2 0-27.7-2.8-40.1-8c-.9 0-1.7-.1-2.4-.2c-24.6-3.8-48 11.9-53.9 36c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4c-20.1-16-49.1-13.3-66 6c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1c-5.9-24.2-29.3-39.8-53.9-36c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9c5.3-21.3-4.6-43.6-24-53.9C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2c24.6 3.8 48-11.9 53.9-36c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5c20.1 16 49.1 13.3 66-6c3-3.4 7.3-5.5 12.1-5.5c5.3 0 10 2.5 13 6.7c8.6 11.9 22 19.2 36.6 19.9c2.5-10 7.7-19.3 15.2-26.6c-6.5-6.4-11.5-14.3-14.3-23.3zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faLandmarkFlag = {
  prefix: 'far',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M272 0H256c-8.8 0-16 7.2-16 16V128H48c-13.3 0-24 10.7-24 24s10.7 24 24 24H464c13.3 0 24-10.7 24-24s-10.7-24-24-24H272V96h80c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H272zM112 208H64V384H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V208H400V384H336V208H288V384H224V208H176V384H112V208zM0 488c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"]
};
var faLips = {
  prefix: 'far',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M258.2 138.9c-22.5-17.8-42-26.9-58.2-26.9c-10.5 0-24.3 4.1-41.7 13.7c-17.2 9.5-34 22.1-50.5 34.9c-17.5 13.6-33.2 27.9-44.4 40.5c-6 6.8-10.3 12.2-13 17C48.3 222 48 223.8 48 224c0 .4 .1 1.7 .6 4.1s1.3 5.2 2.3 8.3c9.8 29.5 28.4 58.7 51.2 85.1C138.4 363.6 190.4 400 256 400h64c65.6 0 117.6-36.4 153.9-78.5c18.1-20.9 31.8-42.8 41-61.2c9.2-18.5 13-29.2 13.1-36.3c0-.2-.2-2-2.5-5.9c-2.7-4.8-6.9-10.2-13-17c-11.2-12.6-26.9-26.9-44.4-40.5c-16.5-12.8-33.3-25.4-50.5-34.9C400.3 116.1 386.5 112 376 112c-16.2 0-35.7 9.1-58.2 26.9c-17.5 13.8-42.1 13.8-59.5 0zm239.4-16.2c19.1 14.8 37.1 31.2 50.8 46.5c13.4 15 27.6 33.7 27.6 54.8c0 20-9.4 40.3-18.1 57.8c-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448H256c-84.7 0-148.8-47.1-190.2-95.1C40.3 323.4 17.7 288.8 5.3 251.5C2.6 243.1 0 233.2 0 224c0-21.1 14.2-39.7 27.6-54.8c13.6-15.3 31.7-31.7 50.8-46.5C111.5 97 156 64 200 64c32.7 0 63 17.5 88 37.3C313 81.5 343.3 64 376 64c44 0 88.5 33 121.6 58.7zM96 236c0-6.7 39.4-27.1 118.1-28c3.5 0 7 .5 10.3 1.6c11.8 3.7 42 12.4 63.6 12.4s51.7-8.7 63.6-12.4c3.3-1 6.8-1.6 10.3-1.6c78.7 .9 118.1 21.2 118.1 28c0 6.9-68.6 84-192 84s-192-77.1-192-84z"]
};
var faPencil = {
  prefix: 'far',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
};
var faPencilAlt = faPencil;
var faBackward = {
  prefix: 'far',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", "M288 94c0-16.6-13.5-30-30-30c-6.3 0-12.5 2-17.6 5.7L9.9 236.6C3.7 241.1 0 248.3 0 256s3.7 14.9 9.9 19.4L240.3 442.3c5.1 3.7 11.3 5.7 17.6 5.7c16.6 0 30-13.4 30-30V318.9L464.7 442.6c5.1 3.5 11.1 5.4 17.3 5.4c16.6 0 30.1-13.5 30.1-30.1V94.1C512 77.5 498.5 64 481.9 64c-6.2 0-12.2 1.9-17.3 5.4L288 193.1V94zm0 157.7L464 128.5v255L288 260.3v-8.6zM64.9 256L240 129.2V382.8L64.9 256z"]
};
var faCaretRight = {
  prefix: 'far',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M201.4 256L112 166.6l0 178.7L201.4 256zm45.3-22.6c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-256c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128z"]
};
var faComments = {
  prefix: 'far',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"]
};
var faPaste = {
  prefix: 'far',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M80 96v16c0 17.7 14.3 32 32 32h60.8c16.6-28.7 47.6-48 83.2-48h62c-7.1-27.6-32.2-48-62-48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64h96V400H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H80zm64-40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 464c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H384v48c0 17.7 14.3 32 32 32h48V448c0 8.8-7.2 16-16 16H256zm192 48c35.3 0 64-28.7 64-64V227.9c0-12.7-5.1-24.9-14.1-33.9l-51.9-51.9c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448z"]
};
var faFileClipboard = faPaste;
var faDesktopArrowDown = {
  prefix: 'far',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", "M64 0H224V48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16H352V0H512c35.3 0 64 28.7 64 64V256v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48zM312 24V142.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faCodePullRequest = {
  prefix: 'far',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M305.8 2.1C314.4 5.9 320 14.5 320 24V72h16c66.3 0 120 53.7 120 120V355.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V192c0-39.8-32.2-72-72-72H320v48c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM112 80A32 32 0 1 0 48 80a32 32 0 1 0 64 0zm-8 76.3V355.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V156.3C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3zM112 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPumpkin = {
  prefix: 'far',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", "M352 118.1V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4L229.4 115.7c-27.3 11.4-50.6 30.6-67 54.7c-7.5 11-4.6 25.9 6.3 33.3s25.9 4.6 33.3-6.3C220.8 170 252.3 152 288 152s67.2 18 86 45.5c7.5 11 22.4 13.8 33.3 6.3s13.8-22.4 6.3-33.3c-15.4-22.5-36.7-40.7-61.7-52.4zM141.3 144.9c12.8-16.9 28.5-31.5 46.4-43.2C176.4 98 164.4 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6c45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-12.4 0-24.4 2-35.8 5.7c17.9 11.6 33.6 26.3 46.4 43.2c21.7 3.5 42.9 17.9 60.1 42.7c20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4c17.3-24.8 38.5-39.2 60.2-42.7z"]
};
var faClipboardList = {
  prefix: 'far',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPenField = {
  prefix: 'far',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M569.2 59.1L581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1 514.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8L480.6 114.5 526.1 160 404.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5L325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6L615.1 138.9c28.1-28.1 28.1-73.7 0-101.8L603.1 25.2C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72V440c0 39.8 32.2 72 72 72H504c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H72zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBlueberries = {
  prefix: 'far',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM384 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V320h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V256z"]
};
var faTruckRampBox = {
  prefix: 'far',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M352 88c0-48.6 39.4-88 88-88H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-22.1 0-40 17.9-40 40V360.7l25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106L30.3 511.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8V88zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"]
};
var faTruckLoading = faTruckRampBox;
var faNote = {
  prefix: 'far',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M384 80c8.8 0 16 7.2 16 16V320H320c-17.7 0-32 14.3-32 32v80H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 480H288h5.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V320 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zm64-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 128a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faArrowDownToSquare = {
  prefix: 'far',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", "M385 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V270.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345c9.4 9.4 24.6 9.4 33.9 0L385 233zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72V104c0-39.8-32.2-72-72-72H392c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24 10.7 24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
};
var faUserCheck = {
  prefix: 'far',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H224 178.3zM625 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 177z"]
};
var faCloudXmark = {
  prefix: 'far',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM239 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faVialVirus = {
  prefix: 'far',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80h8V384c0 53 43 96 96 96c28 0 53.3-12 70.8-31.2c-.2-14.6 5.2-29.3 16.4-40.5c.2-.2 .2-.3 .3-.3l0 0c0-.1 0-.3-.1-.6s-.2-.4-.3-.5l-.1 0c-.1 0-.2 0-.4 0c-15.2 0-29-6.1-39.1-15.9c-3.4 23.2-23.4 41-47.5 41c-26.5 0-48-21.5-48-48V240h96v70.3c10-9.6 23.6-15.4 38.6-15.4c.2 0 .4 0 .4 0l.1 0c.1-.1 .2-.2 .3-.5s.1-.5 .1-.6l0 0c0-.1-.1-.2-.3-.3c-21.9-21.9-21.9-57.3 0-79.2c2.7-2.7 5.7-5.1 8.8-7.2V80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H176 80 32 24zM80 192V80h96V192H80zm271.8-2.3c-13.3 0-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2c0-13.3-10.7-24-24-24zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBookBlank = {
  prefix: 'far',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V394.6c18.9-9 32-28.3 32-50.6V56c0-30.9-25.1-56-56-56H88zM368 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H368zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H392c4.4 0 8 3.6 8 8V344c0 4.4-3.6 8-8 8H80z"]
};
var faBookAlt = faBookBlank;
var faGolfFlagHole = {
  prefix: 'far',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24V160v64 8 55.1 49.8V384c0 .7 0 1.5 .1 2.2c-.1 .6-.1 1.2-.1 1.8c0 19.9 35.8 36 80 36s80-16.1 80-36s-35.8-36-80-36c-11.4 0-22.2 1.1-32 3V326.2c24.6-3.9 51.5-6.2 80-6.2c61.7 0 116.4 10.4 154.9 26.3c19.3 8 33.3 16.9 42.1 25.5c8.7 8.6 11 15.4 11 20.2s-2.3 11.7-11 20.2c-8.8 8.6-22.8 17.5-42.1 25.5C372.4 453.6 317.7 464 256 464s-116.4-10.4-154.9-26.3c-19.3-8-33.3-16.9-42.1-25.5c-8.7-8.6-11-15.4-11-20.2s2.3-11.7 11-20.2c8-7.9 20.3-15.9 37-23.3V296.8c-4.5 1.6-9 3.3-13.2 5.1c-22.7 9.4-42.7 21.2-57.3 35.5C10.7 351.9 0 370.3 0 392s10.7 40.1 25.4 54.5c14.7 14.3 34.6 26.1 57.3 35.5C128.3 500.9 189.6 512 256 512s127.7-11.1 173.2-29.9c22.7-9.4 42.7-21.2 57.3-35.5C501.3 432.1 512 413.7 512 392s-10.7-40.1-25.4-54.5c-14.6-14.3-34.6-26.1-57.3-35.5C383.7 283.1 322.4 272 256 272c-27.8 0-54.8 1.9-80 5.6V246.8l194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM176 193.2V62.8L306.3 128 176 193.2z"]
};
var faMessageArrowDown = {
  prefix: 'far',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24V238.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V120z"]
};
var faCommentAltArrowDown = faMessageArrowDown;
var faFaceUnamused = {
  prefix: 'far',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 392.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 344.3 221.4 328 256 328s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faSheetPlastic = {
  prefix: 'far',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M320 48c8.8 0 16 7.2 16 16V352H256c-17.7 0-32 14.3-32 32v80H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H320zM0 448c0 35.3 28.7 64 64 64H236.1c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM203.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z"]
};
var faCircle9 = {
  prefix: 'far',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM230 316.4c-40.4-11.4-70-48.4-70-92.4c0-53 43-96 96-96s96 43 96 96c0 32.4-14.2 63.2-38.8 84.3l-81.6 70c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8L230 316.4z"]
};
var faBlog = {
  prefix: 'far',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M216 0C379.5 0 512 132.5 512 296c0 13.3-10.7 24-24 24s-24-10.7-24-24C464 159 353 48 216 48c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24V368c0 53 43 96 96 96s96-43 96-96s-43-96-96-96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c79.5 0 144 64.5 144 144s-64.5 144-144 144S0 447.5 0 368V120c0-13.3 10.7-24 24-24zm168 24c0-13.3 10.7-24 24-24c110.5 0 200 89.5 200 200c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-83.9-68.1-152-152-152c-13.3 0-24-10.7-24-24z"]
};
var faUserNinja = {
  prefix: 'far',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M352 128c0 70.7-57.3 128-128 128c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128zM144 112c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM49.3 464H212.4l-6.5-7.7c-.2-.2-.4-.4-.6-.7l-78.4-93.1C85.9 380.1 55.7 418.3 49.3 464zm206.1-23.5L275.2 464H398.7c-6.4-45.7-36.6-83.9-77.7-101.5l-65.7 78zM418.3 512H264.2h-.3H29.7C13.3 512 0 498.7 0 482.3c0-83.7 57.6-153.9 135.4-173.1c5.6-1.4 11.4 .7 15.1 5.1l61.3 71.6c6.4 7.4 17.9 7.4 24.3 0l61.3-71.6c3.7-4.4 9.5-6.4 15.1-5.1C390.4 328.4 448 398.6 448 482.3c0 16.4-13.3 29.7-29.7 29.7z"]
};
var faPencilSlash = {
  prefix: 'far',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L517.3 19.3c-25-25-65.5-25-90.5 0L264.3 181.8 38.8 5.1zM302.3 211.6L385 129 447 191l-75.1 75.1-69.6-54.5zm.9 123.2l-41.7 41.7-49.6-12.4-12.4-49.6 34.4-34.4-38-29.9-73.2 73.2c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6L77.4 439 65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L137 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8l88.6-88.6-38-29.9zM161 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1l11.1-7.4z"]
};
var faBowlingPins = {
  prefix: 'far',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M128 48c-17.7 0-32 14.3-32 32v4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1h33.6c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1V80c0-17.7-14.3-32-32-32zM102.3 230.2L74 305.7c-6.6 17.6-10 36.3-10 55.1c0 22.4 4.8 44.5 14.1 64.9L95.5 464h65.1l17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2H108.8c-1.6 7.5-3.7 14.9-6.4 22.2zM48 80C48 35.8 83.8 0 128 0s80 35.8 80 80v4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2v1c0 12.5 2.2 24.8 6.6 36.5L227 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L200 493.2c-5.2 11.4-16.6 18.8-29.1 18.8H85.2c-12.5 0-23.9-7.3-29.1-18.8L34.4 445.6C22.3 419 16 390.1 16 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5v-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7V80zM384 48c-17.7 0-32 14.3-32 32v4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1h33.6c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1V80c0-17.7-14.3-32-32-32zM358.3 230.2L330 305.7c-6.6 17.6-10 36.3-10 55.1c0 22.4 4.8 44.5 14.1 64.9L351.5 464h65.1l17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2H364.8c-1.6 7.5-3.7 14.9-6.4 22.2zM304 80c0-44.2 35.8-80 80-80s80 35.8 80 80v4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2v1c0 12.5 2.2 24.8 6.6 36.5L483 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L456 493.2c-5.2 11.4-16.6 18.8-29.1 18.8H341.2c-12.6 0-23.9-7.3-29.1-18.8l-21.7-47.6C278.3 419 272 390.1 272 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5v-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7V80z"]
};
var faPersonArrowUpFromLine = {
  prefix: 'far',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3 .1V304H176V176.1c.7 0 1.5-.1 2.3-.1zM176 464V352h32V464H176zm-48 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H152h80H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H256V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L282.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7H178.3c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6V464zM600.1 118.2l-88-80c-9.2-8.3-23.1-8.3-32.3 0l-88 80c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6L472 110.3 472 392c0 13.3 10.7 24 24 24s24-10.7 24-24V110.3l47.9 43.5c9.8 8.9 25 8.2 33.9-1.6s8.2-25-1.6-33.9z"]
};
var faDownRight = {
  prefix: 'far',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", "M320 384V190.6c0-1.7-.8-3.2-2.1-4.2c-2.1-1.6-5-1.4-6.9 .5L257 241c-9.4 9.4-24.6 9.4-33.9 0L98.3 116.3c-2.7-2.7-6.5-4.3-10.3-4.3s-7.6 1.5-10.3 4.3L52.3 141.7c-2.7 2.7-4.3 6.5-4.3 10.3s1.5 7.6 4.3 10.3L177 287c9.4 9.4 9.4 24.6 0 33.9L122.9 375c-1.8 1.8-2.1 4.8-.5 6.9c1 1.3 2.5 2.1 4.2 2.1H320zm48 8c0 22.1-17.9 40-40 40H126.6c-16.8 0-32.5-7.9-42.6-21.3c-15.9-21.2-13.8-50.9 4.9-69.6L126.1 304 18.3 196.3C6.6 184.5 0 168.6 0 152s6.6-32.5 18.3-44.3L43.7 82.4C55.5 70.6 71.4 64 88 64s32.5 6.6 44.3 18.3L240 190.1 277.1 153c18.7-18.7 48.4-20.8 69.6-5c13.4 10.1 21.3 25.8 21.3 42.6V392z"]
};
var faScrollTorah = {
  prefix: 'far',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", "M80 48C62.3 48 48 62.3 48 80V432c0 17.7 14.3 32 32 32s32-14.3 32-32V416 96 80c0-17.7-14.3-32-32-32zm73.3 416C141 492.3 112.8 512 80 512c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0c32.8 0 61 19.7 73.3 48H160 480h6.7C499 19.7 527.2 0 560 0c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80c-32.8 0-61-19.7-73.3-48H480 160h-6.7zm6.7-48H480V96H160V416zm368 16c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32V96 416v16zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"]
};
var faTorah = faScrollTorah;
var faWebhook = {
  prefix: 'far',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M306 50c41.1 9.5 67.5 49.2 61.1 90.2c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20C424.8 82 382.6 18.5 316.8 3.3c-68.9-15.9-137.6 27-153.5 95.9c-10.7 46.3 5.2 92.6 37.7 122.7L129.7 336c-.6 0-1.1 0-1.7 0c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l82.8-132.5c3.4-5.4 4.5-11.9 3-18.1s-5.3-11.6-10.7-15c-28.2-17.6-43.4-51.7-35.5-85.9C220 67 262.9 40.1 306 50zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm42.4 38.5c3.6-6.7 5.6-14.4 5.6-22.5c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c.6 0 1.1 0 1.7 0l82.8 132.5c3.4 5.4 8.8 9.2 15 10.7s12.7 .3 18.1-3c30.9-19.3 72.1-15.5 99 11.3c31.2 31.2 31.2 81.9 0 113.1c-26.8 26.8-68.1 30.6-99 11.3c-11.2-7-26-3.6-33.1 7.6s-3.6 26 7.6 33.1c49.4 31 115.4 25 158.4-18c50-50 50-131 0-181c-37-37-91-46.6-136.8-28.9L330.4 150.5zM112 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm320 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0c0-26.5-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24H232c-6.4 0-12.5 2.5-17 7s-7 10.6-7 17c0 36.4-25 69.4-62 77.9c-43.1 9.9-86-16.9-95.9-60c-8.9-38.6 11.7-77.1 47.1-91.8c12.2-5.1 18-19.1 12.9-31.4s-19.1-18-31.4-12.9C22.1 289.4-11 351 3.3 412.8c15.9 68.9 84.6 111.8 153.5 95.9c51-11.8 87.7-52.5 97-100.7H406.4c8.3 14.3 23.8 24 41.6 24c26.5 0 48-21.5 48-48z"]
};
var faBlindsOpen = {
  prefix: 'far',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H144V160v48 36.1C116 254 96 280.7 96 312c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.3-20-58-48-67.9V208 160 48H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM144 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM0 488c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM64.3 320H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H80.3c-9-14.1-14.7-30.4-16-48zm191.3 48H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H271.7c-1.3 17.6-7 33.9-16 48zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h88V160H24zm200 48H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H224v48z"]
};
var faFence = {
  prefix: 'far',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M64 32c7.8 0 15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9v48h64V112c0-5 1.6-9.9 4.5-13.9l40-56C241 35.7 248.2 32 256 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9v48h64V112c0-5 1.6-9.9 4.5-13.9l40-56C433 35.7 440.2 32 448 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9V448c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V400H320v48c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V400H128v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V112c0-5 1.6-9.9 4.5-13.9l40-56C49 35.7 56.2 32 64 32zM320 352h64V208H320V352zM192 208H128V352h64V208zM48 119.7V432H80V119.7L64 97.3 48 119.7zm192 0V432h32V119.7L256 97.3l-16 22.4zM432 432h32V119.7L448 97.3l-16 22.4V432z"]
};
var faUp = {
  prefix: 'far',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", "M192 82.4L334.7 232.3c.8 .8 1.3 2 1.3 3.2c0 2.5-2 4.6-4.6 4.6H248c-13.3 0-24 10.7-24 24V432H160V264c0-13.3-10.7-24-24-24H52.6c-2.5 0-4.6-2-4.6-4.6c0-1.2 .5-2.3 1.3-3.2L192 82.4zm192 153c0-13.5-5.2-26.5-14.5-36.3L222.9 45.2C214.8 36.8 203.7 32 192 32s-22.8 4.8-30.9 13.2L14.5 199.2C5.2 208.9 0 221.9 0 235.4c0 29 23.5 52.6 52.6 52.6H112V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V288h59.4c29 0 52.6-23.5 52.6-52.6z"]
};
var faArrowAltUp = faUp;
var faBroomBall = {
  prefix: 'far',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M569 7c9.4 9.4 9.4 24.6 0 33.9L369 241l39 39c5.1 5.1 8 12.1 8 19.4c0 12.2-8.1 23-19.9 26.3l-55.6 15.9 .1 .6c7.1 46.4-8.3 93.4-41.5 126.7C271.5 496.5 234 512 194.9 512L22.3 512C10 512 0 502 0 489.7c0-6.2 2.6-12.1 7.2-16.4l49.9-46.1 24.3-22.4L104 384H81.3c-9.6 0-17.3-7.8-17.3-17.3c0-3.9 .2-7.8 .6-11.6c2.7-25.6 14-49.7 32.4-68l10.2-10.2c33.2-33.2 80.2-48.6 126.7-41.5l.6 .1 15.9-55.6c3.4-11.8 14.1-19.9 26.3-19.9c7.3 0 14.2 2.9 19.4 8l39 39L535 7c9.4-9.4 24.6-9.4 33.9 0zM321.2 297.2l28.1-8-62.4-62.4-8 28.1 42.3 42.3zm-84.9-12.9l-9.8-1.5c-31.3-4.8-63 5.6-85.4 28l-10.2 10.2c-5.1 5.1-9.3 11-12.4 17.3c13.5 4.3 24.8 14.5 30.1 28.3c7.2 18.4 2.4 39.3-12.1 52.7L88.1 464l106.8 0c26.4 0 51.7-10.5 70.3-29.1c22.4-22.4 32.8-54.1 28-85.4l-1.5-9.8-55.4-55.4zM528 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faDrumstick = {
  prefix: 'far',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M240 304c-17.7 0-32-14.3-32-32V176c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128H240zm-37.5 78c10.2-14.4 23.9-30 41.5-30h92c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176v92c0 17.7-15.6 31.3-30 41.5c-2.4 1.7-4.6 3.6-6.8 5.7c-12 12-31.5 11.1-47.9 6.8c-4.9-1.3-10-2-15.4-2c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5.3-.7-10.5-2-15.4c-4.3-16.4-5.2-35.9 6.8-47.9c2.1-2.1 4-4.4 5.7-6.7z"]
};
var faSquareV = {
  prefix: 'far',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm141.5 53.3L224 314.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"]
};
var faFaceAwesome = {
  prefix: 'far',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-32V200c0-2-.1-3.9-.4-5.8c-4.2 3.6-9.6 5.8-15.6 5.8c-13.3 0-24-10.7-24-24c0-6 2.2-11.4 5.8-15.6c-1.9-.3-3.8-.4-5.8-.4c-22.1 0-40 17.9-40 40v24h80zm-40-96c39.8 0 72 32.2 72 72v24c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V200c0-39.8 32.2-72 72-72zm216 72c-13.3 0-24-10.7-24-24c0-5.4 1.8-10.3 4.7-14.3c-4.1-1.1-8.3-1.7-12.7-1.7c-26.5 0-48 21.5-48 48v16h96V208c0-4.4-.6-8.7-1.7-12.7c-4 3-8.9 4.7-14.3 4.7zm-32-72c44.2 0 80 35.8 80 80v17.9c0 16.6-13.5 30.1-30.1 30.1H286.1c-16.6 0-30.1-13.5-30.1-30.1V208c0-44.2 35.8-80 80-80zM100.4 307.8c-2.3-10.2 5.5-19.8 15.9-19.8h0H395.7h0c10.4 0 18.1 9.6 15.9 19.8c-3.9 17.4-10.6 33.6-19.5 48.2l0 0c-28.2 45.9-78.9 75.6-134.9 76l-1.1 0c-4.6 0-9.3-.2-13.8-.6c-68.5-5.9-126.7-55.6-141.8-123.6zm263.8 32.4c-8.2-2.7-16.9-4.2-25.9-4.2c-39.2 0-71.9 27.3-80.2 64c44.1-.7 83.8-24.1 106.2-59.8z"]
};
var faGaveDandy = faFaceAwesome;
var faDialOff = {
  prefix: 'far',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM264 288V397.4c-50.3-11-88-55.8-88-109.4c0-61.9 50.1-112 112-112s112 50.1 112 112c0 53.6-37.7 98.4-88 109.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24zm24 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faToggleOff = {
  prefix: 'far',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M384 112c79.5 0 144 64.5 144 144s-64.5 144-144 144H192c-79.5 0-144-64.5-144-144s64.5-144 144-144H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faFaceSmileHorns = {
  prefix: 'far',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM207.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C383.2 350.5 357.2 368 320 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zM240.4 288c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faBoxArchive = {
  prefix: 'far',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M48 80v48H464V80H48zM32 32H480c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM32 416V208H80V416c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V208h48V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64z"]
};
var faArchive = faBoxArchive;
var faGrapes = {
  prefix: 'far',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM408 264c0-44.2-35.8-80-80-80c0-44.2-35.8-80-80-80c-28 0-52.6 14.4-66.9 36.1C167 127.6 148.4 120 128 120c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48c-19.4 14.6-32 37.8-32 64c0 17.6 5.7 33.8 15.2 47C19.4 371.5 0 399.5 0 432c0 44.2 35.8 80 80 80c32.5 0 60.5-19.4 73-47.2c13.2 9.6 29.4 15.2 47 15.2c26.2 0 49.4-12.6 64-32c13.4 10 30 16 48 16c44.2 0 80-35.8 80-80c0-20.4-7.6-39-20.1-53.1C393.6 316.6 408 292 408 264zM248 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM72 312a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm8 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm80 8a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm152-56a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM184 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm144-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faPersonDrowning = {
  prefix: 'far',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", "M152 32c13.3 0 24 10.7 24 24V92.6c0 58 37.9 109.1 93.4 126c43.9 13.4 90.7 14.3 135.1 2.7l109.5-28.6c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3L416.5 267.8c-14.3 3.7-28.9 6.4-43.5 7.9L355.7 379.6c-10.6-3.5-21.2-8.8-30.9-15.5c-4.4-3.1-9.1-5.6-14-7.4l13.3-79.8c-23.2-1.4-46.3-5.5-68.8-12.3c-4.6-1.4-9-2.9-13.4-4.7L220.6 379.6c-9.2 3.1-18.9 4.9-28.6 4.9c-6.6 0-13.5-.9-20.6-2.7l26.3-147c-43-33.3-69.7-85.3-69.7-142.1V56c0-13.3 10.7-24 24-24zm112 96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM111.9 398.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faDialMax = {
  prefix: 'far',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM271 305l77.4 77.4c-43.4 27.8-101.7 22.8-139.6-15.1c-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0c37.9 37.9 43 96.2 15.1 139.6L305 271c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm130.1 96.2A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCircleM = {
  prefix: 'far',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.5 137.9c-6.1-8.4-16.9-12-26.8-8.8s-16.6 12.4-16.6 22.8V360c0 13.3 10.7 24 24 24s24-10.7 24-24V226.2l60.5 83.8c4.5 6.2 11.7 9.9 19.5 9.9s14.9-3.7 19.5-9.9L336 226.2V360c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-10.4-6.7-19.6-16.6-22.8s-20.7 .3-26.8 8.8L256 255 171.5 137.9z"]
};
var faCalendarImage = {
  prefix: 'far',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm99.2 136.7L99.8 390.2c-8.1 10.5-.6 25.8 12.7 25.8H338.9c12.6 0 20.3-13.9 13.5-24.6L268.9 260.3c-6.1-9.7-20.1-9.9-26.7-.5L184 344l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCircleCaretDown = {
  prefix: 'far',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 368c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-208 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z"]
};
var faCaretCircleDown = faCircleCaretDown;
var faArrowDown91 = {
  prefix: 'far',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm409-65c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16c-12.6 4.2-19.4 17.8-15.2 30.4s17.8 19.4 30.4 15.2l16.4-5.5V432H384c-13.3 0-24 10.7-24 24s10.7 24 24 24h48 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H456V312zM424 160a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm88-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.1 29.6 77.3 69.1 86l-15.6 18.7c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1l64.6-77.6c13-15.6 20.3-35.1 20.9-55.3c0-.8 0-1.6 0-2.5z"]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faFaceGrinTongueSquint = {
  prefix: 'far',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V392.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faShishKebab = {
  prefix: 'far',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M416 48c-26.5 0-48 21.5-48 48c0 5.7 1 11.1 2.7 16.1c6.8 19.2 11.3 51.8-11.3 74.5L337 209l24.4 24.4C375.9 247.9 384 267.5 384 288s-8.1 40.1-22.6 54.6l-18.7 18.7C328.1 375.9 308.5 384 288 384c0 20.5-8.1 40.1-22.6 54.6l-18.7 18.7C232.1 471.9 212.5 480 192 480s-40.1-8.1-54.6-22.6L113 433 41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72L54.6 374.6C40.1 360.1 32 340.5 32 320s8.1-40.1 22.6-54.6l18.7-18.7C87.9 232.1 107.5 224 128 224c0-20.5 8.1-40.1 22.6-54.6l18.7-18.7C183.9 136.1 203.5 128 224 128s40.1 8.1 54.6 22.6L303 175l22.5-22.5c1.1-1.1 2.5-3.3 2.8-7.8c.3-4.7-.6-10.6-2.7-16.6C321.9 118 320 107.2 320 96c0-53 43-96 96-96s96 43 96 96c0 19.7-6 38.1-16.2 53.4c-7.4 11-22.3 14-33.3 6.6s-14-22.3-6.6-33.3c5.1-7.6 8.1-16.8 8.1-26.7c0-26.5-21.5-48-48-48zM88.6 340.7l82.7 82.7c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6L88.6 299.3C83.1 304.8 80 312.2 80 320s3.1 15.2 8.6 20.7zm178.7-13.3c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6l-18.7 18.7c-5.5 5.5-8.6 12.9-8.6 20.7s3.1 15.2 8.6 20.7l82.7 82.7z"]
};
var faSprayCan = {
  prefix: 'far',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M128 0C110.3 0 96 14.3 96 32v96H224V32c0-17.7-14.3-32-32-32H128zm96 208c26.5 0 48 21.5 48 48V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V256c0-26.5 21.5-48 48-48H224zM96 160c-53 0-96 43-96 96V440c0 39.8 32.2 72 72 72H248c39.8 0 72-32.2 72-72V256c0-53-43-96-96-96H96zM224 336A64 64 0 1 0 96 336a64 64 0 1 0 128 0zM320 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM512 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM480 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faAlarmSnooze = {
  prefix: 'far',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h62.9L181.1 345.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5H312c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.1l81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5H200z"]
};
var faScarecrow = {
  prefix: 'far',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", "M168 104a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm131 72h69v32H322.6c-24.5 0-43.2 21.7-39.6 45.9l13.9 92.7-13-7.4c-7.9-4.5-17.7-4.2-25.2 .9L224 363.2 189.3 340c-7.6-5-17.3-5.4-25.2-.9l-13 7.4L165 253.9c3.6-24.2-15.1-45.9-39.6-45.9H80V176h69c18.9 19.7 45.6 32 75 32s56.1-12.3 75-32zM120 104c0 8.3 1 16.3 2.8 24H64 56 32c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l7.6 11.4L6.4 179.2C2.4 182.2 0 187 0 192s2.4 9.8 6.4 12.8l19.9 14.9-7.6 11.4c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5H56h8 52.1L96.3 388.4c-1.4 9.1 2.6 18.2 10.2 23.4s17.5 5.6 25.5 1L175 388.2 210.7 412c8.1 5.4 18.6 5.4 26.6 0L273 388.2l43.1 24.6c8 4.6 17.9 4.2 25.5-1s11.5-14.3 10.2-23.4L331.9 256H384h8 24c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-7.6-11.4 19.9-14.9c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-19.9-14.9 7.6-11.4c3.3-4.9 3.6-11.2 .8-16.4s-8.2-8.5-14.1-8.5H392h-8H325.2c1.8-7.7 2.8-15.7 2.8-24C328 46.6 281.4 0 224 0S120 46.6 120 104zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM200 488c0 13.3 10.7 24 24 24s24-10.7 24-24V442.6c-15.2 7.2-32.8 7.2-48 0V488z"]
};
var faTruckMonster = {
  prefix: 'far',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M280 48h88.2c2.5 0 4.8 1.2 6.3 3.1L421.4 112H272V56c0-4.4 3.6-8 8-8zm202 64L412.6 21.9C402 8.1 385.6 0 368.2 0H280c-30.9 0-56 25.1-56 56v56H120c-48.6 0-88 39.4-88 88v30.3c-6.1 5.1-12 10.6-17.5 16.4c-9.1 9.6-8.7 24.8 1 33.9s24.8 8.7 33.9-1C77.2 250.3 116.4 232 160 232c53.3 0 100.3 27.5 127.4 69.1c4.4 6.8 12 10.9 20.1 10.9h24.9c8.1 0 15.7-4.1 20.1-10.9C379.7 259.5 426.7 232 480 232c43.6 0 82.8 18.3 110.5 47.7c9.1 9.6 24.3 10.1 33.9 1s10.1-24.3 1-33.9c-5.5-5.8-11.3-11.3-17.5-16.4V200c0-48.6-39.4-88-88-88H482zm78 88.6c-24.5-10.7-51.6-16.6-80-16.6c-65.4 0-123.5 31.5-160 80c-36.5-48.5-94.5-80-160-80c-28.4 0-55.5 5.9-80 16.6V200c0-22.1 17.9-40 40-40H520c22.1 0 40 17.9 40 40v.6zM152 256c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3L63.8 299.1c-8.6 8.6-9.3 21.9-2.3 31.3c-3.7 6.9-6.8 14.1-9 21.8C40.9 353.9 32 363.9 32 376v16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.7-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.8-3.7-14.1-6.8-21.7-9C190.1 264.9 180.1 256 168 256H152zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm312-80c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3c-3.7 6.9-6.8 14.1-9 21.8C360.9 353.9 352 363.9 352 376v16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.8-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.9-3.7-14.1-6.8-21.8-9C510.1 264.9 500.1 256 488 256H472zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faGiftCard = {
  prefix: 'far',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", "M353.5 68.8L318.7 128H320h72c22.1 0 40-17.9 40-40s-17.9-40-40-40h-2.2c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176H184 64c-8.8 0-16 7.2-16 16V320H528V192c0-8.8-7.2-16-16-16H392 332.6l53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5zM48 384v64c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V384H48zM256 128h1.3L222.5 68.8C214.9 55.9 201.1 48 186.2 48H184c-22.1 0-40 17.9-40 40s17.9 40 40 40h72zm7.9-83.6l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0H392c48.6 0 88 39.4 88 88c0 14.4-3.5 28-9.6 40H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h41.6C99.5 116 96 102.4 96 88c0-48.6 39.4-88 88-88h2.2c31.9 0 61.5 16.9 77.7 44.4z"]
};
var faW = {
  prefix: 'far',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M15.9 33.4c12.5-4.5 26.2 2 30.7 14.5L165.9 379.4 265 49.1C268.1 39 277.4 32 288 32s19.9 7 23 17.1l99.1 330.3L529.4 47.9c4.5-12.5 18.2-18.9 30.7-14.5s18.9 18.2 14.5 30.7l-144 400c-3.5 9.7-12.9 16.1-23.2 15.9s-19.4-7.2-22.3-17.1L288 139.5 191 462.9c-3 9.9-12 16.8-22.3 17.1s-19.7-6.1-23.2-15.9L1.4 64.1c-4.5-12.5 2-26.2 14.5-30.7z"]
};
var faCodePullRequestDraft = {
  prefix: 'far',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", "M48 80a32 32 0 1 1 64 0A32 32 0 1 1 48 80zm56 76.3c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3V355.7C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V156.3zM48 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSquareB = {
  prefix: 'far',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 56c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H176v56h68c15.5 0 28-12.5 28-28zM176 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H244 176v56z"]
};
var faElephant = {
  prefix: 'far',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M299.8 48c-33 0-59.8 26.8-59.8 59.8V112c0 35.3 28.7 64 64 64h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8c-61.9 0-112-50.1-112-112v-4.2c0-6.4 .6-12.7 1.6-18.9C127.5 111.6 80 174.2 80 248v19c0 15.5-1.5 31-4.6 46.3c-3.3 16.3-10.1 31.7-20.1 44.9L43.2 374.4c-8 10.6-23 12.8-33.6 4.8s-12.8-23-4.8-33.6l12.1-16.2c5.7-7.6 9.6-16.3 11.4-25.6C30.8 291.7 32 279.4 32 267V248C32 137.6 114.8 46.6 221.6 33.6C241.3 12.9 269.1 0 299.8 0c30.8 0 59 12.1 79.8 32H384c88.4 0 160 71.6 160 160V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-52.6-36.3-96.8-85.3-108.8c2.1 7.3 3.5 14.9 4.2 22.7l1 12.1c1.1 13.2-8.7 24.8-21.9 25.9s-24.8-8.7-25.9-21.9l-1-12.1c-2.9-35-32.1-61.9-67.2-61.9zM528 381v18.7c0 17.8 14.5 32.3 32.3 32.3c15.8 0 29.3-11.4 31.9-27l.2-1c2.2-13.1 14.5-21.9 27.6-19.7s21.9 14.5 19.7 27.6l-.2 1c-6.5 38.7-40 67.1-79.2 67.1C516 480 480 444 480 399.7V380.8c-24-4.1-45.9-13.9-64-28.1V464c0 26.5-21.5 48-48 48H320c-26.5 0-48-21.5-48-48V411.7c-21.2 2.8-42.8 2.8-64 0V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V392c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48V384c0-7 3-13.6 8.3-18.1s12.2-6.6 19.1-5.6l24.3 3.5c18.8 2.7 37.8 2.7 56.6 0l24.3-3.5c6.9-1 13.9 1.1 19.1 5.6S320 377 320 384v80h48V312c0-13.3 10.7-24 24-24c11.2 0 20.6 7.6 23.2 18c18.7 26.7 51.6 44.9 89.5 44.9c30.1 0 57.1-11.4 76.3-29.6c6.4-6.1 16.5-5.8 22.6 .6s5.8 16.5-.6 22.6c-19.9 18.9-46 31.9-75 36.5zM432 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faEarthAfrica = {
  prefix: 'far',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M464 256c0-19.4-2.6-38.1-7.6-55.9L429 194.6c-7.7-1.5-15.4 2.3-18.9 9.2c-5.8 11.6-19.2 17.1-31.5 13l-14.1-4.7c-7.7-2.6-16.1-.6-21.8 5.1c-3.7 3.7-3.7 9.7 0 13.4l33.5 33.5c5 5 7.8 11.8 7.8 18.9c0 12.3-8.4 23-20.3 26l-5.3 1.3c-3.8 .9-6.4 4.3-6.4 8.2v12.1c0 13.8-4.5 27.3-12.8 38.4l-25.6 34.1c-6 8.1-15.5 12.8-25.6 12.8c-17.7 0-32-14.3-32-32V336c0-8.8-7.2-16-16-16H208c-26.5 0-48-21.5-48-48V244c0-12.6 5.9-24.4 16-32l39.4-29.5c5.6-4.2 12.4-6.5 19.4-6.5c3.5 0 6.9 .6 10.2 1.7l32 10.7c7.2 2.4 15 2.7 22.4 .9l35.4-8.8c10.2-2.5 17.3-11.7 17.3-22.2c0-8.7-4.9-16.6-12.6-20.5l-29.2-14.6c-3.7-1.8-8.1-1.1-11 1.8l-3.9 3.9c-4.6 4.6-10.9 7.2-17.4 7.2c-3.8 0-7.6-.9-11-2.6l-15.2-7.6c-6.7-3.4-14.9-1.6-19.6 4.3l-13.6 17c-5.5 6.9-15.8 7.4-22 1.2c-2.8-2.8-4.3-6.5-4.3-10.4V96.5c0-5.6-1.5-11-4.2-15.9l-10-17.4C101.7 94.1 48 168.8 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faGlobeAfrica = faEarthAfrica;
var faRainbow = {
  prefix: 'far',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 88C169.8 88 48 209.8 48 360v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V360C0 183.3 143.3 40 320 40s320 143.3 320 320v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V360C592 209.8 470.2 88 320 88zm0 224c-26.5 0-48 21.5-48 48v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V360c0-53 43-96 96-96s96 43 96 96v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V360c0-26.5-21.5-48-48-48zM160 360v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V360c0-114.9 93.1-208 208-208s208 93.1 208 208v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V360c0-88.4-71.6-160-160-160s-160 71.6-160 160z"]
};
var faCircleNotch = {
  prefix: 'far',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M215.1 26.3c3.6 12.7-3.7 26-16.5 29.7C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200c-12.7-3.6-20.1-16.9-16.5-29.7s16.9-20.1 29.7-16.5C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9c12.7-3.6 26 3.7 29.7 16.5z"]
};
var faTabletScreenButton = {
  prefix: 'far',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M48 448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V368H48v80zm0-128H400V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V320zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTabletAlt = faTabletScreenButton;
var faPaw = {
  prefix: 'far',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M193.9 189.7c-32.3 10.6-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5s-.3 86.2-32.6 96.8zm217.7 8.9c18.9-32.4 54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3s-29.1-51.7-10.2-84.1zm-311.3 0c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM277.5 92.9c14.3-42.9 52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8zM114.3 409.7c-1.4 3.7-2.3 8.5-2.3 14.2c0 4.5 3.6 8.1 8.1 8.1h3.4c2.2 0 4.3-.4 6.3-1.2l72.7-29.1c34.3-13.7 72.6-13.7 107 0l72.7 29.1c2 .8 4.2 1.2 6.3 1.2h3.4c4.5 0 8.1-3.6 8.1-8.1c0-5.7-.9-10.4-2.3-14.2C352.1 287.4 276.6 272 256 272s-96.1 15.4-141.7 137.7zM69.3 393C121.7 252.4 214.8 224 256 224s134.3 28.4 186.7 169c3.7 9.9 5.3 20.4 5.3 31c0 31-25.1 56.1-56.1 56.1h-3.4c-8.3 0-16.5-1.6-24.2-4.7l-72.7-29.1c-22.9-9.2-48.4-9.2-71.3 0l-72.7 29.1c-7.7 3.1-15.9 4.7-24.2 4.7h-3.4c-31 0-56.1-25.1-56.1-56.1c0-10.5 1.6-21.1 5.3-31z"]
};
var faMessageQuestion = {
  prefix: 'far',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM169.8 117.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCloud = {
  prefix: 'far',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96H504h3.3c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8v.2h-8H464 144C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8z"]
};
var faTrowelBricks = {
  prefix: 'far',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", "M240.8 4.8c-9.4-5.8-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2V152h89c3.6 13.8 16.1 24 31 24h88c26.5 0 48-21.5 48-48s-21.5-48-48-48H376c-14.9 0-27.4 10.2-31 24H256V32c0-11.1-5.7-21.4-15.2-27.2zM288 384h16 32H464v80H256V384h32zm-80 0v80H48V384H208zm256-48H336V272H464v64zM288 272v16 48H240 48c-26.5 0-48 21.5-48 48v80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V384c0-1.3-.1-2.7-.2-4c.1-1.3 .2-2.7 .2-4V272c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48z"]
};
var faSquare3 = {
  prefix: 'far',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32H280c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFaceFlushed = {
  prefix: 'far',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faFlushed = faFaceFlushed;
var faHospitalUser = {
  prefix: 'far',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", "M64 48H256c8.8 0 16 7.2 16 16V415.7c11.3-20 27.9-36.7 48-47.9V271.8 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H256c3.2 0 6.4-.2 9.5-.7c-6-10-9.5-21.8-9.5-34.4c0-4.4 .2-8.7 .7-13c-.2 0-.4 0-.7 0H64c-8.8 0-16-7.2-16-16V416h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V320h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V64c0-8.8 7.2-16 16-16zm72 64v24H112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V184h24c8.8 0 16-7.2 16-16V152c0-8.8-7.2-16-16-16H184V112c0-8.8-7.2-16-16-16H152c-8.8 0-16 7.2-16 16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"]
};
var faMicrowave = {
  prefix: 'far',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M512 80c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM432 136V344c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-312-8c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120z"]
};
var faChfSign = {
  prefix: 'far',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M0 115.3C0 69 38.2 32 83.9 32c30.9 0 59.6 17.4 73.6 45.3c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7C108.9 87.4 96.9 80 83.9 80C64.1 80 48 96.1 48 115.3V396.7C48 415.9 64.1 432 83.9 432c13 0 25-7.4 30.6-18.7c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2C143.5 462.6 114.7 480 83.9 480C38.2 480 0 443 0 396.7V115.3zM216 32c13.3 0 24 10.7 24 24V224H368V56c0-13.3 10.7-24 24-24s24 10.7 24 24V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H240V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zM448 56c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H496V224h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H496V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V56z"]
};
var faTentArrowLeftRight = {
  prefix: 'far',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512H451.1c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2V464H124.9c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1H374.4L312 360z"]
};
var faCartCircleArrowUp = {
  prefix: 'far',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H520.6L489.1 192.1c2.3-.1 4.6-.1 6.9-.1c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faTrashClock = {
  prefix: 'far',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c2 0 3.9-.1 5.8-.3c-18.2-12.9-33.8-29.1-45.9-47.7h-161c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3l-5.9 80.1c15.3-7.1 31.9-12 49.2-14.4l4.9-65.7H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faGavel = {
  prefix: 'far',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", "M313 7c9.3 9.3 9.4 24.3 .2 33.7L471.3 198.8c9.4-9.2 24.4-9.1 33.7 .2c9.4 9.4 9.4 24.6 0 33.9l-16.7 16.8L393 345l-16 16c-9.4 9.4-24.6 9.4-33.9 0c-9-9-9.4-23.5-.9-32.9L184 169.9c-9.4 8.4-23.9 8.1-32.9-.9c-9.4-9.4-9.4-24.6 0-33.9l16-16 95.2-95.3L279 7c9.4-9.4 24.6-9.4 33.9 0zM279.2 74.7L217.9 136 376 294.1l61.3-61.3L279.2 74.7zM223.4 254.6l33.9 33.9-49.8 49.8 7 7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0l7 7 49.8-49.8zm-79.4 88L54.6 432 80 457.4 169.4 368 144 342.6z"]
};
var faLegal = faGavel;
var faSprinklerCeiling = {
  prefix: 'far',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0V96c0 11.5 8.2 21.4 19.5 23.6L128 140.2V91.4L48 76.1V0H0zM256 91.4v48.9l108.5-20.7C375.8 117.4 384 107.5 384 96V0H336V76.1L256 91.4zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V208H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H192 296c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V56z"]
};
var faBrowsers = {
  prefix: 'far',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M144 352V128H528V352c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faTrillium = {
  prefix: 'far',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M203.3 16.2c11.8-11 29.8-11 41.5 0c12.1 11.3 33.1 32.5 51.2 58.8c17.9 26 34.2 58.9 34.2 93.4c0 7.3-.8 14.5-2.2 21.5c7.3 2.3 14.4 5.3 21.2 9.3l0 0c29.9 17.2 50.4 47.6 64.2 75.9c13.9 28.7 21.9 57.3 25.7 73.5c3.8 15.8-5.4 31.5-20.9 36.1c-16 4.8-44.9 12.2-76.8 14.6c-31.5 2.3-68.3-.1-98.2-17.2c-7-4-13.4-8.7-19.1-14c-5.7 5.3-12.1 10-19.1 14c-29.9 17.2-66.7 19.6-98.2 17.2c-31.9-2.4-60.9-9.8-76.8-14.6C14.3 380 5.1 364.4 8.8 348.5c3.8-16.2 11.8-44.8 25.7-73.5c13.7-28.3 34.2-58.8 64.2-75.9l0 0c6.9-3.9 14-7 21.3-9.3c-1.4-6.9-2.2-14.1-2.2-21.4c0-34.4 16.4-67.4 34.2-93.4c18.1-26.3 39.1-47.5 51.2-58.8zm122 224.5l0 0c-6.9-4-14.2-6.3-21.6-7.3c-9.9-1.3-18.6-7-23.6-15.6s-5.8-19-2-28.2c2.7-6.6 4.1-13.7 4.1-21.3v0c0-20.1-10-43.2-25.8-66.2C245.9 86.9 234 73.4 224 63.1c-9.9 10.2-21.9 23.8-32.4 39.1c-15.8 23-25.8 46.1-25.8 66.2c0 7.6 1.5 14.7 4.1 21.3c3.7 9.2 3 19.6-2 28.2s-13.8 14.3-23.6 15.6c-7.4 .9-14.8 3.3-21.7 7.3C105 250.9 89.8 271.1 77.7 296c-8 16.6-13.9 33.5-17.8 47.1c13.9 3.4 31.7 6.9 50.3 8.3c27.9 2.1 53.1-.9 70.8-11c7.1-4.1 12.9-9.3 17.4-15.4c6-8 15.5-12.8 25.6-12.8s19.5 4.7 25.6 12.8c4.5 6 10.4 11.3 17.4 15.4c17.6 10.1 42.9 13.1 70.8 11c18.6-1.4 36.4-4.9 50.3-8.3c-4-13.6-9.8-30.5-17.8-47.1c-12.1-25-27.3-45.1-44.9-55.2zM100.8 123.4c-3 11.8-4.8 24.1-4.8 36.6c0 6.2 .4 12.3 1.3 18.3c-7.8 2.7-15.4 6.1-22.7 10.3c-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31c14.7-1.9 44.4-2.8 83 10zm249.9 55c.9-6 1.3-12.1 1.3-18.4c0-12.5-1.8-24.8-4.8-36.6c38.6-12.8 68.2-11.9 83-10c14.9 1.9 23.7 17.1 17.9 31c-5.6 13.3-19 38.4-47.7 64.6c-8.1-7.7-17.1-14.6-27-20.3c-7.3-4.2-14.9-7.6-22.6-10.3zM205.1 497.1c-8.3-12.6-22.8-38.2-31-74.3c9.8-3.1 19.4-7.2 28.5-12.5c7.8-4.5 14.9-9.7 21.4-15.4c6.5 5.8 13.6 11 21.4 15.4c9.2 5.3 18.8 9.4 28.6 12.5c-8.2 36.1-22.6 61.6-31 74.2c-9.1 13.7-28.8 13.7-37.9 0zM184 240a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faMusicSlash = {
  prefix: 'far',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", "M545 0c17.1 0 31 13.9 31 31V143.5c0 .4 0 .7 0 1.1V368c0 16.7-6.2 32.2-16.7 45.1l71.5 56c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L208 137.7V120c0-10.5 6.9-19.8 16.9-22.9l311-95.7c3-.9 6-1.4 9.1-1.4zM256 175.3l31.7 24.9L528 126.3V54L256 137.7v37.6zm77.7 60.9l87.4 68.5C437.4 294.3 457.8 288 480 288c17.5 0 33.9 3.9 48 10.7V176.5L333.7 236.3zM463.4 337.9l58 45.4c4.6-5.6 6.6-11.4 6.6-15.3c0-9.8-12.9-32-48-32c-6.2 0-11.7 .7-16.6 1.9zM208 259.9l48 37.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c17.5 0 33.9 3.9 48 10.7V259.9zM160 400c-35.1 0-48 22.2-48 32s12.9 32 48 32s48-22.2 48-32s-12.9-32-48-32z"]
};
var faTruckRamp = {
  prefix: 'far',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", "M440 0c-48.6 0-88 39.4-88 88V373.8L17.7 464.8C4.9 468.3-2.6 481.5 .8 494.3s16.7 20.3 29.5 16.8L416.2 406c3.1 59.1 52 106 111.8 106c61.9 0 112-50.1 112-112s-50.1-112-112-112c-45.3 0-84.3 26.9-102 65.6l-.4 .1-25.7 7V88c0-22.1 17.9-40 40-40H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H440zm88 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faBinoculars = {
  prefix: 'far',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V80H96V64zM59.6 158c4.8-26.6 28-46 55.1-46H200c13.3 0 24 10.7 24 24v24h64V136c0-13.3 10.7-24 24-24h85.3c27.1 0 50.3 19.4 55.1 46l5 27.3c3.6 19.9 10.8 39 21.2 56.4l2.6 4.4c20.1 33.6 30.8 72 30.8 111.1V424c0 30.9-25.1 56-56 56H344c-30.9 0-56-25.1-56-56V288H224V424c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V357.2C0 318 10.6 279.6 30.8 246l2.6-4.4c10.4-17.4 17.6-36.5 21.2-56.4l5-27.3zm55.1 2c-3.9 0-7.2 2.8-7.9 6.6l-5 27.3C97.2 219.5 88 244 74.6 266.4l-2.6 4.4C56.3 296.9 48 326.7 48 357.2V424c0 4.4 3.6 8 8 8H168c4.4 0 8-3.6 8-8V160H114.7zm282.6 0H336V424c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8V357.2c0-30.4-8.3-60.3-23.9-86.4l-2.6-4.4c-13.4-22.3-22.6-46.9-27.3-72.5l-5-27.3c-.7-3.8-4-6.6-7.9-6.6zM352 32h32c17.7 0 32 14.3 32 32V80H320V64c0-17.7 14.3-32 32-32z"]
};
var faMicrophoneSlash = {
  prefix: 'far',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM272 187.9V96c0-26.5 21.5-48 48-48s48 21.5 48 48V256c0 2.3-.2 4.6-.5 6.8L272 187.9zm-80 59.4L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7z"]
};
var faBoxTissue = {
  prefix: 'far',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M208 48H117.5l57.1 228.4 2.9 11.6H332.3l7.1-17.8L389.9 144H336c-31.1 0-56.2-9.9-75.5-28.2c-15.8-15-25.1-33.7-30.5-44.6l-.9-1.8C222.3 56 219.8 52 217.5 49.8c-.5-.5-.8-.6-1.3-.8c-.7-.3-3-1-8.2-1zM384 288h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h8l-8-32-12-48L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L416 208l-19.2 48L384 288zM75 208l12 48H48V368H464V256H431.3l19.2-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48H75zM48 416v48H464V416H48z"]
};
var faCircleC = {
  prefix: 'far',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"]
};
var faStarChristmas = {
  prefix: 'far',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M279.2 17.9C276.5 7.4 266.9 0 256 0s-20.5 7.4-23.2 17.9L188.3 188.3 17.9 232.8C7.4 235.5 0 245.1 0 256s7.4 20.5 17.9 23.2l170.4 44.4 44.4 170.4c2.8 10.6 12.3 17.9 23.2 17.9s20.5-7.4 23.2-17.9l44.4-170.4 170.4-44.4c10.6-2.8 17.9-12.3 17.9-23.2s-7.4-20.5-17.9-23.2L323.7 188.3 279.2 17.9zm-48 196.1l24.8-95 24.8 95c2.2 8.4 8.8 15 17.2 17.2l95 24.8-95 24.8c-8.4 2.2-15 8.8-17.2 17.2l-24.8 95-24.8-95c-2.2-8.4-8.8-15-17.2-17.2l-95-24.8 95-24.8c8.4-2.2 15-8.8 17.2-17.2zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zM441 71c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336l-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z"]
};
var faChartBullet = {
  prefix: 'far',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M264 32c13.3 0 24 10.7 24 24v8H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64H240V56c0-13.3 10.7-24 24-24zM160 112v64h80V112H160zm128 0v64H464V112H288zm-176 0H48v64h64V112zM360 256c13.3 0 24 10.7 24 24v8h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H384v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H336v-8c0-13.3 10.7-24 24-24zM224 336v64H336V336H224zm160 0v64h80V336H384zm-208 0H48v64H176V336z"]
};
var faMotorcycle = {
  prefix: 'far',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M292.5 224.7c11.1 14.3 20.4 30.2 27.5 47.2c15.3-36.5 40.6-67.8 72.6-90.2l-15.3-28.2-84.9 71.3zM304 384H288V352c0-88.4-71.6-160-160-160H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c49.6 0 95.1 17.3 130.8 46.3l95.2-80L337.7 80H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h62.5c14.7 0 28.2 8.1 35.2 21l13.9 25.8 46.7-39.3c5.8-4.8 13.1-7.5 20.6-7.5H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H418.2l55.1 102c12.2-3.9 25.2-6 38.7-6c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128c0-40 18.4-75.7 47.1-99.2l-15.4-28.6C377 253.4 352 299.8 352 352v32H304v0zm128-32c0 44.2 35.8 80 80 80s80-35.8 80-80s-35.8-80-80-80c-5.2 0-10.3 .5-15.2 1.4l36.3 67.1c6.3 11.7 2 26.2-9.7 32.5s-26.2 2-32.5-9.7l-36.3-67.1c-14 14.4-22.6 34.1-22.6 55.7zM204.3 328c-10.2-32.5-40.5-56-76.3-56c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H149.2c-5.6 5-13.1 8-21.2 8c-17.7 0-32-14.3-32-32s14.3-32 32-32c8.1 0 15.5 3 21.2 8h55.2zM128 224a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faTreeChristmas = {
  prefix: 'far',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", "M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zm125.3 60.5l15.8-5.9 122 193.1c4.7 7.4 4.9 16.7 .7 24.4s-12.3 12.4-21 12.4H367.7l76.5 119.5c4.7 7.4 5 16.8 .8 24.5s-12.3 12.5-21.1 12.5H24c-8.8 0-16.8-4.8-21.1-12.5s-3.9-17.1 .8-24.5L80.3 355.5H55c-8.7 0-16.8-4.8-21-12.4s-3.9-17 .7-24.4l122-193.1 15.8 5.9L185 165c.4 1.2 .9 2.3 1.4 3.4L98.6 307.5h25.6c8.8 0 16.8 4.8 21.1 12.5s3.9 17.1-.8 24.5L67.9 464H380.1L303.6 344.5c-4.7-7.4-5.1-16.8-.8-24.5s12.3-12.5 21.1-12.5h25.6L261.5 168.4c.5-1.1 1-2.2 1.4-3.4l12.6-33.5zM160 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTireFlat = {
  prefix: 'far',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M464 288c0-114.9-93.1-208-208-208S48 173.1 48 288c0 31 6.8 60.3 18.8 86.7c6.9 15.1 7 33-.8 48.5L48.4 458.5c-.3 .5-.4 1.1-.4 1.7c0 2.1 1.7 3.8 3.8 3.8H132 380h80.2c2.1 0 3.8-1.7 3.8-3.8c0-.6-.1-1.2-.4-1.7l-17.7-35.3c-7.8-15.6-7.7-33.4-.8-48.5C457.2 348.3 464 319 464 288zm48 0c0 38.1-8.3 74.2-23.2 106.7c-1 2.2-1 4.8 .1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2c0 28.6-23.2 51.8-51.8 51.8H380 132 51.8C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8 .1-7C8.3 362.2 0 326.1 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256zm-136 0c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5l0 .9 39.2 12.8c.5-4.5 .8-9 .8-13.6zm-54.9 46.5c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 364.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3l0-41.3zM136 288c0 4.6 .3 9.2 .8 13.6L176 288.9l0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 228.4 136 256.8 136 288zm120-80c8.9 0 17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 210l1.6 2.2c8-2.7 16.6-4.2 25.6-4.2zM88 288a168 168 0 1 1 336 0A168 168 0 1 1 88 288zm200 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSunglasses = {
  prefix: 'far',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6v5.2l0 1.5V352l0 .6V368c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352v16c0 2.6 .2 5.2 .5 7.8l144.4-72.2c-18.8-5-38.3-7.6-57.2-7.6c-29.5 0-60.5 6.4-87.7 18.2V352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c0 .8 .1 1.7 .2 2.5l141-70.5c-18.6-4.9-38-7.5-56.7-7.5z"]
};
var faBadge = {
  prefix: 'far',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M256 48c-24.1 0-45.1 13.5-55.7 33.5C194.9 91.7 183 96.6 172 93.2c-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172c3.4 11-1.5 22.9-11.7 28.2C61.5 210.9 48 231.9 48 256s13.5 45.1 33.5 55.7C91.7 317.1 96.6 329 93.2 340c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7c11-3.4 22.9 1.5 28.2 11.7c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5c5.4-10.2 17.2-15.1 28.2-11.7c21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1c-3.4-11 1.5-22.9 11.7-28.2c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7c-10.2-5.4-15.1-17.2-11.7-28.2c6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2c-11 3.4-22.9-1.5-28.3-11.7C301.1 61.5 280.1 48 256 48zm-88.1-4.6C188.2 17 220.1 0 256 0s67.8 17 88.1 43.4c33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6z"]
};
var faMessagePen = {
  prefix: 'far',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM340.8 123c-14.7-14.7-38.6-14.7-53.3 0L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6l-71.9 71.9z"]
};
var faCommentAltEdit = faMessagePen;
var faMessageEdit = faMessagePen;
var faBellConcierge = {
  prefix: 'far',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H80c0-97.2 78.8-176 176-176s176 78.8 176 176h48c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faConciergeBell = faBellConcierge;
var faPenRuler = {
  prefix: 'far',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", "M13.4 439l23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10c16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8c-9.6 8.5-21 14.8-33.4 18.4L73 498.6 30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L13.4 439zm62.2-41.2L59.4 452.6l54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191 321 129 92.5 357.4c-.6 .6-1.2 1.2-1.7 1.8c-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zM173.3 27.3l65.2 65.2-33.9 33.9-26.2-26.2-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23L139.3 61.3c-6.2-6.2-16.4-6.2-22.6 0L61.3 116.7c-6.2 6.2-6.2 16.4 0 22.6l65.2 65.2L92.5 238.5 27.3 173.3c-25-25-25-65.5 0-90.5L82.7 27.3c25-25 65.5-25 90.5 0zM372.7 450.7c6.2 6.2 16.4 6.2 22.6 0l55.4-55.4c6.2-6.2 6.2-16.4 0-22.6l-16.4-16.4-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23-26.2-26.2 33.9-33.9 65.2 65.2c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0l-65.2-65.2 33.9-33.9 65.2 65.2z"]
};
var faPencilRuler = faPenRuler;
var faArrowProgress = {
  prefix: 'far',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M472 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 384 64zM0 160C0 93.7 53.7 40 120 40H256V17.9C256 8 264 0 273.9 0c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9V88H120c-39.8 0-72 32.2-72 72s32.2 72 72 72H392c66.3 0 120 53.7 120 120c0 59.5-43.3 108.8-100 118.3c-9.1 24.3-32.5 41.7-60 41.7c-35.3 0-64-28.7-64-64s28.7-64 64-64c25.9 0 48.3 15.4 58.3 37.6c30.9-8.1 53.7-36.2 53.7-69.6c0-39.8-32.2-72-72-72H120C53.7 280 0 226.3 0 160zM123.3 424H160V401.9c0-9.9 8-17.9 17.9-17.9c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9V472H123.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40zM88 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm264 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faChessRookPiece = {
  prefix: 'far',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M16 120c0-13.3 10.7-24 24-24H280c13.3 0 24 10.7 24 24V224c0 5.6-2 11.1-5.6 15.4l-33.9 40.7 4.2 71.9H220.7L216 273.4c-.4-6.1 1.6-12.1 5.5-16.8L256 215.3V144H216v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V144H136v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V144H64v71.3l34.4 41.3c3.9 4.7 5.9 10.7 5.5 16.8L99.3 352H51.3l4.2-71.9L21.6 239.4C18 235.1 16 229.6 16 224V120zM136 280.9V248c0-13.3 10.7-24 24-24s24 10.7 24 24v32.9c0 3.9-3.2 7.1-7.1 7.1H143.1c-3.9 0-7.1-3.2-7.1-7.1zM52.7 464H267.3l-16.6-32H69.2L52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h201z"]
};
var faChessRookAlt = faChessRookPiece;
var faSquareRoot = {
  prefix: 'far',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H76.9c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8L290.3 72.9C297.1 48.7 319.2 32 344.3 32H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H344.3z"]
};
var faAlbumCollectionCirclePlus = {
  prefix: 'far',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", "M56 0H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160H442.4c23.9 0 44.4 13 55.4 32l-1.8 0c-26.2 0-51.1 5.7-73.4 16H69.6c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9H348.5c12.3 18.8 28 35.1 46.3 48H99.1c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faPeopleArrows = {
  prefix: 'far',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3C68.8 296 76.2 304 85.6 304H88h40c0 14.3 5.5 28.7 16.4 39.6L192 391.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H112V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.6 1.8-5.2 4-7.5 6.3l-28.1 28.1c-4.6-12.1-16.3-20.5-29.9-20.5H105.6zM448 488V391.2l47.6-47.6C506.5 332.7 512 318.3 512 304h40 2.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C564.9 220.8 551 208 534.4 208H489.6c-13.5 0-25.2 8.4-29.9 20.5l-28.1-28.1c-2.4-2.4-4.9-4.5-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H496V488c0 13.3-10.7 24-24 24s-24-10.7-24-24zm0-424a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM265 257l-23 23H398.1l-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23H241.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faFaceAngryHorns = {
  prefix: 'far',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zm72.4-102.5c9.7-9 10.2-24.2 1.2-33.9C379.3 360.3 354.6 344 320 344s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM240.4 288c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faMarsAndVenusBurst = {
  prefix: 'far',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M520 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h38.1l-54.2 54.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2V416H344c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v24c0 13.3 10.7 24 24 24s24-10.7 24-24V464h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H424V382.2c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L592 81.9V112c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H520zM288 224a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM176 8c-8.9 0-17 4.9-21.2 12.7L124.7 77.5 61.6 65.6c-8.7-1.6-17.6 1.7-23.2 8.6s-6.8 16.4-3.3 24.5l25.6 58.9-48.6 42c-6.7 5.8-9.7 14.8-7.7 23.5s8.6 15.5 17.1 17.8l62 16.7 2.5 64.2c.3 8.9 5.6 16.8 13.6 20.7s17.5 3 24.6-2.3l51.7-38 51.7 38c6.4 4.7 14.7 5.9 22.1 3.3c-16.9-21.2-29.4-46.1-36.2-73.3l-23.4-17.2c-8.5-6.2-20-6.2-28.4 0l-29.5 21.7-1.4-36.6c-.4-10.5-7.6-19.5-17.7-22.2l-35.4-9.6 27.7-24c7.9-6.9 10.5-18.1 6.3-27.7L97.2 121.1l36 6.7c10.3 1.9 20.7-3.1 25.6-12.3L176 83.2l17.2 32.4c4.9 9.3 15.3 14.3 25.6 12.3l16.8-3.1c14.3-23.6 33.4-43.8 56.1-59.3c-.4 .1-.9 .1-1.3 .2L227.3 77.5 197.2 20.7C193 12.9 184.9 8 176 8z"]
};
var faTombstone = {
  prefix: 'far',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M368 432V192c0-79.5-64.5-144-144-144S80 112.5 80 192V432H32V192C32 86 118 0 224 0S416 86 416 192V432H368zM0 488c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM248 152v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V240H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSquareCaretRight = {
  prefix: 'far',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"]
};
var faCaretSquareRight = faSquareCaretRight;
var faScissors = {
  prefix: 'far',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M506.4 439.4c-8.5 10.2-23.7 11.5-33.8 3L312.4 308.2l37.4-31.3L503.4 405.6c10.2 8.5 11.5 23.7 3 33.8zM112 48a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-48c61.9 0 112 50.1 112 112c0 17.9-4.2 34.8-11.6 49.8l75.1 62.9L472.6 69.6c10.2-8.5 25.3-7.2 33.8 3s7.2 25.3-3 33.8l-291 243.8c7.4 15 11.6 31.9 11.6 49.8c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c26.6 0 51.1 9.3 70.3 24.8L250.1 256l-67.8-56.8C163.1 214.7 138.6 224 112 224C50.1 224 0 173.9 0 112S50.1 0 112 0zm64 400A64 64 0 1 0 48 400a64 64 0 1 0 128 0z"]
};
var faCut = faScissors;
var faListMusic = {
  prefix: 'far',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", "M481.1 0C498.2 0 512 13.8 512 30.9V136c0 10.4-6.7 19.6-16.6 22.8L384 194.7V432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c23.8 0 45.9 5.3 64 14.3V64c0-10.3 6.6-19.5 16.4-22.8L471.4 1.6c3.1-1 6.4-1.6 9.8-1.6zM323.3 414.5c-11.2-8-29.2-14.5-51.3-14.5s-40.1 6.5-51.3 14.5C209.4 422.6 208 429.4 208 432s1.4 9.4 12.7 17.5c11.2 8 29.2 14.5 51.3 14.5s40.1-6.5 51.3-14.5c11.3-8.1 12.7-14.9 12.7-17.5s-1.4-9.4-12.7-17.5zM384 144.3l80-25.8V54.6L384 81.3v63zM24 48H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 96 0 85.3 0 72S10.7 48 24 48zm0 128H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSunPlantWilt = {
  prefix: 'far',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M160-.2c-8.4 0-16.2 4.4-20.5 11.6L115.2 51.7 69.6 40.4c-8.2-2-16.8 .4-22.7 6.3s-8.3 14.6-6.3 22.7l11.3 45.6L11.6 139.4C4.4 143.7 0 151.5 0 159.9s4.4 16.2 11.6 20.5l40.2 24.3L40.5 250.4c-2 8.2 .4 16.8 6.3 22.7s14.6 8.3 22.7 6.3l45.6-11.3 24.3 40.2c4.3 7.2 12.1 11.6 20.5 11.6s16.2-4.4 20.5-11.6l24.3-40.2 45.6 11.3c8.2 2 16.8-.4 22.7-6.3s8.3-14.6 6.3-22.7l-11.3-45.6 40.2-24.3c7.2-4.3 11.6-12.1 11.6-20.5s-4.4-16.2-11.6-20.5l-40.2-24.3 11.3-45.6c2-8.2-.4-16.8-6.3-22.7s-14.6-8.3-22.7-6.3L204.9 51.7 180.6 11.4C176.2 4.2 168.5-.2 160-.2zm0 70.4l12.9 21.3c5.4 9 16.1 13.4 26.3 10.9l24.2-6-6 24.2c-2.5 10.2 1.9 20.9 10.9 26.3l21.3 12.9-21.3 12.9c-9 5.4-13.4 16.1-10.9 26.3l6 24.2-24.2-6c-10.2-2.5-20.9 1.9-26.3 10.9L160 249.6l-12.9-21.3c-5.4-9-16.1-13.4-26.3-10.9l-24.2 6 6-24.2c2.5-10.2-1.9-20.9-10.9-26.3L70.4 159.9 91.8 147c9-5.4 13.4-16.1 10.9-26.3l-6-24.2 24.2 6c10.2 2.5 20.9-1.9 26.3-10.9L160 70.3zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V464L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0V280v-8V176z"]
};
var faToiletsPortable = {
  prefix: 'far',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", "M72 48H184c13.3 0 24 10.7 24 24V96H48V72c0-13.3 10.7-24 24-24zM48 432V144H208v80H184c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h24V432H48zm0 56v-8H208v8c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-39.8-32.2-72-72-72H72C32.2 0 0 32.2 0 72V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM392 48H504c13.3 0 24 10.7 24 24V96H368V72c0-13.3 10.7-24 24-24zM368 432V144H528v80H504c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h24V432H368zm0 56v-8H528v8c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-39.8-32.2-72-72-72H392c-39.8 0-72 32.2-72 72V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faHockeyPuck = {
  prefix: 'far',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M48 184c0 4.8 2.3 11.7 11 20.2c8.8 8.6 22.8 17.5 42.1 25.5C139.6 245.6 194.3 256 256 256s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5c8.7-8.6 11-15.4 11-20.2s-2.3-11.7-11-20.2c-8.8-8.6-22.8-17.5-42.1-25.5C372.4 122.4 317.7 112 256 112s-116.4 10.4-154.9 26.3c-19.3 8-33.3 16.9-42.1 25.5c-8.7 8.6-11 15.4-11 20.2zM0 184c0-21.7 10.7-40.1 25.4-54.5c14.7-14.3 34.6-26.1 57.3-35.5C128.3 75.1 189.6 64 256 64s127.7 11.1 173.2 29.9c22.7 9.4 42.7 21.2 57.3 35.5C501.3 143.9 512 162.3 512 184V328c0 21.7-10.7 40.1-25.4 54.5c-14.6 14.3-34.6 26.1-57.3 35.5C383.7 436.9 322.4 448 256 448s-127.7-11.1-173.2-29.9c-22.7-9.4-42.7-21.2-57.3-35.5C10.7 368.1 0 349.7 0 328V184zm464 72.2c-10.5 6.7-22.2 12.6-34.8 17.9C383.7 292.9 322.4 304 256 304s-127.7-11.1-173.2-29.9c-12.6-5.2-24.3-11.1-34.8-17.9V328c0 4.8 2.3 11.7 11 20.2c8.8 8.6 22.8 17.5 42.1 25.5C139.6 389.6 194.3 400 256 400s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5c8.7-8.6 11-15.4 11-20.2V256.2z"]
};
var faMustache = {
  prefix: 'far',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M233.4 112c-32.9 0-64.4 13.1-87.7 36.3c-28.5 28.5-74.2 29.8-104.3 3.1l-1.5-1.3c-2.7-2.4-5.8-4.1-9-5c-1.3-.4-2.7-.7-4.1-.9c-1.1-.1-2.2-.2-3.3-.2c-3.6 .1-7 .9-10.1 2.4c-2.2 1-4.2 2.4-6 4.2C2.9 154.9 0 161.1 0 168v34C0 311.4 88.6 400 198 400c42.8 0 84.5-13.9 118.8-39.6L320 358l3.2 2.4c34.3 25.7 76 39.6 118.8 39.6c109.4 0 198-88.6 198-198V168c0-6.9-2.9-13.1-7.5-17.4c-4.2-4-9.8-6.5-16.1-6.6c-.4 0-.9 0-1.3 0c-2.4 .1-4.8 .5-7.1 1.3c-2.9 1-5.6 2.6-8 4.7l-1.5 1.3c-30.1 26.7-75.8 25.4-104.3-3.1C471 125.1 439.5 112 406.6 112h-1.2c-29.7 0-58.5 10.4-81.3 29.5l-4 3.3-4-3.3c-22.8-19-51.6-29.5-81.3-29.5h-1.2zm358.3 98.7C587.3 289.5 521.9 352 442 352c-32.5 0-64-10.5-90-30l-17.6-13.2c-8.5-6.4-20.3-6.4-28.8 0L288 322c-26 19.5-57.5 30-90 30c-79.9 0-145.3-62.5-149.8-141.3c44.3 16.7 96 7 131.4-28.4C193.9 168 213.3 160 233.4 160h1.2c18.5 0 36.4 6.5 50.6 18.3l19.3 16.1c8.9 7.4 21.8 7.4 30.7 0l19.3-16.1c14.2-11.8 32.1-18.3 50.6-18.3h1.2c20.2 0 39.5 8 53.8 22.3c35.4 35.4 87.1 45.1 131.4 28.4z"]
};
var faHyphen = {
  prefix: 'far',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 256c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
};
var faTable = {
  prefix: 'far',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M48 264V160H232V264H48zm0 48H232V432H64c-8.8 0-16-7.2-16-16V312zM280 432V312H464V416c0 8.8-7.2 16-16 16H280zM464 264H280V160H464V264zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faUserChef = {
  prefix: 'far',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M384 48c0 20.9-13.4 38.7-32 45.3V112v64c0 70.7-57.3 128-128 128s-128-57.3-128-128V112 93.3C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176V160H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM169.4 438c-5.7 2.6-9.4 8.3-9.4 14.6V464H397.1c-7.7-28.9-30.1-51.9-58.8-60.4L304 393.4V379.1l-13.1 3.8L169.4 438zM128 452.6c0-18.8 11-35.9 28.1-43.7l35.6-16.2L144 379.1v14.3l-34.3 10.2c-28.6 8.5-51 31.5-58.8 60.4H128V452.6zM0 486.4c0-60.9 40.5-112.3 96-128.8V334c0-7.8 6.3-14 14-14c1.3 0 2.6 .2 3.9 .5L224 352l110.1-31.5c1.3-.4 2.6-.5 3.9-.5c7.8 0 14 6.3 14 14v23.5c55.5 16.5 96 68 96 128.8c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4zM272 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faMessageImage = {
  prefix: 'far',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492zm88-348c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H256 208 160c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zM176 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCommentAltImage = faMessageImage;
var faUsersMedical = {
  prefix: 'far',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H605.3c-6.6-18.6-24.4-32-45.3-32H528c-20.9 0-38.7 13.4-45.3 32H405.3zm-26.7 32c19.3 0 37.6 4.1 54.2 11.5C422.5 372.3 416 385.4 416 400v8.6c-11.3-5.5-23.9-8.6-37.3-8.6H261.3c-39.8 0-73.2 27.2-82.6 64H428.2c8.8 9.8 21.6 16 35.8 16h16v16c0 5.6 1 11 2.7 16H154.7c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352H378.7zM320 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM512 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H576v48c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V448H464c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16h48V336z"]
};
var faSensorTriangleExclamation = {
  prefix: 'far',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M64 80H384c8.8 0 16 7.2 16 16v49.9c13.1-11.4 30.1-17.9 48-17.9V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H225c-.6-4-1-8.1-1-12.3c0-12.5 3-24.7 8.9-35.7H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm21.8 293.8c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3H595.7c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265zM464 272v88c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSensorAlert = faSensorTriangleExclamation;
var faMagnifyingGlassArrowRight = {
  prefix: 'far',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm33-289c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23H128c-13.3 0-24 10.7-24 24s10.7 24 24 24H230.1l-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
var faTachographDigital = {
  prefix: 'far',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm112 16H336c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32zM80 352c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H544c8.8 0 16 7.2 16 16s-7.2 16-16 16H416c-8.8 0-16-7.2-16-16zM96 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDigitalTachograph = faTachographDigital;
var faFaceMask = {
  prefix: 'far',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", "M128 388.9c-27.6-33.2-45.1-75.1-47.7-121l50.1 26.7c-1.6 5.5-2.4 11.4-2.4 17.4v76.9zM36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9c-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6c-3.6-6.8-11.4-9.9-18.5-7.9C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6zm45 23.6C93.2 128.5 181.2 48 288 48s194.8 80.5 206.7 184.2L429.5 267c-11.6-11.7-27.7-19-45.5-19H192c-17.8 0-33.9 7.2-45.5 19L81.3 232.2zm414.3 35.7c-2.6 45.9-20.1 87.8-47.7 121V312c0-6-.8-11.9-2.4-17.4l50.1-26.7zM170.4 207.4c4.8-5.7 26.7-23.4 61.6-23.4c13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.4 0-85.4 25-98.4 40.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1zM176 312c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16v8H176v-8zm0 40H400v32H176V352zm0 64H400c0 13.3-10.7 24-24 24H288 200c-13.3 0-24-10.7-24-24zM344 184c36.4 0 58.7 15.3 63 19.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-13.5-13.5-48.1-33.7-97-33.7c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faPickleball = {
  prefix: 'far',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M284.3 61.9c18.8-18.7 49.2-18.7 68 0L465.9 175.2c14.8 14.8 17.9 36.9 9.3 54.7c15.7 4.4 30.4 11.1 43.8 19.8c16.6-35.5 10.3-79.1-19.1-108.4L386.3 28C348.8-9.4 287.9-9.4 250.4 28L92.5 185.5c-22.9 22.9-29.8 57.3-17.3 87.2l18.3 43.8c5 12 2.2 25.7-6.9 34.9L34.8 402.9c-25 24.9-25 65.4 0 90.4s65.6 25 90.7 0l52-51.8c9.1-9.1 22.9-11.8 34.8-7l42.5 17.4c11.4 4.7 23.4 6.6 35.2 5.8c-8-15.3-13.6-32.1-16.2-49.9c-.3-.1-.5-.2-.8-.3l-42.5-17.4c-29.9-12.2-64.2-5.4-87.1 17.4l-52 51.8c-6.3 6.2-16.4 6.2-22.7 0c-6.3-6.2-6.2-16.3 0-22.6l51.7-51.5c23-22.9 29.8-57.3 17.3-87.2l-18.3-43.8c-4.5-10.9-2.7-23.3 4.6-32.3l148.4 148c1.7-19 6.6-37 14.3-53.5L158 187.9l126.3-126zM560 384a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM368 368a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm32-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM464 304a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z"]
};
var faStarSharpHalf = {
  prefix: 'far',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M291.7 .3C303.4 2.1 312 12.2 312 24V376c0 7.4-3.4 14.4-9.3 18.9l-144 112c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l50.9-160.1L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176H214.5L265.1 16.7C268.7 5.4 280-1.5 291.7 .3zM264 178.6l-9.1 28.7c-3.2 10-12.4 16.7-22.9 16.7H126l88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2L190.3 421.6 264 364.3V178.6z"]
};
var faUsersSlash = {
  prefix: 'far',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM281.5 195.3c8.8-11.7 22.7-19.3 38.5-19.3c26.5 0 48 21.5 48 48c0 11.6-4.1 22.2-11 30.5l-75.5-59.2zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8l-49.7-39.1c.7 1.9 1.2 3.9 1.8 5.9H178.7c9.5-36.8 42.9-64 82.6-64H378.7c2.6 0 5.1 .1 7.6 .3L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"]
};
var faClover = {
  prefix: 'far',
  iconName: 'clover',
  icon: [448, 512, [], "e139", "M174.4 80c-14.4 0-26 11.7-26 26c0 6.6 1.7 13.2 5 18.9l35.6 63.2c5.3 9.4 3.7 21.1-3.9 28.8s-19.4 9.2-28.8 3.9L93 185.3c-5.8-3.3-12.3-5-18.9-5c-14.4 0-26 11.7-26 26V209c0 7.6 3 14.9 8.4 20.3l9.8 9.8c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-9.8 9.8C51 288.2 48 295.4 48 303v2.6c0 14.4 11.7 26 26 26c6.6 0 13.2-1.7 18.9-5l63.2-35.6c9.4-5.3 21.1-3.7 28.8 3.9s9.2 19.4 3.9 28.8L153.3 387c-3.3 5.8-5 12.3-5 18.9c0 14.4 11.7 26 26 26H177c7.6 0 14.9-3 20.3-8.4l9.8-9.8c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l9.8 9.8c5.4 5.4 12.7 8.4 20.3 8.4h2.6c14.4 0 26-11.7 26-26c0-6.6-1.7-13.2-5-18.9l-35.6-63.2c-5.3-9.4-3.7-21.1 3.9-28.8s19.4-9.2 28.8-3.9L355 326.7c5.8 3.3 12.3 5 18.9 5c14.4 0 26-11.7 26-26V303c0-7.6-3-14.9-8.4-20.3l-9.8-9.8c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l9.8-9.8c5.4-5.4 8.4-12.7 8.4-20.3v-2.8c0-14.3-11.6-25.9-25.9-25.9c-6.7 0-13.3 1.7-19.1 5.1l-61.9 35.5c-9.3 5.3-21.1 3.8-28.7-3.7s-9.4-19.2-4.2-28.7l34.7-63.4c3.1-5.7 4.8-12.2 4.8-18.7c0-14.6-11.8-26.4-26.4-26.4H271c-7.6 0-14.9 3-20.3 8.4L241 98.2c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-9.8-9.8C191.8 83 184.6 80 177 80h-2.6zm-74 26c0-40.9 33.2-74 74-74H177c17.1 0 33.7 5.7 47 16.1C237.4 37.7 253.9 32 271 32h2.3c41.1 0 74.4 33.3 74.4 74.4c0 11.1-2.1 22.1-6.3 32.4c10.3-4.2 21.4-6.4 32.7-6.4c40.8 0 73.9 33.1 73.9 73.9V209c0 17.1-5.7 33.7-16.1 47c10.4 13.4 16.1 29.9 16.1 47v2.6c0 40.9-33.2 74-74 74c-11.2 0-22.3-2.2-32.7-6.4c4.2 10.3 6.4 21.4 6.4 32.7c0 40.9-33.2 74-74 74H271c-17.1 0-33.7-5.7-47-16.1c-13.4 10.4-29.9 16.1-47 16.1h-2.6c-40.9 0-74-33.2-74-74c0-11.2 2.2-22.3 6.4-32.7c-10.3 4.2-21.4 6.4-32.7 6.4c-40.9 0-74-33.2-74-74V303c0-17.1 5.7-33.7 16.1-47C5.7 242.6 0 226.1 0 209v-2.6c0-40.9 33.2-74 74-74c11.2 0 22.3 2.2 32.7 6.4c-4.2-10.3-6.4-21.4-6.4-32.7z"]
};
var faMeat = {
  prefix: 'far',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M443.2 138.7c8.1 13.4 13.9 26.9 17.3 39.8c.5 1.9 .9 3.8 1.3 5.7c2.4 11.6 2.8 22.5 .9 32.1c-1.9 10.1-6.2 18.8-13 25.6l-.2 .2c-29 28.7-92.5 11.9-142-37.6C258 154.8 241.2 91.1 270.2 62.2c1.8-1.8 3.7-3.4 5.8-4.8c.7-.5 1.3-.9 2-1.3c3-1.9 6.3-3.5 9.8-4.7c.6-.2 1.2-.4 1.9-.6c32.7-10.1 82.4 8.5 122.8 48.9c12.4 12.4 22.8 25.7 30.8 39.1zM388.8 302.1C363 323.9 330.1 336 296 336H208c-17.7 0-32-14.3-32-32V216c0-34.1 12.1-67 33.9-92.8c.8 5 1.9 9.9 3.1 14.6c9.3 35.3 30.9 70.9 60.6 100.6s65.3 51.4 100.6 60.6c4.7 1.2 9.6 2.3 14.6 3.1zM212.6 384H296c50.9 0 99.8-20.2 135.8-56.2L483.5 276c.1-.1 .2-.2 .3-.3c23.7-23.7 29.9-54.3 27.8-82.5c-.7-9.4-2.3-18.5-4.6-27c-5.8-22-16.4-44.1-30.7-64.8c-8.7-12.5-18.7-24.6-30-35.8C416.6 35.9 381.1 14.3 345.8 5c-34-8.9-78-8.3-109.5 23.2l-52 52c-36 36-56.2 84.8-56.2 135.8v83.4c0 7.1-2.8 13.9-7.8 18.9c-10.3 10.3-26.9 9.7-40.7 5C73.4 321.1 66.8 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-6.8-1.1-13.4-3.2-19.5c-4.7-13.8-5.3-30.4 5-40.7c5-5 11.8-7.8 18.9-7.8zm175-204.4c8.9-8.9 3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8s34.9 20.4 43.8 11.5z"]
};
var faReply = {
  prefix: 'far',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", "M224 240h96c66.2 0 122 44.7 138.8 105.5c3.3-12.4 5.2-26.2 5.2-41.5c0-70.7-57.3-128-128-128H224 200c-13.3 0-24-10.7-24-24V128 99.9L55.9 208 176 316.1V288 264c0-13.3 10.7-24 24-24h24zm0 48v48 16c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2V80v48h48 64c97.2 0 176 78.8 176 176c0 78-38.6 126.2-68.7 152.1c-4.1 3.5-8.1 6.6-11.7 9.3c-3.2 2.4-6.2 4.4-8.9 6.2c-4.5 3-8.3 5.1-10.8 6.5c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-6.8 3.6-13.2 8.3-18.1c.5-.5 .9-.9 1.4-1.4c2.4-2.3 5.1-5.1 7.7-8.6c1.7-2.3 3.4-5 5-7.9c5.3-9.7 9.5-22.9 9.5-40.2c0-53-43-96-96-96H272 224z"]
};
var faMailReply = faReply;
var faStarAndCrescent = {
  prefix: 'far',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", "M40 256c0 95.9 62.5 177.2 149 205.4C123.2 416.8 80 341.4 80 256s43.2-160.8 109-205.4C102.5 78.8 40 160.1 40 256zM256 0c22.2 0 43.7 2.8 64.2 8.1c2.6 .7 5.2 1.4 7.8 2.1c1.4 .4 2.8 .8 4.2 1.3c4.3 1.3 8.5 2.8 12.7 4.3c1.6 .6 3.1 1.2 4.7 1.8c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-1.7-.1-3.4-.2-5-.3c-3.2-.1-6.4-.2-9.6-.2c-.9 0-1.7 0-2.6 0c-3.2 0-6.5 .2-9.7 .3C206.6 54.7 120 145.2 120 256s86.6 201.3 195.7 207.6c3.2 .2 6.4 .3 9.7 .3c.9 0 1.7 0 2.6 0c3.2 0 6.4-.1 9.6-.2c1.7-.1 3.4-.2 5-.3c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4c-1.6 .6-3.1 1.2-4.7 1.8c-4.2 1.6-8.4 3-12.7 4.3c-1.4 .4-2.8 .8-4.2 1.3c-2.6 .8-5.2 1.5-7.8 2.1c-20.5 5.3-42 8.1-64.2 8.1C114.6 512 0 397.4 0 256S114.6 0 256 0zM357.2 174.2l1.7-3.4 10.9-22.2 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 10.9 22.2 1.7 3.4 13.3 27c1.4 2.8 4.1 4.8 7.2 5.3l29.8 4.3 3.7 .5 24.5 3.6 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-17.7 17.3-2.7 2.6-21.6 21c-2.3 2.2-3.3 5.4-2.8 8.5l5.1 29.7 .6 3.7 4.2 24.4 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-21.9-11.5-3.3-1.7-26.6-14c-2.8-1.5-6.1-1.5-8.9 0l-26.6 14-3.3 1.7-21.9 11.5-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 4.2-24.4 .6-3.7 5.1-29.7c.5-3.1-.5-6.3-2.8-8.5l-21.6-21-2.7-2.6-17.7-17.3-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 24.5-3.6 3.7-.5 29.8-4.3c3.1-.5 5.8-2.4 7.2-5.3l13.3-27zm-7.7 78.6a36.3 36.3 0 1 0 69 22.4 36.3 36.3 0 1 0 -69-22.4z"]
};
var faEmptySet = {
  prefix: 'far',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L396.5 81.5C358.1 50.6 309.2 32 256 32C132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.5-74.5c38.4 31 87.3 49.5 140.5 49.5c123.7 0 224-100.3 224-224c0-53.2-18.6-102.1-49.5-140.5L505 41zM362.3 115.7L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3L396.3 149.7C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176c-39.9 0-76.8-13.3-106.3-35.7z"]
};
var faHouseFire = {
  prefix: 'far',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L447.9 128.2c-12.5-1.1-25.5 2.8-35.4 11.7c-4.1 3.6-8 7.3-12 11L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h48V312c0-22.1 17.9-40 40-40h77c-7.7 15.7-13.8 32-17.4 48H240V464h84.8c13.5 18.8 30.3 35.1 49.6 48H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faSquareMinus = {
  prefix: 'far',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMinusSquare = faSquareMinus;
var faHelicopter = {
  prefix: 'far',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M128 24c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H384v80h8 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1c84 0 152 68.1 152 152v56c0 35.4-28.7 64-64 64h-.4-.4-.4-.4H510h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H503h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H498h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H493h-.4-.4-.4-.4-.4-.4-.4H490h-.4-.4-.4-.4-.4-.4-.4H487h-.4-.4-.4-.4-.4-.4-.4H484h-.4-.4-.4-.4-.4-.4-.4H481h-.4-.4-.4-.4-.4-.4-.4H478h-.4-.4-.4-.4-.4-.4-.4H475h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H471h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H467h-.4-.4-.4-.4-.4-.4-.4H464h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H460h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H456h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H451h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H447h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H442h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H438h-.4-.4H437h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H433h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H428h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H423h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H418h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H414h-.4-.4H413h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H409h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H405h-.4-.4H404h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H400h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H396h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H392h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H388h-.4-.4-.4-.4-.4-.4-.4H385h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H381h-.4-.4-.4-.4-.4-.4-.4H378h-.4-.4-.4-.4-.4-.4-.4H375h-.4-.4-.4-.4-.4-.4-.4H372h-.4-.4-.4-.4-.4-.4-.4H369h-.4-.4-.4-.4-.4-.4-.4H366h-.4-.4-.4-.4-.4-.4-.4H363h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H358h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H353h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H346h-.4-.4-.4-.4H344h-.4-.4-.4-.4H342h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H332h-.4-.4-.4-.4H330h-.4-.4-.4-.4H328h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H321h-.4c-17 0-33.3-6.7-45.3-18.7l-88.1-88.1c-.7-.7-1.5-1.3-2.4-1.7L61.4 236.7c-16.6-7.4-28.6-22.4-32.2-40.2L12.3 111.8C7.3 87.1 26.3 64 51.5 64h6C73.6 64 89 71 99.6 83.1L138.9 128H336V48H152c-13.3 0-24-10.7-24-24zM76.3 187.1c.5 2.5 2.2 4.7 4.6 5.7l123.4 54.9c6.3 2.8 12 6.7 16.9 11.6l88.1 88.1c3 3 7.1 4.7 11.3 4.7h.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3V176H128c-6.9 0-13.5-3-18.1-8.2L63.5 114.7c-.6-.7-1.3-1.2-2-1.7l14.8 74zM384 352h.3 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4c8.8 0 16-7.2 16-16V280c0-57.4-46.5-104-104-104H424h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H423h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H422 422h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H421 421h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H420h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H419 419h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H418h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H417 417h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H416 416h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H415h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H414 414h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H413 413h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H412 412h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H411 411h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H410h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H409h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H408h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H407h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H406 406h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H405 405h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H404 404h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H403h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H402h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H401 401h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H400 400h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H399h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H398 398h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H397h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H396 396h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H395h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H394 394h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H393 393h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H392h-8V352zM631 474.7l-22.5 18c-15.6 12.5-35 19.3-55 19.3H248c-13.3 0-24-10.7-24-24s10.7-24 24-24H553.6c9.1 0 17.9-3.1 25-8.8l22.5-18c10.4-8.3 25.5-6.6 33.7 3.8s6.6 25.5-3.8 33.7z"]
};
var faBird = {
  prefix: 'far',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M48.7 208H192c44.2 0 80-35.8 80-80V112c0-35.3 28.7-64 64-64s64 28.7 64 64v80c0 97.2-78.8 176-176 176c-91.8 0-167.2-70.3-175.3-160zM0 188.4V192C0 294.3 68.5 380.5 162.1 407.4l48.6 91.9c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4L221 416c1 0 2 0 3 0c12.6 0 25-1 37.1-3.1l45.7 86.3c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4l-40.9-77.2C390.3 366.3 448 285.9 448 192V175.5l56.2-33.7c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7l-61.7-37C427.9 32.4 385.7 0 336 0C274.1 0 224 50.1 224 112v16c0 17.7-14.3 32-32 32H28.4C12.7 160 0 172.7 0 188.4zM336 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCompass = {
  prefix: 'far',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSquareCaretDown = {
  prefix: 'far',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"]
};
var faCaretSquareDown = faSquareCaretDown;
var faHeartHalfStroke = {
  prefix: 'far',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M223.3 465.9l2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3L463.9 303.2c30.7-28.5 48.1-68.5 48.1-110.4v-3.3c0-70.4-50-130.8-119.2-144C353.4 37.9 313.1 47 281 69.6l0 0c-4 2.8-7.8 5.8-11.5 9c-4.7 4.1-9.3 8.5-13.5 13.3c-7.5-8.4-15.9-15.9-25-22.3C198.9 47 158.6 37.9 119.2 45.4C50 58.6 0 119.1 0 189.5v3.3c0 41.9 17.4 81.9 48.1 110.4L223.3 465.9zM256 430.7L256 152c6.4 0 12.4-2.5 16.9-7c.4-.3 .7-.7 1-1.1l17.8-20 .1-.1 .1-.1c23.1-25.9 58-37.7 92-31.2c46.5 8.9 80.1 49.5 80.1 96.9v3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7z"]
};
var faHeartHalfAlt = faHeartHalfStroke;
var faFileCircleQuestion = {
  prefix: 'far',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M64 464H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"]
};
var faLaptopCode = {
  prefix: 'far',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M128 80H512c8.8 0 16 7.2 16 16V320h48V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V320h48V96c0-8.8 7.2-16 16-16zM50.7 400H589.3c-6.6 18.6-24.4 32-45.3 32H96c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96H544c53 0 96-43 96-96c0-17.7-14.3-32-32-32H32zM281 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM393 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]
};
var faJoystick = {
  prefix: 'far',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M224 48a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 173.4c50.3-11 88-55.8 88-109.4C336 50.1 285.9 0 224 0S112 50.1 112 112c0 53.6 37.7 98.4 88 109.4V320h48V221.4zM96 320c-17.7 0-32 14.3-32 32c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H128c0-17.7-14.3-32-32-32zm0 80H384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16H96z"]
};
var faGrillFire = {
  prefix: 'far',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", "M48 80V96c0 97.2 78.8 176 176 176c7.3 0 14.5-.4 21.6-1.3c-8 16.2-14.3 32.8-18.1 49.3c-1.2 0-2.4 0-3.6 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h73c1.5 16.6 5.2 32.7 10.7 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96V72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40V96c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1c-4.3-3.9-9.3-6.9-14.5-8.9C398.8 119.8 400 108 400 96V80H48zm72 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM389.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C576 440 504.7 512 416 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM466 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faRectangleVerticalHistory = {
  prefix: 'far',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", "M256 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM192 64c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zM96 72c0-13.3 10.7-24 24-24s24 10.7 24 24V440c0 13.3-10.7 24-24 24s-24-10.7-24-24V72zM0 120c0-13.3 10.7-24 24-24s24 10.7 24 24V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V120z"]
};
var faSwatchbook = {
  prefix: 'far',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 400c0 61.9 50.1 112 112 112H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H385.9l50.7-50.7c25-25 25-65.5 0-90.5L365.3 75.3c-25-25-65.5-25-90.5 0L224 126.1V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V400zm448 64H209.9l128-128H448c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16zM402.7 203.3L224 382.1V193.9l84.7-84.7c6.2-6.2 16.4-6.2 22.6 0l71.4 71.4c6.2 6.2 6.2 16.4 0 22.6zM112 464c-35.3 0-64-28.7-64-64V304H176v96c0 35.3-28.7 64-64 64zM48 256V176H176v80H48zm0-128V64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16v64H48zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPrescriptionBottle = {
  prefix: 'far',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M48 48H336V80H48V48zM40 0C17.9 0 0 17.9 0 40V88c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H40zM32 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H304V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V416h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80V320h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80V224h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80V160H32z"]
};
var faBars = {
  prefix: 'far',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"]
};
var faNavicon = faBars;
var faKeyboardLeft = {
  prefix: 'far',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M576 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H576zM224 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm80 272v16c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm48-104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H352zM248 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H264c-8.8 0-16 7.2-16 16zm16-96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H264zm72 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm96-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H432zm72 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H520c-8.8 0-16 7.2-16 16zm16 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H520zM416 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V248c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zM121 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-63-63 63-63z"]
};
var faPeopleGroup = {
  prefix: 'far',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", "M128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32C50.1 160 0 210.1 0 272c0 44.7 26.2 83.2 64 101.2V416c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H112l0-16V336l0-128h32c12.6 0 24.3 3.6 34.2 9.9c7.9-14.2 18.1-26.9 30.2-37.6C190.2 167.5 168 160 144 160H112zM64 229.7v84.7C54 303.1 48 288.2 48 272s6-31.1 16-42.3zM496 208h32V336v48 16H496V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V373.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H496c-24 0-46.2 7.5-64.4 20.3c12 10.7 22.3 23.4 30.2 37.6c9.9-6.3 21.6-9.9 34.2-9.9zm96 64c0 16.2-6 31.1-16 42.3V229.7c10 11.3 16 26.1 16 42.3zM560 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 32c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V389.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H304zm0 224V352 224h32l0 128v48 32H304V400zm-48-69.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3v84.7zm128 0V245.7c10 11.3 16 26.1 16 42.3s-6 31.1-16 42.3z"]
};
var faHourglassEnd = {
  prefix: 'far',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM273.5 140.5C293 121 304 94.6 304 67V48H80V67c0 27.6 11 54 30.5 73.5L192 222.1l81.5-81.5z"]
};
var faHourglass3 = faHourglassEnd;
var faHeartCrack = {
  prefix: 'far',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M223.3 465.9l2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3L463.9 303.2c30.7-28.5 48.1-68.5 48.1-110.4v-3.3c0-70.4-50-130.8-119.2-144C353.4 37.9 313.1 47 281 69.6l0 0c-4 2.8-7.8 5.8-11.5 9c-4.7 4.1-9.3 8.5-13.5 13.3c-7.5-8.4-15.9-15.9-25-22.3C198.9 47 158.6 37.9 119.2 45.4C50 58.6 0 119.1 0 189.5v3.3c0 41.9 17.4 81.9 48.1 110.4L223.3 465.9zm6.6-331.1l-67.6 67.6c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-59.7-97L316 158.9c3.6-2.1 5-6.6 3.2-10.3l-16.6-35.1c22.4-18.5 52.2-26.4 81.3-20.9c46.5 8.9 80.1 49.5 80.1 96.9v3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7 80.8 268C59.9 248.6 48 221.3 48 192.8v-3.3c0-47.3 33.6-88 80.1-96.9c34-6.5 69 5.4 92 31.2l0 0 .1 .1 9.6 10.8z"]
};
var faHeartBroken = faHeartCrack;
var faFaceBeamHandOverMouth = {
  prefix: 'far',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm-78.3 47.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faDropletPercent = {
  prefix: 'far',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-75.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHumidity = faDropletPercent;
var faSquareUpRight = {
  prefix: 'far',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zm64 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faFaceKissBeam = {
  prefix: 'far',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faKissBeam = faFaceKissBeam;
var faCorn = {
  prefix: 'far',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-20.4 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-19.9 0-37.7 9.1-49.4 23.4l3.6 3.6c11.8 11.8 21.9 25.1 30 39.5c0-.3 0-.7-.1-1c0-.5-.1-.9-.1-1.4c0-8.8 7.2-16 16-16c2.6 0 5 .6 7.1 1.7c6.3 3.1 13.7 3.3 20.1 .6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3c2.6 0 5 .6 7.1 1.7c6.3 3.1 13.7 3.3 20.1 .6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3c4.6 0 8.7 1.9 11.6 5c5.3 5.5 12.8 8.3 20.4 7.3s14.3-5.4 18-12.1c2.8-5 8-8.2 14-8.2c8.8 0 16 7.2 16 16c0 6-3.3 11.2-8.2 14c-6.7 3.7-11.2 10.4-12.1 18s1.8 15.2 7.3 20.4c3.1 2.9 5 7 5 11.6c0 7.2-4.7 13.3-11.3 15.3c-6.7 2.1-12.2 7-15 13.5s-2.6 13.8 .6 20.1c1 2.1 1.7 4.5 1.7 7.1c0 7.2-4.7 13.3-11.3 15.3c-6.7 2.1-12.2 7-15 13.5s-2.6 13.8 .6 20.1c1 2.1 1.7 4.5 1.7 7.1c0 7-4.5 12.9-10.7 15.1c7.2 4.8 14.2 10.2 20.7 16.1L435.5 287c12.6-11.7 20.5-28.4 20.5-47c0-2-.1-3.9-.3-5.8C470.5 222.5 480 204.4 480 184c0-2-.1-3.9-.3-5.8C494.5 166.5 504 148.4 504 128c0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM169 71c-6.1-6.1-15-8.5-23.4-6.2s-14.8 8.9-16.9 17.3l-21.9 87.4c-.4 1.4-1.1 2.7-2.1 3.7L41.9 236.1C15.1 263 0 299.4 0 337.4c0 36 13.6 70.7 38 97.1L66.1 465c27.6 30 66.6 47 107.3 47c38.7 0 75.9-15.4 103.3-42.8l62.9-62.9c.9-.9 1.9-1.5 3.1-1.9l88.8-29.6c8.1-2.7 14.2-9.5 15.9-17.9s-1.1-17-7.4-22.7l-28.5-25.7C374 274.7 325.3 256 274.8 256c-9 0-17.9 .6-26.8 1.8V213c0-40.3-16-79-44.5-107.5L169 71zm31 142v57.1c-25.9 10.2-49.7 25.7-69.8 45.7L60.9 385.2C52.5 370.8 48 354.3 48 337.4c0-25.3 10-49.5 27.9-67.3l62.8-62.8c7.2-7.2 12.3-16.2 14.7-26L165 134.9l4.5 4.5C189 159 200 185.4 200 213zM101.4 432.5l-9.6-10.3 72.3-72.3c29.3-29.3 69.1-45.8 110.6-45.8c37.7 0 74.1 13.6 102.5 38.3l-49.7 16.6c-8.2 2.7-15.7 7.4-21.9 13.5l-62.9 62.9c-18.4 18.4-43.3 28.7-69.3 28.7c-27.4 0-53.5-11.4-72.1-31.5z"]
};
var faRollerCoaster = {
  prefix: 'far',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", "M48 184c0-40.1 22.7-74.9 56-92.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V80h5.1c15 0 29.6 3.2 42.9 9.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V132.6l48 69.1V456c0 13.3 10.7 24 24 24s24-10.7 24-24V270.9l14.9 21.5c9.4 13.6 20.6 25.6 33.1 35.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24V356.1c15.3 5.9 31.4 9.7 48 11.2V456c0 13.3 10.7 24 24 24s24-10.7 24-24V365.8c20.9-4 40-13 56-25.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24V240v-8c0-75.1-60.9-136-136-136h-8.1c-30.4 0-60.3 8.3-86.4 23.9L358 150.8l58 83.5V172l18.1-10.9c14.1-8.4 29.7-13.9 45.9-16V264c0 13.3 10.7 24 24 24s24-10.7 24-24V147.3c36.9 10.4 64 44.4 64 84.7v8c0 44.2-35.8 80-80 80h-8.5c-41.9 0-81.2-20.5-105.1-55L281.9 97.3C253.5 56.4 206.9 32 157.1 32H152C68.1 32 0 100.1 0 184V456c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faPhotoFilmMusic = {
  prefix: 'far',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M576 48H256c-8.8 0-16 7.2-16 16V256c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L380 200.4l56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9l30.5 46.7L406.3 195c-22.9 7.6-38.3 29-38.3 53.1V320H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-6.3 2.1V64c0-8.8-7.2-16-16-16zM289.9 448H160 136 112 64c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64h48 24 24v48 72 88 8 72H326.3c-2.3 1.4-4.6 3-6.7 4.6c-13.8 10.3-25.2 25.2-29.6 43.4zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 208V160H64c-8.8 0-16 7.2-16 16v32h64zm0 144H48v32c0 8.8 7.2 16 16 16h48V352zm0-48V256H48v48h64zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
var faRadar = {
  prefix: 'far',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M316.4 161.7C299 150.5 278.2 144 256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112s112-50.1 112-112h48c0 78.2-56.1 143.3-130.3 157.2c-7.3-8.1-17.9-13.2-29.7-13.2s-22.4 5.1-29.7 13.2c-64.5-12.1-115.4-63-127.5-127.5c8.1-7.3 13.2-17.9 13.2-29.7s-5.1-22.4-13.2-29.7C112.7 152.1 177.8 96 256 96c35.5 0 68.3 11.6 94.9 31.2l34.2-34.2C349.7 64.8 304.8 48 256 48C152.7 48 66.9 123.4 50.7 222.1C39.5 229.2 32 241.7 32 256s7.5 26.8 18.7 33.9c14.4 87.7 83.6 157 171.4 171.4c7.1 11.3 19.6 18.7 33.9 18.7s26.8-7.5 33.9-18.7C388.6 445.1 464 359.3 464 256h48c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l35.4-35.4z"]
};
var faSickle = {
  prefix: 'far',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M218.2 90.2c56.2-56.2 147.4-56.2 203.6 0c2.3 2.3 4.5 4.7 6.7 7.1c-16.4-6-34-9.3-52.5-9.3c-83.9 0-152 68.1-152 152c0 17.8 3.1 35 8.7 50.9l-8.7 8.7-5.8-5.8c-56.2-56.2-56.2-147.4 0-203.6zM455.8 56.2c-75-75-196.5-75-271.5 0s-75 196.5 0 271.5L207 350.6c9.4 9.4 24.6 9.4 33.9 0l37.1-37.1c7.3-7.3 9.1-18.4 4.6-27.6C275.8 272.1 272 256.5 272 240c0-57.4 46.6-104 104-104c38.7 0 72.5 21.1 90.5 52.6c5.6 9.8 17.3 14.4 28 11s17.7-13.8 16.7-25.1c-3.9-43.2-22.4-85.3-55.4-118.4zM121 311c-9.4-9.4-24.6-9.4-33.9 0L71 327c-9.4 9.4-9.4 24.6 0 33.9l7 7L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l71-71 7 7c9.4 9.4 24.6 9.4 33.9 0l16-16c9.4-9.4 9.4-24.6 0-33.9l-24-24-32-32-24-24z"]
};
var faFilm = {
  prefix: 'far',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", "M352 432H160V320 280H352v40V432zm0-200H160V192 80H352V192v40zM64 80h48v88H48V96c0-8.8 7.2-16 16-16zM48 216h64v80H48V216zm64 216H64c-8.8 0-16-7.2-16-16V344h64v88zM400 168V80h48c8.8 0 16 7.2 16 16v72H400zm0 48h64v80H400V216zm0 128h64v72c0 8.8-7.2 16-16 16H400V344zM448 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"]
};
var faCoconut = {
  prefix: 'far',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zM395.2 28.9C361.5-4.8 309.6-5.7 260.4 9.5C210 25 155.3 59.1 107.2 107.2S25 210 9.5 260.4C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512C396 512 512 396 512 253c0-68.7-27.3-134.6-75.9-183.2L395.2 28.9zm27.4 98.5c23.7 32 37.9 70.2 40.9 110.1L457 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l35.6 35.6c-7.2 31.1-21.2 59.6-40.4 83.7L377 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l41.2 41.2c-24.2 19.2-52.6 33.3-83.7 40.4L265 423c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l6.5 6.5c-39.9-2.9-78.1-17.2-110.1-40.9c12.1-1.5 24.2-4.3 36.3-8c50.4-15.5 105-49.7 153.1-97.8s82.2-102.7 97.8-153.1c3.7-12 6.5-24.2 8-36.3zM256 256c62.5-62.5 92.9-133.4 67.9-158.4s-95.9 5.4-158.4 67.9S72.6 298.9 97.6 323.9s95.9-5.4 158.4-67.9z"]
};
var faRulerHorizontal = {
  prefix: 'far',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", "M48 320c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16l-48 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V176l-64 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V176l-64 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V176l-64 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V176l-64 0v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V176l-48 0c-8.8 0-16 7.2-16 16l0 128zm16 64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64L64 384z"]
};
var faShieldCross = {
  prefix: 'far',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h96V392c0 13.3 10.7 24 24 24s24-10.7 24-24V216h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120z"]
};
var faCassetteTape = {
  prefix: 'far',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H472l-25.6-61.5c-8.7-20.9-29.1-34.5-51.7-34.5H181.3c-22.6 0-43 13.6-51.7 34.5L104 432H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM420 432H156l17.9-43.1c1.2-3 4.2-4.9 7.4-4.9H394.7c3.2 0 6.1 1.9 7.4 4.9L420 432zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM176 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16c0-5.5-.7-10.9-2-16H338c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16H238c1.3-5.1 2-10.5 2-16zm224 0c0-35.3-28.7-64-64-64H176c-35.3 0-64 28.7-64 64s28.7 64 64 64H400c35.3 0 64-28.7 64-64zm-80 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSquareTerminal = {
  prefix: 'far',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faPeopleRobbery = {
  prefix: 'far',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M504.5 53.3C493.1 101.7 449.8 136 400 136s-93.1-34.3-104.5-82.7l-8.2-34.8c-3-12.9-16-20.9-28.9-17.9s-20.9 16-17.9 28.9l8.2 34.8c11.3 48.1 44.3 86.5 87.2 106V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V170.2c42.9-19.4 75.9-57.8 87.2-105.9l8.2-34.8c3-12.9-5-25.8-17.9-28.9s-25.8 5-28.9 17.9l-8.2 34.8zM416 183.2V304H384V183.2c5.3 .5 10.6 .8 16 .8s10.7-.3 16-.8zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM16 204.5L16 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136H96V488c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H64l0-99.5C64 188.8 76.8 176 92.5 176c9.4 0 18.1 4.6 23.4 12.3l56.3 81.4c4.5 6.5 11.9 10.3 19.7 10.3h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H204.6l-49.2-71c-14.3-20.6-37.8-33-62.9-33C50.2 128 16 162.2 16 204.5z"]
};
var faLightbulb = {
  prefix: 'far',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"]
};
var faCaretLeft = {
  prefix: 'far',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", "M54.6 256L144 166.6l0 178.7L54.6 256zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z"]
};
var faCommentMiddle = {
  prefix: 'far',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M231.3 387.2L256 436.7l24.7-49.5c6.5-12.9 18.4-22.3 32.5-25.4C407 341 464 274.7 464 208c0-79.5-83.3-160-208-160S48 128.5 48 208c0 66.7 57 133 150.7 153.8c14.1 3.1 26.1 12.5 32.5 25.4zm92.4 21.5l-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208C0 93.1 114.6 0 256 0S512 93.1 512 208c0 95.8-79.8 176.5-188.3 200.7z"]
};
var faTrashCanList = {
  prefix: 'far',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M161.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM338.2 80L301.5 24.9C291.1 9.4 273.6 0 254.9 0H161.1c-18.7 0-36.2 9.4-46.6 24.9L77.8 80H32 24C10.7 80 0 90.7 0 104s10.7 24 24 24h8V432c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V128h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H338.2zM336 128V432c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V128H336zM160 176c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-8.8-7.2-16-16-16zm216-48c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H472zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H472zM448 408c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H472c-13.3 0-24 10.7-24 24z"]
};
var faBlock = {
  prefix: 'far',
  iconName: 'block',
  icon: [640, 512, [], "e46a", "M480 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H480zM160 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm48 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleExclamation = {
  prefix: 'far',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faExclamationCircle = faCircleExclamation;
var faSchoolCircleXmark = {
  prefix: 'far',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92H72C32.2 96 0 128.2 0 168V440c0 39.8 32.2 72 72 72H256 384h10.8C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V168c0-13.3 10.7-24 24-24H176c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4H568c13.3 0 24 10.7 24 24v52.5c18.8 12.3 35.1 28 48 46.3V168c0-39.8-32.2-72-72-72H471.3L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H112zM320 144c8.8 0 16 7.2 16 16v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faArrowRightFromBracket = {
  prefix: 'far',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M505 273c9.4-9.4 9.4-24.6 0-33.9L377 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z"]
};
var faSignOut = faArrowRightFromBracket;
var faFaceFrownSlight = {
  prefix: 'far',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM334.4 385.9C319.2 369.5 293.2 352 256 352s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4s91.7 25.5 113.6 49.4c9 9.7 8.4 24.9-1.4 33.9s-24.9 8.4-33.9-1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleChevronDown = {
  prefix: 'far',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241L239 345c9.4 9.4 24.6 9.4 33.9 0L377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
var faChevronCircleDown = faCircleChevronDown;
var faSidebarFlip = {
  prefix: 'far',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M288 80V432H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H288zM512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zm-64 24c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48zm24 120c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24z"]
};
var faUnlockKeyhole = {
  prefix: 'far',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", "M224 48c-44.2 0-80 35.8-80 80v64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96V128C96 57.3 153.3 0 224 0c57 0 105.2 37.2 121.8 88.6c4.1 12.6-2.8 26.1-15.5 30.2s-26.1-2.8-30.2-15.5C289.8 71.2 259.6 48 224 48zM64 240c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64zM256 376H192c-13.3 0-24-10.7-24-24s10.7-24 24-24h64c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faUnlockAlt = faUnlockKeyhole;
var faTemperatureList = {
  prefix: 'far',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M80 112c0-35.3 28.7-64 64-64s64 28.7 64 64V273.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9V112zM144 0C82.1 0 32 50.2 32 112V273.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM344 32c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zm32 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"]
};
var faCloudShowersHeavy = {
  prefix: 'far',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm244.6 31.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zM313.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5z"]
};
var faHeadphonesSimple = {
  prefix: 'far',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM160 432V320c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm0-160h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H160c-44.2 0-80-35.8-80-80V352c0-44.2 35.8-80 80-80zm192 48V432c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32zm80 32v48c0 44.2-35.8 80-80 80H336c-17.7 0-32-14.3-32-32V304c0-17.7 14.3-32 32-32h16c44.2 0 80 35.8 80 80z"]
};
var faHeadphonesAlt = faHeadphonesSimple;
var faSitemap = {
  prefix: 'far',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", "M320 80v64H256V80h64zM256 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h8v40H112c-30.9 0-56 25.1-56 56v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V288c0-4.4 3.6-8 8-8H264v40h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V280H464c4.4 0 8 3.6 8 8v32h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V288c0-30.9-25.1-56-56-56H312V192h8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256zM48 368h64v64H48V368zm208 0h64v64H256V368zm208 0h64v64H464V368z"]
};
var faPipeSection = {
  prefix: 'far',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v32V360v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H592v8c0 13.3 10.7 24 24 24s24-10.7 24-24V360 152 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H320 48v-8zm0 56H320 592V336H48V176z"]
};
var faSpaceStationMoonConstruction = {
  prefix: 'far',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M208.2 53.5C223.5 49.9 239.5 48 256 48c54.9 0 104.8 21.2 142 56H368c-13.3 0-24 10.7-24 24s10.7 24 24 24h81.5c8.8 0 17-4.9 21.1-12.6s3.7-17.2-1.1-24.6C423.7 45.6 345.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c81.4 0 153.9-38 200.7-97.1c8.2-10.4 6.5-25.5-3.9-33.7s-25.5-6.5-33.7 3.9C381 433.2 322.1 464 256 464c-80.8 0-150.8-46.1-185.3-113.3C109.9 362.7 168.9 376 256 376c116.9 0 183.2-23.9 218.9-36.8l0 0c4.8-1.7 9-3.2 12.7-4.5c7.5-2.5 13.3-8.6 15.5-16.2l.6-2.1c5.5-19.3 8.3-39.3 8.3-59.3V256c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.1c0 12.3-1.3 24.5-4 36.5l-.8 .3C424.3 306.5 364.4 328 256 328s-168.3-21.5-203.2-34.1l-1.5-.5C49.1 281.2 48 268.8 48 256c0-40.8 11.7-78.8 32-110.9c.6 52.5 43.3 94.9 96 94.9c53 0 96-43 96-96c0-41.7-26.6-77.2-63.8-90.5zM128 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm248 40c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"]
};
var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
var faCircleDollarToSlot = {
  prefix: 'far',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", "M256 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.6-64-64-64c-13.6 18.2-29.8 34.3-48 48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V416c0-8.8 7.2-16 16-16h48c-18.2-13.7-34.3-29.8-48-48zM276 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]
};
var faDonate = faCircleDollarToSlot;
var faMemory = {
  prefix: 'far',
  iconName: 'memory',
  icon: [576, 512, [], "f538", "M64 112H512c8.8 0 16 7.2 16 16v8.4c-19.6 17.5-32 43.1-32 71.6s12.4 54 32 71.6V304H48V279.6C67.6 262 80 236.5 80 208s-12.4-54-32-71.6V128c0-8.8 7.2-16 16-16zM528 352v48H472c0-13.3-10.7-24-24-24s-24 10.7-24 24H392c0-13.3-10.7-24-24-24s-24 10.7-24 24H312c0-13.3-10.7-24-24-24s-24 10.7-24 24H232c0-13.3-10.7-24-24-24s-24 10.7-24 24H152c0-13.3-10.7-24-24-24s-24 10.7-24 24H48V352H528zM64 64C28.7 64 0 92.7 0 128v23.4c0 6.8 4.4 12.6 10.1 16.3C23.3 176.3 32 191.1 32 208s-8.7 31.7-21.9 40.3C4.4 252 0 257.8 0 264.6V416c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V264.6c0-6.8-4.4-12.6-10.1-16.3C552.7 239.7 544 224.9 544 208s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zm104 80c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24z"]
};
var faFaceSleeping = {
  prefix: 'far',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", "M48 256C48 141.1 141.1 48 256 48c30.7 0 59.9 6.7 86.1 18.6c12.1 5.5 26.3 .2 31.8-11.9s.2-26.3-11.9-31.8C329.6 8.2 293.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.7-8.2-73.6-22.9-105.9c-5.5-12.1-19.7-17.4-31.8-11.9s-17.4 19.7-11.9 31.8C457.3 196.1 464 225.3 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256zM256 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm64-296h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H358.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H320c-8.8 0-16 7.2-16 16s7.2 16 16 16zM416 16c0 8.8 7.2 16 16 16h25.4L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H470.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0H432c-8.8 0-16 7.2-16 16zM351.6 252c-10.6 0-19.9-3.8-25.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7z"]
};
var faRoadSpikes = {
  prefix: 'far',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M192 352H112 64V304 150.5v-5.8V127.5 116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L112 136l80 120V150.5v-5.8V127.5 116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L240 136l80 120V150.5v-5.8V127.5 116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L368 136l80 120V150.5v-5.8V127.5 116.8c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L496 136 606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 496 454.3 448 384 368 326.3 320 256 240 198.3 192zm-25.7-48L112 222.5V304h54.3zM0 424c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM240 222.5V304h54.3L240 222.5zM422.3 304L368 222.5V304h54.3zM496 222.5V304h54.3L496 222.5z"]
};
var faFireBurner = {
  prefix: 'far',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H80v80H560V304H536c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V280zM48 464H164.3c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H48v32zm171.7 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H219.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zm128 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H347.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zM592 464V432H475.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16H592z"]
};
var faSquirrel = {
  prefix: 'far',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M147.7 48C92.7 48 48 92.7 48 147.7s44.7 99.7 99.7 99.7c22.4 0 40 19.2 38 41.5l-.7 7.7c-1 11-5.9 20.4-12 27.3c-13.1 14.9-21.1 34.4-21.1 55.8c0 39.1 26.6 72 62.8 81.5c-14.3-20-22.8-44.4-22.8-70.9c0-25 7.7-49.3 22-69.8l35-49.9C284.8 219.5 304 158.5 304 96V75.2C304 69 309 64 315.2 64c15.2 0 28.7 7.6 36.8 19.2C360.1 71.6 373.6 64 388.8 64C395 64 400 69 400 75.2V96h7.6c53.4 0 98.2 40.5 103.5 93.7l.8 8c.5 4.5-.4 9.1-2.4 13.1l-4.1 8.2c-14.4 28.8-42 48.1-73.4 52.3V326c24.3 19 40 48.7 40 82c0 20.6-6 39.8-16.3 56h33.4c13.3 0 24 10.7 24 24s-10.7 24-24 24H368 352 313.7 236.3c-73 0-132.3-59.2-132.3-132.3c0-32.3 11.6-61.9 30.8-84.8C59.3 288.3 0 225 0 147.7C0 66.1 66.1 0 147.7 0C207.3 0 258.6 35.3 282 86c5.5 12 .3 26.3-11.8 31.8s-26.3 .3-31.8-11.8c-15.8-34.3-50.5-58-90.6-58zM352 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56c-5.9 0-11.5 .9-16.8 2.6c-12.6 4-26.1-3.1-30.1-15.7s3.1-26.1 15.7-30.1c9.9-3.1 20.4-4.8 31.2-4.8c5.4 0 10.8 .4 16 1.2V248c0-13.3 10.7-24 24-24h11.5c18.2 0 34.8-10.3 42.9-26.5l1-2-.1-1.1c-2.9-28.6-27-50.4-55.7-50.4H400 352h-3.3c-7.6 55.2-28.2 108.1-60.4 154.2l-35 49.9c-8.7 12.4-13.3 27.1-13.3 42.2c0 40.7 33 73.7 73.7 73.7H352zm32-288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faArrowUpToLine = {
  prefix: 'far',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM209.5 167.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L168 244.5V328 456c0 13.3 10.7 24 24 24s24-10.7 24-24V328 244.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z"]
};
var faArrowToTop = faArrowUpToLine;
var faFlag = {
  prefix: 'far',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V64 350.5 400v88c0 13.3 10.7 24 24 24s24-10.7 24-24V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8V334.7l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z"]
};
var faFaceCowboyHat = {
  prefix: 'far',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M216 0c-36.8 0-67.4 64.9-82.4 109.8C100 99.3 70 84.6 45.1 66.8C42.6 65 39.7 64 36.7 64C27.7 64 21 72.3 23.8 80.7C50.8 163.2 144.5 224 256 224s205.2-60.8 232.2-143.3C491 72.3 484.3 64 475.3 64c-3 0-6 1-8.4 2.8C442 84.6 412 99.3 378.4 109.8C363.4 64.9 332.8 0 296 0c-9.1 0-17.9 4-26.1 10.7c-7.9 6.5-19.8 6.5-27.7 0C233.9 4 225.1 0 216 0zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-12.8 9.3-26.6 17.5-41.2 24.6c13.4 23.4 21 50.5 21 79.3c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-28.9 7.6-55.9 21-79.3c-14.6-7.1-28.4-15.4-41.2-24.6zM366.4 367.5c5.7-11.5-6.2-22.2-18.6-18.8c-27.9 7.8-59 12.2-91.6 12.2s-63.7-4.3-91.6-12.2c-12.4-3.5-24.3 7.3-18.6 18.8C166.2 408.1 208 436 256.2 436s90-27.9 110.2-68.6zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHanukiah = {
  prefix: 'far',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M296 56c0-19.4 13.1-43.9 18.2-52.7C315.4 1.2 317.6 0 320 0s4.6 1.2 5.8 3.3C330.9 12.1 344 36.6 344 56c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 104C0 84.6 13.1 60.1 18.2 51.3C19.4 49.2 21.6 48 24 48s4.6 1.2 5.8 3.3C34.9 60.1 48 84.6 48 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zM106.2 51.3c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C122.9 60.1 136 84.6 136 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM152 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C186.9 60.1 200 84.6 200 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C250.9 60.1 264 84.6 264 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM376 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C410.9 60.1 424 84.6 424 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C474.9 60.1 488 84.6 488 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM504 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C538.9 60.1 552 84.6 552 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zM610.2 51.3c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C626.9 60.1 640 84.6 640 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM320 112c13.3 0 24 10.7 24 24V336H552c22.1 0 40-17.9 40-40V184c0-13.3 10.7-24 24-24s24 10.7 24 24V296c0 48.6-39.4 88-88 88H344v80H496c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 144c-13.3 0-24-10.7-24-24s10.7-24 24-24H296V384H88c-48.6 0-88-39.4-88-88V184c0-13.3 10.7-24 24-24s24 10.7 24 24V296c0 22.1 17.9 40 40 40H296V136c0-13.3 10.7-24 24-24zM112 160c8.8 0 16 7.2 16 16V288v16H96V288 176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V288v16H160V288 176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V288v16H224V288 176c0-8.8 7.2-16 16-16zm160 0c8.8 0 16 7.2 16 16V288v16H384V288 176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V288v16H448V288 176c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16V288v16H512V288 176c0-8.8 7.2-16 16-16z"]
};
var faChartScatter3d = {
  prefix: 'far',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V276.8L40.6 437.6c-10.1 8.5-11.5 23.7-2.9 33.8s23.7 11.5 33.8 2.9L256 319.3l184.6 155c10.2 8.5 25.3 7.2 33.8-2.9s7.2-25.3-2.9-33.8L280 276.8V56zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDisplayChartUp = {
  prefix: 'far',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", "M512 48c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H336.5c-.3 0-.6 0-.8 0H240.4c-.3 0-.6 0-.8 0H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H512zM64 416H211.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H352h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H372.3l-8-48H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm188.3 48l8-48h55.3l8 48H252.3zM376 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24H376z"]
};
var faSquareCode = {
  prefix: 'far',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM255 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zM193 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L95 239c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"]
};
var faFeather = {
  prefix: 'far',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M311.9 166.1L112 366.1l0-36c0-55.2 21.9-108.1 60.9-147.1L276.7 79.2c20-20 47.1-31.2 75.3-31.2s55.3 11.2 75.3 31.2l5.5 5.5c20 20 31.2 47.1 31.2 75.3c0 16.8-4 33.3-11.4 48H337.9l7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm-22 89.9H412.1l-48 48H241.9l48-48zm24.9 96c-37.2 30.9-84.2 48-132.9 48h-36l48-48H314.9zM64 330v84L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h84c67.9 0 133-27 181-75L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330z"]
};
var faVolumeLow = {
  prefix: 'far',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M159.9 201.9L272 102.3V409.7L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM412.6 181.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5z"]
};
var faVolumeDown = faVolumeLow;
var faXmarkToSlot = {
  prefix: 'far',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M144 80V360H432V80H144zM96 360V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V360c13.3 0 24 10.7 24 24s-10.7 24-24 24H432 144 96c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 288v48H48l0 96H528V336H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H64zM207 135c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesToSlot = faXmarkToSlot;
var faVoteNay = faXmarkToSlot;
var faBoxTaped = {
  prefix: 'far',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M261.3 80h81.1c6.3 0 12.1 3.7 14.6 9.5L388.4 160H288L261.3 80zm-74.7 0L160 160 59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5h81.1zM160 208v48c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V208H400V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208H160zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70z"]
};
var faBoxAlt = faBoxTaped;
var faCommentSlash = {
  prefix: 'far',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM184.2 119C219.3 95.2 265.7 80 320 80c124.7 0 208 80.5 208 160c0 38.4-19.4 77-53.5 106.6L184.2 119zM112 240c0-16.2 3.4-32.4 10-47.9l-39-30.8C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9l-46-36.3c-18.1 4-37.5 6.2-58 6.2c-31.6 0-61.3-5.5-87.8-15.1c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C124.4 302.8 112 272 112 240z"]
};
var faSwords = {
  prefix: 'far',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M54.8 89.6L51.3 51.3l38.2 3.5L367.4 332.7l33.9-33.9L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4 .1C12.7-.4 8 1.3 4.7 4.7S-.4 12.7 .1 17.4L7 93.9c1 11.2 5.9 21.7 13.9 29.6L298.7 401.4l33.9-33.9L54.8 89.6zM459.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6l16 16c4.7 4.7 11.8 6 17.8 3.3l62-27.5 56.2 56.2c6.2 6.2 16.4 6.2 22.6 0l24-24c6.2-6.2 6.2-16.4 0-22.6l-56.2-56.2 27.5-62c2.7-6.1 1.4-13.1-3.3-17.8l-16-16zm-112-109.3l33.9 33.9L491.1 123.5c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6L418.1 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l33.9 33.9L422.4 54.8l38.2-3.5-3.5 38.2L347.3 199.4zM233.4 381.3l-33.9-33.9-42.7 42.7-34.7-34.7 42.7-42.7-33.9-33.9L88 321.4 75.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-4.7 4.7-6 11.8-3.3 17.8l27.5 62L4.7 460.7c-6.2 6.2-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2 62 27.5c6 2.7 13.1 1.4 17.8-3.3l16-16c6.2-6.2 6.2-16.4 0-22.6L190.6 424l42.7-42.7z"]
};
var faCloudSunRain = {
  prefix: 'far',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.6 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zM320.1 192c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0H557.8c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1V218.3c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9v-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3v5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7v6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0h-266c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"]
};
var faAlbum = {
  prefix: 'far',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM80 256a144 144 0 1 1 288 0A144 144 0 1 1 80 256zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCircleN = {
  prefix: 'far',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.7 138.3c-6-8.6-16.9-12.4-26.9-9.2s-16.8 12.4-16.8 22.9V360c0 13.3 10.7 24 24 24s24-10.7 24-24V228.8L308.3 373.7c6 8.6 16.9 12.4 26.9 9.2s16.8-12.4 16.8-22.9V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V283.2L203.7 138.3z"]
};
var faCompress = {
  prefix: 'far',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H136c13.3 0 24-10.7 24-24V56zM24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24H24zM336 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V168c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H336V56zM312 320c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V368h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H312z"]
};
var faWheatAwn = {
  prefix: 'far',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", "M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3 0 0L41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5 0 0L69.3 386.1c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM261.5 103.3c-25 25-25 65.5 0 90.5L271.7 204c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zM159.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm135.7-22.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm79.2-79.2c25 25 65.5 25 90.5 0C381.2 223 339 219.7 307.9 240.2l10.1 10.1z"]
};
var faWheatAlt = faWheatAwn;
var faAnkh = {
  prefix: 'far',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M80 128c0 42.3 22.6 78.9 50.5 107.6c10.3 10.6 20.6 19.4 29.5 26.3c8.9-6.9 19.3-15.7 29.5-26.3C217.4 206.9 240 170.3 240 128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM98.9 272C66 238.9 32 189.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 61.8-34 110.9-66.9 144H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H184V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H98.9z"]
};
var faHandsHoldingChild = {
  prefix: 'far',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M320 80a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm44.7 84.3L384.5 181c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-27.9-23.6C368.7 104.8 344.7 96 320 96s-48.7 8.8-67.6 24.7l-27.9 23.6c-10.1 8.6-11.4 23.7-2.8 33.8s23.7 11.4 33.8 2.8l19.8-16.7L264.2 253c-1.6 13.2 7.7 25.1 20.8 26.8s25.1-7.7 26.8-20.8l4.4-35h7.6l4.4 35c1.6 13.2 13.6 22.5 26.8 20.8s22.5-13.6 20.8-26.8l-11.1-88.8zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136V352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24V281.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9 0 0L167 393l0 0 16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16 0 0-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V436.8c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359l0 0-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 0 0 26.7-26.7 0 0 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24V352.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72V264.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8V136z"]
};
var faAsterisk = {
  prefix: 'far',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", "M192 32c13.3 0 24 10.7 24 24V212.9l131.4-81.3c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L237.6 256l135 83.6c11.3 7 14.8 21.8 7.8 33s-21.8 14.7-33 7.8L216 299.1V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V299.1L36.6 380.4c-11.3 7-26.1 3.5-33-7.8s-3.5-26.1 7.8-33l135-83.6-135-83.6c-11.3-7-14.8-21.8-7.8-33s21.8-14.8 33-7.8L168 212.9V56c0-13.3 10.7-24 24-24z"]
};
var faKeySkeletonLeftRight = {
  prefix: 'far',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M592 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm48 0c0 70.7-57.3 128-128 128c-62.5 0-114.5-44.8-125.8-104H304v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152H208l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-13.3 10.7-24 24-24l202.2 0C397.5 44.8 449.5 0 512 0c70.7 0 128 57.3 128 128zM48 384a80 80 0 1 0 160 0A80 80 0 1 0 48 384zM0 384c0-70.7 57.3-128 128-128c62.5 0 114.5 44.8 125.8 104l82.2 0V312c0-13.3 10.7-24 24-24s24 10.7 24 24v48h48l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72c0 13.3-10.7 24-24 24H253.8C242.5 467.2 190.5 512 128 512C57.3 512 0 454.7 0 384z"]
};
var faCommentLines = {
  prefix: 'far',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
};
var faLuchadorMask = {
  prefix: 'far',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M288 464H160C98.1 464 48 413.9 48 352V224c0-97.2 78.8-176 176-176s176 78.8 176 176V352c0 61.9-50.1 112-112 112zM224 0C100.3 0 0 100.3 0 224V352c0 88.4 71.6 160 160 160H288c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zM160 352h35.3 57.4H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7H304c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48H304c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80H112c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80h13.3c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8l8-8 4.2-4.2 .4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4 .4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8c0 6.2-5.1 11.3-11.3 11.3H241.4h-6-.6H213.3h-.6-6H195.3zM96 208c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16H144c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H272c-8.8 0-16-7.2-16-16c0-26.5 21.5-48 48-48h32z"]
};
var faLuchador = faLuchadorMask;
var faMaskLuchador = faLuchadorMask;
var faSquareCheck = {
  prefix: 'far',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCheckSquare = faSquareCheck;
var faShredder = {
  prefix: 'far',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M112 192V64c0-8.8 7.2-16 16-16H357.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V192H112zM64 64V192c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64V90.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64zM448 240c8.8 0 16 7.2 16 16v80H48V256c0-8.8 7.2-16 16-16H448zM40 488c0 13.3 10.7 24 24 24s24-10.7 24-24V416H40v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24V416H136v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24V416H232v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24V416H328v72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24V416H424v72z"]
};
var faBookOpenCover = {
  prefix: 'far',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", "M512 337.2V52.4L344 77V373l168-35.8zM296 373V77L128 52.4V337.2L296 373zM523.4 2.2C542.7-.7 560 14.3 560 33.8V350.1c0 15.1-10.6 28.1-25.3 31.3l-201.3 43c-8.8 1.9-17.9 1.9-26.7 0l-201.3-43C90.6 378.3 80 365.2 80 350.1V33.8C80 14.3 97.3-.7 116.6 2.2L320 32 523.4 2.2zM38.3 23.7l10.2 2c-.3 2.7-.5 5.4-.5 8.1V74.6 342.1v66.7l265.8 54.5c2 .4 4.1 .6 6.2 .6s4.2-.2 6.2-.6L592 408.8V342.1 74.6 33.8c0-2.8-.2-5.5-.5-8.1l10.2-2C621.5 19.7 640 34.8 640 55V421.9c0 15.2-10.7 28.3-25.6 31.3L335.8 510.4c-5.2 1.1-10.5 1.6-15.8 1.6s-10.6-.5-15.8-1.6L25.6 453.2C10.7 450.2 0 437.1 0 421.9V55C0 34.8 18.5 19.7 38.3 23.7z"]
};
var faBookOpenAlt = faBookOpenCover;
var faSandwich = {
  prefix: 'far',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M48 112H464v32H48V112zM32 64C14.3 64 0 78.3 0 96v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H32zM48 368H464v32H48V368zM32 320c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm-8-24c11.8 0 23.1-2.9 33.1-6.3c8.8-3 17.8-6.8 26.1-10.3l0 0 3.1-1.3c19.6-8.3 35.3-14.1 49.7-14.1c18.2 0 30.9 5.7 48.7 13.8C202.6 286 224.7 296 256 296s53.4-10 71.3-18.2c17.8-8.1 30.5-13.8 48.7-13.8c14.4 0 30.1 5.9 49.7 14.1l3.1 1.3 0 0c8.3 3.5 17.3 7.3 26.1 10.3c9.9 3.4 21.3 6.3 33.1 6.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-4.2 0-9.9-1.1-17.7-3.7c-7-2.4-14.3-5.5-22.8-9.1l0 0-3.1-1.3C425.9 226.1 401.6 216 376 216c-28.8 0-49.9 9.6-66.9 17.4l-1.7 .8C290.1 242 276.2 248 256 248s-34.1-6-51.4-13.8l-1.7-.8c-17-7.8-38.1-17.4-66.9-17.4c-25.6 0-49.9 10.1-68.3 17.9l-3.2 1.3 0 0c-8.5 3.6-15.9 6.7-22.8 9.1C33.9 246.9 28.2 248 24 248c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faPesetaSign = {
  prefix: 'far',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", "M93.9 32C68.6 32 48 52.6 48 77.9V176H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48V328 456c0 13.3 10.7 24 24 24s24-10.7 24-24V352h96c77.4 0 142-55 156.8-128H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8.8C343.2 95.1 275 32 192 32H93.9zM302.9 176H96V80h96c56.4 0 103.1 41.7 110.9 96zM96 224H299.4c-13.8 46.3-56.6 80-107.4 80H96V224z"]
};
var faSquareParkingSlash = {
  prefix: 'far',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM145.7 88.9c2.6-5.3 8.1-8.9 14.3-8.9H480c8.8 0 16 7.2 16 16V363.5L408.6 295c19.3-17.6 31.4-42.9 31.4-71c0-53-43-96-96-96H264c-16.5 0-30.2 12.6-31.8 28.7L145.7 88.9zM369.8 264.5L280 194.2V176h64c26.5 0 48 21.5 48 48c0 17-8.9 32-22.2 40.5zM232 278.8V296v64c0 13.3 10.7 24 24 24s24-10.7 24-24v-8V320v-3.4l-48-37.8zm-88-69.3L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4L426.5 432H160c-8.8 0-16-7.2-16-16V209.5z"]
};
var faParkingSlash = faSquareParkingSlash;
var faTrainTunnel = {
  prefix: 'far',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208V488c0 13.3 10.7 24 24 24s24-10.7 24-24V256C512 114.6 397.4 0 256 0S0 114.6 0 256V488c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm304-48v48H160V208c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32zM160 368V304H352v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm32-240c-44.2 0-80 35.8-80 80V368c0 27.7 14.1 52.2 35.5 66.5L111 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57H310.1l57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-36.5-36.5C385.9 420.2 400 395.7 400 368V208c0-44.2-35.8-80-80-80H192zm96 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHeading = {
  prefix: 'far',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 56C0 42.7 10.7 32 24 32H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H104V224H344V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H392V248 432h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V272H104V432h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V248 80H24C10.7 80 0 69.3 0 56z"]
};
var faHeader = faHeading;
var faGhost = {
  prefix: 'far',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M48 192V415.5c26.3-4.9 54.6 3.7 73.6 25.5l6.4 7.3 3.8-4.3c31.9-36.4 88.5-36.4 120.4 0l3.8 4.3 6.4-7.3c19.1-21.8 47.3-30.4 73.6-25.5V192c0-79.5-64.5-144-144-144S48 112.5 48 192zM256 512c-5.1 0-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L85.5 472.5c-11.6-13.3-32.1-14-44.5-1.5l-2.3 2.3c-4.2 4.2-10 6.6-16 6.6C10.1 480 0 469.9 0 457.4V192C0 86 86 0 192 0S384 86 384 192V457.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6l-2.3-2.3c-12.5-12.5-32.9-11.8-44.5 1.5L269.3 506c-3.3 3.8-8.2 6-13.3 6zM96 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faFaceAnguished = {
  prefix: 'far',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faHockeySticks = {
  prefix: 'far',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M173.3 13L302 261.7 288.4 288H261.5L130.7 35C124.6 23.3 129.2 8.8 141 2.7s26.3-1.5 32.3 10.3zM373.1 368l24.8-48H576c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H421.2c-26.9 0-51.6-15-64-38.9L338 435.9l27-52.2L399.9 451c4.1 8 12.3 13 21.3 13H496V368H373.1zM544 368v96h32c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H544zM499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H304c1.3 0 2.5 .1 3.7 .3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368H144v96h74.8c9 0 17.2-5 21.3-13L283 368zM64 368c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H96V368H64z"]
};
var faAbacus = {
  prefix: 'far',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 80c8.8 0 16 7.2 16 16V208H448V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h64zm-96 48h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80H416v48zm-160 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H160V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h96v48zm-128 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H48V96c0-8.8 7.2-16 16-16h64v48zM48 416V240h80v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v48H64c-8.8 0-16-7.2-16-16zm112-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V312h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240h96v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v48H160V384zm128-72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240H416v96h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v48H288V384h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V312zm160 72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240h80V416c0 8.8-7.2 16-16 16H448V384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFilmSimple = {
  prefix: 'far',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", "M160 432H352V320 192 80H160V192 320 432zM112 80H64c-8.8 0-16 7.2-16 16v72h64V80zm0 136H48v80h64V216zm0 128H48v72c0 8.8 7.2 16 16 16h48V344zM400 80v88h64V96c0-8.8-7.2-16-16-16H400zm64 136H400v80h64V216zm0 128H400v88h48c8.8 0 16-7.2 16-16V344zM64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32z"]
};
var faFilmAlt = faFilmSimple;
var faList = {
  prefix: 'far',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
};
var faListSquares = faList;
var faTreePalm = {
  prefix: 'far',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M102.9 91.4l30.3 50.5c-4 3.5-8 7.2-12 11.2c-71 71-60.2 151-32.7 191.3c5 7.3 15.2 7.3 21.4 1L236 219.3c2.3 9.3 4.3 20.3 5.6 32.9c4.9 46.6 .5 115.1-26.4 208.3c-7.3 25.3 11.3 51.5 38.5 51.5h84.1c20 0 37.6-15 39.6-35.7c9.2-95.5-5.9-202-34.3-284.3H446.7c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9H560c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C59.6 0 10.7 64.2 1.6 112.1C-.1 120.8 7.2 128 16 128H62.7c2.8 0 5.4-1.5 6.9-3.9L89.1 91.4c3.1-5.2 10.6-5.2 13.7 0zM292 192c28.6 74.1 46 177.9 38.3 272H264.1c25.8-92.9 30.7-164.5 25.2-216.8c-2.2-21.5-6.2-39.9-11.4-55.2H292z"]
};
var faSquarePhoneFlip = {
  prefix: 'far',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zm64 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM293.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCartPlus = {
  prefix: 'far',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M0 24C0 10.7 10.7 0 24 0H69.5c26.9 0 50 19.1 55 45.5l37 194.5H459.2c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 48V88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H344v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V136H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V48c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faGamepad = {
  prefix: 'far',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144H448c79.5 0 144-64.5 144-144s-64.5-144-144-144H192zM0 256C0 150 86 64 192 64H448c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm232-56v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H232v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faBorderCenterV = {
  prefix: 'far',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M448 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 352A32 32 0 1 0 0 352a32 32 0 1 0 64 0zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zM288 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm40 200c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 400z"]
};
var faCircleDot = {
  prefix: 'far',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faDotCircle = faCircleDot;
var faClipboardMedical = {
  prefix: 'far',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 160v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faFaceDizzy = {
  prefix: 'far',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faDizzy = faFaceDizzy;
var faEgg = {
  prefix: 'far',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 448c-74.7 0-144-75.4-144-160c0-48.3 14.1-107.7 41.3-153.5C116.4 88.8 151.1 64 192 64s75.6 24.8 102.7 70.5C321.9 180.3 336 239.7 336 288c0 84.6-69.3 160-144 160zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zM170.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"]
};
var faUpToLine = {
  prefix: 'far',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M82.2 288L192 178 301.8 288H248c-13.3 0-24 10.7-24 24V432H160V312c0-13.3-10.7-24-24-24H82.2zM192 128c-11.5 0-22.5 4.6-30.6 12.7L45.6 256.8C36.9 265.5 32 277.3 32 289.6C32 315.2 52.8 336 78.4 336H112v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V336h33.6c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L222.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zM24 80H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56S10.7 80 24 80z"]
};
var faArrowAltToTop = faUpToLine;
var faHouseMedicalCircleXmark = {
  prefix: 'far',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32H348.5c12.3 18.8 28 35.1 46.3 48H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faWatchFitness = {
  prefix: 'far',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M112.3 0C85.6 0 64 21.6 64 48.3V65.6C27.5 73 0 105.3 0 144V368c0 38.7 27.5 71 64 78.4V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V446.4c36.5-7.4 64-39.7 64-78.4V144c0-38.7-27.5-71-64-78.4V48.3C320 21.6 298.4 0 271.7 0H112.3zM304 112c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H304zM93.7 226.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"]
};
var faClockNineThirty = {
  prefix: 'far',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCampground = {
  prefix: 'far',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", "M375.4 5.6c10.2 8.5 11.5 23.6 3 33.8l-59.1 70.7L555 392.1c8.4 10.1 13 22.8 13 35.9v28c0 30.9-25.1 56-56 56H288 64c-30.9 0-56-25.1-56-56V428c0-13.1 4.6-25.8 13-35.9L256.7 110.1 197.6 39.4c-8.5-10.2-7.1-25.3 3-33.8s25.3-7.1 33.8 3L288 72.7 341.6 8.6c8.5-10.2 23.6-11.5 33.8-3zM57.9 422.8c-1.2 1.4-1.9 3.3-1.9 5.1v28c0 4.4 3.6 8 8 8h62L269.1 281.2c4.5-5.8 11.5-9.2 18.9-9.2s14.4 3.4 18.9 9.2L450 464h62c4.4 0 8-3.6 8-8V428c0-1.9-.7-3.7-1.9-5.1L288 147.5 57.9 422.8zM187 464H288 389L288 334.9 187 464z"]
};
var faFolderPlus = {
  prefix: 'far',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faJug = {
  prefix: 'far',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M192 85V48h64V85c0 17.8 5.9 35.1 16.9 49.1l37.9-29.5-37.9 29.5 78.3 100.7c10.9 14 16.9 31.3 16.9 49.1V288H80v-4.1c0-17.8 5.9-35.1 16.9-49.1l78.3-100.7c10.9-14 16.9-31.3 16.9-49.1zM80 416H368v32c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V416zM322.5 119.8l-11.8-15.1C306.4 99 304 92.1 304 85V48c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 192 144c-13.3 0-24 10.7-24 24s10.7 24 24 24V85c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V283.9c0-17.4-3.5-34.5-10.3-50.3C430.6 222.3 448 197.2 448 168c0-39.8-32.2-72-72-72c-21.2 0-40.3 9.2-53.5 23.8zM400 168c0 12.4-9.4 22.6-21.4 23.9l-25.1-32.2c3.4-9.1 12.2-15.6 22.5-15.6c13.3 0 24 10.7 24 24z"]
};
var faFutbol = {
  prefix: 'far',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M435.4 361.3l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.1zM256 48l.9 0h-1.8l.9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.7 2-4 2.9l4-2.9zm75.2-226.6l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faSnowBlowing = {
  prefix: 'far',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M176 64c13.3 0 24 10.7 24 24v25.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6v55.8l48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6v55.8l35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V398.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4V297.6l-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4V158.6l-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4V88c0-13.3 10.7-24 24-24zM480 424c0-13.3 10.7-24 24-24h48c22.1 0 40-17.9 40-40s-17.9-40-40-40H408c-13.3 0-24-10.7-24-24s10.7-24 24-24H552c48.6 0 88 39.4 88 88s-39.4 88-88 88H504c-13.3 0-24-10.7-24-24zM504 64h48c48.6 0 88 39.4 88 88s-39.4 88-88 88H408c-13.3 0-24-10.7-24-24s10.7-24 24-24H552c22.1 0 40-17.9 40-40s-17.9-40-40-40H504c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faPaintbrush = {
  prefix: 'far',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M278 219.5L356.5 298 524.7 73.6c4.8-6.4 4.1-15.3-1.5-20.9s-14.5-6.3-20.9-1.5L278 219.5zM199.1 321.6c-4.9-1-9.9-1.6-15.1-1.6c-39.8 0-72 32.2-72 72c0 3.8 .3 7.5 .8 11.1c3.3 21.4-2.2 43.1-13.8 60l-.7 .9H184c39.8 0 72-32.2 72-72c0-5.2-.5-10.2-1.6-15.1l-55.4-55.4zM384 341.3c-19.1 25.5-48.6 41.1-80.3 42.6c.2 2.7 .3 5.4 .3 8.1c0 66.3-53.7 120-120 120H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h6c18.1 0 30.1-19.8 27.4-37.6c-.9-6-1.4-12.1-1.4-18.4c0-66.3 53.7-120 120-120c2.7 0 5.4 .1 8.1 .3c1.5-31.7 17-61.1 42.5-80.3L473.5 12.8C499-6.3 534.6-3.8 557.2 18.7s25.1 58.2 6 83.7L384 341.3z"]
};
var faPaintBrush = faPaintbrush;
var faLock = {
  prefix: 'far',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", "M144 128v64H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zM48 256V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16z"]
};
var faArrowDownFromLine = {
  prefix: 'far',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M174.5 472.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 395.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 303.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136zM360 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l336 0z"]
};
var faArrowFromTop = faArrowDownFromLine;
var faGasPump = {
  prefix: 'far',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M256 48c8.8 0 16 7.2 16 16V192H80V64c0-8.8 7.2-16 16-16H256zm16 192V464H80l0-224H272zM32 64V464l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h8H80 272h48 8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0V304h8c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V155.9c0-19.1-7.6-37.4-21.1-50.9L417 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33V160c0 29.8 20.4 54.9 48 62V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64z"]
};
var faSignalBarsSlash = {
  prefix: 'far',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V64c0-35.3-28.7-64-64-64s-64 28.7-64 64V325.8L424 307V192c0-35.3-28.7-64-64-64s-64 28.7-64 64v14.7L38.8 5.1zM344 244.3V192c0-8.8 7.2-16 16-16s16 7.2 16 16v77.4l-32-25.1zM496 363.5V64c0-8.8 7.2-16 16-16s16 7.2 16 16V388.5l-32-25.1zM376 392.2V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V367l-48-37.8V448c0 35.3 28.7 64 64 64s64-28.7 64-64V430.1l-48-37.8zM203.3 256.2C170.1 258.6 144 286.2 144 320V448c0 35.3 28.7 64 64 64s64-28.7 64-64V320c0-3.5-.3-7-.8-10.4l-67.9-53.5zM448 449c.3 23.3 13.1 43.5 32 54.5V474.2L448 449zm-224-1c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-8.8 7.2-16 16-16s16 7.2 16 16V448zM80 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM64 384a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
var faSignalAltSlash = faSignalBarsSlash;
var faMonkey = {
  prefix: 'far',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-91.5 54.8-170.2 133.5-204.9c7.3 15.1 17.2 28.6 29.3 39.9C255.7 275.8 208 340.4 208 416v48H400V440c0-39.8-32.2-72-72-72H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c27 0 51.9 8.9 72 24V320 287.1c5.2 .6 10.6 .9 16 .9c11 0 21.7-1.3 32-3.8v1.8l83.5 83.5C560 398 576 436.7 576 477v11c0 13.3-10.7 24-24 24s-24-10.7-24-24V477c0-27.6-11-54-30.5-73.5L448 353.9V440v24h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H400 208 160h-8C68.1 512 0 443.9 0 360V120C0 53.7 53.7 0 120 0h8c53 0 96 43 96 96s-43 96-96 96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c26.5 0 48-21.5 48-48s-21.5-48-48-48h-8c-39.8 0-72 32.2-72 72V360c0 57.4 46.6 104 104 104h8V416zM448 251c-10.1 3.3-20.8 5-32 5c-5.4 0-10.8-.4-16-1.2c-13.5-2.1-26.1-6.8-37.4-13.5c-16.4-9.8-29.9-24.1-38.8-41.1c-1.4-2.7-2.7-5.4-3.8-8.2c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-11.6 27.9-35 49.6-64 59zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48H384zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRectanglePro = {
  prefix: 'far',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64h56c35.3 0 64 28.7 64 64s-28.7 64-64 64H128v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H128v32h32zm80-56c0-13.3 10.7-24 24-24h56c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7H288v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184zm48 56h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288v32zm200-80c48.6 0 88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88V248c0-48.6 39.4-88 88-88zm-40 88v16c0 22.1 17.9 40 40 40s40-17.9 40-40V248c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
var faPro = faRectanglePro;
var faHouseNight = {
  prefix: 'far',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9zm289.9 85.3c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4L224 294.4V456c0 30.9 25.1 56 56 56H520c30.9 0 56-25.1 56-56V294.4l24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3V456c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V255.3L400 151 528 255.3zM352 312v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24zM248.5 12.3L236.6 44.6 204.3 56.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15L275.4 44.6 263.5 12.3c-2.6-7-12.4-7-15 0zm-145 320c-2.6-7-12.4-7-15 0L76.6 364.6 44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3z"]
};
var faHotTubPerson = {
  prefix: 'far',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", "M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0zM48 336V448c0 8.8 7.2 16 16 16h48V304H48v16 16zM160 464h72V304H160V464zm120 0h72V304l-72 0V464zm-2.7-208H376l24 0 48 0c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V336 320 280 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8zM48 256l88 0h40l-51.2-38.4c-8.3-6.2-18.4-9.6-28.8-9.6c-26.5 0-48 21.5-48 48zm352 48V464h48c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H400zM272 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHotTub = faHotTubPerson;
var faGlobePointer = {
  prefix: 'far',
  iconName: 'globe-pointer',
  icon: [512, 512, [], "e60e", "M303.6 415.6C283 456.8 263.4 464 256 464c-3.1 0-8.3-1.3-14.8-5.7l-15.3 52c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.2 .6 20.2 1.8 30.1l46.9-13.8c-.4-5.4-.6-10.8-.6-16.3c0-16.5 1.9-32.6 5.6-48h76.7c-1.3 13.3-2 27-2.2 41l48.4-14.2c.4-9.1 1.1-18 2-26.7h155c1.6 15.3 2.5 31.4 2.5 48s-.9 32.7-2.5 48h-47l-14.1 48h53.2c-5.6 24.4-13.2 45.9-22 63.6zM208.4 96.4C229 55.2 248.6 48 256 48s27 7.2 47.6 48.4c8.8 17.7 16.4 39.2 22 63.6H186.4c5.6-24.4 13.2-45.9 22-63.6zM384 256c0-16.4-.8-32.5-2.2-48h76.7c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48H381.8c1.5-15.5 2.2-31.6 2.2-48zm-9.3-96c-7.3-35.9-18.5-67.7-32.6-93.4c42.3 19.3 77 52.3 98.4 93.4H374.7zM71.4 160c21.4-41.1 56.1-74.1 98.4-93.4c-14.1 25.6-25.3 57.5-32.6 93.4H71.4zM374.7 352h65.9c-21.4 41.1-56.1 74.1-98.4 93.4c14.1-25.6 25.3-57.5 32.6-93.4zM39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3 .7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9L39 308.5z"]
};
var faBlanket = {
  prefix: 'far',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M48 144V276.1C66.1 263.4 88.2 256 112 256H380c7 0 13.7 1 20 3V144c0-35.3-28.7-64-64-64H112c-35.3 0-64 28.7-64 64zM0 368V144C0 82.1 50.1 32 112 32H336c61.9 0 112 50.1 112 112V320h-.1c.1 1.3 .1 2.7 .1 4c0 37.6-30.4 68-68 68H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H380c11 0 20-9 20-20s-9-20-20-20H112c-35.3 0-64 28.7-64 64s28.7 64 64 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H112C50.1 480 0 429.9 0 368z"]
};
var faMapLocation = {
  prefix: 'far',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", "M403 148.6c3.2-10.3 5-20 5-28.6C408 53.7 354.3 0 288 0C226.4 0 175.6 46.4 168.8 106.2c-.5 4.5-.8 9.1-.8 13.8c0 10.3 2.6 22 7 34.6c.7 2.1 1.5 4.2 2.3 6.3c10.4 27 28.3 57.1 46.7 84.4c18.1 26.9 36.7 51.1 49.2 66.6c7.7 9.6 22 9.6 29.6 0c12.4-15.5 31.1-39.7 49.2-66.6c.1-.2 .3-.4 .4-.6c4.6-6.8 9.1-13.7 13.5-20.8c3.3-5.3 6.5-10.7 9.6-16c0-.1 .1-.1 .1-.2c11.8-20.4 21.8-40.8 27.4-59.2zm-8.3 89.6c-13.9 22.5-29.1 44.2-42.7 62.4V453.7L224 407.2V300.6c-13.5-18.2-28.8-39.9-42.7-62.4c-1.8-2.9-3.6-5.8-5.3-8.8V407.2L48 453.7V200.8l96.9-35.2c-5.2-14.9-8.9-30.5-8.9-45.6c0-.8 0-1.5 0-2.3L15.8 161.4C6.3 164.9 0 173.9 0 184V488c0 7.8 3.8 15.2 10.2 19.7s14.6 5.6 22 2.9l167.8-61 167.8 61c5.3 1.9 11.1 1.9 16.4 0l176-64c9.5-3.4 15.8-12.5 15.8-22.6V120c0-7.8-3.8-15.2-10.2-19.7s-14.6-5.6-22-2.9l-105 38.2c-2.2 15-7.3 30.2-13.2 44.2c-2 4.6-4.1 9.3-6.3 14L528 154.3V407.2L400 453.7V229.5c-1.8 3-3.5 5.9-5.3 8.8z"]
};
var faMapMarked = faMapLocation;
var faHouseFloodWater = {
  prefix: 'far',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", "M301.9 4.4c-8.3-5.9-19.4-5.9-27.7 0l-192 136c-10.8 7.7-13.4 22.6-5.7 33.5s22.6 13.4 33.5 5.7l2.1-1.5v80.4c7.3 1.9 14.4 5.1 20.9 9.6c8.4 5.8 17.7 10.6 27.1 14.1V144.1L288 53.4l128 90.7V282.2c9.5-3.5 18.8-8.3 27.2-14.1c6.5-4.5 13.5-7.8 20.8-9.6V178.1l2.1 1.5c10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5l-192-136zM80 318.1C62.8 333 41 344.8 18.8 349.8C5.9 352.7-2.3 365.5 .6 378.5s15.7 21.1 28.7 18.2C58 390.2 81.6 376.2 96 366.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm31.9 112c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
var faCommentsQuestionCheck = {
  prefix: 'far',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480zM184.3 86.3c-16.4 0-31 10.3-36.4 25.7l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3L247.4 168c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7H184.3zM208 266.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3zm331.3 22c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L431.4 374c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3z"]
};
var faTree = {
  prefix: 'far',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", "M241.8 7.9C237.3 2.9 230.8 0 224 0s-13.3 2.9-17.8 7.9l-144 160c-6.3 7-7.9 17.2-4.1 25.8S70.5 208 80 208H91.8l-62 72.4c-6.1 7.1-7.5 17.1-3.6 25.6s12.4 14 21.8 14H72L4.8 409.6c-5.5 7.3-6.3 17-2.3 25.1S14.9 448 24 448H160h40v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h40H424c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1L376 320h24c9.4 0 17.9-5.5 21.8-14s2.5-18.5-3.6-25.6l-62-72.4H368c9.5 0 18.1-5.6 21.9-14.2s2.3-18.8-4.1-25.8l-144-160zM248 400V216c0-13.3-10.7-24-24-24s-24 10.7-24 24V400H160 72l67.2-89.6c5.5-7.3 6.3-17 2.3-25.1s-12.4-13.3-21.5-13.3H100.2l62-72.4c6.1-7.1 7.5-17.1 3.6-25.6s-12.4-14-21.8-14H133.9L224 59.9 314.1 160H304c-9.4 0-17.9 5.5-21.8 14s-2.5 18.5 3.6 25.6l62 72.4H328c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1L376 400H288 248z"]
};
var faArrowsCross = {
  prefix: 'far',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", "M296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.1L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l359-359V184c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H296zM41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73L167.4 233.4l33.9-33.9L41 39zM246.6 312.6L366.1 432H296c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.1L280.6 278.6l-33.9 33.9z"]
};
var faBackpack = {
  prefix: 'far',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M192 48h64c4.4 0 8 3.6 8 8V80H184V56c0-4.4 3.6-8 8-8zm-56 8V80h-8C57.3 80 0 137.3 0 208V448c0 35.3 28.7 64 64 64h40H344h40c35.3 0 64-28.7 64-64V208c0-70.7-57.3-128-128-128h-8V56c0-30.9-25.1-56-56-56H192c-30.9 0-56 25.1-56 56zM368 464V376 312c0-39.8-32.2-72-72-72H152c-39.8 0-72 32.2-72 72v64 88H64c-8.8 0-16-7.2-16-16V208c0-44.2 35.8-80 80-80h32H288h32c44.2 0 80 35.8 80 80V448c0 8.8-7.2 16-16 16H368zm-240 0V400H320v64H128zm16-304c-13.3 0-24 10.7-24 24s10.7 24 24 24H304c13.3 0 24-10.7 24-24s-10.7-24-24-24H144zM320 352H128V312c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v40z"]
};
var faSquareSmall = {
  prefix: 'far',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M256 144c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16H256zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64z"]
};
var faFolderArrowUp = {
  prefix: 'far',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM280 376V273.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V376c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faFolderUpload = faFolderArrowUp;
var faBridgeLock = {
  prefix: 'far',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H256 449.6c20.2-19.8 47.9-32 78.4-32c27.3 0 52.4 9.8 71.8 26.1c5-4.4 8.2-10.9 8.2-18.1c0-13.3-10.7-24-24-24H536V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zM336 240H304c-57.4 0-104 46.6-104 104v88H152V336c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48V440c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V344c0-30.9 25.1-56 56-56h32c24.9 0 45.9 16.2 53.2 38.6c5.5-12.6 14.9-23.2 26.8-30v-19c-19.1-22.9-47.8-37.5-80-37.5zM488 80v64H408V80h80zM360 80v64H280V80h80zM232 80v64H152V80h80zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faCrosshairsSimple = {
  prefix: 'far',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M462.6 232H392c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.6c-11 95.7-86.9 171.6-182.6 182.6V392c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.6C136.3 451.6 60.4 375.7 49.4 280H120c13.3 0 24-10.7 24-24s-10.7-24-24-24H49.4C60.4 136.3 136.3 60.4 232 49.4V120c0 13.3 10.7 24 24 24s24-10.7 24-24V49.4c95.7 11 171.6 86.9 182.6 182.6zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
var faSackDollar = {
  prefix: 'far',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M218.7 152h74.6l13.8 8.8C361.1 195.4 464 277 464 416c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48c0-139 102.9-220.6 156.9-255.2l13.8-8.8zM286 104H226l-7.5-10.8L187.4 48H324.6L293.5 93.2 286 104zM150.8 139.9C89.4 185.5 0 274.8 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-141.2-89.4-230.5-150.8-276.1c-10.4-7.7-20-14.2-28.2-19.4l27.3-39.5 29.8-43.2C401 21.7 389.6 0 370.3 0H141.7C122.4 0 111 21.7 121.9 37.6l29.8 43.2L179 120.4c-8.2 5.3-17.8 11.7-28.2 19.4zM276 216c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"]
};
var faPenToSquare = {
  prefix: 'far',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"]
};
var faEdit = faPenToSquare;
var faSquareSliders = {
  prefix: 'far',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 80c0-13.3 10.7-24 24-24l32 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24zm24 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l128 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-128 0z"]
};
var faSlidersHSquare = faSquareSliders;
var faCarSide = {
  prefix: 'far',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M171.3 80H224V96v80 16H99.4l34.7-86.9C140.3 90 155 80 171.3 80zM272 192V176 96 80h81.2c12.2 0 23.6 5.5 31.2 15l77.6 97H272zm252 .6L422 65c-16.7-20.9-42-33-68.7-33H171.3c-36 0-68.3 21.9-81.7 55.3l-42.8 107C19.8 201.8 0 226.6 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-66.7-50.9-121.4-116-127.4zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zm135.8-16c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H48V256c0-8.8 7.2-16 16-16H512c44.2 0 80 35.8 80 80v32H570.5zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faMessageMiddleTop = {
  prefix: 'far',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M343.5 144H448c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16H168.5c14.2 0 27.8-6.3 36.9-17.3L256 66l50.6 60.7c9.1 10.9 22.6 17.3 36.9 17.3zm-175-48H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H343.5L268.3 5.8C265.3 2.1 260.7 0 256 0s-9.3 2.1-12.3 5.8L168.5 96z"]
};
var faCommentMiddleTopAlt = faMessageMiddleTop;
var faLightbulbOn = {
  prefix: 'far',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M69.3 4C58.3-3.3 43.4-.3 36 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L69.3 4zM597.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552zM117.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm432-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM448 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8 11.3-12.7 17.7l0 0 0 0 0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8l0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C200.4 228.3 192 203.2 192 176c0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM400 432V416H240v16c0 44.2 35.8 80 80 80s80-35.8 80-80z"]
};
var faKnife = {
  prefix: 'far',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", "M451.4 10.8C458.1 3.9 467.2 0 476.8 0C496.2 0 512 15.8 512 35.2V83.6c0 65.5-25.9 128.4-72.1 174.9l-70.2 70.6c-31.2 31.4-82 31.5-113.3 .2L233.1 306 41.3 504.7c-9.2 9.5-24.4 9.8-33.9 .6s-9.8-24.4-.6-33.9L215.5 255.1 451.4 10.8zm-185 260.7l23.8 23.8c12.5 12.5 32.8 12.5 45.3-.1l70.2-70.6c37.3-37.5 58.2-88.2 58.2-141V66.8L266.4 271.5z"]
};
var faUtensilKnife = faKnife;
var faShareNodes = {
  prefix: 'far',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", "M448 128c0 53-43 96-96 96c-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1L279.6 321c17.6-20.2 43.5-33 72.4-33c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-6.9 .7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33c-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1c0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM352 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShareAlt = faShareNodes;
var faDisplayChartUpCircleDollar = {
  prefix: 'far',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M64 48H512c8.8 0 16 7.2 16 16V194.9c17 3.1 33.1 8.7 48 16.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H211.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H352h42.8c-18.3-12.9-34.1-29.2-46.3-48H323.7 288 252.3l8-48H288h27.7 11c-4.3-15.3-6.6-31.4-6.6-48H240.4c-.3 0-.6 0-.8 0H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zM480 192.7V120c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
var faWaveSine = {
  prefix: 'far',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M47.3 237.8l0 0 0 0 .1-.2 .3-1.1c.3-1 .7-2.5 1.3-4.5c1.2-4 3-9.8 5.6-16.8c5.2-14.1 13.1-32.6 24-50.9C101.2 126.6 132.9 96 176 96c33.3 0 55.6 16.4 74.1 46.2c19.5 31.3 32.6 73.9 46.9 120.8l.6 1.9c13.6 44.6 28.3 93.1 51.5 130.3C373.6 434.4 409.3 464 464 464c68.9 0 113.2-49.4 138.6-91.7c13-21.7 22.1-43.1 28-59.1c2.9-8 5.1-14.7 6.5-19.5c.7-2.4 1.3-4.3 1.6-5.6c.2-.7 .3-1.2 .4-1.6l.1-.5 0-.1 0-.1 0 0s0 0-23.3-5.8l23.3 5.8c3.2-12.9-4.6-25.9-17.5-29.1s-25.9 4.6-29.1 17.4l0 0 0 0-.1 .2-.3 1.1c-.3 1-.7 2.5-1.3 4.5c-1.2 4-3 9.8-5.6 16.8c-5.2 14.1-13 32.6-24 50.9C538.8 385.4 507.1 416 464 416c-33.3 0-55.6-16.4-74.1-46.2C370.4 338.5 357.2 295.9 343 249l-.6-1.9C328.8 202.5 314 154 290.9 116.8C266.4 77.6 230.7 48 176 48C107.1 48 62.8 97.4 37.4 139.7c-13 21.7-22.1 43.1-28 59.1c-2.9 8-5.1 14.7-6.5 19.5c-.7 2.4-1.3 4.3-1.6 5.6c-.2 .7-.3 1.2-.4 1.6l-.1 .5 0 .1 0 .1 0 0s0 0 23.3 5.8L.7 226.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.4z"]
};
var faHeartCircleMinus = {
  prefix: 'far',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9l0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2l-.1 .1-.1 .1-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"]
};
var faCircleW = {
  prefix: 'far',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM150.9 168.7c-4-12.6-17.5-19.6-30.2-15.5s-19.6 17.5-15.5 30.2l64 200c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7L256 254.7l41.1 128.6c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7l64-200c4-12.6-2.9-26.1-15.5-30.2s-26.1 2.9-30.2 15.5L320 297.3 278.9 168.7c-3.2-9.9-12.4-16.7-22.9-16.7s-19.7 6.7-22.9 16.7L192 297.3 150.9 168.7z"]
};
var faCircleCalendar = {
  prefix: 'far',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 112c8.8 0 16 7.2 16 16v16h64V128c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c26.5 0 48 21.5 48 48v32 96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V224 192c0-26.5 21.5-48 48-48h16V128c0-8.8 7.2-16 16-16zM176 320H336V224H176v96z"]
};
var faCalendarCircle = faCircleCalendar;
var faHourglassHalf = {
  prefix: 'far',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5H284.2c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67V48H80V67c0 22.1 7 43.4 19.8 61H284.2z"]
};
var faHourglass2 = faHourglassHalf;
var faMicroscope = {
  prefix: 'far',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M192 0c-17.7 0-32 14.3-32 32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32H192zM176 272V80h64V272H176zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H320 488c13.3 0 24-10.7 24-24s-10.7-24-24-24H447c39.9-35.2 65-86.7 65-144c0-106-86-192-192-192h0v48h0c79.5 0 144 64.5 144 144s-64.5 144-144 144h0H24zm72-56c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
};
var faSunset = {
  prefix: 'far',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M305 217c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V24c0-13.3 10.7-24 24-24s24 10.7 24 24V142.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80zm88.3 8.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H82.1L36.2 397.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L288 285.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464h36.7c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96h36.7l43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3L301.6 334c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L96.8 400.8 140.4 464zM350 464c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48H350z"]
};
var faSink = {
  prefix: 'far',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M280 88c0-22.1 17.9-40 40-40s40 17.9 40 40v24c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-48.6-39.4-88-88-88s-88 39.4-88 88V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H256 488c13.3 0 24-10.7 24-24s-10.7-24-24-24H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H280V88zM32 368v24c0 66.3 53.7 120 120 120H360c66.3 0 120-53.7 120-120V368H432v24c0 39.8-32.2 72-72 72H152c-39.8 0-72-32.2-72-72V368H32z"]
};
var faCalendarExclamation = {
  prefix: 'far',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zM256 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-152c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V248z"]
};
var faTruckContainerEmpty = {
  prefix: 'far',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M432 168c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3V272v16 80c0 17.7-14.3 32-32 32c0 44.2-35.8 80-80 80s-80-35.8-80-80H432 288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32H432V256 168zm103 26.9c-1.5-1.9-3.8-2.9-6.2-2.9H480v64H585l-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHandHeart = {
  prefix: 'far',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", "M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64v2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64V336c0 1.5-.1 3-.4 4.5c-6.2 91.7-79.4 165-171.1 171.1c-1.5 .3-2.9 .4-4.5 .4h-8-8.5c-67.9 0-133-27-181-75L18.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7V96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24V95.9c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16V319.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L75.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9H296h4.9c.6-.1 1.3-.1 1.9-.2c69.7-3.4 125.6-59.3 129-129c0-.6 .1-1.3 .2-1.9V160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 .1V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V152l0-.1V96c0-8.8-7.2-16-16-16s-16 7.1-16 16l0 .1V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V96l0-.1V64c0-8.8-7.2-16-16-16s-16 7.2-16 16V96l0 .1V232zm-32 96.8c0-22.6 18.3-40.8 40.8-40.8c10.8 0 21.2 4.3 28.9 12l5 5 5-5c7.7-7.7 18-12 28.9-12c22.6 0 40.8 18.3 40.8 40.8c0 10.8-4.3 21.2-12 28.9l-55.2 55.2c-4.2 4.2-10.9 4.2-15.1 0L220 357.7c-7.7-7.7-12-18-12-28.9z"]
};
var faBagShopping = {
  prefix: 'far',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 112v48H288V112c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 96H48V416c0 26.5 21.5 48 48 48H352c26.5 0 48-21.5 48-48V208H336v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H160v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V208zm0-48V112C112 50.1 162.1 0 224 0s112 50.1 112 112v48h64c26.5 0 48 21.5 48 48V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V208c0-26.5 21.5-48 48-48h64z"]
};
var faShoppingBag = faBagShopping;
var faArrowDownZA = {
  prefix: 'far',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM352 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h74.6L334.1 184.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 224 352 224H480c13.3 0 24-10.7 24-24s-10.7-24-24-24H405.4L497.9 71.9c6.3-7.1 7.8-17.2 4-25.8S489.4 32 480 32H352zm64 240c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L370.8 440H456c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160c-4.1-8.1-12.4-13.3-21.5-13.3zM394.8 392L416 349.7 437.2 392H394.8z"]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faMitten = {
  prefix: 'far',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M0 142.6C0 63.8 63.8 0 142.6 0c63.7 0 119.6 42.2 137.1 103.4l21.4 75c15.7-11.8 35-18.4 55.2-18.4h4.5c48.2 0 87.3 39.1 87.3 87.3c0 21.9-8.3 43.1-23.1 59.2L353.3 384H304v-8c0-6 2.3-11.8 6.4-16.3l79.2-85.8c6.7-7.3 10.4-16.8 10.4-26.6c0-21.7-17.6-39.3-39.3-39.3h-4.5c-14.6 0-28.3 7.3-36.4 19.5l-9.5 14.2c-5.2 7.8-14.4 11.8-23.7 10.4s-16.8-8.1-19.4-17.1L233.5 116.6C221.9 76 184.8 48 142.6 48C90.3 48 48 90.3 48 142.6v2.5c0 7.9 1 15.8 2.9 23.5l52.4 209.5c.5 1.9 .7 3.9 .7 5.8H55.3L4.3 180.3C1.5 168.8 0 157 0 145.1v-2.5zM64 416H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448c0-17.7 14.3-32 32-32z"]
};
var faReplyClock = {
  prefix: 'far',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M640 144a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm16 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-11.4 0-22.6-1.1-33.4-3.2c.9 6.2 1.4 12.6 1.4 19.2c0 15.3-1.9 29.1-5.2 41.5C442 316.7 386.2 272 320 272H224 200c-13.3 0-24 10.7-24 24v24 28.1L55.9 240 176 131.9V160v24c0 13.3 10.7 24 24 24h24H332c-5.9-15.1-9.8-31.2-11.3-48H272 224V112 96c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V368 320h48 48c53 0 96 43 96 96c0 17.3-4.2 30.5-9.5 40.2c-1.6 2.9-3.3 5.5-5 7.9c-2.6 3.5-5.3 6.4-7.7 8.6c-.5 .5-1 .9-1.4 1.4c-4.8 4.9-8.3 11.3-8.3 18.1c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9c2.6-1.4 6.3-3.5 10.8-6.5c2.7-1.8 5.7-3.8 8.9-6.2c3.7-2.7 7.6-5.8 11.7-9.3C473.4 462.2 512 413.9 512 336z"]
};
var faReplyTime = faReplyClock;
var faPersonRays = {
  prefix: 'far',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3 .1V304H240V176.1c.7 0 1.5-.1 2.3-.1zM240 488V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L346.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7H242.3c-31.7 0-61 17.1-76.6 44.7L107.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L192 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM7 7C-2.3 16.4-2.3 31.6 7 41l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7C31.6-2.3 16.4-2.3 7 7zM505 7c-9.4-9.4-24.6-9.4-33.9 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9zM41 505l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm464 0c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0z"]
};
var faRight = {
  prefix: 'far',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M397.6 256L247.7 398.7c-.8 .8-2 1.3-3.2 1.3c-2.5 0-4.6-2-4.6-4.6l0-83.4c0-13.3-10.7-24-24-24L48 288l0-64 168 0c13.3 0 24-10.7 24-24l0-83.4c0-2.5 2-4.6 4.6-4.6c1.2 0 2.3 .5 3.2 1.3L397.6 256zm-153 192c13.5 0 26.5-5.2 36.3-14.5L434.8 286.9c8.5-8.1 13.2-19.2 13.2-30.9s-4.8-22.8-13.2-30.9L280.8 78.5C271.1 69.2 258.1 64 244.6 64c-29 0-52.6 23.5-52.6 52.6l0 59.4L48 176c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l144 0 0 59.4c0 29 23.5 52.6 52.6 52.6z"]
};
var faArrowAltRight = faRight;
var faCircleF = {
  prefix: 'far',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H208V176H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faUsers = {
  prefix: 'far',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM405.3 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80H378.7c39.8 0 73.2 27.2 82.6 64H178.7c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z"]
};
var faFacePleading = {
  prefix: 'far',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM266.5 412.4c-2-2.1-5.3-4.4-10.5-4.4s-8.5 2.3-10.5 4.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9c8.9-9.5 24.2-19.6 45.5-19.6s36.7 10.1 45.5 19.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 32c-44.2 0-80-35.8-80-80c0-18 6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80zm240-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 0c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48zm-304 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z"]
};
var faEyeSlash = {
  prefix: 'far',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"]
};
var faFlaskVial = {
  prefix: 'far',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M175 389.4l49-79.6V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H176 80 32 24C10.7 0 0 10.7 0 24S10.7 48 24 48h8V352c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-18.7 5.2-37.1 15-53.1zM80 48h96V160H80V48zm0 160h96V352c0 26.5-21.5 48-48 48s-48-21.5-48-48V208zM312 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V217.2L202 408.9c-6.6 10.7-10 22.9-10 35.5c0 37.4 30.3 67.6 67.6 67.6H572.4c37.4 0 67.6-30.3 67.6-67.6c0-12.5-3.5-24.8-10-35.5L512 217.2V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H312zM464 48V224c0 4.4 1.2 8.8 3.6 12.6L518.9 320H313.1l51.3-83.4c2.3-3.8 3.6-8.1 3.6-12.6V48h96zM242.9 434.1L283.6 368H548.4l40.6 66.1c1.9 3.1 2.9 6.7 2.9 10.3c0 10.8-8.8 19.6-19.6 19.6H259.6c-10.9 0-19.6-8.8-19.6-19.6c0-3.6 1-7.2 2.9-10.3z"]
};
var faPoliceBox = {
  prefix: 'far',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M192 0c8.8 0 16 7.2 16 16V32h80c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 64 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-17.7 14.3-32 32-32c0-17.7 14.3-32 32-32h80V16c0-8.8 7.2-16 16-16zM80 464H304V112H80V464zm24-320c0-4.4 3.6-8 8-8h24v32H104V144zm0 40h32v32H112c-4.4 0-8-3.6-8-8V184zm72-48c4.4 0 8 3.6 8 8v24H152V136h24zm-24 48h32v24c0 4.4-3.6 8-8 8H152V184zm56-48h24v32H200V144c0-4.4 3.6-8 8-8zm24 48v32H208c-4.4 0-8-3.6-8-8V184h32zm16-48h24c4.4 0 8 3.6 8 8v24H248V136zm32 48v24c0 4.4-3.6 8-8 8H248V184h32zM104 248c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248z"]
};
var faCucumber = {
  prefix: 'far',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M71.4 440.6c-31.2-31.2-31.2-81.9 0-113.1l256-256c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-63 63c-4.4-4.7-10.6-7.6-17.5-7.6c-13.3 0-24 10.7-24 24c0 6.9 2.9 13.1 7.6 17.5l-159 159c-31.2 31.2-81.9 31.2-113.1 0zM37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM352 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM184 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHeadSideBrain = {
  prefix: 'far',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64V336h.4c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0H224C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm264-32c22.1 0 40-17.9 40-40s-17.9-40-40-40c-2 0-3.9 .1-5.8 .4C299.8 102.5 288.7 96 276 96c-6.2 0-12.1 1.6-17.2 4.3C252 88.2 238.9 80 224 80s-28 8.2-34.8 20.3C184.1 97.6 178.2 96 172 96c-18.5 0-33.8 14-35.8 32l-.2 0c-22.1 0-40 17.9-40 40c0 16.5 9.9 30.6 24.1 36.7c-.1 1.1-.1 2.2-.1 3.3c0 22.1 17.9 40 40 40c5.7 0 11.1-1.2 16-3.3V296c0 13.3 10.7 24 24 24s24-10.7 24-24V247.2c2.6 .5 5.3 .8 8 .8c22.1 0 40-17.9 40-40c0-5.7-1.2-11.1-3.3-16H312z"]
};
var faHand = {
  prefix: 'far',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5V160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1c0 0 0-.1 0-.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16V95.9c0 0 0 .1 0 .1V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16v55.9c0 0 0 .1 0 .1v80c0 13.3 10.7 24 24 24s24-10.7 24-24V160.1c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16V332.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z"]
};
var faHandPaper = faHand;
var faPersonBikingMountain = {
  prefix: 'far',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm.5 103c-2.7-3.4-7.5-4-11-1.4l-74.6 55c-9.6 7.1-8.4 21.8 2.3 27.2l69.6 34.8c8.1 4.1 13.3 12.4 13.3 21.5V416c0 13.3-10.7 24-24 24s-24-10.7-24-24V302.8l-56.3-28.1c-42.8-21.4-47.8-80.4-9.3-108.8l74.6-55C337.2 93.1 371.2 97.5 390 121l37.6 47H480c13.3 0 24 10.7 24 24s-10.7 24-24 24H416c-7.3 0-14.2-3.3-18.7-9l-44.8-56zM188.4 166.7c-6.9 5.2-16.7 3.9-22.1-2.8l-44-55c-5.6-7.1-4.3-17.4 2.9-22.8l65.2-48.9c27.7-20.7 66.8-15.8 88.4 11.2l14.9 18.7c5.6 7.1 4.3 17.4-2.9 22.8L188.4 166.7zM120 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C158.1 503.1 148.1 512 136 512H120c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L31.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C8.9 414.1 0 404.1 0 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9C97.9 264.9 107.9 256 120 256zm8 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM480.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C542.1 503.1 532.1 512 520 512H504c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C392.9 414.1 384 404.1 384 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM576 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faBikingMountain = faPersonBikingMountain;
var faUtensilsSlash = {
  prefix: 'far',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l76.5 59.9 4.9-43.7C121.6 8.2 133.5-1.3 146.7 .1s22.7 13.3 21.2 26.5l-8.1 73.2L200 131.5V24c0-13.3 10.7-24 24-24s24 10.7 24 24V168c0 .4 0 .7 0 1.1L291.2 203c3-5.6 4.8-12.1 4.8-19V169.3L280.1 26.7c-1.5-13.2 8-25 21.2-26.5s25 8 26.5 21.2l16 144 .1 1.3V168v16c0 18-5.4 34.8-14.7 48.8L384 275.7V176C384 32 496 0 512 0c17.7 0 32 14.3 32 32V248v56 48 49.1l86.8 68c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM104 184v-6.1L248 291.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272h-8c-48.6 0-88-39.4-88-88zM519.7 512h.6l-.3 0-.3 0zM432 176V288c0 8.8 7.2 16 16 16h48V248 55.1c-7.1 3.6-14.9 8.5-22.6 15.2C453.7 87.4 432 118.3 432 176z"]
};
var faPrintMagnifyingGlass = {
  prefix: 'far',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M176 160H128V64c0-35.3 28.7-64 64-64H421.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H464V90.5c0-4.2-1.7-8.3-4.7-11.3L432.8 52.7c-3-3-7.1-4.7-11.3-4.7H192c-8.8 0-16 7.2-16 16v96zm16 208v96H378.2c21.1 10.2 44.8 16 69.8 16c16.7 0 32.8-2.6 48-7.3V480c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V400H96c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H352c-17.2 12.9-31.7 29.3-42.6 48H128c-8.8 0-16 7.2-16 16v96h32c0-17.7 14.3-32 32-32H288c0 16.7 2.6 32.8 7.3 48H192zm256 32.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
var faPrintSearch = faPrintMagnifyingGlass;
var faFolderBookmark = {
  prefix: 'far',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M251.7 127.6l0 0c1.4 1.4 2.8 2.7 4.3 3.9V304c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L336 276l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3V144h32c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3z"]
};
var faOm = {
  prefix: 'far',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zm10.9 255c7.5-7.5 17.7-11.7 28.3-11.7H424c22.1 0 40 17.9 40 40V400c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0 0 0c-1.8-7.3-8.4-12.3-15.9-12.1s-13.8 5.5-15.3 12.9L352 384c-15.7-3.1-15.7-3.1-15.7-3.1l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1c-.1 .8-.3 1.9-.4 3.2c-.3 2.7-.6 6.4-.6 10.9c0 8.8 1.2 21 6.1 33.4c5.1 12.7 14.1 25.6 29.4 35.1c15.1 9.5 35.3 14.9 61.5 14.9c44.2 0 80-35.8 80-80V288c0-48.6-39.4-88-88-88h-5.5c-23.3 0-45.7 9.3-62.2 25.8l-26.5 26.5c-7.5 7.5-17.7 11.7-28.3 11.7H231.7C242 247.8 248 228.6 248 208c0-57.4-46.6-104-104-104c-23.4 0-45 7.7-62.4 20.8c-10.6 8-12.7 23-4.8 33.6s23 12.7 33.6 4.8c9.4-7 21-11.2 33.6-11.2c30.9 0 56 25.1 56 56s-25.1 56-56 56H108.9c-7.1 0-12.9 5.8-12.9 12.9c0 2 .5 4 1.4 5.8l5.8 11.6c5.4 10.8 16.5 17.7 28.6 17.7H144h12c42 0 76 34 76 76c0 41.5-33.2 75.2-74.5 76c-50.1-.6-77-18.5-91.6-34.7c-7.6-8.5-12.3-16.9-15-23.2c-1.3-3.1-2.2-5.6-2.7-7.3c-.2-.8-.4-1.4-.5-1.8l-.1-.3c-1.7-8-9.1-13.5-17.2-12.7C22.2 384.9 16 391.8 16 400H32c-16 0-16 0-16 0l0 0 0 .1 0 .1 0 .4c0 .3 0 .7 0 1.2c0 1 .1 2.3 .3 3.9c.3 3.2 .9 7.6 2.1 12.8c2.3 10.4 7 24.4 16.3 38.4C53.6 485.3 89.9 511 156 512v0c.5 0 1.1 0 1.6 0c.8 0 1.6 0 2.4 0c.8 0 1.5-.1 2.2-.2C227.8 508.6 280 454.4 280 388c0-28.6-9.7-55-26-76h47.5c23.3 0 45.7-9.3 62.2-25.8l26.5-26.5zm80.8-153c10.4-8.3 12-23.4 3.8-33.7l-33.7-3.8 0 0-.2 .1c-.2 .1-.5 .4-1 .7c-.9 .7-2.4 1.7-4.3 3c-3.8 2.6-9.5 6-16.4 9.5C405.1 89.6 387 96 368.2 96l-.2 0c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0c-6.3-4.2-14.8-3.4-20.2 2s-6.2 13.8-2 20.2L272 80c-13.3 8.9-13.3 8.9-13.3 8.9l0 0 0 0 .1 .1 .1 .2 .4 .6c.3 .5 .8 1.1 1.4 1.9c1.2 1.6 3 3.8 5.3 6.4c4.6 5.1 11.3 11.9 20.4 18.7c18 13.5 45.3 27.2 81.5 27.2l.1 0c29.1 0 54.9-9.6 72.7-18.5c9.1-4.5 16.4-9.1 21.6-12.5c2.6-1.7 4.6-3.2 6.1-4.3c.7-.5 1.3-1 1.7-1.3l.5-.4 .2-.1 .1-.1 0 0 0 0s0 0-15-18.7l15 18.7zM441.1 69.2L474.7 73c-8.3-10.3-23.3-12-33.7-3.8zM367.5 380.1l0 0c0 0 0 0 0 0z"]
};
var faPi = {
  prefix: 'far',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h88V277.4c0 44.9-11.4 89-33.2 128.2L75 412.3c-6.4 11.6-2.3 26.2 9.3 32.6s26.2 2.3 32.6-9.3l3.8-6.8c25.8-46.4 39.3-98.5 39.3-151.5V112H304V374.6c0 40.6 32.9 73.4 73.4 73.4c27.8 0 53.2-15.7 65.7-40.6l2.3-4.7c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.3 4.7c-4.3 8.6-13.1 14.1-22.8 14.1c-14.1 0-25.4-11.4-25.4-25.4V112h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faFlaskRoundPotion = {
  prefix: 'far',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", "M176 48h96V157.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 351.9c-64.4-.9-94.8-12.3-122.5-22.7c-23.8-9-45.7-17.2-85.5-17.2c-55.8 0-92.3 16.1-111.5 27.9c4-53.9 34.8-100.4 79.2-126.3c18.8-11 32.3-31.6 32.3-55.9V48zM320 157.7V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H304 144 120C106.7 0 96 10.7 96 24s10.7 24 24 24h8V157.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z"]
};
var faFlaskPotion = faFlaskRoundPotion;
var faFaceShush = {
  prefix: 'far',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M48 256c0 73.6 38.3 138.3 96 175.3v.7 24c0 11.8 2.3 23.1 6.5 33.3C61.8 449.1 0 359.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 82.2-38.8 155.4-99 202.3c6.4-18.5 2.7-39.4-10.4-54.7C440.5 365.9 464 313.7 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256zm299.3-4.7c-8.7 8.7-20.5 17.7-35.3 24.6V248c0-2.8-.2-5.6-.6-8.4c5.2-3.5 9.6-7.3 13.3-10.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200 248v27.9c-14.8-6.9-26.6-15.9-35.3-24.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9c-.4 2.7-.6 5.5-.6 8.4zM176.4 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM280 248v72H232V248c0-13.3 10.7-24 24-24s24 10.7 24 24zM224 408v11.5L287.6 464h10c7.1 0 13.9-3.2 18.4-8.6l25.6-30.7c8.5-10.2 23.6-11.6 33.8-3.1s11.6 23.6 3.1 33.8l-25.6 30.7c-13.7 16.4-33.9 25.9-55.3 25.9H280 232c-30.9 0-56-25.1-56-56V432 408c0-30.9 25.1-56 56-56h32c30.9 0 56 25.1 56 56v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8z"]
};
var faWorm = {
  prefix: 'far',
  iconName: 'worm',
  icon: [512, 512, [], "e599", "M400 192V368c0 35.3-28.7 64-64 64s-64-28.7-64-64V320c0-53-43-96-96-96s-96 43-96 96V448c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-35.3 28.7-64 64-64s64 28.7 64 64v48c0 53 43 96 96 96s96-43 96-96V192 120 96c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48s21.5 48 48 48h16 48v48zM176 176c15.9 0 31.2 2.6 45.5 7.3c27.7 9.2 51.7 26.6 69 49.3c5.1 6.7 9.6 13.8 13.5 21.3c10.2 19.8 16 42.2 16 66v20.3V368c0 8.8 7.2 16 16 16s16-7.2 16-16V340.3 320 243.1 240 192H336c-6.3 0-12.5-.6-18.5-1.8c-27.6-5.4-51-22.6-64.7-46.2c-8.2-14.1-12.8-30.5-12.8-48c0-53 43-96 96-96h48c53 0 96 43 96 96v24 72V368c0 79.5-64.5 144-144 144c-55.7 0-104.1-31.7-128-78c-10.2-19.8-16-42.2-16-66V347.7 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v27.7V368v76.9V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V320c0-79.5 64.5-144 144-144zM376 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHouseCircleXmark = {
  prefix: 'far',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H394.8c-18.3-12.9-34.1-29.2-46.3-48H336v0H240V320h86.6c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2H232c-22.1 0-40 17.9-40 40V464H144c-17.7 0-32-14.3-32-32V204.8L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faPlug = {
  prefix: 'far',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c77-11.6 136-78 136-158.2V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM192 368c-61.9 0-112-50.1-112-112V192H304v64c0 61.9-50.1 112-112 112z"]
};
var faCalendarCircleExclamation = {
  prefix: 'far',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H432 400 352 48V448c0 8.8 7.2 16 16 16H284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faSquareI = {
  prefix: 'far',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faChevronUp = {
  prefix: 'far',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
};
var faFaceSaluting = {
  prefix: 'far',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M266.6 14C256.7-.6 236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7s-30.4-17.5-44.7-7.1l-3.3 2.4s0 0 0 0l-9.9 7.2-14.2 10.4L128 185.8V146.8L258.1 58.5c14.6-9.9 18.4-29.8 8.5-44.4zm31.8-8.4c7.2 15.7 7.4 33.4 1.6 48.9c16.6-4.3 34-6.5 52-6.5c114.9 0 208 93.1 208 208s-93.1 208-208 208c-103 0-188.6-74.9-205.1-173.2c-13.8 9.9-29.2 16.3-45.2 19.2C126.5 425.5 229.2 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-18.4 0-36.3 1.9-53.5 5.6zM256 180.5c-.4 13.7-5.1 27.1-13.8 38.2c4.4 12.4 16.2 21.4 30.2 21.4c17.7 0 32-14.3 32-32s-14.3-32-32-32c-6 0-11.6 1.6-16.3 4.5zm13.4 152.6c-11-7.4-25.9-4.6-33.3 6.4s-4.6 25.9 6.4 33.3C265 388.1 301.7 403 352 403s87-14.9 109.5-30.2c11-7.4 13.8-22.4 6.4-33.3s-22.4-13.8-33.3-6.4C419.9 343 392.6 355 352 355s-67.9-12-82.5-21.9zM432.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faGaugeSimpleLow = {
  prefix: 'far',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1 .2-26.3 12.3-31.6s26.3 .2 31.6 12.3L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56s-56-25.1-56-56z"]
};
var faTachometerSlow = faGaugeSimpleLow;
var faFacePersevering = {
  prefix: 'far',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM211.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM133.5 210.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faCircleCamera = {
  prefix: 'far',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm196-96l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h62.7c10 0 19 6.2 22.5 15.6L316 160h36c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h36zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCameraCircle = faCircleCamera;
var faHandSpock = {
  prefix: 'far',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512c-11.2 0-22.5 0-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8c11.2 0 22.5 0 33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"]
};
var faSpiderWeb = {
  prefix: 'far',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M137.5 23.6C141.6 12.7 153 6.3 164.4 8.4l69 12.9c36.1 6.8 73 6.8 109.1 0l69-12.9c11.5-2.1 22.8 4.2 26.9 15.2l28.9 77.2c11.7 31.1 28.5 60 49.8 85.6l45.3 54.3c7.4 8.9 7.4 21.8 0 30.7l-45.3 54.3c-21.3 25.5-38.1 54.5-49.8 85.6l-28.9 77.2c-4.1 10.9-15.4 17.3-26.9 15.2l-69-12.9c-36.1-6.8-73-6.8-109.1 0l-69 12.9c-11.5 2.1-22.8-4.2-26.9-15.2l-28.9-77.2c-11.7-31.1-28.5-60-49.8-85.6L13.6 271.4c-7.4-8.9-7.4-21.8 0-30.7l45.3-54.3c21.3-25.5 38.1-54.5 49.8-85.6l28.9-77.2zm27 64.7l-11 29.3c-13.6 36.2-33.1 69.8-57.8 99.4L83.2 232h49.8c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7L164.5 88.3zm42.1-23.1l24 41.9c37.7 9.5 77.2 9.5 114.9 0l24-41.9-18 3.4c-41.9 7.9-84.9 7.9-126.8 0l-18-3.4zM411.5 88.3l-24.8 43.3 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4h49.8l-12.5-14.9c-24.7-29.7-44.3-63.3-57.8-99.4l-11-29.3zM492.8 280H443c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 24.2 42.4 11-29.3c13.6-36.2 33.1-69.8 57.8-99.4L492.8 280zM369.4 446.8l-22.1-38.7c-37.9-11.7-78.3-12.8-116.7-3.2l-24 41.9 18-3.4c41.9-7.9 84.9-7.9 126.8 0l18 3.4zM164.5 423.7l24.8-43.3-2.5-7c-12.1-34.2-30.3-65.8-53.7-93.4H83.2l12.5 14.9c24.7 29.7 44.3 63.3 57.8 99.4l11 29.3zM193.2 280c10.1 15 18.9 30.7 26.5 47.1L246.6 280H193.2zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1L288 304.4l-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7H329.4l27.3 47.7zM382.8 232c-10.1-15-18.9-30.7-26.5-47.1L329.4 232h53.4zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0L288 207.6 314.7 161zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1h53.4l-26.9-47.1z"]
};
var faCircleMicrophone = {
  prefix: 'far',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm-56 88c13.3 0 24 10.7 24 24c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.3 10.7-24 24-24s24 10.7 24 24c0 62.5-44.8 114.5-104 125.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V381.8C172.8 370.5 128 318.5 128 256c0-13.3 10.7-24 24-24z"]
};
var faMicrophoneCircle = faCircleMicrophone;
var faBookArrowUp = {
  prefix: 'far',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80h96V464H80c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V352H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H392c4.4 0 8 3.6 8 8V344c0 4.4-3.6 8-8 8H304v48h64v64H304v48H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V394.6c18.9-9 32-28.3 32-50.6V56c0-30.9-25.1-56-56-56H88zm55 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L216 488c0 13.3 10.7 24 24 24s24-10.7 24-24V209.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
};
var faPopsicle = {
  prefix: 'far',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160l0 176h88V184c0-13.3 10.7-24 24-24s24 10.7 24 24V336h88V160zM136 384H48c-26.5 0-48-21.5-48-48V160C0 71.6 71.6 0 160 0s160 71.6 160 160V336c0 26.5-21.5 48-48 48H184V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384z"]
};
var faCommand = {
  prefix: 'far',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M0 92C0 41.2 41.2 0 92 0s92 41.2 92 92v44H328V92c0-50.8 41.2-92 92-92s92 41.2 92 92v4c0 53-43 96-96 96H376V320h40c53 0 96 43 96 96v4c0 50.8-41.2 92-92 92s-92-41.2-92-92V376H184v44c0 50.8-41.2 92-92 92s-92-41.2-92-92v-4c0-53 43-96 96-96h40V192H96C43 192 0 149 0 96V92zm136 52v-8V92c0-24.3-19.7-44-44-44S48 67.7 48 92v4c0 26.5 21.5 48 48 48h40zm48 176v8H328v-8V192v-8H184v8V320zm-48 48H96c-26.5 0-48 21.5-48 48v4c0 24.3 19.7 44 44 44s44-19.7 44-44V376v-8zm240 8v44c0 24.3 19.7 44 44 44s44-19.7 44-44v-4c0-26.5-21.5-48-48-48H376v8zm0-232h40c26.5 0 48-21.5 48-48V92c0-24.3-19.7-44-44-44s-44 19.7-44 44v44 8z"]
};
var faBlinds = {
  prefix: 'far',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", "M0 24C0 10.7 10.7 0 24 0H488c13.3 0 24 10.7 24 24c0 8.6-4.5 16.2-11.4 20.4l11 57.6c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9H224V80H458.6l-6.1-32H192V164.1c28 9.9 48 36.6 48 67.9c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-31.3 20-58 48-67.9V48H59.5L53.4 80H112v48H21.9C9.8 128 0 118.2 0 106.1c0-1.4 .1-2.8 .4-4.1l11-57.6C4.5 40.2 0 32.6 0 24zM66.8 208C65 215.7 64 223.7 64 232s1 16.3 2.8 24H21.9C9.8 256 0 246.2 0 234.1c0-1.4 .1-2.8 .4-4.1l13.3-70H62.6l-9.1 48H66.8zm202.4 48c1.8-7.7 2.8-15.7 2.8-24s-1-16.3-2.8-24H458.6l-9.1-48h48.9l13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9H269.2zM168 336H458.6l-9.1-48h48.9l13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9H21.9C9.8 384 0 374.2 0 362.1c0-1.4 .1-2.8 .4-4.1l13.3-70H62.6l-9.1 48H168zM13.7 416H62.6l-9.1 48H458.6l-9.1-48h48.9l13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9H21.9C9.8 512 0 502.2 0 490.1c0-1.4 .1-2.8 .4-4.1l13.3-70zM168 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faStopwatch = {
  prefix: 'far',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", "M144 24c0-13.3 10.7-24 24-24H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V97.4c43.4 5 82.8 23.3 113.8 50.9L391 119c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-31 31c24 33.9 38.1 75.3 38.1 120c0 114.9-93.1 208-208 208S16 418.9 16 304C16 197.2 96.4 109.3 200 97.4V48H168c-13.3 0-24-10.7-24-24zm80 440a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm24-248V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSaxophone = {
  prefix: 'far',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M514.5 32c-23.3 0-45.7 9.3-62.2 25.8L448 62.1l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7L400 110l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7L352 158l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7-90.6 90.6L265 176c12.8-.5 23-11.1 23-24c0-13.3-10.7-24-24-24H248 56 24c-13.3 0-24 10.7-24 24s10.7 24 24 24h2.1L4 275.3c-2.7 12-4 24.2-4 36.5C0 404.7 75.3 480 168.2 480h9.1c51.9 0 101.2-22.7 134.9-62.2l224.5-263c1.5-1.8 3.7-2.8 6.1-2.8h50.6c25.8 0 46.6-20.9 46.6-46.6c0-12.4-4.9-24.2-13.7-33L611.7 57.8C595.2 41.3 572.8 32 549.5 32h-35zM75.3 176H214.1L178.5 276.7c-1.7 4.7-2.5 9.7-2.5 14.8c0 24.5 19.9 44.4 44.4 44.4h2.3c12.4 0 24.2-4.9 33-13.6l112.1-112c.4-.4 .9-.8 1.3-1.2s.8-.8 1.2-1.3L416 161.9c.3-.3 .7-.6 1-1s.6-.7 1-1l46.4-46.3c.2-.2 .5-.4 .7-.7s.4-.4 .6-.7l20.6-20.6c7.5-7.5 17.7-11.7 28.3-11.7h35c10.6 0 20.8 4.2 28.3 11.7L590.1 104H542.8c-16.4 0-32 7.2-42.6 19.6l-224.5 263c-24.6 28.8-60.5 45.4-98.3 45.4h-9.1C101.8 432 48 378.2 48 311.8c0-8.8 1-17.5 2.9-26.1L75.3 176zM136 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquare2 = {
  prefix: 'far',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm190.7 88.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"]
};
var faFieldHockeyStickBall = {
  prefix: 'far',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", "M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4c-5.3 0-10.5-4.7-10.5-11c0-1.6 .4-3.1 .9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1 .3-84.4 32.7l-17 38.5C4.8 334 .7 352.9 .6 371.8C0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7L500.3 100.9zM398.1 162.6L213 425.4c-16.9 24-44.4 38.3-73.7 38.4c-50.5 .1-91.1-41.4-90.7-91.6c.1-12.4 2.7-24.8 7.8-36.1l17-38.5c3.6-8.1 13-11.7 21.1-8.2s11.7 13 8.2 21.1l-17 38.5c-3.2 7.3-5 15.4-5 23.5c-.3 32.7 26.2 59.5 58.6 59.4c19-.1 36.7-9.3 47.6-24.8L372.5 143.4l25.6 19.2zM432 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faFieldHockey = faFieldHockeyStickBall;
var faArrowUpSquareTriangle = {
  prefix: 'far',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", "M528 454.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9zM368 80v96h96V80H368zm94.4 352L416 354.6 369.6 432h92.8zM320 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z"]
};
var faSortShapesUpAlt = faArrowUpSquareTriangle;
var faFaceScream = {
  prefix: 'far',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", "M528 256c0 15.2-1.6 30-4.7 44.3c14.9-9.7 33-13.9 50.7-11.7c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6c17.7-2.2 35.7 2 50.7 11.7C113.6 286 112 271.2 112 256c0-114.9 93.1-208 208-208s208 93.1 208 208zM320 464c-41.6 0-80.4-12.2-112.9-33.3c6.9 20.3 11.7 41.1 14.8 61.8C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c3.1-20.7 7.9-41.5 14.8-61.8C400.5 451.8 361.7 464 320 464zM536.7 330.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3c-16.4-10.6-37.6-8.8-51.8 3.1zM183.3 282.7c27.3 14.9 67.6-2.9 90.1-39.8s18.6-78.8-8.7-93.7s-67.6 2.9-90.1 39.8s-18.6 78.8 8.7 93.7zM320 304c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V352c0-26.5-21.5-48-48-48zm46.6-61c22.5 36.9 62.8 54.7 90.1 39.8s31.1-56.9 8.7-93.7s-62.8-54.7-90.1-39.8s-31.1 56.9-8.7 93.7zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9z"]
};
var faSquareM = {
  prefix: 'far',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm139.5 41.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z"]
};
var faCameraWeb = {
  prefix: 'far',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M224 384a168 168 0 1 0 0-336 168 168 0 1 0 0 336zm0 48c-29.1 0-56.9-5.8-82.2-16.2L104.7 464H343.3l-37.1-48.2C280.9 426.2 253.1 432 224 432zM440 216c0 72.8-36 137.2-91.3 176.4l62.3 81c5.6 7.2 6.5 17 2.5 25.2s-12.4 13.4-21.5 13.4H56c-9.1 0-17.5-5.2-21.5-13.4s-3.1-18 2.5-25.2l62.3-81C44 353.2 8 288.8 8 216C8 96.7 104.7 0 224 0S440 96.7 440 216zm-144 0a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-192 0a120 120 0 1 1 240 0 120 120 0 1 1 -240 0z"]
};
var faWebcam = faCameraWeb;
var faCommentArrowDown = {
  prefix: 'far',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V262.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V152z"]
};
var faLightbulbCfl = {
  prefix: 'far',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M165.8 47.3l-128 32C25 82.5 11.9 74.7 8.7 61.8S13.3 35.9 26.2 32.7l128-32c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1zM311.3 82.2c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zm0 96c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zM144 384h80c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H184v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H96c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V306.2l48-12V384zM311.3 274.2c3.2 12.9-4.6 25.9-17.5 29.1l-64 16-5.8 1.5V384H176V302.6c-.3-11 7.1-21.1 18.2-23.9l8-2 0 0 16-4 64-16c12.9-3.2 25.9 4.6 29.1 17.5z"]
};
var faWindowFrameOpen = {
  prefix: 'far',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", "M432 240H280V48H416c8.8 0 16 7.2 16 16V240zm-200 0H80V64c0-8.8 7.2-16 16-16H232V240zm248 48V240 64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V240v48H80 432h48zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H56 456h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V320H432V464H80V320H32V464H24z"]
};
var faFaceKiss = {
  prefix: 'far',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faKiss = faFaceKiss;
var faBridgeCircleXmark = {
  prefix: 'far',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H256 496h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H536V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240H304c-57.4 0-104 46.6-104 104v88H152V336c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48V440c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V344c0-30.9 25.1-56 56-56h32c1.1 0 2.1 0 3.1 .1zM488 80v64H408V80h80zM360 80v64H280V80h80zM232 80v64H152V80h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPeriod = {
  prefix: 'far',
  iconName: 'period',
  icon: [128, 512, [], "2e", "M64 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faFaceGrinTongue = {
  prefix: 'far',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V363.6c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongue = faFaceGrinTongue;
var faUpToDottedLine = {
  prefix: 'far',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", "M114.2 288L224 178 333.8 288 280 288c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 128c-11.5 0-22.5 4.6-30.6 12.7L77.6 256.8C68.9 265.5 64 277.3 64 289.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zM416 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM128 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64z"]
};
var faThoughtBubble = {
  prefix: 'far',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M256 0c-48.7 0-91.4 25.6-115.4 64C62.6 65.9 0 129.6 0 208c0 79.5 64.5 144 144 144c9.4 0 18.7-.9 27.6-2.7C193.3 370.7 223.1 384 256 384s62.7-13.3 84.4-34.7c9 1.7 18.2 2.7 27.6 2.7c79.5 0 144-64.5 144-144c0-78.4-62.6-142.1-140.6-144C347.4 25.6 304.7 0 256 0zM176.3 98.7C190.4 68.7 220.8 48 256 48s65.6 20.7 79.7 50.7c4.3 9.1 13.8 14.6 23.8 13.7c2.8-.2 5.6-.4 8.5-.4c53 0 96 43 96 96s-43 96-96 96c-10 0-19.7-1.5-28.7-4.4c-9.6-3-20 .3-26.2 8.3C299.9 325 279.2 336 256 336s-43.9-11-57.1-28.1c-6.1-8-16.6-11.3-26.2-8.3c-9 2.8-18.7 4.4-28.7 4.4c-53 0-96-43-96-96s43-96 96-96c2.9 0 5.7 .1 8.5 .4c10 .9 19.5-4.6 23.8-13.7zM192 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 480A32 32 0 1 0 0 480a32 32 0 1 0 64 0z"]
};
var faSkeletonRibs = {
  prefix: 'far',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H254c-32.1 0-62.3 17.5-76.7 47.4c-14.1 29.2-34.2 74.3-50.9 124.3C109.8 285.3 96 341.4 96 392v11.7c0 42.1 34.2 76.3 76.3 76.3c11.2 0 22.3-2.5 32.5-7.3l70.9-33.4c6.6-3.1 13.4-5.4 20.3-7.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V432.3c6.9 1.6 13.7 4 20.3 7.1l70.9 33.4c10.2 4.8 21.3 7.3 32.5 7.3c42.1 0 76.3-34.2 76.3-76.3V392c0-50.6-13.8-106.7-30.3-156.3c-16.7-50-36.9-95.1-50.9-124.3C448.3 81.5 418.1 64 386 64H344V24zm-48 88v60.3L193.6 192.8c9.7-23.7 19.3-44.6 27-60.6c5.9-12.3 18.7-20.2 33.5-20.2h42zM173.6 245.8L296 221.3V278L152.7 319.8c4.9-22.8 11.6-46.1 19.2-68.9c.6-1.7 1.2-3.5 1.8-5.2zM144.8 372.1L296 328v55.4c-14 2.2-27.7 6.4-40.7 12.6l-70.9 33.4c-3.8 1.8-7.9 2.7-12.1 2.7c-15.6 0-28.3-12.7-28.3-28.3V392c0-6.5 .3-13.1 .8-19.9zM344 383.4V328l151.2 44.1c.5 6.8 .8 13.4 .8 19.9v11.7c0 15.6-12.7 28.3-28.3 28.3c-4.2 0-8.3-.9-12.1-2.7l-70.9-33.4c-13.1-6.1-26.8-10.3-40.7-12.6zm143.3-63.6L344 278V221.3l122.4 24.5c.6 1.7 1.2 3.5 1.8 5.2c7.6 22.7 14.3 46 19.2 68.9zm-40.9-127L344 172.3V112h42c14.8 0 27.5 7.9 33.5 20.2c7.7 16 17.3 36.9 27 60.6zM0 128V232 488c0 13.3 10.7 24 24 24s24-10.7 24-24V232c0-6.5 3.4-12.4 8.9-15.8L94 194c21.1-12.6 34-35.4 34-60v-6c0-35.3-28.7-64-64-64S0 92.7 0 128zm48 37.6V128c0-8.8 7.2-16 16-16s16 7.2 16 16v6c0 7.7-4 14.9-10.7 18.8L48 165.6zM576 64c-35.3 0-64 28.7-64 64v6c0 24.6 12.9 47.4 34 60l37.1 22.3c5.5 3.3 8.9 9.3 8.9 15.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V232 128c0-35.3-28.7-64-64-64zm-5.3 88.8c-6.6-4-10.7-11.1-10.7-18.8v-6c0-8.8 7.2-16 16-16s16 7.2 16 16v37.6l-21.3-12.8z"]
};
var faRaygun = {
  prefix: 'far',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M288 64H192L102.2 4.1C98.2 1.4 93.4 0 88.6 0C75 0 64 11 64 24.6V74.8C26.2 92.8 0 131.3 0 176c0 59.3 46.1 107.8 104.4 111.7l-69 137.9c-7.9 15.8-1.5 35 14.3 42.9l80 40c15.8 7.9 35 1.5 42.9-14.3l103-206 .2-.3H288v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8V240 112 64 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8zM112 112H288V240H112c-35.3 0-64-28.7-64-64s28.7-64 64-64zM392 64c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V208h60.9l77.1 30.9c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V128c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L476.9 144H416V88c0-13.3-10.7-24-24-24zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM222 288.3L136.8 458.5 85.5 432.8l72.3-144.5H222z"]
};
var faFlute = {
  prefix: 'far',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", "M144 304H576c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H144v96zm-48 0V208H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H96zM64 160H96h24 24H576c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H144 120 96 64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAcorn = {
  prefix: 'far',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M267.2 38.4c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8L224 16c-10.7 14.3-18 30.7-21.6 48H96C43 64 0 107 0 160v16c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-53-43-96-96-96H252.1c2.4-6.8 5.9-13.3 10.3-19.2l4.8-6.4zM400 160H48c0-26.5 21.5-48 48-48H352c26.5 0 48 21.5 48 48zM48.4 240c4.1 78.1 39 189.3 165.5 236.4c6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240H351.5c-3.9 65.7-32.7 150.2-127.5 188.9C129.2 390.2 100.3 305.7 96.5 240H48.4z"]
};
var faVideoArrowUpRight = {
  prefix: 'far',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M320 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V351 161 128c0-35.3-28.7-64-64-64H64zm464 84.6V363.4L416 313v52.6l104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5v-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4V199l112-50.4zM152 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1L103 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l103-103V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24H152z"]
};
var faGrateDroplet = {
  prefix: 'far',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", "M0 88C0 57.1 25.1 32 56 32h72 96 96 72c30.9 0 56 25.1 56 56v74.2c-15.1 4.3-28.2 14.6-35.8 28.8L400 214V88c0-4.4-3.6-8-8-8H344V232h46.4L336.9 332.2C325.8 353.1 320 376.4 320 400c0 29.6 8.9 57.1 24.2 80H320 224 128 56c-30.9 0-56-25.1-56-56V256 88zm56-8c-4.4 0-8 3.6-8 8V232h56V80H56zM48 424c0 4.4 3.6 8 8 8h48V280H48V424zm152 8V280H152V432h48zm96 0V280H248V432h48zM248 80V232h48V80H248zM200 232V80H152V232h48zm240.5-25.9c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"]
};
var faSealExclamation = {
  prefix: 'far',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M176 112c12.7 0 24.9-5.1 33.9-14.1L256 51.9l46.1 46.1c9 9 21.2 14.1 33.9 14.1h64v64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9V400H335.1c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1H112V335.1c0-12.7-5.1-24.9-14.1-33.9L52.4 255.5l45.6-45.6c9-9 14.1-21.2 14.1-33.9V112h64zM289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64H112c-26.5 0-48 21.5-48 48v64L18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448H400c26.5 0 48-21.5 48-48V335.1l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176V112c0-26.5-21.5-48-48-48H336L289.9 17.9zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faChessBishop = {
  prefix: 'far',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352H96V325c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3v27h48V338.7c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24H160 104zM52.7 464l16.6-32H250.8l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H279.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"]
};
var faMessageSms = {
  prefix: 'far',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zm-3.6-343.6c-4.9 1.6-8.2 6.2-8.2 11.4v96c0 6.6 5.4 12 12 12s12-5.4 12-12V196l26.4 35.2c2.3 3 5.8 4.8 9.6 4.8s7.3-1.8 9.6-4.8L292 196v60c0 6.6 5.4 12 12 12s12-5.4 12-12V160c0-5.2-3.3-9.8-8.2-11.4s-10.3 .1-13.4 4.2L256 204l-38.4-51.2c-3.1-4.1-8.5-5.8-13.4-4.2zM108 182.9c0-3.1 1.3-5.3 4.8-7.4c3.9-2.3 9.6-3.6 15-3.5c6.9 .1 17.4 1.7 24.3 3.5c6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8.6-2.3-21-4.2-30.1-4.3c-8.7-.1-19 1.8-27.6 6.8C91.6 160.2 84 169.5 84 183c.1 12.9 7.6 21.1 15.8 26c7.2 4.3 16.2 7 23.5 9.2l1.1 .3c8.4 2.5 14.6 4.6 19 7.3c3.7 2.3 4.5 4.1 4.5 6.6c.1 3.9-1.5 6.3-4.6 8.2c-3.6 2.2-9.1 3.5-15 3.4c-7.9-.3-15.4-2.8-24.9-6c-1.3-.4-2.7-.9-4.1-1.4c-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.2 .4 2.4 .8 3.7 1.3l0 0 0 0c9.1 3.1 20.3 6.9 32 7.3c9.2 .3 19.8-1.6 28.5-7c9.2-5.7 16.1-15.4 15.9-28.9c-.2-12.9-7.4-21.3-15.8-26.6c-7.5-4.7-17-7.6-24.5-9.8l-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2c-3.7-2.2-4.2-3.8-4.2-5.6zm256 0c0-3.1 1.3-5.3 4.8-7.4c3.9-2.3 9.6-3.6 15-3.5c6.6 .1 13.7 1.5 21.1 3.5c6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8-2.1-17.4-4.2-26.9-4.3c-8.7-.1-19 1.8-27.6 6.8c-9 5.3-16.6 14.6-16.5 28.1c.1 12.9 7.6 21.1 15.8 26c7.2 4.3 16.2 7 23.5 9.2l1.1 .3c8.4 2.5 14.6 4.6 19 7.3c3.7 2.3 4.5 4.1 4.5 6.6c.1 3.9-1.5 6.3-4.6 8.2c-3.6 2.2-9.1 3.5-15 3.4c-7.6-.2-14.7-2.7-23.8-5.8l0 0 0 0c-1.5-.5-3.1-1.1-4.8-1.6c-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.3 .4 2.7 .9 4.1 1.4l0 0c8.9 3.1 19.8 6.8 31.3 7.2c9.2 .3 19.8-1.6 28.5-7c9.2-5.7 16.1-15.4 15.9-28.9c-.2-12.9-7.4-21.3-15.8-26.6c-7.5-4.7-17-7.6-24.5-9.8l-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2c-3.7-2.2-4.2-3.8-4.2-5.6z"]
};
var faCoffeeBeans = {
  prefix: 'far',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", "M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-46.6-46.7c3.5 4.1 7 9.2 10.4 14.9c-25.8 22.7-83.8 25-133.5-24.7c-28-28-39.5-58.7-40.1-84.8c27.8 29.1 60 40.6 87.3 50.3l1.4 .5c30.2 10.8 54.3 19.8 74.6 43.8zm-10-123c28 28 39.5 58.7 40.1 84.8c-27.8-29.1-60-40.6-87.3-50.3l-1.4-.5c-30.2-10.8-54.3-19.8-74.6-43.8c-3.5-4.1-7-9.2-10.4-14.9c25.8-22.7 83.8-25 133.5 24.7zM128.1 446c-.4 5.4-1.6 11.5-3.1 17.9C90.7 461.7 48 422.3 48 352c0-39.7 13.6-69.5 31.6-88.3c-.9 40.2 13.7 71.1 26.1 97.3l.6 1.3c13.7 29 24.4 52.4 21.8 83.7zM208 352c0 39.7-13.6 69.5-31.6 88.3c.9-40.2-13.7-71.1-26.1-97.3l-.6-1.3c-13.7-29-24.4-52.4-21.8-83.7c.4-5.4 1.6-11.5 3.1-17.9C165.3 242.3 208 281.7 208 352zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z"]
};
var faHatWitch = {
  prefix: 'far',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", "M148.4 384H96l85.9-196.3C198.8 149 228 116.9 265 96.5l170.4-94c3-1.7 6.4-2.5 9.9-2.5c7 0 13.7 2.4 19.1 6.7L564 86.4c7.6 6.1 12 15.3 12 25V121c0 4.6-1 9.2-2.9 13.4l-39.1 84.7c-3.6 7.9-11.5 12.9-20.1 12.9c-10.4 0-19.4-7.2-21.7-17.4l-8-35.9C481.7 167.8 472 160 460.8 160c-8 0-15.5 4-19.9 10.7l-19.5 29.3c-3.5 5.3-5.4 11.5-5.4 17.8c0 4.1 .8 8.2 2.3 11.9L480 384H428.3L373.7 247.5l0 0c-3.8-9.5-5.7-19.7-5.7-29.8c0-15.7 4.6-31.2 13.4-44.5L401 144c13.3-20 35.8-32 59.8-32c22.8 0 43.6 10.7 56.9 27.9l9.8-21.2L444.6 52.3 288.2 138.6c-27.7 15.3-49.7 39.3-62.4 68.4L148.4 384zM240 336c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v48H240V336zm313.4 80c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.7-6.9 15.6C550.1 470.3 493.4 512 416 512H160C82.6 512 25.9 470.3 6.9 454.2C2.4 450.4 0 444.6 0 438.6C0 426.1 10.1 416 22.6 416H553.4z"]
};
var faFaceGrinWink = {
  prefix: 'far',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
var faGrinWink = faFaceGrinWink;
var faClockThreeThirty = {
  prefix: 'far',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V256c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faEarDeaf = {
  prefix: 'far',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M505 41l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM185 361L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L151 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm55-249c-70.7 0-128 57.3-128 128c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2c-4.8 4.9-6.6 9.9-6.6 13.8c0 75.1-60.9 136-136 136c-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88c0-19.1 8.9-35.5 20.1-47.1c22.3-23 35.9-54.4 35.9-88.9c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40z"]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faAlarmClock = {
  prefix: 'far',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24V288c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V184z"]
};
var faEclipse = {
  prefix: 'far',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-15.8-6.6-30.6-15.1-44.2-25.2l-4.5 24.4L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 4.5 24.4C353.2 79.1 368 70.6 383.9 64l-8.2-44.3zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c10.4 0 20.5-1.4 30.1-4.1c-8.4-13.9-15.3-28.9-20.3-44.6c-3.2 .5-6.5 .7-9.8 .7c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.3 0 6.6 .3 9.8 .7c5-15.8 11.9-30.7 20.3-44.6c-9.6-2.7-19.7-4.1-30.1-4.1zm80 112a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0a176 176 0 1 0 -352 0 176 176 0 1 0 352 0z"]
};
var faFaceRelieved = {
  prefix: 'far',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm193 87c11.8 11.8 32.7 25 63 25s51.2-13.1 63-25c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-19.1 19.1-51.6 39-97 39s-77.9-19.9-97-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm158.7-91c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 285.2 371 292 351.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 285.2 179 292 159.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zm73-135.4c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.8 20.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"]
};
var faRoadCircleCheck = {
  prefix: 'far',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480H360.2c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32H217.7zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faDiceFive = {
  prefix: 'far',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faOctagonMinus = {
  prefix: 'far',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMinusOctagon = faOctagonMinus;
var faSquareRss = {
  prefix: 'far',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 40c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faRssSquare = faSquareRss;
var faFaceZany = {
  prefix: 'far',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M436.1 152C378.7 52.5 251.5 18.4 152 75.9S18.4 260.5 75.9 360c25 43.3 63.2 74.2 106.5 90.6c-4.1-10.7-6.4-22.4-6.4-34.6v-7.8c-10.4-6.2-20.1-13.7-28.9-22.2c-10.2-9.9-6.6-26.3 5.7-33.4L391.2 214.9c12.3-7.1 28.3-2 31.8 11.8c15.2 59.4-5.9 124.1-55 165V416c0 5.5-.5 10.9-1.4 16.1C461 373 492.3 249.2 436.1 152zM384 477.7c-27.9 16.1-57.5 26.3-87.5 31.1c-7.8 2.1-16 3.2-24.5 3.2c-1.9 0-3.7-.1-5.6-.2c-92 3.7-182.9-42.6-232.1-127.8C-36.4 261.6 5.6 105 128 34.3S407 5.6 477.7 128s28.7 279-93.7 349.7zM296.4 160c-11.1 0-20.4-7.5-23.2-17.7c-.8 3.1-1.2 6.4-1.2 9.7c0 22.1 17.9 40 40 40s40-17.9 40-40s-17.9-40-40-40c-3 0-6 .3-8.8 1c9.9 2.9 17.2 12.1 17.2 23c0 13.3-10.7 24-24 24zM312 80a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 80 224zm48 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM336 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTricycle = {
  prefix: 'far',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h73.6c7.9 0 14.4 6.4 14.4 14.4c0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8 .7-1.6 1.4-2.3 2.2H307.2c-58.8 0-114 23.9-154.1 64.6L133.6 176H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H77.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4C416 59.9 388.1 32 353.6 32H280zm62.2 251.8l18.5 74c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-18.5-74c42 2.5 75.2 37.3 75.2 79.9c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-28.9 15.3-54.2 38.2-68.2zM112 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faLandMineOn = {
  prefix: 'far',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 336c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48v16h31.5c19.6 0 37.3 11.9 44.6 30.2l34.4 85.9c8.4 21-7.1 43.9-29.7 43.9H111.3c-22.6 0-38.1-22.9-29.7-43.9l34.4-85.9c7.3-18.2 24.9-30.2 44.6-30.2H192V336zM505.1 464l-25.6-64h-319l-25.6 64H505.1zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"]
};
var faSquareArrowUpLeft = {
  prefix: 'far',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 48c13.3 0 24 10.7 24 24s-10.7 24-24 24H193.9L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H288z"]
};
var faICursor = {
  prefix: 'far',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M.1 22.2c-1 13.2 8.9 24.8 22.1 25.8l15.4 1.2C75 52 104 83.3 104 120.9V232H64c-13.3 0-24 10.7-24 24s10.7 24 24 24h40V391.1c0 37.6-29 68.9-66.5 71.8l-15.4 1.2C8.9 465.1-.9 476.6 .1 489.8s12.6 23.1 25.8 22.1l15.4-1.2c35.7-2.7 66.7-20.9 86.8-47.6c20.1 26.7 51.1 44.9 86.8 47.6l15.4 1.2c13.2 1 24.8-8.9 25.8-22.1s-8.9-24.8-22.1-25.8l-15.4-1.2C181 460 152 428.7 152 391.1V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H152V120.9c0-37.6 29-68.9 66.5-71.8l15.4-1.2c13.2-1 23.1-12.6 22.1-25.8S243.4-.9 230.2 .1L214.8 1.3C179.1 4 148.1 22.2 128 48.9C107.9 22.2 76.9 4 41.2 1.3L25.8 .1C12.6-.9 1.1 8.9 .1 22.2z"]
};
var faChartMixedUpCircleDollar = {
  prefix: 'far',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", "M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h52.5L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2L496 80.7V136c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H408zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8V432zm-8-208c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-4.4 3.6-8 8-8s8 3.6 8 8v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]
};
var faSaltShaker = {
  prefix: 'far',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M325.2 464H58.8c-6 0-10.8-4.8-10.8-10.8c0-.6 .1-1.3 .2-1.9L94.5 192H289.5l46.3 259.3c.1 .6 .2 1.3 .2 1.9c0 6-4.8 10.8-10.8 10.8zM58.8 512H325.2c32.5 0 58.8-26.3 58.8-58.8c0-3.5-.3-6.9-.9-10.3L323.7 110.3C312.3 46.5 256.8 0 192 0S71.7 46.5 60.3 110.3L.9 442.9c-.6 3.4-.9 6.9-.9 10.3C0 485.7 26.3 512 58.8 512zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faStamp = {
  prefix: 'far',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M299.3 116.7c3-6.2 4.7-13.2 4.7-20.7c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 7.5 1.7 14.5 4.7 20.7l.3 .6c7 14.6 19 39.6 19 68.7c0 65.2-52.8 118-118 118H96c-26.5 0-48 21.5-48 48v8c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8v-8c0-26.5-21.5-48-48-48H398c-65.2 0-118-52.8-118-118c0-29 12-54.1 19-68.6l0 0 .3-.6zm43.3 20.8C335.2 152.9 328 168.9 328 186c0 38.7 31.4 70 70 70h18c53 0 96 43 96 96v8c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56v-8c0-53 43-96 96-96h18c38.7 0 70-31.3 70-70c0-17.1-7.2-33.1-14.6-48.5c-6-12.6-9.4-26.6-9.4-41.5c0-53 43-96 96-96s96 43 96 96c0 14.9-3.4 28.9-9.4 41.5zM32 480c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32z"]
};
var faFilePlus = {
  prefix: 'far',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM192 208c-13.3 0-24 10.7-24 24v48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V328h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V232c0-13.3-10.7-24-24-24z"]
};
var faDrawSquare = {
  prefix: 'far',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", "M64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 43.3V356.7c16 6.5 28.9 19.3 35.3 35.3H324.7c6.5-16 19.3-28.9 35.3-35.3V155.3c-16-6.5-28.9-19.3-35.3-35.3H123.3c-6.5 16-19.3 28.9-35.3 35.3zM123.3 440c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V155.3C16.5 145.9 0 122.9 0 96C0 60.7 28.7 32 64 32c26.9 0 49.9 16.5 59.3 40H324.7c9.5-23.5 32.5-40 59.3-40c35.3 0 64 28.7 64 64c0 26.9-16.5 49.9-40 59.3V356.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40H123.3zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm320 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0-320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faToiletPaperUnderSlash = {
  prefix: 'far',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V192c0-49.5-10.5-95.4-28.5-129.9C530 28.7 501.7 0 464 0H176c-33.8 0-60 23-77.6 51.8L38.8 5.1zm97.7 76.6c14-25.4 29-33.7 39.5-33.7H388.7c-3 4.5-5.7 9.3-8.2 14.1C362.5 96.6 352 142.5 352 192c0 22 2.1 43.3 6 63.3L136.5 81.7zM460.6 335.7l-30.2-23.7c-2.5-3.6-5-7.7-7.4-12.4c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C437.4 56.9 453.1 48 464 48s26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3c-1.1 0-2.2-.1-3.4-.3zm45.1 35.3c8.2-5.4 15.6-12.2 22.3-20v37.5l-22.3-17.5zm21.7 140.5L467.1 464H280c-4.4 0-8-3.6-8-8V416H224v40c0 30.9 25.1 56 56 56H520c2.5 0 5-.2 7.4-.5zM304.6 336H176c-10.9 0-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7c0-2.6 0-5.1 .1-7.7L66.8 148.6c-1.8 14-2.8 28.6-2.8 43.4c0 49.5 10.5 95.4 28.5 129.9C110 355.3 138.3 384 176 384H365.5l-60.9-48zM488 192c0-26.5-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48s24-21.5 24-48z"]
};
var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
var faStairs = {
  prefix: 'far',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M384 56c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H432V200c0 13.3-10.7 24-24 24H304V328c0 13.3-10.7 24-24 24H176V456c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128V328c0-13.3 10.7-24 24-24H256V200c0-13.3 10.7-24 24-24H384V56z"]
};
var faDroneFront = {
  prefix: 'far',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M136 96c10.4 0 19.3 6.7 22.6 16H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h89.4c3.3-9.3 12.2-16 22.6-16zm345.4 16c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24H481.4zM112 256V192h48v49.6l10.8 5.7 47.7-27.8c30.8-18 65.9-27.5 101.6-27.5s70.7 9.5 101.6 27.5l47.7 27.8 10.8-5.7V192h48v64c0 8.9-4.9 17.1-12.8 21.2l-51.6 27.3 4.5 5.4c18 21.6 27.8 48.8 27.8 76.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-5.2c0-16.8-5.9-33.2-16.7-46.1l-11-13.2-41.1 21.7c-3.5 1.8-7.3 2.8-11.2 2.8H272c-3.9 0-7.8-1-11.2-2.8l-41.1-21.7-11 13.2c-10.8 12.9-16.7 29.3-16.7 46.1V392c0 13.3-10.7 24-24 24s-24-10.7-24-24v-5.2c0-28.1 9.8-55.3 27.8-76.8l4.5-5.4-51.6-27.3c-7.9-4.2-12.8-12.3-12.8-21.2zm307.3 17.7l-21.9-12.8C373.9 247.2 347.2 240 320 240s-53.9 7.2-77.4 20.9l-21.9 12.8L278 304H362l57.2-30.3z"]
};
var faDroneAlt = faDroneFront;
var faGlassEmpty = {
  prefix: 'far',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M6.3 7.8C10.9 2.8 17.3 0 24 0H360c6.7 0 13.1 2.8 17.7 7.8s6.8 11.6 6.2 18.3L347.7 446.2C344.5 483.4 313.3 512 276 512H108c-37.4 0-68.5-28.6-71.7-65.8L.1 26.1C-.5 19.4 1.8 12.7 6.3 7.8zM50.2 48l34 394.1C85.2 454.5 95.6 464 108 464H276c12.5 0 22.8-9.5 23.9-21.9L333.8 48H50.2z"]
};
var faDialHigh = {
  prefix: 'far',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 248H397.4c-11 50.3-55.8 88-109.4 88c-61.9 0-112-50.1-112-112s50.1-112 112-112c53.6 0 98.4 37.7 109.4 88H288c-13.3 0-24 10.7-24 24s10.7 24 24 24zm160-24a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faUserHelmetSafety = {
  prefix: 'far',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M216 0h16c13.3 0 24 10.7 24 24V80l28.4-56.9c38 20.4 64.5 59.4 67.3 104.9h.2c13.3 0 24 10.7 24 24s-10.7 24-24 24H96c-13.3 0-24-10.7-24-24s10.7-24 24-24h.2C99 82.6 125.6 43.5 163.6 23.1L192 80V24c0-13.3 10.7-24 24-24zM162 304c-34.9-19.4-59.8-54.6-65-96h48.6c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H351c-5.2 41.4-30.1 76.6-65 96c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16zm-11.4 48H224h73.4 16.2C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352h16.2zM397.1 464c-9.9-36.9-43.5-64-83.5-64H134.4c-40 0-73.6 27.1-83.5 64H397.1z"]
};
var faUserConstruction = faUserHelmetSafety;
var faUserHardHat = faUserHelmetSafety;
var faI = {
  prefix: 'far',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H136V432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V80H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H160 24z"]
};
var faHryvniaSign = {
  prefix: 'far',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M105.7 104.6C125.6 88.7 150.3 80 175.8 80H227c33.7 0 61 27.3 61 61c0 20.7-10.5 39.8-27.5 51H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H171l-65.3 34.8c-7 3.7-13.5 8.2-19.4 13.2H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H53.8C50 347.1 48 358.9 48 371c0 60.2 48.8 109 109 109h51.2c36.4 0 71.7-12.4 100.1-35.1l2.7-2.2c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-2.7 2.2c-19.9 15.9-44.6 24.6-70.1 24.6H157c-33.7 0-61-27.3-61-61c0-12.8 4-24.9 11-35H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H183l90-48h87c13.3 0 24-10.7 24-24s-10.7-24-24-24H323.3c8.2-15.4 12.7-32.9 12.7-51c0-60.2-48.8-109-109-109H175.8c-36.4 0-71.7 12.4-100.1 35.1L73 69.3C62.7 77.5 61 92.6 69.3 103s23.4 12 33.7 3.7l2.7-2.2z"]
};
var faHryvnia = faHryvniaSign;
var faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'far',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M489 57c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V72c0-13.3-10.7-24-24-24s-24 10.7-24 24V216c0 13.3 10.7 24 24 24H440c13.3 0 24-10.7 24-24s-10.7-24-24-24H353.9L489 57zM23 455c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V440c0 13.3 10.7 24 24 24s24-10.7 24-24V296c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h86.1L23 455z"]
};
var faPills = {
  prefix: 'far',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 80c35.3 0 64 28.7 64 64V256H48V144c0-35.3 28.7-64 64-64zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 432c-61.9 0-112-50.1-112-112c0-22.2 6.5-43 17.7-60.4L476.4 414.3C459 425.5 438.2 432 416 432zM355.6 225.7C373 214.5 393.8 208 416 208c61.9 0 112 50.1 112 112c0 22.2-6.5 43-17.7 60.4L355.6 225.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"]
};
var faFaceGrinWide = {
  prefix: 'far',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
var faGrinAlt = faFaceGrinWide;
var faTooth = {
  prefix: 'far',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M64 143.3c0 12.5 2.9 24.9 8.5 36.1l17.1 34.2c8.8 17.7 15.2 36.4 18.9 55.8L139.6 431c.1 .6 .6 1 1.2 1c.5 0 1-.4 1.2-.9l28.4-102.4C177.1 304.6 199 288 224 288s46.9 16.6 53.5 40.7L306 431.1c.1 .5 .6 .9 1.2 .9c.6 0 1.1-.4 1.2-1l31.1-161.6c3.7-19.4 10.1-38.2 18.9-55.8l15.1-30.2c6.9-13.9 10.6-29.2 10.6-44.8c0-32.4-26.3-58.7-58.7-58.7H314.6C298 80 282 85.9 269.4 96.7l-7 6 8.1 6c10.6 8 12.8 23 4.8 33.6s-23 12.8-33.6 4.8l-32-24-32-24-8-6C158.2 84.6 144.3 80 130 80h-2.7C92.3 80 64 108.3 64 143.3zm159-70l15.1-13C259.4 42 286.5 32 314.6 32h10.7C384.2 32 432 79.8 432 138.7c0 23-5.4 45.7-15.6 66.2l-15.1 30.2c-6.9 13.7-11.8 28.3-14.7 43.4L355.5 440.1C351 463.3 330.8 480 307.2 480c-22.1 0-41.5-14.7-47.4-36L231.3 341.5c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.3-7.3 5.5L188.3 444c-5.9 21.3-25.3 36-47.4 36c-23.6 0-43.9-16.7-48.3-39.9L61.4 278.5c-2.9-15.1-7.8-29.7-14.7-43.4L29.6 200.8C20.7 183 16 163.3 16 143.3C16 81.8 65.8 32 127.3 32H130c24.7 0 48.7 8 68.4 22.8l8 6L223 73.2z"]
};
var faBasketballHoop = {
  prefix: 'far',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", "M49.2 209.4C64.9 179.7 144.6 48 320 48s255.1 131.7 270.8 161.4c.7 1.4 1.2 3.1 1.2 5.5V331.2c0 6.3-3.7 12.1-9.5 14.6l-60.3 26.8-8 56.1 87.8-39c23.1-10.3 38-33.2 38-58.5V214.9c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9V331.2c0 25.3 14.9 48.2 38 58.5l87.8 39-8-56.1L57.5 345.8c-5.8-2.6-9.5-8.3-9.5-14.6V214.9c0-2.4 .5-4.2 1.2-5.5zM142.1 288l7.3 50.8 0 0 0 .1 22.9 152c1.1 7.5 6.4 13.8 13.7 16.1s15.2 .3 20.5-5.2l48.7-50.6 50.7 50.9c3.8 3.8 8.8 5.9 14.2 5.9s10.4-2.1 14.2-5.9l50.7-50.9 48.7 50.6c5.3 5.5 13.2 7.5 20.5 5.2s12.6-8.6 13.7-16.1l22.9-152 0 0 0-.1 7.3-50.8H504c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 432 208 160 136c-13.3 0-24 10.7-24 24s10.7 24 24 24h6.1zm315.4 0l-4.1 28.9L418.6 288H456h1.5zM356 288l.5 .4L320 326.2l-36.4-37.8 .5-.4H356zm-134.5 0l-34.8 28.9L182.5 288H184h37.4zm61.5 134.4L320 383.9l37.1 38.5L320 459.7l-37.1-37.2zm9.3-67.4l-37.6 39-44.5-44.7L252.7 314l39.5 41.1zM198.1 394l28.8 28.9-21.2 22L198.1 394zm149.7-38.9L387.3 314l42.6 35.4-44.5 44.7-37.6-39zM441.9 394l-7.7 50.9-21.2-22L441.9 394zM208 176H432v32h48V168c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40v40h48V176z"]
};
var faObjectsAlignBottom = {
  prefix: 'far',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24zM176 336V48H112V336h64zm-64 48c-26.5 0-48-21.5-48-48V48C64 21.5 85.5 0 112 0h64c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H112zm288-48V176H336V336h64zm-64 48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H336z"]
};
var faV = {
  prefix: 'far',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M14.7 33.9c12.2-5.1 26.3 .6 31.4 12.8L192 394 337.9 46.7c5.1-12.2 19.2-18 31.4-12.8s18 19.2 12.8 31.4l-168 400c-3.7 8.9-12.5 14.7-22.1 14.7s-18.4-5.8-22.1-14.7L1.9 65.3C-3.3 53.1 2.5 39 14.7 33.9z"]
};
var faSparkles = {
  prefix: 'far',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
};
var faSquid = {
  prefix: 'far',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M261.5 4.8C265.3 .9 270.7-.8 276 .3L392.7 23.6C423 14.4 456.7 6.5 494.3 .2c5.1-.8 10.3 .8 13.9 4.5s5.3 8.8 4.5 13.9c-6.3 37.6-14.2 71.3-23.4 101.5l23.3 116.7c1.1 5.3-.6 10.8-4.5 14.6s-9.4 5.4-14.7 4.2l-58.9-13.1C388.4 314.5 332.8 346 286.2 353.2l16 16 .1 .1 22.5 22.5c6.2 6.2 16.4 6.2 22.6 0l56.4-56.3c18.9-18.9 49.5-18.7 68.2 .3l36.4 37.1c6.1 6.3 6.1 16.3-.1 22.5l-2.8 2.8c-34 34-87.7 33.3-121 1.9L370 414.4c-18.7 18.7-49.1 18.7-67.9 0L273.7 386c-9.4-9.2-24.4-9.2-33.7 0l-.1 .1-.1 .1c-9.2 9.4-9.2 24.4 0 33.8l.1 .1 5.7 5.7 9.9 9.9c19.5 19.5 18.6 51.5-2.1 69.8l-2.8 2.5c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6l2.8-2.5c6.9-6.1 7.2-16.8 .7-23.3l-9.9-9.8-.1-.1-22.4-22.4-.1-.1c-10.2-10.1-27-9-35.8 2.3l-15.6 20c-2.7 3.5-4.2 7.7-4.2 12.1c0 10.9 8.8 19.7 19.7 19.7h12.3c8.8 0 16 7.2 16 16s-7.2 16-16 16H164.6c-28.6 0-51.7-23.2-51.7-51.7c0-11.5 3.8-22.7 10.9-31.8l21.9-28.2c7.3-9.4 6.5-22.8-1.9-31.2s-21.8-9.3-31.2-1.9L84.4 389.1C75.3 396.2 64.1 400 52.6 400C24.1 400 .9 376.8 .9 348.3L.9 336c0-8.8 7.2-16 16-16s16 7.2 16 16v12.3c0 10.9 8.8 19.7 19.7 19.7c4.4 0 8.7-1.5 12.1-4.2l20-15.6c11.3-8.8 12.4-25.5 2.4-35.8L64.6 289.9l-.2-.2L53.8 279.2c-6.4-6.4-16.7-6.2-22.9 .3L27.6 283c-6.1 6.4-16.2 6.7-22.6 .6s-6.7-16.2-.6-22.6l3.3-3.5c18.6-19.6 49.7-20 68.7-.9L93 273.1c9.4 9.2 24.4 9.1 33.8-.2c9.4-9.4 9.4-24.5 0-33.9l0 0-5.7-5.7 0 0L98.5 210.7c-18.7-18.7-18.7-49.1 0-67.9l14.3-14.3c-31.4-33.3-32.1-87 1.9-121l2.8-2.8c6.2-6.2 16.3-6.3 22.5-.1l37.1 36.4c19.1 18.7 19.2 49.3 .3 68.2l-56.4 56.4c-6.2 6.2-6.2 16.4 0 22.6l22.6 22.6 2 2 14 14c7.2-46.6 38.7-102.2 110.6-148.4L257.3 19.5c-1.2-5.3 .4-10.8 4.2-14.7zM184.9 296a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM432.3 62C266.7 103.7 228.1 174.4 222.4 215.4c-1.9 13.9 6 30.8 25.1 49.9s36 27 49.9 25.1c41-5.6 111.8-44.3 153.5-209.8c2.8-11.3-7.3-21.5-18.6-18.6z"]
};
var faLeafyGreen = {
  prefix: 'far',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M233.8 27c-38-36.5-98.4-36-135.8 1.5C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1v35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6V330.5c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6v-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27c4.4-12.9 10.8-24.8 18.9-35.5zM526 128c-9.1 35.4-9.7 73.9-6.3 106.9c.2 1.7 .3 3.4 .3 5.1c0 21-13.5 38.9-32.4 45.4c-14.5 5-38.5 13.6-57.7 32.8l-29.1 29.1c-3 3-7.1 4.7-11.3 4.7h-43c-29.7 0-58.2 11.8-79.2 32.8l-10.5 10.5c-3 3-7.1 4.7-11.3 4.7H209.9L313 297l41-41H440c13.3 0 24-10.7 24-24s-10.7-24-24-24H401.9l71-71c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L327 215l-7 7V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1l-96 96V330.5c0-4.2 1.7-8.3 4.7-11.3l10.5-10.5c21-21 32.8-49.5 32.8-79.2v-43c0-4.2 1.7-8.3 4.7-11.3l29.1-29.1c19.2-19.2 27.8-43.2 32.8-57.7C297.1 69.5 315 56 336 56c1.7 0 3.5 .1 5.1 .3c33 3.5 71.4 2.8 106.9-6.3c5.1-1.3 10.4-2 16-2c35.3 0 64 28.7 64 64c0 5.6-.7 10.9-2 16zM105 505l38.2-38.2c12-12 28.3-18.7 45.3-18.7h57c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v57c0 17-6.7 33.3-18.7 45.3L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
var faCircleArrowUpRight = {
  prefix: 'far',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM192 144H344c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V225.9L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135H192c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCalendars = {
  prefix: 'far',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M224 0c13.3 0 24 10.7 24 24V64H360V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v48 16V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192 176 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM144 192V352c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V192H144zm-96-8V392c0 39.8 32.2 72 72 72H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H120C53.7 512 0 458.3 0 392V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faBangladeshiTakaSign = {
  prefix: 'far',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M26.4 32.1C13.2 30.8 1.4 40.4 .1 53.6s8.3 25 21.5 26.3L44 82.1c20.4 2 36 19.3 36 39.8V176H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H80V392c0 48.6 39.4 88 88 88h32c101.6 0 184-82.4 184-184V264c0-48.6-39.4-88-88-88H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c22.1 0 40 17.9 40 40v32c0 75.1-60.9 136-136 136H168c-22.1 0-40-17.9-40-40V224h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H128V121.9c0-45.2-34.3-83.1-79.2-87.6L26.4 32.1z"]
};
var faBicycle = {
  prefix: 'far',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM454.6 296.3l36.3 67.1c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-36.3-67.1c4.9-.9 10-1.4 15.2-1.4c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-21.7 8.6-41.3 22.6-55.7zM136.9 272.5l-28.1 56.1c-9 18.1 4.1 39.4 24.3 39.4h73.2c-7.4 36.5-39.7 64-78.4 64c-44.2 0-80-35.8-80-80s35.8-80 80-80c3 0 6 .2 8.9 .5zM166.8 320l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"]
};
var faHammerWar = {
  prefix: 'far',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", "M216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V52L36.7 32.4C17.7 29.5 0 44.7 0 64V256c0 19.3 17.7 34.5 36.7 31.6l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6V64c0-19.3-17.7-34.5-36.7-31.6L216 52V24zm0 276.3l-24-3.6-24 3.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V300.3zm-35.9-82.7L48 237.4V82.6l132.1 19.8c7.9 1.2 15.9 1.2 23.7 0L336 82.6V237.4L203.9 217.6c-7.9-1.2-15.9-1.2-23.7 0z"]
};
var faCircleD = {
  prefix: 'far',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V360c0 13.3 10.7 24 24 24h72c70.7 0 128-57.3 128-128s-57.3-128-128-128H184zm72 208H208V176h48c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faSpiderBlackWidow = {
  prefix: 'far',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5L160 158.1c.6-32.8 17.8-61.6 43.3-78.4c5.8-3.8 13.1-4.9 19.8-3s12.3 6.7 15.2 13L256 128.1l17.7-38.3c2.9-6.3 8.5-11.1 15.2-13s13.9-.8 19.8 3c25.6 16.8 42.7 45.5 43.3 78.4l32.3-32.3c2.2-2.2 2.9-5.6 1.8-8.5L353.6 32.6c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8L430.9 100c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-68.8-22.9c.8 3.2 1.5 6.4 2 9.7l43.8 43.8c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5l-12.1-12.1C358.8 425.8 311.9 464 256 464s-102.8-38.2-116.2-89.9l-12.1 12.1c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l43.8-43.8c.5-3.3 1.2-6.5 2-9.7L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8L93.7 159.7C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm66 142.7c-1.7 4.9-2.6 10.2-2.6 15.7v88c0 3.4 .4 6.7 1 9.9c1.6 7.6-.6 15.5-5.9 21.2C191.2 292 184 309.1 184 328v16c0 39.8 32.2 72 72 72s72-32.2 72-72V328c0-18.9-7.2-36-19.1-48.9c-5.3-5.7-7.5-13.6-5.9-21.2c.7-3.2 1-6.5 1-9.9V160c0-5.5-.9-10.8-2.6-15.7l-15.6 33.8c-3.9 8.5-12.4 13.9-21.8 13.9H248c-9.4 0-17.9-5.4-21.8-13.9l-15.6-33.8zm7.8 162.9c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12H228c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z"]
};
var faStaffSnake = {
  prefix: 'far',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M222.6 43.2l-.1 4.8H296c48.6 0 88 39.4 88 88s-39.4 88-88 88H248V176h48c22.1 0 40-17.9 40-40s-17.9-40-40-40H221l-6 192h25c44.2 0 80 35.8 80 80s-35.8 80-80 80V400c17.7 0 32-14.3 32-32s-14.3-32-32-32H213.5l-3.6 115.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1.4-43.5L174 448H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h52.5l-2-64H144c-44.2 0-80-35.8-80-80c0-41.5 31.6-75.6 72-79.6V225c-13.8 3.6-24 16.1-24 31c0 17.7 14.3 32 32 32h25L163 96H127.4c.4 2.6 .6 5.3 .6 8c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faPear = {
  prefix: 'far',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M505 7c9.4 9.4 9.4 24.6 0 33.9L457.9 88.1c14 20.5 22.1 45.3 22.1 71.9c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM367 111l22-22c-11.1-5.8-23.7-9.1-37-9.1c-19.2 0-36.8 6.7-50.6 18C264 128.6 212 166 155.6 180.6c-23.9 6.2-46.6 18.7-65.5 37.5c-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0c18.9-18.9 31.3-41.5 37.5-65.5C346 300 383.4 248 414 210.6c11.3-13.8 18-31.3 18-50.6c0-13.4-3.3-25.9-9.1-37l-22 22c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM288 320c0 53-43 96-96 96c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHeadSideCoughSlash = {
  prefix: 'far',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M129 75.8C156.4 58.2 189 48 224 48h24c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6H424c-6.3 0-12 2.4-16.2 6.3L129 75.8zM459.7 335c29.7-5.3 52.3-31.3 52.3-62.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0H224C173.5 0 127 16.7 89.5 44.8L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459.7 335zM27 117.3C9.8 149 0 185.4 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224c0-27.4 6.3-53.3 17.4-76.4L27 117.3zM339.2 363.2l-1.3 .3c-10.5 2.6-17.8 12-17.8 22.8c0 12.2 9.4 22.4 21.6 23.4l58.4 4.9V424v8c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24c10.4 0 19.3-6.7 22.6-16H384c30 0 55.2-20.6 62.1-48.5l-107-84.3zM640 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faTriangle = {
  prefix: 'far',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3z"]
};
var faApartment = {
  prefix: 'far',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M176 96V64c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V192c0 26.5 21.5 48 48 48h64c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H384 352 320V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H192 64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h64c26.5 0 48-21.5 48-48zm16 416h64 64 32 32H512c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H496 448V144 64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64V96H80 64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H192zM352 336c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zm144 80V384c0-8.8-7.2-16-16-16H448c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM128 336c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zm16 80V384c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm112-80c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM368 96c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96zM256 80H224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16zM368 224V192c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM480 336c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H448c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32zM144 224V192c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm112 16c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32z"]
};
var faTruckMedical = {
  prefix: 'far',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h32c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM480 512c-53 0-96-43-96-96h-8H352 320 256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96H558zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240v48c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V208H128c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h48V96z"]
};
var faAmbulance = faTruckMedical;
var faPepper = {
  prefix: 'far',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37v10.9c-17.1-6.1-36.2-7.4-55.1-2.7l-.2 0c-10.5 2.6-20.1 6.9-28.7 12.4C126.5 97.5 99.5 92.2 72.7 98.9C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c10.5-2.6 20.1-6.9 28.7-12.4c5.7 3.6 11.8 6.7 18.3 9.2c10.6 4 22 6.1 33.7 6.1h0l0-24 0 24h0c11.7 0 23.1-2.1 33.7-6.1c6.5-2.4 12.6-5.5 18.3-9.2c8.6 5.5 18.3 9.8 28.7 12.4c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4c-26.8-6.7-53.8-1.4-75.3 12.4c-8.6-5.6-18.3-9.8-28.7-12.4c-19-4.8-38.1-3.5-55.3 2.6V90.6c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7zM84.4 145.4c10.5-2.6 21.1-1.6 30.4 2.4c-10.4 20-13.8 43.8-7.9 67.5l33.6 134.4c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1L153.4 203.6c-6.2-25 8.3-50.3 32.7-57.6c.7-.2 1.5-.4 2.2-.6c18.7-4.7 37.6 2.3 49 16.4c4.6 5.6 11.4 8.9 18.7 8.9s14.1-3.3 18.7-8.9c11.4-14.1 30.3-21.1 49-16.4c9.2 2.3 17 7 23 13.3c4.5 4.7 10.8 7.4 17.3 7.4s12.8-2.7 17.3-7.4c11.6-12.1 29-17.7 46.3-13.4c25.7 6.4 41.4 32.5 34.9 58.2l-56 224c-6.4 25.7-32.5 41.4-58.2 34.9c-9.2-2.3-17-7-23-13.3c-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4c-.2 .2-.5 .5-.7 .7l0 0c-4.7 4.7-10.5 8.5-17.1 11l0 0c-5.3 2-11 3.1-16.8 3.1h0c-5.8 0-11.5-1.1-16.8-3.1l0 0c-6.6-2.4-12.3-6.2-17-10.9l0 0c-.2-.2-.5-.5-.7-.8c-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4c-6 6.3-13.9 11-23 13.3c-25.7 6.4-51.8-9.2-58.2-34.9l-56-224c-6.4-25.7 9.2-51.8 34.9-58.2z"]
};
var faPiano = {
  prefix: 'far',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M432 384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H240v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H112v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H48v64c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V384H432zM48 336H464v-8.4c0-6.1-3.4-11.6-8.8-14.3L396.8 284c-37.2-18.6-60.8-56.7-60.8-98.3C336 109.7 274.3 48 198.3 48H192C112.5 48 48 112.5 48 192V336zm464-8.4V336v24 24 64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384 360 336 192C0 86 86 0 192 0h6.3C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z"]
};
var faGunSquirt = {
  prefix: 'far',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M104 32c13.3 0 24 10.7 24 24v8H448c41.8 0 77.4 26.7 90.5 64H552c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H538.5c-13.2 37.3-48.7 64-90.5 64H249l-18 72h41V312c0-13.3 10.7-24 24-24s24 10.7 24 24v40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H219L199 455.8C195.5 470 182.7 480 168 480H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L79.4 254.6C34.3 246.7 0 207.3 0 160c0-47.6 34.6-87.1 80-94.7V56c0-13.3 10.7-24 24-24zm24.5 224l-44 176h71l44-176h-71zM448 208c26.5 0 48-21.5 48-48s-21.5-48-48-48H104 96c-26.5 0-48 21.5-48 48s21.5 48 48 48H211.5 261 448zM96 144H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWheatAwnCircleExclamation = {
  prefix: 'far',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63.7 63.7c-21.6 7.1-41.4 18.2-58.4 32.5c-24.3-10.1-52.5-7.8-75 7l10.1 10.1c9.4 9.4 21 15.3 33.1 17.6c-11.9 17.2-20.9 36.7-26.1 57.7c-27.3-23.7-66.9-25.8-96.4-6.2l10.1 10.1c23 23 59.1 24.8 84.2 5.5c-2 10.7-3.1 21.7-3.1 32.9c0 7.4 .5 14.8 1.4 21.9c-5.8 2-11.8 3.6-17.8 4.7c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3 0 0L41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5 0 0L69.3 386.1c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM261.5 103.3c-25 25-25 65.5 0 90.5L271.7 204c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zM159.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faSnowman = {
  prefix: 'far',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", "M256 0C189.7 0 136 53.7 136 120c0 19 4.4 37 12.3 53c-7.2 9.3-13.2 19.6-17.8 30.6L104 192.2V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v19.6l-22.5-9.7c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l56 24 49.5 21.2c-.1 1.6-.1 3.1-.1 4.7c0 12.5 1.7 24.7 4.9 36.3C106.7 318.2 96 349.9 96 384c0 39.2 14.1 75.1 37.5 102.9c15.6 18.6 38.4 25.1 58.3 25.1H320.3c19.8 0 42.6-6.5 58.3-25.1C401.9 459.1 416 423.2 416 384c0-34.1-10.7-65.8-28.9-91.7c3.2-11.6 4.9-23.7 4.9-36.3c0-1.6 0-3.1-.1-4.7l49.5-21.2 56-24c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L456 171.6V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v40.2l-26.5 11.4c-4.6-11-10.6-21.3-17.8-30.6c7.9-16 12.3-34 12.3-53C376 53.7 322.3 0 256 0zM184 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 15.6-5 30-13.4 41.8c-6.9 9.6-5.7 22.9 2.8 31.1c16.4 16 26.6 38.3 26.6 63c0 11.3-2.1 22.1-6 32c-3.2 8.2-1.7 17.4 3.9 24.1C358.2 331.6 368 356.6 368 384c0 27.5-9.8 52.5-26.2 72c-3.8 4.6-11.1 8-21.5 8H191.7c-10.4 0-17.7-3.4-21.5-8c-16.4-19.5-26.2-44.6-26.2-72c0-27.4 9.8-52.4 26.1-71.8c5.6-6.7 7.1-16 3.9-24.1c-3.9-9.9-6-20.7-6-32c0-24.7 10.2-47 26.6-63c8.5-8.3 9.7-21.5 2.8-31.1C189 150 184 135.6 184 120zm56-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faUserAlien = {
  prefix: 'far',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M112 167c0-67.7 52.1-119 112-119s112 51.3 112 119c0 33.9-18.3 69.4-46.1 102.4c-23.3 27.7-49.6 49.4-65.9 61.6c-16.3-12.2-42.6-34-65.9-61.6C130.3 236.4 112 201 112 167zM224 0C135.6 0 64 74.8 64 167c0 101 106.6 185 139.2 208.3c6.1 4.3 13.4 6.5 20.8 6.5s14.7-2.1 20.8-6.5C277.4 352 384 268.1 384 167C384 74.8 312.4 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6c0-71.4-55.7-129.8-126.1-134.1c-22.6 22.1-44 38.6-56.7 47.7h48.3c40 0 73.6 27.1 83.5 64H50.9c9.9-36.9 43.5-64 83.5-64h48.3c-12.7-9.2-34-25.6-56.7-47.7C55.7 356.6 0 415 0 486.4zM208 222.9c0-30.3-24.6-54.9-54.9-54.9h-16c-5 0-9.1 4.1-9.1 9.1c0 30.3 24.6 54.9 54.9 54.9h16c5 0 9.1-4.1 9.1-9.1zM294.9 168c-30.3 0-54.9 24.6-54.9 54.9c0 5 4.1 9.1 9.1 9.1h16c30.3 0 54.9-24.6 54.9-54.9c0-5-4.1-9.1-9.1-9.1h-16z"]
};
var faShieldCheck = {
  prefix: 'far',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faMortarPestle = {
  prefix: 'far',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M504.3 11.1c10.9 12.7 10.2 31.7-1.6 43.5L397.3 160H252.3L461 6.2c13.5-9.9 32.3-7.8 43.2 4.9zM80 240v16c0 62.9 31.3 109.5 91.9 131c14.6 5.2 25.8 17.1 30.1 32.1s1 31-8.6 43.1c-.5 .6-1 1.2-1.4 1.8H320c-.5-.6-.9-1.2-1.4-1.8c-9.7-12.1-12.9-28.2-8.6-43.1s15.5-26.9 30.1-32.1c60.7-21.6 91.9-68.1 91.9-131V240H80zm432-24c0 13.3-10.7 24-24 24h-8v16c0 66-27.8 120.8-80 154.8c-13.1 8.5-27.7 15.7-43.9 21.5c10 12.6 17.7 27.1 22.5 42.9c.5 1.7 1 3.5 1.4 5.2c4.4 17.1-10.4 31.7-28.1 31.7H160c-17.7 0-32.4-14.6-28.1-31.7c.4-1.8 .9-3.5 1.4-5.2c4.7-15.8 12.5-30.3 22.5-42.9c-16.1-5.7-30.8-12.9-43.9-21.5C59.8 376.8 32 322 32 256V240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8H480h8c13.3 0 24 10.7 24 24z"]
};
var faRoadBarrier = {
  prefix: 'far',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M24 32c13.3 0 24 10.7 24 24V80H592V56c0-13.3 10.7-24 24-24s24 10.7 24 24V80v48V256v48V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V304H48V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 42.7 10.7 32 24 32zM592 256V128H570.8l-64 128H592zM48 256H69.2l64-128H48V256zM389.2 128H314.8l-64 128h74.3l64-128zM378.8 256h74.3l64-128H442.8l-64 128zm-192-128l-64 128h74.3l64-128H186.8z"]
};
var faChartCandlestick = {
  prefix: 'far',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm272-8c0-8.8-7.2-16-16-16s-16 7.2-16 16V96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32V48zm64 176v64c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32zM160 128c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"]
};
var faBriefcaseBlank = {
  prefix: 'far',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm232 48H152 64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H360z"]
};
var faSchool = {
  prefix: 'far',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", "M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92H568c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H384 256 72c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h96.7l138-92zM568 464c13.3 0 24-10.7 24-24V168c0-13.3-10.7-24-24-24H464c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4H72c-13.3 0-24 10.7-24 24V440c0 13.3 10.7 24 24 24H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80H568zM112 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V208zM112 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V336zM240 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V160c0-8.8-7.2-16-16-16z"]
};
var faIgloo = {
  prefix: 'far',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M512 432H400V368H528v48c0 8.8-7.2 16-16 16zM395.4 320c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80H144V192H432V320H395.4zm95.7-128c23.4 37 36.9 80.9 36.9 128H480V192h11.1zM96 192V320H48c0-47.1 13.5-91 36.9-128H96zM288 80c5.4 0 10.7 .2 16 .5V144H124.8C167.7 104.3 225 80 288 80zm64 64V88.6c37.6 10.4 71.4 29.6 99.2 55.4H352zM176 368v64H64c-8.8 0-16-7.2-16-16V368H176zM64 480H176 400 512c35.3 0 64-28.7 64-64V320C576 160.9 447.1 32 288 32S0 160.9 0 320v96c0 35.3 28.7 64 64 64zM288 288c35.3 0 64 28.7 64 64v80H224V352c0-35.3 28.7-64 64-64z"]
};
var faBracketRound = {
  prefix: 'far',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M156.6 43.7c6.8 11.4 3 26.1-8.3 32.9C115.3 96.3 48 160.7 48 256s67.3 159.7 100.3 179.4c11.4 6.8 15.1 21.5 8.3 32.9s-21.5 15.1-32.9 8.3C82 451.8 0 374.1 0 256S82 60.2 123.7 35.4c11.4-6.8 26.1-3 32.9 8.3z"]
};
var faParenthesis = faBracketRound;
var faJoint = {
  prefix: 'far',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M464 24V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v19c0 13.3-10.7 24-24 24s-24-10.7-24-24V245c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM592 264V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24V43c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v19c0 13.3-10.7 24-24 24s-24-10.7-24-24zM120.2 436.8C171.7 450.7 235.2 464 288 464h27.4l-52.6-63.1c-47 3.2-99.1 14.6-142.6 26.3c-5.8 1.6-11.7 3.2-17.5 4.8c5.8 1.7 11.6 3.3 17.5 4.8zM324.6 400l53.3 64h97.5l-53.3-64H324.6zm160 0l53.3 64H592V400H484.6zM15.8 409.5c30.1-11 61.1-20.3 92-28.6C160.3 366.7 228.8 352 288 352H600c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H288c-59.2 0-127.7-14.7-180.2-28.8c-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z"]
};
var faHorseSaddle = {
  prefix: 'far',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M426.8 .6c1.7-.4 3.4-.6 5.2-.6h8 32 .5c2.5 0 5 .1 7.5 .3V0h56c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c5.4 9.4 9.1 20 10.7 31.3l9.9 69.2c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5V240l0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V364.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8H139.1c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-47.3 37.3-85.9 84.1-87.9c20.3-29.1 54-48.1 92.1-48.1h22.6H232h61.3C309.8 51.5 362.6 6.1 426.8 .6zM416 239V184c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48H472 440h-4.6c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-.2 1.4-.4 2.7-.8 3.9c0 .4 0 .7 0 1.1v32c0 40.3-27.1 74.2-64 84.7v49.1l38.7 11.3c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5V464h48V318.2c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5zM288 160H232 208v16c0 22.1 17.9 40 40 40s40-17.9 40-40V160zm-128 2.1c-27.6 7.2-48 32.3-48 62.2c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464h49.8l-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l1.3 .4V260.7c-36.9-10.4-64-44.4-64-84.7V162.1zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faMugMarshmallows = {
  prefix: 'far',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", "M197.7 125.7C194 122 192 117.1 192 112s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128H200l-2.3-2.3zM32 64c0-17.7 14.3-32 32-32H192c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3c0 5.5 .9 10.9 2.6 16H32V64zM48 384c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V208H152v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H48V384zM0 192c0-17.7 14.3-32 32-32H352h48c61.9 0 112 50.1 112 112s-50.1 112-112 112H384c0 53-43 96-96 96H96c-53 0-96-43-96-96V192zM384 336h16c35.3 0 64-28.7 64-64s-28.7-64-64-64H384V336z"]
};
var faFilters = {
  prefix: 'far',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M233.8 32C210.7 32 192 50.7 192 73.8c0 9.3 3.1 18.4 8.9 25.8L336 272.3v63.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2V272.3L631.1 99.6c5.8-7.4 8.9-16.4 8.9-25.8C640 50.7 621.3 32 598.2 32H233.8zM378.9 249.2L246.5 80h339L453.1 249.2c-3.3 4.2-5.1 9.4-5.1 14.8V382.6l-64-50.3V264c0-5.4-1.8-10.6-5.1-14.8zM163.4 96H41.8C18.7 96 0 114.7 0 137.8c0 9.3 3.1 18.4 8.9 25.8L144 336.3v31.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2V336.3v-.1V283.3l-9.7-12.5-33.2 42.4c-3.3 4.2-5.1 9.4-5.1 14.8v86.6l-64-50.3V328c0-5.4-1.8-10.6-5.1-14.8L54.5 144H195l-19.3-24.6c-5.5-7-9.6-15-12.3-23.4z"]
};
var faBellOn = {
  prefix: 'far',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M320 0c-17.7 0-32 14.3-32 32V49.9C215.5 61.4 160 124.2 160 200v33.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6H520c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C495.5 322.9 480 278.8 480 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H168.3c25.8-40 39.7-86.7 39.7-134.6V200c0-57.4 46.6-104 104-104h8zm64 352H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM0 200c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H536zM597.5 21.3c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3s-1.1 26.3 10.7 32.2z"]
};
var faAngleRight = {
  prefix: 'far',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"]
};
var faDialMed = {
  prefix: 'far',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM176 288c0-53.6 37.7-98.4 88-109.4V288c0 13.3 10.7 24 24 24s24-10.7 24-24V178.6c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHorse = {
  prefix: 'far',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M432 0c-1.8 0-3.5 .2-5.2 .6c-64.2 5.5-117 51-133.5 111.4H232 198.9 176.2c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248v64c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2h49.8c31.7 0 54.7-30.3 46.2-60.8l-14.8-53.3c-.5-1.6-.4-3.4 .2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V327.8c19.8-22.6 32-52.3 32-85.5l0-1.6 0-.7v-7.8c17.7 6 37.5 5.8 55.8-1.5c34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24H480V.3c-2.5-.2-5-.3-7.5-.3H472 440h-8zM416 240.5c0 .6 0 1.2 0 1.7c0 23.5-9.6 44.1-24.7 58.8c-4.6 4.5-7.3 10.7-7.3 17.2V464H336V346.2c0-11.3-7.9-21.1-19-23.5c-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6L188.9 464H139.1l-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9c0-35.5 28.8-64.2 64.2-64.2h22.6H232h81c12.1 0 22.3-9 23.8-21c6.1-49.1 46.6-87.7 96.6-90.8c.7 0 1.3-.1 2-.2H440h32 .5c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7c-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7s-16.1 12.5-16.1 22.6v55c0 .5 0 1 0 1.5zM480 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faQ = {
  prefix: 'far',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M48 256c0 97.2 78.8 176 176 176c35.7 0 69-10.6 96.7-28.9l-91-107.6c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l90.5 107C383.7 340.6 400 300.2 400 256c0-97.2-78.8-176-176-176S48 158.8 48 256zM351.9 439.9C315.6 465.2 271.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 58.9-22.7 112.5-59.9 152.4l54.2 64.1c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8l-53.8-63.6z"]
};
var faMonitorWaveform = {
  prefix: 'far',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", "M64 80c-8.8 0-16 7.2-16 16V240H176c8.4 0 16.2 4.4 20.6 11.7l25.5 42.5 60.4-120.9c3.9-7.8 11.8-12.9 20.5-13.2s17 4.1 21.5 11.6l41 68.3H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-8.4 0-16.2-4.4-20.6-11.7l-25.5-42.5L245.5 354.7c-3.9 7.8-11.8 12.9-20.5 13.2s-17-4.1-21.5-11.6l-41-68.3H48V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faMonitorHeartRate = faMonitorWaveform;
var faLinkSimple = {
  prefix: 'far',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C98.1 144 48 194.1 48 256s50.1 112 112 112h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c61.9 0 112-50.1 112-112s-50.1-112-112-112H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c88.4 0 160 71.6 160 160zM184 232H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faWhistle = {
  prefix: 'far',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M119 95.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6h2c9 0 17.6-3.8 23.7-10.5l63.4-69.7c4.6-5 7.1-11.6 7.1-18.4c0-8.5-3.9-16.5-10.6-21.6L353.5 114.3C319.4 83.1 273.9 64 224 64c-38.8 0-74.8 11.5-105 31.2zM68.5 143.4c-1.4 .4-2.9 .6-4.5 .6c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16c0 .3 0 .7 0 1c-4 4.6-7.9 9.4-11.5 14.3zM402.9 324.4c-21.3-11.1-47.5-4.8-61.4 14.8C315.4 376.1 272.5 400 224 400c-79.5 0-144-64.5-144-144s64.5-144 144-144c37.5 0 71.5 14.2 97.1 37.7c1 .9 2 1.7 3 2.5L391 204l-10.2 13.6c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l9.8-13L582.3 352.1l-40.7 44.7L402.9 324.4zM224 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faG = {
  prefix: 'far',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 80C126.8 80 48 158.8 48 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152h-149c-13.3 0-24-10.7-24-24s10.7-24 24-24H408c21.6 0 41.2 17.9 39.3 41.9C438.2 389.3 341.7 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C310.2 96.9 269.1 80 224 80z"]
};
var faWineGlassCrack = {
  prefix: 'far',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M184 464V350c44.4-7.5 81.5-35.5 101.7-73.6c13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0H264 194.9h-29H56 48.2c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350V464H72c-1 0-2.1 .1-3.1 .2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8c.9 .1 1.9 .2 2.9 .2l.3 0h88 88c1 0 2.1-.1 3.1-.2c11.8-1.5 20.9-11.6 20.9-23.8c0-12.2-9.1-22.2-20.8-23.8c-.9-.1-1.9-.2-2.9-.2l-.3 0H184zM163.3 48c-.4 3.4-2 6.7-4.6 9.3l-52.3 52.3c-5.9 5.9-6.3 15.3-.9 21.6l76 89.8c1.6 1.9 3.9 3 6.4 3c5.8 0 9.9-5.9 7.8-11.3l-30.9-80.4c-2.8-7.2 0-15.3 6.5-19.3l43.4-27.1c5.6-3.5 8.5-10.2 7.2-16.7L217.6 48h24.2L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7L78.2 48h85.1z"]
};
var faFragile = faWineGlassCrack;
var faSlotMachine = {
  prefix: 'far',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M400 416H112v32c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V416zm48 32c0 5.5-.7 10.9-2 16h82c22.1 0 40-17.9 40-40V217.6c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 17.8-9.7 33.3-24 41.6V424c0 48.6-39.4 88-88 88H384 128c-35.3 0-64-28.7-64-64V416c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64V64C64 28.7 92.7 0 128 0H384c35.3 0 64 28.7 64 64V96c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64l0 32zM400 96V64c0-8.8-7.2-16-16-16L128 48c-8.8 0-16 7.2-16 16l0 32H400zm48 48H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zM112 176h56c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L133.9 224H112c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96 24c0-13.3 10.7-24 24-24h56c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L253.9 224H232c-13.3 0-24-10.7-24-24zm144-24h56c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L373.9 224H352c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faNotesMedical = {
  prefix: 'far',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M144 96c0-8.8 7.2-16 16-16H416c8.8 0 16 7.2 16 16V293.5c0 4.2-1.7 8.3-4.7 11.3l-58.5 58.5c-3 3-7.1 4.7-11.3 4.7H160c-8.8 0-16-7.2-16-16V96zM96 96V352c0 35.3 28.7 64 64 64H357.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm176 32c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336H136c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24V376c0 75.1 60.9 136 136 136H296c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faCarWash = {
  prefix: 'far',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M224 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zm-70.2 80H294.2c10.1 0 19.2 6.4 22.6 15.9L333.9 272H114.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM57.4 287.9c-.2 .5-.3 .9-.5 1.4C32.2 306.7 16 335.5 16 368v32 16 32 40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H384v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448 416 400 368c0-32.5-16.2-61.3-40.9-78.6c-.1-.5-.3-.9-.5-1.4L362 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H153.8c-30.4 0-57.6 19.1-67.8 47.8L57.4 287.9zM384 368v32H64V368c0-26.5 21.5-48 48-48H336c26.5 0 48 21.5 48 48zM128 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM112 80c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48s48-16 48-48zm272 48c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48z"]
};
var faEscalator = {
  prefix: 'far',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm182.1 85.8c16-14 36.6-21.8 57.9-21.8H552c48.6 0 88 39.4 88 88s-39.4 88-88 88H481.1L249.9 490.2c-16 14-36.6 21.8-57.9 21.8H88c-48.6 0-88-39.4-88-88s39.4-88 88-88h70.9L390.1 133.8zM448 160c-9.7 0-19 3.5-26.3 9.9L183.8 378.1c-4.4 3.8-10 5.9-15.8 5.9H88c-22.1 0-40 17.9-40 40s17.9 40 40 40H192c9.7 0 19-3.5 26.3-9.9L456.2 245.9c4.4-3.8 10-5.9 15.8-5.9h80c22.1 0 40-17.9 40-40s-17.9-40-40-40H448zM256 128c23.7 0 44.4 12.9 55.5 32L192 264.5V192c0-35.3 28.7-64 64-64z"]
};
var faCommentImage = {
  prefix: 'far',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9l-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5zM296 160c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H256 208 160c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zM176 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faTemperatureHalf = {
  prefix: 'far',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M160 48c-35.3 0-64 28.7-64 64V273.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V273.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V200c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faDongSign = {
  prefix: 'far',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M296 32c-13.3 0-24 10.7-24 24v8H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v76.1c-21.9-17.6-49.7-28.1-80-28.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c30.3 0 58.1-10.5 80-28.1V392c0 13.3 10.7 24 24 24s24-10.7 24-24V288 112h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V56c0-13.3-10.7-24-24-24zM112 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM24 448c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faDonut = {
  prefix: 'far',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M48 289.9c7.7 5 14.4 11.5 19.5 19.2c9.4 13 22 23.4 36.5 30.2c14.7 6.8 30.8 9.7 46.9 8.4l.6 0 .6 0c17.7-.2 35.3 3.3 51.7 10.1l.1 0c16.4 7 34.1 10.5 51.9 10.3l.3 0 0 0c17.8 .2 35.5-3.3 51.9-10.3l.1 0 0 0c16.4-6.8 34-10.2 51.7-10.1l.6 0 .6 0c16.1 1.3 32.2-1.5 46.9-8.3c14.6-6.7 27.1-17.1 36.5-30.1c5.1-7.8 11.8-14.3 19.5-19.3v14c0 21.7-14.2 48.5-52.4 72.4C374 399.9 319.1 416 256 416s-118-16.1-155.6-39.6C62.2 352.5 48 325.7 48 304V289.9zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160V208c0-88.4-114.6-160-256-160zm64 144c0 17.7-28.7 32-64 32s-64-14.3-64-32s28.7-32 64-32s64 14.3 64 32zM283.3 84.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zm-112 38.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm224 9.4l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 192H96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm331.3 36.7l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-240 16l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm176 38.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faDoughnut = faDonut;
var faCapsules = {
  prefix: 'far',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64V256H48V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm283.4 73.3c-20.9-30.4-13.3-72.2 15.8-93c28.5-20.4 68-13.7 88.5 16.2l66.9 97.5L348.5 312.2l-65.1-94.9z"]
};
var faPooStorm = {
  prefix: 'far',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", "M175.3 10.1C179.8 3.8 187 0 194.8 0c58.8 0 132.5 41.8 140.5 121.2C364.2 135.7 384 165.5 384 200c0 2.2-.1 4.4-.2 6.6C421.3 221 448 257.4 448 300c0 55.2-44.8 100-100 100h-8.2c11.5-12.9 15.4-31.2 9.5-47.9l0-.1c28.1-.7 50.7-23.7 50.7-52c0-27-20.7-49.3-47-51.8c-7.6-.7-14.4-5-18.3-11.5s-4.5-14.5-1.7-21.5c1.9-4.7 3-9.8 3-15.2c0-18.6-12.7-34.3-30-38.7c-10.9-2.8-18.4-12.8-18-24.1c0-.5 0-1 0-1.5c0-40.2-26.7-68.8-58.4-81c1.3 5.6 2.4 11.6 2.4 16.8c0 38-19.6 61-39 73.6c-9.3 6-18.5 9.6-25.2 11.7c-3.4 1.1-6.3 1.8-8.4 2.2l-.4 .1c-2.2 .7-4.5 1-6.9 1H152c-22.1 0-40 17.9-40 40c0 5.4 1.1 10.5 3 15.2c2.9 7 2.3 15-1.7 21.5s-10.7 10.8-18.3 11.5C68.7 250.7 48 273 48 300c0 18 9.1 33.8 22.9 43.1c-7.3 12-9.1 27-4.2 40.8c1.6 4.6 3.8 8.8 6.6 12.5C31 384.7 0 346 0 300c0-42.6 26.7-79 64.2-93.4c-.2-2.2-.2-4.4-.2-6.6c0-47.6 37.8-86.3 84.9-87.9l.5-.1c.9-.2 2.4-.6 4.3-1.1c3.8-1.2 8.6-3.1 13.3-6.1c8.6-5.5 17-14.7 17-33.3c0 0 0 0 0 0c0-.3-.2-1.5-.7-4c-.6-2.8-1.5-6.1-2.6-9.9c-2.2-7.5-5-15.3-7.1-21.3l0 0 0 0 0-.1c-.5-1.6-1.1-3.1-1.5-4.3c-2.5-7.3-1.3-15.4 3.2-21.7zM282.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352H304c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384H112c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faPooBolt = faPooStorm;
var faTally1 = {
  prefix: 'far',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", "M128 40c13.3 0 24 10.7 24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24z"]
};
var faFaceFrownOpen = {
  prefix: 'far',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFrownOpen = faFaceFrownOpen;
var faSquareDashed = {
  prefix: 'far',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M88 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-22.1 0-40 17.9-40 40v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V120C0 71.4 39.4 32 88 32zM24 192c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm400 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zm0-32c-13.3 0-24-10.7-24-24V120c0-22.1-17.9-40-40-40H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c48.6 0 88 39.4 88 88v16c0 13.3-10.7 24-24 24zm24 216v16c0 48.6-39.4 88-88 88H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c22.1 0 40-17.9 40-40V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM48 376v16c0 22.1 17.9 40 40 40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-48.6 0-88-39.4-88-88V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM184 480c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H184zM160 56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]
};
var faSquareJ = {
  prefix: 'far',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 56V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHandPointUp = {
  prefix: 'far',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M64 64V241.6c5.2-1 10.5-1.6 16-1.6H96V208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0v24c0 66.3 53.7 120 120 120h48c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H120 80zM0 320s0 0 0 0c0-18 6-34.6 16-48V64C16 28.7 44.7 0 80 0s64 28.7 64 64v82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64v64 24c0 92.8-75.2 168-168 168H168C75.2 512 0 436.8 0 344V320zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 16c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM160 240c5.5 0 10.9 .7 16 2v-2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h16zm64 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16V256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v24z"]
};
var faMoneyBill = {
  prefix: 'far',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faArrowUpBigSmall = {
  prefix: 'far',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", "M368 208V80l128 0V208H368zm-48 0c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V208zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zM368 368h64v64H368V368zm-48 0v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faSortSizeUp = faArrowUpBigSmall;
var faBarcodeRead = {
  prefix: 'far',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", "M56 48c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56zm64 80c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm272 0c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm-208 8c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm152-24c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM528 56c0-4.4-3.6-8-8-8H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56zM56 464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 4.4 3.6 8 8 8zm472-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 30.9-25.1 56-56 56H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8z"]
};
var faBaguette = {
  prefix: 'far',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M578.6 83.6c-24.5-36.8-74.2-46.7-110.9-22.2l-69.7 46.5L433 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-41.9-41.9-74.5 49.6L321 223c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.1-45.1-74.5 49.6L209 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48.3-48.3L83.6 317.4c-36.8 24.5-46.7 74.2-22.2 110.9s74.2 46.7 110.9 22.2l384-256c36.8-24.5 46.7-74.2 22.2-110.9zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z"]
};
var faBowlSoftServe = {
  prefix: 'far',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", "M256 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7H172c-42 0-76 34-76 76c0 4.7 .4 9.3 1.2 13.8C51 162.5 16 203.2 16 252c0 29 12.3 55.1 32 73.3V344c0 57.4 46.6 104 104 104h30.1l-20.4 40.8c-1.1 2.3-1.7 4.7-1.7 7.2c0 2.9 .8 5.8 2.4 8.4c2.9 4.7 8.1 7.6 13.6 7.6H336c5.5 0 10.7-2.9 13.6-7.6c1.6-2.6 2.4-5.5 2.4-8.4c0-2.4-.6-4.9-1.7-7.2L329.9 448H360c57.4 0 104-46.6 104-104V325.3c19.7-18.3 32-44.4 32-73.3c0-49.1-35.3-89.9-82-98.4c1.3-5.7 2-11.6 2-17.6C416 60.9 355.1 0 280 0H256zM396 304H116c-28.7 0-52-23.3-52-52s23.3-52 52-52h12 6.5H168c13.3 0 24-10.7 24-24s-10.7-24-24-24H146.7c-1.7-3.6-2.7-7.7-2.7-12c0-15.5 12.5-28 28-28h69.3c30.2 0 54.7-24.5 54.7-54.7c0-2.7-.2-5.3-.6-8C336.7 56.6 368 92.7 368 136c0 5.8-1.5 11.3-4.3 16H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h95.2H384h12c28.7 0 52 23.3 52 52s-23.3 52-52 52z"]
};
var faFaceHoldingBackTears = {
  prefix: 'far',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 32v16 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6v32zm112 16a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48s-6 34.6-16 48zM310.4 362.5c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9C328.3 413.8 298.3 434 256 434s-72.3-20.2-89.6-38.9c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4C212.1 373.9 230.1 386 256 386s43.9-12.1 54.4-23.5zM128 240c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z"]
};
var faSquareUp = {
  prefix: 'far',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM119.2 217.4l91-84c3.8-3.5 8.7-5.4 13.9-5.4s10.1 1.9 13.9 5.4l91 84c4.6 4.2 7.2 10.1 7.2 16.4c0 12.3-10 22.3-22.3 22.3H272v96c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V256H134.3C122 256 112 246 112 233.7c0-6.2 2.6-12.1 7.2-16.4z"]
};
var faArrowAltSquareUp = faSquareUp;
var faTrainSubwayTunnel = {
  prefix: 'far',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M256 48C141.1 48 48 141.1 48 256V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-114.9-93.1-208-208-208zm24 128l0 80h72V208c0-17.7-14.3-32-32-32H280zm-48 0H192c-17.7 0-32 14.3-32 32v48h72l0-80zM160 304v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V304H160zm-48-96c0-44.2 35.8-80 80-80H320c44.2 0 80 35.8 80 80V368c0 27.7-14.1 52.2-35.5 66.5L401 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-57-57H201.9l-57 57c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l36.5-36.5C126.1 420.2 112 395.7 112 368V208zm64 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSubwayTunnel = faTrainSubwayTunnel;
var faSquareExclamation = {
  prefix: 'far',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faExclamationSquare = faSquareExclamation;
var faSemicolon = {
  prefix: 'far',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M72 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm96 0A72 72 0 1 0 24 128a72 72 0 1 0 144 0zM84.4 347c1.4-6.4 7.1-11 13.6-11c7.3 0 13.9 6.2 13.9 14.3c0 2.7-.8 5.4-2.1 7.6L67.1 428l17.3-81zm-.7 145.8L150.8 383c6-9.8 9.2-21.2 9.2-32.7c0-34.2-27.7-62.3-61.9-62.3c-29.2 0-54.4 20.4-60.6 49L10.4 463.6C5 488.5 24 512 49.5 512c14 0 26.9-7.3 34.2-19.2z"]
};
var faBookmark = {
  prefix: 'far',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z"]
};
var faFanTable = {
  prefix: 'far',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M224 400a176 176 0 1 0 0-352 176 176 0 1 0 0 352zM448 224c0 115.6-87.6 210.8-200 222.7V464H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H224 88c-13.3 0-24-10.7-24-24s10.7-24 24-24H200V446.7C87.6 434.8 0 339.6 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM118.4 197.6c-16.6-41 3.2-87.6 44.2-104.1c12.3-5 26.3 1 31.2 13.3l29.2 72.2c16.7-23.7 45.8-37.5 76.6-33.2c43.8 6.1 74.2 46.6 68.1 90.4c-1.8 13.1-14 22.3-27.1 20.4l-77.1-10.8c12.2 26.4 9.6 58.4-9.6 82.9c-27.2 34.8-77.5 41-112.3 13.8c-10.4-8.2-12.3-23.2-4.1-33.7l47.9-61.4c-28.9-2.6-55.4-21-67-49.7zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAlignJustify = {
  prefix: 'far',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faBatteryLow = {
  prefix: 'far',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", "M464 144c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm80 96H96V320h64V192z"]
};
var faBattery1 = faBatteryLow;
var faCreditCardFront = {
  prefix: 'far',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 360c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zM96 280c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zM376 128h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"]
};
var faBrainArrowCurvedRight = {
  prefix: 'far',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3c-16.6 7.5-28.2 24.1-28.3 43.5c-.1 9.1-5.2 17.3-13.3 21.3C82.8 164.9 72 181.2 72 200c0 7.1 1.5 13.7 4.2 19.7c4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9c6.7 5.4 10 14 8.7 22.5c-.4 2.5-.6 5-.6 7.6c0 26.1 20.8 47.3 46.7 48c9.2 .3 17.4 5.7 21.2 14.1c6.9 15.3 22.3 25.9 40.1 25.9c24.3 0 44-19.7 44-44V88c0-22.1-17.9-40-40-40c-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30c-32.2 0-60.5-16.5-76.9-41.5c-45-8-79.1-47.3-79.1-94.5c0-.5 0-1.1 0-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8c4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4c24.1 14.3 41.5 38.9 45.9 67.8C471.7 138.5 488 167.4 488 200c0 8-1 15.8-2.8 23.3c1.3 1.5 2.6 3.1 3.8 4.8c-5.7 8-9 17.7-9 28v16H459.4c-3.8-9.4-9.8-17.8-17.4-24.3c-8-6.9-10.5-18.3-6.1-28c2.7-6 4.2-12.6 4.2-19.7c0-18.8-10.8-35.1-26.7-43c-8.1-4-13.3-12.3-13.3-21.3c-.1-19.3-11.7-36-28.3-43.5c-6.4-2.9-11.3-8.5-13.2-15.3C353.7 60.2 338.2 48 320 48c-22.1 0-40 17.9-40 40V420c0 19.8 13.1 36.5 31 42.1c6.5 20.5 16.6 36.8 26.4 49c-4.4 .6-8.8 1-13.4 1c-26.9 0-51.2-11.6-68-30zM539.3 244.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8V400H464c-35.3 0-64 28.7-64 64v35.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.7-2.2c-10.5-8.2-45-39.5-45-93.8c0-61.9 50.1-112 112-112h64V256c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5z"]
};
var faMindShare = faBrainArrowCurvedRight;
var faUmbrellaBeach = {
  prefix: 'far',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", "M399.7 18.8c0 0 0 0 0 0c1.3 .5 2.6 .9 4 1.4c4.1 1.5 8.1 3 12 4.7c0 0 0 0 0 0C519.4 68.6 580.3 173.8 571.4 281.8c-1.6 19.2-21.5 30-39.6 23.4L349.7 239l-45.1-16.4L122.5 156.3c-18.1-6.6-26.4-27.7-15.3-43.4c64.2-90.8 182.8-132 292.6-94zM288.8 54.6c-48 6.4-92.7 29.5-125.8 65.4l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM413.3 211c9.4-32.5 13.2-66.4 11.2-100.2c-1.1-18.2-12-34.2-28.2-41.9c-3-1.2-6-2.4-9-3.5c-1-.4-2-.7-2.9-1c-18.2-5.9-38.3-.9-51.5 13.1c-23.3 24.6-42.2 53.1-55.9 84L413.3 211zm45.2 16.4L524 251.3c-2.2-47-20.3-91.9-51-127.2c.4 35-4.5 69.8-14.5 103.3zM552 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l192.7 0 76.9-211.4L338.7 269l-71 195L552 464z"]
};
var faHelmetUn = {
  prefix: 'far',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M240 48c106 0 192 86 192 192H256c-9.4 0-18 5.5-21.8 14.1L196.9 336H82.4c-19 0-34.4-15.4-34.4-34.4V240C48 134 134 48 240 48zm80 372.7l-77.7-68.6L271.5 288H320V420.7zm48 42.4V288H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8C480 107.5 372.5 0 240 0S0 107.5 0 240v61.6C0 347.1 36.9 384 82.4 384H205.9l2.3 2 136 120c4.4 3.9 10 6 15.9 6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.1l-1.1-.9zM285.3 103.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3v96c0 8.8 7.2 16 16 16s16-7.2 16-16V164.8l34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.2l-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112z"]
};
var faLocationSmile = {
  prefix: 'far',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM136 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-79.4 76.9c4.5 6.7 21.6 23.1 47.4 23.1s42.9-16.4 47.4-23.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C262.9 265.7 234.5 292 192 292s-70.9-26.3-80.6-40.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z"]
};
var faMapMarkerSmile = faLocationSmile;
var faArrowLeftToLine = {
  prefix: 'far',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424zM135.6 238.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L212.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z"]
};
var faArrowToLeft = faArrowLeftToLine;
var faBullseye = {
  prefix: 'far',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-272a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSushi = {
  prefix: 'far',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M524.5 302.9c23.1 7.7 46-12.3 41.5-36.3l-8.6-46c-7.1-37.7-24.8-71-49.8-97.2L421.7 268.8l102.8 34.1zM393.7 65.6L296.5 230.2c9 1 17.9 2.9 26.6 5.8l67.5 22.4 92.5-156.6C457.4 82.7 426.7 70 393.7 65.6zM357.5 64H246.6L119.9 278.4l120.9-41.9c5.7-2 11.6-3.6 17.5-4.7L357.5 64zM207.3 64C115 64 35.7 129.8 18.6 220.6l-8.5 45.2C5.6 290 28.9 310 52.1 302l21.1-7.3L209.5 64h-2.1zM32 336.7V352c0 53 43 96 96 96c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c18.8 0 36.4-5.4 51.2-14.8c2.9-1.8 6.6-1.8 9.5 0c14.8 9.4 32.4 14.8 51.2 14.8c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c53 0 96-43 96-96V337.4c-8.5 .8-17.4-.1-26.2-3.1L496 327.1V352c0 26.5-21.5 48-48 48c-8.7 0-16.8-2.3-23.8-6.3c-17.5-10-39-10-56.5 0c-7 4-15 6.3-23.8 6.3c-9.5 0-18.2-2.7-25.6-7.4c-18.6-11.7-42.3-11.7-60.8 0c-7.4 4.7-16.1 7.4-25.6 7.4c-8.7 0-16.8-2.3-23.8-6.3c-17.5-10-39-10-56.5 0c-7 4-15 6.3-23.8 6.3c-26.5 0-48-21.5-48-48V326.1l-20.9 7.2c-9.1 3.2-18.3 4.2-27.1 3.3z"]
};
var faNigiri = faSushi;
var faMessageCaptions = {
  prefix: 'far',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zM120 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faCommentAltCaptions = faMessageCaptions;
var faTrashList = {
  prefix: 'far',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M170.5 51.6L151.5 80h113l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm115-26.6L322.2 80h13.7H384h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H380.4L356.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80.1 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h61.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8H292.6c8.4 0 15.3-6.5 16-14.8L332.3 128H83.7zM472 128H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128H584c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24zM448 408c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24z"]
};
var faBacon = {
  prefix: 'far',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", "M441.7 216c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8c11.2-3.2 23.2-.1 31.4 8.1l96 96c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2zM262.9 196.4l0 0c-41.7 60.7-89.2 129.6-204.1 191.7l24.3 24.3C197.6 352.8 242.8 287 284.5 226.3l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9c26.6-23.5 59.5-43.6 104.2-59.3L443.4 50.1c-49 15.1-82.4 35.1-108.3 58c-27.8 24.5-47.8 53-69.9 85.1l0 0-2.3 3.4zM106.8 436.1l24.3 24.3c114.5-59.7 159.8-125.5 201.3-186l.2-.3 0 0 2.2-3.2 0 0c21.9-31.9 43.9-63.5 75.1-90.9c26.6-23.5 59.5-43.6 104.2-59.3L491.4 98c-49 15.1-82.4 35.1-108.3 58c-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3C269.3 304.9 221.9 374 106.8 436.1z"]
};
var faOption = {
  prefix: 'far',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M172.1 120.4c-4.6-5.3-11.2-8.4-18.2-8.4H24C10.7 112 0 101.3 0 88S10.7 64 24 64H153.9c21 0 41 9.2 54.7 25.1L467.9 391.6c4.6 5.3 11.2 8.4 18.2 8.4H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H486.1c-21 0-41-9.2-54.7-25.1L172.1 120.4zM616 64c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24s10.7-24 24-24H616z"]
};
var faRaccoon = {
  prefix: 'far',
  iconName: 'raccoon',
  icon: [512, 512, [], "e613", "M336 93.1c12.7-16.1 33.6-24.3 54.1-20.6C376.5 57 356.8 48 336 48s-40.5 9-54.1 24.5c20.5-3.6 41.4 4.5 54.1 20.6zm0 69.5c-2.6 3.4-5.7 6.5-9.1 9.2l-35.8 28.6c3.4 1.9 6.8 4 10.1 6.2l10.9 7.3c1.1-12.3 11.4-21.9 23.9-21.9s22.8 9.6 23.9 21.9l10.9-7.3c3.3-2.2 6.7-4.2 10.1-6.2l-35.8-28.6c-3.4-2.7-6.5-5.8-9.1-9.2zm78.8 23.9l31.9-9.6c5.6-1.7 9.4-6.8 9.4-12.6c0-2.8-.9-5.6-2.6-7.9l-17.8-23.7-42.9-25.7c-14.4-8.6-32.9-.4-36.2 16c-1.8 8.9 1.5 18 8.6 23.7l49.6 39.7zM306.9 146.8c7.1-5.7 10.4-14.8 8.6-23.7c-3.3-16.4-21.9-24.7-36.2-16l-42.9 25.7-17.7 23.7c-1.7 2.3-2.6 5-2.6 7.9c0 5.8 3.8 10.9 9.4 12.6l31.9 9.6 49.6-39.7zM206.2 93.1L194.2 57.3c-1.5-4.4-2.2-9.1-2.2-13.8C192 19.5 211.5 0 235.5 0h1.3c3.3 0 6.5 .4 9.7 1.1l41 9.1C302.7 3.6 319.1 0 336 0s33.3 3.6 48.4 10.2l41-9.1c3.2-.7 6.5-1.1 9.7-1.1h1.3c24 0 43.5 19.5 43.5 43.5c0 4.7-.8 9.3-2.2 13.8L465.8 93.1l25.9 34.6c7.9 10.6 12.2 23.5 12.2 36.7c0 27-17.7 50.8-43.6 58.5l-35.3 10.6c-9.8 2.9-19.2 7.3-27.7 13l-18.8 12.6C366 267.5 351.2 272 336 272s-30-4.5-42.6-12.9l-18.8-12.6c-8.5-5.7-17.9-10.1-27.7-13l-35.3-10.6c-25.9-7.8-43.6-31.6-43.6-58.5c0-13.2 4.3-26.1 12.2-36.7l25.9-34.6zM144 241.9c4.7-4.5 9.6-8.8 14.6-12.8c11.3 10.9 25.2 19.2 40.9 24l6 1.8C159.1 282.9 128 333.8 128 392c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-10.9 .8-21.6 2.4-32H48v32c0 39.8 32.2 72 72 72H304v-8c0-13.3-10.7-24-24-24H232c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c39.8 0 72 32.2 72 72v8h80v-8c0-13.3-10.7-24-24-24s-24-10.7-24-24s10.7-24 24-24c39.8 0 72 32.2 72 72v32c0 13.3-10.7 24-24 24H120C53.7 512 0 458.3 0 392V224 104C0 64.2 32.2 32 72 32s72 32.2 72 72V241.9zm-48 70V264H48v48H95.9l.1-.1zM96 216V168H48v48H96zM307.3 364.4l-64-40c-11.2-7-14.7-21.8-7.6-33.1s21.8-14.7 33.1-7.6l64 40c11.2 7 14.7 21.8 7.6 33.1s-21.8 14.7-33.1 7.6zm56.4-7.6c-7-11.2-3.6-26 7.6-33.1l64-40c11.2-7 26-3.6 33.1 7.6s3.6 26-7.6 33.1l-64 40c-11.2 7-26 3.6-33.1-7.6zM48 120H96V104c0-13.3-10.7-24-24-24s-24 10.7-24 24v16zm240-8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faHandPointDown = {
  prefix: 'far',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"]
};
var faArrowUpFromBracket = {
  prefix: 'far',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V328c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V344z"]
};
var faHeadSideGear = {
  prefix: 'far',
  iconName: 'head-side-gear',
  icon: [512, 512, [], "e611", "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64V336h.4c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0H224C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288.6-28.1c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faTrashPlus = {
  prefix: 'far',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80h13.7H416h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H412.4L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80.1 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8H324.6c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zM204 376V308H136c-11 0-20-9-20-20s9-20 20-20h68V200c0-11 9-20 20-20s20 9 20 20v68h68c11 0 20 9 20 20s-9 20-20 20H244v68c0 11-9 20-20 20s-20-9-20-20z"]
};
var faObjectsAlignTop = {
  prefix: 'far',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM176 176V464H112V176h64zm-64-48c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H112zm288 48V336H336V176h64zm-64-48c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H336z"]
};
var faFolder = {
  prefix: 'far',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"]
};
var faFolderBlank = faFolder;
var faFaceAnxiousSweat = {
  prefix: 'far',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", "M496 256c0 114.9-93.1 208-208 208c-65.4 0-123.8-30.2-162-77.5c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM48 416c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47zM335.6 272a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM288 320c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80z"]
};
var faCreditCardBlank = {
  prefix: 'far',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 360c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24z"]
};
var faFileWaveform = {
  prefix: 'far',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", "M384 464H128c-8.8 0-16-7.2-16-16V352H64v96c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L338.7 18.7C326.7 6.7 310.5 0 293.5 0H128C92.7 0 64 28.7 64 64V240h48V64c0-8.8 7.2-16 16-16H288v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16zM276.8 228.1c-4.4-7.7-12.7-12.3-21.5-12.1s-16.8 5.3-20.8 13.3l-45.5 91L164 282.7C159.5 276 152 272 144 272H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H131.2L172 381.3c4.7 7.1 12.9 11.2 21.5 10.6s16.1-5.6 20-13.2l43.9-87.9 9.8 17.1c4.3 7.5 12.2 12.1 20.8 12.1h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H301.9l-25.1-43.9z"]
};
var faFileMedicalAlt = faFileWaveform;
var faMicrochipAi = {
  prefix: 'far',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h-8c-35.3 0-64 28.7-64 64v8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v8c0 35.3 28.7 64 64 64h8v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h8c35.3 0 64-28.7 64-64v-8h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V184h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v-8c0-35.3-28.7-64-64-64h-8V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM112 128c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128zm224 44c-11 0-20 9-20 20V320c0 11 9 20 20 20s20-9 20-20V192c0-11-9-20-20-20zM234.3 184c-3.2-7.3-10.4-12-18.3-12s-15.1 4.7-18.3 12l-56 128c-4.4 10.1 .2 21.9 10.3 26.3s21.9-.2 26.3-10.3l5.3-12h64.8l5.3 12c4.4 10.1 16.2 14.7 26.3 10.3s14.7-16.2 10.3-26.3l-56-128zM216 241.9L230.9 276H201.1L216 241.9z"]
};
var faMug = {
  prefix: 'far',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M80 352c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V112H80V352zM32 96c0-17.7 14.3-32 32-32H384h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H416v32c0 53-43 96-96 96H128c-53 0-96-43-96-96V96zM416 272h32c44.2 0 80-35.8 80-80s-35.8-80-80-80H416V272z"]
};
var faPlaneUpSlash = {
  prefix: 'far',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L38.8 5.1zM576 338.1V297.5c0-19.1-9.7-36.9-25.8-47.2L400 154.2V128c0-20.6-5.8-49.8-16.5-74.4c-5.4-12.4-12.7-25-22.4-34.9C351.2 8.6 337.4 0 320 0c-17.4 0-31.1 8.8-40.7 18.7c-9.6 9.9-16.9 22.4-22.4 34.8C250 69.2 245 86.8 242.3 102.9L288 139V128c0-13.4 4.4-36.1 12.8-55.1c4.2-9.4 8.7-16.4 12.9-20.7c4.1-4.2 6.1-4.2 6.3-4.2l0 0c.6 0 2.8 .1 6.8 4.2c4.2 4.3 8.6 11.2 12.7 20.6C347.8 91.7 352 114.4 352 128v39.4c0 8.2 4.2 15.8 11.1 20.2L524.3 290.8c2.3 1.5 3.7 4 3.7 6.7v29.6l-2.9-.9 43.8 34.6c4.4-6.4 7.1-14.2 7.1-22.7zM148.8 212.6l-59 37.8 12.9 20.2L89.8 250.3C73.7 260.6 64 278.4 64 297.5v40.6c0 27.1 26.4 46.4 52.2 38.1L240 336.6l0 27.4-48 36c-10.1 7.6-16 19.4-16 32v42.1c0 20.9 17 37.9 37.9 37.9c2.3 0 4.6-.3 6.9-1l-6.9-23 6.9 23 0 0 0 0 0 0 .2 0 .6-.2 2.4-.7 8.9-2.7c7.5-2.2 17.8-5.4 29.2-8.8c19.5-5.9 42-12.6 57.8-17.5l95 29.2c24 7.4 49.1-10.7 49.1-36.2V461.4l-48-37.9V436v12 12.4l-88.9-27.4c-4.6-1.4-9.5-1.4-14.1 0c-15.5 4.8-42 12.8-64.6 19.6c-9.1 2.7-17.5 5.3-24.3 7.3V436l54.4-40.8c6-4.5 9.6-11.6 9.6-19.2V322.5l-46.6-36.8L112 327.1V297.5c0-2.7 1.4-5.3 3.7-6.7l73-46.7-39.9-31.5z"]
};
var faRadiation = {
  prefix: 'far',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", "M113.2 104.7l41.9 72.5c-7.3 9.3-13.3 19.6-17.8 30.8l-83.8 0c9.5-40.1 30.6-75.8 59.7-103.3zm83.1 350.6l41.9-72.6c5.8 .8 11.8 1.2 17.8 1.2s11.9-.4 17.8-1.2l41.9 72.6C296.8 461 276.8 464 256 464s-40.8-3-59.7-8.7zM398.8 104.7c29.1 27.5 50.2 63.1 59.7 103.3l-83.8 0c-4.5-11.1-10.5-21.5-17.8-30.8l41.9-72.5zM160 256c8.8 0 15.8-7.2 17.6-15.9c3.5-17.4 12.7-32.8 25.5-44.1c6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l128 0zm48 83.2L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L304 339.2c-4.4-7.7-14.2-10.1-22.6-7.3c-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9l128 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L304 172.9c-4.4 7.6-1.7 17.3 5 23.2c12.8 11.3 22 26.7 25.5 44.1zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPenCircle = {
  prefix: 'far',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM357.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faBagSeedling = {
  prefix: 'far',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", "M91.9 150.1C84 181.9 80 214.4 80 247.2v17.7c0 32.7 4 65.3 11.9 97L97.5 384h317l5.5-22.1c7.9-31.7 11.9-64.3 11.9-97V247.2c0-32.7-4-65.3-11.9-97L414.5 128H97.5l-5.5 22.1zM427.5 48H84.5L98.7 80H413.3l14.2-32zM83.7 464H428.3l-12.8-32H96.5L83.7 464zM55 99.8L35.4 55.7C33.2 50.6 32 45.1 32 39.6C32 17.7 49.7 0 71.6 0H440.4C462.3 0 480 17.7 480 39.6c0 5.5-1.2 11-3.4 16.1L457 99.8l9.7 38.7c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7l-8.8 35.1 19.3 48.2c1.9 4.8 2.9 9.8 2.9 14.9c0 22.2-18 40.2-40.2 40.2H72.2C50 512 32 494 32 471.8c0-5.1 1-10.2 2.9-14.9l19.3-48.2-8.8-35.1C36.5 338 32 301.5 32 264.8V247.2c0-36.6 4.5-73.1 13.4-108.7L55 99.8zM144 160h2c47.3 0 88.4 26 110 64.5C277.6 186 318.7 160 366 160h2c8.8 0 16 7.2 16 16c0 59.2-45.9 107.6-104 111.7V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V287.7c-58.1-4.1-104-52.6-104-111.7c0-8.8 7.2-16 16-16z"]
};
var faChartSimple = {
  prefix: 'far',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", "M240 80V432H208V80h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 272V432H48V272H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-80h32V432H368V144zm-48 0V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faCrutches = {
  prefix: 'far',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M183 7L7 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l15-15L201.9 347.8c1.9 1.9 3.8 3.6 5.8 5.3l3.5-3.5c1.1-1.1 1.8-2.4 2.2-3.9l9.9-44.4L89.9 168 168 89.9l95.7 95.7c1.9-2.2 3.9-4.3 5.9-6.4l27.8-27.8L201.9 56l15-15c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM402 402.7l-27.2 6L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.2-77.2c-8.2 3.9-16.8 6.9-25.8 8.9zM423 7c-9.4 9.4-9.4 24.6 0 33.9L599 217c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L457 7c-9.4-9.4-24.6-9.4-33.9 0zm-7.6 71.6L292.2 201.9c-11.8 11.8-20 26.8-23.7 43.1L244.6 352.6c-1.7 7.4-5.4 14.2-10.8 19.6L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l98.8-98.8c5.4-5.4 12.2-9.1 19.6-10.8L395 371.5c16.3-3.6 31.3-11.8 43.1-23.7L561.4 224.6l-33.9-33.9L456 262.1 377.9 184l71.4-71.4L415.4 78.6zM326.2 235.8L344 217.9 422.1 296l-17.8 17.9c-5.4 5.4-12.2 9.1-19.6 10.8l-89 19.8 19.8-89c1.7-7.4 5.4-14.2 10.8-19.6z"]
};
var faCircleParking = {
  prefix: 'far',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216 16h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H216v96zm64 48H216v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V296 160c0-17.7 14.3-32 32-32h80c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParkingCircle = faCircleParking;
var faMarsStroke = {
  prefix: 'far',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", "M352 24c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L409.9 136l31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31-27.7 27.7C370.7 227.2 384 264.1 384 304c0 97.2-78.8 176-176 176s-176-78.8-176-176s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L342.1 136l-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L430.1 48H376c-13.3 0-24-10.7-24-24zM208 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faLeafOak = {
  prefix: 'far',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", "M302 0c-33.4 0-62.4 22.7-70.5 55.1l-1.9 7.5c-25.2-23.7-64.8-23.2-89.4 1.4c-14.3 14.3-21 34.5-18.2 54.6l5.4 37.6c-20.5-2-41.6 5-57 20.4l-3.2 3.2c-23.2 23.2-29 58.7-14.3 88.1l12.4 24.7c7.2 14.4 11 30.4 11 46.5v62.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72.4-72.4h56.3c16.1 0 32.1 3.8 46.5 11l24.7 12.4c29.4 14.7 64.9 8.9 88.1-14.3l3.2-3.2c15.4-15.4 22.4-36.5 20.4-57l37.6 5.4c20 2.9 40.2-3.9 54.6-18.2c24.6-24.6 25.1-64.2 1.4-89.4l7.5-1.9c32.4-8.1 55.1-37.2 55.1-70.5c0-24.3-12.2-47-32.4-60.5l-7-4.6 2.8-11.3c6.6-26.4-1.1-54.3-20.3-73.5s-47.1-26.9-73.5-20.4l-11.3 2.8-4.6-7C349 12.1 326.3 0 302 0zM161.3 384.6L313.9 232.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L124.1 353.9V339.1c0-23.6-5.5-46.9-16-68L95.7 246.4c-5.4-10.9-3.3-24.1 5.3-32.7l3.2-3.2c7.7-7.7 19.7-8.8 28.7-2.8c21.5 14.3 49.7-3.5 46.1-29l-9.5-66.8c-.7-5.1 1-10.2 4.6-13.8c6.4-6.4 16.7-6.4 23 0l18.5 18.5c17.6 17.6 47.6 9.3 53.7-14.9L278 66.7c2.7-11 12.6-18.7 24-18.7c8.3 0 16 4.1 20.6 11l7.8 11.7c9.4 14.1 26.6 20.7 43 16.6L390 83.1c10-2.5 20.6 .4 27.9 7.7s10.2 17.9 7.7 27.9l-4.2 16.7c-4.1 16.4 2.6 33.6 16.6 43l11.7 7.8c6.9 4.6 11 12.3 11 20.6c0 11.3-7.7 21.2-18.7 24l-34.9 8.7c-24.1 6-32.5 36.1-14.9 53.7l18.5 18.5c6.4 6.4 6.4 16.7 0 23c-3.6 3.6-8.7 5.3-13.8 4.6l-66.8-9.5c-25.5-3.6-43.4 24.6-29 46.1c6 9 4.8 21-2.8 28.7l-3.2 3.2c-8.6 8.6-21.8 10.7-32.7 5.3l-24.7-12.4c-21.1-10.6-44.4-16-68-16h-8.3z"]
};
var faSquareBolt = {
  prefix: 'far',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm298.1 19.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272H128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faVial = {
  prefix: 'far',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M329 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15L30.2 335.8C10.9 355.2 0 381.4 0 408.8C0 465.8 46.2 512 103.2 512c27.4 0 53.6-10.9 73-30.2L456 201.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-32-32L361 39 329 7zm-151 249L344 89.9 422.1 168l-88 88H177.9z"]
};
var faGauge = {
  prefix: 'far',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6V120c0-13.3-10.7-24-24-24s-24 10.7-24 24V301.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faWandMagicSparkles = {
  prefix: 'far',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM461.4 48L496 82.6 386.2 192.3l-34.6-34.6L461.4 48zM80 429.4L317.7 191.7l34.6 34.6L114.6 464 80 429.4zM427.4 14.1L46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faLambda = {
  prefix: 'far',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H132.6c3 0 5.7 1.7 7.1 4.3l10.2 19.6L2 446.5c-5.3 12.2 .4 26.3 12.5 31.5s26.3-.3 31.5-12.5L178.4 158.9l151.3 291c9.6 18.5 28.8 30.2 49.7 30.2H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H379.4c-3 0-5.7-1.7-7.1-4.3L182.3 62.2C172.6 43.6 153.5 32 132.6 32H24z"]
};
var faE = {
  prefix: 'far',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M56 32C25.1 32 0 57.1 0 88V256 424c0 30.9 25.1 56 56 56H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-4.4 0-8-3.6-8-8V272H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V88c0-4.4 3.6-8 8-8H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H56z"]
};
var faPizza = {
  prefix: 'far',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M254.2 322.1c-8.4 3.8-14.2 12.2-14.2 21.9c0 13.3 10.7 24 24 24c9.8 0 18.2-5.8 21.9-14.2L318.1 386c-18.8 9-39.8 14-62.1 14c-79.5 0-144-64.5-144-144s64.5-144 144-144c22.2 0 43.3 5 62.1 14l-84.7 84.7c-25 25-25 65.5 0 90.5l20.8 20.8zm87.6 87.6l23.4 23.4C333.5 452.7 296.1 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c40.1 0 77.5 11.3 109.2 30.9l-23.4 23.4C316.4 88.1 287.1 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c31.1 0 60.4-8.1 85.8-22.3zM425.4 448c6.6-5.8 6.6-16 .3-22.3L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L425.7 86.3C432 80 432 69.9 425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c64.9 0 124.2-24.2 169.4-64zm71.7-82.8l-23.4-23.4C487.9 316.4 496 287.1 496 256s-8.1-60.4-22.3-85.8l23.4-23.4C516.7 178.5 528 215.9 528 256s-11.3 77.5-30.9 109.2zM464 256c0 22.2-5 43.3-14 62.1L387.9 256 450 193.9c9 18.8 14 39.8 14 62.1zm48 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L489.7 425.7c6.2 6.2 16.4 6.3 22.3-.3zM216 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBowlChopsticksNoodles = {
  prefix: 'far',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", "M13.1 93.6L128 72V56c0-13.3 10.7-24 24-24s24 10.7 24 24v7 37.5 38V176v48h32V176 137.5v-42V57 40c0-13.3 10.7-24 24-24s24 10.7 24 24v8V88v48 40 48h32H464c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8H184c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272c0-26.5 21.5-48 48-48h80V176H16.2C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140V108L18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6zM488.4 176H288V135l199.6-6.2C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83V42L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23zM151.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1H328c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272H48c0 71.3 42.4 132.8 103.5 160.5z"]
};
var faH3 = {
  prefix: 'far',
  iconName: 'h3',
  icon: [640, 512, [], "f315", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM400 64c-13.3 0-24 10.7-24 24s10.7 24 24 24H542.1L423 231c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8h88c35.3 0 64 28.7 64 64s-28.7 64-64 64H455.4c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2c6.4 38.6 39.8 66.8 78.9 66.8H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H497.9L617 105c6.9-6.9 8.9-17.2 5.2-26.2S609.7 64 600 64H400z"]
};
var faPenClip = {
  prefix: 'far',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", "M320 62.1l42.7-42.7c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L286.1 96 273 82.9c-9.4-9.4-24.6-9.4-33.9 0L137 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L205.1 49c28.1-28.1 73.7-28.1 101.8 0L320 62.1zm0 67.9L133.5 316.5c-38.8 38.8-66 87.5-78.6 140.7c53.2-12.7 101.9-39.9 140.7-78.6L382.1 192 320 129.9z"]
};
var faPenAlt = faPenClip;
var faBridgeCircleExclamation = {
  prefix: 'far',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24h48v64H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H256 496h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H536V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240H304c-57.4 0-104 46.6-104 104v88H152V336c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48V440c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V344c0-30.9 25.1-56 56-56h32c1.1 0 2.1 0 3.1 .1zM488 80v64H408V80h80zM360 80v64H280V80h80zM232 80v64H152V80h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faBadgePercent = {
  prefix: 'far',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]
};
var faUser = {
  prefix: 'far',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"]
};
var faSensor = {
  prefix: 'far',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 56V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faComma = {
  prefix: 'far',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M120 353.4c0-9.6-7.8-17.4-17.4-17.4c-8.4 0-15.6 6-17.1 14.3L66.7 453.6l50.4-85.7c1.9-3.3 2.9-7 2.9-10.7v-3.8zm48 0v3.8c0 12.3-3.3 24.4-9.5 35.1l-57.2 97.2C93.1 503.4 78 512 61.8 512H60c-24.3 0-44-19.7-44-44c0-2.6 .2-5.3 .7-7.9L38.2 341.7C43.9 310.6 71 288 102.6 288c36.1 0 65.4 29.3 65.4 65.4z"]
};
var faSchoolCircleCheck = {
  prefix: 'far',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92H72C32.2 96 0 128.2 0 168V440c0 39.8 32.2 72 72 72H256 384h10.8C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V168c0-13.3 10.7-24 24-24H176c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4H568c13.3 0 24 10.7 24 24v52.5c18.8 12.3 35.1 28 48 46.3V168c0-39.8-32.2-72-72-72H471.3L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H112zM320 144c8.8 0 16 7.2 16 16v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
var faToiletPaperUnder = {
  prefix: 'far',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", "M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3H324.7c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0H400c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192V456c0 30.9-25.1 56-56 56H216c-30.9 0-56-25.1-56-56V416h48v40c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM112 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faToiletPaperReverse = faToiletPaperUnder;
var faLightEmergency = {
  prefix: 'far',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M352 304V208c0-70.7-57.3-128-128-128S96 137.3 96 208v96H48V208c0-97.2 78.8-176 176-176s176 78.8 176 176v96H352zM48 384l0 48H400V384H48zm0-48H400c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V384c0-26.5 21.5-48 48-48zM160 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"]
};
var faArrowDownToArc = {
  prefix: 'far',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 464c114.9 0 208-93.1 208-208c0-13.3 10.7-24 24-24s24 10.7 24 24c0 141.4-114.6 256-256 256S0 397.4 0 256c0-13.3 10.7-24 24-24s24 10.7 24 24c0 114.9 93.1 208 208 208zM377.6 232.3l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3L232 266.9 232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 242.9 62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9z"]
};
var faDumpster = {
  prefix: 'far',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM86.4 240H489.6l-20 160H106.4l-20-160zM112 448H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8l22-176h18c13.3 0 24-10.7 24-24s-10.7-24-24-24H540l4-32H495.6 80.4 32l4 32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H42L64 448v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"]
};
var faVanShuttle = {
  prefix: 'far',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", "M48 96v96H176V80H64c-8.8 0-16 7.2-16 16zm0 144v80c0 8.8 7.2 16 16 16H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H396.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H576c8.8 0 16-7.2 16-16V240H360 200 48zm176-48H336V80H224V192zm160 0H564.1L471.3 82.8c-1.5-1.8-3.7-2.8-6.1-2.8H384V192zM640 320c0 35.3-28.7 64-64 64c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H200 360 465.2c16.4 0 32 7.2 42.7 19.7L626.7 191.5c8.6 10.1 13.3 23 13.3 36.3V320zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShuttleVan = faVanShuttle;
var faBuildingUser = {
  prefix: 'far',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M64 48H320c8.8 0 16 7.2 16 16V415.7c11.3-20 27.9-36.7 48-47.9V271.8 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c3.2 0 6.4-.2 9.5-.7c-6-10-9.5-21.8-9.5-34.4c0-4.4 .2-8.7 .7-13c-.2 0-.4 0-.7 0H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H232zm344 56a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"]
};
var faLightSwitch = {
  prefix: 'far',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M192 64c-10.4 0-19.3-6.7-22.6-16H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H169.4c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H214.6c-3.3 9.3-12.2 16-22.6 16zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM144 368h96V280H144v88zm0-224v88h96V144H144zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V144z"]
};
var faSquareCaretLeft = {
  prefix: 'far',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faHighlighter = {
  prefix: 'far',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M184 296.6v-48l22.5-16.2 113 113L303.4 368l-48 0c-12.7 0-24.9 5.1-33.9 14.1l-38.1 38.1-51.5-51.5 38.1-38.1c9-9 14.1-21.2 14.1-33.9zM502.8 90.2L347.9 306 246 204.1 461.8 49.2c1.1-.8 2.4-1.2 3.7-1.2c1.7 0 3.3 .7 4.5 1.9L502.1 82c1.2 1.2 1.9 2.8 1.9 4.5c0 1.3-.4 2.6-1.2 3.7zM255.4 416h48c15.5 0 30-7.4 39-20L541.8 118.2C548.4 109 552 97.9 552 86.5c0-14.4-5.7-28.2-15.9-38.4L503.9 15.9C493.7 5.7 479.9 0 465.5 0C454.1 0 443 3.6 433.8 10.2L156 209.6c-12.6 9-20 23.5-20 39v48L92.3 340.3c-10.7 10.7-14.1 26-10.1 39.5L9.4 452.7c-6 6-9.4 14.1-9.4 22.6V480c0 17.7 14.3 32 32 32h84.7c8.5 0 16.6-3.4 22.6-9.4l32.8-32.8c13.6 4 28.8 .6 39.5-10.1L255.4 416zM134.7 439.3L110.1 464H65.9l46.7-46.7 22.1 22.1z"]
};
var faWavePulse = {
  prefix: 'far',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", "M319.4 0c11.1-.3 21 7.1 23.8 17.9l79.3 303.9 27.1-57.7c9.2-19.6 29-32.2 50.7-32.2H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H500.3c-3.1 0-5.9 1.8-7.2 4.6L437.7 402.2c-4.3 9.1-13.9 14.6-23.9 13.7s-18.5-8.1-21-17.8L322.7 129.4 247.5 492.9c-2.2 10.9-11.6 18.8-22.7 19.1s-21-6.9-23.9-17.6L143.3 285.9c-1-3.5-4.1-5.9-7.7-5.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H135.6c25.2 0 47.3 16.8 54 41.1l31 112.6L296.5 19.1C298.8 8.2 308.2 .3 319.4 0z"]
};
var faHeartRate = faWavePulse;
var faKey = {
  prefix: 'far',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M208 176c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128c-10.4 0-20.5-1.2-30.1-3.6c-8.1-2-16.7 .4-22.6 6.4L254.1 336H200c-13.3 0-24 10.7-24 24v40H136c-13.3 0-24 10.7-24 24v40H48V385.9L205.2 228.7c5.9-5.9 8.3-14.5 6.4-22.6c-2.3-9.6-3.6-19.7-3.6-30.1zM336 0C238.8 0 160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9L7 359c-4.5 4.5-7 10.6-7 17V488c0 13.3 10.7 24 24 24H136c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHatSanta = {
  prefix: 'far',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", "M64 352h51.7l78.6-196.4C212.5 109.9 256.8 80 305.9 80c35.4 0 69 15.6 91.8 42.6l19 22.5c-4-.7-8-1.1-12-1.1h-1.2c-37.3 0-67.6 30.3-67.6 67.6c0 10 2.2 19.8 6.4 28.8L395 352h53L385.9 220c-1.2-2.6-1.9-5.5-1.9-8.4c0-10.8 8.8-19.6 19.6-19.6h1.2c2.1 0 4.2 .3 6.3 1l47.1 14.9c1.9-2.7 4-5.1 6.3-7.4c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L64 352zM583.9 182.2C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C489.8 217 480 227.3 480 240s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"]
};
var faTamale = {
  prefix: 'far',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M319.6 69.3L296.4 208l-.4 0H247.8L270.7 70.3c-6.4-4.6-14.9-8.8-25.4-12.1L229.2 208H197.1L213.8 51.3c-12.5-1.8-25.3-2.7-37.8-3V208H160 144V48.2c-12.5 .4-25.4 1.3-37.8 3L122.9 208H90.8L74.7 58.2c-10.6 3.4-19 7.5-25.4 12.1L72.2 208H24l-.4 0L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM296 304l.4 0 23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512s-114-5-150.6-41.3c-7.3-7.3-10.7-17.7-9-27.9L23.6 304l.4 0H66.7c-3.7 10.5-3.6 22 .1 32.3L49.3 441.7c6.4 4.6 14.9 8.8 25.4 12.1l10.1-94.3c9.5 6.5 20.6 9.2 31.3 8.3l-10 92.9c12.5 1.8 25.3 2.6 37.8 3v-108c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8c1.9 2.6 4.1 4.9 6.4 7v108c12.5-.4 25.4-1.3 37.8-3l-10-92.9c10.7 .9 21.8-1.7 31.3-8.3l10.1 94.3c10.6-3.4 19-7.5 25.4-12.1L253.2 336.3c3.7-10.3 3.8-21.7 .1-32.3H296zM24 240H160 296c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBoxCheck = {
  prefix: 'far',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M248 80h94.4c6.3 0 12.1 3.7 14.6 9.5L388.4 160H248V80zM48 208H400V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208zm152-48H59.6L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM337 265c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z"]
};
var faBullhorn = {
  prefix: 'far',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M432 73.9L421.3 84.6C364.5 141.4 288.1 174 208 175.9v.1V304v0 .1c80.1 1.9 156.5 34.5 213.3 91.3L432 406.1V73.9zM160 128h40.7c70 0 137.2-27.8 186.7-77.3l38-38C445.5-7.5 480 6.8 480 35.3V179.6c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4V444.7c0 28.5-34.5 42.8-54.6 22.6l-38-38c-47.8-47.8-112-75.4-179.4-77.2V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56l0-104c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h96zM112 352V456c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V352H112zM64 176c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16l0 0h48 48V176l-96 0z"]
};
var faSteak = {
  prefix: 'far',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M301.5 72.6c-15.9 14.8-25.5 34.1-32.8 50.6c-4.2 9.6-7.7 18-10.9 25.7l-1.3 3.2c-9.3 22.5-18.4 44.6-39.1 65.3c-26.6 26.6-56.8 42.7-81.6 55.3c-2.8 1.4-5.5 2.8-8.1 4.1l0 0c-22.4 11.4-39.6 20.1-55.1 32.5C57.7 321.2 48 337.8 48 360c0 50 42.8 75.3 77.6 87.3C162.2 459.8 206.1 464 240 464c70.2 0 140.7-26.7 194-66.3c52.5-39.1 94-95.4 94-157.7c0-48.1-19-95-47-130c-27.6-34.5-67.9-62-113-62c-27.4 0-49.4 8.6-66.5 24.6zM268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416c-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zM416 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faLocationCrosshairsSlash = {
  prefix: 'far',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c13.4-22.3 22.4-47.6 25.8-74.6H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H510.5C499.7 145.2 430.8 76.3 344 65.5V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V65.5c-43.1 5.4-81.8 25-111.1 54.1L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-22 0-42.2 7.4-58.4 19.8l-38.6-30.2zM367.5 262.8l-65.5-51.3c5.5-2.2 11.6-3.5 17.9-3.5c26.5 0 48 21.5 48 48c0 2.3-.2 4.6-.5 6.8zm47.4 160.2l-41.9-33c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2l-41.9-33c-2.7 9.5-4.7 19.2-6 29.3H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h41.5c10.8 86.8 79.7 155.7 166.5 166.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V446.5c25.5-3.2 49.5-11.4 70.9-23.6z"]
};
var faLocationSlash = faLocationCrosshairsSlash;
var faPersonDolly = {
  prefix: 'far',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM0 340.3L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-109.9L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3zM48 187.2C48 181 53 176 59.2 176c4.5 0 8.9 1.1 12.8 3V295.2L51.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3V187.2zm72 145.7V246.2l15.1 23.5c7.4 11.4 20 18.4 33.6 18.4h54.5l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1L211.3 240H173.1l-49.3-76.7c-14.1-22-38.5-35.3-64.6-35.3C26.5 128 0 154.5 0 187.2v85.3c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L160.7 379c-1.5-10.2-6.8-19.4-14.9-25.8L120 332.9zM288 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm69.4-55.8L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3z"]
};
var faGlobe = {
  prefix: 'far',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M256 464c7.4 0 27-7.2 47.6-48.4c8.8-17.7 16.4-39.2 22-63.6H186.4c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM178.5 304h155c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48h-155c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm7.9-144H325.6c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm195.3 48c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48h76.7c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48H381.8zm58.8-48c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4h65.9zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4h65.9zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48h76.7c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48H53.6zM342.1 445.4c42.3-19.3 77-52.3 98.4-93.4H374.7c-7.3 35.9-18.5 67.7-32.6 93.4zm-172.2 0c-14.1-25.6-25.3-57.5-32.6-93.4H71.4c21.4 41.1 56.1 74.1 98.4 93.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"]
};
var faSynagogue = {
  prefix: 'far',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", "M305.1 5.2c8.7-6.9 21-6.9 29.7 0L462.5 105.9C483.7 122.6 496 148.1 496 175v63l31-31c9.4-9.4 24.6-9.4 33.9 0l62.6 62.6c10.5 10.5 16.4 24.7 16.4 39.6V440c0 39.8-32.2 72-72 72H472 384 256 168 72c-39.8 0-72-32.2-72-72V309.3c0-14.9 5.9-29.1 16.4-39.6L79 207c9.4-9.4 24.6-9.4 33.9 0l31 31V175c0-26.9 12.3-52.4 33.5-69.1L305.1 5.2zM496 464h72c13.3 0 24-10.7 24-24V309.3c0-2.1-.8-4.2-2.3-5.7L544 257.9l-45.7 45.7c-1.5 1.5-2.3 3.5-2.3 5.7V464zM448 175c0-12.2-5.6-23.8-15.2-31.4L320 54.6l-112.8 89c-9.6 7.6-15.2 19.2-15.2 31.4V309.3 464h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80h64V309.3 175zM144 309.3c0-2.1-.8-4.2-2.3-5.7L96 257.9 50.3 303.6c-1.5 1.5-2.3 3.5-2.3 5.7V440c0 13.3 10.7 24 24 24h72V309.3zM327 124.3l15.9 28.1 32.3-.3c6.2-.1 10.1 6.7 7 12.1L365.7 192l16.4 27.8c3.2 5.4-.7 12.1-7 12.1l-32.3-.3L327 259.7c-3.1 5.4-10.9 5.4-13.9 0l-15.9-28.1-32.3 .3c-6.2 .1-10.1-6.7-7-12.1L274.3 192l-16.4-27.8c-3.2-5.4 .7-12.1 7-12.1l32.3 .3L313 124.3c3.1-5.4 10.9-5.4 13.9 0z"]
};
var faFileChartColumn = {
  prefix: 'far',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM216 280c0-13.3-10.7-24-24-24s-24 10.7-24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V280zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V312zM128 344c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V344z"]
};
var faFileChartLine = faFileChartColumn;
var faPersonHalfDress = {
  prefix: 'far',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", "M154 .4A48 48 0 1 1 166 95.6 48 48 0 1 1 154 .4zM176 352V304h0V176.1l0 0V128c30.8 .8 59.1 17.7 74.3 44.6l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h0zM62.9 184.6c17.1-30.3 47.2-50.6 81.1-55.5V237.7L113.3 336H144v48h0V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H69.8c-10.8 0-18.5-10.5-15.3-20.8l46.3-148L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5z"]
};
var faFolderImage = {
  prefix: 'far',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM160 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm155.2 9.6c-4.5-6-11.6-9.6-19.2-9.6s-14.7 3.6-19.2 9.6l-54.2 72.2L202.7 265c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1l-96-128z"]
};
var faCalendarPen = {
  prefix: 'far',
  iconName: 'calendar-pen',
  icon: [512, 512, ["calendar-edit"], "f333", "M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zm-91.2 51c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L272.6 258 287.5 243c14.7-14.7 38.6-14.7 53.3 0zM178.1 352.5L250 280.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.6c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faCalendarEdit = faCalendarPen;
var faRoadBridge = {
  prefix: 'far',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", "M576 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H504V408c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H384c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h72v56c0 13.3 10.7 24 24 24s24-10.7 24-24V48h72zm0-48H384c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM480 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24zM24 96C10.7 96 0 106.7 0 120s10.7 24 24 24H72v64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H96 224h64V208H248V144h40V96H24zM272 304c-57.4 0-104 46.6-104 104v56H120V400c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48v72c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V408c0-30.9 25.1-56 56-56h16V304H272zM200 144v64H120V144h80z"]
};
var faFaceSmileTear = {
  prefix: 'far',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M338.7 446.9c4.3 .7 8.8 1.1 13.3 1.1c43.4 0 80-34.6 80-79c0-.7 0-1.4 0-2c20.3-32.1 32-70.2 32-111c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c29.4 0 57.4-6.1 82.7-17.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm136.3 61.9c10-8.7 25.2-7.6 33.9 2.4C187 339.8 215.5 360 256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24c-58 0-98.8-29.4-122.1-56.3c-8.7-10-7.6-25.2 2.4-33.9zM352 416c-26.5 0-48-21-48-47c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C371.4 308.6 400 349 400 369c0 26-21.5 47-48 47zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faMessagePlus = {
  prefix: 'far',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faCommentAltPlus = faMessagePlus;
var faLocationArrow = {
  prefix: 'far',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", "M224 208H129.4l241.4-98.7L272 350.6V256c0-26.5-21.5-48-48-48zm-48 48h48v48V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H176z"]
};
var faC = {
  prefix: 'far',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M343.5 131.7C275.8 63 166 63 98.3 131.7s-67.7 180 0 248.7s177.5 68.7 245.2 0c9.3-9.4 24.4-9.4 33.7 0s9.3 24.7 0 34.2c-86.3 87.5-226.3 87.5-312.6 0s-86.3-229.5 0-317s226.3-87.5 312.6 0c9.3 9.4 9.3 24.7 0 34.2s-24.4 9.4-33.7 0z"]
};
var faTabletButton = {
  prefix: 'far',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPersonDressFairy = {
  prefix: 'far',
  iconName: 'person-dress-fairy',
  icon: [640, 512, [], "e607", "M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm48.3 144c-7.1 0-13.4 4.7-15.4 11.6L255.6 336H384.4L351.1 219.6c-2-6.9-8.2-11.6-15.4-11.6H304.3zm0-48h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H384V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H304V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H234.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4c-14.1 8-26.1 19.5-34.7 33.5C181.6 120.7 119 85.2 48 80.5V112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78c32.1-.2 61.9-9.7 87-26.2c7.2 4.6 15.4 7.9 24.3 9.3v32.1C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32zM417.6 173.9c-8.6-14-20.6-25.5-34.7-33.5C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528c-41.2 0-79.7-12-112-32.7V415.2c8.9-1.4 17.1-4.7 24.3-9.3c25 16.4 54.9 26 87 26.2c-2.9-29-13.5-55.7-29.7-78l-13.6-18.7c-7.6-10.4-5.6-25 4.5-33L506.6 288C558.7 246.9 592 183.4 592 112V80.5c-71 4.7-133.6 40.2-174.4 93.3z"]
};
var faRectangleHistoryCircleUser = {
  prefix: 'far',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", "M64 464l284.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-26.2 0-51.1 5.7-73.4 16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24H392zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7H463.4c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faBuildingLock = {
  prefix: 'far',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M64 48H320c8.8 0 16 7.2 16 16V309.7c4.6-5.2 10-9.6 16-13.1V272c0-30.5 12.2-58.2 32-78.4V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5V464H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H232zm232 24c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faChartLineUp = {
  prefix: 'far',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zm272 96c0 13.3 10.7 24 24 24h54.1L304 270.1l-79-79c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 79 79c9.4 9.4 24.6 9.4 33.9 0l111-111V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24z"]
};
var faMailbox = {
  prefix: 'far',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M48 208c0-53 43-96 96-96s96 43 96 96V400H64c-8.8 0-16-7.2-16-16V208zM240 448h48H512c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H144C64.5 64 0 128.5 0 208V384c0 35.3 28.7 64 64 64H240zm48-240c0-36.9-13.9-70.5-36.7-96H432c53 0 96 43 96 96V384c0 8.8-7.2 16-16 16H288V208zM104 192c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H104zm256 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H440 360z"]
};
var faTruckBolt = {
  prefix: 'far',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", "M352 48c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H320 243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H352zm32 368c0 53 43 96 96 96s96-43 96-96h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V245.3c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3C487.8 101.9 473.6 96 458.7 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96h64 32 24 8zM557.7 239.6c.1 .1 .3 .3 .4 .4H416V144h42.7c2.1 0 4.2 .8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM267.2 84.6c-5.3-5.2-13.4-6.1-19.7-2.2l-128 80c-6.1 3.8-8.9 11.1-6.9 18s8.2 11.6 15.4 11.6h51.7l-33.5 55.8c-3.8 6.3-2.8 14.5 2.5 19.6s13.4 6.1 19.7 2.2l128-80c6.1-3.8 8.9-11.1 6.9-18s-8.2-11.6-15.4-11.6H236.3l33.5-55.8c3.8-6.3 2.8-14.5-2.5-19.6z"]
};
var faPizzaSlice = {
  prefix: 'far',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M122.2 35.6L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L476.4 389.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9c-22.8-1.6-41.9 14-47.5 34.7zM144.6 138C264.3 152.7 359.3 247.7 374 367.4L61.2 450.8 144.6 138zm12.5-46.8l11.3-42.3C325.6 60.7 451.3 186.4 463.1 343.7l-42.3 11.3c-19.7-136.2-127.5-244-263.7-263.7zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faMoneyBillWave = {
  prefix: 'far',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4l0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5l0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192V368c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5V113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
};
var faChartArea = {
  prefix: 'far',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zM286.1 225.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1l27.3-27.3L432 257.8l0 78.2H144l0-92.1 80-80 62.1 62.1zM320 192l-33.9-33.9-39.4-39.4c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9V352c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V257.8c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-5.6 5.6L320 192z"]
};
var faAreaChart = faChartArea;
var faHouseFlag = {
  prefix: 'far',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M472 0c-13.3 0-24 10.7-24 24v8V192 512h48V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H496V24c0-13.3-10.7-24-24-24zM416 133L286.3 36.7c-8.5-6.3-20.1-6.3-28.6 0l-248 184c-10.6 7.9-12.9 22.9-5 33.6s22.9 12.9 33.6 5L64 240.2V432c0 44.2 35.8 80 80 80l256 0c5.5 0 10.8-.6 16-1.6V459.7c-4.7 2.7-10.2 4.3-16 4.3H352V344c0-22.1-17.9-40-40-40H232c-22.1 0-40 17.9-40 40V464H144c-17.7 0-32-14.3-32-32V204.6L272 85.9 416 192.7V133zM304 352V464l-64 0V352h64z"]
};
var faCircleThreeQuartersStroke = {
  prefix: 'far',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M256 48V224c0 17.7 14.3 32 32 32H464c0-114.9-93.1-208-208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPersonCircleMinus = {
  prefix: 'far',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1H146.3c-.8 0-1.5 0-2.3 .1zM144 352V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144zm144 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faScalpel = {
  prefix: 'far',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", "M200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L200 247.2l5.6-6.7 .4-.5L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1l-36.7-31c4-4.8 6.3-10.9 6.3-17.1v-4C464 58.1 453.9 48 441.4 48c-6.7 0-13 2.9-17.3 8L268.9 240h63.8L457.7 91.7l36.7 31L369.3 271c-9.1 10.8-22.5 17-36.7 17H228.4h-.7H219 200zm-35.3 36.7l4.7-4.7H176h96 16v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160z"]
};
var faBan = {
  prefix: 'far',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faCancel = faBan;
var faBellExclamation = {
  prefix: 'far',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", "M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM256 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-168c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V152z"]
};
var faCircleBookmark = {
  prefix: 'far',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176V368c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4V176c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48z"]
};
var faBookmarkCircle = faCircleBookmark;
var faEggFried = {
  prefix: 'far',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M403.9 162.5c-26.9-6.9-56.4-20.3-82.6-35.6s-52.4-34.3-71.6-54.3c-30.6-31.9-81.3-32.9-113.1-2.2c-14.5 14-22.6 32-24.3 50.6C107.7 173.6 92.7 244.5 63 296c-30.9 53.6-12.6 122.1 41 153s122.1 12.6 153-41c14.7-25.4 38.1-45.6 61.1-59.7c23.3-14.3 50.6-25.3 77.1-29c12.7-1.8 25.3-6.7 36.4-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.4-27.2-25.4-44.4-29.8zM284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM112 240a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112-32c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72c0 8.8 7.2 16 16 16s16-7.2 16-16c0-22.1 17.9-40 40-40z"]
};
var faFaceWeary = {
  prefix: 'far',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm34.8-155.6c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faUniformMartialArts = {
  prefix: 'far',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4V392c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V248.4c0-6.7 1.7-13.4 5-19.3l62-112.8c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2V288H160V221.4l-16 29.1V392c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2C104.3 23.8 144.6 0 188.4 0h.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1c9 0 17.2 5 21.3 13L320 127.1 378.7 13C382.8 5 391 0 400 0h.1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5V392c0 30.9-25.1 56-56 56H552c-30.9 0-56-25.1-56-56V250.5l-16-29.1V288H432V128c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7l62 112.8-21 11.6 21-11.6c3.2 5.9 5 12.5 5 19.3V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3C502.1 62.3 477.9 48 451.6 48h-.1-.1-.1-.1-.1-.1-.1H451 451h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H450h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H449h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H448h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H447h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H446h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H445h-.1-.1-.1-.1-.1-.1-.1-.1-.1H444 444h-.1-.1-.1-.1-.1-.1-.1-.1-.1H443h-.1-.1-.1-.1-.1-.1-.1-.1-.1H442h-.1-.1-.1-.1-.1-.1-.1-.1H441h-.1-.1-.1-.1-.1-.1-.1-.1-.1H440h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H438h-.1-.1-.1-.1-.1-.1-.1-.1H437h-.1-.1-.1-.1-.1-.1-.1-.1H436h-.1-.1-.1-.1-.1-.1-.1-.1H435h-.1-.1-.1-.1-.1-.1-.1-.1H434h-.1-.1-.1-.1-.1-.1-.1-.1H433h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H431h-.1-.1-.1-.1-.1-.1-.1-.1H430h-.1-.1-.1-.1-.1-.1-.1-.1H429h-.1-.1-.1-.1-.1-.1-.1H428h-.1-.1-.1-.1-.1-.1-.1-.1H427h-.1-.1-.1-.1-.1-.1-.1H426h-.1-.1-.1-.1-.1-.1-.1-.1H425h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H423h-.1-.1-.1-.1-.1-.1-.1-.1H422h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H420h-.1-.1-.1-.1-.1-.1-.1-.1H419h-.1-.1-.1-.1-.1-.1-.1-.1H418h-.1-.1-.1-.1-.1-.1-.1-.1H417h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H415h-.1-.1-.1L341.3 190.5 291.2 288h-54L293 179.6 225.4 48h-.1-.1H225h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H223h-.1-.1-.1-.1-.1-.1-.1-.1H222h-.1-.1-.1-.1-.1-.1-.1-.1H221h-.1-.1-.1-.1-.1-.1-.1-.1H220h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H218h-.1-.1-.1-.1-.1-.1-.1-.1H217h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H215h-.1-.1-.1-.1-.1-.1-.1-.1H214h-.1-.1-.1-.1-.1-.1-.1H213h-.1-.1-.1-.1-.1-.1-.1-.1H212h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H210h-.1-.1-.1-.1-.1-.1-.1-.1H209h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H207h-.1-.1-.1-.1-.1-.1-.1-.1H206h-.1-.1-.1-.1-.1-.1-.1-.1H205h-.1-.1-.1-.1-.1-.1-.1-.1H204h-.1-.1-.1-.1-.1-.1-.1-.1H203h-.1-.1-.1-.1-.1-.1-.1-.1H202h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H200h-.1-.1-.1-.1-.1-.1-.1-.1-.1H199h-.1-.1-.1-.1-.1-.1-.1-.1H198h-.1-.1-.1-.1-.1-.1-.1-.1-.1H197h-.1-.1-.1-.1-.1-.1-.1-.1-.1H196 196h-.1-.1-.1-.1-.1-.1-.1-.1-.1H195h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H194h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H193h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H192h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H191h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H190h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H189h-.1-.1-.1-.1-.1-.1-.1-.1-.1zM160 384h48v64c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384zm16-64H320 464h16v32H464 349.9l47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2L290.1 352H176 160V320h16z"]
};
var faCameraRotate = {
  prefix: 'far',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", "M263.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L201.4 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H438.6l-8.6-25.7C422.4 47.4 401 32 376.9 32H263.1zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5H376.9c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4H512c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h90.7c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM362.4 237.6l-15 15c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3H416c8.8 0 16-7.2 16-16V195.3c0-6.2-5.1-11.3-11.3-11.3c-3 0-5.9 1.2-8 3.3l-16.1 16.1C375.1 185.8 348 176 320 176c-32 0-62.6 12.7-85.3 35.3L231 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l3.7-3.7C282.3 231.6 300.8 224 320 224c15.3 0 30.1 4.8 42.4 13.6zM208 380.7c0 6.2 5.1 11.3 11.3 11.3c3 0 5.9-1.2 8-3.3l16.1-16.1C264.9 390.2 292 400 320 400c32 0 62.6-12.7 85.3-35.3L409 361c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-3.7 3.7C357.7 344.4 339.2 352 320 352c-15.3 0-30.1-4.8-42.4-13.6l15-15c2.1-2.1 3.3-5 3.3-8c0-6.2-5.1-11.3-11.3-11.3H224c-8.8 0-16 7.2-16 16v60.7z"]
};
var faSunDust = {
  prefix: 'far',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 0 0 37.6-37.6c-3.4-3.4-7.7-5.7-12.6-6.6L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c.9 4.9 3.3 9.3 6.6 12.6l37.6-37.6 0 0L375.7 19.7zM256 144c-61.9 0-112 50.1-112 112c0 30.9 12.5 58.9 32.8 79.2l33.9-33.9C199.2 289.7 192 273.7 192 256c0-35.3 28.7-64 64-64c17.7 0 33.7 7.2 45.3 18.7l33.9-33.9C314.9 156.5 286.9 144 256 144zm256 16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCommentText = {
  prefix: 'far',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM184 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V312c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 184z"]
};
var faSprayCanSparkles = {
  prefix: 'far',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM96 208c-26.5 0-48 21.5-48 48V448c0 8.8 7.2 16 16 16H256c8.8 0 16-7.2 16-16V256c0-26.5-21.5-48-48-48H96zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zM381.8 51.6L352 64 339.6 93.8C339 95 337.4 96 336 96s-3-1-3.6-2.2L320 64 290.2 51.6C289 51 288 49.4 288 48c0-1.4 1-3 2.2-3.6L320 32 332.4 2.2C333 1 334.6 0 336 0s3 1 3.6 2.2L352 32l29.8 12.4C383 45 384 46.6 384 48c0 1.4-1 3-2.2 3.6zM448 64L418.2 51.6C417 51 416 49.4 416 48c0-1.4 1-3 2.2-3.6L448 32 460.4 2.2C461 1 462.6 0 464 0s3 1 3.6 2.2L480 32l29.8 12.4C511 45 512 46.6 512 48c0 1.4-1 3-2.2 3.6L480 64 467.6 93.8C467 95 465.4 96 464 96s-3-1-3.6-2.2L448 64zm32 160l29.8 12.4c1.2 .6 2.2 2.2 2.2 3.6c0 1.4-1 3-2.2 3.6L480 256l-12.4 29.8c-.6 1.2-2.2 2.2-3.6 2.2s-3-1-3.6-2.2L448 256l-29.8-12.4c-1.2-.6-2.2-2.2-2.2-3.6c0-1.4 1-3 2.2-3.6L448 224l12.4-29.8c.6-1.2 2.2-2.2 3.6-2.2s3 1 3.6 2.2L480 224zm-34.2-76.4L416 160l-12.4 29.8c-.6 1.2-2.2 2.2-3.6 2.2s-3-1-3.6-2.2L384 160l-29.8-12.4c-1.2-.6-2.2-2.2-2.2-3.6c0-1.4 1-3 2.2-3.6L384 128l12.4-29.8C397 97 398.6 96 400 96s3 1 3.6 2.2L416 128l29.8 12.4c1.2 .6 2.2 2.2 2.2 3.6c0 1.4-1 3-2.2 3.6zM160 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faAirFreshener = faSprayCanSparkles;
var faSignalBars = {
  prefix: 'far',
  iconName: 'signal-bars',
  icon: [576, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M528 448V64c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16zM448 64c0-35.3 28.7-64 64-64s64 28.7 64 64V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V64zM376 448V192c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16zM296 192c0-35.3 28.7-64 64-64s64 28.7 64 64V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V192zM208 464c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16s-16 7.2-16 16V448c0 8.8 7.2 16 16 16zm0-208c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V320c0-35.3 28.7-64 64-64zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16A64 64 0 1 1 0 448a64 64 0 1 1 128 0z"]
};
var faSignalAlt = faSignalBars;
var faSignalAlt4 = faSignalBars;
var faSignalBarsStrong = faSignalBars;
var faDiamondExclamation = {
  prefix: 'far',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", "M50.9 249L249 50.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9s-5.2-1-7-2.9L50.9 263c-1.9-1.9-2.9-4.4-2.9-7s1-5.2 2.9-7zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17zm41 111c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faStar = {
  prefix: 'far',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"]
};
var faDialMin = {
  prefix: 'far',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM271 271l-77.4 77.4c-27.8-43.4-22.8-101.7 15.1-139.6c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4c-37.9 37.9-96.2 43-139.6 15.1L305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faRepeat = {
  prefix: 'far',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M22.8 280C9.6 279.3-.6 268 0 254.8l.4-8C5.3 148.9 86.2 72 184.2 72H304l0-36.4C304 15.9 319.9 0 339.6 0c8.8 0 17.3 3.3 23.8 9.1l76.7 69c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-76.7 69c-6.5 5.9-15 9.1-23.8 9.1c-19.6 0-35.6-15.9-35.6-35.6V120H184.2C111.7 120 52 176.8 48.4 249.2l-.4 8C47.3 270.4 36 280.6 22.8 280zM352 128.5L388.1 96 352 63.5l0 65zM489.2 232c13.2 .7 23.4 11.9 22.8 25.2l-.4 8C506.7 363.1 425.8 440 327.8 440L208 440v36.4c0 19.6-15.9 35.6-35.6 35.6c-8.8 0-17.3-3.3-23.8-9.1l-76.7-69c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l76.7-69c6.5-5.9 15-9.1 23.8-9.1c19.6 0 35.6 15.9 35.6 35.6V392l119.8 0c72.5 0 132.2-56.8 135.8-129.2l.4-8c.7-13.2 11.9-23.4 25.2-22.8zM160 383.5L123.9 416 160 448.5v-65z"]
};
var faCross = {
  prefix: 'far',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M112 48c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H272V464c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48V272H48c-26.5 0-48-21.5-48-48V160c0-26.5 21.5-48 48-48h64V48zm112 0H160v88c0 13.3-10.7 24-24 24H48v64h88c13.3 0 24 10.7 24 24V464h64V248c0-13.3 10.7-24 24-24h88V160H248c-13.3 0-24-10.7-24-24V48z"]
};
var faPageCaretDown = {
  prefix: 'far',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16V448zm272 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z"]
};
var faFileCaretDown = faPageCaretDown;
var faBox = {
  prefix: 'far',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M342.4 80H248v80H388.4L357 89.5c-2.6-5.8-8.3-9.5-14.6-9.5zM400 208H48V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V208zM59.6 160H200V80H105.6c-6.3 0-12.1 3.7-14.6 9.5L59.6 160zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38H342.4z"]
};
var faVenusMars = {
  prefix: 'far',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M176 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM352 176c0 89.1-66.2 162.7-152 174.4V400h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H200v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V350.4C66.2 338.7 0 265.1 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c14.6-7.6 28.1-16.8 40.4-27.5C335.2 354.8 366 368 400 368c70.7 0 128-57.3 128-128s-57.3-128-128-128c-8.6 0-17.1 .9-25.2 2.5c-4.9-15.8-11.6-30.7-19.9-44.7C369.3 66 384.4 64 400 64c39.9 0 76.8 13.3 106.3 35.7L558.1 48H504c-13.3 0-24-10.7-24-24s10.7-24 24-24H616c13.3 0 24 10.7 24 24V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-51.7 51.7C562.7 163.2 576 200.1 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"]
};
var faClockSevenThirty = {
  prefix: 'far',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V335.3l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faArrowPointer = {
  prefix: 'far',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", "M144 272h85.8L48 110.4V356.8l59.9-68.4C117 278 130.2 272 144 272zM0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1H170.5l59.1 126.8c5.6 12 .4 26.3-11.6 31.9s-26.3 .4-31.9-11.6L126.7 339.7 38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22z"]
};
var faMousePointer = faArrowPointer;
var faClockFourThirty = {
  prefix: 'far',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V300.8L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faSignalBarsGood = {
  prefix: 'far',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", "M376 192V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16-64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64s64-28.7 64-64V192c0-35.3-28.7-64-64-64zM208 464c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16s16 7.2 16 16V448c0 8.8-7.2 16-16 16zm0-208c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64s64-28.7 64-64V320c0-35.3-28.7-64-64-64zM64 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 448a64 64 0 1 0 128 0A64 64 0 1 0 0 448z"]
};
var faSignalAlt3 = faSignalBarsGood;
var faCactus = {
  prefix: 'far',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M304 448c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V96c0-26.5 21.5-48 48-48s48 21.5 48 48V448zM256 0c-53 0-96 43-96 96V224H112c-8.8 0-16-7.2-16-16V144c0-26.5-21.5-48-48-48S0 117.5 0 144v64c0 61.9 50.1 112 112 112h48V448c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64h48c61.9 0 112-50.1 112-112V272c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8-7.2 16-16 16H352V96c0-53-43-96-96-96zm0 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLightbulbGear = {
  prefix: 'far',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M314.4 213.6c3.6-11.9 5.6-24.5 5.6-37.6c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3c-17.8 7.7-28 25.6-28 43.3v.9c-7.7-4.3-16.7-6.4-25.6-5.9zM245.6 416c3.5 9.2 7.7 18.3 12.8 27c2.9 5 6 9.9 9.4 14.6C257.1 489.2 227.2 512 192 512c-44.2 0-80-35.8-80-80V416H245.6zM144 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48zm228 42.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7l0 17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V467.8c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
var faMaximize = {
  prefix: 'far',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", "M156.1 80H80v76.1L156.1 80zM32 192V64c0-17.7 14.3-32 32-32H192c17.7 0 32 14.3 32 32v2.7c0 8.5-3.4 16.6-9.4 22.6L169 135l87 87 87-87L297.4 89.4c-6-6-9.4-14.1-9.4-22.6V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32h-2.7c-8.5 0-16.6-3.4-22.6-9.4L377 169l-87 87 87 87 45.7-45.7c6-6 14.1-9.4 22.6-9.4H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32v-2.7c0-8.5 3.4-16.6 9.4-22.6L343 377l-87-87-87 87 45.7 45.7c6 6 9.4 14.1 9.4 22.6V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h2.7c8.5 0 16.6 3.4 22.6 9.4L135 343l87-87-87-87L89.4 214.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32zM355.9 432H432V355.9L355.9 432zM80 355.9V432h76.1L80 355.9zM355.9 80L432 156.1V80H355.9z"]
};
var faExpandArrowsAlt = faMaximize;
var faChargingStation = {
  prefix: 'far',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M96 48c-8.8 0-16 7.2-16 16V464H272V64c0-8.8-7.2-16-16-16H96zM32 464V64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v28c0 15.5 12.5 28 28 28s28-12.5 28-28V268.3c-32.5-10.2-56-40.5-56-76.3V152c0-13.3 10.7-24 24-24h8V80c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16v48h8c13.3 0 24 10.7 24 24v40c0 35.8-23.5 66.1-56 76.3V372c0 42-34 76-76 76s-76-34-76-76V344c0-22.1-17.9-40-40-40h-8V464l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H272 80 32 24c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zM464 192c0 17.7 14.3 32 32 32s32-14.3 32-32V176H464v16zM222.9 117.9L199.6 176H240c6.7 0 12.8 4.2 15 10.6s.4 13.4-4.8 17.7l-96 80c-5.6 4.7-13.7 5-19.6 .7s-8.2-12.1-5.5-18.9L152.4 208H112c-6.7 0-12.8-4.2-15-10.6s-.4-13.4 4.8-17.7l96-80c5.6-4.7 13.7-5 19.6-.7s8.2 12.1 5.5 18.9z"]
};
var faShapes = {
  prefix: 'far',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M164.6 175.5l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H192c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2zM288 63.1L220.3 176H355.7L288 63.1zM464 320H336V448H464V320zM328 272H472c22.1 0 40 17.9 40 40V456c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V312c0-22.1 17.9-40 40-40zM208 384A80 80 0 1 0 48 384a80 80 0 1 0 160 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z"]
};
var faTriangleCircleSquare = faShapes;
var faPlaneTail = {
  prefix: 'far',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M.8 39L61.5 308.8l-15.5 4.3C18.8 320.5 0 345.2 0 373.4c0 26 16.1 49.3 40.4 58.5l196.1 74.4c10 3.8 20.5 5.7 31.2 5.7H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H267.7c-4.8 0-9.7-.9-14.2-2.6L57.4 387c-5.7-2.1-9.4-7.6-9.4-13.6c0-6.6 4.4-12.3 10.7-14.1L254 305.4c3.5-1 7-1.4 10.6-1.4H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H384L154.9 19.5C142.8 7 126.2 0 108.9 0H32C11.5 0-3.7 19 .8 39zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faGaugeSimpleMax = {
  prefix: 'far',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-30.9 25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56s-56-25.1-56-56z"]
};
var faTachometerFastest = faGaugeSimpleMax;
var faCircleU = {
  prefix: 'far',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168c0-13.3-10.7-24-24-24s-24 10.7-24 24V288c0 61.9 50.1 112 112 112s112-50.1 112-112V168c0-13.3-10.7-24-24-24s-24 10.7-24 24V288c0 35.3-28.7 64-64 64s-64-28.7-64-64V168z"]
};
var faShieldSlash = {
  prefix: 'far',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", "M174.2 111.2L320 49.4 503 127c5.9 2.5 9.1 7.8 9 12.8c-.3 52.8-13 127.8-52.2 195.3L174.2 111.2zM497.9 365c47.4-78.8 61.8-166.3 62.1-225c.1-26.2-16.3-47.9-38.3-57.2L333.4 2.9C329.2 1 324.7 0 320 0s-9.2 1-13.4 2.9L131 77.4 38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.9 365zM80.6 159.5c5.5 102 51.5 266.3 213.1 343.7c16.7 8 36.1 8 52.8 0c35.7-17.1 65.8-38.5 91.1-62.5l-38.2-30.1c-20.8 18.9-45.1 35.7-73.5 49.3c-3.6 1.7-7.8 1.7-11.3 0C195.8 403.1 147.9 290.6 133.3 201L80.6 159.5z"]
};
var faSquarePhoneHangup = {
  prefix: 'far',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM345.9 303.3c-4.8 7.6-15.1 10.7-24 7.4l-41.6-15.4c-7.9-2.9-12.7-10.1-11.8-17.7l2.6-23.3c-30.4-9.5-63.7-9.5-94.1 0l2.6 23.3c.8 7.6-4 14.8-11.8 17.7l-41.6 15.4c-8.9 3.3-19.2 .1-24-7.4L82.5 272.4c-4.3-6.8-3-15.3 3.1-20.8c76.4-68.8 200.3-68.8 276.7 0c6.1 5.5 7.4 14.1 3.1 20.8l-19.6 30.8z"]
};
var faPhoneSquareDown = faSquarePhoneHangup;
var faArrowUpLeft = {
  prefix: 'far',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", "M56 96c-13.3 0-24 10.7-24 24V360c0 13.3 10.7 24 24 24s24-10.7 24-24V177.9L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-231-231H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H56z"]
};
var faTransporter1 = {
  prefix: 'far',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 288h48V176h32V288h48V208.8l52.9 69.7c8 10.6 23.1 12.6 33.6 4.6s12.6-23.1 4.6-33.6l-65.7-86.7c-16.6-21.9-42.6-34.8-70.1-34.8H236.7c-27.5 0-53.5 12.9-70.1 34.8l-65.7 86.7c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6L192 208.8V288zM480 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160zM64 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 352 6.6 359.3C2.7 360.4 0 363.9 0 368s2.7 7.6 6.6 8.7L32 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 352zm56 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm56-144c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faPeanuts = {
  prefix: 'far',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", "M123 504.9c-16.8-19.6-27-45-27-72.9c0-5.2-.1-10.6-.1-16.1v0 0l0 0c-.6-55.4-1.3-125.1 52.8-179.2c26.5-26.5 59-43.2 94.7-49.8c22.9-4.6 39.5-10.9 50-21.5s16.9-27.1 21.5-50c1.6-8.9 3.9-17.5 6.7-26L299.2 38.9C284.4 5.8 245.7-9 212.6 5.7L161.7 28.3c-15 6.7-28 16.1-38.7 27.3c-10.6 11.2-19.3 24.6-25.2 39.9l-.2 .5c-5.8 15.3-8.3 31-7.9 46.4c.2 8.5 1.3 17 3.4 25.4c4.5 19.9 6.9 41-.4 60s-23.1 33.1-39.8 44.9c-7.2 4.9-13.7 10.5-19.5 16.6C22.7 300.5 14 314 8.1 329.4C2.2 344.7-.4 360.6 0 376c.4 15.5 3.8 31.1 10.5 46.2l22.7 50.9c14.7 33.1 53.5 48 86.6 33.2l3.2-1.4zM563 218.4l-.6 .6 0 0c-9.6 9.5-20.5 16.6-32.2 21.4l0 0c-6.4 2.7-13.2 4.7-20.2 5.9l-.4 .1-.4 .1c-26.6 5.3-63.2 15.3-91.3 43.4s-38.2 64.7-43.4 91.3l-.1 .4-.1 .4c-1.3 7-3.3 13.8-5.9 20.2l0 0c-4.8 11.5-11.8 22.3-21.1 31.9l0 0c-.2 .2-.5 .5-.7 .7c-.1 .1-.3 .3-.4 .4l32.7 33.2-32.7-33.2C328.1 453.1 303.4 464 276 464H208c-17.7 0-32-14.3-32-32V364c0-13.6 2.7-26.5 7.6-38.3l0 0c4.9-11.7 12.1-22.8 21.7-32.4c9.7-9.7 20.7-16.9 32.5-21.7l0 0c6.4-2.7 13.2-4.7 20.2-5.9l.4-.1 .4-.1c26.6-5.3 63.2-15.3 91.3-43.4s38.2-64.7 43.4-91.3l.1-.4 .1-.4c1.3-7 3.3-13.8 5.9-20.2l0 0c4.8-11.7 12-22.6 21.5-32.2l0 0 .3-.3c9.6-9.6 20.6-16.8 32.3-21.6l0 0C465.5 50.7 478.4 48 492 48h68c17.7 0 32 14.3 32 32v68c0 27.5-11 52.3-29 70.4l0 0zm34.1 33.8C623.6 225.4 640 188.6 640 148V80c0-44.2-35.8-80-80-80H492c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9zm-77.1-97a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-192 192a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 392a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM520 219.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 328a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z"]
};
var faShuffle = {
  prefix: 'far',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M425 31l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H352c-12.6 0-24.4 5.9-32 16l-46 61.3-30-40 37.6-50.1C298.2 117 324.3 104 352 104h78.1L391 65c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM204 322.7l-37.6 50.1C149.8 395 123.7 408 96 408H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96c12.6 0 24.4-5.9 32-16l46-61.3 30 40zM391 287c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H352c-27.7 0-53.8-13-70.4-35.2L128 168c-7.6-10.1-19.4-16-32-16H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96c27.7 0 53.8 13 70.4 35.2L320 344c7.6 10.1 19.4 16 32 16h78.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faRandom = faShuffle;
var faPersonRunning = {
  prefix: 'far',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", "M224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-85.3 60.6c14-3.5 28.7-3.5 42.7 0l95 23.7c19 4.8 34.2 19.1 39.9 37.9L336 234.4c1 3.4 4.1 5.6 7.6 5.6H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H343.6c-24.6 0-46.3-16-53.5-39.5l-5.6-18.2-28.1 84.4 32.1 18c16.5 9.3 24.2 28.8 18.6 46.8L270.9 495.2c-4 12.7-17.4 19.7-30.1 15.8s-19.7-17.4-15.7-30.1l34.2-109.5-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5l32.7-98-8.6-2.1c-6.4-1.6-13-1.6-19.4 0l-1.8 .5c-6 1.5-11.6 4.4-16.3 8.4L87.6 202.2c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8l44.5-38.2c10.4-8.9 22.7-15.2 35.9-18.6l1.8-.5zm75.1 182.1l38.3-115L225 169 191.1 270.5c-1.2 3.6 .3 7.6 3.7 9.5l19 10.7zM103.4 368l19.1-50.9c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-14.1 37.6c-5.9 15.6-20.8 25.9-37.4 25.9H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h79.4z"]
};
var faRunning = faPersonRunning;
var faMobileRetro = {
  prefix: 'far',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", "M256 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H256zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 160v64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32zM96 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faGripLinesVertical = {
  prefix: 'far',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M32 32C18.7 32 8 42.7 8 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24z"]
};
var faBinBottlesRecycle = {
  prefix: 'far',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16V24c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96H256c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192h32c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V66.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5H608h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7H135.1c-40.6 0-74.7-30.4-79.5-70.7L32 240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zm48.3 48l23 195.7c1.9 16.1 15.6 28.3 31.8 28.3H504.9c16.2 0 29.9-12.1 31.8-28.3l23-195.7H80.3zm228.1 70.1l-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7c-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4c15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4c-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2c-4.6 0-8.9 2.3-11.5 6.1zm-43.1 64.7l-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7c0 4.7 3.8 8.6 8.6 8.6h25.2c8.8 0 16 7.2 16 16s-7.2 16-16 16H264.6c-22.4 0-40.6-18.2-40.6-40.6c0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7c7.6 4.8 9.8 14.9 4.8 22.4zM353.7 400h20.9c4.8 0 8.6-3.9 8.6-8.6c0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4c7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4c0 22.4-18.2 40.6-40.6 40.6H353.7c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faArrowUpFromSquare = {
  prefix: 'far',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", "M273 7c-9.4-9.4-24.6-9.4-33.9 0L127 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l71-71V328c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l71 71c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72V104c0-39.8-32.2-72-72-72h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8c13.3 0 24 10.7 24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
};
var faFileDashedLine = {
  prefix: 'far',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", "M448 464H192c-8.8 0-16-7.2-16-16V368H128v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V368H464v80c0 8.8-7.2 16-16 16zm16-304v96h48V154.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64V256h48V64c0-8.8 7.2-16 16-16H352v80c0 17.7 14.3 32 32 32h80zM56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24H168c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H280zm192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H472z"]
};
var faPageBreak = faFileDashedLine;
var faBracketCurlyRight = {
  prefix: 'far',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M192 120c0-48.6-39.4-88-88-88H56C42.7 32 32 42.7 32 56s10.7 24 24 24h48c22.1 0 40 17.9 40 40v45.5c0 23.3 9.3 45.7 25.8 62.2L198.1 256l-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2V392c0 22.1-17.9 40-40 40H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c48.6 0 88-39.4 88-88V346.5c0-10.6 4.2-20.8 11.7-28.3L249 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3V120z"]
};
var faSpider = {
  prefix: 'far',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l68.8-22.9c-.8 3.2-1.5 6.4-2 9.7L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5l12.1-12.1C153.2 425.8 200.1 464 256 464s102.8-38.2 116.2-89.9l12.1 12.1c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-43.8-43.8c-.5-3.3-1.2-6.5-2-9.7l68.8 22.9c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L352 158.1c-.6-32.8-17.8-61.6-43.3-78.4c-5.8-3.8-13.1-4.9-19.8-3s-12.3 6.7-15.2 13L256 128.1 238.3 89.7c-2.9-6.3-8.5-11.1-15.2-13s-13.9-.8-19.8 3c-25.6 16.8-42.7 45.5-43.3 78.4l-32.3-32.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6zM208 160c0-5.5 .9-10.8 2.6-15.7l15.6 33.8c3.9 8.5 12.4 13.9 21.8 13.9h16c9.4 0 17.9-5.4 21.8-13.9l15.6-33.8c1.7 4.9 2.6 10.2 2.6 15.7v88c0 3.4-.4 6.7-1 9.9c-1.6 7.6 .6 15.5 5.9 21.2C320.8 292 328 309.1 328 328v16c0 39.8-32.2 72-72 72s-72-32.2-72-72V328c0-18.9 7.2-36 19.1-48.9c5.3-5.7 7.5-13.6 5.9-21.2c-.7-3.2-1-6.5-1-9.9V160z"]
};
var faClockThree = {
  prefix: 'far',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faHandsBound = {
  prefix: 'far',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", "M16 72V206.6c0 22.2 7.4 43.7 21.1 61.2l69.2 88.6C100 360.7 96 367.9 96 376c0 13.3 10.7 24 24 24H520c13.3 0 24-10.7 24-24c0-8.1-4-15.3-10.2-19.7l69.2-88.6c13.7-17.5 21.1-39 21.1-61.2V72c0-39.8-32.2-72-72-72s-72 32.2-72 72v66.3c-.5-.5-1-.9-1.6-1.4c-29.8-25.2-74.3-22-100.2 7.2l-46.7 52.5c-4.2 4.7-8 9.7-11.5 14.8c-3.5-5.2-7.3-10.1-11.5-14.8l-46.7-52.5c-25.9-29.2-70.4-32.4-100.2-7.2c-.5 .5-1.1 .9-1.6 1.4V72c0-39.8-32.2-72-72-72S16 32.2 16 72zM163.8 352L74.9 238.2C67.8 229.2 64 218 64 206.6V72c0-13.3 10.7-24 24-24s24 10.7 24 24V179.4l71.5 95.3c.1 .2 .3 .4 .4 .6c7.5 9.4 20.9 11.6 31 5c11.4-7.4 14.1-22.9 6-33.7c-.1-.2-.3-.4-.4-.6L189.3 207c-2.7-3.3-4.3-7.2-5-11.2c-1.3-8.1 1.6-16.6 8.2-22.2c9.9-8.4 24.8-7.3 33.4 2.4l46.7 52.5c15.1 16.9 23.4 38.8 23.4 61.5V352H163.8zM344 352V290.1c0-22.7 8.3-44.6 23.4-61.5l46.7-52.5c8.6-9.7 23.5-10.8 33.4-2.4c6.7 5.6 9.5 14.1 8.2 22.2c-.6 4-2.3 7.8-5 11.2l-31.3 39.1c-.2 .2-.3 .4-.4 .6c-8.1 10.8-5.4 26.3 6 33.7c10.1 6.6 23.5 4.3 31-5c.2-.2 .3-.4 .4-.6L528 179.4V72c0-13.3 10.7-24 24-24s24 10.7 24 24V206.6c0 11.5-3.8 22.6-10.9 31.7L476.2 352H344zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v16c0 13.3 10.7 24 24 24s24-10.7 24-24V472H296v16c0 13.3 10.7 24 24 24s24-10.7 24-24V472H464v16c0 13.3 10.7 24 24 24s24-10.7 24-24V472h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]
};
var faScalpelLineDashed = {
  prefix: 'far',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", "M441.4 48c-6.7 0-13 2.9-17.3 8L268.9 240h63.8L457.7 91.7l36.7 31L369.3 271c-9.1 10.8-22.5 17-36.7 17H228.4h-.7H219 200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L200 247.2l5.6-6.7 .4-.5L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1l-36.7-31c4-4.8 6.3-10.9 6.3-17.1v-4C464 58.1 453.9 48 441.4 48zm-272 272H176h96 16v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160 4.7-4.7zM248 464h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24zm128 0h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h48z"]
};
var faScalpelPath = faScalpelLineDashed;
var faFileInvoiceDollar = {
  prefix: 'far',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M336 448V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 215.6c11 0 20 9 20 20v10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8v10.1c0 11-9 20-20 20s-20-9-20-20V409.7c-10-1.9-19.3-4.8-27.5-7.3l0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2l0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3V235.6c0-11 9-20 20-20zM96 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPipeSmoking = {
  prefix: 'far',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M586.8 48c-36.4 0-70.1 19-89 50.2L412.1 239.8c13 16 14.6 39.3 2.4 57.2L318.7 438.3c-31.3 46.1-83.3 73.7-139 73.7H168C75.2 512 0 436.8 0 344V232c0-30.9 25.1-56 56-56H216c30.9 0 56 25.1 56 56v9.4l23-29.9c12.3-16 32.9-22.2 51.4-16.9l111.2-138C486.4 20.8 529.9 0 575.9 0h10.9H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H586.8zM56 224c-4.4 0-8 3.6-8 8V344c0 66.3 53.7 120 120 120h11.7c39.8 0 77-19.7 99.3-52.6l95.9-141.3L333 240.8l-66 85.8c-6.3 8.1-17 11.4-26.8 8.1s-16.3-12.4-16.3-22.7V232c0-4.4-3.6-8-8-8H56z"]
};
var faFaceAstonished = {
  prefix: 'far',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 48c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faWindow = {
  prefix: 'far',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64 48 16V416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V224 208 160 96zM464 224H48l0 192c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-192zM96 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPlaneCircleExclamation = {
  prefix: 'far',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2l0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23 0 0 0 0 0 0-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0 0 0 0 0 0 0-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1V297.5c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2V128c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2V303.7c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faEar = {
  prefix: 'far',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192V368c0 53 43 96 96 96s96-43 96-96c0-21.7 10.9-42.6 29.8-54.8C309.7 287.5 336 242.8 336 192zm48 0c0 67.8-35.1 127.4-88.2 161.5c-4.9 3.2-7.8 8.6-7.8 14.5c0 79.5-64.5 144-144 144S0 447.5 0 368V192C0 86 86 0 192 0S384 86 384 192zm-256 0v20.2c0 3 1.7 5.8 4.4 7.2l14 7c18.1 9.1 29.5 27.6 29.5 47.8c0 15.9-7 30.9-19.2 41.1l-37.4 31.2c-10.2 8.5-25.3 7.1-33.8-3.1s-7.1-25.3 3.1-33.8L126 278.4c1.2-1 2-2.6 2-4.2c0-2.1-1.2-4-3-4.9l-14-7c-19-9.5-31-28.9-31-50.1V192c0-61.9 50.1-112 112-112s112 50.1 112 112v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
};
var faFileLock = {
  prefix: 'far',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M320 464H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V309.7c4.6-5.2 10-9.6 16-13.1V272c0-30.5 12.2-58.2 32-78.4V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5V464zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faDiagramVenn = {
  prefix: 'far',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M270 425.9c-47.8-41.1-78-102-78-169.9s30.3-128.8 78-169.9c-14.7-4-30.1-6.1-46-6.1C126.8 80 48 158.8 48 256s78.8 176 176 176c15.9 0 31.4-2.1 46-6.1zM252 320H388c5.9-15.1 9.8-31.2 11.3-48H240.7c1.5 16.8 5.4 32.9 11.3 48zm16.5 32c13.4 20.6 31 38.1 51.5 51.5c20.6-13.4 38.1-31 51.5-51.5H268.5zM252 192c-5.9 15.1-9.8 31.2-11.3 48H399.3c-1.5-16.8-5.4-32.9-11.3-48H252zm119.5-32c-13.4-20.6-31-38.1-51.5-51.5c-20.6 13.4-38.1 31-51.5 51.5H371.5zM320 458.4c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6z"]
};
var faXRay = {
  prefix: 'far',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80h8V432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H56 456h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H456 56 24zM80 432V80H432V432H80zM256 96c-8.8 0-16 7.2-16 16v32H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v32H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v54.6L189.1 275c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 294.6V240h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faGoalNet = {
  prefix: 'far',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", "M48 120c0-22.1 17.9-40 40-40H552c22.1 0 40 17.9 40 40V456c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-48.6-39.4-88-88-88H88C39.4 32 0 71.4 0 120V456c0 13.3 10.7 24 24 24s24-10.7 24-24V120zm128 8c-8.8 0-16 7.2-16 16v48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V320h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V224h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H384V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H288V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H192V144c0-8.8-7.2-16-16-16zm80 256H192V320h64v64zm96 0H288V320h64v64zm96 0H384V320h64v64zm0-96H384V224h64v64zm-96 0H288V224h64v64zm-96 0H192V224h64v64z"]
};
var faCoffinCross = {
  prefix: 'far',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M140.1 464H243.9l91.9-318.2L250.2 48H133.8L48.2 145.8 140.1 464zM11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM216 120v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSpellCheck = {
  prefix: 'far',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M134.1 14.6C130.4 5.8 121.6 0 112 0s-18.3 5.8-22.1 14.6l-88 208c-5.2 12.2 .5 26.3 12.8 31.5s26.3-.5 31.5-12.8L56.8 216H167.2l10.7 25.4c5.2 12.2 19.2 17.9 31.5 12.8s17.9-19.2 12.8-31.5l-88-208zM146.9 168H77.1L112 85.6 146.9 168zM256 24V128 232c0 13.3 10.7 24 24 24h92c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3C426.9 107.3 432 92.2 432 76c0-42-34-76-76-76H280c-13.3 0-24 10.7-24 24zm100 80H304V48h52c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-52 48h52 16c15.5 0 28 12.5 28 28s-12.5 28-28 28H304V152zM568.6 313.3c9.6-9.2 9.9-24.4 .7-33.9s-24.4-9.9-33.9-.7l-183 175.7L265 367c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L335 505c9.2 9.2 24.2 9.4 33.6 .3l200-192z"]
};
var faLocationXmark = {
  prefix: 'far',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faMapMarkerTimes = faLocationXmark;
var faMapMarkerXmark = faLocationXmark;
var faCircleQuarterStroke = {
  prefix: 'far',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M464 256c0-114.9-93.1-208-208-208c-1.4 0-2.9 0-4.3 0c2.7 4.6 4.3 10.1 4.3 16V224c0 17.7-14.3 32-32 32H64c-5.8 0-11.3-1.6-16-4.3c0 1.4 0 2.9 0 4.3c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faLasso = {
  prefix: 'far',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M576 176c0 97.2-128.9 176-288 176c-14.9 0-29.6-.7-43.9-2c7.7 15.3 11.9 32.4 11.9 50.2C256 461.9 205.9 512 144.2 512H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h88.2c35.2 0 63.8-28.6 63.8-63.8c0-24.9-14.5-47.5-37.1-57.9l-44.3-20.5C50.2 290.1 0 236.6 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 304c132.5 0 240-57.3 240-128s-107.5-128-240-128S48 105.3 48 176s107.5 128 240 128z"]
};
var faSlash = {
  prefix: 'far',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]
};
var faPersonToPortal = {
  prefix: 'far',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", "M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L56.4 165.8c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L225.1 480.8c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5H352h16.5H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H368.1c1.2-82.9 11.4-134.5 24.1-164c12.4-28.7 22.4-28.1 23.7-28l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180s-10.7 148.6-24.2 180c-12.4 28.7-22.4 28.1-23.7 28l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28c-10.1-23.4-18.6-60.5-22.2-116H352 321.9c8.8 140.7 47.6 192 94.1 192c53 0 96-66.6 96-256S469 0 416 0c-46.2 0-84.8 50.6-93.9 189.1l-5.8-18.9c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1L103.4 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h84.9c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6z"]
};
var faPortalEnter = faPersonToPortal;
var faCalendarStar = {
  prefix: 'far',
  iconName: 'calendar-star',
  icon: [512, 512, [], "f736", "M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zM265.3 242.9l23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L256 392l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z"]
};
var faComputerMouse = {
  prefix: 'far',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M192 224H48V352c0 61.9 50.1 112 112 112h64c61.9 0 112-50.1 112-112V224H192zm192-48v24 24V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V224 200 176 160C0 71.6 71.6 0 160 0h8 24 24 8c88.4 0 160 71.6 160 160v16zM216 48V176H336V160c0-61.9-50.1-112-112-112h-8zm-48 0h-8C98.1 48 48 98.1 48 160v16H168V48z"]
};
var faMouse = faComputerMouse;
var faArrowRightToBracket = {
  prefix: 'far',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M217 401L345 273c9.4-9.4 9.4-24.6 0-33.9L217 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM344 80l80 0c22.1 0 40 17.9 40 40l0 272c0 22.1-17.9 40-40 40l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c48.6 0 88-39.4 88-88l0-272c0-48.6-39.4-88-88-88l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faSignIn = faArrowRightToBracket;
var faPegasus = {
  prefix: 'far',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M109.6 133.9c-9.9 7.3-18.5 16.1-25.5 26.2C37.3 162.1 0 200.7 0 248v64c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2h49.8c31.7 0 54.7-30.3 46.2-60.8l-14.8-53.3c-.5-1.6-.4-3.4 .2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V327.8c19.8-22.6 32-52.3 32-85.5l0-1.6 0-.7v-7.8c17.7 6 37.5 5.8 55.8-1.5c34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24H480V.3c-2.5-.2-5-.3-7.5-.3H472 440h-8c-1.8 0-3.5 .2-5.2 .6C365 5.9 313.7 48.2 295.3 105.3L164.3 27.4c-7.4-4.4-16.6-4.5-24.1-.2S128 39.4 128 48c0 76.3 36.1 130.2 71.3 164.2c17.5 17 35 29.3 48.1 37.3c6.6 4 12.1 7.1 16.1 9.1c2 1 3.6 1.8 4.8 2.4c.6 .3 1 .5 1.4 .6l.4 .2 .1 .1 .1 0 0 0c0 0 0 0 9.6-22l-9.6 22c12.1 5.3 26.3-.2 31.6-12.4s-.2-26.3-12.4-31.6l0 0-.1 0-.7-.3c-.7-.3-1.9-.9-3.4-1.7c-3-1.5-7.5-4-12.9-7.3c-10.9-6.7-25.4-16.9-39.9-30.9c-20.8-20.2-41.2-47.8-50.8-84.1l19.4 11.6 86.4 51.4c2.6 1.6 5.4 2.6 8.3 3v.3h3.6c.3 0 .6 0 .8 0H313c12.1 0 22.3-9 23.8-21c6.1-49.1 46.6-87.7 96.6-90.8c.7 0 1.3-.1 2-.2H440h32 .5c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7c-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7s-16.1 12.5-16.1 22.6v55c0 .5 0 1 0 1.5c0 .6 0 1.2 0 1.7c0 23.5-9.6 44.1-24.7 58.8c-4.6 4.5-7.3 10.7-7.3 17.2V464H336V346.2c0-11.3-7.9-21.1-19-23.5c-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6L188.9 464H139.1l-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9c0-17.4 7-33.3 18.2-44.8c-8-13.7-15-28.9-20.6-45.5zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faFilesMedical = {
  prefix: 'far',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M384 368H160c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H320V96c0 17.7 14.3 32 32 32h48V352c0 8.8-7.2 16-16 16zM160 416H384c35.3 0 64-28.7 64-64V122.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0H160C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm197.3 72v37.3H208c-8.8 0-16 7.2-16 16v21.3c0 8.8 7.2 16 16 16h37.3V320c0 8.8 7.2 16 16 16h21.3c8.8 0 16-7.2 16-16V282.7H336c8.8 0 16-7.2 16-16V245.3c0-8.8-7.2-16-16-16H298.7V192c0-8.8-7.2-16-16-16H261.3c-8.8 0-16 7.2-16 16z"]
};
var faNfcLock = {
  prefix: 'far',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M384 80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H320v48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v65.1c-17.7 2.5-34 9.2-48 18.9V96c0-8.8-7.2-16-16-16zm-16 72v62.3c-10.2 16.9-16 36.6-16 57.7v24.6c-19.1 11.1-32 31.7-32 55.4V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40zM128 352H320v48H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V352zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faPersonSkiLift = {
  prefix: 'far',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", "M240 0c8.8 0 16 7.2 16 16V207.9l-32 7.5V16c0-8.8 7.2-16 16-16zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM13.6 178.3c12-5.7 26.3-.7 32 11.3l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32zM488 288c13.3 0 24 10.7 24 24v1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L272 406.2V286.3l-94.2 22.2c-18 4.2-36.6-4.5-44.9-21L90.3 202.3C78.8 179.2 95.5 152 121.4 152c13.2 0 25.2 7.4 31.1 19.2l42 84L280.7 235c20.1-4.7 39.3 10.5 39.3 31.1V388.5L443.1 343c12.6-4.6 20.9-16.6 20.9-30v-1c0-13.3 10.7-24 24-24z"]
};
var faSkiLift = faPersonSkiLift;
var faSquare6 = {
  prefix: 'far',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288z"]
};
var faShopSlash = {
  prefix: 'far',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224h25.8c21.1 0 38.2-17.1 38.2-38.2c0-6.4-1.6-12.7-4.7-18.3L557.6 25C549.2 9.6 533.1 0 515.5 0h-391C106.9 0 90.8 9.6 82.4 25L76.9 35 38.8 5.1zM115.2 65l9.3-17 391 0 69.8 128H256.8L115.2 65zM318.1 224H528V388.5L318.1 224zM0 185.8C0 206.9 17.1 224 38.2 224H64V472c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V398.5L284.3 320H112V224h50.5l-60.9-48H54.7l14.1-25.8L30.5 120 4.7 167.4C1.6 173.1 0 179.4 0 185.8zM112 464V368H336v96H112z"]
};
var faStoreAltSlash = faShopSlash;
var faWindTurbine = {
  prefix: 'far',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.8 212c-.5-3.4 .1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5L31.1 140.6C13.7 141 9.5 165 25.7 171.4l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5L315.7 414.8zM232 339.8V464H152c-13.3 0-24 10.7-24 24s10.7 24 24 24H256 360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V417.8l-48-78zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSlidersSimple = {
  prefix: 'far',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M80 336a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm76.3 8L488 344c13.3 0 24 10.7 24 24s-10.7 24-24 24l-331.7 0c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 56zM400 144a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-44.3-24c10.2-32.5 40.5-56 76.3-56c44.2 0 80 35.8 80 80s-35.8 80-80 80c-35.8 0-66.1-23.5-76.3-56L24 168c-13.3 0-24-10.7-24-24s10.7-24 24-24l331.7 0z"]
};
var faGridRound = {
  prefix: 'far',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M88 96A24 24 0 1 1 40 96a24 24 0 1 1 48 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM88 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM248 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z"]
};
var faBadgeSheriff = {
  prefix: 'far',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", "M256.1 63.9c5-6.7 7.9-14.9 7.9-23.9c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 9 2.9 17.2 7.9 23.9c-.9 1.2-1.7 2.4-2.5 3.8l-37.3 64-74 .3c-1.2 0-2.3 .1-3.5 .2c-6.9-12-19.9-20-34.7-20c-22.1 0-40 17.9-40 40s17.9 40 40 40c1.2 0 2.4-.1 3.6-.2L80.4 256 43.6 320.2c-1.2-.1-2.4-.2-3.6-.2c-22.1 0-40 17.9-40 40s17.9 40 40 40c14.8 0 27.8-8.1 34.7-20c1.1 .1 2.3 .2 3.5 .2l74 .3 37.3 64c.8 1.3 1.6 2.6 2.5 3.8c-5 6.7-7.9 14.9-7.9 23.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.9c.9-1.2 1.7-2.4 2.5-3.8l37.3-64 74-.3c1.2 0 2.3-.1 3.5-.2c6.9 12 19.9 20 34.7 20c22.1 0 40-17.9 40-40s-17.9-40-40-40c-1.2 0-2.4 .1-3.6 .2L367.6 256l36.7-64.2c1.2 .1 2.4 .2 3.6 .2c22.1 0 40-17.9 40-40s-17.9-40-40-40c-14.8 0-27.8 8.1-34.7 20c-1.1-.1-2.3-.2-3.5-.2l-74-.3-37.3-64c-.8-1.3-1.6-2.6-2.5-3.8zM272 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-80.7-96.3l32.7-56 32.7 56c7.1 12.2 20.2 19.8 34.4 19.9l64.9 .3-32.2 56.3c-7 12.3-7 27.4 0 39.7l32.2 56.3-64.9 .3c-14.2 .1-27.3 7.6-34.4 19.9l-32.7 56-32.7-56c-7.1-12.2-20.2-19.8-34.4-19.9l-64.9-.3 32.2-56.3c7-12.3 7-27.4 0-39.7L92.1 179.8l64.9-.3c14.2-.1 27.3-7.6 34.4-19.9z"]
};
var faServer = {
  prefix: 'far',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M64 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 336c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H64zM0 352c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352zm392 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM328 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faVirusCovidSlash = {
  prefix: 'far',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zm197 154.4C258.3 139.9 287.8 128 320 128c70.7 0 128 57.3 128 128c0 21.2-5.1 41.1-14.2 58.7L235.8 159.5zM145.6 232H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-43.1-34c-1.5 6-2.7 12.2-3.5 18.5z"]
};
var faIntersection = {
  prefix: 'far',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M24 480c13.3 0 24-10.7 24-24V224c0-79.5 64.5-144 144-144s144 64.5 144 144V456c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-106-86-192-192-192S0 118 0 224V456c0 13.3 10.7 24 24 24z"]
};
var faShopLock = {
  prefix: 'far',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 12.4-5.9 23.3-14.9 30.3c-9.6-16.7-23.4-30.6-39.9-40.4L515.5 48l-391 0L54.7 176H470.3c-18.8 11.3-34 28-43.5 48H384V472c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V224H38.2C17.1 224 0 206.9 0 185.8zM112 224v96H336V224H112zm0 240H336V368H112v96zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faFamily = {
  prefix: 'far',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM105.6 208H128h22.4 32.3c-4.3-9.8-6.7-20.6-6.7-32c0-3.9 .3-7.8 .8-11.5c-8.3-2.9-17.2-4.5-26.4-4.5H105.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h32V336c0-11.1 1.6-21.9 4.6-32H88 85.6c-9.4 0-16.7-8-15.9-17.3l4.1-49.3C75.1 220.8 89 208 105.6 208zM336 176c0 11.4-2.4 22.2-6.7 32h38.9H384h15.7c7.1 0 13.4 4.7 15.4 11.6L448.4 336H368v16c0 11.2-1.9 22-5.5 32H400V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112v16c0 8.8-7.2 16-16 16H256 240c-8.8 0-16-7.2-16-16V336c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16V336c0-44.2-35.8-80-80-80s-80 35.8-80 80v16c0 24 13.2 44.9 32.7 55.8c-.5 2.7-.7 5.4-.7 8.2v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z"]
};
var faHourglassStart = {
  prefix: 'far',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M0 488c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V445c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 0 0 10.7 0 24S10.7 48 24 48h8V67c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445v19H24c-13.3 0-24 10.7-24 24zM273.5 371.5C293 391 304 417.4 304 445v19H80V445c0-27.6 11-54 30.5-73.5L192 289.9l81.5 81.5z"]
};
var faHourglass1 = faHourglassStart;
var faUserHairBuns = {
  prefix: 'far',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H160c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32h14.4c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6c17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6c24.3 0 44-19.7 44-44V108c0-24.3-19.7-44-44-44c-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8C101.9 66.9 93.3 64 84 64c-24.3 0-44 19.7-44 44v40c0 24.3 19.7 44 44 44zM49.3 464c8.3-54.4 55.3-96 112-96H286.7c56.7 0 103.7 41.6 112 96H49.3zM0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3C72.2 320 0 392.2 0 481.3z"]
};
var faBlenderPhone = {
  prefix: 'far',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M158.1 64.1c4.7-12.4 .2-26.7-10.6-33.4l-44-27.2c-9.7-6-21.9-4.2-29.8 4.3C-24.6 114-24.6 286 73.7 392.2c7.9 8.5 20.1 10.3 29.8 4.3l44-27.2c10.8-6.7 15.3-21 10.6-33.4l-22-57.8c-4.2-10.9-14.5-17.6-25.3-16.4l-33.3 3.6c-13.6-42.2-13.6-88.4 0-130.7l33.3 3.6c10.9 1.2 21.2-5.5 25.3-16.4l22-57.8zM268.2 336H442.5l28-112H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H478.5l16-64H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H502.5l12-48H244.2l24 288zM566.1 39.8L489.6 345.5C521.8 361 544 393.9 544 432v16c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V432c0-40.5 25.1-75.1 60.6-89.2L196.3 52C194 24 216.1 0 244.2 0H535c20.8 0 36.1 19.6 31 39.8zM208 432v16c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V432c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48zm144-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHourglassClock = {
  prefix: 'far',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l43.8 43.8c-8.8 21-13.7 44-13.7 68.2c0 59.5 29.6 112.1 74.8 144H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM99.8 128H284.2C297 110.4 304 89 304 67V48H80V67c0 22.1 7 43.4 19.8 61zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]
};
var faPersonSeatReclined = {
  prefix: 'far',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", "M176 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16.9 189.6l16.9 76.2c.8 3.7 4.1 6.3 7.8 6.3h16.4l-19.4-87.3c-1.1-5.1-5.7-8.7-10.9-8.7c-7.1 0-12.4 6.6-10.9 13.6zm68.6-15.2l.4 1.7H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H272.6l10.7 48h35.5c30 0 56.9 18.6 67.4 46.7l28.5 76.1 34.7-9.9c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-56 16c-12 3.4-24.7-2.9-29.1-14.6l-36.3-96.9c-3.5-9.4-12.5-15.6-22.5-15.6H264.5c-.3 0-.7 0-1 0H217.7c-26.2 0-49-18.2-54.7-43.9L146.1 232c-8.2-36.9 19.9-72 57.7-72c27.7 0 51.7 19.3 57.7 46.3zM79.6 147.8l34 192.7c6.1 34.4 36 59.5 70.9 59.5H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H184.5c-58.2 0-108.1-41.8-118.2-99.1l-34-192.7c-2.3-13.1 6.4-25.5 19.5-27.8s25.5 6.4 27.8 19.5z"]
};
var faPaperPlaneTop = {
  prefix: 'far',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M133.9 232L65.8 95.9 383.4 232H133.9zm0 48H383.4L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z"]
};
var faPaperPlaneAlt = faPaperPlaneTop;
var faSend = faPaperPlaneTop;
var faMessageArrowUp = {
  prefix: 'far',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM280 296V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCommentAltArrowUp = faMessageArrowUp;
var faLightbulbExclamation = {
  prefix: 'far',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7l0 0 0 0 0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8l0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zm0-400c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faLayerMinus = {
  prefix: 'far',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M408 60H520c11 0 20 9 20 20s-9 20-20 20H408c-11 0-20-9-20-20s9-20 20-20zM263.2 133.1c7.8-3.4 16.3-5.1 24.8-5.1s17 1.7 24.8 5.1l209.3 89.7c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2L312.8 378.9c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 289.2C40.6 283.5 32 270.5 32 256s8.6-27.5 21.9-33.2l209.3-89.7zM288 176c-2 0-4 .4-5.9 1.2L98.3 256l183.8 78.8c1.9 .8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 256 293.9 177.2c-1.9-.8-3.9-1.2-5.9-1.2zM53.9 350.8l31.2-13.4L146 363.5 98.3 384l183.8 78.8c1.9 .8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 384 430 363.5l60.9-26.1 31.2 13.4c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2L312.8 506.9c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 417.2C40.6 411.5 32 398.5 32 384s8.6-27.5 21.9-33.2z"]
};
var faLayerGroupMinus = faLayerMinus;
var faChartPieSimpleCircleCurrency = {
  prefix: 'far',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M496 192c-46.8 0-89.3 18.2-120.8 48H272V16.6c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288h67.2c-7.6 14.9-13.2 31-16.3 48H224c-26.5 0-48-21.5-48-48V90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V240v48h48zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L460.7 426c21.6 13.2 49.1 13.2 70.7 0z"]
};
var faCircleE = {
  prefix: 'far',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V256 360c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H208V280h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H208V176H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faBuildingWheat = {
  prefix: 'far',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M320 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm40 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104zm112 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232c-8.8 0-16 7.2-16 16zM104 216c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104zm112 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H232c-8.8 0-16 7.2-16 16zm424-40H624c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V192zm0 128V304H624c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zm0 112V416H624c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80zM512 496c0-44.2-35.8-80-80-80H416v16c0 44.2 35.8 80 80 80h16V496zm0-96V384c0-44.2-35.8-80-80-80H416v16c0 44.2 35.8 80 80 80h16zm0-128c0-44.2-35.8-80-80-80H416v16c0 44.2 35.8 80 80 80h16V272zM528 32c-13.3 0-24 10.7-24 24V160c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V96zM456 72c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0-13.3-10.7-24-24-24z"]
};
var faGaugeMax = {
  prefix: 'far',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56s25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM112 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faTachometerAltFastest = faGaugeMax;
var faPersonBreastfeeding = {
  prefix: 'far',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M192 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM116.9 282.2c19.6-26.5 50.6-42.2 83.6-42.2h58.3c27.6 0 54.1 11 73.7 30.6l55.2 55.3c12 12 12.5 31.3 1.2 43.9L326.1 440c-8.8 9.9-8 25.1 1.9 33.9s25.1 8 33.9-1.9l62.8-70.2c28.3-31.6 27-79.8-3-109.8l-55.2-55.3C338 208.1 299.3 192 258.9 192H200.6c-48.2 0-93.6 22.9-122.2 61.7l-56 75.7C-8.1 370.6 7.5 429.5 54.5 450.2L190.3 510c12.1 5.3 26.3-.2 31.6-12.3s-.2-26.3-12.3-31.6L73.8 406.2c-18.8-8.3-25-31.8-12.8-48.3l56-75.7zM192 328c0-13.3-10.7-24-24-24s-24 10.7-24 24v43.4c0 7.5 2.1 14.8 6.1 21.2C177.8 437 226.5 464 278.9 464H280c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.1c-35.1 0-67.7-17.7-86.9-46.9V328zm80 56a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faApostrophe = {
  prefix: 'far',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M128 176c8.8 0 16-7.2 16-16V128 96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64zm16 46c-5.1 1.3-10.5 2-16 2H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32h64c35.3 0 64 28.7 64 64v32 32 72c0 66.3-53.7 120-120 120H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H72c39.8 0 72-32.2 72-72V222z"]
};
var faFireHydrant = {
  prefix: 'far',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M192 0c-17.7 0-32 14.3-32 32v4c-45 11.6-80.4 47-92 92H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H316c-11.6-45-47-80.4-92-92V32c0-17.7-14.3-32-32-32zM56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V384h16c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H320V208H272V464H112V208H64v48H48c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H64v80H56zM248 320a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
var faRightToBracket = {
  prefix: 'far',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M192 365.8L302 256 192 146.2l0 53.8c0 13.3-10.7 24-24 24L48 224l0 64 120 0c13.3 0 24 10.7 24 24l0 53.8zM352 256c0 11.5-4.6 22.5-12.7 30.6L223.2 402.4c-8.7 8.7-20.5 13.6-32.8 13.6c-25.6 0-46.4-20.8-46.4-46.4l0-33.6-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l96 0 0-33.6c0-25.6 20.8-46.4 46.4-46.4c12.3 0 24.1 4.9 32.8 13.6L339.3 225.4c8.1 8.1 12.7 19.1 12.7 30.6zm-8 176l80 0c22.1 0 40-17.9 40-40l0-272c0-22.1-17.9-40-40-40l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSignInAlt = faRightToBracket;
var faVideoPlus = {
  prefix: 'far',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M320 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V351 161 128c0-35.3-28.7-64-64-64H64zm464 84.6V363.4L416 313v52.6l104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5v-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4V199l112-50.4zM216 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V184z"]
};
var faSquareRight = {
  prefix: 'far',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM262.6 151.2l84 91c3.5 3.8 5.4 8.7 5.4 13.9s-1.9 10.1-5.4 13.9l-84 91c-4.2 4.6-10.1 7.2-16.4 7.2C234 368 224 358 224 345.7V304H128c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32l96 0V166.3c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.4 7.2z"]
};
var faArrowAltSquareRight = faSquareRight;
var faCommentSmile = {
  prefix: 'far',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM192 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 270.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"]
};
var faVenus = {
  prefix: 'far',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V400H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V350.4z"]
};
var faPassport = {
  prefix: 'far',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 400c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm33.3-176h39.1c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 304l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32H279.6c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 112l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8H129.3zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faInboxIn = {
  prefix: 'far',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M280 24V230.1l63-63c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 305c-9.4 9.4-24.6 9.4-33.9 0L135 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l63 63V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM149.1 405.5L130.3 368H48v96H464V368H381.7l-18.7 37.5C354.8 421.7 338.2 432 320 432H192c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384H320l18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h82.3c18.2 0 34.8 10.3 42.9 26.5z"]
};
var faInboxArrowDown = faInboxIn;
var faHeartPulse = {
  prefix: 'far',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M256 163.9L222.1 130l-12-12c-21.7-21.7-52.5-31.6-82.7-26.5C81.6 99.1 48 138.7 48 185.1v5.8c0 23.9 8.4 46.9 23.5 65.1h51.1c6.5 0 12.3-3.9 14.8-9.8l31.8-76.3c2.5-5.9 8.2-9.8 14.5-9.8s12.2 3.6 14.8 9.4l58.2 129.3 48.9-97.9c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8h68.7c15.1-18.2 23.5-41.2 23.5-65.1v-5.8c0-46.4-33.6-86-79.3-93.6c-30.2-5-61.1 4.8-82.7 26.5l-12 12L256 163.9zM456 288H407.4 371.8c-18.2 0-34.8-10.3-42.9-26.5L320 243.8l-49.7 99.4c-2.8 5.5-8.5 9-14.6 8.8s-11.7-3.8-14.3-9.4L184.6 216.2 167 258.5C159.5 276.3 142 288 122.7 288h-18H56 35.7C12.8 261.1 0 226.7 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l0 0 12 12 12-12 0 0c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 35.8-12.8 70.1-35.7 97.1H456zM68.6 320h70.3L256 429.3 373.1 320h70.3L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L68.6 320z"]
};
var faHeartbeat = faHeartPulse;
var faCircle8 = {
  prefix: 'far',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128c39.8 0 72 32.2 72 72c0 15.7-5 30.1-13.5 42c18 14.7 29.5 37 29.5 62c0 44.2-35.8 80-80 80H240c-44.2 0-80-35.8-80-80c0-25 11.5-47.4 29.5-62C181 230.1 176 215.7 176 200c0-39.8 32.2-72 72-72h16zm-16 96s0 0 0 0h16s0 0 0 0c13.2 0 24-10.8 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24s10.7 24 24 24zm16 48H248h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8z"]
};
var faCloudsMoon = {
  prefix: 'far',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", "M352 160c0 11.5 1.2 22.7 3.5 33.4c53.7 8.2 96.5 49.8 106.4 103c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zM335.8 272c26.5 0 48 21.5 48 48c0 .8 0 1.7 .1 2.5l2 23.8c1.1 13.2 12.7 23 25.9 21.9c1.3-.1 2.6-.2 4-.2c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.3 0-1.9 0c-.3 0-.6 0-.9 0H146.1c-.3 0-.6 0-1 0c-.4 0-.9 0-1.3 0c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.6 0 3.1 .1 4.6 .3c6.9 1 13.9-1.1 19.1-5.6s8.3-11.2 8.3-18.1V346.3c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9v-1.1c.1-.6 .2-1.1 .3-1.7c2.5-19.6 19.3-34.8 39.7-34.8c12.6 0 23.8 5.8 31.1 14.9c5.8 7.1 15.1 10.4 24.1 8.3s15.9-9.1 18-18c4.9-21.3 24-37.2 46.8-37.2zm96 46.8c-.6-52.5-43.4-94.8-96-94.8c-33 0-62 16.6-79.3 41.9c-12.2-6.3-26-9.9-40.6-9.9c-43 0-78.8 30.9-86.5 71.7c-1 2.6-1.5 5.4-1.5 8.3v5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7v6.9c-36.5 7.4-64 39.7-64 78.4c0 44.2 35.8 80 80 80c.9 0 1.8 0 2.7 0h266c1.1 0 2.1 .1 3.2 .1c53 0 96-43 96-96c0-47.5-34.5-86.9-79.8-94.6l-.2-2.5zM320 192.1h0c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72l0 0h34.8c9.4-19.9 24.6-36.6 43.4-48H73.8c-.6 0-1.2 0-1.7 0c-13.2 0-24-10.7-24-24s10.7-24 24-24c1.1 0 2.2 .1 3.2 .2c25.1 3.3 48.5-13.5 53.4-38.4c2.9-14.7 15.9-25.8 31.4-25.8c13.6 0 25.3 8.5 29.9 20.6c9.2 24.3 36.2 36.9 60.8 28.2c1.6-.6 3.4-.9 5.3-.9c8.8 0 16 7.2 16 16l0 .9c-.1 6.6-1.6 12.9-4.1 18.6c15.5-9.7 33.2-16.3 52.1-18.7l0-.9z"]
};
var faClockTenThirty = {
  prefix: 'far',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faPeopleCarryBox = {
  prefix: 'far',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", "M176 48A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM53 344.3L1.6 479.5c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L92.6 375.4 53 344.3zM96 187.5c0-6.4 5.2-11.5 11.5-11.5c4.4 0 8.6 1 12.5 2.8V295.2L99.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3V187.5zm72 145.4V243.3l26 39.1c3.3 4.9 7.6 9.1 12.7 12.1l26.1 15.7c5.6 5.9 13.5 9.6 22.3 9.9c.4 0 .9 0 1.3 0H383.6c.4 0 .9 0 1.3 0c8.7-.2 16.6-4 22.2-9.9l26.1-15.7c5.1-3 9.4-7.2 12.7-12.1l26-39.1v89.6l-25.8 20.3c-8.1 6.4-13.4 15.6-14.9 25.8L416.2 484.6c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l14.6-102.5 92.2-72.4c13.5-10.6 21.4-26.9 21.4-44V187.5c0-32.9-26.6-59.5-59.5-59.5c-25.8 0-50 12.9-64.3 34.4L416 240.7V160c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v80.7l-52.2-78.3c-14.3-21.5-38.5-34.4-64.3-34.4C74.6 128 48 154.6 48 187.5v84.9c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L208.7 379c-1.5-10.2-6.8-19.4-14.9-25.8L168 332.9zM272 176h96v96H272V176zM512 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM638.4 479.5L587 344.3l-39.5 31.1 46.2 121.2c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31zM532.5 176c6.4 0 11.5 5.2 11.5 11.5v84.9c0 2.5-1.1 4.8-3.1 6.3L520 295.2V178.8c3.8-1.8 8.1-2.8 12.5-2.8z"]
};
var faPeopleCarry = faPeopleCarryBox;
var faFolderUser = {
  prefix: 'far',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H368c0-44.2-35.8-80-80-80H224c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faTrashCanXmark = {
  prefix: 'far',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm63 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTemperatureHigh = {
  prefix: 'far',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64V273.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9V112zM144 0C82.1 0 32 50.2 32 112V273.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faMicrochip = {
  prefix: 'far',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64h-8c-35.3 0-64 28.7-64 64v8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v8c0 35.3 28.7 64 64 64h8v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h48v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h8c35.3 0 64-28.7 64-64v-8h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V184h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448v-8c0-35.3-28.7-64-64-64h-8V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM400 128V384c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16zM192 160c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H192zm16 48h96v96H208V208z"]
};
var faLeftLongToLine = {
  prefix: 'far',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M0 88C0 74.7 10.7 64 24 64s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88zM134.5 272.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 33.7 248 0c30.9 0 56 25.1 56 56l0 48c0 30.9-25.1 56-56 56l-248 0 0 33.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6l-121.4-129zM288 200l0-53.5L185 256 288 365.5l0-53.5c0-13.3 10.7-24 24-24l272 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-272 0c-13.3 0-24-10.7-24-24z"]
};
var faCrown = {
  prefix: 'far',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7l-72-57.6L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0l4.4 23.9L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6l41.4-227.5 4.4-23.9c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-17.1 13.7-72 57.6c-15.9 12.7-39.5 7.5-48.6-10.7L314.8 117.7 309 106zM133.7 418.9L102.2 245.6l28.9 23.1c39.8 31.8 98.8 18.9 121.5-26.7L288 171.3l35.4 70.7c22.8 45.6 81.8 58.5 121.5 26.7l28.9-23.1L442.3 418.9c-1.4 7.6-8 13.1-15.7 13.1H149.4c-7.7 0-14.4-5.5-15.7-13.1z"]
};
var faWeightHanging = {
  prefix: 'far',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M216 88a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm118.4 40c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 14.4 3.5 28 9.6 40H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H334.4zM256 176H392l72 288H48l72-288H256z"]
};
var faXmarksLines = {
  prefix: 'far',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M24 32H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56S10.7 32 24 32zm0 400H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zM41 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55L7 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm224 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM455 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faFilePrescription = {
  prefix: 'far',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm40 192c-13.3 0-24 10.7-24 24v80 64c0 13.3 10.7 24 24 24s24-10.7 24-24V320h22.1c.3 .3 .6 .7 .9 1l55 55-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23-31.1-31.1C227.5 299.7 240 279.3 240 256c0-35.3-28.7-64-64-64H104zm72 80H128V240h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faCalendarRange = {
  prefix: 'far',
  iconName: 'calendar-range',
  icon: [512, 512, [], "e0d6", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H96c-35.3 0-64 28.7-64 64v16 48V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H376V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM80 192H432V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V192zm48 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm224 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 288c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm40 72H152c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faFlowerDaffodil = {
  prefix: 'far',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", "M112 88c0-48.6 39.4-88 88-88c21.3 0 40.8 7.6 56 20.1C271.2 7.6 290.7 0 312 0c48.6 0 88 39.4 88 88c0 21.3-7.6 40.8-20.1 56c12.6 15.2 20.1 34.7 20.1 56c0 48.6-39.4 88-88 88c-11.3 0-22.1-2.1-32-6v91.4c41-52 104.6-85.4 176-85.4h28c15.5 0 28 12.5 28 28c0 108.2-87.8 196-196 196H280 232 196C87.8 512 0 424.2 0 316c0-15.5 12.5-28 28-28H56c71.4 0 135 33.4 176 85.4V282c-9.9 3.9-20.7 6-32 6c-48.6 0-88-39.4-88-88c0-21.3 7.6-40.8 20.1-56C119.6 128.8 112 109.3 112 88zm88-40c-22.1 0-40 17.9-40 40c0 15 8.3 28.2 20.6 35c7.6 4.2 12.4 12.3 12.4 21s-4.7 16.8-12.4 21c-12.4 6.9-20.6 20-20.6 35c0 22.1 17.9 40 40 40c15 0 28.2-8.3 35-20.6c4.2-7.6 12.3-12.4 21-12.4s16.8 4.7 21 12.4c6.9 12.4 20 20.6 35 20.6c22.1 0 40-17.9 40-40c0-15-8.3-28.2-20.6-35c-7.6-4.2-12.4-12.3-12.4-21s4.7-16.8 12.4-21c12.4-6.9 20.6-20 20.6-35c0-22.1-17.9-40-40-40c-15 0-28.2 8.3-35 20.6C272.8 76.3 264.7 81 256 81s-16.8-4.7-21-12.4C228.2 56.3 215 48 200 48zM49.3 336C59.1 408.3 121 464 196 464h29.4C204.5 390.1 136.6 336 56 336H49.3zm413.3 0H456c-80.6 0-148.5 54.1-169.4 128H316c75 0 136.9-55.7 146.7-128zM256 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHandBackPointUp = {
  prefix: 'far',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M144 0C108.7 0 80 28.7 80 64V252.8c-5.2 3.6-10.2 7.6-14.9 11.9L44.8 283.2C26.5 299.9 16 323.5 16 348.3v10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H296c66.3 0 120-53.7 120-120v-8V288c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zM128 64c0-8.8 7.2-16 16-16s16 7.2 16 16V200c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16v8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16v96 8c0 39.8-32.2 72-72 72H170.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C83.6 429.7 64 395.5 64 358.5V348.3c0-11.3 4.8-22 13.1-29.6L96 301.5V344c0 8.8 7.2 16 16 16s16-7.2 16-16V266v-2V64z"]
};
var faWeightScale = {
  prefix: 'far',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0c0-22.6-4.3-44.2-12-64h28c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H92c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
};
var faWeight = faWeightScale;
var faArrowUpToArc = {
  prefix: 'far',
  iconName: 'arrow-up-to-arc',
  icon: [512, 512, [], "e617", "M256 48c114.9 0 208 93.1 208 208c0 13.3 10.7 24 24 24s24-10.7 24-24C512 114.6 397.4 0 256 0S0 114.6 0 256c0 13.3 10.7 24 24 24s24-10.7 24-24C48 141.1 141.1 48 256 48zM377.6 279.7l-104-112c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3L232 245.1 232 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-242.9 62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9z"]
};
var faStarExclamation = {
  prefix: 'far',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM235.4 187.2L287.9 79l52.6 108.2c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-7.1-3.8-15.6-3.8-22.6 0L171.4 443.7l20.2-119.6c1.3-7.7-1.2-15.5-6.8-21L99 217.9l118.3-17.5c7.8-1.2 14.6-6.1 18.1-13.3zM288 168c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-13.3-10.7-24-24-24zm32 168a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBooks = {
  prefix: 'far',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", "M48 416v48h64V416H48zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4H48c-26.5 0-48-21.5-48-48V416 392 368 144 120 96 48C0 21.5 21.5 0 48 0h64c8.7 0 16.9 2.3 24 6.4C143.1 2.3 151.3 0 160 0h64c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L349.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L275.6 145.9 272 132.2V144 368v24 24 48c0 26.5-21.5 48-48 48H160c-8.7 0-16.9-2.3-24-6.4zM160 464h64V416H160v48zM112 48H48V96h64V48zm0 96H48V368h64V144zm48-48h64V48H160V96zm64 272V144H160V368h64zm216.1-12.3l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L464 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L360.4 48.5 304 64.1c0 .1 0 .2 0 .4l11.7 45.2z"]
};
var faUserGroup = {
  prefix: 'far',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", "M1.5 458.7c6-45.5 29.2-85.6 62.8-113.6C95.3 319.4 135 304 178.3 304H224h45.7c43.3 0 83 15.4 113.9 41.1c33.6 28 56.8 68.1 62.8 113.6c1 7.7 1.5 15.6 1.5 23.6c0 16.4-13.3 29.7-29.7 29.7H398.7 49.3 29.7C13.3 512 0 498.7 0 482.3c0-8 .5-15.9 1.5-23.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm208 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM178.3 352c-47.8 0-89.5 25.7-112.2 64c-8.6 14.4-14.4 30.7-16.8 48H98 350h48.8c-.4-2.7-.8-5.3-1.4-8c-2.9-14.3-8.2-27.8-15.5-40c-22.7-38.3-64.4-64-112.2-64H178.3zm431 160H472.4c4.9-8.8 7.6-18.9 7.6-29.7c0-65-29.5-123.2-75.9-161.8c4.3-.4 8.7-.5 13.2-.5h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"]
};
var faUserFriends = faUserGroup;
var faArrowUpAZ = {
  prefix: 'far',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", "M416 32c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-13.6-27.2c-1.6 .3-3.2 .5-4.9 .5H370.8l-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160C398.6 37.1 406.9 32 416 32zM394.8 152h42.3L416 109.7 394.8 152zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM352 288H480c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8L405.4 432H480c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8L426.6 336H352c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSortAlphaUp = faArrowUpAZ;
var faLayerPlus = {
  prefix: 'far',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M464 4c-11 0-20 9-20 20V60H408c-11 0-20 9-20 20s9 20 20 20h36v36c0 11 9 20 20 20s20-9 20-20V100h36c11 0 20-9 20-20s-9-20-20-20H484V24c0-11-9-20-20-20zM288 128c-8.5 0-17 1.7-24.8 5.1L53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 133.1c-7.8-3.4-16.3-5.1-24.8-5.1zm-5.9 49.2c1.9-.8 3.9-1.2 5.9-1.2s4 .4 5.9 1.2L477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256l183.8-78.8zM85.1 337.4L53.9 350.8C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4z"]
};
var faLayerGroupPlus = faLayerPlus;
var faPlayPause = {
  prefix: 'far',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", "M432 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V88zm144 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V88zM112 381.8V130.2L263 256 112 381.8zm4.5-310.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z"]
};
var faBlockQuestion = {
  prefix: 'far',
  iconName: 'block-question',
  icon: [640, 512, [], "e3dd", "M160 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H480c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H160zM96 96c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm137.8 77.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L344 272.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V258.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H286.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 360a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM456 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 392a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSnooze = {
  prefix: 'far',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h59.1l-77.2 88.2c-6.2 7.1-7.7 17.1-3.8 25.7S174.6 176 184 176H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H236.9l77.2-88.2c6.2-7.1 7.7-17.1 3.8-25.7S305.4 0 296 0H184zM312 224c-13.3 0-24 10.7-24 24s10.7 24 24 24h62.9L293.1 377.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H361.1l81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5H312zM24 224c-13.3 0-24 10.7-24 24s10.7 24 24 24H152.6L4.6 473.8c-5.3 7.3-6.1 17-2.1 25S15 512 24 512H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H71.4l148-201.8c5.3-7.3 6.1-17 2.1-25S209 224 200 224H24z"]
};
var faZzz = faSnooze;
var faScannerImage = {
  prefix: 'far',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M66.7 34.5c-11.9-5.9-26.3-1.1-32.2 10.7s-1.1 26.3 10.7 32.2L466.3 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V384 352v-8.4c0-33.3-18.8-63.8-48.6-78.7L66.7 34.5zM528 352v32 32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16H512c8.8 0 16 7.2 16 16zM120 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTvRetro = {
  prefix: 'far',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M135 7c9.4-9.4 24.6-9.4 33.9 0l87 87L343 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55H432c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H190.1L135 41c-9.4-9.4-9.4-24.6 0-33.9zM80 144c-17.7 0-32 14.3-32 32V432c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H80zm336 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM144 192H304c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V240c0-26.5 21.5-48 48-48z"]
};
var faSquareT = {
  prefix: 'far',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm120 48H224 328c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFarm = {
  prefix: 'far',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M48 464l0-288H163.3l23.4-50.2c7.2-15.5 19.8-27.9 35.3-35C212.1 39.1 166.6 0 112 0C50.1 0 0 50.1 0 112V464c0 26.5 21.5 48 48 48H148.1c-11-13.3-18.1-29.8-19.8-48H48zM176 128H48V112c0-35.3 28.7-64 64-64s64 28.7 64 64v16zm81.9 34.4L368 114.2l110.1 48.2 49.9 107V456c0 4.4-3.6 8-8 8H432V408c0-22.1-17.9-40-40-40H344c-22.1 0-40 17.9-40 40v56H216c-4.4 0-8-3.6-8-8V269.3l49.9-107zM384 68.8c-10.2-4.5-21.8-4.5-32.1 0L235.9 119.6c-8.9 3.9-16.1 10.9-20.2 19.7L163.8 250.6c-2.5 5.3-3.8 11.1-3.8 16.9V456c0 30.9 25.1 56 56 56H520c30.9 0 56-25.1 56-56V267.5c0-5.8-1.3-11.6-3.8-16.9L520.3 139.3c-4.1-8.8-11.3-15.8-20.2-19.7L384 68.8zM320 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24z"]
};
var faBarnSilo = faFarm;
var faChessKnight = {
  prefix: 'far',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", "M226.6 48H117.3l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1H66.8c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0H226.6C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352H341.3l24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464H379.3l-16.6-32H85.2zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H56.8C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384h297c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"]
};
var faBarsSort = {
  prefix: 'far',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM192 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H168c13.3 0 24 10.7 24 24z"]
};
var faPalletBoxes = {
  prefix: 'far',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M272 48H112V208H272V48zM112 0H272c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V48C64 21.5 85.5 0 112 0zM528 112H432v96h96V112zM432 64h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48zM0 344c0-13.3 10.7-24 24-24H88 320 552h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H576v96h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H552 320 88 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V368H24c-13.3 0-24-10.7-24-24zM112 464H296V368H112v96zm232 0H528V368H344v96z"]
};
var faPaletteBoxes = faPalletBoxes;
var faPalletAlt = faPalletBoxes;
var faFaceLaughSquint = {
  prefix: 'far',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faLaughSquint = faFaceLaughSquint;
var faCodeSimple = {
  prefix: 'far',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", "M216.6 105.4c9.6-9.2 9.9-24.3 .8-33.9s-24.3-9.9-33.9-.8l-176 168C2.7 243.2 0 249.4 0 256s2.7 12.8 7.4 17.4l176 168c9.6 9.2 24.8 8.8 33.9-.8s8.8-24.8-.8-33.9L58.8 256 216.6 105.4zm142.9 0L517.2 256 359.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9z"]
};
var faBoltSlash = {
  prefix: 'far',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.2 327.6l49.5-42c7.8-6.6 12.3-16.4 12.3-26.6c0-19.3-15.6-34.9-34.9-34.9H391.8L445.4 36.6C450.6 18.3 436.8 0 417.7 0c-6.8 0-13.5 2.4-18.7 6.9L227.9 153.3 38.8 5.1zM266.4 183.5L381.6 85 337.5 239.3l-71.1-55.7zM379.3 272h62.2l-29.8 25.3L379.3 272zm-42.9 89.1l-78.2 66.4L288.1 323l-40.7-32.1L194.6 475.4c-5.2 18.4 8.5 36.6 27.6 36.6c6.8 0 13.4-2.4 18.6-6.8L374.9 391.4l-38.5-30.3zm-183-144.2l-13.7 11.7c-7.5 6.4-11.8 15.8-11.8 25.6c0 18.6 15.1 33.7 33.7 33.7h82l-90.2-71.1z"]
};
var faPanelFire = {
  prefix: 'far',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", "M384 80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H306.1c8.1 17.5 18.8 33.7 31.5 48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-4.2 3.8-8.4 7.6-12.5 11.5V96c0-8.8-7.2-16-16-16zM293.8 311.3c-1.8 .5-3.8 .7-5.8 .7c-13.3 0-24-10.7-24-24s10.7-24 24-24c8.2 0 15.5 4.1 19.8 10.4c-5.8 12.1-10.6 24.5-14 36.9zM96 160c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160zm32 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM453.5 163.6c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 87.8-71.3 159.8-160 159.8c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 432.9c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faBinaryCircleCheck = {
  prefix: 'far',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", "M318 4.5C324.3 9 328 16.3 328 24V176h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H304 248c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V57.3l-16.4 5.5C251 67 237.4 60.2 233.2 47.6S235.8 21.4 248.4 17.2l48-16C303.7-1.2 311.8 0 318 4.5zM94 292.5c6.3 4.5 10 11.8 10 19.5V464h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H80 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V345.3l-16.4 5.5C27 355 13.4 348.2 9.2 335.6S11.8 309.4 24.4 305.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3zM72 0h48c39.8 0 72 32.2 72 72v80c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V72C0 32.2 32.2 0 72 0zM48 72v80c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72C58.7 48 48 58.7 48 72zM192 360c0-39.8 32.2-72 72-72h48c8.8 0 17.2 1.6 25 4.5c-6.8 14.4-11.8 29.8-14.5 45.9c-3.2-1.5-6.7-2.4-10.5-2.4H264c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h48l.1 0h36.4c5.4 8.2 11.4 15.9 18 23.1C353.2 502.4 333.7 512 312 512H264c-39.8 0-72-32.2-72-72V360zm160 8a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faCommentMinus = {
  prefix: 'far',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM184 216c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faBurrito = {
  prefix: 'far',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M67.9 304c-4.4 4.4-8.1 9.4-11.2 14.7c17.3 6 35.9 9.3 55.3 9.3c75.6 0 139.5-49.9 160.6-118.6c4.8-15.6 7.4-32.2 7.4-49.4c0-20.3-3.6-39.8-10.2-57.9L67.9 304zm-53.8-7.4l0 0c5.3-9.7 11.9-18.6 19.8-26.5L242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c2.7 6.1 4.6 12.7 5.7 19.6c6.6 41.7-20.4 81-61 90.4L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9L112 444.1c12.7 12.7 30 19.9 48 19.9s35.3-7.2 48-19.9L409.9 242.2c-18-6.6-37.5-10.2-57.9-10.2c-13 0-25.7 1.5-37.9 4.3C283.3 317.9 204.5 376 112 376c-21.7 0-42.6-3.2-62.4-9.1c2.8 12.5 9.1 24 18.2 33.1L112 444.1 78.1 478.1 33.9 433.9C12.2 412.2 0 382.7 0 352c0-2.4 .1-4.8 .2-7.1l0 0c1-17 5.8-33.5 13.9-48.3z"]
};
var faViolin = {
  prefix: 'far',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M496 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM345 41L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L311 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM198.4 403.2c6.4-4.8 15.3-4.1 20.9 1.5l16 16c5.6 5.6 6.3 14.5 1.5 20.9l-5.3 7.1c16.6 9.7 35.9 15.3 56.5 15.3c25.2 0 48.3-8.2 67-22.2c-2-8.3-3-17-3-25.8c0-60 47.3-109.1 106.6-111.9c8.2-19.7 8.4-46.6-12.7-76.1L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L412 194.1c-29.5-21-56.4-20.8-76.1-12.7C333.1 240.8 284 288 224 288c-8.8 0-17.5-1-25.8-3c-14 18.7-22.2 41.8-22.2 67c0 20.6 5.6 39.9 15.3 56.5l7.1-5.3zm-45.7 34.3c-15.7-24.7-24.7-54-24.7-85.5c0-41.2 15.5-78.7 41.1-107c9.7-10.7 25.8-10.1 39.8-6.7c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64c0-11.6 2.6-24 12.4-30.1c39.3-24.7 94.3-26.4 145.8 14L599 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L480.2 193.8c40.3 51.5 38.6 106.5 14 145.8C488 349.4 475.6 352 464 352c-35.3 0-64 28.7-64 64c0 5.2 .6 10.2 1.8 15.1c3.4 14.1 4 30.2-6.7 39.8C366.7 496.5 329.2 512 288 512c-31.4 0-60.7-9.1-85.5-24.7l-13.7 18.3c-2.8 3.7-7 6-11.7 6.4s-9.2-1.4-12.4-4.6l-32-32c-3.3-3.3-5-7.8-4.6-12.4s2.6-8.9 6.4-11.7l18.3-13.7zM448 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faObjectsColumn = {
  prefix: 'far',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M48 80V240h96V80H48zM0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM304 272V432h96V272H304zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V272zM144 368H48v64h96V368zM48 320h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zM304 80v64h96V80H304zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80z"]
};
var faSquareChevronDown = {
  prefix: 'far',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM207 345L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z"]
};
var faChevronSquareDown = faSquareChevronDown;
var faCommentPlus = {
  prefix: 'far',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM232 328c0 13.3 10.7 24 24 24s24-10.7 24-24V264h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faTriangleInstrument = {
  prefix: 'far',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V67.3c-21.3 5.9-40 19.5-52.1 38.7L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94H450c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L448.2 239l-34.8 34.8 75.5 119.5c4.6 7.4 7.1 15.9 7.1 24.6c0 25.4-20.6 46-46 46H126c-25.4 0-46-20.6-46-46c0-8.7 2.5-17.2 7.1-24.6L252.4 131.6c7.7-12.2 21.1-19.6 35.6-19.6s27.9 7.4 35.6 19.6l46 72.9-62.8 62.8c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l55.1-55.1 34.8-34.8L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6L364.1 106C352 86.8 333.3 73.2 312 67.3V24z"]
};
var faTriangleMusic = faTriangleInstrument;
var faWheelchair = {
  prefix: 'far',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.5 247.2C78.1 263.2 48 304.1 48 352c0 61.9 50.1 112 112 112c42.8 0 80-24 98.9-59.3c6.2-11.7 20.8-16.1 32.5-9.9s16.1 20.8 9.9 32.5C274.3 477.7 221.2 512 160 512C71.6 512 0 440.4 0 352c0-68.5 43.1-126.9 103.5-149.7c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9zm67.2-118.8c13-2.4 25.5 6.3 27.9 19.3l5.1 28.3H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H229.5l13.4 73.4c.7 3.8 4 6.6 7.9 6.6H373.5c15.9 0 30.3 9.4 36.6 24l43 98.3 27.2-9.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-48 16c-11.8 3.9-24.6-1.8-29.6-13.1L368.3 352H250.7c-27.1 0-50.3-19.4-55.1-46L168.4 156.3c-2.4-13 6.3-25.5 19.3-27.9z"]
};
var faUserPilotTie = {
  prefix: 'far',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M217.9 .8l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zM183.2 65.7L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm91.6 183.2L208 416l-12.2 48.9 0 0-.5-.9 0 0L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512H168h0 1 21.2H192v0h64v0h1.7 21.2 1 0H422.4c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.8 464l0 0-.5 .9 0 0L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2H201.9c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464H50.9c7.2-27 27.3-48.8 53.2-58.5L139.2 464zm257.8 0H308.8l35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z"]
};
var faPianoKeyboard = {
  prefix: 'far',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M528 224V384c0 8.8-7.2 16-16 16H432V315.7c9.6-5.5 16-15.9 16-27.7V224h80zM400 400H304V315.7c9.6-5.5 16-15.9 16-27.7V224h64v64c0 11.8 6.4 22.2 16 27.7V400zm-128 0H176V315.7c9.6-5.5 16-15.9 16-27.7V224h64v64c0 11.8 6.4 22.2 16 27.7V400zm-128 0H64c-8.8 0-16-7.2-16-16V224h80v64c0 11.8 6.4 22.2 16 27.7V400zM528 176H416 288 160 48V128c0-8.8 7.2-16 16-16H512c8.8 0 16 7.2 16 16v48zm48 0V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v48 24 24V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224 200 176z"]
};
var faBedEmpty = {
  prefix: 'far',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V184 360v96c0 13.3 10.7 24 24 24s24-10.7 24-24V384H592v80c0 13.3 10.7 24 24 24s24-10.7 24-24V360 280c0-66.3-53.7-120-120-120H48V56zM592 336H48V208H520c39.8 0 72 32.2 72 72v56z"]
};
var faCircleArrowUp = {
  prefix: 'far',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM361 223l-88-88c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47V360c0 13.3 10.7 24 24 24s24-10.7 24-24V209.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
var faArrowCircleUp = faCircleArrowUp;
var faToggleOn = {
  prefix: 'far',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144H384c79.5 0 144-64.5 144-144s-64.5-144-144-144H192zM0 256C0 150 86 64 192 64H384c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm384-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faRectangleVertical = {
  prefix: 'far',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 384zM384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384z"]
};
var faRectanglePortrait = faRectangleVertical;
var faPersonWalking = {
  prefix: 'far',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm11.7 128.8l-29.9 89.8c-1.1 3.2 0 6.6 2.5 8.7l16.4 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1zm57.6 53.1l-28.5 91.3 50.1 40.7c6.9 5.6 11.7 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L114 312.6C96 297.9 88.9 273.5 96.2 251.4L119 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7L19.5 217c17.1-38.5 49.6-68 89.5-81.3c15.3-5.1 31.3-7.7 47.4-7.7h4.9c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L313 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L250 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7zM75.5 402.5l24.1-60.4 39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5z"]
};
var faWalking = faPersonWalking;
var faL = {
  prefix: 'far',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M56 32c13.3 0 24 10.7 24 24V432H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24z"]
};
var faSignalStream = {
  prefix: 'far',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M99.8 69.4c10.2 8.4 11.6 23.6 3.2 33.8C68.6 144.7 48 197.9 48 256s20.6 111.3 55 152.8c8.4 10.2 7 25.3-3.2 33.8s-25.3 7-33.8-3.2C24.8 389.6 0 325.7 0 256S24.8 122.4 66 72.6c8.4-10.2 23.6-11.6 33.8-3.2zm376.5 0c10.2-8.4 25.3-7 33.8 3.2c41.2 49.8 66 113.8 66 183.4s-24.8 133.6-66 183.4c-8.4 10.2-23.6 11.6-33.8 3.2s-11.6-23.6-3.2-33.8c34.3-41.5 55-94.7 55-152.8s-20.6-111.3-55-152.8c-8.4-10.2-7-25.3 3.2-33.8zM248 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-61.1-78.5C170 199.2 160 226.4 160 256s10 56.8 26.9 78.5c8.1 10.5 6.3 25.5-4.2 33.7s-25.5 6.3-33.7-4.2c-23.2-29.8-37-67.3-37-108s13.8-78.2 37-108c8.1-10.5 23.2-12.3 33.7-4.2s12.3 23.2 4.2 33.7zM427 148c23.2 29.8 37 67.3 37 108s-13.8 78.2-37 108c-8.1 10.5-23.2 12.3-33.7 4.2s-12.3-23.2-4.2-33.7C406 312.8 416 285.6 416 256s-10-56.8-26.9-78.5c-8.1-10.5-6.3-25.5 4.2-33.7s25.5-6.3 33.7 4.2z"]
};
var faDownToBracket = {
  prefix: 'far',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M114.2 192L224 302 333.8 192H280c-13.3 0-24-10.7-24-24V48l-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 352c-11.5 0-22.5-4.6-30.6-12.7L77.6 223.2C68.9 214.5 64 202.7 64 190.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 339.3c-8.1 8.1-19.1 12.7-30.6 12.7zM48 344l0 80c0 22.1 17.9 40 40 40l272 0c22.1 0 40-17.9 40-40V344c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faCircleZ = {
  prefix: 'far',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h98.2L164.3 346.3c-5.1 7.3-5.7 16.9-1.5 24.8S175.1 384 184 384H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H229.8L347.7 165.7c5.1-7.3 5.7-16.9 1.5-24.8S336.9 128 328 128H184z"]
};
var faStars = {
  prefix: 'far',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zM115.7 346.2L75.5 307l55.5-8.1c15.6-2.3 29.2-12.1 36.1-26.3l24.8-50.3 24.8 50.3c7 14.2 20.5 24 36.1 26.3l55.5 8.1-40.2 39.2c-11.3 11-16.4 26.9-13.8 42.4l9.5 55.4-49.5-26.1c-14-7.4-30.7-7.4-44.7 0L120 444l9.5-55.4c2.7-15.6-2.5-31.4-13.8-42.4zm54.7-188.8l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94c-8.8-17.9-34.3-17.9-43.1 0zm258.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
};
var faFire = {
  prefix: 'far',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M89.3 156.3C113 115 143.2 77 170.5 50.4c18.7 18.7 40.9 47.2 60.1 71.7c3.8 4.8 7.4 9.5 10.9 13.9c4.6 5.8 11.7 9.2 19.1 9.1s14.4-3.6 18.9-9.5c3.3-4.3 7.7-10.8 12.3-17.4c2.6-3.8 5.3-7.6 7.8-11.2c5.6-7.9 10.5-14.5 14.4-19.1c20 20.8 41 53 57.4 88.4c17.7 38.2 28.6 77 28.6 106.3c0 103-78.8 181.4-176 181.4c-98.3 0-176-78.4-176-181.4c0-37.5 16.2-82.4 41.3-126.2zM199.5 11.6C183.3-3.8 158-3.9 141.8 11.5c-32 30.1-67 73.6-94.1 121C20.7 179.5 0 233 0 282.6C0 410.9 98.1 512 224 512c124.6 0 224-100.9 224-229.4c0-39.1-13.9-85.2-33.1-126.5C395.7 114.6 369.8 74.9 343 49c-16.3-15.8-42-15.8-58.3-.1c-7.9 7.6-17 20-24.3 30.3l-1.1 1.6C240.6 57 218.4 29.5 199.5 11.6zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"]
};
var faBedPulse = {
  prefix: 'far',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM288 216c0-27.3 19.5-50 45.4-55l20 30.1c4.7 7 10.8 12.7 17.8 16.9H344c-4.4 0-8 3.6-8 8V368H592V280c0-39.8-32.2-72-72-72H428.8c9.3-5.6 17-13.9 21.8-24.2L461.9 160H520c66.3 0 120 53.7 120 120V392 496c0 13.3-10.7 24-24 24s-24-10.7-24-24V416H312 48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V392 88C0 74.7 10.7 64 24 64s24 10.7 24 24V368H288V216zm-80 32a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM80 248a88 88 0 1 1 176 0A88 88 0 1 1 80 248z"]
};
var faProcedures = faBedPulse;
var faHouseDay = {
  prefix: 'far',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M174.2 8.3C171.4 3.2 166-.1 160.1-.1s-11.3 3.2-14.1 8.4L118.4 59.5 62.8 42.8c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6L42.8 257.4c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7 6.2 11.5 24-19.6 14.5-11.8c-1 0-2.1 .1-3.1 .1c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 6.6-.8 13-2.3 19.2l54.6-44.5-31.7-17.1 16.7-55.7c1.7-5.6 .1-11.7-4-15.9s-10.3-5.7-15.9-4L201.8 59.5 174.2 8.3zM208 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm207.2-58.6c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4L224 294.4V456c0 30.9 25.1 56 56 56H520c30.9 0 56-25.1 56-56V294.4l24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3V456c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V255.3L400 151 528 255.3zM352 312v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24z"]
};
var faShuttleSpace = {
  prefix: 'far',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", "M32 384H24c-13.3 0-24-10.7-24-24V328 184 152c0-13.3 10.7-24 24-24h8V80c0-26.5 21.5-48 48-48h50c40.6 0 80.4 11 115.2 31.9L405.3 160H456c69.3 0 135 22.7 179.2 81.6c6.4 8.5 6.4 20.3 0 28.8C591 329.3 525.3 352 456 352H405.3L245.2 448.1C210.4 469 170.6 480 130 480H80c-26.5 0-48-21.5-48-48V384zm280-32H168c-9.9 13.2-23.9 23.3-40 28.3V432h2c31.9 0 63.2-8.7 90.6-25.1L312 352zm0-192l-91.5-54.9C193.2 88.7 161.9 80 130 80h-2v51.7c16.1 5.1 30.1 15.1 40 28.3H312zM48 184V328v8h56c12.7 0 23.8-7.4 28.9-18.3c4-8.4 12.4-13.7 21.7-13.7H456c32.6 0 62.4-5.8 88-18.5V226.5c-25.6-12.6-55.4-18.5-88-18.5H154.6c-9.3 0-17.7-5.3-21.7-13.7C127.8 183.4 116.7 176 104 176H48v8zm416 40c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16z"]
};
var faSpaceShuttle = faShuttleSpace;
var faShirtLongSleeve = {
  prefix: 'far',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", "M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4V392c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V248.4c0-6.7 1.7-13.4 5-19.3l62-112.8c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V128c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7l62 112.8-21 11.6 21-11.6c3.2 5.9 5 12.5 5 19.3V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3C502.1 62.3 477.9 48 451.6 48H444c-.4 0-.9 0-1.3 0c-1 .1-2 0-3 0H421.2c-10.8 45.9-52 80-101.2 80s-90.4-34.1-101.2-80H200.3c-1 .1-2 .1-3 0c-.4 0-.9 0-1.3 0h-7.6zM83.2 62.2C104.3 23.8 144.6 0 188.4 0H196c.8 0 1.5 0 2.3 0c.6 0 1.1 0 1.7 0h24c23 0 37.7 18.2 41.1 35.2C270.3 60.7 292.9 80 320 80s49.7-19.3 54.9-44.8C378.3 18.2 393 0 416 0h24c.6 0 1.1 0 1.7 0c.8 0 1.5 0 2.3 0h7.6c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5V392c0 30.9-25.1 56-56 56H552c-30.9 0-56-25.1-56-56V250.5l-16-29.1V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V221.4l-16 29.1V392c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2z"]
};
var faChartPieSimple = {
  prefix: 'far',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M495.4 240c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6V240H495.4zM176 288c0 26.5 21.5 48 48 48H421.1C394.7 410.6 323.6 464 240 464C134 464 48 378 48 272c0-83.6 53.4-154.7 128-181.1V288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8H272 224V240 66.7z"]
};
var faChartPieAlt = faChartPieSimple;
var faFaceLaugh = {
  prefix: 'far',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
  prefix: 'far',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"]
};
var faAlbumCollectionCircleUser = {
  prefix: 'far',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", "M56 0H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160H442.4c23.9 0 44.4 13 55.4 32l-1.8 0c-26.2 0-51.1 5.7-73.4 16H69.6c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9H348.5c12.3 18.8 28 35.1 46.3 48H99.1c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zm96 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7H463.4c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCandy = {
  prefix: 'far',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", "M309 399.6L198.5 178.7C184.3 201 176 227.5 176 256c0 75.8 58.6 137.9 133 143.6zM233.3 141L360 394.4c17.1-4.9 32.8-12.9 46.7-23.4L280 117.6c-17.1 4.9-32.8 12.9-46.7 23.4zM331 112.4L441.5 333.3C455.7 311 464 284.5 464 256c0-75.8-58.6-137.9-133-143.6zM320 64c88 0 162.1 59.1 184.8 139.8l91.9-49c10.5-5.6 23.5-2.7 30.6 6.9s6.1 22.9-2.3 31.3l-29.6 29.6 29.1 10.9C633.8 237 640 246 640 256s-6.2 19-15.6 22.5l-29.1 10.9L625 319c8.4 8.4 9.4 21.7 2.3 31.3s-20.1 12.5-30.6 6.9l-91.9-49C482.1 388.9 408 448 320 448s-162.1-59.1-184.8-139.8l-91.9 49c-10.5 5.6-23.5 2.7-30.6-6.9S6.6 327.4 15 319l29.6-29.6L15.6 278.5C6.2 275 0 266 0 256s6.2-19 15.6-22.5l29.1-10.9L15 193c-8.4-8.4-9.4-21.7-2.3-31.3s20.1-12.5 30.6-6.9l91.9 49C157.9 123.1 232 64 320 64z"]
};
var faBowlHot = {
  prefix: 'far',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M152 0c13.3 0 24 10.7 24 24v8c0 17.6 8.3 34.2 22.4 44.8C224.6 96.4 240 127.3 240 160v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-17.6-8.3-34.2-22.4-44.8C143.4 95.6 128 64.7 128 32V24c0-13.3 10.7-24 24-24zm-.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1H328c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272H48c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8H184c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272zM304 24v8c0 17.6 8.3 34.2 22.4 44.8C352.6 96.4 368 127.3 368 160v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-17.6-8.3-34.2-22.4-44.8C271.4 95.6 256 64.7 256 32V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSoup = faBowlHot;
var faFlatbread = {
  prefix: 'far',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm361-71L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM241 111c9.4 9.4 9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0zM401 305l-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faHeartCirclePlus = {
  prefix: 'far',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9l0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2l-.1 .1-.1 .1-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faCodeFork = {
  prefix: 'far',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3V192c0 22.1 17.9 40 40 40H304c22.1 0 40-17.9 40-40V156.3c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V192c0 48.6-39.4 88-88 88H248v75.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V280H144c-48.6 0-88-39.4-88-88V156.3C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCity = {
  prefix: 'far',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", "M104 0C90.7 0 80 10.7 80 24V64H72C32.2 64 0 96.2 0 136V440c0 39.8 32.2 72 72 72H240c-10-13.4-16-30-16-48H72c-13.3 0-24-10.7-24-24V136c0-13.3 10.7-24 24-24h8 48 48 48V64 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H128V24c0-13.3-10.7-24-24-24zM464 160c0 26.5 21.5 48 48 48h64c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H448 320c-8.8 0-16-7.2-16-16V224 64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16v96zm48-48V64c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64V224 448c0 35.3 28.7 64 64 64H448 576c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H560 512V112zM352 336c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v32zM368 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368zM352 240c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v32zM496 416h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zM480 304c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H496c-8.8 0-16 7.2-16 16v32zM112 320h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zM96 400c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v32zm16-176h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16z"]
};
var faSignalBarsWeak = {
  prefix: 'far',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", "M80 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM64 384a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
var faSignalAlt1 = faSignalBarsWeak;
var faMicrophoneLines = {
  prefix: 'far',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M240 128v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-26.5 21.5-48 48-48s48 21.5 48 48H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h32zM96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"]
};
var faMicrophoneAlt = faMicrophoneLines;
var faClockTwelve = {
  prefix: 'far',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faPepperHot = {
  prefix: 'far',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zm-256 302.7L261.7 160l42.3 0v22.8l-90.7 148c-24.9 40.7-65.3 69.5-111.9 79.8L66 418.5c-10.5 2.3-18 11.7-18 22.5c0 12.7 10.3 23 23 23h32.1c133.7 0 254.1-68.7 323.6-176h1.4l23.9 47.8C372.3 443.9 244.3 512 103.2 512H71c-39.2 0-71-31.8-71-71c0-33.3 23.1-62.1 55.6-69.3L91 363.8c33.9-7.5 63.2-28.5 81.4-58.1z"]
};
var faCitrusSlice = {
  prefix: 'far',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L7 391zm384.3 .3c-91.1 91.1-235.2 96.2-332.6 15.8l22.4-22.4C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216c0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6zm-40.8-276c13.3 17.8 23.2 38.3 28.7 60.6H289.9l60.6-60.6zM272 208H383.8c.1 2.7 .2 5.3 .2 8c0 40.6-14.4 77.9-38.4 106.9l-82.4-82.4c5.9-10 8.9-21.3 8.9-32.5zm-31.5 55.1l82.4 82.4C293.9 369.6 256.6 384 216 384c-2.7 0-5.3-.1-8-.2V272c11.3 0 22.5-3 32.5-8.9zM115.4 350.6L176 289.9v89.3c-22.3-5.4-42.8-15.3-60.6-28.7z"]
};
var faSheep = {
  prefix: 'far',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M384 135.8V208c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V135.8l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5L561.6 77.4C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4L350.5 97.9c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-203.1-1l-.4-.9c-6.9-16.1-5.7-33.5 1.8-47.9c-7.4-11.8-18.5-21-31.7-26C271.6 65.5 264 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8H464c-11.8 0-23.2-1.8-33.8-5.2c.2 3.1 .6 6.2 1.4 9.3c.3 1.2 .5 2.5 .5 3.9c0 8.8-7.2 16-16 16c-.9 0-1.7-.1-2.5-.2c-24.6-3.8-48 11.9-53.9 36c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4c-20.1-16-49.1-13.3-66 6c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1c-5.9-24.2-29.3-39.8-53.9-36c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9c5.3-21.3-4.6-43.6-24-53.9C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2c24.6 3.8 48-11.9 53.9-36c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5c20.1 16 49.1 13.3 66-6c3-3.4 7.3-5.5 12.1-5.5c5.8 0 10.9 3 13.7 7.8c8 13.3 22 21.9 37.4 23.1c.6 0 1.2 .1 1.7 .1z"]
};
var faUnlock = {
  prefix: 'far',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", "M144 128c0-44.2 35.8-80 80-80c35.6 0 65.8 23.2 76.1 55.4c4.1 12.6 17.6 19.5 30.2 15.5s19.5-17.6 15.5-30.2C329.2 37.2 281 0 224 0C153.3 0 96 57.3 96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V128zM48 256c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256z"]
};
var faColonSign = {
  prefix: 'far',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M255.3 29.6c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7l-13.5 56C103.6 88.3 32 163.2 32 256c0 63 33 117.8 82.9 150.8L96.7 482.4c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7L159 428.7c9.3 3.2 18.9 5.8 28.8 7.7l-11.1 46c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7l13-53.9c39.3-2 75.7-15.1 105.5-36.1c10.8-7.7 13.4-22.6 5.7-33.5s-22.6-13.4-33.5-5.7c-18.8 13.3-41.3 22.5-65.9 26l59.6-247c2.1 1.3 4.2 2.7 6.3 4.2c10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5c-7.1-5-14.5-9.5-22.3-13.6l15.7-65.2c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7L274.3 77.8c-9.6-2.3-19.4-4-29.4-4.9l10.4-43.2zm-72.7 96.4l-55.5 230C98 331 80 295.1 80 256c0-60.1 42.5-112.6 102.7-129.9zM170.3 381.8l63.2-261.6c10.2 .5 20.1 1.9 29.6 4.2L199 389.7c-10-1.7-19.6-4.4-28.7-7.9z"]
};
var faHeadset = {
  prefix: 'far',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208V400.1c0 22.1-17.9 40-40 40L313.6 440c-8.3-14.4-23.8-24-41.6-24H240c-26.5 0-48 21.5-48 48s21.5 48 48 48h32c17.8 0 33.3-9.7 41.6-24l110.4 .1c48.6 0 88.1-39.4 88.1-88V256C512 114.6 397.4 0 256 0S0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm112-32V336c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zM80 256v48c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H160c-44.2 0-80 35.8-80 80zm272-32c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32V224zm80 32c0-44.2-35.8-80-80-80H336c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80V256z"]
};
var faBadgerHoney = {
  prefix: 'far',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M465 112c16.9 0 33.6 3.7 49 10.9L559.2 144H486.9c-49.3 0-97.7 13.4-139.9 38.8l-69.4 41.7c-17 10.2-36.4 15.6-56.2 15.6c-55.4 0-101.1-41.2-108.3-94.6c4.9-.9 9.9-1.4 15-1.4H332.2c27.3 0 54.1-6.3 78.5-18.5l2.5-1.2c16.1-8 33.8-12.2 51.8-12.2zm126.8 64c-.6 4.7-2.8 9-6.1 12.4L583 191l16.4 16.4L583 191c-5.5 5.5-13.8 9.2-23.9 10.1c-67.9 6.4-128.1 37.5-169.4 67.9c-7.8 5.7-11.4 15.6-9.1 25c0 .2 .1 .4 .1 .6l0 0 21.3 128c.8 4.9-2.9 9.3-7.9 9.3H363.1c-3.9 0-7.2-2.8-7.9-6.7L338.3 324.1c-1.9-11.6-11.9-20.1-23.7-20.1H204.6c-9.6 0-18.3 5.7-22.1 14.5l-16 37.3c-5.2 12.1-5.9 25.6-2.2 38.2l8.3 27.7c1.5 5.1-2.3 10.3-7.7 10.3H135.8c-3.5 0-6.6-2.3-7.7-5.7L115 382.6c-1.3-4.4-1.3-9.1-.1-13.5l10.7-37.6c1.8-6.2 1-13-2.3-18.6s-8.6-9.7-14.9-11.3C73.7 292.9 48 261.4 48 224c0-27.3 13.7-51.5 34.7-65.9C95.4 223 152.6 272 221.3 272c25.6 0 50.7-7 72.7-20.1l69.4-41.7c33.2-19.9 70.6-31.5 109.1-33.8c2 8.9 10 15.6 19.5 15.6c9.7 0 17.7-6.9 19.6-16h80.2zM48 323.9c7.8 6.2 16.3 11.6 25.4 15.9l-4.6 16.1c-3.8 13.2-3.7 27.3 .3 40.5l13.1 43.7c7.1 23.7 28.9 39.9 53.6 39.9H165c37.5 0 64.4-36.2 53.6-72.1l-8.3-27.7c-.5-1.8-.4-3.7 .3-5.4l9.8-22.8h73.9l13.5 81.2c4.5 27 27.9 46.8 55.2 46.8h31.1c34.6 0 60.9-31.1 55.2-65.2L430.2 299.3c28.6-19.1 64.3-36.8 103.4-45.6l19.6 31.4c3.1 5 10.4 5 13.6 0l27.8-44.5c8.1-3.8 15.7-9 22.4-15.7l2.6-2.6c13.1-13.1 20.4-30.8 20.4-49.3c0-27.1-15.7-51.7-40.2-63.1L534.2 79.4C512.6 69.2 488.9 64 465 64c-25.4 0-50.5 5.9-73.2 17.3l-2.5 1.2C371.6 91.4 352 96 332.2 96H128C57.3 96 0 153.3 0 224V328c0 13.3 10.7 24 24 24s24-10.7 24-24v-4.1z"]
};
var faH4 = {
  prefix: 'far',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", "M455.5 92.9L421.5 256H592V88c0-13.3 10.7-24 24-24s24 10.7 24 24V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V304H392c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24V224H272V88c0-13.3 10.7-24 24-24s24 10.7 24 24V248 424c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H48V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V248 88C0 74.7 10.7 64 24 64z"]
};
var faStoreSlash = {
  prefix: 'far',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 336 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-6.6 0-13.1-.5-19.4-1.6V336H461L301.2 210.7c1.9-1.2 3.7-2.4 5.5-3.7c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm94.1 73.7L152.4 48H487.6l51.5 81.5 0 0c5.8 9.2 6.4 20.5 2.3 30.1c-3.9 9.2-11.1 14.8-20.1 16c-2 .3-3.9 .4-5.8 .4c-11.7 0-22.2-5.1-29.7-13.2c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-6.9 7.6-16.5 12.5-27.5 13.1L132.9 78.9zm-84 55.7c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5zM365.5 384l-60.9-48H144V254.4c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V336v48 64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L467.1 464H160c-8.8 0-16-7.2-16-16V384H365.5z"]
};
var faRoadCircleXmark = {
  prefix: 'far',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480H360.2c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32H217.7zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faSignalSlash = {
  prefix: 'far',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V407.3l-80-62.7V120c0-13.3-10.7-24-24-24s-24 10.7-24 24V307l-80-62.7V216c0-13.3-10.7-24-24-24c-10.4 0-19.2 6.6-22.6 15.8L38.8 5.1zM576 512l-.2 0h.5l-.2 0zM472 488V467.9l-48-37.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM344 367l-48-37.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V367zM192 288c-13.3 0-24 10.7-24 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V312c0-13.3-10.7-24-24-24zM64 384c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V408c0-13.3-10.7-24-24-24z"]
};
var faUserMinus = {
  prefix: 'far',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H224 178.3zM472 200c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H472z"]
};
var faMarsStrokeUp = {
  prefix: 'far',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", "M175.6 5.8c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.4-14V128H104c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v17.8C59 205.4 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59-146.6-136-158.2V176h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V76.2l16.4 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48zM160 240a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faMarsStrokeV = faMarsStrokeUp;
var faChampagneGlasses = {
  prefix: 'far',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M159.2 12.6c5.7-10.5 18.1-15.2 29.3-11.1L320 49.3 451.5 1.5c11.2-4.1 23.7 .7 29.3 11.1l81.6 151c32.4 60.1 10.6 133.3-45.6 167L552.6 429l55.2-20.1c12.5-4.5 26.2 1.9 30.8 14.3s-1.9 26.2-14.3 30.8l-77.8 28.3-77.8 28.3c-12.5 4.5-26.2-1.9-30.8-14.3s1.9-26.2 14.3-30.8l55.2-20.1-35.8-98.5c-61.2 9.4-121.7-29.6-136.3-92.5L320 188.6l-15.3 65.8c-14.6 62.9-75.1 101.9-136.3 92.5l-35.8 98.5 55.2 20.1c12.5 4.5 18.9 18.3 14.3 30.8s-18.3 18.9-30.8 14.3L93.6 482.3 15.8 454C3.3 449.4-3.1 435.7 1.5 423.2s18.3-18.9 30.8-14.3L87.4 429l35.8-98.4c-56.2-33.7-78.1-106.9-45.6-167l81.6-151zm32.4 41L156.8 118 277 161.7l16.5-71L191.6 53.6zM119.8 186.4c-22.4 41.5-2.8 93.3 41.6 109.4c41.3 15 86.5-9.4 96.5-52.3l8.1-34.7L133.7 160.7l-13.9 25.7zM448.4 53.6L346.5 90.7l16.5 71L483.2 118 448.4 53.6zm71.7 132.7l-13.9-25.7L374 208.8l8.1 34.7c10 42.9 55.2 67.3 96.5 52.3c44.3-16.1 64-67.9 41.6-109.4z"]
};
var faGlassCheers = faChampagneGlasses;
var faTaco = {
  prefix: 'far',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M274.8 38.4c-11-8.6-26.5-8.6-37.5 0L193.1 72.6c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1L71.7 152.9c-2 6.8-6.3 12.8-12.2 16.8L13.4 201C1.9 208.9-2.9 223.6 1.8 236.7l17.1 47.7C70.9 209.2 157.7 160 256 160s185.1 49.2 237.1 124.4l17.1-47.7c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8L424.7 99.3c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1 .2-14.1-2-19.7-6.4L274.8 38.4zM256 240c109.5 0 199.2 84.6 207.4 192H48.6C56.8 324.6 146.5 240 256 240zM32 480H480c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zM168 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHexagonPlus = {
  prefix: 'far',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12H344.3c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlusHexagon = faHexagonPlus;
var faClipboard = {
  prefix: 'far',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHouseCircleExclamation = {
  prefix: 'far',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H394.8c-18.3-12.9-34.1-29.2-46.3-48H336v0H240V320h86.6c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2H232c-22.1 0-40 17.9-40 40V464H144c-17.7 0-32-14.3-32-32V204.8L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faFileArrowUp = {
  prefix: 'far',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM216 408V305.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V408c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faFileUpload = faFileArrowUp;
var faWifi = {
  prefix: 'far',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M39.9 185.7C114.6 119.9 212.6 80 320 80s205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32S91.3 76.4 8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2zM320 256c64.6 0 123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5C196.5 280.7 255.4 256 320 256zm56 168a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faMessages = {
  prefix: 'far',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", "M48 72c0-13.3 10.7-24 24-24H344c13.3 0 24 10.7 24 24V248c0 13.3-10.7 24-24 24H216c-4.7 0-9.4 1.4-13.3 4L144 315.2V296c0-13.3-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V72zM72 0C32.2 0 0 32.2 0 72V248c0 39.8 32.2 72 72 72H96v40c0 8.9 4.9 17 12.7 21.2s17.3 3.7 24.6-1.2l90-60H344c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72H72zM256 376c0 39.8 32.2 72 72 72h88.7l90 60c7.4 4.9 16.8 5.4 24.6 1.2S544 496.9 544 488V448h24c39.8 0 72-32.2 72-72V200c0-39.8-32.2-72-72-72H448v48H568c13.3 0 24 10.7 24 24V376c0 13.3-10.7 24-24 24H520c-13.3 0-24 10.7-24 24v19.2L437.3 404c-3.9-2.6-8.6-4-13.3-4H328c-13.3 0-24-10.7-24-24V352H256v24z"]
};
var faCommentsAlt = faMessages;
var faBath = {
  prefix: 'far',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M101.3 48C89.5 48 80 57.5 80 69.3V256H432h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H432 80 32 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V69.3C32 31 63 0 101.3 0c18.4 0 36 7.3 49 20.3l4.8 4.8c11.1-5.8 23.7-9.1 37-9.1c23.9 0 45.4 10.5 60.1 27.2c9.2-5.3 21.1-4 28.9 3.9c9.4 9.4 9.4 24.6 0 33.9L177 185c-9.4 9.4-24.6 9.4-33.9 0c-7.8-7.8-9.1-19.7-3.9-28.9C122.5 141.4 112 119.9 112 96c0-13.4 3.3-25.9 9.1-37l-4.8-4.8c-4-4-9.4-6.2-15-6.2zM32 336H80v32c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V336h48v32c0 28.4-12.4 54-32 71.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V462.7c-5.2 .9-10.5 1.3-16 1.3H128c-5.5 0-10.8-.5-16-1.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V439.6C44.4 422 32 396.4 32 368V336zM192 64c-17.7 0-32 14.3-32 32c0 10.4 4.9 19.6 12.6 25.5l44.8-44.8C211.6 68.9 202.4 64 192 64z"]
};
var faBathtub = faBath;
var faUmbrellaSimple = {
  prefix: 'far',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M256 0c13.3 0 24 10.7 24 24v9.1c119.6 11.1 215.3 104.5 230 223c2.2 17.5-12.4 31.9-30 31.9H32C14.3 288-.2 273.6 2 256.1C16.7 137.6 112.4 44.2 232 33.1V24c0-13.3 10.7-24 24-24zM458.4 240C436.8 148.3 354.3 80 256 80S75.2 148.3 53.6 240H458.4zM280 438.6c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4V320h48V438.6z"]
};
var faUmbrellaAlt = faUmbrellaSimple;
var faRectangleHistoryCirclePlus = {
  prefix: 'far',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", "M64 464l284.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-26.2 0-51.1 5.7-73.4 16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24H392zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faUnderline = {
  prefix: 'far',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
};
var faPrescriptionBottlePill = {
  prefix: 'far',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M48 48H336V80H48V48zM40 0C17.9 0 0 17.9 0 40V88c0 22.1 17.9 40 40 40H344c22.1 0 40-17.9 40-40V40c0-22.1-17.9-40-40-40H40zM32 160V448c0 35.3 28.7 64 64 64H288c11.6 0 22.4-3.1 31.8-8.4c-13.7-11.3-25.6-24.7-35.3-39.6H96c-8.8 0-16-7.2-16-16V416h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80V320h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80V224h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80V160H32zm320 0H304v87.2c13.8-14.6 30-26.8 48-36V160zm80 112a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM383 319c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faUserPen = {
  prefix: 'far',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464H326.5l-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c48.1 0 91.8 19.1 123.9 50.1L359.6 388c-23.4-22.3-55.1-36-89.9-36H178.3c-65.7 0-120.1 48.7-129 112zM613.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faUserEdit = faUserPen;
var faBinarySlash = {
  prefix: 'far',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V360c0-39.8-32.2-72-72-72H399.7L295.4 206.2C310.5 193 320 173.6 320 152V72c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v3L38.8 5.1zM176 112.6V72c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v80c0 10.7-7 19.7-16.6 22.8L176 112.6zM456 24c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16C363.8 21.4 357 35 361.2 47.6S379 67 391.6 62.8L408 57.3V176H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h56 56c13.3 0 24-10.7 24-24s-10.7-24-24-24H456V24zM232 312c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16c-12.6 4.2-19.4 17.8-15.2 30.4s17.8 19.4 30.4 15.2l16.4-5.5V464H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h56 56c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V312zm88 48v80c0 39.8 32.2 72 72 72h48c22.2 0 42-10 55.2-25.8l-37.8-29.7c-4.4 4.7-10.6 7.6-17.5 7.6H392c-13.3 0-24-10.7-24-24V385.9l-47.1-37.1c-.6 3.7-.9 7.4-.9 11.2z"]
};
var faSquareO = {
  prefix: 'far',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM144 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faSignature = {
  prefix: 'far',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48v7.9c0 27.5-2.3 55-7 82.1L158 251.1c-36.9 11.4-62 45.5-62 84.1V410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H450.1l28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96s-96 43-96 96v40c0 13.3 10.7 24 24 24s24-10.7 24-24V128zm-3.8 169l80.9-25c-11.7 43.2-29.4 84.5-52.4 123l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22V335.2c0-17.5 11.4-33 28.2-38.2zM64 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.2c-.1-2-.2-4-.2-6V368zm216.8 48H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H304.1c-7 16.3-14.8 32.4-23.3 48z"]
};
var faStroopwafel = {
  prefix: 'far',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm97.6-45.3l22.6 22.6 45.3-45.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3L210.7 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256 437 278.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3L97.6 301.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm90.5 0L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zM256 233.4l45.3-45.3L256 142.9l-45.3 45.3L256 233.4zM278.6 256l45.3 45.3L369.1 256l-45.3-45.3L278.6 256zM256 278.6l-45.3 45.3L256 369.1l45.3-45.3L256 278.6z"]
};
var faBold = {
  prefix: 'far',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M0 56C0 42.7 10.7 32 24 32H72 88 212c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124H88 72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48V256 80H24C10.7 80 0 69.3 0 56zM212 232c42 0 76-34 76-76s-34-76-76-76H96V232H212zM96 280V432H244c42 0 76-34 76-76s-34-76-76-76H212 96z"]
};
var faAnchorLock = {
  prefix: 'far',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V464H240c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h48 48c18.3 0 36.1-2.7 52.8-7.7c-3.1-7.5-4.8-15.7-4.8-24.3V455.3c-14.9 5.6-31.1 8.7-48 8.7H312V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faBuildingNgo = {
  prefix: 'far',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", "M320 48H64 2C9.1 20.4 34.2 0 64 0H320c29.8 0 54.9 20.4 62 48H320zm16 192h48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V240H48V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V240zM168 80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V96c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V128zM61.3 87.1l34.7 52V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM88 264c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V264zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V264c0-8.8 7.2-16 16-16z"]
};
var faTransporter3 = {
  prefix: 'far',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", "M480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM64 128l-7.3-25.4C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128zm56 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faEngineWarning = {
  prefix: 'far',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M424 88c0 13.3-10.7 24-24 24l-72 0v32l68.6 0c12.6 0 25 3.7 35.5 10.7L483.5 189c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-35.3 0-64-28.7-64-64V280H48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72H80V208c0-35.3 28.7-64 64-64h16 32l88 0V112l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24H400c13.3 0 24 10.7 24 24zM210.3 354l32 40c3 3.8 7.6 6 12.5 6H448c8.8 0 16-7.2 16-16V242.3c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7H192 160 144c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16h28.8c14.6 0 28.4 6.6 37.5 18zM544 224c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224zM304 212c11 0 20 9 20 20v56c0 11-9 20-20 20s-20-9-20-20V232c0-11 9-20 20-20zM280 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faEngineExclamation = faEngineWarning;
var faCircleDownRight = {
  prefix: 'far',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 198.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6L280 216l-66.3-66.3C210 146 205.1 144 200 144s-10 2-13.7 5.7l-36.7 36.7C146 190 144 194.9 144 200s2 10 5.7 13.7L216 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6H336c8.8 0 16-7.2 16-16V198.6z"]
};
var faSquareK = {
  prefix: 'far',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm313.1 72.8l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z"]
};
var faManatSign = {
  prefix: 'far',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M192 32c-13.3 0-24 10.7-24 24V97.5C73.3 109.3 0 190.1 0 288V456c0 13.3 10.7 24 24 24s24-10.7 24-24V288c0-71.4 51.9-130.6 120-142V456c0 13.3 10.7 24 24 24s24-10.7 24-24V146c68.1 11.4 120 70.7 120 142V456c0 13.3 10.7 24 24 24s24-10.7 24-24V288c0-97.9-73.3-178.7-168-190.5V56c0-13.3-10.7-24-24-24z"]
};
var faMoneyCheckPen = {
  prefix: 'far',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M64 112H512c8.8 0 16 7.2 16 16v91.6l6.6-6.6c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.5l6-23.9c2.2-8.8 6.2-17 11.8-24.1H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm56 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 200c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm517.8 35.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
};
var faMoneyCheckEdit = faMoneyCheckPen;
var faNotEqual = {
  prefix: 'far',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M373.5 36.2c11 7.5 13.8 22.4 6.3 33.3L329.2 144H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H296.5l-87 128H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H176.9l-69 101.5c-7.5 11-22.4 13.8-33.3 6.3s-13.8-22.4-6.4-33.3L118.8 368H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H151.5l87-128H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H271.1l69-101.5c7.5-11 22.4-13.8 33.3-6.4z"]
};
var faBorderTopLeft = {
  prefix: 'far',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-352c0-13.3 10.7-24 24-24l352 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32C32.2 32 0 64.2 0 104L0 456zm128-40a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBorderStyle = faBorderTopLeft;
var faMapLocationDot = {
  prefix: 'far',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M408 120c0 8.6-1.8 18.3-5 28.6c-5.7 18.4-15.6 38.8-27.4 59.2l-.1 .2c-3.1 5.4-6.3 10.7-9.6 16c-4.4 7-8.9 14-13.5 20.8l-.4 .6c-18.1 26.9-36.7 51.1-49.2 66.6c-7.7 9.6-22 9.6-29.6 0c-12.4-15.5-31.1-39.7-49.2-66.6c-18.4-27.3-36.3-57.5-46.7-84.4c-.8-2.1-1.6-4.2-2.3-6.3c-4.4-12.6-7-24.4-7-34.6c0-4.7 .3-9.3 .8-13.8C175.6 46.4 226.4 0 288 0c66.3 0 120 53.7 120 120zM352 300.6c13.5-18.2 28.8-39.9 42.7-62.4c1.8-2.9 3.6-5.8 5.3-8.8V453.7l128-46.5V154.3L419.3 193.8c2.2-4.7 4.4-9.3 6.3-14c5.9-14 11-29.2 13.2-44.2l105-38.2c7.4-2.7 15.6-1.6 22 2.9s10.2 11.8 10.2 19.7V424c0 10.1-6.3 19.1-15.8 22.6l-176 64c-5.3 1.9-11.1 1.9-16.4 0L200 449.5l-167.8 61c-7.4 2.7-15.6 1.6-22-2.9S0 495.8 0 488V184c0-10.1 6.3-19.1 15.8-22.6L136 117.7c0 .8 0 1.5 0 2.3c0 15.1 3.7 30.7 8.9 45.6L48 200.8V453.7l128-46.5V229.5c1.8 3 3.5 5.9 5.3 8.8c13.9 22.5 29.1 44.2 42.7 62.4V407.2l128 46.5V300.6zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faMapMarkedAlt = faMapLocationDot;
var faTilde = {
  prefix: 'far',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", "M100.5 176c-29 0-52.5 23.5-52.5 52.5V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V228.5C0 173 45 128 100.5 128c29.6 0 57.6 13 76.7 35.6L307.4 317.4c10 11.8 24.6 18.6 40.1 18.6c29 0 52.5-23.5 52.5-52.5V192c0-13.3 10.7-24 24-24s24 10.7 24 24v91.5C448 339 403 384 347.5 384c-29.6 0-57.6-13-76.7-35.6L140.6 194.6c-10-11.8-24.6-18.6-40.1-18.6z"]
};
var faJedi = {
  prefix: 'far',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M224.8 267.9L246 299.7c1.3 1.9 .2 4.5-2 4.9l-37.6 7.5c-3.7 .7-6.4 4-6.4 7.8s2.7 7.1 6.4 7.8l37.6 7.5c2.2 .4 3.3 3 2 4.9l-21.2 31.9c-2.1 3.2-1.7 7.4 1 10.1s6.9 3.1 10.1 1l26.9-17.9c2.2-1.4 5.1 .2 5 2.8l-2.1 61.7C214.5 419.4 176 374.2 176 320c0-29.6 11.5-56.5 30.2-76.5c4.5-4.8 6.8-11.2 6.4-17.7s-3.3-12.6-8.3-16.9C177.2 185.4 160 150.7 160 112c0-26.9 8.3-51.9 22.5-72.5c6.4-9.3 5.5-21.7-2.2-30s-20-10-29.7-4.4C70.1 52.4 16 139.9 16 240c0 150.2 121.8 272 272 272s272-121.8 272-272C560 139.9 505.9 52.4 425.4 5.2c-9.7-5.7-22.1-3.9-29.7 4.4s-8.6 20.7-2.2 30C407.7 60.1 416 85.1 416 112c0 38.7-17.2 73.4-44.4 96.9c-4.9 4.3-7.9 10.4-8.3 16.9s2 12.9 6.4 17.7c18.8 20 30.2 46.9 30.2 76.5c0 54.2-38.5 99.4-89.7 109.8l-2.1-61.7c-.1-2.6 2.8-4.2 5-2.8l26.9 17.9c3.2 2.1 7.4 1.7 10.1-1s3.1-6.9 1-10.1L330 340.3c-1.3-1.9-.2-4.5 2-4.9l37.5-7.5c3.7-.7 6.4-4 6.4-7.8s-2.7-7.1-6.4-7.8L332 304.6c-2.2-.4-3.3-3-2-4.9l21.2-31.9c2.1-3.2 1.7-7.4-1-10.1s-6.9-3.1-10.1-1l-30 20c-2.1 1.4-4.9 0-5-2.6L296.3 8c-.1-4.5-3.8-8-8.3-8s-8.1 3.5-8.3 8l-8.9 266.2c-.1 2.5-2.9 3.9-5 2.6l-30-20c-3.2-2.1-7.4-1.7-10.1 1s-3.1 6.9-1 10.1zM64.1 233.5c.3-10.7 1.4-21.3 3.1-31.6l17.5 17.5c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L76.5 165.9c8.3-23.7 20.5-45.6 35.8-64.9c-.2 3.6-.3 7.3-.3 11c0 44.9 16.8 85.8 44.4 116.9C138.5 254.8 128 286.2 128 320c0 44.5 18.1 84.7 47.4 113.7c-54.9-32-94.9-86.6-107.4-151l16.6 16.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L64.1 233.5zm447.8 0l-43.2 43.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16.6-16.6c-12.4 64.4-52.5 119.1-107.4 151c29.3-29 47.4-69.2 47.4-113.7c0-33.8-10.5-65.2-28.4-91.1c27.6-31.1 44.4-72 44.4-116.9c0-3.7-.1-7.4-.3-11c15.3 19.3 27.5 41.2 35.8 64.9l-30.8 30.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17.5-17.5c1.8 10.3 2.8 20.9 3.1 31.6z"]
};
var faSquarePollVertical = {
  prefix: 'far',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 224c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm72-72c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zM320 288c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24z"]
};
var faPoll = faSquarePollVertical;
var faArrowDownSquareTriangle = {
  prefix: 'far',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm481 78c0-4.5-1.2-9-3.6-12.9L440.2 301.7c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1zM368 80h96v96H368V80zm94.4 352H369.6L416 354.6 462.4 432zM320 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faSortShapesDownAlt = faArrowDownSquareTriangle;
var faMugHot = {
  prefix: 'far',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", "M88 0c13.3 0 24 10.7 24 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C152.6 76.6 176 97.1 176 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C87.4 83.4 64 62.9 64 24C64 10.7 74.7 0 88 0zM48 416c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V240H48V416zM0 224c0-17.7 14.3-32 32-32H352h48c61.9 0 112 50.1 112 112s-50.1 112-112 112H384c0 53-43 96-96 96H96c-53 0-96-43-96-96V224zM384 368h16c35.3 0 64-28.7 64-64s-28.7-64-64-64H384V368zM224 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C264.6 76.6 288 97.1 288 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C199.4 83.4 176 62.9 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faDogLeashed = {
  prefix: 'far',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M69.6 8.6C78.1-1.6 93.3-2.9 103.4 5.6L292.6 164.5 313.5 39.3l.1-.4 .9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1l11.2 14.9 3.4 4.6 .2 .3L368 32h76.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v32c0 53-43 96-96 96H434.7L432 256V448c0 35.3-28.7 64-64 64H352c-35.3 0-64-28.7-64-64V428.6 379.6c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2v48.9V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224c0-1.3 .1-2.6 .2-3.8c-1.1-.3-2.2-.7-3.3-1.1c-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l0 0 3.9 15.5C55.6 163.5 71.6 176 90 176h54 87.6L72.6 42.4C62.4 33.9 61.1 18.7 69.6 8.6zM318 342.2c11.4 9.1 18 22.9 18 37.4V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V274.8l-96-48V331.6c10.8 0 21.4 3.7 30 10.6zm-78-6.4V224H144 112.1l-.1 .8V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V379.6c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c7 1.5 14.2 2.6 21.6 3zm94.2-139.5l55.3 27.6c6.7-18.8 24.6-31.9 45.2-31.9H480c26.5 0 48-21.5 48-48V112H496c-12.7 0-24.9-5.1-33.9-14.1L444.1 80 368 80c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.7 4.4-2 8.5-3.8 12.4zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faCarBattery = {
  prefix: 'far',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zM64 144c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H64zm304 32c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V192c0-8.8 7.2-16 16-16zM96 224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faBatteryCar = faCarBattery;
var faFaceDowncastSweat = {
  prefix: 'far',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M35.2 126.3C14.9 120.8 0 102.7 0 81C0 61 28.6 20.6 41.6 3.3c3.2-4.4 9.6-4.4 12.8 0c9.5 12.6 27.1 37.2 36 57.5c.3 .7 .6 1.4 .9 2.1C94.2 69.7 96 76 96 81c0 26-21.5 47-48 47c-4.4 0-8.7-.6-12.8-1.7zm81.4-85.1C156.7 15.2 204.6 0 256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-35.8 7.3-69.9 20.6-100.8c8.6 3.1 17.8 4.8 27.4 4.8c8.9 0 17.6-1.5 25.7-4.2C57.3 185.5 48 219.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208s-93.1-208-208-208c-48.7 0-93.4 16.7-128.9 44.7c.6-3.8 .9-7.7 .9-11.7c0-11.4-3.8-22.4-7.1-30.5c-1.3-3.1-2.7-6.2-4.3-9.3zM96 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm208-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM183.6 409.5c-9.7-9-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2z"]
};
var faMailboxFlagUp = {
  prefix: 'far',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M376 224c-13.3 0-24-10.7-24-24V88 56c0-13.3 10.7-24 24-24h64c13.3 0 24 10.7 24 24V88c0 13.3-10.7 24-24 24H400v88c0 13.3-10.7 24-24 24zM144 112c-53 0-96 43-96 96V384c0 8.8 7.2 16 16 16H240V208c0-53-43-96-96-96zm107.3 0c22.8 25.5 36.7 59.1 36.7 96V400H512c8.8 0 16-7.2 16-16V208c0-34.9-18.7-65.5-46.6-82.3c9.1-9.9 14.6-23.2 14.6-37.7V79c47.4 23.6 80 72.5 80 129V384c0 35.3-28.7 64-64 64H288 240 64c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64l176 0V88v24H251.3zM104 192h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMemoCircleInfo = {
  prefix: 'far',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M320 48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-17.2 4.9-33.4 12.3-48 21.8V64c0-8.8-7.2-16-16-16zM96 152c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm24 72H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm312-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16h0v48h0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z"]
};
var faGift = {
  prefix: 'far',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M231.9 44.4C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88c0 14.4 3.5 28 9.6 40H48c-26.5 0-48 21.5-48 48v64c0 20.9 13.4 38.7 32 45.3V288 448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288v-2.7c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176v64H432 288V176h72H464zm-240 0v64H80 48V176H152h72zm0 112V464H96c-8.8 0-16-7.2-16-16V288H224zm64 176V288H432V448c0 8.8-7.2 16-16 16H288zm72-336H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0H152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8L225.3 128H224z"]
};
var faDiceTwo = {
  prefix: 'far',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faVolume = {
  prefix: 'far',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M191.9 201.9L304 102.3V409.7L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H88c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM322.2 32c-7.3 0-14.3 2.7-19.8 7.5L166.9 160H88c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C352 45.3 338.7 32 322.2 32zm182.9 75c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C466.1 312.9 480 286.1 480 256s-13.9-56.9-35.4-74.5z"]
};
var faVolumeMedium = faVolume;
var faTransporter5 = {
  prefix: 'far',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", "M224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H224zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM64 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 160 6.6 167.3C2.7 168.4 0 171.9 0 176s2.7 7.6 6.6 8.7L32 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 160zM472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32 472.7 6.6z"]
};
var faGaugeCircleBolt = {
  prefix: 'far',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24V301.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.7 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faCoinFront = {
  prefix: 'far',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm24-248c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faFileSlash = {
  prefix: 'far',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V154.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zM176 112.6V64c0-8.8 7.2-16 16-16H352v80c0 17.7 14.3 32 32 32h80V338.4L176 112.6zM448 464H192c-8.8 0-16-7.2-16-16V234.7l-48-37.8V448c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.8l-37.7-29.7c-2.9 3.4-7.3 5.5-12.1 5.5z"]
};
var faMessageArrowUpRight = {
  prefix: 'far',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM216 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H216z"]
};
var faTreasureChest = {
  prefix: 'far',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", "M160 80H416V240H352V224c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v16H160V80zM48 160c0-38.7 27.5-71 64-78.4V240H48l0-80zm0 272l0-144h64V432H48zM416 288V432H160V288h64v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288h64zM528 432H464V288h64V432zm0-272v80H464V81.6c36.5 7.4 64 39.7 64 78.4zM128 32C57.3 32 0 89.3 0 160V432c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48V160c0-70.7-57.3-128-128-128H128zM304 256v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessQueen = {
  prefix: 'far',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352H153l-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432H378.8l16.6 32H116.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H407.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"]
};
var faPaintbrushFine = {
  prefix: 'far',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M489 57L306.2 239.7l30.1 30.1L519 87c8.3-8.3 8.3-21.8 0-30.1s-21.8-8.3-30.1 0zM210.5 325c-8.2-3.3-17.2-5-26.5-5c-39.8 0-72 32.2-72 72c0 3.8 .3 7.5 .8 11.1c3.3 21.4-2.2 43.1-13.8 60l-.7 .9H184c39.8 0 72-32.2 72-72c0-9.4-1.8-18.3-5-26.5L210.5 325zm-6.2-51.3L455 23c27-27 70.9-27 97.9 0s27 70.9 0 97.9L302.3 371.7c1.1 6.6 1.7 13.4 1.7 20.3c0 66.3-53.7 120-120 120H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h6c18.1 0 30.1-19.8 27.4-37.6c-.9-6-1.4-12.1-1.4-18.4c0-66.3 53.7-120 120-120c6.9 0 13.7 .6 20.3 1.7z"]
};
var faPaintBrushAlt = faPaintbrushFine;
var faPaintBrushFine = faPaintbrushFine;
var faPaintbrushAlt = faPaintbrushFine;
var faGlasses = {
  prefix: 'far',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6v5.2c0 .5 0 1 0 1.5V352c0 .2 0 .4 0 .6V368c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352v16c0 35.3 28.7 64 64 64h44.3c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2V352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5H464c35.3 0 64-28.7 64-64V314.2c-27.2-11.8-58.2-18.2-87.7-18.2z"]
};
var faHoodCloak = {
  prefix: 'far',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", "M454.4 15.3c3 7.7 1.8 16.2-2.9 22.7c-1 1.3-2.1 2.6-3.3 3.7l-32 29c11.4 10.2 22.6 21.8 33.1 34.8C484.5 149.1 512 208.6 512 288c0 58.5 14.6 101.6 28.6 129.7c7 14.1 14 24.5 19 31.1c2.5 3.3 4.5 5.7 5.7 7.1c.6 .7 1.1 1.2 1.3 1.4l.1 .1 0 0 0 0 0 0c9 9.2 11.7 22.8 6.8 34.7c-5 12-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8c-4.9-11.9-2.2-25.6 6.8-34.7l.2-.2c.2-.2 .7-.7 1.3-1.4c1.3-1.4 3.2-3.8 5.7-7.1c5-6.6 11.9-17 19-31.1C49.4 389.6 64 346.5 64 288C64 151.8 111.4 76.9 167.7 37.7C222 0 278.2 0 288 0h0H432c9.9 0 18.8 6.1 22.4 15.3zm43.3 423.8c-17-34-33.7-84.4-33.7-151.2c0-86.7-38.5-144.2-79.9-181.5c-10.1-9.1-15.9-22-15.9-35.6c0-8.1 2-16 5.8-22.9H288h0c-7.2 0-51 0-92.8 29.1C154.3 105.5 112 164 112 288c0 66.8-16.7 117.2-33.7 151.2c-4.8 9.6-9.6 17.9-14.1 24.8H160V336c0-70.7 57.3-128 128-128s128 57.3 128 128V464h95.8c-4.5-7-9.3-15.2-14.1-24.8zM208 464H368V336c0-44.2-35.8-80-80-80s-80 35.8-80 80V464z"]
};
var faSquareQuote = {
  prefix: 'far',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 240V216 192c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V240zm144 39.3V240 216 192c0-17.7-14.3-32-32-32H272c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71z"]
};
var faUpLeft = {
  prefix: 'far',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", "M64 128V321.4c0 1.7 .8 3.2 2.1 4.2c2.1 1.6 5 1.4 6.9-.5L127 271c9.4-9.4 24.6-9.4 33.9 0L285.7 395.7c2.7 2.7 6.5 4.3 10.3 4.3s7.6-1.5 10.3-4.3l25.4-25.4c2.7-2.7 4.3-6.5 4.3-10.3s-1.5-7.6-4.3-10.3L207 225c-9.4-9.4-9.4-24.6 0-33.9L261.1 137c1.8-1.8 2.1-4.8 .5-6.9c-1-1.3-2.5-2.1-4.2-2.1H64zm-48-8c0-22.1 17.9-40 40-40H257.4c16.8 0 32.5 7.9 42.6 21.3c15.9 21.2 13.8 50.9-4.9 69.6L257.9 208 365.7 315.7C377.4 327.5 384 343.4 384 360s-6.6 32.5-18.3 44.3l-25.4 25.4C328.5 441.4 312.6 448 296 448s-32.5-6.6-44.3-18.3L144 321.9 106.9 359c-18.7 18.7-48.4 20.8-69.6 5C23.9 353.9 16 338.1 16 321.4V120z"]
};
var faBringFront = {
  prefix: 'far',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", "M64 48H192c8.8 0 16 7.2 16 16h48c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64h64V208H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zM448 512H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H512v48h64c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16H384c0 35.3 28.7 64 64 64zM224 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224z"]
};
var faChessBoard = {
  prefix: 'far',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 0v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"]
};
var faBurgerCheese = {
  prefix: 'far',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1H423.6c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224H61.1C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432H384c20.9 0 38.7-13.4 45.3-32H82.7c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32c0 53-43 96-96 96H128c-53 0-96-43-96-96zM253.5 262.8l52.2 26.1c9 4.5 19.6 4.5 28.6 0l52.2-26.1c8.9-4.4 18.7-6.8 28.6-6.8H432h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H208h16.9c9.9 0 19.7 2.3 28.6 6.8z"]
};
var faCheeseburger = faBurgerCheese;
var faBuildingCircleCheck = {
  prefix: 'far',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", "M64 48H320c8.8 0 16 7.2 16 16V294.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1V448c0 8.8-7.2 16-16 16H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H232zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faRepeat1 = {
  prefix: 'far',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M0 254.8C-.6 268 9.6 279.3 22.8 280s24.5-9.5 25.2-22.8l.4-8C52 176.8 111.7 120 184.2 120H304v36.4c0 19.6 15.9 35.6 35.6 35.6c8.8 0 17.3-3.3 23.8-9.1l76.7-69c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-76.7-69c-6.5-5.9-15-9.1-23.8-9.1C319.9 0 304 15.9 304 35.6L304 72H184.2C86.2 72 5.3 148.9 .4 246.8l-.4 8zM388.1 96L352 128.5l0-65L388.1 96zM512 257.2c.7-13.2-9.5-24.5-22.8-25.2s-24.5 9.5-25.2 22.8l-.4 8C460 335.2 400.3 392 327.8 392H208V355.6c0-19.6-15.9-35.6-35.6-35.6c-8.8 0-17.3 3.3-23.8 9.1l-76.7 69c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l76.7 69c6.5 5.9 15 9.1 23.8 9.1c19.6 0 35.6-15.9 35.6-35.6V440H327.8c98 0 178.9-76.9 183.8-174.8l.4-8zM123.9 416L160 383.5v65L123.9 416zM288 208c0-9.1-5.1-17.4-13.3-21.5s-17.9-3.2-25.1 2.3l-32 24c-10.6 8-12.8 23-4.8 33.6c6.5 8.6 17.6 11.6 27.2 8.2V304c0 13.3 10.7 24 24 24s24-10.7 24-24V208z"]
};
var faArrowDownToLine = {
  prefix: 'far',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M360 480c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0zM174.5 344.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 267.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 175.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136z"]
};
var faArrowToBottom = faArrowDownToLine;
var faGrid5 = {
  prefix: 'far',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M0 48c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H16C7.2 96 0 88.8 0 80V48zm0 96c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V144zm16 80H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V336zm16 80H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V432zM208 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM192 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM192 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM288 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM288 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM288 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V432zM400 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM384 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM384 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16z"]
};
var faSwapArrows = {
  prefix: 'far',
  iconName: 'swap-arrows',
  icon: [640, 512, [], "e60a", "M111 7c9.4-9.4 24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47V360c0 39.8 32.2 72 72 72s72-32.2 72-72V152c0-66.3 53.7-120 120-120s120 53.7 120 120l0 278.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47V152c0-39.8-32.2-72-72-72s-72 32.2-72 72V360c0 66.3-53.7 120-120 120s-120-53.7-120-120l0-278.1L57 129c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L111 7z"]
};
var faRightLongToLine = {
  prefix: 'far',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M640 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM505.5 272.4c8.7-9.2 8.7-23.7 0-32.9l-121.4-129c-8.8-9.3-21-14.6-33.7-14.6c-25.6 0-46.3 20.7-46.3 46.3l0 33.7L56 176c-30.9 0-56 25.1-56 56l0 48c0 30.9 25.1 56 56 56l248 0 0 33.7c0 25.6 20.7 46.3 46.3 46.3c12.8 0 25-5.3 33.7-14.6l121.4-129zM352 200l0-53.5L455 256 352 365.5l0-53.5c0-13.3-10.7-24-24-24L56 288c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l272 0c13.3 0 24-10.7 24-24z"]
};
var faPersonChalkboard = {
  prefix: 'far',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80H208V304H176V176.1c.7 0 1.5-.1 2.3-.1zM176 488V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V176H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H368V48H592V272H368V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 178.3c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faMarsStrokeRight = {
  prefix: 'far',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M80 256a128 128 0 1 1 256 0A128 128 0 1 1 80 256zm302.4-24C370.7 146.2 297.1 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152H416v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280h78.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H464V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48H382.4z"]
};
var faMarsStrokeH = faMarsStrokeRight;
var faHandBackFist = {
  prefix: 'far',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16V264c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V370.2c38-20.1 64-60.1 64-106.2V160c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64v64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6v12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V359.9c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4V224.6c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V142.3 128 64z"]
};
var faHandRock = faHandBackFist;
var faGridRound5 = {
  prefix: 'far',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faTally = {
  prefix: 'far',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", "M128 40c13.3 0 24 10.7 24 24V286.7L232 260V64c0-13.3 10.7-24 24-24s24 10.7 24 24V244l80-26.7V64c0-13.3 10.7-24 24-24s24 10.7 24 24V201.4l80-26.7V64c0-13.3 10.7-24 24-24s24 10.7 24 24v94.7l64.4-21.5c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4L536 209.3V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V225.3L408 252V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V268l-80 26.7V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V310.6l-80 26.7V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V353.3L39.6 374.8C27 379 13.4 372.2 9.2 359.6S11.8 333.4 24.4 329.2L104 302.7V64c0-13.3 10.7-24 24-24z"]
};
var faTally5 = faTally;
var faSquareCaretUp = {
  prefix: 'far',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"]
};
var faCaretSquareUp = faSquareCaretUp;
var faCloudShowersWater = {
  prefix: 'far',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", "M184.1 107.8C186.3 74.4 214.1 48 248 48c23.4 0 43.9 12.6 55.1 31.5c3.4 5.7 9 9.8 15.5 11.2s13.3 .1 18.8-3.7c6.4-4.4 14.2-7 22.6-7c19.1 0 35.2 13.4 39.1 31.4c2.4 11 12.2 18.9 23.4 18.9h10.6c17 0 30.9 13.8 30.9 30.9s-13.8 30.9-30.9 30.9H142.9c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9h17.3c12.7 0 23.1-9.8 24-22.5zM248 0c-51.6 0-95 34.9-108 82.3c-42.2 1.5-76 36.2-76 78.8c0 43.6 35.3 78.9 78.9 78.9H433.1c43.6 0 78.9-35.3 78.9-78.9c0-41.4-31.8-75.3-72.4-78.6C425.6 52.7 395.2 32 360 32c-10.1 0-19.9 1.7-28.9 4.9C310.6 14.3 281 0 248 0zM132.6 308.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm327.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM244.6 308.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm103.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
var faChartBar = {
  prefix: 'far',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBarChart = faChartBar;
var faHandsBubbles = {
  prefix: 'far',
  iconName: 'hands-bubbles',
  icon: [576, 512, ["hands-wash"], "e05e", "M416 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM528 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM144 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM48 143.8v84.6c0 39.8 16 77.3 43.4 104.7c-14.4 7.6-26.9 18.3-36.6 31.2C20.1 328.3 0 279.8 0 228.4V143.8c0-35.3 28.7-64 64-64c22.6 0 42.5 11.7 53.9 29.4L164.7 28C180.2 1.2 214.4-8 241.2 7.5c3.8 2.2 7.2 4.8 10.3 7.6c17.4-12.7 41.3-14.8 61.1-3.3s30 33.2 27.7 54.6c4 1.2 8 2.9 11.7 5.1c12.4 7.2 21.1 18.4 25.2 31c-21.4-8.7-46.2-9.1-69 1l-53 23.5 20.2-35 0-.1 16-27.7c2.2-3.8 .9-8.7-2.9-10.9s-8.7-.9-10.9 2.9l-8 13.8 0 .1-8 13.9-31.5 54.5c-19.1 9.6-36.4 21.8-51.5 36.1c-9.8-7.1-12.9-20.7-6.7-31.4l48-83.1 0-.1c2.2-3.8 .9-8.7-2.9-10.9s-8.7-.9-10.9 2.9L124.8 193.2c-5.4 9.4-16.5 14-27 11.2S80 192.1 80 181.2V143.8c0-8.8-7.2-16-16-16s-16 7.2-16 16zM326.1 512c-31.3 0-60.7-7.9-86.4-21.8c8.4-13.8 13.9-29.5 15.7-46.4c20.5 12.8 44.7 20.1 70.7 20.1H456c4.4 0 8-3.6 8-8c0-4.4-3.5-7.9-7.9-8H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h63.9l.2 0H488c4.4 0 8-3.6 8-8c0-4.4-3.5-8-7.9-8H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h95.8l.2 0h32c4.4 0 8-3.6 8-8s-3.6-8-8-8H504.2l-.2 0H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h95.8l.2 0c4.4 0 8-3.6 8-8s-3.6-8-8-8H335.9c-11.2 0-21-7.8-23.4-18.8s3-22.2 13.2-27l25.1-11.8c8-3.8 11.4-13.3 7.7-21.3s-13.3-11.4-21.3-7.7l-56.4 26.5c-27.6 13-50.1 33.5-65.5 58.4c-.2 .2-.3 .5-.5 .7c-14.6 21.7-22.8 47.6-22.8 74.8l0 .9c-14.5-6.9-30.7-10.7-47.7-10.8c1.8-33.2 12.6-64.6 30.4-91.3c20.2-32.4 49.6-59.2 85.7-76.1l56.4-26.5c32-15.1 70.1-1.3 85.2 30.7c7.9 16.8 7.9 35.3 1.4 51.3H488c30.9 0 56 25.1 56 56c0 4.4-.5 8.6-1.5 12.7c19.7 8.7 33.5 28.4 33.5 51.3s-13.8 42.6-33.5 51.3c1 4.1 1.5 8.3 1.5 12.7c0 22.9-13.8 42.6-33.5 51.3c1 4.1 1.5 8.3 1.5 12.7c0 30.9-25.1 56-56 56H326.1z"]
};
var faHandsWash = faHandsBubbles;
var faLessThanEqual = {
  prefix: 'far',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M401 78.2c12.3-5 18.2-19 13.2-31.3s-19-18.2-31.3-13.2L47 169.8c-9.1 3.7-15 12.5-15 22.2s5.9 18.6 15 22.2l336 136c12.3 5 26.3-1 31.3-13.2s-1-26.3-13.2-31.3L120 192 401 78.2zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faTrain = {
  prefix: 'far',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M352 48c26.5 0 48 21.5 48 48v96H48V96c0-26.5 21.5-48 48-48H352zM48 352V240H400V352c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96V352c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57H318.1l57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352V96c0-53-43-96-96-96H96zM224 360a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faUpFromDottedLine = {
  prefix: 'far',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", "M114.2 192L224 82 333.8 192H280c-13.3 0-24 10.7-24 24V336H192V216c0-13.3-10.7-24-24-24H114.2zM224 32c-11.5 0-22.5 4.6-30.6 12.7L77.6 160.8C68.9 169.5 64 181.3 64 193.6c0 25.6 20.8 46.4 46.4 46.4H144v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V240h33.6c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 44.7C246.5 36.6 235.5 32 224 32zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faEyeLowVision = {
  prefix: 'far',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2l-74-58c-36.7-11.8-68.5-32.9-95-57.5c-18.3-17-34-35.6-46.8-53.6L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"]
};
var faLowVision = faEyeLowVision;
var faTrafficLightGo = {
  prefix: 'far',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M64 48c-8.8 0-16 7.2-16 16V352c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-184a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faFaceExhaling = {
  prefix: 'far',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 7-.3 13.9-1 20.7c11.6-8 25.6-12.7 40.8-12.7c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-7.7-2.3c-34.1 24.5-76 39-121.3 39C141.1 464 48 370.9 48 256zM256 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm95.6-172c-10.6 0-19.9-3.8-25.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7zm409.2 96.2c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-20.7 0-37.7 15.8-39.7 35.9l-72.3 18.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9L416.1 412c-.1 1.3-.2 2.6-.2 4c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z"]
};
var faSensorFire = {
  prefix: 'far',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M64 80H384c8.8 0 16 7.2 16 16v55.4c4.1-3.9 8.2-7.7 12.5-11.5c10-8.9 23-12.8 35.5-11.7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H337.6c-12.7-14.3-23.4-30.5-31.5-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm213.5 11.6c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faUserUnlock = {
  prefix: 'far',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464H384v16c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3v67.7C361.9 379.3 319 352 269.7 352H178.3c-65.7 0-120.1 48.7-129 112zM496 272v48h16 48 48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272c0-44.2 35.8-80 80-80s80 35.8 80 80H560c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faHexagonDivide = {
  prefix: 'far',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12H344.3c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var fa00 = {
  prefix: 'far',
  iconName: '00',
  icon: [640, 512, [], "e467", "M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM48 176c0-53 43-96 96-96s96 43 96 96V336c0 53-43 96-96 96s-96-43-96-96V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM400 176c0-53 43-96 96-96s96 43 96 96V336c0 53-43 96-96 96s-96-43-96-96V176z"]
};
var faCrow = {
  prefix: 'far',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M39.2 442.6l72-58.6H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l96-24c-9.4-37.6-43.2-64-82-64H515C496.1 12.3 469.5 0 440 0C382.6 0 336 46.6 336 104v35.1L94.1 336 80.9 346.8l-72 58.6 0 0 0 0C-1.4 413.8-3 428.9 5.4 439.2s23.5 11.8 33.8 3.5l0 0zM195.4 315.4L333.1 203.4c-10.9 51.4-51 93.1-104 104.7l-33.7 7.4zM384 161.9l0 0V139.1 104c0-30.9 25.1-56 56-56s56 25.1 56 56v24 64c0 79.5-64.5 144-144 144H289.5c57.1-31.8 94.5-92.7 94.5-160.8V161.9zM464 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCassetteBetamax = {
  prefix: 'far',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", "M48 416V160H528V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM368 256h80v80H368V256zm-48-16V352c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm-136 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm0-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBetamax = faCassetteBetamax;
var faSailboat = {
  prefix: 'far',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", "M284.6 6.2c-4.2-5.4-11.4-7.5-17.8-5.3S256 9.2 256 16V304c0 8.8 7.2 16 16 16H496c6.1 0 11.7-3.5 14.4-9s2-12-1.7-16.9l-224-288zm-72 90.5c-6.7-2-14 .6-17.9 6.4l-128 192c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.4 14.1 8.4H208c8.8 0 16-7.2 16-16V112c0-7.1-4.6-13.3-11.4-15.3zM60 400H516l-.4 1.6c-8.2 36.5-40.6 62.4-78 62.4H138.4c-37.4 0-69.8-25.9-78-62.4L60 400zM20 352c-10.3 0-17.9 9.5-15.6 19.5l9.1 40.6c13.1 58.4 65 99.9 124.9 99.9H437.6c59.9 0 111.7-41.5 124.9-99.9l9.1-40.6c2.2-10-5.4-19.5-15.6-19.5H20z"]
};
var faWindowRestore = {
  prefix: 'far',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M432 48H208c-17.7 0-32 14.3-32 32V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V336h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256H48V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"]
};
var faNfcMagnifyingGlass = {
  prefix: 'far',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", "M384 80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H333.7c20.2 20.6 46 35.8 74.8 43.1c-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v64c-16.7 0-32.8 2.6-48 7.3V96c0-8.8-7.2-16-16-16zm-16 72v29.4c-18.7 10.8-35.1 25.4-48 42.6V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40zM309.4 400H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V352H291.2c3.5 17.2 9.7 33.3 18.2 48zm138.6 .2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
var faFileBinary = {
  prefix: 'far',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm64 240c-30.9 0-56 25.1-56 56v64c0 30.9 25.1 56 56 56h16c30.9 0 56-25.1 56-56V296c0-30.9-25.1-56-56-56H128zm-8 56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8H128c-4.4 0-8-3.6-8-8V296zm120-56c-13.3 0-24 10.7-24 24s10.7 24 24 24v80c-13.3 0-24 10.7-24 24s10.7 24 24 24h24 24c13.3 0 24-10.7 24-24s-10.7-24-24-24V264c0-13.3-10.7-24-24-24H240z"]
};
var faCircleV = {
  prefix: 'far',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l104 208c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l104-208c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L256 322.3 173.5 157.3z"]
};
var faSquarePlus = {
  prefix: 'far',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlusSquare = faSquarePlus;
var faBowlScoops = {
  prefix: 'far',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M224 208c0 5.4 .4 10.8 1.1 16H446.9c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208zM0 208c0 5.4 .4 10.8 1.1 16H192.9c-.6-5.3-.9-10.6-.9-16c0-22 4.9-42.8 13.7-61.4c-19.8-30.2-53.8-50.2-92.6-50.6L112 96C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1zM173.8 368h-2.2H145c-41.4 0-77.2-26.3-90.5-64H393.5c-13.3 37.7-49.1 64-90.5 64H276.3h-2.2H173.8zm36.9 78.7L224 430.8l13.3 15.9L251.7 464H196.3l14.4-17.3zm92.3 3.9L274.2 416H303c10.6 0 20.9-1.1 30.9-3.3c58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8c10 2.2 20.3 3.3 30.9 3.3h28.8L145 450.6l-10.9 13.1-.3 .3-.4 .5L128 471l-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2h19.2 8.5 .6H291.7h.6 8.5H320c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3L303 450.6z"]
};
var faMistletoe = {
  prefix: 'far',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M288 0c13.3 0 24 10.7 24 24V86.1l98 98 8.7 1.7 65.9 12.7C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-12.7-65.9-1.7-8.7L312 153.9V288l6 8 46.8 62.4C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L258 296l6-8V153.9L199.9 218l-1.4 7.4c3-.9 6.2-1.4 9.5-1.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-7.6 0-14.7-2.7-20.2-7.2l-2.3 11.9C175.4 345.7 129 384 75 384c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l65.9-12.7 8.7-1.7 98-98V24c0-13.3 10.7-24 24-24zM100.4 245.6C70 251.4 48 278 48 309c0 14.9 12.1 27 27 27c30.9 0 57.5-22 63.4-52.4l9.1-47.1-47.1 9.1zm328.2-9.1l9.1 47.1C443.4 314 470 336 501 336c14.9 0 27-12.1 27-27c0-30.9-22-57.5-52.4-63.4l-47.1-9.1zM249.6 387.2c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L288 336l-38.4 51.2zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCustard = {
  prefix: 'far',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", "M116.1 112.8L53.7 368h49.4l33.6-137.6c14.1-3.8 27.9-6.4 39.3-6.4c16.7 0 28.8 5.6 45.6 13.6l1 .5C238.9 246 259.8 256 288 256s49.1-10 65.4-17.9l1-.5c16.8-8.1 28.9-13.6 45.6-13.6c11.4 0 25.2 2.6 39.3 6.4L472.9 368h49.4L459.9 112.8c-7-28.6-32.7-48.8-62.2-48.8H178.2c-29.5 0-55.2 20.2-62.2 48.8zm310.5 65.6c-9-1.5-18-2.4-26.6-2.4c-28.2 0-49.1 10-65.4 17.9l-1 .5C316.8 202.4 304.7 208 288 208s-28.8-5.6-45.6-13.6l-1-.5C225.1 186 204.2 176 176 176c-8.6 0-17.6 .9-26.6 2.4l13.3-54.2c1.8-7.2 8.2-12.2 15.5-12.2H397.8c7.4 0 13.8 5 15.5 12.2l13.3 54.2zM0 424c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"]
};
var faLacrosseStick = {
  prefix: 'far',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", "M261.5 107.5l-6.6 19.7c-6.3 18.9-16 36.5-28.6 51.9l-34.4 42c-10.3 12.6-15.9 28.3-15.9 44.5c0 38.8 31.5 70.3 70.3 70.3c16.2 0 32-5.6 44.5-15.9l42-34.4c15.4-12.6 33-22.3 51.9-28.6l19.7-6.6C440 238.7 464 205.4 464 168h0l0-.3c0-22.9-15.2-53-40.9-78.8S367.2 48 344.3 48l-.3 0v0c-37.4 0-70.7 24-82.5 59.5zM344 0V0l.3 0C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3h0c0 58.1-37.2 109.7-92.3 128.1L400 302.6c-13.4 4.5-25.8 11.3-36.7 20.2l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7c-24 0-46.3-7.1-65-19.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L147.4 330.6c-12.3-18.6-19.4-41-19.4-65c0-27.3 9.5-53.8 26.7-74.9l34.4-42c8.9-10.9 15.8-23.3 20.2-36.7l6.6-19.7C234.3 37.2 285.9 0 344 0z"]
};
var faHockeyMask = {
  prefix: 'far',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M48 240c0-57.4 14.3-105.3 41.1-137.9C114.7 70.9 156.1 48 224 48s109.3 22.9 134.9 54.1C385.7 134.7 400 182.6 400 240c0 95.1-12.6 148.4-36 178.6C343.4 445.3 306 464 224 464s-119.4-18.7-140-45.4C60.6 388.4 48 335.1 48 240zM224 0C64 0 0 111 0 240C0 432 48 512 224 512s224-80 224-272C448 111 384 0 224 0zM200 208c0-17.7-14.3-32-32-32H104c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64s64-28.7 64-64zm112 64c35.3 0 64-28.7 64-64c0-17.7-14.3-32-32-32H280c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64zM176 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSunrise = {
  prefix: 'far',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M271 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L271 7zM393.3 225.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H82.1L36.2 397.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L288 285.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464h36.7c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96h36.7l43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3L301.6 334c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L96.8 400.8 140.4 464zM350 464c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48H350z"]
};
var faSubtitles = {
  prefix: 'far',
  iconName: 'subtitles',
  icon: [576, 512, [], "e60f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM120 240H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 336h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 0H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faPanelEws = {
  prefix: 'far',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", "M64 48c-8.8 0-16 7.2-16 16V294.7C76.3 307 96 335.2 96 368v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-14.2-6.2-27-16-35.8V448c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 160h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"]
};
var faToriiGate = {
  prefix: 'far',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", "M48 112c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V64.5l-1.6 .6C437.9 75 411.6 80 385.2 80H126.8c-26.5 0-52.7-5-77.2-14.9L48 64.5V112zM0 112V13.4C0 6 6 0 13.4 0c1.7 0 3.4 .3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32H385.2c20.4 0 40.5-3.9 59.4-11.4L493.6 1c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4V112c0 35.3-28.7 64-64 64v64h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H448V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V288l-144 0-144 0V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V288H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V176c-35.3 0-64-28.7-64-64zM112 240l120 0V176H112v64zm168-64v64l120 0V176H280z"]
};
var faCloudExclamation = {
  prefix: 'far',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM320 144c-13.3 0-24 10.7-24 24V280c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faMessageLines = {
  prefix: 'far',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
};
var faCommentAltLines = faMessageLines;
var faFrog = {
  prefix: 'far',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M322.4 113c-5.9 17.8-21.6 30.6-40.2 32.7C150.4 160.5 48 272.3 48 408v16c0 4.4 3.6 8 8 8H238.1c.3-.3 .6-.7 .9-1l56.8-56.8c10.4-10.3 16.2-24.4 16.2-39c0-30.5-24.7-55.2-55.2-55.2c-14.6 0-28.7 5.8-39 16.2L169 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48.8-48.8c19.4-19.4 45.6-30.2 73-30.2c50.2 0 92 35.8 101.3 83.2c3-6.3 7.4-11.9 12.9-16.4c4.6-3.8 9.5-7.3 14.5-10.5l135.9-86.5c4.1-2.6 6.5-7.1 6.5-11.9c0-6.2-4-11.7-10-13.5l-70-21.5c-16.8-5.2-29.5-19.1-32.9-36.4C410.6 96.5 391.2 80 368 80c-21.2 0-39.3 13.8-45.6 33zM434.1 371.3l54 58.1c1.5 1.6 3.6 2.6 5.9 2.6h58c13.3 0 24 10.7 24 24s-10.7 24-24 24H494c-15.6 0-30.4-6.5-41-17.9l-23.5-25.3-28.7-31-16.4-17.6-16.4-17.6L355.4 384l-20.3 21.8L310.9 432h48.6 .5c4.7 0 9.2 1.4 12.9 3.7C379.6 440 384 447.5 384 456c0 .8 0 1.5-.1 2.3C382.7 470.5 372.5 480 360 480H310.9 56c-30.9 0-56-25.1-56-56V408C0 247.6 121.1 115.5 276.8 98c12.6-38.3 48.7-66 91.2-66c46.5 0 85.3 33.1 94.1 77l70 21.5c26.1 8 43.9 32.1 43.9 59.4c0 21.2-10.9 41-28.8 52.4L442 309.3l-30.7 19.6c-3.5 2.2-6.8 4.6-9.9 7.2l1.7 1.9 0 0 31 33.4zM368 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBucket = {
  prefix: 'far',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 216c0-13.3 10.7-24 24-24H72.4 375.6 424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-6L389.3 470c-3 24-23.4 42-47.6 42H106.4c-24.2 0-44.6-18-47.6-42L30 240H24c-13.3 0-24-10.7-24-24zm78.4 24l28 224H341.6l28-224H78.4z"]
};
var faFloppyDiskPen = {
  prefix: 'far',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", "M48 96V416c0 8.8 7.2 16 16 16H270.5l-12 48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3v65.1l-48 48V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM128 80v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm389.8-84.2l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417.1L441.1 287.9l71 71L382.9 488.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faImage = {
  prefix: 'far',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWindowFrame = {
  prefix: 'far',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", "M80 464H232V272H80V464zm-48 0V64C32 28.7 60.7 0 96 0H416c35.3 0 64 28.7 64 64V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H432 80 32 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zm400 0V272H280V464H432zM80 224H232V48H96c-8.8 0-16 7.2-16 16V224zm200 0H432V64c0-8.8-7.2-16-16-16H280V224z"]
};
var faMicrophone = {
  prefix: 'far',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M240 96V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-26.5 21.5-48 48-48s48 21.5 48 48zM96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"]
};
var faCow = {
  prefix: 'far',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M72 184c0-23 10.7-43.4 27.5-56.6C97.2 135.2 96 143.5 96 152V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V378.6c2.5 .6 5.2 1.2 8 1.7V392c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.1c2.6 .1 5.3 .1 8 .1s5.4 0 8-.1V392c0 8.8 7.2 16 16 16s16-7.2 16-16V380.4c2.8-.5 5.5-1.1 8-1.7V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V271.1l16 18V336c0 4.6 1.3 9 3.8 12.9l42.3 66.5C523 435.7 545.4 448 569.5 448c38.9 0 70.5-31.6 70.5-70.5V274.9c0-12.4-4.1-24.4-11.7-34.2l-4.3-5.6V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v5l-48.2-62.4C505.1 81.2 470 64 432.9 64H256 184 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184zm91.2-66.1c3.6 12.3 10.3 23.6 19.5 32.8l7.4 7.4C211.8 179.8 241.3 192 272 192s60.2-12.2 81.9-33.9l7.4-7.4c10.7-10.7 17.9-24.1 21-38.6h50.5c22.3 0 43.3 10.3 57 28L590.3 270c1.1 1.4 1.7 3.1 1.7 4.9V377.5c0 12.4-10.1 22.5-22.5 22.5c-7.7 0-14.8-3.9-19-10.4L512 329V280c0-5.9-2.2-11.6-6.1-15.9l-64-72c-6.6-7.4-17.2-10-26.5-6.5S400 198 400 208V400H368V352v-8-8c0-53-43-96-96-96s-96 43-96 96v8 8 48H144V152c0-14.5 7.7-27.1 19.2-34.1zm62.4 211.4l-1.1-.4C228 305.7 247.9 288 272 288s44 17.7 47.5 40.9l-1.1 .4c-9.7 3.2-25.1 6.8-46.4 6.8s-36.7-3.5-46.4-6.8zM576 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faFileZip = {
  prefix: 'far',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", "M64 464h96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"]
};
var faSquareRing = {
  prefix: 'far',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM304 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 256a128 128 0 1 1 256 0A128 128 0 1 1 96 256z"]
};
var faDownFromLine = {
  prefix: 'far',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M82.2 320L192 430 301.8 320H248c-13.3 0-24-10.7-24-24V176H160V296c0 13.3-10.7 24-24 24H82.2zM192 480c-11.5 0-22.5-4.6-30.6-12.7L45.6 351.2C36.9 342.5 32 330.7 32 318.4C32 292.8 52.8 272 78.4 272H112V176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L222.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 80C10.7 80 0 69.3 0 56S10.7 32 24 32H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24z"]
};
var faArrowAltFromTop = faDownFromLine;
var faCaretUp = {
  prefix: 'far',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M160 182.6L70.6 272H249.4L160 182.6zm-22.6-45.3c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
};
var faShieldXmark = {
  prefix: 'far',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faShieldTimes = faShieldXmark;
var faScrewdriver = {
  prefix: 'far',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", "M445.9 55.9l10.2 10.2L396.2 144H368V115.8l77.9-59.9zM507 78.6c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104zM155.3 315.3c11.4-11.4 29.9-11.4 41.4 0s11.4 29.9 0 41.4L96 457.4 54.6 416 155.3 315.3zm75.3-33.9c-30.2-30.2-79.1-30.2-109.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3z"]
};
var faCircleSortDown = {
  prefix: 'far',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM267.3 411.3l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zm0-310.6c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM313.4 192H198.6L256 134.6 313.4 192z"]
};
var faSortCircleDown = faCircleSortDown;
var faFolderClosed = {
  prefix: 'far',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V240zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3z"]
};
var faHouseTsunami = {
  prefix: 'far',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", "M50 176.4C62 104.5 127.8 48 209.4 48c18.8 0 36.7 3 53.4 8.5c12.6 4.2 26.2-2.7 30.3-15.3s-2.7-26.2-15.3-30.3C256.4 3.8 233.4 0 209.4 0C95 0 0 88.4 0 200c0 93.2 54.7 174 144.8 194.8c12.7 3.4 26 5.2 39.7 5.2c.6 0 1.2 0 1.8-.1c1.8 0 3.6 .1 5.4 .1c.1 0 .3 0 .4 0v0c34.6 0 67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9v0c-.1 0-.3 0-.4 0c-12.9 0-25.2-1.4-36.7-4.2c-43.4-12.7-75-52.6-75-99.8c0-57.4 46.7-104 104.4-104c15.9 0 30.9 3.5 44.3 9.8c12 5.6 26.3 .4 31.9-11.6s.4-26.3-11.6-31.9C229.4 101.1 207.5 96 184.4 96C126.3 96 75.6 128.5 50 176.4zM368 286.8V152l79.9-60L527.5 152l.3 124.4c9.4 6.4 20.2 11.3 30.8 13.7c6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5L467.2 46.5c-11.4-8.6-27.1-8.6-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6V265c1.7 1 3.3 2 4.8 3.1c13.4 9.3 28.4 15.9 43.2 18.7zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
var faSquareNfi = {
  prefix: 'far',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M64 80H384c8.8 0 16 7.2 16 16v32h48V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v32H48V96c0-8.8 7.2-16 16-16zM48 384H0v32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384H400v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V384zm1-223c-10.1 3.1-17 12.4-17 23V328c0 13.3 10.7 24 24 24s24-10.7 24-24V263.3l52 78c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64.7l-52-78C70.1 161.9 59.2 158 49 161zm167 23v80 64c0 13.3 10.7 24 24 24s24-10.7 24-24V288h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H264V208h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H240c-13.3 0-24 10.7-24 24zm200 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faForklift = {
  prefix: 'far',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", "M80 160H96V40c0-22.1 17.9-40 40-40H293c16.6 0 31.5 10.3 37.4 25.8l83 218.9c1.7 4.5 2.6 9.3 2.6 14.2V272v72.4c19.6 17.6 32 43.1 32 71.6c0 53-43 96-96 96s-96-43-96-96H192c0 53-43 96-96 96s-96-43-96-96V368 240c0-44.2 35.8-80 80-80zm160 80H360.3L287.4 48H144V171.4L240 240zm0 48c-10 0-19.8-3.1-27.9-8.9L112.6 208H80c-17.7 0-32 14.3-32 32v92.8C62.1 324.7 78.5 320 96 320c35.5 0 66.6 19.3 83.2 48h89.7c16.6-28.7 47.6-48 83.2-48c5.5 0 10.8 .5 16 1.3V288H240zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM528 24V400h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faArrowUpFromGroundWater = {
  prefix: 'far',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", "M288 352c13.3 0 24-10.7 24-24V81.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L305 7c-9.4-9.4-24.6-9.4-33.9 0L191 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V328c0 13.3 10.7 24 24 24zM80 430.1C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM192 192H64c-35.3 0-64 28.7-64 64V425c5.3-3.1 11.2-5.4 17.5-6.9c10.4-2.4 21.2-7.2 30.5-13.5L48 256c0-8.8 7.2-16 16-16H192V192zm384 64c0-35.3-28.7-64-64-64H384v48H512c8.8 0 16 7.2 16 16V404.6c9.3 6.3 20.1 11.1 30.5 13.6c6.3 1.5 12.1 3.8 17.5 6.9V256z"]
};
var faBracketSquareRight = {
  prefix: 'far',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 88c0-30.9-25.1-56-56-56H72C58.7 32 48 42.7 48 56s10.7 24 24 24h64c4.4 0 8 3.6 8 8V424c0 4.4-3.6 8-8 8H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c30.9 0 56-25.1 56-56V88z"]
};
var faMartiniGlass = {
  prefix: 'far',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M35.3 0C15.8 0 0 15.8 0 35.3c0 9.4 3.7 18.3 10.3 25L232 281.9V464H152c-13.3 0-24 10.7-24 24s10.7 24 24 24H256 360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V281.9L501.7 60.3c6.6-6.6 10.3-15.6 10.3-25C512 15.8 496.2 0 476.7 0H35.3zM318.1 176L256 238.1 193.9 176H318.1zm48-48H145.9l-80-80H446.1l-80 80z"]
};
var faGlassMartiniAlt = faMartiniGlass;
var faRotateLeft = {
  prefix: 'far',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M140.8 122.9C171.7 96.2 212 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2c-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.3 0-109.6 21.5-149.2 56.9L76.3 58.3C69.7 51.7 60.7 48 51.3 48C31.8 48 16 63.8 16 83.3V200c0 13.3 10.7 24 24 24H156.7c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25l-40.8-40.8zm-76.8-9L126.1 176H64V113.9z"]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faTableColumns = {
  prefix: 'far',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", "M48 416V160H232V432H64c-8.8 0-16-7.2-16-16zm232 16V160H464V416c0 8.8-7.2 16-16 16H280zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faColumns = faTableColumns;
var faSquareA = {
  prefix: 'far',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336H158.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288h82.3L224 205.7z"]
};
var faTick = {
  prefix: 'far',
  iconName: 'tick',
  icon: [128, 512, [], "e32f", "M40 104c0-13.3 10.7-24 24-24s24 10.7 24 24v1.9c0 1.4-.1 2.8-.4 4.3c0 0 0 0 0 0L64 252 40.4 110.1c-.2-1.4-.4-2.8-.4-4.3V104zm95 14c.7-4 1-8.1 1-12.1V104c0-39.8-32.2-72-72-72S-8 64.2-8 104v1.9c0 4.1 .3 8.1 1 12.1L17.4 264.5C21.2 287.3 40.9 304 64 304s42.8-16.7 46.6-39.5L135 118z"]
};
var faLemon = {
  prefix: 'far',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"]
};
var faHeadSideMask = {
  prefix: 'far',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", "M80 224c0-8 .5-15.8 1.5-23.4L256 316.8V320 480c0 17.7 14.3 32 32 32H431.7c28.6 0 53.7-18.9 61.5-46.4L534.9 320l4.7-16.6c1.5-5.1 2.6-10.4 3.3-15.6c.7-3.1 1.1-6.2 1.1-9.5c0-.8 0-1.6-.1-2.3c0-1.3 .1-2.6 .1-3.9h-.5c-1.1-7.2-4.1-14.1-8.7-19.9l-18-22.5c-11.5-14.4-20.1-31.5-28-50.9c-3.7-8.9-7.1-18-10.6-27.5l-1-2.6c-3.9-10.3-7.9-21-12.4-31.6C435.6 48.3 367.5 0 288 0H256C132.3 0 32 100.3 32 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C94.8 304.8 80 266.2 80 224zm195.3 48L95.3 152C122.8 90.7 184.4 48 256 48h32c59.5 0 110.7 36.2 132.6 87.8c4 9.5 7.8 19.3 11.6 29.7l1 2.6 0 0c3.5 9.4 7.2 19.2 11.1 28.8c8.6 21.1 19.3 43.1 35 62.7l9.9 12.4H456l-.6 0H304 275.3zM368 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm63.7 240H304V320H484.9l-6.9 24H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H468.9l-9.1 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h82.6l-3.5 12.4c-2 6.9-8.2 11.6-15.4 11.6z"]
};
var faHandshake = {
  prefix: 'far',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176H96V304c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128H544h40 40c8.8 0 16 7.2 16 16V352c0 17.7-14.3 32-32 32H576c-11.8 0-22.2-6.4-27.7-16H463.4c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16H56 96h19.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9 .2 13.2 .6zM544 320V176H496c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faGem = {
  prefix: 'far',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"]
};
var faDolly = {
  prefix: 'far',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h80.8c3.5 0 6.5 2.2 7.6 5.5l91.9 281.6C177.7 352.1 160 382 160 416c0 53 43 96 96 96s96-43 96-96c0-2.8-.1-5.5-.3-8.2L560 334.6c12.5-4.4 19.1-18.1 14.7-30.6s-18.1-19.1-30.6-14.7L335.8 362.5C318.5 336.9 289.2 320 256 320c-2 0-4 .1-6 .2L158 38.6C150.5 15.6 129 0 104.8 0H24zM256 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM457.4 117.3c-10.6-28.7-42.2-43.7-71.1-33.5L224.9 140.5l14.9 45.6 57.5-20.2 24.1 66.3c4.5 12.5 18.3 18.9 30.8 14.4s18.9-18.3 14.4-30.8L342.6 150l59.6-20.9c4.1-1.4 8.7 .7 10.2 4.8L467 282.5l45.3-15.9L457.4 117.3z"]
};
var faDollyBox = faDolly;
var faSmoking = {
  prefix: 'far',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", "M440 0c13.3 0 24 10.7 24 24V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v19c0 13.3-10.7 24-24 24s-24-10.7-24-24V245c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V24c0-13.3 10.7-24 24-24zM616 288c-13.3 0-24-10.7-24-24V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24V43c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v19c0 13.3-10.7 24-24 24zm-56 88V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM224 464H432V400H224v64zM0 416c0-35.3 28.7-64 64-64H448c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416z"]
};
var faMinimize = {
  prefix: 'far',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M7 7C-2.3 16.4-2.3 31.6 7 41l80 80L41.4 166.6c-6 6-9.4 14.1-9.4 22.6V192c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-2.7c-8.5 0-16.6 3.4-22.6 9.4L121 87 41 7C31.6-2.3 16.4-2.3 7 7zM505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L391 87 345.4 41.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6L425 121l80-80zM505 471l-80-80 45.7-45.7c6-6 9.4-14.1 9.4-22.6V320c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32h2.7c8.5 0 16.6-3.4 22.6-9.4L391 425l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80 45.7 45.7c6 6 14.1 9.4 22.6 9.4H192c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v2.7c0 8.5 3.4 16.6 9.4 22.6L87 391 7 471zM412.1 176H336V99.9L412.1 176zM336 412.1V336h76.1L336 412.1zM99.9 176L176 99.9V176H99.9zM176 412.1L99.9 336H176v76.1z"]
};
var faCompressArrowsAlt = faMinimize;
var faRefrigerator = {
  prefix: 'far',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M288 48c26.5 0 48 21.5 48 48v64H288V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H48V96c0-26.5 21.5-48 48-48H288zM240 208V344c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208H240zM96 0C43 0 0 43 0 96V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96z"]
};
var faMonument = {
  prefix: 'far',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M175 7c9.4-9.4 24.6-9.4 33.9 0l80 80c3.8 3.8 6.2 8.7 6.8 14l41.4 331H288.8L249.2 115.1 192 57.9l-57.2 57.2L95.2 432H46.8L88.2 101c.7-5.3 3.1-10.2 6.8-14L175 7zM42.8 464H91.2 292.8h48.4H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 64 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H42.8zM144 312c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24z"]
};
var faOctagonXmark = {
  prefix: 'far',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesOctagon = faOctagonXmark;
var faXmarkOctagon = faOctagonXmark;
var faAlignSlash = {
  prefix: 'far',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L471.2 344H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H409.9L307.9 216H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H246.6L144.6 88H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-9 0-16.9 5-21 12.3L38.8 5.1zM152.3 216l-50.4-39.7C98.2 180.5 96 186 96 192c0 13.3 10.7 24 24 24h32.3zM314.8 344l-60.9-48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H314.8zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H477.2l-60.9-48H120z"]
};
var faSnowplow = {
  prefix: 'far',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M298.8 48c3.2 0 6.1 1.9 7.4 4.9L371.8 208H219.5l-56.8-71-2.7-3.4V48H298.8zM429 220.3c-.4-1.2-.9-2.4-1.4-3.6L350.4 34.2C341.6 13.5 321.3 0 298.8 0H152c-22.1 0-40 17.9-40 40v88H96c-26.5 0-48 21.5-48 48V308.1C19 328.3 0 361.9 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-20.4-5.5-39.5-15-56h47v56c0 6 2.2 11.7 6.2 16.1l80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 390.7V249.3l73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1v56H432V238.5 232c0-4.2-1.1-8.2-3-11.7zm-45 68.8c-5.2-.7-10.6-1.1-16-1.1H112c-5.4 0-10.8 .4-16 1.1V176h36.5l56.8 71c4.6 5.7 11.4 9 18.7 9H384v33.1zM112 336H368c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64zm32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faAnglesRight = {
  prefix: 'far',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M113 433L273 273c9.4-9.4 9.4-24.6 0-33.9L113 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L79 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm192 0L465 273c9.4-9.4 9.4-24.6 0-33.9L305 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L271 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
var faAngleDoubleRight = faAnglesRight;
var faTruckRampCouch = {
  prefix: 'far',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", "M352 88c0-48.6 39.4-88 88-88H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-22.1 0-40 17.9-40 40V360.7l25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106L30.3 511.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8V88zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2V334.8l-38.7 10.4L126.7 386.6 64.9 403.2c-17.1 4.6-34.6-5.6-39.2-22.6L13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z"]
};
var faTruckCouch = faTruckRampCouch;
var faCannabis = {
  prefix: 'far',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M275.9 10.6C271.5 4 264 0 256 0s-15.5 4-19.9 10.6c-16.1 24.1-36.5 67.2-49.2 115.1c-6.8 25.8-11.7 54.2-12 82.5c-15-10.3-30.7-19-45.9-26.4c-34.5-16.7-68.6-27-92.3-31.7c-7.9-1.6-16 .9-21.7 6.6s-8.1 13.8-6.5 21.7c6.9 34.4 26.5 93.6 62.3 143.2c-21.3 8.1-39.3 17.5-50.5 23.7C12.7 349.5 8 357.6 8 366.3s4.7 16.8 12.4 21c14.6 8.1 40.5 21.5 70.1 30.4c17.6 5.3 37.8 9.5 58.5 9.3l-5.8 23.2c-2.3 9.1 .9 18.7 8.2 24.5s17.3 7 25.7 2.8L232 450.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V450.2l54.9 27.3c8.4 4.2 18.4 3.1 25.7-2.8s10.5-15.5 8.2-24.5L363.1 427c20.6 .2 40.8-4 58.5-9.3c29.6-8.9 55.6-22.3 70.1-30.4c7.6-4.2 12.4-12.3 12.4-21s-4.7-16.8-12.4-21c-11.1-6.2-29.1-15.6-50.5-23.7C477 272.2 496.6 213 503.5 178.4c1.6-7.9-.9-16-6.5-21.7s-13.8-8.2-21.7-6.6c-23.7 4.7-57.7 15-92.3 31.7c-15.3 7.4-30.9 16.1-45.9 26.4c-.3-28.3-5.2-56.7-12-82.5c-12.6-47.9-33-91.1-49.2-115.1zM280 396.6V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v52.6l-29.6 14.7 2-7.8c2.2-8.6-.6-17.6-7.1-23.6s-15.8-7.8-24.1-4.9c-19 6.7-43.3 4.3-68.7-3.3c-5.5-1.6-10.8-3.5-16-5.4c9.3-3.5 19.2-6.7 29.3-9c8.5-1.9 15.2-8.3 17.7-16.6s.3-17.3-5.8-23.5c-30.1-31-50.9-73.8-63.1-109.2c13.1 4.5 27.3 10.1 41.7 17.1C139 240 168.8 260 189.6 285c7.4 9 20.2 11.3 30.3 5.5s14.7-17.9 10.8-28.9c-12.4-34.8-8.9-79.8 2.6-123.7c6.2-23.5 14.4-45.4 22.7-63.6c8.3 18.2 16.5 40.2 22.7 63.6c11.6 43.8 15 88.8 2.6 123.7c-3.9 11 .6 23.1 10.8 28.9s22.9 3.4 30.3-5.5c20.8-25.1 50.6-45 81.5-59.9c14.3-6.9 28.6-12.6 41.7-17.1c-11.1 32-29.2 70.2-55 100.3c-2.6 3.1-5.3 6-8.1 8.9c-6 6.2-8.2 15.2-5.8 23.5s9.2 14.6 17.7 16.6c10.1 2.3 20 5.5 29.3 9c-5.2 2-10.5 3.8-16 5.4c-25.4 7.7-49.7 10-68.7 3.3c-8.3-2.9-17.6-1.1-24.1 4.9s-9.3 15-7.1 23.6l2 7.8L280 396.6z"]
};
var faCirclePlay = {
  prefix: 'far',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z"]
};
var faPlayCircle = faCirclePlay;
var faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'far',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M295 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24s10.7 24 24 24h86.1L295 183zM217 329c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 430.1V344c0-13.3-10.7-24-24-24s-24 10.7-24 24V488c0 13.3 10.7 24 24 24H168c13.3 0 24-10.7 24-24s-10.7-24-24-24H81.9L217 329z"]
};
var faTablets = {
  prefix: 'far',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M608.8 254.9c-4.7 6.4-9.9 12.5-15.7 18.2s-11.9 11-18.2 15.7c-62.6 46.2-151.3 41-208-15.7s-62-145.4-15.7-208c4.7-6.4 9.9-12.5 15.7-18.2s11.9-11 18.2-15.7c62.6-46.2 151.3-41 208 15.7s62 145.4 15.7 208zM559.2 80.8c-37.9-37.9-96.2-43-139.6-15.1L574.3 220.4c27.8-43.4 22.8-101.7-15.1-139.6zM540.4 254.3L385.7 99.6c-27.8 43.4-22.8 101.7 15.1 139.6s96.2 43 139.6 15.1zM318.2 328c1.2 7.8 1.8 15.8 1.8 24s-.6 16.2-1.8 24c-11.6 77-78 136-158.2 136S13.4 453 1.8 376C.6 368.2 0 360.2 0 352s.6-16.2 1.8-24c11.6-77 78-136 158.2-136s146.6 59 158.2 136zM160 240c-53.6 0-98.4 37.7-109.4 88H269.4c-11-50.3-55.8-88-109.4-88zm0 224c53.6 0 98.4-37.7 109.4-88H50.6c11 50.3 55.8 88 109.4 88z"]
};
var fa360Degrees = {
  prefix: 'far',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h83.2L36 218.7c-4.9 7.4-5.4 16.8-1.2 24.6S47.1 256 56 256H88c30.9 0 56 25.1 56 56v40c0 26.5-21.5 48-48 48H94.5c-16 0-31-8-39.9-21.4L44 362.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l10.6 15.9C32.5 432 62.4 448 94.5 448H96c53 0 96-43 96-96V312c0-53.3-40-97.2-91.6-103.3L172 101.3c4.9-7.4 5.4-16.8 1.2-24.6S160.9 64 152 64H24zm440 80c0-17.7 14.3-32 32-32s32 14.3 32 32V368c0 17.7-14.3 32-32 32s-32-14.3-32-32V144zM576 368V144c0-44.2-35.8-80-80-80s-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80zM272 160c0-26.5 21.5-48 48-48c13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96V288l0 .2V368c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-11.4 0-22.2 2.4-32 6.7V160zm32 80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V272c0-17.7 14.3-32 32-32z"]
};
var faEthernet = {
  prefix: 'far',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M128 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H400 304 208 112 32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H64V160c0-17.7 14.3-32 32-32h32V96zm48 16v40c0 13.3-10.7 24-24 24H112v40c0 13.3-10.7 24-24 24H48V400H88V344c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48V344c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48V344c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48V344c0-13.3 10.7-24 24-24s24 10.7 24 24v56h40V240H424c-13.3 0-24-10.7-24-24V176H360c-13.3 0-24-10.7-24-24V112H176z"]
};
var faEuroSign = {
  prefix: 'far',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M48.6 240c-.4 5.3-.6 10.6-.6 16s.2 10.7 .6 16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H57.3C84.8 412.5 170.5 480 272 480h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H272c-74.6 0-138.4-46.4-164-112H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H96.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H108c25.6-65.6 89.4-112 164-112h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H272C170.5 32 84.8 99.5 57.3 192H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48.6z"]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faChair = {
  prefix: 'far',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M248 48H200V224H152V58.7c-23.9 13.8-40 39.7-40 69.3v96H64V128C64 57.3 121.3 0 192 0h64c70.7 0 128 57.3 128 128v96H336V128c0-29.6-16.1-55.5-40-69.3V224H248V48zM67.1 304l-18 48H398.9l-18-48H67.1zM22.1 287.1c7-18.7 24.9-31.1 44.9-31.1H380.9c20 0 37.9 12.4 44.9 31.1l19.2 51.3c1.9 5.1 2.9 10.5 2.9 16c0 20.4-13.5 37.7-32 43.5v90c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H80v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V398c-18.5-5.8-32-23.1-32-43.5c0-5.5 1-10.9 2.9-16l19.2-51.3z"]
};
var faCircleCheck = {
  prefix: 'far',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faCheckCircle = faCircleCheck;
var faSquareDashedCirclePlus = {
  prefix: 'far',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M104 32H88C39.4 32 0 71.4 0 120v16c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-22.1 17.9-40 40-40h16c13.3 0 24-10.7 24-24s-10.7-24-24-24zM0 296c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80zm24 56c-13.3 0-24 10.7-24 24v16c0 48.6 39.4 88 88 88h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-22.1 0-40-17.9-40-40V376c0-13.3-10.7-24-24-24zM424 192c13.3 0 24-10.7 24-24V120c0-48.6-39.4-88-88-88H344c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c22.1 0 40 17.9 40 40v48c0 13.3 10.7 24 24 24zM256 456c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24zm8-376c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h80zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMoneySimpleFromBracket = {
  prefix: 'far',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", "M48 88v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88C0 39.4 39.4 0 88 0H552c48.6 0 88 39.4 88 88v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-22.1-17.9-40-40-40H88C65.9 48 48 65.9 48 88zm416 8h48l0 352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64l0-352h48l0 352c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16l0-352zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z"]
};
var faBat = {
  prefix: 'far',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M356.3 187.3c-13.3-6.8-22.7-19.3-25.4-33.9l-6.5-34.9c-11.1 6.2-23.6 9.5-36.4 9.5s-25.3-3.3-36.4-9.5l-6.5 34.9c-2.7 14.6-12.1 27.2-25.4 33.9s-28.9 7-42.4 .6l-68.7-32.7C70.1 202.4 48.7 261.3 48 322.3l13.3-6.6c29.9-15 66.3-4.4 83.5 24.3l8.7 14.6 7.6-7.6c27.3-27.3 72.4-24.4 96 6.2L288 393.3l30.8-40.1c23.6-30.6 68.7-33.6 96-6.2l7.6 7.6 8.7-14.6c17.2-28.7 53.6-39.3 83.5-24.3l13.3 6.6c-.6-61-22-120-60.6-167.2l-68.7 32.7c-13.5 6.4-29.1 6.2-42.4-.6zM576 346.3v0 2 28.5c0 10.6-11.2 17.5-20.6 12.8l-25.5-12.8L528 376l0 0-34.7-17.4c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1l-36.6-36.6c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1L48 376l0 0-1.8 .9L20.7 389.7C11.2 394.4 0 387.5 0 376.9V348.4v-2 0V325.2C0 249.6 27.1 176.4 76.3 119c11.6-13.6 30.9-17.7 47.1-10l29.7 14.1 44.8 21.3 9.2-48.8 6.8-36.2c1.3-6.7 7.1-11.5 13.9-11.5c2.8 0 5.5 .8 7.8 2.4l37.8 25.2c4.3 2.9 9.4 4.4 14.7 4.4s10.3-1.5 14.7-4.4l37.8-25.2c2.3-1.5 5-2.4 7.8-2.4c6.8 0 12.6 4.8 13.9 11.5l6.8 36.2 9.2 48.8 44.8-21.3L452.6 109c16.2-7.7 35.5-3.6 47.1 10C548.9 176.4 576 249.6 576 325.2v21.1z"]
};
var faCircleStop = {
  prefix: 'far',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]
};
var faStopCircle = faCircleStop;
var faHeadSideHeadphones = {
  prefix: 'far',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M184 52.6C106.1 70.7 48 140.5 48 224c0 42.2 14.8 80.8 39.5 111.1c13.6 16.6 24.5 38.5 24.5 63.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V398.6c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224C0 100.3 100.3 0 224 0h24c78.8 0 151.4 47.6 183.2 116.2c4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29c9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45c0 35.1-28.5 63.6-63.6 63.6H448v48c0 35.3-28.7 64-64 64H320v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V424c0-13.3 10.7-24 24-24h88c8.8 0 16-7.2 16-16V312c0-13.3 10.7-24 24-24h24.4c8.6 0 15.6-7 15.6-15.6c0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1c-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48H232V98.6c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-53.6 37.7-98.4 88-109.4v-46zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faPhoneRotary = {
  prefix: 'far',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M0 176V141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V176c0 17.7-14.3 32-32 32H437.7c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16c-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208H32c-17.7 0-32-14.3-32-32zM80 401v31H432V401c0-2.8-.7-5.5-2.1-7.9l-101.1-177c-2.8-5-8.2-8.1-13.9-8.1H197.1c-5.7 0-11 3.1-13.9 8.1L82.1 393.1c-1.4 2.4-2.1 5.2-2.1 7.9zm61.6-208.7C153 172.3 174.2 160 197.1 160H314.9c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V401c0-11.1 2.9-22.1 8.4-31.8l101.1-177zM256 256a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCompassDrafting = {
  prefix: 'far',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M304 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3L158.1 306.4C187.9 320.3 221 328 256 328c85.8 0 160.8-46.6 201-116c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8C450.2 319.6 359.7 376 256 376c-43.8 0-85.3-10.1-122.2-28L44.7 500.1c-6.7 11.4-21.4 15.3-32.8 8.6S-3.4 487.3 3.3 475.9L92.6 323.4C60.4 300.2 33.4 270.4 13.5 236c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2C170.2 145.2 160 121.8 160 96c0-53 43-96 96-96s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5l53.5 91.4c-12.6 9.8-26.4 18.1-41.1 24.7l-53.2-90.9zM508.7 475.9c6.7 11.4 2.9 26.1-8.6 32.8s-26.1 2.9-32.8-8.6L394.4 375.7c14.4-7.1 28.2-15.4 41.2-24.6l73 124.8z"]
};
var faDraftingCompass = faCompassDrafting;
var faPlateWheat = {
  prefix: 'far',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M176 32c-8.8 0-16 7.2-16 16V64c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80zM56 64C42.7 64 32 74.7 32 88s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zM24 136c-13.3 0-24 10.7-24 24s10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm8 96c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24zM272 48V64c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM400 32c-8.8 0-16 7.2-16 16V64c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16V112c0-44.2-35.8-80-80-80zm80 160c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V192zM352 176c-44.2 0-80 35.8-80 80v16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V192c0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80v16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80V192zM130 423.7c-7.3-13.2-20.4-22.2-35.3-24.3C76 396.8 60.3 384.6 52.8 368H459.2c-7.5 16.6-23.2 28.8-41.9 31.5c-14.9 2.1-28 11.1-35.3 24.3c-2.8 5-8.1 8.3-14 8.3H144c-6 0-11.2-3.2-14-8.3zM25.6 320C11.5 320 0 331.5 0 345.6C0 397.3 38.3 440 88 447c10.9 19.7 31.9 33 56 33H368c24.1 0 45.1-13.3 56-33c49.7-7 88-49.7 88-101.4c0-14.1-11.5-25.6-25.6-25.6H25.6z"]
};
var faCalendarCircleMinus = {
  prefix: 'far',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H432 400 352 48V448c0 8.8 7.2 16 16 16H284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faChopsticks = {
  prefix: 'far',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M144.9 332.9L332.9 54.7c3.5-4.3 8.4-6.7 13.6-6.7c9.2 0 18.1 8 18.1 19.5c0 4.6-1.4 8.7-3.8 11.9L144.9 332.9zM346.5 0c-21.4 0-40.3 10.4-52.2 26.1l-.4 .5-.4 .6L7.4 450.7c-12 16.4-9.2 39.8 6.8 52.8C30.8 517 54.7 514 67.7 497.6L397.9 109.9l.4-.5 .4-.5c8.7-11.5 13.9-25.9 13.9-41.4C412.6 31 383.7 0 346.5 0zm-37 356.7L561.1 116.2c3.2-2.6 7.3-4.2 11.9-4.2c10.4 0 18.9 8.4 18.9 18.9c0 5.5-2.4 10.5-6.2 14L309.5 356.7zM573 64c-16.6 0-31.8 6.1-43.5 16.1l-.5 .4-.5 .4-381 364.2c-15.5 13.8-17.1 37.6-3.5 53.5s37.3 17.9 53.4 4.7L615.5 182.4l.5-.4 .5-.4c14.3-12.2 23.3-30.4 23.3-50.8C639.9 93.9 609.9 64 573 64z"]
};
var faCarWrench = {
  prefix: 'far',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M468.9 104H456l-.5 0c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1l.5 0h12.9 17.6c10.8 0 18.4-10.6 12.5-19.6c-3.6-5.5-7.8-10.5-12.5-14.9c-4.2-3.9-8.8-7.4-13.8-10.3C470.8 10 468.9 9 466.9 8C456.4 2.9 444.5 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3H163.8c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1c-5 2.9-9.6 6.4-13.8 10.3c-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56H43.1 56l.5 0c.7 0 1.4 .1 2.1 .1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7 .1-1.4 .1-2.1 .1l-.5 0H43.1 25.5C14.7 104 7 114.6 12.9 123.6c3.6 5.5 7.8 10.5 12.5 14.9c4.2 3.9 8.8 7.4 13.8 10.3c1.9 1.1 3.8 2.2 5.8 3.1c10.6 5.1 22.4 8 34.9 8c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3H348.2c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c12.5 0 24.4-2.9 34.9-8c2-1 3.9-2 5.8-3.1c5-2.9 9.6-6.4 13.8-10.3c4.7-4.4 9-9.4 12.5-14.9c5.9-9-1.7-19.6-12.5-19.6H468.9zM185.8 208H326.2c10.1 0 19.2 6.4 22.6 15.9L365.9 272H146.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM89.4 287.9c-.2 .5-.3 .9-.5 1.4C64.2 306.7 48 335.5 48 368v32 16 32 40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H416v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448 416 400 368c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H185.8c-30.4 0-57.6 19.1-67.8 47.8L89.4 287.9zM368 320c26.5 0 48 21.5 48 48v32H96V368c0-26.5 21.5-48 48-48H368zM160 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCarMechanic = faCarWrench;
var faIcicles = {
  prefix: 'far',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M5.2 9.1C9.7 3.4 16.7 0 24 0H488c6.9 0 13.5 3 18.1 8.2s6.6 12.2 5.7 19L448.9 483c-2.3 16.6-16.5 29-33.2 29c-15.8 0-29.4-11-32.8-26.4L332.6 256.5l-11.2 38.2c-4.4 15-18.1 25.2-33.7 25.2c-14.5 0-27.6-9-32.8-22.5l-9.4-24.6-20.2 84.9C221.5 373.1 207.8 384 192 384s-29.5-10.9-33.2-26.2l-20.2-84.9-9.5 24.8C123.9 311.1 111 320 96.6 320c-16.2 0-30.2-11.1-33.9-26.8L.6 29.5C-1 22.4 .6 14.8 5.2 9.1zM54.3 48L99.6 240.6l22-57.2c3.8-9.8 13.5-16 24-15.3s19.3 8.2 21.7 18.4L192 290l24.7-103.5c2.4-10.2 11.3-17.7 21.7-18.4s20.2 5.5 24 15.3L286 244.8 313 153.2c3.1-10.5 12.9-17.6 23.9-17.2s20.3 8.1 22.6 18.8l53 241.4L460.5 48H54.3z"]
};
var faPersonShelter = {
  prefix: 'far',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M268.1 3.3c-7.5-4.4-16.8-4.4-24.3 0l-232 136C4.5 143.6 0 151.5 0 160V488c0 13.3 10.7 24 24 24s24-10.7 24-24V173.8L256 51.8 464 173.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V160c0-8.5-4.5-16.4-11.9-20.7l-232-136zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-16 64.5c2-.3 4.1-.5 6.2-.5h19.5c2.1 0 4.2 .2 6.2 .5V368H240V272.5zM240 416h32v72c0 13.3 10.7 24 24 24s24-10.7 24-24V328.3l18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35V488c0 13.3 10.7 24 24 24s24-10.7 24-24V416z"]
};
var faNeuter = {
  prefix: 'far',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24V350.4z"]
};
var faIdBadge = {
  prefix: 'far',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M256 48V64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faKazoo = {
  prefix: 'far',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M560 256c0 29.6-8.9 57.1-24.2 80H576c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H535.8c15.3 22.9 24.2 50.4 24.2 80zm16 128H482c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H241.7c-11.8 0-23.4-1.6-34.7-4.8c-39.3-11.1-136.7-38.7-184-52.5C9.4 322.7 0 310.2 0 296V216c0-14.2 9.4-26.7 23-30.7c47.3-13.8 144.7-41.4 184-52.5c11.3-3.2 23-4.8 34.7-4.8H350c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16h94c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64zM241.7 336h54.5c-15.3-22.9-24.2-50.4-24.2-80s8.9-57.1 24.2-80H241.7c-7.4 0-14.6 1-21.7 3C183.7 189.3 97.9 213.6 48 228v56c49.9 14.5 135.7 38.7 172.1 49c7 2 14.3 3 21.7 3zM416 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM398.1 209.9L416 227.7l17.9-17.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L444.3 256l17.9 17.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L416 284.3l-17.9 17.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L387.7 256l-17.9-17.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"]
};
var faMarker = {
  prefix: 'far',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M336 113.9L225.9 224 288 286.1 447 127c17.1-17.1 17.1-44.9 0-62.1s-44.9-17.1-62.1 0l-15 15L336 113.9zm-144 144l-58.5 58.5c-38.8 38.8-66 87.5-78.6 140.7c53.2-12.7 101.9-39.9 140.7-78.6L254.1 320 192 257.9zM232.4 23.7c27.9-18.4 65.9-15.4 90.5 9.2l0 0L336 46.1l15-15 0 0C386.9-4.8 445.1-4.8 481 31c35.9 35.9 35.9 94.1 0 129.9L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8l80-80L199 183l69.1-69.1 6.2-6.2L285.1 97l17-17L289 66.9l0 0c-9.4-9.4-24.6-9.3-33.9 0L169 153c-4.1 4.1-9.3 6.4-14.7 6.9c-6.9 .7-14-1.7-19.3-6.9c-9.4-9.4-9.4-24.6 0-33.9L221.1 33c3.5-3.5 7.3-6.6 11.3-9.2z"]
};
var faBinBottles = {
  prefix: 'far',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16V24c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96H256c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192h32c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V66.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5H608h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7H135.1c-40.6 0-74.7-30.4-79.5-70.7L32 240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8zm71.4 243.7c1.9 16.1 15.6 28.3 31.8 28.3H504.9c16.2 0 29.9-12.1 31.8-28.3l23-195.7H80.3l23 195.7z"]
};
var faFaceLaughBeam = {
  prefix: 'far',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faLaughBeam = faFaceLaughBeam;
var faSquareArrowDownLeft = {
  prefix: 'far',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm288-48c13.3 0 24-10.7 24-24s-10.7-24-24-24H193.9L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H288z"]
};
var faBatteryBolt = {
  prefix: 'far',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", "M80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80h92.2c-11.6-13-15.3-31.5-9.5-48H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32H239.2l60-48H80zM464 368H304.8l-60 48H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H371.8c11.6 13 15.3 31.5 9.5 48H464c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H297.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faTreeLarge = {
  prefix: 'far',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", "M224 0c7.4 0 14.4 3.4 18.9 9.3L381.2 186.9c5.6 7.2 6.6 17 2.6 25.3s-12.4 13.5-21.6 13.5H345.7l67.2 100.6c4.9 7.4 5.4 16.8 1.2 24.6s-12.3 12.7-21.2 12.7H369l74.9 111.1c5 7.4 5.5 16.9 1.3 24.7S432.9 512 424 512H24c-8.9 0-17-4.9-21.2-12.7s-3.7-17.3 1.3-24.7L79 363.5H55c-8.9 0-17-4.9-21.2-12.7s-3.7-17.3 1.2-24.6l67.2-100.6H85.8c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L205.1 9.3C209.6 3.4 216.6 0 224 0zM134.9 177.6h12.3c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.2 24.6L99.9 315.5h24.2c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.3 24.7L69.1 464H378.9L303.9 352.9c-5-7.4-5.5-16.9-1.3-24.7s12.3-12.7 21.2-12.7h24.2L280.8 214.9c-4.9-7.4-5.4-16.8-1.2-24.6s12.3-12.7 21.2-12.7h12.3L224 63.1 134.9 177.6z"]
};
var faHelicopterSymbol = {
  prefix: 'far',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M461.6 224H510C495.6 108.2 403.8 16.4 288 2V50.5C377.3 64.2 447.8 134.8 461.6 224zM510 288H461.6C447.8 377.3 377.3 447.8 288 461.6V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V461.6C134.7 447.8 64.2 377.3 50.4 288H2zm0-64H50.4C64.2 134.8 134.7 64.2 224 50.5V2C108.2 16.4 16.4 108.2 2 224zm190-64c0-13.3-10.7-24-24-24s-24 10.7-24 24V352c0 13.3 10.7 24 24 24s24-10.7 24-24V280H320v72c0 13.3 10.7 24 24 24s24-10.7 24-24V160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192V160z"]
};
var faAperture = {
  prefix: 'far',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 464l67-116 13.8-23.8c0-.1 .1-.1 .1-.2l11.5-20 56.3 97.5C366.9 440.1 314.2 464 256 464zM163.6 208l-56.3-97.5C145.1 71.9 197.8 48 256 48L189 164l-13.9 24-11.5 20zm87.8-56l56.3-97.5c54.8 14 100.9 49.8 128.5 97.5h-134H274.7c-.1 0-.2 0-.3 0H251.4zm104.1 68.3c-.1-.1-.1-.2-.2-.3l-11.5-20H456.4c5 17.8 7.6 36.6 7.6 56c0 37.9-10.1 73.4-27.8 104l-67-116-13.7-23.7zM48 256c0-37.9 10.1-73.4 27.8-104l67 116 25.4 44H55.6c-5-17.8-7.6-36.6-7.6-56zM204.3 457.5c-54.8-14-100.9-49.8-128.5-97.5h134 50.8l-56.3 97.5zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216.7 212c4.3-7.4 12.1-11.9 20.6-12h37.3c8.5 .1 16.3 4.6 20.5 11.8l18.7 32.3c4.2 7.4 4.2 16.4 0 23.8c0 0 0 .1-.1 .1l-18.5 32c0 0 0 .1 0 .1c-4.3 7.4-12.2 11.9-20.7 11.9H237.5c-8.6 0-16.5-4.6-20.8-12l-18.5-32c-4.3-7.4-4.3-16.6 0-24l18.5-32z"]
};
var faUniversalAccess = {
  prefix: 'far',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1l11.9 5.1c26.1 11.2 54.2 17 82.7 17s56.5-5.8 82.7-17l11.9-5.1c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-11.9 5.1c-17.3 7.4-35.2 12.9-53.6 16.3v50.1c0 4.3 .7 8.6 2.1 12.6l28.7 86.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-24.4-73.2c-1.3-3.8-4.8-6.4-8.8-6.4s-7.6 2.6-8.8 6.4l-24.4 73.2c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l28.7-86.1c1.4-4.1 2.1-8.3 2.1-12.6V235.5c-18.4-3.5-36.3-8.9-53.6-16.3l-11.9-5.1c-12.2-5.2-17.8-19.3-12.6-31.5s19.3-17.8 31.5-12.6zM256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faGearComplex = {
  prefix: 'far',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm48 96a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM234.9 0c-22.2 0-41.5 15.2-46.7 36.7L180 71l-1.1 .4L148.9 53c-18.9-11.6-43.3-8.7-59 7L60.1 89.9c-15.7 15.7-18.6 40.1-7 59l18.4 30L71 180l-34.2 8.3C15.2 193.4 0 212.7 0 234.9v42.2c0 22.2 15.2 41.5 36.7 46.7L71 332l.4 1.1L53 363.1c-11.6 18.9-8.7 43.3 7 59l29.8 29.8c15.7 15.7 40.1 18.6 59 7l30-18.4 1.1 .4 8.3 34.2c5.2 21.6 24.5 36.7 46.7 36.7h42.2c22.2 0 41.5-15.2 46.7-36.7L332 441l1.1-.4 30 18.4c18.9 11.6 43.3 8.7 59-7l29.8-29.8c15.7-15.7 18.6-40.1 7-59l-18.4-30 .4-1.1 34.2-8.3c21.6-5.2 36.7-24.5 36.7-46.7V234.9c0-22.2-15.2-41.5-36.7-46.7L441 180l-.4-1.1 18.4-30c11.6-18.9 8.7-43.3-7-59L422.1 60.1c-15.7-15.7-40.1-18.6-59-7l-30 18.4L332 71l-8.3-34.2C318.6 15.2 299.3 0 277.1 0H234.9zm0 48l42.2 0 11.3 46.6c1.9 8 7.9 14.5 15.7 17.1c6.8 2.3 13.5 5 19.9 8.2c7.4 3.7 16.2 3.3 23.3-1l40.9-25L418 123.8l-25 40.9c-4.3 7.1-4.7 15.9-1 23.3c3.2 6.4 6 13 8.2 19.9c2.6 7.9 9.1 13.8 17.1 15.7L464 234.9v42.2l-46.6 11.3c-8 1.9-14.5 7.9-17.1 15.7c-2.3 6.8-5 13.5-8.2 19.9c-3.7 7.4-3.3 16.2 1 23.3l25 40.9L388.2 418l-40.9-25c-7.1-4.3-15.9-4.7-23.3-1c-6.4 3.2-13 6-19.9 8.2c-7.9 2.6-13.8 9.1-15.7 17.1L277.1 464H234.9l-11.3-46.6c-1.9-8-7.9-14.5-15.7-17.1c-6.8-2.3-13.5-5-19.9-8.2c-7.4-3.7-16.2-3.3-23.3 1l-40.9 25L94 388.2l25-40.9c4.3-7.1 4.7-15.9 1-23.3c-3.2-6.4-6-13-8.2-19.9c-2.6-7.9-9.1-13.8-17.1-15.7L48 277.1l0-42.2 46.6-11.3c8-1.9 14.5-7.9 17.1-15.7c2.3-6.8 5-13.5 8.2-19.9c3.7-7.4 3.3-16.2-1-23.3L94 123.8 123.8 94l40.9 25c7.1 4.3 15.9 4.7 23.3 1c6.4-3.2 13-6 19.9-8.2c7.9-2.6 13.8-9.1 15.7-17.1L234.9 48z"]
};
var faFileMagnifyingGlass = {
  prefix: 'far',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM272 304c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L263 425.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFileSearch = faFileMagnifyingGlass;
var faUpRight = {
  prefix: 'far',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", "M320 128V321.4c0 1.7-.8 3.2-2.1 4.2c-2.1 1.6-5 1.4-6.9-.5L257 271c-9.4-9.4-24.6-9.4-33.9 0L98.3 395.7c-2.7 2.7-6.5 4.3-10.3 4.3s-7.6-1.5-10.3-4.3L52.3 370.3c-2.7-2.7-4.3-6.5-4.3-10.3s1.5-7.6 4.3-10.3L177 225c9.4-9.4 9.4-24.6 0-33.9L122.9 137c-1.8-1.8-2.1-4.8-.5-6.9c1-1.3 2.5-2.1 4.2-2.1H320zm48-8c0-22.1-17.9-40-40-40H126.6c-16.8 0-32.5 7.9-42.6 21.3c-15.9 21.2-13.8 50.9 4.9 69.6L126.1 208 18.3 315.7C6.6 327.5 0 343.4 0 360s6.6 32.5 18.3 44.3l25.4 25.4C55.5 441.4 71.4 448 88 448s32.5-6.6 44.3-18.3L240 321.9 277.1 359c18.7 18.7 48.4 20.8 69.6 5c13.4-10.1 21.3-25.8 21.3-42.6V120z"]
};
var faCircleChevronUp = {
  prefix: 'far',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271L273 167c-9.4-9.4-24.6-9.4-33.9 0L135 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
var faChevronCircleUp = faCircleChevronUp;
var faUserPolice = {
  prefix: 'far',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm20.6 209.8l65.2 57.1c2.1 1.9 4.3 3.6 6.6 5.1H50.9c8.4-31.2 33.8-55.5 65.7-62.2zM358.4 464l4.7-3.4c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5L315 446.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9l4.7 3.4H259.5c2.3-1.5 4.5-3.2 6.6-5.1l65.2-57.1c31.9 6.7 57.3 30.9 65.7 62.2H358.4zM137.2 356.1c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6c0-71.6-55.9-130.1-126.5-134.2c-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0l-76.3-66.7z"]
};
var faLariSign = {
  prefix: 'far',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M144 32c13.3 0 24 10.7 24 24V97.5c7.9-1 15.9-1.5 24-1.5s16.1 .5 24 1.5V56c0-13.3 10.7-24 24-24s24 10.7 24 24v54c58.9 23.8 103.2 76 116.2 139.7c2.6 13-5.8 25.7-18.7 28.3s-25.7-5.8-28.3-18.7c-8.3-41-34-75.6-69.1-95.9V264c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118c-7.8-1.3-15.8-2-24-2s-16.2 .7-24 2l0 118c0 13.3-10.7 24-24 24s-24-10.7-24-24V163.3C77 188.2 48 234.7 48 288c0 79.5 64.5 144 144 144H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H192 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H65C25.1 396.8 0 345.3 0 288c0-80.6 49.6-149.6 120-178V56c0-13.3 10.7-24 24-24z"]
};
var faVolcano = {
  prefix: 'far',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM48 459.8c0 2.3 1.9 4.2 4.2 4.2H459.8c2.3 0 4.2-1.9 4.2-4.2c0-1-.4-2-1.1-2.8L361.3 342.7l-15 15c-6.6 6.6-15.5 10.3-24.8 10.3c-11 0-21.4-5.2-28-14l-18-24c-12.3-16.4-31.5-26-52-26c-15.2 0-29.9 5.3-41.6 15.1l-39.4 32.8L49.1 457.1c-.7 .8-1.1 1.7-1.1 2.8zM163.4 256.2c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"]
};
var faTeddyBear = {
  prefix: 'far',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", "M144 80c0-17.7 14.3-32 32-32c14 0 25.9 9 30.3 21.5c4 11.5 15.9 18.2 27.8 15.6c16-3.5 34.2-5.1 54-5.1s38 1.7 54 5.1c11.9 2.6 23.8-4.1 27.8-15.6C374.1 57 386 48 400 48c17.7 0 32 14.3 32 32c0 11.5-6.1 21.7-15.4 27.3c-9 5.5-13.3 16.2-10.8 26.4c1.3 5.3 2.1 11.3 2.1 18.3c0 54.9-51 104-120 104s-120-49.1-120-104c0-6.9 .8-13 2.1-18.3c2.6-10.2-1.8-20.9-10.8-26.4C150.1 101.7 144 91.5 144 80zM176 0C131.8 0 96 35.8 96 80c0 22.8 9.5 43.3 24.7 57.9c-.4 3.4-.6 6.8-.7 10.3c-25.2-16.9-59.5-16.5-84.6 3.3c-31.2 24.6-36.6 69.9-12 101.1l25.8 32.7c5.5 6.9 11.2 13.6 17.1 19.9C28.6 311.7 0 344.5 0 384c0 3.9 .3 7.7 .8 11.4c.1 .8 .3 1.5 .4 2.3l13 53.3c8 33 35.8 56.9 68.9 60.6c1.6 .3 3.2 .5 4.8 .5h4 28H456h28 4c1.6 0 3.3-.2 4.8-.5c33.1-3.6 60.9-27.6 68.9-60.6l13-53.3c.2-.8 .3-1.5 .4-2.3c.5-3.7 .8-7.5 .8-11.4c0-39.5-28.6-72.3-66.3-78.8c5.9-6.3 11.6-13 17.1-19.9l25.8-32.7c24.6-31.2 19.2-76.5-12-101.1c-25.1-19.8-59.4-20.2-84.6-3.3c-.1-3.5-.3-6.9-.7-10.3C470.5 123.3 480 102.8 480 80c0-44.2-35.8-80-80-80c-27.5 0-51.8 13.9-66.1 35c-14.7-2.1-30.2-3-45.9-3s-31.1 .9-45.9 3C227.8 13.9 203.5 0 176 0zM92 464H90.6c-.3 0-.6-.1-.9-.1c-13.8-1-25.5-10.7-28.8-24.3l-12.7-52c-.1-1.2-.2-2.4-.2-3.6c0-17.7 14.3-32 32-32c16.1 0 29.5 11.9 31.7 27.4c1.7 11.8 11.8 20.6 23.8 20.6h.6c13.3 0 24-10.7 24-24V332.5c0-8.1-4.1-15.7-11-20.1c-22.9-14.8-44-33.7-62.1-56.8L61.1 222.9c-8.2-10.4-6.4-25.5 4-33.7s25.5-6.4 33.7 4l25.8 32.7c83.3 105.7 243.5 105.7 326.8 0l25.8-32.7c8.2-10.4 23.3-12.2 33.7-4s12.2 23.3 4 33.7l-25.8 32.7c-18.1 23-39.2 41.9-62.1 56.8c-6.8 4.4-11 12-11 20.1V376c0 13.3 10.7 24 24 24h.6c11.9 0 22.1-8.8 23.8-20.6c2.2-15.5 15.6-27.4 31.7-27.4c17.7 0 32 14.3 32 32c0 1.2-.1 2.4-.2 3.6l-12.7 52c-3.3 13.6-15 23.4-28.8 24.3c-.3 0-.6 0-.9 .1H484 456 376V416c0-44.2-35.8-80-80-80H280c-44.2 0-80 35.8-80 80v48H120 92zm156 0V416c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v48H248zm8-320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 32c0-13.3-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24s32-10.7 32-24z"]
};
var faStocking = {
  prefix: 'far',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M96 0C78.3 0 64 14.3 64 32V64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm48 238.9V128H96V238.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V128H304V315.5c0 26.7-13.4 51.7-35.6 66.6L164.3 451.4C152 459.6 137.6 464 122.8 464C81.5 464 48 430.5 48 389.2v-2.2c0-25.8 12.9-49.8 34.3-64.1l26.1-17.4c22.3-14.8 35.6-39.8 35.6-66.6z"]
};
var faPersonWalkingDashedLineArrowRight = {
  prefix: 'far',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128h-4.9c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM553 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H392c-13.3 0-24 10.7-24 24s10.7 24 24 24H558.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80zM392 128c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm24 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344zm-24 72c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-13.3-10.7-24-24-24z"]
};
var faImageSlash = {
  prefix: 'far',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM134.4 80H512c8.8 0 16 7.2 16 16V388.5l-53.4-41.9L387 233.3c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3l-7.2 9.3L256 175.3c-.4-26.2-21.7-47.3-48-47.3c-3.7 0-7.4 .4-10.8 1.2L134.4 80zm353 400L282.9 318.9 266 340.7l-30.5-42.7C231 291.7 223.8 288 216 288s-15 3.7-19.5 10.1l-80 112-4.5 6.3 0-.3V184.2L64 146.4V416c0 35.3 28.7 64 64 64H487.4z"]
};
var faMaskSnorkel = {
  prefix: 'far',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M552 32c13.3 0 24 10.7 24 24l0 104H528V56c0-13.3 10.7-24 24-24zM528 376.6V192h48l0 184.6C576 451.4 515.4 512 440.6 512c-67.4 0-124.5-49.5-134-116.2l-2.3-16.4c-1.9-13.1 7.2-25.3 20.4-27.2s25.3 7.2 27.2 20.4l2.3 16.4c6.2 43.1 43 75 86.5 75c48.3 0 87.4-39.1 87.4-87.4zM64 112c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h79.7c7.1 0 13.4-4.7 15.4-11.6l3.4-11.7c17.7-61.9 105.4-61.9 123.1 0l3.4 11.7c2 6.9 8.2 11.6 15.4 11.6H384c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM304.3 288c-22.3 0-42.4-11.5-54-29.6c-.7-1-1.3-2.1-1.9-3.2c-.3-.5-.6-1-.8-1.5c-2-3.8-3.6-7.8-4.8-12.1l-.6-2.2-2.7-9.6c-4.4-15.5-26.3-15.5-30.8 0l-2.7 9.6-.6 2.2c-1.2 4.2-2.8 8.3-4.8 12.1c-.3 .5-.5 1-.8 1.5c-.6 1.1-1.2 2.2-1.9 3.2c-11.5 18.1-31.7 29.6-54 29.6H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H384c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H304.3z"]
};
var faSmoke = {
  prefix: 'far',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", "M80 128c0-44.2 35.8-80 80-80c31.1 0 58 17.7 71.3 43.7c3.3 6.5 9.5 11.2 16.7 12.6s14.7-.5 20.2-5.3c14-11.9 32-19 51.8-19c24.3 0 46.1 10.8 60.7 27.9c4.9 2 9.7 4.3 14.4 6.8c9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-21.9 0-42.6 5.5-60.7 15.3C235.9 18.5 200.1 0 160 0C89.3 0 32 57.3 32 128c0 32 11.7 61.2 31.1 83.6c16.1-8.3 33.6-14.3 52.2-17.3C94 180 80 155.6 80 128zm512 96c0 27.5-13.8 51.7-34.9 66.1c12.3 10.4 22.8 22.9 31 36.8C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128c-46.6 0-87.3 24.8-109.7 62c-22.2-18.7-51-30-82.3-30c-51.6 0-96 30.5-116.3 74.4c10.7 3.9 20.9 8.7 30.5 14.5c7.9-5 16.2-9.4 25-13C273.9 186.8 295.7 176 320 176c24.3 0 46.1 10.8 60.7 27.9c13.7 5.6 26.5 13.1 38 22.2c7.5-3 13.1-9.6 14.7-17.7c7.2-36.7 39.7-64.4 78.5-64.4c44.2 0 80 35.8 80 80zM48 368c0-53 43-96 96-96c29.5 0 55.9 13.3 73.5 34.3c4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33c36.6 0 67.5 24.6 77 58.2c2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5c35.3 0 64 28.7 64 64s-28.7 64-64 64H144c-53 0-96-43-96-96zm96-144C64.5 224 0 288.5 0 368s64.5 144 144 144H464c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.7 0-62.5 12.2-85.1 32.3C210.2 236.1 178.5 224 144 224z"]
};
var faSterlingSign = {
  prefix: 'far',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M96 159.2C96 115.5 131.5 80 175.2 80c8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4L215.5 38.5c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2V224H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48v63.4c0 17.4-4.4 34.5-12.7 49.8L2.9 444.5c-4.1 7.4-3.9 16.5 .4 23.7S15.5 480 24 480H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H64.4l13-23.9C89.6 385.8 96 360.8 96 335.4V272H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H96V159.2z"]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faBatteryExclamation = {
  prefix: 'far',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", "M208 96v48H80c-17.7 0-32 14.3-32 32V336c0 17.7 14.3 32 32 32H193.6c-1 5.2-1.6 10.5-1.6 16c0 11.4 2.4 22.2 6.7 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H208zM464 416H345.3c4.3-9.8 6.7-20.6 6.7-32c0-5.5-.6-10.8-1.6-16H464c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H336V96H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM240 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faViruses = {
  prefix: 'far',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M327.8 293.8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 34 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24s24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l0 0 9.5 9.5zM285.8 192c-17.9-17.2-28-41.6-27.5-66.4c-11.1 .2-22.1-1.7-32.4-5.5c-12.7-4.7-24.4-12.2-33.9-22c-17.2 17.9-41.6 28-66.4 27.5c.5 24.8-9.6 49.2-27.5 66.4c17.9 17.2 28 41.6 27.5 66.4c24.8-.5 49.2 9.6 66.4 27.5c17.2-17.9 41.6-28 66.4-27.5c-.5-24.8 9.6-49.2 27.5-66.4zM512 240c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM152 176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm72 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSquarePersonConfined = {
  prefix: 'far',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM292 200c33.1 0 60 26.9 60 60v88c0 31.8-24.7 57.8-56 59.9v.1c-.7 0-1.5 0-2.2 0c-.6 0-1.2 0-1.8 0c-5.7 0-11.1-.8-16.3-2.2c-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L232 309V260c0-33.1 26.9-60 60-60zm-4.2 159.2c1.8 .3 3.7 .6 5.6 .7c6-.7 10.6-5.8 10.6-11.9V260c0-6.6-5.4-12-12-12s-12 5.4-12 12v88c0 5.2 3.2 9.5 7.8 11.2zM208 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faUserTie = {
  prefix: 'far',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2 43.8-87.6c3-6 9.4-9.5 15.9-8.4C390.4 335.6 448 401.7 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9c6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2zm-90.6 17.1C82.3 391.1 55.4 424.2 49.3 464h113l-43.8-87.7zM285.7 464h113c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z"]
};
var faArrowDownLong = {
  prefix: 'far',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M175 505c9.4 9.4 24.6 9.4 33.9 0L345 369c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 406.1L73 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 505z"]
};
var faLongArrowDown = faArrowDownLong;
var faTentArrowDownToLine = {
  prefix: 'far',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zM369.3 133c8.6-6.7 20.7-6.7 29.4 0L565.2 261.7c10.7 8.3 18 20.1 20.7 33.3l33.9 169.3C631.2 466.1 640 476 640 488c0 13.3-10.7 24-24 24H600 168 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H148.3l33.8-169c2.6-13.2 10-25.1 20.7-33.3L369.3 133zm-172 331H360V200.9L232.1 299.7c-1.5 1.2-2.6 2.9-3 4.8L197.3 464zM472 464h98.7L538.8 304.4c-.4-1.9-1.4-3.6-3-4.8L408 200.9V336l64 128z"]
};
var faCertificate = {
  prefix: 'far',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M178.7 122.2c11.2-6.5 19.3-17.2 22.5-29.8l5.3-20.9 15 15.5c9 9.3 21.4 14.5 34.4 14.5s25.4-5.2 34.4-14.5l15-15.5 5.3 20.9c3.2 12.6 11.3 23.3 22.5 29.8s24.6 8.1 37 4.6l20.8-5.9-5.9 20.8c-3.5 12.5-1.9 25.8 4.6 37s17.2 19.3 29.8 22.5l20.9 5.3-15.5 15c-9.3 9-14.5 21.4-14.5 34.4s5.2 25.4 14.5 34.4l15.5 15-20.9 5.3c-12.6 3.2-23.3 11.3-29.8 22.5s-8.1 24.6-4.6 37l5.9 20.8-20.8-5.9c-12.5-3.5-25.8-1.9-37 4.6s-19.3 17.2-22.5 29.8l-5.3 20.9-15-15.5c-9-9.3-21.4-14.5-34.4-14.5s-25.4 5.2-34.4 14.5l-15 15.5-5.3-20.9c-3.2-12.6-11.3-23.3-22.5-29.8s-24.6-8.1-37-4.6l-20.8 5.9 5.9-20.8c3.5-12.5 1.9-25.8-4.6-37s-17.2-19.3-29.8-22.5l-20.9-5.3 15.5-15c9.3-9 14.5-21.4 14.5-34.4s-5.2-25.4-14.5-34.4l-15.5-15 20.9-5.3c12.6-3.2 23.3-11.3 29.8-22.5s8.1-24.6 4.6-37l-5.9-20.8 20.8 5.9c12.5 3.5 25.8 1.9 37.1-4.6zM222.5 19.1L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-4 15.9L154.7 80.6 108.5 67.5 92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l4.5 15.8 13.1 46.2L34.1 166.5l-15.9 4c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l11.8 11.5L53.5 256 19.1 289.5 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l15.9 4 46.5 11.8L67.5 403.5l-4.5 15.8c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l15.8-4.5 46.2-13.1 11.8 46.5 4 15.9c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L222.5 493 256 458.5 289.5 493 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l4-15.9 11.8-46.5 46.2 13.1 15.8 4.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-4.5-15.8-13.1-46.2 46.5-11.8 15.9-4c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L493 289.5 458.5 256 493 222.5 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-15.9-4-46.5-11.8 13.1-46.2 4.5-15.8c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-15.8 4.5L357.3 80.6 345.5 34.1l-4-15.9c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L289.5 19.1 256 53.5 222.5 19.1z"]
};
var faCrystalBall = {
  prefix: 'far',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M400 224c0 71-42 132.2-102.6 160h83.3c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160h83.3C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zM167.5 100.3c-2.6-7-12.4-7-15 0l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4zm113 48l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8c-2.6-7-12.4-7-15 0zM20.3 474.2c-5.1 7.3-5.8 16.9-1.6 24.8S31.1 512 40 512H408c8.9 0 17.2-5 21.3-12.9s3.5-17.5-1.6-24.8L386.9 416H61.1L20.3 474.2z"]
};
var faReplyAll = {
  prefix: 'far',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", "M208.5 73.4c9.6-9.1 10-24.3 .9-33.9s-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4zM352 240l0 0H328c-13.3 0-24 10.7-24 24v24 28.1L183.9 208 304 99.9V128v24c0 13.3 10.7 24 24 24h24 48c70.7 0 128 57.3 128 128c0 15.3-1.9 29.1-5.2 41.5C506 284.7 450.2 240 384 240H352zm0 96V288h32c5.4 0 10.8 .5 16 1.3c45.4 7.6 80 47.1 80 94.7c0 17.3-4.2 30.5-9.5 40.2c-1.6 2.9-3.3 5.5-5 7.9c-2.6 3.5-5.3 6.4-7.7 8.6c-.5 .5-1 .9-1.4 1.4c-4.8 4.9-8.3 11.3-8.3 18.1c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9c2.6-1.4 6.3-3.5 10.8-6.5c2.7-1.8 5.7-3.8 8.9-6.2c3.7-2.7 7.6-5.8 11.7-9.3C537.4 430.2 576 382 576 304c0-97.2-78.8-176-176-176H352V80 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V336z"]
};
var faMailReplyAll = faReplyAll;
var faSuitcase = {
  prefix: 'far',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm232 48H152h-8V432H368V144h-8zM64 144c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H96V144H64zM448 432c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H416V432h32z"]
};
var faPersonSkating = {
  prefix: 'far',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 120c0-13.3 10.7-24 24-24H321.4c35.6 0 53.5 43.1 28.3 68.3L268.9 245l69.3 60c8.8 7.6 13.8 18.6 13.8 30.2V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V339l-85.3-74c-24.8-21.5-26-59.7-1.9-82.5c11.9-11.2 26.8-25.1 41.6-38.5H152c-13.3 0-24-10.7-24-24zM79 367L179.4 266.6c4.8 8.5 11.2 16.4 19 23.2l13.7 11.9L113 401c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm324.9 81.4c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faSkating = faPersonSkating;
var faStarShooting = {
  prefix: 'far',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M313 41L265 89c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM129.5 388.7L120 444l49.5-26.1c14-7.4 30.7-7.4 44.7 0L263.8 444l-9.5-55.4c-2.7-15.6 2.5-31.4 13.8-42.4L308.3 307l-55.5-8.1c-15.6-2.3-29.2-12.1-36.1-26.3l-24.8-50.3-24.8 50.3c-7 14.2-20.5 24-36.1 26.3L75.5 307l40.2 39.2c11.3 11 16.4 26.9 13.8 42.4zm-5.4-137.3l46.3-94c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM505 41L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faBinaryLock = {
  prefix: 'far',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", "M318 4.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C235.8 21.4 229 35 233.2 47.6S251 67 263.6 62.8L280 57.3V176H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h56 56c13.3 0 24-10.7 24-24s-10.7-24-24-24H328V24c0-7.7-3.7-15-10-19.5zM94 292.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C11.8 309.4 5 323 9.2 335.6S27 355 39.6 350.8L56 345.3V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H80h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H104V312c0-7.7-3.7-15-10-19.5zM72 0C32.2 0 0 32.2 0 72v80c0 39.8 32.2 72 72 72h48c39.8 0 72-32.2 72-72V72c0-39.8-32.2-72-72-72H72zM48 72c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V72zM192 360v80c0 39.8 32.2 72 72 72h48c39.8 0 72-32.2 72-72V360c0-39.8-32.2-72-72-72H264c-39.8 0-72 32.2-72 72zm72-24h48c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H264c-13.3 0-24-10.7-24-24V360c0-13.3 10.7-24 24-24zm264-96c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFilterCircleDollar = {
  prefix: 'far',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", "M0 41.7C0 18.7 18.7 0 41.7 0H469.9C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8L411.6 193.2c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48H55L218.6 248.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4L256.3 358c-.2 3.3-.3 6.6-.3 10c0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3V272.5L9.4 68C3.3 60.6 0 51.3 0 41.7zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faFunnelDollar = faFilterCircleDollar;
var faCameraRetro = {
  prefix: 'far',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M192 112H64c-8.8 0-16 7.2-16 16v64H156.1c23.5-29.3 59.5-48 99.9-48s76.5 18.7 99.9 48H464V96c0-8.8-7.2-16-16-16H271.1c-2.5 0-4.9 .6-7.2 1.7l-50.5 25.2c-6.7 3.3-14 5.1-21.5 5.1zM48 240V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V240H380c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H48zM0 416V128C0 92.7 28.7 64 64 64l0-16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V64h32l50.5-25.2c8.9-4.4 18.7-6.8 28.6-6.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM336 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faCircleArrowDown = {
  prefix: 'far',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM361 289l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47V152c0-13.3 10.7-24 24-24s24 10.7 24 24V302.1l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faArrowCircleDown = faCircleArrowDown;
var faCommentPen = {
  prefix: 'far',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM340.8 155c-14.7-14.7-38.6-14.7-53.3 0L272.6 170l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 264.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 316c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 192.6l-71.9 71.9z"]
};
var faCommentEdit = faCommentPen;
var faFileImport = {
  prefix: 'far',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M448 464H192c-8.8 0-16-7.2-16-16V368H128v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64V256h48V64c0-8.8 7.2-16 16-16H352v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16zM297 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
var faArrowRightToFile = faFileImport;
var faBanjo = {
  prefix: 'far',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-22.2 59.1-61.5 61.5-1.2 1.2c-22-16.5-48.2-27.7-76.6-31.7V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.7c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.7c-4.1-28.5-15.3-54.6-31.7-76.6l1.2-1.2 0 0 61.5-61.5 59.1-22.2c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM153 311c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48z"]
};
var faSquareArrowUpRight = {
  prefix: 'far',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zm64 16c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faLightEmergencyOn = {
  prefix: 'far',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H72c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm544 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H568zM448 208v96h48V208c0-97.2-78.8-176-176-176s-176 78.8-176 176v96h48V208c0-70.7 57.3-128 128-128s128 57.3 128 128zM144 432V384H496v48H144zM96 384v48c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V384c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48zM320 144c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z"]
};
var faKerning = {
  prefix: 'far',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", "M453.8 34.1c5.6-12 .4-26.3-11.6-31.9s-26.3-.4-31.9 11.6l-216 464c-5.6 12-.4 26.3 11.6 31.9s26.3 .4 31.9-11.6l216-464zM45.5 109.3C39.5 97.4 25.1 92.6 13.3 98.5S-3.4 118.9 2.5 130.7l136 272c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l136-272c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L160 338.3 45.5 109.3zm328.2 293L397.3 352H562.7l23.6 50.2c5.6 12 19.9 17.1 31.9 11.5s17.1-19.9 11.5-31.9l-128-272c-4-8.4-12.4-13.8-21.7-13.8s-17.8 5.4-21.7 13.8l-128 272c-5.6 12-.5 26.3 11.5 31.9s26.3 .5 31.9-11.5zM480 176.4L540.1 304H419.9L480 176.4z"]
};
var faBoxOpen = {
  prefix: 'far',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M17.2 125.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 64 75.2 33.4c-6.7-.8-13.3 2.7-16.3 8.7L17.2 125.5zM320 64l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1L581.1 42.1c-3-6.1-9.6-9.6-16.3-8.7L320 64zm-1.1 64h2.2l0 0h-2.2l0 0zM528 225.3V378.5l-184 46V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V424.5l-184-46V225.3L64 211.6v167c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6v-167l-48 13.7z"]
};
var faSquareF = {
  prefix: 'far',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24z"]
};
var faScroll = {
  prefix: 'far',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M48 112c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V352c0-26.5-21.5-48-48-48h-.6-.6-.6-.6-.6-.6H524h-.6-.6-.6-.6-.6-.6-.6-.6H519h-.6-.6-.6-.6-.5-.6-.5-.6-.5-.5H513h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H507h-.5H506h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H499h-.5H498h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H487h-.5H486h-.5H485h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H456h-.5H455h-.5H454h-.5H453h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H441h-.5H440h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H431h-.5H430h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H423h-.5H422h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H415h-.5H414h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H407h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H400h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H393h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H386h-.5H385h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H378h-.5H377h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H370h-.5H369h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H360h-.5H359h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H347h-.5H346h-.5H345h-.5H344h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H315h-.5H314h-.5H313h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H302h-.5H301h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H294h-.5H293h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H287h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6H281h-.6-.6-.6-.6-.6-.6-.6-.6H276h-.6-.6-.6-.6-.6-.6H272c-26.5 0-48 21.5-48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V112c0-11.4-2.4-22.2-6.7-32H400c17.7 0 32 14.3 32 32V272h48V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v48c0 26.5 21.5 48 48 48H80V160H48V112zM496 432H265.3c4.3-9.8 6.7-20.6 6.7-32V352h0 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 0v48c0 17.7-14.3 32-32 32z"]
};
var faSpa = {
  prefix: 'far',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M288 92.1c21.2 24.9 52.1 69.7 68.6 134.5c13.3-10.3 27.4-19.5 42.2-27.6c-27.3-91.6-79.3-145.6-96.8-161.8c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.5 16.2-69.5 70.1-96.8 161.8c14.8 8.1 28.9 17.3 42.2 27.6c16.5-64.8 47.3-109.7 68.6-134.5zm-96 377c22.9 6.7 47 10.5 72 10.9h48c25-.4 49.1-4.1 72-10.9c111-32.7 192-135.4 192-257c0-11.1-9-20.1-20.1-20.1c-61.7 0-121.7 17.9-171.9 54.1c-41.8 30-75.1 71-96 118.7c-20.9-47.7-54.2-88.6-96-118.7C141.8 209.9 81.8 192 20.1 192C9 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-50.5C116.8 390.9 60.8 323.2 49.9 241.4c55.1 5.9 104.6 30.5 142.1 67.2c33.5 32.9 57.4 75.5 67.2 123.2c-23.5-.9-46.1-5.5-67.2-13.3zm192 0c-21.1 7.7-43.6 12.4-67.2 13.3c9.7-47.8 33.7-90.4 67.2-123.2c37.5-36.8 87-61.3 142.1-67.2C515.2 323.2 459.2 390.9 384 418.5z"]
};
var faArrowLeftFromLine = {
  prefix: 'far',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", "M7.6 238.5C2.7 243.1 0 249.4 0 256s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L84.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128zM400 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336z"]
};
var faArrowFromRight = faArrowLeftFromLine;
var faStrawberry = {
  prefix: 'far',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", "M494.1 33.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C439.7 38.4 420.3 61.8 402 80c-.7 .7-1.4 1.4-2 2c0-.7 0-1.4 0-2.1c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-10.8-8.6-35.4-24.9-68.2-26.6c19.4-19.7 42.9-47.5 56.3-78.7zM192.2 112c20.5 0 40.8 7.8 56.4 23.4l128 128c15.6 15.6 23.4 36 23.4 56.6c0 59.2-62.9 144-224 144c-60 0-87.8-11.7-102.1-25.9S48 396 48 336c0-161 84.9-224 144.2-224zm0-48C96.2 64 0 160 0 336C0 464 48 512 176 512c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64zm-2.8 90.5c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm47.3 98.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm96.7-66.3c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm24-80c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm55.3 90.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-192-80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-23.3 53.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3z"]
};
var faLocationPinLock = {
  prefix: 'far',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M192 451.7c18.5-23.7 41.6-54.7 64-88.1v83.2c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-16.9 2.8-32.6 9.4-46.1 18.9C329.6 106.3 267.6 48 192 48C112.5 48 48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm288 48c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faPause = {
  prefix: 'far',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", "M48 112l0 288H96V112H48zM0 112C0 85.5 21.5 64 48 64H96c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zm224 0V400h48V112H224zm-48 0c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48V400c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V112z"]
};
var faClockEightThirty = {
  prefix: 'far',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V300.8L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlaneEngines = {
  prefix: 'far',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M576 256c0-17.4-8.8-31.1-18.7-40.7c-9.9-9.6-22.4-16.9-34.8-22.4C498 182.1 468.7 176 448 176H381.8l-32.5-50.9C360.3 120.1 368 109 368 96c0-17.7-14.3-32-32-32H310.1L285.7 25.8C275.4 9.7 257.6 0 238.5 0H197.9c-27.1 0-46.4 26.4-38.1 52.2L199.4 176H148l-36-48c-7.6-10.1-19.4-16-32-16H37.9C17 112 0 129 0 149.9c0 3.8 .6 7.5 1.7 11.1l0 0 19.9 64.7C9 230.1 0 242 0 256s9 25.9 21.6 30.3L1.7 350.9l0 0C.6 354.6 0 358.3 0 362.1C0 383 17 400 37.9 400H80c12.6 0 24.4-5.9 32-16L92.8 369.6 112 384l36-48h51.4L159.8 459.8c-8.3 25.8 11 52.2 38.1 52.2l40.6 0c19.1 0 36.9-9.7 47.2-25.8L310.1 448H336c17.7 0 32-14.3 32-32c0-13-7.7-24.1-18.8-29.1L381.8 336H448c20.6 0 49.8-5.8 74.4-16.5c12.4-5.4 25-12.7 34.9-22.4c10-9.8 18.7-23.6 18.7-41.1zM448 224c13.4 0 36.1 4.4 55.1 12.8c9.4 4.2 16.4 8.7 20.7 12.9c4.2 4.1 4.2 6.1 4.2 6.3v0c0 .6-.1 2.8-4.2 6.8c-4.3 4.2-11.2 8.6-20.6 12.7C484.3 283.8 461.6 288 448 288H368.6c-8.2 0-15.8 4.2-20.2 11.1L245.2 460.3c-1.5 2.3-4 3.7-6.7 3.7H208.9l46.3-144.7c2.3-7.3 1-15.3-3.5-21.5s-11.7-9.8-19.4-9.8L136 288c-7.6 0-14.7 3.6-19.2 9.6L76 352H51.6l27.4-88.9c1.4-4.6 1.4-9.5 0-14.1L51.6 160H76l40.8 54.4c4.5 6 11.6 9.6 19.2 9.6h96.3c7.7 0 14.9-3.7 19.4-9.8s5.8-14.2 3.5-21.5L208.9 48h29.6c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9L245.2 51.7 348.4 212.9c4.4 6.9 12 11.1 20.2 11.1l79.4 0z"]
};
var faPlaneAlt = faPlaneEngines;
var faHillAvalanche = {
  prefix: 'far',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M551.1 391.1c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8zM448 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM48 440V145.9L366.1 464H72c-13.3 0-24-10.7-24-24zM68.3 98.3C43.1 73.1 0 91 0 126.6V440c0 39.8 32.2 72 72 72H385.4c35.6 0 53.5-43.1 28.3-68.3L68.3 98.3z"]
};
var faTemperatureEmpty = {
  prefix: 'far',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M96 112c0-35.3 28.7-64 64-64s64 28.7 64 64V273.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C90.3 301 96 288.4 96 273.9V112zM160 0C98.1 0 48 50.2 48 112V273.9c0 1.7-.7 4.4-3.2 7.8C26.7 305.7 16 335.7 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faBomb = {
  prefix: 'far',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", "M459.1 52.4l45.7 16.8c4.3 1.6 7.3 5.9 7.2 10.4c0 4.5-3 8.7-7.2 10.2l-45.7 16.8-16.5 45.8c-1.5 4.4-5.8 7.5-10.4 7.5s-8.9-3.1-10.4-7.5l-16.8-45.8L359.2 89.8c-4.2-1.5-7.2-5.7-7.2-10.2c0-4.6 3-8.9 7.2-10.4l46-16.8L421.7 6.5c1.9-3.9 6.1-6.5 10.4-6.5s8.5 2.6 10.4 6.5l16.5 45.8zM302.9 149.6c-12.1 7.2-27.1 8.8-40.7 3.8c-16.9-6.1-35.1-9.4-54.2-9.4c-88.4 0-160 71.6-160 160s71.6 160 160 160s160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2c-4.9-13.7-3.3-28.6 3.8-40.7l-59.5-59.5zm-24.4-41.3l2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 224c-39.8 0-72 32.2-72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-66.3 53.7-120 120-120c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faGaugeLow = {
  prefix: 'far',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56c0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1 .2-26.3 12.3-31.6s26.3 .2 31.6 12.3L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faTachometerAltSlow = faGaugeLow;
var faRegistered = {
  prefix: 'far',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80H184c-13.3 0-24 10.7-24 24zm48 88V176h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H208z"]
};
var faTrashCanPlus = {
  prefix: 'far',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zM200 376V312H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V200c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faAddressCard = {
  prefix: 'far',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faScaleUnbalancedFlip = {
  prefix: 'far',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M97.1 16.7c-4 12.6 2.9 26.1 15.5 30.2L240.4 87.7c3.1 32.4 25.5 59.2 55.6 68.6V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H320c13.3 0 24-10.7 24-24V156.3c14.2-4.5 26.8-12.8 36.4-23.8l132.3 42.3c12.6 4 26.1-2.9 30.2-15.5s-2.9-26.1-15.5-30.2L399.6 88.3c.3-2.7 .4-5.5 .4-8.3c0-44.2-35.8-80-80-80c-29.8 0-55.8 16.3-69.6 40.5L127.3 1.1c-12.6-4-26.1 2.9-30.2 15.5zM128 163.8L200.4 288H55.6L128 163.8zM254 305.1c2.6-11-1-22.3-6.7-32.1L152.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 273.1C3 282.8-.6 294.1 2 305.1C12.8 350 65.1 384 128 384s115.2-34 126-78.9zM583.3 416H438.4l72.4-124.2L583.3 416zm-72.4 96c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L534.9 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L391.6 401.1c-5.7 9.8-9.3 21.1-6.7 32.1C395.7 478 448 512 510.8 512zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faGlobeSnow = {
  prefix: 'far',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M297.4 384C358 356.2 400 295 400 224c0-97.2-78.8-176-176-176S48 126.8 48 224c0 71 42 132.2 102.6 160H67.2C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 62.7-25.7 119.3-67.2 160H297.4zM232 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.3 84.7l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H271.5l44.8 53.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2H248v48H200V336H144c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L176.5 256H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64c6.2-6.2 16.4-6.2 22.6 0zM328 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM80 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM20.3 474.2L61.1 416H386.9l40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8S416.9 512 408 512H40c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z"]
};
var faSubscript = {
  prefix: 'far',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24H51.2l96 144-96 144H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c8 0 15.5-4 20-10.7l92-138 92 138C272.5 444 280 448 288 448h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H300.8l-96-144 96-144H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H288c-8 0-15.5 4-20 10.7l-92 138L84 74.7C79.5 68 72 64 64 64H24zM472 312c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8V464H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h40 40c13.3 0 24-10.7 24-24s-10.7-24-24-24H472V312z"]
};
var faDiamondTurnRight = {
  prefix: 'far',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", "M50.9 249L249 50.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9s-5.2-1-7-2.9L50.9 263c-1.9-1.9-2.9-4.4-2.9-7s1-5.2 2.9-7zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17zM315.3 148.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v40H240c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V264c0-8.8 7.2-16 16-16h48v40c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
var faDirections = faDiamondTurnRight;
var faIntegral = {
  prefix: 'far',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M216 48c-17.7 0-32 14.3-32 32V432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416c0-13.3 10.7-24 24-24s24 10.7 24 24v16c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-44.2 35.8-80 80-80s80 35.8 80 80V96c0 13.3-10.7 24-24 24s-24-10.7-24-24V80c0-17.7-14.3-32-32-32z"]
};
var faBurst = {
  prefix: 'far',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M161.7 216.4c4.9-14.3 2.7-30.1-5.9-42.6l-39.2-57.1 57.1 39.2c12.5 8.6 28.3 10.7 42.6 5.9s25.5-16.2 30.2-30.6l9.4-29.1 11.7 36c4 12.4 12.9 22.6 24.6 28.3s25.2 6.4 37.5 2l22-8-8 22.1c-4.5 12.2-3.8 25.8 2 37.5s15.9 20.6 28.3 24.6l36 11.7-32.6 10.6c-13.5 4.4-24.3 14.5-29.7 27.6s-4.6 27.9 2 40.4l17 32.2-32.2-17c-12.5-6.6-27.3-7.3-40.4-2s-23.2 16.2-27.6 29.7L256 410.1l-10.6-32.6c-4.4-13.5-14.5-24.3-27.6-29.7s-27.9-4.6-40.4 2l-32.2 17 16.9-32.2c6.6-12.5 7.3-27.3 2-40.4s-16.2-23.2-29.7-27.6L101.9 256l29.1-9.4c14.4-4.7 25.8-15.9 30.6-30.2zm-2-128.5L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l83.7 122 28.3 41.3L68.6 216.3l-52 16.8C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l56.7 18.4 46.3 15L97 355.3 66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3L156.7 415l43.1-22.7 15 46.3 18.4 56.7c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l18.4-56.7 15-46.3L355.3 415l57.5 30.2c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L415 355.3l-22.7-43.1 46.3-15 56.7-18.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-60.8-19.7-45.7-14.8 16.4-45.1 9.2-25.3c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-25.3 9.2-45.1 16.4L298.5 77.4 278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-16.8 52-15.4 47.6L159.6 87.9z"]
};
var faHouseLaptop = {
  prefix: 'far',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M224.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L416 198.4V240H368V159.3L240 55 112 159.3V360c0 4.4 3.6 8 8 8H272v48H120c-30.9 0-56-25.1-56-56V198.4L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM288 216v45.7c-6 6.8-10.6 14.9-13.3 23.8c-3.2 1.6-6.9 2.5-10.7 2.5H216c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24zm64 104V464H544V320H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V464h36c6.6 0 12 5.4 12 12c0 19.9-16.1 36-36 36H592 544 352 304 292c-19.9 0-36-16.1-36-36c0-6.6 5.4-12 12-12h36V304z"]
};
var faLaptopHouse = faHouseLaptop;
var faFaceTired = {
  prefix: 'far',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faTired = faFaceTired;
var faMoneyBills = {
  prefix: 'far',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", "M528 80c0 35.3 28.7 64 64 64V272c-35.3 0-64 28.7-64 64H208c0-35.3-28.7-64-64-64V144c35.3 0 64-28.7 64-64H528zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faBlindsRaised = {
  prefix: 'far',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", "M24 0C10.7 0 0 10.7 0 24C0 34.6 6.9 43.6 16.4 46.8l-15 45C.5 94.6 0 97.5 0 100.5C0 115.7 12.3 128 27.5 128H112V80H55.9L66.6 48H112h32V80v48 80 48V372.1C116 382 96 408.6 96 440c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.4-20-58-48-67.9V256 208 128 80 48h32H445.4l10.7 32H224v48H484.5c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.4-8.7l-15-45C505.1 43.6 512 34.6 512 24c0-13.3-10.7-24-24-24h-8H192 144 32 24zM144 440a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 208H55.5l15.4-48H20.5L1.3 219.9c-.9 2.7-1.3 5.6-1.3 8.4C0 243.6 12.4 256 27.7 256H112V208zm112 48H484.3c15.3 0 27.7-12.4 27.7-27.7c0-2.9-.4-5.7-1.3-8.4L491.5 160H441.1l15.4 48H224v48z"]
};
var faSmog = {
  prefix: 'far',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M80 144c0-53 43-96 96-96c29.5 0 55.9 13.3 73.5 34.3c4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33c36.6 0 67.5 24.6 77 58.2c2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5c35.3 0 64 28.7 64 64s-28.7 64-64 64H459c-6.5 0-12.8 2.7-17.3 7.4c-14.6 15.2-35 24.6-57.7 24.6s-43.1-9.4-57.7-24.6c-4.5-4.7-10.8-7.4-17.3-7.4H176c-53 0-96-43-96-96zM176 0C96.5 0 32 64.5 32 144s64.5 144 144 144H299.3c22.5 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM552 464H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zm280-72c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24zM200 368H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faUfoBeam = {
  prefix: 'far',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M152.5 163.3l-16.9 17c-4-4-6.5-9.2-7-14.9c-.6-7-.8-14-.5-20.7c-22 6.7-40.3 14.6-53.9 23C52.5 181.2 48 192.2 48 197.9c0 4.1 2.2 11 12.6 20.2c10.4 9.1 26.8 18.4 49.1 26.7C154.2 261.3 217.2 272 288 272s133.8-10.7 178.3-27.2c22.3-8.3 38.7-17.6 49.1-26.7c10.4-9.2 12.6-16 12.6-20.2c0-5.7-4.5-16.7-26.2-30.1c-13.7-8.4-31.9-16.3-53.9-23c.3 6.8 .1 13.7-.5 20.7c-.5 5.6-3 10.9-7 14.9l-16.9-17c16.9 17 16.9 17 16.9 17.1l0 0-.1 0-.1 .1-.3 .3c-.2 .2-.4 .4-.7 .7c-.6 .5-1.3 1.1-2.1 1.9c-1.8 1.5-4.2 3.3-7.3 5.5c-6.3 4.3-15.4 9.7-27.7 14.9C377.4 214.2 340.3 224 288 224s-89.4-9.8-114.1-20.2c-12.3-5.2-21.4-10.6-27.7-14.9c-3.1-2.2-5.6-4-7.3-5.5c-.9-.7-1.6-1.4-2.1-1.9c-.3-.3-.5-.5-.7-.7l-.3-.3-.1-.1 0 0 0 0c0 0 0 0 16.9-17.1zM49 126.9c24-14.8 55.6-26.7 91.7-35.2C165.7 36.3 224.3 0 288 0s122.3 36.3 147.3 91.7c36.1 8.6 67.8 20.4 91.7 35.2c26.1 16.1 49 39.7 49 70.9c0 23-12.6 41.9-28.9 56.2c-16.3 14.4-38.6 26.2-64.1 35.7C432 308.7 363 320 288 320s-144-11.3-195-30.2c-25.4-9.5-47.7-21.3-64.1-35.7C12.6 239.8 0 220.8 0 197.9c0-31.2 22.9-54.8 49-70.9zm351 24c-.5-57.5-50.3-103-112-103s-111.4 45.5-112 103c3.8 2.4 9.3 5.5 16.7 8.6c18.4 7.8 49.1 16.4 95.3 16.4s76.9-8.6 95.3-16.4c7.4-3.1 12.9-6.2 16.7-8.6zM117.2 363.2l-72 136c-6.2 11.7-20.7 16.2-32.4 10S-3.4 488.5 2.8 476.8l72-136c6.2-11.7 20.7-16.2 32.4-10s16.2 20.7 10 32.4zm384-22.5l72 136c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-72-136c-6.2-11.7-1.7-26.2 10-32.4s26.2-1.7 32.4 10z"]
};
var faCircleCaretUp = {
  prefix: 'far',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c-6.7 0-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4H360c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112c-4.5-4.9-10.9-7.7-17.6-7.7z"]
};
var faCaretCircleUp = faCircleCaretUp;
var faUserVneckHairLong = {
  prefix: 'far',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zM48.3 461.9H399.7c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9c-41.4 16.9-71.3 56.4-74.4 103.1zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 322.2 448 389.5 448 469.9v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z"]
};
var faSquareALock = {
  prefix: 'far',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M64 80H384c8.8 0 16 7.2 16 16v84.1c14-9.8 30.3-16.4 48-18.9V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H320V432H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm181.8 61.9c-3.9-8.5-12.4-13.9-21.8-13.9s-17.9 5.4-21.8 13.9l-96 208c-5.6 12-.3 26.3 11.7 31.8s26.3 .3 31.8-11.7l12-26.1H286.2l12 26.1c4 8.8 12.7 13.9 21.8 13.9V352c0-11.4 3-22.1 8.2-31.4L245.8 141.9zM224 209.3L264 296H184l40-86.7zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faCrutch = {
  prefix: 'far',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M329 7L505 183c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L295 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM164.2 201.9L287.4 78.6l33.9 33.9L249.9 184 328 262.1l71.4-71.4 33.9 33.9L310.1 347.8c-11.8 11.8-26.8 20-43.1 23.7L159.4 395.4c-7.4 1.7-14.2 5.4-19.6 10.8L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l98.8-98.8c5.4-5.4 9.1-12.2 10.8-19.6L140.5 245c3.6-16.3 11.8-31.3 23.7-43.1zM216 217.9l-17.9 17.9c-5.4 5.4-9.1 12.2-10.8 19.6l-19.8 89 89-19.8c7.4-1.7 14.2-5.4 19.6-10.8L294.1 296 216 217.9z"]
};
var faGasPumpSlash = {
  prefix: 'far',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-67.2-52.7C571.4 404.9 576 391 576 376V155.9c0-19.1-7.6-37.4-21.1-50.9L481 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33V160c0 29.8 20.4 54.9 48 62V376c0 3.8-.9 7.4-2.5 10.6L384 275.7V64c0-35.3-28.7-64-64-64H160c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM144 87.6V64c0-8.8 7.2-16 16-16H320c8.8 0 16 7.2 16 16V238L144 87.6zM144 464V209.5L96 171.6V464l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h8 48H336h48 8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0V398.5l-48-37.8V464H144z"]
};
var faFontAwesome = {
  prefix: 'far',
  iconName: 'font-awesome',
  icon: [448, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V124.2l12.5-2.4c16.7-3.2 31.5-8.5 44.2-13.1l0 0 0 0c3.7-1.3 7.1-2.6 10.4-3.7c15.2-5.2 30.4-9.1 51.2-9.1c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c32.4 0 53.7-6.8 90.5-19.6V342.9l-9.5 3.3c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-16.8 0-31 2-43.9 5c-12.9 3-20.9 16-17.9 28.9s16 20.9 28.9 17.9c9.6-2.2 20.1-3.7 32.9-3.7c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c34.4 0 56.4-7.7 97.8-22.2c7.5-2.6 15.5-5.4 24.4-8.5l16.2-5.5V360 72 38.4L416.2 49.3c-9.7 3.3-18.2 6.3-25.7 8.9c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-27.8 0-48.5 5.5-66.6 11.6c-4.9 1.7-9.3 3.3-13.6 4.8c-11.9 4.3-22 7.9-34.7 10.3L48 75.4V56z"]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faCloudArrowUp = {
  prefix: 'far',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V384c0 13.3 10.7 24 24 24s24-10.7 24-24V249.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faPalette = {
  prefix: 'far',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M464 258.2c0 2.7-1 5.2-4.2 8c-3.8 3.1-10.1 5.8-17.8 5.8H344c-53 0-96 43-96 96c0 6.8 .7 13.4 2.1 19.8c3.3 15.7 10.2 31.1 14.4 40.6l0 0c.7 1.6 1.4 3 1.9 4.3c5 11.5 5.6 15.4 5.6 17.1c0 5.3-1.9 9.5-3.8 11.8c-.9 1.1-1.6 1.6-2 1.8c-.3 .2-.8 .3-1.6 .4c-2.9 .1-5.7 .2-8.6 .2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48h97.9c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTransporter4 = {
  prefix: 'far',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", "M224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM472.7 134.6L480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm-416 224L64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416 6.6 408.7C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24z"]
};
var faChartMixedUpCircleCurrency = {
  prefix: 'far',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", "M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h52.5L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2L496 80.7V136c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H408zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8V432zm-8-208c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-4.4 3.6-8 8-8s8 3.6 8 8v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]
};
var faObjectsAlignRight = {
  prefix: 'far',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464zM336 176L48 176l0-64 288 0 0 64zm48-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64zM336 400l-160 0 0-64 160 0 0 64zm48-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64z"]
};
var faArrowsTurnRight = {
  prefix: 'far',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", "M294.4 7.7c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L362.9 152H120c-39.8 0-72 32.2-72 72v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V224c0-66.3 53.7-120 120-120H362.9L295.7 41.6c-9.7-9-10.3-24.2-1.3-33.9zm-96 256c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L266.9 408H88c-22.1 0-40 17.9-40 40v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448c0-48.6 39.4-88 88-88H266.9l-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9z"]
};
var faVest = {
  prefix: 'far',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M104 0h8.3 5c19.4 0 35.2 10 45.5 19.2C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8C295.5 10 311.3 0 330.7 0h5H344c1.9 0 3.8 .1 5.7 .3C378 3.2 400 27 400 56v72 58.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37V456c0 30.9-25.1 56-56 56H264c-30.9 0-56-25.1-56-56V295.1c0-7.1 1-14.1 3.1-20.9L269.5 81.5c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5l28.8 95-25.1 82.8L119.9 53.7c-1-3.4-4.1-5.7-7.7-5.7H104c-4.4 0-8 3.6-8 8v72 58.7c0 13-3.5 25.9-10.3 37L51.4 280.9c-2.2 3.7-3.4 8-3.4 12.3V398.1l55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L51.4 462.5c1.3 .9 2.9 1.5 4.6 1.5H176.4c1.6 17.6 8.4 33.8 18.8 46.9c-3.6 .7-7.4 1.1-11.2 1.1H56c-30.9 0-56-25.1-56-56V293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3V128 56C48 25.1 73.1 0 104 0zM352 56c0-4.4-3.6-8-8-8h0-8.3c-3.5 0-6.6 2.3-7.7 5.7L257 288.2c-.7 2.3-1 4.6-1 7V456c0 4.4 3.6 8 8 8H392c1.7 0 3.3-.5 4.6-1.5L311 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55V293.3c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37V128 56z"]
};
var faPig = {
  prefix: 'far',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M475 32c-4 0-7.9 .5-11.8 1.5L417.1 45c-21.1 5.3-38.6 18-50.2 35H240C162.6 80 98 135 83.2 208H47.4c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240H80v16c0 55.8 31.8 104.2 78.1 128.1l22.3 68.3c5.4 16.5 20.7 27.6 38 27.6H264c22.1 0 40-17.9 40-40V416h16 32v24c0 22.1 17.9 40 40 40h45.5c17.3 0 32.7-11.1 38-27.6l13.7-42.1c26.1-7.5 49.6-22.2 67.8-42.4H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48h-8.7c-6.7-4.7-12.5-10.5-17.2-17.3l0 0c21-14.9 33.9-39.3 33.9-65.6C600 93 587 80 570.9 80H552v29.1c0 12.2-6.9 23.4-17.8 28.9c-4.1-3.8-8.4-7.4-12.7-10.8c4.2-10.3 6.5-21.5 6.5-33.2V82.3C528 54.5 505.5 32 477.7 32H475zm-.1 48l.1 0 0 0h2.6c1.3 0 2.3 1 2.3 2.3V94c0 9.4-3.3 18.2-8.9 25.1c-4.3 5.3-6.1 12.2-5 19s5.1 12.7 10.9 16.4c19.3 12.2 36.3 28.2 49.7 47.6c8.8 12.8 20.1 23.6 33.1 31.9c6.7 4.3 14.1 6 20.9 6H592v80H553.8c-12.8 0-23.8 6.1-31.1 14.5c-14.5 16.7-34.3 28.1-56.3 32c-8.7 1.6-15.8 7.8-18.6 16.2L431.7 432H400V392c0-13.3-10.7-24-24-24H320 280c-13.3 0-24 10.7-24 24v40H224.3l-23.7-72.7c-2.2-6.6-7.1-12-13.6-14.7c-34.7-14.5-59-48.8-59-88.6V240c0-61.9 50.1-112 112-112H381c9.6 0 18.3-5.7 22.1-14.5c4.6-10.7 13.9-19 25.7-21.9L474.9 80zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faInboxFull = {
  prefix: 'far',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M48 416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V336H382.8l-20.9 41.9c-6.8 13.6-20.6 22.1-35.8 22.1H185.9c-15.2 0-29-8.6-35.8-22.1L129.2 336H48v80zM405.6 92.1C403.8 85 397.4 80 390 80H122c-7.3 0-13.7 5-15.5 12.1L57.5 288h76.6c15.2 0 29 8.6 35.8 22.1L190.8 352H321.2l20.9-41.9c6.8-13.6 20.6-22.1 35.8-22.1h76.6l-49-195.9zM0 416V327.9c0-5.2 .6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32H390c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM184 128H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32 80H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCircleEnvelope = {
  prefix: 'far',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-7.3-256.4c2.2 1.2 4.7 1.9 7.3 1.9s5.1-.6 7.3-1.9l120.6-66.4C382.5 172.9 368.7 160 352 160H160c-16.7 0-30.5 12.9-31.9 29.3l120.6 66.4zm30 28c-7 3.8-14.8 5.8-22.7 5.8s-15.8-2-22.7-5.8L128 225.7V320c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V225.7L278.7 283.6z"]
};
var faEnvelopeCircle = faCircleEnvelope;
var faTrianglePersonDigging = {
  prefix: 'far',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", "M70.3 464L320 55.3 570.2 464H70.3zM285.9 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512H584.5c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm36.5 100.1l-19.7-49.2c-8.4-21.1-28.9-34.9-51.6-34.9c-18.6 0-35.9 9.3-46.3 24.8l-4.2 6.4c-2.5 3.7-3.3 8.2-2.3 12.5s3.8 8 7.6 10.2l153.5 88.6-15.2 25.4c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h96c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8L402 355l-53.5-30.9zm-131.6-3.4l-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2L272 392.9V416c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8z"]
};
var faConstruction = faTrianglePersonDigging;
var faFerry = {
  prefix: 'far',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32h68c17.1 0 28.7 17.4 22.2 33.2L468 80h4c30.9 0 56 25.1 56 56V293.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L463.5 320H424 152 112.5l35.2 50.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L58.1 326C51.5 316.6 48 305.4 48 293.9V136c0-30.9 25.1-56 56-56h4l-6.2-14.8C95.3 49.4 106.9 32 124 32h68zM480 272V136c0-4.4-3.6-8-8-8H448 128 104c-4.4 0-8 3.6-8 8V272h32V184c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24v88h32zM176 208v64H400V208H176zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faBullseyeArrow = {
  prefix: 'far',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", "M361.5 218.4c4.2 11.8 6.5 24.4 6.5 37.6c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c13.2 0 25.9 2.3 37.6 6.5l4.9-4.9-7.6-45.8C279.6 97.3 268 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-12-1.3-23.6-3.8-34.9l-45.8-7.6-4.9 4.9zm97.4-8.1c3.3 14.7 5 30 5 45.7c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c15.7 0 31 1.7 45.7 5l38.8-38.8C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5L459 210.3zm-93.9-29.4l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80 409 22.5c-4.3-10.7-18-13.5-26.2-5.4L331.6 68.4c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7L239 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z"]
};
var faArrowsDownToPeople = {
  prefix: 'far',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", "M120 24c0-13.3 10.7-24 24-24s24 10.7 24 24V142.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0L63 153c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24zm295 95c9.4-9.4 24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24s24 10.7 24 24V142.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9zm81 137a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM480 464h32V400.5c-2-.3-4.1-.5-6.2-.5H486.2c-2.1 0-4.2 .2-6.2 .5V464zm98.9 27.4l-18.9-35V480c0 17.7-14.3 32-32 32H464c-17.7 0-32-14.3-32-32V456.3l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35V400c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V360.3l-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35V480c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V456.3l-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm24 104.5V384h32V304.5c-2-.3-4.1-.5-6.2-.5H310.2c-2.1 0-4.2 .2-6.2 .5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 464h32V400.5c-2-.3-4.1-.5-6.2-.5H134.2c-2.1 0-4.2 .2-6.2 .5V464z"]
};
var faSeedling = {
  prefix: 'far',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M307.3 207c82.9-9.1 148.4-75.6 156-159H456c-76.7 0-142 49.1-166.1 117.5c-8.8-16.8-19.4-32.6-31.6-47.1C296.1 48 370.5 0 456 0h24c17.7 0 32 14.3 32 32c0 113.6-84.6 207.4-194.2 222c-2.1-16.2-5.6-31.9-10.5-47.1zM48 112v16c0 97.2 78.8 176 176 176h8V288c0 0 0 0 0 0c0-97.2-78.8-176-176-176H48zM280 288v16 48l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136h-8C100.3 352 0 251.7 0 128V96C0 78.3 14.3 64 32 64H56c123.7 0 224 100.3 224 224z"]
};
var faSprout = faSeedling;
var faClockSeven = {
  prefix: 'far',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V248.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faLeftRight = {
  prefix: 'far',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M505.6 239.7c8.5 9.2 8.5 23.4 0 32.6l-89.4 96.8c-8.8 9.5-21.1 14.9-34 14.9c-25.5 0-46.3-20.7-46.3-46.3l0-9.7-160 0 0 9.7c0 25.5-20.7 46.3-46.3 46.3c-12.9 0-25.2-5.4-34-14.9L6.4 272.3c-8.5-9.2-8.5-23.4 0-32.6l89.4-96.8c8.8-9.5 21.1-14.9 34-14.9c25.5 0 46.3 20.7 46.3 46.3l0 9.7 160 0 0-9.7c0-25.5 20.7-46.3 46.3-46.3c12.9 0 25.2 5.4 34 14.9l89.4 96.8zM384 178.7l0 29.3c0 13.3-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24l0-29.3L56.7 256 128 333.3l0-29.3c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24l0 29.3L455.3 256 384 178.7zm-253-3.3s0 0 0 0l-1.3-1.2 1.3 1.2 0 0z"]
};
var faArrowsAltH = faLeftRight;
var faBoxesPacking = {
  prefix: 'far',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", "M592 48H304v80H256V48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V464H592V48zM561 311c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V321.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64zM48 208v48H80 304h32V208H48zM0 272V192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-176c-17.7 0-32-14.3-32-32zm80 32V464H304V304H80zm72 32h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCircleArrowLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM223 151l-88 88c-9.4 9.4-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L360 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-150.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faFlashlight = {
  prefix: 'far',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M384 304H48V208H384c11.6 0 22.9-4.2 31.7-11.9l.1-.1c.2-.2 .7-.6 1.4-1.2c1.5-1.2 3.9-3.1 7.4-5.4c6.9-4.8 17.5-11.4 31.4-18.2c15-7.3 33.9-14.6 56.1-19.8V360.7c-22.2-5.2-41-12.5-56.1-19.8c-14-6.8-24.5-13.4-31.4-18.2c-3.4-2.4-5.9-4.3-7.4-5.4c-.7-.6-1.2-1-1.4-1.2l-.1-.1c-8.8-7.7-20-11.9-31.6-11.9zm192 64c-5.5 0-10.8-.2-16-.4V144.4c5.2-.3 10.5-.4 16-.4h16V368H576zM384 160H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H384s72 64 192 64h32c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H576c-120 0-192 64-192 64zM248 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faGroupArrowsRotate = {
  prefix: 'far',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M215 34.4c3.8 12.7-3.5 26.1-16.2 29.8c-14.2 4.2-27.8 10-40.5 17.1C159.4 86.1 160 91 160 96c0 35.3-28.7 64-64 64c-5 0-9.9-.6-14.6-1.7c-7.1 12.7-12.9 26.3-17.1 40.5c-3.8 12.7-17.1 19.9-29.8 16.2s-19.9-17.1-16.2-29.8c5.7-19.3 13.8-37.7 23.8-54.7C35.7 120.5 32 108.7 32 96c0-35.3 28.7-64 64-64c12.7 0 24.5 3.7 34.5 10.1c17-10 35.4-18 54.7-23.8c12.7-3.8 26.1 3.5 29.8 16.2zm82 0c3.8-12.7 17.1-19.9 29.8-16.2c19.3 5.7 37.7 13.8 54.7 23.8C391.5 35.7 403.3 32 416 32c35.3 0 64 28.7 64 64c0 12.7-3.7 24.5-10.1 34.5c10 17 18 35.4 23.8 54.7c3.8 12.7-3.5 26.1-16.2 29.8s-26.1-3.5-29.8-16.2c-4.2-14.2-10-27.8-17.1-40.5c-4.7 1.1-9.6 1.7-14.6 1.7c-35.3 0-64-28.7-64-64c0-5 .6-9.9 1.7-14.6c-12.7-7.1-26.3-12.9-40.5-17.1c-12.7-3.8-19.9-17.1-16.2-29.8zM34.4 297c12.7-3.8 26.1 3.5 29.8 16.2c4.2 14.2 10 27.8 17.1 40.5C86.1 352.6 91 352 96 352c35.3 0 64 28.7 64 64c0 5-.6 9.9-1.7 14.6c12.7 7.1 26.3 12.9 40.5 17.1c12.7 3.8 19.9 17.1 16.2 29.8s-17.1 19.9-29.8 16.2c-19.3-5.8-37.7-13.8-54.7-23.8c-10 6.4-21.8 10.1-34.5 10.1c-35.3 0-64-28.7-64-64c0-12.7 3.7-24.5 10.1-34.5c-10-17-18-35.4-23.8-54.7c-3.8-12.7 3.5-26.1 16.2-29.8zm443.1 0c12.7 3.8 19.9 17.1 16.2 29.8c-5.8 19.3-13.8 37.6-23.8 54.7c6.4 10 10.1 21.8 10.1 34.5c0 35.3-28.7 64-64 64c-12.7 0-24.5-3.7-34.5-10.1c-17 10-35.4 18-54.7 23.8c-12.7 3.8-26.1-3.5-29.8-16.2s3.5-26.1 16.2-29.8c14.2-4.2 27.8-10 40.5-17.1c-1.1-4.7-1.7-9.6-1.7-14.6c0-35.3 28.7-64 64-64c5 0 9.9 .6 14.6 1.7c7.1-12.7 12.9-26.3 17.1-40.5c3.8-12.7 17.1-19.9 29.8-16.2zM112 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zM96 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192.8 256.8c0 24.8 14.1 46.4 34.9 57c11.8 6 16.5 20.5 10.4 32.3s-20.5 16.5-32.3 10.4c-36.2-18.5-61.1-56.2-61.1-99.8c0-28.9 11-55.2 28.9-75.1l-11.2-11.2c-6.6-6.6-1.9-17.8 7.4-17.8h60.5c5.7 0 10.4 4.7 10.4 10.4v60.5c0 9.3-11.2 13.9-17.8 7.4l-15.3-15.3c-9.3 11.1-14.9 25.4-14.9 41.1zm93.1-58.6c-11.8-6-16.5-20.5-10.4-32.3s20.5-16.5 32.3-10.4c36.2 18.5 61.1 56.2 61.1 99.8c0 28.9-11 55.2-28.9 75.1L351 341.5c6.6 6.6 1.9 17.8-7.4 17.8H283.2c-5.7 0-10.4-4.7-10.4-10.4V288.3c0-9.3 11.2-13.9 17.8-7.4l15.3 15.3c9.3-11.1 14.9-25.4 14.9-41.1c0-24.8-14.1-46.4-34.9-57z"]
};
var faBowlFood = {
  prefix: 'far',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M0 192c0 11.7 3.1 22.6 8.6 32H503.4c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64c-.5 0-1.1 0-1.6 0C439 91.5 406.7 64 368 64c-15 0-29 4.1-40.9 11.2C313.8 49.6 286.9 32 256 32s-57.8 17.6-71.1 43.2C173 68.1 159 64 144 64c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64zM144.7 420.6c-4-13.5-13.8-24.6-26.8-30.3C82.7 374.9 56.7 342.7 49.8 304H462.2c-6.9 38.7-32.9 70.9-68.1 86.3c-12.9 5.7-22.7 16.7-26.8 30.3c-2 6.6-8.2 11.4-15.3 11.4H160c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4z"]
};
var faSquare9 = {
  prefix: 'far',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]
};
var faCandyCane = {
  prefix: 'far',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M343 82.3c5.8-1.5 11.9-2.3 18-2.3c13.8 0 26.7 3.9 37.6 10.8l23-23C404.6 55.3 383.6 48 361 48c-9.6 0-19 1.3-28.1 3.9L343 82.3zm78.3 31.1c6.8 10.9 10.8 23.8 10.8 37.6v5.6c0 3.5-.2 6.9-.7 10.3l30.7 10.2c1.3-6.7 1.9-13.6 1.9-20.5V151c0-22.7-7.3-43.6-19.7-60.7l-23 23zm30.2 93.9L420.5 197c-6.1 9.8-14.4 18.3-24.5 24.6l-51.2 32L375 272.5l37.9-23.7c16.5-10.3 29.7-24.7 38.5-41.4zm-106.6 84l-30.2-18.9-77 48.1 30.2 18.9 77-48.1zm-107.2 67l-30.2-18.9-73 45.6L164.6 404l73-45.6zM134.4 422.9L104.2 404 55.5 434.4c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l61.9-38.7zM303.6 65.4l-24.1 15c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l17.5-11L303.6 65.4zM361 128c-4.3 0-8.6 1.2-12.2 3.5l-26.8 16.8c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23C304.9 8 332.7 0 361 0c83.4 0 151 67.6 151 151v5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L370.5 180.9c8.4-5.2 13.5-14.4 13.5-24.3V151c0-12.7-10.3-23-23-23z"]
};
var faArrowDownWideShort = {
  prefix: 'far',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M15 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM312 480h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faSquareDollar = {
  prefix: 'far',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm244.8 37.6v14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
var faDollarSquare = faSquareDollar;
var faUsdSquare = faSquareDollar;
var faPhoneArrowRight = {
  prefix: 'far',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.2-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H312c-13.3 0-24-10.7-24-24s10.7-24 24-24H430.1L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faHandHoldingSeedling = {
  prefix: 'far',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M115.6 0C96 0 80 16 80 35.6C80 113.2 142.8 176 220.4 176H264v80c0 13.3 10.7 24 24 24s24-10.7 24-24V152C312 68.1 243.9 0 160 0H115.6zM160 48c49.2 0 90.4 34.1 101.2 80H220.4c-46.8 0-85.5-34.8-91.5-80H160zm5.2 310.7c6.6-4.4 14.3-6.7 22.2-6.7H344c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 256c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 24 48c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9h7.4c6.8 0 12.3 5.5 12.3 12.3c0 4.2-2.1 8-5.6 10.3l-95.6 61.9C415.1 460 401.5 464 387.7 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H387.7c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6c0-33.3-27-60.3-60.3-60.3h-7.4c-12.5 0-24.8 3.5-35.5 10L408 370c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64H187.4c-17.4 0-34.4 5.1-48.8 14.8L64.7 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H72c4.7 0 9.4-1.4 13.3-4l79.9-53.3zM355.6 176C433.2 176 496 113.2 496 35.6C496 16 480 0 460.4 0H416c-41.7 0-79.5 16.8-107 44c10 13.8 18.1 29 24 45.2C352 64.2 382.1 48 416 48h31.2c-6 45.2-44.7 80-91.5 80H342.4c1 7.9 1.6 15.9 1.6 24v24h11.6z"]
};
var faMessageCheck = {
  prefix: 'far',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM369 153c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z"]
};
var faCommentAltCheck = faMessageCheck;
var faCloudBolt = {
  prefix: 'far',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M184 48c-39.8 0-72 32.2-72 72c0 2.6 .1 5.2 .4 7.7c1.3 12-6.6 23.1-18.3 25.9C67.6 159.9 48 183.7 48 212c0 32.2 25.3 58.4 57.1 59.9c.3 0 .7 0 1 .1H108h95.2l-60 48H108h-4c-1.2 0-2.4-.1-3.5-.3C44.3 315.9 0 269.1 0 212c0-44.1 26.4-81.9 64.2-98.7C67.7 50.1 120 0 184 0c33.9 0 64.5 14.1 86.3 36.6C285.1 28.6 302 24 320 24c46.9 0 86.5 31 99.5 73.7C472.1 106.9 512 152.8 512 208c0 61.9-50.1 112-112 112H352 333.7l24-48H400c35.3 0 64-28.7 64-64s-28.6-64-64-64h0l-.3 0c-12.4 0-22.7-9.3-23.9-21.6C372.9 94.1 349 72 320 72c-14.7 0-28.1 5.7-38.1 15c-5.3 4.9-12.4 7.2-19.5 6.2s-13.4-5-17.2-11.1C232.5 61.6 209.8 48 184 48zM330.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L281.9 352H352c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 384H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faThunderstorm = faCloudBolt;
var faChartLineUpDown = {
  prefix: 'far',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zm352 80c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c6.4 0 12.5 2.5 17 7s7 10.6 7 17l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-22.1L305 273c-9.4 9.4-24.6 9.4-33.9 0l-63-63-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 112H376zm0 272c-13.3 0-24-10.7-24-24s10.7-24 24-24h22.1l-47-47L385 255l47 47 0-22.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 6.4-2.5 12.5-7 17s-10.6 7-17 7H376z"]
};
var faTextSlash = {
  prefix: 'far',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-281.9-221L396.4 80H521.3l-8.5 34.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.5l11-44.1C576.6 56.5 557.5 32 531.5 32h-335c-18.4 0-34.4 12.5-38.8 30.3l-7.5 30.1L38.8 5.1zM191.5 124.8L202.7 80H346.5L308.1 216.2 191.5 124.8zm57.4 300.7l-1.8 6.5H192c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H296.9l23.6-83.5-40.8-32.1L248.9 425.5z"]
};
var faRemoveFormat = faTextSlash;
var faWatch = {
  prefix: 'far',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", "M112 0C85.5 0 64 21.5 64 48v64h1C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144H64v64c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V400h-1c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h1V48c0-26.5-21.5-48-48-48H112zM48 256a144 144 0 1 1 288 0A144 144 0 1 1 48 256zm168-80c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2V176z"]
};
var faCircleDownLeft = {
  prefix: 'far',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 198.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L232 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L296 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H176c-8.8 0-16-7.2-16-16V198.6z"]
};
var faText = {
  prefix: 'far',
  iconName: 'text',
  icon: [448, 512, [], "f893", "M48 80v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H248l0 352h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48l0-352H48z"]
};
var faProjector = {
  prefix: 'far',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", "M424 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM265 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L265 39zM569 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L479 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zM288 320a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm272 0c0-29.1-7.8-56.5-21.4-80H576c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H538.6c13.6-23.5 21.4-50.9 21.4-80zM400 480c36 0 69.3-11.9 96-32h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h16c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H496c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H80v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H304c26.7 20.1 60 32 96 32zM240 320c0 29.1 7.8 56.5 21.4 80H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16H261.4c-13.6 23.5-21.4 50.9-21.4 80zm-112 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFaceSmileWink = {
  prefix: 'far',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
var faSmileWink = faFaceSmileWink;
var faTombstoneBlank = {
  prefix: 'far',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M368 192V432h48V192C416 86 330 0 224 0S32 86 32 192V432H80V192c0-79.5 64.5-144 144-144s144 64.5 144 144zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faTombstoneAlt = faTombstoneBlank;
var faChessKingPiece = {
  prefix: 'far',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H66.9C43.2 96 24 115.2 24 138.9c0 4.7 .8 9.4 2.3 13.8l19.6 57.5C37.7 214.1 32 222.4 32 232c0 11.6 8.2 21.3 19.2 23.5L49.1 352h48l2.1-96h57.6l2.1 96h48l-2.1-96.5c10.9-2.2 19.2-11.9 19.2-23.5c0-9.6-5.7-17.9-13.9-21.8l19.6-57.5c1.5-4.5 2.3-9.1 2.3-13.8c0-23.7-19.2-42.9-42.9-42.9H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zm16.2 192H95.8L74 144H182l-21.8 64zm-91 224H186.8l16.6 32H52.7l16.6-32zm-9.7-48c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H215.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3H59.5z"]
};
var faChessKingAlt = faChessKingPiece;
var faCircle6 = {
  prefix: 'far',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-96-48c0-32.4 14.2-63.2 38.8-84.3l81.6-70c10.1-8.6 25.2-7.5 33.8 2.6s7.5 25.2-2.6 33.8L282 195.6c40.4 11.4 70 48.4 70 92.4c0 53-43 96-96 96s-96-43-96-96z"]
};
var faLeft = {
  prefix: 'far',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M50.4 256L200.3 113.3c.8-.8 2-1.3 3.2-1.3c2.5 0 4.6 2 4.6 4.6l0 83.4c0 13.3 10.7 24 24 24l168 0 0 64-168 0c-13.3 0-24 10.7-24 24l0 83.4c0 2.5-2 4.6-4.6 4.6c-1.2 0-2.3-.5-3.2-1.3L50.4 256zm153-192c-13.5 0-26.5 5.2-36.3 14.5L13.2 225.1C4.8 233.2 0 244.3 0 256s4.8 22.8 13.2 30.9L167.2 433.5c9.8 9.3 22.8 14.5 36.3 14.5c29 0 52.6-23.5 52.6-52.6l0-59.4 144 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-144 0 0-59.4c0-29-23.5-52.6-52.6-52.6z"]
};
var faArrowAltLeft = faLeft;
var faFileWord = {
  prefix: 'far',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"]
};
var faFilePowerpoint = {
  prefix: 'far',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24V336v56c0 13.3 10.7 24 24 24s24-10.7 24-24V360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"]
};
var faSquareDown = {
  prefix: 'far',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M400 416l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64l0 320zM328.8 294.6l-91 84c-3.8 3.5-8.7 5.4-13.9 5.4s-10.1-1.9-13.9-5.4l-91-84c-4.6-4.2-7.2-10.1-7.2-16.4c0-12.3 10-22.3 22.3-22.3H176V160c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32v96h41.7c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.2 16.4z"]
};
var faArrowAltSquareDown = faSquareDown;
var faObjectsAlignCenterVertical = {
  prefix: 'far',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", "M112 80V432h64V80H112zM64 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V232h64V144c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H448v88c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V280H224V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V80zm272 64V368h64V144H336z"]
};
var faArrowsLeftRight = {
  prefix: 'far',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", "M505 273c9.4-9.4 9.4-24.6 0-33.9l-96-96c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L81.9 232l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 348.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z"]
};
var faArrowsH = faArrowsLeftRight;
var faHouseLock = {
  prefix: 'far',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L492.2 165.8c-16.3 5.5-31 14.7-43 26.5L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32h48V312c0-22.1 17.9-40 40-40H344c22.1 0 40 17.9 40 40V464h0v16c0 11.7 3.1 22.6 8.6 32H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM240 464h96V320H240V464zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faCloudArrowDown = {
  prefix: 'far',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM223 313l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faWreath = {
  prefix: 'far',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", "M339.4 88.7c-24.5 7.3-50.4-5.9-58.9-30c-2.2-6.3-8.2-10.7-15.1-10.7c-4 0-7.5 1.4-10.3 3.8c-17.9 15.2-44.2 15.2-62.1 0c-2.8-2.4-6.3-3.8-10.3-3.8c-6.9 0-12.9 4.4-15.1 10.7c-8.5 24.1-34.4 37.3-58.9 30c-1.4-.4-2.9-.7-4.6-.7c-8.8 0-16 7.2-16 16c0 1.7 .2 3.2 .7 4.6c7.3 24.5-5.9 50.4-30 58.9c-6.3 2.2-10.7 8.2-10.7 15.1c0 4 1.4 7.5 3.8 10.3c15.2 17.9 15.2 44.2 0 62.2c-2.4 2.8-3.8 6.3-3.8 10.3c0 6.9 4.4 12.9 10.7 15.1c24.1 8.5 37.3 34.4 30 58.9c-.4 1.4-.7 2.9-.7 4.6c0 8.8 7.2 16 16 16c1.7 0 3.2-.2 4.6-.7c5.4-1.6 10.8-2.2 16.1-1.9c-17 8.5-28.7 26.1-28.7 46.4v3.7c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5v-3.7c0-20.3-11.7-37.9-28.7-46.4c5.3-.3 10.8 .3 16.1 1.9c1.4 .4 2.9 .7 4.6 .7c8.8 0 16-7.2 16-16c0-1.7-.2-3.2-.7-4.6c-7.3-24.5 5.9-50.4 30-58.9c6.3-2.2 10.7-8.2 10.7-15.1c0-4-1.4-7.5-3.8-10.3c-15.2-17.9-15.2-44.2 0-62.2c2.4-2.8 3.8-6.3 3.8-10.3c0-6.9-4.4-12.9-10.7-15.1c-24.1-8.5-37.3-34.4-30-58.9c.4-1.4 .7-2.9 .7-4.6c0-8.8-7.2-16-16-16c-1.7 0-3.2 .2-4.6 .7zM128 492.2V403.8c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8zm69.9-294.3c-2 9.3-5.6 18.2-10.8 26.1c5.2 8 8.9 16.8 10.8 26.1c9.3 2 18.2 5.6 26.1 10.8c8-5.2 16.8-8.9 26.1-10.8c2-9.3 5.6-18.2 10.8-26.1c-5.2-8-8.9-16.8-10.8-26.1c-4.7-1-9.3-2.4-13.7-4.2c-4.3-1.8-8.5-4-12.4-6.6c-8 5.2-16.8 8.9-26.1 10.8zm5.2-55.5c11.3-12.1 30.6-12.1 41.9 0c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1z"]
};
var faChildren = {
  prefix: 'far',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M160 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 160 0a72 72 0 1 0 0 144zm0 16c-34.6 0-67.3 16.2-88.2 43.8L12.9 281.5c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6l45.3-59.8L57.2 368.4c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H96v88c0 13.3 10.7 24 24 24s24-10.7 24-24V400h32v88c0 13.3 10.7 24 24 24s24-10.7 24-24V400h16c7.7 0 15-3.7 19.5-10s5.7-14.3 3.3-21.6L223.5 250.7l45.3 59.8c8 10.6 23.1 12.6 33.6 4.6s12.6-23.1 4.6-33.6l-58.9-77.7C227.3 176.2 194.7 160 160 160zM113.3 352L160 211.9 206.7 352H113.3zM456 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm96 0A72 72 0 1 0 408 72a72 72 0 1 0 144 0zM480 208c5.5 0 10.9 .9 16 2.6V336H464V210.6c5.1-1.7 10.5-2.6 16-2.6zM464 488V384h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V264.8l27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C545.8 177.5 514.1 160 480 160s-65.8 17.5-83.9 46.3l-48.4 76.9c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faMeterDroplet = {
  prefix: 'far',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M256 464c48.8 0 93.8-16.8 129.2-45c2.3 17.2 7.6 33.5 15.4 48.3C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-8.5 5.3-15.7 12.9-20.6 22.1l-15.4 28.8C443.8 122.2 358.6 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zM192 152v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm136.5 54.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"]
};
var faChalkboard = {
  prefix: 'far',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M80 88c0-4.4 3.6-8 8-8H488c4.4 0 8 3.6 8 8V400h48V88c0-30.9-25.1-56-56-56H88C57.1 32 32 57.1 32 88V400H80V88zM224 408v24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H224h24H392h24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H416V408c0-30.9-25.1-56-56-56H280c-30.9 0-56 25.1-56 56zm144 0v24H272V408c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z"]
};
var faBlackboard = faChalkboard;
var faUserLargeSlash = {
  prefix: 'far',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM224.2 150.4c-.1-2.1-.2-4.3-.2-6.4c0-53 43-96 96-96s96 43 96 96c0 47.3-34.3 86.7-79.3 94.6L224.2 150.4zM545.5 512H528l-60.9-48H113.3c8.3-54.4 55.3-96 112-96H345.2l-60.9-48h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"]
};
var faUserAltSlash = faUserLargeSlash;
var faSignalStrong = {
  prefix: 'far',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", "M448 96c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM320 192c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faSignal4 = faSignalStrong;
var faLollipop = {
  prefix: 'far',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c44.4 0 85.2-15 117.7-40.3L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L343.7 309.7C369 277.2 384 236.4 384 192C384 86 298 0 192 0S0 86 0 192z"]
};
var faLollypop = faLollipop;
var faListTree = {
  prefix: 'far',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M24 48C10.7 48 0 58.7 0 72v48c0 13.3 10.7 24 24 24V256 384c0 30.9 25.1 56 56 56h48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H80c-4.4 0-8-3.6-8-8V280h56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H72V144c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H24zM160 96c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zM288 256c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24zm0 160c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H312c-13.3 0-24 10.7-24 24z"]
};
var faEnvelopeOpen = {
  prefix: 'far',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1V200.5c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"]
};
var faDrawCircle = {
  prefix: 'far',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", "M256 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm54.8 17.1C299.6 115.6 279.2 128 256 128s-43.6-12.4-54.8-30.9c-48.7 16.8-87.3 55.4-104.1 104.1C115.6 212.4 128 232.8 128 256s-12.4 43.6-30.9 54.8c16.8 48.7 55.4 87.3 104.1 104.1C212.4 396.4 232.8 384 256 384s43.6 12.4 54.8 30.9c48.7-16.8 87.3-55.4 104.1-104.1C396.4 299.6 384 279.2 384 256s12.4-43.6 30.9-54.8c-16.8-48.7-55.4-87.3-104.1-104.1zm152.1 96.6c28.2 6.7 49.1 32 49.1 62.3s-20.9 55.5-49.1 62.3c-20.8 69.2-75.4 123.8-144.6 144.6c-6.7 28.2-32 49.1-62.3 49.1s-55.5-20.9-62.3-49.1C124.5 442.1 69.9 387.5 49.1 318.3C20.9 311.5 0 286.2 0 256s20.9-55.5 49.1-62.3C69.9 124.5 124.5 69.9 193.7 49.1C200.5 20.9 225.8 0 256 0s55.5 20.9 62.3 49.1c69.2 20.8 123.8 75.4 144.6 144.6zM256 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCatSpace = {
  prefix: 'far',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", "M464 304c70.7 0 128-57.3 128-128c0-32.5-12.1-62.1-32-84.7V176c0 53-43 96-96 96s-96-43-96-96V91.3c-19.9 22.6-32 52.2-32 84.7c0 70.7 57.3 128 128 128zM397.8 66.4l29.4 39.2c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l29.4-39.2C510.9 54.7 488.2 48 464 48s-46.9 6.7-66.2 18.4zM464 352v96c0 8.8 7.2 16 16 16s16-7.2 16-16V349.1c-10.4 1.9-21.1 2.9-32 2.9zM640 176c0 68.4-39 127.7-96 156.8V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V394L336 441v23h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-48.6 0-88-39.4-88-88v-.1V184.5c0-20.2-15-37.2-35-39.7l-7.9-1c-13.2-1.6-22.5-13.6-20.8-26.8S45.8 94.5 59 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3V279c34.5-46.4 85.2-80.1 144.3-92.7c-.2-3.4-.3-6.9-.3-10.3C288 78.8 366.8 0 464 0s176 78.8 176 176zM144 423.9v.1c0 22.1 17.9 40 40 40H288V400c0-17.7-14.3-32-32-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c39.4 0 72.2 28.5 78.8 66l73.3-43.1c-51.7-17.3-92.7-58-110.5-109.5C209 252.6 144 331.2 144 423.9zM231.5 12.3l10.7 28.8c.8 2.2 2.5 3.9 4.7 4.7l28.8 10.7c7 2.6 7 12.4 0 15L246.9 82.2c-2.2 .8-3.9 2.5-4.7 4.7l-10.7 28.8c-2.6 7-12.4 7-15 0L205.8 86.9c-.8-2.2-2.5-3.9-4.7-4.7L172.3 71.5c-7-2.6-7-12.4 0-15l28.8-10.7c2.2-.8 3.9-2.5 4.7-4.7l10.7-28.8c2.6-7 12.4-7 15 0zM432 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHandshakeSimpleSlash = {
  prefix: 'far',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H456 440.6l-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5 44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H505.1L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6H248.7c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zM388.9 402.4l-42-33.1c.8 8.5-2.1 17.2-8.6 23.7c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1l0 0-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H93.7c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c7.3-7.3 12.8-15.6 16.6-24.5zM101.5 176L44.4 131C37 135.1 32 143 32 152c0 13.3 10.7 24 24 24h45.5z"]
};
var faHandshakeAltSlash = faHandshakeSimpleSlash;
var faRabbitRunning = {
  prefix: 'far',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", "M501.8 167.8c-8.6-5.9-17.8-10.8-27.4-14.6C457.6 98 413.6 54.9 357.5 39.6l-2.7-.8L348.4 62l6.3-23.1c-12.2-3.3-25.2-1.7-36.2 4.7l12 20.8-12-20.8-1.1 .6c-20.2 11.7-29.8 35.7-23.1 58.1l7.8 26.3c1.2 4 2.5 8 4 11.9l-57.1-20.8c-13.8-5-28.4-7.6-43.1-7.6H193.7c-30.1 0-57.5 11.7-77.9 30.9C103.7 133.5 88.5 128 72 128c-39.8 0-72 32.2-72 72s32.2 72 72 72c5.9 0 11.5-.7 17-2c6 14.1 14.8 27 26.1 37.8l37.7 36.1-28.3 18.9c-29.4 19.6-37.4 59.3-17.8 88.8s59.3 37.4 88.8 17.8l52.1-34.7 5.3 5.1C269.2 455.3 291 464 313.7 464H416c35.3 0 64-28.7 64-64c0-19.1-8.4-36.3-21.7-48h33.4c46.5 0 84.3-37.7 84.3-84.3c0-25.3-11.4-49.3-31-65.3l-18.9-15.4c13.8-52.7-1.7-108.8-40.6-147l-1.4-1.4c-5.7-5.6-13.8-8-21.6-6.5l-1.6 .3c-8.8 1.7-16 8.3-18.4 16.9c-.8 2.8-1.5 5.5-2.1 8.3c28.7 25.3 49.7 59 59.4 97.4c1.1 4.2 1.7 8.5 2 12.7zM88.5 182.5c-5.1 12.4-8.1 25.9-8.4 40.1c-2.5 .9-5.2 1.4-8 1.4c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.4 0 12.2 2.5 16.5 6.5zm62.7 220.1l37.2-24.8L212 400.5l-43.2 28.8c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2zm190.3-317l.9-.5 2.5 .7c41.9 11.5 74.4 44.6 85.1 86.7c.4 10.5 7.6 19.6 17.8 22.3c11.7 3.1 22.7 8.7 32.3 16.5l34.6 28.2c8.4 6.9 13.4 17.2 13.4 28.1c0 20-16.2 36.3-36.3 36.3H392c-6.4 0-12.5 2.5-17 7l-9.9 9.9c-9.7-43.6-43.3-79.2-88-90.4l-23.3-5.8c-12.9-3.2-25.9 4.6-29.1 17.5s4.6 25.9 17.5 29.1l23.3 5.8c32.1 8 54.5 36.8 54.5 69.8v13c0 13.3 10.7 24 24 24h40l.1 0H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H313.7c-10.3 0-20.2-4-27.6-11.1L148.3 273.1c-13-12.4-20.3-29.5-20.3-47.5c0-36.3 29.4-65.7 65.7-65.7H206c9.1 0 18.1 1.6 26.7 4.7l129.4 47.1c11 4 23.3-.5 29.1-10.7s3.4-23.1-5.7-30.5c-17.6-14.3-30.7-33.7-37.3-55.8l-7.8-26.3c-.3-1.1 .1-2.2 1.1-2.8zM480 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faRabbitFast = faRabbitRunning;
var faMemoPad = {
  prefix: 'far',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", "M400 128V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128H400zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 200c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
};
var faMattressPillow = {
  prefix: 'far',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", "M240 112V400H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H240zm48 0H576c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H288V112zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM80 176V336c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32z"]
};
var faAlarmPlus = {
  prefix: 'far',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM256 176c-13.3 0-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24z"]
};
var faAlicorn = {
  prefix: 'far',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M109.6 133.9c-9.9 7.3-18.5 16.1-25.5 26.2C37.3 162.1 0 200.7 0 248v64c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2h49.8c31.7 0 54.7-30.3 46.2-60.8l-14.8-53.3c-.5-1.6-.4-3.4 .2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V327.8c19.8-22.6 32-52.3 32-85.5l0-1.6 0-.7v-7.8c17.7 6 37.5 5.8 55.8-1.5c34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24H480V.3c-2.5-.2-5-.3-7.5-.3H472 440h-8c-1.8 0-3.5 .2-5.2 .6C365 5.9 313.7 48.2 295.3 105.3L164.3 27.4c-7.4-4.4-16.6-4.5-24.1-.2S128 39.4 128 48c0 76.3 36.1 130.2 71.3 164.2c17.5 17 35 29.3 48.1 37.3c6.6 4 12.1 7.1 16.1 9.1c2 1 3.6 1.8 4.8 2.4c.6 .3 1 .5 1.4 .6l.4 .2 .1 .1 .1 0 0 0c0 0 0 0 9.6-22l-9.6 22c12.1 5.3 26.3-.2 31.6-12.4s-.2-26.3-12.4-31.6l0 0-.1 0-.7-.3c-.7-.3-1.9-.9-3.4-1.7c-3-1.5-7.5-4-12.9-7.3c-10.9-6.7-25.4-16.9-39.9-30.9c-20.8-20.2-41.2-47.8-50.8-84.1l19.4 11.6 86.4 51.4c2.6 1.6 5.4 2.6 8.3 3v.3h3.6c.3 0 .6 0 .8 0H313c12.1 0 22.3-9 23.8-21c6.1-49.1 46.6-87.7 96.6-90.8c.7 0 1.3-.1 2-.2H440h32 .5c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7c-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7s-16.1 12.5-16.1 22.6v55c0 .5 0 1 0 1.5c0 .6 0 1.2 0 1.7c0 23.5-9.6 44.1-24.7 58.8c-4.6 4.5-7.3 10.7-7.3 17.2V464H336V346.2c0-11.3-7.9-21.1-19-23.5c-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6L188.9 464H139.1l-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9c0-17.4 7-33.3 18.2-44.8c-8-13.7-15-28.9-20.6-45.5zM464 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM630.7 64H544v48l89.6-29.9c3.8-1.3 6.4-4.8 6.4-8.8c0-5.1-4.2-9.3-9.3-9.3z"]
};
var faCommentQuestion = {
  prefix: 'far',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM169.8 149.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V248c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faGingerbreadMan = {
  prefix: 'far',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M152 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 9.5-1.8 18.4-5.1 26.6c-7.6 19 4.4 45.4 30.1 45.4h39c22.1 0 40 17.9 40 40s-17.9 40-40 40h-7c-39.2 0-60.7 45.6-35.8 75.9l41.7 50.7c14 17.1 11.6 42.3-5.5 56.3s-42.3 11.6-56.3-5.5l-37.3-45.3c-18.6-22.6-53.1-22.6-71.7 0l-37.3 45.3c-14 17.1-39.2 19.5-56.3 5.5s-19.5-39.2-5.5-56.3l41.7-50.7C155.7 317.6 134.2 272 95 272H88c-22.1 0-40-17.9-40-40s17.9-40 40-40h39c25.7 0 37.7-26.4 30.1-45.4c-3.3-8.2-5.1-17.2-5.1-26.6zM224 0C157.7 0 104 53.7 104 120c0 8.2 .8 16.2 2.4 24H88c-48.6 0-88 39.4-88 88s39.4 88 88 88h3.6L52 368.1c-30.9 37.5-25.5 93 12 123.9l14.5-17.6L64.1 492c37.5 30.9 93 25.5 123.9-12l36-43.8 36 43.8c30.9 37.5 86.3 42.9 123.9 12s42.9-86.3 12-123.9L356.4 320H360c48.6 0 88-39.4 88-88s-39.4-88-88-88H341.6c1.6-7.8 2.4-15.8 2.4-24C344 53.7 290.3 0 224 0zm0 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM208 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faGuaraniSign = {
  prefix: 'far',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M192 0c-13.3 0-24 10.7-24 24V65.5C73.3 77.3 0 158.1 0 256s73.3 178.7 168 190.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V446.5c94.7-11.8 168-92.6 168-190.5c0-13.3-10.7-24-24-24H216V114c29.7 5 56.2 19 76.8 39.2c9.5 9.3 24.7 9.1 33.9-.3s9.1-24.7-.3-33.9C297.2 90.2 258.8 70.8 216 65.5V24c0-13.3-10.7-24-24-24zM168 114V398C99.9 386.6 48 327.4 48 256s51.9-130.6 120-142zm48 284V280H334c-10.1 60.3-57.7 107.9-118 118z"]
};
var faBurgerFries = {
  prefix: 'far',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", "M167.6 2.4C162.9 5.3 160 10.5 160 16V206.7l0 0v63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16c-5-2.5-10.8-2.2-15.6 .7zM128 261V14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6zM58.2 193L40.3 85.6 19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1zm312-17.5l13.6-76.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2.5-.4 5.1-.7 7.9-.8c10.4-6.1 22.1-11.7 35.1-16.4zM286.6 230c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6c2.1-1.5 4-3 5.7-4.5c3.2-4.9 7-10 11.4-15.4c.7-1.6 1.3-3.1 1.7-4.5zM192 304c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512H294.1c-14-13.1-24.9-29.5-31.3-48h-161L66.1 316.8c1.4 1.1 2.8 2.1 4.3 3.1C99.3 340.1 139.1 352 192 352c26.8 0 50.3-3.1 70.6-8.7c-4.3-11.8-6.6-24.6-6.6-37.8c0-3.2 .1-6.7 .5-10.5c-16.7 5.5-37.8 9-64.5 9zm257.9-63.8c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.3 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8H366.8c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88H552c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8H584c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z"]
};
var faMugTea = {
  prefix: 'far',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M80 112h72v10.7c0 8.5-3.4 16.6-9.4 22.6l-21.3 21.3c-6 6-9.4 14.1-9.4 22.6V256c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V189.3c0-8.5-3.4-16.6-9.4-22.6l-21.3-21.3c-6-6-9.4-14.1-9.4-22.6V112H368V352c0 26.5-21.5 48-48 48H128c-26.5 0-48-21.5-48-48V112zM64 64C46.3 64 32 78.3 32 96V352c0 53 43 96 96 96H320c53 0 96-43 96-96V320h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H384 64zM448 272H416V112h32c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faBorderTop = {
  prefix: 'far',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M0 56C0 42.7 10.7 32 24 32H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faArrowsRotate = {
  prefix: 'far',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M496 200c0 13.3-10.7 24-24 24h0H360 328c-13.3 0-24-10.7-24-24s10.7-24 24-24h32 54.1l-52.1-52.1C333.8 95.8 295.7 80 256 80c-72.7 0-135.2 44.1-162 107.1c-5.2 12.2-19.3 17.9-31.5 12.7s-17.9-19.3-12.7-31.5C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9L448 142.1V88l0-.4V56c0-13.3 10.7-24 24-24s24 10.7 24 24V200zM40 288H152c13.3 0 24 10.7 24 24s-10.7 24-24 24H97.9l52.1 52.1C178.2 416.2 216.3 432 256 432c72.6 0 135-43.9 161.9-106.8c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24z"]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faCircleBookOpen = {
  prefix: 'far',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c23.1 0 41 11.1 46.3 14.8c1.1 .8 2.4 1.2 3.7 1.2c3.3 0 5.9-2.7 5.9-5.9V185.3c0-5.8-3.1-11.1-8.3-13.5C221.2 167.1 202.5 160 184 160s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5V346.1c0 3.3 2.7 5.9 5.9 5.9c1.3 0 2.6-.4 3.7-1.2C143 347.1 160.9 336 184 336zm144 0c23.1 0 41 11.1 46.3 14.8c1.1 .8 2.4 1.2 3.7 1.2c3.3 0 5.9-2.7 5.9-5.9V185.3c0-5.8-3.1-11.1-8.3-13.5C365.2 167.1 346.5 160 328 160s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5V346.1c0 3.3 2.7 5.9 5.9 5.9c1.3 0 2.6-.4 3.7-1.2C287 347.1 304.9 336 328 336z"]
};
var faBookCircle = faCircleBookOpen;
var faArrowsToDottedLine = {
  prefix: 'far',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", "M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM313 399l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V488c0 13.3 10.7 24 24 24s24-10.7 24-24V401.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
var faFireExtinguisher = {
  prefix: 'far',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H200v26.6c50.3 11 88 55.8 88 109.4V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V240c0-53.6 37.7-98.4 88-109.4V104.9c-46.9 5.5-86.5 34.8-106.3 75.6c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C30.1 102.8 86.1 62.4 152 56.7V24c0-13.3 10.7-24 24-24s24 10.7 24 24V56h89c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM112 416v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V416H112zm0-48H240V240c0-35.3-28.7-64-64-64s-64 28.7-64 64V368z"]
};
var faGarageOpen = {
  prefix: 'far',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 320V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40H504c22.1 0 40 17.9 40 40V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H144zm0-48H496V240H144v32zm88 144v16H408V416c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16zm0 64v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V416c0-35.3 28.7-64 64-64H392c35.3 0 64 28.7 64 64v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H232z"]
};
var faShelvesEmpty = {
  prefix: 'far',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V184 440v48c0 13.3 10.7 24 24 24s24-10.7 24-24V464H592v24c0 13.3 10.7 24 24 24s24-10.7 24-24V440 184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V160H48V24zm0 184H592V416H48V208z"]
};
var faCruzeiroSign = {
  prefix: 'far',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M80 256c0-97 79.3-176 177.6-176c45.6 0 87 17 118.5 44.9c9.9 8.8 25.1 7.9 33.9-2s7.9-25.1-2-33.9C368 53.5 315.3 32 257.6 32C133.2 32 32 132.1 32 256s101.2 224 225.6 224c57.7 0 110.4-21.5 150.3-57c9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2C344.6 415 303.2 432 257.6 432c-6.3 0-12.5-.3-18.6-1c.7-2.2 1-4.6 1-7V320v-1.8c0-21.1 17.1-38.2 38.2-38.2c10.1 0 19.9 4 27 11.2L311 297c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-5.8-5.8c-16.2-16.2-38.1-25.3-61-25.3c-14.1 0-27.4 3.4-39.2 9.4C236.2 231.3 227 224 216 224c-13.3 0-24 10.7-24 24v70.2V320v99.6C126.3 393.7 80 330.1 80 256z"]
};
var faWatchApple = {
  prefix: 'far',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M112.3 0C85.6 0 64 21.6 64 48.3V65.6C27.5 73 0 105.3 0 144V368c0 38.7 27.5 71 64 78.4V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V446.4c36.5-7.4 64-39.7 64-78.4V144c0-38.7-27.5-71-64-78.4V48.3C320 21.6 298.4 0 271.7 0H112.3zM304 112c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H304zM192 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-8 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faWatchCalculator = {
  prefix: 'far',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M112.3 0C85.6 0 64 21.6 64 48.3V65.6C27.5 73 0 105.3 0 144V368c0 38.7 27.5 71 64 78.4V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V446.4c36.5-7.4 64-39.7 64-78.4V144c0-38.7-27.5-71-64-78.4V48.3C320 21.6 298.4 0 271.7 0H112.3zM304 112c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H304zM104 160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16H280c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H104zM88 272a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM112 312a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faListDropdown = {
  prefix: 'far',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", "M48 192V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V192H48zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm436.7 0H363.3c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c3.1 3.1 8.2 3.1 11.3 0l36.7-36.7c5-5 1.5-13.7-5.7-13.7zM128 232H384c13.3 0 24 10.7 24 24s-10.7 24-24 24H128c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H384c13.3 0 24 10.7 24 24s-10.7 24-24 24H128c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCabinetFiling = {
  prefix: 'far',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", "M400 232H48V64c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V232zM0 256v24V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V280 256 232 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V232v24zM400 448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V280H400V448zM160 152v-8H288v8c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-22.1-17.9-40-40-40H152c-22.1 0-40 17.9-40 40v16c0 13.3 10.7 24 24 24s24-10.7 24-24zm-8 184c-22.1 0-40 17.9-40 40v16c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H288v8c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-22.1-17.9-40-40-40H152z"]
};
var faBurgerSoda = {
  prefix: 'far',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H80.2 32 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H36 84.2h89.9 35.8 89.9H348h12c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H303.8 224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3zM60.3 468c2.1 24.9 22.9 44 47.8 44H275.8c5.4 0 10.7-.9 15.5-2.6c-12.7-12.7-22.6-28.1-28.7-45.4H108.2L86.8 208H38.7L60.3 468zM449.9 240.2c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.3 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8H366.8c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88H552c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8H584c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z"]
};
var faSquareArrowUp = {
  prefix: 'far',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm241 39l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l88-88c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faArrowSquareUp = faSquareArrowUp;
var faGreaterThanEqual = {
  prefix: 'far',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M47 78.2c-12.3-5-18.2-19-13.2-31.3s19-18.2 31.3-13.2l336 136c9.1 3.7 15 12.5 15 22.2s-5.9 18.6-15 22.2L65 350.2c-12.3 5-26.3-1-31.3-13.2s1-26.3 13.2-31.3L328 192 47 78.2zM424 432c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424z"]
};
var faPalletBox = {
  prefix: 'far',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", "M384 48v80c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 115.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V48H176V240H464V48H384zM128 48c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48zM0 344c0-13.3 10.7-24 24-24H88 320 552h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H576v96h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H552 320 88 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V368H24c-13.3 0-24-10.7-24-24zM112 464H296V368H112v96zm232 0H528V368H344v96z"]
};
var faFaceConfounded = {
  prefix: 'far',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm231 77.3l25 20 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 343c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.8 7-21.2 7-30 0l-26.3-21L181.3 404c-9.5 6.3-22.2 5.1-30.3-3l-24-24c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l10.1 10.1L202.7 332c8.7-5.8 20.1-5.3 28.3 1.2zM133.5 178.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 189.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faShieldHalved = {
  prefix: 'far',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M232 59.6V450.3C99.2 375.7 64.4 227.3 64 139.7c0-5 3.1-10.2 9-12.8L232 59.6zm48 390.8V59.6L439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 87.5-35.2 236-168 310.6zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2z"]
};
var faShieldAlt = faShieldHalved;
var faTruckPlow = {
  prefix: 'far',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M184 80h86.1c2.8 0 5.4 1.5 6.8 3.8L343 192H176V88c0-4.4 3.6-8 8-8zM398.6 192c-.6-1.5-1.3-3.1-2.2-4.5L317.8 58.8C307.7 42.2 289.6 32 270.1 32H184c-30.9 0-56 25.1-56 56V192H56c-30.9 0-56 25.1-56 56v96c0 19.4 13.7 35.5 32 39.2l0 .8c0 53 43 96 96 96s96-43 96-96h48c0 53 43 96 96 96s96-43 96-96h54.1l.1 .1 80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 358.7V217.3l73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1V336H480V248c0-30.9-25.1-56-56-56H398.6zM432 312.4c-17-15.2-39.4-24.4-64-24.4c-35.5 0-66.6 19.3-83.2 48H211.2c-16.6-28.7-47.6-48-83.2-48c-33.4 0-62.8 17-80 42.9V248c0-4.4 3.6-8 8-8H424c4.4 0 8 3.6 8 8v64.4zM80 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm288-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faBookAtlas = {
  prefix: 'far',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM176.5 216h-31c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 200a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 123.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 216H208.6c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z"]
};
var faAtlas = faBookAtlas;
var faVirus = {
  prefix: 'far',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M75 75c12.5-12.5 32.8-12.5 45.3 0l8.2 8.2C163.7 118.4 224 93.4 224 43.5V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43.5c0 49.9 60.3 74.9 95.6 39.6l8.2-8.2c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-8.2 8.2c-35.3 35.3-10.3 95.6 39.6 95.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H468.5c-49.9 0-74.9 60.3-39.6 95.6l8.2 8.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-8.2-8.2c-35.3-35.3-95.6-10.3-95.6 39.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V468.5c0-49.9-60.3-74.9-95.6-39.6l-8.2 8.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l8.2-8.2C118.4 348.3 93.4 288 43.5 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H43.5c49.9 0 74.9-60.3 39.6-95.6L75 120.2C62.5 107.7 62.5 87.5 75 75zM256 99.6c-23.3 36.4-68.4 55.1-110.6 45.8c9.3 42.2-9.4 87.3-45.8 110.6c36.4 23.3 55.1 68.4 45.8 110.6c42.2-9.3 87.3 9.4 110.6 45.8c23.3-36.4 68.4-55.1 110.6-45.8c-9.3-42.2 9.4-87.3 45.8-110.6c-36.4-23.3-55.1-68.4-45.8-110.6c-21.2 4.7-43.1 2.3-62.6-5.8c-19.4-8.1-36.4-21.8-48-40zM192 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGridRound2 = {
  prefix: 'far',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", "M128 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM336 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z"]
};
var faCommentMiddleTop = {
  prefix: 'far',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M231.3 124.8L256 75.3l24.7 49.5c6.5 12.9 18.4 22.3 32.5 25.4C407 171 464 237.3 464 304c0 79.5-83.3 160-208 160S48 383.5 48 304c0-66.7 57-133 150.7-153.8c14.1-3.1 26.1-12.5 32.5-25.4zm92.4-21.5l-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304C0 418.9 114.6 512 256 512s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z"]
};
var faEnvelopeCircleCheck = {
  prefix: 'far',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M64 112H448c8.8 0 16 7.2 16 16v22.1l-22.6 18.5C458.6 163 477 160 496 160c5.4 0 10.7 .2 16 .7V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H360.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V212.2L190 328.8c37.7 31 91.8 31.5 130.1 1.5c.9-29.2 8.9-56.5 22.4-80.4l-50.9 41.8c-20.7 17-50.4 17-71.1 0L48 150.1V128c0-8.8 7.2-16 16-16zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faLayerGroup = {
  prefix: 'far',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"]
};
var faRestroomSimple = {
  prefix: 'far',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208h44.8c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3H168 88 85.6c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352zM320 0c-13.3 0-24 10.7-24 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM576 64A64 64 0 1 0 448 64a64 64 0 1 0 128 0zM496.3 208h31.4c7.1 0 13.4 4.7 15.4 11.6L576.4 336H447.6l33.3-116.4c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H448V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h21.6c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H496.3z"]
};
var faArrowsToDot = {
  prefix: 'far',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L201 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 24zM433 345c9.4-9.4 9.4-24.6 0-33.9l-31-31H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H401.9l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM113 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h86.1L79 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72zM167 433c9.4 9.4 24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24V401.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9z"]
};
var faBorderOuter = {
  prefix: 'far',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faHashtagLock = {
  prefix: 'far',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136h111l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136H424c13.3 0 24 10.7 24 24c0 .4 0 .8 0 1.1c-19.9 2.9-38.2 11-53.3 22.9H342.9L287.5 460.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376l-111 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376 24 376c-13.3 0-24-10.7-24-24s10.7-24 24-24l81.1 0 28.8-144H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h87.5l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328l111 0 28.8-144h-111zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faClockTwoThirty = {
  prefix: 'far',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faArchway = {
  prefix: 'far',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M0 56C0 42.7 10.7 32 24 32H56 456h24c13.3 0 24 10.7 24 24s-10.7 24-24 24V432h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H456 424 360c-13.3 0-24-10.7-24-24V336c0-44.2-35.8-80-80-80s-80 35.8-80 80V456c0 13.3-10.7 24-24 24H88 56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V80H24C10.7 80 0 69.3 0 56zM80 80v32H432V80H80zm0 80V432h8 40V336c0-70.7 57.3-128 128-128s128 57.3 128 128v96h40 8V160H80z"]
};
var faHeartCircleCheck = {
  prefix: 'far',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9l0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2l-.1 .1-.1 .1-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faHouseChimneyCrack = {
  prefix: 'far',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24V182.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h85.9l-30.3-48.1c-4.4-6.9-2.8-16 3.6-21.1L288 327.6l-58.1-76.1c-11.3-14.8 7.4-33.6 22.3-22.5l115.2 86.2c8.4 6.3 8.6 18.8 .4 25.3L288 403.8 325.9 464H432c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8z"]
};
var faHouseDamage = faHouseChimneyCrack;
var faFileZipper = {
  prefix: 'far',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16h48v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm48 112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H136.6c-14.5 0-27.2 9.7-30.9 23.8zM128 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFileArchive = faFileZipper;
var faHeartHalf = {
  prefix: 'far',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M236.7 476.9c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5V456.2 433.8v-4.6V96L244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L208 450.1l3.3 3.1 16.4 15.3 9 8.4zM208 384.5L80.3 265.3C59.7 246.1 48 219.1 48 190.9v-5.8c0-46.4 33.6-86 79.3-93.6c29.3-4.9 59.1 4.2 80.7 24.5V384.5z"]
};
var faCommentCheck = {
  prefix: 'far',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM369 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 193z"]
};
var faSquare = {
  prefix: 'far',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faMemo = {
  prefix: 'far',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm120 64H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMartiniGlassEmpty = {
  prefix: 'far',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M0 35.3C0 15.8 15.8 0 35.3 0H476.7C496.2 0 512 15.8 512 35.3c0 9.4-3.7 18.3-10.3 25L280 281.9V464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H256 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V281.9L10.3 60.3C3.7 53.7 0 44.7 0 35.3zM256 238.1L446.1 48H65.9L256 238.1z"]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCouch = {
  prefix: 'far',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M448 80H192c-44.2 0-80 35.8-80 80v40c-12.3-5.1-25.8-8-40-8c-2.7 0-5.4 .1-8 .3V160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v32.3c-2.6-.2-5.3-.3-8-.3c-14.2 0-27.7 2.8-40 8V160c0-44.2-35.8-80-80-80zM568 224c2.7 0 5.4 .1 8 .4c36 4 64 34.5 64 71.6V432c0 26.5-21.5 48-48 48H544c-20.9 0-38.7-13.4-45.3-32H141.3c-6.6 18.6-24.4 32-45.3 32H48c-26.5 0-48-21.5-48-48V296c0-37.1 28-67.6 64-71.6c2.6-.3 5.3-.4 8-.4c15.2 0 29.4 4.7 41 12.8c16.7 11.6 28.2 30 30.5 51.2H496.4c2.3-21.2 13.9-39.6 30.5-51.2c11.6-8.1 25.8-12.8 41-12.8zm-24 72v40 64 32h48V296c0-13.3-10.7-24-24-24s-24 10.7-24 24zM496 400V336H144v64H496zM96 400V336 296c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136H96V400z"]
};
var faCediSign = {
  prefix: 'far',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M216 0c13.3 0 24 10.7 24 24V72.5C277.9 75 313 88 341.9 108.4c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7c-20.9-14.8-46.3-24.5-74.1-27V391.4c27.8-2.5 53.2-12.2 74.1-27c10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5C313 424 277.9 437 240 439.5V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V437.2C102 422 32 347.7 32 256s70-166 160-181.2V24c0-13.3 10.7-24 24-24zM80 256c0 63.2 47 117.9 112 132.3V123.7C127 138.1 80 192.8 80 256z"]
};
var faItalic = {
  prefix: 'far',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 56c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H291.3L144.7 432H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H92.7L239.3 80H152c-13.3 0-24-10.7-24-24z"]
};
var faGlassCitrus = {
  prefix: 'far',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", "M464 144c0-53-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 78.4-62.7 142.2-140.7 144l4.6-48.3c49.3-4 88.1-45.3 88.1-95.7zM6.2 135.9c4.5-5 11-7.9 17.8-7.9H328c6.8 0 13.2 2.9 17.8 7.9s6.8 11.7 6.1 18.4l-29.2 307c-2.7 28.7-26.9 50.7-55.7 50.7H85.1c-28.9 0-53-21.9-55.7-50.7L.1 154.3c-.6-6.7 1.6-13.4 6.1-18.4zM62.6 304L77.1 456.8c.4 4.1 3.8 7.2 8 7.2H266.9c4.1 0 7.6-3.1 8-7.2L289.4 304H62.6zM58 256H294l7.6-80H50.4L58 256z"]
};
var faCalendarLinesPen = {
  prefix: 'far',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H400 384 48V448c0 8.8 7.2 16 16 16H262.5l-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zm-8 256H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 376c0-13.3 10.7-24 24-24H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faChurch = {
  prefix: 'far',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v26.9L192.9 189.7c-20.5 13.3-32.9 36-32.9 60.4V464H72c-13.3 0-24-10.7-24-24V370.1c0-8.1 4.1-15.7 11-20.2l69-44.7V248.1L32.9 309.7C12.4 322.9 0 345.7 0 370.1V440c0 39.8 32.2 72 72 72H192v0H448h8H568c39.8 0 72-32.2 72-72V370.1c0-24.4-12.4-47.2-32.9-60.4L512 248.1v57.2L581 350c6.8 4.4 11 12 11 20.1V440c0 13.3-10.7 24-24 24H480V250.1c0-24.4-12.4-47.2-32.9-60.4L344 122.9V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM320 164.6L421 230c6.8 4.4 11 12 11 20.1V464H368V368c0-26.5-21.5-48-48-48s-48 21.5-48 48v96H208V250.1c0-8.1 4.1-15.7 11-20.1l101-65.4z"]
};
var faPersonSnowmobiling = {
  prefix: 'far',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", "M240 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm99.7 75.4c11.4-6.8 26.1-3.1 32.9 8.2l46.8 78.1 138.9 69.4c10.8 5.4 17.7 16.5 17.7 28.6v59.1c0 10.7-5.3 20.7-14.2 26.6L492 392l54 72h20.1l33-33c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-40 40c-4.5 4.5-10.6 7-17 7H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h46l-48-64H313.3c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l8-16 31.2-62.3C76.6 278.8 87.7 272 99.8 272H288l24-32H280c-7.6 0-14.7-3.6-19.2-9.6l-33.4-44.5c-4.7-6.2-12-9.9-19.8-9.9c-9.8 0-18.6 5.7-22.6 14.7l-19.1 43.1c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l19.1-43.1c11.7-26.3 37.7-43.2 66.4-43.2c22.9 0 44.4 10.8 58.2 29.1L292 192h56l18.7-24.9-35.3-58.8c-6.8-11.4-3.1-26.1 8.2-32.9zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H240c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm160-48H465.5L528 310.3V269.7L398.4 204.8l-72 96L312 320H288 109.7l-16 32H240z"]
};
var faSnowmobile = faPersonSnowmobiling;
var faFaceHushed = {
  prefix: 'far',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCommentsDollar = {
  prefix: 'far',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPickaxe = {
  prefix: 'far',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", "M460.3 112.6c47.6 66.4 63.4 152.5 42 231.5c-.3 .9-.5 1.9-.8 2.8c-1.3 4.4-2.6 8.9-4.1 13.2l-.2 .6c-1.5 4.5-3.2 8.9-5 13.3c-5.4 13.3-24.9 13-29.8-.5c-1.8-4.6-3.6-9.3-5.6-13.9c-1.6-3.7-3.2-7.4-4.9-11.1l-.8-1.7c-28.4-62.2-70.9-119.9-118.5-167.6C285.3 131.9 227.5 88.9 165.3 60.8l-1.7-.8c-3.7-1.7-7.5-3.3-11.3-4.9c-4.6-1.9-9.2-3.7-13.8-5.5c-13.4-5-13.7-24.5-.5-29.8c4.4-1.8 8.8-3.4 13.3-5l.2-.1c4.5-1.5 9-2.9 13.5-4.2c1-.3 2-.5 2.9-.8c78.9-21.3 165-5.5 231.3 42.1l9.5-9.9c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.9 9.5zm-62.2 .7C357 72.3 301 49.8 244.2 48.4c45.4 27.7 86.9 61.4 122.4 97c35.9 35.9 69.4 77.5 97 122.8c-1.3-57.2-24.1-113.6-65.5-154.8zM8.9 457.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4S-3.1 470.4 8.9 457.8z"]
};
var faLinkSimpleSlash = {
  prefix: 'far',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h72c61.9 0 112 50.1 112 112c0 46.6-28.5 86.6-69.1 103.5L389.5 280H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H328.3L216 144h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zm69.6 176.3L70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-61.9 0-112-50.1-112-112c0-28.6 10.7-54.8 28.4-74.6z"]
};
var faDemocrat = {
  prefix: 'far',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M102.2 4.7C99.8 11.1 96 23.1 96 32c0 12.7 5 22.8 11.1 30.5c-5.3 3.6-10.2 7.9-14.7 12.6l-70.6 76C7.8 166.2 0 186.1 0 206.6C0 251.4 36.2 288 81.2 288c13.8 0 27.4-3.5 39.4-10.2L157 257.5l35 75.7V456c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V432h96v24c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V328 216c0-1.4 0-2.8-.1-4.2c5.5 5.7 9.9 11.1 13.2 15.4c2.2 2.9 3.9 5.4 5 7c.5 .8 .9 1.4 1.1 1.8l.2 .3 0 0 0 0 0 0 0 0 0 0c6.8 11.3 21.5 15.1 32.9 8.3c11.4-6.8 15.1-21.5 8.4-32.9L616 224c20.6-12.3 20.6-12.3 20.6-12.3l0 0 0 0-.1-.1-.2-.3-.5-.8c-.4-.7-1-1.6-1.8-2.8c-1.5-2.3-3.8-5.5-6.6-9.3c-5.7-7.6-14.2-17.7-25.1-27.9c-21.5-20-55.1-42.4-98.3-42.4c-1.9 0-3.7 .2-5.5 .6c-3.5-.4-7-.6-10.5-.6H291.1c-1.8 0-3.5-.6-5-1.7L209.9 66.1c7.3-8 14.1-19.3 14.1-34.1c0-8.9-3.8-20.9-6.2-27.3C216.8 1.8 214 0 211 0c-1.9 0-3.8 .7-5.2 2.1L160 45.7 114.2 2.1C112.8 .7 110.9 0 109 0c-3 0-5.8 1.8-6.8 4.7zM240 352H528V456c0 4.4-3.6 8-8 8H488c-4.4 0-8-3.6-8-8V408c0-13.3-10.7-24-24-24H312c-13.3 0-24 10.7-24 24v48c0 4.4-3.6 8-8 8H248c-4.4 0-8-3.6-8-8V352zm288-48H231.4l-41.6-90.1c-2.8-6.1-8-10.7-14.3-12.8s-13.3-1.4-19.1 1.8l-59 32.8c-4.9 2.7-10.5 4.2-16.1 4.2C63 240 48 225.1 48 206.6c0-8.5 3.2-16.7 8.9-22.8l70.6-76c7.1-7.7 17.1-12.2 27.5-12.4c9.1-.2 17.9 2.7 25 8.3L256.4 164c9.9 7.8 22.1 12 34.7 12H488c22.1 0 40 17.9 40 40v88zM379.3 210.3c-.7-1.4-2.2-2.3-3.8-2.3s-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4zM279.5 208c-1.6 0-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4c-.7-1.4-2.2-2.3-3.8-2.3zm195.8 2.3c-.7-1.4-2.2-2.3-3.8-2.3s-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4z"]
};
var faFaceConfused = {
  prefix: 'far',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.2 385.6l-12.8 9.6c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6l12.8-9.6c37.4-28 82.9-43.2 129.6-43.2h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H304c-36.4 0-71.7 11.8-100.8 33.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPinball = {
  prefix: 'far',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM312 408L126.8 251.2c-20.3-17-50.5-14.3-67.6 6s-14.4 50.6 6 67.7c4.5 3.8 9.8 6.8 15.9 8.8l.1 0L312 408zM66.3 379.3c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3c12.6 9.8 15.8 27.1 8.4 40.6c-7.2 13.2-23.1 19.9-37.9 15L66.3 379.3zM96 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faZ = {
  prefix: 'far',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M0 56C0 42.7 10.7 32 24 32H360c9.3 0 17.8 5.4 21.8 13.9s2.6 18.4-3.4 25.6L75.5 432H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L308.5 80H24C10.7 80 0 69.3 0 56z"]
};
var faPersonSkiing = {
  prefix: 'far',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L239.8 365l49.6-74.5-82.7-87.9c-9.5-10.1-14.4-22.4-15.1-34.9l87.7 42 49.4 52.5c12.8 13.6 14.5 34.1 4.2 49.6l-50.2 75.4 135.8 70.5c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 55.5 26.6c1.7-.9 3.5-1.7 5.4-2.5l80.9-32.4c32.4-13 68.6 6.5 75.6 40.7l12.3 59.7 62.9 30.1c12 5.7 17 20 11.3 32s-20 17-32 11.3l-54.2-25.9c-1-.3-1.9-.6-2.8-1l-229.1-110-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5zm217.3 64.7c-1-4.9-6.2-7.7-10.8-5.8l-45.7 18.3 65.5 31.5-9-43.9z"]
};
var faSkiing = faPersonSkiing;
var faDeer = {
  prefix: 'far',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 30.9 25.1 56 56 56h8 8 24l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18h28.2L295 168H104c-36.5 0-68.3 20.4-84.5 50.4c-9.2 13.7-15.1 30-16.2 47.6L0 319c-.6 8.8 6.2 16.4 15 17c8.5 .5 15.9-5.7 16.9-14.1l1.1 1.1c4.5 4.5 7 10.6 7 17v4.3c0 2.6-.4 5.1-1.2 7.6l-8.2 24.7c-5.1 15.4-4.9 32.1 .6 47.4l22.5 61.8C59.4 501.5 74.4 512 91.2 512h46c27.8 0 47.1-27.6 37.6-53.7L157 409.5l6.5-4.3c15.2-10.1 25.6-25.4 29.9-42.4c20 8.7 41.7 13.3 63.8 13.3H264v96c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V311.8c0-2.6 .4-5.1 1.2-7.6L409.3 256h42.3c37.8 0 68.4-30.6 68.4-68.4c0-19.3-8.1-37.6-22.4-50.6L444.1 88.4C460.8 78.7 472 60.7 472 40V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24H386.1 346.6c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zm130.1 96c8.1 0 15.9 3 21.9 8.5l57.3 52.1c4.2 3.9 6.7 9.3 6.7 15.1c0 11.3-9.1 20.4-20.4 20.4H392c-10.3 0-19.5 6.6-22.8 16.4L347.7 289c-2.4 7.3-3.7 15-3.7 22.8V464H312V352c0-13.3-10.7-24-24-24H257.2c-22.1 0-43.7-6.5-62.1-18.8L181.3 300c-8-5.3-18.3-5.4-26.3-.2s-12.2 14.7-10.6 24.1l2.9 17.4c1.6 9.3-2.5 18.7-10.4 23.9L114.7 380c-9.2 6.1-13 17.8-9.2 28.2L125.7 464H96.8L76.3 407.5c-1.9-5.1-1.9-10.7-.2-15.8L84.3 367c2.4-7.3 3.7-15 3.7-22.8v-4.3c0-19.1-7.6-37.4-21.1-50.9L63 285.1c-4.5-4.5-7-10.6-7-17V264c0-26.5 21.5-48 48-48H312.9c10.6 0 20-7 23-17.1l19-63.6c4.1-13.8 16.8-23.2 31.2-23.2zM416 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faInputPipe = {
  prefix: 'far',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm144 56V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faRoadLock = {
  prefix: 'far',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480H384V432H344V408c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l28.3 78.5c13.8-7.8 29.4-12.7 46-14L490 79.6C479.7 51 452.6 32 422.3 32H217.7zM344 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V216zm184 24c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faA = {
  prefix: 'far',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M214.1 46.7C210.4 37.8 201.7 32 192 32s-18.4 5.8-22.1 14.7l-168 400c-5.1 12.2 .6 26.3 12.8 31.4s26.3-.6 31.4-12.8L80.3 384H303.7l34.1 81.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4l-168-400zM283.6 336H100.4L192 118l91.6 218z"]
};
var faBookmarkSlash = {
  prefix: 'far',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48V75L38.8 5.1zM176 112.6V48H464V338.4L176 112.6zM509.9 497.8L315.3 344.5c-3.3 .6-6.5 2-9.3 4L176 441.4V234.7l-48-37.8V488c0 9 5 17.2 13 21.3s17.6 3.4 24.9-1.8L320 397.5l154.1 110c7.3 5.2 16.9 5.9 24.9 1.8c4.9-2.5 8.8-6.7 10.9-11.6z"]
};
var faTemperatureArrowDown = {
  prefix: 'far',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M176 48c-35.3 0-64 28.7-64 64V273.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112V273.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8V112zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3zM448 480c-6.8 0-13.3-2.9-17.8-7.9l-72-80c-8.9-9.9-8.1-25 1.8-33.9s25-8.1 33.9 1.8L424 393.5 424 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 337.5 30.2-33.5c8.9-9.9 24-10.7 33.9-1.8s10.7 24 1.8 33.9l-72 80c-4.6 5.1-11 7.9-17.8 7.9z"]
};
var faTemperatureDown = faTemperatureArrowDown;
var faMace = {
  prefix: 'far',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", "M244.8 95l28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1C301 443.6 294.9 448 288 448s-13-4.4-15.2-10.9l-28-84.1c-12.4-4.1-24-10-34.5-17.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L176.4 301.7c-7.3-10.5-13.2-22.1-17.4-34.5l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 312a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm-32-88a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faFeatherPointed = {
  prefix: 'far',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M117.7 343.9c-11.2-41.4-11.7-113 53.7-178.3c38.1-38.1 93.7-66.3 152.8-85.7c50.6-16.7 100.7-26 138.3-30.3c-4.3 37.6-13.6 87.7-30.3 138.3c-2.2 6.8-4.6 13.5-7 20.1H337.9l7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L122.8 355.2c-2.6-4.1-4.2-7.9-5.1-11.3zm4.6 79.7c10 7.6 21 13.7 33.3 17c54.1 14.6 144.7 14 224.8-66.1C471.5 283.5 505 120.5 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c3.3 12.2 9.4 23.2 17 33.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l81.3-81.3zm34.5-34.5L193.9 352H334.3c-61.9 53.9-127.3 52.9-166.2 42.3c-3.5-.9-7.2-2.6-11.3-5.2zm220-85.2H241.9l48-48H404.6c-8.4 17-17.7 33.2-27.9 48z"]
};
var faFeatherAlt = faFeatherPointed;
var faSausage = {
  prefix: 'far',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M447.5 69.3l15.2-41.9c.8-2.2 1.2-4.6 1.2-7C464 9.1 454.9 0 443.6 0H388.4C377.1 0 368 9.1 368 20.4c0 2.4 .4 4.7 1.2 7l15.2 41.9C346.9 82.3 320 118 320 160c0 88.4-71.6 160-160 160c-42 0-77.7 26.9-90.7 64.5L27.4 369.2c-2.2-.8-4.6-1.2-7-1.2C9.1 368 0 377.1 0 388.4v55.2C0 454.9 9.1 464 20.4 464c2.4 0 4.7-.4 7-1.2l41.9-15.2C82.3 485.1 118 512 160 512c194.4 0 352-157.6 352-352c0-42-26.9-77.7-64.5-90.7zM112 416c0-26.5 21.5-48 48-48c114.9 0 208-93.1 208-208c0-26.5 21.5-48 48-48s48 21.5 48 48c0 167.9-136.1 304-304 304c-26.5 0-48-21.5-48-48z"]
};
var faTrashCanClock = {
  prefix: 'far',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v64.7c-16.8 1.5-32.9 5.4-48 11.3V128H80V432c0 17.7 14.3 32 32 32H284.5c12.3 18.8 28 35.1 46.3 48H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM320 192v40.2c-12.1 10-22.9 21.7-32 34.6V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm-160 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm48 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]
};
var faP = {
  prefix: 'far',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M56 80H168c57.4 0 104 46.6 104 104s-46.6 104-104 104H48V88c0-4.4 3.6-8 8-8zM48 336H168c83.9 0 152-68.1 152-152s-68.1-152-152-152H56C25.1 32 0 57.1 0 88V312 456c0 13.3 10.7 24 24 24s24-10.7 24-24V336z"]
};
var faBroomWide = {
  prefix: 'far',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 143l-12.9-12.9c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4L392.6 266.2c13.9-25 9.5-56.1-10.7-76.3L369 177 505 41zM323.6 291.6l-90 162.1L137 357.1l18-53.9c2.1-6.3-3.9-12.2-10.1-10.1L90.9 311 58.4 278.5l162.1-90L323.6 291.6z"]
};
var faSnowflake = {
  prefix: 'far',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M224 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4V137.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24z"]
};
var faStomach = {
  prefix: 'far',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96c0 66.3 53.7 120 120 120h.2c-.2 2.6-.2 5.3-.2 8v64c0 39.8-32.2 72-72 72H120C53.7 360 0 413.7 0 480v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-35.3 28.7-64 64-64c9.6 0 19 3.5 30.6 11.1c8.8 5.7 17.1 12.6 26.9 20.7c4.2 3.4 8.6 7.1 13.5 11C214.6 484 255.9 512 320 512c106 0 192-86 192-192V224c0-70.7-57.3-128-128-128c-50.6 0-94.4 29.4-115.1 72H256c-39.8 0-72-32.2-72-72V24zm18 388.3c-2-1.6-4-3.3-6-4.9c46.2-4.6 84.6-35.4 100.4-77.3c12.2-6.9 22.6-8 32.7-6.6c12.4 1.7 24.9 7.1 41.1 14.4l1.2 .6c14.8 6.6 33.1 14.8 53 17.6c11.5 1.6 23.3 1.3 35.4-1.5C444.4 417.4 387.6 464 320 464c-47.9 0-78.6-20-107-42.7c-3.5-2.8-7.2-5.8-10.9-8.9l0 0 0 0 0 0zM464 301.6c-12.4 7.1-22.9 8.2-33.1 6.8c-12.4-1.7-24.9-7.1-41.1-14.4l-1.2-.6c-14.8-6.6-33.1-14.8-53-17.6c-10.3-1.4-20.8-1.4-31.6 .7V224c0-44.2 35.8-80 80-80s80 35.8 80 80v77.6z"]
};
var faNewspaper = {
  prefix: 'far',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M168 80c-13.3 0-24 10.7-24 24V408c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112C0 98.7 10.7 88 24 88s24 10.7 24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72H440c39.8 0 72 32.2 72 72V408c0 39.8-32.2 72-72 72H72zM176 136c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V136zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faRectangleAd = {
  prefix: 'far',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm229.5 77.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"]
};
var faAd = faRectangleAd;
var faGuitarElectric = {
  prefix: 'far',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M352 126.1V81.1c0-10.7 5.3-20.7 14.2-26.6L435.6 8.3C443.7 2.9 453.2 0 462.9 0H464c26.5 0 48 21.5 48 48s-21.5 48-48 48H449.9L314.4 231.6c9.1 8.1 13.8 8.4 14.9 8.4c2.6 .1 4.3-.6 10.9-3.5l3.7-1.6c13.2-5.6 36-8.3 52.3 8.2c15.8 15.9 15.8 41.7 0 57.6l-21.6 21.8c-12.2 12.3-28.2 18.8-38.7 23l-2.1 .8c-5.5 2.2-12.7 6.3-20.3 14c-17.3 17.5-23.7 39.4-30.6 63.5c-.9 3-1.7 6-2.6 9.1c-5.2 17.5-14.1 35-28.1 49.2c-39.4 39.9-103.5 39.9-142.9 0L29.5 401.3c-39.3-39.7-39.3-104 0-143.7c14.1-14.2 31.4-23.3 48.8-28.5c2.9-.9 5.7-1.7 8.6-2.6l0 0c23.9-7.1 45.6-13.5 63-31.1c6.3-6.3 10.1-12.4 12.5-17.5c.8-1.8 1.8-3.8 2.8-6c5.4-11.9 13.1-29.1 25.6-41.7l29.9-30.2c15.9-16.1 41.8-16.1 57.7 0c16.1 16.3 14.2 39.7 5.2 54.6c-1.1 1.8-2.1 3.4-3 4.9l0 0c-4.9 8-7.8 12.7-8.8 18.2c-.6 3.2-1 9.2 8.7 19.8L352 126.1zM167 263c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zm-64 64c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zM242.4 129.8l0 0 0 0 0-.1zm-18 39.8c.4-2.3 .9-4.5 1.5-6.7l-1.2 1.2c-5.9 5.9-9.4 13.5-14.7 25.1l0 0c-1.3 2.9-2.8 6-4.4 9.4c-4.6 9.6-11.5 20.2-21.7 30.6c-26.7 27-60.7 36.8-83.8 43.5l0 0c-2.8 .8-5.5 1.6-7.9 2.3c-11.5 3.5-21.3 9-28.6 16.4c-20.8 21-20.8 55.2 0 76.2l79.9 80.8c20.6 20.9 54 20.9 74.6 0c7.3-7.4 12.8-17.4 16.3-29.1c.8-2.6 1.5-5.3 2.4-8.2c6.6-23.3 16.2-57.6 42.8-84.4c12.5-12.6 25.3-20.2 36.2-24.7c12.9-5.2 20-8.4 24.7-13.2l2.3-2.4c-4.6 1.1-9.7 1.7-15 1.6c-18-.5-35-9.6-52.1-26.9l0 0L248 233.2l-.1-.1c-20.4-20.6-27.2-42.3-23.5-63.5z"]
};
var faArrowTurnDownRight = {
  prefix: 'far',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V224c0 48.6 39.4 88 88 88H430.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9L377 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87H88c-22.1 0-40-17.9-40-40V56z"]
};
var faMoonCloud = {
  prefix: 'far',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M635.2 416.6c-2.6 2.5-5.2 5-7.9 7.3c-4.5 4-9.1 7.8-13.9 11.4c-1.8 1.4-3.7 2.7-5.5 4C571.5 465 527.2 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c11.6-12 20.3-26.9 25-43.4C380.2 409 427.2 432 479.5 432c13.3 0 26.2-1.5 38.6-4.3C430.5 397.4 367.6 314 367.6 216c0-43 12.1-83.2 33.1-117.3C343.4 127.6 304 187.1 304 256l0 .3c-13.9-8.9-30.1-14.6-47.5-16c7.6-110.9 95.8-199.6 206.3-207.7c2.3-.2 4.6-.3 6.9-.4c3.2-.1 6.5-.2 9.8-.2c2.7 0 5.5 0 8.2 .1c3.6 .1 7.2 .3 10.7 .6c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-3.2 1.8-6.4 3.8-9.6 5.8c-4.3 2.8-8.5 5.8-12.5 9c-1.1 .8-2.1 1.7-3.2 2.6c-39.2 32.3-64.1 81.2-64.1 136c0 97.1 78.5 175.8 175.2 176l.3 0c1.2 0 2.5 0 3.7 0c5.2-.1 10.3-.4 15.3-1c3.7-.4 7.4-.9 11.1-1.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7zM64 416c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H64z"]
};
var faBreadSliceButter = {
  prefix: 'far',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M112 256V432H400V256c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16c0-34.5-24.6-62.3-74.9-83.9C340.2 87.2 282.8 80 256 80s-84.2 7.2-133.1 28.1C72.6 129.7 48 157.5 48 192c0 8.8 7.2 16 16 16c26.5 0 48 21.5 48 48zm336 0v48V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V304 256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zm-265.4 9.4l50.7-50.7c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-50.7 50.7c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3z"]
};
var faCircleArrowRight = {
  prefix: 'far',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM289 361l88-88c9.4-9.4 9.4-24.6 0-33.9l-88-88c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47L152 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l150.1 0-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
var faArrowCircleRight = faCircleArrowRight;
var faUserGroupCrown = {
  prefix: 'far',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", "M144 144c0 44.2 35.8 80 80 80s80-35.8 80-80V128H144v16zm-.1-124.9l.1 .1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5H336c8.8 0 16 7.2 16 16V39v3.2 .1V144c0 70.7-57.3 128-128 128s-128-57.3-128-128V42.3v-.1V39 16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6zM48.3 464H399.7c-4.1-62.5-56.2-112-119.7-112H168c-63.6 0-115.6 49.5-119.7 112zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8zM432 256c-27.7 0-53-10.1-72.6-26.7c.5-.8 1-1.5 1.4-2.3c12.1-19.9 20-42.6 22.4-67c.5-5.3 .8-10.6 .8-16V42.8C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z"]
};
var faUsersCrown = faUserGroupCrown;
var faCircleI = {
  prefix: 'far',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V336H184c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V176h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 184z"]
};
var faToiletPaperCheck = {
  prefix: 'far',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", "M16.8 487.4c-1.9-8-.7-16.5 3.6-23.7l0-.1c3.8-7 7.3-14.2 10.5-21.6C63.6 366.5 64 269.6 64 192C64 86 107 0 160 0H492.1l0 .1c1.3-.1 2.5-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-17.8 0-33-6-45.3-14.3c3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1 .8c-9.4 68.1-23.7 111.3-33.3 134.5c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-1.5-2.7-2.6-5.5-3.3-8.4zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 42.3-.1 93.4-5.9 144.1C101.2 378.5 92 423.1 73.8 464H333.9c2.7 0 5.3-.8 7.3-2c1.7-1 3-2.4 3.8-4.5C357.7 427 384 345.2 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48H160zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-204.7-4.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L232 225.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faFilterCircleXmark = {
  prefix: 'far',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", "M0 41.7C0 18.7 18.7 0 41.7 0H469.9C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8L411.6 193.2c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48H55L218.6 248.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4L256.3 358c-.2 3.3-.3 6.6-.3 10c0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3V272.5L9.4 68C3.3 60.6 0 51.3 0 41.7zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faLocust = {
  prefix: 'far',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M304 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h24c94.6 0 173.9 65.7 194.7 154c-12.9-6.4-27.4-10-42.7-10H434.6l-45.5-83.5c-3.9-7.2-11.3-11.9-19.4-12.5s-16.1 3.1-20.9 9.7l-35 47.5-29.4-46.2c-4.2-6.6-11.3-10.7-19-11.1s-15.2 3-20.1 9.1L176.6 224H102.1C63.4 224 32 255.4 32 294.1c0 26.9 15.4 51.3 39.4 63.1L5.2 441.1c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l73.5-93.1 41.5 19-33.2 45c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1l42.5-57.6c11.8 2.3 23.9 3.4 36 3.4h33.4l-16.1 28.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9L330.5 416H441.2l25.4 50.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-15.2-30.3c46.2-6.9 81.6-46.7 81.7-94.7l0-.2V280C576 143 465 32 328 32H304zm61 164.6l15 27.4H344.8L365 196.6zm-103.1-3.2L281.4 224H237.7l24.2-30.6zM102.1 272h36.5L102 318.4l-9.1-4.2C85.1 310.7 80 302.8 80 294.1c0-12.2 9.9-22.1 22.1-22.1zm97.7 0H480c26.5 0 48 21.5 48 48s-21.5 48-48 48H456.5c-.2 0-.3 0-.5 0s-.3 0-.5 0H241.8c-20.7 0-41.1-4.4-59.9-13l-35-16 52.9-67zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSort = {
  prefix: 'far',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", "M70.6 176H249.4L160 86.6 70.6 176zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336L160 425.4 249.4 336H70.6zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
};
var faUnsorted = faSort;
var faListOl = {
  prefix: 'far',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM216 72H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faChartWaterfall = {
  prefix: 'far',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm120-72v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm72-88c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM480 88V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSparkle = {
  prefix: 'far',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", "M224 32c9.4 0 17.9 5.4 21.8 13.9l59.5 128.8 128.8 59.5c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8L305.3 337.3 245.8 466.1c-3.9 8.5-12.4 13.9-21.8 13.9s-17.9-5.4-21.8-13.9L142.7 337.3 13.9 277.8C5.4 273.9 0 265.4 0 256s5.4-17.9 13.9-21.8l128.8-59.5L202.2 45.9C206.1 37.4 214.6 32 224 32zm0 81.2l-41.4 89.6c-2.4 5.2-6.5 9.3-11.7 11.7L81.2 256l89.6 41.4c5.2 2.4 9.3 6.5 11.7 11.7L224 398.8l41.4-89.6c2.4-5.2 6.5-9.3 11.7-11.7L366.8 256l-89.6-41.4c-5.2-2.4-9.3-6.5-11.7-11.7L224 113.2z"]
};
var faFaceParty = {
  prefix: 'far',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M320 464c59 0 112.2-24.6 150.1-64h61.6C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176H560c-15.9 0-30.7 4.6-43.2 12.6C488.9 106.8 411.3 48 320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208zM204.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zm160 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM416 316c0 6.9-3.1 13.2-7.3 18.3c-.5 .6-1 1.1-1.5 1.7H592c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H407.2c.5 .6 1 1.1 1.5 1.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C378.7 427.1 361.4 432 344 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2z"]
};
var faKidneys = {
  prefix: 'far',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M165.8 0c-24 0-52.6 6.6-76.2 27.3C58.2 54.8 0 119.5 0 221.2c0 23 3.2 49.4 6.4 70.3c8.9 57.7 59.1 95.9 113.3 95.9c69.6 0 123.8-60.3 116.4-129.5l-.5-5.1 15.9 7.9c2.7 1.4 4.4 4.1 4.4 7.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-21.2-12-40.6-31-50.1l-31-15.5 16.4-17.4c18.7-19.8 29.1-46 29.1-73.3c0-36.7-18.9-70.9-50-90.4L232.5 18 219.8 38.2 232.5 18C213.8 6.2 192.1 0 170 0h-4.2zM121.2 63.4C133.8 52.4 150 48 165.8 48H170c13.1 0 25.9 3.7 37 10.6l5.2 3.2c17.1 10.7 27.5 29.5 27.5 49.7c0 15-5.7 29.4-16 40.3l-16.9 17.8c-16.1 17-23.9 40.2-21.4 63.4l3.2 29.8c4.3 40.8-27.7 76.4-68.7 76.4c-32.4 0-60.9-22.6-65.9-55.1c-3.1-20.2-5.9-43.7-5.9-63c0-82 46.8-134.6 73.2-157.8zm310.7-4.8C443 51.7 455.8 48 468.9 48h4.2c15.8 0 32 4.4 44.6 15.4c26.4 23.2 73.2 75.8 73.2 157.8c0 19.3-2.8 42.7-5.9 63c-5 32.5-33.5 55.1-65.9 55.1c-41.1 0-73.1-35.6-68.7-76.4l3.2-29.8c2.5-23.3-5.4-46.4-21.4-63.4l-16.9-17.8c-10.3-10.9-16-25.3-16-40.3c0-20.2 10.4-39 27.5-49.7l5.2-3.2zM468.9 0c-22.1 0-43.8 6.2-62.5 18l-5.2 3.2c-31.1 19.5-50 53.6-50 90.4c0 27.2 10.4 53.5 29.1 73.3l16.8 17.7L367 217.7c-19 9.5-31 28.9-31 50.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-3 1.7-5.8 4.4-7.2l14.8-7.4-.5 4.6c-7.4 69.2 46.9 129.5 116.4 129.5c54.3 0 104.5-38.1 113.3-95.9c3.2-20.9 6.4-47.3 6.4-70.3c0-101.7-58.2-166.3-89.6-193.9C525.8 6.6 497.2 0 473.2 0h-4.2z"]
};
var faWifiExclamation = {
  prefix: 'far',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", "M344 56V312c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24zM8.2 149.6C79.1 87.2 169 45.7 268.1 34.8C265.5 41.4 264 48.5 264 56V83.7c-85.3 11.2-162.6 47.8-224.1 102c-9.9 8.8-25.1 7.8-33.9-2.2s-7.8-25.1 2.2-33.9zM119.9 285.9c39.6-36.3 89.1-62 144.1-72.6v49.1c-42.4 9.8-80.6 30.4-111.6 58.9c-9.8 9-24.9 8.3-33.9-1.5s-8.3-24.9 1.5-33.9zM376 213.3c54.9 10.5 104.5 36.2 144.1 72.6c9.8 9 10.4 24.1 1.5 33.9s-24.1 10.4-33.9 1.5c-31-28.4-69.2-49.1-111.6-58.9V213.3zM376 424a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0-368c0-7.5-1.5-14.6-4.1-21.2c99.1 10.8 189 52.4 259.9 114.8c9.9 8.8 10.9 23.9 2.2 33.9s-23.9 10.9-33.9 2.2C538.6 131.5 461.3 94.9 376 83.7V56z"]
};
var faChartNetwork = {
  prefix: 'far',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M288 64c0 16.9-6.5 32.2-17.2 43.6l26.9 57.5c12.2-3.4 25-5.2 38.3-5.2c39 0 74.4 15.5 100.3 40.7l77.6-56.9c-1.3-5-1.9-10.3-1.9-15.7c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-12.3 0-23.9-3.5-33.7-9.6l-77.6 56.9c9.8 19.4 15.3 41.4 15.3 64.6c0 18.5-3.5 36.2-9.9 52.5l67.3 40.4c10.7-8.1 24.1-12.9 38.5-12.9c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-3.4 .3-6.7 .8-9.9l-67.4-40.4C419 428.5 379.8 448 336 448c-71.4 0-130.6-51.9-142-120H123.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40H194c6.6-39.1 28.9-72.9 60.2-94.5l-26.9-57.6c-1.1 .1-2.2 .1-3.3 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm48 336a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faPersonDressBurst = {
  prefix: 'far',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM587.1 299.8l-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8H544V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H464V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H389.8c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM526.7 336L480 186.5 433.3 336h93.4zM176 8c8.9 0 17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9L332.2 193l-31.7 56.1-32 8.6-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38-51.7 38c-7.2 5.3-16.6 6.1-24.6 2.3s-13.2-11.8-13.6-20.7l-2.5-64.2L21.6 241c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42L35.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8zm0 75.2l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2z"]
};
var faDiceD4 = {
  prefix: 'far',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", "M256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0zM58.2 307.8L232 439.7V92.1L58.2 307.8zM280 92.1V439.7L453.8 307.8 280 92.1z"]
};
var faMoneyCheckDollar = {
  prefix: 'far',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM280 272H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24zm-76-48v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faVectorSquare = {
  prefix: 'far',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", "M360 72h48v48H360V72zm-8-40c-17.7 0-32 14.3-32 32v8H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32h8l0 192H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32v-8H320v8c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32h-8V160h8c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM88 352l0-192h8c17.7 0 32-14.3 32-32v-8H320v8c0 17.7 14.3 32 32 32h8V352h-8c-17.7 0-32 14.3-32 32v8H128v-8c0-17.7-14.3-32-32-32H88zM40 440V392H88v48H40zm320 0V392h48v48H360zM40 120V72H88v48H40z"]
};
var faBreadSlice = {
  prefix: 'far',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M64 208c-8.8 0-16-7.2-16-16c0-34.5 24.6-62.3 74.9-83.9C171.8 87.2 229.2 80 256 80s84.2 7.2 133.1 28.1C439.4 129.7 464 157.5 464 192c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48V432H112V256c0-26.5-21.5-48-48-48zm384 96V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v48V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V304z"]
};
var faLanguage = {
  prefix: 'far',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H272h32 16H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H320 304 272 64zm512 48c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H320V112H576zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316H123.2l-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276h38zM456 164c-11 0-20 9-20 20v4H384c-11 0-20 9-20 20s9 20 20 20h72 35.1c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228h2c11 0 20-9 20-20s-9-20-20-20H520 476v-4c0-11-9-20-20-20z"]
};
var faWheatAwnSlash = {
  prefix: 'far',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", "M568.7 7.2c9.4 9.4 9.4 24.6 0 33.9L430.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L535 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c2.8 3.9 4.4 8.4 4.6 13L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L216.6 144.4l12.8-12.8c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L534.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM148.2 212.8L376.5 392.6c-3 .8-6 1.4-9 2c6.9 9.4 6 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3 0 0L105 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5 0 0-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l15-15zM325.5 103.3c-25 25-25 65.5 0 90.5L335.7 204c20.5-31 17.2-73.3-10.2-100.6zM223.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM382.1 250.4c25 25 65.5 25 90.5 0C445.2 223 403 219.7 371.9 240.2l10.1 10.1z"]
};
var faFaceKissWinkHeart = {
  prefix: 'far',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faDagger = {
  prefix: 'far',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M192 0c13.3 0 24 10.7 24 24V128h32 24 64c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48H272 224 192 160 112 96c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48h64 24 32V24c0-13.3 10.7-24 24-24zm32 397.9V208h48V397.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-4.5 6.4-11.8 10.2-19.7 10.2s-15.2-3.8-19.7-10.2L122.1 430c-6.6-9.4-10.1-20.6-10.1-32.1V208h48V397.9c0 1.6 .5 3.2 1.4 4.6L192 446.2l30.6-43.7c.9-1.3 1.4-2.9 1.4-4.6z"]
};
var faPodium = {
  prefix: 'far',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M168 72c-22.1 0-40 17.9-40 40v32H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H80V112c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-17.8 0-33.3-9.7-41.6-24H168zM73.5 455.2L47.3 224H95.6l25.7 225.8c.9 8.1 7.8 14.2 15.9 14.2H310.9c8.1 0 15-6.1 15.9-14.2L352.4 224h48.3L374.5 455.2c-3.7 32.3-31 56.8-63.6 56.8H137.1c-32.6 0-59.9-24.4-63.6-56.8z"]
};
var faMemoCircleCheck = {
  prefix: 'far',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M64 48H320c8.8 0 16 7.2 16 16V220.5c14.6-9.5 30.8-17 48-21.8V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c3.3 0 6.6-.3 9.7-.7c-17.9-12.8-33.3-28.8-45.3-47.3H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm456 48a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faRouteHighway = {
  prefix: 'far',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M236.3 3.4c-7.6-4.6-17.1-4.6-24.7 0L202.3 9c-37.5 22.5-83.6 25.1-123.3 7C60.3 7.6 38.2 14.7 28.1 32.5L7.4 68.7c-6.6 11.6-7 25.8-1 37.7l8.5 16.9C26.1 145.9 32 170.8 32 196.1c0 20.7-3.9 41.2-11.6 60.4L8.7 285.7C2.9 300 0 315.3 0 330.7c0 46.7 26.8 89.2 68.8 109.4l144.8 69.5c6.6 3.2 14.2 3.2 20.8 0l144.8-69.5c42.1-20.2 68.8-62.7 68.8-109.4c0-15.4-2.9-30.7-8.7-45.1l-11.7-29.2c-7.7-19.2-11.6-39.7-11.6-60.4c0-25.2 5.9-50.1 17.2-72.7l8.5-16.9c6-12 5.6-26.1-1-37.7L419.9 32.5c-10.2-17.8-32.2-24.9-50.9-16.4c-39.8 18.1-85.9 15.4-123.3-7l-9.4-5.6zM80 192H368c0 1.4 0 2.7 0 4.1c0 26.8 5.1 53.3 15.1 78.2l11.7 29.2c3.5 8.7 5.2 17.9 5.2 27.2c0 28.2-16.2 53.9-41.6 66.1L224 461.4 89.6 396.9C64.2 384.7 48 359 48 330.7c0-9.3 1.8-18.6 5.2-27.2l11.7-29.2c10-24.9 15.1-51.4 15.1-78.2c0-1.4 0-2.7 0-4.1z"]
};
var faDownToLine = {
  prefix: 'far',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M82.2 224L192 334 301.8 224H248c-13.3 0-24-10.7-24-24V80H160V200c0 13.3-10.7 24-24 24H82.2zM192 384c-11.5 0-22.5-4.6-30.6-12.7L45.6 255.2C36.9 246.5 32 234.7 32 222.4C32 196.8 52.8 176 78.4 176H112V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L222.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 432H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faArrowAltToBottom = faDownToLine;
var faFilter = {
  prefix: 'far',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M0 73.7C0 50.7 18.7 32 41.7 32H470.3c23 0 41.7 18.7 41.7 41.7c0 9.6-3.3 18.9-9.4 26.3L336 304.5V447.7c0 17.8-14.5 32.3-32.3 32.3c-7.3 0-14.4-2.5-20.1-7l-92.5-73.4c-9.6-7.6-15.1-19.1-15.1-31.3V304.5L9.4 100C3.3 92.6 0 83.3 0 73.7zM55 80L218.6 280.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4l64 50.8V296c0-5.5 1.9-10.9 5.4-15.2L457 80H55z"]
};
var faSquareG = {
  prefix: 'far',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM144 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z"]
};
var faCirclePhone = {
  prefix: 'far',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.7 128.7l-44 12C134 143.1 128 151 128 160c0 123.7 100.3 224 224 224c9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L280.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48c-3.9-9.3-14-14.2-23.7-11.6z"]
};
var faPhoneCircle = faCirclePhone;
var faClipboardPrescription = {
  prefix: 'far',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 204c-11 0-20 9-20 20v80 64c0 11 9 20 20 20s20-9 20-20V324h35.7l52 52-25.9 25.9c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0L240 404.3l25.9 25.9c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3L268.3 376l25.9-25.9c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L240 347.7l-32.6-32.6C224.6 304.6 236 285.6 236 264c0-33.1-26.9-60-60-60H104zm72 80h-8H124V244h52c11 0 20 9 20 20s-9 20-20 20z"]
};
var faUserNurseHair = {
  prefix: 'far',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M96 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96V70.2zM304 160h-8c-20.5 0-38.7-9.6-50.4-24.5C231.9 159.7 205.8 176 176 176l-32 0c0 44.2 35.8 80 80 80s80-35.8 80-80V160zM49.3 461.9H398.7c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7H30.7c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]
};
var faQuestion = {
  prefix: 'far',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M64 160c0-44.2 35.8-80 80-80h32c44.2 0 80 35.8 80 80v4.6c0 24.1-12 46.6-32.1 59.9l-52.3 34.9C149.4 274.2 136 299.2 136 326v2c0 13.3 10.7 24 24 24s24-10.7 24-24v-2c0-10.7 5.3-20.7 14.2-26.6l52.3-34.9c33.4-22.3 53.4-59.7 53.4-99.8V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 13.3 10.7 24 24 24s24-10.7 24-24zm96 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFileSignature = {
  prefix: 'far',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M64 464H320c8.8 0 16-7.2 16-16v-6.7l39.8-9.9c2.8-.7 5.6-1.6 8.2-2.7V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v49.1l-48 48V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zm96-115l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h25.6l12-48.2c1.4-5.6 4.3-10.8 8.4-14.9L441.1 191.8l71 71L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-1.1 .3-2.1 .4-3.2 .5c-.8 .1-1.5 .2-2.3 .2H256c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L160 349zM549.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0z"]
};
var faToggleLargeOn = {
  prefix: 'far',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288z"]
};
var faUpDownLeftRight = {
  prefix: 'far',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", "M256 55.8L289.5 96h-67L256 55.8zM229.8 12.3L168.2 86.2c-5.3 6.3-8.2 14.3-8.2 22.6c0 19.5 15.8 35.2 35.2 35.2H232v88H144V195.2c0-19.5-15.8-35.2-35.2-35.2c-8.2 0-16.2 2.9-22.6 8.2L12.3 229.8C4.5 236.2 0 245.9 0 256s4.5 19.8 12.3 26.2l73.9 61.6c6.3 5.3 14.3 8.2 22.6 8.2c19.5 0 35.2-15.8 35.2-35.2V280h88v88H195.2c-19.5 0-35.2 15.8-35.2 35.2c0 8.2 2.9 16.2 8.2 22.6l61.6 73.9c6.5 7.8 16.1 12.3 26.2 12.3s19.8-4.5 26.2-12.3l61.6-73.9c5.3-6.3 8.2-14.3 8.2-22.6c0-19.5-15.8-35.2-35.2-35.2H280V280h88v36.8c0 19.5 15.8 35.2 35.2 35.2c8.2 0 16.2-2.9 22.6-8.2l73.9-61.6c7.8-6.5 12.3-16.1 12.3-26.2s-4.5-19.8-12.3-26.2l-73.9-61.6c-6.3-5.3-14.3-8.2-22.6-8.2c-19.5 0-35.2 15.8-35.2 35.2V232H280V144h36.8c19.5 0 35.2-15.8 35.2-35.2c0-8.2-2.9-16.2-8.2-22.6L282.2 12.3C275.8 4.5 266.1 0 256 0s-19.8 4.5-26.2 12.3zM256 456.2L222.5 416h67L256 456.2zM456.2 256L416 289.5v-67L456.2 256zM96 289.5L55.8 256 96 222.5v67z"]
};
var faArrowsAlt = faUpDownLeftRight;
var faDryerHeat = {
  prefix: 'far',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM80 288a144 144 0 1 1 288 0A144 144 0 1 1 80 288zm107.3-83.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L177.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7zm80 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L257.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7z"]
};
var faDryerAlt = faDryerHeat;
var faHouseChimneyUser = {
  prefix: 'far',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v85.9L303.5 5.7zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32zM288 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM176 400c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256c-44.2 0-80 35.8-80 80z"]
};
var faHandHoldingHeart = {
  prefix: 'far',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H387.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H344 320 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"]
};
var faArrowUpSmallBig = {
  prefix: 'far',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", "M368 144V80h64v64H368zm-48 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v64zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zM368 304H496V432H368V304zm-48 0V432c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faSortSizeUpAlt = faArrowUpSmallBig;
var faTrainTrack = {
  prefix: 'far',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", "M222.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5L160.1 96H112c-13.3 0-24 10.7-24 24s10.7 24 24 24h30.8L114 224H72c-13.3 0-24 10.7-24 24s10.7 24 24 24H96.7L67.9 352H32c-13.3 0-24 10.7-24 24s10.7 24 24 24H50.7L33.4 447.9c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5L101.7 400H474.3l23.1 64.1c4.5 12.5 18.2 18.9 30.7 14.5s18.9-18.2 14.5-30.7L525.3 400H544c13.3 0 24-10.7 24-24s-10.7-24-24-24H508.1l-28.8-80H504c13.3 0 24-10.7 24-24s-10.7-24-24-24H462l-28.8-80H464c13.3 0 24-10.7 24-24s-10.7-24-24-24H415.9L398.6 47.9c-4.5-12.5-18.2-18.9-30.7-14.5s-18.9 18.2-14.5 30.7L364.9 96H211.1l11.5-31.9zM193.8 144H382.2L411 224H165l28.8-80zM457.1 352H118.9l28.8-80H428.3l28.8 80z"]
};
var faPuzzlePiece = {
  prefix: 'far',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M201.1 57.3C194.1 62.5 192 68 192 72c0 4.2 2.4 10.1 10.4 15.6c7.8 5.3 13.6 14.6 13.6 25.6c0 17-13.8 30.7-30.7 30.7H56c-4.4 0-8 3.6-8 8v52.5c7.4-2.9 15.5-4.5 24-4.5c43.1 0 72 39.4 72 80s-28.9 80-72 80c-8.5 0-16.6-1.6-24-4.5V456c0 4.4 3.6 8 8 8H156.5c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H360c4.4 0 8-3.6 8-8V326.7c0-17 13.8-30.7 30.7-30.7c11.1 0 20.3 5.8 25.6 13.6c5.5 8 11.4 10.4 15.6 10.4c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-4.2 0-10.1 2.4-15.6 10.4c-5.3 7.8-14.6 13.6-25.6 13.6c-17 0-30.7-13.8-30.7-30.7V152c0-4.4-3.6-8-8-8H278.7c-17 0-30.7-13.8-30.7-30.7c0-11.1 5.8-20.3 13.6-25.6c8-5.5 10.4-11.4 10.4-15.6c0-4-2.1-9.5-9.1-14.7S245 48 232 48s-23.8 4-30.9 9.3zM172.3 18.9C188.5 6.8 209.6 0 232 0s43.5 6.8 59.7 18.9S320 49.5 320 72c0 8.6-1.8 16.7-4.9 24H360c30.9 0 56 25.1 56 56v44.9c7.3-3.1 15.4-4.9 24-4.9c22.5 0 41 12.2 53.1 28.3S512 257.6 512 280s-6.8 43.5-18.9 59.7S462.5 368 440 368c-8.6 0-16.7-1.8-24-4.9V456c0 30.9-25.1 56-56 56H281.9c-18.7 0-33.9-15.2-33.9-33.9c0-10.1 4.5-18.5 9.9-24.2c4.2-4.3 6.1-9.2 6.1-13.9c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9c5.5 5.7 9.9 14.1 9.9 24.2c0 18.7-15.2 33.9-33.9 33.9H56c-30.9 0-56-25.1-56-56V329.9C0 311.2 15.2 296 33.9 296c10.1 0 18.5 4.5 24.2 9.9c4.3 4.2 9.2 6.1 13.9 6.1c9.9 0 24-10.7 24-32s-14.1-32-24-32c-4.7 0-9.5 1.9-13.9 6.1C52.4 259.5 44 264 33.9 264C15.2 264 0 248.8 0 230.1V152c0-30.9 25.1-56 56-56h92.9c-3.1-7.3-4.9-15.4-4.9-24c0-22.5 12.2-41 28.3-53.1z"]
};
var faMoneyCheck = {
  prefix: 'far',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm120 80H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 328c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"]
};
var faStarHalfStroke = {
  prefix: 'far',
  iconName: 'star-half-stroke',
  icon: [640, 512, ["star-half-alt"], "f5c0", "M341.5 13.5C337.5 5.2 329.1 0 319.9 0s-17.6 5.2-21.6 13.5L229.7 154.8 76.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L174.2 328.4 148 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L465.6 328.4 576.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L410.1 154.8 341.5 13.5zM320 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L423 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L331.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"]
};
var faStarHalfAlt = faStarHalfStroke;
var faFileExclamation = {
  prefix: 'far',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM192 176c-13.3 0-24 10.7-24 24V312c0 13.3 10.7 24 24 24s24-10.7 24-24V200c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCode = {
  prefix: 'far',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256 168.4 153.5c9.7-9.1 10.2-24.3 1.1-33.9z"]
};
var faWhiskeyGlass = {
  prefix: 'far',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", "M80.8 288H431.2L461.5 80H50.5L80.8 288zm7 48l10 68.6c2.3 15.7 15.8 27.4 31.7 27.4h253c15.9 0 29.4-11.7 31.7-27.4l10-68.6H87.8zM7.8 43.1C13.9 36 22.7 32 32 32H480c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z"]
};
var faGlassWhiskey = faWhiskeyGlass;
var faMoonStars = {
  prefix: 'far',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M295.8 137.8c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11 11 38.6zM403.8 310.8c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM48 320c0-70 50-128.3 116.2-141.3C141.6 206.3 128 241.5 128 280c0 83.2 63.5 151.6 144.7 159.3c-23 15.6-50.8 24.7-80.7 24.7c-79.5 0-144-64.5-144-144zM192 128C86 128 0 214 0 320S86 512 192 512c69.4 0 130.2-36.9 163.9-92c5.3-8.7 4.6-19.9-2-27.8s-17.3-10.8-26.9-7.2c-12.1 4.5-25.3 7-39.1 7c-61.9 0-112-50.1-112-112c0-45 26.6-83.9 65-101.7c9.3-4.3 14.8-14 13.8-24.2s-8.4-18.6-18.3-20.9c-14.3-3.4-29.2-5.2-44.4-5.2z"]
};
var faBuildingCircleExclamation = {
  prefix: 'far',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", "M64 48H320c8.8 0 16 7.2 16 16V294.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1V448c0 8.8-7.2 16-16 16H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H232zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faClothesHanger = {
  prefix: 'far',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", "M211.4 91.3C221 38.4 267 0 320.8 0C382.2 0 432 49.8 432 111.2v2.9c0 36.5-17.5 70.8-47 92.3l-23.2 16.9L611 391.7c18.1 12.2 29 32.7 29 54.5c0 36.3-29.5 65.8-65.8 65.8H65.8C29.5 512 0 482.5 0 446.2c0-21.9 10.9-42.3 29-54.5L306.2 204.3l50.6-36.8c17.1-12.4 27.2-32.3 27.2-53.5v-2.9C384 76.3 355.7 48 320.8 48c-30.6 0-56.7 21.8-62.2 51.9l-3 16.4c-2.4 13-14.9 21.7-27.9 19.3s-21.7-14.9-19.3-27.9l3-16.4zM320 253L55.8 431.5c-4.9 3.3-7.8 8.8-7.8 14.7C48 456 56 464 65.8 464H574.2c9.8 0 17.8-8 17.8-17.8c0-5.9-2.9-11.4-7.8-14.7L320 253z"]
};
var faMobileNotch = {
  prefix: 'far',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M256 48V64c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V48H96C78.3 48 64 62.3 64 80V432c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H256zM16 80C16 35.8 51.8 0 96 0H288c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80V80z"]
};
var faMobileIphone = faMobileNotch;
var faMagnifyingGlassChart = {
  prefix: 'far',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM104 216v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faArrowUpRightFromSquare = {
  prefix: 'far',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
};
var faExternalLink = faArrowUpRightFromSquare;
var faCubesStacked = {
  prefix: 'far',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", "M240 80v32h32V80H240zM224 32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM136.5 268.2l27.7-16-16-27.7-27.7 16 16 27.7zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM304 272h32V240H304v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V224zM368 432h32V400H368v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384zM208 400v32h32V400H208zm-16-48h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32zM48 432H80V400H48v32zM0 384c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384z"]
};
var faImagesUser = {
  prefix: 'far',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M512 80H160c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16h64c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h64c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16zM160 32H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24V344c0 48.6 39.4 88 88 88H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 480 0 419.1 0 344V120c0-13.3 10.7-24 24-24zm248 80a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faWonSign = {
  prefix: 'far',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", "M71.1 49.5C67.5 36.8 54.3 29.3 41.5 32.9S21.3 49.7 24.9 62.5L79.1 256H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H92.5l44.4 158.5c2.9 10.5 12.6 17.7 23.6 17.5s20.3-7.8 22.9-18.4L221.2 304h69.7l37.8 157.6c2.6 10.6 12 18.2 22.9 18.4s20.6-7 23.6-17.5L419.5 304H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H432.9L487.1 62.5c3.6-12.8-3.9-26-16.6-29.6s-26 3.9-29.6 16.6L383.1 256H328.7L279.3 50.4C276.7 39.6 267.1 32 256 32s-20.7 7.6-23.3 18.4L183.3 256H128.9L71.1 49.5zM142.4 304h29.4l-13.6 56.6L142.4 304zm90.3-48L256 158.8 279.3 256H232.7zm107.5 48h29.4l-15.9 56.6L340.2 304z"]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faImagePolaroidUser = {
  prefix: 'far',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M48 416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V368H48v48zm286-96h66V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V320h66c7.1-27.6 32.2-48 62-48h96c29.8 0 54.9 20.4 62 48zM448 96V320v24 24 48c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V368 344 320 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64zM160 176a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faVirusCovid = {
  prefix: 'far',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M216 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L125.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L46.7 103.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L92 125.9l23.8 23.8C97.9 173.2 85.8 201.3 81.6 232H48V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280H81.6c4.2 30.7 16.3 58.8 34.1 82.3L92 386.1 80.6 374.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L125.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V430.4c30.7-4.2 58.8-16.3 82.3-34.1L386.1 420l-11.3 11.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L420 386.1l-23.8-23.8c17.9-23.5 29.9-51.7 34.1-82.3H464v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H430.4c-4.2-30.7-16.3-58.8-34.1-82.3L420 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L408.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L386.1 92l-23.8 23.8C338.8 97.9 310.7 85.8 280 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H216zm40 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareEllipsis = {
  prefix: 'far',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faPie = {
  prefix: 'far',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M544 240c-7.6 0-14.3-4.9-17-12C490 132.1 397 64 288 64S86 132.1 49 228c-2.7 7.1-9.4 12-17 12c-17.7 0-32 14.3-32 32c0 17.2 13.6 31.3 30.7 32c17.7-.5 35-7 48.7-14.2c7-3.6 12.7-7.3 16.7-10c2-1.4 3.5-2.5 4.5-3.2c.5-.4 .9-.7 1.1-.8l.2-.2 0 0 20.7 .4 0 0 .2 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c6.1-5.4 15.2-5.4 21.2 0l0 0 .1 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c5.9-5.2 14.6-5.4 20.7-.4l0 0 0 0 0 0 0 0 0 0 0 0 .2 .2c.2 .2 .6 .5 1.1 .8c1 .7 2.5 1.9 4.5 3.2c4 2.7 9.7 6.4 16.7 10c13.7 7.2 31.1 13.7 48.7 14.2c17.1-.7 30.7-14.7 30.7-32c0-17.7-14.3-32-32-32zM122.6 276c-5.9-5.2-14.6-5.4-20.7-.4l0 0 20.7 .4s0 0 0 0zM81.4 404.2c8.7 26.1 33.2 43.8 60.7 43.8H433.9c27.5 0 52-17.6 60.7-43.8l24-71.9c-14.2-3.5-26.8-9-36.8-14.2c-2.7-1.4-5.3-2.8-7.6-4.2l-25 75.1c-2.2 6.5-8.3 10.9-15.2 10.9H142.1c-6.9 0-13-4.4-15.2-10.9l-25-75.1c-2.4 1.4-4.9 2.8-7.6 4.2c-10 5.2-22.7 10.7-36.8 14.2l24 71.9zM206.3 151.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessKnightPiece = {
  prefix: 'far',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", "M68.9 112l79.8 0C216.8 112 272 167.2 272 235.3c0 11.3-1.6 22.5-4.6 33.4L243.9 352h49.9l19.8-70.3c4.3-15.1 6.4-30.7 6.4-46.4C320 140.7 243.3 64 148.7 64L40.8 64C18.5 64 .4 82.1 .4 104.5c0 11.6 5 22.5 13.3 30C5 148.3 .3 164.4 .3 181L.1 232C0 253.2 8 273.7 22.4 289.2l1.9 2c6.5 7 14 12.6 22 16.8c-8.3 13-13.1 28.2-13.8 43.9H80.5c1.1-11.5 7-22 16.2-29l25.1-15.4c2.7-1.4 5.3-3 7.8-4.8l42.9-26.3c11.3-6.9 14.8-21.7 7.9-33s-21.7-14.8-33-7.9l-42.7 26.2-.1-.2c-.5 .4-1 .8-1.5 1.2l-4.9 3c-12.8 6.4-28.7 3.8-38.8-7.1l-1.9-2c-6.2-6.6-9.6-15.4-9.5-24.4l.2-51c0-10.6 4.2-20.7 11.7-28.1l8-8c5.5-5.5 8-13.2 6.7-20.8c-.7-4.6-2.8-8.8-5.8-12.2zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM52.7 464l16.6-32H250.8l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H279.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"]
};
var faChessKnightAlt = faChessKnightPiece;
var faAustralSign = {
  prefix: 'far',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M246.1 46.7C242.4 37.8 233.7 32 224 32s-18.4 5.8-22.1 14.7L127.4 224H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h83.2L87.1 320H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H66.9L33.9 446.7c-5.1 12.2 .6 26.3 12.8 31.4s26.3-.6 31.4-12.8L119 368H329l40.9 97.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4L381.1 368H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H360.9l-20.2-48H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H320.6L246.1 46.7zM268.5 224H179.5L224 118l44.5 106zM159.3 272H288.7l20.2 48H139.2l20.2-48z"]
};
var faCloudPlus = {
  prefix: 'far',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H232c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faF = {
  prefix: 'far',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M56 32C25.1 32 0 57.1 0 88V248 456c0 13.3 10.7 24 24 24s24-10.7 24-24V272H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V88c0-4.4 3.6-8 8-8H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H56z"]
};
var faLeaf = {
  prefix: 'far',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M149.6 234.4c20.9-6.7 43.2-10.4 66.4-10.4h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400h.1l.8 0 .1 0C370.2 399.5 464 299.7 464 156.6c0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144l-104 0c-57.6 0-106.3 38.1-122.4 90.4zM96.4 260.1C102.5 168.5 178.8 96 272 96l104 0c28.7 0 54.8-10.8 74.6-28.5c.7-.6 1.4-1.3 2.1-1.9c6.6-6.2 12.5-13.2 17.4-20.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6c2.9 8.9 5.5 17.9 7.8 27.2c.5 1.9 .9 3.8 1.3 5.6c5.4 24.3 8.3 49.8 8.3 76.2C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-75.1 38.3-141.2 96.4-179.9z"]
};
var faBedBunk = {
  prefix: 'far',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", "M24 0C37.3 0 48 10.7 48 24V160H256V40c0-22.1 17.9-40 40-40H456c66.3 0 120 53.7 120 120v64 96V439.7 488c0 13.3-10.7 24-24 24s-24-10.7-24-24V463.7H280 48V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V439.7 184 24C0 10.7 10.7 0 24 0zM256 415.7V296c0-22.1 17.9-40 40-40H528V208H280 48V415.7H256zM528 160V120c0-39.8-32.2-72-72-72H304V160H528zm0 144H304V415.7H528V304zM96 328a56 56 0 1 1 112 0A56 56 0 1 1 96 328zM152 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faRoad = {
  prefix: 'far',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", "M185.7 32c-30.4 0-57.5 19-67.7 47.6L8.6 383.6C-8.3 430.5 26.4 480 76.3 480H499.7c49.9 0 84.6-49.5 67.7-96.4L458 79.6C447.7 51 420.6 32 390.3 32H185.7zM163.2 95.9c3.4-9.5 12.5-15.9 22.6-15.9H264v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l109.4 304c5.6 15.6-6 32.1-22.6 32.1H312V408c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H76.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304zM312 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V216z"]
};
var faTaxi = {
  prefix: 'far',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-35.2 2.2-65.9 25.2-77.7 58.8L48.1 220.8C19.3 237.4 0 268.4 0 304v80 48 56c0 13.3 10.7 24 24 24s24-10.7 24-24V432H464v56c0 13.3 10.7 24 24 24s24-10.7 24-24V432 384 304c0-35.6-19.4-66.6-48.1-83.2l-34.3-97.9C417.9 89.3 387.2 66.3 352 64.2c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 112H346.6c17 0 32.1 10.7 37.8 26.8L408.6 208H103.4l24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM96 256H416c26.5 0 48 21.5 48 48v80H48V304c0-26.5 21.5-48 48-48zm48 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCab = faTaxi;
var faPersonCirclePlus = {
  prefix: 'far',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1H146.3c-.8 0-1.5 0-2.3 .1zM144 352V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faChartPie = {
  prefix: 'far',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M493.1 192H352V50.9C423.5 64 480 120.5 493.1 192zM352 240H527.4c9 0 16.6-7 16.6-16C544 100.3 443.7 0 320 0c-9 0-16 7.6-16 16.6V192v48h48zM222.1 321.9L348.4 448.2C325 458.4 299.2 464 272 464C166 464 80 378 80 272c0-83.6 53.4-154.7 128-181.1V288c0 12.7 5.1 24.9 14.1 33.9zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288V49.6c0-9.2-7.8-16.6-17-15.4zM558.4 288H320L478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3c1.3-9.2-6.1-17-15.4-17z"]
};
var faPieChart = faChartPie;
var faBoltLightning = {
  prefix: 'far',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M77 48L51.4 240H208c7.4 0 14.4 3.4 18.9 9.2s6.2 13.4 4.4 20.6l-23 91.8L322.8 192H176c-7.9 0-15.3-3.9-19.8-10.4s-5.4-14.9-2.6-22.2L196.9 48H77zM30.4 34.7C33 14.8 50 0 70 0H208.6c28.1 0 47.5 28.3 37.3 54.5L211.1 144H337.9c32.1 0 51.1 35.8 33.2 62.4l-199.2 295c-6.5 9.7-19 13.2-29.7 8.5s-16.3-16.4-13.5-27.7L177.3 288H42.3C18.1 288-.6 266.7 2.6 242.7l27.7-208z"]
};
var faClockEight = {
  prefix: 'far',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSackXmark = {
  prefix: 'far',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M293.3 152H218.7l-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48c0-139-102.9-220.6-156.9-255.2L293.3 152zm.2-58.8L324.6 48H187.4l31.1 45.2L226 104h60l7.5-10.8zM0 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 121.9 37.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96zM209 239l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faFileExcel = {
  prefix: 'far',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"]
};
var faFileContract = {
  prefix: 'far',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm54.2 221.8L160 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l10.6-21.3c.6-1.2 1.8-1.9 3.1-1.9s2.5 .7 3.1 1.9l10.6 21.3c2.7 5.4 8.3 8.8 14.3 8.8h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H257.9l-6.2-12.4c-6-12-18.3-19.6-31.7-19.6c-8.6 0-16.8 3.1-23.1 8.6l-11.3-37.5C182.2 311.7 171.8 304 160 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z"]
};
var faFishFins = {
  prefix: 'far',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M247.3 166c-13.1 6.7-25.4 14.5-36.5 22.8c-10.2 7.6-19.5 15.8-27.9 24c-14.2 13.9-35.5 17.6-53.6 9.3L70.6 195.3l21.1 36.9c8.4 14.8 8.4 32.9 0 47.6L70.6 316.7l58.7-26.9c18.1-8.3 39.4-4.6 53.6 9.3c8.4 8.3 17.8 16.4 27.9 24c11.2 8.4 23.5 16.3 36.8 23c16.7 8.4 27 25.8 26.3 44.4l-.8 23.6 46.2-36.3c7.7-6.1 17.2-9.6 27-10.2c44.7-2.5 83.7-21 114.9-44.5c29.4-22.1 51.3-48 64-67.2c-12.7-19.2-34.6-45.1-64-67.2c-31.3-23.5-70.2-42-114.9-44.5c-9.8-.5-19.2-4.1-27-10.2L272.9 97.6l.6 24.3c.5 18.5-9.7 35.7-26.3 44.1zM8.4 373.6C-1 363.3-2.7 348.2 4.2 336.1L50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l103.9 47.6c9.8-9.6 20.8-19.2 32.7-28.1c13.1-9.8 27.7-19.2 43.6-27.2L224 64.9c-.3-12.4 6.5-23.9 17.6-29.4s24.4-4.2 34.1 3.4L349 96.4c56.6 3.2 104.5 26.6 141.1 54c39.2 29.4 67.2 64.7 81.6 89.5c5.8 9.9 5.8 22.2 0 32.1c-14.4 24.8-42.5 60.1-81.6 89.5c-36.6 27.5-84.5 50.9-141.1 54l-73.2 57.5c-9.8 7.7-23.1 9-34.2 3.4s-17.9-17.2-17.5-29.6l1.9-57.9c-16.1-8.1-30.8-17.5-44-27.4c-12-9-22.9-18.5-32.7-28.1L45.3 381.1c-12.6 5.8-27.6 2.8-36.9-7.5zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleQ = {
  prefix: 'far',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1c-44.2 0-80-35.8-80-80zm208 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L343 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-15.1-15.1c14-20.5 22.1-45.3 22.1-71.9z"]
};
var faBuildingFlag = {
  prefix: 'far',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16zM448 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H480V512H416V32c0-17.7 14.3-32 32-32z"]
};
var faFaceGrinBeam = {
  prefix: 'far',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
  prefix: 'far',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5c0-.1 0-.1 0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3V228.7C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H324.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V123.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H123.3C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3V228.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V123.3c16-6.5 28.9-19.3 35.3-35.3H324.7zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40h45.4c6.5 16 19.3 28.9 35.3 35.3V388.7c-16 6.5-28.9 19.3-35.3 35.3H315.3c-6.5-16-19.3-28.9-35.3-35.3V352H232v36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H516.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V283.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H448v16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm301.5 13c-7.5-1.3-13.2-7.9-13.2-15.8c0-8.8 7.2-16 16-16c7.9 0 14.5 5.7 15.8 13.2l0 .1c.1 .9 .2 1.8 .2 2.7c0 8.8-7.2 16-16 16c-.9 0-1.9-.1-2.8-.2z"]
};
var faFaceDisguise = {
  prefix: 'far',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-16.5 1.9-32.6 5.6-48H72c0 50.1 38.4 91.2 87.3 95.6c-9.6 7.9-15.3 19.7-15.3 32.4c0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4 .7 4.8 1.3 7.2 1.8V432c0 8.8 7.2 16 16 16s16-7.2 16-16V406.8c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6L339.5 418c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4c49-4.4 87.3-45.5 87.3-95.6h18.4c3.6 15.4 5.6 31.5 5.6 48zM218 229.5l-21.4 35.7c-1.1 .6-1.9 1-2.6 1.3c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 2.5-.1 4.9-.4 7.3c-5.4 3.6-10.1 8.4-13.5 14.1zM280 208c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-.6-.3-1.5-.7-2.6-1.3L294 229.5c-3.5-5.8-8.1-10.6-13.5-14.1c-.3-2.4-.4-4.9-.4-7.3zm219.4-31.6C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1c3.3-2.9 5.3-7.2 5.3-11.9c0-7.7-5.4-14.1-12.6-15.6zM63.9 176c6.4-15.3 14.5-29.7 24.2-42.9c-.6 4.5 .2 9.3 2.4 13.6l1.4 2.7c-6.1 8-11 16.9-14.4 26.5H63.9zm384.1 0H434.5c-3.4-9.6-8.3-18.6-14.4-26.5l1.4-2.7c2.2-4.4 2.9-9.1 2.4-13.6c9.7 13.2 17.8 27.6 24.2 42.9zM104.9 113.1C142.8 73 196.5 48 256 48s113.2 25 151.1 65.1c-9-2.8-18.7 0-24.9 6.8c-2-.9-4.1-1.7-6.2-2.4V112c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.3c-1.5 .2-2.9 .5-4.4 .8c-6.7-9.6-19.6-13-30.3-7.6s-15.7 17.8-12.1 28.9c-10.7 9.3-19.4 21-25.2 34.2c-5.8-13.2-14.4-24.9-25.2-34.2c3.6-11.1-1.3-23.5-12.1-28.9s-23.6-1.9-30.4 7.6c-1.4-.3-2.9-.6-4.4-.8V112c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.5c-2.1 .7-4.2 1.6-6.2 2.4c-6.2-6.9-16-9.6-24.9-6.8zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4L245.5 246c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleArrowDownRight = {
  prefix: 'far',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM192 368H344c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V286.1L185 151c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l135 135H192c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faAlien8bit = {
  prefix: 'far',
  iconName: 'alien-8bit',
  icon: [640, 512, [128126, "alien-monster"], "f8f6", "M152 32c13.3 0 24 10.7 24 24h24c13.3 0 24 10.7 24 24v48H416V80c0-13.3 10.7-24 24-24h24c0-13.3 10.7-24 24-24s24 10.7 24 24V80c0 13.3-10.7 24-24 24H464v48 8h24c13.3 0 24 10.7 24 24v56h8 40V152c0-13.3 10.7-24 24-24s24 10.7 24 24V264c0 13.3-10.7 24-24 24H544v72c0 13.3-10.7 24-24 24H480v72c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V384H208v48h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V384H120c-13.3 0-24-10.7-24-24V288H56c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24v88h40 8V184c0-13.3 10.7-24 24-24h24v-8V104H152c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm72 144v8c0 13.3-10.7 24-24 24H176v56c0 13.3-10.7 24-24 24h-8v48h40H456h40V288h-8c-13.3 0-24-10.7-24-24V208H440c-13.3 0-24-10.7-24-24v-8H224zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240zm144-16h32c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16z"]
};
var faAlienMonster = faAlien8bit;
var faHandPointRibbon = {
  prefix: 'far',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M112 48c8.8 0 16 7.2 16 16V80H96V64c0-8.8 7.2-16 16-16zm64 32V64c0-35.3-28.7-64-64-64S48 28.7 48 64V80H11.8C5.3 80 0 85.3 0 91.8c0 3.9 1.9 7.5 5.1 9.7L43.6 128 5.1 154.5c-3.2 2.2-5.1 5.8-5.1 9.7C0 170.7 5.3 176 11.8 176H48v96c-10 13.4-16 30-16 48v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V320 256c0-35.3-28.7-64-64-64c-11 0-21.3 2.8-30.3 7.6C309.9 185.2 292 176 272 176c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36V96c0-8.8-7.2-16-16-16zm-48 96v32 32H112c-5.5 0-10.8 .6-16 1.6V176h32zm24 112h40c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c11 0 21.3-2.8 30.3-7.6C314.1 374.8 332 384 352 384c3.2 0 6.3-.2 9.4-.7C345.1 430.3 300.5 464 248 464H200c-66.3 0-120-53.7-120-120V320v0c0-17.7 14.3-32 32-32h40zm200-48c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 256c0-8.8 7.2-16 16-16zm-144 2c-5.1-1.3-10.5-2-16-2H176V208c0-8.8 7.2-16 16-16s16 7.2 16 16v32 2zm48-2c0-8.8 7.2-16 16-16s16 7.2 16 16v16 48c0 8.8-7.2 16-16 16s-16-7.2-16-16V264 240z"]
};
var faPoop = {
  prefix: 'far',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M201.8 14.8C205.5 5.8 214.3 0 224 0h8c71.6 0 131.6 49.5 147.7 116.1C410.8 133 432 166 432 204c0 1.1 0 2.2-.1 3.3c33 14 56.1 46.6 56.1 84.7c0 14.3-3.3 27.8-9.1 39.9c20.3 19 33.1 46 33.1 76.1c0 57.4-46.6 104-104 104H104C46.6 512 0 465.4 0 408c0-30.1 12.8-57.1 33.1-76.1C27.3 319.8 24 306.3 24 292c0-38.1 23.1-70.7 56.1-84.7c0-1.1-.1-2.2-.1-3.3c0-48.1 33.9-88.2 79.1-97.8c5.7-1.4 11.7-2.2 17.8-2.2H180h14.7c16.2 0 29.3-13.1 29.3-29.3V71.4c0-8.6-3.4-16.9-9.5-23L207 41c-6.9-6.9-8.9-17.2-5.2-26.2zm68.5 40.5c1.1 5.3 1.6 10.7 1.6 16.1v3.2c0 42.7-34.6 77.3-77.3 77.3H180h-3.1c-2.2 0-4.3 .3-6.3 .8c-.4 .1-.8 .2-1.2 .3C145.8 158 128 178.9 128 204c0 4.9 .7 9.7 1.9 14.1c1.9 6.7 .8 13.9-3 19.7s-10 9.7-16.9 10.6c-21.5 2.9-38 21.3-38 43.6c0 11.4 4.3 21.8 11.4 29.6c5 5.4 7.1 12.9 5.9 20.1s-5.7 13.6-12.2 17.1C59.7 368.3 48 386.8 48 408c0 30.9 25.1 56 56 56H408c30.9 0 56-25.1 56-56c0-21.2-11.8-39.7-29.2-49.2c-6.5-3.5-10.9-9.8-12.2-17.1s1-14.7 5.9-20.1c7.1-7.8 11.4-18.2 11.4-29.6c0-22.3-16.6-40.7-38-43.6c-6.9-.9-13-4.8-16.9-10.6s-4.9-13-3-19.7c1.3-4.5 1.9-9.2 1.9-14.1c0-22.3-14-41.4-33.8-48.7c-8.2-3-14-10.3-15.3-18.9c-5.6-37-30.7-67.6-64.5-81z"]
};
var faObjectExclude = {
  prefix: 'far',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M64 48H288c8.8 0 16 7.2 16 16v64h48V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V304H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm96 336v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H384v48h64c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V384H160zm128-32c35.3 0 64-28.7 64-64H304c0 8.8-7.2 16-16 16H256v48h32zm64-144V160H304 288v48h16v48h48V208zM224 352l0-48H208V256H160v48 48h48 16zM160 224h48c0-8.8 7.2-16 16-16h32V160H224c-35.3 0-64 28.7-64 64z"]
};
var faTelescope = {
  prefix: 'far',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M459.7 231.7l61.5-35.5-80-138.6L379.7 93.1l80 138.6zM328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8C446.4-.8 466 4.4 474.8 19.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c.6 4 .9 8.1 .9 12.3c0 20.1-7.4 38.5-19.7 52.5l49.9 122.4c5 12.3-.9 26.3-13.2 31.3s-26.3-.9-31.3-13.2l-47-115.3c-6 1.5-12.3 2.2-18.8 2.2s-12.8-.8-18.8-2.2l-47 115.3c-5 12.3-19 18.2-31.3 13.2s-18.2-19-13.2-31.3l44.3-108.8L149.5 418c-15.2 8.2-34.3 2.9-42.9-12.1l-.7-1.3L61.7 430.1c-11.5 6.6-26.2 2.7-32.8-8.8L3.1 376.4c-6.6-11.5-2.7-26.2 8.8-32.8l44.1-25.5L52 311.4c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6zm73.3 127.5l-49.5-85.7L101.3 300.7l39.1 67.7L226 322.1c-1.3-5.8-2-11.9-2-18.1c0-44.2 35.8-80 80-80c22.7 0 43.2 9.5 57.8 24.7l39.9-21.6zM304 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLocationPin = {
  prefix: 'far',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M320.7 249.2c-10.5 24.8-25.4 52.2-42.5 79.9C249.8 375.3 216.8 420 192 451.7c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9C52.5 223.6 48 204.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2zm-105 250C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
var faMapMarker = faLocationPin;
var faSquareList = {
  prefix: 'far',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faKaaba = {
  prefix: 'far',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", "M288 48.8L490.4 112 288 175.2 85.6 112 288 48.8zm9.5 173.8l230.5-72v45.7L292.8 269.7c-3.1 1-6.4 1-9.5 0L48 196.2V150.5l230.5 72c6.2 1.9 12.9 1.9 19.1 0zM48 229.8l225.7 70.5c9.3 2.9 19.3 2.9 28.6 0L528 229.8v30.5l-4.8 1.5c-8.4 2.6-13.1 11.6-10.5 20c2.1 6.8 8.5 11.2 15.3 11.2v95.2l-240 75-240-75V293c6.8 0 13.1-4.4 15.3-11.2c2.6-8.4-2.1-17.4-10.5-20L48 260.2V229.8zM22.5 81.5C9.1 85.6 0 98 0 112V400c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400V112c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zm94.3 200.3c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"]
};
var faToiletPaper = {
  prefix: 'far',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", "M16.9 487.4c-1.9-8-.7-16.5 3.6-23.7l0-.1c3.8-7 7.3-14.2 10.5-21.6C63.6 366.5 64 269.6 64 192C64 86 107 0 160 0H492.2l0 .1c1.3-.1 2.6-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-17.8 0-33-6-45.3-14.3c3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1 .8c-9.4 68.1-23.7 111.3-33.3 134.5c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2c-1.5-2.7-2.6-5.5-3.3-8.4zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 42.3-.1 93.4-5.9 144.1C101.2 378.5 92 423.1 73.8 464H333.9c2.7 0 5.3-.8 7.3-2c1.7-1 3-2.4 3.8-4.5C357.7 427 384 345.2 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48H160zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-344 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faHelmetSafety = {
  prefix: 'far',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M264 80h48c4.4 0 8 3.6 8 8V296c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-30.9-25.1-56-56-56H264c-30.9 0-56 25.1-56 56V296c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-4.4 3.6-8 8-8zM559.4 384H16.6C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6zM32 288v64H80V288c0-68.4 39-127.7 96-156.8V78.7C91.8 110.9 32 192.5 32 288zm464-2.2l0 66.2h48l0-64 0-2.4c-1-94.5-60.5-174.9-144-206.9v52.5c56.4 28.8 95.2 87.2 96 154.6z"]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faCommentCode = {
  prefix: 'far',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM217 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
var faSimCards = {
  prefix: 'far',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M144 352c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3L320.8 52.7c-3-3-7.1-4.7-11.3-4.7H160c-8.8 0-16 7.2-16 16V352zM429.3 93.3c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5zM24 96c13.3 0 24 10.7 24 24V376c0 48.6 39.4 88 88 88H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm184 80h64v64H256 176V208c0-17.7 14.3-32 32-32zM176 304V272h64v64H208c-17.7 0-32-14.3-32-32zm192 0c0 17.7-14.3 32-32 32H272V272h16 80v32zm0-96v32H304V176h32c17.7 0 32 14.3 32 32z"]
};
var faStarship = {
  prefix: 'far',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M0 96C0 60.7 28.7 32 64 32H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H164.8l37.7 26.1 70.1-8.4C302.6 110.7 369.9 64 448 64c106 0 192 86 192 192s-86 192-192 192c-78.1 0-145.4-46.7-175.3-113.7l-70.1-8.4L164.8 352H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H64c-35.3 0-64-28.7-64-64s28.7-64 64-64H80.5l50.1-34.7-13.7-1.6C86.7 312 64 286.4 64 256s22.7-56 52.9-59.6l13.7-1.6L80.5 160H64C28.7 160 0 131.3 0 96zM64 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H192c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm58.6 164c-6.1 .7-10.6 5.9-10.6 12s4.6 11.3 10.6 12l135.4 16.3c-1.4-9.2-2.1-18.6-2.1-28.2s.7-19 2.1-28.2L122.6 244zM48 416c0 8.8 7.2 16 16 16H192c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm400-16a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm32-144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faEject = {
  prefix: 'far',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M4.1 323.3c-7.7-17.4-4.3-37.7 8.6-51.8l176-192C197.7 69.6 210.5 64 224 64s26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352H48c-19 0-36.3-11.2-43.9-28.7zM48 304l352 0L224 112 48 304zM24 400H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCircleRight = {
  prefix: 'far',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3V208H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96v57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8L294.6 135.1z"]
};
var faArrowAltCircleRight = faCircleRight;
var faPlaneCircleCheck = {
  prefix: 'far',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2l0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23 0 0 0 0 0 0-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0 0 0 0 0 0 0-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1V297.5c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2V128c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2V303.7c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSeal = {
  prefix: 'far',
  iconName: 'seal',
  icon: [512, 512, [], "e241", "M210.4 97.9c-9 9-21.2 14.1-33.9 14.1H112v64.5c0 12.7-5.1 24.9-14.1 33.9L52.4 256l45.6 45.6c9 9 14.1 21.2 14.1 33.9V400h64.5c12.7 0 24.9 5.1 33.9 14.1L256 459.6l45.6-45.6c9-9 21.2-14.1 33.9-14.1H400V335.5c0-12.7 5.1-24.9 14.1-33.9L459.6 256l-45.6-45.6c-9-9-14.1-21.2-14.1-33.9V112H335.5c-12.7 0-24.9-5.1-33.9-14.1L256 52.4 210.4 97.9zm11.6-79.5c18.7-18.7 49.1-18.7 67.9 0L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48H335.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48V335.5L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6z"]
};
var faUserCowboy = {
  prefix: 'far',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M208.5 9.9c4.8 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.6 0 58.8 59.3 72.4 112c7.1-2.2 13.7-4.5 19.8-6.9c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9c-7.4 5.4-15.4 10.6-23.8 15.5c.8 5.8 1.2 11.6 1.2 17.6c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-6 .4-11.9 1.2-17.6c-8.4-4.8-16.4-10-23.8-15.5C35.8 147.5 10.1 113 .8 85.1c-2.5-7.4 .8-15.6 7.8-19.2s15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7c6.1 2.4 12.7 4.7 19.8 6.9C117.2 59.3 140.4 0 176 0c18 0 25.9 5.4 32.5 9.9zM224 224c-29 0-55.8-4.8-79.9-12.7c1.7 42.7 36.8 76.7 79.9 76.7s78.2-34.1 79.9-76.7C279.8 219.2 253 224 224 224zM54.2 458.7l-.6 5.3H394.4l-.6-5.3c-2.7-24.3-23.2-42.7-47.7-42.7H101.9c-24.5 0-45 18.4-47.7 42.7zM6.5 453.4C11.9 404.8 53 368 101.9 368H346.1c48.9 0 90 36.8 95.4 85.4l2.6 23.1c2.1 19-12.7 35.5-31.8 35.5H35.8c-19.1 0-33.9-16.6-31.8-35.5l2.6-23.1z"]
};
var faHexagonVerticalNft = {
  prefix: 'far',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9V168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.7c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4V344.9c0 25.7-13.7 49.5-36 62.4L260.9 495.5zm-48-41.6c7.4 4.3 16.6 4.3 24 0l152.9-88.3c7.4-4.3 12-12.2 12-20.8V168.3c0-8.6-4.6-16.5-12-20.8L236.9 59.2c-7.4-4.3-16.6-4.3-24 0L60 147.5c-7.4 4.3-12 12.2-12 20.8l0 176.6c0 8.6 4.6 16.5 12 20.8l152.9 88.3zM95.8 170.6l33.1 82.9V176.6c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L96.9 259.7v76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80-80zm112-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceRollingEyes = {
  prefix: 'far',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faMehRollingEyes = faFaceRollingEyes;
var faBreadLoaf = {
  prefix: 'far',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", "M64 208c-8.8 0-16-7.2-16-16c0-36.7 23.6-63.9 68.1-84.4C160.5 87.1 213.4 80 240 80s79.5 7.1 123.9 27.6C408.4 128.1 432 155.3 432 192c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48V432H320 112V256c0-26.5-21.5-48-48-48zm352 48H528V432H416V304 256zm155.3-47.8c-1.1-.1-2.2-.2-3.3-.2H478c1.3-5.1 2-10.5 2-16c0-51.1-28-86.9-65.8-111.5c28.7 2 72.2 9.7 109.7 27C568.4 128.1 592 155.3 592 192c0 8.8-7.2 16-16 16c-1.6 0-3.1 .1-4.7 .2zM112 480H320h48H528c26.5 0 48-21.5 48-48V304 256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H288 240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v48V432c0 26.5 21.5 48 48 48z"]
};
var faRingsWedding = {
  prefix: 'far',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M119.9 105.1C50.2 128.6 0 194.4 0 272c0 97.2 78.8 176 176 176c7.8 0 15.5-.5 23-1.5c32.3 39.9 81.6 65.5 137 65.5c97.2 0 176-78.8 176-176c0-91.9-70.4-167.3-160.3-175.3c10.4 16.5 18.6 34.5 24.2 53.6C427.1 231.1 464 279.2 464 336c0 70.7-57.3 128-128 128c-32.8 0-62.7-12.3-85.3-32.6l0 0c-12.3-11-22.5-24.4-29.8-39.5l0 0C212.6 375 208 356.1 208 336c0-54.9 34.6-101.8 83.2-119.9C299.4 233 304 251.9 304 272c0 43.5-21.7 81.9-54.8 105c7 14.8 17.7 27.5 30.8 37c43.7-32 72-83.7 72-142c0-77.6-50.2-143.4-119.9-166.9l22.5-50.6c1.9-4.4 1.8-9.4-.3-13.7l-16-32C235.6 3.4 230.1 0 224 0H128c-6.1 0-11.6 3.4-14.3 8.8l-16 32c-2.1 4.3-2.3 9.3-.3 13.7l22.5 50.6zM147.8 48h56.4l.4 .8L187.2 88H164.8L147.4 48.8l.4-.8zM160 336c0 22.6 4.2 44.1 12 63.9C103.1 397.8 48 341.3 48 272c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6C201.5 204.7 160 265.5 160 336z"]
};
var faObjectGroup = {
  prefix: 'far',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16H460.2c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8V396.2c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16H115.8c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8V115.8zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zm2.7 64c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"]
};
var faFrenchFries = {
  prefix: 'far',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M167.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l32 16c5.4 2.7 8.8 8.1 8.8 14.1v238c-9.2 1.4-19.8 2.2-32 2.2s-22.8-.8-32-2.2V206.7l0 0V16c0-5.5 2.9-10.7 7.6-13.6zM128 261c-4.8-2.1-8.7-4.4-11.8-6.6c-12-8.4-16.7-18-18.7-24.3c-.4-1.1-.8-2.3-1.2-3.4l-32-192c-1.2-6.9 2.3-13.8 8.6-16.9l32-16c4.5-2.3 9.9-2.3 14.4 .1s7.7 6.6 8.5 11.6l.2 1.3V261zM58.2 193c-3.2-.7-6.6-1-10.2-1H21.4c-1.6 0-3.2 .1-4.7 .2L.2 98.8C-.7 93.4 1.1 88 5.1 84.3s9.5-5.1 14.8-3.8l20.4 5.1L58.2 193zm309.1-.8c-1.6-.1-3.1-.2-4.7-.2H336c-3.1 0-6 .3-8.8 .8L346.2 85l17.9-4.5c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5l-16.5 93.4zM289.4 223c-1.1 2.4-2.1 4.7-2.8 7c-2 6.3-6.7 15.9-18.7 24.3c-3.2 2.2-7.1 4.5-11.8 6.6V54.6l.2-1.4C257.3 47 262 42 268.1 40.5l32-8c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5L289.4 223zM48 224c8.8 0 16.3 7.2 18.9 15.7C74.3 263 100.3 304 192 304s117.7-41 125.1-64.3c2.7-8.4 10.1-15.7 18.9-15.7h26.6c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224H48zm269.9 92.8c-1.4 1.1-2.8 2.1-4.3 3.1C284.7 340.1 244.9 352 192 352s-92.7-11.9-121.6-32.1c-1.5-1-2.9-2.1-4.3-3.1L101.8 464H282.2l35.7-147.2z"]
};
var faChartLine = {
  prefix: 'far',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zM473 169c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-79-79c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0L473 169z"]
};
var faLineChart = faChartLine;
var faCalendarArrowDown = {
  prefix: 'far',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM248 248V350.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V248c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faCalendarDownload = faCalendarArrowDown;
var faSendBack = {
  prefix: 'far',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", "M192 48c8.8 0 16 7.2 16 16V192c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H192zM64 0C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM576 304c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H448c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16H576zM448 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zM160 288v64c0 35.3 28.7 64 64 64H352V320c0-53 43-96 96-96h32V160c0-35.3-28.7-64-64-64H288v96c0 53-43 96-96 96H160z"]
};
var faMaskVentilator = {
  prefix: 'far',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M176 300.8c0 26.7 8.9 52.3 24.7 73.6c-.5-4.3-.7-8.7-.7-13.1c0-31.9 12.4-72.4 31.4-104.9c9.6-16.5 21.7-32.1 36-43.8C281.7 200.9 299.5 192 320 192c20.4 0 38.2 8.9 52.4 20.7s26.3 27.3 36 43.8c19.1 32.5 31.6 73 31.6 104.9c0 4.3-.2 8.5-.6 12.7C455 352.8 464 327.4 464 300.8c0-38.2-17.9-96.6-49.1-145.7C382.2 103.7 346.7 80 320 80c-27.3 0-62.7 23.8-95.2 75C193.7 204.1 176 262.5 176 300.8zm72 60.5c0 21.8 9.2 41.2 24 54.5v58.6c-45.3-10.8-84-36.5-109.8-71.1L90.9 385.5C37.5 372.1 0 324.1 0 269V184c0-30.9 25.1-56 56-56H185.1C219.8 73.8 267.4 32 320 32c52.1 0 99.7 41.8 134.5 96H584c30.9 0 56 25.1 56 56v85c0 55.1-37.5 103.1-90.9 116.4l-71.6 17.9c-26 34.6-64.7 60.2-109.5 71V415.7c14.7-13.3 24-32.6 24-54.3c0-21.6-9.2-53.7-25-80.6c-7.8-13.2-16.4-23.9-25.1-31.1s-16-9.7-21.9-9.7c-6 0-13.5 2.6-22.1 9.7c-8.7 7.1-17.3 17.8-25.1 31c-15.7 26.8-24.8 59-24.8 80.6zm257.6-14.5l31.8-8c32.1-8 54.5-36.8 54.5-69.9V184c0-4.4-3.6-8-8-8H480.7c19.8 43.2 31.3 88.7 31.3 124.8c0 16-2.2 31.4-6.4 46.1zM159.1 176H56c-4.4 0-8 3.6-8 8v85c0 33 22.5 61.8 54.5 69.9l31.8 7.9c-4.1-14.7-6.3-30.1-6.3-46c0-36.1 11.4-81.6 31.1-124.8zM296 328c0-13.3 10.7-24 24-24s24 10.7 24 24V512H296V328z"]
};
var faSignatureLock = {
  prefix: 'far',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", "M80 128c0-26.5 21.5-48 48-48s48 21.5 48 48v7.9c0 27.5-2.3 55-7 82.1L62 251.1C25.1 262.5 0 296.6 0 335.2V410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2h72.6c5.6-9.7 13.7-17.8 23.4-23.4V272H354.1l28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96s-96 43-96 96v40c0 13.3 10.7 24 24 24s24-10.7 24-24V128zM208.1 368c-7 16.3-14.8 32.4-23.3 48H384V368H208.1zM76.2 297l80.9-25c-11.7 43.2-29.4 84.5-52.4 123L88.8 421.3C84.8 428 77.7 432 70 432c-12.1 0-22-9.8-22-22V335.2c0-17.5 11.4-33 28.2-38.2zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowRight = {
  prefix: 'far',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"]
};
var faSignsPost = {
  prefix: 'far',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24v8H440.3c4.9 0 9.5 2.2 12.5 6L504 102c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6H280v32H448c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H280V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H71.7c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6H232V192H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H232V24zM80 80v64H424.9l25.6-32L424.9 80H80zM432 336V272H87.1L61.5 304l25.6 32H432z"]
};
var faMapSigns = faSignsPost;
var faOctagonPlus = {
  prefix: 'far',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlusOctagon = faOctagonPlus;
var faCashRegister = {
  prefix: 'far',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87.5c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V388.5c0-3-.2-6.1-.6-9L487.8 214.9c-4.5-31.5-31.5-54.9-63.4-54.9H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM48 448V432H464v16c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM440.3 221.7L463.5 384H48.5L71.7 221.7c1.1-7.9 7.9-13.7 15.8-13.7h337c8 0 14.7 5.9 15.8 13.7zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faPersonCircleQuestion = {
  prefix: 'far',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1H146.3c-.8 0-1.5 0-2.3 .1zM144 352V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"]
};
var faMelonSlice = {
  prefix: 'far',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L319 79c-6.2 6.2-8.5 15.3-6.1 23.7l0 0 .1 .4c.1 .5 .3 1.3 .6 2.4c.5 2.3 1.2 5.8 1.8 10.4c1.2 9.2 2.1 22.3 .6 37.9c-2.9 30.9-15.1 71.3-53 109.2c-42.3 42.3-82.7 54-111.6 55.9c-14.7 1-26.8-.5-35-2.2c-4.1-.8-7.2-1.7-9.2-2.3c-1-.3-1.7-.5-2-.7l-.3-.1C96 310.2 85.8 312.2 79 319L7 391zM313 102.7l0 0 0 0 0 0c0 0 0 0 0-.1zm51.8 35.2C377.1 161.3 384 187.8 384 216c0 92.8-75.2 168-168 168c-26.2 0-51-6-73.1-16.7c3.8 0 7.7-.2 11.8-.4c39.9-2.7 91.4-19 142.2-69.9c47.2-47.2 63-98.7 66.8-138.6c.7-7.2 1-14.1 1-20.4zM81.2 384.8C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216c0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6s-235.2 96.2-332.6 15.8l22.4-22.4z"]
};
var faSpaceStationMoon = {
  prefix: 'far',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M256 48c-16.5 0-32.5 1.9-47.8 5.5C245.4 66.8 272 102.3 272 144c0 53-43 96-96 96c-52.7 0-95.4-42.4-96-94.9C59.7 177.2 48 215.2 48 256c0 12.8 1.1 25.2 3.3 37.4c.5 .2 1 .3 1.5 .5C87.7 306.5 147.6 328 256 328s168.3-21.5 203.2-34.1l0 0c.5-.2 1-.4 1.5-.5c2.2-12.1 3.3-24.6 3.3-37.4c0-114.9-93.1-208-208-208zM441.3 350.7C402.1 362.7 343 376 256 376s-146.1-13.3-185.3-25.3C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM176 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faMessageSmile = {
  prefix: 'far',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"]
};
var faCommentAltSmile = faMessageSmile;
var faCupStraw = {
  prefix: 'far',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M194.8 43.2l-20 84.8H80.2 32 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H36 84.2h89.9 35.8 89.9H348h12c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H303.8 224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3c-26 0-48.6 17.9-54.5 43.2zM38.7 208L60.3 468c2.1 24.9 22.9 44 47.8 44H275.8c25 0 45.8-19.1 47.8-44l21.7-260H297.2L275.8 464H108.2L86.8 208H38.7z"]
};
var faLeftFromLine = {
  prefix: 'far',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", "M160 146.2L50 256 160 365.8l0-53.8c0-13.3 10.7-24 24-24l120 0 0-64-120 0c-13.3 0-24-10.7-24-24l0-53.8zM0 256c0-11.5 4.6-22.5 12.7-30.6L128.8 109.6c8.7-8.7 20.5-13.6 32.8-13.6c25.6 0 46.4 20.8 46.4 46.4l0 33.6 96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0 0 33.6c0 25.6-20.8 46.4-46.4 46.4c-12.3 0-24.1-4.9-32.8-13.6L12.7 286.6C4.6 278.5 0 267.5 0 256zM400 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336z"]
};
var faArrowAltFromRight = faLeftFromLine;
var faH = {
  prefix: 'far',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M336 256l0 200c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V208L48 208 48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-200 288 0z"]
};
var faBasketShoppingSimple = {
  prefix: 'far',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192H404.3L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192h36.1H544h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H532L476.1 463.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L44 240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8H81.5h36.1L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM482.5 240H93.5l53 211.9c1.8 7.1 8.2 12.1 15.5 12.1H414c7.3 0 13.7-5 15.5-12.1l53-211.9zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faShoppingBasketAlt = faBasketShoppingSimple;
var faHandsHoldingHeart = {
  prefix: 'far',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M195.9 136.9L297.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L444.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L320 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136V352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24V281.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9 0 0L167 393l0 0 16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16 0 0-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V436.8c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359l0 0-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 0 0 26.7-26.7 0 0 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24V352.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72V264.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8V136z"]
};
var faHandsHeart = faHandsHoldingHeart;
var faClockNine = {
  prefix: 'far',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTarp = {
  prefix: 'far',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", "M48 128c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16V288H448c-17.7 0-32 14.3-32 32v80L64 400c-8.8 0-16-7.2-16-16l0-256zm528 0c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l364.1 0c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9V128zM112 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFaceSleepy = {
  prefix: 'far',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", "M256 464c47 0 90.4-15.6 125.2-41.9c2.7 14.8 2.8 29.6 2.8 41.9c0 4.5 .4 8.9 1.1 13.1C347.2 499.3 303.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 37-7.8 72.1-22 103.9c-7.4-6.2-15.1-11.8-22.7-16.7c-5.8-3.8-11.8-7.3-17.9-10.6C458.8 308.9 464 283 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208zm-80-74.5C191.1 364.8 221.3 348 256 348s64.9 16.8 80.1 41.5c6.8 11.1-6 20.7-18.3 16.4c-18.9-6.5-39.8-10.1-61.8-10.1s-42.9 3.6-61.8 10.1c-12.3 4.2-25.1-5.3-18.3-16.4zM326.2 250.3c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 293.2 371 300 351.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zM159.6 260c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 293.2 179 300 159.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128c48 0 160 48 160 128z"]
};
var faHandHorns = {
  prefix: 'far',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M80 48c8.8 0 16 7.2 16 16V208v32H80c-5.5 0-10.8 .6-16 1.6V64c0-8.8 7.2-16 16-16zM16 64V272C6 285.4 0 302 0 320c0 0 0 0 0 0v24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V288 256 128c0-35.3-28.7-64-64-64s-64 28.7-64 64v50c-5.1-1.3-10.5-2-16-2c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2V64c0-35.3-28.7-64-64-64S16 28.7 16 64zM336 256v32 56c0 66.3-53.7 120-120 120H168c-66.3 0-120-53.7-120-120V320s0 0 0 0c0-17.7 14.3-32 32-32h40 40c8.8 0 16 7.2 16 16s-7.2 16-16 16H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c35.3 0 64-28.7 64-64V256 240 128c0-8.8 7.2-16 16-16s16 7.2 16 16V256zM160 240H144V208c0-8.8 7.2-16 16-16s16 7.2 16 16v32 2c-5.1-1.3-10.5-2-16-2zm96 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V264 240c0-8.8 7.2-16 16-16s16 7.2 16 16v16z"]
};
var faScrewdriverWrench = {
  prefix: 'far',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-8.9-17.6-12.8-37.1-11.6-56.3L101.3 454.9c-5.9 5.8-13.8 9.1-22.1 9.1C62 464 48 450 48 432.8c0-8.3 3.3-16.2 9.1-22.1L194.3 273.5l-33.9-33.9L23.2 376.8zM463.9 164c-1.4 38.9-22.6 72.8-53.8 91.8c1.1 1 2.1 2 3.1 3l31.6 31.6c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C294.7 0 244.4 30.1 216.2 75.4C221.2 84 224 93.8 224 104v40.8l16 16 0-.8c0-60.5 48-109.9 108-111.9L322.7 73.4l0 0c-12 12-18.7 28.3-18.7 45.3V144c0 35.3 28.7 64 64 64h25.4c17 0 33.3-6.7 45.3-18.7L463.9 164z"]
};
var faTools = faScrewdriverWrench;
var faArrowsToEye = {
  prefix: 'far',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M49 15C39.6 5.7 24.4 5.7 15 15S5.7 39.6 15 49l63 63H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24V40c0-13.3-10.7-24-24-24s-24 10.7-24 24V78.1L49 15zM320 352c-64.5 0-113.8-52.1-138.5-96c24.7-43.9 74-96 138.5-96s113.8 52.1 138.5 96c-24.7 43.9-74 96-138.5 96zm0-240c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM625 15c-9.4-9.4-24.6-9.4-33.9 0l-63 63V40c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H561.9l63-63c9.4-9.4 9.4-24.6 0-33.9zM49 497l63-63V472c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H78.1L15 463c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm576 0c9.4-9.4 9.4-24.6 0-33.9l-63-63H600c13.3 0 24-10.7 24-24s-10.7-24-24-24H504c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V433.9l63 63c9.4 9.4 24.6 9.4 33.9 0zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faCircleThreeQuarters = {
  prefix: 'far',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 304c-26.5 0-48-21.5-48-48V53.6C116.3 75.2 48 157.7 48 256c0 114.9 93.1 208 208 208c98.3 0 180.8-68.3 202.4-160H256zM224.1 2C241.6-.2 256 14.3 256 32V208v48h48H480c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512C114.6 512 0 397.4 0 256C0 125.4 97.8 17.7 224.1 2z"]
};
var faTrophyStar = {
  prefix: 'far',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", "M176.9 48c6.4 160.7 44.3 231.4 71.8 261.7c13.7 15.1 25.9 21.4 33.1 24.1c2.6 1 4.7 1.5 6.1 1.9c1.4-.3 3.5-.9 6.1-1.9c7.2-2.7 19.4-9 33.1-24.1c27.5-30.3 65.5-101 71.8-261.7H176.9zM176 0H400c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8H552c13.3 0 24 10.7 24 24c0 108.5-45.9 177.7-101.4 220.6c-53.9 41.7-115.7 57.6-149.5 63.7c-4.7 2.5-9.1 4.5-13.1 6.1V464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H288 184c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V378.4c-4-1.6-8.4-3.6-13.1-6.1c-33.8-6-95.5-22-149.5-63.7C45.9 265.7 0 196.5 0 88C0 74.7 10.7 64 24 64H129.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM390.8 302.6c18.1-8 36.8-18.4 54.4-32c40.6-31.3 75.9-80.2 81.9-158.6H442.7c-9.1 90.1-29.2 150.3-51.9 190.6zm-260-32c17.5 13.6 36.3 24 54.4 32c-22.7-40.3-42.8-100.5-51.9-190.6H48.9c6 78.4 41.3 127.3 81.9 158.6zM295.2 102.5l14.5 29.3c1.2 2.4 3.4 4 6 4.4l32.4 4.7c6.6 1 9.2 9 4.4 13.6l-23.4 22.8c-1.9 1.8-2.7 4.5-2.3 7.1l5.5 32.2c1.1 6.5-5.7 11.5-11.6 8.4l-29-15.2c-2.3-1.2-5.1-1.2-7.4 0l-29 15.2c-5.9 3.1-12.7-1.9-11.6-8.4l5.5-32.2c.4-2.6-.4-5.2-2.3-7.1l-23.4-22.8c-4.7-4.6-2.1-12.7 4.4-13.6l32.4-4.7c2.6-.4 4.9-2 6-4.4l14.5-29.3c2.9-5.9 11.4-5.9 14.3 0z"]
};
var faTrophyAlt = faTrophyStar;
var faPlugCircleBolt = {
  prefix: 'far',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faFaceThermometer = {
  prefix: 'far',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", "M288 48C173.1 48 80 141.1 80 256s93.1 208 208 208c65.9 0 124.7-30.7 162.8-78.5c1.5-1.3 3-2.6 4.4-4L540 301.1C518.8 421 414 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5c-16.5-.3-33.1 4.4-47.3 14.1C429 87.8 363.1 48 288 48zM546.8 180.1c19.8 19.8 19.4 52.1-.9 71.4L415.1 376.1c-1.2 4.2-3.4 8.1-6.8 11.2c-9.7 9-24.9 8.4-33.9-1.4C359.2 369.5 333.2 352 296 352s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4c16.2 0 31.1 2.3 44.4 6.3L477 179.4c19.6-18.8 50.6-18.4 69.8 .7zM401.3 345l28-26.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3L372.5 323.9c11.2 6.3 20.8 13.7 28.9 21.1zm-193-169a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faGridRound4 = {
  prefix: 'far',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M44.8 64a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zM44.8 183.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM57.6 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM177.1 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM296.5 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z"]
};
var faShirtRunning = {
  prefix: 'far',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M88 0c13.3 0 24 10.7 24 24V72c0 44.2 35.8 80 80 80s80-35.8 80-80V24c0-13.3 10.7-24 24-24s24 10.7 24 24c0 127.9 26.8 181 41.5 200.5c9.6 12.8 22.5 32.8 22.5 56.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280.7c0-23.5 12.9-43.5 22.5-56.3C37.2 205 64 151.9 64 24C64 10.7 74.7 0 88 0zM60.8 253.4C52.2 264.8 48 273.9 48 280.7V390.8L299.3 209.3c-5.4-13.6-10.4-29.8-14.6-49.1C261.4 184.7 228.5 200 192 200s-69.4-15.3-92.7-39.8C89 206.9 74.1 235.7 60.8 253.4zM48.1 450c1 7.9 7.7 14 15.9 14H320c8.8 0 16-7.2 16-16V280.7c0-6.8-4.2-15.9-12.8-27.3c-.3-.4-.7-.9-1-1.4L48.1 450z"]
};
var faBookCircleArrowUp = {
  prefix: 'far',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", "M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H394.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H322.9c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H392c4.4 0 8 3.6 8 8V220.5c14.6-9.5 30.8-17 48-21.8V56c0-30.9-25.1-56-56-56H88zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faFaceNauseated = {
  prefix: 'far',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335.6-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM172 267.2C189 277 202 293 208 312h96.2c6.1-18.8 19-34.5 35.8-44.2c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8c-9.4 5.5-15.7 15.6-15.7 27.2s6.3 21.8 15.7 27.2c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8c-17.1-9.9-30.2-26-36.2-45.3H208c-6 19-19.1 35-36 44.8c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8c9.5-5.5 15.7-15.6 15.7-27.2s-6.3-21.8-15.7-27.2c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8z"]
};
var faHeart = {
  prefix: 'far',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"]
};
var faFileChartPie = {
  prefix: 'far',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 240.1c8.7-1.5 16 5.8 16 14.7V320c0 8.8 7.2 16 16 16h64c8.9 0 16.3 7.4 14.6 16.1c-.5 2.5-1 5-1.7 7.4c-13.7 51.2-66.4 81.6-117.6 67.9s-81.6-66.4-67.9-117.6c10-37.4 40.8-63.7 76.5-69.8zm63.9-30.8c40.3 6.7 72 38.5 78.8 78.8c1.5 8.7-5.8 15.9-14.7 15.9H224c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16.1 15.9-14.7z"]
};
var faMarsAndVenus = {
  prefix: 'far',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M352 24c0 13.3 10.7 24 24 24h38.1L371.2 90.9C340.3 64.2 300 48 256 48C158.8 48 80 126.8 80 224c0 89.1 66.2 162.7 152 174.4v.2 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2H208c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.1 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H232c0 13.3 10.7 24 24 24s24-10.7 24-24H256l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V464h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H280v-.2-.3-.3-.3-.3-.3-.3-.3-.3V413v-.3-.3V412v-.3-.3V411v-.3-.3V410v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.2c85.8-11.7 152-85.3 152-174.4c0-35.8-10.7-69.2-29.1-97L448 81.9V120c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faHouseUser = {
  prefix: 'far',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM224 224a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 96h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]
};
var faHomeUser = faHouseUser;
var faCircleArrowDownLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm64-144H168c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24V286.1L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-135 135H320c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faDumpsterFire = {
  prefix: 'far',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM80.4 192H32l4 32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H42L64 448v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H337.6c-12.7-14.3-23.4-30.5-31.5-48H106.4l-20-160H309c4.9-10 10.3-19.8 16.2-29.3c3.8-6.2 7.9-12.5 12.3-18.7H80.4zm373.2-60.2c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faHexagonMinus = {
  prefix: 'far',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12H344.3c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMinusHexagon = faHexagonMinus;
var faLeftToLine = {
  prefix: 'far',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", "M256 146.2L146 256 256 365.8l0-53.8c0-13.3 10.7-24 24-24l120 0 0-64-120 0c-13.3 0-24-10.7-24-24l0-53.8zM96 256c0-11.5 4.6-22.5 12.7-30.6L224.8 109.6c8.7-8.7 20.5-13.6 32.8-13.6c25.6 0 46.4 20.8 46.4 46.4l0 33.6 96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0 0 33.6c0 25.6-20.8 46.4-46.4 46.4c-12.3 0-24.1-4.9-32.8-13.6L108.7 286.6C100.6 278.5 96 267.5 96 256zM48 88l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64s24 10.7 24 24z"]
};
var faArrowAltToLeft = faLeftToLine;
var faHouseCrack = {
  prefix: 'far',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H325.9L288 403.8l79.7-63.3c8.2-6.5 8-19.1-.4-25.3L252.2 229c-14.9-11.1-33.6 7.8-22.3 22.5L288 327.6l-84.8 67.3c-6.4 5.1-7.9 14.2-3.6 21.1L229.9 464H144c-17.7 0-32-14.3-32-32z"]
};
var faPawSimple = {
  prefix: 'far',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zm-.7 146.1c7.1-11.3 19.4-18.1 32.7-18.1s25.7 6.9 32.7 18.1l49.2 78.6c8.7 14 20.9 22.8 32.2 28.1c17.8 8.4 30 26.4 30 47.1c0 28.7-23.3 52-52 52c-11.1 0-21.2-3.4-29.6-9.2c-19.6-13.6-43.8-17.6-62.4-17.6s-42.8 4-62.4 17.6c-8.4 5.8-18.5 9.2-29.6 9.2c-28.7 0-52-23.3-52-52c0-20.8 12.2-38.8 30-47.1c11.2-5.3 23.4-14.1 32.2-28.1l49.2-78.6zm-89.9 53.2c-2.8 4.5-7.1 7.8-11.8 10.1C55.6 305.4 32 339.9 32 380c0 55.2 44.8 100 100 100c21.2 0 40.8-6.6 56.9-17.8c17.4-12 52.8-12 70.1 0C275.2 473.4 294.8 480 316 480c55.2 0 100-44.8 100-100c0-40.1-23.6-74.6-57.6-90.6c-4.8-2.2-9-5.6-11.8-10.1l-49.1-78.6C281.6 175.4 253.9 160 224 160s-57.6 15.4-73.4 40.7l-49.2 78.6zM304 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPawAlt = faPawSimple;
var faArrowLeftLongToLine = {
  prefix: 'far',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M0 88V424c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24S0 74.7 0 88zM135 239c-9.4 9.4-9.4 24.6 0 33.9L271 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L616 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-406.1 0 95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L135 239z"]
};
var faBracketsRound = {
  prefix: 'far',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M148.3 76.6c11.4-6.8 15.1-21.5 8.3-32.9s-21.5-15.1-32.9-8.3C82 60.2 0 137.9 0 256S82 451.8 123.7 476.6c11.4 6.8 26.1 3 32.9-8.3s3-26.1-8.3-32.9C115.3 415.7 48 351.3 48 256s67.3-159.7 100.3-179.4zm215.4 0C396.7 96.3 464 160.7 464 256s-67.3 159.7-100.3 179.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C430 451.8 512 374.1 512 256s-82-195.8-123.7-220.6c-11.4-6.8-26.1-3-32.9 8.3s-3 26.1 8.3 32.9z"]
};
var faParentheses = faBracketsRound;
var faMartiniGlassCitrus = {
  prefix: 'far',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", "M432 240c-14.3 0-27.9-3.1-40.1-8.7l-35.4 35.4C378.5 280.2 404.3 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C369.3 0 316 40.1 296.2 96h52.6c16.6-28.7 47.6-48 83.2-48c53 0 96 43 96 96s-43 96-96 96zM24 128c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l177 177V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h88 88c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V345.9L409 169c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H24zm310.1 48L208 302.1 81.9 176H334.1z"]
};
var faCocktail = faMartiniGlassCitrus;
var faUserShakespeare = {
  prefix: 'far',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1V128c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v23.2c0 10.9 3.7 21.5 10.5 30L373.6 195c6.7 8.4 10.4 18.8 10.4 29.6c0 26.2-21.2 47.4-47.4 47.4H286c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16H111.4C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30V128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM240 416.7c-.3 8.5-7.4 15.3-16 15.3s-15.6-6.8-16-15.3c-23.1 1.9-42.4 7.7-56.5 13.5c-8.6 3.5-15.2 7-19.6 9.6c-2.2 1.3-3.8 2.3-4.8 2.9c-.5 .3-.8 .6-1 .7l-.1 .1c-7.3 5.3-16.9 6-24.9 1.9C93.1 441.3 88 433 88 424V394.9C67.7 412.1 53.5 436.4 49.3 464H208c0-8.8 7.2-16 16-16s16 7.2 16 16H398.7c-4.2-27.6-18.4-51.9-38.7-69.1V424c0 9-5.1 17.3-13.1 21.4c-8 4.1-17.6 3.3-24.9-1.9l-.1-.1c-.2-.1-.5-.3-1-.7c-1-.6-2.6-1.7-4.8-2.9c-4.4-2.5-11-6-19.6-9.6c-14.1-5.8-33.3-11.6-56.5-13.5zM117.9 325.9C133.4 312.3 153.7 304 176 304h96c22.3 0 42.6 8.3 58.1 21.9c68 18.9 117.9 81.3 117.9 155.4c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-74 49.9-136.4 117.9-155.4zM224 368c35.9 0 65.8 8 87.3 16.4C307.7 366 291.5 352 272 352H176c-19.5 0-35.7 14-39.3 32.4C158.2 376 188.1 368 224 368z"]
};
var faArrowRightToArc = {
  prefix: 'far',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M464 256c0-114.9-93.1-208-208-208c-13.3 0-24-10.7-24-24s10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM232.3 134.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L266.9 280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H266.9l-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9s24.2-10.3 33.9-1.3z"]
};
var faFaceSurprise = {
  prefix: 'far',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSurprise = faFaceSurprise;
var faBottleWater = {
  prefix: 'far',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V78c10.7 3.7 20.9 9.2 30 16.2l6 4.6c22.7 17.4 36 44.4 36 73.1c0 12.5-2.5 24.4-7 35.3c4.5 10 7 21.1 7 32.8c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32s-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32s-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80H104c-44.2 0-80-35.8-80-80c0-11.4 2.4-22.2 6.7-32c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32c-4.3-9.8-6.7-20.6-6.7-32c0-11.7 2.5-22.8 7-32.8c-4.5-10.9-7-22.8-7-35.3c0-28.6 13.3-55.6 36-73.1l6-4.6c9.1-7 19.3-12.5 30-16.2V24zM237.8 208c0-4.5 1.2-8.9 3.6-12.9c4.2-6.7 6.6-14.7 6.6-23.2c0-13.7-6.4-26.7-17.3-35l-6-4.6c-10.4-8-23.1-12.3-36.2-12.3H131.4c-13.1 0-25.8 4.3-36.2 12.3l-6 4.6c-10.9 8.4-17.3 21.3-17.3 35c0 8.6 2.4 16.5 6.6 23.2c2.5 4 3.7 8.4 3.6 12.9H237.8zM82 336c0 4.8-1.4 9.6-4.3 13.7C74.1 354.9 72 361.2 72 368s2.1 13.1 5.7 18.3c5.8 8.2 5.8 19.2 0 27.5C74.1 418.9 72 425.2 72 432c0 17.7 14.3 32 32 32H216c17.7 0 32-14.3 32-32c0-6.8-2.1-13.1-5.7-18.3c-5.8-8.2-5.8-19.2 0-27.5c3.6-5.2 5.7-11.4 5.7-18.3s-2.1-13.1-5.7-18.3c-2.9-4.1-4.3-8.9-4.3-13.7H82z"]
};
var faCirclePause = {
  prefix: 'far',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faPauseCircle = faCirclePause;
var faGaugeCirclePlus = {
  prefix: 'far',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24V301.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faFolders = {
  prefix: 'far',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M512 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H277.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16zM160 384H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faAngel = {
  prefix: 'far',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M384 64c0 0 0 .1 0 .2s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2zM256 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM87.6 388.2c5.6-11.1 8.4-23.4 8.4-35.8v-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1c0-27.1 22-48.9 48.2-48.9c12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464H49.7l37.9-75.8zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3H96h53.7H426.3 480h50.7c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm109.6 26.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1c26.1 0 48.2 21.8 48.2 48.9c0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8v.9c0 12.4 2.9 24.7 8.4 35.8L526.3 464H456L380.6 313.2c-4.6-9.2-10.4-17.5-17.3-24.7zm-25.7 46.2L402.3 464H173.7l64.6-129.3C247.7 315.9 267 304 288 304s40.3 11.9 49.7 30.7z"]
};
var faValueAbsolute = {
  prefix: 'far',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zM177 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l79 79-79 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79-79 79-79c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-79 79-79-79zM512 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56z"]
};
var faRabbit = {
  prefix: 'far',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M245.7 0c-24.4 0-45.1 17.9-48.5 42.1l-.7 4.9c-7.8 54.3 8.4 108.9 43.5 150.1v20.6c-66.8 20.7-119.8 73-141.4 139.4C90.3 353.8 81.4 352 72 352c-39.8 0-72 32.2-72 72s32.2 72 72 72c14.7 0 28.3-4.4 39.7-11.9C127.8 501.3 150.6 512 176 512h32l96 0c23.9 0 44.7-13.1 55.7-32.4l5.1 6.8c21.2 28.3 61.3 34 89.6 12.8s34-61.3 12.8-89.6L388 304c46.4-.1 84-37.8 84-84.3c0-25.3-11.4-49.3-31-65.3L404 124.3c-5.6-4.5-11.5-8.6-17.6-12c10.1-24.8 13.6-52.1 9.8-79.4l-.9-6C393.1 11.4 379.9 0 364.3 0c-8.2 0-16.2 3.3-22 9.1l-2 2c-5.8 5.7-11 11.9-15.7 18.3c14.7 21.5 25.1 45.4 30.7 70.4c-8.4-2.1-17-3.4-25.7-3.7c-8.2-29.3-23.8-56.6-46.2-78.8l-3.1-3.1L263.4 31.1l16.8-16.9C271 5.1 258.6 0 245.7 0zM88.7 406.7c-.4 5.7-.7 11.4-.7 17.3c0 5.6 .5 11.1 1.5 16.4C85.1 445.1 78.9 448 72 448c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.5 0 12.4 2.6 16.7 6.7zm156-357.9c.1-.5 .5-.9 1-.9c.3 0 .5 .1 .7 .3l3.1 3.1 16.8-16.9L249.5 51.4c20.4 20.2 33.2 46.2 37.2 73.7c1 6.7 4.7 12.6 10.3 16.4s12.5 5 19 3.5c2.7-.6 5.5-1 8.5-1c17.9 0 35.3 6.2 49.3 17.5l36.9 30.1c8.4 6.9 13.4 17.2 13.4 28.1c0 20-16.2 36.3-36.3 36.3H352c-13.3 0-24 10.7-24 24v16c0 5.2 1.7 10.2 4.8 14.4l96 128c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2l-68.6-91.4c-4.2-5.6-10.6-9-17.5-9.5s-13.8 2.1-18.7 7L271 391c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8h16c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0H176c-22.1 0-40-17.9-40-40c0-80.8 57-148.2 133-164.3c11.1-2.4 19-12.1 19-23.5V187.9c0-6.1-2.4-12.1-6.6-16.5C251.8 140.1 237.8 96.8 244 53.8l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faToiletPaperSlash = {
  prefix: 'far',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L518.1 380.8c14.4-4.3 26.5-12.4 35.9-21.3c13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5C540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM134 79.8c.3-.7 .7-1.4 1-2.1c6.7-13.4 13.4-21.6 18.6-26c2.5-2.1 4.3-3 5.2-3.4c.5-.2 .8-.3 .9-.3s.2 0 .3 0H419c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 29.8-1 57-2.7 81.6L134 79.8zM426.5 309c3.4-33.8 5.5-72.6 5.5-117c0-76 26.2-138.3 59.4-143.6c1.5-.2 3.1-.4 4.6-.4c35.3 0 64 64.5 64 144s-28.7 144-64 144H461l-34.5-27zM20.5 463.6c-4.3 7.2-5.5 15.8-3.6 23.7c.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512H333.9c22.3 0 45.4-12.1 55.4-36.1c5.4-12.9 12.2-32.1 18.8-58.4l-41.7-32.8c-7.5 35.6-15.8 59.2-21.5 72.8c-.9 2.1-2.1 3.5-3.8 4.5c-2 1.2-4.6 2-7.3 2H73.8c18.1-40.9 27.3-85.5 32.2-127.9c5.9-50.6 5.9-101.7 5.9-144.1c0-2.6 0-5.1 .1-7.7L66.5 148.4C64.9 162.4 64 177 64 192c0 77.6-.4 174.5-32.9 250c-3.2 7.4-6.7 14.6-10.5 21.6l0 .1zM496 240c13.3 0 24-21.5 24-48s-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48z"]
};
var faCircleEuro = {
  prefix: 'far',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 16h16c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H206.4c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAppleWhole = {
  prefix: 'far',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M224 112h16c44.2 0 80-35.8 80-80V16c0-8.8-7.2-16-16-16H288c-44.2 0-80 35.8-80 80V96c0 8.8 7.2 16 16 16zM48 288c0-31.7 7.6-62.5 20.4-83.7C80.5 184.3 94.7 176 112 176c17.8 0 43.2 7.4 65.3 16c30 11.7 63.5 11.7 93.5 0c22.1-8.6 47.5-16 65.3-16c17.3 0 31.5 8.3 43.6 28.3C392.4 225.5 400 256.3 400 288c0 54.2-17 100-40.4 131.2c-24 32-51.2 44.8-71.6 44.8c-4.6 0-13.6-1.7-24.9-5.1c-25.4-7.6-52.7-7.6-78.1 0c-11.3 3.4-20.3 5.1-24.9 5.1c-20.4 0-47.6-12.8-71.6-44.8C65 388 48 342.2 48 288zm64-160C35.7 128 0 211.7 0 288C0 416 80 512 160 512c11.9 0 26.5-3.4 38.8-7.1c16.4-4.9 34.1-4.9 50.5 0c12.2 3.7 26.8 7.1 38.8 7.1c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z"]
};
var faAppleAlt = faAppleWhole;
var faKitchenSet = {
  prefix: 'far',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120h66.7c3.8-22.7 23.6-40 47.3-40h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H400c-23.8 0-43.5-17.3-47.3-40H286zM80 144a64 64 0 1 1 128 0A64 64 0 1 1 80 144zM376 264c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40 56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V320h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h56 40v-8zm-40 56V464H464V320H336zM32 336c0-8.8 7.2-16 16-16h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm128 48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32zM0 488c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM400 128v32h96V128H400z"]
};
var faDiamondHalf = {
  prefix: 'far',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", "M215 17C225.9 6.1 240.6 0 256 0V48 464v48c-15.4 0-30.1-6.1-41-17L17 297C6.1 286.1 0 271.4 0 256s6.1-30.1 17-41L215 17zm-7 403.1V91.9L50.9 249c-1.9 1.9-2.9 4.4-2.9 7s1 5.2 2.9 7L208 420.1z"]
};
var faLockKeyhole = {
  prefix: 'far',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", "M224 48c44.2 0 80 35.8 80 80v64H144V128c0-44.2 35.8-80 80-80zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 240H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm184 80c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V320z"]
};
var faLockAlt = faLockKeyhole;
var faR = {
  prefix: 'far',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M56 32C25.1 32 0 57.1 0 88V280 456c0 13.3 10.7 24 24 24s24-10.7 24-24V304H157.9L276.5 469.9c7.7 10.8 22.7 13.3 33.5 5.6s13.3-22.7 5.6-33.5L214.5 300.6C274.9 286.7 320 232.6 320 168c0-75.1-60.9-136-136-136H56zM176 256H48V88c0-4.4 3.6-8 8-8H184c48.6 0 88 39.4 88 88s-39.4 88-88 88h-8z"]
};
var faTemperatureQuarter = {
  prefix: 'far',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M160 48c-35.3 0-64 28.7-64 64V273.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V273.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faSquareInfo = {
  prefix: 'far',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM184 336h24V272H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faInfoSquare = faSquareInfo;
var faWifiSlash = {
  prefix: 'far',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-267-209.3c47.2 8.4 89.8 30.2 123.8 61.4c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208c-7.2 0-14.3 .3-21.4 .8L169.4 107.5C216.2 89.7 267 80 320 80c107.4 0 205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32c-69.1 0-134.7 14.9-193.9 41.5L38.8 5.1zM76.9 156.6L37.7 125.7c-10.2 7.6-20 15.6-29.5 23.9c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c11.8-10.4 24.1-20.1 37-29.1zM226.3 274.3L184 241c-23.4 12.1-44.9 27.2-64.1 44.8c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c21.5-19.7 46.5-35.7 73.9-46.9zM376 424a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
var faToiletPaperXmark = {
  prefix: 'far',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3H324.7c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1H112c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456V351.1c-16.6 19.3-38.1 32.9-64 32.9H112c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0H400c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192V456c0 30.9-25.1 56-56 56H216c-30.9 0-56-25.1-56-56V416h48v40c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM235.3 132.7c6.2 6.2 6.2 16.4 0 22.6L198.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L153.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHandsHoldingDollar = {
  prefix: 'far',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V34.9c-6.9 1.8-13.8 4.5-20.2 8.2c-14.9 8.8-27.9 24.5-27.7 47.4c.1 22.1 13.1 36 26.6 44.1c11.4 6.9 25.6 11.2 36.4 14.4l1.9 .6c12.7 3.8 21.3 6.7 27.1 10.3c4 2.5 4 3.6 4 4.6l0 .2c0 2.3-.5 3.5-.8 4.1c-.4 .7-1.3 1.8-3.2 2.9c-4.1 2.6-11.2 4.4-19.2 4.1c-10.5-.3-20.2-3.6-33.9-8.3c-2.3-.8-4.8-1.6-7.3-2.5c-12.6-4.2-26.2 2.6-30.4 15.2s2.6 26.2 15.2 30.4c1.9 .6 3.9 1.3 6 2c7.4 2.6 16.2 5.6 25.6 7.8V232c0 13.3 10.7 24 24 24s24-10.7 24-24V221.4c7.4-1.8 14.6-4.7 21.3-8.8c15.3-9.5 27-25.9 26.7-48.5c-.3-22-12.8-36.3-26.4-44.9c-12-7.5-26.8-12-37.9-15.3l0 0-.9-.3c-12.9-3.9-21.6-6.6-27.4-10.1c-2.4-1.5-3.2-2.4-3.3-2.6c0-.1 0-.3 0-.6c0-1.6 .4-2.3 .7-2.8c.4-.6 1.4-1.8 3.5-3c4.7-2.8 12-4.5 19.4-4.4c9.1 .1 19.3 2.1 30.2 5c12.8 3.4 26-4.2 29.4-17s-4.2-26-17-29.4c-5.6-1.5-11.7-3-18.2-4.2V24zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136V352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24V281.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9 0 0L167 393l0 0 16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16 0 0-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V436.8c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359l0 0-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 0 0 26.7-26.7 0 0 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24V352.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72V264.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8V136z"]
};
var faHandsUsd = faHandsHoldingDollar;
var faCube = {
  prefix: 'far',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M258.8 50.7c-1.8-.7-3.8-.7-5.7 0L63.6 122.6 256 198.2l192.4-75.6L258.8 50.7zM48 377.9c0 3.3 2.1 6.3 5.2 7.5L232 453.2V240.4L48 168.1V377.9zm232 75.3l178.8-67.8c3.1-1.2 5.2-4.2 5.2-7.5V168.1L280 240.4V453.2zM236.1 5.9c12.8-4.9 26.9-4.9 39.7 0l200 75.9C497.6 90 512 110.8 512 134.1V377.9c0 23.3-14.4 44.1-36.1 52.4l-200 75.9c-12.8 4.9-26.9 4.9-39.7 0l-200-75.9C14.4 422 0 401.2 0 377.9V134.1C0 110.8 14.4 90 36.1 81.7l200-75.9z"]
};
var faArrowDownTriangleSquare = {
  prefix: 'far',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM416 32c-9.9 0-19.1 5.2-24.2 13.7L307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1H502.9c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32zM368 432V336h96v96H368zM416 98.6L462.4 176H369.6L416 98.6zM320 432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v96z"]
};
var faSortShapesDown = faArrowDownTriangleSquare;
var faBitcoinSign = {
  prefix: 'far',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M64 24C64 10.7 74.7 0 88 0s24 10.7 24 24V64h32V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64.7c54 6 96 51.8 96 107.3c0 27.5-10.3 52.6-27.2 71.6C295.9 261.5 320 297.9 320 340c0 59.6-48.4 108-108 108H192v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H112v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H41.7C18.7 448 0 429.3 0 406.3V280v-6.3V232 101.6C0 80.8 16.8 64 37.6 64H64V24zM48 232H180c33.1 0 60-26.9 60-60s-26.9-60-60-60H48V232zm132 48H48V400H212c33.1 0 60-26.9 60-60s-26.9-60-60-60H180z"]
};
var faShutters = {
  prefix: 'far',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM13.7 128L.4 198c-.3 1.4-.4 2.7-.4 4.1C0 214.2 9.8 224 21.9 224H490.1c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70H449.4l9.1 48H53.4l9.1-48H13.7zM.4 326c-.3 1.4-.4 2.7-.4 4.1C0 342.2 9.8 352 21.9 352H490.1c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70H449.4l9.1 48H53.4l9.1-48H13.7L.4 326zm0 128c-.3 1.4-.4 2.7-.4 4.1C0 470.2 9.8 480 21.9 480H490.1c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70H449.4l9.1 48H53.4l9.1-48H13.7L.4 454z"]
};
var faShieldDog = {
  prefix: 'far',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160.9 270.2l-15 30c-1.2 2.5-1.9 5.2-1.9 8c0 7.1 4.3 13.6 10.8 16.4l98.7 42.3c1.7 .7 3.4 1.1 5.2 1.1c7.3 0 13.3-5.9 13.3-13.3V304h48c44.2 0 80-35.8 80-80V192c0-8.8-7.2-16-16-16H320l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H240v64c0 35.3-28.7 64-64 64c-5.2 0-10.3-.6-15.1-1.8zM160 144c-8.8 0-16 7.2-16 16v48c0 17.7 14.3 32 32 32s32-14.3 32-32V176 144h-8H160zm96 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSolarPanel = {
  prefix: 'far',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M114.5 48c-3.8 0-7.1 2.7-7.9 6.5L86.5 160H203.1L214.3 48H114.5zm83.8 160H77.4L54.8 326.5c-.9 4.9 2.8 9.5 7.9 9.5H185.5l12.8-128zm48.2 0L233.7 336H406.3L393.5 208h-147zm142.2-48L377.5 48h-115L251.3 160H388.7zm53 48l12.8 128H577.3c5 0 8.8-4.6 7.9-9.5L562.6 208H441.7zm111.8-48L533.4 54.5c-.7-3.8-4-6.5-7.9-6.5H425.7l11.2 112H553.5zM59.5 45.5C64.5 19.1 87.6 0 114.5 0h411c26.9 0 50 19.1 55 45.5l51.8 272c6.6 34.5-19.9 66.5-55 66.5H344v80h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V384H62.7c-35.1 0-61.6-32-55-66.5l51.8-272z"]
};
var faLockOpen = {
  prefix: 'far',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80v72c0 13.3 10.7 24 24 24s24-10.7 24-24V128C560 57.3 502.7 0 432 0S304 57.3 304 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128zM64 240H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16z"]
};
var faTableTree = {
  prefix: 'far',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", "M48 160V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160H128v64c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-5.6 0-11-1-16-2.7V320c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-26.5 0-48-21.5-48-48V224 160H48zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 240c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240zm80 80h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"]
};
var faHouseChimneyHeart = {
  prefix: 'far',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24V182.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM237.3 208c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
var faTally3 = {
  prefix: 'far',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", "M128 40c13.3 0 24 10.7 24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24zm128 0c13.3 0 24 10.7 24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24zM408 64V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V64c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faElevator = {
  prefix: 'far',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H80c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zm224 86.6l-64-64c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H432c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0zM64 176c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H64zM0 192c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zM272 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32zM128 352h64c26.5 0 48 21.5 48 48c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32c0-26.5 21.5-48 48-48zm176-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faMoneyBillTransfer = {
  prefix: 'far',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M558.1 64L535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-64.6 0 0 0H160v16c0 35.3-28.7 64-64 64H80v93.5L50.7 314.7 32 333.5V128c0-35.3 28.7-64 64-64H383.6l.4 0 174.1 0zM560 320V226.5l29.3-29.3L608 178.5V384c0 35.3-28.7 64-64 64H146.5l0 0-64.6 0 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23L256 400c.1 0 .3 0 .4 0H480V384c0-35.3 28.7-64 64-64h16zM320 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faMoneyBillTrendUp = {
  prefix: 'far',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M320 24c0 13.3 10.7 24 24 24h54.1L286.7 159.3 191.6 77.8c-9-7.7-22.4-7.7-31.3 .1l-120 104c-10 8.7-11.1 23.8-2.4 33.9s23.8 11.1 33.9 2.4l104.4-90.5 96.3 82.5c9.5 8.2 23.7 7.6 32.6-1.3l127-127V136c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zM103.5 304h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5v-49c28.9-3.6 51.9-26.6 55.5-55.5zM48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faHouseFloodWaterCircleArrowRight = {
  prefix: 'far',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M316.1 107.1c-3.5-16.5-9.4-32.2-17.2-46.7L378.1 4.4c8.3-5.9 19.4-5.9 27.7 0l192 136c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7l-2.1-1.5V281.4c-5.3-2.9-10.3-6.2-14.8-9.9c-9.7-8.2-21.3-13.1-33.2-14.6V144.1L392 53.4l-75.9 53.7zM143.9 318.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0zM112 430.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zM0 144a144 144 0 1 1 288 0A144 144 0 1 1 0 144zM140.7 76.7c-6.2 6.2-6.2 16.4 0 22.6L169.4 128H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faSquarePollHorizontal = {
  prefix: 'far',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM256 160c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24zm72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0zM192 352c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24z"]
};
var faPollH = faSquarePollHorizontal;
var faCircle = {
  prefix: 'far',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faCartCircleExclamation = {
  prefix: 'far',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H520.6L489.1 192.1c2.3-.1 4.6-.1 6.9-.1c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faSword = {
  prefix: 'far',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", "M507.3 4.7C503.7 1 498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7l33.9 33.9L408.1 69.1c4.7-4.7 10.8-7.8 17.4-8.9l31.6-5.3-5.3 31.6c-1.1 6.6-4.2 12.7-8.9 17.4L235.3 311.4l33.9 33.9L476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faBackwardFast = {
  prefix: 'far',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M16 424c0 13.3 10.7 24 24 24s24-10.7 24-24V287.9L238.6 440.6c5.4 4.8 12.4 7.4 19.6 7.4c16.5 0 29.8-13.3 29.8-29.8V287.9L462.6 440.6c5.4 4.8 12.4 7.4 19.6 7.4c16.5 0 29.8-13.3 29.8-29.8V93.8C512 77.3 498.7 64 482.2 64c-7.2 0-14.2 2.6-19.6 7.4L288 224.1V93.8C288 77.3 274.7 64 258.2 64c-7.2 0-14.2 2.6-19.6 7.4L64 224.1V88c0-13.3-10.7-24-24-24S16 74.7 16 88V424zM464 133.9V378.1L324.4 256 464 133.9zM240 378.1L100.4 256 240 133.9V378.1z"]
};
var faFastBackward = faBackwardFast;
var faRecycle = {
  prefix: 'far',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", "M181.5 40.9C197.7 15.3 226 0 256 0s58.3 15.3 74.5 40.9L392.8 139l6.6-31.8c2.7-13 15.4-21.3 28.3-18.7s21.3 15.4 18.7 28.3l-19.4 94.4c-1.4 6.7-5.6 12.5-11.5 15.9s-13.1 4.2-19.6 2l-91.4-30.4c-12.6-4.2-19.4-17.8-15.2-30.3s17.8-19.4 30.3-15.2l32.2 10.7L290 66.6C282.7 55.1 269.8 48 256 48s-26.7 7.1-34 18.6l-21.5 33.9c-7 11-21.4 14.4-32.6 7.7c-11.6-6.9-15.1-22-7.9-33.4l21.5-33.9zM439 255.5c11.2-6.7 25.6-3.3 32.6 7.7l26.8 42.2c8.8 13.9 13.5 30 13.6 46.4c.3 48.6-39 88.2-87.6 88.2l-137.2 0 24.8 22c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2s7.9 25.1-2 33.9L287.1 392l137.3 0c22 0 39.8-17.9 39.6-39.9c0-7.4-2.2-14.7-6.2-21l-26.8-42.2c-7.2-11.4-3.6-26.5 7.9-33.4zm-311.6 3.7l-6.7-32.8L54.2 331.1c-4 6.3-6.1 13.6-6.2 21c-.1 22 17.7 39.9 39.6 39.9l48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48.4 0C39 440-.3 400.5 0 351.9c.1-16.4 4.8-32.5 13.6-46.4L78.8 202.8 47.6 213.1c-12.6 4.2-26.2-2.6-30.3-15.2s2.6-26.2 15.2-30.3l91.4-30.4c6.5-2.2 13.6-1.4 19.6 2s10.1 9.2 11.5 15.9l19.4 94.4c2.7 13-5.7 25.7-18.7 28.3s-25.7-5.7-28.3-18.7z"]
};
var faUserAstronaut = {
  prefix: 'far',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M224 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm181.2 80.4C379 53.6 307.8 0 224 0S69 53.6 42.8 128.4C27.6 130.9 16 144.1 16 160v64c0 15.9 11.6 29.1 26.8 31.6c9.7 27.6 25.5 52.4 45.8 72.6C35.6 359.1 0 416.5 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-65.8-35.6-123.2-88.6-154.1c20.3-20.2 36.2-45 45.8-72.6c15.2-2.5 26.8-15.7 26.8-31.6V160c0-15.9-11.6-29.1-26.8-31.6zM319.7 358.5c44.5 18 77.1 59.3 82.6 108.7H336V448c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32v19.2H45.6c5.6-49.5 38.1-90.7 82.6-108.7C156.5 374.7 189.1 384 224 384s67.5-9.3 95.7-25.5zM160 128c-26.5 0-48 21.5-48 48v16c0 53 43 96 96 96h32c53 0 96-43 96-96V176c0-26.5-21.5-48-48-48H160zm39.3 45.5l6 21.2 21.2 6c3.3 .9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5zM176 448c8.8 0 16 7.2 16 16v48H160V464c0-8.8 7.2-16 16-16zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faInterrobang = {
  prefix: 'far',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M144 80c-44.2 0-80 35.8-80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v4.6c0 40.1-20.1 77.6-53.4 99.8l-52.3 34.9c-8.9 5.9-14.2 15.9-14.2 26.6v2 16c0 13.3-10.7 24-24 24s-24-10.7-24-24V328v-2V168c0-13.3 10.7-24 24-24s24 10.7 24 24v83.2l39.9-26.6c20-13.4 32.1-35.8 32.1-59.9V160c0-44.2-35.8-80-80-80H144zM128 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faPlaneSlash = {
  prefix: 'far',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L461 336h19c20.6 0 49.8-5.8 74.4-16.5c12.4-5.4 25-12.7 34.9-22.4c10-9.8 18.7-23.6 18.7-41.1c0-17.4-8.8-31.1-18.7-40.7c-9.9-9.6-22.4-16.9-34.8-22.4C530 182.1 500.7 176 480 176H413.8L317.7 25.8C307.4 9.7 289.6 0 270.5 0H229.9c-27.1 0-46.4 26.4-38.1 52.2l31.1 97.2L38.8 5.1zM288.3 200.7c.1-2.7-.3-5.4-1.1-8L240.9 48h29.6c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9L277.2 51.7 380.4 212.9c4.4 6.9 12 11.1 20.2 11.1l79.4 0c13.4 0 36.1 4.4 55.1 12.8c9.4 4.2 16.4 8.7 20.7 12.9c4.2 4.1 4.2 6.1 4.2 6.3v0c0 .6-.1 2.8-4.2 6.8c-4.3 4.2-11.2 8.6-20.6 12.7C516.3 283.8 493.6 288 480 288H400.6c-.3 0-.6 0-.9 0L288.3 200.7zm88.9 192.5l-37.9-29.8-62.1 97c-1.5 2.3-4 3.7-6.7 3.7H240.9l45.5-142.3L243.7 288 168 288c-7.6 0-14.7 3.6-19.2 9.6L108 352H83.6l27.4-88.9c1.4-4.6 1.4-9.5 0-14.1L84.3 162.4 39.6 127.2c-4.8 6.3-7.6 14.2-7.6 22.7c0 3.8 .6 7.5 1.7 11.1l0 0L62.9 256 33.7 350.9l0 0c-1.1 3.6-1.7 7.4-1.7 11.1C32 383 49 400 69.9 400H112c12.6 0 24.4-5.9 32-16l-19.2-14.4L144 384l36-48h51.4L191.8 459.8c-8.3 25.8 11 52.2 38.1 52.2l40.6 0c19.1 0 36.9-9.7 47.2-25.8l59.5-93z"]
};
var faCircleDashed = {
  prefix: 'far',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M27.7 232c12.3 0 22.5-9.3 25.2-21.3c5.3-23.9 14.7-46.2 27.4-66.2c6.6-10.4 6-24.2-2.8-32.9c-10.1-10.1-26.8-9.4-34.7 2.5c-18.2 27.3-31.3 58.3-37.9 91.6c-2.8 14 8.5 26.3 22.8 26.3zM144.5 80.4c20-12.7 42.3-22.1 66.2-27.4c12-2.7 21.3-12.9 21.3-25.2c0-14.3-12.3-25.6-26.3-22.8c-33.3 6.6-64.3 19.7-91.6 37.9c-11.9 7.9-12.6 24.6-2.5 34.7c8.7 8.7 22.5 9.4 32.9 2.8zM280 484.3c0 14.3 12.3 25.6 26.3 22.8c33.3-6.6 64.3-19.7 91.6-37.9c11.9-7.9 12.6-24.6 2.5-34.7c-8.7-8.7-22.5-9.4-32.9-2.8c-20 12.7-42.3 22.1-66.2 27.4c-12 2.7-21.3 12.9-21.3 25.2zM431.6 367.5c-6.6 10.4-6 24.2 2.8 32.9c10.1 10.1 26.8 9.4 34.7-2.5c18.2-27.3 31.3-58.3 37.9-91.6c2.8-14-8.5-26.3-22.8-26.3c-12.3 0-22.5 9.3-25.2 21.3c-5.3 23.9-14.7 46.2-27.4 66.2zm-320 66.8c-10.1 10.1-9.4 26.8 2.5 34.7c27.3 18.2 58.3 31.3 91.6 37.9c14 2.8 26.3-8.5 26.3-22.8c0-12.3-9.3-22.5-21.3-25.2c-23.9-5.3-46.2-14.7-66.2-27.4c-10.4-6.6-24.2-6-32.9 2.8zM42.9 397.9c7.9 11.9 24.6 12.6 34.7 2.5c8.7-8.7 9.4-22.5 2.8-32.9c-12.7-20-22.1-42.3-27.4-66.2c-2.7-12-12.9-21.3-25.2-21.3c-14.3 0-25.6 12.3-22.8 26.3c6.6 33.3 19.7 64.3 37.9 91.6zM400.4 77.6c10.1-10.1 9.4-26.8-2.5-34.7c-27.3-18.2-58.3-31.3-91.6-37.9c-14-2.8-26.3 8.5-26.3 22.8c0 12.3 9.3 22.5 21.3 25.2c23.9 5.3 46.2 14.7 66.2 27.4c10.4 6.6 24.2 6 32.9-2.8zm31.2 66.8c12.7 20 22.1 42.3 27.4 66.2c2.7 12 12.9 21.3 25.2 21.3c14.3 0 25.6-12.3 22.8-26.3c-6.6-33.3-19.7-64.3-37.9-91.6c-7.9-11.9-24.6-12.6-34.7-2.5c-8.7 8.7-9.4 22.5-2.8 32.9z"]
};
var faTrademark = {
  prefix: 'far',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M331.4 105.8c-6.1-8.4-17-11.9-26.8-8.7s-16.6 12.4-16.6 22.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24V193.5L444.6 342.2c4.5 6.2 11.7 9.8 19.4 9.8s14.9-3.7 19.4-9.8L592 193.5V392c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-10.4-6.7-19.6-16.6-22.8s-20.7 .3-26.8 8.7L464 287.3 331.4 105.8zM0 120c0 13.3 10.7 24 24 24h80V392c0 13.3 10.7 24 24 24s24-10.7 24-24V144h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 96 0 106.7 0 120z"]
};
var faBasketball = {
  prefix: 'far',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M304 458.4c0-.8 0-1.6 0-2.4c0-33.3 10.7-64.1 28.9-89.2l52.2 52.2c-23.5 18.6-51 32.2-81.1 39.4zM256.2 464c-.1 0-.1 0-.2 0c-48.8 0-93.7-16.8-129.1-44.9L256 289.9l42.6 42.6C271.9 366.6 256 409.4 256 456c0 2.7 .1 5.3 .2 8zm76.4-165.4L289.9 256 419.1 126.9C447.2 162.3 464 207.2 464 256c0 .1 0 .1 0 .2c-2.7-.1-5.3-.2-8-.2c-46.6 0-89.4 15.9-123.4 42.6zM458.4 304c-7.1 30.1-20.8 57.7-39.4 81.1l-52.2-52.2c25-18.2 55.9-28.9 89.2-28.9c.8 0 1.6 0 2.4 0zM256 222.1l-42.6-42.6C240.1 145.4 256 102.6 256 56c0-2.7-.1-5.3-.2-8c.1 0 .1 0 .2 0c48.8 0 93.7 16.8 129.1 44.9L256 222.1zm-76.9-76.9L126.9 92.9c23.5-18.6 51-32.2 81.1-39.4c0 .8 0 1.6 0 2.4c0 33.3-10.7 64.1-28.9 89.2zm-33.9 33.9C120.1 197.3 89.3 208 56 208c-.8 0-1.6 0-2.4 0c7.1-30.1 20.8-57.7 39.4-81.1l52.2 52.2zM48 255.8c2.7 .1 5.3 .2 8 .2c46.6 0 89.4-15.9 123.4-42.6L222.1 256 92.9 385.1C64.8 349.7 48 304.8 48 256c0-.1 0-.1 0-.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faBasketballBall = faBasketball;
var faForkKnife = {
  prefix: 'far',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M467.2 9.6c8 10.6 5.8 25.6-4.8 33.6l-122.7 92c-2.6 2-5.1 4.1-7.4 6.4l-1.9 1.9C318.6 155.3 312 171.3 312 188s6.6 32.7 18.4 44.5l6.5 6.5 0 0 0 0 6.5 6.5C355.3 257.4 371.3 264 388 264s32.7-6.6 44.5-18.4l1.9-1.9c2.3-2.3 4.5-4.8 6.4-7.4l92-122.7c8-10.6 23-12.8 33.6-4.8s12.8 23 4.8 33.6l-92 122.7c-3.3 4.4-7 8.6-10.9 12.6l-1.9 1.9c-20.8 20.8-49 32.5-78.4 32.5c-24.5 0-48.1-8.1-67.3-22.8L105 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L286.8 255.3C272.1 236.1 264 212.4 264 188c0-29.4 11.7-57.6 32.5-78.4l1.9-1.9c3.9-3.9 8.1-7.6 12.6-10.9l122.7-92c10.6-8 25.6-5.8 33.6 4.8zM521 55c9.4 9.4 9.4 24.6 0 33.9L405 205c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L487 55c9.4-9.4 24.6-9.4 33.9 0zM382.2 343.9l123 127.4c9.2 9.5 8.9 24.7-.6 33.9s-24.7 8.9-33.9-.6L313.4 341.8l12.1-12.1c17.6 8.5 36.8 13.4 56.7 14.2zM235.6 261.2L48 66.8V83.6c0 52.8 20.9 103.5 58.2 141l70.2 70.6c4.6 4.7 10.3 7.6 16.3 8.8l-36.3 36.3c-5-3.2-9.7-6.9-14-11.3L72.1 258.5C25.9 212 0 149.1 0 83.6V35.2C0 15.8 15.8 0 35.2 0c9.6 0 18.7 3.9 25.3 10.8L232 188.3c0 21.7 5 42.9 14.4 62.1l-10.7 10.7z"]
};
var faUtensilsAlt = faForkKnife;
var faSatelliteDish = {
  prefix: 'far',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M192 24c0 13.3 10.7 24 24 24c137 0 248 111 248 248c0 13.3 10.7 24 24 24s24-10.7 24-24C512 132.5 379.5 0 216 0c-13.3 0-24 10.7-24 24zm24 80c-13.3 0-24 10.7-24 24s10.7 24 24 24c79.5 0 144 64.5 144 144c0 13.3 10.7 24 24 24s24-10.7 24-24c0-106-86-192-192-192zm-7 233l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-40 40L71 199c-13.5-13.5-35.9-12.3-45.1 4.4C9.4 233.2 0 267.5 0 304C0 418.9 93.1 512 208 512c36.5 0 70.8-9.4 100.6-25.9c16.7-9.2 17.8-31.6 4.4-45.1L209 337zM48 304c0-18.1 3-35.5 8.5-51.6L259.6 455.5C243.5 461 226.1 464 208 464c-88.4 0-160-71.6-160-160z"]
};
var faBadgeCheck = {
  prefix: 'far',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faCircleUp = {
  prefix: 'far',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"]
};
var faArrowAltCircleUp = faCircleUp;
var faSlider = {
  prefix: 'far',
  iconName: 'slider',
  icon: [512, 512, [], "e252", "M352 144c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h32zM320 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V280h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H416V160c0-35.3-28.7-64-64-64H320zM0 256c0 13.3 10.7 24 24 24H224V232H24c-13.3 0-24 10.7-24 24z"]
};
var faMobileScreenButton = {
  prefix: 'far',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M64 448c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V368H64v80zm0-128H320V64c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16V320zM16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMobileAlt = faMobileScreenButton;
var faClockOneThirty = {
  prefix: 'far',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faInboxOut = {
  prefix: 'far',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M280 288c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L377 111c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-63-63V288zM149.1 405.5L130.3 368H48v96H464V368H381.7l-18.7 37.5C354.8 421.7 338.2 432 320 432H192c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384H320l18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h82.3c18.2 0 34.8 10.3 42.9 26.5z"]
};
var faInboxArrowUp = faInboxOut;
var faCloudSlash = {
  prefix: 'far',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-33.4-26.2C623.6 418.1 640 383 640 344c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-48.5 0-92.1 20.5-122.8 53.4L38.8 5.1zm140.4 110C200.9 93.4 230.9 80 264 80c36.3 0 68.8 16.1 90.9 41.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 27.8-12.9 52.6-33.1 68.8L179.2 115.1zM426.5 432H144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c16.4-5.8 28.2-19.9 31.2-36.6L98.1 173.3C96.7 182 96 190.9 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h23.4l-60.9-48z"]
};
var faVolumeHigh = {
  prefix: 'far',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.8 640 346.2 640 256s-41.5-170.8-106.4-223.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM159.9 201.9L272 102.3V409.7L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32z"]
};
var faVolumeUp = faVolumeHigh;
var faUsersRays = {
  prefix: 'far',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M7 7C16.4-2.3 31.6-2.3 41 7l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM633 7c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L599 7c9.4-9.4 24.6-9.4 33.9 0zM41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505zm592 0c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2h32 32c6.7 0 13.3 .7 19.6 2c1.1 .2 2.2 .5 3.3 .7c23.6 5.8 43.8 20.3 56.9 39.9c1.2 1.7 2.3 3.5 3.3 5.4c8.2 14.1 12.8 30.5 12.8 48c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32c0-17.5 4.7-33.9 12.8-48c12.9-22.3 34.6-39 60.3-45.3c1.1-.3 2.2-.5 3.3-.7zm96.2-162.6A72 72 0 1 1 275.4 240.5a72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32H288c-20.9 0-38.7 13.4-45.3 32H397.3zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3h69.3c9.8 0 18.9 2.6 26.8 7.2c-34.6 12.2-62.5 38.9-76.2 72.8H122.7C107.9 336 96 324.1 96 309.3zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8c7.9-4.6 17-7.2 26.8-7.2h69.3c29.5 0 53.3 23.9 53.3 53.3c0 14.7-11.9 26.7-26.7 26.7H470.7zM416 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faWallet = {
  prefix: 'far',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M88 32C39.4 32 0 71.4 0 120V392c0 48.6 39.4 88 88 88H424c48.6 0 88-39.4 88-88V216c0-48.6-39.4-88-88-88H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c22.1 0 40 17.9 40 40V392c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V120c0-22.1 17.9-40 40-40H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM384 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faOctagonCheck = {
  prefix: 'far',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faFlatbreadStuffed = {
  prefix: 'far',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120c27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5L281.5 191.3C267.4 181.6 250.4 176 232 176c-48.6 0-88 39.4-88 88c0 18.4 5.6 35.4 15.3 49.5zM275 243l-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86zM395 191l43-43 23-23c21.8 34 35 72.7 35 115c0 123.7-100.3 224-224 224c-42.4 0-81-13.2-115-35l66-66 86-86 86-86zM296 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faClipboardCheck = {
  prefix: 'far',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"]
};
var faCartCirclePlus = {
  prefix: 'far',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H520.6L489.1 192.1c2.3-.1 4.6-.1 6.9-.1c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faTruckClock = {
  prefix: 'far',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h32c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM480 512c-53 0-96-43-96-96h-8H352 320 256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96H558zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 192a112 112 0 1 1 224 0A112 112 0 1 1 96 192zm112-64c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H224V144c0-8.8-7.2-16-16-16z"]
};
var faShippingTimed = faTruckClock;
var faPool8Ball = {
  prefix: 'far',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm120-56a136 136 0 1 1 272 0 136 136 0 1 1 -272 0zm173.3-25.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2C207.2 184.5 200 199.4 200 216c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faFileAudio = {
  prefix: 'far',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 272V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376H112c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h17.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"]
};
var faTurnDownLeft = {
  prefix: 'far',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M6.5 271.6c-8.7 9.2-8.7 23.7 0 32.9l121.4 129c8.8 9.3 21 14.6 33.7 14.6c25.6 0 46.3-20.7 46.3-46.3l0-41.7 144 0c88.4 0 160-71.6 160-160l0-112c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 120c0 4.4-3.6 8-8 8l-152 0 0-41.7c0-25.6-20.7-46.3-46.3-46.3c-12.8 0-25 5.3-33.7 14.6L6.5 271.6zm153.5-93l0 61.5c0 13.3 10.7 24 24 24l176 0c30.9 0 56-25.1 56-56l0-120c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 112c0 61.9-50.1 112-112 112l-168 0c-13.3 0-24 10.7-24 24l0 61.5L57 288 160 178.5z"]
};
var faLockHashtag = {
  prefix: 'far',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", "M144 128v32H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 160V128C96 57.3 153.3 0 224 0s128 57.3 128 128v32h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H96zm0 48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H352 304 144 96zm88 16c13.3 0 24 10.7 24 24v24h32V248c0-13.3 10.7-24 24-24s24 10.7 24 24v24h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H288v32h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H288v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H208v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V320H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V248c0-13.3 10.7-24 24-24zm24 128h32V320H208v32z"]
};
var faChartRadar = {
  prefix: 'far',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36H344.3c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24L365.1 420.9c-4.3 7.4-12.2 12-20.8 12H167.7c-8.6 0-16.5-4.6-20.8-12L58.6 268zm231.5-87.2c3.7-6.1 5.8-13.2 5.8-20.8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9 .6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7c22.1 0 40-17.9 40-40c0-18.5-12.6-34.1-29.6-38.6L290.2 180.8zM202 271.9l47.5-63.4 31.7 79.2L202 271.9z"]
};
var faStaff = {
  prefix: 'far',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M238.8 57.5C256.4 22.3 292.4 0 331.8 0H408c57.4 0 104 46.6 104 104V207.9c0 42.8-26.1 80.8-65.1 96.5l-17.3 30.7c-4.3 7.7-14.1 10.4-21.8 6.1l-29.4-16.6L253.7 360.1 122.9 490.9C94.8 519 49.2 519 21.1 490.9l16.8-16.8L21.1 490.9C-7 462.8-7 417.2 21.1 389.1L96 314.2V288c0-8.8 7.2-16 16-16h26.2l21-21c12.5-12.5 28-21.6 45-26.5L368 177.7V144H355.9c-19.8 29.8-59.2 40.8-92.1 24.4c-35.6-17.8-50-61-32.2-96.6l7.2-14.3zm93-9.5c-21.2 0-40.6 12-50.1 31l-7.2 14.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l2.7-5.5c4.1-8.1 12.4-13.3 21.5-13.3H392c13.3 0 24 10.7 24 24v75.8c0 10.7-7.1 20.1-17.4 23.1L217.4 270.6c-9.2 2.6-17.5 7.5-24.2 14.2L55 423c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L224.2 321.8c2.9-2.9 6.5-5 10.4-6.1l188.8-54c24-6.9 40.6-28.8 40.6-53.8V104c0-30.9-25.1-56-56-56H331.8z"]
};
var faBurger = {
  prefix: 'far',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1H423.6c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224H61.1C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432H384c20.9 0 38.7-13.4 45.3-32H82.7c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32c0 53-43 96-96 96H128c-53 0-96-43-96-96zM16 288c0-17.7 14.3-32 32-32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32z"]
};
var faHamburger = faBurger;
var faUtilityPole = {
  prefix: 'far',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V80H128V56c0-13.3-10.7-24-24-24S80 42.7 80 56V80H64.2c-.2 0-.3 0-.5 0H48V56c0-13.3-10.7-24-24-24S0 42.7 0 56V88c0 22.1 17.9 40 40 40H83.2L232 227.2V296 488c0 13.3 10.7 24 24 24s24-10.7 24-24V296 227.2L428.8 128H472c22.1 0 40-17.9 40-40V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V80H448.2c-.2 0-.3 0-.5 0H432V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V80H280V24zm91.2 104L280 188.8V128h91.2zM232 188.8L140.8 128H232v60.8z"]
};
var faTransporter6 = {
  prefix: 'far',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", "M56.7 6.6L64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zm416 352L480 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWrench = {
  prefix: 'far',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M322.3 268c9.4 2.6 19.3 4 29.7 4c60.5 0 109.8-48 111.9-108l-25.3 25.3c-12 12-28.3 18.7-45.3 18.7H368c-35.3 0-64-28.7-64-64V118.6c0-17 6.7-33.3 18.7-45.3l0 0L348 48.1C288 50.1 240 99.5 240 160c0 10.3 1.4 20.3 4 29.7c4.6 16.6-.2 34.4-12.4 46.6L57.1 410.7c-5.9 5.8-9.1 13.8-9.1 22.1C48 450 62 464 79.2 464c8.3 0 16.2-3.3 22.1-9.1L275.7 280.4c12.2-12.2 30-16.9 46.6-12.4zM424.6 39.4l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3V144c0 8.8 7.2 16 16 16h25.4c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3c0 88.4-71.6 160-160 160c-14.7 0-28.9-2-42.3-5.7L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L197.7 202.3C194 188.9 192 174.7 192 160C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBugs = {
  prefix: 'far',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2zM144 224c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v64zm307.9 97.8l-32 55.4c-4.4 7.7-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9l32-55.4c4.4-7.7 14.2-10.3 21.9-5.9s10.3 14.2 5.9 21.9z"]
};
var faVectorPolygon = {
  prefix: 'far',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", "M360 72h48v48H360V72zm-8-40c-17.7 0-32 14.3-32 32v8H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32h8l0 192H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32v-8H320v8c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H373.6l-27.4-45.6c3.7-5.2 5.8-11.5 5.8-18.4V224c0-6.8-2.1-13.2-5.8-18.4L373.6 160H416c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM298.4 320l27.4 45.6c-3.7 5.2-5.8 11.5-5.8 18.4v8H128v-8c0-17.7-14.3-32-32-32H88l0-192h8c17.7 0 32-14.3 32-32v-8H320v8c0 6.8 2.1 13.2 5.8 18.4L298.4 192H256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h42.4zM40 440V392H88v48H40zm320 0V392h48v48H360zM40 120V72H88v48H40zM264 232h48v48H264V232z"]
};
var faDiagramNested = {
  prefix: 'far',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M144 80v96H48V80h96zM48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48H72v96c0 48.6 39.4 88 88 88h96v24c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v24H160c-22.1 0-40-17.9-40-40V224h24c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM400 336v96H304V336h96z"]
};
var faRupeeSign = {
  prefix: 'far',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 56C0 42.7 10.7 32 24 32h96c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304H48V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V280 56zM48 256h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48V256zm264.6 10.4c-1.2 7.9-.2 12.8 1 15.9s3.5 6.2 7.5 9.4c9.2 7.4 23.3 12.5 43.1 19.6l.8 .3c17.4 6.2 40 14.2 56.7 28.5c9 7.7 16.8 17.6 21.5 30.4c4.7 12.7 5.7 26.7 3.5 41.9c-3.9 26.6-19.1 46.5-41 57.6c-21 10.6-46.4 12.3-71.6 7.6l-.2 0 0 0c-9-1.7-20.2-5.7-29.5-9.2c-6.3-2.4-13-5.1-18.5-7.3l0 0 0 0c-2.7-1.1-5-2-6.9-2.8c-12.3-4.8-18.4-18.8-13.6-31.1s18.8-18.4 31.1-13.6c2.6 1 5.3 2.1 8.2 3.3l0 0 0 0c5.1 2.1 10.7 4.3 16.7 6.6c9.4 3.5 17 6 21.5 6.9c18.1 3.3 32.1 1.2 41.2-3.3c8.1-4.1 13.5-10.7 15.1-21.7c1.3-8.8 .4-14.5-1-18.3c-1.4-3.8-3.8-7.1-7.7-10.5c-9-7.7-22.9-13.1-42.4-20l-2.9-1c-16.8-5.9-38.1-13.5-54.1-26.2c-9-7.2-17.1-16.6-22.1-29s-6.2-26.1-4-40.8c7.8-52.8 62.2-74.5 112.6-65.2c7.1 1.3 28.4 6.1 36.5 8.7c12.6 4 19.7 17.4 15.7 30.1s-17.4 19.7-30.1 15.7c-5.5-1.7-24.7-6.1-30.8-7.3c-36.3-6.7-54.2 10.2-56.4 25z"]
};
var faRupee = faRupeeSign;
var faFileImage = {
  prefix: 'far',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2h48 32 40 72c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"]
};
var faCircleQuestion = {
  prefix: 'far',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faQuestionCircle = faCircleQuestion;
var faImageUser = {
  prefix: 'far',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm192 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4z"]
};
var faBuoy = {
  prefix: 'far',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h12.1L142.2 304H96c-17.7 0-32 14.3-32 32v16c0 13.3 1.8 26.1 5.2 38.3c15.8-7.3 33.9-7.9 50.2-1.5c-4.7-11.3-7.3-23.8-7.3-36.8H464c0 13.1-2.6 25.5-7.3 36.9c16.2-6.4 34.4-5.8 50.2 1.5c3.4-12.2 5.2-25.1 5.2-38.3V336c0-17.7-14.3-32-32-32H433.8L379.9 48H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM330.8 48l11.9 56.6L288 168.5l-54.8-63.9L245.2 48h85.7zM220.8 163.8l35.6 41.5-58.8 68.6 23.2-110.1zM288 242.2L341 304H235l53-61.8zm90.4 31.7l-58.8-68.6 35.6-41.5 23.2 110.1zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
var faPlaneDeparture = {
  prefix: 'far',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M154.5 87.6c9.2-3.8 19.4-4.1 28.8-.8L369 152.8c6.3 2.2 13.2 1.7 19.2-1.4l83.1-43.5c14.9-7.8 31.4-11.9 48.3-11.9h50.8c11.2 0 18.6 11.6 13.9 21.8c-17.2 36.8-46 67-81.9 85.8L251.8 335.1c-1.1 .6-2.4 .9-3.7 .9H126.7c-2.3 0-4.6-1-6.1-2.8L54.2 255.7l23-11.5c2.1-1.1 4.6-1.1 6.8-.2l58.2 25.9c6.7 3 14.4 2.7 20.9-.7l88.1-46.2c7.6-4 12.5-11.7 12.8-20.3s-3.9-16.7-11.2-21.3L124 100.4l30.5-12.7zm44.8-46c-20.6-7.3-43.1-6.7-63.3 1.7L91.3 62c-29.9 12.5-33.4 53.5-5.9 70.8L192 199.9l-40.9 21.4-47.6-21.2c-15.3-6.8-32.8-6.4-47.8 1.1L66.1 222 55.8 201.3 23.6 217.4C.3 229-5.8 259.4 11.1 279.2l73.1 85.3 17.6-15.1L84.2 364.4c10.6 12.4 26.2 19.6 42.5 19.6H248.1c9.1 0 18-2.2 26-6.4L524.5 246.1c45.3-23.8 81.5-61.7 103.1-108c19.6-42-11-90.1-57.4-90.1H519.5c-24.6 0-48.8 6-70.5 17.4L375.1 104 199.3 41.6zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faHandshakeSlash = {
  prefix: 'far',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368h46.5c5.5 9.6 15.9 16 27.7 16h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H584 544 505.1L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6H248.7c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zM263.9 181.5l44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1h48V320H456 440.6l-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.6 0 32-14.3 32-31.9c7.7 .5 14.9 3.8 20.4 9.3L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c7.3-7.3 12.8-15.6 16.6-24.5l-42-33.1c.8 8.5-2.1 17.2-8.6 23.7c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1l0 0-7-7-35.6-35.6C135.8 313 116.4 304.6 96 304V224 176v-4.4zM32 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm560-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBookBookmark = {
  prefix: 'far',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H352V206.7c0 13.4-15.5 20.9-26 12.5L272 176l-54 43.2c-10.5 8.4-26 .9-26-12.5V48H88C65.9 48 48 65.9 48 88V358.7z"]
};
var faBorderCenterH = {
  prefix: 'far',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232z"]
};
var faCanFood = {
  prefix: 'far',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M320 434.3c-3.4 3-10.2 7.5-21.7 12.2C273.5 456.6 235.9 464 192 464s-81.5-7.4-106.3-17.5c-11.5-4.7-18.3-9.2-21.7-12.2V289.4c14.2 6.1 31 11.3 49.7 15.1c7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5c18.7-3.8 35.5-8.9 49.7-15.1V434.3zm48 5.7V240 72c0-39.8-78.8-72-176-72S16 32.2 16 72V240 440c0 39.8 78.8 72 176 72s176-32.2 176-72zM304 72c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faTypewriter = {
  prefix: 'far',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", "M128 64c0-8.8 7.2-16 16-16H335.4c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3V160h48V96.6c0-17-6.7-33.3-18.7-45.3L380.7 18.7C368.7 6.7 352.4 0 335.4 0H144C108.7 0 80 28.7 80 64v96h48V64zM0 224v32c0 17.7 14.3 32 32 32V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H365.3c-8.5 0-16.6 3.4-22.6 9.4l-13.3 13.3c-6 6-14.1 9.4-22.6 9.4H205.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H32c-17.7 0-32 14.3-32 32zm80 64H432V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V288zm48 112v16c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm40-60a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40zm92-20a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faArrowRightFromArc = {
  prefix: 'far',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", "M48 256C48 141.1 141.1 48 256 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C114.6 0 0 114.6 0 256S114.6 512 256 512c13.3 0 24-10.7 24-24s-10.7-24-24-24C141.1 464 48 370.9 48 256zM392.3 134.4c-9.7-9-24.9-8.5-33.9 1.3s-8.5 24.9 1.3 33.9L426.9 232H184c-13.3 0-24 10.7-24 24s10.7 24 24 24H426.9l-67.2 62.4c-9.7 9-10.3 24.2-1.3 33.9s24.2 10.3 33.9 1.3l112-104c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104z"]
};
var faCircleK = {
  prefix: 'far',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.1-343.2c9.3-9.5 9.2-24.6-.3-33.9s-24.6-9.2-33.9 .3L208 239.8V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V298.5 360c0 13.3 10.7 24 24 24s24-10.7 24-24V308.3l30-30.5 70.7 96.4c7.8 10.7 22.9 13 33.5 5.2s13-22.9 5.2-33.5L272.1 243.1l73.1-74.3z"]
};
var faFaceHandOverMouth = {
  prefix: 'far',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1v10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM299.3 276.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faPopcorn = {
  prefix: 'far',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", "M32 156c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4H328.2 119.8 32.2c-.1-1.3-.2-2.7-.2-4zm22.3 84l62.2 224h215l62.2-224h-47L303.6 419.7c-2.1 8.6-10.7 13.9-19.3 11.8s-13.9-10.7-11.8-19.3L313.8 240H240V416c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H134.2l41.3 172.3c2.1 8.6-3.2 17.2-11.8 19.3s-17.2-3.2-19.3-11.8L101.3 240h-47zM224 192H419.8c15.6 0 28.2 12.6 28.2 28.2c0 2.5-.3 5.1-1 7.5L377.8 476.8C372 497.6 353.1 512 331.5 512h-215c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192H224z"]
};
var faHouseWater = {
  prefix: 'far',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V393c14.6-8.5 31.9-10.7 48-6.6V204.8L288 55.5 464 204.8V386.5c16.1-4.2 33.4-1.9 48 6.5V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM256 224h64v64H256V224zm-8-48c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V216c0-22.1-17.9-40-40-40H248zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
var faHouseFlood = faHouseWater;
var faObjectSubtract = {
  prefix: 'far',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M64 48l32 0V0H64C28.7 0 0 28.7 0 64V96H48l0-32c0-8.8 7.2-16 16-16zm160 0V0H128V48l96 0zM48 128H0v96H48l0-96zm0 128H0v32c0 35.3 28.7 64 64 64H96l0-48H64c-8.8 0-16-7.2-16-16l0-32zm80 96h32l48 0h16V304l-96 0v48zm32 32l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64l-64 0v48l64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-64H160zM352 208l0-48V128H304l0 96h48V208zm0-144c0-35.3-28.7-64-64-64H256V48l32 0c8.8 0 16 7.2 16 16V96h48V64zM256 304v48h32c35.3 0 64-28.7 64-64V256H304v32c0 8.8-7.2 16-16 16H256z"]
};
var faCodeBranch = {
  prefix: 'far',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3V256c20.1-15.1 45-24 72-24h96c39.8 0 72-32.2 72-72v-3.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V160c0 66.3-53.7 120-120 120H176c-39.8 0-72 32.2-72 72v3.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V352 156.3C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm240 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faWarehouseFull = {
  prefix: 'far',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40H504c22.1 0 40 17.9 40 40V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V240H144zM376 416h64c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V440c0-13.3 10.7-24 24-24zM176 312c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V312zm24 104h96c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V440c0-13.3 10.7-24 24-24z"]
};
var faWarehouseAlt = faWarehouseFull;
var faHatCowboy = {
  prefix: 'far',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M254.2 82.7c-2 2.8-4.4 6.7-7.1 11.8C236.8 114 226.9 142 218.2 173c-8.5 30.4-15.3 61-19.9 84.3c-.9 4.7-1.8 9.1-2.5 13.1c-16.8-5-32-10.6-45.7-16.6C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64s22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.4 0 84.4 152.2 97.9 221.9c-13.7 5.9-28.9 11.6-45.7 16.6c-.8-4-1.6-8.4-2.5-13.2c-4.6-23.3-11.3-54-19.9-84.3c-8.7-30.9-18.6-59-28.9-78.5c-2.7-5.1-5.1-9-7.1-11.8c-.5 .4-1 .9-1.6 1.4c-.5 .5-1.1 1-1.8 1.6l0 0 0 0C374 93.3 353.4 112 320 112s-54-18.7-62.3-26.2l0 0c-.7-.6-1.3-1.2-1.8-1.6c-.6-.5-1.2-1-1.6-1.4zM380.9 77l0 0c0 0 0 0 0 0l.1 0zm-121.7 0c0 0 0 0 0 0l.1 0s0 0 0 0zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"]
};
var faBridge = {
  prefix: 'far',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H72v64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H96 224 552c13.3 0 24-10.7 24-24s-10.7-24-24-24H504V80h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM456 80v64H376V80h80zM328 80v64H248V80h80zM200 80v64H120V80h80zM24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48V440c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V344c0-30.9 25.1-56 56-56h32c30.9 0 56 25.1 56 56v96c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40V336c0-26.5 21.5-48 48-48c13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96v96H408V344c0-57.4-46.6-104-104-104H272c-57.4 0-104 46.6-104 104v88H120V336c0-53-43-96-96-96z"]
};
var faPhoneFlip = {
  prefix: 'far',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4 .9l112 24C498.8 28.8 512 45.1 512 64v0c0 231.2-175.2 421.5-400.1 445.5c-9.8 1-19.7 1.8-29.6 2.2c0 0 0 0 0 0c0 0-.1 0-.1 0c-6.1 .2-12.1 .4-18.3 .4l0 0c-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM70.5 464C286.3 460.5 460.5 286.2 464 70.5L364.8 49.2l-43 100.4L357.6 179c18.2 14.9 22.9 40.8 11.1 61.2c-30.9 53.3-75.3 97.7-128.6 128.6c-20.4 11.8-46.3 7.1-61.2-11.1l-29.4-35.9-100.4 43L70.5 464zM464 64s0 0 0 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"]
};
var faPhoneAlt = faPhoneFlip;
var faArrowDownFromDottedLine = {
  prefix: 'far',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", "M241.5 472.4c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1L200 395.5V312 184c0-13.3 10.7-24 24-24s24 10.7 24 24V312v83.5l86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faFileDoc = {
  prefix: 'far',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
};
var faSquareQuarters = {
  prefix: 'far',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M52.7 84.7L224 256 395.3 84.7c-2.9-2.9-6.9-4.7-11.3-4.7H64c-4.4 0-8.4 1.8-11.3 4.7zm0 342.6c2.9 2.9 6.9 4.7 11.3 4.7H384c4.4 0 8.4-1.8 11.3-4.7L224 256 52.7 427.3zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faTruckFront = {
  prefix: 'far',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M80 48C62.3 48 48 62.3 48 80V232c4.2-3.2 8.7-6.1 13.3-8.7l40-85.8C113.2 112.2 138.6 96 166.6 96H345.4c28 0 53.4 16.2 65.2 41.6l40 85.8c4.6 2.6 9.1 5.5 13.3 8.7V80c0-17.7-14.3-32-32-32H80zM48 328v40c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V328c0-39.8-32.2-72-72-72H120c-39.8 0-72 32.2-72 72zM0 328V80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V328v40c0 26.2-12.6 49.4-32 64v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H80v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V432C12.6 417.4 0 394.2 0 368V328zM121.4 208H390.6l-23.4-50.1c-3.9-8.4-12.4-13.9-21.7-13.9H166.6c-9.3 0-17.8 5.4-21.7 13.9L121.4 208zM96 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCat = {
  prefix: 'far',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M361 0c10.9 0 21.3 4.3 29 12l36 36h44.1l36-36c7.7-7.7 18.1-12 29-12c22.6 0 41 18.3 41 41V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V41c0-22.6 18.3-41 41-41zm7 160c0 44.2 35.8 80 80 80s80-35.8 80-80V57.9L501.7 84.3C494.2 91.8 484 96 473.4 96H422.6c-10.6 0-20.8-4.2-28.3-11.7L368 57.9V160zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM285 182l4.4-.4c2.2 16.6 7 32.4 13.9 46.9l-14 1.3C188.9 238.9 112 323.1 112 423.9v.1c0 22.1 17.9 40 40 40H256V400c0-17.7-14.3-32-32-32h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c39.4 0 72.2 28.5 78.8 66l93-54.7c7.4-4.4 16.6-4.4 24.1-.1s12.1 12.2 12.1 20.8v96c0 8.8 7.2 16 16 16s16-7.2 16-16V319.2c16.9-1.7 33.1-6 48-12.5V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V394L304 441v23h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-48.6 0-88-39.4-88-88v-.1V184.5c0-20.2-15-37.2-35-39.7l-7.9-1C7.9 142.2-1.5 130.2 .2 117S13.8 94.5 27 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3V279c40-53.7 101.7-90.5 173-97z"]
};
var faTrashXmark = {
  prefix: 'far',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80h13.7H416h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H412.4L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80.1 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8H324.6c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zm62.2 81.9c7.8-7.8 20.5-7.8 28.3 0L224 259.7l49.9-49.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L252.3 288l49.9 49.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L224 316.3l-49.9 49.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L195.7 288l-49.9-49.9c-7.8-7.8-7.8-20.5 0-28.3z"]
};
var faCircleCaretLeft = {
  prefix: 'far',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-368 0c0 6.7 2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-208c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104c-4.9 4.5-7.7 10.9-7.7 17.6z"]
};
var faCaretCircleLeft = faCircleCaretLeft;
var faFiles = {
  prefix: 'far',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M160 368H384c8.8 0 16-7.2 16-16V128H352c-17.7 0-32-14.3-32-32V48H160c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16zm224 48H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H325.5c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64zM24 96c13.3 0 24 10.7 24 24V376c0 48.6 39.4 88 88 88H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24z"]
};
var faAnchorCircleExclamation = {
  prefix: 'far',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V464H240c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h48 48c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5H312V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faFaceClouds = {
  prefix: 'far',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M128 0c27.9 0 51.7 17.9 60.4 42.8C198.6 36 210.8 32 224 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64C28.7 160 0 131.3 0 96S28.7 32 64 32h8.6C83.6 12.9 104.3 0 128 0zM72.1 192h50c-6.5 20.2-10 41.7-10 64c0 80.2 45.4 149.9 112 184.6c.1 22.3 7.2 42.9 19.3 59.7C139.4 467.7 64 370.6 64 256c0-22.1 2.8-43.5 8.1-64zM307.4 48.4C296.8 29.8 280.1 15.2 260.1 7c19.2-4.6 39.2-7 59.9-7C461.4 0 576 114.6 576 256c0 14.8-1.3 29.3-3.7 43.5c-12.5-10.8-28.3-17.8-45.7-19.2c.9-8 1.4-16.1 1.4-24.3c0-114.9-93.1-208-208-208c-4.2 0-8.4 .1-12.6 .4zM208.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368c0-44.2 35.8-80 80-80c29.3 0 54.9 15.8 68.9 39.3c8.8-9.4 21.3-15.3 35.1-15.3c26.5 0 48 21.5 48 48c0 2.7-.2 5.4-.7 8h.7c39.8 0 72 32.2 72 72s-32.2 72-72 72H328c-39.8 0-72-32.2-72-72s32.2-72 72-72h8z"]
};
var faUserCrown = {
  prefix: 'far',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M144 128H304v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128zm0-108.8l-.1-.1c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5C121.5 1.2 118 0 114.4 0H112c-8.8 0-16 7.2-16 16V39v3.2 .1V144c0 70.7 57.3 128 128 128s128-57.3 128-128V42.3v-.1V39 16c0-8.8-7.2-16-16-16h-2.4c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3 .2-.6 .4-.8 .6l-.1 .1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4L178.9 21.2c-11 6.3-24.7 5.5-34.9-2zM168 352H280c63.6 0 115.6 49.5 119.7 112H48.3c4.1-62.5 56.2-112 119.7-112zm0-48C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168z"]
};
var faTruckField = {
  prefix: 'far',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M336 80c8.8 0 16 7.2 16 16v8V224v96 16H243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64V288 128 96c0-8.8 7.2-16 16-16H336zM16 283.7V336v1.4C6.7 340.7 0 349.5 0 360s6.7 19.3 16 22.6V384h8H64c0 53 43 96 96 96s96-43 96-96h96 32c0 53 43 96 96 96s96-43 96-96h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V288c0-35.3-28.7-64-64-64h-5l-.3-.7L486.4 112.2c-9.2-19.6-29-32.2-50.7-32.2H398c-7.1-27.6-32.2-48-62-48H80C44.7 32 16 60.7 16 96v36.3C6.4 137.8 0 148.2 0 160v96c0 11.8 6.4 22.2 16 27.7zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM485.9 224H400V128h35.7c3.1 0 5.9 1.8 7.2 4.6l43 91.4zM528 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faRoute = {
  prefix: 'far',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M438.6 155.7c-7.2 11.5-15 22.6-22.6 32.7c-7.5-10.1-15.4-21.2-22.6-32.7C375.7 127.3 368 106.3 368 96c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.3-7.7 31.3-25.4 59.7zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 33.3 25.9 77.3 50.8 112H328c-48.6 0-88 39.4-88 88s39.4 88 88 88h96c22.1 0 40 17.9 40 40s-17.9 40-40 40H177.8c-2.7 3.8-5.5 7.6-8.2 11.2c-10.7 14.2-21.3 26.9-30 36.8H424c48.6 0 88-39.4 88-88s-39.4-88-88-88H328c-22.1 0-40-17.9-40-40s17.9-40 40-40h84.9c5.1 1.1 10.7-.6 14.5-5zM118.9 408.4c-7.3 11-15.3 21.7-22.9 31.2c-7.6-9.5-15.6-20.2-22.9-31.2C55.4 381.7 48 361.9 48 352c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.9-7.4 29.7-25.1 56.4zm19 55.6c25.9-33.1 54.1-77.3 54.1-112c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0c.1-.1 .2-.2 .3-.3c.3-.3 .6-.7 .9-1c2.8-3.1 6-6.7 9.5-10.7c.1-.1 .1-.1 .2-.2c6.1-7 13-15.2 20-24.2z"]
};
var faCartCircleCheck = {
  prefix: 'far',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H520.6L489.1 192.1c2.3-.1 4.6-.1 6.9-.1c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
var faClipboardQuestion = {
  prefix: 'far',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM105.8 229.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V328c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H158.6c-23.7 0-44.8 14.9-52.8 37.3zM224 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPanorama = {
  prefix: 'far',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", "M48 80.9C72.3 88.8 177.5 120 320 120s247.7-31.2 272-39.1V431.1c-9.8-3.2-32.9-10.2-66.3-17.4c-.5-1-1-1.9-1.6-2.8l-136-208c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9L264.8 330l-29.5-40.2c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8l-88 120c-1.3 1.8-2.4 3.8-3.1 5.8c-28.7 6.5-48.6 12.6-57.5 15.5V80.9zM579.6 34.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCommentMedical = {
  prefix: 'far',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM224 160v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272h48c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H288V160c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faTeethOpen = {
  prefix: 'far',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", "M480 48H96C69.5 48 48 69.5 48 96v29.4C63.9 102.8 90.2 88 120 88c15.2 0 29.5 3.9 42 10.7C178.1 77.6 203.5 64 232 64c21.3 0 40.8 7.5 56 20.1C303.2 71.5 322.7 64 344 64c28.5 0 53.9 13.6 70 34.7C426.5 91.9 440.8 88 456 88c29.8 0 56.1 14.8 72 37.4V96c0-26.5-21.5-48-48-48zm0 208H432 368 320 256 208 144 96 64c-35.3 0-64-28.7-64-64V96C0 43 43 0 96 0H480c53 0 96 43 96 96v96c0 35.3-28.7 64-64 64H480zm0-48c8.8 0 16-7.2 16-16V176c0-22.1-17.9-40-40-40c-9.2 0-17.6 3.1-24.3 8.3c-2.9 2.2-5.5 4.8-7.7 7.7c-5 6.7-8 15-8 24v16c0 8.2 6.1 14.9 14 15.9c.6 .1 1.3 .1 2 .1h48zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9V176 152c0-6.9-1.7-13.4-4.8-19c-6.8-12.5-20-21-35.2-21c-11.2 0-21.3 4.6-28.6 12c-7.1 7.2-11.4 17.1-11.4 28v40c0 8.2 6.1 14.9 14 15.9c.7 .1 1.3 .1 2 .1h48zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9V152c0-10.9-4.4-20.8-11.4-28c-7.3-7.4-17.4-12-28.6-12c-15.2 0-28.4 8.5-35.2 21c-3.1 5.7-4.8 12.1-4.8 19v24 16c0 8.2 6.1 14.9 14 15.9c.7 .1 1.3 .1 2 .1h48zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9V176c0-9-3-17.3-8-24c-2.2-2.9-4.8-5.5-7.7-7.7c-6.7-5.2-15.2-8.3-24.3-8.3c-22.1 0-40 17.9-40 40v16c0 8.8 7.2 16 16 16h48zM480 464c26.5 0 48-21.5 48-48v-5.4c-15.9 22.6-42.2 37.4-72 37.4c-21.3 0-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1c-29.8 0-56.1-14.8-72-37.4V416c0 26.5 21.5 48 48 48H480zm0-128H432c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9v8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16zm-112 0H320c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9v8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-8.2-6.1-14.9-14-15.9c-.6-.1-1.3-.1-2-.1zm112-48h32c35.3 0 64 28.7 64 64v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-35.3 28.7-64 64-64H96h48 64 48 64 48 64 48zM96 336c-8.8 0-16 7.2-16 16v8c0 22.1 17.9 40 40 40c11.2 0 21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-8.2-6.1-14.9-14-15.9c-.7-.1-1.3-.1-2-.1H96zm112 0c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9v8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-8.2-6.1-14.9-14-15.9c-.7-.1-1.3-.1-2-.1H208z"]
};
var faUserTieHairLong = {
  prefix: 'far',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 261.9 58.1 272 70.6 272H224 377.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5V128C352 57.3 294.7 0 224 0zM168.2 511.1l-.2 .9H280l-.2-.9H417.3c17 0 30.7-13.8 30.7-30.7c0-79.6-57.6-145.7-133.5-158.9c-6.6-1.1-12.9 2.4-15.9 8.4l-44 87.9-15.8-58.6 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-15.8 58.6-44-87.9c-3-6-9.4-9.5-15.9-8.4C57.6 334.7 0 400.8 0 480.4c0 17 13.8 30.7 30.7 30.7H168.2zM118.5 375.5l43.8 87.7H49.3c6.1-39.8 33-72.9 69.2-87.7zm167.2 87.7l43.8-87.7c36.2 14.8 63.1 47.8 69.2 87.7h-113z"]
};
var faFileCircleMinus = {
  prefix: 'far',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M64 464H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faHeadSideMedical = {
  prefix: 'far',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64V336h.4c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0H224C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zM192 112v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H256V112c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faTags = {
  prefix: 'far',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", "M345 39.1c-9.3-9.4-24.5-9.5-33.9-.2s-9.5 24.5-.2 33.9L438.6 202.1c33.9 34.3 33.9 89.4 0 123.7L326.7 439.1c-9.3 9.4-9.2 24.6 .2 33.9s24.6 9.2 33.9-.2L472.8 359.6c52.4-53 52.4-138.2 0-191.2L345 39.1zM242.7 50.7c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80V229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168zM48 80H197.5c4.2 0 8.3 1.7 11.3 4.7l168 168c6.2 6.2 6.2 16.4 0 22.6L243.3 408.8c-6.2 6.2-16.4 6.2-22.6 0l-168-168c-3-3-4.7-7.1-4.7-11.3V80zm96 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faWineGlass = {
  prefix: 'far',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M184 464V350c44.4-7.5 81.5-35.5 101.7-73.6c13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0H264 56 48.2c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350V464H72c-1 0-2.1 .1-3.1 .2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8c.9 .1 1.9 .2 2.9 .2l.3 0h88 88c1 0 2.1-.1 3.1-.2c11.8-1.5 20.9-11.6 20.9-23.8c0-12.2-9.1-22.2-20.8-23.8c-.9-.1-1.9-.2-2.9-.2l-.3 0H184zM78.2 48H241.8l6.3 80H71.9l6.3-80zM68.1 176H251.9l2.1 26.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7L68.1 176z"]
};
var faForwardFast = {
  prefix: 'far',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M496 424c0 13.3-10.7 24-24 24s-24-10.7-24-24V287.9L273.4 440.6c-5.4 4.8-12.4 7.4-19.6 7.4c-16.5 0-29.8-13.3-29.8-29.8V287.9L49.4 440.6C44 445.4 37 448 29.8 448C13.3 448 0 434.7 0 418.2V93.8C0 77.3 13.3 64 29.8 64C37 64 44 66.6 49.4 71.4L224 224.1V93.8C224 77.3 237.3 64 253.8 64c7.2 0 14.2 2.6 19.6 7.4L448 224.1V88c0-13.3 10.7-24 24-24s24 10.7 24 24V424zM48 133.9V378.1L187.6 256 48 133.9zM272 378.1L411.6 256 272 133.9V378.1z"]
};
var faFastForward = faForwardFast;
var faFaceMehBlank = {
  prefix: 'far',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faMehBlank = faFaceMehBlank;
var faUserRobot = {
  prefix: 'far',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H144c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H240V16zm96 128v96c0 17.7-14.3 32-32 32V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H240V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H176V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H304c17.7 0 32 14.3 32 32zm64 304v16H304V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H240V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H176V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H48l0-16c0-26.5 21.5-48 48-48H352c26.5 0 48 21.5 48 48zM160 512h64 64H400c26.5 0 48-21.5 48-48V448c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48H160zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM208 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSquareParking = {
  prefix: 'far',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM184 272h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H184v96zm64 48H184v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V296 160c0-17.7 14.3-32 32-32h80c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParking = faSquareParking;
var faCardDiamond = {
  prefix: 'far',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96z"]
};
var faFaceZipper = {
  prefix: 'far',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", "M389.2 394.3l29.1 58.1c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5zm91.3 38.2l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17zM256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c42.5 0 82-12.7 114.9-34.6l18.7 37.3c1 2 2 3.9 3.1 5.7C353.2 497.5 306.3 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 34.9-7 68.1-19.6 98.4l-43.1-21.5c9.5-23.8 14.7-49.7 14.7-76.9c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 320c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM160 336v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFaceRaisedEyebrow = {
  prefix: 'far',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 352c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM328.8 141.8l-29.5 29.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l29.5-29.5c25-25 66.6-20.9 86.2 8.5l4.9 7.4c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7zM128 144h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHouseSignal = {
  prefix: 'far',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M320.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L512 198.4V360c0 30.9-25.1 56-56 56H278.1c-4.7-16.7-11.1-32.8-18.8-48H456c4.4 0 8-3.6 8-8V159.3L336 55 208 159.3V298.7c-14.5-14.1-30.6-26.5-48-37V198.4l-24.8 20.2c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM312 192h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM24 256c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 376c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"]
};
var faSquareChevronUp = {
  prefix: 'far',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm241 71L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faChevronSquareUp = faSquareChevronUp;
var faNfcSymbol = {
  prefix: 'far',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M357.4 473.6c7.7 7.2 19.2 8.5 28.3 3.2C461.4 433 512 349.3 512 256s-50.6-177-126.3-220.8c-11.5-6.6-26.2-2.7-32.8 8.8s-2.7 26.2 8.8 32.8C422.7 112.1 464 180.1 464 256c0 69.6-34.7 132.6-87.6 169.8L200.3 262.4c-9.7-9-24.9-8.4-33.9 1.3s-8.4 24.9 1.3 33.9l189.7 176zM154.6 38.4c-7.7-7.2-19.2-8.5-28.3-3.2C50.6 79 0 162.7 0 256s50.6 177 126.3 220.8c11.5 6.6 26.2 2.7 32.8-8.8s2.7-26.2-8.8-32.8C89.3 399.9 48 331.9 48 256c0-69.6 34.7-132.6 87.6-169.8L311.7 249.6c9.7 9 24.9 8.4 33.9-1.3s8.4-24.9-1.3-33.9L154.6 38.4z"]
};
var faBarsProgress = {
  prefix: 'far',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", "M464 112v64H320V112H464zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM464 336v64H192V336H464zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"]
};
var faTasksAlt = faBarsProgress;
var faFaucetDrip = {
  prefix: 'far',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V45L96 32C78.3 32 64 46.3 64 64s14.3 32 32 32L200 83v45H181.3c-14.9 0-29.1 5.9-39.6 16.4L126.1 160H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H136c6.4 0 12.5-2.5 17-7l22.6-22.6c1.5-1.5 3.5-2.3 5.7-2.3h93.5c2.1 0 4.2 .8 5.7 2.3L303 201c4.5 4.5 10.6 7 17 7h40c57.4 0 104 46.6 104 104v16c0 4.4-3.6 8-8 8H408c-4.4 0-8-3.6-8-8c0-30.9-25.1-56-56-56H311.7c-8.2 0-15.8 4.2-20.2 11.1C277.2 305.3 252.3 320 224 320s-53.2-14.7-67.4-36.9c-4.4-6.9-12-11.1-20.2-11.1H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H124.1c23.4 29.2 59.5 48 99.9 48s76.5-18.8 99.9-48H344c4.4 0 8 3.6 8 8c0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56V312c0-83.9-68.1-152-152-152H329.9l-15.6-15.6c-10.5-10.5-24.7-16.4-39.6-16.4H248V83L352 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L248 45V24zM420.8 423.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4z"]
};
var faArrowsToLine = {
  prefix: 'far',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", "M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm241 71c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V488c0 13.3 10.7 24 24 24s24-10.7 24-24V401.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"]
};
var faDolphin = {
  prefix: 'far',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M80 160c0 13.3 2.3 26 6.5 37.8c3.9 10.8-.4 22.8-10.2 28.7L56.8 238.2 44.7 217.9l12.1 20.2c-5.5 3.3-8.8 9.2-8.8 15.6c0 10.1 8.2 18.2 18.2 18.2H192h24 32.9c6.3 0 12.3 2.5 16.8 6.8L304 316.3V296c0-13.3 10.7-24 24-24h16c48.6 0 88 39.4 88 88v8c0 .9 0 1.8 0 2.6c19.9-21.2 32-49.6 32-81c0-60.8-22.4-116.2-59.4-158.7c-7.2-8.2-7.9-20.3-1.7-29.3c10.4-15.3 23.4-35.5 31.4-51.9c-27.3 4-58.4 14.3-84.2 24.6c-6.4 2.5-13.5 2.2-19.6-.8C297.9 57.2 261.2 48 222.3 48H192C130.1 48 80 98.1 80 160zM277.7 408H344c22.1 0 40-17.9 40-40v-8c0-19.4-13.7-35.5-32-39.2v1.9c0 25-20.3 45.3-45.3 45.3c-11.8 0-23.2-4.6-31.7-12.9L239.1 320H216 192 66.2C29.6 320 0 290.4 0 253.8C0 230.5 12.2 209 32.1 197l3.7-2.2C33.3 183.6 32 171.9 32 160C32 71.6 103.6 0 192 0h30.3C265 0 305.6 9.3 342.2 25.9C374.9 13.5 418.7 0 456 0c7.8 0 17.9 2.4 25.2 11.3c6.7 8.1 7.5 17.4 7.3 23.2c-.4 11.3-5.2 23.4-9.7 33.1c-7 15-17.1 31.8-26.4 46.2C489.8 162.5 512 223.5 512 289.7C512 381.5 437.5 456 345.7 456H344 277.7c-19.9 34.5-56.8 56-97 56H176c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L190.1 432l-28.4-56.8c-2.5-5-2.2-10.9 .7-15.6s8.1-7.6 13.6-7.6h4.7c40.2 0 77.1 21.5 97 56zM136 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faArrowUpRight = {
  prefix: 'far',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", "M328 96c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9L73 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l231-231H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H328z"]
};
var faCircleR = {
  prefix: 'far',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h44l64.8 86.4c8 10.6 23 12.8 33.6 4.8s12.8-23 4.8-33.6L309.8 285c33.6-9.5 58.2-40.4 58.2-77c0-44.2-35.8-80-80-80H184zm80 112H208V176h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H264z"]
};
var faCartFlatbed = {
  prefix: 'far',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H72c4.4 0 8 3.6 8 8V408c0 30.9 25.1 56 56 56h24c0 26.5 21.5 48 48 48s48-21.5 48-48H448c0 26.5 21.5 48 48 48s48-21.5 48-48h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H496 208 136c-4.4 0-8-3.6-8-8V56c0-30.9-25.1-56-56-56H24zM240 80h96v96c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L400 163.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V80h96V304H240V80zm-48 0V304c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48z"]
};
var faDollyFlatbed = faCartFlatbed;
var faBanSmoking = {
  prefix: 'far',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M92.9 126.9L385.1 419.1C349.7 447.2 304.8 464 256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1zm165 97.1L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L353.9 320H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H257.9zm32 32H384v32H321.9l-32-32zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM112 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H240.8l-96-96H112z"]
};
var faSmokingBan = faBanSmoking;
var faCircleSortUp = {
  prefix: 'far',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zm0 310.6c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zM313.4 320H198.6L256 377.4 313.4 320z"]
};
var faSortCircleUp = faCircleSortUp;
var faTerminal = {
  prefix: 'far',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M6.3 72.2c-9-9.8-8.3-24.9 1.4-33.9s24.9-8.3 33.9 1.4l184 200c8.5 9.2 8.5 23.3 0 32.5l-184 200c-9 9.8-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9L175.4 256 6.3 72.2zM248 432H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMobileButton = {
  prefix: 'far',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M80 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H80zM16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHouseMedicalFlag = {
  prefix: 'far',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M496 24v8H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H496V512H448V192 32 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM286.3 36.7L416 133v59.8L272 85.9 112 204.6V432c0 17.7 14.3 32 32 32l256 0c5.8 0 11.3-1.6 16-4.3v50.7c-5.2 1-10.5 1.6-16 1.6l-256 0c-44.2 0-80-35.8-80-80V240.2L38.3 259.3c-10.6 7.9-25.7 5.7-33.6-5s-5.7-25.7 5-33.6l248-184c8.5-6.3 20.1-6.3 28.6 0zM240 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304v48c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V320H192c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faBasketShopping = {
  prefix: 'far',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192H404.3L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192h36.1H544h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H532L476.1 463.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L44 240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8H81.5h36.1L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM93.5 240l53 211.9c1.8 7.1 8.2 12.1 15.5 12.1H414c7.3 0 13.7-5 15.5-12.1l53-211.9H93.5zM224 312v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24s24 10.7 24 24zm64-24c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zm112 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faShoppingBasket = faBasketShopping;
var faTape = {
  prefix: 'far',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M224 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zM362.6 432c52-41 85.4-104.6 85.4-176C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H362.6zM224 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faChestnut = {
  prefix: 'far',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M154 90.5c13.9-11.4 27.8-22.7 41.1-34.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c13.3 12.1 27.2 23.4 41.1 34.8c19.6 16.1 39.3 32.1 57.3 50.2C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128H128C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3c18.1-18.1 37.7-34.1 57.3-50.2zM393.3 384H54.7C67 412.3 95.2 432 128 432H320c32.8 0 61-19.7 73.3-48zm-76-209.4c-13.6-13.6-28.6-26.3-45.2-39.9c-2.7-2.2-5.5-4.5-8.2-6.8l0 0c-12.8-10.5-26.6-21.7-39.9-33.6c-13.3 11.9-27.1 23.1-39.9 33.6l0 0c-2.8 2.3-5.6 4.5-8.2 6.8c-16.6 13.6-31.6 26.3-45.2 39.9C88.9 216.4 53.4 268 48.6 336H399.4c-4.8-68-40.3-119.6-82.1-161.4z"]
};
var faBusSimple = {
  prefix: 'far',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M51.5 96H397.2C381.4 78.9 335.2 48 224 48C121.8 48 69.8 78.3 51.5 96zM400 144H48v80H400V144zm0 128H48V376c0 13.3 10.7 24 24 24H300.2 376c13.3 0 24-10.7 24-24V272zM10.2 70C35.9 38.7 103.8 0 224 0C352.6 0 414 38.6 438.4 70.6c7.5 9.8 9.6 20.9 9.6 29.9V376c0 25-12.7 47-32 59.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H300.2 80v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V435.9C12.7 423 0 401 0 376V100.4C0 91.6 2 80 10.2 70zM112 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBusAlt = faBusSimple;
var faEye = {
  prefix: 'far',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faFaceSadCry = {
  prefix: 'far',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M400 406.1V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V440.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V406.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48V320c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSadCry = faFaceSadCry;
var faHeat = {
  prefix: 'far',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M176 32c13.3 0 24 10.7 24 24v88c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6C167.2 236.2 152 190.7 152 144V56c0-13.3 10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V418.1c0-33.2-9.8-65.6-28.2-93.2L36.3 277.7C12.6 242.2 0 200.5 0 157.9V120c0-13.3 10.7-24 24-24zm328 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V418.1c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3C316.6 242.2 304 200.5 304 157.9V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTicketAirline = {
  prefix: 'far',
  iconName: 'ticket-airline',
  icon: [640, 512, [], "e29a", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V349c-41.4-10.7-72-48.2-72-93s30.6-82.3 72-93V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64v61.3c0 11.2-12.8 18.7-24 18.7c-26.5 0-48 21.5-48 48s21.5 48 48 48c11.2 0 24 7.5 24 18.7V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm432 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM186.7 224l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5h31.1c8.5 0 16.4 4.5 20.7 11.9L262.7 224h40.3c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288H262.7l-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9H171.1c-5.5 0-9.3-5.4-7.6-10.5L186.7 288H144l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H98.2c-5.2 0-9-4.9-7.8-9.9L103 259.9c.6-2.5 .6-5.2 0-7.8L90.5 201.9c-1.3-5 2.6-9.9 7.8-9.9H112c5 0 9.8 2.4 12.8 6.4L144 224h42.7z"]
};
var faBootHeeled = {
  prefix: 'far',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", "M31.3 0C14 0 0 14 0 31.3c0 1.8 .1 3.9 .6 6.2C2.6 47.1 24 154.3 24 232c0 33.2-12.8 93.5-19.7 123.2C1.6 367 0 379.3 0 391.8V440v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V465.3l121.6 40.5c12.2 4.1 25 6.2 37.9 6.2H456h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V430.7c0-28.1-16.3-53.6-41.8-65.4L313.8 307.9c-25.5-11.8-41.8-37.3-41.8-65.4V24c0-13.3-10.7-24-24-24H31.3zM432 430.7V464H287.6c-7.7 0-15.4-1.2-22.8-3.7L135.6 417.2c-2.4-.8-5-1.2-7.6-1.2H104 48V391.8c0-8.5 1.1-17.2 3.1-25.8C57.6 337.7 72 271.8 72 232C72 167.4 58.5 85.7 51.5 48H96V232c0 13.3 10.7 24 24 24s24-10.7 24-24V48h80V242.6c0 46.8 27.2 89.3 69.7 109l124.3 57.4c8.5 3.9 13.9 12.4 13.9 21.8z"]
};
var faArrowsMinimize = {
  prefix: 'far',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M23 23c9.4-9.4 24.6-9.4 33.9 0l119 119V56c0-13.3 10.7-24 24-24s24 10.7 24 24V200c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h86.1L23 57c-9.4-9.4-9.4-24.6 0-33.9zM489 23c9.4 9.4 9.4 24.6 0 33.9l-119 119H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24v86.1L455 23c9.4-9.4 24.6-9.4 33.9 0zM56 336c-13.3 0-24-10.7-24-24s10.7-24 24-24H200c13.3 0 24 10.7 24 24V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V369.9L57 489c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119H56zm232-24c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H369.9L489 455c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V312z"]
};
var faCompressArrows = faArrowsMinimize;
var faAudioDescription = {
  prefix: 'far',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm213.5 77.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"]
};
var faPersonMilitaryToPerson = {
  prefix: 'far',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M71 12.5L182.2 .1C191.7-1 200 6.5 200 16V30.1c0 8.8-7.2 16-16 16H72.9C63.6 46.1 56 38.6 56 29.2c0-8.6 6.5-15.8 15-16.8zM384 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM336 256v16h96V256c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm-48 0c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM66 80H190c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5 .7-10.9 2-16zM224 432c0 6.9-3 13.5-8.2 18.1l-64 56c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9L136.1 456 24 456c-13.3 0-24-10.7-24-24s10.7-24 24-24l112.1 0-15.9-13.9c-10-8.7-11-23.9-2.3-33.9s23.9-11 33.9-2.3l64 56c5.2 4.6 8.2 11.1 8.2 18.1zm72.2 18.1c-5.2-4.6-8.2-11.1-8.2-18.1s3-13.5 8.2-18.1l64-56c10-8.7 25.1-7.7 33.9 2.3s7.7 25.1-2.3 33.9L375.9 408 488 408c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112.1 0 15.9 13.9c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-64-56zM32 256c0-18.8 8.1-35.7 21-47.4l144.2 111c-1.7 .3-3.4 .4-5.2 .4H64c-17.7 0-32-14.3-32-32V256zm192 32c0 3.7-.6 7.2-1.8 10.5L85.1 192.9c3.6-.6 7.2-.9 10.9-.9h64c35.3 0 64 28.7 64 64v32z"]
};
var faFileShield = {
  prefix: 'far',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M64 464H310.7c11 14.4 24.1 28.1 39.5 40.4c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V207l-48 19.2V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"]
};
var faHexagon = {
  prefix: 'far',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24L365.1 420.9c-4.3 7.4-12.2 12-20.8 12l-176.6 0c-8.6 0-16.5-4.6-20.8-12L58.6 268z"]
};
var faManhole = {
  prefix: 'far',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM281.4 115.4c5.8-7.5 14.5-14.7 23.6-11.8c64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8c-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8c5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
var faUserSlash = {
  prefix: 'far',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM290.5 202.4l-35.6-27.9C245.5 161.4 240 145.3 240 128c0-44.2 35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80c-10.4 0-20.4-2-29.5-5.6zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1L467.1 464H145.3c8.9-63.3 63.3-112 129-112h50.6l-60.6-47.7z"]
};
var faPen = {
  prefix: 'far',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"]
};
var faTowerObservation = {
  prefix: 'far',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", "M245.7 2.3c6.5-3.1 14.1-3.1 20.6 0l168 80c12 5.7 17 20 11.3 32c-5.3 11.2-18.2 16.4-29.7 12.3V200c0 27.2-19.4 49.9-45.2 55l34.8 209H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h82.3l34.8-209c-25.7-5-45.2-27.7-45.2-55V126.6c-11.4 4.1-24.3-1.1-29.7-12.3c-5.7-12-.6-26.3 11.4-32l168-80zM256 50.6L144 103.9V128H368V103.9L256 50.6zM144 176v24c0 4.4 3.6 8 8 8H360c4.4 0 8-3.6 8-8V176H144zM330.8 464L256 400.7 181.2 464H330.8zM189.7 256l-3.7 22.5L256 337.8l70.1-59.3L322.3 256H189.7zm-12.9 77.6l-13.8 83 55.9-47.3-42.1-35.6zm116.4 35.6l55.9 47.3-13.8-83-42.1 35.6z"]
};
var faFloppyDisks = {
  prefix: 'far',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M144 352c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9-33.9 33.9L384.8 52.7c-.3-.3-.5-.5-.8-.8V120c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V48H160c-8.8 0-16 7.2-16 16V352zM224 0H373.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h16 48zm0 48V96H336V48H224zM48 120V376c0 48.6 39.4 88 88 88H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24s24 10.7 24 24zM240 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faToiletPaperBlankUnder = {
  prefix: 'far',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", "M71 84.3C85.4 56.9 101.1 48 112 48H324.7c-3 4.5-5.7 9.3-8.2 14.1C298.5 96.6 288 142.5 288 192s10.5 95.4 28.5 129.9c2.5 4.8 5.3 9.5 8.2 14.1H112c-10.9 0-26.6-8.9-41-36.3C57.2 273.3 48 235.3 48 192s9.2-81.3 23-107.7zM400 48c10.9 0 26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3s-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C373.4 56.9 389.1 48 400 48zm64 303.1V456c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V416H160v40c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V192c0-49.5-10.5-95.4-28.5-129.9C466 28.7 437.7 0 400 0H112C74.3 0 46 28.7 28.5 62.1C10.5 96.6 0 142.5 0 192s10.5 95.4 28.5 129.9C46 355.3 74.3 384 112 384H400c25.9 0 47.4-13.6 64-32.9zM424 192c0-26.5-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48s24-21.5 24-48z"]
};
var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
var faFileCode = {
  prefix: 'far',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]
};
var faSignal = {
  prefix: 'far',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", "M576 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM448 96c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM320 192c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faPump = {
  prefix: 'far',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24h8V208H48v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v32V376v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H320V352H48V256h72c13.3 0 24-10.7 24-24V48h96V232c0 13.3 10.7 24 24 24h56V208H288V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H264 120 88zM458.5 146.7c2.6-1.8 5.7-2.7 8.9-2.7H576c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H467.4c-3.2 0-6.2-.9-8.9-2.7l-51.4-34.2c-4.4-3-7.1-8-7.1-13.3V194.3c0-5.3 2.7-10.3 7.1-13.3l51.4-34.3zM431.9 501.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3V413.7c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H464c-8.8 0-16 7.2-16 16z"]
};
var faBus = {
  prefix: 'far',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", "M363.7 96h97.5C445.4 78.9 399.2 48 288 48C185.8 48 133.8 78.3 115.5 96h96.8c5.5-9.6 15.9-16 27.7-16l96 0c11.8 0 22.2 6.4 27.7 16zM464 144H312v80H464V144zm-352 0v80H264V144H112zm0 128V376c0 13.3 10.7 24 24 24H364.2 440c13.3 0 24-10.7 24-24V272H112zM74.2 70C99.9 38.7 167.8 0 288 0C416.6 0 478 38.6 502.4 70.6c7.5 9.8 9.6 20.9 9.6 29.9V128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32V376c0 25-12.7 47-32 59.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H364.2 144v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V435.9C76.7 423 64 401 64 376V256c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V100.4C64 91.6 66 80 74.2 70zM176 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHeartCircleXmark = {
  prefix: 'far',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9l0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2l-.1 .1-.1 .1-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faArrowUpLeftFromCircle = {
  prefix: 'far',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M184 0H24C10.7 0 0 10.7 0 24V184c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9L295 329c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L81.9 48H184c13.3 0 24-10.7 24-24s-10.7-24-24-24zM288 64c-13.3 0-24 10.7-24 24s10.7 24 24 24c97.2 0 176 78.8 176 176s-78.8 176-176 176s-176-78.8-176-176c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z"]
};
var faHouseChimney = {
  prefix: 'far',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24V182.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32h48V312c0-22.1 17.9-40 40-40H344c22.1 0 40 17.9 40 40V464h48c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM336 320H240V464h96V320z"]
};
var faHomeLg = faHouseChimney;
var faWindowMaximize = {
  prefix: 'far',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M.3 89.5C.1 91.6 0 93.8 0 96V224 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224 96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224H464l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"]
};
var faDryer = {
  prefix: 'far',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 256c-44.7 0-82.3-30.6-93-72h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H131c10.7-41.4 48.2-72 93-72c53 0 96 43 96 96s-43 96-96 96zm0 48a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faFaceFrown = {
  prefix: 'far',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFrown = faFaceFrown;
var faChessBishopPiece = {
  prefix: 'far',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", "M64 56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 12.2-9.2 22.3-21 23.8c6.2 6.4 13.2 14.4 20.2 23.8C210.8 129.8 232 168.8 232 216c0 20-5.9 35.9-13.9 48.2c3.7 4.2 5.9 9.7 5.9 15.8c0 11.3-7.8 20.8-18.3 23.3l4.9 48.7H162.3l-4.8-48h-59l-4.8 48H45.5l4.9-48.7C39.8 300.8 32 291.3 32 280c0-6 2.2-11.6 5.9-15.8C29.9 251.9 24 236 24 216c0-47.2 21.2-86.2 40.8-112.4c7-9.4 14.1-17.4 20.2-23.8C73.2 78.3 64 68.2 64 56zm93.3 200l7.5-5.1c9.6-6.5 19.2-16.9 19.2-34.9c0-13.8-2.6-26.9-6.9-39.2L161 193c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l26.1-26.1c-.1-.2-.2-.3-.4-.5c-8.1-10.8-16.2-19.3-22.2-25.1c-.9-.9-1.8-1.7-2.6-2.5c-.8 .8-1.7 1.6-2.6 2.5c-6 5.8-14.1 14.4-22.2 25.1C86.8 154.2 72 183.2 72 216c0 18.1 9.6 28.5 19.2 34.9l7.5 5.1h58.7zM69.2 432L52.7 464H203.3l-16.6-32H69.2zm-9.7-48h137c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384z"]
};
var faChessBishopAlt = faChessBishopPiece;
var faShirtTankTop = {
  prefix: 'far',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24c0 127.9-26.8 181-41.5 200.5C12.9 237.2 0 257.2 0 280.7V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V280.7c0-23.5-12.9-43.5-22.5-56.3C346.8 205 320 151.9 320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V72c0 44.2-35.8 80-80 80s-80-35.8-80-80V24zM99.3 160.2C122.6 184.7 155.5 200 192 200s69.4-15.3 92.7-39.8c10.3 46.7 25.2 75.5 38.5 93.1c8.6 11.4 12.8 20.5 12.8 27.3V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V280.7c0-6.8 4.2-15.9 12.8-27.3c13.3-17.6 28.2-46.5 38.5-93.1z"]
};
var faDiploma = {
  prefix: 'far',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M320 80.3L302 59.7C286.6 42.1 264.4 32 241 32h-1c-44.2 0-80 35.8-80 80c0 11.4 2.4 22.2 6.7 32H96c-65.1 .3-96 71.5-96 128c0 56.9 24.1 119.2 81 140.7c10.5 4 22.5 4.2 33.4 1.8L256 383v81c0 6.2 3.6 11.9 9.2 14.5s12.3 1.8 17-2.2L320 444.8l37.8 31.5c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5V383l141.6 31.5c10.9 2.4 22.9 2.2 33.4-1.8c56.9-21.5 81-83.8 81-140.7c0-56.5-30.9-127.7-96-128H473.3c4.3-9.8 6.7-20.6 6.7-32c0-44.2-35.8-80-80-80h-1c-23.4 0-45.6 10.1-61 27.7L320 80.3zM400 144h-8H345.6c-6.9 0-10.5-8.1-6-13.3l34.5-39.5c5.5-6.3 13.1-10.2 21.3-11.1c1.2-.1 2.3-.2 3.5-.2h1c17.7 0 32 14.3 32 32s-14.3 32-32 32zm-105.6 0H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h1c9.5 0 18.6 4.1 24.8 11.3l34.5 39.5c4.5 5.2 .9 13.3-6 13.3zM240 192h16V333.8L104 367.6c-1.5 .3-3.1 .5-4.3 .4c-1.1 0-1.6-.2-1.7-.2l0 0C68.1 356.5 48 319.7 48 272c0-20.6 5.9-43.3 16.1-59.3C73.6 197.8 84 192.1 96.1 192H240zm144 0h16H543.9c12.1 .1 22.6 5.8 32.1 20.7c10.2 16 16.1 38.7 16.1 59.3c0 47.7-20.1 84.5-50 95.8l0 0c-.1 0-.6 .2-1.7 .2c-1.3 .1-2.8-.1-4.3-.4L384 333.8V192z"]
};
var faScrollRibbon = faDiploma;
var faScreencast = {
  prefix: 'far',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", "M512 80H64c-8.8 0-16 7.2-16 16v97.1c-7.9-.7-15.9-1.1-24-1.1H0V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H288V456c0-8.1-.4-16.1-1.1-24H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16zM24 224c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"]
};
var faWalker = {
  prefix: 'far',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M186.4 48H320c22.1 0 40 17.9 40 40v88H124l23.5-97.4c4.3-18 20.4-30.6 38.9-30.6zM360 224V388.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V88c0-48.6-39.4-88-88-88H186.4c-40.6 0-76 27.8-85.5 67.4L.7 482.4c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7L112.4 224H360zm24 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPrescription = {
  prefix: 'far',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M24 0C10.7 0 0 10.7 0 24V200v96c0 13.3 10.7 24 24 24s24-10.7 24-24V224h78.1l128 128L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L407 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L441 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-95.3-95.3C246.6 214.7 288 168.2 288 112C288 50.1 237.9 0 176 0H24zM176 176H48V48H176c35.3 0 64 28.7 64 64s-28.7 64-64 64z"]
};
var faShop = {
  prefix: 'far',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 21.1-17.1 38.2-38.2 38.2H576V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V224H384V472c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V224H38.2C17.1 224 0 206.9 0 185.8zM112 224v96H336V224H112zM515.5 48l-391 0L54.7 176H585.3L515.5 48zM112 464H336V368H112v96z"]
};
var faStoreAlt = faShop;
var faFloppyDisk = {
  prefix: 'far',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faSave = faFloppyDisk;
var faVihara = {
  prefix: 'far',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M308.5 61.4c-31 21.7-64.8 39-100.5 51.3V160H320 432V112.7c-35.7-12.3-69.5-29.6-100.5-51.3L320 53.3l-11.5 8.1zm173.2 65.8l-1.7-.5v39.7l1.7 1.9 2.5 2.9c27.3 31.5 62.5 55.1 102.1 68.3l4.8 1.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 7s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-7 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v36.6l4.3 7.4 1.9 3.3c17.2 29.6 43.4 52.9 74.8 66.5c8.8 3.6 15 12.2 15 22.3c0 13.3-10.7 24-24 24H576v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H344v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H112v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H24c-13.3 0-24-10.7-24-24c0-10.1 6.2-18.7 15-22.3c31.4-13.6 57.6-36.9 74.8-66.5l1.9-3.3 4.3-7.4V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l4.8-1.6c39.5-13.2 74.8-36.8 102.1-68.3l2.5-2.9 1.7-1.9V126.7l-1.7 .5c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5l23.6-6.4C209.2 63.5 247 45.8 281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23.6 6.4c12.8 3.5 20.3 16.7 16.8 29.5s-16.7 20.3-29.5 16.8zM496 320V288H320 144v32H320 496zM152.8 240H320 487.2c-12.3-9.6-23.9-20.3-34.5-32H320 187.3c-10.6 11.7-22.2 22.4-34.5 32zM100.5 400H320 539.5c-9.5-9.8-18.1-20.5-25.5-32H320 126c-7.5 11.5-16 22.2-25.5 32z"]
};
var faFaceKissClosedEyes = {
  prefix: 'far',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM175.6 220c-10.6 0-19.9 3.8-25.4 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
var faScaleUnbalanced = {
  prefix: 'far',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M542.9 16.7c4 12.6-2.9 26.1-15.5 30.2L399.6 87.7c-3.1 32.4-25.5 59.2-55.6 68.6V464H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H320c-13.3 0-24-10.7-24-24V156.3c-14.2-4.5-26.8-12.8-36.4-23.8L127.3 174.9c-12.6 4-26.1-2.9-30.2-15.5s2.9-26.1 15.5-30.2L240.4 88.3c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80c29.8 0 55.8 16.3 69.6 40.5L512.7 1.1c12.6-4 26.1 2.9 30.2 15.5zM512 163.8L439.6 288H584.4L512 163.8zM386 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 350 574.9 384 512 384s-115.2-34-126-78.9zM56.7 416H201.6L129.2 291.8 56.7 416zm72.4 96C66.3 512 14 478 3.2 433.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C244.3 478 192 512 129.2 512zM320 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faFileUser = {
  prefix: 'far',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M304 464c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H304zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM256 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faUserPoliceTie = {
  prefix: 'far',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M217.9 .8l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zM221 48.6c1.9-.8 4-.8 5.9 0l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm91.6 183.2L208 416l-12.2 48.9 0 0-.5-.9 0 0L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512H168h0 1 21.2H192v0h64v0h1.7 21.2 1 0H422.4c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.8 464l0 0-.5 .9 0 0L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2H201.9c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464H50.9c7.2-27 27.3-48.8 53.2-58.5L139.2 464zm257.8 0H308.8l35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z"]
};
var faFaceTongueMoney = {
  prefix: 'far',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M348.3 442.4c2.2-7.7 3.5-15.9 3.7-24.3c30.5-21.1 53.2-52.1 63.3-88.1c3.8-13.7-7.4-26.1-21.6-26.1H352 320 192 160 118.4c-14.2 0-25.5 12.4-21.6 26.1c10.1 36 32.8 66.9 63.3 88.1c.2 8.4 1.5 16.5 3.7 24.3C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zm-44.4 16C292.2 471.7 275.1 480 256 480s-36.2-8.3-47.9-21.5c-5.5-6.2-9.8-13.5-12.6-21.6c-2.3-6.5-3.5-13.6-3.5-20.9V336H320v80c0 7.3-1.2 14.4-3.5 20.9c-2.8 8-7.1 15.3-12.6 21.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 120c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.3 9 27.2 11.2l1.1 .3c9.6 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V264c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V120zm144-16c-8.8 0-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.4 9 27.2 11.2l1.1 .3c9.5 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8l0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6V264c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7V120c0-8.8-7.2-16-16-16zM267.2 355.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6v6.8c-4.3 .8-8.7 2.4-12.7 5.2c-5.6 4-9.5 9.8-10.8 17.2c-.9 5.3-.5 10.6 1.7 15.4c2.2 4.8 5.7 8.2 9.3 10.6c6.3 4.2 14.5 6.5 20.4 8.1l.8 .2c7.2 2 11.5 3.3 14.1 5.1c1.9 1.3 1.6 4.6-.4 5.8l0 0c-.9 .5-2.8 1.1-6.6 1.1c-7.6-.1-16.9-2.9-24-5.2c-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4v7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6v-6.5c3.6-.6 7.3-1.8 10.8-3.8c6.8-4 11.2-10.5 12.7-18.9c.9-5.3 .5-10.6-1.7-15.4c-2.2-4.8-5.7-8.2-9.3-10.6c-5.4-3.6-11.7-5.2-17.9-6.8c-6.2-1.6-12.3-3.2-17.5-6.6c-1.8-1.2-1.8-3.9 .2-5.2c.7-.5 2.3-1.2 5.3-1.5c6.1-.6 14 .7 20.2 2.3c6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2v-7.2z"]
};
var faTennisBall = {
  prefix: 'far',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M248 463.8c0-55.2 21.1-110.4 63.3-152.6s97.4-63.2 152.6-63.3C459.7 139.5 372.5 52.3 264 48.2c0 55.2-21.1 110.4-63.3 152.6S103.4 264 48.2 264C52.3 372.5 139.5 459.7 248 463.8zm48-3.7C378.8 444 444 378.8 460.2 296c-41.7 1-83.1 17.3-114.9 49.2S297 418.4 296 460.2zM51.9 216c41.7-1 83.1-17.3 114.9-49.2S215 93.6 216 51.9C133.2 68 68 133.2 51.9 216zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSquareL = {
  prefix: 'far',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 56V336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSortUp = {
  prefix: 'far',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", "M160 86.6L70.6 176H249.4L160 86.6zM137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
};
var faSortAsc = faSortUp;
var faCalendarArrowUp = {
  prefix: 'far',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM200 408l0-102.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39V408c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faCalendarUpload = faCalendarArrowUp;
var faCommentDots = {
  prefix: 'far',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCommenting = faCommentDots;
var faPlantWilt = {
  prefix: 'far',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M280 112c0-35.3 28.7-64 64-64s64 28.7 64 64v18.7c-33.9 8-56 33.6-56 72.4c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-38.8-22.1-64.4-56-72.4V112C456 50.1 405.9 0 344 0S232 50.1 232 112v36.1c-18.1-12.7-40.2-20.1-64-20.1c-61.9 0-112 50.1-112 112v18.7c-33.9 8-56 33.6-56 72.4C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-38.8-22.1-64.4-56-72.4V240c0-35.3 28.7-64 64-64s64 28.7 64 64v32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V272 240 112zM54.7 311.3c3.2-2.9 9.9-6.7 22.3-7.2c1 .1 2 .2 3.1 .2s2.1-.1 3.1-.2c12.3 .5 19.1 4.3 22.3 7.2c2.9 2.6 6.7 7.9 6.7 19.8c0 0 0 0 0 0c0 .1 0 .8-.3 2.3c-.3 1.6-.8 3.7-1.8 6.4c-1.8 5.4-4.9 12.2-9.3 19.9c-5.4 9.3-12.3 19.2-20.7 28.9c-8.3-9.7-15.3-19.6-20.7-28.9c-4.4-7.7-7.4-14.4-9.3-19.9c-.9-2.7-1.4-4.8-1.8-6.4c-.3-1.5-.3-2.2-.3-2.3c0 0 0 0 0 0c0-11.9 3.8-17.1 6.7-19.8zM400 203.1c0-11.9 3.8-17.1 6.7-19.8c3.5-3.1 11-7.3 25.3-7.3s21.9 4.1 25.3 7.3c2.9 2.6 6.7 7.9 6.7 19.8c0 0 0 0 0 0c0 .1 0 .8-.3 2.3c-.3 1.6-.8 3.7-1.8 6.4c-1.8 5.4-4.9 12.2-9.3 19.9c-5.4 9.3-12.3 19.2-20.7 28.9c-8.3-9.7-15.3-19.6-20.7-28.9c-4.4-7.7-7.4-14.4-9.3-19.9c-.9-2.7-1.4-4.8-1.8-6.4c-.3-1.5-.3-2.2-.3-2.3l0 0z"]
};
var faScarf = {
  prefix: 'far',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", "M306.7 256l0 0 33.9 33.9L362.7 312 312 362.7 162.4 213.1c-11.7-11.7-18.4-27.7-18.4-44.3c0-10.8 2.8-21.3 8-30.7l41.5-73.8C199.2 54.2 209.9 48 221.4 48h69.1c11.6 0 22.2 6.2 27.9 16.3L360 138.1c5.3 9.4 8 20 8 30.7c0 16.6-6.6 32.6-18.3 44.3l-9 9-50.7-50.7 8-8c3.9-3.9 6.1-9.1 6.1-14.6c0-11.4-9.3-20.7-20.7-20.7H228.7c-11.4 0-20.7 9.3-20.7 20.7c0 5.5 2.2 10.7 6.1 14.6L306.7 256h0zm101.8 33.9l-11.9-11.9L374.6 256l9-9c20.8-20.8 32.4-48.9 32.4-78.2c0-19-4.9-37.7-14.2-54.2L360.3 40.8C346.1 15.6 319.5 0 290.6 0H221.4c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8C100.9 131.1 96 149.8 96 168.8c0 29.3 11.7 57.5 32.4 78.2L278.1 396.7l30.6 30.6 0 0 3.3 3.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L334.6 408l11.3-11.3L360 382.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L382.6 360l14.1-14.1L408 334.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L430.6 312l-3.3-3.3 0 0-18.7-18.7zM116.7 276.7l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6z"]
};
var faAlbumCirclePlus = {
  prefix: 'far',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M64 80H384c8.8 0 16 7.2 16 16v98.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faUserNurseHairLong = {
  prefix: 'far',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v24 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 293.9 58.1 304 70.6 304H224 377.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5V160 136c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160h8zM50 461.9c7.8-38.7 38-69.3 76.4-77.7l52.3 52.3c25 25 65.5 25 90.5 0l52.3-52.3c38.5 8.4 68.6 39 76.4 77.7H50zm80.4-127C56.9 343.6 0 406 0 481.8c0 15.6 12.6 28.2 28.2 28.2H419.8c15.6 0 28.2-12.6 28.2-28.2C448 406 391.1 343.6 317.6 335c-8.7-1-17.2 2.5-23.4 8.7l-58.9 58.9c-6.2 6.2-16.4 6.2-22.6 0l-58.9-58.9c-6.2-6.2-14.7-9.8-23.4-8.7zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8V64h16c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V96H192c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"]
};
var faDiamond = {
  prefix: 'far',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", "M249 50.9L50.9 249c-1.9 1.9-2.9 4.4-2.9 7s1 5.2 2.9 7L249 461.1c1.9 1.9 4.4 2.9 7 2.9s5.2-1 7-2.9L461.1 263c1.9-1.9 2.9-4.4 2.9-7s-1-5.2-2.9-7L263 50.9c-1.9-1.9-4.4-2.9-7-2.9s-5.2 1-7 2.9zM17 215L215 17C225.9 6.1 240.6 0 256 0s30.1 6.1 41 17L495 215c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L297 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17L17 297C6.1 286.1 0 271.4 0 256s6.1-30.1 17-41z"]
};
var faSquareLeft = {
  prefix: 'far',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M48 416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zM185.4 360.8l-84-91c-3.5-3.8-5.4-8.7-5.4-13.9s1.9-10.1 5.4-13.9l84-91c4.2-4.6 10.1-7.2 16.4-7.2c12.3 0 22.3 10 22.3 22.3V208h96c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H224v41.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.4-7.2z"]
};
var faArrowAltSquareLeft = faSquareLeft;
var faFaceGrinSquint = {
  prefix: 'far',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faGrinSquint = faFaceGrinSquint;
var faCircleEllipsisVertical = {
  prefix: 'far',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHandHoldingDollar = {
  prefix: 'far',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H387.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H344 320 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faGridDividers = {
  prefix: 'far',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", "M0 24C0 10.7 10.7 0 24 0H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM80 176h32V144H80v32zM32 128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128zM80 464h32V432H80v32zM32 416c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V416zM240 144v32h32V144H240zM224 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm16 368h32V432H240v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416zM400 144v32h32V144H400zM384 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm16 368h32V432H400v32zm-48-48c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V416zM24 288H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBacterium = {
  prefix: 'far',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-8.6 14.3-16.5 29.5-23.3 45.2l-9.8-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.4 4.5c-4.8 16.8-8.2 34-10 51c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3c.6-3.9 1.4-7.7 2.5-11.5l12.7 5.5c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM207.9 372.9c-.1 .7-.2 1.4-.3 2.1c-3.8 34.6-34.6 59.9-69.4 56.8c-35.1-3.2-61-34.2-58-69.2c4.4-41 20.4-84 42.9-121.4c38-63.4 107.9-131.1 230.5-159.4c34.4-7.9 68.8 13.5 76.8 48s-13.5 68.8-48 76.8C297 226.1 254.9 270.3 232.9 306.9c-10.8 18-21.1 40.8-25 66zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHandPointer = {
  prefix: 'far',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16V200c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16V392c0 39.8-32.2 72-72 72H272 212.3h-.9c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V320 64zM176 0c-35.3 0-64 28.7-64 64V261.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2h.9H272h56c66.3 0 120-53.7 120-120V288l0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"]
};
var faDrumSteelpan = {
  prefix: 'far',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M528 160c0-9.9-8-29.9-55-49.8c-20-8.5-44.3-15.4-71.9-20.6c-1.2 4.1-2.4 8.8-3.6 13.8c-4.5 18.9-7.6 39.2-5.7 53.3c2.2 16.3 10.4 35.1 19.3 51.1c4 7.3 7.9 13.5 10.9 18c19.1-4.5 36.2-9.9 51-16.2c47.1-19.9 55-39.9 55-49.8zM369.1 231.2c-6.9-12.5-14.9-28.8-20.1-46.3c-15.4 8-36 15.1-61 15.1s-45.6-7.1-61-15.1c-5.2 17.5-13.2 33.8-20.1 46.3c-.7 1.3-1.4 2.5-2.1 3.8c25.7 3.3 53.7 5 83.2 5s57.5-1.8 83.2-5c-.7-1.2-1.4-2.5-2.1-3.8zM350.8 92.3c.8-3.2 1.6-6.3 2.3-9.3c-20.6-2-42.4-3-65.1-3s-44.5 1-65.1 3c.8 2.9 1.6 6 2.3 9.3c2.6 11 5.4 24.5 6.7 38.4c.1 .1 .2 .2 .3 .2c2.6 2.3 6.6 5.4 11.8 8.6c10.5 6.4 25.4 12.5 44 12.5s33.5-6.2 44-12.5c5.2-3.2 9.2-6.3 11.8-8.6c.1-.1 .2-.2 .3-.2c1.3-13.9 4.1-27.4 6.7-38.4zM103 209.8c14.8 6.3 31.9 11.7 51 16.2c3-4.5 6.9-10.8 10.9-18c8.9-16 17.1-34.9 19.3-51.1c1.9-14.2-1.1-34.5-5.7-53.3c-1.2-5-2.5-9.7-3.6-13.8c-27.6 5.1-51.9 12.1-71.9 20.6C56 130.1 48 150.1 48 160s8 29.9 55 49.8zM576 160V352c0 24.3-11.3 44.9-28.1 61c-16.5 15.8-39.1 28.3-64.8 37.8C431.7 470.1 362.6 480 288 480s-143.7-9.9-195.1-29.1c-25.6-9.6-48.2-22-64.8-37.8C11.3 396.9 0 376.3 0 352V160C0 80 128.9 32 288 32s288 48 288 128zm-48 74.9C476.4 269 388.2 288 288 288s-188.4-19-240-53.1V352c0 8.2 3.5 16.9 13.3 26.3c10.2 9.7 26.2 19.3 48.4 27.6C153.9 422.4 216.8 432 288 432s134.1-9.6 178.3-26.1c22.1-8.3 38.2-17.8 48.4-27.6c9.9-9.4 13.3-18.2 13.3-26.3V234.9z"]
};
var faHandScissors = {
  prefix: 'far',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"]
};
var faHandsPraying = {
  prefix: 'far',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M277.8 48c-5.9 0-11.4 2.9-14.8 7.7l-99.8 141c-12.4 17.6-19.1 38.6-19.1 60.1v40.2c0 24.1-15.4 45.5-38.3 53.1L31.6 374.8C19 379 5.4 372.2 1.2 359.6S3.8 333.4 16.4 329.2l74.1-24.7c3.3-1.1 5.5-4.1 5.5-7.6V256.7c0-31.5 9.8-62.2 28-87.9l99.8-141C236.2 10.4 256.4 0 277.8 0c16.1 0 30.8 5.8 42.2 15.3C331.4 5.8 346.1 0 362.2 0c21.5 0 41.6 10.4 54 27.9l99.8 141c18.2 25.7 28 56.4 28 87.9v40.2c0 3.4 2.2 6.5 5.5 7.6l74.1 24.7c12.6 4.2 19.4 17.8 15.2 30.4s-17.8 19.4-30.4 15.2l-74.1-24.7c-22.9-7.6-38.3-29-38.3-53.1V256.7c0-21.5-6.7-42.5-19.1-60.1L377 55.7c-3.4-4.8-8.9-7.7-14.8-7.7c-9.6 0-18 8-18.2 18.2c0 .1 0 .3 0 .4s0 .3 0 .4c.1 3.7 1.3 7.4 3.3 10.3L416.5 178c10.1 14.7 15.5 32.1 15.5 49.9V236v60c0 13.3-10.7 24-24 24s-24-10.7-24-24V236c0-11-9-20-20-20c-10.9 0-19.8 8.7-20 19.6c0 .1 0 .3 0 .4v74c0 .3 0 .6 0 .9c.4 46.6 31.8 87.3 76.9 99.5l201.4 54.4c12.8 3.5 20.4 16.6 16.9 29.4s-16.6 20.4-29.4 16.9L408.3 456.7C370.9 446.6 339.9 423 320 392c-19.9 31-50.9 54.6-88.3 64.8L30.3 511.2c-12.8 3.5-26-4.1-29.4-16.9s4.1-26 16.9-29.4l201.4-54.4c45.1-12.2 76.5-52.9 76.9-99.5c0-.3 0-.6 0-.9V236c0-.1 0-.3 0-.4c-.2-10.8-9.1-19.6-20-19.6c-11 0-20 9-20 20v60c0 13.3-10.7 24-24 24s-24-10.7-24-24V236v-8.1c0-17.8 5.4-35.2 15.5-49.9L292.7 77.3c2-2.9 3.2-6.6 3.3-10.3c0-.1 0-.3 0-.4s0-.3 0-.4C295.8 56 287.4 48 277.8 48zM320 122.4L287.9 169c12.1 2.1 23.1 7.5 32.1 15.1c9-7.6 20-13 32.1-15.1L320 122.4z"]
};
var faPrayingHands = faHandsPraying;
var faFacePensive = {
  prefix: 'far',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 368h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H208c-13.3 0-24-10.7-24-24s10.7-24 24-24zm143.6-84c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 317.2 371 324 351.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 317.2 179 324 159.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zM81.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5 .7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"]
};
var faUserMusic = {
  prefix: 'far',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464H288v0c0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c36.3 0 70.1 10.9 98.3 29.5v51.6c-3.2 .4-6.5 1-9.6 1.7C335.1 365.2 304 352 269.7 352H178.3c-65.7 0-120.1 48.7-129 112zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
var faArrowRotateRight = {
  prefix: 'far',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M472 224c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v80.1l-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8c10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2 0 0L418.9 176H328c-13.3 0-24 10.7-24 24s10.7 24 24 24H472z"]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faMessagesDollar = {
  prefix: 'far',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", "M72 48C58.7 48 48 58.7 48 72V248c0 13.3 10.7 24 24 24h48c13.3 0 24 10.7 24 24v19.2L202.7 276c3.9-2.6 8.6-4 13.3-4H344c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72zM0 72C0 32.2 32.2 0 72 0H344c39.8 0 72 32.2 72 72V248c0 39.8-32.2 72-72 72H223.3l-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360V320H72c-39.8 0-72-32.2-72-72V72zM256 352h48v24c0 13.3 10.7 24 24 24h96c4.7 0 9.4 1.4 13.3 4L496 443.2V424c0-13.3 10.7-24 24-24h48c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H448V128H568c39.8 0 72 32.2 72 72V376c0 39.8-32.2 72-72 72H544v40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60H328c-39.8 0-72-32.2-72-72V352zM224 79.1V89.5c5.9 .9 11.6 2.3 16.8 3.6c8.6 2.2 13.7 10.9 11.5 19.5s-10.9 13.7-19.5 11.5c-8.8-2.3-17.3-3.9-25-4c-6.4-.1-13 1.4-17.4 3.9c-3.9 2.2-4.8 4.3-4.8 6.8l0 .1c0 1 0 2.2 4.1 4.6c5.1 3 12.5 5.2 22.7 8.2l.5 .2c9 2.6 20.4 6 29.6 11.6c10.2 6.3 19.6 16.6 19.8 32.8c.2 16.7-8.6 28.6-20 35.5c-5.7 3.4-12 5.7-18.4 7v10.3c0 8.8-7.2 16-16 16s-16-7.2-16-16V230c-8.2-1.7-15.8-4.3-22.5-6.5l0 0 0 0c-1.7-.6-3.3-1.1-4.9-1.6c-8.4-2.7-13-11.7-10.3-20.2s11.7-13 20.2-10.3c2 .6 3.9 1.3 5.8 1.9l0 0 0 0c10.9 3.6 19.2 6.4 28.2 6.6c6.9 .2 13.3-1.3 17.3-3.7c3.3-2 4.6-4.2 4.6-7.7c0-1.8-.4-3.4-4.5-5.9c-5-3.1-12.4-5.4-22.5-8.4l-1.4-.4c-8.7-2.5-19.7-5.8-28.4-10.9c-10.1-5.9-19.8-16-19.9-32.2c-.1-16.8 9.7-28.3 20.8-34.7c5.5-3.2 11.5-5.3 17.6-6.6V79.1c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCommentsAltDollar = faMessagesDollar;
var faSensorOn = {
  prefix: 'far',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 96c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm381.3-20c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM536 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H536zm13.3 140c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z"]
};
var faBalloon = {
  prefix: 'far',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 35.8-18.4 74.2-46.5 110.7c-27.5 35.7-60.2 64.2-79 79.3c-7.6 6.1-13.8 13.5-18.4 21.8c-4.6-8.3-10.9-15.8-18.4-21.8c-18.9-15.1-51.5-43.6-79-79.3C66.4 266.2 48 227.8 48 192zM150.7 450.5L144 464l-.1 .1-3 6-11.6 23.2c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9h25.9 6.7 .1 36.7 .1 6.7 25.9c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8l-11.6-23.2-3-6-.1-.1-6.7-13.5c-5.3-10.6-2.1-23.6 7.1-31C281.2 386.9 384 294.6 384 192C384 86 298 0 192 0S0 86 0 192C0 294.6 102.8 386.9 143.6 419.5c9.3 7.4 12.5 20.4 7.1 31zM128 184c0-30.9 25.1-56 56-56c13.3 0 24-10.7 24-24s-10.7-24-24-24C126.6 80 80 126.6 80 184c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faBiohazard = {
  prefix: 'far',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c3.3-6.2 5.9-12.8 7.3-19.8c-29.9-23.5-51.1-57.5-58.3-96.4c-7.1-2.2-14.4-3.4-21.7-3.8c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c3.8 6.9 8.5 13.3 14.3 18.8c18-7 37.5-10.8 57.9-10.8s40 3.8 57.9 10.8c5.8-5.5 10.5-11.9 14.3-18.8c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM445.3 301.3c-7.2 38.9-28.5 72.9-58.3 96.4c1.5 7 4 13.7 7.3 19.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-7.3 .3-14.6 1.5-21.7 3.8z"]
};
var faChessQueenPiece = {
  prefix: 'far',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", "M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM16 232c0-13.3 10.7-24 24-24h5.1L3.6 140.6c-6.4-10.4-4-24 5.7-31.5l2.5-1.9c6.1-4.7 14.1-6.3 21.5-4.1c2.1 .6 4.4 1 6.8 1c11.7 0 21.4-8.3 23.6-19.4c1.9-9.7 9.5-17.3 19.2-19s19.5 2.6 24.7 11C111.8 83.5 119.4 88 128 88s16.2-4.5 20.5-11.4c5.2-8.4 15-12.8 24.7-11s17.4 9.3 19.2 19c2.1 11 11.9 19.4 23.6 19.4c2.4 0 4.7-.3 6.8-1c7.4-2.2 15.4-.6 21.5 4.1l2.5 1.9c9.7 7.5 12.1 21.1 5.7 31.5L211 208h5c13.3 0 24 10.7 24 24s-10.7 24-24 24H200.8l4.4 96h-48l-4.4-96H103.3l-4.4 96h-48l4.4-96H40c-13.3 0-24-10.7-24-24zm138.6-24l37.1-60.2c-11.6-4.2-21.8-11.2-29.7-20.3c-10.1 5.4-21.6 8.5-33.9 8.5s-23.8-3.1-33.9-8.5c-8 9.1-18.2 16.1-29.7 20.3L101.4 208h53.2zM52.7 464H203.3l-16.6-32H69.2L52.7 464zm143.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h137z"]
};
var faChessQueenAlt = faChessQueenPiece;
var faLocationCrosshairs = {
  prefix: 'far',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", "M256 0c13.3 0 24 10.7 24 24V65.5C366.8 76.3 435.7 145.2 446.5 232H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H446.5C435.7 366.8 366.8 435.7 280 446.5V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V446.5C145.2 435.7 76.3 366.8 65.5 280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H65.5C76.3 145.2 145.2 76.3 232 65.5V24c0-13.3 10.7-24 24-24zM112 256a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm192 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
var faLocation = faLocationCrosshairs;
var faMarsDouble = {
  prefix: 'far',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M288 56c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9l-83.7 83.7C338.7 227.2 352 264.1 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L366.1 80H312c-13.3 0-24-10.7-24-24zM176 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM480 158.1L558.1 80H504c-13.3 0-24-10.7-24-24s10.7-24 24-24H616c13.3 0 24 10.7 24 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9l-83.7 83.7C530.7 227.2 544 264.1 544 304c0 97.2-78.8 176-176 176c-22.6 0-44.2-4.3-64-12c14.3-11.2 27.1-24.2 38-38.6c8.4 1.7 17.1 2.6 26 2.6c70.7 0 128-57.3 128-128c0-35.7-14.7-68.1-38.3-91.3C471.3 202.5 480 186.3 480 168v-9.9z"]
};
var faHousePersonLeave = {
  prefix: 'far',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM461.8 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm59 54.6l50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L434 312.6c-18.1-14.7-25.2-39.1-17.8-61.2L439 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l9.5-21.3c17.1-38.5 49.6-68 89.5-81.3c15.3-5.1 31.3-7.7 47.4-7.7h4.9c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L633 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L570 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3zm-101.1 21l39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L361 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4zM255.2 5.4L391.9 116.8c-14.8 7.8-28.4 17.5-40.5 28.9L240 55 112 159.3V360c0 4.4 3.6 8 8 8H320h40 14.9l-6.6 16.5L336.8 416H120c-30.9 0-56-25.1-56-56V198.4L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0zM160 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V208z"]
};
var faHouseLeave = faHousePersonLeave;
var faHousePersonDepart = faHousePersonLeave;
var faRulerTriangle = {
  prefix: 'far',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", "M48 448V67.9l66.7 66.7-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1L444.1 464H64c-8.8 0-16-7.2-16-16zm454.6 6.6L57.4 9.4C51.4 3.4 43.2 0 34.7 0H32C14.3 0 0 14.3 0 32V448c0 35.3 28.7 64 64 64H480c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6zM128 256V384H256L128 256z"]
};
var faCardClub = {
  prefix: 'far',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M320 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm66.1 208.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V336H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V303.2c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3z"]
};
var faChildDress = {
  prefix: 'far',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M184 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 72a72 72 0 1 1 144 0A72 72 0 1 1 88 72zm-17 129.8c21.3-25.7 52.7-40.9 86-41.8c.7 0 1.4 0 2.2 0h.9 .9c.7 0 1.4 0 2.2 0c33.3 .9 64.6 16.1 86 41.8l65.4 78.8c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1l-43.1-52 36.3 109c2.4 7.3 1.2 15.4-3.3 21.6s-11.8 10-19.5 10H224v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H144v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H72c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l36.3-109-43.1 52c-8.5 10.2-23.6 11.6-33.8 3.1S-2.9 290.9 5.5 280.7l65.4-78.8zM160 208c-.5 0-1 0-1.4 0c-3.2 .2-6.1 2.3-7.1 5.5L105.3 352H214.7L168.5 213.5c-1-3.1-3.9-5.3-7.1-5.5c-.5 0-1 0-1.4 0z"]
};
var faUsersBetweenLines = {
  prefix: 'far',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", "M24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24S10.7 0 24 0zm0 464H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zM321.6 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-60.5 80.8c4.1-.5 8.3-.8 12.5-.8h48 48c4.2 0 8.4 .3 12.5 .8c47.1 6.1 83.5 46.4 83.5 95.2c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32h0c10.5-29.7 35.3-52.8 66.1-60.9c0 0 0 0 0 0c3.9-1 7.9-1.8 11.9-2.3zM273.6 240c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80s80 35.8 80 80c0 26.2-12.6 49.4-32 64l0 0c-13.4 10-30 16-48 16s-34.6-6-48-16l0 0zM392.7 341.9c-6.8-3.8-14.7-5.9-23.1-5.9h-96c-20.9 0-38.7 13.4-45.3 32H414.9c-2.6-7.3-6.9-13.8-12.4-19c-3.7-1.7-7-4.2-9.8-7.1zM147.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM96 256h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64zm480 96H493.6c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32zM499.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faLungsVirus = {
  prefix: 'far',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M344 24V150.4c-7.1-4.1-15.3-6.4-24-6.4s-16.9 2.3-24 6.4V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 165.3v24.1c-14.4-9.6-32.8-10.5-48-2.9V165.3c0-11.8-9.6-21.3-21.3-21.3c-6.8 0-12.8 3.2-16.4 8.3c-14.7 21.1-42.3 62.6-67.8 111.6C77 312.8 54.3 367.9 48 417v6c0 22.6 18.3 41 41 41c3.4 0 6.7-.4 9.9-1.2l72.7-18.2c6.4-1.6 12.3-4.5 17.3-8.3c1.8 2.9 4 5.6 6.6 8.2c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3zm273.4 344l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c2.5-2.5 4.7-5.3 6.6-8.2c5 3.8 10.9 6.7 17.3 8.3l72.7 18.2c3.3 .8 6.6 1.2 9.9 1.2c22.6 0 41-18.3 41-41v-6c-6.3-49.1-29-104.2-54.4-153.1c-25.5-49-53.1-90.5-67.8-111.6c-3.6-5.1-9.6-8.3-16.4-8.3c-11.8 0-21.3 9.6-21.3 21.3v21.2c-15.2-7.6-33.6-6.6-48 2.9V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7zM320 176c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSpinnerThird = {
  prefix: 'far',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M457 372c11.5 6.6 26.3 2.7 31.8-9.3C503.7 330.2 512 294.1 512 256C512 122.7 410.1 13.2 280 1.1C266.8-.1 256 10.7 256 24v0c0 13.3 10.8 23.9 24 25.4C383.5 61.2 464 149.2 464 256c0 29.3-6.1 57.3-17 82.6c-5.3 12.2-1.5 26.8 10 33.5v0z"]
};
var faFaceGrinTears = {
  prefix: 'far',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"]
};
var faGrinTears = faFaceGrinTears;
var faPhone = {
  prefix: 'far',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0s0 0 0 0"]
};
var faComputerMouseScrollwheel = {
  prefix: 'far',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M336 352V160c0-61.9-50.1-112-112-112H160C98.1 48 48 98.1 48 160V352c0 61.9 50.1 112 112 112h64c61.9 0 112-50.1 112-112zM0 160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V160zM192 96c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32z"]
};
var faMouseAlt = faComputerMouseScrollwheel;
var faCalendarXmark = {
  prefix: 'far',
  iconName: 'calendar-xmark',
  icon: [512, 512, ["calendar-times"], "f273", "M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCalendarTimes = faCalendarXmark;
var faChildReaching = {
  prefix: 'far',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 192 0a72 72 0 1 0 0 144zm-.2 32c-41.6 0-80-22.4-100.6-58.5L76.9 92.2c-6.5-11.5-21.2-15.6-32.7-9s-15.6 21.2-9 32.7l14.4 25.3c15 26.5 36.8 47.7 62.5 62.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h64V488c0 13.3 10.7 24 24 24s24-10.7 24-24V203c25-14 46.2-34.6 61.1-60.2l15.6-26.7c6.7-11.4 2.8-26.1-8.6-32.8s-26.1-2.8-32.8 8.6l-15.6 26.7C271 154.2 232.9 176 191.8 176zM224 336H160V220.9c10.4 2.1 21 3.1 31.8 3.1c10.9 0 21.7-1.1 32.2-3.2V336z"]
};
var faTableLayout = {
  prefix: 'far',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", "M448 80c8.8 0 16 7.2 16 16v64H48V96c0-8.8 7.2-16 16-16H448zM48 416V208h96V432H64c-8.8 0-16-7.2-16-16zm144 16V208H464V416c0 8.8-7.2 16-16 16H192zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faNarwhal = {
  prefix: 'far',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M639.4 20.5c2.3-7.7-1.6-16-9-19.2s-16-.4-20.1 6.5L516 167.3c-15.7-4.7-32.3-7.3-49.6-7.3c-53.1 0-104.4 19.5-144.1 54.8L177.9 343.2c-6.4 5.7-14.6 8.8-23.1 8.8c-19.2 0-34.8-15.6-34.8-34.8V304 258.7l37.9-26.5c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L72 258.7V304v13.2V352c0 88.4 71.6 160 160 160H464c97.2 0 176-80 176-177.2c0-50.1-21.2-95.5-55.1-127.5L639.4 20.5zM232 464c-46.3 0-86-28.1-103.1-68.1c8.1 2.7 16.8 4.1 25.9 4.1c20.3 0 39.8-7.4 55-20.9L354.2 250.7c30.9-27.5 70.9-42.7 112.2-42.7C535.4 208 592 265 592 334.8C592 405.9 534.3 464 464 464H232zM496 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faRampLoading = {
  prefix: 'far',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", "M96 48H352c8.8 0 16 7.2 16 16V312.4l48 88V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V400.4l48-88V64c0-8.8 7.2-16 16-16zm67 240c-20.5 0-39.3 11.2-49.2 29.2l-74 135.7C25.3 479.5 44.6 512 75 512H373c30.4 0 49.7-32.5 35.1-59.2l-74-135.7c-9.8-18-28.7-29.2-49.2-29.2H163zm-7 52.2c1.4-2.6 4.1-4.2 7-4.2H285c2.9 0 5.6 1.6 7 4.2L359.6 464H88.4L156 340.2z"]
};
var faCalendarCirclePlus = {
  prefix: 'far',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H432 400 352 48V448c0 8.8 7.2 16 16 16H284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faToothbrush = {
  prefix: 'far',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M64 176c-8.8 0-16-7.2-16-16s7.2-16 16-16H288c29.4 0 55.1-11.9 71-36.1c4.3-6.5 7.4-13.2 9.7-19.9c6.4 2.7 12 6 16.6 9.7c9.5 7.7 14.6 17 14.6 30.3c0 26.5-21.5 48-48 48H64zM0 160c0 35.3 28.7 64 64 64H352c53 0 96-43 96-96c0-58.5-51.6-89.9-104-95.2c-8.8-.9-15.8 6.4-16.4 15.2c-1.5 25.3-8.4 48-39.6 48H64C28.7 96 0 124.7 0 160zM80 280c0-13.3-10.7-24-24-24s-24 10.7-24 24V432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H56h80 80 80 80H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H400V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V432H320V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V432H240V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V432H160V280c0-13.3-10.7-24-24-24s-24 10.7-24 24V432H80V280z"]
};
var faBorderInner = {
  prefix: 'far',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64c-13.3 0-24-10.7-24-24l0-176L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0 0-176c0-13.3 10.7-24 24-24s24 10.7 24 24l0 176 176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0 0 176c0 13.3-10.7 24-24 24z"]
};
var faPawClaws = {
  prefix: 'far',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M178.1 15.3L138.9 58.4C121.6 77.4 112 102.3 112 128h0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8C226.3 100.2 210.3 81 192 71.2V20.7c0-7.3-9-10.8-13.9-5.4zm132 206.3c32.3 10.6 70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1h0c0-25.7-9.6-50.6-26.9-69.6L333.9 15.3C329 9.9 320 13.4 320 20.7V71.2c-18.3 9.8-34.3 28.9-42.5 53.6c-14.3 42.9 .3 86.2 32.6 96.8zm-209.7 8.9C91.1 214.7 77.9 203 64 196.8V152.6c0-7.7-9.9-11-14.5-4.7L12.2 199.2C4.3 210.1 0 223.3 0 236.8V240H0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1zM256 304c20.6 0 96.1 15.4 141.7 137.7c1.4 3.7 2.3 8.5 2.3 14.2c0 4.5-3.6 8.1-8.1 8.1h-3.4c-2.2 0-4.3-.4-6.3-1.2l-72.7-29.1c-34.3-13.7-72.6-13.7-107 0l-72.7 29.1c-2 .8-4.2 1.2-6.3 1.2h-3.4c-4.5 0-8.1-3.6-8.1-8.1c0-5.7 .9-10.4 2.3-14.2C159.9 319.4 235.4 304 256 304zm0-48c-41.2 0-134.3 28.4-186.7 169c-3.7 9.9-5.3 20.4-5.3 31c0 31 25.1 56.1 56.1 56.1h3.4c8.3 0 16.5-1.6 24.2-4.7l72.7-29.1c22.9-9.2 48.4-9.2 71.3 0l72.7 29.1c7.7 3.1 15.9 4.7 24.2 4.7h3.4c31 0 56.1-25.1 56.1-56.1c0-10.5-1.6-21.1-5.3-31C390.3 284.4 297.2 256 256 256zm165.8 58.7c24.5 14 59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4h0v-3.2c0-13.5-4.3-26.7-12.2-37.6l-37.3-51.3c-4.6-6.3-14.5-3-14.5 4.7v44.2c-13.9 6.1-27.1 17.8-36.4 33.7c-18.9 32.4-14.3 70.1 10.2 84.1z"]
};
var faKiwiFruit = {
  prefix: 'far',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M399.8 265.3C358.7 298.6 295.3 320 224 320s-134.7-21.4-175.8-54.7C53.1 358.2 129.9 432 224 432s170.9-73.8 175.8-166.7zM448 176v80c0 123.7-100.3 224-224 224S0 379.7 0 256V176C0 96.5 100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24z"]
};
var faTrafficLightSlow = {
  prefix: 'far',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M64 48c-8.8 0-16 7.2-16 16V352c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-120a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faRectangleCode = {
  prefix: 'far',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M448 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM287 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zM225 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"]
};
var faHeadSideVirus = {
  prefix: 'far',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64V336h.4c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0H224C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zM224 72c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 160.1 129 200 96 200c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 294.5 208 311 208 344c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 271.9 319 232 352 232c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 137.5 240 121 240 88c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faKeyboardBrightness = {
  prefix: 'far',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M129 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80zm167 33c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V200zm135 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80zM0 392c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm216-24c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H216zm320 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H536z"]
};
var faBooksMedical = {
  prefix: 'far',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", "M112 416v48h64V416H112zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4H112c-26.5 0-48-21.5-48-48V416 392v-8H176V368 320h48v48h64V144H224v48H176V144 128H64v-8V96 48C64 21.5 85.5 0 112 0h64c8.7 0 16.9 2.3 24 6.4C207.1 2.3 215.3 0 224 0h64c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L413.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L339.6 145.9 336 132.2V144 368v24 24 48c0 26.5-21.5 48-48 48H224c-8.7 0-16.9-2.3-24-6.4zM224 464h64V416H224v48zM176 48H112V96h64V48zm48 48h64V48H224V96zM504.1 355.7l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L528 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L424.4 48.5 368 64.1c0 .1 0 .2 0 .4l11.7 45.2zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H128v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16H64V176z"]
};
var faLightbulbSlash = {
  prefix: 'far',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6l0 0 0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8L38.8 5.1zM200 131.4C218.1 82.7 265 48 320 48c70.7 0 128 57.3 128 128c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7l0 0 0 0 0 0 0 0 0 0c-4.6 6.3-9.5 13-14.4 20L268.9 185.5c1.9-2.6 3.1-5.9 3.1-9.5c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-40 0-73.1 29.3-79 67.6l-41-32.1zM400 424.9L388.7 416H240v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-7.1zM152.4 229.8c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-2-3.7-4.2-7.5-6.5-11.2L152.4 229.8z"]
};
var faHouseBlank = {
  prefix: 'far',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V204.8L288 55.5 464 204.8z"]
};
var faHomeBlank = faHouseBlank;
var faSquare5 = {
  prefix: 'far',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 32H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H196l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"]
};
var faSquareHeart = {
  prefix: 'far',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM335.7 265.6l-91.5 92.9c-5.6 5.7-13 8.5-20.3 8.5c-7.3 0-14.6-2.9-20.1-8.5l-91.5-92.9c-26.4-26.8-26.4-70.4 0-97.2s69.3-26.8 95.8 0l16 16.2 16-16.2c26.4-26.8 69.3-26.8 95.8 0s26.4 70.4 0 97.2z"]
};
var faHeartSquare = faSquareHeart;
var faPuzzle = {
  prefix: 'far',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M448 0c35.3 0 64 28.7 64 64V192c0 8.8-7.2 16-16 16H444c-6.6 0-12 5.4-12 12v4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-4c0-6.6-5.4-12-12-12l-36 0c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-8.8 0-16-7.2-16-16V16c0-8.8 7.2-16 16-16H448zM0 240V128C0 92.7 28.7 64 64 64H208c8.8 0 16 7.2 16 16v52c0 6.6 5.4 12 12 12h4c17.7 0 32 14.3 32 32s-14.3 32-32 32h-4c-6.6 0-12 5.4-12 12v52c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8-7.2 16-16 16H48V440c0 13.3 10.7 24 24 24H224V428c0-6.6-5.4-12-12-12h-4c-17.7 0-32-14.3-32-32s14.3-32 32-32h4c6.6 0 12-5.4 12-12V304c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16V448c0 35.3-28.7 64-64 64H256 240 72c-39.8 0-72-32.2-72-72V272 240z"]
};
var faUserGear = {
  prefix: 'far',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464H336.6c3.3 4.2 6.7 8.2 10.3 12c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-3.6 2.3-7 5.1-9.9 8.4c-14.4-5.5-30.1-8.5-46.5-8.5H178.3c-65.7 0-120.1 48.7-129 112zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
var faUserCog = faUserGear;
var faPipeCircleCheck = {
  prefix: 'far',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", "M24 96c13.3 0 24 10.7 24 24v8H320 464v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v32 40.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9V176H320 48V336H322.9c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V360 152 120c0-13.3 10.7-24 24-24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faArrowUp19 = {
  prefix: 'far',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M456 56V176h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H432 384c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V89.3l-16.4 5.5C379 99 365.4 92.2 361.2 79.6S363.8 53.4 376.4 49.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM424 304a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM406.1 430.2c-40-8.3-70.1-43.7-70.1-86.2c0-48.6 39.4-88 88-88s88 39.4 88 88c0 21.1-7.3 41.5-20.6 57.8l-56.8 69.4c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l8.7-10.6z"]
};
var faSortNumericUp = faArrowUp19;
var faOctagonExclamation = {
  prefix: 'far',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM256 128c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faDialLow = {
  prefix: 'far',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 336c-53.6 0-98.4-37.7-109.4-88H288c13.3 0 24-10.7 24-24s-10.7-24-24-24H178.6c11-50.3 55.8-88 109.4-88c61.9 0 112 50.1 112 112s-50.1 112-112 112zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm448 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDoorClosed = {
  prefix: 'far',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M416 48c8.8 0 16 7.2 16 16V464H144V64c0-8.8 7.2-16 16-16H416zm64 416V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H96h48H432h48 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H480zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faLaptopMobile = {
  prefix: 'far',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", "M128 48H448c8.8 0 16 7.2 16 16V96h48V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V320H16c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H352V320H112V64c0-8.8 7.2-16 16-16zM384 176V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48zm48 0H592V464H432V176z"]
};
var faPhoneLaptop = faLaptopMobile;
var faConveyorBeltBoxes = {
  prefix: 'far',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M304 48V208H144V48H304zM144 0C117.5 0 96 21.5 96 48V208c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H144zM528 112v96H432V112h96zM432 64c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H432zm96 272c35.3 0 64 28.7 64 64s-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64H528zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H112zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faConveyorBeltAlt = faConveyorBeltBoxes;
var faShieldVirus = {
  prefix: 'far',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 96c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faStarfighterTwinIonEngineAdvanced = {
  prefix: 'far',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", "M118.5 7.6c9-9.7 24.2-10.2 33.9-1.2s10.2 24.2 1.2 33.9L50.2 151.2c-1.4 1.5-2.2 3.4-2.2 5.5V195l137.9-26.3C214.4 124.9 263.8 96 320 96s105.6 28.9 134.1 72.7L592 195V156.6c0-2-.8-4-2.2-5.5L486.5 40.4c-9-9.7-8.5-24.9 1.2-33.9s24.9-8.5 33.9 1.2L624.9 118.4c9.7 10.4 15.1 24 15.1 38.2v47.5V224v64 19.9 47.5c0 14.2-5.4 27.8-15.1 38.2L521.5 504.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9L589.8 360.8c1.4-1.5 2.2-3.4 2.2-5.5V317L454.1 343.3C425.6 387.1 376.2 416 320 416s-105.6-28.9-134.1-72.7L48 317v38.4c0 2 .8 4 2.2 5.5L153.5 471.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2L15.1 393.6C5.4 383.2 0 369.6 0 355.4V307.9 288 224 204.1 156.6c0-14.2 5.4-27.8 15.1-38.2L118.5 7.6zM48 268.1l115.7 22c-2.4-11-3.7-22.4-3.7-34.2s1.3-23.2 3.7-34.2L48 243.9v24.3zm428.3-46.3c2.4 11 3.7 22.4 3.7 34.2s-1.3 23.2-3.7 34.2l115.7-22V243.9l-115.7-22zM304 334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2V334.4zm-50.7-34.3c-5.6-8.4-9.6-17.9-11.7-28.1H209.1c2.7 19 10.2 36.4 21.2 51.1l23-23zM241.6 240c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1h32.5zm34.3-50.7c8.4-5.6 17.9-9.6 28.1-11.7V145.1c-19 2.7-36.4 10.2-51.1 21.2l23 23zM336 366.9c19-2.7 36.4-10.2 51.1-21.2l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7v32.5zM430.9 272H398.4c-2.1 10.2-6.1 19.7-11.7 28.1l23 23c11-14.7 18.4-32.1 21.2-51.1zm-32.5-32h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23c5.6 8.4 9.6 17.9 11.7 28.1zM336 145.1v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23c-14.7-11-32.1-18.4-51.1-21.2zM352 256c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.2-9.2h-.5c-8.7 .1-16.5 3.6-22.2 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
var faDiceSix = {
  prefix: 'far',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faStarfighterTwinIonEngine = {
  prefix: 'far',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", "M24 32c13.3 0 24 10.7 24 24V193.7l105.8-24.9C182.4 125 231.8 96 288 96s105.6 29 134.2 72.8L528 193.7V56c0-13.3 10.7-24 24-24s24 10.7 24 24V205v19 64 19V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V318.3L422.2 343.2C393.6 387 344.2 416 288 416s-105.6-29-134.2-72.8L48 318.3V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V307 288 224 205 56C0 42.7 10.7 32 24 32zM444.7 288.6L528 269V243l-83.3-19.6c2.2 10.5 3.3 21.4 3.3 32.6s-1.1 22.1-3.3 32.6zM48 269l83.3 19.6c-2.2-10.5-3.3-21.4-3.3-32.6s1.1-22.1 3.3-32.6L48 243v26zm224 97.9V334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2zm-73.7-43.8l23-23c-5.6-8.4-9.6-17.9-11.7-28.1H177.1c2.7 19 10.2 36.4 21.2 51.1zM177.1 240h32.5c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1zm43.8-73.7l23 23c8.4-5.6 17.9-9.6 28.1-11.7V145.1c-19 2.7-36.4 10.2-51.1 21.2zM355.1 345.7l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7v32.5c19-2.7 36.4-10.2 51.1-21.2zm22.6-22.6c11-14.7 18.4-32.1 21.2-51.1H366.4c-2.1 10.2-6.1 19.7-11.7 28.1l23 23zm-23-111.2c5.6 8.4 9.6 17.9 11.7 28.1h32.5c-2.7-19-10.2-36.4-21.2-51.1l-23 23zm.3-45.6c-14.7-11-32.1-18.4-51.1-21.2v32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23zM310.6 278.6c5.8-5.8 9.4-13.8 9.4-22.6c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.3-9.2h-.5c-8.7 .1-16.5 3.6-22.3 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4z"]
};
var faStarfighterAlt = faStarfighterTwinIonEngine;
var faRocketLaunch = {
  prefix: 'far',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M197.9 253.9c12.9 6.4 24.7 14.8 35 25.2s18.8 22.2 25.2 35c105.8-30 156.7-79.5 181.5-126c25-46.8 27.3-97.6 22-137.7c-40.1-5.3-90.9-3-137.7 22c-46.5 24.8-96 75.8-126 181.5zM384 312.1v82.2c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-114.7c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3h82.2C281.7-3.8 408.8-8.5 483.9 5.3c11.6 2.1 20.7 11.2 22.8 22.8c13.8 75.1 9.1 202.2-122.7 284zM28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5C132.3 504.3 66 511 28.3 511.9zm50.2-64.5c12.8-.7 31.2-3.7 41.3-13.7c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9zM328 144a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faMosquitoNet = {
  prefix: 'far',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-13.3 0-25.3 5.4-34 14.1l-11.7-1.7 7.5 6.5c-3.4 4.5-6.1 9.6-7.8 15.2c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM105.2 310c.8-.8 1.6-1.5 2.4-2.3l82-71.4L78.5 252.9c-.4 .1-.8 .1-1.1 .2C60.6 255.2 48 269.5 48 286.3c0 29.8 36.1 44.8 57.2 23.7zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"]
};
var faVentDamper = {
  prefix: 'far',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M512 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H512zM128 64c-35.3 0-64 28.7-64 64v32H32c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32H64v32c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V352h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H576V128c0-35.3-28.7-64-64-64H128zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faBridgeWater = {
  prefix: 'far',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", "M48 112v50.8c45.9 10.9 80 52.2 80 101.5V361c-14.8-8.5-32-10.6-48-6.5V264.3C80 233.2 54.8 208 23.7 208C10.6 208 0 197.4 0 184.3V96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v88.3c0 13.1-10.6 23.7-23.7 23.7c-31.1 0-56.3 25.2-56.3 56.3v90.2c-16-4.1-33.2-2-48 6.6V264.3c0-49.2 34.1-90.5 80-101.5V112H48zM192 384.5c-5.2 0-10.5-.6-16-1.7V272c0-61.9 50.1-112 112-112s112 50.1 112 112V382.8c-5.5 1.1-10.8 1.7-16 1.7c-10.4 0-21.3-2.2-32-6.1V272c0-35.3-28.7-64-64-64s-64 28.7-64 64V378.4c-10.3 3.8-21.1 6.1-32 6.1zm-80.1 13.6c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faBanBug = {
  prefix: 'far',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1L385.1 419.1C349.7 447.2 304.8 464 256 464zm78.9-163c.2-1.1 .3-2.1 .5-3.2l29.5 5.9c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7V246.7l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-21.6 0-41.2 8.6-55.6 22.5L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L334.9 301zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z"]
};
var faDebug = faBanBug;
var faPersonBooth = {
  prefix: 'far',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M299.2 48l75.1 191.2c2.7 6.8 2.1 14.4-1.5 20.7L316.8 358c-3.1 5.5-4.8 11.7-4.8 18c0 13.3 10.7 24 24 24c8.3 0 15.7-4.2 20-10.7c4.4-6.7 11.9-10.7 20-10.7s15.5 4 20 10.7c4.3 6.5 11.7 10.7 20 10.7c8.6 0 16.2-4.5 20.5-11.5c4.3-6.9 11.8-11.2 19.9-11.4s15.8 3.8 20.4 10.5c5.1 7.5 13.6 12.3 23.2 12.3c13.2 0 24.3-9.2 27.3-21.5c.2-.9 .5-1.7 .7-2.5V372 56c0-4.4-3.6-8-8-8H299.2zM528 442.7c-8.7 3.4-18.1 5.3-28 5.3c-15.8 0-30.5-4.8-42.6-13.1c-11.7 8.2-26 13.1-41.4 13.1c-14.8 0-28.6-4.5-40-12.1c-11.4 7.7-25.2 12.1-40 12.1c-39.8 0-72-32.2-72-72c0-14.7 3.8-29.1 11.1-41.8l50.4-88.1L247.6 48c-4.3 .2-7.6 3.7-7.6 8V208H192V56c0-30.9 25.1-56 56-56h16H520c30.9 0 56 25.1 56 56V372v12V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V442.7zM192 320h48V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V320zM64 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM61.2 208c-7.3 0-13.2 5.9-13.2 13.2v42.2l0 .6v13c.1 1.7 .7 3.4 1.8 4.7L72 309V209.9c-3.4-1.2-7.1-1.9-10.8-1.9zM0 276.6V221.2C0 187.4 27.4 160 61.2 160c24.2 0 47.2 11 62.3 29.9l40 50.1H216c13.3 0 24 10.7 24 24s-10.7 24-24 24H159.7c-12.2 0-23.6-5.5-31.2-15L120 262.4V368.1l23 28.4c5.8 7.1 9 16 9 25.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V424.5L48 355.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V277.5l0-.9z"]
};
var faTextWidth = {
  prefix: 'far',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M48 112l0-32 152 0 0 160-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-160 152 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24zM441 401c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23L81.9 360l23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 284.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64z"]
};
var faGarageCar = {
  prefix: 'far',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40H504c22.1 0 40 17.9 40 40V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V240H144zm127.9 85.9l-7 26.1H375l-7.5-26.2c-1-3.4-4.1-5.8-7.7-5.8H279.6c-3.6 0-6.8 2.4-7.7 5.9zm-59.7 37l4.6-17.2 8.7-32.3c6.6-24.4 28.8-41.4 54.1-41.4h80.2c25 0 47 16.6 53.8 40.6l9.4 32.8 5.1 17.8C445 374.7 456 394.1 456 416v72c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H232v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V416c0-22.1 11.2-41.5 28.2-53zM408 416c0-8.8-7.2-16-16-16H248c-8.8 0-16 7.2-16 16v16H408V416z"]
};
var faSquareKanban = {
  prefix: 'far',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zM128 288c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24zm168 40c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V328zm-72-72c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24z"]
};
var faHatWizard = {
  prefix: 'far',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M327.7 227.6c-5.1-11.5-7.7-23.9-7.7-36.5c0-10.1 1.7-20.1 5-29.7l27.7-79.1-98.3 56.2c-26.6 15.2-47.7 38.5-60.1 66.5L100.5 416H48L150.4 185.5c16.6-37.4 44.7-68.4 80.2-88.7L376.9 13.2l.1 0 2.1-1.2 16.6-9.5C398.5 .9 401.7 0 405 0c10.5 0 19 8.5 19 19v1.5c0 2.3-.4 4.6-1.2 6.8l-5 14.2-1.5 4.2-.1 .3-46 131.3c-1.6 4.4-2.4 9.1-2.4 13.8c0 5.9 1.2 11.7 3.6 17l-43.9 19.5zm43.9-19.5L464 416H411.5L327.7 227.6l43.9-19.5zM246.2 416H201.8l-6.5-19.4-40.4-13.5C148.4 381 144 374.9 144 368s4.4-13 10.9-15.2l40.4-13.5 13.5-40.4c2.2-6.5 8.3-10.9 15.2-10.9s13 4.4 15.2 10.9l13.5 40.4 40.4 13.5c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-40.4 13.5L246.2 416zM0 480c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM264 168c3.4 0 6.5 2.2 7.6 5.5l6.7 20.2 20.2 6.7c3.3 1.1 5.5 4.1 5.5 7.6s-2.2 6.5-5.5 7.6l-20.2 6.7-6.7 20.2c-1.1 3.3-4.1 5.5-7.6 5.5s-6.5-2.2-7.6-5.5l-6.7-20.2-20.2-6.7c-3.3-1.1-5.5-4.1-5.5-7.6s2.2-6.5 5.5-7.6l20.2-6.7 6.7-20.2c1.1-3.3 4.1-5.5 7.6-5.5z"]
};
var faPenFancy = {
  prefix: 'far',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", "M399.4 59.9c7.1-7.6 17-11.9 27.3-11.9C447.3 48 464 64.7 464 85.3c0 10.4-4.3 20.2-11.9 27.3l-195.5 182-39.2-39.2 182-195.5zM426.7 0C403 0 380.4 9.8 364.2 27.2L170.8 234.9 97.2 257.6c-22.8 7-40.6 24.9-47.6 47.6L1.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l22.6-73.6L484.8 147.8C502.2 131.6 512 109 512 85.3C512 38.2 473.8 0 426.7 0zM228.8 334.8l-20.3 65.9c-2.3 7.6-8.3 13.5-15.9 15.9L85 449.7 134.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L62.3 427 95.5 319.3c2.3-7.6 8.3-13.5 15.9-15.9l65.9-20.3 51.6 51.6z"]
};
var faCoffeePot = {
  prefix: 'far',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M88 80c-22.1 0-40 17.9-40 40v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V120C0 71.4 39.4 32 88 32h34.4H192 453.6C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80H88zm296.8 80l35.6-80H192 155.6l35.6 80H384.8zm1.2 48H190c-41.8 21.6-71.7 63.1-77.1 112H463.1c-5.4-48.9-35.3-90.4-77.1-112zm32.2 224H157.7c.1 0 .1 0 .2 0H418c.1 0 .1 0 .2 0z"]
};
var faMouseField = {
  prefix: 'far',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M393.4 50.8C397.9 49 402.8 48 408 48c22.1 0 40 17.9 40 40c0 8.1-2.4 15.6-6.5 21.9c-10.4-5.3-21.7-9.1-33.6-11.4c-.9-17.4-6.1-33.7-14.5-47.8zm86.2 88.4C489.9 124.8 496 107.1 496 88c0-48.6-39.4-88-88-88c-18.4 0-35.5 5.7-49.6 15.3C342.5 5.6 323.9 0 304 0C246.6 0 200 46.6 200 104v3.2c0 21.2 6.4 41.3 17.7 58.1C143.2 184.4 88 252 88 332.6c0 12.7 2.8 24.7 7.9 35.4H72c-39.8 0-72 32.2-72 72s32.2 72 72 72H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24h99.4H344h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H344.2l32-80H456c30.9 0 56-25.1 56-56v-7.7c0-32.6-12.2-62.4-32.4-85.1zM292.6 368H171.4c-19.6 0-35.4-15.9-35.4-35.4C136 263.8 191.8 208 260.6 208H280c11.4 0 21.2-8 23.5-19.2s-3.6-22.4-14.1-26.9l-7.5-3.2c-20.6-8.8-33.9-29.1-33.9-51.5V104c0-30.9 25.1-56 56-56s56 25.1 56 56v16c0 12.5 9.7 23 22.2 23.9l8 .6c41.7 3.2 73.9 38 73.9 79.8V232c0 4.4-3.6 8-8 8H360c-9.8 0-18.6 6-22.3 15.1L292.6 368zM396 216a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faPersonDigging = {
  prefix: 'far',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440.8 288c8.2 .3 15.7 4.7 19.8 11.8l104 176c4.4 7.4 4.5 16.6 .2 24.1s-12.2 12.1-20.8 12.1H288c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l16-48c3.3-9.8 12.4-16.4 22.8-16.4h35.4l20.3-29.5L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4s19.1-18 31.4-12.9L61 210.1l19.8-36.2C96.2 145.6 125.8 128 158 128h3.8c52.3 0 98.5 33.8 114.4 83.6l32.3 101.6 79 32.9 32.8-47.7c4.6-6.8 12.4-10.7 20.6-10.4zm-190.4 1l-20-62.8c-9.5-29.9-37.3-50.2-68.6-50.2H158c-14.6 0-28.1 8-35.1 20.8l-17.3 31.8L250.4 289zm188.1 67.6l-66.7 97L364.6 464H501.9L438.5 356.6zM81.4 301.1l128 54.4c8.9 3.8 14.6 12.5 14.6 22.1V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V393.5L87.5 355.9 47 494.7c-3.7 12.7-17 20-29.8 16.3S-2.7 494 1 481.3L49 316.5l7.6-25.9 24.9 10.6z"]
};
var faDigging = faPersonDigging;
var faShowerDown = {
  prefix: 'far',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M192 0c13.3 0 24 10.7 24 24v9.8c77 11.6 136 78 136 158.2v16h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H328 56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V192C32 111.8 91 45.4 168 33.8V24c0-13.3 10.7-24 24-24zM80 208H304V192c0-61.9-50.1-112-112-112S80 130.1 80 192v16zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zm109.8 42.4l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zm64 128l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zm82.2-170.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1z"]
};
var faShowerAlt = faShowerDown;
var faBoxCircleCheck = {
  prefix: 'far',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M342.4 80c6.3 0 12.1 3.7 14.6 9.5L388.4 160H248V80h94.4zM48 208H358.6c22.3-10.3 47.2-16 73.4-16c5.4 0 10.7 .2 16 .7v-3.1c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H296.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V208zm11.6-48L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80H59.6zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBrightness = {
  prefix: 'far',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M232 88c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V88zm24 120a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM0 256c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm424-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H424zM256 512c13.3 0 24-10.7 24-24V424c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24zM75 75c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zM391.8 357.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3zM75 437c9.4 9.4 24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9zM357.8 120.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3z"]
};
var faCarSideBolt = {
  prefix: 'far',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M134.2 105.1L99.4 192H128v48H64c-8.8 0-16 7.2-16 16v96H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H389.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H592V320c0-44.2-35.8-80-80-80H416V192h46.1L384.5 95c-7.6-9.5-19.1-15-31.2-15H171.3c-16.4 0-31.1 10-37.1 25.1zM46.8 194.3l42.8-107C103 53.9 135.3 32 171.3 32H353.2c26.7 0 52 12.2 68.7 33L524 192.6c65.1 6 116 60.8 116 127.4v48c0 17.7-14.3 32-32 32H574.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H32c-17.7 0-32-14.3-32-32V256c0-29.4 19.8-54.2 46.8-61.7zM434.7 400a48 48 0 1 0 90.5-32 48 48 0 1 0 -90.5 32zM208 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM331.2 100.6c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176H352c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L243.7 208H192c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"]
};
var faOrnament = {
  prefix: 'far',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32H128c-17.7 0-32 14.3-32 32v25.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3V128c0-17.7-14.3-32-32-32h-8.6zM192 176c42.6 0 81 18.5 107.3 48H84.7c26.4-29.5 64.7-48 107.3-48zM56.2 272H327.8c5.3 15 8.2 31.2 8.2 48s-2.9 33-8.2 48H56.2c-5.3-15-8.2-31.2-8.2-48s2.9-33 8.2-48zM84.7 416H299.3C273 445.5 234.6 464 192 464s-81-18.5-107.3-48z"]
};
var faPhoneArrowDownLeft = {
  prefix: 'far',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.2-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM505 41l-135 135H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faPhoneArrowDown = faPhoneArrowDownLeft;
var faPhoneIncoming = faPhoneArrowDownLeft;
var faCloudWord = {
  prefix: 'far',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120v0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96H504h3.3c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8v.2h-8H464 144C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8zM512 368c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16zM240 352c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zM128 304c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm272-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHandFingersCrossed = {
  prefix: 'far',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M169.8 57.6c3.7-8 13.3-11.5 21.3-7.7s11.5 13.3 7.7 21.3L120 240H84.7l55.7-119.5c1-1.7 1.9-3.5 2.5-5.3l26.8-57.6zM126.3 37.3l-6.5 14C102.9 24.1 68 13.1 38.3 27C6.3 41.9-7.6 80 7.3 112l42.1 90.2L22 261c-.9 2-1.5 4-1.9 6C7.6 281.1 0 299.7 0 320v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V272 256 224c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.4 0-10.7 .7-15.7 1.9l18-38.5c14.9-32 1.1-70.1-31-85.1s-70.1-1.1-85.1 31zM50.8 91.7c-3.7-8-.3-17.5 7.7-21.3s17.5-.3 21.3 7.7l13.7 29.3L75.9 145.4l-25-53.7zM240 176c8.8 0 16 7.2 16 16v32 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16zm0 128c7.9 0 15.4-1.4 22.4-4c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120H168c-66.3 0-120-53.7-120-120l0-24 0 0c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2zm96-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224c0-8.8 7.2-16 16-16s16 7.2 16 16v32z"]
};
var faTrash = {
  prefix: 'far',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"]
};
var faGaugeSimple = {
  prefix: 'far',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6V120c0-13.3-10.7-24-24-24s-24 10.7-24 24V301.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56z"]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faArrowDownSmallBig = {
  prefix: 'far',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", "M143 473L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55V56c0-13.3 10.7-24 24-24s24 10.7 24 24V398.1l55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zM368 144h64V80H368v64zm-48 0V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48zm48 160V432H496V304H368zm-48 0c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V304z"]
};
var faSortSizeDownAlt = faArrowDownSmallBig;
var faBookMedical = {
  prefix: 'far',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM48 432c0 17.7 14.3 32 32 32H368V400H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM208 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272v48c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V224H160c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48V112z"]
};
var faFaceMelting = {
  prefix: 'far',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M528 256c0-114.9-93.1-208-208-208s-208 93.1-208 208c0 33.5 7.9 65 21.9 93c16.7 33.4 12.5 72.2-.1 100.7c-2.1 4.7-4.6 9.5-7.6 14.4H319.9l.1 0h0 0l.1 0h164c-2.7-7.5-4.1-15.6-4.1-24c0-32.6 21.6-60.1 51.3-69c-10.9-20.5-14.2-44.9-9.1-66.1c3.8-15.6 5.8-32 5.8-48.9zm40.9 60.1c-6 24.8 11.1 51.9 36.6 51.9h0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H605.5h0L552 416c-13.3 0-24 10.7-24 24s10.7 24 24 24s24 10.7 24 24s-10.7 24-24 24H320.1l-.1 0-.1 0H46.6 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H46.6c38.9 0 61.8-58.8 44.4-93.6C73.7 336 64 297.1 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 20.7-2.5 40.8-7.1 60.1zm-305.1-158a32 32 0 1 1 -16.6 61.8 32 32 0 1 1 16.6-61.8zm115.4 64A32 32 0 1 1 441 238.7a32 32 0 1 1 -61.8-16.6zM220.4 279.9c11.3 23.2 33.6 50.1 72.7 60.6s71.9-1.7 93.2-16.1c11-7.4 25.9-4.6 33.3 6.4s4.6 25.9-6.4 33.3c-29.5 19.9-76.5 37.8-132.5 22.8s-87.9-54-103.4-86c-5.8-11.9-.8-26.3 11.1-32.1s26.3-.8 32.1 11.1z"]
};
var faPoo = {
  prefix: 'far',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M224 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l7.4 7.4c6.1 6.1 9.5 14.4 9.5 23v3.2c0 16.2-13.1 29.3-29.3 29.3H180h-3.1c-6.1 0-12.1 .8-17.8 2.2C113.9 115.8 80 155.9 80 204c0 1.1 0 2.2 .1 3.3C47.1 221.3 24 253.9 24 292c0 14.3 3.3 27.8 9.1 39.9C12.8 350.9 0 377.9 0 408c0 57.4 46.6 104 104 104H408c57.4 0 104-46.6 104-104c0-30.1-12.8-57.1-33.1-76.1c5.8-12.1 9.1-25.6 9.1-39.9c0-38.1-23.1-70.7-56.1-84.7c0-1.1 .1-2.2 .1-3.3c0-38-21.2-71-52.3-87.9C363.6 49.5 303.6 0 232 0h-8zm48 71.4c0-5.5-.6-10.9-1.6-16.1c33.8 13.4 58.9 44 64.5 81c1.3 8.6 7.2 15.9 15.3 18.9C370 162.6 384 181.7 384 204c0 4.9-.7 9.7-1.9 14.1c-1.9 6.7-.8 13.9 3 19.7s10 9.7 16.9 10.6c21.5 2.9 38 21.3 38 43.6c0 11.4-4.3 21.8-11.4 29.6c-5 5.4-7.1 12.9-5.9 20.1s5.7 13.6 12.2 17.1c17.4 9.5 29.2 28 29.2 49.2c0 30.9-25.1 56-56 56H104c-30.9 0-56-25.1-56-56c0-21.2 11.7-39.7 29.2-49.2c6.5-3.5 10.9-9.8 12.2-17.1s-1-14.7-5.9-20.1C76.3 313.8 72 303.4 72 292c0-22.3 16.6-40.7 38-43.6c6.9-.9 13-4.8 16.9-10.6s4.9-13 3-19.7c-1.3-4.5-1.9-9.2-1.9-14.1c0-25.1 17.8-46 41.4-50.9c.4-.1 .8-.2 1.2-.3c2-.5 4.1-.8 6.3-.8H180h14.7c42.7 0 77.3-34.6 77.3-77.3V71.4zM192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM172.3 352c-6.8 0-12.3 5.5-12.3 12.3c0 2.4 .7 4.8 2.2 6.7c8.2 10.5 39.5 45 93.8 45s85.6-34.6 93.8-45c1.5-1.9 2.2-4.3 2.2-6.7c0-6.8-5.5-12.3-12.3-12.3H172.3z"]
};
var faPenClipSlash = {
  prefix: 'far',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0L384 62.1 370.9 49c-28.1-28.1-73.7-28.1-101.8 0l-76.6 76.6L38.8 5.1zM230.5 155.4L303 82.9c9.4-9.4 24.6-9.4 33.9 0L350.1 96l-85.8 85.8-33.7-26.4zm71.8 56.2L384 129.9 446.1 192l-74.2 74.2-69.6-54.5zM197.5 316.5l36.3-36.3-38-29.9-32.3 32.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7-38-29.9-43.6 43.6c-38.8 38.8-87.5 66-140.7 78.6c12.7-53.2 39.9-101.9 78.6-140.7z"]
};
var faPenAltSlash = faPenClipSlash;
var faQuoteRight = {
  prefix: 'far',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 296c0 66.3-53.7 120-120 120H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h16c39.8 0 72-32.2 72-72V286c-5.1 1.3-10.5 2-16 2H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-48-72V192 160c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16zM64 240h64c8.8 0 16-7.2 16-16V192 160c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16zm128-48v32 72c0 66.3-53.7 120-120 120H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H72c39.8 0 72-32.2 72-72V286c-5.1 1.3-10.5 2-16 2H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32z"]
};
var faQuoteRightAlt = faQuoteRight;
var faScrollOld = {
  prefix: 'far',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M80 80c-17.7 0-32 14.3-32 32v48H80v48H48c-26.5 0-48-21.5-48-48V112C0 67.8 35.8 32 80 32H400c44.2 0 80 35.8 80 80V272H448 432 400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V112c0-17.7-14.3-32-32-32H153.3c4.3 9.8 6.7 20.6 6.7 32V224h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160V400c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-26.5 21.5-48 48-48h.6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6c26.5 0 48 21.5 48 48v48c0 44.2-35.8 80-80 80H192c-44.2 0-80-35.8-80-80V112c0-17.7-14.3-32-32-32zM265.3 432H496c17.7 0 32-14.3 32-32V352h0-.6-.6-.6-.6-.6-.6H524h-.6-.6-.6-.6-.6-.6-.6-.6H519h-.6-.6-.6-.6-.5-.6-.5-.6-.5-.5H513h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H507h-.5H506h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H499h-.5H498h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H487h-.5H486h-.5H485h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H456h-.5H455h-.5H454h-.5H453h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H441h-.5H440h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H431h-.5H430h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H423h-.5H422h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H415h-.5H414h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H407h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H400v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-.4-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H360h-.5H359h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H347h-.5H346h-.5H345h-.5H344h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H315h-.5H314h-.5H313h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H302h-.5H301h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H294h-.5H293h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H287h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6H281h-.6-.6-.6-.6-.6-.6-.6-.6H276h-.6-.6-.6-.6-.6-.6H272h0v48c0 11.4-2.4 22.2-6.7 32z"]
};
var faGuitars = {
  prefix: 'far',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", "M152 178V133.7l19.8-39.6c2.8-5.6 4.2-11.7 4.2-17.9V24c0-13.3-10.7-24-24-24H104C90.7 0 80 10.7 80 24V76.2c0 6.2 1.4 12.3 4.2 17.9L104 133.7V178c-50.3 8.6-88 43.8-88 86c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c29.3 0 56.3-8 77.8-21.4c-8.4-14.7-13.4-31.7-13.8-49.7c-13.1 12.9-34.3 23.2-64 23.2c-54 0-80-33.9-80-56c0-9.7 3.7-19.8 12.4-29.3c26.2-29 26.4-71.9 7.8-101.2c-3-4.8-4.2-9.2-4.2-13.5c0-9.6 11.2-29.7 40-37.1V312c0 13.3 10.7 24 24 24s24-10.7 24-24V226.9c28.8 7.4 40 27.5 40 37.1c0 4.2-1.2 8.7-4.2 13.5c-18.6 29.4-18.4 72.2 7.8 101.2c2.5 2.7 4.6 5.5 6.3 8.4c4.1-11.5 8.8-22.1 12.9-31.2l0 0 1-2.3c3.3-7.4 6.1-13.9 8.5-19.7c-3-10.1-1.5-21.8 4.1-30.7c1.1-1.7 2.1-3.5 3.1-5.3c-.9-4.9-2.7-10.7-5.7-19.3l-.4-1.3c-3.5-10-8.5-24.7-9.2-40.9c-.1-1.3-.1-2.5-.1-3.8V219.6 209.6c-15.8-15.7-38.2-27.1-64-31.5zm170.6-53.9L344 148.6V240c-23.7 0-38.6-8.8-48-19.8c-2.5-2.9-4.6-6-6.3-9.1c-3.7-6.6-6-13.3-7.4-19.1l0-.2c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16v8 19.6 12.9c0 .8 0 1.7 .1 2.5c.5 11.5 4.2 22.3 7.9 33.1c4 11.6 8 23.3 8 35.9c0 20-9.3 40.9-19 62.5c-10.3 23.2-21 47.1-21 71.7c0 40.8 33 73.8 73.8 73.8H438.2c40.8 0 73.8-33 73.8-73.8c0-24.5-10.7-48.5-21-71.7c-9.6-21.6-19-42.5-19-62.5c0-12 4-22.9 8.1-33.8l0 0c3.3-8.9 6.6-17.8 7.6-27.2c.2-1.9 .3-3.8 .3-5.7v-1.6V222 208c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5l-.2 .5c-1.9 4.5-4.7 9.4-9.1 14c-1 1.1-2.1 2.1-3.2 3.1c-9.4 8.3-24.3 14.9-48 14.9V74.1c9.6-6.4 16-17.3 16-29.7V39.8C408 17.8 390.2 0 368.2 0c-18.8 0-35 13.1-38.9 31.5L315.4 96.3c-2.1 9.9 .6 20.2 7.2 27.8zM344 384c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zm81.9-99.7c-1.1 6.1-1.9 12.8-1.9 19.7c0 30.7 13.5 60.6 22.2 80l0 0c.7 1.5 1.4 3 2 4.4c10.7 24 15.8 38 15.8 49.8c0 14.2-11.6 25.8-25.8 25.8H297.8c-14.2 0-25.8-11.6-25.8-25.8c0-11.9 5.2-25.8 15.8-49.8c.6-1.4 1.3-2.9 2-4.4l0 0c8.7-19.4 22.2-49.2 22.2-80c0-7.2-.8-14.1-1.9-20.5c10.4 2.9 21.7 4.5 33.9 4.5h48c12.1 0 23.4-1.3 33.9-3.7z"]
};
var faPhoneXmark = {
  prefix: 'far',
  iconName: 'phone-xmark',
  icon: [640, 512, [], "e227", "M393 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.2-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2C239.2 485.6 64 295.2 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L393 286.7zm133.8 78.1l-100.4-43L397 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L112.1 70.5C115.5 286.2 289.8 460.5 505.5 464l21.3-99.2zM407 7c9.4-9.4 24.6-9.4 33.9 0l47 47L535 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L407 41c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faHose = {
  prefix: 'far',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M312 128c13.3 0 24-10.7 24-24v-2.3l80.2-11.5C417.3 98 423.9 104 432 104c8.8 0 16-7.2 16-16V40c0-8.8-7.2-16-16-16c-8.1 0-14.7 6-15.8 13.7L336 26.3V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24zM8 488c0 13.3 10.7 24 24 24H416c13.3 0 24-10.7 24-24s-10.7-24-24-24H32c-13.3 0-24 10.7-24 24zM32 384c-13.3 0-24 10.7-24 24s10.7 24 24 24H416c13.3 0 24-10.7 24-24s-10.7-24-24-24H32zM8 328c0 13.3 10.7 24 24 24H416c13.3 0 24-10.7 24-24s-10.7-24-24-24H32c-13.3 0-24 10.7-24 24zM56 156c0-37.6 30.4-68 68-68H256V40H124C59.9 40 8 91.9 8 156s51.9 116 116 116H416c13.3 0 24-10.7 24-24s-10.7-24-24-24H124c-37.6 0-68-30.4-68-68z"]
};
var faClockSix = {
  prefix: 'far',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faShirt = {
  prefix: 'far',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M146.3 27.8C167.9 9.8 195.1 0 223.2 0c18.2 0 31.1 13.6 34 28.5C263 57.8 288.9 80 320 80s57-22.2 62.8-51.5C385.7 13.6 398.7 0 416.8 0c28.1 0 55.3 9.8 76.8 27.8L478.3 46.3l15.4-18.4L619.8 133c11.6 9.7 18.8 23.6 20 38.6s-3.7 29.9-13.7 41.3l-56 64c-20 22.9-54.6 25.6-78 6.1L480 272.9V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V272.9L147.9 283c-23.4 19.5-58 16.7-78-6.1l-56-64C3.9 201.5-1 186.6 .2 171.6s8.4-29 20-38.6L146.3 27.8zm66.5 20.9c-13.1 1.9-25.5 7.4-35.8 15.9L50.9 169.9c-1.7 1.4-2.7 3.4-2.9 5.5s.5 4.3 2 5.9L31.9 197.1 50 181.3l56 64c2.9 3.3 7.8 3.7 11.1 .9l51.5-42.9c7.2-6 17.1-7.2 25.5-3.3s13.8 12.4 13.8 21.7V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V221.7c0-9.3 5.4-17.8 13.8-21.7s18.4-2.7 25.5 3.3l51.5 42.9c3.3 2.8 8.3 2.4 11.1-.9l56-64c1.4-1.6 2.1-3.7 2-5.9s-1.2-4.1-2.9-5.5L462.9 64.7c-10.3-8.6-22.7-14.1-35.8-15.9C413.1 94.6 370.5 128 320 128s-93.1-33.4-107.1-79.3z"]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faBillboard = {
  prefix: 'far',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H248V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H80C53.5 32 32 53.5 32 80V352H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H80 296v88c0 13.3 10.7 24 24 24s24-10.7 24-24V400H560h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80c0-26.5-21.5-48-48-48H440V24zM320 352H80L80 80H200v48h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h32 32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80H392v48h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h32 32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80H560V352H320z"]
};
var faSquareR = {
  prefix: 'far',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32H256c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H176v64h56z"]
};
var faCubes = {
  prefix: 'far',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", "M290.7 48.3c-1.7-.6-3.6-.6-5.4 0l-81.2 29L288 109.5l83.9-32.1-81.2-29zM176 207.2l88 31.4V151.7l-88-33.7v89.3zm136 31.4l88-31.4V117.9l-88 33.7v86.9zM448 93V207.5l91.9 34.8c21.8 8.2 36.1 29.1 36.1 52.4V413.9c0 22.2-13.1 42.3-33.5 51.3l-96.4 42.4c-14 6.1-29.8 6.3-43.9 .5L288 460.7 173.8 508c-14.1 5.8-30 5.7-43.9-.5L33.5 465.1C13.1 456.2 0 436.1 0 413.9V294.7c0-23.3 14.4-44.1 36.1-52.4L128 207.5V93c0-23.7 14.9-44.8 37.2-52.7l104-37.1c12.2-4.3 25.5-4.3 37.6 0l104 37.1C433.1 48.2 448 69.3 448 93zM264 320.2l-88 33.7V455.1l88-36.4V320.2zM52.8 421.2L128 454.3V353.9L48 323.2v90.7c0 3.2 1.9 6 4.8 7.3zM400 455.1V353.9l-88-33.7v98.6l88 36.4zm48-.9l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3V323.2l-80 30.6V454.3zM155 250.7c-1.8-.6-3.7-.6-5.5 .1L70.8 280.6 152 311.7l83.9-32.1L155 250.7zm266 0l-80.9 28.9L424 311.7l81.2-31.1-78.7-29.8c-1.8-.7-3.7-.7-5.5-.1z"]
};
var faEnvelopeOpenDollar = {
  prefix: 'far',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", "M120 48c-4.4 0-8 3.6-8 8V225.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V186.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2V56c0-4.4-3.6-8-8-8H120zM48 276.2V456c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8V276.2L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V237.9zM276 88v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V296c0 11-9 20-20 20s-20-9-20-20V281.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V88c0-11 9-20 20-20s20 9 20 20z"]
};
var faDivide = {
  prefix: 'far',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M264 96a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm0 320a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM408 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H408z"]
};
var faSunCloud = {
  prefix: 'far',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-16.9 0-32.8-4.4-46.6-12.1l-2.1 11.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4-13.3 19.3c9.6-2.7 19.7-4.1 30.1-4.1c9.8 0 19.4 1.3 28.5 3.7l15.3-22.1c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c11.4 0 22.3-1.7 32.6-4.8c-.4-3.7-.6-7.4-.6-11.2c0-21.4 7-41.2 18.8-57.1C295.1 310.1 276.7 320 256 320c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 14.2-4.6 27.3-12.4 37.9c13.2-17.3 32.1-30 54-35.3c1.8-4 3.8-8 6.1-11.7C363 189.3 314.8 144 256 144zM384 416H568c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64z"]
};
var faLampFloor = {
  prefix: 'far',
  iconName: 'lamp-floor',
  icon: [640, 512, [], "e015", "M183.6 176H456.4L405.2 48H234.8L183.6 176zM194.3 20.1C199.1 8 210.9 0 224 0H416c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM216 464h80V256h48V464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H320 216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSquare7 = {
  prefix: 'far',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32H296c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTengeSign = {
  prefix: 'far',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 56C0 42.7 10.7 32 24 32H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56zM0 184c0-13.3 10.7-24 24-24H192 360c13.3 0 24 10.7 24 24s-10.7 24-24 24H216V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H24c-13.3 0-24-10.7-24-24z"]
};
var faTenge = faTengeSign;
var faHeadphones = {
  prefix: 'far',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", "M49.6 262C62.4 159.4 149.9 80 256 80s193.6 79.4 206.4 182c-9.4-3.9-19.6-6-30.4-6c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80V368 336 288C512 146.6 397.4 32 256 32S0 146.6 0 288v48 32 32c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48c-10.8 0-21 2.1-30.4 6zM48 336c0-17.7 14.3-32 32-32V432c-17.7 0-32-14.3-32-32V368 336zm416 0v32 32c0 17.7-14.3 32-32 32V304c17.7 0 32 14.3 32 32z"]
};
var faHandsHolding = {
  prefix: 'far',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M72 64c39.8 0 72 32.2 72 72V264.8c12.1-10.5 28-16.8 45.3-16.8c18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3c5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3c17.3 0 33.1 6.3 45.3 16.8V136c0-39.8 32.2-72 72-72s72 32.2 72 72V352.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V281.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9c0 0 0 0 0 0L473 393c0 0 0 0 0 0l-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16c0 0 0 0 0 0l26.7-26.7c4-4 6.2-9.4 6.2-15c0-11.7-9.5-21.3-21.3-21.3c-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V436.8c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2c-11.7 0-21.3 9.5-21.3 21.3c0 5.6 2.2 11 6.2 15L201 359l0 0 16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16 0 0-26.7-26.7 0 0-15.9-15.9C106.2 332.1 96 307.5 96 281.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V352.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L35.1 437.1C12.6 414.6 0 384.1 0 352.2V136C0 96.2 32.2 64 72 64z"]
};
var faCampfire = {
  prefix: 'far',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4c-3.2 0-6.4 1.1-9 3.4c-29.9 27-55.3 57.7-73.2 87.1c-17.7 29-29.2 60.2-29.2 84.2C112 254.5 175.3 320 256 320c79.9 0 144-65.5 144-145.3c0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0c-8.7 8-16.7 17.8-23.8 26.8C266.6 37 250 19.6 232.2 3.4zM301 248.2c-13.5 9.1-27.9 13.6-44.1 13.6c-40.5 0-72.9-26.4-72.9-70.9c0-21.8 13.5-40.9 40.5-74.5c3.6 4.5 55.8 71.8 55.8 71.8L312.7 150c2.7 3.6 4.5 7.3 6.3 10.9c16.2 30 9 68.2-18 87.3zM32.5 289.6c-12.4-4.7-26.3 1.5-31 13.9s1.5 26.2 13.9 31L188.3 400 15.5 465.6c-12.4 4.7-18.6 18.6-13.9 31s18.6 18.6 31 13.9L256 425.7l223.5 84.8c12.4 4.7 26.3-1.5 31-13.9s-1.5-26.2-13.9-31L323.7 400l172.8-65.6c12.4-4.7 18.6-18.6 13.9-31s-18.6-18.6-31-13.9L256 374.3 32.5 289.6z"]
};
var faCircleAmpersand = {
  prefix: 'far',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 191.6c0-8.6 7-15.6 15.6-15.6h19.2c7.3 0 13.2 5.9 13.2 13.2c0 4.2-2 8.1-5.4 10.6L235 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11zm71 46.9c15.7-11.5 25-29.8 25-49.3c0-33.8-27.4-61.2-61.2-61.2H231.6c-35.1 0-63.6 28.5-63.6 63.6c0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1c-17.1 12.5-27.2 32.4-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5h32.2c24.1 0 46.9-10.9 62-29.4L327 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7L287 238.5zm-87.5 64.1l30.7-22.5 40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8H210.5c-10.2 0-18.5-8.3-18.5-18.5c0-5.9 2.8-11.4 7.5-14.9z"]
};
var faSnowflakes = {
  prefix: 'far',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M224 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4V137.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24zM487 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faHandsClapping = {
  prefix: 'far',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M328 0c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM223.1 18.7c7.4-4.9 17.3-2.9 22.2 4.4l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2zM412 152c9.5-5.1 20.4-8 32-8c37.6 0 68 30.4 68 68V329.6c0 100.5-81.3 182-181.7 182.4c27.3-16.9 50.5-39.8 67.8-66.8c39.4-23.4 65.8-66.4 65.8-115.6V212c0-11-9-20-20-20c-5 0-9.6 1.9-13.1 4.9c-2.5-16.7-9.2-32-18.9-44.9zM410.7 23.1c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48zM320 208v40c0 3.3-.6 6.4-1.8 9.2s-2.9 5.5-5.2 7.8s-5 4-7.8 5.2s-5.9 1.8-9.2 1.8s-6.4-.6-9.2-1.8s-5.5-2.9-7.8-5.2L169 154.9c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7L233 247c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L121 202.9l-32-32c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l24 24L185 295c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L65 242.9s0 0 0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l48 48 0 0L137 343c1.2 1.2 2.2 2.4 3.1 3.8c6.2 9.3 5.1 22-3.1 30.2c-9.4 9.4-24.6 9.4-33.9 0L65 338.9l0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l22 22 0 0 16 16 0 0 33.6 33.6c25.2 25.2 59.4 39.4 95 39.4C291.8 464 352 403.8 352 329.6V208c0-8.8-7.2-16-16-16s-16 7.2-16 16zM113.9 129.6c10.4-15.4 28.1-25.6 48.1-25.6c15.4 0 30.1 6.1 41 17L274 192.1c7.1-27.6 32.2-48.1 62-48.1c35.3 0 64 28.7 64 64V329.6C400 430.3 318.3 512 217.6 512c-48.4 0-94.8-19.2-129-53.4L55 425l0 0L39 409l0 0-22-22C6.1 376 0 361.3 0 345.9c0-19.6 9.7-36.9 24.6-47.4L17 290.9C6.1 280 0 265.3 0 249.9c0-21.2 11.4-39.8 28.4-49.9c-2.9-7-4.4-14.5-4.4-22.1c0-32 25.9-57.9 57.9-57.9c11.4 0 22.5 3.4 31.9 9.6z"]
};
var faRepublican = {
  prefix: 'far',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M152 32C68.1 32 0 100.1 0 184v80V424c0 30.9 25.1 56 56 56H88c30.9 0 56-25.1 56-56V384H304v40c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56V384h48v24c0 39.8 32.2 72 72 72s72-32.2 72-72V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V360 264 184c0-83.9-68.1-152-152-152H152zM496 288v48H424c-13.3 0-24 10.7-24 24v64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V360c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v64c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V288H496zm0-48H48V184C48 126.6 94.6 80 152 80H392c57.4 0 104 46.6 104 104v56zM405.7 115.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L450 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM271.9 112c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-122.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L194 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6z"]
};
var faLeafMaple = {
  prefix: 'far',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", "M344.8 13.3c-3.7-7.4-11-12.4-19.3-13.2s-16.4 2.8-21.4 9.5L249.9 82l-2.1-16.1c-.9-7-4.8-13.2-10.7-17.1s-13.2-4.9-19.9-2.9L181.8 56.4 147 15.9c-4.6-5.3-11.2-8.4-18.2-8.4s-13.7 3.1-18.2 8.4L74 58.5 27 52.6c-7.9-1-15.8 2-21 8S-1.2 74.7 .8 82.4L41.4 238 10.7 258.5c-7 4.6-11 12.6-10.7 20.9s5 15.9 12.3 20l106.9 59.4L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L153.2 392.8l59.4 106.9c4.1 7.3 11.6 12 20 12.3s16.3-3.7 20.9-10.7L274 470.6l155.6 40.6c7.7 2 15.9 .1 21.9-5.2s9-13.1 8-21l-5.4-42.8c-.3-2.7 .7-5.3 2.7-7.1l39.3-33.7c5.3-4.6 8.4-11.2 8.4-18.2s-3.1-13.7-8.4-18.2l-40.6-34.8 10.5-35.4c2-6.8 .9-14-2.9-19.9s-10.1-9.8-17.1-10.7L430 262.1l72.4-54.3c6.7-5 10.2-13.1 9.5-21.4s-5.7-15.6-13.2-19.3l-36.1-18.1c-3.4-1.7-5.2-5.7-4.1-9.4l22.6-79.2c2.4-8.4 .1-17.4-6.1-23.6s-15.2-8.5-23.6-6.1L372.2 53.5c-3.7 1.1-7.6-.7-9.4-4.1L344.8 13.3zM188.5 357.5L313.9 232.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L154.5 323.5 70.1 276.6l2.7-1.8c14.2-9.5 20.8-26.9 16.5-43.4L56.2 104.6l24.7 3.1c8 1 16-2.1 21.2-8.2l26.7-31.1 26.7 31.1c6.2 7.2 16 10.1 25.1 7.4l23.2-6.9 6 46.8c1.2 9.7 8.2 17.7 17.7 20.2s19.5-1 25.3-8.8l66.5-88.7 .7 1.4C332 95 359.5 107.1 385.4 99.7l37.7-10.8-10.8 37.7c-7.4 25.9 4.7 53.4 28.8 65.5l1.4 .7-88.7 66.5c-7.8 5.9-11.3 15.9-8.8 25.3s10.5 16.4 20.2 17.7l46.8 6-6.9 23.2c-2.7 9.1 .2 18.9 7.4 25.1l31.1 26.7-18.1 15.5c-14.3 12.2-21.5 30.8-19.1 49.5l1 7.7L280.6 422.8c-16.5-4.3-33.9 2.3-43.4 16.5l-1.8 2.7-46.9-84.5z"]
};
var faArrowLeft = {
  prefix: 'far',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"]
};
var faPersonCircleXmark = {
  prefix: 'far',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1H146.3c-.8 0-1.5 0-2.3 .1zM144 352V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faRuler = {
  prefix: 'far',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", "M63.2 379.3c-6.2-6.2-6.2-16.4 0-22.6l39.4-39.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 39.4-39.4c6.2-6.2 16.4-6.2 22.6 0l69.5 69.5c6.2 6.2 6.2 16.4 0 22.6L155.3 448.8c-6.2 6.2-16.4 6.2-22.6 0L63.2 379.3zM98.7 482.7c25 25 65.5 25 90.5 0L482.7 189.3c25-25 25-65.5 0-90.5L413.3 29.3c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z"]
};
var faCupStrawSwoosh = {
  prefix: 'far',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M249.3 0H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H249.3c-3.7 0-6.9 2.6-7.8 6.2L224.2 128h79.6H352h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H348 299.8 209.9 174.1 84.2 36 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8H80.2h94.7l20-84.8C200.8 17.9 223.4 0 249.3 0zM60.3 468L38.7 208H86.8L99.7 362.4c15.7-3.1 27.5-7.3 36.9-11.9c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7c16-8.6 35.4-15.1 59.8-18.9l3-36h48.2L323.7 468c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44zM290 293.5c-14.1 3.1-24.6 7.1-32.9 11.6c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-14.9 7.4-32.6 13.1-54.2 17l4.5 53.5H275.8L290 293.5z"]
};
var faTemperatureSun = {
  prefix: 'far',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", "M320.6 98.5l-2.7-.5L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l70.8 49.6c4.5 3.2 10.3 3.8 15.4 1.6c.7-.3 1.5-.7 2.1-1.1c-5.4-16.9-8.3-34.9-8.3-53.7c0-37.7 11.8-72.6 32-101.2V112c0-4.5 .2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64V273.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5c7.1-9.5 12.8-22.1 12.8-36.6V112zM464 0C402.1 0 352 50.2 352 112V273.9c0 1.7-.7 4.4-3.2 7.8c-18.1 24.1-28.8 54-28.8 86.4c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8V112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faTemperatureHot = faTemperatureSun;
var faAlignLeft = {
  prefix: 'far',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faDiceD6 = {
  prefix: 'far',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M243.9 7.7c-12.4-7-27.6-6.9-39.9 .3L19.8 115.6C7.5 122.8 0 135.9 0 150.1V366.6c0 14.5 7.8 27.8 20.5 34.9l184 103c12.1 6.8 26.9 6.8 39.1 0l184-103c12.6-7.1 20.5-20.4 20.5-34.9V146.8c0-14.4-7.7-27.7-20.3-34.8L243.9 7.7zM71.8 140.8L224.2 51.7l152 86.2L223.8 228.2l-152-87.4zM48 182.4l152 87.4V447.1L48 361.9V182.4zM248 447.1V269.7l152-90.1V361.9L248 447.1z"]
};
var faRestroom = {
  prefix: 'far',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M128 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-7.3 80h14.6c3 0 5.9 .3 8.7 1V304H112V177c2.8-.6 5.7-1 8.7-1zM112 488V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V251.4l17.6 45.3c4.8 12.4 18.7 18.5 31.1 13.7s18.5-18.7 13.7-31.1l-37-95.2c-13.2-33.8-45.7-56.1-82-56.1H120.7c-36.3 0-68.9 22.3-82 56.1L1.6 279.3c-4.8 12.4 1.3 26.3 13.7 31.1s26.3-1.3 31.1-13.7L64 251.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM320 0c-13.3 0-24 10.7-24 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM560 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48 80c-40.7 0-77.2 25-92 62.9l-34.4 88.4c-4.8 12.4 1.3 26.3 13.7 31.1c7.6 3 15.8 1.8 22.1-2.5l-15.7 55.8c-2.9 10.2 4.8 20.3 15.4 20.3H448V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h26.9c10.6 0 18.3-10.1 15.4-20.3l-15.7-55.8c6.3 4.2 14.5 5.4 22.1 2.5c12.4-4.8 18.5-18.7 13.7-31.1L604 190.9C589.2 153 552.7 128 512 128zm0 48c2.2 0 4 1.4 4.6 3.5l44 156.5H463.4l44-156.5c.6-2.1 2.5-3.5 4.6-3.5z"]
};
var faHighDefinition = {
  prefix: 'far',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 184V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208h32zM160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v72 72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V256 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48H160V184z"]
};
var faRectangleHd = faHighDefinition;
var faJ = {
  prefix: 'far',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M296 32c13.3 0 24 10.7 24 24V320c0 88.4-71.6 160-160 160S0 408.4 0 320V280c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 61.9 50.1 112 112 112s112-50.1 112-112V56c0-13.3 10.7-24 24-24z"]
};
var faGalaxy = {
  prefix: 'far',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M160 184c0-68.3 50.4-124.9 116.1-134.5c-31.2 28.4-51.6 66.6-58 108.1c-1.4 9.3 2.7 18.6 10.6 23.7s18.1 5.2 26 .1C275.9 167.8 301 160 328 160c68.3 0 124.9 50.4 134.5 116.1c-28.4-31.2-66.6-51.6-108.1-58c-9.3-1.4-18.6 2.7-23.7 10.6s-5.2 18.1-.1 26C344.2 275.9 352 301 352 328c0 68.3-50.4 124.9-116.1 134.5c31.2-28.4 51.6-66.6 58-108.1c1.4-9.3-2.7-18.6-10.6-23.7s-18.1-5.2-26-.1C236.1 344.2 211 352 184 352c-68.3 0-124.9-50.4-134.5-116.1c28.4 31.2 66.6 51.6 108.1 58c9.3 1.4 18.6-2.7 23.7-10.6s5.2-18.1 .1-26C167.8 236.1 160 211 160 184zM296 0C194.4 0 112 82.4 112 184c0 15.9 2 31.3 5.8 46c-16.4-9.4-30.8-22.2-42.2-37.9l-13-17.9c-6.5-9-16.9-14.2-28-14.2C15.5 160 0 175.5 0 194.6V216C0 317.6 82.4 400 184 400c15.9 0 31.3-2 46-5.8c-9.4 16.4-22.2 30.8-37.9 42.2l-17.9 13c-9 6.5-14.2 16.9-14.2 28c0 19.1 15.5 34.6 34.6 34.6H216c101.6 0 184-82.4 184-184c0-15.9-2-31.3-5.8-46c16.4 9.4 30.8 22.2 42.2 37.9l13 17.9c6.5 9 16.9 14.2 28 14.2c19.1 0 34.6-15.5 34.6-34.6V296c0-101.6-82.4-184-184-184c-15.9 0-31.3 2-46 5.8c9.4-16.4 22.2-30.8 37.9-42.2l17.9-13-14-19.3 14 19.3c9-6.5 14.2-16.9 14.2-28C352 15.5 336.5 0 317.4 0H296zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faUsersViewfinder = {
  prefix: 'far',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", "M48 48v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V32C0 14.3 14.3 0 32 0H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H48zm544 0H504c-13.3 0-24-10.7-24-24s10.7-24 24-24H608c17.7 0 32 14.3 32 32V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V48zM136 464c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-17.7 0-32-14.3-32-32V376c0-13.3 10.7-24 24-24s24 10.7 24 24v88h88zm456 0V376c0-13.3 10.7-24 24-24s24 10.7 24 24V480c0 17.7-14.3 32-32 32H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h88zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2h32 32c6.7 0 13.3 .7 19.6 2c1.1 .2 2.2 .5 3.3 .7c23.6 5.8 43.8 20.3 56.9 39.9c1.2 1.7 2.3 3.5 3.3 5.4c8.2 14.1 12.8 30.5 12.8 48c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32c0-17.5 4.7-33.9 12.8-48c12.9-22.3 34.6-39 60.3-45.3c1.1-.3 2.2-.5 3.3-.7zm96.2-162.6A72 72 0 1 1 275.4 240.5a72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32H288c-20.9 0-38.7 13.4-45.3 32H397.3zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3h69.3c9.8 0 18.9 2.6 26.8 7.2c-34.6 12.2-62.5 38.9-76.2 72.8H122.7C107.9 336 96 324.1 96 309.3zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8c7.9-4.6 17-7.2 26.8-7.2h69.3c29.5 0 53.3 23.9 53.3 53.3c0 14.7-11.9 26.7-26.7 26.7H470.7zM416 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faFileVideo = {
  prefix: 'far',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"]
};
var faCherries = {
  prefix: 'far',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", "M288 24L302.1 4.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1c0 0 0 0 0 0s0 0 0 0l0 0 0 .2-.1 .9c-.1 .9-.3 2.2-.6 4c-.6 3.6-1.5 9-2.9 15.8c-2.8 13.7-7.6 33.3-15.3 56.3c-14 42-37.4 94.7-75.8 143.7C152.3 233.5 126.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.5 0-38.9 4.3-54 9.7c27.1-42.6 45-85.1 56.7-120.2c5.7-17 9.9-32.3 13-45.1c11.7 10.8 25.8 24.7 40.1 41.2c29.6 34.3 59.1 78.4 73.1 128.5c-12-5.3-27-10.3-44.2-12.7c16.3 14.8 30.1 35.3 37.4 63c1.8 1 3.3 2 4.6 2.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4l.1 0 .6 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-12.3 0-36.6-3.4-61.7-13.4c-9.2 14.8-20.2 27.5-32.3 38.2C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.2 10.6-76.3 19.6C453.5 176 415.2 118.9 380.2 78.3c-19.9-23-39.2-41.3-53.6-53.9c-7.2-6.3-13.2-11.2-17.5-14.5c-2.1-1.7-3.8-3-5-3.9c-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1 0 0 0 0s0 0-14.1 19.4zM162.4 293.8c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4l.1 0 .6 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-16.7 0-55.6-6.3-88.7-26.8C72.7 418.3 48 388.4 48 336c0-39.1 15.1-51.2 24.2-56.5c6.1-3.6 12.7-5.6 18-6.6c2.6-.5 4.6-.7 5.7-.8c.3 0 .6 0 .7-.1c18.7 .1 35.4 5.5 48 11.4c6.2 2.9 11.1 5.8 14.2 7.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3z"]
};
var faUpRightFromSquare = {
  prefix: 'far',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faCircleSort = {
  prefix: 'far',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM244.7 411.3l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faSortCircle = faCircleSort;
var faTableCells = {
  prefix: 'far',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", "M360 80v88H464V96c0-8.8-7.2-16-16-16H360zm-48 0H200v88H312V80zM152 80H64c-8.8 0-16 7.2-16 16v72H152V80zM48 216v80H152V216H48zm0 128v72c0 8.8 7.2 16 16 16h88V344H48zm152 88H312V344H200v88zm160 0h88c8.8 0 16-7.2 16-16V344H360v88zM464 296V216H360v80H464zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 296H312V216H200v80z"]
};
var faTh = faTableCells;
var faFilePdf = {
  prefix: 'far',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
};
var faSiren = {
  prefix: 'far',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M345.6 304H394L375 152.1C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1L54 304h48.4l18.2-146c1-8 7.8-14 15.9-14h175c8.1 0 14.9 6 15.9 14l18.2 146zm-165.5 0l11.8-94c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-12.2 98h32.2zM48 384H400v48H48l0-48zM0 384v48c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V384c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"]
};
var faArrowUpToDottedLine = {
  prefix: 'far',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM241.5 151.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L200 228.5V312 440c0 13.3 10.7 24 24 24s24-10.7 24-24V312 228.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z"]
};
var faImageLandscape = {
  prefix: 'far',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H83.8l80.8-110.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L232.8 330l83.1-127.1c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L485 400h27c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM96 448H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H472 272 200 96zm64-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLandscape = faImageLandscape;
var faTankWater = {
  prefix: 'far',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M277.2 80L263.9 55.7 251 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H197L184.1 55.7 170.8 80H64c-8.8 0-16 7.2-16 16V302.4c14.1-2.7 27.8-8.7 39.3-15.3c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 18.9 12.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 19 12.8c11.6 6.6 25.2 12.5 39.4 15.3V96c0-8.8-7.2-16-16-16H277.2zM48 416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V351c-25-3.1-47.1-13-63.1-22.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-16 9.1-38.1 19-63 22.1v65zM212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7L273 139.2c4.6 8.4 7 17.9 7 27.5V168c0 30.9-25.1 56-56 56s-56-25.1-56-56v-1.4c0-9.6 2.4-19 7-27.5L212.2 71z"]
};
var faCurlingStone = {
  prefix: 'far',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", "M264 80c-22.1 0-40 17.9-40 40v24H416c35.3 0 64 28.7 64 64v1.1c54.3 7.8 96 54.4 96 110.9v48c0 61.9-50.1 112-112 112H112C50.1 480 0 429.9 0 368V320c0-56.4 41.7-103.1 96-110.9V208c0-35.3 28.7-64 64-64h16V120c0-48.6 39.4-88 88-88H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H264zM112 432H464c35.3 0 64-28.7 64-64H48c0 35.3 28.7 64 64 64zM48 320H528c0-35.3-28.7-64-64-64H112c-35.3 0-64 28.7-64 64z"]
};
var faCurling = faCurlingStone;
var faGamepadModern = {
  prefix: 'far',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 336H424c22 0 41.2 15 46.6 36.4l3.6 14.3c6.7 26.6 30.6 45.3 58 45.3c33 0 59.8-26.8 59.8-59.8v-2.8c0-3.5-.3-7.1-.9-10.6L558.4 168c-6.2-36-27.8-60.4-54.6-67.1C461.4 90.3 399.7 80 320 80s-141.5 10.3-183.7 20.9C109.4 107.6 87.8 132 81.6 168L48.9 358.8c-.6 3.5-.9 7-.9 10.6v2.8c0 33 26.8 59.8 59.8 59.8c27.4 0 51.4-18.7 58-45.3l3.6-14.3C174.8 351 194 336 216 336zm211.6 62.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM232 168v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H232v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faGamepadAlt = faGamepadModern;
var faMessagesQuestion = {
  prefix: 'far',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", "M72 48C58.7 48 48 58.7 48 72V248c0 13.3 10.7 24 24 24h48c13.3 0 24 10.7 24 24v19.2L202.7 276c3.9-2.6 8.6-4 13.3-4H344c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72zM0 72C0 32.2 32.2 0 72 0H344c39.8 0 72 32.2 72 72V248c0 39.8-32.2 72-72 72H223.3l-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360V320H72c-39.8 0-72-32.2-72-72V72zM256 352h48v24c0 13.3 10.7 24 24 24h96c4.7 0 9.4 1.4 13.3 4L496 443.2V424c0-13.3 10.7-24 24-24h48c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H448V128H568c39.8 0 72 32.2 72 72V376c0 39.8-32.2 72-72 72H544v40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60H328c-39.8 0-72-32.2-72-72V352zM147.9 96.1c5.5-15.4 20.1-25.7 36.4-25.7h41.3c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 165.4v.3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7H184.3c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 228a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z"]
};
var faBookBible = {
  prefix: 'far',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM48 432c0 17.7 14.3 32 32 32H368V400H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM208 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272v96c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V208H160c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h48V96z"]
};
var faBible = faBookBible;
var faO = {
  prefix: 'far',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"]
};
var faSuitcaseMedical = {
  prefix: 'far',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm240 88V432H144V144h8H360h8zM96 144V432H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16H96zM416 432V144h32c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H416zM229.3 224v37.3H192c-8.8 0-16 7.2-16 16v21.3c0 8.8 7.2 16 16 16h37.3V352c0 8.8 7.2 16 16 16h21.3c8.8 0 16-7.2 16-16V314.7H320c8.8 0 16-7.2 16-16V277.3c0-8.8-7.2-16-16-16l-37.3 0V224c0-8.8-7.2-16-16-16H245.3c-8.8 0-16 7.2-16 16z"]
};
var faMedkit = faSuitcaseMedical;
var faBriefcaseArrowRight = {
  prefix: 'far',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm24 88H360h88c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h88zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H152c-13.3 0-24 10.7-24 24s10.7 24 24 24H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
var faExpandWide = {
  prefix: 'far',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M136 64c13.3 0 24 10.7 24 24s-10.7 24-24 24H48v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V88C0 74.7 10.7 64 24 64H136zM0 312c0-13.3 10.7-24 24-24s24 10.7 24 24v88h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V312zM488 64c13.3 0 24 10.7 24 24V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V112H376c-13.3 0-24-10.7-24-24s10.7-24 24-24H488zM464 312c0-13.3 10.7-24 24-24s24 10.7 24 24V424c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h88V312z"]
};
var faClockElevenThirty = {
  prefix: 'far',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faRv = {
  prefix: 'far',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H520c48.6 0 88 39.4 88 88v40c0 22.5-15.5 41.4-36.4 46.6l53.1 41.7c9.7 7.6 15.3 19.2 15.3 31.5V376c0 22.1-17.9 40-40 40H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H408 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7 .9-13.7 2.6-20.1c-1.3-.8-2.4-1.8-3.5-2.9L21.1 335C7.6 321.5 0 303.2 0 284.1V104C0 64.2 32.2 32 72 32H224V24zM72 80c-13.3 0-24 10.7-24 24V284.1c0 6.4 2.5 12.5 7 17L121.9 368H128c13.4-10 30-16 48-16s34.6 6 48 16H384V256 184c0-13.3 10.7-24 24-24h16 80 56V120c0-22.1-17.9-40-40-40H72zM556.8 256l-61.1-48H432v48H556.8zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM120 128H264c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"]
};
var faUserSecret = {
  prefix: 'far',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 13.4 22.1 25.6 57.7 34.3C88.6 169.4 88 176.6 88 184c0 13.9 2.1 27.4 6 40H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H168 280 418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H354c3.9-12.6 6-26.1 6-40c0-7.4-.6-14.6-1.7-21.7c35.6-8.7 57.7-20.9 57.7-34.3c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm44 448l-24.8-99.1c-2.1-8.2-.8-16.9 3.6-24.2l15.7-26.2c25.7-7.6 48.3-22.6 65.2-42.5h23.8l-19.8 49.5c-8.1 20.2-1.6 43.3 15.9 56.3c27.3 20.4 46.2 51 51.2 86.2H268zM185.5 314.5l15.7 26.2c4.4 7.3 5.7 16 3.6 24.2L180 464H49.3c4.9-35.2 23.9-65.8 51.2-86.2c17.4-13 23.9-36.1 15.9-56.3L96.5 272h23.8c16.9 19.9 39.5 34.9 65.2 42.5zM224 272c-38.2 0-70.7-24.4-82.9-58.4c7.1 6.5 16.5 10.4 26.9 10.4h12.4c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2H280c10.4 0 19.8-3.9 26.9-10.4c-12.2 34-44.7 58.4-82.9 58.4z"]
};
var faOtter = {
  prefix: 'far',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2 12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185zM160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-5.1 0-10.1-.4-14.9-1.2c9.5 28.6 36.5 49.2 68.3 49.2h64c13.3 0 24 10.7 24 24c0 2.8-.5 5.5-1.4 8H352c0-11.4 2.4-22.2 6.7-32H328c-36.7 0-68.1-22.4-81.3-54.3c-10.3 4.1-21.5 6.3-33.3 6.3c-14.1 0-27.9-3.3-40.5-9.6L160 240zm250.8 16c10.8-45.9 52-80 101.2-80c13.3 0 24 10.7 24 24v-5.7c0-38.8-24.9-73.3-61.7-85.6l-17.9-6c-12.1-4-18.9-16.8-15.6-29s15.7-19.8 28.1-17.2l16.2 3.4C575.4 78.9 640 158.5 640 250.8c0 120.3-92.6 218.9-210.4 228.5c-4.5 .5-9 .8-13.6 .8h-5.2H384 257.6C133 480 32 379 32 254.4V216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 8-1 15.7-3 23.1c12.4-7.9 27.2-12.5 43-12.5h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-16.6 0-30.2 12.6-31.8 28.7c4.9 2.1 10.2 3.3 15.8 3.3h82.8zM99.7 335.8l.1 .2h.3l-.4-.2zM410.8 432c4.7 0 9.4-.2 14.1-.5c35.6-4.4 63.1-34.7 63.1-71.5V304 256 229.4c-18.9 9-32 28.3-32 50.6c0 13.3-10.7 24-24 24c-17.7 0-32 14.3-32 32v24c0 13.3-10.7 24-24 24H136.2c31.8 29.8 74.5 48 121.4 48H384h26.8zM536 360c0 8.2-.8 16.3-2.4 24c35.9-33.1 58.4-80.6 58.4-133.3c0-16.7-2.8-32.8-8-47.9V208c0 35.5-19.3 66.6-48 83.2V360zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faDreidel = {
  prefix: 'far',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", "M441 39c9.4 9.4 9.4 24.6 0 33.9L327.6 186.3l67.7 67.7c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l67.7 67.7L407 39c9.4-9.4 24.6-9.4 33.9 0zM106.3 204.3L52.7 257.9c-3 3-4.7 7.1-4.7 11.3V416c0 8.8 7.2 16 16 16H210.7c4.2 0 8.3-1.7 11.3-4.7l53.7-53.7L106.3 204.3zm33.9-33.9L309.7 339.7 361.4 288 192 118.6l-51.7 51.7z"]
};
var faPersonDress = {
  prefix: 'far',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", "M208 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm21.7 185.7l37.4 66.1c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l37.4-66.1L53.7 363.7C50.8 373.9 58.5 384 69.1 384H96V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h26.9c10.6 0 18.3-10.1 15.4-20.3L229.7 233.7zM160 176c2.2 0 4 1.4 4.6 3.5l44 156.5H111.4l44-156.5c.6-2.1 2.5-3.5 4.6-3.5z"]
};
var faFemale = faPersonDress;
var faCommentDollar = {
  prefix: 'far',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM276 136c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V344c0 11 9 20 20 20s20-9 20-20V330.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V136z"]
};
var faBusinessTime = {
  prefix: 'far',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64v32.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9V160c0-8.8-7.2-16-16-16H360 152 64c-8.8 0-16 7.2-16 16v96H192 352h8.2c-21.9 26.6-36.2 59.7-39.5 96l-.7 0H224c-17.7 0-32-14.3-32-32V304H48V416c0 8.8 7.2 16 16 16H332c6.9 17.5 16.4 33.7 28.2 48H64c-35.3 0-64-28.7-64-64V280 160c0-35.3 28.7-64 64-64h64zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]
};
var faBriefcaseClock = faBusinessTime;
var faFlowerTulip = {
  prefix: 'far',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", "M273.9 8.1C269.4 2.9 262.9 0 256 0s-13.4 2.9-17.9 8.1L189 63.3 134.7 21.1c-7.2-5.6-17-6.6-25.3-2.6S96 30.8 96 40V152c0 75.1 60.9 136 136 136v85.4C191 321.4 127.4 288 56 288H28c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512h36 48 36c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28H456c-71.4 0-135 33.4-176 85.4V288c75.1 0 136-60.9 136-136V40c0-9.2-5.2-17.5-13.5-21.6s-18-3-25.3 2.6L323 63.3 273.9 8.1zM280 240H232c-48.6 0-88-39.4-88-88V89.1l33.3 25.9c10 7.8 24.3 6.5 32.7-3L256 60.1l46.1 51.8c8.4 9.5 22.7 10.8 32.7 3L368 89.1V152c0 48.6-39.4 88-88 88zM196 464c-75 0-136.9-55.7-146.7-128H56c80.6 0 148.5 54.1 169.4 128H196zm120 0H286.6c20.9-73.9 88.8-128 169.4-128h6.7C452.9 408.3 391 464 316 464z"]
};
var faPeoplePantsSimple = {
  prefix: 'far',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM73.7 237.3l-4.1 49.3C68.8 296 76.2 304 85.6 304H88h80 2.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C180.9 220.8 167 208 150.4 208H105.6c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H112V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM329.7 237.3l-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3H344h80 2.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C436.9 220.8 423 208 406.4 208H361.6c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H368V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3z"]
};
var faCloudDrizzle = {
  prefix: 'far',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM88 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V376zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440zm168-24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-13.3-10.7-24-24-24zm-72-40c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V376zm168-24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-13.3-10.7-24-24-24z"]
};
var faTableCellsLarge = {
  prefix: 'far',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", "M280 80V232H464V96c0-8.8-7.2-16-16-16H280zm-48 0H64c-8.8 0-16 7.2-16 16V232H232V80zM48 280V416c0 8.8 7.2 16 16 16H232V280H48zM280 432H448c8.8 0 16-7.2 16-16V280H280V432zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faThLarge = faTableCellsLarge;
var faBookTanakh = {
  prefix: 'far',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M448 88c0-48.6-39.4-88-88-88H56C25.1 0 0 25.1 0 56V344c0 22.3 13.1 41.6 32 50.6V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H368c44.2 0 80-35.8 80-80c0-2.7-.1-5.4-.4-8h.4V88zM368 400c17.7 0 32 14.3 32 32s-14.3 32-32 32H80V400H368zm32-41.3c-9.8-4.3-20.6-6.7-32-6.7H56c-4.4 0-8-3.6-8-8V56c0-4.4 3.6-8 8-8H360c22.1 0 40 17.9 40 40V358.7zM216 104l13.9 24H202.1L216 104zM202.1 80l-27.7 48H119c-12.3 0-20 13.3-13.9 24l27.7 48-27.7 48c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H313c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H257.6L229.9 80c-6.2-10.7-21.6-10.7-27.7 0zm-69.3 72h27.7l-13.9 24-13.9-24zm55.4 0h55.4l27.7 48-27.7 48H188.3l-27.7-48 27.7-48zm-55.4 96l13.9-24 13.9 24H132.9zM216 296l-13.9-24h27.7L216 296zm83.1-48H271.4l13.9-24 13.9 24zm0-96l-13.9 24-13.9-24h27.7z"]
};
var faTanakh = faBookTanakh;
var faSolarSystem = {
  prefix: 'far',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M464 256c0 42.1-12.5 81.3-34 114.1c-4.4-1.3-9.1-2.1-14-2.1c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c14.2 9 25.3 22.3 31.6 38C196.5 54.6 225.5 48 256 48c114.9 0 208 93.1 208 208zM256 464C141.1 464 48 370.9 48 256c0-42.1 12.5-81.3 34-114.1c4.4 1.3 9.1 2.1 14 2.1c26.5 0 48-21.5 48-48s-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-14.1-9.1-25.1-22.4-31.3-38.2c-26.1 11.8-55 18.3-85.5 18.3zM390.8 169.8c.8-3.1 1.2-6.4 1.2-9.8c0-22.1-17.9-40-40-40c-3.4 0-6.6 .4-9.8 1.2C317.3 105.2 287.8 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-31.8-9.3-61.3-25.2-86.2zM312 159c0 .3 0 .7 0 1c0 22.1 17.9 40 40 40c.3 0 .7 0 1 0c9.5 16.5 15 35.6 15 56c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c20.4 0 39.5 5.5 56 15zm-56 81a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faSealQuestion = {
  prefix: 'far',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M176 112c12.7 0 24.9-5.1 33.9-14.1L256 51.9l46.1 46.1c9 9 21.2 14.1 33.9 14.1h64v64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9V400H335.1c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1H112V335.1c0-12.7-5.1-24.9-14.1-33.9L52.4 255.5l45.6-45.6c9-9 14.1-21.2 14.1-33.9V112h64zM289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64H112c-26.5 0-48 21.5-48 48v64L18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448H400c26.5 0 48-21.5 48-48V335.1l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176V112c0-26.5-21.5-48-48-48H336L289.9 17.9zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPhoneVolume = {
  prefix: 'far',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zm73 166.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.2-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2z"]
};
var faVolumeControlPhone = faPhoneVolume;
var faDiscDrive = {
  prefix: 'far',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M80 96V432H432V96c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm400 0V432h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H456 56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64zM112 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHatCowboySide = {
  prefix: 'far',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M444.8 256H311.3l-31.5-25.6c-25-20.3-55-33-86.6-37.1l4.9-63.4c.3-3.6 2.9-6.5 6.4-7.2L412.3 81.2 444.8 256zM560 400H520c0-1.4-.1-2.9-.4-4.4l-26-139.6c10.2 5.4 21.6 12 32.8 19.8C563.6 301.2 592 332.9 592 368c0 17.7-14.3 32-32 32zM498 204.6c-5.9-2.8-11.1-5.1-15.3-6.9l-24.6-132C454.6 46.2 437.6 32 417.7 32c-2.7 0-5.4 .3-8.1 .8L195.1 75.7c-24.6 4.9-42.9 25.6-44.9 50.6L145 194C62.9 206.8 0 277.9 0 363.6v18.8C0 418.6 29.4 448 65.6 448H464h16 80c44.2 0 80-35.8 80-80c0-60.9-47.6-105.2-86.4-131.8c-20.3-13.9-40.5-24.5-55.5-31.6zM48 363.6C48 295.3 103.3 240 171.6 240c28.4 0 55.9 9.8 77.9 27.7L412.4 400H65.6c-9.7 0-17.6-7.9-17.6-17.6V363.6z"]
};
var faTableRows = {
  prefix: 'far',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", "M448 432l-320 0 0-152 336 0 0 136c0 8.8-7.2 16-16 16zm16-200l-336 0 0-152 320 0c8.8 0 16 7.2 16 16l0 136zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z"]
};
var faRows = faTableRows;
var faLocationExclamation = {
  prefix: 'far',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 96c13.3 0 24 10.7 24 24V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMapMarkerExclamation = faLocationExclamation;
var faFaceFearful = {
  prefix: 'far',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M464 256c0-43.5-13.3-83.9-36.2-117.2l-.1 .2c-6 6.5-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c8 1.1 15.7 2.8 23.2 5.2C342.4 62.2 300.9 48 256 48s-86.4 14.2-120.4 38.4c7.5-2.4 15.2-4.2 23.2-5.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8l-.1-.2C61.3 172.1 48 212.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
var faClipboardUser = {
  prefix: 'far',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H304c0-44.2-35.8-80-80-80H160c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faBusSchool = {
  prefix: 'far',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", "M96 95v1h84.3c5.5-9.6 15.9-16 27.7-16l96 0c11.8 0 22.2 6.4 27.7 16H416V95c0-.4 0-.8-.1-1l0-.1C404.2 79.4 363.5 48 256 48C156.9 48 109.6 79.1 96 94.3c0 .2 0 .4 0 .7zm0 49v82.8c7.7-1.8 15.7-2.8 24-2.8H232V144H96zm320 82.8V144H280v80H392c8.3 0 16.3 1 24 2.8zM464 95v33h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H467c17.9 18.7 29 44.1 29 72v56c0 29.8-20.4 54.9-48 62v42c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H112v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V446c-27.6-7.1-48-32.2-48-62V328c0-27.9 11-53.3 29-72H32c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32H48V95c0-8.8 2-20.6 10.4-30.6C82.9 35.2 145.9 0 256 0C373.7 0 430.9 35.1 454.3 65c7.7 9.8 9.7 21.1 9.7 30zM112 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM120 272c-30.9 0-56 25.1-56 56v56c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V328c0-30.9-25.1-56-56-56H120z"]
};
var faFilmSlash = {
  prefix: 'far',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L89.5 44.9C100.2 36.8 113.6 32 128 32H512c35.3 0 64 28.7 64 64V416c0 3.3-.2 6.5-.7 9.6l55.5 43.5c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM176 112.6V80H134.4L176 112.6zM328.3 232H416V192 80H224v70.3L328.3 232zM528 388.5V344H471.2L528 388.5zM416 423.8L487.4 480H128c-35.3 0-64-28.7-64-64V146.4L152.3 216H112v80h64V234.7L233.5 280H224v40V432H416v-8.2zM176 344H112v72c0 8.8 7.2 16 16 16h48V344zM464 80v88h64V96c0-8.8-7.2-16-16-16H464zm64 136H464v80h64V216z"]
};
var faSquareArrowDownRight = {
  prefix: 'far',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M384 432c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384zm64-16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24H160z"]
};
var faBookSparkles = {
  prefix: 'far',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM160 112l8.8-17.7c2.9-5.9 11.4-5.9 14.3 0L192 112l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 144l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 144l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 112zM264 216l16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 216l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 264l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 264l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 216z"]
};
var faBookSpells = faBookSparkles;
var faWashingMachine = {
  prefix: 'far',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM314.6 319.7c-3.5 .2-7 .3-10.6 .3c-32 0-56-16-80-32s-48-32-80-32c-3.5 0-7.1 .2-10.7 .4C146.4 218.9 182 192 224 192c53 0 96 43 96 96c0 11.1-1.9 21.8-5.4 31.7zM368 288A144 144 0 1 0 80 288a144 144 0 1 0 288 0z"]
};
var faWasher = faWashingMachine;
var faChild = {
  prefix: 'far',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144A72 72 0 1 1 160 0zM128 214V336h64V214.4c-10.2-4.2-21.2-6.4-32.4-6.4c-11 0-21.6 2.1-31.6 6zm0 170V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V257.9L43.7 309.8c-7.6 10.9-22.6 13.5-33.4 5.9S-3.3 293.1 4.3 282.2L50.1 217c25-35.7 65.9-57 109.5-57c43.2 0 83.7 20.8 108.8 56L315.5 282c7.7 10.8 5.2 25.8-5.6 33.5s-25.8 5.2-33.5-5.6L240 258.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H128z"]
};
var faLiraSign = {
  prefix: 'far',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M96 159.2C96 115.5 131.5 80 175.2 80c8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4L215.5 38.5c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2V192H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48v4.5c0 18.8-5.1 37.3-14.8 53.5L3.4 443.7c-4.4 7.4-4.6 16.6-.3 24.2S15.4 480 24 480H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H66.4l8-13.3C88.5 395.1 96 368.1 96 340.5V336H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H96V240H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H96V159.2z"]
};
var faUserVisor = {
  prefix: 'far',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M224 208c26.2 0 49.4-12.6 64-32H160c14.6 19.4 37.8 32 64 32zm0 48c-54 0-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2V80c0-17.7 14.3-32 32-32h12.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H336c17.7 0 32 14.3 32 32v64c0 15.3-10.7 28-25 31.2C324.2 222.5 278 256 224 256zM128 112c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM269.7 352H178.3c-65.7 0-120.1 48.7-129 112H398.7c-8.9-63.3-63.3-112-129-112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM313.5 429c-7.9 0-18.8 9.5-26.5 16.3c-2.1 1.9-4 3.5-5.5 4.7c-2.3 1.7-5.7 0-5.4-2.9c3.2-30.5 13.2-55.5 29.8-74.7c1.3-1.5 4.1-1.6 5.1 .1c15.8 20.6 24.2 45.9 25.1 75.3c0 3.2-4.1 4.7-6.1 2.1c-10.2-14.4-14.7-19.2-16.6-20.9z"]
};
var faFilePlusMinus = {
  prefix: 'far',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM216 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v40c0 13.3 10.7 24 24 24s24-10.7 24-24V288h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V200zM128 384c-13.3 0-24 10.7-24 24s10.7 24 24 24H256c13.3 0 24-10.7 24-24s-10.7-24-24-24H128z"]
};
var faChessClockFlip = {
  prefix: 'far',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", "M384 56c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H488v32h88c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V176c0-35.3 28.7-64 64-64H96V96c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16v16H440V80H408c-13.3 0-24-10.7-24-24zM64 160c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H64zm376 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm16 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V240zM126.5 222.5A104 104 0 1 1 273.5 369.5 104 104 0 1 1 126.5 222.5zm124.5 22.6c-6.2-6.2-16.4-6.2-22.6 0L194.3 279c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faChessClockAlt = faChessClockFlip;
var faSatellite = {
  prefix: 'far',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l58.1 58.1c-50.9-9.8-105.5 3.2-147.2 39.7c-3.8 3.3-5.9 8-5.9 13v.5c0 4.9 1.9 9.6 5.4 13L103 375 55 423c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48 97.6 97.6c3.5 3.5 8.1 5.4 13 5.4h.5c5 0 9.8-2.2 13-5.9c36.5-41.7 49.6-96.3 39.7-147.2L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68L463 177c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L417 49c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17L309 75 241 7zm34.6 289.5c-6.4-9.7-13.8-18.8-22.3-27.3l-10.6-10.6c-8.5-8.5-17.6-15.9-27.3-22.3L369 82.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L429.1 129c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L275.6 296.6zM275 109L197 187l-51-51L224 57.9l51 51zM376 366.1l-51-51L403 237l51 51L376 366.1zM219.4 303.2c38.8 38.8 47.1 97 23.8 144.1L64.7 268.8c47.1-23.2 105.3-14.9 144.1 23.8l10.6 10.6z"]
};
var faPlaneLock = {
  prefix: 'far',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l95.3 61c-8.3 14.1-13.5 30.2-14.9 47.4L299.1 187.6c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2l0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6c9 2.7 17.5 5.3 24.3 7.3V436l-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2V303.7c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5l82.5 26.4c-11 11.5-17.8 27.1-17.8 44.3v.4l-48-15.4V364l48 36v79.3c0 7.9 1.4 15.4 4 22.4c-6.8 6.4-15.9 10.3-26 10.3c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23 0 0 0 0 0 0-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0 0 0 0 0 0 0-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1V297.5c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2V128c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faSteeringWheel = {
  prefix: 'far',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M232 369v93.6C133.7 451.3 56.2 371.4 48.6 272H156.4l74.3 95.5c.4 .5 .8 1 1.3 1.5zm48 0c.4-.5 .9-1 1.3-1.5L355.6 272H463.4c-7.6 99.4-85 179.3-183.4 190.6V369zm72-145l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H195.8c-12.1 0-23.2 6.8-28.6 17.7L160 224H50.4C65.8 124.3 152 48 256 48s190.2 76.3 205.6 176H352zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faTag = {
  prefix: 'far',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", "M197.5 32c17 0 33.3 6.7 45.3 18.7l176 176c25 25 25 65.5 0 90.5L285.3 450.7c-25 25-65.5 25-90.5 0l-176-176C6.7 262.7 0 246.5 0 229.5V80C0 53.5 21.5 32 48 32H197.5zM48 229.5c0 4.2 1.7 8.3 4.7 11.3l176 176c6.2 6.2 16.4 6.2 22.6 0L384.8 283.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-3-3-7.1-4.7-11.3-4.7H48V229.5zM112 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faStretcher = {
  prefix: 'far',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M41.4 71.5c-9.1-9.6-24.3-10-33.9-.9s-10 24.3-.9 33.9L139.7 244.6c16.6 17.5 39.7 27.4 63.8 27.4H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H203.5c-11 0-21.4-4.5-29-12.4L41.4 71.5zM241.2 304l86 62.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 86-62.5H413.2L368 336.9 322.8 304H241.2zM240 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faBookSection = {
  prefix: 'far',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM224.7 246.1c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9c7.9 2.5 12.3 10.9 9.9 18.8c-2.5 7.9-11 12.3-18.8 9.9c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8c2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26l-7-1.8zM222 177.9c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26c0 0-8.8-2.3-9.7-2.6z"]
};
var faBookLaw = faBookSection;
var faInboxes = {
  prefix: 'far',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M62.5 96h67.9c18.2 0 34.8 10.3 42.9 26.5L192 160H320l18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5h67.8l-40-48-307 0-40 48zM48 144v96H464V144l-82.3 0-18.7 37.5C354.8 197.7 338.2 208 320 208H192c-18.2 0-34.8-10.3-42.9-26.5L130.3 144 48 144zM0 144V113.4c0-11.2 3.9-22.1 11.1-30.7L65.6 17.3C74.7 6.3 88.2 0 102.5 0h307c14.2 0 27.8 6.3 36.9 17.3l54.5 65.4c7.2 8.6 11.1 19.5 11.1 30.7V144v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144zM310.1 432H201.9c-24.2 0-46.4-13.7-57.2-35.4L130.3 368H48v96H464V368l-82.3 0-14.3 28.6-42.6-21.3 42.6 21.3c-10.8 21.7-33 35.4-57.2 35.4zM48 320h82.3c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8H310.1c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]
};
var faCoffeeBean = {
  prefix: 'far',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M385.4 134.2c-13.2 27.4-29.7 55.9-48.4 74.7c-34.5 34.8-69.6 52.3-101.5 68.2l-.8 .4c-32.1 16-61 30.6-89.7 59.4c-16.5 16.6-34.2 46.5-49.4 76.9c22.9 13.6 52.9 19.1 87.6 14.1c45.5-6.5 96.1-30.9 138.9-73.8s67.3-93.4 73.8-138.9c4.5-31.5 .4-59.1-10.5-81zm-34.9-39c-23.2-14.8-54.2-20.9-90.3-15.8c-45.5 6.5-96.1 30.9-138.9 73.8S54 246.7 47.5 292.2c-4.8 33.6 .2 62.7 12.8 85.3c14.6-27.4 32.1-55.8 50.7-74.4c34.5-34.8 69.6-52.3 101.5-68.2l.8-.4c32.1-16 61-30.6 89.7-59.4c16.8-16.9 33.6-48.3 47.5-79.8zm50.5-20.7c74.2 74.2 54.2 214.6-44.8 313.6s-239.4 119-313.6 44.8s-54.2-214.6 44.8-313.6s239.4-119 313.6-44.8z"]
};
var faCircleYen = {
  prefix: 'far',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM159.9 150.2c9.8-8.9 25-8.2 33.9 1.6L256 220.3l62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H280v32h40c8.8 0 16 7.2 16 16s-7.2 16-16 16H280v25c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h40V288H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h31.6l-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z"]
};
var faBracketsCurly = {
  prefix: 'far',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M152 32c-48.6 0-88 39.4-88 88v45.5c0 10.6-4.2 20.8-11.7 28.3L7 239c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c7.5 7.5 11.7 17.7 11.7 28.3V392c0 48.6 39.4 88 88 88h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H152c-22.1 0-40-17.9-40-40V346.5c0-23.3-9.3-45.7-25.8-62.2L57.9 256l28.3-28.3c16.5-16.5 25.8-38.9 25.8-62.2V120c0-22.1 17.9-40 40-40h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm272 0H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c22.1 0 40 17.9 40 40v45.5c0 23.3 9.3 45.7 25.8 62.2L518.1 256l-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2V392c0 22.1-17.9 40-40 40H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c48.6 0 88-39.4 88-88V346.5c0-10.6 4.2-20.8 11.7-28.3L569 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3V120c0-48.6-39.4-88-88-88z"]
};
var faEllipsisStrokeVertical = {
  prefix: 'far',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 88A64 64 0 1 1 96 32a64 64 0 1 1 0 128zm24 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 32 256zm88 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 32 416z"]
};
var faEllipsisVAlt = faEllipsisStrokeVertical;
var faComment = {
  prefix: 'far',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"]
};
var faSquare1 = {
  prefix: 'far',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm172 99.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4V336H160c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V152c0-8.6-4.6-16.5-12-20.8z"]
};
var faCakeCandles = {
  prefix: 'far',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM120 168c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H64c-35.3 0-64 28.7-64 64V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V288c0-35.3-28.7-64-64-64h-8V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H248V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H120V168zM64 272H384c8.8 0 16 7.2 16 16v60.8c-5.5-2.1-10.9-5.1-15.8-8.5c-3.2-2.2-6.1-5-9.1-7.7c-6.7-6.3-13.5-12.6-23.2-12.6c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5C310.2 347 299 352 288 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7c-6.7-6.3-13.5-12.6-23.2-12.6c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5C182.2 347 171 352 160 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7C112.4 326.3 105.7 320 96 320c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5c-4.9 3.4-10.3 6.4-15.8 8.5V288c0-8.8 7.2-16 16-16zM400 398.5V464H48V398.5c17.5-3.3 33.9-11.6 48-22.3c18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c14.1 10.7 30.5 19 48 22.3z"]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faHeadSide = {
  prefix: 'far',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64V336h.4c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0H224C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faEnvelope = {
  prefix: 'far',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faDollyEmpty = {
  prefix: 'far',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", "M0 24C0 10.7 10.7 0 24 0h80.8C129 0 150.5 15.6 158 38.6L250 320.2c2-.1 4-.2 6-.2c33.2 0 62.5 16.9 79.8 42.5L544 289.4c12.5-4.4 26.2 2.2 30.6 14.7s-2.2 26.2-14.7 30.6L351.7 407.8c.2 2.7 .3 5.4 .3 8.2c0 53-43 96-96 96s-96-43-96-96c0-34 17.7-63.9 44.3-80.9L112.4 53.5c-1.1-3.3-4.1-5.5-7.6-5.5H24C10.7 48 0 37.3 0 24zM304 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faFaceTissue = {
  prefix: 'far',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 8.7 .5 17.3 1.6 25.7L8.1 288.7c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-11.5 0-22.9-.8-34-2.2c.6-1.9 1-3.9 1.4-5.9l6.9-41.5c8.4 1 17 1.6 25.7 1.6zm-13.3-76l9-54.1 4.3 3.4 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.2 6.6-19.7 7-28.3 1.2zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-159.2 162c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5z"]
};
var faAnglesUp = {
  prefix: 'far',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M241 47c-9.4-9.4-24.6-9.4-33.9 0L47 207c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 241c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 47zM401 399L241 239c-9.4-9.4-24.6-9.4-33.9 0L47 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
var faAngleDoubleUp = faAnglesUp;
var faBinRecycle = {
  prefix: 'far',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M0 56C0 42.7 10.7 32 24 32h8H80.1 495.9 544h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H540.6L516.2 420.6C513.9 454.1 486 480 452.4 480H123.6c-33.6 0-61.4-25.9-63.8-59.4L35.4 80H24C10.7 80 0 69.3 0 56zM83.6 80l24.1 337.1c.6 8.4 7.6 14.9 16 14.9H452.4c8.4 0 15.4-6.5 16-14.9L492.4 80H83.6zM288 176c-2.2 0-4.3 1.1-5.5 2.9l-20.7 29.6c-7.3 10.5-21.6 13.4-32.4 6.6c-11.7-7.3-14.8-22.9-6.9-34.1l20.7-29.6c10.2-14.6 27-23.3 44.8-23.3s34.6 8.7 44.8 23.3l20.7 29.6c7.9 11.3 4.7 26.8-6.9 34.1c-10.8 6.8-25.1 3.9-32.4-6.6l-20.7-29.6c-1.3-1.8-3.3-2.9-5.5-2.9zm-88.3 77.1c11.7 7.3 14.8 22.9 6.9 34.1l-21.5 30.7c-.8 1.1-1.2 2.4-1.2 3.7c0 3.5 2.9 6.4 6.4 6.4H240c13.3 0 24 10.7 24 24s-10.7 24-24 24H190.4c-30.1 0-54.4-24.4-54.4-54.4c0-11.2 3.4-22.1 9.8-31.2l21.5-30.7c7.3-10.5 21.6-13.4 32.4-6.6zM312 352c0-13.3 10.7-24 24-24h49.6c3.5 0 6.4-2.9 6.4-6.4c0-1.3-.4-2.6-1.2-3.7l-21.5-30.7c-7.9-11.3-4.7-26.8 6.9-34.1c10.8-6.8 25.1-3.9 32.4 6.6l21.5 30.7c6.4 9.1 9.8 20 9.8 31.2c0 30.1-24.4 54.4-54.4 54.4H336c-13.3 0-24-10.7-24-24z"]
};
var faPaperclip = {
  prefix: 'far',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", "M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.2-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"]
};
var faChartLineDown = {
  prefix: 'far',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zM320 296c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v54.1L321 127c-9.4-9.4-24.6-9.4-33.9 0l-79 79-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l79-79L398.1 272H344c-13.3 0-24 10.7-24 24z"]
};
var faArrowRightToCity = {
  prefix: 'far',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M336 56c0-4.4 3.6-8 8-8H456c4.4 0 8 3.6 8 8V216c0 13.3 10.7 24 24 24h80 16c4.4 0 8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-28.2-20.9-51.6-48-55.4V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H512V56c0-30.9-25.1-56-56-56H344c-30.9 0-56 25.1-56 56V488c0 13.3 10.7 24 24 24s24-10.7 24-24V56zm32 40v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H384zM368 288v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H512zM496 384v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16zM160.1 158.2c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9L169.9 232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H169.9l-42.1 38.2c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6l88-80c5-4.5 7.9-11 7.9-17.8s-2.9-13.2-7.9-17.8l-88-80z"]
};
var faLockA = {
  prefix: 'far',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", "M224 48c44.2 0 80 35.8 80 80v32H144V128c0-44.2 35.8-80 80-80zM96 128v32H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 208H96h48H304h48 32c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm58.5 197.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L178.8 400h90.3l13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2L245.6 245.5c-1.2-2.4-2.7-4.6-4.6-6.5c-2.2-2.2-4.7-3.9-7.4-5c-3.1-1.3-6.3-2-9.5-2s-6.4 .6-9.5 2c-2.7 1.2-5.3 2.9-7.4 5c-1.9 1.9-3.4 4.1-4.6 6.5L122.5 405.3zM202.8 352L224 309.7 245.2 352H202.8z"]
};
var faRibbon = {
  prefix: 'far',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", "M6.5 415.6l96.6-103.4L136 347.4 60.5 428.2l40.3 28.2 68.5-73.3 32.8 35.1-80.5 86.2c-8.2 8.7-21.5 10.1-31.3 3.3l-80-56c-5.7-4-9.4-10.2-10.1-17.2s1.6-13.8 6.3-18.9zM245.9 159.4l7-7.5c12.3-13.1 19.1-30.4 19.1-48.4c0-15.3-5-30.2-14.1-42.5l-9.3-12.5c-7.3-.4-15.5-.6-24.4-.6V0c14.8 0 27.9 .6 39 1.5c9.1 .7 17 1.7 23.5 2.6c21.2 3.1 38.2 15.4 49.5 30.6l40.2 53.6c15.4 20.6 23.7 45.6 23.7 71.3c0 30.1-11.4 59.1-32 81.2l-23 24.6-32.8-35.2L332.9 208c12.3-13.1 19.1-30.4 19.1-48.4c0-15.3-5-30.2-14.2-42.5L319.5 92.6c.3 3.6 .5 7.3 .5 11c0 30.1-11.4 59.1-32 81.2l-9.2 9.8-32.8-35.2zM224 48c-8.9 0-17.1 .2-24.4 .6l-9.3 12.5c-9.2 12.3-14.1 27.2-14.1 42.5c0 18 6.8 35.3 19.1 48.4L441.5 415.6c4.7 5.1 7.1 12 6.3 18.9s-4.4 13.2-10.1 17.2l-80 56c-9.8 6.9-23.1 5.5-31.3-3.3L80.1 240.7c-20.6-22-32-51-32-81.2c0-25.7 8.3-50.7 23.7-71.3L112 34.7c11.4-15.2 28.4-27.5 49.5-30.6c6.6-1 14.4-1.9 23.5-2.6C196.1 .6 209.2 0 224 0V48zM110.2 117.1c-9.2 12.3-14.1 27.2-14.1 42.5c0 18 6.8 35.3 19.1 48.4L347.3 456.4l40.3-28.2L160.1 184.7c-20.6-22-32-51-32-81.2c0-3.7 .2-7.4 .5-11l-18.4 24.5z"]
};
var faLungs = {
  prefix: 'far',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V166.8c0 18.1-8.7 35.1-23.5 45.6L256 224.2V184.7 176 165.3C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412c-.2 1.3-.2 2.6-.2 4v7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2C226 480.5 256 442.1 256 398V322.5l-48 34.3V398c0 22-15 41.2-36.4 46.6L98.9 462.8c-3.3 .8-6.6 1.2-9.9 1.2c-22.6 0-41-18.3-41-41v-6c6.3-49.1 29-104.2 54.4-153.1c25.5-49 53.1-90.5 67.8-111.6c3.6-5.1 9.6-8.3 16.4-8.3c11.8 0 21.3 9.6 21.3 21.3V176v43.2 39.3l-69.9 50c-10.8 7.7-13.3 22.7-5.6 33.5s22.7 13.3 33.5 5.6l42.1-30 48-34.3 44.4-31.7c7.4-5.3 13.9-11.4 19.6-18.2c5.6 6.8 12.2 12.9 19.6 18.2L384 283.2l48 34.3 42.1 30c10.8 7.7 25.8 5.2 33.5-5.6s5.2-25.8-5.6-33.5l-69.9-50V219.2 176 165.3c0-11.8 9.6-21.3 21.3-21.3c6.8 0 12.8 3.2 16.4 8.3c14.7 21.1 42.3 62.6 67.8 111.6C563 312.8 585.7 367.9 592 417v6c0 22.6-18.3 41-41 41c-3.4 0-6.7-.4-9.9-1.2l-72.7-18.2C447 439.3 432 420.1 432 398V356.8l-48-34.3V398c0 44.1 30 82.5 72.7 93.1l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89v-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3V176v8.7 39.5l-16.6-11.8c-14.7-10.5-23.4-27.5-23.4-45.6V24z"]
};
var faPersonPinball = {
  prefix: 'far',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM48 186.2c0-5.6 4.6-10.2 10.2-10.2c4.9 0 9.7 1.3 13.8 3.7V299.8L50.6 279.9c-1.6-1.5-2.6-3.6-2.6-5.9V186.2zm72 158.2v-88l6.5 11.5c7.1 12.5 20.4 20.2 34.7 20.2H192v88V488c0 13.3 10.7 24 24 24s24-10.7 24-24V400H592v88c0 13.3 10.7 24 24 24s24-10.7 24-24V376 208 24c0-13.3-10.7-24-24-24H504c-13.3 0-24 10.7-24 24V66c0 6.9 1.3 13.8 3.8 20.3l44 113.2L251 249.3c-4.4-5.7-11.3-9.3-19-9.3H165.9l-42.3-74c-13.4-23.5-38.4-38-65.4-38C26.1 128 0 154.1 0 186.2V274c0 15.6 6.5 30.4 17.9 41L112 402.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V399c0-11.1-4.6-21.7-12.8-29.3L120 344.4zM592 352H240V300.1l32.1-5.8c0 .6-.1 1.1-.1 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24c0-3.5-.8-6.9-2.2-9.9L592 236.7V352zM48 386.7L0 342.1 0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-101.3zM528 66V48h64V187.2l-16.5 2.4L528.5 68.9c-.4-.9-.5-1.9-.5-2.9z"]
};
var faArrowUp91 = {
  prefix: 'far',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M424 80a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm88 40c0 .8 0 1.6 0 2.5c-.6 20.2-7.9 39.7-20.9 55.3l-64.6 77.6c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L405.1 206c-39.5-8.6-69.1-43.8-69.1-86c0-48.6 39.4-88 88-88s88 39.4 88 88zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM456 312V432h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H432 384c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V345.3l-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
var faSortNumericUpAlt = faArrowUp91;
var faAppleCore = {
  prefix: 'far',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M192 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H192zM128 464c4.6 0 13.6-1.7 24.9-5.1c25.4-7.6 52.7-7.6 78.1 0c11.3 3.4 20.3 5.1 24.9 5.1c11.4 0 24.9-3.9 38.9-13.1C260.7 411.6 240 360.2 240 304c0-46 13.9-88.8 37.7-124.4c-12.7 3-26.4 7.5-39 12.4c-30 11.7-63.5 11.7-93.5 0c-12.6-4.9-26.2-9.4-39-12.4C130.1 215.2 144 258 144 304c0 56.2-20.7 107.6-54.9 146.9c14 9.2 27.4 13.1 38.9 13.1zM304 128c6.7 0 13 .6 19.1 1.9l0 0 .5 .1c11.3 2.3 21.5 6.7 30.6 12.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-11.9 0-26.5-3.4-38.8-7.1c-16.4-4.9-34.1-4.9-50.5 0c-12.2 3.7-26.8 7.1-38.8 7.1c-34.9 0-69.8-18.3-98.1-49.6c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3c9.2-6 19.4-10.3 30.6-12.7l.5-.1 0 0C67 128.6 73.3 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3z"]
};
var faCircleY = {
  prefix: 'far',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM170.1 152.3c-8.7-10-23.8-11.1-33.9-2.4s-11.1 23.8-2.4 33.9L232 297v79c0 13.3 10.7 24 24 24s24-10.7 24-24V297l98.1-113.2c8.7-10 7.6-25.2-2.4-33.9s-25.2-7.6-33.9 2.4L256 251.4l-85.9-99.1z"]
};
var faH6 = {
  prefix: 'far',
  iconName: 'h6',
  icon: [640, 512, [], "e413", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM519 69.3c-10.3-8.3-25.5-6.6-33.7 3.7l-98 122.5C364.4 224 352 259.5 352 296h.2c-.1 2.6-.2 5.3-.2 8c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-6.8 0-13.4 .5-20 1.4L522.7 103c8.3-10.4 6.6-25.5-3.8-33.7zM496 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faLitecoinSign = {
  prefix: 'far',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M112 56c0-13.3-10.7-24-24-24S64 42.7 64 56V220.5L17.8 232.8C5 236.2-2.6 249.4 .8 262.2s16.6 20.4 29.4 17l33.8-9V456c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H112V257.4l158.2-42.2c12.8-3.4 20.4-16.6 17-29.4s-16.6-20.4-29.4-17L112 207.7V56z"]
};
var faCircleSmall = {
  prefix: 'far',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M272 256A112 112 0 1 0 48 256a112 112 0 1 0 224 0zM0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
var faBorderNone = {
  prefix: 'far',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faArrowTurnDownLeft = {
  prefix: 'far',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", "M464 56c0-13.3 10.7-24 24-24s24 10.7 24 24V224c0 48.6-39.4 88-88 88H81.9l87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-9.4-9.4-9.4-24.6 0-33.9L135 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87H424c22.1 0 40-17.9 40-40V56z"]
};
var faCircleNodes = {
  prefix: 'far',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M368 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-29.9 50.6c6.8 8.3 15.2 15.2 24.7 20.2L326 352.6c-11.5 1.4-22.2 5.3-31.7 11.1L153.3 240.2c4.3-9.9 6.7-20.7 6.7-32.2c0-2-.1-4.1-.2-6.1l178.3-71.3zM410 159.4c39.5-4.9 70-38.6 70-79.4c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 2 .1 4.1 .2 6.1L141.9 157.4C127.3 139.4 105 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c15.3 0 29.5-4.3 41.6-11.7L262.7 399.8c-4.3 9.9-6.7 20.7-6.7 32.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-30.7-17.3-57.4-42.7-70.8L410 159.4zM304 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faParachuteBox = {
  prefix: 'far',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H232V320H208c-3.3 0-6.5 .3-9.6 1L96.3 188.9c-.2-4.3-.3-8.6-.3-12.9c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192H38L162.4 353c-1.6 4.7-2.4 9.8-2.4 15v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-5.3-.8-10.3-2.4-15L474 192h19.1c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 4.3-.1 8.6-.3 12.9L313.6 321c-3.1-.6-6.3-1-9.6-1H280V192H383.5zM208 368h96v96H208V368z"]
};
var faMessageMedical = {
  prefix: 'far',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM224 128v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240h48c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H288V128c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faCommentAltMedical = faMessageMedical;
var faRugbyBall = {
  prefix: 'far',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M336 16h32c70.7 0 128 57.3 128 128v32c0 176.7-143.3 320-320 320H144C73.3 496 16 438.7 16 368V336C16 159.3 159.3 16 336 16zM308.5 65.4C252.1 71 200.9 93.9 160 128.6c-11.5 9.8-22.2 20.5-32 32.1c-34.8 41.3-57.6 93.1-62.8 150C88.5 266 125.5 216.6 172 170c45.1-45.1 92.9-81.2 136.4-104.6zm-108 381.5c57.2-5.1 109.3-27.9 150.8-62.9c11.6-9.8 22.3-20.5 32.1-32c34.9-41.1 57.8-92.6 63.3-149.3c-23.4 43.7-59.7 91.7-105 137c-46.8 46.8-96.4 83.9-141.3 107.2zM90.4 421.4c2.7 2.7 8.8 5.9 22.3 5c13.4-.9 31.2-5.8 52.5-15.6c42.3-19.4 93.5-55.8 142.7-105s85.6-100.4 105-142.7c9.8-21.2 14.7-39 15.6-52.5c.9-13.5-2.3-19.6-5-22.3s-8.8-5.9-22.3-5c-13.4 .9-31.2 5.8-52.5 15.6c-42.3 19.5-93.5 55.8-142.7 105s-85.6 100.4-105 142.7c-9.8 21.2-14.7 39-15.6 52.5c-.9 13.5 2.3 19.6 5 22.3z"]
};
var faCommentMusic = {
  prefix: 'far',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM352 128c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V219.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V160 128z"]
};
var faIndent = {
  prefix: 'far',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 64C0 77.3 10.7 88 24 88H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 40 0 50.7 0 64zM192 192c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H216zM0 448c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM121 268.4c7.8-6.4 7.8-18.3 0-24.7L26.2 165.6C15.7 157 0 164.4 0 177.9V334.1c0 13.5 15.7 20.9 26.2 12.4L121 268.4z"]
};
var faTreeDeciduous = {
  prefix: 'far',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M185.9 103.6c-1.4 6.2-5.3 11.6-10.7 15s-12 4.4-18.2 3c-4.1-1-8.5-1.5-13-1.5c-30.9 0-56 25.1-56 56c0 6.4 1.1 12.5 3 18.2c3.8 11.1-1 23.4-11.3 28.9C60.8 233.2 48 253.2 48 276c0 33.1 26.9 60 60 60H232V320 256 152c0-13.3 10.7-24 24-24s24 10.7 24 24V256v64 16H404c33.1 0 60-26.9 60-60c0-22.8-12.8-42.8-31.7-52.9c-10.4-5.6-15.2-17.8-11.3-28.9c1.9-5.7 3-11.8 3-18.2c0-30.9-25.1-56-56-56c-4.5 0-8.8 .5-13 1.5c-6.2 1.5-12.7 .4-18.2-3s-9.3-8.7-10.7-15C318.7 71.7 290.1 48 256 48s-62.7 23.7-70.1 55.6zM232 384H108C48.4 384 0 335.6 0 276c0-34.4 16.1-65 41.1-84.8c-.7-5-1.1-10.1-1.1-15.2C40 118.6 86.6 72 144 72c.7 0 1.3 0 2 0C164.5 29.6 206.8 0 256 0s91.5 29.6 110 72c.7 0 1.3 0 2 0c57.4 0 104 46.6 104 104c0 5.2-.4 10.2-1.1 15.2C495.9 211 512 241.6 512 276c0 59.6-48.4 108-108 108H280V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384z"]
};
var faTreeAlt = faTreeDeciduous;
var faPuzzlePieceSimple = {
  prefix: 'far',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M168 112c-4.4 0-8 3.6-8 8v79.1c0 22.6-18.3 40.9-40.9 40.9c-15 0-26.5-8.1-33.5-16.3c-4.9-5.9-9.8-7.7-13.6-7.7c-4 0-9.5 2.1-14.7 9.1S48 243 48 256s4 23.8 9.3 30.9s10.7 9.1 14.7 9.1c3.7 0 8.6-1.8 13.6-7.7c7-8.3 18.5-16.3 33.5-16.3c22.6 0 40.9 18.3 40.9 40.9V392c0 4.4 3.6 8 8 8h76.5c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24H472c4.4 0 8-3.6 8-8V312.9c0-22.6 18.3-40.9 40.9-40.9c15 0 26.5 8.1 33.5 16.3c4.9 5.9 9.8 7.7 13.6 7.7c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-3.7 0-8.6 1.8-13.6 7.7c-7 8.3-18.5 16.3-33.5 16.3c-22.6 0-40.9-18.3-40.9-40.9V120c0-4.4-3.6-8-8-8H395.5c2.9 7.4 4.5 15.5 4.5 24c0 43.1-39.4 72-80 72s-80-28.9-80-72c0-8.5 1.6-16.6 4.5-24H168zm-56 8c0-30.9 25.1-56 56-56H270.1C288.8 64 304 79.2 304 97.9c0 10.1-4.5 18.5-9.9 24.2c-4.2 4.3-6.1 9.2-6.1 13.9c0 9.9 10.7 24 32 24s32-14.1 32-24c0-4.7-1.9-9.5-6.1-13.9c-5.5-5.7-9.9-14.1-9.9-24.2C336 79.2 351.2 64 369.9 64H472c30.9 0 56 25.1 56 56v62.6c10.9-8.8 24.6-14.6 40-14.6c22.5 0 41 12.2 53.1 28.3S640 233.6 640 256s-6.8 43.5-18.9 59.7S590.5 344 568 344c-15.4 0-29.1-5.8-40-14.6V392c0 30.9-25.1 56-56 56H369.9c-18.7 0-33.9-15.2-33.9-33.9c0-10.1 4.5-18.5 9.9-24.2c4.2-4.3 6.1-9.2 6.1-13.9c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9c5.5 5.7 9.9 14.1 9.9 24.2c0 18.7-15.2 33.9-33.9 33.9H168c-30.9 0-56-25.1-56-56V329.4C101.1 338.2 87.4 344 72 344c-22.5 0-41-12.2-53.1-28.3S0 278.4 0 256s6.8-43.5 18.9-59.7S49.5 168 72 168c15.4 0 29.1 5.8 40 14.6V120z"]
};
var faPuzzlePieceAlt = faPuzzlePieceSimple;
var faTruckFieldUn = {
  prefix: 'far',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M80 80c-8.8 0-16 7.2-16 16v32V288v48H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H352V320 224 104 96c0-8.8-7.2-16-16-16H80zM16 336V283.7C6.4 278.2 0 267.8 0 256V160c0-11.8 6.4-22.2 16-27.7V96c0-35.3 28.7-64 64-64H336c29.8 0 54.9 20.4 62 48h37.7c21.7 0 41.4 12.5 50.7 32.2l52.3 111.2 .3 .7h5c35.3 0 64 28.7 64 64v48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H576c0 53-43 96-96 96s-96-43-96-96H352 256c0 53-43 96-96 96s-96-43-96-96H24 16v-1.4C6.7 379.3 0 370.5 0 360s6.7-19.3 16-22.6V336zm96 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM400 224h85.9l-43-91.4c-1.3-2.8-4.1-4.6-7.2-4.6H400v96zm80 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faNfcTrash = {
  prefix: 'far',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", "M384 80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H378.2l3.4 48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5H400V96c0-8.8-7.2-16-16-16zM352 240c0 13.7 5.8 26.1 15 34.8l1 14.3V360c0 22.1-17.9 40-40 40H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V352H320V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40v52.2c-9.8 8.8-16 21.6-16 35.8zm97.7-39.2c2.7-5.4 8.2-8.8 14.3-8.8h96c6.1 0 11.6 3.4 14.3 8.8L585.9 224H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H576 448 400c-8.8 0-16-7.2-16-16s7.2-16 16-16h38.1l11.6-23.2zM413.9 482.3L400 288H624L610.1 482.3C608.9 499 595 512 578.2 512H445.8c-16.8 0-30.7-13-31.9-29.7z"]
};
var faHourglass = {
  prefix: 'far',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V67c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445v19H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V445c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM192 289.9l81.5 81.5C293 391 304 417.4 304 445v19H80V445c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67V48H304V67c0 27.6-11 54-30.5 73.5L192 222.1z"]
};
var faHourglassEmpty = faHourglass;
var faMountain = {
  prefix: 'far',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", "M464 424.1c0 4.4-3.5 7.9-7.9 7.9H55.9c-4.4 0-7.9-3.5-7.9-7.9c0-1.5 .4-2.9 1.2-4.2L149.6 260l39.5 50.8c4.6 5.9 11.7 9.3 19.2 9.3s14.5-3.6 19-9.6L268 256h92L462.8 419.9c.8 1.3 1.2 2.7 1.2 4.2zM329.8 208H256c-7.6 0-14.7 3.6-19.2 9.6l-29.1 38.9-30.9-39.8L256 90.3 329.8 208zM55.9 480H456.1c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z"]
};
var faFileXmark = {
  prefix: 'far',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm47 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faFileTimes = faFileXmark;
var faHouseHeart = {
  prefix: 'far',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32zm64-162.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faHomeHeart = faHouseHeart;
var faHouseChimneyBlank = {
  prefix: 'far',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v85.9L303.5 5.7zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32z"]
};
var faMeterBolt = {
  prefix: 'far',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M464 256c0 8.9-.6 17.6-1.6 26.2l49.3-39.4C504.8 107.5 393 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c73.7 0 140.1-31.1 186.8-81l7.5-15H432c-11.5 0-22.3-4.1-30.7-11.1C363.8 441.5 312.5 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208zM192 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm234.1 75.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H553.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faUserDoctor = {
  prefix: 'far',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm64 225c5.2-.7 10.6-1 16-1h96c5.4 0 10.8 .3 16 1v49c-27.6 7.1-48 32.2-48 62v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V464c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24c8.8 0 16-7.2 16-16V464c0-29.8-20.4-54.9-48-62V361.3c46.9 19 80 65 80 118.7v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-97.2-78.8-176-176-176H176C78.8 304 0 382.8 0 480v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-53.7 33.1-99.7 80-118.7v41c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V353zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUserMd = faUserDoctor;
var faSlashBack = {
  prefix: 'far',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", "M11.9 3.3C.4 10-3.4 24.7 3.3 36.1l272 464c6.7 11.4 21.4 15.3 32.8 8.6s15.3-21.4 8.6-32.8l-272-464C38 .4 23.3-3.4 11.9 3.3z"]
};
var faCircleInfo = {
  prefix: 'far',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faInfoCircle = faCircleInfo;
var faFishingRod = {
  prefix: 'far',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M280.4 48c-3.2 0-6.3 .5-9.3 1.4L206.6 69.2C136.1 90.9 88 156.1 88 229.8v42.9c22.7 3.8 40 23.6 40 47.3V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V320c0-23.8 17.3-43.5 40-47.3V229.8C40 135 101.8 51.2 192.5 23.4L256.9 3.5C264.5 1.2 272.4 0 280.4 0c44 0 79.6 35.7 79.6 79.6V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V79.6C312 62.2 297.8 48 280.4 48zM48 320V464H80V320H48zm208 24c0-71.6 55.6-127.8 89-148.1c4.3-2.6 9.6-2.6 14 0c33.5 20.3 89 76.6 89 148.1c0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3V496c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16v-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHammerCrash = {
  prefix: 'far',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M289.9 328.5l1.5 .7c15 7.5 31.5 8.6 46.4 4.2l-.3 1.8 54.1-23.5c9.6-4.2 20.9-1.6 27.7 6.3l38.6 44.6 15.4-56.9c2.7-10.1 11.7-17.3 22.2-17.7l58.9-2.3-34.9-47.5c-6.2-8.5-6.2-20 0-28.4l34.9-47.5L495.4 160c-10.5-.4-19.5-7.6-22.2-17.7L457.8 85.3l-20.3 23.6c-6-9.1-14.4-16.9-24.9-22.1L399 80l52-60.3c5.8-6.7 14.8-9.7 23.5-7.7s15.5 8.6 17.8 17.1L515 112.7l86.5 3.4c8.9 .3 16.8 5.6 20.7 13.6s3 17.5-2.3 24.6L568.6 224l51.3 69.7c5.3 7.2 6.1 16.6 2.3 24.6s-11.8 13.2-20.7 13.6L515 335.3l-22.6 83.5c-2.3 8.6-9.2 15.2-17.8 17.1s-17.7-1-23.5-7.7l-56.6-65.5-79.4 34.5c-8.1 3.5-17.6 2.3-24.5-3.3s-10.3-14.5-8.6-23.2l7.9-42.3zM81.9 64L53.5 120.8 312.8 250.5l49.7-99.4L188.2 64H81.9zM43.4 33.7C48.8 22.8 59.9 16 72 16H192c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3L186.4 241 69.5 474.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2L143.4 219.5 17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80z"]
};
var faMessageHeart = {
  prefix: 'far',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM144 173.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCloudMeatball = {
  prefix: 'far',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M184 49.2c-38.7 0-72 33.3-72 76.8c0 2.8 .1 5.6 .4 8.4c1.2 11.9-6.5 22.8-18.1 25.7C68.5 166.5 48 191.5 48 222.6c0 35.5 26.4 62.6 57.2 64.1c.3 0 .7 0 1 .1H108h63.3c-18.3 9.2-31.6 27-34.6 48H108l-4 0c-1.2 0-2.4-.1-3.6-.3C43.3 330.4 0 280.9 0 222.6C0 177.4 25.9 137.7 64.1 120C67.1 54.9 118.6 1.2 184 1.2c34.2 0 64.8 14.8 86.4 38.2c14.7-8.3 31.6-13 49.6-13c47.9 0 87.2 33.2 99.7 77.4C472.9 113.5 512 162 512 218.4c0 63.2-49.1 116.4-112 116.4H375.3c-3-21-16.3-38.8-34.6-48H400c34.3 0 64-29.5 64-68.4s-29.7-68.4-64-68.4h0l-.3 0c-12.4 0-22.8-9.4-23.9-21.7c-3-31.2-27.7-53.9-55.7-53.9c-14.4 0-27.6 5.8-37.7 15.6c-5.3 5.1-12.6 7.6-19.9 6.6s-13.7-5.2-17.5-11.6c-13-21.9-35.7-35.9-60.9-35.9zM288 320c0 1-.1 2.1-.1 3.1c.7-.8 1.3-1.6 2.1-2.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-.7 .7-1.5 1.4-2.3 2.1c1-.1 2.1-.2 3.1-.2c17.7 0 32 14.3 32 32s-14.3 32-32 32c-1 0-2.1-.1-3.1-.1c.8 .7 1.6 1.3 2.3 2.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0c-.7-.7-1.4-1.5-2.1-2.3c.1 1 .1 2.1 .1 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1 .1-2.1 .1-3.1c-.7 .8-1.3 1.6-2.1 2.3c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3c.7-.7 1.5-1.4 2.3-2.1c-1 .1-2.1 .1-3.1 .1c-17.7 0-32-14.3-32-32s14.3-32 32-32c1 0 2.1 .1 3.1 .1c-.8-.6-1.6-1.3-2.3-2.1c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c.7 .7 1.4 1.5 2.1 2.3c-.1-1-.1-2.1-.1-3.1c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm416 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCameraPolaroid = {
  prefix: 'far',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M512 432H64c-8.8 0-16-7.2-16-16V384H528v32c0 8.8-7.2 16-16 16zM68.4 336l32.9-49.3c7-10.5 10.7-22.9 10.7-35.5V96c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V251.2c0 12.6 3.7 25 10.7 35.5L507.6 336H68.4zM64 480H512c35.3 0 64-28.7 64-64V371.4c0-12.6-3.7-25-10.7-35.5L514.7 260c-1.8-2.6-2.7-5.7-2.7-8.9V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V251.2c0 3.2-.9 6.2-2.7 8.9L10.7 335.9C3.7 346.4 0 358.7 0 371.4V416c0 35.3 28.7 64 64 64zM408 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM288 288a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-32-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCamera = {
  prefix: 'far',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M199.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L137.4 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H374.6l-8.6-25.7C358.4 47.4 337 32 312.9 32H199.1zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5H312.9c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h90.7c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faCameraAlt = faCamera;
var faSquareVirus = {
  prefix: 'far',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 13.6c13.3 0 24 10.7 24 24c0 23.8 28.8 35.7 45.6 18.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.8 16.8-4.9 45.6 18.9 45.6c13.3 0 24 10.7 24 24s-10.7 24-24 24c-23.8 0-35.7 28.8-18.9 45.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-16.8-16.8-45.6-4.9-45.6 18.9c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-23.8-28.8-35.7-45.6-18.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.8-16.8 4.9-45.6-18.9-45.6c-13.3 0-24-10.7-24-24s10.7-24 24-24c23.8 0 35.7-28.8 18.9-45.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.8 16.8 45.6 4.9 45.6-18.9c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCartArrowUp = {
  prefix: 'far',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", "M296 184V81.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V184c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 24C0 10.7 10.7 0 24 0H69.5c26.9 0 50 19.1 55 45.5l37 194.5H459.2c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faMeteor = {
  prefix: 'far',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M474.8 0c-5.2 0-10.3 1.1-15 3.2L324 62.9l1.4-18.2c2.5-34.2-36.2-55.5-63.7-35.1L82.7 142.5C30.6 181.2 0 242.7 0 307.5C0 419.8 91 512 203.6 512c65.7 0 127.4-31.8 165.7-85.3L495.6 249.8c19.7-27.6-1.8-65.7-35.6-63.1l-10.7 .8L508.8 52.2c2.1-4.7 3.2-9.8 3.2-15C512 16.7 495.3 0 474.8 0zm-168 122.9l147-64.7L389.2 204.9c-3.4 7.7-2.5 16.7 2.4 23.5s13 10.7 21.4 10.1l33.5-2.6-116.4 163C301 439.7 253.8 464 203.6 464C117.8 464 48 393.6 48 307.5c0-49.7 23.6-96.9 63.4-126.5L276.2 58.6l-3 40.6c-.6 8.4 3.2 16.5 10.1 21.4s15.8 5.8 23.5 2.4zM200 424a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faCarOn = {
  prefix: 'far',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 208H326.2c10.1 0 19.2 6.4 22.6 15.9L365.9 272H146.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM89.4 287.9c-.2 .5-.3 .9-.5 1.4C64.2 306.7 48 335.5 48 368v32 16 32 40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H416v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448 416 400 368c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H185.8c-30.4 0-57.6 19.1-67.8 47.8L89.4 287.9zM416 368v32H96V368c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48zM160 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
var faSleigh = {
  prefix: 'far',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80h8V256c0 62.5 44.8 114.5 104 125.8V432H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H560c44.2 0 80-35.8 80-80V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 17.7-14.3 32-32 32H440V383.8C507 379.6 560 324 560 256V144h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H560 536 512 456c-22.1 0-40 17.9-40 40v45.7c0 23.3-18.9 42.3-42.3 42.3c-58.3 0-112.5-30-143.4-79.5l-18.9-30.2C182.5 67.9 133.7 38.1 80 32.8c-5.1-.5-10.2-.8-15.4-.8L64 32H63 32 24zM392 432H184V384H392v48zm40-96H392 184 160c-44.2 0-80-35.8-80-80V81.1c37.2 5 70.5 26.3 90.7 58.6L189.6 170c39.7 63.5 109.2 102 184.1 102c49.9 0 90.3-40.4 90.3-90.3V144h48V256c0 44.2-35.8 80-80 80z"]
};
var faArrowDown19 = {
  prefix: 'far',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M456 56c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16C363.8 53.4 357 67 361.2 79.6S379 99 391.6 94.8L408 89.3V128v48H384c-13.3 0-24 10.7-24 24s10.7 24 24 24h48 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H456V128 56zM143 473c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm281-89a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-17.9 46.2l-8.7 10.6c-8.4 10.3-6.9 25.4 3.4 33.8s25.4 6.9 33.8-3.4l56.8-69.4C504.7 385.5 512 365.1 512 344c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.5 30.1 77.9 70.1 86.2z"]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faBuoyMooring = {
  prefix: 'far',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", "M264 24c0-13.3 10.7-24 24-24s24 10.7 24 24V66.6c42.6 9.4 76.7 43.2 85.3 87.5l47.1 241.2c-.4 .3-.8 .6-1.2 .9c-13.3 9.2-28.9 15.9-43.8 18.8L383.9 336H192.1l-15.4 78.9c-14.9-2.9-30.5-9.6-43.8-18.8c-.4-.3-.8-.6-1.3-.9l47.1-241.2c8.6-44.3 42.8-78.1 85.3-87.5V24zm24 88c-30.3 0-56.4 21.5-62.2 51.3L201.4 288H374.6L350.2 163.3C344.4 133.5 318.3 112 288 112zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faSquare4 = {
  prefix: 'far',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm127.6 97.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H240v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H169.3l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"]
};
var faHandHoldingDroplet = {
  prefix: 'far',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H387.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H344 320 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faTricycleAdult = {
  prefix: 'far',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M288 88c0-13.3 10.7-24 24-24h38.9c18.7 0 36.2 9.4 46.6 24.9L512.4 261.3c9.9-3.4 20.5-5.3 31.6-5.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-24.6 9.3-47 24.5-64l-13.4-20.1-39.8 53.1c-14.7 19.5-37.7 31.1-62.1 31.1c-5 0-10-.5-14.9-1.4l-55.1-10.7c.5 4 .8 8.1 .8 12.2c0 53-43 96-96 96c-17.5 0-33.9-4.7-48-12.8c.6-.4 1.3-.8 1.9-1.1c-14.5 8.9-31.6 14-49.9 14c-53 0-96-43-96-96c0-24.4 9.1-46.6 24-63.5l-4.6-.9c-13-2.5-21.5-15.1-19-28.2s15.1-21.5 28.2-19l322.9 63c1.9 .4 3.8 .5 5.7 .5c9.3 0 18.1-4.4 23.7-11.9l50-66.6-73.3-110c-1.5-2.2-4-3.6-6.7-3.6H312c-13.3 0-24-10.7-24-24zM186.6 320.2c3.5 10 5.4 20.7 5.4 31.8c0 16.9-4.3 32.7-12 46.5c3.8 1 7.8 1.5 12 1.5c26.5 0 48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l-47.8-9.3zM48.7 97.1c12.6-4 26.1 2.9 30.2 15.5l15.3 47.9c2.7 8.3 9.7 14.6 18.3 16.2l84.1 16.4c13 2.5 21.5 15.1 19 28.2s-15.1 21.5-28.2 19l-84.1-16.4c-25.8-5-46.8-23.7-54.8-48.7L33.1 127.3c-4-12.6 2.9-26.1 15.5-30.2zM144 352a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm448 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faWaveform = {
  prefix: 'far',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H46.3l26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z"]
};
var faWater = {
  prefix: 'far',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M80 78.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7C41 104.8 62.8 93 80 78.1zm0 288c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm31.9-144c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faStarSharpHalfStroke = {
  prefix: 'far',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2H361.6L310.9 16.7zM288 103.2l0 0 33.1 104.1c3.2 10 12.4 16.7 22.9 16.7H450.1l-88.8 69.1c-7.9 6.2-11.2 16.6-8.1 26.2l32.5 102.3-82.9-64.5c-4.3-3.4-9.5-5.1-14.7-5.1V103.2z"]
};
var faStarSharpHalfAlt = faStarSharpHalfStroke;
var faNfcSignal = {
  prefix: 'far',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", "M384 80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H230c-3.4 15.5-5.3 31.6-5.8 48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V227c-16.6 2.5-32.6 6.6-48 12V96c0-8.8-7.2-16-16-16zm-16 72V252.8c-17.2 8.8-33.3 19.4-48 31.6V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40zM239 400H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V352H261.7c-9.1 15.1-16.7 31.1-22.7 48zM488 256c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24c-48.6 0-88 39.4-88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136c13.3 0 24 10.7 24 24z"]
};
var faPlaneProp = {
  prefix: 'far',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M267.3 176h49.5L299.1 48H284.9L267.3 176zM344.7 27.6l5 36.4c.7-.1 1.5-.1 2.2-.1h16V48c0-8.8 7.2-16 16-16s16 7.2 16 16V80c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128h-9.4l6.6 48h93.1c21 0 48.1 6.2 70.4 17.4C549.4 203.8 576 223.9 576 256c0 32.5-26.4 52.6-47.4 63c-22.5 11.1-49.5 17-70.3 17H365.2l-6.6 48H368V368c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H352c-.8 0-1.5 0-2.2-.1l-5 36.4C342.5 500.2 329 512 313 512H271c-16 0-29.5-11.8-31.7-27.6l-5-36.4H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h1.4l-7.2-52.4-75.7-9.1-5.8 34.3C134.3 372.4 120.8 384 105 384H71c-15.9 0-29.4-11.7-31.7-27.4L28.7 287.8C12.6 286.2 0 272.5 0 256s12.6-30.2 28.7-31.8l10.7-68.7C41.6 139.7 55.1 128 71 128h34c15.8 0 29.3 11.6 31.6 27.2l5.8 34.3 75.7-9.1 7.2-52.4H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h10.3l5-36.4C241.5 11.8 255 0 271 0H313c16 0 29.5 11.8 31.7 27.6zM267.3 336l17.7 128h14.2l17.7-128H267.3zm191.1-48c13.4 0 33.1-4.1 49-12c17.4-8.6 20.7-16.5 20.7-20c0-2.9-3.2-10.8-20.8-19.7c-15.9-8-35.7-12.3-48.9-12.3H257.4L125.5 239.8c-12.7 1.5-24.4-7.2-26.5-19.8l-7.5-44H84.7L72.3 256l12.4 80h6.8L99 292c2.2-12.6 13.8-21.3 26.5-19.8L257.4 288H458.3z"]
};
var faCalendarCheck = {
  prefix: 'far',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faClockDesk = {
  prefix: 'far',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM224 0C347.7 0 448 100.3 448 224V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V224C0 100.3 100.3 0 224 0zm0 96c13.3 0 24 10.7 24 24v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V120c0-13.3 10.7-24 24-24z"]
};
var faCalendarClock = {
  prefix: 'far',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H432 400 288 48V448c0 8.8 7.2 16 16 16H284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]
};
var faCalendarTime = faCalendarClock;
var faBraille = {
  prefix: 'far',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM88 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faPrescriptionBottleMedical = {
  prefix: 'far',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M48 48H336V80H48V48zM32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160H304V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V160H32zm133.3 80v37.3H128c-8.8 0-16 7.2-16 16v21.3c0 8.8 7.2 16 16 16h37.3V368c0 8.8 7.2 16 16 16h21.3c8.8 0 16-7.2 16-16V330.7H256c8.8 0 16-7.2 16-16V293.3c0-8.8-7.2-16-16-16l-37.3 0V240c0-8.8-7.2-16-16-16H181.3c-8.8 0-16 7.2-16 16z"]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faPlateUtensils = {
  prefix: 'far',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M24 16c13.3 0 24 10.7 24 24V168c0 4.4 3.6 8 8 8h8V40c0-13.3 10.7-24 24-24s24 10.7 24 24V176h8c4.4 0 8-3.6 8-8V40c0-13.3 10.7-24 24-24s24 10.7 24 24V168c0 30.9-25.1 56-56 56h-8V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V224H56c-30.9 0-56-25.1-56-56V40C0 26.7 10.7 16 24 16zM560 160V272h32V216 85.2c-16.6 15.3-32 39.1-32 74.8zm32 160H544c-17.7 0-32-14.3-32-32V160C512 59.2 596.2 23.2 613.1 17c2-.7 4-1 6.1-1c11.5 0 20.9 9.3 20.9 20.9V216v56 48V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V320zM336 480c-81.5 0-152.8-43.5-192-108.6V252.7c5.7-1.6 11.1-3.8 16.3-6.4c-.2 3.2-.3 6.5-.3 9.7c0 97.2 78.8 176 176 176c70.8 0 131.8-41.8 159.7-102c10.6 12.2 25.8 20.3 42.8 21.8C502.6 427.6 425.4 480 336 480zM208 72.2C244.3 46.8 288.4 32 336 32c60.3 0 115 23.8 155.3 62.5c-6.5 17.5-10.6 37.5-11.2 60.3C448.2 109.6 395.6 80 336 80c-50.4 0-95.9 21.2-128 55.2V72.2zM416 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z"]
};
var faFamilyPants = {
  prefix: 'far',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3C68.8 296 76.2 304 85.6 304H88h60.6c-3 10.1-4.6 20.9-4.6 32v16H112V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 11.4 2.4 22.2 6.7 32H150.4 128 105.6zM336 176c0-3.9-.3-7.8-.8-11.5c8.3-2.9 17.2-4.5 26.4-4.5h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H368V336c0-11.1-1.6-21.9-4.6-32H424h2.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C436.9 220.8 423 208 406.4 208H384 361.6 329.3c4.3-9.8 6.7-20.6 6.7-32zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 208c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8 7.2 16 16 16h16 16c8.8 0 16-7.2 16-16V336zm48 16c0 24-13.2 44.9-32.7 55.8c.5 2.7 .7 5.4 .7 8.2v64c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V416c0-2.8 .2-5.5 .7-8.2C189.2 396.9 176 376 176 352V336c0-44.2 35.8-80 80-80s80 35.8 80 80v16z"]
};
var faHoseReel = {
  prefix: 'far',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", "M320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c45.6 0 87.7-14.6 122-39.5c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5C428 494 376.1 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256v96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.3l-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L514.3 400H512c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V256c0-114.9-93.1-208-208-208zM208 256a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM320 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHouseWindow = {
  prefix: 'far',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32zM256 288V224h64v64H256zm-48-72v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V216c0-22.1-17.9-40-40-40H248c-22.1 0-40 17.9-40 40z"]
};
var faLandmark = {
  prefix: 'far',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192H477.9c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM256 51.4L423.8 144H88.2L256 51.4zM112 224H64V384H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V224H400V384H336V224H288V384H224V224H176V384H112V224zM0 488c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"]
};
var faTruck = {
  prefix: 'far',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", "M352 48c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H320 243.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H352zm32 368c0 53 43 96 96 96s96-43 96-96h40c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V245.3c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3C487.8 101.9 473.6 96 458.7 96H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96h64 32 24 8zM557.7 239.6c.1 .1 .3 .3 .4 .4H416V144h42.7c2.1 0 4.2 .8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCrosshairs = {
  prefix: 'far',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M256 0c13.3 0 24 10.7 24 24V41.3C380.1 52.4 459.6 131.9 470.7 232H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H470.7C459.6 380.1 380.1 459.6 280 470.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V470.7C131.9 459.6 52.4 380.1 41.3 280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H41.3C52.4 131.9 131.9 52.4 232 41.3V24c0-13.3 10.7-24 24-24zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3V392c0-13.3 10.7-24 24-24s24 10.7 24 24v30.3c73.6-10.5 131.8-68.7 142.3-142.3H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h30.3C411.8 158.4 353.6 100.2 280 89.7V120c0 13.3-10.7 24-24 24s-24-10.7-24-24V89.7C158.4 100.2 100.2 158.4 89.7 232H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H89.7zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCloudRainbow = {
  prefix: 'far',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M291.5 195.2C344.7 107 441.5 48 552 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C420.9 0 306.5 71.7 245.9 178.1c10.8 6 20.8 13.4 29.6 21.9c5.2-1.9 10.5-3.5 16-4.8zM394.6 216c38.1-44.1 94.5-72 157.4-72c13.3 0 24-10.7 24-24s-10.7-24-24-24c-82.4 0-155.7 38.9-202.5 99.4c16.5 3.9 31.8 11 45.2 20.6zm42.9 53.3c9.8 2.8 19.2 6.7 28 11.6C486.1 255.9 517.2 240 552 240c13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.1 0-94.8 23-124.1 59.1c3.7 5.8 6.9 11.8 9.7 18.2zM112 312c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 462.4 48 436.2 48 404c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C26.4 322.1 0 359.9 0 404c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 247 366.9 216 320 216c-18 0-34.9 4.6-49.7 12.6C248.5 206.1 217.9 192 184 192z"]
};
var faPersonCane = {
  prefix: 'far',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M176 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 209.5L76.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L93.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h35c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L256 214.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H176V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1H176V304h32V176.1zM352 376v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-30.9 25.1-56 56-56s56 25.1 56 56V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-4.4-3.6-8-8-8s-8 3.6-8 8z"]
};
var faAlien = {
  prefix: 'far',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224C0 359.3 148.8 471.7 194.7 503.2zM224 48c97.2 0 176 78.8 176 176c0 50.4-28.2 101.3-68.2 146.9c-39.2 44.7-84.2 78.1-105.6 92.7l0 0 0 0-.1 0c0 0-.1 0-.1 0s-.1 0-.1 0l-.1 0c-.3 .1-.9 .2-1.8 .2s-1.4-.1-1.8-.2c-.1 0-.2-.1-.2-.1l-.1 0-.1 0 0 0 0 0c-21.4-14.6-66.4-48-105.6-92.7C76.2 325.3 48 274.4 48 224c0-97.2 78.8-176 176-176zm16 258.3c0 7.6 6.1 13.7 13.7 13.7h32c45.4 0 82.3-36.8 82.3-82.3c0-7.6-6.1-13.7-13.7-13.7h-32c-45.4 0-82.3 36.8-82.3 82.3zM125.7 224h-32c-7.6 0-13.7 6.1-13.7 13.7c0 45.4 36.8 82.3 82.3 82.3h32c7.6 0 13.7-6.1 13.7-13.7c0-45.4-36.8-82.3-82.3-82.3z"]
};
var faTent = {
  prefix: 'far',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", "M274.4 4.2c8.2-5.7 19-5.7 27.3 0L521.5 155.9c13.5 9.3 22.2 24 23.9 40.2l26.7 254c3.5 33.1-22.4 61.9-55.7 61.9H440 264 59.5C26.3 512 .4 483.2 3.9 450.1l26.7-254c1.7-16.3 10.4-31 23.9-40.2L274.4 4.2zM516.5 464c4.7 0 8.5-4.1 8-8.8l-26.7-254c-.2-2.3-1.5-4.4-3.4-5.7L312 69.7V279.3L413.6 464H516.5zM264 69.7L81.7 195.4c-1.9 1.3-3.2 3.4-3.4 5.7l-26.7 254c-.5 4.7 3.2 8.8 8 8.8H264l0-136 0-136 0-122.3z"]
};
var faLaptopBinary = {
  prefix: 'far',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M128 80H512c8.8 0 16 7.2 16 16V320h48V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V320h48V96c0-8.8 7.2-16 16-16zM50.7 400H589.3c-6.6 18.6-24.4 32-45.3 32H96c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96H544c53 0 96-43 96-96c0-17.7-14.3-32-32-32H32zM200 128c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H200zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V168zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H304zm80 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H424c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16v16h32V288c0-8.8-7.2-16-16-16H192zm240 0H416c-8.8 0-16 7.2-16 16s7.2 16 16 16v16h32V288c0-8.8-7.2-16-16-16zm-64 40c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40v8h32v-8c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8h32v-8z"]
};
var faVestPatches = {
  prefix: 'far',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M178.5 81.5l28.8 95-25.1 82.8-64-211.2c-.3 0-.6-.1-.9-.1H104c-4.4 0-8 3.6-8 8v72 58.7c0 13-3.5 25.9-10.3 37L51.4 280.9c-2.2 3.7-3.4 8-3.4 12.3V456c0 4.4 3.6 8 8 8H176.4c1.6 17.6 8.4 33.8 18.8 46.9c-3.6 .7-7.4 1.1-11.2 1.1H56c-30.9 0-56-25.1-56-56V293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3V128 56C48 25.1 73.1 0 104 0h13.3 6.8c10.1 0 19.5 3.8 26.7 10.2c4.6 2.8 8.6 6 12 9C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8c3.4-3.1 7.5-6.2 12-9C304.4 3.8 313.8 0 323.9 0h6.8H344c30.9 0 56 25.1 56 56v72 58.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37V456c0 30.9-25.1 56-56 56H264c-30.9 0-56-25.1-56-56V295.1c0-7.1 1-14.1 3.1-20.9L269.5 81.5c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5zM329.8 48.1L257 288.2c-.7 2.3-1 4.6-1 7V456c0 4.4 3.6 8 8 8H392c4.4 0 8-3.6 8-8V293.3c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37V128 56c0-3.9-2.7-7.1-6.4-7.8c-.5-.1-1.1-.2-1.6-.2H330.7c-.3 0-.6 0-.9 .1zM288 288v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H304c-8.8 0-16-7.2-16-16V288zM84.7 260.7c6.2-6.2 16.4-6.2 22.6 0L120 273.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 296l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 318.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 296 84.7 283.3c-6.2-6.2-6.2-16.4 0-22.6zM112 360a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faPeopleDressSimple = {
  prefix: 'far',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM96.9 219.6L63.6 336H192.4L159.1 219.6c-2-6.9-8.2-11.6-15.4-11.6H112.3c-7.1 0-13.4 4.7-15.4 11.6zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H112V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM352.9 219.6L319.6 336H448.4L415.1 219.6c-2-6.9-8.2-11.6-15.4-11.6H368.3c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H368V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]
};
var faCheckDouble = {
  prefix: 'far',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z"]
};
var faArrowDownAZ = {
  prefix: 'far',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm305-89c-13.3 0-24 10.7-24 24s10.7 24 24 24h74.6L334.1 440.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 480 352 480H480c13.3 0 24-10.7 24-24s-10.7-24-24-24H405.4l92.5-104.1c6.3-7.1 7.8-17.2 4-25.8S489.4 288 480 288H352zM416 32c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L370.8 200H456c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160C433.4 37.1 425.1 32 416 32zM394.8 152L416 109.7 437.2 152H394.8z"]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faBowlingBallPin = {
  prefix: 'far',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", "M464 48c-17.7 0-32 14.3-32 32v4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1h33.6c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1V80c0-17.7-14.3-32-32-32zM438.3 230.2l-1 2.7c-8.5-27.4-21.8-52.7-38.8-74.9c-.4-2.5-1-5-1.6-7.4l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7V80c0-44.2 35.8-80 80-80s80 35.8 80 80v4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2v1c0 12.5 2.2 24.8 6.6 36.5L563 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L536 493.2c-5.2 11.4-16.6 18.8-29.1 18.8H421.2c-12.6 0-23.9-7.3-29.1-18.8l-10.6-23.3c12.6-13.1 23.7-27.7 33-43.4l17 37.5h65.1l17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2H444.8c-1.6 7.5-3.7 14.9-6.4 22.2zM168 196a28 28 0 1 1 56 0 28 28 0 1 1 -56 0zm28 60a28 28 0 1 1 0 56 28 28 0 1 1 0-56zM96 244a28 28 0 1 1 56 0 28 28 0 1 1 -56 0zm272 60A160 160 0 1 0 48 304a160 160 0 1 0 320 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304z"]
};
var faBellSchoolSlash = {
  prefix: 'far',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6L38.8 5.1zM156.5 97.3C185.6 66.9 226.6 48 272 48c88.4 0 160 71.6 160 160c0 31.6-9.1 61-24.9 85.8L356.3 254c7.5-13.7 11.7-29.3 11.7-46c0-53-43-96-96-96c-25 0-47.7 9.5-64.8 25.1L156.5 97.3zm161 126.2l-71.3-55.9c7.5-4.8 16.4-7.6 25.9-7.6c26.5 0 48 21.5 48 48c0 5.4-.9 10.6-2.6 15.5zM331 356.8C312.7 364 292.8 368 272 368c-88.4 0-160-71.6-160-160c0-7.6 .5-15.2 1.6-22.5l-42-33.1C66.6 170.1 64 188.7 64 208c0 59 24.6 112.2 64 150.1V448c0 35.3 28.7 64 64 64H336h16H480c13.1 0 25.3-3.5 35.9-9.6L467.1 464H414c1.3-5.1 2-10.5 2-16V423.8l-85-67zM336 464H192c-8.8 0-16-7.2-16-16V392.6c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4V448c0 8.8-7.2 16-16 16H336z"]
};
var faPlusLarge = {
  prefix: 'far',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M488 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0 0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24H232l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208 208 0z"]
};
var faMoneyBillWheat = {
  prefix: 'far',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M176 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80zM56 16C42.7 16 32 26.7 32 40s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zM24 88C10.7 88 0 98.7 0 112s10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm8 96c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24zM272 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80zm80 144c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80zM352 128c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80zM48 359.5c28.9-3.6 51.9-26.6 55.5-55.5h305c3.6 29 26.6 51.9 55.5 55.5v49c-29 3.6-51.9 26.6-55.5 55.5h-305c-3.6-29-26.6-51.9-55.5-55.5v-49zM48 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faCameraViewfinder = {
  prefix: 'far',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0zM376 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM173.8 120.2c6.3-14.7 20.8-24.2 36.8-24.2h90.9c16 0 30.5 9.5 36.8 24.2l3.3 7.8H352c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h10.5l3.3-7.8zm42 23.8l-7.5 17.5c-3.8 8.8-12.5 14.5-22.1 14.5H160c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H325.7c-9.6 0-18.3-5.7-22.1-14.5L296.2 144H215.8zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
var faScreenshot = faCameraViewfinder;
var faMessageMusic = {
  prefix: 'far',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V128 96z"]
};
var faCommentAltMusic = faMessageMusic;
var faCarBuilding = {
  prefix: 'far',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", "M288 48H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H192v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v64.5c-17.5 1.7-33.9 7.7-48 17.1V64c0-8.8-7.2-16-16-16zM256 219.1l-13.1 36.6c-.9 .2-1.9 .3-2.9 .3H208c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v11.1zM96 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V112zM208 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208zm0 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V304zm265.8-96c-10.1 0-19.2 6.4-22.6 15.9L322.1 272H541.9l-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9H361.8zm-96.4 79.9L294 207.8c10.2-28.7 37.4-47.8 67.8-47.8H502.2c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2 .5 .3 .9 .5 1.4C623.8 306.7 640 335.5 640 368v32 16 32 40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H272v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448 416 400 368c0-32.5 16.2-61.3 40.9-78.7c.1-.5 .3-.9 .5-1.4zM544 320H320c-26.5 0-48 21.5-48 48v32H592V368c0-26.5-21.5-48-48-48zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBorderBottomRight = {
  prefix: 'far',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 352c0 13.3-10.7 24-24 24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l352 0c39.8 0 72-32.2 72-72l0-352zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faBorderStyleAlt = faBorderBottomRight;
var faOctagon = {
  prefix: 'far',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M174.5 55.1c4.5-4.5 10.6-7 17-7h129c6.4 0 12.5 2.5 17 7L456.9 174.5c4.5 4.5 7 10.6 7 17v129c0 6.4-2.5 12.5-7 17L337.5 456.9c-4.5 4.5-10.6 7-17 7h-129c-6.4 0-12.5-2.5-17-7L55.1 337.5 21.2 371.4l33.9-33.9c-4.5-4.5-7-10.6-7-17v-129c0-6.4 2.5-12.5 7-17L174.5 55.1zM.1 320.5c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1h-129c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5v129z"]
};
var faCommentArrowUpRight = {
  prefix: 'far',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM200 152c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V288c0 13.3 10.7 24 24 24s24-10.7 24-24V176c0-13.3-10.7-24-24-24H200z"]
};
var faOctagonDivide = {
  prefix: 'far',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCookie = {
  prefix: 'far',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M240.5 64.6c-12-1.7-24.3 .5-35.1 6.2l-74 39.5C120.7 116 112 125 106.6 136L69.9 211.6c-5.4 11-7.1 23.5-5 35.6L79.4 330c2.1 12.1 8 23.2 16.8 31.7l60.3 58.4c8.8 8.5 20 14 32 15.7l83 11.7c12 1.7 24.3-.5 35.1-6.2l74-39.5C391.3 396 400 387 405.4 376l36.7-75.5c5.4-11 7.1-23.5 5-35.6L432.6 182c-2.1-12.1-8-23.2-16.8-31.7L355.5 91.9c-8.8-8.5-20-14-32-15.7l-83-11.7zM182.8 28.4c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1 .7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5c-19.7 10.5-42.3 14.5-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7L62.8 396.2C46.8 380.6 36 360.3 32.2 338.3L17.6 255.5c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM288 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faArrowRotateLeft = {
  prefix: 'far',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M40 224c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24v80.1l20-23.5C125 63.4 186.9 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-50.4 0-97-16.7-134.4-44.8c-10.6-8-12.7-23-4.8-33.6s23-12.7 33.6-4.8C179.8 418.9 216.3 432 256 432c97.2 0 176-78.8 176-176s-78.8-176-176-176c-54.3 0-102.9 24.6-135.2 63.4l-.1 .2 0 0L93.1 176H184c13.3 0 24 10.7 24 24s-10.7 24-24 24H40z"]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faTvMusic = {
  prefix: 'far',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", "M576 48c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H576zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 488c0 13.3 10.7 24 24 24H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM416 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V128 96z"]
};
var faHardDrive = {
  prefix: 'far',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", "M64 80c-8.8 0-16 7.2-16 16V258c5.1-1.3 10.5-2 16-2H448c5.5 0 10.9 .7 16 2V96c0-8.8-7.2-16-16-16H64zM48 320v96c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHdd = faHardDrive;
var faReel = {
  prefix: 'far',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H64V88c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24V48h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H384 344 104 64 24zm80 72V48H344V72H104zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H64h40H344h40 40c13.3 0 24-10.7 24-24s-10.7-24-24-24H384V424c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24v40H24zm320 0H104V440H344v24zM80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faFaceGrinSquintTears = {
  prefix: 'far',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faDumbbell = {
  prefix: 'far',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M128 88c0-30.9 25.1-56 56-56h16c30.9 0 56 25.1 56 56V232H384V88c0-30.9 25.1-56 56-56h16c30.9 0 56 25.1 56 56v16h24c30.9 0 56 25.1 56 56v72h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H592v72c0 30.9-25.1 56-56 56H512v16c0 30.9-25.1 56-56 56H440c-30.9 0-56-25.1-56-56V280H256V424c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56V408H104c-30.9 0-56-25.1-56-56V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48V160c0-30.9 25.1-56 56-56h24V88zm48 16v24V384v24 16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8v16zm-48 48H104c-4.4 0-8 3.6-8 8V352c0 4.4 3.6 8 8 8h24V152zM464 384V128 104 88c0-4.4-3.6-8-8-8H440c-4.4 0-8 3.6-8 8V424c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V408 384zm72-24c4.4 0 8-3.6 8-8V160c0-4.4-3.6-8-8-8H512V360h24z"]
};
var faRectangleList = {
  prefix: 'far',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faListAlt = faRectangleList;
var faTarpDroplet = {
  prefix: 'far',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c7 19.8 20.3 36.6 37.5 48H64c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l352 0V384c0-17.7 14.3-32 32-32h80V192c0-8.8-7.2-16-16-16l-170.9 0c17.2-11.4 30.5-28.2 37.5-48H512c35.3 0 64 28.7 64 64V364.1c0 12.7-5.1 24.9-14.1 33.9l-99.9 99.9c-9 9-21.2 14.1-33.9 14.1L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm48 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faAlarmExclamation = {
  prefix: 'far',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM432 288A176 176 0 1 0 80 288a176 176 0 1 0 352 0zM396.5 462.5C358.1 493.4 309.2 512 256 512s-102.1-18.6-140.5-49.5L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l42.5-42.5C50.6 390.1 32 341.2 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 53.2-18.6 102.1-49.5 140.5L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-42.5-42.5zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24-168V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHouseMedicalCircleCheck = {
  prefix: 'far',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32H348.5c12.3 18.8 28 35.1 46.3 48H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm32 112a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faTrafficCone = {
  prefix: 'far',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M217.8 15c3.7-9 12.5-15 22.2-15h32c9.8 0 18.6 5.9 22.2 15L476.9 464H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H35.1L217.8 15zM386 368H126L86.9 464H425.1l-39-96zm-19.5-48L320.9 208H191.1L145.5 320h221zM210.6 160h90.8L256 48.4 210.6 160z"]
};
var faGrate = {
  prefix: 'far',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M56 32C25.1 32 0 57.1 0 88V256 424c0 30.9 25.1 56 56 56h72 96 96 72c30.9 0 56-25.1 56-56V256 88c0-30.9-25.1-56-56-56H320 224 128 56zm48 48V232H48V88c0-4.4 3.6-8 8-8h48zM48 280h56V432H56c-4.4 0-8-3.6-8-8V280zM152 432V280h48V432H152zm96 0V280h48V432H248zm96 0V280h56V424c0 4.4-3.6 8-8 8H344zm56-200H344V80h48c4.4 0 8 3.6 8 8V232zM296 80V232H248V80h48zm-96 0V232H152V80h48z"]
};
var faArrowDownRight = {
  prefix: 'far',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", "M328 416c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24s-24 10.7-24 24V334.1L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l231 231H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H328z"]
};
var faPersonSkiingNordic = {
  prefix: 'far',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8c1.2 1.5 2.6 2.7 4.1 3.8L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H311.5c.4 0 .7 0 1.1 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.2-176.7c10.4-2.6 18.2-12 18.2-23.3c0-13.3-10.7-24-24-24H407.6c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zM429.4 288L402.3 464H344.6L371 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C361.3 272 383 288 407.6 288h21.7zM99.7 464l55.8-265.1 40.6-34.8c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L294.4 464H190.7l36.8-109.8-8-4.5c-13.1-7.4-23.6-17.6-31.2-29.6L140.1 464H99.7zM316.1 175.8l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L289 169l27.1 6.8z"]
};
var faSkiingNordic = faPersonSkiingNordic;
var faCalendarPlus = {
  prefix: 'far',
  iconName: 'calendar-plus',
  icon: [512, 512, [], "f271", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H96c-35.3 0-64 28.7-64 64v16 48V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H376V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM80 192H432V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V192zm176 40c-13.3 0-24 10.7-24 24v48H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V352h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V256c0-13.3-10.7-24-24-24z"]
};
var faPersonFromPortal = {
  prefix: 'far',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", "M72.2 436C58.7 404.6 48 348.4 48 256s10.7-148.6 24.2-180C84.6 47.3 94.6 47.9 95.9 48l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180c0 45.7-2.6 82.6-6.9 112H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h7s0 0 0 0h49.7s0 0 0 0h28.2c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L199.4 368H185.6c4.2-31.3 6.4-68.4 6.4-112c0-21.4-.5-41.2-1.6-59.6l37.7-32.4c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L321.1 480.8c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8L403 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C393.3 272 415 288 439.6 288H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H439.6c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L184.7 138C170.3 38 136 0 96 0C43 0 0 66.6 0 256S43 512 96 512c28 0 53.2-18.6 70.7-64H113.9c-9.5 16.5-16.7 16.1-17.8 16l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-19.9 79.8l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8z"]
};
var faPortalExit = faPersonFromPortal;
var faPlaneArrival = {
  prefix: 'far',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", "M552.2 333.2c4.3 4 2.8 11.1-2.8 12.9c-26.5 8.8-54.9 9.7-81.9 2.6L141.9 264c-1.2-.3-2.3-.9-3.2-1.7l-87.7-75c-1.8-1.5-2.8-3.7-2.8-6.1l-.2-86.6 18.2 4.6c2.5 .6 4.5 2.4 5.5 4.8l25.9 64.8c2.8 7 8.8 12.3 16.1 14.3l113.9 30.4c8.4 2.2 17.4-.2 23.4-6.5s8.3-15.3 5.8-23.6L216.3 48 242 48 349.1 238.4c3.2 5.6 8.5 9.8 14.7 11.4l113 30.1c16.3 4.3 31.3 12.6 43.7 24l31.6 29.2zm12.3 58.5c40.3-13.3 51.5-65 20.3-93.8l-31.6-29.2c-18.1-16.7-40-28.8-63.8-35.1L386 206.1 281.5 20.4C274.4 7.8 261.1 0 246.6 0H205.5c-26.8 0-46 25.8-38.3 51.5l31.4 104.6-60.8-16.2L116.4 86.3c-6.7-16.7-21-29.2-38.4-33.5L49.7 45.7C24.5 39.4 0 58.5 0 84.6l.2 96.8 0 0c0 16.3 7.2 31.8 19.6 42.4l87.7 75c6.4 5.5 14.1 9.5 22.3 11.6l325.5 84.7c35.9 9.4 73.8 8.1 109.1-3.5zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm168-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCowbellCirclePlus = {
  prefix: 'far',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M176 48h96V96H176V48zm-48-8V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H262.6c-4.3-15.3-6.6-31.4-6.6-48H48l64-224H336l18.8 65.8c14.2-7 29.6-12.1 45.6-15l-18.3-64C376.3 110.2 357.4 96 336 96H320V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zm32 408c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6H160zm272 64a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCowbellMore = faCowbellCirclePlus;
var faCircleLeft = {
  prefix: 'far',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H256V150.3c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"]
};
var faArrowAltCircleLeft = faCircleLeft;
var faDistributeSpacingVertical = {
  prefix: 'far',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M0 56C0 69.3 10.7 80 24 80H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56zM368 208v96H144V208H368zM144 160c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H144zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faSignalBarsFair = {
  prefix: 'far',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", "M208 304c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16zm-64 16c0-35.3 28.7-64 64-64s64 28.7 64 64V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V320zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16A64 64 0 1 1 0 448a64 64 0 1 1 128 0z"]
};
var faSignalAlt2 = faSignalBarsFair;
var faSportsball = {
  prefix: 'far',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M447 99c3.8 33.4 4.4 70.2-.1 107c-25.6-8.1-49.2-20.8-69.7-37.2L447 99zm-9 154.5c-7.2 28-17.9 55.2-33 79.8c-4.7 7.7-9.9 15.1-15.5 22.3L289.9 256l53.1-53.1c27.5 22.9 59.7 40.3 94.9 50.6zM356.1 390.1c-19.4 16.1-42.4 29.6-69.7 39.8c-10.2 3.8-21 7.1-32.4 9.9c-10.2-35.9-27.8-68.7-51.1-96.7L256 289.9 356.1 390.1zM206.3 447.8c-31.5 3.2-67 3-106.9-1.3l69.3-69.3c16.6 20.8 29.5 44.6 37.5 70.6zM22.9 455.2l0 0c.5 2.7 1 5.3 1.6 7.9c1.6 7.5 5.7 14 11.4 18.6c4.2 3.3 9.2 5.6 14.6 6.5c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5c-1.5-7.1-5.2-13.3-10.5-17.8c-.7-.6-1.5-1.3-2.3-1.8c-3.9-2.8-8.4-4.7-13.3-5.5c-2.1-.3-4.2-.7-6.2-1l0 0C395.7 13.3 343 11.7 296.6 16.9c0 0 0 0 0 0c-16.6 1.9-32.4 4.6-47.5 8.1c0 0 0 0 0 0c-14.1 3.3-27.5 7.4-40.3 12.1c-34.1 12.7-63 30-87.1 50.7l0 0C109.4 98.5 98.3 110 88.3 122.2l0 0c-8.2 10-15.6 20.5-22.2 31.4c-18.4 29.9-31 62.5-39.2 95.7c0 0 0 0 0 0c-3.9 15.7-6.8 31.6-8.8 47.4c0 0 0 0 0 0c-7.4 56.9-3.6 113 4.9 158.4zM65 413c-3.8-33.4-4.4-70.2 .1-107c25.6 8.1 49.2 20.8 69.7 37.2L65 413zm9-154.5c7.2-28 17.9-55.2 33-79.8c4.7-7.7 9.9-15.1 15.5-22.3L222.1 256l-53.1 53.1c-27.5-22.9-59.7-40.3-94.9-50.6zm81.9-136.6c19.4-16.1 42.4-29.6 69.7-39.8c10.2-3.8 21-7.1 32.4-9.9c10.2 35.9 27.8 68.7 51.1 96.7L256 222.1 155.9 121.9zM305.7 64.2c31.5-3.2 67-3 106.9 1.3l-69.3 69.3c-16.6-20.8-29.5-44.6-37.5-70.6z"]
};
var faGameConsoleHandheldCrank = {
  prefix: 'far',
  iconName: 'game-console-handheld-crank',
  icon: [640, 512, [], "e5b9", "M96 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H96zM32 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V272h32V200 168c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H560v72c0 13.3-10.7 24-24 24H480v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V96zm128 32H352c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm16 160c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V304c0-8.8 7.2-16 16-16zm120 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTrainSubway = {
  prefix: 'far',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M200 48l0 160H48V96c0-26.5 21.5-48 48-48H200zm48 0H352c26.5 0 48 21.5 48 48V208H248l0-160zM48 352V256H400v96c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96V352c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57H318.1l57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352V96c0-53-43-96-96-96H96zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSubway = faTrainSubway;
var faChartGantt = {
  prefix: 'far',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm88 72H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFaceSmileUpsideDown = {
  prefix: 'far',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM177.6 193.9C192.8 177.5 218.8 160 256 160s63.2 17.5 78.4 33.9c9 9.7 24.2 10.4 33.9 1.4s10.4-24.2 1.4-33.9c-22-23.8-60-49.4-113.6-49.4s-91.7 25.5-113.6 49.4c-9 9.7-8.4 24.9 1.4 33.9s24.9 8.4 33.9-1.4zM208.4 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faBallPile = {
  prefix: 'far',
  iconName: 'ball-pile',
  icon: [640, 512, [], "f77e", "M368 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 0c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C405.1 365.1 416 389.3 416 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C213.1 365.1 224 389.3 224 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C138.9 306.9 128 282.7 128 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C234.9 146.9 224 122.7 224 96c0-53 43-96 96-96s96 43 96 96zm-96 96c-9.9 0-19.5-1.5-28.6-4.3C309.1 205.1 320 229.3 320 256c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zm0 64c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C330.9 306.9 320 282.7 320 256zM176 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM368 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM560 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faBadgeDollar = {
  prefix: 'far',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20v17.4c-8.8 1.8-17.7 4.8-25.7 9.6c-15 8.9-27.7 24.4-27.6 46.9c.1 21.5 12.6 35.1 26.3 43.4c11.9 7.2 27 11.7 39.1 15.4l1.9 .6c13.9 4.2 24.4 7.6 31.7 12.2c6.1 3.8 7.5 6.8 7.6 11c.1 6.5-2.5 10.4-7.6 13.6c-6 3.7-15.2 5.9-25.1 5.6c-12.7-.4-24.6-4.4-39.7-9.6l0 0 0 0 0 0 0 0c-2.6-.9-5.2-1.8-8-2.7c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2 .7 4.5 1.5 6.8 2.3c9.7 3.3 20.9 7.2 32.8 9.6v18c0 11 9 20 20 20s20-9 20-20V354.4c9.3-1.7 18.6-4.9 26.8-10.1c15.3-9.5 26.8-25.7 26.5-48.1c-.3-21.6-12.4-35.6-26.3-44.3c-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9c-6.2-3.7-7-6.3-7-9.3c0-5.1 2.1-8.8 7.9-12.3c6.5-3.8 16-6 25-5.8c10.9 .2 22.9 2.6 35.2 5.8c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4V140.4z"]
};
var faMoneyBillsSimple = {
  prefix: 'far',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", "M576 80c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H576zM160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faMoneyBillsAlt = faMoneyBillsSimple;
var faListTimeline = {
  prefix: 'far',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M219.9 112H400V80H219.9l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm187.9 16H400V400H219.9l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM203.9 256l16 16H464V240H219.9l-16 16zm-13.3 54.6l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4z"]
};
var faIndianRupeeSign = {
  prefix: 'far',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 56C0 42.7 10.7 32 24 32h80H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H211.3c17.7 19.8 30.1 44.6 34.7 72h50c13.3 0 24 10.7 24 24s-10.7 24-24 24H246c-11.4 68.1-70.7 120-142 120H98.9L261.9 436.5c10.8 7.7 13.3 22.7 5.6 33.5s-22.7 13.3-33.5 5.6l-224-160C1.6 309.5-2 298.6 1.1 288.7S13.6 272 24 272h80c44.7 0 82.3-30.6 93-72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H197c-10.7-41.4-48.2-72-93-72H24C10.7 80 0 69.3 0 56z"]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faCropSimple = {
  prefix: 'far',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24V80H24C10.7 80 0 90.7 0 104s10.7 24 24 24H80V376c0 30.9 25.1 56 56 56H352V384H136c-4.4 0-8-3.6-8-8V24zM384 488c0 13.3 10.7 24 24 24s24-10.7 24-24V432h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H432l0-248c0-30.9-25.1-56-56-56L160 80v48l216 0c4.4 0 8 3.6 8 8l0 352z"]
};
var faCropAlt = faCropSimple;
var faMoneyBill1 = {
  prefix: 'far',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"]
};
var faMoneyBillAlt = faMoneyBill1;
var faLeftLong = {
  prefix: 'far',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", "M6.5 272.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 33.7 248 0c30.9 0 56 25.1 56 56l0 48c0 30.9-25.1 56-56 56l-248 0 0 33.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6L6.5 272.4zm153.5 93l0-53.5c0-13.3 10.7-24 24-24l272 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-272 0c-6.4 0-12.5-2.5-17-7s-7-10.6-7-17l0-53.5L57 256 160 365.5z"]
};
var faLongArrowAltLeft = faLeftLong;
var faKeyboardDown = {
  prefix: 'far',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M64 48c-8.8 0-16 7.2-16 16V240c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V240c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM159 359c9.4-9.4 24.6-9.4 33.9 0l95 95 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L305 505c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L159 393c-9.4-9.4-9.4-24.6 0-33.9zm1-167c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V192zM120 88h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V104zm96-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V104zm96-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16z"]
};
var faCircleUpRight = {
  prefix: 'far',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 313.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L280 296l-66.3 66.3C210 366 205.1 368 200 368s-10-2-13.7-5.7l-36.7-36.7C146 322 144 317.1 144 312s2-10 5.7-13.7L216 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H336c8.8 0 16 7.2 16 16V313.4z"]
};
var faCloudBoltMoon = {
  prefix: 'far',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", "M361.4 79.9c31.2 18.7 52.5 52.2 54.3 90.8c33.3 15.8 57.6 47.5 63 85.3c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9zM128.1 160c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7v1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9v30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.3 0-.6 0-1 0H293.7l-8 16.1H304c20.3 0 38.4 12.8 45.2 31.9h16.1c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4v-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7V176c0-2.9-.5-5.7-1.5-8.3C374.9 126.9 339.1 96 296.1 96c-14.7 0-28.5 3.6-40.6 9.9C238.1 80.6 209.1 64 176.1 64c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 169 .1 208.5 .1 256c0 43.4 28.8 80 68.3 91.9c3.1-6.6 7.6-12.6 13.6-17.4l33.3-26.6H98.9c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm154 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"]
};
var faThunderstormMoon = faCloudBoltMoon;
var faDna = {
  prefix: 'far',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", "M416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 2.7-.1 5.4-.2 8H80.2c-.2-2.6-.2-5.3-.2-8C80 10.7 69.3 0 56 0S32 10.7 32 24c0 55.6 24.5 101.9 58.1 141.9c27.2 32.4 61.5 62 95.8 90.1c-34.3 28.1-68.6 57.7-95.8 90.1C56.5 386.1 32 432.4 32 488c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.7 .1-5.4 .2-8H367.8c.2 2.6 .2 5.3 .2 8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-55.6-24.5-101.9-58.1-141.9c-20.6-24.5-45.2-47.3-70.8-69.2c-8.7 7.1-17.3 14.1-25.7 20.9l0 0-2.2 1.8c-3.4 2.7-6.7 5.5-10.1 8.1c11.2 9.4 22.1 18.8 32.3 28.3h-115c22-20.4 46.7-40.4 72.2-61c.3-.2 .5-.4 .8-.6l.7-.6c41.3-33.4 84.7-68.6 117.7-107.9C391.5 125.9 416 79.6 416 24zM121.1 384H326.9c12.4 15.7 22.4 31.6 29.4 48H91.7c7-16.4 17-32.3 29.4-48zM91.7 80H356.3c-7 16.4-17 32.3-29.4 48H121.1c-12.4-15.7-22.4-31.6-29.4-48zm189.8 96c-17.8 16.4-37.2 32.6-57.5 49.1c-20.3-16.5-39.7-32.7-57.5-49.1h115z"]
};
var faVirusSlash = {
  prefix: 'far',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zM220 147.1c39 4.3 78.6-14.2 100-47.6c23.3 36.4 68.4 55.1 110.6 45.8c-9.3 42.2 9.4 87.3 45.8 110.6c-21.2 13.6-36.4 34.5-43.6 58L220 147.1zM402 412.7l-44.6-35.1c-14.9 8.2-27.9 20.1-37.4 34.8c-23.3-36.4-68.4-55.1-110.6-45.8c9.3-42.2-9.4-87.3-45.8-110.6c7.1-4.5 13.6-9.9 19.2-16l-38.1-30c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"]
};
var faBracketRoundRight = {
  prefix: 'far',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M35.4 43.7c-6.8 11.4-3 26.1 8.3 32.9C76.7 96.3 144 160.7 144 256s-67.3 159.7-100.3 179.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C110 451.8 192 374.1 192 256S110 60.2 68.3 35.4c-11.4-6.8-26.1-3-32.9 8.3z"]
};
var faCircleSterling = {
  prefix: 'far',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm261.5-96c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H231.7l.1 9.7c.1 18.6-3.1 37-9.6 54.3H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"]
};
var faCircle5 = {
  prefix: 'far',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128c-11.6 0-21.5 8.3-23.6 19.7l-16 88c-1.2 6.5 .4 13.3 4.4 18.6s10 8.8 16.6 9.5l86.9 9.8c15.8 1.8 27.8 15.2 27.8 31.1c0 17.3-14 31.3-31.3 31.3h-36c-11.5 0-22.3-5.7-28.8-15.3l-4.1-6.1c-7.4-11-22.3-13.9-33.3-6.5s-13.9 22.3-6.5 33.3l4.1 6.1c15.4 22.9 41.1 36.6 68.6 36.6h36c43.8 0 79.3-35.5 79.3-79.3c0-40.3-30.3-74.3-70.4-78.8L220.2 219l7.8-43h84c13.3 0 24-10.7 24-24s-10.7-24-24-24H208z"]
};
var faMinus = {
  prefix: 'far',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"]
};
var faSubtract = faMinus;
var faFireFlame = {
  prefix: 'far',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9c-5.7 15.6-8.6 32.1-8.6 48.7C48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2C132.3 118.8 86.3 191.2 57.3 271L12.2 254.6C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zM189.3 163.8c1.7-2.4 4.4-3.8 7.4-3.8c5 0 9.1 4.1 9.1 9.1v10.8c0 7.8 3.1 15.3 8.5 20.8l44.1 45.1c19 19.4 29.6 45.5 29.6 72.6V320c0 53-43 96-96 96s-96-43-96-96V308.6c0-18.4 6.6-36.3 18.6-50.3l6-7c1.8-2.1 4.4-3.3 7.1-3.3c5.2 0 9.4 4.2 9.4 9.4v40.9c0 20.8 16.9 37.7 37.7 37.7s37.7-16.9 37.7-37.7v-1.5c0-10.2-3.9-19.9-11-27.3l-11-11.4c-12.3-12.8-19.2-29.8-19.2-47.5c0-14.4 4.5-28.4 13-40.1l4.9-6.7z"]
};
var faFlame = faFireFlame;
var faRightToLine = {
  prefix: 'far',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", "M192 146.2L302 256 192 365.8l0-53.8c0-13.3-10.7-24-24-24L48 288l0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM352 256c0-11.5-4.6-22.5-12.7-30.6L223.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L339.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM400 88l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faArrowAltToRight = faRightToLine;
var faGif = {
  prefix: 'far',
  iconName: 'gif',
  icon: [576, 512, [], "e190", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM296 160c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm56 24v80 64c0 13.3 10.7 24 24 24s24-10.7 24-24V288h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H400V208h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H376c-13.3 0-24 10.7-24 24zM128 256c0-26.5 21.5-48 48-48c8 0 15.4 1.9 22 5.3c11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8c7-4.4 11.2-12.1 11.2-20.3V264c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v13.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48z"]
};
var faChess = {
  prefix: 'far',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M128 0c8.8 0 16 7.2 16 16V32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H144V96h45.1c23.7 0 42.9 19.2 42.9 42.9c0 4.7-.8 9.4-2.3 13.8l-19.6 57.5c8.2 3.8 13.9 12.1 13.9 21.8c0 11.6-8.2 21.3-19.2 23.5l2.1 96.5h-48l-2.1-96H99.2l-2.1 96h-48l2.1-96.5C40.2 253.3 32 243.6 32 232c0-9.6 5.7-17.9 13.9-21.8L26.3 152.8c-1.5-4.5-2.3-9.1-2.3-13.8C24 115.2 43.2 96 66.9 96H112V64H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zm54 144H74l21.8 64h64.4L182 144zM52.7 464H203.3l-16.6-32H69.2L52.7 464zm143.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h137zM280 160H488c13.3 0 24 10.7 24 24v72c0 5-1.6 9.9-4.5 13.9L472 319.7V352H424V312c0-5 1.6-9.9 4.5-13.9L464 248.3V208H432v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V208H368v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V208H304v40.3l35.5 49.7c2.9 4.1 4.5 8.9 4.5 13.9v40H296V319.7l-35.5-49.7c-2.9-4.1-4.5-8.9-4.5-13.9V184c0-13.3 10.7-24 24-24zM475.6 396.3L507 452.9c3.3 5.9 5 12.6 5 19.3c0 22-17.8 39.8-39.8 39.8H295.8c-22 0-39.8-17.8-39.8-39.8c0-6.8 1.7-13.4 5-19.3l31.4-56.6c4.2-7.6 12.3-12.3 21-12.3H454.6c8.7 0 16.7 4.7 21 12.3zM327.5 432l-17.8 32H458.2l-17.8-32H327.5z"]
};
var faTrashSlash = {
  prefix: 'far',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L491.3 359.8 508.4 128H520c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H463.9 450.2L413.5 24.9C403.1 9.4 385.6 0 366.9 0H273.1c-18.7 0-36.2 9.4-46.6 24.9L189.8 80H176.1 134.4L38.8 5.1zM195.6 128H460.3L445.8 324.1 195.6 128zm77.5-80h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM155.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H420.6c26.1 0 48.8-15.7 58.7-38.4l-42.1-33.1-.6 8.7c-.6 8.4-7.6 14.8-16 14.8H219.4c-8.4 0-15.3-6.5-16-14.8L188.3 244.4l-51.1-40.3 18.4 248.6z"]
};
var faArrowLeftLong = {
  prefix: 'far',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", "M7 239c-9.4 9.4-9.4 24.6 0 33.9L143 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 232l95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239z"]
};
var faLongArrowLeft = faArrowLeftLong;
var faPlugCircleCheck = {
  prefix: 'far',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faFontCase = {
  prefix: 'far',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", "M198.4 47.5C194.9 38.2 186 32 176 32s-18.9 6.2-22.4 15.5l-152 400c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L83.1 368H268.9l36.7 96.5c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31l-152-400zM250.7 320H101.4L176 123.6 250.7 320zM616 160c-13.3 0-24 10.7-24 24v8.8c-22.1-20.4-51.6-32.8-84-32.8c-68.5 0-124 55.5-124 124v72c0 68.5 55.5 124 124 124c32.4 0 61.9-12.4 84-32.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zM432 284c0-42 34-76 76-76s76 34 76 76v72c0 42-34 76-76 76s-76-34-76-76V284z"]
};
var faStreetView = {
  prefix: 'far',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M256 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 256 0a72 72 0 1 0 0 144zM192 280l0 0V240c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v40l0 0c-19.4 4.9-33.8 21.3-36 41.2l-6.2 55.6c-.5 4.1-3.9 7.1-8 7.1H242.1c-4.1 0-7.5-3.1-8-7.1L228 321.3c-2.2-19.9-16.6-36.3-36-41.2zm-5.6 102.2c3.2 28.4 27.1 49.8 55.7 49.8h27.8c28.5 0 52.5-21.5 55.7-49.8l6.2-55.6c20.8-5.2 36.3-24.1 36.3-46.6V240c0-44.2-35.8-80-80-80H224c-44.2 0-80 35.8-80 80v40c0 22.5 15.4 41.3 36.3 46.6l6.2 55.6zm-54.1 12c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"]
};
var faArrowDownLeft = {
  prefix: 'far',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", "M56 416c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24V334.1L311 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-231 231H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H56z"]
};
var faFrancSign = {
  prefix: 'far',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M72 32C58.7 32 48 42.7 48 56V216 320H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48v88c0 13.3 10.7 24 24 24s24-10.7 24-24V368H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H96V240H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H96V80H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
};
var faFlaskRoundPoison = {
  prefix: 'far',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", "M176 48h96V157.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 352c0 43.1-17 82.1-44.7 110.9c-.1 .1-.3 .2-.8 .4c-.9 .4-2.5 .7-4.8 .7H114.2c-2.2 0-3.8-.4-4.8-.7c-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352c0-59 31.9-110.6 79.7-138.4c18.8-11 32.3-31.6 32.3-55.9V48zM320 157.7V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H304 144 120C106.7 0 96 10.7 96 24s10.7 24 24 24h8V157.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4zM286.8 378.4c15.6-13 25.2-30.8 25.2-50.4c0-39.8-39.4-72-88-72s-88 32.2-88 72c0 19.6 9.6 37.4 25.2 50.4c4.1 3.4 6.8 8.3 6.8 13.6v8c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16v-8c0-5.3 2.7-10.2 6.8-13.6zM192 312a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFlaskPoison = faFlaskRoundPoison;
var faVolumeOff = {
  prefix: 'far',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M272 102.3L159.9 201.9c-4.4 3.9-10.1 6.1-15.9 6.1H56c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h88c5.9 0 11.6 2.2 15.9 6.1L272 409.7V102.3zm-1.6-62.8c5.5-4.8 12.5-7.5 19.8-7.5C306.7 32 320 45.3 320 61.8V450.2c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5L134.9 352H56c-30.9 0-56-25.1-56-56V216c0-30.9 25.1-56 56-56h78.9L270.4 39.5z"]
};
var faBookCircleArrowRight = {
  prefix: 'far',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", "M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H394.8c-18.3-12.9-34.1-29.2-46.3-48H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H322.9c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H392c4.4 0 8 3.6 8 8V220.5c14.6-9.5 30.8-17 48-21.8V56c0-30.9-25.1-56-56-56H88zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faChartUser = {
  prefix: 'far',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M576 48H224c-8.8 0-16 7.2-16 16v41.3c-14.8-6-31-9.3-48-9.3V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-8.3-18-19.8-34.2-33.7-48H576c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zM412.7 139.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h88c8.8 0 16 7.2 16 16v88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM160 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 400c-39.8 0-73.2 27.2-82.6 64H269.3c-9.5-36.8-42.9-64-82.6-64H133.3zm0-48h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"]
};
var faUserChart = faChartUser;
var faHandsAslInterpreting = {
  prefix: 'far',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M186.3 55.8l-51.8 86.3c-5.8 9.6-17.4 14-28.1 10.5S89 138.6 90 127.5l5.9-61.9c.8-8.8-5.6-16.6-14.4-17.4s-16.6 5.6-17.4 14.4l-16 168-.1 .8v.8 32c0 61.9 50.1 112 112 112h48c31.6 0 60.5-14.5 76.2-41.6c4.4-7.7 1.8-17.4-5.8-21.9c-2.5-1.4-5.1-2.1-7.7-2.2l-.3 0-.3 0c-5.5 .1-10.7 3-13.6 8C247.4 334.1 230 344 208 344c-30.9 0-56-25.1-56-56s25.1-56 56-56c11.6 0 21.7 1.8 30.1 5.8c8.9 4.2 14.8 10.3 18.4 16.6c2.9 5 8.1 7.9 13.6 8l.3 0 .3 0c2.6 0 5.2-.7 7.7-2.2c7.6-4.4 10.3-14.2 5.8-21.9c-6-10.3-13.5-18-21.9-23.6c-7.1-4.8-11.1-12.9-10.5-21.5s5.6-16.1 13.2-19.9l46.2-23.1c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-87.4 43.7c-9.5 4.8-21.1 2.7-28.3-5.2s-8.5-19.5-3-28.7l35.6-59.4c4.5-7.6 2.1-17.4-5.5-22s-17.4-2.1-22 5.5zm92.8 349.5C257.5 417.8 232.7 424 208 424H160C71.6 424 0 352.4 0 264V232v-1.9c0-.8 0-1.5 .1-2.3l.2-1.9 16-168C19.6 22.8 50.9-3.1 86.1 .3c24.7 2.4 44.9 18.5 53.4 40.1l5.6-9.3c18.2-30.3 57.5-40.1 87.8-22c26.9 16.2 37.7 49 27 77.4l15.4-7.7c31.4-15.7 69.5-3.2 85.5 28C382.5 94.2 407.3 88 432 88h48c88.4 0 160 71.6 160 160v32 1.9c0 .8 0 1.5-.1 2.3l-.2 1.9-16 168c-3.4 35.2-34.6 61-69.8 57.6c-24.7-2.4-44.9-18.5-53.4-40.1l-5.6 9.3c-18.2 30.3-57.5 40.1-87.8 22c-26.9-16.2-37.7-49-27-77.4l-15.4 7.7c-31.4 15.7-69.5 3.2-85.5-28zm174.6 51l51.8-86.3c5.8-9.6 17.4-14 28.1-10.5s17.5 13.9 16.4 25.1l-5.9 61.9c-.8 8.8 5.6 16.6 14.4 17.4s16.6-5.6 17.4-14.4l16-168 .1-.8V280 248c0-61.9-50.1-112-112-112H432c-31.6 0-60.5 14.5-76.2 41.6c-4.4 7.6-1.8 17.4 5.8 21.9c2.5 1.4 5.1 2.1 7.7 2.2l.3 0 .3 0c5.5-.1 10.7-3 13.6-8C392.6 177.9 410 168 432 168c30.9 0 56 25.1 56 56s-25.1 56-56 56c-11.6 0-21.7-1.8-30.1-5.8c-8.9-4.2-14.8-10.3-18.4-16.6c-2.9-5-8.1-7.9-13.6-8l-.3 0-.3 0c-2.6 0-5.2 .7-7.7 2.2c-7.7 4.4-10.3 14.2-5.8 21.9c6 10.3 13.5 18 21.9 23.6c7.1 4.8 11.1 12.9 10.6 21.5s-5.6 16.1-13.2 19.9l-46.2 23.1c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l87.4-43.7c9.5-4.8 21.1-2.7 28.3 5.2s8.5 19.5 3 28.7l-35.6 59.4c-4.5 7.6-2.1 17.4 5.5 22s17.4 2.1 22-5.5zM224 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm208-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faPresentationScreen = {
  prefix: 'far',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm8 80V296c0 30.9 25.1 56 56 56H264v46.1l-73 73c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73-73V352H488c30.9 0 56-25.1 56-56V80H496V296c0 4.4-3.6 8-8 8H288 88c-4.4 0-8-3.6-8-8V80H32z"]
};
var faPresentation = faPresentationScreen;
var faCircleBolt = {
  prefix: 'far',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM330.1 115.6c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faFaceSmileHalo = {
  prefix: 'far',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zm-64 0c0 17.7-86 32-192 32S64 97.7 64 80s86-32 192-32s192 14.3 192 32zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-14 5.8-29.6 11.1-46.4 15.6c17.8 29.1 28 63.3 28 99.9c0 106-86 192-192 192S64 378 64 272c0-36.6 10.2-70.8 28-99.9c-16.9-4.6-32.4-9.8-46.4-15.6zm172 128.3l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 244.4 120 262.1 120 280c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm-73.9 47.9c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm233.9-47.9l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 244.4 280 262.1 280 280c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]
};
var faCartCircleArrowDown = {
  prefix: 'far',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H520.6L489.1 192.1c2.3-.1 4.6-.1 6.9-.1c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 393.4V304c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHousePersonReturn = {
  prefix: 'far',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm66.2 266.6l-29.9-89.8c-7.7 1.2-15 3.6-21.7 7.1c.1 .3 .2 .7 .3 1l32.4 103.8 16.3-13.3c2.6-2.1 3.6-5.6 2.5-8.7zm-59 54.6l-28.5-91.3-10.5 36.7c-1.9 6.5-5.4 12.5-10.2 17.3L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l27.6-27.6 10.9-38.1c14.4-50.5 60.6-85.4 113.2-85.4h4.9c16.1 0 32.1 2.6 47.4 7.7c39.9 13.3 72.4 42.8 89.5 81.3l9.5 21.3c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-9.5-21.3c-10.9-24.4-30.9-43.5-55.6-53.3l22.8 68.3c7.4 22.1 .3 46.5-17.8 61.2L421.5 397.4l-22.1 96c-3 12.9-15.9 21-28.8 18s-21-15.9-18-28.8L375.4 384c2-8.7 6.8-16.4 13.8-22.1l50.1-40.7zm101.1 21l24.1 60.4L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-69.7-69.7c-3.8-3.8-6.8-8.4-8.9-13.4l-19.2-48 39-31.7zm-146.7-224l2.9 2.4c-13.5 8.9-25.6 20-35.7 32.8L240 55 112 159.3V360c0 4.4 3.6 8 8 8H346.8c-1.1 2.9-1.9 5.8-2.6 8.8L335.1 416H120c-30.9 0-56-25.1-56-56V198.4L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0L371.1 99.8c6.3 7.4 14 13.7 22.6 18.4zM160 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V208z"]
};
var faHousePersonArrive = faHousePersonReturn;
var faHouseReturn = faHousePersonReturn;
var faMessageXmark = {
  prefix: 'far',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM175 127c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faCommentAltTimes = faMessageXmark;
var faMessageTimes = faMessageXmark;
var faFileCertificate = {
  prefix: 'far',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", "M448 464H224v32c0 5.5-1 10.9-2.7 16H448c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H192c-35.3 0-64 28.7-64 64v71.1l.1-.1c1.5-.7 4-2 6.6-3c13.6-5.5 28.3-5.4 41.3-.5V64c0-8.8 7.2-16 16-16H352v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16zM109.2 161.6c-10-4.1-21.5-1-28.1 7.5L70.6 182.6c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.9-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2L9.1 241.1c-8.5 6.6-11.6 18.1-7.5 28.1L8 285c.8 1.9 .8 4.1 0 6.1L1.6 306.8c-4.1 10-1 21.5 7.5 28.1l13.5 10.5c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.9 19.1 20.5 20.6L64 390.2V496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V390.2l15.5-2.1c10.7-1.5 19.1-9.9 20.5-20.6l2.3-16.9c.3-2.1 1.4-4 3-5.2l13.5-10.5c8.5-6.6 11.6-18.1 7.5-28.1L248 291c-.8-1.9-.8-4.1 0-6.1l6.5-15.8c4.1-10 1-21.5-7.5-28.1l-13.5-10.5c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.9-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.5-13.5c-6.6-8.5-18.1-11.6-28.1-7.5L131 168c-1.9 .8-4.1 .8-6.1 0l-15.8-6.5zM64 288a64 64 0 1 1 128 0A64 64 0 1 1 64 288z"]
};
var faFileAward = faFileCertificate;
var faUserDoctorHairLong = {
  prefix: 'far',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zm80 224c-5.4 0-10.8 .3-16 1v49.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-41c-46.9 19-80 65-80 118.7v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-97.2 78.8-176 176-176h96c97.2 0 176 78.8 176 176v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-53.7-33.1-99.7-80-118.7V402c27.6 7.1 48 32.2 48 62v32c0 8.8-7.2 16-16 16H328c-8.8 0-16-7.2-16-16s7.2-16 16-16h8V464c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V464c0-29.8 20.4-54.9 48-62V353c-5.2-.7-10.6-1-16-1H176zm-8 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCameraSecurity = {
  prefix: 'far',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M384 48c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h40.1L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3H360c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM287.5 416l29.5 48H130.9l29.5-48h127zM336 208a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM224 144a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCameraHome = faCameraSecurity;
var faGear = {
  prefix: 'far',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
};
var faCog = faGear;
var faDropletSlash = {
  prefix: 'far',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 464c37.9 0 72.4-14.6 98.1-38.6l38 30C421.4 490.3 373.2 512 320 512c-106 0-192-86-192-192c0-27.7 12-62.9 29.8-99.6l38.7 30.5c-1.2 2.7-2.4 5.4-3.6 8c-11.9 27.6-17 48.2-17 61.1c0 79.5 64.5 144 144 144zm185.2-93.3l125.6 98.4c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L205.8 136c34.9-54.7 72-103 88.9-124.3C300.6 4.2 309.5 0 319.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C381.8 57.7 512 228.8 512 320c0 17.5-2.4 34.6-6.8 50.7zm-42.3-33.1c.7-5.8 1.1-11.6 1.1-17.6c0-13-5.1-33.5-17-61.1c-11.5-26.6-27.6-55.8-45.5-84.7c-29-46.8-61-90.2-81.5-117c-19.3 25.1-48.7 65-76.3 108.5L462.9 337.5zM224 312c0-11.9 8.7-21.8 20.1-23.7l27.9 21.9c0 .6 .1 1.2 .1 1.7c0 30.9 25.1 56 56 56c13.3 0 24 10.7 24 24s-10.7 24-24 24c-57.4 0-104-46.6-104-104z"]
};
var faTintSlash = faDropletSlash;
var faBookHeart = {
  prefix: 'far',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zm80-185.4c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faMosque = {
  prefix: 'far',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", "M400 0c7.6 0 14.7 3.6 19.2 9.6c18 24 40.1 42.1 66.5 59.5c15.7 10.3 31.3 19.5 48.2 29.3c13.1 7.6 26.9 15.7 42.2 25.2c31 19.2 48 53.2 48 88.3c0 25.6-8.9 49.2-23.8 67.7C623.8 291.4 640 315.8 640 344v96c0 39.8-32.2 72-72 72H448 352 240h-8H72c-39.8 0-72-32.2-72-72V176 140.7C0 96.3 20.5 54.3 55.6 27l25.7-20c8.7-6.7 20.8-6.7 29.5 0l25.7 20c26.9 20.9 45.2 50.4 52.3 83.1c-24.1 21.6-38.9 51-43.3 81.9H144 48V440c0 13.3 10.7 24 24 24h92.1c-2.7-7.5-4.1-15.6-4.1-24V344c0-28.2 16.2-52.6 39.8-64.4C184.9 261 176 237.5 176 211.8c0-35.1 17-69.1 48-88.3c15.2-9.4 29.1-17.5 42.2-25.2l0 0c16.9-9.9 32.5-19 48.2-29.3c26.4-17.4 48.5-35.5 66.4-59.5C385.3 3.6 392.4 0 400 0zM232 464h8 16V408c0-13.3 10.7-24 24-24s24 10.7 24 24v56h48V414c0-19 8.4-37 23-49.2L400 344l25 20.8C439.6 377 448 395 448 414v50h48V408c0-13.3 10.7-24 24-24s24 10.7 24 24v56h24c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24H515.8 400 284.2 232c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24zM48 144h96v-3.3c0-29.6-13.7-57.6-37.1-75.8L96 56.4 85.1 64.9C61.7 83.1 48 111.1 48 140.7V144zm528 67.8c0-19.9-9.6-37.7-25.3-47.5c-12.6-7.8-25.9-15.6-39-23.3c-18.3-10.8-36.5-21.4-52.4-31.9C438.2 95.3 418.1 80 400 61c-18.1 18.9-38.2 34.2-59.3 48.1c-16 10.5-34.1 21.1-52.4 31.9c-13.1 7.7-26.4 15.5-39 23.3C233.6 174.1 224 192 224 211.8c0 33.2 26.9 60.2 60.2 60.2H400 515.8c33.2 0 60.2-26.9 60.2-60.2z"]
};
var faDuck = {
  prefix: 'far',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M69.1 324.1c11.2 4.8 23.7 5.2 35.2 1l146.5-52.7c14.6-5.3 25.8-17.3 30-32.2s.9-31-8.8-43.1c-10-12.4-15.9-28-15.9-45.1c0-39.8 32.2-72 72-72s72 32.2 72 72c0 20.1-8.2 38.2-21.5 51.4l7.5 7.6-7.5-7.6c-7.1 7-13.6 15.5-18.4 25.5c-8.7 18.2-5.1 39.9 9 54.4c14.3 14.5 22.9 34.3 22.9 56V352c0 44.2-35.8 80-80 80H196c-69.8 0-128.7-49.4-144.1-115.2l17.2 7.4zM446.8 135C438.5 76.8 388.5 32 328 32c-66.3 0-120 53.7-120 120c0 11.2 1.5 22 4.4 32.2c4.4 15.9 12.1 30.5 22.1 43l-47 16.9L88 280 37 258.1c-3.3-1.4-6.9-2.1-10.5-2.1C11.9 256 0 268.1 0 282.7C0 391 87.8 480 196 480H312c70.7 0 128-57.3 128-128V339.2c0-34.7-13.9-66.4-36.6-89.6c2.1-4.4 5.1-8.5 8.7-12c1.8-1.8 3.6-3.7 5.3-5.6h3.5c50.3 0 91.1-40.8 91.1-91.1c0-6.8-6-12.1-12.8-11.3L463.9 134c-5.7 .7-11.4 1-17.1 1zM344 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM299.2 289.1c-13.1-1.8-25.2 7.5-27 20.6c-2.7 20-18 38.3-40.8 44c-18.6 4.6-36.8-.5-49.3-11.6c-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9c24.2 21.5 58.7 30.8 92.8 22.3c41.6-10.4 71.4-44.4 76.7-84.2c1.8-13.1-7.5-25.2-20.6-27z"]
};
var faMosquito = {
  prefix: 'far',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", "M177.5 506.9c-10.3-8.2-12.2-23.5-4.3-34.1l43.1-57.3 0-55.6c0-5.8 2-11.4 5.7-15.8l62.3-74.6L154.6 387.8C97.6 447.6 0 405.2 0 320.6c0-47.9 34-88.3 79.3-94.2l153-23.9-40.8-40.9c-7.8-7.8-9.4-20.1-3.9-29.8l23.9-41.7L173.3 39.2c-8-10.6-6.1-25.9 4.3-34.1s25.2-6.3 33.2 4.4l48 63.9c5.9 7.9 6.6 18.6 1.7 27.2L237.8 140 288 190.3l0-38.1c0-14.9 10.2-27.4 24-31l0-57.2c0-4.4 3.6-8 8-8s8 3.6 8 8l0 57.2c13.8 3.6 24 16.1 24 31l0 38.2L402.2 140l-22.6-39.5c-4.9-8.6-4.2-19.3 1.7-27.2l48-63.9c8-10.6 22.8-12.6 33.2-4.4s12.2 23.5 4.3 34.1L428.5 90.1l23.9 41.7c5.5 9.7 3.9 22-3.9 29.8l-40.8 40.9 153 23.9c45.3 5.9 79.4 46.3 79.4 94.2c0 84.6-97.6 127-154.6 67.1L355.7 269.4 418 344c3.7 4.4 5.7 10 5.7 15.8l0 62.7 42.1 49c8.6 10.1 7.7 25.5-2.1 34.3s-24.7 7.9-33.4-2.1l-48-55.9c-3.8-4.4-5.9-10.2-5.9-16.1l0-62.9L352 339.7l0 68.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-68.1-24.3 29.2 0 54.9c0 5.4-1.7 10.6-4.9 14.9l-48 63.9c-8 10.6-22.8 12.6-33.2 4.4zM119.9 354.6c.8-.8 1.6-1.6 2.4-2.3L233.4 250.9l-146.6 23c-.4 .1-.8 .1-1.2 .2C65.8 276.6 48 295.1 48 320.6c0 22.3 12.2 37.3 27 43.7c14.5 6.3 31.3 4.5 44.9-9.7zM406.6 250.9L517.7 352.3c.8 .7 1.6 1.5 2.4 2.3c13.6 14.2 30.4 16 44.9 9.7c14.8-6.4 27-21.4 27-43.7c0-25.5-17.8-44-37.6-46.6c-.4-.1-.8-.1-1.2-.2L406.6 250.9z"]
};
var faStarOfDavid = {
  prefix: 'far',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M408.9 301.9L378.2 352h61.5l-30.8-50.1zM380.8 256l-58.9-96H190.1l-58.9 96 58.9 96H321.9l58.9-96zm56.3 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-58.9-96l30.7 50.1L439.7 160H378.2zm-85.8-48L256 52.7 219.6 112h72.8zM133.8 160H72.3l30.8 50.1L133.8 160zM103.1 301.9L72.3 352h61.5l-30.8-50.1zM219.6 400L256 459.3 292.4 400H219.6z"]
};
var faFlagSwallowtail = {
  prefix: 'far',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v8V80 304v48V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H48V24zm0 56H376l-62.4 83.2c-12.8 17.1-12.8 40.5 0 57.6L376 304H48V80z"]
};
var faFlagAlt = faFlagSwallowtail;
var faPersonMilitaryRifle = {
  prefix: 'far',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M160 39c0 13.8 11.2 25 25 25H336c8.8 0 16-7.2 16-16V17.4C352 8 344 .7 334.7 1.4L182.9 14.1C170 15.2 160 26 160 39zm277.9 1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9L327.2 231.6c-10.1-3.8-20.8-6.2-31.7-7.1c-2.5-.3-5-.4-7.6-.4h-2.7H226.7 224c-2.6 0-5.1 .1-7.5 .4c-35.7 3.1-68.5 22-88.9 52L36.2 410.5c-7.5 11-4.6 25.9 6.3 33.4s25.9 4.6 33.3-6.3L160 314.1V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V314.1l84.2 123.5c7.5 11 22.4 13.8 33.4 6.3s13.8-22.4 6.3-33.3l-85.2-125 38.6-66.9c8.8-15.3 3.6-34.9-11.7-43.7l-1.6-.9 55.5-96.1c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8-13.9-8zM304 403.6L228.8 272h56.5c1.7 0 3.5 .1 5.2 .2c7.7 1.2 13.5 7.8 13.5 15.8V403.6zm-96-71.3L283.2 464H208V332.4zM176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H283.7c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H177.6c-1 5.2-1.6 10.5-1.6 16z"]
};
var faCarGarage = {
  prefix: 'far',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M331.4 2.9c-7.1-3.8-15.7-3.8-22.8 0l-296 160c-11.7 6.3-16 20.9-9.7 32.5s20.9 16 32.5 9.7L320 51.3 604.6 205.1c11.7 6.3 26.2 2 32.5-9.7s2-26.2-9.7-32.5l-296-160zM249.8 208H390.2c10.1 0 19.2 6.4 22.6 15.9L429.9 272H210.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2 .5-.3 .9-.5 1.4C128.2 306.7 112 335.5 112 368v32 16 32 40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H480v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448 416 400 368c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L458 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H249.8c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM432 320c26.5 0 48 21.5 48 48v32H160V368c0-26.5 21.5-48 48-48H432zM224 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCartShopping = {
  prefix: 'far',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM131.1 80H520.7L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8H161.6L131.1 80zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faShoppingCart = faCartShopping;
var faBookFont = {
  prefix: 'far',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM261.5 93.3l88 176c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 256c-.4 0-.8 0-1.2 0H192c-.4 0-.8 0-1.2 0l-17.4 34.8c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l88-176C222.6 85.1 230.9 80 240 80s17.4 5.1 21.5 13.3zM265.2 208L240 157.7 214.8 208h50.3z"]
};
var faShieldPlus = {
  prefix: 'far',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faVials = {
  prefix: 'far',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M0 56C0 42.7 10.7 32 24 32H56 168h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V80H24C10.7 80 0 69.3 0 56zM80 80V256h64V80H80zM288 56c0-13.3 10.7-24 24-24h32H456h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V80h-8c-13.3 0-24-10.7-24-24zm80 24V256h64V80H368z"]
};
var faEyeDropperFull = {
  prefix: 'far',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l0 0 8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9v52.9l-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28h52.9c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6 183.4 198.6 53.1 329z"]
};
var faDistributeSpacingHorizontal = {
  prefix: 'far',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", "M456 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM304 368l-96 0 0-224 96 0 0 224zm48-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM80 24C80 10.7 69.3 0 56 0S32 10.7 32 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24L80 24z"]
};
var faTabletRugged = {
  prefix: 'far',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M352 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H352zM96 0C66.6 0 41.8 19.8 34.3 46.8L8.8 59.6C3.4 62.3 0 67.8 0 73.9v76.2c0 6.1 3.4 11.6 8.8 14.3L32 176v16L8.8 203.6C3.4 206.3 0 211.8 0 217.9v76.2c0 6.1 3.4 11.6 8.8 14.3L32 320v16L8.8 347.6C3.4 350.3 0 355.8 0 361.9v76.2c0 6.1 3.4 11.6 8.8 14.3l25.5 12.7C41.8 492.2 66.6 512 96 512H352c29.4 0 54.2-19.8 61.7-46.8l25.5-12.7c5.4-2.7 8.8-8.2 8.8-14.3V361.9c0-6.1-3.4-11.6-8.8-14.3L416 336V320l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V217.9c0-6.1-3.4-11.6-8.8-14.3L416 192V176l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V73.9c0-6.1-3.4-11.6-8.8-14.3L413.7 46.8C406.2 19.8 381.4 0 352 0H96z"]
};
var faTemperatureSnow = {
  prefix: 'far',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M368 112c0-35.3 28.7-64 64-64s64 28.7 64 64V273.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5c7.1-9.5 12.8-22.1 12.8-36.6V112zM432 0C370.1 0 320 50.1 320 112V273.9c0 1.7-.7 4.4-3.2 7.8c-18.1 24.1-28.8 54-28.8 86.4c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8V112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 131.6l-88 50.8V126.6l35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V81.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6v55.8l-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6v55.8l-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6V392c0 13.3 10.7 24 24 24s24-10.7 24-24V366.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4V265.6l67.7 39.1c5.2-13.5 12-26.2 20.3-37.9v-5.8l-64-37 64-37V131.6z"]
};
var faTemperatureFrigid = faTemperatureSnow;
var faMoped = {
  prefix: 'far',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", "M328 56c0-13.3 10.7-24 24-24h41.3c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4H528c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8.4c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8H336c-.9 0-1.7 0-2.6-.1H288 256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32V320c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v80c0 17.7 14.3 32 32 32h40 31.3c14.5-46 49.1-83.1 93.6-100.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4H352c-13.3 0-24-10.7-24-24zM120 112H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 128H128c-44.2 0-80 35.8-80 80v16H214.7c-4.3-9.8-6.7-20.6-6.7-32V240zM160 432c26.5 0 48-21.5 48-48H112c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faFaceSmilePlus = {
  prefix: 'far',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M544 0c13.3 0 24 10.7 24 24V72h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H568v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V120H472c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V24c0-13.3 10.7-24 24-24zM400 288A176 176 0 1 0 48 288a176 176 0 1 0 352 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM146 332.8c19.1 21.6 46.9 35.2 78 35.2s58.9-13.6 78-35.2c8.8-9.9 23.9-10.9 33.9-2.1s10.9 23.9 2.1 33.9C310.2 396.1 269.4 416 224 416s-86.2-19.9-114-51.5c-8.8-9.9-7.8-25.1 2.1-33.9s25.1-7.8 33.9 2.1z"]
};
var faSmilePlus = faFaceSmilePlus;
var faRadioTuner = {
  prefix: 'far',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M511.1 17.6c3.5 12.8-4 26-16.8 29.5L201.2 128H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V304 192v-3.4c0-32.4 21.6-60.8 52.9-69.4L481.6 .9c12.8-3.5 26 4 29.5 16.8zM48 272v32V448c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V272H48zm256 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM96 320H224c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faRadioAlt = faRadioTuner;
var faFaceSwear = {
  prefix: 'far',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M320 48c114.9 0 208 93.1 208 208h48C576 114.6 461.4 0 320 0S64 114.6 64 256h48c0-114.9 93.1-208 208-208zM240.4 224c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32zM48 288c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm352 96H384v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V384H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32V384H320zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM184 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 336v1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-.6 .4-1.2 .9-1.5 2.9c-.2 1-.1 1.6-.1 1.8c.1 .1 .5 .6 1.5 1.3c3.7 2.5 9.6 4.4 19.2 7.3l.7 .2c8 2.4 19.1 5.8 27.6 11.9c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c.5-.3 1.4-.9 2-4c.2-1.2 .2-1.9 .2-2.3c0-.4-.1-.6-.1-.6l0 0c0-.1-.3-.6-1.6-1.6c-3.5-2.5-9.3-4.6-18.7-7.4L106 414c-7.7-2.3-18.3-5.5-26.4-11c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7V336c0-8.8 7.2-16 16-16s16 7.2 16 16zM96.1 375.4a.1 .1 0 1 0 .1-.1 .1 .1 0 1 0 -.1 .1z"]
};
var faWaterArrowDown = {
  prefix: 'far',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V161.7l-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L312 161.7V24zM80 302.1C62.8 317 41 328.8 18.8 333.8C5.9 336.7-2.3 349.5 .6 362.5s15.7 21.1 28.7 18.2C58 374.2 81.6 360.2 96 350.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm0 128C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0z"]
};
var faWaterLower = faWaterArrowDown;
var faScannerTouchscreen = {
  prefix: 'far',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M128 24V64h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0V64h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16V64h32V16c0-8.8-7.2-16-16-16zM384 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM64 144H288c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm0-48C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 80c-13.3 0-24 10.7-24 24V408c0 13.3 10.7 24 24 24H248c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H104z"]
};
var faCircle7 = {
  prefix: 'far',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H287.8l-93 172.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l112-208c4-7.4 3.8-16.4-.5-23.7s-12.2-11.7-20.6-11.7H184z"]
};
var faPlugCirclePlus = {
  prefix: 'far',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16zM104 0c13.3 0 24 10.7 24 24v88H80V24C80 10.7 90.7 0 104 0zM280 0c13.3 0 24 10.7 24 24v88H256V24c0-13.3 10.7-24 24-24zM0 168c0-13.3 10.7-24 24-24h8H80 304h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v19.2c-18 9.2-34.2 21.4-48 36V192H80v64c0 61.9 50.1 112 112 112c24.3 0 46.9-7.8 65.2-20.9c-.8 6.9-1.2 13.9-1.2 20.9c0 11.4 1.1 22.5 3.1 33.3c-13.5 6.2-28 10.7-43.1 12.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V414.2C91 402.6 32 336.2 32 256V192H24c-13.3 0-24-10.7-24-24z"]
};
var faPersonSkiJumping = {
  prefix: 'far',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM112 120c0-13.3 10.7-24 24-24H301.2c37 0 54.2 45.9 26.3 70.2L202.4 275 171 385 433.7 249.1c18.6-9.6 30.3-28.8 30.3-49.7V192c0-13.3 10.7-24 24-24s24 10.7 24 24v7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3C23.3 515.4 8.8 510.8 2.7 499s-1.5-26.3 10.3-32.3l113.2-58.6c-5.4-5.9-7.6-14.4-5.3-22.7l37.2-130.1c.1-.2 .1-.5 .2-.7l8.3-29c2.7-9.4 7.8-18 14.9-24.9c11.1-10.7 36.2-34.6 60.8-56.8H136c-13.3 0-24-10.7-24-24z"]
};
var faSkiJump = faPersonSkiJumping;
var faPlaceOfWorship = {
  prefix: 'far',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M320 0c6.8 0 13.3 2.9 17.8 7.9l67.9 75.4c6.6 7.3 10.3 16.9 10.3 26.8v75.4l38.4 24.9c15.9 10.3 25.6 28 25.6 47V464h88c13.3 0 24-10.7 24-24V370.1c0-8.1-4.1-15.7-11-20.2l-69-44.7V248.1l95.1 61.5c20.5 13.3 32.9 36 32.9 60.4V440c0 39.8-32.2 72-72 72H384v0H224v0H72c-39.8 0-72-32.2-72-72V370.1c0-24.4 12.4-47.2 32.9-60.4L128 248.1v57.2L59 350c-6.8 4.4-11 12-11 20.2V440c0 13.3 10.7 24 24 24h88V257.4c0-19 9.6-36.7 25.6-47L224 185.5V110.1c0-9.9 3.7-19.4 10.3-26.8L302.2 7.9C306.7 2.9 313.2 0 320 0zM272 113.2v85.4c0 8.1-4.1 15.7-11 20.1l-49.4 32c-2.3 1.5-3.7 4-3.7 6.7V464h64V368c0-26.5 21.5-48 48-48s48 21.5 48 48v96h64V257.4c0-2.7-1.4-5.2-3.7-6.7l-49.4-32c-6.8-4.4-11-12-11-20.1V113.2L320 59.9l-48 53.3z"]
};
var faWaterArrowUp = {
  prefix: 'far',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", "M312 216c0 13.3-10.7 24-24 24s-24-10.7-24-24V78.3l-47.9 43.5c-9.8 8.9-25 8.2-33.9-1.6s-8.2-25 1.6-33.9l88-80c9.2-8.3 23.1-8.3 32.3 0l88 80c9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6L312 78.3V216zM80 302.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm0 128c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7z"]
};
var faWaterRise = faWaterArrowUp;
var faWaveformLines = {
  prefix: 'far',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", "M320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM520 64c13.3 0 24 10.7 24 24V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM216 96c13.3 0 24 10.7 24 24V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm208 32c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM120 192c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM24 224c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm592 0c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24z"]
};
var faWaveformPath = faWaveformLines;
var faSplit = {
  prefix: 'far',
  iconName: 'split',
  icon: [512, 512, [], "e254", "M391 31c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H346.5c-10.6 0-20.8 4.2-28.3 11.7L225.9 256l92.3 92.3c7.5 7.5 17.7 11.7 28.3 11.7h83.5l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H346.5c-23.3 0-45.7-9.3-62.2-25.8L182.1 280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H182.1L284.3 129.8c16.5-16.5 38.9-25.8 62.2-25.8h83.5L391 65c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faFilmCanister = {
  prefix: 'far',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M96 32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32h40 32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H296 56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V80H24C10.7 80 0 69.3 0 56S10.7 32 24 32H56 96zM80 80V464H272V80H80zm464 48c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32 14.3-32 32v32c0 17.7-14.3 32-32 32H352V128H544zM392 184v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V184c0-8.8-7.2-16-16-16H408c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V184c0-8.8-7.2-16-16-16H504zM392 344v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V344c0-8.8-7.2-16-16-16H408c-8.8 0-16 7.2-16 16z"]
};
var faFilmCannister = faFilmCanister;
var faFolderXmark = {
  prefix: 'far',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faFolderTimes = faFolderXmark;
var faToiletPaperBlank = {
  prefix: 'far',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", "M20.5 463.6c-4.3 7.2-5.5 15.8-3.6 23.7c.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512H333.9c22.3 0 45.4-12.1 55.4-36.1c9.6-23.2 23.9-66.4 33.3-134.5c0-.3 .1-.6 .1-.8c5.5-40.5 9.3-89.7 9.3-148.6c0-76 26.2-138.3 59.4-143.6c1.5-.2 3.1-.4 4.6-.4c35.3 0 64 64.5 64 144s-28.7 144-64 144c-14 0-26.9-10-37.4-27.1c-2.2 22.3-4.9 42.5-7.9 60.8C463 378 478.2 384 496 384c24.5 0 44.1-11.4 58-24.5c13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5C540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160C107 0 64 86 64 192c0 77.6-.4 174.5-32.9 250c-3.2 7.4-6.7 14.6-10.5 21.6l0 .1zM419 48c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 153.2-26.3 235-39 265.5c-.9 2.1-2.1 3.5-3.8 4.5c-2 1.2-4.6 2-7.3 2H73.8c18.1-40.9 27.3-85.5 32.2-127.9c5.9-50.6 5.9-101.7 5.9-144.1c0-47.2 9.7-87.5 23.1-114.3c6.7-13.4 13.4-21.6 18.6-26c2.5-2.1 4.3-3 5.2-3.4c.5-.2 .8-.3 .9-.3s.2 0 .3 0H419zm77 192c13.3 0 24-21.5 24-48s-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48z"]
};
var faToiletPaperAlt = faToiletPaperBlank;
var faTabletScreen = {
  prefix: 'far',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M48 448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V368H48v80zm0-128H400V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V320zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTabletAndroidAlt = faTabletScreen;
var faHexagonVerticalNftSlanted = {
  prefix: 'far',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", "M188.9 495.5c22.3 12.9 49.7 12.9 72 0l152.9-88.3c22.3-12.9 36-36.6 36-62.4V168.3c0-25.7-13.7-49.5-36-62.4L260.9 17.7c-22.3-12.9-49.7-12.9-72 0L36 105.9C13.7 118.8 0 142.6 0 168.3V344.9c0 25.7 13.7 49.5 36 62.4l152.9 88.3zm48-41.6c-7.4 4.3-16.6 4.3-24 0L60 365.7c-7.4-4.3-12-12.2-12-20.8l0-176.6c0-8.6 4.6-16.5 12-20.8L212.9 59.2c7.4-4.3 16.6-4.3 24 0l152.9 88.3c7.4 4.3 12 12.2 12 20.8V344.9c0 8.6-4.6 16.5-12 20.8L236.9 453.9zm27-344.3c5 2.8 8.1 8.2 8.1 13.9c0 12.3-13.3 20-23.9 13.9l-24.2-13.8v117h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144V96.3c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6c0 0 .1 0 .1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3zm32.1 55.2c-5-2.8-8.1-8.2-8.1-13.9c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3V352.6c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.4l-23.8-13.6zM159.8 144.6v224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2v61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270V144.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFolderMusic = {
  prefix: 'far',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V283.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V224 192z"]
};
var faDisplayMedical = {
  prefix: 'far',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", "M512 48c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H336.5c-.3 0-.6 0-.8 0H240.4c-.3 0-.6 0-.8 0H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H512zM64 416H211.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H352h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H372.3l-8-48H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm188.3 48l8-48h55.3l8 48H252.3zM256 128v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240h48c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H320V128c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"]
};
var faDesktopMedical = faDisplayMedical;
var faShareAll = {
  prefix: 'far',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", "M367.5 73.4c-9.6-9.1-10-24.3-.9-33.9s24.3-10 33.9-.9L542.2 173.2c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8 .9-33.9L509.2 208 367.5 73.4zM224 240l0 0h24c13.3 0 24 10.7 24 24v24 28.1L392.1 208 272 99.9V128v24c0 13.3-10.7 24-24 24H224 176c-70.7 0-128 57.3-128 128c0 15.3 1.9 29.1 5.2 41.5C70 284.7 125.8 240 192 240h32zm0 96V288H192c-5.5 0-10.8 .5-16 1.3c-45.4 7.6-80 47.1-80 94.7c0 17.3 4.2 30.5 9.5 40.2c1.6 2.9 3.3 5.5 5 7.9c2.6 3.5 5.3 6.4 7.7 8.6c.5 .5 1 .9 1.4 1.4c4.8 4.9 8.3 11.3 8.3 18.1c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9c-2.6-1.4-6.3-3.5-10.8-6.5c-2.7-1.8-5.7-3.8-8.9-6.2c-3.7-2.7-7.6-5.8-11.7-9.3C38.6 430.2 0 382 0 304c0-97.2 78.8-176 176-176h48V80 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V336z"]
};
var faPeapod = {
  prefix: 'far',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M416 48C212.8 48 48 212.8 48 416v48H96c203.2 0 368-164.8 368-368V48H416zm0-48h48c26.5 0 48 21.5 48 48V96c0 229.8-186.2 416-416 416H48c-26.5 0-48-21.5-48-48V416C0 186.2 186.2 0 416 0zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faChessClock = {
  prefix: 'far',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", "M256 56c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v32H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V176c0-35.3-28.7-64-64-64H544V96c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v16H200V80h32c13.3 0 24-10.7 24-24zM576 160c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H576zM200 400a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM184 240c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V240zM513.5 369.5A104 104 0 1 0 366.5 222.5 104 104 0 1 0 513.5 369.5zM490.9 245.1c6.2 6.2 6.2 16.4 0 22.6L457 301.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faAxe = {
  prefix: 'far',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M486.6 9.4c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3V384c0 17.7 14.3 32 32 32c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32H525.3l-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16zM305.4 267.9l-61.3-61.3L9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0L305.4 267.9zm185.9-73.9c9 9 21.2 14.1 33.9 14.1h66c-7.6 84.4-74.8 151.7-159.3 159.3v-66c0-12.7-5.1-24.9-14.1-33.9L278.6 128 352 54.6 491.3 193.9z"]
};
var faSquareD = {
  prefix: 'far',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H176V336z"]
};
var faGripVertical = {
  prefix: 'far',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M40 440l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm192-40l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 232l48 0 0 48-48 0 0-48zM0 280c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48zm232 0l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 72l48 0 0 48-48 0 0-48zM0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48zm232 0l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40z"]
};
var faMobileSignalOut = {
  prefix: 'far',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", "M64 48H224V0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V288H304V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 120c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"]
};
var faArrowTurnUp = {
  prefix: 'far',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c48.6 0 88-39.4 88-88l0-342.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L168 424c0 22.1-17.9 40-40 40L24 464z"]
};
var faLevelUp = faArrowTurnUp;
var faU = {
  prefix: 'far',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M24 32c13.3 0 24 10.7 24 24V288c0 79.5 64.5 144 144 144s144-64.5 144-144V56c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 106-86 192-192 192S0 394 0 288V56C0 42.7 10.7 32 24 32z"]
};
var faArrowUpFromDottedLine = {
  prefix: 'far',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", "M241.5 39.6C236.9 34.7 230.6 32 224 32s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L200 116.5V200 328c0 13.3 10.7 24 24 24s24-10.7 24-24V200 116.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faSquareRootVariable = {
  prefix: 'far',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H76.9c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8L290.3 72.9C297.1 48.7 319.2 32 344.3 32H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H344.3zM399 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faSquareRootAlt = faSquareRootVariable;
var faLightSwitchOn = {
  prefix: 'far',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M169.4 48c3.3 9.3 12.2 16 22.6 16s19.3-6.7 22.6-16H320c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H214.6c-3.3-9.3-12.2-16-22.6-16s-19.3 6.7-22.6 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H169.4zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 256h96V368H144V256zm0-160c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H144z"]
};
var faArrowDownArrowUp = {
  prefix: 'far',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM399 39l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 39c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faSortAlt = faArrowDownArrowUp;
var faRaindrops = {
  prefix: 'far',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M105.9 106.6l41.9-67.8C150.4 34.6 155 32 160 32s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9V144c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.5c0-12.3 3.4-24.4 9.9-34.9zm-96 192l41.9-67.8C54.4 226.6 59 224 64 224s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9V336c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.5c0-12.3 3.4-24.4 9.9-34.9zm242.6 11.5c-8.2 12.7-12.5 27.6-12.5 42.7c0 43.4 35.9 79.2 80 79.2s80-35.8 80-79.2c0-15.1-4.3-30-12.5-42.7L320 204.6 252.5 310.1zm-40.4-25.9l95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5C441 304.7 448 328.5 448 352.8C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z"]
};
var faDash = {
  prefix: 'far',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 256c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
};
var faMinusLarge = faDash;
var faClock = {
  prefix: 'far',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faClockFour = faClock;
var faInputNumeric = {
  prefix: 'far',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", "M576 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm40 120c0 13.3 10.7 24 24 24h8v96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V184c0-13.3-10.7-24-24-24H128c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H318.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"]
};
var faTruckTow = {
  prefix: 'far',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M96 64v96c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 20.2 70.4 9.8 80 4.3C84.7 1.6 90.2 0 96 0h21.7 28c9.1 0 17.8 3.9 23.9 10.7L373.3 240H384V152c0-30.9 25.1-56 56-56h50.1c20.9 0 40.7 9.1 54.4 24.8l81.8 94.4c8.8 10.2 13.7 23.2 13.7 36.7V360c0 30.9-25.1 56-56 56h-8c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H56c-30.9 0-56-25.1-56-56V296c0-30.9 25.1-56 56-56H184L96 64zM243.2 368H396.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H584c4.4 0 8-3.6 8-8V288H432 416 384 351.8 208 56c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48zM145.8 56.3L237.7 240h71.4L145.8 56.3zM584.2 240l-76-87.7c-4.6-5.3-11.2-8.3-18.1-8.3H440c-4.4 0-8 3.6-8 8v88H584.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faBackwardStep = {
  prefix: 'far',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", "M80 88c0-13.3-10.7-24-24-24S32 74.7 32 88V226.7v58.6V424c0 13.3 10.7 24 24 24s24-10.7 24-24V318.9L256.7 442.6c5.1 3.5 11.1 5.4 17.3 5.4c16.6 0 30.1-13.5 30.1-30.1V94.1C304 77.5 290.5 64 273.9 64c-6.2 0-12.2 1.9-17.3 5.4L80 193.1V88zm0 172.3v-8.6L256 128.5v255L80 260.3z"]
};
var faStepBackward = faBackwardStep;
var faPallet = {
  prefix: 'far',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v96H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H88 320 552h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H576V368h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H552 320 88 24zm88 48H296v96H112V368zm232 0H528v96H344V368z"]
};
var faCarBolt = {
  prefix: 'far',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M127.7 106.8L103.4 176H128v48H96c-26.5 0-48 21.5-48 48v80H464V272c0-26.5-21.5-48-48-48H384V176h24.6l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H165.4c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32H346.6c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9C492.6 205.4 512 236.4 512 272v80 48 56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H48v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400 352 272c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM315.2 116.6c5.3 5.2 6.3 13.3 2.5 19.6L284.3 192H336c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L227.7 224H176c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"]
};
var faArrowsMaximize = {
  prefix: 'far',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", "M328 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.1L256 222.1 113.9 80H184c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 32 32 42.7 32 56V184c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9L222.1 256 80 398.1V328c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24H184c13.3 0 24-10.7 24-24s-10.7-24-24-24H113.9L256 289.9 398.1 432H328c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.1L289.9 256 432 113.9V184c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H328z"]
};
var faExpandArrows = faArrowsMaximize;
var faFaucet = {
  prefix: 'far',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M224 64c13.3 0 24 10.7 24 24v21L352 96c17.7 0 32 14.3 32 32s-14.3 32-32 32L248 147v45h26.7c14.9 0 29.1 5.9 39.6 16.4L329.9 224H360c83.9 0 152 68.1 152 152v16c0 30.9-25.1 56-56 56H408c-30.9 0-56-25.1-56-56c0-4.4-3.6-8-8-8H323.9c-23.4 29.2-59.5 48-99.9 48s-76.5-18.8-99.9-48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H136.3c8.2 0 15.8 4.2 20.2 11.1C170.8 369.3 195.7 384 224 384s53.2-14.7 67.4-36.9c4.4-6.9 12-11.1 20.2-11.1H344c30.9 0 56 25.1 56 56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V376c0-57.4-46.6-104-104-104H320c-6.4 0-12.5-2.5-17-7l-22.6-22.6c-1.5-1.5-3.5-2.3-5.7-2.3H181.3c-2.1 0-4.2 .8-5.7 2.3L153 265c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H126.1l15.6-15.6c10.5-10.5 24.7-16.4 39.6-16.4H200V147L96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l104 13V88c0-13.3 10.7-24 24-24z"]
};
var faCloudSleet = {
  prefix: 'far',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm272 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM216 376c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V376zm256 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H472V376z"]
};
var faLampStreet = {
  prefix: 'far',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M48 172c0-68.5 55.5-124 124-124c65 0 118.3 50 123.6 113.5c-84 10.7-151.1 75.6-164.9 158.6C127.7 337.6 142.3 352 160 352H480c17.7 0 32.3-14.4 29.4-31.9C495.5 236.9 428 171.8 343.7 161.4C338.2 71.4 263.4 0 172 0C77 0 0 77 0 172V488c0 13.3 10.7 24 24 24s24-10.7 24-24V172zM455.8 304H184.2c19.8-55.9 73.1-96 135.8-96s116.1 40.1 135.8 96zM320 448c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64z"]
};
var faListRadio = {
  prefix: 'far',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM64 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z"]
};
var faPenNibSlash = {
  prefix: 'far',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L448.6 326.3 476.2 225l10.4-10.4 71-71c21.9-21.9 21.9-57.3 0-79.2L511.6 18.3c-21.9-21.9-57.3-21.9-79.2 0l-71 71L351 99.8 209 138.5 38.8 5.1zM256.1 175.4l104.8-28.6 68.3 68.3-21.6 79.1L256.1 175.4zM272 352c13.5 0 25.7-5.6 34.4-14.6l-75-59.1c-4.7 7.4-7.4 16.2-7.4 25.7c0 7.4 1.7 14.4 4.7 20.7L126.5 426.9l63.6-181.1-39.8-31.4L71 440c-6.5 18.5-1.8 39.1 12 52.9s34.4 18.5 52.9 12l264.1-92.8 .8-.3-44.7-35.2L149.1 449.5 251.3 347.3c6.3 3 13.3 4.7 20.7 4.7z"]
};
var faBaseballBatBall = {
  prefix: 'far',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", "M372 17.5C383.8 6.3 399.5 0 415.7 0c16.8 0 32.9 6.7 44.7 18.5l33 33c11.9 11.9 18.5 28 18.5 44.7c0 16.3-6.3 31.9-17.5 43.7L356.3 284.7c-14.1 14.8-30.3 27.5-48 37.8L201.8 384.2c-12.6 7.3-24.3 16.3-34.6 26.6l-38.6 38.6c-.3-.3-.6-.7-1-1l-64-64c-.3-.3-.7-.6-1-1l38.6-38.6c10.3-10.3 19.3-22 26.6-34.6l61.6-106.5c10.3-17.7 23-33.9 37.8-48L372 17.5zM171.9 329.9l10.2 10.2L284.2 281c13.8-8 26.4-17.9 37.3-29.4L459.8 106.8c2.7-2.8 4.2-6.6 4.2-10.5c0-4-1.6-7.9-4.5-10.8l-33-33c-2.9-2.9-6.7-4.5-10.8-4.5c-3.9 0-7.7 1.5-10.5 4.2L260.4 190.4c-11.5 11-21.4 23.6-29.4 37.3L171.9 329.9zM464 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM15 399c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L15 433c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faSquareUpLeft = {
  prefix: 'far',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 313.4V176c0-8.8 7.2-16 16-16H281.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z"]
};
var faOverline = {
  prefix: 'far',
  iconName: 'overline',
  icon: [448, 512, [], "f876", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm200 80c-97.2 0-176 78.8-176 176v16c0 97.2 78.8 176 176 176s176-78.8 176-176V288c0-97.2-78.8-176-176-176zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V288z"]
};
var faS = {
  prefix: 'far',
  iconName: 's',
  icon: [320, 512, [115], "53", "M91.2 90.6c-24 10.1-37.9 26.2-41.8 48c-2.8 16.1-1 27.4 2.8 35.7c3.8 8.5 10.6 16.1 21.1 23.3c22.1 15.1 54.9 24.6 93.2 35.3c.8 .2 1.6 .4 2.4 .7c35.3 9.9 75.6 21.2 104.9 41.2c15.6 10.6 29.3 24.5 37.7 43.1c8.5 18.7 10.6 40 6.4 63.9c-7.2 40.8-34.4 68.8-70.5 83.9c-35.3 14.8-79.6 17.8-125.7 10.7l-.1 0c-24.5-3.9-64.3-17.2-90.9-26.2c-5.3-1.8-10-3.4-14-4.7C4 441.4-2.9 427.8 1.2 415.2s17.7-19.5 30.3-15.4c4.9 1.6 10.5 3.5 16.3 5.4c26.9 9 61.2 20.4 81.3 23.6c40.4 6.2 75.1 2.9 99.8-7.5c24-10.1 37.9-26.2 41.8-48c2.8-16.1 1-27.4-2.8-35.7c-3.8-8.5-10.6-16.1-21.1-23.3c-22.1-15.1-54.9-24.6-93.2-35.3c-.8-.2-1.6-.4-2.4-.7c-35.3-9.9-75.6-21.2-104.9-41.2c-15.6-10.6-29.3-24.5-37.7-43.1c-8.5-18.7-10.6-40-6.4-63.9l23.6 4.2L2.1 130.3C9.3 89.5 36.5 61.5 72.6 46.4c35.3-14.8 79.6-17.8 125.7-10.7c13.7 2.1 55.1 9.9 69.7 13.8c12.8 3.3 20.5 16.5 17.2 29.3s-16.5 20.5-29.3 17.2c-12.4-3.2-52-10.8-64.9-12.8l3.6-23.7L191 83.1c-40.4-6.2-75.2-2.9-99.9 7.5z"]
};
var faTimeline = {
  prefix: 'far',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", "M128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24 108.3c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 35.8 23.5 66.1 56 76.3V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H296v59.7c-32.5 10.2-56 40.5-56 76.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V280H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H536V172.3c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 35.8 23.5 66.1 56 76.3V232H152V172.3zM320 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM480 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faKeyboard = {
  prefix: 'far',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 320H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16z"]
};
var faArrowsFromDottedLine = {
  prefix: 'far',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V168c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V344zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faUsbDrive = {
  prefix: 'far',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", "M64 144c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H400V144H64zM0 160c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160zm608-32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H480V128H608zm-48 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM536 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faBallot = {
  prefix: 'far',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H96zM80 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM200 104c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H200zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H200zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H200z"]
};
var faCaretDown = {
  prefix: 'far',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
};
var faLocationDotSlash = {
  prefix: 'far',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM192.3 125.4C216.3 79.4 264.5 48 320 48c79.5 0 144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2c-7.4 17.4-16.9 36.2-27.9 55.4l-57.7-45.2C385.3 245.1 400 220.3 400 192c0-44.2-35.8-80-80-80c-35.1 0-65 22.7-75.7 54.1l-52-40.7zM318 223.9l-28.5-22.4c-.9-3-1.5-6.2-1.5-9.6c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-.7 0-1.3 0-2-.1zM191.3 249.2c-.5-1.2-1-2.5-1.5-3.7l-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9z"]
};
var faMapMarkerAltSlash = faLocationDotSlash;
var faCards = {
  prefix: 'far',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", "M244.7 49c3.7-2.1 8.4-.9 10.5 2.8l167 289.3c2.1 3.7 .9 8.4-2.8 10.5L226.5 463c-3.7 2.1-8.4 .9-10.5-2.8L49 170.9c-2.1-3.7-.9-8.4 2.8-10.5L244.7 49zM27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zM324.1 499c9.7 8.1 22.2 13 35.9 13H584c30.9 0 56-25.1 56-56V120c0-30.9-25.1-56-56-56H360c-1.8 0-3.5 .1-5.3 .2L491.5 301.1c24.2 41.9 9.8 95.6-32.1 119.8L324.1 499zM582 187.6l-48.2 49.9c-3.2 3.2-8.5 3.2-11.5 0l-48.4-49.9c-14-14.5-13.2-38.5 2.5-51.9c13.5-11.7 34.2-9.5 46.7 3.2l5 5.2 4.7-5.2c12.5-12.7 33-15 46.9-3.2c15.5 13.5 16.2 37.5 2.2 51.9zM171.4 174.3l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4 .2-.8 .3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4 .1 .8 .2 1.1 .3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4L197 159.6c-11.1-3-22.6 3.6-25.6 14.8z"]
};
var faHouseChimneyMedical = {
  prefix: 'far',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24V182.6l55.5 47.1c10.1 8.6 11.3 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM272 192h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16z"]
};
var faClinicMedical = faHouseChimneyMedical;
var faBoxingGlove = {
  prefix: 'far',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M48 120c0-39.8 32.2-72 72-72H272c39.8 0 72 32.2 72 72v8H312c-40.3 0-74.2 27.1-84.7 64H167.5c-19.9 0-36.8-14.6-39.6-34.3l-.2-1.1c-1.9-13.1-14-22.2-27.2-20.4s-22.2 14-20.4 27.2l.2 1.1c6.2 43.4 43.3 75.6 87.1 75.6h59.8c10.4 36.9 44.4 64 84.7 64c13.3 0 24-10.7 24-24s-10.7-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40h51.1c.6 .1 1.2 .2 1.9 .3c19.7 2.5 35 19.3 35 39.7v38.9c0 14.9-5.9 29.1-16.4 39.6l-60.9 60.9c-12 12-18.7 28.3-18.7 45.3V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V359.6c0-6.8-2.9-13.3-8-17.9C57.2 328.5 48 309.3 48 288V120zM120 0C53.7 0 0 53.7 0 120V288c0 31.5 12.2 60.2 32 81.6V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V400.6c0-4.2 1.7-8.3 4.7-11.3l60.9-60.9c19.5-19.5 30.5-46 30.5-73.5V216c0-37.3-23.2-69.2-56-82V120C392 53.7 338.3 0 272 0H120zm32.9 346.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 411.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 372.8l-39.1-26.1z"]
};
var faGloveBoxing = faBoxingGlove;
var faTemperatureThreeQuarters = {
  prefix: 'far',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M160 48c-35.3 0-64 28.7-64 64V273.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V273.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V152c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faBellSchool = {
  prefix: 'far',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM352 358.1c39.4-37.9 64-91.1 64-150.1C416 93.1 322.9 0 208 0S0 93.1 0 208c0 59 24.6 112.2 64 150.1V448c0 35.3 28.7 64 64 64H272h16H416c39.2 0 71.1-31.4 72-70.4c14.4-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.7 9.6 33.2 24 41.5c-.8 12.5-11.2 22.5-24 22.5H350c1.3-5.1 2-10.5 2-16V358.1zM288 464H272 128c-8.8 0-16-7.2-16-16V392.6c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4V448c0 8.8-7.2 16-16 16zM208 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faMobileScreen = {
  prefix: 'far',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M64 448c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V368H64v80zm0-128H320V64c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16V320zM16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM160 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileAndroidAlt = faMobileScreen;
var faPlaneUp = {
  prefix: 'far',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l150.2 96.1c16.1 10.3 25.8 28.1 25.8 47.2v40.6c0 27.1-26.4 46.4-52.2 38.1L336 336.6V364l48 36c10.1 7.6 16 19.4 16 32v42.1c0 20.9-17 37.9-37.9 37.9c-3.8 0-7.5-.6-11.1-1.7L256 481.1l-94.9 29.2c-3.6 1.1-7.4 1.7-11.1 1.7C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1V297.5c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2V128c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm21.5 54.2c-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436v24.4l88.9-27.4c4.6-1.4 9.5-1.4 14.1 0L352 460.4V436l-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2V303.7c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5L464 327.1V297.5c0-2.7-1.4-5.3-3.7-6.7L299.1 187.6c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2l0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7zM146.9 464.4s0 0 0 0z"]
};
var faFolderHeart = {
  prefix: 'far',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCircleLocationArrow = {
  prefix: 'far',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm358.2-73.3l-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4C239.4 389.5 232 380.4 232 370V280H142c-10.4 0-19.5-7.4-21.5-17.6c-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2z"]
};
var faLocationCircle = faCircleLocationArrow;
var faFaceHeadBandage = {
  prefix: 'far',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M71.3 354c6.6-9.7 13.4-19.2 20.6-28.4C120.5 406.2 197.5 464 288 464c114.9 0 208-93.1 208-208c0-13.2-1.2-26.2-3.6-38.7c11.9 3 23.7 6.3 35.4 9.8l15 4.5c.8 8 1.1 16.2 1.1 24.4c0 141.4-114.6 256-256 256c-99.5 0-185.8-56.8-228.2-139.8c2.5-3.8 4.8-7.5 6.7-10.7c1.9-3.1 3.5-5.7 4.7-7.5zM218.5 209.6c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32c13.5-10.8 27.6-20.9 42.1-30.4zM368.1 12.8c-45.1 9.1-88.5 23-129.6 41.1c-13.9 3.4-27.2 8.2-39.8 14.2c-33.5 3.1-66.5 7.9-98.9 14.3C146.6 31.8 213.6 0 288 0c28 0 54.9 4.5 80.1 12.8zm-.3 382.7C352.2 381.2 328.4 368 296 368c-12.3 0-23.2 1.9-32.8 4.9c-12.6 4-26.1-3-30.1-15.7s3-26.1 15.7-30.1c14.2-4.5 30-7.1 47.2-7.1c46.5 0 81.4 19.3 104.2 39.9c9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6zM336.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c20.8 12.6 39.7 28 56.1 45.7C419.3 71.1 360.6 64.9 300.6 64.1zM406 103.4c34 4.3 67.3 10.5 100.1 18.3c14.1 22.8 24.6 47.9 31 74.7C458.2 172.7 374.6 160 288 160c-17.1 0-34.1 .5-51 1.5c-47.8 2.8-94.6 9.4-140 19.7c-19.6 4.4-39 9.5-58.1 15.3c6.4-26.8 17-51.9 31-74.7c48.4-11.6 98.2-19.5 149.3-23.2C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1c-51.6 37.5-96.5 83.8-132.2 136.7C36.5 310.9 32 284 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5z"]
};
var faSushiRoll = {
  prefix: 'far',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M400 207.7c-13.2 11.2-29 19.7-45 26.1C319 248.2 272.7 256 224 256s-95-7.8-131-22.2c-16-6.4-31.9-14.9-45-26.1V368c0 3 3.6 18.5 39.1 36.3C119.6 420.5 168 432 224 432s104.4-11.5 136.9-27.7C396.4 386.5 400 371 400 368V207.7zM64 144c0 10.4 6.2 20.1 17.1 28.8c20.4-23.3 45.9-40.4 70.3-52.7c20.1-10.1 40.2-17.3 57.5-21.9c-1.7-5.8-3-11.7-3.8-17.7C125.7 84.2 64 111.2 64 144zm54 47.9c28.2 10 65.4 16.1 106 16.1c30.9 0 59.8-3.5 84.2-9.6c-35.3-13.5-63.8-36.1-82-63.4c-16 3.8-36.4 10.5-56.9 20.8c-18.6 9.3-36.6 21.3-51.4 36.1zM384 144c0-32.4-60.1-59.2-138.2-63.4c9.3 42.5 53.3 85.3 122.8 90.8c9.8-8.3 15.4-17.6 15.4-27.4zM224 32c123.7 0 224 50.1 224 112V368c0 61.9-100.3 112-224 112S0 429.9 0 368V144C0 82.1 100.3 32 224 32z"]
};
var faMakiRoll = faSushiRoll;
var faMakizushi = faSushiRoll;
var faCarBump = {
  prefix: 'far',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", "M142.2 101.6L307.3 57.4c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6L107.5 205.6l5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zM64.8 133.7l-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1L60 416.5l6.2 23.3 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1 1.7-.5L495.8 324.7l1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1 0 0L529.8 266l-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7L390.4 46.4C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5l290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1L100.2 381.1 81.7 311.9c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0 -59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0 -15.9-59.5 30.8 30.8 0 1 0 15.9 59.5zM584.8 512c19.5 0 34.7-17.7 25.8-35c-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35H584.8z"]
};
var faPiggyBank = {
  prefix: 'far',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M277.1 48c23 0 42.5 14.7 49.8 35.2c4.4 12.5 18.1 19 30.6 14.6s19-18.1 14.6-30.6C358.3 28.1 321 0 277.1 0S195.8 28.1 182 67.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6C234.5 62.7 254.1 48 277.1 48zM66.7 197.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-4.7 2.3C15.7 169.3 0 194.7 0 222.6c0 37.4 28 68.3 64.2 72.9C66.4 344.7 91 388.2 128 416v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V448h48v16c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V426.6c18.7-10.8 35.1-25.4 48-42.6h32c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H530.7c-8.2-18.8-19.9-35.7-34.2-49.8l11.3-36.8-22.9-7 22.9 7c6.3-20.6-9.1-41.4-30.6-41.4H456c-31.5 0-60.2 12.2-81.6 32H224c-74.4 0-137 50.8-154.9 119.6c-12-2-21.1-12.5-21.1-25.1c0-9.6 5.4-18.4 14.1-22.8l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM402.3 168c13.1-14.7 32.1-23.9 53.2-24L446 174.8c-2.9 9.4 .2 19.6 7.9 25.8c17.4 13.9 30.4 32.8 37.1 54.5c3.1 10.1 12.4 17 22.9 17h14v64H499.4c-8.3 0-16 4.3-20.3 11.3c-11.7 18.7-28.7 33.7-48.9 42.8C421.5 394 416 402.5 416 412v52H368V424c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24v40H176V403.4c0-8.3-4.3-16-11.3-20.3c-31.7-19.8-52.7-55-52.7-95c0-61.9 50.1-112 112-112H384h0l.4 0c6.8 0 13.4-2.9 17.9-8z"]
};
var faRacquet = {
  prefix: 'far',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", "M349 48c31.9 0 61.1 10.9 82.6 32.4S464 131.2 464 163c0 40.6-17.7 84.9-52.9 120.1c-64 64-154.5 68.7-202.7 20.5C186.9 282.1 176 252.8 176 221c0-40.6 17.7-84.9 52.9-120.1S308.4 48 349 48zm0-48c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 17.2 2.4 34.3 7.3 50.6c8.2 27.4 7.6 58.9-9.9 80.6c-12.6-11.3-31.9-10.9-44 1.2l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.1-12.1 12.5-31.4 1.2-44c21.7-17.5 53.2-18 80.5-9.7c67.7 20.4 148.5-3.6 204.8-59.8c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM54.6 448L104 398.6l9.4 9.4L64 457.4 54.6 448z"]
};
var faCarMirrors = {
  prefix: 'far',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M197.4 80c-17 0-32.1 10.7-37.8 26.8L135.4 176H440.6l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H197.4zM44.8 224H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H84.6l29.8-85.1C126.7 55.6 160 32 197.4 32H378.6c37.4 0 70.7 23.6 83.1 58.9L491.4 176H536c13.3 0 24 10.7 24 24s-10.7 24-24 24h-4.8c8.2 14.1 12.8 30.5 12.8 48v80 48 56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H80v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400 352 272c0-17.5 4.7-33.9 12.8-48zm83.2 0c-26.5 0-48 21.5-48 48v80H496V272c0-26.5-21.5-48-48-48H128zm-16 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faIndustryWindows = {
  prefix: 'far',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", "M80 88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8V214.7c0 8.6 4.6 16.5 12 20.8s16.6 4.2 24-.1L320 153.8l0 70.9c0 8.8 4.8 16.8 12.5 21.1s17.1 3.9 24.5-.8l139.1-89L496 304v16 88c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V352 304 88zm8-56C57.1 32 32 57.1 32 88V304v48 56c0 39.8 32.2 72 72 72H472c39.8 0 72-32.2 72-72V320 304 155.9c0-37.9-41.9-60.9-73.9-40.4L368 180.8v-27c0-37-40.2-60.1-72.2-41.5L192 172.9V88c0-30.9-25.1-56-56-56H88zm56 264c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H144zm104 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H264c-8.8 0-16 7.2-16 16zm136-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H384z"]
};
var faIndustryAlt = faIndustryWindows;
var faBoltAuto = {
  prefix: 'far',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M317.4 36.6C322.6 18.3 308.8 0 289.7 0c-6.8 0-13.5 2.4-18.7 6.9L11.8 228.6C4.3 235 0 244.4 0 254.3C0 272.9 15.1 288 33.7 288h86.4L66.6 475.4C61.4 493.7 75.2 512 94.3 512c6.8 0 13.4-2.4 18.6-6.8L371.7 285.6c7.8-6.6 12.3-16.4 12.3-26.6c0-19.3-15.6-34.9-34.9-34.9H263.8L317.4 36.6zM72.4 240L253.6 85 208.9 241.4c-2.1 7.2-.6 15 3.9 21s11.6 9.5 19.2 9.5h81.5L130.3 427.5l44.8-156.9c2.1-7.2 .6-15-3.9-21s-11.6-9.5-19.2-9.5H72.4zM464 288c-9.1 0-17.4 5.1-21.5 13.3l-88 176c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L410.8 472H517.2l13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-88-176c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7L493.2 424H434.8L464 365.7z"]
};
var faBatteryHalf = {
  prefix: 'far',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", "M464 144c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"]
};
var faBattery3 = faBatteryHalf;
var faFluxCapacitor = {
  prefix: 'far',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM283.3 253.3c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7l-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0L224 199.4l51.7-51.7c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zM180.4 268.9c-21.9 14.3-36.4 39-36.4 67.1c0 44.2 35.8 80 80 80s80-35.8 80-80c0-28.1-14.5-52.8-36.4-67.1l-3.6 3.6V336c0 22.1-17.9 40-40 40s-40-17.9-40-40V272.6l-3.6-3.6zM155.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V262.6l75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z"]
};
var faMountainCity = {
  prefix: 'far',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M344 48c-4.4 0-8 3.6-8 8V219.7l-48-79.6V56c0-30.9 25.1-56 56-56H456c30.9 0 56 25.1 56 56V192h32V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72.6c27.1 3.9 48 27.2 48 55.4V480c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-4.4-3.6-8-8-8H568 488c-13.3 0-24-10.7-24-24V56c0-4.4-3.6-8-8-8H344zm27.3 230.2c2.9-3.8 7.5-6.2 12.7-6.2h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-9.8l-34.9-57.8zM384 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM368 192c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V192zm128 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V288zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V384c0-8.8 7.2-16 16-16zM224 188.9L154.5 304.1l21.3 30.8 28-37.3c4.5-6 11.6-9.6 19.2-9.6h60.8L224 188.9zM58 464H390L312.8 336H235l-40.8 54.4c-4.6 6.2-11.9 9.7-19.7 9.6s-14.9-4-19.3-10.4l-28-40.5L58 464zM253.4 144.7L442.9 458.9c6.5 10.8 6.7 24.3 .7 35.3s-17.6 17.8-30.1 17.8H34.5c-12.5 0-24-6.8-30.1-17.8s-5.8-24.5 .7-35.3L194.6 144.7C200.9 134.3 212 128 224 128s23.1 6.3 29.4 16.7z"]
};
var faCoins = {
  prefix: 'far',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M176 88v0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c.4 .3 .8 .7 1.2 1c-18.7 .4-36.9 1.7-54.4 4.1V88c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C226.4 7.5 271.5 0 320 0s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S512 70 512 88V192 296c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9c-9.6 3.7-20.1 6.9-31.3 9.6V323.6c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5v0V252.4c-5.3 2.6-10.9 5-16.7 7.2c-9.6 3.7-20.1 6.9-31.3 9.6V219.6c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0V148.4c-5.3 2.6-10.9 5-16.7 7.2c-13.7 5.2-29.4 9.6-46.3 12.9c-5.1-7.5-11-13.9-16.8-19.1c-10.1-9.1-21.8-16.5-34-22.6c31.7-2.3 59.3-8.2 80-16.1c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7C403.2 54.9 364.2 48 320 48s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5l0 0zM48 216v0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7c-27-10.3-66-17.2-110.2-17.2s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5l0 0zM0 216c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C98.4 135.5 143.5 128 192 128s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S384 198 384 216V320 424c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9C285.6 504.5 240.5 512 192 512s-93.6-7.5-127.3-20.3c-16.8-6.4-32-14.6-43.5-24.9S0 442 0 424V320 216zM336 320V276.4c-5.3 2.6-10.9 5-16.7 7.2C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2V320v0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5v0 0zM64.7 387.7c-5.8-2.2-11.4-4.6-16.7-7.2V424l0 0c0 0 0 .5 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5v0V380.4c-5.3 2.6-10.9 5-16.7 7.2C285.6 400.5 240.5 408 192 408s-93.6-7.5-127.3-20.3z"]
};
var faHoneyPot = {
  prefix: 'far',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M78.6 352c21.5 40.9 49 67 64.6 79.6l.1 0c.4 .1 1.4 .4 3.1 .4H301.6c1.6 0 2.6-.2 3.1-.4l.1 0c15.5-12.6 43.1-38.7 64.6-79.6H78.6zM48 224H400c0-79.5-64.5-144-144-144H192c-5.4 0-10.7 .3-16 .9V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V95c-47.4 23.6-80 72.5-80 129zM56 32h96 40 64H392c13.3 0 24 10.7 24 24s-10.7 24-24 24h-9c39.9 35.2 65 86.7 65 144c0 138.8-79.6 217.9-113.3 245.1c-9.3 7.5-21.1 10.9-33.1 10.9H146.4c-12 0-23.7-3.3-33.1-10.9C79.6 441.9 0 362.8 0 224C0 166.7 25.1 115.2 65 80H56C42.7 80 32 69.3 32 56s10.7-24 24-24z"]
};
var faOlive = {
  prefix: 'far',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M160 432C98.1 432 48 381.9 48 320c0-79.2 37-138.4 85.9-179.1C184.3 99 243.7 80 280 80c13.6 0 31.8 7.5 50.4 19.9c8.5 5.7 15.7 11.4 20.8 15.8c2.5 2.1 4.4 3.9 5.6 5c.6 .6 1 1 1.2 1.2l.1 .1 .1 .1c.2 .2 .6 .6 1.2 1.2c1.1 1.2 2.9 3.1 5 5.6c4.3 5 10.1 12.2 15.8 20.8C392.5 168.2 400 186.4 400 200c0 36.3-19 95.7-60.9 146.1C298.4 395 239.2 432 160 432zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM271.1 208.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z"]
};
var faKhanda = {
  prefix: 'far',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5c0 0 0 0 .1 0h0l41.1-28.2c72.1-49.6 86.2-151.1 39.1-221.7c-4-6-3.5-14 1.3-19.5s12.8-6.9 19.3-3.6c58.5 30 104.7 91.3 104.7 158.2c0 53.1-26.4 100.5-51.2 133.6c-14.8 19.7-31.7 38.7-50.6 54.7c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6c-19-15.9-35.8-35-50.6-54.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c15.4-15.4 32.7-29.2 52.2-39c6.5-3.2 14.3-1.7 19.2 3.7c6.9 7.8 3.4 16.3-1.5 23.7C76.1 162.6 95 262.9 164.4 310.6l41.1 28.2 .1 0L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1zM57.3 163C47 180.1 40 200.4 40 224c0 40.4 20.4 79.2 43.2 109.6c10 13.4 20.7 25.9 32 37l36-20.5-9.5-6.5C81.5 302.2 51.5 231.7 57.3 163zM429.9 333.6c22.8-30.4 43.2-69.2 43.2-109.6c0-24.3-7.4-45.1-18.2-62.5c6.7 68.5-20.8 138.9-83.6 182l-9.5 6.5 35.9 20.4c11.4-11.1 22.1-23.6 32.1-36.9z"]
};
var faFilterList = {
  prefix: 'far',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", "M41.2 64C18.5 64 0 82.5 0 105.2c0 10.4 3.9 20.4 11 28.1l93 100.1v126c0 13.4 6.7 26 18 33.4l75.5 49.8c5.3 3.5 11.6 5.4 18 5.4c18 0 32.6-14.6 32.6-32.6v-182l93-100.1c7.1-7.6 11-17.6 11-28.1C352 82.5 333.5 64 310.8 64H41.2zM145.6 207.7L56.8 112H295.2l-88.8 95.7c-4.1 4.4-6.4 10.3-6.4 16.3V386.8l-48-31.7V224c0-6.1-2.3-11.9-6.4-16.3zM344 392c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zM320 256c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zM408 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H408z"]
};
var faOutlet = {
  prefix: 'far',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM80 256c0-52.3 26.5-85.2 43.6-100.9c8.6-8 20.2-11.1 31.9-11.1h137c11.7 0 23.3 3.1 31.9 11.1c17 15.8 43.6 48.7 43.6 100.9s-26.5 85.2-43.6 100.9c-8.6 8-20.2 11.1-31.9 11.1h-137c-11.7 0-23.3-3.1-31.9-11.1C106.5 341.2 80 308.3 80 256zm96-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V208zM200 296v16c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V296c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faSliders = {
  prefix: 'far',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"]
};
var faSlidersH = faSliders;
var faCauldron = {
  prefix: 'far',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM74.2 252.5c9.6-17.7 20.1-33.2 28.6-44.5H224 345.2c8.5 11.4 19 26.9 28.6 44.5c15.9 29.2 26.2 58.5 26.2 81.9c0 39.2-18.3 70-49.4 92.5C318.3 450.2 272.6 464 224 464s-94.3-13.8-126.6-37.1C66.3 404.4 48 373.6 48 334.4c0-23.3 10.3-52.6 26.2-81.9zM44.6 208C22.5 243.4 0 290.8 0 334.4c0 37.4 11.9 69.4 32 95.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V473c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v15c0 13.3 10.7 24 24 24s24-10.7 24-24V429.9c20.1-26.1 32-58.1 32-95.5c0-43.6-22.5-91-44.6-126.4H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H368 224 80 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H44.6z"]
};
var faPeople = {
  prefix: 'far',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3 .1V304H144V176.1c.7 0 1.5-.1 2.3-.1zM144 488V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L250.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7H146.3c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM587.1 299.8c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6l-51.8 91.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l47.9-84.6-46.3 148c-3.2 10.3 4.5 20.8 15.3 20.8H416V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h26.2c10.8 0 18.5-10.5 15.3-20.8l-46.3-148 47.9 84.6zM526.7 336H433.3L480 186.5 526.7 336z"]
};
var faFolderTree = {
  prefix: 'far',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V136 392c0 30.9 25.1 56 56 56H256V400H56c-4.4 0-8-3.6-8-8V160H256V112H48V24zM336 176V48h44.1l17 17c9.6 9.6 22.6 15 36.2 15H528v96H336zM288 32V192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H433.3c-.8 0-1.7-.3-2.3-.9L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm48 432V336h44.1l17 17c9.6 9.6 22.6 15 36.2 15H528v96H336zM288 320V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H433.3c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z"]
};
var faNetworkWired = {
  prefix: 'far',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M400 48v96H240V48H400zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h56v40H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H136v40H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H184V280H456v40H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H504V280H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V192h56c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM80 368H240v96H80V368zm480 0v96H400V368H560z"]
};
var faCroissant = {
  prefix: 'far',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M323.7 242.1c2 18.9-4.5 38.1-18.4 51.9L294 305.3c-13.9 13.9-33 20.4-51.9 18.4L208 350.2V384l15.6 93.6c.3 1.6 .4 3.2 .4 4.9c0 16.3-13.2 29.6-29.6 29.6H189c-4.2 0-8.3-.7-12.2-2.3c-35.8-14.3-67.5-36.5-93.2-64.3c-16.4 7.1-36 2.5-45.3-13.7C14 389.4 0 340.3 0 288c0-22.4 2.6-44.2 7.4-65.1C2.7 215.6 0 207 0 197.9c0-5 .8-10 2.5-14.6C33.2 99.6 99.6 33.2 183.3 2.5C188 .8 193 0 197.9 0c9.1 0 17.7 2.7 24.9 7.4C243.8 2.6 265.6 0 288 0c52.3 0 101.4 14 143.7 38.4c16.2 9.3 20.8 28.9 13.7 45.3c27.9 25.7 50 57.4 64.3 93.2c1.5 3.9 2.3 8 2.3 12.2v5.4c0 16.3-13.2 29.6-29.6 29.6c-1.6 0-3.3-.1-4.9-.4L384 208H350.2l-26.5 34.1zm-74.3-191l55.3 137.3L394.5 72.9C362.5 57 326.3 48 288 48c-13.1 0-26 1.1-38.6 3.1zM51.1 249.4C49.1 262 48 274.9 48 288c0 38.3 9 74.5 24.9 106.5l115.5-89.8L51.1 249.4zM388 160l3.9 .7 62 10.3c-10-17.9-22.6-34.3-37.2-48.4L387.6 160h.4zM171 453.9l-10.3-62L160 388v-.4l-37.4 29.1c14.2 14.6 30.5 27.2 48.4 37.2zm71.8-179c6 2.4 12.8 1 17.3-3.5l11.3-11.3c4.5-4.5 5.9-11.3 3.5-17.3l-78.2-194c-67.9 25.9-122 80-147.9 147.9l194 78.2z"]
};
var faMapPin = {
  prefix: 'far',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M64 144a96 96 0 1 1 192 0A96 96 0 1 1 64 144zM184 286c68.1-11.4 120-70.7 120-142C304 64.5 239.5 0 160 0S16 64.5 16 144c0 71.4 51.9 130.6 120 142V488c0 13.3 10.7 24 24 24s24-10.7 24-24V286z"]
};
var faHamsa = {
  prefix: 'far',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M184 104v96c0 13.3 10.7 24 24 24s24-10.7 24-24V104 72c0-13.3 10.7-24 24-24s24 10.7 24 24v32 96c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3 10.7-24 24-24s24 10.7 24 24V280c0 13.3 10.7 24 24 24h48.4c8.6 0 15.6 7 15.6 15.6c0 4.1-1.6 8.1-4.6 11l-83.8 83.8C343.9 446.2 300.9 464 256 464s-87.9-17.8-119.6-49.5L52.6 330.6c-2.9-2.9-4.6-6.9-4.6-11C48 311 55 304 63.6 304H112c13.3 0 24-10.7 24-24V104c0-13.3 10.7-24 24-24s24 10.7 24 24zm7.8-64.6C182.2 34.7 171.4 32 160 32c-39.8 0-72 32.2-72 72V256H63.6C28.5 256 0 284.5 0 319.6c0 16.9 6.7 33 18.6 45l83.8 83.8c40.7 40.7 96 63.6 153.5 63.6s112.8-22.9 153.5-63.6l83.8-83.8c11.9-11.9 18.6-28.1 18.6-45c0-35.1-28.5-63.6-63.6-63.6H424V104c0-39.8-32.2-72-72-72c-11.4 0-22.2 2.7-31.8 7.4C308.3 16 284 0 256 0s-52.3 16-64.2 39.4zM165.4 338.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288s-76.8 35.8-90.6 50.2zM256 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCentSign = {
  prefix: 'far',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M216 0c13.3 0 24 10.7 24 24V72.5C277.9 75 313 88 341.9 108.4c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7C289.7 130.3 259.2 120 226 120c-82 0-146 62.2-146 136s64 136 146 136c33.3 0 63.7-10.3 88.2-27.6c10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5C313 424 277.9 437 240 439.5V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V437.2C102 422 32 347.7 32 256s70-166 160-181.2V24c0-13.3 10.7-24 24-24z"]
};
var faSwordsLaser = {
  prefix: 'far',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M204.6 250.7l42.9-39.3 50.7 55.5-37 40.5L281 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-.7-.7-59 59L105 501.7C98.3 508.3 89.4 512 80 512s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l82.3-82.3 0 0 0 0 59-59-.7-.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l19.7 19.7zM505.7 40.2l-115.3 126-46.7-42.7L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7s9.4 23.7 .7 33.2zM177.1 361.6l-26.7-26.7-12.4 12.4 26.7 26.7 12.4-12.4zm-61.8 8.3L53.3 432 80 458.7l62.1-62.1-26.7-26.7zM173 312.3L199.7 339l12.7-12.7-26.7-26.7L173 312.3zM135 7c9.1-9.1 23.7-9.4 33.2-.7L360 181.8V286.9L134.3 40.2c-8.7-9.5-8.3-24.1 .7-33.2zM626.8 459.8l-39 39c-8.4 8.4-19.9 13.2-31.8 13.2s-23.4-4.7-31.8-13.2L398.1 372.7c-9-9-14.1-21.2-14.1-33.9V211.3c0-21.4 25.9-32.1 41-17L626.8 396.2c8.4 8.4 13.2 19.9 13.2 31.8s-4.7 23.4-13.2 31.8zM590.7 428l-66.1-66.1-34.7 34.7L556 462.7 590.7 428zm-88.7-88.7L432 269.3v69.5l35.3 35.3 34.7-34.7z"]
};
var faFlask = {
  prefix: 'far',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M176 196.8c0 20.7-5.8 41-16.6 58.7L119.7 320H328.3l-39.7-64.5c-10.9-17.7-16.6-38-16.6-58.7V48H176V196.8zM320 48V196.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h40H288h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8z"]
};
var faPersonPregnant = {
  prefix: 'far',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M240 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 352c0 17.7 14.3 32 32 32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h16 16V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h48 16c17.7 0 32-14.3 32-32V320c0-46.8-33.4-85.7-77.7-94.3l-6.1-32.5c-6.8-36.1-37.1-62.7-73.3-65.1c-1-.1-1.9-.2-2.9-.2h-2.4H176h-4.7c-32.5 0-62.3 17.9-77.6 46.5L34.8 284.7c-6.2 11.7-1.8 26.2 9.9 32.5s26.2 1.8 32.5-9.9L96 272.1V352zm80-176h13.6c15.4 0 28.6 11 31.5 26.1l6.1 32.5c3.6 19.4 18.7 34.5 38.1 38.3c22.1 4.3 38.8 23.8 38.8 47.1v16H192 144V208c0-17.7 14.3-32 32-32z"]
};
var faSquareU = {
  prefix: 'far',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64V280c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-13.3 10.7-24 24-24s24 10.7 24 24V280c0 61.9-50.1 112-112 112s-112-50.1-112-112V160c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faWandSparkles = {
  prefix: 'far',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M455.9 49.3c.9-.8 2.1-1.3 3.3-1.3c2.7 0 4.9 2.2 4.9 4.9c0 1.2-.4 2.4-1.3 3.3L97.3 459.6c-2.5 2.8-6.1 4.4-9.9 4.4c-3.5 0-6.9-1.4-9.4-3.9L51.9 434c-2.5-2.5-3.9-5.9-3.9-9.4c0-3.8 1.6-7.3 4.4-9.9L455.9 49.3zM459.1 0C446 0 433.4 4.9 423.6 13.7l-263 238.2c-2.9 2.7-6.8 4.1-10.7 4.1H112c-8.8 0-16 7.2-16 16v31.3c0 4.5-1.9 8.8-5.3 11.9L20.2 379.1C7.3 390.7 0 407.2 0 424.5c0 16.3 6.5 31.9 18 43.4L44.1 494c11.5 11.5 27.1 18 43.4 18c17.3 0 33.8-7.3 45.4-20.2L399.7 197.3c3-3.3 7.3-5.3 11.9-5.3H432c8.8 0 16-7.2 16-16V150.1c0-4 1.5-7.8 4.1-10.7l46.2-51C507.1 78.6 512 66 512 52.9C512 23.7 488.3 0 459.1 0zM432 288c-3.6 0-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7c-1-3.4-4.1-5.8-7.7-5.8zM87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8L57.5 121.5 5.8 136.3c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8L87.7 69.8zM208 0c-3.7 0-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6 .9-6.1 4.1-6.1 7.8s2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8L215.8 6.1C214.9 2.5 211.7 0 208 0z"]
};
var faRouter = {
  prefix: 'far',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M198.6 105.9c-9.9 8.8-25.1 7.8-33.9-2.1s-7.8-25.1 2.1-33.9C216.2 26.4 281.1 0 352 0s135.8 26.4 185.1 69.9c9.9 8.8 10.9 23.9 2.1 33.9s-23.9 10.9-33.9 2.1C464.5 69.8 410.8 48 352 48s-112.5 21.8-153.4 57.9zM64 352c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64zM0 368c0-35.3 28.7-64 64-64H328V248c0-13.3 10.7-24 24-24s24 10.7 24 24v56H512c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V368zm104 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 160c-28.6 0-54.9 10-75.5 26.7c-10.3 8.3-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C275.2 126 312 112 352 112s76.8 14 105.7 37.4c10.3 8.3 11.9 23.5 3.5 33.8s-23.5 11.9-33.8 3.5C406.9 170 380.6 160 352 160z"]
};
var faEllipsisVertical = {
  prefix: 'far',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"]
};
var faEllipsisV = faEllipsisVertical;
var faSwordLaserAlt = {
  prefix: 'far',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232H330.2L505.7 40.2zM13.2 459.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2L310.6 304l1.1-1.1 8.3-8.3 11.3-11.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H304 292.3h-1.5H173.3c-12.7 0-24.9 5.1-33.9 14.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8zM242.7 304l-70.1 70.1-34.7-34.7L173.3 304h69.5zm-92.7 92.7L84 462.7 49.3 428l66.1-66.1 34.7 34.7z"]
};
var faTicket = {
  prefix: 'far',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M64 64C28.7 64 0 92.7 0 128v60.1c0 10.2 6.4 19.2 16 22.6c18.7 6.6 32 24.4 32 45.3s-13.3 38.7-32 45.3c-9.6 3.4-16 12.5-16 22.6V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V323.9c0-10.2-6.4-19.2-16-22.6c-18.7-6.6-32-24.4-32-45.3s13.3-38.7 32-45.3c9.6-3.4 16-12.5 16-22.6V128c0-35.3-28.7-64-64-64H64zM48 128c0-8.8 7.2-16 16-16H512c8.8 0 16 7.2 16 16v44.9c-28.7 16.6-48 47.6-48 83.1s19.3 66.6 48 83.1V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V339.1c28.7-16.6 48-47.6 48-83.1s-19.3-66.6-48-83.1V128zM400 304H176V208H400v96zM128 192V320c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"]
};
var faPowerOff = {
  prefix: 'far',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM134.2 107.3c10.7-7.9 12.9-22.9 5.1-33.6s-22.9-12.9-33.6-5.1C46.5 112.3 8 182.7 8 262C8 394.6 115.5 502 248 502s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3c-10.7-7.9-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6c47.5 35 78.2 91.2 78.2 154.7c0 106-86 192-192 192S56 368 56 262c0-63.4 30.7-119.7 78.2-154.7z"]
};
var faCoin = {
  prefix: 'far',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M98.5 268C59.1 245.8 48 222.7 48 208s11.1-37.8 50.5-60c37.9-21.3 93.5-36 157.5-36s119.6 14.7 157.5 36c39.4 22.2 50.5 45.3 50.5 60s-11.1 37.8-50.5 60C375.6 289.3 320 304 256 304s-119.6-14.7-157.5-36zM256 64C114.6 64 0 128.5 0 208l0 48 0 64c0 70.7 114.6 128 256 128s256-57.3 256-128l0-64 0-48c0-79.5-114.6-144-256-144zM216 350.3c13 1.1 26.4 1.7 40 1.7s27-.6 40-1.7l0 48c-12.9 1.1-26.3 1.7-40 1.7s-27.1-.6-40-1.7l0-48zm-32-4l0 48.1c-23.7-3.9-45.3-9.6-64-16.6l0-47.7c19.7 7 41.2 12.5 64 16.2zM48 292c11.6 9.1 25 17.4 40 24.7l0 46.5C54.2 344.2 48 326.8 48 320l0-28zM328 394.3l0-48.1c22.8-3.8 44.3-9.2 64-16.2l0 47.7c-18.7 7-40.3 12.7-64 16.6zm96-31.2l0-46.5c15-7.3 28.4-15.6 40-24.7l0 28c0 6.8-6.2 24.2-40 43.1zM256 184c40.2 0 75.7 5.2 100.3 12.9c11.8 3.7 19.9 7.7 24.7 11.1c-4.8 3.4-12.9 7.3-24.7 11.1c-24.6 7.8-60 12.9-100.3 12.9s-75.7-5.2-100.3-12.9c-11.8-3.7-19.9-7.7-24.7-11.1c4.8-3.4 12.9-7.3 24.7-11.1c24.6-7.8 60-12.9 100.3-12.9zm128.8 27.4a.2 .2 0 1 0 -.4 .1 .2 .2 0 1 0 .4-.1zm-.1-6.6a.2 .2 0 1 0 -.1-.5 .2 .2 0 1 0 .1 .5zm-257.4-.2a.2 .2 0 1 0 .4-.1 .2 .2 0 1 0 -.4 .1zm.1 6.6a.2 .2 0 1 0 .1 .5 .2 .2 0 1 0 -.1-.5zM432 208c0-17.7-11.3-30.3-21.6-37.9c-10.7-8-24.6-14.2-39.7-18.9c-30.4-9.6-71-15.2-114.7-15.2s-84.3 5.6-114.7 15.2c-15.1 4.8-29 10.9-39.7 18.9C91.3 177.7 80 190.3 80 208s11.3 30.3 21.6 37.9c10.7 8 24.6 14.2 39.7 18.9c30.4 9.6 71 15.2 114.7 15.2s84.3-5.6 114.7-15.2c15.1-4.8 29-10.9 39.7-18.9c10.3-7.7 21.6-20.2 21.6-37.9z"]
};
var faLaptopSlash = {
  prefix: 'far',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-20.3-15.9c18.2-17.5 29.5-42 29.5-69.2c0-17.7-14.3-32-32-32H481.4L134.4 80H512c8.8 0 16 7.2 16 16V320h48V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM542.6 400h46.6c-3.3 9.3-9.4 17.3-17.3 23l-29.4-23zM426.3 432H96c-20.9 0-38.7-13.4-45.3-32H385.7l-60.9-48H32c-17.7 0-32 14.3-32 32c0 53 43 96 96 96H487.2l-60.9-48zM112 184.4L64 146.6V320h48V184.4z"]
};
var faRightLong = {
  prefix: 'far',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", "M505.5 239.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6c-25.6 0-46.3-20.7-46.3-46.3l0-33.7L56 336c-30.9 0-56-25.1-56-56l0-48c0-30.9 25.1-56 56-56l248 0 0-33.7c0-25.6 20.7-46.3 46.3-46.3c12.8 0 25 5.3 33.7 14.6l121.4 129zM352 146.5l0 53.5c0 13.3-10.7 24-24 24L56 224c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l272 0c6.4 0 12.5 2.5 17 7s7 10.6 7 17l0 53.5L455 256 352 146.5z"]
};
var faLongArrowAltRight = faRightLong;
var faCircleB = {
  prefix: 'far',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V256 360c0 13.3 10.7 24 24 24H292c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76H184c-13.3 0-24 10.7-24 24zm144 52c0 15.5-12.5 28-28 28H208V176h68c15.5 0 28 12.5 28 28zM208 336V280h68 16c15.5 0 28 12.5 28 28s-12.5 28-28 28H208z"]
};
var faPersonDressSimple = {
  prefix: 'far',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM96.9 219.6L63.6 336H192.4L159.1 219.6c-2-6.9-8.2-11.6-15.4-11.6H112.3c-7.1 0-13.4 4.7-15.4 11.6zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H112V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z"]
};
var faPipeCollar = {
  prefix: 'far',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M109.3 18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L35.4 126C12.9 164.1 0 208.5 0 256s12.9 91.9 35.4 130L18.7 402.7c-25 25-25 65.5 0 90.5s65.5 25 90.5 0L126 476.6c38.1 22.5 82.6 35.4 130 35.4s91.9-12.9 130-35.4l16.7 16.7c25 25 65.5 25 90.5 0s25-65.5 0-90.5L476.6 386c22.5-38.1 35.4-82.6 35.4-130s-12.9-91.9-35.4-130l16.7-16.7c25-25 25-65.5 0-90.5s-65.5-25-90.5 0L386 35.4C347.9 12.9 303.5 0 256 0s-91.9 12.9-130 35.4L109.3 18.7zM48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM48 64a16 16 0 1 1 32 0A16 16 0 1 1 48 64zm0 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm400-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faLightsHoliday = {
  prefix: 'far',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", "M35.3 66.8l0 0 .1 0 .6 .3c.6 .3 1.7 .8 3.1 1.5c2.8 1.4 7.3 3.4 13.2 5.8c11.9 4.9 30 11.6 54.1 18.3C154.5 106.3 226.4 120 320 120s165.5-13.7 213.5-27.1c24-6.7 42.1-13.4 54.1-18.3c6-2.5 10.4-4.5 13.2-5.8c1.4-.7 2.5-1.2 3.1-1.5l.6-.3 0 0 0 0c11.7-6.3 26.2-1.9 32.5 9.8s1.9 26.2-9.8 32.5L616 88c11.4 21.1 11.4 21.1 11.4 21.1l0 0 0 0-.1 .1-.4 .2-1.2 .6c-1 .5-2.4 1.2-4.2 2c-3.6 1.7-8.8 4.1-15.6 6.9c-13.6 5.6-33.5 12.9-59.4 20.2C494.5 153.7 418.4 168 320 168s-174.5-14.3-226.5-28.9c-26-7.3-45.9-14.6-59.4-20.2c-6.8-2.8-12-5.2-15.6-6.9c-1.8-.9-3.2-1.5-4.2-2l-1.2-.6-.4-.2-.1-.1 0 0 0 0s0 0 11.4-21.1L12.6 109.1C1 102.8-3.4 88.3 2.9 76.6c6.3-11.7 20.8-16 32.5-9.8zm80 155.3L130 181c14.8 3.1 30.7 6.1 47.9 8.7l-17.3 48.6c27.2 20.5 39.2 56.9 27.2 90.7c-16.1 45.2-95.7 101.8-118.3 93.8s-48.6-102.2-32.5-147.4c12-33.7 44.4-54.4 78.3-53.1zM296 259.7V199.7c7.9 .2 15.9 .3 24 .3s16.1-.1 24-.3v59.9c32.5 10.2 56 40.5 56 76.3c0 48-56 128-80 128s-80-80-80-128c0-35.8 23.5-66.1 56-76.3zm183.4-21.4l-17.3-48.6c17.1-2.6 33.1-5.5 47.9-8.7l14.7 41.2c34-1.3 66.3 19.4 78.3 53.1c16.1 45.2-9.8 139.4-32.5 147.4s-102.2-48.6-118.3-93.8c-12-33.7 0-70.2 27.2-90.7zM82.2 291.4c-1.2 3.4-2.6 11-2.1 23.3c.4 11.6 2.3 24.6 5.3 37c1.3 5.3 2.7 10.2 4.2 14.6c3.9-2.5 8.1-5.4 12.5-8.7c10.2-7.7 19.9-16.6 27.5-25.4c8-9.2 11.8-16 13-19.4c5.9-16.7-2.8-35-19.4-40.9s-35 2.8-40.9 19.4zM288 336c0 3.6 1.3 11.3 5.8 22.6c4.3 10.8 10.4 22.4 17.4 33.1c3 4.6 6 8.7 8.8 12.4c2.8-3.7 5.8-7.8 8.8-12.4c7-10.7 13.1-22.3 17.4-33.1c4.5-11.4 5.8-19 5.8-22.6c0-17.7-14.3-32-32-32s-32 14.3-32 32zm228.9-64c-16.7 5.9-25.3 24.2-19.4 40.9c1.2 3.4 5 10.2 13 19.4c7.6 8.8 17.3 17.6 27.5 25.4c4.4 3.3 8.6 6.2 12.5 8.7c1.5-4.4 2.9-9.3 4.2-14.6c3-12.4 4.9-25.4 5.3-37c.4-12.2-.9-19.9-2.1-23.3c-5.9-16.7-24.2-25.3-40.9-19.4z"]
};
var faCitrus = {
  prefix: 'far',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M304 128h80c53 0 96-43 96-96V16c0-8.8-7.2-16-16-16H384c-31 0-58.7 14.7-76.2 37.6c-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7c-13.5 9.1-28.8 15.7-45.3 19.1c23.9 32 38 71.7 38 114.6c0 106-86 192-192 192S64 378 64 272S150 80 256 80c11.2 0 22.2 1 32.9 2.8c-.6 4.3-.9 8.7-.9 13.2v16c0 8.8 7.2 16 16 16z"]
};
var faFlagUsa = {
  prefix: 'far',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M24 0C37.3 0 48 10.7 48 24V52l85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v66.2 51.3 52.7 51.3 74.2c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 404l0 84c0 13.3-10.7 24-24 24s-24-10.7-24-24V416 366.5 313.2 264 217.2 168 64 24C0 10.7 10.7 0 24 0zM400 93c-56.4 22.9-120.2 20.6-175-6.8c-15.3-7.7-32.1-11.8-49-12.3v60.7c18.8 .6 37.5 3.6 55.6 9l49.3 14.8c35.2 10.6 72.9 9.3 107.3-3.6l11.8-4.4V93zM48 252.9l68.5-15.8c39.8-9.2 81.4-6.9 119.9 6.6l41.9 14.7c37.1 13 77.6 12.5 114.5-1.3l7.3-2.7V201.6c-42.9 14.9-89.4 15.9-132.9 2.8l-49.3-14.8c-28-8.4-57.6-9.3-86.1-2.8L48 206.2v46.7zm0 49.3v52.4l68.6-17.2c52.2-13.1 107.4-7 155.6 17.1c32.2 16.1 69.7 18.1 103.4 5.4l24.4-9.1V305.4c-44.7 14.4-93.1 13.9-137.6-1.7L220.5 289c-30-10.5-62.3-12.3-93.3-5.1L48 302.2zM96 104a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 152a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLaptopFile = {
  prefix: 'far',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", "M448 48H128c-8.8 0-16 7.2-16 16V320H320v64H48c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16H64V64C64 28.7 92.7 0 128 0H448c35.3 0 64 28.7 64 64V96H464V64c0-8.8-7.2-16-16-16zM400 464H592V256H544c-17.7 0-32-14.3-32-32V176l-112 0V464zm192 48H400c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48H524.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48z"]
};
var faTty = {
  prefix: 'far',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M370 188.8v25.9l76.6 16.9 15.8-53.4c3.3-11.2-.3-17.4-2.5-19.4C421 123.4 349.4 80 256 80s-165 43.4-203.9 78.6c-2.2 2-5.8 8.2-2.5 19.4l15.8 53.4L142 214.6V188.8c0-19.5 11.8-37.1 29.9-44.5c53.9-21.9 114.2-21.9 168.1 0c18.1 7.4 29.9 24.9 29.9 44.5zm-48 25.9V188.8c-42.3-17.2-89.7-17.2-132 0v25.9c0 22.5-15.7 42-37.7 46.9L75.7 278.4c-24.6 5.4-49.2-9.1-56.4-33.3L3.5 191.7c-7.2-24.5-2.6-51.4 16.3-68.6C64.9 82.2 147.6 32 256 32s191.1 50.2 236.2 91.1c18.9 17.2 23.5 44.1 16.3 68.6l-15.8 53.4c-7.1 24.2-31.8 38.7-56.4 33.3l-76.6-16.9c-22-4.8-37.7-24.3-37.7-46.9zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"]
};
var faTeletype = faTty;
var faChartTreeMap = {
  prefix: 'far',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M176 80V192H48L48 80H176zM48 32C21.5 32 0 53.5 0 80V192c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM176 320V432H48l0-112H176zM48 272c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H176c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H48zM304 80H464v32H304V80zm-48 0v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM464 240v32H304V240H464zM304 192c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H304zm0 208H464v32H304V400zm-48 0v32c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48z"]
};
var faDiagramNext = {
  prefix: 'far',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", "M448 224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H232v86.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V224H448zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64l-74.3 0c4.8 16 2.2 33.8-7.7 48h82c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368 144l-80 0c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16h82c-9.9-14.2-12.5-32-7.7-48L64 288z"]
};
var faPersonRifle = {
  prefix: 'far',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", "M240 0c-44.2 0-80 35.8-80 80s35.8 80 80 80c43.9 0 79.5-35.3 80-79V79c-.5-43.7-36.1-79-80-79zm20.7 192H219.3c-45.5 0-87 25.7-107.3 66.3L34.5 413.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L152 285.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24V242.6c6.2-1.7 12.7-2.6 19.3-2.6h41.3c3.8 0 7.6 .3 11.3 .9V488c0 13.3 10.7 24 24 24s24-10.7 24-24V271.2 207.7c-17.8-10.1-38.1-15.7-59.3-15.7zM208 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32H384c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32h32v48 64c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16H432 416zm16 336H416 400V240h32v96z"]
};
var faClockFiveThirty = {
  prefix: 'far',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V335.3l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faPipeValve = {
  prefix: 'far',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V77L128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l104-13v77H48v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v32V424v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V424 216 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H280V115l104 13c17.7 0 32-14.3 32-32s-14.3-32-32-32L280 77V56zM48 400V240H256 464V400H48z"]
};
var faArrowUpFromArc = {
  prefix: 'far',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 464C141.1 464 48 370.9 48 256c0-13.3-10.7-24-24-24s-24 10.7-24 24C0 397.4 114.6 512 256 512s256-114.6 256-256c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 114.9-93.1 208-208 208zM134.4 119.7c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3L232 85.1 232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-242.9 62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9l-104-112C269 2.8 262.7 0 256 0s-13 2.8-17.6 7.7l-104 112z"]
};
var faFaceSpiralEyes = {
  prefix: 'far',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M464 256c0-114.9-93.1-208-208-208c-71 0-133.6 35.5-171.1 89.8c18.5-21.6 45.8-36.5 76.6-37.7c6.6-.3 12.2 4.9 12.5 11.5s-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-1.2-11.3 0-22.5 3-33.3C53.5 201.5 48 228.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm338.1 48.5c-.3-6.6 4.9-12.2 11.5-12.5c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5zm-35.9 46.6l6.7-4.5c22.2-14.8 51.8-11.9 70.7 7L385 359c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-5.4-5.4c-2.7-2.7-6.9-3.1-10.1-1l-6.7 4.5c-20.3 13.5-47 12.4-66-2.9l-1.7-1.4c-2.9-2.3-7.1-2.3-10 0l-1.7 1.4c-19 15.2-45.8 16.4-66 2.9l-6.7-4.5c-3.2-2.1-7.4-1.7-10.1 1L161 393c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l5.4-5.4c18.9-18.9 48.5-21.8 70.7-7l6.7 4.5c2.9 1.9 6.7 1.8 9.4-.4l1.7-1.4c20.5-16.4 49.5-16.4 70 0l1.7 1.4c2.7 2.2 6.5 2.3 9.4 .4z"]
};
var faCompressWide = {
  prefix: 'far',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M160 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H136c13.3 0 24-10.7 24-24V88zM24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V312c0-13.3-10.7-24-24-24H24zM400 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V200c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H400V88zM376 288c-13.3 0-24 10.7-24 24V424c0 13.3 10.7 24 24 24s24-10.7 24-24V336h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"]
};
var faCirclePhoneHangup = {
  prefix: 'far',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM391.4 294l21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8c-84.9-78.6-222.6-78.6-307.5 0c-6.8 6.3-8.2 16.1-3.4 23.8L120.6 294c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3L203.7 238c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6c9.9 3.8 21.4 .2 26.7-8.5z"]
};
var faPhoneCircleDown = faCirclePhoneHangup;
var faGearComplexCode = {
  prefix: 'far',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M188.2 36.7C193.4 15.2 212.7 0 234.9 0h42.2c22.2 0 41.5 15.2 46.7 36.7L332 71l1.1 .4 30-18.4c18.9-11.6 43.3-8.7 59 7l29.8 29.8c15.7 15.7 18.6 40.1 7 59l-18.4 30 .4 1.1 34.2 8.3c21.6 5.2 36.7 24.5 36.7 46.7v42.2c0 22.2-15.2 41.5-36.7 46.7L441 332l-.4 1.1 18.4 30c11.6 18.9 8.7 43.3-7 59l-29.8 29.8c-15.7 15.7-40.1 18.6-59 7l-30-18.4L332 441l-8.3 34.2c-5.2 21.6-24.5 36.7-46.7 36.7H234.9c-22.2 0-41.5-15.2-46.7-36.7L180 441l-1.1-.4-30 18.4c-18.9 11.6-43.3 8.7-59-7L60.1 422.1c-15.7-15.7-18.6-40.1-7-59l18.4-30L71 332l-34.2-8.3C15.2 318.6 0 299.3 0 277.1V234.9c0-22.2 15.2-41.5 36.7-46.7L71 180l.4-1.1L53 148.9c-11.6-18.9-8.7-43.3 7-59L89.9 60.1c15.7-15.7 40.1-18.6 59-7l30 18.4L180 71l8.3-34.2zM277.1 48l-42.2 0L223.6 94.6c-1.9 8-7.9 14.5-15.7 17.1c-6.8 2.3-13.5 5-19.9 8.2c-7.4 3.7-16.2 3.3-23.3-1L123.8 94 94 123.8l25 40.9c4.3 7.1 4.7 15.9 1 23.3c-3.2 6.4-6 13-8.2 19.9c-2.6 7.9-9.1 13.8-17.1 15.7L48 234.9l0 42.2 46.6 11.3c8 1.9 14.5 7.9 17.1 15.7c2.3 6.8 5 13.5 8.2 19.9c3.7 7.4 3.3 16.2-1 23.3L94 388.2 123.8 418l40.9-25c7.1-4.3 15.9-4.7 23.3-1c6.4 3.2 13 6 19.9 8.2c7.9 2.6 13.8 9.1 15.7 17.1L234.9 464h42.2l11.3-46.6c1.9-8 7.9-14.5 15.7-17.1c6.8-2.3 13.5-5 19.9-8.2c7.4-3.7 16.2-3.3 23.3 1l40.9 25L418 388.2l-25-40.9c-4.3-7.1-4.7-15.9-1-23.3c3.2-6.4 6-13 8.2-19.9c2.6-7.9 9.1-13.8 17.1-15.7L464 277.1V234.9l-46.6-11.3c-8-1.9-14.5-7.9-17.1-15.7c-2.3-6.8-5-13.5-8.2-19.9c-3.7-7.4-3.3-16.2 1-23.3l25-40.9L388.2 94l-40.9 25c-7.1 4.3-15.9 4.7-23.3 1c-6.4-3.2-13-6-19.9-8.2c-7.9-2.6-13.8-9.1-15.7-17.1L277.1 48zm14.6 115.3l-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3l40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L339.7 256l-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"]
};
var faHouseMedicalCircleExclamation = {
  prefix: 'far',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32H348.5c12.3 18.8 28 35.1 46.3 48H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faBadminton = {
  prefix: 'far',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M228.9 100.9C193.7 136.1 176 180.4 176 221c0 31.9 10.9 61.1 32.4 82.6c48.2 48.2 138.8 43.5 202.7-20.5C446.3 247.9 464 203.6 464 163c0-31.9-10.9-61.1-32.4-82.6S380.8 48 349 48c-40.6 0-84.9 17.7-120.1 52.9zM194.9 66.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-56.3 56.3-137 80.2-204.8 59.8c-27.3-8.2-58.7-7.8-80.5 9.7c11.3 12.6 10.9 31.9-1.2 44l-72 72c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l72-72c12.1-12.1 31.4-12.5 44-1.2c17.5-21.8 18.1-53.3 9.9-80.6c-4.9-16.3-7.3-33.4-7.3-50.6c0-54.2 23.4-110.5 66.9-154zM104 398.6L54.6 448l9.4 9.4L113.4 408l-9.4-9.4zM512 352c26.5 0 48 21.5 48 48v32H464V400c0-26.5 21.5-48 48-48zm-50.3 96h33.4l-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9l13-43.4zm34.3 0h32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448zm32.9 0h33.4l13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7L528.9 448z"]
};
var faClosedCaptioning = {
  prefix: 'far',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"]
};
var faPersonHiking = {
  prefix: 'far',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", "M288 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM136.5 125.8c3.8-15.1-7.7-29.8-23.3-29.8h-4.2C73 96 41.4 120.1 31.9 155L7 246.4c-3.7 13.7 5.2 27.7 19.2 30l47.9 8c12.3 2.1 24.2-5.7 27.2-17.9l35.2-140.7zM384 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v24H308.8l-28.7-43.1c-11.2-16.9-28.6-28.7-48.5-32.9c-32-6.9-63.6 13.3-70.9 45.2l-19.8 86.5c-4.7 20.4 2.4 41.7 18.4 55.2L240 387.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V383.4c0-11.8-5.2-22.9-14.2-30.5l-27.5-23.2 22.4-95.2 2.5 3.7c7.4 11.1 19.9 17.8 33.3 17.8H336V488c0 13.3 10.7 24 24 24s24-10.7 24-24V184zm-162.4-5.1c3.6 .8 7 2.2 10 4.1L205.3 294.9l-14.9-12.6c-2.3-1.9-3.3-5-2.6-7.9l19.8-86.5c1.4-6.3 7.7-10.3 14.1-9zM80.9 481.5c-3.6 12.8 3.8 26 16.6 29.6s26-3.8 29.6-16.6l36.7-130-24.8-21c-5.6-4.7-10.5-10.1-14.6-15.8L80.9 481.5z"]
};
var faHiking = faPersonHiking;
var faRightFromLine = {
  prefix: 'far',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", "M288 146.2L398 256 288 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM448 256c0-11.5-4.6-22.5-12.7-30.6L319.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L435.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88z"]
};
var faArrowAltFromLeft = faRightFromLine;
var faVenusDouble = {
  prefix: 'far',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM368 176c0 89.1-66.2 162.7-152 174.4V400h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V350.4C82.2 338.7 16 265.1 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c10.9-11.7 20.5-24.6 28.5-38.6C393.7 294.9 419.8 304 448 304c70.7 0 128-57.3 128-128s-57.3-128-128-128c-28.2 0-54.3 9.1-75.5 24.6c-8-14-17.6-26.9-28.5-38.6C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 89.1-66.2 162.7-152 174.4V400h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H472v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V350.4c-29.7-4-57-15.5-80-32.4z"]
};
var faImages = {
  prefix: 'far',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCalculator = {
  prefix: 'far',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M336 176V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V176H336zm0-48H48V64c0-8.8 7.2-16 16-16H320c8.8 0 16 7.2 16 16v64zm48 0V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v64 24 24V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V176 152 128zM80 232a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM80 408c0 13.3 10.7 24 24 24h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H104c-13.3 0-24 10.7-24 24zM192 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM168 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM280 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM256 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
var faShuttlecock = {
  prefix: 'far',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M247 48l-43.3 89.2L280 97.4V48H247zM168.5 209.6l-38.9 80L159 319l75.9-75.9 25.7-81.5-92.1 48zM328 40V80h72c17.7 0 32 14.3 32 32v72h40c22.1 0 40 17.9 40 40v46c0 15.3-8.7 29.3-22.5 36l-242 117.5c-.7 1.4-1.7 2.7-2.8 3.8l-51.5 51.5c-21.2 21.2-50 33.1-80 33.1C50.7 512 0 461.3 0 398.9c0-30 11.9-58.8 33.1-80l51.5-51.5c1.2-1.2 2.5-2.1 3.8-2.8L206 22.5C212.7 8.7 226.7 0 242 0h46c22.1 0 40 17.9 40 40zM222.3 382.3l80-38.9 48-92.1-81.5 25.7L193 353l29.4 29.4zm70.4-163.1L384 190.4V128H321.6l-28.8 91.2zM188.1 416L96 323.9 73.3 346.6l92.1 92.1L188.1 416zm-48.4 42.3l-86-86C50 380.6 48 389.6 48 398.9c0 36 29.2 65.1 65.1 65.1c9.2 0 18.3-2 26.6-5.7zm235.1-150L464 265V232H414.6l-39.7 76.3z"]
};
var faUserHair = {
  prefix: 'far',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM49.6 464H398.4c-9.3-54.5-56.8-96-113.9-96H163.6c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"]
};
var faEyeEvil = {
  prefix: 'far',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M288.4 115.5L320 65l31.6 50.6c6.3 10 16 17.4 27.4 20.7c10.6 3.1 20.6 6.9 30 11.4c11 5.3 23.5 6.2 35.2 2.6l27.7-8.6-2.3 3.6c-10.6 16.2-10.5 37.1 .3 53.2c4.2 6.2 7.6 12.5 10.3 19c5.2 12.4 15.4 22 28.1 26.5L542.1 256l-33.9 12.1c-12.7 4.5-22.8 14.1-28.1 26.5c-2.7 6.5-6.2 12.8-10.3 19c-10.8 16.1-10.9 37-.3 53.2l2.3 3.6-27.7-8.6c-11.6-3.6-24.2-2.7-35.2 2.6c-9.4 4.5-19.4 8.4-30 11.4c-11.4 3.3-21.1 10.6-27.4 20.7L320 447l-31.6-50.6c-6.3-10-16-17.4-27.4-20.7c-10.6-3.1-20.6-6.9-30-11.4c-11-5.3-23.5-6.2-35.2-2.6l-27.7 8.6 2.3-3.6c10.6-16.2 10.5-37.1-.3-53.2c-4.2-6.2-7.6-12.5-10.3-19c-5.2-12.4-15.4-22-28.1-26.5L97.9 256l33.9-12.1c12.7-4.5 22.8-14.1 28.1-26.5c2.7-6.5 6.2-12.8 10.3-19c10.8-16.1 10.9-37 .3-53.2l-2.3-3.6 27.7 8.6c11.6 3.6 24.2 2.7 35.2-2.6c9.4-4.5 19.4-8.4 30-11.4c11.4-3.3 21.1-10.6 27.4-20.7zM392.3 90.1L344.5 13.6C339.2 5.1 330 0 320 0s-19.2 5.1-24.5 13.6L247.7 90.1c-13.1 3.8-25.7 8.6-37.5 14.3L114.9 74.7c-9.2-2.9-19.1 .3-24.9 8s-6.1 18.1-.8 26.1l41.3 62.7c-5.8 8.6-10.7 17.7-14.7 27.1L15.1 234.6C6 237.8 0 246.4 0 256s6 18.2 15.1 21.4l100.6 35.9c4 9.4 8.9 18.5 14.7 27.1L89.2 403.2c-5.3 8-4.9 18.5 .8 26.1s15.7 10.9 24.9 8l95.3-29.8c11.8 5.7 24.4 10.5 37.5 14.3l47.8 76.5C300.8 506.9 310 512 320 512s19.2-5.1 24.5-13.6l47.8-76.5c13.1-3.8 25.7-8.6 37.5-14.3l95.3 29.8c9.2 2.9 19.1-.3 24.9-8s6.1-18.1 .8-26.1l-41.3-62.7c5.8-8.6 10.7-17.7 14.7-27.1l100.6-35.9c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4L524.3 198.7c-4-9.4-8.9-18.5-14.7-27.1l41.3-62.7c5.3-8 4.9-18.5-.8-26.1s-15.7-10.9-24.9-8l-95.3 29.8c-11.8-5.7-24.4-10.5-37.5-14.3zM256 245.5c12 4 24.5 7 37.3 8.7c.1 .4 .2 .7 .4 1.1c5.5 14.4 13.5 24.4 18.1 29.3c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c4.5-4.9 12.6-14.9 18.1-29.3c.1-.4 .3-.7 .4-1.1c12.9-1.7 25.3-4.6 37.3-8.7c0 .8 0 1.6 0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-.8 0-1.6 0-2.5zM246 242l0 0c0 0 .1 0 .1 0l-.1 0c0 0 0 0 0 0zm148 0a.1 .1 0 1 0 -.1-.1 .1 .1 0 1 0 .1 .1zM220.1 219c-2.7 9.2-4.1 18.9-4.1 29c0 57.4 46.6 104 104 104s104-46.6 104-104c0-10-1.4-19.8-4.1-29c-4.9-16.8-25-20.6-41.3-14.1C360.5 212.1 340.7 216 320 216s-40.5-3.9-58.6-11.1c-16.3-6.4-36.4-2.7-41.3 14.1z"]
};
var faPeoplePulling = {
  prefix: 'far',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM48 271.9V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-30.9 25.1-56 56-56h58.4c15.1 0 29.9 3.9 43 11.2l122.5 68.7c17.9-34 48.4-60 85.1-72.3c15.3-5.1 31.3-7.7 47.4-7.7h4.9c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L569 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L506 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3 50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L370 312.6c-18.1-14.7-25.2-39.1-17.8-61.2L375 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2c-6.8-3-11.5-8.8-13.3-15.4L160.5 196l63 286.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3L145.6 352H114.7l28.7 130.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3L48 271.9zM106.9 176H76.1l28.1 128H135L106.9 176zM464 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM397.8 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm-42.1 75.6l39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L297 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4z"]
};
var faN = {
  prefix: 'far',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M15.8 33.4c9.5-3.5 20.1-.6 26.6 7.1L336 390.1V56c0-13.3 10.7-24 24-24s24 10.7 24 24V456c0 10.1-6.3 19.1-15.8 22.6s-20.1 .6-26.6-7.1L48 121.9V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 45.9 6.3 36.9 15.8 33.4z"]
};
var faSwap = {
  prefix: 'far',
  iconName: 'swap',
  icon: [640, 512, [], "e609", "M240 119c0 22.6-18.3 41-41 41H152V360c0 39.8 32.2 72 72 72s72-32.2 72-72V152c0-66.3 53.7-120 120-120s120 53.7 120 120V352h47c22.6 0 41 18.3 41 41c0 10.9-4.3 21.3-12 29l-83 83c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-83-83c-7.7-7.7-12-18.1-12-29c0-22.6 18.3-41 41-41h47V152c0-39.8-32.2-72-72-72s-72 32.2-72 72V360c0 66.3-53.7 120-120 120s-120-53.7-120-120V160H57c-22.6 0-41-18.3-41-41c0-10.9 4.3-21.3 12-29L111 7c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l83 83c7.7 7.7 12 18.1 12 29zM73.9 112l108.1 0L128 57.9 73.9 112zm384 288L512 454.1 566.1 400H457.9z"]
};
var faGarage = {
  prefix: 'far',
  iconName: 'garage',
  icon: [640, 512, [], "e009", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 368V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V232c0-22.1 17.9-40 40-40H504c22.1 0 40 17.9 40 40V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V368H144zm0-48H496V240H144v80zm136 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCableCar = {
  prefix: 'far',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-8a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM432 288v64H352V272h64c8.8 0 16 7.2 16 16zm0 112v48c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V400H184 328 432zM80 352V288c0-8.8 7.2-16 16-16h64v80H80zm128-80h96v80H208V272zM96 224c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H280V147.5l212.9-44c13-2.7 21.3-15.4 18.6-28.4s-15.4-21.3-28.4-18.6l-232 48-232 48c-13 2.7-21.3 15.4-18.6 28.4s15.4 21.3 28.4 18.6l203.1-42V224H96z"]
};
var faTram = faCableCar;
var faShovelSnow = {
  prefix: 'far',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4c-15.1 15.1-35.6 23.6-57 23.6c-13.5 0-26.2-3.3-37.4-9.2L297.9 248l35.3 35.3c19.8 19.8 21.9 51.2 4.9 73.5L236.7 489.9c-10.6 13.9-27.1 22.1-44.5 22.1h-2.9c-14.9 0-29.1-5.9-39.6-16.4L16.4 362.3C5.9 351.8 0 337.6 0 322.7v-2.9c0-17.5 8.2-34 22.1-44.5L155.2 173.9c22.3-17 53.7-14.9 73.5 4.9L264 214.1l81.2-81.2c-5.9-11.2-9.2-23.9-9.2-37.4c0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9L393.5 72.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L454.1 104 408 57.9zM184.3 212L51.2 313.5c-2 1.5-3.2 3.9-3.2 6.4v2.9c0 2.1 .8 4.2 2.3 5.7L183.6 461.7c1.5 1.5 3.5 2.3 5.7 2.3h2.9c2.5 0 4.9-1.2 6.4-3.2L300 327.7c2.4-3.2 2.1-7.7-.7-10.5L194.8 212.7c-2.8-2.8-7.3-3.1-10.5-.7zm5.8 90.1l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm48 48l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
var faCloudRain = {
  prefix: 'far',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM89.2 372L54.2 436.6C50.1 444.1 48 452.5 48 461v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3L102.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm160 0l-35.1 64.6c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm124.9 64.6c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-35.1 64.6z"]
};
var faFaceLying = {
  prefix: 'far',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", "M431.3 368H352c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H288c-13.3 0-24-10.7-24-24s10.7-24 24-24H440c7.7 0 15.1 1.2 22.1 3.4C448.1 126.1 361.2 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c73.6 0 138.3-38.3 175.3-96zm67.4-30.3C464.6 439 368.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 8.8-.4 17.6-1.3 26.2c.9 4.5 1.3 9.1 1.3 13.8c0 15.6-4.9 30-13.3 41.7zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM195.2 390.4c-8 10.6-23 12.7-33.6 4.8s-12.7-23-4.8-33.6C175.7 336.4 206 320 240 320c14.7 0 28.8 3.1 41.6 8.7c12.1 5.3 17.7 19.5 12.4 31.6s-19.5 17.7-31.6 12.4c-6.8-3-14.4-4.6-22.4-4.6c-18.3 0-34.6 8.8-44.8 22.4z"]
};
var faSprinkler = {
  prefix: 'far',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M0 24a24 24 0 1 1 48 0A24 24 0 1 1 0 24zm24 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM512 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM424 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 136a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM97.8 270.8c3.7-9 12.5-14.8 22.2-14.8H232V88c0-13.3 10.7-24 24-24s24 10.7 24 24V256H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89V472c0 22.1-17.9 40-40 40H232c-22.1 0-40-17.9-40-40V385.9l-89-89c-6.9-6.9-8.9-17.2-5.2-26.2zM256 304H177.9l55 55c4.5 4.5 7 10.6 7 17v88h32V376c0-6.4 2.5-12.5 7-17l55-55H256z"]
};
var faBuildingCircleXmark = {
  prefix: 'far',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", "M64 48H320c8.8 0 16 7.2 16 16V294.6c11.1-24.3 27.7-45.5 48-62.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1V448c0 8.8-7.2 16-16 16H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm24 56v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H232zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPersonSledding = {
  prefix: 'far',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", "M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 152c0-13.3 10.7-24 24-24H321.4c35.6 0 53.5 43.1 28.3 68.3L281.9 264H344c22.1 0 40 17.9 40 40v80c0 7.7-3.7 14.6-9.4 19l43.9 22.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 269.3C1.2 263.2-3.4 248.7 2.7 236.9s20.6-16.3 32.4-10.2l124.1 64.4c-4.3-11.5-2.2-25.4 8.8-35.1l90.7-80H152c-13.3 0-24-10.7-24-24zM336 312H199.3L336 383V312z"]
};
var faSledding = faPersonSledding;
var faGameConsoleHandheld = {
  prefix: 'far',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M64 48c-8.8 0-16 7.2-16 16V416c0 26.5 21.5 48 48 48H288c26.5 0 48-21.5 48-48V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zM232 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 288c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H144v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V304c0-8.8 7.2-16 16-16zM112 96H272c8.8 0 16 7.2 16 16V224c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V112c0-8.8 7.2-16 16-16z"]
};
var faShip = {
  prefix: 'far',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h40c30.9 0 56 25.1 56 56V238.4l25.9 9.7c38.1 14.3 48.7 63.2 19.9 92L457 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.9-68.9c4.1-4.1 2.6-11.1-2.8-13.1L290.8 218.7c-1.8-.7-3.8-.7-5.6 0L87 293c-5.4 2-7 9-2.8 13.1L153 375c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L50.2 340.1c-28.8-28.8-18.2-77.7 19.9-92L96 238.4V120c0-30.9 25.1-56 56-56h40V32zm-48 88V220.4l124.3-46.6c12.7-4.8 26.6-4.8 39.3 0L432 220.4V120c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faClockSixThirty = {
  prefix: 'far',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392V256c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faBatterySlash = {
  prefix: 'far',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6C563.1 386 576 362.5 576 336V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H154.8L38.8 5.1zM216 144H496c17.7 0 32 14.3 32 32V336c0 15.9-11.6 29.1-26.7 31.6L216 144zM345.2 368H112c-17.7 0-32-14.3-32-32V176c0-5.1 1.2-10 3.4-14.3l-38-30C36.9 144.4 32 159.6 32 176V336c0 44.2 35.8 80 80 80H406.2l-60.9-48z"]
};
var faTugrikSign = {
  prefix: 'far',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H168V205.3L58.2 232.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5L168 254.7v46.5L58.2 328.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5L168 350.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V338.7l109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 289.3V242.7l109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 193.3V80H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H192 24z"]
};
var faArrowsDownToLine = {
  prefix: 'far',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", "M552 432L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm17-159c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-63 63L472 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L431 377c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L569 273zM249 239c-9.4-9.4-24.6-9.4-33.9 0l-63 63L152 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1L41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L111 377c9.4 9.4 24.6 9.4 33.9 0L249 273c9.4-9.4 9.4-24.6 0-33.9z"]
};
var faDownload = {
  prefix: 'far',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V294.1l-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95V24zM128.8 304H64c-35.3 0-64 28.7-64 64v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V368c0-35.3-28.7-64-64-64H383.2l-48 48H448c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16H176.8l-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faAnglesUpDown = {
  prefix: 'far',
  iconName: 'angles-up-down',
  icon: [448, 512, [], "e60d", "M239 498.7c-8.8 7-21.2 7-30 0L49 370.7c-10.4-8.3-12-23.4-3.7-33.7s23.4-12 33.7-3.8l145 116 145-116c10.4-8.3 25.5-6.6 33.7 3.8s6.6 25.5-3.8 33.7l-160 128zM399 141.3c10.3 8.3 12 23.4 3.7 33.7s-23.4 12-33.7 3.7L224 62.7 79 178.7c-10.4 8.3-25.5 6.6-33.7-3.7s-6.6-25.5 3.7-33.7l160-128c8.8-7 21.2-7 30 0l160 128z"]
};
var faShelves = {
  prefix: 'far',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", "M24 0C37.3 0 48 10.7 48 24V160H592V24c0-13.3 10.7-24 24-24s24 10.7 24 24V184 440v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V464H48v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V440 184 24C0 10.7 10.7 0 24 0zM48 416H592V208H48V416zM352 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V32zM128 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32zm160 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"]
};
var faInventory = faShelves;
var faCloudSnow = {
  prefix: 'far',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM64 352c-13.3 0-24 10.7-24 24v16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H40v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H88V376c0-13.3-10.7-24-24-24zm192 32c-13.3 0-24 10.7-24 24v16H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V472h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V408c0-13.3-10.7-24-24-24zm216-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H472V376z"]
};
var faFaceGrin = {
  prefix: 'far',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrin = faFaceGrin;
var faDeleteLeft = {
  prefix: 'far',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", "M205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H205.3zM528 128V384c0 8.8-7.2 16-16 16H205.3c-4.2 0-8.3-1.7-11.3-4.7L54.6 256 193.9 116.7c3-3 7.1-4.7 11.3-4.7H512c8.8 0 16 7.2 16 16zm-95 47c-9.4-9.4-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9z"]
};
var faBackspace = faDeleteLeft;
var faOven = {
  prefix: 'far',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M352 48c26.5 0 48 21.5 48 48v64H48V96c0-26.5 21.5-48 48-48H352zm48 160V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208H400zM96 0C43 0 0 43 0 96V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96zm32 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 240c-17.7 0-32 14.3-32 32V400c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H112zm32 48H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCloudBinary = {
  prefix: 'far',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM176 216v16c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V216c0-22.1-17.9-40-40-40H216c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8zm72-16c0 8.8 7.2 16 16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm120-16c-22.1 0-40 17.9-40 40v16c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V216c0-22.1-17.9-40-40-40H408zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H408c-4.4 0-8-3.6-8-8V216zM192 320c0 8.8 7.2 16 16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm80 24v16c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V344c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zm88-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H400z"]
};
var faEyeDropper = {
  prefix: 'far',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l0 0 8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9v52.9l-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28h52.9c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6l-33.9-33.9L149.1 425c-4.5 4.5-10.6 7-17 7H80V379.9c0-6.4 2.5-12.5 7-17L217.4 232.6l-33.9-33.9L53.1 329z"]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faCommentCaptions = {
  prefix: 'far',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zM136 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H136zm112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H376c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faCommentsQuestion = {
  prefix: 'far',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM147.9 112.1c5.5-15.4 20.1-25.7 36.4-25.7h41.3c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 181.4v.3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7H184.3c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 244a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z"]
};
var faScribble = {
  prefix: 'far',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M183.3 21.4C198.3 7.7 218 0 238.4 0h1C283.9 0 320 36.1 320 80.6c0 21.4-8.5 41.9-23.6 57L89.5 344.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L374.5 151.6c15.1-15.1 35.6-23.6 57-23.6c44.5 0 80.6 36.1 80.6 80.6c0 21.4-8.5 41.9-23.6 57L384.2 369.8c-10.4 10.3-16.2 24.4-16.2 39c0 30.5 24.7 55.2 55.2 55.2h4.4c5.6 0 11.2-.9 16.6-2.7l36.2-12.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-36.2 12.1c-10.2 3.4-21 5.2-31.8 5.2h-4.4c-57 0-103.2-46.2-103.2-103.2c0-27.4 10.9-53.6 30.2-73L454.5 231.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6c-8.6 0-16.9 3.4-23 9.5L169.5 424.4c-15.1 15.1-35.6 23.6-57 23.6C68.1 448 32 411.9 32 367.4c0-21.4 8.5-41.9 23.6-57L262.5 103.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6h-1c-8.4 0-16.5 3.2-22.7 8.8L40.2 217.7c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L183.3 21.4z"]
};
var faRotateExclamation = {
  prefix: 'far',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M416.5 176c-23.6-25.7-42.6-46.5-63.3-62.8C326.4 92.1 298.2 80 256 80c-77.8 0-145.9 50.4-169.3 119.7c-4.2 12.6-17.9 19.3-30.4 15.1s-19.3-17.9-15.1-30.4C71.3 95.5 157.7 32 256 32c53.9 0 92.3 16.3 126.9 43.5c21.9 17.2 42.9 39.5 65.1 63.8V104c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.5zM280 152V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM40 432c-13.3 0-24-10.7-24-24V312c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H97.9l3 3.3 0 0 0 0c22 24.3 39.8 43.9 59.4 59.6c26.1 21 53.6 33.1 95.8 33.1c77.8 0 145.9-50.4 169.3-119.7c4.2-12.6 17.9-19.3 30.4-15.1s19.3 17.9 15.1 30.4C440.7 416.5 354.3 480 256 480c-53.9 0-91.9-16.4-125.8-43.6c-22.1-17.7-43.4-41-66.2-66.2V408c0 13.3-10.7 24-24 24z"]
};
var faFileCircleCheck = {
  prefix: 'far',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M64 464H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGlass = {
  prefix: 'far',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512H276c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8H24zM57.1 128L50.2 48H333.8l-6.9 80H57.1zm4.1 48H322.8L299.9 442.1C298.8 454.5 288.4 464 276 464H108c-12.5 0-22.8-9.5-23.9-21.9L61.2 176z"]
};
var faLoader = {
  prefix: 'far',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zm0 384c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V408zM0 256c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm408-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H408zM437 75c-9.4-9.4-24.6-9.4-33.9 0l-56.6 56.6c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9zM165.5 380.4c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6zM75 75c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zM380.5 346.5c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.6-56.6z"]
};
var faForward = {
  prefix: 'far',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", "M224 94c0-16.6 13.5-30 30-30c6.3 0 12.5 2 17.6 5.7L502.1 236.6c6.2 4.5 9.9 11.7 9.9 19.4s-3.7 14.9-9.9 19.4L271.7 442.3c-5.1 3.7-11.3 5.7-17.6 5.7c-16.6 0-30-13.4-30-30V318.9L47.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4C13.5 448 0 434.5 0 417.9V94.1C0 77.5 13.5 64 30.1 64c6.2 0 12.2 1.9 17.3 5.4L224 193.1V94zm0 157.7L48 128.5v255L224 260.3v-8.6zM447.1 256L272 129.2V382.8L447.1 256z"]
};
var faUserPilot = {
  prefix: 'far',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M217.9 .8c4-1.1 8.2-1.1 12.2 0l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5v8.4c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 131.7 80 121.6 80 110.9v-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40zM183.2 65.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7zM98.1 168.8c14 5.4 28.5 9.9 43.3 13.4c-.4 3.2-.6 6.5-.6 9.8c0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8c14.8-3.6 29.3-8.1 43.3-13.4c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM50.9 464H188.5c-2.3-1.5-4.5-3.2-6.6-5.1l-65.2-57.1c-31.9 6.7-57.3 30.9-65.7 62.2zm346.1 0c-8.4-31.2-33.8-55.5-65.7-62.2l-65.2 57.1c-2.1 1.9-4.3 3.6-6.6 5.1H397.1zM126.5 352.2c3.9-.2 7.8 1.2 10.7 3.8l76.3 66.7c6 5.3 15 5.3 21.1 0l76.3-66.7c3-2.6 6.8-4.1 10.7-3.8C392.1 356.3 448 414.8 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4c0-71.6 55.9-130.1 126.5-134.2z"]
};
var faMobile = {
  prefix: 'far',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M80 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H80zM16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM160 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faCodePullRequestClosed = {
  prefix: 'far',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", "M144 80A32 32 0 1 0 80 80a32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3V355.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V156.3C55.5 146.1 32 115.8 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM112 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 48c-44.2 0-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V224c0-13.3 10.7-24 24-24s24 10.7 24 24V355.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80zM327 7c9.4-9.4 24.6-9.4 33.9 0l39 39L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L327 41c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faFaceMeh = {
  prefix: 'far',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faMeh = faFaceMeh;
var faAlignCenter = {
  prefix: 'far',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M120 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM96 320c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faBookSkull = {
  prefix: 'far',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM48 432c0 17.7 14.3 32 32 32H368V400H80c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM288 195.2V208c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V195.2c-19.4-11.7-32-30.3-32-51.2c0-35.3 35.8-64 80-64s80 28.7 80 64c0 20.9-12.6 39.5-32 51.2zM224 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM128.8 234.9c2.8-8.4 11.9-12.9 20.2-10.1L240 255.1l90.9-30.3c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2L290.6 272l50.5 16.8c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1L240 288.9l-90.9 30.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L189.4 272l-50.5-16.8c-8.4-2.8-12.9-11.9-10.1-20.2z"]
};
var faBookDead = faBookSkull;
var faIdCard = {
  prefix: 'far',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M528 160V416c0 8.8-7.2 16-16 16H320c0-44.2-35.8-80-80-80H176c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V160H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"]
};
var faDriversLicense = faIdCard;
var faFaceDotted = {
  prefix: 'far',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M256 0c-13.6 0-27 1.1-40 3.1c-13.1 2.1-22 14.3-20 27.4s14.3 22 27.4 20C234 48.9 244.9 48 256 48s22 .9 32.6 2.5c13.1 2.1 25.4-6.9 27.4-20s-6.9-25.4-20-27.4C283 1.1 269.6 0 256 0zM133.7 87.7c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3C83.8 64.7 64.7 83.8 48.9 105.5c-7.8 10.7-5.4 25.7 5.3 33.5s25.7 5.4 33.5-5.3c12.8-17.6 28.4-33.2 46.1-46.1zM406.5 48.9c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5c17.6 12.8 33.2 28.4 46 46.1c7.8 10.7 22.8 13.1 33.5 5.3s13.1-22.8 5.3-33.5c-15.8-21.7-34.9-40.8-56.6-56.6zM50.5 223.4c2.1-13.1-6.9-25.4-20-27.4s-25.4 6.9-27.4 20C1.1 229 0 242.4 0 256s1.1 27 3.1 40c2.1 13.1 14.3 22 27.4 20s22-14.3 20-27.4C48.9 278 48 267.1 48 256s.9-22 2.5-32.6zM508.9 216c-2.1-13.1-14.3-22-27.4-20s-22 14.3-20 27.4c1.7 10.6 2.5 21.5 2.5 32.6s-.9 22-2.5 32.6c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20c2.1-13.1 3.1-26.4 3.1-40s-1.1-27-3.1-40zM87.7 378.3c-7.8-10.7-22.8-13.1-33.5-5.3s-13.1 22.8-5.3 33.5c15.8 21.7 34.9 40.8 56.6 56.6c10.7 7.8 25.7 5.4 33.5-5.3s5.4-25.7-5.3-33.5c-17.6-12.8-33.2-28.4-46.1-46zm375.4 28.2c7.8-10.7 5.4-25.7-5.3-33.5s-25.7-5.4-33.5 5.3c-12.8 17.6-28.4 33.2-46 46c-10.7 7.8-13.1 22.8-5.3 33.5s22.8 13.1 33.5 5.3c21.7-15.8 40.8-34.9 56.6-56.6zm-239.7 55c-13.1-2.1-25.4 6.9-27.4 20s6.9 25.4 20 27.4c13.1 2.1 26.4 3.1 40 3.1s27-1.1 40-3.1c13.1-2.1 22-14.3 20-27.4s-14.3-22-27.4-20C278 463.1 267.1 464 256 464s-22-.9-32.6-2.5zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faFaceWorried = {
  prefix: 'far',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 414.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faOutdent = {
  prefix: 'far',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", "M0 64C0 50.7 10.7 40 24 40H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 88 0 77.3 0 64zM192 192c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24zm24 104H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 448c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM7 268.4C-.8 262-.8 250 7 243.6l94.8-78.1c10.4-8.6 26.2-1.2 26.2 12.4V334.1c0 13.5-15.7 20.9-26.2 12.4L7 268.4z"]
};
var faDedent = faOutdent;
var faHeartCircleExclamation = {
  prefix: 'far',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9l0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2l-.1 .1-.1 .1-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faHouse = {
  prefix: 'far',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H384V312c0-22.1-17.9-40-40-40H232c-22.1 0-40 17.9-40 40V464H144c-17.7 0-32-14.3-32-32zm128 32V320h96V464H240z"]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faVectorCircle = {
  prefix: 'far',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", "M232 88h48V40H232V88zM192 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V49.6c67.8 21 121.4 74.5 142.4 142.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H462.4c-21 67.8-74.5 121.4-142.4 142.4V480c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V462.4C124.2 441.4 70.6 387.8 49.6 320H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H49.6C70.6 124.2 124.2 70.6 192 49.6V32zM100.5 192.3C116 194.5 128 207.9 128 224v64c0 16.1-12 29.5-27.5 31.7c17 41.6 50.3 74.8 91.8 91.8C194.5 396 207.9 384 224 384h64c16.1 0 29.5 12 31.7 27.5c41.6-17 74.8-50.3 91.8-91.8C396 317.5 384 304.1 384 288V224c0-16.1 12-29.5 27.5-31.7c-17-41.6-50.3-74.8-91.8-91.8C317.5 116 304.1 128 288 128H224c-16.1 0-29.5-12-31.7-27.5c-41.6 17-74.8 50.3-91.8 91.8zM424 232v48h48V232H424zM232 424v48h48V424H232zM40 232v48H88V232H40z"]
};
var faCarCircleBolt = {
  prefix: 'far',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M127.7 106.8L103.4 176H408.6l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H165.4c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32H346.6c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9c2.6 1.5 5.2 3.2 7.6 4.9c-28.3 3.9-54.4 14.6-76.8 30.3H96c-26.5 0-48 21.5-48 48v80H320.7c-.5 5.3-.7 10.6-.7 16c0 10.9 1 21.6 2.9 32H48v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400 352 272c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm384-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faCalendarWeek = {
  prefix: 'far',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM112 256H336c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16z"]
};
var faFlyingDisc = {
  prefix: 'far',
  iconName: 'flying-disc',
  icon: [640, 512, [], "e3a9", "M486.4 89.6c7.9 7.9 16.9 31.4 .6 80.4c-15.3 45.9-49.5 101-100.7 152.2S279.9 407.6 234 422.9c-49 16.3-72.5 7.3-80.4-.6c-5.6-5.6-11.8-19.2-9-44.3c19.9 19.2 45.3 20.8 62.5 18.9c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c1.9-17.2 .3-42.6-18.9-62.5c25.1-2.8 38.7 3.3 44.3 9zM201.2 175.4C104.3 281.9 67.6 404.2 119.7 456.3c55.3 55.3 189.8 10.5 300.5-100.2S575.6 111 520.3 55.7C468.2 3.6 345.9 40.3 239.5 137.1c-6.6 6-13.2 12.2-19.7 18.7c-6.5 6.5-12.7 13-18.6 19.6zm35.6 32.2c5.4-6 11.1-11.9 17-17.8c5.9-5.9 11.9-11.6 17.9-17c57.9-52.3 116.2-78.4 135.5-59.1c21.4 21.4-12.7 90.1-76.1 153.4s-132.1 97.4-153.4 76.1c-19.4-19.4 6.8-77.7 59.1-135.6z"]
};
var faLaptopMedical = {
  prefix: 'far',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M128 80H512c8.8 0 16 7.2 16 16V320h48V96c0-35.3-28.7-64-64-64H128C92.7 32 64 60.7 64 96V320h48V96c0-8.8 7.2-16 16-16zM50.7 400H589.3c-6.6 18.6-24.4 32-45.3 32H96c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96H544c53 0 96-43 96-96c0-17.7-14.3-32-32-32H32zM288 144v48H240c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H352V144c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]
};
var faSquareDownRight = {
  prefix: 'far',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M384 432c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384zm64-16c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416zM320 198.6V336c0 8.8-7.2 16-16 16H166.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3C114 210 112 205.1 112 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z"]
};
var faB = {
  prefix: 'far',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M56 32C25.1 32 0 57.1 0 88V256 424c0 30.9 25.1 56 56 56H196c68.5 0 124-55.5 124-124c0-48.9-28.3-91.1-69.3-111.3c23-22.5 37.3-53.9 37.3-88.7c0-68.5-55.5-124-124-124H56zM164 232H48V88c0-4.4 3.6-8 8-8H164c42 0 76 34 76 76s-34 76-76 76zM48 280H164h28 4c42 0 76 34 76 76s-34 76-76 76H56c-4.4 0-8-3.6-8-8V280z"]
};
var faSeatAirline = {
  prefix: 'far',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V142.9c0 14.7 3.1 29.2 9.1 42.5L89.1 364c14.2 31.6 45.6 52 80.3 52H216v48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H264V416h88c29.1 0 55.3-17.5 66.5-44.3l27.7-66.5c3.1-7.4 2.3-15.9-2.2-22.5S432 272 424 272H100.5L86.2 240H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H64.6L52.9 165.8c-3.2-7.2-4.9-15-4.9-22.9V24zm84.9 320.4L122 320H388l-13.8 33.2c-3.7 8.9-12.5 14.8-22.2 14.8H169.4c-15.8 0-30.1-9.3-36.5-23.6z"]
};
var faMoonOverSun = {
  prefix: 'far',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", "M361.3 1.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L450.9 256l56.9 82.5c4.6 6.7 5.5 15.3 2.4 22.8s-9.8 13-17.8 14.4l-98.5 18.1-18.1 98.5c-1.5 8-6.9 14.7-14.4 17.8s-16.1 2.2-22.8-2.4L256 450.9l-82.5 56.9c-6.7 4.6-15.3 5.5-22.8 2.4s-12.9-9.8-14.4-17.8l-18.1-98.5L19.7 375.7c-8-1.5-14.7-6.9-17.8-14.4s-2.2-16.1 2.4-22.8L61.1 256 4.2 173.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-12.9 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L256 61.1 338.5 4.2c6.7-4.6 15.3-5.5 22.8-2.4zm-26.1 63L269.6 110c-8.2 5.7-19 5.7-27.2 0L176.8 64.8l-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L64.8 176.8 110 242.4c5.7 8.2 5.7 19 0 27.2L64.8 335.2l78.3 14.4c9.8 1.8 17.5 9.5 19.3 19.3l14.4 78.3L242.4 402c8.2-5.7 19-5.7 27.2 0l65.6 45.2 14.4-78.3c1.8-9.8 9.5-17.5 19.3-19.3l78.3-14.4L402 269.6c-5.7-8.2-5.7-19 0-27.2l45.2-65.6-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3L335.2 64.8zM144 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm151.7 50.2C310.5 294.5 320 276.4 320 256c0-35.3-28.7-64-64-64c-.2 0-.4 0-.5 0c-12.3 12.2-19.9 29-19.9 47.5c0 34.4 26.2 62.9 60.1 66.7z"]
};
var faEclipseAlt = faMoonOverSun;
var faPipe = {
  prefix: 'far',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M32 0C45.3 0 56 10.7 56 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24C8 10.7 18.7 0 32 0z"]
};
var faFileMedical = {
  prefix: 'far',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm96 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faPotato = {
  prefix: 'far',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M464 144c0-53-43-96-96-96c-26.6 0-50.5 10.7-68 28.2C269.3 107 232 134.9 194 155.7c-16.1 8.8-29.4 22.1-38.2 38.2C134.9 232 107 269.3 76.2 300C58.7 317.5 48 341.4 48 368c0 53 43 96 96 96c20.2 0 38.9-6.2 54.3-16.8c31.8-21.9 67.9-39.9 104.3-52.2c29.5-10 53.5-34 62.1-66.1c11.5-42.8 36.5-84.4 68.8-114.7C452.4 196.6 464 171.7 464 144zm48 0c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM352 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM168 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faDiceOne = {
  prefix: 'far',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleA = {
  prefix: 'far',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-9.1 0-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L190.8 320H321.2l17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7L297.2 272H214.8L256 189.7z"]
};
var faHelmetBattle = {
  prefix: 'far',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M80 17.1L65.1 225.7c-1.2 17-15.4 30.2-32.5 30.2H30.4C13.6 256 0 242.4 0 225.6c0-2.3 .3-4.6 .8-6.8L48.4 12.4c1.9-8.1 9.7-13.5 18-12.2s14.2 8.6 13.6 17zM75.5 420.5c-9.2-5.6-13.5-16.7-10.6-27.1C81.9 333.6 96 270.2 96 208c0-85 89.1-149.2 153.1-189c1.9-1.2 4-2.6 6.3-4.1C264.8 8.4 277.3 0 288 0s23.2 8.4 32.7 14.9c2.3 1.5 4.4 3 6.3 4.1C390.9 58.8 480 123 480 208c0 62.2 14.1 125.6 31.1 185.4c3 10.4-1.4 21.4-10.6 27.1L316.8 506c-8.5 3.9-17.7 6-27 6h-3.7c-9.3 0-18.6-2-27-6L75.5 420.5zM312 455.3l147.4-68.7C444.4 330.7 432 269.5 432 208c0-25-13.1-50.9-39.2-78.3c-26-27.1-60-50.6-91.2-70c-2.7-1.7-5.9-3.9-8.3-5.4l-1.5-1c-1.4-1-2.7-1.8-3.9-2.5c-1.2 .7-2.4 1.6-3.9 2.5l-1.5 1c-2.3 1.6-5.5 3.7-8.3 5.4c-31.2 19.4-65.2 42.9-91.2 70C157.1 157.1 144 183 144 208c0 61.5-12.4 122.7-27.4 178.7L264 455.3V299.2c0-6.7-4.2-12.7-10.5-15l-65.1-23.7c-7.4-2.7-12.4-9.8-12.4-17.7c0-10.4 8.4-18.8 18.8-18.8H381.2c10.4 0 18.8 8.4 18.8 18.8c0 7.9-5 15-12.4 17.7l-65.1 23.7c-6.3 2.3-10.5 8.3-10.5 15V455.3zM509.6 .2c8.3-1.2 16.1 4.1 18 12.2l47.6 206.4c.5 2.2 .8 4.5 .8 6.8c0 16.8-13.6 30.4-30.4 30.4h-2.2c-17.1 0-31.3-13.2-32.5-30.2L496 17.1c-.6-8.3 5.3-15.7 13.6-17z"]
};
var faButter = {
  prefix: 'far',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M464 112V288H416V112H128c-8.8 0-16 7.2-16 16V288H64V128c0-35.3 28.7-64 64-64H416h24 24 48c35.3 0 64 28.7 64 64V288H528V128c0-8.8-7.2-16-16-16H464zM0 344c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V368H24c-13.3 0-24-10.7-24-24z"]
};
var faBlanketFire = {
  prefix: 'far',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M48 112c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64v39.4c4.1-3.9 8.2-7.7 12.5-11.5c10-8.9 23-12.8 35.5-11.7V112C448 50.1 397.9 0 336 0H112C50.1 0 0 50.1 0 112V336c0 61.9 50.1 112 112 112H314.4c-8.7-14.9-15.4-31-19.9-48H112c-35.3 0-64-28.7-64-64s28.7-64 64-64H309c4.9-10 10.3-19.8 16.2-29.3c3.8-6.2 7.9-12.5 12.3-18.7H112c-23.8 0-45.9 7.4-64 20.1V112zM288 350.1c0-12.4 2-25.2 5.6-38.1H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H288.3c-.2-3.3-.3-6.6-.3-9.9zM453.5 163.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faKiwiBird = {
  prefix: 'far',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M266.4 347.3c31.2-18.9 74.9-43.3 125.9-43.3H448c44.2 0 80-35.8 80-80s-35.8-80-80-80H392.3c-51 0-94.7-24.4-125.9-43.3C244.7 87.6 219.3 80 192 80C112.5 80 48 144.5 48 224s64.5 144 144 144c27.3 0 52.7-7.6 74.4-20.7zM392.3 352c-36.4 0-69.9 17.6-101.1 36.4c-11.1 6.7-22.9 12.3-35.2 16.7V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V415.3c-5.3 .4-10.6 .7-16 .7c-16.6 0-32.7-2.1-48-6v46c0 13.3-10.7 24-24 24s-24-10.7-24-24V390.3C38.6 357.1 0 295.1 0 224C0 118 86 32 192 32c36.3 0 70.3 10.1 99.2 27.6C322.4 78.4 355.9 96 392.3 96H448c70.7 0 128 57.3 128 128V464c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7L477.6 348.6c-9.5 2.2-19.4 3.4-29.6 3.4H392.3zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCastle = {
  prefix: 'far',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 39.8 32.2 72 72 72H568c39.8 0 72-32.2 72-72V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H512V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H400V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H288V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zm0 88H464V224H176V112zM48 272H592V440c0 13.3-10.7 24-24 24H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H72c-13.3 0-24-10.7-24-24V272z"]
};
var faGolfClub = {
  prefix: 'far',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", "M498.7 2.5c11.9 5.9 16.7 20.3 10.7 32.2L290.7 472.2c-12.2 24.4-37.1 39.8-64.4 39.8H56c-30.9 0-56-25.1-56-56V347.1c0-37.6 36.3-64.5 72.2-53.6L293 360.4 466.5 13.3c5.9-11.9 20.3-16.7 32.2-10.7zM271.2 404L58.3 339.5c-5.1-1.6-10.3 2.3-10.3 7.7V368H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H48v16H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H48v8c0 4.4 3.6 8 8 8H226.3c9.1 0 17.4-5.1 21.5-13.3L271.2 404z"]
};
var faArrowRightArrowLeft = {
  prefix: 'far',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", "M103 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L424 408c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 360l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l96 96zM441 145c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l342.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z"]
};
var faExchange = faArrowRightArrowLeft;
var faRotateRight = {
  prefix: 'far',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3V200c0 13.3-10.7 24-24 24H355.3c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176H448V113.9z"]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faUtensils = {
  prefix: 'far',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M71.9 26.7c1.5-13.2-8-25-21.2-26.5s-25 8-26.5 21.2l-16 144L8 166.7V168v16c0 48.6 39.4 88 88 88h8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V272h8c48.6 0 88-39.4 88-88V168v-1.3l-.1-1.3-16-144C230.4 8.2 218.5-1.3 205.3 .1s-22.7 13.3-21.2 26.5L200 169.3V184c0 22.1-17.9 40-40 40H128 96c-22.1 0-40-17.9-40-40V169.3L71.9 26.7zM152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM336 176c0-57.7 21.7-88.6 41.4-105.7c7.7-6.6 15.5-11.6 22.6-15.2V248v56H352c-8.8 0-16-7.2-16-16V176zm64 176V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352 304 248 32c0-17.7-14.3-32-32-32C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h48z"]
};
var faCutlery = faUtensils;
var faArrowUpWideShort = {
  prefix: 'far',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM312 480c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H312zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H312z"]
};
var faSortAmountUp = faArrowUpWideShort;
var faChartPieSimpleCircleDollar = {
  prefix: 'far',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M496 192c-46.8 0-89.3 18.2-120.8 48H272V16.6c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288h67.2c-7.6 14.9-13.2 31-16.3 48H224c-26.5 0-48-21.5-48-48V90.9C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V240v48h48zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faBalloons = {
  prefix: 'far',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", "M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160c0 31.6 15.3 65.1 38.2 96.6c22.5 30.8 48.7 54.8 62.4 66.3c4.4 3.7 8.2 7.9 11.4 12.5c3.2-4.6 7-8.8 11.4-12.5c13.7-11.5 39.9-35.5 62.4-66.3c23-31.5 38.2-65 38.2-96.6zM112 400l10-20.1c3.5-6.9 1.6-15.3-4.4-20.3C87.2 334 0 252.5 0 160C0 71.6 71.6 0 160 0s160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3L208 400l.1 .1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9H185.2h-6.7-.1H141.7h-.1-6.7 0H108.9c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1zm48-264c-13.3 0-24 10.7-24 24s-10.7 24-24 24s-24-10.7-24-24c0-39.8 32.2-72 72-72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM437.7 423.7c-26.2-22.1-94.5-85.6-113-161.8C340.5 231.8 352 197.2 352 160c0-9.9-.7-19.6-2.2-29c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3L528 464l.1 .1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9H505.2h-6.7-.1H461.7h-.1-6.7H428.9c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1 10-20.1c3.5-6.9 1.6-15.3-4.4-20.3zM480 112c-61.9 0-112 50.1-112 112c0 31.6 15.3 65.1 38.2 96.6c22.5 30.8 48.7 54.8 62.4 66.3c4.4 3.7 8.2 7.9 11.4 12.5c3.2-4.6 7-8.8 11.4-12.5c13.7-11.5 39.9-35.5 62.4-66.3c23-31.5 38.2-65 38.2-96.6c0-61.9-50.1-112-112-112zM456 224c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-39.8 32.2-72 72-72c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24 10.7-24 24z"]
};
var faMillSign = {
  prefix: 'far',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M302.4 32.5c4.7-12.4-1.5-26.3-13.9-31s-26.3 1.5-31 13.9l-36.1 95.3c-11.3 6.6-21.2 15.2-29.4 25.3C172.2 111.6 141.9 96 108 96c-22.5 0-43.3 6.9-60.6 18.6C44.9 103.9 35.4 96 24 96C10.7 96 0 106.7 0 120v80H.1c0 1.3-.1 2.7-.1 4V424c0 13.3 10.7 24 24 24s24-10.7 24-24V204c0-33.1 26.9-60 60-60s60 26.9 60 60v47.6L81.6 479.5c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L168 386.9V416v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8V260.4l43.3-114c5.3-1.5 10.9-2.4 16.7-2.4c33.1 0 60 26.9 60 60V424c0 13.3 10.7 24 24 24s24-10.7 24-24V204c0-58.9-47.1-106.7-105.7-108l24.1-63.5z"]
};
var faBowlRice = {
  prefix: 'far',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M176 56c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H200c-13.3 0-24 10.7-24 24zm24 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H200zM56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H72c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm88.7 244.6c-4-13.5-13.8-24.6-26.8-30.3C82.7 374.9 56.7 342.7 49.8 304H462.2c-6.9 38.7-32.9 70.9-68.1 86.3c-12.9 5.7-22.7 16.7-26.8 30.3c-2 6.6-8.2 11.4-15.3 11.4H160c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480H352c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4H27.4zM224 200c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zm-96 0c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H104zm216 96c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H344c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H296zm120 96c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H392zM296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H296z"]
};
var faTimelineArrow = {
  prefix: 'far',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M160 96A32 32 0 1 0 96 96a32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3V232H328V172.3c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V232H554.6l-58.9-54.4c-9.7-9-10.3-24.2-1.4-33.9s24.2-10.3 33.9-1.4l103.9 95.9c.1 .1 .3 .3 .4 .4c.3 .3 .6 .6 .9 .9c4 4.3 6.5 10.1 6.5 16.4s-2.5 12.1-6.5 16.4c-.3 .3-.6 .6-.9 .9c-.1 .1-.3 .3-.4 .4L528.3 369.6c-9.7 9-24.9 8.4-33.9-1.4s-8.4-24.9 1.4-33.9L554.6 280H248v59.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V172.3C71.5 162.1 48 131.8 48 96c0-44.2 35.8-80 80-80s80 35.8 80 80zM192 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSkull = {
  prefix: 'far',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M368 400c-.4-16 7.3-31.2 20.4-40.4C436.1 326.2 464 276.9 464 224c0-91.4-86.9-176-208-176S48 132.6 48 224c0 52.9 27.9 102.2 75.6 135.6c13.1 9.2 20.8 24.4 20.4 40.4l0 0v64h48V440c0-13.3 10.7-24 24-24s24 10.7 24 24v24h32V440c0-13.3 10.7-24 24-24s24 10.7 24 24v24h48V400l0 0zm48-1.1c0 .4 0 .7 0 1.1v64c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V400c0-.4 0-.7 0-1.1C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9zM112 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm232-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faGameBoardSimple = {
  prefix: 'far',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm16 80V256H224V112H80zM224 256V400H368V256H224z"]
};
var faGameBoardAlt = faGameBoardSimple;
var faCircleVideo = {
  prefix: 'far',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24V312c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V200zM364.9 317.9L320 288V224l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V307.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
};
var faVideoCircle = faCircleVideo;
var faChartScatterBubble = {
  prefix: 'far',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM176 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm200 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM240 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm168 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHouseTurret = {
  prefix: 'far',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", "M56 48c-4.4 0-8 3.6-8 8V203.8c0 2 .7 3.9 2 5.3l55.9 62.9c3.9 4.4 6.1 10.1 6.1 15.9V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V297.1L14.1 241C5 230.8 0 217.5 0 203.8V56C0 25.1 25.1 0 56 0H296c30.9 0 56 25.1 56 56v68.6l-48 44V56c0-4.4-3.6-8-8-8H256V88c0 13.3-10.7 24-24 24s-24-10.7-24-24V48H144V88c0 13.3-10.7 24-24 24s-24-10.7-24-24V48H56zm120 96c22.1 0 40 17.9 40 40v40c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V184c0-22.1 17.9-40 40-40zm100.8 93l128-117.3c24.5-22.4 62-22.4 86.5 0L619.2 237c13.2 12.1 20.8 29.2 20.8 47.2V448c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V284.2c0-17.9 7.5-35.1 20.8-47.2zM304 284.2V448c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V284.2c0-4.5-1.9-8.8-5.2-11.8L458.8 155c-6.1-5.6-15.5-5.6-21.6 0l-128 117.3c-3.3 3-5.2 7.3-5.2 11.8zM400 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H424c-13.3 0-24-10.7-24-24V296z"]
};
var faBanana = {
  prefix: 'far',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", "M352 144c0 46.7-10.5 90.9-29.3 130.4l-25.3-20.2c-4.4-3.5-9.1-6.8-13.9-9.8C296.7 213.6 304 179.7 304 144c0-31.4-5.6-61.3-15.9-89c-9.5-25.5 8.6-55 38-55c9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 10.9-.6 21.6-1.8 32.1c-10.9 .4-21.7 2.1-32.3 4.9l-17.6 4.7c2.4-13.5 3.6-27.5 3.6-41.7c0-59.5-21.7-114-57.6-156c6.2 24.3 9.6 49.7 9.6 76zM211.3 304c-12.5 0-24.7 4.1-34.7 11.6l-42.2 31.6c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6l42.2-31.6c18.3-13.7 40.6-21.2 63.5-21.2c24 0 47.4 8.2 66.1 23.2l48.1 38.5h0l96.7-25.8h0c6.1-1.6 12.3-2.7 18.5-3.4l0 0c3.7-.4 7.5-.6 11.3-.6c40.7 0 78.4 21.3 99.3 56.2l21.3 35.4c6.8 11.4 3.1 26.1-8.2 32.9s-26.1 3.1-32.9-8.2l-21.3-35.4C497.9 348.5 475.8 336 452 336c-5.9 0-11.8 .8-17.5 2.3l-11.5 3.1C378.2 441.9 277.3 512 160 512L48 512c-26.5 0-48-21.5-48-48V448c0-26.5 21.5-48 48-48c77 0 146.1-34 193-87.8c-8.9-5.3-19.2-8.2-29.7-8.2z"]
};
var faHandHoldingSkull = {
  prefix: 'far',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M192 128c0 29.9 20.4 58.1 53.8 71.8c9.9 4.1 15.9 14.2 14.7 24.9L258.8 240h58.4l-1.7-15.3c-1.2-10.6 4.8-20.8 14.7-24.9C363.6 186.1 384 157.9 384 128c0-41.1-39.6-80-96-80s-96 38.9-96 80zM288 0c76.2 0 144 54.2 144 128c0 46.7-27.7 86.1-66.9 108.2l2.8 25.2c.8 6.8-1.4 13.6-6 18.7s-11.1 8-17.9 8H232c-6.8 0-13.3-2.9-17.9-8s-6.7-11.9-6-18.7l2.8-25.2C171.7 214.1 144 174.7 144 128C144 54.2 211.8 0 288 0zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H387.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H344 320 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4zM224 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM328 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPeopleDress = {
  prefix: 'far',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM267.1 299.8l-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8H224V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H144V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H69.8c-10.8 0-18.5-10.5-15.3-20.8l46.3-148L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM206.7 336L160 186.5 113.3 336h93.4zM480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM587.1 299.8l-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8H544V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H464V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H389.8c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM526.7 336L480 186.5 433.3 336h93.4z"]
};
var faLoveseat = {
  prefix: 'far',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M176 80H336c44.2 0 80 35.8 80 80v34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8V160c0-70.7-57.3-128-128-128H176C105.3 32 48 89.3 48 160v34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8V160c0-44.2 35.8-80 80-80zM462.5 227.6c-7.1-2.3-14.6-3.6-22.5-3.6c-9.5 0-18.5 1.8-26.8 5.2c-24.1 9.7-41.8 32-44.7 58.8H143.6c-3-26.8-20.6-49.1-44.7-58.8C90.5 225.8 81.5 224 72 224c-7.9 0-15.4 1.3-22.5 3.6C20.7 237 0 264.1 0 296V432c0 26.5 21.5 48 48 48H96c20.9 0 38.7-13.4 45.3-32H370.7c6.6 18.6 24.4 32 45.3 32h48c26.5 0 48-21.5 48-48V296c0-31.9-20.7-59-49.5-68.4zM368 400H144V336h32H336h32v64zM96 400v32H48l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24v40 64zM464 296V432H416V296c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faCouchSmall = faLoveseat;
var faTowerBroadcast = {
  prefix: 'far',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M54.8 1.9C42.6-3.4 28.5 2.3 23.3 14.4C8.3 49.3 0 87.7 0 128s8.3 78.7 23.3 113.6c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5C54.9 193.6 48 161.6 48 128s6.9-65.6 19.4-94.6C72.6 21.2 67 7.1 54.8 1.9zm466.4 0C509 7.1 503.4 21.2 508.6 33.4c12.5 29 19.4 61 19.4 94.6s-6.9 65.6-19.4 94.6c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6c15-34.9 23.3-73.3 23.3-113.6s-8.3-78.7-23.3-113.6C547.5 2.3 533.4-3.4 521.2 1.9zM312 187.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 26.9 16.5 49.9 40 59.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V187.3zM166.5 87.6c4.2-12.6-2.6-26.2-15.2-30.3S125.1 59.8 121 72.4c-5.8 17.5-9 36.2-9 55.6s3.1 38.1 9 55.6c4.2 12.6 17.8 19.4 30.3 15.2s19.4-17.8 15.2-30.3c-4.2-12.7-6.5-26.3-6.5-40.4s2.3-27.7 6.5-40.4zM455 72.4c-4.2-12.6-17.8-19.4-30.3-15.2s-19.4 17.8-15.2 30.3c4.2 12.7 6.5 26.3 6.5 40.4s-2.3 27.7-6.5 40.4c-4.2 12.6 2.6 26.2 15.2 30.3s26.2-2.6 30.3-15.2c5.8-17.5 9-36.2 9-55.6s-3.1-38.1-9-55.6z"]
};
var faBroadcastTower = faTowerBroadcast;
var faTruckPickup = {
  prefix: 'far',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M272 88v88H446.9L374.7 83.1c-1.5-1.9-3.8-3.1-6.3-3.1H280c-4.4 0-8 3.6-8 8zM412.6 53.6L507.7 176H552c30.9 0 56 25.1 56 56v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H560h-1.3c.9 5.2 1.3 10.5 1.3 16c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16H270.7c.9 5.2 1.3 10.5 1.3 16c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16H80 32 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V232c0-30.9 25.1-56 56-56H224V88c0-30.9 25.1-56 56-56h88.3c17.3 0 33.6 8 44.2 21.6zM96 320h8.4c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32H256 384h8.4c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32H544h16V232c0-4.4-3.6-8-8-8H496.2h-.5H248 88c-4.4 0-8 3.6-8 8v88H96zm128 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faBlockQuote = {
  prefix: 'far',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M24 72C10.7 72 0 82.7 0 96s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM152 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM128 416c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zM0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24V424z"]
};
var faUpLong = {
  prefix: 'far',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", "M143.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3H240V456c0 30.9-25.1 56-56 56H136c-30.9 0-56-25.1-56-56V208H46.3C20.7 208 0 187.3 0 161.7c0-12.8 5.3-25 14.6-33.7L143.6 6.5zM50.5 160H104c13.3 0 24 10.7 24 24V456c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V184c0-13.3 10.7-24 24-24h53.5L160 57 50.5 160z"]
};
var faLongArrowAltUp = faUpLong;
var faStop = {
  prefix: 'far',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", "M320 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faCodeMerge = {
  prefix: 'far',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24.7 108.1C136.8 145.7 160 115.6 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3V355.7C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V254.9c27.2 25.5 63.8 41.1 104 41.1h83.7c10.2 32.5 40.5 56 76.3 56c44.2 0 80-35.8 80-80s-35.8-80-80-80c-35.8 0-66.1 23.5-76.3 56H208c-53.3 0-97.3-40.2-103.3-91.9zM80 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMoneyCheckDollarPen = {
  prefix: 'far',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M512 112H64c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H348.3c-5.6 7.1-9.6 15.3-11.8 24.1l-6 23.9H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64.6c-15.2 2-29.8 8.8-41.4 20.5l-6.6 6.6V128c0-8.8-7.2-16-16-16zM256 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24zm24-120H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zM160 132c11 0 20 9 20 20v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20zM613.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
var faUpFromLine = {
  prefix: 'far',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M82.2 192L192 82 301.8 192H248c-13.3 0-24 10.7-24 24V336H160V216c0-13.3-10.7-24-24-24H82.2zM192 32c-11.5 0-22.5 4.6-30.6 12.7L45.6 160.8C36.9 169.5 32 181.3 32 193.6C32 219.2 52.8 240 78.4 240H112v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V240h33.6c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L222.6 44.7C214.5 36.6 203.5 32 192 32zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faArrowAltFromBottom = faUpFromLine;
var faUpload = {
  prefix: 'far',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95V360zm32-8V304H448c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V368c0-35.3 28.7-64 64-64H200v48H64c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H312zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHurricane = {
  prefix: 'far',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M48 208C48 133.5 99 70.8 168 53v52.4c0 21.2 16 37.1 34.6 40.2C278.3 158.3 336 224.1 336 303.4c0 74.5-51 137.2-120 155V406c0-21.2-16-37.1-34.6-40.2C105.7 353.1 48 287.3 48 208zM216 42.1c0-22.7-20.1-43.4-45.6-38.7C73.5 21.1 0 105.9 0 208C0 309.2 72.3 393.5 168 412.2v57.1c0 22.7 20.1 43.4 45.6 38.7C310.5 490.3 384 405.4 384 303.4c0-101.2-72.3-185.5-168-204.2V42.1zM176 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faGridRound2Plus = {
  prefix: 'far',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", "M80 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM80 384a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
};
var faPeoplePants = {
  prefix: 'far',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3 .1V304H144V176.1c.7 0 1.5-.1 2.3-.1zM144 488V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L250.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7H146.3c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3 .1V304H464V176.1c.7 0 1.5-.1 2.3-.1zM464 488V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L570.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7H466.3c-31.7 0-61 17.1-76.6 44.7L331.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L416 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faMound = {
  prefix: 'far',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M485 368H91l94.8-164.9c21-36.6 60-59.1 102.2-59.1s81.2 22.6 102.2 59.1L485 368zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48H512.7c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z"]
};
var faWindsock = {
  prefix: 'far',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M24 0C37.3 0 48 10.7 48 24V96h80V87.4c0-20.3 18.7-35.5 38.5-31.3l320 66.7c14.8 3.1 25.5 16.2 25.5 31.3V262c0 15.2-10.6 28.2-25.5 31.3L166.5 360c-19.9 4.1-38.5-11-38.5-31.3V320H48V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V296 120 24C0 10.7 10.7 0 24 0zM48 144V272h80V144H48zM416 259l48-10V167l-48-10V259zm-48 10V147l-80-16.7V285.6L368 269zM240 295.6V120.4L176 107V309l64-13.3z"]
};
var faCircleHalf = {
  prefix: 'far',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M208 53.6C116.3 75.2 48 157.7 48 256s68.3 180.8 160 202.4V53.6zM224.1 2C241.6-.2 256 14.3 256 32V480c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z"]
};
var faBrakeWarning = {
  prefix: 'far',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M320 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM83.9 75.8c-11.1-7.2-26-4-33.2 7.2C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173c7.2 11.1 22 14.4 33.2 7.2s14.4-22 7.2-33.2C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147c7.2-11.1 4-26-7.2-33.2zm472.2 0c-11.1 7.2-14.4 22-7.2 33.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147c-7.2 11.1-4 26 7.2 33.2s26 4 33.2-7.2C621.4 379.1 640 319.7 640 256s-18.6-123.1-50.7-173c-7.2-11.1-22-14.4-33.2-7.2zM320 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faToiletPortable = {
  prefix: 'far',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M48 72V96H272V72c0-13.3-10.7-24-24-24H72C58.7 48 48 58.7 48 72zm0 72V432H272V320H248c-13.3 0-24-10.7-24-24V248c0-13.3 10.7-24 24-24h24V144H48zm0 336v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V72C0 32.2 32.2 0 72 0H248c39.8 0 72 32.2 72 72V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48z"]
};
var faCompactDisc = {
  prefix: 'far',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM241.8 128.8c8.8-1 15.1-8.9 14.1-17.7s-8.9-15.1-17.7-14.1C164.1 105.2 105.2 164.1 97 238.2c-1 8.8 5.4 16.7 14.1 17.7s16.7-5.4 17.7-14.1c6.6-59.3 53.7-106.4 113-113z"]
};
var faFileArrowDown = {
  prefix: 'far',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24V334.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V232z"]
};
var faFileDownload = faFileArrowDown;
var faSaxophoneFire = {
  prefix: 'far',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M109.5 2.6c13.8 12.4 26.8 25.9 38.8 40.4c5.5-6.9 11.8-14.5 18.5-20.7c3.9-3.6 10.1-3.6 14 0c17.3 15.9 31.9 36.9 42.3 56.8c10.2 19.6 16.9 41.2 16.9 55.3c0 14.6-2.8 28.6-8 41.5H176.8c8.9-15.4 9.3-35.4 .2-52.1c-1.4-2.8-2.8-5.6-4.9-8.4l-25.2 29.4s-40.6-51.8-43.4-55.3C82.5 115.5 72 130.2 72 147c0 11.2 2.7 21 7.5 29H23.9c-5.1-12.9-7.9-26.9-7.9-41.5C16 116 24.9 92 38.7 69.7c14-22.7 33.7-46.3 57-67.1c2-1.8 4.5-2.6 7-2.6c2.5 0 4.9 .9 6.9 2.6zM0 232c0-13.3 10.7-24 24-24H40 232h16c13.3 0 24 10.7 24 24c0 13-10.3 23.6-23.2 24l-21.2 58.3L318 224l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L366 176l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L414 128l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7 4.3-4.3C468.8 73.3 491.2 64 514.5 64h35c23.3 0 45.7 9.3 62.2 25.8l14.6 14.6c8.7 8.7 13.7 20.6 13.7 33c0 25.8-20.9 46.6-46.6 46.6H542.8c-2.3 0-4.6 1-6.1 2.8l-224.5 263c-33.7 39.5-83 62.2-134.9 62.2h-5.5C76.9 512 0 435.1 0 340.2c0-9.5 .8-18.9 2.3-28.2l9.8-59.1C4.9 248.8 0 241 0 232zm464.3-86.4L417.9 192c-.3 .3-.6 .7-1 1s-.7 .7-1 1l-45.8 45.8c-.4 .4-.8 .9-1.2 1.3s-.8 .8-1.3 1.2l-112.1 112c-8.7 8.7-20.6 13.6-33 13.6h-2.4c-24.4 0-44.3-19.8-44.3-44.3c0-5.2 .9-10.3 2.7-15.1L197.7 256H60.3L49.7 319.9c-1.1 6.7-1.7 13.5-1.7 20.3C48 408.6 103.4 464 171.8 464h5.5c37.8 0 73.8-16.6 98.3-45.4l224.5-263c10.6-12.5 26.2-19.6 42.6-19.6h47.3l-12.3-12.3c-7.5-7.5-17.7-11.7-28.3-11.7h-35c-10.6 0-20.8 4.2-28.3 11.7l-20.6 20.6c-.2 .2-.4 .5-.6 .7s-.5 .4-.7 .7zM96 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSaxHot = faSaxophoneFire;
var faCameraWebSlash = {
  prefix: 'far',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L485.3 355.1C516.9 317.5 536 269 536 216C536 96.7 439.3 0 320 0C248.3 0 184.8 34.9 145.5 88.7L38.8 5.1zM183.3 118.3C213.8 75.8 263.6 48 320 48c92.8 0 168 75.2 168 168c0 41.8-15.3 80-40.5 109.4l-37.8-29.7C428.5 274.6 440 246.6 440 216c0-66.3-53.7-120-120-120c-41 0-77.2 20.6-98.9 52l-37.8-29.7zM371.7 266.1L259 177.7c12.7-20.3 35.3-33.7 61-33.7c39.8 0 72 32.2 72 72c0 19.5-7.7 37.1-20.3 50.1zM359.6 379.3c-12.7 3.1-25.9 4.7-39.6 4.7c-92.8 0-168-75.2-168-168l0-.2-45.1-35.5C105 191.9 104 203.8 104 216c0 72.8 36 137.2 91.3 176.4l-62.3 81c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4H528l-60.9-48H200.7l37.1-48.2C263.1 426.2 290.9 432 320 432c30 0 58.6-6.1 84.6-17.2l-45-35.5z"]
};
var faWebcamSlash = faCameraWebSlash;
var faFolderMedical = {
  prefix: 'far',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM224 256H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v48z"]
};
var faFolderGear = {
  prefix: 'far',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H289.9L247 53.1C233.5 39.6 215.2 32 196.1 32H64zM48 96c0-8.8 7.2-16 16-16H196.1c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96zM353.2 264.2c6.3-3.6 9.5-11.2 6.8-17.9c-1.7-4.3-3.7-8.4-5.9-12.4l-2-3.5c-2.4-4-5.1-7.9-7.9-11.5c-4.5-5.7-12.6-6.8-18.9-3.1l-1.2 .7c-8 4.6-17.9 3.5-25.9-1.2s-14.1-12.7-14.1-21.9v-1.4c0-7.3-4.9-13.8-12.2-14.8c-5.2-.7-10.5-1.1-15.8-1.1s-10.7 .4-15.8 1.1c-7.2 1-12.2 7.5-12.2 14.8v1.4c0 9.3-6.1 17.3-14.1 21.9s-17.9 5.8-25.9 1.2l-1.2-.7c-6.3-3.6-14.4-2.6-18.9 3.1c-2.9 3.7-5.5 7.5-8 11.5l-2 3.4c-2.2 4-4.2 8.2-5.9 12.5c-2.7 6.8 .4 14.3 6.8 17.9l1.2 .7c8 4.6 12 13.8 12 23.1s-4 18.4-12 23.1l-1.2 .7c-6.3 3.6-9.5 11.2-6.8 17.9c1.7 4.3 3.7 8.4 5.9 12.4l2.1 3.6c2.4 4 5 7.8 7.9 11.5c4.5 5.7 12.6 6.8 18.9 3.1l1.2-.7c8-4.6 17.9-3.5 25.9 1.2s14.1 12.7 14.1 21.9v1.4c0 7.3 4.9 13.8 12.2 14.8c5.2 .7 10.5 1.1 15.8 1.1s10.7-.4 15.8-1.1c7.2-1 12.2-7.5 12.2-14.8v-1.4c0-9.3 6.1-17.3 14.1-21.9s17.9-5.8 25.9-1.2l1.2 .7c6.3 3.6 14.4 2.6 18.9-3.1c2.9-3.6 5.5-7.5 7.9-11.4l2.1-3.6c2.2-4 4.2-8.1 5.9-12.4c2.7-6.8-.4-14.3-6.8-17.9l-1.2-.7c-8-4.6-12-13.8-12-23.1s4-18.5 12-23.1l1.2-.7zM221 288a35 35 0 1 1 70 0 35 35 0 1 1 -70 0z"]
};
var faFolderCog = faFolderGear;
var faHandWave = {
  prefix: 'far',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", "M336.2 82.3L335 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S281.5-1.1 290.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM80 68.7c17.9-17.9 43.8-23 66.2-15.2c3.1-6.8 7.4-13.1 13-18.7c25-25 65.5-25 90.5 0L368 153v-5.2c0-35.3 28.7-64 64-64s64 28.7 64 64V305.6c0 1.6 0 3.1-.1 4.7c0 .6 .1 1.1 .1 1.7c0 109.9-88.7 199.2-198.5 200l-.5 0h-1l0 0-6.6 0c-53 0-103.9-21.1-141.4-58.6L34.7 340.2c-25-25-25-65.5 0-90.5c3.9-3.9 8.2-7.2 12.7-9.9l-1.4-1.4c-25-25-25-65.5 0-90.5c5.6-5.6 11.9-9.9 18.7-13C57 112.5 62.1 86.6 80 68.7zm79.3 56.7l-.1-.1-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l22.5 22.5 .1 .1L232.7 244c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L119.5 244l.1 .1 56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L91.4 283.7l-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L181.9 419.5C210.4 448 249.1 464 289.4 464l6.6 0 0 0h.6l.2 0c82.8-.5 149.9-67.1 151.1-149.8c-.1-1-.1-2.1-.1-3.1c.1-1.8 .1-3.6 .1-5.5V147.9c0-8.8-7.2-16-16-16s-16 7.2-16 16V211c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L215.8 68.7c-6.2-6.2-16.4-6.2-22.6 0c-6.2 6.2-6.2 16.3-.1 22.6l96.2 96.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1zM13.7 368.2c8.7-1.2 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.3 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 386.3c-1.2-8.7 4.8-16.9 13.6-18.1z"]
};
var faArrowUpArrowDown = {
  prefix: 'far',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M529 377c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1l-55-55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39z"]
};
var faSortUpDown = faArrowUpArrowDown;
var faCaravan = {
  prefix: 'far',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M416 80c61.9 0 112 50.1 112 112V368H480V168c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40V368H275.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H80c-17.7 0-32-14.3-32-32V112c0-17.7 14.3-32 32-32H416zM80 416H96c0 53 43 96 96 96s96-43 96-96h64 96 80 48l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0V192c0-88.4-71.6-160-160-160H80C35.8 32 0 67.8 0 112V336c0 44.2 35.8 80 80 80zM432 224H416c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v96H368V176h64v48zM128 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H128zm64 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faShieldCat = {
  prefix: 'far',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160 154.4V272c0 53 43 96 96 96s96-43 96-96V154.4c0-5.8-4.7-10.4-10.4-10.4h-.2c-3.4 0-6.5 1.6-8.5 4.3l-40 53.3c-3 4-7.8 6.4-12.8 6.4H232c-5 0-9.8-2.4-12.8-6.4l-40-53.3c-2-2.7-5.2-4.3-8.5-4.3h-.2c-5.8 0-10.4 4.7-10.4 10.4zM216 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faMessageSlash = {
  prefix: 'far',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zm73.3 57.4c.7-8.1 7.6-14.5 15.9-14.5H512c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H501.8L112.1 62.5zM224 368H128c-8.8 0-16-7.2-16-16V184.2L64 146.4V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76h32.8l-54.4-42.9c-2.5 1.3-4.9 2.8-7.2 4.5L272 432V416c0-26.5-21.5-48-48-48z"]
};
var faCommentAltSlash = faMessageSlash;
var faBolt = {
  prefix: 'far',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", "M321.7 0c19.1 0 32.9 18.3 27.6 36.6L295.8 224h85.2c19.3 0 34.9 15.6 34.9 34.9c0 10.3-4.5 20-12.3 26.6L144.9 505.2c-5.2 4.4-11.8 6.8-18.6 6.8c-19.1 0-32.9-18.3-27.6-36.6L152.2 288H65.7C47.1 288 32 272.9 32 254.3c0-9.9 4.3-19.2 11.8-25.6L303.1 6.9C308.3 2.4 314.9 0 321.7 0zM285.6 85L104.4 240H184c7.5 0 14.6 3.5 19.2 9.5s6 13.8 3.9 21L162.3 427.5 345.5 272H264c-7.5 0-14.6-3.5-19.2-9.5s-6-13.8-3.9-21L285.6 85z"]
};
var faZap = faBolt;
var faTrashCanCheck = {
  prefix: 'far',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zM337 241L209 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 207c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faGlassWater = {
  prefix: 'far',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512H276c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8H24zM57.6 134.3L50.2 48H333.8l-7.4 86.3-25.2 14c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 155.6 99 157.3 82.8 148.3l-25.2-14zm5 57.6c32.7 16.6 72.1 12.6 100.9-10.4c16.7-13.3 40.4-13.3 57 0c28.8 23 68.3 27 100.9 10.4L299.9 442.1C298.8 454.5 288.4 464 276 464H108c-12.5 0-22.8-9.5-23.9-21.9L62.6 191.9z"]
};
var faOilWell = {
  prefix: 'far',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M482 73.7c-4.6-17.1-22.1-27.2-39.2-22.6l58 216.4c17.1-4.6 27.2-22.1 22.6-39.2L482 73.7zm-51.6-69c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6L431.3 193.6 96 280.5V464h44.1L198 294.3l55.6-14.4L229.1 352h85.9l-27.6-80.8 46.6-12.1 70 204.9H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48V184c0-13.3 10.7-24 24-24s24 10.7 24 24v46.9l135.7-35.2 17.6-51.5c3.3-9.7 12.4-16.2 22.7-16.2s19.4 6.5 22.7 16.2l11 32.3 113.1-29.3L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM353.2 464l-21.9-64H212.7l-21.9 64H353.2z"]
};
var faPersonSimple = {
  prefix: 'far',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208h44.8c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3H168 88 85.6c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352z"]
};
var faVault = {
  prefix: 'far',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", "M64 48c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H112v8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c-35.3 0-64-28.7-64-64V64zM320 240a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM80 240a144 144 0 1 1 288 0A144 144 0 1 1 80 240zm144-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272-16c0 17.8-9.7 33.3-24 41.6V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V217.6c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48z"]
};
var faMars = {
  prefix: 'far',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-83.7 83.7C252.8 141.3 215.9 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-39.9-13.3-76.8-35.7-106.3L400 113.9V168c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H312zM48 304a128 128 0 1 1 256 0A128 128 0 1 1 48 304z"]
};
var faToilet = {
  prefix: 'far',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M0 24C0 37.3 10.7 48 24 48H56 392h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H392 56 24C10.7 0 0 10.7 0 24zM81.6 182.9l-1.6 .5V80H32V207.1l-.4 .4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3c1.7 1.1 3.5 2.1 5.2 3.2L69.3 448.2c-3.5 6.3-5.3 13.5-5.3 20.7c0 23.8 19.3 43.1 43.1 43.1H340.9c23.8 0 43.1-19.3 43.1-43.1c0-7.2-1.8-14.4-5.3-20.7l-22.3-40.7c1.8-1 3.5-2.1 5.2-3.2c45-28.1 78.4-75.6 78.4-148.3c0-20.3-9.5-36.6-23.6-48.5l-.4-.4V80H368V183.4l-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9zM373.8 326.8c-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3c-14.7-9.2-27.8-21.2-37.6-36.9c2.4 .8 4.9 1.5 7.4 2.3C119.6 340 170.3 344 224 344s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3zM56 256c0-3.7 1.2-7.4 6.6-12c6.1-5.1 16.5-10.4 32.3-15C126.3 220 171.6 216 224 216s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15c5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12c-6.1 5.1-16.5 10.4-32.2 15C321.7 292 276.4 296 224 296s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15c-5.4-4.6-6.6-8.2-6.6-12zM312.3 426.8L332.6 464H115.4l20.4-37.2c30.5 9.7 61.8 13.2 88.3 13.2s57.7-3.5 88.3-13.2zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faPlaneCircleXmark = {
  prefix: 'far',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128v26.2l84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2V128c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2l0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1v39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7v29.6l144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436v23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23 0 0 0 0 0 0-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0 0 0 0 0 0 0-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1V432c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1V297.5c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2V128c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2V303.7c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
var faYenSign = {
  prefix: 'far',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M43.8 42.5c-7.5-11-22.4-13.8-33.3-6.4S-3.3 58.5 4.2 69.5L109.2 224H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h96v48H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h96v88c0 13.3 10.7 24 24 24s24-10.7 24-24V368h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V272h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H210.8L315.8 69.5c7.5-11 4.6-25.9-6.4-33.3s-25.9-4.6-33.3 6.4L160 213.3 43.8 42.5z"]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faGearCode = {
  prefix: 'far',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zm73.7 111.8l-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3l40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L339.7 256l-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"]
};
var faNotes = {
  prefix: 'far',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M144 96c0-8.8 7.2-16 16-16H416c8.8 0 16 7.2 16 16V288H384c-17.7 0-32 14.3-32 32v48H160c-8.8 0-16-7.2-16-16V96zM96 96V352c0 35.3 28.7 64 64 64H357.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM320 488c0-13.3-10.7-24-24-24H136c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24V376c0 75.1 60.9 136 136 136H296c13.3 0 24-10.7 24-24z"]
};
var faRubleSign = {
  prefix: 'far',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", "M111.3 32C85.2 32 64 53.2 64 79.3V272H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V416H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H112V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H111.3zM240 272H112V80H240c53 0 96 43 96 96s-43 96-96 96z"]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faTrashUndo = {
  prefix: 'far',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3zM222.9 194.7c-7.3-8.3-20-9-28.2-1.7l-72 64c-4.3 3.8-6.7 9.2-6.7 14.9s2.4 11.2 6.7 14.9l72 64c8.3 7.3 20.9 6.6 28.2-1.7s6.6-20.9-1.7-28.2L188.6 292H240c24.3 0 44 19.7 44 44v24c0 11 9 20 20 20s20-9 20-20V336c0-46.4-37.6-84-84-84H188.6l32.7-29.1c8.3-7.3 9-20 1.7-28.2z"]
};
var faTrashArrowTurnLeft = faTrashUndo;
var faChampagneGlass = {
  prefix: 'far',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", "M80 0C68.1 0 58 8.7 56.3 20.5L29.7 201C19.1 272.5 67.8 337.3 136 349.8V464H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h88 88c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V349.8c64.4-12.2 110.8-72.8 102.6-140.6l-22.8-188C262.4 9.1 252.1 0 240 0H80zm8.9 128l11.8-80h118l9.7 80H88.9zm-7.1 48H234.2l4.7 38.9c5.7 47.4-31.2 89.1-78.9 89.1c-51.1 0-90.3-45.4-82.9-96l4.7-32z"]
};
var faGlassChampagne = faChampagneGlass;
var faObjectsAlignCenterHorizontal = {
  prefix: 'far',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", "M432 176L80 176l0-64 352 0 0 64zm48-64c0-26.5-21.5-48-48-48L280 64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l152 0 0 64-88 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l88 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 88 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-88 0 0-64 152 0c26.5 0 48-21.5 48-48l0-64zM368 400l-224 0 0-64 224 0 0 64z"]
};
var faSun = {
  prefix: 'far',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faTrashCanSlash = {
  prefix: 'far',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V128h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H464 450.2L413.5 24.9C403.1 9.4 385.6 0 366.9 0H273.1c-18.7 0-36.2 9.4-46.6 24.9L189.8 80H176 134.4L38.8 5.1zM195.6 128H464V338.4l-48-37.6V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v83.7L336 238V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v21L195.6 128zm77.5-80h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM492.7 484.2l-37.8-29.8c-5.8 5.9-13.9 9.6-22.9 9.6H208c-17.7 0-32-14.3-32-32V234.7l-48-37.8V432c0 44.2 35.8 80 80 80H432c24.3 0 46-10.8 60.7-27.8zM224 272.5V400c0 8.8 7.2 16 16 16s16-7.2 16-16V297.7l-32-25.2zm80 63V400c0 8.8 7.2 16 16 16s16-7.2 16-16V360.7l-32-25.2z"]
};
var faTrashAltSlash = faTrashCanSlash;
var faScreenUsers = {
  prefix: 'far',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M80 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0A64 64 0 1 0 32 320a64 64 0 1 0 128 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64zm240-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H288zM544 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-96 96c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H512c-35.3 0-64 28.7-64 64zM544 48H96c-8.8 0-16 7.2-16 16V225.3c-18.3 3.1-34.8 11.3-48 23.1V64C32 28.7 60.7 0 96 0H544c35.3 0 64 28.7 64 64V248.4c-13.2-11.8-29.7-20.1-48-23.1V64c0-8.8-7.2-16-16-16z"]
};
var faUsersClass = faScreenUsers;
var faGuitar = {
  prefix: 'far',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M431 7c9.4-9.4 24.6-9.4 33.9 0l40 40c9.4 9.4 9.4 24.6 0 33.9l-48 48c-2.4 2.4-5.3 4.3-8.5 5.5l-59.1 22.2-35.8 35.8c38.2 50.8 41.4 115.2 4.6 152c-12 12-26.8 19.7-43.2 23.4c-18.1 4.1-33.5 20.8-34.5 39.4c-1.4 27.9-11.7 53.8-31.2 73.4C200.3 529.4 112 520.3 51.8 460.2S-17.4 311.7 31.4 262.8C51 243.2 76.9 233 104.8 231.5c18.5-.9 35.3-16.4 39.4-34.5c3.7-16.4 11.4-31.2 23.4-43.2c36.8-36.8 101.2-33.6 152 4.6l35.8-35.8 22.2-59.1c1.2-3.2 3.1-6.1 5.5-8.5L431 7zM254.4 291.6c1.1 4 1.6 8.1 1.6 12.4c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.3 0 8.5 .6 12.4 1.6l64.8-64.8c-36-24.5-70.6-18.1-83.8-5c-5 5-8.6 11.5-10.5 19.8c-8.3 37-41.6 69.7-83.8 71.9c-17.6 .9-31.7 7.1-41.9 17.3c-23.9 23.9-27.9 81.2 20.4 129.5s105.6 44.3 129.5 20.4c10.1-10.1 16.4-24.3 17.3-41.9c2.1-42.2 34.9-75.4 71.9-83.8c8.3-1.9 14.8-5.5 19.8-10.5c13.2-13.2 19.6-47.8-5-83.8l-64.8 64.8z"]
};
var faSquareArrowLeft = {
  prefix: 'far',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm39 241l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L328 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-150.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9z"]
};
var faArrowSquareLeft = faSquareArrowLeft;
var faSquare8 = {
  prefix: 'far',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm168 96H216c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H216s0 0 0 0zm0 48c0 0 0 0 0 0h16c0 0 0 0 0 0h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h8z"]
};
var faFaceSmileHearts = {
  prefix: 'far',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M553.5 361.1C568 329 576 293.4 576 256c0-24.5-3.4-48.2-9.9-70.6c-3.6-12.7-16.9-20.1-29.7-16.5s-20.1 16.9-16.5 29.7c5.2 18.2 8 37.4 8 57.4c0 35.3-8.8 68.5-24.3 97.6c16.7-3.7 34.5-1.2 49.8 7.4zM448.1 419.9C412.8 447.5 368.3 464 320 464c-50.4 0-96.6-17.9-132.6-47.7c-3.4 9.1-8.8 17.7-16.1 25l-13.1 13.1C202.4 490.4 258.7 512 320 512c53.3 0 102.8-16.3 143.8-44.2c-11.2-13.9-16.5-31-15.7-47.9zm-326-99.8C115.5 299.9 112 278.4 112 256c0-114.9 93.1-208 208-208c30.7 0 59.9 6.7 86.1 18.6c12.1 5.5 26.3 .2 31.8-11.9s.2-26.3-11.9-31.8C393.6 8.2 357.7 0 320 0C178.6 0 64 114.6 64 256c0 25.7 3.8 50.5 10.8 73.8c1.8 1.1 3.5 2.2 5.2 3.4c12.5-9 27.3-13.4 42-13.2zm85.7-3.3c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C383.2 334.5 357.2 352 320 352s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm6.5-87.1c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C279.7 186.8 259 180 239.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM399.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C439.7 186.8 419 180 399.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM573.7 11.5L560 25.3 546.3 11.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0zm54.9 384c-15.2-15.3-39.8-15.3-54.9 0L560 409.3l-13.7-13.8c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2zm-534.9-32L80 377.3 66.3 363.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0z"]
};
var faBracketsSquare = {
  prefix: 'far',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M56 32C25.1 32 0 57.1 0 88V424c0 30.9 25.1 56 56 56h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H56zm336 0H328c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c4.4 0 8 3.6 8 8V424c0 4.4-3.6 8-8 8H328c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56z"]
};
var faBrackets = faBracketsSquare;
var faLaptopArrowDown = {
  prefix: 'far',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M256 32V80H128c-8.8 0-16 7.2-16 16V320H64V96c0-35.3 28.7-64 64-64H256zM384 80V32H512c35.3 0 64 28.7 64 64V320H528V96c0-8.8-7.2-16-16-16H384zM320 32c13.3 0 24 10.7 24 24V238.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V56c0-13.3 10.7-24 24-24zM96 432H544c20.9 0 38.7-13.4 45.3-32H50.7c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32c0 53-43 96-96 96H96c-53 0-96-43-96-96z"]
};
var faHockeyStickPuck = {
  prefix: 'far',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H304c1.3 0 2.5 .1 3.7 .3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368H144v96h74.8c9 0 17.2-5 21.3-13L283 368zM64 368c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H96V368H64zm368 64v32H592V432H432zm-48 0c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V432z"]
};
var faHouseTree = {
  prefix: 'far',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M417.4 7.5C412.9 2.7 406.6 0 400 0s-12.9 2.7-17.4 7.5l-103.5 109 35.4 32.4 85.5-90L496.1 160H448c-9.6 0-18.2 5.7-22 14.5s-2 19 4.6 26L528.3 304H480c-9.4 0-17.9 5.4-21.8 13.9s-2.6 18.5 3.5 25.6L564.1 464H416c0 18-6 34.6-16 48H616c9.4 0 17.9-5.4 21.8-13.9s2.6-18.5-3.5-25.6L531.9 352H584c9.6 0 18.2-5.7 22-14.5s2-19-4.6-26L503.7 208H552c9.6 0 18.3-5.7 22.1-14.5s2-19-4.7-26l-152-160zM20.8 237C7.5 249.1 0 266.2 0 284.2V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V284.2zM144 296v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24z"]
};
var faSignalFair = {
  prefix: 'far',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", "M192 288c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faSignal2 = faSignalFair;
var faFaceLaughWink = {
  prefix: 'far',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
var faLaughWink = faFaceLaughWink;
var faCircleDollar = {
  prefix: 'far',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM276.8 133.6v14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
var faDollarCircle = faCircleDollar;
var faUsdCircle = faCircleDollar;
var faHorseHead = {
  prefix: 'far',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", "M405.1 48.7c9.2-3.3 18.9 3.6 18.9 13.4c0 4.2-1.9 8.2-5.1 10.9l-34.3 28.5c-7.3 6.1-10.4 16-7.7 25.2s10.6 15.9 20.1 17.1l1.5 .2c31.3 3.9 58.7 23 73.3 51L520 287.8c11 21.3 7 47.2-9.9 64.2c-10.3 10.3-24.3 16.1-38.8 16.1h-7.4c-18.5 0-36-8-48.2-21.9l-26.2-30c-10.3-11.8-28-13.5-40.4-3.9c-27.6 21.5-67.3 17.2-89.7-9.7l-25-30c-8.5-10.2-23.6-11.6-33.8-3.1s-11.6 23.6-3.1 33.8l25 30c25 30 62.3 43.8 98.6 40l43.4 68.2c2.3 3.5 3.5 7.7 3.5 11.9c0 5.8-4.7 10.6-10.6 10.6H136c-13.3 0-24-10.7-24-24V316.7c0-98.2 61.8-185.7 154.3-218.6L405.1 48.7zm0 367l-21.5-33.8c21 21.7 50 34.1 80.4 34.1h7.4c27.3 0 53.5-10.8 72.8-30.1c31.7-31.7 39.2-80.4 18.5-120.2l-48.3-92.8c-14.4-27.8-37.3-49.6-64.7-63C463.8 98 472 80.5 472 62.1c0-43-42.5-73-83-58.6L250.2 52.9C138.6 92.5 64 198.2 64 316.7V440c0 39.8 32.2 72 72 72H357.4c32.4 0 58.6-26.2 58.6-58.6c0-13.3-3.8-26.4-11-37.6zM360 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsRepeat = {
  prefix: 'far',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M0 254.5c-.8 13.2 9.2 24.6 22.5 25.5s24.6-9.2 25.5-22.5l.5-8C51.9 194.7 97.3 152 152.2 152H366.1l-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H152.2C72 104 5.6 166.4 .5 246.5l-.5 8zm511.9 3c.8-13.2-9.2-24.6-22.5-25.5s-24.6 9.2-25.4 22.5l-.5 8c-3.4 54.8-48.9 97.5-103.8 97.5H145.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 367c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55H359.8c80.3 0 146.7-62.4 151.7-142.5l.5-8z"]
};
var faRepeatAlt = faArrowsRepeat;
var faBoreHole = {
  prefix: 'far',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M256 0c13.3 0 24 10.7 24 24V228.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V24c0-13.3 10.7-24 24-24zm0 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM112 176H80c-17.7 0-32 14.3-32 32V432c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V208c0-17.7-14.3-32-32-32H400V288c0 79.5-64.5 144-144 144s-144-64.5-144-144V176zm16-48c17.7 0 32 14.3 32 32V288c0 53 43 96 96 96s96-43 96-96V160c0-17.7 14.3-32 32-32h48c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V208c0-44.2 35.8-80 80-80h48z"]
};
var faIndustry = {
  prefix: 'far',
  iconName: 'industry',
  icon: [576, 512, [], "f275", "M88 80c-4.4 0-8 3.6-8 8V304v48 56c0 13.3 10.7 24 24 24H472c13.3 0 24-10.7 24-24V320 304l0-148.1-139.1 89c-7.4 4.7-16.8 5-24.5 .8s-12.5-12.3-12.5-21.1l0-70.9L180.1 235.4c-7.4 4.3-16.6 4.4-24 .1s-12-12.2-12-20.8V88c0-4.4-3.6-8-8-8H88zM32 88c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56v84.9l103.8-60.6c32-18.7 72.2 4.4 72.2 41.5v27l102.1-65.4C502.1 95 544 117.9 544 155.9V304v16 88c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V352 304 88z"]
};
var faImagePolaroid = {
  prefix: 'far',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M400 368v48c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V368H400zM75.3 320H48V96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V320H376.4L284.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-56 85.6-16.6-22.6c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L75.3 320zM448 320V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V320v24 24 48c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V368 344 320zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faWaveTriangle = {
  prefix: 'far',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", "M176.1 32c7.7 0 14.9 3.7 19.4 10L464.1 415.1 596.6 233.8c7.8-10.7 22.8-13 33.5-5.2s13 22.8 5.2 33.5l-152 208c-4.5 6.2-11.8 9.9-19.5 9.8s-14.9-3.7-19.4-10L175.9 96.9 43.4 278.2c-7.8 10.7-22.8 13-33.5 5.2s-13-22.8-5.2-33.5l152-208c4.5-6.2 11.8-9.9 19.5-9.8z"]
};
var faPersonRunningFast = {
  prefix: 'far',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", "M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L321.1 480.8c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8L403 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C393.3 272 415 288 439.6 288H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H439.6c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8zM218.5 317.1L199.4 368H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h84.9c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm-16 80c0 8.8 7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
};
var faCircleDown = {
  prefix: 'far',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H304V160c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32v96H150.3C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"]
};
var faArrowAltCircleDown = faCircleDown;
var faGrill = {
  prefix: 'far',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M48 80H400V96c0 97.2-78.8 176-176 176S48 193.2 48 96V80zM40 32C17.9 32 0 49.9 0 72V96c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64H316.7l21.2 49.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L318.8 299C395.1 263.3 448 185.8 448 96V72c0-22.1-17.9-40-40-40H40zM151.8 368l22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4s33.4-1.9 49.3-5.4L296.2 368H151.8zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faArrowsTurnToDots = {
  prefix: 'far',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", "M255 31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39L424 104c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-22.1-17.9-40-40-40l-174.1 0 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9l80-80zM257 287l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L88 408c-22.1 0-40 17.9-40 40v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448c0-48.6 39.4-88 88-88l174.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm127 97a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"]
};
var faChartMixed = {
  prefix: 'far',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", "M503.6 74.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6L320.2 168.3 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2l168-144zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8V432zm-8-208c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-4.4 3.6-8 8-8s8 3.6 8 8v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zm264 16v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V336c0-4.4 3.6-8 8-8s8 3.6 8 8zm-56 0v96c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48zm184 96c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8V432zm-8-208c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48z"]
};
var faAnalytics = faChartMixed;
var faFlorinSign = {
  prefix: 'far',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M315.3 32c-36 0-68.3 21.9-81.7 55.3L179 224H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.8L105.8 406.9C99.7 422 85 432 68.7 432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H68.7c36 0 68.3-21.9 81.7-55.3L211.4 272H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H230.6l47.5-118.9C284.3 90 299 80 315.3 80H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H315.3z"]
};
var faArrowDownShortWide = {
  prefix: 'far',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M15 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM312 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H312zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H312zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H312zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H312z"]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faLessThan = {
  prefix: 'far',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", "M381.5 77.3c5.9 11.9 1.1 26.3-10.7 32.2L77.7 256 370.7 402.5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-336-168C5.1 273.4 0 265.1 0 256s5.1-17.4 13.3-21.5l336-168c11.9-5.9 26.3-1.1 32.2 10.7z"]
};
var faDisplayCode = {
  prefix: 'far',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", "M512 48c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H336.5c-.3 0-.6 0-.8 0H240.4c-.3 0-.6 0-.8 0H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H512zM64 416H211.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H352h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H372.3l-8-48H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm188.3 48l8-48h55.3l8 48H252.3zM249 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM361 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]
};
var faDesktopCode = faDisplayCode;
var faFaceDrooling = {
  prefix: 'far',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M48 256c0 114.9 93.1 208 208 208v48C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 80.8-37.5 152.9-96 199.9V388.9c30-36 48-82.4 48-132.9c0-114.9-93.1-208-208-208S48 141.1 48 256zm110.8-32.4c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4c3.8-11.3 12.2-26.8 25.8-39.8C153.2 155.2 173.5 144 200 144c13.3 0 24 10.7 24 24s-10.7 24-24 24c-11.9 0-20.9 4.8-27.9 11.4c-7.4 7-11.8 15.5-13.4 20.2zM129 309.3c10.4-8.3 25.5-6.6 33.7 3.7c18.7 23.4 49.8 47 93.3 47s74.5-23.6 93.3-47c8.3-10.4 23.4-12 33.7-3.7s12 23.4 3.8 33.7c-.9 1.1-1.8 2.2-2.7 3.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.4c-9.5 7-20.2 13.3-32 18.5V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V404.9c-10 2-20.7 3.1-32 3.1c-62.6 0-106.2-34.3-130.7-65c-8.3-10.3-6.6-25.5 3.7-33.7zM339.9 203.4c-7-6.6-16-11.4-27.9-11.4c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.5 0 46.8 11.2 60.9 24.6c13.7 13 22.1 28.5 25.8 39.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2c-1.6-4.7-6-13.2-13.4-20.2z"]
};
var faOilTemperature = {
  prefix: 'far',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", "M264 24c0-13.3 10.7-24 24-24h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H312V96h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H312v83.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V120 24zm24 312a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM111.9 286.1c17.8 15.4 41.2 28.5 65 32.6c2.4 18.1 9.1 34.9 19.1 49.3c-1.3 0-2.7 .1-4.1 .1c-34.6 0-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0zM384 368c-1.3 0-2.7 0-4-.1c10-14.3 16.7-31.1 19.1-49.3c23.8-4.1 47.2-17.2 65-32.6c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8zm-272 62.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faOilTemp = faOilTemperature;
var faSquareQuestion = {
  prefix: 'far',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm137.8 69.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H190.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faQuestionSquare = faSquareQuestion;
var faAirConditioner = {
  prefix: 'far',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M64 48c-8.8 0-16 7.2-16 16V192c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm120 64H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM368 288V392c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7c-11.5-6.6-15.4-21.3-8.7-32.8s21.3-15.4 32.8-8.7C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88V288h48zM208 424V288h48V424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2c11.5-6.6 26.2-2.7 32.8 8.7s2.7 26.2-8.7 32.8c-12 7-20 19.9-20 34.7c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
};
var faAngleDown = {
  prefix: 'far',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z"]
};
var faMountains = {
  prefix: 'far',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M464 424.1c0 4.4-3.5 7.9-7.9 7.9H55.9c-4.4 0-7.9-3.5-7.9-7.9c0-1.5 .4-2.9 1.2-4.2L256 90.3 462.8 419.9c.8 1.3 1.2 2.7 1.2 4.2zm-464 0C0 455 25 480 55.9 480H456.1 578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1z"]
};
var faOmega = {
  prefix: 'far',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 80C126.8 80 48 158.8 48 256c0 63.7 33.8 119.5 84.6 150.4c11.4 7 19.4 19.6 19.4 34.2c0 21.8-17.6 39.4-39.4 39.4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H85.4C33.4 391 0 327.4 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 71.4-33.4 135-85.4 176H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H335.4c-21.8 0-39.4-17.6-39.4-39.4c0-14.6 8-27.2 19.4-34.2C366.2 375.5 400 319.7 400 256c0-97.2-78.8-176-176-176z"]
};
var faCarTunnel = {
  prefix: 'far',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 48C141.1 48 48 141.1 48 256V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-114.9-93.1-208-208-208zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM122.7 332l22.5-69.3c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7L389.3 332c16.1 11.6 26.7 30.6 26.7 52V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H144v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V384c0-21.4 10.5-40.4 26.7-52zM144 432H368V384c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16v48zm16-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPersonDollyEmpty = {
  prefix: 'far',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM0 488L0 340.3c.5 .4 1.1 .9 1.6 1.3L48 378.1 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24zM60.6 176c-6.9 0-12.6 5.6-12.6 12.6v83.9c0 2.5 1.1 4.8 3.1 6.3L72 295.2v-117c-3.6-1.4-7.5-2.2-11.4-2.2zM120 234.7v98.2l25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4L113.6 388.9 21.4 316.5C7.9 305.9 0 289.6 0 272.4V188.6C0 155.1 27.1 128 60.6 128c24.8 0 48.2 11.7 63.1 31.5L172 224h35.3l-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L219.3 272H168c-12.6 0-24.4-5.9-32-16l-16-21.3zM304 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPanFood = {
  prefix: 'far',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M528 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zM48 184V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm568-24c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24zM243.4 142.8C250.7 106.3 282.8 80 320 80s69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14H254.3c-7.4 0-12.9-6.8-11.5-14l.6-3.2zm-13.3 43.1c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM227.3 284.7c2.1 2.1 3.5 4.6 4.2 7.3c.4 1.7 .8 3.4 1.1 5.1l0 0c1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7H280c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56V349.3c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9c-1.7-.3-3.5-.7-5.1-1.1c-2.7-.7-5.2-2.1-7.3-4.2c-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zm132.9-4.9l79.6-79.6c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6v4.8c0 18.7-8.5 36.4-23.1 48.1C446 315.2 432.4 320 418.4 320l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4z"]
};
var faHeadSideCough = {
  prefix: 'far',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M224 48C126.8 48 48 126.8 48 224c0 42.2 14.8 80.8 39.5 111.1c13.6 16.6 24.5 38.5 24.5 63.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V398.6c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224C0 100.3 100.3 0 224 0h24c78.8 0 151.4 47.6 183.2 116.2c4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29c9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45c0 35.1-28.5 63.6-63.6 63.6H448v0 24 64 8c0 35.3-28.7 64-64 64H318.6c-3.3 9.3-12.2 16-22.6 16c-13.3 0-24-10.7-24-24V472c0-13.3 10.7-24 24-24h88c8.8 0 16-7.2 16-16v-8-9.3l-58.4-4.9c-12.2-1-21.6-11.2-21.6-23.4c0-10.8 7.3-20.2 17.8-22.8L400 348V336v-8V312c0-13.3 10.7-24 24-24h24.4c8.6 0 15.6-7 15.6-15.6c0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1c-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48H224zm80 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM488 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM528 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM528 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faGripLines = {
  prefix: 'far',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M448 192c0-13.3-10.7-24-24-24L24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24zm0 128c0-13.3-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24z"]
};
var faThumbsDown = {
  prefix: 'far',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"]
};
var faUserLock = {
  prefix: 'far',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464H384v16c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3v67.7C361.9 379.3 319 352 269.7 352H178.3c-65.7 0-120.1 48.7-129 112zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faArrowRightLong = {
  prefix: 'far',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", "M505 273c9.4-9.4 9.4-24.6 0-33.9L369 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l95 95L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l406.1 0-95 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z"]
};
var faLongArrowRight = faArrowRightLong;
var faTicketsAirline = {
  prefix: 'far',
  iconName: 'tickets-airline',
  icon: [640, 512, [], "e29b", "M144 96V320c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V281.8c-24-15.7-40-42.8-40-73.8s16-58.1 40-73.8V96c0-8.8-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zm16-64H576c35.3 0 64 28.7 64 64v56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1v56c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM24 96c13.3 0 24 10.7 24 24V360c0 39.8 32.2 72 72 72H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H120C53.7 480 0 426.3 0 360V120c0-13.3 10.7-24 24-24zm264.4 80l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5H304c8.5 0 16.4 4.5 20.7 11.9L364.4 176h40.3c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7H364.4l-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9H272.9c-5.5 0-9.3-5.3-7.6-10.5L288.4 240H245.8l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H200c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9h13.8c5 0 9.8 2.4 12.8 6.4L245.8 176h42.7z"]
};
var faAnchorCircleXmark = {
  prefix: 'far',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V464H240c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h48 48c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5H312V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faEllipsis = {
  prefix: 'far',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
var faEllipsisH = faEllipsis;
var faNfcSlash = {
  prefix: 'far',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM145.7 88.9c2.6-5.3 8.1-8.9 14.3-8.9H480c8.8 0 16 7.2 16 16V363.5l-32-25.1V152c0-22.1-17.9-40-40-40H336c-22.1 0-40 17.9-40 40v54.7l-60-47c11.4-1.9 20-11.8 20-23.7c0-13.3-10.7-24-24-24H216c-10.5 0-20.1 4-27.2 10.7L145.7 88.9zM416 300.8l-48.5-38c.3-2.2 .5-4.5 .5-6.8c0-17.8-9.7-33.3-24-41.6V160h72V300.8zm70.9 178.9L426.5 432H160c-8.8 0-16-7.2-16-16V209.5L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4zM385.8 400l-60.9-48H224V272.5l-48-37.8V360c0 22.1 17.9 40 40 40H385.8z"]
};
var faChessPawn = {
  prefix: 'far',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120H243.4l10.7 80H205.7L195 272H160 125l-10.7 80H65.9l10.7-80H64c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464H267.3l-16.6-32H69.2L52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h201z"]
};
var faKitMedical = {
  prefix: 'far',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", "M144 432H432V80H144V432zm-48 0V80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H96zM64 32H96h24 24H432h24 24 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H480 456 432 144 120 96 64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32zM480 432h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H480V432zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"]
};
var faFirstAid = faKitMedical;
var faGrid2Plus = {
  prefix: 'far',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", "M176 80H80v96h96V80zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 304H80v96h96V336zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 80v96h96V80H336zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
};
var faBells = {
  prefix: 'far',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M230.8 245.5C203.2 170.3 232.4 88.2 296.5 46c-4.5-2.2-9.1-4.2-13.9-6C214 15.1 138 50.4 112.8 119L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c9.4-32.5 8.1-67.2-3.5-99.1l-18.7-51.2zM306 218.2c-17-46.4 6.9-97.8 53.3-114.7s97.9 7 114.9 53.4l18.8 51.2c15.8 43.1 43.6 80.8 80.1 108.5L333.7 403.7c9.9-44.6 6.9-91.2-9-134.4L306 218.2zM283.9 404.6l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2C493.2 69.2 414.1 32.5 342.8 58.4s-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9zM480.8 480c35.6 0 64.5-28.8 64.5-64.3c0-1.3 0-2.6-.1-3.9L429.1 454.1c11.8 15.7 30.6 25.9 51.7 25.9zM94.3 376.1c-.3 2.5-.4 5-.4 7.5c0 35.5 28.9 64.3 64.5 64.3c22.3 0 41.9-11.3 53.5-28.4L94.3 376.1z"]
};
var faPersonThroughWindow = {
  prefix: 'far',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M304 48V66.4c0 46.1-28.9 87.3-72.2 103.1C169.5 192.1 128 251.3 128 317.6l0 82.4H48L48 48H304zm48 0H592V400H510.3L499 385.4l-75.2-97.8c-7.6-9.8-19.3-15.6-31.7-15.6L333 272l-49.4-75.7c42.1-28.9 68.4-77.2 68.4-130V48zm97.7 352H365.9l32 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H303.9l36.2 53.5c7.4 11 22.4 13.8 33.3 6.4s13.8-22.4 6.4-33.3L297.2 352.5 343.6 320l44.6 0 61.5 80zm-178.3 0H176l0-82.4c0-15.7 3.3-30.8 9.4-44.5l86 126.9zm-1.1-87.3l-54.1-79.9c7.3-6 15.4-11 24.2-15l51.9 79.6-22 15.4zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faToolbox = {
  prefix: 'far',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M184 80H328c4.4 0 8 3.6 8 8v40H176V88c0-4.4 3.6-8 8-8zm-56 8v40H99.9c-12.7 0-24.9 5.1-33.9 14.1L14.1 193.9c-9 9-14.1 21.2-14.1 33.9V320v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320 227.9c0-12.7-5.1-24.9-14.1-33.9l-51.9-51.9c-9-9-21.2-14.1-33.9-14.1H384V88c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM464 296H368V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H192V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H48V227.9L99.9 176H412.1L464 227.9V296zM48 344h96v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344H320v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344h96v72c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V344z"]
};
var faEnvelopeDot = {
  prefix: 'far',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M496 160A80 80 0 1 0 496 0a80 80 0 1 0 0 160zm16 224V190.9c-5.2 .7-10.6 1.1-16 1.1c-22.5 0-43.5-6.6-61-18.1L291.5 291.7c-20.7 17-50.4 17-71.1 0L48 150.1V128c0-8.8 7.2-16 16-16H388.6c-3-10.1-4.6-20.9-4.6-32c0-5.4 .4-10.8 1.1-16H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64zM48 212.2L190 328.8c38.4 31.5 93.7 31.5 132 0L464 212.2V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V212.2z"]
};
var faEnvelopeBadge = faEnvelopeDot;
var faHandsHoldingCircle = {
  prefix: 'far',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M320 256A128 128 0 1 0 320 0a128 128 0 1 0 0 256zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136V352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2V136c0-13.3 10.7-24 24-24s24 10.7 24 24V281.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9 0 0L167 393l0 0 16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16 0 0-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V436.8c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359l0 0-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16 0 0 26.7-26.7 0 0 15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4V136c0-13.3 10.7-24 24-24s24 10.7 24 24V352.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9V136c0-39.8-32.2-72-72-72s-72 32.2-72 72V264.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8V136z"]
};
var faBug = {
  prefix: 'far',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM39 103c9.4-9.4 24.6-9.4 33.9 0l72.4 72.4C161.3 165.7 180 160 200 160H312c20 0 38.7 5.7 54.6 15.5L439 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C410.3 225.3 416 244 416 264h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H416v8c0 27.2-6.8 52.8-18.8 75.3L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-70.9-70.9C339.3 462.5 299.7 480 256 480s-83.3-17.5-112.2-45.9L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8C102.8 372.8 96 347.2 96 320v-8H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96c0-20 5.7-38.7 15.5-54.6L39 137c-9.4-9.4-9.4-24.6 0-33.9zM144 264v56c0 53.6 37.7 98.4 88 109.4V280c0-13.3 10.7-24 24-24s24 10.7 24 24V429.4c50.3-11 88-55.8 88-109.4V264c0-30.9-25.1-56-56-56H200c-30.9 0-56 25.1-56 56z"]
};
var faBowlChopsticks = {
  prefix: 'far',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23l-473.8 74zM0 159.7c0-8.8 7-16 15.7-16.2l471.9-14.7C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6H16.2C7.3 176 0 168.7 0 159.7zM151.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1H328c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272H48c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8H184c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272z"]
};
var faCreditCard = {
  prefix: 'far',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faCreditCardAlt = faCreditCard;
var faCircleS = {
  prefix: 'far',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c1.1-6.2 5-11.8 15.4-15.8c11-4.3 27.6-6 47.8-2.9c6 .9 20.6 4 27.3 5.7c12.8 3.3 25.9-4.5 29.2-17.3s-4.5-25.9-17.3-29.2c-7.7-2-23.9-5.5-32-6.7c-25.6-3.9-51.3-2.6-72.6 5.7c-21.9 8.6-40.3 25.7-45 52c-2.6 14.4-1.3 28 4.4 40.3c5.6 12.1 14.7 20.8 24.1 27.2c17.2 11.6 40.3 18.1 58.6 23.2l2 .6c21.1 5.9 36.7 10.6 46.8 17.4c4.5 3 6.5 5.6 7.4 7.7c.9 1.9 1.8 5.2 .6 11.6c-1.1 6.2-5 11.8-15.4 15.8c-11 4.3-27.5 6-47.7 2.9c-12.2-1.9-36.1-8.9-50-13.4c-12.6-4-26.1 2.9-30.2 15.5s2.9 26.1 15.5 30.2c13.6 4.4 40.9 12.5 57.3 15.1l0 0 .1 0c25.6 3.9 51.3 2.6 72.6-5.7c21.9-8.6 40.3-25.7 45-52c2.6-14.4 1.4-28-4.4-40.3c-5.6-12.1-14.7-20.8-24.1-27.2c-17.2-11.6-40.3-18.1-58.6-23.2l-2-.6c-21.1-5.9-36.7-10.6-46.8-17.4c-4.5-3-6.5-5.6-7.4-7.7c-.9-1.9-1.8-5.2-.6-11.6z"]
};
var faBoxBallot = {
  prefix: 'far',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", "M176 208H400V48H176V208zM128 32c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32zM48 160H96v48H48V320H528V208H480V160h48c26.5 0 48 21.5 48 48V320v24 24 96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368 344 320 208c0-26.5 21.5-48 48-48zM528 368H48l0 96H528V368z"]
};
var faCar = {
  prefix: 'far',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M127.7 106.8L103.4 176H408.6l-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8H165.4c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32H346.6c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9C492.6 205.4 512 236.4 512 272v80 48 56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H48v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400 352 272c0-35.6 19.3-66.6 48.1-83.2zM416 224H96c-26.5 0-48 21.5-48 48v80H464V272c0-26.5-21.5-48-48-48zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faAutomobile = faCar;
var faHandHoldingHand = {
  prefix: 'far',
  iconName: 'hand-holding-hand',
  icon: [512, 512, [], "e4f7", "M146.8 318.9c5.8-3.9 12.7-6 19.7-6H305.8c7.9 0 14.2 6.4 14.2 14.2s-6.4 14.2-14.2 14.2H284.4 227.6c-11.8 0-21.3 9.6-21.3 21.3s9.6 21.3 21.3 21.3h56.9 21.3 42.7c3.9 0 7.8-1.1 11.2-3.2l83.1-51.1c2.8-1.7 5.9-2.6 9.2-2.6h6.6c6 0 10.9 4.9 10.9 10.9c0 3.7-1.9 7.1-5 9.2l-85 55c-10.4 6.7-22.4 10.3-34.8 10.3H21.3C9.6 412.4 0 422 0 433.8s9.6 21.3 21.3 21.3H344.6c20.6 0 40.7-5.9 57.9-17.1l85-55c15.3-9.9 24.5-26.8 24.5-45c0-29.6-24-53.6-53.6-53.6h-6.6c-11.1 0-22 3.1-31.5 8.9l-57.7 35.5c0-.6 0-1.2 0-1.8c0-31.4-25.5-56.9-56.9-56.9H166.6c-15.4 0-30.5 4.6-43.4 13.1L57.5 327.1H21.3C9.6 327.1 0 336.7 0 348.4s9.6 21.3 21.3 21.3H64c4.2 0 8.3-1.2 11.8-3.6l71-47.3zM365.2 193.1c-5.8 3.9-12.7 6-19.7 6H206.2c-7.9 0-14.2-6.4-14.2-14.2s6.4-14.2 14.2-14.2h21.3 56.9c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H227.6 206.2 163.6c-3.9 0-7.8 1.1-11.2 3.2L69.3 182.3c-2.8 1.7-5.9 2.6-9.2 2.6H53.6c-6 0-10.9-4.9-10.9-10.9c0-3.7 1.9-7.1 5-9.2l85-55c10.4-6.7 22.4-10.3 34.8-10.3H490.7c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H167.4c-20.6 0-40.7 5.9-57.9 17.1l-85 55C9.2 138.9 0 155.8 0 174c0 29.6 24 53.6 53.6 53.6h6.6c11.1 0 22-3.1 31.5-8.9l57.7-35.5c0 .6 0 1.2 0 1.8c0 31.4 25.5 56.9 56.9 56.9H345.4c15.4 0 30.5-4.6 43.4-13.1l65.6-43.8h36.2c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H448c-4.2 0-8.3 1.2-11.8 3.6l-71 47.3z"]
};
var faUserTieHair = {
  prefix: 'far',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M304 144V128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128C96 57.3 153.3 0 224 0zm30.8 418.4l43.8-87.6c3-6 9.4-9.5 15.9-8.4C390.4 335.6 448 401.7 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9c6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2zM118.5 376.3C82.3 391.1 55.4 424.2 49.3 464h113l-43.8-87.7zM285.7 464h113c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z"]
};
var faPodiumStar = {
  prefix: 'far',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M182.4 72c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H224c-17.8 0-33.3 9.7-41.6 24H168c-48.6 0-88 39.4-88 88v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H128V112c0-22.1 17.9-40 40-40h14.4zM47.3 224L73.5 455.2c3.7 32.3 31 56.8 63.6 56.8H310.9c32.6 0 59.9-24.4 63.6-56.8L400.7 224H352.4L326.8 449.8c-.9 8.1-7.8 14.2-15.9 14.2H137.1c-8.1 0-15-6.1-15.9-14.2L95.6 224H47.3zm201.5 77.7l-18.2-41.3c-2.6-5.8-10.5-5.8-13.1 0l-18.2 41.3c-1.1 2.4-3.2 4-5.7 4.3l-43.2 5.4c-6.1 .8-8.6 8.7-4 13l31.9 30.9c1.8 1.8 2.7 4.4 2.2 7L171.9 407c-1.2 6.3 5.2 11.2 10.6 8.1l37.9-22.2c2.2-1.3 4.9-1.3 7 0L265.5 415c5.4 3.1 11.8-1.7 10.6-8.1l-8.5-44.6c-.5-2.6 .3-5.2 2.2-7l31.9-30.9c4.5-4.4 2.1-12.3-4-13L254.5 306c-2.5-.3-4.6-2-5.7-4.3z"]
};
var faUserHairMullet = {
  prefix: 'far',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M304 128c0-5.7-.6-11.3-1.7-16.6c-30.6-3.1-58.5-17.9-78.3-40.6c-19.8 22.7-47.6 37.5-78.3 40.6c-1.1 5.4-1.7 10.9-1.7 16.6v16c0 18 6 34.6 16 48h0v0c14.6 19.4 37.8 32 64 32s49.4-12.6 64-32v0h0c10-13.4 16-30 16-48V128zM237.4 271.3c-4.4 .5-8.9 .7-13.4 .7s-9-.2-13.4-.7L193 289c-5.5 5.5-13.2 8-20.8 6.7s-14.2-6.1-17.6-13l-6.1-12.2-19.5 7.8c-9.3 3.7-19.8 1.3-26.6-6s-8.3-18.1-3.8-27c8.5-17 11-22.3 12.2-27.1c.7-2.9 1.1-5.9 1.2-12.3C101.8 187.5 96 166.4 96 144V128c0-7.1 .6-14 1.7-20.7C91.8 102.9 88 95.9 88 88c0-13.3 10.7-24 24-24h1.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64H336c13.3 0 24 10.7 24 24c0 7.9-3.8 14.9-9.7 19.3c1.1 6.8 1.7 13.7 1.7 20.7v16c0 22.4-5.8 43.5-15.9 61.8c.1 6.4 .5 9.4 1.2 12.3c1.2 4.8 3.7 10.1 12.2 27.1c4.5 8.9 2.9 19.7-3.8 27s-17.3 9.7-26.6 6l-19.5-7.8-6.1 12.2c-3.4 6.9-10 11.7-17.6 13s-15.4-1.3-20.8-6.7l-17.7-17.7zM49.6 464H398.4c-9.3-54.5-56.8-96-113.9-96H163.6c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320H284.4C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"]
};
var faBusinessFront = faUserHairMullet;
var faPartyBack = faUserHairMullet;
var faTrianBalbot = faUserHairMullet;
var faMicrophoneStand = {
  prefix: 'far',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M476.9 204.9l1-1c45.9-46.9 45.6-122.2-1-168.7s-121.8-46.9-168.7-1l-1 .9 0 0-16 16-16 16 0 0-.9 1C251.8 91 240.4 120.7 240 150.5L17.2 388.2C6.1 400 0 415.5 0 431.6c0 16.8 6.7 33 18.6 44.9l16.8 16.8C47.4 505.3 63.5 512 80.4 512c16.1 0 31.7-6.1 43.4-17.2L232 393.4V488c0 13.3 10.7 24 24 24s24-10.7 24-24V348.4L361.5 272c29.8-.4 59.5-11.8 82.4-34.2l1-1 16-16 16-16zM361.9 224L325 187 288 150.1c.5-17.4 7.2-34.6 20.1-48L409.9 203.9c-13.4 12.9-30.7 19.6-48 20.1zm82-54L342.1 68.1c28.2-27.2 73-26.8 100.8 1s28.1 72.7 1 100.8zM80.4 464c-4.1 0-8.1-1.6-11-4.5L52.5 442.6c-2.9-2.9-4.5-6.9-4.5-11c0-3.9 1.5-7.7 4.2-10.6L264.6 194.5 291 221l26.5 26.5L91 459.8c-2.9 2.7-6.7 4.2-10.6 4.2z"]
};
var faBookOpenReader = {
  prefix: 'far',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M256 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 0a96 96 0 1 1 0 192A96 96 0 1 1 256 0zM228 279l-.2-.1c-.7-.5-2.4-1.5-5.2-2.9c-5.5-2.8-15.4-7.3-30.6-12.2c-28-9-74.2-19.3-144-22.7V417.4c84.9 5 147.1 22.3 184 35.7V282l-4-3zm52 3V453.1c36.9-13.4 99.1-30.7 184-35.7V241.1c-69.9 3.4-116 13.7-144 22.7c-15.1 4.9-25 9.4-30.6 12.2c-2.8 1.4-4.5 2.4-5.2 2.9l-.2 .1-4 3zM32 192.5C199.2 197.4 256 240 256 240s56.8-42.6 224-47.5c17.7-.5 32 13.9 32 31.5V432c0 17.7-14.4 31.9-32 32.7c-114.9 4.7-186.9 33.7-208.8 43.8c-4.8 2.2-9.9 3.5-15.1 3.5s-10.4-1.3-15.1-3.5c-21.9-10.1-93.9-39.1-208.8-43.8c-17.7-.7-32-15-32-32.7V224c0-17.7 14.4-32.1 32-31.5z"]
};
var faBookReader = faBookOpenReader;
var faFamilyDress = {
  prefix: 'far',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM112.3 208H128h15.7 38.9c-4.3-9.8-6.7-20.6-6.7-32c0-2.4 .1-4.8 .3-7.1c-9.6-5.7-20.8-8.9-32.6-8.9H112.3c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h37.5c-3.5-10-5.5-20.8-5.5-32V336H63.6L96.9 219.6c2-6.9 8.2-11.6 15.4-11.6zM336 176c0 11.4-2.4 22.2-6.7 32h38.9H384h15.7c7.1 0 13.4 4.7 15.4 11.6L448.4 336H368v16c0 11.2-1.9 22-5.5 32H400V488c0 13.3 10.7 24 24 24s24-10.7 24-24V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112v16c0 8.8-7.2 16-16 16H256 240c-8.8 0-16-7.2-16-16V336c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16V336c0-44.2-35.8-80-80-80s-80 35.8-80 80v16c0 24 13.2 44.9 32.7 55.8c-.5 2.7-.7 5.4-.7 8.2v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V416c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z"]
};
var faCircleX = {
  prefix: 'far',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8L224.6 256l-74.9 88.5c-8.6 10.1-7.3 25.3 2.8 33.8s25.3 7.3 33.8-2.8L256 293.2l69.7 82.3c8.6 10.1 23.7 11.4 33.8 2.8s11.4-23.7 2.8-33.8L287.4 256l74.9-88.5c8.6-10.1 7.3-25.3-2.8-33.8s-25.3-7.3-33.8 2.8L256 218.8l-69.7-82.3z"]
};
var faCabin = {
  prefix: 'far',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M256 54.1L95.3 176H416.7L256 54.1zM231.8 12.2c14.3-10.8 34.1-10.8 48.4 0L432 127.4V56c0-13.3 10.7-24 24-24s24 10.7 24 24V163.8l22.5 17.1c8.2 6.2 11.5 17 8.2 26.8s-12.4 16.3-22.7 16.3H24c-10.3 0-19.5-6.6-22.7-16.3s0-20.5 8.2-26.8L231.8 12.2zM32 296c0-13.3 10.7-24 24-24H168c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24H168c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM56 368H168c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zm264-72c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm24 168H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zM224 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMountainSun = {
  prefix: 'far',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", "M480 80a80 80 0 1 1 160 0A80 80 0 1 1 480 80zM412.7 281.7l48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1h0H55.9C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7zm28.5 45.4l62.2 99.2c5.6 8.9 8.6 19.2 8.6 29.7c0 2.7-.2 5.3-.6 7.9h67.4c7.2 0 13.1-5.9 13.1-13.1c0-2.4-.7-4.8-1.9-6.8L480 263.6l-38.8 63.6zM456.1 464c4.4 0 7.9-3.5 7.9-7.9c0-1.5-.4-2.9-1.2-4.2L256 122.3 49.2 451.9c-.8 1.3-1.2 2.7-1.2 4.2c0 4.4 3.5 7.9 7.9 7.9H456.1z"]
};
var faChartSimpleHorizontal = {
  prefix: 'far',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M400 240L48 240l0 32 352 0 0-32zm48 32c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 32zM208 400L48 400l0 32 160 0 0-32zm48 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32zm80-320l0-32L48 80l0 32 288 0zm0 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48z"]
};
var faBluetooth = {
  prefix: 'far',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M182.1 2.1c8.6-3.9 18.7-2.4 25.8 3.9l136 120c5.3 4.7 8.2 11.4 8.1 18.4s-3.3 13.6-8.7 18.1L229.8 256l113.5 93.5c5.4 4.5 8.6 11.1 8.7 18.1s-2.8 13.8-8.1 18.4l-136 120c-7.1 6.2-17.2 7.8-25.8 3.9S168 497.4 168 488V306.9L71.3 386.5c-10.2 8.4-25.4 7-33.8-3.3s-7-25.4 3.3-33.8L154.2 256 40.7 162.5C30.5 154.1 29 139 37.5 128.7s23.6-11.7 33.8-3.3L168 205.1V24c0-9.4 5.5-18 14.1-21.9zM216 306.9v128l75-66.2-75-61.8zm0-101.7l75-61.8L216 77.2v128z"]
};
var faArrowsLeftRightToLine = {
  prefix: 'far',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", "M24 64c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64zm217 71c9.4 9.4 9.4 24.6 0 33.9l-63 63 284.1 0-63-63c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L537 239c9.4 9.4 9.4 24.6 0 33.9L433 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l63-63-284.1 0 63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L207 135c9.4-9.4 24.6-9.4 33.9 0zM640 88V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHandBackPointLeft = {
  prefix: 'far',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 176c0-35.3 28.7-64 64-64l188.8 0c3.6-5.2 7.6-10.2 11.9-14.9l18.4-20.3C299.9 58.5 323.5 48 348.3 48l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 328c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-5.3 .7-10.5 1.9-15.5c-20.2-10.8-33.9-32-33.9-56.5c0-2.7 .2-5.4 .5-8L64 240c-35.3 0-64-28.7-64-64zm64-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l136 0c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8c0 8.8 7.2 16 16 16l8 0c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l20-11.7-20 11.7-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1L301.5 128l42.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-78 0-2 0L64 160z"]
};
var faMessageDots = {
  prefix: 'far',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCommentAltDots = faMessageDots;
var faMessaging = faMessageDots;
var faFileHeart = {
  prefix: 'far',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM93.7 306.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"]
};
var faBeerMug = {
  prefix: 'far',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", "M208 0c-26.8 0-51.1 11-68.5 28.8l-.1 0C126.9 20.7 112 16 96 16C51.8 16 16 51.8 16 96s35.8 80 80 80c16 0 30.9-4.7 43.4-12.8l.1 0C156.9 181 181.2 192 208 192c26.5 0 50.6-10.8 68-28.2l0 0c12.8 8.5 28.2 13.5 44.6 13.5c44.5 0 80.6-36.1 80.6-80.6s-36.1-80.6-80.6-80.6c-16.1 0-31.2 4.8-43.9 13l0 0C259.3 11.1 234.9 0 208 0zM173.1 63c8.8-9.3 21.1-15 34.9-15c13.8 0 26.2 5.8 35 15.1c8.4 8.9 19.6 12.8 29.3 13.7c9.7 .9 20.9-1 30.4-7.4c5.2-3.4 11.3-5.4 18-5.4c18 0 32.6 14.6 32.6 32.6s-14.6 32.6-32.6 32.6c-6.8 0-13.1-2.1-18.3-5.6c-9.4-6.4-20.6-8.4-30.3-7.7c-9.7 .7-20.9 4.5-29.4 13.3c-8.8 9.1-21 14.7-34.6 14.7c-13.7 0-26.1-5.7-34.9-15c-8.4-8.9-19.6-12.7-29.2-13.6c-9.7-.8-20.8 1.1-30.3 7.3c-5 3.3-11.1 5.3-17.6 5.3c-17.7 0-32-14.3-32-32s14.3-32 32-32c6.5 0 12.6 1.9 17.6 5.3c9.5 6.3 20.6 8.2 30.3 7.3c9.7-.8 20.8-4.7 29.2-13.6zM32 187.9V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64v-.3l86.8-38c25-11 41.2-35.7 41.2-63V228.8c0-38-30.8-68.8-68.8-68.8H413.8c-17.5 25.7-45.5 43.8-77.8 48.2V431.5c0 .4 0 .7 0 1.1V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V206.9c-17.7-2.5-34-9.2-48-18.9zM208 224c-8.8 0-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM320.3 97.2c.1 0 .1 .1 .1 .1l0 0c0 0 .1 0 .2 0c.1 0 .2 0 .2 0l0 0c0 0 .1-.1 .2-.2s.1-.2 .2-.2l0 0c0 0 0-.1 0-.2s0-.2 0-.2l0 0c0 0-.1-.1-.2-.2s-.2-.1-.2-.2l0 0c0 0-.1 0-.2 0c-.1 0-.1 0-.2 0l0 0s0 0 0 0s0 0-.1 0l-.9 .6 .8 .6zM96 96l0 0 0 0 0 0s0 0 0 0s0 0 0 0l0 0 0 0 0 0 0 0 0 0zM443.2 208c11.5 0 20.8 9.3 20.8 20.8V346.7c0 8.3-4.9 15.7-12.5 19.1L384 395.3V208h59.2zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faBeerFoam = faBeerMug;
var faDiceD20 = {
  prefix: 'far',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6V368c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368V144c0-8.4 4.4-16.2 11.7-20.6l200-120zM80 191.1v83.4L112.8 215 80 191.1zm65.5 63.9L94.9 347l115 9.2L145.5 255.1zm10.6 145L232 445.6V406.2l-75.9-6.1zM280 406.2v39.5l75.9-45.5L280 406.2zM432 274.6V191.1L399.2 215 432 274.6zM375 173.3l37.6-27.3L327.1 94.6 375 173.3zM184.9 94.6L99.4 145.9 137 173.3l47.9-78.6zM256 70.2L186.7 184H325.3L256 70.2zM324.3 232H187.7L256 339.3 324.3 232zM302.1 356.2l115-9.2-50.6-92L302.1 356.2z"]
};
var faDrone = {
  prefix: 'far',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M224 112C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c5.2 0 10.2-.3 15.2-1L88.7 171.6C64.9 162.3 48 139.1 48 112c0-35.3 28.7-64 64-64c27.1 0 50.3 16.9 59.6 40.7L223 127.2c.7-5 1-10.1 1-15.2zm-10.7 47.9l-39.8-29.9-29.7-22.3C141.7 92.1 128.2 80 112 80c-17.7 0-32 14.3-32 32c0 16.2 12.1 29.7 27.8 31.7l22.3 29.7 29.9 39.8 .1 .1v85.3l-.1 .1-29.9 39.8-22.3 29.7C92.1 370.3 80 383.8 80 400c0 17.7 14.3 32 32 32c16.2 0 29.7-12.1 31.7-27.8l29.7-22.3 39.8-29.9 .1-.1h85.3l.1 .1 39.8 29.9 29.7 22.3c2.1 15.7 15.5 27.8 31.7 27.8c17.7 0 32-14.3 32-32c0-16.2-12.1-29.7-27.8-31.7l-22.3-29.7-29.9-39.8-.1-.1V213.3l.1-.1 29.9-39.8 22.3-29.7c15.7-2.1 27.8-15.5 27.8-31.7c0-17.7-14.3-32-32-32c-16.2 0-29.7 12.1-31.7 27.8l-29.7 22.3-39.8 29.9-.1 .1H213.3l-.1-.1zM223 384.8l-51.3 38.5C162.3 447.1 139.1 464 112 464c-35.3 0-64-28.7-64-64c0-27.1 16.9-50.3 40.7-59.6L127.2 289c-5-.7-10.1-1-15.2-1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-5.2-.3-10.2-1-15.2zM288 112c0 5.2 .3 10.2 1 15.2l51.3-38.5C349.7 64.9 372.9 48 400 48c35.3 0 64 28.7 64 64c0 27.1-16.9 50.3-40.7 59.6L384.8 223c5 .7 10.1 1 15.2 1c61.9 0 112-50.1 112-112S461.9 0 400 0S288 50.1 288 112zm1 272.8c-.7 5-1 10.1-1 15.2c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-5.2 0-10.2 .3-15.2 1l38.5 51.3c23.8 9.3 40.7 32.5 40.7 59.6c0 35.3-28.7 64-64 64c-27.1 0-50.3-16.9-59.6-40.7L289 384.8zM224 208h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16z"]
};
var faTruckDroplet = {
  prefix: 'far',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h32c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM480 512c-53 0-96-43-96-96h-8H352 320 256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96H558zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c-39.8 0-72-29.6-72-66c0-27 39.4-82.9 59.9-110.3c6.1-8.2 18.1-8.2 24.2 0C240.6 123 280 179 280 206c0 36.5-32.2 66-72 66z"]
};
var faFileCircleXmark = {
  prefix: 'far',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M64 464H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faTemperatureArrowUp = {
  prefix: 'far',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M176 48c-35.3 0-64 28.7-64 64V273.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112V273.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8V112zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3zM448 32c6.8 0 13.3 2.9 17.8 7.9l72 80c8.9 9.9 8.1 25-1.8 33.9s-25 8.1-33.9-1.8L472 118.5 472 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-337.5-30.2 33.5c-8.9 9.9-24 10.7-33.9 1.8s-10.7-24-1.8-33.9l72-80c4.6-5.1 11-7.9 17.8-7.9z"]
};
var faTemperatureUp = faTemperatureArrowUp;
var faMedal = {
  prefix: 'far',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", "M4.1 38.2L106.4 191.5c11.2-11.6 23.7-21.9 37.3-30.6L68.4 48h64.5l54.9 91.5c15.8-5.5 32.4-9.1 49.6-10.6l-6.1-10.1L169.3 15.5C163.5 5.9 153.1 0 141.9 0H24.6C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6zm276.6 80.5l-6.1 10.1c17.2 1.5 33.8 5.2 49.6 10.6L379.2 48h64.5L368.4 160.9c13.6 8.7 26.1 19 37.3 30.6L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0H370.1c-11.2 0-21.7 5.9-27.4 15.5L280.8 118.7zM256 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm7.2-257.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L180.7 304c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L252.3 386c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L302.4 355c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4l-19.2-38.9z"]
};
var faPersonFairy = {
  prefix: 'far',
  iconName: 'person-fairy',
  icon: [640, 512, [], "e608", "M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3H280h80 2.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C372.9 220.8 359 208 342.4 208H297.6zM336 352H304V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352zM32 32c89.4 0 169.4 40.8 222.2 104.7c-15 6.3-28.4 15.9-39.3 27.8C174.1 116.6 114.7 84.9 48 80.5V112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78c43.3-.2 82.5-17.6 111.2-45.7v61C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32zM425.1 164.5c-10.9-11.9-24.3-21.5-39.3-27.8C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528c-41.2 0-79.7-12-112-32.7v-61c28.7 28.2 67.9 45.5 111.2 45.7c-2.9-29-13.5-55.7-29.7-78l-13.6-18.7c-7.6-10.4-5.6-25 4.5-33L506.6 288C558.7 246.9 592 183.4 592 112V80.5c-66.7 4.4-126.1 36.1-166.9 84z"]
};
var faBed = {
  prefix: 'far',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V360v96c0 13.3 10.7 24 24 24s24-10.7 24-24V384H312 592v80c0 13.3 10.7 24 24 24s24-10.7 24-24V360 248c0-66.3-53.7-120-120-120H344c-30.9 0-56 25.1-56 56V336H48V56zM592 248v88H336V184c0-4.4 3.6-8 8-8H520c39.8 0 72 32.2 72 72zM128 216a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm128 0A88 88 0 1 0 80 216a88 88 0 1 0 176 0z"]
};
var faBookCopy = {
  prefix: 'far',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M192 88c0-48.6 39.4-88 88-88H528c26.5 0 48 21.5 48 48V160v96c0 20.9-13.4 38.7-32 45.3V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H520 272c-44.2 0-80-35.8-80-80V88zM528 48H280c-22.1 0-40 17.9-40 40V262.7c9.8-4.3 20.6-6.7 32-6.7H520h8V160 48zM272 304c-17.7 0-32 14.3-32 32s14.3 32 32 32H496V304H272zM160 96v48H88c-22.1 0-40 17.9-40 40V358.7c9.8-4.3 20.6-6.7 32-6.7h81.1c2.5 17.7 9.2 34 18.9 48H80c-17.7 0-32 14.3-32 32s14.3 32 32 32H304V448h48v16h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H328 80c-44.2 0-80-35.8-80-80V184c0-48.6 39.4-88 88-88h72z"]
};
var faSquareH = {
  prefix: 'far',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm336 56V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHSquare = faSquareH;
var faSquareC = {
  prefix: 'far',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z"]
};
var faClockTwo = {
  prefix: 'far',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120v91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSquareEllipsisVertical = {
  prefix: 'far',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCalendarUsers = {
  prefix: 'far',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H160c-35.3 0-64 28.7-64 64v16 48h16 32 16H480h16 32 16V144 128c0-35.3-28.7-64-64-64H440V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H248V24zm6.7 440c.9 5.2 1.3 10.5 1.3 16c0 11.7-3.1 22.6-8.6 32H392.6c-5.4-9.4-8.6-20.3-8.6-32c0-5.5 .5-10.8 1.3-16H254.7zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H480zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64z"]
};
var faPodcast = {
  prefix: 'far',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M400 224c0 61.1-31.1 115-78.4 146.5c-1.4 17-4.1 36.6-7.1 54.9l-.6 3.8C392.8 394.7 448 315.8 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-3-18.4-5.7-38.1-7.1-55.1C79.1 338.9 48 285.1 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zm-32 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9c1.6-7.1 4.3-13.9 8.1-20.3c5.1-8.5 11.7-15.2 18.8-20.5C138 272.9 128 249.6 128 224c0-53 43-96 96-96s96 43 96 96c0 25.6-10 48.9-26.4 66.1c7.2 5.2 13.7 11.9 18.8 20.5c3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM178.9 487.7c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2c0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2zM225.5 464c-.5 0-1 0-1.5 0s-1.1 0-1.5 0c-3.1-13.3-6.7-31.9-9.9-51.4c-3.9-23.7-6.5-45.4-7-59c.6-.1 1.4-.3 2.2-.4c4.3-.8 9.7-1.2 16.3-1.2s12 .4 16.3 1.2c.8 .1 1.5 .3 2.2 .4c-.5 13.5-3.1 35.1-7 58.8c-3.2 19.5-6.9 38.1-10 51.5z"]
};
var faBee = {
  prefix: 'far',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", "M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2c0-11.2 1-22.2 3.1-32.8C74.5 266.1 48 237.2 48 208c0-32.2 32.3-64 80-64c37.3 0 65.2 19.5 75.6 43.3C167.5 213.5 144 256 144 304c0 83.8 103.6 179.7 129.9 202.8c3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-48-23.5-90.5-59.6-116.7C382.8 163.5 410.7 144 448 144c47.7 0 80 31.8 80 64c0 29.2-26.5 58.1-67.1 63.2c2 10.6 3.1 21.6 3.1 32.8c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zm17.6 393.9c-3.8-4.9-7.5-9.8-10.9-14.6H350c-3.4 4.8-7 9.7-10.9 14.6c-17.6 22.5-36.7 42.2-51.1 56c-14.4-13.8-33.5-33.5-51.1-56zm140-62.6H199.1c-4.6-11.7-7.1-22.5-7.1-32H384c0 9.5-2.5 20.3-7.1 32zm-5.8-80H204.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48z"]
};
var faTemperatureFull = {
  prefix: 'far',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M160 48c-35.3 0-64 28.7-64 64V273.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6V112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V273.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faBell = {
  prefix: 'far',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
var faCandyBar = {
  prefix: 'far',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M0 320V224H128v96H0zm0 64V352H128v96H64c-35.3 0-64-28.7-64-64zm288 64H160V352H288V320H160V224H288V192H160V64H288h48H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H336 288zM36.7 177C43.9 165 48 151 48 136c0-4-.3-7.9-.9-11.7c-1-7 6.2-14.2 13.1-13.1c3.8 .6 7.7 .9 11.7 .9c15 0 29-4.1 41-11.3c6.1-3.6 15 .4 15 7.4V160h0v32h-8l0 0H44.2c-7.1 0-11.1-9-7.4-15zM336 112V400H576c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H336z"]
};
var faChocolateBar = faCandyBar;
var faXmarkLarge = {
  prefix: 'far',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"]
};
var faPinata = {
  prefix: 'far',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H84.4C37.8 48 0 85.8 0 132.4c0 36.3 23.3 68.6 57.7 80.1L96 225.3V440c0 39.8 32.2 72 72 72h22.4c36.2 0 65.6-29.4 65.6-65.6c0-21.2 17.2-38.4 38.4-38.4h19.2c21.2 0 38.4 17.2 38.4 38.4c0 36.2 29.4 65.6 65.6 65.6H440c39.8 0 72-32.2 72-72V328c0-57.4-46.6-104-104-104H272V24zM84.4 96H224V221.2l-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1L144 224.4v-4.8c0-17.2-11-32.5-27.4-37.9L72.9 167C58 162 48 148.1 48 132.4C48 112.3 64.3 96 84.4 96zM212.6 260.2l17.5-7c7.1 11.3 19.6 18.8 33.9 18.8H408c20.2 0 37.8 10.7 47.7 26.7c-6.7-1.8-13.8-1.4-20.3 1.2l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-3.4 1.4V258.8l23.3-9.3 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1zM144 335.6l15.3-6.1 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 16.7 8.4v54.5l-11.4-4.6c-8.5-3.4-18-3-26.2 1.1l-19.1 9.6-32.3-12.9c-15.7-15.8-37.3-25.5-61.3-25.5H294.4c-24 0-45.7 9.8-61.3 25.5l-32.3 12.9-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1L144 392.4V335.6zm0 91.2l23.3-9.3 19.1 9.6c7.3 3.6 15.6 4.3 23.3 2.1c-1.1 5.6-1.7 11.3-1.7 17.2c0 9.7-7.9 17.6-17.6 17.6H168c-13.3 0-24-10.7-24-24V426.8zm296.7-9.3l23.3 9.3V440c0 13.3-10.7 24-24 24H417.6c-9.7 0-17.6-7.9-17.6-17.6c0-5.9-.6-11.6-1.7-17.2c7.7 2.3 16 1.5 23.3-2.1l19.1-9.6zM176 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsFromLine = {
  prefix: 'far',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V168c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24v86.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V344zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faSuperscript = {
  prefix: 'far',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M472 24c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8V176H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h40 40c13.3 0 24-10.7 24-24s-10.7-24-24-24H472V24zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24H51.2l96 144-96 144H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c8 0 15.5-4 20-10.7l92-138 92 138C272.5 444 280 448 288 448h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H300.8l-96-144 96-144H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H288c-8 0-15.5 4-20 10.7l-92 138L84 74.7C79.5 68 72 64 64 64H24z"]
};
var faBowlSpoon = {
  prefix: 'far',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M112 144c-42.6 0-64-28.2-64-48s21.4-48 64-48s64 28.2 64 48s-21.4 48-64 48zm0 48c52.2 0 96-30.6 108.5-72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H220.5C208 30.6 164.2 0 112 0C50.1 0 0 43 0 96s50.1 96 112 96zm64.5 266.9c-4.5-11.7-13.5-21.2-25-26.4C90.4 404.8 48 343.3 48 272H464c0 71.3-42.4 132.8-103.5 160.5c-11.5 5.2-20.4 14.7-25 26.4c-1.2 3.1-4.2 5.1-7.5 5.1H184c-3.3 0-6.3-2-7.5-5.1zM48 224c-26.5 0-48 21.5-48 48c0 90.8 54.1 169 131.7 204.2c8.1 21 28.4 35.8 52.3 35.8H328c23.8 0 44.2-14.9 52.3-35.8C457.9 441 512 362.8 512 272c0-26.5-21.5-48-48-48H48z"]
};
var faHexagonCheck = {
  prefix: 'far',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12H344.3c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faPlugCircleXmark = {
  prefix: 'far',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faStarOfLife = {
  prefix: 'far',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M184 64c0-35.3 28.7-64 64-64h16c35.3 0 64 28.7 64 64v67.3l58.3-33.6c30.6-17.7 69.8-7.2 87.4 23.4l8 13.9c17.7 30.6 7.2 69.8-23.4 87.4L400 256l58.3 33.6c30.6 17.7 41.1 56.8 23.4 87.4l-8 13.9c-17.7 30.6-56.8 41.1-87.4 23.4L328 380.7V448c0 35.3-28.7 64-64 64H248c-35.3 0-64-28.7-64-64V380.7l-58.3 33.6C95.1 432 56 421.5 38.3 390.9l-8-13.9c-17.7-30.6-7.2-69.8 23.4-87.4L112 256 53.7 222.4c-30.6-17.7-41.1-56.8-23.4-87.4l8-13.9C56 90.5 95.1 80 125.7 97.6L184 131.3V64zm64-16c-8.8 0-16 7.2-16 16V172.9c0 8.6-4.6 16.5-12 20.8s-16.6 4.3-24 0l-94.3-54.4c-7.7-4.4-17.4-1.8-21.9 5.9l-8 13.9c-4.4 7.7-1.8 17.4 5.9 21.9L172 235.2c7.4 4.3 12 12.2 12 20.8s-4.6 16.5-12 20.8L77.7 331.2c-7.7 4.4-10.3 14.2-5.9 21.9l8 13.9c4.4 7.7 14.2 10.3 21.9 5.9L196 318.4c7.4-4.3 16.6-4.3 24 0s12 12.2 12 20.8V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V339.1c0-8.6 4.6-16.5 12-20.8s16.6-4.3 24 0l94.3 54.4c7.7 4.4 17.4 1.8 21.9-5.9l8-13.9c4.4-7.7 1.8-17.4-5.9-21.9L340 276.8c-7.4-4.3-12-12.2-12-20.8s4.6-16.5 12-20.8l94.3-54.4c7.7-4.4 10.3-14.2 5.9-21.9l-8-13.9c-4.4-7.7-14.2-10.3-21.9-5.9L316 193.6c-7.4 4.3-16.6 4.3-24 0s-12-12.2-12-20.8V64c0-8.8-7.2-16-16-16H248z"]
};
var faPhoneSlash = {
  prefix: 'far',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c8.6 14.9 18.5 29 29.4 42.1L601.2 5.1zM240.4 287.9C228.1 273 217 257 207.2 240.2c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L112 70.5c1.5 93.7 35.2 179.6 90.5 247.1l37.8-29.6zm199.4-12.7l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.3-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2c-86.2-9.2-165.2-42.8-229.7-93.9L273.2 385c65 48.5 145.3 77.6 232.3 79l21.3-99.2-100.4-43L397 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-8-4.6-15.7-9.5-23.3-14.7l39.8-31.3c2.5 1.5 5 3.1 7.6 4.5L384 297.7l31.4-24.7c7.9-1.7 16.4-1.1 24.3 2.3z"]
};
var faTrafficLightStop = {
  prefix: 'far',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M64 48c-8.8 0-16 7.2-16 16V352c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-120a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
var faPaintRoller = {
  prefix: 'far',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M352 48H64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zM64 0H352c35.3 0 64 28.7 64 64v8 48 8c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm96 352c0-17.7 14.3-32 32-32h8V304c0-39.8 32.2-72 72-72H424c22.1 0 40-17.9 40-40V144c0-10.4-6.7-19.3-16-22.6V72.4c36 4 64 34.5 64 71.6v48c0 48.6-39.4 88-88 88H272c-13.3 0-24 10.7-24 24v16h8c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"]
};
var faAccentGrave = {
  prefix: 'far',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M80 65.3C80 55.8 87.8 48 97.3 48c8.4 0 15.6 6 17 14.3l18.2 102.1L82.9 79.9C81 76.6 80 72.9 80 69.2V65.3zm-48 0v3.9c0 12.3 3.3 24.4 9.5 35.1l57.3 97.4c8.1 13.8 23 22.3 39 22.3c28.2 0 49.5-25.5 44.6-53.3L161.6 53.8C156.1 22.7 129 0 97.3 0C61.2 0 32 29.2 32 65.3z"]
};
var faHandshakeAngle = {
  prefix: 'far',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", "M264 320c39.8 0 72-32.2 72-72v-8H440c13.3 0 24 10.7 24 24c0 11.7-8.4 21.5-19.4 23.6c-7.7 1.5-14.2 6.6-17.4 13.8s-2.7 15.5 1.4 22.2c2.2 3.6 3.4 7.8 3.4 12.4c0 13.3-10.7 24-24 24s-24 10.7-24 24c0 8.8-7.2 16-16 16H352 320 253.3c-14.9 0-29.1 5.9-39.6 16.4L159 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l54.6-54.6c1.5-1.5 3.5-2.3 5.7-2.3H320h32 16c28 0 51.8-17.9 60.5-42.9c29.8-8.8 51.5-36.4 51.5-69.1c0-3.9-.3-7.8-.9-11.5C498.9 311.7 512 289.4 512 264c0-39.8-32.2-72-72-72H336V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-22.1 17.9-40 40-40H418.7c14.9 0 29.1-5.9 39.6-16.4L513 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L424.4 61.7c-1.5 1.5-3.5 2.3-5.7 2.3H280c-48.6 0-88 39.4-88 88v96c0 39.8 32.2 72 72 72zM160 132.5c-19 7.5-33.9 23.6-39.4 44.2L99 257.5c-.4 1.4-1.1 2.6-2.1 3.6L7 351c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L130.9 295c7-7 12-15.6 14.5-25.2L160 215.1V132.5zM543.2 250.8L633 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-75.3 75.3c10.3 13.9 17.1 30.5 19.4 48.5z"]
};
var faHandsHelping = faHandshakeAngle;
var faCircle0 = {
  prefix: 'far',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96V224c0-53-43-96-96-96zm-48 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V224z"]
};
var faDialMedLow = {
  prefix: 'far',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM208.8 367.2c-37.9-37.9-43-96.2-15.1-139.6L271 305c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.4-77.4c43.4-27.8 101.7-22.8 139.6 15.1c43.7 43.7 43.7 114.7 0 158.4s-114.7 43.7-158.4 0zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLocationDot = {
  prefix: 'far',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faMapMarkerAlt = faLocationDot;
var faCrab = {
  prefix: 'far',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M.2 120l0 0 0 0C4.4 53 60 0 128 0h44.7c7.1 0 10.7 8.6 5.7 13.7L141.7 50.3c-5 5-1.5 13.7 5.7 13.7H184c4.4 0 8.1 3.6 7.5 8c-3.9 31.6-30.9 56-63.5 56H48v33.3c0 9.4 5.4 17.9 13.9 21.8L133.3 216c16.9-12.2 37-20.3 58.7-23V152c0-13.3 10.7-24 24-24s24 10.7 24 24v40h32V152c0-13.3 10.7-24 24-24s24 10.7 24 24v41c21.7 2.7 41.7 10.9 58.7 23l71.4-32.9c8.5-3.9 13.9-12.4 13.9-21.8V128H384c-32.6 0-59.6-24.4-63.5-56c-.5-4.4 3.1-8 7.5-8h36.7c7.1 0 10.7-8.6 5.7-13.7L333.7 13.7c-5-5-1.5-13.7 5.7-13.7H384c68 0 123.6 53 127.8 120l0 0 0 0c0 .1 0 .3 0 .4l.2 7.6h-7.9l-.1 0h8v33.3c0 28.1-16.3 53.6-41.8 65.4L413.1 253c2.2 3.6 4.2 7.2 6 11h31.2l26.9-13.5c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-32 16c-3.3 1.7-7 2.5-10.7 2.5H431.8c.2 2.6 .2 5.3 .2 8v1.4l23.6 7.9c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-30-10L387 381l36.6 12.2c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-54-18-2.2 2.2L371.7 435c7.6 4.2 12.3 12.3 12.3 21v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V470.1L297.9 449c-.6-.3-1.1-.6-1.6-1H215.7c-.5 .3-1.1 .7-1.6 1L176 470.1V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V456c0-8.7 4.7-16.7 12.3-21l24.9-13.8L163 419l-54 18L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8L125 381 107 363 77 373 49 401c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8L80 321.4V320c0-2.7 .1-5.4 .2-8H56c-3.7 0-7.4-.9-10.7-2.5l-32-16C1.4 287.5-3.4 273.1 2.5 261.3s20.3-16.7 32.2-10.7L61.7 264H92.9c1.8-3.8 3.9-7.4 6-11L41.8 226.7C16.3 214.9 0 189.4 0 161.3V128H8l-.1 0H0l.2-7.6c0-.1 0-.3 0-.4zM296 240H216h-8c-42.9 0-77.9 33.8-79.9 76.2L211.9 400h88.2l83.8-83.8c-2-42.4-37-76.2-79.9-76.2h-8z"]
};
var faBoxOpenFull = {
  prefix: 'far',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M480.9 3.1C456-6.2 428.4 6.3 419.1 31.2L384 124.8C382.2 55.6 325.6 0 256 0C185.3 0 128 57.3 128 128c0 2.2 .1 4.3 .2 6.5l65.5 8.2c-1.1-4.7-1.7-9.6-1.7-14.7c0-35.3 28.7-64 64-64s64 28.7 64 64c0 10.7-2.6 20.7-7.2 29.6l7.2 .9 161.4-20.2 27.5-73.4c9.3-24.8-3.3-52.5-28.1-61.8zM58.9 170.1L17.2 253.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 192 75.2 161.4c-6.7-.8-13.3 2.7-16.3 8.7zM576 339.6l-48 13.7v57.2l-184 46V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V456.5l-184-46V353.3L64 339.6v71c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6v-71zm46.8-86.1l-41.7-83.4c-3-6.1-9.6-9.6-16.3-8.7L320 192l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1z"]
};
var faBoxFull = faBoxOpenFull;
var faFile = {
  prefix: 'far',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
};
var faGreaterThan = {
  prefix: 'far',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", "M2.5 77.3c-5.9 11.9-1.1 26.3 10.7 32.2L306.3 256 13.3 402.5C1.4 408.5-3.4 422.9 2.5 434.7s20.3 16.7 32.2 10.7l336-168c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-336-168C22.9 60.6 8.5 65.4 2.5 77.3z"]
};
var faQuotes = {
  prefix: 'far',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M0 96C0 43 43 0 96 0h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H96C69.5 48 48 69.5 48 96H96c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V168 144 96zm48 72l0 24H96V144H48v24zM176 96c0-53 43-96 96-96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8c-26.5 0-48 21.5-48 48h48c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H224c-26.5 0-48-21.5-48-48V168 144 96zm48 48v24 24h48V144H224zM576 416c0 53-43 96-96 96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c26.5 0 48-21.5 48-48H480c-26.5 0-48-21.5-48-48V320c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v24 24 48zm-48-48V344 320H480v48h48zM400 416c0 53-43 96-96 96h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h8c26.5 0 48-21.5 48-48H304c-26.5 0-48-21.5-48-48V320c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v24 24 48zm-48-72V320H304v48h48V344z"]
};
var faPretzel = {
  prefix: 'far',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M56 184.2c0 52.5 20.3 100.3 53.5 135.9l19-26.8C103.3 264 88 225.9 88 184.2c0-39.9 32.3-72.2 72.2-72.2H164c42 0 76 34 76 76v5.1c0 16.8-5.2 33.2-14.9 46.9l-45.9 64.9c0 .1-.1 .1-.1 .2l-46.2 65.2c0 .1-.1 .1-.1 .2l-25.8 36.4c-5.1 7.2-3.4 17.2 3.8 22.3s17.2 3.4 22.3-3.8L163.7 382c6.2-8.7 17.3-12.3 27.4-8.8c20.3 7 42.2 10.8 65 10.8c11.2 0 22.3-.9 33-2.7l-21-29.7c-3.9 .3-7.9 .4-11.9 .4c-9.2 0-18.3-.7-27.2-2.2c-8.2-1.3-15.1-6.8-18.3-14.4s-2.2-16.4 2.6-23.1l23.3-32.9c4.5-6.4 11.8-10.1 19.6-10.1s15.1 3.8 19.6 10.1l11.5 16.3 11.8 16.6c0 0 0 .1 .1 .1l49.3 69.5c0 0 .1 .1 .1 .1l30.6 43.2c5.1 7.2 15.1 8.9 22.3 3.8s8.9-15.1 3.8-22.3l-25.8-36.4c-7.3-10.2-5.4-24.3 4.3-32.4c44.3-36.7 72.4-92 72.4-153.8C456 126.7 409.3 80 351.8 80H348c-29.3 0-55.8 11.6-75.3 30.6c-9.3 9.1-24.1 9.1-33.5 0C219.8 91.6 193.3 80 164 80h-3.8C102.7 80 56 126.7 56 184.2zM81.2 360C36.1 315.1 8 253 8 184.2C8 100.1 76.1 32 160.2 32H164c34.4 0 66.2 11.2 92 30c25.8-18.9 57.6-30 92-30h3.8C435.8 32 504 100.1 504 184.2c0 68.7-28.1 130.9-73.2 175.8l13.5 19c20.4 28.8 13.6 68.8-15.2 89.2s-68.8 13.6-89.2-15.2l0 0 0 0-20.6-29.1C299 429.2 277.8 432 256 432s-43-2.8-63.2-8.1L172.2 453c-20.4 28.8-60.4 35.7-89.2 15.2l13.3-18.8L83 468.2C54.2 447.8 47.3 407.8 67.8 379l0 0 13.5-19zM136 184.2c0 25.3 7.9 48.9 21.4 68.3l28.5-40.2c4-5.6 6.1-12.3 6.1-19.1V188c0-15.5-12.5-28-28-28h-3.8c-13.4 0-24.2 10.8-24.2 24.2zM320 188v5.1c0 6.9 2.1 13.5 6.1 19.1l28.5 40.2c13.5-19.4 21.4-42.9 21.4-68.3c0-13.4-10.8-24.2-24.2-24.2H348c-15.5 0-28 12.5-28 28zm28-76h3.8c39.9 0 72.2 32.3 72.2 72.2c0 49.4-21.5 93.9-55.5 124.6c-5.1 4.6-11.9 6.8-18.7 6s-13-4.4-16.9-10L286.9 240c-9.7-13.7-14.9-30.1-14.9-46.9V188c0-42 34-76 76-76z"]
};
var faPersonSwimming = {
  prefix: 'far',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", "M32 160a64 64 0 1 0 128 0A64 64 0 1 0 32 160zM80 334.1C62.8 349 41 360.8 18.8 365.8C5.9 368.7-2.3 381.5 .6 394.5s15.7 21.1 28.7 18.2C58 406.2 81.6 392.2 96 382.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM256.5 193.9L403 318.1c13.8-3.2 27.9-9.6 40.2-18c2.4-1.7 4.9-3.2 7.5-4.5L295.9 164.3C319.7 151.4 347 144 376 144h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376c-119.3 0-216 96.7-216 216v2.2c10.8 4 21.9 6.2 32 6.2c5.4 0 10.7-.5 16-1.6V312c0-46.1 18.5-87.8 48.5-118.1z"]
};
var faSwimmer = faPersonSwimming;
var faArrowDown = {
  prefix: 'far',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"]
};
var faUserRobotXmarks = {
  prefix: 'far',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H144c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80H240V16zm96 128v96c0 17.7-14.3 32-32 32V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H240V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H176V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H304c17.7 0 32 14.3 32 32zm64 304v16H304V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H240V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H176V432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H48l0-16c0-26.5 21.5-48 48-48H352c26.5 0 48 21.5 48 48zM224 512h64H400c26.5 0 48-21.5 48-48V448c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48H160h64zM16 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144zM168 157.4l-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0s-5.1 13.4 0 18.6L149.4 176l-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0L168 194.6l14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L186.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L168 157.4zm78.7-14.7c-5.1 5.1-5.1 13.4 0 18.6L261.4 176l-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0L280 194.6l14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L298.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L280 157.4l-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0z"]
};
var faMessageQuote = {
  prefix: 'far',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM160 112c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192 168 144c0-17.7-14.3-32-32-32H160zm224 80V168 144c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192z"]
};
var faCommentAltQuote = faMessageQuote;
var faCandyCorn = {
  prefix: 'far',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", "M612.6 18.1C570.4 4.2 524.1 0 480 0c-44 0-90 4.4-132.2 17.9C331.4 23.4 320 38.8 320 56c0 20.1 7 52 15.6 84c9.1 33.8 21.4 73 34.7 110.4c13.2 37.2 27.9 73.6 41.6 101.3c13.4 27 32.9 64.3 68.1 64.3s54.6-37.3 68.1-64.3c13.8-27.7 28.4-64.1 41.6-101.3C603 213 615.3 173.8 624.4 140C633 108 640 76.1 640 56c0-17.2-11-32.5-27.4-37.9zM480 280c14.2 0 32.1 2.4 45.4 4.6c-6.9 17-13.8 32.6-20.3 45.7c-7 14-12.8 24.8-19.3 32.3c-2.9 3.4-4.9 4.8-5.7 5.2l-.1 .1-.1-.1c-.8-.5-2.8-1.8-5.7-5.2c-6.5-7.5-12.3-18.3-19.3-32.3c-6.5-13.1-13.4-28.7-20.3-45.7c13.3-2.2 31.2-4.6 45.4-4.6zM583.2 107.4C556.2 102.6 512.4 96 480 96s-76.2 6.6-103.2 11.4c-4.7-19.2-7.7-35-8.5-45.5C402.6 51.7 441 48 480 48c39.2 0 77.7 3.6 111.7 13.8c-.9 10.6-3.9 26.4-8.5 45.6zM191.7 122.3c-39.6 20.1-75.4 49.9-106.6 81C54 234.5 24.5 270.1 4.3 309.5c-7.7 15.4-4.9 34.4 7.3 46.6c14.2 14.2 41.8 31.8 70.4 48.3c30.3 17.5 66.8 36.5 102.6 53.6c35.7 16.9 71.8 32.4 101 42.2c28.6 9.6 68.7 22.2 93.6-2.7s12.2-65 2.7-93.6c-9.8-29.3-25.2-65.4-42.2-101c-17-35.9-36.1-72.3-53.6-102.6c-16.5-28.7-34.2-56.2-48.3-70.4c-12.2-12.2-30.8-15.2-46.2-7.5zm91.4 279c10-10 24.4-21 35.4-28.8c7.2 16.9 13.3 32.8 18 46.7c5 14.8 8.5 26.6 9.2 36.5c.3 4.5-.1 6.9-.3 7.8l0 .1-.1 0c-.9 .3-3.3 .7-7.8 .3c-9.9-.7-21.7-4.3-36.5-9.2c-13.9-4.7-29.7-10.8-46.7-18c7.8-10.9 18.8-25.3 28.8-35.4zM234 206.3c-22.5 15.8-58.1 42-81 64.9s-49.2 58.5-64.9 81c-16.9-10.3-30.1-19.3-38.2-26.2c17.1-31.4 41.6-61.2 69.2-88.8c27.7-27.7 57.5-52.4 88.8-69.2c6.8 8.1 15.9 21.4 26.2 38.3z"]
};
var faFolderMagnifyingGlass = {
  prefix: 'far',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFolderSearch = faFolderMagnifyingGlass;
var faNotebook = {
  prefix: 'far',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M240 48H416c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H240V48zm-48 0V464H128c-8.8 0-16-7.2-16-16V416h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H112V280h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H112V144h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H112V64c0-8.8 7.2-16 16-16h64zM64 416v32c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V96H24C10.7 96 0 106.7 0 120s10.7 24 24 24H64v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v88H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64z"]
};
var faDroplet = {
  prefix: 'far',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 57.4 46.6 104 104 104c13.3 0 24-10.7 24-24s-10.7-24-24-24c-30.9 0-56-25.1-56-56z"]
};
var faTint = faDroplet;
var faBullseyePointer = {
  prefix: 'far',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 5.5 .2 10.9 .6 16.3L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.9c5.4 .4 10.8 .6 16.3 .6zm-2.4-48l14.3-48.6C324.2 361.4 368 313.8 368 256c0-61.9-50.1-112-112-112c-57.8 0-105.4 43.8-111.4 100.1L96 258.4c0-.8 0-1.6 0-2.4c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-.8 0-1.6 0-2.4 0zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z"]
};
var faEraser = {
  prefix: 'far',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", "M97 319c-9.4 9.4-9.4 24.6 0 33.9l72 72c4.5 4.5 10.6 7 17 7H294.1c6.4 0 12.5-2.5 17-7l65-65L216 200 97 319zM285.1 63c28.1-28.1 73.7-28.1 101.8 0L513 189.1c28.1 28.1 28.1 73.7 0 101.8L371.9 432H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H296v0c-.6 0-1.3 0-1.9 0H185.9c-19.1 0-37.4-7.6-50.9-21.1l-72-72c-28.1-28.1-28.1-73.7 0-101.8L285.1 63z"]
};
var faHexagonImage = {
  prefix: 'far',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36H344.3c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24l-34.5 59.8-78.1-94c-4.6-5.5-11.3-8.7-18.5-8.7s-13.9 3.2-18.5 8.7L232.2 320l-38.9-40.6c-4.6-4.8-11-7.5-17.6-7.4s-13 2.9-17.4 7.8l-56.9 62.3L58.6 268zM232 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
var faEarthAmericas = {
  prefix: 'far',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M256 464C141.1 464 48 370.9 48 256c0-22 3.4-43.1 9.7-63l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v30.4c0 15.9 15.2 27.3 30.5 23c15.9-4.5 28.3-17 32.8-32.8l1.5-5.4c4.6-16.1 15.3-29.7 29.8-38l9.2-5.3c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c73.6 3.6 137.2 45.6 171.2 106.3L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3C448.7 385.4 361.5 464 256 464zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faCrateApple = {
  prefix: 'far',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M160 54.9c0 5 4.1 9.1 9.1 9.1C199.4 64 224 39.4 224 9.1c0-5-4.1-9.1-9.1-9.1C184.6 0 160 24.6 160 54.9zM80 171.4c0-15.3 3.8-29 8.7-37.2c2.3-3.8 4.1-5.3 4.9-5.7l0 0c.4-.2 .8-.5 2.4-.5c2.2 0 6.5 .5 12.6 2.1c5.8 1.5 11.9 3.6 17.2 5.7c21.9 8.5 46.4 8.5 68.3 0c5.4-2.1 11.4-4.2 17.2-5.7c6.1-1.6 10.3-2.1 12.6-2.1c1.6 0 2.1 .3 2.4 .5l0 0c.7 .5 2.6 1.9 4.9 5.7c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6h48.5c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6H81.7c-1.1-6.5-1.7-13.3-1.7-20.6zM430.3 192h48.5c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0c-12.4-4.8-29.6-10.3-44.6-11c3.4 4 6.4 8.3 9 12.7c7.8 12.9 13.2 27.5 16.4 42.3l1.7 .7c21.9 8.5 46.4 8.5 68.3 0c5.4-2.1 11.4-4.2 17.2-5.7c6.1-1.6 10.3-2.1 12.6-2.1c1.6 0 2.1 .3 2.4 .5l0 0c.7 .5 2.6 1.9 4.9 5.7c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6zM406.9 0C376.6 0 352 24.6 352 54.9c0 5 4.1 9.1 9.1 9.1C391.4 64 416 39.4 416 9.1c0-5-4.1-9.1-9.1-9.1zM456 272c4.4 0 8 3.6 8 8v64H48V280c0-4.4 3.6-8 8-8H456zM48 456V392H464v64c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8zm8-232c-30.9 0-56 25.1-56 56V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V280c0-30.9-25.1-56-56-56H56zm360 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faAppleCrate = faCrateApple;
var faPersonBurst = {
  prefix: 'far',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3 .1V304H464V176.1c.7 0 1.5-.1 2.3-.1zM464 488V352h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L570.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7H466.3c-31.7 0-61 17.1-76.6 44.7L331.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L416 223.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 49.9-7.8 23.5-41.6-53.7-37L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"]
};
var faGameBoard = {
  prefix: 'far',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 96H224v80H144V96H64v80h80v80H64v80h80v80h80V336h80v80h80V336H304V256h80V176H304V96zM224 256v80H144V256h80zm0 0V176h80v80H224z"]
};
var faHatChef = {
  prefix: 'far',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M180.9 100.3C192.2 69.7 221.6 48 256 48s63.8 21.7 75.1 52.3c3.2 8.7 11.2 14.8 20.5 15.6s18.2-3.8 22.8-11.9c8.3-14.4 23.9-24 41.6-24c26.5 0 48 21.5 48 48c0 10.9-2.9 28.1-8.1 49.2c-5.1 20.6-11.9 43.2-18.8 64.4c-6.9 21.2-13.8 40.6-19 54.8c-1 2.7-1.9 5.3-2.8 7.6H360.6l23.2-133.3c1.5-8.7-4.3-17-13-18.5s-17 4.3-18.5 13L328.1 304H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16V304H183.9L159.8 165.3c-1.5-8.7-9.8-14.5-18.5-13s-14.5 9.8-13 18.5L151.4 304H96.6c-.9-2.3-1.8-4.9-2.8-7.6c-5.2-14.2-12.1-33.7-19-54.8c-6.9-21.2-13.7-43.8-18.8-64.4C50.9 156.1 48 138.9 48 128c0-26.5 21.5-48 48-48c17.7 0 33.3 9.6 41.6 24c4.7 8.1 13.6 12.7 22.8 11.9s17.3-6.9 20.5-15.6zM454.4 336.7L432 328c22.4 8.7 22.4 8.7 22.4 8.7l0 0 0 0 0-.1 .1-.3 .5-1.3c.4-1.1 1-2.7 1.8-4.8c1.6-4.1 3.8-10.1 6.4-17.3c5.3-14.6 12.4-34.6 19.5-56.4c7.1-21.8 14.3-45.7 19.7-67.8c5.3-21.7 9.4-43.5 9.4-60.6c0-53-43-96-96-96c-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0s-79.1 20.1-102.4 51.2c-16-12-36-19.2-57.6-19.2C43 32 0 75 0 128c0 17.1 4.1 38.9 9.4 60.6c5.4 22.2 12.6 46 19.7 67.8c7.1 21.8 14.2 41.9 19.5 56.4c2.7 7.3 4.9 13.2 6.4 17.3c.8 2.1 1.4 3.7 1.8 4.8l.5 1.3 .1 .3 0 .1 0 0 0 0s0 0 22.4-8.7l-22.4 8.7C61.2 345.9 70.1 352 80 352H432c9.9 0 18.8-6.1 22.4-15.3zM64 384v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384H400v64c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V384H64z"]
};
var faHandBackPointRight = {
  prefix: 'far',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 176c0-35.3-28.7-64-64-64l-188.8 0c-3.6-5.2-7.6-10.2-11.9-14.9L228.8 76.8C212.1 58.5 188.5 48 163.7 48l-10.2 0C99.5 48 49.5 76.7 22.2 123.4L20.7 126C7.1 149.3 0 175.7 0 202.6L0 328c0 66.3 53.7 120 120 120l8 0 96 0c35.3 0 64-28.7 64-64c0-2.8-.2-5.6-.5-8.3c19.4-11 32.5-31.8 32.5-55.7c0-5.3-.7-10.5-1.9-15.5c20.2-10.8 33.9-32 33.9-56.5c0-2.7-.2-5.4-.5-8l96.5 0c35.3 0 64-28.7 64-64zm-64-16c8.8 0 16 7.2 16 16s-7.2 16-16 16l-136 0c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8c0 8.8-7.2 16-16 16l-8 0c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8c0 8.8-7.2 16-16 16c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1c2 2.7 3.2 6 3.2 9.6c0 8.8-7.2 16-16 16l-96 0-8 0c-39.8 0-72-32.2-72-72l0-125.4c0-18.4 4.9-36.5 14.2-52.4l-20-11.7 20 11.7 1.5-2.6c18.6-32 52.8-51.6 89.8-51.6l10.2 0c11.3 0 22 4.8 29.6 13.1L210.5 128 168 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l78 0 2 0 200 0z"]
};
var faDove = {
  prefix: 'far',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", "M256.3 159c1-14.8 4.3-28.9 9.6-42C251.3 91.3 241.7 61.6 240.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8C190.2 22.2 174.9 44.5 161 76.1c13.4 29 36.1 50.6 63.1 66.9c10.5 6.3 21.4 11.6 32.2 16zM400 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM177.1 208c45.8 29 96.4 42.7 132 47c6.8 .8 13.7-1.3 18.8-5.9s8.1-11.1 8.1-18V168c0-30.9 25.1-56 56-56h61.8L436 138.7c-2.6 3.9-4 8.6-4 13.3V296c0 57.4-46.6 104-104 104H269.6c-5.4 0-10.7 1.9-15 5.3L181.2 464c-62.2-.9-106.4-30.9-126.8-51.6l99.7-27.2c8.9-2.4 15.6-9.8 17.3-18.9s-2.1-18.3-9.5-23.7C125.4 316.3 80 267.5 80 184c0-31.8 3.9-55.5 8.9-73.1c20.4 43.4 53.2 74.9 88.2 97.1zM91.2 32c-9.9 0-19.4 4.9-25 13.6C52.7 66.3 32 106.2 32 184c0 77.3 31.8 131.1 66.1 166.7L29.5 369.4c-12.8 3.5-23 13.1-27.3 25.6S.1 421.4 8 432c22.2 29.6 84.5 80 176 80c9.1 0 17.9-3.1 25-8.8L278 448h50c83.9 0 152-68.1 152-152V159.3l25.9-38.9c4-6 6.1-13 6.1-20.1c0-20-16.2-36.3-36.3-36.3H392c-57.4 0-104 46.6-104 104v34.5c-26.3-6.1-57-17.3-85.2-35.1c-38.3-24.2-70.7-60-82.3-111.9C117.5 42.3 105.7 32 91.2 32z"]
};
var faSnowflakeDroplets = {
  prefix: 'far',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M320 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L469 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L493 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L368 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L493 328.2l28 16.2-22 42.7L469 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L344 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l8.4-31.5-30.1 17.4-22-42.7 28-16.2-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L272 256l-66.2-38.2-77.8 20.9c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l31.5-8.4-37.1-21.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L171 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L296 214.4V137.9L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24zM519.1 418.1l47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5c0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z"]
};
var faBatteryEmpty = {
  prefix: 'far',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", "M80 144c-17.7 0-32 14.3-32 32V336c0 17.7 14.3 32 32 32H464c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"]
};
var faBattery0 = faBatteryEmpty;
var faGrid4 = {
  prefix: 'far',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M32 89.6V64H57.6V89.6H32zm57.6 16V48c0-8.8-7.2-16-16-16H16C7.2 32 0 39.2 0 48v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6H73.6c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9H16c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6H73.6c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V167.5c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5H16c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6H73.6c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V286.9c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM16 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16H73.6c8.8 0 16-7.2 16-16V406.4c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6H16zM32 209.1V183.5H57.6v25.6H32zm0 119.5V302.9H57.6v25.6H32zM32 448V422.4H57.6V448H32zM151.5 89.6V64h25.6V89.6H151.5zm57.6 16V48c0-8.8-7.2-16-16-16H135.5c-8.8 0-16 7.2-16 16v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6h57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9h0H135.5c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V167.5c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5H135.5c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V286.9c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM135.5 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6H135.5zm16-181.3V183.5h25.6v25.6H151.5zm0 119.5V302.9h25.6v25.6H151.5zm0 119.5V422.4h25.6V448H151.5zM270.9 64h25.6V89.6H270.9V64zm48.6 56c5.3-2.6 9-8.1 9-14.4V48c0-8.8-7.2-16-16-16H254.9c-8.8 0-16 7.2-16 16v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6h0 57.6 0c2.5 0 4.9-.6 7-1.6zm0 33.1c-2.1-1-4.5-1.6-7-1.6h0H254.9h0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V167.5c0-6.3-3.7-11.8-9-14.4zm0 119.5c-2.1-1-4.5-1.6-7-1.6H254.9c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6h57.6c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V286.9c0-6.3-3.7-11.8-9-14.4zm-7 117.8H254.9c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V406.4c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM270.9 183.5h25.6v25.6H270.9V183.5zm0 119.5h25.6v25.6H270.9V302.9zm0 119.5h25.6V448H270.9V422.4zM390.4 89.6V64H416V89.6H390.4zm57.6 16V48c0-8.8-7.2-16-16-16H374.4c-8.8 0-16 7.2-16 16v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6h0H432h0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9h0H374.4h0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6H432c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V167.5c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5H374.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4v57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6H432c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4V286.9c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM374.4 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V406.4c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6H374.4zm16-181.3V183.5H416v25.6H390.4zm0 119.5V302.9H416v25.6H390.4zm0 119.5V422.4H416V448H390.4z"]
};
var faSocks = {
  prefix: 'far',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M288 48c0-17 5.3-32.8 14.4-45.8C297.9 .8 293 0 288 0H176c-26.5 0-48 21.5-48 48V234.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54C12.8 362.2 0 389.1 0 417.5C0 469.7 42.3 512 94.5 512h6.9c22.6 0 44.6-7.6 62.5-21.5l12.9-10.1c-8.4-14.6-13.9-31-15.9-48.5l-26.6 20.8c-9.4 7.3-21 11.3-32.9 11.3H94.5C68.8 464 48 443.2 48 417.5c0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1V144H288V96H176V48H288zM368 0c-26.5 0-48 21.5-48 48V234.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54c-22.1 17.9-34.9 44.9-34.9 73.3c0 52.2 42.3 94.5 94.5 94.5h6.3c23.1 0 45.5-7.9 63.4-22.5l111.3-90.1c28.1-22.8 44.5-57.1 44.5-93.3V48c0-26.5-21.5-48-48-48H368zm0 48h96V96H368V48zm0 96h96V306.2c0 21.7-9.8 42.3-26.7 56L326 452.2c-9.4 7.6-21.1 11.8-33.2 11.8h-6.3c-25.7 0-46.5-20.8-46.5-46.5c0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1V144z"]
};
var faFaceSunglasses = {
  prefix: 'far',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", "M256 464C141.1 464 48 370.9 48 256c0-16.3 1.9-32.2 5.4-47.4l3.9 23.3C61.2 255 81.2 272 104.7 272h78.7c23.5 0 43.5-17 47.3-40.1l6.6-39.9h37.3l6.6 39.9c3.9 23.1 23.9 40.1 47.3 40.1h78.7c23.5 0 43.5-17 47.3-40.1l3.9-23.3c3.6 15.2 5.4 31.1 5.4 47.4c0 114.9-93.1 208-208 208zM227.1 144c-8.7-9.8-21.4-16-35.8-16H96.7c-1.6 0-3.2 .1-4.8 .2C129.9 79.4 189.3 48 256 48s126.1 31.4 164.1 80.2c-1.6-.2-3.2-.2-4.8-.2H320.7c-14.4 0-27.1 6.2-35.8 16H227.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4z"]
};
var faInbox = {
  prefix: 'far',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M48 336h81.2l20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1H326.1c15.1 0 29-8.6 35.8-22.1L382.8 336H464v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V336zm406.5-48H377.9c-15.1 0-29 8.6-35.8 22.1L321.2 352H190.8l-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1H57.5l49-195.9C108.2 85 114.6 80 122 80H390c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
};
var faSquare0 = {
  prefix: 'far',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSection = {
  prefix: 'far',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M48.4 90.6c2.8-15.9 12.5-27.3 29-34.6c17.6-7.7 42.8-10.5 73.1-5.6L153.7 30l-3.3 20.5c9.7 1.6 39.9 7.6 49.1 10.1c12.8 3.5 26-4 29.5-16.8s-4-26-16.8-29.5C200.7 11.1 168.7 4.8 158.1 3C121.8-2.8 86.5-.5 58 12.1C28.6 25.1 6.7 49 1 83.3c-.1 .4-.1 .8-.2 1.2c-2.2 19.5 .4 37 7.9 52.3c7.4 15.2 18.8 26.6 31.4 35.3c2.4 1.7 4.9 3.3 7.4 4.8C24.2 189.8 6.8 210.7 1.7 239.4c-.1 .4-.1 .9-.2 1.3c-2.3 18.8 .4 35.8 8.1 50.7c7.6 14.6 19.1 25.5 31.6 33.7c22.9 15.1 53.3 23.9 79.2 31.5l3.6 1c29 8.5 52.3 15.7 67.7 26.7c7.1 5.1 11.4 10.2 13.7 15.6c2.3 5.3 3.6 12.8 1.6 24.2c-2.5 14.2-11.6 25.1-28.5 32.2c-17.7 7.4-43.1 9.9-73.3 5.3c-14.9-2.4-40.4-10.8-61-17.7c-4.5-1.5-8.8-2.9-12.7-4.2c-12.6-4.1-26.1 2.8-30.2 15.4s2.8 26.1 15.4 30.2c3 1 6.5 2.1 10.5 3.5l0 0 0 0 0 0c20.3 6.7 51.4 17.1 70.6 20.2l.1 0c36 5.5 70.9 3.3 99.1-8.5c29-12.1 51.4-34.8 57.3-68.1c3.4-19 1.9-36.3-4.8-51.8c-6.7-15.3-17.6-26.8-29.8-35.6c0 0 0 0 0 0c17.7-13.5 30.5-32.7 34.7-58c3.3-19.7 1.8-37.5-4.7-53.4c-6.5-15.8-17.3-27.9-29.6-37.2c-23.2-17.5-55.1-27.4-81.8-35.6l-.7-.2c-29.3-9-53.3-16.5-69.9-28.1c-7.7-5.4-12.7-11-15.7-17c-2.8-5.8-4.6-13.7-3.4-25.1zM163.2 319.3c-8.6-2.8-17-5.2-25-7.6l-.8-.2C108.3 303 84.2 295.9 67.6 285c-7.8-5.1-12.6-10.3-15.4-15.7c-2.6-5-4.3-11.9-3.2-22.1c2.7-13.9 11.7-24.6 28.4-31.6c13-5.4 30.2-8.3 50.5-7.5c26.9 8.4 48.6 15.8 63.1 26.8c7.1 5.4 11.6 10.9 14.1 17.1c2.5 6.1 3.9 14.7 1.8 27.2c-3.3 19.4-17.2 33.8-43.7 40.1z"]
};
var faSquareThisWayUp = {
  prefix: 'far',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM120 352H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM328 192V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H254.5c-8 0-14.5-6.5-14.5-14.5c0-3.5 1.3-7 3.7-9.6L286.2 120c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6c0 8-6.5 14.5-14.5 14.5H328zM80 177.5c0-3.5 1.3-7 3.7-9.6L126.2 120c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6c0 8-6.5 14.5-14.5 14.5H168V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H94.5c-8 0-14.5-6.5-14.5-14.5z"]
};
var faBoxUp = faSquareThisWayUp;
var faGaugeHigh = {
  prefix: 'far',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56c0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faSquareAmpersand = {
  prefix: 'far',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm184 95.6c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2H199.6c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4H178.5c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"]
};
var faEnvelopeOpenText = {
  prefix: 'far',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M392 48H120c-4.4 0-8 3.6-8 8V225.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V186.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2V56c0-4.4-3.6-8-8-8zM160 120c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zm0 80c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM48 276.2V456c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8V276.2L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V237.9z"]
};
var faLampDesk = {
  prefix: 'far',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M347.3 97.9L309.3 59.9C301.6 52.3 291.3 48 280.6 48C258.2 48 240 66.2 240 88.6c0 10.8 4.3 21.1 11.9 28.7l38.1 38.1c9 9 14.1 21.2 14.1 33.9v60.1L441.4 112H381.3c-12.7 0-24.9-5.1-33.9-14.1zm-4.1-72L381.3 64H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V189.3l-13.7-13.7c-.6 .7-1.3 1.4-2 2.1l-93.1 86L204.4 464H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H154.5L96.9 262.6c-2.5-8.7 .1-18.1 6.8-24.2l104-96c.5-.5 1-.9 1.5-1.3C198.1 126 192 107.6 192 88.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6c0 26.5-21.5 48-48 48z"]
};
var faHospital = {
  prefix: 'far',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M232 0c-39.8 0-72 32.2-72 72v8H72C32.2 80 0 112.2 0 152V440c0 39.8 32.2 72 72 72h.2 .2 .2 .2 .2H73h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H75h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H77h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H79h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H82h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H85h.2 .2 .2 .2H86h.2 .2 .2 .2H87h.2 .2 .2 .2H88h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H98h.2 .2 .2 .2H99h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2v0H456h8v0H568c39.8 0 72-32.2 72-72V152c0-39.8-32.2-72-72-72H480V72c0-39.8-32.2-72-72-72H232zM480 128h88c13.3 0 24 10.7 24 24v40H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v48H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56V440c0 13.3-10.7 24-24 24H480V336 128zM72 128h88V464h-.1-.2-.2-.2H159h-.2-.2-.2H158h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H154h-.2-.2-.2H153h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H150h-.2-.2-.2H149h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H146h-.2-.2-.2H145h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H142h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H139h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H136h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H133h-.2-.2-.2-.2-.2-.2-.2-.2H131h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H128h-.2-.2-.2-.2-.2-.2-.2-.2H126h-.2-.2-.2-.2-.2-.2-.2-.2H124h-.2-.2-.2-.2-.2-.2-.2-.2H122h-.2-.2-.2-.2-.2-.2-.2-.2H120h-.2-.2-.2-.2-.2-.2-.2-.2H118h-.2-.2-.2-.2-.2-.2-.2-.2H116h-.2-.2-.2-.2-.2-.2-.2-.2H114h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H111h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H108h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H105h-.2-.2-.2-.2H104h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H100h-.2-.2-.2-.2H99h-.2-.2-.2-.2H98h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H88h-.2-.2-.2-.2H87h-.2-.2-.2-.2H86h-.2-.2-.2-.2H85h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H82h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H79h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H77h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H75h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H73h-.2-.2-.2-.2-.2H72c-13.2 0-24-10.7-24-24V336h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V240h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V152c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24V336 464H368V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H208V72zm88 24v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H344V96c0-8.8-7.2-16-16-16H312c-8.8 0-16 7.2-16 16z"]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faPollPeople = {
  prefix: 'far',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM592 80v64H480V80H592zM272 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zM592 368v64H352V368H592zM272 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H272zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64z"]
};
var faWhiskeyGlassIce = {
  prefix: 'far',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", "M50.5 80h411L414.2 404.6c-2.3 15.7-15.8 27.4-31.7 27.4h-253c-15.9 0-29.4-11.7-31.7-27.4L50.5 80zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM255.4 179.3l.6-.6c-5-1.8-10.4-2.7-16-2.7H144c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h73.8l-19-19c-8.5-8.5-14.7-18.4-18.6-29H144V224h66.7l44.7-44.7zM312 235.9l56.6 56.6L312 349l-56.6-56.6L312 235.9zm-33.9-33.9l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9L278.1 383c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9l-56.6-56.6c-18.7-18.7-49.1-18.7-67.9 0z"]
};
var faGlassWhiskeyRocks = faWhiskeyGlassIce;
var faWineBottle = {
  prefix: 'far',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9c-7.5 7.5-18.8 9-27.9 4.4l-72.5 72.5c-8 8-10.9 19.6-9.6 30.9c4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0l36-36L88.7 312.7l-36 36L18.7 314.7 180.2 153.3c28.1-28.1 66.3-40.2 103-36.2c11.3 1.2 22.9-1.6 30.9-9.6l72.5-72.5c-4.6-9-3.1-20.3 4.4-27.9zM200.7 200.7L311.3 311.3l13.5-13.5c17.4-17.4 24.9-41 22.5-63.8c-2.4-21.8 2.6-49.3 23.4-70l70.7-70.7L418.7 70.6l-70.7 70.7c-20.8 20.8-48.2 25.8-70 23.4c-22.9-2.5-46.4 5-63.8 22.4l-13.5 13.5z"]
};
var faChessRook = {
  prefix: 'far',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", "M80 80V192c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352H85.2l9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192V72c0-22.1 17.9-40 40-40H376c22.1 0 40 17.9 40 40V192c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85H314.5l-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4V80H304v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H80zm4.7 384H363.3l-16.6-32H101.2L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H72.8C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384h265zM208 288c-8.8 0-16-7.2-16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H208z"]
};
var faUserBountyHunter = {
  prefix: 'far',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72H323zm5.5 36.4L248 171.5v98.4l9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0l-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9V171.5l-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2L383 256.5c1.3 20-12.4 37.9-32.1 41.8L250.1 318.4c-5.2 1-10.4 1.6-15.7 1.6H213.5c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6c-1-3.4-1.6-7-1.6-10.7V16C64 7.2 71.2 0 80 0H96c8.8 0 16 7.2 16 16s-7.2 16-16 16V70zM313.6 400H134.4c-40 0-73.6 27.1-83.5 64H160l59.2-44.4c2.8-2.1 6.8-2.1 9.6 0L288 464H397.1c-9.9-36.9-43.5-64-83.5-64zM0 486.4C0 412.2 60.2 352 134.4 352H313.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"]
};
var faBarsStaggered = {
  prefix: 'far',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faDiagramSankey = {
  prefix: 'far',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M329.9 80c-2.8 0-5.4 1.5-6.8 3.8L253.8 197.2c-10.2 16.6-28.3 26.8-47.8 26.8H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H206.1c2.8 0 5.4-1.5 6.8-3.8L282.2 58.8C292.3 42.2 310.4 32 329.9 32H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H329.9zm-124 240l61.7 108c1.4 2.5 4.1 4 6.9 4H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H274.6c-20.1 0-38.7-10.8-48.6-28.2L150.6 320H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H205.9z"]
};
var faCloudHailMixed = {
  prefix: 'far',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm232 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM326.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm256-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCircleUpLeft = {
  prefix: 'far',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 313.4c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L232 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L296 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16c0-12.5-10.1-22.6-22.6-22.6H176c-8.8 0-16 7.2-16 16V313.4z"]
};
var faDharmachakra = {
  prefix: 'far',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M232.4 24.7l.4 8.5c-44.4 4.6-85 22.1-117.9 48.8l-5.7-6.3c-9.1-10-24.6-10.3-34.2-.8s-9.2 25.1 .8 34.2l6.3 5.7c-26.7 32.9-44.3 73.4-48.8 117.9l-8.5-.4C11.3 231.8 0 242.5 0 256s11.3 24.2 24.7 23.6l8.5-.4c4.6 44.4 22.1 85 48.8 117.9l-6.3 5.7c-10 9.1-10.3 24.6-.8 34.2s25.1 9.2 34.2-.8l5.7-6.3c32.9 26.7 73.4 44.3 117.9 48.8l-.4 8.5c-.6 13.5 10.1 24.7 23.6 24.7s24.2-11.3 23.6-24.7l-.4-8.5c44.4-4.6 85-22.1 117.9-48.8l5.7 6.3c9.1 10 24.6 10.3 34.2 .8s9.2-25.1-.8-34.2l-6.3-5.7c26.7-32.9 44.3-73.4 48.8-117.9l8.5 .4c13.5 .6 24.7-10.1 24.7-23.6s-11.3-24.2-24.7-23.6l-8.5 .4c-4.6-44.4-22.1-85-48.8-117.9l6.3-5.7c10-9.1 10.3-24.6 .8-34.2s-25.1-9.2-34.2 .8L397.1 82c-32.9-26.7-73.4-44.3-117.9-48.8l.4-8.5C280.2 11.3 269.5 0 256 0s-24.2 11.3-23.6 24.7zM147.3 394.4l54.2-59.4c10.9 7.5 23.5 12.9 37.1 15.4l-3.7 80.3c-32.8-3.9-62.9-16.9-87.6-36.3zm29.6-84l-59.4 54.2C98.1 340 85.2 309.9 81.2 277.1l80.3-3.7c2.5 13.6 7.8 26.1 15.4 37.1zM81.2 234.9c3.9-32.8 16.9-62.9 36.3-87.6l59.4 54.2c-7.5 10.9-12.9 23.5-15.4 37.1l-80.3-3.7zm120.3-58l-54.2-59.4c24.7-19.4 54.8-32.4 87.6-36.3l3.7 80.3c-13.6 2.5-26.1 7.8-37.1 15.4zm108.9 0c-10.9-7.5-23.5-12.9-37.1-15.4l3.7-80.3c32.8 3.9 62.9 16.9 87.6 36.3l-54.2 59.4zm54.2 217.5c-24.7 19.4-54.8 32.4-87.6 36.3l-3.7-80.3c13.6-2.5 26.1-7.8 37.1-15.4l54.2 59.4zm29.8-29.8l-59.4-54.2c7.5-10.9 12.9-23.5 15.4-37.1l80.3 3.7c-3.9 32.8-16.9 62.9-36.3 87.6zm0-217.4c19.4 24.7 32.4 54.8 36.3 87.6l-80.3 3.7c-2.5-13.6-7.8-26.1-15.4-37.1l59.4-54.2zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faObjectsAlignLeft = {
  prefix: 'far',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 24C0 10.7 10.7 0 24 0S48 10.7 48 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 24zM176 176l288 0 0-64-288 0 0 64zm-48-64c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm48 288l160 0 0-64-160 0 0 64zm-48-64c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z"]
};
var faOilCanDrip = {
  prefix: 'far',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 88c0 13.3-10.7 24-24 24H280v48h88.9c9.9 0 19.7 2.3 28.6 6.8L448 192l139.8-30 2.1-.4 11.3-2.4 13.9-3c18.1-3.9 30.7 17.6 18.4 31.5l-9.4 10.6-7.6 8.6-1.4 1.6L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V346.7l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48H96h48 3.2H232V112H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H328c13.3 0 24 10.7 24 24zM458.7 242.1c-11.4 2.4-23.2 .9-33.6-4.3l-50.5-25.2c-1.8-.9-3.7-1.4-5.7-1.4H147.2V364.8H403.1c3.7 0 7.2-1.6 9.6-4.3L530.8 226.6l-72.1 15.4zM96 211.2V208H48v64.8l48 21.3V211.2zM592 448c-26.5 0-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z"]
};
var faFaceSmilingHands = {
  prefix: 'far',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M320 352c-27.4 0-48.6-9.4-64-20.9V384v2.5c18 8.1 39.4 13.5 64 13.5s46-5.4 64-13.5V384 331.1c-15.4 11.5-36.6 20.9-64 20.9zM112 252.3C114 139.1 206.4 48 320 48s206 91.1 208 204.3c13.3-11.9 31.7-15.2 47.7-9.6C568.7 107.5 456.9 0 320 0S71.3 107.5 64.3 242.6c16-5.5 34.4-2.3 47.7 9.6zm139 200c-4.6 15.8-12.2 30.4-22.1 43c28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7c-9.9-12.6-17.5-27.2-22.1-43c-21.6 7.6-44.8 11.7-69 11.7s-47.4-4.1-69-11.7zm30.6-223.5l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm129.7 70.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM68.7 276.7c-6.2 6.2-6.2 16.4 0 22.6L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2V384 330.4c0-11-9-20-20-20s-20 9-20 20v19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faBroccoli = {
  prefix: 'far',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88c0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96H416c53 0 96-43 96-96c0-40.8-25.5-75.7-61.4-89.6c3.5-9.5 5.4-19.7 5.4-30.4c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zM208.4 89.7C211.5 66.2 231.6 48 256 48s44.5 18.2 47.6 41.7c1.1 8.6 6.9 16 15 19.2s17.3 1.8 24.1-3.8c6.9-5.7 15.7-9.1 25.4-9.1c22.1 0 40 17.9 40 40c0 12-5.3 22.8-13.7 30.2c-7.8 6.8-10.4 17.9-6.3 27.4s13.7 15.4 24.1 14.6c1.3-.1 2.6-.2 4-.2c26.5 0 48 21.5 48 48s-21.5 48-48 48H96c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.3 0 2.7 .1 4 .2c10.3 .8 20-5 24.1-14.6s1.5-20.6-6.3-27.4C109.3 158.8 104 148 104 136c0-22.1 17.9-40 40-40c9.7 0 18.5 3.4 25.4 9.1c6.7 5.5 15.9 7 24.1 3.8s13.8-10.6 15-19.2zM192.2 490.3c5 12.8 17.1 21.7 30.9 21.7h65.9c13.8 0 25.9-8.9 30.9-21.7c17.6-45.3 39.6-82.1 56.1-106.3H280l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384H136.1c16.5 24.2 38.5 60.9 56.1 106.3z"]
};
var faRouteInterstate = {
  prefix: 'far',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M64 192H447.3c-3.3 42-12.4 79.6-27.6 113.3C391 369 338.9 421.2 255.5 461.7c-84.6-37.1-136.4-89.1-164.6-153.4C75.7 273.8 67 235.1 64 192zM272.6 6c-10.2-6.1-23-6.1-33.2 0c-53.2 31.8-107 33.5-178.8 20c-17.7-3.3-35 8.7-37.7 26.9C8 156.5 12.5 249.5 46.9 327.6c34.7 78.9 98.6 139.8 196.5 181.1c8.3 3.5 17.8 3.3 26-.5c95.4-44.7 158.9-105.4 194.1-183.2c34.9-77.2 40.4-168.5 25.5-272.2c-2.6-18.2-19.9-30.2-37.7-26.9C379.6 39.5 325.8 37.8 272.6 6z"]
};
var faEarMuffs = {
  prefix: 'far',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", "M320 48c-83.1 0-151.4 63.4-159.3 144.4c-2.9-.3-5.8-.4-8.7-.4c-14.4 0-27.9 3.4-39.9 9.5C115.5 89.7 207.3 0 320 0S524.5 89.7 527.9 201.5c-12-6.1-25.5-9.5-39.9-9.5c-3 0-5.9 .1-8.7 .4C471.4 111.4 403.1 48 320 48zM480 224.6c2.6-.4 5.3-.6 8-.6c12 0 23.2 3.8 32.3 10.2c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-28.2 20.9-51.6 48-55.4zM152 224c2.7 0 5.4 .2 8 .6c27.1 3.9 48 27.2 48 55.4c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2C128.8 227.8 140 224 152 224zm7 108c-8.6-14.9-8.6-33.2 0-48.1c.7-1.1 1-2.4 1-4c0-4.4-3.6-8-8-8c-1.8 0-3.3 .5-4.6 1.4c-12 8.4-27.1 11-41.2 6.9c-.7-.2-1.4-.3-2.3-.3c-2.8 0-5.3 1.4-6.8 3.8c-6.3 10-16.1 17.3-27.4 20.5c-3.4 1-5.8 4.1-5.8 7.7c0 .8 .1 1.5 .3 2.2c4.8 17.3-.5 35.8-13.7 48c-1.7 1.5-2.6 3.6-2.6 5.9s.9 4.4 2.6 5.9c13.2 12.2 18.5 30.7 13.7 48c-.2 .6-.3 1.3-.3 2.2c0 3.6 2.4 6.7 5.8 7.7c11.4 3.2 21.1 10.5 27.4 20.5c1.5 2.4 4 3.8 6.8 3.8c.9 0 1.6-.1 2.3-.3c14-4.1 29.2-1.6 41.2 6.9c1.3 .9 2.8 1.4 4.6 1.4c4.4 0 8-3.6 8-8c0-1.5-.4-2.8-1-4c-8.6-14.9-8.6-33.2 0-48.1c.7-1.1 1-2.4 1-4c0-1.8-.5-3.3-1.4-4.5c-11.5-16.5-11.5-38.4 0-54.9c.9-1.3 1.4-2.8 1.4-4.5c0-1.5-.4-2.8-1-4zm321-52c0 1.5 .4 2.8 1 4c8.6 14.9 8.6 33.2 0 48.1c-.7 1.1-1 2.4-1 4c0 1.8 .5 3.3 1.4 4.5c11.5 16.5 11.5 38.4 0 54.9c-.9 1.3-1.4 2.8-1.4 4.5c0 1.5 .4 2.8 1 4c8.6 14.9 8.6 33.2 0 48.1c-.7 1.1-1 2.4-1 4c0 4.4 3.6 8 8 8c1.8 0 3.3-.5 4.6-1.4c12-8.4 27.1-11 41.2-6.9c.7 .2 1.4 .3 2.3 .3c2.8 0 5.3-1.4 6.8-3.8c6.3-10 16.1-17.3 27.4-20.5c3.4-1 5.8-4.1 5.8-7.7c0-.8-.1-1.5-.3-2.2c-4.7-17.3 .5-35.8 13.7-48c1.7-1.5 2.6-3.6 2.6-5.9s-.9-4.4-2.6-5.9c-13.2-12.2-18.5-30.7-13.7-48c.2-.6 .3-1.3 .3-2.2c0-3.6-2.4-6.7-5.8-7.7c-11.4-3.2-21.1-10.5-27.4-20.5c-1.5-2.4-4-3.8-6.8-3.8c-.9 0-1.6 .1-2.3 .3c-14 4.1-29.2 1.6-41.2-6.9c-1.3-.9-2.8-1.4-4.6-1.4c-4.4 0-8 3.6-8 8z"]
};
var faHotdog = {
  prefix: 'far',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", "M496.2 208.2l-34 34c1.2 1.7 1.9 3.7 1.9 5.8c0 2.6-1 5.2-2.9 7L255 461.1c-1.9 1.9-4.4 2.9-7 2.9c-2.1 0-4.1-.7-5.8-1.9l-34 34c10.7 10.2 25 15.8 39.8 15.8c15.4 0 30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41c0-14.8-5.7-29.1-15.8-39.8zM15.8 303.8l34-34c-1.2-1.7-1.9-3.7-1.9-5.8c0-2.6 1-5.2 2.9-7L17 223 50.9 257 257 50.9c1.9-1.9 4.4-2.9 7-2.9c2.1 0 4.1 .7 5.8 1.9l34-34C293.1 5.7 278.8 0 264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8zM447.6 143.6l-304 304c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l304-304c21.9-21.9 57.3-21.9 79.2 0s21.9 57.3 0 79.2zm33.9 33.9c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-7 7-12.5 10.8-17 13.1c-4.5 2.3-8.5 3.4-13.6 4.7l-1.5 .4c-4.7 1.2-10.9 2.7-17.3 5.6c-7.4 3.4-14.8 8.4-22.7 16.3c-16.2 16.2-20.5 30.7-24 42.7l0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.5 7.8-12.4 9.1c-3 1.3-5.8 1.7-10.6 2.4l-.4 .1c-4.6 .6-10.9 1.6-18 4.5c-7.4 3.1-14.8 8.1-22.6 15.9c-16.2 16.2-20.5 30.7-24 42.7l0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.7 8.1-13.3 9.8c-3.6 1.6-6.9 2.5-12 3.7l-1.2 .3c-5.6 1.4-12.6 3.2-20.4 7.3c-7.9 4-16 9.9-25 18.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1c4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4 0 0c4.7-1.2 10.9-2.7 17.3-5.6c7.4-3.4 14.8-8.4 22.7-16.3c16.2-16.2 20.5-30.7 24-42.7l0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.5-7.8 12.4-9.1c3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5c7.4-3.1 14.8-8.1 22.6-15.9c16.2-16.2 20.5-30.7 24-42.7l0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.7-8.1 13.3-9.8c3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3c7.9-4 16-9.9 25-18.9z"]
};
var faTransporterEmpty = {
  prefix: 'far',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", "M96 488c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24z"]
};
var faPersonWalkingWithCane = {
  prefix: 'far',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 32c-34.8 0-66.3 20.5-80.4 52.3l-47.1 106c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2L120 211.1v68.7c0 17.8 8.5 34.6 22.9 45.2L240 396.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V392.1c0-12.7-6.1-24.7-16.3-32.3L240 336.6V207.3l68 102c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3L271 167.2c-16.3-24.5-43.8-39.2-73.2-39.2H161.6zM168 279.8V176h24V301.4l-20.7-15.2c-2.1-1.5-3.3-3.9-3.3-6.5zm175.4 70.1L450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L370.4 332.6c-3.2 3.7-7 7.1-11.3 10c-5 3.3-10.3 5.7-15.7 7.3zM96.7 482.4c-3.1 12.9 4.8 25.8 17.7 28.9s25.8-4.8 28.9-17.7l26.3-109.4-42-30.8-31 129z"]
};
var faBlind = faPersonWalkingWithCane;
var faAngle90 = {
  prefix: 'far',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V456c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V56zM96 97.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z"]
};
var faRectangleTerminal = {
  prefix: 'far',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M448 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faKite = {
  prefix: 'far',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M368 48H584c2.2 0 4.2 .9 5.7 2.3L480 160 592 272v6.3c0 3.7-2.6 7-6.3 7.8L289.8 351.9c-.3-.3-.5-.6-.8-.9L480 160 368 48zm-61-4.1L234.1 372l-87.5 87.5c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6V359.8l-24-12-24 12v88.6c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L268 405.9 596.1 333c25.6-5.7 43.9-28.4 43.9-54.7V56c0-30.9-25.1-56-56-56H361.7c-26.2 0-49 18.2-54.7 43.9zM0 152c0 13.3 10.7 24 24 24h8c22.1 0 40 17.9 40 40v68L18.7 257.4c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9v70.1C0 346.2 5.8 352 12.9 352c2 0 4-.5 5.8-1.4L72 324v0l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4l.5 0c3.5 .1 7 .7 10.4 1.9c1.2 .4 2.3 .9 3.4 1.5l0 0L120 324l53.3 26.6c1.8 .9 3.8 1.4 5.8 1.4c7.1 0 12.9-5.8 12.9-12.9V268.9c0-7.1-5.8-12.9-12.9-12.9c-2 0-4 .5-5.8 1.4L120 284V216c0-48.6-39.4-88-88-88H24c-13.3 0-24 10.7-24 24z"]
};
var faDrum = {
  prefix: 'far',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 24.9 14.9 44.5 33.2 58.7c18.5 14.3 43.6 25.5 72 33.9C147.4 473 199.8 480 256 480s108.6-7 150.8-19.5c28.4-8.4 53.5-19.6 72-33.9C497.1 412.5 512 392.9 512 368V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6zM424 293.2c15-5.6 28.4-12 40-19V368c0 4.1-2.3 11.2-14.5 20.7c-6.5 5-15 10-25.5 14.7V293.2zM280 319.5c34.4-1.3 66.9-5.6 96-12.2V419.1c-27.9 6.7-60.5 11.1-96 12.5v-112zM136 307.4c29.1 6.6 61.6 10.8 96 12.2v112c-35.5-1.4-68.1-5.8-96-12.5V307.4zM48 274.2c11.6 7 25 13.4 40 19V403.3c-10.4-4.7-18.9-9.6-25.5-14.7C50.3 379.2 48 372.1 48 368V274.2z"]
};
var faScrubber = {
  prefix: 'far',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faIceCream = {
  prefix: 'far',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", "M224 0C140.9 0 72.6 63.3 64.8 144.4C28.4 148 0 178.7 0 216c0 39.8 32.2 72 72 72h64.4H311.6 376c39.8 0 72-32.2 72-72c0-37.3-28.4-68-64.8-71.6C375.4 63.3 307.1 0 224 0zM112 160c0-61.9 50.1-112 112-112s112 50.1 112 112c0 2.2-.1 4.4-.2 6.6c-.4 6.6 2 13.1 6.5 17.9s10.8 7.5 17.5 7.5H376c13.3 0 24 10.7 24 24s-10.7 24-24 24H311.6 136.4 72c-13.3 0-24-10.7-24-24s10.7-24 24-24H88.2c6.6 0 12.9-2.7 17.5-7.5s6.9-11.3 6.5-17.9c-.1-2.2-.2-4.4-.2-6.6zm88.1 338.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320H98.3L200.1 498.1z"]
};
var faHeartCircleBolt = {
  prefix: 'far',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9l0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2l-.1 .1-.1 .1-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H452.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faFishBones = {
  prefix: 'far',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M96 166.9c0-7.2-3.3-14.1-8.9-18.7l-48-38.9c-8.8-7.1-21.3-7.1-30.1-.1s-11.5 19.2-6.6 29.3L54.9 245.4c3.3 6.7 3.3 14.5 0 21.2L2.5 373.4c-5 10.1-2.2 22.3 6.6 29.3s21.3 7 30.1-.1l48-38.9c5.6-4.6 8.9-11.4 8.9-18.7V304h0V280h40v72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h48v72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h48v72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h40V381.1c0 16.9 17.1 28.4 31.8 20c16-9.1 30.6-19.7 43.7-30.7c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8c-13.1-11-27.7-21.6-43.7-30.7c-14.7-8.4-31.8 3.1-31.8 20V232H376V160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H280V160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H184V160c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H96V208h0V166.9zM464 330.8V181.2c28.5 24.9 49.7 53.6 61.8 74.8c-12.1 21.2-33.3 49.9-61.8 74.8z"]
};
var faDeerRudolph = {
  prefix: 'far',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M240 0c8.8 0 16 7.2 16 16V40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 8.6-1.9 16.7-5.4 24h39.5H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 20.7-11.2 38.7-27.9 48.4l43.7 39.7c7.3-9.8 19-16.2 32.1-16.2c22.1 0 40 17.9 40 40s-17.9 40-40 40c0 0-.1 0-.1 0c-2.3 35.7-31.9 64-68.2 64H409.3l-16.1 48.2c-.8 2.4-1.2 5-1.2 7.6V472c0 22.1-17.9 40-40 40H304c-22.1 0-40-17.9-40-40V376h-6.8c-22 0-43.7-4.6-63.8-13.3c-4.3 17.1-14.7 32.3-29.9 42.4l-6.5 4.3 17.8 48.8c9.5 26.1-9.8 53.7-37.6 53.7h-46c-16.8 0-31.8-10.5-37.6-26.3L31.2 423.9c-5.6-15.3-5.8-32-.6-47.4l8.2-24.7c.8-2.4 1.2-5 1.2-7.6v-4.3c0-6.4-2.5-12.5-7-17l-1.1-1.1c-1 8.4-8.4 14.7-16.9 14.1c-8.8-.6-15.5-8.1-15-17l3.3-53c1.1-17.6 6.9-33.9 16.2-47.6c16.2-30 48-50.4 84.5-50.4H295l7.2-24H274c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96H296h-8-8c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zM354.9 135.2l-19 63.6c-3 10.2-12.4 17.1-23 17.1H104c-26.5 0-48 21.5-48 48v4.1c0 6.4 2.5 12.5 7 17l3.9 3.9C80.4 302.5 88 320.8 88 339.9v4.3c0 7.7-1.2 15.4-3.7 22.8l-8.2 24.7c-1.7 5.1-1.6 10.7 .2 15.8L96.8 464h28.9l-20.3-55.8c-3.8-10.4 0-22 9.2-28.2l22.2-14.8c7.9-5.2 11.9-14.6 10.4-23.9l-2.9-17.4c-1.6-9.4 2.6-18.9 10.6-24.1s18.4-5.1 26.3 .2l13.7 9.2c18.4 12.3 40 18.8 62.1 18.8H288c13.3 0 24 10.7 24 24V464h32V311.8c0-7.7 1.2-15.4 3.7-22.8l21.5-64.6c3.3-9.8 12.4-16.4 22.8-16.4h59.6c11.3 0 20.4-9.1 20.4-20.4c0-5.7-2.4-11.2-6.7-15.1L408 120.5c-6-5.5-13.8-8.5-21.9-8.5c-14.4 0-27.1 9.4-31.2 23.2zM400 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFax = {
  prefix: 'far',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M176 64c0-8.8 7.2-16 16-16H383.4c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3V160h48V96.6c0-17-6.7-33.3-18.7-45.3L428.7 18.7C416.7 6.7 400.4 0 383.4 0H192c-35.3 0-64 28.7-64 64v66c-5.1-1.3-10.5-2-16-2H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H96h16H448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H176V64zm0 176H448c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H174c1.3-5.1 2-10.5 2-16V240zM112 464H96 64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v24V448c0 8.8-7.2 16-16 16zM272 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM240 400a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM368 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM336 400a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faParagraph = {
  prefix: 'far',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160h64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H384l0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-376H288V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H192c-88.4 0-160-71.6-160-160zM240 304V80H192C130.1 80 80 130.1 80 192s50.1 112 112 112h48z"]
};
var faHeadSideHeart = {
  prefix: 'far',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M48 224c0-97.2 78.8-176 176-176h24c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6H424c-13.3 0-24 10.7-24 24v72c0 8.8-7.2 16-16 16H296c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V448h64c35.3 0 64-28.7 64-64V336h.4c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0H224C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V398.6c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm64-34.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faSquareE = {
  prefix: 'far',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm152 32H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z"]
};
var faMeterFire = {
  prefix: 'far',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M256 48c68.7 0 129.5 33.3 167.4 84.6c16.7-8 37.2-5.5 51.5 7.4c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-12.6-11.6-23.6-24.8-32.8-39.2c-19.7 6.2-40.6 9.5-62.3 9.5C141.1 464 48 370.9 48 256S141.1 48 256 48zM368 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 11.2 7.6 20.6 18 23.2c9-12.9 19.1-25.7 30-38.3V152zm-176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm173.5 11.6c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faCloudHail = {
  prefix: 'far',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM160 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCheckToSlot = {
  prefix: 'far',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M144 80V360H432V80H144zM96 360V80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V360c13.3 0 24 10.7 24 24s-10.7 24-24 24H432 144 96c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 288v48H48l0 96H528V336H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H64zM385 179.6L278.3 286.3c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L191 233c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4L351 145.7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faVoteYea = faCheckToSlot;
var faMoneyFromBracket = {
  prefix: 'far',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", "M48 88v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88C0 39.4 39.4 0 88 0H552c48.6 0 88 39.4 88 88v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-22.1-17.9-40-40-40H88C65.9 48 48 65.9 48 88zm416 8h48l0 352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64l0-352h48l0 304c35.3 0 64 28.7 64 64H400c0-35.3 28.7-64 64-64V96zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z"]
};
var faStarHalf = {
  prefix: 'far',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4V128.4z"]
};
var faCarBus = {
  prefix: 'far',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", "M64.5 80H192 321.4C302.1 65.3 263.5 48 192 48C126.6 48 86.2 64.8 64.5 80zM48 128v80H168V128H48zm0 128v96c0 13.3 10.7 24 24 24H192v48H80v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V411.9C12.7 399 0 377 0 352V118.2c0-22 4.6-51.9 28.8-71.4C58.6 22.7 111.5 0 192 0c84.9 0 135.8 22.1 164.5 46.6c23.4 20 27.5 49.9 27.5 71.6V128H348.2c-4.1 0-8.2 .3-12.2 .8V128H216v80h36.9l-13.7 48H192 48zm56 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm257.8-80c-10.1 0-19.2 6.4-22.6 15.9L322.1 272H541.9l-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9H361.8zm-96.4 79.9L294 207.8c10.2-28.7 37.4-47.8 67.8-47.8H502.2c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2 .5 .3 .9 .5 1.4C623.8 306.7 640 335.5 640 368v32 16 32 40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448H272v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V448 416 400 368c0-32.5 16.2-61.3 40.9-78.7c.1-.5 .3-.9 .5-1.4zM544 320H320c-26.5 0-48 21.5-48 48v32H592V368c0-26.5-21.5-48-48-48zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSpeaker = {
  prefix: 'far',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M320 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H320zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM232 120a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM192 432a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM136 328a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
var faTimer = {
  prefix: 'far',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M256 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V49.4C383.6 61.3 464 149.2 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-43.3 13.2-83.5 35.8-116.8c7.5-11 4.6-25.9-6.4-33.3s-25.9-4.6-33.3 6.4C16.3 153.2 0 202.7 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM193 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z"]
};
var faBoxesStacked = {
  prefix: 'far',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", "M384 48c8.8 0 16 7.2 16 16V192h48V64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64V192h48V64c0-8.8 7.2-16 16-16h56v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V48h56zM327.6 512H512c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H327.6c11.8 13.2 20.1 29.7 23.1 48H376v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V272h56c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H350.7c-3.1 18.3-11.3 34.8-23.1 48zM256 272c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16h56v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V272h56zM64 224c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H64z"]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faGrillHot = {
  prefix: 'far',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M120 0C106.7 0 96 10.7 96 24v2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24c0-13.3-10.7-24-24-24zM48.9 208H399.1c-8 72-69 128-143.1 128H192c-74.1 0-135.2-56-143.1-128zM32 160c-17.7 0-32 14.3-32 32c0 78.1 46.6 145.3 113.6 175.3l-7.5 17.5c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H327l10.9 25.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L334.4 367.3c67-30 113.6-97.2 113.6-175.3c0-17.7-14.3-32-32-32H32zM147.5 410l12.3-28.7c10.5 1.8 21.2 2.7 32.2 2.7h64c11 0 21.7-.9 32.2-2.7L306.5 424H155.3c-2-5-4.7-9.7-7.8-14zM72 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24z"]
};
var faBallotCheck = {
  prefix: 'far',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 352c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H96zm80-224c0 13.3 10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H200c-13.3 0-24 10.7-24 24zm32 128c0 13.3 10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H232c-13.3 0-24 10.7-24 24zM176 384c0 13.3 10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H200c-13.3 0-24 10.7-24 24zm-4.7-140.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 257.4 99.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z"]
};
var faLink = {
  prefix: 'far',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", "M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"]
};
var faChain = faLink;
var faEarListen = {
  prefix: 'far',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M388.9 3.8C450.6 43 493.6 105.8 508 177.6l3.5 17.7c2.6 13-5.8 25.6-18.8 28.2s-25.6-5.8-28.2-18.8L460.9 187c-11.8-58.9-47.1-110.5-97.8-142.7c-11.2-7.1-14.5-22-7.4-33.1s21.9-14.5 33.1-7.4zM240 112c-70.7 0-128 57.3-128 128c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2c-4.8 4.9-6.6 9.9-6.6 13.8c0 75.1-60.9 136-136 136c-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88c0-19.1 8.9-35.5 20.1-47.1c22.3-23 35.9-54.4 35.9-88.9c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40zM168 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM24 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm57-97l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L47 401c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faAssistiveListeningSystems = faEarListen;
var faFileMinus = {
  prefix: 'far',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]
};
var faTreeCity = {
  prefix: 'far',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M336 56c0-4.4 3.6-8 8-8H456c4.4 0 8 3.6 8 8V216c0 13.3 10.7 24 24 24h80 16c4.4 0 8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V248c0-28.2-20.9-51.6-48-55.4V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H512V56c0-30.9-25.1-56-56-56H344c-30.9 0-56 25.1-56 56V488c0 13.3 10.7 24 24 24s24-10.7 24-24V56zm32 40v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H384zM368 288v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H512zM496 384v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16zM224 160c0-53-43-96-96-96c-54 0-96 43-96 96c0 6 0 11 1 16C13 190 0 214 0 240c0 45 35 80 80 80H96V480c0 18 14 32 32 32c17 0 32-14 32-32V320h16c44 0 80-35 80-80c0-26-14-50-34-64c1-5 2-10 2-16z"]
};
var faPlay = {
  prefix: 'far',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", "M48 432L336 256 48 80l0 352zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432V80C0 62.6 9.4 46.6 24.5 38.1z"]
};
var faFont = {
  prefix: 'far',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M246.2 46.9C242.5 37.9 233.8 32 224 32s-18.5 5.9-22.2 14.9L44.6 432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H96.5l32.7-80H318.9l32.7 80H312c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H403.4L246.2 46.9zM299.3 304H148.7L224 119.5 299.3 304z"]
};
var faCupTogo = {
  prefix: 'far',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M108.2 48h232c3 0 5.8 1.7 7.2 4.4L361.2 80H88l13-27.4c1.3-2.8 4.1-4.6 7.2-4.6zM414.8 80L390.3 31c-9.5-19-28.9-31-50.1-31h-232C86.6 0 66.9 12.4 57.6 32L34.8 80H24C10.7 80 0 90.7 0 104s10.7 24 24 24H50 400h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-9.2zM47.4 160L74.6 453.9c3 32.9 30.7 58.1 63.7 58.1H309.7c33.1 0 60.7-25.2 63.7-58.1L400.6 160H352.4l-5.9 64H101.5l-5.9-64H47.4zm68.9 224H331.6l-6.1 65.5c-.8 8.2-7.7 14.5-15.9 14.5H138.3c-8.3 0-15.2-6.3-15.9-14.5L116.4 384z"]
};
var faCoffeeTogo = faCupTogo;
var faSquareDownLeft = {
  prefix: 'far',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zM128 198.6V336c0 8.8 7.2 16 16 16H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C290 146 285.1 144 280 144s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z"]
};
var faBurgerLettuce = {
  prefix: 'far',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1H423.6c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224H61.1C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432H384c20.9 0 38.7-13.4 45.3-32H82.7c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32c0 53-43 96-96 96H128c-53 0-96-43-96-96zm48-56c-20.1 0-35.8-5.1-46.7-10.5c-5.4-2.7-9.6-5.5-12.7-7.8c-1.5-1.1-2.7-2.1-3.7-3c-.5-.4-.9-.8-1.2-1.1l-.4-.4-.2-.2-.1-.1 0 0 0 0c0 0 0 0 17-17L15 305c-9.4-9.4-9.4-24.6 0-33.9c9.2-9.2 24.2-9.4 33.6-.4c.1 .1 .4 .3 .8 .6c1 .7 2.8 1.9 5.3 3.2c5.1 2.5 13.4 5.5 25.3 5.5c8.2 0 15.2-3.8 30-12.6l.2-.1c13.2-7.9 32.3-19.3 57.8-19.3c25.1 0 42.2 11.1 54.1 18.8l1.6 1c12 7.7 19.8 12.2 32.3 12.2c12.2 0 19-4.2 30.7-12l.6-.4c12.3-8.2 29.4-19.6 56.7-19.6c27.2 0 46.1 11.3 59.6 19.6c14.5 9 20.5 12.4 28.4 12.4c11.9 0 20.2-2.9 25.3-5.5c2.6-1.3 4.4-2.5 5.3-3.2c.4-.3 .7-.6 .8-.6c9.4-9 24.3-8.9 33.6 .4c9.4 9.4 9.4 24.6 0 33.9l-17-17c17 17 17 17 17 17l0 0 0 0-.1 .1-.2 .2-.4 .4c-.3 .3-.7 .7-1.2 1.1c-.9 .8-2.1 1.8-3.7 3c-3 2.3-7.2 5.1-12.7 7.8C467.8 322.9 452.1 328 432 328c-22.2 0-39.3-10.7-50.8-17.9c-1-.6-1.9-1.2-2.7-1.7C365.9 300.7 356.8 296 344 296c-12.2 0-19 4.2-30.7 12l-.6 .4C300.4 316.6 283.3 328 256 328c-27.5 0-45.5-11.6-58.3-19.8l0 0C184.8 299.9 178.4 296 168 296c-11 0-19.8 4.5-33.4 12.6l-2.3 1.4c-12.1 7.3-29.9 18-52.2 18z"]
};
var faRupiahSign = {
  prefix: 'far',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 56C0 42.7 10.7 32 24 32h96c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304H48V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V280 56zM48 256h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48V256zm264-96h88c61.9 0 112 50.1 112 112s-50.1 112-112 112H336V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24zm88 176c35.3 0 64-28.7 64-64s-28.7-64-64-64H336V336h64z"]
};
var faMagnifyingGlass = {
  prefix: 'far',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
};
var faSearch = faMagnifyingGlass;
var faTableTennisPaddleBall = {
  prefix: 'far',
  iconName: 'table-tennis-paddle-ball',
  icon: [640, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M476.4 99.5c52.2 52.2 64.8 129 37.7 193.1c15.8 4.4 30.4 11.7 43.1 21.3c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0l-60.1 60.1c-24 24-37.5 56.6-37.5 90.5V219c0 33.9 13.5 66.5 37.5 90.5c13.4 13.4 12 35.6-3 47.2l-49.3 38C70.3 403.1 64 416 64 429.7c0 11.7 4.7 22.9 12.9 31.2l38.1 38.1c8.3 8.3 19.5 12.9 31.2 12.9c13.7 0 26.6-6.3 35-17.2l38-49.3c11.6-15 33.8-16.5 47.2-3c24 24 56.6 37.5 90.5 37.5h2.7c3.1 0 6.1-.1 9.2-.3c-8.3-14.4-13.8-30.6-16-47.8c-19.7-1-38.5-9.3-52.5-23.3l-33.9 33.9 33.9-33.9c-33.9-33.9-89.9-30.3-119.2 7.7L145.9 462l-32-32 45.8-35.3c38-29.3 41.6-85.3 7.7-119.2c-15-15-23.4-35.4-23.4-56.6v-2.7c0-11 2.3-21.8 6.6-31.7L354.9 388.8c3.7-17.2 10.9-33.2 20.8-47.1L180.5 146.6l47-47c68.7-68.7 180.2-68.7 248.9 0zM432 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faPersonDotsFromLine = {
  prefix: 'far',
  iconName: 'person-dots-from-line',
  icon: [576, 512, ["diagnoses"], "f470", "M288 48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM24 320L8.9 301.3C-1.4 309.7-3 324.8 5.3 335.1s23.4 11.9 33.7 3.6l0 0 .1-.1 .7-.6c.7-.5 1.8-1.4 3.3-2.4c3-2.2 7.5-5.4 13.4-9.2c11.9-7.7 29.3-18.2 51.5-28.6c19.4-9.2 42.3-18.3 68-25.6V432h48V261.3c20.2-3.3 41.6-5.3 64-5.3s43.8 1.9 64 5.3V432h48V272.1c25.7 7.4 48.5 16.5 68 25.6c22.2 10.5 39.6 20.9 51.5 28.6c5.9 3.9 10.4 7.1 13.4 9.2c1.5 1.1 2.6 1.9 3.3 2.4l.7 .6 .1 .1 0 0c10.3 8.3 25.4 6.7 33.7-3.6s6.7-25.4-3.6-33.8L552 320c15.1-18.7 15.1-18.7 15.1-18.7l0 0 0 0-.1-.1-.3-.3-.6-.5-.6-.4c-1-.8-2.4-1.8-4.2-3.1c-3.6-2.6-8.8-6.3-15.5-10.7c-13.4-8.8-32.8-20.3-57.3-31.9C439.6 231.3 370.1 208 288 208s-151.6 23.3-200.4 46.3c-24.4 11.5-43.9 23.1-57.3 31.9c-6.7 4.4-11.9 8.1-15.5 10.7c-1.8 1.3-3.2 2.4-4.2 3.1c-.5 .4-.9 .7-1.2 .9l-.3 .3-.1 .1 0 0 0 0s0 0 15.1 18.7zM0 488c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM56 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM336 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM488 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faDiagnoses = faPersonDotsFromLine;
var faChevronsDown = {
  prefix: 'far',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
var faChevronDoubleDown = faChevronsDown;
var faTrashCanArrowUp = {
  prefix: 'far',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm144 48c6.4 0 12.5 2.5 17 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V257.9l-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c4.5-4.5 10.6-7 17-7z"]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faSignalGood = {
  prefix: 'far',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", "M320 192c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faSignal3 = faSignalGood;
var faLocationQuestion = {
  prefix: 'far',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM105.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V218.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMapMarkerQuestion = faLocationQuestion;
var faFloppyDiskCircleXmark = {
  prefix: 'far',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M48 96V416c0 8.8 7.2 16 16 16H268c6.9 17.5 16.4 33.7 28.2 48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368zM128 80v80H272V80H128zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368z"]
};
var faFloppyDiskTimes = faFloppyDiskCircleXmark;
var faSaveCircleXmark = faFloppyDiskCircleXmark;
var faSaveTimes = faFloppyDiskCircleXmark;
var faNairaSign = {
  prefix: 'far',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M107.8 42.5C101.9 33.8 91 30 80.9 33.1S64 45.5 64 56V256H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64V456c0 13.3 10.7 24 24 24s24-10.7 24-24V304H227.6L340.2 469.5c5.9 8.7 16.8 12.5 26.9 9.4s16.9-12.4 16.9-22.9V304h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H384V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V256H253L107.8 42.5zM285.7 304H336v74l-50.3-74zM195 256H112V134l83 122z"]
};
var faPeach = {
  prefix: 'far',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M96 32c0 34.7 18.4 65.1 46 82C61.6 126.5 0 196 0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-84-61.6-153.5-142-166c27.6-16.9 46-47.3 46-82V24c0-13.3-10.7-24-24-24H352c-53 0-96 43-96 96c0-53-43-96-96-96H120C106.7 0 96 10.7 96 24v8zm72 128c58.1 0 106.6 41.3 117.6 96.2c2.6 13 13.1 23.8 26.4 23.8s24.2-10.8 22.3-23.9c-4.7-32.9-19-62.8-39.9-86.7c4.1-1 8.2-2.1 12.2-3.5c11.7-3.8 24.3-5.9 37.4-5.9c66.3 0 120 53.7 120 120c0 43.4-32.4 84.6-84.3 120.9c-49.2 34.4-103.9 55.9-123.7 63c-19.8-7.1-74.5-28.6-123.7-63C80.4 364.6 48 323.4 48 280c0-66.3 53.7-120 120-120z"]
};
var faTaxiBus = {
  prefix: 'far',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", "M192 48c71.5 0 110.1 17.3 129.4 32H192 64.5C86.2 64.8 126.6 48 192 48zM48 208V128H168v80H48zm0 144V256H192h47.2l13.7-48H216V128H328.6c3.6-25.4 24.3-45.2 50-47.7c-4-12.2-10.8-24-22-33.6C327.8 22.1 276.9 0 192 0C111.5 0 58.6 22.7 28.8 46.8C4.6 66.3 0 96.2 0 118.2V352c0 25 12.7 47 32 59.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V424H192V376H72c-13.3 0-24-10.7-24-24zm80-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 144v16h-6.2c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1c-.2 .5-.3 .9-.5 1.4C240.2 306.7 224 335.5 224 368v32 16 32 40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H592v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448 416 400 368c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H496V144c0-17.7-14.3-32-32-32H400c-17.7 0-32 14.3-32 32zm-6.2 64H400h64 38.2c10.1 0 19.2 6.4 22.6 15.9L541.9 272H322.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM320 320H544c26.5 0 48 21.5 48 48v32H272V368c0-26.5 21.5-48 48-48zm40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBracketCurly = {
  prefix: 'far',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M64 120c0-48.6 39.4-88 88-88h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-22.1 0-40 17.9-40 40v45.5c0 23.3-9.3 45.7-25.8 62.2L57.9 256l28.3 28.3c16.5 16.5 25.8 38.9 25.8 62.2V392c0 22.1 17.9 40 40 40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-48.6 0-88-39.4-88-88V346.5c0-10.6-4.2-20.8-11.7-28.3L7 273c-9.4-9.4-9.4-24.6 0-33.9l45.3-45.3c7.5-7.5 11.7-17.7 11.7-28.3V120z"]
};
var faBracketCurlyLeft = faBracketCurly;
var faLobster = {
  prefix: 'far',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240H176v16H143.1c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H176v16H122.4c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H176v16h-.9c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1h.9l23.8 66.6c-23.1 7.3-39.8 28.8-39.8 54.3c0 3.9 3.2 7.1 7.1 7.1H344.9c3.9 0 7.1-3.2 7.1-7.1c0-25.5-16.7-47-39.8-54.3L336 384h.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H336V336h53.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H336V288h32.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H336V240h2.9c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5V72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9v64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192h-3.4c-2.6-22.5-16-42.9-31.5-59.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7v25c-3.2-2.2-6.3-4.1-9-5.8c-4.3-2.6-9.7-2.6-14 0c-2.8 1.6-5.8 3.6-9 5.8v-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v52.1c-15.5 16.3-28.9 36.7-31.5 59.2h-3.4c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4V64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72V8.2zM262.2 448H249.8L224 375.7V240 200c0-6.6 3.8-17 15.4-30.3c5.2-6 11-11.4 16.6-16c5.7 4.7 11.5 10.1 16.6 16C284.2 183 288 193.4 288 200v40V375.7L262.2 448z"]
};
var faCartFlatbedEmpty = {
  prefix: 'far',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", "M0 24C0 10.7 10.7 0 24 0H72c30.9 0 56 25.1 56 56V408c0 4.4 3.6 8 8 8h72H496 616c13.3 0 24 10.7 24 24s-10.7 24-24 24H544c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48H136c-30.9 0-56-25.1-56-56V56c0-4.4-3.6-8-8-8H24C10.7 48 0 37.3 0 24z"]
};
var faDollyFlatbedEmpty = faCartFlatbedEmpty;
var faColon = {
  prefix: 'far',
  iconName: 'colon',
  icon: [192, 512, [], "3a", "M120 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 128zm96 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 384z"]
};
var faCartArrowDown = {
  prefix: 'far',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M0 24C0 10.7 10.7 0 24 0H69.5c26.9 0 50 19.1 55 45.5l37 194.5H459.2c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 24V126.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faWand = {
  prefix: 'far',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M459.1 48c-1.2 0-2.4 .4-3.3 1.3L52.4 414.7c-2.8 2.5-4.4 6.1-4.4 9.9c0 3.5 1.4 6.9 3.9 9.4L78 460.1c2.5 2.5 5.9 3.9 9.4 3.9c3.8 0 7.3-1.6 9.9-4.4L462.7 56.1c.8-.9 1.3-2.1 1.3-3.3c0-2.7-2.2-4.9-4.9-4.9zM423.6 13.7C433.4 4.9 446 0 459.1 0C488.3 0 512 23.7 512 52.9c0 13.1-4.9 25.8-13.7 35.5l-46.2 51c-2.7 2.9-4.1 6.8-4.1 10.7V176c0 8.8-7.2 16-16 16H411.6c-4.5 0-8.8 1.9-11.9 5.3L132.9 491.8C121.3 504.7 104.8 512 87.5 512c-16.3 0-31.9-6.5-43.4-18L18 467.9C6.5 456.4 0 440.8 0 424.5c0-17.3 7.3-33.8 20.2-45.4l70.6-63.9c3.3-3 5.3-7.3 5.3-11.9V272c0-8.8 7.2-16 16-16h37.9c4 0 7.8-1.5 10.7-4.1l263-238.2z"]
};
var faWalkieTalkie = {
  prefix: 'far',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H56C25.1 96 0 121.1 0 152V305.4c0 10.6 4.2 20.8 11.7 28.3L32 353.9V456c0 30.9 25.1 56 56 56H296c30.9 0 56-25.1 56-56V353.9l20.3-20.3c7.5-7.5 11.7-17.7 11.7-28.3V152c0-30.9-25.1-56-56-56h-8c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm80 120h96 40c4.4 0 8 3.6 8 8V302.1l-20.3 20.3c-7.5 7.5-11.7 17.7-11.7 28.3V456c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V350.6c0-10.6-4.2-20.8-11.7-28.3L48 302.1V152c0-4.4 3.6-8 8-8H88 192zm-56 48c-13.3 0-24 10.7-24 24s10.7 24 24 24H248c13.3 0 24-10.7 24-24s-10.7-24-24-24H136zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H248c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"]
};
var faFilePen = {
  prefix: 'far',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", "M64 464H262.6l-5.1 20.5c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V285.7l-48 48V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faFileEdit = faFilePen;
var faReceipt = {
  prefix: 'far',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M39.6 5.8C32.5-.3 22.5-1.7 14 2.2S0 14.6 0 24V488c0 9.4 5.5 17.9 14 21.8s18.5 2.5 25.6-3.6L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c7.1 6.1 17.1 7.5 25.6 3.6s14-12.4 14-21.8V24c0-9.4-5.5-17.9-14-21.8s-18.5-2.5-25.6 3.6L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8zm8.4 430V76.2l16.4 14c9 7.7 22.3 7.7 31.2 0L136 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L248 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l16.4-14V435.8l-16.4-14c-9-7.7-22.3-7.7-31.2 0L248 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0L136 456.4 95.6 421.8c-9-7.7-22.3-7.7-31.2 0L48 435.8zM120 144c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 256c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
};
var faTablePicnic = {
  prefix: 'far',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M88 64C74.7 64 64 74.7 64 88s10.7 24 24 24h71.4L106.3 240H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H86.4h52H373.6h52H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H405.7L352.6 112H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM438.9 320h-52l46.9 113.2c5.1 12.2 19.1 18.1 31.4 13s18.1-19.1 13-31.4L438.9 320zm-313.8 0h-52L33.8 414.8c-5.1 12.2 .7 26.3 13 31.4s26.3-.7 31.4-13L125.1 320zm33.2-80l53.1-128h89.3l53.1 128H158.3z"]
};
var faSquarePen = {
  prefix: 'far',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm325.8 43.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faCircleMicrophoneLines = {
  prefix: 'far',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416c-26.5 0-48 21.5-48 48V256c0 26.5 21.5 48 48 48s48-21.5 48-48H280c-8.8 0-16-7.2-16-16s7.2-16 16-16h24V192H280c-8.8 0-16-7.2-16-16s7.2-16 16-16h24V144c0-26.5-21.5-48-48-48zM176 256c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 62.5 44.8 114.5 104 125.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24V381.8c59.2-11.2 104-63.3 104-125.8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
var faMicrophoneCircleAlt = faCircleMicrophoneLines;
var faDisplaySlash = {
  prefix: 'far',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9V64c0-35.3-28.7-64-64-64H96C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zm54.9 43c.7-.1 1.5-.2 2.3-.2H544c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H501.8L93.7 48.2zM80 352V159.2L32 121.4V352c0 35.3 28.7 64 64 64H243.7l-8 48H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H384h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H404.3l-8-48H406L345 368H272.4c-.2 0-.4 0-.6 0c-.1 0-.2 0-.3 0H96c-8.8 0-16-7.2-16-16zm212.3 64h55.3l8 48H284.3l8-48z"]
};
var faDesktopSlash = faDisplaySlash;
var faSuitcaseRolling = {
  prefix: 'far',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M144 56v72h96V56c0-4.4-3.6-8-8-8H152c-4.4 0-8 3.6-8 8zM96 128V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56v72h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H112v8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H96zM64 176c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H64zm32 72c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm0 112c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24z"]
};
var faPersonCircleExclamation = {
  prefix: 'far',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1H146.3c-.8 0-1.5 0-2.3 .1zM144 352V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faTransporter2 = {
  prefix: 'far',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", "M64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6L64 32zM480 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 352zM120 464H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM180.4 224H120.2l46.4-61.2c16.6-21.9 42.6-34.8 70.1-34.8h38.6c27.5 0 53.5 12.9 70.1 34.8L391.8 224H331.6 320 272V176H240v48H192 180.4zM112 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHandsHoldingDiamond = {
  prefix: 'far',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96zM72 64c39.8 0 72 32.2 72 72V264.8c12.1-10.5 28-16.8 45.3-16.8c18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3c5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3c17.3 0 33.1 6.3 45.3 16.8V136c0-39.8 32.2-72 72-72s72 32.2 72 72V352.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V281.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9 0 0L473 393l0 0-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16 0 0 26.7-26.7c4-4 6.2-9.4 6.2-15c0-11.7-9.5-21.3-21.3-21.3c-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V436.8c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2c-11.7 0-21.3 9.5-21.3 21.3c0 5.6 2.2 11 6.2 15L201 359l0 0 16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16 0 0-26.7-26.7 0 0-15.9-15.9C106.2 332.1 96 307.5 96 281.9V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V352.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L35.1 437.1C12.6 414.6 0 384.1 0 352.2V136C0 96.2 32.2 64 72 64z"]
};
var faHandReceiving = faHandsHoldingDiamond;
var faMoneyBillSimpleWave = {
  prefix: 'far',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4l0 0c73.7-18.9 160.5-41.1 248.8-20.9V91.8C461.8 68.7 393.6 83 310.3 104.1c-4.5 1.1-9 2.3-13.5 3.5l0 0C223.1 126.4 136.3 148.7 48 128.4V420.2c66.2 23.1 134.4 8.9 217.7-12.3zM0 421.5V113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
};
var faChevronDown = {
  prefix: 'far',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
};
var faBatteryFull = {
  prefix: 'far',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", "M464 144c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faBellPlus = {
  prefix: 'far',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", "M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM224 152c-13.3 0-24 10.7-24 24v40H160c-13.3 0-24 10.7-24 24s10.7 24 24 24h40v40c0 13.3 10.7 24 24 24s24-10.7 24-24V264h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V176c0-13.3-10.7-24-24-24z"]
};
var faBookArrowRight = {
  prefix: 'far',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", "M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V394.6c18.9-9 32-28.3 32-50.6V288H400v56c0 4.4-3.6 8-8 8H80c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H392c4.4 0 8 3.6 8 8v72h48V56c0-30.9-25.1-56-56-56H88zM368 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H368zM553 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H558.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
var faHospitals = {
  prefix: 'far',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M320 48H512c8.8 0 16 7.2 16 16V256H320v48H528v48H320v48H528v48c0 8.8-7.2 16-16 16H320c0 17.3-5.5 33.2-14.7 46.3c4.7 1.1 9.7 1.7 14.7 1.7H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64v1.6c19.5 4 36.5 15 48 30.4V64c0-8.8 7.2-16 16-16zm88 48v24H384c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H456V96c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16zM136 176c-8.8 0-16 7.2-16 16v24H96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V264h24c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H168V192c0-8.8-7.2-16-16-16H136zM64 144H224c8.8 0 16 7.2 16 16V352H48V160c0-8.8 7.2-16 16-16zM48 400H240v48c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V400zM0 160V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64C28.7 96 0 124.7 0 160z"]
};
var faClub = {
  prefix: 'far',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M352 146.4c0-.8 0-1.6 0-2.4c0-53-43-96-96-96s-96 43-96 96c0 .8 0 1.6 0 2.4c.6 22.9-15.1 42.9-37.4 48C79.9 204.1 48 242.4 48 288c0 53 43 96 96 96c30.1 0 57-13.8 74.7-35.7c9.1-11.3 22.8-17.8 37.3-17.8s28.2 6.5 37.3 17.8C311 370.2 337.9 384 368 384c53 0 96-43 96-96c0-45.6-31.9-83.9-74.6-93.6c-22.3-5.1-37.9-25.1-37.4-48zM368 432c-27.9 0-53.9-7.9-76-21.7c-4.1-2.6-8.1-5.4-12-8.3v62h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V402c-3.8 3-7.8 5.8-12 8.3c-22.1 13.7-48.1 21.7-76 21.7C64.5 432 0 367.5 0 288c0-68.5 47.9-125.9 112-140.4c0-1.2 0-2.4 0-3.6C112 64.5 176.5 0 256 0s144 64.5 144 144c0 1.2 0 2.4 0 3.6c64.1 14.5 112 71.9 112 140.4c0 79.5-64.5 144-144 144z"]
};
var faSkullCrossbones = {
  prefix: 'far',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", "M290.1 185.8C309.6 170.4 320 149.5 320 128c0-39-37.5-80-96-80s-96 41-96 80c0 21.5 10.4 42.4 29.9 57.8c11.4 9.1 18.1 22.9 18.1 37.6V232c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-8.6c0-14.6 6.7-28.5 18.1-37.6zM320 232c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56v-8.6C98.5 200 80 165.9 80 128C80 57.3 144.5 0 224 0s144 57.3 144 128c0 37.9-18.5 72-48 95.4V232zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L224 357l188.9-98.2c11.8-6.1 26.2-1.5 32.4 10.2s1.5 26.3-10.2 32.4L276 384l159.1 82.7c11.8 6.1 16.3 20.6 10.2 32.4s-20.6 16.3-32.4 10.2L224 411 35.1 509.3c-11.8 6.1-26.3 1.5-32.4-10.2s-1.5-26.2 10.2-32.4L172 384 12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM160 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faDropletDegree = {
  prefix: 'far',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zM400 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faDewpoint = faDropletDegree;
var faCodeCompare = {
  prefix: 'far',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v48h16c39.8 0 72-32.2 72-72V156.3c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V320c0 66.3-53.7 120-120 120H320v48zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V120H176c-39.8 0-72 32.2-72 72V355.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3V192c0-66.3 53.7-120 120-120h16V24zM48 432a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faListUl = {
  prefix: 'far',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm120 8c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faListDots = faListUl;
var faHandHoldingMagic = {
  prefix: 'far',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M176 76c0 15.5 12.5 28 28 28h84c13.3 0 24 10.7 24 24s-10.7 24-24 24H204c-42 0-76-34-76-76s34-76 76-76H328c66.3 0 120 53.7 120 120s-53.7 120-120 120H280v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24h72c39.8 0 72-32.2 72-72s-32.2-72-72-72H204c-15.5 0-28 12.5-28 28zm11.4 276c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H387.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H344 320 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"]
};
var faWatermelonSlice = {
  prefix: 'far',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M0 408c0-6.4 2.5-12.5 7-17L391 7c9.4-9.4 24.6-9.4 33.9 0c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c-4.5-4.5-7-10.6-7-17zm58.7-.8c97.4 80.4 241.5 75.3 332.6-15.8s96.2-235.2 15.8-332.6L384.8 81.2C414.3 118.1 432 165 432 216c0 119.3-96.7 216-216 216c-51 0-97.9-17.7-134.8-47.2L58.7 407.2zM384 216c0-37.7-12.4-72.6-33.4-100.6l-26.3 26.3 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-26.3 26.3c28 21 62.9 33.4 100.6 33.4c92.8 0 168-75.2 168-168zm-52.7 12.7l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faCircleEllipsis = {
  prefix: 'far',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faSchoolLock = {
  prefix: 'far',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92H568c39.8 0 72 32.2 72 72V272c0-38.1-19-71.7-48-91.9V168c0-13.3-10.7-24-24-24H464c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4H72c-13.3 0-24 10.7-24 24V440c0 13.3 10.7 24 24 24H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80 16c0 11.7 3.1 22.6 8.6 32H384 256 72c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72h96.7l138-92zM112 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM240 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V160c0-8.8-7.2-16-16-16zm208 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faTowerCell = {
  prefix: 'far',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M51.8 1.6c12.4 4.8 18.5 18.7 13.8 31C54.3 62 48 94.2 48 128s6.3 66 17.6 95.4c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8C7.4 205.8 0 167.8 0 128S7.4 50.2 20.8 15.4C25.6 3 39.5-3.2 51.8 1.6zm472.4 0c12.4-4.8 26.3 1.4 31 13.8C568.6 50.2 576 88.2 576 128s-7.4 77.8-20.8 112.6c-4.8 12.4-18.7 18.5-31 13.8s-18.5-18.7-13.8-31C521.7 194 528 161.8 528 128s-6.3-66-17.6-95.4c-4.8-12.4 1.4-26.3 13.8-31zM291.3 191.9c-1.1 .1-2.2 .1-3.3 .1s-2.2 0-3.3-.1L239.8 288h96.4l-44.8-96.1zM195 384H381l-22.4-48H217.4L195 384zm-22.4 48l-30.9 66.2c-5.6 12-19.9 17.2-31.9 11.6s-17.2-19.9-11.6-31.9L241.2 171.6C230.5 160.2 224 144.9 224 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 16.9-6.5 32.2-17.2 43.6L477.7 477.9c5.6 12 .4 26.3-11.6 31.9s-26.3 .4-31.9-11.6L403.4 432H172.6zM163.3 73.6C156 90.2 152 108.6 152 128s4 37.8 11.3 54.4c5.3 12.1-.2 26.3-12.4 31.6s-26.3-.2-31.6-12.4C109.5 179 104 154.1 104 128s5.5-51 15.3-73.6c5.3-12.1 19.5-17.7 31.6-12.4s17.7 19.5 12.4 31.6zM456.7 54.4C466.5 77 472 101.9 472 128s-5.5 51-15.3 73.6c-5.3 12.1-19.5 17.7-31.6 12.4s-17.7-19.5-12.4-31.6c7.3-16.6 11.3-35 11.3-54.4s-4-37.8-11.3-54.4c-5.3-12.1 .2-26.3 12.4-31.6s26.3 .2 31.6 12.4z"]
};
var faSdCards = {
  prefix: 'far',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M400 352V64c0-8.8-7.2-16-16-16H234.5c-4.2 0-8.3 1.7-11.3 4.7l-74.5 74.5c-3 3-4.7 7.1-4.7 11.3V352c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16zM114.7 93.3l74.5-74.5C201.3 6.7 217.5 0 234.5 0H384c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V138.5c0-17 6.7-33.3 18.7-45.3zM24 96c13.3 0 24 10.7 24 24V376c0 48.6 39.4 88 88 88H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm280 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faJugBottle = {
  prefix: 'far',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zm32 152c-44.2 0-80 35.8-80 80V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256c0-44.2-35.8-80-80-80H128zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm224 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256zM472 64h80c13.3 0 24 10.7 24 24v40H448V88c0-13.3 10.7-24 24-24zM417 392c-.3-.2-.7-.4-1-.6V256c0-24.7-5.6-48.1-15.6-69c5.1-5.3 11.1-9.8 18-13l13.2-6.2c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l13.2 6.2c21 9.9 34.4 31 34.4 54.2c0 22.8-12.7 42.6-31.5 52.7C627.4 292 640 312.5 640 336c0 24.1-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56c0 35.3-28.7 64-64 64H448c-17 0-32.5-6.7-44-17.5c7.6-13.8 12-29.6 12-46.5V392.6c.3-.2 .7-.4 1-.6z"]
};
var faDownLong = {
  prefix: 'far',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", "M176.4 505.5c-9.2 8.7-23.7 8.7-32.9 0L14.6 384.1C5.3 375.3 0 363.1 0 350.3C0 324.7 20.7 304 46.3 304L80 304 80 56c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 248 33.7 0c25.6 0 46.3 20.7 46.3 46.3c0 12.8-5.3 25-14.6 33.7l-129 121.4zm93-153.5L216 352c-13.3 0-24-10.7-24-24l0-272c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 272c0 6.4-2.5 12.5-7 17s-10.6 7-17 7l-53.5 0L160 455 269.5 352z"]
};
var faLongArrowAltDown = faDownLong;
var faEnvelopes = {
  prefix: 'far',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M512 80H160c-8.8 0-16 7.2-16 16v7.8L321.4 235.2c4.2 3.1 9.3 4.8 14.6 4.8s10.4-1.7 14.6-4.8L528 103.8V96c0-8.8-7.2-16-16-16zm16 83.5L379.1 273.8C366.7 283 351.5 288 336 288s-30.7-5-43.1-14.2L144 163.5V320c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V163.5zM160 32H512c35.3 0 64 28.7 64 64V320c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24V344c0 48.6 39.4 88 88 88H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 480 0 419.1 0 344V120c0-13.3 10.7-24 24-24z"]
};
var faPhoneOffice = {
  prefix: 'far',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", "M160 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H160zM104.6 32C115.6 12.9 136.3 0 160 0h48c23.7 0 44.4 12.9 55.4 32H320h24 24H512c35.3 0 64 28.7 64 64v48 24 24V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32h40.6zM96 80H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V192H360c-22.1 0-40-17.9-40-40V80H272V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V80zm272 0v64H528V96c0-8.8-7.2-16-16-16H368zm16 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM352 400a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM480 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM448 400a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faRankingStar = {
  prefix: 'far',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", "M353.8 54.1l52.3 7.5c9.3 1.4 13.2 12.9 6.4 19.8l-38 36.6 9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.6-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l9-52.1-38-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5L309.8 6.3c4.3-8.6 16.5-8.3 20.4 0l23.6 47.8zM272 304V464h96V304H272zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V304zM48 368v96h96V368H48zM0 368c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368zm592 32H496v64h96V400zm-96-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faChessKing = {
  prefix: 'far',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V56H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v40H59.6C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352h52.3L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6H224 388.4c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352h52.3l54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H248V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V24zM101.2 432H346.8l16.6 32H84.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3H91.5c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512H375.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"]
};
var faNfcPen = {
  prefix: 'far',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", "M384 80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H270.5l-12 48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V235.6l-48 48V96c0-8.8-7.2-16-16-16zM289.3 394.3c-1.8 1.8-3.5 3.7-5 5.7H120c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40h16c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V352H320V160H248v54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6V152c0-22.1 17.9-40 40-40h88c22.1 0 40 17.9 40 40V315.6l-78.7 78.7zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faPersonHarassing = {
  prefix: 'far',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 209.5L44.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1S-3.4 287.7 3.1 276.2L61.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h35c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L224 214.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1H144V304h32V176.1zM304 32h56c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm116 56c33.1 0 60 26.9 60 60v96c0 31.8-24.7 57.8-56 59.9v.1c-.7 0-1.5 0-2.2 0c-.6 0-1.2 0-1.8 0c-5.7 0-11.1-.8-16.3-2.2c-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L456 413V356c0-33.1 26.9-60 60-60zm1.4 167.9c6-.7 10.6-5.8 10.6-11.9V356c0-6.6-5.4-12-12-12s-12 5.4-12 12v96c0 5.2 3.2 9.5 7.8 11.2c1.8 .3 3.7 .6 5.6 .7zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z"]
};
var faHatWinter = {
  prefix: 'far',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M256 0c-12.7 0-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C326.2 103 336 92.7 336 80s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2C279 9.8 268.7 0 256 0zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48H464c26.5 0 48-21.5 48-48s-21.5-48-48-48H48zM162.5 134.6C42.8 199.9 32 384 32 384H80.1c.1-1.5 .3-3.7 .6-6.3c.7-6.5 2-16 4.2-27.4c.9-4.9 2-10.1 3.2-15.5l36.3-18.1c2.3-1.1 4.9-1.1 7.2 0L167 334.3c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0L295 334.3c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0l36.3 18.1c1.2 5.4 2.3 10.6 3.2 15.5c2.1 11.5 3.4 21 4.2 27.4c.3 2.6 .5 4.7 .6 6.3H480s-10.8-184.1-130.5-249.4c-2.5 9-7.3 17.5-14.4 24.6c-5.6 5.6-12.2 9.8-19.2 12.6c41 17.8 67.7 53.9 86 95.6c.6 1.3 1.2 2.7 1.7 4c-14.5-5.5-30.8-4.7-44.9 2.3l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L281 273.7c-15.8-7.9-34.3-7.9-50.1 0l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L153 273.7c-14.1-7-30.3-7.8-44.9-2.3c.6-1.3 1.2-2.7 1.7-4c18.4-41.7 45.1-77.8 86-95.6c-7-2.7-13.5-6.9-19.2-12.6c-7.1-7.1-11.9-15.6-14.4-24.6z"]
};
var faBrazilianRealSign = {
  prefix: 'far',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M400 0c13.3 0 24 10.7 24 24V65.2c14.6 1.7 29 5.4 42.7 10.9l14.2 5.7c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-14.3-5.7c-14.2-5.7-29.3-8.6-44.6-8.6H392c-30.9 0-56 25.1-56 56c0 23.5 14.7 44.6 36.8 52.6l70.7 25.7c41.1 14.9 68.4 54 68.4 97.7c0 52-38.2 95.1-88 102.8V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V445.8c-17.1-3-33.7-8.9-48.9-17.6l-27-15.4c-11.5-6.6-15.5-21.2-8.9-32.7s21.2-15.5 32.7-8.9l27 15.4c15.4 8.8 32.8 13.4 50.6 13.4H408c30.9 0 56-25.1 56-56c0-23.5-14.7-44.6-36.8-52.6l-70.7-25.7c-41.1-14.9-68.4-54-68.4-97.7c0-52 38.2-95.1 88-102.8V24c0-13.3 10.7-24 24-24zM0 56C0 42.7 10.7 32 24 32h96c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304H48V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V280 56zM48 256h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H48V256z"]
};
var faLandmarkDome = {
  prefix: 'far',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M256 0c13.3 0 24 10.7 24 24v9.5C369.5 44.6 439.9 117.4 447.3 208H456c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H400 112 64 56c-13.3 0-24-10.7-24-24s10.7-24 24-24h8.7C72.1 117.4 142.5 44.6 232 33.5V24c0-13.3 10.7-24 24-24zM112.9 208H399.1c-8-72-69-128-143.1-128s-135.2 56-143.1 128zm-.9 80v96h64V288h48v96h64V288h48v96h64V288h48v96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H64c-13.3 0-24-10.7-24-24s10.7-24 24-24V288h48zM8 488c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-13.3 0-24-10.7-24-24z"]
};
var faLandmarkAlt = faLandmarkDome;
var faBoneBreak = {
  prefix: 'far',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L201 71zM473 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM296.1 264.8c-1.9-13.4-14.5-22.6-27.9-20.2L180.1 260c-4.1 .7-8-1.8-9.4-5.7c-14.3-39.1-55.3-63.6-98-56.1C24.9 206.6-7.1 251.8 1.4 299.3c4.5 25.1 19.3 45.7 39.4 58.4c4.7 3 5.8 9.5 2.5 13.9c-14.5 18.7-21.3 43.2-16.8 68.3c8.4 47.5 54.1 79.1 101.9 70.8c42.7-7.5 72.8-44.4 72.7-86c0-4.1 2.8-7.8 6.9-8.5L320 396.6l112.1 19.6c4.1 .7 6.9 4.4 6.9 8.5c-.1 41.6 30 78.5 72.7 86c47.9 8.4 93.5-23.3 101.9-70.8c4.5-25.1-2.4-49.5-16.8-68.3c-3.4-4.4-2.2-11 2.5-13.9c20.1-12.7 34.9-33.4 39.4-58.4c8.4-47.5-23.5-92.7-71.4-101.1c-42.7-7.5-83.7 17-98 56.1c-1.4 3.9-5.3 6.4-9.4 5.7l-88.1-15.4c-13.3-2.3-26 6.8-27.9 20.2c-1.8 12.8 6.9 24.8 19.6 27l88.1 15.4c29.1 5.1 54.1-12.9 62.8-36.5c6.4-17.4 24.9-28.7 44.6-25.3c22.1 3.9 36.1 24.4 32.4 45.4c-2 11.2-8.5 20.4-17.8 26.3c-28.5 18-35.6 57-14.8 83.8c6.6 8.5 9.5 19.4 7.6 30.5c-3.7 21.1-24.3 35.8-46.4 31.9c-19.6-3.4-33-20.2-33-38.6c0-25.3-17.4-50.8-46.6-55.9L324.8 348.7c-1.6-.3-3.2-.4-4.8-.4c-1.6 0-3.2 .1-4.8 .4L199.7 368.9C170.5 374 153 399.5 153 424.8c0 18.4-13.4 35.2-33 38.6c-22.2 3.9-42.7-10.8-46.4-31.9c-2-11.1 1-22 7.6-30.5c20.8-26.9 13.7-65.9-14.8-83.8c-9.2-5.8-15.8-15.1-17.8-26.3c-3.7-20.9 10.3-41.5 32.4-45.4c19.7-3.4 38.3 7.9 44.6 25.3c8.6 23.6 33.7 41.6 62.8 36.5l88.1-15.4c12.8-2.2 21.5-14.2 19.6-27z"]
};
var faArrowUp = {
  prefix: 'far',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V115.9L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z"]
};
var faDownFromDottedLine = {
  prefix: 'far',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", "M114.2 320L224 430 333.8 320H280c-13.3 0-24-10.7-24-24V176H192V296c0 13.3-10.7 24-24 24H114.2zM224 480c-11.5 0-22.5-4.6-30.6-12.7L77.6 351.2C68.9 342.5 64 330.7 64 318.4c0-25.6 20.8-46.4 46.4-46.4H144V176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96h33.6c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faTv = {
  prefix: 'far',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM120 464H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faBorderLeft = {
  prefix: 'far',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M24 480c-13.3 0-24-10.7-24-24L0 56C0 42.7 10.7 32 24 32s24 10.7 24 24l0 400c0 13.3-10.7 24-24 24zm104-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faCircleDivide = {
  prefix: 'far',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faShrimp = {
  prefix: 'far',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M0 104C0 64.2 32.2 32 72 32H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24 10.7-24 24s10.7 24 24 24H336c97.2 0 176 78.8 176 176s-78.8 176-176 176H248c-13.3 0-24-10.7-24-24c0-12 8.8-21.9 20.2-23.7l-4.9-1.9c-12.4-4.8-18.5-18.7-13.7-31.1s18.7-18.5 31.1-13.7l68.7 26.7c20.5 8 42.6-7.1 42.6-29.1c0-17.3-14-31.2-31.2-31.2H259.5C158 352 74.5 274.6 64.9 175.7C28.5 172.1 0 141.4 0 104zM464 304c0-9.3-1-18.4-2.9-27.2L401 336.9c9.4 13 15 29 15 46.3c0 8.2-1.2 16-3.4 23.4C443.8 383.3 464 346 464 304zm-23.7-74.2c-21.8-30.5-56.6-51.1-96.3-53.5V304.3c6.2 .6 12.2 1.8 18 3.8l78.3-78.3zM296 176H113.3c9.5 72.2 71.4 128 146.2 128H296V176zm-72 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faListCheck = {
  prefix: 'far',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24zM192 256c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTasks = faListCheck;
var faDiagramSubtask = {
  prefix: 'far',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H152v96c0 22.1 17.9 40 40 40h32v-8c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H288c-35.3 0-64-28.7-64-64v-8H192c-48.6 0-88-39.4-88-88V224H64c-35.3 0-64-28.7-64-64V96zM448 336H288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16z"]
};
var faJugDetergent = {
  prefix: 'far',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M120 0C106.7 0 96 10.7 96 24V48H88C74.7 48 64 58.7 64 72s10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V24c0-13.3-10.7-24-24-24H120zM256 176c44.2 0 80 35.8 80 80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80H256zM128 128C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"]
};
var faCircleUser = {
  prefix: 'far',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"]
};
var faUserCircle = faCircleUser;
var faSquareY = {
  prefix: 'far',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm138.1 56.3L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"]
};
var faUserDoctorHair = {
  prefix: 'far',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zm64 225c5.2-.7 10.6-1 16-1h96c5.4 0 10.8 .3 16 1v49c-27.6 7.1-48 32.2-48 62v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V464c0-17.7 14.3-32 32-32s32 14.3 32 32v16h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24c8.8 0 16-7.2 16-16V464c0-29.8-20.4-54.9-48-62V361.3c46.9 19 80 65 80 118.7v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-97.2-78.8-176-176-176H176C78.8 304 0 382.8 0 480v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-53.7 33.1-99.7 80-118.7v41c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V353zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPlanetRinged = {
  prefix: 'far',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", "M464 31.1a.9 .9 0 1 0 -1.6 .5 .9 .9 0 1 0 1.6-.5zm-5.2 22.1c-11.9 4.4-27 11.5-45 21.9c-13.4-11.8-27.9-21.8-43-30c63.8-40.5 113.9-56.2 133.1-37c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208c-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1c8.3 15.1 18.3 29.6 30 43c-10.4 18-17.6 33-21.9 45c12.6-4.6 28.7-12.3 48.1-23.8c8.2-4.8 16.7-10.2 25.4-16C78.8 380.9 48 322 48 256C48 141.1 141.1 48 256 48c66 0 124.9 30.8 163 78.8c5.8-8.8 11.2-17.3 16-25.4c11.4-19.4 19.2-35.5 23.8-48.1zM389.6 167.9C361 124.6 311.8 96 256 96C167.6 96 96 167.6 96 256c0 55.8 28.6 105 71.9 133.6c37.1-28.2 77.4-63.4 117.8-103.8s75.6-80.8 103.8-117.8zM217.9 411.4c12.2 3 25 4.6 38.1 4.6c88.4 0 160-71.6 160-160c0-13.1-1.6-25.9-4.6-38.1c-26.5 33-57.4 67.5-91.7 101.8s-68.8 65.2-101.8 91.7zM31.1 464a.9 .9 0 1 0 .5-1.6 .9 .9 0 1 0 -.5 1.6zm16.8 16a1.1 1.1 0 1 0 1.8 1.1A1.1 1.1 0 1 0 47.9 480zM480 47.9a1.1 1.1 0 1 0 1.1 1.8A1.1 1.1 0 1 0 480 47.9z"]
};
var faMushroom = {
  prefix: 'far',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M24 258.1C24 133.2 125.2 32 250.1 32h11.8C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9H320.6 191.4 85.9C51.7 320 24 292.3 24 258.1zM145.9 113.6C101.2 146 72 198.6 72 258.1c0 7.7 6.2 13.9 13.9 13.9H426.1c7.7 0 13.9-6.2 13.9-13.9c0-12-1.2-23.7-3.4-35C427.8 233.4 414.6 240 400 240c-26.5 0-48-21.5-48-48c0-26.1 20.8-47.3 46.7-48c-24.2-29-57.5-50.2-95.4-59.2c.5 3.7 .8 7.4 .8 11.2c0 44.2-35.8 80-80 80c-38.1 0-70-26.7-78.1-62.4zM234.3 352l-15 80h73.4l-15-80h48.8l16.9 90.1c1.8 9.4-.7 19-6.8 26.3s-15.1 11.6-24.6 11.6H200c-9.5 0-18.5-4.2-24.6-11.6s-8.6-17-6.8-26.3L185.4 352h48.8zM144 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserShield = {
  prefix: 'far',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464H374.7c13.2 17.2 29.3 33.4 48.9 47.5c-1.7 .3-3.5 .5-5.3 .5H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c17.6 0 34.6 2.6 50.7 7.3c.9 16.6 3.4 35.3 8.3 54.8c-17.7-9-37.8-14.1-59-14.1H178.3c-65.7 0-120.1 48.7-129 112zM487.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C634 277.4 640 286.2 640 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C377.9 464.8 352 359.3 352 296c0-9.8 6-18.6 15.1-22.3l120-48zM591.4 312L496 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"]
};
var faMegaphone = {
  prefix: 'far',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", "M552 32c-13.3 0-24 10.7-24 24v5.7L48 192.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v21.7V224v64 18.3V328c0 13.3 10.7 24 24 24s24-10.7 24-24v-8.6l117.6 32.1C162 361.7 160 372.6 160 384c0 53 43 96 96 96c46.9 0 86-33.6 94.3-78.1L528 450.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V432 80 56c0-13.3-10.7-24-24-24zM528 400.6L48 269.7V242.3L528 111.4V400.6zM208 384c0-7.1 1.5-13.8 4.3-19.8l91.5 24.9c-2.6 24.1-23 42.8-47.7 42.8c-26.5 0-48-21.5-48-48z"]
};
var faWreathLaurel = {
  prefix: 'far',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M237.1 50.9l-11.8 .7c-20.3 1.1-36.6 17.4-37.7 37.7l-.7 11.8 11.8-.7c20.3-1.1 36.6-17.4 37.7-37.7l.7-11.8zM43.1 177.7c-11.4-30.3-9.7-65.3 7.8-95.6L71.5 46.4c6.3-10.9 20.2-14.6 31-8.3c15.9 9.2 28.9 21.4 38.8 35.5c8-38.5 41-67.7 81.3-70l38.6-2.1c14.3-.8 26.1 11 25.3 25.3l-2.1 38.6c-2.5 44.8-38.2 80.5-83 83l-24.6 1.4C155.6 180.8 144 217.8 144 256c0 97.2 78.8 176 176 176h11.6c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480H320 308.4c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.1 16.8-7.9 25.4-11.2c-5.5-3.1-10.8-6.5-15.9-10.1l-4.8 2.8-.3 .2c-4.6 2.7-9.4 5-14.2 6.9c-50.9 20.4-110.3 .8-138.5-48L14.2 366.4c-6.3-10.9-2.6-24.8 8.3-31c6-3.5 12.2-6.4 18.5-8.7C16 306.1 0 274.9 0 240l0-41.2C0 186.2 10.2 176 22.7 176c7 0 13.8 .6 20.4 1.7zm420-28l-24.6-1.4c-44.8-2.5-80.5-38.2-83-83l-2.1-38.6c-.8-14.3 11-26.1 25.3-25.3l38.6 2.1c40.3 2.2 73.3 31.5 81.3 70c9.9-14.1 22.9-26.3 38.8-35.5c10.9-6.3 24.8-2.6 31 8.3l20.6 35.7c17.5 30.3 19.2 65.3 7.8 95.6c6.6-1.1 13.4-1.7 20.4-1.7c12.6 0 22.7 10.2 22.7 22.7l0 41.2c0 34.9-16 66.1-41.1 86.7c6.3 2.3 12.5 5.2 18.5 8.7c10.9 6.3 14.6 20.2 8.3 31l-20.6 35.7c-21.6 37.4-61.5 57.6-101.8 55.9c-5.3-8.3-12.8-15.4-22.3-20.1l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1c-10.4-4.8-21-9-31.8-12.6c-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-38.2-11.6-75.2-32.8-106.3zM414.7 51.6l-11.8-.7 .7 11.8c1.1 20.3 17.4 36.6 37.7 37.7l11.8 .7-.7-11.8c-1.1-20.3-17.4-36.6-37.7-37.7zM96 301.9l0-4.7c0-31.6-20-58.5-48-68.8L48 240c0 29.8 20.4 54.9 48 62zM544 297.2l0 4.7c27.6-7.1 48-32.2 48-62l0-11.5c-28 10.3-48 37.2-48 68.8zM149 407.8l-2.4-4.1c-15.8-27.3-46.5-40.6-75.9-35.6l5.7 9.9c14.9 25.8 45.1 37.3 72.5 29.7zM105.4 179.7c15.8-27.3 11.9-60.6-7.2-83.5l-5.7 9.9c-14.9 25.8-9.8 57.7 10.6 77.7l2.4-4.1zM537 183.8c20.3-20 25.5-51.8 10.6-77.7l-5.7-9.9c-19.1 22.9-22.9 56.2-7.2 83.5l2.4 4.1zM491 407.8c27.4 7.6 57.6-3.9 72.5-29.7l5.7-9.9c-29.4-5.1-60.1 8.2-75.9 35.6l-2.4 4.1z"]
};
var faCircleExclamationCheck = {
  prefix: 'far',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M48 256C48 141.1 141.1 48 256 48c84.1 0 156.7 50 189.4 121.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8C448.8 61.6 359.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c72.9 0 138.8-30.5 185.4-79.4c9.1-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8C368.7 439.2 315.3 464 256 464C141.1 464 48 370.9 48 256zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM625 175c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 209c9.4-9.4 9.4-24.6 0-33.9z"]
};
var faWind = {
  prefix: 'far',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 24c0 13.3 10.7 24 24 24h44c24.3 0 44 19.7 44 44s-19.7 44-44 44H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H356c50.8 0 92-41.2 92-92s-41.2-92-92-92H312c-13.3 0-24 10.7-24 24zm64 368c0 13.3 10.7 24 24 24h44c50.8 0 92-41.2 92-92s-41.2-92-92-92H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H420c24.3 0 44 19.7 44 44s-19.7 44-44 44H376c-13.3 0-24 10.7-24 24zM120 512h44c50.8 0 92-41.2 92-92s-41.2-92-92-92H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H164c24.3 0 44 19.7 44 44s-19.7 44-44 44H120c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
var faBoxDollar = {
  prefix: 'far',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M248 80h94.4c6.3 0 12.1 3.7 14.6 9.5L388.4 160H248V80zm-5.7 128H400V416c0 8.8-7.2 16-16 16H242.3c1.1-2.5 1.7-5.2 1.7-8V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216c0-2.8-.6-5.6-1.7-8zm-36.7 0c-1.1 2.4-1.7 5.2-1.7 8v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5l0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 2.8 .6 5.5 1.7 8H64c-8.8 0-16-7.2-16-16V208H205.7zM200 160H59.6L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70z"]
};
var faBoxUsd = faBoxDollar;
var faCarBurst = {
  prefix: 'far',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M197.2 20.7l30.1 56.7 63.1-11.8c1-.2 2.1-.3 3.1-.4c-3.6 4.1-7 8.4-10.2 13l-29.3 43-35.2 6.6c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c1.9-1.4 3.9-2.4 6-3.2l-19.5 72.7-24 17.7c-7.2 5.3-16.6 6.1-24.6 2.3s-13.2-11.8-13.6-20.7l-2.5-64.2L21.6 241c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42L35.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8s17 4.9 21.2 12.7zM536.5 148.5l-137-36.7c-16.4-4.4-33.8 2.1-43.4 16.1l-31 45.5c1.3 .3 2.5 .6 3.8 .9l237.6 63.7c1.3 .3 2.5 .7 3.7 1.1L566 184.1c-1.3-17-13.1-31.2-29.5-35.6zm77.4 32.1l7.2 96.4c15 22.2 20.7 50.6 13.2 78.6l-12.3 46-6.9 25.7-5.5 20.7-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.5-14.2-14.5-25.1l12.4-46.3-6.7-1.8L232.9 346.9l-6.7-1.8-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.5-14.2-14.5-25.1l12.4-46.3 12.4-46.4 12.3-46c7.5-28 26.6-49.7 50.7-61.5l54.5-79.9c21.1-30.9 59.4-45.1 95.5-35.4l137 36.7c36.1 9.7 62.2 41.1 65 78.4zM554 284.3L316.4 220.6c-25.6-6.9-51.9 8.3-58.8 33.9l-12.3 46 330.3 88.5 12.3-46c6.9-25.6-8.3-51.9-33.9-58.8zm14.3 53.3a27.4 27.4 0 1 1 -52.9-14.2 27.4 27.4 0 1 1 52.9 14.2zM310.9 240.3a27.4 27.4 0 1 1 -14.2 52.9 27.4 27.4 0 1 1 14.2-52.9z"]
};
var faCarCrash = faCarBurst;
var faY = {
  prefix: 'far',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M43.4 41.9C35.7 31.2 20.7 28.8 9.9 36.6S-3.2 59.3 4.6 70.1L168 295.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24V295.8L379.4 70.1c7.8-10.7 5.4-25.7-5.4-33.5s-25.7-5.4-33.5 5.4L192 247.1 43.4 41.9z"]
};
var faUserHeadset = {
  prefix: 'far',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.6c-2.7-4.7-6.1-9.1-9.9-12.9C297.1 229.2 304 211.4 304 192c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 19.4 6.9 37.2 18.4 51.1C151 254.6 144 270.5 144 288c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352h16 16 57.4H304h9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352h16.2H208zm105.6 48H134.4c-40 0-73.6 27.1-83.5 64H397.1c-9.9-36.9-43.5-64-83.5-64z"]
};
var faArrowsRetweet = {
  prefix: 'far',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M145 71c-9.4-9.4-24.6-9.4-33.9 0L23 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47V328c0 48.6 39.4 88 88 88H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-22.1 0-40-17.9-40-40V145.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 71zM312 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c22.1 0 40 17.9 40 40V366.1l-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47V184c0-48.6-39.4-88-88-88H312z"]
};
var faRetweetAlt = faArrowsRetweet;
var faPersonSnowboarding = {
  prefix: 'far',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", "M204.3 3c11.6-6.4 26.2-2.3 32.6 9.3l31.9 57.4c1.3 2.3 3.6 3.8 6.2 4.1l33.8 3.4c24.1 2.4 46.9 12 65.4 27.6L503.5 213.6c10.1 8.5 11.4 23.7 2.9 33.8s-23.7 11.4-33.8 2.9l-68.2-57.5-82.3 43.9 24.7 18.9c24.9 19 34.6 51.9 24.1 81.4l-28.2 79c-1.4 3.8-3.6 7-6.3 9.6l93.3 35.7c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l19.4 7.4c-2.9-11.4 2.9-23.4 14-28.1L192 272l0-68.2c0-21.2 12-40.6 31-50.1L284.4 123l-14.1-1.4c-18.3-1.8-34.5-12.5-43.4-28.5L195 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zm91.8 407.2c-.3-3.4 .1-6.9 1.3-10.3l28.2-79c3.5-9.8 .3-20.8-8-27.1L240 234.4l0 42.9c0 16.1-9.7 30.7-24.6 36.9L134 348.2l162.1 62.1zM259.6 189l20.5 15.7 84.6-45.1-17.2-14.5L259.6 189zM384 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faSnowboarding = faPersonSnowboarding;
var faSquareChevronRight = {
  prefix: 'far',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM313 273L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z"]
};
var faChevronSquareRight = faSquareChevronRight;
var faLacrosseStickBall = {
  prefix: 'far',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M344 48v0l.3 0c22.9 0 53 15.2 78.8 40.9s40.9 55.9 40.9 78.8l0 .3h0c0 37.4-24 70.7-59.5 82.5l-19.7 6.6c-18.9 6.3-36.5 16-51.9 28.6l-42 34.4c-12.6 10.3-28.3 15.9-44.5 15.9c-38.8 0-70.3-31.5-70.3-70.3c0-16.2 5.6-32 15.9-44.5l34.4-42c12.6-15.4 22.3-33 28.6-51.9l6.6-19.7C273.3 72 306.6 48 344 48zm0-48V0C285.9 0 234.3 37.2 215.9 92.3L209.4 112c-4.5 13.4-11.3 25.8-20.2 36.7l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9c0 24 7.1 46.3 19.4 65L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L181.4 364.6c18.6 12.3 41 19.4 65 19.4c27.3 0 53.8-9.4 74.9-26.7l42-34.4c10.9-8.9 23.3-15.8 36.7-20.2l19.7-6.6c55.1-18.4 92.3-70 92.3-128.1h0l0-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0L344 0zM464 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faTruckFast = {
  prefix: 'far',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M352 48H128c-8.8 0-16 7.2-16 16V96H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H64V64C64 28.7 92.7 0 128 0H352c35.3 0 64 28.7 64 64V96h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c0 53-43 96-96 96s-96-43-96-96h-8H352 320 256c0 53-43 96-96 96s-96-43-96-96V368 288h48v44.8c14.1-8.2 30.5-12.8 48-12.8c35.5 0 66.6 19.3 83.2 48H320h32c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zM557.7 239.6l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96H558l-.2-.2-.2-.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zM16 224H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faShippingFast = faTruckFast;
var faUserMagnifyingGlass = {
  prefix: 'far',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM49.3 464c8.9-63.3 63.3-112 129-112h91.4c7.5 0 14.8 .6 21.9 1.8c-2.3-10.9-3.6-22.2-3.6-33.8c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1H224 178.3C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3c-25 0-48.7-5.8-69.8-16H49.3zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
var faStarSharp = {
  prefix: 'far',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M288 0c10.5 0 19.7 6.8 22.9 16.7L361.5 176H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L403.9 320.7l50.9 160.1c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7L288 406.4 158.7 506.9c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l50.9-160.1L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176H214.5L265.1 16.7C268.3 6.8 277.5 0 288 0zm0 103.2L254.9 207.3c-3.2 10-12.4 16.7-22.9 16.7H125.9l88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2L190.3 421.6l82.9-64.5c8.7-6.7 20.8-6.7 29.5 0l82.9 64.5L353.1 319.3c-3-9.6 .2-20 8.1-26.2L450.1 224H344c-10.5 0-19.7-6.8-22.9-16.7L288 103.2z"]
};
var faCommentHeart = {
  prefix: 'far',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCircle1 = {
  prefix: 'far',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c7.4 4.3 12 12.2 12 20.8V336h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H256 192c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V193.4l-20.1 11.5c-11.5 6.6-26.2 2.6-32.7-8.9s-2.6-26.2 8.9-32.7l56-32c7.4-4.2 16.6-4.2 24 .1z"]
};
var faCircleStar = {
  prefix: 'far',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-391c-6.1 0-11.7 3.5-14.3 8.9l-31.3 63.3-69.9 10.2c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4L182.2 280l-11.9 69.6c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2L256 333.6l62.5 32.9c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6L329.8 280l50.6-49.3c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-69.9-10.2-31.3-63.3c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
var faStarCircle = faCircleStar;
var faFish = {
  prefix: 'far',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M180.8 303.7c9.2 10.4 19.4 20.6 30.7 30.1c33.7 28.5 76 50.2 124.5 50.2s90.8-21.8 124.5-50.2c30.3-25.5 52.7-55.7 65.3-77.8c-12.6-22.1-35-52.2-65.3-77.8C426.8 149.7 384.5 128 336 128s-90.8 21.7-124.5 50.2c-11.3 9.5-21.5 19.7-30.7 30.1c-14 15.8-36.7 20.6-56 11.8L70.6 195.3l21.1 36.9c8.4 14.8 8.4 32.9 0 47.6L70.6 316.7l54.3-24.9c19.2-8.8 41.9-4 56 11.8zM4.2 336.1L50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l99.5 45.6c10.5-11.9 22.5-23.8 35.7-35C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-13.2-11.2-25.1-23.1-35.7-35L45.3 381.1c-12.6 5.8-27.6 2.8-36.9-7.5S-2.7 348.2 4.2 336.1zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCloudFog = {
  prefix: 'far',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", "M176 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H172h-1.9c-.3 0-.7-.1-1-.1C137.3 270.4 112 244.2 112 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM248 0C184 0 131.7 50.1 128.2 113.3C90.4 130.1 64 167.9 64 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H464c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C470.5 55 430.9 24 384 24c-18 0-34.9 4.6-49.7 12.6C312.5 14.1 281.9 0 248 0zM0 392c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm64 96c0 13.3 10.7 24 24 24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm208 0c0 13.3 10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H296c-13.3 0-24 10.7-24 24z"]
};
var faFog = faCloudFog;
var faWaffle = {
  prefix: 'far',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 112v32l64 0V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H368v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H272v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H176v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V272H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V112c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128l64 0V176l-64 0v64zm96 0h64V176H272v64zm0 32v64h64V272H272zm-32 0H176v64h64V272z"]
};
var faMusicNote = {
  prefix: 'far',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384 31.1C384 13.9 370.1 0 352.9 0c-2.7 0-5.3 .3-7.9 1L193.9 40.8C183.3 43.6 176 53.1 176 64V366.3c-18.1-9-40.2-14.3-64-14.3C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80V195.4l141.9-36.1C376.6 156.6 384 147 384 136V31.1zM176 432c0 2.6-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C49.4 441.4 48 434.6 48 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zM336 117.3L224 145.8V82.5L336 53v64.3z"]
};
var faMusicAlt = faMusicNote;
var faHexagonExclamation = {
  prefix: 'far',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12H344.3c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCartShoppingFast = {
  prefix: 'far',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M64 24C64 10.7 74.7 0 88 0h45.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H234.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H263.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H88C74.7 48 64 37.3 64 24zM225.6 240H523.2c10.9 0 20.4-7.3 23.2-17.8L584.7 80H195.1l30.5 160zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM24 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faObjectUnion = {
  prefix: 'far',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M160 304c26.5 0 48 21.5 48 48v96c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16H352c-26.5 0-48-21.5-48-48V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16h96zm-48 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v48 48h48 48c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V400 352H112z"]
};
var faUserGraduate = {
  prefix: 'far',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M228.7 .5c-3.1-.6-6.3-.6-9.4 0l-200 40C8.1 42.7 0 52.6 0 64C0 74.3 6.5 83.3 16 86.6v71.8L.3 236.9c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9H48c4.8 0 9.3-2.1 12.4-5.9s4.3-8.6 3.3-13.3L48 158.4V93.3l171.3 34.3c3.1 .6 6.3 .6 9.4 0l200-40C439.9 85.3 448 75.4 448 64s-8.1-21.3-19.3-23.5l-200-40zM49.3 464c5.8-37.6 30-69.2 63.3-85.1l63.6 71.5c5 5.6 10.7 10.1 16.9 13.6H49.3zm349.4 0H254.9c6.2-3.4 11.9-7.9 16.9-13.6l63.6-71.5c33.3 15.8 57.5 47.4 63.3 85.1zM109.6 328.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-71-45.9-131.3-109.6-152.8c-10.9-3.7-22.7 .4-30.3 9L236 418.5c-6.4 7.2-17.6 7.2-23.9 0l-72.1-81.1c-7.6-8.6-19.4-12.7-30.3-9zM96 160c0 70.7 57.3 128 128 128s128-57.3 128-128V135.5l-48 9.6V160c0 44.2-35.8 80-80 80s-80-35.8-80-80V145.1l-48-9.6V160z"]
};
var faStarfighter = {
  prefix: 'far',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M254.4 35C256.9 15 274 0 294.1 0h51.8c20.2 0 37.2 15 39.7 35l25.8 206.4c4.1-.9 8.3-1.4 12.6-1.4h32c30.9 0 56 25.1 56 56v56h56V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.7l-88 29.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-.6c-8.8-1.3-17-4.6-24-9.5c-9.1 6.3-20.1 10-32 10H280c-11.9 0-22.9-3.7-32-10c-7 4.9-15.2 8.2-24 9.5v.6c0 17.7-14.3 32-32 32s-32-14.3-32-32v-5.3L72 445.3V448c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V352h56V296c0-30.9 25.1-56 56-56h32c4.3 0 8.6 .5 12.6 1.4L254.4 35zM368 424V296 281.5L338.8 48H301.2L272 281.5V296 424c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zm48-128V424c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8H424c-4.4 0-8 3.6-8 8zm-200-8H184c-4.4 0-8 3.6-8 8V424c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8zm104-64c17.7 0 32 14.3 32 32v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V256c0-17.7 14.3-32 32-32z"]
};
var faCircleHalfStroke = {
  prefix: 'far',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M464 256c0-114.9-93.1-208-208-208V464c114.9 0 208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faAdjust = faCircleHalfStroke;
var faArrowRightLongToLine = {
  prefix: 'far',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M640 88V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zM505 239c9.4 9.4 9.4 24.6 0 33.9L369 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l95-95L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l406.1 0-95-95c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L505 239z"]
};
var faSquareArrowDown = {
  prefix: 'far',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM207 377l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L200 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 150.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0z"]
};
var faArrowSquareDown = faSquareArrowDown;
var faDiamondHalfStroke = {
  prefix: 'far',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", "M256 464V48c2.6 0 5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17z"]
};
var faClapperboard = {
  prefix: 'far',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M48 208H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208zm352-48H336l80-80h32c8.8 0 16 7.2 16 16l-64 64zM320 80l-80 80H176l80-80h64zM160 80L80 160H48V128L96 80h64zm352 80V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64 24 24V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208 184 160z"]
};
var faSquareChevronLeft = {
  prefix: 'far',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm71-241L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faChevronSquareLeft = faSquareChevronLeft;
var faPhoneIntercom = {
  prefix: 'far',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M112 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h48zm0 400c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H192c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h48zm64-64V96c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16zm80-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zM240 112c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H240z"]
};
var faLinkHorizontal = {
  prefix: 'far',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M143.9 64C64.4 64 0 128.4 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5c13.2 .9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-52.9 42.9-95.9 95.9-95.9H304.1c52.9 0 95.9 42.9 95.9 95.9c0 50.5-39.1 92.3-89.5 95.6l-8.1 .5c-13.2 .9-23.2 12.3-22.4 25.5s12.3 23.2 25.5 22.3l8.1-.5c75.6-5 134.3-67.8 134.3-143.5C448 128.4 383.6 64 304.1 64H143.9zM496.1 448C575.6 448 640 383.6 640 304.1c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 52.9-42.9 95.9-95.9 95.9H335.9c-53 0-95.9-42.9-95.9-95.9c0-50.5 39.1-92.3 89.5-95.7l7.1-.5c13.2-.9 23.2-12.3 22.3-25.6s-12.3-23.2-25.6-22.3l-7.1 .5C250.7 165.6 192 228.4 192 304.1C192 383.6 256.4 448 335.9 448H496.1z"]
};
var faChainHorizontal = faLinkHorizontal;
var faMango = {
  prefix: 'far',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M352 1.4c-2.5-.9-5.2-1.4-8-1.4c-13.3 0-24 10.7-24 24V96c-49.1 0-98.3 18.7-135.8 56.2c-45.8 37.2-67.8 76.7-88.4 113.5c-19.1 34.1-36.9 66-71.2 91.8C15 365 7.4 375.4 3.3 387.9c-11.1 33.5 7.1 69.8 40.6 80.9c0 0 100.1 43.3 244.1 43.3c166.5 0 224-147.4 224-224c0-49.1-18.7-98.3-56.2-135.8c-16.6-16.6-35.6-29.6-55.8-38.8v54.8c7.7 5.2 15 11.1 21.8 17.9C450 214.3 464 251.1 464 288c0 28.5-11.4 74.2-39.8 111.7C397.2 435.3 354.9 464 288 464c-67.3 0-124.3-10.1-164.4-20.2c-20-5-35.6-10-46.1-13.6c-5.2-1.8-9.1-3.3-11.6-4.3c-1.2-.5-2.1-.8-2.6-1.1l-.5-.2 0 0 0 0 0 0-1.8-.8-2-.7C50.6 420.4 46 411.4 48.8 403c1-3.1 2.8-5.6 5.1-7.4c42.4-31.9 64.6-71.8 83-104.8l3.1-5.6c19.4-34.8 37.9-65.9 74.5-95.7l1.9-1.6 1.7-1.7c28.1-28.1 65-42.2 101.8-42.2v24c0 13.3 10.7 24 24 24s24-10.7 24-24V152.2 102.1v-49C385.2 79 414.6 96 448 96h40c13.3 0 24-10.7 24-24c0-39.8-32.2-72-72-72H376 352l0 1.4zM400 288c-8.8 0-16 7.2-16 16c0 44.2-35.8 80-80 80c-8.8 0-16 7.2-16 16s7.2 16 16 16c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16z"]
};
var faMusicNoteSlash = {
  prefix: 'far',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", "M512 31.1C512 13.9 498.1 0 480.9 0c-2.7 0-5.3 .3-7.9 1L321.9 40.8C311.3 43.6 304 53.1 304 64V213L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L352 250.6V195.4l141.9-36.1C504.6 156.6 512 147 512 136V31.1zM304 366.3c-18.1-9-40.2-14.3-64-14.3c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V373.3l-48-37.8v30.8zm0 65.7c0 2.6-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C177.4 441.4 176 434.6 176 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zM464 117.3L352 145.8V82.5L464 53v64.3z"]
};
var faMusicAltSlash = faMusicNoteSlash;
var faCircleRadiation = {
  prefix: 'far',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faRadiationAlt = faCircleRadiation;
var faFaceTongueSweat = {
  prefix: 'far',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", "M496 256c0 81.7-47.1 152.4-115.7 186.4c2.4-8.4 3.7-17.3 3.7-26.4V400.7c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V416c0 9.2 1.3 18 3.7 26.4c-27.1-13.4-50.8-32.6-69.6-55.9c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM352 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V394.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"]
};
var faGlobeStand = {
  prefix: 'far',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3V464H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V430.7c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L332.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm97-159a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm240 0A144 144 0 1 0 64 208a144 144 0 1 0 288 0z"]
};
var faBaseball = {
  prefix: 'far',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M248 463.8c0-6 .3-11.9 .7-17.8c1.1-13.2 12.7-23 25.9-21.9s23 12.7 21.9 25.9c-.3 3.4-.5 6.8-.5 10.2C378.8 444 444 378.8 460.2 296c-3.4 .1-6.8 .3-10.2 .5c-13.2 1.1-24.8-8.7-25.9-21.9s8.7-24.8 21.9-25.9c5.9-.5 11.8-.7 17.8-.7C459.7 139.5 372.5 52.3 264 48.2c0 6-.3 11.9-.7 17.8c-1.1 13.2-12.7 23-25.9 21.9s-23-12.7-21.9-25.9c.3-3.4 .5-6.8 .5-10.2C133.2 68 68 133.2 51.9 216c3.4-.1 6.8-.3 10.2-.5c13.2-1.1 24.8 8.7 25.9 21.9s-8.7 24.8-21.9 25.9c-5.9 .5-11.8 .7-17.8 .7C52.3 372.5 139.5 459.7 248 463.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm118-55.2c36.5-16.8 66-46.3 82.8-82.8c5.5-12 19.8-17.3 31.8-11.8s17.3 19.8 11.8 31.8C222.8 185 185 222.8 138 244.4c-12 5.5-26.3 .2-31.8-11.8s-.2-26.3 11.8-31.8zM394 311.2c-36.5 16.8-66 46.3-82.8 82.8c-5.5 12-19.8 17.3-31.8 11.8s-17.3-19.8-11.8-31.8C289.2 327 327 289.2 374 267.6c12-5.5 26.3-.2 31.8 11.8s.2 26.3-11.8 31.8z"]
};
var faBaseballBall = faBaseball;
var faCircleP = {
  prefix: 'far',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24V288v72c0 13.3 10.7 24 24 24s24-10.7 24-24V312h68c50.8 0 92-41.2 92-92s-41.2-92-92-92H184zm92 136H208V176h68c24.3 0 44 19.7 44 44s-19.7 44-44 44z"]
};
var faAwardSimple = {
  prefix: 'far',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", "M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64.4 492.4L88 390.1c11.7 5.2 24.5 7.9 37.8 7.6l11.1-.3 9.5 5.8c28 17 63.1 17 91.1 0l9.5-5.8 11.1 .3c13.3 .3 26.1-2.4 37.8-7.6l23.6 102.3c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9z"]
};
var faJetFighterUp = {
  prefix: 'far',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M277.2 12.8C273.1 4.9 264.9 0 256 0s-17.1 4.9-21.2 12.8L168.4 138.2c-5.5 10.4-8.4 21.9-8.4 33.7v31.6L48 281.9V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v80 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H160v1.1l-41.9 66.3c-4 6.3-6.1 13.6-6.1 21.1c0 21.8 17.7 39.5 39.5 39.5h209c21.8 0 39.5-17.7 39.5-39.5c0-7.5-2.1-14.8-6.1-21.1L352 385.1V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V360 328 248c0-13.3-10.7-24-24-24s-24 10.7-24 24v33.9L352 203.5V171.9c0-11.7-2.9-23.3-8.4-33.7L277.2 12.8zM457.6 336H352V262.1L457.6 336zM304 360v32c0 4.5 1.3 9 3.7 12.8L345.1 464H280V408c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H166.9l37.4-59.2c2.4-3.8 3.7-8.3 3.7-12.8V360 216.3v-.6V171.9c0-3.9 1-7.8 2.8-11.2L256 75.3l45.2 85.4c1.8 3.5 2.8 7.3 2.8 11.2v43.7 .6V360zM160 336H54.4L160 262.1V336z"]
};
var faDiagramProject = {
  prefix: 'far',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", "M136 80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8h80zM56 32C25.1 32 0 57.1 0 88v80c0 30.9 25.1 56 56 56h80c5.6 0 11.1-.8 16.2-2.4l75.9 101.2c-2.7 6.5-4.1 13.7-4.1 21.2v80c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V344c0-30.9-25.1-56-56-56H280c-5.6 0-11.1 .8-16.2 2.4L187.9 189.2c2.7-6.5 4.1-13.7 4.1-21.2V152H384v16c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56H440c-30.9 0-56 25.1-56 56v16H192V88c0-30.9-25.1-56-56-56H56zM360 336c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H280c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8h80zM440 80h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H440c-4.4 0-8-3.6-8-8V88c0-4.4 3.6-8 8-8z"]
};
var faProjectDiagram = faDiagramProject;
var faPedestal = {
  prefix: 'far',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M352 48H96c-8.8 0-16 7.2-16 16V432H32V64C32 28.7 60.7 0 96 0H352c35.3 0 64 28.7 64 64V432H368V64c0-8.8-7.2-16-16-16zM24 464H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96-352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM304 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faChartPyramid = {
  prefix: 'far',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", "M256 95.8L199.9 192H312.1L256 95.8zM125.2 320H386.8l-46.7-80H171.9l-46.7 80zm-28 48L59.9 432l392.3 0-37.3-64H97.2zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0L493.6 407.8c18.7 32-4.4 72.2-41.5 72.2H59.9c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z"]
};
var faSidebar = {
  prefix: 'far',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M224 80V432H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H224zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM64 312c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24z"]
};
var faSnowmanHead = {
  prefix: 'far',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M336 144v48H112V144H336zM64 64V192H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48.7C28 272.3 16 310.8 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-41.2-12-79.7-32.7-112H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H384V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64zm0 288c0-43.6 17.4-83.1 45.7-112H112 336h2.3c28.3 28.9 45.7 68.4 45.7 112c0 43.1-17 82.1-44.7 110.9c-.1 .1-.3 .2-.8 .4c-.9 .4-2.5 .7-4.8 .7H114.2c-2.2 0-3.8-.4-4.8-.7c-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352zm88-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7c0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z"]
};
var faFrostyHead = faSnowmanHead;
var faCopy = {
  prefix: 'far',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"]
};
var faBurgerGlass = {
  prefix: 'far',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512H276c5.6 0 11-.6 16.2-1.8c-13.1-12.8-23.3-28.5-29.4-46.2H108c-12.5 0-22.8-9.5-23.9-21.9L64 208H311.8c15.5-12.4 35-24.1 59.2-32.7L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8H24zM59.8 160L50.2 48H333.8l-9.7 112H59.8zm390.1 80.2c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.3 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8H366.8c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88H552c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8H584c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40H376c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z"]
};
var faVolumeXmark = {
  prefix: 'far',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M159.9 201.9L272 102.3V409.7L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H56c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h88c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V61.8C320 45.3 306.7 32 290.2 32zM425 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55z"]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faHandSparkles = {
  prefix: 'far',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M262.4 36C272.8 14.7 294.7 0 320 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64v2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2-29.3 8.4c8.7-16.8 14-35.7 15-55.7c0-.6 .1-1.3 .2-1.9V160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 .1V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V152l0-.1V96c0-8.8-7.2-16-16-16s-16 7.1-16 16l0 .1V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V96l0-.1V64c0-8.8-7.2-16-16-16s-16 7.2-16 16V96l0 .1V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V95.9c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16V319.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-43.7-43.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9H360h4.9c.6-.1 1.3-.1 1.9-.2c30.9-1.5 59.1-13.4 81.2-32.1l0 .3c0 17.6 10.8 33.3 27 39.6c-28.5 22.8-63.9 37.3-102.5 39.9c-1.4 .3-3 .4-4.5 .4h-8-8.5c-67.9 0-133-27-181-75L82.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7V96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zm50.3 290.6L320 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L320 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L288 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L288 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm257.5 33.1L584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7zM104 88l40 11.4v25.1L104 136 90.2 184.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 136 7.7 122.2C3.1 120.9 0 116.7 0 112s3.1-8.9 7.7-10.2L56 88 69.8 39.7C71.1 35.1 75.3 32 80 32s8.9 3.1 10.2 7.7L104 88z"]
};
var faBarsFilter = {
  prefix: 'far',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zM288 408c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24z"]
};
var faPaintbrushPencil = {
  prefix: 'far',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M181.3 19.3c-25-25-65.5-25-90.5 0L51.3 58.7c-3.1 3.1-5.9 6.5-8.2 10c-16.4 24.8-13.7 58.6 8.2 80.5l88.8 88.8c13.9-4 28.6-6.1 43.9-6.1l1.5 0 8.2-8.2L161 191 223 129l32.8 32.8 33.9-33.9L181.3 19.3zM414.2 320.1l37.3 37.3c.6 .6 1.2 1.2 1.7 1.8c3.9 4.4 6.7 9.6 8.4 15.2l6.9 23.4 16.1 54.8-54.8-16.1-23.4-6.9c-6.4-1.9-12.3-5.4-17-10.1l-37.3-37.3-8.1 8.1 0 1.7c0 15.2-2.1 29.9-6.1 43.9l17.6 17.6c1.3 1.3 2.6 2.6 4 3.8c9.6 8.5 21 14.8 33.4 18.4l78.1 23L513.2 511c8.4 2.5 17.5 .2 23.7-6.1s8.5-15.3 6.1-23.7L530.6 439l-23-78.1c-4.2-14.1-11.8-27-22.2-37.4l-37.3-37.3-33.9 33.9zM519 57c8.3 8.3 8.3 21.8 0 30.1L336.3 269.8l-30.1-30.1L489 57c8.3-8.3 21.8-8.3 30.1 0zM184 320c9.4 0 18.3 1.8 26.5 5L251 365.5c3.3 8.2 5 17.2 5 26.5c0 39.8-32.2 72-72 72H98.4l.7-.9c11.6-16.9 17.1-38.6 13.8-60c-.5-3.6-.8-7.3-.8-11.1c0-39.8 32.2-72 72-72zM455 23L204.3 273.7c-6.6-1.1-13.4-1.7-20.3-1.7c-66.3 0-120 53.7-120 120c0 6.2 .5 12.4 1.4 18.4C68.1 428.2 56.1 448 38 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H184c66.3 0 120-53.7 120-120c0-6.9-.6-13.7-1.7-20.3L553 121c27-27 27-70.9 0-97.9s-70.9-27-97.9 0z"]
};
var faPartyBell = {
  prefix: 'far',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M48 224c0-97.2 78.8-176 176-176c27.8 0 54.1 6.5 77.5 17.9c.7 .4 1.2 .8 1.7 1.6c.5 .9 .9 2.1 .9 3.2c0 1.7-.7 3.4-1.9 4.6L75.3 302.1c-1.2 1.2-2.9 1.9-4.6 1.9c-1.1 0-2.3-.3-3.2-.9c-.7-.4-1.2-.9-1.6-1.7C54.5 278.1 48 251.8 48 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zM480 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM359 167c-9.4 9.4-9.4 24.6 0 33.9l8.2 8.3c24.4 24.4 56.4 39.8 90.7 43.6l27.4 3c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5l-27.4-3c-23.5-2.6-45.4-13.1-62.1-29.8L393 167c-9.4-9.4-24.6-9.4-33.9 0zM201 359c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8.3 8.3c16.7 16.7 27.2 38.6 29.8 62.1l3 27.4c1.5 13.2 13.3 22.7 26.5 21.2s22.7-13.3 21.2-26.5l-3-27.4c-3.8-34.3-19.2-66.3-43.6-90.7L201 359zM503.5 506.3c10.1-8.6 11.4-23.7 2.8-33.8l-8.5-10c-4.9-5.8-7.5-13.2-7.3-20.7c1.1-42.5-31.7-78.3-74.2-80.8l-30-1.8c-16.6-1-29.4-15-29-31.6c.5-19.4-6.1-38.2-18.6-53l-8.5-10c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8l8.5 10c4.9 5.8 7.5 13.2 7.3 20.7c-1.1 42.5 31.7 78.3 74.2 80.8l30 1.8c16.6 1 29.4 15 29 31.6c-.5 19.4 6.1 38.2 18.6 53l8.5 10c8.6 10.1 23.7 11.4 33.8 2.8z"]
};
var faUserVneckHair = {
  prefix: 'far',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM48.3 464H399.7c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9C81.2 377.8 51.3 417.3 48.3 464zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z"]
};
var faJackOLantern = {
  prefix: 'far',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", "M275.5 10.4L231.6 110.6c-4 2.1-7.9 4.5-11.6 7.1C200 104.1 176.9 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6c45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-24.9 0-48 8.1-68 21.6c-1.3-.9-2.7-1.8-4-2.6V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4zM81.2 187.6C101.3 158.7 126.7 144 152 144c18 0 35.8 7.4 51.9 21.9c9.1 8.3 23 8.3 32.2 0C252.2 151.4 270 144 288 144s35.8 7.4 51.9 21.9c9.1 8.3 23 8.3 32.2 0C388.2 151.4 406 144 424 144c25.3 0 50.7 14.7 70.8 43.6c20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4zm140.1 27.5c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5h64c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zM368 208c-5.4 0-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5h64c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48c-3-4.5-8-7.1-13.3-7.1zM470.1 312c1.4-5-.3-10.2-4-13.8c-5.8-5.8-15.1-6.6-22.2-2.4C420.8 309.4 365.6 336 288 336v16c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V332.5c-52.4-7.7-89.9-26.2-107.9-36.8c-7.1-4.2-16.4-3.4-22.2 2.4c-3.7 3.7-5.4 8.8-4 13.8c4.2 14.7 17.2 46.8 54.1 71.4c.3-8.6 7.3-15.4 16-15.4h16c8.8 0 16 7.2 16 16v21.5c21.8 6.5 48.2 10.5 80 10.5s58.2-4 80-10.5V384c0-8.8 7.2-16 16-16h16c8.6 0 15.7 6.9 16 15.4c36.9-24.7 49.9-56.7 54.1-71.4z"]
};
var faGrip = {
  prefix: 'far',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", "M408 376l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM408 184l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM200 376l48 0 0-48-48 0 0 48zm48 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-232l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM40 376l48 0 0-48-48 0 0 48zm48 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-232l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48z"]
};
var faGripHorizontal = faGrip;
var faShareFromSquare = {
  prefix: 'far',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
};
var faShareSquare = faShareFromSquare;
var faKeynote = {
  prefix: 'far',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", "M198.4 72H184c-22.1 0-40 17.9-40 40v48H422.3c16.1 0 31 8 39.9 21.4l41.7 62.5c5.3 7.9 8.1 17.1 8.1 26.6V320c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V270.5c0-9.5 2.8-18.7 8.1-26.6l41.7-62.5C58.7 168 73.6 160 89.7 160H96V112c0-48.6 39.4-88 88-88h14.4C206.7 9.7 222.2 0 240 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H240c-17.8 0-33.3-9.7-41.6-24zM48 304H464V270.5L422.3 208 89.7 208 48 270.5V304zm80 184c0-13.3 10.7-24 24-24h80V384h48v80h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H256 152c-13.3 0-24-10.7-24-24z"]
};
var faChildCombatant = {
  prefix: 'far',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M160 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM176 208c5.5 0 10.9 .9 16 2.6V336H160V210.6c5.1-1.7 10.5-2.6 16-2.6zM160 488V384h32V488c0 13.3 10.7 24 24 24s24-10.7 24-24V264.8l27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C241.8 177.5 210.1 160 176 160s-65.8 17.5-83.9 46.3L43.7 283.2c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44V488c0 13.3 10.7 24 24 24s24-10.7 24-24zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32H384c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32h32v48 64c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16H432 416zm16 336H416 400V240h32v96z"]
};
var faChildRifle = faChildCombatant;
var faGun = {
  prefix: 'far',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H40C17.9 64 0 81.9 0 104v96c0 22.1 17.9 40 40 40h2c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480H176c14.7 0 27.5-10 31-24.2L233 352h88.5c23.7 0 44.8-14.9 52.7-37.2L400.9 240h32.5c10.6 0 20.8-4.2 28.3-11.7L481.9 208H536c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40h-8V56zM245 304l16-64h89l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3H245zm-33.5-64l-48 192h-79l35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4h96.1zM267 192H219 68.8 48V112H504h24v48H478.6c-10.6 0-20.8 4.2-28.3 11.7L430.1 192H267z"]
};
var faSquarePhone = {
  prefix: 'far',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm154.7 32.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"]
};
var faPhoneSquare = faSquarePhone;
var faHatBeach = {
  prefix: 'far',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M197.9 201.4C225.6 215.1 270 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-22 15.7-40.4 36.6-44.4C397.1 131.1 360.8 112 320 112c-57.2 0-105.7 37.6-122.1 89.4zM320 64c70.2 0 130.8 41.1 159 100.5c6.1-2.9 12.8-4.5 19.7-4.5c25 0 45.3 20.3 45.3 45.3c0 12-4.8 23.5-13.3 32L528 240l2.7 2.7c.8 .8 1.6 1.6 2.3 2.5l77.3 30.9c17.9 7.2 29.7 24.6 29.7 43.9c0 17.6-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7l16.5-17.4L25.1 369.8C8.9 354.5 0 337.6 0 320c0-19.3 11.8-36.7 29.7-43.9l8.6 21.6-8.6-21.6 114.6-45.8C149.3 137.6 226.1 64 320 64zM429.3 320c-16.7 0-31.3-9-39.1-22.5c-21.2 4.1-45 6.5-70.2 6.5c-62.4 0-116.5-14.3-142.9-35.2c-.3 .1-.5 .2-.8 .3L48 320.5c.2 1.5 1.5 6.4 10.1 14.5c10.3 9.8 27.8 20.8 53.4 31C162.5 386.3 236.2 400 320 400s157.5-13.7 208.4-34.1c25.6-10.2 43.1-21.2 53.4-31c8.6-8.1 9.9-13 10.1-14.5l-54.7-21.9c-8 12.9-22.2 21.4-38.5 21.4c-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3zM464 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPlus = {
  prefix: 'far',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"]
};
var faAdd = faPlus;
var faExpand = {
  prefix: 'far',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M136 32c13.3 0 24 10.7 24 24s-10.7 24-24 24H48v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 42.7 10.7 32 24 32H136zM0 344c0-13.3 10.7-24 24-24s24 10.7 24 24v88h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V344zM424 32c13.3 0 24 10.7 24 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24H424zM400 344c0-13.3 10.7-24 24-24s24 10.7 24 24V456c0 13.3-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h88V344z"]
};
var faComputer = {
  prefix: 'far',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", "M384 80c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H281.3 264 184 166.7 64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 384h86.7l-16 48H88c-13.3 0-24 10.7-24 24s10.7 24 24 24h30.7H152 296h33.3H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H313.3l-16-48H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64zm121.3 48l16-48h45.4l16 48H185.3zM528 80h64v32H528V80zm0 80h64v32H528V160zm64 80V432H528V240h64zM480 80V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFort = {
  prefix: 'far',
  iconName: 'fort',
  icon: [640, 512, [], "e486", "M48 112v48c0 8.8 7.2 16 16 16H80h80c8.8 0 16-7.2 16-16V112H136 88 48zm176 48c0 5.5-.7 10.9-2 16H418c-1.3-5.1-2-10.5-2-16V112v-8V64 24c0-13.3 10.7-24 24-24c7.1 0 13.4 3.1 17.8 7.9c3.8 4.3 6.2 9.9 6.2 16.1V64h40V24c0-6.2 2.3-11.8 6.2-16.1C514.6 3.1 520.9 0 528 0s13.4 3.1 17.8 7.9c3.8 4.3 6.2 9.9 6.2 16.1V64h40V24c0-6.2 2.3-11.8 6.2-16.1C602.6 3.1 608.9 0 616 0c13.3 0 24 10.7 24 24V64v40 8 48c0 23.7-12.9 44.4-32 55.4V224 448c0 35.3-28.7 64-64 64H384 256 96c-35.3 0-64-28.7-64-64V224v-8.6C12.9 204.4 0 183.7 0 160V112v-8V64 24C0 10.7 10.7 0 24 0c7.1 0 13.4 3.1 17.8 7.9C45.7 12.2 48 17.8 48 24V64H88V24c0-6.2 2.3-11.8 6.2-16.1C98.6 3.1 104.9 0 112 0s13.4 3.1 17.8 7.9c3.9 4.3 6.2 9.9 6.2 16.1V64h40V24c0-6.2 2.3-11.8 6.2-16.1C186.6 3.1 192.9 0 200 0c13.3 0 24 10.7 24 24V64v40 8 48zM384 464h64V224H192V464h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v80zm112 0h48c8.8 0 16-7.2 16-16V224H496V464zM96 464h48V224H80V448c0 8.8 7.2 16 16 16zM560 176h16c8.8 0 16-7.2 16-16V112H552 504 464v48c0 8.8 7.2 16 16 16h80z"]
};
var faCloudCheck = {
  prefix: 'far',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"]
};
var faXmark = {
  prefix: 'far',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faFaceSmirking = {
  prefix: 'far',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm382.3 88.9l-1.9 4.8c-12.2 30.4-41.6 50.3-74.3 50.3H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H306.1c13.1 0 24.9-8 29.7-20.1l1.9-4.8c4.9-12.3 18.9-18.3 31.2-13.4s18.3 18.9 13.4 31.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faArrowsUpDownLeftRight = {
  prefix: 'far',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", "M273 7c-9.4-9.4-24.6-9.4-33.9 0L167 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V232H81.9l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31H232V430.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V280H430.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H280V81.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7z"]
};
var faArrows = faArrowsUpDownLeftRight;
var faChalkboardUser = {
  prefix: 'far',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M576 48H224c-8.8 0-16 7.2-16 16v41.3c-14.8-6-31-9.3-48-9.3V64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H544 520 392 368 336.8c-8.3-18-19.8-34.2-33.7-48H368V328c0-30.9 25.1-56 56-56h64c30.9 0 56 25.1 56 56v40h32c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zM496 368V328c0-4.4-3.6-8-8-8H424c-4.4 0-8 3.6-8 8v40h80zM208 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM50.7 464H269.3c-9.5-36.8-42.9-64-82.6-64H133.3c-39.8 0-73.2 27.2-82.6 64zM0 485.3C0 411.7 59.7 352 133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"]
};
var faChalkboardTeacher = faChalkboardUser;
var faRhombus = {
  prefix: 'far',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M224 52.3L50.5 256 224 459.7 397.5 256 224 52.3zM9.6 230.1l184-216C201.2 5.1 212.3 0 224 0s22.8 5.1 30.4 14.1l184 216c12.7 14.9 12.7 36.9 0 51.9l-184 216c-7.6 8.9-18.7 14.1-30.4 14.1s-22.8-5.1-30.4-14.1l-184-216C-3.2 267-3.2 245 9.6 230.1z"]
};
var faClawMarks = {
  prefix: 'far',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M39 7C48.4-2.3 63.6-2.3 73 7L176.6 110.6c15 15 23.4 35.4 23.4 56.6V184h16.8c21.2 0 41.6 8.4 56.6 23.4l95.2 95.2c15 15 23.4 35.4 23.4 56.6V376h16.8c21.2 0 41.6 8.4 56.6 23.4L537 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71.6-71.6c-6-6-14.1-9.4-22.6-9.4H368c-13.3 0-24-10.7-24-24V359.2c0-8.5-3.4-16.6-9.4-22.6l-95.2-95.2c-6-6-14.1-9.4-22.6-9.4H176c-13.3 0-24-10.7-24-24V167.2c0-8.5-3.4-16.6-9.4-22.6L39 41C29.7 31.6 29.7 16.4 39 7zm0 224c9.4-9.4 24.6-9.4 33.9 0L146.9 305c13.5 13.5 21.1 31.8 21.1 50.9V376h20.1c19.1 0 37.4 7.6 50.9 21.1L313 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L205.1 431c-4.5-4.5-10.6-7-17-7H144c-13.3 0-24-10.7-24-24V355.9c0-6.4-2.5-12.5-7-17L39 265c-9.4-9.4-9.4-24.6 0-33.9zM297 7l9.9 9.9C320.4 30.5 328 48.8 328 67.9V88h20.1c19.1 0 37.4 7.6 50.9 21.1L434.9 145c13.5 13.5 21.1 31.8 21.1 50.9V216h20.1c19.1 0 37.4 7.6 50.9 21.1L537 247c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.9-9.9c-4.5-4.5-10.6-7-17-7H432c-13.3 0-24-10.7-24-24V195.9c0-6.4-2.5-12.5-7-17L365.1 143c-4.5-4.5-10.6-7-17-7H304c-13.3 0-24-10.7-24-24V67.9c0-6.4-2.5-12.5-7-17L263 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faPesoSign = {
  prefix: 'far',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", "M93.6 32C68.4 32 48 52.4 48 77.6V128H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48v48H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H48v72V456c0 13.3 10.7 24 24 24s24-10.7 24-24V368h88c67 0 124.9-39.2 151.8-96H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-9.7c1.1-7.8 1.7-15.9 1.7-24s-.6-16.2-1.7-24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H335.8C308.9 71.2 251 32 184 32H93.6zM280 128H96V80h88c39.3 0 74.1 18.9 96 48zM96 176H301.6c1.6 7.8 2.4 15.8 2.4 24s-.8 16.2-2.4 24H96V176zm184 96c-21.9 29.1-56.7 48-96 48H96V272H280z"]
};
var faFaceSmileTongue = {
  prefix: 'far',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M419.5 453c-44.3 36.9-101.3 59-163.5 59C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 27.2-4.2 53.4-12.1 77.9c9.1 23.9 7.8 51.5-6 75.4c-16 27.6-44.7 43.2-74.4 43.6zm-56.2-18.8l-44.2-27.4c-19.5 8-40.8 12.4-63.1 12.4c-70.4 0-130.1-43.8-157.5-105.5c-5.4-12.1 .1-26.3 12.2-31.7s26.3 .1 31.7 12.2c20.4 46.1 64.1 76.9 113.6 76.9c56.5 0 105.6-40.3 120.8-97.4c1.9-7.3 7.2-13.2 14.2-16.1s14.9-2.2 21.4 1.7l49 29.5c1.7-10.7 2.6-21.7 2.6-33c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c39.3 0 76-10.9 107.3-29.8zM217.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zM398.5 399.6c18.8 11 42.9 4.7 53.8-14.2c11-19.1 4.5-43.6-14.6-54.6l-.4-.2 0 0-24.7-14.9c-11.2 24.5-27.5 46.1-47.6 63.2l33.5 20.8zM377.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"]
};
var faCartCircleXmark = {
  prefix: 'far',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c9.2-18 21.4-34.2 36-48H161.6L131.1 80H520.6L489.1 192.1c2.3-.1 4.6-.1 6.9-.1c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faBuildingShield = {
  prefix: 'far',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M64 48H320c8.8 0 16 7.2 16 16V226.2L384 207V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c10.9 0 21.2-2.7 30.2-7.6c-15.4-12.4-28.5-26-39.5-40.4H240V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zM296 232c0-8.8-7.2-16-16-16H232c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h24c.1-22.8 14-43.4 35.2-51.8l4.8-1.9V232zM88 104v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V104c0-8.8-7.2-16-16-16H232zM88 232v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V232c0-8.8-7.2-16-16-16H104c-8.8 0-16 7.2-16 16zm335.1-6.3l-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM527.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L527.4 312z"]
};
var faCirclePhoneFlip = {
  prefix: 'far',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm69.3 128.7l44 12C378 143.1 384 151 384 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8L231.7 312c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48c3.9-9.3 14-14.2 23.7-11.6z"]
};
var faPhoneCircleAlt = faCirclePhoneFlip;
var faBaby = {
  prefix: 'far',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M224 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM107.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l18.7 18.7c12.8 12.8 27.5 23.4 43.4 31.5c8.1 4.1 13.1 12.4 13.1 21.4v13 0H288l0-13c0-9 5.1-17.3 13.1-21.4c15.9-8.1 30.6-18.6 43.4-31.5l18.7-18.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-18.7 18.7c-26 26-61.2 40.6-97.9 40.6s-72-14.6-97.9-40.6l-18.7-18.7zM304.6 341.5l-24.1 21.1L304 392.9c6.8 8.8 6.7 21.1-.2 29.7L291.5 438c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l32-40c4.6-5.8 4.7-14 .1-19.8l-44.1-56.7zm-137 21.1l-24.1-21.1L99.4 398.2c-4.5 5.8-4.5 14 .1 19.8l32 40c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-12.3-15.4c-6.9-8.7-7-21-.2-29.7l23.6-30.3zM50.7 146.7c25-25 65.5-25 90.5 0L160 165.5c17 17 40 26.5 64 26.5s47-9.5 64-26.5l18.7-18.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L378.5 256c-12.9 12.9-27.2 23.9-42.5 33.1l0 14.6 50.5 65c18.2 23.4 18 56.2-.5 79.3l-32 40c-22.1 27.6-62.4 32.1-90 10s-32.1-62.4-10-90l.5-.6-5.8-7.4H199.3l-5.8 7.4 .5 .6c22.1 27.6 17.6 67.9-10 90s-67.9 17.6-90-10L62 448c-18.5-23.1-18.7-55.9-.5-79.3l50.5-65 0-14.6c-15.4-9.2-29.7-20.3-42.5-33.1L50.7 237.3c-25-25-25-65.5 0-90.5z"]
};
var faUsersLine = {
  prefix: 'far',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", "M147.2 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 192c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h98.7c18.2-31.4 49.3-54.4 86-61.6C238.1 206 216.7 192 192 192H96zm480 96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-24.5 0-45.7 13.7-56.5 33.9c38 6.6 70.3 29.9 89 62.1H576zm-134.8 0c-14.6-16.3-34.6-27.5-57.1-30.9c-.6-.1-1.3-.2-1.9-.3c-4.1-.5-8.3-.8-12.5-.8h-48-48c-4.2 0-8.4 .3-12.5 .8c-1.7 .2-3.4 .5-5.1 .8c-21.3 3.9-40.1 14.9-53.9 30.4c-15.2 17-24.4 39.4-24.4 64c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-24.6-9.2-47-24.4-64zm58-128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM321.6 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-48 96l0 0c13.4 10 30 16 48 16s34.6-6 48-16l0 0c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64zM414.9 336H228.3c6.6-18.6 24.4-32 45.3-32h96c20.9 0 38.7 13.4 45.3 32zM0 456c0 13.3 10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"]
};
var faQuoteLeft = {
  prefix: 'far',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 216C0 149.7 53.7 96 120 96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-39.8 0-72 32.2-72 72v10c5.1-1.3 10.5-2 16-2h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm48 72v32 32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm336-16H320c-8.8 0-16 7.2-16 16v32 32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V288c0-8.8-7.2-16-16-16zM256 320V288 216c0-66.3 53.7-120 120-120h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-39.8 0-72 32.2-72 72v10c5.1-1.3 10.5-2 16-2h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320z"]
};
var faQuoteLeftAlt = faQuoteLeft;
var faTractor = {
  prefix: 'far',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", "M152 48H266.3c3.3 0 6.2 2 7.4 5l42.8 107H192 160 144V56c0-4.4 3.6-8 8-8zM96 56V192.6c-11.2-3.9-24.2-1.4-33.1 7.6L40.2 222.9c-12.5 12.5-12.5 32.8 0 45.3l5.8 5.8c-2.2 4.6-4.1 9.3-5.8 14.1H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h8.2c1.7 4.8 3.7 9.5 5.8 14.1l-5.8 5.8c-12.5 12.5-12.5 32.8 0 45.3l22.6 22.6c12.5 12.5 32.8 12.5 45.3 0l5.8-5.8c4.6 2.2 9.3 4.1 14.1 5.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-8.2c4.8-1.7 9.5-3.7 14.1-5.8l5.8 5.8c12.5 12.5 32.8 12.5 45.3 0l22.6-22.6c12.5-12.5 12.5-32.8 0-45.3l-5.8-5.8c2.2-4.6 4.1-9.3 5.8-14.1H320h94.8c6.5-18.5 17.5-34.9 31.6-48H352V320c0-17.7-14.3-32-32-32h-8.2c-1.7-4.8-3.7-9.5-5.8-14.1l5.8-5.8c12.5-12.5 12.5-32.8 0-45.3L296.9 208h54.6c.4 0 .7 0 1.1 0H504h80c4.4 0 8 3.6 8 8v32.7c0 7.4-3.4 14.3-9.2 18.9l-46.7 36.7c20.1 1.3 38.9 7.7 55.1 17.7l21.3-16.7c17.4-13.6 27.5-34.5 27.5-56.6V216c0-30.9-25.1-56-56-56H528V118.2c0-16.1 3.8-32.1 11-46.5l2.5-5c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.5 5c-10.6 21.1-16 44.4-16 68V160H368.2L318.3 35.2C309.8 13.9 289.2 0 266.3 0H152C121.1 0 96 25.1 96 56zm80 200a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM528 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128a88 88 0 1 0 0-176 88 88 0 1 0 0 176z"]
};
var faKeySkeleton = {
  prefix: 'far',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 48a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 31.1 9.9 59.9 26.6 83.4L7 407c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L88 393.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 98.6-98.6C244.1 278.1 272.9 288 304 288z"]
};
var faTrashArrowUp = {
  prefix: 'far',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80h13.7H416h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H412.4L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80.1 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8H324.6c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zm154.5 65.9l64 64c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L244 256.3V384c0 11-9 20-20 20s-20-9-20-20V256.3l-29.9 29.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l64-64c7.8-7.8 20.5-7.8 28.3 0z"]
};
var faTrashRestore = faTrashArrowUp;
var faArrowDownUpLock = {
  prefix: 'far',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", "M145 505l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V280H416v-8c0-14.1 2.6-27.6 7.4-40H344V81.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L337 7c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V232H152 104 24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V430.1L49 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0zm7-313V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V192h48zM296 320V456c0 13.3 10.7 24 24 24s24-10.7 24-24V320H296zm232-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowDownToBracket = {
  prefix: 'far',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87V24c0-13.3 10.7-24 24-24s24 10.7 24 24V270.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344v80c0 22.1 17.9 40 40 40H360c22.1 0 40-17.9 40-40V344c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88V344c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faLinesLeaning = {
  prefix: 'far',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5l-144 400c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5l144-400zm78.1-31.7c-13-2.6-25.6 5.8-28.2 18.8l-80 400c-2.6 13 5.8 25.6 18.8 28.2s25.6-5.8 28.2-18.8l80-400c2.6-13-5.8-25.6-18.8-28.2zM360 32c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24z"]
};
var faSquareQ = {
  prefix: 'far',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM144 256c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
var faRulerCombined = {
  prefix: 'far',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M192 288V272 224l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V128l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 272 0 112c0 .6 0 1.2 .1 1.7c.8 8 7.7 14.3 15.9 14.3H176l272 0c8.8 0 16-7.2 16-16l0-112c0-8.8-7.2-16-16-16H416v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H320v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H240 224v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm96-16H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64l-272 0H64C30.9 512 3.6 486.8 .3 454.5c-.2-2.2-.3-4.3-.3-6.5V336 64C0 28.7 28.7 0 64 0H176c35.3 0 64 28.7 64 64l0 160 0 48h48z"]
};
var faSymbols = {
  prefix: 'far',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 80C10.7 80 0 90.7 0 104s10.7 24 24 24H88v72c0 13.3 10.7 24 24 24s24-10.7 24-24V128h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM464 53.3v76.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V43.5c0-25.2-23.1-44.2-47.8-39.2l-128 25.6C317.5 33.6 304 50 304 69.1v92.4c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V75.7L464 53.3zM505 295c-9.4-9.4-24.6-9.4-33.9 0L295 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 329c9.4-9.4 9.4-24.6 0-33.9zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM84 256c-37.7 0-68 30.8-68 68.2c0 19.3 8.2 37.9 22.6 50.8l4.5 4-17 13C9.6 404.8 0 424.4 0 445.1v1.4C0 482.7 29.3 512 65.5 512c14.9 0 29.3-5.1 40.9-14.3l36.3-29 41.3 37.2c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-35.5-31.9L215 410.7c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-40.6 32.5L118 381.9l7.9-6c16.5-12.7 26.1-32.2 26.1-53c0-36.9-29.9-66.9-66.9-66.9H84zm12.6 81.9L81.8 349.3l-11-9.9c-4.2-3.8-6.7-9.4-6.7-15.2C64 313 73.1 304 84 304h1.1c10.4 0 18.9 8.5 18.9 18.9c0 5.9-2.7 11.4-7.4 15zM55.4 430.1l24-18.4 27.1 24.4L76.4 460.2c-3.1 2.5-6.9 3.8-10.9 3.8c-9.6 0-17.5-7.8-17.5-17.5v-1.4c0-5.9 2.7-11.4 7.4-15z"]
};
var faIconsAlt = faSymbols;
var faCopyright = {
  prefix: 'far',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"]
};
var faFlaskGear = {
  prefix: 'far',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", "M176 48V196.8c0 20.7-5.8 41-16.6 58.7L100 352H325.8c.1 .1 .2 .1 .2 .2c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 6.7 1.5 13.5 4.2 19.7c-9 4.3-19 6.6-29.7 6.6H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5V48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h40H288h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V196.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3c-5.2 9.1-9.6 18.4-13.1 27.9l-20.7-33.6c-10.9-17.7-16.6-38-16.6-58.7V48H176zM447.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8v17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7V218.2c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faHighlighterLine = {
  prefix: 'far',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M169.9 330.6l-38.1 38.1 51.5 51.5 38.1-38.1c9-9 21.2-14.1 33.9-14.1l48 0 16.2-22.5-113-113L184 248.6v48c0 12.7-5.1 24.9-14.1 33.9zm178-24.6L502.8 90.2c.8-1.1 1.2-2.4 1.2-3.7c0-1.7-.7-3.3-1.9-4.5L470 49.9c-1.2-1.2-2.8-1.9-4.5-1.9c-1.3 0-2.6 .4-3.7 1.2L246 204.1 347.9 306zM303.4 416h-48l-43.7 43.7c-10.7 10.7-26 14.1-39.5 10.1l-32.8 32.8c-6 6-14.1 9.4-22.6 9.4H32c-17.7 0-32-14.3-32-32v-4.7c0-8.5 3.4-16.6 9.4-22.6l72.8-72.8c-4-13.6-.6-28.8 10.1-39.5L136 296.6v-48c0-15.5 7.4-30 20-39L433.8 10.2C443 3.6 454.1 0 465.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4c0 11.4-3.6 22.5-10.2 31.7L342.4 396c-9 12.6-23.5 20-39 20zm-190.7 1.3L65.9 464h44.1l24.7-24.7-22.1-22.1zM248 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBracketSquare = {
  prefix: 'far',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 88C0 57.1 25.1 32 56 32h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8V424c0 4.4 3.6 8 8 8h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V88z"]
};
var faBracket = faBracketSquare;
var faBracketLeft = faBracketSquare;
var faIslandTropical = {
  prefix: 'far',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3H78.2c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2c2.2 8.6-5 15.8-13.8 15.8H451.3c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3H319.4c3.5 15.4 7.2 35.7 9.5 59.7c4.4 45.4 3.7 104.4-13.9 167.1c57.7 12.4 101 63.7 101 125.1c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32c0-70.7 57.3-128 128-128h24.9c26-56.3 38-110.2 43.3-151.1c1.3-9.9 2.2-19 2.8-27.1l-71.8 71.8c-6.2 6.2-16.5 6.2-21-1.4c-18.5-31.6-22.5-90.9 32.3-145.7c1.4-1.4 2.8-2.7 4.1-4c-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24zM237.3 352h28.5c18.5-59.2 19.5-115.9 15.3-159.7c-.6-6.1-1.3-12-2-17.5c-.7 9.6-1.7 20.5-3.3 32.4c-5.2 39.6-16 90.6-38.5 144.9zM288 400H160c-38.7 0-71 27.5-78.4 64H366.4c-7.4-36.5-39.7-64-78.4-64z"]
};
var faIslandTreePalm = faIslandTropical;
var faArrowRightFromLine = {
  prefix: 'far',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88zM440.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L363.5 232H280l-128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0h83.5l-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"]
};
var faArrowFromLeft = faArrowRightFromLine;
var faH2 = {
  prefix: 'far',
  iconName: 'h2',
  icon: [640, 512, [], "f314", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zm397.3 40.8C457.9 118 474 112 490.7 112h9.2c42.1 0 76.2 34.1 76.2 76.2c0 21.3-8.9 41.5-24.5 56L375.7 406.4c-7.3 6.7-9.7 17.2-6.1 26.4s12.5 15.3 22.4 15.3H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H453.4L584.1 279.4c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64h-9.2c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l29.7-25.4z"]
};
var faEquals = {
  prefix: 'far',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M40 144c-13.3 0-24 10.7-24 24s10.7 24 24 24H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H40z"]
};
var faCakeSlice = {
  prefix: 'far',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M464 304v.2 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H48V304H464zM48 416V384H464v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM296 32c-7.2 0-14.2 2.4-19.8 6.9l-264 208C4.5 252.9 0 262.2 0 272V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.6 64-64v-.2-.2-.2-.2-.2V415v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V413v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V411v-.2-.2-.2-.2V410v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V406v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V401v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V398v-.2-.2-.2-.2-.2-.2-.2-.2V396v-.2-.2-.2-.2-.2-.2-.2-.2V394v-.2-.2-.2V393v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V390v-.2-.2-.2V389v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V379v-.3-.3-.3V378v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V374v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V371v-.3-.3-.3-.3-.3-.3V369v-.3-.3-.3-.3-.3-.3V367v-.3-.3-.3-.3-.3-.3V365v-.3-.3-.3-.3-.3-.3V363v-.3-.3-.3-.3-.3-.3-.3-.3-.3V360v-.3-.3-.3-.3-.3-.3-.3-.3-.3V357v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V353v-.3-.3V352v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V346v-.3-.3V345v-.3-.3V344v-.3-.3V343v-.3-.3V342v-.3-.3V341v-.3-.3V340v-.3-.3V339v-.3-.3V338v-.3-.3V337v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4V330v-.4-.4V329v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V325v-.4-.4V324v-.4-.4-.4-.4-.4-.4-.4V321v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V312v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V307v-.4-.4-.4-.4V305v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V297v-.4-.4-.4-.4V295v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V290v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V285v-.4-.4-.4-.4-.4-.4V282v-.4-.4-.4-.4-.4-.4V279v-.4-.4-.4-.4-.4-.4-.4-.4V275v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.5V267v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V262v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V256c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32z"]
};
var faShortcake = faCakeSlice;
var faPeanut = {
  prefix: 'far',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M435 218.4c18-18.1 29-42.9 29-70.4V80c0-17.7-14.3-32-32-32H364c-13.6 0-26.5 2.7-38.3 7.6l0 0c-11.7 4.8-22.7 12-32.3 21.6l-.3 .3 0 0c-9.6 9.6-16.7 20.6-21.5 32.2l0 0c-2.7 6.4-4.7 13.2-5.9 20.2l-.1 .4-.1 .4c-5.3 26.6-15.3 63.2-43.4 91.3s-64.7 38.2-91.3 43.4l-.4 .1-.4 .1c-7 1.3-13.8 3.3-20.2 5.9l0 0C98 276.4 87 283.6 77.3 293.3c-9.7 9.7-16.9 20.7-21.7 32.4l0 0C50.7 337.5 48 350.4 48 364v68c0 17.7 14.3 32 32 32h68c27.4 0 52.1-10.9 70.2-28.7l32.7 33.2-32.7-33.2c.4-.4 .8-.7 1.1-1.1l0 0c9.4-9.5 16.4-20.4 21.1-31.9l0 0c2.7-6.4 4.7-13.2 5.9-20.2l.1-.4 .1-.4c5.3-26.6 15.3-63.2 43.4-91.3s64.7-38.2 91.3-43.4l.4-.1 .4-.1c7-1.3 13.8-3.3 20.2-5.9l0 0c11.6-4.8 22.6-11.9 32.2-21.4l0 0 .6-.6 0 0zM512 148c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.5 .6-1.1 1.1-1.7 1.7C225.1 495.8 188.5 512 148 512H80c-44.2 0-80-35.8-80-80V364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C234.4 74 245 57.8 259.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0h68c44.2 0 80 35.8 80 80v68zM372.8 136a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-192 192a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 372.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM372.8 200a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 308.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"]
};
var faWrenchSimple = {
  prefix: 'far',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M133 10.3c6.9 4.4 11 12 11 20.2V150.1l48 48 48-48V30.5c0-8.2 4.2-15.8 11-20.2s15.5-5 23-1.6C338.3 38.2 384 98.5 384 176c0 64.3-31.6 121.1-80 156V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V319.1c0-8.3 4.3-16.1 11.4-20.4C308.6 273.3 336 227.8 336 176c0-42.2-18.3-77.7-48-102.4V160c0 6.4-2.5 12.5-7 17l-72 72c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-72-72c-4.5-4.5-7-10.6-7-17V73.6C66.3 98.3 48 133.8 48 176c0 51.8 27.4 97.3 68.6 122.7c7.1 4.4 11.4 12.1 11.4 20.4V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V332C31.6 297.1 0 240.3 0 176C0 98.5 45.7 38.2 110 8.7c7.4-3.4 16.1-2.8 23 1.6z"]
};
var faBlender = {
  prefix: 'far',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 80C0 35.8 35.8 0 80 0h48 32 16.2H471c20.8 0 36.1 19.6 31 39.8L425.6 345.5C457.8 361 480 393.9 480 432v16c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V432c0-40.5 25.1-75.1 60.6-89.2L149.3 256H80c-44.2 0-80-35.8-80-80V80zM144 432v16c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V432c0-26.5-21.5-48-48-48H192c-26.5 0-48 21.5-48 48zM406.5 224H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H414.5l16-64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H438.5l12-48H180.2l24 288H378.5l28-112zM80 48C62.3 48 48 62.3 48 80v96c0 17.7 14.3 32 32 32h65.3L132 48H80zM288 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTeeth = {
  prefix: 'far',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", "M96 80c-26.5 0-48 21.5-48 48v45.4C63.9 150.8 90.2 136 120 136c15.2 0 29.5 3.9 42 10.7c16.1-21.1 41.4-34.7 70-34.7c21.3 0 40.8 7.5 56 20.1c15.2-12.6 34.7-20.1 56-20.1c28.5 0 53.9 13.6 70 34.7c12.5-6.8 26.8-10.7 42-10.7c29.8 0 56.1 14.8 72 37.4V128c0-26.5-21.5-48-48-48H96zM48 362.6V384c0 26.5 21.5 48 48 48H480c26.5 0 48-21.5 48-48V362.6c-15.9 22.6-42.2 37.4-72 37.4c-21.3 0-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1c-29.8 0-56.1-14.8-72-37.4zM0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm192 72v24 16c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9c.7 .1 1.3 .1 2 .1h48c.7 0 1.3 0 2-.1c7.2-.9 13-6.6 13.9-13.9c.1-.7 .1-1.3 .1-2V200c0-10.9-4.4-20.8-11.4-28c-7.3-7.4-17.4-12-28.6-12c-15.2 0-28.4 8.5-35.2 21c-3.1 5.7-4.8 12.1-4.8 19zm64 88H208c-.7 0-1.3 0-2 .1c-7.2 .9-13 6.6-13.9 13.9c-.1 .7-.1 1.3-.1 2v8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9c-.7-.1-1.3-.1-2-.1zm48 16v8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9c-.6-.1-1.3-.1-2-.1H320c-.7 0-1.3 0-2 .1c-7.2 .9-13 6.6-13.9 13.9c-.1 .7-.1 1.3-.1 2zm16-48h48c.7 0 1.3 0 2-.1c7.3-.9 13-6.6 13.9-13.9c.1-.7 .1-1.3 .1-2V224 200c0-6.9-1.7-13.4-4.8-19c-6.8-12.5-20-21-35.2-21c-11.2 0-21.3 4.6-28.6 12c-7.1 7.2-11.4 17.1-11.4 28v40c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9c.7 .1 1.3 .1 2 .1zm110-.1c.6 .1 1.3 .1 2 .1h48c8.2 0 14.9-6.1 15.9-14c.1-.7 .1-1.3 .1-2V224c0-22.1-17.9-40-40-40c-9.2 0-17.6 3.1-24.3 8.3c-2.9 2.2-5.5 4.8-7.7 7.7c-5 6.7-8 15-8 24v16c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9zM416.1 302c-.1 .7-.1 1.3-.1 2v8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12c22.1 0 40-17.9 40-40v-8c0-.7 0-1.3-.1-2c-1-7.9-7.7-14-15.9-14H432c-.7 0-1.3 0-2 .1c-7.3 .9-13 6.6-13.9 13.9zM146 288.1c-.7-.1-1.3-.1-2-.1H96c-8.2 0-14.9 6.1-15.9 14c-.1 .7-.1 1.3-.1 2v8c0 22.1 17.9 40 40 40c11.2 0 21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28v-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9zM159.9 242c.1-.7 .1-1.3 .1-2V224c0-9-3-17.3-8-24c-2.2-2.9-4.8-5.5-7.7-7.7c-6.7-5.2-15.2-8.3-24.3-8.3c-22.1 0-40 17.9-40 40v16c0 .7 0 1.3 .1 2c1 7.9 7.7 14 15.9 14h48c.7 0 1.3 0 2-.1c7.2-.9 13-6.6 13.9-13.9z"]
};
var faTally2 = {
  prefix: 'far',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", "M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 13.3 10.7 24 24 24s24-10.7 24-24V64zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 13.3 10.7 24 24 24s24-10.7 24-24V64z"]
};
var faShekelSign = {
  prefix: 'far',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M40 32C26.7 32 16 42.7 16 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V80H184c39.8 0 72 32.2 72 72V336c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-66.3-53.7-120-120-120H40zM312 480c66.3 0 120-53.7 120-120V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 39.8-32.2 72-72 72H192V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24H312z"]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faCars = {
  prefix: 'far',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", "M137.8 48H278.2c10.1 0 19.2 6.4 22.6 15.9L317.9 112H98.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM41.4 127.9c-.2 .5-.3 .9-.5 1.4C16.2 146.7 0 175.5 0 208v32 16 32 40c0 13.3 10.7 24 24 24s24-10.7 24-24V288H220.1c5.3-6.6 11.3-12.7 17.8-18.2L248.5 240H48V208c0-26.5 21.5-48 48-48H286.8c19.2-20 46.1-32 75.1-32h12.8l0-.1L346 47.8C335.7 19.1 308.6 0 278.2 0H137.8C107.4 0 80.3 19.1 70 47.8L41.4 127.9zM112 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm249.8-16H502.2c10.1 0 19.2 6.4 22.6 15.9L541.9 272H322.1l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2 .5-.3 .9-.5 1.4C240.2 306.7 224 335.5 224 368v32 16 32 40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H592v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448 416 400 368c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8H361.8c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM544 320c26.5 0 48 21.5 48 48v32H272V368c0-26.5 21.5-48 48-48H544zM336 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faAxeBattle = {
  prefix: 'far',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M120.8 70.4c15 20 39.3 40.8 79.2 51.1v49.2c-57.2-11.6-94.4-40.5-117.6-71.5c-3.1-4.2-6.2-8.6-9.2-13.3C57.2 119.3 48 156.7 48 192c0 36.8 10 76.1 27.4 110.7c4.4-6.6 9-12.9 13.8-18.8l37.3 30.3c-13.6 16.8-25 36.8-30.9 57.8c-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3c-4.4-5.3-8.7-10.9-12.8-16.6l-1-1.4c-1.1-1.6-2.3-3.3-3.4-4.9l-.2-.3C18.6 307.4 0 247.9 0 192C0 136.2 18.5 77.4 50 29.8l.7-1c2.1-3.1 4.2-6.1 6.3-9.1l.5-.7c3.3-4.5 6.7-8.9 10.2-13.2C71.8 .9 78.4-1.1 84.5 .7c6.1 1.8 10.5 7 11.3 13.3c.9 6.4 2.6 12.8 4.7 19l.2 .6c.6 1.7 1.2 3.3 1.9 5l.1 .2c4.6 11.4 11 22.2 18 31.7zm5.6 243.7L89.2 283.8c23.4-28.8 59.1-57.3 110.8-69.5V264c-34.2 10.7-57.6 30.4-73.6 50.1zM312 170.7V121.5c40-10.3 64.3-31.1 79.3-51.1c7.1-9.5 13.4-20.3 18-31.7l.1-.2c.7-1.6 1.3-3.3 1.9-5l.2-.6c2.2-6.2 3.8-12.6 4.7-19c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.7 .2 16.8 5.1c3.5 4.3 6.9 8.7 10.2 13.2l.5 .7c2.2 3 4.3 6 6.3 9.1l.7 1c27.1 41.1 44.6 90.5 48.9 139.2L488 192l23.1 23.1c-4.3 48.9-22 98.9-49.4 140l-.2 .3c-1.1 1.7-2.2 3.3-3.4 4.9l-1 1.4c-4.1 5.7-8.3 11.3-12.8 16.6c-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8c-15.9-19.6-39.4-39.4-73.7-50.1V214.3c51.7 12.3 87.5 40.7 110.9 69.5c4.8 5.9 9.4 12.2 13.8 18.8c11.1-22.1 19.3-46.2 23.6-70.4l-6.3-6.3c-18.7-18.7-18.7-49.1 0-67.9l6.3-6.3c-4.1-22.6-11.5-45-21.5-65.9c-3 4.7-6 9.2-9.2 13.3c-23.2 31-60.5 59.9-117.7 71.5zM280 56V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faUserHairLong = {
  prefix: 'far',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zM49.3 464H398.7c-8.3-54.4-55.3-96-112-96H161.3c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320H286.7C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"]
};
var faMap = {
  prefix: 'far',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"]
};
var faArrowLeftFromArc = {
  prefix: 'far',
  iconName: 'arrow-left-from-arc',
  icon: [512, 512, [], "e615", "M464 256c0-114.9-93.1-208-208-208c-13.3 0-24-10.7-24-24s10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM119.7 134.4c9.7-9 24.9-8.5 33.9 1.3s8.5 24.9-1.3 33.9L85.1 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H85.1l67.2 62.4c9.7 9 10.3 24.2 1.3 33.9s-24.2 10.3-33.9 1.3l-112-104C2.8 269 0 262.7 0 256s2.8-13 7.7-17.6l112-104z"]
};
var faFileCircleInfo = {
  prefix: 'far',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M64 464H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16h0v48h0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z"]
};
var faFaceDisappointed = {
  prefix: 'far',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faLassoSparkles = {
  prefix: 'far',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", "M290.7 0L288 0C128.9 0 0 78.8 0 176c0 60.6 50.2 114.1 126.6 145.8l44.3 20.5c22.6 10.4 37.1 33 37.1 57.9c0 35.2-28.6 63.8-63.8 63.8H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h88.2C205.9 512 256 461.9 256 400.2c0-17.8-4.2-34.9-11.9-50.2c14.3 1.3 29 2 43.9 2c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80l0 .6c49.1 23.4 80 57.5 80 95.4c0 70.7-107.5 128-240 128S48 246.7 48 176c0-60.7 79.2-111.5 185.5-124.7c5.4-7.3 12.9-13 21.8-16.3l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4L306.3 50.3 266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L321 149.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15L365.7 50.3 351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8L426.4 417c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L481 501.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L565.6 447c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7L511 362.4c-2.3-6.3-8.3-10.4-15-10.4z"]
};
var faClockEleven = {
  prefix: 'far',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faRocket = {
  prefix: 'far',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M368.3 265c-44.5 30.1-129.3 68.2-175.7 88l-35-35c20.4-46.1 59.2-130 89.3-174.4C309.1 52 398.4 41.9 461.7 50.3c8.5 63.3-1.7 152.6-93.3 214.7zM118.5 288c-3.6 8-6.8 15.2-9.4 21.2c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8l0 96.2c0 8.6 4.6 16.6 12.1 20.9s16.7 4.2 24.1-.2l88.5-52.5c21.9-13 35.3-36.5 35.3-61.9V312.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-82.1 0c-25.4 0-49 13.4-61.9 35.3L3.4 251.8c-4.4 7.4-4.5 16.6-.2 24.1S15.4 288 24 288h94.5zM408 144a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
var faSirenOn = {
  prefix: 'far',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M69.3 36l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM597.3 76l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM490 304H441.6L423.4 158c-1-8-7.8-14-15.9-14h-175c-8.1 0-14.9 6-15.9 14L198.4 304H150l19-151.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L490 304zm-246.1 0l12.2-98c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9l-11.8 94H243.9zM496 384H144v48H496V384zM144 336H496c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V384c0-26.5 21.5-48 48-48z"]
};
var faClockTen = {
  prefix: 'far',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faCandleHolder = {
  prefix: 'far',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", "M128 112c0 17.7 14.3 32 32 32s32-14.3 32-32c0-3.2-3.6-14.8-17.4-33.6c-4.7-6.4-9.8-12.5-14.6-18.1c-4.9 5.5-9.9 11.7-14.6 18.1C131.6 97.2 128 108.8 128 112zm32 80c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 80H96V464H224V272H176v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V272zM48 464V272c0-26.5 21.5-48 48-48H224c26.5 0 48 21.5 48 48V464h36.1c-2.7-7.5-4.1-15.6-4.1-24c0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.7-32.2 71.9-71.8 72l-.1 0H376 272 224 96 48 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48zm352-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faVideoArrowDownLeft = {
  prefix: 'far',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M320 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H320zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V351 161 128c0-35.3-28.7-64-64-64H64zm464 84.6V363.4L416 313v52.6l104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5v-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4V199l112-50.4zM232 352c13.3 0 24-10.7 24-24s-10.7-24-24-24H177.9L281 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-103 103V216c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24H232z"]
};
var faPhotoFilm = {
  prefix: 'far',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M256 48c-8.8 0-16 7.2-16 16V288c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L380 232.4l56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L578.7 303.8c7.6-1.3 13.3-7.9 13.3-15.8V64c0-8.8-7.2-16-16-16H256zM192 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zm-56 64h24v48 88V376v8 80H352V384h48v80h48c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H400 376 352 160 136 112 64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h48 24zm-24 48H64c-8.8 0-16 7.2-16 16v48h64V176zm0 288V400H48v48c0 8.8 7.2 16 16 16h48zM48 352h64V288H48v64zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPhotoVideo = faPhotoFilm;
var faFloppyDiskCircleArrowRight = {
  prefix: 'far',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M48 96V416c0 8.8 7.2 16 16 16H268c6.9 17.5 16.4 33.7 28.2 48H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368zM128 80v80H272V80H128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L457.4 352H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
var faFolderMinus = {
  prefix: 'far',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faPlanetMoon = {
  prefix: 'far',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM224 464c97.2 0 176-78.8 176-176c0-82.2-56.4-151.3-132.6-170.6l-71 82.9c-11.5 13.4-10.7 33.4 1.8 45.9c6.3 6.3 14.9 9.9 23.9 9.9h66c17.7 0 32 14.3 32 32v15.9c0 10.6-2.6 21-7.6 30.3l-41.3 76.6c-4.4 8.1-12.8 13.2-22 13.2c-13.8 0-25-11.2-25-25V352c-17.7 0-32-14.3-32-32V288l-49.9-49.9c-9-9-21.2-14.1-33.9-14.1H60c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176zM0 288c0-52.3 17.9-100.5 48-138.6c1-1.3 2.1-2.6 3.2-3.9C92.2 95.7 154.4 64 224 64c13.3 0 26.4 1.2 39.1 3.4C368.2 85.9 448 177.6 448 288c0 123.7-100.3 224-224 224S0 411.7 0 288z"]
};
var faFaceEyesXmarks = {
  prefix: 'far',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM137 135l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm192 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM256 304c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]
};
var faChartScatter = {
  prefix: 'far',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDisplayArrowDown = {
  prefix: 'far',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", "M64 0H224V48H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H352V0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM260.3 416l-8 48h71.3l-8-48H260.3zM312 24V206.1l39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faStore = {
  prefix: 'far',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M507.1 129.5l0 0c5.8 9.2 6.4 20.5 2.3 30.1c-3.9 9.2-11.1 14.8-20.1 16c-2 .3-3.9 .4-5.8 .4c-11.7 0-22.2-5.1-29.7-13.2c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-1.8 0-3.8-.1-5.8-.4c-8.9-1.2-16-6.8-19.9-16c-4.1-9.6-3.5-20.9 2.3-30.1l0 0 0 0L120.4 48H455.6l51.5 81.5zM483.5 224c4.1 0 8.1-.3 12-.8c55.5-7.4 81.8-72.5 52.1-119.4L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c0 0 0 0 0 0c19.6 0 37.5-6.4 51.9-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c0 0 0 0 0 0zM112 336V254.4c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V336v48 64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 336 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-6.6 0-13.1-.5-19.4-1.6V336H112zm352 48v64c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V384H464z"]
};
var faArrowTrendUp = {
  prefix: 'far',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", "M352 120c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9L337 369c-9.4 9.4-24.6 9.4-33.9 0l-111-111L41 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L175 207c9.4-9.4 24.6-9.4 33.9 0l111 111L494.1 144H376c-13.3 0-24-10.7-24-24z"]
};
var faPlugCircleMinus = {
  prefix: 'far',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faOliveBranch = {
  prefix: 'far',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H425.2c-34.2 0-67.9 7.5-98.8 22.1L191.9 133.4C189.1 219.3 118.6 288 32 288H16c-8.8 0-16-7.2-16-16V256c0-61.4 34.5-114.6 85.2-141.5C40.4 102.8 11.3 75.8 2.7 66.9C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM399.4 427c19.3-25.7 32.6-63.3 32.6-107s-13.3-81.3-32.6-107c-19.2-25.7-42.2-37-63.4-37s-44.2 11.4-63.4 37C253.3 238.7 240 276.4 240 320s13.3 81.3 32.6 107c19.2 25.7 42.2 37 63.4 37s44.2-11.4 63.4-37zM336 512c-79.5 0-144-86-144-192s64.5-192 144-192s144 86 144 192s-64.5 192-144 192zm129.7-40.2c9.4-13.1 17.6-27.5 24.4-43.1c3.6 .8 7.1 1.5 10.5 2c31.1 4.6 55-3.6 70.2-19.3c15.4-16 23.9-42.1 19.2-76c-4.7-33.8-22.2-71.6-53.2-103.7c-18-18.7-37.7-32.5-57.2-41.7c-4.9-8.8-10.3-17.2-16.2-25c-10.5-14-22.7-26.5-36.2-36.9c48.2 1.6 101.3 25.8 144.2 70.3c75 77.8 90.2 188.1 33.9 246.4c-34.1 35.4-86.8 43.5-139.6 27z"]
};
var faAngle = {
  prefix: 'far',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", "M253.3 67.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2l-208 400c-3.9 7.4-3.6 16.4 .8 23.5S15.6 480 24 480H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H63.5L253.3 67.1zM242 175.5l-22.6 43.4c19.3 15.8 36.5 34 51.3 54.1l40.8-25.6c-19.6-27.2-43-51.4-69.5-71.9zM322.7 392h48.8c-6-36.9-18-71.8-34.7-103.8l-40.8 25.6c12.4 24.3 21.5 50.6 26.8 78.2z"]
};
var faVacuumRobot = {
  prefix: 'far',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335-79c-43.6-43.6-114.4-43.6-158.1 0c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c62.4-62.4 163.5-62.4 225.9 0s62.4 163.5 0 225.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c43.6-43.6 43.6-114.4 0-158.1zM212.7 212.7c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"]
};
var faSignHanging = {
  prefix: 'far',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M88 0c13.3 0 24 10.7 24 24V64l376 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-376 0V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64H64V24C64 10.7 74.7 0 88 0zM192 336H432V192H192V336zM144 176c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V176z"]
};
var faSign = faSignHanging;
var faSquareDivide = {
  prefix: 'far',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM136 232H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSignalStreamSlash = {
  prefix: 'far',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-69.7-24.8-133.6-66-183.4c-8.4-10.2-23.6-11.6-33.8-3.2s-11.6 23.6-3.2 33.8c34.3 41.5 55 94.7 55 152.8c0 40.1-9.8 77.9-27.2 111.2l-51.6-40.4c9.5-21.7 14.8-45.6 14.8-70.8c0-40.7-13.8-78.2-37-108c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7C406 199.2 416 226.4 416 256c0 13.9-2.2 27.3-6.3 39.8L38.8 5.1zm84.7 188.2C116.1 212.8 112 233.9 112 256c0 40.7 13.8 78.2 37 108c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7C170 312.8 160 285.6 160 256c0-10.7 1.3-21.1 3.8-31l-40.3-31.7zM33 122C11.9 162 0 207.6 0 256c0 69.7 24.8 133.6 66 183.4c8.4 10.2 23.6 11.6 33.8 3.2s11.6-23.6 3.2-33.8C68.6 367.3 48 314.1 48 256c0-37.1 8.4-72.3 23.5-103.7L33 122z"]
};
var faBezierCurve = {
  prefix: 'far',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M352 80v64H288V80h64zM288 32c-26.5 0-48 21.5-48 48v8H123.3C113.9 64.5 90.9 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40h79C138.2 173.8 93.9 241.5 88.5 320H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-7.3c5.9-68.4 49.2-126.1 109.4-152.6C254.3 182.1 270 192 288 192h64c18 0 33.7-9.9 41.9-24.6c60.2 26.4 103.5 84.1 109.4 152.6H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8.5c-5.3-78.5-49.7-146.2-113.8-184h79c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64s-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H400V80c0-26.5-21.5-48-48-48H288zM48 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm512 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 368v64H80V368h64zm352 0h64v64H496V368z"]
};
var faEyeDropperHalf = {
  prefix: 'far',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M233 202.9L199 169l-8-8 0 0c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 33.9-33.9 71.3-71.3c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72l-71.3 71.3L377 279l8 8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-8-8L309.1 279 233 202.9zM343 245.1L448.2 139.9c10.1-10.1 15.8-23.8 15.8-38.1C464 72.1 439.9 48 410.2 48c-14.3 0-28 5.7-38.1 15.8L266.9 169 343 245.1zM183.4 198.6l33.9 33.9L129.9 320H254.1l25.4-25.4 33.9 33.9L183 458.9c-13.5 13.5-31.8 21.1-50.9 21.1H79.3l-42 28c-9.5 6.3-22.2 5.1-30.3-3s-9.3-20.8-3-30.3l28-42V379.9c0-19.1 7.6-37.4 21.1-50.9L183.4 198.6z"]
};
var faStoreLock = {
  prefix: 'far',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M507.1 129.5l0 0c5.8 9.2 6.4 20.5 2.3 30.1c-.3 .7-.6 1.5-1 2.2c6.4-1.1 13-1.7 19.7-1.7c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8l0 0c19.6 0 37.5-6.4 51.9-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c1.2 .9 2.5 1.8 3.8 2.7c9.7-14.3 22.6-26.3 37.7-34.9c-7.4-2.1-13.9-6.2-19-11.8c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-1.8 0-3.8-.1-5.8-.4c-8.9-1.2-16-6.8-19.9-16c-4.1-9.6-3.5-20.9 2.3-30.1l0 0 0 0L120.4 48H455.6l51.5 81.5zM112 336V254.4c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V336v48 64c0 35.3 28.7 64 64 64H392.6c-5.4-9.4-8.6-20.3-8.6-32V464H128c-8.8 0-16-7.2-16-16V384H384V352c0-5.5 .7-10.9 2-16H112zm416-96c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faBellSlash = {
  prefix: 'far',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V49.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96h8 8c57.4 0 104 46.6 104 104v33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48H168.3c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6H406.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
var faCloudBoltSun = {
  prefix: 'far',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm112.1 48c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48c0 20.6 12.9 38.1 31.1 44.9c-12.6 11.7-17.9 29.3-14 46c-37.9-12.9-65.1-48.7-65.1-90.9c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3v5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7v6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0H541.3c3.5-10.1 3.7-21.3 0-31.8c-2.1-6.1-5.4-11.6-9.6-16.2h26.1c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1V218.3c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9v-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-.6 .7-1.1 1.3-1.8 1.9c-6.1 1.1-12 3.5-17.4 7c-1.6 0-3.3-.2-4.9-.6c-8.9-2.1-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm154 35.6c5.8 4.7 7.6 12.9 4.2 19.6L425.9 352H496c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384H304c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faThunderstormSun = faCloudBoltSun;
var faCameraSlash = {
  prefix: 'far',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V160c0-35.3-28.7-64-64-64H438.6l-8.6-25.7C422.4 47.4 401 32 376.9 32H263.1c-24.1 0-45.5 15.4-53.1 38.3L201.4 96H154.8L38.8 5.1zM216 144h2.7c10.3 0 19.5-6.6 22.8-16.4l14-42.1c1.1-3.3 4.1-5.5 7.6-5.5H376.9c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4H512c8.8 0 16 7.2 16 16V388.5l-98.4-77.2c1.6-7.5 2.4-15.4 2.4-23.4c0-61.9-50.1-112-112-112c-17.5 0-34.1 4-48.9 11.2L216 144zM382.6 274.6L318.1 224c.6 0 1.3 0 1.9 0c30.7 0 56.4 21.7 62.6 50.6zM487.4 480l-60.9-48H128c-8.8 0-16-7.2-16-16V184.2L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6V416c0 35.3 28.7 64 64 64H487.4zM370.6 388l-45.9-36.1c-1.6 .1-3.1 .2-4.7 .2c-31.8 0-58.2-23.2-63.2-53.6L211 262.2c-1.9 8.3-3 16.9-3 25.8c0 61.9 50.1 112 112 112c18.2 0 35.4-4.3 50.6-12z"]
};
var faCommentQuote = {
  prefix: 'far',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM160 144c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V224 200 176c0-17.7-14.3-32-32-32H160zm224 80V200 176c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V224z"]
};
var faTablet = {
  prefix: 'far',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTabletAndroid = faTablet;
var faSchoolFlag = {
  prefix: 'far',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H318.1l89.6 64H504c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H336 240 72c-39.8 0-72-32.2-72-72V232c0-39.8 32.2-72 72-72h96.3L264 91.6V24c0-13.3 10.7-24 24-24zM504 464c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H400c-5 0-9.9-1.6-13.9-4.5l-98.1-70-98.1 70c-4.1 2.9-8.9 4.5-13.9 4.5H72c-13.3 0-24 10.7-24 24V440c0 13.3 10.7 24 24 24H240V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64H504zM240 240a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM112 256h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V272zM112 352h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm320 0h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z"]
};
var faMessageCode = {
  prefix: 'far',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM217 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
var faGlassHalf = {
  prefix: 'far',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512H276c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8H24zM66.7 240L50.2 48H333.8L317.3 240H66.7zm4.1 48H313.2L299.9 442.1C298.8 454.5 288.4 464 276 464H108c-12.5 0-22.8-9.5-23.9-21.9L70.8 288z"]
};
var faGlassHalfEmpty = faGlassHalf;
var faGlassHalfFull = faGlassHalf;
var faFill = {
  prefix: 'far',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M73 7C63.6-2.3 48.4-2.3 39 7s-9.4 24.6 0 33.9l89.4 89.4L30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L162.3 96.4 73 7zm89.4 157.3L231 233c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-68.7-68.7L255 71.6c9.4-9.4 24.6-9.4 33.9 0L440.4 223c9.4 9.4 9.4 24.6 0 33.9l-31 31H51.2c1.6-9.5 6.1-18.6 13.4-25.9l97.8-97.8z"]
};
var faMessageMinus = {
  prefix: 'far',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faCommentAltMinus = faMessageMinus;
var faAngleUp = {
  prefix: 'far',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z"]
};
var faDinosaur = {
  prefix: 'far',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M449.1 0c-16.8 0-33 6-45.7 16.9L375.7 40.7C360.7 53.5 352 72.4 352 92.2c0 37.5 30.4 67.8 67.8 67.8H472c13.3 0 24 10.7 24 24v19.2c0 11.5-9.3 20.8-20.8 20.8c-13 0-25.6-3.8-36.4-11L413.3 196c-35.2-23.5-76.6-36-119-36h-9.1c-60.8 0-119.5 22.7-164.5 63.6l-80.2 73C14.7 320 0 353.3 0 388.2C0 456.6 55.4 512 123.8 512H255.1c35.9 0 64.9-29.1 64.9-64.9c0-33-24.7-60.7-57.4-64.5l-103.2-12c-2.5-10.6-12-18.6-23.4-18.6c-13.3 0-24 10.7-24 24c0 21.3 16 39.2 37.1 41.7L257 430.3c8.5 1 15 8.2 15 16.8c0 9.3-7.6 16.9-16.9 16.9H123.8C82 464 48 430 48 388.2c0-21.4 9-41.7 24.8-56.1l80.2-73c36.2-32.9 83.3-51.1 132.2-51.1h9.1c32.9 0 65 9.7 92.4 28l25.4 16.9c18.7 12.5 40.6 19.1 63.1 19.1c38 0 68.8-30.8 68.8-68.8V184c0-39.8-32.2-72-72-72H419.8c-11 0-19.8-8.9-19.8-19.8c0-5.8 2.5-11.3 6.9-15.1l27.7-23.8c4-3.4 9.1-5.3 14.4-5.3h11.6C533.2 48 592 106.8 592 179.3v26.9c0 65-28.9 126.6-78.8 168.2l-8.6 7.2c-6.2 5.2-9.2 12.9-8.6 20.4c-.1 .7-.1 1.3-.1 2v52c0 4.4-3.6 8-8 8H440c-4.4 0-8-3.6-8-8V424c0-8-3.9-15.4-10.5-19.9c-6.6-4.4-14.9-5.4-22.3-2.4l-.1 0c-.2 .1-.5 .2-.9 .3c-.9 .3-2.4 .8-4.6 1.5c-4.2 1.3-10.8 3.1-19.5 5c-7.7 1.6-17.1 3.3-28.2 4.6c4 10.6 6.1 22 6.1 34c0 4.7-.3 9.3-1 13.8c12.7-1.5 23.7-3.4 32.9-5.4l.1 0v.5c0 30.9 25.1 56 56 56h48c30.9 0 56-25.1 56-56V411.2c60.8-50.7 96-125.8 96-205V179.3C640 80.3 559.7 0 460.7 0H449.1zM480 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faDrumstickBite = {
  prefix: 'far',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M208 272c0 17.7 14.3 32 32 32h16 51.2c-2.1-10.4-3.2-21.1-3.2-32c0-82.8 62.8-150.8 143.4-159.1C425.4 74.1 383.7 48 336 48c-70.7 0-128 57.3-128 128v64 32zm-48-32V176C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1H256 244c-17.7 0-31.3 15.6-41.5 30c-1.7 2.4-3.6 4.6-5.7 6.7c-12 12-11.1 31.5-6.8 47.9c1.3 4.9 2 10 2 15.4c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5.3 0 10.5 .7 15.4 2c16.4 4.3 35.9 5.2 47.9-6.8c2.1-2.1 4.4-4 6.8-5.7c14.4-10.2 30-23.9 30-41.5V240z"]
};
var faLinkHorizontalSlash = {
  prefix: 'far',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.4-44.2c39.5-25.6 65.6-70.1 65.6-120.7c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 39.8-24.3 74-58.8 88.4L414.8 299.8c20.8-25 33.2-57.1 33.2-91.9C448 128.4 383.6 64 304.1 64H143.9c-9.1 0-18.1 .9-26.8 2.5L38.8 5.1zM175.2 112h129c52.9 0 95.9 42.9 95.9 95.9c0 23.7-8.6 45.5-23 62.3L175.2 112zM446.8 448l-60.9-48H335.9c-53 0-95.9-42.9-95.9-95.9c0-6 .6-12 1.6-17.7l-40.8-32.1c-5.7 15.6-8.9 32.4-8.9 49.8C192 383.6 256.4 448 335.9 448H446.8zM30.1 119.7C11.2 144.1 0 174.7 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5c13.2 .9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-22 7.4-42.2 19.8-58.4L30.1 119.7z"]
};
var faChainHorizontalSlash = faLinkHorizontalSlash;
var faHollyBerry = {
  prefix: 'far',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm160 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM161.4 264.5c-1.7 58.6-42.3 107.5-97 121.6c6.2 22 7.2 45.1 2.7 67.4c24.9-6.1 50.9-5.4 75.4 1.9c1.7-58.6 42.3-107.5 97-121.6c-6.2-22-7.1-45.1-2.7-67.4c-24.9 6.1-50.9 5.4-75.4-1.9zM113.4 232c0-16.2 15.6-27.7 31.1-22.9l29.8 9.2c16.8 5.2 34.8 5.7 51.8 1.3l39-9.9c11.1-2.8 21.5 2.5 26.6 11.2c15.2 2.8 30.9 1.9 45.7-2.7l29.8-9.2c15.4-4.8 31.1 6.8 31.1 22.9v28.8c0 44.9 36.4 81.4 81.4 81.4c16.6 0 28.2 16.5 22.6 32.1l-6.7 18.6c-6.9 19.2-7.5 40.1-1.8 59.6l8.1 27.7c5.2 17.8-10.9 34.6-28.9 30l-39-9.9c-17.1-4.3-35-3.8-51.8 1.3l-29.8 9.2c-15.4 4.8-31.1-6.8-31.1-22.9l0-28.8c0-39.5-28.1-72.4-65.4-79.8v0c-37.4 7.4-65.6 40.3-65.6 79.8l0 28.8c0 16.2-15.6 27.7-31.1 22.9l-29.8-9.2c-16.8-5.2-34.8-5.7-51.8-1.3l-39 9.9c-18 4.6-34.2-12.2-28.9-30l8.1-27.7c5.8-19.6 5.1-40.4-1.8-59.6L9.5 374.3c-5.6-15.6 6-32.1 22.6-32.1c44.9 0 81.4-36.4 81.4-81.4V232zM292.7 341c44.2 19.7 75.2 63.4 76.7 114.5c24.5-7.3 50.6-8 75.4-1.9c-4.5-22.4-3.5-45.5 2.7-67.4c-54.7-14.1-95.3-62.9-97-121.6c-21.1 6.3-43.3 7.7-64.9 4.1c-5.4 19.2-4.7 39.7 2.1 58.5l5 13.9z"]
};
var faNose = {
  prefix: 'far',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M205.3 12.9C199.2 1.2 184.7-3.4 172.9 2.7s-16.3 20.6-10.2 32.4C237 178 327.3 280.7 374.8 329.6c16 16.4 25.2 37.6 25.2 59.2c0 41.5-33.7 75.2-75.2 75.2H313.9l-17-17-30.1-30.1c-21.1-21.1-49.7-32.9-79.5-32.9c-32.8 0-59.4 26.6-59.4 59.4V448c0 35.3 28.7 64 64 64H324.8C392.8 512 448 456.8 448 388.8c0-35.4-15.1-68.3-38.8-92.7C363.7 249.4 276.8 150.4 205.3 12.9zm27.6 437.9L246.1 464H192c-8.8 0-16-7.2-16-16v-4.6c0-6.3 5.1-11.4 11.4-11.4c17.1 0 33.5 6.8 45.6 18.9zM141 303.5c13-2.8 21.2-15.5 18.4-28.5s-15.5-21.2-28.5-18.4l-22.8 4.9C45.1 274.9 0 330.7 0 395.2c0 40.6 18 79.1 49.2 105.1l7.4 6.2c10.2 8.5 25.3 7.1 33.8-3.1s7.1-25.3-3.1-33.8l-7.4-6.2C59.7 446.5 48 421.5 48 395.2c0-41.9 29.2-78 70.2-86.8l22.8-4.9z"]
};
var faArrowLeftToArc = {
  prefix: 'far',
  iconName: 'arrow-left-to-arc',
  icon: [512, 512, [], "e616", "M48 256C48 141.1 141.1 48 256 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C114.6 0 0 114.6 0 256S114.6 512 256 512c13.3 0 24-10.7 24-24s-10.7-24-24-24C141.1 464 48 370.9 48 256zM279.7 134.4l-112 104c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c9.7 9 24.9 8.5 33.9-1.3s8.5-24.9-1.3-33.9L245.1 280H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H245.1l67.2-62.4c9.7-9 10.3-24.2 1.3-33.9s-24.2-10.3-33.9-1.3z"]
};
var faChevronLeft = {
  prefix: 'far',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"]
};
var faBacteria = {
  prefix: 'far',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M304.9 .7c9.6 2.7 15.1 12.7 12.4 22.3l-2.9 10.3c15.4 7.9 28.3 20.5 36.4 36.4L361 66.7c9.6-2.7 19.5 2.8 22.3 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.8 17.6-4.1 34.6-13.2 48.8l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-7.9 5.1-16.8 8.9-26.4 11.1c-5.9 1.4-11.4 2.9-16.6 4.6l3 10.6c2.7 9.6-2.8 19.5-12.4 22.3s-19.5-2.8-22.3-12.4l-1.6-5.6c-17.8 10.8-29 23.4-36.5 34.5l8.5 3.6c9.1 3.9 13.4 14.5 9.5 23.6s-14.5 13.4-23.6 9.5l-9.6-4.1c-.8 2.9-1.4 5.8-1.8 8.7c-1.4 13.3-6 25.6-12.7 36.2l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-14.1 9-31 13.9-48.8 13.2l-3.1 11c-2.7 9.6-12.7 15.1-22.3 12.4S64 370.6 66.7 361l2.9-10.3c-15.7-8.1-28.4-20.9-36.4-36.4l-10.3 2.9C13.4 320 3.4 314.5 .7 304.9s2.8-19.5 12.4-22.3l11-3.1c-.2-3.7-.1-7.4 .3-11.2c1.1-12.1 3.8-24.2 7-35.9c.2-.8 .4-1.5 .7-2.3l-8.7-3.5c-9.2-3.7-13.7-14.2-10-23.4s14.2-13.7 23.4-10l7.4 3c4.6-10.7 10.3-22.2 17.4-34c1.4-2.4 2.9-4.8 4.5-7.3l-11.2-9c-7.8-6.2-9-17.5-2.8-25.3s17.5-9 25.3-2.8L87.3 126c10.2-12.2 22-24.1 35.5-35.3L117 82c-5.5-8.3-3.3-19.4 5-25s19.4-3.3 25 5l4.9 7.4c13.7-8.8 28.7-16.8 45.2-23.9l-3.6-8.5c-3.9-9.1 .3-19.7 9.5-23.6s19.7 .3 23.6 9.5l4.4 10.3c8.4-2.6 17.1-4.9 26.2-7c7.5-1.7 15.1-2.4 22.4-2.1l3.1-11C285.4 3.5 295.4-2 304.9 .7zM143.8 279.9c.1-.7 .2-1.4 .3-2.1c3.2-20.9 11.7-39.5 20.3-53.8c18-30 52.2-65.4 119.7-80.9c19.4-4.5 31.5-23.8 27-43.2s-23.8-31.5-43.2-27c-88.4 20.4-138.2 69-165.3 114.1c-13.3 22.1-20.8 42.9-25 58.3c-2.8 10-4.7 19.2-5.5 27.6c-1.8 19.8 12.8 37.2 32.6 39c19.6 1.8 36.9-12.5 39-31.9zm352.4-47.8c-.1 .7-.2 1.4-.3 2.1c-3.2 20.9-11.7 39.5-20.3 53.8c-18 30-52.2 65.4-119.7 80.9c-19.4 4.5-31.5 23.8-27 43.2s23.8 31.5 43.2 27c88.4-20.4 138.2-69 165.3-114.1c13.3-22.1 20.8-42.9 25-58.3c2.8-10 4.7-19.2 5.5-27.6c1.8-19.8-12.8-37.2-32.6-39c-19.6-1.8-36.9 12.5-39 31.9zm39.3-80l3.1-11c2.7-9.6 12.7-15.1 22.3-12.4s15.1 12.7 12.4 22.3l-2.9 10.3c15.7 8.1 28.4 20.9 36.4 36.4l10.3-2.9c9.6-2.7 19.5 2.8 22.2 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.2 3.7 .1 7.4-.3 11.2c-1.1 12.1-3.8 24.2-7 35.9l-.2 .8-.4 1.5 8.7 3.5c9.2 3.7 13.7 14.2 10 23.4s-14.2 13.7-23.4 10l-7.4-3c-4.6 10.7-10.3 22.2-17.4 34c-1.4 2.4-3 4.8-4.5 7.3l11.2 9c7.8 6.2 9 17.5 2.8 25.3s-17.5 9-25.3 2.8L552.7 386c-10.2 12.2-22 24.1-35.5 35.3L523 430c5.5 8.3 3.3 19.4-5 25s-19.4 3.3-25-5l-4.9-7.4c-13.7 8.8-28.7 16.8-45.2 23.9l3.6 8.5c3.9 9.1-.3 19.7-9.5 23.6s-19.7-.3-23.6-9.5l-4.4-10.3c-8.4 2.6-17.1 4.9-26.2 7c-7.5 1.7-15.1 2.4-22.5 2.1l-3.1 11c-2.7 9.6-12.7 15.1-22.2 12.4s-15.1-12.7-12.4-22.3l3-10.3c-15.4-7.9-28.3-20.5-36.4-36.4l-10.3 2.9c-9.6 2.7-19.5-2.8-22.3-12.4s2.8-19.5 12.4-22.2l11-3.1c-.8-17.6 4.1-34.6 13.2-48.8l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c7.9-5.1 16.8-8.9 26.4-11.1c5.9-1.4 11.4-2.9 16.6-4.6l-3-10.6c-2.7-9.6 2.8-19.5 12.4-22.3s19.5 2.8 22.3 12.4l1.6 5.6c17.8-10.8 29-23.4 36.5-34.5l-8.5-3.6c-9.1-3.9-13.4-14.5-9.5-23.6s14.5-13.4 23.6-9.5l9.6 4.1c.8-2.9 1.4-5.8 1.8-8.7c1.4-13.3 5.9-25.6 12.7-36.2l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c14.1-9 31-13.9 48.8-13.2zM192 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM400 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faClouds = {
  prefix: 'far',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", "M272 112c0 .7 0 1.4 0 2c-.3 10.3 6 19.7 15.6 23.2s20.5 .6 27-7.4c8.8-10.9 22.3-17.9 37.4-17.9c26.5 0 48 21.5 48 48c0 8.7-2.3 16.8-6.3 23.8c3.6 2.3 7.1 4.8 10.6 7.4c12.8-4.4 26.5-6.8 40.7-7.2c2-7.7 3-15.7 3-24c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192s43 96 96 96h65.9c2.7-17.1 8.3-33.3 16.2-48H96c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.4 1 16.6 2.9c7.9 2.9 16.8 1.5 23.4-3.8s9.9-13.7 8.7-22c-.4-2.9-.6-6-.6-9.1c0-35.3 28.7-64 64-64s64 28.7 64 64zM240 312c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H236h-1.9c-.3 0-.7-.1-1-.1C201.3 462.4 176 436.2 176 404c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C154.4 322.1 128 359.9 128 404c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H528c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C534.5 247 494.9 216 448 216c-18 0-34.9 4.6-49.7 12.6C376.5 206.1 345.9 192 312 192z"]
};
var faMoneyBillSimple = {
  prefix: 'far',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faHandLizard = {
  prefix: 'far',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H288c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V413.3L281.1 384H136c-39.8 0-72-32.2-72-72s32.2-72 72-72H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H72c-39.8 0-72-32.2-72-72S32.2 64 72 64H281.6c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V316.1c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9H72z"]
};
var faTablePivot = {
  prefix: 'far',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", "M464 416c0 8.8-7.2 16-16 16H128V192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160V160H464V416zM64 32C28.7 32 0 60.7 0 96v64H128V32H64zM414.8 246.1c2.5-6 1.1-12.9-3.5-17.4l-32-32c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h16v48c0 8.8-7.2 16-16 16H288V304c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-32 32c-6.2 6.2-6.2 16.4 0 22.6l32 32c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V352h48c26.5 0 48-21.5 48-48V256h16c6.5 0 12.3-3.9 14.8-9.9z"]
};
var faFilterSlash = {
  prefix: 'far',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L408.1 294.6 566.6 100c6.1-7.4 9.4-16.7 9.4-26.3c0-23-18.7-41.7-41.7-41.7h-429c-8.6 0-16.5 2.6-23.1 7.1L38.8 5.1zM134.4 80H521L370.3 265 134.4 80zM288 364.4V322.9l-48-37.8v83.2c0 12.2 5.6 23.7 15.1 31.3L347.6 473c5.7 4.5 12.8 7 20.1 7c17.8 0 32.3-14.5 32.3-32.3V411.2l-48-37.8v41.9l-64-50.8z"]
};
var faTrashCanUndo = {
  prefix: 'far',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm145.9 64.1c8.8 9.9 7.9 25.1-2 33.9L199.1 248H240c48.6 0 88 39.4 88 88v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V336c0-22.1-17.9-40-40-40H199.1l24.8 22.1c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2z"]
};
var faTrashCanArrowTurnLeft = faTrashCanUndo;
var faTrashUndoAlt = faTrashCanUndo;
var faNotdef = {
  prefix: 'far',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M48 421.8L162.8 256 48 90.2V421.8zM77.2 464H306.8L192 298.2 77.2 464zm144-208L336 421.8V90.2L221.2 256zM306.8 48H77.2L192 213.8 306.8 48zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]
};
var faDisease = {
  prefix: 'far',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M64.1 286.3c0-19.3-8.3-37.6-22.8-50.3L21.8 219C8 206.9 .1 189.5 .1 171.2c0-39.3 35.3-69.3 74.1-62.8l55.6 9.3c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-7.4c-9.6 0-19.2 1.2-28.5 3.5L91 433.2c-32.6 8.2-65.7-11.7-73.8-44.3c-5.7-22.6 2.1-46.4 20-61.4L49.8 317c9.1-7.6 14.3-18.9 14.3-30.7zM267 102.1c-31.8 47.7-88.6 72.3-145.1 62.9l-55.6-9.3c-9.5-1.6-18.2 5.8-18.2 15.4c0 4.5 1.9 8.8 5.3 11.7l19.5 17.1c24.9 21.8 39.2 53.3 39.2 86.4c0 26.1-11.5 50.8-31.5 67.5L68 364.3c-3.8 3.2-5.4 8.2-4.2 13c1.7 6.9 8.7 11.1 15.6 9.4l54.9-13.7c13.1-3.3 26.6-4.9 40.1-4.9h7.4c38.1 0 75.2 13 104.9 36.8l30.9 24.7c2 1.6 4.5 2.5 7 2.5c6.2 0 11.3-5 11.3-11.3l0-25.2c0-54.7 33.6-103.7 84.6-123.5l36.9-14.3c4-1.5 6.6-5.3 6.6-9.6c0-5-3.5-9.2-8.4-10.1l-28-5.1c-55.4-10.1-99.4-52.4-111.8-107.4L308.8 94c-1.8-8.2-9.1-14-17.5-14c-6 0-11.6 3-14.9 8L267 102.1zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm48-128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPersonToDoor = {
  prefix: 'far',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", "M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L56.4 165.8c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L225.1 480.8c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H343.6c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1L103.4 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h84.9c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM528 48V464H432V303.2c-10.2 10.4-24.3 16.8-40 16.8c-2.7 0-5.4-.2-8-.6V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48V208.6c2.6-.4 5.3-.6 8-.6c15.7 0 29.8 6.4 40 16.8V48h96z"]
};
var faTurntable = {
  prefix: 'far',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-88c0-13.3-10.7-24-24-24s-24 10.7-24 24V271.7c0 6.7-1.7 13.3-4.9 19.2l-40.2 73.7c-6.3 11.6-2.1 26.2 9.6 32.6s26.2 2.1 32.6-9.6l40.2-73.7c7-12.9 10.7-27.4 10.7-42.1V136z"]
};
var faBriefcaseMedical = {
  prefix: 'far',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm24 88H360h88c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h88zm72 64v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faGenderless = {
  prefix: 'far',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
var faChevronRight = {
  prefix: 'far',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
};
var faSignalWeak = {
  prefix: 'far',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", "M64 384c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faSignal1 = faSignalWeak;
var faClockFive = {
  prefix: 'far',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V248.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faRetweet = {
  prefix: 'far',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", "M120 208h31c22.6 0 41-18.3 41-41c0-10.9-4.3-21.3-12-29L113 71c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-67 67c-7.7 7.7-12 18.1-12 29c0 22.6 18.3 41 41 41H72V328c0 48.6 39.4 88 88 88H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H160c-22.1 0-40-17.9-40-40V208zM96 121.9L134.1 160l-76.1 0L96 121.9zM504 304V184c0-48.6-39.4-88-88-88H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H416c22.1 0 40 17.9 40 40V304H425c-22.6 0-41 18.3-41 41c0 10.9 4.3 21.3 12 29l67 67c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l67-67c7.7-7.7 12-18.1 12-29c0-22.6-18.3-41-41-41H504zm-24 86.1L441.9 352h76.1L480 390.1z"]
};
var faCarRear = {
  prefix: 'far',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M165.4 80H346.6c17 0 32.1 10.7 37.8 26.8L408.6 176H103.4l24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM82.3 90.9L48.1 188.8C19.3 205.4 0 236.4 0 272v64c0 23.7 12.9 44.4 32 55.4V456c0 13.3 10.7 24 24 24s24-10.7 24-24V400H432v56c0 13.3 10.7 24 24 24s24-10.7 24-24V391.4c19.1-11.1 32-31.7 32-55.4V272c0-35.6-19.4-66.6-48.1-83.2L429.7 90.9C417.3 55.6 384 32 346.6 32H165.4C128 32 94.7 55.6 82.3 90.9zM96 224H416c20.9 0 38.7 13.4 45.3 32H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v32c0 8.8-7.2 16-16 16H320V320c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v32H64c-8.8 0-16-7.2-16-16V304h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H50.7c6.6-18.6 24.4-32 45.3-32z"]
};
var faCarAlt = faCarRear;
var faPumpSoap = {
  prefix: 'far',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", "M112 56c0-30.9 25.1-56 56-56h48c25.4 0 46.8 16.9 53.7 40h46.4c19.1 0 37.4 7.6 50.9 21.1L409 103c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L333.1 95c-4.5-4.5-10.6-7-17-7H272v40H224V56c0-4.4-3.6-8-8-8H168c-4.4 0-8 3.6-8 8v72H112V56zM101.5 222.7l-18.7 224C82.1 456 89.4 464 98.8 464H285.2c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7H117.4c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7H266.6c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zm125.8 59.9c2.9-4.1 7.5-6.6 12.6-6.6s9.7 2.5 12.6 6.6l33.3 48.1c6.6 9.5 10.1 20.8 10.1 32.4v.9c0 30.9-25.1 56-56 56s-56-25.1-56-56v-.9c0-11.6 3.5-22.9 10.1-32.4l33.3-48.1z"]
};
var faComputerClassic = {
  prefix: 'far',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M384 48c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V368c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V423.4c19.1-11.1 32-31.7 32-55.4V64c0-35.3-28.7-64-64-64H64zM80 432H368v32H80V432zm0-320v96c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V112c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32zM208 320c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm-88 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFrame = {
  prefix: 'far',
  iconName: 'frame',
  icon: [448, 512, [], "e495", "M448 120c0-13.3-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L112 96l0-40c0-13.3-10.7-24-24-24S64 42.7 64 56l0 40L24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l40 0 0 224-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 224 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-224 40 0c13.3 0 24-10.7 24-24zM112 368l0-224 224 0 0 224-224 0z"]
};
var faVideoSlash = {
  prefix: 'far',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L113.9 64H352c35.3 0 64 28.7 64 64v33V288v12.8L560 413.6V363.4 352 288 148.6L448 199V146.4L552.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5V352v24.5 74.8l22.8 17.9c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM368 263.1V128c0-8.8-7.2-16-16-16H175.2L368 263.1zM32 128c0-2.2 .1-4.4 .3-6.5L80 159V384c0 8.8 7.2 16 16 16H352c8.2 0 15-6.2 15.9-14.1L407 416.7c-11.2 18.7-31.6 31.3-55 31.3H96c-35.3 0-64-28.7-64-64V128z"]
};
var faBatteryQuarter = {
  prefix: 'far',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", "M464 144c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"]
};
var faBattery2 = faBatteryQuarter;
var faEllipsisStroke = {
  prefix: 'far',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM256 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-88 0a64 64 0 1 0 128 0A64 64 0 1 0 32 256z"]
};
var faEllipsisHAlt = faEllipsisStroke;
var faRadio = {
  prefix: 'far',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M494.4 47.1c12.8-3.5 20.3-16.7 16.8-29.5S494.4-2.7 481.6 .9L52.9 119.1C21.6 127.8 0 156.2 0 188.6V192 304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H201.2L494.4 47.1zM48 192c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V304 192zm304 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H224c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faBabyCarriage = {
  prefix: 'far',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M138.9 22.9L256 192H400V152c0-30.9 25.1-56 56-56h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H456c-4.4 0-8 3.6-8 8v40 32c0 28-6.1 55.6-17.7 81.1c-11.6 25.5-28.6 48.4-49.5 67.5c-21 19.1-45.6 34-72.5 44.1S252.8 432 224 432s-57.4-5.2-84.3-15.3s-51.5-25-72.5-44.1c-21-19.1-37.9-42-49.5-67.5C6.1 279.6 0 252 0 224V192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM56.1 272c1.5 4.5 3.3 8.9 5.3 13.2c8.8 19.4 21.8 37.1 38.2 51.9s35.7 26.6 57.1 34.7s44.2 12.2 67.4 12.2s46-4.1 67.4-12.2s40.8-19.8 57.1-34.7s29.3-32.5 38.2-51.9c2-4.3 3.7-8.8 5.3-13.2c3.6-10.4 6-21.1 7.2-32H48.9c1.2 10.9 3.6 21.6 7.2 32z"]
};
var faCarriageBaby = faBabyCarriage;
var faFaceExpressionless = {
  prefix: 'far',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 72H352c13.3 0 24 10.7 24 24s-10.7 24-24 24H160c-13.3 0-24-10.7-24-24s10.7-24 24-24zM128 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faDownToDottedLine = {
  prefix: 'far',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", "M114.2 224L224 334 333.8 224 280 224c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 384c-11.5 0-22.5-4.6-30.6-12.7L77.6 255.2C68.9 246.5 64 234.7 64 222.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0z"]
};
var faCloudMusic = {
  prefix: 'far',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM416 184c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V275.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V216 184z"]
};
var faTrafficLight = {
  prefix: 'far',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M64 48c-8.8 0-16 7.2-16 16V352c0 61.9 50.1 112 112 112s112-50.1 112-112V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V352c0 88.4-71.6 160-160 160S0 440.4 0 352V64zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-168a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-72a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
var faCloudMinus = {
  prefix: 'far',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faThermometer = {
  prefix: 'far',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M369.8 64.2c10.3-10.4 24.4-16.2 39-16.2c30.5 0 55.2 24.7 55.2 55.2c0 14.6-5.8 28.7-16.2 39L224.4 365.7c-1.5 1.5-3.5 2.3-5.7 2.3H144V293.3c0-2.1 .8-4.2 2.3-5.7l27.3-27.3 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 45.5-45.5zM96 293.3v88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l89-89h88.8c14.9 0 29.1-5.9 39.6-16.4L481.8 176.2c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2L112.4 253.7C101.9 264.2 96 278.4 96 293.3z"]
};
var faShieldMinus = {
  prefix: 'far',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faVrCardboard = {
  prefix: 'far',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M560 112H80c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32H190.6c12.1 0 23.2-6.8 28.6-17.7l34.7-69.5C266.4 287.8 292 272 320 272s53.6 15.8 66.1 40.8l34.7 69.5c5.4 10.8 16.5 17.7 28.6 17.7H560c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM80 64H560c44.2 0 80 35.8 80 80V368c0 44.2-35.8 80-80 80H449.4c-30.3 0-58-17.1-71.6-44.2l-34.7-69.5c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-34.7 69.5c-13.6 27.1-41.3 44.2-71.6 44.2H80c-44.2 0-80-35.8-80-80V144C0 99.8 35.8 64 80 64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCarTilt = {
  prefix: 'far',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", "M142.2 101.6L307.3 57.4c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6L107.5 205.6l5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zM64.8 133.7l-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1L60 416.5l6.2 23.3L72.7 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H120.5l-9.7-36.1 1.7-.5L495.8 324.7l1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1 0 0L529.8 266l-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7L390.4 46.4C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5l290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1L100.2 381.1 81.7 311.9c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0 -59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0 -15.9-59.5 30.8 30.8 0 1 0 15.9 59.5z"]
};
var faGaugeCircleMinus = {
  prefix: 'far',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24V301.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 208a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16z"]
};
var faBrightnessLow = {
  prefix: 'far',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", "M288 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faHandMiddleFinger = {
  prefix: 'far',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M224 0c-35.3 0-64 28.7-64 64V184.5c-2.6-.3-5.3-.5-8-.5c-35.3 0-64 28.7-64 64v10.8c-2.4 1.9-4.7 3.9-6.9 5.9L60.8 283.2C42.5 299.9 32 323.5 32 348.3v10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7H312c66.3 0 120-53.7 120-120v-8V288c0-35.3-28.7-64-64-64c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zM208 64c0-8.8 7.2-16 16-16s16 7.2 16 16V232c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16v8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16v96 8c0 39.8-32.2 72-72 72H186.6c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C99.6 429.7 80 395.5 80 358.5V348.3c0-11.3 4.8-22 13.1-29.6l10.9-9.9V344c0 8.8 7.2 16 16 16s16-7.2 16-16V271v-7V248c0-8.8 7.2-16 16-16c5.2 0 9.9 2.5 12.8 6.4c6.2 8.3 17 11.6 26.8 8.3s16.4-12.4 16.4-22.8V64z"]
};
var faPercent = {
  prefix: 'far',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M369 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L369 113zM112 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faPercentage = faPercent;
var faTruckMoving = {
  prefix: 'far',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M72 80c-13.3 0-24 10.7-24 24V326.7c9.8-4.3 20.6-6.7 32-6.7c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32H432V104c0-13.3-10.7-24-24-24H72zM208 480c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80V352 304 104C0 64.2 32.2 32 72 32H408c39.8 0 72 32.2 72 72v40h48.8c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3V272v16 80c0 17.7-14.3 32-32 32c0 44.2-35.8 80-80 80s-80-35.8-80-80h-8-8H288c0 44.2-35.8 80-80 80zM535 194.9c-1.5-1.9-3.8-2.9-6.2-2.9H480v64H585l-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faGlassWaterDroplet = {
  prefix: 'far',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512H276c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8H24zM73.5 319.2L50.2 48H333.8L310.5 319.2l-9.3 5.2c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 331.6 99 333.3 82.8 324.3l-9.3-5.2zm4.7 55c29 8.6 60.9 2.8 85.2-16.6c16.7-13.3 40.4-13.3 57 0c24.3 19.4 56.2 25.3 85.2 16.6l-5.9 67.9C298.8 454.5 288.4 464 276 464H108c-12.5 0-22.8-9.5-23.9-21.9l-5.9-67.9zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"]
};
var faConveyorBelt = {
  prefix: 'far',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M384 48h80V208H176V48h80v80c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 115.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V48zM128 48V208c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zM592 400c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64s28.7-64 64-64H528c35.3 0 64 28.7 64 64zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H112zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faLocationCheck = {
  prefix: 'far',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-79-23L177 297c-9.4 9.4-24.6 9.4-33.9 0L79 233c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faMapMarkerCheck = faLocationCheck;
var faCoinVertical = {
  prefix: 'far',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M204 413.5c-22.2 39.4-45.3 50.5-60 50.5s-37.8-11.1-60-50.5C62.7 375.6 48 320 48 256s14.7-119.6 36-157.5C106.2 59.1 129.3 48 144 48s37.8 11.1 60 50.5c21.3 37.9 36 93.5 36 157.5s-14.7 119.6-36 157.5zM0 256C0 397.4 64.5 512 144 512h48 64c70.7 0 128-114.6 128-256S326.7 0 256 0H192 144C64.5 0 0 114.6 0 256zm286.3 40c1.2-13 1.7-26.4 1.7-40s-.6-27-1.7-40h48c1.1 12.9 1.7 26.3 1.7 40s-.6 27.1-1.7 40h-48zm-4 32h48.1c-3.9 23.7-9.6 45.3-16.6 64H266c7-19.7 12.5-41.2 16.2-64zM228 464c9.1-11.6 17.4-25 24.7-40h46.5c-18.9 33.8-36.3 40-43.1 40H228zM330.3 184H282.2c-3.8-22.8-9.2-44.3-16.2-64h47.7c7 18.7 12.7 40.3 16.6 64zM299.1 88H252.7C245.3 73 237 59.6 228 48h28c6.8 0 24.2 6.2 43.1 40zM120 256c0-40.2 5.2-75.7 12.9-100.3c3.7-11.8 7.7-19.9 11.1-24.7c3.4 4.8 7.3 12.9 11.1 24.7c7.8 24.6 12.9 60 12.9 100.3s-5.2 75.7-12.9 100.3c-3.7 11.8-7.7 19.9-11.1 24.7c-3.4-4.8-7.3-12.9-11.1-24.7c-7.8-24.6-12.9-60-12.9-100.3zm27.4-128.8a.2 .2 0 1 0 .1 .4 .2 .2 0 1 0 -.1-.4zm-6.6 .1a.2 .2 0 1 0 -.5 .1 .2 .2 0 1 0 .5-.1zm-.2 257.4a.2 .2 0 1 0 -.1-.4 .2 .2 0 1 0 .1 .4zm6.6-.1a.2 .2 0 1 0 .5-.1 .2 .2 0 1 0 -.5 .1zM144 80c-17.7 0-30.3 11.3-37.9 21.6c-8 10.7-14.2 24.6-18.9 39.7C77.6 171.7 72 212.3 72 256s5.6 84.3 15.2 114.7c4.8 15.1 10.9 29 18.9 39.7c7.7 10.3 20.2 21.6 37.9 21.6s30.3-11.3 37.9-21.6c8-10.7 14.2-24.6 18.9-39.7c9.6-30.4 15.2-71 15.2-114.7s-5.6-84.3-15.2-114.7c-4.8-15.1-10.9-29-18.9-39.7C174.3 91.3 161.7 80 144 80z"]
};
var faDisplay = {
  prefix: 'far',
  iconName: 'display',
  icon: [576, 512, [], "e163", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM211.7 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48zm48.7 0l-8 48h71.3l-8-48H260.3z"]
};
var faPersonSign = {
  prefix: 'far',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7L316.5 226l-19.3-7.2c-12.1-4.6-22.8-12.3-30.9-22.4L238 161c-16.7-20.9-42-33-68.7-33H129.6c-34.8 0-66.3 20.5-80.4 52.3L2.1 286.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2L80 229.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352h52.2l27.1 59.6c.5 1 .7 2.2 .7 3.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.9c0-8-1.7-15.9-5-23.2l-35-77V210.4l12.7 15.9c13.5 16.9 31.3 29.8 51.6 37.4l19.7 7.4-11 30.3c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM334.8 60l120.3 43.8L433.2 164 312.9 120.2 334.8 60zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 80H168V304H128V176c.5 0 1.1 0 1.6 0z"]
};
var faFaceSmile = {
  prefix: 'far',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSmile = faFaceSmile;
var faPhoneHangup = {
  prefix: 'far',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M320 144C193.1 144 98.7 205.9 53.3 250.2c-4.6 4.5-6.6 12.9-2.1 21.8l36.1 71.5c1.6 3.2 5.2 4.9 8.7 4.2l102.4-20.3c3.7-.7 6.4-4 6.4-7.8V248.5c0-10.4 6.6-19.5 16.5-22.8l3.4-1.1c61.9-20.4 128.7-20.4 190.7 0l3.4 1.1c9.8 3.2 16.5 12.4 16.5 22.8v71.1c0 3.8 2.7 7.1 6.4 7.8L544 347.7c3.5 .7 7.1-1 8.7-4.2L588.8 272c4.5-8.9 2.6-17.3-2.1-21.8C541.3 205.9 446.9 144 320 144zM19.8 215.8C71.5 165.4 177.4 96 320 96s248.5 69.4 300.2 119.8c22 21.5 23.8 53.4 11.4 77.8l-36.1 71.5c-11.3 22.4-36.2 34.6-60.9 29.7L432.3 374.5c-26.2-5.2-45.1-28.2-45.1-54.9V266.2c-44-12-90.4-12-134.4 0v53.4c0 26.7-18.9 49.7-45.1 54.9L105.3 394.8c-24.7 4.9-49.6-7.3-60.9-29.7L8.3 293.6C-4 269.2-2.3 237.3 19.8 215.8z"]
};
var faSignatureSlash = {
  prefix: 'far',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8l-61.2-48H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H450.1l28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4V128c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM178 114.2C183.9 94.4 202.3 80 224 80c26.5 0 48 21.5 48 48v7.9c0 16.7-.9 33.4-2.6 50L178 114.2zM343.5 243.9l73.7-22.8-22.5 63-51.2-40.2zM345.2 368H304.1c-7 16.3-14.8 32.4-23.3 48H406.2l-60.9-48zM158 251.1c-36.9 11.4-62 45.5-62 84.1V410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c18.5-30.8 33.8-63.3 45.7-97l-40-31.6c-11.5 36.3-27.2 71.2-46.8 103.9l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22V335.2c0-17.5 11.4-33 28.2-38.2l59.5-18.4-45.8-36.1L158 251.1zM64 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.2c-.1-2-.2-4-.2-6V368z"]
};
var faThumbtack = {
  prefix: 'far',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M134.6 51.7L123.8 192.6c-1.1 14.6-8.8 27.8-20.9 36C79 244.8 61.1 269.4 53.8 298.9L52.5 304H168V216c0-13.3 10.7-24 24-24s24 10.7 24 24v88H331.5l-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2c-12.1-8.2-19.8-21.5-20.9-36L249.4 51.7c-.1-1.2-.1-2.5-.1-3.7H134.8c0 1.2 0 2.5-.1 3.7zM168 352H32c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48H56c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24C32 10.7 42.7 0 56 0H86.8 297.2 328c13.3 0 24 10.7 24 24c0 8.8-4.8 16.5-11.8 20.7c-3.6 2.1-7.7 3.3-12.2 3.3H297.2l3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3H216V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352z"]
};
var faThumbTack = faThumbtack;
var faWheatSlash = {
  prefix: 'far',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-174-136.4c3.6-2.8 7.1-5.9 10.5-9.3l16.9-16.9c8.5-8.5 9.3-21.7 2.4-31.1c21.9-3.8 42.9-14.2 59.8-31.1l16.9-16.9c9.4-9.4 9.4-24.6 0-33.9l-16.9-16.9c-11.6-11.6-24.8-20.4-38.9-26.7C546.8 140.9 576 105.9 576 64V24c0-13.3-10.7-24-24-24H512c-41.9 0-76.9 29.3-85.8 68.5C420 54.3 411 41 399.4 29.4L382.5 12.4c-9.4-9.4-24.6-9.4-33.9 0L331.6 29.4c-16.9 16.9-27.3 37.9-31.1 59.8c-9.4-6.9-22.6-6.1-31.1 2.4l-16.9 16.9c-12.5 12.5-21.5 27.3-26.8 43L38.8 5.1zM267.7 184.5c.8-15.3 7-30.3 18.6-42c19.9 20 27.1 47.8 21.6 73.5l-40.2-31.5zM372 266.3c22-1.3 44.5 6.4 61.3 23.3c-5 4.9-10.5 8.9-16.4 11.9L372 266.3zM173.3 346.1l11.3 11.3 0 0L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L218.5 391.4l11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l.5-.5-38.1-30c-25.1 21.5-63 20.4-86.8-3.4l-10.1-10.2c20.1-13.3 44.8-16.6 67.2-9.8l-90.2-71.1c.1 15.6-4.3 31.2-13.2 44.7l-10.1-10.1c-17.6-17.6-22.8-43-15.6-65.2l-39.1-30.8c-21.4 42.1-14.5 94.8 20.7 129.9zM512 48h16V64c0 22.1-17.9 40-40 40H472V88c0-22.1 17.9-40 40-40zM365.5 153.8c-25-25-25-65.5 0-90.5c27.3 27.4 30.7 69.6 10.2 100.6l-10.1-10.1zm147 56.5c-25 25-65.5 25-90.5 0l-10.1-10.1c31-20.5 73.3-17.2 100.6 10.2z"]
};
var faTrophy = {
  prefix: 'far',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M248.8 309.7c-27.6-30.3-65.5-101-71.8-261.7H399.1c-6.4 160.7-44.3 231.4-71.8 261.7c-13.7 15.1-25.9 21.4-33.1 24.1c-2.6 1-4.7 1.5-6.1 1.9c-1.4-.3-3.5-.9-6.1-1.9c-7.2-2.7-19.4-9-33.1-24.1zM400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88C0 196.5 45.9 265.7 101.5 308.6c53.9 41.7 115.7 57.6 149.5 63.7c4.7 2.5 9.1 4.5 13.1 6.1V464H184c-13.3 0-24 10.7-24 24s10.7 24 24 24H288 392c13.3 0 24-10.7 24-24s-10.7-24-24-24H312V378.4c4-1.6 8.4-3.6 13.1-6.1c33.8-6 95.5-22 149.5-63.7C530.1 265.7 576 196.5 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm42.7 112h84.4c-6 78.4-41.3 127.3-81.9 158.6c-17.5 13.6-36.3 24-54.4 32c22.7-40.3 42.8-100.5 51.9-190.6zM185.2 302.6c-18.1-8-36.8-18.4-54.4-32C90.2 239.3 54.9 190.4 48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6z"]
};
var faCloudsSun = {
  prefix: 'far',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9C276.8 132.7 244.8 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm409.8 32.1h12.4c.6 0 1.2 0 1.8 0c13.2 0 24-10.7 24-24s-10.7-24-24-24c-1.1 0-2.2 .1-3.2 .2c-25.1 3.3-48.5-13.5-53.4-38.4c-2.9-14.7-15.9-25.8-31.4-25.8c-13.6 0-25.3 8.5-29.9 20.6c-9.2 24.3-36.2 36.9-60.8 28.2c-1.6-.6-3.4-.9-5.3-.9c-8.8 0-15.9 7.1-16 15.9l-.1 0c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9c-9.5-17.7-23.6-32.5-40.8-42.9zM320.1 320c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0H557.8c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1V346.3c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9v-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3v5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7v6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0h-266c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"]
};
var faPersonPraying = {
  prefix: 'far',
  iconName: 'person-praying',
  icon: [448, 512, [128720, "pray"], "f683", "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM202.1 192c5.3 0 10.2 2.7 12.9 7.2l4.3 7.1L152.2 367.5l-9.4-6c-9.8-6.3-13.7-18.7-9.2-29.4l54.5-130.7c2.4-5.7 7.9-9.3 14-9.3zm48.3 64.7l7.4 12.1c12.8 20.9 41.2 25.4 59.9 9.6l89.8-76c10.1-8.6 11.4-23.7 2.8-33.8s-23.7-11.4-33.8-2.8l-82.7 70-37.9-61.6C244.4 155.4 224 144 202.1 144c-25.5 0-48.5 15.3-58.3 38.9L89.3 313.6c-13.4 32.3-1.8 69.5 27.6 88.3L214 464H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H296c10.7 0 20-7 23-17.3s-1.1-21.2-10.1-27l-115.7-74 57.1-137.1z"]
};
var faPray = faPersonPraying;
var faHammer = {
  prefix: 'far',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", "M432.8 204.9c-9.1-9.1-21.5-14.2-34.4-14.1c-11.3 .1-22.4-4.1-31-12.7L329.3 140c-5.9-5.9-9.3-14-9.3-22.4V105.5c0-17.6-9.6-33.7-25-42.1L273.3 51.5c8.4-2.3 17.1-3.5 25.8-3.5h18.1c24.5 0 48 9.3 65.8 26.1l44.6 42c9.7 9.1 14.3 21.7 13.5 34.1c-.8 13.7 4.3 27.1 14 36.8l37 37L472 244.1l-39.2-39.2zM216.7 75.3l.3 .2 55 30v12.1c0 21.1 8.4 41.4 23.3 56.3l38.1 38.1c18.1 18.1 41.8 26.9 65.4 26.7l39.2 39.2 1 1-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L569 217c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-8 8-1-1-37-37c1.6-26.1-8-52.7-28.5-72l-44.6-42C389.2 14 353.9 0 317.2 0H299.2C279 0 259.1 4.2 240.7 12.4L219.1 22l-.3 .1-6.2 2.8-19.1 8.5c-5.6 2.5-9.2 7.9-9.5 14s3 11.8 8.3 14.7l18.4 10 6 3.3zm44.2 107.3L27.4 377.1C10.1 391.6 0 413.1 0 435.7C0 477.8 34.1 512 76.3 512c22.6 0 44.1-10.1 58.6-27.4L330 250.4c-6.8-4.5-13.2-9.7-19.2-15.7l-38.1-38.1c-4.3-4.3-8.3-9-11.8-14z"]
};
var faFaceVomit = {
  prefix: 'far',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M496 256c0 63.4-28.3 120.1-73 158.3c5.8 9.5 14.8 17 25.9 20.7l16.7 5.6C513.9 393.9 544 328.5 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.1-3.7 20.1-11.1 25.9-20.7C108.3 376.1 80 319.4 80 256C80 141.1 173.1 48 288 48s208 93.1 208 208zM148 157.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm544-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 396.1V337.8c10.8 4.3 18.7 8.5 23.1 11.5c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2C406.3 310.3 355.2 288 288 288s-118.3 22.3-136.9 34.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4c4.4-3 12.3-7.2 23.1-11.5v58.3c0 31-19.8 58.5-49.2 68.3l-34.1 11.4c-7.6 2.5-12.7 9.6-12.7 17.6c0 10.3 8.3 18.6 18.6 18.6H461.4c10.3 0 18.6-8.3 18.6-18.6c0-8-5.1-15.1-12.7-17.6l-34.1-11.4c-29.4-9.8-49.2-37.3-49.2-68.3zM304 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faSpeakers = {
  prefix: 'far',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", "M264.4 0c-11.8 13.2-20.1 29.7-23.1 48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H241.3c3.1 18.3 11.3 34.8 23.1 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H264.4zM224 232v56.8c-10.2-10.4-24.3-16.8-40-16.8c-30.9 0-56 25.1-56 56s25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V424c-12.3 5.1-25.8 8-40 8c-57.4 0-104-46.6-104-104s46.6-104 104-104c14.2 0 27.7 2.8 40 8zM184 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM336 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H336zM272 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336c-35.3 0-64-28.7-64-64V64zM456 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM352 328a104 104 0 1 1 208 0 104 104 0 1 1 -208 0zm104 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faTtyAnswer = {
  prefix: 'far',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.2-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64v0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM304 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM288 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V176zM400 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V80zM592 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H592c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM576 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H592c-8.8 0-16-7.2-16-16V176zM400 160H528c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16z"]
};
var faTeletypeAnswer = faTtyAnswer;
var faMugTeaSaucer = {
  prefix: 'far',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", "M144 288c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V80H248V90.7c0 8.5 3.4 16.6 9.4 22.6l21.3 21.3c6 6 9.4 14.1 9.4 22.6V224c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V157.3c0-8.5 3.4-16.6 9.4-22.6l21.3-21.3c6-6 9.4-14.1 9.4-22.6V80H144V288zM96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 240h32c44.2 0 80-35.8 80-80s-35.8-80-80-80H480V240zM24 432H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faDiagramLeanCanvas = {
  prefix: 'far',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", "M512 80V296h80V96c0-8.8-7.2-16-16-16H512zm-48 0H400v88h64V80zM352 80H288V296h64V80zM240 80H176v88h64V80zM128 80H64c-8.8 0-16 7.2-16 16V296h80V80zM48 344v72c0 8.8 7.2 16 16 16H296V344H48zm296 88H576c8.8 0 16-7.2 16-16V344H344v88zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM240 296V216H176v80h64zm224-80H400v80h64V216z"]
};
var faAlt = {
  prefix: 'far',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M467.9 120.4c4.6-5.3 11.2-8.4 18.2-8.4H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H486.1c-21 0-41 9.2-54.7 25.1L172.1 391.6c-4.6 5.3-11.2 8.4-18.2 8.4H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H153.9c21 0 41-9.2 54.7-25.1L467.9 120.4zM440 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H440z"]
};
var faDial = {
  prefix: 'far',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM208.8 208.8c37.9-37.9 96.2-43 139.6-15.1L271 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l77.4-77.4c27.8 43.4 22.8 101.7-15.1 139.6c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4zm192.3-33.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDialMedHigh = faDial;
var faHandPeace = {
  prefix: 'far',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V272 256 224c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192v48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2h-7.4l-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240H144c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120H232c-66.3 0-120-53.7-120-120l0-24 0 0c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16z"]
};
var faCircleTrash = {
  prefix: 'far',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 128h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7L310.6 128H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H352L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3H205.4c-16.6 0-30.5-12.8-31.9-29.3L160 192z"]
};
var faTrashCircle = faCircleTrash;
var faRotate = {
  prefix: 'far',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l4.1 4.1-35.7 35.7c-6.6 6.6-10.3 15.6-10.3 25c0 19.5 15.8 35.3 35.3 35.3H472c13.3 0 24-10.7 24-24V83.3C496 63.8 480.2 48 460.7 48c-9.4 0-18.3 3.7-25 10.3L400 94.1l-4.1-4.1C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9l-4.1-4.1 35.7-35.7c6.6-6.6 10.3-15.6 10.3-25c0-19.5-15.8-35.3-35.3-35.3H40c-13.3 0-24 10.7-24 24V428.7C16 448.2 31.8 464 51.3 464c9.4 0 18.3-3.7 25-10.3L112 417.9l4.1 4.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9zM448 176H385.9L448 113.9V176zM64 336h62.1L64 398.1V336z"]
};
var faSyncAlt = faRotate;
var faCircleQuarters = {
  prefix: 'far',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M108.9 403.1L256 256 403.1 403.1C440.7 365.4 464 313.4 464 256s-23.3-109.4-60.9-147.1L256 256 108.9 108.9C71.3 146.6 48 198.6 48 256s23.3 109.4 60.9 147.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSpinner = {
  prefix: 'far',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M288 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM448 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM75 437a32 32 0 1 0 45.3-45.3A32 32 0 1 0 75 437zm316.8 0A32 32 0 1 0 437 391.8 32 32 0 1 0 391.8 437zM75 75a32 32 0 1 0 45.3 45.3A32 32 0 1 0 75 75z"]
};
var faTowerControl = {
  prefix: 'far',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", "M160 24c0-13.3 10.7-24 24-24h40 40c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V96h40c17.7 0 32 14.3 32 32h93.2c21.4 0 36.8 20.7 30.6 41.2L402.7 306.5c7.9 3.9 13.3 12.1 13.3 21.5c0 13.3-10.7 24-24 24H368V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352l-192 0V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H56c-13.3 0-24-10.7-24-24c0-9.4 5.4-17.6 13.3-21.5L4.1 169.2C-2.1 148.7 13.3 128 34.8 128H128c0-17.7 14.3-32 32-32h40V48H184c-13.3 0-24-10.7-24-24zM94.7 304H128V176H56.3L94.7 304zm81.3 0l96 0V176H176V304zM320 176V304h33.3l38.4-128H320z"]
};
var faArrowUpTriangleSquare = {
  prefix: 'far',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", "M416 32c9.9 0 19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9L391.8 45.7C396.9 37.2 406.1 32 416 32zM368 432h96V336H368v96zM416 98.6L369.6 176h92.8L416 98.6zM320 432V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z"]
};
var faSortShapesUp = faArrowUpTriangleSquare;
var faWhale = {
  prefix: 'far',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L79.2 176.8 43.6 212.4C15.7 240.3 0 278.2 0 317.6C0 407.3 72.7 480 162.4 480H544c53 0 96-43 96-96V275.7C640 194.1 573.9 128 492.3 128c-80.5 0-158.6 27.4-221.4 77.7L139 311.2c-7.1 5.7-15.9 8.8-25 8.8h-1c-19 0-35.2-13.7-38.4-32.5c-1.7-9.9 .6-20.1 6.3-28.4l35.4-51.4 9.1-13.2 47.6 7.9c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4zM50.5 341.5C66.4 358 88.7 368 113 368h1c20 0 39.4-6.8 55-19.3L300.9 243.1C355.2 199.7 422.7 176 492.3 176c55 0 99.7 44.6 99.7 99.7V384c0 26.5-21.5 48-48 48H162.4c-55 0-100.9-38.8-111.9-90.5zM392 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faRobot = {
  prefix: 'far',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M320 0c13.3 0 24 10.7 24 24V96H448c53 0 96 43 96 96V416c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96H296V24c0-13.3 10.7-24 24-24zM192 144c-26.5 0-48 21.5-48 48V416c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V192c0-26.5-21.5-48-48-48H320 192zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16zM208 384h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16zM200 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm200-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faPeace = {
  prefix: 'far',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M232 462.6v-156L111.3 405.4c32 31 74 51.9 120.7 57.2zM80.9 368.3L232 244.6V49.4C128.4 61.3 48 149.2 48 256c0 41.4 12.1 79.9 32.9 112.3zm319.8 37.1L280 306.6v156c46.7-5.4 88.7-26.2 120.7-57.2zm30.4-37.1C451.9 335.9 464 297.4 464 256c0-106.8-80.4-194.7-184-206.6V244.6L431.1 368.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPartyHorn = {
  prefix: 'far',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7 .1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM59.3 452.7l86.9-32.6L91.9 365.8 59.3 452.7zm200.1-75l-125-125-23.9 63.8 85.1 85.1 63.8-23.9zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4L310.9 361.3c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18 519.4-7.4 494 2 468.8L98.1 212.6z"]
};
var faGears = {
  prefix: 'far',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M147.1 52.7l-6.5 23.5c-1.7 6.2-6.3 11.2-12.4 13.5c-10 3.7-19.1 9-27.2 15.7c-5 4.1-11.6 5.6-17.9 4l-23.6-6.2c-5 6.9-9.4 14.4-12.9 22.3l17.1 17.4c4.5 4.6 6.6 11.1 5.5 17.4c-.9 5.1-1.3 10.3-1.3 15.7s.5 10.6 1.3 15.7c1.1 6.4-.9 12.9-5.5 17.4L46.7 226.5c3.5 7.9 7.9 15.4 12.9 22.3l23.6-6.2c6.3-1.6 12.9-.1 17.9 4c8 6.7 17.2 12 27.2 15.7c6.1 2.2 10.7 7.2 12.4 13.5l6.5 23.5c4.2 .4 8.5 .7 12.9 .7s8.7-.2 12.9-.7l6.5-23.5c1.7-6.2 6.3-11.2 12.4-13.5c10-3.7 19.1-9 27.2-15.7c5-4.1 11.6-5.6 17.9-4l23.6 6.2c5-6.9 9.4-14.4 12.9-22.3l-17.1-17.4c-4.5-4.6-6.6-11.1-5.5-17.4c.9-5.1 1.3-10.3 1.3-15.7s-.5-10.6-1.3-15.7c-1.1-6.4 .9-12.9 5.5-17.4l17.1-17.4c-3.5-7.9-7.9-15.4-12.9-22.3l-23.6 6.2c-6.3 1.6-12.9 .1-17.9-4c-8-6.7-17.2-12-27.2-15.7c-6.1-2.2-10.7-7.2-12.4-13.5l-6.5-23.5c-4.2-.4-8.5-.7-12.9-.7s-8.7 .2-12.9 .7zM127.3 15.3C137.9 13.1 148.8 12 160 12s22.1 1.1 32.7 3.3c7.4 1.5 13.3 7 15.3 14.3l7.3 26.6c7.3 3.4 14.3 7.4 20.8 12l26.6-7c7.3-1.9 15 .4 20 6.1c14.4 16.3 25.7 35.5 32.8 56.7c2.4 7.1 .6 15-4.7 20.4L291.5 164c.4 4 .5 8 .5 12s-.2 8-.5 12l19.4 19.6c5.3 5.4 7.1 13.2 4.7 20.4c-7.1 21.2-18.3 40.4-32.8 56.7c-5 5.6-12.7 8-20 6.1l-26.6-7c-6.5 4.6-13.5 8.6-20.8 12L208 322.4c-2 7.3-7.9 12.8-15.3 14.3c-10.6 2.1-21.5 3.3-32.7 3.3s-22.1-1.1-32.7-3.3c-7.4-1.5-13.3-7-15.3-14.3l-7.3-26.6c-7.3-3.4-14.3-7.4-20.8-12l-26.6 7c-7.3 1.9-15-.4-20-6.1C22.8 268.4 11.5 249.2 4.4 228c-2.4-7.1-.6-15 4.7-20.4L28.5 188c-.4-4-.5-8-.5-12s.2-8 .5-12L9.2 144.4C3.9 139 2 131.1 4.4 124c7.1-21.2 18.3-40.4 32.8-56.7c5-5.6 12.7-8 20-6.1l26.6 7c6.5-4.6 13.5-8.6 20.8-12L112 29.6c2-7.3 7.9-12.8 15.3-14.3zM120 176a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM340.7 364.9l23.5 6.5c6.2 1.7 11.2 6.3 13.5 12.4c3.7 10 9 19.1 15.7 27.2c4.1 5 5.6 11.6 4 17.9l-6.2 23.6c6.9 5 14.4 9.4 22.3 12.9l17.4-17.1c4.6-4.5 11.1-6.6 17.4-5.5c5.1 .9 10.3 1.3 15.7 1.3s10.6-.5 15.7-1.3c6.4-1.1 12.9 .9 17.4 5.5l17.4 17.1c7.9-3.5 15.4-7.9 22.3-12.9l-6.2-23.6c-1.6-6.2-.1-12.9 4-17.9c6.7-8 12-17.2 15.7-27.2c2.2-6.1 7.2-10.7 13.5-12.4l23.5-6.5c.4-4.2 .7-8.5 .7-12.9s-.2-8.7-.7-12.9l-23.5-6.5c-6.2-1.7-11.2-6.3-13.5-12.4c-3.7-10-9-19.1-15.7-27.2c-4.1-5-5.6-11.6-4-17.9l6.2-23.6c-6.9-5-14.4-9.4-22.3-12.9l-17.4 17.1c-4.6 4.5-11.1 6.6-17.4 5.5c-5.1-.9-10.3-1.3-15.7-1.3s-10.6 .5-15.7 1.3c-6.4 1.1-12.9-.9-17.4-5.5l-17.4-17.1c-7.9 3.5-15.4 7.9-22.3 12.9l6.2 23.6c1.6 6.3 .1 12.9-4 17.9c-6.7 8-12 17.2-15.7 27.2c-2.2 6.1-7.2 10.7-13.5 12.4l-23.5 6.5c-.4 4.2-.7 8.5-.7 12.9s.2 8.7 .7 12.9zm-37.4 19.8c-2.1-10.6-3.3-21.5-3.3-32.7s1.1-22.1 3.3-32.7c1.5-7.4 7-13.3 14.3-15.3l26.6-7.3c3.4-7.3 7.4-14.3 12-20.8l-7-26.6c-1.9-7.3 .4-15 6.1-20c16.3-14.4 35.5-25.7 56.7-32.8c7.1-2.4 15-.6 20.4 4.7L452 220.5c4-.4 8-.5 12-.5s8 .2 12 .5l19.6-19.4c5.4-5.3 13.2-7.1 20.4-4.7c21.2 7.1 40.4 18.3 56.7 32.8c5.6 5 8 12.7 6.1 20l-7 26.6c4.6 6.5 8.6 13.5 12 20.8l26.6 7.3c7.3 2 12.8 7.9 14.3 15.3c2.1 10.6 3.3 21.5 3.3 32.7s-1.1 22.1-3.3 32.7c-1.5 7.4-7 13.3-14.3 15.3l-26.6 7.3c-3.4 7.3-7.4 14.3-12 20.8l7 26.6c1.9 7.3-.5 15-6.1 20c-16.3 14.4-35.5 25.7-56.7 32.8c-7.1 2.4-15 .6-20.4-4.7L476 483.5c-4 .4-8 .5-12 .5s-8-.2-12-.5l-19.6 19.4c-5.4 5.3-13.2 7.1-20.4 4.7c-21.2-7.1-40.4-18.3-56.7-32.8c-5.6-5-8-12.7-6.1-20l7-26.6c-4.6-6.5-8.6-13.5-12-20.8L317.6 400c-7.3-2-12.8-7.9-14.3-15.3zM464 392a40 40 0 1 1 0-80 40 40 0 1 1 0 80z"]
};
var faCogs = faGears;
var faSunBright = {
  prefix: 'far',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M280 24V88c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm157 84.9l-45.3 45.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L403.1 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM108.9 75l45.3 45.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L75 108.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM24 232H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm400 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H424c-13.3 0-24-10.7-24-24s10.7-24 24-24zM154.2 391.8L108.9 437c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l45.3-45.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm237.6-33.9L437 403.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.3-45.3c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM280 424v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V424c0-13.3 10.7-24 24-24s24 10.7 24 24zm40-168a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z"]
};
var faSunAlt = faSunBright;
var faWarehouse = {
  prefix: 'far',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V176.3c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 328v48H496V328H144zm0 136H496V424H144v40zm-23.7 48c-.1 0-.2 0-.3 0c-13.3 0-24-10.7-24-24V232c0-22.1 17.9-40 40-40H504c22.1 0 40 17.9 40 40V488c0 13.3-10.7 24-24 24c-.1 0-.2 0-.3 0H120.3zM144 280H496V240H144v40z"]
};
var faConveyorBeltArm = {
  prefix: 'far',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M152 0H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H259l-4.5 26.9c6 5 10.8 11.4 13.9 18.8l198.8 26.5c13.1 1.8 22.4 13.8 20.6 27c-.8 5.9-3.7 11-7.8 14.7V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V166.1L262 141.3c-8.8 11.4-22.6 18.7-38 18.7c-26.5 0-48-21.5-48-48c0-20.6 13-38.1 31.2-45l3.2-19H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24h16c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-56.4 41.7-103.1 96-110.9V264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24h64V264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24h64V264zM112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64H528c35.3 0 64-28.7 64-64s-28.7-64-64-64H488 440 328 280 168 120h-8zm16 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLockKeyholeOpen = {
  prefix: 'far',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M432 48c-44.2 0-80 35.8-80 80v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H304V128C304 57.3 361.3 0 432 0s128 57.3 128 128v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V128c0-44.2-35.8-80-80-80zM384 240H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16zM256 376H192c-13.3 0-24-10.7-24-24s10.7-24 24-24h64c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faLockOpenAlt = faLockKeyholeOpen;
var faSquareFragile = {
  prefix: 'far',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 38.3c0-12.3 10-22.3 22.3-22.3H176l32 64-32 32 80 64-32-64 48-32-32-64h57.7c12.3 0 22.3 10 22.3 22.3V224c0 47.6-34.6 87.1-80 94.7V368h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V318.7c-45.4-7.6-80-47.1-80-94.7V134.3z"]
};
var faBoxFragile = faSquareFragile;
var faSquareWineGlassCrack = faSquareFragile;
var faArrowUpRightDots = {
  prefix: 'far',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M128 24c0 13.3 10.7 24 24 24h86.1L7 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l231-231V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSquareN = {
  prefix: 'far',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm154.3 40.5L288 294.5V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z"]
};
var faSplotch = {
  prefix: 'far',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M187.7 400.2L84.9 409.5c-11.2 1-20.9-7.8-20.9-19.1c0-4.2 1.3-8.2 3.8-11.5l18.8-25c16.7-22.3 25.4-49.5 24.8-77.3c-.5-23.1-7.5-45.7-20.2-65L50.6 149.7c-1.7-2.6-2.6-5.7-2.6-8.8c0-10.1 9.1-17.7 19-15.9l42.8 7.8c52.6 9.6 106.3-9.9 140.6-51l22.3-26.8c3.7-4.4 9.1-6.9 14.8-6.9c8.3 0 15.7 5.3 18.3 13.2l15 45.1c15.7 47.2 51.9 84.7 98.5 102.2l32.3 12.1c7.4 2.8 12.4 9.9 12.4 17.8c0 6-2.8 11.6-7.6 15.2l-62 46.5c-37.9 28.4-57.9 74.7-52.7 121.8l2.5 22.7c1.1 10.3-6.9 19.3-17.3 19.3c-3.9 0-7.8-1.3-10.9-3.8L279 430.5c-24.7-19.8-55.4-30.5-87-30.5c-1.5 0-2.9 .1-4.3 .2zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3c39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6c0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46c-20 0-38.9 8.9-51.7 24.2L213.5 51C190.3 78.8 154 92 118.4 85.5L75.6 77.7C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z"]
};
var faFaceGrinHearts = {
  prefix: 'far',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"]
};
var faGrinHearts = faFaceGrinHearts;
var faMeter = {
  prefix: 'far',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 152v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faMandolin = {
  prefix: 'far',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4l-81.8 22.3-50.6 50.6C324.6 305.1 317.5 512 176 512C78.8 512 0 433.2 0 336C0 194.5 206.9 187.4 287.9 190.1l50.6-50.6 22.3-81.9c1.6-5.8 5.3-10.8 10.4-14l64-40zm-246.8 286l51.5-51.5c-22.3 .8-47.1 2.8-71.6 7.1c-36.9 6.5-68.6 17.3-90.1 32.8C58.9 292.1 48 309.4 48 336c0 70.7 57.3 128 128 128c26.6 0 43.9-10.9 57.9-30.2c15.6-21.5 26.4-53.2 32.8-90.1c4.3-24.5 6.3-49.3 7.1-71.6l-51.5 51.5c1.1 4 1.6 8.1 1.6 12.4c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.3 0 8.5 .6 12.4 1.6z"]
};
var faDiceFour = {
  prefix: 'far',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSimCard = {
  prefix: 'far',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M48 64V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V154.5c0-4.2-1.7-8.3-4.7-11.3L240.8 52.7c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16zM0 448V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zM128 240h16v80H80V288c0-26.5 21.5-48 48-48zM80 384V352h80 48v80H128c-26.5 0-48-21.5-48-48zm176 48H240V352h64v32c0 26.5-21.5 48-48 48zm48-144v32H224 176V240h80c26.5 0 48 21.5 48 48z"]
};
var faTransgender = {
  prefix: 'far',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", "M128 24c0-13.3-10.7-24-24-24H24C10.7 0 0 10.7 0 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9L78.1 112l-7 7c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 15.2 15.2C107.6 187.7 96 220.5 96 256c0 80.2 59 146.6 136 158.2V432H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V414.2c77-11.6 136-78 136-158.2c0-35.5-11.6-68.3-31.2-94.9L464 81.9V104c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1l-79.2 79.2C324.3 107.6 291.5 96 256 96s-68.3 11.6-94.9 31.2L145.9 112l7-7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-7 7L81.9 48H104c13.3 0 24-10.7 24-24zM256 368c-61.9 0-112-50.1-112-112c0-29.8 11.7-56.9 30.7-77c.8-.6 1.6-1.3 2.3-2s1.4-1.5 2-2.3c20.1-19 47.2-30.7 77-30.7s56.9 11.7 77 30.7c.6 .8 1.3 1.6 2 2.3s1.5 1.4 2.3 2c19 20.1 30.7 47.2 30.7 77c0 61.9-50.1 112-112 112z"]
};
var faTransgenderAlt = faTransgender;
var faMercury = {
  prefix: 'far',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M73 5.3C83.3-3 98.4-1.4 106.7 9c18.5 23.1 51.4 38.9 84.9 39l.3 0 .3 0c33.5-.1 66.4-15.9 84.9-39C285.6-1.4 300.7-3 311 5.3s12 23.4 3.7 33.7c-9.9 12.4-22.2 23.1-36 31.8C332 101.1 368 158.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-65.7 36-122.9 89.3-153.2C91.5 62.1 79.2 51.4 69.3 39C61 28.7 62.6 13.6 73 5.3zM192 96l-.3 0C121.1 96.2 64 153.4 64 224c0 70.7 57.3 128 128 128s128-57.3 128-128c0-70.6-57.1-127.8-127.7-128l-.3 0z"]
};
var faUpFromBracket = {
  prefix: 'far',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M114.2 160L224 50 333.8 160H280c-13.3 0-24 10.7-24 24l0 120-64 0V184c0-13.3-10.7-24-24-24l-53.8 0zM224 0c-11.5 0-22.5 4.6-30.6 12.7L77.6 128.8C68.9 137.5 64 149.3 64 161.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0v96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96h33.6c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 12.7C246.5 4.6 235.5 0 224 0zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z"]
};
var faKnifeKitchen = {
  prefix: 'far',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M488 0c-9.4 0-18.3 3.7-25 10.3L284.6 188.7l11.3 11.3L400.3 304.4l31-17.2c15.2-8.5 24.7-24.5 24.7-42V213.3c0-4.2 1.7-8.3 4.7-11.3l97-97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L513 10.3C506.3 3.7 497.4 0 488 0zM432 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM4.7 468.7c-8.4 8.4-4.7 22.9 6.5 26.6C43.4 505.7 78.1 512 112 512c123.3 0 209.4-62.8 287.3-140.7c6.2-6.2 6.2-16.4 0-22.6l-23-23-33.9 33.9C275 422.2 205.5 464 112 464c-10.7 0-21.6-.8-32.6-2.2L262 279.3l33.9-33.9L262 211.4l-33.9 33.9L4.7 468.7z"]
};
var faBorderRight = {
  prefix: 'far',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M424 32c13.3 0 24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowTurnDown = {
  prefix: 'far',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M24 48C10.7 48 0 37.3 0 24S10.7 0 24 0L128 0c48.6 0 88 39.4 88 88l0 342.1 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L209 505c-9.4 9.4-24.6 9.4-33.9 0L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L168 88c0-22.1-17.9-40-40-40L24 48z"]
};
var faLevelDown = faArrowTurnDown;
var faSpade = {
  prefix: 'far',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M437.7 242.9l0 0L256.4 55 74.2 242.9l0 0c-37 38.4-34.9 102.3 6.7 138l0 0 .3 .2c32 27.9 86 25.1 120.8-10.2l19.7-20.7c9.2-9.7 22-15.1 35.4-14.9s26 5.9 35 15.8l18.3 20.2c34.3 34.4 87.3 38 121.7 9.5c40.6-35.7 42.6-99.6 5.7-138zM233.5 9.7c12-13 33-13 45.9 0L472.2 209.5c55.9 57.9 52.9 153.8-9 207.8c-50.7 42.6-122.8 39.2-173 .2c-3.5-2.7-6.9-5.6-10.2-8.7V464h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V408.7c-3.1 2.9-6.4 5.7-9.8 8.4c-50.4 39.4-123.4 43-172.5 .3c-62.9-53.9-65.9-149.8-10-207.8L233.5 9.7z"]
};
var faCardSpade = {
  prefix: 'far',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm175 77.2c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 59.7 59.7c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-3.2-3.2c-.3-.3-.6-.6-1-.9V336h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V298.6c-.3 .3-.7 .6-1 .9l-3.2 3.2c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l59.7-59.7L175 141.2z"]
};
var faLineColumns = {
  prefix: 'far',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", "M24 40H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 88 0 77.3 0 64S10.7 40 24 40zm0 128H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 320c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM24 424H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zM288 192c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24zM312 40H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24zM288 320c0-13.3 10.7-24 24-24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24zm24 104H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faArrowRightToLine = {
  prefix: 'far',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM312.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L235.5 232 152 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"]
};
var faArrowToRight = faArrowRightToLine;
var faPersonFallingBurst = {
  prefix: 'far',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", "M232 0c13.3 0 24 10.7 24 24l0 10.4c0 56.5-30.1 107.8-77.5 135.8L236.7 256l74.9 0c13.1 0 25.3 6.4 32.8 17.1l51.2 73.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L307.5 304l-49.6 0c-1.3 1.5-2.9 2.8-4.6 4l-53.9 36 84.8 131c7.2 11.1 4 26-7.1 33.2s-26 4-33.2-7.1L84.4 254.7C81.5 264.6 80 275 80 285.6L80 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V285.6c0-66.3 41.5-125.5 103.8-148.2c43.3-15.8 72.2-57 72.2-103.1V24c0-13.3 10.7-24 24-24zM173.3 303.6l26-17.3-64.8-95.5c-8.4 4.9-16.1 10.9-22.8 17.7l61.6 95.2zM0 80a48 48 0 1 1 96 0A48 48 0 1 1 0 80zM464 302.3l-33.3 24.5c-.7-1.2-1.5-2.3-2.3-3.4l-51.2-73.2c-15-21.4-39.4-34.1-65.5-34.1l-19.8 0c.5-6.2 3.4-12.1 8.2-16.3l48.6-42L323.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C447 12.9 455.1 8 464 8s17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9 48.6 42c6.7 5.8 9.7 14.8 7.7 23.5s-8.6 15.5-17.1 17.8l-62 16.7-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38zm0-219.1l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L464 83.2z"]
};
var faFlagPennant = {
  prefix: 'far',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v8V80 304v48V488c0 13.3 10.7 24 24 24s24-10.7 24-24V350.9L432.9 213.4c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4L48 33.1V24zm0 60.1L350.1 192 48 299.9V84.1z"]
};
var faPennant = faFlagPennant;
var faConveyorBeltEmpty = {
  prefix: 'far',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64H528c35.3 0 64-28.7 64-64s-28.7-64-64-64H112zM0 400c0-61.9 50.1-112 112-112H528c61.9 0 112 50.1 112 112s-50.1 112-112 112H112C50.1 512 0 461.9 0 400zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserGroupSimple = {
  prefix: 'far',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", "M104 136a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm160 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm216 88a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM128 336h64c44.2 0 80 35.8 80 80v16H48l0-16c0-44.2 35.8-80 80-80zm0-48C57.3 288 0 345.3 0 416v16c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V416c0-70.7-57.3-128-128-128H128zM448 480h64c70.7 0 128-57.3 128-128V336c0-26.5-21.5-48-48-48H368c-21.8 0-40.3 14.6-46.1 34.6C340.8 348.9 352 381.1 352 416v16c0 1.5 0 3-.1 4.5C375.3 463.2 409.7 480 448 480z"]
};
var faAward = {
  prefix: 'far',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM1.3 441.8l41.2-97.9 4.5 8.2c15.7 28.7 46.1 46.3 78.9 45.5l11.1-.3 9.5 5.8c8 4.9 16.7 8.4 25.6 10.5l-37.3 88.5c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.7c8.9-2.1 17.5-5.6 25.5-10.5l9.5-5.8 11.1 .3c32.7 .8 63.2-16.8 78.9-45.5l4.5-8.2 41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"]
};
var faTicketSimple = {
  prefix: 'far',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v60.1c0 10.2-6.4 19.2-16 22.6c-18.7 6.6-32 24.4-32 45.3s13.3 38.7 32 45.3c9.6 3.4 16 12.5 16 22.6V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V323.9c0-10.2 6.4-19.2 16-22.6c18.7-6.6 32-24.4 32-45.3s-13.3-38.7-32-45.3c-9.6-3.4-16-12.5-16-22.6V128zm64-16c-8.8 0-16 7.2-16 16v44.9c28.7 16.6 48 47.6 48 83.1s-19.3 66.6-48 83.1V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V339.1c-28.7-16.6-48-47.6-48-83.1s19.3-66.6 48-83.1V128c0-8.8-7.2-16-16-16H64z"]
};
var faTicketAlt = faTicketSimple;
var faBuilding = {
  prefix: 'far',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"]
};
var faAnglesLeft = {
  prefix: 'far',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM399 79L239 239c-9.4 9.4-9.4 24.6 0 33.9L399 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-143-143L433 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
var faAngleDoubleLeft = faAnglesLeft;
var faCamcorder = {
  prefix: 'far',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M96 120c0-22.1 17.9-40 40-40H296c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88 39.4-88 88v42c-27.6 7.1-48 32.2-48 62V416c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V399 241 224c0-35.3-28.7-64-64-64H96V120zM64 208H320c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zM520.3 460.5c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5v-209c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 226.4V279l112-50.4V411.4L416 361v52.6l104.3 46.9zM80 264c0 13.3 10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H104c-13.3 0-24 10.7-24 24z"]
};
var faVideoHandheld = faCamcorder;
var faPancakes = {
  prefix: 'far',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M256 192c0-17.7 14.3-31.9 32-32.6c108.6-4.4 192-31.1 192-63.4c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37C86.5 138.3 96 150.6 96 164.8V264c0 13.3 10.7 24 24 24s24-10.7 24-24V187.3c0-18.8 15.8-33.2 34.4-31.2c16 1.7 29.6 15 29.6 31V216c0 13.3 10.7 24 24 24s24-10.7 24-24V192zM192 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zM64 163.8c-12.1-4.7-23.1-10.1-32.3-16.3c-9.1-6.2-19.6-15.3-26-27.8C2 127.1 0 135.2 0 144c0 15.3 6 28.6 16.9 40C6 195.4 0 208.7 0 224s6 28.6 16.9 40C6 275.4 0 288.7 0 304s6 28.6 16.9 40C6 355.4 0 368.7 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-15.3-6-28.6-16.9-40C506 332.6 512 319.3 512 304s-6-28.6-16.9-40C506 252.6 512 239.3 512 224s-6-28.6-16.9-40C506 172.6 512 159.3 512 144c0-8.8-2-16.9-5.7-24.3c-6.3 12.4-16.9 21.6-26 27.8C465 157.7 445 165.8 423.2 172c-8.2 2.3-17 4.5-26.2 6.5c-29.9 7.1-67 11.5-109 12.9V216c0 8.4-1.9 16.5-5.2 23.6c68.3-1.9 128.5-11.1 170.1-28.6c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8l0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 264.8 324.4 272 256 272c-6.5 0-13-.1-19.3-.2c-1.6 .1-3.1 .2-4.7 .2c-2.7 0-5.3-.2-7.8-.5c-17-.6-33.1-1.7-48.3-3.2c-1.5 19.4-12.8 36-29 44.9C180 317.8 217 320 256 320c79.2 0 150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8l0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 344.8 324.4 352 256 352s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.7-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8l0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c4.9 2.1 10.2 4.1 15.6 5.9C68 287.7 64 276.3 64 264V240.1c-4.8-2.8-8.5-5.5-11.1-7.9c-4.9-4.6-4.9-6.9-4.9-8l0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c1.6 .7 3.2 1.3 4.9 2V163.8zM59.1 371c47 19.8 117.7 29 196.9 29s150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8l0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 424.8 324.4 432 256 432s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.8-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8l0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9z"]
};
var faAlbumCircleUser = {
  prefix: 'far',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M64 80H384c8.8 0 16 7.2 16 16v98.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-11.8-14.3-21.4-30.5-28.2-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faSubtitlesSlash = {
  prefix: 'far',
  iconName: 'subtitles-slash',
  icon: [640, 512, [], "e610", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80H544c8.8 0 16 7.2 16 16V413.6L508.2 373c2.4-3.7 3.8-8.2 3.8-13c0-13.3-10.7-24-24-24H461l-67.2-52.6c4 2.9 8.9 4.6 14.2 4.6h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-13.3 0-24 10.7-24 24c0 7.4 3.4 14 8.6 18.4L134.4 80zm353 400l-60.9-48H96c-8.8 0-16-7.2-16-16V159L32 121.2V416c0 35.3 28.7 64 64 64H487.4zM365.5 384l-59.9-47.2C295.5 339.6 288 348.9 288 360c0 13.3 10.7 24 24 24h53.5zM243.7 288l-60.9-48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h91.7zM152 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
};
var faQrcode = {
  prefix: 'far',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M144 80v96H48V80h96zM48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm96 304v96H48V336h96zM48 288c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zM304 80h96v96H304V80zm-48 0v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM72 120v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zM88 360c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V376c0-8.8-7.2-16-16-16H88zM328 120v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344c-8.8 0-16 7.2-16 16zM256 304V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16s-16 7.2-16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM368 448a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
var faDiceD10 = {
  prefix: 'far',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", "M256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2L238 8.2C242.5 3 249.1 0 256 0zM91.6 247.4l50.9-12 36-86.9L91.6 247.4zM256 86.8L189.7 247 256 291.2 322.3 247 256 86.8zm100.6 195L280 332.8V435.6l156.7-135-80-18.8zm63.8-34.3l-86.9-98.9 36 86.9 50.9 12zM232 435.6V332.8l-76.6-51.1-80 18.8L232 435.6z"]
};
var faFireplace = {
  prefix: 'far',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", "M48 48H592V80H48V48zM32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32l0 360c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V368c0-88.4 71.6-160 160-160s160 71.6 160 160V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM80 464V128H560V464H528V368c0-114.9-93.1-208-208-208s-208 93.1-208 208v96H80zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z"]
};
var faBrowser = {
  prefix: 'far',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M.3 89.5C.1 91.6 0 93.8 0 96v64V416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V160 96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 160H464l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256z"]
};
var faPenPaintbrush = {
  prefix: 'far',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M68.4 360.9L45.4 439 33 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L105 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L524.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L485.3 19.3c-25-25-65.5-25-90.5 0L90.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L353 129 415 191 186.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L91.4 452.6l16.1-54.8 6.9-23.4zm170.2 71.4C304.4 485.1 345 512 391.9 512h152c17.7 0 32-14.3 32-32s-14.3-32-32-32h-6c-18.1 0-30.1-19.8-27.4-37.6c.9-6 1.4-12.1 1.4-18.4c0-46.9-26.9-87.5-66.1-107.3l-37.2 37.2c31.7 7.5 55.3 36 55.3 70.1c0 3.8-.3 7.5-.8 11.1c-3.3 21.4 2.2 43.1 13.8 60l.7 .9H391.9c-34 0-62.5-23.6-70.1-55.3l-37.2 37.2zM136 24C105.1-6.9 54.9-6.9 24 24S-6.9 105.1 24 136l98.7 98.7 33.9-33.9L57.9 102.1c-12.2-12.2-12.2-31.9 0-44.1s31.9-12.2 44.1 0l98.7 98.7 33.9-33.9L136 24z"]
};
var faPencilPaintbrush = faPenPaintbrush;
var faFishCooked = {
  prefix: 'far',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M149.3 203.9c19.8-22.8 47.5-46.1 78.2-63.6C258.4 122.8 290.7 112 320 112c44.8 0 97.6 25.1 140.5 58.9c21.1 16.6 38.7 34.5 50.7 50.7C524 238.8 528 250.7 528 256s-4 17.2-16.8 34.4c-12.1 16.2-29.6 34.1-50.7 50.7C417.6 374.9 364.8 400 320 400c-29.3 0-61.6-10.8-92.5-28.4c-30.7-17.5-58.4-40.8-78.2-63.6c-8-9.2-21.7-10.9-31.7-4L60 343.6l17.6-74.8c2-8.4 2-17.2 0-25.7L60 168.4 117.6 208c10.1 6.9 23.7 5.2 31.7-4zM320 64c-40.4 0-81 14.5-116.3 34.6c-28.5 16.2-54.7 36.7-76 58.1L46.9 101.1C42 97.8 36.3 96 30.4 96C11.7 96-2.2 113.5 2.1 131.7L30.9 254.2c.3 1.2 .3 2.5 0 3.7L2.1 380.3C-2.2 398.5 11.7 416 30.4 416c5.9 0 11.6-1.8 16.5-5.1l80.9-55.6c21.3 21.3 47.5 41.8 76 58.1C239 433.5 279.6 448 320 448c60.2 0 123.4-32.2 170.2-69.1c23.8-18.7 44.5-39.5 59.6-59.8C564.1 299.8 576 277.4 576 256s-11.9-43.8-26.2-63.1c-15-20.3-35.8-41.1-59.6-59.8C443.4 96.2 380.2 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z"]
};
var faChairOffice = {
  prefix: 'far',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M288 48c8.8 0 16 7.2 16 16V224h48V64c0-35.3-28.7-64-64-64H160C124.7 0 96 28.7 96 64V224h48V64c0-8.8 7.2-16 16-16H288zM64 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm368 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM248 400H370.5c25.2 0 45.5-20.4 45.5-45.5c0-5.5-1-10.9-2.9-16l-19.2-51.3c-7-18.7-24.9-31.1-44.9-31.1H99.1c-20 0-37.9 12.4-44.9 31.1L34.9 338.5C33 343.6 32 349 32 354.5C32 379.6 52.4 400 77.5 400H200v64H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V400zM99.1 304H348.9l18 48H224 81.1l18-48z"]
};
var faNestingDolls = {
  prefix: 'far',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112V224H80V112zM200.7 64.9c-4.1-5.3-13.2-5.3-17.3 0c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7zM635.5 474.1c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13H312c-9 0-17.2-5-21.3-13c-4.1-8-3.4-17.6 1.8-24.9l0 0 .2-.3c.2-.3 .6-.8 1-1.5c.9-1.4 2.3-3.5 4-6.3c3.4-5.6 7.9-13.8 12.5-23.8c9.2-20.3 17.8-46.8 17.8-74.1v-8c0-75.1 60.9-136 136-136s136 60.9 136 136v8c0 27.3 8.6 53.7 17.8 74.1c4.6 10 9.1 18.2 12.5 23.8c1.7 2.8 3.1 5 4 6.3c.5 .7 .8 1.2 1 1.5l.2 .3 0 0 0 0zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6c1.7 17.9 9.4 35.3 23.1 49c31.2 31.2 81.9 31.2 113.1 0c13.7-13.7 21.4-31.1 23.1-49c.4-4.3-3.3-7.6-7.6-7.6c-25.8 0-48.7-12.2-63.3-31.1c-4.1-5.3-13.2-5.3-17.3 0zM261.4 464c-7.1 15.1-7.3 32.7 0 48H74.5c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4c2.7-5.3 8.1-8.6 14-8.6H332.1c-11.3 14.3-20.3 30.5-26.5 48H71.9C57.9 332.9 48 358 48 384c0 35.9 12.8 63.3 23.2 79.6c.2 0 .4 .1 .6 .1c.7 .1 1.6 .3 2.7 .3H261.4z"]
};
var faClockRotateLeft = {
  prefix: 'far',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", "M48 106.7V56c0-13.3-10.7-24-24-24S0 42.7 0 56V168c0 13.3 10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H80.7c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
};
var faHistory = faClockRotateLeft;
var faTrumpet = {
  prefix: 'far',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M592 128.7V351.3c-10-10.5-21.8-22-35.2-33.2C519.9 287.4 467.9 256 408 256H357.4 168 48V224H408c59.9 0 111.9-31.4 148.8-62.2c13.4-11.2 25.2-22.6 35.2-33.2zM352 304V416H312V304h40zm48 112V304h8c43.4 0 84.6 23.1 118 51c33 27.6 55.5 57.3 61 64.9c5.7 7.9 14.6 12.1 23.7 12.1c16.2 0 29.2-13.1 29.2-29.2V77.2C640 61.1 626.9 48 610.8 48c-9.1 0-18.1 4.2-23.7 12.1c-5.5 7.6-27.9 37.3-61 64.9c-33.4 27.9-74.6 51-118 51h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H312v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H224v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H48v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v32 80 32c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H80.3C70 320.2 64 339.4 64 360c0 57.4 46.6 104 104 104h32 88 88 32c49.6 0 91-34.7 101.5-81.1c-1.3-1.1-2.6-2.2-3.9-3.3c-13.7-11.4-27.9-21.2-42.3-28.6c.5 2.9 .7 5.9 .7 9c0 30.9-25.1 56-56 56h-8zm-136 0H224V304h40V416zm-88 0h-8c-30.9 0-56-25.1-56-56s25.1-56 56-56h8V416z"]
};
var faFaceGrinBeamSweat = {
  prefix: 'far',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faFireSmoke = {
  prefix: 'far',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", "M293.5 3.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 19.8 3.6 38.8 10.1 56.3c9.6 3.3 18.7 7.6 27.3 12.7c12.7-13.6 27.6-25 44.2-33.8c-1.1-5.5-1.6-11.3-1.6-17.4c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c8.6 15.8 11.3 33.7 8.4 50.4c16.6 8.8 31.5 20.2 44.2 33.8c8.5-5.1 17.6-9.3 27.1-12.6C476.4 231 480 212 480 192.2c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM233.2 361.3c7-41.6 43.2-73.3 86.8-73.3s79.8 31.7 86.8 73.3c1.8 10.7 10.5 18.8 21.2 19.9s20.9-5.1 24.8-15.2c10.4-27 36.6-46 67.2-46c39.8 0 72 32.2 72 72c0 37.7-29 68.7-66 71.8c-.7 .1-1.3 .1-2 .2h-4H320 120h-4c-.7-.1-1.3-.2-2-.2c-36.9-3-66-34-66-71.8c0-39.8 32.2-72 72-72c30.6 0 56.7 19 67.2 46c3.9 10.1 14.1 16.3 24.8 15.2s19.4-9.2 21.2-19.9zM320 240c-49.4 0-92.7 26.4-116.5 65.8c-21.6-20.9-51-33.8-83.5-33.8C53.7 272 0 325.7 0 392c0 61.4 46.1 112 105.6 119.1c2 .6 4.2 .9 6.4 .9h8H320 520h8c2.2 0 4.3-.3 6.4-.9C593.9 504 640 453.4 640 392c0-66.3-53.7-120-120-120c-32.5 0-61.9 12.9-83.5 33.8C412.7 266.4 369.4 240 320 240z"]
};
var faPhoneMissed = {
  prefix: 'far',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M120 0H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H177.9l55.4 55.4C254.2 124.3 282.5 136 312 136s57.8-11.7 78.6-32.6L487 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96.4 96.4C394.7 167.2 354.2 184 312 184s-82.7-16.8-112.6-46.6L144 81.9V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM448 392v49.3c0 3.9 2.8 7.2 6.6 7.9l85.8 15.6c3.7 .7 7.4-1.3 8.8-4.8l24.7-58.8c7.4-17.6 2.5-30.9-4.4-36.9C520 321.8 432.8 272 320 272s-200 49.8-249.5 92.3c-6.9 5.9-11.8 19.3-4.4 36.9L90.8 460c1.5 3.5 5.1 5.4 8.8 4.8l85.8-15.6c3.8-.7 6.6-4 6.6-7.9V392c0-19.6 11.9-37.3 30.2-44.6c62.8-25.1 132.9-25.1 195.7 0C436 354.7 448 372.4 448 392zm-48 49.3V392c-51.4-20.5-108.6-20.5-160 0v49.3c0 27.1-19.4 50.3-46 55.1L108.2 512c-25.8 4.7-51.4-9.2-61.6-33.4L21.8 419.8c-13.5-32-8.9-69.3 17.4-91.9C95 280 192.9 224 320 224s225 56 280.8 103.9c26.3 22.6 30.9 59.9 17.4 91.9l-24.8 58.8c-10.2 24.2-35.8 38.1-61.6 33.4L446 496.4c-26.6-4.8-46-28-46-55.1z"]
};
var faFileExport = {
  prefix: 'far',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M336 448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80v96h48V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V368H336v80zM489 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H494.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
var faArrowRightFromFile = faFileExport;
var faShield = {
  prefix: 'far',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M256 49.4L73 127c-5.9 2.5-9.1 7.8-9 12.8c.5 91.4 38.4 249.3 186.4 320.1c3.6 1.7 7.8 1.7 11.3 0C409.7 389 447.6 231.2 448 139.7c0-5-3.1-10.2-9-12.8L256 49.4zM269.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z"]
};
var faShieldBlank = faShield;
var faArrowUpShortWide = {
  prefix: 'far',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm201 9h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faArrowsRepeat1 = {
  prefix: 'far',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M22.5 280C9.3 279.1-.8 267.7 0 254.5l.5-8C5.6 166.4 72 104 152.2 104H366.1L311 49c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l96 96c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H152.2c-54.9 0-100.4 42.7-103.8 97.5l-.5 8c-.8 13.2-12.2 23.3-25.5 22.5zm467-47.9c13.2 .8 23.3 12.2 22.5 25.5l-.5 8C506.4 345.6 440 408 359.8 408H145.9l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 401c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H359.8c54.9 0 100.4-42.7 103.8-97.5l.5-8c.8-13.2 12.2-23.3 25.4-22.5zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
var faRepeat1Alt = faArrowsRepeat1;
var faGunSlash = {
  prefix: 'far',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8 432.9 240h32.5c10.6 0 20.8-4.2 28.3-11.7L513.9 208H568c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40h-8V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H113.9L38.8 5.1zM175.2 112H536h24v48H510.6c-10.6 0-20.8 4.2-28.3 11.7L462.1 192H299 277.2L175.2 112zM338.5 240h43.4l-9.5 26.6L338.5 240zM80 192V159L32 121.2V200c0 22.1 17.9 40 40 40h2c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480H208c14.7 0 27.5-10 31-24.2L265 352h59.9l-91.4-72-38 152h-79l35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4h35.4l-60.9-48H100.8 80z"]
};
var faAvocado = {
  prefix: 'far',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M464 144c0 29.9-13.6 56.5-35.1 74.2c-24.2 19.9-47.3 49.3-54.7 86.9c-8.9 45.7-29.5 88.5-53.1 112c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c23.6-23.6 66.3-44.2 112-53.1c37.6-7.4 67-30.4 86.9-54.7C311.5 61.6 338.1 48 368 48c53 0 96 43 96 96zM421.3 314.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zM283.2 347.2c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4s-49.1 102.1-16.4 134.8s93 25.3 134.8-16.4z"]
};
var faBinary = {
  prefix: 'far',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M328 24V176h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H304 248c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V57.3l-16.4 5.5C251 67 237.4 60.2 233.2 47.6S235.8 21.4 248.4 17.2l48-16C303.7-1.2 311.8 0 318 4.5S328 16.3 328 24zM104 312V464h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H80 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V345.3l-16.4 5.5C27 355 13.4 348.2 9.2 335.6S11.8 309.4 24.4 305.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM0 72C0 32.2 32.2 0 72 0h48c39.8 0 72 32.2 72 72v80c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72V72zM72 48C58.7 48 48 58.7 48 72v80c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H72zM264 288h48c39.8 0 72 32.2 72 72v80c0 39.8-32.2 72-72 72H264c-39.8 0-72-32.2-72-72V360c0-39.8 32.2-72 72-72zm-24 72v80c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V360c0-13.3-10.7-24-24-24H264c-13.3 0-24 10.7-24 24z"]
};
var faGlassesRound = {
  prefix: 'far',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6V336c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128H271.8c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4V325.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 432a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm392-88a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]
};
var faGlassesAlt = faGlassesRound;
var faPhonePlus = {
  prefix: 'far',
  iconName: 'phone-plus',
  icon: [640, 512, [], "f4d2", "M456 200V136H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V24c0-13.3 10.7-24 24-24s24 10.7 24 24V88h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H504v64c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-63 86.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6l0 0c-6.1 0-12.2-.1-18.2-.4l-.1 0 0 0c-10-.4-19.8-1.1-29.6-2.2C239.2 485.6 64 295.2 64 64v0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L393 286.7zm133.8 78.1l-100.4-43L397 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L112.1 70.5C115.5 286.2 289.8 460.5 505.5 464l21.3-99.2z"]
};
var faDitto = {
  prefix: 'far',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M48 105.9c0 1.4 .1 2.8 .4 4.3L72 252 95.6 110.1l0 0c.2-1.4 .4-2.8 .4-4.3V104c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.9zm96 0c0 4.1-.3 8.1-1 12.1L118.6 264.5C114.8 287.3 95.1 304 72 304s-42.8-16.7-46.6-39.5L1 118c-.7-4-1-8.1-1-12.1V104C0 64.2 32.2 32 72 32s72 32.2 72 72v1.9zm80 0c0 1.4 .1 2.8 .4 4.3L248 252l23.6-141.9c.2-1.4 .4-2.8 .4-4.3V104c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.9zm96 0c0 4.1-.3 8.1-1 12.1L294.6 264.5C290.8 287.3 271.1 304 248 304s-42.8-16.7-46.6-39.5L177 118c-.7-4-1-8.1-1-12.1V104c0-39.8 32.2-72 72-72s72 32.2 72 72v1.9z"]
};
var faPersonSeat = {
  prefix: 'far',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 92c0-6.6 5.4-12 12-12s12 5.4 12 12v92H144c-4.4 0-8-3.6-8-8V220zm72 92V256h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H206.8c-5.6-27.4-29.8-48-58.8-48c-33.1 0-60 26.9-60 60v84c0 30.9 25.1 56 56 56h40 54c12 0 22.2 8.9 23.8 20.8l10.4 78.3C273.8 471.1 284 480 296 480h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H317l-7.7-57.5C304.6 338.7 274.1 312 238 312H208zM48 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 66.3 53.7 120 120 120h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V152z"]
};
var faHouseMedical = {
  prefix: 'far',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM288 55.5L112 204.8V432c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V204.8L288 55.5zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faGolfBallTee = {
  prefix: 'far',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M336 192c0 55.7-31.7 104.1-78 128h77.1c30.4-34 48.9-78.8 48.9-128C384 86 298 0 192 0S0 86 0 192c0 49.2 18.5 94 48.9 128H126c-46.3-23.9-78-72.3-78-128c0-79.5 64.5-144 144-144s144 64.5 144 144zM226.1 248.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM64 376c0 13.3 10.7 24 24 24h64c8.8 0 16 7.2 16 16v72c0 13.3 10.7 24 24 24s24-10.7 24-24V416c0-8.8 7.2-16 16-16h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24z"]
};
var faGolfBall = faGolfBallTee;
var faCircleChevronLeft = {
  prefix: 'far',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135L167 239c-9.4 9.4-9.4 24.6 0 33.9L271 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-87-87 87-87c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faHouseChimneyWindow = {
  prefix: 'far',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9V56c0-13.3 10.7-24 24-24s24 10.7 24 24V182.6l55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5V432c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8V432c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V204.8L288 55.5 112 204.8zM256 288h64V224H256v64zm-48-72c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H248c-22.1 0-40-17.9-40-40V216z"]
};
var faScythe = {
  prefix: 'far',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M639.5 28.9c2.7-13-5.7-25.7-18.6-28.4s-25.7 5.7-28.4 18.6L536.9 288H408c-13.3 0-24 10.7-24 24s10.7 24 24 24H526.9L496.5 483.1c-2.7 13 5.7 25.7 18.6 28.4s25.7-5.7 28.4-18.6l96-464zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224H517.4l9.9-48H68.7C108.6 126.8 196.8 48 352 48H553.8l7.3-35.3c.9-4.5 2.4-8.7 4.2-12.7H352z"]
};
var faPenNib = {
  prefix: 'far',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", "M368.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71L412.2 225 371.6 374.1c-4.8 17.8-18.1 32-35.5 38.1L72 505c-18.5 6.5-39.1 1.8-52.9-12S.5 458.5 7 440L99.8 175.9c6.1-17.4 20.3-30.6 38.1-35.5L287 99.8l10.4-10.4 71-71zM296.9 146.8L150.5 186.7c-2.5 .7-4.6 2.6-5.4 5.1L62.5 426.9 164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L85.1 449.5l235.1-82.6c2.5-.9 4.4-2.9 5.1-5.4l39.9-146.4-68.3-68.3z"]
};
var faBanParking = {
  prefix: 'far',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1L385.1 419.1C349.7 447.2 304.8 464 256 464zm80-162c24.2-17.4 40-45.9 40-78c0-53-43-96-96-96H200c-10.4 0-19.6 4.9-25.5 12.6L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L336 302zm-120-120V176h64c26.5 0 48 21.5 48 48c0 18.9-11 35.3-26.9 43.1L216 182.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 265.9V296v64c0 13.3 10.7 24 24 24s24-10.7 24-24V320h6.1L168 265.9z"]
};
var faParkingCircleSlash = faBanParking;
var faTentArrowTurnLeft = {
  prefix: 'far',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512H451.1c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2V464H124.9c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1H374.4L312 360z"]
};
var faFaceDiagonalMouth = {
  prefix: 'far',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm358.1 79.2l-184 48c-12.8 3.3-25.9-4.3-29.3-17.2s4.3-25.9 17.2-29.3l184-48c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDiagramCells = {
  prefix: 'far',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", "M448 224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64l384 0zm16 128v64c0 8.8-7.2 16-16 16l-80 0H144 64c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16zm48 64V352c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64z"]
};
var faCricketBatBall = {
  prefix: 'far',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143-24.4-24.4c-21.9-21.9-57.3-21.9-79.2 0L16.1 334C6.1 344-.6 358.4 .5 374.4c.8 11.3 2.8 28.6 8.2 46.4C13.8 438.1 22.9 457.9 39 473c15 16.2 34.9 25.2 52.2 30.4c17.8 5.4 35.1 7.4 46.4 8.2c16 1.1 30.4-5.6 40.4-15.6L386.3 287.6c21.9-21.9 21.9-57.3 0-79.2L361.9 184 505 41zM269.7 159.6l41.2 41.2 .2 .2 .2 .2 41.2 41.2c3.1 3.1 3.1 8.2 0 11.3L318.1 288H232c-4.4 0-8-3.6-8-8V193.9l34.3-34.3c3.1-3.1 8.2-3.1 11.3 0zM176 241.9V280c0 30.9 25.1 56 56 56h38.1l-126 126c-.7 .7-1.5 1.2-2.1 1.5c-.5 .2-.8 .2-1.1 .2c-9.3-.6-22.6-2.2-35.7-6.2s-24-9.7-30.9-17.2c-.8-.8-1.6-1.7-2.4-2.4c-7.5-6.9-13.2-17.8-17.2-30.9s-5.6-26.5-6.2-35.7c0-.3 0-.6 .2-1.1c.2-.6 .7-1.4 1.5-2.1l126-126zM400 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faCricket = faCricketBatBall;
var faTents = {
  prefix: 'far',
  iconName: 'tents',
  icon: [640, 512, [], "e582", "M430.1 4.6c-8.4-6.1-19.8-6.1-28.2 0l-165 120c-1.7 1.2-3.3 2.6-4.8 4c10.9 1.4 21.5 5.6 30.7 12.6l16.1 12.3L416 53.7 566.8 163.4c1.8 1.3 2.9 3.2 3.2 5.4l17.2 126.1c.7 4.8-3.1 9.1-7.9 9.1H454c.6 2.1 1 4.3 1.3 6.5l6.2 41.5H579.3c33.9 0 60.1-29.9 55.5-63.6L617.6 162.3c-2.1-15.1-10.2-28.7-22.6-37.7l-165-120zM238.7 165c-8.6-6.7-20.7-6.7-29.3 0L43.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L5.5 448.1C.6 481.8 26.8 512 60.9 512H387.1c34.1 0 60.3-30.2 55.4-63.9L425.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L238.7 165zM73 331l127-98.2V464H60.9c-4.9 0-8.6-4.3-7.9-9.1L69.9 336.2c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L375 331c1.6 1.3 2.7 3.1 3 5.2L395 454.9c.7 4.8-3.1 9.1-7.9 9.1H310.4L248 360z"]
};
var faWandMagic = {
  prefix: 'far',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", "M319.7 157.7l34.6 34.6L464 82.6 429.4 48 319.7 157.7zm-33.9 33.9L48 429.4 82.6 464 320.3 226.2l-34.6-34.6zM14.1 395.4L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9z"]
};
var faMagic = faWandMagic;
var faDog = {
  prefix: 'far',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M318 342.2c11.4 9.1 18 22.9 18 37.4V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V274.3L300.5 223c-3.2 .7-6.5 1-9.9 1H144 112.1l-.1 .8V448c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V379.6c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c9.5 2.1 19.4 3.2 29.6 3.2s20.1-1.1 29.6-3.2c14.2-3.1 29.1 .3 40.4 9.4zM336.9 189l53.4 32.8c7.2-17.7 24.6-29.8 44.4-29.8H480c26.5 0 48-21.5 48-48V112H496c-12.7 0-24.9-5.1-33.9-14.1L444.1 80 368 80c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.3 1.7-.7 3.4-1.1 5.1zM64.2 220.2c-1.1-.3-2.2-.7-3.3-1.1c-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l0 0 3.9 15.5C55.6 163.5 71.6 176 90 176h54H290.7L313.5 39.3l.1-.4 .9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1l11.2 14.9 3.4 4.6 .2 .3L368 32h76.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v32c0 53-43 96-96 96H434.7L432 256V448c0 35.3-28.7 64-64 64H352c-35.3 0-64-28.7-64-64V428.6 379.6c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2v48.9V448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224c0-1.3 .1-2.6 .2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faPenLine = {
  prefix: 'far',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", "M13.4 439l23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10c16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8c-9.6 8.5-21 14.8-33.4 18.4L73 498.6 30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L13.4 439zm62.2-41.2L59.4 452.6l54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191 321 129 92.5 357.4c-.6 .6-1.2 1.2-1.7 1.8c-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zM248 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faAtomSimple = {
  prefix: 'far',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", "M89.6 422.4c7.9 7.9 31.4 16.9 80.4 .6c13.2-4.4 27.2-10.4 41.6-17.9c-18.9-14.4-37.7-30.8-55.8-48.9s-34.5-36.9-48.9-55.8c-7.5 14.4-13.5 28.4-17.9 41.6c-16.3 49-7.3 72.5 .6 80.4zM76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256zM107 211.6c14.4-18.9 30.8-37.7 48.9-55.8s36.9-34.5 55.8-48.9c-14.4-7.5-28.4-13.5-41.6-17.9c-49-16.3-72.5-7.3-80.4 .6s-16.9 31.4-.6 80.4c4.4 13.2 10.4 27.2 17.9 41.6zM256 134c-22.1 15.5-44.5 34.1-66.2 55.8s-40.3 44.1-55.8 66.2c15.5 22.1 34.1 44.5 55.8 66.2s44.1 40.3 66.2 55.8c22.1-15.5 44.5-34.1 66.2-55.8s40.3-44.1 55.8-66.2c-15.5-22.1-34.1-44.5-55.8-66.2s-44.1-40.3-66.2-55.8zm149 77.7c7.5-14.4 13.5-28.4 17.9-41.6c16.3-49 7.3-72.5-.6-80.4s-31.4-16.9-80.4-.6c-13.2 4.4-27.2 10.4-41.6 17.9c18.9 14.4 37.7 30.8 55.8 48.9s34.5 36.9 48.9 55.8zm0 88.7c-14.4 18.9-30.8 37.7-48.9 55.8s-36.9 34.5-55.8 48.9c14.4 7.5 28.4 13.5 41.6 17.9c49 16.3 72.5 7.3 80.4-.6s16.9-31.4 .6-80.4c-4.4-13.2-10.4-27.2-17.9-41.6zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faAtomAlt = faAtomSimple;
var faAmpersand = {
  prefix: 'far',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M178 80h44.4c27.4 0 49.7 22.2 49.7 49.7c0 16.2-7.9 31.4-21.2 40.7l-61.4 43-47.2-48.5C133.1 155.5 128 143 128 130c0-27.6 22.4-50 50-50zm45.3 168.2l55.1-38.5c26.1-18.3 41.7-48.1 41.7-80C320 75.7 276.3 32 222.3 32H178c-54.1 0-98 43.9-98 98c0 25.5 10 50 27.7 68.3l41.8 43L75.9 292.8C48.4 312 32 343.5 32 377.1C32 433.9 78.1 480 134.9 480h77.8c35.1 0 67.8-17.7 87-47.1l14.6-22.3 60.4 62.1c9.2 9.5 24.4 9.7 33.9 .5s9.7-24.4 .5-33.9l-67.9-69.8 70.8-108.3c7.3-11.1 4.1-26-7-33.2s-26-4.1-33.2 7L307 334.2l-83.7-86zm-39.8 27.9l96.6 99.3-20.5 31.3c-10.3 15.8-28 25.4-46.9 25.4H134.9C104.6 432 80 407.4 80 377.1c0-17.9 8.7-34.7 23.4-45l80-56z"]
};
var faCarrot = {
  prefix: 'far',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", "M320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6C337.6 17 320 42.3 320 72zM199.3 197.4c13.2-8.6 28.9-13.4 45.3-13.4c46.1 0 83.4 37.3 83.4 83.4c0 32.5-18.9 62-48.3 75.7l-42.8 19.8L209 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15.4 15.4L73.3 438.7l94.8-204.6L207 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41.7-41.7zM34.1 509.8L299.8 386.6c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136c-51.2 0-97.7 29.7-119.2 76.2L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8z"]
};
var faArrowUpFromLine = {
  prefix: 'far',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M209.5 39.6C204.9 34.7 198.6 32 192 32s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L168 116.5V200 328c0 13.3 10.7 24 24 24s24-10.7 24-24V200 116.5l86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faArrowFromBottom = faArrowUpFromLine;
var faMoon = {
  prefix: 'far',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"]
};
var faPenSlash = {
  prefix: 'far',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L517.3 19.3c-25-25-65.5-25-90.5 0L264.2 181.8 38.8 5.1zM302.3 211.6L385 129 447 191l-75.1 75.1-69.6-54.5zM156.5 357.4l77.3-77.3-38-29.9-73.2 73.2c-10.4 10.4-18 23.3-22.2 37.4L77.4 439 65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L137 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8l88.6-88.6-38-29.9-84.6 84.6c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8z"]
};
var faWineGlassEmpty = {
  prefix: 'far',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M56 0C43.5 0 33.1 9.6 32.1 22.1L18.1 198.5C12.3 273.1 64.8 337.9 136 350V464H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h88 88c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V350c71.2-12.1 123.7-76.9 117.9-151.5L287.9 22.1C286.9 9.6 276.5 0 264 0H56zM66 202.3L78.2 48H241.8L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7z"]
};
var faWineGlassAlt = faWineGlassEmpty;
var faSquareStar = {
  prefix: 'far',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 25c6.1 0 11.7 3.5 14.3 8.9l31.3 63.3 69.9 10.2c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4L297.8 280l11.9 69.6c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 333.6l-62.5 32.9c-5.4 2.8-11.9 2.4-16.9-1.2s-7.4-9.6-6.4-15.6L150.2 280 99.7 230.7c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l69.9-10.2 31.3-63.3c2.7-5.5 8.3-8.9 14.3-8.9z"]
};
var faCheese = {
  prefix: 'far',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M464 240.2V256H48c0-3.9 2-7.6 5.3-9.8L301.5 80.7c.7-.4 1.5-.7 2.3-.7C392.3 80 464 151.7 464 240.2zM48 304H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V304zm464-48V240.2C512 125.2 418.8 32 303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V256z"]
};
var faSendBackward = {
  prefix: 'far',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V224c0-53 43-96 96-96H352V64c0-35.3-28.7-64-64-64H64zM224 208H448c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zm-64 16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"]
};
var faYinYang = {
  prefix: 'far',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M464 256c0 114.9-93.1 208-208 208c-50.9 0-92.2-41.2-92.2-92s41.3-92 92.2-92c77.3 0 140-62.7 140-140c0-15.4-2.5-30.1-7-44c45.9 38.2 75 95.7 75 160zM256 48c50.8 0 92 41.2 92 92s-41.2 92-92 92c-77.3 0-140.2 62.6-140.2 140c0 15.3 2.5 30 7 43.8C77.1 377.6 48 320.2 48 256C48 141.1 141.1 48 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMusic = {
  prefix: 'far',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M512 31c0-17.1-13.9-31-31-31c-3.1 0-6.2 .5-9.1 1.4l-311 95.7C150.9 100.2 144 109.5 144 120V240 362.7c-14.1-6.8-30.5-10.7-48-10.7c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V260.2l272-83.7V298.7c-14.1-6.8-30.5-10.7-48-10.7c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V144.6c0-.4 0-.7 0-1.1V31zM464 368c0 9.8-12.9 32-48 32s-48-22.2-48-32s12.9-32 48-32s48 22.2 48 32zM144 432c0 9.8-12.9 32-48 32s-48-22.2-48-32s12.9-32 48-32s48 22.2 48 32zM464 126.3L192 210V137.7L464 54v72.2z"]
};
var faCompassSlash = {
  prefix: 'far',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9L38.8 5.1zM172.2 109.7C209.9 71.6 262.2 48 320 48c114.9 0 208 93.1 208 208c0 39.8-11.2 77-30.6 108.6L397.1 285.9l47.5-123.5c7.5-19.4-11.6-38.5-31-31L270.3 186.5l-98.1-76.9zM320 464c-114.9 0-208-93.1-208-208c0-22.3 3.5-43.8 10-63.9L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256c55.2 0 106.3-17.5 148.1-47.2l-39.7-31.3C396.8 452.9 359.7 464 320 464zm-3-118.2l-92.2-72.6-29.4 76.5c-7.5 19.4 11.6 38.5 31 31L317 345.8z"]
};
var faClockOne = {
  prefix: 'far',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFileMusic = {
  prefix: 'far',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM304 208c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V299.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V240 208z"]
};
var faCodeCommit = {
  prefix: 'far',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", "M320 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm158.2-88c-11.6 77-78 136-158.2 136s-146.6-59-158.2-136H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H161.8c11.6-77 78-136 158.2-136s146.6 59 158.2 136H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H478.2z"]
};
var faTemperatureLow = {
  prefix: 'far',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64V273.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9V112zM144 0C82.1 0 32 50.2 32 112V273.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faPersonBiking = {
  prefix: 'far',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", "M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 384A80 80 0 1 1 48 384a80 80 0 1 1 160 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM592 384a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM341.5 149.6c3.5-2.5 8.3-1.9 11 1.4l44.8 56c4.6 5.7 11.5 9 18.7 9h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H427.5L390 121c-18.8-23.5-52.7-27.9-76.9-10.1l-74.6 55c-38.5 28.4-33.4 87.4 9.3 108.8L304 302.8V416c0 13.3 10.7 24 24 24s24-10.7 24-24V288c0-9.1-5.1-17.4-13.3-21.5l-69.6-34.8c-10.7-5.3-12-20.1-2.3-27.2l74.6-55z"]
};
var faBiking = faPersonBiking;
var faDisplayChartUpCircleCurrency = {
  prefix: 'far',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M64 48H512c8.8 0 16 7.2 16 16V194.9c17 3.1 33.1 8.7 48 16.3V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H211.7l-8 48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h72H352h42.8c-18.3-12.9-34.1-29.2-46.3-48H323.7 288 252.3l8-48H288h27.7 11c-4.3-15.3-6.6-31.4-6.6-48H240.4c-.3 0-.6 0-.8 0H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zM480 192.7V120c0-13.3-10.7-24-24-24H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111V200c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z"]
};
var faSkeleton = {
  prefix: 'far',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M256 0c13.3 0 24 10.7 24 24V64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v48H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v48H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v85.7l75.5-32.3c8.3-3.5 17.2-5.4 26.1-5.4c36.7 0 66.4 29.7 66.4 66.4v1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3H153.9c-16.6 0-32.4-6.6-44.1-18.3L83.9 467.9c-12.7-12.7-19.9-30-19.9-48v-1.5c0-36.7 29.7-66.4 66.4-66.4c9 0 17.9 1.8 26.1 5.4L232 389.7V304H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H232V208H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H232V112H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H232V24c0-13.3 10.7-24 24-24zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCircleG = {
  prefix: 'far',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80c20.5 0 39.2 7.7 53.3 20.4c9.9 8.8 25.1 8 33.9-1.9s8-25-1.9-33.9C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h52.3c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80z"]
};
var faCircleArrowUpLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm64-368H168c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V225.9L327 361c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-135-135H320c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faCoinBlank = {
  prefix: 'far',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M256 304c64 0 119.6-14.7 157.5-36c39.4-22.2 50.5-45.3 50.5-60s-11.1-37.8-50.5-60C375.6 126.7 320 112 256 112s-119.6 14.7-157.5 36C59.1 170.2 48 193.3 48 208s11.1 37.8 50.5 60c37.9 21.3 93.5 36 157.5 36zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 48 0 64c0 70.7-114.6 128-256 128S0 390.7 0 320l0-64 0-48zM256 352c-13.6 0-27-.6-40-1.7l0 48c12.9 1.1 26.3 1.7 40 1.7s27.1-.6 40-1.7l0-48c-13 1.1-26.4 1.7-40 1.7zM120 330l0 47.7c18.7 7 40.3 12.7 64 16.6l0-48.1c-22.8-3.8-44.3-9.2-64-16.2zM88 316.7C73 309.3 59.6 301 48 292l0 28c0 6.8 6.2 24.2 40 43.1l0-46.5zm240 29.6l0 48.1c23.7-3.9 45.3-9.6 64-16.6l0-47.7c-19.7 7-41.2 12.5-64 16.2zM464 320l0-28c-11.6 9.1-25 17.4-40 24.7l0 46.5c33.8-18.9 40-36.3 40-43.1z"]
};
var faBroom = {
  prefix: 'far',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 207l-39-39c-5.1-5.1-12.1-8-19.4-8c-12.2 0-23 8.1-26.3 19.9l-15.9 55.6-.6-.1c-46.4-7.1-93.5 8.3-126.7 41.5L97 287c-18.4 18.4-29.7 42.4-32.4 68c-.4 3.8-.6 7.7-.6 11.6c0 9.6 7.8 17.3 17.3 17.3H104L81.3 404.9 57.1 427.3 7.2 473.4C2.6 477.6 0 483.5 0 489.7C0 502 10 512 22.3 512l172.7 0c39.1 0 76.6-15.5 104.2-43.2c33.2-33.2 48.6-80.2 41.5-126.7l-.1-.6 55.6-15.9c11.8-3.4 19.9-14.1 19.9-26.3c0-7.3-2.9-14.2-8-19.4l-39-39L569 41zM278.8 254.8l8-28.1 62.4 62.4-28.1 8-42.3-42.3zm-52.3 28l9.8 1.5 55.4 55.4 1.5 9.8c4.8 31.3-5.6 63-28 85.4c-18.6 18.6-43.9 29.1-70.3 29.1L88.1 464l48.5-44.7c14.5-13.4 19.3-34.3 12.1-52.7c-5.4-13.7-16.6-23.9-30.1-28.3c3.1-6.4 7.3-12.2 12.4-17.3l10.2-10.2c22.4-22.4 54.1-32.8 85.4-28z"]
};
var faVacuum = {
  prefix: 'far',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M290 48c-27.1 0-50.6 19-56.2 45.5L206 224H156.9L186.8 83.5C197.2 34.8 240.2 0 290 0H528c61.9 0 112 50.1 112 112c0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320V448c0 35.3-28.7 64-64 64H468.7c14.8-13 26.5-29.4 34-48H544c8.8 0 16-7.2 16-16V320c0-79.5-64.5-144-144-144c-8.8 0-16 7.2-16 16v97c-5.2-.7-10.6-1-16-1c-11 0-21.8 1.4-32 4V192c0-35.3 28.7-64 64-64c47.9 0 91.8 17.6 125.4 46.6c28.9-6.1 50.6-31.9 50.6-62.6c0-35.3-28.7-64-64-64H290zM150.1 256h49.1L171.7 385.1c29.8 5.5 52.3 31.6 52.3 62.9c0 35.3-28.7 64-64 64H32c-17.7 0-32-14.3-32-32c0-53 43-96 96-96h26.9l27.2-128zM432 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM176 448c0-8.8-7.2-16-16-16H96c-20.9 0-38.7 13.4-45.3 32H160c8.8 0 16-7.2 16-16zm208-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faShieldHeart = {
  prefix: 'far',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM144 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCardHeart = {
  prefix: 'far',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z"]
};
var faLightbulbCflOn = {
  prefix: 'far',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M343.3 18.2C340.1 5.3 327-2.5 314.2 .7l-128 32c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l128-32c12.9-3.2 20.7-16.2 17.5-29.1zm110.5 93.1c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zm0 96c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zM416 416c0-17.7-14.3-32-32-32H304V294.2l-48 12V384c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h40v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h40c17.7 0 32-14.3 32-32V416zm37.8-112.7c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16-16 4 0 0-8 2c-11.1 2.8-18.5 12.9-18.2 23.9V384h48V320.7l5.8-1.5 64-16zM53.3 4C42.3-3.3 27.4-.3 20 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L53.3 4zM613.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552zM101.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm464-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z"]
};
var faMelon = {
  prefix: 'far',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M464 256c0-25.8-4.7-50.4-13.2-73.2c-14.9 51.3-51.2 110.5-104.3 163.6s-112.3 89.4-163.6 104.3c22.8 8.6 47.4 13.2 73.2 13.2c114.9 0 208-93.1 208-208zM61.2 329.2c14.9-51.3 51.2-110.5 104.3-163.6s112.3-89.4 163.6-104.3C306.4 52.7 281.8 48 256 48C141.1 48 48 141.1 48 256c0 25.8 4.7 50.4 13.2 73.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM403 109c-5.2-5.2-24.1-13.9-67.8 .7c-40.7 13.6-89.8 44-135.7 89.9s-76.3 95-89.9 135.7c-14.6 43.7-5.8 62.6-.7 67.8s24.1 13.9 67.8-.7c40.7-13.6 89.9-44 135.7-89.9s76.3-95 89.9-135.7c14.6-43.7 5.8-62.6 .7-67.8z"]
};
var faGopuram = {
  prefix: 'far',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M120 0c13.3 0 24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64 80v48 2.7c18.6 6.6 32 24.4 32 45.3v48c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3v64c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3v80c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V384c0-20.9 13.4-38.7 32.1-45.3c0-.9-.1-1.8-.1-2.7V272c0-20.9 13.4-38.7 32.1-45.3c0-.9-.1-1.8-.1-2.7V176c0-20.9 13.4-38.7 32-45.3V128 80 64 32 24c0-13.3 10.7-24 24-24zm24 80v48H368V80H144zm-32 96v48h48V176H144 112zm208 48V176H192v48h32c0-17.7 14.3-32 32-32s32 14.3 32 32h32zm32-48v48h48V176H368 352zm0 96H160v64h64V320c0-17.7 14.3-32 32-32s32 14.3 32 32v16h64V272zm32 64h48V272H400 384v64zM128 464h80V448c0-26.5 21.5-48 48-48s48 21.5 48 48v16h80V384H352 160 128v80zm288 0h48V384H432 416v80zM128 272H112 80v64h48V272zM96 384H80 48v80H96V384z"]
};
var faEarthOceania = {
  prefix: 'far',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 416c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM423.2 290.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faGlobeOceania = faEarthOceania;
var faContainerStorage = {
  prefix: 'far',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80h8V432H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H56 584h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V80h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H584 56 24zM80 432V80H560V432H80zm96-280c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V360c0 13.3 10.7 24 24 24s24-10.7 24-24V152z"]
};
var faFacePouting = {
  prefix: 'far',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faSquareXmark = {
  prefix: 'far',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm143 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faFaceExplode = {
  prefix: 'far',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M120 160c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56H352c-17.7 0-32 14.3-32 32v4.5c0 10.3 4.4 20.1 11.9 27l9.5 6c10.4 6.5 23.5 6.5 33.9 0l17.3-10.8c10.4-6.5 23.5-6.5 33.9 0l20.7 12.9c4.8 3 10.3 4.6 15.8 4.8c4.2 .2 8.5-.5 12.6-2.1l33.9-13.1c1.5 11.4 2.3 23 2.3 34.8c0 5.3-.2 10.7-.5 15.9C503.3 405.9 392 512 256 512S8.7 405.9 .5 271.9C.2 266.7 0 261.3 0 256c0-11.8 .8-23.4 2.3-34.8l34 13.1c4.1 1.6 8.4 2.3 12.6 2.1c5.5-.2 11-1.8 15.8-4.8l20.7-12.9c10.4-6.5 23.5-6.5 33.9 0l17.3 10.8c10.4 6.5 23.5 6.5 33.9 0l9.5-6c7.5-6.9 11.9-16.6 11.9-27V192c0-17.7-14.3-32-32-32H120zm-8.8 110.1l-8.8-5.5-12.2 7.6C77.9 279.9 64 284 49.9 284.4C63.8 385.8 150.7 464 256 464s192.2-78.2 206.1-179.6c-14.1-.4-28-4.5-40.3-12.1l-12.2-7.6-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0zM176.4 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 368c26.5 0 48 21.5 48 48v5.3c0 5.9-4.8 10.7-10.7 10.7H218.7c-5.9 0-10.7-4.8-10.7-10.7V416c0-26.5 21.5-48 48-48z"]
};
var faExplodingHead = faFaceExplode;
var faHashtag = {
  prefix: 'far',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136h111l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H342.9L314.1 328H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H304.5l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376h-111l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h81.1l28.8-144H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h87.5l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328h111l28.8-144h-111z"]
};
var faUpRightAndDownLeftFromCenter = {
  prefix: 'far',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M323.3 0C303.8 0 288 15.8 288 35.3c0 9.4 3.7 18.3 10.3 25L326.1 88 264 150.1c-18.7 18.7-18.7 49.1 0 67.9L294.1 248c18.7 18.7 49.1 18.7 67.9 0L424 185.9l27.7 27.7c6.6 6.6 15.6 10.3 25 10.3c19.5 0 35.3-15.8 35.3-35.3V40c0-22.1-17.9-40-40-40H323.3zM377 71l-23-23H464V158.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0l-79 79L297.9 184l79-79c9.4-9.4 9.4-24.6 0-33.9zM188.7 512c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25L185.9 424 248 361.9c18.7-18.7 18.7-49.1 0-67.9L217.9 264c-18.7-18.7-49.1-18.7-67.9 0L88 326.1 60.3 298.3c-6.6-6.6-15.6-10.3-25-10.3C15.8 288 0 303.8 0 323.3V472c0 22.1 17.9 40 40 40H188.7zM135 441l23 23H48V353.9l23 23c9.4 9.4 24.6 9.4 33.9 0l79-79L214.1 328l-79 79c-9.4 9.4-9.4 24.6 0 33.9z"]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faOilCan = {
  prefix: 'far',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M328 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48H147.2 144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L615 208.6l1.4-1.6 7.6-8.6 9.4-10.6c12.3-13.9-.3-35.4-18.4-31.5l-13.9 3-11.3 2.4-2.1 .4L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H280V112h48zm97.1 125.8c10.4 5.2 22.3 6.7 33.6 4.3l72.1-15.4L412.7 360.5c-2.4 2.8-5.9 4.3-9.6 4.3H147.2V211.2H368.9c2 0 3.9 .5 5.7 1.4l50.5 25.2zM96 294.1L48 272.8V208H96v3.2 82.9z"]
};
var faT = {
  prefix: 'far',
  iconName: 't',
  icon: [384, 512, [116], "54", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80H168V456c0 13.3 10.7 24 24 24s24-10.7 24-24V80H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H192 24z"]
};
var faTransformerBolt = {
  prefix: 'far',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M136 24c0-13.3-10.7-24-24-24S88 10.7 88 24v8H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H136V24zm160 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h48 48c8.8 0 16-7.2 16-16s-7.2-16-16-16H296V24zM48 112c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H56 328h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V208h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H328 56 24zM80 464V208H304V464H80zM233.4 243.1c-5.9-4.3-14-4-19.6 .7l-96 80c-5.2 4.3-7.1 11.4-4.8 17.7s8.3 10.6 15 10.6h40.4l-23.2 58.1c-2.7 6.8-.5 14.6 5.5 18.9s14 4 19.6-.7l96-80c5.2-4.3 7.1-11.4 4.8-17.7s-8.3-10.6-15-10.6H215.6l23.2-58.1c2.7-6.8 .5-14.6-5.5-18.9z"]
};
var faHippo = {
  prefix: 'far',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M391 39c9.4-9.4 24.6-9.4 33.9 0l14.2 14.2C449.5 49.9 460.5 48 472 48h32c15.8 0 30.8 3.5 44.2 9.8L559 47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7c13.8 17.7 22 39.9 22 64c0 .3 .1 .6 .3 .7c19.4 17.6 31.7 43 31.7 71.3c0 28.4-12.4 54-32 71.6l0 .4v32c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24v-8H480v8c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V314.5c-37.3-13.2-64-48.7-64-90.5c0-16.2 4-31.4 11.1-44.8c2.9-5.6 4.9-11.7 4.9-18V152c0-8.9 1.1-17.5 3.2-25.8c-25.6-9.4-52.7-14.2-80-14.2H256 231.2C147.7 112 80 179.7 80 263.2c0 19.7-4.1 39.2-12.1 57.2L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 153.2 121.2 64 231.2 64H256h35.2c35.1 0 69.9 6.6 102.6 19.5c1.2-1.4 2.4-2.7 3.7-4L391 73c-9.4-9.4-9.4-24.6 0-33.9zm81 57c-30.9 0-56 25.1-56 56v9.2c0 16.4-5.1 30.3-10.5 40.4c-3.5 6.6-5.5 14.2-5.5 22.4c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48c0-14.1-6-26.8-15.8-35.6C566 179.2 560 166 560 152c0-30.9-25.1-56-56-56H472zM408 377.6c7.1 4.1 15.3 6.4 24 6.4h24v40c0 30.9-25.1 56-56 56H352c-30.9 0-56-25.1-56-56V407.6c-26.4 5.4-53.6 5.4-80 0V424c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24v48c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8V376c0-7.6 3.6-14.8 9.8-19.3s14.1-5.8 21.4-3.6l11.3 3.6c29.6 9.3 61.4 9.3 91 0l11.3-3.6c7.3-2.3 15.2-1 21.4 3.6s9.8 11.7 9.8 19.3v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V377.6zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-56 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faChartColumn = {
  prefix: 'far',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm120-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm72 40c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM480 88V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faCassetteVhs = {
  prefix: 'far',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", "M48 416V160H528V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM352 336H224V256H352v80zM144 296c0-19.4 13.7-35.5 32-39.2v78.4c-18.3-3.7-32-19.8-32-39.2zm288 0c0 19.4-13.7 35.5-32 39.2V256.8c18.3 3.7 32 19.8 32 39.2zM96 296c0 48.6 39.4 88 88 88H392c48.6 0 88-39.4 88-88s-39.4-88-88-88H184c-48.6 0-88 39.4-88 88z"]
};
var faVhs = faCassetteVhs;
var faInfinity = {
  prefix: 'far',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 237.3C0 159.3 63.3 96 141.3 96c39 0 76.2 16.1 102.9 44.5L320 221l75.8-80.5C422.5 112.1 459.7 96 498.7 96c78 0 141.3 63.3 141.3 141.3v37.4c0 78-63.3 141.3-141.3 141.3c-39 0-76.2-16.1-102.9-44.5L320 291l-75.8 80.5C217.5 399.9 180.3 416 141.3 416C63.3 416 0 352.7 0 274.7V237.3zM287 256l-77.8-82.6c-17.6-18.7-42.2-29.4-68-29.4C89.8 144 48 185.8 48 237.3v37.4c0 51.5 41.8 93.3 93.3 93.3c25.7 0 50.3-10.6 68-29.4L287 256zm65.9 0l77.8 82.6c17.6 18.7 42.2 29.4 68 29.4c51.5 0 93.3-41.8 93.3-93.3V237.3c0-51.5-41.8-93.3-93.3-93.3c-25.7 0-50.3 10.6-68 29.4L353 256z"]
};
var faVialCircleCheck = {
  prefix: 'far',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M0 56C0 42.7 10.7 32 24 32h8H80h96 48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V80H24C10.7 80 0 69.3 0 56zM80 80V192h96V80H80zm0 160V384c0 26.5 21.5 48 48 48s48-21.5 48-48V240H80zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faChimney = {
  prefix: 'far',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M48 176H400V80H48v96zM0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32V192c0 17.7-14.3 32-32 32V360 464c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H288v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H184 80v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V360l0-136c-17.7 0-32-14.3-32-32V64zM80 224V336h80V224H80zm128 0V336h56H368V224H208z"]
};
var faObjectIntersect = {
  prefix: 'far',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M96 48H64c-8.8 0-16 7.2-16 16V96H0V64C0 28.7 28.7 0 64 0H96V48zm32 0V0h96V48H128zM0 128H48v96H0V128zm352 32v48 48 32c0 35.3-28.7 64-64 64H224 208 160V304 256 224c0-35.3 28.7-64 64-64h64 16 48zM160 416h48v32c0 8.8 7.2 16 16 16h32v48H224c-35.3 0-64-28.7-64-64V416zM352 64V96H304V64c0-8.8-7.2-16-16-16H256V0h32c35.3 0 64 28.7 64 64zm64 144V160h32c35.3 0 64 28.7 64 64v32H464V224c0-8.8-7.2-16-16-16H416zM96 304v48H64c-35.3 0-64-28.7-64-64V256H48v32c0 8.8 7.2 16 16 16H96zM288 464h96v48H288V464zm160 48H416V464h32c8.8 0 16-7.2 16-16V416h48v32c0 35.3-28.7 64-64 64zm64-128H464V288h48v96zM304 208H224c-8.8 0-16 7.2-16 16v80h80c8.8 0 16-7.2 16-16V208z"]
};
var faPersonArrowDownToLine = {
  prefix: 'far',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80h27.5c.8 0 1.5 0 2.3 .1V304H176V176.1c.7 0 1.5-.1 2.3-.1zM176 464V352h32V464H176zm-48 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H152h80H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H256V223.6l43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L282.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7H178.3c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6V464zM472 56l0 281.7-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L520 337.7 520 56c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faVoicemail = {
  prefix: 'far',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM251.3 336c22.8-25.5 36.7-59.1 36.7-96c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 36.9 13.9 70.5 36.7 96H251.3zM496 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faBlockBrick = {
  prefix: 'far',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M144 80v48h56 48 56V80H144zM96 128V80H64c-8.8 0-16 7.2-16 16v32H96zM48 176v56H200V176H48zm0 160H96V280H48v56zm0 48v32c0 8.8 7.2 16 16 16H200V384H144 96 48zm96-48H304V280H144v56zm208 0h48V280H352v56zm48 48H352 304 248v48H384c8.8 0 16-7.2 16-16V384zm0-208H248v56H400V176zm0-48V96c0-8.8-7.2-16-16-16H352v48h48zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faWallBrick = faBlockBrick;
var faFan = {
  prefix: 'far',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M304 40l-4.1 38.2-5.7 52.7c9.4-4 18.9-6.9 28.5-8.6c7-1.2 14-1.9 21-2.2c79-2.9 151.9 53.9 167.7 132.1c.5 2.5 .7 5.1 .7 7.7V264c0 22.1-17.9 40-40 40l-38.2-4.1-52.7-5.7c4 9.4 6.9 18.9 8.6 28.5c1.2 7 1.9 14 2.2 21c2.9 79-53.9 151.9-132.1 167.7c-2.5 .5-5.1 .7-7.7 .7H248c-22.1 0-40-17.9-40-40l4.1-38.2 5.7-52.7c-9.4 4-18.9 6.9-28.5 8.6c-7 1.2-14 1.9-21 2.2C89.4 394.8 16.4 338 .7 259.8c-.5-2.5-.7-5.1-.7-7.7V248c0-22.1 17.9-40 40-40l38.2 4.1 52.7 5.7c-4-9.4-6.9-18.9-8.6-28.5c-1.2-7-1.9-14-2.2-21C117.2 89.4 174 16.4 252.2 .7c2.5-.5 5.1-.7 7.7-.7H264c22.1 0 40 17.9 40 40zm82.3 206.5l76.3 8.3c-15.2-56.4-73.6-95.1-131.8-85.1c-5.5 .9-11.4 2.7-17.8 5.4c-15.7 6.7-33.7 4.6-47.4-5.6s-21-26.8-19.2-43.7l8.3-76.3c-56.4 15.2-95.1 73.6-85.1 131.8c.9 5.5 2.7 11.4 5.4 17.8c6.7 15.7 4.6 33.7-5.6 47.4s-26.8 21-43.7 19.2l-76.3-8.3c15.2 56.4 73.6 95.1 131.8 85.1c5.5-.9 11.4-2.7 17.8-5.4c15.7-6.7 33.7-4.6 47.4 5.6s21 26.8 19.2 43.7l-8.3 76.3c56.4-15.2 95.1-73.6 85.1-131.8c-.9-5.5-2.7-11.4-5.4-17.8c-6.7-15.7-4.6-33.7 5.6-47.4s26.8-21 43.7-19.2zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBagsShopping = {
  prefix: 'far',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M176 96c0-26.5 21.5-48 48-48s48 21.5 48 48v64H176V96zm-48 64H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64h96V432H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16h48c0-35.3-28.7-64-64-64H320V96c0-53-43-96-96-96s-96 43-96 96v64zm128 96c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H256zm64 80v16c0 35.3 28.7 64 64 64s64-28.7 64-64V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 53-43 96-96 96s-96-43-96-96V336c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faParagraphLeft = {
  prefix: 'far',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", "M304 48h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H224 200 168 144C82.1 0 32 50.1 32 112s50.1 112 112 112h32v72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72V200 48h32l0 248c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM176 48V176H144c-35.3 0-64-28.7-64-64s28.7-64 64-64h24 8zM120.1 361.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72C2.9 402.7 0 409.2 0 416s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 440H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H86.5l33.5-30.2z"]
};
var faParagraphRtl = faParagraphLeft;
var faPersonWalkingLuggage = {
  prefix: 'far',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM365.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L384.7 288.6l-16.3-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L503 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C484.1 162.8 437.9 128 385.3 128h-4.9c-16.1 0-32.1 2.6-47.4 7.7c-39.9 13.3-72.4 42.8-89.5 81.3l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3c10.9-24.4 30.9-43.5 55.6-53.3l-22.8 68.3c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L488.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21l-24.1 60.4L231 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zm-75.7-52c-7.6-4.4-17.4-1.8-21.9 5.8L203 335.9 147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c.6-1 1.1-1.9 1.5-2.9L253.8 312c4.4-7.6 1.8-17.4-5.8-21.9z"]
};
var faCaravanSimple = {
  prefix: 'far',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M80 80c-17.7 0-32 14.3-32 32V336c0 17.7 14.3 32 32 32h28.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H528V192c0-61.9-50.1-112-112-112H80zM96 416H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V368l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0H528 288c0 53-43 96-96 96s-96-43-96-96zm0-256c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160zm256-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM240 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCaravanAlt = faCaravanSimple;
var faTurtle = {
  prefix: 'far',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M336 240V208c0-70.7-57.3-128-128-128S80 137.3 80 208v32H336zm48-32v41.2c0 21.4-17.4 38.8-38.8 38.8H70.8C49.4 288 32 270.6 32 249.2V208c0-97.2 78.8-176 176-176s176 78.8 176 176zm96 80c-8.3 0-16.3-1.6-23.6-4.5C440.3 328 400.4 361 352 367v1 72c0 22.1-17.9 40-40 40H264c-22.1 0-40-17.9-40-40V368H192v72c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V368H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64h48 32 48 32 48 32 32c44.2 0 80-35.8 80-80V224 192 176c0-35.3 28.7-64 64-64c53 0 96 43 96 96v16c0 35.3-28.7 64-64 64H480zM272 368v64h32V368H272zm-160 0v64h32V368H112zM496 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faPencilMechanical = {
  prefix: 'far',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", "M500.7 36.7L475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L389.5 42.5c-4.3-1.6-8.9-2.5-13.5-2.5c-10.2 0-20.1 4.1-27.3 11.3L317 83 287.6 53.7c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2C67 333 62.8 340.1 60.6 348L32.8 445.3 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7L164 451.4c7.8-2.2 15-6.4 20.8-12.2L460.7 163.3c7.2-7.2 11.3-17.1 11.3-27.3c0-4.7-.8-9.3-2.5-13.5l31.1-31.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3zM376 91.9L420.1 136 183 373.1 138.9 329 376 91.9zM89.1 422.9l16.9-59 42.2 42.2-59 16.9z"]
};
var faUpDown = {
  prefix: 'far',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M111.7 6.4c9.2-8.5 23.4-8.5 32.6 0l96.8 89.4c9.5 8.8 14.9 21.1 14.9 34c0 25.5-20.7 46.3-46.3 46.3H200V336h9.7c25.5 0 46.3 20.7 46.3 46.3c0 12.9-5.4 25.2-14.9 34l-96.8 89.4c-9.2 8.5-23.4 8.5-32.6 0L14.9 416.2C5.4 407.5 0 395.2 0 382.3C0 356.7 20.7 336 46.3 336H56V176H46.3C20.7 176 0 155.3 0 129.7c0-12.9 5.4-25.2 14.9-34L111.7 6.4zM50.7 128H80c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H50.7L128 455.3 205.3 384H176c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24h29.3L128 56.7 50.7 128zM47.4 381s0 0 0 0l-1.2 1.3 1.2-1.3 0 0z"]
};
var faArrowsAltV = faUpDown;
var faCloudMoonRain = {
  prefix: 'far',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M353.6 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.2 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C417 0 363.5 46.5 353.6 107.6zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zM128.1 192c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7v1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9v30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.2 0-.4 0-.6 0c-.1 0-.2 0-.4 0H98.9c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 201 .1 240.5 .1 288c0 53 43 96 96 96c1.1 0 2.2 0 3.2-.1h266c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4v-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7V208c0-2.9-.5-5.7-1.5-8.3c-7.7-40.8-43.4-71.7-86.5-71.7c-14.7 0-28.5 3.6-40.6 9.9C238.1 112.6 209.1 96 176.1 96z"]
};
var faBoothCurtain = {
  prefix: 'far',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", "M56 48c-4.4 0-8 3.6-8 8V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H58h.2 .2 .2 .2 .2H59h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H61h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H63h.2 .2 .2 .2H64h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H66h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H68h.2 .2 .2 .2H69h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H71h.2 .2 .2 .2H72h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H75h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H78h.2 .2 .2 .2H79h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H82h.2 .2 .2 .2H83h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H86h.2 .2 .2 .2H87h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H90h.2 .2 .2 .2H91h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H94h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H97h.2 .2 .2 .2H98h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1V48h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H142h-.1-.1-.1-.1-.1-.1-.1H141h-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1H139h-.1-.1-.1-.1-.1-.1-.1H138h-.1-.1-.1-.1-.1-.1H137h-.1-.1-.1-.1-.1-.1H136h-.1-.1-.1-.1-.1-.1H135h-.1-.1-.1-.1-.1-.1H134h-.1-.1-.1-.1-.1-.1H133h-.1-.1-.1-.1-.1-.1H132h-.1-.1-.1-.2-.2-.2-.2-.2-.2-.2-.2-.2H130h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H128h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H126h-.2-.2-.2-.2-.2H125h-.2-.2-.2-.2-.2H124h-.2-.2-.2-.2-.2H123h-.2-.2-.2-.2-.2H122h-.2-.2-.2-.2-.2H121h-.2-.2-.2-.2-.2H120h-.2-.2-.2-.2-.2H119h-.2-.2-.2-.2-.2H118h-.2-.2-.2-.2-.2H117h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H114h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H111h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H109h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H107h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H105h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H103h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H100h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H98h-.2-.2-.2-.2H97h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H94h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H91h-.2-.2-.2-.2H90h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H87h-.2-.2-.2-.2H86h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H83h-.2-.2-.2-.2H82h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H79h-.2-.2-.2-.2H78h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H75h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H72h-.2-.2-.2-.2H71h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H69h-.2-.2-.2-.2H68h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H66h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H64h-.2-.2-.2-.2H63h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H61h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H59h-.2-.2-.2-.2-.2H58h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H56zM416 0h40c30.9 0 56 25.1 56 56V96 392v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V459.9c-7.5 2.7-15.6 4.1-24 4.1c-18.4 0-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3s-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3c-39.8 0-72-32.2-72-72V32c0-17.7 14.3-32 32-32h64 48 48 7.8H416zM368 48H320V392c0 13.3 10.7 24 24 24s24-10.7 24-24V48zm96 344V96 56c0-4.4-3.6-8-8-8H416V96 392c0 13.3 10.7 24 24 24s24-10.7 24-24zm-240 0c0 13.3 10.7 24 24 24s24-10.7 24-24V48H224V392z"]
};
var faCalendar = {
  prefix: 'far',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"]
};
var faBoxHeart = {
  prefix: 'far',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M248 80h94.4c6.3 0 12.1 3.7 14.6 9.5L388.4 160H248V80zM48 208H400V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208zm152-48H59.6L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5H200v80zM400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM212.7 404.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 267.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z"]
};
var faTrailer = {
  prefix: 'far',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M64 80H496c8.8 0 16 7.2 16 16V336H275.2c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM288 384H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H560V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H96c0 53 43 96 96 96s96-43 96-96zM136 112c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V280c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V280c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zM144 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faUserDoctorMessage = {
  prefix: 'far',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", "M144 128a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128A128 128 0 1 1 224 0a128 128 0 1 1 0 256zm-48 96c-5.4 0-10.8 .3-16 1v49.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7v-41c-46.9 19-80 65-80 118.7v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-97.2 78.8-176 176-176h96c97.2 0 176 78.8 176 176v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-53.7-33.1-99.7-80-118.7V402c27.6 7.1 48 32.2 48 62v32c0 8.8-7.2 16-16 16H328c-8.8 0-16-7.2-16-16s7.2-16 16-16h8V464c0-17.7-14.3-32-32-32s-32 14.3-32 32v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V464c0-29.8 20.4-54.9 48-62V353c-5.2-.7-10.6-1-16-1H176zm-8 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM432 0H592c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H544l-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2V224H432c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48z"]
};
var faUserMdChat = faUserDoctorMessage;
var faBahai = {
  prefix: 'far',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M288 0c10.9 0 20.4 7.3 23.2 17.8l28.1 105.3 89.2-62.6c8.9-6.2 20.9-5.7 29.2 1.3s10.9 18.7 6.3 28.6L417.8 189l108.6 9.4c10.8 .9 19.7 9 21.6 19.7s-3.7 21.3-13.5 25.9L435.6 290l77.2 77c7.7 7.7 9.3 19.6 3.8 29s-16.5 14-27 11.2L384.4 378.8 394 487.4c1 10.8-5.5 21-15.7 24.7s-21.7 .1-27.9-8.8L288 413.9l-62.4 89.4c-6.2 8.9-17.7 12.5-27.9 8.8s-16.7-13.8-15.7-24.7l9.6-108.6L86.4 407.2c-10.5 2.8-21.6-1.8-27-11.2s-3.9-21.3 3.8-29l77.2-77L41.5 244.1c-9.9-4.6-15.4-15.2-13.5-25.9s10.7-18.8 21.6-19.7L158.2 189 112 90.3c-4.6-9.8-2-21.6 6.3-28.6s20.3-7.5 29.2-1.3l89.2 62.6L264.8 17.8C267.6 7.3 277.1 0 288 0zm0 117.1l-13.7 51.6c-2 7.6-7.6 13.7-15 16.4s-15.6 1.6-22-2.9l-43.7-30.7 22.6 48.3c3.3 7.1 3 15.4-1 22.2s-10.9 11.2-18.7 11.9l-53.2 4.6L191.8 261c7.1 3.3 12.2 9.9 13.5 17.6s-1.1 15.6-6.7 21.2l-37.8 37.7 51.5-13.9c7.6-2 15.7-.2 21.7 4.8s9.2 12.7 8.5 20.5L237.8 402l30.6-43.7c4.5-6.4 11.8-10.3 19.7-10.3s15.2 3.8 19.7 10.3L338.2 402l-4.7-53.1c-.7-7.8 2.5-15.5 8.5-20.5s14.1-6.8 21.7-4.8l51.5 13.9-37.8-37.7c-5.5-5.5-8-13.4-6.7-21.2s6.4-14.3 13.5-17.6l48.4-22.5-53.2-4.6c-7.8-.7-14.8-5.1-18.7-11.9s-4.3-15.1-1-22.2l22.6-48.3-43.7 30.7c-6.4 4.5-14.6 5.6-22 2.9s-13-8.8-15-16.4L288 117.1z"]
};
var faHaykal = faBahai;
var faLighthouse = {
  prefix: 'far',
  iconName: 'lighthouse',
  icon: [640, 512, [], "e612", "M33.5 1.9l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48C2.4 40.8-3.3 26.7 1.9 14.5S21.3-3.3 33.5 1.9zm112 204.1l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5zM308.6 2.9c7.1-3.8 15.7-3.8 22.8 0l104 56c11.7 6.3 16 20.8 9.8 32.5c-5.7 10.6-18.2 15.1-29.1 11.3V128H368V77.1L320 51.3 272 77.1V128H224V102.6c-11 3.9-23.4-.7-29.1-11.3c-6.3-11.7-1.9-26.2 9.8-32.5l104-56zM263.4 208L212.2 464H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v48h75.8L376.6 208H263.4zM352 512H288 189.1 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h11.2l51.2-256.1c-12.5-.8-22.4-11.2-22.4-23.9c0-13.3 10.7-24 24-24h8H416h8c13.3 0 24 10.7 24 24c0 12.7-9.9 23.1-22.4 23.9L476.8 464H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H450.9 352zM638.1 14.6c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6zm-156.1 160c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5z"]
};
var faAmpGuitar = {
  prefix: 'far',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M256 0c-48.9 0-92.5 28.8-121.6 53.8c-10.7 9.2-20 18.3-27.5 26.2H64C28.7 80 0 108.7 0 144v80 24 24V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V272 248 224 144c0-35.3-28.7-64-64-64H405.1c-7.5-7.9-16.8-17.1-27.5-26.2C348.5 28.8 304.9 0 256 0zm0 48c26.4 0 53.6 13.8 77.7 32H178.3c24.1-18.2 51.4-32 77.7-32zM464 272V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V272H464zm0-48H48V144c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16v80zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM384 304a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm288-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
var faSdCard = {
  prefix: 'far',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M336 64V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V154.5c0-4.2 1.7-8.3 4.7-11.3l90.5-90.5c3-3 7.1-4.7 11.3-4.7H320c8.8 0 16 7.2 16 16zm48 384V64c0-35.3-28.7-64-64-64H154.5c-17 0-33.3 6.7-45.3 18.7L18.7 109.3C6.7 121.3 0 137.5 0 154.5V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64zM176 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96z"]
};
var faVolumeSlash = {
  prefix: 'far',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V61.8C352 45.3 338.7 32 322.2 32c-7.3 0-14.3 2.7-19.8 7.5L199.5 131 38.8 5.1zm199.1 156L304 102.3V213l-66.1-51.8zM32 216v80c0 30.9 25.1 56 56 56h78.9L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8V373.3l-48-37.8v74.2L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1H88c-4.4 0-8-3.6-8-8V216c0-4.4 3.6-8 8-8h54.2L81.7 160.4C53.7 163.5 32 187.2 32 216z"]
};
var faBorderBottom = {
  prefix: 'far',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 456c0 13.3-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24zM384 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0A32 32 0 1 1 0 160zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faWifiWeak = {
  prefix: 'far',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", "M264 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
var faWifi1 = faWifiWeak;
var faDragon = {
  prefix: 'far',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M273 17c3.1-10.1 12.4-17 23-17H424h24 27.8c35 0 68.3 15.3 91.1 41.9l56 65.4c11 12.8 17 29.1 17 46c0 39.1-31.7 70.7-70.7 70.7H546.5c-23.3 0-45.7-9.3-62.2-25.8l-3.9-3.9c1.7 12.7 8.4 24.3 18.8 32L592 296c30.2 22.7 48 58.2 48 96c0 66.3-53.7 120-120 120H432 56.5C27.7 512.3 3 490.4 .2 461.3c-2.9-30.8 19.7-58.1 50.5-61l345.6-32.6-12-13.1C353.3 320.6 336 276.2 336 230.2V188.1v0l0-.1v0l0-32-49.7-22.1c-8.3-3.7-13.8-11.8-14.2-20.9s4.4-17.6 12.3-22l37.6-20.9L282.7 44C273.9 38.1 270 27.2 273 17zM375.3 48l6 4c7 4.6 11 12.6 10.7 20.9s-5 15.9-12.3 20l-29.9 16.6 20 8.9c8.7 3.9 14.3 12.4 14.3 21.9l0 47.5v0l0 .1v0 42.1c0 34 12.8 66.8 35.7 91.9l44.6 48.7c6.2 6.7 8 16.3 4.7 24.8s-11.1 14.4-20.1 15.3L55.2 448c-4.4 .4-7.6 4.3-7.2 8.7c.4 4.2 3.9 7.3 8 7.3l.3 0v0H432h88c39.8 0 72-32.2 72-72c0-22.7-10.7-44-28.8-57.6l-92.8-69.6C446.2 246.7 432 218.2 432 188V168c0-13.3 10.7-24 24-24h32c6.4 0 12.5 2.5 17 7l13.3 13.3c7.5 7.5 17.7 11.7 28.3 11.7h22.8c12.5 0 22.7-10.2 22.7-22.7c0-5.4-1.9-10.7-5.5-14.8l-56-65.4C516.8 57.2 496.9 48 475.8 48H448 424 375.3zM514.6 95.2c-1.8 2.2-4 4.1-6.6 5.6c-11.5 6.6-26.2 2.7-32.8-8.8c-1.3-2.3-2.2-4.8-2.7-7.3c-.9-4.6 3.7-7.7 8.3-6.5l29.6 7.4c4.5 1.1 7.2 6 4.2 9.6zM520 79.5v.9c0-.3 0-.6 0-.9zM189.4 112.4L304 188.8v41.4c0 31.2 6.8 61.8 19.5 89.8H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1z"]
};
var faShoePrints = {
  prefix: 'far',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M323.7 62.6C355.1 54.7 390.3 48 416 48c41.2 0 89.8 10.6 126.5 28.9C582 96.7 592 116.3 592 128c0 9.4-5.1 21.5-35.9 33.1c-29.4 11.1-67 14.9-92.1 14.9c-34.7 0-53.5-10.4-80.2-25.7l-.7-.4c-20.6-11.8-45.1-25.8-79.1-33V67.8c6-1.7 12.7-3.4 19.7-5.2zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32v80 48h0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zm67.7 353.4c-7-1.8-13.7-3.5-19.7-5.2V395.1c34-7.3 58.5-21.3 79.1-33l.7-.4C282.5 346.4 301.3 336 336 336c25.2 0 62.7 3.7 92.1 14.9C458.9 362.5 464 374.6 464 384c0 11.7-10 31.3-49.5 51.1C377.8 453.4 329.2 464 288 464c-25.7 0-60.9-6.7-92.3-14.6zM128 352h0v48 80s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"]
};
var faCirclePlus = {
  prefix: 'far',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faPlusCircle = faCirclePlus;
var faFaceGrinTongueWink = {
  prefix: 'far',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4V363.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faHandHolding = {
  prefix: 'far',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M165.2 358.7c6.6-4.4 14.3-6.7 22.2-6.7H344c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 256c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 24 48c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9h7.4c6.8 0 12.3 5.5 12.3 12.3c0 4.2-2.1 8-5.6 10.3l-95.6 61.9C415.1 460 401.5 464 387.7 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H387.7c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6c0-33.3-27-60.3-60.3-60.3h-7.4c-12.5 0-24.8 3.5-35.5 10L408 370c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64H187.4c-17.4 0-34.4 5.1-48.8 14.8L64.7 368H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H72c4.7 0 9.4-1.4 13.3-4l79.9-53.3z"]
};
var faPlugCircleExclamation = {
  prefix: 'far',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24v88h48V24zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v88h48V24zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64c0 80.2 59 146.6 136 158.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V414.2c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112V192H304v55.2c13.8-14.6 30-26.8 48-36V192h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H304 80 32 24zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faLinkSlash = {
  prefix: 'far',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l91-91c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6l-95.1 95.1-45.5-35.7c24.2-53.3 14.1-117.9-29.3-161.3c-52.1-52.1-134.4-55.9-190.8-11.2L38.8 5.1zm186.3 146c36.9-22.3 85.6-17.6 117.4 14.3c26 26 34 63.3 23.7 96.4L225.1 151.1zM406.9 416.6l-54.2-42.7c-20.2-2.7-39.7-11.7-55.2-27.3c-9.8-9.8-17-21.2-21.7-33.3l-54.2-42.7c-2.2 39.6 11.9 79.9 41.9 109.9c38.8 38.8 94.2 50.8 143.4 36zM116.6 187.9L59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6l60.9-60.9-38-29.9z"]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faClone = {
  prefix: 'far',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"]
};
var faPersonWalkingArrowLoopLeft = {
  prefix: 'far',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128h-4.9c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM447 449c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-39-39H484c86.2 0 156-69.8 156-156s-69.8-156-156-156L344 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l140 0c59.6 0 108 48.4 108 108s-48.4 108-108 108H441.9l39-39c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9l80 80z"]
};
var faArrowUpZA = {
  prefix: 'far',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", "M352 32H480c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8L405.4 176H480c13.3 0 24 10.7 24 24s-10.7 24-24 24H352c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8L426.6 80H352c-13.3 0-24-10.7-24-24s10.7-24 24-24zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V113.9L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM416 272c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-13.6-27.2c-1.6 .3-3.2 .5-4.9 .5H370.8l-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160c4.1-8.1 12.4-13.3 21.5-13.3zM394.8 392h42.3L416 349.7 394.8 392z"]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faFireFlameCurved = {
  prefix: 'far',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M53.9 186.1C19.4 220.6 0 267.4 0 316.2v11.5C0 429.5 82.5 512 184.3 512h15.1C301.4 512 384 429.4 384 327.4c0-66.1-27.1-129.2-74.9-174.8L230.9 78.2C221.4 69.1 216 56.6 216 43.4V37.3v-16C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5L168 21.3l-9.9 13.2c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.3 3.9-.5 7.8-.4 11.7c.2 22.9 6.6 45.4 18.4 65c2.2 3.7 4.6 7.2 7.2 10.6L168 213.3l21.2 28.3c7 9.3 10.8 20.7 10.8 32.4v14c0 22.1-17.9 40-40 40s-40-17.9-40-40V229.3v-2.5V188.3c0-15.6-12.7-28.3-28.3-28.3c-1.3 0-2.6 .1-3.9 .3c-6 .8-11.7 3.6-16.1 8L53.9 186.1zm18.1 53V288c0 48.6 39.4 88 88 88s88-39.4 88-88V274c0-22.1-7.2-43.5-20.4-61.2l-32-42.7c-11.8-15.7-17.4-35.1-15.7-54.6l.9-10.8c.3-3.6 .8-7.2 1.6-10.7c4.3 6.9 9.4 13.3 15.4 18.9l33.1-34.8-33.1 34.8L276 187.4c38.3 36.5 60 87.1 60 140C336 402.9 274.9 464 199.4 464H184.3C109 464 48 403 48 327.7V316.2c0-27.7 8.5-54.6 24-77.2z"]
};
var faFireAlt = faFireFlameCurved;
var faTornado = {
  prefix: 'far',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M332.4 48H48c.3 28 6.3 55.1 17 80H304.1c-.1-1.8-.1-3.6-.1-5.4C304 95 314.2 68.5 332.4 48zM317.5 176H94c15.5 19.3 34.6 35.9 56.6 48.9L203.5 256H376l-49.6-66.1c-3.3-4.4-6.3-9.1-8.9-13.9zm80.9 128H282.9c19.9 15.1 36.1 34.6 47.3 57c8.9 17.8 14.4 37 16.4 56.5l23.6-23.6c19.1-19.1 29.8-45 29.8-72c0-6-.5-12.1-1.6-17.9zm5.7 123.9L340 492l-.4 .4L336 496l-10.1 10.1c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l2.4-14.1 .8-5 .1-.5 2.7-16c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6V32C0 14.3 14.3 0 32 0H393.4C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16L370.8 77.2c-12 12-18.8 28.4-18.8 45.4c0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9c0 39.7-15.8 77.8-43.9 105.9z"]
};
var faFileCirclePlus = {
  prefix: 'far',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M64 464H284.5c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3v44.1c-17.2 4.9-33.4 12.3-48 21.8V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faDeleteRight = {
  prefix: 'far',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", "M370.7 64c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64H370.7zM48 128V384c0 8.8 7.2 16 16 16H370.7c4.2 0 8.3-1.7 11.3-4.7L521.4 256 382.1 116.7c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16zm95 47c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faBookQuran = {
  prefix: 'far',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M360 0c48.6 0 88 39.4 88 88V424h-.4c.3 2.6 .4 5.3 .4 8c0 44.2-35.8 80-80 80H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V394.6c-18.9-9-32-28.3-32-50.6V56C0 25.1 25.1 0 56 0H360zM80 400v64H368c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm288-48c11.4 0 22.2 2.4 32 6.7V88c0-22.1-17.9-40-40-40H56c-4.4 0-8 3.6-8 8V344c0 4.4 3.6 8 8 8H368zM282.1 150.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L312 199.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L288 217.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zm-24.6-45.6c4.1 1.8 6.5 5.9 6.5 10.3c0 7.6-7.1 13.2-14.7 13.1c-.4 0-.8 0-1.3 0c-39.8 0-72 32.2-72 72s32.2 72 72 72c.4 0 .8 0 1.3 0c7.6-.1 14.7 5.5 14.7 13.1c0 4.4-2.4 8.5-6.5 10.3c-12.7 5.5-26.8 8.6-41.5 8.6c-57.4 0-104-46.6-104-104s46.6-104 104-104c14.8 0 28.8 3.1 41.5 8.6z"]
};
var faQuran = faBookQuran;
var faCircleQuarter = {
  prefix: 'far',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M208 53.6V208L53.6 208C71.6 131.7 131.7 71.6 208 53.6zM2 224.1C-.2 241.6 14.3 256 32 256l192 0c17.7 0 32-14.3 32-32V32c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z"]
};
var faAnchor = {
  prefix: 'far',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6v32H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V464H240c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512h48 48c100.2 0 181.8-80.2 184-179.9l16.4 14.1c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.2-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.3-14C469.7 405.4 409.7 464 336 464H312V240h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H312V160c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80z"]
};
var faBorderAll = {
  prefix: 'far',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 80c8.8 0 16 7.2 16 16V232H248V80H384zm16 200V416c0 8.8-7.2 16-16 16H248V280H400zM200 232H48V96c0-8.8 7.2-16 16-16H200V232zM48 280H200V432H64c-8.8 0-16-7.2-16-16V280zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFunction = {
  prefix: 'far',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M72 88c0-48.6 39.4-88 88-88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H160c-22.1 0-40 17.9-40 40V192h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120V390.7c0 44.8-33.7 82.5-78.3 87.5l-15.1 1.7c-13.2 1.5-25-8-26.5-21.2s8-25 21.2-26.5l15.1-1.7C56.7 428.2 72 411.1 72 390.7V240H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H72V88zm244.3 76.8C288.4 209.1 272 262.5 272 320s16.4 110.9 44.3 155.2c7.1 11.2 3.7 26-7.5 33.1s-26 3.7-33.1-7.5C243 448.9 224 386.7 224 320s19-128.9 51.7-180.8c7.1-11.2 21.9-14.6 33.1-7.5s14.6 21.9 7.5 33.1zm231.4 0c-7.1-11.2-3.7-26 7.5-33.1s26-3.7 33.1 7.5C621 191.1 640 253.3 640 320s-19 128.9-51.7 180.8c-7.1 11.2-21.9 14.6-33.1 7.5s-14.6-21.9-7.5-33.1C575.6 430.9 592 377.5 592 320s-16.4-110.9-44.3-155.2zM393 247l39 39 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faFaceAngry = {
  prefix: 'far',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faAngry = faFaceAngry;
var faPeopleSimple = {
  prefix: 'far',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM73.7 237.3l-4.1 49.3C68.8 296 76.2 304 85.6 304H88h80 2.4c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C180.9 220.8 167 208 150.4 208H105.6c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H112V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM352.9 219.6L319.6 336H448.4L415.1 219.6c-2-6.9-8.2-11.6-15.4-11.6H368.3c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H368V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V384H298.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]
};
var faCookieBite = {
  prefix: 'far',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M182.8 28.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4zm34.9 37.5c19 54.5 63.9 96.7 120 111.9c17.7 50.9 58.1 91.1 109.1 108.7c-1 4.8-2.5 9.5-4.7 13.9L405.4 376c-5.4 11-14.1 20.1-24.8 25.8l-74 39.5c-10.8 5.7-23 7.9-35.1 6.2l-83-11.7c-12-1.7-23.3-7.2-32-15.7l-29.7 30.7 29.7-30.7L96.2 361.7c-8.8-8.5-14.7-19.6-16.8-31.7L64.9 247.2c-2.1-12.1-.4-24.6 5-35.6L106.6 136c5.4-11 14.1-20.1 24.8-25.8l74-39.5c3.9-2.1 8.1-3.7 12.4-4.9zM192 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faArrowTrendDown = {
  prefix: 'far',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", "M352 392c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24V334.1L337 143c-9.4-9.4-24.6-9.4-33.9 0l-111 111L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 305c9.4 9.4 24.6 9.4 33.9 0l111-111L494.1 368H376c-13.3 0-24 10.7-24 24z"]
};
var faRss = {
  prefix: 'far',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M0 56C0 42.7 10.7 32 24 32c234.2 0 424 189.8 424 424c0 13.3-10.7 24-24 24s-24-10.7-24-24C400 248.3 231.7 80 24 80C10.7 80 0 69.3 0 56zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM24 176c154.6 0 280 125.4 280 280c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1-103.9-232-232-232c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFeed = faRss;
var faFaceMonocle = {
  prefix: 'far',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M448 336.1V224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v86.5C377.8 434.8 320.3 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c16.7 0 32.9 2 48.4 5.7c-6.9 2.8-13.3 6.6-19.2 11.2L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c5.7 3.8 12.9 3.5 18.2-.3c48 38.1 78.7 96.9 78.7 163c0 28.4-5.7 55.5-16 80.1zm3.9 84.7C489.4 376.3 512 318.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336c-8.8 0-16 7.2-16 16z"]
};
var faDrawPolygon = {
  prefix: 'far',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zm8 59.3V356.7c16 6.5 28.9 19.3 35.3 35.3H324.7c2.1-5.2 4.9-10.1 8.2-14.5L298 319.2c-3.2 .5-6.6 .8-10 .8c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.7 .3 10 .8l34.9-58.2c-3.3-4.4-6.1-9.3-8.2-14.5H123.3c-6.5 16-19.3 28.9-35.3 35.3zM374.1 352.8c3.2-.5 6.6-.8 9.9-.8c35.3 0 64 28.7 64 64s-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40H123.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V155.3C16.5 145.9 0 122.9 0 96C0 60.7 28.7 32 64 32c26.9 0 49.9 16.5 59.3 40H324.7c9.5-23.5 32.5-40 59.3-40c35.3 0 64 28.7 64 64s-28.7 64-64 64c-3.4 0-6.7-.3-9.9-.8l-34.9 58.2c8.1 10.7 12.9 24.1 12.9 38.5s-4.8 27.8-12.9 38.5l34.9 58.2zM400 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm336-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faScaleBalanced = {
  prefix: 'far',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M520 48H393.3C381 19.7 352.8 0 320 0s-61 19.7-73.3 48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H241.6c5.8 28.6 26.9 51.7 54.4 60.3V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H320 520c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V156.3c27.5-8.6 48.6-31.7 54.4-60.3H520c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 147.8L584.4 320H439.6L512 195.8zM386 337.1C396.8 382 449.1 416 512 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 305.1c-5.7 9.8-9.3 21.1-6.7 32.1zM54.4 320l72.4-124.2L199.3 320H54.4zm72.4 96c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L150.9 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L7.6 305.1c-5.7 9.8-9.3 21.1-6.7 32.1C11.7 382 64 416 126.8 416zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBalanceScale = faScaleBalanced;
var faCalendarLines = {
  prefix: 'far',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm48 88c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]
};
var faCalendarNote = faCalendarLines;
var faArrowDownBigSmall = {
  prefix: 'far',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", "M143 473L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55V56c0-13.3 10.7-24 24-24s24 10.7 24 24V398.1l55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zM368 368v64h64V368H368zm-48 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V368zm48-160H496V80L368 80V208zm-48 0V80c0-26.5 21.5-48 48-48H496c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z"]
};
var faSortSizeDown = faArrowDownBigSmall;
var faGaugeSimpleHigh = {
  prefix: 'far',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56s56-25.1 56-56z"]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faDoNotEnter = {
  prefix: 'far',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128-48H384c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32z"]
};
var faShower = {
  prefix: 'far',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M48 123.9C48 99.6 67.6 80 91.9 80c11.6 0 22.8 4.6 31 12.9l6.7 6.7c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8 .8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-.8 .8L303.4 81l-.2-.2c-37.9-37.9-96.2-43-139.6-15.1l-6.7-6.7C139.6 41.7 116.3 32 91.9 32C41.1 32 0 73.1 0 123.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V123.9zM269.5 115l6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2 .2 0 0zM416 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faDiceD8 = {
  prefix: 'far',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", "M239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7zM126.2 324.3L232 430.1V368L126.2 324.3zM280 368v62L385.8 324.3 280 368zM445.6 247.6L280 81.9V316.1l165.6-68.5zM232 81.9L66.4 247.6 232 316.1V81.9z"]
};
var faDesktop = {
  prefix: 'far',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16zm64 208v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48z"]
};
var faDesktopAlt = faDesktop;
var faM = {
  prefix: 'far',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M17.1 33C27.3 30 38.2 34 44 42.8L224 316.3 403.9 42.8C409.8 34 420.7 30 430.9 33S448 45.4 448 56V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V136.1l-156 237c-4.4 6.7-12 10.8-20 10.8s-15.6-4.1-20-10.8L48 136.1V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 45.4 7 36.1 17.1 33z"]
};
var faGripDotsVertical = {
  prefix: 'far',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", "M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFaceViewfinder = {
  prefix: 'far',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M0 56v80c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-4.4 3.6-8 8-8h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C25.1 0 0 25.1 0 56zM352 24c0 13.3 10.7 24 24 24h80c4.4 0 8 3.6 8 8v80c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-30.9-25.1-56-56-56H376c-13.3 0-24 10.7-24 24zM24 352c-13.3 0-24 10.7-24 24v80c0 30.9 25.1 56 56 56h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-4.4 0-8-3.6-8-8V376c0-13.3-10.7-24-24-24zm464 0c-13.3 0-24 10.7-24 24v80c0 4.4-3.6 8-8 8H376c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c30.9 0 56-25.1 56-56V376c0-13.3-10.7-24-24-24zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 280c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z"]
};
var faSoftServe = {
  prefix: 'far',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M192 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7H140c-42 0-76 34-76 76c0 5.4 .6 10.7 1.7 15.8C27.7 167.2 0 202.3 0 244c0 34.9 19.4 65.2 48 80.8V352c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5H259.4c16.3 0 30-12.3 31.8-28.5L302.2 384H304c17.7 0 32-14.3 32-32V324.8c28.6-15.6 48-45.9 48-80.8c0-41.9-28.1-77.3-66.4-88.4c1.6-6.3 2.4-12.8 2.4-19.6v-8C320 57.3 262.7 0 192 0zM292 288H92c-24.3 0-44-19.7-44-44s19.7-44 44-44h4 6.5H112c13.3 0 24-10.7 24-24c0-12.3-9.3-22.5-21.2-23.8c-1.8-3.7-2.8-7.8-2.8-12.2c0-15.5 12.5-28 28-28h37.3c29.7 0 53.9-23.7 54.7-53.3c23.9 13.8 40 39.7 40 69.3v8c0 5.8-1.5 11.3-4.3 16H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h63.2H288h4c24.3 0 44 19.7 44 44s-19.7 44-44 44z"]
};
var faCreemee = faSoftServe;
var faH5 = {
  prefix: 'far',
  iconName: 'h5',
  icon: [640, 512, [], "e412", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM440 64c-11.4 0-21.3 8.1-23.5 19.3l-32 160c-1.4 7.1 .4 14.4 5 19.9s11.4 8.8 18.6 8.8H528c35.3 0 64 28.7 64 64s-28.7 64-64 64H464.4c-13.8 0-26-8.8-30.4-21.9l-3.2-9.7c-4.2-12.6-17.8-19.4-30.4-15.2s-19.4 17.8-15.2 30.4l3.2 9.7C399.4 426 429.9 448 464.4 448H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H437.3l22.4-112H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H440z"]
};
var faHandBackPointDown = {
  prefix: 'far',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M144 512c-35.3 0-64-28.7-64-64l0-188.8c-5.2-3.6-10.2-7.6-14.9-11.9L44.8 228.8C26.5 212.1 16 188.5 16 163.7l0-10.2C16 99.5 44.7 49.5 91.4 22.2L94 20.7C117.3 7.1 143.7 0 170.6 0L296 0c66.3 0 120 53.7 120 120l0 8 0 96c0 35.3-28.7 64-64 64c-2.8 0-5.6-.2-8.3-.5c-11 19.4-31.8 32.5-55.7 32.5c-5.3 0-10.5-.7-15.5-1.9c-10.8 20.2-32 33.9-56.5 33.9c-2.7 0-5.4-.2-8-.5l0 96.5c0 35.3-28.7 64-64 64zm-16-64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-136c0-10.3 6.6-19.5 16.4-22.8s20.6 .1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4c8.8 0 16-7.2 16-16l0-8c0-10.3 6.6-19.5 16.4-22.8s20.6 .1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4c8.8 0 16-7.2 16-16c0-9.1 5.1-17.4 13.3-21.5s17.9-3.2 25.1 2.3c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16l0-96 0-8c0-39.8-32.2-72-72-72L170.6 48c-18.4 0-36.5 4.9-52.4 14.2l-11.7-20 11.7 20-2.6 1.5C83.6 82.3 64 116.5 64 153.5l0 10.2c0 11.3 4.8 22 13.1 29.6L96 210.5 96 168c0-8.8 7.2-16 16-16s16 7.2 16 16l0 78 0 2 0 200z"]
};
var faTableList = {
  prefix: 'far',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", "M192 80v88H464V96c0-8.8-7.2-16-16-16H192zm-48 0H64c-8.8 0-16 7.2-16 16v72h96V80zM48 216v80h96V216H48zm0 128v72c0 8.8 7.2 16 16 16h80V344H48zm144 88H448c8.8 0 16-7.2 16-16V344H192v88zM464 296V216H192v80H464zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faThList = faTableList;
var faCommentSms = {
  prefix: 'far',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM204.2 180.6c-4.9 1.6-8.2 6.2-8.2 11.4v96c0 6.6 5.4 12 12 12s12-5.4 12-12V228l26.4 35.2c2.3 3 5.8 4.8 9.6 4.8s7.3-1.8 9.6-4.8L292 228v60c0 6.6 5.4 12 12 12s12-5.4 12-12V192c0-5.2-3.3-9.8-8.2-11.4s-10.3 .1-13.4 4.2L256 236l-38.4-51.2c-3.1-4.1-8.5-5.8-13.4-4.2zM116 214.9c0-3.1 1.3-5.3 4.8-7.4c3.9-2.3 9.6-3.6 15-3.5c6.9 .1 17.4 1.7 24.3 3.5c6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8.6-2.3-21-4.2-30.1-4.3c-8.7-.1-19 1.8-27.6 6.8C99.6 192.2 92 201.5 92 215c.1 12.9 7.6 21.1 15.8 26c7.2 4.3 16.2 7 23.5 9.2l1.1 .3c8.4 2.5 14.6 4.6 19 7.3c3.7 2.3 4.5 4.1 4.5 6.6c.1 3.9-1.5 6.3-4.6 8.2c-3.6 2.2-9.1 3.5-15 3.4c-7.9-.3-15.4-2.8-24.9-6l0 0c-1.3-.4-2.7-.9-4-1.4c-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.2 .4 2.4 .8 3.7 1.3l0 0 0 0c9.1 3.1 20.3 6.9 32 7.3c9.2 .3 19.8-1.6 28.5-7c9.2-5.7 16.1-15.4 15.9-28.9c-.2-12.9-7.4-21.3-15.8-26.6c-7.5-4.7-17-7.6-24.5-9.8l0 0-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2c-3.7-2.2-4.2-3.8-4.2-5.6zm240 0c0-3.1 1.3-5.3 4.8-7.4c3.9-2.3 9.6-3.6 15-3.5c6.6 .1 13.7 1.5 21.1 3.5c6.4 1.7 13-2.1 14.7-8.5s-2.1-13-8.5-14.7c-8-2.1-17.4-4.2-26.9-4.3c-8.7-.1-19 1.8-27.6 6.8c-9 5.3-16.6 14.6-16.5 28.1c.1 12.9 7.6 21.1 15.8 26c7.2 4.3 16.2 7 23.5 9.2l1.1 .3c8.4 2.5 14.6 4.6 19 7.3c3.7 2.3 4.5 4.1 4.5 6.6c0 3.9-1.5 6.3-4.6 8.2c-3.6 2.2-9.1 3.5-15 3.4c-7.6-.2-14.7-2.7-23.8-5.8l0 0 0 0c-1.5-.5-3.1-1.1-4.8-1.6c-6.3-2.1-13.1 1.3-15.2 7.6s1.3 13.1 7.6 15.2c1.3 .4 2.7 .9 4.1 1.4l0 0c8.9 3.1 19.8 6.8 31.3 7.2c9.2 .3 19.8-1.6 28.5-7c9.2-5.7 16.1-15.4 15.9-28.9c-.2-12.9-7.4-21.3-15.8-26.6c-7.5-4.7-17-7.6-24.5-9.8l-.4-.1c-8.5-2.6-14.8-4.5-19.2-7.2c-3.7-2.2-4.2-3.8-4.2-5.6z"]
};
var faSms = faCommentSms;
var faRectangle = {
  prefix: 'far',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M448 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faRectangleLandscape = faRectangle;
var faClipboardListCheck = {
  prefix: 'far',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm3.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4 99.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTurkey = {
  prefix: 'far',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.4 .2-.7 .4-1 .6l-28.3 20c-3.2 2.3-6.2 5-9 8.3C505.8 285.7 528 334.2 528 384c0 21-6.1 32.8-13.9 41c-8.9 9.4-23.9 18.1-47.3 24.8C418.6 463.6 354 464 288 464s-130.6-.4-178.8-14.2c-23.4-6.7-38.4-15.4-47.3-24.8C54.1 416.8 48 405 48 384c0-62 34.5-122 86-168.3C186.4 168.8 247.4 144 288 144c20.5 0 46.3 6.4 73.6 18.7c-15.2 .8-30.8-.5-45.8-2.1c-28.5-3-58.2 4.9-82.2 24.3c-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c18.6-15 31.1-34.8 37.2-56.2c.2-.7 .4-1.3 .6-2c9.6-33.7 20.1-70.5 48.7-90.6L486.7 192l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56z"]
};
var faBook = {
  prefix: 'far',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM152 112H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faUserPlus = {
  prefix: 'far',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112H49.3c8.9-63.3 63.3-112 129-112h91.4zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H224 178.3zM504 312c0 13.3 10.7 24 24 24s24-10.7 24-24V248h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552V136c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H440c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faIceSkate = {
  prefix: 'far',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M296 0c13.3 0 24 10.7 24 24V144v38l128.6 37.5c37.5 11 63.4 45.4 63.4 84.5v24c0 30.9-25.1 56-56 56H88c-30.9 0-56-25.1-56-56V136.4c0-25.2 16.8-47.3 41.1-54L272 27.5V24c0-13.3 10.7-24 24-24zM272 128V77.3L85.9 128.7c-3.5 1-5.9 4.1-5.9 7.7V328c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8V304c0-17.8-11.7-33.4-28.8-38.4L292.6 224H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h32zM552 408c13.3 0 24 10.7 24 24v8c0 39.8-32.2 72-72 72H408 120 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96V416h48v48H384V416h48v48h72c13.3 0 24-10.7 24-24v-8c0-13.3 10.7-24 24-24z"]
};
var faCheck = {
  prefix: 'far',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faBatteryThreeQuarters = {
  prefix: 'far',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", "M464 144c17.7 0 32 14.3 32 32V336c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"]
};
var faBattery4 = faBatteryThreeQuarters;
var faTomato = {
  prefix: 'far',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M241 7L224 24C241 7 241 7 241 7l0 0 0 0 .1 .1 .2 .2 .5 .5c.4 .4 1 1 1.7 1.8c1.4 1.5 3.2 3.6 5.4 6.3c4.4 5.4 10.1 13.1 15.8 22.8c6.6 11.2 13.4 25.5 18 42.1c45.7 3.1 88.5 14.2 125.1 32.8c6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3H365.9l15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4 150.3 190.7c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4c-4-7.9-.9-17.5 7-21.5l.8-.4C142.2 94.6 185.6 83.5 232 80.7c-2.6-6.4-5.6-12.3-8.7-17.6c-4.3-7.3-8.6-13-11.7-16.9c-1.6-1.9-2.8-3.4-3.6-4.3c-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5c-.4 6.6 .7 13.3 3.1 19.6C67.1 219.8 48 256.7 48 304c0 49.8 21.1 88 56.2 115c36.2 27.9 89.2 45 151.8 45s115.5-17.1 151.8-45c35.1-27 56.2-65.2 56.2-115c0-47.3-19.1-84.2-51.1-110.9c2.4-6.3 3.4-13 3.1-19.6c10.3-3.5 19.1-10.4 25-19.5c44 35.5 71.1 86.4 71.1 150c0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z"]
};
var faSwordLaser = {
  prefix: 'far',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L230.7 226.8l54.4 54.4L505.7 40.2zM185 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l.7 .7-59 59c0 0 0 0 0 0s0 0 0 0L10.3 407C3.7 413.7 0 422.6 0 432s3.7 18.3 10.3 25L55 501.7c6.6 6.6 15.6 10.3 25 10.3s18.3-3.7 25-10.3l82.3-82.3 59-59 .7 .7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96-96zm-20.3 143l-26.7-26.7 12.4-12.4 26.7 26.7-12.4 12.4zm-49.4-4.1l26.7 26.7L80 458.7 53.3 432l62.1-62.1zM173 312.3l12.7-12.7 26.7 26.7L199.7 339 173 312.3z"]
};
var faHouseCircleCheck = {
  prefix: 'far',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H394.8c-18.3-12.9-34.1-29.2-46.3-48H336v0H240V320h86.6c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2H232c-22.1 0-40 17.9-40 40V464H144c-17.7 0-32-14.3-32-32V204.8L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBuildings = {
  prefix: 'far',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M448 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448zM288 0c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H288zM192 128H72c-39.8 0-72 32.2-72 72V440c0 39.8 32.2 72 72 72H216.4c-11.8-13.2-20.1-29.7-23.1-48H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24H192V128zM112 320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H112zm224 16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v32zM112 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H112zM336 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm16 144h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16z"]
};
var faAngleLeft = {
  prefix: 'far',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"]
};
var faCartFlatbedBoxes = {
  prefix: 'far',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H72c4.4 0 8 3.6 8 8V408c0 30.9 25.1 56 56 56h24c0 26.5 21.5 48 48 48s48-21.5 48-48H448c0 26.5 21.5 48 48 48s48-21.5 48-48h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H496 208 136c-4.4 0-8-3.6-8-8V56c0-30.9-25.1-56-56-56H24zM240 80H368V304H240l0-224zm-48 0V304c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48zm368 0v64H496V80h64zM496 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H496zm0 240h96v32H496V272zm-48 0v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H496c-26.5 0-48 21.5-48 48z"]
};
var faDollyFlatbedAlt = faCartFlatbedBoxes;
var faDiagramSuccessor = {
  prefix: 'far',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM240 160c0 8.8-7.2 16-16 16L64 176c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l144 0 16 0c8.8 0 16 7.2 16 16l0 64zm48-64c0-5.5-.7-10.9-2-16l82 0c13.3 0 24 10.7 24 24l0 38.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-38.1c0-39.8-32.2-72-72-72L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64z"]
};
var faTruckArrowRight = {
  prefix: 'far',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H76.8c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48H320h32c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM480 512c-53 0-96-43-96-96h-8H352 320 256c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V96h42.7c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6V368h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3H416v96H558zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM241 95l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H112c-13.3 0-24-10.7-24-24s10.7-24 24-24H246.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faSquareW = {
  prefix: 'far',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm118.9 64.7L160 289.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 289.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 246.7 182.9 375.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"]
};
var faArrowsSplitUpAndLeft = {
  prefix: 'far',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", "M241 137c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55V384v8c0 39.8 32.2 72 72 72h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H416c-66.3 0-120-53.7-120-120v-8c0-39.8-32.2-72-72-72H81.9l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55H224c27 0 51.9 8.9 72 24V81.9l-55 55z"]
};
var faLamp = {
  prefix: 'far',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M2.5 211.7l80-192C87.4 7.8 99.1 0 112 0H336c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1zM56 208H392L325.3 48H122.7L56 208zm88 105.4V288h48v25.4c0 17-6.7 32-16.2 42.9C165.7 368 144 398.1 144 432c0 12.2 3.7 23.1 8.4 31.9c.6 .1 1.3 .1 2.1 .1h139c.8 0 1.5-.1 2.1-.1c4.6-8.8 8.4-19.7 8.4-31.9c0-32.3-22.1-63.8-32.6-76.4c-9.2-10.9-15.4-25.6-15.4-42V288h48v25.6c0 4.1 1.6 8 4.2 11.2c11.7 14 43.8 56.9 43.8 107.2c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-51.9 31.6-93.4 43.5-107.1c2.8-3.2 4.5-7.3 4.5-11.5z"]
};
var faAirplay = {
  prefix: 'far',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", "M480 80H96c-26.5 0-48 21.5-48 48V320c0 26.5 21.5 48 48 48h53.5l-34.7 34.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L426.5 368H480c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48zM198.6 432H377.4L288 342.6 198.6 432zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0z"]
};
var faHandFist = {
  prefix: 'far',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", "M112 80c8.8 0 16 7.2 16 16v80H112c-5.5 0-10.8 .6-16 1.6V96c0-8.8 7.2-16 16-16zm0 144h40 40c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4c10.4 21.3 32.3 36 57.6 36c5.2 0 10.2-.6 15-1.8c-4.4 32.4-23.8 60.1-51.1 75.9c-7.4 4.3-12 12.2-12 20.8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V379.9c38.7-27.5 64-72.8 64-123.9V208 192 160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C239.2 14.7 217.3 0 192 0s-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4C76.7 32 48 60.7 48 96V200c0 2.3 .3 4.6 1 6.7C38.3 220.3 32 237.4 32 256c0 64.2 39.8 119 96 141.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V380c0-11-7.4-20.5-18-23.2C113.1 345.2 80 304.4 80 256c0-17.7 14.3-32 32-32zm256-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V176 160c0-8.8 7.2-16 16-16s16 7.2 16 16v32zM176 176V96 64c0-8.8 7.2-16 16-16s16 7.2 16 16V96v80 2c-5.1-1.3-10.5-2-16-2H176zm80 0V96c0-8.8 7.2-16 16-16s16 7.2 16 16v64 16c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
var faFistRaised = faHandFist;
var faShieldQuartered = {
  prefix: 'far',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M73 127c-5.9 2.5-9.1 7.8-9 12.8c.1 17.9 1.6 38.4 5.1 60.3H232V59.6L73 127zm6.7 121c20.9 73.9 65.9 153.7 152.3 202.3V248H79.7zM280 248V450.4C366.4 401.8 411.4 322 432.3 248H280zm162.9-48c3.5-21.9 5-42.3 5.1-60.3c0-5-3.1-10.2-9-12.8L280 59.6V200H442.9zM269.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z"]
};
var faSlashForward = {
  prefix: 'far',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", "M308.1 3.3c11.4 6.7 15.3 21.4 8.6 32.8l-272 464c-6.7 11.4-21.4 15.3-32.8 8.6S-3.4 487.3 3.3 475.9l272-464C282 .4 296.7-3.4 308.1 3.3z"]
};
var faLocationPen = {
  prefix: 'far',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L208.6 122 223.5 107c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5L186 144.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faMapMarkerEdit = faLocationPen;
var faCloudMoon = {
  prefix: 'far',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M495.8 0C389.8 0 304 86.1 304 192.2c0 10.8 .9 21.5 2.6 31.8c58.8 1.4 106.4 48.2 109.2 106.7c22.8 10.8 41.4 29.1 52.6 51.7c8.9 1.3 18.1 1.9 27.4 1.9c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7zM128.1 320c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7v1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9v30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.3 0-.6 0-1 0H98.9c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 329 .1 368.5 .1 416c0 53 43 96 96 96c1.1 0 2.2 0 3.2-.1h266c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4v-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7V336c0-2.9-.5-5.7-1.5-8.3c-7.7-40.8-43.4-71.7-86.5-71.7c-14.7 0-28.5 3.6-40.6 9.9c-17.3-25.3-46.3-41.9-79.3-41.9z"]
};
var faPotFood = {
  prefix: 'far',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24C64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80H324.6c13.8-46.3 56.6-80 107.4-80zM16 280c0-13.3 10.7-24 24-24H66.7c6.6-18.6 24.4-32 45.3-32H528c20.9 0 38.7 13.4 45.3 32H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H573.7c-11 76.9-61.1 141.2-129.5 172.2c-8.1 21-28.4 35.8-52.3 35.8H248c-23.8 0-44.2-14.9-52.3-35.8C127.3 445.2 77.3 380.9 66.3 304H40c-13.3 0-24-10.7-24-24zM240.5 458.9c1.2 3.1 4.2 5.1 7.5 5.1H392c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C485.6 404.8 528 343.3 528 272H112c0 71.3 42.4 132.8 103.5 160.5c11.5 5.2 20.4 14.7 25 26.4z"]
};
var faBriefcase = {
  prefix: 'far',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V280 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280 160c0-35.3 28.7-64 64-64h64zM48 304V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V304H320v16c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V304H48zm144-48H320 464V160c0-8.8-7.2-16-16-16H360 152 64c-8.8 0-16 7.2-16 16v96H192z"]
};
var faPersonFalling = {
  prefix: 'far',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V34.4c0 46.1-28.9 87.3-72.2 103.1C137.5 160.1 96 219.3 96 285.6V360c0 13.3 10.7 24 24 24s24-10.7 24-24l0-74.4c0-10.7 1.5-21.1 4.4-30.9L307.9 501c7.2 11.1 22.1 14.3 33.2 7.1s14.3-22.1 7.1-33.2L263.6 344.3 327 304l46.3 0 64.8 72.1c8.9 9.9 24 10.6 33.9 1.8s10.6-24 1.8-33.9l-67.2-74.7c-7.6-8.4-18.4-13.2-29.7-13.2l-56.6 0h-.6l-19 0-58.2-85.9c47.4-28 77.5-79.3 77.5-135.8L320 24zM263.9 287.2L237.5 304l-61.8-95.5c6.7-6.8 14.4-12.8 22.8-17.7l65.4 96.4zM112 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faImagePortrait = {
  prefix: 'far',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M320 48L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16zm0-48c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"]
};
var faPortrait = faImagePortrait;
var faUserTag = {
  prefix: 'far',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM398.7 464c-.5-3.4-1.1-6.7-1.8-10l45.6 45.6c-5.4 7.5-14.2 12.5-24.2 12.5H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c17.5 0 34.3 2.5 50.3 7.2v33c0 6.4 .8 12.7 2.3 18.8c-16.1-7.1-33.9-11-52.6-11H178.3c-65.7 0-120.1 48.7-129 112H398.7zM384 224h82.7c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3V256c0-17.7 14.3-32 32-32zm72 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faRug = {
  prefix: 'far',
  iconName: 'rug',
  icon: [640, 512, [], "e569", "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h8v40H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v40H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H56 80 560h24 32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V360h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V280h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V200h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V112h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H584 560 80 56 24zm56 48h48V400H80V336 256 176 112zM464 400H176V112H464V400zm48 0V112h48v64 80 80 64H512z"]
};
var faPrintSlash = {
  prefix: 'far',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400H544c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H277.2L176 112.6V64c0-8.8 7.2-16 16-16H421.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zM338.5 240H512c8.8 0 16 7.2 16 16v96H512 496 481.4L338.5 240zm-155.7 0l-60.6-47.7C89.6 195.2 64 222.6 64 256V368c0 17.7 14.3 32 32 32h48v80c0 17.7 14.3 32 32 32H464c15.5 0 28.5-11 31.4-25.7L448 449v15H192V368H345.2l-60.9-48H176c-17.7 0-32 14.3-32 32H112V256c0-8.8 7.2-16 16-16h54.8z"]
};
var faEarthEurope = {
  prefix: 'far',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c3.5 0 6.9 .1 10.3 .3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c-4.1 12.6-9.3 24.7-15.6 36.1c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c-5.6 .5-11.4 .7-17.1 .7zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
var faGlobeEurope = faEarthEurope;
var faCartFlatbedSuitcase = {
  prefix: 'far',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", "M0 24C0 10.7 10.7 0 24 0H72c30.9 0 56 25.1 56 56V408c0 4.4 3.6 8 8 8h72H496 616c13.3 0 24 10.7 24 24s-10.7 24-24 24H544c0 26.5-21.5 48-48 48s-48-21.5-48-48H256c0 26.5-21.5 48-48 48s-48-21.5-48-48H136c-30.9 0-56-25.1-56-56V56c0-4.4-3.6-8-8-8H24C10.7 48 0 37.3 0 24zM360 48c-4.4 0-8 3.6-8 8V96h96V56c0-4.4-3.6-8-8-8H360zM496 96h48c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h48V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96zM256 144c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16h32V144H256zm80 0V304H464V144H336zM544 304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H512V304h32z"]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faHandBackPointRibbon = {
  prefix: 'far',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M96 64c0-35.3 28.7-64 64-64s64 28.7 64 64V96v64 .5c2.6-.3 5.3-.5 8-.5c24.5 0 45.7 13.7 56.5 33.9c5-1.2 10.2-1.9 15.5-1.9c23.9 0 44.8 13.1 55.7 32.5c2.7-.3 5.5-.5 8.3-.5c35.3 0 64 28.7 64 64v96 8c0 66.3-53.7 120-120 120H186.6c-26.9 0-53.3-7.1-76.6-20.7l-2.6-1.5C60.7 462.5 32 412.5 32 358.5V348.3c0-24.8 10.5-48.4 28.8-65.1l20.3-18.4c4.8-4.3 9.7-8.3 14.9-11.9V176H43.8c-6.5 0-11.8-5.3-11.8-11.8c0-3.9 1.9-7.5 5.1-9.7L75.6 128 37.1 101.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 85.3 37.3 80 43.8 80H96V64zm48 112v88 2 78c0 8.8-7.2 16-16 16s-16-7.2-16-16V301.5L93.1 318.7C84.8 326.3 80 337 80 348.3v10.2c0 37 19.6 71.2 51.6 89.8l2.6 1.5-11.7 20 11.7-20c15.9 9.3 34 14.2 52.4 14.2H312c39.8 0 72-32.2 72-72v-8V288c0-8.8-7.2-16-16-16c-3.6 0-6.9 1.2-9.6 3.2c-7.3 5.5-17 6.3-25.1 2.3s-13.3-12.4-13.3-21.5c0-8.8-7.2-16-16-16c-5.2 0-9.9 2.5-12.8 6.4c-6.2 8.3-17 11.6-26.8 8.3s-16.4-12.4-16.4-22.8v-8c0-8.8-7.2-16-16-16c-5.2 0-9.9 2.5-12.8 6.4c-6.2 8.3-17 11.6-26.8 8.3s-16.4-12.4-16.4-22.8V176H144zm32-96V64c0-8.8-7.2-16-16-16s-16 7.2-16 16V80h32z"]
};
var faRectangleXmark = {
  prefix: 'far',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faTireRugged = {
  prefix: 'far',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M213.1 62c1-8 7.8-14 15.9-14h54.1c8.1 0 14.9 6 15.9 14c1.2 9.1 7.4 16.8 16.1 19.7c7.7 2.6 15.2 5.7 22.4 9.3c8.2 4.1 18.1 3.1 25.3-2.5c6.3-4.9 15.4-4.4 21.1 1.3l38.3 38.3c5.7 5.7 6.3 14.8 1.3 21.1c-5.6 7.3-6.6 17.1-2.5 25.3c3.6 7.2 6.7 14.7 9.3 22.4c2.9 8.7 10.6 15 19.7 16.1c8 1 14 7.8 14 15.9v54.1c0 8.1-6 14.9-14 15.9c-9.1 1.2-16.8 7.4-19.7 16.1c-2.6 7.7-5.7 15.2-9.3 22.4c-4.1 8.2-3.1 18.1 2.5 25.3c4.9 6.3 4.4 15.4-1.3 21.1l-38.3 38.3c-5.7 5.7-14.8 6.3-21.1 1.3c-7.3-5.6-17.1-6.6-25.3-2.5c-7.2 3.6-14.7 6.7-22.4 9.3c-8.7 2.9-15 10.6-16.1 19.7c-1 8-7.8 14-15.9 14H228.9c-8.1 0-14.9-6-15.9-14c-1.2-9.1-7.4-16.8-16.1-19.7c-7.7-2.6-15.2-5.7-22.4-9.3c-8.2-4.1-18.1-3.1-25.3 2.5c-6.3 4.9-15.4 4.4-21.1-1.3L89.8 383.9c-5.7-5.7-6.3-14.8-1.3-21.1c5.6-7.3 6.6-17.1 2.5-25.3c-3.6-7.2-6.7-14.7-9.3-22.4c-2.9-8.7-10.6-15-19.7-16.1c-8-1-14-7.8-14-15.9V228.9c0-8.1 6-14.9 14-15.9c9.1-1.2 16.8-7.4 19.7-16.1c2.6-7.7 5.7-15.2 9.3-22.4c4.1-8.2 3.1-18.1-2.5-25.3c-4.9-6.3-4.4-15.4 1.3-21.1l38.3-38.3c5.7-5.7 14.8-6.3 21.1-1.3c7.3 5.6 17.1 6.6 25.3 2.5c7.2-3.6 14.7-6.7 22.4-9.3c8.7-2.9 15-10.6 16.1-19.7zM228.9 0C202 0 178.6 16.7 169.3 40.8c-1.4 .6-2.8 1.1-4.2 1.7c-23.6-10.4-51.9-5.7-71 13.4L55.8 94.1c-19 19-23.7 47.4-13.4 71c-.6 1.4-1.2 2.8-1.7 4.2C16.7 178.6 0 202 0 228.9v54.1c0 26.9 16.7 50.3 40.8 59.6c.6 1.4 1.1 2.8 1.7 4.2c-10.4 23.6-5.7 51.9 13.4 71l38.3 38.3c19 19 47.4 23.7 71 13.4c1.4 .6 2.8 1.2 4.2 1.7c9.4 24 32.7 40.8 59.6 40.8h54.1c26.9 0 50.3-16.7 59.6-40.8c1.4-.6 2.8-1.1 4.2-1.7c23.6 10.4 51.9 5.7 71-13.4l38.3-38.3c19-19 23.7-47.4 13.4-71c.6-1.4 1.2-2.8 1.7-4.2c24-9.4 40.8-32.7 40.8-59.6V228.9c0-26.9-16.7-50.3-40.8-59.6c-.6-1.4-1.1-2.8-1.7-4.2c10.4-23.6 5.7-51.9-13.4-71L417.9 55.8c-19-19-47.4-23.7-71-13.4c-1.4-.6-2.8-1.2-4.2-1.7C333.4 16.7 310 0 283.1 0H228.9zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM232 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-67.3 42.3a24 24 0 1 1 45.7 14.8 24 24 0 1 1 -45.7-14.8zm152.4-15.4a24 24 0 1 1 14.8 45.7 24 24 0 1 1 -14.8-45.7zm-4.6 122.7a24 24 0 1 1 -28.2-38.8 24 24 0 1 1 28.2 38.8zm-79.3-5.3a24 24 0 1 1 -38.8-28.2 24 24 0 1 1 38.8 28.2z"]
};
var faLightbulbDollar = {
  prefix: 'far',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7l0 0 0 0 0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h48.6c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8l0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zm16-400c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V262.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V112z"]
};
var faCowbell = {
  prefix: 'far',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", "M176 48h96V96H176V48zm-48-8V96H112c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416H400c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96H320V40c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40zM112 144H336l64 224H48l64-224zM288 448H160c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faBahtSign = {
  prefix: 'far',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M136 0c-13.3 0-24 10.7-24 24V64H37.6C16.8 64 0 80.8 0 101.6V232v41.7V280 406.3c0 23 18.7 41.7 41.7 41.7H112v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h52c59.6 0 108-48.4 108-108c0-42.1-24.1-78.5-59.2-96.4C277.7 224.6 288 199.5 288 172c0-59.6-48.4-108-108-108H160V24c0-13.3-10.7-24-24-24zM112 112V232H48V112h64zm48 120V112h20c33.1 0 60 26.9 60 60s-26.9 60-60 60H160zm-48 48V400H48V280h64zm48 120V280h20 32c33.1 0 60 26.9 60 60s-26.9 60-60 60H160z"]
};
var faCorner = {
  prefix: 'far',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", "M0 184c0-13.3 10.7-24 24-24H392c30.9 0 56 25.1 56 56V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-4.4-3.6-8-8-8H24c-13.3 0-24-10.7-24-24z"]
};
var faChevronsRight = {
  prefix: 'far',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faChevronDoubleRight = faChevronsRight;
var faBookOpen = {
  prefix: 'far',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M156 32C100.6 32 48.8 46.6 27.1 53.6C10.3 59 0 74.5 0 91.1V403.5c0 26.1 24 44.2 48 40.2c19.8-3.3 54.8-7.7 100-7.7c54 0 97.5 25.5 112.5 35.6c7.5 5 16.8 8.4 27 8.4c11.5 0 21.6-4.2 29.3-9.9C330.2 460.3 369.1 436 428 436c47.7 0 80.5 4 99 7.2c23.9 4.1 49-13.8 49-40.6V91.1c0-16.5-10.3-32.1-27.1-37.5C527.2 46.6 475.4 32 420 32c-36.8 0-71.8 6.4-97.4 12.7c-12.8 3.2-23.5 6.3-30.9 8.7c-1.3 .4-2.6 .8-3.7 1.2c-1.1-.4-2.4-.8-3.7-1.2c-7.5-2.4-18.1-5.5-30.9-8.7C227.8 38.4 192.8 32 156 32zM264 97.3V417.9C238 404.2 196.8 388 148 388c-42.9 0-77.4 3.7-100 7.1V97.3C70.3 90.6 112.4 80 156 80c31.6 0 62.6 5.6 85.9 11.3c8.6 2.1 16.1 4.2 22.1 6zm48 319.2V97.3c6-1.8 13.5-3.9 22.1-6C357.4 85.6 388.4 80 420 80c43.6 0 85.7 10.6 108 17.3V394.7c-21.7-3.3-54.9-6.7-100-6.7c-51.4 0-90.8 15-116 28.6z"]
};
var faBookJournalWhills = {
  prefix: 'far',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM148.8 190.5c3.4 3.4 8.9 3.4 12.3 0s3.4-8.9 0-12.3l-28.8-28.9c8.2-17 20.2-31.8 35-43.4c3.9-3.1 9.3 1.9 7.9 6.7c-6.9 23.5-.9 49.4 16.5 67.2c3.3 3.4 3.6 8.8 .9 12.6c-11 15.4-14.4 35.2-8.7 53.5c6.4 21.1 24 37.2 45.7 41.7L231 252l-11.3 7.8c-.7 .4-1.6 .7-2.5 .7c-1.1 0-2.2-.4-3-1.1c-.8-1-1.4-2-1.4-3.3c0-.7 .3-1.5 .5-2.2l9.4-15.5-19.6-4.1c-1.9-.4-3.4-2.3-3.4-4.4s1.5-3.8 3.4-4.2l19.6-4.1L213.4 206c-1-1.8-.7-4.1 .8-5.5s3.8-1.6 5.5-.4l13.1 8.9 5-120.8c.1-2.5 2-4.2 4.4-4.2s4.2 1.8 4.4 4.2l5.2 122.5 15.4-10.5c.6-.5 1.5-.7 2.3-.8c0 0 .1 0 .1 0c1.6 0 3 .8 3.8 2.2s.7 3.1-.1 4.5L264 221.6l19.6 4.1c1.9 .4 3.4 2.2 3.4 4.2s-1.5 4-3.4 4.4l-19.6 4 9.3 15.7c.8 1.4 1 3 .1 4.4s-2.2 2.2-3.8 2.2c-.8 0-1.8-.3-2.5-.7l-13.8-9.4 1.5 37.4c21.7-4.5 39.3-20.6 45.7-41.7c5.7-18.3 2.3-38.2-8.7-53.5c-2.8-3.8-2.4-9.3 .9-12.7c17.4-17.9 23.4-43.8 16.4-67.3c-1.4-4.8 4-9.7 7.9-6.7c14.8 11.5 26.8 26.4 35 43.5l-28.8 28.9c-3.4 3.4-3.4 8.9 0 12.3s8.9 3.4 12.3 0l23.2-23.2c3.3 11 5.6 22.5 5.6 34.5c0 .3 0 .5-.1 .8s-.1 .5-.1 .8l-40.5 35.5c-1.8 1.8-2.9 4.1-3 6.5c.1 2 .8 4.1 2.2 5.7c1.8 1.8 4.1 2.9 6.5 3c2.2 0 4.2-.8 5.7-2.2L361 229.5C348.3 283.6 300.1 324 242.2 324s-106.1-40.4-118.8-94.5L149.2 252c1.6 1.4 3.7 2 5.7 2.2c3.7 0 6.8-2.3 8.2-5.6c1.2-3.4 .3-7.4-2.5-9.7l-40.5-35.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-12 2.3-23.5 5.6-34.5l23.2 23.2z"]
};
var faJournalWhills = faBookJournalWhills;
var faInhaler = {
  prefix: 'far',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", "M429.8 32.7l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248 386.9 101.6l14-51.8c3.4-12.6 16.3-20.2 29-17zM389 216.9l-2.1 7.8C379.4 252.6 354 272 325.1 272H240V432H449.9l33-121.2-94-94zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480H232c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40h93.1c7.2 0 13.6-4.9 15.4-11.8L357 150.9c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM0 256a32 32 0 1 1 64 0A32 32 0 1 1 0 256zm0 96a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHandcuffs = {
  prefix: 'far',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 336a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 352c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm240 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSnake = {
  prefix: 'far',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M305.6 96H282.9 168C110.6 96 64 142.6 64 200s46.6 104 104 104H320c35.3 0 64 28.7 64 64s-28.7 64-64 64H256.1 256l0 0H118.7c-7.5 0-14.8 1.7-21.5 5.1L75.3 448l21.9 10.9c6.7 3.3 14 5.1 21.5 5.1h57.2 .1l.1 0 .1 0L320 464c53 0 96-43 96-96s-43-96-96-96H168c-39.8 0-72-32.2-72-72s32.2-72 72-72H282.9h22.7L320 145.5c11.6 14.1 29 22.5 47.6 22.5c9 0 17.9-2 26.1-5.8l54.4-25.4c9.6-4.5 15.8-14.2 15.8-24.8s-6.2-20.3-15.8-24.8L393.8 61.8C385.6 58 376.7 56 367.7 56c-18.6 0-36 8.4-47.6 22.5L305.6 96zM176 512l-.1 0H118.7c-14.9 0-29.6-3.5-42.9-10.1L14.3 471.2C5.5 466.8 0 457.8 0 448s5.5-18.8 14.3-23.2l61.4-30.7c6.5-3.3 13.3-5.7 20.4-7.4c7.4-1.8 14.9-2.7 22.6-2.7H168h88l.1 0h36.2H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H292.3 256.1h0H256h0H168c-17.3 0-33.9-2.9-49.3-8.2c-5.7-2-11.3-4.2-16.7-6.8c-50.9-24.6-86-76.7-86-137C16 116.1 84.1 48 168 48H282.9c20.6-25.1 51.6-40 84.7-40c16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-49.6 23.1-4.9 2.3c-14.5 6.8-30.4 10.3-46.4 10.3c-16.8 0-33-3.8-47.7-10.9c-14.2-6.9-26.9-16.7-37.1-29.1H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.7 20.2H320c16.7 0 32.7 2.8 47.7 8.1c16.5 5.8 31.6 14.5 44.7 25.5C443.9 283.9 464 323.6 464 368c0 79.5-64.5 144-144 144H176zM352 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTriangleExclamation = {
  prefix: 'far',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faNoteMedical = {
  prefix: 'far',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M384 80c8.8 0 16 7.2 16 16V320H320c-17.7 0-32 14.3-32 32v80H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 480H288h5.5c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3V320 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64zM192 144v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H256V144c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faDatabase = {
  prefix: 'far',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M400 86v88.7c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 203 269.5 208 224 208s-87.3-5-121.2-13.4C79.6 188.9 61.3 182 48 174.7V86l.6-.5C53.9 81 64.5 74.8 81.8 68.6C115.9 56.5 166.2 48 224 48s108.1 8.5 142.2 20.6c17.3 6.2 27.8 12.4 33.2 16.9l.6 .5zm0 141.5v75.2c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 331 269.5 336 224 336s-87.3-5-121.2-13.4C79.6 316.9 61.3 310 48 302.7V227.6c13.3 5.3 27.9 9.9 43.3 13.7C129.5 250.6 175.2 256 224 256s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7zM48 426V355.6c13.3 5.3 27.9 9.9 43.3 13.7C129.5 378.6 175.2 384 224 384s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7V426l-.6 .5c-5.3 4.5-15.9 10.7-33.2 16.9C332.1 455.5 281.8 464 224 464s-108.1-8.5-142.2-20.6c-17.3-6.2-27.8-12.4-33.2-16.9L48 426zm354.1-2.1s0 .1-.2 .2l.1-.2 0-.1zm-356.1 0a.3 .3 0 1 0 .6-.2 .3 .3 0 1 0 -.6 .2zm0-335.8a.3 .3 0 1 0 .5 .2 .3 .3 0 1 0 -.5-.2zm356-.2a.3 .3 0 1 0 -.1 .6 .3 .3 0 1 0 .1-.6zM448 432V80C448 35.8 347.7 0 224 0S0 35.8 0 80V432c0 44.2 100.3 80 224 80s224-35.8 224-80z"]
};
var faDownLeft = {
  prefix: 'far',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", "M64 384V190.6c0-1.7 .8-3.2 2.1-4.2c2.1-1.6 5-1.4 6.9 .5L127 241c9.4 9.4 24.6 9.4 33.9 0L285.7 116.3c2.7-2.7 6.5-4.3 10.3-4.3s7.6 1.5 10.3 4.3l25.4 25.4c2.7 2.7 4.3 6.5 4.3 10.3s-1.5 7.6-4.3 10.3L207 287c-9.4 9.4-9.4 24.6 0 33.9L261.1 375c1.8 1.8 2.1 4.8 .5 6.9c-1 1.3-2.5 2.1-4.2 2.1H64zm-48 8c0 22.1 17.9 40 40 40H257.4c16.8 0 32.5-7.9 42.6-21.3c15.9-21.2 13.8-50.9-4.9-69.6L257.9 304 365.7 196.3C377.4 184.5 384 168.6 384 152s-6.6-32.5-18.3-44.3L340.3 82.4C328.5 70.6 312.6 64 296 64s-32.5 6.6-44.3 18.3L144 190.1 106.9 153c-18.7-18.7-48.4-20.8-69.6-5C23.9 158.1 16 173.9 16 190.6V392z"]
};
var faShare = {
  prefix: 'far',
  iconName: 'share',
  icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M288 240H192c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128H288h24c13.3 0 24-10.7 24-24V128 99.9L456.1 208 336 316.1V288 264c0-13.3-10.7-24-24-24H288zm0 48v48 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V80v48H240 176C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96h48 48z"]
};
var faArrowTurnRight = faShare;
var faMailForward = faShare;
var faFaceThinking = {
  prefix: 'far',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 17.7 2.2 34.8 6.4 51.2C40.8 317.4 32 333.7 32 352v28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l10.1-27.7c3.8 .2 7.7 .3 11.6 .3zm43-158.9c-9.9-2-20.5-1.3-30.7 2.5L237.9 319l-65.5-15.4c-8.6-2-13.9-10.6-11.9-19.2s10.6-13.9 19.2-11.9l97.1 22.8c8.2 1.9 15.7 5.3 22.3 9.8zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-120-31.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3zM112 352v48.4l167.6-62.8c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9L230.9 407c-.1 .4-.3 .8-.4 1.2l-26.3 72.2c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTurnDownRight = {
  prefix: 'far',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M505.5 271.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6c-25.6 0-46.3-20.7-46.3-46.3l0-41.7-144 0C71.6 360 0 288.4 0 200L0 88C0 57.1 25.1 32 56 32l32 0c30.9 0 56 25.1 56 56l0 120c0 4.4 3.6 8 8 8l152 0 0-41.7c0-25.6 20.7-46.3 46.3-46.3c12.8 0 25 5.3 33.7 14.6l121.4 129zM352 178.5l0 61.5c0 13.3-10.7 24-24 24l-176 0c-30.9 0-56-25.1-56-56L96 88c0-4.4-3.6-8-8-8L56 80c-4.4 0-8 3.6-8 8l0 112c0 61.9 50.1 112 112 112l168 0c13.3 0 24 10.7 24 24l0 61.5L455 288 352 178.5z"]
};
var faBottleDroplet = {
  prefix: 'far',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M128 48V152.2c0 16-8 31-21.3 39.9C80.9 209.4 64 238.8 64 272V448c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V272c0-33.2-16.9-62.6-42.7-79.9C200 183.2 192 168.3 192 152.2V48l-64 0zM256 24c0 10.4-6.7 19.3-16 22.6V152.2c38.6 25.8 64 69.8 64 119.8V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V272c0-49.9 25.4-93.9 64-119.8V46.6C70.7 43.3 64 34.5 64 24C64 10.7 74.7 0 88 0L232 0c13.3 0 24 10.7 24 24zM160 384c-26.5 0-48-21.5-48-48c0-22.2 23-52 37.2-68.2c5.8-6.7 15.9-6.7 21.7 0C185 284 208 313.8 208 336c0 32-21.5 48-48 48z"]
};
var faMaskFace = {
  prefix: 'far',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M320 112c17.7 0 35 5.2 49.8 15.1l37.1 24.8c23.7 15.8 51.4 24.2 79.9 24.2H496v48c0 59.5-29.5 112.1-74.7 143.9l-3.1 .8 .3 1.2c-28.1 19-62 30.1-98.5 30.1s-70.4-11.1-98.5-30.1l.3-1.2-3.1-.8C173.5 336.1 144 283.5 144 224V176h9.2c28.4 0 56.2-8.4 79.9-24.2l37.1-24.8c14.7-9.8 32-15.1 49.8-15.1zM96 224c0 45.1 13.4 87.2 36.3 122.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48zM90.9 385.5l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4zm446.6-46.6l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16 80c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]
};
var faHillRockslide = {
  prefix: 'far',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm124.4 71.8c-2.7-4.9-2.7-10.8 0-15.7l27-48c2.8-5 8.2-8.2 13.9-8.2l53.3 0c5.8 0 11.1 3.1 13.9 8.2l27 48c2.7 4.9 2.7 10.8 0 15.7l-27 48c-2.8 5-8.2 8.2-13.9 8.2H293.4c-5.8 0-11.1-3.1-13.9-8.2l-27-48zM48 145.9V440c0 13.3 10.7 24 24 24H366.1L48 145.9zM0 126.6C0 91 43.1 73.1 68.3 98.3L413.7 443.7c25.2 25.2 7.4 68.3-28.3 68.3H72c-39.8 0-72-32.2-72-72V126.6zm504.2 277l-48-27c-5-2.8-8.2-8.2-8.2-13.9V309.4c0-5.8 3.1-11.1 8.2-13.9l48-27c4.9-2.7 10.8-2.7 15.7 0l48 27c5 2.8 8.2 8.2 8.2 13.9v53.3c0 5.8-3.1 11.1-8.2 13.9l-48 27c-4.9 2.7-10.8 2.7-15.7 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faScannerKeyboard = {
  prefix: 'far',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M128 24V64h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0V64h48V24c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16V64h32V16c0-8.8-7.2-16-16-16zM384 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM64 144H288c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm0-48C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 80c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24H248c13.3 0 24-10.7 24-24V200c0-13.3-10.7-24-24-24H104zM96 304c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H96zM80 400v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm128-96c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H208zm-16 96v16c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faCircleO = {
  prefix: 'far',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-256a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]
};
var faGridHorizontal = {
  prefix: 'far',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", "M40 168v48H88V168H40zM0 168c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V168zM40 328v48H88V328H40zM0 328c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328zM248 168H200v48h48V168zm-48-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 200v48h48V328H200zm-40 0c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V328zM408 168H360v48h48V168zm-48-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm0 200v48h48V328H360zm-40 0c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V328z"]
};
var faMessageDollar = {
  prefix: 'far',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM276 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]
};
var faCommentAltDollar = faMessageDollar;
var faRightLeft = {
  prefix: 'far',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M336 215c0 22.6 18.3 41 41 41c10.9 0 21.3-4.3 29-12l99-99c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17l-99-99c-7.7-7.7-18.1-12-29-12c-22.6 0-41 18.3-41 41v63H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H336v63zm118.1-87L384 198.1V57.9L454.1 128zM135 256c-10.9 0-21.3 4.3-29 12L7 367c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l99 99c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V408H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H176V297c0-22.6-18.3-41-41-41zm-7 198.1L57.9 384 128 313.9V454.1z"]
};
var faExchangeAlt = faRightLeft;
var faColumns3 = {
  prefix: 'far',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", "M448 80V432H576c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H448zm-48 0H240V432H400V80zM192 432V80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H192zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faPaperPlane = {
  prefix: 'far',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"]
};
var faRoadCircleExclamation = {
  prefix: 'far',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480H360.2c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24v24H108.3c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9H296v24c0 13.3 10.7 24 24 24s24-10.7 24-24V80h78.3c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32H217.7zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faDungeon = {
  prefix: 'far',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M256 128c-6.9 0-13.7 .5-20.4 1.4l-.2 0c-7.8 1-15.6-3-18.5-10.3l-.7-1.8L199 74.3l-.2-.5c-3-7.6 .2-16.2 7.2-19.5c.9-.4 1.9-.8 2.9-1C224.1 49.8 239.8 48 256 48s31.9 1.8 47.1 5.3c1 .2 2 .6 2.9 1c7 3.3 10.3 11.9 7.2 19.5l-.2 .5-17.2 43.1-.7 1.8c-2.9 7.3-10.7 11.3-18.5 10.3l-.2 0c-6.6-.9-13.4-1.4-20.4-1.4zM96 512h32H384h32 32c35.3 0 64-28.7 64-64V408c0-11.7-3.1-22.6-8.6-32c5.4-9.4 8.6-20.3 8.6-32V304c0-11.7-3.1-22.6-8.6-32c5.8-10.2 8.9-22.3 7.8-35.6c-2.2-28.6-9.1-56-19.9-81.2c-6.1-14.3-16.2-24.5-28-30.6c-.6-13.3-5.5-26.7-15.8-38.3c-16.8-18.9-36.4-35.4-58.1-48.7c-13.2-8.1-27.3-10.6-40.5-8.8c-8.2-10.5-20-18.7-35.1-22.1C295.2 2.3 275.9 0 256 0s-39.2 2.3-57.9 6.6C183 10.1 171.2 18.2 163 28.7c-13.2-1.8-27.3 .7-40.5 8.8C100.8 50.8 81.2 67.3 64.4 86.2c-10.2 11.6-15.2 25-15.8 38.3c-11.8 6.2-21.9 16.3-28 30.6C9.8 180.4 2.9 207.8 .7 236.4c-1 13.3 2 25.4 7.8 35.6C3.1 281.4 0 292.3 0 304v40c0 11.7 3.1 22.6 8.6 32C3.1 385.4 0 396.3 0 408v40c0 35.3 28.7 64 64 64H96zM371.4 165.2c-6.4 4.3-14.8 3.3-20.7-1.6l-.2-.2c-5.5-4.8-11.4-9.2-17.6-13.1l-.2-.2c-6.3-4.2-9.6-11.8-7.7-19c.2-.6 .4-1.2 .6-1.8l17.2-43.1 .2-.5c3.2-7.4 11.4-11.1 18.7-8.6c1 .3 1.9 .8 2.8 1.3c17.7 10.8 33.6 24.2 47.2 39.6c.7 .8 1.3 1.7 1.8 2.6c3.8 6.7 1.5 15.4-5.2 19.9l-1.1 .8-32.6 21.7-3.2 2.1zm15.4 46.4l-.2-.4c-2.8-6.5-1.8-14 2.8-19c.9-.9 1.8-1.8 2.9-2.5l32.6-21.7c.4-.3 .8-.5 1.2-.7c6.8-3.8 15.3-2 19.6 4.1c.6 .8 1.1 1.7 1.5 2.7c8.8 20.5 14.4 42.7 16.2 66c0 .6 .1 1.2 0 1.9c-.4 7.9-7.2 14.1-15.4 14.1H416h-2.6c-7.8 0-14.3-5.7-16.4-13.2c-.1-.3-.2-.7-.2-1c-2.2-10.6-5.7-20.7-10.1-30.3zM400 304c0-.5 0-.9 .1-1.4c.6-7.3 6.2-13.3 13.4-14.4c.8-.1 1.7-.2 2.6-.2h32c8.1 0 14.9 6.1 15.9 14c.1 .7 .1 1.4 .1 2v40c0 .7 0 1.3-.1 2c-1 7.9-7.7 14-15.9 14H416c-8.2 0-14.9-6.1-15.9-14c-.1-.6-.1-1.3-.1-2V304zm0 104c0-.7 0-1.3 .1-2c1-7.9 7.7-14 15.9-14h32c8.2 0 14.9 6.1 15.9 14c.1 .6 .1 1.3 .1 2v40c0 8.8-7.2 16-16 16H416c-8.8 0-16-7.2-16-16V408zM147.6 78.5c.9-.6 1.8-1 2.8-1.3c7.3-2.6 15.5 1.2 18.7 8.6l.2 .5 17.2 43.1c.2 .6 .4 1.2 .6 1.8c1.9 7.2-1.4 14.8-7.7 19l-.3 .2c-6.2 3.9-12.1 8.3-17.6 13.1l-.2 .2c-5.9 4.9-14.3 5.9-20.7 1.6l-3.2-2.1-32.6-21.7-1.1-.8c-6.7-4.5-9-13.2-5.2-19.9c.5-.9 1.1-1.8 1.8-2.6c13.7-15.4 29.6-28.8 47.2-39.6zM64.8 174.1c.4-1 .9-1.9 1.5-2.7c4.3-6.1 12.8-7.9 19.6-4.1c.4 .2 .8 .5 1.2 .7l32.6 21.7c1.1 .7 2.1 1.6 2.9 2.5c4.6 5 5.6 12.6 2.8 19l-.2 .4c-4.4 9.6-7.8 19.7-10.1 30.3c-.1 .3-.1 .7-.2 1c-2 7.5-8.6 13.2-16.4 13.2H96 64c-8.2 0-15-6.2-15.4-14.1c0-.6 0-1.2 0-1.9c1.8-23.3 7.4-45.5 16.2-66zM48 304c0-.7 0-1.4 .1-2c1-7.9 7.7-14 15.9-14H96c.9 0 1.7 .1 2.6 .2c7.2 1.2 12.8 7.1 13.4 14.4c0 .5 .1 .9 .1 1.4v40c0 .7 0 1.3-.1 2c-1 7.9-7.7 14-15.9 14H64c-8.2 0-14.9-6.1-15.9-14c-.1-.6-.1-1.3-.1-2V304zm0 104c0-.7 0-1.3 .1-2c1-7.9 7.7-14 15.9-14H96c8.2 0 14.9 6.1 15.9 14c.1 .6 .1 1.3 .1 2v40c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V408zM272 192V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 32V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faHandHoldingBox = {
  prefix: 'far',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M432 48H352v73.7c0 3.5-2.8 6.3-6.3 6.3c-1.1 0-2.2-.3-3.1-.8l-46.6-26.6c-4.9-2.8-11-2.8-15.9 0l-46.6 26.6c-1 .5-2 .8-3.1 .8c-3.5 0-6.3-2.8-6.3-6.3V48H144V208H432V48zm0-48c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h80H352h80zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H387.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H344 320 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"]
};
var faInputText = {
  prefix: 'far',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7H146.3l-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280h32.8L184 243.1zM304 184c0-13.3 10.7-24 24-24h52c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60H328c-13.3 0-24-10.7-24-24v-8V256 192v-8zm48 24v24h28c6.6 0 12-5.4 12-12s-5.4-12-12-12H352zm0 96h44c6.6 0 12-5.4 12-12s-5.4-12-12-12H380 352v24z"]
};
var faWindowFlip = {
  prefix: 'far',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64 48 16V416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224 208 160 96zM48 224H464l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192zM416 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faWindowAlt = faWindowFlip;
var faAlignRight = {
  prefix: 'far',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M424 40c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H424zm0 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424zm24 152c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24zM424 424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424z"]
};
var faScannerGun = {
  prefix: 'far',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M112 80c-35.3 0-64 28.7-64 64s28.7 64 64 64H232.4 288h16V80H112zM79.1 251.1C33.3 237.1 0 194.4 0 144C0 82.1 50.1 32 112 32H304c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H260L144.3 454.4c-13.4 23-42.9 30.7-65.8 17.2L25 440.1C2.3 426.8-5.4 397.6 7.8 374.8L79.1 251.1zm52.6 4.9L49.4 398.8l53.5 31.4L204.4 256H131.7zM440 32H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24s10.7-24 24-24zM416 216c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm24 216H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24s10.7-24 24-24zM416 144c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 144H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16z"]
};
var faScanner = faScannerGun;
var faTire = {
  prefix: 'far',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 .9l39.2 12.8c.5-4.5 .8-9 .8-13.6c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5c0 .3 0 .6 0 .9zm-14.9 45.6c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 373.6l0-41.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3zm-95.2-104L176 256.9c0-.3 0-.6 0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 196.4 136 224.8 136 256c0 4.6 .3 9.2 .8 13.6zm93.6-89.5c8-2.7 16.6-4.2 25.6-4.2s17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 178l1.6 2.2zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 88a168 168 0 1 1 0 336 168 168 0 1 1 0-336z"]
};
var faEngine = {
  prefix: 'far',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", "M424 88c0 13.3-10.7 24-24 24l-72 0v32l68.6 0c12.6 0 25 3.7 35.5 10.7L483.5 189c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-35.3 0-64-28.7-64-64V280H48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72H80V208c0-35.3 28.7-64 64-64h16 32l88 0V112l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24H400c13.3 0 24 10.7 24 24zM288 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM172.8 336c14.6 0 28.4 6.6 37.5 18l32 40c3 3.8 7.6 6 12.5 6H448c8.8 0 16-7.2 16-16V242.3c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7H192 160 144c-8.8 0-16 7.2-16 16V320c0 8.8 7.2 16 16 16h28.8zM576 192h32c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
};
var faMoneyBill1Wave = {
  prefix: 'far',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4l0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5l0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192V368c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5V113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM256 208c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLifeRing = {
  prefix: 'far',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faHands = {
  prefix: 'far',
  iconName: 'hands',
  icon: [576, 512, ["sign-language", "signing"], "f2a7", "M528 143.8c0-8.8-7.2-16-16-16s-16 7.2-16 16v37.4c0 10.9-7.3 20.4-17.8 23.2s-21.6-1.8-27-11.2L369.7 52c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9l0 .1 48 83.1c6.2 10.7 3.2 24.3-6.7 31.4c-15.1-14.3-32.3-26.5-51.5-36.1L314.3 84l-8-13.9 0-.1-8-13.8c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9l8 13.9 8 13.9 0 .1 20.2 35-53-23.5c-22.8-10.1-47.6-9.8-69-1c4.1-12.6 12.8-23.9 25.2-31c3.8-2.2 7.7-3.9 11.7-5.1c-2.3-21.4 7.8-43.2 27.7-54.6s43.8-9.4 61.1 3.3c3.1-2.9 6.5-5.4 10.3-7.6C361.6-8 395.8 1.2 411.3 28l46.9 81.2c11.4-17.7 31.3-29.4 53.9-29.4c35.3 0 64 28.7 64 64v84.6c0 69.4-36.7 133.6-96.5 168.8c-10.4 6.1-21 11.1-31.9 15.1c8-19.2 13.3-39.9 15.4-61.4c40.5-27.4 65-73.2 65-122.4V143.8zm-353.9 13c15.1-32 53.2-45.7 85.2-30.7l56.4 26.5c36 16.9 65.4 43.7 85.7 76.1c19.6 29.4 30.7 64.4 30.7 101.2c0 1 0 2 0 3c0 1 0 2.1 0 3.1c0 1.2-.1 2.3-.2 3.4c-5 96.1-84.5 172.6-181.8 172.6H120c-30.9 0-56-25.1-56-56c0-4.4 .5-8.6 1.5-12.7C45.8 434.6 32 414.9 32 392c0-4.4 .5-8.6 1.5-12.7C13.8 370.6 0 350.9 0 328s13.8-42.6 33.5-51.3c-.9-4.1-1.5-8.3-1.5-12.7c0-30.9 25.1-56 56-56h84.7c-6.4-16-6.5-34.5 1.4-51.3zM72 320l-.2 0H56c-4.4 0-8 3.6-8 8s3.6 8 8 8H88l.2 0H184c13.3 0 24 10.7 24 24s-10.7 24-24 24H87.9c-4.4 0-7.9 3.6-7.9 8c0 4.4 3.6 8 8 8h31.9l.2 0H184c13.3 0 24 10.7 24 24s-10.7 24-24 24H119.9c-4.4 .1-7.9 3.6-7.9 8c0 4.4 3.6 8 8 8H249.9c72.3 0 131.3-57.3 134-128.9c0-.4 0-.9 .1-1.3l0-.5 0-.6 0-.3c0-.8 0-1.7 0-2.5c0-27.2-8.2-53.1-22.8-74.8c-.2-.2-.3-.5-.5-.7c-15.5-24.9-38-45.4-65.5-58.4l-56.4-26.5c-8-3.8-17.5-.3-21.3 7.7s-.3 17.5 7.7 21.3l25.1 11.8c10.2 4.8 15.7 16 13.2 27s-12.2 18.8-23.4 18.8H88c-4.4 0-8 3.6-8 8s3.6 8 8 8l.2 0H184c13.3 0 24 10.7 24 24s-10.7 24-24 24H72z"]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faCircleCaretRight = {
  prefix: 'far',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 0c0-6.7-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104c4.9-4.5 7.7-10.9 7.7-17.6z"]
};
var faCaretCircleRight = faCircleCaretRight;
var faWheat = {
  prefix: 'far',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", "M448 48c-22.1 0-40 17.9-40 40v16h16c22.1 0 40-17.9 40-40V48H448zM362.2 68.5C371.1 29.3 406.1 0 448 0h40c13.3 0 24 10.7 24 24V64c0 41.9-29.2 76.9-68.4 85.8c14.1 6.2 27.3 15.1 38.9 26.7l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.2-11.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L120.6 357.5l0 0-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9C347 41 356 54.3 362.2 68.5zm-60.6 85.4L311.7 164c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM222.4 233l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm-79.2 79.2l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm147 56.5c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.2c25 25 65.5 25 90.5 0zm79.2-79.2c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1c25 25 65.5 25 90.5 0zm79.2-79.2C421.2 183 379 179.7 347.9 200.2l10.1 10.1c25 25 65.5 25 90.5 0z"]
};
var faFileSpreadsheet = {
  prefix: 'far',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM176 256v48H112V256h64zm-64 80h64v48H112V336zm96 0h64v48H208V336zm-16 80h16 64c17.7 0 32-14.3 32-32V336 320 304 256c0-17.7-14.3-32-32-32H208 192 176 112c-17.7 0-32 14.3-32 32v48 16 16 48c0 17.7 14.3 32 32 32h64 16zm16-112V256h64v48H208z"]
};
var faAudioDescriptionSlash = {
  prefix: 'far',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80H544c8.8 0 16 7.2 16 16V413.6l-95.4-74.8C493 322.1 512 291.3 512 256c0-53-43-96-96-96H360c-13.3 0-24 10.7-24 24v54L134.4 80zM419.9 303.8L384 275.7V208h32c26.5 0 48 21.5 48 48c0 25.2-19.4 45.8-44.1 47.8zM487.4 480l-60.9-48H96c-8.8 0-16-7.2-16-16V159L32 121.2V416c0 35.3 28.7 64 64 64H487.4zM130.5 317.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l9.4-18.9h82.2l9.4 18.9c5.9 11.9 20.3 16.7 32.2 10.7c3-1.5 5.5-3.5 7.5-5.9l-80.9-63.8H202.9l8.6-17.2L173 232.3l-42.5 85z"]
};
var faCalendarDay = {
  prefix: 'far',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM112 256h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16z"]
};
var faWaterLadder = {
  prefix: 'far',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", "M128 128c0-53 43-96 96-96s96 43 96 96v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-26.5-21.5-48-48-48s-48 21.5-48 48v96.2H384V128c0-53 43-96 96-96s96 43 96 96v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-26.5-21.5-48-48-48s-48 21.5-48 48V248.2 371c-15.5 8.4-32.8 13.5-48 13.5h0V272.2H176V382.8c-14.7-2.9-30-9.6-43.1-18.7c-1.6-1.1-3.2-2.2-4.9-3.1V248.2 128zM111.9 398.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faArrowsUpDown = {
  prefix: 'far',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M177 7c-9.4-9.4-24.6-9.4-33.9 0L47 103c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V430.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V81.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 7z"]
};
var faArrowsV = faArrowsUpDown;
var faChessPawnPiece = {
  prefix: 'far',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", "M128 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm73.4 144c12.6-.7 22.6-11.2 22.6-24c0-9.7-5.8-18.1-14.1-21.9c8.9-14.6 14.1-31.8 14.1-50.1c0-53-43-96-96-96s-96 43-96 96c0 18.4 5.2 35.5 14.1 50.1C37.8 245.9 32 254.3 32 264c0 12.8 10 23.3 22.6 24l-3.6 64H99.1l3.6-64H128h25.3l3.6 64h48.1l-3.6-64zM52.7 464l16.6-32H186.8l16.6 32H52.7zm143.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H215.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"]
};
var faChessPawnAlt = faChessPawnPiece;
var faFaceGrimace = {
  prefix: 'far',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrimace = faFaceGrimace;
var faWheelchairMove = {
  prefix: 'far',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208.6 113c-8-3.4-17.2-2.2-24 3.2l-49.8 38.7c-10.5 8.1-25.5 6.3-33.7-4.2s-6.3-25.5 4.2-33.7l49.8-38.7c20.6-16 48.1-19.6 72.1-9.5l84.2 35.5c35.7 15 45.7 60.9 19.5 89.5L288.6 240H402.5c26.8 0 46 25.8 38.3 51.5L399 430.9c-3.8 12.7-17.2 19.9-29.9 16.1s-19.9-17.2-16.1-29.9L391.7 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c1.2 0 2.5 0 3.7 0l68.9-68.9-24-10.1zm87 48.2c3.7-4.1 2.3-10.6-2.8-12.8l-20.4-8.6-60.7 60.7c11.8 4 22.9 9.4 33.3 15.9l50.6-55.2zM160 464a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faWheelchairAlt = faWheelchairMove;
var faTurnDown = {
  prefix: 'far',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M175.6 505.5c9.2 8.7 23.7 8.7 32.9 0l129-121.4c9.3-8.8 14.6-21 14.6-33.7c0-25.6-20.7-46.3-46.3-46.3H264V160C264 71.6 192.4 0 104 0H56C25.1 0 0 25.1 0 56V88c0 30.9 25.1 56 56 56h56c4.4 0 8 3.6 8 8V304H78.3C52.7 304 32 324.7 32 350.3c0 12.8 5.3 25 14.6 33.7l129 121.4zM82.5 352H144c13.3 0 24-10.7 24-24V152c0-30.9-25.1-56-56-56H56c-4.4 0-8-3.6-8-8V56c0-4.4 3.6-8 8-8h48c61.9 0 112 50.1 112 112V328c0 13.3 10.7 24 24 24h61.5L192 455 82.5 352z"]
};
var faLevelDownAlt = faTurnDown;
var faSquareS = {
  prefix: 'far',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
var faRectangleBarcode = {
  prefix: 'far',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm120 32c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 0c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm136-24c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144z"]
};
var faBarcodeAlt = faRectangleBarcode;
var faPersonWalkingArrowRight = {
  prefix: 'far',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128h-4.9c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM553 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H392c-13.3 0-24 10.7-24 24s10.7 24 24 24H558.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
var faSquareEnvelope = {
  prefix: 'far',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM216.7 255.6L96.1 189.3C97.5 172.9 111.3 160 128 160H320c16.7 0 30.5 12.9 31.9 29.3L231.3 255.6c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9zm30 28L352 225.7V320c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V225.7l105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8z"]
};
var faEnvelopeSquare = faSquareEnvelope;
var faDice = {
  prefix: 'far',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", "M241 68.3c-9.4-9.4-24.6-9.4-33.9 0L68.3 207c-9.4 9.4-9.4 24.6 0 33.9L207 379.7c9.4 9.4 24.6 9.4 33.9 0L379.7 241c9.4-9.4 9.4-24.6 0-33.9L241 68.3zM173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 413.8L436.3 297.5c28.6-28.6 37-69.6 25.4-105.5H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64V413.8zM504 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM120 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104-56a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 208a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUnicorn = {
  prefix: 'far',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M426.8 .6c1.7-.4 3.4-.6 5.2-.6h8 32 .5c2.5 0 5 .1 7.5 .3V0h56c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c3.5 6.1 6.3 12.7 8.3 19.7h73.5c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-69.8 23.3 5.6 39.4c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5V240l0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V364.5l-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8H139.1c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-47.3 37.3-85.9 84.1-87.9c20.3-29.1 54-48.1 92.1-48.1h22.6H232h61.3C309.8 51.5 362.6 6.1 426.8 .6zM416 239V184c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48H472 440h-4.6c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-1.5 12-11.7 21-23.8 21H232 198.9 176.2c-35.5 0-64.2 28.8-64.2 64.2c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464h49.8l-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l88 25.7c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5V464h48V318.2c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBowlingBall = {
  prefix: 'far',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPompebled = {
  prefix: 'far',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M254.4 22.8c45.2 31.3 55.3 91.3 38 147.2c45.1-35.6 103.5-47.2 148.3-15c64.6 45.8 71.6 140.2 25.7 208.1l0 0C386.7 480.8 219.2 542 98.5 455.5C-21.8 369.5-25.9 190 53.9 72.2c46-68.6 135.3-95.4 200.5-49.4zm21.5 185.1l0 0zM226.7 62.1c-38-26.9-98.3-15-133 36.9l-.1 .1c-69.9 103.1-60.2 251 32.8 317.4l0 0c91.7 65.7 230.3 23 300.2-80.2c34.9-51.7 24.7-114.9-13.8-142.1l-.1-.1c-25.6-18.4-73.5-11.7-111.5 33.9c-12.9 17.5-37.4 21.8-55.4 8.7c-17.6-12.7-21.9-36.7-10.4-54.7c28.6-52.7 17.8-101.6-8.5-119.7l-.2-.2 0 0z"]
};
var faBrain = {
  prefix: 'far',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3c-16.6 7.5-28.2 24.1-28.3 43.5c-.1 9.1-5.2 17.3-13.3 21.3C82.8 164.9 72 181.2 72 200c0 7.1 1.5 13.7 4.2 19.7c4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9c6.7 5.4 10 14 8.7 22.5c-.4 2.5-.6 5-.6 7.6c0 26.1 20.8 47.3 46.7 48c9.2 .3 17.4 5.7 21.2 14.1c6.9 15.3 22.3 25.9 40.1 25.9c24.3 0 44-19.7 44-44V88c0-22.1-17.9-40-40-40c-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30c-32.2 0-60.5-16.5-76.9-41.5c-45-8-79.1-47.3-79.1-94.5c0-.5 0-1.1 0-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8c4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4c24.1 14.3 41.5 38.9 45.9 67.8C471.7 138.5 488 167.4 488 200c0 8-1 15.8-2.8 23.3c16.7 19.6 26.8 45 26.8 72.7c0 30.5-12.2 58.2-32 78.4c0 .5 0 1.1 0 1.6c0 47.3-34.1 86.5-79.1 94.5c-16.4 25-44.7 41.5-76.9 41.5c-26.9 0-51.2-11.6-68-30zm24-62c0 24.3 19.7 44 44 44c17.8 0 33.2-10.6 40.1-25.9c3.8-8.4 12-13.9 21.2-14.1c25.9-.7 46.7-21.9 46.7-48c0-2.6-.2-5.2-.6-7.6c-1.4-8.5 2-17.1 8.7-22.5C454.7 334.1 464 316.2 464 296c0-19.3-8.5-36.6-22.1-48.3c-8-6.9-10.5-18.3-6.1-28c2.7-6 4.2-12.6 4.2-19.7c0-18.8-10.8-35.1-26.7-43c-8.1-4-13.3-12.3-13.3-21.3c-.1-19.3-11.7-36-28.3-43.5c-6.4-2.9-11.3-8.5-13.2-15.3C353.7 60.2 338.2 48 320 48c-22.1 0-40 17.9-40 40V420z"]
};
var faWatchSmart = {
  prefix: 'far',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M64 48.3C64 21.6 85.6 0 112.3 0H271.7C298.4 0 320 21.6 320 48.3V65.6c36.5 7.4 64 39.7 64 78.4V368c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V446.4C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4V48.3zM80 112c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32H80zm136 72v60.8l39.4 32.8c10.2 8.5 11.6 23.6 3.1 33.8s-23.6 11.6-33.8 3.1l-48-40c-5.5-4.6-8.6-11.3-8.6-18.4V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faBookUser = {
  prefix: 'far',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M88 0C39.4 0 0 39.4 0 88V424H.4c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V394.6c18.9-9 32-28.3 32-50.6V56c0-30.9-25.1-56-56-56H88zM368 400v64H80c-17.7 0-32-14.3-32-32s14.3-32 32-32H368zM80 352c-11.4 0-22.2 2.4-32 6.7V88c0-22.1 17.9-40 40-40H392c4.4 0 8 3.6 8 8V344c0 4.4-3.6 8-8 8H352V336c0-44.2-35.8-80-80-80H208c-44.2 0-80 35.8-80 80v16H80zM240 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faSensorCloud = {
  prefix: 'far',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", "M64 80H384c8.8 0 16 7.2 16 16V224c17.2 0 33.5 3.9 48 10.8V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H234.8c-6.9-14.5-10.8-30.8-10.8-48H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zm96 360H560c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432c0 44.2 35.8 80 80 80z"]
};
var faSensorSmoke = faSensorCloud;
var faClapperboardPlay = {
  prefix: 'far',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", "M48 416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V208H48V416zM336 160h64l64-64c0-8.8-7.2-16-16-16H416l-80 80zm-96 0l80-80H256l-80 80h64zM80 160l80-80H96L48 128v32H80zM512 96v64 24 24V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208 184 160 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64zM216.5 241.9c5.2-2.8 11.5-2.5 16.4 .8l96 64c4.4 3 7.1 8 7.1 13.3s-2.7 10.3-7.1 13.3l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V256c0-5.9 3.2-11.3 8.5-14.1z"]
};
var faBandage = {
  prefix: 'far',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", "M448 144V368H560c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32H448zM192 96H448 560c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H448 192 80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H192zm0 272V144H80c-17.7 0-32 14.3-32 32V336c0 17.7 14.3 32 32 32H192zm80-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faBandAid = faBandage;
var faCalendarMinus = {
  prefix: 'far',
  iconName: 'calendar-minus',
  icon: [512, 512, [], "f272", "M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zM328 352H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faCircleXmark = {
  prefix: 'far',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faCircle4 = {
  prefix: 'far',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c12.6 4.2 19.4 17.8 15.2 30.4L201.3 272H272V216c0-13.3 10.7-24 24-24s24 10.7 24 24v56h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H168c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l48-144c4.2-12.6 17.8-19.4 30.4-15.2z"]
};
var faGifts = {
  prefix: 'far',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H200.6c-5.4-9.4-8.6-20.3-8.6-32V464H64c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h80c0 0 0 0 .1 0h80 32.4c5.3-8.2 11.7-15.7 19-22.1C263.8 106.2 245.1 96 224 96h-6.2l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zm0 72h72 56 8v72H272V272zm0 120H408v72H272V392zm320 0v72H456V392H592zM456 344V272h8 56 72v72H456zm88-144c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"]
};
var faAlbumCollection = {
  prefix: 'far',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M56 0H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160H442.4c38.7 0 68.5 34 63.5 72.3l-29.5 224C472.2 488.2 445 512 412.9 512H99.1c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM69.6 208c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9H412.9c8 0 14.8-6 15.9-13.9l29.5-224c1.3-9.6-6.2-18.1-15.9-18.1H69.6zM400 336c0 57.4-64.5 104-144 104s-144-46.6-144-104s64.5-104 144-104s144 46.6 144 104zM16 104c0-13.3 10.7-24 24-24H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24z"]
};
var faHotel = {
  prefix: 'far',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM432 48V464H304V384h32c8.8 0 16.1-7.2 14.7-15.9C343.1 322.6 303.6 288 256 288s-87.1 34.6-94.7 80.1c-1.5 8.7 5.8 15.9 14.7 15.9h32v80H80V48H432zM144 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H144zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM336 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H336zM128 208v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
};
var faEarthAsia = {
  prefix: 'far',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M464 256c0-90.7-58.1-167.9-139.1-196.3l-16.4 40.9c-2.9 7.2-9 12.5-16.5 14.4l-17 4.3c-16.7 4.2-23.7 24-13.4 37.7l16.1 21.5c6.1 8.1 6.4 19.2 .8 27.7l-10.7 16.1C260.5 233.3 248 240 234.6 240h-2.3c-16.1 0-27.6 15.5-23 30.9l6 19.9c4.4 14.6-6.5 29.2-21.7 29.2c-10.7 0-20.6-6.1-25.4-15.7l-9.3-18.5c-7.3-14.7-26.9-17.8-38.4-6.2l-15.4 15.4c-5.7 5.7-13.8 8.1-21.7 6.6l-31.7-6.3C70 391.3 154.5 464 256 464c48.1 0 92.3-16.3 127.5-43.7l-5.9-4.3L359 422.9c-19.8 7.4-41.8-1.9-50.4-21.1L303 389.4c-8.5-18.9-1.1-41.2 17-51.3L356.2 318c2.3-1.3 4.3-3.1 5.7-5.3l6.1-9.5c6-9.4 16.4-15.1 27.6-15.1s21.6 5.7 27.6 15.1l2 3.1c3.7 5.8 10.8 8.6 17.5 6.7l14.6-4.1c4.4-16.9 6.8-34.5 6.8-52.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm163.9 80.5l32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 11c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zM350.3 135.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"]
};
var faGlobeAsia = faEarthAsia;
var faIdCardClip = {
  prefix: 'far',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M256 0c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H256zM192 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H384v48H512c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H192V64zm96 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"]
};
var faIdCardAlt = faIdCardClip;
var faMagnifyingGlassPlus = {
  prefix: 'far',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faThumbsUp = {
  prefix: 'far',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.1s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"]
};
var faCloudShowers = {
  prefix: 'far',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0h0c35.3 0 64 28.7 64 64s-28.7 64-64 64H108h-1.9c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3h4H400c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM112 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-13.3-10.7-24-24-24zm192 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-13.3-10.7-24-24-24zm-72 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V408zm168-24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V408c0-13.3-10.7-24-24-24z"]
};
var faUserClock = {
  prefix: 'far',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464H348.5c12.3 18.8 28 35.1 46.3 48H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304H224h45.7c20.6 0 40.4 3.5 58.8 9.9c-4.9 15.3-7.8 31.4-8.4 48.2c-15.5-6.5-32.5-10.1-50.4-10.1H178.3c-65.7 0-120.1 48.7-129 112zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]
};
var faOnion = {
  prefix: 'far',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M171.3 33.9c.2-.7 .4-1.5 .6-2.2c1-3.8 1.9-7.8 2.5-11.9C176.2 9 184.9 0 195.8 0c6.3 0 12.1 3 15.8 7.9l0 0c.7 .9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3l0 0C240.1 3 245.9 0 252.2 0c10.9 0 19.6 9 21.3 19.8c.6 4.1 1.5 8.1 2.5 11.9c.2 .7 .4 1.5 .6 2.2l0 .1c11.6 39.7 43.1 65.3 76 92C399 163.7 448 203.5 448 288c0 80.4-58 135.2-131.9 160.3l10.7 32.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2L269.4 460c-7.1 1.2-14.2 2.1-21.4 2.7V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V462.7c-7.2-.7-14.3-1.6-21.4-2.7l-11.9 35.6c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l10.7-32.1C58 423.2 0 368.4 0 288c0-84.5 49-124.3 95.3-162c32.9-26.7 64.4-52.4 76-92l0-.1zm31.3 48.2c-7.9 13.9-17.4 26-27.5 36.8c-.5 .5-1 1.1-1.5 1.6c-.4 .8-.9 1.9-1.5 3.2c-1.5 3.2-3.6 7.9-6.2 13.7c-5.1 11.7-12 28.2-18.9 46.9c-13.9 38.1-27 83.8-27 119.5c0 32.5 9.2 60.2 18.5 79.8c3.8 8.1 7.6 14.7 10.8 19.7c17.4 5.8 36.1 9.6 55.3 11.4C194.2 389.7 184 354.2 184 312c0-61.9 6.1-128.6 12.1-179.6c2.3-19.3 4.6-36.4 6.5-50.2zm34.3-13.5c-.3 1.8-.6 3.8-.9 5.8c-2.2 15.1-5.2 36.5-8.2 61.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c1.7 4 3.3 7.7 4.9 11c21.3-1.7 41.9-5.9 61-12.4c3.3-4.4 7.1-10.2 11-17.2c9.9-17.9 19.7-43.2 19.7-73.6c0-37.1-15.8-88.6-32.6-132.5c-8.3-21.6-16.6-40.7-22.8-54.5c-.8-1.9-1.7-3.7-2.4-5.3c-.2-.2-.4-.5-.7-.7c-13.2-14.2-25.6-30.8-34.5-50.7c-.5 .1-.9 .2-1.4 .3zm91.9 99.9c16.8 43.9 34.6 100.1 34.6 143.5c0 25.2-5.5 47.4-12.6 65.7C382.1 355.2 400 325.3 400 288c0-53.7-25.3-81.3-63.6-113.2c-2.4-2-5-4.1-7.6-6.3zM102.6 381.4C94.6 360.5 88 334.1 88 304c0-41.6 14.9-91.9 29-130.5c.6-1.5 1.1-3.1 1.7-4.6c-2.5 2-4.8 4-7.1 5.8C73.3 206.7 48 234.3 48 288c0 37.7 18.2 67.7 50 90.2c1.5 1.1 3.1 2.1 4.6 3.2z"]
};
var faClockTwelveThirty = {
  prefix: 'far',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 152V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faArrowDownToDottedLine = {
  prefix: 'far',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", "M32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM241.5 360.4c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1L200 283.5V200 72c0-13.3 10.7-24 24-24s24 10.7 24 24V200v83.5l86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136z"]
};
var faHandDots = {
  prefix: 'far',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64v2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64V336c0 1.5-.1 3-.4 4.5c-6.2 91.7-79.4 165-171.1 171.1c-1.5 .3-2.9 .4-4.5 .4h-8-8.5c-67.9 0-133-27-181-75L18.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7V96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24V95.9c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16V319.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L75.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9H296h4.9c.6-.1 1.3-.1 1.9-.2c69.7-3.4 125.6-59.3 129-129c0-.6 .1-1.3 .2-1.9V160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 .1V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V152l0-.1V96c0-8.8-7.2-16-16-16s-16 7.1-16 16l0 .1V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V96l0-.1V64c0-8.8-7.2-16-16-16s-16 7.2-16 16V96l0 .1V232zm0 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faAllergies = faHandDots;
var faFileInvoice = {
  prefix: 'far',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM192 400c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zM112 224H272c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32z"]
};
var faWindowMinimize = {
  prefix: 'far',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faRectangleWide = {
  prefix: 'far',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M576 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faCommentArrowUp = {
  prefix: 'far',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM280 328V217.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V328c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faGarlic = {
  prefix: 'far',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M376 131.2c-15.2-12.1-24-30.5-24-50V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48V81.2c0 19.4-8.8 37.8-24 50L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448H136v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h16v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h-4.5C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2zm-168-56V48h32V75.2c0 48.1 15 95 43 134.1l17.4 24.4c12.7 17.8 19.6 39.2 19.6 61.1V304c0 53-43 96-96 96s-96-43-96-96v-9.2c0-21.9 6.8-43.3 19.6-61.1L165 209.3c24.1-33.7 38.6-73.2 42.1-114.2c.6-4.6 .9-9.2 .9-13.9V75.2zM272 48h32V81.2c0 34 15.5 66.2 42 87.5l83.3 66.6c21.9 17.6 34.7 44.1 34.7 72.2c0 51.1-41.4 92.5-92.5 92.5H308.7c26.6-23.5 43.3-57.8 43.3-96v-9.2c0-28.6-8.9-56.5-25.5-79.7L309 190.7c-24.1-33.7-37-74.1-37-115.5V48zM139.3 400C88.8 399.4 48 358.2 48 307.5c0-28.1 12.8-54.7 34.7-72.2l57-45.6c-.2 .3-.5 .6-.7 1l-17.4 24.4C104.9 238.4 96 266.2 96 294.8V304c0 38.2 16.8 72.5 43.3 96z"]
};
var faMugSaucer = {
  prefix: 'far',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", "M144 80H432V288c0 26.5-21.5 48-48 48H192c-26.5 0-48-21.5-48-48V80zM128 32c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H448 128zM512 240H480V80h32c44.2 0 80 35.8 80 80s-35.8 80-80 80zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faCoffee = faMugSaucer;
var faBrush = {
  prefix: 'far',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M48 288V64c0-8.8 7.2-16 16-16H96v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48h64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V48h96c8.8 0 16 7.2 16 16V288H48zM0 320c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V320zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTreeDecorated = {
  prefix: 'far',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", "M242.9 9.3C238.4 3.4 231.4 0 224 0s-14.4 3.4-18.9 9.3L66.8 186.9c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5h16.5L35.1 326.2c-4.9 7.4-5.4 16.8-1.2 24.6s12.3 12.7 21.2 12.7H79L4.1 474.6c-5 7.4-5.5 16.9-1.3 24.7S15.1 512 24 512H424c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.3-24.7L369 363.5h24c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6L345.7 225.6h16.5c9.2 0 17.5-5.2 21.6-13.5s3-18-2.6-25.3L242.9 9.3zM147.2 177.6H134.9L224 63.1l89.1 114.5H300.8c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l67.2 100.6H323.8c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.3 24.7L378.9 464H69.1l74.9-111.1c5-7.4 5.5-16.9 1.3-24.7s-12.3-12.7-21.2-12.7H99.9l67.2-100.6c4.9-7.4 5.4-16.8 1.2-24.6s-12.3-12.7-21.2-12.7zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faMask = {
  prefix: 'far',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M91.4 162.3C61 188.5 48 225.2 48 272c0 43.9 15.3 74.8 36.8 95c22 20.6 53.7 33 91.2 33h8.4c6.1 0 11.6-3.4 14.3-8.8l23.2-46.3 39 19.5-39-19.5C234.4 319.8 260 304 288 304s53.6 15.8 66.1 40.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8H400c37.4 0 69.2-12.4 91.2-33c21.5-20.2 36.8-51.1 36.8-95c0-46.8-13-83.5-43.4-109.7C452.9 134.9 394.3 112 288 112s-164.9 22.9-196.6 50.3zM0 272C0 160 64 64 288 64s288 96 288 208s-80 176-176 176h-8.4c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4H176C80 448 0 384 0 272zm96-16a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCalendarHeart = {
  prefix: 'far',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM112 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faMagnifyingGlassMinus = {
  prefix: 'far',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faFlower = {
  prefix: 'far',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM192.9 100.9C177.6 87.8 157.8 80 136 80c-48.6 0-88 39.4-88 88c0 21.8 7.8 41.6 20.9 56.9c15.2 17.9 15.2 44.2 0 62.2C55.8 302.4 48 322.2 48 344c0 48.6 39.4 88 88 88c21.8 0 41.6-7.8 56.9-20.9c17.9-15.2 44.2-15.2 62.2 0C270.4 424.2 290.2 432 312 432c48.6 0 88-39.4 88-88c0-21.8-7.8-41.6-20.9-56.9c-15.2-17.9-15.2-44.2 0-62.2C392.2 209.6 400 189.8 400 168c0-48.6-39.4-88-88-88c-21.8 0-41.6 7.8-56.9 20.9c-17.9 15.2-44.2 15.2-62.2 0zM256 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faArrowDownFromArc = {
  prefix: 'far',
  iconName: 'arrow-down-from-arc',
  icon: [512, 512, [], "e614", "M256 48C141.1 48 48 141.1 48 256c0 13.3-10.7 24-24 24s-24-10.7-24-24C0 114.6 114.6 0 256 0S512 114.6 512 256c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-114.9-93.1-208-208-208zM134.4 392.3c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3L232 426.9 232 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 242.9 62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112z"]
};
var faRightLeftLarge = {
  prefix: 'far',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M182.1 504c-15.4 0-30.1-6.1-41-17L20.7 366.6C12.6 358.5 8 347.5 8 336s4.6-22.5 12.7-30.6L141.1 185c10.9-10.9 25.6-17 41-17c32 0 57.9 25.9 57.9 57.9V232l80 0h96 8 8c8.8 0 16 7.2 16 16v8 8l0 22.1c0 5.5 4.5 9.9 9.9 9.9c2.6 0 5.2-1 7-2.9L582.1 176 465 58.9c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9V88v8 8c0 8.8-7.2 16-16 16h-8-8H320c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V65.9C400 33.9 425.9 8 457.9 8c15.4 0 30.1 6.1 41 17L619.3 145.4c8.1 8.1 12.7 19.1 12.7 30.6s-4.6 22.5-12.7 30.6L498.9 327c-10.9 10.9-25.6 17-41 17c-32 0-57.9-25.9-57.9-57.9V280l-80 0H224h-8-8c-8.8 0-16-7.2-16-16v-8-8V225.9c0-5.5-4.5-9.9-9.9-9.9c-2.6 0-5.2 1-7 2.9L57.9 336 175 453.1c1.9 1.9 4.4 2.9 7 2.9c5.5 0 9.9-4.5 9.9-9.9V424v-8-8c0-8.8 7.2-16 16-16h8 8l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0v6.1c0 32-25.9 57.9-57.9 57.9z"]
};
var faRulerVertical = {
  prefix: 'far',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M192 48c8.8 0 16 7.2 16 16V96H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H192zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]
};
var faCirclesOverlap = {
  prefix: 'far',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", "M192 288c0 40.8 10.9 79 30 112c-96.3-1.1-174-79.5-174-176c0-97.2 78.8-176 176-176c38.9 0 74.8 12.6 104 34C248 116.2 192 195.5 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 16c-38.9 0-74.8-12.6-104-34C392 395.8 448 316.5 448 224c0-40.8-10.9-79-30-112c96.3 1.1 174 79.5 174 176c0 97.2-78.8 176-176 176z"]
};
var faUserLarge = {
  prefix: 'far',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", "M352 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-240 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM49.3 464H462.7c-8.3-54.4-55.3-96-112-96H161.3c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320H350.7C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"]
};
var faUserAlt = faUserLarge;
var faStarshipFreighter = {
  prefix: 'far',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M400 256c0-97.2-78.8-176-176-176S48 158.8 48 256s78.8 176 176 176c14.8 0 29.1-1.8 42.8-5.2L208 350.7c-45.4-7.6-80-47.1-80-94.7c0-53 43-96 96-96s96 43 96 96c0 1.3 0 2.7-.1 4l60 77.7C392.7 313.3 400 285.5 400 256zm40 112c1.1 0 2.3 0 3.4 .1L528 335.2V280H446.7c-3.4 31.8-13.4 61.6-28.7 88h22zm6.7-136H528V176.8l-118.2-46c19.9 29.5 32.9 63.9 36.9 101.1zM555.6 375.9l-57 22.2C507 409.9 512 424.4 512 440c0 39.8-32.2 72-72 72H368c-22.3 0-43.3-10.3-57-28l-9.9-12.9C275.9 477 250 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8V256v90.1c0 13.2-8.1 25-20.4 29.8zM88 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm152-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm77 198.7c4.5 5.9 11.6 9.3 19 9.3h72c13.3 0 24-10.7 24-24s-10.7-24-24-24H379.8L300.7 313.7c-9.7 12.9-22.6 23.3-37.5 30l85.8 111z"]
};
var faTrainTram = {
  prefix: 'far',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", "M55.5 63c7.6-9.5 19.1-15 31.2-15H200V96H160c-53 0-96 43-96 96V352c0 26 10.3 49.6 27.2 66.9L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l60.6-60.6c8.4 2.4 17.2 3.7 26.4 3.7H288c9.2 0 18-1.3 26.4-3.7L375 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-52.1-52.1C373.7 401.6 384 378 384 352V192c0-53-43-96-96-96H248V48H361.2c12.2 0 23.6 5.5 31.2 15l12.8 16c8.3 10.4 23.4 12 33.7 3.7s12-23.4 3.8-33.7L430 33C413.3 12.2 388 0 361.2 0H86.8C60 0 34.7 12.2 18 33L5.3 49C-3 59.4-1.3 74.5 9 82.7S34.5 89.3 42.7 79L55.5 63zM160 144H288c26.5 0 48 21.5 48 48v48H112V192c0-26.5 21.5-48 48-48zM112 288H336v64c0 26.5-21.5 48-48 48H160c-26.5 0-48-21.5-48-48V288zm72 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBridgeSuspension = {
  prefix: 'far',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", "M149.1 12.5C145 5 137.1 0 128 0c-8.8 0-16.5 4.7-20.7 11.8C94.3 33 80.7 53.9 65.3 71.5c-15.5 17.7-31.7 30.6-49.4 36.9C3.4 113-3.1 126.7 1.4 139.2s18.2 18.9 30.7 14.4c28.2-10.2 50.8-29.4 69.2-50.4c.9-1 1.8-2 2.6-3V240H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H536V100.2c.9 1 1.7 2 2.6 3c18.4 21 41 40.3 69.2 50.4c12.5 4.5 26.2-2 30.7-14.4s-2-26.2-14.4-30.7c-17.7-6.4-33.9-19.3-49.4-36.9c-15.4-17.6-29-38.6-42-59.8C528.5 4.7 520.8 0 512 0c-9.1 0-17 5-21.1 12.5C455.8 73.6 390.3 112 320 112s-135.8-38.4-170.9-99.5zM200 240H152V92.8c14.5 13.7 30.7 25.6 48 35.4V240zm96 0H248V149c15.5 4.8 31.6 8.1 48 9.8V240zm96 0H344V158.8c16.4-1.6 32.5-4.9 48-9.8v91zm96 0H440V128.3c17.3-9.8 33.5-21.7 48-35.4V240zM0 360c0 13.3 10.7 24 24 24H40c30.9 0 56 25.1 56 56v24c0 26.5 21.5 48 48 48h49.4c25.7 0 46.6-20.9 46.6-46.6V464c0-44.2 35.8-80 80-80s80 35.8 80 80v1.4c0 25.7 20.9 46.6 46.6 46.6H496c26.5 0 48-21.5 48-48V440c0-30.9 25.1-56 56-56h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H600c-57.4 0-104 46.6-104 104v24H448c0-70.7-57.3-128-128-128s-128 57.3-128 128H144V440c0-57.4-46.6-104-104-104H24c-13.3 0-24 10.7-24 24z"]
};
var faTrashCheck = {
  prefix: 'far',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80h13.7H416h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H412.4L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3H123.4c-33.5 0-61.3-25.9-63.8-59.3L35.6 128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80.1 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8H324.6c8.4 0 15.3-6.5 16-14.8L364.3 128H83.7zM318.1 246.1l-104 104c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L200 307.7l89.9-89.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
var faUserNurse = {
  prefix: 'far',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM216 40c-4.4 0-8 3.6-8 8V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216zM49.3 461.9H398.7c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7H30.7c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4z"]
};
var faBoombox = {
  prefix: 'far',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", "M136 48H504c22.1 0 40 17.9 40 40v72H448c0-17.7-14.3-32-32-32s-32 14.3-32 32H352c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H96V88c0-22.1 17.9-40 40-40zM48 88v74c-27.6 7.1-48 32.2-48 62V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V224c0-29.8-20.4-54.9-48-62V88c0-48.6-39.4-88-88-88H136C87.4 0 48 39.4 48 88zM64 208H576c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zM176 432a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-48-96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm432 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSyringe = {
  prefix: 'far',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", "M407 7c-9.4 9.4-9.4 24.6 0 33.9l15 15L384 94.1 329 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72 72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L456 89.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L473 39 441 7c-9.4-9.4-24.6-9.4-33.9 0zM271.4 94.6l-191 191C69.9 296.2 64 310.4 64 325.3v88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h88.8c14.9 0 29.1-5.9 39.6-16.4l191-191c-.3-.3-.7-.6-1-1l-33-33-191 191c-1.5 1.5-3.5 2.3-5.7 2.3H112V325.3c0-2.1 .8-4.2 2.3-5.7l27.3-27.3 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 13.1-13.1-33-33c-.3-.3-.6-.7-1-1z"]
};
var faCloudSun = {
  prefix: 'far',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM320.1 320c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0H557.8c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1V346.3c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9v-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3v5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7v6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0h-266c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"]
};
var faShieldExclamation = {
  prefix: 'far',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faStopwatch20 = {
  prefix: 'far',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h32V97.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-29.2 29.2c-31.1-27.5-70.4-45.9-113.8-50.9V48h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM64 304a160 160 0 1 1 320 0A160 160 0 1 1 64 304zm172-48v96c0 28.7 23.3 52 52 52s52-23.3 52-52V256c0-28.7-23.3-52-52-52s-52 23.3-52 52zm52-12c6.6 0 12 5.4 12 12v96c0 6.6-5.4 12-12 12s-12-5.4-12-12V256c0-6.6 5.4-12 12-12zm-132.4 8.6c1.7-5.1 6.5-8.6 11.9-8.6c6.9 0 12.5 5.6 12.5 12.5v2.2c0 3.6-1.3 7.1-3.7 9.8l-39 43.9c-13.7 15.4-21.2 35.2-21.2 55.8V384c0 11 9 20 20 20h64c11 0 20-9 20-20s-9-20-20-20H156.2c.9-9.2 4.7-17.9 10.9-24.9l39-43.9c8.9-10 13.8-23 13.8-36.4v-2.2c0-29-23.5-52.5-52.5-52.5c-22.6 0-42.7 14.5-49.8 35.9l-.6 1.7c-3.5 10.5 2.2 21.8 12.6 25.3s21.8-2.2 25.3-12.6l.6-1.7z"]
};
var faSquareFull = {
  prefix: 'far',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M464 48V464H48V48H464zM48 0H0V48 464v48H48 464h48V464 48 0H464 48z"]
};
var faGripDots = {
  prefix: 'far',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", "M352 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-160 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM224 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faCommentExclamation = {
  prefix: 'far',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM256 112c-13.3 0-24 10.7-24 24V248c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPenSwirl = {
  prefix: 'far',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", "M441.2 59.1L453.1 71c9.4 9.4 9.4 24.6 0 33.9L432 126.1 386.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM231.9 236.8L352.6 114.5 398.1 160 276.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L215 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM373 25.5L197.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.3-9.7 36.1-19.6L487.1 138.9c28.1-28.1 28.1-73.7 0-101.8L475.1 25.2C446.9-3.1 401-2.9 373 25.5zm-48.3-7.9C302.9 11.4 279.8 8 256 8C119 8 8 119 8 256S119 504 256 504c13.3 0 24-10.7 24-24s-10.7-24-24-24C145.5 456 56 366.5 56 256S145.5 56 256 56c9.7 0 19.3 .7 28.7 2l40-40.4zM454.1 228.4c1.2 9 1.9 18.2 1.9 27.6c0 57.4-46.6 104-104 104c-13.3 0-24 10.7-24 24s10.7 24 24 24c83.9 0 152-68.1 152-152c0-23.6-3.3-46.4-9.4-68l-40.4 40.5z"]
};
var faFalafel = {
  prefix: 'far',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M147.4 120.3c-15.2 18.4-15.2 45.1 0 63.5c.3 .4 .5 1 .3 1.6c-2.3 9-1.9 18.2 .6 26.6c-20.8-9-45-2.4-58.5 15.9c-.3 .4-.5 .4-.7 .4c-24.3-.7-44.9 16.5-49.4 39.9c-.1 .6-.5 1-.7 1.1c-21.9 10-33.1 34.3-27.3 57.3c.2 .6 0 1.3-.3 1.6c-15.2 18.4-15.2 45.1 0 63.5c.3 .4 .5 1 .3 1.6c-5.8 23 5.4 47.3 27.3 57.3c.2 .1 .6 .4 .7 1.1c4.6 23.4 25.2 40.6 49.4 39.9c.1 0 .4 0 .7 .4c14.3 19.4 40.5 25.6 61.9 14.3c.1-.1 .2-.1 .3-.1s.2 0 .3 .1c21.5 11.3 47.7 5 61.9-14.3c.3-.4 .5-.4 .7-.4c24.3 .7 44.9-16.5 49.4-39.9c.1-.6 .5-1 .7-1.1c10.2-4.7 18.1-12.4 23-21.7c4.9 9.3 12.8 17.1 23 21.7c.2 .1 .6 .4 .7 1.1c4.6 23.4 25.2 40.6 49.4 39.9c.1 0 .4 0 .7 .4c14.3 19.4 40.5 25.6 61.9 14.3c.1-.1 .2-.1 .3-.1s.2 0 .3 .1c21.5 11.3 47.7 5 61.9-14.3c.3-.4 .6-.4 .7-.4c24.3 .7 44.9-16.5 49.4-39.9c.1-.6 .5-1 .7-1.1c16.4-7.5 26.7-22.9 28.5-39.9c-18.6 7.3-39.4 6-56.9 1.2l-.1 0c-10 7.3-17 18.2-19.4 30.6c-.1 .5-.3 .8-.5 .9s-.3 .2-.4 .2c-16.1-.5-31.2 7.1-40.7 19.9c-.1 .2-.2 .2-.3 .3c-.1 .1-.2 .1-.2 .1s-.1 0-.2 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 0-.1 0-.1 .1l-.1 0-.1 0-.1 0-.1 0c-.1 0-.2 0-.2-.1c-.1 0-.2-.1-.3-.3c-9.5-12.8-24.6-20.4-40.7-19.9c-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c8.7 .2 17.1-1.8 24.5-5.9c-.9-11.7 .3-23.8 4.6-35.2c7.1-4.1 16-4.4 23.7-.4l.4 .2c13.8-12.1 20-31.3 15.4-49.7c-.2-.6 0-1.3 .3-1.6c15.2-18.4 15.2-45.1 0-63.5c-.3-.4-.5-1-.3-1.6c5.8-23-5.4-47.3-27.3-57.3c-.2-.1-.6-.4-.7-1.1c-4.6-23.4-25.2-40.6-49.4-39.9c-.1 0-.4 0-.7-.4C335.9 .6 309.7-5.7 288.3 5.6c-.1 .1-.2 .1-.3 .1s-.2 0-.3-.1c-21.5-11.3-47.7-5-61.9 14.3c-.3 .4-.5 .4-.7 .4c-24.3-.7-44.9 16.5-49.4 39.9c-.1 .6-.5 1-.7 1.1c-21.9 10-33.1 34.3-27.3 57.3c.2 .6 0 1.3-.3 1.6zM324.5 243.4c-5 3.2-9.4 7.3-13 12.2c-.1 .2-.2 .2-.3 .3s-.2 .1-.2 .1s-.1 0-.2 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 .1-.2 .1-.2 .1s-.1 0-.1 0l-.1 0c-.1 0-.2 0-.2-.1s-.2-.1-.3-.3c-3.6-4.9-8-9-13-12.2c-7.8-8.2-18.4-13.6-30.2-14.9c-4.2-12.9-13.7-23.7-26.3-29.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c16.1 .5 31.2-7.1 40.7-19.9c.1-.2 .2-.2 .3-.3s.2-.1 .2-.1s.1 0 .2 0c0 0 .1 0 .2 .1c14.2 7.5 31.1 7.5 45.3 0c.1-.1 .2-.1 .2-.1c0 0 .1 0 .2 0l.1 0 .1 0c0 0 .1 0 .1 .1c.1 0 .2 .1 .3 .3c9.5 12.8 24.6 20.4 40.7 19.9c.1 0 .2 0 .4 .2s.4 .5 .5 .9c3 15.6 13.3 28.9 27.9 35.5c.2 .1 .4 .2 .6 .6s.2 .8 .1 1.3c-3.9 15.4-.3 31.7 9.9 44c.2 .3 .4 .7 .4 1.1s-.2 .9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44c.1 .5 .1 .9-.1 1.3s-.4 .5-.6 .6c-12.6 5.8-22.1 16.6-26.3 29.5c-11.8 1.2-22.4 6.7-30.2 14.9zM48.4 361.1c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c16.1 .5 31.2-7.1 40.7-19.9c.1-.2 .2-.2 .3-.3s.2-.1 .2-.1s.1 0 .2 0c0 0 .1 0 .2 .1c14.2 7.5 31.1 7.5 45.3 0c.1-.1 .2-.1 .2-.1c0 0 .1 0 .2 0l.1 0 0 0c0 0 .1 0 .1 .1c.1 0 .2 .1 .3 .3c9.5 12.8 24.6 20.4 40.7 19.9c.1 0 .2 0 .4 .2s.4 .5 .5 .9c3 15.6 13.3 28.9 27.9 35.5c.2 .1 .4 .2 .6 .6s.2 .8 .1 1.3c-3.9 15.4-.3 31.7 9.9 44c.2 .3 .4 .7 .4 1.1s-.2 .9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44c.1 .5 .1 .9-.1 1.3s-.4 .5-.6 .6c-14.6 6.7-24.8 20-27.9 35.5c-.1 .5-.3 .8-.5 .9s-.3 .2-.4 .2c-16.1-.5-31.2 7.1-40.7 19.9c-.1 .2-.2 .2-.3 .3c0 0-.1 0-.1 .1c0 0-.1 0-.1 0l-.1 0-.1 0-.1 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 .1-.2 .1-.2 .1c0 0-.1 0-.2 0s-.2 0-.2-.1c-.1 0-.2-.1-.3-.3c-9.5-12.8-24.6-20.4-40.7-19.9c-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44zM416 261c-1 24.2 13.6 56 40.3 82.7c19.3 19.4 41.4 32.3 61.3 37.6c19.5 5.2 37 3 47.9-7.9c5.5-5.5 8.8-12.7 10-20.9c2.1-14.2-1.8-31.6-10.9-49.3c-5.2-10.1-12.1-20.3-20.6-30.1c-2.6-3-5.4-5.9-8.2-8.8l-.5-.5c-33.5-33.3-74.9-47.5-99.3-35.9c-3.5 1.7-6.6 3.8-9.4 6.6c-6.7 6.7-10.1 15.9-10.5 26.5zM112 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm224-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCircle2 = {
  prefix: 'far',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L167.6 342.5c-7.2 6.7-9.5 17.2-5.9 26.3S174.2 384 184 384H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H244.7l64.4-60.4C326.3 259.5 336 237 336 213.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1l-24.2 18.4c-10.5 8-12.6 23.1-4.5 33.6s23.1 12.6 33.6 4.5l24.2-18.4z"]
};
var faMagnet = {
  prefix: 'far',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M48 256c0 97.2 78.8 176 176 176s176-78.8 176-176V192H336v64c0 61.9-50.1 112-112 112s-112-50.1-112-112V192H48v64zM0 88C0 57.1 25.1 32 56 32h48c30.9 0 56 25.1 56 56V256c0 35.3 28.7 64 64 64s64-28.7 64-64V88c0-30.9 25.1-56 56-56h48c30.9 0 56 25.1 56 56V256c0 123.7-100.3 224-224 224S0 379.7 0 256V88z"]
};
var faJar = {
  prefix: 'far',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M32 24c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM256 128c8.8 0 16 7.2 16 16v80H48V144c0-8.8 7.2-16 16-16H256zm16 240v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V368H272zM64 80C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64H64z"]
};
var faGramophone = {
  prefix: 'far',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M127 0c10.5-.4 20 6 23.6 15.9l0 .1 .3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.6 22.9 40.1 40.4c5.4 10.9 8.2 23 8.2 35l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4H184c-13.3 0-24-10.7-24-24c0-1.7 .2-3.3 .5-4.8c2.2-10.9 11.9-19.2 23.5-19.2l110 0c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-44.1-7.3-133.1-7.9-241.4 69.4c-.3 .2-.7 .5-1 .7c-2.7 1.8-5.6 2.9-8.7 3.5c-3.2 .6-6.6 .6-10-.2c-1.4-.3-2.7-.8-4-1.3c-.4-.2-.8-.4-1.2-.6c-1.4-.7-2.7-1.5-3.9-2.4c-.7-.5-1.3-1.1-1.9-1.7c-1.3-1.2-2.4-2.6-3.4-4.1c-1.8-2.8-3-5.8-3.6-8.9c-.6-3.1-.5-6.4 .2-9.6c.1-.3 .2-.7 .3-1L104.8 17.9C107.5 7.7 116.5 .4 127 0zM94.8 243.4c54.3-29.5 103.6-42.4 144.6-46.7c-41.1-30.1-70.7-62.3-91.5-90.2c-4.5-6.1-8.6-11.9-12.3-17.5L94.8 243.4zM0 488c0-13.3 10.7-24 24-24h8V432c0-26.5 21.5-48 48-48H304c26.5 0 48 21.5 48 48v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H304 80 32 24c-13.3 0-24-10.7-24-24zm304-24V432H80v32H304z"]
};
var faDiceD12 = {
  prefix: 'far',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M200.3 48L158.7 72 256 102.8 353.3 72 311.7 48 200.3 48zm-97.1 56.7L49.7 197.3l83.9 93.1L232 241.2V145.6L103.2 104.7zM48 267.1v44.7l55.7 96.5L140 429.2l-33.1-96.8L48 267.1zM202.7 464h108l43.9-131.8L256 282.8l-98.5 49.3L202.7 464zm170.5-35.4l35.2-20.3L464 311.7V267.1l-58.8 65.3-32.1 96.2zm89.2-231.3l-53.4-92.5L280 145.6v95.6l98.4 49.2 83.9-93.1zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4H311.7c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24V311.7c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4H200.3c-8.4 0-16.7-2.2-24-6.4L79.7 449.8c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24V200.3c0-8.4 2.2-16.7 6.4-24L62.2 79.7c4.2-7.3 10.3-13.4 17.6-17.6L176.3 6.4z"]
};
var faNoteSticky = {
  prefix: 'far',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H288V352c0-17.7 14.3-32 32-32h80V96c0-8.8-7.2-16-16-16H64zM288 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320v5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"]
};
var faStickyNote = faNoteSticky;
var faDown = {
  prefix: 'far',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", "M192 429.6L49.3 279.7c-.8-.8-1.3-2-1.3-3.2c0-2.5 2-4.6 4.6-4.6l83.4 0c13.3 0 24-10.7 24-24l0-168 64 0 0 168c0 13.3 10.7 24 24 24l83.4 0c2.5 0 4.6 2 4.6 4.6c0 1.2-.5 2.3-1.3 3.2L192 429.6zM0 276.6c0 13.5 5.2 26.5 14.5 36.3L161.1 466.8c8.1 8.5 19.2 13.2 30.9 13.2s22.8-4.8 30.9-13.2L369.5 312.8c9.3-9.8 14.5-22.8 14.5-36.3c0-29-23.5-52.6-52.6-52.6L272 224l0-144c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 144-59.4 0C23.5 224 0 247.5 0 276.6z"]
};
var faArrowAltDown = faDown;
var faHundredPoints = {
  prefix: 'far',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M171.2 99.6C175.3 61.2 207.8 32 246.5 32c45 0 80.1 39 75.3 83.8L308.8 236.4c-4.1 38.5-36.6 67.6-75.3 67.6c-45 0-80.1-39-75.3-83.8L171.2 99.6zM246.5 80c-14.2 0-26 10.7-27.5 24.8L206 225.3c-1.8 16.4 11.1 30.7 27.5 30.7c14.2 0 26-10.7 27.5-24.8L274 110.7C275.8 94.3 262.9 80 246.5 80zm-128-43.4c6.9 5.1 10.4 13.4 9.4 22l-32 256c-1.6 13.2-13.6 22.7-26.8 21.3s-22.5-13.3-20.8-26.4L75 95 41.4 109.9c-12.2 5.4-26.3 0-31.5-12.1s.4-26.3 12.6-31.7l72-32c7.9-3.5 17-2.6 23.9 2.5zM431.7 32c44.4 0 79.2 37.9 75.6 82.1l-7.4 88.4c-3.3 39.3-36.1 69.5-75.6 69.5c-44.4 0-79.2-37.9-75.6-82.1l7.4-88.4C359.4 62.2 392.2 32 431.7 32zM404 105.5l-7.4 88.4C395.2 210.1 408 224 424.3 224c14.5 0 26.5-11.1 27.7-25.5l7.4-88.4C460.8 93.9 448 80 431.7 80c-14.5 0-26.5 11.1-27.7 25.5zM511.7 323.9c2.3 13.1-6.5 25.5-19.6 27.7l-464 80C15 433.9 2.6 425.1 .3 412.1s6.5-25.5 19.6-27.7l464-80c13.1-2.3 25.5 6.5 27.7 19.6zM459.9 439.7l-240 40c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l240-40c13.1-2.2 25.4 6.7 27.6 19.7s-6.7 25.4-19.7 27.6z"]
};
var fa100 = faHundredPoints;
var faPaperclipVertical = {
  prefix: 'far',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", "M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108V344c0 39.8-32.2 72-72 72s-72-32.2-72-72V152c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3 10.7 24 24 24s24-10.7 24-24V108c0-33.1-26.9-60-60-60s-60 26.9-60 60V368c0 53 43 96 96 96s96-43 96-96V152c0-13.3 10.7-24 24-24s24 10.7 24 24V368c0 79.5-64.5 144-144 144s-144-64.5-144-144V108z"]
};
var faWindWarning = {
  prefix: 'far',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M224 432c61.8 0 116.1-31.8 147.5-80h54.9c-36 75.7-113.1 128-202.4 128C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208H399.3C391.2 150.3 315.8 80 224 80C126.8 80 48 158.8 48 256s78.8 176 176 176zm0-304c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM478 224c-2.1-16.5-5.7-32.6-10.8-48H544c26.5 0 48-21.5 48-48s-21.5-48-48-48H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c53 0 96 43 96 96s-43 96-96 96H478zm-6 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64c30.9 0 56-25.1 56-56s-25.1-56-56-56H344c-13.3 0-24-10.7-24-24s10.7-24 24-24H536c57.4 0 104 46.6 104 104s-46.6 104-104 104H472z"]
};
var faWindCircleExclamation = faWindWarning;
var faLocationPinSlash = {
  prefix: 'far',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM192.3 125.4C216.3 79.4 264.5 48 320 48c79.5 0 144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2c-7.4 17.4-16.9 36.2-27.9 55.4L192.3 125.4zm-2.5 120.1l-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9c-.5-1.2-1-2.5-1.5-3.7z"]
};
var faMapMarkerSlash = faLocationPinSlash;
var faFaceSadSweat = {
  prefix: 'far',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", "M496 256c0 114.9-93.1 208-208 208c-65.4 0-123.8-30.2-162-77.5c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM35.7 299.4C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1zM360.4 409.5c9.7-9 10.2-24.2 1.2-33.9C347.3 360.3 322.6 344 288 344s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM367.6 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-192-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.7-100.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zm121.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faBugSlash = {
  prefix: 'far',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", "M224 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H252.4c-15.7 0-28.4-12.7-28.4-28.4V96zm73.7 112L432 313.3V264c0-30.9-25.1-56-56-56H297.7zM477.4 348.9L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L240 162.8c7.7-1.8 15.8-2.8 24-2.8H376c20 0 38.7 5.7 54.6 15.5L503 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C474.3 225.3 480 244 480 264h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H480v8c0 9.9-.9 19.5-2.6 28.9zm-46.6 86.5C402.1 463 363 480 320 480c-43.7 0-83.3-17.5-112.2-45.9L137 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8c-12-22.4-18.8-48.1-18.8-75.3v-8H88c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c0-12.9 2.4-25.3 6.7-36.7L208.1 260c-.1 1.3-.1 2.7-.1 4v56c0 53.6 37.7 98.4 88 109.4V329.2L344 367v62.4c18.3-4 34.8-12.4 48.6-24.1l38.2 30.1z"]
};
var faCupcake = {
  prefix: 'far',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M224 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7H152c-39.8 0-72 32.2-72 72l0 .8C34.9 142.7 0 181.3 0 228c0 50.8 41.2 92 92 92H356c50.8 0 92-41.2 92-92c0-46.8-35-85.5-80.2-91.3c.2-2 .2-4 .2-6.1C368 58.5 309.5 0 237.3 0H224zm40 57.3c0-1.7-.1-3.3-.2-5c32.7 11 56.2 41.9 56.2 78.3c0 6-1.8 11.5-4.8 16.1c-4.9 7.4-5.3 16.8-1.1 24.6s12.3 12.6 21.1 12.6H356c24.3 0 44 19.7 44 44s-19.7 44-44 44H92c-24.3 0-44-19.7-44-44s19.7-44 44-44h18.4c8.6 0 16.5-4.6 20.8-12s4.3-16.6 0-24c-2-3.5-3.2-7.6-3.2-12c0-13.3 10.7-24 24-24h57.3c30.2 0 54.7-24.5 54.7-54.7zM89.3 471.9C93.2 495 113.2 512 136.7 512h11.2l-20-160H69.3l20 119.9zM180.1 512h87.8l20-160H160.1l20 160zm120 0h11.2c23.5 0 43.5-17 47.3-40.1l20-119.9H320.1l-20 160z"]
};
var faLightSwitchOff = {
  prefix: 'far',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M169.4 464c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H214.6c-3.3 9.3-12.2 16-22.6 16s-19.3-6.7-22.6-16H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H169.4zM64 512c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64zm80-256h96V144H144V256zm0 160c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H144z"]
};
var faToggleLargeOff = {
  prefix: 'far',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M192 400a144 144 0 1 1 0-288 144 144 0 1 1 0 288zm0 48H384c106 0 192-86 192-192s-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448zm127-48c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h65c79.5 0 144 64.5 144 144s-64.5 144-144 144H319z"]
};
var faPenFancySlash = {
  prefix: 'far',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L398.9 287.3 548.8 147.8C566.2 131.6 576 109 576 85.3C576 38.2 537.8 0 490.7 0C467 0 444.4 9.8 428.2 27.2L275.8 190.9 38.8 5.1zM313.7 220.6L463.4 59.9c7.1-7.6 17-11.9 27.3-11.9C511.3 48 528 64.7 528 85.3c0 10.4-4.3 20.2-11.9 27.3L360.6 257.4l-46.9-36.8zM175.3 303.5l57.5-17.7L187 249.7l-25.8 7.9c-22.8 7-40.6 24.9-47.6 47.6L65.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l15.3-49.6-40.4-31.8-20.7 67.3c-2.3 7.6-8.3 13.5-15.9 15.9L149 449.7 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L126.3 427l33.1-107.7c2.3-7.6 8.3-13.5 15.9-15.9z"]
};
var faTruckContainer = {
  prefix: 'far',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M0 104C0 64.2 32.2 32 72 32H328c39.8 0 72 32.2 72 72V288c0 13.3-10.7 24-24 24s-24-10.7-24-24V104c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24V288c0 13.3-10.7 24-24 24s-24-10.7-24-24V104zM608 400c0 44.2-35.8 80-80 80s-80-35.8-80-80H432 288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32H432V256 168c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3V272v16 80c0 17.7-14.3 32-32 32zM585 256l-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9H480v64H585zM136 136V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBoot = {
  prefix: 'far',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", "M32 0H352c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H0V32C0 14.3 14.3 0 32 0zM0 464v-6.6V448 416 160H48V416H464V359.4c0-21.2-13.9-39.9-34.2-46L345 288H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.7c-1.8-5-2.7-10.4-2.7-16V224H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V160h48v80l91.6 27.5c40.6 12.2 68.4 49.6 68.4 92V416v32 9.4V464h-.4c-1.5 12-6.9 23.3-15.6 32c-10.2 10.2-24.1 16-38.6 16H442.5c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7H54.6c-14.5 0-28.4-5.8-38.6-16C7.3 487.3 1.9 476 .4 464H0z"]
};
var faArrowUpFromWaterPump = {
  prefix: 'far',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", "M112 0C85.5 0 64 21.5 64 48V256c-35.3 0-64 28.7-64 64V425c5.3-3.1 11.2-5.4 17.5-6.9c10.4-2.4 21.2-7.2 30.5-13.5V320c0-8.8 7.2-16 16-16H512c8.8 0 16 7.2 16 16v84.6c9.3 6.3 20.1 11.1 30.5 13.6c6.3 1.5 12.1 3.8 17.5 6.9V320c0-35.3-28.7-64-64-64H472l0-174.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 7c-9.4-9.4-24.6-9.4-33.9 0L351 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L424 256H288V48c0-26.5-21.5-48-48-48H112zm-.1 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
var faFileCheck = {
  prefix: 'far',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"]
};
var faBone = {
  prefix: 'far',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", "M127.4 177c-3.3-18.8-19.7-33-39.4-33c-22.1 0-40 17.9-40 40c0 11.7 4.9 22.1 13 29.5c24.8 22.8 24.8 62.2 0 85c-8 7.4-13 17.8-13 29.5c0 22.1 17.9 40 40 40c19.7 0 36.1-14.3 39.4-33c4.3-24.6 25.7-47 55.6-47H393c29.9 0 51.3 22.4 55.6 47c3.3 18.8 19.7 33 39.4 33c22.1 0 40-17.9 40-40c0-11.7-4.9-22.1-13-29.5c-24.8-22.8-24.8-62.2 0-85c8-7.4 13-17.8 13-29.5c0-22.1-17.9-40-40-40c-19.7 0-36.1 14.3-39.4 33c-4.3 24.6-25.7 47-55.6 47H183c-29.9 0-51.3-22.4-55.6-47zm47.3-8.3c.7 4.1 4.1 7.3 8.3 7.3H393c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88c0 25.7-11 48.8-28.5 64.9c-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88c-43.4 0-79.5-31.4-86.7-72.7c-.7-4.1-4.1-7.3-8.3-7.3H183c-4.1 0-7.6 3.2-8.3 7.3C167.5 384.6 131.4 416 88 416c-48.6 0-88-39.4-88-88c0-25.7 11-48.8 28.5-64.9c4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88c43.4 0 79.5 31.4 86.7 72.7z"]
};
var faCardsBlank = {
  prefix: 'far',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", "M51.8 160.4c-3.7 2.1-4.9 6.8-2.8 10.5l167 289.3c2.1 3.7 6.8 4.9 10.5 2.8L419.4 351.6c3.7-2.1 4.9-6.8 2.8-10.5L255.2 51.8c-2.1-3.7-6.8-4.9-10.5-2.8L51.8 160.4zM7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zm451.9 226c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13l135.3-78.1z"]
};
var faCircle3 = {
  prefix: 'far',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h66.3l-50.5 46.3c-7.3 6.7-9.7 17.2-6.1 26.5s12.6 15.3 22.5 15.2l51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2H240c-13.5 0-26-7-33-18.4l-2.6-4.2c-7-11.3-21.8-14.8-33-7.8s-14.8 21.8-7.8 33l2.6 4.2C182 368.4 209.9 384 240 384h27.8c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5c7.3-6.7 9.7-17.2 6.2-26.4s-12.5-15.3-22.4-15.3H184z"]
};
var faBenchTree = {
  prefix: 'far',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M578.7 150c-14.7-10.6-22.1-28.5-19.3-46.4c.4-2.5 .6-5 .6-7.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 2.6 .2 5.2 .6 7.6c2.8 17.9-4.6 35.8-19.3 46.4c-8.2 5.9-13.3 15.3-13.3 26c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-10.6-5.1-20.1-13.3-26zM608 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176c0 44.2-35.8 80-80 80H536V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V256H464c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96zM80 272H304V240H80v32zM32 224c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64c0 14.9-10.2 27.4-24 31v33h32c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H80v88c0 13.3-10.7 24-24 24s-24-10.7-24-24V400H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V319c-13.8-3.6-24-16.1-24-31V224zm72 96v32H280V320H104z"]
};
var faKeyboardBrightnessLow = {
  prefix: 'far',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm88-16c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faSkiBootSki = {
  prefix: 'far',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M415.6 28.5c2.5-13-6-25.6-19-28.1s-25.6 6-28.1 19L366 32H176c-11.3 0-21.1 7.9-23.5 19L88.8 348.3c-7.5 34.9 19.1 67.7 54.8 67.7H424c30.9 0 56-25.1 56-56V307.1c0-20.6-11.3-39.5-29.4-49.3l-71.7-38.6L415.6 28.5zM275 80h81.8l-15.4 80H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h31.3l-6.2 32H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.9l81.8 44.1c2.6 1.4 4.2 4.1 4.2 7V360c0 4.4-3.6 8-8 8H143.6c-5.1 0-8.9-4.7-7.8-9.7l26-121.3C202 215.7 249.2 171.2 275 80zm-33.4 0c-17.9 57.7-44.8 92-70.3 112.5L195.4 80h46.2zM640 408c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 30.9-25.1 56-56 56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H536c57.4 0 104-46.6 104-104z"]
};
var faBrainCircuit = {
  prefix: 'far',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M192 48c22.1 0 40 17.9 40 40v40H212.7c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24H232v96H192c-26.5 0-48 21.5-48 48v11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V304c0-8.8 7.2-16 16-16h40V420c0 24.3-19.7 44-44 44c-17.8 0-33.2-10.6-40.1-25.9c-3.8-8.4-12-13.9-21.2-14.1c-25.9-.7-46.7-21.9-46.7-48c0-2.6 .2-5.2 .6-7.6c1.4-8.5-2-17.1-8.7-22.5C57.3 334.1 48 316.2 48 296c0-19.3 8.5-36.6 22.1-48.3c8-6.9 10.5-18.3 6.1-28c-2.7-6-4.2-12.6-4.2-19.7c0-18.8 10.8-35.1 26.7-43c8.1-4 13.3-12.3 13.3-21.3c.1-19.3 11.7-36 28.3-43.5c6.4-2.9 11.3-8.5 13.2-15.3C158.3 60.2 173.8 48 192 48zm-4 464c26.9 0 51.2-11.6 68-30c16.8 18.5 41.1 30 68 30c32.2 0 60.5-16.5 76.9-41.5c45-8 79.1-47.3 79.1-94.5c0-.5 0-1.1 0-1.6c19.8-20.2 32-47.9 32-78.4c0-27.8-10.1-53.2-26.8-72.7C487 215.8 488 208 488 200c0-32.6-16.3-61.5-41.1-78.8c-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0c-25.2 0-48 10.6-64 27.6C240 10.6 217.2 0 192 0c-36.3 0-67.5 22-80.9 53.4C86.9 67.7 69.6 92.3 65.1 121.2C40.3 138.5 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.5 12.2 58.2 32 78.4c0 .5 0 1.1 0 1.6c0 47.3 34.1 86.5 79.1 94.5c16.4 25 44.7 41.5 76.9 41.5zm136-48c-24.3 0-44-19.7-44-44V352h51.3c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24H280V160h40c8.8 0 16 7.2 16 16v11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V176c0-26.5-21.5-48-48-48H280V88c0-22.1 17.9-40 40-40c18.2 0 33.7 12.2 38.5 28.9c1.9 6.8 6.8 12.4 13.2 15.3c16.6 7.5 28.2 24.1 28.3 43.5c.1 9.1 5.2 17.3 13.3 21.3c15.9 7.9 26.7 24.2 26.7 43c0 7.1-1.5 13.7-4.2 19.7c-4.4 9.7-1.9 21 6.1 28c13.5 11.8 22.1 29 22.1 48.3c0 20.2-9.3 38.1-23.9 49.9c-6.7 5.4-10 14-8.7 22.5c.4 2.5 .6 5 .6 7.6c0 26.1-20.8 47.3-46.7 48c-9.2 .3-17.4 5.7-21.2 14.1C357.2 453.4 341.8 464 324 464zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faUserInjured = {
  prefix: 'far',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M224 208c-44.2 0-80-35.8-80-80h32H304c0 44.2-35.8 80-80 80zM150.7 96C163 67.7 191.2 48 224 48c1.2 0 2.5 0 3.7 .1L170.2 96H150.7zM264.6 59c14.5 8.5 26 21.5 32.8 37H220.2l44.4-37zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM49.3 464c4.7-33.3 21.9-62.5 46.7-82.7V464H49.3zm246.3 0H261.3l-32-48H276c15.5 0 28 12.5 28 28c0 7.8-3.2 14.9-8.4 20zm37 0c2.2-6.3 3.4-13 3.4-20c0-33.1-26.9-60-60-60H208l-21.3-32h83c65.7 0 120.1 48.7 129 112H332.6zM178.3 304C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"]
};
var faBlockBrickFire = {
  prefix: 'far',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M176 80v48h32 48 80V80H176zm-48 48V80H96c-8.8 0-16 7.2-16 16v32h48zM80 176v56H208V176H80zm0 160h48V280H80v56zm0 48v32c0 8.8 7.2 16 16 16H208V384H176 128 80zm96-48H288.8c-.5 4.7-.8 9.4-.8 14.1c0 11.5 1 22.9 3 33.9H256v48h50.1c8.1 17.5 18.8 33.7 31.5 48H96c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64v48.6c-1.7-1.5-3.3-3.1-5-4.6c-17.7-16-44.7-16-62.5-.1c-12.9 11.5-25.1 23.7-36.5 36.1H256v56h76c-2.4 3.6-4.7 7.2-6.9 10.7c-7.4 12-14.2 24.5-19.9 37.3H176v56zM432 128V96c0-8.8-7.2-16-16-16H384v48h48zm21.5 35.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faFirewall = faBlockBrickFire;
var faFaceSadTear = {
  prefix: 'far',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSadTear = faFaceSadTear;
var faPlane = {
  prefix: 'far',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M557.3 215.3c9.9 9.7 18.7 23.3 18.7 40.7c0 17.4-8.6 31.2-18.7 41.1c-9.9 9.7-22.6 17-34.9 22.4C497.8 330.2 468.6 336 448 336l-66.2 0L285.7 486.2c-10.3 16.1-28.1 25.8-47.2 25.8l-40.6 0c-27.1 0-46.4-26.4-38.1-52.2L199.4 336 148 336l-36 48L92.8 369.6 112 384c-7.6 10.1-19.4 16-32 16l-42.1 0C17 400 0 383 0 362.1c0-3.8 .6-7.5 1.7-11.1c0 0 0 0 0 0L30.9 256 1.7 161.1s0 0 0 0C.6 157.4 0 153.7 0 149.9C0 129 17 112 37.9 112L80 112c12.6 0 24.4 5.9 32 16l36 48 51.4 0L159.8 52.2C151.6 26.4 170.8 0 197.9 0l40.6 0c19.1 0 36.9 9.7 47.2 25.8L381.8 176l66.2 0c20.7 0 50 6.1 74.5 16.9c12.3 5.5 24.9 12.8 34.8 22.4zm-54.2 21.5c-19-8.4-41.7-12.8-55.1-12.8l-79.4 0c-8.2 0-15.8-4.2-20.2-11.1L245.2 51.7l20.2-12.9L245.2 51.7c-1.5-2.3-4-3.7-6.7-3.7l-29.6 0 46.3 144.7c2.3 7.3 1 15.3-3.5 21.5s-11.7 9.8-19.4 9.8L136 224c-7.6 0-14.7-3.6-19.2-9.6L76 160l-24.4 0 27.4 88.9c1.4 4.6 1.4 9.5 0 14.1L51.6 352 76 352l40.8-54.4c4.5-6 11.6-9.6 19.2-9.6l96.3 0c7.7 0 14.9 3.7 19.4 9.8s5.8 14.2 3.5 21.5L208.9 464l29.6 0c2.7 0 5.3-1.4 6.7-3.7L348.4 299.1c4.4-6.9 12-11.1 20.2-11.1l79.4 0c13.6 0 36.3-4.2 55.2-12.5c9.4-4.1 16.3-8.5 20.6-12.7c4.1-4 4.2-6.2 4.2-6.8l0 0c0-.2 0-2.2-4.2-6.3c-4.3-4.2-11.3-8.7-20.7-12.9zM47.6 365l0 0 0 0s0 0 0 0zm0-218.1s0 0 0 0l0 0 0 0z"]
};
var faTentArrowsDown = {
  prefix: 'far',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512H451.1c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2V464H124.9c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29V232.9L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1H374.4L312 360z"]
};
var faExclamation = {
  prefix: 'far',
  iconName: 'exclamation',
  icon: [64, 512, [10069, 10071, 61738], "21", "M56 56c0-13.3-10.7-24-24-24S8 42.7 8 56V344c0 13.3 10.7 24 24 24s24-10.7 24-24V56zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faArrowsSpin = {
  prefix: 'far',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M257.1 87.5c-11.3 0-22.4 1.1-33.1 3.3V42.1c10.8-1.7 21.9-2.5 33.1-2.5c56 0 107 21.3 145.4 56.2l35.1-35.1c10.1-10.1 27.3-2.9 27.3 11.3l0 105.4c0 8.8-7.2 16-16 16l-105.4 0c-14.3 0-21.4-17.2-11.3-27.3l36.3-36.3c-29.6-26.3-68.7-42.2-111.4-42.2zM129.9 145.9c-25.4 29.4-40.7 67.8-40.7 109.7c0 11.1 1.1 22 3.1 32.5H43.6c-1.6-10.6-2.4-21.4-2.4-32.5c0-55.2 20.7-105.5 54.7-143.7L60.7 76.7C50.6 66.6 57.7 49.4 72 49.4l105.4 0c8.8 0 16 7.2 16 16V170.7c0 14.3-17.2 21.4-27.3 11.3l-36.2-36.2zm52.2 202.4l-34.6 34.6c29.4 25.4 67.8 40.7 109.7 40.7c10.5 0 20.9-1 30.9-2.8v48.6c-10.1 1.4-20.4 2.2-30.9 2.2c-55.2 0-105.5-20.7-143.7-54.7L76.7 453.6c-10.1 10.1-27.3 2.9-27.3-11.3l0-105.4c0-8.8 7.2-16 16-16l105.4 0c14.3 0 21.4 17.2 11.3 27.3zm166.2-16l34.7 34.7c26.3-29.6 42.2-68.7 42.2-111.4c0-10.8-1-21.3-3-31.5h48.7c1.5 10.3 2.3 20.8 2.3 31.5c0 56-21.3 107-56.2 145.4l36.7 36.7c10.1 10.1 2.9 27.3-11.3 27.3H336.9c-8.8 0-16-7.2-16-16V343.5c0-14.3 17.2-21.4 27.3-11.3z"]
};
var faFaceSmileRelaxed = {
  prefix: 'far',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm-2-98.1c-10.6 0-19.9 3.8-25.4 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
var faCommentXmark = {
  prefix: 'far',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM175 159c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faCommentTimes = faCommentXmark;
var faPrint = {
  prefix: 'far',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M112 160V64c0-8.8 7.2-16 16-16H357.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64v96h48zm16 208H384v96H128V368zm-16-48c-17.7 0-32 14.3-32 32H48V256c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16v96H432c0-17.7-14.3-32-32-32H112zm320 80h48c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64V368c0 17.7 14.3 32 32 32H80v80c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V400z"]
};
var faTurkishLiraSign = {
  prefix: 'far',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", "M88 32c13.3 0 24 10.7 24 24v56.2L249.4 72.9c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7L112 162.1v46.1l137.4-39.3c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7L112 258.1V432h71.8c81.3 0 148.2-63.9 151.8-145.1l.4-8c.6-13.2 11.8-23.5 25.1-22.9s23.5 11.8 22.9 25.1l-.4 8C378.8 395.9 290.7 480 183.8 480H88c-13.3 0-24-10.7-24-24V271.8l-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11V175.8l-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11V56c0-13.3 10.7-24 24-24z"]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faFaceNoseSteam = {
  prefix: 'far',
  iconName: 'face-nose-steam',
  icon: [512, 512, [], "e382", "M256 464c-21.6 0-42.4-3.3-61.9-9.4c-3.1 8.6-8.1 16.7-15 23.6c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-7-7-12-15.2-15.1-23.9c-19 5.7-39.2 8.8-60 8.8zM464 256c0 21.3-3.2 41.8-9.1 61.1c8.5 3.1 16.5 8.1 23.4 14.9c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1c8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c7.2-7.2 15.7-12.3 24.7-15.4C51 296.8 48 276.8 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208zM345.9 443.6s0 0 0 0c1.5 4.7 4.1 9.1 7.9 12.9c.7 .7 1.3 1.3 2 1.9c4.2 3.6 9.2 5.9 14.4 6.9c-1.8 3.7-2.8 7.7-3.1 11.7c-.1 1.3-.1 2.7 0 4c0 .6 .1 1.3 .2 1.9c.8 6.9 3.9 13.6 9.2 18.9c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5c0 0 0 0 0 0c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-3.6-3.6-7.9-6.2-12.5-7.7c0 0 0 0 0 0c-11.1-3.7-23.9-1.1-32.8 7.7c-4.4 4.4-7.2 9.7-8.5 15.3l-69.1-46.8c-2.7-1.9-6.4-1.5-8.7 .8c-2.3 2.3-2.7 5.9-.9 8.7l46 70c-5.6 1.3-10.9 4.2-15.3 8.5c-8.8 8.8-11.4 21.3-7.9 32.4zM142.4 485.5c.4-1.8 .7-3.6 .8-5.4c.3-5.4-.7-10.8-3.1-15.7c5.2-1 10.1-3.3 14.4-6.9c.7-.6 1.4-1.2 2-1.8c3.7-3.7 6.3-8.2 7.9-12.9c3.5-11 .9-23.6-7.9-32.4c-4.4-4.4-9.7-7.2-15.3-8.5l47.6-69.1c1.9-2.7 1.5-6.4-.8-8.8c-2.3-2.3-5.9-2.7-8.6-.9l-70.9 46.1c-1.3-5.6-4.2-10.9-8.5-15.3c-8.6-8.6-20.8-11.3-31.6-8.1c-5 1.5-9.7 4.2-13.6 8.1c-.7 .7-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2C1.7 445.6 3 472.7 20.3 489.9s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c4.4-4.4 7.2-9.8 8.5-15.4zM112 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm95.2-101.1c-2.8-8.4-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1c8.4-2.8 12.9-11.9 10.1-20.2zm-286.4 0c-2.8 8.4 1.7 17.4 10.1 20.2c35.5 11.8 64.4 34.8 73.7 44.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9c-8.4-2.8-17.4 1.7-20.2 10.1z"]
};
var faCircleWaveformLines = {
  prefix: 'far',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c0-13.3-10.7-24-24-24s-24 10.7-24 24V368c0 13.3 10.7 24 24 24s24-10.7 24-24V144zm80 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V312c0 13.3 10.7 24 24 24s24-10.7 24-24V200zM176 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V216zm240 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V240z"]
};
var faWaveformCircle = faCircleWaveformLines;
var faDollarSign = {
  prefix: 'far',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V71.7c-3.1 .1-6.2 .3-9.3 .6c-23.2 1.9-47.2 7.4-67.2 20.1C38.7 105.6 23.5 126 18 154.2c-3.9 20.3-2 38.8 6.1 55.2c8 16 20.9 27.6 34.8 36.2c26.2 16.2 61.9 25.3 92.9 33.2l2.3 .6c33.9 8.6 62.6 16.1 81.7 28c9 5.6 14.3 11.2 17.1 16.9c2.7 5.3 4.2 12.8 2 24.5c-2.9 14.7-13.4 26.9-34.5 34.9c-21.6 8.2-52 10.9-87.6 5.9c-22.6-3.3-61.8-12.7-83-22.1c-12.1-5.4-26.3 .1-31.7 12.2s.1 26.3 12.2 31.7C57 423.2 101.1 433.4 126 437l.1 0c3.3 .5 6.6 .9 9.9 1.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V439.4c19.3-1.3 37.4-4.9 53.5-11c31.9-12.1 57.7-35.2 64.5-70.6c3.9-20.3 2-38.8-6.1-55.2c-8-16-20.9-27.6-34.8-36.2c-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28c-9-5.6-14.3-11.2-17.1-16.9c-2.7-5.3-4.2-12.8-2-24.5c2.9-14.8 10.1-24 20.2-30.4c10.9-6.9 26.3-11.2 45.3-12.7c38.3-3.1 83.1 5.3 113.9 12.5c12.9 3.1 25.8-4.9 28.9-17.8s-4.9-25.8-17.8-28.9c-18.7-4.4-44.2-9.7-71.5-12.5V24z"]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faFerrisWheel = {
  prefix: 'far',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M371.4 73.4c-20.4-13-43.2-22.6-67.5-28.1C302.5 20.1 281.6 0 256 0s-46.5 20.1-47.9 45.3c-24.3 5.5-47.1 15.1-67.5 28.1c-8-5.9-17.9-9.4-28.5-9.4c-26.5 0-48 21.5-48 48c0 10.7 3.5 20.6 9.4 28.5c-13 20.4-22.6 43.2-28.1 67.5C20.1 209.5 0 230.4 0 256s20.1 46.5 45.3 47.9c5.5 24.3 15.1 47.1 28.1 67.5c-5.9 8-9.4 17.9-9.4 28.6c0 25.6 20 46.4 45.1 47.9l38.5-80c-7.4-8.3-17.7-13.9-29.3-15.5c-14.8-21.1-24.9-45.7-28.7-72.4h90c-2.4-7.6-3.7-15.6-3.7-24s1.3-16.4 3.7-24h-90c3.8-26.7 13.9-51.3 28.7-72.4c2.1-.3 4.1-.7 6-1.2L185.1 219c7.6-14.5 19.5-26.4 33.9-33.9l-60.6-60.6c.5-2 .9-4 1.2-6c21.1-14.8 45.7-24.9 72.4-28.7v90c7.6-2.4 15.6-3.7 24-3.7s16.4 1.3 24 3.7v-90c26.7 3.8 51.3 13.9 72.4 28.7c.3 2.1 .7 4.1 1.2 6L293 185.1c14.5 7.6 26.4 19.5 33.9 33.9l60.6-60.6c2 .5 4 .9 6 1.2c14.8 21.1 24.9 45.7 28.7 72.4h-90c2.4 7.6 3.7 15.6 3.7 24s-1.3 16.4-3.7 24h90c-3.8 26.7-13.9 51.3-28.7 72.4c-11.6 1.5-21.8 7.2-29.3 15.5l38.5 80C428 446.4 448 425.6 448 400c0-10.7-3.5-20.6-9.4-28.6c13-20.4 22.6-43.2 28.1-67.5c25.3-1.4 45.3-22.3 45.3-47.9s-20.1-46.5-45.3-47.9c-5.5-24.3-15.1-47.1-28.1-67.5c5.9-8 9.4-17.9 9.4-28.5c0-26.5-21.5-48-48-48c-10.7 0-20.6 3.5-28.6 9.4zM304 256c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.6 4.1 22.3 11 30.6L130.2 477.9c-3.5 7.4-2.9 16.1 1.5 23s12 11.1 20.2 11.1H360c8.2 0 15.8-4.2 20.2-11.1s5-15.6 1.5-23L293 286.6c6.9-8.3 11-19 11-30.6zm18.4 208H189.6L256 321l66.4 143z"]
};
var faComputerSpeaker = {
  prefix: 'far',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", "M312.4 480c-11.8-13.2-20.1-29.7-23.1-48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H312.4zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H288V336H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H289.3c3.1-18.3 11.3-34.8 23.1-48H64zM576 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H576zM384 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H384zm96 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM448 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faSkullCow = {
  prefix: 'far',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5C0 166.1 57.2 224 128 224v0h16v64c0 45 31 82.8 72.7 93.2l25.6 85.2c8.1 27.1 33 45.6 61.3 45.6h32.8c28.3 0 53.2-18.5 61.3-45.6l25.6-85.2C465 370.8 496 333 496 288V224h16v0c70.8 0 128-57.9 128-128.5c0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1s-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2C587.7 106.3 563.7 128 535 128H512v0H471.6C454 108.4 428.4 96 400 96H240c-28.4 0-54 12.4-71.6 32H128v0H105c-28.7 0-52.7-21.7-55.6-50.3c-.8-7.8 .1-15.8 2.6-23.2L63.2 21.1zM228.3 334.6C207.4 329.4 192 310.4 192 288V224 192c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48v32 64c0 22.4-15.4 41.4-36.3 46.6c-16.4 4.1-29.5 16.6-34.4 32.8l-25.6 85.2c-2 6.8-8.3 11.4-15.3 11.4H303.6c-7.1 0-13.3-4.6-15.3-11.4l-25.6-85.2c-4.9-16.2-17.9-28.7-34.4-32.8zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faX = {
  prefix: 'far',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.1 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z"]
};
var faMagnifyingGlassDollar = {
  prefix: 'far',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm20-312c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faUsersGear = {
  prefix: 'far',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2H178.7c9.5-36.8 42.9-64 82.6-64H371.9c3.6-5 8.2-9.1 13.5-12.2l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM624.6 355.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faUsersCog = faUsersGear;
var faPersonMilitaryPointing = {
  prefix: 'far',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M224 39c0-13 10-23.8 22.9-24.9L398.7 1.4C408 .7 416 8 416 17.4V48c0 8.8-7.2 16-16 16H249c-13.8 0-25-11.2-25-25zM32 248c0-13.3 10.7-24 24-24H232h8H344h.6c42.9 0 82.5 22.9 103.9 60l92.3 160c6.6 11.5 2.7 26.2-8.8 32.8s-26.2 2.7-32.8-8.8L416 323.8V480c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V272H56c-13.3 0-24-10.7-24-24zm240 24v82.1L345.4 272c-.5 0-1 0-1.4 0H272zm0 192h96V432H272v32zm96-145.2L309.7 384H368V318.8zM240 112c0-5.5 .6-10.8 1.6-16h50.7c-2.7 4.7-4.3 10.2-4.3 16c0 17.7 14.3 32 32 32s32-14.3 32-32c0-5.8-1.6-11.3-4.3-16h50.7c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
var faBuildingColumns = {
  prefix: 'far',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192H477.9c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144H88.2L256 51.4 423.8 144H283.7c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224V384c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V224H400V384H336V224H288V384H224V224H176V384H112V224H64zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H32z"]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faCircleT = {
  prefix: 'far',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V360c0 13.3 10.7 24 24 24s24-10.7 24-24V192h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 152z"]
};
var faSack = {
  prefix: 'far',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M293.3 152H218.7l-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48c0-139-102.9-220.6-156.9-255.2L293.3 152zm.2-58.8L324.6 48H187.4l31.1 45.2L226 104h60l7.5-10.8zM0 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 121.9 37.6C111 21.7 122.4 0 141.7 0H370.3c19.3 0 30.7 21.7 19.8 37.6L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96z"]
};
var faGrid2 = {
  prefix: 'far',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", "M80 80v96h96V80H80zM32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zM80 336v96h96V336H80zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336zM432 80H336v96h96V80zM336 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 304v96h96V336H336zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336z"]
};
var faCameraCctv = {
  prefix: 'far',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M54.9 192.2l169.3 70.5c.1 0 .2 .1 .2 .1c.6 .2 1.1 .4 1.6 .7l92.2 38.4 160-106.7L134.9 52.2l-80 140zM185.2 298.5l-165.5-69c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9L229.5 317 182.4 440.5C178.9 449.8 170 456 160 456H48v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V432 376c0-13.3 10.7-24 24-24s24 10.7 24 24v32h95.5l41.7-109.5zm211.8 47.1l132.9-88.6 36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-1.7 4-4.9 7.2-8.9 8.7s-8.5 1.5-12.5-.3L396.9 345.6z"]
};
var faCctv = faCameraCctv;
var faUmbrella = {
  prefix: 'far',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M288 0c13.3 0 24 10.7 24 24V48.9c123.7 9.6 226.1 93 255.5 204.4c.4 1.4 .7 2.9 1.1 4.3c1.4 5.8 2.7 11.7 3.7 17.6c.6 3.5 1.1 7.1 1.6 10.7c2 15.6-17.3 24.4-27.8 12.7c-2.5-2.8-5.5-5.5-8.8-8c-3.4-2.5-7.1-4.9-11.1-7l-.7-.4-.6-.3c-13.5-6.8-29.7-11-44.9-11c-30.1 0-56.3 16.6-70 41.2c-.5 .9-1 1.7-1.4 2.6c-2.1 4.1-3.8 8.3-5.1 12.8c-.7 2.4-1.4 4.9-1.9 7.5c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5c-1.4-4.4-3.1-8.7-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6c-13.7-24.6-39.9-41.2-70-41.2s-56.3 16.6-70 41.2c-.5 .9-.9 1.7-1.4 2.6c-2.1 4.1-3.8 8.3-5.1 12.8c-.7 2.4-1.4 4.9-1.9 7.5c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5c-1.4-4.4-3.1-8.7-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6C152.3 288.6 126.1 272 96 272c-15.2 0-31.4 4.2-44.9 11c-.4 .2-.9 .5-1.3 .7c-4 2.1-7.7 4.4-11.1 7c-3.3 2.5-6.3 5.2-8.8 8C19.4 310.4 .1 301.5 2.1 285.9c.5-3.6 1-7.2 1.6-10.7c1-5.9 2.3-11.8 3.7-17.6c.4-1.4 .7-2.9 1.1-4.3C37.9 141.9 140.3 58.6 264 48.9V24c0-13.3 10.7-24 24-24zm96 267.3c23.4-26.6 57.7-43.3 96-43.3c8.6 0 17.5 .9 26.4 2.6C468.9 150.2 386.1 96 288 96s-180.9 54.2-218.4 130.6c8.9-1.7 17.8-2.6 26.4-2.6c38.3 0 72.6 16.8 96 43.3c23.4-26.6 57.7-43.3 96-43.3s72.6 16.8 96 43.3zM288 304c8.7 0 16.9 2.3 24 6.4V438.6c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4V310.4c7.1-4.1 15.3-6.4 24-6.4z"]
};
var faTrowel = {
  prefix: 'far',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", "M340.4 142L370 171.6l87.9-87.9c8.2-8.2 8.2-21.4 0-29.6s-21.4-8.2-29.6 0L340.4 142zM491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-5.4-5.4L237.9 308l75 75c5.9 5.9 8.3 14.5 6.4 22.6s-8 14.6-15.9 17.2l-272 88c-8.6 2.8-18 .5-24.4-5.9s-8.6-15.8-5.9-24.4l88-272c2.6-7.9 9.1-14 17.2-15.9s16.7 .5 22.6 6.4l75 75L304.3 173.8l-5.4-5.4c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zM251.3 389.2L122.8 260.7l-61.5 190 190-61.5z"]
};
var faHorizontalRule = {
  prefix: 'far',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 256c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
};
var faBedFront = {
  prefix: 'far',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M32 80V205.8c14.5-7.7 30.8-12.4 48-13.6l0-.3V160c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h32V160c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32l0 .3c17.2 1.1 33.5 5.9 48 13.6V80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80zM88 224c-48.6 0-88 39.4-88 88v80 64c0 13.3 10.7 24 24 24s24-10.7 24-24V416H464v40c0 13.3 10.7 24 24 24s24-10.7 24-24V392 312c0-48.6-39.4-88-88-88H88zM464 368H48V312c0-22.1 17.9-40 40-40H424c22.1 0 40 17.9 40 40v56z"]
};
var faBedAlt = faBedFront;
var faD = {
  prefix: 'far',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M56 80c-4.4 0-8 3.6-8 8V424c0 4.4 3.6 8 8 8H160c97.2 0 176-78.8 176-176s-78.8-176-176-176H56zM0 88C0 57.1 25.1 32 56 32H160c123.7 0 224 100.3 224 224s-100.3 224-224 224H56c-30.9 0-56-25.1-56-56V88z"]
};
var faStapler = {
  prefix: 'far',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M448 384v48H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H448h48 24 72c26.5 0 48-21.5 48-48V336 299.3 288l-.7-.1c-3.8-31.8-23.3-59.9-52.4-74.4L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L11.5 144.7C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L64 240V344c0 22.1 17.9 40 40 40H448zm0-48H112V252l336 84zm72 96H496V336c0-22-15-41.2-36.4-46.6L55.2 188.3c-4.2-1.1-7.2-4.8-7.2-9.2c0-2 .7-4 1.9-5.7l32.3-43.1C106 98.7 143.3 80 182.9 80c19.5 0 38.8 4.6 56.3 13.3L565.5 256.4c14.5 7.3 24.3 21.3 26.2 37.2c.1 .8 .2 1.6 .3 2.4v3.4V336v96H520z"]
};
var faMasksTheater = {
  prefix: 'far',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M376.1 32.1c-41.2 .7-71.8 7.8-94.3 16.7c-23.1-2-53.9-1.4-94 5.2C95.6 69.1 60.7 98 49.3 110.7L76.8 271.9c4.9 28.7 17.5 52.2 36.1 67.2c20.3 16.4 45.2 34 70.7 46.2c10.4 5 20 8.6 28.8 11.1c1.7 3.1 3.4 6.1 5.3 9.2c8.1 13 17.9 27.5 29.1 42.1c-58 4.9-123.3-37.8-165-71.7c-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28c1.7 1.2 3.2 2.5 4.5 4zM194 282.3c-15.6 5.8-29.7 14-42.1 24.2c-6.6 5.4-16.8 1.7-15.6-6.6c5.4-35 31.3-64.6 67.2-74.3l-8.5 49.6c-.4 2.3-.8 4.7-1.1 7zM176.7 153.7c4.5-3.2 11.1-2.2 12.2 3.1c.1 .5 .2 1.1 .3 1.6c3.7 21.7-11.2 42.2-33.4 45.8s-43.1-11-46.8-32.7c-.1-.5-.2-1.1-.2-1.6c-.7-5.4 5.3-8.4 10.5-6.9c9.3 2.8 19.5 3.6 29.8 1.9s19.6-5.7 27.5-11.3zM385.1 510.6c-60-9.8-110.5-74.6-140.1-122c-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9C289.5 76.8 344 51.8 460.2 70.9S619.5 131 634.5 152.1c5.8 8.1 6.4 18.2 4.7 28L611.3 343.8c-6.4 37.2-23.5 72.2-53.2 96.2c-43.7 35.4-113.1 80.5-173 70.7zm-47-80.7c20.7 20.3 39.5 31 55 33.6s36.9-1.6 63.2-14.2c25.5-12.2 50.4-29.8 70.7-46.2c18.6-15.1 31.2-38.6 36.1-67.3l27.5-161.2C579.3 162 544.4 133.1 452.1 118s-134.9 1-149.9 9.4L274.7 288.6c-4.9 28.7-.8 54.9 11.8 75.1c13.7 22 31.5 46.6 51.5 66.2zm57.3-193.4c-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9c.1-.5 .2-1.1 .2-1.6c3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1 .5-.2 1.1-.3 1.6c-1.1 5.3-7.8 6.3-12.2 3.1zm140.4 17.9c-1.1 5.3-7.8 6.3-12.2 3.1c-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9c.1-.5 .2-1.1 .2-1.6c3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1 .5-.2 1.1-.3 1.6zm-20.3 56.6c7.9-3.2 16.5 3.5 12.8 11.1c-21.1 44.3-70.3 71.2-121.9 62.8s-89.2-49.7-94.4-98.2c-.9-8.3 9.4-12 15.8-6.4c24.3 21.2 54.8 36.2 89.3 41.8s68.3 1.2 98.3-11.1z"]
};
var faTheaterMasks = faMasksTheater;
var faKipSign = {
  prefix: 'far',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M88 32c13.3 0 24 10.7 24 24V210.5L312.3 37.8c10-8.7 25.2-7.5 33.8 2.5s7.5 25.2-2.5 33.8L160.6 232H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H160.6L343.7 437.8c10 8.7 11.2 23.8 2.5 33.8s-23.8 11.2-33.8 2.5L112 301.5V457c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V56c0-13.3 10.7-24 24-24z"]
};
var faFaceWoozy = {
  prefix: 'far',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 208c0-35.3-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64s32-28.7 32-64zM213.8 247.3c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l64-16zM200.9 98.7c-7.4-4.9-17.3-2.9-22.2 4.4c-23.2 34.8-58.4 53.2-71.7 57.7c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1c18.6-6.2 60.3-28.3 88.3-70.3c4.9-7.4 2.9-17.3-4.4-22.2zM385.8 360.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6L319 362.3c-3.3 3.6-7.9 5.7-12.8 5.7c-3.5 0-6.9-1.1-9.8-3l-11.7-8.1c-24-16.5-54.7-19.4-81.4-7.7c-11.7 5.2-25.3 3.7-35.7-3.9l-9.4-6.9c-10.7-7.8-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6l9.4 6.9c24.2 17.8 56 21.2 83.4 9.1c11.4-5 24.5-3.8 34.8 3.3l11.7 8.1c10.9 7.5 23.8 11.5 37 11.5c18.4 0 36-7.8 48.3-21.4l31.3-34.5z"]
};
var faCloudQuestion = {
  prefix: 'far',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM233.8 197.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H286.6c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPineapple = {
  prefix: 'far',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M423.1 1.7c4.2 2.1 7.3 5.9 8.4 10.5l3.6 14.3C447 19.6 460.6 16 474.5 16H480c8.8 0 16 7.2 16 16v5.5c0 13.9-3.6 27.5-10.4 39.4l14.3 3.6c4.6 1.1 8.4 4.2 10.5 8.4s2.2 9.1 .4 13.4c-6.8 15.9-19.5 26.7-34.1 31.6l14.7 14.7c6.2 6.2 6.2 16.4 0 22.6c-15.4 15.4-35.3 23.6-55.5 24.5c8 18.9 12.2 39.3 12.2 60.2c0 41-16.3 80.3-45.3 109.3L301.3 466.7C272.3 495.7 233 512 192 512s-80.3-16.3-109.3-45.3L45.3 429.3l33.9-33.9 37.5 37.5c20 20 47.1 31.2 75.3 31.2s55.3-11.2 75.3-31.2L368.8 331.3c20-20 31.2-47.1 31.2-75.3s-11.2-55.3-31.2-75.3l-37.5-37.5c-20-20-47.1-31.2-75.3-31.2s-55.3 11.2-75.3 31.2L79.2 244.7C59.2 264.7 48 291.8 48 320s11.2 55.3 31.2 75.3L45.3 429.3C16.3 400.3 0 361 0 320s16.3-80.3 45.3-109.3L146.7 109.3C175.7 80.3 215 64 256 64c20.9 0 41.3 4.2 60.2 12.2c.9-20.2 9.1-40.1 24.5-55.5c6.2-6.2 16.4-6.2 22.6 0l14.7 14.7C383 20.8 393.8 8.1 409.7 1.3c4.3-1.8 9.2-1.7 13.4 .4zm-235.8 211L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 313.4zM164.7 372.7c6.2-6.2 16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faHandPointLeft = {
  prefix: 'far',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"]
};
var faGalleryThumbnails = {
  prefix: 'far',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M512 48c8.8 0 16 7.2 16 16V288c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM0 448v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512z"]
};
var faCircleJ = {
  prefix: 'far',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360c0-13.3-10.7-24-24-24s-24 10.7-24 24V288c0 26.5-21.5 48-48 48s-48-21.5-48-48v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 53 43 96 96 96s96-43 96-96V152z"]
};
var faEyes = {
  prefix: 'far',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", "M255.6 385.2C231.4 416.6 201.5 432 172 432s-59.4-15.4-83.6-46.8c-9.1-11.9-17.1-25.7-23.5-41.2c9.2 5.1 19.8 8 31.1 8c35.3 0 64-28.7 64-64s-28.7-64-64-64c-19 0-36.1 8.3-47.8 21.4c2-47.8 17.7-89.3 40.2-118.6C112.6 95.4 142.5 80 172 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2zM320 141.8C290 76.1 235 32 172 32C77 32 0 132.3 0 256S77 480 172 480c63 0 118-44.1 148-109.8C350 435.9 405 480 468 480c95 0 172-100.3 172-224s-77-224-172-224c-63 0-118 44.1-148 109.8zm42.8 206.6c6.6 2.3 13.7 3.6 21.2 3.6c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.8 0-28.5 5-39.3 13.5c3.3-44.4 18.5-83 39.8-110.6C408.6 95.4 438.5 80 468 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2C527.4 416.6 497.5 432 468 432s-59.4-15.4-83.6-46.8c-8.2-10.7-15.5-23.1-21.6-36.7z"]
};
var faHandshakeSimple = {
  prefix: 'far',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", "M272.2 64.6c-4.4-.4-8.8-.6-13.2-.6H248.7c-37.2 0-73.2 13.7-101 38.4L121.1 126c-1.5 1.3-3.4 2-5.3 2H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h59.8c13.7 0 27-5 37.2-14.1l26.5-23.6c12-10.7 26.2-18.3 41.5-22.5l51.1-51.1zM377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-70.1 66.2c-30.8 29.1-30.1 78.3 1.6 106.5c27.8 24.7 69.7 24.3 97-.9l35.8-33 75.8 75.8c9.4 9.4 9.4 24.6 0 33.9c-8.4 8.4-21.6 9.3-30.9 2.6c-7.1-5.1-16.5-5.9-24.4-2.1s-13.1 11.6-13.6 20.4c-.4 7.1-3.2 14-8.6 19.4c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1c0 0 0 0 0 0l-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H93.7c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c6.1-6.1 10.9-12.9 14.6-20.2c22.2 3.8 45.8-2.9 63-20.1c5.6-5.6 10.1-11.9 13.5-18.7H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H469.2c-2.9-12.9-9.3-25.1-19.4-35.1l-74.4-74.4 .8-.8c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-71.9 66.4c-9.2 8.5-23.2 8.6-32.5 .3c-10.6-9.4-10.9-26-.5-35.7l70.1-66.2c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H505.1L475 101.2C448 77.3 413.2 64 377.1 64z"]
};
var faHandshakeAlt = faHandshakeSimple;
var faPageCaretUp = {
  prefix: 'far',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V138.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7H64c-8.8 0-16 7.2-16 16V448zm272 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2H122.2c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z"]
};
var faFileCaretUp = faPageCaretUp;
var faJetFighter = {
  prefix: 'far',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", "M216 0h23.8 .4H296c13.3 0 24 10.7 24 24s-10.7 24-24 24h-6.9c4.7 6.1 9.8 12.6 15.1 19.6c25.3 32.8 56.8 74.1 81.8 108.4h97.1c5.7 0 11.3 .9 16.7 2.5l108.1 33.8C627 218.3 640 236 640 256s-13 37.7-32.1 43.7L499.8 333.4c-5.4 1.7-11 2.6-16.7 2.6H386L288.5 464H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H240.2h-.5H216 184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V336H177.9l-31.6 31.6c-10.5 10.5-24.7 16.4-39.6 16.4H88c-30.9 0-56-25.1-56-56V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V184c0-30.9 25.1-56 56-56h18.7c14.9 0 29.1 5.9 39.6 16.4L177.9 176H192V48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h32zm24 176h86.4c-19.9-26.7-41.6-55.1-60.1-79.1C256.3 84 247.3 72.4 240 63V176zM80 280v48c0 4.4 3.6 8 8 8h18.7c2.1 0 4.2-.8 5.7-2.3L151 295c4.5-4.5 10.6-7 17-7H483.1c.8 0 1.6-.1 2.4-.4L586.7 256 485.5 224.4c-.8-.2-1.6-.4-2.4-.4H168c-6.4 0-12.5-2.5-17-7l-38.6-38.6c-1.5-1.5-3.5-2.3-5.7-2.3H88c-4.4 0-8 3.6-8 8v48h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H80zm160 56V448.4L325.6 336H240z"]
};
var faFighterJet = faJetFighter;
var faComet = {
  prefix: 'far',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M459.8 3.2c4.7-2.1 9.8-3.2 15-3.2C495.3 0 512 16.7 512 37.2c0 5.2-1.1 10.3-3.2 15L449.3 187.5l10.7-.8c33.9-2.6 55.4 35.5 35.6 63.1L369.2 426.7C331 480.2 269.3 512 203.6 512C91 512 0 419.8 0 307.5c0-64.8 30.6-126.3 82.7-165L261.6 9.6c27.5-20.4 66.3 .9 63.7 35.1L324 62.9 459.8 3.2zm-6 55.1l-147 64.7c-7.7 3.4-16.6 2.5-23.5-2.4s-10.7-13-10.1-21.4l3-40.6L111.4 181C71.6 210.6 48 257.8 48 307.5C48 393.6 117.8 464 203.6 464c50.2 0 97.4-24.3 126.6-65.2l116.4-163L413 238.5c-8.4 .6-16.5-3.2-21.4-10.1s-5.8-15.8-2.4-23.5L453.8 58.3zM208 200c6.1 0 11.7 3.5 14.3 8.9l24.5 49.6 54.8 8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-39.6 38.6 9.4 54.5c1 6-1.4 12.1-6.4 15.7s-11.5 4.1-16.8 1.2l-49-25.8-49 25.8c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.7l9.4-54.5-39.6-38.6c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l54.8-8 24.5-49.6c2.7-5.5 8.3-8.9 14.3-8.9z"]
};
var faSquareShareNodes = {
  prefix: 'far',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm352 80c0 26.5-21.5 48-48 48c-9.8 0-18.9-2.9-26.5-7.9L197.7 256l79.9 39.9c7.6-5 16.7-7.9 26.5-7.9c26.5 0 48 21.5 48 48s-21.5 48-48 48c-25.5 0-46.4-20-47.9-45.1l-85.6-42.8c-7.6 5-16.7 7.9-26.5 7.9c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.8 0 18.9 2.9 26.5 7.9l85.6-42.8C257.6 148 278.5 128 304 128c26.5 0 48 21.5 48 48z"]
};
var faShareAltSquare = faSquareShareNodes;
var faShieldKeyhole = {
  prefix: 'far',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM312 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6V328c0 13.3 10.7 24 24 24s24-10.7 24-24V258.6c18.9-9 32-28.3 32-50.6z"]
};
var faBarcode = {
  prefix: 'far',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm112 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zM464 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faPlusMinus = {
  prefix: 'far',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M216 32c0-13.3-10.7-24-24-24s-24 10.7-24 24V152H48c-13.3 0-24 10.7-24 24s10.7 24 24 24H168V320c0 13.3 10.7 24 24 24s24-10.7 24-24V200H336c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V32zM8 488c0 13.3 10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H32c-13.3 0-24 10.7-24 24z"]
};
var faSquareSlidersVertical = {
  prefix: 'far',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 96c-13.3 0-24 10.7-24 24v32H104c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V360c0 13.3 10.7 24 24 24s24-10.7 24-24V232h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H168V152c0-13.3-10.7-24-24-24zm184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V280H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v32c0 13.3 10.7 24 24 24s24-10.7 24-24V328h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H328V152z"]
};
var faSlidersVSquare = faSquareSlidersVertical;
var faVideo = {
  prefix: 'far',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64v33V351v33c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM528 363.4V148.6L416 199V146.4L520.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5v241c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L416 365.6V313l112 50.4z"]
};
var faVideoCamera = faVideo;
var faMessageMiddle = {
  prefix: 'far',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M343.5 368H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H168.5c14.2 0 27.8 6.3 36.9 17.3L256 446l50.6-60.7c9.1-10.9 22.6-17.3 36.9-17.3zm-175 48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H343.5l-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z"]
};
var faCommentMiddleAlt = faMessageMiddle;
var faGraduationCap = {
  prefix: 'far',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M320 80c2.5 0 5 .4 7.4 1.3l218 78.7-218 78.7c-2.4 .9-4.9 1.3-7.4 1.3s-5-.4-7.4-1.3L184.9 192.6l140.8-52.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4L154.9 169.6c-5.2 2-10.3 4.2-15.3 6.6L94.7 160l218-78.7c2.4-.9 4.9-1.3 7.4-1.3zM15.8 182.6l77.4 27.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32s-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6zm480.8 80l-46.5 16.8 12.7 120.5c-4.8 3.5-12.8 8-24.6 12.6C410 423.6 368 432 320 432s-90-8.4-118.3-19.4c-11.8-4.6-19.8-9.2-24.6-12.6l12.7-120.5-46.5-16.8L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6zM467.4 396a.7 .7 0 1 0 -1.2-.7 .7 .7 0 1 0 1.2 .7zm-294.8 0a.7 .7 0 1 0 1.2-.6 .7 .7 0 1 0 -1.2 .6z"]
};
var faMortarBoard = faGraduationCap;
var faHandHoldingMedical = {
  prefix: 'far',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M224 24c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24V80h56c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H320v56c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V176H168c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h56V24zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H387.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H344 320 256c-13.3 0-24-10.7-24-24s10.7-24 24-24h64 24c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z"]
};
var faPersonCircleCheck = {
  prefix: 'far',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1H146.3c-.8 0-1.5 0-2.3 .1zM144 352V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H144zm144 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSquareZ = {
  prefix: 'far',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136 32H312c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMessageText = {
  prefix: 'far',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM168 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h64V296c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 168z"]
};
var faCommentAltText = faMessageText;
var faTurnUp = {
  prefix: 'far',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M175.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3H264V352c0 88.4-71.6 160-160 160H56c-30.9 0-56-25.1-56-56V424c0-30.9 25.1-56 56-56h56c4.4 0 8-3.6 8-8V208H78.3C52.7 208 32 187.3 32 161.7c0-12.8 5.3-25 14.6-33.7L175.6 6.5zM82.5 160H144c13.3 0 24 10.7 24 24V360c0 30.9-25.1 56-56 56H56c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h48c61.9 0 112-50.1 112-112V184c0-13.3 10.7-24 24-24h61.5L192 57 82.5 160z"]
};
var faLevelUpAlt = faTurnUp;
var icons = {
  fa0: fa0,
  fa1: fa1,
  fa2: fa2,
  fa3: fa3,
  fa4: fa4,
  fa5: fa5,
  fa6: fa6,
  fa7: fa7,
  fa8: fa8,
  fa9: fa9,
  faFillDrip: faFillDrip,
  faArrowsToCircle: faArrowsToCircle,
  faCircleChevronRight: faCircleChevronRight,
  faChevronCircleRight: faChevronCircleRight,
  faWagonCovered: faWagonCovered,
  faLineHeight: faLineHeight,
  faBagel: faBagel,
  faTransporter7: faTransporter7,
  faAt: faAt,
  faRectanglesMixed: faRectanglesMixed,
  faPhoneArrowUpRight: faPhoneArrowUpRight,
  faPhoneArrowUp: faPhoneArrowUp,
  faPhoneOutgoing: faPhoneOutgoing,
  faTrashCan: faTrashCan,
  faTrashAlt: faTrashAlt,
  faCircleL: faCircleL,
  faHeadSideGoggles: faHeadSideGoggles,
  faHeadVr: faHeadVr,
  faTextHeight: faTextHeight,
  faUserXmark: faUserXmark,
  faUserTimes: faUserTimes,
  faFaceHandYawn: faFaceHandYawn,
  faGaugeSimpleMin: faGaugeSimpleMin,
  faTachometerSlowest: faTachometerSlowest,
  faStethoscope: faStethoscope,
  faCoffin: faCoffin,
  faMessage: faMessage,
  faCommentAlt: faCommentAlt,
  faSalad: faSalad,
  faBowlSalad: faBowlSalad,
  faInfo: faInfo,
  faRobotAstromech: faRobotAstromech,
  faRingDiamond: faRingDiamond,
  faFonduePot: faFonduePot,
  faTheta: faTheta,
  faFaceHandPeeking: faFaceHandPeeking,
  faSquareUser: faSquareUser,
  faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
  faCompressAlt: faCompressAlt,
  faExplosion: faExplosion,
  faFileLines: faFileLines,
  faFileAlt: faFileAlt,
  faFileText: faFileText,
  faWaveSquare: faWaveSquare,
  faRing: faRing,
  faBuildingUn: faBuildingUn,
  faDiceThree: faDiceThree,
  faTirePressureWarning: faTirePressureWarning,
  faWifiFair: faWifiFair,
  faWifi2: faWifi2,
  faCalendarDays: faCalendarDays,
  faCalendarAlt: faCalendarAlt,
  faMp3Player: faMp3Player,
  faAnchorCircleCheck: faAnchorCircleCheck,
  faTally4: faTally4,
  faRectangleHistory: faRectangleHistory,
  faBuildingCircleArrowRight: faBuildingCircleArrowRight,
  faVolleyball: faVolleyball,
  faVolleyballBall: faVolleyballBall,
  faSunHaze: faSunHaze,
  faTextSize: faTextSize,
  faUfo: faUfo,
  faFork: faFork,
  faUtensilFork: faUtensilFork,
  faArrowsUpToLine: faArrowsUpToLine,
  faMobileSignal: faMobileSignal,
  faBarcodeScan: faBarcodeScan,
  faSortDown: faSortDown,
  faSortDesc: faSortDesc,
  faFolderArrowDown: faFolderArrowDown,
  faFolderDownload: faFolderDownload,
  faCircleMinus: faCircleMinus,
  faMinusCircle: faMinusCircle,
  faFaceIcicles: faFaceIcicles,
  faShovel: faShovel,
  faDoorOpen: faDoorOpen,
  faFilms: faFilms,
  faRightFromBracket: faRightFromBracket,
  faSignOutAlt: faSignOutAlt,
  faFaceGlasses: faFaceGlasses,
  faNfc: faNfc,
  faAtom: faAtom,
  faSoap: faSoap,
  faIcons: faIcons,
  faHeartMusicCameraBolt: faHeartMusicCameraBolt,
  faMicrophoneLinesSlash: faMicrophoneLinesSlash,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faClosedCaptioningSlash: faClosedCaptioningSlash,
  faCalculatorSimple: faCalculatorSimple,
  faCalculatorAlt: faCalculatorAlt,
  faBridgeCircleCheck: faBridgeCircleCheck,
  faSlidersUp: faSlidersUp,
  faSlidersV: faSlidersV,
  faLocationMinus: faLocationMinus,
  faMapMarkerMinus: faMapMarkerMinus,
  faPumpMedical: faPumpMedical,
  faFingerprint: faFingerprint,
  faSkiBoot: faSkiBoot,
  faStandardDefinition: faStandardDefinition,
  faRectangleSd: faRectangleSd,
  faH1: faH1,
  faHandPointRight: faHandPointRight,
  faMagnifyingGlassLocation: faMagnifyingGlassLocation,
  faSearchLocation: faSearchLocation,
  faMessageBot: faMessageBot,
  faForwardStep: faForwardStep,
  faStepForward: faStepForward,
  faFaceSmileBeam: faFaceSmileBeam,
  faSmileBeam: faSmileBeam,
  faLightCeiling: faLightCeiling,
  faMessageExclamation: faMessageExclamation,
  faCommentAltExclamation: faCommentAltExclamation,
  faBowlScoop: faBowlScoop,
  faBowlShavedIce: faBowlShavedIce,
  faSquareX: faSquareX,
  faUtilityPoleDouble: faUtilityPoleDouble,
  faFlagCheckered: faFlagCheckered,
  faChevronsUp: faChevronsUp,
  faChevronDoubleUp: faChevronDoubleUp,
  faFootball: faFootball,
  faFootballBall: faFootballBall,
  faUserVneck: faUserVneck,
  faSchoolCircleExclamation: faSchoolCircleExclamation,
  faCrop: faCrop,
  faAnglesDown: faAnglesDown,
  faAngleDoubleDown: faAngleDoubleDown,
  faUsersRectangle: faUsersRectangle,
  faPeopleRoof: faPeopleRoof,
  faSquareArrowRight: faSquareArrowRight,
  faArrowSquareRight: faArrowSquareRight,
  faLocationPlus: faLocationPlus,
  faMapMarkerPlus: faMapMarkerPlus,
  faLightbulbExclamationOn: faLightbulbExclamationOn,
  faPeopleLine: faPeopleLine,
  faBeerMugEmpty: faBeerMugEmpty,
  faBeer: faBeer,
  faCrateEmpty: faCrateEmpty,
  faDiagramPredecessor: faDiagramPredecessor,
  faTransporter: faTransporter,
  faCalendarCircleUser: faCalendarCircleUser,
  faArrowUpLong: faArrowUpLong,
  faLongArrowUp: faLongArrowUp,
  faPersonCarryBox: faPersonCarryBox,
  faPersonCarry: faPersonCarry,
  faFireFlameSimple: faFireFlameSimple,
  faBurn: faBurn,
  faPerson: faPerson,
  faMale: faMale,
  faLaptop: faLaptop,
  faFileCsv: faFileCsv,
  faMenorah: faMenorah,
  faUnion: faUnion,
  faChevronsLeft: faChevronsLeft,
  faChevronDoubleLeft: faChevronDoubleLeft,
  faCircleHeart: faCircleHeart,
  faHeartCircle: faHeartCircle,
  faTruckPlane: faTruckPlane,
  faRecordVinyl: faRecordVinyl,
  faBringForward: faBringForward,
  faSquareP: faSquareP,
  faFaceGrinStars: faFaceGrinStars,
  faGrinStars: faGrinStars,
  faSigma: faSigma,
  faCameraMovie: faCameraMovie,
  faBong: faBong,
  faClarinet: faClarinet,
  faTruckFlatbed: faTruckFlatbed,
  faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
  faPastafarianism: faPastafarianism,
  faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
  faLeafHeart: faLeafHeart,
  faHouseBuilding: faHouseBuilding,
  faCheeseSwiss: faCheeseSwiss,
  faSpoon: faSpoon,
  faUtensilSpoon: faUtensilSpoon,
  faJarWheat: faJarWheat,
  faEnvelopesBulk: faEnvelopesBulk,
  faMailBulk: faMailBulk,
  faFileCircleExclamation: faFileCircleExclamation,
  faBowArrow: faBowArrow,
  faCartXmark: faCartXmark,
  faHexagonXmark: faHexagonXmark,
  faTimesHexagon: faTimesHexagon,
  faXmarkHexagon: faXmarkHexagon,
  faCircleH: faCircleH,
  faHospitalSymbol: faHospitalSymbol,
  faMerge: faMerge,
  faPager: faPager,
  faCartMinus: faCartMinus,
  faAddressBook: faAddressBook,
  faContactBook: faContactBook,
  faPanFrying: faPanFrying,
  faGrid: faGrid,
  faGrid3: faGrid3,
  faFootballHelmet: faFootballHelmet,
  faHandLove: faHandLove,
  faTrees: faTrees,
  faStrikethrough: faStrikethrough,
  faPage: faPage,
  faK: faK,
  faDiagramPrevious: faDiagramPrevious,
  faGaugeMin: faGaugeMin,
  faTachometerAltSlowest: faTachometerAltSlowest,
  faFolderGrid: faFolderGrid,
  faEggplant: faEggplant,
  faRam: faRam,
  faLandmarkFlag: faLandmarkFlag,
  faLips: faLips,
  faPencil: faPencil,
  faPencilAlt: faPencilAlt,
  faBackward: faBackward,
  faCaretRight: faCaretRight,
  faComments: faComments,
  faPaste: faPaste,
  faFileClipboard: faFileClipboard,
  faDesktopArrowDown: faDesktopArrowDown,
  faCodePullRequest: faCodePullRequest,
  faPumpkin: faPumpkin,
  faClipboardList: faClipboardList,
  faPenField: faPenField,
  faBlueberries: faBlueberries,
  faTruckRampBox: faTruckRampBox,
  faTruckLoading: faTruckLoading,
  faNote: faNote,
  faArrowDownToSquare: faArrowDownToSquare,
  faUserCheck: faUserCheck,
  faCloudXmark: faCloudXmark,
  faVialVirus: faVialVirus,
  faBookBlank: faBookBlank,
  faBookAlt: faBookAlt,
  faGolfFlagHole: faGolfFlagHole,
  faMessageArrowDown: faMessageArrowDown,
  faCommentAltArrowDown: faCommentAltArrowDown,
  faFaceUnamused: faFaceUnamused,
  faSheetPlastic: faSheetPlastic,
  faCircle9: faCircle9,
  faBlog: faBlog,
  faUserNinja: faUserNinja,
  faPencilSlash: faPencilSlash,
  faBowlingPins: faBowlingPins,
  faPersonArrowUpFromLine: faPersonArrowUpFromLine,
  faDownRight: faDownRight,
  faScrollTorah: faScrollTorah,
  faTorah: faTorah,
  faWebhook: faWebhook,
  faBlindsOpen: faBlindsOpen,
  faFence: faFence,
  faUp: faUp,
  faArrowAltUp: faArrowAltUp,
  faBroomBall: faBroomBall,
  faQuidditch: faQuidditch,
  faQuidditchBroomBall: faQuidditchBroomBall,
  faDrumstick: faDrumstick,
  faSquareV: faSquareV,
  faFaceAwesome: faFaceAwesome,
  faGaveDandy: faGaveDandy,
  faDialOff: faDialOff,
  faToggleOff: faToggleOff,
  faFaceSmileHorns: faFaceSmileHorns,
  faBoxArchive: faBoxArchive,
  faArchive: faArchive,
  faGrapes: faGrapes,
  faPersonDrowning: faPersonDrowning,
  faDialMax: faDialMax,
  faCircleM: faCircleM,
  faCalendarImage: faCalendarImage,
  faCircleCaretDown: faCircleCaretDown,
  faCaretCircleDown: faCaretCircleDown,
  faArrowDown91: faArrowDown91,
  faSortNumericDesc: faSortNumericDesc,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faFaceGrinTongueSquint: faFaceGrinTongueSquint,
  faGrinTongueSquint: faGrinTongueSquint,
  faShishKebab: faShishKebab,
  faSprayCan: faSprayCan,
  faAlarmSnooze: faAlarmSnooze,
  faScarecrow: faScarecrow,
  faTruckMonster: faTruckMonster,
  faGiftCard: faGiftCard,
  faW: faW,
  faCodePullRequestDraft: faCodePullRequestDraft,
  faSquareB: faSquareB,
  faElephant: faElephant,
  faEarthAfrica: faEarthAfrica,
  faGlobeAfrica: faGlobeAfrica,
  faRainbow: faRainbow,
  faCircleNotch: faCircleNotch,
  faTabletScreenButton: faTabletScreenButton,
  faTabletAlt: faTabletAlt,
  faPaw: faPaw,
  faMessageQuestion: faMessageQuestion,
  faCloud: faCloud,
  faTrowelBricks: faTrowelBricks,
  faSquare3: faSquare3,
  faFaceFlushed: faFaceFlushed,
  faFlushed: faFlushed,
  faHospitalUser: faHospitalUser,
  faMicrowave: faMicrowave,
  faChfSign: faChfSign,
  faTentArrowLeftRight: faTentArrowLeftRight,
  faCartCircleArrowUp: faCartCircleArrowUp,
  faTrashClock: faTrashClock,
  faGavel: faGavel,
  faLegal: faLegal,
  faSprinklerCeiling: faSprinklerCeiling,
  faBrowsers: faBrowsers,
  faTrillium: faTrillium,
  faMusicSlash: faMusicSlash,
  faTruckRamp: faTruckRamp,
  faBinoculars: faBinoculars,
  faMicrophoneSlash: faMicrophoneSlash,
  faBoxTissue: faBoxTissue,
  faCircleC: faCircleC,
  faStarChristmas: faStarChristmas,
  faChartBullet: faChartBullet,
  faMotorcycle: faMotorcycle,
  faTreeChristmas: faTreeChristmas,
  faTireFlat: faTireFlat,
  faSunglasses: faSunglasses,
  faBadge: faBadge,
  faMessagePen: faMessagePen,
  faCommentAltEdit: faCommentAltEdit,
  faMessageEdit: faMessageEdit,
  faBellConcierge: faBellConcierge,
  faConciergeBell: faConciergeBell,
  faPenRuler: faPenRuler,
  faPencilRuler: faPencilRuler,
  faArrowProgress: faArrowProgress,
  faChessRookPiece: faChessRookPiece,
  faChessRookAlt: faChessRookAlt,
  faSquareRoot: faSquareRoot,
  faAlbumCollectionCirclePlus: faAlbumCollectionCirclePlus,
  faPeopleArrows: faPeopleArrows,
  faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
  faFaceAngryHorns: faFaceAngryHorns,
  faMarsAndVenusBurst: faMarsAndVenusBurst,
  faTombstone: faTombstone,
  faSquareCaretRight: faSquareCaretRight,
  faCaretSquareRight: faCaretSquareRight,
  faScissors: faScissors,
  faCut: faCut,
  faListMusic: faListMusic,
  faSunPlantWilt: faSunPlantWilt,
  faToiletsPortable: faToiletsPortable,
  faHockeyPuck: faHockeyPuck,
  faMustache: faMustache,
  faHyphen: faHyphen,
  faTable: faTable,
  faUserChef: faUserChef,
  faMessageImage: faMessageImage,
  faCommentAltImage: faCommentAltImage,
  faUsersMedical: faUsersMedical,
  faSensorTriangleExclamation: faSensorTriangleExclamation,
  faSensorAlert: faSensorAlert,
  faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
  faTachographDigital: faTachographDigital,
  faDigitalTachograph: faDigitalTachograph,
  faFaceMask: faFaceMask,
  faPickleball: faPickleball,
  faStarSharpHalf: faStarSharpHalf,
  faUsersSlash: faUsersSlash,
  faClover: faClover,
  faMeat: faMeat,
  faReply: faReply,
  faMailReply: faMailReply,
  faStarAndCrescent: faStarAndCrescent,
  faEmptySet: faEmptySet,
  faHouseFire: faHouseFire,
  faSquareMinus: faSquareMinus,
  faMinusSquare: faMinusSquare,
  faHelicopter: faHelicopter,
  faBird: faBird,
  faCompass: faCompass,
  faSquareCaretDown: faSquareCaretDown,
  faCaretSquareDown: faCaretSquareDown,
  faHeartHalfStroke: faHeartHalfStroke,
  faHeartHalfAlt: faHeartHalfAlt,
  faFileCircleQuestion: faFileCircleQuestion,
  faLaptopCode: faLaptopCode,
  faJoystick: faJoystick,
  faGrillFire: faGrillFire,
  faRectangleVerticalHistory: faRectangleVerticalHistory,
  faSwatchbook: faSwatchbook,
  faPrescriptionBottle: faPrescriptionBottle,
  faBars: faBars,
  faNavicon: faNavicon,
  faKeyboardLeft: faKeyboardLeft,
  faPeopleGroup: faPeopleGroup,
  faHourglassEnd: faHourglassEnd,
  faHourglass3: faHourglass3,
  faHeartCrack: faHeartCrack,
  faHeartBroken: faHeartBroken,
  faFaceBeamHandOverMouth: faFaceBeamHandOverMouth,
  faDropletPercent: faDropletPercent,
  faHumidity: faHumidity,
  faSquareUpRight: faSquareUpRight,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faFaceKissBeam: faFaceKissBeam,
  faKissBeam: faKissBeam,
  faCorn: faCorn,
  faRollerCoaster: faRollerCoaster,
  faPhotoFilmMusic: faPhotoFilmMusic,
  faRadar: faRadar,
  faSickle: faSickle,
  faFilm: faFilm,
  faCoconut: faCoconut,
  faRulerHorizontal: faRulerHorizontal,
  faShieldCross: faShieldCross,
  faCassetteTape: faCassetteTape,
  faSquareTerminal: faSquareTerminal,
  faPeopleRobbery: faPeopleRobbery,
  faLightbulb: faLightbulb,
  faCaretLeft: faCaretLeft,
  faCommentMiddle: faCommentMiddle,
  faTrashCanList: faTrashCanList,
  faBlock: faBlock,
  faCircleExclamation: faCircleExclamation,
  faExclamationCircle: faExclamationCircle,
  faSchoolCircleXmark: faSchoolCircleXmark,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faSignOut: faSignOut,
  faFaceFrownSlight: faFaceFrownSlight,
  faCircleChevronDown: faCircleChevronDown,
  faChevronCircleDown: faChevronCircleDown,
  faSidebarFlip: faSidebarFlip,
  faUnlockKeyhole: faUnlockKeyhole,
  faUnlockAlt: faUnlockAlt,
  faTemperatureList: faTemperatureList,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faHeadphonesSimple: faHeadphonesSimple,
  faHeadphonesAlt: faHeadphonesAlt,
  faSitemap: faSitemap,
  faPipeSection: faPipeSection,
  faSpaceStationMoonConstruction: faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt: faSpaceStationMoonAlt,
  faCircleDollarToSlot: faCircleDollarToSlot,
  faDonate: faDonate,
  faMemory: faMemory,
  faFaceSleeping: faFaceSleeping,
  faRoadSpikes: faRoadSpikes,
  faFireBurner: faFireBurner,
  faSquirrel: faSquirrel,
  faArrowUpToLine: faArrowUpToLine,
  faArrowToTop: faArrowToTop,
  faFlag: faFlag,
  faFaceCowboyHat: faFaceCowboyHat,
  faHanukiah: faHanukiah,
  faChartScatter3d: faChartScatter3d,
  faDisplayChartUp: faDisplayChartUp,
  faSquareCode: faSquareCode,
  faFeather: faFeather,
  faVolumeLow: faVolumeLow,
  faVolumeDown: faVolumeDown,
  faXmarkToSlot: faXmarkToSlot,
  faTimesToSlot: faTimesToSlot,
  faVoteNay: faVoteNay,
  faBoxTaped: faBoxTaped,
  faBoxAlt: faBoxAlt,
  faCommentSlash: faCommentSlash,
  faSwords: faSwords,
  faCloudSunRain: faCloudSunRain,
  faAlbum: faAlbum,
  faCircleN: faCircleN,
  faCompress: faCompress,
  faWheatAwn: faWheatAwn,
  faWheatAlt: faWheatAlt,
  faAnkh: faAnkh,
  faHandsHoldingChild: faHandsHoldingChild,
  faAsterisk: faAsterisk,
  faKeySkeletonLeftRight: faKeySkeletonLeftRight,
  faCommentLines: faCommentLines,
  faLuchadorMask: faLuchadorMask,
  faLuchador: faLuchador,
  faMaskLuchador: faMaskLuchador,
  faSquareCheck: faSquareCheck,
  faCheckSquare: faCheckSquare,
  faShredder: faShredder,
  faBookOpenCover: faBookOpenCover,
  faBookOpenAlt: faBookOpenAlt,
  faSandwich: faSandwich,
  faPesetaSign: faPesetaSign,
  faSquareParkingSlash: faSquareParkingSlash,
  faParkingSlash: faParkingSlash,
  faTrainTunnel: faTrainTunnel,
  faHeading: faHeading,
  faHeader: faHeader,
  faGhost: faGhost,
  faFaceAnguished: faFaceAnguished,
  faHockeySticks: faHockeySticks,
  faAbacus: faAbacus,
  faFilmSimple: faFilmSimple,
  faFilmAlt: faFilmAlt,
  faList: faList,
  faListSquares: faListSquares,
  faTreePalm: faTreePalm,
  faSquarePhoneFlip: faSquarePhoneFlip,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faCartPlus: faCartPlus,
  faGamepad: faGamepad,
  faBorderCenterV: faBorderCenterV,
  faCircleDot: faCircleDot,
  faDotCircle: faDotCircle,
  faClipboardMedical: faClipboardMedical,
  faFaceDizzy: faFaceDizzy,
  faDizzy: faDizzy,
  faEgg: faEgg,
  faUpToLine: faUpToLine,
  faArrowAltToTop: faArrowAltToTop,
  faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
  faWatchFitness: faWatchFitness,
  faClockNineThirty: faClockNineThirty,
  faCampground: faCampground,
  faFolderPlus: faFolderPlus,
  faJug: faJug,
  faFutbol: faFutbol,
  faFutbolBall: faFutbolBall,
  faSoccerBall: faSoccerBall,
  faSnowBlowing: faSnowBlowing,
  faPaintbrush: faPaintbrush,
  faPaintBrush: faPaintBrush,
  faLock: faLock,
  faArrowDownFromLine: faArrowDownFromLine,
  faArrowFromTop: faArrowFromTop,
  faGasPump: faGasPump,
  faSignalBarsSlash: faSignalBarsSlash,
  faSignalAltSlash: faSignalAltSlash,
  faMonkey: faMonkey,
  faRectanglePro: faRectanglePro,
  faPro: faPro,
  faHouseNight: faHouseNight,
  faHotTubPerson: faHotTubPerson,
  faHotTub: faHotTub,
  faGlobePointer: faGlobePointer,
  faBlanket: faBlanket,
  faMapLocation: faMapLocation,
  faMapMarked: faMapMarked,
  faHouseFloodWater: faHouseFloodWater,
  faCommentsQuestionCheck: faCommentsQuestionCheck,
  faTree: faTree,
  faArrowsCross: faArrowsCross,
  faBackpack: faBackpack,
  faSquareSmall: faSquareSmall,
  faFolderArrowUp: faFolderArrowUp,
  faFolderUpload: faFolderUpload,
  faBridgeLock: faBridgeLock,
  faCrosshairsSimple: faCrosshairsSimple,
  faSackDollar: faSackDollar,
  faPenToSquare: faPenToSquare,
  faEdit: faEdit,
  faSquareSliders: faSquareSliders,
  faSlidersHSquare: faSlidersHSquare,
  faCarSide: faCarSide,
  faMessageMiddleTop: faMessageMiddleTop,
  faCommentMiddleTopAlt: faCommentMiddleTopAlt,
  faLightbulbOn: faLightbulbOn,
  faKnife: faKnife,
  faUtensilKnife: faUtensilKnife,
  faShareNodes: faShareNodes,
  faShareAlt: faShareAlt,
  faDisplayChartUpCircleDollar: faDisplayChartUpCircleDollar,
  faWaveSine: faWaveSine,
  faHeartCircleMinus: faHeartCircleMinus,
  faCircleW: faCircleW,
  faCircleCalendar: faCircleCalendar,
  faCalendarCircle: faCalendarCircle,
  faHourglassHalf: faHourglassHalf,
  faHourglass2: faHourglass2,
  faMicroscope: faMicroscope,
  faSunset: faSunset,
  faSink: faSink,
  faCalendarExclamation: faCalendarExclamation,
  faTruckContainerEmpty: faTruckContainerEmpty,
  faHandHeart: faHandHeart,
  faBagShopping: faBagShopping,
  faShoppingBag: faShoppingBag,
  faArrowDownZA: faArrowDownZA,
  faSortAlphaDesc: faSortAlphaDesc,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faMitten: faMitten,
  faReplyClock: faReplyClock,
  faReplyTime: faReplyTime,
  faPersonRays: faPersonRays,
  faRight: faRight,
  faArrowAltRight: faArrowAltRight,
  faCircleF: faCircleF,
  faUsers: faUsers,
  faFacePleading: faFacePleading,
  faEyeSlash: faEyeSlash,
  faFlaskVial: faFlaskVial,
  faPoliceBox: faPoliceBox,
  faCucumber: faCucumber,
  faHeadSideBrain: faHeadSideBrain,
  faHand: faHand,
  faHandPaper: faHandPaper,
  faPersonBikingMountain: faPersonBikingMountain,
  faBikingMountain: faBikingMountain,
  faUtensilsSlash: faUtensilsSlash,
  faPrintMagnifyingGlass: faPrintMagnifyingGlass,
  faPrintSearch: faPrintSearch,
  faFolderBookmark: faFolderBookmark,
  faOm: faOm,
  faPi: faPi,
  faFlaskRoundPotion: faFlaskRoundPotion,
  faFlaskPotion: faFlaskPotion,
  faFaceShush: faFaceShush,
  faWorm: faWorm,
  faHouseCircleXmark: faHouseCircleXmark,
  faPlug: faPlug,
  faCalendarCircleExclamation: faCalendarCircleExclamation,
  faSquareI: faSquareI,
  faChevronUp: faChevronUp,
  faFaceSaluting: faFaceSaluting,
  faGaugeSimpleLow: faGaugeSimpleLow,
  faTachometerSlow: faTachometerSlow,
  faFacePersevering: faFacePersevering,
  faCircleCamera: faCircleCamera,
  faCameraCircle: faCameraCircle,
  faHandSpock: faHandSpock,
  faSpiderWeb: faSpiderWeb,
  faCircleMicrophone: faCircleMicrophone,
  faMicrophoneCircle: faMicrophoneCircle,
  faBookArrowUp: faBookArrowUp,
  faPopsicle: faPopsicle,
  faCommand: faCommand,
  faBlinds: faBlinds,
  faStopwatch: faStopwatch,
  faSaxophone: faSaxophone,
  faSquare2: faSquare2,
  faFieldHockeyStickBall: faFieldHockeyStickBall,
  faFieldHockey: faFieldHockey,
  faArrowUpSquareTriangle: faArrowUpSquareTriangle,
  faSortShapesUpAlt: faSortShapesUpAlt,
  faFaceScream: faFaceScream,
  faSquareM: faSquareM,
  faCameraWeb: faCameraWeb,
  faWebcam: faWebcam,
  faCommentArrowDown: faCommentArrowDown,
  faLightbulbCfl: faLightbulbCfl,
  faWindowFrameOpen: faWindowFrameOpen,
  faFaceKiss: faFaceKiss,
  faKiss: faKiss,
  faBridgeCircleXmark: faBridgeCircleXmark,
  faPeriod: faPeriod,
  faFaceGrinTongue: faFaceGrinTongue,
  faGrinTongue: faGrinTongue,
  faUpToDottedLine: faUpToDottedLine,
  faThoughtBubble: faThoughtBubble,
  faSkeletonRibs: faSkeletonRibs,
  faRaygun: faRaygun,
  faFlute: faFlute,
  faAcorn: faAcorn,
  faVideoArrowUpRight: faVideoArrowUpRight,
  faGrateDroplet: faGrateDroplet,
  faSealExclamation: faSealExclamation,
  faChessBishop: faChessBishop,
  faMessageSms: faMessageSms,
  faCoffeeBeans: faCoffeeBeans,
  faHatWitch: faHatWitch,
  faFaceGrinWink: faFaceGrinWink,
  faGrinWink: faGrinWink,
  faClockThreeThirty: faClockThreeThirty,
  faEarDeaf: faEarDeaf,
  faDeaf: faDeaf,
  faDeafness: faDeafness,
  faHardOfHearing: faHardOfHearing,
  faAlarmClock: faAlarmClock,
  faEclipse: faEclipse,
  faFaceRelieved: faFaceRelieved,
  faRoadCircleCheck: faRoadCircleCheck,
  faDiceFive: faDiceFive,
  faOctagonMinus: faOctagonMinus,
  faMinusOctagon: faMinusOctagon,
  faSquareRss: faSquareRss,
  faRssSquare: faRssSquare,
  faFaceZany: faFaceZany,
  faTricycle: faTricycle,
  faLandMineOn: faLandMineOn,
  faSquareArrowUpLeft: faSquareArrowUpLeft,
  faICursor: faICursor,
  faChartMixedUpCircleDollar: faChartMixedUpCircleDollar,
  faSaltShaker: faSaltShaker,
  faStamp: faStamp,
  faFilePlus: faFilePlus,
  faDrawSquare: faDrawSquare,
  faToiletPaperUnderSlash: faToiletPaperUnderSlash,
  faToiletPaperReverseSlash: faToiletPaperReverseSlash,
  faStairs: faStairs,
  faDroneFront: faDroneFront,
  faDroneAlt: faDroneAlt,
  faGlassEmpty: faGlassEmpty,
  faDialHigh: faDialHigh,
  faUserHelmetSafety: faUserHelmetSafety,
  faUserConstruction: faUserConstruction,
  faUserHardHat: faUserHardHat,
  faI: faI,
  faHryvniaSign: faHryvniaSign,
  faHryvnia: faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter: faArrowDownLeftAndArrowUpRightToCenter,
  faPills: faPills,
  faFaceGrinWide: faFaceGrinWide,
  faGrinAlt: faGrinAlt,
  faTooth: faTooth,
  faBasketballHoop: faBasketballHoop,
  faObjectsAlignBottom: faObjectsAlignBottom,
  faV: faV,
  faSparkles: faSparkles,
  faSquid: faSquid,
  faLeafyGreen: faLeafyGreen,
  faCircleArrowUpRight: faCircleArrowUpRight,
  faCalendars: faCalendars,
  faBangladeshiTakaSign: faBangladeshiTakaSign,
  faBicycle: faBicycle,
  faHammerWar: faHammerWar,
  faCircleD: faCircleD,
  faSpiderBlackWidow: faSpiderBlackWidow,
  faStaffSnake: faStaffSnake,
  faRodAsclepius: faRodAsclepius,
  faRodSnake: faRodSnake,
  faStaffAesculapius: faStaffAesculapius,
  faPear: faPear,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faTriangle: faTriangle,
  faApartment: faApartment,
  faTruckMedical: faTruckMedical,
  faAmbulance: faAmbulance,
  faPepper: faPepper,
  faPiano: faPiano,
  faGunSquirt: faGunSquirt,
  faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
  faSnowman: faSnowman,
  faUserAlien: faUserAlien,
  faShieldCheck: faShieldCheck,
  faMortarPestle: faMortarPestle,
  faRoadBarrier: faRoadBarrier,
  faChartCandlestick: faChartCandlestick,
  faBriefcaseBlank: faBriefcaseBlank,
  faSchool: faSchool,
  faIgloo: faIgloo,
  faBracketRound: faBracketRound,
  faParenthesis: faParenthesis,
  faJoint: faJoint,
  faHorseSaddle: faHorseSaddle,
  faMugMarshmallows: faMugMarshmallows,
  faFilters: faFilters,
  faBellOn: faBellOn,
  faAngleRight: faAngleRight,
  faDialMed: faDialMed,
  faHorse: faHorse,
  faQ: faQ,
  faMonitorWaveform: faMonitorWaveform,
  faMonitorHeartRate: faMonitorHeartRate,
  faLinkSimple: faLinkSimple,
  faWhistle: faWhistle,
  faG: faG,
  faWineGlassCrack: faWineGlassCrack,
  faFragile: faFragile,
  faSlotMachine: faSlotMachine,
  faNotesMedical: faNotesMedical,
  faCarWash: faCarWash,
  faEscalator: faEscalator,
  faCommentImage: faCommentImage,
  faTemperatureHalf: faTemperatureHalf,
  faTemperature2: faTemperature2,
  faThermometer2: faThermometer2,
  faThermometerHalf: faThermometerHalf,
  faDongSign: faDongSign,
  faDonut: faDonut,
  faDoughnut: faDoughnut,
  faCapsules: faCapsules,
  faPooStorm: faPooStorm,
  faPooBolt: faPooBolt,
  faTally1: faTally1,
  faFaceFrownOpen: faFaceFrownOpen,
  faFrownOpen: faFrownOpen,
  faSquareDashed: faSquareDashed,
  faSquareJ: faSquareJ,
  faHandPointUp: faHandPointUp,
  faMoneyBill: faMoneyBill,
  faArrowUpBigSmall: faArrowUpBigSmall,
  faSortSizeUp: faSortSizeUp,
  faBarcodeRead: faBarcodeRead,
  faBaguette: faBaguette,
  faBowlSoftServe: faBowlSoftServe,
  faFaceHoldingBackTears: faFaceHoldingBackTears,
  faSquareUp: faSquareUp,
  faArrowAltSquareUp: faArrowAltSquareUp,
  faTrainSubwayTunnel: faTrainSubwayTunnel,
  faSubwayTunnel: faSubwayTunnel,
  faSquareExclamation: faSquareExclamation,
  faExclamationSquare: faExclamationSquare,
  faSemicolon: faSemicolon,
  faBookmark: faBookmark,
  faFanTable: faFanTable,
  faAlignJustify: faAlignJustify,
  faBatteryLow: faBatteryLow,
  faBattery1: faBattery1,
  faCreditCardFront: faCreditCardFront,
  faBrainArrowCurvedRight: faBrainArrowCurvedRight,
  faMindShare: faMindShare,
  faUmbrellaBeach: faUmbrellaBeach,
  faHelmetUn: faHelmetUn,
  faLocationSmile: faLocationSmile,
  faMapMarkerSmile: faMapMarkerSmile,
  faArrowLeftToLine: faArrowLeftToLine,
  faArrowToLeft: faArrowToLeft,
  faBullseye: faBullseye,
  faSushi: faSushi,
  faNigiri: faNigiri,
  faMessageCaptions: faMessageCaptions,
  faCommentAltCaptions: faCommentAltCaptions,
  faTrashList: faTrashList,
  faBacon: faBacon,
  faOption: faOption,
  faRaccoon: faRaccoon,
  faHandPointDown: faHandPointDown,
  faArrowUpFromBracket: faArrowUpFromBracket,
  faHeadSideGear: faHeadSideGear,
  faTrashPlus: faTrashPlus,
  faObjectsAlignTop: faObjectsAlignTop,
  faFolder: faFolder,
  faFolderBlank: faFolderBlank,
  faFaceAnxiousSweat: faFaceAnxiousSweat,
  faCreditCardBlank: faCreditCardBlank,
  faFileWaveform: faFileWaveform,
  faFileMedicalAlt: faFileMedicalAlt,
  faMicrochipAi: faMicrochipAi,
  faMug: faMug,
  faPlaneUpSlash: faPlaneUpSlash,
  faRadiation: faRadiation,
  faPenCircle: faPenCircle,
  faBagSeedling: faBagSeedling,
  faChartSimple: faChartSimple,
  faCrutches: faCrutches,
  faCircleParking: faCircleParking,
  faParkingCircle: faParkingCircle,
  faMarsStroke: faMarsStroke,
  faLeafOak: faLeafOak,
  faSquareBolt: faSquareBolt,
  faVial: faVial,
  faGauge: faGauge,
  faDashboard: faDashboard,
  faGaugeMed: faGaugeMed,
  faTachometerAltAverage: faTachometerAltAverage,
  faWandMagicSparkles: faWandMagicSparkles,
  faMagicWandSparkles: faMagicWandSparkles,
  faLambda: faLambda,
  faE: faE,
  faPizza: faPizza,
  faBowlChopsticksNoodles: faBowlChopsticksNoodles,
  faH3: faH3,
  faPenClip: faPenClip,
  faPenAlt: faPenAlt,
  faBridgeCircleExclamation: faBridgeCircleExclamation,
  faBadgePercent: faBadgePercent,
  faUser: faUser,
  faSensor: faSensor,
  faComma: faComma,
  faSchoolCircleCheck: faSchoolCircleCheck,
  faToiletPaperUnder: faToiletPaperUnder,
  faToiletPaperReverse: faToiletPaperReverse,
  faLightEmergency: faLightEmergency,
  faArrowDownToArc: faArrowDownToArc,
  faDumpster: faDumpster,
  faVanShuttle: faVanShuttle,
  faShuttleVan: faShuttleVan,
  faBuildingUser: faBuildingUser,
  faLightSwitch: faLightSwitch,
  faSquareCaretLeft: faSquareCaretLeft,
  faCaretSquareLeft: faCaretSquareLeft,
  faHighlighter: faHighlighter,
  faWavePulse: faWavePulse,
  faHeartRate: faHeartRate,
  faKey: faKey,
  faHatSanta: faHatSanta,
  faTamale: faTamale,
  faBoxCheck: faBoxCheck,
  faBullhorn: faBullhorn,
  faSteak: faSteak,
  faLocationCrosshairsSlash: faLocationCrosshairsSlash,
  faLocationSlash: faLocationSlash,
  faPersonDolly: faPersonDolly,
  faGlobe: faGlobe,
  faSynagogue: faSynagogue,
  faFileChartColumn: faFileChartColumn,
  faFileChartLine: faFileChartLine,
  faPersonHalfDress: faPersonHalfDress,
  faFolderImage: faFolderImage,
  faCalendarPen: faCalendarPen,
  faCalendarEdit: faCalendarEdit,
  faRoadBridge: faRoadBridge,
  faFaceSmileTear: faFaceSmileTear,
  faMessagePlus: faMessagePlus,
  faCommentAltPlus: faCommentAltPlus,
  faLocationArrow: faLocationArrow,
  faC: faC,
  faTabletButton: faTabletButton,
  faPersonDressFairy: faPersonDressFairy,
  faRectangleHistoryCircleUser: faRectangleHistoryCircleUser,
  faBuildingLock: faBuildingLock,
  faChartLineUp: faChartLineUp,
  faMailbox: faMailbox,
  faTruckBolt: faTruckBolt,
  faPizzaSlice: faPizzaSlice,
  faMoneyBillWave: faMoneyBillWave,
  faChartArea: faChartArea,
  faAreaChart: faAreaChart,
  faHouseFlag: faHouseFlag,
  faCircleThreeQuartersStroke: faCircleThreeQuartersStroke,
  faPersonCircleMinus: faPersonCircleMinus,
  faScalpel: faScalpel,
  faBan: faBan,
  faCancel: faCancel,
  faBellExclamation: faBellExclamation,
  faCircleBookmark: faCircleBookmark,
  faBookmarkCircle: faBookmarkCircle,
  faEggFried: faEggFried,
  faFaceWeary: faFaceWeary,
  faUniformMartialArts: faUniformMartialArts,
  faCameraRotate: faCameraRotate,
  faSunDust: faSunDust,
  faCommentText: faCommentText,
  faSprayCanSparkles: faSprayCanSparkles,
  faAirFreshener: faAirFreshener,
  faSignalBars: faSignalBars,
  faSignalAlt: faSignalAlt,
  faSignalAlt4: faSignalAlt4,
  faSignalBarsStrong: faSignalBarsStrong,
  faDiamondExclamation: faDiamondExclamation,
  faStar: faStar,
  faDialMin: faDialMin,
  faRepeat: faRepeat,
  faCross: faCross,
  faPageCaretDown: faPageCaretDown,
  faFileCaretDown: faFileCaretDown,
  faBox: faBox,
  faVenusMars: faVenusMars,
  faClockSevenThirty: faClockSevenThirty,
  faArrowPointer: faArrowPointer,
  faMousePointer: faMousePointer,
  faClockFourThirty: faClockFourThirty,
  faSignalBarsGood: faSignalBarsGood,
  faSignalAlt3: faSignalAlt3,
  faCactus: faCactus,
  faLightbulbGear: faLightbulbGear,
  faMaximize: faMaximize,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faChargingStation: faChargingStation,
  faShapes: faShapes,
  faTriangleCircleSquare: faTriangleCircleSquare,
  faPlaneTail: faPlaneTail,
  faGaugeSimpleMax: faGaugeSimpleMax,
  faTachometerFastest: faTachometerFastest,
  faCircleU: faCircleU,
  faShieldSlash: faShieldSlash,
  faSquarePhoneHangup: faSquarePhoneHangup,
  faPhoneSquareDown: faPhoneSquareDown,
  faArrowUpLeft: faArrowUpLeft,
  faTransporter1: faTransporter1,
  faPeanuts: faPeanuts,
  faShuffle: faShuffle,
  faRandom: faRandom,
  faPersonRunning: faPersonRunning,
  faRunning: faRunning,
  faMobileRetro: faMobileRetro,
  faGripLinesVertical: faGripLinesVertical,
  faBinBottlesRecycle: faBinBottlesRecycle,
  faArrowUpFromSquare: faArrowUpFromSquare,
  faFileDashedLine: faFileDashedLine,
  faPageBreak: faPageBreak,
  faBracketCurlyRight: faBracketCurlyRight,
  faSpider: faSpider,
  faClockThree: faClockThree,
  faHandsBound: faHandsBound,
  faScalpelLineDashed: faScalpelLineDashed,
  faScalpelPath: faScalpelPath,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faPipeSmoking: faPipeSmoking,
  faFaceAstonished: faFaceAstonished,
  faWindow: faWindow,
  faPlaneCircleExclamation: faPlaneCircleExclamation,
  faEar: faEar,
  faFileLock: faFileLock,
  faDiagramVenn: faDiagramVenn,
  faXRay: faXRay,
  faGoalNet: faGoalNet,
  faCoffinCross: faCoffinCross,
  faSpellCheck: faSpellCheck,
  faLocationXmark: faLocationXmark,
  faMapMarkerTimes: faMapMarkerTimes,
  faMapMarkerXmark: faMapMarkerXmark,
  faCircleQuarterStroke: faCircleQuarterStroke,
  faLasso: faLasso,
  faSlash: faSlash,
  faPersonToPortal: faPersonToPortal,
  faPortalEnter: faPortalEnter,
  faCalendarStar: faCalendarStar,
  faComputerMouse: faComputerMouse,
  faMouse: faMouse,
  faArrowRightToBracket: faArrowRightToBracket,
  faSignIn: faSignIn,
  faPegasus: faPegasus,
  faFilesMedical: faFilesMedical,
  faNfcLock: faNfcLock,
  faPersonSkiLift: faPersonSkiLift,
  faSkiLift: faSkiLift,
  faSquare6: faSquare6,
  faShopSlash: faShopSlash,
  faStoreAltSlash: faStoreAltSlash,
  faWindTurbine: faWindTurbine,
  faSlidersSimple: faSlidersSimple,
  faGridRound: faGridRound,
  faBadgeSheriff: faBadgeSheriff,
  faServer: faServer,
  faVirusCovidSlash: faVirusCovidSlash,
  faIntersection: faIntersection,
  faShopLock: faShopLock,
  faFamily: faFamily,
  faHourglassStart: faHourglassStart,
  faHourglass1: faHourglass1,
  faUserHairBuns: faUserHairBuns,
  faBlenderPhone: faBlenderPhone,
  faHourglassClock: faHourglassClock,
  faPersonSeatReclined: faPersonSeatReclined,
  faPaperPlaneTop: faPaperPlaneTop,
  faPaperPlaneAlt: faPaperPlaneAlt,
  faSend: faSend,
  faMessageArrowUp: faMessageArrowUp,
  faCommentAltArrowUp: faCommentAltArrowUp,
  faLightbulbExclamation: faLightbulbExclamation,
  faLayerMinus: faLayerMinus,
  faLayerGroupMinus: faLayerGroupMinus,
  faChartPieSimpleCircleCurrency: faChartPieSimpleCircleCurrency,
  faCircleE: faCircleE,
  faBuildingWheat: faBuildingWheat,
  faGaugeMax: faGaugeMax,
  faTachometerAltFastest: faTachometerAltFastest,
  faPersonBreastfeeding: faPersonBreastfeeding,
  faApostrophe: faApostrophe,
  faFireHydrant: faFireHydrant,
  faRightToBracket: faRightToBracket,
  faSignInAlt: faSignInAlt,
  faVideoPlus: faVideoPlus,
  faSquareRight: faSquareRight,
  faArrowAltSquareRight: faArrowAltSquareRight,
  faCommentSmile: faCommentSmile,
  faVenus: faVenus,
  faPassport: faPassport,
  faInboxIn: faInboxIn,
  faInboxArrowDown: faInboxArrowDown,
  faHeartPulse: faHeartPulse,
  faHeartbeat: faHeartbeat,
  faCircle8: faCircle8,
  faCloudsMoon: faCloudsMoon,
  faClockTenThirty: faClockTenThirty,
  faPeopleCarryBox: faPeopleCarryBox,
  faPeopleCarry: faPeopleCarry,
  faFolderUser: faFolderUser,
  faTrashCanXmark: faTrashCanXmark,
  faTemperatureHigh: faTemperatureHigh,
  faMicrochip: faMicrochip,
  faLeftLongToLine: faLeftLongToLine,
  faCrown: faCrown,
  faWeightHanging: faWeightHanging,
  faXmarksLines: faXmarksLines,
  faFilePrescription: faFilePrescription,
  faCalendarRange: faCalendarRange,
  faFlowerDaffodil: faFlowerDaffodil,
  faHandBackPointUp: faHandBackPointUp,
  faWeightScale: faWeightScale,
  faWeight: faWeight,
  faArrowUpToArc: faArrowUpToArc,
  faStarExclamation: faStarExclamation,
  faBooks: faBooks,
  faUserGroup: faUserGroup,
  faUserFriends: faUserFriends,
  faArrowUpAZ: faArrowUpAZ,
  faSortAlphaUp: faSortAlphaUp,
  faLayerPlus: faLayerPlus,
  faLayerGroupPlus: faLayerGroupPlus,
  faPlayPause: faPlayPause,
  faBlockQuestion: faBlockQuestion,
  faSnooze: faSnooze,
  faZzz: faZzz,
  faScannerImage: faScannerImage,
  faTvRetro: faTvRetro,
  faSquareT: faSquareT,
  faFarm: faFarm,
  faBarnSilo: faBarnSilo,
  faChessKnight: faChessKnight,
  faBarsSort: faBarsSort,
  faPalletBoxes: faPalletBoxes,
  faPaletteBoxes: faPaletteBoxes,
  faPalletAlt: faPalletAlt,
  faFaceLaughSquint: faFaceLaughSquint,
  faLaughSquint: faLaughSquint,
  faCodeSimple: faCodeSimple,
  faBoltSlash: faBoltSlash,
  faPanelFire: faPanelFire,
  faBinaryCircleCheck: faBinaryCircleCheck,
  faCommentMinus: faCommentMinus,
  faBurrito: faBurrito,
  faViolin: faViolin,
  faObjectsColumn: faObjectsColumn,
  faSquareChevronDown: faSquareChevronDown,
  faChevronSquareDown: faChevronSquareDown,
  faCommentPlus: faCommentPlus,
  faTriangleInstrument: faTriangleInstrument,
  faTriangleMusic: faTriangleMusic,
  faWheelchair: faWheelchair,
  faUserPilotTie: faUserPilotTie,
  faPianoKeyboard: faPianoKeyboard,
  faBedEmpty: faBedEmpty,
  faCircleArrowUp: faCircleArrowUp,
  faArrowCircleUp: faArrowCircleUp,
  faToggleOn: faToggleOn,
  faRectangleVertical: faRectangleVertical,
  faRectanglePortrait: faRectanglePortrait,
  faPersonWalking: faPersonWalking,
  faWalking: faWalking,
  faL: faL,
  faSignalStream: faSignalStream,
  faDownToBracket: faDownToBracket,
  faCircleZ: faCircleZ,
  faStars: faStars,
  faFire: faFire,
  faBedPulse: faBedPulse,
  faProcedures: faProcedures,
  faHouseDay: faHouseDay,
  faShuttleSpace: faShuttleSpace,
  faSpaceShuttle: faSpaceShuttle,
  faShirtLongSleeve: faShirtLongSleeve,
  faChartPieSimple: faChartPieSimple,
  faChartPieAlt: faChartPieAlt,
  faFaceLaugh: faFaceLaugh,
  faLaugh: faLaugh,
  faFolderOpen: faFolderOpen,
  faAlbumCollectionCircleUser: faAlbumCollectionCircleUser,
  faCandy: faCandy,
  faBowlHot: faBowlHot,
  faSoup: faSoup,
  faFlatbread: faFlatbread,
  faHeartCirclePlus: faHeartCirclePlus,
  faCodeFork: faCodeFork,
  faCity: faCity,
  faSignalBarsWeak: faSignalBarsWeak,
  faSignalAlt1: faSignalAlt1,
  faMicrophoneLines: faMicrophoneLines,
  faMicrophoneAlt: faMicrophoneAlt,
  faClockTwelve: faClockTwelve,
  faPepperHot: faPepperHot,
  faCitrusSlice: faCitrusSlice,
  faSheep: faSheep,
  faUnlock: faUnlock,
  faColonSign: faColonSign,
  faHeadset: faHeadset,
  faBadgerHoney: faBadgerHoney,
  faH4: faH4,
  faStoreSlash: faStoreSlash,
  faRoadCircleXmark: faRoadCircleXmark,
  faSignalSlash: faSignalSlash,
  faUserMinus: faUserMinus,
  faMarsStrokeUp: faMarsStrokeUp,
  faMarsStrokeV: faMarsStrokeV,
  faChampagneGlasses: faChampagneGlasses,
  faGlassCheers: faGlassCheers,
  faTaco: faTaco,
  faHexagonPlus: faHexagonPlus,
  faPlusHexagon: faPlusHexagon,
  faClipboard: faClipboard,
  faHouseCircleExclamation: faHouseCircleExclamation,
  faFileArrowUp: faFileArrowUp,
  faFileUpload: faFileUpload,
  faWifi: faWifi,
  faWifi3: faWifi3,
  faWifiStrong: faWifiStrong,
  faMessages: faMessages,
  faCommentsAlt: faCommentsAlt,
  faBath: faBath,
  faBathtub: faBathtub,
  faUmbrellaSimple: faUmbrellaSimple,
  faUmbrellaAlt: faUmbrellaAlt,
  faRectangleHistoryCirclePlus: faRectangleHistoryCirclePlus,
  faUnderline: faUnderline,
  faPrescriptionBottlePill: faPrescriptionBottlePill,
  faUserPen: faUserPen,
  faUserEdit: faUserEdit,
  faBinarySlash: faBinarySlash,
  faSquareO: faSquareO,
  faSignature: faSignature,
  faStroopwafel: faStroopwafel,
  faBold: faBold,
  faAnchorLock: faAnchorLock,
  faBuildingNgo: faBuildingNgo,
  faTransporter3: faTransporter3,
  faEngineWarning: faEngineWarning,
  faEngineExclamation: faEngineExclamation,
  faCircleDownRight: faCircleDownRight,
  faSquareK: faSquareK,
  faManatSign: faManatSign,
  faMoneyCheckPen: faMoneyCheckPen,
  faMoneyCheckEdit: faMoneyCheckEdit,
  faNotEqual: faNotEqual,
  faBorderTopLeft: faBorderTopLeft,
  faBorderStyle: faBorderStyle,
  faMapLocationDot: faMapLocationDot,
  faMapMarkedAlt: faMapMarkedAlt,
  faTilde: faTilde,
  faJedi: faJedi,
  faSquarePollVertical: faSquarePollVertical,
  faPoll: faPoll,
  faArrowDownSquareTriangle: faArrowDownSquareTriangle,
  faSortShapesDownAlt: faSortShapesDownAlt,
  faMugHot: faMugHot,
  faDogLeashed: faDogLeashed,
  faCarBattery: faCarBattery,
  faBatteryCar: faBatteryCar,
  faFaceDowncastSweat: faFaceDowncastSweat,
  faMailboxFlagUp: faMailboxFlagUp,
  faMemoCircleInfo: faMemoCircleInfo,
  faGift: faGift,
  faDiceTwo: faDiceTwo,
  faVolume: faVolume,
  faVolumeMedium: faVolumeMedium,
  faTransporter5: faTransporter5,
  faGaugeCircleBolt: faGaugeCircleBolt,
  faCoinFront: faCoinFront,
  faFileSlash: faFileSlash,
  faMessageArrowUpRight: faMessageArrowUpRight,
  faTreasureChest: faTreasureChest,
  faChessQueen: faChessQueen,
  faPaintbrushFine: faPaintbrushFine,
  faPaintBrushAlt: faPaintBrushAlt,
  faPaintBrushFine: faPaintBrushFine,
  faPaintbrushAlt: faPaintbrushAlt,
  faGlasses: faGlasses,
  faHoodCloak: faHoodCloak,
  faSquareQuote: faSquareQuote,
  faUpLeft: faUpLeft,
  faBringFront: faBringFront,
  faChessBoard: faChessBoard,
  faBurgerCheese: faBurgerCheese,
  faCheeseburger: faCheeseburger,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faRepeat1: faRepeat1,
  faArrowDownToLine: faArrowDownToLine,
  faArrowToBottom: faArrowToBottom,
  faGrid5: faGrid5,
  faSwapArrows: faSwapArrows,
  faRightLongToLine: faRightLongToLine,
  faPersonChalkboard: faPersonChalkboard,
  faMarsStrokeRight: faMarsStrokeRight,
  faMarsStrokeH: faMarsStrokeH,
  faHandBackFist: faHandBackFist,
  faHandRock: faHandRock,
  faGridRound5: faGridRound5,
  faTally: faTally,
  faTally5: faTally5,
  faSquareCaretUp: faSquareCaretUp,
  faCaretSquareUp: faCaretSquareUp,
  faCloudShowersWater: faCloudShowersWater,
  faChartBar: faChartBar,
  faBarChart: faBarChart,
  faHandsBubbles: faHandsBubbles,
  faHandsWash: faHandsWash,
  faLessThanEqual: faLessThanEqual,
  faTrain: faTrain,
  faUpFromDottedLine: faUpFromDottedLine,
  faEyeLowVision: faEyeLowVision,
  faLowVision: faLowVision,
  faTrafficLightGo: faTrafficLightGo,
  faFaceExhaling: faFaceExhaling,
  faSensorFire: faSensorFire,
  faUserUnlock: faUserUnlock,
  faHexagonDivide: faHexagonDivide,
  fa00: fa00,
  faCrow: faCrow,
  faCassetteBetamax: faCassetteBetamax,
  faBetamax: faBetamax,
  faSailboat: faSailboat,
  faWindowRestore: faWindowRestore,
  faNfcMagnifyingGlass: faNfcMagnifyingGlass,
  faFileBinary: faFileBinary,
  faCircleV: faCircleV,
  faSquarePlus: faSquarePlus,
  faPlusSquare: faPlusSquare,
  faBowlScoops: faBowlScoops,
  faMistletoe: faMistletoe,
  faCustard: faCustard,
  faLacrosseStick: faLacrosseStick,
  faHockeyMask: faHockeyMask,
  faSunrise: faSunrise,
  faSubtitles: faSubtitles,
  faPanelEws: faPanelEws,
  faToriiGate: faToriiGate,
  faCloudExclamation: faCloudExclamation,
  faMessageLines: faMessageLines,
  faCommentAltLines: faCommentAltLines,
  faFrog: faFrog,
  faBucket: faBucket,
  faFloppyDiskPen: faFloppyDiskPen,
  faImage: faImage,
  faWindowFrame: faWindowFrame,
  faMicrophone: faMicrophone,
  faCow: faCow,
  faFileZip: faFileZip,
  faSquareRing: faSquareRing,
  faDownFromLine: faDownFromLine,
  faArrowAltFromTop: faArrowAltFromTop,
  faCaretUp: faCaretUp,
  faShieldXmark: faShieldXmark,
  faShieldTimes: faShieldTimes,
  faScrewdriver: faScrewdriver,
  faCircleSortDown: faCircleSortDown,
  faSortCircleDown: faSortCircleDown,
  faFolderClosed: faFolderClosed,
  faHouseTsunami: faHouseTsunami,
  faSquareNfi: faSquareNfi,
  faForklift: faForklift,
  faArrowUpFromGroundWater: faArrowUpFromGroundWater,
  faBracketSquareRight: faBracketSquareRight,
  faMartiniGlass: faMartiniGlass,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faRotateLeft: faRotateLeft,
  faRotateBack: faRotateBack,
  faRotateBackward: faRotateBackward,
  faUndoAlt: faUndoAlt,
  faTableColumns: faTableColumns,
  faColumns: faColumns,
  faSquareA: faSquareA,
  faTick: faTick,
  faLemon: faLemon,
  faHeadSideMask: faHeadSideMask,
  faHandshake: faHandshake,
  faGem: faGem,
  faDolly: faDolly,
  faDollyBox: faDollyBox,
  faSmoking: faSmoking,
  faMinimize: faMinimize,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faRefrigerator: faRefrigerator,
  faMonument: faMonument,
  faOctagonXmark: faOctagonXmark,
  faTimesOctagon: faTimesOctagon,
  faXmarkOctagon: faXmarkOctagon,
  faAlignSlash: faAlignSlash,
  faSnowplow: faSnowplow,
  faAnglesRight: faAnglesRight,
  faAngleDoubleRight: faAngleDoubleRight,
  faTruckRampCouch: faTruckRampCouch,
  faTruckCouch: faTruckCouch,
  faCannabis: faCannabis,
  faCirclePlay: faCirclePlay,
  faPlayCircle: faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter: faArrowUpRightAndArrowDownLeftFromCenter,
  faTablets: faTablets,
  fa360Degrees: fa360Degrees,
  faEthernet: faEthernet,
  faEuroSign: faEuroSign,
  faEur: faEur,
  faEuro: faEuro,
  faChair: faChair,
  faCircleCheck: faCircleCheck,
  faCheckCircle: faCheckCircle,
  faSquareDashedCirclePlus: faSquareDashedCirclePlus,
  faMoneySimpleFromBracket: faMoneySimpleFromBracket,
  faBat: faBat,
  faCircleStop: faCircleStop,
  faStopCircle: faStopCircle,
  faHeadSideHeadphones: faHeadSideHeadphones,
  faPhoneRotary: faPhoneRotary,
  faCompassDrafting: faCompassDrafting,
  faDraftingCompass: faDraftingCompass,
  faPlateWheat: faPlateWheat,
  faCalendarCircleMinus: faCalendarCircleMinus,
  faChopsticks: faChopsticks,
  faCarWrench: faCarWrench,
  faCarMechanic: faCarMechanic,
  faIcicles: faIcicles,
  faPersonShelter: faPersonShelter,
  faNeuter: faNeuter,
  faIdBadge: faIdBadge,
  faKazoo: faKazoo,
  faMarker: faMarker,
  faBinBottles: faBinBottles,
  faFaceLaughBeam: faFaceLaughBeam,
  faLaughBeam: faLaughBeam,
  faSquareArrowDownLeft: faSquareArrowDownLeft,
  faBatteryBolt: faBatteryBolt,
  faTreeLarge: faTreeLarge,
  faHelicopterSymbol: faHelicopterSymbol,
  faAperture: faAperture,
  faUniversalAccess: faUniversalAccess,
  faGearComplex: faGearComplex,
  faFileMagnifyingGlass: faFileMagnifyingGlass,
  faFileSearch: faFileSearch,
  faUpRight: faUpRight,
  faCircleChevronUp: faCircleChevronUp,
  faChevronCircleUp: faChevronCircleUp,
  faUserPolice: faUserPolice,
  faLariSign: faLariSign,
  faVolcano: faVolcano,
  faTeddyBear: faTeddyBear,
  faStocking: faStocking,
  faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
  faImageSlash: faImageSlash,
  faMaskSnorkel: faMaskSnorkel,
  faSmoke: faSmoke,
  faSterlingSign: faSterlingSign,
  faGbp: faGbp,
  faPoundSign: faPoundSign,
  faBatteryExclamation: faBatteryExclamation,
  faViruses: faViruses,
  faSquarePersonConfined: faSquarePersonConfined,
  faUserTie: faUserTie,
  faArrowDownLong: faArrowDownLong,
  faLongArrowDown: faLongArrowDown,
  faTentArrowDownToLine: faTentArrowDownToLine,
  faCertificate: faCertificate,
  faCrystalBall: faCrystalBall,
  faReplyAll: faReplyAll,
  faMailReplyAll: faMailReplyAll,
  faSuitcase: faSuitcase,
  faPersonSkating: faPersonSkating,
  faSkating: faSkating,
  faStarShooting: faStarShooting,
  faBinaryLock: faBinaryLock,
  faFilterCircleDollar: faFilterCircleDollar,
  faFunnelDollar: faFunnelDollar,
  faCameraRetro: faCameraRetro,
  faCircleArrowDown: faCircleArrowDown,
  faArrowCircleDown: faArrowCircleDown,
  faCommentPen: faCommentPen,
  faCommentEdit: faCommentEdit,
  faFileImport: faFileImport,
  faArrowRightToFile: faArrowRightToFile,
  faBanjo: faBanjo,
  faSquareArrowUpRight: faSquareArrowUpRight,
  faExternalLinkSquare: faExternalLinkSquare,
  faLightEmergencyOn: faLightEmergencyOn,
  faKerning: faKerning,
  faBoxOpen: faBoxOpen,
  faSquareF: faSquareF,
  faScroll: faScroll,
  faSpa: faSpa,
  faArrowLeftFromLine: faArrowLeftFromLine,
  faArrowFromRight: faArrowFromRight,
  faStrawberry: faStrawberry,
  faLocationPinLock: faLocationPinLock,
  faPause: faPause,
  faClockEightThirty: faClockEightThirty,
  faPlaneEngines: faPlaneEngines,
  faPlaneAlt: faPlaneAlt,
  faHillAvalanche: faHillAvalanche,
  faTemperatureEmpty: faTemperatureEmpty,
  faTemperature0: faTemperature0,
  faThermometer0: faThermometer0,
  faThermometerEmpty: faThermometerEmpty,
  faBomb: faBomb,
  faGaugeLow: faGaugeLow,
  faTachometerAltSlow: faTachometerAltSlow,
  faRegistered: faRegistered,
  faTrashCanPlus: faTrashCanPlus,
  faAddressCard: faAddressCard,
  faContactCard: faContactCard,
  faVcard: faVcard,
  faScaleUnbalancedFlip: faScaleUnbalancedFlip,
  faBalanceScaleRight: faBalanceScaleRight,
  faGlobeSnow: faGlobeSnow,
  faSubscript: faSubscript,
  faDiamondTurnRight: faDiamondTurnRight,
  faDirections: faDirections,
  faIntegral: faIntegral,
  faBurst: faBurst,
  faHouseLaptop: faHouseLaptop,
  faLaptopHouse: faLaptopHouse,
  faFaceTired: faFaceTired,
  faTired: faTired,
  faMoneyBills: faMoneyBills,
  faBlindsRaised: faBlindsRaised,
  faSmog: faSmog,
  faUfoBeam: faUfoBeam,
  faCircleCaretUp: faCircleCaretUp,
  faCaretCircleUp: faCaretCircleUp,
  faUserVneckHairLong: faUserVneckHairLong,
  faSquareALock: faSquareALock,
  faCrutch: faCrutch,
  faGasPumpSlash: faGasPumpSlash,
  faFontAwesome: faFontAwesome,
  faFontAwesomeFlag: faFontAwesomeFlag,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faCloudArrowUp: faCloudArrowUp,
  faCloudUpload: faCloudUpload,
  faCloudUploadAlt: faCloudUploadAlt,
  faPalette: faPalette,
  faTransporter4: faTransporter4,
  faChartMixedUpCircleCurrency: faChartMixedUpCircleCurrency,
  faObjectsAlignRight: faObjectsAlignRight,
  faArrowsTurnRight: faArrowsTurnRight,
  faVest: faVest,
  faPig: faPig,
  faInboxFull: faInboxFull,
  faCircleEnvelope: faCircleEnvelope,
  faEnvelopeCircle: faEnvelopeCircle,
  faTrianglePersonDigging: faTrianglePersonDigging,
  faConstruction: faConstruction,
  faFerry: faFerry,
  faBullseyeArrow: faBullseyeArrow,
  faArrowsDownToPeople: faArrowsDownToPeople,
  faSeedling: faSeedling,
  faSprout: faSprout,
  faClockSeven: faClockSeven,
  faLeftRight: faLeftRight,
  faArrowsAltH: faArrowsAltH,
  faBoxesPacking: faBoxesPacking,
  faCircleArrowLeft: faCircleArrowLeft,
  faArrowCircleLeft: faArrowCircleLeft,
  faFlashlight: faFlashlight,
  faGroupArrowsRotate: faGroupArrowsRotate,
  faBowlFood: faBowlFood,
  faSquare9: faSquare9,
  faCandyCane: faCandyCane,
  faArrowDownWideShort: faArrowDownWideShort,
  faSortAmountAsc: faSortAmountAsc,
  faSortAmountDown: faSortAmountDown,
  faSquareDollar: faSquareDollar,
  faDollarSquare: faDollarSquare,
  faUsdSquare: faUsdSquare,
  faPhoneArrowRight: faPhoneArrowRight,
  faHandHoldingSeedling: faHandHoldingSeedling,
  faMessageCheck: faMessageCheck,
  faCommentAltCheck: faCommentAltCheck,
  faCloudBolt: faCloudBolt,
  faThunderstorm: faThunderstorm,
  faChartLineUpDown: faChartLineUpDown,
  faTextSlash: faTextSlash,
  faRemoveFormat: faRemoveFormat,
  faWatch: faWatch,
  faCircleDownLeft: faCircleDownLeft,
  faText: faText,
  faProjector: faProjector,
  faFaceSmileWink: faFaceSmileWink,
  faSmileWink: faSmileWink,
  faTombstoneBlank: faTombstoneBlank,
  faTombstoneAlt: faTombstoneAlt,
  faChessKingPiece: faChessKingPiece,
  faChessKingAlt: faChessKingAlt,
  faCircle6: faCircle6,
  faLeft: faLeft,
  faArrowAltLeft: faArrowAltLeft,
  faFileWord: faFileWord,
  faFilePowerpoint: faFilePowerpoint,
  faSquareDown: faSquareDown,
  faArrowAltSquareDown: faArrowAltSquareDown,
  faObjectsAlignCenterVertical: faObjectsAlignCenterVertical,
  faArrowsLeftRight: faArrowsLeftRight,
  faArrowsH: faArrowsH,
  faHouseLock: faHouseLock,
  faCloudArrowDown: faCloudArrowDown,
  faCloudDownload: faCloudDownload,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faWreath: faWreath,
  faChildren: faChildren,
  faMeterDroplet: faMeterDroplet,
  faChalkboard: faChalkboard,
  faBlackboard: faBlackboard,
  faUserLargeSlash: faUserLargeSlash,
  faUserAltSlash: faUserAltSlash,
  faSignalStrong: faSignalStrong,
  faSignal4: faSignal4,
  faLollipop: faLollipop,
  faLollypop: faLollypop,
  faListTree: faListTree,
  faEnvelopeOpen: faEnvelopeOpen,
  faDrawCircle: faDrawCircle,
  faCatSpace: faCatSpace,
  faHandshakeSimpleSlash: faHandshakeSimpleSlash,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faRabbitRunning: faRabbitRunning,
  faRabbitFast: faRabbitFast,
  faMemoPad: faMemoPad,
  faMattressPillow: faMattressPillow,
  faAlarmPlus: faAlarmPlus,
  faAlicorn: faAlicorn,
  faCommentQuestion: faCommentQuestion,
  faGingerbreadMan: faGingerbreadMan,
  faGuaraniSign: faGuaraniSign,
  faBurgerFries: faBurgerFries,
  faMugTea: faMugTea,
  faBorderTop: faBorderTop,
  faArrowsRotate: faArrowsRotate,
  faRefresh: faRefresh,
  faSync: faSync,
  faCircleBookOpen: faCircleBookOpen,
  faBookCircle: faBookCircle,
  faArrowsToDottedLine: faArrowsToDottedLine,
  faFireExtinguisher: faFireExtinguisher,
  faGarageOpen: faGarageOpen,
  faShelvesEmpty: faShelvesEmpty,
  faCruzeiroSign: faCruzeiroSign,
  faWatchApple: faWatchApple,
  faWatchCalculator: faWatchCalculator,
  faListDropdown: faListDropdown,
  faCabinetFiling: faCabinetFiling,
  faBurgerSoda: faBurgerSoda,
  faSquareArrowUp: faSquareArrowUp,
  faArrowSquareUp: faArrowSquareUp,
  faGreaterThanEqual: faGreaterThanEqual,
  faPalletBox: faPalletBox,
  faFaceConfounded: faFaceConfounded,
  faShieldHalved: faShieldHalved,
  faShieldAlt: faShieldAlt,
  faTruckPlow: faTruckPlow,
  faBookAtlas: faBookAtlas,
  faAtlas: faAtlas,
  faVirus: faVirus,
  faGridRound2: faGridRound2,
  faCommentMiddleTop: faCommentMiddleTop,
  faEnvelopeCircleCheck: faEnvelopeCircleCheck,
  faLayerGroup: faLayerGroup,
  faRestroomSimple: faRestroomSimple,
  faArrowsToDot: faArrowsToDot,
  faBorderOuter: faBorderOuter,
  faHashtagLock: faHashtagLock,
  faClockTwoThirty: faClockTwoThirty,
  faArchway: faArchway,
  faHeartCircleCheck: faHeartCircleCheck,
  faHouseChimneyCrack: faHouseChimneyCrack,
  faHouseDamage: faHouseDamage,
  faFileZipper: faFileZipper,
  faFileArchive: faFileArchive,
  faHeartHalf: faHeartHalf,
  faCommentCheck: faCommentCheck,
  faSquare: faSquare,
  faMemo: faMemo,
  faMartiniGlassEmpty: faMartiniGlassEmpty,
  faGlassMartini: faGlassMartini,
  faCouch: faCouch,
  faCediSign: faCediSign,
  faItalic: faItalic,
  faGlassCitrus: faGlassCitrus,
  faCalendarLinesPen: faCalendarLinesPen,
  faChurch: faChurch,
  faPersonSnowmobiling: faPersonSnowmobiling,
  faSnowmobile: faSnowmobile,
  faFaceHushed: faFaceHushed,
  faCommentsDollar: faCommentsDollar,
  faPickaxe: faPickaxe,
  faLinkSimpleSlash: faLinkSimpleSlash,
  faDemocrat: faDemocrat,
  faFaceConfused: faFaceConfused,
  faPinball: faPinball,
  faZ: faZ,
  faPersonSkiing: faPersonSkiing,
  faSkiing: faSkiing,
  faDeer: faDeer,
  faInputPipe: faInputPipe,
  faRoadLock: faRoadLock,
  faA: faA,
  faBookmarkSlash: faBookmarkSlash,
  faTemperatureArrowDown: faTemperatureArrowDown,
  faTemperatureDown: faTemperatureDown,
  faMace: faMace,
  faFeatherPointed: faFeatherPointed,
  faFeatherAlt: faFeatherAlt,
  faSausage: faSausage,
  faTrashCanClock: faTrashCanClock,
  faP: faP,
  faBroomWide: faBroomWide,
  faSnowflake: faSnowflake,
  faStomach: faStomach,
  faNewspaper: faNewspaper,
  faRectangleAd: faRectangleAd,
  faAd: faAd,
  faGuitarElectric: faGuitarElectric,
  faArrowTurnDownRight: faArrowTurnDownRight,
  faMoonCloud: faMoonCloud,
  faBreadSliceButter: faBreadSliceButter,
  faCircleArrowRight: faCircleArrowRight,
  faArrowCircleRight: faArrowCircleRight,
  faUserGroupCrown: faUserGroupCrown,
  faUsersCrown: faUsersCrown,
  faCircleI: faCircleI,
  faToiletPaperCheck: faToiletPaperCheck,
  faFilterCircleXmark: faFilterCircleXmark,
  faLocust: faLocust,
  faSort: faSort,
  faUnsorted: faUnsorted,
  faListOl: faListOl,
  faList12: faList12,
  faListNumeric: faListNumeric,
  faChartWaterfall: faChartWaterfall,
  faSparkle: faSparkle,
  faFaceParty: faFaceParty,
  faKidneys: faKidneys,
  faWifiExclamation: faWifiExclamation,
  faChartNetwork: faChartNetwork,
  faPersonDressBurst: faPersonDressBurst,
  faDiceD4: faDiceD4,
  faMoneyCheckDollar: faMoneyCheckDollar,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faVectorSquare: faVectorSquare,
  faBreadSlice: faBreadSlice,
  faLanguage: faLanguage,
  faWheatAwnSlash: faWheatAwnSlash,
  faFaceKissWinkHeart: faFaceKissWinkHeart,
  faKissWinkHeart: faKissWinkHeart,
  faDagger: faDagger,
  faPodium: faPodium,
  faMemoCircleCheck: faMemoCircleCheck,
  faRouteHighway: faRouteHighway,
  faDownToLine: faDownToLine,
  faArrowAltToBottom: faArrowAltToBottom,
  faFilter: faFilter,
  faSquareG: faSquareG,
  faCirclePhone: faCirclePhone,
  faPhoneCircle: faPhoneCircle,
  faClipboardPrescription: faClipboardPrescription,
  faUserNurseHair: faUserNurseHair,
  faQuestion: faQuestion,
  faFileSignature: faFileSignature,
  faToggleLargeOn: faToggleLargeOn,
  faUpDownLeftRight: faUpDownLeftRight,
  faArrowsAlt: faArrowsAlt,
  faDryerHeat: faDryerHeat,
  faDryerAlt: faDryerAlt,
  faHouseChimneyUser: faHouseChimneyUser,
  faHandHoldingHeart: faHandHoldingHeart,
  faArrowUpSmallBig: faArrowUpSmallBig,
  faSortSizeUpAlt: faSortSizeUpAlt,
  faTrainTrack: faTrainTrack,
  faPuzzlePiece: faPuzzlePiece,
  faMoneyCheck: faMoneyCheck,
  faStarHalfStroke: faStarHalfStroke,
  faStarHalfAlt: faStarHalfAlt,
  faFileExclamation: faFileExclamation,
  faCode: faCode,
  faWhiskeyGlass: faWhiskeyGlass,
  faGlassWhiskey: faGlassWhiskey,
  faMoonStars: faMoonStars,
  faBuildingCircleExclamation: faBuildingCircleExclamation,
  faClothesHanger: faClothesHanger,
  faMobileNotch: faMobileNotch,
  faMobileIphone: faMobileIphone,
  faMagnifyingGlassChart: faMagnifyingGlassChart,
  faArrowUpRightFromSquare: faArrowUpRightFromSquare,
  faExternalLink: faExternalLink,
  faCubesStacked: faCubesStacked,
  faImagesUser: faImagesUser,
  faWonSign: faWonSign,
  faKrw: faKrw,
  faWon: faWon,
  faImagePolaroidUser: faImagePolaroidUser,
  faVirusCovid: faVirusCovid,
  faSquareEllipsis: faSquareEllipsis,
  faPie: faPie,
  faChessKnightPiece: faChessKnightPiece,
  faChessKnightAlt: faChessKnightAlt,
  faAustralSign: faAustralSign,
  faCloudPlus: faCloudPlus,
  faF: faF,
  faLeaf: faLeaf,
  faBedBunk: faBedBunk,
  faRoad: faRoad,
  faTaxi: faTaxi,
  faCab: faCab,
  faPersonCirclePlus: faPersonCirclePlus,
  faChartPie: faChartPie,
  faPieChart: faPieChart,
  faBoltLightning: faBoltLightning,
  faClockEight: faClockEight,
  faSackXmark: faSackXmark,
  faFileExcel: faFileExcel,
  faFileContract: faFileContract,
  faFishFins: faFishFins,
  faCircleQ: faCircleQ,
  faBuildingFlag: faBuildingFlag,
  faFaceGrinBeam: faFaceGrinBeam,
  faGrinBeam: faGrinBeam,
  faObjectUngroup: faObjectUngroup,
  faFaceDisguise: faFaceDisguise,
  faCircleArrowDownRight: faCircleArrowDownRight,
  faAlien8bit: faAlien8bit,
  faAlienMonster: faAlienMonster,
  faHandPointRibbon: faHandPointRibbon,
  faPoop: faPoop,
  faObjectExclude: faObjectExclude,
  faTelescope: faTelescope,
  faLocationPin: faLocationPin,
  faMapMarker: faMapMarker,
  faSquareList: faSquareList,
  faKaaba: faKaaba,
  faToiletPaper: faToiletPaper,
  faHelmetSafety: faHelmetSafety,
  faHardHat: faHardHat,
  faHatHard: faHatHard,
  faCommentCode: faCommentCode,
  faSimCards: faSimCards,
  faStarship: faStarship,
  faEject: faEject,
  faCircleRight: faCircleRight,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faPlaneCircleCheck: faPlaneCircleCheck,
  faSeal: faSeal,
  faUserCowboy: faUserCowboy,
  faHexagonVerticalNft: faHexagonVerticalNft,
  faFaceRollingEyes: faFaceRollingEyes,
  faMehRollingEyes: faMehRollingEyes,
  faBreadLoaf: faBreadLoaf,
  faRingsWedding: faRingsWedding,
  faObjectGroup: faObjectGroup,
  faFrenchFries: faFrenchFries,
  faChartLine: faChartLine,
  faLineChart: faLineChart,
  faCalendarArrowDown: faCalendarArrowDown,
  faCalendarDownload: faCalendarDownload,
  faSendBack: faSendBack,
  faMaskVentilator: faMaskVentilator,
  faSignatureLock: faSignatureLock,
  faArrowRight: faArrowRight,
  faSignsPost: faSignsPost,
  faMapSigns: faMapSigns,
  faOctagonPlus: faOctagonPlus,
  faPlusOctagon: faPlusOctagon,
  faCashRegister: faCashRegister,
  faPersonCircleQuestion: faPersonCircleQuestion,
  faMelonSlice: faMelonSlice,
  faSpaceStationMoon: faSpaceStationMoon,
  faMessageSmile: faMessageSmile,
  faCommentAltSmile: faCommentAltSmile,
  faCupStraw: faCupStraw,
  faLeftFromLine: faLeftFromLine,
  faArrowAltFromRight: faArrowAltFromRight,
  faH: faH,
  faBasketShoppingSimple: faBasketShoppingSimple,
  faShoppingBasketAlt: faShoppingBasketAlt,
  faHandsHoldingHeart: faHandsHoldingHeart,
  faHandsHeart: faHandsHeart,
  faClockNine: faClockNine,
  faTarp: faTarp,
  faFaceSleepy: faFaceSleepy,
  faHandHorns: faHandHorns,
  faScrewdriverWrench: faScrewdriverWrench,
  faTools: faTools,
  faArrowsToEye: faArrowsToEye,
  faCircleThreeQuarters: faCircleThreeQuarters,
  faTrophyStar: faTrophyStar,
  faTrophyAlt: faTrophyAlt,
  faPlugCircleBolt: faPlugCircleBolt,
  faFaceThermometer: faFaceThermometer,
  faGridRound4: faGridRound4,
  faShirtRunning: faShirtRunning,
  faBookCircleArrowUp: faBookCircleArrowUp,
  faFaceNauseated: faFaceNauseated,
  faHeart: faHeart,
  faFileChartPie: faFileChartPie,
  faMarsAndVenus: faMarsAndVenus,
  faHouseUser: faHouseUser,
  faHomeUser: faHomeUser,
  faCircleArrowDownLeft: faCircleArrowDownLeft,
  faDumpsterFire: faDumpsterFire,
  faHexagonMinus: faHexagonMinus,
  faMinusHexagon: faMinusHexagon,
  faLeftToLine: faLeftToLine,
  faArrowAltToLeft: faArrowAltToLeft,
  faHouseCrack: faHouseCrack,
  faPawSimple: faPawSimple,
  faPawAlt: faPawAlt,
  faArrowLeftLongToLine: faArrowLeftLongToLine,
  faBracketsRound: faBracketsRound,
  faParentheses: faParentheses,
  faMartiniGlassCitrus: faMartiniGlassCitrus,
  faCocktail: faCocktail,
  faUserShakespeare: faUserShakespeare,
  faArrowRightToArc: faArrowRightToArc,
  faFaceSurprise: faFaceSurprise,
  faSurprise: faSurprise,
  faBottleWater: faBottleWater,
  faCirclePause: faCirclePause,
  faPauseCircle: faPauseCircle,
  faGaugeCirclePlus: faGaugeCirclePlus,
  faFolders: faFolders,
  faAngel: faAngel,
  faValueAbsolute: faValueAbsolute,
  faRabbit: faRabbit,
  faToiletPaperSlash: faToiletPaperSlash,
  faCircleEuro: faCircleEuro,
  faAppleWhole: faAppleWhole,
  faAppleAlt: faAppleAlt,
  faKitchenSet: faKitchenSet,
  faDiamondHalf: faDiamondHalf,
  faLockKeyhole: faLockKeyhole,
  faLockAlt: faLockAlt,
  faR: faR,
  faTemperatureQuarter: faTemperatureQuarter,
  faTemperature1: faTemperature1,
  faThermometer1: faThermometer1,
  faThermometerQuarter: faThermometerQuarter,
  faSquareInfo: faSquareInfo,
  faInfoSquare: faInfoSquare,
  faWifiSlash: faWifiSlash,
  faToiletPaperXmark: faToiletPaperXmark,
  faHandsHoldingDollar: faHandsHoldingDollar,
  faHandsUsd: faHandsUsd,
  faCube: faCube,
  faArrowDownTriangleSquare: faArrowDownTriangleSquare,
  faSortShapesDown: faSortShapesDown,
  faBitcoinSign: faBitcoinSign,
  faShutters: faShutters,
  faShieldDog: faShieldDog,
  faSolarPanel: faSolarPanel,
  faLockOpen: faLockOpen,
  faTableTree: faTableTree,
  faHouseChimneyHeart: faHouseChimneyHeart,
  faTally3: faTally3,
  faElevator: faElevator,
  faMoneyBillTransfer: faMoneyBillTransfer,
  faMoneyBillTrendUp: faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal: faSquarePollHorizontal,
  faPollH: faPollH,
  faCircle: faCircle,
  faCartCircleExclamation: faCartCircleExclamation,
  faSword: faSword,
  faBackwardFast: faBackwardFast,
  faFastBackward: faFastBackward,
  faRecycle: faRecycle,
  faUserAstronaut: faUserAstronaut,
  faInterrobang: faInterrobang,
  faPlaneSlash: faPlaneSlash,
  faCircleDashed: faCircleDashed,
  faTrademark: faTrademark,
  faBasketball: faBasketball,
  faBasketballBall: faBasketballBall,
  faForkKnife: faForkKnife,
  faUtensilsAlt: faUtensilsAlt,
  faSatelliteDish: faSatelliteDish,
  faBadgeCheck: faBadgeCheck,
  faCircleUp: faCircleUp,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faSlider: faSlider,
  faMobileScreenButton: faMobileScreenButton,
  faMobileAlt: faMobileAlt,
  faClockOneThirty: faClockOneThirty,
  faInboxOut: faInboxOut,
  faInboxArrowUp: faInboxArrowUp,
  faCloudSlash: faCloudSlash,
  faVolumeHigh: faVolumeHigh,
  faVolumeUp: faVolumeUp,
  faUsersRays: faUsersRays,
  faWallet: faWallet,
  faOctagonCheck: faOctagonCheck,
  faFlatbreadStuffed: faFlatbreadStuffed,
  faClipboardCheck: faClipboardCheck,
  faCartCirclePlus: faCartCirclePlus,
  faTruckClock: faTruckClock,
  faShippingTimed: faShippingTimed,
  faPool8Ball: faPool8Ball,
  faFileAudio: faFileAudio,
  faTurnDownLeft: faTurnDownLeft,
  faLockHashtag: faLockHashtag,
  faChartRadar: faChartRadar,
  faStaff: faStaff,
  faBurger: faBurger,
  faHamburger: faHamburger,
  faUtilityPole: faUtilityPole,
  faTransporter6: faTransporter6,
  faWrench: faWrench,
  faBugs: faBugs,
  faVectorPolygon: faVectorPolygon,
  faDiagramNested: faDiagramNested,
  faRupeeSign: faRupeeSign,
  faRupee: faRupee,
  faFileImage: faFileImage,
  faCircleQuestion: faCircleQuestion,
  faQuestionCircle: faQuestionCircle,
  faImageUser: faImageUser,
  faBuoy: faBuoy,
  faPlaneDeparture: faPlaneDeparture,
  faHandshakeSlash: faHandshakeSlash,
  faBookBookmark: faBookBookmark,
  faBorderCenterH: faBorderCenterH,
  faCanFood: faCanFood,
  faTypewriter: faTypewriter,
  faArrowRightFromArc: faArrowRightFromArc,
  faCircleK: faCircleK,
  faFaceHandOverMouth: faFaceHandOverMouth,
  faPopcorn: faPopcorn,
  faHouseWater: faHouseWater,
  faHouseFlood: faHouseFlood,
  faObjectSubtract: faObjectSubtract,
  faCodeBranch: faCodeBranch,
  faWarehouseFull: faWarehouseFull,
  faWarehouseAlt: faWarehouseAlt,
  faHatCowboy: faHatCowboy,
  faBridge: faBridge,
  faPhoneFlip: faPhoneFlip,
  faPhoneAlt: faPhoneAlt,
  faArrowDownFromDottedLine: faArrowDownFromDottedLine,
  faFileDoc: faFileDoc,
  faSquareQuarters: faSquareQuarters,
  faTruckFront: faTruckFront,
  faCat: faCat,
  faTrashXmark: faTrashXmark,
  faCircleCaretLeft: faCircleCaretLeft,
  faCaretCircleLeft: faCaretCircleLeft,
  faFiles: faFiles,
  faAnchorCircleExclamation: faAnchorCircleExclamation,
  faFaceClouds: faFaceClouds,
  faUserCrown: faUserCrown,
  faTruckField: faTruckField,
  faRoute: faRoute,
  faCartCircleCheck: faCartCircleCheck,
  faClipboardQuestion: faClipboardQuestion,
  faPanorama: faPanorama,
  faCommentMedical: faCommentMedical,
  faTeethOpen: faTeethOpen,
  faUserTieHairLong: faUserTieHairLong,
  faFileCircleMinus: faFileCircleMinus,
  faHeadSideMedical: faHeadSideMedical,
  faTags: faTags,
  faWineGlass: faWineGlass,
  faForwardFast: faForwardFast,
  faFastForward: faFastForward,
  faFaceMehBlank: faFaceMehBlank,
  faMehBlank: faMehBlank,
  faUserRobot: faUserRobot,
  faSquareParking: faSquareParking,
  faParking: faParking,
  faCardDiamond: faCardDiamond,
  faFaceZipper: faFaceZipper,
  faFaceRaisedEyebrow: faFaceRaisedEyebrow,
  faHouseSignal: faHouseSignal,
  faSquareChevronUp: faSquareChevronUp,
  faChevronSquareUp: faChevronSquareUp,
  faNfcSymbol: faNfcSymbol,
  faBarsProgress: faBarsProgress,
  faTasksAlt: faTasksAlt,
  faFaucetDrip: faFaucetDrip,
  faArrowsToLine: faArrowsToLine,
  faDolphin: faDolphin,
  faArrowUpRight: faArrowUpRight,
  faCircleR: faCircleR,
  faCartFlatbed: faCartFlatbed,
  faDollyFlatbed: faDollyFlatbed,
  faBanSmoking: faBanSmoking,
  faSmokingBan: faSmokingBan,
  faCircleSortUp: faCircleSortUp,
  faSortCircleUp: faSortCircleUp,
  faTerminal: faTerminal,
  faMobileButton: faMobileButton,
  faHouseMedicalFlag: faHouseMedicalFlag,
  faBasketShopping: faBasketShopping,
  faShoppingBasket: faShoppingBasket,
  faTape: faTape,
  faChestnut: faChestnut,
  faBusSimple: faBusSimple,
  faBusAlt: faBusAlt,
  faEye: faEye,
  faFaceSadCry: faFaceSadCry,
  faSadCry: faSadCry,
  faHeat: faHeat,
  faTicketAirline: faTicketAirline,
  faBootHeeled: faBootHeeled,
  faArrowsMinimize: faArrowsMinimize,
  faCompressArrows: faCompressArrows,
  faAudioDescription: faAudioDescription,
  faPersonMilitaryToPerson: faPersonMilitaryToPerson,
  faFileShield: faFileShield,
  faHexagon: faHexagon,
  faManhole: faManhole,
  faUserSlash: faUserSlash,
  faPen: faPen,
  faTowerObservation: faTowerObservation,
  faFloppyDisks: faFloppyDisks,
  faToiletPaperBlankUnder: faToiletPaperBlankUnder,
  faToiletPaperReverseAlt: faToiletPaperReverseAlt,
  faFileCode: faFileCode,
  faSignal: faSignal,
  faSignal5: faSignal5,
  faSignalPerfect: faSignalPerfect,
  faPump: faPump,
  faBus: faBus,
  faHeartCircleXmark: faHeartCircleXmark,
  faArrowUpLeftFromCircle: faArrowUpLeftFromCircle,
  faHouseChimney: faHouseChimney,
  faHomeLg: faHomeLg,
  faWindowMaximize: faWindowMaximize,
  faDryer: faDryer,
  faFaceFrown: faFaceFrown,
  faFrown: faFrown,
  faChessBishopPiece: faChessBishopPiece,
  faChessBishopAlt: faChessBishopAlt,
  faShirtTankTop: faShirtTankTop,
  faDiploma: faDiploma,
  faScrollRibbon: faScrollRibbon,
  faScreencast: faScreencast,
  faWalker: faWalker,
  faPrescription: faPrescription,
  faShop: faShop,
  faStoreAlt: faStoreAlt,
  faFloppyDisk: faFloppyDisk,
  faSave: faSave,
  faVihara: faVihara,
  faFaceKissClosedEyes: faFaceKissClosedEyes,
  faScaleUnbalanced: faScaleUnbalanced,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faFileUser: faFileUser,
  faUserPoliceTie: faUserPoliceTie,
  faFaceTongueMoney: faFaceTongueMoney,
  faTennisBall: faTennisBall,
  faSquareL: faSquareL,
  faSortUp: faSortUp,
  faSortAsc: faSortAsc,
  faCalendarArrowUp: faCalendarArrowUp,
  faCalendarUpload: faCalendarUpload,
  faCommentDots: faCommentDots,
  faCommenting: faCommenting,
  faPlantWilt: faPlantWilt,
  faScarf: faScarf,
  faAlbumCirclePlus: faAlbumCirclePlus,
  faUserNurseHairLong: faUserNurseHairLong,
  faDiamond: faDiamond,
  faSquareLeft: faSquareLeft,
  faArrowAltSquareLeft: faArrowAltSquareLeft,
  faFaceGrinSquint: faFaceGrinSquint,
  faGrinSquint: faGrinSquint,
  faCircleEllipsisVertical: faCircleEllipsisVertical,
  faHandHoldingDollar: faHandHoldingDollar,
  faHandHoldingUsd: faHandHoldingUsd,
  faGridDividers: faGridDividers,
  faBacterium: faBacterium,
  faHandPointer: faHandPointer,
  faDrumSteelpan: faDrumSteelpan,
  faHandScissors: faHandScissors,
  faHandsPraying: faHandsPraying,
  faPrayingHands: faPrayingHands,
  faFacePensive: faFacePensive,
  faUserMusic: faUserMusic,
  faArrowRotateRight: faArrowRotateRight,
  faArrowRightRotate: faArrowRightRotate,
  faArrowRotateForward: faArrowRotateForward,
  faRedo: faRedo,
  faMessagesDollar: faMessagesDollar,
  faCommentsAltDollar: faCommentsAltDollar,
  faSensorOn: faSensorOn,
  faBalloon: faBalloon,
  faBiohazard: faBiohazard,
  faChessQueenPiece: faChessQueenPiece,
  faChessQueenAlt: faChessQueenAlt,
  faLocationCrosshairs: faLocationCrosshairs,
  faLocation: faLocation,
  faMarsDouble: faMarsDouble,
  faHousePersonLeave: faHousePersonLeave,
  faHouseLeave: faHouseLeave,
  faHousePersonDepart: faHousePersonDepart,
  faRulerTriangle: faRulerTriangle,
  faCardClub: faCardClub,
  faChildDress: faChildDress,
  faUsersBetweenLines: faUsersBetweenLines,
  faLungsVirus: faLungsVirus,
  faSpinnerThird: faSpinnerThird,
  faFaceGrinTears: faFaceGrinTears,
  faGrinTears: faGrinTears,
  faPhone: faPhone,
  faComputerMouseScrollwheel: faComputerMouseScrollwheel,
  faMouseAlt: faMouseAlt,
  faCalendarXmark: faCalendarXmark,
  faCalendarTimes: faCalendarTimes,
  faChildReaching: faChildReaching,
  faTableLayout: faTableLayout,
  faNarwhal: faNarwhal,
  faRampLoading: faRampLoading,
  faCalendarCirclePlus: faCalendarCirclePlus,
  faToothbrush: faToothbrush,
  faBorderInner: faBorderInner,
  faPawClaws: faPawClaws,
  faKiwiFruit: faKiwiFruit,
  faTrafficLightSlow: faTrafficLightSlow,
  faRectangleCode: faRectangleCode,
  faHeadSideVirus: faHeadSideVirus,
  faKeyboardBrightness: faKeyboardBrightness,
  faBooksMedical: faBooksMedical,
  faLightbulbSlash: faLightbulbSlash,
  faHouseBlank: faHouseBlank,
  faHomeBlank: faHomeBlank,
  faSquare5: faSquare5,
  faSquareHeart: faSquareHeart,
  faHeartSquare: faHeartSquare,
  faPuzzle: faPuzzle,
  faUserGear: faUserGear,
  faUserCog: faUserCog,
  faPipeCircleCheck: faPipeCircleCheck,
  faArrowUp19: faArrowUp19,
  faSortNumericUp: faSortNumericUp,
  faOctagonExclamation: faOctagonExclamation,
  faDialLow: faDialLow,
  faDoorClosed: faDoorClosed,
  faLaptopMobile: faLaptopMobile,
  faPhoneLaptop: faPhoneLaptop,
  faConveyorBeltBoxes: faConveyorBeltBoxes,
  faConveyorBeltAlt: faConveyorBeltAlt,
  faShieldVirus: faShieldVirus,
  faStarfighterTwinIonEngineAdvanced: faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced: faStarfighterAltAdvanced,
  faDiceSix: faDiceSix,
  faStarfighterTwinIonEngine: faStarfighterTwinIonEngine,
  faStarfighterAlt: faStarfighterAlt,
  faRocketLaunch: faRocketLaunch,
  faMosquitoNet: faMosquitoNet,
  faVentDamper: faVentDamper,
  faBridgeWater: faBridgeWater,
  faBanBug: faBanBug,
  faDebug: faDebug,
  faPersonBooth: faPersonBooth,
  faTextWidth: faTextWidth,
  faGarageCar: faGarageCar,
  faSquareKanban: faSquareKanban,
  faHatWizard: faHatWizard,
  faPenFancy: faPenFancy,
  faCoffeePot: faCoffeePot,
  faMouseField: faMouseField,
  faPersonDigging: faPersonDigging,
  faDigging: faDigging,
  faShowerDown: faShowerDown,
  faShowerAlt: faShowerAlt,
  faBoxCircleCheck: faBoxCircleCheck,
  faBrightness: faBrightness,
  faCarSideBolt: faCarSideBolt,
  faOrnament: faOrnament,
  faPhoneArrowDownLeft: faPhoneArrowDownLeft,
  faPhoneArrowDown: faPhoneArrowDown,
  faPhoneIncoming: faPhoneIncoming,
  faCloudWord: faCloudWord,
  faHandFingersCrossed: faHandFingersCrossed,
  faTrash: faTrash,
  faGaugeSimple: faGaugeSimple,
  faGaugeSimpleMed: faGaugeSimpleMed,
  faTachometerAverage: faTachometerAverage,
  faArrowDownSmallBig: faArrowDownSmallBig,
  faSortSizeDownAlt: faSortSizeDownAlt,
  faBookMedical: faBookMedical,
  faFaceMelting: faFaceMelting,
  faPoo: faPoo,
  faPenClipSlash: faPenClipSlash,
  faPenAltSlash: faPenAltSlash,
  faQuoteRight: faQuoteRight,
  faQuoteRightAlt: faQuoteRightAlt,
  faScrollOld: faScrollOld,
  faGuitars: faGuitars,
  faPhoneXmark: faPhoneXmark,
  faHose: faHose,
  faClockSix: faClockSix,
  faShirt: faShirt,
  faTShirt: faTShirt,
  faTshirt: faTshirt,
  faBillboard: faBillboard,
  faSquareR: faSquareR,
  faCubes: faCubes,
  faEnvelopeOpenDollar: faEnvelopeOpenDollar,
  faDivide: faDivide,
  faSunCloud: faSunCloud,
  faLampFloor: faLampFloor,
  faSquare7: faSquare7,
  faTengeSign: faTengeSign,
  faTenge: faTenge,
  faHeadphones: faHeadphones,
  faHandsHolding: faHandsHolding,
  faCampfire: faCampfire,
  faCircleAmpersand: faCircleAmpersand,
  faSnowflakes: faSnowflakes,
  faHandsClapping: faHandsClapping,
  faRepublican: faRepublican,
  faLeafMaple: faLeafMaple,
  faArrowLeft: faArrowLeft,
  faPersonCircleXmark: faPersonCircleXmark,
  faRuler: faRuler,
  faCupStrawSwoosh: faCupStrawSwoosh,
  faTemperatureSun: faTemperatureSun,
  faTemperatureHot: faTemperatureHot,
  faAlignLeft: faAlignLeft,
  faDiceD6: faDiceD6,
  faRestroom: faRestroom,
  faHighDefinition: faHighDefinition,
  faRectangleHd: faRectangleHd,
  faJ: faJ,
  faGalaxy: faGalaxy,
  faUsersViewfinder: faUsersViewfinder,
  faFileVideo: faFileVideo,
  faCherries: faCherries,
  faUpRightFromSquare: faUpRightFromSquare,
  faExternalLinkAlt: faExternalLinkAlt,
  faCircleSort: faCircleSort,
  faSortCircle: faSortCircle,
  faTableCells: faTableCells,
  faTh: faTh,
  faFilePdf: faFilePdf,
  faSiren: faSiren,
  faArrowUpToDottedLine: faArrowUpToDottedLine,
  faImageLandscape: faImageLandscape,
  faLandscape: faLandscape,
  faTankWater: faTankWater,
  faCurlingStone: faCurlingStone,
  faCurling: faCurling,
  faGamepadModern: faGamepadModern,
  faGamepadAlt: faGamepadAlt,
  faMessagesQuestion: faMessagesQuestion,
  faBookBible: faBookBible,
  faBible: faBible,
  faO: faO,
  faSuitcaseMedical: faSuitcaseMedical,
  faMedkit: faMedkit,
  faBriefcaseArrowRight: faBriefcaseArrowRight,
  faExpandWide: faExpandWide,
  faClockElevenThirty: faClockElevenThirty,
  faRv: faRv,
  faUserSecret: faUserSecret,
  faOtter: faOtter,
  faDreidel: faDreidel,
  faPersonDress: faPersonDress,
  faFemale: faFemale,
  faCommentDollar: faCommentDollar,
  faBusinessTime: faBusinessTime,
  faBriefcaseClock: faBriefcaseClock,
  faFlowerTulip: faFlowerTulip,
  faPeoplePantsSimple: faPeoplePantsSimple,
  faCloudDrizzle: faCloudDrizzle,
  faTableCellsLarge: faTableCellsLarge,
  faThLarge: faThLarge,
  faBookTanakh: faBookTanakh,
  faTanakh: faTanakh,
  faSolarSystem: faSolarSystem,
  faSealQuestion: faSealQuestion,
  faPhoneVolume: faPhoneVolume,
  faVolumeControlPhone: faVolumeControlPhone,
  faDiscDrive: faDiscDrive,
  faHatCowboySide: faHatCowboySide,
  faTableRows: faTableRows,
  faRows: faRows,
  faLocationExclamation: faLocationExclamation,
  faMapMarkerExclamation: faMapMarkerExclamation,
  faFaceFearful: faFaceFearful,
  faClipboardUser: faClipboardUser,
  faBusSchool: faBusSchool,
  faFilmSlash: faFilmSlash,
  faSquareArrowDownRight: faSquareArrowDownRight,
  faBookSparkles: faBookSparkles,
  faBookSpells: faBookSpells,
  faWashingMachine: faWashingMachine,
  faWasher: faWasher,
  faChild: faChild,
  faLiraSign: faLiraSign,
  faUserVisor: faUserVisor,
  faFilePlusMinus: faFilePlusMinus,
  faChessClockFlip: faChessClockFlip,
  faChessClockAlt: faChessClockAlt,
  faSatellite: faSatellite,
  faPlaneLock: faPlaneLock,
  faSteeringWheel: faSteeringWheel,
  faTag: faTag,
  faStretcher: faStretcher,
  faBookSection: faBookSection,
  faBookLaw: faBookLaw,
  faInboxes: faInboxes,
  faCoffeeBean: faCoffeeBean,
  faCircleYen: faCircleYen,
  faBracketsCurly: faBracketsCurly,
  faEllipsisStrokeVertical: faEllipsisStrokeVertical,
  faEllipsisVAlt: faEllipsisVAlt,
  faComment: faComment,
  faSquare1: faSquare1,
  faCakeCandles: faCakeCandles,
  faBirthdayCake: faBirthdayCake,
  faCake: faCake,
  faHeadSide: faHeadSide,
  faEnvelope: faEnvelope,
  faDollyEmpty: faDollyEmpty,
  faFaceTissue: faFaceTissue,
  faAnglesUp: faAnglesUp,
  faAngleDoubleUp: faAngleDoubleUp,
  faBinRecycle: faBinRecycle,
  faPaperclip: faPaperclip,
  faChartLineDown: faChartLineDown,
  faArrowRightToCity: faArrowRightToCity,
  faLockA: faLockA,
  faRibbon: faRibbon,
  faLungs: faLungs,
  faPersonPinball: faPersonPinball,
  faArrowUp91: faArrowUp91,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faAppleCore: faAppleCore,
  faCircleY: faCircleY,
  faH6: faH6,
  faLitecoinSign: faLitecoinSign,
  faCircleSmall: faCircleSmall,
  faBorderNone: faBorderNone,
  faArrowTurnDownLeft: faArrowTurnDownLeft,
  faCircleNodes: faCircleNodes,
  faParachuteBox: faParachuteBox,
  faMessageMedical: faMessageMedical,
  faCommentAltMedical: faCommentAltMedical,
  faRugbyBall: faRugbyBall,
  faCommentMusic: faCommentMusic,
  faIndent: faIndent,
  faTreeDeciduous: faTreeDeciduous,
  faTreeAlt: faTreeAlt,
  faPuzzlePieceSimple: faPuzzlePieceSimple,
  faPuzzlePieceAlt: faPuzzlePieceAlt,
  faTruckFieldUn: faTruckFieldUn,
  faNfcTrash: faNfcTrash,
  faHourglass: faHourglass,
  faHourglassEmpty: faHourglassEmpty,
  faMountain: faMountain,
  faFileXmark: faFileXmark,
  faFileTimes: faFileTimes,
  faHouseHeart: faHouseHeart,
  faHomeHeart: faHomeHeart,
  faHouseChimneyBlank: faHouseChimneyBlank,
  faMeterBolt: faMeterBolt,
  faUserDoctor: faUserDoctor,
  faUserMd: faUserMd,
  faSlashBack: faSlashBack,
  faCircleInfo: faCircleInfo,
  faInfoCircle: faInfoCircle,
  faFishingRod: faFishingRod,
  faHammerCrash: faHammerCrash,
  faMessageHeart: faMessageHeart,
  faCloudMeatball: faCloudMeatball,
  faCameraPolaroid: faCameraPolaroid,
  faCamera: faCamera,
  faCameraAlt: faCameraAlt,
  faSquareVirus: faSquareVirus,
  faCartArrowUp: faCartArrowUp,
  faMeteor: faMeteor,
  faCarOn: faCarOn,
  faSleigh: faSleigh,
  faArrowDown19: faArrowDown19,
  faSortNumericAsc: faSortNumericAsc,
  faSortNumericDown: faSortNumericDown,
  faBuoyMooring: faBuoyMooring,
  faSquare4: faSquare4,
  faHandHoldingDroplet: faHandHoldingDroplet,
  faHandHoldingWater: faHandHoldingWater,
  faTricycleAdult: faTricycleAdult,
  faWaveform: faWaveform,
  faWater: faWater,
  faStarSharpHalfStroke: faStarSharpHalfStroke,
  faStarSharpHalfAlt: faStarSharpHalfAlt,
  faNfcSignal: faNfcSignal,
  faPlaneProp: faPlaneProp,
  faCalendarCheck: faCalendarCheck,
  faClockDesk: faClockDesk,
  faCalendarClock: faCalendarClock,
  faCalendarTime: faCalendarTime,
  faBraille: faBraille,
  faPrescriptionBottleMedical: faPrescriptionBottleMedical,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPlateUtensils: faPlateUtensils,
  faFamilyPants: faFamilyPants,
  faHoseReel: faHoseReel,
  faHouseWindow: faHouseWindow,
  faLandmark: faLandmark,
  faTruck: faTruck,
  faCrosshairs: faCrosshairs,
  faCloudRainbow: faCloudRainbow,
  faPersonCane: faPersonCane,
  faAlien: faAlien,
  faTent: faTent,
  faLaptopBinary: faLaptopBinary,
  faVestPatches: faVestPatches,
  faPeopleDressSimple: faPeopleDressSimple,
  faCheckDouble: faCheckDouble,
  faArrowDownAZ: faArrowDownAZ,
  faSortAlphaAsc: faSortAlphaAsc,
  faSortAlphaDown: faSortAlphaDown,
  faBowlingBallPin: faBowlingBallPin,
  faBellSchoolSlash: faBellSchoolSlash,
  faPlusLarge: faPlusLarge,
  faMoneyBillWheat: faMoneyBillWheat,
  faCameraViewfinder: faCameraViewfinder,
  faScreenshot: faScreenshot,
  faMessageMusic: faMessageMusic,
  faCommentAltMusic: faCommentAltMusic,
  faCarBuilding: faCarBuilding,
  faBorderBottomRight: faBorderBottomRight,
  faBorderStyleAlt: faBorderStyleAlt,
  faOctagon: faOctagon,
  faCommentArrowUpRight: faCommentArrowUpRight,
  faOctagonDivide: faOctagonDivide,
  faCookie: faCookie,
  faArrowRotateLeft: faArrowRotateLeft,
  faArrowLeftRotate: faArrowLeftRotate,
  faArrowRotateBack: faArrowRotateBack,
  faArrowRotateBackward: faArrowRotateBackward,
  faUndo: faUndo,
  faTvMusic: faTvMusic,
  faHardDrive: faHardDrive,
  faHdd: faHdd,
  faReel: faReel,
  faFaceGrinSquintTears: faFaceGrinSquintTears,
  faGrinSquintTears: faGrinSquintTears,
  faDumbbell: faDumbbell,
  faRectangleList: faRectangleList,
  faListAlt: faListAlt,
  faTarpDroplet: faTarpDroplet,
  faAlarmExclamation: faAlarmExclamation,
  faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
  faTrafficCone: faTrafficCone,
  faGrate: faGrate,
  faArrowDownRight: faArrowDownRight,
  faPersonSkiingNordic: faPersonSkiingNordic,
  faSkiingNordic: faSkiingNordic,
  faCalendarPlus: faCalendarPlus,
  faPersonFromPortal: faPersonFromPortal,
  faPortalExit: faPortalExit,
  faPlaneArrival: faPlaneArrival,
  faCowbellCirclePlus: faCowbellCirclePlus,
  faCowbellMore: faCowbellMore,
  faCircleLeft: faCircleLeft,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faDistributeSpacingVertical: faDistributeSpacingVertical,
  faSignalBarsFair: faSignalBarsFair,
  faSignalAlt2: faSignalAlt2,
  faSportsball: faSportsball,
  faGameConsoleHandheldCrank: faGameConsoleHandheldCrank,
  faTrainSubway: faTrainSubway,
  faSubway: faSubway,
  faChartGantt: faChartGantt,
  faFaceSmileUpsideDown: faFaceSmileUpsideDown,
  faBallPile: faBallPile,
  faBadgeDollar: faBadgeDollar,
  faMoneyBillsSimple: faMoneyBillsSimple,
  faMoneyBillsAlt: faMoneyBillsAlt,
  faListTimeline: faListTimeline,
  faIndianRupeeSign: faIndianRupeeSign,
  faIndianRupee: faIndianRupee,
  faInr: faInr,
  faCropSimple: faCropSimple,
  faCropAlt: faCropAlt,
  faMoneyBill1: faMoneyBill1,
  faMoneyBillAlt: faMoneyBillAlt,
  faLeftLong: faLeftLong,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faKeyboardDown: faKeyboardDown,
  faCircleUpRight: faCircleUpRight,
  faCloudBoltMoon: faCloudBoltMoon,
  faThunderstormMoon: faThunderstormMoon,
  faDna: faDna,
  faVirusSlash: faVirusSlash,
  faBracketRoundRight: faBracketRoundRight,
  faCircleSterling: faCircleSterling,
  faCircle5: faCircle5,
  faMinus: faMinus,
  faSubtract: faSubtract,
  faFireFlame: faFireFlame,
  faFlame: faFlame,
  faRightToLine: faRightToLine,
  faArrowAltToRight: faArrowAltToRight,
  faGif: faGif,
  faChess: faChess,
  faTrashSlash: faTrashSlash,
  faArrowLeftLong: faArrowLeftLong,
  faLongArrowLeft: faLongArrowLeft,
  faPlugCircleCheck: faPlugCircleCheck,
  faFontCase: faFontCase,
  faStreetView: faStreetView,
  faArrowDownLeft: faArrowDownLeft,
  faFrancSign: faFrancSign,
  faFlaskRoundPoison: faFlaskRoundPoison,
  faFlaskPoison: faFlaskPoison,
  faVolumeOff: faVolumeOff,
  faBookCircleArrowRight: faBookCircleArrowRight,
  faChartUser: faChartUser,
  faUserChart: faUserChart,
  faHandsAslInterpreting: faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAslInterpreting: faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen: faPresentationScreen,
  faPresentation: faPresentation,
  faCircleBolt: faCircleBolt,
  faFaceSmileHalo: faFaceSmileHalo,
  faCartCircleArrowDown: faCartCircleArrowDown,
  faHousePersonReturn: faHousePersonReturn,
  faHousePersonArrive: faHousePersonArrive,
  faHouseReturn: faHouseReturn,
  faMessageXmark: faMessageXmark,
  faCommentAltTimes: faCommentAltTimes,
  faMessageTimes: faMessageTimes,
  faFileCertificate: faFileCertificate,
  faFileAward: faFileAward,
  faUserDoctorHairLong: faUserDoctorHairLong,
  faCameraSecurity: faCameraSecurity,
  faCameraHome: faCameraHome,
  faGear: faGear,
  faCog: faCog,
  faDropletSlash: faDropletSlash,
  faTintSlash: faTintSlash,
  faBookHeart: faBookHeart,
  faMosque: faMosque,
  faDuck: faDuck,
  faMosquito: faMosquito,
  faStarOfDavid: faStarOfDavid,
  faFlagSwallowtail: faFlagSwallowtail,
  faFlagAlt: faFlagAlt,
  faPersonMilitaryRifle: faPersonMilitaryRifle,
  faCarGarage: faCarGarage,
  faCartShopping: faCartShopping,
  faShoppingCart: faShoppingCart,
  faBookFont: faBookFont,
  faShieldPlus: faShieldPlus,
  faVials: faVials,
  faEyeDropperFull: faEyeDropperFull,
  faDistributeSpacingHorizontal: faDistributeSpacingHorizontal,
  faTabletRugged: faTabletRugged,
  faTemperatureSnow: faTemperatureSnow,
  faTemperatureFrigid: faTemperatureFrigid,
  faMoped: faMoped,
  faFaceSmilePlus: faFaceSmilePlus,
  faSmilePlus: faSmilePlus,
  faRadioTuner: faRadioTuner,
  faRadioAlt: faRadioAlt,
  faFaceSwear: faFaceSwear,
  faWaterArrowDown: faWaterArrowDown,
  faWaterLower: faWaterLower,
  faScannerTouchscreen: faScannerTouchscreen,
  faCircle7: faCircle7,
  faPlugCirclePlus: faPlugCirclePlus,
  faPersonSkiJumping: faPersonSkiJumping,
  faSkiJump: faSkiJump,
  faPlaceOfWorship: faPlaceOfWorship,
  faWaterArrowUp: faWaterArrowUp,
  faWaterRise: faWaterRise,
  faWaveformLines: faWaveformLines,
  faWaveformPath: faWaveformPath,
  faSplit: faSplit,
  faFilmCanister: faFilmCanister,
  faFilmCannister: faFilmCannister,
  faFolderXmark: faFolderXmark,
  faFolderTimes: faFolderTimes,
  faToiletPaperBlank: faToiletPaperBlank,
  faToiletPaperAlt: faToiletPaperAlt,
  faTabletScreen: faTabletScreen,
  faTabletAndroidAlt: faTabletAndroidAlt,
  faHexagonVerticalNftSlanted: faHexagonVerticalNftSlanted,
  faFolderMusic: faFolderMusic,
  faDisplayMedical: faDisplayMedical,
  faDesktopMedical: faDesktopMedical,
  faShareAll: faShareAll,
  faPeapod: faPeapod,
  faChessClock: faChessClock,
  faAxe: faAxe,
  faSquareD: faSquareD,
  faGripVertical: faGripVertical,
  faMobileSignalOut: faMobileSignalOut,
  faArrowTurnUp: faArrowTurnUp,
  faLevelUp: faLevelUp,
  faU: faU,
  faArrowUpFromDottedLine: faArrowUpFromDottedLine,
  faSquareRootVariable: faSquareRootVariable,
  faSquareRootAlt: faSquareRootAlt,
  faLightSwitchOn: faLightSwitchOn,
  faArrowDownArrowUp: faArrowDownArrowUp,
  faSortAlt: faSortAlt,
  faRaindrops: faRaindrops,
  faDash: faDash,
  faMinusLarge: faMinusLarge,
  faClock: faClock,
  faClockFour: faClockFour,
  faInputNumeric: faInputNumeric,
  faTruckTow: faTruckTow,
  faBackwardStep: faBackwardStep,
  faStepBackward: faStepBackward,
  faPallet: faPallet,
  faCarBolt: faCarBolt,
  faArrowsMaximize: faArrowsMaximize,
  faExpandArrows: faExpandArrows,
  faFaucet: faFaucet,
  faCloudSleet: faCloudSleet,
  faLampStreet: faLampStreet,
  faListRadio: faListRadio,
  faPenNibSlash: faPenNibSlash,
  faBaseballBatBall: faBaseballBatBall,
  faSquareUpLeft: faSquareUpLeft,
  faOverline: faOverline,
  faS: faS,
  faTimeline: faTimeline,
  faKeyboard: faKeyboard,
  faArrowsFromDottedLine: faArrowsFromDottedLine,
  faUsbDrive: faUsbDrive,
  faBallot: faBallot,
  faCaretDown: faCaretDown,
  faLocationDotSlash: faLocationDotSlash,
  faMapMarkerAltSlash: faMapMarkerAltSlash,
  faCards: faCards,
  faHouseChimneyMedical: faHouseChimneyMedical,
  faClinicMedical: faClinicMedical,
  faBoxingGlove: faBoxingGlove,
  faGloveBoxing: faGloveBoxing,
  faTemperatureThreeQuarters: faTemperatureThreeQuarters,
  faTemperature3: faTemperature3,
  faThermometer3: faThermometer3,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faBellSchool: faBellSchool,
  faMobileScreen: faMobileScreen,
  faMobileAndroidAlt: faMobileAndroidAlt,
  faPlaneUp: faPlaneUp,
  faFolderHeart: faFolderHeart,
  faCircleLocationArrow: faCircleLocationArrow,
  faLocationCircle: faLocationCircle,
  faFaceHeadBandage: faFaceHeadBandage,
  faSushiRoll: faSushiRoll,
  faMakiRoll: faMakiRoll,
  faMakizushi: faMakizushi,
  faCarBump: faCarBump,
  faPiggyBank: faPiggyBank,
  faRacquet: faRacquet,
  faCarMirrors: faCarMirrors,
  faIndustryWindows: faIndustryWindows,
  faIndustryAlt: faIndustryAlt,
  faBoltAuto: faBoltAuto,
  faBatteryHalf: faBatteryHalf,
  faBattery3: faBattery3,
  faFluxCapacitor: faFluxCapacitor,
  faMountainCity: faMountainCity,
  faCoins: faCoins,
  faHoneyPot: faHoneyPot,
  faOlive: faOlive,
  faKhanda: faKhanda,
  faFilterList: faFilterList,
  faOutlet: faOutlet,
  faSliders: faSliders,
  faSlidersH: faSlidersH,
  faCauldron: faCauldron,
  faPeople: faPeople,
  faFolderTree: faFolderTree,
  faNetworkWired: faNetworkWired,
  faCroissant: faCroissant,
  faMapPin: faMapPin,
  faHamsa: faHamsa,
  faCentSign: faCentSign,
  faSwordsLaser: faSwordsLaser,
  faFlask: faFlask,
  faPersonPregnant: faPersonPregnant,
  faSquareU: faSquareU,
  faWandSparkles: faWandSparkles,
  faRouter: faRouter,
  faEllipsisVertical: faEllipsisVertical,
  faEllipsisV: faEllipsisV,
  faSwordLaserAlt: faSwordLaserAlt,
  faTicket: faTicket,
  faPowerOff: faPowerOff,
  faCoin: faCoin,
  faLaptopSlash: faLaptopSlash,
  faRightLong: faRightLong,
  faLongArrowAltRight: faLongArrowAltRight,
  faCircleB: faCircleB,
  faPersonDressSimple: faPersonDressSimple,
  faPipeCollar: faPipeCollar,
  faLightsHoliday: faLightsHoliday,
  faCitrus: faCitrus,
  faFlagUsa: faFlagUsa,
  faLaptopFile: faLaptopFile,
  faTty: faTty,
  faTeletype: faTeletype,
  faChartTreeMap: faChartTreeMap,
  faDiagramNext: faDiagramNext,
  faPersonRifle: faPersonRifle,
  faClockFiveThirty: faClockFiveThirty,
  faPipeValve: faPipeValve,
  faArrowUpFromArc: faArrowUpFromArc,
  faFaceSpiralEyes: faFaceSpiralEyes,
  faCompressWide: faCompressWide,
  faCirclePhoneHangup: faCirclePhoneHangup,
  faPhoneCircleDown: faPhoneCircleDown,
  faGearComplexCode: faGearComplexCode,
  faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
  faBadminton: faBadminton,
  faClosedCaptioning: faClosedCaptioning,
  faPersonHiking: faPersonHiking,
  faHiking: faHiking,
  faRightFromLine: faRightFromLine,
  faArrowAltFromLeft: faArrowAltFromLeft,
  faVenusDouble: faVenusDouble,
  faImages: faImages,
  faCalculator: faCalculator,
  faShuttlecock: faShuttlecock,
  faUserHair: faUserHair,
  faEyeEvil: faEyeEvil,
  faPeoplePulling: faPeoplePulling,
  faN: faN,
  faSwap: faSwap,
  faGarage: faGarage,
  faCableCar: faCableCar,
  faTram: faTram,
  faShovelSnow: faShovelSnow,
  faCloudRain: faCloudRain,
  faFaceLying: faFaceLying,
  faSprinkler: faSprinkler,
  faBuildingCircleXmark: faBuildingCircleXmark,
  faPersonSledding: faPersonSledding,
  faSledding: faSledding,
  faGameConsoleHandheld: faGameConsoleHandheld,
  faShip: faShip,
  faClockSixThirty: faClockSixThirty,
  faBatterySlash: faBatterySlash,
  faTugrikSign: faTugrikSign,
  faArrowsDownToLine: faArrowsDownToLine,
  faDownload: faDownload,
  faAnglesUpDown: faAnglesUpDown,
  faShelves: faShelves,
  faInventory: faInventory,
  faCloudSnow: faCloudSnow,
  faFaceGrin: faFaceGrin,
  faGrin: faGrin,
  faDeleteLeft: faDeleteLeft,
  faBackspace: faBackspace,
  faOven: faOven,
  faCloudBinary: faCloudBinary,
  faEyeDropper: faEyeDropper,
  faEyeDropperEmpty: faEyeDropperEmpty,
  faEyedropper: faEyedropper,
  faCommentCaptions: faCommentCaptions,
  faCommentsQuestion: faCommentsQuestion,
  faScribble: faScribble,
  faRotateExclamation: faRotateExclamation,
  faFileCircleCheck: faFileCircleCheck,
  faGlass: faGlass,
  faLoader: faLoader,
  faForward: faForward,
  faUserPilot: faUserPilot,
  faMobile: faMobile,
  faMobileAndroid: faMobileAndroid,
  faMobilePhone: faMobilePhone,
  faCodePullRequestClosed: faCodePullRequestClosed,
  faFaceMeh: faFaceMeh,
  faMeh: faMeh,
  faAlignCenter: faAlignCenter,
  faBookSkull: faBookSkull,
  faBookDead: faBookDead,
  faIdCard: faIdCard,
  faDriversLicense: faDriversLicense,
  faFaceDotted: faFaceDotted,
  faFaceWorried: faFaceWorried,
  faOutdent: faOutdent,
  faDedent: faDedent,
  faHeartCircleExclamation: faHeartCircleExclamation,
  faHouse: faHouse,
  faHome: faHome,
  faHomeAlt: faHomeAlt,
  faHomeLgAlt: faHomeLgAlt,
  faVectorCircle: faVectorCircle,
  faCarCircleBolt: faCarCircleBolt,
  faCalendarWeek: faCalendarWeek,
  faFlyingDisc: faFlyingDisc,
  faLaptopMedical: faLaptopMedical,
  faSquareDownRight: faSquareDownRight,
  faB: faB,
  faSeatAirline: faSeatAirline,
  faMoonOverSun: faMoonOverSun,
  faEclipseAlt: faEclipseAlt,
  faPipe: faPipe,
  faFileMedical: faFileMedical,
  faPotato: faPotato,
  faDiceOne: faDiceOne,
  faCircleA: faCircleA,
  faHelmetBattle: faHelmetBattle,
  faButter: faButter,
  faBlanketFire: faBlanketFire,
  faKiwiBird: faKiwiBird,
  faCastle: faCastle,
  faGolfClub: faGolfClub,
  faArrowRightArrowLeft: faArrowRightArrowLeft,
  faExchange: faExchange,
  faRotateRight: faRotateRight,
  faRedoAlt: faRedoAlt,
  faRotateForward: faRotateForward,
  faUtensils: faUtensils,
  faCutlery: faCutlery,
  faArrowUpWideShort: faArrowUpWideShort,
  faSortAmountUp: faSortAmountUp,
  faChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar,
  faBalloons: faBalloons,
  faMillSign: faMillSign,
  faBowlRice: faBowlRice,
  faTimelineArrow: faTimelineArrow,
  faSkull: faSkull,
  faGameBoardSimple: faGameBoardSimple,
  faGameBoardAlt: faGameBoardAlt,
  faCircleVideo: faCircleVideo,
  faVideoCircle: faVideoCircle,
  faChartScatterBubble: faChartScatterBubble,
  faHouseTurret: faHouseTurret,
  faBanana: faBanana,
  faHandHoldingSkull: faHandHoldingSkull,
  faPeopleDress: faPeopleDress,
  faLoveseat: faLoveseat,
  faCouchSmall: faCouchSmall,
  faTowerBroadcast: faTowerBroadcast,
  faBroadcastTower: faBroadcastTower,
  faTruckPickup: faTruckPickup,
  faBlockQuote: faBlockQuote,
  faUpLong: faUpLong,
  faLongArrowAltUp: faLongArrowAltUp,
  faStop: faStop,
  faCodeMerge: faCodeMerge,
  faMoneyCheckDollarPen: faMoneyCheckDollarPen,
  faMoneyCheckEditAlt: faMoneyCheckEditAlt,
  faUpFromLine: faUpFromLine,
  faArrowAltFromBottom: faArrowAltFromBottom,
  faUpload: faUpload,
  faHurricane: faHurricane,
  faGridRound2Plus: faGridRound2Plus,
  faPeoplePants: faPeoplePants,
  faMound: faMound,
  faWindsock: faWindsock,
  faCircleHalf: faCircleHalf,
  faBrakeWarning: faBrakeWarning,
  faToiletPortable: faToiletPortable,
  faCompactDisc: faCompactDisc,
  faFileArrowDown: faFileArrowDown,
  faFileDownload: faFileDownload,
  faSaxophoneFire: faSaxophoneFire,
  faSaxHot: faSaxHot,
  faCameraWebSlash: faCameraWebSlash,
  faWebcamSlash: faWebcamSlash,
  faFolderMedical: faFolderMedical,
  faFolderGear: faFolderGear,
  faFolderCog: faFolderCog,
  faHandWave: faHandWave,
  faArrowUpArrowDown: faArrowUpArrowDown,
  faSortUpDown: faSortUpDown,
  faCaravan: faCaravan,
  faShieldCat: faShieldCat,
  faMessageSlash: faMessageSlash,
  faCommentAltSlash: faCommentAltSlash,
  faBolt: faBolt,
  faZap: faZap,
  faTrashCanCheck: faTrashCanCheck,
  faGlassWater: faGlassWater,
  faOilWell: faOilWell,
  faPersonSimple: faPersonSimple,
  faVault: faVault,
  faMars: faMars,
  faToilet: faToilet,
  faPlaneCircleXmark: faPlaneCircleXmark,
  faYenSign: faYenSign,
  faCny: faCny,
  faJpy: faJpy,
  faRmb: faRmb,
  faYen: faYen,
  faGearCode: faGearCode,
  faNotes: faNotes,
  faRubleSign: faRubleSign,
  faRouble: faRouble,
  faRub: faRub,
  faRuble: faRuble,
  faTrashUndo: faTrashUndo,
  faTrashArrowTurnLeft: faTrashArrowTurnLeft,
  faChampagneGlass: faChampagneGlass,
  faGlassChampagne: faGlassChampagne,
  faObjectsAlignCenterHorizontal: faObjectsAlignCenterHorizontal,
  faSun: faSun,
  faTrashCanSlash: faTrashCanSlash,
  faTrashAltSlash: faTrashAltSlash,
  faScreenUsers: faScreenUsers,
  faUsersClass: faUsersClass,
  faGuitar: faGuitar,
  faSquareArrowLeft: faSquareArrowLeft,
  faArrowSquareLeft: faArrowSquareLeft,
  faSquare8: faSquare8,
  faFaceSmileHearts: faFaceSmileHearts,
  faBracketsSquare: faBracketsSquare,
  faBrackets: faBrackets,
  faLaptopArrowDown: faLaptopArrowDown,
  faHockeyStickPuck: faHockeyStickPuck,
  faHouseTree: faHouseTree,
  faSignalFair: faSignalFair,
  faSignal2: faSignal2,
  faFaceLaughWink: faFaceLaughWink,
  faLaughWink: faLaughWink,
  faCircleDollar: faCircleDollar,
  faDollarCircle: faDollarCircle,
  faUsdCircle: faUsdCircle,
  faHorseHead: faHorseHead,
  faArrowsRepeat: faArrowsRepeat,
  faRepeatAlt: faRepeatAlt,
  faBoreHole: faBoreHole,
  faIndustry: faIndustry,
  faImagePolaroid: faImagePolaroid,
  faWaveTriangle: faWaveTriangle,
  faPersonRunningFast: faPersonRunningFast,
  faCircleDown: faCircleDown,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faGrill: faGrill,
  faArrowsTurnToDots: faArrowsTurnToDots,
  faChartMixed: faChartMixed,
  faAnalytics: faAnalytics,
  faFlorinSign: faFlorinSign,
  faArrowDownShortWide: faArrowDownShortWide,
  faSortAmountDesc: faSortAmountDesc,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faLessThan: faLessThan,
  faDisplayCode: faDisplayCode,
  faDesktopCode: faDesktopCode,
  faFaceDrooling: faFaceDrooling,
  faOilTemperature: faOilTemperature,
  faOilTemp: faOilTemp,
  faSquareQuestion: faSquareQuestion,
  faQuestionSquare: faQuestionSquare,
  faAirConditioner: faAirConditioner,
  faAngleDown: faAngleDown,
  faMountains: faMountains,
  faOmega: faOmega,
  faCarTunnel: faCarTunnel,
  faPersonDollyEmpty: faPersonDollyEmpty,
  faPanFood: faPanFood,
  faHeadSideCough: faHeadSideCough,
  faGripLines: faGripLines,
  faThumbsDown: faThumbsDown,
  faUserLock: faUserLock,
  faArrowRightLong: faArrowRightLong,
  faLongArrowRight: faLongArrowRight,
  faTicketsAirline: faTicketsAirline,
  faAnchorCircleXmark: faAnchorCircleXmark,
  faEllipsis: faEllipsis,
  faEllipsisH: faEllipsisH,
  faNfcSlash: faNfcSlash,
  faChessPawn: faChessPawn,
  faKitMedical: faKitMedical,
  faFirstAid: faFirstAid,
  faGrid2Plus: faGrid2Plus,
  faBells: faBells,
  faPersonThroughWindow: faPersonThroughWindow,
  faToolbox: faToolbox,
  faEnvelopeDot: faEnvelopeDot,
  faEnvelopeBadge: faEnvelopeBadge,
  faHandsHoldingCircle: faHandsHoldingCircle,
  faBug: faBug,
  faBowlChopsticks: faBowlChopsticks,
  faCreditCard: faCreditCard,
  faCreditCardAlt: faCreditCardAlt,
  faCircleS: faCircleS,
  faBoxBallot: faBoxBallot,
  faCar: faCar,
  faAutomobile: faAutomobile,
  faHandHoldingHand: faHandHoldingHand,
  faUserTieHair: faUserTieHair,
  faPodiumStar: faPodiumStar,
  faUserHairMullet: faUserHairMullet,
  faBusinessFront: faBusinessFront,
  faPartyBack: faPartyBack,
  faTrianBalbot: faTrianBalbot,
  faMicrophoneStand: faMicrophoneStand,
  faBookOpenReader: faBookOpenReader,
  faBookReader: faBookReader,
  faFamilyDress: faFamilyDress,
  faCircleX: faCircleX,
  faCabin: faCabin,
  faMountainSun: faMountainSun,
  faChartSimpleHorizontal: faChartSimpleHorizontal,
  faBluetooth: faBluetooth,
  faArrowsLeftRightToLine: faArrowsLeftRightToLine,
  faHandBackPointLeft: faHandBackPointLeft,
  faMessageDots: faMessageDots,
  faCommentAltDots: faCommentAltDots,
  faMessaging: faMessaging,
  faFileHeart: faFileHeart,
  faBeerMug: faBeerMug,
  faBeerFoam: faBeerFoam,
  faDiceD20: faDiceD20,
  faDrone: faDrone,
  faTruckDroplet: faTruckDroplet,
  faFileCircleXmark: faFileCircleXmark,
  faTemperatureArrowUp: faTemperatureArrowUp,
  faTemperatureUp: faTemperatureUp,
  faMedal: faMedal,
  faPersonFairy: faPersonFairy,
  faBed: faBed,
  faBookCopy: faBookCopy,
  faSquareH: faSquareH,
  faHSquare: faHSquare,
  faSquareC: faSquareC,
  faClockTwo: faClockTwo,
  faSquareEllipsisVertical: faSquareEllipsisVertical,
  faCalendarUsers: faCalendarUsers,
  faPodcast: faPodcast,
  faBee: faBee,
  faTemperatureFull: faTemperatureFull,
  faTemperature4: faTemperature4,
  faThermometer4: faThermometer4,
  faThermometerFull: faThermometerFull,
  faBell: faBell,
  faCandyBar: faCandyBar,
  faChocolateBar: faChocolateBar,
  faXmarkLarge: faXmarkLarge,
  faPinata: faPinata,
  faArrowsFromLine: faArrowsFromLine,
  faSuperscript: faSuperscript,
  faBowlSpoon: faBowlSpoon,
  faHexagonCheck: faHexagonCheck,
  faPlugCircleXmark: faPlugCircleXmark,
  faStarOfLife: faStarOfLife,
  faPhoneSlash: faPhoneSlash,
  faTrafficLightStop: faTrafficLightStop,
  faPaintRoller: faPaintRoller,
  faAccentGrave: faAccentGrave,
  faHandshakeAngle: faHandshakeAngle,
  faHandsHelping: faHandsHelping,
  faCircle0: faCircle0,
  faDialMedLow: faDialMedLow,
  faLocationDot: faLocationDot,
  faMapMarkerAlt: faMapMarkerAlt,
  faCrab: faCrab,
  faBoxOpenFull: faBoxOpenFull,
  faBoxFull: faBoxFull,
  faFile: faFile,
  faGreaterThan: faGreaterThan,
  faQuotes: faQuotes,
  faPretzel: faPretzel,
  faPersonSwimming: faPersonSwimming,
  faSwimmer: faSwimmer,
  faArrowDown: faArrowDown,
  faUserRobotXmarks: faUserRobotXmarks,
  faMessageQuote: faMessageQuote,
  faCommentAltQuote: faCommentAltQuote,
  faCandyCorn: faCandyCorn,
  faFolderMagnifyingGlass: faFolderMagnifyingGlass,
  faFolderSearch: faFolderSearch,
  faNotebook: faNotebook,
  faDroplet: faDroplet,
  faTint: faTint,
  faBullseyePointer: faBullseyePointer,
  faEraser: faEraser,
  faHexagonImage: faHexagonImage,
  faEarthAmericas: faEarthAmericas,
  faEarth: faEarth,
  faEarthAmerica: faEarthAmerica,
  faGlobeAmericas: faGlobeAmericas,
  faCrateApple: faCrateApple,
  faAppleCrate: faAppleCrate,
  faPersonBurst: faPersonBurst,
  faGameBoard: faGameBoard,
  faHatChef: faHatChef,
  faHandBackPointRight: faHandBackPointRight,
  faDove: faDove,
  faSnowflakeDroplets: faSnowflakeDroplets,
  faBatteryEmpty: faBatteryEmpty,
  faBattery0: faBattery0,
  faGrid4: faGrid4,
  faSocks: faSocks,
  faFaceSunglasses: faFaceSunglasses,
  faInbox: faInbox,
  faSquare0: faSquare0,
  faSection: faSection,
  faSquareThisWayUp: faSquareThisWayUp,
  faBoxUp: faBoxUp,
  faGaugeHigh: faGaugeHigh,
  faTachometerAlt: faTachometerAlt,
  faTachometerAltFast: faTachometerAltFast,
  faSquareAmpersand: faSquareAmpersand,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faLampDesk: faLampDesk,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalWide: faHospitalWide,
  faPollPeople: faPollPeople,
  faWhiskeyGlassIce: faWhiskeyGlassIce,
  faGlassWhiskeyRocks: faGlassWhiskeyRocks,
  faWineBottle: faWineBottle,
  faChessRook: faChessRook,
  faUserBountyHunter: faUserBountyHunter,
  faBarsStaggered: faBarsStaggered,
  faReorder: faReorder,
  faStream: faStream,
  faDiagramSankey: faDiagramSankey,
  faCloudHailMixed: faCloudHailMixed,
  faCircleUpLeft: faCircleUpLeft,
  faDharmachakra: faDharmachakra,
  faObjectsAlignLeft: faObjectsAlignLeft,
  faOilCanDrip: faOilCanDrip,
  faFaceSmilingHands: faFaceSmilingHands,
  faBroccoli: faBroccoli,
  faRouteInterstate: faRouteInterstate,
  faEarMuffs: faEarMuffs,
  faHotdog: faHotdog,
  faTransporterEmpty: faTransporterEmpty,
  faPersonWalkingWithCane: faPersonWalkingWithCane,
  faBlind: faBlind,
  faAngle90: faAngle90,
  faRectangleTerminal: faRectangleTerminal,
  faKite: faKite,
  faDrum: faDrum,
  faScrubber: faScrubber,
  faIceCream: faIceCream,
  faHeartCircleBolt: faHeartCircleBolt,
  faFishBones: faFishBones,
  faDeerRudolph: faDeerRudolph,
  faFax: faFax,
  faParagraph: faParagraph,
  faHeadSideHeart: faHeadSideHeart,
  faSquareE: faSquareE,
  faMeterFire: faMeterFire,
  faCloudHail: faCloudHail,
  faCheckToSlot: faCheckToSlot,
  faVoteYea: faVoteYea,
  faMoneyFromBracket: faMoneyFromBracket,
  faStarHalf: faStarHalf,
  faCarBus: faCarBus,
  faSpeaker: faSpeaker,
  faTimer: faTimer,
  faBoxesStacked: faBoxesStacked,
  faBoxes: faBoxes,
  faBoxesAlt: faBoxesAlt,
  faGrillHot: faGrillHot,
  faBallotCheck: faBallotCheck,
  faLink: faLink,
  faChain: faChain,
  faEarListen: faEarListen,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faFileMinus: faFileMinus,
  faTreeCity: faTreeCity,
  faPlay: faPlay,
  faFont: faFont,
  faCupTogo: faCupTogo,
  faCoffeeTogo: faCoffeeTogo,
  faSquareDownLeft: faSquareDownLeft,
  faBurgerLettuce: faBurgerLettuce,
  faRupiahSign: faRupiahSign,
  faMagnifyingGlass: faMagnifyingGlass,
  faSearch: faSearch,
  faTableTennisPaddleBall: faTableTennisPaddleBall,
  faPingPongPaddleBall: faPingPongPaddleBall,
  faTableTennis: faTableTennis,
  faPersonDotsFromLine: faPersonDotsFromLine,
  faDiagnoses: faDiagnoses,
  faChevronsDown: faChevronsDown,
  faChevronDoubleDown: faChevronDoubleDown,
  faTrashCanArrowUp: faTrashCanArrowUp,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faSignalGood: faSignalGood,
  faSignal3: faSignal3,
  faLocationQuestion: faLocationQuestion,
  faMapMarkerQuestion: faMapMarkerQuestion,
  faFloppyDiskCircleXmark: faFloppyDiskCircleXmark,
  faFloppyDiskTimes: faFloppyDiskTimes,
  faSaveCircleXmark: faSaveCircleXmark,
  faSaveTimes: faSaveTimes,
  faNairaSign: faNairaSign,
  faPeach: faPeach,
  faTaxiBus: faTaxiBus,
  faBracketCurly: faBracketCurly,
  faBracketCurlyLeft: faBracketCurlyLeft,
  faLobster: faLobster,
  faCartFlatbedEmpty: faCartFlatbedEmpty,
  faDollyFlatbedEmpty: faDollyFlatbedEmpty,
  faColon: faColon,
  faCartArrowDown: faCartArrowDown,
  faWand: faWand,
  faWalkieTalkie: faWalkieTalkie,
  faFilePen: faFilePen,
  faFileEdit: faFileEdit,
  faReceipt: faReceipt,
  faTablePicnic: faTablePicnic,
  faSquarePen: faSquarePen,
  faPenSquare: faPenSquare,
  faPencilSquare: faPencilSquare,
  faCircleMicrophoneLines: faCircleMicrophoneLines,
  faMicrophoneCircleAlt: faMicrophoneCircleAlt,
  faDisplaySlash: faDisplaySlash,
  faDesktopSlash: faDesktopSlash,
  faSuitcaseRolling: faSuitcaseRolling,
  faPersonCircleExclamation: faPersonCircleExclamation,
  faTransporter2: faTransporter2,
  faHandsHoldingDiamond: faHandsHoldingDiamond,
  faHandReceiving: faHandReceiving,
  faMoneyBillSimpleWave: faMoneyBillSimpleWave,
  faChevronDown: faChevronDown,
  faBatteryFull: faBatteryFull,
  faBattery: faBattery,
  faBattery5: faBattery5,
  faBellPlus: faBellPlus,
  faBookArrowRight: faBookArrowRight,
  faHospitals: faHospitals,
  faClub: faClub,
  faSkullCrossbones: faSkullCrossbones,
  faDropletDegree: faDropletDegree,
  faDewpoint: faDewpoint,
  faCodeCompare: faCodeCompare,
  faListUl: faListUl,
  faListDots: faListDots,
  faHandHoldingMagic: faHandHoldingMagic,
  faWatermelonSlice: faWatermelonSlice,
  faCircleEllipsis: faCircleEllipsis,
  faSchoolLock: faSchoolLock,
  faTowerCell: faTowerCell,
  faSdCards: faSdCards,
  faJugBottle: faJugBottle,
  faDownLong: faDownLong,
  faLongArrowAltDown: faLongArrowAltDown,
  faEnvelopes: faEnvelopes,
  faPhoneOffice: faPhoneOffice,
  faRankingStar: faRankingStar,
  faChessKing: faChessKing,
  faNfcPen: faNfcPen,
  faPersonHarassing: faPersonHarassing,
  faHatWinter: faHatWinter,
  faBrazilianRealSign: faBrazilianRealSign,
  faLandmarkDome: faLandmarkDome,
  faLandmarkAlt: faLandmarkAlt,
  faBoneBreak: faBoneBreak,
  faArrowUp: faArrowUp,
  faDownFromDottedLine: faDownFromDottedLine,
  faTv: faTv,
  faTelevision: faTelevision,
  faTvAlt: faTvAlt,
  faBorderLeft: faBorderLeft,
  faCircleDivide: faCircleDivide,
  faShrimp: faShrimp,
  faListCheck: faListCheck,
  faTasks: faTasks,
  faDiagramSubtask: faDiagramSubtask,
  faJugDetergent: faJugDetergent,
  faCircleUser: faCircleUser,
  faUserCircle: faUserCircle,
  faSquareY: faSquareY,
  faUserDoctorHair: faUserDoctorHair,
  faPlanetRinged: faPlanetRinged,
  faMushroom: faMushroom,
  faUserShield: faUserShield,
  faMegaphone: faMegaphone,
  faWreathLaurel: faWreathLaurel,
  faCircleExclamationCheck: faCircleExclamationCheck,
  faWind: faWind,
  faBoxDollar: faBoxDollar,
  faBoxUsd: faBoxUsd,
  faCarBurst: faCarBurst,
  faCarCrash: faCarCrash,
  faY: faY,
  faUserHeadset: faUserHeadset,
  faArrowsRetweet: faArrowsRetweet,
  faRetweetAlt: faRetweetAlt,
  faPersonSnowboarding: faPersonSnowboarding,
  faSnowboarding: faSnowboarding,
  faSquareChevronRight: faSquareChevronRight,
  faChevronSquareRight: faChevronSquareRight,
  faLacrosseStickBall: faLacrosseStickBall,
  faTruckFast: faTruckFast,
  faShippingFast: faShippingFast,
  faUserMagnifyingGlass: faUserMagnifyingGlass,
  faStarSharp: faStarSharp,
  faCommentHeart: faCommentHeart,
  faCircle1: faCircle1,
  faCircleStar: faCircleStar,
  faStarCircle: faStarCircle,
  faFish: faFish,
  faCloudFog: faCloudFog,
  faFog: faFog,
  faWaffle: faWaffle,
  faMusicNote: faMusicNote,
  faMusicAlt: faMusicAlt,
  faHexagonExclamation: faHexagonExclamation,
  faCartShoppingFast: faCartShoppingFast,
  faObjectUnion: faObjectUnion,
  faUserGraduate: faUserGraduate,
  faStarfighter: faStarfighter,
  faCircleHalfStroke: faCircleHalfStroke,
  faAdjust: faAdjust,
  faArrowRightLongToLine: faArrowRightLongToLine,
  faSquareArrowDown: faSquareArrowDown,
  faArrowSquareDown: faArrowSquareDown,
  faDiamondHalfStroke: faDiamondHalfStroke,
  faClapperboard: faClapperboard,
  faSquareChevronLeft: faSquareChevronLeft,
  faChevronSquareLeft: faChevronSquareLeft,
  faPhoneIntercom: faPhoneIntercom,
  faLinkHorizontal: faLinkHorizontal,
  faChainHorizontal: faChainHorizontal,
  faMango: faMango,
  faMusicNoteSlash: faMusicNoteSlash,
  faMusicAltSlash: faMusicAltSlash,
  faCircleRadiation: faCircleRadiation,
  faRadiationAlt: faRadiationAlt,
  faFaceTongueSweat: faFaceTongueSweat,
  faGlobeStand: faGlobeStand,
  faBaseball: faBaseball,
  faBaseballBall: faBaseballBall,
  faCircleP: faCircleP,
  faAwardSimple: faAwardSimple,
  faJetFighterUp: faJetFighterUp,
  faDiagramProject: faDiagramProject,
  faProjectDiagram: faProjectDiagram,
  faPedestal: faPedestal,
  faChartPyramid: faChartPyramid,
  faSidebar: faSidebar,
  faSnowmanHead: faSnowmanHead,
  faFrostyHead: faFrostyHead,
  faCopy: faCopy,
  faBurgerGlass: faBurgerGlass,
  faVolumeXmark: faVolumeXmark,
  faVolumeMute: faVolumeMute,
  faVolumeTimes: faVolumeTimes,
  faHandSparkles: faHandSparkles,
  faBarsFilter: faBarsFilter,
  faPaintbrushPencil: faPaintbrushPencil,
  faPartyBell: faPartyBell,
  faUserVneckHair: faUserVneckHair,
  faJackOLantern: faJackOLantern,
  faGrip: faGrip,
  faGripHorizontal: faGripHorizontal,
  faShareFromSquare: faShareFromSquare,
  faShareSquare: faShareSquare,
  faKeynote: faKeynote,
  faChildCombatant: faChildCombatant,
  faChildRifle: faChildRifle,
  faGun: faGun,
  faSquarePhone: faSquarePhone,
  faPhoneSquare: faPhoneSquare,
  faHatBeach: faHatBeach,
  faPlus: faPlus,
  faAdd: faAdd,
  faExpand: faExpand,
  faComputer: faComputer,
  faFort: faFort,
  faCloudCheck: faCloudCheck,
  faXmark: faXmark,
  faClose: faClose,
  faMultiply: faMultiply,
  faRemove: faRemove,
  faTimes: faTimes,
  faFaceSmirking: faFaceSmirking,
  faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  faArrows: faArrows,
  faChalkboardUser: faChalkboardUser,
  faChalkboardTeacher: faChalkboardTeacher,
  faRhombus: faRhombus,
  faClawMarks: faClawMarks,
  faPesoSign: faPesoSign,
  faFaceSmileTongue: faFaceSmileTongue,
  faCartCircleXmark: faCartCircleXmark,
  faBuildingShield: faBuildingShield,
  faCirclePhoneFlip: faCirclePhoneFlip,
  faPhoneCircleAlt: faPhoneCircleAlt,
  faBaby: faBaby,
  faUsersLine: faUsersLine,
  faQuoteLeft: faQuoteLeft,
  faQuoteLeftAlt: faQuoteLeftAlt,
  faTractor: faTractor,
  faKeySkeleton: faKeySkeleton,
  faTrashArrowUp: faTrashArrowUp,
  faTrashRestore: faTrashRestore,
  faArrowDownUpLock: faArrowDownUpLock,
  faArrowDownToBracket: faArrowDownToBracket,
  faLinesLeaning: faLinesLeaning,
  faSquareQ: faSquareQ,
  faRulerCombined: faRulerCombined,
  faSymbols: faSymbols,
  faIconsAlt: faIconsAlt,
  faCopyright: faCopyright,
  faFlaskGear: faFlaskGear,
  faHighlighterLine: faHighlighterLine,
  faBracketSquare: faBracketSquare,
  faBracket: faBracket,
  faBracketLeft: faBracketLeft,
  faIslandTropical: faIslandTropical,
  faIslandTreePalm: faIslandTreePalm,
  faArrowRightFromLine: faArrowRightFromLine,
  faArrowFromLeft: faArrowFromLeft,
  faH2: faH2,
  faEquals: faEquals,
  faCakeSlice: faCakeSlice,
  faShortcake: faShortcake,
  faPeanut: faPeanut,
  faWrenchSimple: faWrenchSimple,
  faBlender: faBlender,
  faTeeth: faTeeth,
  faTally2: faTally2,
  faShekelSign: faShekelSign,
  faIls: faIls,
  faShekel: faShekel,
  faSheqel: faSheqel,
  faSheqelSign: faSheqelSign,
  faCars: faCars,
  faAxeBattle: faAxeBattle,
  faUserHairLong: faUserHairLong,
  faMap: faMap,
  faArrowLeftFromArc: faArrowLeftFromArc,
  faFileCircleInfo: faFileCircleInfo,
  faFaceDisappointed: faFaceDisappointed,
  faLassoSparkles: faLassoSparkles,
  faClockEleven: faClockEleven,
  faRocket: faRocket,
  faSirenOn: faSirenOn,
  faClockTen: faClockTen,
  faCandleHolder: faCandleHolder,
  faVideoArrowDownLeft: faVideoArrowDownLeft,
  faPhotoFilm: faPhotoFilm,
  faPhotoVideo: faPhotoVideo,
  faFloppyDiskCircleArrowRight: faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight: faSaveCircleArrowRight,
  faFolderMinus: faFolderMinus,
  faPlanetMoon: faPlanetMoon,
  faFaceEyesXmarks: faFaceEyesXmarks,
  faChartScatter: faChartScatter,
  faDisplayArrowDown: faDisplayArrowDown,
  faStore: faStore,
  faArrowTrendUp: faArrowTrendUp,
  faPlugCircleMinus: faPlugCircleMinus,
  faOliveBranch: faOliveBranch,
  faAngle: faAngle,
  faVacuumRobot: faVacuumRobot,
  faSignHanging: faSignHanging,
  faSign: faSign,
  faSquareDivide: faSquareDivide,
  faSignalStreamSlash: faSignalStreamSlash,
  faBezierCurve: faBezierCurve,
  faEyeDropperHalf: faEyeDropperHalf,
  faStoreLock: faStoreLock,
  faBellSlash: faBellSlash,
  faCloudBoltSun: faCloudBoltSun,
  faThunderstormSun: faThunderstormSun,
  faCameraSlash: faCameraSlash,
  faCommentQuote: faCommentQuote,
  faTablet: faTablet,
  faTabletAndroid: faTabletAndroid,
  faSchoolFlag: faSchoolFlag,
  faMessageCode: faMessageCode,
  faGlassHalf: faGlassHalf,
  faGlassHalfEmpty: faGlassHalfEmpty,
  faGlassHalfFull: faGlassHalfFull,
  faFill: faFill,
  faMessageMinus: faMessageMinus,
  faCommentAltMinus: faCommentAltMinus,
  faAngleUp: faAngleUp,
  faDinosaur: faDinosaur,
  faDrumstickBite: faDrumstickBite,
  faLinkHorizontalSlash: faLinkHorizontalSlash,
  faChainHorizontalSlash: faChainHorizontalSlash,
  faHollyBerry: faHollyBerry,
  faNose: faNose,
  faArrowLeftToArc: faArrowLeftToArc,
  faChevronLeft: faChevronLeft,
  faBacteria: faBacteria,
  faClouds: faClouds,
  faMoneyBillSimple: faMoneyBillSimple,
  faHandLizard: faHandLizard,
  faTablePivot: faTablePivot,
  faFilterSlash: faFilterSlash,
  faTrashCanUndo: faTrashCanUndo,
  faTrashCanArrowTurnLeft: faTrashCanArrowTurnLeft,
  faTrashUndoAlt: faTrashUndoAlt,
  faNotdef: faNotdef,
  faDisease: faDisease,
  faPersonToDoor: faPersonToDoor,
  faTurntable: faTurntable,
  faBriefcaseMedical: faBriefcaseMedical,
  faGenderless: faGenderless,
  faChevronRight: faChevronRight,
  faSignalWeak: faSignalWeak,
  faSignal1: faSignal1,
  faClockFive: faClockFive,
  faRetweet: faRetweet,
  faCarRear: faCarRear,
  faCarAlt: faCarAlt,
  faPumpSoap: faPumpSoap,
  faComputerClassic: faComputerClassic,
  faFrame: faFrame,
  faVideoSlash: faVideoSlash,
  faBatteryQuarter: faBatteryQuarter,
  faBattery2: faBattery2,
  faEllipsisStroke: faEllipsisStroke,
  faEllipsisHAlt: faEllipsisHAlt,
  faRadio: faRadio,
  faBabyCarriage: faBabyCarriage,
  faCarriageBaby: faCarriageBaby,
  faFaceExpressionless: faFaceExpressionless,
  faDownToDottedLine: faDownToDottedLine,
  faCloudMusic: faCloudMusic,
  faTrafficLight: faTrafficLight,
  faCloudMinus: faCloudMinus,
  faThermometer: faThermometer,
  faShieldMinus: faShieldMinus,
  faVrCardboard: faVrCardboard,
  faCarTilt: faCarTilt,
  faGaugeCircleMinus: faGaugeCircleMinus,
  faBrightnessLow: faBrightnessLow,
  faHandMiddleFinger: faHandMiddleFinger,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faTruckMoving: faTruckMoving,
  faGlassWaterDroplet: faGlassWaterDroplet,
  faConveyorBelt: faConveyorBelt,
  faLocationCheck: faLocationCheck,
  faMapMarkerCheck: faMapMarkerCheck,
  faCoinVertical: faCoinVertical,
  faDisplay: faDisplay,
  faPersonSign: faPersonSign,
  faFaceSmile: faFaceSmile,
  faSmile: faSmile,
  faPhoneHangup: faPhoneHangup,
  faSignatureSlash: faSignatureSlash,
  faThumbtack: faThumbtack,
  faThumbTack: faThumbTack,
  faWheatSlash: faWheatSlash,
  faTrophy: faTrophy,
  faCloudsSun: faCloudsSun,
  faPersonPraying: faPersonPraying,
  faPray: faPray,
  faHammer: faHammer,
  faFaceVomit: faFaceVomit,
  faSpeakers: faSpeakers,
  faTtyAnswer: faTtyAnswer,
  faTeletypeAnswer: faTeletypeAnswer,
  faMugTeaSaucer: faMugTeaSaucer,
  faDiagramLeanCanvas: faDiagramLeanCanvas,
  faAlt: faAlt,
  faDial: faDial,
  faDialMedHigh: faDialMedHigh,
  faHandPeace: faHandPeace,
  faCircleTrash: faCircleTrash,
  faTrashCircle: faTrashCircle,
  faRotate: faRotate,
  faSyncAlt: faSyncAlt,
  faCircleQuarters: faCircleQuarters,
  faSpinner: faSpinner,
  faTowerControl: faTowerControl,
  faArrowUpTriangleSquare: faArrowUpTriangleSquare,
  faSortShapesUp: faSortShapesUp,
  faWhale: faWhale,
  faRobot: faRobot,
  faPeace: faPeace,
  faPartyHorn: faPartyHorn,
  faGears: faGears,
  faCogs: faCogs,
  faSunBright: faSunBright,
  faSunAlt: faSunAlt,
  faWarehouse: faWarehouse,
  faConveyorBeltArm: faConveyorBeltArm,
  faLockKeyholeOpen: faLockKeyholeOpen,
  faLockOpenAlt: faLockOpenAlt,
  faSquareFragile: faSquareFragile,
  faBoxFragile: faBoxFragile,
  faSquareWineGlassCrack: faSquareWineGlassCrack,
  faArrowUpRightDots: faArrowUpRightDots,
  faSquareN: faSquareN,
  faSplotch: faSplotch,
  faFaceGrinHearts: faFaceGrinHearts,
  faGrinHearts: faGrinHearts,
  faMeter: faMeter,
  faMandolin: faMandolin,
  faDiceFour: faDiceFour,
  faSimCard: faSimCard,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faMercury: faMercury,
  faUpFromBracket: faUpFromBracket,
  faKnifeKitchen: faKnifeKitchen,
  faBorderRight: faBorderRight,
  faArrowTurnDown: faArrowTurnDown,
  faLevelDown: faLevelDown,
  faSpade: faSpade,
  faCardSpade: faCardSpade,
  faLineColumns: faLineColumns,
  faArrowRightToLine: faArrowRightToLine,
  faArrowToRight: faArrowToRight,
  faPersonFallingBurst: faPersonFallingBurst,
  faFlagPennant: faFlagPennant,
  faPennant: faPennant,
  faConveyorBeltEmpty: faConveyorBeltEmpty,
  faUserGroupSimple: faUserGroupSimple,
  faAward: faAward,
  faTicketSimple: faTicketSimple,
  faTicketAlt: faTicketAlt,
  faBuilding: faBuilding,
  faAnglesLeft: faAnglesLeft,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faCamcorder: faCamcorder,
  faVideoHandheld: faVideoHandheld,
  faPancakes: faPancakes,
  faAlbumCircleUser: faAlbumCircleUser,
  faSubtitlesSlash: faSubtitlesSlash,
  faQrcode: faQrcode,
  faDiceD10: faDiceD10,
  faFireplace: faFireplace,
  faBrowser: faBrowser,
  faPenPaintbrush: faPenPaintbrush,
  faPencilPaintbrush: faPencilPaintbrush,
  faFishCooked: faFishCooked,
  faChairOffice: faChairOffice,
  faNestingDolls: faNestingDolls,
  faClockRotateLeft: faClockRotateLeft,
  faHistory: faHistory,
  faTrumpet: faTrumpet,
  faFaceGrinBeamSweat: faFaceGrinBeamSweat,
  faGrinBeamSweat: faGrinBeamSweat,
  faFireSmoke: faFireSmoke,
  faPhoneMissed: faPhoneMissed,
  faFileExport: faFileExport,
  faArrowRightFromFile: faArrowRightFromFile,
  faShield: faShield,
  faShieldBlank: faShieldBlank,
  faArrowUpShortWide: faArrowUpShortWide,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faArrowsRepeat1: faArrowsRepeat1,
  faRepeat1Alt: faRepeat1Alt,
  faGunSlash: faGunSlash,
  faAvocado: faAvocado,
  faBinary: faBinary,
  faGlassesRound: faGlassesRound,
  faGlassesAlt: faGlassesAlt,
  faPhonePlus: faPhonePlus,
  faDitto: faDitto,
  faPersonSeat: faPersonSeat,
  faHouseMedical: faHouseMedical,
  faGolfBallTee: faGolfBallTee,
  faGolfBall: faGolfBall,
  faCircleChevronLeft: faCircleChevronLeft,
  faChevronCircleLeft: faChevronCircleLeft,
  faHouseChimneyWindow: faHouseChimneyWindow,
  faScythe: faScythe,
  faPenNib: faPenNib,
  faBanParking: faBanParking,
  faParkingCircleSlash: faParkingCircleSlash,
  faTentArrowTurnLeft: faTentArrowTurnLeft,
  faFaceDiagonalMouth: faFaceDiagonalMouth,
  faDiagramCells: faDiagramCells,
  faCricketBatBall: faCricketBatBall,
  faCricket: faCricket,
  faTents: faTents,
  faWandMagic: faWandMagic,
  faMagic: faMagic,
  faDog: faDog,
  faPenLine: faPenLine,
  faAtomSimple: faAtomSimple,
  faAtomAlt: faAtomAlt,
  faAmpersand: faAmpersand,
  faCarrot: faCarrot,
  faArrowUpFromLine: faArrowUpFromLine,
  faArrowFromBottom: faArrowFromBottom,
  faMoon: faMoon,
  faPenSlash: faPenSlash,
  faWineGlassEmpty: faWineGlassEmpty,
  faWineGlassAlt: faWineGlassAlt,
  faSquareStar: faSquareStar,
  faCheese: faCheese,
  faSendBackward: faSendBackward,
  faYinYang: faYinYang,
  faMusic: faMusic,
  faCompassSlash: faCompassSlash,
  faClockOne: faClockOne,
  faFileMusic: faFileMusic,
  faCodeCommit: faCodeCommit,
  faTemperatureLow: faTemperatureLow,
  faPersonBiking: faPersonBiking,
  faBiking: faBiking,
  faDisplayChartUpCircleCurrency: faDisplayChartUpCircleCurrency,
  faSkeleton: faSkeleton,
  faCircleG: faCircleG,
  faCircleArrowUpLeft: faCircleArrowUpLeft,
  faCoinBlank: faCoinBlank,
  faBroom: faBroom,
  faVacuum: faVacuum,
  faShieldHeart: faShieldHeart,
  faCardHeart: faCardHeart,
  faLightbulbCflOn: faLightbulbCflOn,
  faMelon: faMelon,
  faGopuram: faGopuram,
  faEarthOceania: faEarthOceania,
  faGlobeOceania: faGlobeOceania,
  faContainerStorage: faContainerStorage,
  faFacePouting: faFacePouting,
  faSquareXmark: faSquareXmark,
  faTimesSquare: faTimesSquare,
  faXmarkSquare: faXmarkSquare,
  faFaceExplode: faFaceExplode,
  faExplodingHead: faExplodingHead,
  faHashtag: faHashtag,
  faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  faExpandAlt: faExpandAlt,
  faOilCan: faOilCan,
  faT: faT,
  faTransformerBolt: faTransformerBolt,
  faHippo: faHippo,
  faChartColumn: faChartColumn,
  faCassetteVhs: faCassetteVhs,
  faVhs: faVhs,
  faInfinity: faInfinity,
  faVialCircleCheck: faVialCircleCheck,
  faChimney: faChimney,
  faObjectIntersect: faObjectIntersect,
  faPersonArrowDownToLine: faPersonArrowDownToLine,
  faVoicemail: faVoicemail,
  faBlockBrick: faBlockBrick,
  faWallBrick: faWallBrick,
  faFan: faFan,
  faBagsShopping: faBagsShopping,
  faParagraphLeft: faParagraphLeft,
  faParagraphRtl: faParagraphRtl,
  faPersonWalkingLuggage: faPersonWalkingLuggage,
  faCaravanSimple: faCaravanSimple,
  faCaravanAlt: faCaravanAlt,
  faTurtle: faTurtle,
  faPencilMechanical: faPencilMechanical,
  faUpDown: faUpDown,
  faArrowsAltV: faArrowsAltV,
  faCloudMoonRain: faCloudMoonRain,
  faBoothCurtain: faBoothCurtain,
  faCalendar: faCalendar,
  faBoxHeart: faBoxHeart,
  faTrailer: faTrailer,
  faUserDoctorMessage: faUserDoctorMessage,
  faUserMdChat: faUserMdChat,
  faBahai: faBahai,
  faHaykal: faHaykal,
  faLighthouse: faLighthouse,
  faAmpGuitar: faAmpGuitar,
  faSdCard: faSdCard,
  faVolumeSlash: faVolumeSlash,
  faBorderBottom: faBorderBottom,
  faWifiWeak: faWifiWeak,
  faWifi1: faWifi1,
  faDragon: faDragon,
  faShoePrints: faShoePrints,
  faCirclePlus: faCirclePlus,
  faPlusCircle: faPlusCircle,
  faFaceGrinTongueWink: faFaceGrinTongueWink,
  faGrinTongueWink: faGrinTongueWink,
  faHandHolding: faHandHolding,
  faPlugCircleExclamation: faPlugCircleExclamation,
  faLinkSlash: faLinkSlash,
  faChainBroken: faChainBroken,
  faChainSlash: faChainSlash,
  faUnlink: faUnlink,
  faClone: faClone,
  faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
  faArrowUpZA: faArrowUpZA,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faFireFlameCurved: faFireFlameCurved,
  faFireAlt: faFireAlt,
  faTornado: faTornado,
  faFileCirclePlus: faFileCirclePlus,
  faDeleteRight: faDeleteRight,
  faBookQuran: faBookQuran,
  faQuran: faQuran,
  faCircleQuarter: faCircleQuarter,
  faAnchor: faAnchor,
  faBorderAll: faBorderAll,
  faFunction: faFunction,
  faFaceAngry: faFaceAngry,
  faAngry: faAngry,
  faPeopleSimple: faPeopleSimple,
  faCookieBite: faCookieBite,
  faArrowTrendDown: faArrowTrendDown,
  faRss: faRss,
  faFeed: faFeed,
  faFaceMonocle: faFaceMonocle,
  faDrawPolygon: faDrawPolygon,
  faScaleBalanced: faScaleBalanced,
  faBalanceScale: faBalanceScale,
  faCalendarLines: faCalendarLines,
  faCalendarNote: faCalendarNote,
  faArrowDownBigSmall: faArrowDownBigSmall,
  faSortSizeDown: faSortSizeDown,
  faGaugeSimpleHigh: faGaugeSimpleHigh,
  faTachometer: faTachometer,
  faTachometerFast: faTachometerFast,
  faDoNotEnter: faDoNotEnter,
  faShower: faShower,
  faDiceD8: faDiceD8,
  faDesktop: faDesktop,
  faDesktopAlt: faDesktopAlt,
  faM: faM,
  faGripDotsVertical: faGripDotsVertical,
  faFaceViewfinder: faFaceViewfinder,
  faSoftServe: faSoftServe,
  faCreemee: faCreemee,
  faH5: faH5,
  faHandBackPointDown: faHandBackPointDown,
  faTableList: faTableList,
  faThList: faThList,
  faCommentSms: faCommentSms,
  faSms: faSms,
  faRectangle: faRectangle,
  faRectangleLandscape: faRectangleLandscape,
  faClipboardListCheck: faClipboardListCheck,
  faTurkey: faTurkey,
  faBook: faBook,
  faUserPlus: faUserPlus,
  faIceSkate: faIceSkate,
  faCheck: faCheck,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBattery4: faBattery4,
  faTomato: faTomato,
  faSwordLaser: faSwordLaser,
  faHouseCircleCheck: faHouseCircleCheck,
  faBuildings: faBuildings,
  faAngleLeft: faAngleLeft,
  faCartFlatbedBoxes: faCartFlatbedBoxes,
  faDollyFlatbedAlt: faDollyFlatbedAlt,
  faDiagramSuccessor: faDiagramSuccessor,
  faTruckArrowRight: faTruckArrowRight,
  faSquareW: faSquareW,
  faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  faLamp: faLamp,
  faAirplay: faAirplay,
  faHandFist: faHandFist,
  faFistRaised: faFistRaised,
  faShieldQuartered: faShieldQuartered,
  faSlashForward: faSlashForward,
  faLocationPen: faLocationPen,
  faMapMarkerEdit: faMapMarkerEdit,
  faCloudMoon: faCloudMoon,
  faPotFood: faPotFood,
  faBriefcase: faBriefcase,
  faPersonFalling: faPersonFalling,
  faImagePortrait: faImagePortrait,
  faPortrait: faPortrait,
  faUserTag: faUserTag,
  faRug: faRug,
  faPrintSlash: faPrintSlash,
  faEarthEurope: faEarthEurope,
  faGlobeEurope: faGlobeEurope,
  faCartFlatbedSuitcase: faCartFlatbedSuitcase,
  faLuggageCart: faLuggageCart,
  faHandBackPointRibbon: faHandBackPointRibbon,
  faRectangleXmark: faRectangleXmark,
  faRectangleTimes: faRectangleTimes,
  faTimesRectangle: faTimesRectangle,
  faWindowClose: faWindowClose,
  faTireRugged: faTireRugged,
  faLightbulbDollar: faLightbulbDollar,
  faCowbell: faCowbell,
  faBahtSign: faBahtSign,
  faCorner: faCorner,
  faChevronsRight: faChevronsRight,
  faChevronDoubleRight: faChevronDoubleRight,
  faBookOpen: faBookOpen,
  faBookJournalWhills: faBookJournalWhills,
  faJournalWhills: faJournalWhills,
  faInhaler: faInhaler,
  faHandcuffs: faHandcuffs,
  faSnake: faSnake,
  faTriangleExclamation: faTriangleExclamation,
  faExclamationTriangle: faExclamationTriangle,
  faWarning: faWarning,
  faNoteMedical: faNoteMedical,
  faDatabase: faDatabase,
  faDownLeft: faDownLeft,
  faShare: faShare,
  faArrowTurnRight: faArrowTurnRight,
  faMailForward: faMailForward,
  faFaceThinking: faFaceThinking,
  faTurnDownRight: faTurnDownRight,
  faBottleDroplet: faBottleDroplet,
  faMaskFace: faMaskFace,
  faHillRockslide: faHillRockslide,
  faScannerKeyboard: faScannerKeyboard,
  faCircleO: faCircleO,
  faGridHorizontal: faGridHorizontal,
  faMessageDollar: faMessageDollar,
  faCommentAltDollar: faCommentAltDollar,
  faRightLeft: faRightLeft,
  faExchangeAlt: faExchangeAlt,
  faColumns3: faColumns3,
  faPaperPlane: faPaperPlane,
  faRoadCircleExclamation: faRoadCircleExclamation,
  faDungeon: faDungeon,
  faHandHoldingBox: faHandHoldingBox,
  faInputText: faInputText,
  faWindowFlip: faWindowFlip,
  faWindowAlt: faWindowAlt,
  faAlignRight: faAlignRight,
  faScannerGun: faScannerGun,
  faScanner: faScanner,
  faTire: faTire,
  faEngine: faEngine,
  faMoneyBill1Wave: faMoneyBill1Wave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faLifeRing: faLifeRing,
  faHands: faHands,
  faSignLanguage: faSignLanguage,
  faSigning: faSigning,
  faCircleCaretRight: faCircleCaretRight,
  faCaretCircleRight: faCaretCircleRight,
  faWheat: faWheat,
  faFileSpreadsheet: faFileSpreadsheet,
  faAudioDescriptionSlash: faAudioDescriptionSlash,
  faCalendarDay: faCalendarDay,
  faWaterLadder: faWaterLadder,
  faLadderWater: faLadderWater,
  faSwimmingPool: faSwimmingPool,
  faArrowsUpDown: faArrowsUpDown,
  faArrowsV: faArrowsV,
  faChessPawnPiece: faChessPawnPiece,
  faChessPawnAlt: faChessPawnAlt,
  faFaceGrimace: faFaceGrimace,
  faGrimace: faGrimace,
  faWheelchairMove: faWheelchairMove,
  faWheelchairAlt: faWheelchairAlt,
  faTurnDown: faTurnDown,
  faLevelDownAlt: faLevelDownAlt,
  faSquareS: faSquareS,
  faRectangleBarcode: faRectangleBarcode,
  faBarcodeAlt: faBarcodeAlt,
  faPersonWalkingArrowRight: faPersonWalkingArrowRight,
  faSquareEnvelope: faSquareEnvelope,
  faEnvelopeSquare: faEnvelopeSquare,
  faDice: faDice,
  faUnicorn: faUnicorn,
  faBowlingBall: faBowlingBall,
  faPompebled: faPompebled,
  faBrain: faBrain,
  faWatchSmart: faWatchSmart,
  faBookUser: faBookUser,
  faSensorCloud: faSensorCloud,
  faSensorSmoke: faSensorSmoke,
  faClapperboardPlay: faClapperboardPlay,
  faBandage: faBandage,
  faBandAid: faBandAid,
  faCalendarMinus: faCalendarMinus,
  faCircleXmark: faCircleXmark,
  faTimesCircle: faTimesCircle,
  faXmarkCircle: faXmarkCircle,
  faCircle4: faCircle4,
  faGifts: faGifts,
  faAlbumCollection: faAlbumCollection,
  faHotel: faHotel,
  faEarthAsia: faEarthAsia,
  faGlobeAsia: faGlobeAsia,
  faIdCardClip: faIdCardClip,
  faIdCardAlt: faIdCardAlt,
  faMagnifyingGlassPlus: faMagnifyingGlassPlus,
  faSearchPlus: faSearchPlus,
  faThumbsUp: faThumbsUp,
  faCloudShowers: faCloudShowers,
  faUserClock: faUserClock,
  faOnion: faOnion,
  faClockTwelveThirty: faClockTwelveThirty,
  faArrowDownToDottedLine: faArrowDownToDottedLine,
  faHandDots: faHandDots,
  faAllergies: faAllergies,
  faFileInvoice: faFileInvoice,
  faWindowMinimize: faWindowMinimize,
  faRectangleWide: faRectangleWide,
  faCommentArrowUp: faCommentArrowUp,
  faGarlic: faGarlic,
  faMugSaucer: faMugSaucer,
  faCoffee: faCoffee,
  faBrush: faBrush,
  faTreeDecorated: faTreeDecorated,
  faMask: faMask,
  faCalendarHeart: faCalendarHeart,
  faMagnifyingGlassMinus: faMagnifyingGlassMinus,
  faSearchMinus: faSearchMinus,
  faFlower: faFlower,
  faArrowDownFromArc: faArrowDownFromArc,
  faRightLeftLarge: faRightLeftLarge,
  faRulerVertical: faRulerVertical,
  faCirclesOverlap: faCirclesOverlap,
  faUserLarge: faUserLarge,
  faUserAlt: faUserAlt,
  faStarshipFreighter: faStarshipFreighter,
  faTrainTram: faTrainTram,
  faBridgeSuspension: faBridgeSuspension,
  faTrashCheck: faTrashCheck,
  faUserNurse: faUserNurse,
  faBoombox: faBoombox,
  faSyringe: faSyringe,
  faCloudSun: faCloudSun,
  faShieldExclamation: faShieldExclamation,
  faStopwatch20: faStopwatch20,
  faSquareFull: faSquareFull,
  faGripDots: faGripDots,
  faCommentExclamation: faCommentExclamation,
  faPenSwirl: faPenSwirl,
  faFalafel: faFalafel,
  faCircle2: faCircle2,
  faMagnet: faMagnet,
  faJar: faJar,
  faGramophone: faGramophone,
  faDiceD12: faDiceD12,
  faNoteSticky: faNoteSticky,
  faStickyNote: faStickyNote,
  faDown: faDown,
  faArrowAltDown: faArrowAltDown,
  faHundredPoints: faHundredPoints,
  fa100: fa100,
  faPaperclipVertical: faPaperclipVertical,
  faWindWarning: faWindWarning,
  faWindCircleExclamation: faWindCircleExclamation,
  faLocationPinSlash: faLocationPinSlash,
  faMapMarkerSlash: faMapMarkerSlash,
  faFaceSadSweat: faFaceSadSweat,
  faBugSlash: faBugSlash,
  faCupcake: faCupcake,
  faLightSwitchOff: faLightSwitchOff,
  faToggleLargeOff: faToggleLargeOff,
  faPenFancySlash: faPenFancySlash,
  faTruckContainer: faTruckContainer,
  faBoot: faBoot,
  faArrowUpFromWaterPump: faArrowUpFromWaterPump,
  faFileCheck: faFileCheck,
  faBone: faBone,
  faCardsBlank: faCardsBlank,
  faCircle3: faCircle3,
  faBenchTree: faBenchTree,
  faKeyboardBrightnessLow: faKeyboardBrightnessLow,
  faSkiBootSki: faSkiBootSki,
  faBrainCircuit: faBrainCircuit,
  faUserInjured: faUserInjured,
  faBlockBrickFire: faBlockBrickFire,
  faFirewall: faFirewall,
  faFaceSadTear: faFaceSadTear,
  faSadTear: faSadTear,
  faPlane: faPlane,
  faTentArrowsDown: faTentArrowsDown,
  faExclamation: faExclamation,
  faArrowsSpin: faArrowsSpin,
  faFaceSmileRelaxed: faFaceSmileRelaxed,
  faCommentXmark: faCommentXmark,
  faCommentTimes: faCommentTimes,
  faPrint: faPrint,
  faTurkishLiraSign: faTurkishLiraSign,
  faTry: faTry,
  faTurkishLira: faTurkishLira,
  faFaceNoseSteam: faFaceNoseSteam,
  faCircleWaveformLines: faCircleWaveformLines,
  faWaveformCircle: faWaveformCircle,
  faDollarSign: faDollarSign,
  faDollar: faDollar,
  faUsd: faUsd,
  faFerrisWheel: faFerrisWheel,
  faComputerSpeaker: faComputerSpeaker,
  faSkullCow: faSkullCow,
  faX: faX,
  faMagnifyingGlassDollar: faMagnifyingGlassDollar,
  faSearchDollar: faSearchDollar,
  faUsersGear: faUsersGear,
  faUsersCog: faUsersCog,
  faPersonMilitaryPointing: faPersonMilitaryPointing,
  faBuildingColumns: faBuildingColumns,
  faBank: faBank,
  faInstitution: faInstitution,
  faMuseum: faMuseum,
  faUniversity: faUniversity,
  faCircleT: faCircleT,
  faSack: faSack,
  faGrid2: faGrid2,
  faCameraCctv: faCameraCctv,
  faCctv: faCctv,
  faUmbrella: faUmbrella,
  faTrowel: faTrowel,
  faHorizontalRule: faHorizontalRule,
  faBedFront: faBedFront,
  faBedAlt: faBedAlt,
  faD: faD,
  faStapler: faStapler,
  faMasksTheater: faMasksTheater,
  faTheaterMasks: faTheaterMasks,
  faKipSign: faKipSign,
  faFaceWoozy: faFaceWoozy,
  faCloudQuestion: faCloudQuestion,
  faPineapple: faPineapple,
  faHandPointLeft: faHandPointLeft,
  faGalleryThumbnails: faGalleryThumbnails,
  faCircleJ: faCircleJ,
  faEyes: faEyes,
  faHandshakeSimple: faHandshakeSimple,
  faHandshakeAlt: faHandshakeAlt,
  faPageCaretUp: faPageCaretUp,
  faFileCaretUp: faFileCaretUp,
  faJetFighter: faJetFighter,
  faFighterJet: faFighterJet,
  faComet: faComet,
  faSquareShareNodes: faSquareShareNodes,
  faShareAltSquare: faShareAltSquare,
  faShieldKeyhole: faShieldKeyhole,
  faBarcode: faBarcode,
  faPlusMinus: faPlusMinus,
  faSquareSlidersVertical: faSquareSlidersVertical,
  faSlidersVSquare: faSlidersVSquare,
  faVideo: faVideo,
  faVideoCamera: faVideoCamera,
  faMessageMiddle: faMessageMiddle,
  faCommentMiddleAlt: faCommentMiddleAlt,
  faGraduationCap: faGraduationCap,
  faMortarBoard: faMortarBoard,
  faHandHoldingMedical: faHandHoldingMedical,
  faPersonCircleCheck: faPersonCircleCheck,
  faSquareZ: faSquareZ,
  faMessageText: faMessageText,
  faCommentAltText: faCommentAltText,
  faTurnUp: faTurnUp,
  faLevelUpAlt: faLevelUpAlt
};




/***/ }),

/***/ 73582:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg$": function() { return /* binding */ faStop; },
/* harmony export */   "FVb": function() { return /* binding */ faUsers; },
/* harmony export */   "FzC": function() { return /* binding */ faPaperPlaneTop; },
/* harmony export */   "JyM": function() { return /* binding */ faSparkles; },
/* harmony export */   "UOM": function() { return /* binding */ faMicrophone; },
/* harmony export */   "_tD": function() { return /* binding */ faChevronRight; },
/* harmony export */   "dlc": function() { return /* binding */ faWaveformLines; },
/* harmony export */   "f8k": function() { return /* binding */ faCheckCircle; },
/* harmony export */   "mTx": function() { return /* binding */ faChevronUp; },
/* harmony export */   "paY": function() { return /* binding */ faArrowRotateLeft; },
/* harmony export */   "ptq": function() { return /* binding */ faChevronDown; },
/* harmony export */   "x_p": function() { return /* binding */ faSunBright; },
/* harmony export */   "zc": function() { return /* binding */ faPlay; }
/* harmony export */ });
/* unused harmony exports fas, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashCan, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileLines, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faCalendarAlt, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDown, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faRam, faLandmarkFlag, faLips, faPencil, faPencilAlt, faBackward, faCaretRight, faComments, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faUsersMedical, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faEmptySet, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faCircleExclamation, faExclamationCircle, faSchoolCircleXmark, faArrowRightFromBracket, faSignOut, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faAsterisk, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faCheckSquare, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmSimple, faFilmAlt, faList, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faLock, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faGlobePointer, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faPenToSquare, faEdit, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareNodes, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faHourglass2, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faFacePleading, faEyeSlash, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faFolderBookmark, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faArrowDownLeftAndArrowUpRightToCenter, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faAngleRight, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFaceFrownOpen, faFrownOpen, faSquareDashed, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faAlignJustify, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faRaccoon, faHandPointDown, faArrowUpFromBracket, faHeadSideGear, faTrashPlus, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faWandMagicSparkles, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faUser, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faPersonDressFairy, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faTruckBolt, faPizzaSlice, faMoneyBillWave, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faXRay, faGoalNet, faCoffinCross, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneAlt, faSend, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faArrowUpToArc, faStarExclamation, faBooks, faUserGroup, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileArrowUp, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faSwapArrows, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faSubtitles, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faImage, faWindowFrame, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faCaretUp, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faFolderClosed, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faHandshake, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faArrowUpRightAndArrowDownLeftFromCenter, faTablets, fa360Degrees, faEthernet, faEuroSign, faEur, faEuro, faChair, faCircleCheck, faSquareDashedCirclePlus, faMoneySimpleFromBracket, faBat, faCircleStop, faStopCircle, faHeadSideHeadphones, faPhoneRotary, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faSuitcase, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faLightEmergencyOn, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faMoneyBills, faBlindsRaised, faSmog, faUfoBeam, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMemoPad, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faEnvelopeCircleCheck, faLayerGroup, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faNewspaper, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faSort, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileNotch, faMobileIphone, faMagnifyingGlassChart, faArrowUpRightFromSquare, faExternalLink, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faImagePolaroidUser, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faSignatureLock, faArrowRight, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyStar, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faHeart, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faCirclePause, faPauseCircle, faGaugeCirclePlus, faFolders, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faUserAstronaut, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faBadgeCheck, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faCircleQuestion, faQuestionCircle, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faEye, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faPen, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faFileCode, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faDiploma, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortUp, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommentDots, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faSpinnerThird, faFaceGrinTears, faGrinTears, faPhone, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faTrash, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faArrowLeft, faPersonCircleXmark, faRuler, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faFilePdf, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSparkles, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faComment, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faEnvelope, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleNodes, faParachuteBox, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faCircleInfo, faInfoCircle, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCamera, faCameraAlt, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faMinus, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileCertificate, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faGear, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClock, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faCaretDown, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faFilterList, faOutlet, faSliders, faSlidersH, faCauldron, faPeople, faFolderTree, faNetworkWired, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisVertical, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faSwap, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faDownload, faAnglesUpDown, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faPersonSimple, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faAngleDown, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faEnvelopeDot, faEnvelopeBadge, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faMedal, faPersonFairy, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faPodcast, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faBell, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faMapMarkerAlt, faCrab, faBoxOpenFull, faBoxFull, faFile, faGreaterThan, faQuotes, faPretzel, faPersonSwimming, faSwimmer, faArrowDown, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faGrillHot, faBallotCheck, faLink, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faRupiahSign, faMagnifyingGlass, faSearch, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFilePen, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faTasks, faDiagramSubtask, faJugDetergent, faCircleUser, faUserCircle, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faCopy, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faKeynote, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faPlus, faAdd, faExpand, faComputer, faFort, faCloudCheck, faXmark, faClose, faMultiply, faRemove, faTimes, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faArrowLeftFromArc, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faRocket, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faArrowLeftToArc, faChevronLeft, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercent, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faRobot, faPeace, faPartyHorn, faGears, faCogs, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faBuilding, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faSubtitlesSlash, faQrcode, faDiceD10, faFireplace, faBrowser, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faPenLine, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faMusic, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faBoxHeart, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faLighthouse, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faPlusCircle, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faBook, faUserPlus, faIceSkate, faCheck, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faAngleLeft, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronsRight, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faTriangleExclamation, faExclamationTriangle, faWarning, faNoteMedical, faDatabase, faDownLeft, faShare, faArrowTurnRight, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faColumns3, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faCircleXmark, faTimesCircle, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faThumbsUp, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faArrowDownFromArc, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faStickyNote, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faFaceSadSweat, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faShieldKeyhole, faBarcode, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faGraduationCap, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt */
var prefix = "fas";
var fa0 = {
  prefix: 'fas',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"]
};
var fa1 = {
  prefix: 'fas',
  iconName: '1',
  icon: [256, 512, [], "31", "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"]
};
var fa2 = {
  prefix: 'fas',
  iconName: '2',
  icon: [320, 512, [], "32", "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"]
};
var fa3 = {
  prefix: 'fas',
  iconName: '3',
  icon: [320, 512, [], "33", "M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"]
};
var fa4 = {
  prefix: 'fas',
  iconName: '4',
  icon: [384, 512, [], "34", "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"]
};
var fa5 = {
  prefix: 'fas',
  iconName: '5',
  icon: [320, 512, [], "35", "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"]
};
var fa6 = {
  prefix: 'fas',
  iconName: '6',
  icon: [320, 512, [], "36", "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"]
};
var fa7 = {
  prefix: 'fas',
  iconName: '7',
  icon: [320, 512, [], "37", "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"]
};
var fa8 = {
  prefix: 'fas',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"]
};
var fa9 = {
  prefix: 'fas',
  iconName: '9',
  icon: [320, 512, [], "39", "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"]
};
var faFillDrip = {
  prefix: 'fas',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"]
};
var faArrowsToCircle = {
  prefix: 'fas',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"]
};
var faCircleChevronRight = {
  prefix: 'fas',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"]
};
var faChevronCircleRight = faCircleChevronRight;
var faWagonCovered = {
  prefix: 'fas',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M4.5 57.4C-5.2 30.3 16.1 2.1 44.8 4.1L194.1 14C210.9 15.1 224 29.1 224 45.9V224H64L4.5 57.4zM288 16h64c17.7 0 32 14.3 32 32V224H256V48c0-17.7 14.3-32 32-32zM64 288c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32h-1.6c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H286.9c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80H96c-17.7 0-32-14.3-32-32zm96 128H114c5.8 22.5 23.5 40.2 46 46V416zm0-32V338c-22.5 5.8-40.2 23.5-46 46h46zm32 78c22.5-5.8 40.2-23.5 46-46H192v46zm0-124v46h46c-5.8-22.5-23.5-40.2-46-46zM448 462V416H402c5.8 22.5 23.5 40.2 46 46zm-46-78h46V338c-22.5 5.8-40.2 23.5-46 46zm124 32H480v46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46v46h46zM595.2 4.1c28.7-1.9 50 26.2 40.3 53.4L576 224H416V45.9c0-16.8 13.1-30.8 29.9-31.9l149.3-10z"]
};
var faLineHeight = {
  prefix: 'fas',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V370.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V141.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM256 416c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-17.7 0-32 14.3-32 32z"]
};
var faBagel = {
  prefix: 'fas',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zM396.1 155c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM144 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faTransporter7 = {
  prefix: 'fas',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", "M472.7 38.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64l-7.3-25.4zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288 6.6 295.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zM296 512h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h88 80z"]
};
var faAt = {
  prefix: 'fas',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faRectanglesMixed = {
  prefix: 'fas',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", "M0 80C0 53.5 21.5 32 48 32H272c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm384 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V80zM112 304H288c26.5 0 48 21.5 48 48v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48z"]
};
var faPhoneArrowUpRight = {
  prefix: 'fas',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M295 183l135-135H384c-13.3 0-24-10.7-24-24s10.7-24 24-24H488c13.3 0 24 10.7 24 24V128c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"]
};
var faPhoneArrowUp = faPhoneArrowUpRight;
var faPhoneOutgoing = faPhoneArrowUpRight;
var faTrashCan = {
  prefix: 'fas',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
};
var faTrashAlt = faTrashCan;
var faCircleL = {
  prefix: 'fas',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152V336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHeadSideGoggles = {
  prefix: 'fas',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M45.9 128C75.3 53.1 148.3 0 233.7 0H256c39.3 0 75.8 11.8 106.2 32H304c-61.9 0-112 50.1-112 112c0 17.2 3.9 33.5 10.8 48H32.2 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H45.9zM304 256H507.1c3.2 6.2 4.9 13.1 4.9 20.2c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V375.8c0-17-7.1-33-17.5-46.4C55 299.1 38.3 261.6 33.5 224H225.6c20.2 19.8 47.9 32 78.4 32zm0-192H416V224H304c-44.2 0-80-35.8-80-80s35.8-80 80-80zM480 224H448V64h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32z"]
};
var faHeadVr = faHeadSideGoggles;
var faTextHeight = {
  prefix: 'fas',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"]
};
var faUserXmark = {
  prefix: 'fas',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faUserTimes = faUserXmark;
var faFaceHandYawn = {
  prefix: 'fas',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M336.9 498.9C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5V384 330.4c0-28.7 23.3-52 52-52c1.8 0 3.6 .1 5.3 .3C184.8 246.3 217.8 224 256 224c28.7 0 54.5 12.6 72.1 32.6c14.8-2.4 30.4 2 41.8 13.4c12.2 12.2 16.5 29.4 12.8 45c1.1 .9 2.2 1.9 3.2 3c18.1 18.1 18.7 47.1 1.8 65.9c16.9 18.8 16.3 47.8-1.8 65.9l-49 49zM204.5 102c5.5 6.9 4.4 17-2.5 22.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l80-64c6.9-5.5 17-4.4 22.5 2.5zM310 124.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5l80 64c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5l-80-64zM299.3 276.7c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGaugeSimpleMin = {
  prefix: 'fas',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerSlowest = faGaugeSimpleMin;
var faStethoscope = {
  prefix: 'fas',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCoffin = {
  prefix: 'fas',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6z"]
};
var faMessage = {
  prefix: 'fas',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]
};
var faCommentAlt = faMessage;
var faSalad = {
  prefix: 'fas',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M416 96c2.6 0 5.2 .1 7.8 .2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4C43 64 0 107 0 160s43 96 96 96h73.4L84.7 171.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 249.4V112c0-8.8 7.2-16 16-16s16 7.2 16 16V256h52c-2.6-10.2-4-21-4-32c0-70.7 57.3-128 128-128zM27.4 288C12.3 288 0 300.3 0 315.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28H371.8c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 446.1 512 385.9 512 315.4c0-15.1-12.3-27.4-27.4-27.4H27.4zM512 224c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H506.5c3.5-10 5.5-20.8 5.5-32z"]
};
var faBowlSalad = faSalad;
var faInfo = {
  prefix: 'fas',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"]
};
var faRobotAstromech = {
  prefix: 'fas',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M256 0c70.7 0 128 57.3 128 128v32H128V128C128 57.3 185.3 0 256 0zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM48 240c0-26.5 21.5-48 48-48H416c26.5 0 48 21.5 48 48V398.3c0 8.7 2.4 17.2 6.8 24.7l38.9 64.8c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H400c-8.8 0-16-7.2-16-16V384l-45.3 45.3c-12 12-28.3 18.7-45.3 18.7h-75c-17 0-33.3-6.7-45.3-18.7L128 384V496c0 8.8-7.2 16-16 16H16c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1L41.2 423c4.5-7.5 6.8-16 6.8-24.7V240zm160 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faRingDiamond = {
  prefix: 'fas',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M122.5 13.3C126.6 5.1 134.9 0 144 0h96c9.1 0 17.4 5.1 21.5 13.3l24 48c3.5 7.1 3.4 15.5-.5 22.4l-30.4 54.8C329.9 164.4 384 235.9 384 320c0 106-86 192-192 192S0 426 0 320c0-84.1 54.1-155.6 129.4-181.6L99 83.7c-3.8-6.9-4-15.3-.5-22.4l24-48zM192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]
};
var faFonduePot = {
  prefix: 'fas',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M319 39.8l-24 96c-2.9 11.5-11.6 20-22.2 23L264.5 192h-33l10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zm62.9 120.2L360.6 192H322.1l33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM32 224H64v16 64c0 8.8 7.2 16 16 16s16-7.2 16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16s16-7.2 16-16V240 224H384h64 32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 52.3-25.1 98.8-64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-3.2c-10.3 2.1-21 3.2-32 3.2H160c-11 0-21.7-1.1-32-3.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448C25.1 418.8 0 372.3 0 320V256c0-17.7 14.3-32 32-32z"]
};
var faTheta = {
  prefix: 'fas',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M64 256c0-51 15.9-96 40.2-127.6C128.5 96.9 159.8 80 192 80s63.5 16.9 87.8 48.4C304.1 160 320 205 320 256s-15.9 96-40.2 127.6C255.5 415.1 224.2 432 192 432s-63.5-16.9-87.8-48.4C79.9 352 64 307 64 256zM192 16C135.8 16 87.1 45.7 53.5 89.4C19.9 133.1 0 192.1 0 256s19.9 122.9 53.5 166.6C87.1 466.3 135.8 496 192 496s104.9-29.7 138.5-73.4C364.1 378.9 384 319.9 384 256s-19.9-122.9-53.5-166.6C296.9 45.7 248.2 16 192 16zM128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]
};
var faFaceHandPeeking = {
  prefix: 'fas',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M497.8 144.3c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0C248.5 0 183.8 29.3 137.3 76.6c7.7 1.8 14.9 5.7 20.9 11.7c17.2 17.2 17.2 45 0 62.2l-1.5 1.5H232c22.1 0 40 17.9 40 40c0 2.6-.2 5.1-.7 7.5c10.1 7.3 16.7 19.1 16.7 32.5s-6.6 25.3-16.7 32.5c.5 2.4 .7 4.9 .7 7.5c0 22.1-17.9 40-40 40h-8c0 .3 0 .6 0 .9c0 22.1-17.9 40-40 40l-64.8 0c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2c-5.4 .7-10.8 1.1-16.3 1.1H456c-22.1 0-40-17.9-40-40c0-.1 0-.2 0-.3c0-.2 0-.4 0-.6h-8c-22.1 0-40-17.9-40-40c0-1.1 0-2.2 .1-3.3c-37-10.4-64.1-44.4-64.1-84.7c0-48.6 39.4-88 88-88c6.6 0 13 .7 19.2 2.1c11.8-4 25.2-2.4 36.1 5.4l37.9 27.1c1.1-9.6 5.3-18.9 12.6-26.2zM320 448c-35.3 0-64-21.5-64-48s28.7-48 64-48s64 21.5 64 48s-28.7 48-64 48zm90.3-208c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16h35.8zM248 192c0-8.8-7.2-16-16-16H118.2c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9H184c8.8 0 16-7.2 16-16s-7.2-16-16-16H170c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h62c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16H169.6c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9c0 7.4-6 13.4-13.4 13.4L392 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h84c2.2 0 4 1.8 4 4s-1.8 4-4 4H408c-8.8 0-16 7.2-16 16s7.2 16 16 16l67.5 0c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5H456c-8.8 0-16 7.2-16 16s7.2 16 16 16h64.8c25.2 0 49.5-10 67.3-27.9c36.9-36.9 37.2-96.6 .8-133.8l-.8-.8L543 161.3c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19c-2.8 .3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z"]
};
var faSquareUser = {
  prefix: 'fas',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M81.1 416H366.9c-7.8-54.3-54.4-96-110.9-96H192c-56.4 0-103.1 41.7-110.9 96zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faDownLeftAndUpRightToCenter = {
  prefix: 'fas',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faExplosion = {
  prefix: 'fas',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]
};
var faFileLines = {
  prefix: 'fas',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faWaveSquare = {
  prefix: 'fas',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"]
};
var faRing = {
  prefix: 'fas',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"]
};
var faBuildingUn = {
  prefix: 'fas',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faDiceThree = {
  prefix: 'fas',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faTirePressureWarning = {
  prefix: 'fas',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M384 32c0-17.7 14.3-32 32-32s32 14.3 32 32V54.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4c17.5 35.6 33.4 82.6 27.5 136.2c-5.3 48.6-28.1 99-76.8 148.7v34c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16v-8H336v8c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16v-8H240v8c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16v-8H144v8c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V462C31.3 412.3 8.6 361.9 3.2 313.3c-5.9-53.6 9.9-100.6 27.5-136.2c7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 102.5 64 78.5 64 54.5V32C64 14.3 78.3 0 96 0s32 14.3 32 32V54.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5c-14.7 29.7-25.3 64-21.3 100.9c3.7 34 20.4 74.1 65.7 117.7H379.4c45.3-43.6 62-83.7 65.7-117.7c4.1-36.9-6.6-71.1-21.3-100.9c-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 116.2 384 85.4 384 54.5V32zM280 120V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faWifiFair = {
  prefix: 'fas',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", "M320 352a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-160c-70.2 0-137.9 25.6-190.5 72c-13.2 11.7-14.5 31.9-2.8 45.2c11.8 13.3 32 14.5 45.2 2.8c40.9-36.1 93.5-56 148.1-56s107.3 19.9 148.1 56c6.1 5.4 13.7 8 21.2 8c8.8 0 17.7-3.7 24-10.8c11.7-13.2 10.4-33.5-2.8-45.2c-52.6-46.4-120.2-72-190.5-72zM171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faWifi2 = faWifiFair;
var faCalendarDays = {
  prefix: 'fas',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
};
var faCalendarAlt = faCalendarDays;
var faMp3Player = {
  prefix: 'fas',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM96 64C78.3 64 64 78.3 64 96v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96z"]
};
var faAnchorCircleCheck = {
  prefix: 'fas',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faTally4 = {
  prefix: 'fas',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm96-32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zM544 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faRectangleHistory = {
  prefix: 'fas',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M512 224c0-35.3-28.7-64-64-64L64 160c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224zM440 80L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM392 0L120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faBuildingCircleArrowRight = {
  prefix: 'fas',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faVolleyball = {
  prefix: 'fas',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"]
};
var faVolleyballBall = faVolleyball;
var faSunHaze = {
  prefix: 'fas',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", "M425.5 1.2c5 2.1 8.6 6.6 9.6 11.9L455 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L510.9 256 448 256c0-70.7-57.3-128-128-128s-128 57.3-128 128l-62.9 0L66.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L185 121 204.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L320 65.1 410.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM320 160c53 0 96 43 96 96H224c0-53 43-96 96-96zM616 288c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24s10.7-24 24-24H616zm-208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H408zm144 88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H552zM64 488c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24z"]
};
var faTextSize = {
  prefix: 'fas',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M64 128V96h96l0 320H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H224l0-320h96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H192 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM384 304V288h64l0 128H432c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H512l0-128h64v16c0 17.7 14.3 32 32 32s32-14.3 32-32V272c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v32c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faUfo = {
  prefix: 'fas',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", "M320 112c59.2 0 109.6 37.9 128.3 90.7c5 14.2 7.7 29.4 7.7 45.3c0 0-40 40-136 40s-136-40-136-40c0-15.9 2.7-31.1 7.7-45.3c18.7-52.8 69-90.7 128.3-90.7zm0-48c-90.1 0-165.2 64.8-180.9 150.4C55.1 237.5 0 276.2 0 320c0 70.7 143.3 128 320 128s320-57.3 320-128c0-43.8-55.1-82.5-139.1-105.6C485.2 128.8 410.2 64 320 64zm0 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm408-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faFork = {
  prefix: 'fas',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M412.4 5.9c5.2 6.4 4.8 15.6-1.1 21.5L320 118.6c-5.2 5.2-5.2 13.6 0 18.8c4.9 4.9 12.8 5.2 18.1 .6l99.4-86.1c6.3-5.5 15.9-5.2 21.8 .8s6.3 15.4 .8 21.8L374 173.9c-4.6 5.3-4.3 13.2 .6 18.1c5.2 5.2 13.6 5.2 18.8 0l91.3-91.3c5.8-5.8 15.1-6.3 21.5-1.1s7.7 14.4 3.2 21.2l-71 106.5c-18.6 27.9-49.9 44.6-83.4 44.6c-19.3 0-37.9-5.5-53.9-15.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L255.7 211c-10.2-16-15.7-34.7-15.7-53.9c0-33.5 16.8-64.8 44.6-83.4l106.5-71c6.8-4.6 16-3.2 21.2 3.2z"]
};
var faUtensilFork = faFork;
var faArrowsUpToLine = {
  prefix: 'fas',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"]
};
var faMobileSignal = {
  prefix: 'fas',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", "M64 64H288V315.7c18.3-21.2 39.9-39.5 64-54V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H224V488c0-13.6 1-27 3-40H64V64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM488 256c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24z"]
};
var faBarcodeScan = {
  prefix: 'fas',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", "M88 32C74.7 32 64 42.7 64 56V192h64V56c0-13.3-10.7-24-24-24H88zM64 456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H64V456zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16V320H160V464zm64-8c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H224V456zm0-264h64V56c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24V192zm96 264c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H320V456zm0-264h64V56c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24V192zM448 464c0 8.8 7.2 16 16 16s16-7.2 16-16V320H448V464zm0-416V192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V320H512V456zm0-264h64V56c0-13.3-10.7-24-24-24H536c-13.3 0-24 10.7-24 24V192zm-352 0h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16V192zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faSortDown = {
  prefix: 'fas',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
};
var faSortDesc = faSortDown;
var faFolderArrowDown = {
  prefix: 'fas',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24V302.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V200z"]
};
var faFolderDownload = faFolderArrowDown;
var faCircleMinus = {
  prefix: 'fas',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMinusCircle = faCircleMinus;
var faFaceIcicles = {
  prefix: 'fas',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M512 256c0 8.3-.4 16.6-1.2 24.7c0 .5-.1 1.1-.1 1.6l-14.8 200C494.7 499.1 480.8 512 464 512s-30.7-12.9-31.9-29.6l-2.8-37.9c-5 4.6-10.2 9-15.6 13.2l-11.5 32.9C397.7 503.4 385.6 512 372 512c-11.5 0-21.9-6.1-27.5-15.7C316.9 506.5 287.1 512 256 512c-69.4 0-132.3-27.6-178.4-72.4C71.9 444.9 64.3 448 56 448c-15.6 0-29-11.3-31.6-26.7L6.5 313.4C2.2 294.9 0 275.7 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM56 415.8l0 .2 0-.2 20-120.2C78.1 283.3 68.6 272 56 272s-22.1 11.3-20.1 23.7L56 415.8zM344 400l28 80 28-80V360l-56 0v40zm55.3-56c-3.8-22.7-23.6-40-47.3-40h-8v40l55.3 0zM328 344V304H264v40h64zm0 56V360H264v40l32 48 32-48zm-80-96H184v40l64 0V304zm0 56l-64 0v40h64V360zm-80-16V304h-8c-23.8 0-43.5 17.3-47.3 40H168zm0 56V360H112.7c3.8 22.7 23.6 40 47.3 40h8zm40.4-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 480l21.8-232.1C487 235.1 476.9 224 464 224s-23 11.1-21.8 23.9L464 480z"]
};
var faShovel = {
  prefix: 'fas',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", "M361.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-44.1 44.1c-18.7 18.7-44.1 29.3-70.6 29.3c-15.9 0-30.9-3.7-44.3-10.3l-97 97 50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32V386.3c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7 97-97C291.7 155.1 288 140 288 124.1c0-26.5 10.5-51.9 29.3-70.6L361.4 9.4zM384 77.3L362.5 98.7c-6.7 6.7-10.5 15.9-10.5 25.4c0 19.8 16.1 35.9 35.9 35.9c9.5 0 18.6-3.8 25.4-10.5L434.7 128 384 77.3z"]
};
var faDoorOpen = {
  prefix: 'fas',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"]
};
var faFilms = {
  prefix: 'fas',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm8 48h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM472 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H488c-8.8 0-16-7.2-16-16V96zM168 184h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16V200c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H488c-8.8 0-16-7.2-16-16V200zM168 288h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H488c-8.8 0-16-7.2-16-16V304zM288 80h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V112c0-17.7 14.3-32 32-32zM256 256c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faRightFromBracket = {
  prefix: 'fas',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]
};
var faSignOutAlt = faRightFromBracket;
var faFaceGlasses = {
  prefix: 'fas',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.1 2.8-43.5 8.1-64H48v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h32v56c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V192h39.9c5.3 20.5 8.1 41.9 8.1 64zM256 0C363.4 0 455.4 66.2 493.4 160H458.6c-9-18.9-28.3-32-50.6-32H328c-22.3 0-41.6 13.1-50.6 32H234.6c-9-18.9-28.3-32-50.6-32H104c-22.3 0-41.6 13.1-50.6 32H18.6C56.6 66.2 148.6 0 256 0zM80 192v-8c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V192zm61.5 147.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 184c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8 56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V184zM184.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faNfc = {
  prefix: 'fas',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 48V368c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48z"]
};
var faAtom = {
  prefix: 'fas',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSoap = {
  prefix: 'fas',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"]
};
var faIcons = {
  prefix: 'fas',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"]
};
var faHeartMusicCameraBolt = faIcons;
var faMicrophoneLinesSlash = {
  prefix: 'fas',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faClosedCaptioningSlash = {
  prefix: 'fas',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zm197.8 155c26.6 1.2 50.4 13.3 67 31.9c6.1 6.8 7.6 16.2 4.7 24.3l-71.6-56.2zm94 73.7c10-42.3 48-73.8 93.4-73.8c28.4 0 54 12.4 71.5 32c8.8 9.9 8 25-1.9 33.9s-25 8-33.9-1.9c-8.8-9.9-21.6-16-35.8-16c-26.5 0-48 21.5-48 48c0 5.4 .9 10.5 2.5 15.4l-47.9-37.6zm89.4 70c1.3 .1 2.7 .2 4.1 .2c14.2 0 27-6.1 35.8-16c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-7.8 8.7-17.2 16-27.7 21.4l-47.9-37.6zM32 121.2V416c0 35.3 28.7 64 64 64H487.4L295 328.4c-16.8 14.7-38.9 23.6-63 23.6c-53 0-96-43-96-96c0-16 3.9-31.1 10.8-44.3L32 121.2zM232 304c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5c0 26.5 21.5 48 48 48z"]
};
var faCalculatorSimple = {
  prefix: 'fas',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M0 48C0 21.5 21.5 0 48 0H176c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zm288 0c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V48zm48 240H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM0 336c0-26.5 21.5-48 48-48H176c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zM416 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V96H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H416V64zM64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM83.3 348.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L89.4 400 60.7 428.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 422.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L134.6 400l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 377.4 83.3 348.7zM352 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z"]
};
var faCalculatorAlt = faCalculatorSimple;
var faBridgeCircleCheck = {
  prefix: 'fas',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faSlidersUp = {
  prefix: 'fas',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M96 0c17.7 0 32 14.3 32 32V86.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V233.3C35.7 221 16 192.8 16 160s19.7-61 48-73.3V32C64 14.3 78.3 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 32.8-19.7 61-48 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V425.3c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32V278.7c28.3 12.3 48 40.5 48 73.3zM448 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 73.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V265.3c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V32c0-17.7 14.3-32 32-32s32 14.3 32 32v86.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3z"]
};
var faSlidersV = faSlidersUp;
var faLocationMinus = {
  prefix: 'fas',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM120 168H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMapMarkerMinus = faLocationMinus;
var faPumpMedical = {
  prefix: 'fas',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFingerprint = {
  prefix: 'fas',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"]
};
var faSkiBoot = {
  prefix: 'fas',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M383.4 38c3.3-17.4-8-34.1-25.4-37.5s-34.1 8-37.5 25.4l-1.2 6H245.7c-22.1 130.8-76 201.3-127.2 238.9c-26.2 19.3-51.2 29.5-69.9 35c-6.3 1.8-11.8 3.1-16.5 4L.6 474c-1.8 9.4 .7 19.1 6.8 26.4S22.5 512 32 512H448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V376c0-12.3-7-23.4-18-28.8L340 288H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h69.5l12.3-64H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h72l17.3-90 6.2-32zM38.8 275.4c.3-.1 .6-.2 .9-.3c15.6-4.6 37.1-13.3 59.9-30c43-31.6 92.3-92.9 113.7-213.1H112C96.7 32 83.5 42.9 80.6 58L38.8 275.4z"]
};
var faStandardDefinition = {
  prefix: 'fas',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 88V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328c-13.3 0-24 10.7-24 24zm48 24h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208zm-184.9 .1c7.4-2.4 19.5-2.9 36.2-.7l3-22.2-3 22.2c5.1 .7 21.1 3.4 25.7 4.4c12.1 2.8 24.1-4.8 26.8-16.9s-4.8-24.1-16.9-26.8c-6.5-1.5-23.9-4.4-29.7-5.1c-18.9-2.5-38.9-3.1-56 2.5c-18.8 6.1-33.9 19.7-38.5 42.3c-.1 .4-.1 .8-.2 1.2c-1.7 11.4-.2 22.4 5 32.3c5.1 9.6 12.9 16.1 20.5 20.7c13.7 8.2 31.5 12.3 45.1 15.5l0 0 1.7 .4c16 3.7 27.1 6.5 34.1 10.7c3 1.8 3.8 3 3.9 3.3l0 0c.1 .1 .7 1.2 .2 4.7c-.4 2.7-1.2 3.8-1.7 4.3c-.7 .7-2.3 2-5.8 3.1c-7.7 2.4-20.1 2.9-36.9 .6c-7.4-1-20.3-4.8-31.4-8c-2.5-.7-5-1.4-7.2-2.1c-11.9-3.4-24.3 3.5-27.7 15.4s3.5 24.3 15.4 27.7c1.5 .4 3.3 .9 5.3 1.5l0 0c10.8 3.2 28.4 8.3 39.4 9.9l.1 0c18.9 2.5 39.2 3.1 56.4-2.3c8.9-2.8 17.8-7.5 24.9-15.2c7.3-7.8 11.8-17.6 13.4-28.5c1.7-11.4 .2-22.4-5-32.3c-5.1-9.6-12.9-16.1-20.5-20.7c-13.7-8.2-31.5-12.3-45.1-15.5l0 0-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7c-3-1.8-3.8-3-3.9-3.3l0 0c-.1-.1-.6-1.1-.3-4.1c.9-4 2.8-6.2 8.3-8z"]
};
var faRectangleSd = faStandardDefinition;
var faH1 = {
  prefix: 'fas',
  iconName: 'h1',
  icon: [576, 512, [], "f313", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8V384H416c-17.7 0-32 14.3-32 32s14.3 32 32 32h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V96z"]
};
var faHandPointRight = {
  prefix: 'fas',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"]
};
var faMagnifyingGlassLocation = {
  prefix: 'fas',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faMessageBot = {
  prefix: 'fas',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M160 0C124.7 0 96 28.7 96 64V176H59.7c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16H96V352c0 35.3 28.7 64 64 64h64v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416H480c35.3 0 64-28.7 64-64V208h36.3c5.5 9.6 15.9 16 27.7 16c17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H544V64c0-35.3-28.7-64-64-64H160zm0 128c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V128zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faForwardStep = {
  prefix: 'fas',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"]
};
var faStepForward = faForwardStep;
var faFaceSmileBeam = {
  prefix: 'fas',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faSmileBeam = faFaceSmileBeam;
var faLightCeiling = {
  prefix: 'fas',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M256 0c17.7 0 32 14.3 32 32V162c115.8 14.4 207.6 106.3 222 222.1c2.2 17.5-12.4 31.9-30 31.9H32C14.3 416-.2 401.6 2 384.1C16.4 268.2 108.2 176.4 224 162V32c0-17.7 14.3-32 32-32zm0 512c-35.3 0-64-28.7-64-64H320c0 35.3-28.7 64-64 64z"]
};
var faMessageExclamation = {
  prefix: 'fas',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCommentAltExclamation = faMessageExclamation;
var faBowlScoop = {
  prefix: 'fas',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M32 224H416c0-106-86-192-192-192S32 118 32 224zM16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9C11.1 361.9 72.4 416 145 416h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H320c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z"]
};
var faBowlShavedIce = faBowlScoop;
var faSquareX = {
  prefix: 'fas',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"]
};
var faUtilityPoleDouble = {
  prefix: 'fas',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M256 0c17.7 0 32 14.3 32 32V64h96V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32V56c0-13.3 10.7-24 24-24s24 10.7 24 24V96c0 17.7-14.3 32-32 32H428.8L288 221.9V256h96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v40c0 17.7-14.3 32-32 32H428.8L288 413.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V413.9L83.2 320H32c-17.7 0-32-14.3-32-32V248c0-13.3 10.7-24 24-24s24 10.7 24 24v8H80v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V221.9L83.2 128H32C14.3 128 0 113.7 0 96V56C0 42.7 10.7 32 24 32s24 10.7 24 24v8H80V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32zM140.8 128L224 183.4V128H140.8zM288 183.4L371.2 128H288v55.4zM140.8 320L224 375.4V320H140.8zM288 375.4L371.2 320H288v55.4z"]
};
var faFlagCheckered = {
  prefix: 'fas',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"]
};
var faChevronsUp = {
  prefix: 'fas',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M278.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3 425.4 278.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192zm192 384l-192-192c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3 425.4 470.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faChevronDoubleUp = faChevronsUp;
var faFootball = {
  prefix: 'fas',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faFootballBall = faFootball;
var faUserVneck = {
  prefix: 'fas',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 0a128 128 0 1 0 0 256A128 128 0 1 0 224 0zM157.3 327.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-83.1-62.9-151.5-143.7-160.3c-5.3-.6-10.5 1.9-13.7 6.2l-53.9 71.8c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z"]
};
var faSchoolCircleExclamation = {
  prefix: 'fas',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faCrop = {
  prefix: 'fas',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"]
};
var faAnglesDown = {
  prefix: 'fas',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faAngleDoubleDown = faAnglesDown;
var faUsersRectangle = {
  prefix: 'fas',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faPeopleRoof = {
  prefix: 'fas',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"]
};
var faSquareArrowRight = {
  prefix: 'fas',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM361 273L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z"]
};
var faArrowSquareRight = faSquareArrowRight;
var faLocationPlus = {
  prefix: 'fas',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM168 280V216H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V104c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faMapMarkerPlus = faLocationPlus;
var faLightbulbExclamationOn = {
  prefix: 'fas',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM344 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V200c0 13.3 10.7 24 24 24s24-10.7 24-24V88zM320 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faPeopleLine = {
  prefix: 'fas',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"]
};
var faBeerMugEmpty = {
  prefix: 'fas',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"]
};
var faBeer = faBeerMugEmpty;
var faCrateEmpty = {
  prefix: 'fas',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M48 224c-26.5 0-48 21.5-48 48v80H512V272c0-26.5-21.5-48-48-48H48zM512 384H0v80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V384zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faDiagramPredecessor = {
  prefix: 'fas',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"]
};
var faTransporter = {
  prefix: 'fas',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 272v96H184V237.3L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7V416H264V320H248zM216 512H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216zM64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128 6.6 120.7C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4C40.4 66.7 43.9 64 48 64s7.6 2.7 8.7 6.6L64 96zM472.7 6.6L480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6z"]
};
var faCalendarCircleUser = {
  prefix: 'fas',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faArrowUpLong = {
  prefix: 'fas',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"]
};
var faLongArrowUp = faArrowUpLong;
var faPersonCarryBox = {
  prefix: 'fas',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7V241.7l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4H224 352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v96H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32v0V410.5l-64-64z"]
};
var faPersonCarry = faPersonCarryBox;
var faFireFlameSimple = {
  prefix: 'fas',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"]
};
var faBurn = faFireFlameSimple;
var faPerson = {
  prefix: 'fas',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"]
};
var faMale = faPerson;
var faLaptop = {
  prefix: 'fas',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"]
};
var faFileCsv = {
  prefix: 'fas',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
};
var faMenorah = {
  prefix: 'fas',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"]
};
var faUnion = {
  prefix: 'fas',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"]
};
var faChevronsLeft = {
  prefix: 'fas',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192l-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
};
var faChevronDoubleLeft = faChevronsLeft;
var faCircleHeart = {
  prefix: 'fas',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L131.9 280.9z"]
};
var faHeartCircle = faCircleHeart;
var faTruckPlane = {
  prefix: 'fas',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faRecordVinyl = {
  prefix: 'fas',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBringForward = {
  prefix: 'fas',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 448H448V224H384V160h64c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384h64v64zm64-96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64z"]
};
var faSquareP = {
  prefix: 'fas',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H176v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H176v88h68z"]
};
var faFaceGrinStars = {
  prefix: 'fas',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"]
};
var faGrinStars = faFaceGrinStars;
var faSigma = {
  prefix: 'fas',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M2.4 51.8C7.4 39.8 19.1 32 32 32H320c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H109.3L246.6 233.4c12.5 12.5 12.5 32.8 0 45.3L109.3 416H320V384c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 35.3-28.7 64-64 64H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L178.7 256 9.4 86.6C.2 77.5-2.5 63.7 2.4 51.8z"]
};
var faCameraMovie = {
  prefix: 'fas',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM352 256H128C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66C261.8 26.6 303.8 0 352 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM558.3 259.4c10.8 5.4 17.7 16.5 17.7 28.6V480c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48L448 448V432 336 320l12.8-9.6 64-48c9.7-7.3 22.7-8.4 33.5-3zM64 288h64H352c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V352H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64z"]
};
var faBong = {
  prefix: 'fas',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]
};
var faClarinet = {
  prefix: 'fas',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M224 144c0-8.8 7.2-16 16-16h32 96 96 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v32h76.6c9.5 0 18.7-2.8 26.6-8.1l31.9-21.3c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1V368c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8l-31.9-21.3c-7.9-5.3-17.1-8.1-26.6-8.1H108.3c-10.2 0-20.3-1.9-29.7-5.7L10.1 318.9C4 316.4 0 310.5 0 304V240c0-6.5 4-12.4 10.1-14.9l68.6-27.4c9.4-3.8 19.5-5.7 29.7-5.7H256V160H240c-8.8 0-16-7.2-16-16zm224 16H384v32h64V160zm-96 0H288v32h64V160zM272 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTruckFlatbed = {
  prefix: 'fas',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", "M608 416H576c0 53-43 96-96 96s-96-43-96-96H352 256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H88.4c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32H352V128c0-17.7 14.3-32 32-32h16 16 50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32zM416 160v96H544V237.3L466.7 160H416zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSpaghettiMonsterFlying = {
  prefix: 'fas',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faArrowDownUpAcrossLine = {
  prefix: 'fas',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"]
};
var faLeafHeart = {
  prefix: 'fas',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M272 96l0 0H376c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96l0 0zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5c-29.5 0-53.5 23.9-53.5 53.5z"]
};
var faHouseBuilding = {
  prefix: 'fas',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M368 0c-26.5 0-48 21.5-48 48V153.9l64 58.7V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H413.2c1.9 6.8 2.8 13.9 2.8 21.1V288h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416V464c0 18-6 34.6-16 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368zM512 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V208zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM400 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V112zM0 277.1V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V277.1c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1zM144 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V296z"]
};
var faCheeseSwiss = {
  prefix: 'fas',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M451 93c37.7 37.7 61 89.7 61 147.2V256H496.2 448 96 16 0c0-5.4 .7-10.7 2.1-15.8c3.8-13.7 12.4-25.8 24.5-33.9L96 160l23.2-15.4c7.8-5.2 18.4-2.3 25.5 3.8C153.1 155.6 164 160 176 160c26.5 0 48-21.5 48-48c0-5.2-.8-10.2-2.3-14.9c-2.9-9-1.6-19.9 6.3-25.1l47-31.3c8.6-5.7 18.6-8.7 28.9-8.7c56 0 106.8 22.1 144.2 58c1 1 2 2 3 2.9zM432 288h16 48 16v16V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V304 288H16 96 304c8.8 0 15.7 7.4 18.6 15.7C329.1 322.5 347 336 368 336s38.9-13.5 45.4-32.3c2.9-8.4 9.8-15.7 18.6-15.7zM224 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faSpoon = {
  prefix: 'fas',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"]
};
var faUtensilSpoon = faSpoon;
var faJarWheat = {
  prefix: 'fas',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"]
};
var faEnvelopesBulk = {
  prefix: 'fas',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", "M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"]
};
var faMailBulk = faEnvelopesBulk;
var faFileCircleExclamation = {
  prefix: 'fas',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faBowArrow = {
  prefix: 'fas',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L144.6 333.4 93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-458 85.5c-12.6-11.6-32.1-11.3-44.3 .9c-12.5 12.5-12.5 32.8 0 45.3L145.8 287 191 241.8l-90.6-90.6c56.5-30.7 125.2-30.9 181.9-.7l46.8-46.8c-83.8-53.2-191.8-53-275.4 .8zM361.5 229.7c30.2 56.7 30 125.4-.7 181.9L270.2 321 225 366.2 361.4 502.6c12.5 12.5 32.8 12.5 45.3 0c12.2-12.2 12.5-31.8 .9-44.3c53.7-83.6 54-191.6 .8-275.4l-46.8 46.8z"]
};
var faCartXmark = {
  prefix: 'fas',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM395.4 128.9L364.3 160l31.1 31.1c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L336 188.3l-31.1 31.1c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L307.7 160l-31.1-31.1c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L336 131.7l31.1-31.1c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
var faHexagonXmark = {
  prefix: 'fas',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faTimesHexagon = faHexagonXmark;
var faXmarkHexagon = faHexagonXmark;
var faCircleH = {
  prefix: 'fas',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHospitalSymbol = faCircleH;
var faMerge = {
  prefix: 'fas',
  iconName: 'merge',
  icon: [512, 512, [], "e526", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32h97.2c9.7 0 18.9 4.4 25 12L247 256 154.2 372c-6.1 7.6-15.3 12-25 12H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h97.2c29.2 0 56.7-13.3 75-36l99.2-124H384v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H303.4L204.2 100c-18.2-22.8-45.8-36-75-36H32z"]
};
var faPager = {
  prefix: 'fas',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faCartMinus = {
  prefix: 'fas',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM280 132H392c11 0 20 9 20 20s-9 20-20 20H280c-11 0-20-9-20-20s9-20 20-20z"]
};
var faAddressBook = {
  prefix: 'fas',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"]
};
var faContactBook = faAddressBook;
var faPanFrying = {
  prefix: 'fas',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9C566.7 409.2 576 427.1 576 448c0 35.3-28.7 64-64 64c-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224zM319.9 154c-21.2-5.4-50.6-22.6-65.8-38.4c-24.5-25.5-65-26.3-90.5-1.8c-11.6 11.2-18.1 25.6-19.4 40.5c-2.2 24.7-9.2 56.2-21.5 77.6c-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3c9.4-16.3 33-30 51.6-32.6c10.2-1.4 20.3-5.4 29.2-12c28.4-21.1 34.3-61.1 13.3-89.5c-9.1-12.3-21.8-20.4-35.5-23.9zM528 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faGrid = {
  prefix: 'fas',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]
};
var faGrid3 = faGrid;
var faFootballHelmet = {
  prefix: 'fas',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M488.1 194.9c4.5 17.1-8.2 33.1-25.7 35.3L340.3 245.5l14 74.5H464c26.5 0 48 21.5 48 48v32 50.4c0 25.2-20.4 45.6-45.6 45.6h-17c-54.9 0-102-39.1-112.1-93.1L327.7 352H288l9.2 18.3c4.5 9 6.8 18.9 6.8 28.9c0 35.7-29 64.7-64.7 64.7h-1.7c-9 0-17.9-1.8-26.1-5.4l-93.4-40c-4-1.7-8.3-2.6-12.6-2.6h-14c-9.1 0-17.9-3.8-23.5-10.9C35.4 364.1 16 312.3 16 256C16 123.5 123.5 16 256 16c111.4 0 205.1 75.9 232.1 178.9zm-207.1 58c-14.3 1.8-25.1 14-25.1 28.4c0 4.4 1 8.8 3 12.8l13 26h49.7l-13.2-70.6-27.4 3.4zM360.3 352l6 32H480V368c0-8.8-7.2-16-16-16H360.3zM480 416H374.7c13.1 28.7 42 48 74.7 48h17c7.5 0 13.6-6.1 13.6-13.6V416zM176 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHandLove = {
  prefix: 'fas',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M160 0c17.7 0 32 14.3 32 32V191.9l0 .1v96c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c35.3 0 64-28.7 64-64V224.1l0-.1V96c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176H284.8c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V32c0-17.7 14.3-32 32-32zm64 192c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm128 0c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
};
var faTrees = {
  prefix: 'fas',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M70.2 121.4L178.5 5.8C182 2.1 186.9 0 192 0s10 2.1 13.5 5.8L313.8 121.4c4 4.3 6.2 9.9 6.2 15.7c0 12.7-10.3 22.9-22.9 22.9H272l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H304l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H224v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H23.5C10.5 416 0 405.5 0 392.5c0-5.5 1.9-10.8 5.4-15L80 288H55.5c-13 0-23.5-10.5-23.5-23.5c0-5.5 1.9-10.8 5.4-15L112 160H86.9C74.3 160 64 149.7 64 137.1c0-5.8 2.2-11.4 6.2-15.7zm271.4-16.4L434.5 5.8C438 2.1 442.9 0 448 0s10 2.1 13.5 5.8L569.8 121.4c4 4.3 6.2 9.9 6.2 15.7c0 12.7-10.3 22.9-22.9 22.9H528l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H560l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5H480v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416l0-23.4 0-.1 0-.1V392h0c-.1-12.8-4.7-25.2-12.9-35l-40.6-48.7c13-10.2 21.4-26 21.4-43.8c0-13-4.6-25.6-12.9-35.5l-40.4-48.5c12.9-10 21.3-25.8 21.3-43.4c0-11.6-3.7-22.8-10.4-32.1z"]
};
var faStrikethrough = {
  prefix: 'fas',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"]
};
var faPage = {
  prefix: 'fas',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64z"]
};
var faK = {
  prefix: 'fas',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"]
};
var faDiagramPrevious = {
  prefix: 'fas',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", "M448 352L64 352v64l384 0V352zm0-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64H232V224l-46.1 0c-21.4 0-32.1-25.9-17-41L239 113c9.4-9.4 24.6-9.4 33.9 0L343 183c15.1 15.1 4.4 41-17 41L280 224v64H448zM365.7 160.4L295.6 90.3c-21.9-21.9-57.3-21.9-79.2 0l-70.1 70.1c-18.4 18.4-20.4 43.7-11 63.6L64 224c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H376.7c9.4-19.9 7.4-45.2-11-63.6z"]
};
var faGaugeMin = {
  prefix: 'fas',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltSlowest = faGaugeMin;
var faFolderGrid = {
  prefix: 'fas',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM104 240c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H104zm128 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H232zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V264c0-13.3-10.7-24-24-24H360c-13.3 0-24 10.7-24 24z"]
};
var faEggplant = {
  prefix: 'fas',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9V192c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48c0-5.8-4-10.7-9.4-12.6c-13.3-4.8-25.4-13-35.1-22.8s-18-21.9-22.8-35.1c-2-5.4-6.9-9.4-12.6-9.4c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16H462.1l9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6c11.8 20 32.1 34.4 55.9 38.3c6.7 14 15.8 26.3 25.8 36.2s22.2 19.1 36.2 25.8c5 30.4 27.1 55.1 56.2 63.8C410.6 362.7 311.1 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z"]
};
var faRam = {
  prefix: 'fas',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-8.8 7.2-16 16-16s16 7.2 16 16V88.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2V240c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V167.8l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21V64c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3V64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM308.5 174.1c-8.9-20.8-4.3-44 10-59.7C312.3 85.6 286.7 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40H464c-61.9 0-112-50.1-112-112V207.4c-18.7-2.7-35.5-14.8-43.5-33.4zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faLandmarkFlag = {
  prefix: 'fas',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"]
};
var faLips = {
  prefix: 'fas',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M288 101.3c3-2.4 6.2-4.8 9.7-7.3c17.8-12.7 46.8-30 78.3-30c20.3 0 42.8 9.3 61.4 19.2c20 10.6 41.1 24.7 60.2 39.5c19.1 14.8 37.1 31.2 50.8 46.5c6.8 7.6 13.1 15.7 17.9 23.7c4.3 7.2 9.7 18.3 9.7 31c0 9.2-2.6 19.1-5.3 27.5c-3 9.1-7.4 19.4-12.8 30.3c-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448H256c-84.7 0-148.8-47.1-190.2-95.1C44.9 328.8 29 303.5 18.1 281.8C12.7 271 8.4 260.7 5.3 251.5C2.6 243.1 0 233.2 0 224c0-12.8 5.5-23.8 9.7-31c4.8-8.1 11.1-16.1 17.9-23.7c13.6-15.3 31.7-31.7 50.8-46.5c19.1-14.9 40.2-29 60.2-39.5C157.2 73.3 179.7 64 200 64c31.5 0 60.6 17.2 78.3 30c3.4 2.5 6.7 4.9 9.7 7.3zM64 224c0 7.9 80 96 224 96s224-88.1 224-96c0-7.7-46.3-31.1-138.8-32c-3.4 0-6.9 .5-10.1 1.5C350 197.6 313.7 208 288 208s-62-10.4-75.1-14.4c-3.3-1-6.7-1.6-10.1-1.5C110.3 192.9 64 216.3 64 224z"]
};
var faPencil = {
  prefix: 'fas',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPencilAlt = faPencil;
var faBackward = {
  prefix: 'fas',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"]
};
var faCaretRight = {
  prefix: 'fas',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"]
};
var faComments = {
  prefix: 'fas',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"]
};
var faPaste = {
  prefix: 'fas',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V256H416c-17.7 0-32-14.3-32-32V128H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm256 88v96h96l-96-96z"]
};
var faFileClipboard = faPaste;
var faDesktopArrowDown = {
  prefix: 'fas',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352V64H512V288H64V64H224V0H64zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V174.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z"]
};
var faCodePullRequest = {
  prefix: 'fas',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPumpkin = {
  prefix: 'fas',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", "M234.6 103.9C251.5 98.8 269.4 96 288 96c22.8 0 44.7 4.2 64.8 11.7c-.6-2-.8-4.1-.8-6.3V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3z"]
};
var faClipboardList = {
  prefix: 'fas',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
};
var faPenField = {
  prefix: 'fas',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M601.9 16c-18.8-18.8-49.2-18.7-67.9 0L494.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L601.9 16zM328.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L560.8 167.5 471.7 78.4 328.5 221.8zM80 128c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V304c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16H272c17.7 0 32-14.3 32-32s-14.3-32-32-32H80zm80 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBlueberries = {
  prefix: 'fas',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM176 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-304c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V224c0-8.8 7.2-16 16-16zM384 64V96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTruckRampBox = {
  prefix: 'fas',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"]
};
var faTruckLoading = faTruckRampBox;
var faNote = {
  prefix: 'fas',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320H336c-26.5 0-48 21.5-48 48V480H64c-35.3 0-64-28.7-64-64V96zM402.7 352H448l-32 32-64 64-32 32V434.7 368c0-8.8 7.2-16 16-16h66.7zM112 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faArrowDownToSquare = {
  prefix: 'fas',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", "M374.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 242.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V242.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80H400c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faUserCheck = {
  prefix: 'fas',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCloudXmark = {
  prefix: 'fas',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm95-273c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faVialVirus = {
  prefix: 'fas',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBookBlank = {
  prefix: 'fas',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faBookAlt = faBookBlank;
var faGolfFlagHole = {
  prefix: 'fas',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24V232c0 1.3 .1 2.7 .3 4c-.2 1.3-.3 2.6-.3 4v92.8C51.5 349.4 0 380.5 0 416c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8V246.8l194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM288 416c0 17.7-28.7 32-64 32s-64-14.3-64-32s28.7-32 64-32s64 14.3 64 32z"]
};
var faMessageArrowDown = {
  prefix: 'fas',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V238.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V120z"]
};
var faCommentAltArrowDown = faMessageArrowDown;
var faFaceUnamused = {
  prefix: 'fas',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-117.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304c-8.8 0-16-7.2-16-16z"]
};
var faSheetPlastic = {
  prefix: 'fas',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"]
};
var faCircle9 = {
  prefix: 'fas',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C337.8 287.2 352 256.4 352 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]
};
var faBlog = {
  prefix: 'fas',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"]
};
var faUserNinja = {
  prefix: 'fas',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"]
};
var faPencilSlash = {
  prefix: 'fas',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.6 295.8l42.1-42.1L474.3 231l11.3-11.3-33.9-33.9-62.1-62.1L355.7 89.8l-11.3 11.3-22.6 22.6-57.8 57.8L38.8 5.1zM306.2 214.7l50.5-50.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-47.8 47.8-25.4-19.9zM195.5 250l-72.9 72.9c-10.4 10.4-18 23.3-22.2 37.4L65 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.3-88.3-77.9-61.4-27.6 27.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.9-24.9L195.5 250zM224 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.1 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM426.7 18.7L412.3 33.2 389.7 55.8 378.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L517.3 18.7c-25-25-65.5-25-90.5 0z"]
};
var faBowlingPins = {
  prefix: 'fas',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M128 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H86.5c-.5-2.7-1.1-5.4-1.8-8.1L66.9 87.1c-2-7.2-2.9-14.6-2.9-22V64C64 28.7 92.7 0 128 0zM82.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4l38.6 104.7c7.6 20.6 11.5 42.5 11.5 64.4c0 28.9-6.7 57.5-19.7 83.4l-15.7 31.4C183.2 505.2 172.1 512 160 512H96c-12.1 0-23.2-6.8-28.6-17.7L51.7 462.9C38.7 437 32 408.5 32 379.5c0-22 3.9-43.8 11.5-64.4L82.1 210.4zM384 0c35.3 0 64 28.7 64 64v1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H342.5c-.5-2.7-1.1-5.4-1.8-8.1L322.9 87.1c-2-7.2-2.9-14.6-2.9-22V64c0-35.3 28.7-64 64-64zM338.1 210.4c2.2-6 3.8-12.1 4.8-18.4h82.3c1 6.3 2.6 12.4 4.8 18.4L470 319.3c6.6 17.9 10 36.8 10 55.8c0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C440.9 504 429.1 512 416 512H352c-13.1 0-24.9-8-29.7-20.1L299.5 435C291.9 416 288 395.6 288 375.1c0-19 3.4-37.9 10-55.8l40.1-108.9z"]
};
var faPersonArrowUpFromLine = {
  prefix: 'fas',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faDownRight = {
  prefix: 'fas',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", "M336 432H96c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l72-72L11.3 171.3C4.1 164.1 0 154.2 0 144s4.1-20.1 11.3-27.3L52.7 75.3C59.9 68.1 69.8 64 80 64s20.1 4.1 27.3 11.3L241.4 209.4l72-72c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6V400c0 17.7-14.3 32-32 32z"]
};
var faScrollTorah = {
  prefix: 'fas',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"]
};
var faTorah = faScrollTorah;
var faWebhook = {
  prefix: 'fas',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M306 50c-43.1-9.9-86 16.9-95.9 60c-7.9 34.1 7.4 68.2 35.5 85.9c5.4 3.4 9.2 8.8 10.7 15s.3 12.7-3 18.1L170.4 361.5c3.6 6.7 5.6 14.4 5.6 22.5c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.6 0 1.1 0 1.7 0L201 221.9c-32.5-30.2-48.4-76.4-37.7-122.7C179.2 30.3 247.9-12.6 316.8 3.3c65.9 15.2 108 78.7 97.7 144.4c-2.1 13.1-14.3 22-27.4 20s-22-14.3-20-27.4C373.5 99.2 347.1 59.5 306 50zM289.7 176c-.6 0-1.1 0-1.7 0c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48c0 8.1-2 15.8-5.6 22.5l71.3 114.1c45.8-17.7 99.8-8.2 136.8 28.9c50 50 50 131 0 181c-43 43-109 49-158.4 18c-11.2-7-14.6-21.8-7.6-33.1s21.8-14.6 33.1-7.6c30.9 19.3 72.1 15.5 99-11.3c31.2-31.2 31.2-81.9 0-113.1c-26.8-26.8-68.1-30.6-99-11.3c-5.4 3.4-11.9 4.5-18.1 3s-11.6-5.3-15-10.7L289.7 176zM448 432c-17.8 0-33.3-9.7-41.6-24H253.8c-9.2 48.3-46 88.9-97 100.7c-68.9 15.9-137.6-27-153.5-95.9C-11 351 22.1 289.4 78.7 265.8c12.2-5.1 26.3 .7 31.4 12.9s-.7 26.3-12.9 31.4c-35.4 14.7-56 53.3-47.1 91.8c9.9 43.1 52.9 69.9 95.9 60c37-8.5 62.1-41.5 62-77.9c0-6.4 2.5-12.5 7-17s10.6-7 17-7H406.4c8.3-14.3 23.8-24 41.6-24c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faBlindsOpen = {
  prefix: 'fas',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64 64 66.7c13.6 4.8 24.4 15.6 29.3 29.3c.1 .3 .2 .7 .4 1c1.5 4.7 2.4 9.7 2.4 15c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16c4.8-13.6 15.6-24.4 29.3-29.3V192 128 64H32C14.3 64 0 49.7 0 32zm47.4 96H96v64H17.8C8 192 0 184 0 174.2c0-4 1.4-7.9 3.9-11.1L22.4 140c6.1-7.6 15.3-12 25-12zm0 160H65.6c-1 5.2-1.6 10.5-1.6 16c0 18 6 34.6 16 48H17.8C8 352 0 344 0 334.2c0-4 1.4-7.9 3.9-11.1L22.4 300c6.1-7.6 15.3-12 25-12zm446.9 64H208c10-13.4 16-30 16-48c0-5.5-.6-10.8-1.6-16H464.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8zm0-160H192V128H464.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8zM17.8 512C8 512 0 504 0 494.2c0-4 1.4-7.9 3.9-11.1L22.4 460c6.1-7.6 15.3-12 25-12H464.6c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8H17.8z"]
};
var faFence = {
  prefix: 'fas',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M76.8 38.4C73.8 34.4 69 32 64 32s-9.8 2.4-12.8 6.4L6.4 98.1C2.2 103.7 0 110.4 0 117.3V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V416h32V352H128V224h32V160H128V117.3c0-6.9-2.2-13.7-6.4-19.2L76.8 38.4zm192 0c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4L198.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V416h32V352H320V224h32V160H320V117.3c0-6.9-2.2-13.7-6.4-19.2L268.8 38.4zM448 32c-5 0-9.8 2.4-12.8 6.4L390.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V117.3c0-6.9-2.2-13.7-6.4-19.2L460.8 38.4c-3-4-7.8-6.4-12.8-6.4z"]
};
var faUp = {
  prefix: 'fas',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", "M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H256V440c0 22.1-17.9 40-40 40H168c-22.1 0-40-17.9-40-40V256H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l160-160z"]
};
var faArrowAltUp = faUp;
var faBroomBall = {
  prefix: 'fas',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faDrumstick = {
  prefix: 'fas',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M150.6 287.8c6-6 9.4-14.1 9.4-22.6V176C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176H246.8c-8.5 0-16.6 3.4-22.6 9.4l-26.8 26.8c-12.3 12.3-11.4 32.5-7.2 49.4c1.1 4.6 1.8 9.5 1.8 14.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8 .6 14.5 1.8c16.9 4.2 37.1 5.2 49.4-7.2l26.8-26.8z"]
};
var faSquareV = {
  prefix: 'fas',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm77.5 125.3L224 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"]
};
var faFaceAwesome = {
  prefix: 'fas',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm203.5-95.6c-5.6 9.4-15.8 15.6-27.5 15.6c-17.7 0-32-14.3-32-32c0-9.1 3.8-17.4 10-23.2c-3.3-.5-6.6-.8-10-.8c-35.3 0-64 28.7-64 64v10.3c0 16.4 13.3 29.7 29.7 29.7h68.6c16.4 0 29.7-13.3 29.7-29.7V184c0-8.3-1.6-16.3-4.5-23.6zM384 176c-17.7 0-32-14.3-32-32c0-8.5 3.3-16.3 8.8-22c-5.4-1.3-11-2-16.8-2c-39.8 0-72 32.2-72 72v7.5c0 13.5 11 24.5 24.5 24.5h95.1c13.5 0 24.5-11 24.5-24.5V192c0-10.4-2.2-20.2-6.1-29.1c-5.8 8-15.2 13.1-25.9 13.1zM245.5 447.8c2.7 .1 5.4 .2 8.1 .2h4.9c55.1 0 105.1-26.1 137-67.5c0 0 0 0 0 0c15.7-20.5 27-44.6 32.4-71.3c2.2-11-6.2-21.2-17.4-21.2h0H101.6h0c-11.2 0-19.6 10.2-17.4 21.2c15.6 78.1 82.4 135 161.2 138.6zm-5.4-32.5c1.5-44.1 37.8-79.4 82.2-79.4c19.9 0 38.1 7 52.3 18.7C349 392.1 306.1 416 258.4 416h-4.9c-4.6 0-9.1-.2-13.5-.6z"]
};
var faGaveDandy = faFaceAwesome;
var faDialOff = {
  prefix: 'fas',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 288c0 80.2-59 146.6-136 158.2V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V446.2c-77-11.6-136-78-136-158.2c0-88.4 71.6-160 160-160s160 71.6 160 160zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faToggleOff = {
  prefix: 'fas',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faFaceSmileHorns = {
  prefix: 'fas',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 512c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM228.1 349.5C246 370.2 276.6 392 320 392s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C413.8 396.1 375.1 424 320 424s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM272.4 272c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4zm128 32c-17.7 0-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32z"]
};
var faBoxArchive = {
  prefix: 'fas',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faArchive = faBoxArchive;
var faGrapes = {
  prefix: 'fas',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM304 152a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM112 232a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm32 80A56 56 0 1 0 32 312a56 56 0 1 0 112 0zM112 456A56 56 0 1 0 0 456a56 56 0 1 0 112 0zm144-32a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM280 288a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
var faPersonDrowning = {
  prefix: 'fas',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"]
};
var faDialMax = {
  prefix: 'fas',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM401.4 174.7c56.7 56.7 61.9 145.4 15.7 208L305.2 270.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L383.2 416.7c-62.6 46.2-151.3 41-208-15.7c-62.5-62.5-62.5-163.8 0-226.3s163.8-62.5 226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleM = {
  prefix: 'fas',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.5 137.9L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z"]
};
var faCalendarImage = {
  prefix: 'fas',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM147.2 360.7c6.5-8.4 19.1-8.3 25.5 .2L184 376l58.3-84.2c6.5-9.4 20.5-9.1 26.7 .5l83.4 131.1c6.8 10.6-.9 24.6-13.5 24.6H112.5c-13.3 0-20.8-15.2-12.7-25.8l47.3-61.5zM128 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleCaretDown = {
  prefix: 'fas',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 368c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"]
};
var faCaretCircleDown = faCircleCaretDown;
var faArrowDown91 = {
  prefix: 'fas',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faFaceGrinTongueSquint = {
  prefix: 'fas',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faShishKebab = {
  prefix: 'fas',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M438.6 73.4c-12.5-12.5-32.8-12.5-45.3 0c-8.5 8.5-11.3 20.7-8.1 31.7c3.2 10.9 5.6 24.2 4.5 38c-1.1 14-5.9 30.3-19.1 43.4L346.2 211 301 165.8l24.4-24.4c.2-.3 .5-1.3 .6-3.2c.3-3.8-.3-9.1-2.1-15.2c-9.5-32.5-1.5-69.2 24.3-94.9c37.5-37.5 98.3-37.5 135.8 0c31.4 31.4 36.5 79.2 15.3 115.9c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c7.1-12.2 5.3-28.2-5.1-38.6zM61.8 405L107 450.2 54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L61.8 405zM325.3 141.5a.1 .1 0 1 0 -.1-.2 .1 .1 0 1 0 .1 .2zM233 143L369 279c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L151 225c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM87 255c9.4-9.4 24.6-9.4 33.9 0L257 391c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0L39 337c-9.4-9.4-9.4-24.6 0-33.9l48-48z"]
};
var faSprayCan = {
  prefix: 'fas',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faAlarmSnooze = {
  prefix: 'fas',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192H312c9.2 0 17.5 5.2 21.6 13.5s3 18-2.6 25.3L249.1 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L262.9 240H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faScarecrow = {
  prefix: 'fas',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", "M320 96c0 11.2-1.9 22-5.5 32H416c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H343c-10.1 0-17.7 9.2-15.7 19.1l24.3 121.7c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3 .9L287.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-4.9 2.8-11 2.8-15.9 0L175.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1l24.3-121.7c2-9.9-5.6-19.1-15.7-19.1H32c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l7.6-11.4L6.4 204.8C2.4 201.8 0 197 0 192s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5H133.5c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 480V427.8l12.2 6.9c12.3 7 27.4 7 39.7 0l12.2-6.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faTruckMonster = {
  prefix: 'fas',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faGiftCard = {
  prefix: 'fas',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", "M353.5 68.8C361.1 55.9 374.9 48 389.8 48H392c22.1 0 40 17.9 40 40s-17.9 40-40 40H320h-1.3l34.8-59.2zm-131 0L257.3 128H256 184c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3L288 85.5l-24.1-41C247.7 16.9 218.1 0 186.2 0H184C135.4 0 96 39.4 96 88c0 14.4 3.5 28 9.6 40H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H470.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4zM512 384v64H64V384H512zm0-64H64V192H230.1l-40.5 48.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1L288 197.5l61.6 73.9c8.5 10.2 23.6 11.6 33.8 3.1s11.6-23.6 3.1-33.8L345.9 192H512V320z"]
};
var faW = {
  prefix: 'fas',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"]
};
var faCodePullRequestDraft = {
  prefix: 'fas',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", "M56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zm56 73.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V153.3zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm312-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSquareB = {
  prefix: 'fas',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 120c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H176v56h68c15.5 0 28-12.5 28-28zM176 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H244 176v56z"]
};
var faElephant = {
  prefix: 'fas',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M304 0C242.1 0 192 50.1 192 112s50.1 112 112 112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144-64.5-144-144c0-25.3 6.5-49.1 18-69.8c-20.5 7-39.4 17.3-56.1 30.4C67.4 111.9 32 175.8 32 248v19c0 12.4-1.2 24.7-3.7 36.9c-1.9 9.3-5.8 18-11.4 25.6L4.8 345.6c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l12.1-16.2c3.2-4.3 6.1-8.8 8.7-13.5V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V410c15.3 3.9 31.4 6 48 6s32.7-2.1 48-6v70c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V340.7c16.7 18.9 38.8 32.8 64 39.3v18.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4V380c22.9-5.9 43.4-18 59.4-34.4c6.2-6.3 6.1-16.4-.2-22.6c-6.3-6.2-16.3-6.1-22.5 .1c-1.3 1.3-2.6 2.6-4 3.9c-1.5 1.4-3.1 2.7-4.6 4c-8.3 6.7-17.8 12-28 15.6v0c-10 3.5-20.8 5.5-32 5.5s-22-1.9-32-5.5v0c-7.5-2.6-14.6-6.2-21.1-10.5h0c-9.1-6.1-17.2-13.7-23.7-22.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2C472.5 310 491.1 320 512 320c11.7 0 22.6-3.1 32-8.6V192c0-88.4-71.6-160-160-160h-1.6C362.2 12.2 334.5 0 304 0zM464 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faEarthAfrica = {
  prefix: 'fas',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faGlobeAfrica = faEarthAfrica;
var faRainbow = {
  prefix: 'fas',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"]
};
var faCircleNotch = {
  prefix: 'fas',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"]
};
var faTabletScreenButton = {
  prefix: 'fas',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"]
};
var faTabletAlt = faTabletScreenButton;
var faPaw = {
  prefix: 'fas',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"]
};
var faMessageQuestion = {
  prefix: 'fas',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCloud = {
  prefix: 'fas',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"]
};
var faTrowelBricks = {
  prefix: 'fas',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"]
};
var faSquare3 = {
  prefix: 'fas',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H280c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H208c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFaceFlushed = {
  prefix: 'fas',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faFlushed = faFaceFlushed;
var faHospitalUser = {
  prefix: 'fas',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"]
};
var faMicrowave = {
  prefix: 'fas',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"]
};
var faChfSign = {
  prefix: 'fas',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M0 113.4C0 68.5 36.5 32 81.4 32c30.8 0 59 17.4 72.8 45l2.3 4.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L97 105.6c-3-5.9-9-9.6-15.6-9.6C71.8 96 64 103.8 64 113.4V398.6c0 9.6 7.8 17.4 17.4 17.4c6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45C36.5 480 0 443.5 0 398.6V113.4zM224 32c17.7 0 32 14.3 32 32V224h96V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H256V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM448 64c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V224h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64z"]
};
var faTentArrowLeftRight = {
  prefix: 'fas',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faCartCircleArrowUp = {
  prefix: 'fas',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faTrashClock = {
  prefix: 'fas',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H330.8C285.6 480.1 256 427.5 256 368c0-90.4 68.2-164.9 155.9-174.9L416 128zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faGavel = {
  prefix: 'fas',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"]
};
var faLegal = faGavel;
var faSprinklerCeiling = {
  prefix: 'fas',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0V96c0 15.3 10.8 28.4 25.7 31.4L128 147.8V82.6L64 69.8V0H0zM256 82.6v65.3l102.3-20.5c15-3 25.7-16.1 25.7-31.4V0H320V69.8L256 82.6zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V64z"]
};
var faBrowsers = {
  prefix: 'fas',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM280 72H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zM224 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faTrillium = {
  prefix: 'fas',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M128 160c0-64.1 61.6-128.2 86.1-151.1c5.6-5.3 14.1-5.3 19.8 0c24.5 23 86.1 87 86.1 151.1c0 15.7-3.7 30.4-10.4 43.5c16.2 0 32.6 4.2 47.7 12.9c55.5 32 80.2 117.4 87.8 150.2c1.8 7.5-2.5 14.9-9.9 17.1c-32.1 9.7-118.4 31.1-173.9-1c-16.6-9.6-29.2-23.3-37.4-39.2c-8.1 15.9-20.8 29.6-37.4 39.2c-55.5 32-141.8 10.7-173.9 1c-7.4-2.2-11.6-9.6-9.9-17.1c7.6-32.7 32.3-118.1 87.8-150.2c15.1-8.7 31.6-12.9 47.8-12.9C131.7 190.4 128 175.7 128 160zm136 80a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm88-80v0c0-12.5-1.8-24.8-4.8-36.6c38.6-12.8 68.2-11.9 83-10c14.9 1.9 23.7 17.1 17.9 31c-5.6 13.3-19 38.4-47.7 64.6c-8.1-7.7-17.1-14.6-27-20.3l0 0c-7.3-4.2-14.9-7.6-22.6-10.3c.9-6 1.3-12.1 1.3-18.4zM100.8 123.4c-3 11.8-4.8 24.1-4.8 36.6c0 6.2 .4 12.3 1.3 18.3c-7.8 2.7-15.4 6.1-22.7 10.3l0 0c-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31c14.7-1.9 44.4-2.8 83 10zm73.3 299.4c9.8-3.1 19.4-7.2 28.5-12.5c7.8-4.5 14.9-9.7 21.4-15.4c6.5 5.8 13.6 11 21.4 15.4c9.2 5.3 18.8 9.4 28.6 12.5c-8.2 36.1-22.6 61.6-31 74.2c-9.1 13.7-28.8 13.7-37.9 0c-8.3-12.6-22.8-38.2-31-74.3z"]
};
var faMusicSlash = {
  prefix: 'fas',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-71.5-56C569.8 400.2 576 384.7 576 368V104 32c0-10.1-4.8-19.6-12.9-25.7s-18.6-7.9-28.3-5l-320 96c-12.7 3.8-21.6 14.9-22.7 27.9L38.8 5.1zM300.7 210.4L512 147V292.6c-10-2.9-20.8-4.6-32-4.6c-22.2 0-42.6 6.3-58.8 16.8L300.7 210.4zM192 247.3V356.6c-10-3-20.8-4.6-32-4.6c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80V297.7l-64-50.4z"]
};
var faTruckRamp = {
  prefix: 'fas',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", "M640 400V0H416c-35.3 0-64 28.7-64 64V353.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416 402.7C417.5 463.3 467 512 528 512c61.9 0 112-50.1 112-112zM528 352a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faBinoculars = {
  prefix: 'fas',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"]
};
var faMicrophoneSlash = {
  prefix: 'fas',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4z"]
};
var faBoxTissue = {
  prefix: 'fas',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"]
};
var faCircleC = {
  prefix: 'fas',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"]
};
var faStarChristmas = {
  prefix: 'fas',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M15.5 275.9L192 320l44.1 176.5c2.3 9.1 10.5 15.5 19.9 15.5s17.6-6.4 19.9-15.5L320 320l176.5-44.1c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L320 192 275.9 15.5C273.6 6.4 265.4 0 256 0s-17.6 6.4-19.9 15.5L192 192 15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zM441 71c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336l-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z"]
};
var faChartBullet = {
  prefix: 'fas',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M264 32c13.3 0 24 10.7 24 24v8H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64H240V56c0-13.3 10.7-24 24-24zM160 128v32h80V128H160zm128 0v32H448V128H288zm48 256V352H256v32h80zm0 64H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H336v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H384v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8zm48-96v32h64V352H384z"]
};
var faMotorcycle = {
  prefix: 'fas',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTreeChristmas = {
  prefix: 'fas',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", "M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zM263 165l11.8-31.5 144 180c3.4 4.2 5.2 9.4 5.2 14.8c0 13.1-10.6 23.7-23.7 23.7H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2c0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H47.7C34.6 352 24 341.4 24 328.3c0-5.4 1.8-10.6 5.2-14.8l144-180L185 165c6.1 16.2 21.6 27 39 27s32.9-10.8 39-27zM184 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM288 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faTireFlat = {
  prefix: 'fas',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M256 32C114.6 32 0 146.6 0 288c0 47.3 12.8 91.7 35.2 129.7C14.9 423.3 0 441.9 0 464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48c0-22.1-14.9-40.7-35.2-46.3c22.4-38 35.2-82.4 35.2-129.7C512 146.6 397.4 32 256 32zm96 384c-2.1 1.6-4.3 3.2-6.6 4.7C319.9 437.9 289.1 448 256 448c-36 0-69.3-11.9-96-32c-38.9-29.2-64-75.7-64-128c0-88.4 71.6-160 160-160s160 71.6 160 160c0 52.3-25.1 98.8-64 128zm-96-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm16 95c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6l0 65zM381.7 312.2c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4l61.8 20.1zM256 224c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM128 288c0 8.3 .8 16.3 2.3 24.2L192.1 292c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1z"]
};
var faSunglasses = {
  prefix: 'fas',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368l105.6-52.8c-10.7-1.9-22.2-3.2-33.9-3.2c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zm409.8-10.3c-10.5-1.9-21.9-3.1-33.4-3.1c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.3 41.2 102.3-51.1z"]
};
var faBadge = {
  prefix: 'fas',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z"]
};
var faMessagePen = {
  prefix: 'fas',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm340.8 59c-14.7-14.7-38.6-14.7-53.3 0L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6l-71.9 71.9z"]
};
var faCommentAltEdit = faMessagePen;
var faMessageEdit = faMessagePen;
var faBellConcierge = {
  prefix: 'fas',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faConciergeBell = faBellConcierge;
var faPenRuler = {
  prefix: 'fas',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"]
};
var faPencilRuler = faPenRuler;
var faArrowProgress = {
  prefix: 'fas',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M448 128A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM128 32C57.3 32 0 89.3 0 160s57.3 128 128 128H384c35.3 0 64 28.7 64 64c0 27.9-17.9 51.7-42.8 60.4c-11.5-17.1-31-28.4-53.2-28.4c-35.3 0-64 28.7-64 64s28.7 64 64 64c24.7 0 46.1-14 56.8-34.4C467.6 466.1 512 414.2 512 352c0-70.7-57.3-128-128-128H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H256v14.1c0 9.9 8 17.9 17.9 17.9c4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9L284.8 3.8c-3.1-2.4-7-3.8-11-3.8C264 0 256 8 256 17.9V32H128zm-8.6 384c-11.1-19.1-31.7-32-55.4-32c-35.3 0-64 28.7-64 64s28.7 64 64 64c23.7 0 44.4-12.9 55.4-32H160v14.1c0 9.9 8 17.9 17.9 17.9c4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9l-60.8-47.3c-3.1-2.4-7-3.8-11-3.8c-9.9 0-17.9 8-17.9 17.9V416H119.4z"]
};
var faChessRookPiece = {
  prefix: 'fas',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M67.4 384L80 264 49.4 233.4c-6-6-9.4-14.1-9.4-22.6V112c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V112c0-8.8 7.2-16 16-16h24c8.8 0 16 7.2 16 16v98.7c0 8.5-3.4 16.6-9.4 22.6L240 264l12.6 120H67.4zM136 280.9c0 3.9 3.2 7.1 7.1 7.1h33.8c3.9 0 7.1-3.2 7.1-7.1V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v32.9zM20.8 473.6L64 416H256l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24c0-5.2 1.7-10.2 4.8-14.4z"]
};
var faChessRookAlt = faChessRookPiece;
var faSquareRoot = {
  prefix: 'fas',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1z"]
};
var faAlbumCollectionCirclePlus = {
  prefix: 'fas',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", "M32 24c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42H394.8c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2H48zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H472c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPeopleArrows = {
  prefix: 'fas',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faFaceAngryHorns = {
  prefix: 'fas',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M576 256c0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.6 3.5-48.4 9.9-70.9C29.6 125.8 6.5 50.1 .3 19.1C-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1c23.3 7 46 12.2 63 15.5C209.1 19.1 262.3 0 320 0s110.9 19.1 153.8 51.3c17-3.3 39.7-8.6 63-15.5c29.8-8.9 59.1-20.2 78.4-33.1c5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166c6.5 22.5 9.9 46.3 9.9 70.9zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faMarsAndVenusBurst = {
  prefix: 'fas',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H376c0 13.3 10.7 24 24 24s24-10.7 24-24H400l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"]
};
var faTombstone = {
  prefix: 'fas',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M32 192C32 86 118 0 224 0S416 86 416 192V416H32V192zM0 480c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM248 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v40H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h48V328c0 13.3 10.7 24 24 24s24-10.7 24-24V208h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V120z"]
};
var faSquareCaretRight = {
  prefix: 'fas',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"]
};
var faCaretSquareRight = faSquareCaretRight;
var faScissors = {
  prefix: 'fas',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCut = faScissors;
var faListMusic = {
  prefix: 'fas',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", "M498.7 6c8.3 6 13.3 15.7 13.3 26V96c0 13.8-8.8 26-21.9 30.4L416 151.1V432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c17.2 0 33.5 2.8 48 7.7V128 64c0-13.8 8.8-26 21.9-30.4l96-32C479.6-1.6 490.4 0 498.7 6zM32 64H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96S14.3 64 32 64zm0 128H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faSunPlantWilt = {
  prefix: 'fas',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"]
};
var faToiletsPortable = {
  prefix: 'fas',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"]
};
var faHockeyPuck = {
  prefix: 'fas',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"]
};
var faMustache = {
  prefix: 'fas',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M147.9 148.4C169.3 125.2 199.4 112 231 112c33 0 64.4 14.4 85.9 39.5l3.1 3.6 3.1-3.6C344.6 126.4 376 112 409 112c31.6 0 61.7 13.2 83.1 36.4l2 2.1c27.6 29.9 74.6 30.9 103.4 2.1L599 151c2.5-2.5 5.5-4.4 8.6-5.5c2.6-1 5.4-1.5 8.4-1.5c5.7 0 10.9 2 15 5.2c1.3 1.1 2.6 2.3 3.6 3.6c.4 .5 .7 1 1.1 1.4c.3 .4 .5 .8 .7 1.1c.3 .5 .6 .9 .8 1.4c1.8 3.3 2.7 7.1 2.7 11.2v39.4C640 313.8 553.8 400 447.4 400c-46.7 0-91.7-16.9-126.9-47.7l-.5-.4-.5 .4C284.4 383.1 239.3 400 192.6 400C86.2 400 0 313.8 0 207.4V168c0-4.2 1.1-8.1 2.9-11.5c.6-1 1.2-2.1 2-3c1.2-1.6 2.6-3 4.1-4.2c1.5-1.2 3.1-2.2 4.8-3c3.1-1.5 6.5-2.3 10.2-2.3c2.9 0 5.8 .5 8.4 1.5c3.1 1.2 6.1 3 8.6 5.5l1.6 1.6c28.8 28.8 75.8 27.9 103.4-2.1l2-2.1z"]
};
var faHyphen = {
  prefix: 'fas',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 256c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faTable = {
  prefix: 'fas',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faUserChef = {
  prefix: 'fas',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M384 48c0 20.9-13.4 38.7-32 45.3V112v64c0 70.7-57.3 128-128 128s-128-57.3-128-128V112 93.3C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176V160H144v16c0 44.2 35.8 80 80 80s80-35.8 80-80zM178.4 340.6c7.5 1.9 8.2 12.3 1 15.2l-43.2 17.3C111.9 382.8 96 406.3 96 432.5V480v24 8H88 64 25.6C11.5 512 0 500.5 0 486.4c0-58.8 37.7-108.8 90.3-127c3.3-1.2 5.7-4.3 5.7-7.8V330.2c0-5.2 4.9-9 9.9-7.8l72.5 18.1zM352 512H160 136h-8v-8V480 432.5c0-13.1 8-24.9 20.1-29.7L341 325.6c5.3-2.1 11 1.8 11 7.4v18.6c0 3.5 2.3 6.6 5.7 7.8c52.6 18.2 90.3 68.2 90.3 127c0 14.1-11.5 25.6-25.6 25.6H352zM224 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faMessageImage = {
  prefix: 'fas',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm176 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 201c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 132 304 128 296 128z"]
};
var faCommentAltImage = faMessageImage;
var faUsersMedical = {
  prefix: 'fas',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM405.3 320h77.4c6.6-18.6 24.4-32 45.3-32h32c20.9 0 38.7 13.4 45.3 32h13.4c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM416 400c0-14.6 6.5-27.7 16.9-36.5C416.3 356.1 398 352 378.7 352H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H482.7c-1.8-5-2.7-10.4-2.7-16V480H464c-26.5 0-48-21.5-48-48V400zm0-176a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm96 112v48H464c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H576V336c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16z"]
};
var faSensorTriangleExclamation = {
  prefix: 'fas',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H225c-.6-4-1-8.1-1-12.3c0-13.2 3.4-26.2 9.9-37.7l150.4-265c13-22.9 37.3-37.1 63.7-37.1V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm53.8 325.8c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3H595.7c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265zM464 272v88c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSensorAlert = faSensorTriangleExclamation;
var faMagnifyingGlassArrowRight = {
  prefix: 'fas',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"]
};
var faTachographDigital = {
  prefix: 'fas',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faDigitalTachograph = faTachographDigital;
var faFaceMask = {
  prefix: 'fas',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", "M410.5 281.7L541.8 222C525.1 96.7 417.9 0 288 0S50.9 96.7 34.2 222l131.3 59.7c8-15.3 24.1-25.7 42.5-25.7H368c18.4 0 34.5 10.4 42.5 25.7zm5.5 32.6V384h93.8c21.8-37.6 34.2-81.3 34.2-127.9L416 314.3zM413.3 416c-6.6 18.6-24.4 32-45.3 32H208c-20.9 0-38.7-13.4-45.3-32H88.1c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96H413.3zM160 384V314.3L32 256.1c0 46.6 12.5 90.3 34.2 127.9H160zm-4.7-180.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C146.4 167 184.6 144 240 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-47 0-77.1 19.7-84.7 27.3zM336 176c-8.8 0-16-7.2-16-16s7.2-16 16-16c55.4 0 93.6 23 107.3 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C413.1 195.7 383 176 336 176zM208 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"]
};
var faPickleball = {
  prefix: 'fas',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M250.4 28c37.5-37.4 98.4-37.4 136 0L499.9 141.3c29.2 29.2 35.7 72.4 19.4 107.8c-24.9-15.8-54.4-25-86.1-25c-72 0-133 47.3-153.3 112.5L155.7 212.8c-6.3-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L273 374.9c-.2 3-.3 6.1-.3 9.1c0 27.8 7.1 53.8 19.6 76.6c-9.3 .5-18.7-1-27.6-4.7l-56.7-23.2c-23.9-9.8-51.4-4.3-69.6 13.9L84.4 500.3c-15.6 15.6-41 15.6-56.7 0s-15.6-40.9 0-56.5l53.5-53.4c18.4-18.3 23.8-45.8 13.9-69.8L71.1 262.8c-10-23.9-4.5-51.4 13.9-69.7L250.4 28zM304 384a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm32-16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-80-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"]
};
var faStarSharpHalf = {
  prefix: 'fas',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M254.4 50.4L214.5 176H90.3 88 74.7 56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4 103.7 80.7L132 446.7l-1.1 3.5L126.1 465l-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4V325.3 155.9 0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9l0 0-4.6 14.3-1 3.2z"]
};
var faUsersSlash = {
  prefix: 'fas',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"]
};
var faClover = {
  prefix: 'fas',
  iconName: 'clover',
  icon: [448, 512, [], "e139", "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"]
};
var faMeat = {
  prefix: 'fas',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384H212.6c-7.1 0-13.9 2.8-18.9 7.8c-10.3 10.3-9.7 26.9-5 40.7c2.1 6.1 3.2 12.7 3.2 19.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c6.8 0 13.4 1.1 19.5 3.2c13.8 4.7 30.4 5.3 40.7-5c5-5 7.8-11.8 7.8-18.9V241.3c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2S299.1 33.2 270.2 62.2s-12.2 92.6 37.4 142.2zm36.3-36.3c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5s20.4 34.9 11.5 43.8s-28.5 3.7-43.8-11.5z"]
};
var faReply = {
  prefix: 'fas',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"]
};
var faMailReply = faReply;
var faStarAndCrescent = {
  prefix: 'fas',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"]
};
var faEmptySet = {
  prefix: 'fas',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", "M435.4 121.9l67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1zm-91.2 .7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5zm-176.5 267L389.5 167.8C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z"]
};
var faHouseFire = {
  prefix: 'fas',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faSquareMinus = {
  prefix: 'fas',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMinusSquare = faSquareMinus;
var faHelicopter = {
  prefix: 'fas',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"]
};
var faBird = {
  prefix: 'fas',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M0 192v-3.6C0 172.7 12.7 160 28.4 160H224c17.7 0 32-14.3 32-32V96c0-53 43-96 96-96c47.5 0 86.9 34.5 94.6 79.7l57.6 34.6c4.8 2.9 7.8 8.1 7.8 13.7s-2.9 10.8-7.8 13.7L448 175.5V192c0 93.9-57.7 174.3-139.7 207.6l40.9 77.2c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-45.7-86.3C249 415 236.6 416 224 416c-1 0-2 0-3 0l32.2 60.8c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-48.6-91.9C68.5 380.5 0 294.3 0 192zm376-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCompass = {
  prefix: 'fas',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSquareCaretDown = {
  prefix: 'fas',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"]
};
var faCaretSquareDown = faSquareCaretDown;
var faHeartHalfStroke = {
  prefix: 'fas',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M256 186.5V407.4L420.7 253.6c17.4-16.2 27.3-38.9 27.3-62.7v-5.8c0-38.6-27.9-71.5-66-77.9c-25.1-4.2-50.8 4-68.8 22l-12 12L256 186.5zM119.4 44.1C165 36.5 211.3 51.4 244 84l0 0 12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"]
};
var faHeartHalfAlt = faHeartHalfStroke;
var faFileCircleQuestion = {
  prefix: 'fas',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"]
};
var faLaptopCode = {
  prefix: 'fas',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faJoystick = {
  prefix: 'fas',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M336 112c0 50.7-33.7 93.6-80 107.4V320H192V219.4c-46.3-13.8-80-56.6-80-107.4C112 50.1 162.1 0 224 0s112 50.1 112 112zM200 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 352c0-17.7 14.3-32 32-32s32 14.3 32 32H384c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64z"]
};
var faGrillFire = {
  prefix: 'fas',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", "M0 72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40V96c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1c-17.7-16-44.7-16-62.5-.1c-35.4 31.6-65.6 67.7-87.3 102.8c-15 24.3-27.7 51-33.6 77.3c-1.2 0-2.4 0-3.6 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368h73c1.5 16.6 5.2 32.7 10.7 48H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96V72zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM389.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 56.7 24.2 76.9C576 437.9 504.7 512 416 512c-89.7 0-160-74.2-160-161.9c0-26.4 12.7-58.6 32.4-90.6c20-32.4 48.1-66.1 81.4-95.8c5.6-5 14.2-5 19.8 0zM466 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faRectangleVerticalHistory = {
  prefix: 'fas',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", "M256 0c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H256zM96 72V440c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-13.3-10.7-24-24-24s-24 10.7-24 24zM0 120V392c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24S0 106.7 0 120z"]
};
var faSwatchbook = {
  prefix: 'fas',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faPrescriptionBottle = {
  prefix: 'fas',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"]
};
var faBars = {
  prefix: 'fas',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faNavicon = faBars;
var faKeyboardLeft = {
  prefix: 'fas',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M224 64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM224 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM320 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336zM432 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM416 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V240zM528 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM512 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM113.2 153.8c-9-3.7-19.3-1.7-26.2 5.2L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V176c0-9.7-5.8-18.5-14.8-22.2z"]
};
var faPeopleGroup = {
  prefix: 'fas',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"]
};
var faHourglassEnd = {
  prefix: 'fas',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"]
};
var faHourglass3 = faHourglassEnd;
var faHeartCrack = {
  prefix: 'fas',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"]
};
var faHeartBroken = faHeartCrack;
var faFaceBeamHandOverMouth = {
  prefix: 'fas',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM217.6 212.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm-78.3 63.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faDropletPercent = {
  prefix: 'fas',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zm75.3-267.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHumidity = faDropletPercent;
var faSquareUpRight = {
  prefix: 'fas',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faFaceKissBeam = {
  prefix: 'fas',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faKissBeam = faFaceKissBeam;
var faCorn = {
  prefix: 'fas',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M512 40c0 15-8.3 28.1-20.5 34.9C499.2 82.2 504 92.6 504 104c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 22.1-17.9 40-40 40c-1.1 0-2.3 0-3.4-.1c2.2 4.9 3.4 10.4 3.4 16.1c0 13.6-6.8 25.7-17.3 32.9c-47.7-29.7-103.6-41.1-157.5-34.2c6.9-53.9-4.5-109.8-34.2-157.5C214.3 102.8 226.4 96 240 96c5.7 0 11.2 1.2 16.1 3.4c-.1-1.1-.1-2.2-.1-3.4c0-22.1 17.9-40 40-40c6.4 0 12.4 1.5 17.8 4.2C318.8 43.8 334 32 352 32c6.4 0 12.4 1.5 17.8 4.2C374.8 19.8 390 8 408 8c11.4 0 21.8 4.8 29.1 12.5C443.9 8.3 457 0 472 0c22.1 0 40 17.9 40 40zM137.7 98c1.2-6.3 8.9-8.7 13.2-3.9c45.4 50.5 69.5 114 56.9 183.4c-38.7 10.7-75.2 31.2-105.5 61.6L24.9 416.5c-34.2-37.7-33.1-96 3.2-132.4l64-64c18.3-18.3 30.6-41.7 35.3-67.1L137.7 98zM92.1 483.9L47.4 439.2l77.5-77.5c28.6-28.6 63.5-47.1 100.1-55.6c72.2-16.6 139.8 7.4 192.8 55c4.8 4.3 2.4 12.1-3.9 13.2l-54.9 10.2c-25.4 4.7-48.8 17-67.1 35.3l-64 64c-37.5 37.5-98.3 37.5-135.8 0z"]
};
var faRollerCoaster = {
  prefix: 'fas',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", "M64 190.1c0-31.8 15.8-60 40-77V456c0 13.3 10.7 24 24 24s24-10.7 24-24V96.2c2-.1 4-.2 6.1-.2c14.8 0 29.1 3.5 41.9 9.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V154.7l48 69.1V456c0 13.3 10.7 24 24 24s24-10.7 24-24V292.9l20.3 29.2c7.9 11.3 17.2 21.3 27.7 29.8V456c0 13.3 10.7 24 24 24s24-10.7 24-24V377.6c13.6 4.2 28 6.4 42.6 6.4H488v72c0 13.3 10.7 24 24 24s24-10.7 24-24V378.4c14.4-4.2 27.8-10.5 40-18.6V448c0 17.7 14.3 32 32 32s32-14.3 32-32V248h-.2c.1-2.6 .2-5.3 .2-8c0-79.5-64.5-144-144-144h-4c-28.9 0-57.3 7.1-82.8 20.7l-51.6 27.5L432 251.3V177.1l7.3-3.9c12.7-6.8 26.5-11 40.7-12.5V264c0 13.3 10.7 24 24 24s24-10.7 24-24V166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80H482.6c-26.2 0-50.8-12.8-65.7-34.4L287.9 99.9C258.4 57.4 209.9 32 158.1 32C70.8 32 0 102.8 0 190.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V190.1z"]
};
var faPhotoFilmMusic = {
  prefix: 'fas',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M192 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9h64l0 64H256c-35.3 0-64-28.7-64-64V64zM319.5 404.6c-13.8 10.3-25.2 25.2-29.6 43.4H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96V360c0 17.7 14.3 32 32 32H342.2c-8.2 3.3-15.8 7.5-22.6 12.6zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM56 168v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V264c0-8.8-7.2-16-16-16H72zM56 360v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V360c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
var faRadar = {
  prefix: 'fas',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M304.8 173.3c-14.3-8.4-31-13.3-48.8-13.3c-53 0-96 43-96 96s43 96 96 96s96-43 96-96h64c0 73.5-49.6 135.5-117.2 154.2C290.8 394.7 274.7 384 256 384s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6c14.4-8.3 24.1-23.8 24.1-41.7c0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2l22.8-22.8C341.2 79 300.4 64 256 64C163.1 64 85.7 129.9 67.9 217.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4c19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256h64c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l23.8-23.8z"]
};
var faSickle = {
  prefix: 'fas',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M212.7 340.7L181 309c-33.9-33.9-53-80-53-128C128 81 209 0 309 0h11c90.1 0 165.8 62.1 186.4 145.8c1.8 7.3-4 14.2-11.5 14.2c-3.9 0-7.5-1.9-9.9-4.9C458.9 122.9 419.5 104 377.8 104C301.7 104 240 165.7 240 241.8v9.8c0 20.7 5.2 39.7 12.2 58.6c2.2 6 .9 12.8-3.7 17.3l-13.2 13.2c-6.2 6.2-16.4 6.2-22.6 0zM121 311l24 24 32 32 24 24c9.4 9.4 9.4 24.6 0 33.9l-16 16c-9.4 9.4-24.6 9.4-33.9 0l-7-7L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l71-71-7-7c-9.4-9.4-9.4-24.6 0-33.9l16-16c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faFilm = {
  prefix: 'fas',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"]
};
var faCoconut = {
  prefix: 'fas',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M141.2 141.2c-43.7 43.7-73 91.8-85.8 133.3c-13.2 42.7-7.4 71.9 7.5 86.7s44 20.6 86.7 7.5c41.5-12.8 89.6-42.1 133.3-85.8s73-91.8 85.8-133.3c13.2-42.7 7.4-71.9-7.5-86.7s-44-20.6-86.7-7.5C233 68.1 184.9 97.5 141.2 141.2zM260.4 9.5C309.6-5.7 361.5-4.8 395.2 28.8l40.9 40.9C484.7 118.4 512 184.3 512 252.9C512 396 396 512 253 512c-68.7 0-134.6-27.3-183.2-75.9l-41-41C-4.8 361.5-5.7 309.6 9.5 260.3c15.6-50.4 49.7-105 97.8-153.1S210 25 260.4 9.5zm63.5 88.1c25 25-5.4 95.9-67.9 158.4s-133.4 92.9-158.4 67.9s5.4-95.9 67.9-158.4S298.9 72.6 323.9 97.6zm95.4 107.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-56 136c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-136 56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32z"]
};
var faRulerHorizontal = {
  prefix: 'fas',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"]
};
var faShieldCross = {
  prefix: 'fas',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 66.8l32 13.6V128c0 17.7 14.3 32 32 32H431.3c-1.2 19.6-4.2 41.4-9.4 64H320c-17.7 0-32 14.3-32 32V426.8c-10 6.5-20.7 12.5-32 18c-11.3-5.5-22-11.5-32-18V256c0-17.7-14.3-32-32-32H90.1c-5.2-22.6-8.1-44.4-9.4-64H192c17.7 0 32-14.3 32-32V80.3l32-13.6z"]
};
var faCassetteTape = {
  prefix: 'fas',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H483.1l-36.3-96.9c-7-18.7-24.9-31.1-44.9-31.1H174.2c-20 0-37.9 12.4-44.9 31.1L92.9 480H64c-35.3 0-64-28.7-64-64V96zM416.8 394.4L448.9 480H127.1l32.1-85.6c2.3-6.2 8.3-10.4 15-10.4H401.8c6.7 0 12.6 4.1 15 10.4zM341.5 192H234.5c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32H341.5c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32zm90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM112 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faSquareTerminal = {
  prefix: 'fas',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm70.3 55.8c-9 9.8-8.3 25 1.5 33.9L148.5 256 71.8 326.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faPeopleRobbery = {
  prefix: 'fas',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"]
};
var faLightbulb = {
  prefix: 'fas',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"]
};
var faCaretLeft = {
  prefix: 'fas',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"]
};
var faCommentMiddle = {
  prefix: 'fas',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M188.3 408.7l44.5 89c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3l44.5-89C432.2 384.5 512 303.8 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 95.8 79.8 176.5 188.3 200.7z"]
};
var faTrashCanList = {
  prefix: 'fas',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M147.8 0c-12.1 0-23.2 6.8-28.6 17.7L112 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H304l-7.2-14.3C291.4 6.8 280.3 0 268.2 0H147.8zM384 128H32V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V128zM160 208V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm192-80c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H480zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H480zM448 416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"]
};
var faBlock = {
  prefix: 'fas',
  iconName: 'block',
  icon: [640, 512, [], "e46a", "M96 96c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96zm96 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM192 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCircleExclamation = {
  prefix: 'fas',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faExclamationCircle = faCircleExclamation;
var faSchoolCircleXmark = {
  prefix: 'fas',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
var faArrowRightFromBracket = {
  prefix: 'fas',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"]
};
var faSignOut = faArrowRightFromBracket;
var faFaceFrownSlight = {
  prefix: 'fas',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm91.9-117.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleChevronDown = {
  prefix: 'fas',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"]
};
var faChevronCircleDown = faCircleChevronDown;
var faSidebarFlip = {
  prefix: 'fas',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zM288 96V416H64V96H288zm136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48zm24 120c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48z"]
};
var faUnlockKeyhole = {
  prefix: 'fas',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"]
};
var faUnlockAlt = faUnlockKeyhole;
var faTemperatureList = {
  prefix: 'fas',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM352 32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352zM320 192c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z"]
};
var faCloudShowersHeavy = {
  prefix: 'fas',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"]
};
var faHeadphonesSimple = {
  prefix: 'fas',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"]
};
var faHeadphonesAlt = faHeadphonesSimple;
var faSitemap = {
  prefix: 'fas',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"]
};
var faPipeSection = {
  prefix: 'fas',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M32 96C14.3 96 0 110.3 0 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32zm576 0c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32zm-64 32H96V384H544V128z"]
};
var faSpaceStationMoonConstruction = {
  prefix: 'fas',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0c57.8 0 111.1 19.1 153.9 51.4c3.9 2.9 6.1 7.5 6.1 12.4V80c0 8.8-7.2 16-16 16H368c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48 16c8.8 0 16 7.2 16 16v32c0 8.8 7.2 16 16 16h31.9c8.1 0 14.9 6 15.5 14.1c.4 5.9 .6 11.9 .6 17.9zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352c44.3 0 87.3-3.2 128-9.2V368c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16v19.3c0 3.9-1.4 7.7-4.1 10.5C397.2 480.4 330.3 512 256 512zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
var faCircleDollarToSlot = {
  prefix: 'fas',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faDonate = faCircleDollarToSlot;
var faMemory = {
  prefix: 'fas',
  iconName: 'memory',
  icon: [576, 512, [], "f538", "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faFaceSleeping = {
  prefix: 'fas',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", "M512 256c0-46.6-12.5-90.3-34.2-128H432c-19.4 0-36.9-11.7-44.3-29.6c-7.1-17.1-3.7-36.7 8.6-50.4c-2.9-3.2-5.4-6.9-7.3-10.8C350.2 13.6 304.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM272 96c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L310.6 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L297.4 96H272zM216 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM416 16c0 8.8 7.2 16 16 16h25.4L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H470.6l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0H432c-8.8 0-16 7.2-16 16z"]
};
var faRoadSpikes = {
  prefix: 'fas',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faFireBurner = {
  prefix: 'fas',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSquirrel = {
  prefix: 'fas',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M160 296.2c0 2-.7 3.9-2 5.4c-18.7 22.3-30 51-30 82.3c0 70.7 57.3 128 128 128h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H432c10-13.4 16-30 16-48c0-26.2-12.6-49.4-32-64c-13.4-10-30-16-48-16c-9.4 0-18.3 1.6-26.7 4.5c-8.3 2.9-17.5-1.4-20.4-9.8s1.4-17.5 9.8-20.4c11.7-4.1 24.3-6.4 37.3-6.4c17.2 0 33.5 3.9 48 10.8V240h21.2c26.7 0 51.7-13.4 66.6-35.6L512 192c0-53-43-96-96-96V75.2C416 69 411 64 404.8 64c-15.2 0-28.7 7.6-36.8 19.2C359.9 71.6 346.4 64 331.2 64C325 64 320 69 320 75.2V96c0 54.4-10.5 108.1-30.7 158c-.9-2-1.3-4.2-1.3-6.4V144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144c2.3 0 4.6-.1 6.9-.2c4.9-.2 9.1 3.5 9.1 8.4zM416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faArrowUpToLine = {
  prefix: 'fas',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM214.6 169.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 269.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"]
};
var faArrowToTop = faArrowUpToLine;
var faFlag = {
  prefix: 'fas',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"]
};
var faFaceCowboyHat = {
  prefix: 'fas',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M216 0c9.1 0 17.9 4 26.1 10.7c7.9 6.5 19.8 6.5 27.7 0C278.1 4 286.9 0 296 0c36.8 0 67.4 64.9 82.4 109.8C412 99.3 442 84.6 466.9 66.8c2.5-1.8 5.4-2.8 8.4-2.8c8.9 0 15.6 8.3 12.9 16.7C461.2 163.2 367.5 224 256 224S50.8 163.2 23.8 80.7C21 72.3 27.7 64 36.7 64c3 0 6 1 8.4 2.8C70 84.6 100 99.3 133.6 109.8C148.6 64.9 179.2 0 216 0zM48 304c0-37.9 10.1-73.4 27.8-104c48.8 35.3 112.5 56 180.2 56s131.4-20.6 180.2-56c17.7 30.6 27.8 66.1 27.8 104c0 114.9-93.1 208-208 208S48 418.9 48 304zm299.8 60.7c-27.9 7.8-59 12.1-91.6 12.1s-63.7-4.3-91.6-12.1c-12.4-3.5-24.3 7.3-18.6 18.8C166.2 424.1 208 452 256.2 452s90-27.9 110.2-68.6c5.7-11.5-6.2-22.2-18.6-18.8zM216 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHanukiah = {
  prefix: 'fas',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"]
};
var faChartScatter3d = {
  prefix: 'fas',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V273L43.5 423.4c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1L256 329.7 427.5 472.6c13.6 11.3 33.8 9.5 45.1-4.1s9.5-33.8-4.1-45.1L288 273V64zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDisplayChartUp = {
  prefix: 'fas',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm64 0V352H512V64H64zM376 96h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144H376c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSquareCode = {
  prefix: 'fas',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm262.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L324.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L123.9 256l60.2-54.2z"]
};
var faFeather = {
  prefix: 'fas',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"]
};
var faVolumeLow = {
  prefix: 'fas',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
};
var faVolumeDown = faVolumeLow;
var faXmarkToSlot = {
  prefix: 'fas',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"]
};
var faTimesToSlot = faXmarkToSlot;
var faVoteNay = faXmarkToSlot;
var faBoxTaped = {
  prefix: 'fas',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M50.7 58.5L0 160H160L192 32H93.7C75.5 32 58.9 42.3 50.7 58.5zM288 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H256l32 128zM160 192H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192z"]
};
var faBoxAlt = faBoxTaped;
var faCommentSlash = {
  prefix: 'fas',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"]
};
var faSwords = {
  prefix: 'fas',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M4.7 4.7C8.5 .9 13.9-.7 19.1 .3L89.6 14.4c9.3 1.9 17.8 6.4 24.5 13.1L393.4 306.7l-86.6 86.6L27.5 114.2c-6.7-6.7-11.3-15.2-13.1-24.5L.3 19.1C-.7 13.9 .9 8.5 4.7 4.7zm454.6 304l16 16c4.7 4.7 6 11.8 3.3 17.8l-27.5 62 56.2 56.2c6.2 6.2 6.2 16.4 0 22.6l-24 24c-6.2 6.2-16.4 6.2-22.6 0l-56.2-56.2-62 27.5c-6.1 2.7-13.1 1.4-17.8-3.3l-16-16c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zM96 329.4l50.7-50.7 86.6 86.6L182.6 416l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-4.7 4.7-11.8 6-17.8 3.3l-62-27.5L51.3 507.3c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6l56.2-56.2-27.5-62c-2.7-6.1-1.4-13.1 3.3-17.8l16-16c6.2-6.2 16.4-6.2 22.6 0L96 329.4zM484.5 114.2L365.3 233.4l-86.6-86.6L397.8 27.5c6.7-6.7 15.2-11.3 24.5-13.1L492.9 .3c5.2-1 10.7 .6 14.5 4.4s5.4 9.2 4.4 14.5L497.6 89.6c-1.9 9.3-6.4 17.8-13.1 24.5z"]
};
var faCloudSunRain = {
  prefix: 'fas',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faAlbum = {
  prefix: 'fas',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleN = {
  prefix: 'fas',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.7 138.3L304 283.2V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.5 6.8-19.8 16.8-22.9s20.9 .6 26.9 9.2z"]
};
var faCompress = {
  prefix: 'fas',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"]
};
var faWheatAwn = {
  prefix: 'fas',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"]
};
var faWheatAlt = faWheatAwn;
var faAnkh = {
  prefix: 'fas',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"]
};
var faHandsHoldingChild = {
  prefix: 'fas',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faAsterisk = {
  prefix: 'fas',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"]
};
var faKeySkeletonLeftRight = {
  prefix: 'fas',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M576 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm64 0c0 70.7-57.3 128-128 128c-59.6 0-109.8-40.8-124-96H320v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H224l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l196 0C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128zM64 384a64 64 0 1 0 128 0A64 64 0 1 0 64 384zM0 384c0-70.7 57.3-128 128-128c59.6 0 109.8 40.8 124 96l68 0V320c0-17.7 14.3-32 32-32s32 14.3 32 32v32h32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-196 0c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z"]
};
var faCommentLines = {
  prefix: 'fas',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faLuchadorMask = {
  prefix: 'fas',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M224 0C100.3 0 0 100.3 0 224v96C0 426 86 512 192 512h64c106 0 192-86 192-192V224C448 100.3 347.7 0 224 0zM128 384c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H252.7 195.3 160c-17.7 0-32 14.3-32 32zm-32 0c0-33.2 25.2-60.5 57.6-63.7c-1-3.7-1.6-7.6-1.6-11.6c0-7.3 1.8-14.4 5.3-20.7H144c-44.2 0-80-35.8-80-80c0-26.5 21.5-48 48-48h32c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80h32c26.5 0 48 21.5 48 48c0 44.2-35.8 80-80 80H290.7c3.4 6.3 5.3 13.4 5.3 20.7c0 4-.6 7.9-1.6 11.6c32.3 3.2 57.6 30.5 57.6 63.7c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64zm156.7-64h.2c6.1 0 11.1-5 11.1-11.1c0 0 0-.1 0-.1s0-.1 0-.1c0-3-1.2-5.9-3.3-8l-8-8-4.2-4.2-.4-.4-10.3-10.3C234 274 229.1 272 224 272s-10 2-13.7 5.7L200 288l-.4 .4-4.2 4.2-8 8c-2.1 2.1-3.3 5-3.3 8c0 0 0 .1 0 .1s0 .1 0 .1c0 6.1 5 11.1 11.1 11.1h.2 11.3 6 .6 21.5 .6 6 11.3zM112 192c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48H112zm240 16c0-8.8-7.2-16-16-16H304c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48z"]
};
var faLuchador = faLuchadorMask;
var faMaskLuchador = faLuchadorMask;
var faSquareCheck = {
  prefix: 'fas',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCheckSquare = faSquareCheck;
var faShredder = {
  prefix: 'fas',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M64 64C64 28.7 92.7 0 128 0H354.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64V64zM384 93.3L354.7 64H128V192H384V93.3zM432 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 416H88v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416zm96 0h48v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V416z"]
};
var faBookOpenCover = {
  prefix: 'fas',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", "M304 32V408L96 368V34.7C96 14.9 113.8-.2 133.3 3.1L304 32zM89.7 405.1L320 451.2l230.3-46.1c15-3 25.7-16.1 25.7-31.4V28.8l25.7-5.1C621.5 19.7 640 34.8 640 55V421.8c0 15.3-10.8 28.4-25.7 31.4L320 512 25.7 453.1C10.8 450.2 0 437 0 421.8V55C0 34.8 18.5 19.7 38.3 23.7L64 28.8v345c0 15.3 10.8 28.4 25.7 31.4zM336 408V32L506.7 3.1C526.2-.2 544 14.9 544 34.7V368L336 408z"]
};
var faBookOpenAlt = faBookOpenCover;
var faSandwich = {
  prefix: 'fas',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M0 96C0 78.3 14.3 64 32 64H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V96zM303.9 382.6c10 5.8 22.3 5.8 32.2 0l70.2-40.9c6.4-3.7 13.6-5.7 20.9-5.7H432h48c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32H208h4.8c7.4 0 14.6 2 20.9 5.7l70.2 40.9zM32 304c-17.7 0-32-14.3-32-32s14.3-32 32-32c7.2 0 15.8-3.7 35.4-13c16.6-7.8 40.6-19 68.6-19c30.6 0 53 10.2 70.1 18l1.9 .9c17.2 7.8 29.7 13.1 48.1 13.1s30.9-5.3 48.1-13.1l1.9-.9c17-7.8 39.4-18 70.1-18c28 0 52.1 11.3 68.6 19c19.6 9.2 28.2 13 35.4 13c17.7 0 32 14.3 32 32s-14.3 32-32 32c-22.7 0-44.3-10.3-58.8-17.2l0 0c-1.3-.6-2.6-1.2-3.8-1.8c-17.4-8.2-29.4-13-41.4-13c-16.2 0-27.5 5-45.4 13.1l-.1 0c-18 8.2-41.4 18.9-74.5 18.9s-56.6-10.7-74.5-18.9l-.1 0C163.5 277 152.2 272 136 272c-12 0-23.9 4.7-41.4 13c-1.2 .6-2.5 1.2-3.8 1.8C76.3 293.7 54.7 304 32 304z"]
};
var faPesetaSign = {
  prefix: 'fas',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"]
};
var faSquareParkingSlash = {
  prefix: 'fas',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM227 152.7c6-14.5 20.3-24.7 37-24.7h72c53 0 96 43 96 96c0 26.3-10.6 50.2-27.8 67.5l-51.4-40.3c9.1-5.6 15.2-15.7 15.2-27.2c0-17.7-14.3-32-32-32H288v8.4l-61-47.8zM224 288V272.5L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4L288 322.9V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V288z"]
};
var faParkingSlash = faSquareParkingSlash;
var faTrainTunnel = {
  prefix: 'fas',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h41.4l64.3-64.3C137.3 444.5 112 417.2 112 384V192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 33.2-25.3 60.5-57.7 63.7L406.6 512H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM361.4 512l-64-64H214.6l-64 64H361.4zM184 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H184zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHeading = {
  prefix: 'fas',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"]
};
var faHeader = faHeading;
var faGhost = {
  prefix: 'fas',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFaceAnguished = {
  prefix: 'fas',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faHockeySticks = {
  prefix: 'fas',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M220.6 17.7l82.3 164.6-35.8 71.6L163.4 46.3c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3zM372.8 322.1L387.8 352H544V480v32H480v0H435.8c-24.2 0-46.4-13.7-57.2-35.4l-41.5-83 35.8-71.6zM576 352h32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H576V352zM462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H160 128 96V480 352H252.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32H64V512H32c-17.7 0-32-14.3-32-32V384z"]
};
var faAbacus = {
  prefix: 'fas',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 96V208H448V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h64zm-96 32h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96H416v32zm-160 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H160V176h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V96h96v32zm-128 0h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H64V96h64v32zM64 416l0-176h64v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H64zm96-32h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V312h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240h96v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v24h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H160V384zm128-72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240H416v96h-8c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v32H288V384h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V312zm160 72h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V240h64V416H448V384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFilmSimple = {
  prefix: 'fas',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", "M384 32H128V80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64V432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48H384V432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64V80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V32zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304zm336-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faFilmAlt = faFilmSimple;
var faList = {
  prefix: 'fas',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
};
var faListSquares = faList;
var faTreePalm = {
  prefix: 'fas',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M102.9 91.4l30.3 50.5c-4 3.5-8 7.2-12 11.2c-71 71-60.2 151-32.7 191.3c5 7.3 15.2 7.3 21.4 1L248.4 206.9c4 10.8 7.8 26.2 9.7 47.2c4.2 46.5-1.6 116.8-32.7 216.4c-3 9.7-1.3 20.3 4.8 28.5s15.6 13 25.8 13h64c16.1 0 29.8-12 31.8-28c12.4-99-2.3-207.2-31.7-292H446.7c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9H560c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C59.6 0 10.7 64.2 1.6 112.1C-.1 120.8 7.2 128 16 128H62.7c2.8 0 5.4-1.5 6.9-3.9L89.1 91.4c3.1-5.2 10.6-5.2 13.7 0z"]
};
var faSquarePhoneFlip = {
  prefix: 'fas',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCartPlus = {
  prefix: 'fas',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"]
};
var faGamepad = {
  prefix: 'fas',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"]
};
var faBorderCenterV = {
  prefix: 'fas',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M448 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 352A32 32 0 1 0 0 352a32 32 0 1 0 64 0zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zM288 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384z"]
};
var faCircleDot = {
  prefix: 'fas',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faDotCircle = faCircleDot;
var faClipboardMedical = {
  prefix: 'fas',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"]
};
var faFaceDizzy = {
  prefix: 'fas',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faDizzy = faFaceDizzy;
var faEgg = {
  prefix: 'fas',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"]
};
var faUpToLine = {
  prefix: 'fas',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M342.1 262.1L219.3 139.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3L41.9 262.1c-6.4 6.4-9.9 15-9.9 24C32 304.8 47.2 320 65.9 320l62.1 0 0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V320l62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24zM32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96z"]
};
var faArrowAltToTop = faUpToLine;
var faHouseMedicalCircleXmark = {
  prefix: 'fas',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faWatchFitness = {
  prefix: 'fas',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M64 48C64 21.5 85.5 0 112 0H272c26.5 0 48 21.5 48 48H64zm0 416H320c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48zM0 160c0-44.2 35.8-80 80-80H304c44.2 0 80 35.8 80 80V352c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V160zm141.3 0C107.4 160 80 187.4 80 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faClockNineThirty = {
  prefix: 'fas',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h80V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCampground = {
  prefix: 'fas',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"]
};
var faFolderPlus = {
  prefix: 'fas',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faJug = {
  prefix: 'fas',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M160 0H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM400 168c0-13.3-10.7-24-24-24c-10.3 0-19.1 6.5-22.5 15.6l25.1 32.2c12.1-1.3 21.4-11.5 21.4-23.9zm-89.3-63.3l11.8 15.1C335.7 105.2 354.8 96 376 96c39.8 0 72 32.2 72 72c0 29.2-17.4 54.3-42.3 65.6c6.8 15.8 10.3 32.9 10.3 50.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V283.9c0-28.5 9.5-56.1 27-78.6l78.3-100.7c2.1-2.6 3.7-5.6 4.8-8.7H305.9c1.1 3.1 2.7 6 4.8 8.7zM128 288c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H128z"]
};
var faFutbol = {
  prefix: 'fas',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faSnowBlowing = {
  prefix: 'fas',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M512 48h32c53 0 96 43 96 96s-43 96-96 96H416c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H512c-17.7 0-32-14.3-32-32s14.3-32 32-32zM176 64c13.3 0 24 10.7 24 24v25.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6v55.8l48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6v55.8l35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V398.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4V297.6l-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4V158.6l-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4V88c0-13.3 10.7-24 24-24zM480 432c0-17.7 14.3-32 32-32h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H416c-17.7 0-32-14.3-32-32s14.3-32 32-32H536c53 0 96 43 96 96s-43 96-96 96H512c-17.7 0-32-14.3-32-32z"]
};
var faPaintbrush = {
  prefix: 'fas',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"]
};
var faPaintBrush = faPaintbrush;
var faLock = {
  prefix: 'fas',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"]
};
var faArrowDownFromLine = {
  prefix: 'fas',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 370.7V192c0-17.7 14.3-32 32-32s32 14.3 32 32V370.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128zM32 96C14.3 96 0 81.7 0 64S14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]
};
var faArrowFromTop = faArrowDownFromLine;
var faGasPump = {
  prefix: 'fas',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faSignalBarsSlash = {
  prefix: 'fas',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V376l-64-50.2V176c0-26.5-21.5-48-48-48s-48 21.5-48 48v74.6L38.8 5.1zM288 322.9l-74.7-58.8C200.5 272.7 192 287.4 192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V322.9zM448 464V449l-96-75.6V464c0 26.5 21.5 48 48 48s48-21.5 48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAltSlash = faSignalBarsSlash;
var faMonkey = {
  prefix: 'fas',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-89.7 61.4-165 144.5-186.1C329.1 265 369.9 288 416 288c9.8 0 19.4-1 28.7-3L526.5 363c31.6 30.2 49.5 72 49.5 115.7V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-26.2-10.7-51.3-29.7-69.4L416 346.1V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 160C71.6 512 0 440.4 0 352V110.1C0 49.3 49.3 0 110.1 0h10.4c57.2 0 102.8 47.8 100.1 104.9c-2.3 48.2-38.6 88-86.4 94.6l-1.9 .3c-17.5 2.4-33.7-9.8-36.1-27.3s9.8-33.7 27.3-36.1l1.9-.3c17.3-2.4 30.4-16.7 31.2-34.2c1-20.6-15.5-37.9-36.2-37.9H110.1C84.7 64 64 84.7 64 110.1V352c0 53 43 96 96 96V416zM416 256c-29.3 0-55.9-12.2-74.8-31.7c-9-9.3-16.2-20.2-21.3-32.3c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-15.7 37.6-52.8 64-96 64zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48H384zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRectanglePro = {
  prefix: 'fas',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm40 128h56c35.3 0 64 28.7 64 64s-28.7 64-64 64H128v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H128v32h32zm80-56c0-13.3 10.7-24 24-24h56c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7H288v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 184zm48 56h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288v32zm200-80c48.6 0 88 39.4 88 88v16c0 48.6-39.4 88-88 88s-88-39.4-88-88V248c0-48.6 39.4-88 88-88zm-40 88v16c0 22.1 17.9 40 40 40s40-17.9 40-40V248c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
var faPro = faRectanglePro;
var faHouseNight = {
  prefix: 'fas',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9zm138.3-3.8c-2.6-7-12.4-7-15 0L236.6 44.6 204.3 56.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15L275.4 44.6 263.5 12.3zm158.2 92.2c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32V464c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V304zM88.5 332.3L76.6 364.6 44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0z"]
};
var faHotTubPerson = {
  prefix: 'fas',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"]
};
var faHotTub = faHotTubPerson;
var faGlobePointer = {
  prefix: 'fas',
  iconName: 'globe-pointer',
  icon: [512, 512, [], "e60e", "M352 256c0 22.2-1.2 43.6-3.3 64H281.8l12.6-42.8c10.7-36.4-23.1-70.3-59.6-59.6l-74.6 21.9c.4-16.3 1.5-32.2 3.1-47.5H348.7c2.2 20.4 3.3 41.8 3.3 64zM20.4 280.6c-7.1 2.1-13.1 5.5-18.1 9.9C.8 279.2 0 267.7 0 256c0-22.1 2.8-43.5 8.1-64H131.2c-1.9 18.4-2.9 37.4-3.1 57L20.4 280.6zM231.4 491.6L272.4 352h71.9c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512c-7.2 0-16.3-3.1-27.3-13.4c1-2.2 1.9-4.6 2.7-7.1zM380.8 192H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-325.7 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7H167.7zm-32.4 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM493.4 352c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z"]
};
var faBlanket = {
  prefix: 'fas',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M0 128V352c0 70.7 57.3 128 128 128H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H368c44.2 0 80-35.8 80-80V128c0-53-43-96-96-96H96C43 32 0 75 0 128z"]
};
var faMapLocation = {
  prefix: 'fas',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"]
};
var faMapMarked = faMapLocation;
var faHouseFloodWater = {
  prefix: 'fas',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"]
};
var faCommentsQuestionCheck = {
  prefix: 'fas',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5zM180.2 77.3h48.5c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20V179.5c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6H180.2c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1c6.6-18.6 24.2-31.1 44-31.1zm27.8 160a26.7 26.7 0 1 1 0 53.3 26.7 26.7 0 1 1 0-53.3zm358.1 88.8l-80 80c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L472 363.7l65.9-65.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
var faTree = {
  prefix: 'fas',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"]
};
var faArrowsCross = {
  prefix: 'fas',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", "M54.6 41.4c-12.5-12.5-32.8-12.5-45.3 0S-3.1 74.1 9.4 86.6L156.1 233.4l45.3-45.3L54.6 41.4zM338.7 416H288c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7l-92.1-92.1-45.3 45.3L338.7 416zM288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H288z"]
};
var faBackpack = {
  prefix: 'fas',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M192 48h64c4.4 0 8 3.6 8 8V96H184V56c0-4.4 3.6-8 8-8zm-56 8V96h-8C57.3 96 0 153.3 0 224V448c0 35.3 28.7 64 64 64l0-112V352c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64v48V512c35.3 0 64-28.7 64-64V224c0-70.7-57.3-128-128-128h-8V56c0-30.9-25.1-56-56-56H192c-30.9 0-56 25.1-56 56zM352 512V416H96v96H352zM144 176H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352 384V352c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v32H352z"]
};
var faSquareSmall = {
  prefix: 'fas',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160z"]
};
var faFolderArrowUp = {
  prefix: 'fas',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM280 376V273.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V376c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faFolderUpload = faFolderArrowUp;
var faBridgeLock = {
  prefix: 'fas',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faCrosshairsSimple = {
  prefix: 'fas',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M445.3 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h61.3C431.9 368.4 368.4 431.9 288 445.3V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v61.3C143.6 431.9 80.1 368.4 66.7 288H128c17.7 0 32-14.3 32-32s-14.3-32-32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V128c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7C368.4 80.1 431.9 143.6 445.3 224zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
var faSackDollar = {
  prefix: 'fas',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"]
};
var faPenToSquare = {
  prefix: 'fas',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]
};
var faEdit = faPenToSquare;
var faSquareSliders = {
  prefix: 'fas',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zm0-144c0 17.7-14.3 32-32 32l-32 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16L96 368c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 0c17.7 0 32 14.3 32 32zM352 144c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 160 0z"]
};
var faSlidersHSquare = faSquareSliders;
var faCarSide = {
  prefix: 'fas',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faMessageMiddleTop = {
  prefix: 'fas',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M343.5 96H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H168.5L243.7 5.8c3-3.6 7.5-5.8 12.3-5.8s9.3 2.1 12.3 5.8L343.5 96z"]
};
var faCommentMiddleTopAlt = faMessageMiddleTop;
var faLightbulbOn = {
  prefix: 'fas',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80z"]
};
var faKnife = {
  prefix: 'fas',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", "M217.5 249.3l242-242c4.7-4.7 11-7.3 17.6-7.3c11.2 0 21 7.5 23.5 18.4C505.3 38.6 512 71.5 512 96c0 83.3-48.2 130.5-128.9 209.4c-6.5 6.4-13.3 13-20.3 19.9c-12.1 11.9-28.4 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-14.6-14.6-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192 16-16c0 0 .1-.1 .1-.1z"]
};
var faUtensilKnife = faKnife;
var faShareNodes = {
  prefix: 'fas',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"]
};
var faShareAlt = faShareNodes;
var faDisplayChartUpCircleDollar = {
  prefix: 'fas',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V211.2c-19.5-10-41.1-16.4-64-18.5V64H64V352H320.7c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2c-.2-1.3-.3-2.6-.3-3.9V177.9L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faWaveSine = {
  prefix: 'fas',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M63.4 230.3l0-.1 .2-1c.2-.9 .5-2.4 1-4.3c1-3.8 2.5-9.4 4.6-16.2C73.6 195 80.3 177 90 159.4C110.2 122.8 137.8 96 176 96c29 0 49.1 14.4 67 44.4c19 31.8 31.9 75.4 46.3 124.5c.2 .8 .5 1.6 .7 2.4c13.5 46.2 28.4 97.5 52 137c25.1 42 63 75.6 122 75.6c73.8 0 118.2-53.2 142-96.6c12.3-22.4 20.6-44.5 25.7-60.8c2.6-8.2 4.5-15.1 5.7-20c.6-2.5 1.1-4.4 1.4-5.9c.2-.7 .3-1.3 .4-1.7l.1-.5 0-.2 0-.1 0 0c0 0 0 0-31.4-6.3l31.4 6.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1l0 0 0 .1-.2 1c-.2 .9-.5 2.4-1 4.3c-1 3.8-2.5 9.4-4.6 16.2c-4.3 13.7-11.1 31.6-20.8 49.2c-20.1 36.6-47.8 63.4-86 63.4c-29 0-49.1-14.4-67-44.4c-19-31.8-31.9-75.4-46.3-124.5c-.2-.8-.5-1.6-.7-2.4c-13.5-46.2-28.4-97.5-52-137C272.9 65.6 235 32 176 32C102.2 32 57.8 85.2 34 128.6C21.7 151 13.4 173 8.2 189.3c-2.6 8.2-4.5 15.1-5.7 20c-.6 2.5-1.1 4.4-1.4 5.9c-.2 .7-.3 1.3-.4 1.7l-.1 .5 0 .2 0 .1 0 0c0 0 0 0 31.4 6.3L.6 217.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1"]
};
var faHeartCircleMinus = {
  prefix: 'fas',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faCircleW = {
  prefix: 'fas',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM150.9 168.7L192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L256 254.7 214.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"]
};
var faCircleCalendar = {
  prefix: 'fas',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 96c8.8 0 16 7.2 16 16v16h64V112c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32c17.7 0 32 14.3 32 32v32H128V160c0-17.7 14.3-32 32-32h32V112c0-8.8 7.2-16 16-16zM128 352V224H384V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32z"]
};
var faCalendarCircle = faCircleCalendar;
var faHourglassHalf = {
  prefix: 'fas',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"]
};
var faHourglass2 = faHourglassHalf;
var faMicroscope = {
  prefix: 'fas',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSunset = {
  prefix: 'fas',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M354.5 104.3L320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V135.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm48.7 132.8c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L64 432H169.3c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80H512l29.2-42.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345 403.1 237.1zM0 488c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24z"]
};
var faSink = {
  prefix: 'fas',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"]
};
var faCalendarExclamation = {
  prefix: 'fas',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM192 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-176v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTruckContainerEmpty = {
  prefix: 'fas',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M456 144c-13.3 0-24 10.7-24 24v88 32 32H208 80 32c-17.7 0-32 14.3-32 32v32 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L432 384l17.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H456zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHandHeart = {
  prefix: 'fas',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", "M256 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176H284.8c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zM208 362.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6h-1.1c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5h-1.1c-23.5 0-42.6 19.1-42.6 42.6z"]
};
var faBagShopping = {
  prefix: 'fas',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faShoppingBag = faBagShopping;
var faArrowDownZA = {
  prefix: 'fas',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faMitten = {
  prefix: 'fas',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"]
};
var faReplyClock = {
  prefix: 'fas',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M352 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM496 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V80c0-8.8-7.2-16-16-16zm0 256c5.1 0 10.2-.2 15.2-.6c.5 5.5 .8 11 .8 16.6c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 257.7 0 249.1 0 240s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v64h96.7c8.1 89.7 83.5 160 175.3 160z"]
};
var faReplyTime = faReplyClock;
var faPersonRays = {
  prefix: 'fas',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"]
};
var faRight = {
  prefix: 'fas',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-96L40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l184 0 0-96c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l160 160z"]
};
var faArrowAltRight = faRight;
var faCircleF = {
  prefix: 'fas',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24z"]
};
var faUsers = {
  prefix: 'fas',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"]
};
var faFacePleading = {
  prefix: 'fas',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM302.7 427.9c6.6-5.9 7.1-16 1.2-22.6C294.7 395.1 278.7 384 256 384s-38.7 11.1-47.9 21.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c4.7-5.3 12.7-10.7 24.1-10.7s19.4 5.4 24.1 10.7c5.9 6.6 16 7.1 22.6 1.2zM240 240c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48c0 44.2 35.8 80 80 80s80-35.8 80-80zm192 0c0-18-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80s80-35.8 80-80zm-304-8c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]
};
var faEyeSlash = {
  prefix: 'fas',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"]
};
var faFlaskVial = {
  prefix: 'fas',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"]
};
var faPoliceBox = {
  prefix: 'fas',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M192 0c8.8 0 16 7.2 16 16V32h80c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V96c0-17.7 14.3-32 32-32c0-17.7 14.3-32 32-32h80V16c0-8.8 7.2-16 16-16zM96 136v24h32V128H104c-4.4 0-8 3.6-8 8zm0 40v24c0 4.4 3.6 8 8 8h24V176H96zm72-48H144v32h32V136c0-4.4-3.6-8-8-8zm-24 48v32h24c4.4 0 8-3.6 8-8V176H144zm72-48c-4.4 0-8 3.6-8 8v24h32V128H216zm24 48H208v24c0 4.4 3.6 8 8 8h24V176zm16-48v32h32V136c0-4.4-3.6-8-8-8H256zm32 48H256v32h24c4.4 0 8-3.6 8-8V176zM96 256v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"]
};
var faCucumber = {
  prefix: 'fas',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM400 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faHeadSideBrain = {
  prefix: 'fas',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM285.3 208H336c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7 .1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2c-26.5 0-48 21.5-48 48c-26.5 0-48 21.5-48 48c0 20.9 13.4 38.7 32.1 45.3c0 .9-.1 1.8-.1 2.7c0 26.5 21.5 48 48 48c5.6 0 11-1 16-2.7V288c0 17.7 14.3 32 32 32s32-14.3 32-32V269.3c5 1.8 10.4 2.7 16 2.7c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16zM160 176v2.7l-.1 0c0-.9 .1-1.8 .1-2.7z"]
};
var faHand = {
  prefix: 'fas',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"]
};
var faHandPaper = faHand;
var faPersonBikingMountain = {
  prefix: 'fas',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM427.2 160l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zm-238.8 6.7L290.8 89.9c7.2-5.4 8.5-15.7 2.9-22.8L278.8 48.4c-21.6-27-60.7-32-88.4-11.2L125.2 86.1c-7.2 5.4-8.5 15.7-2.9 22.8l44 55c5.4 6.7 15.2 8 22.1 2.8zM120 256c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3L31.8 299.1c-8.6 8.6-9.3 21.9-2.3 31.3c-3.7 6.9-6.8 14.1-9 21.8C8.9 353.9 0 363.9 0 376v16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9C97.9 503.1 107.9 512 120 512h16c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.7-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.8-3.7-14.1-6.8-21.7-9C158.1 264.9 148.1 256 136 256H120zm8 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352.2-43.4c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3c-3.7 6.9-6.8 14.1-9 21.8C392.9 353.9 384 363.9 384 376v16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.5 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6h16c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.8-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8V376c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.9-3.7-14.1-6.8-21.8-9C542.1 264.9 532.1 256 520 256H504c-12.1 0-22.1 8.9-23.8 20.6zM448 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faBikingMountain = faPersonBikingMountain;
var faUtensilsSlash = {
  prefix: 'fas',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V352 240 32c0-17.7-14.3-32-32-32C496 0 384 32 384 176v99.7l-77.6-60.8c8.6-13.6 13.6-29.7 13.6-47c0-6.4-.7-12.8-2.1-19.1L287.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S256 7.8 256 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L223.9 14.6C223.2 6.3 216.3 0 208 0s-15.2 6.3-15.9 14.6l-9.4 103.3L160 100.1V16c0-8.2-6.1-15-14.3-15.9s-15.6 4.5-17.4 12.4L116.5 66 38.8 5.1zM176 255.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V285.1L96.1 171.7c1.9 44.2 36.3 80 79.9 83.9z"]
};
var faPrintMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M192 0H418.7c17 0 33.3 6.7 45.3 18.7L493.3 48c12 12 18.7 28.3 18.7 45.3V160H448V93.3L418.7 64H192v96H128V64c0-35.3 28.7-64 64-64zM128 192H352c-38.9 29.2-64 75.7-64 128c0 11 1.1 21.7 3.2 32H192v16 16 64H352c26.7 20.1 60 32 96 32c17.5 0 34.4-2.8 50.2-8l6.3 6.3c-10.8 20.1-32 33.8-56.4 33.8H192c-35.3 0-64-28.7-64-64V384H96c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
var faPrintSearch = faPrintMagnifyingGlass;
var faFolderBookmark = {
  prefix: 'fas',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM288 176V336c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V176c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"]
};
var faOm = {
  prefix: 'fas',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z"]
};
var faPi = {
  prefix: 'fas',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H96V284c0 39.7-9.3 78.9-27 114.5l-1.6 3.2c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l1.6-3.2C148.4 382.7 160 333.7 160 284V128H288V366.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faFlaskRoundPotion = {
  prefix: 'fas',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", "M192 64h64v93.7c0 30.4 16.9 56.1 40.3 69.7c43 25 71.6 71.4 71.7 124.4c-58.6-1.7-85.4-12.6-109.9-22.6c-22-9-42.2-17.2-82.1-17.2c-42.3 0-73.4 9.2-94.5 18.8c6.5-44.1 33-81.7 70.2-103.4c23.4-13.6 40.3-39.3 40.3-69.7V64zm128 93.7V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H304 144 128C110.3 0 96 14.3 96 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z"]
};
var faFlaskPotion = faFlaskRoundPotion;
var faFaceShush = {
  prefix: 'fas',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M0 256C0 359.8 61.8 449.1 150.5 489.3c-4.2-10.3-6.5-21.5-6.5-33.3V432 408c0-37.3 23.2-69.2 56-82V275.9c-14.8-6.9-26.6-15.9-35.3-24.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9c4-27 27.3-47.6 55.4-47.6s51.3 20.7 55.4 47.6c5.2-3.5 9.6-7.3 13.3-10.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-8.7 8.7-20.5 17.7-35.3 24.6v58.3c17.9 11.7 31.3 29.7 37 50.9c16-3.2 33.3 .6 46.9 11.9c18.4 15.3 24.5 39.9 17.1 61.3c60.3-46.8 99-120 99-202.3C512 114.6 397.4 0 256 0S0 114.6 0 256zM176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 248c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h48V248zM224 408c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-30.9-25.1-56-56-56H232c-30.9 0-56 25.1-56 56v24 24c0 30.9 25.1 56 56 56h48 17.5c21.4 0 41.6-9.5 55.3-25.9l25.6-30.7c8.5-10.2 7.1-25.3-3.1-33.8s-25.3-7.1-33.8 3.1L316 455.4c-4.6 5.5-11.3 8.6-18.4 8.6h-10L224 419.5V408z"]
};
var faWorm = {
  prefix: 'fas',
  iconName: 'worm',
  icon: [512, 512, [], "e599", "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHouseCircleXmark = {
  prefix: 'fas',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPlug = {
  prefix: 'fas',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faCalendarCircleExclamation = {
  prefix: 'fas',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faSquareI = {
  prefix: 'fas',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faChevronUp = {
  prefix: 'fas',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
};
var faFaceSaluting = {
  prefix: 'fas',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M258.1 58.5h0c14.5-9.8 18.4-29.4 8.8-44c0 0 0 0 0 0c-.1-.1-.2-.3-.3-.4C256.7-.6 236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c18.9 15.4 43.2 20.9 66 16.5c4.4-.9 8.8-2.1 13.1-3.8c.3-.1 .7-.3 1-.4c.5-.2 1-.4 1.5-.6c5.6-2.3 10.9-5.4 16-9l82.3-59.9h0c14.3-10.4 17.5-30.4 7.1-44.7c-4.8-6.7-11.8-10.9-19.3-12.5c-3.5-.7-7.2-.9-10.8-.4c-5.1 .7-10.1 2.6-14.6 5.8L128 185.8V146.8l27.3-18.5 13.1-8.9 89.7-60.9zM352 0c-18.4 0-36.3 1.9-53.5 5.6c12.6 27.9 3.8 61.6-22.4 79.4l-54.6 37c8.6 4.4 16.3 10.9 22.3 19.2c8.6 11.9 12.6 25.7 12.2 39.3c4.8-2.8 10.4-4.5 16.3-4.5c17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.9 0-25.8-8.9-30.2-21.4c-3.5 4.4-7.7 8.5-12.5 12l-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0zM257.4 341c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3s15.2-8.8 22.3-3.6zm175-165a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGaugeSimpleLow = {
  prefix: 'fas',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerSlow = faGaugeSimpleLow;
var faFacePersevering = {
  prefix: 'fas',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zm-104.8-310c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM133.5 210.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faCircleCamera = {
  prefix: 'fas',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM196 160l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h62.7c10 0 19 6.2 22.5 15.6L316 160h36c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h36zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faCameraCircle = faCircleCamera;
var faHandSpock = {
  prefix: 'fas',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1v0c0-.1 .1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"]
};
var faSpiderWeb = {
  prefix: 'fas',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M133.8 22.2c4.8-12.7 18-20.2 31.4-17.7l69 12.9c35.6 6.7 72.1 6.7 107.6 0l69-12.9c13.4-2.5 26.6 5 31.4 17.7l28.9 77.2c11.5 30.7 28.1 59.2 49.1 84.4l45.3 54.3c8.7 10.4 8.7 25.5 0 35.9l-45.3 54.3c-21 25.2-37.6 53.7-49.1 84.4l-28.9 77.2c-4.8 12.7-18 20.2-31.4 17.7l-69-12.9c-35.6-6.7-72.1-6.7-107.6 0l-69 12.9c-13.4 2.5-26.6-5-31.4-17.7l-28.9-77.2C93.3 382 76.7 353.4 55.7 328.2L10.5 273.9c-8.7-10.4-8.7-25.5 0-35.9l45.3-54.3c21-25.2 37.6-53.7 49.1-84.4l28.9-77.2zm33.3 70.6L157.3 119c-13.7 36.6-33.5 70.6-58.5 100.6L88.4 232h44.6c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7L167.1 92.8zm42.1-23.1l21.4 37.4c37.7 9.5 77.2 9.5 114.9 0l21.4-37.4-14.7 2.8c-42.4 7.9-85.9 7.9-128.3 0l-14.7-2.8zM408.9 92.8l-22.2 38.8 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4h44.6l-10.3-12.4c-25-30-44.8-64-58.5-100.6l-9.8-26.2zM487.6 280H443c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 21.6 37.9 9.8-26.2c13.7-36.6 33.5-70.6 58.5-100.6L487.6 280zM366.8 442.3l-19.5-34.2c-37.9-11.7-78.3-12.8-116.7-3.2l-21.3 37.4 14.7-2.8c42.4-7.9 85.9-7.9 128.3 0l14.7 2.8zM167.1 419.2l22.2-38.8-2.5-7c-12.1-34.2-30.3-65.8-53.7-93.4H88.4l10.3 12.4c25 30 44.8 64 58.5 100.6l9.8 26.2zM193.2 280c10.1 15 18.9 30.7 26.5 47.1L246.6 280H193.2zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1L288 304.4l-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7H329.4l27.3 47.7zM382.8 232c-10.1-15-18.9-30.7-26.5-47.1L329.4 232h53.4zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0L288 207.6 314.7 161zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1h53.4l-26.9-47.1z"]
};
var faCircleMicrophone = {
  prefix: 'fas',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm-64 80c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96V240c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16V383c-63.1-7.9-112-61.7-112-127V240c0-8.8 7.2-16 16-16z"]
};
var faMicrophoneCircle = faCircleMicrophone;
var faBookArrowUp = {
  prefix: 'fas',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H264V209.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V384H96c-17.7 0-32 14.3-32 32z"]
};
var faPopsicle = {
  prefix: 'fas',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M160 0C71.6 0 0 71.6 0 160V336c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V160C320 71.6 248.4 0 160 0zm32 480V416H128v64c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faCommand = {
  prefix: 'fas',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M0 96C0 43 43 0 96 0s96 43 96 96v32H320V96c0-53 43-96 96-96s96 43 96 96s-43 96-96 96H384V320h32c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96V384H192v32c0 53-43 96-96 96s-96-43-96-96s43-96 96-96h32V192H96C43 192 0 149 0 96zm128 32V96c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32h32zm64 192H320V192H192V320zm-64 64H96c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32V384zm256 0v32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H384zm0-256h32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32v32z"]
};
var faBlinds = {
  prefix: 'fas',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", "M32 0C14.3 0 0 14.3 0 32C0 43.4 6 53.4 15 59.1L1.1 100.8c-.7 2.1-1.1 4.3-1.1 6.5C0 118.8 9.2 128 20.6 128H128V64h32v64H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L497 59.1c9-5.7 15-15.7 15-27.1c0-17.7-14.3-32-32-32H32zM24 160L1.1 228.8c-.7 2.1-1.1 4.3-1.1 6.5C0 246.8 9.2 256 20.6 256H98.7c4.8-13.6 15.6-24.4 29.3-29.3V160H24zM144 320c-20.9 0-38.7-13.4-45.3-32H24L1.1 356.8c-.7 2.1-1.1 4.3-1.1 6.5C0 374.8 9.2 384 20.6 384H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 288H189.3c-6.6 18.6-24.4 32-45.3 32zm16-93.3c13.6 4.8 24.4 15.6 29.3 29.3H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 160H160v66.7zM20.6 512H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 416H24L1.1 484.8c-.7 2.1-1.1 4.3-1.1 6.5C0 502.8 9.2 512 20.6 512z"]
};
var faStopwatch = {
  prefix: 'fas',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSaxophone = {
  prefix: 'fas',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M246.7 176L171.4 306.1c-2.2 3.8-3.4 8.2-3.4 12.6v2.6c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L319 225l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L367 177l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L415 129l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 44.3-44.3c12-12 28.3-18.7 45.3-18.7h30.3c15 0 29.5 5.2 41 14.8l24.3 20.3c3.7 3.1 5.9 7.7 5.9 12.6c0 9-7.3 16.3-16.3 16.3H559.5c-9.8 0-19 4.5-25.1 12.1L288.6 418.6C257.9 457.4 211.2 480 161.8 480C72.4 480 0 407.6 0 318.2v-3.1c0-12.7 1.5-25.4 4.4-37.8L28.2 176H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H246.7zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquare2 = {
  prefix: 'fas',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM190.7 184.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"]
};
var faFieldHockeyStickBall = {
  prefix: 'fas',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", "M491.2 8.5c21.8 15.1 27.3 45 12.2 66.8l-52.2 75.5L371.3 97.5l53.1-76.8c15.1-21.8 45-27.3 66.8-12.2zM353.1 123.9L433 177.2 241 454.9c-24.6 35.5-64.9 56.8-108.1 56.9C59.5 512 .1 452.3 .6 378.9l0-2.2c.2-25.7 7.8-50.8 21.8-72.4l17.3-26.5c14.5-22.2 44.2-28.4 66.4-13.9s28.4 44.2 13.9 66.4l-17.3 26.5c-4 6.1-6.2 13.3-6.2 20.6l0 2.2c-.1 20 16 36.2 36 36.1c11.7 0 22.7-5.8 29.4-15.5L353.1 123.9zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faFieldHockey = faFieldHockeyStickBall;
var faArrowUpSquareTriangle = {
  prefix: 'fas',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zM443.1 303c-5.8-9.4-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5H496c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128z"]
};
var faSortShapesUpAlt = faArrowUpSquareTriangle;
var faFaceScream = {
  prefix: 'fas',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", "M573.9 288.5c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6c20.6-2.5 41.7 3.5 57.8 16.9l0 0c57.5 48 87.8 118 98 187C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c10.2-69 40.4-139 98-187l0 0c16.1-13.4 37.2-19.4 57.8-17zM320 320c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7s62.8-54.7 90.1-39.8s31.1 56.9 8.7 93.7zm183.3 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7s67.6 2.9 90.1 39.8s18.6 78.8-8.7 93.7zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9zM588.5 327c-16.4-10.6-37.6-8.8-51.8 3.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3z"]
};
var faSquareM = {
  prefix: 'fas',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm75.5 105.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V226.2l-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z"]
};
var faCameraWeb = {
  prefix: 'fas',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M344.2 413.1C406.6 373.3 448 303.5 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 79.5 41.4 149.3 103.8 189.1L45.6 453.8c-11.4 8-16.4 22.5-12.2 35.8S50 512 64 512H384c14 0 26.3-9.1 30.5-22.4s-.7-27.8-12.2-35.8l-58.2-40.7zM224 352a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM176 224c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faWebcam = faCameraWeb;
var faCommentArrowDown = {
  prefix: 'fas',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-296V270.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faLightbulbCfl = {
  prefix: 'fas',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M167.8 63c17.1-4.3 27.6-21.7 23.3-38.8S169.4-3.3 152.2 1L24.2 33C7.1 37.2-3.3 54.6 1 71.8S22.6 99.3 39.8 95l128-32zM319 88.2c-4.3-17.1-21.7-27.6-38.8-23.3l-256 64C7.1 133.2-3.3 150.6 1 167.8s21.7 27.6 38.8 23.3l256-64c17.1-4.3 27.6-21.7 23.3-38.8zM295.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64C7.1 229.2-3.3 246.6 1 263.8s21.7 27.6 38.8 23.3l256-64zM64 416v32c0 17.7 14.3 32 32 32h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H144V294L96 306v78c-17.7 0-32 14.3-32 32zM319 280.2c-4.3-17.1-21.7-27.6-38.8-23.3l-64 16-16 4c-13.2 3.3-22.4 14.3-24 27l-.2 0v3.3c0 .5 0 .9 0 1.4V384h48V337l7.8-1.9 64-16c17.1-4.3 27.6-21.7 23.3-38.8z"]
};
var faWindowFrameOpen = {
  prefix: 'fas',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", "M480 224V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64V224v64H96 416h64V224zm-64 0H280V64H416V224zm-184 0H96V64H232V224zM96 448V320H32V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320H416V448H96z"]
};
var faFaceKiss = {
  prefix: 'fas',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faKiss = faFaceKiss;
var faBridgeCircleXmark = {
  prefix: 'fas',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPeriod = {
  prefix: 'fas',
  iconName: 'period',
  icon: [128, 512, [], "2e", "M0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416z"]
};
var faFaceGrinTongue = {
  prefix: 'fas',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGrinTongue = faFaceGrinTongue;
var faUpToDottedLine = {
  prefix: 'fas',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM73.9 262.1L196.7 139.3c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3L374.1 262.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H288V448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V320H97.9C79.2 320 64 304.8 64 286.1c0-9 3.6-17.6 9.9-24z"]
};
var faThoughtBubble = {
  prefix: 'fas',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M374.8 80.3C355.9 33.2 309.8 0 256 0s-99.9 33.2-118.8 80.3c-3-.2-6.1-.3-9.2-.3C57.3 80 0 137.3 0 208s57.3 128 128 128c14.4 0 28.3-2.4 41.3-6.8C184.7 361.6 217.7 384 256 384s71.3-22.4 86.7-54.8c12.9 4.4 26.8 6.8 41.3 6.8c70.7 0 128-57.3 128-128s-57.3-128-128-128c-3.1 0-6.1 .1-9.2 .3zM144 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSkeletonRibs = {
  prefix: 'fas',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H260.2c-33.5 0-65.7 17.6-82.1 48.9C150.5 165.8 96 282.2 96 384v17c0 43.6 35.4 79 79 79c15.1 0 30.1-2.7 44.2-8l67.1-25.2c.6-.2 1.1-.4 1.7-.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V446.2c.6 .2 1.1 .4 1.7 .6L420.8 472c14.1 5.3 29.1 8 44.2 8c43.6 0 79-35.4 79-79V384c0-101.8-54.5-218.2-82.2-271.1C445.5 81.6 413.3 64 379.8 64H352V32zm-64 96v38.3l-72.7 16.2c7-15.2 13.8-28.7 19.6-40c4.5-8.6 13.9-14.5 25.3-14.5H288zM186 254.6l102-22.7v39.7L171.2 303.4c4.1-16.5 9.2-32.9 14.7-48.8zM160.3 372.7L288 337.9v42c-8.2 1.7-16.3 4-24.2 7l-67.1 25.2c-7 2.6-14.3 3.9-21.7 3.9c-8.3 0-15-6.7-15-15V384c0-3.7 .1-7.5 .3-11.3zM352 379.9V339l118.8 35.6c3 .9 6.1 1.3 9.1 1.4c.1 2.7 .1 5.3 .1 8v17c0 8.3-6.7 15-15 15c-7.4 0-14.8-1.3-21.7-3.9l-67.1-25.2c-7.9-3-16-5.3-24.2-7zm117.8-72.4L352 272.2V231.9l102 22.7c6 17.2 11.4 35.1 15.7 53zm-45-125L352 166.3V128h27.8c11.4 0 20.8 5.9 25.3 14.5c5.9 11.3 12.6 24.8 19.6 40zM0 144v96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V240c0-10.1 4.7-19.6 12.8-25.6l25.6-19.2C118.5 183.1 128 164.1 128 144c0-35.3-28.7-64-64-64S0 108.7 0 144zM576 80c-35.3 0-64 28.7-64 64c0 20.1 9.5 39.1 25.6 51.2l25.6 19.2c8.1 6 12.8 15.5 12.8 25.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V240 144c0-35.3-28.7-64-64-64z"]
};
var faRaygun = {
  prefix: 'fas',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M192 64h96V56c0-13.3 10.7-24 24-24s24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24v-.4L188.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9L120.2 288H112C50.1 288 0 237.9 0 176C0 131.3 26.2 92.8 64 74.8V24.6C64 11 75 0 88.6 0c4.8 0 9.6 1.4 13.6 4.1L192 64zm200 0c13.3 0 24 10.7 24 24v56h60.9l77.1-30.9c4.9-2 10.5-1.4 14.9 1.6s7 7.9 7 13.2v96c0 5.3-2.6 10.3-7 13.2s-10 3.6-14.9 1.6L476.9 208H416v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM136 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faFlute = {
  prefix: 'fas',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", "M48 160H96V352H48c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zM592 352H128V160H592c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faAcorn = {
  prefix: 'fas',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M262.4 4.8c10.6 8 12.8 23 4.8 33.6l-4.8 6.4c-4.4 5.9-7.9 12.4-10.3 19.2H352c53 0 96 43 96 96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32c0-53 43-96 96-96H202.4C206 46.7 213.3 30.3 224 16l4.8-6.4c8-10.6 23-12.8 33.6-4.8zM213.9 476.4C78.5 425.9 48 302.1 48 224H224 400c0 78.1-30.5 201.9-165.9 252.4c-6.5 2.4-13.7 2.4-20.2 0z"]
};
var faVideoArrowUpRight = {
  prefix: 'fas',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9V192 320v17.1l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128zM152 160H264c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faGrateDroplet = {
  prefix: 'fas',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", "M0 96C0 60.7 28.7 32 64 32h64 96 96 64c35.3 0 64 28.7 64 64v66.2c-15.1 4.3-28.2 14.6-35.8 28.8L336.9 332.2C325.8 353.1 320 376.4 320 400c0 29.6 8.9 57.1 24.2 80H320 224 128 64c-35.3 0-64-28.7-64-64V256 96zm96 0H64V224H96V96zM64 416H96V288H64V416zm128 0V288H160V416h32zm96 0V288H256V416h32zM384 96H352V224h32V96zM256 96V224h32V96H256zm-96 0V224h32V96H160zM440.5 206.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"]
};
var faSealExclamation = {
  prefix: 'fas',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48H335.1l-45.1 45.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48V335.1L18.4 289.5c-18.7-18.7-18.7-49.1 0-67.9L64 176V112c0-26.5 21.5-48 48-48h64l46.1-46.1zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faChessBishop = {
  prefix: 'fas',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"]
};
var faMessageSms = {
  prefix: 'fas',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm202.9 80.8C196.4 147 192 153.1 192 160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V208l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm173.1 38c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.1 .1 12.9 1.4 20.1 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4c-9.3-.1-20.4 1.9-29.7 7.4c-9.9 5.9-18.6 16.4-18.5 31.6c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7-.2-13.5-2.4-22.6-5.5l0 0 0 0c-1.5-.5-3.2-1.1-4.9-1.6c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2 .4 2.6 .9 4 1.4l0 0 0 0c8.8 3 20.4 7 32.6 7.4c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.2-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4zm-272 0c0-1.1 .2-1.6 .4-1.9c.3-.4 .9-1.2 2.4-2c3.1-1.8 8-3 12.9-2.9c6.6 .1 16.7 1.6 23.3 3.4c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4c-9.3-.1-20.4 1.9-29.7 7.4C80.6 157.3 72 167.8 72 183c.1 14.7 8.8 24 17.7 29.4c7.6 4.6 17.1 7.4 24.3 9.6l0 0 1.2 .4c8.5 2.6 14.2 4.5 18 6.9c2.7 1.7 2.7 2.4 2.7 3.1l0 .2c0 1.6-.3 2.3-.6 2.7c-.3 .5-.9 1.2-2.1 2c-2.8 1.7-7.5 2.9-12.8 2.8c-7.2-.2-14.2-2.6-23.7-5.8l0 0 0 0c-1.3-.4-2.7-.9-4.1-1.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1 .4 2.4 .8 3.6 1.2l0 0 0 0c9 3.1 20.9 7.2 33.2 7.6c9.8 .3 21.2-1.6 30.7-7.6c10.2-6.4 18-17.3 17.8-32.3c-.2-14.7-8.5-24.2-17.6-29.9c-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8c-1.6-1-2.1-1.6-2.2-1.7c0-.1 0-.2 0-.4z"]
};
var faCoffeeBeans = {
  prefix: 'fas',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", "M507.5 209.7c-3.4 12.3-19.1 11.8-25.4 .7c-5.4-9.5-11.3-18.5-17.6-26c-27.6-32.6-60.8-44.5-90.1-55l-1-.3c-30-10.7-55.8-20.2-77.5-45.9c-10.8-12.8-21.3-33.4-29.3-52c-1.7-4-.6-8.7 3-11.2C320.9-16 401.3-2.6 458 54c45.7 45.7 63.2 106.7 49.5 155.6zM228.5 78.3c3.4-12.3 19.1-11.8 25.4-.7c5.3 9.5 11.3 18.5 17.6 26c27.6 32.6 60.8 44.5 90.1 55l1 .3c30 10.7 55.8 20.2 77.5 45.9c10.8 12.8 21.3 33.4 29.3 52c1.7 4 .6 8.7-3 11.2C415.1 304 334.7 290.6 278 234c-45.7-45.7-63.2-106.7-49.5-155.6zM75.5 206c11.2-6.3 22 5.2 18.5 17.6c-2.9 10.5-5.2 21.2-6 31c-3.6 42.8 11.6 74.9 25 103.2l.4 .9c13.7 28.9 25.3 54.1 22.5 87.8c-1.4 16.7-8.6 38.9-16.1 57.9c-1.6 4.1-5.8 6.6-10.1 5.8C47.7 499.3 0 432.6 0 352c0-65 31-120.9 75.5-146zM180.5 498c-11.2 6.3-22-5.2-18.5-17.6c2.9-10.5 5.2-21.2 6-31c3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8c1.4-16.7 8.6-38.9 16.1-57.9c1.6-4.1 5.8-6.6 10.1-5.8C208.3 204.7 256 271.4 256 352c0 65-31 120.9-75.5 146z"]
};
var faHatWitch = {
  prefix: 'fas',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", "M200.7 181.4L112 384H224V336c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v48H464L386.7 206.1c-1.8-4-2.7-8.4-2.7-12.8v-.8c0-5.6 1.5-11 4.2-15.9l18.6-32.5c5.7-10 16.3-16.1 27.8-16.1H455c14.7 0 27.5 10 31 24.2l6.2 24.6c2.2 8.9 10.2 15.1 19.4 15.1c9.5 0 17.7-6.7 19.6-16.1l12.2-60.8c.4-2.1 .6-4.2 .6-6.3v-6.8c0-9-3.8-17.5-10.4-23.6L457.2 8.4C451.3 3 443.6 0 435.6 0h-2.2c-6.1 0-12.1 1.8-17.3 5L273.1 96.6c-32 20.5-57.2 50-72.4 84.8zM320 384V336c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48h64zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512H416c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6H22.6z"]
};
var faFaceGrinWink = {
  prefix: 'fas',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrinWink = faFaceGrinWink;
var faClockThreeThirty = {
  prefix: 'fas',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V256c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faEarDeaf = {
  prefix: 'fas',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faAlarmClock = {
  prefix: 'fas',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 184v94.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faEclipse = {
  prefix: 'fas',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9l9.6 52.2c-34.2 15-63.7 38.9-85.4 68.8c-12.4-4-25.6-6.2-39.4-6.2c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2c21.7 29.9 51.1 53.9 85.4 68.8l-9.6 52.2c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM256 160c7.6 0 15 .9 22.1 2.6C264 190.7 256 222.4 256 256s8 65.3 22.1 93.4c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96zM464 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352z"]
};
var faFaceRelieved = {
  prefix: 'fas',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 356.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM207.2 74.9c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zM314.9 95.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"]
};
var faRoadCircleCheck = {
  prefix: 'fas',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faDiceFive = {
  prefix: 'fas',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faOctagonMinus = {
  prefix: 'fas',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faMinusOctagon = faOctagonMinus;
var faSquareRss = {
  prefix: 'fas',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faRssSquare = faSquareRss;
var faFaceZany = {
  prefix: 'fas',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M384.1 477.7C506.5 407 548.5 250.4 477.8 128S250.5-36.4 128.1 34.3S-36.3 261.6 34.4 384c36.2 62.7 94.9 104.3 160.1 120.5c-11.5-15.8-18.4-35.4-18.4-56.5V408.2c-10.4-6.2-20.1-13.7-28.9-22.2c-10.2-9.9-6.6-26.3 5.7-33.4L391.2 214.9c12.3-7.1 28.3-2 31.8 11.8c15.2 59.4-5.9 124.1-55 165V448c0 15.4-3.6 30-10.1 42.9c8.8-3.8 17.5-8.2 26.1-13.2zM128 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm112-8a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm96.1 296V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0C257.8 383.9 248 376 236.7 376h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64zM152 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm144-56a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTricycle = {
  prefix: 'fas',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h73.6c7.9 0 14.4 6.4 14.4 14.4c0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8 .7-1.6 1.4-2.3 2.2H307.2c-58.8 0-114 23.9-154.1 64.6L133.6 176H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H77.6l44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6h12.1l11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4C416 59.9 388.1 32 353.6 32H280zm64.2 260l16.5 65.9c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-16.5-65.9c36.6 3.4 65.2 34.2 65.2 71.7c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-25.1 12.8-47.1 32.2-60zM112 312a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faLandMineOn = {
  prefix: 'fas',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"]
};
var faSquareArrowUpLeft = {
  prefix: 'fas',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM288 144c13.3 0 24 10.7 24 24s-10.7 24-24 24H193.9L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H288z"]
};
var faICursor = {
  prefix: 'fas',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"]
};
var faChartMixedUpCircleDollar = {
  prefix: 'fas',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM192 224c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]
};
var faSaltShaker = {
  prefix: 'fas',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M319.4 448H64.6l36.6-256H282.8l36.6 256zM59.8 512H324.2c33 0 59.8-26.8 59.8-59.8c0-2.8-.2-5.7-.6-8.5L338.1 126.7C327.7 54 265.4 0 192 0S56.3 54 45.9 126.7L.6 443.8c-.4 2.8-.6 5.6-.6 8.5c0 33 26.8 59.8 59.8 59.8zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faStamp = {
  prefix: 'fas',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"]
};
var faFilePlus = {
  prefix: 'fas',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM192 240c13.3 0 24 10.7 24 24v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V264c0-13.3 10.7-24 24-24z"]
};
var faDrawSquare = {
  prefix: 'fas',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V151.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM119.4 448c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V360.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4z"]
};
var faToiletPaperUnderSlash = {
  prefix: 'fas',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V343.1c-9.9 19.5-23.2 38.2-39.9 51.8L510 374.4c22.6-14.8 41.4-46 53.1-86.4c8.2-28.2 12.8-61 12.8-96C576 86 533 0 480 0c-11.2 0-22 3.8-32 10.9c-37.3 26.4-64 97.5-64 181.1c0 33.8 4.4 65.5 12 93.1l-39.3-30.8c-3.1-19.9-4.7-40.8-4.7-62.3c0-56.9 11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM528 512L406.2 416H224v48c0 26.5 21.5 48 48 48H528l.3 0H528zM64 192c0 106 43 192 96 192H365.5L66.5 148.4C64.9 162.4 64 177 64 192zm416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
var faStairs = {
  prefix: 'fas',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"]
};
var faDroneFront = {
  prefix: 'fas',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M155.7 112c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H155.7zM376 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H539.7c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16H376zM96 192v64c0 12.6 7.4 24.1 19 29.2l56.5 25.1c-17.8 21.5-27.5 48.5-27.5 76.4V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-16.8 5.9-33.2 16.7-46.1l8.4-10.1L259 349.2c4.1 1.8 8.5 2.8 13 2.8h96c4.5 0 8.9-.9 13-2.8l41.9-18.6 8.4 10.1c10.8 12.9 16.7 29.3 16.7 46.1V392c0 13.3 10.7 24 24 24s24-10.7 24-24v-5.2c0-27.9-9.7-54.9-27.5-76.4L525 285.2c11.6-5.1 19-16.6 19-29.2V192H480v43.2l-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7L160 235.2V192H96z"]
};
var faDroneAlt = faDroneFront;
var faGlassEmpty = {
  prefix: 'fas',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M8.6 10.2C14.6 3.7 23.1 0 32 0H352c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3H108.7c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9H275.3c8.4 0 15.4-6.5 16-14.9L317.6 64H66.4z"]
};
var faDialHigh = {
  prefix: 'fas',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm.4 127.6c80.2 0 146.6 59 158.2 136H288.4c-13.3 0-24 10.7-24 24s10.7 24 24 24H446.6c-11.6 77-78 136-158.2 136c-88.4 0-160-71.6-160-160s71.6-160 160-160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserHelmetSafety = {
  prefix: 'fas',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M216 0c-13.3 0-24 10.7-24 24V80L163.6 23.1C125.6 43.5 99 82.6 96.2 128H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24h-.2C349 82.6 322.4 43.5 284.4 23.1L256 80V24c0-13.3-10.7-24-24-24H216zm8 320c65.3 0 119.1-48.9 127-112H97c7.9 63.1 61.7 112 127 112zm-89.6 32C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4z"]
};
var faUserConstruction = faUserHelmetSafety;
var faUserHardHat = faUserHelmetSafety;
var faI = {
  prefix: 'fas',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"]
};
var faHryvniaSign = {
  prefix: 'fas',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"]
};
var faHryvnia = faHryvniaSign;
var faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fas',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M502.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L336 130.7V80c0-17.7-14.3-32-32-32s-32 14.3-32 32V208c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32s-14.3-32-32-32H381.3L502.6 54.6zM80 272c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L176 381.3V432c0 17.7 14.3 32 32 32s32-14.3 32-32V304c0-17.7-14.3-32-32-32H80z"]
};
var faPills = {
  prefix: 'fas',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"]
};
var faFaceGrinWide = {
  prefix: 'fas',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
var faGrinAlt = faFaceGrinWide;
var faTooth = {
  prefix: 'fas',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"]
};
var faBasketballHoop = {
  prefix: 'fas',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", "M6.8 187C24.7 153.1 116.7 0 320 0S615.3 153.1 633.2 187c4.9 9.4 6.8 19.1 6.8 28V331.2c0 25.3-14.9 48.2-38 58.5l-96.4 42.9L526.2 288H493.9l-7.2 50.3-22.9 160c-.9 6.1-5.2 11.2-11.1 13s-12.3 .1-16.5-4.4L384.4 451l-52.8 56c-3 3.2-7.2 5-11.6 5s-8.6-1.8-11.6-5l-52.8-56-51.9 55.9c-4.2 4.5-10.6 6.2-16.5 4.4s-10.2-6.9-11.1-13l-22.9-160L146.1 288H113.8l20.7 144.6L38 389.7C14.9 379.4 0 356.5 0 331.2V214.9c0-8.9 1.8-18.6 6.8-28zM178.4 288l5.2 36.6 44-36.6H178.4zm99.3 0l-.6 .5L320 334.6l42.8-46.1-.6-.5H277.8zm134.5 0l44 36.6 5.2-36.6H412.3zM192 128c-17.7 0-32 14.3-32 32v48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h64H464h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V160c0-17.7-14.3-32-32-32H192zm256 32v48H192V160H448zM387.5 309l-45.7 49.2 42.7 46 51.6-54.7L387.5 309zm49.4 151.6l11-76.8-41.5 44 30.5 32.9zM320 381.7l-42.6 45.9L320 472.7l42.6-45.2L320 381.7zm-21.8-23.5L252.5 309l-48.7 40.5 51.6 54.7 42.7-46zm-64.6 69.5l-41.5-44 11 76.8 30.5-32.9z"]
};
var faObjectsAlignBottom = {
  prefix: 'fas',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M24 512l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24zM64 336c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48l0 288zm224 0c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48l0 160z"]
};
var faV = {
  prefix: 'fas',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"]
};
var faSparkles = {
  prefix: 'fas',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
};
var faSquid = {
  prefix: 'fas',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M276 .3c-5.3-1.1-10.8 .6-14.6 4.5s-5.4 9.4-4.2 14.7l13.1 58.9c-71.9 46.2-103.4 101.8-110.6 148.4L146 213l-2.3-2.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6l56.4-56.4c18.9-18.9 18.7-49.5-.3-68.2L140.1 4.6c-6.3-6.1-16.3-6.1-22.5 .1l-2.8 2.8c-34 34-33.3 87.7-1.9 121L98.5 142.9c-18.7 18.7-18.7 49.1 0 67.9l22.6 22.6 0 0 5.7 5.7 0 0c9.3 9.4 9.3 24.5 0 33.9c-9.3 9.3-24.4 9.4-33.8 .2L76.5 256.6c-19.1-19.1-50.2-18.7-68.7 .9L4.4 261c-6.1 6.4-5.8 16.5 .6 22.6s16.5 5.8 22.6-.6l3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l10.6 10.6 .1 .2 22.6 22.6c10.1 10.2 9 26.9-2.4 35.8l-20 15.6c-3.5 2.7-7.7 4.2-12.1 4.2c-10.9 0-19.7-8.8-19.7-19.7V336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 12.3C.9 376.8 24.1 400 52.6 400c11.5 0 22.7-3.8 31.8-10.9l28.2-21.9c9.4-7.3 22.8-6.5 31.2 1.9s9.3 21.8 1.9 31.2l-21.9 28.2c-7.1 9.1-10.9 20.3-10.9 31.8c0 28.6 23.2 51.7 51.7 51.7h12.3c8.8 0 16-7.2 16-16s-7.2-16-16-16H164.6c-10.9 0-19.7-8.8-19.7-19.7c0-4.4 1.5-8.7 4.2-12.1l15.6-20c8.8-11.4 25.6-12.4 35.8-2.3l.1 .1L223 448.3l.1 .1 9.9 9.8c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8l-9.9-9.9-5.7-5.7-.1-.1c-9.3-9.3-9.3-24.4 0-33.8l.1-.1 .1-.1c9.3-9.2 24.4-9.2 33.7 0l28.4 28.4c18.7 18.7 49.1 18.7 67.9 0L384.4 400c33.3 31.4 87 32.1 121-1.9l2.8-2.8c6.2-6.2 6.3-16.3 .1-22.5L472 335.7c-18.7-19-49.3-19.2-68.2-.3l-56.4 56.3c-6.2 6.2-16.4 6.2-22.6 0l-22.5-22.5-.1-.1-16-16c46.6-7.2 102.2-38.7 148.4-110.6l58.9 13.1c5.3 1.2 10.8-.4 14.7-4.2s5.6-9.3 4.5-14.6L489.3 120.2c9.2-30.2 17.2-64 23.4-101.5c.9-5.1-.8-10.3-4.5-13.9S499.4-.6 494.3 .2C456.7 6.5 423 14.4 392.7 23.6L276 .3zM168.9 280a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faLeafyGreen = {
  prefix: 'fas',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M97.9 28.4C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1v35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6V330.5c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6v-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27c4.4-12.9 10.8-24.8 18.9-35.5c-38-36.5-98.4-36-135.8 1.5zM567.5 229.9c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v45.7c0 17-6.7 33.3-18.7 45.3L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.9-35.9c12-12 28.3-18.7 45.3-18.7h45.7c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1zM475.3 100.7c6.2 6.2 6.2 16.4 0 22.6L390.6 208H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H358.6l-59.3 59.3-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L272 281.4V192c0-8.8 7.2-16 16-16s16 7.2 16 16v57.4l36.7-36.7 112-112c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faCircleArrowUpRight = {
  prefix: 'fas',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l160 0c13.3 0 24 10.7 24 24l0 152z"]
};
var faCalendars = {
  prefix: 'fas',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M224 0c-17.7 0-32 14.3-32 32V64H144c-26.5 0-48 21.5-48 48v48H512V112c0-26.5-21.5-48-48-48H416V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H256V32c0-17.7-14.3-32-32-32zM96 192V368c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V192H96zm-48-8c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 66.3 53.7 120 120 120H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V184z"]
};
var faBangladeshiTakaSign = {
  prefix: 'fas',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"]
};
var faBicycle = {
  prefix: 'fas',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"]
};
var faHammerWar = {
  prefix: 'fas',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", "M192 0c17.7 0 32 14.3 32 32V50.8L347.3 32.4c9.2-1.4 18.6 1.3 25.6 7.4S384 54.7 384 64V256c0 9.3-4.1 18.2-11.1 24.2s-16.4 8.8-25.6 7.4L196.7 265.1c-3.1-.5-6.3-.5-9.5 0L36.7 287.6c-9.2 1.4-18.6-1.3-25.6-7.4S0 265.3 0 256V64c0-9.3 4.1-18.2 11.1-24.2s16.4-8.8 25.6-7.4L160 50.8V32c0-17.7 14.3-32 32-32zm0 296.7l32 4.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V301.5l32-4.8z"]
};
var faCircleD = {
  prefix: 'fas',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H184c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 208c44.2 0 80-35.8 80-80s-35.8-80-80-80H208V336h48z"]
};
var faSpiderBlackWidow = {
  prefix: 'fas',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5L176 174.1V160c0-31.8 18.6-59.3 45.5-72.2c9.1-4.4 18.5 3.3 18.5 13.4V112c0 8.8 7.2 16 16 16s16-7.2 16-16V101.2c0-10.1 9.4-17.7 18.5-13.4C317.4 100.7 336 128.2 336 160v14.1l48.3-48.3c2.2-2.2 2.9-5.6 1.8-8.5L353.6 32.6c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8L430.9 100c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-80.4-26.8 57.4 57.4c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-32.3 32.3c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l57.4-57.4L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8L93.7 159.7C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm73.8 305.6L240 336l-21.6 28.8c-1.6 2.1-2.4 4.6-2.4 7.2c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12c0-2.6-.8-5.1-2.4-7.2L272 336l21.6-28.8c1.6-2.1 2.4-4.6 2.4-7.2c0-6.6-5.4-12-12-12H228c-6.6 0-12 5.4-12 12c0 2.6 .8 5.1 2.4 7.2z"]
};
var faStaffSnake = {
  prefix: 'fas',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faPear = {
  prefix: 'fas',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M505 7c9.4 9.4 9.4 24.6 0 33.9L457.9 88.1c14 20.5 22.1 45.3 22.1 71.9c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM320 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z"]
};
var faHeadSideCoughSlash = {
  prefix: 'fas',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTriangle = {
  prefix: 'fas',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", "M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480H472c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z"]
};
var faApartment = {
  prefix: 'fas',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M176 0c-26.5 0-48 21.5-48 48V96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48h80 32 96V416c0-17.7 14.3-32 32-32s32 14.3 32 32v96h96 32 80c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H448V48c0-26.5-21.5-48-48-48H176zM368 320H336c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm144 80c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm16 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112-80H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM384 80v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM384 208c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM496 320H464c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 208c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm112 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16z"]
};
var faTruckMedical = {
  prefix: 'fas',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
};
var faAmbulance = faTruckMedical;
var faPepper = {
  prefix: 'fas',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37v10.9c-5.6-2-11.5-3.5-17.4-4.4l-1.1-.2c-8.1-1.2-16.4-1.3-24.9-.3c-4 .5-7.9 1.2-11.9 2.2c-51.4 12.9-74.7 65-61.9 116.4l37.1 148.3c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L83.8 223c-11.8-47 .4-94.4 31.3-125.2c-13.6-2.8-28-2.6-42.4 1C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c7-1.7 13.6-4.2 19.8-7.3c5.6-2.8 12.3-2.8 17.9 0c3 1.5 6 2.8 9.2 4c10.7 4 22.2 6.2 34 6.2c11.6 0 22.9-2.1 33.5-6.1c3.2-1.2 6.4-2.6 9.4-4.1c5.6-2.8 12.3-2.8 17.9 0c6.2 3.1 12.8 5.6 19.8 7.3c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4c-23.2-5.8-46.5-2.6-66.3 7.3c-5.6 2.8-12.3 2.8-17.9 0c-6.2-3.1-12.8-5.6-19.8-7.3c-19-4.8-38.1-3.5-55.3 2.6V90.6c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7z"]
};
var faPiano = {
  prefix: 'fas',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M0 192V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.6c0-24.2-13.7-46.4-35.4-57.2l-58.4-29.2c-21-10.5-34.2-31.9-34.2-55.4C384 83.2 300.8 0 198.3 0H192C86 0 0 86 0 192zM416 352h32v96H64V352H96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V352z"]
};
var faGunSquirt = {
  prefix: 'fas',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M128 56c0-13.3-10.7-24-24-24S80 42.7 80 56v9.3C34.6 72.9 0 112.4 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480H168c14.7 0 27.5-10 31-24.2L219 376h53v16c0 13.3 10.7 24 24 24s24-10.7 24-24V352 312c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H231l18-72H448c41.8 0 77.4-26.7 90.5-64H552c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H538.5C525.4 90.7 489.8 64 448 64H128V56zM96 128H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faWheatAwnCircleExclamation = {
  prefix: 'fas',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faSnowman = {
  prefix: 'fas',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faUserAlien = {
  prefix: 'fas',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm244.6 9c-37.9 0-68.6 30.7-68.6 68.6c0 6.3 5.1 11.4 11.4 11.4h16c37.9 0 68.6-30.7 68.6-68.6c0-6.3-5.1-11.4-11.4-11.4h-16zM208 244.6c0-37.9-30.7-68.6-68.6-68.6h-16c-6.3 0-11.4 5.1-11.4 11.4c0 37.9 30.7 68.6 68.6 68.6h16c6.3 0 11.4-5.1 11.4-11.4zM0 486.4C0 415 55.7 356.6 126.1 352.3c23.8 23.2 46.1 40.2 58.5 49.1c12 8.6 25.9 12.4 39.4 12.4s27.4-3.8 39.4-12.4c12.4-8.8 34.7-25.8 58.5-49.1C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"]
};
var faShieldCheck = {
  prefix: 'fas',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faMortarPestle = {
  prefix: 'fas',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faRoadBarrier = {
  prefix: 'fas',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"]
};
var faChartCandlestick = {
  prefix: 'fas',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16V96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32V48zm64 176v64c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-17.7 0-32 14.3-32 32zM160 128c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"]
};
var faBriefcaseBlank = {
  prefix: 'fas',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64z"]
};
var faSchool = {
  prefix: 'fas',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"]
};
var faIgloo = {
  prefix: 'fas',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"]
};
var faBracketRound = {
  prefix: 'fas',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z"]
};
var faParenthesis = faBracketRound;
var faJoint = {
  prefix: 'fas',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"]
};
var faHorseSaddle = {
  prefix: 'fas',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128v32c0 41.8-26.7 77.4-64 90.5v78.6l51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM224 320V256c-53 0-96-43-96-96V130.6c-21.8 5.5-40.3 19.5-51.7 38.2C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l.3 .1zm64-160V128H224 203.2 160v32c0 35.3 28.7 64 64 64s64-28.7 64-64zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faMugMarshmallows = {
  prefix: 'fas',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", "M192 32c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3c0 5.5 .9 10.9 2.6 16H32V64c0-17.7 14.3-32 32-32H192zm5.7 93.7C194 122 192 117.1 192 112s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128H200l-2.3-2.3zM0 192c0-17.7 14.3-32 32-32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160H352h48c61.9 0 112 50.1 112 112s-50.1 112-112 112H384c0 53-43 96-96 96H96c-53 0-96-43-96-96V192zm384 32v96h16c26.5 0 48-21.5 48-48s-21.5-48-48-48H384z"]
};
var faFilters = {
  prefix: 'fas',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M232 32c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L352 261.5V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V261.5L629.4 99.1c10.7-11.7 13.6-28.6 7.2-43.2S615.9 32 600 32H232zM40 96c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L160 325.5V400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V325.5l32-34.8V274L179 120.7c-6.7-7.3-11.7-15.7-14.9-24.7H40z"]
};
var faBellOn = {
  prefix: 'fas',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M320 0c-17.7 0-32 14.3-32 32V51.2C215 66 160 130.6 160 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416H512c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM0 200c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H536zM597.5 21.3c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3s-1.1 26.3 10.7 32.2z"]
};
var faAngleRight = {
  prefix: 'fas',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"]
};
var faDialMed = {
  prefix: 'fas',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 287.2C128 207 187 140.6 264 129l0 158.2c0 13.3 10.7 24 24 24s24-10.7 24-24L312 129c77 11.6 136 78 136 158.2c0 88.4-71.6 160-160 160s-160-71.6-160-160zm384 .8a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHorse = {
  prefix: 'fas',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faQ = {
  prefix: 'fas',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"]
};
var faMonitorWaveform = {
  prefix: 'fas',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 96H496c8.8 0 16 7.2 16 16V400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V272 112c0-8.8 7.2-16 16-16zM96 256h96c6.1 0 11.6 3.4 14.3 8.8L224 300.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L329.9 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-6.1 0-11.6-3.4-14.3-8.8L288 243.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L182.1 288H96v96H480V128H96V256z"]
};
var faMonitorHeartRate = faMonitorWaveform;
var faLinkSimple = {
  prefix: 'fas',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96 43-96 96s43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96-43 96-96s-43-96-96-96H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160zM192 224H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faWhistle = {
  prefix: 'fas',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M44.1 188.8C18.5 180.5 0 156.4 0 128C0 92.7 28.7 64 64 64c23.4 0 43.8 12.5 55 31.2C149.2 75.5 185.2 64 224 64c51 0 97.4 19.9 131.8 52.4c1.1 .5 2.2 1.2 3.2 2l62.4 48.3c5.1 4 7.3 10.6 5.6 16.9l-5.7 21.1c-3.2 11.7 1.1 24.2 10.8 31.5c9.6 7.2 22.7 7.9 33 1.7l17.7-10.6c5.7-3.4 12.8-3 18 1.1l128.6 99.6C636.1 333 640 341 640 349.4c0 6.8-2.5 13.4-7.1 18.4l-63.4 69.7c-6.1 6.7-14.7 10.5-23.7 10.5h-2c-5.2 0-10.2-1.2-14.8-3.6L380.7 367c-34.8 49-92 81-156.7 81C118 448 32 362 32 256c0-23.6 4.3-46.3 12.1-67.2zM288 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faG = {
  prefix: 'fas',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"]
};
var faWineGlassCrack = {
  prefix: 'fas',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H233.9C222 0 214.3 12.5 219.6 23.2l14.2 28.5c3.5 7.1 1.4 15.7-5.1 20.3l-58.4 40.9c-6 4.2-8.4 12-5.8 18.9l31.1 81c2.1 5.5-1.9 11.4-7.8 11.4c-2.4 0-4.7-1.1-6.3-2.9L92.1 118c-6.4-7.4-4.7-18.7 3.5-24l58.6-37.3c7.6-4.8 9.7-14.9 4.7-22.4L140.7 7.1c-3-4.5-8-7.1-13.3-7.1H64z"]
};
var faFragile = faWineGlassCrack;
var faSlotMachine = {
  prefix: 'fas',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M128 0C92.7 0 64 28.7 64 64H448c0-35.3-28.7-64-64-64H128zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64H416h32 80c53 0 96-43 96-96V211.8c9.8-8.8 16-21.6 16-35.8c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 14.2 6.2 27 16 35.8V416c0 17.7-14.3 32-32 32H448V416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zM56 200c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6L126.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L115.6 224H80c-13.3 0-24-10.7-24-24zm168-24h59.9c23 0 38.5 23.5 29.4 44.6L270.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L259.6 224H224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 24c0-13.3 10.7-24 24-24h59.9c23 0 38.5 23.5 29.4 44.6L414.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L403.6 224H368c-13.3 0-24-10.7-24-24z"]
};
var faNotesMedical = {
  prefix: 'fas',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"]
};
var faCarWash = {
  prefix: 'fas',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M64 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zm160 0c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zM432 80c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48zM153.8 224H294.2c6.8 0 12.8 4.3 15.1 10.6L328.3 288H119.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zM78.5 213.1L50.2 292.4C30.1 300.9 16 320.8 16 344v40 64 32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448H352v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C358.1 181.3 328 160 294.2 160H153.8c-33.8 0-64 21.3-75.3 53.1zM96 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faEscalator = {
  prefix: 'fas',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM405.9 175.8C417.5 165.6 432.5 160 448 160h96c35.3 0 64 28.7 64 64s-28.7 64-64 64H472L234.1 496.2C222.5 506.4 207.5 512 192 512H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h72L405.9 175.8zM320 192v16.4l-128 112V192c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faCommentImage = {
  prefix: 'fas',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm168-16c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1s-12.4 13.3-21.5 13.3H200 120c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6L199 257.3l77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z"]
};
var faTemperatureHalf = {
  prefix: 'fas',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faDongSign = {
  prefix: 'fas',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faDonut = {
  prefix: 'fas',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160v31c-.7 10-4.3 19.5-10.5 27.4c-6.2 8-14.7 14-24.4 17.1l-.3 .1-.3 .1c-13.1 4.9-24.4 13.8-32 25.5c-9.4 13-22 23.3-36.5 30.1c-14.7 6.8-30.8 9.6-46.9 8.3l-.6 0-.6 0c-17.7-.2-35.3 3.3-51.7 10.1l0 0-.1 0c-16.4 7-34.1 10.5-51.9 10.3l0 0-.3 0c-17.8 .2-35.5-3.3-51.9-10.3l-.1 0c-16.4-6.8-34-10.2-51.7-10.1l-.6 0-.6 0c-16.1 1.3-32.3-1.6-46.9-8.4c-14.6-6.8-27.1-17.1-36.5-30.2c-7.7-11.7-18.9-20.6-32-25.5l-.4-.1-.4-.1c-9.7-3.1-18.2-9.1-24.4-17.1C4.3 258.4 .7 248.9 0 238.9V208zm0 92.7c7.4 5.7 15.7 10.1 24.6 13c6.7 2.6 12.4 7.2 16.3 13.2l.2 .3 .2 .3c12.6 17.6 29.6 31.7 49.3 40.8c19.5 9 41 12.9 62.4 11.3c13.2-.1 26.3 2.5 38.5 7.6c20.4 8.6 42.4 13 64.5 12.8c22.1 .2 44.1-4.2 64.5-12.8c12.2-5.1 25.3-7.6 38.5-7.6c21.4 1.7 42.9-2.2 62.3-11.2c19.7-9.1 36.7-23.1 49.3-40.7l.2-.3 .2-.3c3.9-6 9.6-10.6 16.3-13.2c8.9-2.9 17.3-7.4 24.6-13V304c0 88.4-114.6 160-256 160S0 392.4 0 304v-3.3zM320 192c0-17.7-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32s64-14.3 64-32zM283.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-112 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224 9.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16H96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm331.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-240 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
var faDoughnut = faDonut;
var faCapsules = {
  prefix: 'fas',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"]
};
var faPooStorm = {
  prefix: 'fas',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 41 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"]
};
var faPooBolt = faPooStorm;
var faTally1 = {
  prefix: 'fas',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", "M128 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]
};
var faFaceFrownOpen = {
  prefix: 'fas',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"]
};
var faFrownOpen = faFaceFrownOpen;
var faSquareDashed = {
  prefix: 'fas',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M96 32h32V96H96c-17.7 0-32 14.3-32 32v32H0V128C0 75 43 32 96 32zM0 192H64V320H0V192zm384 0h64V320H384V192zm64-32H384V128c0-17.7-14.3-32-32-32H320V32h32c53 0 96 43 96 96v32zm0 192v32c0 53-43 96-96 96H320V416h32c17.7 0 32-14.3 32-32V352h64zM64 352v32c0 17.7 14.3 32 32 32h32v64H96c-53 0-96-43-96-96V352H64zm96 128V416H288v64H160zm0-384V32H288V96H160z"]
};
var faSquareJ = {
  prefix: 'fas',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM304 152V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHandPointUp = {
  prefix: 'fas',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"]
};
var faMoneyBill = {
  prefix: 'fas',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faArrowUpBigSmall = {
  prefix: 'fas',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM320 368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V368zM368 32H496c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"]
};
var faSortSizeUp = faArrowUpBigSmall;
var faBarcodeRead = {
  prefix: 'fas',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", "M56 48c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56zm96 80h16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm160 0h16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm72 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H408c-13.3 0-24-10.7-24-24V152zM240 128c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM528 56c0-4.4-3.6-8-8-8H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56zM56 464h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 4.4 3.6 8 8 8zm472-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 30.9-25.1 56-56 56H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8z"]
};
var faBaguette = {
  prefix: 'fas',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M583 234.5c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L356.5 77.8l70.8 70.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L329.3 96l-88 58.7 74 74c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-78.6-78.6-88 58.7 77.2 77.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L98.9 249.6 57 277.5C-1.8 316.7-17.7 396.2 21.5 455s118.7 74.7 177.5 35.5l384-256z"]
};
var faBowlSoftServe = {
  prefix: 'fas',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", "M257.2 9.9c2.5-6 8.3-9.9 14.8-9.9h36.6C367.9 0 416 48.1 416 107.4c0 19.9-6.9 38.1-18.3 52.6H416c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h8.6c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64h94.1C264 64 272 56 272 46.1c0-4.8-1.9-9.3-5.3-12.7l-6.1-6.1c-4.6-4.6-5.9-11.5-3.5-17.4zM64 320H448c8.8 0 16 7.2 16 16v8c0 57.4-46.6 104-104 104H329.9l20.4 40.8c1.1 2.3 1.7 4.7 1.7 7.2c0 2.9-.8 5.8-2.4 8.4c-2.9 4.7-8.1 7.6-13.6 7.6H176c-5.5 0-10.7-2.9-13.6-7.6c-1.6-2.6-2.4-5.5-2.4-8.4c0-2.4 .6-4.9 1.7-7.2L182.1 448H152C94.6 448 48 401.4 48 344v-8c0-8.8 7.2-16 16-16z"]
};
var faFaceHoldingBackTears = {
  prefix: 'fas',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM344.5 367.9c-6.7-5.8-16.8-5.1-22.6 1.6C309 384.4 287.1 400 256 400s-53-15.6-65.9-30.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6C183.1 410.3 213.2 432 256 432s72.9-21.7 90.1-41.5c5.8-6.7 5.1-16.8-1.6-22.6zM240 272V240c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48s6 34.6 16 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.7c9.8 4.3 20.6 6.7 32 6.7c18 0 34.6-6 48-16c0 8.8 7.2 16 16 16s16-7.2 16-16V288 272zm144 41.3V320c0 8.8 7.2 16 16 16s16-7.2 16-16V288c10-13.4 16-30 16-48s-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7zM128 232c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]
};
var faSquareUp = {
  prefix: 'fas',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm39.1 185.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H272v96c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V256H118.3C106 256 96 246 96 233.7c0-6.2 2.6-12.1 7.1-16.3z"]
};
var faArrowAltSquareUp = faSquareUp;
var faTrainSubwayTunnel = {
  prefix: 'fas',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h41.4l64.3-64.3C137.3 444.5 112 417.2 112 384V192c0-35.3 28.7-64 64-64H336c35.3 0 64 28.7 64 64V384c0 33.2-25.3 60.5-57.7 63.7L406.6 512H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM361.4 512l-64-64H214.6l-64 64H361.4zM184 192c-13.3 0-24 10.7-24 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H192h-8zm88 24v8 64 8c0 13.3 10.7 24 24 24h8 16 8c13.3 0 24-10.7 24-24v-8V224v-8c0-13.3-10.7-24-24-24h-8H304h-8c-13.3 0-24 10.7-24 24zM184 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSubwayTunnel = faTrainSubwayTunnel;
var faSquareExclamation = {
  prefix: 'fas',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faExclamationSquare = faSquareExclamation;
var faSemicolon = {
  prefix: 'fas',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M96 64a64 64 0 1 1 0 128A64 64 0 1 1 96 64zm54.8 319L83.7 492.8C76.4 504.7 63.5 512 49.5 512C24 512 5 488.5 10.4 463.6L37.5 337c6.1-28.6 31.4-49 60.6-49c34.2 0 61.9 28.1 61.9 62.3c0 11.5-3.2 22.9-9.2 32.7z"]
};
var faBookmark = {
  prefix: 'fas',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"]
};
var faFanTable = {
  prefix: 'fas',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M256 413.6C355.7 398.2 432 312 432 208C432 93.1 338.9 0 224 0S16 93.1 16 208c0 104 76.3 190.2 176 205.6V448H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224 352c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V413.6zM184.9 68.5L224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4c-1.2 8.8-9.3 14.8-18.1 13.6L260.2 229.2c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2c-7-5.4-8.2-15.5-2.8-22.5l64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7c8.2-3.3 17.5 .6 20.8 8.8zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAlignJustify = {
  prefix: 'fas',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]
};
var faBatteryLow = {
  prefix: 'fas',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm80 96H96V320h64V192z"]
};
var faBattery1 = faBatteryLow;
var faCreditCardFront = {
  prefix: 'fas',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM96 368c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM408 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H408z"]
};
var faBrainArrowCurvedRight = {
  prefix: 'fas',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M240 56c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56V56zm32 0V456c0 30.9 25.1 56 56 56c3.2 0 6.4-.3 9.5-.8C321.3 491 304 459.3 304 416c0-79.5 64.5-144 144-144h32V256c0-4.9 .8-9.8 2.2-14.3c-4.9-3.9-10.2-7.3-16-10C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56zM539.3 244.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v48H448c-61.9 0-112 50.1-112 112c0 54.3 34.6 85.6 45 93.8c1.9 1.5 4.3 2.2 6.7 2.2c6.8 0 12.3-5.5 12.3-12.3V464c0-35.3 28.7-64 64-64h48v48c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"]
};
var faMindShare = faBrainArrowCurvedRight;
var faUmbrellaBeach = {
  prefix: 'fas',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"]
};
var faHelmetUn = {
  prefix: 'fas',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faLocationSmile = {
  prefix: 'fas',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-95.4 84.9c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z"]
};
var faMapMarkerSmile = faLocationSmile;
var faArrowLeftToLine = {
  prefix: 'fas',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 96C0 78.3 14.3 64 32 64s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96zM137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]
};
var faArrowToLeft = faArrowLeftToLine;
var faBullseye = {
  prefix: 'fas',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSushi = {
  prefix: 'fas',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M479.7 320l-73.8-24.5L506.3 125.6c24.8 26.7 42.1 60.7 48.5 98.8l12.5 75.2c4 23.8-18.8 43.2-41.7 35.6l-7-2.3L479.7 320h0zM393.5 66.1c32.9 4.8 63.2 18 88.7 37.5L374.8 285.2 323.1 268c-14.6-4.9-30-7-45.2-6.4L393.5 66.1zm-36-2.1L235.6 270.4 96.1 318.7 246.6 64H357.5zM21.3 224.4C36.6 132.2 116.1 64.6 209.5 64L49.4 334.8c-22.4 6.6-44.5-12.5-40.6-36l12.4-74.4zM32 384V369c8.5 .7 17.5-.3 26.4-3.4l193-66.9c20-6.9 41.6-7.1 61.7-.4l205.5 68.2c8.6 2.9 17.2 3.8 25.5 3.1V384c0 35.3-28.7 64-64 64c-19.1 0-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7C132.3 439.6 115.1 448 96 448c-35.3 0-64-28.7-64-64z"]
};
var faNigiri = faSushi;
var faMessageCaptions = {
  prefix: 'fas',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H344zM120 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faCommentAltCaptions = faMessageCaptions;
var faTrashList = {
  prefix: 'fas',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M147.8 0H268.2c12.1 0 23.2 6.8 28.6 17.7L304 32h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h80l7.2-14.3C124.6 6.8 135.7 0 147.8 0zM32 128H384L362.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm448 0H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32s14.3-32 32-32zM448 416c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-17.7 0-32-14.3-32-32z"]
};
var faBacon = {
  prefix: 'fas',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"]
};
var faOption = {
  prefix: 'fas',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M448 448c-9.7 0-18.9-4.4-25-12L176.6 128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H192c9.7 0 18.9 4.4 25 12L463.4 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H448zm0-320c-17.7 0-32-14.3-32-32s14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H448z"]
};
var faRaccoon = {
  prefix: 'fas',
  iconName: 'raccoon',
  icon: [512, 512, [], "e613", "M336 32c20.5 0 39.9 9.2 52.8 25.1l28.9 35.6-31.5-7.3c-20.2-4.7-39.7 4.2-50.2 19.9c-10.5-15.7-30.1-24.6-50.2-19.9l-31.5 7.3 28.9-35.6C296.1 41.2 315.5 32 336 32zM296.7 205.3c-5.6-3.7-11.4-7-17.5-10l39.9-21.8c6.9-3.8 12.6-9.1 16.8-15.3c4.2 6.3 9.9 11.6 16.8 15.3l39.9 21.8c-6 2.9-11.9 6.2-17.5 10L360 215.4c-.3-13-10.9-23.4-24-23.4s-23.7 10.4-24 23.4l-15.3-10.2zm187.5-81.4l-20.3-25 13.8-41.5c1.5-4.4 2.2-9.1 2.2-13.8C480 19.5 460.5 0 436.5 0h-1.3c-3.3 0-6.5 .4-9.7 1.1l-44.1 9.8C367.5 3.8 352 0 336 0s-31.5 3.8-45.3 10.9L246.6 1.1c-3.2-.7-6.5-1.1-9.7-1.1h-1.3C211.5 0 192 19.5 192 43.5c0 4.7 .8 9.3 2.2 13.8l13.8 41.5-20.3 25c-7.6 9.3-11.7 21-11.7 33c0 23.1 15.2 43.5 37.3 50.2l35.8 10.7c10.6 3.2 20.6 7.9 29.8 14l18.8 12.6C309.1 252 322.4 256 336 256s26.9-4 38.2-11.6L393 231.9c9.2-6.1 19.2-10.9 29.8-14l35.8-10.7c22.2-6.6 37.3-27 37.3-50.2c0-12-4.1-23.7-11.7-33zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM185.1 229.3C131.2 266.9 96 329.4 96 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-16.4 1.7-32.5 4.8-48H0v48c0 61.9 50.1 112 112 112H240h80V496c0-26.5-21.5-48-48-48H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c44.2 0 80 35.8 80 80v16h24l.1 0H416h64V495.6c-.2-26.3-21.6-47.6-48-47.6H416l0 0V376l-6.4 4.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l38.1-28.5c12.3-9.2 19.5-23.7 19.5-39.1c0-14.9-6.8-29-18.5-38.3c-6.6 2.2-12.9 5.3-18.7 9.2l-18.8 12.6c-16.6 11-36 16.9-55.9 16.9s-39.4-5.9-55.9-16.9l-18.8-12.6c-6.6-4.4-13.7-7.7-21.3-10l-35.8-10.7c-6.8-2-13.2-4.9-19.1-8.4zM0 128H128V96c0-35.3-28.7-64-64-64S0 60.7 0 96v32zm0 32v64H128V160H0zM0 320H77.7c8.2-23.2 19.8-44.7 34.3-64H0v64zm480-24l-.3-.9c0 .4-.1 .9-.1 1.3l.5-.4zM317.7 376.2c-4.5 7.6-14.4 10-22 5.5l-80-48c-7.6-4.5-10-14.4-5.5-22s14.4-10 22-5.5l80 48c7.6 4.5 10 14.4 5.5 21.9z"]
};
var faHandPointDown = {
  prefix: 'fas',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"]
};
var faArrowUpFromBracket = {
  prefix: 'fas',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"]
};
var faHeadSideGear = {
  prefix: 'fas',
  iconName: 'head-side-gear',
  icon: [512, 512, [], "e611", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm336.6-28.3c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faTrashPlus = {
  prefix: 'fas',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zM200 408c0 13.3 10.7 24 24 24s24-10.7 24-24V344h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faObjectsAlignTop = {
  prefix: 'fas',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M24 0H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24S10.7 0 24 0zM64 176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V176zm224 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V176z"]
};
var faFolder = {
  prefix: 'fas',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"]
};
var faFolderBlank = faFolder;
var faFaceAnxiousSweat = {
  prefix: 'fas',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5zM208 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faCreditCardBlank = {
  prefix: 'fas',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faFileWaveform = {
  prefix: 'fas',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", "M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"]
};
var faFileMedicalAlt = faFileWaveform;
var faMicrochipAi = {
  prefix: 'fas',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zm32 152c6.4 0 12.1 3.8 14.7 9.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304H176.5l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6zm17.5 96L208 231.9 190.5 272h35.1zM336 176c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16z"]
};
var faMug = {
  prefix: 'fas',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M64 64C46.3 64 32 78.3 32 96V352c0 53 43 96 96 96H320c53 0 96-43 96-96V320h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H384 64zm352 64h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H416V128z"]
};
var faPlaneUpSlash = {
  prefix: 'fas',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L482.4 352.8 554.9 377c10.4 3.5 21.1-4.3 21.1-15.2V305.1c0-10.7-5.3-20.7-14.2-26.6L384 160l0-66.3C384 59.5 356 0 320 0c-35 0-64 59.5-64 93.7V160l-10.6 7.1L38.8 5.1zm122.5 218L78.2 278.5C69.3 284.4 64 294.4 64 305.1v56.7c0 10.9 10.7 18.6 21.1 15.2L256 320v80l-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L320 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c7.8 0 14-6.3 14-14V455.3c0-2.8-.7-5.6-2.1-8L161.3 223.1z"]
};
var faRadiation = {
  prefix: 'fas',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faPenCircle = {
  prefix: 'fas',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faBagSeedling = {
  prefix: 'fas',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", "M64 64L38.6 38.6c-4.2-4.2-6.6-10-6.6-16C32 10.1 42.1 0 54.6 0H457.4C469.9 0 480 10.1 480 22.6c0 6-2.4 11.8-6.6 16L448 64H64zM56 96H456l10.6 42.5c8.9 35.5 13.4 72 13.4 108.7v17.7c0 36.6-4.5 73.1-13.4 108.7L456 416H56L45.4 373.5C36.5 338 32 301.5 32 264.8V247.2c0-36.6 4.5-73.1 13.4-108.7L56 96zm8 352H448l25.4 25.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16L64 448zm80-288c-8.8 0-16 7.2-16 16c0 59.2 45.9 107.6 104 111.7V328c0 13.3 10.7 24 24 24s24-10.7 24-24V287.7c58.1-4.1 104-52.6 104-111.7c0-8.8-7.2-16-16-16h-2c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160h-2z"]
};
var faChartSimple = {
  prefix: 'fas',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"]
};
var faCrutches = {
  prefix: 'fas',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M470.6 9.4l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM294.6 188.2L404.1 78.6l45.3 45.3L397.3 176 464 242.7l52.1-52.1 45.3 45.3-74.6 74.6-.1 .1-.1 .1-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8L297.1 395.2c-5.9 1.3-11.4 4.3-15.7 8.6l-98.8 98.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1zm45.3 45.3c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6L418.7 288 352 221.3l-12.2 12.2zM169.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L213.3 56l84.1 84.1-25.4 25.4c-6.7 6.7-12.6 14.1-17.6 22L168 101.3 101.3 168 223.7 290.4l-10.1 45.5-17 17c-2.9-2.3-5.7-4.8-8.4-7.5L56 213.3l-1.4 1.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160zM411.7 402.5c9.3-2.1 18.3-5.2 26.9-9.2l64.1 64.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-90.2-90.2 44.5-9.9z"]
};
var faCircleParking = {
  prefix: 'fas',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 0h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H232v64zm48 64H232v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParkingCircle = faCircleParking;
var faMarsStroke = {
  prefix: 'fas',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"]
};
var faLeafOak = {
  prefix: 'fas',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", "M429.7 268.6l40.9-10.2c24.4-6.1 41.4-28 41.4-53.1c0-18.3-9.1-35.4-24.4-45.5l-14.3-9.5c-5.6-3.8-8.3-10.6-6.6-17.2l5-20.1c5.1-20.4-.9-42-15.8-56.9s-36.5-20.9-56.9-15.8l-20.1 5c-6.6 1.6-13.4-1-17.2-6.6l-9.5-14.3C342.1 9.1 325 0 306.7 0c-25.1 0-47 17.1-53.1 41.4L243.4 82.3c-1.5 6-9 8.1-13.4 3.7L208 64c-17.7-17.7-46.3-17.7-64 0c-10.1 10.1-14.8 24.3-12.8 38.4l10.7 75.1c.8 5.6-5.4 9.5-10.1 6.4C111 170 83.3 172.7 65.6 190.4l-3.6 3.6c-17.9 17.9-22.3 45.2-11 67.8L66.5 293C75.4 310.7 80 330.3 80 350.2v35.2L229.6 235.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l73-73h15.8c19.9 0 39.5 4.6 57.2 13.5l31.1 15.5c22.6 11.3 49.9 6.9 67.8-11l3.6-3.6c17.7-17.7 20.4-45.4 6.6-66.2c-3.1-4.7 .8-10.9 6.4-10.1l75.1 10.7c14.1 2 28.3-2.7 38.4-12.8c17.7-17.7 17.7-46.3 0-64l-22-22c-4.4-4.4-2.3-11.9 3.7-13.4z"]
};
var faSquareBolt = {
  prefix: 'fas',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm234.1 83.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240H320c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272H128c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faVial = {
  prefix: 'fas',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"]
};
var faGauge = {
  prefix: 'fas',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faWandMagicSparkles = {
  prefix: 'fas',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faLambda = {
  prefix: 'fas',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H140.2l16.4 32.7L18.8 434.9c-7.3 16.1-.1 35.1 16 42.3s35.1 .1 42.3-16L193.5 202.6l121 242c10.8 21.7 33 35.4 57.2 35.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H371.8L197.5 67.4C186.6 45.7 164.5 32 140.2 32H32z"]
};
var faE = {
  prefix: 'fas',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"]
};
var faPizza = {
  prefix: 'fas',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M385.2 419c10.4-8.2 25.5-8.4 34.9 1s9.4 24.7-.8 33.1C375 489.9 318.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c62.1 0 119 22.1 163.3 58.8c10.2 8.5 10.1 23.8 .8 33.1s-24.5 9.2-34.9 1C349.7 64.8 304.8 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c48.8 0 93.7-16.8 129.2-45zm-16-49.9c6.2 6.2 6.3 16.5-.5 22.1c-69.1 57.7-172.2 54.1-237.1-10.8c-68.7-68.7-68.7-180.2 0-248.9C196.5 66.6 299.5 63 368.6 120.8c6.8 5.7 6.7 15.9 .5 22.1L267.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L369.1 369.1zM192 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM443.4 156.6c6.7-6.7 17.7-6.2 23 1.7c39.5 59 39.5 136.5 0 195.5c-5.2 7.8-16.3 8.3-23 1.7l-88.1-88.1c-6.2-6.2-6.2-16.4 0-22.6l24.2-24.2c3.6 2.2 7.9 3.5 12.5 3.5c13.3 0 24-10.7 24-24c0-4.6-1.3-8.9-3.5-12.5l30.9-30.9zM472 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm22.4 126.4c-8.9-8.9-9.4-23.1-2.3-33.5C514.8 339.6 528 299.3 528 256s-13.2-83.6-35.9-116.9c-7.1-10.4-6.6-24.6 2.3-33.5c9.9-9.9 26.2-9.4 34.3 2C558.5 149.5 576 200.7 576 256s-17.5 106.5-47.4 148.4c-8.1 11.4-24.4 11.9-34.3 2z"]
};
var faBowlChopsticksNoodles = {
  prefix: 'fas',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", "M13.1 93.6L128 72V56c0-13.3 10.7-24 24-24s24 10.7 24 24v7 37.5 38V176v48h32V176 137.5v-42V57 40c0-13.3 10.7-24 24-24s24 10.7 24 24v8V88v48 40 48h32H478.4c18.2 0 32.7 15.3 31.6 33.5c-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5C.9 239.3 15.4 224 33.6 224H128V176H16.2C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140V108L18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6zM488.4 176H288V135l199.6-6.2C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83V42L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23z"]
};
var faH3 = {
  prefix: 'fas',
  iconName: 'h3',
  icon: [640, 512, [], "f315", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM400 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H514.7l-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h72c30.9 0 56 25.1 56 56s-25.1 56-56 56H455.4c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5H520c66.3 0 120-53.7 120-120c0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H400z"]
};
var faPenClip = {
  prefix: 'fas',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"]
};
var faPenAlt = faPenClip;
var faBridgeCircleExclamation = {
  prefix: 'fas',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faBadgePercent = {
  prefix: 'fas',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]
};
var faUser = {
  prefix: 'fas',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"]
};
var faSensor = {
  prefix: 'fas',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faComma = {
  prefix: 'fas',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M160 350.4V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.1-60.1 50.1l-22.2 122c-.5 2.6-.7 5.2-.7 7.9v8.2C16 495.9 32.1 512 51.9 512c12.5 0 24.1-6.5 30.6-17.2L150.8 383c6-9.8 9.2-21.1 9.2-32.6z"]
};
var faSchoolCircleCheck = {
  prefix: 'fas',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
var faToiletPaperUnder = {
  prefix: 'fas',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", "M96 0H348.2C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416H416c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V416zM64 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faToiletPaperReverse = faToiletPaperUnder;
var faLightEmergency = {
  prefix: 'fas',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160V352H64V192zm160-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zM32 384H416c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"]
};
var faArrowDownToArc = {
  prefix: 'fas',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 448c106 0 192-86 192-192c0-17.7 14.3-32 32-32s32 14.3 32 32c0 141.4-114.6 256-256 256S0 397.4 0 256c0-17.7 14.3-32 32-32s32 14.3 32 32c0 106 86 192 192 192zM390.6 230.6l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 242.7 224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faDumpster = {
  prefix: 'fas',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"]
};
var faVanShuttle = {
  prefix: 'fas',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShuttleVan = faVanShuttle;
var faBuildingUser = {
  prefix: 'fas',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"]
};
var faLightSwitch = {
  prefix: 'fas',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 96h64c35.3 0 64 28.7 64 64v80H96V160c0-35.3 28.7-64 64-64zM288 272v80c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V272H288zM192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSquareCaretLeft = {
  prefix: 'fas',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faHighlighter = {
  prefix: 'fas',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"]
};
var faWavePulse = {
  prefix: 'fas',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", "M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H499.8L444.6 398.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4L323.7 167.3 255.3 486.7c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H135.9c28.6 0 53.7 18.9 61.5 46.4L219.6 348 288.7 25.3C291.8 10.9 304.4 .4 319.1 0z"]
};
var faHeartRate = faWavePulse;
var faKey = {
  prefix: 'fas',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faHatSanta = {
  prefix: 'fas',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", "M149.7 137.8L64 352H448L385.1 210.6c-.8-1.7-1.1-3.5-1.1-5.4c0-7.3 5.9-13.2 13.2-13.2h.8c1.4 0 2.7 .2 4 .6l55.3 16.6c2.1-3.2 4.5-6.1 7.2-8.8c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8zm434.3 44.4C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C489.8 217 480 227.3 480 240s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48s-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"]
};
var faTamale = {
  prefix: 'fas',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M48.1 18.3C72.3 8.6 108.4 0 160 0s87.7 8.6 111.9 18.3c12.1 4.8 21 9.9 27.4 14.1c12.7 8.5 23.1 20.4 20.3 36.9L296.4 208l-.4 0H236.2L248 72.7c.4-4.4-2.9-8.3-7.3-8.7s-8.3 2.9-8.7 7.3L220.1 208H168V64c0-4.4-3.6-8-8-8s-8 3.6-8 8V208H99.9L88 71.3c-.4-4.4-4.3-7.7-8.7-7.3s-7.7 4.3-7.3 8.7L83.8 208H24l-.4 0L.4 69.3C-2.3 52.8 8.1 40.8 20.8 32.4c6.3-4.2 15.3-9.3 27.4-14.1zM24 240H296c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16s7.2-16 16-16zM152 448c0 4.4 3.6 8 8 8s8-3.6 8-8V346.7c13.4 17.9 35.9 26.5 57.4 18.1l6.6 76c.4 4.4 4.3 7.7 8.7 7.3s7.7-4.3 7.3-8.7l-7.3-84.1c14.2-13.2 18.9-33.4 12.6-51.2H296l.4 0 23.1 138.7c1.7 10.2-1.6 20.6-8.9 27.9l0 0c-10.6 10.5-25.1 17.6-38.7 23C247.7 503.4 211.6 512 160 512s-87.7-8.6-111.9-18.3c-13.7-5.5-28.1-12.5-38.7-23l0 0c-7.3-7.3-10.6-17.7-8.9-27.9L23.6 304l.4 0H66.7c-6.3 17.7-1.6 38 12.6 51.2L72 439.3c-.4 4.4 2.9 8.3 7.3 8.7s8.3-2.9 8.7-7.3l6.6-76c21.5 8.4 44-.2 57.4-18.1V448z"]
};
var faBoxCheck = {
  prefix: 'fas',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm337 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 281z"]
};
var faBullhorn = {
  prefix: 'fas',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"]
};
var faSteak = {
  prefix: 'fas',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122l0 0c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416c-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zm6.8-75.2c-13.3 12.4-21.9 29-29 45.3c-2.9 6.6-5.6 13.2-8.3 19.8c-11.4 27.8-22.8 55.7-46.4 79.3c-41.4 41.4-78.6 57.1-107 69l-1.1 .5-.7 .3 0 0c-13.5 5.7-27.5 11.6-37.7 20.3C70.4 328.8 64 342.1 64 360c0 39.3 33.9 60.8 66.8 72.1C165.1 443.9 207 448 240 448c66.3 0 133.6-25.4 184.4-63.2C474.8 347.4 512 295.2 512 240c0-44.1-17.5-87.5-43.5-120C442.7 87.8 406.6 64 368 64c-23.7 0-41.7 7.3-55.6 20.3zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLocationCrosshairsSlash = {
  prefix: 'fas',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c12.1-20.1 20.6-42.6 24.6-66.6H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H509.3C495.9 143.6 432.4 80.1 352 66.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7c-39.9 6.7-75.6 25.7-103.1 52.9L38.8 5.1zm197 154.4C258.3 139.9 287.8 128 320 128c70.7 0 128 57.3 128 128c0 21.2-5.1 41.1-14.2 58.7l-38.9-30.5c3.3-8.8 5.1-18.3 5.1-28.2c0-44.2-35.8-80-80-80c-16.8 0-32.4 5.2-45.3 14l-38.9-30.5zM414.9 422.9l-56.8-44.7C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h34.7c13.5 80.4 76.9 143.9 157.3 157.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c22.6-3.8 43.8-11.5 62.9-22.4z"]
};
var faLocationSlash = faLocationCrosshairsSlash;
var faPersonDolly = {
  prefix: 'fas',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3L98.1 399.4 18.7 320C6.7 308 0 291.7 0 274.7V186.6C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64h46.1l-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L223.3 288H152.6c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64V480v0c0 17.7-14.3 32-32 32s-32-14.3-32-32zm288-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm69.4-87.8c-17.1 4.3-34.5-6.1-38.8-23.3l-22.9-91.5c-4.3-17.1 6.1-34.5 23.3-38.8l91.5-22.9c17.1-4.3 34.5 6.1 38.8 23.3l22.9 91.5c4.3 17.1-6.1 34.5-23.3 38.8l-91.5 22.9z"]
};
var faGlobe = {
  prefix: 'fas',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"]
};
var faSynagogue = {
  prefix: 'fas',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"]
};
var faFileChartColumn = {
  prefix: 'fas',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 248V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 64V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24s24 10.7 24 24zM128 376v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFileChartLine = faFileChartColumn;
var faPersonHalfDress = {
  prefix: 'fas',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"]
};
var faFolderImage = {
  prefix: 'fas',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H392c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 228 304 224 296 224z"]
};
var faCalendarPen = {
  prefix: 'fas',
  iconName: 'calendar-pen',
  icon: [512, 512, ["calendar-edit"], "f333", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm308.8 75c-14.7-14.7-38.6-14.7-53.3 0L272.6 282l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 376.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 428c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 304.6l-71.9 71.9z"]
};
var faCalendarEdit = faCalendarPen;
var faRoadBridge = {
  prefix: 'fas',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"]
};
var faFaceSmileTear = {
  prefix: 'fas',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm141.5 67.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM352 416c26.5 0 48-21 48-47c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C332.4 308.6 304 349 304 369c0 26 21.5 47 48 47zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMessagePlus = {
  prefix: 'fas',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faCommentAltPlus = faMessagePlus;
var faLocationArrow = {
  prefix: 'fas',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"]
};
var faC = {
  prefix: 'fas',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"]
};
var faTabletButton = {
  prefix: 'fas',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPersonDressFairy = {
  prefix: 'fas',
  iconName: 'person-dress-fairy',
  icon: [640, 512, [], "e607", "M320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM304.3 160h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H384v80c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V384H234.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4c-21.5 12.1-38 32.3-45.2 57.3L172.9 334.4c-10.7 37.5 14.2 74.8 51.1 80.7v32.1C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32zM528 480c-41.2 0-79.7-12-112-32.7V415.2c36.9-6 61.8-43.3 51.1-80.7L428 197.6c-7.1-24.9-23.7-45.1-45.2-57.3C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528z"]
};
var faRectangleHistoryCircleUser = {
  prefix: 'fas',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", "M320 368c0 59.5 29.5 112.1 74.8 144L64 512c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24H392zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7H463.4c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faBuildingLock = {
  prefix: 'fas',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faChartLineUp = {
  prefix: 'fas',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM439 279c15.1 15.1 41 4.4 41-17V152c0-13.3-10.7-24-24-24H345.9c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80L439 279z"]
};
var faMailbox = {
  prefix: 'fas',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M0 208V384c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm256 0V384c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144H245.2C290.4 95.9 320 148.5 320 208zm64 0c0-8.8 7.2-16 16-16h64 32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V224H400c-8.8 0-16-7.2-16-16z"]
};
var faTruckBolt = {
  prefix: 'fas',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM270.3 87.2L233.9 160H288c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L182.1 192H128c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z"]
};
var faPizzaSlice = {
  prefix: 'fas',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMoneyBillWave = {
  prefix: 'fas',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"]
};
var faChartArea = {
  prefix: 'fas',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"]
};
var faAreaChart = faChartArea;
var faHouseFlag = {
  prefix: 'fas',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"]
};
var faCircleThreeQuartersStroke = {
  prefix: 'fas',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M256 64V224c0 17.7 14.3 32 32 32H448c0-106-86-192-192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPersonCircleMinus = {
  prefix: 'fas',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faScalpel = {
  prefix: 'fas',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", "M387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320H176h96 16v16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160 4.7-4.7z"]
};
var faBan = {
  prefix: 'fas',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faCancel = faBan;
var faBellExclamation = {
  prefix: 'fas',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM192 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-184v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faCircleBookmark = {
  prefix: 'fas',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4V176z"]
};
var faBookmarkCircle = faCircleBookmark;
var faEggFried = {
  prefix: 'fas',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM336 240a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-160-8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-39.8 32.2-72 72-72c8.8 0 16 7.2 16 16s-7.2 16-16 16c-22.1 0-40 17.9-40 40z"]
};
var faFaceWeary = {
  prefix: 'fas',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm46.6-164c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faUniformMartialArts = {
  prefix: 'fas',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M180 0h28 9.6c12.3 0 23.5 7 28.8 18.1l61.1 126.7L253 288H144V133.1L98 216.7c-1.3 2.4-2 5-2 7.7V384c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7C95.9 21.2 124.9 2.8 157 .3c1-.2 2-.3 3-.3h4.4H180zM389.1 20.6C393.8 8.2 405.7 0 419 0h13 28 15.6H480c1 0 2 .1 3 .3c32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54V384c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32V224.4c0-2.7-.7-5.3-2-7.7l-46-83.7V288H287.2l52.7-138.3L389.1 20.6zM320 320H496v32H388.4 349.9l47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2L290.1 352H251.6 144V320H264h56zM216.1 405.4c-14.7 22.1-8.7 51.9 13.3 66.6s51.9 8.7 66.6-13.3L320 422.5l24.1 36.1c14.7 22.1 44.5 28 66.6 13.3s28-44.5 13.3-66.6L409.7 384H496v64c0 35.3-28.7 64-64 64H208c-35.3 0-64-28.7-64-64V384h86.3l-14.2 21.4z"]
};
var faCameraRotate = {
  prefix: 'fas',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", "M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"]
};
var faSunDust = {
  prefix: 'fas',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", "M371.1 13.1L391 121l-44.5 44.5C323.3 142.3 291.3 128 256 128c-70.7 0-128 57.3-128 128c0 35.3 14.3 67.3 37.5 90.5L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9zM256 160c26.5 0 50.5 10.7 67.9 28.1L188.1 323.9C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96zm192 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM240 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCommentText = {
  prefix: 'fas',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 160h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V312c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSprayCanSparkles = {
  prefix: 'fas',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"]
};
var faAirFreshener = faSprayCanSparkles;
var faSignalBars = {
  prefix: 'fas',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M560 0c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V48c0-26.5-21.5-48-48-48zM352 176V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zM240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAlt = faSignalBars;
var faSignalAlt4 = faSignalBars;
var faSignalBarsStrong = faSignalBars;
var faDiamondExclamation = {
  prefix: 'fas',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faStar = {
  prefix: 'fas',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"]
};
var faDialMin = {
  prefix: 'fas',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM400.9 401c-56.7 56.7-145.4 62-208 15.7L304.7 304.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L158.9 382.8c-46.2-62.6-41-151.3 15.7-208c62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faRepeat = {
  prefix: 'fas',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"]
};
var faCross = {
  prefix: 'fas',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"]
};
var faPageCaretDown = {
  prefix: 'fas',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z"]
};
var faFileCaretDown = faPageCaretDown;
var faBox = {
  prefix: 'fas',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"]
};
var faVenusMars = {
  prefix: 'fas',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"]
};
var faClockSevenThirty = {
  prefix: 'fas',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V335.3l-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faArrowPointer = {
  prefix: 'fas',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"]
};
var faMousePointer = faArrowPointer;
var faClockFourThirty = {
  prefix: 'fas',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V300.8L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faSignalBarsGood = {
  prefix: 'fas',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", "M400 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 304V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48s-48 21.5-48 48zM32 432v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSignalAlt3 = faSignalBarsGood;
var faCactus = {
  prefix: 'fas',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M160 96c0-53 43-96 96-96s96 43 96 96V352h48c8.8 0 16-7.2 16-16V272c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 61.9-50.1 112-112 112H352v16c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V320H112C50.1 320 0 269.9 0 208V144c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 8.8 7.2 16 16 16h48V96zm80 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLightbulbGear = {
  prefix: 'fas',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M262.1 352.2c-11 7-19.1 18.6-21.4 31.8H112c-9.6-31.9-29.5-59.1-49.2-86.2l0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3c-17.8 7.7-28 25.6-28 43.3v.9c-17.6-9.7-41.5-8.2-57.2 8.7c-9.2 9.9-17.4 20.9-24.4 33s-12.4 24.7-16.4 37.6c-6.7 21.6 3.4 42.7 20 53.3zM112 416H245.6c3.5 9.2 7.7 18.3 12.8 27c2.9 5 6 9.9 9.4 14.6C257.1 489.2 227.2 512 192 512c-44.2 0-80-35.8-80-80V416zm0-240c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16zm260 42.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7l0 17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V467.8c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
var faMaximize = {
  prefix: 'fas',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", "M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"]
};
var faExpandArrowsAlt = faMaximize;
var faChargingStation = {
  prefix: 'fas',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"]
};
var faShapes = {
  prefix: 'fas',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
var faTriangleCircleSquare = faShapes;
var faPlaneTail = {
  prefix: 'fas',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M61.5 308.8L.8 39C-3.7 19 11.5 0 32 0h76.9c17.3 0 33.9 7 46 19.5L384 256H488h24v24 24V464v24 24H488 267.7c-10.7 0-21.2-1.9-31.2-5.7L40.4 431.9C16.1 422.7 0 399.4 0 373.4c0-28.2 18.8-52.8 45.9-60.3l15.5-4.3zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"]
};
var faGaugeSimpleMax = {
  prefix: 'fas',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometerFastest = faGaugeSimpleMax;
var faCircleU = {
  prefix: 'fas',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faShieldSlash = {
  prefix: 'fas',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", "M320 0c4.6 0 9.2 1 13.4 2.9L521.7 82.8c22 9.3 38.4 31 38.3 57.2c-.3 58.7-14.7 146.2-62.1 225L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L131 77.4 306.7 2.9C310.8 1 315.4 0 320 0zM80.6 159.5L437.5 440.7c-25.2 24-55.3 45.4-91.1 62.5c-16.7 8-36.1 8-52.8 0C132 425.8 86.1 261.5 80.6 159.5z"]
};
var faSquarePhoneHangup = {
  prefix: 'fas',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM359.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L66.8 274.8C62 267 63.4 257.3 70.3 251c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L359.4 310z"]
};
var faPhoneSquareDown = faSquarePhoneHangup;
var faArrowUpLeft = {
  prefix: 'fas',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", "M64 96c-17.7 0-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V205.3L297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 160H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"]
};
var faTransporter1 = {
  prefix: 'fas',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 512c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216 128zM383.7 288c-9.3-.1-18.5-4.2-24.7-12l-31-38.7V288H184V237.3L153 276c-6.3 7.8-15.4 11.9-24.7 12H128v0c-7 0-14.1-2.3-20-7c-13.8-11.1-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36h40.7c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45c-5.9 4.7-13 7-20 7v0h-.3zm-327 38.6L64 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 384 6.6 376.7C2.7 375.6 0 372.1 0 368s2.7-7.6 6.6-8.7L32 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM176 320H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPeanuts = {
  prefix: 'fas',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", "M299.2 38.9l22.6 50.7c-3.6 10.8-6.5 22.2-8.8 31.5l0 0 0 0 0 0c-1.2 4.6-2.2 8.8-3.1 12.1c-4.2 14.8-8.7 24.6-16.3 32.2s-17.4 12.1-32.2 16.3c-3.4 1-7.5 2-12.1 3.1l0 0c-12.5 3.1-28.5 7.1-42 12.7c-21.3 8.8-41.2 21.9-58.4 39.1C114.3 271.1 96 315.4 96 364v68c0 27.8 10.2 53.3 27 72.9l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2zM492 0h68c44.2 0 80 35.8 80 80v68c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.6 .6-1.1 1.1-1.7 1.7C353.1 495.8 316.5 512 276 512H208c-44.2 0-80-35.8-80-80V364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C362.4 74 373 57.8 387.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C452.8 4 471.9 0 492 0zm52 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM339.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z"]
};
var faShuffle = {
  prefix: 'fas',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"]
};
var faRandom = faShuffle;
var faPersonRunning = {
  prefix: 'fas',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"]
};
var faRunning = faPersonRunning;
var faMobileRetro = {
  prefix: 'fas',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faGripLinesVertical = {
  prefix: 'fas',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faBinBottlesRecycle = {
  prefix: 'fas',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", "M152 0c-13.3 0-24 10.7-24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16H256c8.8 0 16-7.2 16-16s-7.2-16-16-16V24c0-13.3-10.7-24-24-24H152zM32 192H352c0-26.5-10.7-50.5-28.1-67.9c-1.1-1.1-2.1-2.1-3.2-3.1c-17.1-15.5-39.7-25-64.6-25H128c-53 0-96 43-96 96zm352 0H575.1c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-5.3-2.5-10.8-4.4-16.4-5.7V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24V66.1c-5.6 1.3-11.1 3.2-16.4 5.7L354.1 78c-7.2 3.4-13.5 8-18.6 13.6C365 115.1 384 151.3 384 192zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32L56.2 457c4.5 31.5 31.5 55 63.4 55h401c31.8 0 58.9-23.4 63.4-55L608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM308.5 326.1l-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7c-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4c15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4c-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2c-4.6 0-8.9 2.3-11.5 6.1zm-43.1 64.7l-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7c0 4.7 3.8 8.6 8.6 8.6h25.2c8.8 0 16 7.2 16 16s-7.2 16-16 16H264.6c-22.4 0-40.6-18.2-40.6-40.6c0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7c7.6 4.8 9.8 14.9 4.8 22.4zM353.7 416h20.9c4.8 0 8.6-3.9 8.6-8.6c0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4c7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4c0 22.4-18.2 40.6-40.6 40.6H353.7c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faArrowUpFromSquare = {
  prefix: 'fas',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM64 112c0-8.8 7.2-16 16-16h8c17.7 0 32-14.3 32-32s-14.3-32-32-32H80C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112z"]
};
var faFileDashedLine = {
  prefix: 'fas',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512v96H128V64zm0 304H512v80c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V368zM512 128H384V0L512 128zM56 288H168c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24zm192 0H584c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faPageBreak = faFileDashedLine;
var faBracketCurlyRight = {
  prefix: 'fas',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M192 128c0-53-43-96-96-96H64C46.3 32 32 46.3 32 64s14.3 32 32 32H96c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9L178.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96c53 0 96-43 96-96V346.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6V128z"]
};
var faSpider = {
  prefix: 'fas',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"]
};
var faClockThree = {
  prefix: 'fas',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faHandsBound = {
  prefix: 'fas',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"]
};
var faScalpelLineDashed = {
  prefix: 'fas',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", "M441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3H332.6c14.1 0 27.6-6.2 36.7-17L494.4 122.7C505.8 109.2 512 92.2 512 74.6v-4C512 31.6 480.4 0 441.4 0zM164.7 324.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336V320H272 176h-6.6l-4.7 4.7zM304 480H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H496z"]
};
var faScalpelPath = faScalpelLineDashed;
var faFileInvoiceDollar = {
  prefix: 'fas',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"]
};
var faPipeSmoking = {
  prefix: 'fas',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M575.2 64c-32.1 0-62.1 16-79.9 42.7l-61.8 92.7c-3.9-4.8-8.6-9.1-14-12.7l-24-16c-4.7-3.2-9.7-5.6-14.9-7.4L442 71.2C471.7 26.7 521.7 0 575.2 0H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H575.2zM333.4 206.2c9.8-14.7 29.7-18.7 44.4-8.9l24 16c14.7 9.8 18.7 29.7 8.9 44.4L287.8 442.1C258.6 485.8 209.6 512 157.1 512C70.3 512 0 441.7 0 354.9V272c0-26.5 21.5-48 48-48H208c26.5 0 48 21.5 48 48v50.3l77.4-116.1z"]
};
var faFaceAstonished = {
  prefix: 'fas',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faWindow = {
  prefix: 'fas',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zM96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPlaneCircleExclamation = {
  prefix: 'fas',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faEar = {
  prefix: 'fas',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M319.9 335.2c-18.2 16.3-30 39.1-35.1 62.9c-5.6 26.3-18.6 51.3-39 71.7c-56.2 56.2-147.4 56.2-203.6 0C14.1 441.7 0 404.9 0 368V192C0 86 86 0 192 0S384 86 384 192c0 56.9-24.8 108-64.1 143.2zM128 192c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-61.9-50.1-112-112-112S80 130.1 80 192v20.2c0 21.2 12 40.6 31 50.1l14 7c1.8 .9 3 2.8 3 4.9c0 1.6-.7 3.2-2 4.2L88.6 309.6c-10.2 8.5-11.6 23.6-3.1 33.8s23.6 11.6 33.8 3.1l37.4-31.2C169 305.1 176 290.1 176 274.2c0-20.2-11.4-38.8-29.5-47.8l-14-7c-2.7-1.4-4.4-4.1-4.4-7.2V192z"]
};
var faFileLock = {
  prefix: 'fas',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v33.6c-19.8 20.2-32 47.9-32 78.4v24.6c-19.1 11.1-32 31.7-32 55.4V480c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm80 112c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faDiagramVenn = {
  prefix: 'fas',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M256 412.8C216.4 372.4 192 317 192 256s24.4-116.4 64-156.8C245.7 97.1 235 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c11 0 21.7-1.1 32-3.2zm64 45.7c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6zM370.7 192H269.3c-6.5 14.9-10.8 31.1-12.5 48H383.2c-1.7-16.9-6-33.1-12.5-48zM269.3 320H370.7c6.5-14.9 10.8-31.1 12.5-48H256.8c1.7 16.9 6 33.1 12.5 48zM288 352c9.1 12.1 19.9 22.9 32 32c12.1-9.1 22.9-19.9 32-32H288zm64-192c-9.1-12.1-19.9-22.9-32-32c-12.1 9.1-22.9 19.9-32 32h64z"]
};
var faXRay = {
  prefix: 'fas',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faGoalNet = {
  prefix: 'fas',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", "M64 128c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-53-43-96-96-96H96C43 32 0 75 0 128V448c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm112 0c-8.8 0-16 7.2-16 16v48H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V416h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V320h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V224h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H480V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H384V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H288V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H192V144c0-8.8-7.2-16-16-16zm80 256H192V320h64v64zm96 0H288V320h64v64zm96 0H384V320h64v64zm0-96H384V224h64v64zm-96 0H288V224h64v64zm-96 0H192V224h64v64z"]
};
var faCoffinCross = {
  prefix: 'fas',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1H255.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9zM216 120v40h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V208H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSpellCheck = {
  prefix: 'fas',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"]
};
var faLocationXmark = {
  prefix: 'fas',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faMapMarkerTimes = faLocationXmark;
var faMapMarkerXmark = faLocationXmark;
var faCircleQuarterStroke = {
  prefix: 'fas',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M64 256l160 0c17.7 0 32-14.3 32-32l0-160c106 0 192 86 192 192s-86 192-192 192S64 362 64 256zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
var faLasso = {
  prefix: 'fas',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h71c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4 .2-.4C44.7 284.1 0 233.2 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 288c123.7 0 224-50.1 224-112s-100.3-112-224-112S64 114.1 64 176s100.3 112 224 112z"]
};
var faSlash = {
  prefix: 'fas',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]
};
var faPersonToPortal = {
  prefix: 'fas',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c3.6 8.7 10.9 15.2 19.6 18.1C357.8 96.9 391.4 0 432 0c44.2 0 80 114.6 80 256s-35.8 256-80 256c-40.9 0-74.6-98-79.4-224.5c-34.6-3.6-64.9-25.9-78.5-58.5l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM109.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H91.2l18.3-41.3z"]
};
var faPortalEnter = faPersonToPortal;
var faCalendarStar = {
  prefix: 'fas',
  iconName: 'calendar-star',
  icon: [512, 512, [], "f736", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zm233.3 58.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L256 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z"]
};
var faComputerMouse = {
  prefix: 'fas',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"]
};
var faMouse = faComputerMouse;
var faArrowRightToBracket = {
  prefix: 'fas',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faSignIn = faArrowRightToBracket;
var faPegasus = {
  prefix: 'fas',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C378.4 0 321.7 55.6 320 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1c0 48.1 3.8 99.9 26 139.8c9.2 16.6 21.7 31.3 38.2 42.7c-7.2-2.5-14-5.4-20.3-8.8c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43c-25.9 3.5-48.1 18.6-61.1 40C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faFilesMedical = {
  prefix: 'fas',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M160 0H320V96c0 17.7 14.3 32 32 32h96V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM416 64l32 32H402.7 384 352V64 45.3 0l32 32 32 32zM24 96c13.3 0 24 10.7 24 24V376c0 48.6 39.4 88 88 88H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24zm216 80v48H192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288h48c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H304V176c0-8.8-7.2-16-16-16H256c-8.8 0-16 7.2-16 16z"]
};
var faNfcLock = {
  prefix: 'fas',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v65.1c-24.9 3.6-47.2 15.3-64 32.5V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V272v24.6c-19.1 11.1-32 31.7-32 55.4v32H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H320v64H64c-35.3 0-64-28.7-64-64V96zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faPersonSkiLift = {
  prefix: 'fas',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", "M240 0c8.8 0 16 7.2 16 16V198.3l-32 8.5V16c0-8.8 7.2-16 16-16zM64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80zm36.4 138c-14.2-30.8 8.3-66 42.2-66c18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6V388.5L443.1 343c12.6-4.6 20.9-16.6 20.9-30v-1c0-13.3 10.7-24 24-24s24 10.7 24 24v1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L256 412.2V297.7l-66.7 17.8c-22.6 6-46.2-5.1-56-26.3L100.4 218zM45.7 189.6l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32s26.3-.7 32 11.3z"]
};
var faSkiLift = faPersonSkiLift;
var faSquare6 = {
  prefix: 'fas',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288z"]
};
var faShopSlash = {
  prefix: 'fas',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384z"]
};
var faStoreAltSlash = faShopSlash;
var faWindTurbine = {
  prefix: 'fas',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.8 212c-.5-3.4 .1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5L31.1 140.6C13.7 141 9.5 165 25.7 171.4l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5L315.7 414.8zM224 326.8V464H152c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H288V430.8l-64-104zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSlidersSimple = {
  prefix: 'fas',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm90.5 0L480 320c17.7 0 32 14.3 32 32s-14.3 32-32 32l-293.5 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96s43-96 96-96c41.8 0 77.4 26.7 90.5 64zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-58.5-32c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64L32 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l293.5 0z"]
};
var faGridRound = {
  prefix: 'fas',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 160A64 64 0 1 1 0 256a64 64 0 1 1 128 0zM64 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM288 96A64 64 0 1 1 160 96a64 64 0 1 1 128 0zM224 320a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-256a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
var faBadgeSheriff = {
  prefix: 'fas',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", "M272 48c0 14.8-6.7 28-17.2 36.8l25 42.8c5.7 9.8 16.2 15.8 27.5 15.9l47.6 .2c6.7-18.5 24.4-31.7 45.2-31.7c26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L363 240.1c-5.6 9.8-5.6 21.9 0 31.8l20.1 35.2c5.3-2 10.9-3.1 16.9-3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-47.6 .2c-11.3 0-21.8 6.1-27.5 15.9l-25 42.8c10.5 8.8 17.2 22 17.2 36.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8l-25-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-47.6-.2C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L85 271.9c5.6-9.8 5.6-21.9 0-31.8L64.9 204.9c-5.3 2-10.9 3.1-16.9 3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l47.6-.2c11.3 0 21.8-6.1 27.5-15.9l25-42.8C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faServer = {
  prefix: 'fas',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faVirusCovidSlash = {
  prefix: 'fas',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"]
};
var faIntersection = {
  prefix: 'fas',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M32 480c17.7 0 32-14.3 32-32V224c0-70.7 57.3-128 128-128s128 57.3 128 128V448c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-106-86-192-192-192S0 118 0 224V448c0 17.7 14.3 32 32 32z"]
};
var faShopLock = {
  prefix: 'fas',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFamily = {
  prefix: 'fas',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 160h44.8c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.6 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.7-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336c0-44.2 35.8-80 80-80z"]
};
var faHourglassStart = {
  prefix: 'fas',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"]
};
var faHourglass1 = faHourglassStart;
var faUserHairBuns = {
  prefix: 'fas',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H160c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32h14.4c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6c17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6c24.3 0 44-19.7 44-44V108c0-24.3-19.7-44-44-44c-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8C101.9 66.9 93.3 64 84 64c-24.3 0-44 19.7-44 44v40c0 24.3 19.7 44 44 44zm77.3 128C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]
};
var faBlenderPhone = {
  prefix: 'fas',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"]
};
var faHourglassClock = {
  prefix: 'fas',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h10.8C285.6 480.1 256 427.5 256 368c0-27.2 6.2-53 17.2-76l-36-36 67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faPersonSeatReclined = {
  prefix: 'fas',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", "M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm89 160l-8-32h63c17.7 0 32-14.3 32-32s-14.3-32-32-32H240.8c-6.6-19-24.5-32-44.9-32c-30.9 0-53.6 29.1-46.1 59l21.1 84.5C178 332 203.6 352 233 352h6.3c.5 0 .9 0 1.4 0h78.1c6.7 0 12.6 4.1 15 10.4L370 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H265zM95.5 154.1c-3.3-17.4-20-28.8-37.3-25.6s-28.8 20-25.6 37.3L65.9 343.6C77.2 404.1 130.1 448 191.7 448H272c17.7 0 32-14.3 32-32s-14.3-32-32-32H191.7c-30.8 0-57.2-21.9-62.9-52.2L95.5 154.1z"]
};
var faPaperPlaneTop = {
  prefix: 'fas',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5L68.1 212.2c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7L491.8 292.7c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z"]
};
var faPaperPlaneAlt = faPaperPlaneTop;
var faSend = faPaperPlaneTop;
var faMessageArrowUp = {
  prefix: 'fas',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM280 296V177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V296c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCommentAltArrowUp = faMessageArrowUp;
var faLightbulbExclamation = {
  prefix: 'fas',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zm0-448c13.3 0 24 10.7 24 24V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM160 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faLayerMinus = {
  prefix: 'fas',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M408 56c-13.3 0-24 10.7-24 24s10.7 24 24 24H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H408zm-96.5 77.2c-14.9-6.9-32.1-6.9-47 0L45.9 234.2C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z"]
};
var faLayerGroupMinus = faLayerMinus;
var faChartPieSimpleCircleCurrency = {
  prefix: 'fas',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240H375.2c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z"]
};
var faCircleE = {
  prefix: 'fas',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v56H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z"]
};
var faBuildingWheat = {
  prefix: 'fas',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"]
};
var faGaugeMax = {
  prefix: 'fas',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltFastest = faGaugeMax;
var faPersonBreastfeeding = {
  prefix: 'fas',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"]
};
var faApostrophe = {
  prefix: 'fas',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M72 352c66.3 0 120-53.7 120-120V160 128 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64v8c0 30.9-25.1 56-56 56H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z"]
};
var faFireHydrant = {
  prefix: 'fas',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M224 32v4c45 11.6 80.4 47 92 92h12c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H68c11.6-45 47-80.4 92-92V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM32 488c0-13.3 10.7-24 24-24h8V400H48c-17.7 0-32-14.3-32-32V304c0-17.7 14.3-32 32-32H64V208H320v64h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320v64h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H64 56c-13.3 0-24-10.7-24-24zm160-88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faRightToBracket = {
  prefix: 'fas',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faSignInAlt = faRightToBracket;
var faVideoPlus = {
  prefix: 'fas',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9V192 320v17.1l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128zM216 184v48h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSquareRight = {
  prefix: 'fas',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM262.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L262.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C234 384 224 374 224 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"]
};
var faArrowAltSquareRight = faSquareRight;
var faCommentSmile = {
  prefix: 'fas',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM192 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.5 270.1c9.9-8.8 25-8 33.9 1.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9C337 333.4 298.6 352 256 352s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z"]
};
var faVenus = {
  prefix: 'fas',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"]
};
var faPassport = {
  prefix: 'fas',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faInboxIn = {
  prefix: 'fas',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M288 32V210.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]
};
var faInboxArrowDown = faInboxIn;
var faHeartPulse = {
  prefix: 'fas',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"]
};
var faHeartbeat = faHeartPulse;
var faCircle8 = {
  prefix: 'fas',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128H248c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H248s0 0 0 0zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h8 16z"]
};
var faCloudsMoon = {
  prefix: 'fas',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", "M352 160c0 11.5 1.2 22.7 3.5 33.4c53.7 8.2 96.5 49.8 106.4 103c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zM114.8 273.9c20.1-30.1 54.3-49.9 93.2-49.9c12.9 0 25.3 2.2 36.8 6.2c19.6-19.9 45.8-33.5 75-37.2l0-.9c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c16.1 0 30.9-5.3 42.9-14.1zM64 431.9c0 44.2 35.8 80 80 80H415.9c53 0 96-43 96-96c0-47.6-34.6-87-80-94.6l0-1.3c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 431.9z"]
};
var faClockTenThirty = {
  prefix: 'fas',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faPeopleCarryBox = {
  prefix: 'fas',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"]
};
var faPeopleCarry = faPeopleCarryBox;
var faFolderUser = {
  prefix: 'fas',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM144 405.3c0 5.9 4.8 10.7 10.7 10.7H357.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H197.3c-29.5 0-53.3 23.9-53.3 53.3z"]
};
var faTrashCanXmark = {
  prefix: 'fas',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM143 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faTemperatureHigh = {
  prefix: 'fas',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faMicrochip = {
  prefix: 'fas',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"]
};
var faLeftLongToLine = {
  prefix: 'fas',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96zM279.5 409.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22V320l288 0c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32l-288 0V120c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136c-4.8 4.5-7.5 10.8-7.5 17.4s2.7 12.9 7.5 17.4l144 136z"]
};
var faCrown = {
  prefix: 'fas',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"]
};
var faWeightHanging = {
  prefix: 'fas',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"]
};
var faXmarksLines = {
  prefix: 'fas',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faFilePrescription = {
  prefix: 'fas',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"]
};
var faCalendarRange = {
  prefix: 'fas',
  iconName: 'calendar-range',
  icon: [512, 512, [], "e0d6", "M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM160 288a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM384 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 288c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm40 104c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H264z"]
};
var faFlowerDaffodil = {
  prefix: 'fas',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", "M288 281.3c9.8 4.3 20.6 6.7 32 6.7c44.2 0 80-35.8 80-80c0-26.2-12.6-49.4-32-64c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0c-44.2 0-80 35.8-80 80c0 26.2 12.6 49.4 32 64c-19.4 14.6-32 37.8-32 64c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7V394.8C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512H224h32 32 61.5C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V281.3zM208 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faHandBackPointUp = {
  prefix: 'fas',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M136 0C113.9 0 96 17.9 96 40V240v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L39 284.8C24.4 297 16 315 16 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H288c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C334 227.5 313.3 208 288 208c-12.4 0-23.6 4.7-32.1 12.3C254 195.5 233.3 176 208 176c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"]
};
var faWeightScale = {
  prefix: 'fas',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
};
var faWeight = faWeightScale;
var faArrowUpToArc = {
  prefix: 'fas',
  iconName: 'arrow-up-to-arc',
  icon: [512, 512, [], "e617", "M256 64c106 0 192 86 192 192c0 17.7 14.3 32 32 32s32-14.3 32-32C512 114.6 397.4 0 256 0S0 114.6 0 256c0 17.7 14.3 32 32 32s32-14.3 32-32C64 150 150 64 256 64zM390.6 281.4l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 269.3 224 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faStarExclamation = {
  prefix: 'fas',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M288.1 0c12.2 0 23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18zM288 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBooks = {
  prefix: 'fas',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", "M0 32C0 14.3 14.3 0 32 0H96c17.7 0 32 14.3 32 32V96H0V32zm0 96H128V384H0V128zM0 416H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H160V32zm0 96H288V384H160V128zm0 288H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416zm203.6-19.9L320 232.6V142.8l100.4-26.9 66 247.4L363.6 396.1zM412.2 85L320 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zM371.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z"]
};
var faUserGroup = {
  prefix: 'fas',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"]
};
var faUserFriends = faUserGroup;
var faArrowUpAZ = {
  prefix: 'fas',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"]
};
var faSortAlphaUp = faArrowUpAZ;
var faLayerPlus = {
  prefix: 'fas',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M464 0c-13.3 0-24 10.7-24 24V56H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v32c0 13.3 10.7 24 24 24s24-10.7 24-24V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H488V24c0-13.3-10.7-24-24-24zM311.5 133.2c-14.9-6.9-32.1-6.9-47 0L45.9 234.2C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z"]
};
var faLayerGroupPlus = faLayerPlus;
var faPlayPause = {
  prefix: 'fas',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", "M116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160zM448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"]
};
var faBlockQuestion = {
  prefix: 'fas',
  iconName: 'block-question',
  icon: [640, 512, [], "e3dd", "M160 32c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm73.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L344 280.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V266.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H286.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM472 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM144 408a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSnooze = {
  prefix: 'fas',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5s16.5 17.7 28.6 17.7h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S300.1 0 288 0H192zM320 224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32l-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5s16.5 17.7 28.6 17.7h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H384l57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S428.1 224 416 224H320zM32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32h91.7L7.4 459.5c-7.9 9.5-9.7 22.8-4.4 34.1S19.6 512 32 512H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H100.3L216.6 308.5c7.9-9.5 9.7-22.8 4.4-34.1s-16.6-18.4-29-18.4H32z"]
};
var faZzz = faSnooze;
var faScannerImage = {
  prefix: 'fas',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M79.1 35.8c-15.6-8.3-35-2.4-43.3 13.2s-2.4 35 13.2 43.3L416 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V339.2c0-23.6-13-45.3-33.9-56.5L79.1 35.8zM64 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faTvRetro = {
  prefix: 'fas',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M169 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55H80C35.8 96 0 131.8 0 176V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H321.9l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87L169 7zM424 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 224c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V224z"]
};
var faSquareT = {
  prefix: 'fas',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 112H224 328c13.3 0 24 10.7 24 24s-10.7 24-24 24H248V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFarm = {
  prefix: 'fas',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M0 96C0 43 43 0 96 0s96 43 96 96H0zm181.4 32L132.8 246c-3.2 7.7-4.8 16-4.8 24.4V480c0 11.7 3.1 22.6 8.6 32H48c-26.5 0-48-21.5-48-48V128H181.4zM160 480V270.3c0-4.2 .8-8.3 2.4-12.2l48.9-118.7c3-7.4 8.7-13.3 15.9-16.7L354.3 62.5c8.7-4.1 18.7-4.1 27.4 0l127.1 60.2c7.2 3.4 12.9 9.4 15.9 16.7l48.9 118.7c1.6 3.9 2.4 8 2.4 12.2V480c0 17.7-14.3 32-32 32H432V448c0-26.5-21.5-48-48-48H352c-26.5 0-48 21.5-48 48v64H192c-17.7 0-32-14.3-32-32zM320 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V248c0-13.3-10.7-24-24-24H344c-13.3 0-24 10.7-24 24z"]
};
var faBarnSilo = faFarm;
var faChessKnight = {
  prefix: 'fas',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"]
};
var faBarsSort = {
  prefix: 'fas',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM192 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H160c17.7 0 32 14.3 32 32z"]
};
var faPalletBoxes = {
  prefix: 'fas',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M64 32C64 14.3 78.3 0 96 0H288c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V32zM384 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V96zM0 352c0-17.7 14.3-32 32-32H96 320 544h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H544 320 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V384H32c-17.7 0-32-14.3-32-32zm128 96H288V384H128v64zm224 0H512V384H352v64z"]
};
var faPaletteBoxes = faPalletBoxes;
var faPalletAlt = faPalletBoxes;
var faFaceLaughSquint = {
  prefix: 'fas',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faLaughSquint = faFaceLaughSquint;
var faCodeSimple = {
  prefix: 'fas',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", "M214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6zm146.7 0L498.7 256 361.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3z"]
};
var faBoltSlash = {
  prefix: 'fas',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-182.4-143 52.7-46.1c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H368.5L445.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8L228.4 153.7 38.8 5.1zM138.9 231.9c-10 8.8-13.6 22.9-8.9 35.3s16.6 20.7 30 20.7h83.7l-88.9-70-15.9 13.9zm55.7 235.5c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8L374.4 391 264.5 304.4l-69.9 163z"]
};
var faPanelFire = {
  prefix: 'fas',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-9.9 8.9-19.4 18.1-28.5 27.5V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H337.5c-4.4 6.2-8.5 12.5-12.3 18.7c-10.9 17.6-20.5 36.4-27.2 55.4c-3-1.4-6.4-2.1-9.9-2.1c-13.3 0-24 10.7-24 24s10.7 24 24 24l.2 0c-.1 2-.2 4.1-.2 6.1c0 49.3 18.6 95.2 49.6 129.9H64c-35.3 0-64-28.7-64-64V96zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM453.5 163.6c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79c0 87.8-71.3 159.8-160 159.8c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 432.9c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
var faBinaryCircleCheck = {
  prefix: 'fas',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", "M322.7 6c8.3 6 13.3 15.7 13.3 26V160h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H304 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C303.6-1.6 314.4 0 322.7 6zM98.7 294c8.3 6 13.3 15.7 13.3 26V448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm0 64v96h64V64H64zM192 352c0-35.3 28.7-64 64-64h64c6.2 0 12.2 .9 17.9 2.5c-11.2 22.9-17.6 48.6-17.9 75.7V352H256v96h64v0h19.2c7.8 15.3 17.8 29.3 29.5 41.5C357 503.3 339.5 512 320 512H256c-35.3 0-64-28.7-64-64V352zm128.7 32H320V369.8c0 4.8 .3 9.5 .7 14.2zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faCommentMinus = {
  prefix: 'fas',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 216H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBurrito = {
  prefix: 'fas',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M251.4 52.6L33.9 270.1c-9.9 9.9-17.8 21.3-23.4 33.7C39.2 324.1 74.2 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-40.4-13.6-77.7-36.6-107.4zm15-32C299.7 57.5 320 106.4 320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c53.6 0 102.5 20.3 139.4 53.6c12.8-14.2 20.6-33 20.6-53.6c0-11.4-2.4-22.2-6.7-32c4.3-9.8 6.7-20.6 6.7-32c0-34.6-22-64.1-52.8-75.2C448.1 22 418.6 0 384 0c-11.4 0-22.2 2.4-32 6.7C342.2 2.4 331.4 0 320 0c-20.6 0-39.4 7.8-53.6 20.6zm193 240C429.7 237.6 392.4 224 352 224c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-40.8 0-78.8-11.7-110.9-32C.4 341.3 0 346.6 0 352c0 30.7 12.2 60.2 33.9 81.9l44.1 44.1C99.8 499.8 129.3 512 160 512s60.2-12.2 81.9-33.9L459.4 260.6z"]
};
var faViolin = {
  prefix: 'fas',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M630.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L417 177.7C398 166.5 375.7 160 352 160c-20.8 0-40.4 5-57.8 13.8c-6.7 3.4-9.1 11.4-7.7 18.8c1 5 1.5 10.2 1.5 15.4c0 44.2-35.8 80-80 80c-11.6 0-22.7-2.5-32.7-7c-7.4-3.3-16.6-2.4-21.3 4.3C137.6 308.7 128 337.2 128 368c0 15 2.3 29.5 6.6 43.1l44.6-33.5c19.1-14.3 45.9-12.4 62.7 4.5l16 16c16.9 16.9 18.8 43.6 4.5 62.7l-33.5 44.6c13.6 4.3 28.1 6.6 43.1 6.6c30.8 0 59.3-9.6 82.6-26.1c6.7-4.7 7.6-13.8 4.3-21.3c-4.5-10-7-21-7-32.7c0-44.2 35.8-80 80-80c5.3 0 10.5 .5 15.4 1.5c7.4 1.4 15.4-1 18.8-7.7c8.8-17.4 13.8-37 13.8-57.8c0-23.7-6.5-46-17.7-65L630.6 54.6zM520 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM345 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 41zM472 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm48-48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM198.4 403.2l-64 48c-3.7 2.8-6 7-6.4 11.7s1.4 9.2 4.6 12.4l32 32c3.3 3.3 7.8 5 12.4 4.6s8.9-2.6 11.7-6.4l48-64c4.8-6.4 4.1-15.3-1.5-20.9l-16-16c-5.6-5.6-14.5-6.3-20.9-1.5z"]
};
var faObjectsColumn = {
  prefix: 'fas',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M48 32C21.5 32 0 53.5 0 80V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zM304 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H304zM0 400v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48zM304 32c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304z"]
};
var faSquareChevronDown = {
  prefix: 'fas',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM207 345L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z"]
};
var faChevronSquareDown = faSquareChevronDown;
var faCommentPlus = {
  prefix: 'fas',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM232 328V264H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V152c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faTriangleInstrument = {
  prefix: 'fas',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V69.9c-18 6.8-33.6 19.4-44.1 36.1L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94H450c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L448.2 239l-46.4 46.4 73.6 116.5c3 4.8 4.6 10.4 4.6 16c0 16.6-13.5 30-30 30H126c-16.6 0-30-13.5-30-30c0-5.7 1.6-11.2 4.6-16L266 140.1c4.8-7.6 13.1-12.1 22-12.1s17.3 4.6 22 12.1l48 75.9-51.2 51.2c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l43.5-43.5 46.4-46.4L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6L364.1 106C353.6 89.2 338 76.7 320 69.9V32z"]
};
var faTriangleMusic = faTriangleInstrument;
var faWheelchair = {
  prefix: 'fas',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"]
};
var faUserPilotTie = {
  prefix: 'fas',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM161.7 72.8c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512H192v0h64v0H422.4c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.2 464.9 240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2H201.9c-11.9 0-19.6 12.5-14.3 23.2zM320 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16z"]
};
var faPianoKeyboard = {
  prefix: 'fas',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM512 224V384H432V315.7c9.6-5.5 16-15.9 16-27.7V224h64zM400 384H304V315.7c9.6-5.5 16-15.9 16-27.7V224h64v64c0 11.8 6.4 22.2 16 27.7V384zm-128 0H176V315.7c9.6-5.5 16-15.9 16-27.7V224h64v64c0 11.8 6.4 22.2 16 27.7V384zm-128 0H64V224h64v64c0 11.8 6.4 22.2 16 27.7V384z"]
};
var faBedEmpty = {
  prefix: 'fas',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V256v96 96c0 17.7 14.3 32 32 32s32-14.3 32-32V416H352 576v32c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-53-43-96-96-96H64V64z"]
};
var faCircleArrowUp = {
  prefix: 'fas',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"]
};
var faArrowCircleUp = faCircleArrowUp;
var faToggleOn = {
  prefix: 'fas',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faRectangleVertical = {
  prefix: 'fas',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0z"]
};
var faRectanglePortrait = faRectangleVertical;
var faPersonWalking = {
  prefix: 'fas',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"]
};
var faWalking = faPersonWalking;
var faL = {
  prefix: 'fas',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"]
};
var faSignalStream = {
  prefix: 'fas',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M108.2 71c13.8 11.1 16 31.2 5 45C82.4 154.4 64 203 64 256s18.4 101.6 49.1 140c11.1 13.8 8.8 33.9-5 45s-33.9 8.8-45-5C23.7 386.7 0 324.1 0 256S23.7 125.3 63.2 76c11.1-13.8 31.2-16 45-5zm359.7 0c13.8-11.1 33.9-8.8 45 5C552.3 125.3 576 187.9 576 256s-23.7 130.7-63.2 180c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45c30.7-38.4 49.1-87 49.1-140s-18.4-101.6-49.1-140c-11.1-13.8-8.8-33.9 5-45zM232 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-27.5-74.7c-17.8 19.8-28.5 46-28.5 74.7s10.8 54.8 28.5 74.7c11.8 13.2 10.7 33.4-2.5 45.2s-33.4 10.7-45.2-2.5C129 342.2 112 301.1 112 256s17-86.2 44.8-117.3c11.8-13.2 32-14.3 45.2-2.5s14.3 32 2.5 45.2zm214.7-42.7C447 169.8 464 210.9 464 256s-17 86.2-44.8 117.3c-11.8 13.2-32 14.3-45.2 2.5s-14.3-32-2.5-45.2c17.8-19.8 28.5-46 28.5-74.7s-10.8-54.8-28.5-74.7c-11.8-13.2-10.7-33.4 2.5-45.2s33.4-10.7 45.2 2.5z"]
};
var faDownToBracket = {
  prefix: 'fas',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M374.1 217.9L251.3 340.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L73.9 217.9c-6.4-6.4-9.9-15-9.9-24C64 175.2 79.2 160 97.9 160l62.1 0 0-128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l0 128 62.1 0c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24zM64 352v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faCircleZ = {
  prefix: 'fas',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8L282.2 176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faStars = {
  prefix: 'fas',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94zm215.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
};
var faFire = {
  prefix: 'fas',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"]
};
var faBedPulse = {
  prefix: 'fas',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faProcedures = faBedPulse;
var faHouseDay = {
  prefix: 'fas',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M174.2 8.3C171.4 3.2 166-.1 160.1-.1s-11.3 3.2-14.1 8.4L118.4 59.5 62.8 42.9c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146.1c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6L42.8 257.6c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7L133.1 288l57.4-53c-9.4 3.9-19.7 6-30.5 6c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 13.1-3.1 25.4-8.7 36.3L296 137.5l-35.3-19 16.7-55.7c1.7-5.6 .1-11.7-4-15.9s-10.3-5.7-15.9-4L201.8 59.5 174.2 8.3zM112 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm309.7-55.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352h32V464c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48V352h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V304z"]
};
var faShuttleSpace = {
  prefix: 'fas',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"]
};
var faSpaceShuttle = faShuttleSpace;
var faShirtLongSleeve = {
  prefix: 'fas',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", "M157 .3c-32.1 2.5-61 20.9-76.7 49.5L13.9 170.5C4.8 187 0 205.6 0 224.4V384c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V224.4c0-2.7 .7-5.3 2-7.7l46-83.7V448c0 35.3 28.7 64 64 64H432c35.3 0 64-28.7 64-64V133.1l46 83.7c1.3 2.4 2 5 2 7.7V384c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224.4c0-18.9-4.8-37.4-13.9-54L559.7 49.7C544.1 21.2 515.1 2.8 483 .3c-1-.2-2-.3-3-.3h-4.4H460 432c-8.8 0-15.9 7.2-17.3 15.9C407.1 61.4 367.6 96 320 96s-87.1-34.6-94.7-80.1C223.9 7.2 216.8 0 208 0H180 164.4 160c-1 0-2 .1-3 .3z"]
};
var faChartPieSimple = {
  prefix: 'fas',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M495.4 240H272V16.6c0-9 7-16.6 16-16.6C411.7 0 512 100.3 512 224c0 9-7.6 16-16.6 16zM190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288H445.3c18.5 0 33.3 15.7 29.5 33.8C451.9 430.5 355.5 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2z"]
};
var faChartPieAlt = faChartPieSimple;
var faFaceLaugh = {
  prefix: 'fas',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
  prefix: 'fas',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"]
};
var faAlbumCollectionCircleUser = {
  prefix: 'fas',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", "M32 24c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42H394.8c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2H48zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H472c13.3 0 24-10.7 24-24s-10.7-24-24-24H40zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C553.5 468.1 526.2 480 496 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7h65.2c21 0 38.9 13.7 45.1 32.7zM448 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCandy = {
  prefix: 'fas',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", "M318.1 64c-24.5 .2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.2-28.5 52.6-47.3L318.1 64zM492.3 340.8c4.7-9.6 8.7-19.6 11.8-30l93.2 46.6c10.5 5.3 23.3 2.1 30.2-7.4s5.8-22.7-2.5-31l-29.6-29.6 29.1-10.9C633.8 275 640 266 640 256s-6.2-19-15.6-22.5l-29.1-10.9L625 193c8.3-8.3 9.4-21.5 2.5-31s-19.7-12.7-30.2-7.4L504 201.1C483.7 132.9 426.5 80.6 355.5 67.3L492.3 340.8zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zM284.5 444.7L147.7 171.2c-4.7 9.6-8.7 19.6-11.8 30L42.7 154.5c-10.5-5.3-23.3-2.1-30.2 7.4s-5.8 22.7 2.5 31l29.6 29.6L15.6 233.5C6.2 237 0 246 0 256s6.2 19 15.6 22.5l29.1 10.9L15 319c-8.3 8.3-9.4 21.5-2.5 31s19.7 12.7 30.2 7.4L136 310.9c20.3 68.2 77.5 120.6 148.5 133.9z"]
};
var faBowlHot = {
  prefix: 'fas',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M152 0c-13.3 0-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2C183.7 125.8 192 142.4 192 160v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C184.3 66.2 176 49.6 176 32V24c0-13.3-10.7-24-24-24zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H33.6zM304 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 32.7 15.4 63.6 41.6 83.2C311.7 125.8 320 142.4 320 160v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-32.7-15.4-63.6-41.6-83.2C312.3 66.2 304 49.6 304 32V24z"]
};
var faSoup = faBowlHot;
var faFlatbread = {
  prefix: 'fas',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 171.3l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faHeartCirclePlus = {
  prefix: 'fas',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCodeFork = {
  prefix: 'fas',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCity = {
  prefix: 'fas',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"]
};
var faSignalBarsWeak = {
  prefix: 'fas',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", "M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z"]
};
var faSignalAlt1 = faSignalBarsWeak;
var faMicrophoneLines = {
  prefix: 'fas',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"]
};
var faMicrophoneAlt = faMicrophoneLines;
var faClockTwelve = {
  prefix: 'fas',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faPepperHot = {
  prefix: 'fas',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"]
};
var faCitrusSlice = {
  prefix: 'fas',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zm116.3 32.9c9.6 2.7 18.8-4.9 18.8-14.9V264.5c0-6.2-4.3-11.5-10-14c-5.9-2.6-13-2.1-17.6 2.5L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c27.1 27.1 59.6 45.5 94 55.2zM250.5 166c2.5 5.7 7.8 10 14 10H409c10 0 17.6-9.1 14.9-18.8C414.2 123 396 90.6 369.1 63.6l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L253 148.4c-4.6 4.6-5.2 11.7-2.5 17.6zm.6 50.5c-2 4.9-1.4 10.6 2.4 14.3l114 114c6.6 6.6 17.4 6.2 22.9-1.3c26.2-35.8 40.1-77.8 41.5-120.1c.3-8.6-6.8-15.4-15.4-15.4H263c-5.3 0-9.8 3.7-11.8 8.5zm-34.6 34.6c-4.9 2-8.5 6.5-8.5 11.8V416.4c0 8.6 6.8 15.7 15.4 15.4c42.4-1.4 84.4-15.3 120.1-41.5c7.5-5.5 7.9-16.3 1.3-22.9l-114-114c-3.7-3.7-9.4-4.4-14.3-2.4z"]
};
var faSheep = {
  prefix: 'fas',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M384 135.8V208c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V135.8l14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5L561.6 77.4C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4L350.5 97.9c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 175.4c-18.7-2.7-35.5-14.8-43.5-33.4c-6.9-16.1-5.7-33.5 1.8-47.9C299 76 278.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1H176c17.7 0 32-14.3 32-32V426.3c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7V480c0 17.7 14.3 32 32 32h29.4c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8H464c-61.9 0-112-50.1-112-112V175.4z"]
};
var faUnlock = {
  prefix: 'fas',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"]
};
var faColonSign = {
  prefix: 'fas',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"]
};
var faHeadset = {
  prefix: 'fas',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"]
};
var faBadgerHoney = {
  prefix: 'fas',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M164.6 389.3l16-37.3H298.7l16.9 101.3c2.6 15.4 15.9 26.7 31.6 26.7h31.1c19.8 0 34.8-17.8 31.6-37.3L393 342.1c27.9-29 80.6-70.8 144.1-90.8l16.1 25.8c3.1 5 10.4 5 13.6 0l22.8-36.5c12.9-2.1 25.2-7.4 34.4-16.6c10.2-10.2 16-24.1 16-38.6v-3.8c0-23.2-12.6-44.5-32.8-55.8L525.3 80.3C506.1 69.6 484.5 64 462.5 64c-20.1 0-39.9 4.7-57.8 13.6L400 80c-21 10.5-44.2 16-67.8 16H160 128C57.3 96 0 153.3 0 224v32c0 17.7 14.3 32 32 32c5.4 0 10.6-1.4 15-3.7c9.1 17.1 22.1 31.9 37.7 43.3l-16.8 59c-2.5 8.8-2.5 18.2 .2 27l13.1 43.7c4.1 13.5 16.5 22.8 30.7 22.8H141c21.4 0 36.8-20.7 30.7-41.2l-8.3-27.7c-2.2-7.2-1.7-14.9 1.2-21.8zM570 160H518.6c.9 2.5 1.4 5.2 1.4 8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-2.8 .5-5.5 1.4-8h-5.9c-23.2 0-46 6.3-65.9 18.2L294.8 242.3c-14.9 9-32 13.7-49.4 13.7H192c-46.4 0-86.2-28.2-103.2-68.5C102 161.7 129 144 160 144H332.2c31 0 61.5-7.2 89.2-21.1l4.7-2.4c11.3-5.6 23.7-8.6 36.3-8.6c13.8 0 27.4 3.5 39.5 10.2L570 160z"]
};
var faH4 = {
  prefix: 'fas',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", "M479 103.8L441 256H576V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320H400c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
};
var faStoreSlash = {
  prefix: 'fas',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"]
};
var faRoadCircleXmark = {
  prefix: 'fas',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
var faSignalSlash = {
  prefix: 'fas',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V401.1l-64-50.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V300.8l-64-50.2V224c0-17.7-14.3-32-32-32c-10.7 0-20.1 5.2-25.9 13.2L38.8 5.1zM576 512l-.3 0h.6l-.3 0zm-96-32v-5.8l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM352 373.3l-64-50.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V373.3zM192 288c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]
};
var faUserMinus = {
  prefix: 'fas',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMarsStrokeUp = {
  prefix: 'fas',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"]
};
var faMarsStrokeV = faMarsStrokeUp;
var faChampagneGlasses = {
  prefix: 'fas',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"]
};
var faGlassCheers = faChampagneGlasses;
var faTaco = {
  prefix: 'fas',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M274.8 38.4l44.1 34.2c5.6 4.4 12.6 6.6 19.7 6.4l55.8-1.7c14-.4 26.5 8.6 30.4 22.1l15.6 53.6c2 6.8 6.3 12.8 12.2 16.8L498.6 201c11.6 7.9 16.3 22.5 11.6 35.7l-17.1 47.7C441.1 209.2 354.3 160 256 160s-185.1 49.2-237.1 124.4L1.8 236.7c-4.7-13.1 0-27.8 11.6-35.7l46.1-31.4c5.9-4 10.2-9.9 12.2-16.8L87.3 99.3c3.9-13.4 16.4-22.5 30.4-22.1L173.4 79c7.1 .2 14.1-2 19.7-6.4l44.1-34.2c11-8.6 26.5-8.6 37.5 0zM512 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32C0 306.6 114.6 192 256 192s256 114.6 256 256zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHexagonPlus = {
  prefix: 'fas',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faPlusHexagon = faHexagonPlus;
var faClipboard = {
  prefix: 'fas',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHouseCircleExclamation = {
  prefix: 'fas',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faFileArrowUp = {
  prefix: 'fas',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"]
};
var faFileUpload = faFileArrowUp;
var faWifi = {
  prefix: 'fas',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faMessages = {
  prefix: 'fas',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", "M64 0C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM352 352H256v32c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448V256c0 53-43 96-96 96z"]
};
var faCommentsAlt = faMessages;
var faBath = {
  prefix: 'fas',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"]
};
var faBathtub = faBath;
var faUmbrellaSimple = {
  prefix: 'fas',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M256 0c17.7 0 32 14.3 32 32v2C403.8 48.4 495.6 140.2 510 256.1c2.2 17.5-12.4 31.9-30 31.9H32C14.3 288-.2 273.6 2 256.1C16.4 140.2 108.2 48.4 224 34V32c0-17.7 14.3-32 32-32zm32 430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V320h64V430.6z"]
};
var faUmbrellaAlt = faUmbrellaSimple;
var faRectangleHistoryCirclePlus = {
  prefix: 'fas',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", "M320 368c0 59.5 29.5 112.1 74.8 144L64 512c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24H392zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304z"]
};
var faUnderline = {
  prefix: 'fas',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faPrescriptionBottlePill = {
  prefix: 'fas',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352v83.2c-57 29.1-96 88.4-96 156.8c0 54.5 24.8 103.3 63.8 135.6c-9.4 5.4-20.2 8.4-31.8 8.4H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128zM304.8 300.5c6.7-12.6 23.6-13.5 33.7-3.4L502.9 461.5c10.1 10.1 9.2 27-3.4 33.7C479.4 505.9 456.4 512 432 512c-79.5 0-144-64.5-144-144c0-24.4 6.1-47.4 16.8-67.5zm254.5 135c-6.7 12.6-23.6 13.5-33.7 3.4L361.1 274.5c-10.1-10.1-9.2-27 3.4-33.7C384.6 230.1 407.6 224 432 224c79.5 0 144 64.5 144 144c0 24.4-6.1 47.4-16.8 67.5z"]
};
var faUserPen = {
  prefix: 'fas',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
};
var faUserEdit = faUserPen;
var faBinarySlash = {
  prefix: 'fas',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V352c0-35.3-28.7-64-64-64H399.7L298 208.3c13.5-11.7 22-29 22-48.3V64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zM192 125.2V64h64v96H236.4L192 125.2zM464 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V32zM240 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H240V320zm80 32v96c0 35.3 28.7 64 64 64h64c20.1 0 38.1-9.3 49.8-23.8l-51-40.2H384V398.5l-63.9-50.3c-.1 1.3-.1 2.5-.1 3.8z"]
};
var faSquareO = {
  prefix: 'fas',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faSignature = {
  prefix: 'fas',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"]
};
var faStroopwafel = {
  prefix: 'fas',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"]
};
var faBold = {
  prefix: 'fas',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"]
};
var faAnchorLock = {
  prefix: 'fas',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faBuildingNgo = {
  prefix: 'fas',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"]
};
var faTransporter3 = {
  prefix: 'fas',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512h88 80 88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32zM56.7 102.6C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128l-7.3-25.4zM480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faEngineWarning = {
  prefix: 'fas',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0v32H208 160 128c-17.7 0-32 14.3-32 32v56H48V160c0-13.3-10.7-24-24-24s-24 10.7-24 24V352c0 13.3 10.7 24 24 24s24-10.7 24-24V280H96v72c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H328V112l72 0zM544 224V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H576c-17.7 0-32 14.3-32 32zM304 188c11 0 20 9 20 20v88c0 11-9 20-20 20s-20-9-20-20V208c0-11 9-20 20-20zM280 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faEngineExclamation = faEngineWarning;
var faCircleDownRight = {
  prefix: 'fas',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 198.6V336c0 8.8-7.2 16-16 16H198.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L216 280l-66.3-66.3C146 210 144 205.1 144 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L280 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z"]
};
var faSquareK = {
  prefix: 'fas',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM313.1 168.8l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z"]
};
var faManatSign = {
  prefix: 'fas',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"]
};
var faMoneyCheckPen = {
  prefix: 'fas',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.5l6-23.9c2.8-11.3 8.6-21.5 16.8-29.7L534.6 213.1c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64H64zm48 224H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm517.8 27.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
};
var faMoneyCheckEdit = faMoneyCheckPen;
var faNotEqual = {
  prefix: 'fas',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"]
};
var faBorderTopLeft = {
  prefix: 'fas',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBorderStyle = faBorderTopLeft;
var faMapLocationDot = {
  prefix: 'fas',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faMapMarkedAlt = faMapLocationDot;
var faTilde = {
  prefix: 'fas',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", "M99.9 192C80.1 192 64 208.1 64 227.9V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V227.9C0 172.7 44.7 128 99.9 128c26.5 0 51.9 10.5 70.6 29.3L322.7 309.5c6.7 6.7 15.9 10.5 25.4 10.5c19.8 0 35.9-16.1 35.9-35.9V192c0-17.7 14.3-32 32-32s32 14.3 32 32v92.1c0 55.2-44.7 99.9-99.9 99.9c-26.5 0-51.9-10.5-70.6-29.3L125.3 202.5c-6.7-6.7-15.9-10.5-25.4-10.5z"]
};
var faJedi = {
  prefix: 'fas',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"]
};
var faSquarePollVertical = {
  prefix: 'fas',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"]
};
var faPoll = faSquarePollVertical;
var faArrowDownSquareTriangle = {
  prefix: 'fas',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 72c0-22.1 17.9-40 40-40H472c22.1 0 40 17.9 40 40V184c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72zM443.1 303l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15z"]
};
var faSortShapesDownAlt = faArrowDownSquareTriangle;
var faMugHot = {
  prefix: 'fas',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"]
};
var faDogLeashed = {
  prefix: 'fas',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M122.7 4.1l160 144c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-160-144c-6.6-5.9-7.1-16-1.2-22.6s16-7.1 22.6-1.2zM144 192H256V383.3c-5.3 .5-10.6 .7-16 .7c-28.8 0-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16zM320 364.8c-10.1 5.2-20.8 9.4-32 12.6V208.1L416 262l0 218c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8zM426.7 192l-6.2 37.2L305.9 180.9l26.8-161C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7zM448 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCarBattery = {
  prefix: 'fas',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"]
};
var faBatteryCar = faCarBattery;
var faFaceDowncastSweat = {
  prefix: 'fas',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M35.2 126.3c4.1 1.1 8.4 1.7 12.8 1.7c26.5 0 48-21 48-47c0-5-1.8-11.3-4.6-18.1c-.3-.7-.6-1.4-.9-2.1c-8.9-20.2-26.5-44.9-36-57.5c-3.2-4.4-9.6-4.4-12.8 0C28.6 20.6 0 61 0 81c0 21.7 14.9 39.8 35.2 45.3zM256 0c-51.4 0-99.3 15.2-139.4 41.2c1.5 3.1 3 6.2 4.3 9.3c3.4 8 7.1 19 7.1 30.5c0 44.3-36.6 79-80 79c-9.6 0-18.8-1.7-27.4-4.8C7.3 186.2 0 220.2 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM195.9 410.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7zM96 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm208-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMailboxFlagUp = {
  prefix: 'fas',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M400 16c-29.8 0-54.9 20.4-62 48H245.2C290.4 95.9 320 148.5 320 208V384c0 24.6-9.2 47-24.4 64H512c35.3 0 64-28.7 64-64V208c0-42.6-18.5-81-48-107.3V80c0-35.3-28.7-64-64-64H400zm0 208c-8.8 0-16-7.2-16-16V112 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416v80c0 8.8-7.2 16-16 16zM0 208V384c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V208c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z"]
};
var faMemoCircleInfo = {
  prefix: 'fas',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm352-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16h0v48h0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z"]
};
var faGift = {
  prefix: 'fas',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"]
};
var faDiceTwo = {
  prefix: 'fas',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faVolume = {
  prefix: 'fas',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M333.1 34.8C344.6 40 352 51.4 352 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
};
var faVolumeMedium = faVolume;
var faTransporter5 = {
  prefix: 'fas',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", "M480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6L480 32zM56.7 134.6L64 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 192 6.6 184.7C2.7 183.6 0 180.1 0 176s2.7-7.6 6.6-8.7L32 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM384 512H296 216 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zM176 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faGaugeCircleBolt = {
  prefix: 'fas',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24V292.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356H552c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380H440c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faCoinFront = {
  prefix: 'fas',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-264c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faFileSlash = {
  prefix: 'fas',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V160H384c-17.7 0-32-14.3-32-32V0H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zM128 196.9V448c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.8L128 196.9zM512 128L384 0V128H512z"]
};
var faMessageArrowUpRight = {
  prefix: 'fas',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm200 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h54.1l-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24H200z"]
};
var faTreasureChest = {
  prefix: 'fas',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", "M0 160v96H128V32C57.3 32 0 89.3 0 160zM0 432c0 26.5 21.5 48 48 48h80V288H0V432zM416 288H352v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V288H160V480H416V288zM528 480c26.5 0 48-21.5 48-48V288H448V480h80zm48-320c0-70.7-57.3-128-128-128V256H576V160zM416 256V32H160V256h64V224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64zM304 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faChessQueen = {
  prefix: 'fas',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"]
};
var faPaintbrushFine = {
  prefix: 'fas',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M559.6 16.4c21.9 21.9 21.9 57.3 0 79.2L306.9 348.3l-79.2-79.2L480.4 16.4c21.9-21.9 57.3-21.9 79.2 0zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z"]
};
var faPaintBrushAlt = faPaintbrushFine;
var faPaintBrushFine = faPaintbrushFine;
var faPaintbrushAlt = faPaintbrushFine;
var faGlasses = {
  prefix: 'fas',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"]
};
var faHoodCloak = {
  prefix: 'fas',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", "M432 0H288h0c-9.8 0-66 0-120.2 37.7C111.4 76.9 64 151.8 64 288c0 58.5-14.6 101.6-28.6 129.7c-7 14.1-14 24.5-19 31.1c-2.5 3.3-4.5 5.7-5.7 7.1c-.6 .7-1.1 1.2-1.3 1.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8h96V320c0-88.4 71.6-160 160-160s160 71.6 160 160V512h96c12.9 0 24.6-7.8 29.6-19.8c4.9-11.9 2.2-25.6-6.8-34.7l0 0 0 0 0 0-.1-.1c-.2-.2-.7-.7-1.3-1.4c-1.3-1.4-3.2-3.8-5.7-7.1c-5-6.6-11.9-17-19-31.1C526.6 389.6 512 346.5 512 288c0-103.1-46.5-172.8-95.8-217.2l32-29c7.3-6.7 9.8-17.2 6.2-26.4S441.9 0 432 0zM416 512V320c0-70.7-57.3-128-128-128s-128 57.3-128 128V512H416z"]
};
var faSquareQuote = {
  prefix: 'fas',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 128h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H128c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V272H272c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24z"]
};
var faUpLeft = {
  prefix: 'fas',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", "M48 80H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-72 72L372.7 340.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3l-41.4 41.4c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L142.6 302.6l-72 72c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V112c0-17.7 14.3-32 32-32z"]
};
var faBringFront = {
  prefix: 'fas',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", "M64 64h64 32 32 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64h64V192H64V64zM480 448H448 384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H512v64h64V448H512 480zM224 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224z"]
};
var faChessBoard = {
  prefix: 'fas',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"]
};
var faBurgerCheese = {
  prefix: 'fas',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M32 194.9C32 211 45 224 61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM128 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400v16c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V400c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM234 262.7c-6.5-4.4-14.2-6.7-22.1-6.7H208l-.1 0H64c-26.5 0-48 21.5-48 48s21.5 48 48 48H448c26.5 0 48-21.5 48-48s-21.5-48-48-48H432.1l-.1 0h-3.9c-7.9 0-15.6 2.3-22.1 6.7l-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0L234 262.7z"]
};
var faCheeseburger = faBurgerCheese;
var faBuildingCircleCheck = {
  prefix: 'fas',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faRepeat1 = {
  prefix: 'fas',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M32 256c-17.7 0-32-14.3-32-32C0 135.6 71.6 64 160 64H320V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V128H160c-53 0-96 43-96 96c0 17.7-14.3 32-32 32zm448 0c17.7 0 32 14.3 32 32c0 88.4-71.6 160-160 160H192v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32H352c53 0 96-43 96-96c0-17.7 14.3-32 32-32zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
var faArrowDownToLine = {
  prefix: 'fas',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zM214.6 342.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 242.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V242.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128z"]
};
var faArrowToBottom = faArrowDownToLine;
var faGrid5 = {
  prefix: 'fas',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M0 48c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H16C7.2 96 0 88.8 0 80V48zm0 96c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V144zm16 80H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V336zm16 80H48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V432zM208 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM192 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM192 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM288 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V48zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM288 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM288 432c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V432zM400 32h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM384 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM384 336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16z"]
};
var faSwapArrows = {
  prefix: 'fas',
  iconName: 'swap-arrows',
  icon: [640, 512, [], "e60a", "M105.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 109.3V352c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-70.7 57.3-128 128-128s128 57.3 128 128V402.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L480 402.7V160c0-35.3-28.7-64-64-64s-64 28.7-64 64V352c0 70.7-57.3 128-128 128s-128-57.3-128-128V109.3L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z"]
};
var faRightLongToLine = {
  prefix: 'fas',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32zM360.5 409.4c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V320L32 320c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32l288 0V120c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z"]
};
var faPersonChalkboard = {
  prefix: 'fas',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faMarsStrokeRight = {
  prefix: 'fas',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"]
};
var faMarsStrokeH = faMarsStrokeRight;
var faHandBackFist = {
  prefix: 'fas',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"]
};
var faHandRock = faHandBackFist;
var faGridRound5 = {
  prefix: 'fas',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faTally = {
  prefix: 'fas',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", "M128 32c17.7 0 32 14.3 32 32V275.6l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32V232.9l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32V190.3l64-21.3V64c0-17.7 14.3-32 32-32s32 14.3 32 32v83.6l53.9-18c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L544 215.1V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V236.4l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V279.1l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V321.7l-64 21.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V364.4l-53.9 18c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5L96 296.9V64c0-17.7 14.3-32 32-32z"]
};
var faTally5 = faTally;
var faSquareCaretUp = {
  prefix: 'fas',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"]
};
var faCaretSquareUp = faSquareCaretUp;
var faCloudShowersWater = {
  prefix: 'fas',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faChartBar = {
  prefix: 'fas',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faBarChart = faChartBar;
var faHandsBubbles = {
  prefix: 'fas',
  iconName: 'hands-bubbles',
  icon: [576, 512, ["hands-wash"], "e05e", "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"]
};
var faHandsWash = faHandsBubbles;
var faLessThanEqual = {
  prefix: 'fas',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faTrain = {
  prefix: 'fas',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faUpFromDottedLine = {
  prefix: 'fas',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", "M73.9 166.1L196.7 43.3C203.9 36.1 213.8 32 224 32s20.1 4.1 27.3 11.3L374.1 166.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H288V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V224H97.9C79.2 224 64 208.8 64 190.1c0-9 3.6-17.6 9.9-24zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faEyeLowVision = {
  prefix: 'fas',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"]
};
var faLowVision = faEyeLowVision;
var faTrafficLightGo = {
  prefix: 'fas',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-200a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faFaceExhaling = {
  prefix: 'fas',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", "M256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7C329.3 410.6 320 398.1 320 384s9.3-26.6 22.8-30.6L385 340.7c5.3-30 31.5-52.7 63-52.7c.7 0 1.4 0 2.1 0c13.2-14.7 32.3-24 53.7-24c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM195.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm121.6 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM256 344a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm287.4-5.5c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-22.1 0-39.9 17.9-39.9 40l-56.1 14.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9l56.9 14.2c-.5 2.5-.8 5.1-.8 7.8c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z"]
};
var faSensorFire = {
  prefix: 'fas',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm245.5 43.6c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faUserUnlock = {
  prefix: 'fas',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3V480c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3zM496 272v48h16 48 48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272c0-44.2 35.8-80 80-80s80 35.8 80 80H560c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faHexagonDivide = {
  prefix: 'fas',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var fa00 = {
  prefix: 'fas',
  iconName: '00',
  icon: [640, 512, [], "e467", "M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM64 176c0-44.2 35.8-80 80-80s80 35.8 80 80V336c0 44.2-35.8 80-80 80s-80-35.8-80-80V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM416 176c0-44.2 35.8-80 80-80s80 35.8 80 80V336c0 44.2-35.8 80-80 80s-80-35.8-80-80V176z"]
};
var faCrow = {
  prefix: 'fas',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCassetteBetamax = {
  prefix: 'fas',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 160H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 320a96 96 0 1 1 192 0A96 96 0 1 1 64 320zm256-64c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V256z"]
};
var faBetamax = faCassetteBetamax;
var faSailboat = {
  prefix: 'fas',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"]
};
var faWindowRestore = {
  prefix: 'fas',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"]
};
var faNfcMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v64c-22.8 0-44.4 4.8-64 13.3V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v48c-38.9 29.2-64 75.7-64 128c0 22.8 4.8 44.4 13.3 64H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H320c21.6 28.8 52.7 50 88.6 59.1c-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
var faFileBinary = {
  prefix: 'fas',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48zM96 304v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm144-48h32c8.8 0 16 7.2 16 16V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H272 240c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V288H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleV = {
  prefix: 'fas',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3L256 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"]
};
var faSquarePlus = {
  prefix: 'fas',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlusSquare = faSquarePlus;
var faBowlScoops = {
  prefix: 'fas',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M224 208c0 5.4 .4 10.8 1.1 16H446.9c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208zM0 208c0 5.4 .4 10.8 1.1 16H192.9c-.6-5.3-.9-10.6-.9-16c0-22 4.9-42.8 13.7-61.4c-13.9-21.2-34.9-37.4-59.6-45.3C135.4 97.9 123.9 96 112 96C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1zM16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9C11.1 361.9 72.4 416 145 416h40.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H320c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416H303c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4H16z"]
};
var faMistletoe = {
  prefix: 'fas',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v94.1l-98 98L91.3 230.4C38.3 240.6 0 287 0 341c0 41.4 33.6 75 75 75c50.5 0 94.3-33.5 108.1-81.2c7.2 10.4 19.3 17.2 32.9 17.2c22.1 0 40-17.9 40-40s-17.9-40-40-40c-7.9 0-15.3 2.3-21.5 6.3l5.4-28.2L264 185.9v72.4c14.7 13.2 24 32.3 24 53.7c0 39.8-32.2 72-72 72c-7.2 0-14.2-1.1-20.8-3c-2.1 8.4-3.2 17.1-3.2 25.9V416c0 53 43 96 96 96s96-43 96-96v-9.1c0-25.1-9-49.4-25.3-68.4L312 284V185.9L376.1 250l14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75c0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98V24zm64 88a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faCustard = {
  prefix: 'fas',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", "M396.7 64c30 0 56 20.8 62.5 50.1l13.5 60.8C450.9 167.4 423.5 160 400 160c-26.4 0-45.8 9.4-62.2 17.2l-.7 .3c-16.7 8-30.4 14.4-49.1 14.4s-32.3-6.4-49.1-14.4l-.7-.3C221.8 169.4 202.4 160 176 160c-23.5 0-50.9 7.4-72.6 14.9l13.5-60.8C123.4 84.8 149.3 64 179.3 64H396.7zM64.3 350.9L95.1 212.1c4.1-1.6 8.5-3.3 13.2-5c22-7.9 47.8-15.1 67.7-15.1c18.7 0 32.3 6.4 49.1 14.4l.7 .3c16.4 7.9 35.8 17.2 62.2 17.2s45.8-9.4 62.2-17.2l.7-.3c16.7-8 30.4-14.4 49.1-14.4c19.8 0 45.6 7.2 67.7 15.1c4.7 1.7 9.2 3.4 13.2 5L512 352 64.3 350.9zM32 384H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faLacrosseStick = {
  prefix: 'fas',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", "M336 64v0c.1 0 .2 0 .3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1c0 .1 0 .2 0 .3h0c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64V0C274.4 0 220.2 40.9 203.3 100.1L200 111.7c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-136 136c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3C471.1 291.8 512 237.6 512 176h0c0-.1 0-.2 0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0c-.1 0-.2 0-.3 0z"]
};
var faHockeyMask = {
  prefix: 'fas',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M0 240C0 111 64 0 224 0S448 111 448 240c0 192-48 272-224 272S0 432 0 240zM160 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 272c35.3 0 64-28.7 64-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64zm256-64c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faSunrise = {
  prefix: 'fas',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M354.5 135.7L320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm39.1 89.5c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L512 432H406.7c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80H64L34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM0 488c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
};
var faSubtitles = {
  prefix: 'fas',
  iconName: 'subtitles',
  icon: [576, 512, [], "e60f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 208H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 336h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 0H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faPanelEws = {
  prefix: 'fas',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", "M64 0C28.7 0 0 28.7 0 64V288H16c44.2 0 80 35.8 80 80v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-26.5-21.5-48-48-48H0V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm48 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 128h64c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"]
};
var faToriiGate = {
  prefix: 'fas',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"]
};
var faCloudExclamation = {
  prefix: 'fas',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM320 160c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faMessageLines = {
  prefix: 'fas',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
};
var faCommentAltLines = faMessageLines;
var faFrog = {
  prefix: 'fas',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBucket = {
  prefix: 'fas',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"]
};
var faFloppyDiskPen = {
  prefix: 'fas',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H258.5l14-55.9c2.8-11.3 8.6-21.5 16.8-29.7L448 235.6V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm325.8-52.2c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 417.1c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.8l-71-71L311.9 417.1z"]
};
var faImage = {
  prefix: 'fas',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWindowFrame = {
  prefix: 'fas',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", "M32 256V64C32 28.7 60.7 0 96 0H416c35.3 0 64 28.7 64 64V256 448c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V256zm384 32H280V448H416V288zm-184 0H96V448H232V288zm48-64H416V64H280V224zM232 64H96V224H232V64z"]
};
var faMicrophone = {
  prefix: 'fas',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"]
};
var faCow = {
  prefix: 'fas',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"]
};
var faFileZip = {
  prefix: 'fas',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H240c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"]
};
var faSquareRing = {
  prefix: 'fas',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 224a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"]
};
var faDownFromLine = {
  prefix: 'fas',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M41.9 345.9L164.7 468.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L342.1 345.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9H256V160c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32V288H65.9C47.2 288 32 303.2 32 321.9c0 9 3.6 17.6 9.9 24zM32 96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96z"]
};
var faArrowAltFromTop = faDownFromLine;
var faCaretUp = {
  prefix: 'fas',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
};
var faShieldXmark = {
  prefix: 'fas',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faShieldTimes = faShieldXmark;
var faScrewdriver = {
  prefix: 'fas',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"]
};
var faCircleSortDown = {
  prefix: 'fas',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9H352c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zm0-310.6l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM313.4 192L256 134.6 198.6 192H313.4z"]
};
var faSortCircleDown = faCircleSortDown;
var faFolderClosed = {
  prefix: 'fas',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"]
};
var faHouseTsunami = {
  prefix: 'fas',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"]
};
var faSquareNfi = {
  prefix: 'fas',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"]
};
var faForklift = {
  prefix: 'fas',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", "M48 160H96V48c0-26.5 21.5-48 48-48H292.7c20.3 0 38.4 12.8 45.2 31.9l75.3 210.8c1.8 5.2 2.8 10.6 2.8 16.1v85.7c19.6 17.6 32 43.1 32 71.6c0 53-43 96-96 96s-96-43-96-96H192c0 53-43 96-96 96s-96-43-96-96V208c0-26.5 21.5-48 48-48zm208 96h94L281.4 64H160v96l96 96zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM544 32V384h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H512c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faArrowUpFromGroundWater = {
  prefix: 'fas',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"]
};
var faBracketSquareRight = {
  prefix: 'fas',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 96c0-35.3-28.7-64-64-64H64C46.3 32 32 46.3 32 64s14.3 32 32 32h64V416H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c35.3 0 64-28.7 64-64V96z"]
};
var faMartiniGlass = {
  prefix: 'fas',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"]
};
var faGlassMartiniAlt = faMartiniGlass;
var faRotateLeft = {
  prefix: 'fas',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faTableColumns = {
  prefix: 'fas',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"]
};
var faColumns = faTableColumns;
var faSquareA = {
  prefix: 'fas',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336H158.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288h82.3L224 205.7z"]
};
var faTick = {
  prefix: 'fas',
  iconName: 'tick',
  icon: [128, 512, [], "e32f", "M0 98.3V96C0 60.7 28.7 32 64 32s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L101.5 256.5C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4z"]
};
var faLemon = {
  prefix: 'fas',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"]
};
var faHeadSideMask = {
  prefix: 'fas',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHandshake = {
  prefix: 'fas',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faGem = {
  prefix: 'fas',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"]
};
var faDolly = {
  prefix: 'fas',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"]
};
var faDollyBox = faDolly;
var faSmoking = {
  prefix: 'fas',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"]
};
var faMinimize = {
  prefix: 'fas',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"]
};
var faCompressArrowsAlt = faMinimize;
var faRefrigerator = {
  prefix: 'fas',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M96 0C43 0 0 43 0 96v64H288V112c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V96c0-53-43-96-96-96H96zM384 192H320V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H0V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V192z"]
};
var faMonument = {
  prefix: 'fas',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faOctagonXmark = {
  prefix: 'fas',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faTimesOctagon = faOctagonXmark;
var faXmarkOctagon = faOctagonXmark;
var faAlignSlash = {
  prefix: 'fas',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H399.7l-81.7-64H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H236.4L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM324.9 352l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H324.9zM162.5 224l-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7c0 17.7 14.3 32 32 32h34.5zM487.4 480l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H487.4z"]
};
var faSnowplow = {
  prefix: 'fas',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faAnglesRight = {
  prefix: 'fas',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"]
};
var faAngleDoubleRight = faAnglesRight;
var faTruckRampCouch = {
  prefix: 'fas',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2V334.8l-38.7 10.4L126.7 386.6 64.9 403.2c-17.1 4.6-34.6-5.6-39.2-22.6L13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z"]
};
var faTruckCouch = faTruckRampCouch;
var faCannabis = {
  prefix: 'fas',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"]
};
var faCirclePlay = {
  prefix: 'fas',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
};
var faPlayCircle = faCirclePlay;
var faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fas',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L297.4 169.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H352zM214.6 297.4c-12.5-12.5-32.8-12.5-45.3 0L64 402.7V352c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3L214.6 342.6c12.5-12.5 12.5-32.8 0-45.3z"]
};
var faTablets = {
  prefix: 'fas',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"]
};
var fa360Degrees = {
  prefix: 'fas',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M640 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H96L38.4 204.8c-7.3 9.7-8.4 22.7-3 33.5S51.9 256 64 256H80c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32H90.5c-8.5 0-16.6-3.4-22.6-9.4L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l13.3 13.3c18 18 42.4 28.1 67.9 28.1H96c53 0 96-43 96-96V304c0-47-29-87.3-70.1-103.9l63.7-84.9c7.3-9.7 8.4-22.7 3-33.5S172.1 64 160 64H32zm448 80c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm96 224V144c0-44.2-35.8-80-80-80s-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80zM288 160c0-17.7 14.3-32 32-32s32-14.3 32-32s-14.3-32-32-32c-53 0-96 43-96 96V288c0 .1 0 .2 0 .2V368c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-5.5 0-10.8 .6-16 1.6V160zm0 112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272z"]
};
var faEthernet = {
  prefix: 'fas',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"]
};
var faEuroSign = {
  prefix: 'fas',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faChair = {
  prefix: 'fas',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"]
};
var faCircleCheck = {
  prefix: 'fas',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCheckCircle = faCircleCheck;
var faSquareDashedCirclePlus = {
  prefix: 'fas',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M96 32C43 32 0 75 0 128v32H64V128c0-17.7 14.3-32 32-32h32V32H96zM0 192V320H64V192H0zM64 352H0v32c0 53 43 96 96 96h32V416H96c-17.7 0-32-14.3-32-32V352zM384 128v70.6c15.3-4.3 31.4-6.6 48-6.6c5.4 0 10.7 .2 16 .7V128c0-53-43-96-96-96H320V96h32c17.7 0 32 14.3 32 32zM160 480H296.2c-15.3-18.5-26.9-40.2-33.6-64H160v64zm0-384H288V32H160V96zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faMoneySimpleFromBracket = {
  prefix: 'fas',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", "M64 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 43 43 0 96 0H544c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96zm64 0l384 0 0 352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64l0-352zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z"]
};
var faBat = {
  prefix: 'fas',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M235.6 52.8l10.8 14.4c6 8.1 15.5 12.8 25.6 12.8h32c10.1 0 19.6-4.7 25.6-12.8l10.8-14.4c2.3-3 5.8-4.8 9.6-4.8c5.8 0 10.8 4.1 11.8 9.8l19 101.4L452.6 125c16.2-7.7 35.5-3.6 47.1 10C548.9 192.4 576 265.6 576 341.2v37.6c0 9.7-10.2 16-18.9 11.7l-63.8-31.9c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1l-36.6-36.6c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1L18.9 390.5c-8.7 4.3-18.9-2-18.9-11.7V341.2C0 265.6 27.1 192.4 76.3 135c11.6-13.6 30.9-17.7 47.1-10l71.8 34.2 19-101.4c1.1-5.7 6-9.8 11.8-9.8c3.8 0 7.4 1.8 9.6 4.8z"]
};
var faCircleStop = {
  prefix: 'fas',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]
};
var faStopCircle = faCircleStop;
var faHeadSideHeadphones = {
  prefix: 'fas',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M256 0V0c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2C0 122.8 67.4 36.9 160 9.3V86.6c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9c-10-7.2-17.4-18.2-17.4-30.5V0zM240 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faPhoneRotary = {
  prefix: 'fas',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M0 141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V176c0 17.7-14.3 32-32 32H437.7c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16c-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208H32c-17.7 0-32-14.3-32-32V141.3zM32 432V401c0-11.1 2.9-22.1 8.4-31.8l101.1-177C153 172.3 174.2 160 197.1 160H314.9c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zM328 312a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faCompassDrafting = {
  prefix: 'fas',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDraftingCompass = faCompassDrafting;
var faPlateWheat = {
  prefix: 'fas',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"]
};
var faCalendarCircleMinus = {
  prefix: 'fas',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faChopsticks = {
  prefix: 'fas',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M368 0c-15.3 0-29 7.2-37.7 18.3L3.4 486.1c-5.5 6.9-4.3 17 2.7 22.5s17 4.2 22.5-2.7L405.7 77.7C412.2 69.5 416 59.2 416 48c0-26.5-21.5-48-48-48zM131.9 506.4c5.8 6.7 15.9 7.5 22.6 1.7L623.2 148.4c10.3-8.8 16.8-21.9 16.8-36.4c0-26.5-21.5-48-48-48c-11.9 0-22.8 4.4-31.2 11.6L133.6 483.9c-6.7 5.8-7.5 15.8-1.7 22.6z"]
};
var faCarWrench = {
  prefix: 'fas',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M468.9 104H456l-.5 0c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1l.5 0h12.9 17.6c10.8 0 18.4-10.6 12.5-19.6c-3.6-5.5-7.8-10.5-12.5-14.9c-4.2-3.9-8.8-7.4-13.8-10.3C470.8 10 468.9 9 466.9 8C456.4 2.9 444.5 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3H163.8c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1c-5 2.9-9.6 6.4-13.8 10.3c-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56H43.1 56l.5 0c.7 0 1.4 .1 2.1 .1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7 .1-1.4 .1-2.1 .1l-.5 0H43.1 25.5C14.7 104 7 114.6 12.9 123.6c3.6 5.5 7.8 10.5 12.5 14.9c4.2 3.9 8.8 7.4 13.8 10.3c1.9 1.1 3.8 2.2 5.8 3.1c10.6 5.1 22.4 8 34.9 8c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3H348.2c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c12.5 0 24.4-2.9 34.9-8c2-1 3.9-2 5.8-3.1c5-2.9 9.6-6.4 13.8-10.3c4.7-4.4 9-9.4 12.5-14.9c5.9-9-1.7-19.6-12.5-19.6H468.9zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCarMechanic = faCarWrench;
var faIcicles = {
  prefix: 'fas',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"]
};
var faPersonShelter = {
  prefix: 'fas',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faNeuter = {
  prefix: 'fas',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"]
};
var faIdBadge = {
  prefix: 'fas',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faKazoo = {
  prefix: 'fas',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M514 128h94c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H514c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16H224c-3 0-6-.4-9-1.3l-192-56C9.4 322.7 0 310.2 0 296V216c0-14.2 9.4-26.7 23-30.7l192-56c2.9-.8 5.9-1.3 9-1.3H382c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16zm30 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM427.3 212.7L448 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L470.6 256l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L448 278.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L425.4 256l-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faMarker = {
  prefix: 'fas',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"]
};
var faBinBottles = {
  prefix: 'fas',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", "M152 0h80c13.3 0 24 10.7 24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16V24c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96H256c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192H32zm352 0c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V66.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5H384zM0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32L583.8 457c-4.5 31.5-31.5 55-63.4 55h-401c-31.8 0-58.9-23.4-63.4-55L32 288c-17.7 0-32-14.3-32-32z"]
};
var faFaceLaughBeam = {
  prefix: 'fas',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faLaughBeam = faFaceLaughBeam;
var faSquareArrowDownLeft = {
  prefix: 'fas',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zM288 368c13.3 0 24-10.7 24-24s-10.7-24-24-24H193.9L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H288z"]
};
var faBatteryBolt = {
  prefix: 'fas',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", "M80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80h92.2c-12.9-14.5-16.1-35.6-7.2-53.5l5.3-10.5H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H219.2l80-64H80zM464 352H324.8l-80 64H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H371.8c13 14.5 16.1 35.6 7.2 53.5L373.7 160H464c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H297.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faTreeLarge = {
  prefix: 'fas',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", "M62 169.4L210.6 5.9C214 2.1 218.9 0 224 0s10 2.1 13.4 5.9L386 169.4c3.9 4.2 6 9.8 6 15.5c0 12.7-10.3 23.1-23.1 23.1H344l75.5 105.7c2.9 4.1 4.5 9 4.5 14.1c0 13.4-10.9 24.2-24.2 24.2H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2c0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H48.2C34.8 352 24 341.1 24 327.8c0-5 1.6-10 4.5-14.1L104 208H79.1C66.3 208 56 197.7 56 184.9c0-5.7 2.1-11.3 6-15.5z"]
};
var faHelicopterSymbol = {
  prefix: 'fas',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"]
};
var faAperture = {
  prefix: 'fas',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 0c4 0 7.9 .1 11.9 .3c11.3 .5 17.5 12.9 11.8 22.8L177.5 200c-6.2 10.7-21.6 10.7-27.7 0L82.8 84.1c-3.6-6.3-2.6-14.3 2.9-19.2C130.9 24.5 190.6 0 256 0zM0 256c0-50.9 14.9-98.3 40.5-138.2c6.1-9.5 19.9-8.6 25.6 1.2L168.2 296c6.2 10.7-1.5 24-13.9 24H20.5c-7.3 0-13.7-4.9-15.2-12.1C1.8 291.2 0 273.8 0 256zM193.7 492c-3.6 6.3-11.1 9.4-18 7.1C111.8 478 59 432.5 28.5 373.6C23.3 363.5 31 352 42.3 352H246.8c12.3 0 20 13.3 13.9 24l-67 116zM256 512c-4 0-7.9-.1-11.9-.3c-11.3-.5-17.5-12.9-11.8-22.8L334.5 312c6.2-10.7 21.6-10.7 27.7 0l66.9 115.9c3.6 6.3 2.6 14.3-2.9 19.2C381.1 487.5 321.4 512 256 512zM512 256c0 50.9-14.9 98.3-40.5 138.2c-6.1 9.5-19.9 8.6-25.6-1.2L343.8 216c-6.2-10.7 1.5-24 13.9-24H491.5c7.3 0 13.7 4.9 15.2 12.1c3.5 16.8 5.3 34.1 5.3 51.9zM318.3 20c3.6-6.3 11.1-9.4 18-7.1C400.2 34 453 79.5 483.5 138.4c5.2 10.1-2.5 21.6-13.8 21.6H265.2c-12.3 0-20-13.3-13.9-24l67-116z"]
};
var faUniversalAccess = {
  prefix: 'fas',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faGearComplex = {
  prefix: 'fas',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2V230.1c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faFileMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm16 304c0 17.8-4.9 34.5-13.3 48.9L297 391.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-38.4-38.4C210.4 395.2 193.8 400 176 400c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faFileSearch = faFileMagnifyingGlass;
var faUpRight = {
  prefix: 'fas',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", "M336 80H96c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l72 72L11.3 340.7C4.1 347.9 0 357.8 0 368s4.1 20.1 11.3 27.3l41.4 41.4C59.9 443.9 69.8 448 80 448s20.1-4.1 27.3-11.3L241.4 302.6l72 72c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V112c0-17.7-14.3-32-32-32z"]
};
var faCircleChevronUp = {
  prefix: 'fas',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"]
};
var faChevronCircleUp = faCircleChevronUp;
var faUserPolice = {
  prefix: 'fas',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5v8.4c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 131.7 80 121.6 80 110.9v-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4c0 17.2 7 46.1 36.9 58.6c2 .8 4.2 .8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4L227 48.6zM98.1 168.8c39.1 15 81.5 23.2 125.9 23.2s86.8-8.2 125.9-23.2c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM134.4 352c2.8 0 5.5 .9 7.7 2.6l72.3 54.2c5.7 4.3 13.5 4.3 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352zM352 408c-3.5 0-6.5 2.2-7.6 5.5L339 430.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9L331 454.8l-5.4 16.6c-1.1 3.3 .1 6.9 2.9 9s6.6 2 9.4 0L352 470.1l14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9L373 454.8l14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5z"]
};
var faLariSign = {
  prefix: 'fas',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"]
};
var faVolcano = {
  prefix: 'fas',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"]
};
var faTeddyBear = {
  prefix: 'fas',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", "M154.7 103.7C138.7 93.9 128 76.2 128 56c0-30.9 25.1-56 56-56c24.2 0 44.7 15.3 52.6 36.7C252.5 33.5 269.8 32 288 32s35.5 1.5 51.4 4.7C347.3 15.3 367.8 0 392 0c30.9 0 56 25.1 56 56c0 20.2-10.7 37.9-26.7 47.7c1.8 7.4 2.7 15.5 2.7 24.3c0 70.7-60.9 128-136 128s-136-57.3-136-128c0-8.8 .9-16.8 2.7-24.3zM240 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM50.3 178.3c20.8-16.4 51-12.8 67.4 8L143.5 219c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7c16.4-20.8 46.6-24.4 67.4-8s24.4 46.6 8 67.4l-25.8 32.7c-17.7 22.4-37.9 41.3-59.9 56.7V400h16.6c3.9-27.1 27.2-48 55.4-48c30.9 0 56 25.1 56 56c0 2.7-.2 5.4-.6 8l-13 53.3c-5.8 23.8-26.3 40.9-50.4 42.6v.1h-4H480 96 68 64v-.1c-24.1-1.7-44.6-18.8-50.4-42.6L.6 416c-.4-2.6-.6-5.3-.6-8c0-30.9 25.1-56 56-56c28.2 0 51.6 20.9 55.4 48H128V335.1c-22-15.4-42.3-34.3-59.9-56.7L42.3 245.7c-16.4-20.8-12.8-51 8-67.4zM256 352c-35.3 0-64 28.7-64 64H384c0-35.3-28.7-64-64-64H256z"]
};
var faStocking = {
  prefix: 'fas',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M96 0C78.3 0 64 14.3 64 32V64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96zm0 128V238.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V128H96z"]
};
var faPersonWalkingDashedLineArrowRight = {
  prefix: 'fas',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"]
};
var faImageSlash = {
  prefix: 'fas',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64H487.4l-81.2-64H320 248 152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z"]
};
var faMaskSnorkel = {
  prefix: 'fas',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M544 32c-17.7 0-32 14.3-32 32v96h64V64c0-17.7-14.3-32-32-32zM512 367.4c0 44.5-36.1 80.6-80.6 80.6c-39.4 0-73-28.5-79.5-67.4l-.3-1.9c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.3 1.9C300.4 460.9 360.7 512 431.4 512C511.3 512 576 447.3 576 367.4V192H512V367.4zM64 64C28.7 64 0 92.7 0 128v96c0 35.3 28.7 64 64 64h79.7c28.6 0 53.7-18.9 61.5-46.4l3.4-11.7c4.4-15.5 26.3-15.5 30.8 0l3.4 11.7c7.8 27.5 33 46.4 61.5 46.4H384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"]
};
var faSmoke = {
  prefix: 'fas',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", "M172.3 194.3c-9.2-1.5-18.7-2.3-28.3-2.3c-29.2 0-56.7 7.1-80.9 19.6C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-11.5 7.3-22 16-31.2 25.9C372.7 102.8 347.2 96 320 96c-66.5 0-123.5 40.6-147.7 98.3zm276.3 62.5C419.5 217.5 372.7 192 320 192c-31.5 0-60.9 9.1-85.7 24.9c-9.6-5.8-19.8-10.6-30.5-14.5C224 158.5 268.4 128 320 128c31.3 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9C563.1 284.5 516.9 256 464 256c-5.2 0-10.3 .3-15.4 .8zM144 512C64.5 512 0 447.5 0 368s64.5-144 144-144c34.5 0 66.1 12.1 90.9 32.3C257.6 236.2 287.4 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112s-50.1 112-112 112H144z"]
};
var faSterlingSign = {
  prefix: 'fas',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faBatteryExclamation = {
  prefix: 'fas',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", "M208 96v64H80c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H198.7c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80H208zM464 416H345.3c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H336V96H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM240 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faViruses = {
  prefix: 'fas',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faSquarePersonConfined = {
  prefix: 'fas',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"]
};
var faUserTie = {
  prefix: 'fas',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 256A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8 .7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"]
};
var faArrowDownLong = {
  prefix: 'fas',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"]
};
var faLongArrowDown = faArrowDownLong;
var faTentArrowDownToLine = {
  prefix: 'fas',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320V448z"]
};
var faCertificate = {
  prefix: 'fas',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"]
};
var faCrystalBall = {
  prefix: 'fas',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M448 224c0 62.7-25.7 119.3-67.2 160H67.2C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM152.5 84.3l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4c-2.6-7-12.4-7-15 0zm159 48c-2.6-7-12.4-7-15 0l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8zm98.9 331.8c3.7 5.1 5.6 11.3 5.6 17.6c0 16.7-13.6 30.3-30.3 30.3H62.3C45.6 512 32 498.4 32 481.7c0-6.3 2-12.5 5.6-17.6L72 416H376l34.4 48.1z"]
};
var faReplyAll = {
  prefix: 'fas',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"]
};
var faMailReplyAll = faReplyAll;
var faSuitcase = {
  prefix: 'fas',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"]
};
var faPersonSkating = {
  prefix: 'fas',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
var faSkating = faPersonSkating;
var faStarShooting = {
  prefix: 'fas',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M313 41L265 89c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM170.4 157.4c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM505 41L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faBinaryLock = {
  prefix: 'fas',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", "M322.7 6c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V32c0-10.3-4.9-19.9-13.3-26zM98.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16C5.1 311.2-3.9 329.4 1.7 346.1s23.7 25.8 40.5 20.2l5.9-2V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H80h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V320c0-10.3-4.9-19.9-13.3-26zM64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 64h64v96H64V64zM192 352v96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64zm128 0v96H256V352h64zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faFilterCircleDollar = {
  prefix: 'fas',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
var faFunnelDollar = faFilterCircleDollar;
var faCameraRetro = {
  prefix: 'fas',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"]
};
var faCircleArrowDown = {
  prefix: 'fas',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"]
};
var faArrowCircleDown = faCircleArrowDown;
var faCommentPen = {
  prefix: 'fas',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm84.8-293c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L272.6 170 287.5 155c14.7-14.7 38.6-14.7 53.3 0zM178.1 264.5L250 192.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faCommentEdit = faCommentPen;
var faFileImport = {
  prefix: 'fas',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"]
};
var faArrowRightToFile = faFileImport;
var faBanjo = {
  prefix: 'fas',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41L286 180.7c-20.6-13.9-44.3-23.4-70-27V152c0-13.3-10.7-24-24-24s-24 10.7-24 24v1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296H24c-13.3 0-24 10.7-24 24s10.7 24 24 24h1.7c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.7c-3.7-25.7-13.1-49.5-27-70l76.1-76.1 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM155.3 308.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48z"]
};
var faSquareArrowUpRight = {
  prefix: 'fas',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faLightEmergencyOn = {
  prefix: 'fas',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H552zM320 32c-88.4 0-160 71.6-160 160V352H480V192c0-88.4-71.6-160-160-160zM240 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80zM96 416v32c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z"]
};
var faKerning = {
  prefix: 'fas',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", "M454.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l240-480zM60.6 113.7C52.7 97.9 33.5 91.5 17.7 99.4S-4.5 126.5 3.4 142.3l128 256c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l128-256c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L160 312.4 60.6 113.7zm320 284.6L403.8 352H556.2l23.2 46.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-128-256C503.2 102.8 492.1 96 480 96s-23.2 6.8-28.6 17.7l-128 256c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3zM480 199.6L524.2 288H435.8L480 199.6z"]
};
var faBoxOpen = {
  prefix: 'fas',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"]
};
var faSquareF = {
  prefix: 'fas',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v64h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24z"]
};
var faScroll = {
  prefix: 'fas',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"]
};
var faSpa = {
  prefix: 'fas',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"]
};
var faArrowLeftFromLine = {
  prefix: 'fas',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", "M384 96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96zM9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224 288 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]
};
var faArrowFromRight = faArrowLeftFromLine;
var faStrawberry = {
  prefix: 'fas',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", "M481.5 1.9c12.2 5.2 17.8 19.3 12.6 31.5c-13.4 31.2-36.9 59-56.3 78.7c32.8 1.8 57.4 18 68.2 26.6c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 .7 0 1.4 0 2.1c.7-.7 1.4-1.3 2-2c18.2-18.2 37.7-41.7 47.9-65.5c5.2-12.2 19.3-17.8 31.5-12.6zM0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336zM172.8 172.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm87.3 2.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm32-96c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-224-96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zM108.8 364.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7z"]
};
var faLocationPinLock = {
  prefix: 'fas',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faPause = {
  prefix: 'fas',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"]
};
var faClockEightThirty = {
  prefix: 'fas',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V300.8L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlaneEngines = {
  prefix: 'fas',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M576 256c0-35-59.5-64-93.7-64l-116.6 0-37.2-65.1C342 123.1 352 110.7 352 96c0-17.7-14.3-32-32-32l-27.4 0L265.2 16.1C259.5 6.2 248.9 0 237.4 0L181.2 0c-10.6 0-18.3 10.2-15.4 20.4l49 171.6L112 192 68.8 134.4c-3-4-7.8-6.4-12.8-6.4l-42 0c-7.8 0-14 6.3-14 14c0 1.3 .2 2.6 .5 3.9l22.7 79.3C9.8 229 0 241.4 0 256s9.8 27 23.2 30.8L.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14l42 0c5 0 9.8-2.4 12.8-6.4L112 320l102.9 0-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1L292.6 448l27.4 0c17.7 0 32-14.3 32-32c0-14.7-10-27.1-23.5-30.9L365.7 320l116.6 0c34.2 0 93.7-28 93.7-64z"]
};
var faPlaneAlt = faPlaneEngines;
var faHillAvalanche = {
  prefix: 'fas',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"]
};
var faTemperatureEmpty = {
  prefix: 'fas',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faBomb = {
  prefix: 'fas',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"]
};
var faGaugeLow = {
  prefix: 'fas',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAltSlow = faGaugeLow;
var faRegistered = {
  prefix: 'fas',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"]
};
var faTrashCanPlus = {
  prefix: 'fas',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM200 408c0 13.3 10.7 24 24 24s24-10.7 24-24V344h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faAddressCard = {
  prefix: 'fas',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faScaleUnbalancedFlip = {
  prefix: 'fas',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faGlobeSnow = {
  prefix: 'fas',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M448 224c0 62.7-25.7 119.3-67.2 160H256V352h64c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256H288c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4l-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64v32H67.2C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM256 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM20.3 474.2L61.1 416H386.9l40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8S416.9 512 408 512H40c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z"]
};
var faSubscript = {
  prefix: 'fas',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"]
};
var faDiamondTurnRight = {
  prefix: 'fas',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"]
};
var faDirections = faDiamondTurnRight;
var faIntegral = {
  prefix: 'fas',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M216 64c-13.3 0-24 10.7-24 24V424c0 48.6-39.4 88-88 88s-88-39.4-88-88v-8c0-17.7 14.3-32 32-32s32 14.3 32 32v8c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-48.6 39.4-88 88-88s88 39.4 88 88v8c0 17.7-14.3 32-32 32s-32-14.3-32-32V88c0-13.3-10.7-24-24-24z"]
};
var faBurst = {
  prefix: 'fas',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"]
};
var faHouseLaptop = {
  prefix: 'fas',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"]
};
var faLaptopHouse = faHouseLaptop;
var faFaceTired = {
  prefix: 'fas',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faTired = faFaceTired;
var faMoneyBills = {
  prefix: 'fas',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faBlindsRaised = {
  prefix: 'fas',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", "M32 0C14.3 0 0 14.3 0 32C0 43.9 6.5 54.2 16.1 59.8L1.2 100.6c-.8 2.2-1.2 4.6-1.2 7C0 118.9 9.1 128 20.4 128H128V64h32v64H491.6c11.3 0 20.4-9.1 20.4-20.4c0-2.4-.4-4.7-1.2-7L495.9 59.8C505.5 54.2 512 43.9 512 32c0-17.7-14.3-32-32-32H32zM144 512c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V224H491.9c11.1 0 20.1-9 20.1-20.1c0-2.6-.5-5.1-1.4-7.5L496 160H160v64H128V160H16L1.4 196.4c-1 2.4-1.4 4.9-1.4 7.5C0 215 9 224 20.1 224H128V418.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faSmog = {
  prefix: 'fas',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"]
};
var faUfoBeam = {
  prefix: 'fas',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M184 152s24 40 104 40s104-40 104-40c0-48-33.3-104-104-104s-104 56-104 104zm-42.6-40.4C159.1 47.2 218.1 0 288 0s128.9 47.2 146.6 111.6C519.2 131.1 576 167 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41 56.8-76.9 141.4-96.4zM120 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM74.3 325.7l4.2-8.9c14.3 5.6 29.7 10.6 46 15l-6.8 14.5-72 152c-5.7 12-20 17.1-32 11.4s-17.1-20-11.4-32l72-152zm384 20.6l-6.8-14.5c16.3-4.4 31.7-9.4 46-15l4.2 8.9 72 152c5.7 12 .6 26.3-11.4 32s-26.3 .6-32-11.4l-72-152z"]
};
var faCircleCaretUp = {
  prefix: 'fas',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H152c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"]
};
var faCaretCircleUp = faCircleCaretUp;
var faUserVneckHairLong = {
  prefix: 'fas',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zm61.3 199.1l53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2C385.1 329.7 448 398.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 398.2 62.9 329.7 143.7 321c5.3-.6 10.5 1.9 13.7 6.2z"]
};
var faSquareALock = {
  prefix: 'fas',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H320V384c-9.1 0-17.7-5.2-21.8-13.9l-12-26.1H161.8l-12 26.1c-5.6 12-19.8 17.3-31.8 11.7s-17.3-19.8-11.7-31.8l96-208c3.9-8.5 12.4-13.9 21.8-13.9s17.9 5.4 21.8 13.9l82.4 178.6c5.6-10 13.9-18.3 23.8-24V272c0-56.4 41.7-103.1 96-110.9V96c0-35.3-28.7-64-64-64H64zM224 209.3L184 296h80l-40-86.7zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faCrutch = {
  prefix: 'fas',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"]
};
var faGasPumpSlash = {
  prefix: 'fas',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-72.2-56.6C569.5 397.9 576 379.7 576 360V224 192 168 154.5c0-17-6.7-33.3-18.7-45.3L480 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32l32 32v64c0 29.8 20.4 54.9 48 62V360c0 8.5-2.7 16.4-7.2 22.9L384 275.7V64c0-35.3-28.7-64-64-64H160c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM96 171.6V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32V398.5L96 171.6z"]
};
var faFontAwesome = {
  prefix: 'fas',
  iconName: 'font-awesome',
  icon: [448, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M448 48V384c-63.1 22.5-82.3 32-119.5 32c-62.8 0-86.6-32-149.3-32c-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2c62.7 0 86.5 32 149.3 32c20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3c-62.8 0-86.6-32-149.3-32c-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32V76.7c40.3-8 64.4-28.7 115.2-28.7c62.7 0 86.5 32 149.3 32c37.1 0 56.4-9.5 119.5-32z"]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faCloudArrowUp = {
  prefix: 'fas',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faPalette = {
  prefix: 'fas',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTransporter4 = {
  prefix: 'fas',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", "M224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM56.7 358.6L64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416 6.6 408.7C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 480c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H296 216 128c-17.7 0-32-14.3-32-32z"]
};
var faChartMixedUpCircleCurrency = {
  prefix: 'fas',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.8L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105v39c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H400zM192 224c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]
};
var faObjectsAlignRight = {
  prefix: 'fas',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48L48 224c-26.5 0-48-21.5-48-48V112C0 85.5 21.5 64 48 64l288 0zm0 224c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48H336z"]
};
var faArrowsTurnRight = {
  prefix: 'fas',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"]
};
var faVest = {
  prefix: 'fas',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]
};
var faPig = {
  prefix: 'fas',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M513.5 32c8 0 14.5 6.5 14.5 14.5V78c0 19.7-9 37.8-23.6 49.7c6.4 4.9 12.7 10.1 18.6 15.7c17.6-15.9 28.5-38.6 29-63.3h40c8.8 0 16 7.2 16 16v16c0 32.8-24.6 59.8-56.3 63.5l6.8 9C570 200 585 212.5 602.2 221.1L608 224h8c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24H572.5c-22.2 21.2-49.7 36.2-79.8 43.3l-13 45.5C475.8 470.5 463.3 480 449 480H416c-17.7 0-32-14.3-32-32V416H320 272v32c0 17.7-14.3 32-32 32H207c-14.3 0-26.8-9.5-30.8-23.2L155 382.4C110.3 358 80 310.5 80 256V240H47.4C21.2 240 0 218.8 0 192.6c0-21.8 14.8-40.7 35.9-46l8.2-2c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-8.2 2c-6.9 1.7-11.7 7.9-11.7 15c0 8.5 6.9 15.4 15.4 15.4H83.2C98 135 162.6 80 240 80H362.4c14.5 0 28.8 1.3 42.7 3.9c8.1-19.5 25.4-34.4 47-39.1l58.4-12.5c1-.2 2-.3 3-.3zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
var faInboxFull = {
  prefix: 'fas',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M58.9 80.5C66 52 91.6 32 121 32H391c29.4 0 55 20 62.1 48.5l57 227.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V323.9c0-5.2 .6-10.4 1.9-15.5l57-227.9zM391 96H121L73 288h51.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H439L391 96zM176 144H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleEnvelope = {
  prefix: 'fas',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v9.3L264.7 255.6c-2.7 1.2-5.7 1.9-8.7 1.9s-5.9-.6-8.7-1.9L128 201.3V192zm149.9 92.7L384 236.5V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V236.5l106.1 48.3c6.9 3.1 14.3 4.8 21.9 4.8s15-1.6 21.9-4.8z"]
};
var faEnvelopeCircle = faCircleEnvelope;
var faTrianglePersonDigging = {
  prefix: 'fas',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", "M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480H536c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faConstruction = faTrianglePersonDigging;
var faFerry = {
  prefix: 'fas',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faBullseyeArrow = {
  prefix: 'fas',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", "M335.2 244.7c.5 3.7 .8 7.5 .8 11.3c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c3.8 0 7.6 .3 11.3 .8l31.2-31.2L293.7 117c-12-3.3-24.7-5-37.7-5c-79.5 0-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2zm110.1-20.8c1.8 10.4 2.7 21.1 2.7 32.1c0 106-86 192-192 192S64 362 64 256S150 64 256 64c10.9 0 21.6 .9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3zm-80.2-43.1l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80 409 22.5c-4.3-10.7-18-13.5-26.2-5.4L331.6 68.4c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7L239 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z"]
};
var faArrowsDownToPeople = {
  prefix: 'fas',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
var faSeedling = {
  prefix: 'fas',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"]
};
var faSprout = faSeedling;
var faClockSeven = {
  prefix: 'fas',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V248.7l-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faLeftRight = {
  prefix: 'fas',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"]
};
var faArrowsAltH = faLeftRight;
var faBoxesPacking = {
  prefix: 'fas',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faCircleArrowLeft = {
  prefix: 'fas',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faFlashlight = {
  prefix: 'fas',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M576 416h32c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H576V416zM544 97.7C449.1 107.9 384 160 384 160H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H384s65.1 52.1 160 62.3V97.7zM224 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32z"]
};
var faGroupArrowsRotate = {
  prefix: 'fas',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"]
};
var faBowlFood = {
  prefix: 'fas',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"]
};
var faSquare9 = {
  prefix: 'fas',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]
};
var faCandyCane = {
  prefix: 'fas',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"]
};
var faArrowDownWideShort = {
  prefix: 'fas',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faSquareDollar = {
  prefix: 'fas',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM244.8 133.6v14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
var faDollarSquare = faSquareDollar;
var faUsdSquare = faSquareDollar;
var faPhoneArrowRight = {
  prefix: 'fas',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H312c-13.3 0-24-10.7-24-24s10.7-24 24-24H430.1L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faHandHoldingSeedling = {
  prefix: 'fas',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M96 14.5C96 6.5 102.5 0 110.5 0H160c88.4 0 160 71.6 160 160v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H241.5C161.1 160 96 94.9 96 14.5zm384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0h49.5c8 0 14.5 6.5 14.5 14.5zm88.2 321.7c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faMessageCheck = {
  prefix: 'fas',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm369 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z"]
};
var faCommentAltCheck = faMessageCheck;
var faCloudBolt = {
  prefix: 'fas',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faThunderstorm = faCloudBolt;
var faChartLineUpDown = {
  prefix: 'fas',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm313.4 57.4L288 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l112-112 18.7 18.7c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6V96.2v-.3V80c0-8.8-7.2-16-16-16H374.6C362.1 64 352 74.1 352 86.6c0 6 2.4 11.8 6.6 16l18.7 18.7zm64 141.3l-18.7 18.7-34.7-34.7-45.3 45.3 34.7 34.7-18.7 18.7c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6l89.4 0c8.8 0 16-7.2 16-16V278.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6z"]
};
var faTextSlash = {
  prefix: 'fas',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"]
};
var faRemoveFormat = faTextSlash;
var faWatch = {
  prefix: 'fas',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", "M112 0H272c26.5 0 48 21.5 48 48V72.2C283.7 46.8 239.6 32 192 32s-91.7 14.8-128 40.2V48C64 21.5 85.5 0 112 0zM64 464V439.8c36.3 25.3 80.4 40.2 128 40.2s91.7-14.8 128-40.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48zM0 256a192 192 0 1 1 384 0A192 192 0 1 1 0 256zM192 152c-13.3 0-24 10.7-24 24v80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2V176c0-13.3-10.7-24-24-24z"]
};
var faCircleDownLeft = {
  prefix: 'fas',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 198.6V336c0 8.8 7.2 16 16 16H313.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L296 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C322 146 317.1 144 312 144s-10 2-13.7 5.7L232 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z"]
};
var faText = {
  prefix: 'fas',
  iconName: 'text',
  icon: [448, 512, [], "f893", "M64 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V80C0 53.5 21.5 32 48 32H224 400c26.5 0 48 21.5 48 48v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V96H256l0 320h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H144c-17.7 0-32-14.3-32-32s14.3-32 32-32h48l0-320H64z"]
};
var faProjector = {
  prefix: 'fas',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM281 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L281 39zM585 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L495 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zm-9 119H512c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64V384c0 35.3 28.7 64 64 64l9.9 39.8C77.5 502 90.3 512 105 512h14c14.7 0 27.5-10 31-24.2L160 448H320c26.7 20.1 60 32 96 32c24.4 0 47.5-5.5 68.2-15.2l5.7 23c3.6 14.2 16.4 24.2 31 24.2h14c14.7 0 27.5-10 31-24.2L576 448c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64zM416 224a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFaceSmileWink = {
  prefix: 'fas',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faSmileWink = faFaceSmileWink;
var faTombstoneBlank = {
  prefix: 'fas',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M224 0C118 0 32 86 32 192V416H416V192C416 86 330 0 224 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faTombstoneAlt = faTombstoneBlank;
var faChessKingPiece = {
  prefix: 'fas',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48z"]
};
var faChessKingAlt = faChessKingPiece;
var faCircle6 = {
  prefix: 'fas',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C174.2 224.8 160 255.6 160 288z"]
};
var faLeft = {
  prefix: 'fas',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 96 184 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-184 0 0 96c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160z"]
};
var faArrowAltLeft = faLeft;
var faFileWord = {
  prefix: 'fas',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"]
};
var faFilePowerpoint = {
  prefix: 'fas',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"]
};
var faSquareDown = {
  prefix: 'fas',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm39.1-185.4l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H272V160c0-17.7-14.3-32-32-32H208c-17.7 0-32 14.3-32 32v96H118.3C106 256 96 266 96 278.3c0 6.2 2.6 12.1 7.1 16.3z"]
};
var faArrowAltSquareDown = faSquareDown;
var faObjectsAlignCenterVertical = {
  prefix: 'fas',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", "M64 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48V232h64V144c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v88h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H448v88c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V280H224V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V80z"]
};
var faArrowsLeftRight = {
  prefix: 'fas',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"]
};
var faArrowsH = faArrowsLeftRight;
var faHouseLock = {
  prefix: 'fas',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faCloudArrowDown = {
  prefix: 'fas',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faWreath = {
  prefix: 'fas',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", "M122.2 42.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5v-3.7c0-28.6-23.2-51.8-51.8-51.8c-7.2 0-14.4 1.5-21 4.5L224 381l-55.2-24.5c-6.6-2.9-13.8-4.5-21-4.5C119.2 352 96 375.2 96 403.8v3.7c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6zM203 142.4c-5.7 6-13.6 9.4-21.9 9.1c-16.6-.6-30.2 13-29.6 29.6c.3 8.3-3 16.3-9.1 21.9c-12.1 11.3-12.1 30.6 0 41.9c6 5.7 9.4 13.6 9.1 21.9c-.6 16.6 13 30.2 29.6 29.6c8.3-.3 16.3 3 21.9 9.1c11.3 12.1 30.6 12.1 41.9 0c5.7-6 13.6-9.4 21.9-9.1c16.6 .6 30.2-13 29.6-29.6c-.3-8.3 3-16.3 9.1-21.9c12.1-11.3 12.1-30.6 0-41.9c-6-5.7-9.4-13.6-9.1-21.9c.6-16.6-13-30.2-29.6-29.6c-8.3 .3-16.3-3-21.9-9.1c-11.3-12.1-30.6-12.1-41.9 0zM128 403.8c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8v88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8V403.8z"]
};
var faChildren = {
  prefix: 'fas',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"]
};
var faMeterDroplet = {
  prefix: 'fas',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M256 512c53.7 0 103.5-16.5 144.6-44.7C390 447.2 384 424.3 384 400c0-23.6 5.8-46.9 16.9-67.8l75.3-141.2c4.9-9.2 12.1-16.7 20.6-22.1C461.2 70.4 366.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm120.5 46.1L429.2 347.3C420.5 363.5 416 381.6 416 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7L551.5 206.1c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1z"]
};
var faChalkboard = {
  prefix: 'fas',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faBlackboard = faChalkboard;
var faUserLargeSlash = {
  prefix: 'fas',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"]
};
var faUserAltSlash = faUserLargeSlash;
var faSignalStrong = {
  prefix: 'fas',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", "M480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM352 224c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM192 288c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]
};
var faSignal4 = faSignalStrong;
var faLollipop = {
  prefix: 'fas',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M210.8 334.8C265.3 314.2 304 261.6 304 200v-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64v8c0 53-43 96-96 96h-8C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c41.5 0 79.9-13.1 111.2-35.5L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L348.5 303.2C370.9 271.9 384 233.5 384 192C384 86 298 0 192 0S0 86 0 192z"]
};
var faLollypop = faLollipop;
var faListTree = {
  prefix: 'fas',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M24 48C10.7 48 0 58.7 0 72v48c0 13.3 10.7 24 24 24V256 384c0 30.9 25.1 56 56 56h48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H80c-4.4 0-8-3.6-8-8V280h56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24H72V144c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H24zM160 96c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM288 256c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zm0 160c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z"]
};
var faEnvelopeOpen = {
  prefix: 'fas',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"]
};
var faDrawCircle = {
  prefix: 'fas',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", "M472.1 196.7c-20.8-76-80.7-135.9-156.7-156.7C305.8 16.5 282.8 0 256 0s-49.8 16.5-59.3 39.9c-76 20.8-135.9 80.7-156.7 156.7C16.5 206.2 0 229.2 0 256s16.5 49.8 39.9 59.3c20.8 76 80.7 135.9 156.7 156.7c9.5 23.4 32.5 39.9 59.3 39.9s49.8-16.5 59.3-39.9c76-20.8 135.9-80.7 156.7-156.7c23.4-9.5 39.9-32.5 39.9-59.3s-16.5-49.8-39.9-59.3zM408 206c-14.7 11.7-24 29.8-24 50s9.4 38.3 24 50c-15.8 48.2-53.9 86.2-102 102c-11.7-14.7-29.8-24-50-24s-38.3 9.4-50 24c-48.2-15.8-86.2-53.9-102-102c14.7-11.7 24-29.8 24-50s-9.4-38.3-24-50c15.8-48.2 53.9-86.2 102-102c11.7 14.7 29.8 24 50 24s38.3-9.4 50-24c48.2 15.8 86.2 53.9 102 102z"]
};
var faCatSpace = {
  prefix: 'fas',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", "M576 160c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7zM411.2 89.6L381.8 50.4C401.1 38.7 423.8 32 448 32s46.9 6.7 66.2 18.4L484.8 89.6c-3 4-7.8 6.4-12.8 6.4H424c-5 0-9.8-2.4-12.8-6.4zM480 316.8C553 302 608 237.4 608 160C608 71.6 536.4 0 448 0S288 71.6 288 160c0 11.7 1.3 23.1 3.6 34.1c-54.9 8.1-102.2 39.5-131.6 83.8V192.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1C50.4 94.1 34.4 106.5 32.2 124s10.2 33.5 27.8 35.7l7.9 1c16 2 28 15.6 28 31.8V416c0 53 43 96 96 96H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H280L416 339.2V480c0 17.7 14.3 32 32 32s32-14.3 32-32V316.8zM400 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM231.5 12.3c-2.6-7-12.4-7-15 0L205.8 41.1c-.8 2.2-2.5 3.9-4.7 4.7L172.3 56.5c-7 2.6-7 12.4 0 15l28.8 10.7c2.2 .8 3.9 2.5 4.7 4.7l10.7 28.8c2.6 7 12.4 7 15 0l10.7-28.8c.8-2.2 2.5-3.9 4.7-4.7l28.8-10.7c7-2.6 7-12.4 0-15L246.9 45.8c-2.2-.8-3.9-2.5-4.7-4.7L231.5 12.3z"]
};
var faHandshakeSimpleSlash = {
  prefix: 'fas',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z"]
};
var faHandshakeAltSlash = faHandshakeSimpleSlash;
var faRabbitRunning = {
  prefix: 'fas',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", "M460.7 39.3l-2.2-2.1c-4.7-4.6-11.5-6.4-17.9-4.7s-11.4 6.6-13.1 13l-.8 2.9c-3.3 11.8-5.1 23.7-5.5 35.6c24.3 20.6 42.9 47.8 53.3 78.8c-8.2-1.9-16.5-2.9-25-2.9c-.6 0-1.1 0-1.7 0c-18.4-44-56.5-77.4-103.6-89.3l-3.4-.9c-6.2-1.6-12.9-.6-18.5 2.6c-10.8 6.2-15.6 19.5-11.2 31.1c14.9 39.5 44.3 71.4 81.4 89.7c-3.7 6.6-6.4 14-7.6 21.8L279.7 154.9C248.8 137.3 213.8 128 178.2 128c-32.3 0-62.2 16.8-78.9 44.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1c4.9 17.2 14.5 33.1 28.4 45.9L257.2 431.2C269 442 284.4 448 300.4 448H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352 335.2 320V340.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8c-8.5-2.4-13.4-11.3-11-19.8s11.3-13.4 19.8-11l30.8 8.8c55 15.7 92.8 65.9 92.8 123.1v15.7l56-32.4 6.4-3.7H515.7c33.3 0 60.3-27 60.3-60.3c0-18.1-8.2-35.3-22.2-46.7l-34.6-28.2c-4.6-3.7-9.4-7.1-14.5-10c8.4-49.3-7.8-100-43.9-135.5zm-318.5 382c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9l46-30.7-48.6-44.5-32.9 22zM480 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faRabbitFast = faRabbitRunning;
var faMemoPad = {
  prefix: 'fas',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", "M0 64V96H448V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64zm0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128H0zm96 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16z"]
};
var faMattressPillow = {
  prefix: 'fas',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"]
};
var faAlarmPlus = {
  prefix: 'fas',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 176c-13.3 0-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24z"]
};
var faAlicorn = {
  prefix: 'fas',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M448 160v78.1V240h0c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3 .3 4.6 .3 6.9c0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1H143.1c-13.8 0-26-8.8-30.4-21.9L95.3 437.7c-10.6-31.7-6.5-65.9 10-93.9c7.6-12.9 9.5-29.1 1.2-41.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-44.6 33.2-81.5 76.3-87.2c13-21.4 35.2-36.5 61.1-40c3.8 15.3 9.2 29.8 16.5 43c11.3 20.4 27.4 37.7 49.9 49.8c6.3 3.4 13.1 6.4 20.3 8.8c-16.5-11.4-28.9-26-38.2-42.7C163.8 147.9 160 96.1 160 48c0-5.9 3.2-11.3 8.5-14.1s11.5-2.5 16.4 .8L320 124.8C321.7 55.6 378.4 0 448 0h16 16 64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1c-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faCommentQuestion = {
  prefix: 'fas',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM169.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V234.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faGingerbreadMan = {
  prefix: 'fas',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M296.9 158.5c-5.2 6-1.2 17.5 6.7 17.5H368c35.3 0 64 28.7 64 64s-28.7 64-64 64H347.1c-19 0-29.4 22.2-17.2 36.7L385.2 407c22.6 27.2 19 67.5-8.2 90.1s-67.5 19-90.1-8.2l-45.6-54.8c-9-10.7-25.5-10.7-34.4 0L161.2 489c-22.6 27.2-63 30.8-90.1 8.2s-30.8-63-8.2-90.1l55.2-66.3c12.2-14.6 1.8-36.7-17.2-36.7H80c-35.3 0-64-28.7-64-64s28.7-64 64-64h64.4c7.9 0 11.9-11.5 6.7-17.5C136.7 141.7 128 119.9 128 96c0-53 43-96 96-96s96 43 96 96c0 23.9-8.7 45.7-23.1 62.5zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faGuaraniSign = {
  prefix: 'fas',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"]
};
var faBurgerFries = {
  prefix: 'fas',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", "M183.2 1.7c-5-2.5-10.8-2.2-15.6 .7S160 10.5 160 16V206.7l0 0v63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zM128 14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6L19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1L40.3 85.6zM383.8 98.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2-.3 4-.6 6.1-.7c11-6.5 23.3-12.3 37.1-17.2l13.4-76.1zM276.3 337.2c-11.8-10.4-19.5-25.3-20.2-42.1c-16.6 5.4-37.6 8.8-64.1 8.8c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512H272c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8zm-8.5-82.9c.8-.6 1.6-1.1 2.4-1.7c4.1-6.6 9.4-14 16.1-21.6c.1-.3 .2-.6 .3-.9c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6zm372.2 38c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304z"]
};
var faMugTea = {
  prefix: 'fas',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M144 64v50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6V256c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V189.3c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6V64H384h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H416v32c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h80zM416 256h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H416V256z"]
};
var faBorderTop = {
  prefix: 'fas',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm64 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faArrowsRotate = {
  prefix: 'fas',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faCircleBookOpen = {
  prefix: 'fas',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C225 347.1 207.1 336 184 336zm144 0c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9V185.3c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5V346.1c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C369 347.1 351.1 336 328 336z"]
};
var faBookCircle = faCircleBookOpen;
var faArrowsToDottedLine = {
  prefix: 'fas',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V32zM201.4 329.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faFireExtinguisher = {
  prefix: 'fas',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faGarageOpen = {
  prefix: 'fas',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM194.1 320l-5.2 15c-17.2 9.5-28.9 27.9-28.9 49v96c0 17.7 14.3 32 32 32s32-14.3 32-32V464H416v16c0 17.7 14.3 32 32 32s32-14.3 32-32V384c0-21.1-11.7-39.5-28.9-49l-5.2-15H395l2.8 8H242.2l2.8-8H194.1zM240 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM512 224H128v64H512V224z"]
};
var faShelvesEmpty = {
  prefix: 'fas',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V192 448v32c0 17.7 14.3 32 32 32s32-14.3 32-32H576c0 17.7 14.3 32 32 32s32-14.3 32-32V448 192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V160H64V32zm0 192H576V416H64V224z"]
};
var faCruzeiroSign = {
  prefix: 'fas',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"]
};
var faWatchApple = {
  prefix: 'fas',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M64 48H320c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160V352c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zM192 213.3a42.7 42.7 0 1 1 0 85.3 42.7 42.7 0 1 1 0-85.3zM213.3 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm74.7-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 512H272c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"]
};
var faWatchCalculator = {
  prefix: 'fas',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M64 48H320c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160V352c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zm0 64H304c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm32 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM112 512H272c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"]
};
var faListDropdown = {
  prefix: 'fas',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 192V416H64V192H448zM436.7 96c7.1 0 10.7 8.6 5.7 13.7l-36.7 36.7c-3.1 3.1-8.2 3.1-11.3 0l-36.7-36.7c-5-5-1.5-13.7 5.7-13.7h73.4zM128 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H384c13.3 0 24-10.7 24-24s-10.7-24-24-24H128zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H384c13.3 0 24-10.7 24-24s-10.7-24-24-24H128z"]
};
var faCabinetFiling = {
  prefix: 'fas',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V240H0V64zM0 272H448V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272zM128 128v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm0 256v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384H288v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"]
};
var faBurgerSoda = {
  prefix: 'fas',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H333.4c14-8.2 30.1-15.4 48.6-20.9c1.3-3.5 2-7.2 2-11.1c0-17.7-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3zM40 224L60.3 468c2.1 24.9 22.9 44 47.8 44H272c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c4.2-9.5 13.8-27.8 32.2-47H40zm600 68.3c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304z"]
};
var faSquareArrowUp = {
  prefix: 'fas',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm177 87L353 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 119c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faArrowSquareUp = faSquareArrowUp;
var faGreaterThanEqual = {
  prefix: 'fas',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"]
};
var faPalletBox = {
  prefix: 'fas',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", "M176 0h80V112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM0 352c0-17.7 14.3-32 32-32H96 320 544h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H544 320 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V384H32c-17.7 0-32-14.3-32-32zm128 96H288V384H128v64zm224 0H512V384H352v64z"]
};
var faFaceConfounded = {
  prefix: 'fas',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-161.6 160L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0z"]
};
var faShieldHalved = {
  prefix: 'fas',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"]
};
var faShieldAlt = faShieldHalved;
var faTruckPlow = {
  prefix: 'fas',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M192 96v96H327.5L269.9 96H192zm-64 96V80c0-26.5 21.5-48 48-48h93.9c22.5 0 43.3 11.8 54.9 31.1L402.1 192H448c17.7 0 32 14.3 32 32v64h32V176c0-7.3 2.5-14.3 7-20l64-80c11-13.8 31.2-16 45-5s16 31.2 5 45l-57 71.2V320v36.8L633 428c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-64-80c-4.5-5.7-7-12.7-7-20V352H474.5c3.5 10 5.5 20.8 5.5 32c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H224c-1.9 0-3.8-.2-5.6-.5c3.7 10.2 5.6 21.1 5.6 32.5c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h96zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBookAtlas = {
  prefix: 'fas',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"]
};
var faAtlas = faBookAtlas;
var faVirus = {
  prefix: 'fas',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGridRound2 = {
  prefix: 'fas',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", "M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM288 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]
};
var faCommentMiddleTop = {
  prefix: 'fas',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M188.3 103.3l44.5-89C237.2 5.5 246.2 0 256 0s18.8 5.5 23.2 14.3l44.5 89C432.2 127.5 512 208.2 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-95.8 79.8-176.5 188.3-200.7z"]
};
var faEnvelopeCircleCheck = {
  prefix: 'fas',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faLayerGroup = {
  prefix: 'fas',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"]
};
var faRestroomSimple = {
  prefix: 'fas',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM25.9 233.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-13.3 0-24 10.7-24 24V488c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zM512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H448v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H496.3z"]
};
var faArrowsToDot = {
  prefix: 'fas',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBorderOuter = {
  prefix: 'fas',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 96l0 320H384V96H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faHashtagLock = {
  prefix: 'fas',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32c0 .4 0 .8 0 1.1c-24.1 3.5-45.8 14.6-62.4 30.9H347.1L325.8 320h2.8c-5.4 9.4-8.6 20.3-8.6 32v32h-4.9l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1zM464 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faClockTwoThirty = {
  prefix: 'fas',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V256c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faArchway = {
  prefix: 'fas',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"]
};
var faHeartCircleCheck = {
  prefix: 'fas',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHouseChimneyCrack = {
  prefix: 'fas',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"]
};
var faHouseDamage = faHouseChimneyCrack;
var faFileZipper = {
  prefix: 'fas',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faFileArchive = faFileZipper;
var faHeartHalf = {
  prefix: 'fas',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M256 96L244 84l0 0c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9l0-50.7 0-265.4V96z"]
};
var faCommentCheck = {
  prefix: 'fas',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM369 193L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faSquare = {
  prefix: 'fas',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
};
var faMemo = {
  prefix: 'fas',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faMartiniGlassEmpty = {
  prefix: 'fas',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCouch = {
  prefix: 'fas',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"]
};
var faCediSign = {
  prefix: 'fas',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"]
};
var faItalic = {
  prefix: 'fas',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"]
};
var faGlassCitrus = {
  prefix: 'fas',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", "M448 144c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 78.4-62.6 142.1-140.5 144l6.5-64.6c39.5-4.9 70-38.6 70-79.4zM249.3 224l-.1 1.3-.9-1.3h1zM8.3 138.5C14.3 131.8 23 128 32 128H320c9 0 17.7 3.8 23.7 10.5s9 15.7 8.1 24.7L322.7 454.4C319.5 487.1 291.9 512 259 512H93c-32.9 0-60.4-24.9-63.7-57.6L.2 163.2c-.9-9 2-18 8.1-24.7zM67.4 192l6.4 64H278.2l6.4-64H67.4z"]
};
var faCalendarLinesPen = {
  prefix: 'fas',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448v43.6L289.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H48c-26.5 0-48-21.5-48-48V192zm120 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 392c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faChurch = {
  prefix: 'fas',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"]
};
var faPersonSnowmobiling = {
  prefix: 'fas',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", "M240 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM373.5 85.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l37.4 74.7L360 192H304l-61.7-55.6c-11.8-10.6-27-16.4-42.8-16.4h-.9c-23.7 0-45.5 13.1-56.6 34.1l-35.3 66.6c-11.4 21.6-9.4 47.8 5.3 67.4H99.8c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.5 5-3.6 10.2-3.4 15.2c4-.6 8.1-.9 12.3-.9H272c26.2 0 49.4 12.6 64 32H450l36 48H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H576c6.4 0 12.5-2.5 17-7l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33 33H546l-46-61.3 68.9-45.9c4.5-3 7.1-8 7.1-13.3V265.9c0-6.1-3.4-11.6-8.8-14.3L419.8 177.9 373.5 85.3zM298.5 256H312l-24 32H264l-72-32 32-48 29.3 29.3c12 12 28.3 18.7 45.3 18.7zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48H272c26.5 0 48-21.5 48-48s-21.5-48-48-48H48z"]
};
var faSnowmobile = faPersonSnowmobiling;
var faFaceHushed = {
  prefix: 'fas',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCommentsDollar = {
  prefix: 'fas',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"]
};
var faPickaxe = {
  prefix: 'fas',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", "M462.4 373.5l0 0-.1-.2-.3-.8c-.3-.7-.7-1.8-1.3-3.3c-1.2-2.9-3-7.2-5.5-12.7c-5-11-12.6-26.7-23.1-45.3c-21-37.3-53.6-86-99.5-132s-94.7-78.5-132-99.5c-18.6-10.5-34.3-18.1-45.3-23.1c-5.5-2.5-9.8-4.3-12.7-5.5c-1.4-.6-2.5-1-3.3-1.3l-.8-.3-.2-.1 0 0 0 0c-6.2-2.3-10.4-8.2-10.5-14.8s3.9-12.6 10-15.1C169.5 7 204 0 240 0c59.6 0 114.7 19.2 159.5 51.6l9.4-9.8c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.8 9.4C492.8 157.3 512 212.4 512 272c0 36-7 70.5-19.8 102c-2.5 6.1-8.5 10.1-15.1 10s-12.5-4.3-14.8-10.5l0 0zM9.4 502.6C-3 490.3-3.1 470.4 8.9 457.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4z"]
};
var faLinkSimpleSlash = {
  prefix: 'fas',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96c0 43.3-28.6 79.8-67.9 91.8L399.7 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H318.1l-81.7-64H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zM121 191.4L70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-53 0-96-43-96-96c0-24.9 9.5-47.6 25-64.6z"]
};
var faDemocrat = {
  prefix: 'fas',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"]
};
var faFaceConfused = {
  prefix: 'fas',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.1 395.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16H341c-61.8 0-121.7 21-169.9 59.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPinball = {
  prefix: 'fas',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm22.1 254.4c14.9 4.8 30.7-1.8 37.9-15c7.4-13.5 4.2-30.8-8.4-40.6l-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faZ = {
  prefix: 'fas',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"]
};
var faPersonSkiing = {
  prefix: 'fas',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"]
};
var faSkiing = faPersonSkiing;
var faDeer = {
  prefix: 'fas',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M240 0c8.8 0 16 7.2 16 16V40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 8.6-1.9 16.7-5.4 24h30.6H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16V40c0 21.7-12.3 40.4-30.3 49.8c.6 .5 1.1 1.1 1.7 1.6l55.3 55.3c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3H416h-5.3L384 304v64V480c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V368H251.7c-28.8 0-55.3-9.8-76.3-26.4c-2.1 16.9-9.8 32.6-21.9 44.8L142.9 397c-4.6 4.6-6.2 11.5-4 17.7l19.3 54.7c7.3 20.8-8.1 42.6-30.2 42.6H94.1c-13.6 0-25.7-8.6-30.2-21.4l-15.5-44c-11.4-32.4-7.4-67.8 10-96.3C65 339.4 65 324.9 56 315.9c-3-3-5.7-6.1-8.1-9.5c-1.3 12.9-12.7 22.5-25.7 21.5C8.9 326.9-.9 315.4 .1 302.2L2.4 272c4.2-54.2 49.3-96 103.7-96h7.9H128h64c.6 0 1.2 0 1.7 0c.8 0 1.7 0 2.5 0H302.4l9.6-32H274c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96H296h-8-8c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zM400 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faInputPipe = {
  prefix: 'fas',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", "M64 128V384H576V128H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm144 56V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faRoadLock = {
  prefix: 'fas',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faA = {
  prefix: 'fas',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"]
};
var faBookmarkSlash = {
  prefix: 'fas',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48V75L38.8 5.1zM128 487.7c0 13.4 10.9 24.3 24.3 24.3c5 0 9.9-1.5 14-4.4L320 400 473.7 507.6c4.1 2.9 9 4.4 14 4.4c9.9 0 18.4-5.9 22.2-14.3L128 196.9V487.7z"]
};
var faTemperatureArrowDown = {
  prefix: 'fas',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"]
};
var faTemperatureDown = faTemperatureArrowDown;
var faMace = {
  prefix: 'fas',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", "M244.8 95l28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1C301 443.6 294.9 448 288 448s-13-4.4-15.2-10.9l-28-84.1c-9.8-3.3-19-7.6-27.7-12.9L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L171.9 294.9c-5.3-8.6-9.6-17.9-12.9-27.7l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faFeatherPointed = {
  prefix: 'fas',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"]
};
var faFeatherAlt = faFeatherPointed;
var faSausage = {
  prefix: 'fas',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M320 160c0-42 26.9-77.7 64.5-90.7L369.2 27.4c-.8-2.2-1.2-4.6-1.2-7C368 9.1 377.1 0 388.4 0h55.2C454.9 0 464 9.1 464 20.4c0 2.4-.4 4.7-1.2 7L447.5 69.3C485.1 82.3 512 118 512 160c0 194.4-157.6 352-352 352c-42 0-77.7-26.9-90.7-64.5L27.4 462.8c-2.2 .8-4.6 1.2-7 1.2C9.1 464 0 454.9 0 443.6V388.4C0 377.1 9.1 368 20.4 368c2.4 0 4.7 .4 7 1.2l41.9 15.2C82.3 346.9 118 320 160 320c88.4 0 160-71.6 160-160zm80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 114.9-93.1 208-208 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240z"]
};
var faTrashCanClock = {
  prefix: 'fas',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416v64.7c-29.3 2.6-56.6 12.5-80 27.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v39.2c-29.8 31.5-48 74-48 120.8c0 59.5 29.6 112.1 74.8 144H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm64 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"]
};
var faP = {
  prefix: 'fas',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"]
};
var faBroomWide = {
  prefix: 'fas',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z"]
};
var faSnowflake = {
  prefix: 'fas',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"]
};
var faStomach = {
  prefix: 'fas',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96c0 70.7 57.3 128 128 128v64c0 35.3-28.7 64-64 64H128C57.3 352 0 409.3 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0-26.5 21.5-48 48-48c24.6 0 36 9.5 58.2 28.2l0 0c1.7 1.4 3.4 2.9 5.3 4.4c12.6 10.5 28.4 22.9 49.6 32.2C246.5 506.2 272 512 304 512c114.9 0 208-93.1 208-208V224c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64H256c-35.3 0-64-28.7-64-64V32zM445.1 332.7c-7.2 1.9-14.6 3.3-21.1 3.3c-16.8 .2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9 .1-17.1 2.1-25.6 4.6c1.1-6.7 1.6-13.6 1.6-20.6V224c0-35.3 28.7-64 64-64s64 28.7 64 64v80c0 9.8-1 19.4-2.9 28.7z"]
};
var faNewspaper = {
  prefix: 'fas',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faRectangleAd = {
  prefix: 'fas',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"]
};
var faAd = faRectangleAd;
var faGuitarElectric = {
  prefix: 'fas',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M352 81.1v33.6L243.8 223c-14.6-26.1-5.5-50.4 3.2-64.7c4.8-7.9 4.8-18.7-1.7-25.3s-17.1-6.6-23.6 0l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5l0 0 0 0c-1.2 2.6-2.3 5.1-3.5 7.6c-3.5 7.3-8.9 15.7-17.1 24c-24.7 25-64.7 40.2-89.6 47.7c-14.5 4.4-28.1 11.7-38.7 22.4c-30 30.4-30 79.6 0 110l79.9 80.8c30 30.4 78.7 30.4 108.8 0c10.7-10.8 17.9-24.5 22.2-39.2c7.5-25.2 22.5-65.6 47.2-90.6c10-10.1 20-16 28.3-19.3l1.1-.5 0 0c11.3-4.6 23-9.4 31.6-18l21.6-21.8c6.5-6.6 6.5-17.3 0-23.8s-17.3-6.6-25.8-3c-11.1 4.7-28 7.3-48.3-4.7L461.3 96H464c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.1c-9.7 0-19.2 2.9-27.3 8.3L366.2 54.5C357.3 60.4 352 70.4 352 81.1zM195.3 268.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-64 64l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faArrowTurnDownRight = {
  prefix: 'fas',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V224c0 53 43 96 96 96H402.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256H96c-17.7 0-32-14.3-32-32V64z"]
};
var faMoonCloud = {
  prefix: 'fas',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M479.5 32c-118.2 0-214.9 92-223 208.3C310 244.7 352 289.4 352 344c0 27.9-11 53.3-29 72c40.3 39.6 95.5 64 156.4 64c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.2-.5-12.6-.8-19-.8zM64 416H248c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64z"]
};
var faBreadSliceButter = {
  prefix: 'fas',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zm182.6 73.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-50.7 50.7z"]
};
var faCircleArrowRight = {
  prefix: 'fas',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"]
};
var faArrowCircleRight = faCircleArrowRight;
var faUserGroupCrown = {
  prefix: 'fas',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", "M144 144V128H304v16c0 44.2-35.8 80-80 80s-80-35.8-80-80zm-.1-124.9c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5C121.5 1.2 118 0 114.4 0H112c-8.8 0-16 7.2-16 16V39v3.2 .1V144c0 70.7 57.3 128 128 128s128-57.3 128-128V42.3v-.1V39 16c0-8.8-7.2-16-16-16h-2.4c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3 .2-.6 .4-.8 .6l-.1 .1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4L178.9 21.2c-11 6.3-24.7 5.5-34.9-2l-.1-.1zM168 304C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168zm264-48c61.9 0 112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8V144c0 5.4-.3 10.7-.8 16c-2.4 24.3-10.3 47.1-22.4 67c-.5 .8-1 1.6-1.4 2.3C379 245.9 404.3 256 432 256zm39.4 256H609.3c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320H417.3c-2.4 0-4.8 .1-7.1 .2C452.9 356.8 480 411.3 480 472v8c0 11.7-3.1 22.6-8.6 32z"]
};
var faUsersCrown = faUserGroupCrown;
var faCircleI = {
  prefix: 'fas',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V336h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48V176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faToiletPaperCheck = {
  prefix: 'fas',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM291.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 225.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72z"]
};
var faFilterCircleXmark = {
  prefix: 'fas',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faLocust = {
  prefix: 'fas',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSort = {
  prefix: 'fas',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"]
};
var faUnsorted = faSort;
var faListOl = {
  prefix: 'fas',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faChartWaterfall = {
  prefix: 'fas',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64-96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faSparkle = {
  prefix: 'fas',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", "M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9L142.7 174.7 13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L305.3 174.7 245.8 45.9z"]
};
var faFaceParty = {
  prefix: 'fas',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M531.7 400C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176H560c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48H416c-1 0-2 0-3 .1c-1.2-2.3-2.7-4.4-4.3-6.4c-4.3-5.2-10.1-9.7-16.7-13.4C378.7 276.9 361.4 272 344 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c1.6-2 3.1-4.1 4.3-6.4c1 .1 2 .1 3 .1H531.7zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm89.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM512 256c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H400c-8.8 0-16-7.2-16-16s7.2-16 16-16H592c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H560c-26.5 0-48-21.5-48-48zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2z"]
};
var faKidneys = {
  prefix: 'fas',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M152 0c-21.5 0-45.5 6.3-64.3 23.8C56.4 52.8 0 119.6 0 224c0 24.9 3.5 54.7 7.1 79.1c7.1 48 48.8 80.9 95.3 80.9c58.4 0 104-50.4 98.2-108.5l-4.1-41.2c-2-20.1 4.5-40.1 17.9-55.1l18.2-20.5c15.2-17.1 23.5-39.1 23.5-61.9c0-31.2-15.6-60.2-41.5-77.5l-3.4-2.3C194.5 5.9 175.1 0 155.2 0H152zM488 0h-3.2c-19.9 0-39.4 5.9-55.9 16.9l-3.4 2.3C399.6 36.5 384 65.6 384 96.7c0 22.8 8.4 44.8 23.5 61.9l18.2 20.5c13.4 15.1 19.9 35.1 17.9 55.1l-4.1 41.2C433.7 333.6 479.3 384 537.7 384c46.5 0 88.2-32.9 95.3-80.9c3.6-24.4 7.1-54.2 7.1-79.1c0-104.4-56.4-171.2-87.7-200.2C533.5 6.3 509.5 0 488 0zM228.2 231.1l1.9 18.8 21.5 10.7c2.7 1.4 4.4 4.1 4.4 7.2V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-21.2-12-40.6-31-50.1l-34.8-17.4-.1 .1c-7.5 8.4-11.1 19.5-10 30.7zm173.6-30.7l-.1-.1L367 217.7c-19 9.5-31 28.9-31 50.1V488c0 13.3 10.7 24 24 24s24-10.7 24-24V267.8c0-3 1.7-5.8 4.4-7.2l21.5-10.7 1.9-18.8c1.1-11.2-2.5-22.3-10-30.7z"]
};
var faWifiExclamation = {
  prefix: 'fas',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", "M320 32c-27.2 0-48.7 23.1-46.8 50.2l14.9 208C289.3 307 303.2 320 320 320s30.7-13 31.9-29.7l14.9-208C368.7 55.1 347.2 32 320 32zM241.3 84.5c-1.2-17.4 3.3-33.9 11.9-47.6C159.4 51 75.1 94.1 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c51.3-49.2 116.2-84.3 188.5-99.1l-1.4-19.3zm157.4 0l-1.4 19.3c72.3 14.8 137.2 49.9 188.5 99.1c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C564.9 94.1 480.6 51 386.8 37c8.6 13.7 13.1 30.1 11.9 47.6zM129.5 264c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c23.6-20.8 51.6-36.7 82.4-46.2l-4.7-65.1C204.4 212 163.4 234.1 129.5 264zm260.9-63.3l-4.6 65.1c30.8 9.4 58.8 25.4 82.4 46.2c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2c-33.9-29.9-74.9-52-120.1-63.3zM384 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faChartNetwork = {
  prefix: 'fas',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M288 64c0 13.7-4.3 26.3-11.6 36.7l29.2 62.5c9.8-2.1 20-3.2 30.4-3.2c36.1 0 69 13.3 94.3 35.2L512.4 135c-.2-2.3-.4-4.6-.4-7c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.2 0-17.9-1.9-25.8-5.4l-82 60.2c7.6 17.5 11.8 36.9 11.8 57.2c0 15.6-2.5 30.7-7.1 44.8l72 43.2c9.2-5.1 19.8-8 31.1-8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64l0-1.1-72.1-43.3C413.7 431 376.8 448 336 448c-68.5 0-125.9-47.9-140.4-112H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c23.7 0 44.4 12.9 55.4 32h76.1c7.5-33 26.3-61.6 52.1-81.7l-29.2-62.5C185.7 124.9 160 97.5 160 64c0-35.3 28.7-64 64-64s64 28.7 64 64zm48 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPersonDressBurst = {
  prefix: 'fas',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"]
};
var faDiceD4 = {
  prefix: 'fas',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", "M228.8 .7C235.5 2.8 240 9 240 16V496c0 6.3-3.7 12-9.4 14.6s-12.5 1.6-17.2-2.6L5.4 324c-6.1-5.4-7.2-14.5-2.5-21.2l208-296c4-5.7 11.3-8.2 17.9-6.1zm54.4 0c6.7-2.1 13.9 .3 17.9 6.1l208 296c4.7 6.7 3.6 15.8-2.5 21.2l-208 184c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V16c0-7 4.5-13.2 11.2-15.3z"]
};
var faMoneyCheckDollar = {
  prefix: 'fas',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faVectorSquare = {
  prefix: 'fas',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"]
};
var faBreadSlice = {
  prefix: 'fas',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"]
};
var faLanguage = {
  prefix: 'fas',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"]
};
var faWheatAwnSlash = {
  prefix: 'fas',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L569 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L473 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L393.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L447 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88z"]
};
var faFaceKissWinkHeart = {
  prefix: 'fas',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faDagger = {
  prefix: 'fas',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H48c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32H192h98.7c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48s-21.5-48-48-48H224V32zM128 224v24V414.8c0 10.5 2.9 20.8 8.5 29.7l35.1 56.2c4.4 7 12.1 11.3 20.4 11.3s16-4.3 20.4-11.3l35.1-56.2c5.6-8.9 8.5-19.2 8.5-29.7V248 224H232 152 128z"]
};
var faPodium = {
  prefix: 'fas',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M182.4 72c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H224c-17.8 0-33.3 9.7-41.6 24H168c-48.6 0-88 39.4-88 88v32H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H128V112c0-22.1 17.9-40 40-40h14.4zM48 224L73.7 455.1c3.6 32.4 31 56.9 63.6 56.9H310.7c32.6 0 60-24.5 63.6-56.9L400 224H48z"]
};
var faMemoCircleCheck = {
  prefix: 'fas',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm208 48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
var faRouteHighway = {
  prefix: 'fas',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M240.5 4.6c-10.1-6.1-22.8-6.1-32.9 0l-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7c-15.2-7.6-33.7-2-42.1 12.7l-32 56c-5.3 9.3-5.6 20.6-.8 30.2l16.2 32.5C27.8 159.1 32 177 32 195.2c0 14.9-2.8 29.7-8.4 43.6L9.3 274.5C3.2 289.9 0 306.4 0 323c0 49.5 28 94.8 72.2 116.9l137.4 68.7c9 4.5 19.6 4.5 28.6 0l137.4-68.7C420 417.8 448 372.5 448 323c0-16.6-3.2-33.1-9.3-48.5l-14.3-35.7c-5.5-13.9-8.4-28.6-8.4-43.6c0-18.2 4.2-36.2 12.4-52.5l16.2-32.5c4.8-9.6 4.5-20.9-.8-30.2l-32-56c-8.4-14.7-26.9-20.3-42.1-12.7l-1.4 .7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8zM96 192H352c0 1.1 0 2.2 0 3.2c0 23.1 4.4 45.9 13 67.3l14.3 35.7c3.2 7.9 4.8 16.3 4.8 24.8c0 25.3-14.3 48.4-36.9 59.7L224 444.2 100.9 382.7C78.3 371.4 64 348.3 64 323c0-8.5 1.6-16.9 4.8-24.8L83 262.6c8.6-21.4 13-44.3 13-67.3c0-1.1 0-2.2 0-3.2z"]
};
var faDownToLine = {
  prefix: 'fas',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M342.1 249.9L219.3 372.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L41.9 249.9c-6.4-6.4-9.9-15-9.9-24C32 207.2 47.2 192 65.9 192l62.1 0 0-128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V192l62.1 0c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24zM32 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faArrowAltToBottom = faDownToLine;
var faFilter = {
  prefix: 'fas',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"]
};
var faSquareG = {
  prefix: 'fas',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H248c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z"]
};
var faCirclePhone = {
  prefix: 'fas',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.7 128.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L200 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C368.9 378 361 384 352 384c-123.7 0-224-100.3-224-224c0-9 6-16.9 14.7-19.3l44-12z"]
};
var faPhoneCircle = faCirclePhone;
var faClipboardPrescription = {
  prefix: 'fas',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"]
};
var faUserNurseHair = {
  prefix: 'fas',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v40c0 70.7 57.3 128 128 128s128-57.3 128-128V136c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160h8zM141.3 336.2c-7.6-8.1-18.9-11.9-29.4-8.5C47 348.5 0 409.4 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-71.8-47-132.7-111.9-153.6c-10.5-3.4-21.8 .4-29.4 8.5l-71 75.5c-6.3 6.7-17 6.7-23.3 0l-71-75.5zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8V64h16c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V96H192c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"]
};
var faQuestion = {
  prefix: 'fas',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faFileSignature = {
  prefix: 'fas',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"]
};
var faToggleLargeOn = {
  prefix: 'fas',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
var faUpDownLeftRight = {
  prefix: 'fas',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"]
};
var faArrowsAlt = faUpDownLeftRight;
var faDryerHeat = {
  prefix: 'fas',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM156.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L177.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm102.6 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L257.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7z"]
};
var faDryerAlt = faDryerHeat;
var faHouseChimneyUser = {
  prefix: 'fas',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"]
};
var faHandHoldingHeart = {
  prefix: 'fas',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faArrowUpSmallBig = {
  prefix: 'fas',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM320 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80zm48 176H496c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48z"]
};
var faSortSizeUpAlt = faArrowUpSmallBig;
var faTrainTrack = {
  prefix: 'fas',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", "M222.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L147.6 96H112c-17.7 0-32 14.3-32 32s14.3 32 32 32h14.3l-21.3 64H72c-17.7 0-32 14.3-32 32s14.3 32 32 32H83.6L62.3 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h8.9l-7.3 21.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l14-42.1H467.6l14 42.1c5.6 16.8 23.7 25.8 40.5 20.2s25.8-23.7 20.2-40.5L535.1 416H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H513.7l-21.3-64H504c17.7 0 32-14.3 32-32s-14.3-32-32-32H471.1l-21.3-64H464c17.7 0 32-14.3 32-32s-14.3-32-32-32H428.4l-14-42.1c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5L360.9 96H215.1l7.3-21.9zM193.7 160H382.3l21.3 64H172.4l21.3-64zM446.3 352H129.7l21.3-64H424.9l21.3 64z"]
};
var faPuzzlePiece = {
  prefix: 'fas',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8v0c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320v0c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256v0C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2v0z"]
};
var faMoneyCheck = {
  prefix: 'fas',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"]
};
var faStarHalfStroke = {
  prefix: 'fas',
  iconName: 'star-half-stroke',
  icon: [640, 512, ["star-half-alt"], "f5c0", "M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"]
};
var faStarHalfAlt = faStarHalfStroke;
var faFileExclamation = {
  prefix: 'fas',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM192 192c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCode = {
  prefix: 'fas',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
};
var faWhiskeyGlass = {
  prefix: 'fas',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"]
};
var faGlassWhiskey = faWhiskeyGlass;
var faMoonStars = {
  prefix: 'fas',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M284.8 99.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11zm119 211.6c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM191.8 128C85.8 128 0 214.1 0 320.2S85.8 512.4 191.8 512.4c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z"]
};
var faBuildingCircleExclamation = {
  prefix: 'fas',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faClothesHanger = {
  prefix: 'fas',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", "M209.8 84.8C222.3 35 267.1 0 318.5 0H320c61.9 0 112 50.1 112 112v6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8L608.2 377.2C628.1 391 640 413.7 640 438c0 40.9-33.1 74-74 74H74c-40.9 0-74-33.1-74-74c0-24.2 11.9-47 31.8-60.8L301.6 189.8l.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3V112c0-26.5-21.5-48-48-48h-1.5c-22 0-41.2 15-46.6 36.4l-.9 3.4c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l.9-3.4zM320 255L68.3 429.7c-2.7 1.9-4.3 4.9-4.3 8.2c0 5.5 4.5 10 10 10H566c5.5 0 10-4.5 10-10c0-3.3-1.6-6.4-4.3-8.2L320 255z"]
};
var faMobileNotch = {
  prefix: 'fas',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M128 64V80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V64h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM96 0C51.8 0 16 35.8 16 80V432c0 44.2 35.8 80 80 80H288c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H96zm32 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16z"]
};
var faMobileIphone = faMobileNotch;
var faMagnifyingGlassChart = {
  prefix: 'fas',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faArrowUpRightFromSquare = {
  prefix: 'fas',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faExternalLink = faArrowUpRightFromSquare;
var faCubesStacked = {
  prefix: 'fas',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"]
};
var faImagesUser = {
  prefix: 'fas',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm240 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM269.7 256H402.3c25.2 0 45.7 20.5 45.7 45.7c0 10.1-8.2 18.3-18.3 18.3H242.3c-10.1 0-18.3-8.2-18.3-18.3c0-25.2 20.5-45.7 45.7-45.7zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faWonSign = {
  prefix: 'fas',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faImagePolaroidUser = {
  prefix: 'fas',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32V320c0 17.7 14.3 32 32 32h16c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h16c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm96 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faVirusCovid = {
  prefix: 'fas',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faSquareEllipsis = {
  prefix: 'fas',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faPie = {
  prefix: 'fas',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M544 240c-7.6 0-14.3-4.9-17-12C490 132.1 397 64 288 64S86 132.1 49 228c-2.7 7.1-9.4 12-17 12c-17.7 0-32 14.3-32 32c0 17.2 13.6 31.3 30.7 32c17.7-.5 35-7 48.7-14.2c7-3.6 12.7-7.3 16.7-10c2-1.4 3.5-2.5 4.5-3.2c.5-.4 .9-.7 1.1-.8l.2-.2 0 0 20.7 .4 0 0 .2 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c6.1-5.4 15.2-5.4 21.2 0l0 0 .1 .1c.2 .2 .5 .4 .9 .8c.9 .7 2.2 1.8 4.1 3.1c3.7 2.6 9.1 6.2 16.1 9.8c14 7.2 33.4 14.2 56.1 14.2s42.2-7 56.1-14.2c7-3.6 12.4-7.2 16.1-9.8c1.8-1.3 3.2-2.4 4.1-3.1c.4-.4 .7-.6 .9-.8l.1-.1c5.9-5.2 14.6-5.4 20.7-.4l0 0 0 0 0 0 0 0 0 0 0 0 .2 .2c.2 .2 .6 .5 1.1 .8c1 .7 2.5 1.9 4.5 3.2c4 2.7 9.7 6.4 16.7 10c13.7 7.2 31.1 13.7 48.7 14.2c17.1-.7 30.7-14.7 30.7-32c0-17.7-14.3-32-32-32zM122.6 276c-5.9-5.2-14.6-5.4-20.7-.4l0 0 20.7 .4s0 0 0 0zM81.4 404.2c8.7 26.1 33.2 43.8 60.7 43.8H433.9c27.5 0 52-17.6 60.7-43.8l24-71.9c-14.2-3.5-26.8-9-36.8-14.2c-7-3.7-12.9-7.3-17.5-10.3c-4.5 3.1-10.3 6.7-17.4 10.4C429.8 327 405.2 336 376 336s-53.8-9-70.8-17.8c-6.9-3.6-12.7-7.2-17.2-10.2c-4.5 3-10.2 6.6-17.2 10.2C253.8 327 229.2 336 200 336s-53.8-9-70.8-17.8c-7.1-3.6-12.9-7.3-17.4-10.4c-4.6 3-10.5 6.7-17.5 10.3c-10 5.2-22.7 10.7-36.8 14.2l24 71.9zM206.3 151.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3l16 32c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessKnightPiece = {
  prefix: 'fas',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", "M57.6 102.4l-6.9 6.9c-12 12-18.7 28.3-18.7 45.3v81.2c0 10.7 5.3 20.7 14.2 26.6l3.5 2.4c12.7 8.5 29.1 9.5 42.8 2.7c2.3-1.1 4.5-2.5 6.5-4l38.8-29.1c5.5-4.1 13.1-4.1 18.6 0c8.2 6.1 8.3 18.4 .2 24.7L81 317c-20.8 16-33 40.7-33 67H272l26.9-107.6c3.4-13.6 5.1-27.5 5.1-41.5c0-94.4-76.5-171-171-171H47.8C39.1 64 32 71.1 32 79.8c0 6 3.4 11.5 8.7 14.2l16.9 8.4zm19.2 54.4a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L272 416H48z"]
};
var faChessKnightAlt = faChessKnightPiece;
var faAustralSign = {
  prefix: 'fas',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"]
};
var faCloudPlus = {
  prefix: 'fas',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H232c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faF = {
  prefix: 'fas',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"]
};
var faLeaf = {
  prefix: 'fas',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"]
};
var faBedBunk = {
  prefix: 'fas',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H256 512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448 416 288 256 192 160 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32v96H64V32zM512 256H256c-17.7 0-32 14.3-32 32v96H64V192H256 512v64zM192 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faRoad = {
  prefix: 'fas',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faTaxi = {
  prefix: 'fas',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCab = faTaxi;
var faPersonCirclePlus = {
  prefix: 'fas',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faChartPie = {
  prefix: 'fas',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"]
};
var faPieChart = faChartPie;
var faBoltLightning = {
  prefix: 'fas',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"]
};
var faClockEight = {
  prefix: 'fas',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSackXmark = {
  prefix: 'fas',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"]
};
var faFileExcel = {
  prefix: 'fas',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"]
};
var faFileContract = {
  prefix: 'fas',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"]
};
var faFishFins = {
  prefix: 'fas',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCircleQ = {
  prefix: 'fas',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
var faBuildingFlag = {
  prefix: 'fas',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"]
};
var faFaceGrinBeam = {
  prefix: 'fas',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
  prefix: 'fas',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"]
};
var faFaceDisguise = {
  prefix: 'fas',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M256 512c141.4 0 256-114.6 256-256c0-16.4-1.5-32.5-4.5-48H440c0 50.1-38.4 91.2-87.3 95.6c9.6 7.9 15.3 19.7 15.3 32.4c0 15.9-9 30.4-23.1 37.5L364.5 398c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4 .7-4.8 1.3-7.2 1.8V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V406.8c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6L172.5 418c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208H4.5C1.5 223.5 0 239.6 0 256C0 397.4 114.6 512 256 512zm61.9-245.5c7.9 3.5 16.8 5.5 26.1 5.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3c5.4 3.6 10.1 8.4 13.5 14.1l21.4 35.7c1.1 .6 1.9 1 2.6 1.3zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c9.3 0 18.1-2 26.1-5.5c.6-.3 1.5-.7 2.6-1.3L218 229.5c3.5-5.8 8.1-10.6 13.5-14.1c.3-2.4 .4-4.9 .4-7.3zM12.7 176H77.5c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9V96c0-8.8 7.2-16 16-16s16 7.2 16 16v16.3c4.4 .4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2V96c0-8.8 7.2-16 16-16s16 7.2 16 16v19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5h64.7C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176zM256 240c-4.3 0-8.3 2.3-10.5 6l-39.8 66.3-2.4 4-4.2 2.1-17.7 8.8c-3.4 1.7-5.5 5.1-5.5 8.8s2.1 7.2 5.5 8.8l53.1 26.5c13.5 6.8 29.4 6.8 42.9 0l53.1-26.5c3.4-1.7 5.5-5.1 5.5-8.8s-2.1-7.2-5.5-8.8l-17.7-8.8-4.2-2.1-2.4-4L266.5 246c-2.2-3.7-6.2-6-10.5-6zM144 216a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCircleArrowDownRight = {
  prefix: 'fas',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM192 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24H192z"]
};
var faAlien8bit = {
  prefix: 'fas',
  iconName: 'alien-8bit',
  icon: [640, 512, [128126, "alien-monster"], "f8f6", "M128 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48c8.8 0 16 7.2 16 16v48H384V80c0-8.8 7.2-16 16-16h48V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H448v32 32h48c8.8 0 16 7.2 16 16v48h32V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16H544v80c0 8.8-7.2 16-16 16H480v80c0 8.8-7.2 16-16 16H416 368c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16h48V384H224v32h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224 176c-8.8 0-16-7.2-16-16V384H112c-8.8 0-16-7.2-16-16V288H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v80h32V176c0-8.8 7.2-16 16-16h48V128 96H144c-8.8 0-16-7.2-16-16V48zm64 192v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm192 0v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16z"]
};
var faAlienMonster = faAlien8bit;
var faHandPointRibbon = {
  prefix: 'fas',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H11.8C5.3 128 0 122.7 0 116.2c0-3.9 1.9-7.5 5.1-9.7L43.6 80 5.1 53.5C1.9 51.3 0 47.7 0 43.8C0 37.3 5.3 32 11.8 32L64 32zm0 208V160h64v80H64zm192-48c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H194.3c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"]
};
var faPoop = {
  prefix: 'fas',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"]
};
var faObjectExclude = {
  prefix: 'fas',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M0 64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V352H64c-35.3 0-64-28.7-64-64V64zM320 192H192V320H320V192z"]
};
var faTelescope = {
  prefix: 'fas',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L375.7 40zM11.8 343.6C.4 350.3-3.6 364.9 3.1 376.4l25.9 44.9c6.6 11.5 21.3 15.4 32.8 8.8l44.1-25.5 .8 1.4c8.6 15 27.6 20.4 42.8 12.2l88.4-47.4L193.8 478.9c-5 12.3 .9 26.3 13.2 31.3s26.3-.9 31.3-13.2L304 335.6l65.8 161.4c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3L346.4 312.5l86.1-46.2-.2-.3-96-166.3c-1-1.8-2-3.6-2.8-5.4L62.4 268.4c-14.4 9.2-19 28.1-10.4 42.9l4 6.9L11.8 343.6z"]
};
var faLocationPin = {
  prefix: 'fas',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"]
};
var faMapMarker = faLocationPin;
var faSquareList = {
  prefix: 'fas',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H192z"]
};
var faKaaba = {
  prefix: 'fas',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"]
};
var faToiletPaper = {
  prefix: 'fas',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faHelmetSafety = {
  prefix: 'fas',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faCommentCode = {
  prefix: 'fas',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM217 193l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM329 159l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faSimCards = {
  prefix: 'fas',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V141.3c0-17-6.7-33.3-18.7-45.3L352 18.7C340 6.7 323.7 0 306.7 0H160zm48 144v48H160V176c0-17.7 14.3-32 32-32h16zm-48 80h64 96 64v48H320 224 160V224zm224-32H336V144h16c17.7 0 32 14.3 32 32v16zm-80-48v48H240V144h64zm80 160v16c0 17.7-14.3 32-32 32H336V304h48zm-80 48H240V304h64v48zm-96 0H192c-17.7 0-32-14.3-32-32V304h48v48zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faStarship = {
  prefix: 'fas',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M448 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 256a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm32-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM188.9 205.4L137 160h71c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128s14.3 32 32 32H64.1l65.5 57.3-2.2 .4C109.1 221.4 96 237.4 96 256s13.1 34.6 31.4 38.3l2.2 .4L64.1 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c17.7 0 32-14.3 32-32s-14.3-32-32-32H137l51.9-45.4 43 8.6c-5.2-18.9-7.9-38.7-7.9-59.2s2.7-40.3 7.9-59.2l-43 8.6z"]
};
var faEject = {
  prefix: 'fas',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"]
};
var faCircleRight = {
  prefix: 'fas',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"]
};
var faArrowAltCircleRight = faCircleRight;
var faPlaneCircleCheck = {
  prefix: 'fas',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faSeal = {
  prefix: 'fas',
  iconName: 'seal',
  icon: [512, 512, [], "e241", "M289.9 18.4c-18.7-18.7-49.1-18.7-67.9 0L176.5 64H112c-26.5 0-48 21.5-48 48v64.5L18.4 222.1c-18.7 18.7-18.7 49.1 0 67.9L64 335.5V400c0 26.5 21.5 48 48 48h64.5l45.6 45.6c18.7 18.7 49.1 18.7 67.9 0L335.5 448H400c26.5 0 48-21.5 48-48V335.5l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5V112c0-26.5-21.5-48-48-48H335.5L289.9 18.4z"]
};
var faUserCowboy = {
  prefix: 'fas',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M224 16c6.7 0 10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.2 0 58.3 58.1 72 110.4C316.4 120 277 128 224 128s-92.4-8-120-17.6C117.7 58.1 140.8 0 176 0c18 0 25.9 5.4 32.5 9.9c4.8 3.3 8.8 6.1 15.5 6.1zM8.6 97.8c7-3.6 15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7C115.8 149.6 161.8 160 224 160s108.2-10.4 140.2-22.9c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9c-7.1 5.2-14.7 10.1-22.7 14.8c0 .8 0 1.5 0 2.3c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-.8 0-1.5 0-2.3c-8-4.6-15.6-9.6-22.7-14.8C35.8 179.5 10.1 145 .8 117.1c-2.5-7.4 .8-15.6 7.8-19.2zM100.7 384H347.3c48.4 0 89.3 36.1 95.3 84.1l1 7.9c2.4 19.1-12.5 36-31.8 36H36.2C17 512 2.1 495.1 4.5 476l1-7.9c6-48 46.8-84.1 95.3-84.1z"]
};
var faHexagonVerticalNft = {
  prefix: 'fas',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9V168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.7c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4V344.9c0 25.7-13.7 49.5-36 62.4L260.9 495.5zM95.8 170.6c-2.8-7.1-10.3-11.2-17.9-9.8s-13 8-13 15.7v160c0 8.8 7.2 16 16 16s16-7.2 16-16V259.7l33.1 82.9c2.8 7.1 10.3 11.2 17.9 9.8s13-8 13-15.7v-160c0-8.8-7.2-16-16-16s-16 7.2-16 16v76.9L95.8 170.6zm97.1 5.9v80 80c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-144h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"]
};
var faFaceRollingEyes = {
  prefix: 'fas',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"]
};
var faMehRollingEyes = faFaceRollingEyes;
var faBreadLoaf = {
  prefix: 'fas',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", "M0 192C0 64 176 32 240 32s240 32 240 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64zM397.4 34.9c-2-.9-4.1-1.9-6.2-2.8c3.1-.1 6-.2 8.8-.2c64 0 240 32 240 160c0 35.3-28.7 64-64 64V432c0 26.5-21.5 48-48 48H432c10-13.4 16-30 16-48V282.5c37.3-13.2 64-48.7 64-90.5c0-82.2-57.6-130.7-114.6-157.1z"]
};
var faRingsWedding = {
  prefix: 'fas',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M113.7 8.8C116.4 3.4 121.9 0 128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 52.3-22.8 99.2-59 131.5c-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-12-1.9-23.6-5.4-34.5c-34.9 19-58.6 56-58.6 98.5c0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9c-5-26.2-14.8-50.7-28.6-72.4C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32zM176 160c-61.9 0-112 50.1-112 112c0 58.7 45.1 106.8 102.5 111.6c-4.2-15.1-6.5-31.1-6.5-47.6c0-64.4 34.5-120.7 86.1-151.3C226.9 169.2 202.5 160 176 160z"]
};
var faObjectGroup = {
  prefix: 'fas',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"]
};
var faFrenchFries = {
  prefix: 'fas',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M183.2 1.7c-5-2.5-10.8-2.2-15.6 .7S160 10.5 160 16V206.7l0 0v63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2V31.8c-.1-6-3.5-11.4-8.8-14.1l-32-16zM128 14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6V14.7zM40.3 85.6L19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2H48c3.6 0 7 .4 10.2 1L40.3 85.6zM383.8 98.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2.8-.5 5.7-.8 8.8-.8h26.6c1.6 0 3.2 .1 4.7 .2l16.5-93.4zm-64-48c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4V261c4.8-2.1 8.7-4.4 11.8-6.6c12-8.4 16.7-18 18.7-24.3c.7-2.3 1.7-4.7 2.8-7L319.8 50.8zM.6 250.5l57.5 237C61.5 501.9 74.4 512 89.2 512H294.8c14.8 0 27.6-10.1 31.1-24.5l57.5-237c.4-1.7 .6-3.3 .6-5.1c0-11.8-9.6-21.4-21.4-21.4H336c-8.8 0-16.3 7.2-18.9 15.7C309.7 263 283.7 304 192 304s-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224H21.4C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1z"]
};
var faChartLine = {
  prefix: 'fas',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"]
};
var faLineChart = faChartLine;
var faCalendarArrowDown = {
  prefix: 'fas',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V366.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V264z"]
};
var faCalendarDownload = faCalendarArrowDown;
var faSendBack = {
  prefix: 'fas',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", "M192 64V192H64V64H192zM64 0C28.7 0 0 28.7 0 64V192c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM576 320V448H448V320H576zM448 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zM160 288v64c0 35.3 28.7 64 64 64H352V320c0-53 43-96 96-96h32V160c0-35.3-28.7-64-64-64H288v96c0 53-43 96-96 96H160z"]
};
var faMaskVentilator = {
  prefix: 'fas',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faSignatureLock = {
  prefix: 'fas',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", "M96 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5L68.4 243.7C27.8 255.8 0 293.2 0 335.6v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3h72.6c5.6-9.7 13.7-17.8 23.4-23.4V272c0-5.4 .4-10.8 1.1-16H364.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L220.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM209.9 368c-6.7 16.3-14.2 32.3-22.3 48H384V368H209.9zM86.8 305l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2L79.9 411.7c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowRight = {
  prefix: 'fas',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
};
var faSignsPost = {
  prefix: 'fas',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faMapSigns = faSignsPost;
var faOctagonPlus = {
  prefix: 'fas',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faPlusOctagon = faOctagonPlus;
var faCashRegister = {
  prefix: 'fas',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"]
};
var faPersonCircleQuestion = {
  prefix: 'fas',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"]
};
var faMelonSlice = {
  prefix: 'fas',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zM320 128c0 106-86 192-192 192c-11.4 0-22.5-1-33.3-2.9c-5.4-.9-11 .6-14.8 4.5L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L321.6 79.8c-3.9 3.9-5.4 9.4-4.5 14.8c1.9 10.8 2.9 22 2.9 33.3z"]
};
var faSpaceStationMoon = {
  prefix: 'fas',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0S512 114.6 512 256zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352s176.6-13.6 249.2-37.2C478.6 427.9 377.1 512 256 512zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
var faMessageSmile = {
  prefix: 'fas',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"]
};
var faCommentAltSmile = faMessageSmile;
var faCupStraw = {
  prefix: 'fas',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M249.3 0H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H249.3c-3.7 0-6.9 2.6-7.8 6.2L224.2 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H174.9l20-84.8C200.8 17.9 223.4 0 249.3 0zM60.3 468L40 224H344L323.7 468c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44z"]
};
var faLeftFromLine = {
  prefix: 'fas',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", "M134.1 406.1L11.3 283.3C4.1 276.1 0 266.2 0 256s4.1-20.1 11.3-27.3L134.1 105.9c6.4-6.4 15-9.9 24-9.9c18.7 0 33.9 15.2 33.9 33.9l0 62.1 128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0 0 62.1c0 18.7-15.2 33.9-33.9 33.9c-9 0-17.6-3.6-24-9.9zM384 416l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faArrowAltFromRight = faLeftFromLine;
var faH = {
  prefix: 'fas',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"]
};
var faBasketShoppingSimple = {
  prefix: 'fas',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192H404.3L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192H544c17.7 0 32 14.3 32 32s-14.3 32-32 32L492.1 463.5C485 492 459.4 512 430 512H146c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h85.6L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM144 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm312-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faShoppingBasketAlt = faBasketShoppingSimple;
var faHandsHoldingHeart = {
  prefix: 'fas',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M195.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L195.9 136.9zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faHandsHeart = faHandsHoldingHeart;
var faClockNine = {
  prefix: 'fas',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V256c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTarp = {
  prefix: 'fas',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFaceSleepy = {
  prefix: 'fas',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", "M385.1 477.1C347.2 499.3 303.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 37-7.8 72.1-22 103.9c-7.4-6.2-15.1-11.8-22.7-16.7C429.6 318.7 383.6 304 352 304c-15.3 0-28.5 10.9-31.4 25.9s5.3 30.1 19.5 35.8c21 8.4 31.6 23.5 37.4 41.7c6.3 19.4 6.5 40.3 6.5 56.6c0 4.5 .4 8.9 1.1 13.1zM176 389.5c-6.8 11.1 6 20.7 18.3 16.4c18.9-6.5 39.8-10.1 61.8-10.1s42.9 3.6 61.8 10.1c12.3 4.2 25.1-5.3 18.3-16.4C321 364.8 290.8 348 256 348s-64.9 16.8-80.1 41.5zM316.8 246.4c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0zm-121.6 0c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128c48 0 160 48 160 128z"]
};
var faHandHorns = {
  prefix: 'fas',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM320 96c0-17.7 14.3-32 32-32s32 14.3 32 32v96 96 64c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c35.3 0 64-28.7 64-64V192 96z"]
};
var faScrewdriverWrench = {
  prefix: 'fas',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTools = faScrewdriverWrench;
var faArrowsToEye = {
  prefix: 'fas',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"]
};
var faCircleThreeQuarters = {
  prefix: 'fas',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256C0 397.4 114.6 512 256 512c130.6 0 238.3-97.8 254-224.1c2.2-17.5-12.4-31.9-30-31.9H256V32z"]
};
var faTrophyStar = {
  prefix: 'fas',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", "M176 0H400c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8H552c13.3 0 24 10.7 24 24c0 92.6-33.5 157-78.5 200.7c-44.3 43.1-98.3 64.8-138.2 75.8c-23.4 6.5-39.4 26-39.4 45.6c0 20.9 17 37.9 37.9 37.9H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h26.1c20.9 0 37.9-17 37.9-37.9c0-19.6-15.9-39.2-39.4-45.6c-39.9-11-93.9-32.7-138.1-75.8C33.5 245 0 180.6 0 88C0 74.7 10.7 64 24 64H129.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM133.2 112H48.9c5.1 66.3 31.1 111.2 63 142.3c22.4 21.8 48.3 37.3 73.2 48.3c-22.7-40.3-42.8-100.5-51.9-190.6zM390.8 302.6c24.9-11 50.8-26.5 73.2-48.3c32-31.1 58-76 63-142.3H442.7c-9.1 90.1-29.2 150.3-51.9 190.6zM295.2 86.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L212.7 136c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L284.3 218c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L334.4 187c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4L295.2 86.5z"]
};
var faTrophyAlt = faTrophyStar;
var faPlugCircleBolt = {
  prefix: 'fas',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faFaceThermometer = {
  prefix: 'fas',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", "M544 256c0 141.4-114.6 256-256 256S32 397.4 32 256S146.6 0 288 0C400 0 495.2 72 530 172.2c-14-4.1-29.8-.7-41 10.2l-150.8 146c-14.9-5.2-31.6-8.4-50.2-8.4c-55.1 0-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6C214 373.8 244.6 352 288 352s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6c5.2-4.5 6.8-11.6 4.5-17.7l9.4-9-24.8-24.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.1 25.1 15.3-14.8-25.4-25.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.7 25.7 15.3-14.8-26-26c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.3 26.3L514.1 275l-26.6-26.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.9 26.9 12.5-12c.1 3.2 .2 6.4 .2 9.6zM240.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faGridRound4 = {
  prefix: 'fas',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M44.8 121.6a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm0 119.5a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7A44.8 44.8 0 1 1 0 315.7a44.8 44.8 0 1 1 89.6 0zM44.8 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM209.1 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM328.5 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 315.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6z"]
};
var faShirtRunning = {
  prefix: 'fas',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M80 0c17.7 0 32 14.3 32 32V80c0 44.2 35.8 80 80 80s80-35.8 80-80V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 33.3 2.6 61.5 6.5 85.2L0 393.8V282.5c0-17 6.7-33.5 14.7-48.4C28.8 207.6 48 155 48 64V32C48 14.3 62.3 0 80 0zM3.8 469.8L360.4 215c3 7.5 6 13.8 8.9 19c8 15 14.7 31.5 14.7 48.4V448c0 35.3-28.7 64-64 64H64c-27.7 0-51.3-17.6-60.2-42.2z"]
};
var faBookCircleArrowUp = {
  prefix: 'fas',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h10.8c-23.3-16.4-42.5-38.4-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H320.7c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32H384 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6l-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
var faFaceNauseated = {
  prefix: 'fas',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM168 282.7c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3H206.4c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8z"]
};
var faHeart = {
  prefix: 'fas',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"]
};
var faFileChartPie = {
  prefix: 'fas',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm40 320H208c-8.8 0-16-7.2-16-16V216c0-8.8 7.2-16.1 16-14.9c53.5 7.1 95.9 49.5 103 103c1.2 8.8-6.1 16-14.9 16zM160 230V336c0 8.8 7.2 16 16 16H282c10.1 0 17.7 9.3 14.1 18.8C278.9 415.9 235.2 448 184 448c-66.3 0-120-53.7-120-120c0-51.2 32.1-94.9 77.2-112.2c9.5-3.6 18.8 4 18.8 14.1z"]
};
var faMarsAndVenus = {
  prefix: 'fas',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faHouseUser = {
  prefix: 'fas',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"]
};
var faHomeUser = faHouseUser;
var faCircleArrowDownLeft = {
  prefix: 'fas',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm64-144c13.3 0 24-10.7 24-24s-10.7-24-24-24H225.9L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H320z"]
};
var faDumpsterFire = {
  prefix: 'fas',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faHexagonMinus = {
  prefix: 'fas',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faMinusHexagon = faHexagonMinus;
var faLeftToLine = {
  prefix: 'fas',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", "M230.1 406.1L107.3 283.3C100.1 276.1 96 266.2 96 256s4.1-20.1 11.3-27.3L230.1 105.9c6.4-6.4 15-9.9 24-9.9c18.7 0 33.9 15.2 33.9 33.9l0 62.1 128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0 0 62.1c0 18.7-15.2 33.9-33.9 33.9c-9 0-17.6-3.6-24-9.9zM64 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32z"]
};
var faArrowAltToLeft = faLeftToLine;
var faHouseCrack = {
  prefix: 'fas',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"]
};
var faPawSimple = {
  prefix: 'fas',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm1.7 206c6.2-2.3 11.8-6.3 15-12.2l40-71.9c14.4-25.9 41.7-42 71.3-42s56.9 16.1 71.3 42l40 71.9c3.2 5.8 8.8 9.9 15 12.2c38.3 14 65.7 50.8 65.7 94c0 55.2-44.8 100-100 100c-21.2 0-40.8-6.6-56.9-17.8c-17.4-12-52.8-12-70.1 0C172.8 473.4 153.2 480 132 480C76.8 480 32 435.2 32 380c0-43.2 27.4-80 65.7-94zM304 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm48 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM48 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faPawAlt = faPawSimple;
var faArrowLeftLongToLine = {
  prefix: 'fas',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32S0 78.3 0 96zM137.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 288 608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"]
};
var faBracketsRound = {
  prefix: 'fas',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M145.8 90.6c14.7-9.8 18.7-29.7 8.9-44.4s-29.7-18.7-44.4-8.9C71.9 62.9 0 140.2 0 256S71.9 449 110.2 474.6c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4C120.1 404.3 64 345 64 256s56.1-148.3 81.8-165.4zm220.5 0C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C440.1 449.1 512 371.8 512 256s-71.9-193.1-110.2-218.6c-14.7-9.8-34.6-5.8-44.4 8.9s-5.8 34.6 8.9 44.4z"]
};
var faParentheses = faBracketsRound;
var faMartiniGlassCitrus = {
  prefix: 'fas',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"]
};
var faCocktail = faMartiniGlassCitrus;
var faUserShakespeare = {
  prefix: 'fas',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M224 48c-44.2 0-80 35.8-80 80v32c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1V128c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v23.2c0 10.9 3.7 21.5 10.5 30L373.6 195c6.7 8.4 10.4 18.8 10.4 29.6c0 26.2-21.2 47.4-47.4 47.4H286c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16H111.4C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30V128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM272 304c23.9 0 45.8 8.8 62.6 23.2c65.7 20.4 113.4 81.7 113.4 154c0 17-13.8 30.7-30.7 30.7H240c0-8.8-7.2-16-16-16s-16 7.2-16 16H30.7C13.8 512 0 498.2 0 481.3c0-72.4 47.7-133.6 113.4-154C130.2 312.8 152.1 304 176 304h96zM208 448a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm-80-48c26.4-10.6 54.6-16 83.1-16h25.8c28.5 0 56.7 5.4 83.1 16c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48z"]
};
var faArrowRightToArc = {
  prefix: 'fas',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M448 256c0-106-86-192-192-192c-17.7 0-32-14.3-32-32s14.3-32 32-32C397.4 0 512 114.6 512 256s-114.6 256-256 256c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192zM230.6 121.4l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H242.7l-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faFaceSurprise = {
  prefix: 'fas',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSurprise = faFaceSurprise;
var faBottleWater = {
  prefix: 'fas',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.1 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C40.5 415.4 32 400.7 32 384s8.5-31.4 21.5-40C40.5 335.4 32 320.7 32 304s8.5-31.4 21.5-40C40.5 255.4 32 240.7 32 224c0-15.6 7.4-29.4 18.9-38.2C39.5 178.7 32 166.1 32 151.7zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faCirclePause = {
  prefix: 'fas',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faPauseCircle = faCirclePause;
var faGaugeCirclePlus = {
  prefix: 'fas',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24V292.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faFolders = {
  prefix: 'fas',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M512 384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faAngel = {
  prefix: 'fas',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M384 64c0 0 0 .1 0 .2s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2zm-16 80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM120 464H49.7l37.9-75.8c5.6-11.1 8.4-23.4 8.4-35.8v-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1c0-27.1 22-48.9 48.2-48.9c12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3H96h96H384h96 50.7c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm126.8 51.4c-4.6-9.2-10.4-17.5-17.3-24.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1c26.1 0 48.2 21.8 48.2 48.9c0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8v.9c0 12.4 2.9 24.7 8.4 35.8L526.3 464H456L380.6 313.2z"]
};
var faValueAbsolute = {
  prefix: 'fas',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32zM182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7l-73.4-73.4zM512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faRabbit = {
  prefix: 'fas',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M321.4 128c4.8 0 9.6 .3 14.3 .9c1.1-24-2.6-47.9-10.9-70.1c7.6-17.8 18.6-34.2 32.7-48.3l4.6-4.6c3.7-3.7 8.8-5.8 14-5.8c9.2 0 17.2 6.4 19.3 15.4l1 4.4c9.8 42.4 1.8 86.5-21 122.4c5.5 3.1 10.7 6.6 15.6 10.6L425.8 181c14 11.4 22.2 28.6 22.2 46.7c0 33.3-27 60.3-60.3 60.3H352v25.8l61.7 154.3c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-39.4-98.6L265.6 448H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H208 160c-28.5 0-52.6-18.6-60.9-44.2C88.8 480.1 73.3 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C114 317.7 176.8 255.9 256 242.7V193.4c0-10.9 2.7-21.2 7.4-30.2c-34.3-36.5-50.3-86.8-43.2-136.8l.7-4.9C222.7 9.2 233.2 0 245.7 0c6.6 0 12.9 2.6 17.6 7.3l3.1 3.1c31.8 31.5 47.9 74.8 45.4 118.4c3.1-.5 6.3-.7 9.6-.7zM368 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faToiletPaperSlash = {
  prefix: 'fas',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"]
};
var faCircleEuro = {
  prefix: 'fas',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272h16c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h24.7c19.2-46.9 65.4-80 119.2-80H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H192.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H206.4c14.7 20.3 38.5 33.5 65.5 33.5H313c13.3 0 24 10.7 24 24s-10.7 24-24 24H271.9c-54.4 0-101-33.8-119.8-81.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faAppleWhole = {
  prefix: 'fas',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"]
};
var faAppleAlt = faAppleWhole;
var faKitchenSet = {
  prefix: 'fas',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faDiamondHalf = {
  prefix: 'fas',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", "M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7V0z"]
};
var faLockKeyhole = {
  prefix: 'fas',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", "M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faLockAlt = faLockKeyhole;
var faR = {
  prefix: 'fas',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faTemperatureQuarter = {
  prefix: 'fas',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faSquareInfo = {
  prefix: 'fas',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM184 336h24V272H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faInfoSquare = faSquareInfo;
var faWifiSlash = {
  prefix: 'fas',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5 .9-39.3 2.7l-95.1-74.5C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1L38.8 5.1zM93.6 169.8L41.7 128.9C30.7 137.7 20 147 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c12.4-11.9 25.6-23 39.5-33.1zM228 275.7L173 232.3c-15.5 9.2-30.1 19.8-43.5 31.7c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zM320 352c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-7-1.1-13.7-3.2-20l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2z"]
};
var faToiletPaperXmark = {
  prefix: 'fas',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M96 0H348.2C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9H96C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416H416c44.8 0 76.9-35.2 96-72.9V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V416zm51.3-283.3c-6.2-6.2-16.4-6.2-22.6 0L152 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L129.4 192 92.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 214.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L174.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faHandsHoldingDollar = {
  prefix: 'fas',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M344 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8l0 0c-2.1-.7-4.1-1.4-5.9-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faHandsUsd = faHandsHoldingDollar;
var faCube = {
  prefix: 'fas',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"]
};
var faArrowDownTriangleSquare = {
  prefix: 'fas',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM443.1 47l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5H336c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15zM320 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V336z"]
};
var faSortShapesDown = faArrowDownTriangleSquare;
var faBitcoinSign = {
  prefix: 'fas',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"]
};
var faShutters = {
  prefix: 'fas',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM20.6 224H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 128H24L1.1 196.8c-.7 2.1-1.1 4.3-1.1 6.5C0 214.8 9.2 224 20.6 224zM491.4 352c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 256H24L1.1 324.8c-.7 2.1-1.1 4.3-1.1 6.5C0 342.8 9.2 352 20.6 352H491.4zM20.6 480H491.4c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 384H24L1.1 452.8c-.7 2.1-1.1 4.3-1.1 6.5C0 470.8 9.2 480 20.6 480z"]
};
var faShieldDog = {
  prefix: 'fas',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSolarPanel = {
  prefix: 'fas',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"]
};
var faLockOpen = {
  prefix: 'fas',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"]
};
var faTableTree = {
  prefix: 'fas',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 160V416H64V160H96v64 96c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16-7.2-16-16V269.3c5 1.8 10.4 2.7 16 2.7h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16-7.2-16-16V160H448zM224 240v32c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm80 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H304z"]
};
var faHouseChimneyHeart = {
  prefix: 'fas',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM237.3 208c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
var faTally3 = {
  prefix: 'fas',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", "M128 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM416 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faElevator = {
  prefix: 'fas',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"]
};
var faMoneyBillTransfer = {
  prefix: 'fas',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faMoneyBillTrendUp = {
  prefix: 'fas',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faHouseFloodWaterCircleArrowRight = {
  prefix: 'fas',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faSquarePollHorizontal = {
  prefix: 'fas',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"]
};
var faPollH = faSquarePollHorizontal;
var faCircle = {
  prefix: 'fas',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faCartCircleExclamation = {
  prefix: 'fas',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faSword = {
  prefix: 'fas',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", "M511.8 18.6c.8-5.1-.8-10.3-4.5-13.9S498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7 269.3 345.4 476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faBackwardFast = {
  prefix: 'fas',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"]
};
var faFastBackward = faBackwardFast;
var faRecycle = {
  prefix: 'fas',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"]
};
var faUserAstronaut = {
  prefix: 'fas',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faInterrobang = {
  prefix: 'fas',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M144 96c-35.3 0-64 28.7-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128v3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2V320c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.4V176c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4l18.6-12c18.3-11.8 29.4-32.1 29.4-53.8V160c0-35.3-28.7-64-64-64H144zM120 440a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faPlaneSlash = {
  prefix: 'fas',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64H440.6L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0zM41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3z"]
};
var faCircleDashed = {
  prefix: 'fas',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5C83.7 164.8 69.9 196.9 65.5 232H1.1zM138.3 104.3L92.7 58.8C131.3 26.9 179.3 6 232 1.1V65.5c-35.1 4.4-67.2 18.2-93.7 38.8zM280 446.5c35.1-4.4 67.2-18.2 93.7-38.8l45.5 45.5C380.7 485.1 332.7 506 280 510.9V446.5zm127.7-72.8c20.6-26.6 34.5-58.7 38.8-93.7h64.4c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zM92.7 453.2l45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8v64.4c-52.7-4.9-100.7-25.8-139.3-57.7zM58.8 419.3C26.9 380.7 6 332.7 1.1 280H65.5c4.4 35.1 18.2 67.2 38.8 93.7L58.8 419.3zM419.3 58.8l-45.5 45.5C347.2 83.7 315.1 69.9 280 65.5V1.1C332.7 6 380.7 26.9 419.3 58.8zm-11.6 79.5l45.5-45.5c31.9 38.5 52.8 86.6 57.7 139.3H446.5c-4.4-35.1-18.2-67.2-38.8-93.7z"]
};
var faTrademark = {
  prefix: 'fas',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"]
};
var faBasketball = {
  prefix: 'fas',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"]
};
var faBasketballBall = faBasketball;
var faForkKnife = {
  prefix: 'fas',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M475.3 27.3c5.8-5.8 6.3-15.1 1.1-21.5S462-1.9 455.1 2.7l-106.5 71C320.8 92.3 304 123.6 304 157.1c0 19.3 5.5 37.9 15.7 53.9L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L365 256.3c16 10.2 34.7 15.7 53.9 15.7c33.5 0 64.8-16.8 83.4-44.6l71-106.5c4.6-6.8 3.2-16-3.2-21.2s-15.6-4.8-21.5 1.1L457.4 192c-5.2 5.2-13.6 5.2-18.8 0c-4.9-4.9-5.2-12.8-.6-18.1l86.1-99.4c5.5-6.3 5.2-15.9-.8-21.8s-15.4-6.3-21.8-.8L402.1 138c-5.3 4.6-13.2 4.3-18.1-.6c-5.2-5.2-5.2-13.6 0-18.8l91.3-91.3zM52.5 7.3C47.9 2.6 41.5 0 34.9 0c-11.2 0-21 7.5-23.5 18.4C6.7 38.6 0 71.5 0 96c0 83.3 48.2 130.5 128.9 209.4c6.5 6.4 13.3 13 20.3 19.9c1.9 1.8 3.8 3.5 5.9 5.1L265.4 220.1 52.5 7.3zM457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L355.9 310.6l-45.3 45.3L457.4 502.6z"]
};
var faUtensilsAlt = faForkKnife;
var faSatelliteDish = {
  prefix: 'fas',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faBadgeCheck = {
  prefix: 'fas',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faCircleUp = {
  prefix: 'fas',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"]
};
var faArrowAltCircleUp = faCircleUp;
var faSlider = {
  prefix: 'fas',
  iconName: 'slider',
  icon: [512, 512, [], "e252", "M352 160V352H320V160h32zM320 96c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V160c0-35.3-28.7-64-64-64H320zM0 256c0 17.7 14.3 32 32 32H224V224H32c-17.7 0-32 14.3-32 32z"]
};
var faMobileScreenButton = {
  prefix: 'fas',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"]
};
var faMobileAlt = faMobileScreenButton;
var faClockOneThirty = {
  prefix: 'fas',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V263.3l60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faInboxOut = {
  prefix: 'fas',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M288 109.3V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]
};
var faInboxArrowUp = faInboxOut;
var faCloudSlash = {
  prefix: 'fas',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445c24.6-23.3 40-56.3 40-93c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.4 0-88.2 19.8-117.4 51.3L38.8 5.1zM97.2 172.6c-.8 6.4-1.2 12.9-1.2 19.4c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144H487.4L97.2 172.6z"]
};
var faVolumeHigh = {
  prefix: 'fas',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"]
};
var faVolumeUp = faVolumeHigh;
var faUsersRays = {
  prefix: 'fas',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faWallet = {
  prefix: 'fas',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faOctagonCheck = {
  prefix: 'fas',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faFlatbreadStuffed = {
  prefix: 'fas',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120c27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5L281.5 191.3C267.4 181.6 250.4 176 232 176c-48.6 0-88 39.4-88 88c0 18.4 5.6 35.4 15.3 49.5zM482.8 73.1c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9zM256 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faClipboardCheck = {
  prefix: 'fas',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faCartCirclePlus = {
  prefix: 'fas',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16H512v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
var faTruckClock = {
  prefix: 'fas',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 176A112 112 0 1 0 96 176a112 112 0 1 0 224 0zM208 96c8.8 0 16 7.2 16 16v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"]
};
var faShippingTimed = faTruckClock;
var faPool8Ball = {
  prefix: 'fas',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm384-64a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-80-48c0 11.5-4 22-10.7 30.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48zm-48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFileAudio = {
  prefix: 'fas',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"]
};
var faTurnDownLeft = {
  prefix: 'fas',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M177.5 446c-8.8 3.8-19 2-26-4.6l-144-136C2.7 300.9 0 294.6 0 288s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 88 192 0c17.7 0 32-14.3 32-32l0-144c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 144c0 70.7-57.3 128-128 128l-192 0 0 88c0 9.6-5.7 18.2-14.5 22z"]
};
var faLockHashtag = {
  prefix: 'fas',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80zm96 48c-8.8 0-16 7.2-16 16v32H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v64H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V320h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H288V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H192V256c0-8.8-7.2-16-16-16zm16 144V320h64v64H192z"]
};
var faChartRadar = {
  prefix: 'fas',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", "M72.5 252c-1.4 2.5-1.4 5.5 0 8l88.3 152.9c1.4 2.5 4.1 4 6.9 4H344.3c2.9 0 5.5-1.5 6.9-4L439.5 260l48.7 28.1L439.5 260c1.4-2.5 1.4-5.5 0-8L351.2 99.1c-1.4-2.5-4.1-4-6.9-4H167.7c-2.9 0-5.5 1.5-6.9 4L72.5 252zM17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM290.2 180.8l40.2 100.6c17.1 4.6 29.6 20.1 29.6 38.6c0 22.1-17.9 40-40 40c-15.9 0-29.7-9.3-36.1-22.7l-97.2-19.4c-7.1 6.3-16.4 10.2-26.7 10.2c-22.1 0-40-17.9-40-40s17.9-40 40-40l57.6-76.8c-1-3.6-1.6-7.3-1.6-11.2c0-22.1 17.9-40 40-40s40 17.9 40 40c0 7.6-2.1 14.7-5.8 20.8zM202 271.9l79.2 15.8-31.7-79.2L202 271.9z"]
};
var faStaff = {
  prefix: 'fas',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M284.2 44.2C297.8 17.1 325.5 0 355.8 0H432c44.2 0 80 35.8 80 80V183.9c0 35.7-23.7 67.1-58 76.9l-3.9 1.1c-4 1.2-7.5 3.9-9.5 7.5l-19 33.6c-4.3 7.7-14.1 10.4-21.8 6.1l-32.8-18.5c-3.7-2.1-8.1-2.6-12.3-1.5l-85.5 24.4c-2.6 .7-5 2.1-6.9 4.1L81.9 497.9c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l77.3-77.3c3-3 4.7-7.1 4.7-11.3V304c0-8.8 7.2-16 16-16h37.5c4.2 0 8.3-1.7 11.3-4.7l39.4-39.4c9.6-9.6 21.5-16.6 34.6-20.4l169.6-48.5c6.9-2 11.6-8.2 11.6-15.4V112c0-8.8-7.2-16-16-16H371.8c-3.7 0-7.2 2.1-8.8 5.5v0c-11.9 23.7-40.7 33.3-64.4 21.5s-33.3-40.7-21.5-64.4l7.2-14.3z"]
};
var faBurger = {
  prefix: 'fas',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"]
};
var faHamburger = faBurger;
var faUtilityPole = {
  prefix: 'fas',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M256 0c17.7 0 32 14.3 32 32V64h96V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h32V56c0-13.3 10.7-24 24-24s24 10.7 24 24V96c0 17.7-14.3 32-32 32H428.8L288 221.9V288 480c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 221.9L83.2 128H32C14.3 128 0 113.7 0 96V56C0 42.7 10.7 32 24 32s24 10.7 24 24v8H80V56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h96V32c0-17.7 14.3-32 32-32zM140.8 128L224 183.4V128H140.8zM288 183.4L371.2 128H288v55.4z"]
};
var faTransporter6 = {
  prefix: 'fas',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", "M56.7 6.6L64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zM384 512H296 216 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32zm96-128l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 384zM224 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWrench = {
  prefix: 'fas',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBugs = {
  prefix: 'fas',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"]
};
var faVectorPolygon = {
  prefix: 'fas',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", "M0 64C0 46.3 14.3 32 32 32H96c17.7 0 32 14.3 32 32H320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384.3l-4.5 7.9-28.4 49.7c.4 2.1 .6 4.2 .6 6.4v64c0 2.2-.2 4.3-.6 6.4l28.4 49.7 4.5 7.9H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32H128c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V160c-17.7 0-32-14.3-32-32V64zM322.2 372.3L292.3 320H256c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h36.3l29.9-52.3c-1.4-3.6-2.2-7.5-2.2-11.7H128c0 17.7-14.3 32-32 32V352c17.7 0 32 14.3 32 32H320c0-4.1 .8-8.1 2.2-11.7zM48 80v32H80V80H48zm320 0v32h32V80H368zM80 400H48v32H80V400zm288 0v32h32V400H368zM304 240H272v32h32V240z"]
};
var faDiagramNested = {
  prefix: 'fas',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H128v96c0 17.7 14.3 32 32 32h96V336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V416H160c-53 0-96-43-96-96V224H48c-26.5 0-48-21.5-48-48V80z"]
};
var faRupeeSign = {
  prefix: 'fas',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"]
};
var faRupee = faRupeeSign;
var faFileImage = {
  prefix: 'fas',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"]
};
var faCircleQuestion = {
  prefix: 'fas',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faQuestionCircle = faCircleQuestion;
var faImageUser = {
  prefix: 'fas',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4z"]
};
var faBuoy = {
  prefix: 'fas',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", "M192 0c-17.7 0-32 14.3-32 32c0 15.3 10.8 28.1 25.1 31.3L133.8 320H96c-17.7 0-32 14.3-32 32v16c0 8.2 .7 16.1 2 23.9c21-11.1 46.9-9.9 66.9 4.2c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20-14.1 45.9-15.3 66.9-4.2c1.3-7.8 2-15.8 2-23.9V352c0-17.7-14.3-32-32-32H442.2L390.9 63.3C405.2 60.1 416 47.3 416 32c0-17.7-14.3-32-32-32H192zM325.8 64l9.8 49L288 168.5 240.4 113l9.8-49h75.5zm21.8 108.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM221.3 320L288 242.2 354.7 320H221.3zm85.2 101.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faPlaneDeparture = {
  prefix: 'fas',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
};
var faHandshakeSlash = {
  prefix: 'fas',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faBookBookmark = {
  prefix: 'fas',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"]
};
var faBorderCenterH = {
  prefix: 'fas',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z"]
};
var faCanFood = {
  prefix: 'fas',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M270.3 304.5c12.1-2.5 23.4-5.5 33.7-9V426c-2.8 1.6-6.6 3.6-11.8 5.7C269.8 440.9 234.4 448 192 448s-77.8-7.1-100.2-16.3c-5.2-2.1-9-4.1-11.8-5.7V295.5c10.3 3.5 21.6 6.5 33.7 9c7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5zm-100.1-40a32 32 0 1 1 43.5 46.9 32 32 0 1 1 -43.5-46.9zM16 72V240 440c0 39.8 78.8 72 176 72s176-32.2 176-72V240 72c0-39.8-78.8-72-176-72S16 32.2 16 72zm288 0c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24z"]
};
var faTypewriter = {
  prefix: 'fas',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", "M64 64C64 28.7 92.7 0 128 0H354.7c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3V192h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H64V64zm320 64H352c-17.7 0-32-14.3-32-32V64H128V192h18.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4H306.7c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H384V128zM160 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm-32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faArrowRightFromArc = {
  prefix: 'fas',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", "M64 256C64 150 150 64 256 64c17.7 0 32-14.3 32-32s-14.3-32-32-32C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256zM390.6 121.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H402.7l-57.4 57.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112z"]
};
var faCircleK = {
  prefix: 'fas',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.1-343.2l-73.1 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V298.5 152c0-13.3 10.7-24 24-24s24 10.7 24 24v87.8L310.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z"]
};
var faFaceHandOverMouth = {
  prefix: 'fas',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52V384v32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-37.1 52.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2V384 330.4c0-11 9-20 20-20s20 9 20 20v19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faPopcorn = {
  prefix: 'fas',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", "M32.2 160c-.1-1.3-.2-2.7-.2-4c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4H328.2 119.8 32.2zm-4 32H97.8l30.3 257.9c1 8.8 9 15.1 17.8 14s15.1-9 14-17.8L130 192h78V448c0 8.8 7.2 16 16 16s16-7.2 16-16V192h78L288.1 446.1c-1 8.8 5.2 16.7 14 17.8s16.7-5.2 17.8-14L350.2 192h69.6c15.6 0 28.2 12.6 28.2 28.2c0 2.5-.3 5.1-1 7.5L377.8 476.8C372 497.6 353.1 512 331.5 512h-215c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192z"]
};
var faHouseWater = {
  prefix: 'fas',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V393c21.3-12.2 48.1-11.4 68.8 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20.7-14.6 47.7-15.4 69.1-3l-.5-105.6h32zM224 216c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V216zm82.5 205.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faHouseFlood = faHouseWater;
var faObjectSubtract = {
  prefix: 'fas',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M512 448c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-96-96 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 96 96 0c35.3 0 64 28.7 64 64l0 224zM288 288l0-224L64 64l0 224 224 0z"]
};
var faCodeBranch = {
  prefix: 'fas',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faWarehouseFull = {
  prefix: 'fas',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM376 384H488c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V408c0-13.3 10.7-24 24-24zM128 248c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V248zm24 136H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faWarehouseAlt = faWarehouseFull;
var faHatCowboy = {
  prefix: 'fas',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"]
};
var faBridge = {
  prefix: 'fas',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"]
};
var faPhoneFlip = {
  prefix: 'fas',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"]
};
var faPhoneAlt = faPhoneFlip;
var faArrowDownFromDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", "M32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM374.6 342.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 370.7V304 192c0-17.7 14.3-32 32-32s32 14.3 32 32V304v66.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faFileDoc = {
  prefix: 'fas',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
};
var faSquareQuarters = {
  prefix: 'fas',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0L224 256 384 96H64zm0 320H384L224 256 64 416z"]
};
var faTruckFront = {
  prefix: 'fas',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCat = {
  prefix: 'fas',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faTrashXmark = {
  prefix: 'fas',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zM143 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faCircleCaretLeft = {
  prefix: 'fas',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-368 0c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"]
};
var faCaretCircleLeft = faCircleCaretLeft;
var faFiles = {
  prefix: 'fas',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M320 0H160C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V128H352c-17.7 0-32-14.3-32-32V0zM448 96L416 64 384 32 352 0V45.3 64 96h32 18.7H448zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faAnchorCircleExclamation = {
  prefix: 'fas',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faFaceClouds = {
  prefix: 'fas',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M128 0C104.3 0 83.6 12.9 72.6 32H64C28.7 32 0 60.7 0 96s28.7 64 64 64H224c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C179.7 17.9 155.9 0 128 0zM72.1 192c-5.3 20.5-8.1 41.9-8.1 64c0 114.6 75.4 211.7 179.3 244.3c-12.1-17-19.3-37.8-19.3-60.3c0-50.6 36.2-92.8 84.1-102.1C321.2 290.7 364.6 256 416 256c29.1 0 55.6 11.1 75.5 29.2c8.9-3.4 18.5-5.2 28.5-5.2c20 0 38.3 7.3 52.3 19.5c2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96c0 39.6-24 73.6-58.2 88.3c6.5 5.9 10.5 14.3 10.5 23.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H72.1zm328.3-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368h-8c-39.8 0-72 32.2-72 72s32.2 72 72 72H568c39.8 0 72-32.2 72-72s-32.2-72-72-72h-.7c.4-2.6 .7-5.3 .7-8c0-26.5-21.5-48-48-48c-13.9 0-26.4 5.9-35.1 15.3C470.9 303.8 445.3 288 416 288c-44.2 0-80 35.8-80 80z"]
};
var faUserCrown = {
  prefix: 'fas',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M144 128v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128H144zm0-108.8c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5H336c8.8 0 16 7.2 16 16V39v3.2 .1V144c0 70.7-57.3 128-128 128s-128-57.3-128-128V42.3v-.1V39 16c0-8.8 7.2-16 16-16h2.4c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6l.1 .1zM0 472c0-92.8 75.2-168 168-168H280c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8z"]
};
var faTruckField = {
  prefix: 'fas',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faRoute = {
  prefix: 'fas',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faCartCircleCheck = {
  prefix: 'fas',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
var faClipboardQuestion = {
  prefix: 'fas',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faPanorama = {
  prefix: 'fas',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"]
};
var faCommentMedical = {
  prefix: 'fas',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"]
};
var faTeethOpen = {
  prefix: 'fas',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"]
};
var faUserTieHairLong = {
  prefix: 'fas',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 261.9 58.1 272 70.6 272H224 377.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5V128C352 57.3 294.7 0 224 0zm55.7 510.9c1.8 .7 3.8 1.1 5.8 1.1H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c2.1 0 4-.4 5.8-1.1L168 512H280l-.3-1.1z"]
};
var faFileCircleMinus = {
  prefix: 'fas',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"]
};
var faHeadSideMedical = {
  prefix: 'fas',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM192 112v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H256V112c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faTags = {
  prefix: 'fas',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faWineGlass = {
  prefix: 'fas',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"]
};
var faForwardFast = {
  prefix: 'fas',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"]
};
var faFastForward = faForwardFast;
var faFaceMehBlank = {
  prefix: 'fas',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMehBlank = faFaceMehBlank;
var faUserRobot = {
  prefix: 'fas',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M224 0c8.8 0 16 7.2 16 16V64h64c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352H352c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32H352V448c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32V448c0-53 43-96 96-96zm80 112v48H144V464c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v48H208V464c0-8.8 7.2-16 16-16zm80 16v48H272V464c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faSquareParking = {
  prefix: 'fas',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"]
};
var faParking = faSquareParking;
var faCardDiamond = {
  prefix: 'fas',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 84.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z"]
};
var faFaceZipper = {
  prefix: 'fas',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", "M492.4 354.4C505 324.1 512 290.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c50.3 0 97.2-14.5 136.7-39.5c-1.1-1.8-2.2-3.7-3.1-5.7l-29.1-58.1c-9.2-18.5-5.6-40.8 9-55.4l15.7-15.7c14.6-14.6 36.9-18.2 55.4-9l51.8 25.9zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 336v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm98.2 132.4c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5l29.1 58.1zm62.3-36.9c4.7 4.7 4.7 12.3 0 17l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0z"]
};
var faFaceRaisedEyebrow = {
  prefix: 'fas',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
};
var faHouseSignal = {
  prefix: 'fas',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"]
};
var faSquareChevronUp = {
  prefix: 'fas',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM241 167L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z"]
};
var faChevronSquareUp = faSquareChevronUp;
var faNfcSymbol = {
  prefix: 'fas',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M348.9 471.8c10.3 9.3 25.4 10.8 37.4 3.9C461.6 432.1 512 348.8 512 256s-50.3-176.1-125.7-219.7C371 27.5 351.4 32.7 342.6 48s-3.6 34.9 11.7 43.7C410.1 124 448 186.4 448 256c0 61.4-29.5 117.2-74.8 151.7L213.4 264.2c-13.2-11.8-33.4-10.7-45.2 2.4s-10.7 33.4 2.4 45.2l178.3 160zM163.1 40.2c-10.3-9.3-25.4-10.8-37.4-3.9C50.3 79.9 0 163.2 0 256s50.3 176.1 125.7 219.7c15.3 8.8 34.9 3.6 43.7-11.7s3.6-34.9-11.7-43.7C101.9 388 64 325.7 64 256c0-61.4 29.5-117.2 74.8-151.7L298.6 247.8c13.2 11.8 33.4 10.7 45.2-2.4s10.7-33.4-2.4-45.2L163.1 40.2z"]
};
var faBarsProgress = {
  prefix: 'fas',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"]
};
var faTasksAlt = faBarsProgress;
var faFaucetDrip = {
  prefix: 'fas',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"]
};
var faArrowsToLine = {
  prefix: 'fas',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V32zM201.4 329.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faDolphin = {
  prefix: 'fas',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M477.3 24.9c3.5-5.3 3.6-12.2 .1-17.6S467.7-.8 461.4 .2c-16.7 2.8-43.1 8.6-68.8 17C378 22 362.5 28 349 35.3C306.5 12.8 258 0 206.5 0H176C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7L20.5 209.6C7.8 217.2 0 231 0 245.8C0 269.1 18.9 288 42.2 288H176h16 11.2l92 61.3c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V288h6.6c31.7 0 57.4 25.7 57.4 57.4c0 30.6-24 55.8-54.5 57.3l-53.4 2.7c-20.2-33-56.3-53.4-95.4-53.4H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6h4.7c35.9 0 69.2-17.1 90.1-45.4l68 3.8c94.1 5.2 173.3-70 173.3-164.3c0-80.8-31.4-154.5-82.7-209.3l48-72zM176 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faArrowUpRight = {
  prefix: 'fas',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", "M352 128c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0L41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 205.3 288 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224z"]
};
var faCircleR = {
  prefix: 'fas',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H288c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64h56z"]
};
var faCartFlatbed = {
  prefix: 'fas',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"]
};
var faDollyFlatbed = faCartFlatbed;
var faBanSmoking = {
  prefix: 'fas',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"]
};
var faSmokingBan = faBanSmoking;
var faCircleSortUp = {
  prefix: 'fas',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zm0 310.6l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zM313.4 320L256 377.4 198.6 320H313.4z"]
};
var faSortCircleUp = faCircleSortUp;
var faTerminal = {
  prefix: 'fas',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faMobileButton = {
  prefix: 'fas',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHouseMedicalFlag = {
  prefix: 'fas',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faBasketShopping = {
  prefix: 'fas',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faShoppingBasket = faBasketShopping;
var faTape = {
  prefix: 'fas',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faChestnut = {
  prefix: 'fas',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M224 32c5.3 0 10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c7.5 6.8 16.7 14.3 27.2 22.8l3.1 2.5 0 0c20.3 16.4 44.7 36.1 68.2 59.6C400.8 190.2 448 258 448 352H0c0-94 47.2-161.8 96.7-211.3c23.5-23.5 47.9-43.2 68.2-59.6l3.1-2.5c10.6-8.5 19.7-16 27.2-22.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1zM4 384H444c-14.2 55.2-64.3 96-124 96H128C68.4 480 18.2 439.2 4 384z"]
};
var faBusSimple = {
  prefix: 'fas',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBusAlt = faBusSimple;
var faEye = {
  prefix: 'fas',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
};
var faFaceSadCry = {
  prefix: 'fas',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSadCry = faFaceSadCry;
var faHeat = {
  prefix: 'fas',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32zM32 96c17.7 0 32 14.3 32 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96L44.8 294.4C15.7 255.6 0 208.5 0 160V128c0-17.7 14.3-32 32-32zm320 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160V128c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faTicketAirline = {
  prefix: 'fas',
  iconName: 'ticket-airline',
  icon: [640, 512, [], "e29a", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V336c0-8.8-7.3-15.8-15.8-18c-27.7-7-48.2-32.1-48.2-62s20.5-55 48.2-62c8.6-2.2 15.8-9.1 15.8-18V128c0-35.3-28.7-64-64-64H64zm352 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 224l-28.5-85.5c-1.7-5.2 2.1-10.5 7.6-10.5h31.1c8.5 0 16.4 4.5 20.7 11.9L256 224h46.9c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288H256l-49.1 84.1c-4.3 7.4-12.2 11.9-20.7 11.9H155.1c-5.5 0-9.3-5.4-7.6-10.5L176 288H120l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H74.2c-5.2 0-9-4.9-7.8-9.9L79 259.9c.6-2.5 .6-5.2 0-7.8L66.5 201.9c-1.3-5 2.6-9.9 7.8-9.9H88c5 0 9.8 2.4 12.8 6.4L120 224h56z"]
};
var faBootHeeled = {
  prefix: 'fas',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", "M128 0H63.3C46 0 32 14 32 31.3c0 1.8 .1 3.9 .6 6.2C34.6 47.1 56 154.3 56 232c0 33.2-12.8 93.5-19.7 123.2C33.6 367 32 379.3 32 391.8V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V472.9l125 34.7c10.5 2.9 21.3 4.4 32.1 4.4H456h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V429.7c0-27.3-15.4-52.2-39.8-64.4L327.8 309.1c-24.4-12.2-39.8-37.1-39.8-64.4V24c0-13.3-10.7-24-24-24H160V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V0z"]
};
var faArrowsMinimize = {
  prefix: 'fas',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h50.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zm448 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L397.3 160H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v50.7L457.4 9.4zM32 320c0-17.7 14.3-32 32-32H192c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352H64c-17.7 0-32-14.3-32-32zm256 0c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H397.3L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 397.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V320z"]
};
var faCompressArrows = faArrowsMinimize;
var faAudioDescription = {
  prefix: 'fas',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"]
};
var faPersonMilitaryToPerson = {
  prefix: 'fas',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"]
};
var faFileShield = {
  prefix: 'fas',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"]
};
var faHexagon = {
  prefix: 'fas',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220z"]
};
var faManhole = {
  prefix: 'fas',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM281.4 115.4c5.8-7.5 14.5-14.7 23.6-11.8c64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8c-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8c5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
var faUserSlash = {
  prefix: 'fas',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"]
};
var faPen = {
  prefix: 'fas',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"]
};
var faTowerObservation = {
  prefix: 'fas',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faFloppyDisks = {
  prefix: 'fas',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M96 56c0-30.9 25.1-56 56-56H370.7c14.9 0 29.1 5.9 39.6 16.4l85.3 85.3c10.5 10.5 16.4 24.7 16.4 39.6V360c0 30.9-25.1 56-56 56H152c-30.9 0-56-25.1-56-56V56zm96 8c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H192zM368 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM48 120V376c0 48.6 39.4 88 88 88H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faToiletPaperBlankUnder = {
  prefix: 'fas',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", "M348.2 0H96C43 0 0 86 0 192S43 384 96 384H348.2c-11.6-12.2-21.1-26.9-28.7-41.9C299.5 302 288 248.9 288 192s11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9zM384 10.9c-37.3 26.4-64 97.5-64 181.1s26.7 154.7 64 181.1c10 7.1 20.8 10.9 32 10.9c35.5 0 66.6-38.6 83.2-96c8.2-28.2 12.8-61 12.8-96C512 86 469 0 416 0c-11.2 0-22 3.8-32 10.9zM416 256c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64zM160 464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V343.1c-19.1 37.8-51.2 72.9-96 72.9H160v48z"]
};
var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
var faFileCode = {
  prefix: 'fas',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faSignal = {
  prefix: 'fas',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faPump = {
  prefix: 'fas',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M128 32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM32 176c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-17.7-14.3-32-32-32zm128 48H96V384H320V96H160V224zM431.9 106.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3V413.7c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7zM448 208c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16z"]
};
var faBus = {
  prefix: 'fas',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"]
};
var faHeartCircleXmark = {
  prefix: 'fas',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faArrowUpLeftFromCircle = {
  prefix: 'fas',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M192 0H32C14.3 0 0 14.3 0 32V192c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3L297.4 342.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 64H192c17.7 0 32-14.3 32-32s-14.3-32-32-32zM325.3 67.1c-17.4-2.9-33.9 8.8-36.9 26.3s8.8 33.9 26.3 36.9C390.4 142.9 448 208.8 448 288c0 88.4-71.6 160-160 160c-79.2 0-145.1-57.6-157.8-133.3c-2.9-17.4-19.4-29.2-36.9-26.3s-29.2 19.4-26.3 36.9C84.9 431.3 177 512 288 512c123.7 0 224-100.3 224-224c0-111-80.7-203.1-186.7-220.9z"]
};
var faHouseChimney = {
  prefix: 'fas',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"]
};
var faHomeLg = faHouseChimney;
var faWindowMaximize = {
  prefix: 'fas',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faDryer = {
  prefix: 'fas',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM336 304c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H113.1c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112z"]
};
var faFaceFrown = {
  prefix: 'fas',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFrown = faFaceFrown;
var faChessBishopPiece = {
  prefix: 'fas',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", "M104 32C90.7 32 80 42.7 80 56c0 12.2 9.1 22.3 20.9 23.8C79.6 100.1 48 139 48 192c0 26.3 13.6 40.5 26.3 48H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384H192l-13.7-96H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-2.3c12.7-7.5 26.3-21.7 26.3-48c0-22.5-5.7-42.4-13.9-59.5l-38.8 38.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L177 104.4c-7.4-10-15.2-18.2-21.9-24.6C166.9 78.3 176 68.2 176 56c0-13.3-10.7-24-24-24H104zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48z"]
};
var faChessBishopAlt = faChessBishopPiece;
var faShirtTankTop = {
  prefix: 'fas',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M112 32C112 14.3 97.7 0 80 0S48 14.3 48 32V64c0 91-19.2 143.6-33.3 170.1C6.7 249.1 0 265.5 0 282.5V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V282.5c0-17-6.7-33.5-14.7-48.4C355.2 207.6 336 155 336 64V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V80c0 44.2-35.8 80-80 80s-80-35.8-80-80V32z"]
};
var faDiploma = {
  prefix: 'fas',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M302 59.7l18 20.6 18-20.6C353.4 42.1 375.6 32 399 32h1c44.2 0 80 35.8 80 80c0 11.4-2.4 22.2-6.7 32H544v32c0-32 0-32 0-32l0 0 .1 0 .2 0 .5 0c.4 0 .8 0 1.4 .1c1 .1 2.3 .1 3.8 .3c3 .3 7 .9 11.6 2.1c9.2 2.3 21.3 6.9 33.4 15.9C620.9 181.7 640 216.2 640 272c0 47.5-13.7 81.1-32 104.1c-18 22.6-38.5 32.6-49 36.6c-7.3 2.8-14 3.3-19 3.3h-.5c-4.7 0-9.3-.5-13.9-1.5L384 383v81c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2L320 444.8l-37.8 31.5c-4.8 4-11.4 4.8-17 2.2s-9.2-8.3-9.2-14.5V383L114.4 414.5c-4.6 1-9.2 1.5-13.9 1.5h-.5c-4.9 0-11.7-.5-19-3.3c-10.5-4-31-14-49-36.6C13.7 353.1 0 319.5 0 272c0-55.8 19.1-90.3 44.8-109.6c12.1-9.1 24.3-13.6 33.4-15.9c4.6-1.2 8.6-1.8 11.6-2.1c1.5-.2 2.8-.3 3.8-.3c.5 0 1 0 1.4-.1l.5 0 .2 0 .1 0 0 0c0 0 0 0 0 32V144h70.7c-4.3-9.8-6.7-20.6-6.7-32c0-44.2 35.8-80 80-80h1c23.4 0 45.6 10.1 61 27.7zM240 144h54.4c6.9 0 10.5-8.1 6-13.3L265.9 91.3C259.6 84.1 250.5 80 241 80h-1c-17.7 0-32 14.3-32 32s14.3 32 32 32zm105.6 0H392h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1c-1.2 0-2.3 .1-3.5 .2c-8.2 .9-15.8 4.8-21.3 11.1l-34.5 39.5c-4.5 5.2-.9 13.3 6 13.3zM256 208H96.7l-.1 0c-.5 .1-1.5 .2-2.9 .5c-2.8 .7-6.7 2.1-10.6 5.1C76.9 218.3 64 231.8 64 272c0 34.5 9.6 53.7 18.1 64.3c7.2 9 14.9 13.5 19.2 15.6L256 317.4V208zM384 317.4l154.8 34.4c4.3-2 12-6.6 19.2-15.6c8.4-10.6 18.1-29.8 18.1-64.3c0-40.2-12.9-53.7-19.2-58.4c-3.9-2.9-7.7-4.4-10.6-5.1c-1.4-.3-2.4-.5-2.9-.5l-.1 0H384V317.4zM540.1 352c0 0 0 0 0 0l0 0h0zM99.9 352c0 0 0 0 0 0h0z"]
};
var faScrollRibbon = faDiploma;
var faScreencast = {
  prefix: 'fas',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", "M512 96H64v99c-13-2-26.4-3-40-3H0V96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H288V456c0-13.6-1-27-3-40H512V96zM24 224c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"]
};
var faWalker = {
  prefix: 'fas',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M194 64H320c17.7 0 32 14.3 32 32v64H145l17.9-71.8C166.5 74 179.3 64 194 64zM352 224V392.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V96c0-53-43-96-96-96H194c-44.1 0-82.4 30-93.1 72.7L1 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3L129 224H352zm32 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faPrescription = {
  prefix: 'fas',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faShop = {
  prefix: 'fas',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"]
};
var faStoreAlt = faShop;
var faFloppyDisk = {
  prefix: 'fas',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faSave = faFloppyDisk;
var faVihara = {
  prefix: 'fas',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"]
};
var faFaceKissClosedEyes = {
  prefix: 'fas',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-93.5-80.1c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faScaleUnbalanced = {
  prefix: 'fas',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faFileUser = {
  prefix: 'fas',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"]
};
var faUserPoliceTie = {
  prefix: 'fas',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM98.1 168.8C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512H192v0h64v0H422.4c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.2 464.9 240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2H201.9c-11.9 0-19.6 12.5-14.3 23.2zm172 38.4l5.4 16.6 17.4 0c3.5 0 6.6 2.2 7.6 5.5s-.1 6.9-2.9 9L373 454.8l5.4 16.6c1.1 3.3-.1 6.9-2.9 9s-6.6 2-9.4 0L352 470.1l-14.1 10.3c-2.8 2-6.6 2.1-9.4 0s-4-5.7-2.9-9l5.4-16.6-14.1-10.2c-2.8-2-4-5.7-2.9-9s4.2-5.5 7.6-5.5l17.4 0 5.4-16.6c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5z"]
};
var faFaceTongueMoney = {
  prefix: 'fas',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M0 256C0 364.6 67.7 457.5 163.1 494.6C151.1 476.8 144 455.2 144 432V421.5c-22.4-20.1-39-46.1-47.2-75.4c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1c-8.2 29.4-24.9 55.4-47.2 75.4V432c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM192 104v9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2V248c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.2c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16s16 7.2 16 16zM336 88c8.8 0 16 7.2 16 16v9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2V248c0 8.8-7.2 16-16 16s-16-7.2-16-16V237.2c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1V104c0-8.8 7.2-16 16-16zm0 264H176v80c0 44.2 35.8 80 80 80s80-35.8 80-80V352zm-80 16c5.9 0 10.7 4.9 10.7 10.9v6.7c3 .6 5.8 1.2 8.1 1.8c5.7 1.6 9.1 7.5 7.6 13.3s-7.4 9.3-13 7.7c-5.5-1.5-12.6-2.8-18-2.2c-2.7 .3-4.1 .9-4.7 1.4c-1.7 1.3-1.7 3.8-.2 4.9c4.6 3.3 10 4.7 15.5 6.2c5.6 1.5 11.2 3 15.9 6.4c3.2 2.3 6.3 5.5 8.3 9.9c2 4.5 2.3 9.4 1.5 14.4c-1.3 7.8-5.3 13.9-11.3 17.7c-3.1 1.9-6.4 3-9.6 3.6v6.1c0 6-4.8 10.9-10.7 10.9s-10.7-4.9-10.7-10.9v-7.3c-5.6-1.3-10.7-3-14-4.1c-5.6-1.9-8.6-8.1-6.8-13.8s7.9-8.8 13.5-6.9c6.3 2.1 14.6 4.7 21.3 4.8c3.3 .1 5.1-.5 5.9-1c1.8-1.1 2.1-4.3 .4-5.5c-2.3-1.7-6.2-2.9-12.6-4.8l-.8-.2c-5.2-1.5-12.6-3.7-18.1-7.6c-3.2-2.3-6.3-5.5-8.3-9.9c-2-4.5-2.3-9.4-1.5-14.4c1.2-6.9 4.6-12.4 9.6-16.1c3.6-2.6 7.5-4.1 11.3-4.9v-6.4c0-6 4.8-10.9 10.7-10.9z"]
};
var faTennisBall = {
  prefix: 'fas',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M.2 245.1C.1 248.7 0 252.3 0 256C0 397.4 114.6 512 256 512c3.7 0 7.3-.1 10.9-.2c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c.2-3.6 .2-7.2 .2-10.9C512 114.6 397.4 0 256 0c-3.7 0-7.3 .1-10.9 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4zM206.8 4.7C104.9 24.6 24.6 104.9 4.7 206.8C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9zM445.4 293.4c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6c101.9-19.8 182.2-100.2 202.1-202.1c-19.6-8.1-40.6-12.1-61.9-11.8z"]
};
var faSquareL = {
  prefix: 'fas',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM176 152V336H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSortUp = {
  prefix: 'fas',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
};
var faSortAsc = faSortUp;
var faCalendarArrowUp = {
  prefix: 'fas',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM248 424V321.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V424c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faCalendarUpload = faCalendarArrowUp;
var faCommentDots = {
  prefix: 'fas',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCommenting = faCommentDots;
var faPlantWilt = {
  prefix: 'fas',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"]
};
var faScarf = {
  prefix: 'fas',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", "M416 168.8c0 22.8-7 44.9-19.9 63.4L278.6 114.7l15.1-15.1C283.1 97.5 270.3 96 256 96s-27.1 1.5-37.8 3.6L256 137.4 374.6 256l9.4 9.4 11.3 11.3 112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L384 310.6 358.6 336 459.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 358.6 310.6 384 411.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112L128.4 247C107.7 226.3 96 198.1 96 168.8c0-19 4.9-37.7 14.2-54.2l41.5-73.8C165.9 15.6 192.5 0 221.4 0h69.1c28.9 0 55.6 15.6 69.7 40.8l41.5 73.8c9.3 16.6 14.2 35.2 14.2 54.2zM4.7 388.7l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"]
};
var faAlbumCirclePlus = {
  prefix: 'fas',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64V96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208 0a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faUserNurseHairLong = {
  prefix: 'fas',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M96 70.2V128h.3c-.2 2.6-.3 5.3-.3 8v24 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 293.9 58.1 304 70.6 304H224 377.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5V160 136c0-2.7-.1-5.4-.3-8h.3V70.2c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160v16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160h8zM151.4 346.8c-6.4-6.8-15.4-10.6-24.6-9.3C55.1 347.7 0 409.4 0 483.8C0 499.4 12.6 512 28.2 512H419.8c15.6 0 28.2-12.6 28.2-28.2c0-74.5-55.1-136.1-126.7-146.3c-9.2-1.3-18.3 2.5-24.6 9.3l-61 64.8c-6.3 6.7-17 6.7-23.3 0l-61-64.8zM208 48c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8V64h16c4.4 0 8 3.6 8 8V88c0 4.4-3.6 8-8 8H240v16c0 4.4-3.6 8-8 8H216c-4.4 0-8-3.6-8-8V96H192c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h16V48z"]
};
var faDiamond = {
  prefix: 'fas',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"]
};
var faSquareLeft = {
  prefix: 'fas',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm185.4 39.1L85.5 242.2C82 245.9 80 250.9 80 256s2 10.1 5.5 13.8l99.9 107.1c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1z"]
};
var faArrowAltSquareLeft = faSquareLeft;
var faFaceGrinSquint = {
  prefix: 'fas',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
var faGrinSquint = faFaceGrinSquint;
var faCircleEllipsisVertical = {
  prefix: 'fas',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faHandHoldingDollar = {
  prefix: 'fas',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faGridDividers = {
  prefix: 'fas',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", "M0 24C0 10.7 10.7 0 24 0H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM64 96h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 288h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zM192 128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zM352 128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V128zm32 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zM24 288H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBacterium = {
  prefix: 'fas',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faHandPointer = {
  prefix: 'fas',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"]
};
var faDrumSteelpan = {
  prefix: 'fas',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"]
};
var faHandScissors = {
  prefix: 'fas',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"]
};
var faHandsPraying = {
  prefix: 'fas',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"]
};
var faPrayingHands = faHandsPraying;
var faFacePensive = {
  prefix: 'fas',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 384h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM387.2 270.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM65.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3c-7.9 4-17.5 .7-21.5-7.2zm373.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"]
};
var faUserMusic = {
  prefix: 'fas',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c36.3 0 70.1 10.9 98.3 29.5v51.6c-18 2.5-34.8 9.1-48.5 19.4c-17.6 13.2-31.5 34-31.5 59.5c0 19.1 7.7 35.4 18.9 48H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
var faArrowRotateRight = {
  prefix: 'fas',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faMessagesDollar = {
  prefix: 'fas',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V320H64c-35.3 0-64-28.7-64-64V64zM256 352h96c53 0 96-43 96-96V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64V352zM228 56c0-11-9-20-20-20s-20 9-20 20V70c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V264c0 11 9 20 20 20s20-9 20-20V250.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V56z"]
};
var faCommentsAltDollar = faMessagesDollar;
var faSensorOn = {
  prefix: 'fas',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24zm413.3 12l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM536 232h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H536c-13.3 0-24-10.7-24-24s10.7-24 24-24zm13.3 140l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z"]
};
var faBalloon = {
  prefix: 'fas',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M0 192C0 86 86 0 192 0S384 86 384 192c0 102.6-102.8 194.9-143.6 227.5c-9.3 7.4-12.5 20.4-7.1 31l21.4 42.7c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9H140.9c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l21.4-42.7c5.3-10.6 2.1-23.6-7.1-31C102.8 386.9 0 294.6 0 192zm96-16c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.1 64 64 114.1 64 176c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faBiohazard = {
  prefix: 'fas',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"]
};
var faChessQueenPiece = {
  prefix: 'fas',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", "M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM229.9 124.9l-41.5 67.5c11.2 2.1 19.6 11.8 19.6 23.6c0 13.3-10.7 24-24 24h-8l19.6 144H60.4L80 240H72c-13.3 0-24-10.7-24-24c0-11.8 8.5-21.5 19.6-23.6L26.1 124.9c-3.7-6-3-13.6 1.6-18.9s12.1-6.9 18.6-4.1c3 1.3 6.3 2.1 9.8 2.1c11.8 0 21.6-8.5 23.6-19.7c1.1-6.3 6-11.4 12.3-12.8s12.8 1.1 16.5 6.4C112.8 84 119.9 88 128 88s15.2-4 19.6-10.1c3.7-5.3 10.2-7.8 16.5-6.4s11.1 6.4 12.3 12.8c2 11.2 11.8 19.7 23.6 19.7c3.5 0 6.8-.7 9.8-2.1c6.4-2.9 13.9-1.2 18.6 4.1s5.3 13 1.6 18.9zM208 416l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24c0-5.2 1.7-10.2 4.8-14.4L48 416H208z"]
};
var faChessQueenAlt = faChessQueenPiece;
var faLocationCrosshairs = {
  prefix: 'fas',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faLocation = faLocationCrosshairs;
var faMarsDouble = {
  prefix: 'fas',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"]
};
var faHousePersonLeave = {
  prefix: 'fas',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0L379.5 117.2c-32.6 19.5-57.5 50.2-69.6 86.7l-2.6 7.8c-11.2 33.5 6.9 69.8 40.5 81c15.8 5.3 32.2 4 46.3-2.3L361.5 372l-44 44H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM443.7 200.5l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L601 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5c-1 .4-1.9 .8-2.9 1.2zm-30 135.1c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L388.7 398l25-62.4z"]
};
var faHouseLeave = faHousePersonLeave;
var faHousePersonDepart = faHousePersonLeave;
var faRulerTriangle = {
  prefix: 'fas',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", "M0 32V448c0 35.3 28.7 64 64 64H480c17.7 0 32-14.3 32-32v-2.7c0-8.5-3.4-16.6-9.4-22.6l-51.3-51.3-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L131.3 83.3l-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L57.4 9.4C51.4 3.4 43.2 0 34.7 0H32C14.3 0 0 14.3 0 32zM128 256L256 384H128V256z"]
};
var faCardClub = {
  prefix: 'fas',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM130.1 208.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8V336H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V303.2c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3z"]
};
var faChildDress = {
  prefix: 'fas',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"]
};
var faUsersBetweenLines = {
  prefix: 'fas',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faLungsVirus = {
  prefix: 'fas',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSpinnerThird = {
  prefix: 'fas',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]
};
var faFaceGrinTears = {
  prefix: 'fas',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"]
};
var faGrinTears = faFaceGrinTears;
var faPhone = {
  prefix: 'fas',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"]
};
var faComputerMouseScrollwheel = {
  prefix: 'fas',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M160 0C71.6 0 0 71.6 0 160V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V160C384 71.6 312.4 0 224 0H160zm64 128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faMouseAlt = faComputerMouseScrollwheel;
var faCalendarXmark = {
  prefix: 'fas',
  iconName: 'calendar-xmark',
  icon: [512, 512, ["calendar-times"], "f273", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM337 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"]
};
var faCalendarTimes = faCalendarXmark;
var faChildReaching = {
  prefix: 'fas',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"]
};
var faTableLayout = {
  prefix: 'fas',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 96v64H64V96H448zM64 224h64V416H64V224zm384 0V416H192V224H448z"]
};
var faNarwhal = {
  prefix: 'fas',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M639.3 20.7c2.4-7.8-1.4-16.1-8.9-19.4s-16.2-.4-20.2 6.6L516.7 168.3c-16.9-5.4-34.9-8.3-53.6-8.3c-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4V253.1l29.9-20.9c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L64 253.1V352c0 88.4 71.6 160 160 160H464c97.2 0 176-78.8 176-176c0-51.4-22.3-97.7-57.8-129.9l57-185.4zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faRampLoading = {
  prefix: 'fas',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", "M32 48C32 21.5 53.5 0 80 0H368c26.5 0 48 21.5 48 48V440.4l-64-128V64H96V312.4l-64 128V48zM404.4 488.8c.8 1.5 1.2 3 1.5 4.6c1.5 9.3-5.6 18.6-15.8 18.6H368 80 57.9c-10.2 0-17.4-9.2-15.8-18.6c.3-1.5 .7-3.1 1.5-4.6L96 384l32-64H320l32 64 52.4 104.8z"]
};
var faCalendarCirclePlus = {
  prefix: 'fas',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3V192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faToothbrush = {
  prefix: 'fas',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M64 224c-35.3 0-64-28.7-64-64s28.7-64 64-64H288c31.2 0 38.2-22.7 39.6-48c.5-8.8 7.6-16.1 16.4-15.2c52.4 5.3 104 36.7 104 95.2c0 53-43 96-96 96H64zm-8 32c13.3 0 24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24V416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V280c0-13.3 10.7-24 24-24z"]
};
var faBorderInner = {
  prefix: 'fas',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0-384A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zM416 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM416 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM0 256c0-17.7 14.3-32 32-32l160 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160L32 288c-17.7 0-32-14.3-32-32z"]
};
var faPawClaws = {
  prefix: 'fas',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M178.1 15.3C183 9.9 192 13.4 192 20.7V71.2c18.3 9.8 34.3 28.9 42.5 53.6c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.2h0c0-25.7 9.6-50.6 26.9-69.6l39.2-43.1zm132 206.3c-32.3-10.6-46.9-53.9-32.6-96.8c8.2-24.7 24.2-43.8 42.5-53.6V20.7c0-7.3 9-10.8 13.9-5.4l39.2 43.1c17.3 19 26.9 43.9 26.9 69.6h0c.2 11.3-1.5 23.2-5.5 35.1c-14.3 42.9-52.1 69.1-84.4 58.5zm-209.7 8.9c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240H0v-3.2c0-13.5 4.3-26.7 12.2-37.6l37.3-51.3c4.6-6.3 14.5-3 14.5 4.7v44.2c13.9 6.1 27.1 17.8 36.4 33.7zM69.2 433.2C121.6 291.9 214.7 256 256 256s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 512 64 491.1 64 465.3v-1.6c0-10.4 1.6-20.7 5.2-30.5zM421.8 314.7c-24.5-14-29.1-51.7-10.2-84.1c9.3-15.9 22.4-27.6 36.4-33.7V152.6c0-7.7 9.9-11 14.5-4.7l37.3 51.3c8 10.9 12.2 24.1 12.2 37.6V240h0c.1 13.3-3.7 27.8-11.6 41.4c-18.9 32.4-54 47.3-78.5 33.3z"]
};
var faKiwiFruit = {
  prefix: 'fas',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M448 176c0 79.5-100.3 144-224 144S0 255.5 0 176S100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16V248c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24zM224 480C102.4 480 3.4 383.1 .1 262.2c13.2 16.4 29.8 30.7 48.2 42.5C94.7 334.6 156.9 352 224 352s129.3-17.4 175.7-47.3c18.5-11.9 35-26.2 48.2-42.5C444.6 383.1 345.6 480 224 480z"]
};
var faTrafficLightSlow = {
  prefix: 'fas',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-128a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faRectangleCode = {
  prefix: 'fas',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm294.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L356.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L155.9 256l60.2-54.2z"]
};
var faHeadSideVirus = {
  prefix: 'fas',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faKeyboardBrightness = {
  prefix: 'fas',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M134.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 192c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96zm153.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64zM0 384c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm224-32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H544z"]
};
var faBooksMedical = {
  prefix: 'fas',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", "M64 32C64 14.3 78.3 0 96 0h64c17.7 0 32 14.3 32 32V96H64V32zm0 384H192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416zM224 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H224V32zm0 96H352V384H224V128zm0 288H352v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V416zm203.6-19.9L384 232.6V142.8l100.4-26.9 66 247.4L427.6 396.1zM476.2 85L384 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L476.2 85zM435.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L435.8 427zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H128v48c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16H64V176z"]
};
var faLightbulbSlash = {
  prefix: 'fas',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8L38.8 5.1zM213.3 141.9C227.7 96.7 270 64 320 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-40 0-73.1 29.3-79 67.6l-27.7-21.7zm-60.9 87.9c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H348.1L152.4 229.8zM240 416v16c0 44.2 35.8 80 80 80s80-35.8 80-80v-7.1L388.7 416H240z"]
};
var faHouseBlank = {
  prefix: 'fas',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
};
var faHomeBlank = faHouseBlank;
var faSquare5 = {
  prefix: 'fas',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm112 96H280c13.3 0 24 10.7 24 24s-10.7 24-24 24H196l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"]
};
var faSquareHeart = {
  prefix: 'fas',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM99.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 280.9z"]
};
var faHeartSquare = faSquareHeart;
var faPuzzle = {
  prefix: 'fas',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M320 0H448c35.3 0 64 28.7 64 64V192c0 8.8-7.2 16-16 16H444c-6.6 0-12 5.4-12 12v4c0 17.7-14.3 32-32 32s-32-14.3-32-32v-4c0-6.6-5.4-12-12-12l-36 0c-8.8 0-16-7.2-16-16V160c0-8.8 7.2-16 16-16h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-8.8 0-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM0 256V128C0 92.7 28.7 64 64 64H192c8.8 0 16 7.2 16 16v36c0 6.6 5.4 12 12 12h4c17.7 0 32 14.3 32 32s-14.3 32-32 32h-4c-6.6 0-12 5.4-12 12v52c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V240c0-17.7-14.3-32-32-32s-32 14.3-32 32v16c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM0 448V320c0-8.8 7.2-16 16-16H192c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H64c-35.3 0-64-28.7-64-64zM240 320c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16V448c0 35.3-28.7 64-64 64H256c-8.8 0-16-7.2-16-16V320z"]
};
var faUserGear = {
  prefix: 'fas',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
var faUserCog = faUserGear;
var faPipeCircleCheck = {
  prefix: 'fas',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", "M32 96c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm448 0c17.7 0 32 14.3 32 32v64.7c-5.3-.5-10.6-.7-16-.7c-16.6 0-32.7 2.3-48 6.6V128c0-17.7 14.3-32 32-32zM320 368c0 5.4 .2 10.7 .7 16H96V128H416v83.2c-57 29.1-96 88.4-96 156.8zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faArrowUp19 = {
  prefix: 'fas',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"]
};
var faSortNumericUp = faArrowUp19;
var faOctagonExclamation = {
  prefix: 'fas',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faDialLow = {
  prefix: 'fas',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-.4 447.6c-80.2 0-146.6-59-158.2-136l158.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-158.2 0c11.6-77 78-136 158.2-136c88.4 0 160 71.6 160 160s-71.6 160-160 160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDoorClosed = {
  prefix: 'fas',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLaptopMobile = {
  prefix: 'fas',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H352V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM448 448V192H576V448H448zM384 176V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z"]
};
var faPhoneLaptop = faLaptopMobile;
var faConveyorBeltBoxes = {
  prefix: 'fas',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M64 32C64 14.3 78.3 0 96 0H288c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V32zM384 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V224c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V96zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faConveyorBeltAlt = faConveyorBeltBoxes;
var faShieldVirus = {
  prefix: 'fas',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fas',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", "M148.8 7.7c13.4 11.5 15 31.7 3.5 45.1L64 155.8v61.8l107.6-21.5C195.3 137.4 252.8 96 320 96s124.7 41.4 148.4 100.1L576 217.6V148.5L488.5 53.7c-12-13-11.2-33.2 1.8-45.2s33.2-11.2 45.2 1.8L623 105.1c10.9 11.8 17 27.3 17 43.4V348.8c0 14.5-4.9 28.6-14 40L537 500c-11 13.8-31.2 16-45 5s-16-31.2-5-45l89-111.2V294.4L468.4 315.9C444.7 374.6 387.2 416 320 416s-124.7-41.4-148.4-100.1L64 294.4v61.8l88.3 103c11.5 13.4 9.9 33.6-3.5 45.1s-33.6 9.9-45.1-3.5l-88.3-103C5.5 386.2 0 371.4 0 356.2V155.8c0-15.3 5.5-30.1 15.4-41.7l88.3-103c11.5-13.4 31.7-15 45.1-3.5zM304 350.7V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5H225.3c2.4 14.6 8.2 28.1 16.4 39.6zM225.3 240H258c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8V161.3c-14.6 2.4-28.1 8.2-39.6 16.4zM375.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6H382c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM382 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM342.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32l0 0 0 0c-17.7 0-32 14.3-32 32c0 17.7 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"]
};
var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
var faDiceSix = {
  prefix: 'fas',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faStarfighterTwinIonEngine = {
  prefix: 'fas',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", "M32 32c17.7 0 32 14.3 32 32V211.2l75.6-15.1C163.3 137.4 220.8 96 288 96s124.7 41.4 148.4 100.1L512 211.2V64c0-17.7 14.3-32 32-32s32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.8l-75.6 15.1C412.7 374.6 355.2 416 288 416s-124.7-41.4-148.4-100.1L64 300.8V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 224 64C0 46.3 14.3 32 32 32zM272 350.7V318c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5H193.3c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240H226c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8V161.3c-14.6 2.4-28.1 8.2-39.6 16.4zM343.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8v32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6H350c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240h32.7c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4V194c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM310.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"]
};
var faStarfighterAlt = faStarfighterTwinIonEngine;
var faRocketLaunch = {
  prefix: 'fas',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M117.8 128H207C286.9-3.7 409.5-8.5 483.9 5.3c11.6 2.2 20.7 11.2 22.8 22.8c13.8 74.4 9 197-122.7 276.9v89.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-114.7c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9c12.8-.7 31.2-3.7 41.3-13.7z"]
};
var faMosquitoNet = {
  prefix: 'fas',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"]
};
var faVentDamper = {
  prefix: 'fas',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M64 128c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64v32h32c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H576v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V352H32c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32H64V128zm120 16c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faBridgeWater = {
  prefix: 'fas',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faBanBug = {
  prefix: 'fas',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5C335.9 434.9 297.5 448 256 448zm89-148.3l19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7V246.7l35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-18.7 0-35.9 6.4-49.6 17.2L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L345 299.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z"]
};
var faDebug = faBanBug;
var faPersonBooth = {
  prefix: 'fas',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"]
};
var faTextWidth = {
  prefix: 'fas',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"]
};
var faGarageCar = {
  prefix: 'fas',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM254.3 293.4L242.2 328H397.8l-12.1-34.6c-1.1-3.2-4.2-5.4-7.6-5.4H261.8c-3.4 0-6.4 2.2-7.6 5.4zM188.9 335L209 277.5c7.9-22.5 29.1-37.5 52.9-37.5H378.2c23.8 0 45 15.1 52.9 37.5L451.1 335c17.2 9.5 28.9 27.9 28.9 49v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V464H224v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-21.1 11.7-39.5 28.9-49zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faSquareKanban = {
  prefix: 'fas',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zm-64-96c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32zM256 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64zM128 320c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32z"]
};
var faHatWizard = {
  prefix: 'fas',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faPenFancy = {
  prefix: 'fas',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"]
};
var faCoffeePot = {
  prefix: 'fas',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M64 128c0-17.7 14.3-32 32-32h12.8l34 84.9C95 215.9 64 272.3 64 336v8c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8H418c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344v-8c0-63.7-31-120.1-78.8-155.1L478.1 68.8c1.3-3.2 1.9-6.6 1.9-10C480 44 468 32 453.2 32H192 122.8 96C43 32 0 75 0 128v64c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm65 192c5.2-41.4 30.1-76.6 65-96H382c34.9 19.4 59.8 54.6 65 96H129z"]
};
var faMouseField = {
  prefix: 'fas',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M396.4 112.9C398.8 105 400 96.6 400 88c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.9 14.9 56.3 37.6 72.2C169.5 164.3 96 240.4 96 333.6c0 12.3 2.7 24 7.5 34.4H72c-39.8 0-72 32.2-72 72s32.2 72 72 72H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24s10.7-24 24-24H178.4 232h8 19H382.6c18.5 0 33.4-15 33.4-33.4c0-14.1-8.8-26.6-22-31.4l-43.7-15.9 23.8-63.5c2 .1 4 .2 6 .2H482.9c16.1 0 29.1-13 29.1-29.1c0-41.5-19.3-78.4-49.4-102.4C473.5 125.8 480 107.7 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 13.9-2.5 27.2-7.2 39.5c-9.1-3.2-18.6-5.5-28.4-6.6zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16H312c-22.1 0-40-17.9-40-40s17.9-40 40-40z"]
};
var faPersonDigging = {
  prefix: 'fas',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"]
};
var faDigging = faPersonDigging;
var faShowerDown = {
  prefix: 'fas',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M192 0c17.7 0 32 14.3 32 32v3.2C297 50 352 114.6 352 192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32C32 114.6 87 50 160 35.2V32c0-17.7 14.3-32 32-32zm52.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zm-82.2-85.6l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zm146.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"]
};
var faShowerAlt = faShowerDown;
var faBoxCircleCheck = {
  prefix: 'fas',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H416 240V32zM0 416V192H416v.7c-89.7 8.1-160 83.5-160 175.3c0 42.5 15.1 81.6 40.2 112H64c-35.3 0-64-28.7-64-64zm288-48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faBrightness = {
  prefix: 'fas',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M224 80V32c0-17.7 14.3-32 32-32s32 14.3 32 32V80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM0 256c0-17.7 14.3-32 32-32H80c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm432-32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H432c-17.7 0-32-14.3-32-32s14.3-32 32-32zM256 512c-17.7 0-32-14.3-32-32V432c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 17.7-14.3 32-32 32zM73.4 438.6c-12.5-12.5-12.5-32.8 0-45.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0zm288-333.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm77.3 333.3c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3zm-333.3-288l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"]
};
var faCarSideBolt = {
  prefix: 'fas',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M82.2 92.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3zM480 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM114.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM331.2 100.6c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176H352c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L243.7 208H192c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"]
};
var faOrnament = {
  prefix: 'fas',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32H128c-17.7 0-32 14.3-32 32v25.7C66.9 170.5 42.5 194.9 25.7 224H358.3c-16.9-29.1-41.2-53.5-70.3-70.3V128c0-17.7-14.3-32-32-32h-8.6zM0 320c0 22.4 3.8 44 10.9 64H373.1c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64H10.9C3.8 276 0 297.6 0 320zm25.7 96c33.2 57.4 95.2 96 166.3 96s133.1-38.6 166.3-96H25.7z"]
};
var faPhoneArrowDownLeft = {
  prefix: 'fas',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M505 41l-135 135H416c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24v46.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"]
};
var faPhoneArrowDown = faPhoneArrowDownLeft;
var faPhoneIncoming = faPhoneArrowDownLeft;
var faCloudWord = {
  prefix: 'fas',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm512 32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16zM240 352c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96zM128 304c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm272-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faHandFingersCrossed = {
  prefix: 'fas',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M93 18.5l17.3 37.2L75 131.3 35 45.5c-7.5-16-.5-35.1 15.5-42.5s35.1-.5 42.5 15.5zM150.6 272l0 0H152c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64H80l0 0h35.3l0 0h35.3zM192 252.1c-8-5.4-17.2-9.2-27-11L181 207l11 23.7v21.5zM130.2 240H59.6L163 18.5c7.5-16 26.5-22.9 42.5-15.5s22.9 26.5 15.5 42.5L130.2 240zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224z"]
};
var faTrash = {
  prefix: 'fas',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
};
var faGaugeSimple = {
  prefix: 'fas',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faArrowDownSmallBig = {
  prefix: 'fas',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM320 80v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zm48 176c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368z"]
};
var faSortSizeDownAlt = faArrowDownSmallBig;
var faBookMedical = {
  prefix: 'fas',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"]
};
var faFaceMelting = {
  prefix: 'fas',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M571.4 304.8c-4.5 23.2 11.8 47.2 35.4 47.2H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H44.9c36.8 0 58.4-50.7 42.9-84.1C72.5 331.1 64 294.5 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 16.7-1.6 33-4.6 48.8zM247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zM441 238.7a32 32 0 1 0 -61.8-16.6A32 32 0 1 0 441 238.7zM213.2 299.4c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z"]
};
var faPoo = {
  prefix: 'fas',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"]
};
var faPenClipSlash = {
  prefix: 'fas',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l55-55 17-17-1-1-16-16-96-96-17-17L338.9 81c-28.1-28.1-73.7-28.1-101.8 0l-44.6 44.6L38.8 5.1zM230.5 155.4L271 114.9c9.4-9.4 24.6-9.4 33.9 0L318.1 128l-53.8 53.8-33.7-26.4zm-67 127.1c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7L195.8 250.3l-32.3 32.3zM517.3 19.3c-25-25-65.5-25-90.5 0L374.6 71.4l17 17 96 96 16 16 0 0 1 1 0 0 52.1-52.1c25-25 25-65.5 0-90.5L517.3 19.3z"]
};
var faPenAltSlash = faPenClipSlash;
var faQuoteRight = {
  prefix: 'fas',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"]
};
var faQuoteRightAlt = faQuoteRight;
var faScrollOld = {
  prefix: 'fas',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M48 32c26.5 0 48 21.5 48 48v80H48 32c-17.7 0-32-14.3-32-32V80C0 53.5 21.5 32 48 32zm80 48c0-18-6-34.6-16-48H384c51.4 0 93.4 40.5 95.9 91.3c-.4 3.5-2 6.9-4.6 9.4l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3V200v16 1.4c0 4.2-1.7 8.3-4.7 11.3l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3V296v24H314.7c-32.4 0-58.7 26.3-58.7 58.7V384c0 35.3-28.7 64-64 64s-64-28.7-64-64V264v-1.4c0-4.2 1.7-8.3 4.7-11.3l21.7-21.7c3.1-3.1 3.1-8.2 0-11.3l-21.7-21.7c-3-3-4.7-7.1-4.7-11.3V184 80zM576 368c0 61.9-50.1 112-112 112H368 192c53 0 96-43 96-96v-5.3c0-14.7 11.9-26.7 26.7-26.7H344h1.4c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.1 3.1 8.2 3.1 11.3 0l21.7-21.7c3-3 7.1-4.7 11.3-4.7H424 560c8.8 0 16 7.2 16 16z"]
};
var faGuitars = {
  prefix: 'fas',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", "M104 0h48c13.3 0 24 10.7 24 24V76.2c0 6.2-1.4 12.3-4.2 17.9L152 133.7V178c50.3 8.6 88 43.8 88 86c0 14-4.2 27.3-11.6 39.1c-8.2 13-7.5 32 2.9 43.4c5.9 6.5 10.9 13.7 14.8 21.3c-2.3 4.9-4.7 9.6-7 13.9c-8.8 16.3-15 35.6-15 56.5c0 11.6 1.9 22.8 5.4 33.3C205.9 496.1 169.3 512 128 512C57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5c10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-42.1 37.7-77.3 88-86V133.7L84.2 94.1C81.4 88.6 80 82.4 80 76.2V24C80 10.7 90.7 0 104 0zm24 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM360 148.6l-21.4-24.5c-6.6-7.6-9.3-17.9-7.2-27.8l13.9-64.8C349.2 13.1 365.4 0 384.2 0c22 0 39.8 17.8 39.8 39.8v4.6c0 12.4-6.4 23.3-16 29.7V238.9c27.9-4.2 39.6-19.4 44.5-31.3c3.3-8.2 10.7-15.5 19.5-15.5s16 7.2 16 16v29.3c0 11.6-4.8 22.8-9.3 33.5l-.5 1.1c-3.3 7.8-6.2 18.5-6.2 32.1c0 33.5 17 70.9 28.8 92.9c6.9 12.7 11.2 26.9 11.2 41.3c0 40.8-33 73.8-73.8 73.8H329.8C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3C279 374.9 296 337.5 296 304c0-11.2-2-20.5-4.5-27.8c-.9-2.5-1.8-5-2.7-7.5l0 0 0 0c-4.3-11.8-8.8-23.8-8.8-36.2V192c0-8.8 7.2-16 16-16s16.1 7.2 18.2 15.8c3.9 16.4 14.9 40.5 45.8 46.7V148.6zM336 320c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H352c-8.8 0-16 7.2-16 16z"]
};
var faPhoneXmark = {
  prefix: 'fas',
  iconName: 'phone-xmark',
  icon: [640, 512, [], "e227", "M181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512C264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24zM399 15c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L399 49c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faHose = {
  prefix: 'fas',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M288 104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.3l80.2-11.5C417.3 98 423.9 104 432 104c8.8 0 16-7.2 16-16V40c0-8.8-7.2-16-16-16c-8.1 0-14.7 6-15.8 13.7L336 26.3V24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80zM64 176c0-44.2 35.8-80 80-80H256V32H144C64.5 32 0 96.5 0 176s64.5 144 144 144H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-44.2 0-80-35.8-80-80zM32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faClockSix = {
  prefix: 'fas',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faShirt = {
  prefix: 'fas',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faBillboard = {
  prefix: 'fas',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H80C53.5 32 32 53.5 32 80V352c-17.7 0-32 14.3-32 32s14.3 32 32 32H80 288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416H560h48c17.7 0 32-14.3 32-32s-14.3-32-32-32V80c0-26.5-21.5-48-48-48H448zM320 352H96V96h96v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V96H384v32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V96h96V352H320z"]
};
var faSquareR = {
  prefix: 'fas',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H256c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288H176v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152c0-13.3 10.7-24 24-24zm80 112h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H176v64h56z"]
};
var faCubes = {
  prefix: 'fas',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"]
};
var faEnvelopeOpenDollar = {
  prefix: 'fas',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM276 136v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4l0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"]
};
var faDivide = {
  prefix: 'fas',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"]
};
var faSunCloud = {
  prefix: 'fas',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2l-20.1 29.1C481 193 472.6 192 464 192c-32.9 0-62.4 14.2-82.9 36.7C368.6 171.1 317.3 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1c11.3 38.8 46.5 67.5 88.7 69l-9.4 51c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM352 256c0 1.9-.1 3.7-.2 5.5c-35.6 12.6-61.5 45.6-63.7 85c-10.1 3.6-20.9 5.5-32.2 5.5c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm32 160c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72H384z"]
};
var faLampFloor = {
  prefix: 'fas',
  iconName: 'lamp-floor',
  icon: [640, 512, [], "e015", "M194.3 20.1C199.1 8 210.9 0 224 0H416c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM288 256h64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V256z"]
};
var faSquare7 = {
  prefix: 'fas',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTengeSign = {
  prefix: 'fas',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"]
};
var faTenge = faTengeSign;
var faHeadphones = {
  prefix: 'fas',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"]
};
var faHandsHolding = {
  prefix: 'fas',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
var faCampfire = {
  prefix: 'fas',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4c-3.2 0-6.4 1.1-9 3.4c-29.9 27-55.3 57.7-73.2 87.1c-17.7 29-29.2 60.2-29.2 84.2C112 254.5 175.3 320 256 320c79.9 0 144-65.5 144-145.3c0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0c-8.7 8-16.7 17.8-23.8 26.8C266.6 37 250 19.6 232.2 3.4zM301 248.2c-13.5 9.1-27.9 13.6-44.1 13.6c-40.5 0-72.9-26.4-72.9-70.9c0-21.8 13.5-40.9 40.5-74.5c3.6 4.5 55.8 71.8 55.8 71.8L312.7 150c2.7 3.6 4.5 7.3 6.3 10.9c16.2 30 9 68.2-18 87.3zM42.8 289.9c-16.6-5.9-35 2.7-40.9 19.4s2.7 35 19.4 40.9L160.9 400 21.2 449.9C4.6 455.8-4.1 474.1 1.9 490.8s24.3 25.3 40.9 19.4L256 434l213.2 76.2c16.6 5.9 35-2.7 40.9-19.4s-2.7-35-19.4-40.9L351.1 400l139.6-49.9c16.6-5.9 25.3-24.3 19.4-40.9s-24.3-25.3-40.9-19.4L256 366 42.8 289.9z"]
};
var faCircleAmpersand = {
  prefix: 'fas',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 191.6c0 4.1 1.6 8.1 4.6 11L235 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2H231.6c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L361 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4H210.5c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"]
};
var faSnowflakes = {
  prefix: 'fas',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zM487 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faHandsClapping = {
  prefix: 'fas',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"]
};
var faRepublican = {
  prefix: 'fas',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"]
};
var faLeafMaple = {
  prefix: 'fas',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", "M339.8 7.5l15.8 31.6c7.1 14.2 23.6 21.1 38.7 16l67.6-22.5c1.4-.5 2.9-.7 4.4-.7c7.6 0 13.8 6.2 13.8 13.8c0 1.5-.2 2.9-.7 4.4l-22.5 67.6c-5 15.1 1.8 31.6 16 38.7l31.6 15.8c4.6 2.3 7.5 7 7.5 12.2c0 4.7-2.4 9.1-6.4 11.6l-97.9 61.2c-6.8 4.3-3.8 14.8 4.2 14.8h38.3c7.6 0 13.8 6.2 13.8 13.8c0 1.5-.2 2.9-.7 4.4l-8.5 25.5c-4.1 12.3-.3 25.9 9.5 34.4l34.3 29.4c3.4 2.9 5.4 7.2 5.4 11.7c0 5.5-3 10.6-7.8 13.4l-28.9 16.5c-11.6 6.6-17.9 19.8-15.7 33l4.2 25.1c.1 .6 .2 1.3 .2 1.9c0 7.6-7.2 13.2-14.6 11.2l-155-40.4c-8.2-2.1-16.6 2.4-19.2 10.4l-8.5 25.4c-1.7 5-6.3 8.4-11.6 8.4c-4.4 0-8.5-2.4-10.7-6.3l-53-95.3L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239.3 270.8c3.6-6.1 2.7-14.1-2.5-19.4c-6.2-6.2-16.4-6.2-22.6 0l-84 84L22.3 275.5c-3.9-2.2-6.3-6.2-6.3-10.7c0-5.3 3.4-9.9 8.4-11.6l25.4-8.5c8-2.7 12.5-11.1 10.4-19.2L19.8 70.6C17.9 63.2 23.4 56 31 56c.6 0 1.3 .1 1.9 .2L58 60.3c13.2 2.2 26.4-4.1 33-15.7l16.5-28.9C110.3 11 115.4 8 120.9 8c4.5 0 8.8 2 11.7 5.4L162 47.7c8.5 9.9 22.1 13.6 34.4 9.5l25.5-8.5c1.4-.5 2.9-.7 4.4-.7c7.6 0 13.8 6.2 13.8 13.8v38.3c0 8 10.5 11.1 14.8 4.2L316 6.4c2.5-4 6.9-6.4 11.6-6.4c5.2 0 9.9 2.9 12.2 7.5z"]
};
var faArrowLeft = {
  prefix: 'fas',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
var faPersonCircleXmark = {
  prefix: 'fas',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faRuler = {
  prefix: 'fas',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"]
};
var faCupStrawSwoosh = {
  prefix: 'fas',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M194.8 43.2l-20 84.8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224.2l17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H249.3c-26 0-48.6 17.9-54.5 43.2zM40 224L60.3 468c2.1 24.9 22.9 44 47.8 44H275.8c25 0 45.8-19.1 47.8-44L344 224H40zm194.4 78.9c18.8-10.1 42-17.2 72.7-20.6L303 331.2c-20.8 3.1-35.2 8.2-45.8 13.9c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-17.7 8.8-39.3 15.2-66.7 18.9l-4-47.9c22.1-3.2 37.7-8.3 49.4-14.1c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7z"]
};
var faTemperatureSun = {
  prefix: 'fas',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", "M320.6 98.5l-2.7-.5L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l70.8 49.6c4.5 3.1 10.3 3.8 15.4 1.6c.7-.3 1.5-.7 2.1-1.1c-5.4-16.9-8.3-34.9-8.3-53.7c0-37.7 11.8-72.6 32-101.2V112c0-4.5 .2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm208 0c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C537.8 332.6 544 349.5 544 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM464 0C402.1 0 352 50.2 352 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
var faTemperatureHot = faTemperatureSun;
var faAlignLeft = {
  prefix: 'fas',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faDiceD6 = {
  prefix: 'fas',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"]
};
var faRestroom = {
  prefix: 'fas',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faHighDefinition = {
  prefix: 'fas',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 88V328c0 13.3 10.7 24 24 24h56c53 0 96-43 96-96s-43-96-96-96H328c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48H352V208h32zM160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v72 72c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V256 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v48H160V184z"]
};
var faRectangleHd = faHighDefinition;
var faJ = {
  prefix: 'fas',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"]
};
var faGalaxy = {
  prefix: 'fas',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M320 0h11.5C342.8 0 352 9.2 352 20.5c0 7.1-3.7 13.7-9.8 17.5l-12.5 7.7c-35.2 21.7-60.9 54.9-73.3 93.1c19.9-7 41.3-10.8 63.5-10.8c106 0 192 86 192 192v11.5c0 11.3-9.2 20.5-20.5 20.5c-7.1 0-13.7-3.7-17.5-9.8l-7.7-12.5c-21.7-35.2-54.9-60.9-93.1-73.3c7 19.9 10.8 41.3 10.8 63.5c0 106-86 192-192 192H180.5c-11.3 0-20.5-9.2-20.5-20.5c0-7.1 3.7-13.7 9.8-17.5l12.5-7.7c35.2-21.7 60.9-54.9 73.3-93.1c-19.9 7-41.3 10.8-63.5 10.8C86 384 0 298 0 192V180.5C0 169.2 9.2 160 20.5 160c7.1 0 13.7 3.7 17.5 9.8l7.7 12.5c21.7 35.2 54.9 60.9 93.1 73.3c-7-19.9-10.8-41.3-10.8-63.5C128 86 214 0 320 0zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faUsersViewfinder = {
  prefix: 'fas',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"]
};
var faFileVideo = {
  prefix: 'fas',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
};
var faCherries = {
  prefix: 'fas',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", "M288 24L302.1 4.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1c0 0 0 0 0 0s0 0 0 0l0 0 0 .2-.1 .9c-.1 .9-.3 2.2-.6 4c-.6 3.6-1.5 9-2.9 15.8c-2.8 13.7-7.6 33.3-15.3 56.3c-14 42-37.4 94.7-75.8 143.7C152.3 233.5 126.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.5 0-38.9 4.3-54 9.7c27.1-42.6 45-85.1 56.7-120.2c5.7-17 9.9-32.3 13-45.1c11.7 10.8 25.8 24.7 40.1 41.2c29.6 34.3 59.1 78.4 73.1 128.5c-12-5.3-27-10.3-44.2-12.7C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.2 10.6-76.3 19.6C453.5 176 415.2 118.9 380.2 78.3c-19.9-23-39.2-41.3-53.6-53.9c-7.2-6.3-13.2-11.2-17.5-14.5c-2.1-1.7-3.8-3-5-3.9c-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1 0 0 0 0s0 0-14.1 19.4z"]
};
var faUpRightFromSquare = {
  prefix: 'fas',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faCircleSort = {
  prefix: 'fas',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96z"]
};
var faSortCircle = faCircleSort;
var faTableCells = {
  prefix: 'fas',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"]
};
var faTh = faTableCells;
var faFilePdf = {
  prefix: 'fas',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
};
var faSiren = {
  prefix: 'fas',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M73 152.1L48 352h57.9l22.2-178c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9L138.1 352H400L375 152.1C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1zM32 384c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H32z"]
};
var faArrowUpToDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-9.4 233.4l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 269.3V336 448c0 17.7 14.3 32 32 32s32-14.3 32-32V336 269.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faImageLandscape = {
  prefix: 'fas',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm328 64c-8 0-15.5 4-20 10.7l-56 84L234.7 265c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H424c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C343.5 196 336 192 328 192zM160 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLandscape = faImageLandscape;
var faTankWater = {
  prefix: 'fas',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M285.9 96l-22-40.3L251 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H197L184.1 55.7 162.1 96H64V297.9c8.3-3 16.2-6.8 23.3-10.8c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 18.9 12.7c15.8 9 35.5 16.8 55.2 16.9h.4c19.6 0 39.3-7.9 55.2-16.9c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 19 12.8c7.1 4 15 7.9 23.4 10.8V96H285.9zM175 139.2L212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7L273 139.2c4.6 8.4 7 17.9 7 27.5V168c0 30.9-25.1 56-56 56s-56-25.1-56-56v-1.4c0-9.6 2.4-19 7-27.5z"]
};
var faCurlingStone = {
  prefix: 'fas',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", "M224 128c0-17.7 14.3-32 32-32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-53 0-96 43-96 96v32c-35.3 0-64 28.7-64 64c-53 0-96 43-96 96v16H576V320c0-53-43-96-96-96c0-35.3-28.7-64-64-64H224V128zM576 368H0v16c0 53 43 96 96 96H480c53 0 96-43 96-96V368z"]
};
var faCurling = faCurlingStone;
var faGamepadModern = {
  prefix: 'fas',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384H424l3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2v-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faGamepadAlt = faGamepadModern;
var faMessagesQuestion = {
  prefix: 'fas',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V320H64c-35.3 0-64-28.7-64-64V64zM256 352h96c53 0 96-43 96-96V128H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H544v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320c-35.3 0-64-28.7-64-64V352zM136.2 92.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 146.1c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6H180.2c-19.8 0-37.4 12.4-44 31.1zM234.7 248a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0z"]
};
var faBookBible = {
  prefix: 'fas',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"]
};
var faBible = faBookBible;
var faO = {
  prefix: 'fas',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"]
};
var faSuitcaseMedical = {
  prefix: 'fas',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faMedkit = faSuitcaseMedical;
var faBriefcaseArrowRight = {
  prefix: 'fas',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM297 191l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H152c-13.3 0-24-10.7-24-24s10.7-24 24-24H302.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faExpandWide = {
  prefix: 'fas',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M32 64C14.3 64 0 78.3 0 96v96c0 17.7 14.3 32 32 32s32-14.3 32-32V128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V320zM384 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32H384zM512 320c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V320z"]
};
var faClockElevenThirty = {
  prefix: 'fas',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392V263.3l-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3V392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faRv = {
  prefix: 'fas',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", "M224 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16V32H512c53 0 96 43 96 96c0 17.7-14.3 32-32 32H384V416H254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H96L18.7 338.7C6.7 326.7 0 310.5 0 293.5V96C0 60.7 28.7 32 64 32H224V16zM112 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112zm96 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80-48V400 320 288 216 192h24 76.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V320v64c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80V416zM578.1 288l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48H578.1z"]
};
var faUserSecret = {
  prefix: 'fas',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"]
};
var faOtter = {
  prefix: 'fas',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faDreidel = {
  prefix: 'fas',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", "M438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 146.7 225.9 84.7c-18.7-18.7-49.1-18.7-67.9 0l-57.4 57.4L337.9 379.3l57.4-57.4c18.7-18.7 18.7-49.1 0-67.9L333.3 192 438.6 86.6zM315.3 401.9L78.1 164.7 18.7 224C6.7 236 0 252.3 0 269.3V416c0 35.3 28.7 64 64 64H210.7c17 0 33.3-6.7 45.3-18.7l59.3-59.3z"]
};
var faPersonDress = {
  prefix: 'fas',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"]
};
var faFemale = faPersonDress;
var faCommentDollar = {
  prefix: 'fas',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"]
};
var faBusinessTime = {
  prefix: 'fas',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faBriefcaseClock = faBusinessTime;
var faFlowerTulip = {
  prefix: 'fas',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", "M96 44v84c0 70.7 57.3 128 128 128V394.8C192.1 349.5 139.5 320 80 320H29.5C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512H224h32 32 61.5C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5H432c-59.5 0-112.1 29.5-144 74.8V256c70.7 0 128-57.3 128-128V44c0-6.6-5.4-12-12-12c-2.6 0-5.1 .8-7.2 2.4L336 80 268.8 5.3c-3-3.4-7.4-5.3-11.9-5.3h-1.7c-4.5 0-8.9 1.9-11.9 5.3L176 80 115.2 34.4c-2.1-1.6-4.6-2.4-7.2-2.4c-6.6 0-12 5.4-12 12z"]
};
var faPeoplePantsSimple = {
  prefix: 'fas',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C482.7 191.9 448 160 406.4 160H361.6z"]
};
var faCloudDrizzle = {
  prefix: 'fas',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-8 56v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 64v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V440c0-13.3 10.7-24 24-24zm-72-40v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24z"]
};
var faTableCellsLarge = {
  prefix: 'fas',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faThLarge = faTableCellsLarge;
var faBookTanakh = {
  prefix: 'fas',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"]
};
var faTanakh = faBookTanakh;
var faSolarSystem = {
  prefix: 'fas',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M448 256c0 41.9-13.4 80.6-36.2 112.2C387.3 370.3 368 390.9 368 416c0 26.5 21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192zM256 448C150 448 64 362 64 256c0-41.9 13.4-80.6 36.2-112.2C124.7 141.7 144 121.1 144 96c0-26.5-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448zM389.2 182.7c1.8-4.6 2.8-9.5 2.8-14.7c0-22.1-17.9-40-40-40c-4 0-7.8 .6-11.5 1.7C316.4 113.5 287.3 104 256 104c-83.9 0-152 68.1-152 152s68.1 152 152 152s152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3zM312 168.4c.2 20.6 16 37.6 36.2 39.5c7.5 14.4 11.8 30.8 11.8 48.2c0 57.4-46.6 104-104 104s-104-46.6-104-104s46.6-104 104-104c20.6 0 39.8 6 56 16.4zm8 87.6a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faSealQuestion = {
  prefix: 'fas',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64h64c26.5 0 48 21.5 48 48v64l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1V400c0 26.5-21.5 48-48 48H335.1l-45.1 45.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448H112c-26.5 0-48-21.5-48-48V335.1L18.4 289.5c-18.7-18.7-18.7-49.1 0-67.9L64 176V112c0-26.5 21.5-48 48-48h64l46.1-46.1zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPhoneVolume = {
  prefix: 'fas',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"]
};
var faVolumeControlPhone = faPhoneVolume;
var faDiscDrive = {
  prefix: 'fas',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M32 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z"]
};
var faHatCowboySide = {
  prefix: 'fas',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"]
};
var faTableRows = {
  prefix: 'fas',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 0V224H448V96H128zM448 288H128V416H448V288z"]
};
var faRows = faTableRows;
var faLocationExclamation = {
  prefix: 'fas',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 96c13.3 0 24 10.7 24 24V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMapMarkerExclamation = faLocationExclamation;
var faFaceFearful = {
  prefix: 'fas',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM96 224a64 64 0 1 1 128 0A64 64 0 1 1 96 224zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8zM192.4 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faClipboardUser = {
  prefix: 'fas',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"]
};
var faBusSchool = {
  prefix: 'fas',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", "M256 0C380.8 0 464 35.2 464 80V96v16h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H464v28.2c9.8 8.8 16 21.6 16 35.8v96c0 20.9-13.4 38.7-32 45.3V480c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V448H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V445.3c-18.6-6.6-32-24.4-32-45.3V304c0-14.2 6.2-27 16-35.8V240H32c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32H48V96 80C48 35.2 131.2 0 256 0zM112 160v64c0 17.7 14.3 32 32 32h96V128H144c-17.7 0-32 14.3-32 32zm160 96h96c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H272V256zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16z"]
};
var faFilmSlash = {
  prefix: 'fas',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM224 150.3V128c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H318.1L224 150.3zM487.4 480l-87-68.5c-4.8 2.9-10.4 4.5-16.4 4.5H256c-17.7 0-32-14.3-32-32V320c0-14.1 9.1-26.1 21.8-30.3l-71.1-56c.8 2 1.3 4.1 1.3 6.4v32c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h32c.9 0 1.9 .1 2.8 .2L64 146.4V416c0 35.3 28.7 64 64 64H487.4zM112 368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16V368zM464 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H480c-8.8 0-16-7.2-16-16V240zM480 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H480c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"]
};
var faSquareArrowDownRight = {
  prefix: 'fas',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24h94.1L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135V184c0-13.3 10.7-24 24-24s24 10.7 24 24V344c0 13.3-10.7 24-24 24H160z"]
};
var faBookSparkles = {
  prefix: 'fas',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM264 200l16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 200l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 248l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 248l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 200zM168.8 78.3c2.9-5.9 11.4-5.9 14.3 0L192 96l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 128l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 128l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 96l8.8-17.7z"]
};
var faBookSpells = faBookSparkles;
var faWashingMachine = {
  prefix: 'fas',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 328c-61.9 0-112-50.1-112-112c0-16.5 3.6-32.2 10-46.3c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416z"]
};
var faWasher = faWashingMachine;
var faChild = {
  prefix: 'fas',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"]
};
var faLiraSign = {
  prefix: 'fas',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"]
};
var faUserVisor = {
  prefix: 'fas',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M343 175.2C324.2 222.5 278 256 224 256s-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2V80c0-17.7 14.3-32 32-32h12.1C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48H336c17.7 0 32 14.3 32 32v64c0 15.3-10.7 28-25 31.2zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zm348.7-19.9c2.4 3.2 7.3 1.4 7.3-2.5c-1.1-35.3-11.3-65.6-30.1-90.2c-1.2-2-4.6-1.9-6.1-.1c-19.9 23-31.9 53-35.8 89.5c-.3 3.5 3.7 5.5 6.5 3.5c1.8-1.4 4.1-3.4 6.6-5.6c9.2-8.1 22.3-19.5 31.7-19.5c2.3 2 7.6 7.8 19.9 25zM144 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
};
var faFilePlusMinus = {
  prefix: 'fas',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM208 208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V208c0-8.8 7.2-16 16-16s16 7.2 16 16zM128 384H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faChessClockFlip = {
  prefix: 'fas',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", "M384 56c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H488v48h88c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64H96V112c0-8.8 7.2-16 16-16H240c8.8 0 16 7.2 16 16v16H440V80H408c-13.3 0-24-10.7-24-24zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zm-52.7-59.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48c6.2-6.2 16.4-6.2 22.6 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm16-176v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faChessClockAlt = faChessClockFlip;
var faSatellite = {
  prefix: 'fas',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"]
};
var faPlaneLock = {
  prefix: 'fas',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faSteeringWheel = {
  prefix: 'fas',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M224 358.9v86.5C143.6 431.9 80.1 368.4 66.7 288H168.9L224 358.9zm64 0L343.1 288H445.3C431.9 368.4 368.4 431.9 288 445.3V358.9zM352 224l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7H195.8c-12.1 0-23.2 6.8-28.6 17.7L160 224H66.7C81.9 133.2 160.9 64 256 64s174.1 69.2 189.3 160H352zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
var faTag = {
  prefix: 'fas',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faStretcher = {
  prefix: 'fas',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M83 79.2C64.9 59.8 34.5 58.9 15.2 77S-5.1 125.5 13 144.8L123.5 262.7c15.1 16.1 36.3 25.3 58.4 25.3H592c26.5 0 48-21.5 48-48s-21.5-48-48-48H188.8L83 79.2zM240 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 64-46.5H391.2L368 336.9 344.8 320H263.2l64 46.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faBookSection = {
  prefix: 'fas',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM228.5 241.3l7.5 2c37.9 9.8 46.1 15 43.6 27.7c-2.5 13.2-23.7 19.6-51.7 15.7c-10.2-1.4-22.4-5.4-33.1-8.9l-5.9-1.9c-8.4-2.7-17.4 1.9-20.1 10.4c-2.7 8.4 2 17.4 10.4 20.1l5.8 1.9c12 3.9 25.7 8.3 38.6 10.1c7 1 13.8 1.5 20.2 1.5c36.5 0 62.2-15.8 67.3-42.8c4.1-21.2-4-34.9-16.7-44.4c8.7-7.1 14.5-16.4 16.7-27.6c8.6-45.1-36.9-56.9-67-64.7l0 0-7.3-1.9c-36.5-9.7-38-16.5-36.2-25.8c2.5-13.2 23.8-19.7 51.6-15.7c6.6 .9 14.6 2.9 25.2 6.2c8.3 2.6 17.4-2.1 20-10.5c2.6-8.4-2.1-17.4-10.5-20c-12.2-3.8-21.9-6.2-30.2-7.3c-47.1-6.7-81.5 9.6-87.5 41.3c-4.1 21.3 4.4 35.1 16.7 44.5c-8.7 7.1-14.5 16.4-16.7 27.5c-8.5 44.6 37.4 56.8 59.5 62.7zm-2.9-72.8c.9 .2 10.3 2.7 10.3 2.7c37.9 9.8 46.1 15 43.6 27.7c-2.2 11.3-16.5 14.9-25.2 16.1c-3.6-1-17.7-4.7-17.7-4.7c-36.5-9.7-38-16.5-36.2-25.8c2.2-11.3 16.5-14.9 25.2-16.1z"]
};
var faBookLaw = faBookSection;
var faInboxes = {
  prefix: 'fas',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M117.7 64L79.3 160h45c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7h45L394.3 64H117.7zM60.3 35.2C68.8 13.9 89.4 0 112.2 0H399.8c22.9 0 43.5 13.9 52 35.2L508 175.8c2.6 6.6 4 13.7 4 20.8V264c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V196.6c0-7.1 1.4-14.2 4-20.8L60.3 35.2zM48 352h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faCoffeeBean = {
  prefix: 'fas',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M331.4 203.3c24.4-24.6 45.4-67.3 59.9-101.7c5.1-12.2 20.9-15.3 28.2-4.3c51.2 77.7 26.2 201.2-63.4 290.8c-79.6 79.6-186 108.1-263.2 77.7c-14.8-5.8-20-23.2-13.2-37.5c.7-1.6 1.5-3.1 2.2-4.7c16.5-34.5 37.5-72.2 57.4-92.3c29.7-29.9 59.7-44.9 91.8-61l.5-.3 0 0c32-15.9 66.1-32.9 99.7-66.8zM53.1 409.7c-5.3 11-19.9 13.6-26.9 3.6c-54-77.4-29.6-203.2 61.2-294C167.6 39.1 275.1 10.7 352.5 42.4c14 5.7 19.4 22 13.7 36c-1.4 3.5-2.9 7.1-4.4 10.8c-14.5 34.5-33.5 71.8-53.1 91.5c-29.7 29.9-59.7 44.9-91.8 61l-.5 .3c-32 15.9-66.1 32.9-99.7 66.8c-24.1 24.3-47.1 66.6-63.6 101z"]
};
var faCircleYen = {
  prefix: 'fas',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.9 150.2c9.8-8.9 25-8.2 33.9 1.6L256 220.3l62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H280v32h40c8.8 0 16 7.2 16 16s-7.2 16-16 16H280v25c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h40V288H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h31.6l-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z"]
};
var faBracketsCurly = {
  prefix: 'fas',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M416 32H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32 14.3 32 32v37.5c0 25.5 10.1 49.9 28.1 67.9L498.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9V384c0 17.7-14.3 32-32 32H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c53 0 96-43 96-96V346.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6V128c0-53-43-96-96-96zM160 32c-53 0-96 43-96 96v37.5c0 8.5-3.4 16.6-9.4 22.6L9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c6 6 9.4 14.1 9.4 22.6V384c0 53 43 96 96 96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V346.5c0-25.5-10.1-49.9-28.1-67.9L77.3 256l22.6-22.6c18-18 28.1-42.4 28.1-67.9V128c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160z"]
};
var faEllipsisStrokeVertical = {
  prefix: 'fas',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96A72 72 0 1 1 96 24a72 72 0 1 1 0 144zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 256zm96 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 416z"]
};
var faEllipsisVAlt = faEllipsisStrokeVertical;
var faComment = {
  prefix: 'fas',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"]
};
var faSquare1 = {
  prefix: 'fas',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm236 35.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4V336H160c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V152c0-8.6-4.6-16.5-12-20.8z"]
};
var faCakeCandles = {
  prefix: 'fas',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faHeadSide = {
  prefix: 'fas',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faEnvelope = {
  prefix: 'fas',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"]
};
var faDollyEmpty = {
  prefix: 'fas',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64h72.9L197 340.2c-22.5 17.6-37 45-37 75.8c0 53 43 96 96 96c52.4 0 95.1-42 96-94.3l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2L331.8 357c-17.2-22.1-43.9-36.5-74-37L165.7 43.8C156.9 17.6 132.5 0 104.9 0H32z"]
};
var faFaceTissue = {
  prefix: 'fas',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", "M512 256c0 141.4-114.6 256-256 256c-11.5 0-22.9-.8-34-2.2c.6-1.9 1-3.9 1.4-5.9l18.4-110.2 5.4 3.6c5.4 3.6 12.4 3.6 17.8 0L304 371.2l39.1 26.1c4.8 3.2 10.9 3.6 16 1l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-23.7 11.8-40.3-26.8c-5.4-3.6-12.4-3.6-17.8 0L256 364.8l-8.5-5.7 7.9-47.2c2.5-15.3-2.4-30.9-13.4-41.8s-26.5-16-41.8-13.4l-192 32c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM133.5 130.7c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 141.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6zM219.3 292.7c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5z"]
};
var faAnglesUp = {
  prefix: 'fas',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"]
};
var faAngleDoubleUp = faAnglesUp;
var faBinRecycle = {
  prefix: 'fas',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M0 64C0 46.3 14.3 32 32 32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zm32 64H544L517.3 421.8c-3 33-30.6 58.2-63.7 58.2H122.4c-33.1 0-60.7-25.2-63.7-58.2L32 128zm256 88c2.2 0 4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6c11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-20.7 29.6c-7.9 11.3-4.7 26.8 6.9 34.1c10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6c1.3-1.8 3.3-2.9 5.5-2.9zm-88.3 77.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4H240c13.3 0 24-10.7 24-24s-10.7-24-24-24H190.4c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l21.5-30.7c7.9-11.3 4.7-26.8-6.9-34.1zM312 392c0 13.3 10.7 24 24 24h49.6c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6c-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4H336c-13.3 0-24 10.7-24 24z"]
};
var faPaperclip = {
  prefix: 'fas',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"]
};
var faChartLineDown = {
  prefix: 'fas',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm217.4 57.4L208 194.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0L304 189.3l57.4 57.4L329 279c-15.1 15.1-4.4 41 17 41H456c13.3 0 24-10.7 24-24V185.9c0-21.4-25.9-32.1-41-17l-32.4 32.4-80-80c-12.5-12.5-32.8-12.5-45.3 0z"]
};
var faArrowRightToCity = {
  prefix: 'fas',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faLockA = {
  prefix: 'fas',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", "M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zm49.7 280.8L209.6 265c.8-1.6 1.8-3 3-4.3c1.4-1.5 3.1-2.6 5-3.4c2.1-.9 4.2-1.3 6.4-1.3s4.3 .4 6.4 1.3c1.8 .8 3.5 1.9 5 3.4c1.3 1.3 2.3 2.7 3.1 4.3l79.9 159.9c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L270.1 400H177.9l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5zM193.9 368h60.2L224 307.8 193.9 368z"]
};
var faRibbon = {
  prefix: 'fas',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", "M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"]
};
var faLungs = {
  prefix: 'fas',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"]
};
var faPersonPinball = {
  prefix: 'fas',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7v65.1l49.9 49.9c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L18.7 320C6.7 308 0 291.7 0 274.7V186.6C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64H224c12.9 0 24.1 7.7 29.1 18.7l295-49.2L515.3 95c-2.2-6.5-3.3-13.4-3.3-20.2V32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V178.2 216v8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H256v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H152.6c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64V480v0c0 17.7-14.3 32-32 32s-32-14.3-32-32zM280 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowUp91 = {
  prefix: 'fas',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"]
};
var faSortNumericUpAlt = faArrowUp91;
var faAppleCore = {
  prefix: 'fas',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M192 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H192zM30.5 167c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3c-34.9 0-69.8-18.3-98.1-49.6c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137z"]
};
var faCircleY = {
  prefix: 'fas',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM170.1 152.3L256 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L133.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"]
};
var faH6 = {
  prefix: 'fas',
  iconName: 'h6',
  icon: [640, 512, [], "e413", "M537 116l-35.3 44.1C578.6 163.1 640 226.4 640 304c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45zM416 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
};
var faLitecoinSign = {
  prefix: 'fas',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"]
};
var faCircleSmall = {
  prefix: 'fas',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
var faBorderNone = {
  prefix: 'fas',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faArrowTurnDownLeft = {
  prefix: 'fas',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", "M448 64c0-17.7 14.3-32 32-32s32 14.3 32 32V224c0 53-43 96-96 96H109.3l73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H416c17.7 0 32-14.3 32-32V64z"]
};
var faCircleNodes = {
  prefix: 'fas',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"]
};
var faParachuteBox = {
  prefix: 'fas',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"]
};
var faMessageMedical = {
  prefix: 'fas',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm224 64v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240h48c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H288V128c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faCommentAltMedical = faMessageMedical;
var faRugbyBall = {
  prefix: 'fas',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M368 16c13.4 0 26.4 2.1 38.5 5.9c-21.1 1.8-44.5 8.7-69 19.5c-53.4 23.5-114.8 66.9-172.1 124.1S64.9 284.1 41.4 337.6c-10.8 24.5-17.7 47.9-19.5 69C18.1 394.4 16 381.4 16 368l0-32C16 159.3 159.3 16 336 16l32 0zm122.1 89.5c3.8 12.2 5.9 25.1 5.9 38.5v32c0 176.7-143.3 320-320 320H144c-13.4 0-26.4-2.1-38.5-5.9c21.1-1.8 44.5-8.7 69-19.5c53.4-23.5 114.8-66.9 172.1-124.1s100.6-118.6 124.1-172.1c10.8-24.5 17.7-47.9 19.5-69zM63.7 448.3c-6.7-6.7-10.9-17.8-10.2-34.8c.7-17.1 6.3-38.5 17.1-63c21.5-49 62.3-107.1 117.5-162.3s113.4-95.9 162.3-117.5c24.5-10.8 45.9-16.4 63-17.1c17.1-.7 28.1 3.5 34.8 10.2s10.9 17.8 10.2 34.8c-.7 17.1-6.3 38.5-17.1 63c-21.5 49-62.3 107.1-117.5 162.3s-113.4 95.9-162.3 117.5c-24.5 10.8-45.9 16.4-63 17.1c-17.1 .7-28.1-3.4-34.8-10.2z"]
};
var faCommentMusic = {
  prefix: 'fas',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm96-320v32V288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V183.1l-96 36V320c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V208 176c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z"]
};
var faIndent = {
  prefix: 'fas',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"]
};
var faTreeDeciduous = {
  prefix: 'fas',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M384 80c-11.5 0-22.5 2.4-32.4 6.8C347 38.1 305.9 0 256 0s-91 38.1-95.6 86.8C150.5 82.4 139.5 80 128 80c-44.2 0-80 35.8-80 80c0 14.4 3.8 27.9 10.5 39.6C24.1 214.2 0 248.3 0 288c0 53 43 96 96 96H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H416c53 0 96-43 96-96c0-39.7-24.1-73.8-58.5-88.4c6.7-11.7 10.5-25.2 10.5-39.6c0-44.2-35.8-80-80-80z"]
};
var faTreeAlt = faTreeDeciduous;
var faPuzzlePieceSimple = {
  prefix: 'fas',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M264.8 64C277.6 64 288 74.4 288 87.2v0c0 9.2-5.8 17.3-13.2 22.8c-11.6 8.7-18.8 20.7-18.8 34c0 26.5 28.7 48 64 48s64-21.5 64-48c0-13.3-7.2-25.3-18.8-34c-7.4-5.5-13.2-13.6-13.2-22.8v0C352 74.4 362.4 64 375.2 64H464c26.5 0 48 21.5 48 48v88.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V400c0 26.5-21.5 48-48 48H375.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H176c-26.5 0-48-21.5-48-48V311.2c0-12.8-10.4-23.2-23.2-23.2v0c-9.2 0-17.3 5.8-22.8 13.2C73.3 312.8 61.3 320 48 320c-26.5 0-48-28.7-48-64s21.5-64 48-64c13.3 0 25.3 7.2 34 18.8c5.5 7.4 13.6 13.2 22.8 13.2v0c12.8 0 23.2-10.4 23.2-23.2V112c0-26.5 21.5-48 48-48h88.8z"]
};
var faPuzzlePieceAlt = faPuzzlePieceSimple;
var faTruckFieldUn = {
  prefix: 'fas',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faNfcTrash = {
  prefix: 'fas',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5H400c-5.6 0-11 1-16 2.7V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v96V368c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H336c16.4 0 30.9-8.2 39.6-20.8l6.1 84.8H64c-35.3 0-64-28.7-64-64V96zM449.7 200.8c2.7-5.4 8.2-8.8 14.3-8.8h96c6.1 0 11.6 3.4 14.3 8.8L585.9 224H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H576 448 400c-8.8 0-16-7.2-16-16s7.2-16 16-16h38.1l11.6-23.2zM413.9 482.3L400 288H624L610.1 482.3C608.9 499 595 512 578.2 512H445.8c-16.8 0-30.7-13-31.9-29.7z"]
};
var faHourglass = {
  prefix: 'fas',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"]
};
var faHourglassEmpty = faHourglass;
var faMountain = {
  prefix: 'fas',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"]
};
var faFileXmark = {
  prefix: 'fas',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faFileTimes = faFileXmark;
var faHouseHeart = {
  prefix: 'fas',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM176 269.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faHomeHeart = faHouseHeart;
var faHouseChimneyBlank = {
  prefix: 'fas',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"]
};
var faMeterBolt = {
  prefix: 'fas',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M256 512c73.7 0 140.1-31.1 186.8-81l7.5-15H432c-20.4 0-38.5-12.9-45.3-32.1s-.6-40.6 15.3-53.4l109.6-87.7C504.8 107.5 393 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm218.1 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H553.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
var faUserDoctor = {
  prefix: 'fas',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faUserMd = faUserDoctor;
var faSlashBack = {
  prefix: 'fas',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", "M16.1 4.2C.8 13-4.6 32.5 4.2 47.9l256 448c8.8 15.3 28.3 20.7 43.7 11.9s20.7-28.3 11.9-43.7l-256-448C51 .8 31.5-4.6 16.1 4.2z"]
};
var faCircleInfo = {
  prefix: 'fas',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faInfoCircle = faCircleInfo;
var faFishingRod = {
  prefix: 'fas',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M295.9 48c-3 0-6 .4-8.8 1.2L209.8 71.3C137.7 91.9 88 157.8 88 232.8V288h8c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8V232.8c0-96.4 63.9-181.2 156.7-207.7L273.8 3.1C281 1 288.4 0 295.9 0C340.1 0 376 35.9 376 80.1V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V80.1C328 62.4 313.6 48 295.9 48zM256 344c0-71.6 55.6-127.8 89-148.1c4.3-2.6 9.6-2.6 14 0c33.5 20.3 89 76.6 89 148.1c0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3V496c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16v-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faHammerCrash = {
  prefix: 'fas',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M283.9 378.6l18.3-60.1c18-4.1 34.2-16 43.1-33.8l64-128c10.5-21.1 8.4-45.2-3.7-63.6l52.7-76.6c3.7-5.4 10.4-8 16.7-6.5s11.2 6.7 12.3 13.1l16.2 104.1 105.1-7.4c6.5-.5 12.7 3.1 15.5 9s1.8 12.9-2.6 17.8L550.1 224l71.3 77.5c4.4 4.8 5.5 11.9 2.6 17.8s-9 9.5-15.5 9l-105.1-7.4L487.3 425c-1 6.5-5.9 11.7-12.3 13.1s-13-1.1-16.7-6.5l-59.7-86.7-91.4 52.2c-5.7 3.3-12.8 2.7-17.9-1.4s-7.2-10.9-5.3-17.2zm28.3-101.7c-9.3 10.9-25.2 14.4-38.6 7.7l-65.9-32.9 0 0L122 208.8l0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80C48.8 22.8 59.9 16 72 16H192c5 0 9.9 1.2 14.3 3.4l78.2 39.1 81.8 40.9c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-1.2 2.4-2.7 4.6-4.4 6.6zM107.6 237.4l85.9 42.9L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.2 5.1 442.5L107.6 237.4z"]
};
var faMessageHeart = {
  prefix: 'fas',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM144 173.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCloudMeatball = {
  prefix: 'fas',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faCameraPolaroid = {
  prefix: 'fas',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M64 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V246.3l53.3 79.9c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V361.7c0-12.6 3.7-25 10.7-35.5L64 246.3V96zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM448 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faCamera = {
  prefix: 'fas',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faCameraAlt = faCamera;
var faSquareVirus = {
  prefix: 'fas',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCartArrowUp = {
  prefix: 'fas',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H312V177.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V288h99.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faMeteor = {
  prefix: 'fas',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faCarOn = {
  prefix: 'fas',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
var faSleigh = {
  prefix: 'fas',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"]
};
var faArrowDown19 = {
  prefix: 'fas',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faBuoyMooring = {
  prefix: 'fas',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", "M256 32c0-17.7 14.3-32 32-32s32 14.3 32 32V68.7c38 11.5 67.8 43.2 75.9 83.7l48.5 242.7c-.4 .3-.9 .6-1.3 .9c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-19 0-41.2-7.9-59.2-20.3c-.4-.3-.9-.6-1.3-.9l48.5-242.7c8.1-40.6 37.9-72.2 75.9-83.7V32zm32 96c-22 0-40.9 15.5-45.2 37L218.2 288H357.8L333.2 165c-4.3-21.5-23.2-37-45.2-37zm18.5 293.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faSquare4 = {
  prefix: 'fas',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm191.6 33.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H240v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H169.3l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"]
};
var faHandHoldingDroplet = {
  prefix: 'fas',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faTricycleAdult = {
  prefix: 'fas',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M312 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h31.4c2.6 0 5 1.3 6.5 3.4l79.2 112.5-48.2 64.3c-5.6 7.5-14.4 11.9-23.7 11.9c-1.9 0-3.8-.2-5.7-.5l-322.9-63c-13-2.5-25.6 6-28.2 19s6 25.6 19 28.2l4.6 .9C9.1 305.4 0 327.6 0 352c0 53 43 96 96 96c18.2 0 35.3-5.1 49.8-13.9c-.6 .4-1.2 .7-1.8 1.1c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-4.1-.3-8.2-.8-12.2l55.1 10.7c4.9 1 9.9 1.4 14.9 1.4c24.4 0 47.4-11.5 62.1-31.1l38.8-51.8 13.7 19.5C457 305.6 448 327.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-11.4 0-22.3 2-32.5 5.6L389.2 87.8C378.7 72.9 361.6 64 343.4 64H312zM223.5 327.4c5.3 6.8 8.5 15.3 8.5 24.6c0 22.1-17.9 40-40 40c-2.9 0-5.6-.3-8.3-.9c5.3-12 8.3-25.2 8.3-39.1c0-11.2-1.9-21.9-5.4-31.8l36.9 7.2zM96 312a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm448 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM94.1 117.2c-6-16.6-24.3-25.3-40.9-19.3s-25.3 24.3-19.3 40.9l14.9 41.7c9.4 26.2 31.7 45.6 58.9 51.3l77.7 16.3c17.3 3.6 34.3-7.4 37.9-24.7s-7.4-34.3-24.7-37.9l-77.7-16.3c-5.4-1.1-9.9-5-11.8-10.3L94.1 117.2z"]
};
var faWaveform = {
  prefix: 'fas',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H576c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H46.3l26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z"]
};
var faWater = {
  prefix: 'fas',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faStarSharpHalfStroke = {
  prefix: 'fas',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M56 230.4L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176H74.7h2.5 .1H214.5L258.6 37.2l.1-.3 1.3-4 0 0 5.2-16.2C268.3 6.8 277.6 0 288 0s19.7 6.8 22.9 16.7L316 32.9l1.3 4 .1 .3L361.6 176H498.7h.1 2.5H520c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L520 230.4l-2 1.5-.1 .1-114 88.7 44.4 139.5 .1 .4 1.4 4.5 5 15.7c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7l-13-10.1-3.7-2.9-.3-.3L288 406.4 175.8 493.7l-.3 .3-3.7 2.9-13 10.1c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l5-15.7 1.4-4.5 .1-.4 44.4-139.5L58.1 232l-.1-.1-2-1.5zM288 335.5l0 0 34.4 26.7 47.9 37.2-19.7-61.8-11.8-37.2 30.8-24L426.7 232H361.6h-41l-12.4-39L288 129.5l0 0V335.5z"]
};
var faStarSharpHalfAlt = faStarSharpHalfStroke;
var faNfcSignal = {
  prefix: 'fas',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V227c-22.4 3.4-43.8 9.6-64 18.3V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V261.7c-47.2 28.4-84.8 71.2-106.7 122.3H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H233.9c-5.8 20.4-9.2 41.9-9.8 64H64c-35.3 0-64-28.7-64-64V96zM488 256c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24c-48.6 0-88 39.4-88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136c13.3 0 24 10.7 24 24z"]
};
var faPlaneProp = {
  prefix: 'fas',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M240 384l-8.3-66.4-110-11L113.8 370c-1 8-7.8 14-15.9 14H62.1c-8.1 0-14.9-6-15.9-14L36 287.8c-1.3 .2-2.6 .2-4 .2c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.3 0 2.7 .1 4 .2L46.2 142c1-8 7.8-14 15.9-14H97.9c8.1 0 14.9 6 15.9 14l7.9 63.4 110-11L240 128H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h24l6.2-50c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14L328 64h40V48c0-8.8 7.2-16 16-16s16 7.2 16 16V80c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V128H336l8 64H482.3c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64H344l-8 64h32V368c0-8.8 7.2-16 16-16s16 7.2 16 16v32c8.8 0 16 7.2 16 16s-7.2 16-16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H328l-6.2 50c-1 8-7.8 14-15.9 14H270.1c-8.1 0-14.9-6-15.9-14L248 448H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h16z"]
};
var faCalendarCheck = {
  prefix: 'fas',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"]
};
var faClockDesk = {
  prefix: 'fas',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M0 224a224 224 0 1 1 448 0A224 224 0 1 1 0 224zM224 96c-13.3 0-24 10.7-24 24V224c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41V120c0-13.3-10.7-24-24-24zm0 384c96.4 0 180.3-53.3 224-132V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V348c43.7 78.7 127.6 132 224 132z"]
};
var faCalendarClock = {
  prefix: 'fas',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H432 0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7V192zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
};
var faCalendarTime = faCalendarClock;
var faBraille = {
  prefix: 'fas',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faPrescriptionBottleMedical = {
  prefix: 'fas',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faPlateUtensils = {
  prefix: 'fas',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M40.7 16c4 .3 7.1 3.5 7.3 7.5L55.5 152H72.9L88.1 23.1c.5-4 3.9-7.1 7.9-7.1s7.5 3 7.9 7.1L119.1 152h17.3L144 23.5c.2-4 3.3-7.2 7.3-7.5s7.6 2.3 8.5 6.1l30.3 128.7c1.3 5.4 1.9 11 1.9 16.6c0 39.9-32.2 72.2-72 72.5V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V240c-39.8-.3-72-32.6-72-72.5c0-5.6 .6-11.2 1.9-16.6L32.2 22.2c.9-3.9 4.5-6.5 8.5-6.1zm572.4 1c2-.7 4-1 6.1-1c11.5 0 20.9 9.3 20.9 20.9V216 320 472c0 13.3-10.7 24-24 24s-24-10.7-24-24V320H544c-17.7 0-32-14.3-32-32V160C512 59.2 596.2 23.2 613.1 17zM221.2 143.6L204.9 74.3C241.8 47.7 287.1 32 336 32c60.3 0 115 23.8 155.3 62.5C484.3 113.3 480 135 480 160v26.2C454.1 132.8 399.3 96 336 96c-44.9 0-85.5 18.5-114.6 48.3l-.2-.8zM336 480c-76.2 0-143.5-38.1-184-96.2V266.8c8.5-2.8 16.6-6.7 24-11.4l0 .6c0 88.4 71.6 160 160 160c68.1 0 126.2-42.5 149.3-102.4c9.2 21 29.3 36.2 53.2 38.2C502.6 427.6 425.4 480 336 480zM208 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z"]
};
var faFamilyPants = {
  prefix: 'fas',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 160h44.8c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.5 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-3.9-.3-7.8-.8-11.5c8.3-2.9 17.2-4.5 26.4-4.5h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336c0-44.2 35.8-80 80-80z"]
};
var faHoseReel = {
  prefix: 'fas',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", "M320 64c-106 0-192 86-192 192s86 192 192 192c40.8 0 78.6-12.7 109.7-34.4c14.5-10.1 34.4-6.6 44.6 7.9s6.6 34.4-7.9 44.6C424.8 495 374.3 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256v96h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-2.3l-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16H520c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L506.3 400H504c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V256c0-106-86-192-192-192zM224 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faHouseWindow = {
  prefix: 'fas',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM248 192h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H248c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24z"]
};
var faLandmark = {
  prefix: 'fas',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"]
};
var faTruck = {
  prefix: 'fas',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCrosshairs = {
  prefix: 'fas',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCloudRainbow = {
  prefix: 'fas',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M560 64.4C466.8 69.5 385.4 119 336.5 192l-.5 0c-19.7 0-38.3 5.1-54.4 14.1c-5.5-6-11.5-11.4-18-16.4C319.9 81.4 430.9 6.1 560 .4c8.8-.4 16 6.8 16 15.6V48c0 8.8-7.2 16-16 16.4zM424 234.7c-13.3-16.9-31.5-29.9-52.3-36.9C415.4 139.9 483.1 101.2 560 96.5c8.8-.5 16 6.7 16 15.5v32c0 8.8-7.2 15.9-16 16.7c-55.3 4.6-104 32.6-136 74zm23.4 57.2c-1-9.1-3-17.9-6.1-26.2c25.7-40.1 68.9-67.9 118.8-72.9c8.8-.9 16 6.4 16 15.2v32c0 8.8-7.2 15.9-15.9 17.3c-31.4 5.2-57.7 25.8-70.9 53.7c-12.5-8.7-26.6-15.3-41.8-19.1zM96 512c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 318.1 64 311.1 64 304c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96z"]
};
var faPersonCane = {
  prefix: 'fas',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"]
};
var faAlien = {
  prefix: 'fas',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M224 0C100.3 0 0 100.3 0 224C0 359.3 148.8 471.7 194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0zm32 306.3c0-45.4 36.8-82.3 82.3-82.3h32c7.6 0 13.7 6.1 13.7 13.7c0 45.4-36.8 82.3-82.3 82.3h-32c-7.6 0-13.7-6.1-13.7-13.7zM109.7 224c45.4 0 82.3 36.8 82.3 82.3c0 7.6-6.1 13.7-13.7 13.7h-32C100.8 320 64 283.2 64 237.7c0-7.6 6.1-13.7 13.7-13.7h32z"]
};
var faTent = {
  prefix: 'fas',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"]
};
var faLaptopBinary = {
  prefix: 'fas',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM200 128h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V168c0-22.1 17.9-40 40-40zm-8 40v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8zm112-40h16c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H424c-22.1 0-40-17.9-40-40V168zm40-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H424zM192 272h16c8.8 0 16 7.2 16 16v64H192V304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 16v64H416V304c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16zm-80 24v40l-32 0V312c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v40l-32 0V312c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40z"]
};
var faVestPatches = {
  prefix: 'fas',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faPeopleDressSimple = {
  prefix: 'fas',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4H112.3zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4H368.3z"]
};
var faCheckDouble = {
  prefix: 'fas',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"]
};
var faArrowDownAZ = {
  prefix: 'fas',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faBowlingBallPin = {
  prefix: 'fas',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", "M416 64c0-35.3 28.7-64 64-64s64 28.7 64 64v1.1c0 7.4-1 14.8-3 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1H438.5c-.5-2.7-1.1-5.4-1.8-8.1L418.9 87.1c-2-7.2-2.9-14.6-2.9-22V64zm22.8 128h82.3c1 6.3 2.6 12.4 4.8 18.4L566 319.3c6.6 17.9 10 36.8 10 55.8c0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C536.9 504 525.1 512 512 512H448c-13.1 0-24.9-8-29.7-20.1l-17.8-44.5c29.8-40 47.5-89.6 47.5-143.4c0-30.7-5.8-60.1-16.3-87.1l2.4-6.5c2.2-6 3.8-12.1 4.8-18.4zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zM224 172a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM196 288a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0 -56 0 28 28 0 1 0 56 0z"]
};
var faBellSchoolSlash = {
  prefix: 'fas',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6L38.8 5.1zM220 147.2c14-11.9 32.1-19.2 52-19.2c44.2 0 80 35.8 80 80c0 12.9-3.1 25.1-8.5 35.9l-26.1-20.4c1.7-4.9 2.6-10.1 2.6-15.5c0-26.5-21.5-48-48-48c-9.5 0-18.4 2.8-25.9 7.6L220 147.2zM508.3 496.5L465.8 463c-3.2 .7-6.4 1-9.8 1H416V423.8l-16.1-12.7C362.9 434.5 319 448 272 448c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48H384h32 40c19.3 0 37.3-5.7 52.3-15.5zM373 389.9L71.5 152.4C66.6 170.1 64 188.7 64 208c0 114.9 93.1 208 208 208c36.7 0 71.1-9.5 101-26.1z"]
};
var faPlusLarge = {
  prefix: 'fas',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H224V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0 0-192z"]
};
var faMoneyBillWheat = {
  prefix: 'fas',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faCameraViewfinder = {
  prefix: 'fas',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0zM376 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM180 128l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6h94.7c10 0 19 6.2 22.5 15.6L332 128h36c26.5 0 48 21.5 48 48V336c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h36zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faScreenshot = faCameraViewfinder;
var faMessageMusic = {
  prefix: 'fas',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V187.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V128 96z"]
};
var faCommentAltMusic = faMessageMusic;
var faCarBuilding = {
  prefix: 'fas',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", "M48 0C21.5 0 0 21.5 0 48V432c0 26.5 21.5 48 48 48H192V448 352c0-32.8 16.5-61.8 41.6-79.1l5.6-16.9H208c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h32c8.2 0 14.9 6.1 15.9 14l.5-1.4c10.5-31.6 34.2-56 63.7-68.2V48c0-26.5-21.5-48-48-48H48zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0-96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V112zM80 288h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm282.6-64H501.4c6.9 0 13 4.4 15.2 10.9L534.3 288H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352v96h0v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H560v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32l0-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faBorderBottomRight = {
  prefix: 'fas',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 336c0 8.8-7.2 16-16 16L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l336 0c44.2 0 80-35.8 80-80l0-336zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
var faBorderStyleAlt = faBorderBottomRight;
var faOctagon = {
  prefix: 'fas',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M191.5 .1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5v129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1h-129z"]
};
var faCommentArrowUpRight = {
  prefix: 'fas',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM200 160H312c13.3 0 24 10.7 24 24V296c0 13.3-10.7 24-24 24s-24-10.7-24-24V241.9l-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faOctagonDivide = {
  prefix: 'fas',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H168zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCookie = {
  prefix: 'fas',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowRotateLeft = {
  prefix: 'fas',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faTvMusic = {
  prefix: 'fas',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", "M576 64V352H64V64H576zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zM416 112c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v48 49.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V219.1l96-36v42.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V160 112z"]
};
var faHardDrive = {
  prefix: 'fas',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faHdd = faHardDrive;
var faReel = {
  prefix: 'fas',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M0 32C0 14.3 14.3 0 32 0H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V88c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V64H32C14.3 64 0 49.7 0 32zM0 480c0-17.7 14.3-32 32-32H64V424c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v24h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM80 144H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFaceGrinSquintTears = {
  prefix: 'fas',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faDumbbell = {
  prefix: 'fas',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"]
};
var faRectangleList = {
  prefix: 'fas',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"]
};
var faListAlt = faRectangleList;
var faTarpDroplet = {
  prefix: 'fas',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faAlarmExclamation = {
  prefix: 'fas',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-200c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faHouseMedicalCircleCheck = {
  prefix: 'fas',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faTrafficCone = {
  prefix: 'fas',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M173.7 128L216 20.3C220.8 8.1 232.7 0 245.8 0h20.4c13.2 0 25 8.1 29.8 20.3L338.3 128H173.7zm-25.1 64H363.4l37.7 96H110.9l37.7-96zM48 448l37.7-96H426.3L464 448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48z"]
};
var faGrate = {
  prefix: 'fas',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64h64 96 96 64c35.3 0 64-28.7 64-64V256 96c0-35.3-28.7-64-64-64H320 224 128 64zm0 64H96V224H64V96zm0 192H96V416H64V288zm96 128V288h32V416H160zm96 0V288h32V416H256zm96 0V288h32V416H352zm32-192H352V96h32V224zM288 96V224H256V96h32zm-96 0V224H160V96h32z"]
};
var faArrowDownRight = {
  prefix: 'fas',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", "M320 416c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 146.7L86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352 96 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0z"]
};
var faPersonSkiingNordic = {
  prefix: 'fas',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"]
};
var faSkiingNordic = faPersonSkiingNordic;
var faCalendarPlus = {
  prefix: 'fas',
  iconName: 'calendar-plus',
  icon: [512, 512, [], "f271", "M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM256 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H176c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"]
};
var faPersonFromPortal = {
  prefix: 'fas',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", "M154.2 352c3.8-29.6 5.8-62.1 5.8-96c0-18.3-.6-36.1-1.7-53.4c12.4 8.3 29.4 7 40.4-4l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3C385 264.7 419.9 288 458.7 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c0 0 0 0-.1 .1C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256S35.8 512 80 512c25.3 0 47.8-37.5 62.5-96h55.1c19 0 36.2-11.2 43.9-28.5L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L187.2 352h-33zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faPortalExit = faPersonFromPortal;
var faPlaneArrival = {
  prefix: 'fas',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCowbellCirclePlus = {
  prefix: 'fas',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M112 96h16V40c0-22.1 17.9-40 40-40H280c22.1 0 40 17.9 40 40V96h16c21.4 0 40.3 14.2 46.2 34.8l18.3 64C318.3 209.7 256 281.6 256 368c0 16.6 2.3 32.7 6.6 48H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zM285.5 465.6C277.9 492.4 253.2 512 224 512c-35.3 0-64-28.7-64-64H275.2c3.1 6.1 6.6 12 10.3 17.6zM272 96V48H176V96h96zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faCowbellMore = faCowbellCirclePlus;
var faCircleLeft = {
  prefix: 'fas',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"]
};
var faArrowAltCircleLeft = faCircleLeft;
var faDistributeSpacingVertical = {
  prefix: 'fas',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M0 56C0 42.7 10.7 32 24 32H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 80 0 69.3 0 56zM96 208c0-26.5 21.5-48 48-48H368c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V208zM24 432H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSignalBarsFair = {
  prefix: 'fas',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", "M240 256c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V432c0-26.5-21.5-48-48-48z"]
};
var faSignalAlt2 = faSignalBarsFair;
var faSportsball = {
  prefix: 'fas',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M487.6 48.9c-.1-.5-.2-1-.3-1.5L365.3 169.3c34.8 30.2 79 49.8 127.6 53.9c9.3-63 4.7-125.5-5.4-174.3zM464.8 24.6c-1.1-.3-2.2-.5-3.3-.7c-65.6-11-122.9-12.5-172.8-6c3.9 49.1 23.6 93.7 54 128.8L464.8 24.6zM446 358.4c19.8-32.3 33-67.7 41.1-103.6c-55.1-5.3-105.1-28.1-144.4-62.8l-64 64L418.5 395.9c10.3-11.8 19.4-24.4 27.4-37.5zM320 169.4c-35-39.7-57.9-90.3-63-146.1c-17 3.6-33 8.3-48.1 13.9c-37 13.7-67.8 33-93.1 56L256 233.4l64-64zM233.4 256L93.4 116.1C83.2 127.9 74.1 140.5 66 153.6c-19.8 32.3-33 67.7-41.1 103.6c55.1 5.3 105.1 28.1 144.4 62.8l64-64zM192 342.6c35 39.7 58 90.3 63 146.1c17-3.6 33-8.3 48.1-13.9c37-13.7 67.8-33 93.1-56L256 278.6l-64 64zm-45.3 .1c-34.8-30.2-79-49.8-127.6-53.9c-9.3 63-4.7 125.5 5.4 174.3c.1 .5 .2 1 .3 1.5L146.7 342.7zm22.6 22.6L47.2 487.4c1.1 .3 2.2 .5 3.3 .7c65.6 11 122.9 12.5 172.8 6c-3.9-49.1-23.6-93.7-54-128.8z"]
};
var faGameConsoleHandheldCrank = {
  prefix: 'fas',
  iconName: 'game-console-handheld-crank',
  icon: [640, 512, [], "e5b9", "M32 96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V96zm96 0c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H128zm32 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160V336zm144 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM512 168c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H560v72c0 13.3-10.7 24-24 24H512V272 256 200 168z"]
};
var faTrainSubway = {
  prefix: 'fas',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSubway = faTrainSubway;
var faChartGantt = {
  prefix: 'fas',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faFaceSmileUpsideDown = {
  prefix: 'fas',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm91.9 186.5C330 165.8 299.4 144 256 144s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM367.6 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faBallPile = {
  prefix: 'fas',
  iconName: 'ball-pile',
  icon: [640, 512, [], "f77e", "M320 160A80 80 0 1 0 320 0a80 80 0 1 0 0 160zM208 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM192 432A80 80 0 1 0 32 432a80 80 0 1 0 160 0zm128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM432 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faBadgeDollar = {
  prefix: 'fas',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20v17.4c-8.8 1.8-17.7 4.8-25.7 9.6c-15 8.9-27.7 24.4-27.6 46.9c.1 21.5 12.6 35.1 26.3 43.4c11.9 7.2 27 11.7 39.1 15.4l1.9 .6c13.9 4.2 24.4 7.6 31.7 12.2c6.1 3.8 7.5 6.8 7.6 11c.1 6.5-2.5 10.4-7.6 13.6c-6 3.7-15.2 5.9-25.1 5.6c-12.7-.4-24.6-4.4-39.7-9.6l0 0 0 0 0 0 0 0c-2.6-.9-5.2-1.8-8-2.7c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2 .7 4.5 1.5 6.8 2.3c9.7 3.3 20.9 7.2 32.8 9.6v18c0 11 9 20 20 20s20-9 20-20V354.4c9.3-1.7 18.6-4.9 26.8-10.1c15.3-9.5 26.8-25.7 26.5-48.1c-.3-21.6-12.4-35.6-26.3-44.3c-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9c-6.2-3.7-7-6.3-7-9.3c0-5.1 2.1-8.8 7.9-12.3c6.5-3.8 16-6 25-5.8c10.9 .2 22.9 2.6 35.2 5.8c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4V140.4z"]
};
var faMoneyBillsSimple = {
  prefix: 'fas',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faMoneyBillsAlt = faMoneyBillsSimple;
var faListTimeline = {
  prefix: 'fas',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M16 96a48 48 0 1 1 96 0A48 48 0 1 1 16 96zM64 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM191.5 54.4c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6l38.4-28.8zM153.1 243.2l38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H488c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6zm0 160l38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4H424c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H210.7c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6z"]
};
var faIndianRupeeSign = {
  prefix: 'fas',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faCropSimple = {
  prefix: 'fas',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"]
};
var faCropAlt = faCropSimple;
var faMoneyBill1 = {
  prefix: 'fas',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"]
};
var faMoneyBillAlt = faMoneyBill1;
var faLeftLong = {
  prefix: 'fas',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"]
};
var faLongArrowAltLeft = faLeftLong;
var faKeyboardDown = {
  prefix: 'fas',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M64 0C28.7 0 0 28.7 0 64V224c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM64 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176zm112-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm272 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V176zM176 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80zM368 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V80zM153.8 366.8c-3.7 9-1.7 19.3 5.2 26.2L271 505c9.4 9.4 24.6 9.4 33.9 0L417 393c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H176c-9.7 0-18.5 5.8-22.2 14.8z"]
};
var faCircleUpRight = {
  prefix: 'fas',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 313.4V176c0-8.8-7.2-16-16-16H198.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L216 232l-66.3 66.3C146 302 144 306.9 144 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L280 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"]
};
var faCloudBoltMoon = {
  prefix: 'fas',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", "M361.4 79.9C380.6 33 427.1 0 481.2 0c3.7 0 7.3 .2 10.9 .5c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1c0 48.1 39.4 87.4 88.4 87.4c5.2 0 10.3-.4 15.2-1.3c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1c-.8 0-1.6 0-2.4 0c-5.4-37.8-29.7-69.5-63-85.3c-1.8-38.6-23.1-72.1-54.3-90.8zm86.4 192.1c0 44.2-35.8 80-80 80H349.2C342.4 332.8 324.3 320 304 320H285.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L82 330.5c-6 4.8-10.5 10.7-13.6 17.4C28.8 336 0 299.4 0 255.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7zM282.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352H304c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384H112c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faThunderstormMoon = faCloudBoltMoon;
var faDna = {
  prefix: 'fas',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"]
};
var faVirusSlash = {
  prefix: 'fas',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"]
};
var faBracketRoundRight = {
  prefix: 'fas',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M37.4 46.2C27.6 61 31.5 80.8 46.3 90.6C71.9 107.7 128 167 128 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C120.1 449 192 371.8 192 256S120.1 62.9 81.8 37.4C67 27.6 47.2 31.5 37.4 46.2z"]
};
var faCircleSterling = {
  prefix: 'fas',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H231.7l.1 9.7c.1 18.6-3.1 37-9.6 54.3H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h7.5l-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"]
};
var faCircle5 = {
  prefix: 'fas',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H228l-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3h-36c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3h36c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"]
};
var faMinus = {
  prefix: 'fas',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"]
};
var faSubtract = faMinus;
var faFireFlame = {
  prefix: 'fas',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zM188.8 148.3c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7v11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.1-112-112v-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7c6.1 0 11 4.9 11 11v44c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-13.2-13.2c-14-14-21.9-33.1-21.9-53c0-16.2 5.3-32 15-44.9l5.8-7.8z"]
};
var faFlame = faFireFlame;
var faRightToLine = {
  prefix: 'fas',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM384 416l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faArrowAltToRight = faRightToLine;
var faGif = {
  prefix: 'fas',
  iconName: 'gif',
  icon: [576, 512, [], "e190", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm296 64c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm56 24v80 64c0 13.3 10.7 24 24 24s24-10.7 24-24V288h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H400V208h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H376c-13.3 0-24 10.7-24 24zM128 256c0-26.5 21.5-48 48-48c8 0 15.4 1.9 22 5.3c11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8c7-4.4 11.2-12.1 11.2-20.3V264c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v13.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48z"]
};
var faChess = {
  prefix: 'fas',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"]
};
var faTrashSlash = {
  prefix: 'fas',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.2 364.4 512 128H195.6L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H416l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM149.2 467c1.6 25.3 22.6 45 47.9 45H442.9c20.6 0 38.3-13 45.1-31.5L132.5 200.4 149.2 467z"]
};
var faArrowLeftLong = {
  prefix: 'fas',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"]
};
var faLongArrowLeft = faArrowLeftLong;
var faPlugCircleCheck = {
  prefix: 'fas',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faFontCase = {
  prefix: 'fas',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", "M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368H255.8L290 459.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304H120.2L176 155.1 231.8 304zM608 160c-13 0-24.1 7.7-29.2 18.8C559.4 166.9 536.5 160 512 160c-70.7 0-128 57.3-128 128v64c0 70.7 57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V352 288 192c0-17.7-14.3-32-32-32zM576 288v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V288c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faStreetView = {
  prefix: 'fas',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"]
};
var faArrowDownLeft = {
  prefix: 'fas',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", "M32 384c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-146.7 0L342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L96 306.7 96 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224z"]
};
var faFrancSign = {
  prefix: 'fas',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
};
var faFlaskRoundPoison = {
  prefix: 'fas',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", "M328.5 172.1c-5.2-3-8.5-8.4-8.5-14.4V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H304 256 192 144 128C110.3 0 96 14.3 96 32s14.3 32 32 32v93.7c0 6-3.3 11.4-8.5 14.4l0 0c-5.3 3.1-10.4 6.4-15.4 9.9C50.8 219.7 16 281.8 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512H333.8c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9zM300 376.6c-7.1 5.2-12 13-12 21.8V408c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24v-9.6c0-8.8-4.9-16.7-12-21.8c-22.1-16.1-36-39.1-36-64.6c0-48.6 50.1-88 112-88s112 39.4 112 88c0 25.5-13.9 48.6-36 64.6zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faFlaskPoison = faFlaskRoundPoison;
var faVolumeOff = {
  prefix: 'fas',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"]
};
var faBookCircleArrowRight = {
  prefix: 'fas',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h10.8c-23.3-16.4-42.5-38.4-55.6-64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H320.7c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4V32c0-17.7-14.3-32-32-32H384 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faChartUser = {
  prefix: 'fas',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H576V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm252.7 75.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h88c8.8 0 16 7.2 16 16v88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM0 485.3C0 411.7 59.7 352 133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"]
};
var faUserChart = faChartUser;
var faHandsAslInterpreting = {
  prefix: 'fas',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faPresentationScreen = {
  prefix: 'fas',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V288c0 35.3 28.7 64 64 64H256v34.7l-70.6 70.6c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 445.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L320 386.7V352H480c35.3 0 64-28.7 64-64V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 64 32zM96 64H480V288H288 96V64z"]
};
var faPresentation = faPresentationScreen;
var faCircleBolt = {
  prefix: 'fas',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm74.1-396.4c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272H160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faFaceSmileHalo = {
  prefix: 'fas',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80S114.6 0 256 0S512 35.8 512 80zm-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32s192-14.3 192-32zM16 272c0-41.9 10.7-81.3 29.6-115.5C98.1 178.3 173 192 256 192s157.9-13.7 210.4-35.5C485.3 190.7 496 230.1 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272zm148.1 85.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 378.2 299.4 400 256 400s-74-21.8-91.9-42.5zm53.5-56.7l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 260.4 120 278.1 120 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 260.4 280 278.1 280 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]
};
var faCartCircleArrowDown = {
  prefix: 'fas',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 393.4V304c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4l28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faHousePersonReturn = {
  prefix: 'fas',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0L388.9 125.9c-19 14.8-34.4 34.5-44.1 57.7l-10.7 25.8-10.7 5.4c-31.6 15.8-44.4 54.3-28.6 85.9c15.4 30.9 52.5 43.8 83.6 29.7l-6.8 7.5c-9 9.8-15.4 21.7-18.6 34.7L342 416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm84.3 200.5c-1-.4-1.9-.8-2.9-1.2l16.9 63.5c5.6 21.1 .1 43.6-14.7 59.7l-70.7 77.1-22 88.1c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l23-92.1c1.9-7.8 5.8-14.9 11.2-20.8l49.5-54-19.3-65.5-9.6 23c-4.4 10.6-12.5 19.3-22.8 24.5l-26.7 13.3c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L359 232.7l15.3-36.8c17.1-41.1 57.3-67.9 101.9-67.9c22.8 0 45.3 4.8 66.1 14l8 3.5c32.9 14.6 58.1 42.4 69.4 76.5l2.6 7.8c5.6 16.8-3.5 34.9-20.2 40.5s-34.9-3.5-40.5-20.2l-2.6-7.8c-5.7-17.1-18.3-30.9-34.7-38.2l-8-3.5zm30 135.1l25 62.4 59.4 59.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L523.7 441c-4.6-4.6-8.2-10.1-10.6-16.1l-14.5-36.2 40.7-44.4c2.5-2.7 4.8-5.6 7-8.6z"]
};
var faHousePersonArrive = faHousePersonReturn;
var faHouseReturn = faHousePersonReturn;
var faMessageXmark = {
  prefix: 'fas',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm175 63c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faCommentAltTimes = faMessageXmark;
var faMessageTimes = faMessageXmark;
var faFileCertificate = {
  prefix: 'fas',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H221.3c1.8-5.1 2.7-10.5 2.7-16V416c1.3-.5 2.5-1 3.8-1.5c6.8-3 14.3-7.8 20.6-15.5c6.4-7.9 10.1-17.2 11.4-27.1c.5-3.6 .8-5.7 1.1-7.1c1.1-.9 2.8-2.3 5.6-4.5c19.9-15.4 27.1-42.2 17.5-65.5c-1.4-3.3-2.1-5.4-2.6-6.7c.5-1.4 1.2-3.4 2.6-6.7c9.5-23.3 2.4-50.1-17.5-65.5c-2.8-2.2-4.5-3.6-5.6-4.5c-.3-1.4-.6-3.6-1.1-7.1c-3.4-24.9-23-44.6-47.9-47.9c-3.6-.5-5.7-.8-7.1-1.1c-.9-1.1-2.3-2.8-4.5-5.6c-15.4-19.9-42.2-27.1-65.5-17.5c-2.6 1.1-5.1 2.3-6.6 3l-.1 .1V64zm384 64H384V0L512 128zM109.2 161.6L125 168c1.9 .8 4.1 .8 6.1 0l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1L248 285c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6L192 390.2V496c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L128 483.2 88.9 509.3c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V390.2l-15.5-2.1c-10.7-1.5-19.1-9.9-20.5-20.6l-2.3-16.9c-.3-2.1-1.4-4-3-5.2L9.1 334.9c-8.5-6.6-11.6-18.1-7.5-28.1L8 291c.8-1.9 .8-4.1 0-6.1L1.6 269.2c-4.1-10-1-21.5 7.5-28.1l13.5-10.5c1.7-1.3 2.7-3.2 3-5.2l2.3-16.9c1.5-10.7 9.9-19.1 20.5-20.5l16.9-2.3c2.1-.3 4-1.4 5.2-3l10.5-13.5c6.6-8.5 18.1-11.6 28.1-7.5zM192 288A64 64 0 1 0 64 288a64 64 0 1 0 128 0z"]
};
var faFileAward = faFileCertificate;
var faUserDoctorHairLong = {
  prefix: 'fas',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zM288 320v42c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16V424c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-29.8-20.4-54.9-48-62V323.4c73.1 15.3 128 80.2 128 157.8c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-77.7 54.9-142.5 128-157.8v46.9c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V320l1.3 0H286.7l1.3 0zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCameraSecurity = {
  prefix: 'fas',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H310l59 36.9c12.1 7.6 17.7 22.2 13.8 36S366.3 512 352 512H96c-14.3 0-26.8-9.5-30.8-23.2s1.7-28.4 13.8-36L138 416H64c-35.3 0-64-28.7-64-64V64zM128 208a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 208a128 128 0 1 0 256 0z"]
};
var faCameraHome = faCameraSecurity;
var faGear = {
  prefix: 'fas',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faCog = faGear;
var faDropletSlash = {
  prefix: 'fas',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faTintSlash = faDropletSlash;
var faBookHeart = {
  prefix: 'fas',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm64-258.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4C221.1 102.5 205.5 96 189.3 96c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faMosque = {
  prefix: 'fas',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"]
};
var faDuck = {
  prefix: 'fas',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M400.7 224c-.4 0-.7 .3-.7 .7v0 24c0 6.6 2.8 12.8 7.2 17.7C427.6 289.1 440 319.1 440 352c0 70.7-57.3 128-128 128H196C87.8 480 0 392.2 0 284v-5.4C0 266.1 10.1 256 22.6 256c6 0 11.8 2.4 16 6.6L54 278c6.2 6.2 15.2 8.5 23.6 6.1l172.8-49.4c10.4-3 15.7-14.5 7.8-21.7v0c-21-19-34.1-46.5-34.1-77c0-57.4 46.6-104 104-104c53.8 0 98.1 40.9 103.5 93.3c0 .4 .3 .6 .7 .7v0c10.5 1.3 21.2 1.3 31.8 0l35.3-4.4c6.8-.8 12.8 4.4 12.8 11.3c0 50.3-40.8 91.1-91.1 91.1H400.7zM368 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM340.6 296.9c.5-8.8-6.2-16.4-15-16.9s-16.4 6.2-16.9 15c-2.4 41.2-32.6 79-77.3 90.1c-40.3 10.1-80.5-4.6-103.7-33.5c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c31.1 38.7 84 57.6 136.4 44.5c58-14.5 98.3-63.8 101.5-119.3z"]
};
var faMosquito = {
  prefix: 'fas',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"]
};
var faStarOfDavid = {
  prefix: 'fas',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"]
};
var faFlagSwallowtail = {
  prefix: 'fas',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H64z"]
};
var faFlagAlt = faFlagSwallowtail;
var faPersonMilitaryRifle = {
  prefix: 'fas',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faCarGarage = {
  prefix: 'fas',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M343.8 8.8c-14.8-8.4-32.9-8.4-47.6 0L24.1 164.2C8.8 173 3.5 192.5 12.2 207.9s28.3 20.7 43.7 11.9L320 68.9 584.1 219.8c15.3 8.8 34.9 3.4 43.7-11.9s3.4-34.9-11.9-43.7L343.8 8.8zM249.8 224H390.2c6.8 0 12.8 4.3 15.1 10.6L424.3 288H215.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9l-28.3 79.3C126.1 300.9 112 320.8 112 344v40 64 32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H448v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C454.1 181.3 424 160 390.2 160H249.8c-33.8 0-64 21.3-75.3 53.1zM192 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faCartShopping = {
  prefix: 'fas',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faShoppingCart = faCartShopping;
var faBookFont = {
  prefix: 'fas',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM254.3 72.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-64 128-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L185.9 224H294.1l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-32-64-64-128zM240 115.8L278.1 192H201.9L240 115.8z"]
};
var faShieldPlus = {
  prefix: 'fas',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faVials = {
  prefix: 'fas',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"]
};
var faEyeDropperFull = {
  prefix: 'fas',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9 176.1 202.6 55.4 323.3z"]
};
var faDistributeSpacingHorizontal = {
  prefix: 'fas',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", "M32 24C32 10.7 42.7 0 56 0S80 10.7 80 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24zM160 144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V144zM456 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]
};
var faTabletRugged = {
  prefix: 'fas',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M32 176L8.8 164.4C3.4 161.7 0 156.2 0 150.1V73.9c0-6.1 3.4-11.6 8.8-14.3L34.3 46.8C41.8 19.8 66.6 0 96 0H352c29.4 0 54.2 19.8 61.7 46.8l25.5 12.7c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 176v16l23.2 11.6c5.4 2.7 8.8 8.3 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3L416 320v16l23.2 11.6c5.4 2.7 8.8 8.2 8.8 14.3v76.2c0 6.1-3.4 11.6-8.8 14.3l-25.5 12.7c-7.5 27-32.3 46.8-61.7 46.8H96c-29.4 0-54.2-19.8-61.7-46.8L8.8 452.4C3.4 449.7 0 444.2 0 438.1V361.9c0-6.1 3.4-11.6 8.8-14.3L32 336V320L8.8 308.4C3.4 305.7 0 300.2 0 294.1V217.9c0-6.1 3.4-11.6 8.8-14.3L32 192V176zM112 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112z"]
};
var faTemperatureSnow = {
  prefix: 'fas',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M384 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C505.8 332.6 512 349.5 512 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM432 0C370.1 0 320 50.1 320 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 131.6l-88 50.8V126.6l35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V81.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6v55.8l-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6v55.8l-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6V392c0 13.3 10.7 24 24 24s24-10.7 24-24V366.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4V265.6l67.7 39.1c5.2-13.5 12-26.2 20.3-37.9v-5.8l-64-37 64-37V131.6z"]
};
var faTemperatureFrigid = faTemperatureSnow;
var faMoped = {
  prefix: 'fas',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", "M328 56c0-13.3 10.7-24 24-24h41.3c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4H528c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-8.4c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8H336c-.9 0-1.7 0-2.6-.1H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32V320c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v64c0 17.7 14.3 32 32 32h77.3c16.8-38.5 48.4-69.2 87.6-84.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4H352c-13.3 0-24-10.7-24-24zM128 96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32 336c26.5 0 48-21.5 48-48H112c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faFaceSmilePlus = {
  prefix: 'fas',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M544 0c-13.3 0-24 10.7-24 24V72H472c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V120h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H568V24c0-13.3-10.7-24-24-24zM224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM140 346.1c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4z"]
};
var faSmilePlus = faFaceSmilePlus;
var faRadioTuner = {
  prefix: 'fas',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 336H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z"]
};
var faRadioAlt = faRadioTuner;
var faFaceSwear = {
  prefix: 'fas',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M320 0C178.6 0 64 114.6 64 256H576C576 114.6 461.4 0 320 0zM240.4 224c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8zM48 288c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm352 96H384v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V448H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V384H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32V336c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32V384H320zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM184 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 336v1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-.6 .4-1.2 .9-1.5 2.9c-.2 1-.1 1.6-.1 1.8c.1 .1 .5 .6 1.5 1.3c3.7 2.5 9.6 4.4 19.2 7.3l.7 .2c8 2.4 19.1 5.8 27.6 11.9c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c.5-.3 1.4-.9 2-4c.2-1.2 .2-1.9 .2-2.3c0-.4-.1-.6-.1-.6l0 0c0-.1-.3-.6-1.6-1.6c-3.5-2.5-9.3-4.6-18.7-7.4L106 414c-7.7-2.3-18.3-5.5-26.4-11c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7V336c0-8.8 7.2-16 16-16s16 7.2 16 16zM96.1 375.4a.1 .1 0 1 0 .1-.1 .1 .1 0 1 0 -.1 .1z"]
};
var faWaterArrowDown = {
  prefix: 'fas',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", "M354.5 104.3L320 135.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V135.7l-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm-85 189.6C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 373.7 159 384 192 384c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 309.2 410.9 320 384 320c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zm37 128c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faWaterLower = faWaterArrowDown;
var faScannerTouchscreen = {
  prefix: 'fas',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M152 0h16c13.3 0 24 10.7 24 24V64H128V24c0-13.3 10.7-24 24-24zM0 160c0-35.3 28.7-64 64-64H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm64 16V432c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM288 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V64H288V24zM240 0c8.8 0 16 7.2 16 16V64H224V16c0-8.8 7.2-16 16-16zM384 16c0-8.8 7.2-16 16-16s16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V16zM472 0h16c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"]
};
var faCircle7 = {
  prefix: 'fas',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H328c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faPlugCirclePlus = {
  prefix: 'fas',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faPersonSkiJumping = {
  prefix: 'fas',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H304.5c46 0 65.7 58.4 29 86.2L230.1 260.8l-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6L179.5 380.6 433.7 249.1c18.6-9.6 30.3-28.8 30.3-49.7V192c0-13.3 10.7-24 24-24s24 10.7 24 24v7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3C23.3 515.4 8.8 510.8 2.7 499s-1.5-26.3 10.3-32.3l111.2-57.5c-10.7-8.4-15.2-23-10.2-36.4l44-117.4c3.9-10.5 9.7-20.2 17-28.8L232.1 160H160c-17.7 0-32-14.3-32-32z"]
};
var faSkiJump = faPersonSkiJumping;
var faPlaceOfWorship = {
  prefix: 'fas',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"]
};
var faWaterArrowUp = {
  prefix: 'fas',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", "M354.5 135.7L320 104.3V208c0 17.7-14.3 32-32 32s-32-14.3-32-32V104.3l-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm-85 158.2c11.1-7.9 25.9-7.9 37 0C329 309.4 356.5 320 384 320c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 373.7 417 384 384 384c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 309.2 165.1 320 192 320c27.5 0 55-10.6 77.5-26.1zm37 128C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faWaterRise = faWaterArrowUp;
var faWaveformLines = {
  prefix: 'fas',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM544 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM256 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V160zM160 224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm576 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faWaveformPath = faWaveformLines;
var faSplit = {
  prefix: 'fas',
  iconName: 'split',
  icon: [512, 512, [], "e254", "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H346.5c-8.5 0-16.6 3.4-22.6 9.4L237.3 256l86.6 86.6c6 6 14.1 9.4 22.6 9.4H384V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H346.5c-25.5 0-49.9-10.1-67.9-28.1L178.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H178.7l99.9-99.9c18-18 42.4-28.1 67.9-28.1H384V64c0-12.9 7.8-24.6 19.8-29.6z"]
};
var faFilmCanister = {
  prefix: 'fas',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M128 0C110.3 0 96 14.3 96 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c0-17.7-14.3-32-32-32H128zM352 128V416H480c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32-14.3 32-32V160c0-17.7-14.3-32-32-32H352zm56 40h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V184c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H504c-8.8 0-16-7.2-16-16V184zM408 328h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V344c0-8.8 7.2-16 16-16z"]
};
var faFilmCannister = faFilmCanister;
var faFolderXmark = {
  prefix: 'fas',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faFolderTimes = faFolderXmark;
var faToiletPaperBlank = {
  prefix: 'fas',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", "M384 192c0-65.5 13.2-142.4 60.2-192H160C107 0 64 86 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1C356.7 439 384 350.8 384 192zm224 0C608 86 565 0 512 0s-96 86-96 192s43 192 96 192s96-86 96-192zm-64 0c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"]
};
var faToiletPaperAlt = faToiletPaperBlank;
var faTabletScreen = {
  prefix: 'fas',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 448c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM384 64H64V384H384V64z"]
};
var faTabletAndroidAlt = faTabletScreen;
var faHexagonVerticalNftSlanted = {
  prefix: 'fas',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9V168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.7c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4V344.9c0 25.7-13.7 49.5-36 62.4L260.9 495.5zm11.1-372c0-5.7-3.1-11-8.1-13.9L216.1 82.3c-2-1.2-4.3-2-6.8-2.2c-.5 0-1-.1-1.4-.1l-.1 0c-3.3 0-6.3 1-8.8 2.6c-1.5 1-2.9 2.2-4 3.7c-1.2 1.5-2.1 3.3-2.6 5.2c-.4 1.6-.6 3.1-.6 4.7V256.6v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-117l24.2 13.8c10.7 6.1 23.9-1.6 23.9-13.9zm16 27.4c0 5.7 3.1 11 8.1 13.9l23.8 13.6V352.6c0 8.8 7.2 16 16 16s16-7.2 16-16V196.6l16.2 9.3c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-72-41.1c-10.7-6.1-23.9 1.6-23.9 13.9zM143.8 128.6c-8.8 0-16 7.2-16 16V270L95 171.5c-2.5-7.4-10-12-17.7-10.7s-13.4 7.9-13.4 15.8v160c0 8.8 7.2 16 16 16s16-7.2 16-16V275.2l32.8 98.5c2.5 7.4 10 12 17.7 10.7s13.4-7.9 13.4-15.8v-224c0-8.8-7.2-16-16-16z"]
};
var faFolderMusic = {
  prefix: 'fas',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V283.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V224 192z"]
};
var faDisplayMedical = {
  prefix: 'fas',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm64 0V352H512V64H64zm192 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240H208c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16h48V128z"]
};
var faDesktopMedical = faDisplayMedical;
var faShareAll = {
  prefix: 'fas',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", "M366.6 39.5c9.1-9.6 24.3-10 33.9-.9L542.2 173.2c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8 .9-33.9L509.2 208 367.5 73.4c-9.6-9.1-10-24.3-.9-33.9zM224 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V288H192c-53 0-96 43-96 96c0 30.4 12.8 47.9 22.2 56.7c5.5 5.1 9.8 12 9.8 19.5c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h48V64z"]
};
var faPeapod = {
  prefix: 'fas',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M464 0H416C186.2 0 0 186.2 0 416v48c0 26.5 21.5 48 48 48H96c229.8 0 416-186.2 416-416V48c0-26.5-21.5-48-48-48zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faChessClock = {
  prefix: 'fas',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", "M256 56c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v48H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H544V112c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v16H200V80h32c13.3 0 24-10.7 24-24zM576 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-52.7-59.3c-6.2-6.2-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm-16 48v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faAxe = {
  prefix: 'fas',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3V384c0 17.7 14.3 32 32 32c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32H525.3l-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4zM448 316c45-11.6 80.4-47 92-92h32.8C560.1 286.7 510.7 336.1 448 348.8V316zM244.1 206.6L9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0L305.4 267.9l-61.3-61.3z"]
};
var faSquareD = {
  prefix: 'fas',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96h72c70.7 0 128 57.3 128 128s-57.3 128-128 128H152c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm24 208h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H176V336z"]
};
var faGripVertical = {
  prefix: 'fas',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"]
};
var faMobileSignalOut = {
  prefix: 'fas',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", "M64 64H224V0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V288H288V448H64V64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 120c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"]
};
var faArrowTurnUp = {
  prefix: 'fas',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"]
};
var faLevelUp = faArrowTurnUp;
var faU = {
  prefix: 'fas',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"]
};
var faArrowUpFromDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 141.3V208 320c0 17.7 14.3 32 32 32s32-14.3 32-32V208 141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faSquareRootVariable = {
  prefix: 'fas',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"]
};
var faSquareRootAlt = faSquareRootVariable;
var faLightSwitchOn = {
  prefix: 'fas',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 96h64c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zm32-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 128c-17.7 0-32 14.3-32 32v96H256V160c0-17.7-14.3-32-32-32H160z"]
};
var faArrowDownArrowUp = {
  prefix: 'fas',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L128 370.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V370.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96zm352-333.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96z"]
};
var faSortAlt = faArrowDownArrowUp;
var faRaindrops = {
  prefix: 'fas',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M102.4 133.6c-4.2 8.6-6.4 18-6.4 27.6c0 34.7 28.1 62.8 62.8 62.8h2.4c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L171.5 39.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2l-46.1 94.4zm-96 192c-4.2 8.6-6.4 18-6.4 27.6C0 387.9 28.1 416 62.8 416h2.4c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L75.5 231.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2L6.4 325.6zM307.8 134.8L210 294.2c-11.8 19.2-18 41.3-18 63.8c0 67.4 54.6 122 122 122h12c67.4 0 122-54.6 122-122c0-22.5-6.2-44.6-18-63.8L332.2 134.8c-2.6-4.2-7.2-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z"]
};
var faDash = {
  prefix: 'fas',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faMinusLarge = faDash;
var faClock = {
  prefix: 'fas',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faClockFour = faClock;
var faInputNumeric = {
  prefix: 'fas',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", "M576 128V384H64V128H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm40 120c0 13.3 10.7 24 24 24h8v96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V184c0-13.3-10.7-24-24-24H128c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H318.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"]
};
var faTruckTow = {
  prefix: 'fas',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M96 0h49.6c9.1 0 17.8 3.9 23.9 10.7L384 252V128c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7L621.3 192c12 12 18.7 28.3 18.7 45.3V256v32 88c0 22.1-17.9 40-40 40H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48H192L96 64V176c0 26.5-21.5 48-48 48s-48-21.5-48-48V160c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32C64 14.3 78.3 0 96 0zM576 256V237.3L498.7 160H448v96H576zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faBackwardStep = {
  prefix: 'fas',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"]
};
var faStepBackward = faBackwardStep;
var faPallet = {
  prefix: 'fas',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"]
};
var faCarBolt = {
  prefix: 'fas',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M74.8 96.3L39.6 196.8C16.4 206.4 0 229.3 0 256V400v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V400H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400 256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM318.3 119.2L281.9 192H336c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L230.1 224H176c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z"]
};
var faArrowsMaximize = {
  prefix: 'fas',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", "M320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L256 210.7 141.3 96H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H64C46.3 32 32 46.3 32 64V192c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3L210.7 256 96 370.7V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H141.3L256 301.3 370.7 416H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v50.7L301.3 256 416 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320z"]
};
var faExpandArrows = faArrowsMaximize;
var faFaucet = {
  prefix: 'fas',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"]
};
var faCloudSleet = {
  prefix: 'fas',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm272 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zM216 376v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm256 0v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H472v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H408c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V376c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faLampStreet = {
  prefix: 'fas',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M64 176c0-61.9 50.1-112 112-112c57.4 0 104.7 43.2 111.2 98.8C207.1 176.6 144 239.9 130.6 320.1C127.7 337.6 142.3 352 160 352H480c17.7 0 32.3-14.4 29.4-31.9c-13.5-80.6-77.2-144.2-157.9-157.6C344.6 71.6 268.7 0 176 0C78.8 0 0 78.8 0 176V480c0 17.7 14.3 32 32 32s32-14.3 32-32V176zM320 448c35.3 0 64-28.7 64-64H256c0 35.3 28.7 64 64 64z"]
};
var faListRadio = {
  prefix: 'fas',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zM64 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faPenNibSlash = {
  prefix: 'fas',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.3 327.6l28.3-94.4 2.8-9.2L352 94.6l-9.2 2.8L208.1 137.8 38.8 5.1zm29 440.7c-3.8 11.3-1 23.9 7.3 32.4L228.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-9.4 2.7-18.2 7.4-25.7l-85-67L67.8 445.8zM272 352c-7.4 0-14.4-1.7-20.7-4.7L97.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c3.6-1.2 7.1-2.8 10.5-4.6l-98.5-77.6c-8.7 9-20.9 14.6-34.4 14.6zM432.4 18.3L376.7 74.1 501.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L511.6 18.3c-21.9-21.9-57.3-21.9-79.2 0z"]
};
var faBaseballBatBall = {
  prefix: 'fas',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faSquareUpLeft = {
  prefix: 'fas',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 281.4V176c0-8.8 7.2-16 16-16H281.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z"]
};
var faOverline = {
  prefix: 'fas',
  iconName: 'overline',
  icon: [448, 512, [], "f876", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm192 96a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM336 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z"]
};
var faS = {
  prefix: 'fas',
  iconName: 's',
  icon: [320, 512, [115], "53", "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"]
};
var faTimeline = {
  prefix: 'fas',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faKeyboard = {
  prefix: 'fas',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"]
};
var faArrowsFromDottedLine = {
  prefix: 'fas',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V352c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
var faUsbDrive = {
  prefix: 'fas',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", "M64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64H416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zm544 32H480V384H608c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32zM560 232a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm24 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"]
};
var faBallot = {
  prefix: 'fas',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112zm0 128c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zM80 352h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm112 32c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16-272H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 256c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16z"]
};
var faCaretDown = {
  prefix: 'fas',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
};
var faLocationDotSlash = {
  prefix: 'fas',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zm219 171.7c6.8-28 32.1-48.8 62.2-48.8c35.3 0 64 28.7 64 64c0 24.7-13.9 46-34.4 56.7l-91.8-72zm85.9 322.4c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
var faMapMarkerAltSlash = faLocationDotSlash;
var faCards = {
  prefix: 'fas',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", "M7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zM197 159.6c-11.1-3-22.6 3.6-25.6 14.8l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4 .2-.8 .3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4 .1 .8 .2 1.1 .3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4L197 159.6zM459.4 420.9c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2H584c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13l135.3-78.1zm74.5-183.3L582 187.6c14-14.5 13.2-38.5-2.2-51.9c-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2c-15.7 13.5-16.5 37.5-2.5 51.9l48.4 49.9c3 3.2 8.2 3.2 11.5 0z"]
};
var faHouseChimneyMedical = {
  prefix: 'fas',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"]
};
var faClinicMedical = faHouseChimneyMedical;
var faBoxingGlove = {
  prefix: 'fas',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M0 96C0 43 43 0 96 0H288c53 0 96 43 96 96v32H352c-26.2 0-49.4 12.6-64 32H144c-21.2 0-34.3-5.3-41.8-9.7c-3.8-2.3-6.3-4.4-7.7-5.8c-.7-.7-1.1-1.2-1.3-1.5l-.1-.1 0 0c-5-7.1-14.7-9-22-4.2c-7.4 4.9-9.3 14.8-4.4 22.2L80 152c-13.3 8.9-13.3 8.9-13.3 8.9l0 0 0 0 .1 .1 .1 .2 .4 .5c.3 .4 .6 .8 1.1 1.4c.9 1.1 2 2.4 3.6 4c3.1 3.1 7.6 6.9 13.8 10.7C98.3 185.3 117.2 192 144 192H273.6c-1 5.2-1.6 10.5-1.6 16c0 37.3 25.5 68.6 60 77.5c8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-20.7-5.3-36-24.1-36-46.5c0-26.5 21.5-48 48-48h32c35.3 0 64 28.7 64 64v24.2c0 25.5-10.1 49.9-28.1 67.9l-49.1 49.1c-12 12-18.7 28.3-18.7 45.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V359.6C12.4 342 0 316.4 0 288V96zM152.9 354.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 419.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 380.8l-39.1-26.1z"]
};
var faGloveBoxing = faBoxingGlove;
var faTemperatureThreeQuarters = {
  prefix: 'fas',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faBellSchool = {
  prefix: 'fas',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", "M208 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 288A208 208 0 1 0 208 0a208 208 0 1 0 0 416zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 448c-54 0-103.9-17.9-144-48v64c0 26.5 21.5 48 48 48H320h32 40c43.4 0 80.1-28.8 92-68.3c16.6-7.6 28-24.3 28-43.7c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15.5 7.3 29.2 18.7 38c-8 15.4-24.1 26-42.7 26H352V400c-40.1 30.1-90 48-144 48z"]
};
var faMobileScreen = {
  prefix: 'fas',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"]
};
var faMobileAndroidAlt = faMobileScreen;
var faPlaneUp = {
  prefix: 'fas',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"]
};
var faFolderHeart = {
  prefix: 'fas',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faCircleLocationArrow = {
  prefix: 'fas',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM358.2 182.7l-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4C239.4 389.5 232 380.4 232 370V280H142c-10.4 0-19.5-7.4-21.5-17.6c-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2z"]
};
var faLocationCircle = faCircleLocationArrow;
var faFaceHeadBandage = {
  prefix: 'fas',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2c-8.2 2-15.3 7.1-19.7 14.3C26.9 130.6 15 158.9 7.8 189c-2.4 10.2 .3 20.9 7.2 28.7c-2.5 2.8-4.9 5.6-7.3 8.5c-4.7 5.5-7.3 12.4-7.6 19.6C.1 249.2 0 252.6 0 256c0 31.4 5 61.7 14.4 90.1c3.8 11.6 13.9 20 26 21.7c5.6 .8 11.2 0 16.3-2C97.8 452.2 185.9 512 288 512c141.4 0 256-114.6 256-256c0-9.5-.5-18.8-1.5-28c6.1-1.1 11.9-3.9 16.5-8.3c8.3-7.9 11.8-19.6 9.2-30.7c-7.2-30.1-19.1-58.4-34.9-84.1c-3.3-5.3-8-9.5-13.5-12.1c-.6-6-2.9-11.9-6.9-16.8c-21.2-26.5-47-49.1-76.2-66.8c-6.1-3.7-13.4-5.2-20.5-4.4c-16.2 2-32.2 4.6-48.1 7.9C342.9 4.5 316 0 288 0zM219.2 98.5s0 0 0 0s0 0 0 0C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4c2.2 .3 4.4 .6 6.6 .9c31.7 4.3 62.9 10.1 93.5 17.5c.1 .2 .2 .3 .3 .5c7.3 11.9 13.7 24.4 19 37.5c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26c-.3 0-.5 0-.8 0c-9.1-.3-18.3-.4-27.5-.4c-17.1 0-34.1 .5-51 1.5c-48.2 2.8-95.4 9.6-141.2 20c-7 1.6-13.9 3.3-20.9 5c-12.1 3.1-24.1 6.4-36 10c.5-2 1-4 1.5-6c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38c23.2-5.6 46.8-10.3 70.7-14.1c0 0 0 0 0 0c.8-.1 1.6-.3 2.5-.4c25-3.9 50.4-6.9 76.1-8.7zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5zm126 13.6c13.5-10.8 27.6-20.9 42.1-30.4c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32zM476.2 82.4C419.3 71.1 360.6 64.9 300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2zm-103 315.1C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3c-8.4 2.7-17.4-2-20.1-10.5s2-17.4 10.5-20.1c13.4-4.2 28.4-6.8 44.8-6.8c44.2 0 77.2 18.3 98.8 37.9c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1zM368.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSushiRoll = {
  prefix: 'fas',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M448 368V144C448 82.1 347.7 32 224 32S0 82.1 0 144V368c0 61.9 100.3 112 224 112s224-50.1 224-112zM308.2 198.4c-24.5 6.1-53.3 9.6-84.2 9.6c-40.7 0-77.8-6.1-106-16.1c14.8-14.8 32.8-26.7 51.4-36.1c20.5-10.3 40.9-17 56.9-20.8c18.2 27.3 46.6 49.9 82 63.4zM205.1 80.4c.8 6 2.1 11.9 3.8 17.7c-17.3 4.7-37.4 11.8-57.5 21.9c-24.5 12.3-49.9 29.4-70.3 52.7C70.2 164.1 64 154.4 64 144c0-32.8 61.7-59.8 141.1-63.6zm40.7 .2c78 4.3 138.2 31 138.2 63.4c0 9.8-5.5 19.1-15.4 27.4c-69.5-5.5-113.5-48.4-122.8-90.8z"]
};
var faMakiRoll = faSushiRoll;
var faMakizushi = faSushiRoll;
var faCarBump = {
  prefix: 'fas',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", "M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6zM584.8 512c19.5 0 34.7-17.7 25.8-35c-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35H584.8z"]
};
var faPiggyBank = {
  prefix: 'fas',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faRacquet = {
  prefix: 'fas',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154z"]
};
var faCarMirrors = {
  prefix: 'fas',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M167.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4H378.6c13.6 0 25.7 8.6 30.2 21.4L434.9 192H141.1l26.1-74.6zM32 224h8.6c-5.4 9.4-8.6 20.3-8.6 32V400v48c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H448v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400 256c0-11.7-3.1-22.6-8.6-32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H491.5L469.2 96.3C455.7 57.8 419.4 32 378.6 32H197.4c-40.8 0-77.1 25.8-90.6 64.3L84.5 160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32zm64 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faIndustryWindows = {
  prefix: 'fas',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", "M32 64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V215.4L316.6 131c16-8.6 35.4 3 35.4 21.1v63.2L508.6 131c16-8.6 35.4 3 35.4 21.1V304 432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V352 304 64zM264 312c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H264zM120 328v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H136c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V328c0-8.8-7.2-16-16-16H392z"]
};
var faIndustryAlt = faIndustryWindows;
var faBoltAuto = {
  prefix: 'fas',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M317.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224C.9 240.7-2.6 254.8 2 267.3S18.7 288 32 288H143.5L66.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H240.5L317.4 44.6zM464 288c-12.1 0-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160C487.2 294.8 476.1 288 464 288zM447.8 424L464 391.6 480.2 424H447.8z"]
};
var faBatteryHalf = {
  prefix: 'fas',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"]
};
var faBattery3 = faBatteryHalf;
var faFluxCapacitor = {
  prefix: 'fas',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM148.7 237.3l-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0l49 49c1.8-6.6 2.7-13.6 2.7-20.7c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7zM184 282.7c-23.9 13.8-40 39.7-40 69.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-29.6-16.1-55.5-40-69.3V352c0 22.1-17.9 40-40 40s-40-17.9-40-40V282.7zm115.3-45.4c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0 7.2 .9 14.1 2.7 20.7l49-49c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zm-160-88.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6V352c0 8.8 7.2 16 16 16s16-7.2 16-16V262.6l91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-84.7-84.7z"]
};
var faMountainCity = {
  prefix: 'fas',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"]
};
var faCoins = {
  prefix: 'fas',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"]
};
var faHoneyPot = {
  prefix: 'fas',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M128 32H64C46.3 32 32 46.3 32 64s14.3 32 32 32C25.1 125.2 0 171.7 0 224C0 362.8 79.6 441.9 113.3 469.1c9.3 7.5 21.1 10.9 33.1 10.9H301.6c12 0 23.7-3.3 33.1-10.9C368.4 441.9 448 362.8 448 224c0-52.3-25.1-98.8-64-128c17.7 0 32-14.3 32-32s-14.3-32-32-32H176V136c0 13.3-10.7 24-24 24s-24-10.7-24-24V32zM64 224H384c0 53.7-14.7 96.1-32.9 128H96.9C78.7 320.1 64 277.7 64 224z"]
};
var faOlive = {
  prefix: 'fas',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M160 480C71.6 480 0 408.4 0 320C0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zM287.1 192.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z"]
};
var faKhanda = {
  prefix: 'fas',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"]
};
var faFilterList = {
  prefix: 'fas',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", "M40 64C24.2 64 9.9 73.3 3.5 87.7s-3.8 31.3 6.8 43L112 243.8V368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V243.8l101.7-113c10.6-11.7 13.2-28.6 6.8-43S327.8 64 312 64H40zM352 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352zM320 256c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zM416 64c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416z"]
};
var faOutlet = {
  prefix: 'fas',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 224c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4H301.6c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm96-64c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm-64 96c-13.3 0-24 10.7-24 24v16c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V312c0-13.3-10.7-24-24-24z"]
};
var faSliders = {
  prefix: 'fas',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"]
};
var faSlidersH = faSliders;
var faCauldron = {
  prefix: 'fas',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24V473c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39v15c0 13.3 10.7 24 24 24s24-10.7 24-24V429.9c20.1-26.1 32-58.1 32-95.5c0-37.3-16.5-77.4-35.1-110.4H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H368 224 80 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h3.1z"]
};
var faPeople = {
  prefix: 'fas',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faFolderTree = {
  prefix: 'fas',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"]
};
var faNetworkWired = {
  prefix: 'fas',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"]
};
var faCroissant = {
  prefix: 'fas',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M259.4 1.4c3.9 5.9 7 12.5 9.1 19.5l59.9 199.7c1.2 4.1 2 8.2 2.4 12.4L440.3 92.2c13.6-17.4 10.5-42.8-8.6-53.9C389.4 14 340.3 0 288 0c-9.7 0-19.2 .5-28.6 1.4zM233 330.8c-4.1-.4-8.3-1.2-12.4-2.4L20.9 268.5c-7-2.1-13.6-5.2-19.5-9.1C.5 268.8 0 278.3 0 288c0 52.3 14 101.4 38.4 143.7c11 19.1 36.4 22.2 53.9 8.6L233 330.8zM232.7 19l0 0c2 3 3.6 6.4 4.8 10c-1.2-3.6-2.8-6.9-4.8-10l0 0zm232.9 92.8L390 209l87.6 14.6c1.6 .3 3.2 .4 4.9 .4c16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2c-10.1-25.2-24.1-48.5-41.3-69c-.9 1.4-1.9 2.7-2.9 4zM209 390l-97.1 75.6c-1.3 1-2.6 2-4 2.9c20.5 17.2 43.8 31.2 69 41.3c3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6c0-1.6-.1-3.3-.4-4.9L209 390zM19 232.7l0 0c2.3 1.5 4.7 2.8 7.3 3.8c1.2 .5 2.5 1 3.8 1.3l199.7 59.9c11.3 3.4 23.5 .3 31.8-8l28.1-28.1c8.3-8.3 11.4-20.5 8-31.8L237.8 30.1C232.5 12.2 216 0 197.4 0c-4.6 0-9.2 .7-13.5 2.3C99.7 33 33 99.7 2.3 183.9C.7 188.2 0 192.8 0 197.4c0 14.5 7.4 27.6 19 35.3l0 0z"]
};
var faMapPin = {
  prefix: 'fas',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"]
};
var faHamsa = {
  prefix: 'fas',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCentSign = {
  prefix: 'fas',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"]
};
var faSwordsLaser = {
  prefix: 'fas',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M135 7c-9.1 9.1-9.4 23.7-.7 33.2L360 286.9V181.8L168.2 6.3C158.7-2.4 144.1-2.1 135 7zm263 349.7l49 49 27.3-27.3 32-32L533.7 319 411.3 196.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V322.7c0 12.7 5.1 24.9 14.1 33.9zM523.3 352L629 457.7l3.5-3.5c4.8-4.8 7.5-11.3 7.5-18.1s-2.7-13.3-7.5-18.1L545 330.3 523.3 352zM512 363.3L491.3 384 597 489.7 617.7 469 512 363.3zm-32 32L458.3 417l87.5 87.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l3.5-3.5L480 395.3zM247.6 211.4l-24.7 22.6c-1.6-3.9-4.7-7.2-8.7-8.8c-6-2.5-12.9-1.1-17.4 3.5l-25.4 25.4-4.9-4.9c-12.5-12.3-32.6-12.2-45 .2c-12.5 12.5-12.5 32.8 0 45.3l4.7 4.7L7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l50.3 50.3c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L209.9 388.7c9-9 14.1-21.2 14.1-33.9v-6.6l74.3-81.2-50.7-55.5zm142.8-45.2l115.3-126c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L343.7 123.5l46.7 42.7zM152 344a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFlask = {
  prefix: 'fas',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"]
};
var faPersonPregnant = {
  prefix: 'fas',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"]
};
var faSquareU = {
  prefix: 'fas',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 136V288c0 35.3 28.7 64 64 64s64-28.7 64-64V168c0-13.3 10.7-24 24-24s24 10.7 24 24V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faWandSparkles = {
  prefix: 'fas',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"]
};
var faRouter = {
  prefix: 'fas',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M352 48c58.8 0 112.5 21.8 153.4 57.9c9.9 8.8 25.1 7.8 33.9-2.1s7.8-25.1-2.1-33.9C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9c-9.9 8.8-10.9 23.9-2.1 33.9s23.9 10.9 33.9 2.1C239.5 69.8 293.2 48 352 48zm24 200c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H376V248zM96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM276.5 186.7C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7c10.3 8.3 25.4 6.8 33.8-3.5s6.8-25.4-3.5-33.8C428.8 126 392 112 352 112s-76.8 14-105.7 37.4c-10.3 8.3-11.9 23.5-3.5 33.8s23.5 11.9 33.8 3.5z"]
};
var faEllipsisVertical = {
  prefix: 'fas',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"]
};
var faEllipsisV = faEllipsisVertical;
var faSwordLaserAlt = {
  prefix: 'fas',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232H330.2L505.7 40.2zM189.3 256c-12.7 0-24.9 5.1-33.9 14.1l-49 49 27.3 27.3 32 32L193 405.7 315.3 283.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H189.3zm-7.6 161L160 395.3 54.3 501l3.5 3.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L181.7 417zM43 489.7L148.7 384 128 363.3 22.3 469 43 489.7zm-32-32L116.7 352 95 330.3 7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l3.5 3.5z"]
};
var faTicket = {
  prefix: 'fas',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"]
};
var faPowerOff = {
  prefix: 'fas',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"]
};
var faCoin = {
  prefix: 'fas',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M256 352C114.6 352 0 287.5 0 208S114.6 64 256 64s256 64.5 256 144s-114.6 144-256 144zM86.6 248.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200s10.5 36.7 22.6 48.2zM96 200c0-35.3 71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64s-160-28.7-160-64zM0 290.1c13.2 15.6 29.7 29.3 48 40.9l0 63.7C17.8 373.6 0 347.9 0 320l0-29.9zM80 413l0-64.7c28.4 13.2 60.9 23 96 29l0 64.3c-36.2-6-68.9-15.9-96-28.7zm128 32.8l0-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4l0 64.1c-15.5 1.5-31.6 2.2-48 2.2s-32.5-.8-48-2.2zm128-4.1l0-64.3c35.1-6 67.6-15.9 96-29l0 64.7c-27.1 12.8-59.8 22.7-96 28.7zm128-47l0-63.7c18.3-11.5 34.8-25.2 48-40.9l0 29.9c0 27.9-17.8 53.6-48 74.6z"]
};
var faLaptopSlash = {
  prefix: 'fas',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-14-10.9c14.3-13.9 23.2-33.4 23.2-55c0-10.6-8.6-19.2-19.2-19.2H522.2L154.8 96H512V352h64V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM128 197L64 146.6V352h64V197zM487.2 480L365.3 384H19.2C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H487.2z"]
};
var faRightLong = {
  prefix: 'fas',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"]
};
var faLongArrowAltRight = faRightLong;
var faCircleB = {
  prefix: 'fas',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C356.3 261.6 368 283.4 368 308c0 42-34 76-76 76H184c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H208v56h68c15.5 0 28-12.5 28-28zM208 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H276 208v56z"]
};
var faPersonDressSimple = {
  prefix: 'fas',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v80c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z"]
};
var faPipeCollar = {
  prefix: 'fas',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M18.7 18.7c25-25 65.5-25 90.5 0L126 35.4C164.1 12.9 208.5 0 256 0s91.9 12.9 130 35.4l16.7-16.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L476.6 126c22.5 38.1 35.4 82.6 35.4 130s-12.9 91.9-35.4 130l16.7 16.7c25 25 25 65.5 0 90.5s-65.5 25-90.5 0L386 476.6C347.9 499.1 303.5 512 256 512s-91.9-12.9-130-35.4l-16.7 16.7c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L35.4 386C12.9 347.9 0 303.5 0 256s12.9-91.9 35.4-130L18.7 109.3c-25-25-25-65.5 0-90.5zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faLightsHoliday = {
  prefix: 'fas',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", "M5.4 78.2c9.8-14.7 29.6-18.7 44.3-9l0 0 .4 .3c.5 .3 1.3 .8 2.5 1.5c2.4 1.4 6.3 3.6 11.7 6.3C75 82.7 91.6 90.1 114.1 97.6C159 112.6 227.6 128 320 128s161-15.4 205.9-30.4c22.5-7.5 39.1-14.9 49.8-20.3c5.4-2.7 9.3-4.9 11.7-6.3c1.2-.7 2.1-1.2 2.5-1.5l.4-.2 0 0c0 0 0 0 .1 0c14.7-9.7 34.5-5.8 44.3 8.9c9.8 14.7 5.8 34.6-8.9 44.4L608 96c17.8 26.6 17.7 26.6 17.7 26.6l0 0-.1 0-.2 .1-.4 .3c-.3 .2-.7 .5-1.2 .8c-1 .6-2.4 1.5-4.2 2.5c-3.6 2.1-8.7 4.9-15.3 8.2c-13.3 6.6-32.7 15.2-58.2 23.7C495 175.4 419.6 192 320 192s-175-16.6-226.1-33.6c-25.5-8.5-44.9-17.1-58.2-23.7c-6.6-3.3-11.7-6.1-15.3-8.2c-1.8-1-3.2-1.9-4.2-2.5c-.5-.3-.9-.6-1.2-.8l-.4-.3-.1-.1-.1 0 0 0c0 0 0 0 17.7-26.6L14.2 122.6C-.5 112.8-4.4 93 5.4 78.2zM523.2 198.7l9.4 25.8c30.8 1.9 59 21.7 70.2 52.5c16.4 45.1-8.8 139.4-31.4 147.6s-102.5-47.8-119-92.9c-11.2-30.8-2.3-64.1 20-85.3l-12.3-33.8c23.2-4 44.2-8.7 63.1-13.8zM320 224c10.9 0 21.6-.2 32-.6v39.2c28.3 12.3 48 40.5 48 73.3c0 48-56 128-80 128s-80-80-80-128c0-32.8 19.7-61 48-73.3V223.4c10.4 .4 21.1 .6 32 .6zM179.9 212.5l-12.3 33.8c22.3 21.3 31.2 54.5 20 85.3c-16.4 45.1-96.4 101.1-119 92.9S20.8 322.1 37.3 277c11.2-30.8 39.4-50.6 70.2-52.5l9.4-25.8c18.8 5.1 39.9 9.9 63.1 13.8z"]
};
var faCitrus = {
  prefix: 'fas',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M304 128h80c53 0 96-43 96-96V16c0-8.8-7.2-16-16-16H384c-53 0-96 43-96 96v16c0 8.8 7.2 16 16 16zM256 96c0-23.1 6.1-44.7 16.8-63.4c-5.5-.4-11.1-.6-16.8-.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7C435 152 410.4 160 384 160H304c-26.5 0-48-21.5-48-48V96z"]
};
var faFlagUsa = {
  prefix: 'fas',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faLaptopFile = {
  prefix: 'fas',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"]
};
var faTty = {
  prefix: 'fas',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"]
};
var faTeletype = faTty;
var faChartTreeMap = {
  prefix: 'fas',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M0 80C0 53.5 21.5 32 48 32H176c26.5 0 48 21.5 48 48V192c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM0 320c0-26.5 21.5-48 48-48H176c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V320zM304 32H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zM256 240c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V240zm48 112H464c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"]
};
var faDiagramNext = {
  prefix: 'fas',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"]
};
var faPersonRifle = {
  prefix: 'fas',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"]
};
var faClockFiveThirty = {
  prefix: 'fas',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V335.3l20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faPipeValve = {
  prefix: 'fas',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V76L128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 76V64zm0 84.2l-32-4-32 4V192H96V448H416V192H288V148.2zM32 160c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32zm480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V192z"]
};
var faArrowUpFromArc = {
  prefix: 'fas',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 448C150 448 64 362 64 256c0-17.7-14.3-32-32-32s-32 14.3-32 32C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 106-86 192-192 192zM121.4 121.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112z"]
};
var faFaceSpiralEyes = {
  prefix: 'fas',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56.9-137.1l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-147-263.3c.3 6.6-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5c6.6-.3 12.2 4.9 12.5 11.5zM357.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z"]
};
var faCompressWide = {
  prefix: 'fas',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V96zM32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32H32zM416 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V96zM384 288c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z"]
};
var faCirclePhoneHangup = {
  prefix: 'fas',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM391.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L98.8 274.8c-4.8-7.8-3.4-17.5 3.4-23.8c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L391.4 310z"]
};
var faPhoneCircleDown = faCirclePhoneHangup;
var faGearComplexCode = {
  prefix: 'fas',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2V230.1c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM287.8 162.6l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM187.3 227.3L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faHouseMedicalCircleExclamation = {
  prefix: 'fas',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faBadminton = {
  prefix: 'fas',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154zM464 400c0-26.5 21.5-48 48-48s48 21.5 48 48v32H464V400zm-15.3 91.4l13-43.4h33.4l-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9zM496 496V448h32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16zm48.7 4.6L528.9 448h33.4l13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7z"]
};
var faClosedCaptioning = {
  prefix: 'fas',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"]
};
var faPersonHiking = {
  prefix: 'fas',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"]
};
var faHiking = faPersonHiking;
var faRightFromLine = {
  prefix: 'fas',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", "M313.9 105.9L436.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L313.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM64 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32z"]
};
var faArrowAltFromLeft = faRightFromLine;
var faVenusDouble = {
  prefix: 'fas',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"]
};
var faImages = {
  prefix: 'fas',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faCalculator = {
  prefix: 'fas',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faShuttlecock = {
  prefix: 'fas',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M320 32c0 8.8-7.2 16-16 16c-24.4 0-46 15.8-53.4 39.1l-29.3 92.8c-1.3 4.1-4.2 7.6-8.1 9.5l-32.4 16.2c-3.1 1.5-5.6 4.1-7.2 7.2l-32.5 64.9c-3.1 6.2-1.9 13.6 3 18.5L163 315l71.9-71.9L281.1 96.8C284.3 86.8 293.5 80 304 80H408c13.3 0 24 10.7 24 24V208c0 10.5-6.8 19.7-16.8 22.9L268.8 277.1 197 349l18.9 18.9c4.9 4.9 12.3 6.1 18.5 3l64.9-32.5c3.1-1.5 5.6-4.1 7.2-7.2l16.2-32.4c1.9-3.9 5.4-6.8 9.5-8.1l92.8-29.3c23.3-7.4 39.1-29 39.1-53.4c0-8.8 7.2-16 16-16h8c13.3 0 24 10.7 24 24v51.7c0 12.4-7.2 23.7-18.4 29L250.1 411.2c-6.7 3.1-12.8 7.4-18 12.7l-28.8 28.8-144-144 28.8-28.8c5.2-5.2 9.5-11.3 12.7-18L215.4 18.4C220.6 7.2 231.9 0 244.3 0H296c13.3 0 24 10.7 24 24v8zM36.7 331.3l144 144-6.9 6.9c-19.1 19.1-45 29.8-72 29.8C45.6 512 0 466.4 0 410.2c0-27 10.7-52.9 29.8-72l6.9-6.9z"]
};
var faUserHair = {
  prefix: 'fas',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zm65.3 192C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]
};
var faEyeEvil = {
  prefix: 'fas',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M254.9 112.2c-10.7 2.8-21.1 6.3-30.9 10.4L114.4 76.1c-8.7-3.7-18.7-1-24.4 6.5s-5.5 17.9 .4 25.2l57.3 70.8c-7 9-12.8 18.6-17.3 28.6L15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9l114.9 28.7c4.5 10.1 10.3 19.7 17.3 28.6L90.4 404.1c-5.9 7.3-6.1 17.7-.4 25.2s15.7 10.2 24.4 6.5L224 389.4c9.8 4.1 20.1 7.6 30.9 10.4l42.7 97.6c3.9 8.9 12.7 14.7 22.4 14.7s18.5-5.8 22.4-14.7l42.7-97.6c10.7-2.8 21.1-6.3 30.9-10.4l109.7 46.5c8.7 3.7 18.7 1 24.4-6.5s5.5-17.9-.4-25.2l-57.3-70.8c7-9 12.8-18.6 17.3-28.6l114.9-28.7c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L509.6 207.4c-4.5-10.1-10.3-19.7-17.3-28.6l57.3-70.8c5.9-7.3 6.1-17.7 .4-25.2s-15.7-10.2-24.4-6.5L416 122.6c-9.8-4.1-20.1-7.6-30.9-10.4L342.4 14.7C338.5 5.8 329.7 0 320 0s-18.5 5.8-22.4 14.7l-42.7 97.6zM320 352c-53 0-96-43-96-96c0-19.7 6-38.1 16.2-53.3c16.6 9.6 35 16.2 54.7 19.3c-3.9 9.4-6.8 20.8-6.8 34c0 31.5 16.5 52.7 23.8 60.6c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c7.3-7.9 23.8-29.2 23.8-60.6c0-13.2-2.9-24.6-6.8-34c19.6-3.1 38.1-9.8 54.7-19.3C410 217.9 416 236.3 416 256c0 53-43 96-96 96z"]
};
var faPeoplePulling = {
  prefix: 'fas',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"]
};
var faN = {
  prefix: 'fas',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"]
};
var faSwap = {
  prefix: 'fas',
  iconName: 'swap',
  icon: [640, 512, [], "e609", "M237 141.6c-5.3 11.2-16.6 18.4-29 18.4H160V352c0 35.3 28.7 64 64 64s64-28.7 64-64V160c0-70.7 57.3-128 128-128s128 57.3 128 128V352h48c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1l-80 96c-6.1 7.3-15.1 11.5-24.6 11.5s-18.5-4.2-24.6-11.5l-80-96c-7.9-9.5-9.7-22.8-4.4-34.1s16.6-18.4 29-18.4h48V160c0-35.3-28.7-64-64-64s-64 28.7-64 64V352c0 70.7-57.3 128-128 128s-128-57.3-128-128V160l-48 0c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1l80-96C109.5 4.2 118.5 0 128 0s18.5 4.2 24.6 11.5l80 96c7.9 9.5 9.7 22.8 4.4 34.1z"]
};
var faGarage = {
  prefix: 'fas',
  iconName: 'garage',
  icon: [640, 512, [], "e009", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM128 224v96H512V224H128zm0 128V512H512V352H128zm128 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16z"]
};
var faCableCar = {
  prefix: 'fas',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"]
};
var faTram = faCableCar;
var faShovelSnow = {
  prefix: 'fas',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4c-15.1 15.1-35.6 23.6-57 23.6c-13.5 0-26.2-3.3-37.4-9.2l-83.5 83.5 47 47c11.3 11.3 12.5 29.1 3 41.8l-120 160c-5.6 7.4-14.1 12.1-23.3 12.7s-18.3-2.7-24.9-9.3l-168-168C2.8 328.1-.6 319 .1 309.7s5.3-17.8 12.7-23.3l160-120c12.7-9.6 30.6-8.3 41.8 3l47 47 83.5-83.5c-5.9-11.2-9.2-23.9-9.2-37.4c0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9L393.5 72.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L454.1 104 408 57.9zM203.3 267.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z"]
};
var faCloudRain = {
  prefix: 'fas',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"]
};
var faFaceLying = {
  prefix: 'fas',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", "M494 350.5c-4.5 1-9.2 1.5-14 1.5H352c-8.8 0-16-7.2-16-16s7.2-16 16-16H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16H480c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c108 0 200.4-66.9 238-161.5zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6z"]
};
var faSprinkler = {
  prefix: 'fas',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M24 0a24 24 0 1 1 0 48A24 24 0 1 1 24 0zM0 128a24 24 0 1 1 48 0A24 24 0 1 1 0 128zM0 232a24 24 0 1 1 48 0A24 24 0 1 1 0 232zM64 72a24 24 0 1 1 48 0A24 24 0 1 1 64 72zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm360 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM448 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 64c17.7 0 32 14.3 32 32V256H388.2c15.3 0 27.8 12.4 27.8 27.8c0 7.8-3.3 15.2-9 20.5L320 384v96c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V384l-87-79.7c-5.7-5.3-9-12.7-9-20.5c0-15.3 12.4-27.8 27.8-27.8H224V96c0-17.7 14.3-32 32-32z"]
};
var faBuildingCircleXmark = {
  prefix: 'fas',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faPersonSledding = {
  prefix: 'fas',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", "M400 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 226.7c-11.8-6.1-26.3-1.5-32.4 10.2s-1.5 26.3 10.2 32.4L396.4 468.4c27.3 14.2 59.7 14.4 87.2 .7l15.2-7.6c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-15.2 7.6c-13.7 6.9-29.9 6.7-43.6-.3l-41.7-21.6c4.5-5.5 7.2-12.5 7.2-20.2V304c0-26.5-21.5-48-48-48H301.3L361 196.3c25.2-25.2 7.4-68.3-28.3-68.3H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h84l-59.2 40.3c-23.6 16.1-26 44.8-13.8 64.9L35.1 226.7zM320 320v54.6L214.7 320H320z"]
};
var faSledding = faPersonSledding;
var faGameConsoleHandheld = {
  prefix: 'fas',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zM96 80V192c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 304v16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v16c0 8.8 7.2 16 16 16s16-7.2 16-16V352h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H128V304c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faShip = {
  prefix: 'fas',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faClockSixThirty = {
  prefix: 'fas',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120V256c0-13.3-10.7-24-24-24s-24 10.7-24 24V392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faBatterySlash = {
  prefix: 'fas',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6C563.1 386 576 362.5 576 336V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H154.8L38.8 5.1zM236.4 160H496c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H481.4l-245-192zm88.5 192H112c-8.8 0-16-7.2-16-16V176c0-1.4 .2-2.7 .5-4L45.4 131.7C36.9 144.4 32 159.6 32 176V336c0 44.2 35.8 80 80 80H406.2l-81.2-64z"]
};
var faTugrikSign = {
  prefix: 'fas',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V199L56.2 225c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 265v30L56.2 321c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 361v87c0 17.7 14.3 32 32 32s32-14.3 32-32V345L327.8 319c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 279V249L327.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 183V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"]
};
var faArrowsDownToLine = {
  prefix: 'fas',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"]
};
var faDownload = {
  prefix: 'fas',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faAnglesUpDown = {
  prefix: 'fas',
  iconName: 'angles-up-down',
  icon: [448, 512, [], "e60d", "M244 7c-11.7-9.3-28.3-9.3-40 0L44 135c-13.8 11-16 31.2-5 45s31.2 16 45 5L224 73 364 185c13.8 11 33.9 8.8 45-5s8.8-33.9-5-45L244 7zM404 377c13.8-11 16-31.2 5-45s-31.2-16-45-5L224 439 84 327c-13.8-11-33.9-8.8-45 5s-8.8 33.9 5 45L204 505c11.7 9.3 28.3 9.3 40 0L404 377z"]
};
var faShelves = {
  prefix: 'fas',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", "M32 0C49.7 0 64 14.3 64 32V160H576V32c0-17.7 14.3-32 32-32s32 14.3 32 32V192 448v32c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32V448 192 32C0 14.3 14.3 0 32 0zM64 416H576V224H64V416zM352 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V32zM128 256h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32zm160 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32z"]
};
var faInventory = faShelves;
var faCloudSnow = {
  prefix: 'fas',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM64 352c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H88v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H40V376c0-13.3 10.7-24 24-24zm192 32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V408c0-13.3 10.7-24 24-24zm216-8v16h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H472v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V440H408c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V376c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFaceGrin = {
  prefix: 'fas',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrin = faFaceGrin;
var faDeleteLeft = {
  prefix: 'fas',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faBackspace = faDeleteLeft;
var faOven = {
  prefix: 'fas',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M0 96v64H448V96c0-53-43-96-96-96H96C43 0 0 43 0 96zM56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zM176 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 200V448H64l0-192H384zM64 192H0v64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256 192H384 64zm48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
};
var faCloudBinary = {
  prefix: 'fas',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm16-280v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm88-16c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm136-16c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H424zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V200zM176 320c0 8.8 7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm96 24v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V344c0-22.1-17.9-40-40-40H312c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8V344c0-4.4 3.6-8 8-8zm104-32c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V320c0-8.8-7.2-16-16-16H416z"]
};
var faEyeDropper = {
  prefix: 'fas',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faCommentCaptions = {
  prefix: 'fas',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM120 208H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 288h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zm128 0H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCommentsQuestion = {
  prefix: 'fas',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM136.2 108.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4h48.5c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 162.1c-6.2 3.6-10 10.2-10 17.3v11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6H180.2c-19.8 0-37.4 12.4-44 31.1zM234.7 264a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0z"]
};
var faScribble = {
  prefix: 'fas',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M170 23.3C186.5 8.3 208 0 230.3 0h1.1C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4C96 373 107 384 120.6 384c6.5 0 12.8-2.6 17.4-7.2L360.8 153.9c16.6-16.6 39.1-25.9 62.6-25.9c48.9 0 88.6 39.7 88.6 88.6c0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.8 8.8-13.8 20.9-13.8 33.4c0 26 21.1 47.1 47 47.1c6.2 0 12.4-1.5 18-4.2l16.7-8.4c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L477.6 501c-14.5 7.2-30.4 11-46.6 11c-61.4 0-111-49.9-111-111.1c0-29.5 11.7-57.8 32.6-78.7l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4c0-13.6-11-24.6-24.6-24.6c-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9C71.7 448 32 408.3 32 359.4c0-23.5 9.3-46 25.9-62.6L248.8 105.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64h-1.1c-6.4 0-12.6 2.4-17.3 6.7L53.5 215.7c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2L170 23.3z"]
};
var faRotateExclamation = {
  prefix: 'fas',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M74.9 192L46.1 178.2c-7.6 15.9-.9 35 15 42.7s35 .9 42.7-15l0 0 0 0 0-.1 .2-.3 .7-1.5c.6-1.3 1.6-3.2 2.8-5.6c2.5-4.8 5.9-11.4 10-18.5c8.7-15.3 18.2-29.8 25.3-36.9c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0c-13.8 13.8-27 35.2-35.7 50.6c-4.6 8.2-8.6 15.6-11.3 21c-1.4 2.7-2.5 4.9-3.3 6.5l-.9 1.8-.2 .5-.1 .2 0 0 0 0 0 0s0 0 28.9 13.8zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 464c17.7 0 32-14.3 32-32V396.8l17.6 17.6c87.5 87.5 229.3 87.5 316.8 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0L125.7 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32V432c0 17.7 14.3 32 32 32z"]
};
var faFileCircleCheck = {
  prefix: 'fas',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGlass = {
  prefix: 'fas',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM70.9 128L66.4 64H317.6l-4.6 64H70.9z"]
};
var faLoader = {
  prefix: 'fas',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32zm0 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416zM0 256c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm416-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H416zM75 75c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75C107.7 62.5 87.5 62.5 75 75zM391.8 346.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L391.8 437c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3zM75 437c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-12.5 12.5-12.5 32.8 0 45.3zM346.5 120.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L437 120.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-45.3 45.3z"]
};
var faForward = {
  prefix: 'fas',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"]
};
var faUserPilot = {
  prefix: 'fas',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5v8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2v-8.4l23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM161.7 72.8c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm116.3 240l-72.3-54.2c-2.2-1.7-4.9-2.6-7.7-2.6C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352c-2.8 0-5.5 .9-7.7 2.6l-72.3 54.2c-5.7 4.3-13.5 4.3-19.2 0zM336 416h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobile = {
  prefix: 'fas',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faCodePullRequestClosed = {
  prefix: 'fas',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L400 34.7 425.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L445.3 80l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L400 125.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 80 329.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zM136 80A24 24 0 1 0 88 80a24 24 0 1 0 48 0zm56 0c0 32.8-19.7 61-48 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C51.7 141 32 112.8 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM112 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm288 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 56c-44.2 0-80-35.8-80-80c0-32.8 19.7-61 48-73.3V224c0-17.7 14.3-32 32-32s32 14.3 32 32V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80z"]
};
var faFaceMeh = {
  prefix: 'fas',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faMeh = faFaceMeh;
var faAlignCenter = {
  prefix: 'fas',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"]
};
var faBookSkull = {
  prefix: 'fas',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"]
};
var faBookDead = faBookSkull;
var faIdCard = {
  prefix: 'fas',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"]
};
var faDriversLicense = faIdCard;
var faFaceDotted = {
  prefix: 'fas',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M216 3.1C229 1.1 242.4 0 256 0s27 1.1 40 3.1c17.5 2.7 29.4 19.1 26.6 36.6s-19.1 29.4-36.6 26.6C276.3 64.8 266.3 64 256 64s-20.3 .8-30.1 2.3c-17.5 2.7-33.8-9.2-36.6-26.6S198.5 5.9 216 3.1zM150.2 55.9c10.4 14.3 7.2 34.3-7 44.7c-16.3 11.9-30.7 26.2-42.5 42.5c-10.4 14.3-30.4 17.4-44.7 7s-17.4-30.4-7-44.7c15.8-21.7 34.9-40.8 56.6-56.6c14.3-10.4 34.3-7.2 44.7 7zm211.6 0c10.4-14.3 30.4-17.4 44.7-7c21.7 15.8 40.8 34.9 56.6 56.6c10.4 14.3 7.2 34.3-7 44.7s-34.3 7.2-44.7-7c-11.9-16.3-26.2-30.7-42.5-42.5c-14.3-10.4-17.4-30.4-7-44.7zM472.3 189.3c17.5-2.7 33.8 9.2 36.6 26.6c2.1 13.1 3.1 26.4 3.1 40s-1.1 27-3.1 40c-2.7 17.5-19.1 29.4-36.6 26.6s-29.4-19.1-26.6-36.6c1.5-9.8 2.3-19.8 2.3-30.1s-.8-20.3-2.3-30.1c-2.7-17.5 9.2-33.8 26.6-36.6zm-432.6 0c17.5 2.7 29.4 19.1 26.6 36.6C64.8 235.7 64 245.7 64 256s.8 20.3 2.3 30.1c2.7 17.5-9.2 33.8-26.6 36.6S5.9 313.5 3.1 296C1.1 283 0 269.6 0 256s1.1-27 3.1-40c2.7-17.5 19.1-29.4 36.6-26.6zM55.9 361.8c14.3-10.4 34.3-7.2 44.7 7c11.9 16.3 26.2 30.7 42.5 42.5c14.3 10.4 17.4 30.4 7 44.7s-30.4 17.4-44.7 7c-21.7-15.8-40.8-34.9-56.6-56.6c-10.4-14.3-7.2-34.3 7-44.7zm400.1 0c14.3 10.4 17.4 30.4 7 44.7c-15.8 21.7-34.9 40.8-56.6 56.6c-14.3 10.4-34.3 7.2-44.7-7s-7.2-34.3 7-44.7c16.3-11.9 30.7-26.2 42.5-42.5c10.4-14.3 30.4-17.4 44.7-7zM189.3 472.3c2.7-17.5 19.1-29.4 36.6-26.6c9.8 1.5 19.8 2.3 30.1 2.3s20.3-.8 30.1-2.3c17.5-2.7 33.8 9.2 36.6 26.6s-9.2 33.8-26.6 36.6c-13.1 2.1-26.4 3.1-40 3.1s-27-1.1-40-3.1c-17.5-2.7-29.4-19.1-26.6-36.6zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM184 328H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faFaceWorried = {
  prefix: 'fas',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-73.6-97.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
var faOutdent = {
  prefix: 'fas',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"]
};
var faDedent = faOutdent;
var faHeartCircleExclamation = {
  prefix: 'fas',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faHouse = {
  prefix: 'fas',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faVectorCircle = {
  prefix: 'fas',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", "M192 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v9.3C392.2 62.8 449.2 119.8 470.7 192H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-9.3C449.2 392.2 392.2 449.2 320 470.7V480c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32v-9.3C119.8 449.2 62.8 392.2 41.3 320H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h9.3C62.8 119.8 119.8 62.8 192 41.3V32zM403.7 194.4c-16.2-38.9-47.3-70-86.2-86.2C312.7 119.9 301.3 128 288 128H224c-13.3 0-24.7-8.1-29.6-19.7c-38.9 16.2-70 47.3-86.2 86.2c11.6 4.8 19.7 16.2 19.7 29.6v64c0 13.3-8.1 24.7-19.7 29.6c16.2 38.9 47.3 70 86.2 86.2c4.8-11.6 16.2-19.7 29.6-19.7h64c13.3 0 24.7 8.1 29.6 19.7c38.9-16.2 70-47.3 86.2-86.2C392.1 312.7 384 301.3 384 288V224c0-13.3 8.1-24.7 19.7-29.6zM240 48V80h32V48H240zm32 384H240v32h32V432zM432 240v32h32V240H432zM80 240H48v32H80V240z"]
};
var faCarCircleBolt = {
  prefix: 'fas',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l34.1 97.4C385.8 205.7 320 279.2 320 368c0 10.9 1 21.6 2.9 32H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2H516.4l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
var faCalendarWeek = {
  prefix: 'fas',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"]
};
var faFlyingDisc = {
  prefix: 'fas',
  iconName: 'flying-disc',
  icon: [640, 512, [], "e3a9", "M119.7 456.3c-25.2-25.2-29.6-66.7-16.5-114.9c3.2 9.5 8.4 18.5 16.2 26.3c15.6 15.6 36 20.7 55 20.5c18.8-.1 38.8-5.3 58.2-13.3c39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2c.1-19-5-39.5-20.5-55c-7.8-7.8-16.8-13-26.3-16.2c48.2-13 89.8-8.6 114.9 16.6c55.3 55.3 10.5 189.8-100.2 300.5S175 511.6 119.7 456.3zM331.1 267.1C257.4 340.9 172.7 375.8 142 345s4.1-115.4 77.9-189.2S378.3 47.2 409 77.9s-4.1 115.4-77.9 189.2z"]
};
var faLaptopMedical = {
  prefix: 'fas',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"]
};
var faSquareDownRight = {
  prefix: 'fas',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M384 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384zM320 198.6V336c0 8.8-7.2 16-16 16H166.6c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3C114 210 112 205.1 112 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z"]
};
var faB = {
  prefix: 'fas',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"]
};
var faSeatAirline = {
  prefix: 'fas',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V143.6c0 15.2 3.1 30.2 9.1 44.1L82 357.8c15.1 35.3 49.8 58.2 88.2 58.2H216v48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H264V416h96c15.1 0 29.3-7.1 38.4-19.2l43.2-57.6c7.3-9.7 8.4-22.7 3-33.5S428.1 288 416 288H121.7L108 256H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H80.5L67.9 162.5c-2.6-6-3.9-12.4-3.9-18.9V32z"]
};
var faMoonOverSun = {
  prefix: 'fas',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM400 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-258 0c0-63.1 51.6-114 115-114c3.3 0 6.5 .1 9.7 .4c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-22.9 12.8-38.3 37.1-38.3 64.8c0 41 33.6 74.5 75.4 74.5c4.4 0 8.8-.4 13-1.1c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-20.7 19.9-49 32.2-80.1 32.2c-63.4 0-115-50.9-115-114z"]
};
var faEclipseAlt = faMoonOverSun;
var faPipe = {
  prefix: 'fas',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M32 0C49.7 0 64 14.3 64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0z"]
};
var faFileMedical = {
  prefix: 'fas',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"]
};
var faPotato = {
  prefix: 'fas',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M466.3 249.2C494.4 222.9 512 185.5 512 144C512 64.5 447.5 0 368 0c-39.8 0-75.9 16.2-102 42.3C238.6 69.8 205 95 170.9 113.6c-24.1 13.2-44 33.1-57.3 57.3C95 205 69.8 238.6 42.3 266C16.2 292.1 0 328.2 0 368c0 79.5 64.5 144 144 144c30.3 0 58.4-9.3 81.5-25.3c28.1-19.3 60.2-35.3 92.5-46.2c44.1-14.9 80.1-50.9 93.1-99.2c9.2-34.2 29.4-67.9 55.2-92.1zM384 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM136 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faDiceOne = {
  prefix: 'fas',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCircleA = {
  prefix: 'fas',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L321.2 320H190.8l-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L214.8 272h82.3L256 189.7z"]
};
var faHelmetBattle = {
  prefix: 'fas',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M80 17.1c.6-8.3-5.3-15.7-13.6-17s-16.1 4.1-18 12.2L.8 218.8c-.5 2.2-.8 4.5-.8 6.8C0 242.4 13.6 256 30.4 256h2.2c17.1 0 31.3-13.2 32.5-30.2L80 17.1zM320 352V488c0 18.4 20.8 30.1 36.5 20.5l144-88c9.2-5.6 13.5-16.7 10.6-27.1C494.1 333.6 480 270.2 480 208c0-85-89.1-149.2-153.1-189c-1.9-1.2-4-2.6-6.3-4.1l0 0C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4c-3 10.4 1.4 21.4 10.6 27.1l144 88c15.7 9.6 36.5-2.1 36.5-20.5V296h0V267.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H397.4c10.3 0 18.6 8.3 18.6 18.6c0 8-5.1 15.1-12.7 17.6l-72.3 24.1c-6.5 2.2-10.9 8.3-10.9 15.2V352h0zM509.6 .2c-8.3 1.2-14.2 8.6-13.6 17l14.9 208.6c1.2 17 15.4 30.2 32.5 30.2h2.2c16.8 0 30.4-13.6 30.4-30.4c0-2.3-.3-4.6-.8-6.8L527.6 12.4c-1.9-8.1-9.7-13.5-18-12.2z"]
};
var faButter = {
  prefix: 'fas',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M64 128c0-35.3 28.7-64 64-64H448V288H64V128zM32 320H608c17.7 0 32 14.3 32 32s-14.3 32-32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c-17.7 0-32-14.3-32-32s14.3-32 32-32zM512 64c35.3 0 64 28.7 64 64V288H480V64h32z"]
};
var faBlanketFire = {
  prefix: 'fas',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M0 128V352c0 70.7 57.3 128 128 128H337.6c-16.5-18.6-29.6-40.3-38.1-64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H301.8c6.3-15.5 14.4-30.8 23.3-45.3c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7V128c0-53-43-96-96-96H96C43 32 0 75 0 128zM288 350.1c0-9.8 1.3-19.9 3.6-30.1H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H291c-2-11.1-3-22.4-3-33.9zM453.5 163.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faKiwiBird = {
  prefix: 'fas',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faCastle = {
  prefix: 'fas',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", "M128 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h48V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v96V224h64V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v96V464c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V512H48c-26.5 0-48-21.5-48-48V272 176c0-8.8 7.2-16 16-16H48c8.8 0 16 7.2 16 16v48h64V112 16z"]
};
var faGolfClub = {
  prefix: 'fas',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", "M508.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L264 392.5l0-.5L42.1 318C21.4 311.1 0 326.6 0 348.4V376H48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v32H48c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v8c0 17.7 14.3 32 32 32H255.3c12 .3 23.6-6.3 29.3-17.7l224-448z"]
};
var faArrowRightArrowLeft = {
  prefix: 'fas',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"]
};
var faExchange = faArrowRightArrowLeft;
var faRotateRight = {
  prefix: 'fas',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faUtensils = {
  prefix: 'fas',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"]
};
var faCutlery = faUtensils;
var faArrowUpWideShort = {
  prefix: 'fas',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]
};
var faSortAmountUp = faArrowUpWideShort;
var faChartPieSimpleCircleDollar = {
  prefix: 'fas',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6V240H375.2c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80H224V66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
var faBalloons = {
  prefix: 'fas',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", "M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160c0 92.5 87.2 174 117.7 199.7c5.9 5 7.8 13.4 4.4 20.3L97.4 429.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H211.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L198 379.9c-3.5-6.9-1.6-15.3 4.4-20.3C232.8 334 320 252.5 320 160zM144 96c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zM437.7 423.7c5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9H531.1c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L518 443.9c-3.5-6.9-1.6-15.3 4.4-20.3C552.8 398 640 316.5 640 224c0-88.4-71.6-160-160-160c-53.7 0-101.2 26.4-130.2 67c1.4 9.5 2.2 19.2 2.2 29c0 37.2-11.5 71.8-27.3 101.9c18.5 76.2 86.8 139.7 113 161.8zM416 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"]
};
var faMillSign = {
  prefix: 'fas',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"]
};
var faBowlRice = {
  prefix: 'fas',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTimelineArrow = {
  prefix: 'fas',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H530.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM328 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSkull = {
  prefix: 'fas',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faGameBoardSimple = {
  prefix: 'fas',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 0V256H384V96H224zm0 160H64V416H224V256z"]
};
var faGameBoardAlt = faGameBoardSimple;
var faCircleVideo = {
  prefix: 'fas',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192zM396.9 317.9L352 288V224l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V307.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
};
var faVideoCircle = faCircleVideo;
var faChartScatterBubble = {
  prefix: 'fas',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM384 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faHouseTurret = {
  prefix: 'fas',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", "M256 464V277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48zM424 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H424zM24 0C10.7 0 0 10.7 0 24V96v8 93.5c0 17 6.7 33.3 18.7 45.3L64 288V464c0 26.5 21.5 48 48 48H240c-10-13.4-16-30-16-48V277.1c0-22.4 9.4-43.8 25.9-59L352 124.6V104 96 24c0-13.3-10.7-24-24-24H280c-13.3 0-24 10.7-24 24V96H224V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24V96H96V24C96 10.7 85.3 0 72 0H24zM176 160c22.1 0 40 17.9 40 40v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V200c0-22.1 17.9-40 40-40z"]
};
var faBanana = {
  prefix: 'fas',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", "M304 144c0 35.7-7.3 69.6-20.5 100.5c4.8 3 9.4 6.2 13.9 9.8l35.5 28.4L413.9 261c10.6-2.8 21.4-4.4 32.3-4.9c1.2-10.5 1.8-21.3 1.8-32.1c0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55c10.3 27.7 15.9 57.7 15.9 89zM277.4 279.2c-18.8-15-42.1-23.2-66.1-23.2c-22.9 0-45.2 7.4-63.5 21.2l-42.2 31.6c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l42.2-31.6c10-7.5 22.2-11.6 34.7-11.6c10.5 0 20.8 2.9 29.7 8.2C194.1 366 125 400 48 400c-26.5 0-48 21.5-48 48v16c0 26.5 21.5 48 48 48l112 0c117.3 0 218.2-70.1 263.1-170.6l11.5-3.1c5.7-1.5 11.6-2.3 17.5-2.3c23.8 0 45.9 12.5 58.1 32.9l21.3 35.4c6.8 11.4 21.6 15 32.9 8.2s15-21.6 8.2-32.9l-21.3-35.4C530.4 309.3 492.7 288 452 288c-3.8 0-7.5 .2-11.3 .6c-5.5 .5-10.9 1.5-16.3 2.8c-.8 .2-1.5 .4-2.3 .6l-96.7 25.8h0l-48.1-38.5z"]
};
var faHandHoldingSkull = {
  prefix: 'fas',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M371.6 232.2c-6 3.8-9.4 10.8-8 17.7l4.1 20.6c.2 .9 .3 1.9 .3 2.9c0 8-6.5 14.6-14.6 14.6H222.6c-8 0-14.6-6.5-14.6-14.6c0-1 .1-1.9 .3-2.9l4.1-20.6c1.4-7-2-13.9-8-17.7C167.8 209 144 171 144 128C144 57.3 208.5 0 288 0s144 57.3 144 128c0 43-23.8 81-60.4 104.2zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faPeopleDress = {
  prefix: 'fas',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M208 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM70.2 384H88v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L226.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-53.6-89.2c-20.3-33.7-56.7-54.3-96-54.3H154.2c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9C51.6 373.3 59.3 384 70.2 384zM528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faLoveseat = {
  prefix: 'fas',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M64 160C64 89.3 121.3 32 192 32H320c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM416 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H384h32V320 272z"]
};
var faCouchSmall = faLoveseat;
var faTowerBroadcast = {
  prefix: 'fas',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"]
};
var faBroadcastTower = faTowerBroadcast;
var faTruckPickup = {
  prefix: 'fas',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
var faBlockQuote = {
  prefix: 'fas',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zM128 416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"]
};
var faUpLong = {
  prefix: 'fas',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"]
};
var faLongArrowAltUp = faUpLong;
var faStop = {
  prefix: 'fas',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faCodeMerge = {
  prefix: 'fas',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faMoneyCheckDollarPen = {
  prefix: 'fas',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64.6c-15.2 2-29.8 8.8-41.4 20.5L353.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-6 23.9H64c-35.3 0-64-28.7-64-64V128zM256 304c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM144 139.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V352c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V160c0-11.1-9-20.1-20.1-20.1zm469.8 95.8l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
var faUpFromLine = {
  prefix: 'fas',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M41.9 166.1L164.7 43.3C171.9 36.1 181.8 32 192 32s20.1 4.1 27.3 11.3L342.1 166.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H256V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V224H65.9C47.2 224 32 208.8 32 190.1c0-9 3.6-17.6 9.9-24zM32 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faArrowAltFromBottom = faUpFromLine;
var faUpload = {
  prefix: 'fas',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faHurricane = {
  prefix: 'fas',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGridRound2Plus = {
  prefix: 'fas',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", "M128 224a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 256a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM480 128a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
};
var faPeoplePants = {
  prefix: 'fas',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faMound = {
  prefix: 'fas',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"]
};
var faWindsock = {
  prefix: 'fas',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h64v8.6c0 20.3 18.7 35.5 38.5 31.3l41.5-8.6V64.7L166.5 56c-19.9-4.1-38.5 11-38.5 31.3V96H64V32zm64 112V272H64V144h64zM272 78V338l96-20V98L272 78zM486.5 293.3c14.8-3.1 25.5-16.2 25.5-31.3V154c0-15.2-10.6-28.2-25.5-31.3L432 111.3V304.7l54.5-11.4z"]
};
var faCircleHalf = {
  prefix: 'fas',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256S97.8 494.3 224.1 510c17.5 2.2 31.9-12.4 31.9-30V32z"]
};
var faBrakeWarning = {
  prefix: 'fas',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M96 256a224 224 0 1 1 448 0A224 224 0 1 1 96 256zM344 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM91.1 109C63.8 151.4 48 201.8 48 256s15.8 104.6 43.1 147c7.2 11.1 4 26-7.2 33.2s-26 4-33.2-7.2C18.6 379.1 0 319.7 0 256S18.6 132.9 50.7 83c7.2-11.1 22-14.4 33.2-7.2s14.4 22 7.2 33.2zM589.3 83C621.4 132.9 640 192.3 640 256s-18.6 123.1-50.7 173c-7.2 11.1-22 14.4-33.2 7.2s-14.4-22-7.2-33.2c27.3-42.4 43.1-92.8 43.1-147s-15.8-104.6-43.1-147c-7.2-11.1-4-26 7.2-33.2s26-4 33.2 7.2z"]
};
var faToiletPortable = {
  prefix: 'fas',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faCompactDisc = {
  prefix: 'fas',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faFileArrowDown = {
  prefix: 'fas',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFileDownload = faFileArrowDown;
var faSaxophoneFire = {
  prefix: 'fas',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M102.6 0c-2.5 0-5 .9-7 2.6c-23.3 20.8-43 44.4-57 67.1C24.9 92 16 116 16 134.5c0 14.6 2.8 28.6 7.9 41.5H79.5c-4.8-8-7.5-17.8-7.5-29c0-16.8 10.5-31.5 31.5-57.4c2.8 3.5 43.4 55.3 43.4 55.3l25.2-29.4c2.1 2.8 3.5 5.6 4.9 8.4c9.1 16.7 8.7 36.7-.2 52.1H232c5.1-12.9 8-26.9 8-41.5c0-14.1-6.7-35.7-16.9-55.3c-10.3-19.9-25-40.9-42.3-56.8c-3.9-3.6-10.1-3.6-14 0c-6.7 6.1-13 13.7-18.5 20.7c-12.1-14.5-25-28-38.8-40.4C107.5 .9 105.1 0 102.6 0zm68.8 338.1L218.9 256H232c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H16.9L4.4 309.4C1.5 321.8 0 334.4 0 347.1v3.1C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4L534.4 140.1c6.1-7.7 15.3-12.1 25.1-12.1h64.2c9 0 16.3-7.3 16.3-16.3c0-4.9-2.2-9.5-5.9-12.6L609.8 78.8c-11.5-9.6-26-14.8-41-14.8H538.5c-17 0-33.3 6.7-45.3 18.7L449 127l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L401 175l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L353 223l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L206.6 369.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6v-2.6c0-4.4 1.2-8.8 3.4-12.6zM144 280a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faSaxHot = faSaxophoneFire;
var faCameraWebSlash = {
  prefix: 'fas',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135.2-106C525.9 324.9 544 276.6 544 224C544 100.3 443.7 0 320 0C248 0 183.9 34 143 86.7L38.8 5.1zM193.3 126.2C222.6 88.4 268.5 64 320 64c88.4 0 160 71.6 160 160c0 37.7-13 72.3-34.8 99.6L420 303.9c17.5-21.9 28-49.7 28-79.9c0-70.7-57.3-128-128-128c-41.3 0-78.1 19.6-101.5 50l-25.2-19.7zm88.2 69.1l-25.2-19.7C270.9 156.4 294 144 320 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.8 0-29.8 7.6-38.5 19.3zM507.7 496L359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9c-88.4 0-160-71.6-160-160c0-.6 0-1.3 0-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S146 512 160 512H480c11.6 0 22.1-6.2 27.7-16zM324.8 351.9L194.5 249.2C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1z"]
};
var faWebcamSlash = faCameraWebSlash;
var faFolderMedical = {
  prefix: 'fas',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faFolderGear = {
  prefix: 'fas',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM368.6 259.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM216 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faFolderCog = faFolderGear;
var faHandWave = {
  prefix: 'fas',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", "M352.2 82.3L351 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S297.5-1.1 306.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7l0-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40V312.3c0 60.2-27.9 116.9-75.5 153.7C385.7 505.3 321 515.7 263 498.7c-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9 .1 .1L165.3 344c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L185.4 70.6zM13.7 352.2c8.7-1.2 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.3 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 370.3c-1.2-8.7 4.8-16.9 13.6-18.1z"]
};
var faArrowUpArrowDown = {
  prefix: 'fas',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 141.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zm352 333.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L448 370.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V370.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96z"]
};
var faSortUpDown = faArrowUpArrowDown;
var faCaravan = {
  prefix: 'fas',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faShieldCat = {
  prefix: 'fas',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faMessageSlash = {
  prefix: 'fas',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zM64 352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h32.8L64 146.4V352z"]
};
var faCommentAltSlash = faMessageSlash;
var faBolt = {
  prefix: 'fas',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"]
};
var faZap = faBolt;
var faTrashCanCheck = {
  prefix: 'fas',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM337 265c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z"]
};
var faGlassWater = {
  prefix: 'fas',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"]
};
var faOilWell = {
  prefix: 'fas',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"]
};
var faPersonSimple = {
  prefix: 'fas',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"]
};
var faVault = {
  prefix: 'fas',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"]
};
var faMars = {
  prefix: 'fas',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faToilet = {
  prefix: 'fas',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPlaneCircleXmark = {
  prefix: 'fas',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faYenSign = {
  prefix: 'fas',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faGearCode = {
  prefix: 'fas',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zm-208.2-3.9c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zM187.3 227.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L353.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z"]
};
var faNotes = {
  prefix: 'fas',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M160 32c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64H339.2c4.3 0 8.6-.4 12.8-1.3V320c0-17.7 14.3-32 32-32h94.7c.9-4.2 1.3-8.5 1.3-12.8V96c0-35.3-28.7-64-64-64H160zM384 352v45.7V416l96-96H461.7 416 384v32zM296 464H136c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24V376c0 75.1 60.9 136 136 136H296c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
var faRubleSign = {
  prefix: 'fas',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faTrashUndo = {
  prefix: 'fas',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128zM217.8 199.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V352c0-22.1-17.9-40-40-40H182.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"]
};
var faTrashArrowTurnLeft = faTrashUndo;
var faChampagneGlass = {
  prefix: 'fas',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", "M88 0C71.9 0 58.3 12 56.3 27.9L33.2 208C24.9 273.4 67.3 332.4 128 348V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348c60.7-15.6 103.1-74.6 94.8-140l-23-180.1C261.7 12 248.1 0 232 0H88zm20 128l8.2-64h87.7l8.2 64H108z"]
};
var faGlassChampagne = faChampagneGlass;
var faObjectsAlignCenterHorizontal = {
  prefix: 'fas',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", "M256 0c-13.3 0-24 10.7-24 24V64H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H232v64H144c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h88v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h88c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H280V224H432c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H280V24c0-13.3-10.7-24-24-24z"]
};
var faSun = {
  prefix: 'fas',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faTrashCanSlash = {
  prefix: 'fas',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376V128H195.6L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H416l-7.2-14.3C403.4 6.8 392.3 0 380.2 0H259.8c-12.1 0-23.2 6.8-28.6 17.7L224 32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM304 213v-5c0-8.8 7.2-16 16-16s16 7.2 16 16v30L304 213zm96 75.2V208c0-8.8 7.2-16 16-16s16 7.2 16 16V313.3l-32-25.1zM128 448c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.8L431.5 436c-1.8 6.9-8 12-15.5 12c-8.8 0-16-7.2-16-16V411.2l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V335.5l-64-50.4V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V259.9l-80-63V448z"]
};
var faTrashAltSlash = faTrashCanSlash;
var faScreenUsers = {
  prefix: 'fas',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M96 0C60.7 0 32 28.7 32 64V248.4C49 233.2 71.4 224 96 224V64l448 0V224c24.6 0 47 9.2 64 24.4V64c0-35.3-28.7-64-64-64H96zm64 320A64 64 0 1 0 32 320a64 64 0 1 0 128 0zM0 480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64zM384 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM224 480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H288c-35.3 0-64 28.7-64 64zm320-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H512z"]
};
var faUsersClass = faScreenUsers;
var faGuitar = {
  prefix: 'fas',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSquareArrowLeft = {
  prefix: 'fas',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM87 239L199 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L344 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L87 273c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faArrowSquareLeft = faSquareArrowLeft;
var faSquare8 = {
  prefix: 'fas',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm232 32H216c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0H216s0 0 0 0zm16 48h8c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h8 16z"]
};
var faFaceSmileHearts = {
  prefix: 'fas',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M448.2 34.3c-1.3 19.7 5.5 39.8 20.5 54.9l55.5 55.8c9.2 9.3 21.1 14.2 33.2 14.9C569.4 189.6 576 222 576 256c0 37.4-8 73-22.5 105.1c-27-15.2-61.9-11.3-84.8 11.8c-25.8 26-27.5 67.1-4.9 94.9C422.8 495.7 373.3 512 320 512c-61.3 0-117.6-21.6-161.7-57.6l13.1-13.1c27.6-27.7 27.6-72.6 0-100.4c-24.8-25-63.6-27.6-91.3-7.7c-1.7-1.2-3.5-2.4-5.2-3.4C67.8 306.5 64 281.7 64 256C64 114.6 178.6 0 320 0c46.7 0 90.5 12.5 128.2 34.3zM205.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm-.7-90.3c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm230.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM573.7 11.5c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0L491.4 66.7c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 25.3l13.7-13.8zm54.9 384c15.2 15.3 15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 409.3l13.7-13.8c15.2-15.3 39.8-15.3 54.9 0zm-534.9-32c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2L93.2 474.5c-7.3 7.3-19.1 7.3-26.3 0L11.4 418.7c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L80 377.3l13.7-13.8z"]
};
var faBracketsSquare = {
  prefix: 'fas',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zM64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64V416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32z"]
};
var faBrackets = faBracketsSquare;
var faLaptopArrowDown = {
  prefix: 'fas',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M128 32C92.7 32 64 60.7 64 96V352h64V96H256V32H128zM512 96V352h64V96c0-35.3-28.7-64-64-64H384V96H512zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2zM344 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V238.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V56z"]
};
var faHockeyStickPuck = {
  prefix: 'fas',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4H160 128 96V480 352H252.2L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32H64V512H32c-17.7 0-32-14.3-32-32V384zm416 32H608c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448c0-17.7 14.3-32 32-32z"]
};
var faHouseTree = {
  prefix: 'fas',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H514.6L601 300c7.7 9.6 9.2 22.8 3.9 33.9S588.3 352 576 352H546.6L633 460c7.7 9.6 9.2 22.8 3.9 33.9S620.3 512 608 512H400c10-13.4 16-30 16-48V277.1c0-22.4-9.4-43.8-25.9-59L282.9 119.9 393.4 9.4zM0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V277.1zM144 296v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V296c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24z"]
};
var faSignalFair = {
  prefix: 'fas',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", "M224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V416z"]
};
var faSignal2 = faSignalFair;
var faFaceLaughWink = {
  prefix: 'fas',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faLaughWink = faFaceLaughWink;
var faCircleDollar = {
  prefix: 'fas',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm20.8-378.4v14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7V133.6c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
var faDollarCircle = faCircleDollar;
var faUsdCircle = faCircleDollar;
var faHorseHead = {
  prefix: 'fas',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsRepeat = {
  prefix: 'fas',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M1.6 213.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2C77.1 189.9 118.5 160 165.2 160H338.7l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96H165.2C91 96 25.1 143.5 1.6 213.9zm508.7 84.2c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2C434.9 322.1 393.5 352 346.8 352H173.3l41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 416H346.8c74.2 0 140.1-47.5 163.6-117.9z"]
};
var faRepeatAlt = faArrowsRepeat;
var faBoreHole = {
  prefix: 'fas',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"]
};
var faIndustry = {
  prefix: 'fas',
  iconName: 'industry',
  icon: [576, 512, [], "f275", "M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"]
};
var faImagePolaroid = {
  prefix: 'fas',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H352c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm152 64c-5.3 0-10.2 2.6-13.2 6.9l-52.4 76.3-9.6-12.8c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-48 64c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8h48 48 40 88c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faWaveTriangle = {
  prefix: 'fas',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", "M176 32c10.1 0 19.6 4.7 25.6 12.8L464 394.7 582.4 236.8c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-144 192c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L176 117.3 57.6 275.2c-10.6 14.1-30.7 17-44.8 6.4s-17-30.7-6.4-44.8l144-192c6-8.1 15.5-12.8 25.6-12.8z"]
};
var faPersonRunningFast = {
  prefix: 'fas',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM259.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C198.4 108.3 228.2 96 259.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H458.7c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L334 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L382.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM205.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h59.2l18.3-41.3zM16 95.8H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm16 48H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faCircleDown = {
  prefix: 'fas',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"]
};
var faArrowAltCircleDown = faCircleDown;
var faGrill = {
  prefix: 'fas',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M0 72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40V96c0 89.8-52.9 167.3-129.2 203l63.2 147.5c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L316.7 416H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96V72zM151.8 368H296.2l-22.9-53.4c-15.9 3.6-32.3 5.4-49.3 5.4s-33.4-1.9-49.3-5.4L151.8 368zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faArrowsTurnToDots = {
  prefix: 'fas',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"]
};
var faChartMixed = {
  prefix: 'fas',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", "M500 89c13.8-11 16-31.2 5-45s-31.2-16-45-5L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L500 89zM160 256V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32s-32 14.3-32 32zm288-64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32zm96-32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faAnalytics = faChartMixed;
var faFlorinSign = {
  prefix: 'fas',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"]
};
var faArrowDownShortWide = {
  prefix: 'fas',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faLessThan = {
  prefix: 'fas',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"]
};
var faDisplayCode = {
  prefix: 'fas',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336l10.7 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm64 0V352H512V64H64zM249 177l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM361 143l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faDesktopCode = faDisplayCode;
var faFaceDrooling = {
  prefix: 'fas',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M384 477.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c33.9 0 66.4-6.6 96-18.6V370.9c-9.7 6.4-20.3 12.2-32 16.9V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V397.1c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-3.8 4.7-7.9 9.5-12.5 14.2V477.8zM158.6 189.6c-8.4 8-13.5 17.7-15.4 23.5c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2c3.4-10.2 11.1-24.6 23.8-36.5C149.5 154.2 167.9 144 192 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-14.3 0-25.2 5.8-33.4 13.6zm210.2 23.5c-1.9-5.8-7-15.4-15.4-23.5c-8.2-7.8-19-13.6-33.4-13.6c-8.8 0-16-7.2-16-16s7.2-16 16-16c24.1 0 42.5 10.2 55.4 22.4c12.6 12 20.4 26.3 23.8 36.5c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1z"]
};
var faOilTemperature = {
  prefix: 'fas',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", "M256 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H320V96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V128 32zM400 304l0-1.2c21.9-3.2 43.7-12.6 61.5-24.9l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 357.7 417 368 384 368c-1.4 0-2.7 0-4-.1c12.6-18.1 20-40.2 20-63.9zM192 368c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0c17.8 12.3 39.6 21.7 61.4 24.9l0 1.2c0 23.8 7.4 45.8 20 63.9c-1.3 0-2.7 .1-4 .1zm192 80c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0C329 437.4 356.5 448 384 448z"]
};
var faOilTemp = faOilTemperature;
var faSquareQuestion = {
  prefix: 'fas',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm73.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H190.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faQuestionSquare = faSquareQuestion;
var faAirConditioner = {
  prefix: 'fas',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 256H192V416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7c15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7C83.4 349.4 64 380.4 64 416c0 53 43 96 96 96s96-43 96-96V256zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32V256H320V384z"]
};
var faAngleDown = {
  prefix: 'fas',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
};
var faMountains = {
  prefix: 'fas',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M381.1 480H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 164.1 472.2 160 480 160s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1H456.1h-75z"]
};
var faOmega = {
  prefix: 'fas',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 96C135.6 96 64 167.6 64 256c0 56.4 29.1 106 73.3 134.5c13.3 8.6 22.7 23.7 22.7 41.2c0 26.7-21.6 48.3-48.3 48.3H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H67.2C25.8 375.4 0 318.7 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H336.3c-26.7 0-48.3-21.6-48.3-48.3c0-17.5 9.4-32.6 22.7-41.2C354.9 362 384 312.4 384 256c0-88.4-71.6-160-160-160z"]
};
var faCarTunnel = {
  prefix: 'fas',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPersonDollyEmpty = {
  prefix: 'fas',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7V241.7l16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4h70.7l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1l6.5 26.2H161.1l-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6v88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32v0V410.5l-64-64zM272 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faPanFood = {
  prefix: 'fas',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M320 512A256 256 0 1 0 320 0a256 256 0 1 0 0 512zm0-448c37.2 0 69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14H254.3c-7.4 0-12.9-6.8-11.5-14l.6-3.2C250.7 90.3 282.8 64 320 64zM230.1 185.9c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM227.3 284.7c2.1 2.1 3.5 4.6 4.2 7.3c.4 1.7 .8 3.4 1.1 5.1c1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7H280c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56V349.3c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9c-1.7-.3-3.5-.7-5.1-1.1c-2.7-.7-5.2-2.1-7.3-4.2c-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zM455.8 184.2c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6v4.8c0 18.7-8.5 36.4-23.1 48.1C462 299.2 448.4 304 434.4 304l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4l79.6-79.6zM24 160c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm616 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V328c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
};
var faHeadSideCough = {
  prefix: 'fas',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGripLines = {
  prefix: 'fas',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"]
};
var faThumbsDown = {
  prefix: 'fas',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"]
};
var faUserLock = {
  prefix: 'fas',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowRightLong = {
  prefix: 'fas',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faLongArrowRight = faArrowRightLong;
var faTicketsAirline = {
  prefix: 'fas',
  iconName: 'tickets-airline',
  icon: [640, 512, [], "e29b", "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V272c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm416 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM265.3 106.5c-1.7-5.2 2.1-10.5 7.6-10.5H304c8.5 0 16.4 4.5 20.7 11.9L364.4 176h40.3c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7H364.4l-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9H272.9c-5.5 0-9.3-5.3-7.6-10.5L288.4 240H245.8l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4H200c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9h13.8c5 0 9.8 2.4 12.8 6.4L245.8 176h42.7l-23.2-69.5zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"]
};
var faAnchorCircleXmark = {
  prefix: 'fas',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faEllipsis = {
  prefix: 'fas',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faEllipsisH = faEllipsis;
var faNfcSlash = {
  prefix: 'fas',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V96c0-35.3-28.7-64-64-64H160c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM173.5 110.7c8.7-9 21-14.7 34.5-14.7h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-3.3 0-6.4 1-8.9 2.7l-25.6-20.1zM302.1 211.5c.6-.3 1.3-.5 1.9-.7V144c0-26.5 21.5-48 48-48h80c26.5 0 48 21.5 48 48V350.9l-32-25.1V144c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v66.7c18.6 6.6 32 24.4 32 45.3c0 2.3-.2 4.6-.5 6.8l-65.5-51.3zM486.9 479.6L406.2 416H208c-26.5 0-48-21.5-48-48V222.1L96 171.6V416c0 35.3 28.7 64 64 64H480c2.3 0 4.6-.1 6.9-.4zM208 384H365.5L192 247.3V368c0 8.8 7.2 16 16 16z"]
};
var faChessPawn = {
  prefix: 'fas',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"]
};
var faKitMedical = {
  prefix: 'fas',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"]
};
var faFirstAid = faKitMedical;
var faGrid2Plus = {
  prefix: 'fas',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", "M80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 256h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
};
var faBells = {
  prefix: 'fas',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M230.8 245.5l18.7 51.2c11.7 31.8 12.9 66.5 3.5 99.1l-1.1 3.9L21.4 315.8C10 311.7 2 301.5 .6 289.5s4.1-23.8 14.3-30.4l8.2-5.4C57.6 231 84 197.8 98.2 159l14.7-40C138 50.4 214 15.1 282.6 40.1c4.8 1.7 9.4 3.7 13.9 6c-64.1 42.2-93.3 124.2-65.7 199.5zm30.1-10.9c-26.1-71.3 10.5-150.2 81.9-176.2s150.4 10.8 176.5 82.1L538 191.7c14 38.2 39.8 71 73.6 93.6l13.7 9.2c10 6.7 15.4 18.5 14 30.4s-9.5 22.1-20.8 26.2L321.1 459.4c-11.3 4.1-24 1.5-32.8-6.7s-12.3-20.7-9-32.2l4.6-15.8c11.2-39 9.7-80.7-4.3-118.9l-18.8-51.2zM480.8 480c-21.2 0-40-10.2-51.7-25.9l116.1-42.3c.1 1.3 .1 2.6 .1 3.9c0 35.5-28.9 64.3-64.5 64.3zM94.3 376.1l117.6 43.4c-11.6 17.1-31.2 28.4-53.5 28.4c-35.6 0-64.5-28.8-64.5-64.3c0-2.5 .1-5.1 .4-7.5z"]
};
var faPersonThroughWindow = {
  prefix: 'fas',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faToolbox = {
  prefix: 'fas',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"]
};
var faEnvelopeDot = {
  prefix: 'fas',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M496 0a80 80 0 1 1 0 160A80 80 0 1 1 496 0zM48 64H385.1c-.7 5.2-1.1 10.6-1.1 16c0 45.6 27.2 84.8 66.3 102.3L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112C0 85.5 21.5 64 48 64zM294.4 339.2L490.8 191.9c1.7 .1 3.4 .1 5.2 .1c5.4 0 10.8-.4 16-1.1V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V176L217.6 339.2c22.8 17.1 54 17.1 76.8 0z"]
};
var faEnvelopeBadge = faEnvelopeDot;
var faHandsHoldingCircle = {
  prefix: 'fas',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"]
};
var faBug = {
  prefix: 'fas',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"]
};
var faBowlChopsticks = {
  prefix: 'fas',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M18.5 125.1l473.8-74c11.3-1.8 19.7-11.5 19.7-23c0-14.6-13.3-25.6-27.6-22.9L13.1 93.6C5.5 95 0 101.6 0 109.3c0 9.8 8.8 17.3 18.5 15.8zM0 159.7c0 9 7.3 16.2 16.2 16.2H488.4c13 0 23.6-10.6 23.6-23.6c0-13.3-11-24-24.4-23.6L15.7 143.5C7 143.8 0 151 0 159.7zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35H332.7c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5H33.6z"]
};
var faCreditCard = {
  prefix: 'fas',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faCreditCardAlt = faCreditCard;
var faCircleS = {
  prefix: 'fas',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
var faBoxBallot = {
  prefix: 'fas',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", "M128 32c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32V224H128V32zM0 352H576V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352zM48 160H96v96H480V160h48c26.5 0 48 21.5 48 48V320H0V208c0-26.5 21.5-48 48-48z"]
};
var faCar = {
  prefix: 'fas',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faAutomobile = faCar;
var faHandHoldingHand = {
  prefix: 'fas',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faUserTieHair = {
  prefix: 'fas',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0zm55.7 510.9c1.8 .7 3.8 1.1 5.8 1.1H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c2.1 0 4-.4 5.8-1.1L168 512H280l-.3-1.1z"]
};
var faPodiumStar = {
  prefix: 'fas',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M168 72c-22.1 0-40 17.9-40 40v32H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H80V112c0-48.6 39.4-88 88-88h14.4C190.7 9.7 206.2 0 224 0h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H224c-17.8 0-33.3-9.7-41.6-24H168zM73.7 455.1L48 224H400L374.3 455.1c-3.6 32.4-31 56.9-63.6 56.9H137.3c-32.6 0-60-24.5-63.6-56.9zM231.3 276.8c-2.9-6.4-11.7-6.4-14.5 0l-20.2 45.5c-1.2 2.6-3.6 4.4-6.3 4.8l-47.9 5.9c-6.8 .8-9.5 9.5-4.5 14.3l35.4 34c2 2 3 4.9 2.4 7.7l-9.4 49.1c-1.3 6.9 5.8 12.3 11.8 8.9l42.1-24.4c2.4-1.4 5.4-1.4 7.8 0L270 446.9c6 3.5 13.1-1.9 11.8-8.9L272.3 389c-.5-2.8 .4-5.8 2.4-7.7l35.4-34c5-4.8 2.3-13.5-4.5-14.3L257.8 327c-2.8-.3-5.2-2.1-6.3-4.8l-20.2-45.5z"]
};
var faUserHairMullet = {
  prefix: 'fas',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M304 128v16c0 18-6 34.6-16 48h0v0c-14.6 19.4-37.8 32-64 32s-49.4-12.6-64-32v0h0c-10-13.4-16-30-16-48V128c0-5.7 .6-11.3 1.7-16.6c30.6-3.1 58.5-17.9 78.3-40.6c19.8 22.7 47.6 37.5 78.3 40.6c1.1 5.4 1.7 10.9 1.7 16.6zM237.4 271.3L255 289c5.5 5.5 13.2 8 20.8 6.7s14.2-6.1 17.6-13l6.1-12.2 19.5 7.8c9.3 3.7 19.8 1.3 26.6-6s8.3-18.1 3.8-27c-8.5-17-11-22.3-12.2-27.1c-.7-2.9-1.1-5.9-1.2-12.3C346.2 187.5 352 166.4 352 144V128c0-7.1-.6-14-1.7-20.7c5.9-4.4 9.7-11.4 9.7-19.3c0-13.3-10.7-24-24-24h-1.1C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H112C98.7 64 88 74.7 88 88c0 7.9 3.8 14.9 9.7 19.3C96.6 114 96 120.9 96 128v16c0 22.4 5.8 43.5 15.9 61.8c-.1 6.4-.5 9.4-1.2 12.3c-1.2 4.8-3.7 10.1-12.2 27.1c-4.5 8.9-2.9 19.7 3.8 27s17.3 9.7 26.6 6l19.5-7.8 6.1 12.2c3.5 6.9 10 11.7 17.6 13s15.4-1.3 20.8-6.7l17.7-17.7c4.4 .5 8.9 .7 13.4 .7s9-.2 13.4-.7zM161.3 320C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320H161.3z"]
};
var faBusinessFront = faUserHairMullet;
var faPartyBack = faUserHairMullet;
var faTrianBalbot = faUserHairMullet;
var faMicrophoneStand = {
  prefix: 'fas',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M479.2 32.8c-43.7-43.7-114.7-43.7-158.4 0l-4.7 4.7L474.5 195.9l4.7-4.7c43.7-43.7 43.7-114.7 0-158.4zM293.5 60.1l-4.7 4.7c-24.4 24.4-35.2 57.2-32.4 89L358.2 255.6c31.8 2.8 64.6-8 89-32.4l4.7-4.7L293.5 60.1zM229.1 171.7L215.8 187 7.8 427c-11 12.7-10.3 31.7 1.6 43.6l32 32c11.9 11.9 30.9 12.6 43.6 1.6L224 383.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V328.2l37-32 15.3-13.3L229.1 171.7z"]
};
var faBookOpenReader = {
  prefix: 'fas',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"]
};
var faBookReader = faBookOpenReader;
var faFamilyDress = {
  prefix: 'fas',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM112.3 160h31.4c11.8 0 23 3.2 32.6 8.9c-.2 2.3-.3 4.7-.3 7.1c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2v16c0 28.4 12.4 54 32 71.6V480c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5H112c-26.5 0-48-21.5-48-48V384H42.4c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4c7.8-27.5 33-46.4 61.5-46.4zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.5 2.4-11.4 2.4-17.5V423.6c19.6-17.6 32-43.1 32-71.6V336c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.8-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v80c0 26.5-21.5 48-48 48H368zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80v16c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V407.4c-19.1-11.1-32-31.7-32-55.4V336c0-44.2 35.8-80 80-80z"]
};
var faCircleX = {
  prefix: 'fas',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5L256 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L224.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"]
};
var faCabin = {
  prefix: 'fas',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M237.4 6C248.5-2 263.5-2 274.6 6L384 84.1V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v88.7L498.6 166c11.3 8.1 16.1 22.6 11.9 35.8S493.9 224 480 224H448 416 32c-13.9 0-26.2-9-30.5-22.2S2.1 174 13.4 166L237.4 6zM32 280c0-13.3 10.7-24 24-24H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V280zm24 72H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm0 96H168c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V472c0-13.3 10.7-24 24-24zM320 280c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V280zm24 168H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V472c0-13.3 10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24H456c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24H344c-13.3 0-24-10.7-24-24V376zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faMountainSun = {
  prefix: 'fas',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"]
};
var faChartSimpleHorizontal = {
  prefix: 'fas',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M400 320c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l352 0zM208 480c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 352c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0zM384 112l0-32c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 32c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48z"]
};
var faBluetooth = {
  prefix: 'fas',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M178.8 2.9c11.4-5.2 24.8-3.2 34.3 5.1l128 112C348 126 352 134.8 352 144s-4 18-10.9 24.1L240.6 256l100.5 87.9C348 350 352 358.8 352 368s-4 18-10.9 24.1l-128 112c-9.4 8.3-22.9 10.2-34.3 5.1S160 492.6 160 480V326.5L85.1 392.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2L143.4 256 42.9 168.1c-13.3-11.6-14.6-31.9-3-45.2s31.9-14.6 45.2-3L160 185.5V32c0-12.6 7.3-24 18.8-29.1zM224 326.5v83L271.4 368 224 326.5zm0-141L271.4 144 224 102.5v83z"]
};
var faArrowsLeftRightToLine = {
  prefix: 'fas',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faHandBackPointLeft = {
  prefix: 'fas',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 168c0-22.1 17.9-40 40-40l200 0 7 0 73 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.7 0c1.4-2 3-3.9 4.5-5.8l16-19.2C297 56.4 315 48 334 48L372 48c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 320c0 70.7-57.3 128-128 128l-64 0-32 0c-26.5 0-48-21.5-48-48c0-12.4 4.7-23.6 12.3-32.1C227.5 366 208 345.3 208 320c0-12.4 4.7-23.6 12.3-32.1C195.5 286 176 265.3 176 240c0-12.3 4.6-23.5 12.2-32L40 208c-22.1 0-40-17.9-40-40z"]
};
var faMessageDots = {
  prefix: 'fas',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCommentAltDots = faMessageDots;
var faMessaging = faMessageDots;
var faFileHeart = {
  prefix: 'fas',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 344.6C86.5 333.1 80 317.5 80 301.3z"]
};
var faBeerMug = {
  prefix: 'fas',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", "M267.7 133.3C253 149.7 231.7 160 208 160s-45-10.3-59.7-26.7c-6.9-7.7-21.4-8.6-29.6-2.3C108 139.1 94.6 144 80 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c14.6 0 28 4.9 38.7 13c8.2 6.3 22.7 5.4 29.6-2.3C163 10.3 184.3 0 208 0s45 10.3 59.7 26.7c6.9 7.7 21.4 8.6 29.6 2.3C308 20.9 321.4 16 336 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.6 0-28-4.9-38.7-13c-8.2-6.3-22.7-5.4-29.6 2.3zM32 448V163.2C46.1 171.3 62.5 176 80 176c18.7 0 36.2-5.4 51-14.7c20 19 47.2 30.7 77 30.7s57-11.7 77-30.7c14.8 9.3 32.3 14.7 51 14.7c19.6 0 37.9-5.9 53.1-16h46.1c42.4 0 76.8 34.4 76.8 76.8V338.9c0 30.3-17.9 57.9-45.6 70.2L384 445.7V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm352-72.4l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V236.8c0-7.1-5.7-12.8-12.8-12.8H384V375.6zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V400c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"]
};
var faBeerFoam = faBeerMug;
var faDiceD20 = {
  prefix: 'fas',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"]
};
var faDrone = {
  prefix: 'fas',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M223 127.2L171.6 88.7C162.3 64.9 139.1 48 112 48c-35.3 0-64 28.7-64 64c0 27.1 16.9 50.3 40.7 59.6L127.2 223c-5 .7-10.1 1-15.2 1C50.1 224 0 173.9 0 112S50.1 0 112 0s112 50.1 112 112c0 5.2-.3 10.2-1 15.2zm-49.6 2.8l39.8 29.9 .1 .1h85.3l.1-.1 39.8-29.9 29.7-22.3C370.3 92.1 383.8 80 400 80c17.7 0 32 14.3 32 32c0 16.2-12.1 29.7-27.8 31.7l-22.3 29.7-29.9 39.8-.1 .1v85.3l.1 .1 29.9 39.8 22.3 29.7c15.7 2.1 27.8 15.5 27.8 31.7c0 17.7-14.3 32-32 32c-16.2 0-29.7-12.1-31.7-27.8l-29.7-22.3-39.8-29.9-.1-.1H213.3l-.1 .1-39.8 29.9-29.7 22.3C141.7 419.9 128.2 432 112 432c-17.7 0-32-14.3-32-32c0-16.2 12.1-29.7 27.8-31.7l22.3-29.7 29.9-39.8 .1-.1V213.3l-.1-.1-29.9-39.8-22.3-29.7C92.1 141.7 80 128.2 80 112c0-17.7 14.3-32 32-32c16.2 0 29.7 12.1 31.7 27.8l29.7 22.3zM224 400c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c5.2 0 10.2 .3 15.2 1L88.7 340.4C64.9 349.7 48 372.9 48 400c0 35.3 28.7 64 64 64c27.1 0 50.3-16.9 59.6-40.7L223 384.8c.7 5 1 10.1 1 15.2zm65-272.8c-.7-5-1-10.1-1-15.2C288 50.1 338.1 0 400 0s112 50.1 112 112s-50.1 112-112 112c-5.2 0-10.2-.3-15.2-1l38.5-51.3c23.8-9.3 40.7-32.5 40.7-59.6c0-35.3-28.7-64-64-64c-27.1 0-50.3 16.9-59.6 40.7L289 127.2zM288 400c0-5.2 .3-10.2 1-15.2l51.3 38.5c9.3 23.8 32.5 40.7 59.6 40.7c35.3 0 64-28.7 64-64c0-27.1-16.9-50.3-40.7-59.6L384.8 289c5-.7 10.1-1 15.2-1c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112z"]
};
var faTruckDroplet = {
  prefix: 'fas',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"]
};
var faFileCircleXmark = {
  prefix: 'fas',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
var faTemperatureArrowUp = {
  prefix: 'fas',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"]
};
var faTemperatureUp = faTemperatureArrowUp;
var faMedal = {
  prefix: 'fas',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"]
};
var faPersonFairy = {
  prefix: 'fas',
  iconName: 'person-fairy',
  icon: [640, 512, [], "e608", "M320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM297.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4zM32 32c89.4 0 169.4 40.8 222.2 104.7c-37.4 15.7-64.6 51.2-68.2 94L181.9 280c-3 36.2 14.4 69 42.1 87.7v79.6C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64C0 46.3 14.3 32 32 32zM528 480c-41.2 0-79.7-12-112-32.7V367.7c27.8-18.7 45.1-51.5 42.1-87.7L454 230.7c-3.6-42.7-30.8-78.2-68.2-94C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32H528z"]
};
var faBed = {
  prefix: 'fas',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faBookCopy = {
  prefix: 'fas',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M160 96L96 96C43 96 0 139 0 192V416c0 53 43 96 96 96H320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 288 96c-17.7 0-32-14.3-32-32s14.3-32 32-32h81.1c-10.9-18.8-17.1-40.7-17.1-64V96zM320 416h32H512h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H512 288c-53 0-96 43-96 96V320c0 24.6 9.2 47 24.4 64c17.6 19.6 43.1 32 71.6 32h32zm-64-96c0-17.7 14.3-32 32-32h96 96v64H384 288c-17.7 0-32-14.3-32-32z"]
};
var faSquareH = {
  prefix: 'fas',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faHSquare = faSquareH;
var faSquareC = {
  prefix: 'fas',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z"]
};
var faClockTwo = {
  prefix: 'fas',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faSquareEllipsisVertical = {
  prefix: 'fas',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faCalendarUsers = {
  prefix: 'fas',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M192 32V64H144c-26.5 0-48 21.5-48 48v48h32H512h32V112c0-26.5-21.5-48-48-48H448V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H256V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm55.4 480H392.6c-5.4-9.4-8.6-20.3-8.6-32c0-43.8 29.4-80.8 69.6-92.3c-23-20.5-37.6-50.4-37.6-83.7c0-56.4 41.7-103.1 96-110.9V192H128v1.1c54.3 7.8 96 54.4 96 110.9c0 33.3-14.5 63.2-37.6 83.7C226.6 399.2 256 436.2 256 480c0 11.7-3.1 22.6-8.6 32zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H480zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64z"]
};
var faPodcast = {
  prefix: 'fas',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
var faBee = {
  prefix: 'fas',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", "M196.7 4.7c6.2-6.2 16.4-6.2 22.6 0l34.8 34.8C264.4 34.7 275.9 32 288 32s23.6 2.7 33.9 7.5L356.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L347.8 58.8C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112c0 61.9-53.6 104.9-112.9 111.2c.6-5.1 .9-10.2 .9-15.2c0-16.8-2.4-33.1-6.8-48.5c35.2-3.6 54.8-27.9 54.8-47.5c0-21.3-22.9-48-64-48c-34.8 0-56.6 19.2-62.4 38.1c28.6 26.3 46.4 64 46.4 105.9c0 83.8-103.6 179.7-129.9 202.8c-3.9 3.4-8.9 5.2-14.1 5.2s-10.2-1.8-14.1-5.2C247.6 483.7 144 387.8 144 304c0-41.9 17.9-79.6 46.4-105.9C184.6 179.2 162.8 160 128 160c-41.1 0-64 26.7-64 48c0 19.6 19.5 43.9 54.8 47.5c-4.4 15.4-6.8 31.7-6.8 48.5c0 5 .3 10.1 .9 15.2C53.6 312.9 0 269.9 0 208C0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9c-.3-2.9-.5-5.9-.5-8.9c0-20.4 7.6-39 20.2-53.2L196.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm52.8 384.1c12.8 16.4 26.5 31.3 38.5 43.4c12-12.1 25.7-27 38.5-43.4c1.2-1.6 2.5-3.2 3.7-4.8H245.8c1.2 1.6 2.4 3.2 3.7 4.8zM359.6 336c5.6-12.6 8.4-23.4 8.4-32H208c0 8.6 2.8 19.4 8.4 32H359.6zM352 256c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32H352z"]
};
var faTemperatureFull = {
  prefix: 'fas',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faBell = {
  prefix: 'fas',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]
};
var faCandyBar = {
  prefix: 'fas',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M0 320H128V224H0v96zm0 64c0 35.3 28.7 64 64 64h64V352H0v32zm288 64V352H160v96H288zm0-224H160v96H288V224zm0-160H160V192H288V64zm288 0H320V448H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM44.2 192H120s0 0 0 0h8V160h0V108.2c0-7.1-9-11.1-15-7.4C101 107.9 87 112 72 112c-4 0-7.9-.3-11.7-.9c-7-1-14.2 6.2-13.1 13.1c.6 3.8 .9 7.7 .9 11.7c0 15-4.1 29-11.3 41c-3.6 6.1 .4 15 7.4 15z"]
};
var faChocolateBar = faCandyBar;
var faXmarkLarge = {
  prefix: 'fas',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"]
};
var faPinata = {
  prefix: 'fas',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M112 318.1V254.7l25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2L259.8 224H288 432c44.2 0 80 35.8 80 80v13.2l-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7L112 318.1zm0 35.8l2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6v50.5l-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7H224c-3.2 0-6.2 .9-8.9 2.7l-16.3 10.8-16.5-8.3c-9-4.5-19.6-4.5-28.6 0L136 414.1l-24-12V353.9zm37.3-119.2L34.4 190.6C13.4 179.6 0 157.8 0 133.8V128C0 92.7 28.7 64 64 64H176V32c0-17.7 14.3-32 32-32s32 14.3 32 32V198.1l-71.4 35.7c-6 3-13.1 3.4-19.3 .9zM112 437.9l9.7 4.8c9 4.5 19.6 4.5 28.6 0l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2l7.4-4.9V480c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V437.9zm288-2.7l7.4 4.9c9.6 6.4 21.8 7.1 32.1 2l16.5-8.3 17.7 8.8c9 4.5 19.6 4.5 28.6 0l9.7-4.8V480c0 17.7-14.3 32-32 32H432c-17.7 0-32-14.3-32-32V435.2zM200 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faArrowsFromLine = {
  prefix: 'fas',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352v32H160c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H256V352c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faSuperscript = {
  prefix: 'fas',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"]
};
var faBowlSpoon = {
  prefix: 'fas',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M112 192C50.1 192 0 149 0 96S50.1 0 112 0c48.8 0 90.3 26.7 105.6 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H217.6c-15.4 37.3-56.9 64-105.6 64zM2 257.5C.9 239.3 15.4 224 33.6 224H478.4c18.2 0 32.7 15.3 31.6 33.5c-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35H179.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5z"]
};
var faHexagonCheck = {
  prefix: 'fas',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
var faPlugCircleXmark = {
  prefix: 'fas',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faStarOfLife = {
  prefix: 'fas',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"]
};
var faPhoneSlash = {
  prefix: 'fas',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"]
};
var faTrafficLightStop = {
  prefix: 'fas',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm72 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-128a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
var faPaintRoller = {
  prefix: 'fas',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"]
};
var faAccentGrave = {
  prefix: 'fas',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M108.3 204.8L41.2 95c-6-9.8-9.2-21.2-9.2-32.7C32 28.1 59.7 0 93.9 0c29.2 0 54.4 20.4 60.6 49l27.1 126.6C187 200.5 168 224 142.5 224c-14 0-26.9-7.3-34.2-19.2z"]
};
var faHandshakeAngle = {
  prefix: 'fas',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"]
};
var faHandsHelping = faHandshakeAngle;
var faCircle0 = {
  prefix: 'fas',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faDialMedLow = {
  prefix: 'fas',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM174.6 400.5c-56.7-56.7-62-145.4-15.7-208L270.8 304.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L192.8 158.5c62.6-46.2 151.3-41 208 15.7c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faLocationDot = {
  prefix: 'fas',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faMapMarkerAlt = faLocationDot;
var faCrab = {
  prefix: 'fas',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M128 0C60 0 4.4 53 .2 120c0 .2 0 .3 0 .5L0 128H7.9l.1 0H0v33.3c0 28.1 16.3 53.6 41.8 65.4L98.9 253c-3.7 6-6.9 12.4-9.6 19H51.8L23.2 257.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l32 16c2.2 1.1 4.7 1.7 7.2 1.7H81c-.7 5.2-1 10.6-1 16v9.8l-21.1 7c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L72.6 366l28-9.3 30.7 30.7L90.9 400.8c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L104.6 430l52-17.3 15.7 15.7-36.6 21.9c-4.8 2.9-7.8 8.1-7.8 13.7v32c0 8.8 7.2 16 16 16s16-7.2 16-16V473.1L201.8 448H310.2L352 473.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V464c0-5.6-3-10.8-7.8-13.7l-36.6-21.9 15.7-15.7 52 17.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-40.4-13.5 30.7-30.7 28 9.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-21.1-7V320c0-5.4-.3-10.8-1-16h33c2.5 0 4.9-.6 7.2-1.7l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L460.2 272H422.7c-2.7-6.6-5.9-13-9.6-19l57.1-26.3c25.5-11.8 41.8-37.3 41.8-65.4V128h-8c0 0 .1 0 .1 0H512l-.2-7.5c0-.1 0-.3 0-.4l0 0 0 0C507.6 53 452 0 384 0H339.3c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c5 5 1.5 13.7-5.7 13.7H328c-4.4 0-8.1 3.6-7.5 8c3.9 31.6 30.9 56 63.5 56h80v33.3c0 9.4-5.4 17.9-13.9 21.8L378.7 216c-16.9-12.2-37-20.3-58.7-23V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H224V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v49c-21.7 2.7-41.7 10.9-58.7 23L61.9 183.1C53.4 179.2 48 170.6 48 161.3V128h80c32.6 0 59.6-24.4 63.5-56c.5-4.4-3.1-8-7.5-8H147.3c-7.1 0-10.7-8.6-5.7-13.7l36.7-36.7c5-5 1.5-13.7-5.7-13.7H128z"]
};
var faBoxOpenFull = {
  prefix: 'fas',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M508.9 64.9l-27.5 73.4L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1 .6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0c69.6 0 126.2 55.6 128 124.7l35.1-93.6c9.3-24.8 37-37.4 61.8-28.1s37.4 37 28.1 61.8zM576 338.3v83.4c0 14.7-10 27.5-24.2 31L335.5 506.8c-10.2 2.6-20.9 2.6-31 0L88.2 452.8C74 449.2 64 436.4 64 421.7V338.3l127.6 36.5c27.8 8 57.6-3.8 72.5-28.6L320 252.9l55.9 93.2c14.9 24.8 44.6 36.6 72.5 28.6L576 338.3zM58.9 168.8c3-6.1 9.6-9.6 16.3-8.7L320 190.7l244.8-30.6c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 344c-13.9 4-28.8-1.9-36.2-14.3L320 190.7l-83.4 139c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 297.3c-19.3-5.5-28.8-27.2-19.8-45.1l41.7-83.4z"]
};
var faBoxFull = faBoxOpenFull;
var faFile = {
  prefix: 'fas',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"]
};
var faGreaterThan = {
  prefix: 'fas',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"]
};
var faQuotes = {
  prefix: 'fas',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M88 0C39.4 0 0 39.4 0 88v56 24 24c0 26.5 21.5 48 48 48H96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H64V88c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32s-14.3-32-32-32H88zM264 0c-48.6 0-88 39.4-88 88v56 24 24c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H240V88c0-13.3 10.7-24 24-24h8c17.7 0 32-14.3 32-32s-14.3-32-32-32h-8zM576 424V368 344 320c0-26.5-21.5-48-48-48H480c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8c48.6 0 88-39.4 88-88zM312 512c48.6 0 88-39.4 88-88V368 344 320c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h32v8c0 13.3-10.7 24-24 24h-8c-17.7 0-32 14.3-32 32s14.3 32 32 32h8z"]
};
var faPretzel = {
  prefix: 'fas',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M138.6 32C62.1 32 0 94.1 0 170.6C0 253.3 40.9 326.5 103.7 371L71.3 417C58.6 435 62.9 460 81 472.7s43 8.4 55.7-9.7l40-56.8c21.8 6.4 44.9 9.8 68.7 9.8H256h10.6c23.9 0 46.9-3.4 68.7-9.8l40 56.8c12.7 18.1 37.7 22.4 55.7 9.7s22.4-37.7 9.7-55.7l-32.4-46C471.1 326.5 512 253.3 512 170.6C512 94.1 449.9 32 373.4 32H364c-42.6 0-81 18-108 46.8C229 50 190.6 32 148 32h-9.4zM216 180v7.4c0 15.5-4.8 30.7-13.7 43.4l-52.5 74.7C107.5 275.6 80 226.3 80 170.6c0-32.4 26.2-58.6 58.6-58.6H148c37.6 0 68 30.4 68 68zm40 113.5L285.2 335c-6.1 .7-12.3 1-18.6 1H256 245.4c-6.3 0-12.5-.3-18.6-1L256 293.5zm53.7-62.6C300.8 218.2 296 203 296 187.4V180c0-37.6 30.4-68 68-68h9.4c32.4 0 58.6 26.2 58.6 58.6c0 55.7-27.5 105-69.7 134.9l-52.5-74.7z"]
};
var faPersonSwimming = {
  prefix: 'fas',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faSwimmer = faPersonSwimming;
var faArrowDown = {
  prefix: 'fas',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
};
var faUserRobotXmarks = {
  prefix: 'fas',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M224 0c8.8 0 16 7.2 16 16V64h64c35.3 0 64 28.7 64 64V256c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h64V16c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm400-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352H352c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32H352V448c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32-14.3-32-32V448c0-53 43-96 96-96zm80 112v48H144V464c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16v48H208V464c0-8.8 7.2-16 16-16zm80 16v48H272V464c0-8.8 7.2-16 16-16s16 7.2 16 16zM119.5 119.5c-4.7 4.7-4.7 12.3 0 17L143 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L160 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L177 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L160 143l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0zm145 0c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L271 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L288 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L305 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L288 143l-23.5-23.5z"]
};
var faMessageQuote = {
  prefix: 'fas',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm160 48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192 168 144c0-17.7-14.3-32-32-32H160zm224 80V168 144c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h32v7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71V192z"]
};
var faCommentAltQuote = faMessageQuote;
var faCandyCorn = {
  prefix: 'fas',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", "M440.6 256c9.8 25.6 19.6 49 28.7 67.2c3.3 6.7 6.2 12.4 9.3 17.7c.5 .8 1 1.7 1.4 2.4c.5-.8 1-1.6 1.4-2.4c3.1-5.3 6-11 9.3-17.7c9-18.2 18.9-41.5 28.7-67.2H440.6zM480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 17.4-5.3 43.8-12.3 71.4c-4.4-1-9.3-2.1-14.5-3.1c-30.9-6.2-76-12.3-133.1-12.3s-102.2 6.1-133.1 12.3c-5.3 1.1-10.1 2.1-14.5 3.1c-7-27.6-12.3-54-12.3-71.4c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM370.3 250.4c-11-30.8-21.3-62.9-29.6-92.1c3.8-.9 8-1.8 12.4-2.7c29.1-5.8 72-11.7 126.9-11.7s97.8 5.9 126.9 11.7c4.5 .9 8.6 1.8 12.4 2.7c-8.3 29.2-18.6 61.3-29.6 92.1c-13.2 37.2-27.9 73.6-41.6 101.3c-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3zM83 211.1c30.4-30.4 65.3-59.4 103.9-79c15-7.5 33.1-4.6 45 7.3c12 12 26.6 33.9 40.7 57.7c-3.8 2.3-7.8 5-12.2 7.9c-25.6 17.1-60.9 43.9-100.3 83.3S94 363 76.9 388.6c-2.9 4.3-5.5 8.4-7.9 12.2C45.2 386.6 23.3 372 11.3 360C-.6 348.1-3.3 329.6 4.2 314.6C23.9 276.2 52.6 241.5 83 211.1zm97 248.2c-28.8-13.7-58-28.7-83.9-43c2-3.2 4.3-6.7 6.7-10.4c16-24 41.6-57.7 79.4-95.5S253.7 247 277.7 231c3.7-2.5 7.2-4.7 10.4-6.7c14.4 25.9 29.4 55.1 43.1 83.9c16.5 34.8 31.5 70 41.1 98.5c9.3 27.9 21.7 67-2.6 91.2s-63.4 11.9-91.2 2.6c-28.5-9.6-63.7-24.6-98.5-41.1zm52.3-44.6c24.4 11 47.3 20.2 66.1 26.5c6.9 2.3 12.8 4.2 18.6 5.8c.9 .2 1.8 .5 2.7 .7c-.2-.9-.4-1.7-.7-2.7c-1.5-5.8-3.4-11.7-5.8-18.6c-6.3-18.8-15.6-41.7-26.5-66.1l-54.4 54.4z"]
};
var faFolderMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faFolderSearch = faFolderMagnifyingGlass;
var faNotebook = {
  prefix: 'fas',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M64 48v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v80H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56c0 26.5 21.5 48 48 48h80V0H112C85.5 0 64 21.5 64 48zM432 0H224V512H432c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48z"]
};
var faDroplet = {
  prefix: 'fas',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"]
};
var faTint = faDroplet;
var faBullseyePointer = {
  prefix: 'fas',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M256 448c106 0 192-86 192-192s-86-192-192-192S64 150 64 256c0 3.9 .1 7.8 .4 11.7L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l18.4-62.6c3.9 .2 7.8 .4 11.7 .4zm2.3-48l19.7-67c33.5-9.6 58-40.4 58-76.9c0-44.2-35.8-80-80-80c-36.5 0-67.4 24.5-76.9 58L112 253.7C113.2 175.2 177.2 112 256 112c79.5 0 144 64.5 144 144c0 78.8-63.2 142.8-141.7 144zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z"]
};
var faEraser = {
  prefix: 'fas',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"]
};
var faHexagonImage = {
  prefix: 'fas',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36H344.3c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36H167.7c-25.7 0-49.5 13.7-62.4 36L17.1 220zm141.2 59.8c4.5-4.9 10.8-7.7 17.4-7.8s13 2.6 17.6 7.4L232.2 320l71.6-86.2c4.6-5.5 11.3-8.7 18.5-8.7s13.9 3.2 18.5 8.7l72.6 87.4-55.2 95.7c-2.9 5-8.1 8-13.9 8l-176.6 0c-5.7 0-11-3-13.9-8l-46.8-81 51.2-56.1zM192 120a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
var faEarthAmericas = {
  prefix: 'fas',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faCrateApple = {
  prefix: 'fas',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M160 54.9C160 24.6 184.6 0 214.9 0c5 0 9.1 4.1 9.1 9.1C224 39.4 199.4 64 169.1 64c-5 0-9.1-4.1-9.1-9.1zM32 171.4C32 127.8 52.4 80 96 80c15.6 0 34.1 5.9 47.2 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6H33.2c-.8-6.7-1.2-13.5-1.2-20.6zM319 192c.7-6.7 1-13.6 1-20.6c0-26.1-6-55.1-20.3-78.6c-2.7-4.4-5.7-8.7-9-12.7c15 .6 32.2 6.1 44.6 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6H319zM406.9 0c5 0 9.1 4.1 9.1 9.1C416 39.4 391.4 64 361.1 64c-5 0-9.1-4.1-9.1-9.1C352 24.6 376.6 0 406.9 0zM0 272c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48v80H0V272zM0 384H512v80c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V384zm80-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faAppleCrate = faCrateApple;
var faPersonBurst = {
  prefix: 'fas',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"]
};
var faGameBoard = {
  prefix: 'fas',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0v80h80V96H144zm0 160V176H64v80h80zm80 0H144v80H64v80h80V336h80v80h80V336h80V256H304V176h80V96H304v80H224v80zm0 0h80v80H224V256z"]
};
var faHatChef = {
  prefix: 'fas',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M153.6 51.2C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2c16-12.1 36-19.2 57.6-19.2c7.1 0 14.4 .8 21.6 2.5C482 44.7 512 84.3 512 128c0 7.1-.8 14.4-2.5 21.6C496 224 448 320 448 320H373.6l26.2-157.4c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2L341.1 320H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16V320H170.9L143.8 157.4c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4L138.4 320H64s-48-96-61.5-170.4C.8 142.4 0 135.1 0 128c0-43.7 30-83.3 74.4-93.5C81.6 32.8 88.9 32 96 32c21.6 0 41.6 7.1 57.6 19.2zM448 448c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V352H448v96z"]
};
var faHandBackPointRight = {
  prefix: 'fas',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 168c0-22.1-17.9-40-40-40l-200 0-7 0-73 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l55.7 0c-1.4-2-3-3.9-4.5-5.8L227.2 71C215 56.4 197 48 178 48L140 48c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l64 0 32 0c26.5 0 48-21.5 48-48c0-12.4-4.7-23.6-12.3-32.1C284.5 366 304 345.3 304 320c0-12.4-4.7-23.6-12.3-32.1C316.5 286 336 265.3 336 240c0-12.3-4.6-23.5-12.2-32L472 208c22.1 0 40-17.9 40-40z"]
};
var faDove = {
  prefix: 'fas',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faSnowflakeDroplets = {
  prefix: 'fas',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M320 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L383.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 21.5 12.6-29.3 57-22.7-13.2 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L352 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L145 395.1l-29.3-57 21.5-12.6-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L256.5 256l-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8c-15.3-8.9-20.4-28.5-11.5-43.8s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L288 200.3V129.9L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32zM519.1 418.1l47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5c0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z"]
};
var faBatteryEmpty = {
  prefix: 'fas',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", "M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"]
};
var faBattery0 = faBatteryEmpty;
var faGrid4 = {
  prefix: 'fas',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M0 48c0-8.8 7.2-16 16-16H73.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V48zM0 167.5c0-8.8 7.2-16 16-16H73.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V167.5zM16 270.9H73.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V286.9c0-8.8 7.2-16 16-16zM0 406.4c0-8.8 7.2-16 16-16H73.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V406.4zM119.5 48c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V48zm0 119.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V167.5zm16 103.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V286.9c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H135.5c-8.8 0-16-7.2-16-16V406.4zM254.9 32h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm0 119.5h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V167.5c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16h57.6c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V286.9zm16 103.5h57.6c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H254.9c-8.8 0-16-7.2-16-16V406.4c0-8.8 7.2-16 16-16zM358.4 48c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V48zm0 119.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V167.5zm16 103.5H432c8.8 0 16 7.2 16 16v57.6c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V286.9c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16V464c0 8.8-7.2 16-16 16H374.4c-8.8 0-16-7.2-16-16V406.4z"]
};
var faSocks = {
  prefix: 'fas',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"]
};
var faFaceSunglasses = {
  prefix: 'fas',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", "M256 512c141.4 0 256-114.6 256-256c0-16.6-1.6-32.8-4.6-48.5l2.6-15.7c7.9-47.6-20.5-91.8-63.3-106.6C399.8 32.9 331.8 0 256 0S112.2 32.9 65.3 85.2C22.4 100-6 144.2 2 191.8l2.6 15.7C1.6 223.2 0 239.4 0 256C0 397.4 114.6 512 256 512zM183.3 272H104.7c-23.5 0-43.5-17-47.3-40.1l-8-48C44.4 154.6 67 128 96.7 128h94.7c14.4 0 27.1 6.2 35.8 16h57.8c8.7-9.8 21.4-16 35.8-16h94.7c29.7 0 52.2 26.6 47.3 55.9l-8 48C450.8 255 430.8 272 407.3 272H328.7c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9H239.3c0 2.6-.2 5.2-.7 7.9l-8 48C226.8 255 206.8 272 183.3 272zm-19.2 69.5C182 362.2 212.6 384 256 384s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 388.1 311.1 416 256 416s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6z"]
};
var faInbox = {
  prefix: 'fas',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]
};
var faSquare0 = {
  prefix: 'fas',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-48 96v64c0 26.5 21.5 48 48 48s48-21.5 48-48V224c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
var faSection = {
  prefix: 'fas',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"]
};
var faSquareThisWayUp = {
  prefix: 'fas',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM80 384H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM265.4 192c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L306.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H352V304c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V192H265.4zm-192 0c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L114.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4H160V304c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V192H73.4z"]
};
var faBoxUp = faSquareThisWayUp;
var faGaugeHigh = {
  prefix: 'fas',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faSquareAmpersand = {
  prefix: 'fas',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM184 191.6c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2H199.6c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4H178.5c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6h19.2c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5h32.2c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"]
};
var faEnvelopeOpenText = {
  prefix: 'fas',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faLampDesk = {
  prefix: 'fas',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M192 65.9C192 29.5 221.5 0 257.9 0c17.5 0 34.3 6.9 46.6 19.3L349.3 64H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V173.3l-92.6 92.6L209 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H184.7c-.5 0-.9 0-1.4 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H143L97 263.8c-2.7-10.9 .5-22.4 8.4-30.4L218.7 120l-7.4-7.4C198.9 100.2 192 83.4 192 65.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6c0 26.5-21.5 48-48 48z"]
};
var faHospital = {
  prefix: 'fas',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faPollPeople = {
  prefix: 'fas',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zm448 80H480V96h96v32zM272 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zM576 416H352V384H576v32zM272 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H272zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H64z"]
};
var faWhiskeyGlassIce = {
  prefix: 'fas',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM417 283.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L356.3 417c-9.6 9.6-22.7 15-36.3 15s-26.7-5.4-36.3-15l-49-49H160c-35.3 0-64-28.7-64-64V281.1L69 96H443L415.8 282.5l1.2 1.2zM160 208c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h50.6c-1.7-5.1-2.6-10.5-2.6-16c0-13.6 5.4-26.7 15-36.3l33-33V240c0-17.7-14.3-32-32-32H160zm85.7 98.3C242 310 240 314.9 240 320s2 10 5.7 13.7l60.7 60.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l60.7-60.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-60.7-60.7C330 242 325.1 240 320 240s-10 2-13.7 5.7l-60.7 60.7z"]
};
var faGlassWhiskeyRocks = faWhiskeyGlassIce;
var faWineBottle = {
  prefix: 'fas',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"]
};
var faChessRook = {
  prefix: 'fas',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"]
};
var faUserBountyHunter = {
  prefix: 'fas',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72H323zm5.5 36.4L248 171.5v98.4l9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0l-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9V171.5l-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2L383 256.5c1.3 20-12.4 37.9-32.1 41.8L250.1 318.4c-5.2 1-10.4 1.6-15.7 1.6H213.5c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6c-1-3.4-1.6-7-1.6-10.7V16C64 7.2 71.2 0 80 0H96c8.8 0 16 7.2 16 16s-7.2 16-16 16V70zm38.4 282H313.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352zm37.1 103.4c-3.7 2.8-1.7 8.6 2.9 8.6h99.2c4.6 0 6.6-5.9 2.9-8.6l-47.7-35.8c-2.8-2.1-6.8-2.1-9.6 0l-47.7 35.8z"]
};
var faBarsStaggered = {
  prefix: 'fas',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faDiagramSankey = {
  prefix: 'fas',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M294.4 44.8c6-8.1 15.5-12.8 25.6-12.8H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H336L249.6 211.2c-6 8.1-15.5 12.8-25.6 12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H208L294.4 44.8zM141.9 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H216.5l57.6 96H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-11.2 0-21.7-5.9-27.4-15.5L141.9 320z"]
};
var faCloudHailMixed = {
  prefix: 'fas',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm232 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zM326.1 385.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCircleUpLeft = {
  prefix: 'fas',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 313.4V176c0-8.8 7.2-16 16-16H313.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L296 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C322 366 317.1 368 312 368s-10-2-13.7-5.7L232 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z"]
};
var faDharmachakra = {
  prefix: 'fas',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faObjectsAlignLeft = {
  prefix: 'fas',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24L48 24C48 10.7 37.3 0 24 0S0 10.7 0 24zM176 64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48L176 64zm0 224c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H176z"]
};
var faOilCanDrip = {
  prefix: 'fas',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 96c0 17.7-14.3 32-32 32H288v32h80.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48V346.7l-67.5-30C11.2 309 0 291.8 0 272.8V208c0-26.5 21.5-48 48-48H96h48 80V128H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32zM48 208v64.8l48 21.3V208H48zM592 448c-26.5 0-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z"]
};
var faFaceSmilingHands = {
  prefix: 'fas',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M411.1 495.3c-17-21.6-27.1-48.9-27.1-78.5V386c-18.1 8.4-39.4 14-64 14s-45.9-5.6-64-14v30.8c0 29.6-10.1 56.9-27.1 78.5c28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7zM320 0C183.1 0 71.3 107.5 64.3 242.6c16.8-5.8 36.2-2 49.6 11.4L161 301.1c9.4-13.7 25.1-22.7 43-22.7c28.7 0 52 23.3 52 52v19.2c16.8 10.6 38.1 18.4 64 18.4s47.2-7.7 64-18.4V330.4c0-28.7 23.3-52 52-52c17.9 0 33.6 9 43 22.7l47.1-47.1c13.4-13.4 32.8-17.2 49.6-11.4C568.7 107.5 456.9 0 320 0zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zM68.7 299.3L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2V384 330.4c0-11-9-20-20-20s-20 9-20 20v19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm502.6 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7V330.4c0-11-9-20-20-20s-20 9-20 20V384v32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3z"]
};
var faBroccoli = {
  prefix: 'fas',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M0 256c0 53 43 96 96 96H416c53 0 96-43 96-96c0-45.5-31.6-83.6-74.1-93.5c6.4-10 10.1-21.8 10.1-34.5c0-35.3-28.7-64-64-64c-12.7 0-24.6 3.7-34.5 10.1C339.6 31.6 301.5 0 256 0s-83.6 31.6-93.5 74.1C152.6 67.7 140.7 64 128 64c-35.3 0-64 28.7-64 64c0 12.7 3.7 24.6 10.1 34.5C31.6 172.4 0 210.5 0 256zM192.2 490.3c5 12.8 17.1 21.7 30.9 21.7h65.9c13.8 0 25.9-8.9 30.9-21.7c17.6-45.3 39.6-82.1 56.1-106.3H280l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384H136.1c16.5 24.2 38.5 60.9 56.1 106.3z"]
};
var faRouteInterstate = {
  prefix: 'fas',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M85.3 192h341c-.8 44.3-7.9 81.8-21.9 114.4c-23.4 54.1-68.5 99.1-149 138.5c-81.5-36.2-126.1-80.9-149-135.4c-14-33.3-20.6-72-21-117.4zM276.9 7.3c-12.8-7.8-29-7.8-41.8 0c-27.5 16.8-50.2 26-73.4 30c-23.3 4-49.2 3.2-83.7-3.2C55.9 30 34.4 45 31.1 67.7C16 170.4 15.9 259.5 47.3 334.2c32.1 76.4 94.6 132.5 193 173.9c10.4 4.4 22.3 4.1 32.5-.6c95.7-44.8 157.8-100.7 190.3-175.7c32-73.9 32.9-161.2 17.8-264.1C477.6 45.1 456.1 30 434 34.1c-34.4 6.3-60.3 7.2-83.7 3.2c-23.2-4-45.9-13.2-73.4-30z"]
};
var faEarMuffs = {
  prefix: 'fas',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", "M320 64c-78.2 0-143.3 56.1-157.2 130.2c-6-1.4-12.3-2.2-18.8-2.2c-17.7 0-34.1 5.8-47.4 15.6C105 91.5 201.8 0 320 0S535 91.5 543.4 207.6C530.1 197.8 513.7 192 496 192c-6.5 0-12.7 .8-18.8 2.2C463.3 120.1 398.2 64 320 64zM179.8 304c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48c-22.1 0-40.8-15-46.3-35.4C92.2 478.8 86.2 480 80 480c-26.5 0-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3C33.2 316.2 32 310.2 32 304c0-26.5 21.5-48 48-48c6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32zm280.4 0c-7.6-8.5-12.2-19.7-12.2-32c0-26.5 21.5-48 48-48c22.1 0 40.8 15 46.3 35.4c5.5-2.2 11.4-3.4 17.7-3.4c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7c0 26.5-21.5 48-48 48c-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32z"]
};
var faHotdog = {
  prefix: 'fas',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"]
};
var faTransporterEmpty = {
  prefix: 'fas',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", "M296 512h88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h88 80z"]
};
var faPersonWalkingWithCane = {
  prefix: 'fas',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"]
};
var faBlind = faPersonWalkingWithCane;
var faAngle90 = {
  prefix: 'fas',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V64zM96 97.6v48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384h48.3c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z"]
};
var faRectangleTerminal = {
  prefix: 'fas',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm102.3 55.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faKite = {
  prefix: 'fas',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M344 0c-14.9 0-27.8 10.3-31.2 24.8l-80 344c-.4 1.7-.7 3.5-.8 5.2l-85.4 85.4c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6V359.8l-24-12-24 12v88.6c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L266 407.9c1.8-.1 3.5-.4 5.2-.8l344-80c14.5-3.4 24.8-16.3 24.8-31.2V32c0-17.7-14.3-32-32-32H344zM24 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h8c22.1 0 40 17.9 40 40v68L18.7 257.4c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9v70.1C0 346.2 5.8 352 12.9 352c2 0 4-.5 5.8-1.4L72 324v0l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4l.5 0c3.5 .1 7 .7 10.4 1.9c1.2 .4 2.3 .9 3.4 1.5l0 0L120 324l53.3 26.6c1.8 .9 3.8 1.4 5.8 1.4c7.1 0 12.9-5.8 12.9-12.9V268.9c0-7.1-5.8-12.9-12.9-12.9c-2 0-4 .5-5.8 1.4L120 284V216c0-48.6-39.4-88-88-88H24zM427.3 84.7L480 137.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 160l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 182.6 363.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 160l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
var faDrum = {
  prefix: 'fas',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"]
};
var faScrubber = {
  prefix: 'fas',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faIceCream = {
  prefix: 'fas',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"]
};
var faHeartCircleBolt = {
  prefix: 'fas',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
var faFishBones = {
  prefix: 'fas',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M87.1 148.2c5.6 4.6 8.9 11.4 8.9 18.7V208h0v24h40V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h48V160c0-13.3 10.7-24 24-24s24 10.7 24 24v72h40V130.9c0-16.9 17.1-28.4 31.8-20c16 9.1 30.6 19.7 43.7 30.7c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8c-13.1 11-27.7 21.6-43.7 30.7c-14.7 8.4-31.8-3.1-31.8-20V280H376v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H280v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H184v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H96v24h0v41.1c0 7.2-3.3 14.1-8.9 18.7l-48 38.9c-8.8 7.1-21.3 7.1-30.1 .1s-11.5-19.2-6.6-29.3L54.9 266.6c3.3-6.7 3.3-14.5 0-21.2L2.5 138.6c-5-10.1-2.2-22.3 6.6-29.3s21.3-7 30.1 .1l48 38.9z"]
};
var faDeerRudolph = {
  prefix: 'fas',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 30.9 25.1 56 56 56h8 8 24l-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18h38l-9.6 32H196.3c-.8 0-1.7 0-2.5 0c-.6 0-1.2 0-1.7 0H128 113.9h-7.9C51.7 176 6.6 217.8 2.4 272L.1 302.2c-1 13.2 8.9 24.8 22.1 25.8c13 1 24.4-8.6 25.7-21.5c2.4 3.3 5.2 6.5 8.1 9.5c9 9 9 23.5 2.4 34.4c-17.4 28.6-21.5 63.9-10 96.3l15.5 44C68.4 503.4 80.5 512 94.1 512H128c22.1 0 37.5-21.8 30.2-42.6l-19.3-54.7c-2.2-6.2-.6-13 4-17.7l10.6-10.6c12.1-12.1 19.8-27.9 21.9-44.8c21 16.5 47.5 26.4 76.3 26.4H288V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V368 304l26.7-80H416h50.7c25 0 45.3-20.3 45.3-45.3c0-1.2 0-2.4-.1-3.6c2.6 .5 5.4 .8 8.1 .8c22.1 0 40-17.9 40-40s-17.9-40-40-40c-19.6 0-35.9 14.1-39.3 32.7L443.4 91.4c-.6-.6-1.1-1.1-1.7-1.6C459.7 80.4 472 61.7 472 40V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24H377.3 346.6c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zM384 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faFax = {
  prefix: 'fas',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faParagraph = {
  prefix: 'fas',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
};
var faHeadSideHeart = {
  prefix: 'fas',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm112-35c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faSquareE = {
  prefix: 'fas',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 96H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56h88c13.3 0 24 10.7 24 24s-10.7 24-24 24H176v56H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V256 152c0-13.3 10.7-24 24-24z"]
};
var faMeterFire = {
  prefix: 'fas',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M256 512c33.6 0 65.7-6.5 95.1-18.3c-39-35.9-63.1-87.5-63.1-143.7c0-35.2 16.3-73.6 37.2-107.4c4.4-7.1 9.1-14.2 14.1-21.3C327.9 216.5 320 205.2 320 192V160c0-17.7 14.3-32 32-32s32 14.3 32 32v7.4c9-9.4 18.5-18.6 28.5-27.5C430.2 124 457.3 124 475 140c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm165.5 3.6c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8C332.7 291.3 320 325.6 320 352c0 87.8 70.3 159.8 160 159.8c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 432.9c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faCloudHail = {
  prefix: 'fas',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm0 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faCheckToSlot = {
  prefix: 'fas',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"]
};
var faVoteYea = faCheckToSlot;
var faMoneyFromBracket = {
  prefix: 'fas',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", "M64 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 43 43 0 96 0H544c53 0 96 43 96 96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7-14.3-32-32-32H96C78.3 64 64 78.3 64 96zm64 0l384 0 0 352c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64l0-352zM256 448c0-35.3-28.7-64-64-64v64h64zm192-64c-35.3 0-64 28.7-64 64h64l0-64zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z"]
};
var faStarHalf = {
  prefix: 'fas',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"]
};
var faCarBus = {
  prefix: 'fas',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", "M32 416H48v32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V416h64V352c0-32.8 16.5-61.8 41.6-79.1L249.9 224H208V96h88c13.3 0 24 10.7 24 24v16.4c13.2-5.4 27.7-8.4 42.6-8.4H384V74.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0H176.9C123.7 0 71.2 12.4 23.7 36.2C9.2 43.4 0 58.2 0 74.5V384c0 17.7 14.3 32 32 32zM88 96h88V224H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm266.6-72H501.4c6.9 0 13 4.4 15.2 10.9L534.3 288H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352v96h0v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H560v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32l0-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faSpeaker = {
  prefix: 'fas',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM304 336A112 112 0 1 0 80 336a112 112 0 1 0 224 0zM192 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faTimer = {
  prefix: 'fas',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M256 0c-17.7 0-32 14.3-32 32V96c0 17.7 14.3 32 32 32s32-14.3 32-32V66.7C378.8 81.9 448 160.9 448 256c0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1c12.6-12.4 12.8-32.6 .5-45.3S89.5 60.8 76.8 73.1C29.5 119.6 0 184.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM193 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z"]
};
var faBoxesStacked = {
  prefix: 'fas',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faGrillHot = {
  prefix: 'fas',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M120 0c13.3 0 24 10.7 24 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V24c0-13.3 10.7-24 24-24zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424H306.5l-18.3-42.7C277.7 383.1 267 384 256 384H192c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faBallotCheck = {
  prefix: 'fas',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112zm0 256c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368zm144 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 128c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 112H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-52.7-27.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 249.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faLink = {
  prefix: 'fas',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"]
};
var faChain = faLink;
var faEarListen = {
  prefix: 'fas',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
var faAssistiveListeningSystems = faEarListen;
var faFileMinus = {
  prefix: 'fas',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM120 304H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faTreeCity = {
  prefix: 'fas',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"]
};
var faPlay = {
  prefix: 'fas',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"]
};
var faFont = {
  prefix: 'fas',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"]
};
var faCupTogo = {
  prefix: 'fas',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M55.2 17.7C60.6 6.8 71.7 0 83.8 0H364.2c12.1 0 23.2 6.8 28.6 17.7L416 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96S14.3 64 32 64L55.2 17.7zM74.7 453.8L48 160H400L373.3 453.8c-3 33-30.6 58.2-63.7 58.2H138.4c-33.1 0-60.7-25.2-63.7-58.2zM323.8 290.9c1.7-18.7-13.1-34.9-31.9-34.9H156c-18.8 0-33.6 16.2-31.9 34.9l8.7 96c1.5 16.5 15.3 29.1 31.9 29.1H283.2c16.6 0 30.4-12.6 31.9-29.1l8.7-96z"]
};
var faCoffeeTogo = faCupTogo;
var faSquareDownLeft = {
  prefix: 'fas',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm64-281.4V336c0 8.8 7.2 16 16 16H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C290 146 285.1 144 280 144s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z"]
};
var faBurgerLettuce = {
  prefix: 'fas',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M32 194.9C32 211 45 224 61.1 224H450.9c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM128 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400v16c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V400c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm48-48c24.6 0 44.2-11.8 56.2-19c.9-.5 1.7-1 2.5-1.5c13.7-8.1 20.8-11.5 29.3-11.5c7.7 0 12.3 2.5 25.4 10.9l.2 .1c13 8.3 32.6 21 62.4 21c29.7 0 48.6-12.6 61-20.9l.8-.5c11.6-7.7 16.6-10.6 26.2-10.6c10.5 0 17.9 3.7 30.2 11.3c.9 .5 1.8 1.1 2.8 1.7c11.4 7.1 30.3 19 55 19c21.5 0 38.4-5.4 50.3-11.4c5.9-3 10.5-6 13.9-8.5c1.7-1.3 3.1-2.4 4.1-3.3c.5-.5 1-.9 1.4-1.2l.5-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.3-12.3-32-12.5-44.5-.7l-.3 .2c-.6 .5-2 1.4-4.1 2.5c-4.1 2-11.2 4.6-21.7 4.6c-5.2 0-9.2-2-24.2-11.3C394.1 268.3 373.5 256 344 256c-29.7 0-48.6 12.6-61 20.9l-.8 .5C270.6 285.1 265.7 288 256 288c-10 0-16.1-3.2-28-10.9l-1.8-1.1c-11.9-7.7-30.8-20-58.3-20c-27.7 0-48.4 12.3-61.6 20.2l-.5 .3C90.7 285.6 85.6 288 80 288c-10.5 0-17.6-2.6-21.7-4.6c-2.1-1-3.5-2-4.1-2.5l-.3-.2c-12.5-11.8-32.3-11.6-44.5 .7c-12.5 12.5-12.5 32.8 0 45.3l22.4-22.4C9.4 326.6 9.4 326.6 9.4 326.6l0 0 0 0 .1 .1 .2 .2 .5 .5c.4 .4 .8 .8 1.4 1.2c1.1 .9 2.4 2.1 4.1 3.3c3.4 2.5 8 5.6 13.9 8.5C41.6 346.6 58.5 352 80 352z"]
};
var faRupiahSign = {
  prefix: 'fas',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"]
};
var faMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faSearch = faMagnifyingGlass;
var faTableTennisPaddleBall = {
  prefix: 'fas',
  iconName: 'table-tennis-paddle-ball',
  icon: [640, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faPersonDotsFromLine = {
  prefix: 'fas',
  iconName: 'person-dots-from-line',
  icon: [576, 512, ["diagnoses"], "f470", "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faDiagnoses = faPersonDotsFromLine;
var faChevronsDown = {
  prefix: 'fas',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M278.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 402.7 425.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192zm192-384l-192 192c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 210.7 425.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"]
};
var faChevronDoubleDown = faChevronsDown;
var faTrashCanArrowUp = {
  prefix: 'fas',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faSignalGood = {
  prefix: 'fas',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", "M320 192c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faSignal3 = faSignalGood;
var faLocationQuestion = {
  prefix: 'fas',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM105.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V218.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMapMarkerQuestion = faLocationQuestion;
var faFloppyDiskCircleXmark = {
  prefix: 'fas',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faFloppyDiskTimes = faFloppyDiskCircleXmark;
var faSaveCircleXmark = faFloppyDiskCircleXmark;
var faSaveTimes = faFloppyDiskCircleXmark;
var faNairaSign = {
  prefix: 'fas',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"]
};
var faPeach = {
  prefix: 'fas',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-11.4 0-22.6 1-33.5 2.8C120.5 67.2 112 46.6 112 24c0-13.3 10.7-24 24-24h24c53 0 96 43 96 96c0-53 43-96 96-96h24c13.3 0 24 10.7 24 24c0 22.6-8.5 43.2-22.5 58.8C366.6 81 355.4 80 344 80zM168 112c17.8 0 34.9 2.8 50.9 7.9c63 20 109.9 76.2 116.3 144.2c.8 8.8 7.9 16 16.8 16s16.1-7.2 15.4-16c-4.6-58.2-34.2-109.5-78-143c.8-.2 1.5-.5 2.3-.7c16.5-5.4 34-8.3 52.3-8.3c92.8 0 168 75.2 168 168c0 136.2-199.3 214.6-240.6 229.4c-5 1.8-10.1 2.6-15.4 2.6s-10.4-.8-15.4-2.6C199.3 494.6 0 416.2 0 280c0-92.8 75.2-168 168-168z"]
};
var faTaxiBus = {
  prefix: 'fas',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", "M48 416H32c-17.7 0-32-14.3-32-32V74.5c0-16.2 9.2-31 23.7-38.3C71.2 12.4 123.7 0 176.9 0h30.3c53.2 0 105.6 12.4 153.2 36.2C374.8 43.4 384 58.2 384 74.5V96c-21.9 0-40.4 14.7-46.2 34.8c-6.1 1.4-12.1 3.3-17.8 5.6V120c0-13.3-10.7-24-24-24H208V224h41.9l-16.3 48.9C208.5 290.2 192 319.2 192 352v64H128v32c0 17.7-14.3 32-32 32H80c-17.7 0-32-14.3-32-32V416zM64 120v80c0 13.3 10.7 24 24 24h88V96H88c-13.3 0-24 10.7-24 24zm56 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 152c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v8h5.4c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352l0 96v32c0 17.7-14.3 32-32 32H592c-17.7 0-32-14.3-32-32V448H304v32c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V448h0V352c0-25.4 14.8-47.3 36.1-57.6l26.6-79.7C297.6 182 328.2 160 362.6 160H368v-8zm-20.6 82.9L329.7 288H534.3l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H362.6c-6.9 0-13 4.4-15.2 10.9zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
var faBracketCurly = {
  prefix: 'fas',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M64 128c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32 14.3-32 32v37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9V384c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96-43-96-96V346.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3c6-6 9.4-14.1 9.4-22.6V128z"]
};
var faBracketCurlyLeft = faBracketCurly;
var faLobster = {
  prefix: 'fas',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64v64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240H192v16H143.1c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H192v16H122.4c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H192v16H175.1c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1H192l21.4 64.1c-29.8 1.8-53.4 26.5-53.4 56.8c0 3.9 3.2 7.1 7.1 7.1H344.9c3.9 0 7.1-3.2 7.1-7.1c0-30.2-23.6-55-53.4-56.8L320 384h16.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4H320V336h69.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H320V288h48.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H320V240h18.9c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5V72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9v64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192H314.2c-2.7-7.3-6.2-14-10.2-20.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7V138c-3.1-2.3-6.2-4.4-9-6.1c-4.3-2.6-9.7-2.6-13.9 0c-2.8 1.7-5.9 3.8-9 6.1V80.7c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v91.1c-4 6.2-7.5 13-10.2 20.2H173.1c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4V64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72V8.2z"]
};
var faCartFlatbedEmpty = {
  prefix: 'fas',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32z"]
};
var faDollyFlatbedEmpty = faCartFlatbedEmpty;
var faColon = {
  prefix: 'fas',
  iconName: 'colon',
  icon: [192, 512, [], "3a", "M96 192A64 64 0 1 0 96 64a64 64 0 1 0 0 128zm0 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faCartArrowDown = {
  prefix: 'fas',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faWand = {
  prefix: 'fas',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1H144c-8.8 0-16 7.2-16 16v27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8c9.5 0 18.5-4 24.8-11.1L372.3 197.3c3-3.4 7.4-5.3 11.9-5.3H400c8.8 0 16-7.2 16-16V154.6c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z"]
};
var faWalkieTalkie = {
  prefix: 'fas',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faFilePen = {
  prefix: 'fas',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faFileEdit = faFilePen;
var faReceipt = {
  prefix: 'fas',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
};
var faTablePicnic = {
  prefix: 'fas',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M319.3 64H192.7c-.5 0-1 0-1.5 0H96C78.3 64 64 78.3 64 96s14.3 32 32 32h48.7l-38.4 96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H80.7h68.9H362.3h68.9H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H405.7l-38.4-96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320.7c-.5 0-1 0-1.5 0zM444.1 320H375.1l43.2 107.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L444.1 320zm-307.2 0H67.9L34.3 404.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8L136.9 320zm38.4-96l38.4-96h84.7l38.4 96H175.3z"]
};
var faSquarePen = {
  prefix: 'fas',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faCircleMicrophoneLines = {
  prefix: 'fas',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96c-26.5 0-48 21.5-48 48V256c0 26.5 21.5 48 48 48s48-21.5 48-48V240H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c0-26.5-21.5-48-48-48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16V383c63.1-7.9 112-61.7 112-127V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96V240z"]
};
var faMicrophoneCircleAlt = faCircleMicrophoneLines;
var faDisplaySlash = {
  prefix: 'fas',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9V64c0-35.3-28.7-64-64-64H96C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zM113.9 64H544V352H481.4L113.9 64zM32 352c0 35.3 28.7 64 64 64H272l-10.7 32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32-14.3 32-32c0-2.1-.2-4.1-.6-6.1L446.6 448H378.7L368 416h38l-81.2-64H96V171.8L32 121.4V352z"]
};
var faDesktopSlash = faDisplaySlash;
var faSuitcaseRolling = {
  prefix: 'fas',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faPersonCircleExclamation = {
  prefix: 'fas',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faTransporter2 = {
  prefix: 'fas',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", "M56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48s2.7 7.6 6.6 8.7L32 64l7.3 25.4C40.4 93.3 43.9 96 48 96s7.6-2.7 8.7-6.6L64 64l25.4-7.3C93.3 55.6 96 52.1 96 48s-2.7-7.6-6.6-8.7L64 32 56.7 6.6zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512h88 80 88c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32zM399.4 224l-48.1-60c-18.2-22.7-45.8-36-74.9-36H235.7c-29.1 0-56.7 13.2-74.9 36l-48.1 60H399.4zM480 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 352zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]
};
var faHandsHoldingDiamond = {
  prefix: 'fas',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M297.4 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zM80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
var faHandReceiving = faHandsHoldingDiamond;
var faMoneyBillSimpleWave = {
  prefix: 'fas',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
};
var faChevronDown = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
};
var faBatteryFull = {
  prefix: 'fas',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faBellPlus = {
  prefix: 'fas',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM224 152c13.3 0 24 10.7 24 24v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V264H160c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V176c0-13.3 10.7-24 24-24z"]
};
var faBookArrowRight = {
  prefix: 'fas',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V232H558.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H448V32c0-17.7-14.3-32-32-32H384 96zM448 184v48H248c-13.3 0-24-10.7-24-24s10.7-24 24-24H448zM96 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faHospitals = {
  prefix: 'fas',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M304 0c-26.5 0-48 21.5-48 48V64c35.3 0 64 28.7 64 64V480c0 11.7-3.1 22.6-8.6 32H528c26.5 0 48-21.5 48-48V384H464c-8.8 0-16-7.2-16-16s7.2-16 16-16H576V288H464c-8.8 0-16-7.2-16-16s7.2-16 16-16H576V48c0-26.5-21.5-48-48-48H304zM408 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H456v24c0 8.8-7.2 16-16 16H424c-8.8 0-16-7.2-16-16V168H384c-8.8 0-16-7.2-16-16V136c0-8.8 7.2-16 16-16h24V96zM0 144V384H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v48c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H48C21.5 96 0 117.5 0 144zm120 48c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H168v24c0 8.8-7.2 16-16 16H136c-8.8 0-16-7.2-16-16V264H96c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16h24V192z"]
};
var faClub = {
  prefix: 'fas',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M380 160.1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1c-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V448H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V372.7c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1z"]
};
var faSkullCrossbones = {
  prefix: 'fas',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"]
};
var faDropletDegree = {
  prefix: 'fas',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM464 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
var faDewpoint = faDropletDegree;
var faCodeCompare = {
  prefix: 'fas',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
var faListUl = {
  prefix: 'fas',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faListDots = faListUl;
var faHandHoldingMagic = {
  prefix: 'fas',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M192 80c0 8.8 7.2 16 16 16h80c17.7 0 32 14.3 32 32s-14.3 32-32 32H208c-44.2 0-80-35.8-80-80s35.8-80 80-80H320c70.7 0 128 57.3 128 128s-57.3 128-128 128H288c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32h64c35.3 0 64-28.7 64-64s-28.7-64-64-64H208c-8.8 0-16 7.2-16 16zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faWatermelonSlice = {
  prefix: 'fas',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zm22.3-22.3c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4zm245.4-220c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-168 72c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faCircleEllipsis = {
  prefix: 'fas',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSchoolLock = {
  prefix: 'fas',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"]
};
var faTowerCell = {
  prefix: 'fas',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"]
};
var faSdCards = {
  prefix: 'fas',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M384 0H237.3C220.3 0 204 6.7 192 18.7L114.7 96c-12 12-18.7 28.3-18.7 45.3V352c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM280 64c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm80 0c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V376c0 75.1 60.9 136 136 136H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faJugBottle = {
  prefix: 'fas',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", "M120 0C106.7 0 96 10.7 96 24V48H88C74.7 48 64 58.7 64 72s10.7 24 24 24H232c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V24c0-13.3-10.7-24-24-24H120zm8 128C57.3 128 0 185.3 0 256V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm160 96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zM472 64c-13.3 0-24 10.7-24 24v40H576V88c0-13.3-10.7-24-24-24H472zM416.4 392.4c-.1 .1-.2 .1-.4 .2V448c0 16.9-4.3 32.7-12 46.5c11.5 10.9 27 17.5 44 17.5H576c35.3 0 64-28.7 64-64c0-24.1-13.3-45.1-33-56c19.7-10.9 33-31.9 33-56c0-23.5-12.6-44-31.5-55.1c18.7-10.1 31.5-29.9 31.5-52.7c0-23.2-13.4-44.3-34.4-54.2l-13.2-6.2c-11-5.1-23-7.8-35.1-7.8H466.7c-12.1 0-24.1 2.7-35.1 7.8L418.4 174c-6.9 3.2-13 7.7-18 13c10 20.9 15.6 44.3 15.6 69V391.4c.3 .2 .7 .4 1 .6c-.2 .1-.4 .2-.6 .4z"]
};
var faDownLong = {
  prefix: 'fas',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"]
};
var faLongArrowAltDown = faDownLong;
var faEnvelopes = {
  prefix: 'fas',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M316.7 249.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4l220-163C570.8 55.7 544.2 32 512 32H160c-32.2 0-58.8 23.7-63.3 54.7l220 163zm57.7 25.7C363.3 283.6 349.8 288 336 288s-27.3-4.4-38.4-12.7L96 126V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V126L374.4 275.3zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"]
};
var faPhoneOffice = {
  prefix: 'fas',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", "M128 0C110.3 0 96 14.3 96 32V384c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H128zM64 32C28.7 32 0 60.7 0 96V448c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H256V384c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V32zm256 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128zm32 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM480 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faRankingStar = {
  prefix: 'fas',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"]
};
var faChessKing = {
  prefix: 'fas',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"]
};
var faNfcPen = {
  prefix: 'fas',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V235.6l-64 64V144c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V144c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V331.6L299.6 384H112c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-26.5 0-48 21.5-48 48V368c0 26.5 21.5 48 48 48H275.1c-1 2.6-1.9 5.3-2.6 8.1l-14 55.9H64c-35.3 0-64-28.7-64-64V96zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faPersonHarassing = {
  prefix: 'fas',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"]
};
var faHatWinter = {
  prefix: 'fas',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M279.9 22.2C279 9.8 268.7 0 256 0s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C326.2 103 336 92.7 336 80s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM216.4 175.6c-14.2 0-28.4-5.4-39.3-16.1c-62.7 27.1-98.6 85.4-118.9 139.6c4.2 1.6 8.9 1.4 13-.6l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.1 2 8.8 2.2 13 .6c-20.3-54.2-56.2-112.5-118.9-139.6c-10.9 10.7-25.1 16.1-39.3 16.1C285.5 185.7 271.5 192 256 192s-29.5-6.3-39.6-16.4zM48.1 329.5C34.3 377.5 32 416 32 416H480s-2.3-38.5-16.1-86.5c-12.2 4.3-25.6 3.5-37.3-2.4l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0L85.5 327.2c-11.7 5.8-25.2 6.6-37.3 2.4z"]
};
var faBrazilianRealSign = {
  prefix: 'fas',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"]
};
var faLandmarkDome = {
  prefix: 'fas',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"]
};
var faLandmarkAlt = faLandmarkDome;
var faBoneBreak = {
  prefix: 'fas',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L201 71zM473 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM143.9 223.8C129.3 204.5 106.1 192 80 192c-44.2 0-80 35.8-80 80c0 35.8 23.5 66.1 55.9 76.3c4.6 1.5 8.3 5.1 9.3 9.8s-1.1 9.5-4.8 12.6C43.1 385.5 32 407.5 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-11.9 7-23.8 18.6-26.1L320 384l109.4 21.9C441 408.2 448 420.1 448 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-24.5-11.1-46.5-28.5-61.2c-3.7-3.1-5.7-7.9-4.8-12.6s4.7-8.4 9.3-9.8C616.5 338.1 640 307.8 640 272c0-44.2-35.8-80-80-80c-26.1 0-49.3 12.5-63.9 31.8c-10.1 13.3-25.7 23.8-42.1 20.5l-70.6-14.1c-17.3-3.5-34.2 7.8-37.7 25.1L320 384 294.3 255.4c-3.5-17.3-20.3-28.6-37.7-25.1L186 244.4c-16.4 3.3-32.1-7.2-42.1-20.5z"]
};
var faArrowUp = {
  prefix: 'fas',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"]
};
var faDownFromDottedLine = {
  prefix: 'fas',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", "M73.9 345.9L196.7 468.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L374.1 345.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9H288V160c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32V288H97.9C79.2 288 64 303.2 64 321.9c0 9 3.6 17.6 9.9 24zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM256 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM448 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faTv = {
  prefix: 'fas',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faBorderLeft = {
  prefix: 'fas',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M32 480c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
var faCircleDivide = {
  prefix: 'fas',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232H344c13.3 0 24 10.7 24 24s-10.7 24-24 24H168c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faShrimp = {
  prefix: 'fas',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faListCheck = {
  prefix: 'fas',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faTasks = faListCheck;
var faDiagramSubtask = {
  prefix: 'fas',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H160v96c0 17.7 14.3 32 32 32h32c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H288c-35.3 0-64-28.7-64-64H192c-53 0-96-43-96-96V224H64c-35.3 0-64-28.7-64-64V96zM448 352H288v64H448V352z"]
};
var faJugDetergent = {
  prefix: 'fas',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faCircleUser = {
  prefix: 'fas',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
var faUserCircle = faCircleUser;
var faSquareY = {
  prefix: 'fas',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm74.1 120.3L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297v79c0 13.3-10.7 24-24 24s-24-10.7-24-24V297L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"]
};
var faUserDoctorHair = {
  prefix: 'fas',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16h31.8c28.9 0 55.8-15.2 70.6-40l5.3 5.3C265 89 280.8 95.7 297.3 96c4.3 9.8 6.7 20.6 6.7 32v16zM224 0C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0zm64 320l-1.3 0H161.3l-1.3 0v50.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V323.4C54.9 338.8 0 403.6 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-77.7-54.9-142.5-128-157.8V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V320zM168 424a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faPlanetRinged = {
  prefix: 'fas',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", "M319.7 319.7C456.6 182.8 539.1 43.3 503.9 8.1C481.7-14 418.3 10.4 340.2 65.7C314.4 54.3 286 48 256 48C141.1 48 48 141.1 48 256c0 30 6.3 58.4 17.7 84.2C10.4 418.3-14 481.7 8.1 503.9c35.2 35.2 174.7-47.3 311.6-184.2zM256 464c114.9 0 208-93.1 208-208c0-16.1-1.8-31.8-5.3-46.9c-31.8 42.6-71.4 88.2-116.4 133.2s-90.6 84.6-133.2 116.4c15.1 3.5 30.7 5.3 46.9 5.3z"]
};
var faMushroom = {
  prefix: 'fas',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M24 258.1C24 133.2 125.2 32 250.1 32h11.8C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9H313 199 85.9C51.7 320 24 292.3 24 258.1zm387.5-96.7c-3.7-.9-7.5-1.4-11.5-1.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c15.9 0 30-7.7 38.7-19.6c-3.3-27.4-12.9-52.9-27.2-75zM145.9 113.6c8 35.7 39.9 62.4 78.1 62.4c44.2 0 80-35.8 80-80c0-3.8-.3-7.5-.8-11.2C290 81.7 276.1 80 261.9 80H250.1c-38.9 0-74.9 12.5-104.2 33.6zM191 352H321L343 440.2c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3H200c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L191 352zM160 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faUserShield = {
  prefix: 'fas',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"]
};
var faMegaphone = {
  prefix: 'fas',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", "M544 32c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM64 190.3L480 64V448L348.9 408.2C338.2 449.5 300.7 480 256 480c-53 0-96-43-96-96c0-11 1.9-21.7 5.3-31.5L64 321.7C63.1 338.6 49.1 352 32 352c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32c17.1 0 31.1 13.4 32 30.3zm239 203.9l-91.6-27.8c-2.1 5.4-3.3 11.4-3.3 17.6c0 26.5 21.5 48 48 48c23 0 42.2-16.2 46.9-37.8z"]
};
var faWreathLaurel = {
  prefix: 'fas',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M144 112C144 50.1 194.1 0 256 0h16c8.8 0 16 7.2 16 16V32c0 60.2-47.5 109.3-107 111.9c-23.9 32.2-37 71.5-37 112.1c0 97.2 78.8 176 176 176h11.6c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480H320 308.4c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2c-5.6-3.2-11-6.7-16.3-10.3c-59.6 28.2-131.9 6.3-165.4-51.8l-8-13.9c-4.4-7.7-1.8-17.4 5.9-21.9c13.8-8 28.4-13.1 43.3-15.5C27.5 315.6 0 273 0 224V208c0-8.8 7.2-16 16-16c15.9 0 31.1 2.9 45.2 8.2c-24.3-38.8-26.8-89.5-2.3-131.9l8-13.9c4.4-7.7 14.2-10.3 21.9-5.9C115 63.7 133.8 86.8 144 113v-1zm315 31.9C399.5 141.3 352 92.2 352 32V16c0-8.8 7.2-16 16-16h16c61.9 0 112 50.1 112 112v1c10.2-26.2 29-49.2 55.3-64.4c7.7-4.4 17.4-1.8 21.9 5.9l8 13.9c24.5 42.4 21.9 93.1-2.3 131.9c14.1-5.3 29.3-8.2 45.2-8.2c8.8 0 16 7.2 16 16v16c0 49-27.5 91.6-68 113.1c14.8 2.4 29.5 7.5 43.3 15.5c7.7 4.4 10.3 14.2 5.9 21.9l-8 13.9c-24.2 42-68.7 65.1-114 64c-4.8-5.8-10.9-10.8-18.1-14.4l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1c-10.4-4.8-21-9-31.8-12.6c-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-40.6-13.1-79.9-37-112.1z"]
};
var faCircleExclamationCheck = {
  prefix: 'fas',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M506.5 203L480 229.5l-18.7-18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l64 64c11.9 11.9 27.4 18.2 43 18.7c-44.3 76.5-127 128-221.8 128C114.6 512 0 397.4 0 256S114.6 0 256 0C379.2 0 482.1 87 506.5 203zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM625 209L497 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faWind = {
  prefix: 'fas',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]
};
var faBoxDollar = {
  prefix: 'fas',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm244 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5l0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V440c0 11 9 20 20 20s20-9 20-20V426.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V232z"]
};
var faBoxUsd = faBoxDollar;
var faCarBurst = {
  prefix: 'fas',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"]
};
var faCarCrash = faCarBurst;
var faY = {
  prefix: 'fas',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"]
};
var faUserHeadset = {
  prefix: 'fas',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M224 32C135.6 32 64 103.6 64 192v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192C32 86 118 0 224 0S416 86 416 192v16c0 61.9-50.1 112-112 112H240 224 208c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80V192c0-88.4-71.6-160-160-160zM96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256h-8.6c-11.1-19.1-31.7-32-55.4-32H208c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192zM224 352h16 64 9.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352H208h16z"]
};
var faArrowsRetweet = {
  prefix: 'fas',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M150.6 73.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 173.3V320c0 53 43 96 96 96H304c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32-14.3-32-32V173.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM336 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H448c17.7 0 32 14.3 32 32V338.7l-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L544 338.7V192c0-53-43-96-96-96H336z"]
};
var faRetweetAlt = faArrowsRetweet;
var faPersonSnowboarding = {
  prefix: 'fas',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faSnowboarding = faPersonSnowboarding;
var faSquareChevronRight = {
  prefix: 'fas',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM313 273L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z"]
};
var faChevronSquareRight = faSquareChevronRight;
var faLacrosseStickBall = {
  prefix: 'fas',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M336 64v0c.1 0 .2 0 .3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1c0 .1 0 .2 0 .3h0c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64V0C274.4 0 220.2 40.9 203.3 100.1L200 111.7c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-136 136c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3C471.1 291.8 512 237.6 512 176h0c0-.1 0-.2 0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0c-.1 0-.2 0-.3 0zM496 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
var faTruckFast = {
  prefix: 'fas',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faShippingFast = faTruckFast;
var faUserMagnifyingGlass = {
  prefix: 'fas',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3c-88.4 0-160-71.6-160-160c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1H178.3zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
var faStarSharp = {
  prefix: 'fas',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2H361.5L310.9 16.7z"]
};
var faCommentHeart = {
  prefix: 'fas',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM144 205.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faCircle1 = {
  prefix: 'fas',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L232 193.4V336H192c-13.3 0-24 10.7-24 24s10.7 24 24 24h64 64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V152c0-8.6-4.6-16.5-12-20.8z"]
};
var faCircleStar = {
  prefix: 'fas',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 104c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
var faStarCircle = faCircleStar;
var faFish = {
  prefix: 'fas',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCloudFog = {
  prefix: 'fas',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", "M160 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8C128 50.1 178.1 0 240 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H160zM0 392c0-13.3 10.7-24 24-24H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm64 96c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24z"]
};
var faFog = faCloudFog;
var faWaffle = {
  prefix: 'fas',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 80c-8.8 0-16 7.2-16 16v48H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V368h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V368h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V176h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H368V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H272V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H176V96c0-8.8-7.2-16-16-16zm16 256V272h64v64H176zm96 0V272h64v64H272zm64-160v64H272V176h64zm-96 0v64H176V176h64z"]
};
var faMusicNote = {
  prefix: 'fas',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384 32c0-9.9-4.5-19.2-12.3-25.2S353.8-1.4 344.2 1l-128 32C202 36.5 192 49.3 192 64v64V359.7c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V153L359.8 127C374 123.5 384 110.7 384 96V32z"]
};
var faMusicAlt = faMusicNote;
var faHexagonExclamation = {
  prefix: 'fas',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36H344.3c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36H167.7c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faCartShoppingFast = {
  prefix: 'fas',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24h45.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H263.7c-11.5 0-21.4-8.2-23.6-19.5L234.7 288H523.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C640.6 57 621.4 32 595.1 32h-411C175 12.8 155.6 0 133.5 0H88zM240 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM24 96C10.7 96 0 106.7 0 120s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
};
var faObjectUnion = {
  prefix: 'fas',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h96v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V64c0-35.3-28.7-64-64-64H64z"]
};
var faUserGraduate = {
  prefix: 'fas',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"]
};
var faStarfighter = {
  prefix: 'fas',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M353.8 14L384 256V464c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V256L286.2 14c1-8 7.8-14 15.9-14h35.8c8.1 0 14.9 6 15.9 14zM288 256v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256c0-17.7-14.3-32-32-32s-32 14.3-32 32zM48 72c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V352h56V320c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32 64 32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-9.6L72 444v4c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24zm544 0c13.3 0 24 10.7 24 24v24c13.3 0 24 10.7 24 24s-10.7 24-24 24V448c0 13.3-10.7 24-24 24s-24-10.7-24-24v-4l-88 26.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448 416 352 320c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32h56V168c-13.3 0-24-10.7-24-24s10.7-24 24-24V96c0-13.3 10.7-24 24-24z"]
};
var faCircleHalfStroke = {
  prefix: 'fas',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faAdjust = faCircleHalfStroke;
var faArrowRightLongToLine = {
  prefix: 'fas',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32zM502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l370.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]
};
var faSquareArrowDown = {
  prefix: 'fas',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M64 480c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64zm177-87L353 281c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71V136c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 393c9.4 9.4 24.6 9.4 33.9 0z"]
};
var faArrowSquareDown = faSquareArrowDown;
var faDiamondHalfStroke = {
  prefix: 'fas',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", "M256 78.5L433.5 256 256 433.5V78.5zm28.3-66.8c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"]
};
var faClapperboard = {
  prefix: 'fas',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"]
};
var faSquareChevronLeft = {
  prefix: 'fas',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM135 239L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faChevronSquareLeft = faSquareChevronLeft;
var faPhoneIntercom = {
  prefix: 'fas',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M48 32H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32zM160 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V96zM320 368a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H368zM224 128v96c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"]
};
var faLinkHorizontal = {
  prefix: 'fas',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M144.6 64C64.7 64 0 128.7 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-44.5 36.1-80.6 80.6-80.6H303.4c44.5 0 80.6 36.1 80.6 80.6c0 39.4-28.5 73-67.4 79.5l-1.9 .3c-17.4 2.9-29.2 19.4-26.3 36.8s19.4 29.2 36.8 26.3l1.9-.3c69.7-11.6 120.8-72 120.8-142.6C448 128.7 383.3 64 303.4 64H144.6zM495.4 448C575.3 448 640 383.3 640 303.4c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 44.5-36.1 80.6-80.6 80.6H336.6c-44.5 0-80.6-36.1-80.6-80.6c0-39.4 28.5-73 67.4-79.5l1.9-.3c17.4-2.9 29.2-19.4 26.3-36.8s-19.4-29.2-36.8-26.3l-1.9 .3C243.1 172.4 192 232.7 192 303.4C192 383.3 256.7 448 336.6 448H495.4z"]
};
var faChainHorizontal = faLinkHorizontal;
var faMango = {
  prefix: 'fas',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M344 0h8 24 8 56c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24H448c-33.4 0-62.8-17-80-42.9v49c32.2 8.3 62.6 25 87.8 50.2C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224c-144 0-244.1-43.3-244.1-43.3C10.3 457.6-7.9 421.4 3.3 387.9C7.4 375.4 15 365 24.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8c20.6-36.8 42.6-76.3 88.4-113.5C221.7 114.7 270.9 96 320 96V24c0-13.3 10.7-24 24-24zm88 304c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z"]
};
var faMusicNoteSlash = {
  prefix: 'fas',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", "M512 32c0-9.9-4.5-19.2-12.3-25.2S481.8-1.4 472.2 1l-128 32C330 36.5 320 49.3 320 64v64 97.5L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L384 275.7V153L487.8 127C502 123.5 512 110.7 512 96V32zM272 352c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V411.2L317.8 359c-14-4.5-29.5-7-45.8-7z"]
};
var faMusicAltSlash = faMusicNoteSlash;
var faCircleRadiation = {
  prefix: 'fas',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faRadiationAlt = faCircleRadiation;
var faFaceTongueSweat = {
  prefix: 'fas',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", "M544 256c0 112.9-73.1 208.7-174.5 242.8C378.7 484 384 466.6 384 448V416.7c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7V448c0 18.6 5.3 36 14.5 50.8c-41.3-13.9-78-38-106.9-69.4C116.9 415 128 393.5 128 369c0-11.4-3.8-22.4-7.1-30.5c-3.7-8.7-8.4-17.6-13.2-25.7C98.1 296.7 87 281.3 80 272.1c-11.6-15.6-31.7-19.9-48-12.8c0-1.1 0-2.2 0-3.3C32 114.6 146.6 0 288 0S544 114.6 544 256zM96 369c0 14.2-6.4 26.9-16.5 35.5C71 411.7 60 416 48 416c-26.5 0-48-21-48-47c0-17.3 21.4-50 35.7-69.7c2.2-3 4.2-5.8 5.9-8.1c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM352 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6z"]
};
var faGlobeStand = {
  prefix: 'fas',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3V464H88c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V430.7c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L332.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm193-15a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
var faBaseball = {
  prefix: 'fas',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"]
};
var faBaseballBall = faBaseball;
var faCircleP = {
  prefix: 'fas',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128h92c50.8 0 92 41.2 92 92s-41.2 92-92 92H208v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V288 152c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44H208v88h68z"]
};
var faAwardSimple = {
  prefix: 'fas',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", "M173.3 5.3c11.5-7 26-7 37.5 0l17.9 10.9c5.9 3.6 12.7 5.4 19.6 5.2l20.9-.5c13.5-.3 26 6.9 32.5 18.7l10 18.4c3.3 6.1 8.3 11 14.3 14.3l18.4 10c11.8 6.5 19.1 19 18.7 32.5l-.5 20.9c-.2 6.9 1.7 13.7 5.2 19.6l10.9 17.9c7 11.5 7 26 0 37.5l-10.9 17.9c-3.6 5.9-5.4 12.7-5.2 19.6l.5 20.9c.3 13.5-6.9 26-18.7 32.5l-18.4 10c-6.1 3.3-11 8.3-14.3 14.3l-10 18.4c-6.5 11.8-19 19.1-32.5 18.7l-20.9-.5c-6.9-.2-13.7 1.7-19.6 5.2l-17.9 10.9c-11.5 7-26 7-37.5 0l-17.9-10.9c-5.9-3.6-12.7-5.4-19.6-5.2l-20.9 .5c-13.5 .3-26-6.9-32.5-18.7L72.4 326c-3.3-6.1-8.3-11-14.3-14.3l-18.4-10c-11.8-6.5-19.1-19-18.7-32.5l.5-20.9c.2-6.9-1.7-13.7-5.2-19.6L5.3 210.7c-7-11.5-7-26 0-37.5l10.9-17.9c3.6-5.9 5.4-12.7 5.2-19.6l-.5-20.9c-.3-13.5 6.9-26 18.7-32.5L58 72.4c6.1-3.3 11-8.3 14.3-14.3l10-18.4c6.5-11.8 19-19.1 32.5-18.7l20.9 .5c6.9 .2 13.7-1.7 19.6-5.2L173.3 5.3zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM64.4 492.4L88 390c8.9 3.7 18.6 5.6 28.6 5.4l20.7-.5c.2 0 .4 .1 .6 .2l17.6 10.7c22.4 13.6 50.5 13.6 72.9 0L246.1 395c.2-.1 .4-.2 .6-.2l20.7 .5c10 .2 19.7-1.7 28.6-5.4l23.6 102.4c1.3 5.5-.5 11.3-4.6 15.2s-10 5.3-15.4 3.8L192 480.6 84.4 511.4c-5.4 1.6-11.3 .1-15.4-3.8s-5.8-9.7-4.6-15.2z"]
};
var faJetFighterUp = {
  prefix: 'fas',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"]
};
var faDiagramProject = {
  prefix: 'fas',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"]
};
var faProjectDiagram = faDiagramProject;
var faPedestal = {
  prefix: 'fas',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M96 0C60.7 0 32 28.7 32 64V416H416V64c0-35.3-28.7-64-64-64H96zm24 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faChartPyramid = {
  prefix: 'fas',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", "M290.6 59.7c-15.4-26.5-53.7-26.5-69.1 0L163 160H349L290.6 59.7zM69.6 320H442.4L367.7 192H144.3L69.6 320zM51 352L11.4 419.8C-4.2 446.5 15.1 480 45.9 480H466.1c30.9 0 50.1-33.5 34.6-60.2L461 352H51z"]
};
var faSidebar = {
  prefix: 'fas',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 0V416H448V96H224zM88 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM64 216c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"]
};
var faSnowmanHead = {
  prefix: 'fas',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M64 64C64 28.7 92.7 0 128 0H320c35.3 0 64 28.7 64 64v96H224 64V64zM330.2 192H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H390.3c16.3 28.2 25.7 61 25.7 96c0 59.8-27.4 113.3-70.3 148.5c-9.7 8-22.3 11.5-34.9 11.5H137.2c-12.6 0-25.1-3.5-34.9-11.5C59.4 465.3 32 411.8 32 352c0-35 9.3-67.8 25.7-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h85.8H330.2zM152 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7c0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z"]
};
var faFrostyHead = faSnowmanHead;
var faCopy = {
  prefix: 'fas',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"]
};
var faBurgerGlass = {
  prefix: 'fas',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H272c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c5.5-12.5 20.5-40.4 52.7-65.3c16.2-12.5 36.3-23.8 60.9-32l10-139.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73.2 160L66.4 64H317.6l-6.9 96H73.2zM640 292.3c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5H612.5c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16H304z"]
};
var faVolumeXmark = {
  prefix: 'fas',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faHandSparkles = {
  prefix: 'fas',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"]
};
var faBarsFilter = {
  prefix: 'fas',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM288 416c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32z"]
};
var faPaintbrushPencil = {
  prefix: 'fas',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M559.6 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0L227.7 269.1l79.2 79.2L559.6 95.6zM205 291.8c-9.3-2.5-19-3.8-29-3.8c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176c61.9 0 112-50.1 112-112c0-10-1.3-19.8-3.8-29l.1-.1-79.2-79.2-.1 .1zm93.4-138.7L164.7 19.3c-25-25-65.5-25-90.5 0L50.7 42.7c-25 25-25 65.5 0 90.5L173.5 256c.8 0 1.7 0 2.5 0c6.2 0 12.4 .4 18.4 1.2L298.5 153.1zM320 402.5l64.6 64.6c6.7 6.7 15.1 11.6 24.2 14.2l104 29.7c8.4 2.4 17.4 .1 23.6-6.1s8.5-15.2 6.1-23.6l-29.7-104c-2.6-9.2-7.5-17.5-14.2-24.2l-75.6-75.6L318.8 381.6c.8 6 1.2 12.2 1.2 18.4c0 .8 0 1.7 0 2.5z"]
};
var faPartyBell = {
  prefix: 'fas',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M0 224C0 100.3 100.3 0 224 0c35.3 0 68.9 8.2 98.7 22.8C341.9 32.3 352 51.7 352 70.7c0 14.5-5.7 28.3-16 38.5L109.2 336C99 346.3 85.1 352 70.7 352c-19 0-38.4-10.1-47.8-29.3C8.2 292.9 0 259.3 0 224zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 480a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM359 167c9.4-9.4 24.6-9.4 33.9 0l8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3c13.2 1.5 22.7 13.3 21.2 26.5s-13.3 22.7-26.5 21.2l-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201c-9.4-9.4-9.4-24.6 0-33.9zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4c1.5 13.2-8 25-21.2 26.5s-25-8-26.5-21.2l-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM503.5 506.3c-10.1 8.6-25.3 7.3-33.8-2.8l-8.5-10c-12.5-14.8-19.1-33.7-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8c.2-7.6-2.4-15-7.3-20.7l-8.5-10c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l8.5 10c12.5 14.8 19.1 33.7 18.6 53c-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8c-.2 7.6 2.4 15 7.3 20.7l8.5 10c8.6 10.1 7.3 25.3-2.8 33.8z"]
};
var faUserVneckHair = {
  prefix: 'fas',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M304 128v16c0 44.2-35.8 80-80 80s-80-35.8-80-80V128c0-5.5 .6-10.8 1.6-16H176c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96h1.3c4.3 9.8 6.7 20.6 6.7 32zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zm61.3 199.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7H417.3c17 0 30.7-13.8 30.7-30.7c0-83.1-62.9-151.5-143.7-160.3c-5.3-.6-10.5 1.9-13.7 6.2l-53.9 71.8c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z"]
};
var faJackOLantern = {
  prefix: 'fas',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", "M234.6 103.9C251.5 98.8 269.4 96 288 96c22.8 0 44.7 4.2 64.8 11.7c-.6-2-.8-4.1-.8-6.3V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3zM208 208c5.3 0 10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H176c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1zm173.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5H336c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1zM368 437.5C346.2 444 319.8 448 288 448s-58.2-4-80-10.5V416c0-8.8-7.2-16-16-16H176c-8.6 0-15.7 6.9-16 15.4c-36.9-24.7-49.9-56.7-54.1-71.4c-1.4-5 .3-10.2 4-13.8c5.8-5.8 15.1-6.6 22.2-2.4c18 10.6 55.5 29.1 107.9 36.8V384c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V368c77.6 0 132.8-26.6 155.9-40.2c7.1-4.2 16.4-3.4 22.2 2.4c3.7 3.7 5.4 8.8 4 13.8c-4.2 14.7-17.3 46.8-54.1 71.4c-.3-8.6-7.3-15.4-16-15.4H384c-8.8 0-16 7.2-16 16v21.5z"]
};
var faGrip = {
  prefix: 'fas',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"]
};
var faGripHorizontal = faGrip;
var faShareFromSquare = {
  prefix: 'fas',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"]
};
var faShareSquare = faShareFromSquare;
var faKeynote = {
  prefix: 'fas',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", "M184 72h14.4c8.3 14.3 23.8 24 41.6 24h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H240c-17.8 0-33.3 9.7-41.6 24H184c-48.6 0-88 39.4-88 88v48H80c-12.1 0-23.2 6.8-28.6 17.7l-48 96C1.2 278.1 0 283 0 288v32c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V288c0-5-1.2-9.9-3.4-14.3l-48-96C455.2 166.8 444.1 160 432 160H144V112c0-22.1 17.9-40 40-40zM160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V384H224v64H160z"]
};
var faChildCombatant = {
  prefix: 'fas',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"]
};
var faChildRifle = faChildCombatant;
var faGun = {
  prefix: 'fas',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faSquarePhone = {
  prefix: 'fas',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"]
};
var faPhoneSquare = faSquarePhone;
var faHatBeach = {
  prefix: 'fas',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M320 448c176.7 0 320-57.3 320-128c0-19.3-11.8-36.7-29.7-43.9L574.9 262c.7 4.2 1.1 8.5 1.1 12.8c0 42.7-34.6 77.3-77.3 77.3c-12.2 0-24.1-2.9-34.7-8.3c-10.7 5.4-22.6 8.3-34.7 8.3c-38.6 0-70.6-28.3-76.3-65.4c-10.6 .9-21.6 1.4-32.9 1.4c-88.4 0-160-28.7-160-64v0L29.7 276.1C11.8 283.3 0 300.7 0 320c0 70.7 143.3 128 320 128zm32-242.7c0-42.7 34.6-77.3 77.3-77.3c7.1 0 14.1 1 20.9 2.9C421.1 90.4 373.6 64 320 64c-70.4 0-130.2 45.5-151.6 108.7l.1-.2C174.7 201.3 240.1 224 320 224c11.7 0 23-.5 34-1.4c-1.3-5.6-2-11.5-2-17.3zM473.1 168c-5.5 3.8-12.7 3.8-18.2 0c-7.5-5.2-16.4-8-25.7-8c-25 0-45.3 20.3-45.3 45.3c0 9.2 2.8 18.2 8 25.7c3.8 5.5 3.8 12.7 0 18.2c-5.2 7.5-8 16.4-8 25.7c0 25 20.3 45.3 45.3 45.3c9.2 0 18.2-2.8 25.7-8c5.5-3.8 12.7-3.8 18.2 0c7.5 5.2 16.4 8 25.7 8c25 0 45.3-20.3 45.3-45.3c0-9.2-2.8-18.2-8-25.7c-3.8-5.5-3.8-12.7 0-18.2c5.2-7.5 8-16.4 8-25.7c0-25-20.3-45.3-45.3-45.3c-9.2 0-18.2 2.8-25.7 8zM464 216a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faPlus = {
  prefix: 'fas',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
};
var faAdd = faPlus;
var faExpand = {
  prefix: 'fas',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"]
};
var faComputer = {
  prefix: 'fas',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faFort = {
  prefix: 'fas',
  iconName: 'fort',
  icon: [640, 512, [], "e486", "M0 16C0 7.2 7.2 0 16 0H48c8.8 0 16 7.2 16 16V64H96V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V96v16 48H384V112 96 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V64h32V16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16V96v16 64c0 20.9-13.4 38.7-32 45.3V464c0 26.5-21.5 48-48 48H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V512H80c-26.5 0-48-21.5-48-48V221.3C13.4 214.7 0 196.9 0 176V112 96 16z"]
};
var faCloudCheck = {
  prefix: 'fas',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"]
};
var faXmark = {
  prefix: 'fas',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faFaceSmirking = {
  prefix: 'fas',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-48c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H112c-8.8 0-16 7.2-16 16zM375.8 338.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.2 1.2c-3.2 19.3-19.9 33.4-39.5 33.4H192c-8.8 0-16 7.2-16 16s7.2 16 16 16H304.6c35.2 0 65.2-25.4 71-60.2l.2-1.2zM288 208c0 8.8 7.2 16 16 16h32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32H304c-8.8 0-16 7.2-16 16z"]
};
var faArrowsUpDownLeftRight = {
  prefix: 'fas',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"]
};
var faArrows = faArrowsUpDownLeftRight;
var faChalkboardUser = {
  prefix: 'fas',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"]
};
var faChalkboardTeacher = faChalkboardUser;
var faRhombus = {
  prefix: 'fas',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M254.4 14.1C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9l-184-216z"]
};
var faClawMarks = {
  prefix: 'fas',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4l96 96 64 64 160 160 64 64 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L434.7 448H384c-17.7 0-32-14.3-32-32V365.3L210.7 224H160c-17.7 0-32-14.3-32-32V141.3L41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm0 224c12.5-12.5 32.8-12.5 45.3 0l64 64 96 96 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L210.7 448H128c-17.7 0-32-14.3-32-32V333.3L41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3zM310.6 9.4l32 32 64 64 64 64 64 64 32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L498.7 288H448c-17.7 0-32-14.3-32-32V205.3L370.7 160H320c-17.7 0-32-14.3-32-32V77.3L265.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faPesoSign = {
  prefix: 'fas',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"]
};
var faFaceSmileTongue = {
  prefix: 'fas',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M503.4 322c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c61.5 0 118-21.7 162.1-57.9c-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1c2.3-8.5 11.1-13.6 19.6-11.3c1.5 .4 2.9 1 4.2 1.8l65.4 37.8c5 2.9 9.6 6.2 13.7 10zM370.6 389.3l55.7 33.1c22.6 13.4 51.8 5.8 65-17c13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1c-11.7 30.4-30.5 57.1-54.5 77.6zm-153-160.5l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"]
};
var faCartCircleXmark = {
  prefix: 'fas',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H320.7c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32h-143l-9.1-48H339.2c29.1-57 88.4-96 156.8-96c14.3 0 28.3 1.7 41.6 4.9l35-124.3C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faBuildingShield = {
  prefix: 'fas',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"]
};
var faCirclePhoneFlip = {
  prefix: 'fas',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm69.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L312 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C143.1 378 151 384 160 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"]
};
var faPhoneCircleAlt = faCirclePhoneFlip;
var faBaby = {
  prefix: 'fas',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"]
};
var faUsersLine = {
  prefix: 'fas',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faQuoteLeft = {
  prefix: 'fas',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"]
};
var faQuoteLeftAlt = faQuoteLeft;
var faTractor = {
  prefix: 'fas',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"]
};
var faKeySkeleton = {
  prefix: 'fas',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c22.2 14 48.5 22.1 76.7 22.1z"]
};
var faTrashArrowUp = {
  prefix: 'fas',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"]
};
var faTrashRestore = faTrashArrowUp;
var faArrowDownUpLock = {
  prefix: 'fas',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faArrowDownToBracket = {
  prefix: 'fas',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M374.6 214.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 242.7V32c0-17.7 14.3-32 32-32s32 14.3 32 32V242.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM64 352v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faLinesLeaning = {
  prefix: 'fas',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"]
};
var faSquareQ = {
  prefix: 'fas',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 224c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
var faRulerCombined = {
  prefix: 'fas',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"]
};
var faSymbols = {
  prefix: 'fas',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM32 0H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 64 0 49.7 0 32S14.3 0 32 0zM502.6 342.6l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM0 128c0-17.7 14.3-32 32-32h80 80c17.7 0 32 14.3 32 32s-14.3 32-32 32H144v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160H32c-17.7 0-32-14.3-32-32zM288 328a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM472 432a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM135.6 374l10.3 10.8 23.5-23.5c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-24.7 24.7L215.2 458c12.2 12.8 11.6 33.1-1.2 45.2s-33.1 11.6-45.2-1.2l-24.1-25.4-12.8 12.8C117.4 503.9 97.7 512 77.3 512C34.6 512 0 477.4 0 434.7v-.9c0-19.4 7.2-38.2 20.3-52.6l13.1-14.4C22.5 354.3 16 337.9 16 320c0-39.8 32.2-72 72-72s72 32.2 72 72c0 21.5-9.4 40.8-24.4 54zm-68 50.3c-2.4 2.6-3.7 6-3.7 9.5v.9c0 7.3 5.9 13.3 13.3 13.3c3.5 0 6.9-1.4 9.4-3.9l14-14L81.1 409.5 67.7 424.3zM104 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faIconsAlt = faSymbols;
var faCopyright = {
  prefix: 'fas',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"]
};
var faFlaskGear = {
  prefix: 'fas',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c10.6 0 20.7-2.4 29.7-6.6c-2.8-6.2-4.2-12.9-4.2-19.7v-.9c-17.6 9.7-41.5 8.1-57.2-8.7c-9.2-9.9-17.4-20.9-24.4-33s-12.5-24.7-16.4-37.6c-6.7-21.6 3.4-42.7 20-53.3l-.2-.2h-207L173 263.9c12.4-20.2 19-43.4 19-67.1V64h64V196.8c0 23.7 6.6 46.9 19 67.1L304 311c.1-4 .8-8.1 2-12.2c4-12.9 9.4-25.5 16.4-37.6c4.1-7.1 8.7-13.9 13.6-20.3l-6.5-10.6c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM436 218.2v17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9v17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8V467.5c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7V218.2c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7c-6.8 1.5-11.3 7.8-11.3 14.8zm-4.1 133.5a48.1 48.1 0 1 1 96.1 0 48.1 48.1 0 1 1 -96.1 0z"]
};
var faHighlighterLine = {
  prefix: 'fas',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M229 229l215-158.4 29.3 29.3L315 315 229 229zM128 320l0 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L224 416h71.7c15.3 0 29.6-7.2 38.6-19.5L535.6 123.4c5.5-7.4 8.4-16.4 8.4-25.6c0-11.4-4.5-22.4-12.6-30.5L476.6 12.6C468.5 4.5 457.6 0 446.2 0C437 0 428 2.9 420.6 8.4L147.5 209.6c-12.3 9-19.5 23.4-19.5 38.6V320zM70.1 403.3l-63 63c-4.5 4.5-7 10.6-7 17V488c0 13.3 10.7 24 24 24H92.7c6.4 0 12.5-2.5 17-7l31-31L70.1 403.3zM224 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"]
};
var faBracketSquare = {
  prefix: 'fas',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 96C0 60.7 28.7 32 64 32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64V416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V96z"]
};
var faBracket = faBracketSquare;
var faBracketLeft = faBracketSquare;
var faIslandTropical = {
  prefix: 'fas',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3H78.2c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2c2.2 8.6-5 15.8-13.8 15.8H451.3c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3H301.5c28 79.9 21.2 170.2 9.9 226.1C370.9 365.1 416 417.3 416 480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32c0-70.7 57.3-128 128-128h64c29.7-79.3 29.4-150.9 22.8-194l-87.6 87.6c-6.2 6.2-16.5 6.2-21-1.4c-18.5-31.6-22.5-90.9 32.3-145.7c1.4-1.4 2.8-2.7 4.1-4c-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24z"]
};
var faIslandTreePalm = faIslandTropical;
var faArrowRightFromLine = {
  prefix: 'fas',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 224 160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faArrowFromLeft = faArrowRightFromLine;
var faH2 = {
  prefix: 'fas',
  iconName: 'h2',
  icon: [640, 512, [], "f314", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4H496c35.3 0 64 28.7 64 64v5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H482.3l100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4V192c0-70.7-57.3-128-128-128h-4.5c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z"]
};
var faEquals = {
  prefix: 'fas',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"]
};
var faCakeSlice = {
  prefix: 'fas',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M276.2 38.9c5.6-4.4 12.6-6.9 19.8-6.9c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v.5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2c0 35.4-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272c0-9.8 4.5-19.1 12.2-25.1l264-208zM448 288H64v48H448v-.1-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4V330v-.4-.4V329v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V325v-.4-.4V324v-.4-.4-.4-.4-.4-.4-.4V321v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V312v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V307v-.4-.4-.4-.4V305v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V297v-.4-.4-.4-.4V295v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V290v-.4-.4-.4-.4V288zM64 416H448v-.2-.2-.2-.2-.2V415v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V413v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V411v-.2-.2-.2-.2V410v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V406v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V401v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V398v-.2-.2-.2-.2-.2-.2-.2-.2V396v-.2-.2-.2-.2-.2-.2-.2-.2V394v-.2-.2-.2V393v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V390v-.2-.2-.2V389v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V379v-.3-.3-.3V378v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V374v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V371v-.3-.3-.3-.3-.3-.3V369v-.3-.3-.3V368H64v48z"]
};
var faShortcake = faCakeSlice;
var faPeanut = {
  prefix: 'fas',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M432 0H364c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148V80c0-44.2-35.8-80-80-80zM396.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM192 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"]
};
var faWrenchSimple = {
  prefix: 'fas',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M132.7 164.7l48 48c6.2 6.2 16.4 6.2 22.6 0l48-48c3-3 4.7-7.1 4.7-11.3V17.6c0-11 10.9-18.7 20.8-13.8C340.3 35 384 100.4 384 176c0 71.1-38.6 133.1-96 166.3V464c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V342.3C38.6 309.1 0 247.1 0 176C0 100.4 43.7 35 107.2 3.7C117.1-1.2 128 6.5 128 17.6V153.4c0 4.2 1.7 8.3 4.7 11.3z"]
};
var faBlender = {
  prefix: 'fas',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faTeeth = {
  prefix: 'fas',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"]
};
var faTally2 = {
  prefix: 'fas',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faShekelSign = {
  prefix: 'fas',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faCars = {
  prefix: 'fas',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", "M123.4 74.9c2.2-6.5 8.3-10.9 15.2-10.9H277.4c6.9 0 13 4.4 15.2 10.9L310.3 128H105.7l17.7-53.1zM36.1 134.4C14.8 144.7 0 166.6 0 192v96H0v32c0 17.7 14.3 32 32 32H48c17.7 0 32-14.3 32-32V288H216.5c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6h15.1L353.3 54.7C342.4 22 311.8 0 277.4 0H138.6c-34.4 0-65 22-75.9 54.7L36.1 134.4zM56 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm306.6 16H501.4c6.9 0 13 4.4 15.2 10.9L534.3 288H329.7l17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352v96h0v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448H560v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32l0-32V352c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160H362.6c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faAxeBattle = {
  prefix: 'fas',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M95.9 14l0 .1c0 .1 .1 .4 .1 .7c.1 .7 .3 1.8 .6 3.3c.6 3 1.7 7.4 3.5 12.8c3.6 10.8 9.9 25.1 20.6 39.5c13.9 18.6 36 37.9 71.2 48.8V266.8c-29.9 11.1-50.9 29.3-65.6 47.3c-11.9 14.6-19.7 29.3-24.5 40.3c-2.4 5.5-4 10-5.1 13.1c-.5 1.5-.9 2.7-1.1 3.5l-.2 .8 0 .1 0 0c-1.5 5.8-6.1 10.3-11.9 11.7s-12-.7-15.8-5.3L80 368c-12.2 10.3-12.2 10.3-12.2 10.3l0 0 0 0-.1-.1-.2-.2-.6-.8c-.5-.7-1.3-1.6-2.3-2.9c-1.9-2.5-4.6-6.1-7.7-10.6c-6.3-9.2-14.7-22.4-23.1-38.9C17 291.9 0 245.3 0 192S17 92.1 33.7 59.3c8.4-16.5 16.8-29.7 23.1-38.9c3.2-4.6 5.8-8.2 7.7-10.6c1-1.2 1.7-2.2 2.3-2.9l.6-.8 .2-.2 .1-.1 0 0 0 0s0 0 12.2 10.3L67.8 5.7c4.1-4.9 10.7-6.8 16.8-5c6.1 1.8 10.5 7 11.3 13.3l0 0zM320 266.8V119.2c35.2-10.9 57.3-30.2 71.2-48.8C403.3 54.3 412.8 34 416.1 14c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.8 .3 16.9 5.2c13.3 16.3 24.4 34.8 33.9 53.4c12.4 24.5 25.1 56.6 30.7 93.4c.5 3.5-1.4 7-4.7 8.4l-55.1 23.6c-6.5 2.8-6.5 11.9 0 14.7L504.3 223c3.3 1.4 5.3 4.8 4.7 8.4c-8 53-31.3 105.5-64.5 146.6c-3.9 4.6-10.3 7-16.1 5.6s-10.5-6-11.9-11.8c-5.9-21-17.2-40.9-30.9-57.7c-14.7-18-35.7-36.2-65.6-47.3zM288 64V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faUserHairLong = {
  prefix: 'fas',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M304 128c0-11.4-2.4-22.2-6.7-32H296c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112H145.6c-1 5.2-1.6 10.5-1.6 16v16c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H224 70.6C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5V128zm65.3 192H286.7C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3C0 392.2 72.2 320 161.3 320z"]
};
var faMap = {
  prefix: 'fas',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"]
};
var faArrowLeftFromArc = {
  prefix: 'fas',
  iconName: 'arrow-left-from-arc',
  icon: [512, 512, [], "e615", "M448 256c0-106-86-192-192-192c-17.7 0-32-14.3-32-32s14.3-32 32-32C397.4 0 512 114.6 512 256s-114.6 256-256 256c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192zM121.4 121.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H109.3l57.4 57.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3l112-112z"]
};
var faFileCircleInfo = {
  prefix: 'fas',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16h0v48h0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16 16c8.8 0 16-7.2 16-16s-7.2-16-16-16V368c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16z"]
};
var faFaceDisappointed = {
  prefix: 'fas',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
var faLassoSparkles = {
  prefix: 'fas',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", "M290.7 0L288 0C128.9 0 0 78.8 0 176c0 57.2 44.7 108.1 113.9 140.2l-.2 .4L160.5 340c19.3 9.7 31.5 29.4 31.5 51c0 31.5-25.5 57-57 57H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h71c66.8 0 121-54.2 121-121c0-14.1-2.4-27.8-7-40.6c12.8 1.1 25.8 1.6 39 1.6c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80c0 5.6-1 11.1-2.8 16.2C486.4 116.5 512 144.8 512 176c0 61.9-100.3 112-224 112S64 237.9 64 176c0-51 68.2-94 161.4-107.6c3.8-15.2 14.8-27.9 29.9-33.4l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4L306.3 50.3 266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L321 149.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15L365.7 50.3 351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8L426.4 417c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L481 501.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L565.6 447c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7L511 362.4c-2.3-6.3-8.3-10.4-15-10.4z"]
};
var faClockEleven = {
  prefix: 'fas',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120v56.7l-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faRocket = {
  prefix: 'fas',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faSirenOn = {
  prefix: 'fas',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M69.3 36l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM597.3 76l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM144 352l25-199.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L496 352H234.1l21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L201.9 352H144zM96 416c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416z"]
};
var faClockTen = {
  prefix: 'fas',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120v91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
var faCandleHolder = {
  prefix: 'fas',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", "M160 192c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 32v48c0 8.8 7.2 16 16 16s16-7.2 16-16V224h64c17.7 0 32 14.3 32 32V464h52.1c-2.7-7.5-4.1-15.6-4.1-24c0-39.8 32.2-72 72-72s72 32.2 72 72s-32.2 72-72 72H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H64V256c0-17.7 14.3-32 32-32h32zM400 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faVideoArrowDownLeft = {
  prefix: 'fas',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9V192 320v17.1l14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128zM232 352H120c-13.3 0-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103H232c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
var faPhotoFilm = {
  prefix: 'fas',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"]
};
var faPhotoVideo = faPhotoFilm;
var faFloppyDiskCircleArrowRight = {
  prefix: 'fas',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H296.2c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
var faFolderMinus = {
  prefix: 'fas',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faPlanetMoon = {
  prefix: 'fas',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zM236.2 112.4c-4-.3-8.1-.4-12.2-.4c-76.2 0-141.1 48.4-165.6 116.2C53.3 242.3 64.7 256 79.7 256h28.4c12.7 0 24.9 5.1 33.9 14.1L185 313c4.5 4.5 7 10.6 7 17V352c0 9.2 3.9 17.6 10.2 23.4l1.9 1.8c9.3 8.6 19.9 18.4 19.9 30.8v23c0 13.8 11.2 25 25 25c9.2 0 17.7-5.1 22-13.2l41.3-76.6c5-9.3 7.6-19.8 7.6-30.3V320c0-17.7-14.3-32-32-32H222.1c-9 0-17.7-3.6-24.1-10c-12.5-12.5-13.4-32.4-2.1-45.9l52.7-63.2c4.8-5.8 7.4-13 7.4-20.5V134.9c0-11.6-8.3-21.7-19.8-22.5z"]
};
var faFaceEyesXmarks = {
  prefix: 'fas',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM123.3 132.7L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm192 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM256 304c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]
};
var faChartScatter = {
  prefix: 'fas',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDisplayArrowDown = {
  prefix: 'fas',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H352V64H512V352H64V64H224V0H64zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V206.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V24z"]
};
var faStore = {
  prefix: 'fas',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"]
};
var faArrowTrendUp = {
  prefix: 'fas',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"]
};
var faPlugCircleMinus = {
  prefix: 'fas',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"]
};
var faOliveBranch = {
  prefix: 'fas',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H425.2c-34.2 0-67.9 7.5-98.8 22.1L191.9 133.4C189.1 219.3 118.6 288 32 288H16c-8.8 0-16-7.2-16-16V256c0-61.4 34.5-114.6 85.2-141.5C40.4 102.8 11.3 75.8 2.7 66.9C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM480 320c0 106-64.5 192-144 192s-144-86-144-192s64.5-192 144-192s144 86 144 192zM465.7 471.8c29.2-40.5 46.3-94 46.3-151.8c0-59.3-18-114.2-48.6-155c-10.5-14-22.7-26.5-36.2-36.9c48.2 1.6 101.3 25.8 144.2 70.3c75 77.8 90.2 188.1 33.9 246.4c-34.1 35.4-86.8 43.5-139.6 27z"]
};
var faAngle = {
  prefix: 'fas',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", "M252.6 78.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-192 384c-5 9.9-4.4 21.7 1.4 31.1S20.9 480 32 480H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H83.8L252.6 78.3zm-12.2 96l-21.9 43.8c21.4 17.4 40.4 37.7 56.2 60.4l40.8-25.3c-20.7-30.1-46.1-56.7-75.1-78.9zM321.1 384h49c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3c13.3 24.2 23.3 50.5 29.5 78.3z"]
};
var faVacuumRobot = {
  prefix: 'fas',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM356.7 356.7c55.6-55.6 55.6-145.8 0-201.4s-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm-144-144c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"]
};
var faSignHanging = {
  prefix: 'fas',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]
};
var faSign = faSignHanging;
var faSquareDivide = {
  prefix: 'fas',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM136 232H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSignalStreamSlash = {
  prefix: 'fas',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-68.1-23.7-130.7-63.2-180c-11.1-13.8-31.2-16-45-5s-16 31.2-5 45c30.7 38.4 49.1 87 49.1 140c0 36.4-8.7 70.8-24.1 101.1l-38.7-30.4c9.5-21.7 14.8-45.6 14.8-70.8c0-45.1-17-86.2-44.8-117.3c-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2c17.8 19.8 28.5 46 28.5 74.7c0 10.1-1.3 19.9-3.8 29.2l-53.6-42c-5.8-24.7-28-43.2-54.5-43.2c-.2 0-.4 0-.5 0L38.8 5.1zm84.7 188.2C116.1 212.8 112 233.9 112 256c0 45.1 17 86.2 44.8 117.3c11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7c0-6.8 .6-13.5 1.8-19.9l-54.3-42.8zM33 122C11.9 162 0 207.6 0 256c0 68.1 23.7 130.7 63.2 180c11.1 13.8 31.2 16 45 5s16-31.2 5-45C82.4 357.6 64 309 64 256c0-33.4 7.3-65.1 20.4-93.5L33 122z"]
};
var faBezierCurve = {
  prefix: 'fas',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"]
};
var faEyeDropperHalf = {
  prefix: 'fas',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4zm-63.9 71.8l45.3 45.3L149.3 320h85.5l29.4-29.4 45.3 45.3L188.7 456.6c-15 15-35.4 23.4-56.6 23.4H89.7L49.7 506.6c-12.7 8.5-29.6 6.8-40.4-4s-12.5-27.7-4-40.4L32 422.3V379.9c0-21.2 8.4-41.6 23.4-56.6L176.1 202.6z"]
};
var faStoreLock = {
  prefix: 'fas',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c5 5.5 10.6 10.3 16.8 14.4C455.2 179.6 489.3 160 528 160c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3zM128 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H392.6c-5.4-9.4-8.6-20.3-8.6-32V384H128zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
var faBellSlash = {
  prefix: 'fas',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7 .7-3.5 .7-5.4c0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8H406.2L160 222.1v20.7zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
var faCloudBoltSun = {
  prefix: 'fas',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zM639.9 303.9c0 44.2-35.8 80-80 80H541.3c3.5-10.1 3.7-21.3 0-31.8C534.5 332.9 516.4 320 496 320H477.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-14.5 11.6-20.9 30.5-16.8 48.4c-37.9-12.8-65.2-48.7-65.2-90.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7zM474.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L425.9 352H496c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384H304c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
var faThunderstormSun = faCloudBoltSun;
var faCameraSlash = {
  prefix: 'fas',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8L202.7 96H154.8L38.8 5.1zM285.4 198.4c10.7-4.1 22.4-6.4 34.6-6.4c53 0 96 43 96 96c0 4.1-.3 8.2-.8 12.2L285.4 198.4zM224 288c0-5 .4-9.9 1.1-14.6L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6V416c0 35.3 28.7 64 64 64H487.4L356.4 376.8c-11.2 4.6-23.5 7.2-36.4 7.2c-53 0-96-43-96-96z"]
};
var faCommentQuote = {
  prefix: 'fas',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM160 144h48c17.7 0 32 14.3 32 32v24 24 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H160c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32zm224 80v39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7V256H304c-17.7 0-32-14.3-32-32V176c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v24 24z"]
};
var faTablet = {
  prefix: 'fas',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faTabletAndroid = faTablet;
var faSchoolFlag = {
  prefix: 'fas',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"]
};
var faMessageCode = {
  prefix: 'fas',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm217 97c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
var faGlassHalf = {
  prefix: 'fas',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM77.8 224L66.4 64H317.6L306.2 224H77.8z"]
};
var faGlassHalfEmpty = faGlassHalf;
var faGlassHalfFull = faGlassHalf;
var faFill = {
  prefix: 'fas',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"]
};
var faMessageMinus = {
  prefix: 'fas',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
};
var faCommentAltMinus = faMessageMinus;
var faAngleUp = {
  prefix: 'fas',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"]
};
var faDinosaur = {
  prefix: 'fas',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M446.2 0H448C554 0 640 86 640 192v30.6c0 88-51.5 165.6-128 201.5V480c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V458c-15.3 3.9-31.4 6-48 6c-6.8 0-13.5-.4-20.1-1c-7.5-18.9-24.4-33.3-45.4-36.8L162 408.1c-19.6-3.3-34-20.2-34-40.1c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.5 25.7 65.8 60.7 71.7l108.5 18.1c13.2 2.2 22.8 13.6 22.8 26.9c0 15.1-12.2 27.3-27.3 27.3H256 224 192 120.7C54.1 512 0 457.9 0 391.3c0-34 14.4-66.5 39.5-89.3l89.7-81.6C172 181.5 227.6 160 285.3 160c50.2 0 99 16.3 139.2 46.4L480 248c6.9 5.2 15.3 8 24 8c22.1 0 40-17.9 40-40V192c0-35.3-28.7-64-64-64H448 415.7c-26.3 0-47.7-21.4-47.7-47.7V75.6c0-16.7 10.1-31.6 25.6-37.8l1.7-.7c8.2-3.3 14.8-9.4 18.7-17.2C420.2 7.7 432.6 0 446.2 0zM464 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faDrumstickBite = {
  prefix: 'fas',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"]
};
var faLinkHorizontalSlash = {
  prefix: 'fas',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.7-44.4c39.6-25.8 65.9-70.5 65.9-121.3c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 36.6-24.4 67.6-57.9 77.4L415.3 300.2c20.5-25.1 32.7-57.1 32.7-91.6C448 128.7 383.3 64 303.4 64H144.6c-9.4 0-18.5 .9-27.4 2.6L38.8 5.1zM195.6 128H303.4c44.5 0 80.6 36.1 80.6 80.6c0 19.7-7.1 38-19.1 52.1L195.6 128zM446.8 448l-81.2-64H336.6c-44.5 0-80.6-36.1-80.6-80.6c0-1.9 .1-3.7 .2-5.5l-55.5-43.8c-5.6 15.4-8.6 32.1-8.6 49.3C192 383.3 256.7 448 336.6 448H446.8zM30.4 119.9C11.3 144.4 0 175.2 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-18.5 6.2-35.5 16.6-49.1L30.4 119.9z"]
};
var faChainHorizontalSlash = faLinkHorizontalSlash;
var faHollyBerry = {
  prefix: 'fas',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faNose = {
  prefix: 'fas',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M324.2 231.9L421 338.3c17.4 19.1 27 44 27 69.9C448 465.5 401.5 512 344.1 512h-9.4c-32.3 0-63.6-11.3-88.4-32l-6.4-5.3c-20.7-17.2-46.7-26.7-73.6-26.7c-21.2 0-38.3 17.2-38.3 38.3V492c0 1.7 .1 3.4 .3 5.1c.8 7.1-4 14.9-11.2 14.9H112C50.8 512 1.1 462.9 0 401.9C1 345.3 44.3 298 100.9 292.4l44.7-4.5c8.8-.9 15.2-8.7 14.3-17.5s-8.7-15.2-17.5-14.3l-44.7 4.5c-7.1 .7-14 1.9-20.7 3.6c-6.4 1.6-13-3-13-9.7V32C64 14.3 78.3 0 96 0h61.6c11.4 0 21.9 6 27.6 15.9l75.6 129.6c18.1 30.9 39.3 59.9 63.4 86.4z"]
};
var faArrowLeftToArc = {
  prefix: 'fas',
  iconName: 'arrow-left-to-arc',
  icon: [512, 512, [], "e616", "M64 256C64 150 150 64 256 64c17.7 0 32-14.3 32-32s-14.3-32-32-32C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256zM281.4 121.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H269.3l57.4-57.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
};
var faChevronLeft = {
  prefix: 'fas',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
};
var faBacteria = {
  prefix: 'fas',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faClouds = {
  prefix: 'fas',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", "M304 160c-74.1 0-135.2 56-143.1 128H96c-53 0-96-43-96-96s43-96 96-96l1.1 0C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96c0 12.1-2.2 23.6-6.3 34.2c-11.4 2.3-22.2 6.4-32.1 11.9C383.3 177.7 345.7 160 304 160zM224 512c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H224z"]
};
var faMoneyBillSimple = {
  prefix: 'fas',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
var faHandLizard = {
  prefix: 'fas',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"]
};
var faTablePivot = {
  prefix: 'fas',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", "M0 96C0 60.7 28.7 32 64 32h64V160H0V96zm448 64H160V32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192H128V416H448V160zm-33.2 86.1c-2.5 6-8.3 9.9-14.8 9.9H384v48c0 26.5-21.5 48-48 48H288v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16V256H336c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z"]
};
var faFilterSlash = {
  prefix: 'fas',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L406.6 293.4 567 97.3c9.8-12 11.8-28.5 5.2-42.5S551.5 32 536 32H104c-8.1 0-15.8 2.5-22.3 6.8L38.8 5.1zM256 400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6V398.5L256 297.7V400z"]
};
var faTrashCanUndo = {
  prefix: 'fas',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V128zM217.8 199.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264H240c48.6 0 88 39.4 88 88v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V352c0-22.1-17.9-40-40-40H182.5l33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z"]
};
var faTrashCanArrowTurnLeft = faTrashCanUndo;
var faTrashUndoAlt = faTrashCanUndo;
var faNotdef = {
  prefix: 'fas',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]
};
var faDisease = {
  prefix: 'fas',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPersonToDoor = {
  prefix: 'fas',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H362.7c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM109.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H91.2l18.3-41.3zM384 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V320h0c35.3 0 64-28.7 64-64s-28.7-64-64-64h0V48z"]
};
var faTurntable = {
  prefix: 'fas',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM512 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V272.4c0 2.5-.6 4.9-1.7 7.2l-16.2 32.5c-11 .7-21.4 7-26.7 17.6l-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l16-32c5.3-10.6 4.2-22.7-1.9-31.9l16.2-32.4c3.3-6.7 5.1-14 5.1-21.5V112zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBriefcaseMedical = {
  prefix: 'fas',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faGenderless = {
  prefix: 'fas',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
var faChevronRight = {
  prefix: 'fas',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
};
var faSignalWeak = {
  prefix: 'fas',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", "M64 384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"]
};
var faSignal1 = faSignalWeak;
var faClockFive = {
  prefix: 'fas',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392V248.7l60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faRetweet = {
  prefix: 'fas',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"]
};
var faCarRear = {
  prefix: 'fas',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCarAlt = faCarRear;
var faPumpSoap = {
  prefix: 'fas',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"]
};
var faComputerClassic = {
  prefix: 'fas',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M0 48C0 21.5 21.5 0 48 0H400c26.5 0 48 21.5 48 48V368c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48zM32 480V448H416v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM96 64C78.3 64 64 78.3 64 96V224c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm144-24c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"]
};
var faFrame = {
  prefix: 'fas',
  iconName: 'frame',
  icon: [448, 512, [], "e495", "M448 128c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L128 96l0-32c0-17.7-14.3-32-32-32S64 46.3 64 64l0 32L32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l32 0 0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 192 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-192 32 0c17.7 0 32-14.3 32-32zM128 352l0-192 192 0 0 192-192 0z"]
};
var faVideoSlash = {
  prefix: 'fas',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"]
};
var faBatteryQuarter = {
  prefix: 'fas',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"]
};
var faBattery2 = faBatteryQuarter;
var faEllipsisStroke = {
  prefix: 'fas',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM256 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-96 0a72 72 0 1 0 144 0A72 72 0 1 0 24 256z"]
};
var faEllipsisHAlt = faEllipsisStroke;
var faRadio = {
  prefix: 'fas',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"]
};
var faBabyCarriage = {
  prefix: 'fas',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCarriageBaby = faBabyCarriage;
var faFaceExpressionless = {
  prefix: 'fas',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM128 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faDownToDottedLine = {
  prefix: 'fas',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", "M0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM73.9 249.9L196.7 372.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L374.1 249.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9H288V64c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32V192H97.9C79.2 192 64 207.2 64 225.9c0 9 3.6 17.6 9.9 24z"]
};
var faCloudMusic = {
  prefix: 'fas',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM416 184c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v32 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V275.1l96-36v74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32V216 184z"]
};
var faTrafficLight = {
  prefix: 'fas',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
var faCloudMinus = {
  prefix: 'fas',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
};
var faThermometer = {
  prefix: 'fas',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"]
};
var faShieldMinus = {
  prefix: 'fas',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faVrCardboard = {
  prefix: 'fas',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCarTilt = {
  prefix: 'fas',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", "M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l6 22.2H48c-26.5 0-48 21.5-48 48v16H640V496c0-26.5-21.5-48-48-48H162.6c-.1-.2-.1-.5-.2-.7L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6z"]
};
var faGaugeCircleMinus = {
  prefix: 'fas',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3V88c0-13.3 10.7-24 24-24s24 10.7 24 24V292.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16z"]
};
var faBrightnessLow = {
  prefix: 'fas',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", "M224 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM432 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0-256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faHandMiddleFinger = {
  prefix: 'fas',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"]
};
var faPercent = {
  prefix: 'fas',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
var faPercentage = faPercent;
var faTruckMoving = {
  prefix: 'fas',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGlassWaterDroplet = {
  prefix: 'fas',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"]
};
var faConveyorBelt = {
  prefix: 'fas',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M176 0h80V112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1V0h80c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faLocationCheck = {
  prefix: 'fas',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM305 145L177 273c-9.4 9.4-24.6 9.4-33.9 0L79 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faMapMarkerCheck = faLocationCheck;
var faCoinVertical = {
  prefix: 'fas',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M288 256c0 141.4-64.5 256-144 256S0 397.4 0 256S64.5 0 144 0s144 114.6 144 256zM184.2 425.4c11.4-12 20.1-27.7 26.8-44.4c13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64s-36.7 10.5-48.2 22.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448s36.7-10.5 48.2-22.6zM136 416c-35.3 0-64-71.6-64-160s28.7-160 64-160s64 71.6 64 160s-28.7 160-64 160zm90.1 96c15.6-13.2 29.3-29.7 40.9-48h63.7c-21 30.2-46.8 48-74.6 48H226.1zM349 432H284.3c13.2-28.4 23-60.9 29-96h64.3c-6 36.2-15.9 68.9-28.7 96zm32.8-128H317.6c1.6-15.7 2.4-31.7 2.4-48s-.8-32.3-2.4-48h64.1c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48zm-4.1-128H313.3c-6-35.1-15.9-67.6-29-96H349c12.8 27.1 22.7 59.8 28.7 96zm-47-128H267c-11.5-18.3-25.2-34.8-40.9-48H256c27.9 0 53.6 17.8 74.6 48z"]
};
var faDisplay = {
  prefix: 'fas',
  iconName: 'display',
  icon: [576, 512, [], "e163", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"]
};
var faPersonSign = {
  prefix: 'fas',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7-15.4 42.4-28.8-10.8c-9.7-3.7-18.4-9.6-25.4-17.4L235 160.2c-18.2-20.5-44.3-32.2-71.8-32.2H135.6c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L80 263.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h20.2L192 407.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V407.6c0-9.9-2.3-19.7-6.8-28.6L216 312.4V235.2l.3 .3c13.8 15.6 31.2 27.5 50.7 34.8l29.3 11L289 301.5c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM192 48A48 48 0 1 0 96 48a48 48 0 1 0 96 0z"]
};
var faFaceSmile = {
  prefix: 'fas',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSmile = faFaceSmile;
var faPhoneHangup = {
  prefix: 'fas',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M11.7 266.3l41.9 94.3c6.1 13.7 20.8 21.3 35.5 18.4l109.2-21.8c15-3 25.7-16.1 25.7-31.4V240c62.3-20.8 129.7-20.8 192 0v85.8c0 15.3 10.8 28.4 25.7 31.4L550.9 379c14.7 2.9 29.4-4.7 35.5-18.4l41.9-94.3c7.2-16.2 5.1-35.1-7.4-47.7C570.8 168.1 464.2 96 320 96S69.2 168.1 19.1 218.6c-12.5 12.6-14.6 31.5-7.4 47.7z"]
};
var faSignatureSlash = {
  prefix: 'fas',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416h53c13.3 0 24-10.7 24-24s-10.7-24-24-24H501.8l-61.2-48H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM192.1 125.3C193.5 108.9 207.2 96 224 96c17.7 0 32 14.3 32 32v7.8c0 12.8-.5 25.6-1.5 38.3l-62.4-48.9zM355.3 253.2l42.8-12.8-12.3 36.8-30.5-23.9zm-190.9-9.5c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c17.5-30.5 31.9-62.7 43.1-95.9L181.1 238.7l-16.7 5zm67.4 46.6c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7l49-14.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24z"]
};
var faThumbtack = {
  prefix: 'fas',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"]
};
var faThumbTack = faThumbtack;
var faWheatSlash = {
  prefix: 'fas',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM536 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16H536z"]
};
var faTrophy = {
  prefix: 'fas',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"]
};
var faCloudsSun = {
  prefix: 'fas',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9C276.8 132.7 244.8 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17.1c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm450.6 75c-18.9-35.1-56-59-98.7-59c-12.9 0-25.3 2.2-36.8 6.2C435.9 206.6 403.7 192 368 192c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9zm45.3 148.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faPersonPraying = {
  prefix: 'fas',
  iconName: 'person-praying',
  icon: [448, 512, [128720, "pray"], "f683", "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"]
};
var faPray = faPersonPraying;
var faHammer = {
  prefix: 'fas',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"]
};
var faFaceVomit = {
  prefix: 'fas',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M544 256c0 72.5-30.1 137.9-78.5 184.5l-16.7-5.6c-11.9-4-21.5-12.3-27.2-22.9c16.7-12.6 26.4-27.7 26.4-44c0-44.2-71.6-80-160-80s-160 35.8-160 80c0 16.3 9.7 31.4 26.4 44c-5.7 10.6-15.2 19-27.2 22.9l-16.7 5.6C62.1 393.9 32 328.5 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256zM148 141.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm480 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 396.1V338.7c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7v57.4c0 31 19.8 58.5 49.2 68.3l34.1 11.4c7.6 2.5 12.7 9.6 12.7 17.6c0 10.3-8.3 18.6-18.6 18.6H114.6c-10.3 0-18.6-8.3-18.6-18.6c0-8 5.1-15.1 12.7-17.6l34.1-11.4c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faSpeakers = {
  prefix: 'fas',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", "M64 0H280.4C265.2 17 256 39.4 256 64V257.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6V448c0 24.6 9.2 47 24.4 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM320 503.4c-19.1-11.1-32-31.7-32-55.4V336 64c0-23.7 12.9-44.4 32-55.4C329.4 3.1 340.3 0 352 0H576c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H352c-11.7 0-22.6-3.1-32-8.6zM352 336a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM176 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 336a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faTtyAnswer = {
  prefix: 'fas',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24zM304 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80zM496 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H592c-8.8 0-16-7.2-16-16V80zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H592c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM384 176c0-8.8 7.2-16 16-16H528c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V176z"]
};
var faTeletypeAnswer = faTtyAnswer;
var faMugTeaSaucer = {
  prefix: 'fas',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", "M208 82.7V32H128c-17.7 0-32 14.3-32 32V288c0 53 43 96 96 96H384c53 0 96-43 96-96h32c70.7 0 128-57.3 128-128s-57.3-128-128-128H448 240V82.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6V224c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V157.3c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6zM480 96h32c35.3 0 64 28.7 64 64s-28.7 64-64 64H480V96zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faDiagramLeanCanvas = {
  prefix: 'fas',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", "M512 96V304h64V96H512zm-48 0H400v80h64V96zM352 96H288V304h64V96zM240 96H176v80h64V96zM128 96H64V304h64V96zM64 352v64H296V352H64zm280 64H576V352H344v64zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM240 304V224H176v80h64zm224-80H400v80h64V224z"]
};
var faAlt = {
  prefix: 'fas',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M448 64c-9.7 0-18.9 4.4-25 12L176.6 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c9.7 0 18.9-4.4 25-12L463.4 128H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H448zm0 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H448z"]
};
var faDial = {
  prefix: 'fas',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM175.1 174.2c56.7-56.7 145.4-62 208-15.7L271.3 270.4c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L417.1 192.4c46.2 62.6 41 151.3-15.7 208c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDialMedHigh = faDial;
var faHandPeace = {
  prefix: 'fas',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"]
};
var faCircleTrash = {
  prefix: 'fas',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7L310.6 128H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H352L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3H205.4c-16.6 0-30.5-12.8-31.9-29.3L160 192z"]
};
var faTrashCircle = faCircleTrash;
var faRotate = {
  prefix: 'fas',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"]
};
var faSyncAlt = faRotate;
var faCircleQuarters = {
  prefix: 'fas',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M120.2 391.8L256 256 391.8 391.8C426.5 357 448 309 448 256s-21.5-101-56.2-135.8L256 256 120.2 120.2C85.5 155 64 203 64 256s21.5 101 56.2 135.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faSpinner = {
  prefix: 'fas',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"]
};
var faTowerControl = {
  prefix: 'fas',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V96H160c-17.7 0-32 14.3-32 32H42.6C16 128-3.2 153.4 4.1 179L44.5 320.2C28.5 321.9 16 335.5 16 352c0 17.7 14.3 32 32 32H80v96c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V384l32 0c17.7 0 32-14.3 32-32c0-16.5-12.5-30.1-28.5-31.8L443.9 179c7.3-25.6-11.9-51-38.5-51H320c0-17.7-14.3-32-32-32H248V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H224 184zM128 192V320H111c-.1-.3-.1-.5-.2-.8L74.4 192H128zm48 128V192h96V320l-96 0zM320 192h53.6L337.2 319.2l-.1 .3-.1 .5H320V192z"]
};
var faArrowUpTriangleSquare = {
  prefix: 'fas',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM443.1 47C437.3 37.7 427 32 416 32s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5H496c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128zM320 336v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
};
var faSortShapesUp = faArrowUpTriangleSquare;
var faWhale = {
  prefix: 'fas',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L43.6 212.4C15.7 240.3 0 278.2 0 317.6C0 407.3 72.7 480 162.4 480H544c53 0 96-43 96-96V272.1C640 192.5 575.5 128 495.9 128c-82.5 0-162.4 29.5-225 83.2L156.4 309.4c-8 6.8-18.1 10.6-28.6 10.6h-1.1c-18.3 0-34.5-11.7-40.3-29c-4-12-2.4-25.2 4.3-35.9l37.6-60.1 44.7 7.5c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4zM400 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faRobot = {
  prefix: 'fas',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"]
};
var faPeace = {
  prefix: 'fas',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
var faPartyHorn = {
  prefix: 'fas',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7 .1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM150.6 201.4l160 160c7.7 7.7 11 18.8 8.6 29.4s-9.9 19.4-20 23.2l-39.7 14.9L83.1 252.5 98 212.8c3.8-10.2 12.6-17.7 23.2-20s21.7 1 29.4 8.6zM48.2 345.6l22.6-60.2L226.6 441.2l-60.2 22.6L48.2 345.6zM35.9 378.5l97.6 97.6L43.2 510c-11.7 4.4-25 1.5-33.9-7.3S-2.4 480.5 2 468.8l33.8-90.3z"]
};
var faGears = {
  prefix: 'fas',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faCogs = faGears;
var faSunBright = {
  prefix: 'fas',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M256 0c-13.3 0-24 10.7-24 24V88c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm0 400c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V424c0-13.3-10.7-24-24-24zM488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H424c-13.3 0-24 10.7-24 24s10.7 24 24 24h64zM112 256c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24zM437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9zM154.2 357.8c-9.4-9.4-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9zM403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437zM154.2 154.2c9.4-9.4 9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
var faSunAlt = faSunBright;
var faWarehouse = {
  prefix: 'fas',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"]
};
var faConveyorBeltArm = {
  prefix: 'fas',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M240.9 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H267.1l-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3c17.5 2.3 29.8 18.4 27.5 35.9c-1.4 10.2-7.4 18.7-15.7 23.5V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V190.1L255.2 164.5c-8.4 7.2-19.3 11.6-31.2 11.6c-26.5 0-48-21.5-48-48c0-17.1 8.9-32 22.3-40.6L202.2 64H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h79c.6 0 1.2 0 1.9 0zM240 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h32c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96s43-96 96-96l0-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64V280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v40h64V280zM128 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faLockKeyholeOpen = {
  prefix: 'fas',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M432 64c-44.2 0-80 35.8-80 80v48h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H288V144C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V144c0-44.2-35.8-80-80-80zM256 384c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"]
};
var faLockOpenAlt = faLockKeyholeOpen;
var faSquareFragile = {
  prefix: 'fas',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 86.3C128 106 138 96 150.3 96H176l32 64-32 32 80 64-32-64 48-32L240 96h57.7C310 96 320 106 320 118.3V208c0 47.6-34.6 87.1-80 94.7V384h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V302.7c-45.4-7.6-80-47.1-80-94.7V118.3z"]
};
var faBoxFragile = faSquareFragile;
var faSquareWineGlassCrack = faSquareFragile;
var faArrowUpRightDots = {
  prefix: 'fas',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faSquareN = {
  prefix: 'fas',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.3 104.5L288 294.5V152c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z"]
};
var faSplotch = {
  prefix: 'fas',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"]
};
var faFaceGrinHearts = {
  prefix: 'fas',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"]
};
var faGrinHearts = faFaceGrinHearts;
var faMeter = {
  prefix: 'fas',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faMandolin = {
  prefix: 'fas',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4L388 169.2l-65.9 65.9C323.7 322.4 311.5 512 176 512C78.8 512 0 433.2 0 336C0 200.5 189.6 188.3 276.9 189.8L342.8 124l18.1-66.3c1.6-5.8 5.3-10.8 10.4-14l64-40zM208 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faDiceFour = {
  prefix: 'fas',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faSimCard = {
  prefix: 'fas',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"]
};
var faTransgender = {
  prefix: 'fas',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
var faTransgenderAlt = faTransgender;
var faMercury = {
  prefix: 'fas',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"]
};
var faUpFromBracket = {
  prefix: 'fas',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M73.9 134.1L196.7 11.3C203.9 4.1 213.8 0 224 0s20.1 4.1 27.3 11.3L374.1 134.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9H288V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192H97.9C79.2 192 64 176.8 64 158.1c0-9 3.6-17.6 9.9-24zM64 352v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V352c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 53-43 96-96 96H96c-53 0-96-43-96-96V352c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faKnifeKitchen = {
  prefix: 'fas',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M488 0c9.4 0 18.3 3.7 25 10.3L557.7 55c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-97 97c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42l-31 17.2L295.9 200.1l-11.3-11.3L463 10.3C469.7 3.7 478.6 0 488 0zM432 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM262 211.4l11.3 11.3 126 126c6.2 6.2 6.2 16.4 0 22.6C321.4 449.2 235.3 512 112 512c-25.6 0-50.9-4.2-69.5-8.4c-9.4-2.1-17.2-4.2-22.7-5.7c-2.8-.8-4.9-1.4-6.5-1.9c-.8-.2-1.4-.4-1.8-.6l-.5-.2-.1 0 0 0 0 0 0 0s0 0 5.1-15.2l-5.1 15.2c-5.3-1.8-9.2-6.1-10.5-11.5s.3-11.1 4.3-15l246-246L262 211.4z"]
};
var faBorderRight = {
  prefix: 'fas',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M416 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowTurnDown = {
  prefix: 'fas',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"]
};
var faLevelDown = faArrowTurnDown;
var faSpade = {
  prefix: 'fas',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M278 12.5c-12.3-11.7-31.7-11.7-44 0L168 75.1 40 196.3c-51.3 48.6-53.5 129.6-4.9 181s129.6 53.5 181 4.9l8-7.6V448H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V374.6l8 7.6c51.3 48.6 132.3 46.4 181-4.9s46.4-132.3-4.9-181L344 75.1 278 12.5z"]
};
var faCardSpade = {
  prefix: 'fas',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM175 137.8c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-7.4-7.4c-.3-.3-.6-.6-1-.9V336h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V295.2c-.3 .3-.7 .6-1 .9l-7.4 7.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64L175 137.8z"]
};
var faLineColumns = {
  prefix: 'fas',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", "M224 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H192c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32zM0 320c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM224 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32zM288 64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zM512 192c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32zM288 320c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zM512 448c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32z"]
};
var faArrowRightToLine = {
  prefix: 'fas',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM310.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
};
var faArrowToRight = faArrowRightToLine;
var faPersonFallingBurst = {
  prefix: 'fas',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"]
};
var faFlagPennant = {
  prefix: 'fas',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352L433 213.6c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L64 32z"]
};
var faPennant = faFlagPennant;
var faConveyorBeltEmpty = {
  prefix: 'fas',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserGroupSimple = {
  prefix: 'fas',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", "M160 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm320 0a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM0 416c0-70.7 57.3-128 128-128h64c70.7 0 128 57.3 128 128v16c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416zm448 64c-38.3 0-72.7-16.8-96.1-43.5c.1-1.5 .1-3 .1-4.5V416c0-34.9-11.2-67.1-30.1-93.4c5.8-20 24.2-34.6 46.1-34.6H592c26.5 0 48 21.5 48 48v16c0 70.7-57.3 128-128 128H448z"]
};
var faAward = {
  prefix: 'fas',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"]
};
var faTicketSimple = {
  prefix: 'fas',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"]
};
var faTicketAlt = faTicketSimple;
var faBuilding = {
  prefix: 'fas',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"]
};
var faAnglesLeft = {
  prefix: 'fas',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
};
var faAngleDoubleLeft = faAnglesLeft;
var faCamcorder = {
  prefix: 'fas',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M128 96c-17.7 0-32 14.3-32 32v32H320c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-23.7 12.9-44.4 32-55.4V128c0-53 43-96 96-96H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zm431.1 67.8c10.4 5.6 16.9 16.4 16.9 28.2V448c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 401.1V384 256 238.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faVideoHandheld = faCamcorder;
var faPancakes = {
  prefix: 'fas',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M256 192c0-17.7 14.3-31.9 32-32.6c108.6-4.4 192-31.1 192-63.4c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37C86.5 138.3 96 150.6 96 164.8V272c0 17.7 14.3 32 32 32s32-14.3 32-32V171.7c0-9.5 8.1-16.8 17.5-15.7c8.1 .9 14.5 7.6 14.5 15.7V224c0 17.7 14.3 32 32 32s32-14.3 32-32V192zM192 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zM14.9 133C5.3 141.4 0 150.5 0 160c0 20.3 24.2 38.8 64 52.9V164.8c0-.1-.1-.2-.2-.4c-.4-.5-1.2-1.3-2.4-1.8c-14.7-5.9-28.7-13.4-39.6-22.9c-2.3-2-4.6-4.3-6.8-6.8zM286.1 239.5C413.3 234.8 512 201 512 160c0-9.5-5.3-18.6-14.9-27c-4 4.5-8.5 8.4-12.7 11.5c-13.4 10-30.9 17.8-49.8 24C396.6 181 345.5 189 289.3 191.3c-.5 0-.9 .2-1.2 .5c-.1 .1-.1 .2-.1 .2l0 32c0 5.3-.7 10.5-1.9 15.5zM7.2 221.1C2.5 227.2 0 233.5 0 240c0 21 25.8 40 68 54.3c-2.6-6.9-4-14.5-4-22.3V246.7c-21.5-6.8-41.1-15.2-56.8-25.6zM256 320c141.4 0 256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26c-47.8 14.9-111.2 24-180.2 24.8c-11.3 10-26.1 16.1-42.4 16.1c-11.8 0-22.9-3.2-32.4-8.8c-1.6 14.1-7.8 26.9-17 36.7c25.6 2.7 52.9 4.1 81.4 4.1zm256 0c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320c0 44.2 114.6 80 256 80s256-35.8 256-80zm0 80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400c0 44.2 114.6 80 256 80s256-35.8 256-80z"]
};
var faAlbumCircleUser = {
  prefix: 'fas',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4H64c-35.3 0-64-28.7-64-64V96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7H399.4c-21 0-38.9 13.7-45.1 32.7C374.5 468.1 401.8 480 432 480s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
var faSubtitlesSlash = {
  prefix: 'fas',
  iconName: 'subtitles-slash',
  icon: [640, 512, [], "e610", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zm355 278.2l-1.2-.9c-5.3-4.4-8.6-11-8.6-18.4c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-5.3 0-10.2-1.7-14.2-4.6zM461 336h27c13.3 0 24 10.7 24 24c0 4.8-1.4 9.3-3.8 13L461 336zm26.4 144L365.5 384H312c-13.3 0-24-10.7-24-24c0-11.1 7.5-20.4 17.7-23.2l-62-48.8H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h30.8L32 121.2V416c0 35.3 28.7 64 64 64H487.4zM152 336h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faQrcode = {
  prefix: 'fas',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
var faDiceD10 = {
  prefix: 'fas',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", "M209.7 16.3C212.4 8.3 206.4 0 198 0c-3.8 0-7.3 1.7-9.7 4.6L2.4 237C.8 238.9 0 241.3 0 243.8c0 7 6.4 12.1 13.2 10.6l117.6-26.1c5.5-1.2 9.9-5.2 11.7-10.6L209.7 16.3zM8.7 288.2C3.6 289.4 0 293.9 0 299.1c0 3.1 1.3 6.1 3.6 8.2L220.7 508.9c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5V328.8c0-5.3-2.6-10.2-6.9-13.2l-78.7-54.5c-3.7-2.5-8.2-3.4-12.6-2.5L8.7 288.2zM272 500.5c0 6.3 5.1 11.5 11.5 11.5c2.9 0 5.7-1.1 7.8-3.1L508.4 307.3c2.3-2.1 3.6-5.1 3.6-8.2c0-5.2-3.6-9.8-8.7-10.9L370.2 258.7c-4.4-1-8.9-.1-12.6 2.5l-78.7 54.5c-4.3 3-6.9 7.9-6.9 13.2V500.5zM498.8 254.4c6.8 1.5 13.2-3.7 13.2-10.6c0-2.5-.8-4.9-2.4-6.8L323.7 4.6C321.4 1.7 317.8 0 314 0c-8.5 0-14.4 8.3-11.7 16.3l67.2 201.5c1.8 5.3 6.2 9.3 11.7 10.6l117.6 26.1zM246.6 6.8L174.8 222.3c-2.2 6.7 .2 14.2 6.1 18.2l66.1 45.7c5.5 3.8 12.7 3.8 18.2 0l66.1-45.7c5.8-4 8.3-11.5 6.1-18.2L265.4 6.8C264 2.7 260.3 0 256 0s-8 2.7-9.4 6.8z"]
};
var faFireplace = {
  prefix: 'fas',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", "M0 32V64C0 81.7 14.3 96 32 96H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm608 96H32V480c0 17.7 14.3 32 32 32h96V352c0-88.4 71.6-160 160-160s160 71.6 160 160V512h96c17.7 0 32-14.3 32-32V128zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z"]
};
var faBrowser = {
  prefix: 'fas',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm384 0c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24z"]
};
var faPenPaintbrush = {
  prefix: 'fas',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M95.6 16.4L226.3 147.1l-79.2 79.2L16.4 95.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0zM400 512c-53.6 0-98.5-37.7-109.4-88.1L423.9 290.6c50.3 11 88.1 55.8 88.1 109.4c0 3.9-.2 7.8-.6 11.6c-1.8 17.5 10.2 36.4 27.8 36.4H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H400zM501.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L354.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM76.9 353.2L331.7 98.3 445.7 212.3 190.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2z"]
};
var faPencilPaintbrush = faPenPaintbrush;
var faFishCooked = {
  prefix: 'fas',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M320 64c120 0 256 128 256 192s-136 192-256 192c-74.8 0-155.9-49.8-206.3-102.8c-6-6.3-15.8-7.2-22.5-1.7L26.1 396.4c-5.3 4.3-12.9 4.8-18.7 1.1s-8.6-10.7-6.9-17.4L30.5 259.9c.6-2.5 .6-5.2 0-7.8L.5 131.9c-1.6-6.5 .9-13.2 6.4-17s12.7-3.8 18.2 0l72 49.5c6.6 4.5 15.5 3.5 21.1-2.2C168.9 110.9 247.4 64 320 64zm-4.7 84.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm112 16c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zm16 112c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faChairOffice = {
  prefix: 'fas',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M160 0H288c35.3 0 64 28.7 64 64V256H96V64c0-35.3 28.7-64 64-64zM64 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm384 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zM51.4 305.7C56.8 294.8 67.9 288 80 288H368c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2H256v64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V384H64c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32z"]
};
var faNestingDolls = {
  prefix: 'fas',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M192 0c61.9 0 112 50.1 112 112V224H80V112C80 50.1 130.1 0 192 0zm-8.7 64.9c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7c-4.1-5.3-13.2-5.3-17.3 0zM635.5 474.1c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13H312c-9 0-17.2-5-21.3-13c-4.1-8-3.4-17.6 1.8-24.9l0 0 .2-.3c.2-.3 .6-.8 1-1.5c.9-1.4 2.3-3.5 4-6.3c3.4-5.6 7.9-13.8 12.5-23.8c9.2-20.3 17.8-46.8 17.8-74.1v-8c0-75.1 60.9-136 136-136s136 60.9 136 136v8c0 27.3 8.6 53.7 17.8 74.1c4.6 10 9.1 18.2 12.5 23.8c1.7 2.8 3.1 5 4 6.3c.5 .7 .8 1.2 1 1.5l.2 .3 0 0 0 0zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6c1.7 17.9 9.4 35.3 23.1 49c31.2 31.2 81.9 31.2 113.1 0c13.7-13.7 21.4-31.1 23.1-49c.4-4.3-3.3-7.6-7.6-7.6c-25.8 0-48.7-12.2-63.3-31.1c-4.1-5.3-13.2-5.3-17.3 0zM296 360v8c0 21-6.8 42.7-15 60.8c-4 8.7-7.9 15.8-10.8 20.6c-1.4 2.4-2.6 4.1-3.2 5.2c-.3 .5-.6 .9-.7 1l0 0 0 .1 0 0 0 0c-11.7 16.6-13.5 38.1-4.9 56.3H74.5c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4c2.7-5.3 8.1-8.6 14-8.6H332.1C309.5 284.6 296 320.7 296 360z"]
};
var faClockRotateLeft = {
  prefix: 'fas',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
};
var faHistory = faClockRotateLeft;
var faTrumpet = {
  prefix: 'fas',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M628.7 64.7C635.4 66.8 640 73 640 80V368c0 7-4.6 13.2-11.3 15.3s-14-.4-17.9-6.2l0 0 0 0-.1-.2-.7-.9c-.6-.8-1.5-2.1-2.8-3.8c-2.5-3.3-6.2-8.1-11-13.9c-9.6-11.6-23.6-26.9-40.8-42.3c-35-31.1-81.3-60-131.4-60H400V382c27.6-7.1 48-32.2 48-62V290.8c22 5 43.7 16.4 64 31.2c-1.1 69.8-58 126-128 126H288.1c0 0 0 0-.1 0H192c-70.7 0-128-57.3-128-128c0-23.3 6.2-45.2 17.1-64H46.6c-3.3 9.3-12.2 16-22.6 16c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24c10.4 0 19.3 6.7 22.6 16H176V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32h40V160c0-13.3 10.7-24 24-24s24 10.7 24 24v32h24c50.1 0 96.4-28.8 131.4-60c17.3-15.3 31.2-30.7 40.8-42.3c4.8-5.8 8.5-10.6 11-13.9c1.2-1.7 2.2-2.9 2.8-3.8l.7-.9 .1-.2 0 0 0 0c4-5.8 11.2-8.3 17.9-6.2zM312 384h40V256H312V384zM224 256V384h40V256H224zm-96 64c0 29.8 20.4 54.9 48 62V258c-27.6 7.1-48 32.2-48 62z"]
};
var faFaceGrinBeamSweat = {
  prefix: 'fas',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faFireSmoke = {
  prefix: 'fas',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", "M283.7 0c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 30 8.2 58.3 22.7 82.4c4.6 2.6 9 5.4 13.3 8.5c13.7-16.8 30.7-30.8 50.1-40.9c-3.9-9.4-6-20.2-6-32.1c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c11.3 20.7 12.3 44.9 4.2 65.2c19.3 10.1 36.2 24 49.9 40.8c4.2-3 8.5-5.8 12.9-8.3c14.6-24.1 23-52.4 23-82.5c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7c-2.8-2.5-6.3-3.7-9.8-3.8zM0 400c0 61.9 50.1 112 112 112H320 528c61.9 0 112-50.1 112-112s-50.1-112-112-112c-37 0-69.9 18-90.3 45.7C418.2 288 372.8 256 320 256s-98.2 32-117.7 77.7C181.9 306 149 288 112 288C50.1 288 0 338.1 0 400z"]
};
var faPhoneMissed = {
  prefix: 'fas',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M232 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 58.7 58.7C282.3 152.4 300.8 160 320 160s37.7-7.6 51.3-21.3L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L405.3 172.7C382.6 195.3 352 208 320 208s-62.6-12.7-85.3-35.3L176 113.9l-39 39c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V24c0-13.3 10.7-24 24-24H232zM51.4 489.9l-35.4-62c-9.7-16.9-8.3-38.1 5.5-51.7C72.6 325.9 178.1 256 320 256s247.4 69.9 298.5 120.2c13.9 13.6 15.2 34.8 5.5 51.7l-35.4 62c-7.4 12.9-22.7 19.1-37 14.8L438.8 470.8c-13.5-4.1-22.8-16.5-22.8-30.6V384c-62.3-20.8-129.7-20.8-192 0v56.2c0 14.1-9.3 26.6-22.8 30.6L88.4 504.7c-14.3 4.3-29.6-1.8-37-14.8z"]
};
var faFileExport = {
  prefix: 'fas',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"]
};
var faArrowRightFromFile = faFileExport;
var faShield = {
  prefix: 'fas',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"]
};
var faShieldBlank = faShield;
var faArrowUpShortWide = {
  prefix: 'fas',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faArrowsRepeat1 = {
  prefix: 'fas',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M21.9 254.4C5.1 248.8-3.9 230.6 1.6 213.9C25.1 143.5 91 96 165.2 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H165.2c-46.7 0-88.1 29.9-102.8 74.1c-5.6 16.8-23.7 25.8-40.5 20.2zm468.2 3.3c16.8 5.6 25.8 23.7 20.2 40.5C486.9 368.5 421 416 346.8 416H173.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H346.8c46.7 0 88.1-29.9 102.8-74.1c5.6-16.8 23.7-25.8 40.5-20.2zM288 216v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
var faRepeat1Alt = faArrowsRepeat1;
var faGunSlash = {
  prefix: 'fas',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8 432.9 240H464c8.5 0 16.6-3.4 22.6-9.4L509.3 208H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H560V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H113.9L38.8 5.1zM195.6 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H236.4l-40.8-32zM338.5 240h43.4l-9.5 26.6L338.5 240zM324.9 352L264 304h-3l.5-2L32 121.2V208c0 17.7 14.3 32 32 32H74c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480h96c14.7 0 27.5-10 31-24.2L249 352h75.9z"]
};
var faAvocado = {
  prefix: 'fas',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M459.4 255.3c-18.5 15.2-33.5 35.6-38.1 59.1c-10.2 51.9-34 104.5-66.3 136.7c-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c32.3-32.3 84.9-56.1 136.7-66.3c23.5-4.6 43.9-19.6 59.1-38.1C283.1 20.5 323.2 0 368 0c79.5 0 144 64.5 144 144c0 44.8-20.5 84.9-52.6 111.3zM283.2 347.2c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4s-49.1 102.1-16.4 134.8s93 25.3 134.8-16.4z"]
};
var faBinary = {
  prefix: 'fas',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M336 32V160h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H304 256c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V76.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C303.6-1.6 314.4 0 322.7 6s13.3 15.7 13.3 26zM112 320V448h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM0 64C0 28.7 28.7 0 64 0h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm128 0H64v96h64V64zM256 288h64c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zm0 64v96h64V352H256z"]
};
var faGlassesRound = {
  prefix: 'fas',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6V336c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128H271.8c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4V325.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 416a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm376-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
var faGlassesAlt = faGlassesRound;
var faPhonePlus = {
  prefix: 'fas',
  iconName: 'phone-plus',
  icon: [640, 512, [], "f4d2", "M456 200V136H392c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V24c0-13.3 10.7-24 24-24s24 10.7 24 24V88h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H504v64c0 13.3-10.7 24-24 24s-24-10.7-24-24zM181.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c33.3 70.4 90.3 127.4 160.7 160.7L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512C264.6 512 64 311.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24z"]
};
var faDitto = {
  prefix: 'fas',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M0 96v2.3c0 3.8 .3 7.6 1 11.4L26.5 256.5C29.7 274.7 45.5 288 64 288s34.3-13.3 37.5-31.5L127 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64S0 60.7 0 96zm192 0v2.3c0 3.8 .3 7.6 1 11.4l25.5 146.8c3.2 18.2 19 31.5 37.5 31.5s34.3-13.3 37.5-31.5L319 109.6c.7-3.8 1-7.5 1-11.4V96c0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
};
var faPersonSeat = {
  prefix: 'fas',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 160V256h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H189.3c-6.6-18.6-24.4-32-45.3-32c-26.5 0-48 21.5-48 48v80c0 35.3 28.7 64 64 64h85.6c8.1 0 14.9 6 15.9 14l10.7 86c2 16 15.6 28 31.8 28h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.2L325 358.1c-5-40-39-70.1-79.4-70.1H192zM64 160c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 70.7 57.3 128 128 128h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64V160z"]
};
var faHouseMedical = {
  prefix: 'fas',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"]
};
var faGolfBallTee = {
  prefix: 'fas',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"]
};
var faGolfBall = faGolfBallTee;
var faCircleChevronLeft = {
  prefix: 'fas',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faHouseChimneyWindow = {
  prefix: 'fas',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"]
};
var faScythe = {
  prefix: 'fas',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M614.7 .7c5.6 1.2 10.5 3.8 14.5 7.3c8.4 7.4 12.6 19 10.1 30.7l-4.8 22.6L577.6 326.7l-34.3 160c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38l26-121.3H416c-17.7 0-32-14.3-32-32s14.3-32 32-32H520.4L569 61.3l7.7-36 0 0L582.1 0H608c2.2 0 4.5 .2 6.7 .7zM352 0H549.4l-4 18.6L508.3 192H12.7C5.7 192 0 186.3 0 179.3c0-2.1 .5-4.1 1.6-6C15 151.1 114.8 0 352 0z"]
};
var faPenNib = {
  prefix: 'fas',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"]
};
var faBanParking = {
  prefix: 'fas',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M412.5 367.2L342.3 297c20.6-17.6 33.7-43.8 33.7-73c0-53-43-96-96-96H208c-9.7 0-18.6 3.5-25.5 9.2L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2zm-45.3 45.3C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5zM296.6 251.4L237.3 192H280c17.7 0 32 14.3 32 32c0 11.6-6.2 21.7-15.4 27.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 261.3V288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V325.3l-64-64z"]
};
var faParkingCircleSlash = faBanParking;
var faTentArrowTurnLeft = {
  prefix: 'fas',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faFaceDiagonalMouth = {
  prefix: 'fas',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM372.4 319.4l-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faDiagramCells = {
  prefix: 'fas',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", "M512 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H64v64l384 0zm0 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64z"]
};
var faCricketBatBall = {
  prefix: 'fas',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-135 135L409 231c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-23 23H240c-8.8 0-16-7.2-16-16V126.1l23-23c9.4-9.4 24.6-9.4 33.9 0l41.4 41.4 135-135c12.5-12.5 32.8-12.5 45.3 0zM352 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM16.1 334L192 158.1V272c0 26.5 21.5 48 48 48H353.9L178 495.9c-10 10-24.4 16.7-40.4 15.6c-11.3-.8-28.6-2.8-46.4-8.2C73.9 498.2 54.1 489.1 39 473c-16.2-15-25.2-34.9-30.4-52.2C3.2 403 1.2 385.7 .5 374.4C-.6 358.4 6.1 344 16.1 334z"]
};
var faCricket = faCricketBatBall;
var faTents = {
  prefix: 'fas',
  iconName: 'tents',
  icon: [640, 512, [], "e582", "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H224V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faWandMagic = {
  prefix: 'fas',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"]
};
var faMagic = faWandMagic;
var faDog = {
  prefix: 'fas',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faPenLine = {
  prefix: 'fas',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-48.4 48.4L314.3 67.7l48.4-48.4c25-25 65.5-25 90.5 0zM58.6 323.5L291.7 90.3 421.7 220.3 188.5 453.4c-10.4 10.4-23.3 18-37.4 22.2L30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L36.4 360.9c4.2-14.1 11.8-27 22.2-37.4zM248 464H552c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faAtomSimple = {
  prefix: 'fas',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", "M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faAtomAlt = faAtomSimple;
var faAmpersand = {
  prefix: 'fas',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M180.7 96h38c20.6 0 37.3 16.7 37.3 37.3c0 11.8-5.5 22.8-14.9 29.9l-48 36-39-41.3c-6.4-6.8-10-15.8-10-25.2c0-20.3 16.4-36.7 36.7-36.7zm56.6 150l42.2-31.6C305 195.3 320 165.2 320 133.3C320 77.4 274.6 32 218.7 32h-38C125.1 32 80 77.1 80 132.7c0 25.7 9.8 50.4 27.5 69.1l34 36L74.7 288C47.8 308.1 32 339.8 32 373.3C32 432.2 79.8 480 138.7 480h74.5c37.4 0 72.4-18.7 93.2-49.9l6.9-10.4L360.7 470c12.1 12.8 32.4 13.4 45.2 1.3s13.4-32.4 1.3-45.2l-57.5-60.9 60.9-91.4c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9l-52.7 79.1L237.3 246zm-51.5 38.6L268.2 372l-15.1 22.6C244.2 408 229.2 416 213.2 416H138.7C115.1 416 96 396.9 96 373.3c0-13.4 6.3-26.1 17.1-34.1l72.7-54.5z"]
};
var faCarrot = {
  prefix: 'fas',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"]
};
var faArrowUpFromLine = {
  prefix: 'fas',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.3V208 320c0 17.7 14.3 32 32 32s32-14.3 32-32V208 141.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faArrowFromBottom = faArrowUpFromLine;
var faMoon = {
  prefix: 'fas',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"]
};
var faPenSlash = {
  prefix: 'fas',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l75.7-75.7L355.7 90.3l-91.5 91.5L38.8 5.1zm78 324.1c-6.6 6.6-11.5 14.8-14.1 23.8L65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1l94.4-94.4L195.8 250.3l-79 79zM426.7 19.3L378.3 67.7 508.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0z"]
};
var faWineGlassEmpty = {
  prefix: 'fas',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"]
};
var faWineGlassAlt = faWineGlassEmpty;
var faSquareStar = {
  prefix: 'fas',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 8c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L224 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
var faCheese = {
  prefix: 'fas',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"]
};
var faSendBackward = {
  prefix: 'fas',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64h64V224c0-53 43-96 96-96H352V64c0-35.3-28.7-64-64-64H64zM224 224H448V448H224V224zm-64 0V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"]
};
var faYinYang = {
  prefix: 'fas',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faMusic = {
  prefix: 'fas',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"]
};
var faCompassSlash = {
  prefix: 'fas',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9L38.8 5.1zM270.3 186.5l143.3-55.1c19.4-7.5 38.5 11.6 31 31L397.1 285.9 270.3 186.5zM320 512c55.2 0 106.3-17.5 148.1-47.2L317 345.8l-90.6 34.8c-19.4 7.5-38.5-11.6-31-31l29.4-76.5L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256z"]
};
var faClockOne = {
  prefix: 'fas',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v56.7l20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFileMusic = {
  prefix: 'fas',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm32 224v32V384c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V279.1l-96 36V416c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8V304 272c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z"]
};
var faCodeCommit = {
  prefix: 'fas',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"]
};
var faTemperatureLow = {
  prefix: 'fas',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"]
};
var faPersonBiking = {
  prefix: 'fas',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
var faBiking = faPersonBiking;
var faDisplayChartUpCircleCurrency = {
  prefix: 'fas',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V211.2c-19.5-10-41.1-16.4-64-18.5V64H64V352H320.7c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144H160c-17.7 0-32-14.3-32-32s14.3-32 32-32h69.3L240 416H64c-35.3 0-64-28.7-64-64V64zm480 56v72.7c-16.7 1.5-32.7 5.3-47.7 11.2c-.2-1.3-.3-2.6-.3-3.9V177.9L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L460.7 426c21.6 13.2 49.1 13.2 70.7 0z"]
};
var faSkeleton = {
  prefix: 'fas',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M256 0c17.7 0 32 14.3 32 32V64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H288v64c0 .8 0 1.6-.1 2.3l67.6-29c8.3-3.5 17.2-5.4 26.1-5.4c36.7 0 66.4 29.7 66.4 66.4v1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3H153.9c-16.6 0-32.4-6.6-44.1-18.3L83.9 467.9c-12.7-12.7-19.9-30-19.9-48v-1.5c0-36.7 29.7-66.4 66.4-66.4c9 0 17.9 1.8 26.1 5.4l67.6 29c-.1-.8-.1-1.5-.1-2.3V320H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V224H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H224V128H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H224V32c0-17.7 14.3-32 32-32zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
var faCircleG = {
  prefix: 'fas',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80z"]
};
var faCircleArrowUpLeft = {
  prefix: 'fas',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm64-368c13.3 0 24 10.7 24 24s-10.7 24-24 24H225.9L361 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24H320z"]
};
var faCoinBlank = {
  prefix: 'fas',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144s-114.6-144-256-144S0 128.5 0 208zm0 82.1L0 320c0 27.9 17.8 53.6 48 74.6L48 331c-18.3-11.5-34.8-25.2-48-40.9zM80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29L80 413zm128 32.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2l0-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4l0 64.1zm128-4.1c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29l0 64.3zm128-47c30.2-21 48-46.8 48-74.6l0-29.9c-13.2 15.6-29.7 29.3-48 40.9l0 63.7z"]
};
var faBroom = {
  prefix: 'fas',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"]
};
var faVacuum = {
  prefix: 'fas',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M301.6 64H512c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.8 52.8C513.8 148.1 467.2 128 416 128c-35.3 0-64 28.7-64 64V292c10.2-2.6 21-4 32-4c70.7 0 128 57.3 128 128c0 38.2-16.8 72.5-43.3 96H544c35.3 0 64-28.7 64-64V320c0-31.7-7.7-61.7-21.3-88C619 208.7 640 170.8 640 128C640 57.3 582.7 0 512 0H301.6C241.3 0 189.1 42.2 176.4 101.2L150.1 224h65.5L239 114.6C245.4 85.1 271.4 64 301.6 64zM208.7 256H143.3L109 416H83.8c-33.8 0-64.7 18.9-80 49C1.4 469.5 0 474.6 0 480c0 17.7 14.3 32 32 32h95.4c.4 0 .9 0 1.3 0H176c26.5 0 48-21.5 48-48s-21.5-48-48-48h-1.6l34.3-160zM480 416a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faShieldHeart = {
  prefix: 'fas',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
var faCardHeart = {
  prefix: 'fas',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z"]
};
var faLightbulbCflOn = {
  prefix: 'fas',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M351 24.2c4.3 17.1-6.1 34.5-23.3 38.8l-128 32c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l128-32c17.1-4.3 34.5 6.1 38.8 23.3zM455.8 127l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM479 184.2c4.3 17.1-6.1 34.5-23.3 38.8l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zM256 384V306l48-12v90h80c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H352c0 17.7-14.3 32-32 32s-32-14.3-32-32H256c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm199.8-65l-64 16L384 337v47H336V308.7c0-.5 0-.9 0-1.4V304l.2 0c1.6-12.7 10.8-23.7 24-27l16-4 64-16c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM53.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S42.3-3.3 53.3 4zM613.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM101.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm464-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z"]
};
var faMelon = {
  prefix: 'fas',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M256 512c-38.5 0-75-8.5-107.7-23.7c67.1-5.8 149.8-48.2 220.8-119.2s113.4-153.8 119.2-220.8C503.5 181 512 217.5 512 256c0 141.4-114.6 256-256 256zM74.7 436.8c-19.1-19.4-26.8-55.8-11.9-108c14.6-51.2 49.6-110.2 102.7-163.3s112.1-88.1 163.3-102.7c52.4-15 88.9-7.1 108.2 12.2s27.2 55.9 12.2 108.2c-14.6 51.2-49.6 110.2-102.7 163.3s-112.1 88.1-163.3 102.7c-52.1 14.9-88.6 7.2-108-11.9c-.2-.2-.4-.4-.5-.5zm-51-73.1C8.5 331 0 294.5 0 256C0 114.6 114.6 0 256 0c38.5 0 75 8.5 107.7 23.7c-67.1 5.8-149.8 48.2-220.8 119.2s-113.4 153.8-119.2 220.8z"]
};
var faGopuram = {
  prefix: 'fas',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faEarthOceania = {
  prefix: 'fas',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
var faGlobeOceania = faEarthOceania;
var faContainerStorage = {
  prefix: 'fas',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM176 152V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faFacePouting = {
  prefix: 'fas',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faSquareXmark = {
  prefix: 'fas',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faFaceExplode = {
  prefix: 'fas',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M320 196.5c0 7.9 2.5 15.4 7 21.6c-14.5-6.6-31.5-5.6-45.3 3l-17.3 10.8c-5.2 3.2-11.8 3.2-17 0L230.2 221c-13.8-8.6-30.8-9.6-45.3-3c4.5-6.2 7-13.7 7-21.6V192c0-17.7-14.3-32-32-32H120c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56H352c-17.7 0-32 14.3-32 32v4.5zM299 248c5.1-3 11.4-3 16.4 0h0c.1 .1 .2 .1 .3 .2L333 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0l20.7 12.9c12.8 8 28.6 9.5 42.7 4.1L512 253.5c0 .8 0 1.7 0 2.5c0 141.4-114.6 256-256 256S0 397.4 0 256c0-.8 0-1.7 0-2.5l30.5 11.7c14.1 5.4 29.9 3.9 42.7-4.1l20.7-12.9c5.2-3.2 11.8-3.2 17 0L128.2 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1 .2-.1 .3-.2h0c5.1-3 11.4-3 16.4 0h0c.1 .1 .2 .1 .3 .2L230.6 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1 .2-.1 .3-.2h0zm-90.6 88a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 437.3c0 5.9 4.8 10.7 10.7 10.7H309.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H245.3c-29.5 0-53.3 23.9-53.3 53.3z"]
};
var faExplodingHead = faFaceExplode;
var faHashtag = {
  prefix: 'fas',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"]
};
var faUpRightAndDownLeftFromCenter = {
  prefix: 'fas',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faOilCan = {
  prefix: 'fas',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"]
};
var faT = {
  prefix: 'fas',
  iconName: 't',
  icon: [384, 512, [116], "54", "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"]
};
var faTransformerBolt = {
  prefix: 'fas',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M136 24v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H112 64c-8.8 0-16-7.2-16-16s7.2-16 16-16H88V24C88 10.7 98.7 0 112 0s24 10.7 24 24zm160 0v8h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H272 224c-8.8 0-16-7.2-16-16s7.2-16 16-16h24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM48 112c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zm160 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zM0 192c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V224c-17.7 0-32-14.3-32-32zm232.9 34.7c-6-4-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4h57.8l-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H214.2l25-74.9c2.3-6.8-.3-14.3-6.3-18.3z"]
};
var faHippo = {
  prefix: 'fas',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faChartColumn = {
  prefix: 'fas',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faCassetteVhs = {
  prefix: 'fas',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", "M0 96v32H576V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160H0zM467.9 384H416V349.3c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3V224h51.9c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80zM160 349.3V384H108.1C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80H160v34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3zM256 224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32z"]
};
var faVhs = faCassetteVhs;
var faInfinity = {
  prefix: 'fas',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"]
};
var faVialCircleCheck = {
  prefix: 'fas',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faChimney = {
  prefix: 'fas',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64zM32 192h96V320H32V192zm384 0V320H160V192H416zM288 352V480H32V352H288zm128 0V480H320V352h96z"]
};
var faObjectIntersect = {
  prefix: 'fas',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M288 64v96H224c-35.3 0-64 28.7-64 64v64H64V64H288zM64 352h96v96c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H352V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64zM448 224V448H224V352h64c35.3 0 64-28.7 64-64V224h96z"]
};
var faPersonArrowDownToLine = {
  prefix: 'fas',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
var faVoicemail = {
  prefix: 'fas',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faBlockBrick = {
  prefix: 'fas',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M96 32v80H352V32H96zM64 112V32C28.7 32 0 60.7 0 96v16H64zM0 144v96H208V144H0zM0 368H64V272H0v96zm0 32v16c0 35.3 28.7 64 64 64H208V400H0zm240 0v80H384c35.3 0 64-28.7 64-64V400H240zm208-32V272H384v96h64zm-96 0V272H96v96H352zm96-224H240v96H448V144zm0-32V96c0-35.3-28.7-64-64-64v80h64z"]
};
var faWallBrick = faBlockBrick;
var faFan = {
  prefix: 'fas',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBagsShopping = {
  prefix: 'fas',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M176 96v64h96V96c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-48 64V96c0-53 43-96 96-96s96 43 96 96v64h64c35.3 0 64 28.7 64 64H240c-44.2 0-80 35.8-80 80V464c0 5.5 .6 10.8 1.6 16H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64zm128 96H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V320c0-35.3 28.7-64 64-64zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 35.3-28.7 64-64 64s-64-28.7-64-64V336z"]
};
var faParagraphLeft = {
  prefix: 'fas',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", "M320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 144C82.1 0 32 50.1 32 112s50.1 112 112 112h16l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224h32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM128 384V337.6c0-9.7-7.9-17.6-17.6-17.6c-4.2 0-8.2 1.5-11.3 4.2l-93 78.7C2.2 406.1 0 410.9 0 416s2.2 9.9 6.1 13.2l93 78.7c3.2 2.7 7.2 4.2 11.3 4.2c9.7 0 17.6-7.9 17.6-17.6V448H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]
};
var faParagraphRtl = faParagraphLeft;
var faPersonWalkingLuggage = {
  prefix: 'fas',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"]
};
var faCaravanSimple = {
  prefix: 'fas',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M80 32C35.8 32 0 67.8 0 112V336c0 44.2 35.8 80 80 80H96c0 53 43 96 96 96s96-43 96-96H576l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V192c0-88.4-71.6-160-160-160H80zM64 160c0-17.7 14.3-32 32-32H224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160zm288-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM144 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faCaravanAlt = faCaravanSimple;
var faTurtle = {
  prefix: 'fas',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M384 249.2c0 21.4-17.4 38.8-38.8 38.8H70.8C49.4 288 32 270.6 32 249.2V208c0-97.2 78.8-176 176-176s176 78.8 176 176v41.2zM480 288c-2 0-4-.1-5.9-.3c-16.3 53.3-64.3 92.7-122.1 96V440c0 22.1-17.9 40-40 40H264c-22.1 0-40-17.9-40-40V384H192v56c0 22.1-17.9 40-40 40H104c-22.1 0-40-17.9-40-40V384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h72 48H264h48 32c39.8 0 72-32.2 72-72V224 192 176c0-35.3 28.7-64 64-64c53 0 96 43 96 96v16c0 35.3-28.7 64-64 64H480zm16-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faPencilMechanical = {
  prefix: 'fas',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", "M475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L390.6 41.4l80 80 30.1-30.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3L475.3 11.3zm-233 76.3c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2C67 333 62.8 340.1 60.6 348L32.8 445.3 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7L164 451.4c7.8-2.2 15-6.4 20.8-12.2L436.7 187.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L379.3 75.3C372.1 68.1 362.2 64 352 64s-20.1 4.1-27.3 11.3L317 83 287.6 53.7c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6zM89.1 422.9l17.3-60.5 43.2 43.2L89.1 422.9z"]
};
var faUpDown = {
  prefix: 'fas',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"]
};
var faArrowsAltV = faUpDown;
var faCloudMoonRain = {
  prefix: 'fas',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"]
};
var faBoothCurtain = {
  prefix: 'fas',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", "M64 0C28.7 0 0 28.7 0 64V480c0 17.7 14.3 32 32 32s32-14.3 32-32V64l64 0V0H64zM512 64c0-35.3-28.7-64-64-64H352 256 192c-17.7 0-32 14.3-32 32V400c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48v80c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"]
};
var faCalendar = {
  prefix: 'fas',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"]
};
var faBoxHeart = {
  prefix: 'fas',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M93.7 32H208V160H0L50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32H354.3c18.2 0 34.8 10.3 42.9 26.5L448 160H240V32zM0 192H448V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zM212.7 420.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 283.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z"]
};
var faTrailer = {
  prefix: 'fas',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faUserDoctorMessage = {
  prefix: 'fas',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3c0-81 54-149.4 128-171.1v59.1c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7V304.9c6-.6 12.1-.9 18.3-.9h91.4c6.2 0 12.3 .3 18.3 .9V362c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16V424c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V424c0-29.8-20.4-54.9-48-62V311.2c74 21.7 128 90.1 128 171.1c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM432 0H592c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H544l-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2V224H432c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48z"]
};
var faUserMdChat = faUserDoctorMessage;
var faBahai = {
  prefix: 'fas',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"]
};
var faHaykal = faBahai;
var faLighthouse = {
  prefix: 'fas',
  iconName: 'lighthouse',
  icon: [640, 512, [], "e612", "M33.5 1.9l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48C2.4 40.8-3.3 26.7 1.9 14.6S21.3-3.3 33.5 1.9zm112 204.1l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5zM303.9 4.4c10-5.8 22.3-5.8 32.2 0l96 56c15.3 8.9 20.4 28.5 11.5 43.8C437.7 114.3 427 120 416 120v40c17.7 0 32 14.3 32 32c0 13.3-8.1 24.7-19.7 29.5L473.6 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H450.9 352V448c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H189.1 160c-17.7 0-32-14.3-32-32s14.3-32 32-32h6.4l45.3-226.5C200.1 216.7 192 205.3 192 192c0-17.7 14.3-32 32-32h0V120c-11 0-21.7-5.7-27.6-15.9c-8.9-15.3-3.7-34.9 11.5-43.8l96-56zM352 87.7L320 69.1 288 87.7V160h64V87.7zM638.1 14.6c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6zm-156.1 160c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5z"]
};
var faAmpGuitar = {
  prefix: 'fas',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M256 0c-48.9 0-92.5 28.8-121.6 53.8c-15 12.9-27.3 25.7-35.8 35.3c-2.3 2.6-4.3 4.9-6 6.9H64C28.7 96 0 124.7 0 160V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H419.5c-1.7-2.1-3.8-4.4-6-6.9c-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0zm96.9 96H159.1c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 448V256H448V448H64zm64-128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM384 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faSdCard = {
  prefix: 'fas',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faVolumeSlash = {
  prefix: 'fas',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L197.8 129.8 38.8 5.1zM352 373.3L82.9 161.3C53.8 167.4 32 193.1 32 224v64c0 35.3 28.7 64 64 64h67.8L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448V373.3z"]
};
var faBorderBottom = {
  prefix: 'fas',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zm-64-96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0A32 32 0 1 1 0 160zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faWifiWeak = {
  prefix: 'fas',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", "M256 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
var faWifi1 = faWifiWeak;
var faDragon = {
  prefix: 'fas',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"]
};
var faShoePrints = {
  prefix: 'fas',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"]
};
var faCirclePlus = {
  prefix: 'fas',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faPlusCircle = faCirclePlus;
var faFaceGrinTongueWink = {
  prefix: 'fas',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faHandHolding = {
  prefix: 'fas',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .1 .5 .5 0 1 1 .9-.1z"]
};
var faPlugCircleExclamation = {
  prefix: 'fas',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"]
};
var faLinkSlash = {
  prefix: 'fas',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faClone = {
  prefix: 'fas',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"]
};
var faPersonWalkingArrowLoopLeft = {
  prefix: 'fas',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"]
};
var faArrowUpZA = {
  prefix: 'fas',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faFireFlameCurved = {
  prefix: 'fas',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"]
};
var faFireAlt = faFireFlameCurved;
var faTornado = {
  prefix: 'fas',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"]
};
var faFileCirclePlus = {
  prefix: 'fas',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"]
};
var faDeleteRight = {
  prefix: 'fas',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", "M0 128C0 92.7 28.7 64 64 64H370.7c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V128zm143 47c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
var faBookQuran = {
  prefix: 'fas',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"]
};
var faQuran = faBookQuran;
var faCircleQuarter = {
  prefix: 'fas',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M32 256C14.3 256-.2 241.6 2 224.1C16.4 108.2 108.2 16.4 224.1 2C241.6-.2 256 14.3 256 32V224c0 17.7-14.3 32-32 32L32 256z"]
};
var faAnchor = {
  prefix: 'fas',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"]
};
var faBorderAll = {
  prefix: 'fas',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"]
};
var faFunction = {
  prefix: 'fas',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M64 96c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32 14.3-32 32v96h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V383.5c0 48.4-36.1 89.3-84.1 95.3l-7.9 1C18.4 481.9 2.4 469.5 .2 452s10.2-33.5 27.8-35.7l7.9-1c16-2 28-15.6 28-31.8V256H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V96zm266.7 81.7C303.7 218.4 288 267.3 288 320s15.7 101.6 42.7 142.3c9.8 14.7 5.7 34.6-9 44.3s-34.6 5.7-44.3-9C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7c9.8-14.7 29.6-18.8 44.3-9s18.8 29.6 9 44.3zm202.6 0c-9.8-14.7-5.7-34.6 9-44.3s34.6-5.7 44.3 9C620.4 193.3 640 254.4 640 320s-19.6 126.7-53.3 177.7c-9.8 14.7-29.6 18.8-44.3 9s-18.8-29.6-9-44.3c27-40.7 42.7-89.6 42.7-142.3s-15.7-101.6-42.7-142.3zM398.6 241.4L432 274.7l33.4-33.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L477.3 320l33.4 33.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L432 365.3l-33.4 33.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L386.7 320l-33.4-33.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"]
};
var faFaceAngry = {
  prefix: 'fas',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
var faAngry = faFaceAngry;
var faPeopleSimple = {
  prefix: 'fas',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160H105.6zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8H320v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V384h21.6c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.9-27.5-33-46.4-61.5-46.4H368.3z"]
};
var faCookieBite = {
  prefix: 'fas',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faArrowTrendDown = {
  prefix: 'fas',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"]
};
var faRss = {
  prefix: 'fas',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faFeed = faRss;
var faFaceMonocle = {
  prefix: 'fas',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M427.2 446.3C381.9 487.2 321.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 62.8-22.6 120.3-60.1 164.9c-2.5-8.6-3.9-17.7-3.9-26.9V224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6v91.5c0 18.4 3.9 36.2 11.2 52.4zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336c-8.8 0-16 7.2-16 16zM305.2 89.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L376.3 61c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z"]
};
var faDrawPolygon = {
  prefix: 'fas',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"]
};
var faScaleBalanced = {
  prefix: 'fas',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"]
};
var faBalanceScale = faScaleBalanced;
var faCalendarLines = {
  prefix: 'fas',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM96 296c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24zm24 72H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faCalendarNote = faCalendarLines;
var faArrowDownBigSmall = {
  prefix: 'fas',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM320 368v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48zM368 32c-26.5 0-48 21.5-48 48V208c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368z"]
};
var faSortSizeDown = faArrowDownBigSmall;
var faGaugeSimpleHigh = {
  prefix: 'fas',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faDoNotEnter = {
  prefix: 'fas',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96 208H416c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16z"]
};
var faShower = {
  prefix: 'fas',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faDiceD8 = {
  prefix: 'fas',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", "M240 16c0-6.5-4-12.4-10-14.8s-13-1-17.5 3.7l-208 216c-3.7 3.9-5.3 9.3-4.1 14.6s4.9 9.5 9.9 11.5l208 80c4.9 1.9 10.5 1.2 14.8-1.7s6.9-7.9 6.9-13.2V16zM34.6 307.5c-4.1 6.3-3.3 14.6 1.9 20l176 179.7c4.5 4.6 11.5 6.1 17.5 3.6s10-8.3 10-14.8V384c0-6.6-4.1-12.6-10.3-14.9l-176-67.7c-7-2.7-15-.1-19.1 6.1zm442.7 0c-4.1-6.3-12.1-8.8-19.1-6.1l-176 67.7c-6.2 2.4-10.3 8.3-10.3 14.9V496c0 6.5 3.9 12.4 10 14.8s12.9 1 17.5-3.6l176-179.7c5.3-5.4 6.1-13.7 1.9-20zM282 1.2C276 3.6 272 9.5 272 16V312c0 5.3 2.6 10.2 6.9 13.2s9.9 3.6 14.8 1.7l208-80c5-1.9 8.7-6.2 9.9-11.5s-.4-10.7-4.1-14.6l-208-216C295 .2 288.1-1.3 282 1.2z"]
};
var faDesktop = {
  prefix: 'fas',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"]
};
var faDesktopAlt = faDesktop;
var faM = {
  prefix: 'fas',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"]
};
var faGripDotsVertical = {
  prefix: 'fas',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 416A48 48 0 1 0 0 416a48 48 0 1 0 96 0zM208 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
var faFaceViewfinder = {
  prefix: 'fas',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M56 0h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-4.4 0-8 3.6-8 8v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56C0 25.1 25.1 0 56 0zM376 0h80c30.9 0 56 25.1 56 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-4.4-3.6-8-8-8H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376v80c0 4.4 3.6 8 8 8h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-30.9 0-56-25.1-56-56V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0v80c0 30.9-25.1 56-56 56H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c4.4 0 8-3.6 8-8V376c0-13.3 10.7-24 24-24s24 10.7 24 24zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zm128-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM169.9 292.5c-6.4 6.1-6.6 16.2-.5 22.6C191.2 337.8 222 352 256 352s64.8-14.2 86.6-36.9c6.1-6.4 5.9-16.5-.5-22.6s-16.5-5.9-22.6 .5C303.5 309.6 281 320 256 320s-47.5-10.4-63.5-27.1c-6.1-6.4-16.2-6.6-22.6-.5z"]
};
var faSoftServe = {
  prefix: 'fas',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M208 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C208 56 200 64 190.1 64H128c-35.3 0-64 28.7-64 64c0 11.8 3.2 22.9 8.8 32.4C40.8 164 16 191.1 16 224c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64s-28.7-64-64-64h-2.3c11.5-14.4 18.3-32.7 18.3-52.6C320 48.1 271.9 0 212.6 0H208zM48 320v32c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5H259.4c16.3 0 30-12.3 31.8-28.5L302.2 384H304c17.7 0 32-14.3 32-32V320H48z"]
};
var faCreemee = faSoftServe;
var faH5 = {
  prefix: 'fas',
  iconName: 'h5',
  icon: [640, 512, [], "e412", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM432 64c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4 .4 19.3 6.5 26.8s15.2 11.8 24.8 11.8H524c28.7 0 52 23.3 52 52s-23.3 52-52 52H456.4c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2H524c64.1 0 116-51.9 116-116s-51.9-116-116-116H439.4L458 128H576c17.7 0 32-14.3 32-32s-14.3-32-32-32H432z"]
};
var faHandBackPointDown = {
  prefix: 'fas',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M136 512c-22.1 0-40-17.9-40-40V272v-7V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v55.7c-2-1.4-3.9-3-5.8-4.5L39 227.2C24.4 215 16 197 16 178V140c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0H288c70.7 0 128 57.3 128 128v64 32c0 26.5-21.5 48-48 48c-12.4 0-23.6-4.7-32.1-12.3C334 284.5 313.3 304 288 304c-12.4 0-23.6-4.7-32.1-12.3C254 316.5 233.3 336 208 336c-12.3 0-23.5-4.6-32-12.2V472c0 22.1-17.9 40-40 40z"]
};
var faTableList = {
  prefix: 'fas',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"]
};
var faThList = faTableList;
var faCommentSms = {
  prefix: 'fas',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"]
};
var faSms = faCommentSms;
var faRectangle = {
  prefix: 'fas',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faRectangleLandscape = faRectangle;
var faClipboardListCheck = {
  prefix: 'fas',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-4.7 132.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 249.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM192 272c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-16 80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faTurkey = {
  prefix: 'fas',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.4 .2-.7 .4-1 .6l-28.3 20c-8.3 5.9-15.1 15-21.2 28.3c-6.1 13.4-10.5 28.6-15.4 46l-.3 1c-7.9 27.5-24 53-47.9 72.3c-61.8 50-152.5 40.5-202.5-21.4c-13.9-17.2-23.2-36.6-28.1-56.7c-2.3-9.4 5.3-17.9 15-17.9c8 0 14.6 5.8 16.9 13.5c4 14.5 10.9 28.5 21 41c21.3 26.3 52.1 40.5 83.5 41.5c25.9 .8 52.2-7.3 74-24.9c18.6-15 31.1-34.8 37.2-56.2l.6-2c9.6-33.7 20.1-70.5 48.7-90.6L486.7 192s0 0 0 0l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56z"]
};
var faBook = {
  prefix: 'fas',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faUserPlus = {
  prefix: 'fas',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
var faIceSkate = {
  prefix: 'fas',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M512 336c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V132.2c0-21.4 14.2-40.3 34.8-46.2L256 32c0-17.7 14.3-32 32-32s32 14.3 32 32V96H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 232.5 512 270.9 512 315v21zm40 72c13.3 0 24 10.7 24 24v8c0 39.8-32.2 72-72 72H408 120 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96V416h48v48H384V416h48v48h72c13.3 0 24-10.7 24-24v-8c0-13.3 10.7-24 24-24z"]
};
var faCheck = {
  prefix: 'fas',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};
var faBatteryThreeQuarters = {
  prefix: 'fas',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"]
};
var faBattery4 = faBatteryThreeQuarters;
var faTomato = {
  prefix: 'fas',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M241 7L224 24C241 7 241 7 241 7l0 0 0 0 .1 .1 .2 .2 .5 .5c.4 .4 1 1 1.7 1.8c1.4 1.5 3.2 3.6 5.4 6.3c4.4 5.4 10.1 13.1 15.8 22.8c6.6 11.2 13.4 25.5 18 42.1c45.7 3.1 88.5 14.2 125.1 32.8c6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3H365.9l15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4 150.3 190.7c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4c-4-7.9-.9-17.5 7-21.5l.8-.4C142.2 94.6 185.6 83.5 232 80.7c-2.6-6.4-5.6-12.3-8.7-17.6c-4.3-7.3-8.6-13-11.7-16.9c-1.6-1.9-2.8-3.4-3.6-4.3c-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5c-.6 11.8 3.1 23.7 11 33.2c13.6 16.3 36.3 21.8 55.8 13.4L256 180.2l93.1 39.9c19.5 8.4 42.2 2.9 55.8-13.4c7.9-9.5 11.7-21.5 11-33.2c10.3-3.5 19.1-10.4 25-19.5c44 35.5 71.1 86.4 71.1 150c0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z"]
};
var faSwordLaser = {
  prefix: 'fas',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", "M505 7c9.1 9.1 9.4 23.7 .7 33.2L285.2 281.3l-54.4-54.4L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7zM195.3 236.7l80 80c6.2 6.2 6.2 16.4 0 22.6c-6.1 6.1-15.8 6.2-22.1 .5l-81-81c-5.8-6.3-5.6-16 .5-22.1c6.2-6.2 16.4-6.2 22.6 0zm-57.7 57.7l23.7-23.7 80 80-23.7 23.7-80-80zm-11.3 11.3l80 80-20.7 20.7-80-80 20.7-20.7zM87 330.3L181.7 425l-2.3 2.3L105 501.7C98.3 508.3 89.4 512 80 512s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l74.3-74.3 2.3-2.3z"]
};
var faHouseCircleCheck = {
  prefix: 'fas',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
var faBuildings = {
  prefix: 'fas',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M256 0c-35.3 0-64 28.7-64 64v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256 448c35.3 0 64-28.7 64-64V192 64c0-35.3-28.7-64-64-64H256zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V304zm208 16c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272zm112-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 192h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V80zM400 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM256 208V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400z"]
};
var faAngleLeft = {
  prefix: 'fas',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
};
var faCartFlatbedBoxes = {
  prefix: 'fas',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM224 32c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224zM416 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32zm32 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448z"]
};
var faDollyFlatbedAlt = faCartFlatbedBoxes;
var faDiagramSuccessor = {
  prefix: 'fas',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"]
};
var faTruckArrowRight = {
  prefix: 'fas',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"]
};
var faSquareW = {
  prefix: 'fas',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm54.9 136.7L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 254.7 182.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"]
};
var faArrowsSplitUpAndLeft = {
  prefix: 'fas',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"]
};
var faLamp = {
  prefix: 'fas',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M82.5 19.7C87.4 7.8 99.1 0 112 0H336c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 288H288v32s64 50.5 64 112c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-61.5 64-112 64-112V288z"]
};
var faAirplay = {
  prefix: 'fas',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", "M480 96H96c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h69.5l-50.7 50.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L410.5 352H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM265.4 297.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
};
var faHandFist = {
  prefix: 'fas',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", "M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"]
};
var faFistRaised = faHandFist;
var faShieldQuartered = {
  prefix: 'fas',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM80 141.4L256 66.8V224H90.1c-6.9-30-9.8-58.5-10.1-82.6zM256 444.8V224H422c-18.5 80.5-65.5 172.2-166 220.8z"]
};
var faSlashForward = {
  prefix: 'fas',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", "M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9S-4.6 479.5 4.2 464.1l256-448C269 .8 288.5-4.6 303.9 4.2z"]
};
var faLocationPen = {
  prefix: 'fas',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L208.6 122 223.5 107c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5L186 144.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
var faMapMarkerEdit = faLocationPen;
var faCloudMoon = {
  prefix: 'fas',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faPotFood = {
  prefix: 'fas',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24C64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80H324.6c13.8-46.3 56.6-80 107.4-80zM77.7 320H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H65.9c-.2-17.5 14-32 31.7-32H542.4c17.7 0 31.9 14.5 31.7 32H592c17.7 0 32 14.3 32 32s-14.3 32-32 32H562.3c-20.6 64-66.1 116.7-124.7 147.2l-1.2 9.7c-2.5 20-19.5 35-39.7 35H243.3c-20.2 0-37.2-15-39.7-35l-1.2-9.7C143.8 436.7 98.3 384 77.7 320z"]
};
var faBriefcase = {
  prefix: 'fas',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"]
};
var faPersonFalling = {
  prefix: 'fas',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
var faImagePortrait = {
  prefix: 'fas',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"]
};
var faPortrait = faImagePortrait;
var faUserTag = {
  prefix: 'fas',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
var faRug = {
  prefix: 'fas',
  iconName: 'rug',
  icon: [640, 512, [], "e569", "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"]
};
var faPrintSlash = {
  prefix: 'fas',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L522.2 384H544c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H277.2L192 125.2V64H418.7L448 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0H192c-35.3 0-64 28.7-64 64V75L38.8 5.1zm459 483.1l-51-40.2H192V384 368 352H324.9L122.2 192.3C89.6 195.2 64 222.6 64 256v96c0 17.7 14.3 32 32 32h32v64c0 35.3 28.7 64 64 64H448c20.1 0 38.1-9.3 49.8-23.8zM496 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faEarthEurope = {
  prefix: 'fas',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faGlobeEurope = faEarthEurope;
var faCartFlatbedSuitcase = {
  prefix: 'fas',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faHandBackPointRibbon = {
  prefix: 'fas',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M112 128H43.8c-6.5 0-11.8-5.3-11.8-11.8c0-3.9 1.9-7.5 5.1-9.7L75.6 80 37.1 53.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 37.3 37.3 32 43.8 32h69C116.5 13.7 132.6 0 152 0c22.1 0 40 17.9 40 40v8 64 16H176 112zm0 112V160h80v28.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v32 64c0 70.7-57.3 128-128 128H185.9c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C48.9 446.1 32 410 32 372V334c0-19 8.4-37 23-49.2l19.2-16c1.9-1.6 3.8-3.1 5.8-4.5V320c0 8.8 7.2 16 16 16s16-7.2 16-16V247v-7z"]
};
var faRectangleXmark = {
  prefix: 'fas',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faTireRugged = {
  prefix: 'fas',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M320 24c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24V40c0 .4 0 .8 0 1.3c-14.9 4.4-29.2 10.4-42.6 17.7c-.3-.3-.6-.6-.9-.9L137.2 46.7c-9.4-9.4-24.6-9.4-33.9 0L46.7 103.3c-9.4 9.4-9.4 24.6 0 33.9L58 148.5c.3 .3 .6 .6 .9 .9c-7.3 13.4-13.2 27.7-17.7 42.6c-.4 0-.8 0-1.3 0H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24H40c.4 0 .8 0 1.3 0c4.4 14.9 10.4 29.2 17.7 42.6c-.3 .3-.6 .6-.9 .9L46.7 374.8c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0L148.5 454c.3-.3 .6-.6 .9-.9c13.4 7.3 27.7 13.2 42.6 17.7c0 .4 0 .8 0 1.3v16c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V472c0-.4 0-.8 0-1.3c14.9-4.4 29.2-10.4 42.6-17.7c.3 .3 .6 .6 .9 .9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9L454 363.5c-.3-.3-.6-.6-.9-.9c7.3-13.4 13.2-27.7 17.7-42.6c.4 0 .8 0 1.3 0h16c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H472c-.4 0-.8 0-1.3 0c-4.4-14.9-10.4-29.2-17.7-42.6c.3-.3 .6-.6 .9-.9l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9L408.7 46.7c-9.4-9.4-24.6-9.4-33.9 0L363.5 58c-.3 .3-.6 .6-.9 .9c-13.4-7.3-27.7-13.2-42.6-17.7c0-.4 0-.8 0-1.3V24zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-61.1 2.9a24 24 0 1 0 -14.8 45.7 24 24 0 1 0 14.8-45.7zm106.7 30.2a24 24 0 1 0 45.7-14.8 24 24 0 1 0 -45.7 14.8zm-22.7 87.2a24 24 0 1 0 38.8-28.2 24 24 0 1 0 -38.8 28.2zm-51.1-33.5a24 24 0 1 0 -28.2 38.8 24 24 0 1 0 28.2-38.8z"]
};
var faLightbulbDollar = {
  prefix: 'fas',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM212 88v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V296c0 11-9 20-20 20s-20-9-20-20V281.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V88c0-11 9-20 20-20s20 9 20 20z"]
};
var faCowbell = {
  prefix: 'fas',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", "M112 96h16V40c0-22.1 17.9-40 40-40H280c22.1 0 40 17.9 40 40V96h16c21.4 0 40.3 14.2 46.2 34.8l64 224c4.1 14.5 1.2 30.1-7.8 42.1s-23.3 19.1-38.3 19.1H48c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zm160 0V48H176V96h96zm16 352c0 35.3-28.7 64-64 64s-64-28.7-64-64H288z"]
};
var faBahtSign = {
  prefix: 'fas',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"]
};
var faCorner = {
  prefix: 'fas',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", "M0 192c0-17.7 14.3-32 32-32H384c35.3 0 64 28.7 64 64V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"]
};
var faChevronsRight = {
  prefix: 'fas',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"]
};
var faChevronDoubleRight = faChevronsRight;
var faBookOpen = {
  prefix: 'fas',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"]
};
var faBookJournalWhills = {
  prefix: 'fas',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"]
};
var faJournalWhills = faBookJournalWhills;
var faInhaler = {
  prefix: 'fas',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", "M429.8 32.7c-12.7-3.2-25.6 4.4-29 17l-14 51.8L533.2 248 575.2 94.3c1.7-6.2 .8-12.9-2.4-18.4s-8.6-9.6-14.9-11.2l-128-32zM534.1 305.5c1.5-5.5-.1-11.5-4.1-15.5L383.8 143.8c-8.7-8.7-23.6-4.7-26.8 7.2l-16.5 61.2c-1.9 7-8.2 11.8-15.4 11.8H232c-22.1 0-40 17.9-40 40V440c0 22.1 17.9 40 40 40H456c18 0 33.8-12.1 38.6-29.5l39.5-145zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zm0 96A32 32 0 1 0 0 352a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faHandcuffs = {
  prefix: 'fas',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSnake = {
  prefix: 'fas',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M483.4 65.7L403.6 25.8c-30.8-15.4-68-9.4-92.3 15L288 64H176C96.5 64 32 128.5 32 208s64.5 144 144 144H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H256.1l-.1 0H111.6c-10.3 0-20.6 1.7-30.4 4.9l-66 22C6.1 446 0 454.4 0 464s6.1 18 15.2 21.1l66 22c9.8 3.3 20 4.9 30.4 4.9h64.3l.1 0H320c70.7 0 128-57.3 128-128s-57.3-128-128-128H176c-26.5 0-48-21.5-48-48s21.5-48 48-48H288l23.2 23.2c24.3 24.3 61.5 30.4 92.3 15l79.8-39.9c17.5-8.8 28.6-26.7 28.6-46.3s-11.1-37.5-28.6-46.3zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTriangleExclamation = {
  prefix: 'fas',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faNoteMedical = {
  prefix: 'fas',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320H336c-26.5 0-48 21.5-48 48V480H64c-35.3 0-64-28.7-64-64V96zM402.7 352H448l-32 32-64 64-32 32V434.7 368c0-8.8 7.2-16 16-16h66.7zM192 144v48H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H256V144c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16z"]
};
var faDatabase = {
  prefix: 'fas',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"]
};
var faDownLeft = {
  prefix: 'fas',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", "M48 432H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-72-72L372.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L331.3 75.3C324.1 68.1 314.2 64 304 64s-20.1 4.1-27.3 11.3L142.6 209.4l-72-72c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6V400c0 17.7 14.3 32 32 32z"]
};
var faShare = {
  prefix: 'fas',
  iconName: 'share',
  icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]
};
var faArrowTurnRight = faShare;
var faMailForward = faShare;
var faFaceThinking = {
  prefix: 'fas',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M512 256c0 141.4-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13c23.9-8.7 38.3-32 36.8-56.1c-1.3-24.4-16.5-46.1-39.2-55.6L166.2 257.3c-8.1-3.4-17.5 .4-21 8.5s.4 17.5 8.5 21l82.4 34.7L144 355v-3c0-30.9-25.1-56-56-56s-56 25.1-56 56v28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM112 352v48.6l151.8-55.2c12.5-4.5 26.2 1.9 30.8 14.4s-1.9 26.2-14.4 30.8l-49.8 18.1-26.1 71.7c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faTurnDownRight = {
  prefix: 'fas',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M334.5 446c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 88-192 0c-17.7 0-32-14.3-32-32L96 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64L0 208c0 70.7 57.3 128 128 128l192 0 0 88c0 9.6 5.7 18.2 14.5 22z"]
};
var faBottleDroplet = {
  prefix: 'fas',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"]
};
var faMaskFace = {
  prefix: 'fas',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
};
var faHillRockslide = {
  prefix: 'fas',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faScannerKeyboard = {
  prefix: 'fas',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M152 0h16c13.3 0 24 10.7 24 24V64H128V24c0-13.3 10.7-24 24-24zM312 0h16c13.3 0 24 10.7 24 24V64H288V24c0-13.3 10.7-24 24-24zM224 16c0-8.8 7.2-16 16-16s16 7.2 16 16V64H224V16zM400 0c8.8 0 16 7.2 16 16V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24H472c-13.3 0-24-10.7-24-24V24zM0 160c0-35.3 28.7-64 64-64H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm64 24v16c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24V184c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm0 120v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80zm112-80v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208z"]
};
var faCircleO = {
  prefix: 'fas',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
var faGridHorizontal = {
  prefix: 'fas',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", "M128 168c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V168zm0 160c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-160v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V168c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"]
};
var faMessageDollar = {
  prefix: 'fas',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm276 40c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]
};
var faCommentAltDollar = faMessageDollar;
var faRightLeft = {
  prefix: 'fas',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"]
};
var faExchangeAlt = faRightLeft;
var faColumns3 = {
  prefix: 'fas',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 96V416H64V96H192zm64 0H384V416H256V96zm320 0V416H448V96H576z"]
};
var faPaperPlane = {
  prefix: 'fas',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"]
};
var faRoadCircleExclamation = {
  prefix: 'fas',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"]
};
var faDungeon = {
  prefix: 'fas',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"]
};
var faHandHoldingBox = {
  prefix: 'fas',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M224 121.7c0 3.5 2.8 6.3 6.3 6.3c1.1 0 2.2-.3 3.1-.8l46.6-26.6c4.9-2.8 11-2.8 15.9 0l46.6 26.6c1 .5 2 .8 3.1 .8c3.5 0 6.3-2.8 6.3-6.3V0h80c26.5 0 48 21.5 48 48V208c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h80V121.7zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
};
var faInputText = {
  prefix: 'fas',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", "M64 128V384H576V128H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7H146.3l-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280h32.8L184 243.1zM304 184c0-13.3 10.7-24 24-24h52c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60H328c-13.3 0-24-10.7-24-24v-8V256 192v-8zm48 24v24h28c6.6 0 12-5.4 12-12s-5.4-12-12-12H352zm0 96h44c6.6 0 12-5.4 12-12s-5.4-12-12-12H380 352v24z"]
};
var faWindowFlip = {
  prefix: 'fas',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faWindowAlt = faWindowFlip;
var faAlignRight = {
  prefix: 'fas',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
};
var faScannerGun = {
  prefix: 'fas',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M112 32C50.1 32 0 82.1 0 144c0 50.7 33.8 93.6 80 107.4L8.1 374.7c-13.3 22.8-5.7 52.2 17.1 65.6l53.4 31.4c22.8 13.4 52.3 5.8 65.7-17L261.2 256H304c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H112zm328 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H440zM416 216v16c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H440c-13.3 0-24 10.7-24 24zm24 200c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24H552c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H440zM416 144c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16zm16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm-16 80c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16z"]
};
var faScanner = faScannerGun;
var faTire = {
  prefix: 'fas',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-16.1 62l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6zm47.9-58l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-40.2-63.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5zM168.3 162.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7zm33.7 127.7l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"]
};
var faEngine = {
  prefix: 'fas',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24H208c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0v32H208 160 128c-17.7 0-32 14.3-32 32v56H48V160c0-13.3-10.7-24-24-24s-24 10.7-24 24V352c0 13.3 10.7 24 24 24s24-10.7 24-24V280H96v72c0 17.7 14.3 32 32 32h44.8l32 40c12.1 15.2 30.5 24 50 24H448c35.3 0 64-28.7 64-64V238.8c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14H328V112l72 0zM544 224V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H576c-17.7 0-32 14.3-32 32zm-256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faMoneyBill1Wave = {
  prefix: 'fas',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLifeRing = {
  prefix: 'fas',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
var faHands = {
  prefix: 'fas',
  iconName: 'hands',
  icon: [576, 512, ["sign-language", "signing"], "f2a7", "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faCircleCaretRight = {
  prefix: 'fas',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 0c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"]
};
var faCaretCircleRight = faCircleCaretRight;
var faWheat = {
  prefix: 'fas',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", "M472 0c-48.6 0-88 39.4-88 88v24c0 8.8 7.2 16 16 16h24c48.6 0 88-39.4 88-88V16c0-8.8-7.2-16-16-16H472zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L305.5 27.3z"]
};
var faFileSpreadsheet = {
  prefix: 'fas',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM88 224H296c17.7 0 32 14.3 32 32v16 80 64c0 17.7-14.3 32-32 32H232 152 88c-17.7 0-32-14.3-32-32V352 272 256c0-17.7 14.3-32 32-32zm0 112h48V288H88v48zm80 0h48V288H168v48zm80 0h48V288H248v48zm0 32v48h48V368H248zm-32 0H168v48h48V368zm-80 0H88v48h48V368z"]
};
var faAudioDescriptionSlash = {
  prefix: 'fas',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6V96c0-35.3-28.7-64-64-64H96c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM336 238V184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96c0 35.3-19 66.1-47.4 82.8l-44.6-35c24.7-2 44.1-22.7 44.1-47.8c0-26.5-21.5-48-48-48H384v67.7L336 238zM487.4 480L314.3 343.6c-2 2.4-4.6 4.4-7.5 5.9c-11.9 5.9-26.3 1.1-32.2-10.7l-9.4-18.9H182.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l42.5-85L32 121.2V416c0 35.3 28.7 64 64 64H487.4zm-254-200.2l-21.8-17.2-8.6 17.2h30.4z"]
};
var faCalendarDay = {
  prefix: 'fas',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"]
};
var faWaterLadder = {
  prefix: 'fas',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faArrowsUpDown = {
  prefix: 'fas',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"]
};
var faArrowsV = faArrowsUpDown;
var faChessPawnPiece = {
  prefix: 'fas',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", "M176 240c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h5.7L64 384H192l-13.7-96H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8zM4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48L4.8 473.6z"]
};
var faChessPawnAlt = faChessPawnPiece;
var faFaceGrimace = {
  prefix: 'fas',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faGrimace = faFaceGrimace;
var faWheelchairMove = {
  prefix: 'fas',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
var faWheelchairAlt = faWheelchairMove;
var faTurnDown = {
  prefix: 'fas',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"]
};
var faLevelDownAlt = faTurnDown;
var faSquareS = {
  prefix: 'fas',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
var faRectangleBarcode = {
  prefix: 'fas',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 96c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm88-16c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm88 24c0-13.3 10.7-24 24-24s24 10.7 24 24V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V152zm112-24c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"]
};
var faBarcodeAlt = faRectangleBarcode;
var faPersonWalkingArrowRight = {
  prefix: 'fas',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"]
};
var faSquareEnvelope = {
  prefix: 'fas',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"]
};
var faEnvelopeSquare = faSquareEnvelope;
var faDice = {
  prefix: 'fas',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faUnicorn = {
  prefix: 'fas',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M448 160v78.1V240h0c-.5 30-12.8 56.4-32 75.7V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V346.7c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3 .3 4.6 .3 6.9c0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1H143.1c-13.8 0-26-8.8-30.4-21.9L95.3 437.7c-10.6-31.7-6.5-65.9 10-93.9c7.6-12.9 9.5-29.1 1.2-41.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V256c0-44.6 33.2-81.5 76.3-87.2c14.9-24.4 41.8-40.8 72.5-40.8h54.4H224h96C320 57.3 377.3 0 448 0h16 16 64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-5.7c5.2 4.6 9.6 10 13.1 16h79.3c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8L560 90.7v64.8c0 22.1-13.4 41.9-33.9 50.1c-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
var faBowlingBall = {
  prefix: 'fas',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faPompebled = {
  prefix: 'fas',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M460.3 172c-46.2-33.2-117-14.1-165.1 44.3c-5.9 8.6-17.2 10.6-25.6 4.5s-10.3-17.6-4.4-26.2c36.9-66.9 29-141.3-17.7-173.5C188.6-20.6 103.1 1.5 56.9 70.4c-85.5 126.3-77.6 313.4 44.2 400.4c121.4 87 296.3 27.7 381.8-98.6c46.2-68.4 36.4-158.5-22.6-200.2z"]
};
var faBrain = {
  prefix: 'fas',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"]
};
var faWatchSmart = {
  prefix: 'fas',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M64 48H320c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160V352c0 44.2 35.8 80 80 80H304c44.2 0 80-35.8 80-80V160c0-44.2-35.8-80-80-80H80zm136 80v86.1l41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17V160c0-13.3 10.7-24 24-24s24 10.7 24 24zM112 512H272c26.5 0 48-21.5 48-48H64c0 26.5 21.5 48 48 48z"]
};
var faBookUser = {
  prefix: 'fas',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM304 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM128 304c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208c-44.2 0-80 35.8-80 80z"]
};
var faSensorCloud = {
  prefix: 'fas',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H234.8c-6.9-14.5-10.8-30.8-10.8-48c0-44.7 26.2-83.3 64.1-101.3C290.9 271.3 339.9 224 400 224c17.2 0 33.5 3.9 48 10.8V96c0-35.3-28.7-64-64-64H64zm48 88V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V120c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 512H560c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432c0 44.2 35.8 80 80 80z"]
};
var faSensorSmoke = faSensorCloud;
var faClapperboardPlay = {
  prefix: 'fas',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", "M453.8 32.3L327 159l-1 1H233.9L361 33l1-1H448c2 0 3.9 .1 5.8 .3zM393.9 160L498 56c8.8 11 14 24.9 14 40v64H393.9zM201.9 32h92.1L167 159l-1 1H73.9L201 33l1-1zm-67.9 0L7 159l-1 1H0V96C0 60.7 28.7 32 64 32h70.1zM0 192H512V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm216.5 65.9c-5.2 2.8-8.5 8.2-8.5 14.1V400c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8z"]
};
var faBandage = {
  prefix: 'fas',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faBandAid = faBandage;
var faCalendarMinus = {
  prefix: 'fas',
  iconName: 'calendar-minus',
  icon: [512, 512, [], "f272", "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM344 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24H344z"]
};
var faCircleXmark = {
  prefix: 'fas',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faCircle4 = {
  prefix: 'fas',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10H272v40c0 13.3 10.7 24 24 24s24-10.7 24-24V320h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v56H201.3l37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"]
};
var faGifts = {
  prefix: 'fas',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"]
};
var faAlbumCollection = {
  prefix: 'fas',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M32 24c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H56C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42H432c24.2 0 44.6-18 47.6-42l32-256c1.7-13.7-2.5-27.4-11.6-37.7s-22.2-16.2-36-16.2H48zM440 344c0 75.1-82.4 136-184 136S72 419.1 72 344s82.4-136 184-136s184 60.9 184 136zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H472c13.3 0 24-10.7 24-24s-10.7-24-24-24H40z"]
};
var faHotel = {
  prefix: 'fas',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"]
};
var faEarthAsia = {
  prefix: 'fas',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"]
};
var faGlobeAsia = faEarthAsia;
var faIdCardClip = {
  prefix: 'fas',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
var faIdCardAlt = faIdCardClip;
var faMagnifyingGlassPlus = {
  prefix: 'fas',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faThumbsUp = {
  prefix: 'fas',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
};
var faCloudShowers = {
  prefix: 'fas',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm16 32c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm192 0c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24zm-72 56v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V408c0-13.3 10.7-24 24-24z"]
};
var faUserClock = {
  prefix: 'fas',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"]
};
var faOnion = {
  prefix: 'fas',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M216.8 17.7l-3.4-6.8C210.1 4.2 203.3 0 195.8 0c-10.9 0-19.6 9-21.3 19.8C167 67.8 132 96.2 95.3 126C49 163.7 0 203.5 0 288c0 80.4 58 135.2 131.9 160.3l-10.7 32.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2L178.6 460c7.1 1.2 14.2 2.1 21.4 2.7V488c0 13.3 10.7 24 24 24s24-10.7 24-24V462.7c7.2-.7 14.3-1.6 21.4-2.7l11.9 35.6c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-10.7-32.1C390 423.2 448 368.4 448 288c0-84.5-49-124.3-95.3-162C316 96.2 281 67.8 273.5 19.8C271.8 9 263.1 0 252.2 0c-7.5 0-14.3 4.2-17.7 10.9l-3.4 6.8c-2.9 5.9-11.4 5.9-14.3 0zM97 186.2l.4-.9c.4-.8 .8-1.5 1.2-2.2c2.5-3.8 6.6-6.4 11.3-6.9c1.9-.2 3.8-.1 5.6 .3s3.6 1.2 5.2 2.2c3.9 2.6 6.4 6.8 7 11.2c.3 1.9 .2 3.9-.3 5.9c-.3 1.3-.8 2.5-1.3 3.6l-.3 .7c-.3 .6-.8 1.6-1.4 2.9c-1.2 2.6-2.9 6.4-4.9 11.2c-4 9.6-9 23-13.3 38.2c-8.8 31.3-13.5 67.1-3.4 94c3.1 8.3-1.1 17.5-9.4 20.6s-17.5-1.1-20.6-9.4c-13.9-37-6.6-81.3 2.6-114c4.7-16.7 10.2-31.4 14.5-41.8c2.2-5.2 4-9.4 5.4-12.3c.7-1.5 1.2-2.6 1.6-3.4zM209 122.5c.3-.9 .8-1.8 1.3-2.7c1.2-2.1 2.9-3.8 4.8-5c3.4-2.3 7.7-3.3 11.9-2.5c1.9 .4 3.7 1 5.2 2c2 1.2 3.7 2.9 5 4.8s2.2 4.1 2.6 6.4c.3 1.8 .3 3.7-.1 5.5c-.2 1.1-.5 2.2-1 3.3l0 .1-.5 1.3c-.4 1.1-1.1 2.8-1.9 5c-1.6 4.4-4 10.9-6.6 18.9c-5.4 16.2-12.2 38.7-18.1 64c-11.9 51.7-18.9 111.9-4.4 155.3c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1c-17.5-52.5-8.5-120.3 3.6-172.7c6.1-26.6 13.3-50.1 18.9-67c2.8-8.4 5.2-15.2 7-19.9c.9-2.4 1.6-4.2 2.1-5.4l.6-1.5 .1-.1zM288 160c0-8.8 7.2-16 16-16c.1 0 .2 0 .2 0c.1 0 .2 0 .4 0c5.8-.2 11.6 2.7 14.6 8.2l-1 .6 0 0c1-.5 1-.5 1-.5l0 0 0 0 0 .1 .2 .3 .6 1.1c.5 .9 1.2 2.2 2.1 3.9c1.8 3.4 4.2 8.3 7.1 14.3c5.7 12.1 13.1 29.2 19.8 48.9c13.1 38.7 24.5 90.6 11.7 135.5c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c10-35.1 1.4-79.2-11.2-116.5c-6.2-18.3-13.1-34.2-18.4-45.6c-2.7-5.7-4.9-10.2-6.5-13.2l-.1-.1c-3.5-2.9-5.7-7.3-5.7-12.2z"]
};
var faClockTwelveThirty = {
  prefix: 'fas',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-360V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faArrowDownToDottedLine = {
  prefix: 'fas',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", "M374.6 214.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 242.7V176 64c0-17.7 14.3-32 32-32s32 14.3 32 32V176v66.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
var faHandDots = {
  prefix: 'fas',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faAllergies = faHandDots;
var faFileInvoice = {
  prefix: 'fas',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
var faWindowMinimize = {
  prefix: 'fas',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
};
var faRectangleWide = {
  prefix: 'fas',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
};
var faCommentArrowUp = {
  prefix: 'fas',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-120c0 13.3-10.7 24-24 24s-24-10.7-24-24V209.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V328z"]
};
var faGarlic = {
  prefix: 'fas',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M83.4 169.1C42.3 200.5 0 232.7 0 288C0 392.6 85.5 411.7 116.7 415.2C85 390.5 64 352.6 64 304c0-27.8 4.3-48.7 11-66.5c5.9-15.6 13.6-28.6 20.7-40.5c.8-1.4 1.7-2.8 2.5-4.2c7.8-13.2 15.1-26.2 20.5-43.3c1.2-3.7 2.3-7.7 3.3-11.9c-11.7 10.9-25.1 21.1-38.7 31.5zM384 416s128 0 128-128c0-55.3-42.3-87.5-83.4-118.9C389.8 139.5 352 110.6 352 64V48c0-26.5-21.5-48-48-48H288V80c0 30.2 4.7 51.9 11.4 69c6.7 17.1 15.7 30.3 25.5 43.8c1.2 1.6 2.4 3.3 3.6 4.9l0 0 0 0c19 25.8 39.4 53.5 39.4 106.3c0 49.2-21.5 87.3-53.7 112H384zM256 80V0H208c-26.5 0-48 21.5-48 48V64 80c0 33.4-4.2 58.5-10.8 79.2c-6.6 20.7-15.3 36.2-23.5 49.9l-2.5 4.2c-7.2 12.1-13.5 22.6-18.3 35.5c-5.3 13.9-9 31-9 55.2c0 69.3 54.9 112 120 112s120-42.7 120-112c0-42.1-15-62.5-33.5-87.7l0 0 0-.1c-1.1-1.5-2.2-3.1-3.4-4.6c-10.2-13.9-21.2-29.8-29.5-50.9C261.3 139.5 256 113.8 256 80zM136 448v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H136zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H200zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H264zm64 0v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448H328z"]
};
var faMugSaucer = {
  prefix: 'fas',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faCoffee = faMugSaucer;
var faBrush = {
  prefix: 'fas',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
var faTreeDecorated = {
  prefix: 'fas',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1C24 341.1 34.8 352 48.2 352H80L3.8 474c-2.5 4-3.8 8.5-3.8 13.2C0 500.9 11.1 512 24.9 512H423.1c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352h31.8c13.4 0 24.2-10.9 24.2-24.2c0-5-1.6-10-4.5-14.1L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9zM160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faMask = {
  prefix: 'fas',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
var faCalendarHeart = {
  prefix: 'fas',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM112 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
var faMagnifyingGlassMinus = {
  prefix: 'fas',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faFlower = {
  prefix: 'fas',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M128 480c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128zm96-304a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
var faArrowDownFromArc = {
  prefix: 'fas',
  iconName: 'arrow-down-from-arc',
  icon: [512, 512, [], "e614", "M256 64C150 64 64 150 64 256c0 17.7-14.3 32-32 32s-32-14.3-32-32C0 114.6 114.6 0 256 0S512 114.6 512 256c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-106-86-192-192-192zM121.4 390.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 224 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112z"]
};
var faRightLeftLarge = {
  prefix: 'fas',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M184.4 512c-19 0-37.2-7.5-50.6-21L15 372.3C5.4 362.7 0 349.6 0 336s5.4-26.7 15-36.3L133.8 181c13.4-13.4 31.6-21 50.6-21c37 0 67.4 28 71.2 64H320h96 16c8.8 0 16 7.2 16 16v16 24.4c0 4.2 3.4 7.6 7.6 7.6c2 0 3.9-.8 5.4-2.2L570.7 176 461 66.2c-1.4-1.4-3.4-2.2-5.4-2.2c-4.2 0-7.6 3.4-7.6 7.6V96v16c0 8.8-7.2 16-16 16H416 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.4c3.8-36 34.2-64 71.2-64c19 0 37.2 7.5 50.6 21L625 139.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L506.2 331c-13.4 13.4-31.6 21-50.6 21c-37 0-67.4-28-71.2-64H320 224 208c-8.8 0-16-7.2-16-16V256 231.6c0-4.2-3.4-7.6-7.6-7.6c-2 0-3.9 .8-5.4 2.2L69.3 336 179 445.8c1.4 1.4 3.4 2.2 5.4 2.2c4.2 0 7.6-3.4 7.6-7.6V416 400c0-8.8 7.2-16 16-16h16 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H255.6c-3.8 36-34.2 64-71.2 64z"]
};
var faRulerVertical = {
  prefix: 'fas',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"]
};
var faCirclesOverlap = {
  prefix: 'fas',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", "M192 288c0 34.2 7.7 66.6 21.4 95.7C130 378.2 64 308.8 64 224c0-88.4 71.6-160 160-160c32.2 0 62.2 9.5 87.3 25.9C240.4 127.5 192 202.1 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 0c-32.2 0-62.2-9.5-87.3-25.9C399.6 384.5 448 309.9 448 224c0-34.2-7.7-66.6-21.4-95.7C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160z"]
};
var faUserLarge = {
  prefix: 'fas',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"]
};
var faUserAlt = faUserLarge;
var faStarshipFreighter = {
  prefix: 'fas',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8V208c0 8.8-7.2 16-16 16H445.7 432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h13.7H560c8.8 0 16 7.2 16 16v42.1c0 13.2-8.1 25-20.4 29.8l-82.1 31.9c4.1 7.1 6.5 15.3 6.5 24.1c0 26.5-21.5 48-48 48H352c-11.5 0-21.6-6.1-27.3-15.2C292.2 474.9 258.2 480 224 480zm0-272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
var faTrainTram = {
  prefix: 'fas',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
var faBridgeSuspension = {
  prefix: 'fas',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", "M128 8c9.1 0 17 5 21.1 12.5C184.2 81.6 249.7 120 320 120s135.8-38.4 170.9-99.5C495 13 502.9 8 512 8c8.8 0 16.5 4.7 20.7 11.8c13.1 21.2 26.6 42.2 42 59.8c15.5 17.7 31.7 30.6 49.4 36.9c12.5 4.5 18.9 18.2 14.4 30.7s-18.2 18.9-30.7 14.4c-25.5-9.2-46.4-25.8-63.9-44.5V256h64c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32c-35.3 0-64 28.7-64 64v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V448c0-53-43-96-96-96H288c-53 0-96 43-96 96v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-35.3-28.7-64-64-64c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32H96V117.1c-17.4 18.7-38.4 35.3-63.9 44.5c-12.5 4.5-26.2-2-30.7-14.4s2-26.2 14.4-30.7c17.7-6.4 33.9-19.3 49.4-36.9c15.4-17.6 29-38.6 42-59.8C111.5 12.7 119.2 8 128 8zM480 108.1c-12.4 10.7-25.8 20.1-40 28.2V256h40V108.1zm-88 49c-15.5 4.8-31.6 8.1-48 9.8V256h48V157zm-96 9.8c-16.4-1.6-32.5-4.9-48-9.8v99h48V166.8zm-96-30.5c-14.2-8-27.6-17.5-40-28.2V256h40V136.3z"]
};
var faTrashCheck = {
  prefix: 'fas',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zM337 249c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 249z"]
};
var faUserNurse = {
  prefix: 'fas',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"]
};
var faBoombox = {
  prefix: 'fas',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", "M120 48H520c22.1 0 40 17.9 40 40v72H448c0-17.7-14.3-32-32-32s-32 14.3-32 32H352c0-17.7-14.3-32-32-32s-32 14.3-32 32H256c0-17.7-14.3-32-32-32s-32 14.3-32 32H80V88c0-22.1 17.9-40 40-40zM608 168.6V88c0-48.6-39.4-88-88-88H120C71.4 0 32 39.4 32 88v80.6C12.9 179.6 0 200.3 0 224V448c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V224c0-23.7-12.9-44.4-32-55.4zM256 336A80 80 0 1 0 96 336a80 80 0 1 0 160 0zM64 336a112 112 0 1 1 224 0A112 112 0 1 1 64 336zm400 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
var faSyringe = {
  prefix: 'fas',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"]
};
var faCloudSun = {
  prefix: 'fas',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"]
};
var faShieldExclamation = {
  prefix: 'fas',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 128c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faStopwatch20 = {
  prefix: 'fas',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"]
};
var faSquareFull = {
  prefix: 'fas',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M0 0H512V512H0V0z"]
};
var faGripDots = {
  prefix: 'fas',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", "M336 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
};
var faCommentExclamation = {
  prefix: 'fas',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm0-336c13.3 0 24 10.7 24 24V248c0 13.3-10.7 24-24 24s-24-10.7-24-24V136c0-13.3 10.7-24 24-24zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faPenSwirl = {
  prefix: 'fas',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", "M347.8 17C319.3 6 288.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256S150 64 256 64c14.1 0 27.8 1.5 41 4.4L347.8 17zM310.6 349.4c-5.4 5.3-11.4 9.8-17.8 13.6c-1.7 2.7-3 5.7-3.8 9c-4.4 17.1 5.9 34.6 23 39c12.8 3.3 26.2 5 40 5c88.4 0 160-71.6 160-160c0-32.2-5.9-63-16.8-91.3l-51.4 51.4c2.7 12.9 4.2 26.2 4.2 39.9c0 53-43 96-96 96c-8.3 0-16.4-1.1-24-3c-5.9-1.5-11.9-1.3-17.4 .4zM473.9 16c-18.8-18.8-49.2-18.7-67.9 0L366.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L473.9 16zM200.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L432.8 167.5 343.7 78.4 200.5 221.8z"]
};
var faFalafel = {
  prefix: 'fas',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M166.6 162.5c5.9 7.1 8 16.7 5.7 25.7c-.3 1.3-.6 2.6-.7 3.9c17.2 .6 33.9 8.6 45.1 22.8c28.3 .2 52.1 20.3 58.1 47.4c4.8 2.4 9.2 5.4 13.1 8.8c3.9-3.4 8.3-6.4 13.1-8.8c6-27.1 29.8-47.1 58.1-47.4c17.3-21.9 47.4-29.2 72.8-17c1.5-.7 3-1.4 4.5-1.9c.1-2.6-.2-5.2-.9-7.8c-2.3-9-.1-18.6 5.7-25.7c8.8-10.7 8.8-26.3 0-37c-5.9-7.1-8-16.7-5.7-25.7c3.4-13.5-3.2-27.6-15.7-33.3c-8.3-3.8-14.3-11.5-16.1-20.6c-2.7-13.7-14.6-23.5-28.3-23.1c-9.1 .3-17.8-4-23.2-11.4C344 .3 329.1-3.2 316.9 3.2c-8.1 4.3-17.7 4.3-25.8 0C278.9-3.2 264 .3 255.8 11.4c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37zm48.8 84.4c-3.6 .1-7.2-.5-10.5-1.8c-5-1.9-9.4-5.2-12.7-9.6c-8.2-11.2-23.2-14.6-35.3-8.2c-8.1 4.3-17.7 4.3-25.8 0c-12.2-6.4-27.1-2.9-35.3 8.2c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c4.1-1.9 7.6-4.7 10.3-8.1c-3.1-10.1-3.7-21-1.2-31.7c-17.3-22.1-17.3-53.3 0-75.4c-2.4-10.7-1.9-21.7 1.2-31.7c-2.7-3.4-6.2-6.2-10.3-8.1c-8.3-3.8-14.3-11.5-16.1-20.6c-.2-1-.5-2-.8-3c-3.7-12.1-14.9-20.4-27.6-20.1zM224 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm453.4-42.6c4.1-4.1 7-9.2 8.7-14.9c0-.2 .1-.3 .1-.5c7-25-7.6-62.8-38.6-93.7c-23.3-23.3-50.5-37.4-73.1-39.9c0 0 0 0 0 0c-2-.2-3.9-.4-5.8-.4c0 0 0 0 0 0c-9.6-.2-18.3 1.8-25.1 6.4c0 0 0 0 0 0c0 0-.1 0-.1 .1c-1.6 1.1-3.1 2.3-4.5 3.6c-.2 .2-.3 .3-.5 .5c-19.2 19.2-11.4 59 16.6 94.3c4 5 8.4 10 13.2 14.8c38.4 38.4 87.2 51.7 109.1 29.8zM508.6 412c-26-7.1-52.6-23.3-74.9-45.7s-38.6-48.9-45.7-74.9c-5.3-19.6-6.4-43.3 4.2-63.6c-3.2 1.9-6.1 4.4-8.4 7.6c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c12.5-5.7 19.2-19.8 15.7-33.3l-.1-.6c-18.1 6.4-38 5-54.9 .4zM368 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
var faCircle2 = {
  prefix: 'fas',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 336H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L276.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"]
};
var faMagnet = {
  prefix: 'fas',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"]
};
var faJar = {
  prefix: 'fas',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"]
};
var faGramophone = {
  prefix: 'fas',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M127 0c10.5-.4 20 6 23.6 15.9l0 .1 .3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.6 22.9 40.1 40.4c5.4 10.9 8.2 23 8.2 35l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4H184c-13.3 0-24-10.7-24-24s10.7-24 24-24l110 0c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-44.1-7.3-133.1-7.9-241.4 69.4c-.3 .2-.7 .5-1 .7c-2.7 1.8-5.6 2.9-8.7 3.5c-3.2 .6-6.6 .6-10-.2c-1.2-.3-2.4-.7-3.6-1.1c-.5-.2-1-.5-1.5-.7c-.9-.4-1.7-.9-2.5-1.5c-1.2-.8-2.2-1.6-3.2-2.6c-1.4-1.3-2.5-2.7-3.6-4.2c-1.8-2.8-3-5.8-3.6-8.9c-.6-3.1-.5-6.4 .2-9.6c.1-.3 .2-.7 .3-1L104.8 17.9C107.5 7.7 116.5 .4 127 0zM32 416c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V416z"]
};
var faDiceD12 = {
  prefix: 'fas',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M318.2 0c4.2 0 8.4 1.1 12 3.2l72 41.6c5.9 3.4 5.1 12.2-1.3 14.5L264.1 108.1c-5.2 1.9-10.9 1.9-16.1 0L111.1 59.3c-6.4-2.3-7.2-11.1-1.3-14.5l72-41.6c3.6-2.1 7.8-3.2 12-3.2H318.2zM149.9 490.4L74.2 446.6c-3.6-2.1-6.7-5.1-8.8-8.8L3.2 330.2c-2.1-3.6-3.2-7.8-3.2-12V233.9c0-7.1 8.6-10.7 13.7-5.7l96.1 96.1c2.7 2.7 4.8 6.1 5.9 9.8L161.6 481c2.2 7-5.3 13-11.6 9.3zM512 233.9v84.2c0 4.2-1.1 8.4-3.2 12L446.6 437.8c-2.1 3.6-5.1 6.7-8.8 8.8l-75.8 43.7c-6.3 3.6-13.8-2.4-11.6-9.3l45.9-146.9c1.2-3.7 3.2-7.1 5.9-9.8l96.1-96.1c5-5 13.7-1.5 13.7 5.7zM15.3 184.7c-5.1-5.1-6.2-13-2.5-19.3L57.4 88c3.9-6.7 12-9.7 19.2-7.1l152.8 54.6c6.4 2.3 10.6 8.3 10.6 15.1v85.7c0 6.1-3.4 11.6-8.8 14.3l-89.7 44.8c-6.2 3.1-13.6 1.9-18.5-3L15.3 184.7zM454.6 88l44.7 77.3c3.6 6.3 2.6 14.2-2.5 19.3L389 292.4c-4.9 4.9-12.3 6.1-18.5 3l-89.7-44.8c-5.4-2.7-8.8-8.3-8.8-14.3V150.6c0-6.8 4.3-12.8 10.6-15.1L435.4 80.9c7.3-2.6 15.4 .4 19.2 7.1zM295.5 512H216.5c-7 0-13.2-4.5-15.3-11.2L151.4 341.2c-2.3-7.5 1.1-15.6 8.1-19.1l89.3-44.7c4.5-2.3 9.8-2.3 14.3 0l89.3 44.7c7 3.5 10.5 11.6 8.1 19.1L310.7 500.8c-2.1 6.7-8.3 11.2-15.3 11.2z"]
};
var faNoteSticky = {
  prefix: 'fas',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"]
};
var faStickyNote = faNoteSticky;
var faDown = {
  prefix: 'fas',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l96 0 0-184c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 184 96 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160z"]
};
var faArrowAltDown = faDown;
var faHundredPoints = {
  prefix: 'fas',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M163 101.8C168 61.9 201.9 32 242 32c47.9 0 85 42 79 89.5L309 218.2c-5 39.8-38.9 69.8-79 69.8c-47.9 0-85-42-79-89.5L163 101.8zM242 96c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6c7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6zM135.7 68l-32 224c-2.5 17.5-18.7 30-36.2 27.7S37.8 301.5 40.3 284L64.3 116.5l-19.7 8.7c-16.2 7.2-35.1 0-42-16.1s.6-35.1 16.8-42.3l72-32c10.6-4.7 22.9-3.4 32.1 3.5s13.8 18.2 12.2 29.7zm376 247.5c2.5 17.5-9.7 33.7-27.2 36.2l-448 64C19 418.2 2.8 406 .3 388.5S10 354.8 27.5 352.3l448-64c17.5-2.5 33.7 9.7 36.2 27.2zm0 96c2.5 17.5-9.7 33.7-27.2 36.2l-224 32c-17.5 2.5-33.7-9.7-36.2-27.2s9.7-33.7 27.2-36.2l224-32c17.5-2.5 33.7 9.7 36.2 27.2zM427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6c-46.9 0-83.7-40.3-79.5-87l7.3-80.4C351.9 63.5 386.4 32 427.7 32zm-15.7 78.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2c8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2c-8.2 0-15 6.2-15.7 14.4z"]
};
var fa100 = faHundredPoints;
var faPaperclipVertical = {
  prefix: 'fas',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", "M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128V320c0 44.2-35.8 80-80 80s-80-35.8-80-80V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-35.3-28.7-64-64-64s-64 28.7-64 64V336c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-17.7 14.3-32 32-32s32 14.3 32 32V336c0 97.2-78.8 176-176 176s-176-78.8-176-176V128z"]
};
var faWindWarning = {
  prefix: 'fas',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M418 368c-38.7 67-111.1 112-194 112C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208H384c-35.3 0-64 28.7-64 64s28.7 64 64 64h34zM248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm248 48c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32H536c53 0 96 43 96 96s-43 96-96 96H504c-17.7 0-32-14.3-32-32zm72-192H479.5c-1.4-22.2-5.6-43.7-12.3-64H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H512c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c53 0 96 43 96 96s-43 96-96 96z"]
};
var faWindCircleExclamation = faWindWarning;
var faLocationPinSlash = {
  prefix: 'fas',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM343.7 499.2c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
var faMapMarkerSlash = faLocationPinSlash;
var faFaceSadSweat = {
  prefix: 'fas',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5zm291.3 7.4c-6.6 5.9-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z"]
};
var faBugSlash = {
  prefix: 'fas',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7V479.2z"]
};
var faCupcake = {
  prefix: 'fas',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M240 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C240 56 232 64 222.1 64H160c-35.3 0-64 28.7-64 64l0 .8c-3.3 .5-6.6 1.4-9.9 2.4L50.9 143C20.5 153.2 0 181.6 0 213.6C0 254.7 33.3 288 74.4 288H373.6c41.1 0 74.4-33.3 74.4-74.4c0-32-20.5-60.4-50.9-70.6l-35.3-11.8c-4.1-1.4-8.2-2.3-12.5-2.8c1.7-6.7 2.6-13.8 2.6-21C352 48.1 303.9 0 244.6 0H240zm27.9 512l24-192H156.1l24 192h87.8zM64 320L89.3 471.9C93.2 495 113.2 512 136.7 512h11.2l-24-192H64zM300.1 512h11.2c23.5 0 43.5-17 47.3-40.1L384 320H324.1l-24 192z"]
};
var faLightSwitchOff = {
  prefix: 'fas',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M64 512c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64zm96-96h64c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64V352c0 35.3 28.7 64 64 64zm32 32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM160 384c-17.7 0-32-14.3-32-32V256H256v96c0 17.7-14.3 32-32 32H160z"]
};
var faToggleLargeOff = {
  prefix: 'fas',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M192 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 64H384c106 0 192-86 192-192s-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448zm143.1-64c30.4-34 48.9-78.8 48.9-128s-18.5-94-48.9-128H384c70.7 0 128 57.3 128 128s-57.3 128-128 128H335.1z"]
};
var faPenFancySlash = {
  prefix: 'fas',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L387.9 278.7l161-140.2c17.2-15 27.1-36.7 27.1-59.6c0-43.6-35.4-79-79-79c-22.8 0-44.6 9.9-59.6 27.1L287.1 199.7 38.8 5.1zM318 346.5L211 262.3l-60.1 13.9c-17.1 3.9-30.7 16.9-35.4 33.8L65.7 487.6l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1L88.4 510.3 266 460.5c16.9-4.7 29.9-18.3 33.8-35.4L318 346.5z"]
};
var faTruckContainer = {
  prefix: 'fas',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M48 32H352c26.5 0 48 21.5 48 48V240c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80C0 53.5 21.5 32 48 32zM80 80c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM224 96V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16zM160 80c-8.8 0-16 7.2-16 16V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM304 96V224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16zm128 72c0-13.3 10.7-24 24-24h72.8c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3V272v16 64c0 17.7-14.3 32-32 32h-1.6c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H432 286.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80V384 352c0-17.7 14.3-32 32-32H80 208 432V288 256 168zm48 88H585l-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9H480v64zm80 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM208 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faBoot = {
  prefix: 'fas',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", "M0 32C0 14.3 14.3 0 32 0H320c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H0V32zM0 457.4V448H512v9.4c0 14.5-5.8 28.4-16 38.6s-24.1 16-38.6 16H442.5c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7h-11c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7H54.6c-14.5 0-28.4-5.8-38.6-16S0 471.9 0 457.4zM0 416V128H320v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h48l119.3 29.8C482 296.5 512 334.9 512 379v37H0z"]
};
var faArrowUpFromWaterPump = {
  prefix: 'fas',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"]
};
var faFileCheck = {
  prefix: 'fas',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm49 281L177 409c-9.4 9.4-24.6 9.4-33.9 0L79 345c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 247c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
var faBone = {
  prefix: 'fas',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"]
};
var faCardsBlank = {
  prefix: 'fas',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", "M27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zM459.4 420.9L324.1 499c9.7 8.1 22.2 13 35.9 13H584c30.9 0 56-25.1 56-56V120c0-30.9-25.1-56-56-56H360c-1.8 0-3.5 .1-5.3 .2L491.5 301.1c24.2 41.9 9.8 95.6-32.1 119.8z"]
};
var faCircle3 = {
  prefix: 'fas',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128H312c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2H240c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4h27.8c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faBenchTree = {
  prefix: 'fas',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M608 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176c0 44.2-35.8 80-80 80H544V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256H464c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96zM32 224c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224zm0 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H96v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
var faKeyboardBrightnessLow = {
  prefix: 'fas',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H224z"]
};
var faSkiBootSki = {
  prefix: 'fas',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M390.3 .6c17.3 3.5 28.6 20.3 25.1 37.7l-6.4 32L397.4 128H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h55l-9.6 48H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h62.2l78.7 34.7c11.6 5.1 19.1 16.6 19.1 29.3v80c0 17.7-14.3 32-32 32H120c-9.6 0-18.7-4.3-24.7-11.7s-8.5-17.2-6.6-26.6l24.7-123.6c2.9-.5 6.1-1.2 9.5-2.1c15.6-3.9 36.4-11.6 58.3-26.9c42.4-29.7 86.4-86.4 104.5-193.1h65.7l1.3-6.3C356.1 8.4 372.9-2.8 390.3 .6zM162.8 198.9c-15.8 11-30.8 17.2-42.6 20.7L152.6 57.7c3-15 16.1-25.7 31.4-25.7h69.2c-17.4 96-56.7 143.3-90.4 166.9zM640 416c0 53-43 96-96 96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32-14.3 32-32s14.3-32 32-32s32 14.3 32 32z"]
};
var faBrainCircuit = {
  prefix: 'fas',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M240 56c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56V272H192c-8.8 0-16 7.2-16 16v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V288c0-26.5 21.5-48 48-48h48V160H205.3c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32H240V56zm32 104V352h34.7c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32H272v72c0 30.9 25.1 56 56 56c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56v72h48c26.5 0 48 21.5 48 48v2.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V176c0-8.8-7.2-16-16-16H272zM144 144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm208 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM144 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm192 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"]
};
var faUserInjured = {
  prefix: 'fas',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"]
};
var faBlockBrickFire = {
  prefix: 'fas',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M128 32v80H384V32H128zM96 112V32C60.7 32 32 60.7 32 96v16H96zM32 144v96H240V144H32zm0 224H96V272H32v96zm0 32v16c0 35.3 28.7 64 64 64H240V400H32zm240 0v80h65.6c-20.2-22.6-35.1-50-43.1-80H272zM480 144h-.6l.6 .6V144zm-208 0v96h54.9c20.6-32.8 48.5-66.2 81-96H272zM128 272v96H288.8c-.5-5.9-.8-11.9-.8-17.9c0-25.4 8.5-52.4 21-78.1H128zM480 112V96c0-35.3-28.7-64-64-64v80h64zm-26.5 51.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 439.9 390.3 512 480 512c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 433c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"]
};
var faFirewall = faBlockBrickFire;
var faFaceSadTear = {
  prefix: 'fas',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faSadTear = faFaceSadTear;
var faPlane = {
  prefix: 'fas',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"]
};
var faTentArrowsDown = {
  prefix: 'fas',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"]
};
var faExclamation = {
  prefix: 'fas',
  iconName: 'exclamation',
  icon: [64, 512, [10069, 10071, 61738], "21", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
var faArrowsSpin = {
  prefix: 'fas',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"]
};
var faFaceSmileRelaxed = {
  prefix: 'fas',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
var faCommentXmark = {
  prefix: 'fas',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM175 159c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
var faCommentTimes = faCommentXmark;
var faPrint = {
  prefix: 'fas',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
var faTurkishLiraSign = {
  prefix: 'fas',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", "M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faFaceNoseSteam = {
  prefix: 'fas',
  iconName: 'face-nose-steam',
  icon: [512, 512, [], "e382", "M498.2 339.1c8.9-26.1 13.8-54 13.8-83.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c23.3-23.3 60.1-24.9 85.3-4.7l51-30.6c30-18 64.1 16.1 46.1 46.1l-30.6 51c20.2 25.1 18.6 62-4.7 85.3c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C198.4 507 226.6 512 256 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-23.3-23.3-24.9-60.1-4.7-85.3l-30.6-51c-18-30 16.1-64.1 46.1-46.1l51 30.6c25.1-20.2 62-18.6 85.3 4.7c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1zm-12.4 29.7c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-12-12-31.2-12.5-43.8-1.4c-.5 .5-1 .9-1.5 1.4c-3.7 3.7-6.3 8.1-7.8 12.8L332.8 323c-2.8-1.8-6.5-1.4-8.8 1l-.2 .2c-.3 .2-.6 .5-.7 .8c-1.6 2.3-1.7 5.3-.1 7.7l44.2 70.4c-4.9 1.5-9.6 4.1-13.4 8c-4.7 4.7-7.6 10.4-8.8 16.4c-.5 2.4-.7 4.8-.6 7.2c.2 7.9 3.4 15.7 9.4 21.7c.7 .7 1.3 1.3 2 1.9c4.2 3.6 9.2 5.9 14.4 6.9c-1.5 3.2-2.5 6.7-2.9 10.1c-.2 1.8-.3 3.7-.2 5.6c0 .7 .1 1.4 .2 2c.8 6.9 3.9 13.5 9.1 18.8c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5l0 0zM142.4 485.5c.4-1.8 .7-3.6 .8-5.4c.3-5.4-.7-10.8-3.1-15.7c5.2-1 10.1-3.3 14.4-6.9c.7-.6 1.4-1.2 2-1.8c1.5-1.5 2.8-3.1 4-4.8c8-11.9 7.1-27.9-2.5-38.9c-.5-.5-.9-1-1.4-1.5c-3.6-3.6-7.9-6.2-12.5-7.7l44.9-69.8c1.8-2.8 1.4-6.5-.9-8.8c-2.3-2.3-5.9-2.7-8.7-1L108 367.5c0-.2-.1-.3-.1-.5c-1.5-4.8-4.1-9.4-8-13.2c-.2-.2-.4-.4-.7-.6c-.3-.3-.6-.5-.8-.8c-12.6-11.1-31.7-10.6-43.8 1.4c-.7 .7-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2C1.7 445.6 3 472.7 20.3 489.9s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c4.4-4.4 7.2-9.8 8.5-15.4zM112 224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 32c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm95.2-133.1c2.8 8.4-1.7 17.4-10.1 20.2c-35.5 11.8-64.4 34.8-73.7 44.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c12-12 45-38.1 86.3-51.9c8.4-2.8 17.4 1.7 20.2 10.1zm-286.4 0c2.8-8.4 11.9-12.9 20.2-10.1c41.3 13.8 74.2 39.9 86.3 51.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-9.3-9.3-38.2-32.3-73.7-44.1c-8.4-2.8-12.9-11.9-10.1-20.2z"]
};
var faCircleWaveformLines = {
  prefix: 'fas',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 176V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24V312c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16zM224 216v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V216c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
var faWaveformCircle = faCircleWaveformLines;
var faDollarSign = {
  prefix: 'fas',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faFerrisWheel = {
  prefix: 'fas',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M302.7 36.9c27.7 5.9 53.5 16.9 76.4 31.9c6.3-3.1 13.4-4.8 20.9-4.8c26.5 0 48 21.5 48 48c0 7.5-1.7 14.6-4.8 20.9c15.1 22.9 26 48.7 31.9 76.4c21.1 5 36.9 24 36.9 46.7s-15.7 41.7-36.9 46.7c-5.9 27.7-16.9 53.5-31.9 76.4c3.1 6.3 4.8 13.4 4.8 20.9c0 25.6-20 46.4-45.1 47.9l-38.5-80c4.6-5.1 10.3-9.2 16.6-12c17.2-21.5 29-47.5 33.2-75.9H332.3c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24h81.9c-3.9-26.3-14.3-50.4-29.4-70.9L326.9 219c-7.6-14.5-19.5-26.4-33.9-33.9l57.9-57.9c-20.5-15.1-44.6-25.4-70.9-29.4v81.9c-7.6-2.4-15.6-3.7-24-3.7s-16.4 1.3-24 3.7V97.8c-26.3 4-50.4 14.3-70.9 29.4L219 185.1c-14.5 7.6-26.4 19.5-33.9 33.9l-57.9-57.9c-15.1 20.5-25.4 44.6-29.4 70.9h81.9c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24H97.8c4.3 28.5 16.1 54.4 33.2 75.9c6.4 2.8 12.1 6.9 16.7 12l-38.5 80C84 446.4 64 425.6 64 400c0-7.5 1.7-14.6 4.8-20.9c-15.1-22.9-26.1-48.7-31.9-76.4C15.7 297.7 0 278.7 0 256s15.7-41.7 36.9-46.7c5.9-27.7 16.9-53.5 31.9-76.4C65.7 126.6 64 119.5 64 112c0-26.5 21.5-48 48-48c7.5 0 14.6 1.7 20.9 4.8c22.9-15.1 48.7-26.1 76.4-31.9C214.3 15.7 233.3 0 256 0s41.7 15.7 46.7 36.9zM304 256c0 11.6-4.1 22.3-11 30.6l88.8 191.3c3.4 7.4 2.9 16.1-1.5 23s-12 11.1-20.2 11.1H152c-8.2 0-15.8-4.2-20.2-11.1s-5-15.6-1.5-23L219 286.6c-6.9-8.3-11-19-11-30.6c0-26.5 21.5-48 48-48s48 21.5 48 48z"]
};
var faComputerSpeaker = {
  prefix: 'fas',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", "M288 432V416H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H304c-10-13.4-16-30-16-48zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H288V320H64V96H288V80c0-18 6-34.6 16-48H64zm304 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368zM544 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm64-192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
var faSkullCow = {
  prefix: 'fas',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5C0 166.1 57.2 224 128 224V208 192 160 144 128H105c-28.7 0-52.7-21.7-55.6-50.3c-.8-7.8 .1-15.8 2.6-23.2L63.2 21.1zM240 96c-44.2 0-80 35.8-80 80V288c0 37 25.2 68.2 59.3 77.3l27.6 110.3c5.3 21.4 24.5 36.4 46.6 36.4h53c22 0 41.2-15 46.6-36.4l27.6-110.3C454.8 356.2 480 325 480 288V176c0-44.2-35.8-80-80-80H240zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM584.4 1.9c-6.8 3.7-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2C587.7 106.3 563.7 128 535 128H512v16 16 32 16 16c70.8 0 128-57.9 128-128.5c0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1z"]
};
var faX = {
  prefix: 'fas',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
var faMagnifyingGlassDollar = {
  prefix: 'fas',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faUsersGear = {
  prefix: 'fas',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
var faUsersCog = faUsersGear;
var faPersonMilitaryPointing = {
  prefix: 'fas',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"]
};
var faBuildingColumns = {
  prefix: 'fas',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faCircleT = {
  prefix: 'fas',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144H256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V192H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faSack = {
  prefix: 'fas',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4z"]
};
var faGrid2 = {
  prefix: 'fas',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", "M224 80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM288 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"]
};
var faCameraCctv = {
  prefix: 'fas',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l158.1 65.9L137.9 400H64V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v48 48c0 17.7 14.3 32 32 32s32-14.3 32-32V464h96c13.3 0 25.2-8.2 29.9-20.6l47-123.4 70.8 29.5c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160zM513.4 398.6c3.9 1.8 8.4 1.9 12.5 .3s7.2-4.7 8.9-8.7l40-96c3.3-8-.3-17.2-8.3-20.8l-36.7-16.3L396.9 345.6l116.5 52.9z"]
};
var faCctv = faCameraCctv;
var faUmbrella = {
  prefix: 'fas',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"]
};
var faTrowel = {
  prefix: 'fas',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"]
};
var faHorizontalRule = {
  prefix: 'fas',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
};
var faBedFront = {
  prefix: 'fas',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M32 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V209.1c-14.5-8.4-30.7-14-48-16.1c0-.3 0-.7 0-1V160c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v32H240V160c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v32c0 .3 0 .7 0 1c-17.3 2.2-33.6 7.8-48 16.1V80zM0 320c0-53 43-96 96-96H416c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320z"]
};
var faBedAlt = faBedFront;
var faD = {
  prefix: 'fas',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"]
};
var faStapler = {
  prefix: 'fas',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"]
};
var faMasksTheater = {
  prefix: 'fas',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"]
};
var faTheaterMasks = faMasksTheater;
var faKipSign = {
  prefix: 'fas',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"]
};
var faFaceWoozy = {
  prefix: 'fas',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7c4.9-7.4 14.8-9.3 22.2-4.4zm22.6 121.4c2.1 8.6-3.1 17.3-11.6 19.4l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6zM336 272c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
var faCloudQuestion = {
  prefix: 'fas',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm89.8-282.7l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V296c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H286.6c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faPineapple = {
  prefix: 'fas',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M431.5 12.1c-1.1-4.5-4.2-8.4-8.4-10.5s-9.1-2.2-13.4-.4C393.8 8.1 383 20.8 378.1 35.4L363.3 20.7c-6.2-6.2-16.4-6.2-22.6 0C325.3 36.1 317.1 56 316.2 76.2C297.3 68.2 276.9 64 256 64c-41 0-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3L402.7 365.3c29-29 45.3-68.3 45.3-109.3c0-20.9-4.2-41.3-12.2-60.2c20.2-.9 40.1-9.1 55.5-24.5c6.2-6.2 6.2-16.4 0-22.6l-14.7-14.7c14.6-4.9 27.3-15.8 34.1-31.6c1.8-4.3 1.7-9.2-.4-13.4s-5.9-7.3-10.5-8.4l-14.3-3.6C492.4 65 496 51.4 496 37.5V32c0-8.8-7.2-16-16-16h-5.5c-13.9 0-27.5 3.6-39.4 10.4l-3.6-14.3zM164.7 212.7c6.2-6.2 16.4-6.2 22.6 0L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm182.6 0L288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM164.7 395.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32z"]
};
var faHandPointLeft = {
  prefix: 'fas',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"]
};
var faGalleryThumbnails = {
  prefix: 'fas',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M512 64V288H64L64 64H512zM64 0C28.7 0 0 28.7 0 64V288c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM0 448v32c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H192zm128 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V448c0-17.7-14.3-32-32-32H512z"]
};
var faCircleJ = {
  prefix: 'fas',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360V288c0 53-43 96-96 96s-96-43-96-96v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c0 26.5 21.5 48 48 48s48-21.5 48-48V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
var faEyes = {
  prefix: 'fas',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", "M96 224c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64zm224-97.3c-5-9.1-10.5-17.6-16.6-25.7C272.8 60.2 228.1 32 176 32s-96.8 28.2-127.4 69C18 141.8 0 196.7 0 256s18 114.2 48.6 155c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7c5 9.1 10.5 17.6 16.6 25.7c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155C560.8 60.2 516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zm54.4 224.6c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3z"]
};
var faHandshakeSimple = {
  prefix: 'fas',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"]
};
var faHandshakeAlt = faHandshakeSimple;
var faPageCaretUp = {
  prefix: 'fas',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M320 512c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2H122.2c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z"]
};
var faFileCaretUp = faPageCaretUp;
var faJetFighter = {
  prefix: 'fas',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"]
};
var faFighterJet = faJetFighter;
var faComet = {
  prefix: 'fas',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M299.4 75.6L493.7 .9c1.5-.6 3.2-.9 4.8-.9C506 0 512 6 512 13.5c0 1.7-.3 3.3-.9 4.8L436.4 212.6l29.3-2.3c12.8-1 21.5 12.8 15.1 24L378.6 410.7C342.3 473.4 275.4 512 203 512C90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L277.7 31.2c11.1-6.5 25 2.2 24 15.1l-2.3 29.3zM192 200c-6.1 0-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L192 402.1l58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
var faSquareShareNodes = {
  prefix: 'fas',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
var faShareAltSquare = faSquareShareNodes;
var faShieldKeyhole = {
  prefix: 'fas',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V258.6c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56z"]
};
var faBarcode = {
  prefix: 'fas',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
var faPlusMinus = {
  prefix: 'fas',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
};
var faSquareSlidersVertical = {
  prefix: 'fas',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176V128c0-17.7-14.3-32-32-32zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V288H256c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H336V128z"]
};
var faSlidersVSquare = faSquareSlidersVertical;
var faVideo = {
  prefix: 'fas',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"]
};
var faVideoCamera = faVideo;
var faMessageMiddle = {
  prefix: 'fas',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M343.5 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H168.5l75.2 90.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L343.5 416z"]
};
var faCommentMiddleAlt = faMessageMiddle;
var faGraduationCap = {
  prefix: 'fas',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"]
};
var faMortarBoard = faGraduationCap;
var faHandHoldingMedical = {
  prefix: 'fas',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"]
};
var faPersonCircleCheck = {
  prefix: 'fas',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
var faSquareZ = {
  prefix: 'fas',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm72 96H312c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336H312c13.3 0 24 10.7 24 24s-10.7 24-24 24H136c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176H136c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
var faMessageText = {
  prefix: 'fas',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm168 48c-13.3 0-24 10.7-24 24s10.7 24 24 24h64V296c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 168z"]
};
var faCommentAltText = faMessageText;
var faTurnUp = {
  prefix: 'fas',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"]
};
var faLevelUpAlt = faTurnUp;
var icons = {
  fa0: fa0,
  fa1: fa1,
  fa2: fa2,
  fa3: fa3,
  fa4: fa4,
  fa5: fa5,
  fa6: fa6,
  fa7: fa7,
  fa8: fa8,
  fa9: fa9,
  faFillDrip: faFillDrip,
  faArrowsToCircle: faArrowsToCircle,
  faCircleChevronRight: faCircleChevronRight,
  faChevronCircleRight: faChevronCircleRight,
  faWagonCovered: faWagonCovered,
  faLineHeight: faLineHeight,
  faBagel: faBagel,
  faTransporter7: faTransporter7,
  faAt: faAt,
  faRectanglesMixed: faRectanglesMixed,
  faPhoneArrowUpRight: faPhoneArrowUpRight,
  faPhoneArrowUp: faPhoneArrowUp,
  faPhoneOutgoing: faPhoneOutgoing,
  faTrashCan: faTrashCan,
  faTrashAlt: faTrashAlt,
  faCircleL: faCircleL,
  faHeadSideGoggles: faHeadSideGoggles,
  faHeadVr: faHeadVr,
  faTextHeight: faTextHeight,
  faUserXmark: faUserXmark,
  faUserTimes: faUserTimes,
  faFaceHandYawn: faFaceHandYawn,
  faGaugeSimpleMin: faGaugeSimpleMin,
  faTachometerSlowest: faTachometerSlowest,
  faStethoscope: faStethoscope,
  faCoffin: faCoffin,
  faMessage: faMessage,
  faCommentAlt: faCommentAlt,
  faSalad: faSalad,
  faBowlSalad: faBowlSalad,
  faInfo: faInfo,
  faRobotAstromech: faRobotAstromech,
  faRingDiamond: faRingDiamond,
  faFonduePot: faFonduePot,
  faTheta: faTheta,
  faFaceHandPeeking: faFaceHandPeeking,
  faSquareUser: faSquareUser,
  faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
  faCompressAlt: faCompressAlt,
  faExplosion: faExplosion,
  faFileLines: faFileLines,
  faFileAlt: faFileAlt,
  faFileText: faFileText,
  faWaveSquare: faWaveSquare,
  faRing: faRing,
  faBuildingUn: faBuildingUn,
  faDiceThree: faDiceThree,
  faTirePressureWarning: faTirePressureWarning,
  faWifiFair: faWifiFair,
  faWifi2: faWifi2,
  faCalendarDays: faCalendarDays,
  faCalendarAlt: faCalendarAlt,
  faMp3Player: faMp3Player,
  faAnchorCircleCheck: faAnchorCircleCheck,
  faTally4: faTally4,
  faRectangleHistory: faRectangleHistory,
  faBuildingCircleArrowRight: faBuildingCircleArrowRight,
  faVolleyball: faVolleyball,
  faVolleyballBall: faVolleyballBall,
  faSunHaze: faSunHaze,
  faTextSize: faTextSize,
  faUfo: faUfo,
  faFork: faFork,
  faUtensilFork: faUtensilFork,
  faArrowsUpToLine: faArrowsUpToLine,
  faMobileSignal: faMobileSignal,
  faBarcodeScan: faBarcodeScan,
  faSortDown: faSortDown,
  faSortDesc: faSortDesc,
  faFolderArrowDown: faFolderArrowDown,
  faFolderDownload: faFolderDownload,
  faCircleMinus: faCircleMinus,
  faMinusCircle: faMinusCircle,
  faFaceIcicles: faFaceIcicles,
  faShovel: faShovel,
  faDoorOpen: faDoorOpen,
  faFilms: faFilms,
  faRightFromBracket: faRightFromBracket,
  faSignOutAlt: faSignOutAlt,
  faFaceGlasses: faFaceGlasses,
  faNfc: faNfc,
  faAtom: faAtom,
  faSoap: faSoap,
  faIcons: faIcons,
  faHeartMusicCameraBolt: faHeartMusicCameraBolt,
  faMicrophoneLinesSlash: faMicrophoneLinesSlash,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faClosedCaptioningSlash: faClosedCaptioningSlash,
  faCalculatorSimple: faCalculatorSimple,
  faCalculatorAlt: faCalculatorAlt,
  faBridgeCircleCheck: faBridgeCircleCheck,
  faSlidersUp: faSlidersUp,
  faSlidersV: faSlidersV,
  faLocationMinus: faLocationMinus,
  faMapMarkerMinus: faMapMarkerMinus,
  faPumpMedical: faPumpMedical,
  faFingerprint: faFingerprint,
  faSkiBoot: faSkiBoot,
  faStandardDefinition: faStandardDefinition,
  faRectangleSd: faRectangleSd,
  faH1: faH1,
  faHandPointRight: faHandPointRight,
  faMagnifyingGlassLocation: faMagnifyingGlassLocation,
  faSearchLocation: faSearchLocation,
  faMessageBot: faMessageBot,
  faForwardStep: faForwardStep,
  faStepForward: faStepForward,
  faFaceSmileBeam: faFaceSmileBeam,
  faSmileBeam: faSmileBeam,
  faLightCeiling: faLightCeiling,
  faMessageExclamation: faMessageExclamation,
  faCommentAltExclamation: faCommentAltExclamation,
  faBowlScoop: faBowlScoop,
  faBowlShavedIce: faBowlShavedIce,
  faSquareX: faSquareX,
  faUtilityPoleDouble: faUtilityPoleDouble,
  faFlagCheckered: faFlagCheckered,
  faChevronsUp: faChevronsUp,
  faChevronDoubleUp: faChevronDoubleUp,
  faFootball: faFootball,
  faFootballBall: faFootballBall,
  faUserVneck: faUserVneck,
  faSchoolCircleExclamation: faSchoolCircleExclamation,
  faCrop: faCrop,
  faAnglesDown: faAnglesDown,
  faAngleDoubleDown: faAngleDoubleDown,
  faUsersRectangle: faUsersRectangle,
  faPeopleRoof: faPeopleRoof,
  faSquareArrowRight: faSquareArrowRight,
  faArrowSquareRight: faArrowSquareRight,
  faLocationPlus: faLocationPlus,
  faMapMarkerPlus: faMapMarkerPlus,
  faLightbulbExclamationOn: faLightbulbExclamationOn,
  faPeopleLine: faPeopleLine,
  faBeerMugEmpty: faBeerMugEmpty,
  faBeer: faBeer,
  faCrateEmpty: faCrateEmpty,
  faDiagramPredecessor: faDiagramPredecessor,
  faTransporter: faTransporter,
  faCalendarCircleUser: faCalendarCircleUser,
  faArrowUpLong: faArrowUpLong,
  faLongArrowUp: faLongArrowUp,
  faPersonCarryBox: faPersonCarryBox,
  faPersonCarry: faPersonCarry,
  faFireFlameSimple: faFireFlameSimple,
  faBurn: faBurn,
  faPerson: faPerson,
  faMale: faMale,
  faLaptop: faLaptop,
  faFileCsv: faFileCsv,
  faMenorah: faMenorah,
  faUnion: faUnion,
  faChevronsLeft: faChevronsLeft,
  faChevronDoubleLeft: faChevronDoubleLeft,
  faCircleHeart: faCircleHeart,
  faHeartCircle: faHeartCircle,
  faTruckPlane: faTruckPlane,
  faRecordVinyl: faRecordVinyl,
  faBringForward: faBringForward,
  faSquareP: faSquareP,
  faFaceGrinStars: faFaceGrinStars,
  faGrinStars: faGrinStars,
  faSigma: faSigma,
  faCameraMovie: faCameraMovie,
  faBong: faBong,
  faClarinet: faClarinet,
  faTruckFlatbed: faTruckFlatbed,
  faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
  faPastafarianism: faPastafarianism,
  faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
  faLeafHeart: faLeafHeart,
  faHouseBuilding: faHouseBuilding,
  faCheeseSwiss: faCheeseSwiss,
  faSpoon: faSpoon,
  faUtensilSpoon: faUtensilSpoon,
  faJarWheat: faJarWheat,
  faEnvelopesBulk: faEnvelopesBulk,
  faMailBulk: faMailBulk,
  faFileCircleExclamation: faFileCircleExclamation,
  faBowArrow: faBowArrow,
  faCartXmark: faCartXmark,
  faHexagonXmark: faHexagonXmark,
  faTimesHexagon: faTimesHexagon,
  faXmarkHexagon: faXmarkHexagon,
  faCircleH: faCircleH,
  faHospitalSymbol: faHospitalSymbol,
  faMerge: faMerge,
  faPager: faPager,
  faCartMinus: faCartMinus,
  faAddressBook: faAddressBook,
  faContactBook: faContactBook,
  faPanFrying: faPanFrying,
  faGrid: faGrid,
  faGrid3: faGrid3,
  faFootballHelmet: faFootballHelmet,
  faHandLove: faHandLove,
  faTrees: faTrees,
  faStrikethrough: faStrikethrough,
  faPage: faPage,
  faK: faK,
  faDiagramPrevious: faDiagramPrevious,
  faGaugeMin: faGaugeMin,
  faTachometerAltSlowest: faTachometerAltSlowest,
  faFolderGrid: faFolderGrid,
  faEggplant: faEggplant,
  faRam: faRam,
  faLandmarkFlag: faLandmarkFlag,
  faLips: faLips,
  faPencil: faPencil,
  faPencilAlt: faPencilAlt,
  faBackward: faBackward,
  faCaretRight: faCaretRight,
  faComments: faComments,
  faPaste: faPaste,
  faFileClipboard: faFileClipboard,
  faDesktopArrowDown: faDesktopArrowDown,
  faCodePullRequest: faCodePullRequest,
  faPumpkin: faPumpkin,
  faClipboardList: faClipboardList,
  faPenField: faPenField,
  faBlueberries: faBlueberries,
  faTruckRampBox: faTruckRampBox,
  faTruckLoading: faTruckLoading,
  faNote: faNote,
  faArrowDownToSquare: faArrowDownToSquare,
  faUserCheck: faUserCheck,
  faCloudXmark: faCloudXmark,
  faVialVirus: faVialVirus,
  faBookBlank: faBookBlank,
  faBookAlt: faBookAlt,
  faGolfFlagHole: faGolfFlagHole,
  faMessageArrowDown: faMessageArrowDown,
  faCommentAltArrowDown: faCommentAltArrowDown,
  faFaceUnamused: faFaceUnamused,
  faSheetPlastic: faSheetPlastic,
  faCircle9: faCircle9,
  faBlog: faBlog,
  faUserNinja: faUserNinja,
  faPencilSlash: faPencilSlash,
  faBowlingPins: faBowlingPins,
  faPersonArrowUpFromLine: faPersonArrowUpFromLine,
  faDownRight: faDownRight,
  faScrollTorah: faScrollTorah,
  faTorah: faTorah,
  faWebhook: faWebhook,
  faBlindsOpen: faBlindsOpen,
  faFence: faFence,
  faUp: faUp,
  faArrowAltUp: faArrowAltUp,
  faBroomBall: faBroomBall,
  faQuidditch: faQuidditch,
  faQuidditchBroomBall: faQuidditchBroomBall,
  faDrumstick: faDrumstick,
  faSquareV: faSquareV,
  faFaceAwesome: faFaceAwesome,
  faGaveDandy: faGaveDandy,
  faDialOff: faDialOff,
  faToggleOff: faToggleOff,
  faFaceSmileHorns: faFaceSmileHorns,
  faBoxArchive: faBoxArchive,
  faArchive: faArchive,
  faGrapes: faGrapes,
  faPersonDrowning: faPersonDrowning,
  faDialMax: faDialMax,
  faCircleM: faCircleM,
  faCalendarImage: faCalendarImage,
  faCircleCaretDown: faCircleCaretDown,
  faCaretCircleDown: faCaretCircleDown,
  faArrowDown91: faArrowDown91,
  faSortNumericDesc: faSortNumericDesc,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faFaceGrinTongueSquint: faFaceGrinTongueSquint,
  faGrinTongueSquint: faGrinTongueSquint,
  faShishKebab: faShishKebab,
  faSprayCan: faSprayCan,
  faAlarmSnooze: faAlarmSnooze,
  faScarecrow: faScarecrow,
  faTruckMonster: faTruckMonster,
  faGiftCard: faGiftCard,
  faW: faW,
  faCodePullRequestDraft: faCodePullRequestDraft,
  faSquareB: faSquareB,
  faElephant: faElephant,
  faEarthAfrica: faEarthAfrica,
  faGlobeAfrica: faGlobeAfrica,
  faRainbow: faRainbow,
  faCircleNotch: faCircleNotch,
  faTabletScreenButton: faTabletScreenButton,
  faTabletAlt: faTabletAlt,
  faPaw: faPaw,
  faMessageQuestion: faMessageQuestion,
  faCloud: faCloud,
  faTrowelBricks: faTrowelBricks,
  faSquare3: faSquare3,
  faFaceFlushed: faFaceFlushed,
  faFlushed: faFlushed,
  faHospitalUser: faHospitalUser,
  faMicrowave: faMicrowave,
  faChfSign: faChfSign,
  faTentArrowLeftRight: faTentArrowLeftRight,
  faCartCircleArrowUp: faCartCircleArrowUp,
  faTrashClock: faTrashClock,
  faGavel: faGavel,
  faLegal: faLegal,
  faSprinklerCeiling: faSprinklerCeiling,
  faBrowsers: faBrowsers,
  faTrillium: faTrillium,
  faMusicSlash: faMusicSlash,
  faTruckRamp: faTruckRamp,
  faBinoculars: faBinoculars,
  faMicrophoneSlash: faMicrophoneSlash,
  faBoxTissue: faBoxTissue,
  faCircleC: faCircleC,
  faStarChristmas: faStarChristmas,
  faChartBullet: faChartBullet,
  faMotorcycle: faMotorcycle,
  faTreeChristmas: faTreeChristmas,
  faTireFlat: faTireFlat,
  faSunglasses: faSunglasses,
  faBadge: faBadge,
  faMessagePen: faMessagePen,
  faCommentAltEdit: faCommentAltEdit,
  faMessageEdit: faMessageEdit,
  faBellConcierge: faBellConcierge,
  faConciergeBell: faConciergeBell,
  faPenRuler: faPenRuler,
  faPencilRuler: faPencilRuler,
  faArrowProgress: faArrowProgress,
  faChessRookPiece: faChessRookPiece,
  faChessRookAlt: faChessRookAlt,
  faSquareRoot: faSquareRoot,
  faAlbumCollectionCirclePlus: faAlbumCollectionCirclePlus,
  faPeopleArrows: faPeopleArrows,
  faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
  faFaceAngryHorns: faFaceAngryHorns,
  faMarsAndVenusBurst: faMarsAndVenusBurst,
  faTombstone: faTombstone,
  faSquareCaretRight: faSquareCaretRight,
  faCaretSquareRight: faCaretSquareRight,
  faScissors: faScissors,
  faCut: faCut,
  faListMusic: faListMusic,
  faSunPlantWilt: faSunPlantWilt,
  faToiletsPortable: faToiletsPortable,
  faHockeyPuck: faHockeyPuck,
  faMustache: faMustache,
  faHyphen: faHyphen,
  faTable: faTable,
  faUserChef: faUserChef,
  faMessageImage: faMessageImage,
  faCommentAltImage: faCommentAltImage,
  faUsersMedical: faUsersMedical,
  faSensorTriangleExclamation: faSensorTriangleExclamation,
  faSensorAlert: faSensorAlert,
  faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
  faTachographDigital: faTachographDigital,
  faDigitalTachograph: faDigitalTachograph,
  faFaceMask: faFaceMask,
  faPickleball: faPickleball,
  faStarSharpHalf: faStarSharpHalf,
  faUsersSlash: faUsersSlash,
  faClover: faClover,
  faMeat: faMeat,
  faReply: faReply,
  faMailReply: faMailReply,
  faStarAndCrescent: faStarAndCrescent,
  faEmptySet: faEmptySet,
  faHouseFire: faHouseFire,
  faSquareMinus: faSquareMinus,
  faMinusSquare: faMinusSquare,
  faHelicopter: faHelicopter,
  faBird: faBird,
  faCompass: faCompass,
  faSquareCaretDown: faSquareCaretDown,
  faCaretSquareDown: faCaretSquareDown,
  faHeartHalfStroke: faHeartHalfStroke,
  faHeartHalfAlt: faHeartHalfAlt,
  faFileCircleQuestion: faFileCircleQuestion,
  faLaptopCode: faLaptopCode,
  faJoystick: faJoystick,
  faGrillFire: faGrillFire,
  faRectangleVerticalHistory: faRectangleVerticalHistory,
  faSwatchbook: faSwatchbook,
  faPrescriptionBottle: faPrescriptionBottle,
  faBars: faBars,
  faNavicon: faNavicon,
  faKeyboardLeft: faKeyboardLeft,
  faPeopleGroup: faPeopleGroup,
  faHourglassEnd: faHourglassEnd,
  faHourglass3: faHourglass3,
  faHeartCrack: faHeartCrack,
  faHeartBroken: faHeartBroken,
  faFaceBeamHandOverMouth: faFaceBeamHandOverMouth,
  faDropletPercent: faDropletPercent,
  faHumidity: faHumidity,
  faSquareUpRight: faSquareUpRight,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faFaceKissBeam: faFaceKissBeam,
  faKissBeam: faKissBeam,
  faCorn: faCorn,
  faRollerCoaster: faRollerCoaster,
  faPhotoFilmMusic: faPhotoFilmMusic,
  faRadar: faRadar,
  faSickle: faSickle,
  faFilm: faFilm,
  faCoconut: faCoconut,
  faRulerHorizontal: faRulerHorizontal,
  faShieldCross: faShieldCross,
  faCassetteTape: faCassetteTape,
  faSquareTerminal: faSquareTerminal,
  faPeopleRobbery: faPeopleRobbery,
  faLightbulb: faLightbulb,
  faCaretLeft: faCaretLeft,
  faCommentMiddle: faCommentMiddle,
  faTrashCanList: faTrashCanList,
  faBlock: faBlock,
  faCircleExclamation: faCircleExclamation,
  faExclamationCircle: faExclamationCircle,
  faSchoolCircleXmark: faSchoolCircleXmark,
  faArrowRightFromBracket: faArrowRightFromBracket,
  faSignOut: faSignOut,
  faFaceFrownSlight: faFaceFrownSlight,
  faCircleChevronDown: faCircleChevronDown,
  faChevronCircleDown: faChevronCircleDown,
  faSidebarFlip: faSidebarFlip,
  faUnlockKeyhole: faUnlockKeyhole,
  faUnlockAlt: faUnlockAlt,
  faTemperatureList: faTemperatureList,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faHeadphonesSimple: faHeadphonesSimple,
  faHeadphonesAlt: faHeadphonesAlt,
  faSitemap: faSitemap,
  faPipeSection: faPipeSection,
  faSpaceStationMoonConstruction: faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt: faSpaceStationMoonAlt,
  faCircleDollarToSlot: faCircleDollarToSlot,
  faDonate: faDonate,
  faMemory: faMemory,
  faFaceSleeping: faFaceSleeping,
  faRoadSpikes: faRoadSpikes,
  faFireBurner: faFireBurner,
  faSquirrel: faSquirrel,
  faArrowUpToLine: faArrowUpToLine,
  faArrowToTop: faArrowToTop,
  faFlag: faFlag,
  faFaceCowboyHat: faFaceCowboyHat,
  faHanukiah: faHanukiah,
  faChartScatter3d: faChartScatter3d,
  faDisplayChartUp: faDisplayChartUp,
  faSquareCode: faSquareCode,
  faFeather: faFeather,
  faVolumeLow: faVolumeLow,
  faVolumeDown: faVolumeDown,
  faXmarkToSlot: faXmarkToSlot,
  faTimesToSlot: faTimesToSlot,
  faVoteNay: faVoteNay,
  faBoxTaped: faBoxTaped,
  faBoxAlt: faBoxAlt,
  faCommentSlash: faCommentSlash,
  faSwords: faSwords,
  faCloudSunRain: faCloudSunRain,
  faAlbum: faAlbum,
  faCircleN: faCircleN,
  faCompress: faCompress,
  faWheatAwn: faWheatAwn,
  faWheatAlt: faWheatAlt,
  faAnkh: faAnkh,
  faHandsHoldingChild: faHandsHoldingChild,
  faAsterisk: faAsterisk,
  faKeySkeletonLeftRight: faKeySkeletonLeftRight,
  faCommentLines: faCommentLines,
  faLuchadorMask: faLuchadorMask,
  faLuchador: faLuchador,
  faMaskLuchador: faMaskLuchador,
  faSquareCheck: faSquareCheck,
  faCheckSquare: faCheckSquare,
  faShredder: faShredder,
  faBookOpenCover: faBookOpenCover,
  faBookOpenAlt: faBookOpenAlt,
  faSandwich: faSandwich,
  faPesetaSign: faPesetaSign,
  faSquareParkingSlash: faSquareParkingSlash,
  faParkingSlash: faParkingSlash,
  faTrainTunnel: faTrainTunnel,
  faHeading: faHeading,
  faHeader: faHeader,
  faGhost: faGhost,
  faFaceAnguished: faFaceAnguished,
  faHockeySticks: faHockeySticks,
  faAbacus: faAbacus,
  faFilmSimple: faFilmSimple,
  faFilmAlt: faFilmAlt,
  faList: faList,
  faListSquares: faListSquares,
  faTreePalm: faTreePalm,
  faSquarePhoneFlip: faSquarePhoneFlip,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faCartPlus: faCartPlus,
  faGamepad: faGamepad,
  faBorderCenterV: faBorderCenterV,
  faCircleDot: faCircleDot,
  faDotCircle: faDotCircle,
  faClipboardMedical: faClipboardMedical,
  faFaceDizzy: faFaceDizzy,
  faDizzy: faDizzy,
  faEgg: faEgg,
  faUpToLine: faUpToLine,
  faArrowAltToTop: faArrowAltToTop,
  faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
  faWatchFitness: faWatchFitness,
  faClockNineThirty: faClockNineThirty,
  faCampground: faCampground,
  faFolderPlus: faFolderPlus,
  faJug: faJug,
  faFutbol: faFutbol,
  faFutbolBall: faFutbolBall,
  faSoccerBall: faSoccerBall,
  faSnowBlowing: faSnowBlowing,
  faPaintbrush: faPaintbrush,
  faPaintBrush: faPaintBrush,
  faLock: faLock,
  faArrowDownFromLine: faArrowDownFromLine,
  faArrowFromTop: faArrowFromTop,
  faGasPump: faGasPump,
  faSignalBarsSlash: faSignalBarsSlash,
  faSignalAltSlash: faSignalAltSlash,
  faMonkey: faMonkey,
  faRectanglePro: faRectanglePro,
  faPro: faPro,
  faHouseNight: faHouseNight,
  faHotTubPerson: faHotTubPerson,
  faHotTub: faHotTub,
  faGlobePointer: faGlobePointer,
  faBlanket: faBlanket,
  faMapLocation: faMapLocation,
  faMapMarked: faMapMarked,
  faHouseFloodWater: faHouseFloodWater,
  faCommentsQuestionCheck: faCommentsQuestionCheck,
  faTree: faTree,
  faArrowsCross: faArrowsCross,
  faBackpack: faBackpack,
  faSquareSmall: faSquareSmall,
  faFolderArrowUp: faFolderArrowUp,
  faFolderUpload: faFolderUpload,
  faBridgeLock: faBridgeLock,
  faCrosshairsSimple: faCrosshairsSimple,
  faSackDollar: faSackDollar,
  faPenToSquare: faPenToSquare,
  faEdit: faEdit,
  faSquareSliders: faSquareSliders,
  faSlidersHSquare: faSlidersHSquare,
  faCarSide: faCarSide,
  faMessageMiddleTop: faMessageMiddleTop,
  faCommentMiddleTopAlt: faCommentMiddleTopAlt,
  faLightbulbOn: faLightbulbOn,
  faKnife: faKnife,
  faUtensilKnife: faUtensilKnife,
  faShareNodes: faShareNodes,
  faShareAlt: faShareAlt,
  faDisplayChartUpCircleDollar: faDisplayChartUpCircleDollar,
  faWaveSine: faWaveSine,
  faHeartCircleMinus: faHeartCircleMinus,
  faCircleW: faCircleW,
  faCircleCalendar: faCircleCalendar,
  faCalendarCircle: faCalendarCircle,
  faHourglassHalf: faHourglassHalf,
  faHourglass2: faHourglass2,
  faMicroscope: faMicroscope,
  faSunset: faSunset,
  faSink: faSink,
  faCalendarExclamation: faCalendarExclamation,
  faTruckContainerEmpty: faTruckContainerEmpty,
  faHandHeart: faHandHeart,
  faBagShopping: faBagShopping,
  faShoppingBag: faShoppingBag,
  faArrowDownZA: faArrowDownZA,
  faSortAlphaDesc: faSortAlphaDesc,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faMitten: faMitten,
  faReplyClock: faReplyClock,
  faReplyTime: faReplyTime,
  faPersonRays: faPersonRays,
  faRight: faRight,
  faArrowAltRight: faArrowAltRight,
  faCircleF: faCircleF,
  faUsers: faUsers,
  faFacePleading: faFacePleading,
  faEyeSlash: faEyeSlash,
  faFlaskVial: faFlaskVial,
  faPoliceBox: faPoliceBox,
  faCucumber: faCucumber,
  faHeadSideBrain: faHeadSideBrain,
  faHand: faHand,
  faHandPaper: faHandPaper,
  faPersonBikingMountain: faPersonBikingMountain,
  faBikingMountain: faBikingMountain,
  faUtensilsSlash: faUtensilsSlash,
  faPrintMagnifyingGlass: faPrintMagnifyingGlass,
  faPrintSearch: faPrintSearch,
  faFolderBookmark: faFolderBookmark,
  faOm: faOm,
  faPi: faPi,
  faFlaskRoundPotion: faFlaskRoundPotion,
  faFlaskPotion: faFlaskPotion,
  faFaceShush: faFaceShush,
  faWorm: faWorm,
  faHouseCircleXmark: faHouseCircleXmark,
  faPlug: faPlug,
  faCalendarCircleExclamation: faCalendarCircleExclamation,
  faSquareI: faSquareI,
  faChevronUp: faChevronUp,
  faFaceSaluting: faFaceSaluting,
  faGaugeSimpleLow: faGaugeSimpleLow,
  faTachometerSlow: faTachometerSlow,
  faFacePersevering: faFacePersevering,
  faCircleCamera: faCircleCamera,
  faCameraCircle: faCameraCircle,
  faHandSpock: faHandSpock,
  faSpiderWeb: faSpiderWeb,
  faCircleMicrophone: faCircleMicrophone,
  faMicrophoneCircle: faMicrophoneCircle,
  faBookArrowUp: faBookArrowUp,
  faPopsicle: faPopsicle,
  faCommand: faCommand,
  faBlinds: faBlinds,
  faStopwatch: faStopwatch,
  faSaxophone: faSaxophone,
  faSquare2: faSquare2,
  faFieldHockeyStickBall: faFieldHockeyStickBall,
  faFieldHockey: faFieldHockey,
  faArrowUpSquareTriangle: faArrowUpSquareTriangle,
  faSortShapesUpAlt: faSortShapesUpAlt,
  faFaceScream: faFaceScream,
  faSquareM: faSquareM,
  faCameraWeb: faCameraWeb,
  faWebcam: faWebcam,
  faCommentArrowDown: faCommentArrowDown,
  faLightbulbCfl: faLightbulbCfl,
  faWindowFrameOpen: faWindowFrameOpen,
  faFaceKiss: faFaceKiss,
  faKiss: faKiss,
  faBridgeCircleXmark: faBridgeCircleXmark,
  faPeriod: faPeriod,
  faFaceGrinTongue: faFaceGrinTongue,
  faGrinTongue: faGrinTongue,
  faUpToDottedLine: faUpToDottedLine,
  faThoughtBubble: faThoughtBubble,
  faSkeletonRibs: faSkeletonRibs,
  faRaygun: faRaygun,
  faFlute: faFlute,
  faAcorn: faAcorn,
  faVideoArrowUpRight: faVideoArrowUpRight,
  faGrateDroplet: faGrateDroplet,
  faSealExclamation: faSealExclamation,
  faChessBishop: faChessBishop,
  faMessageSms: faMessageSms,
  faCoffeeBeans: faCoffeeBeans,
  faHatWitch: faHatWitch,
  faFaceGrinWink: faFaceGrinWink,
  faGrinWink: faGrinWink,
  faClockThreeThirty: faClockThreeThirty,
  faEarDeaf: faEarDeaf,
  faDeaf: faDeaf,
  faDeafness: faDeafness,
  faHardOfHearing: faHardOfHearing,
  faAlarmClock: faAlarmClock,
  faEclipse: faEclipse,
  faFaceRelieved: faFaceRelieved,
  faRoadCircleCheck: faRoadCircleCheck,
  faDiceFive: faDiceFive,
  faOctagonMinus: faOctagonMinus,
  faMinusOctagon: faMinusOctagon,
  faSquareRss: faSquareRss,
  faRssSquare: faRssSquare,
  faFaceZany: faFaceZany,
  faTricycle: faTricycle,
  faLandMineOn: faLandMineOn,
  faSquareArrowUpLeft: faSquareArrowUpLeft,
  faICursor: faICursor,
  faChartMixedUpCircleDollar: faChartMixedUpCircleDollar,
  faSaltShaker: faSaltShaker,
  faStamp: faStamp,
  faFilePlus: faFilePlus,
  faDrawSquare: faDrawSquare,
  faToiletPaperUnderSlash: faToiletPaperUnderSlash,
  faToiletPaperReverseSlash: faToiletPaperReverseSlash,
  faStairs: faStairs,
  faDroneFront: faDroneFront,
  faDroneAlt: faDroneAlt,
  faGlassEmpty: faGlassEmpty,
  faDialHigh: faDialHigh,
  faUserHelmetSafety: faUserHelmetSafety,
  faUserConstruction: faUserConstruction,
  faUserHardHat: faUserHardHat,
  faI: faI,
  faHryvniaSign: faHryvniaSign,
  faHryvnia: faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter: faArrowDownLeftAndArrowUpRightToCenter,
  faPills: faPills,
  faFaceGrinWide: faFaceGrinWide,
  faGrinAlt: faGrinAlt,
  faTooth: faTooth,
  faBasketballHoop: faBasketballHoop,
  faObjectsAlignBottom: faObjectsAlignBottom,
  faV: faV,
  faSparkles: faSparkles,
  faSquid: faSquid,
  faLeafyGreen: faLeafyGreen,
  faCircleArrowUpRight: faCircleArrowUpRight,
  faCalendars: faCalendars,
  faBangladeshiTakaSign: faBangladeshiTakaSign,
  faBicycle: faBicycle,
  faHammerWar: faHammerWar,
  faCircleD: faCircleD,
  faSpiderBlackWidow: faSpiderBlackWidow,
  faStaffSnake: faStaffSnake,
  faRodAsclepius: faRodAsclepius,
  faRodSnake: faRodSnake,
  faStaffAesculapius: faStaffAesculapius,
  faPear: faPear,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faTriangle: faTriangle,
  faApartment: faApartment,
  faTruckMedical: faTruckMedical,
  faAmbulance: faAmbulance,
  faPepper: faPepper,
  faPiano: faPiano,
  faGunSquirt: faGunSquirt,
  faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
  faSnowman: faSnowman,
  faUserAlien: faUserAlien,
  faShieldCheck: faShieldCheck,
  faMortarPestle: faMortarPestle,
  faRoadBarrier: faRoadBarrier,
  faChartCandlestick: faChartCandlestick,
  faBriefcaseBlank: faBriefcaseBlank,
  faSchool: faSchool,
  faIgloo: faIgloo,
  faBracketRound: faBracketRound,
  faParenthesis: faParenthesis,
  faJoint: faJoint,
  faHorseSaddle: faHorseSaddle,
  faMugMarshmallows: faMugMarshmallows,
  faFilters: faFilters,
  faBellOn: faBellOn,
  faAngleRight: faAngleRight,
  faDialMed: faDialMed,
  faHorse: faHorse,
  faQ: faQ,
  faMonitorWaveform: faMonitorWaveform,
  faMonitorHeartRate: faMonitorHeartRate,
  faLinkSimple: faLinkSimple,
  faWhistle: faWhistle,
  faG: faG,
  faWineGlassCrack: faWineGlassCrack,
  faFragile: faFragile,
  faSlotMachine: faSlotMachine,
  faNotesMedical: faNotesMedical,
  faCarWash: faCarWash,
  faEscalator: faEscalator,
  faCommentImage: faCommentImage,
  faTemperatureHalf: faTemperatureHalf,
  faTemperature2: faTemperature2,
  faThermometer2: faThermometer2,
  faThermometerHalf: faThermometerHalf,
  faDongSign: faDongSign,
  faDonut: faDonut,
  faDoughnut: faDoughnut,
  faCapsules: faCapsules,
  faPooStorm: faPooStorm,
  faPooBolt: faPooBolt,
  faTally1: faTally1,
  faFaceFrownOpen: faFaceFrownOpen,
  faFrownOpen: faFrownOpen,
  faSquareDashed: faSquareDashed,
  faSquareJ: faSquareJ,
  faHandPointUp: faHandPointUp,
  faMoneyBill: faMoneyBill,
  faArrowUpBigSmall: faArrowUpBigSmall,
  faSortSizeUp: faSortSizeUp,
  faBarcodeRead: faBarcodeRead,
  faBaguette: faBaguette,
  faBowlSoftServe: faBowlSoftServe,
  faFaceHoldingBackTears: faFaceHoldingBackTears,
  faSquareUp: faSquareUp,
  faArrowAltSquareUp: faArrowAltSquareUp,
  faTrainSubwayTunnel: faTrainSubwayTunnel,
  faSubwayTunnel: faSubwayTunnel,
  faSquareExclamation: faSquareExclamation,
  faExclamationSquare: faExclamationSquare,
  faSemicolon: faSemicolon,
  faBookmark: faBookmark,
  faFanTable: faFanTable,
  faAlignJustify: faAlignJustify,
  faBatteryLow: faBatteryLow,
  faBattery1: faBattery1,
  faCreditCardFront: faCreditCardFront,
  faBrainArrowCurvedRight: faBrainArrowCurvedRight,
  faMindShare: faMindShare,
  faUmbrellaBeach: faUmbrellaBeach,
  faHelmetUn: faHelmetUn,
  faLocationSmile: faLocationSmile,
  faMapMarkerSmile: faMapMarkerSmile,
  faArrowLeftToLine: faArrowLeftToLine,
  faArrowToLeft: faArrowToLeft,
  faBullseye: faBullseye,
  faSushi: faSushi,
  faNigiri: faNigiri,
  faMessageCaptions: faMessageCaptions,
  faCommentAltCaptions: faCommentAltCaptions,
  faTrashList: faTrashList,
  faBacon: faBacon,
  faOption: faOption,
  faRaccoon: faRaccoon,
  faHandPointDown: faHandPointDown,
  faArrowUpFromBracket: faArrowUpFromBracket,
  faHeadSideGear: faHeadSideGear,
  faTrashPlus: faTrashPlus,
  faObjectsAlignTop: faObjectsAlignTop,
  faFolder: faFolder,
  faFolderBlank: faFolderBlank,
  faFaceAnxiousSweat: faFaceAnxiousSweat,
  faCreditCardBlank: faCreditCardBlank,
  faFileWaveform: faFileWaveform,
  faFileMedicalAlt: faFileMedicalAlt,
  faMicrochipAi: faMicrochipAi,
  faMug: faMug,
  faPlaneUpSlash: faPlaneUpSlash,
  faRadiation: faRadiation,
  faPenCircle: faPenCircle,
  faBagSeedling: faBagSeedling,
  faChartSimple: faChartSimple,
  faCrutches: faCrutches,
  faCircleParking: faCircleParking,
  faParkingCircle: faParkingCircle,
  faMarsStroke: faMarsStroke,
  faLeafOak: faLeafOak,
  faSquareBolt: faSquareBolt,
  faVial: faVial,
  faGauge: faGauge,
  faDashboard: faDashboard,
  faGaugeMed: faGaugeMed,
  faTachometerAltAverage: faTachometerAltAverage,
  faWandMagicSparkles: faWandMagicSparkles,
  faMagicWandSparkles: faMagicWandSparkles,
  faLambda: faLambda,
  faE: faE,
  faPizza: faPizza,
  faBowlChopsticksNoodles: faBowlChopsticksNoodles,
  faH3: faH3,
  faPenClip: faPenClip,
  faPenAlt: faPenAlt,
  faBridgeCircleExclamation: faBridgeCircleExclamation,
  faBadgePercent: faBadgePercent,
  faUser: faUser,
  faSensor: faSensor,
  faComma: faComma,
  faSchoolCircleCheck: faSchoolCircleCheck,
  faToiletPaperUnder: faToiletPaperUnder,
  faToiletPaperReverse: faToiletPaperReverse,
  faLightEmergency: faLightEmergency,
  faArrowDownToArc: faArrowDownToArc,
  faDumpster: faDumpster,
  faVanShuttle: faVanShuttle,
  faShuttleVan: faShuttleVan,
  faBuildingUser: faBuildingUser,
  faLightSwitch: faLightSwitch,
  faSquareCaretLeft: faSquareCaretLeft,
  faCaretSquareLeft: faCaretSquareLeft,
  faHighlighter: faHighlighter,
  faWavePulse: faWavePulse,
  faHeartRate: faHeartRate,
  faKey: faKey,
  faHatSanta: faHatSanta,
  faTamale: faTamale,
  faBoxCheck: faBoxCheck,
  faBullhorn: faBullhorn,
  faSteak: faSteak,
  faLocationCrosshairsSlash: faLocationCrosshairsSlash,
  faLocationSlash: faLocationSlash,
  faPersonDolly: faPersonDolly,
  faGlobe: faGlobe,
  faSynagogue: faSynagogue,
  faFileChartColumn: faFileChartColumn,
  faFileChartLine: faFileChartLine,
  faPersonHalfDress: faPersonHalfDress,
  faFolderImage: faFolderImage,
  faCalendarPen: faCalendarPen,
  faCalendarEdit: faCalendarEdit,
  faRoadBridge: faRoadBridge,
  faFaceSmileTear: faFaceSmileTear,
  faMessagePlus: faMessagePlus,
  faCommentAltPlus: faCommentAltPlus,
  faLocationArrow: faLocationArrow,
  faC: faC,
  faTabletButton: faTabletButton,
  faPersonDressFairy: faPersonDressFairy,
  faRectangleHistoryCircleUser: faRectangleHistoryCircleUser,
  faBuildingLock: faBuildingLock,
  faChartLineUp: faChartLineUp,
  faMailbox: faMailbox,
  faTruckBolt: faTruckBolt,
  faPizzaSlice: faPizzaSlice,
  faMoneyBillWave: faMoneyBillWave,
  faChartArea: faChartArea,
  faAreaChart: faAreaChart,
  faHouseFlag: faHouseFlag,
  faCircleThreeQuartersStroke: faCircleThreeQuartersStroke,
  faPersonCircleMinus: faPersonCircleMinus,
  faScalpel: faScalpel,
  faBan: faBan,
  faCancel: faCancel,
  faBellExclamation: faBellExclamation,
  faCircleBookmark: faCircleBookmark,
  faBookmarkCircle: faBookmarkCircle,
  faEggFried: faEggFried,
  faFaceWeary: faFaceWeary,
  faUniformMartialArts: faUniformMartialArts,
  faCameraRotate: faCameraRotate,
  faSunDust: faSunDust,
  faCommentText: faCommentText,
  faSprayCanSparkles: faSprayCanSparkles,
  faAirFreshener: faAirFreshener,
  faSignalBars: faSignalBars,
  faSignalAlt: faSignalAlt,
  faSignalAlt4: faSignalAlt4,
  faSignalBarsStrong: faSignalBarsStrong,
  faDiamondExclamation: faDiamondExclamation,
  faStar: faStar,
  faDialMin: faDialMin,
  faRepeat: faRepeat,
  faCross: faCross,
  faPageCaretDown: faPageCaretDown,
  faFileCaretDown: faFileCaretDown,
  faBox: faBox,
  faVenusMars: faVenusMars,
  faClockSevenThirty: faClockSevenThirty,
  faArrowPointer: faArrowPointer,
  faMousePointer: faMousePointer,
  faClockFourThirty: faClockFourThirty,
  faSignalBarsGood: faSignalBarsGood,
  faSignalAlt3: faSignalAlt3,
  faCactus: faCactus,
  faLightbulbGear: faLightbulbGear,
  faMaximize: faMaximize,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faChargingStation: faChargingStation,
  faShapes: faShapes,
  faTriangleCircleSquare: faTriangleCircleSquare,
  faPlaneTail: faPlaneTail,
  faGaugeSimpleMax: faGaugeSimpleMax,
  faTachometerFastest: faTachometerFastest,
  faCircleU: faCircleU,
  faShieldSlash: faShieldSlash,
  faSquarePhoneHangup: faSquarePhoneHangup,
  faPhoneSquareDown: faPhoneSquareDown,
  faArrowUpLeft: faArrowUpLeft,
  faTransporter1: faTransporter1,
  faPeanuts: faPeanuts,
  faShuffle: faShuffle,
  faRandom: faRandom,
  faPersonRunning: faPersonRunning,
  faRunning: faRunning,
  faMobileRetro: faMobileRetro,
  faGripLinesVertical: faGripLinesVertical,
  faBinBottlesRecycle: faBinBottlesRecycle,
  faArrowUpFromSquare: faArrowUpFromSquare,
  faFileDashedLine: faFileDashedLine,
  faPageBreak: faPageBreak,
  faBracketCurlyRight: faBracketCurlyRight,
  faSpider: faSpider,
  faClockThree: faClockThree,
  faHandsBound: faHandsBound,
  faScalpelLineDashed: faScalpelLineDashed,
  faScalpelPath: faScalpelPath,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faPipeSmoking: faPipeSmoking,
  faFaceAstonished: faFaceAstonished,
  faWindow: faWindow,
  faPlaneCircleExclamation: faPlaneCircleExclamation,
  faEar: faEar,
  faFileLock: faFileLock,
  faDiagramVenn: faDiagramVenn,
  faXRay: faXRay,
  faGoalNet: faGoalNet,
  faCoffinCross: faCoffinCross,
  faSpellCheck: faSpellCheck,
  faLocationXmark: faLocationXmark,
  faMapMarkerTimes: faMapMarkerTimes,
  faMapMarkerXmark: faMapMarkerXmark,
  faCircleQuarterStroke: faCircleQuarterStroke,
  faLasso: faLasso,
  faSlash: faSlash,
  faPersonToPortal: faPersonToPortal,
  faPortalEnter: faPortalEnter,
  faCalendarStar: faCalendarStar,
  faComputerMouse: faComputerMouse,
  faMouse: faMouse,
  faArrowRightToBracket: faArrowRightToBracket,
  faSignIn: faSignIn,
  faPegasus: faPegasus,
  faFilesMedical: faFilesMedical,
  faNfcLock: faNfcLock,
  faPersonSkiLift: faPersonSkiLift,
  faSkiLift: faSkiLift,
  faSquare6: faSquare6,
  faShopSlash: faShopSlash,
  faStoreAltSlash: faStoreAltSlash,
  faWindTurbine: faWindTurbine,
  faSlidersSimple: faSlidersSimple,
  faGridRound: faGridRound,
  faBadgeSheriff: faBadgeSheriff,
  faServer: faServer,
  faVirusCovidSlash: faVirusCovidSlash,
  faIntersection: faIntersection,
  faShopLock: faShopLock,
  faFamily: faFamily,
  faHourglassStart: faHourglassStart,
  faHourglass1: faHourglass1,
  faUserHairBuns: faUserHairBuns,
  faBlenderPhone: faBlenderPhone,
  faHourglassClock: faHourglassClock,
  faPersonSeatReclined: faPersonSeatReclined,
  faPaperPlaneTop: faPaperPlaneTop,
  faPaperPlaneAlt: faPaperPlaneAlt,
  faSend: faSend,
  faMessageArrowUp: faMessageArrowUp,
  faCommentAltArrowUp: faCommentAltArrowUp,
  faLightbulbExclamation: faLightbulbExclamation,
  faLayerMinus: faLayerMinus,
  faLayerGroupMinus: faLayerGroupMinus,
  faChartPieSimpleCircleCurrency: faChartPieSimpleCircleCurrency,
  faCircleE: faCircleE,
  faBuildingWheat: faBuildingWheat,
  faGaugeMax: faGaugeMax,
  faTachometerAltFastest: faTachometerAltFastest,
  faPersonBreastfeeding: faPersonBreastfeeding,
  faApostrophe: faApostrophe,
  faFireHydrant: faFireHydrant,
  faRightToBracket: faRightToBracket,
  faSignInAlt: faSignInAlt,
  faVideoPlus: faVideoPlus,
  faSquareRight: faSquareRight,
  faArrowAltSquareRight: faArrowAltSquareRight,
  faCommentSmile: faCommentSmile,
  faVenus: faVenus,
  faPassport: faPassport,
  faInboxIn: faInboxIn,
  faInboxArrowDown: faInboxArrowDown,
  faHeartPulse: faHeartPulse,
  faHeartbeat: faHeartbeat,
  faCircle8: faCircle8,
  faCloudsMoon: faCloudsMoon,
  faClockTenThirty: faClockTenThirty,
  faPeopleCarryBox: faPeopleCarryBox,
  faPeopleCarry: faPeopleCarry,
  faFolderUser: faFolderUser,
  faTrashCanXmark: faTrashCanXmark,
  faTemperatureHigh: faTemperatureHigh,
  faMicrochip: faMicrochip,
  faLeftLongToLine: faLeftLongToLine,
  faCrown: faCrown,
  faWeightHanging: faWeightHanging,
  faXmarksLines: faXmarksLines,
  faFilePrescription: faFilePrescription,
  faCalendarRange: faCalendarRange,
  faFlowerDaffodil: faFlowerDaffodil,
  faHandBackPointUp: faHandBackPointUp,
  faWeightScale: faWeightScale,
  faWeight: faWeight,
  faArrowUpToArc: faArrowUpToArc,
  faStarExclamation: faStarExclamation,
  faBooks: faBooks,
  faUserGroup: faUserGroup,
  faUserFriends: faUserFriends,
  faArrowUpAZ: faArrowUpAZ,
  faSortAlphaUp: faSortAlphaUp,
  faLayerPlus: faLayerPlus,
  faLayerGroupPlus: faLayerGroupPlus,
  faPlayPause: faPlayPause,
  faBlockQuestion: faBlockQuestion,
  faSnooze: faSnooze,
  faZzz: faZzz,
  faScannerImage: faScannerImage,
  faTvRetro: faTvRetro,
  faSquareT: faSquareT,
  faFarm: faFarm,
  faBarnSilo: faBarnSilo,
  faChessKnight: faChessKnight,
  faBarsSort: faBarsSort,
  faPalletBoxes: faPalletBoxes,
  faPaletteBoxes: faPaletteBoxes,
  faPalletAlt: faPalletAlt,
  faFaceLaughSquint: faFaceLaughSquint,
  faLaughSquint: faLaughSquint,
  faCodeSimple: faCodeSimple,
  faBoltSlash: faBoltSlash,
  faPanelFire: faPanelFire,
  faBinaryCircleCheck: faBinaryCircleCheck,
  faCommentMinus: faCommentMinus,
  faBurrito: faBurrito,
  faViolin: faViolin,
  faObjectsColumn: faObjectsColumn,
  faSquareChevronDown: faSquareChevronDown,
  faChevronSquareDown: faChevronSquareDown,
  faCommentPlus: faCommentPlus,
  faTriangleInstrument: faTriangleInstrument,
  faTriangleMusic: faTriangleMusic,
  faWheelchair: faWheelchair,
  faUserPilotTie: faUserPilotTie,
  faPianoKeyboard: faPianoKeyboard,
  faBedEmpty: faBedEmpty,
  faCircleArrowUp: faCircleArrowUp,
  faArrowCircleUp: faArrowCircleUp,
  faToggleOn: faToggleOn,
  faRectangleVertical: faRectangleVertical,
  faRectanglePortrait: faRectanglePortrait,
  faPersonWalking: faPersonWalking,
  faWalking: faWalking,
  faL: faL,
  faSignalStream: faSignalStream,
  faDownToBracket: faDownToBracket,
  faCircleZ: faCircleZ,
  faStars: faStars,
  faFire: faFire,
  faBedPulse: faBedPulse,
  faProcedures: faProcedures,
  faHouseDay: faHouseDay,
  faShuttleSpace: faShuttleSpace,
  faSpaceShuttle: faSpaceShuttle,
  faShirtLongSleeve: faShirtLongSleeve,
  faChartPieSimple: faChartPieSimple,
  faChartPieAlt: faChartPieAlt,
  faFaceLaugh: faFaceLaugh,
  faLaugh: faLaugh,
  faFolderOpen: faFolderOpen,
  faAlbumCollectionCircleUser: faAlbumCollectionCircleUser,
  faCandy: faCandy,
  faBowlHot: faBowlHot,
  faSoup: faSoup,
  faFlatbread: faFlatbread,
  faHeartCirclePlus: faHeartCirclePlus,
  faCodeFork: faCodeFork,
  faCity: faCity,
  faSignalBarsWeak: faSignalBarsWeak,
  faSignalAlt1: faSignalAlt1,
  faMicrophoneLines: faMicrophoneLines,
  faMicrophoneAlt: faMicrophoneAlt,
  faClockTwelve: faClockTwelve,
  faPepperHot: faPepperHot,
  faCitrusSlice: faCitrusSlice,
  faSheep: faSheep,
  faUnlock: faUnlock,
  faColonSign: faColonSign,
  faHeadset: faHeadset,
  faBadgerHoney: faBadgerHoney,
  faH4: faH4,
  faStoreSlash: faStoreSlash,
  faRoadCircleXmark: faRoadCircleXmark,
  faSignalSlash: faSignalSlash,
  faUserMinus: faUserMinus,
  faMarsStrokeUp: faMarsStrokeUp,
  faMarsStrokeV: faMarsStrokeV,
  faChampagneGlasses: faChampagneGlasses,
  faGlassCheers: faGlassCheers,
  faTaco: faTaco,
  faHexagonPlus: faHexagonPlus,
  faPlusHexagon: faPlusHexagon,
  faClipboard: faClipboard,
  faHouseCircleExclamation: faHouseCircleExclamation,
  faFileArrowUp: faFileArrowUp,
  faFileUpload: faFileUpload,
  faWifi: faWifi,
  faWifi3: faWifi3,
  faWifiStrong: faWifiStrong,
  faMessages: faMessages,
  faCommentsAlt: faCommentsAlt,
  faBath: faBath,
  faBathtub: faBathtub,
  faUmbrellaSimple: faUmbrellaSimple,
  faUmbrellaAlt: faUmbrellaAlt,
  faRectangleHistoryCirclePlus: faRectangleHistoryCirclePlus,
  faUnderline: faUnderline,
  faPrescriptionBottlePill: faPrescriptionBottlePill,
  faUserPen: faUserPen,
  faUserEdit: faUserEdit,
  faBinarySlash: faBinarySlash,
  faSquareO: faSquareO,
  faSignature: faSignature,
  faStroopwafel: faStroopwafel,
  faBold: faBold,
  faAnchorLock: faAnchorLock,
  faBuildingNgo: faBuildingNgo,
  faTransporter3: faTransporter3,
  faEngineWarning: faEngineWarning,
  faEngineExclamation: faEngineExclamation,
  faCircleDownRight: faCircleDownRight,
  faSquareK: faSquareK,
  faManatSign: faManatSign,
  faMoneyCheckPen: faMoneyCheckPen,
  faMoneyCheckEdit: faMoneyCheckEdit,
  faNotEqual: faNotEqual,
  faBorderTopLeft: faBorderTopLeft,
  faBorderStyle: faBorderStyle,
  faMapLocationDot: faMapLocationDot,
  faMapMarkedAlt: faMapMarkedAlt,
  faTilde: faTilde,
  faJedi: faJedi,
  faSquarePollVertical: faSquarePollVertical,
  faPoll: faPoll,
  faArrowDownSquareTriangle: faArrowDownSquareTriangle,
  faSortShapesDownAlt: faSortShapesDownAlt,
  faMugHot: faMugHot,
  faDogLeashed: faDogLeashed,
  faCarBattery: faCarBattery,
  faBatteryCar: faBatteryCar,
  faFaceDowncastSweat: faFaceDowncastSweat,
  faMailboxFlagUp: faMailboxFlagUp,
  faMemoCircleInfo: faMemoCircleInfo,
  faGift: faGift,
  faDiceTwo: faDiceTwo,
  faVolume: faVolume,
  faVolumeMedium: faVolumeMedium,
  faTransporter5: faTransporter5,
  faGaugeCircleBolt: faGaugeCircleBolt,
  faCoinFront: faCoinFront,
  faFileSlash: faFileSlash,
  faMessageArrowUpRight: faMessageArrowUpRight,
  faTreasureChest: faTreasureChest,
  faChessQueen: faChessQueen,
  faPaintbrushFine: faPaintbrushFine,
  faPaintBrushAlt: faPaintBrushAlt,
  faPaintBrushFine: faPaintBrushFine,
  faPaintbrushAlt: faPaintbrushAlt,
  faGlasses: faGlasses,
  faHoodCloak: faHoodCloak,
  faSquareQuote: faSquareQuote,
  faUpLeft: faUpLeft,
  faBringFront: faBringFront,
  faChessBoard: faChessBoard,
  faBurgerCheese: faBurgerCheese,
  faCheeseburger: faCheeseburger,
  faBuildingCircleCheck: faBuildingCircleCheck,
  faRepeat1: faRepeat1,
  faArrowDownToLine: faArrowDownToLine,
  faArrowToBottom: faArrowToBottom,
  faGrid5: faGrid5,
  faSwapArrows: faSwapArrows,
  faRightLongToLine: faRightLongToLine,
  faPersonChalkboard: faPersonChalkboard,
  faMarsStrokeRight: faMarsStrokeRight,
  faMarsStrokeH: faMarsStrokeH,
  faHandBackFist: faHandBackFist,
  faHandRock: faHandRock,
  faGridRound5: faGridRound5,
  faTally: faTally,
  faTally5: faTally5,
  faSquareCaretUp: faSquareCaretUp,
  faCaretSquareUp: faCaretSquareUp,
  faCloudShowersWater: faCloudShowersWater,
  faChartBar: faChartBar,
  faBarChart: faBarChart,
  faHandsBubbles: faHandsBubbles,
  faHandsWash: faHandsWash,
  faLessThanEqual: faLessThanEqual,
  faTrain: faTrain,
  faUpFromDottedLine: faUpFromDottedLine,
  faEyeLowVision: faEyeLowVision,
  faLowVision: faLowVision,
  faTrafficLightGo: faTrafficLightGo,
  faFaceExhaling: faFaceExhaling,
  faSensorFire: faSensorFire,
  faUserUnlock: faUserUnlock,
  faHexagonDivide: faHexagonDivide,
  fa00: fa00,
  faCrow: faCrow,
  faCassetteBetamax: faCassetteBetamax,
  faBetamax: faBetamax,
  faSailboat: faSailboat,
  faWindowRestore: faWindowRestore,
  faNfcMagnifyingGlass: faNfcMagnifyingGlass,
  faFileBinary: faFileBinary,
  faCircleV: faCircleV,
  faSquarePlus: faSquarePlus,
  faPlusSquare: faPlusSquare,
  faBowlScoops: faBowlScoops,
  faMistletoe: faMistletoe,
  faCustard: faCustard,
  faLacrosseStick: faLacrosseStick,
  faHockeyMask: faHockeyMask,
  faSunrise: faSunrise,
  faSubtitles: faSubtitles,
  faPanelEws: faPanelEws,
  faToriiGate: faToriiGate,
  faCloudExclamation: faCloudExclamation,
  faMessageLines: faMessageLines,
  faCommentAltLines: faCommentAltLines,
  faFrog: faFrog,
  faBucket: faBucket,
  faFloppyDiskPen: faFloppyDiskPen,
  faImage: faImage,
  faWindowFrame: faWindowFrame,
  faMicrophone: faMicrophone,
  faCow: faCow,
  faFileZip: faFileZip,
  faSquareRing: faSquareRing,
  faDownFromLine: faDownFromLine,
  faArrowAltFromTop: faArrowAltFromTop,
  faCaretUp: faCaretUp,
  faShieldXmark: faShieldXmark,
  faShieldTimes: faShieldTimes,
  faScrewdriver: faScrewdriver,
  faCircleSortDown: faCircleSortDown,
  faSortCircleDown: faSortCircleDown,
  faFolderClosed: faFolderClosed,
  faHouseTsunami: faHouseTsunami,
  faSquareNfi: faSquareNfi,
  faForklift: faForklift,
  faArrowUpFromGroundWater: faArrowUpFromGroundWater,
  faBracketSquareRight: faBracketSquareRight,
  faMartiniGlass: faMartiniGlass,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faRotateLeft: faRotateLeft,
  faRotateBack: faRotateBack,
  faRotateBackward: faRotateBackward,
  faUndoAlt: faUndoAlt,
  faTableColumns: faTableColumns,
  faColumns: faColumns,
  faSquareA: faSquareA,
  faTick: faTick,
  faLemon: faLemon,
  faHeadSideMask: faHeadSideMask,
  faHandshake: faHandshake,
  faGem: faGem,
  faDolly: faDolly,
  faDollyBox: faDollyBox,
  faSmoking: faSmoking,
  faMinimize: faMinimize,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faRefrigerator: faRefrigerator,
  faMonument: faMonument,
  faOctagonXmark: faOctagonXmark,
  faTimesOctagon: faTimesOctagon,
  faXmarkOctagon: faXmarkOctagon,
  faAlignSlash: faAlignSlash,
  faSnowplow: faSnowplow,
  faAnglesRight: faAnglesRight,
  faAngleDoubleRight: faAngleDoubleRight,
  faTruckRampCouch: faTruckRampCouch,
  faTruckCouch: faTruckCouch,
  faCannabis: faCannabis,
  faCirclePlay: faCirclePlay,
  faPlayCircle: faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter: faArrowUpRightAndArrowDownLeftFromCenter,
  faTablets: faTablets,
  fa360Degrees: fa360Degrees,
  faEthernet: faEthernet,
  faEuroSign: faEuroSign,
  faEur: faEur,
  faEuro: faEuro,
  faChair: faChair,
  faCircleCheck: faCircleCheck,
  faCheckCircle: faCheckCircle,
  faSquareDashedCirclePlus: faSquareDashedCirclePlus,
  faMoneySimpleFromBracket: faMoneySimpleFromBracket,
  faBat: faBat,
  faCircleStop: faCircleStop,
  faStopCircle: faStopCircle,
  faHeadSideHeadphones: faHeadSideHeadphones,
  faPhoneRotary: faPhoneRotary,
  faCompassDrafting: faCompassDrafting,
  faDraftingCompass: faDraftingCompass,
  faPlateWheat: faPlateWheat,
  faCalendarCircleMinus: faCalendarCircleMinus,
  faChopsticks: faChopsticks,
  faCarWrench: faCarWrench,
  faCarMechanic: faCarMechanic,
  faIcicles: faIcicles,
  faPersonShelter: faPersonShelter,
  faNeuter: faNeuter,
  faIdBadge: faIdBadge,
  faKazoo: faKazoo,
  faMarker: faMarker,
  faBinBottles: faBinBottles,
  faFaceLaughBeam: faFaceLaughBeam,
  faLaughBeam: faLaughBeam,
  faSquareArrowDownLeft: faSquareArrowDownLeft,
  faBatteryBolt: faBatteryBolt,
  faTreeLarge: faTreeLarge,
  faHelicopterSymbol: faHelicopterSymbol,
  faAperture: faAperture,
  faUniversalAccess: faUniversalAccess,
  faGearComplex: faGearComplex,
  faFileMagnifyingGlass: faFileMagnifyingGlass,
  faFileSearch: faFileSearch,
  faUpRight: faUpRight,
  faCircleChevronUp: faCircleChevronUp,
  faChevronCircleUp: faChevronCircleUp,
  faUserPolice: faUserPolice,
  faLariSign: faLariSign,
  faVolcano: faVolcano,
  faTeddyBear: faTeddyBear,
  faStocking: faStocking,
  faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
  faImageSlash: faImageSlash,
  faMaskSnorkel: faMaskSnorkel,
  faSmoke: faSmoke,
  faSterlingSign: faSterlingSign,
  faGbp: faGbp,
  faPoundSign: faPoundSign,
  faBatteryExclamation: faBatteryExclamation,
  faViruses: faViruses,
  faSquarePersonConfined: faSquarePersonConfined,
  faUserTie: faUserTie,
  faArrowDownLong: faArrowDownLong,
  faLongArrowDown: faLongArrowDown,
  faTentArrowDownToLine: faTentArrowDownToLine,
  faCertificate: faCertificate,
  faCrystalBall: faCrystalBall,
  faReplyAll: faReplyAll,
  faMailReplyAll: faMailReplyAll,
  faSuitcase: faSuitcase,
  faPersonSkating: faPersonSkating,
  faSkating: faSkating,
  faStarShooting: faStarShooting,
  faBinaryLock: faBinaryLock,
  faFilterCircleDollar: faFilterCircleDollar,
  faFunnelDollar: faFunnelDollar,
  faCameraRetro: faCameraRetro,
  faCircleArrowDown: faCircleArrowDown,
  faArrowCircleDown: faArrowCircleDown,
  faCommentPen: faCommentPen,
  faCommentEdit: faCommentEdit,
  faFileImport: faFileImport,
  faArrowRightToFile: faArrowRightToFile,
  faBanjo: faBanjo,
  faSquareArrowUpRight: faSquareArrowUpRight,
  faExternalLinkSquare: faExternalLinkSquare,
  faLightEmergencyOn: faLightEmergencyOn,
  faKerning: faKerning,
  faBoxOpen: faBoxOpen,
  faSquareF: faSquareF,
  faScroll: faScroll,
  faSpa: faSpa,
  faArrowLeftFromLine: faArrowLeftFromLine,
  faArrowFromRight: faArrowFromRight,
  faStrawberry: faStrawberry,
  faLocationPinLock: faLocationPinLock,
  faPause: faPause,
  faClockEightThirty: faClockEightThirty,
  faPlaneEngines: faPlaneEngines,
  faPlaneAlt: faPlaneAlt,
  faHillAvalanche: faHillAvalanche,
  faTemperatureEmpty: faTemperatureEmpty,
  faTemperature0: faTemperature0,
  faThermometer0: faThermometer0,
  faThermometerEmpty: faThermometerEmpty,
  faBomb: faBomb,
  faGaugeLow: faGaugeLow,
  faTachometerAltSlow: faTachometerAltSlow,
  faRegistered: faRegistered,
  faTrashCanPlus: faTrashCanPlus,
  faAddressCard: faAddressCard,
  faContactCard: faContactCard,
  faVcard: faVcard,
  faScaleUnbalancedFlip: faScaleUnbalancedFlip,
  faBalanceScaleRight: faBalanceScaleRight,
  faGlobeSnow: faGlobeSnow,
  faSubscript: faSubscript,
  faDiamondTurnRight: faDiamondTurnRight,
  faDirections: faDirections,
  faIntegral: faIntegral,
  faBurst: faBurst,
  faHouseLaptop: faHouseLaptop,
  faLaptopHouse: faLaptopHouse,
  faFaceTired: faFaceTired,
  faTired: faTired,
  faMoneyBills: faMoneyBills,
  faBlindsRaised: faBlindsRaised,
  faSmog: faSmog,
  faUfoBeam: faUfoBeam,
  faCircleCaretUp: faCircleCaretUp,
  faCaretCircleUp: faCaretCircleUp,
  faUserVneckHairLong: faUserVneckHairLong,
  faSquareALock: faSquareALock,
  faCrutch: faCrutch,
  faGasPumpSlash: faGasPumpSlash,
  faFontAwesome: faFontAwesome,
  faFontAwesomeFlag: faFontAwesomeFlag,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faCloudArrowUp: faCloudArrowUp,
  faCloudUpload: faCloudUpload,
  faCloudUploadAlt: faCloudUploadAlt,
  faPalette: faPalette,
  faTransporter4: faTransporter4,
  faChartMixedUpCircleCurrency: faChartMixedUpCircleCurrency,
  faObjectsAlignRight: faObjectsAlignRight,
  faArrowsTurnRight: faArrowsTurnRight,
  faVest: faVest,
  faPig: faPig,
  faInboxFull: faInboxFull,
  faCircleEnvelope: faCircleEnvelope,
  faEnvelopeCircle: faEnvelopeCircle,
  faTrianglePersonDigging: faTrianglePersonDigging,
  faConstruction: faConstruction,
  faFerry: faFerry,
  faBullseyeArrow: faBullseyeArrow,
  faArrowsDownToPeople: faArrowsDownToPeople,
  faSeedling: faSeedling,
  faSprout: faSprout,
  faClockSeven: faClockSeven,
  faLeftRight: faLeftRight,
  faArrowsAltH: faArrowsAltH,
  faBoxesPacking: faBoxesPacking,
  faCircleArrowLeft: faCircleArrowLeft,
  faArrowCircleLeft: faArrowCircleLeft,
  faFlashlight: faFlashlight,
  faGroupArrowsRotate: faGroupArrowsRotate,
  faBowlFood: faBowlFood,
  faSquare9: faSquare9,
  faCandyCane: faCandyCane,
  faArrowDownWideShort: faArrowDownWideShort,
  faSortAmountAsc: faSortAmountAsc,
  faSortAmountDown: faSortAmountDown,
  faSquareDollar: faSquareDollar,
  faDollarSquare: faDollarSquare,
  faUsdSquare: faUsdSquare,
  faPhoneArrowRight: faPhoneArrowRight,
  faHandHoldingSeedling: faHandHoldingSeedling,
  faMessageCheck: faMessageCheck,
  faCommentAltCheck: faCommentAltCheck,
  faCloudBolt: faCloudBolt,
  faThunderstorm: faThunderstorm,
  faChartLineUpDown: faChartLineUpDown,
  faTextSlash: faTextSlash,
  faRemoveFormat: faRemoveFormat,
  faWatch: faWatch,
  faCircleDownLeft: faCircleDownLeft,
  faText: faText,
  faProjector: faProjector,
  faFaceSmileWink: faFaceSmileWink,
  faSmileWink: faSmileWink,
  faTombstoneBlank: faTombstoneBlank,
  faTombstoneAlt: faTombstoneAlt,
  faChessKingPiece: faChessKingPiece,
  faChessKingAlt: faChessKingAlt,
  faCircle6: faCircle6,
  faLeft: faLeft,
  faArrowAltLeft: faArrowAltLeft,
  faFileWord: faFileWord,
  faFilePowerpoint: faFilePowerpoint,
  faSquareDown: faSquareDown,
  faArrowAltSquareDown: faArrowAltSquareDown,
  faObjectsAlignCenterVertical: faObjectsAlignCenterVertical,
  faArrowsLeftRight: faArrowsLeftRight,
  faArrowsH: faArrowsH,
  faHouseLock: faHouseLock,
  faCloudArrowDown: faCloudArrowDown,
  faCloudDownload: faCloudDownload,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faWreath: faWreath,
  faChildren: faChildren,
  faMeterDroplet: faMeterDroplet,
  faChalkboard: faChalkboard,
  faBlackboard: faBlackboard,
  faUserLargeSlash: faUserLargeSlash,
  faUserAltSlash: faUserAltSlash,
  faSignalStrong: faSignalStrong,
  faSignal4: faSignal4,
  faLollipop: faLollipop,
  faLollypop: faLollypop,
  faListTree: faListTree,
  faEnvelopeOpen: faEnvelopeOpen,
  faDrawCircle: faDrawCircle,
  faCatSpace: faCatSpace,
  faHandshakeSimpleSlash: faHandshakeSimpleSlash,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faRabbitRunning: faRabbitRunning,
  faRabbitFast: faRabbitFast,
  faMemoPad: faMemoPad,
  faMattressPillow: faMattressPillow,
  faAlarmPlus: faAlarmPlus,
  faAlicorn: faAlicorn,
  faCommentQuestion: faCommentQuestion,
  faGingerbreadMan: faGingerbreadMan,
  faGuaraniSign: faGuaraniSign,
  faBurgerFries: faBurgerFries,
  faMugTea: faMugTea,
  faBorderTop: faBorderTop,
  faArrowsRotate: faArrowsRotate,
  faRefresh: faRefresh,
  faSync: faSync,
  faCircleBookOpen: faCircleBookOpen,
  faBookCircle: faBookCircle,
  faArrowsToDottedLine: faArrowsToDottedLine,
  faFireExtinguisher: faFireExtinguisher,
  faGarageOpen: faGarageOpen,
  faShelvesEmpty: faShelvesEmpty,
  faCruzeiroSign: faCruzeiroSign,
  faWatchApple: faWatchApple,
  faWatchCalculator: faWatchCalculator,
  faListDropdown: faListDropdown,
  faCabinetFiling: faCabinetFiling,
  faBurgerSoda: faBurgerSoda,
  faSquareArrowUp: faSquareArrowUp,
  faArrowSquareUp: faArrowSquareUp,
  faGreaterThanEqual: faGreaterThanEqual,
  faPalletBox: faPalletBox,
  faFaceConfounded: faFaceConfounded,
  faShieldHalved: faShieldHalved,
  faShieldAlt: faShieldAlt,
  faTruckPlow: faTruckPlow,
  faBookAtlas: faBookAtlas,
  faAtlas: faAtlas,
  faVirus: faVirus,
  faGridRound2: faGridRound2,
  faCommentMiddleTop: faCommentMiddleTop,
  faEnvelopeCircleCheck: faEnvelopeCircleCheck,
  faLayerGroup: faLayerGroup,
  faRestroomSimple: faRestroomSimple,
  faArrowsToDot: faArrowsToDot,
  faBorderOuter: faBorderOuter,
  faHashtagLock: faHashtagLock,
  faClockTwoThirty: faClockTwoThirty,
  faArchway: faArchway,
  faHeartCircleCheck: faHeartCircleCheck,
  faHouseChimneyCrack: faHouseChimneyCrack,
  faHouseDamage: faHouseDamage,
  faFileZipper: faFileZipper,
  faFileArchive: faFileArchive,
  faHeartHalf: faHeartHalf,
  faCommentCheck: faCommentCheck,
  faSquare: faSquare,
  faMemo: faMemo,
  faMartiniGlassEmpty: faMartiniGlassEmpty,
  faGlassMartini: faGlassMartini,
  faCouch: faCouch,
  faCediSign: faCediSign,
  faItalic: faItalic,
  faGlassCitrus: faGlassCitrus,
  faCalendarLinesPen: faCalendarLinesPen,
  faChurch: faChurch,
  faPersonSnowmobiling: faPersonSnowmobiling,
  faSnowmobile: faSnowmobile,
  faFaceHushed: faFaceHushed,
  faCommentsDollar: faCommentsDollar,
  faPickaxe: faPickaxe,
  faLinkSimpleSlash: faLinkSimpleSlash,
  faDemocrat: faDemocrat,
  faFaceConfused: faFaceConfused,
  faPinball: faPinball,
  faZ: faZ,
  faPersonSkiing: faPersonSkiing,
  faSkiing: faSkiing,
  faDeer: faDeer,
  faInputPipe: faInputPipe,
  faRoadLock: faRoadLock,
  faA: faA,
  faBookmarkSlash: faBookmarkSlash,
  faTemperatureArrowDown: faTemperatureArrowDown,
  faTemperatureDown: faTemperatureDown,
  faMace: faMace,
  faFeatherPointed: faFeatherPointed,
  faFeatherAlt: faFeatherAlt,
  faSausage: faSausage,
  faTrashCanClock: faTrashCanClock,
  faP: faP,
  faBroomWide: faBroomWide,
  faSnowflake: faSnowflake,
  faStomach: faStomach,
  faNewspaper: faNewspaper,
  faRectangleAd: faRectangleAd,
  faAd: faAd,
  faGuitarElectric: faGuitarElectric,
  faArrowTurnDownRight: faArrowTurnDownRight,
  faMoonCloud: faMoonCloud,
  faBreadSliceButter: faBreadSliceButter,
  faCircleArrowRight: faCircleArrowRight,
  faArrowCircleRight: faArrowCircleRight,
  faUserGroupCrown: faUserGroupCrown,
  faUsersCrown: faUsersCrown,
  faCircleI: faCircleI,
  faToiletPaperCheck: faToiletPaperCheck,
  faFilterCircleXmark: faFilterCircleXmark,
  faLocust: faLocust,
  faSort: faSort,
  faUnsorted: faUnsorted,
  faListOl: faListOl,
  faList12: faList12,
  faListNumeric: faListNumeric,
  faChartWaterfall: faChartWaterfall,
  faSparkle: faSparkle,
  faFaceParty: faFaceParty,
  faKidneys: faKidneys,
  faWifiExclamation: faWifiExclamation,
  faChartNetwork: faChartNetwork,
  faPersonDressBurst: faPersonDressBurst,
  faDiceD4: faDiceD4,
  faMoneyCheckDollar: faMoneyCheckDollar,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faVectorSquare: faVectorSquare,
  faBreadSlice: faBreadSlice,
  faLanguage: faLanguage,
  faWheatAwnSlash: faWheatAwnSlash,
  faFaceKissWinkHeart: faFaceKissWinkHeart,
  faKissWinkHeart: faKissWinkHeart,
  faDagger: faDagger,
  faPodium: faPodium,
  faMemoCircleCheck: faMemoCircleCheck,
  faRouteHighway: faRouteHighway,
  faDownToLine: faDownToLine,
  faArrowAltToBottom: faArrowAltToBottom,
  faFilter: faFilter,
  faSquareG: faSquareG,
  faCirclePhone: faCirclePhone,
  faPhoneCircle: faPhoneCircle,
  faClipboardPrescription: faClipboardPrescription,
  faUserNurseHair: faUserNurseHair,
  faQuestion: faQuestion,
  faFileSignature: faFileSignature,
  faToggleLargeOn: faToggleLargeOn,
  faUpDownLeftRight: faUpDownLeftRight,
  faArrowsAlt: faArrowsAlt,
  faDryerHeat: faDryerHeat,
  faDryerAlt: faDryerAlt,
  faHouseChimneyUser: faHouseChimneyUser,
  faHandHoldingHeart: faHandHoldingHeart,
  faArrowUpSmallBig: faArrowUpSmallBig,
  faSortSizeUpAlt: faSortSizeUpAlt,
  faTrainTrack: faTrainTrack,
  faPuzzlePiece: faPuzzlePiece,
  faMoneyCheck: faMoneyCheck,
  faStarHalfStroke: faStarHalfStroke,
  faStarHalfAlt: faStarHalfAlt,
  faFileExclamation: faFileExclamation,
  faCode: faCode,
  faWhiskeyGlass: faWhiskeyGlass,
  faGlassWhiskey: faGlassWhiskey,
  faMoonStars: faMoonStars,
  faBuildingCircleExclamation: faBuildingCircleExclamation,
  faClothesHanger: faClothesHanger,
  faMobileNotch: faMobileNotch,
  faMobileIphone: faMobileIphone,
  faMagnifyingGlassChart: faMagnifyingGlassChart,
  faArrowUpRightFromSquare: faArrowUpRightFromSquare,
  faExternalLink: faExternalLink,
  faCubesStacked: faCubesStacked,
  faImagesUser: faImagesUser,
  faWonSign: faWonSign,
  faKrw: faKrw,
  faWon: faWon,
  faImagePolaroidUser: faImagePolaroidUser,
  faVirusCovid: faVirusCovid,
  faSquareEllipsis: faSquareEllipsis,
  faPie: faPie,
  faChessKnightPiece: faChessKnightPiece,
  faChessKnightAlt: faChessKnightAlt,
  faAustralSign: faAustralSign,
  faCloudPlus: faCloudPlus,
  faF: faF,
  faLeaf: faLeaf,
  faBedBunk: faBedBunk,
  faRoad: faRoad,
  faTaxi: faTaxi,
  faCab: faCab,
  faPersonCirclePlus: faPersonCirclePlus,
  faChartPie: faChartPie,
  faPieChart: faPieChart,
  faBoltLightning: faBoltLightning,
  faClockEight: faClockEight,
  faSackXmark: faSackXmark,
  faFileExcel: faFileExcel,
  faFileContract: faFileContract,
  faFishFins: faFishFins,
  faCircleQ: faCircleQ,
  faBuildingFlag: faBuildingFlag,
  faFaceGrinBeam: faFaceGrinBeam,
  faGrinBeam: faGrinBeam,
  faObjectUngroup: faObjectUngroup,
  faFaceDisguise: faFaceDisguise,
  faCircleArrowDownRight: faCircleArrowDownRight,
  faAlien8bit: faAlien8bit,
  faAlienMonster: faAlienMonster,
  faHandPointRibbon: faHandPointRibbon,
  faPoop: faPoop,
  faObjectExclude: faObjectExclude,
  faTelescope: faTelescope,
  faLocationPin: faLocationPin,
  faMapMarker: faMapMarker,
  faSquareList: faSquareList,
  faKaaba: faKaaba,
  faToiletPaper: faToiletPaper,
  faHelmetSafety: faHelmetSafety,
  faHardHat: faHardHat,
  faHatHard: faHatHard,
  faCommentCode: faCommentCode,
  faSimCards: faSimCards,
  faStarship: faStarship,
  faEject: faEject,
  faCircleRight: faCircleRight,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faPlaneCircleCheck: faPlaneCircleCheck,
  faSeal: faSeal,
  faUserCowboy: faUserCowboy,
  faHexagonVerticalNft: faHexagonVerticalNft,
  faFaceRollingEyes: faFaceRollingEyes,
  faMehRollingEyes: faMehRollingEyes,
  faBreadLoaf: faBreadLoaf,
  faRingsWedding: faRingsWedding,
  faObjectGroup: faObjectGroup,
  faFrenchFries: faFrenchFries,
  faChartLine: faChartLine,
  faLineChart: faLineChart,
  faCalendarArrowDown: faCalendarArrowDown,
  faCalendarDownload: faCalendarDownload,
  faSendBack: faSendBack,
  faMaskVentilator: faMaskVentilator,
  faSignatureLock: faSignatureLock,
  faArrowRight: faArrowRight,
  faSignsPost: faSignsPost,
  faMapSigns: faMapSigns,
  faOctagonPlus: faOctagonPlus,
  faPlusOctagon: faPlusOctagon,
  faCashRegister: faCashRegister,
  faPersonCircleQuestion: faPersonCircleQuestion,
  faMelonSlice: faMelonSlice,
  faSpaceStationMoon: faSpaceStationMoon,
  faMessageSmile: faMessageSmile,
  faCommentAltSmile: faCommentAltSmile,
  faCupStraw: faCupStraw,
  faLeftFromLine: faLeftFromLine,
  faArrowAltFromRight: faArrowAltFromRight,
  faH: faH,
  faBasketShoppingSimple: faBasketShoppingSimple,
  faShoppingBasketAlt: faShoppingBasketAlt,
  faHandsHoldingHeart: faHandsHoldingHeart,
  faHandsHeart: faHandsHeart,
  faClockNine: faClockNine,
  faTarp: faTarp,
  faFaceSleepy: faFaceSleepy,
  faHandHorns: faHandHorns,
  faScrewdriverWrench: faScrewdriverWrench,
  faTools: faTools,
  faArrowsToEye: faArrowsToEye,
  faCircleThreeQuarters: faCircleThreeQuarters,
  faTrophyStar: faTrophyStar,
  faTrophyAlt: faTrophyAlt,
  faPlugCircleBolt: faPlugCircleBolt,
  faFaceThermometer: faFaceThermometer,
  faGridRound4: faGridRound4,
  faShirtRunning: faShirtRunning,
  faBookCircleArrowUp: faBookCircleArrowUp,
  faFaceNauseated: faFaceNauseated,
  faHeart: faHeart,
  faFileChartPie: faFileChartPie,
  faMarsAndVenus: faMarsAndVenus,
  faHouseUser: faHouseUser,
  faHomeUser: faHomeUser,
  faCircleArrowDownLeft: faCircleArrowDownLeft,
  faDumpsterFire: faDumpsterFire,
  faHexagonMinus: faHexagonMinus,
  faMinusHexagon: faMinusHexagon,
  faLeftToLine: faLeftToLine,
  faArrowAltToLeft: faArrowAltToLeft,
  faHouseCrack: faHouseCrack,
  faPawSimple: faPawSimple,
  faPawAlt: faPawAlt,
  faArrowLeftLongToLine: faArrowLeftLongToLine,
  faBracketsRound: faBracketsRound,
  faParentheses: faParentheses,
  faMartiniGlassCitrus: faMartiniGlassCitrus,
  faCocktail: faCocktail,
  faUserShakespeare: faUserShakespeare,
  faArrowRightToArc: faArrowRightToArc,
  faFaceSurprise: faFaceSurprise,
  faSurprise: faSurprise,
  faBottleWater: faBottleWater,
  faCirclePause: faCirclePause,
  faPauseCircle: faPauseCircle,
  faGaugeCirclePlus: faGaugeCirclePlus,
  faFolders: faFolders,
  faAngel: faAngel,
  faValueAbsolute: faValueAbsolute,
  faRabbit: faRabbit,
  faToiletPaperSlash: faToiletPaperSlash,
  faCircleEuro: faCircleEuro,
  faAppleWhole: faAppleWhole,
  faAppleAlt: faAppleAlt,
  faKitchenSet: faKitchenSet,
  faDiamondHalf: faDiamondHalf,
  faLockKeyhole: faLockKeyhole,
  faLockAlt: faLockAlt,
  faR: faR,
  faTemperatureQuarter: faTemperatureQuarter,
  faTemperature1: faTemperature1,
  faThermometer1: faThermometer1,
  faThermometerQuarter: faThermometerQuarter,
  faSquareInfo: faSquareInfo,
  faInfoSquare: faInfoSquare,
  faWifiSlash: faWifiSlash,
  faToiletPaperXmark: faToiletPaperXmark,
  faHandsHoldingDollar: faHandsHoldingDollar,
  faHandsUsd: faHandsUsd,
  faCube: faCube,
  faArrowDownTriangleSquare: faArrowDownTriangleSquare,
  faSortShapesDown: faSortShapesDown,
  faBitcoinSign: faBitcoinSign,
  faShutters: faShutters,
  faShieldDog: faShieldDog,
  faSolarPanel: faSolarPanel,
  faLockOpen: faLockOpen,
  faTableTree: faTableTree,
  faHouseChimneyHeart: faHouseChimneyHeart,
  faTally3: faTally3,
  faElevator: faElevator,
  faMoneyBillTransfer: faMoneyBillTransfer,
  faMoneyBillTrendUp: faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal: faSquarePollHorizontal,
  faPollH: faPollH,
  faCircle: faCircle,
  faCartCircleExclamation: faCartCircleExclamation,
  faSword: faSword,
  faBackwardFast: faBackwardFast,
  faFastBackward: faFastBackward,
  faRecycle: faRecycle,
  faUserAstronaut: faUserAstronaut,
  faInterrobang: faInterrobang,
  faPlaneSlash: faPlaneSlash,
  faCircleDashed: faCircleDashed,
  faTrademark: faTrademark,
  faBasketball: faBasketball,
  faBasketballBall: faBasketballBall,
  faForkKnife: faForkKnife,
  faUtensilsAlt: faUtensilsAlt,
  faSatelliteDish: faSatelliteDish,
  faBadgeCheck: faBadgeCheck,
  faCircleUp: faCircleUp,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faSlider: faSlider,
  faMobileScreenButton: faMobileScreenButton,
  faMobileAlt: faMobileAlt,
  faClockOneThirty: faClockOneThirty,
  faInboxOut: faInboxOut,
  faInboxArrowUp: faInboxArrowUp,
  faCloudSlash: faCloudSlash,
  faVolumeHigh: faVolumeHigh,
  faVolumeUp: faVolumeUp,
  faUsersRays: faUsersRays,
  faWallet: faWallet,
  faOctagonCheck: faOctagonCheck,
  faFlatbreadStuffed: faFlatbreadStuffed,
  faClipboardCheck: faClipboardCheck,
  faCartCirclePlus: faCartCirclePlus,
  faTruckClock: faTruckClock,
  faShippingTimed: faShippingTimed,
  faPool8Ball: faPool8Ball,
  faFileAudio: faFileAudio,
  faTurnDownLeft: faTurnDownLeft,
  faLockHashtag: faLockHashtag,
  faChartRadar: faChartRadar,
  faStaff: faStaff,
  faBurger: faBurger,
  faHamburger: faHamburger,
  faUtilityPole: faUtilityPole,
  faTransporter6: faTransporter6,
  faWrench: faWrench,
  faBugs: faBugs,
  faVectorPolygon: faVectorPolygon,
  faDiagramNested: faDiagramNested,
  faRupeeSign: faRupeeSign,
  faRupee: faRupee,
  faFileImage: faFileImage,
  faCircleQuestion: faCircleQuestion,
  faQuestionCircle: faQuestionCircle,
  faImageUser: faImageUser,
  faBuoy: faBuoy,
  faPlaneDeparture: faPlaneDeparture,
  faHandshakeSlash: faHandshakeSlash,
  faBookBookmark: faBookBookmark,
  faBorderCenterH: faBorderCenterH,
  faCanFood: faCanFood,
  faTypewriter: faTypewriter,
  faArrowRightFromArc: faArrowRightFromArc,
  faCircleK: faCircleK,
  faFaceHandOverMouth: faFaceHandOverMouth,
  faPopcorn: faPopcorn,
  faHouseWater: faHouseWater,
  faHouseFlood: faHouseFlood,
  faObjectSubtract: faObjectSubtract,
  faCodeBranch: faCodeBranch,
  faWarehouseFull: faWarehouseFull,
  faWarehouseAlt: faWarehouseAlt,
  faHatCowboy: faHatCowboy,
  faBridge: faBridge,
  faPhoneFlip: faPhoneFlip,
  faPhoneAlt: faPhoneAlt,
  faArrowDownFromDottedLine: faArrowDownFromDottedLine,
  faFileDoc: faFileDoc,
  faSquareQuarters: faSquareQuarters,
  faTruckFront: faTruckFront,
  faCat: faCat,
  faTrashXmark: faTrashXmark,
  faCircleCaretLeft: faCircleCaretLeft,
  faCaretCircleLeft: faCaretCircleLeft,
  faFiles: faFiles,
  faAnchorCircleExclamation: faAnchorCircleExclamation,
  faFaceClouds: faFaceClouds,
  faUserCrown: faUserCrown,
  faTruckField: faTruckField,
  faRoute: faRoute,
  faCartCircleCheck: faCartCircleCheck,
  faClipboardQuestion: faClipboardQuestion,
  faPanorama: faPanorama,
  faCommentMedical: faCommentMedical,
  faTeethOpen: faTeethOpen,
  faUserTieHairLong: faUserTieHairLong,
  faFileCircleMinus: faFileCircleMinus,
  faHeadSideMedical: faHeadSideMedical,
  faTags: faTags,
  faWineGlass: faWineGlass,
  faForwardFast: faForwardFast,
  faFastForward: faFastForward,
  faFaceMehBlank: faFaceMehBlank,
  faMehBlank: faMehBlank,
  faUserRobot: faUserRobot,
  faSquareParking: faSquareParking,
  faParking: faParking,
  faCardDiamond: faCardDiamond,
  faFaceZipper: faFaceZipper,
  faFaceRaisedEyebrow: faFaceRaisedEyebrow,
  faHouseSignal: faHouseSignal,
  faSquareChevronUp: faSquareChevronUp,
  faChevronSquareUp: faChevronSquareUp,
  faNfcSymbol: faNfcSymbol,
  faBarsProgress: faBarsProgress,
  faTasksAlt: faTasksAlt,
  faFaucetDrip: faFaucetDrip,
  faArrowsToLine: faArrowsToLine,
  faDolphin: faDolphin,
  faArrowUpRight: faArrowUpRight,
  faCircleR: faCircleR,
  faCartFlatbed: faCartFlatbed,
  faDollyFlatbed: faDollyFlatbed,
  faBanSmoking: faBanSmoking,
  faSmokingBan: faSmokingBan,
  faCircleSortUp: faCircleSortUp,
  faSortCircleUp: faSortCircleUp,
  faTerminal: faTerminal,
  faMobileButton: faMobileButton,
  faHouseMedicalFlag: faHouseMedicalFlag,
  faBasketShopping: faBasketShopping,
  faShoppingBasket: faShoppingBasket,
  faTape: faTape,
  faChestnut: faChestnut,
  faBusSimple: faBusSimple,
  faBusAlt: faBusAlt,
  faEye: faEye,
  faFaceSadCry: faFaceSadCry,
  faSadCry: faSadCry,
  faHeat: faHeat,
  faTicketAirline: faTicketAirline,
  faBootHeeled: faBootHeeled,
  faArrowsMinimize: faArrowsMinimize,
  faCompressArrows: faCompressArrows,
  faAudioDescription: faAudioDescription,
  faPersonMilitaryToPerson: faPersonMilitaryToPerson,
  faFileShield: faFileShield,
  faHexagon: faHexagon,
  faManhole: faManhole,
  faUserSlash: faUserSlash,
  faPen: faPen,
  faTowerObservation: faTowerObservation,
  faFloppyDisks: faFloppyDisks,
  faToiletPaperBlankUnder: faToiletPaperBlankUnder,
  faToiletPaperReverseAlt: faToiletPaperReverseAlt,
  faFileCode: faFileCode,
  faSignal: faSignal,
  faSignal5: faSignal5,
  faSignalPerfect: faSignalPerfect,
  faPump: faPump,
  faBus: faBus,
  faHeartCircleXmark: faHeartCircleXmark,
  faArrowUpLeftFromCircle: faArrowUpLeftFromCircle,
  faHouseChimney: faHouseChimney,
  faHomeLg: faHomeLg,
  faWindowMaximize: faWindowMaximize,
  faDryer: faDryer,
  faFaceFrown: faFaceFrown,
  faFrown: faFrown,
  faChessBishopPiece: faChessBishopPiece,
  faChessBishopAlt: faChessBishopAlt,
  faShirtTankTop: faShirtTankTop,
  faDiploma: faDiploma,
  faScrollRibbon: faScrollRibbon,
  faScreencast: faScreencast,
  faWalker: faWalker,
  faPrescription: faPrescription,
  faShop: faShop,
  faStoreAlt: faStoreAlt,
  faFloppyDisk: faFloppyDisk,
  faSave: faSave,
  faVihara: faVihara,
  faFaceKissClosedEyes: faFaceKissClosedEyes,
  faScaleUnbalanced: faScaleUnbalanced,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faFileUser: faFileUser,
  faUserPoliceTie: faUserPoliceTie,
  faFaceTongueMoney: faFaceTongueMoney,
  faTennisBall: faTennisBall,
  faSquareL: faSquareL,
  faSortUp: faSortUp,
  faSortAsc: faSortAsc,
  faCalendarArrowUp: faCalendarArrowUp,
  faCalendarUpload: faCalendarUpload,
  faCommentDots: faCommentDots,
  faCommenting: faCommenting,
  faPlantWilt: faPlantWilt,
  faScarf: faScarf,
  faAlbumCirclePlus: faAlbumCirclePlus,
  faUserNurseHairLong: faUserNurseHairLong,
  faDiamond: faDiamond,
  faSquareLeft: faSquareLeft,
  faArrowAltSquareLeft: faArrowAltSquareLeft,
  faFaceGrinSquint: faFaceGrinSquint,
  faGrinSquint: faGrinSquint,
  faCircleEllipsisVertical: faCircleEllipsisVertical,
  faHandHoldingDollar: faHandHoldingDollar,
  faHandHoldingUsd: faHandHoldingUsd,
  faGridDividers: faGridDividers,
  faBacterium: faBacterium,
  faHandPointer: faHandPointer,
  faDrumSteelpan: faDrumSteelpan,
  faHandScissors: faHandScissors,
  faHandsPraying: faHandsPraying,
  faPrayingHands: faPrayingHands,
  faFacePensive: faFacePensive,
  faUserMusic: faUserMusic,
  faArrowRotateRight: faArrowRotateRight,
  faArrowRightRotate: faArrowRightRotate,
  faArrowRotateForward: faArrowRotateForward,
  faRedo: faRedo,
  faMessagesDollar: faMessagesDollar,
  faCommentsAltDollar: faCommentsAltDollar,
  faSensorOn: faSensorOn,
  faBalloon: faBalloon,
  faBiohazard: faBiohazard,
  faChessQueenPiece: faChessQueenPiece,
  faChessQueenAlt: faChessQueenAlt,
  faLocationCrosshairs: faLocationCrosshairs,
  faLocation: faLocation,
  faMarsDouble: faMarsDouble,
  faHousePersonLeave: faHousePersonLeave,
  faHouseLeave: faHouseLeave,
  faHousePersonDepart: faHousePersonDepart,
  faRulerTriangle: faRulerTriangle,
  faCardClub: faCardClub,
  faChildDress: faChildDress,
  faUsersBetweenLines: faUsersBetweenLines,
  faLungsVirus: faLungsVirus,
  faSpinnerThird: faSpinnerThird,
  faFaceGrinTears: faFaceGrinTears,
  faGrinTears: faGrinTears,
  faPhone: faPhone,
  faComputerMouseScrollwheel: faComputerMouseScrollwheel,
  faMouseAlt: faMouseAlt,
  faCalendarXmark: faCalendarXmark,
  faCalendarTimes: faCalendarTimes,
  faChildReaching: faChildReaching,
  faTableLayout: faTableLayout,
  faNarwhal: faNarwhal,
  faRampLoading: faRampLoading,
  faCalendarCirclePlus: faCalendarCirclePlus,
  faToothbrush: faToothbrush,
  faBorderInner: faBorderInner,
  faPawClaws: faPawClaws,
  faKiwiFruit: faKiwiFruit,
  faTrafficLightSlow: faTrafficLightSlow,
  faRectangleCode: faRectangleCode,
  faHeadSideVirus: faHeadSideVirus,
  faKeyboardBrightness: faKeyboardBrightness,
  faBooksMedical: faBooksMedical,
  faLightbulbSlash: faLightbulbSlash,
  faHouseBlank: faHouseBlank,
  faHomeBlank: faHomeBlank,
  faSquare5: faSquare5,
  faSquareHeart: faSquareHeart,
  faHeartSquare: faHeartSquare,
  faPuzzle: faPuzzle,
  faUserGear: faUserGear,
  faUserCog: faUserCog,
  faPipeCircleCheck: faPipeCircleCheck,
  faArrowUp19: faArrowUp19,
  faSortNumericUp: faSortNumericUp,
  faOctagonExclamation: faOctagonExclamation,
  faDialLow: faDialLow,
  faDoorClosed: faDoorClosed,
  faLaptopMobile: faLaptopMobile,
  faPhoneLaptop: faPhoneLaptop,
  faConveyorBeltBoxes: faConveyorBeltBoxes,
  faConveyorBeltAlt: faConveyorBeltAlt,
  faShieldVirus: faShieldVirus,
  faStarfighterTwinIonEngineAdvanced: faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced: faStarfighterAltAdvanced,
  faDiceSix: faDiceSix,
  faStarfighterTwinIonEngine: faStarfighterTwinIonEngine,
  faStarfighterAlt: faStarfighterAlt,
  faRocketLaunch: faRocketLaunch,
  faMosquitoNet: faMosquitoNet,
  faVentDamper: faVentDamper,
  faBridgeWater: faBridgeWater,
  faBanBug: faBanBug,
  faDebug: faDebug,
  faPersonBooth: faPersonBooth,
  faTextWidth: faTextWidth,
  faGarageCar: faGarageCar,
  faSquareKanban: faSquareKanban,
  faHatWizard: faHatWizard,
  faPenFancy: faPenFancy,
  faCoffeePot: faCoffeePot,
  faMouseField: faMouseField,
  faPersonDigging: faPersonDigging,
  faDigging: faDigging,
  faShowerDown: faShowerDown,
  faShowerAlt: faShowerAlt,
  faBoxCircleCheck: faBoxCircleCheck,
  faBrightness: faBrightness,
  faCarSideBolt: faCarSideBolt,
  faOrnament: faOrnament,
  faPhoneArrowDownLeft: faPhoneArrowDownLeft,
  faPhoneArrowDown: faPhoneArrowDown,
  faPhoneIncoming: faPhoneIncoming,
  faCloudWord: faCloudWord,
  faHandFingersCrossed: faHandFingersCrossed,
  faTrash: faTrash,
  faGaugeSimple: faGaugeSimple,
  faGaugeSimpleMed: faGaugeSimpleMed,
  faTachometerAverage: faTachometerAverage,
  faArrowDownSmallBig: faArrowDownSmallBig,
  faSortSizeDownAlt: faSortSizeDownAlt,
  faBookMedical: faBookMedical,
  faFaceMelting: faFaceMelting,
  faPoo: faPoo,
  faPenClipSlash: faPenClipSlash,
  faPenAltSlash: faPenAltSlash,
  faQuoteRight: faQuoteRight,
  faQuoteRightAlt: faQuoteRightAlt,
  faScrollOld: faScrollOld,
  faGuitars: faGuitars,
  faPhoneXmark: faPhoneXmark,
  faHose: faHose,
  faClockSix: faClockSix,
  faShirt: faShirt,
  faTShirt: faTShirt,
  faTshirt: faTshirt,
  faBillboard: faBillboard,
  faSquareR: faSquareR,
  faCubes: faCubes,
  faEnvelopeOpenDollar: faEnvelopeOpenDollar,
  faDivide: faDivide,
  faSunCloud: faSunCloud,
  faLampFloor: faLampFloor,
  faSquare7: faSquare7,
  faTengeSign: faTengeSign,
  faTenge: faTenge,
  faHeadphones: faHeadphones,
  faHandsHolding: faHandsHolding,
  faCampfire: faCampfire,
  faCircleAmpersand: faCircleAmpersand,
  faSnowflakes: faSnowflakes,
  faHandsClapping: faHandsClapping,
  faRepublican: faRepublican,
  faLeafMaple: faLeafMaple,
  faArrowLeft: faArrowLeft,
  faPersonCircleXmark: faPersonCircleXmark,
  faRuler: faRuler,
  faCupStrawSwoosh: faCupStrawSwoosh,
  faTemperatureSun: faTemperatureSun,
  faTemperatureHot: faTemperatureHot,
  faAlignLeft: faAlignLeft,
  faDiceD6: faDiceD6,
  faRestroom: faRestroom,
  faHighDefinition: faHighDefinition,
  faRectangleHd: faRectangleHd,
  faJ: faJ,
  faGalaxy: faGalaxy,
  faUsersViewfinder: faUsersViewfinder,
  faFileVideo: faFileVideo,
  faCherries: faCherries,
  faUpRightFromSquare: faUpRightFromSquare,
  faExternalLinkAlt: faExternalLinkAlt,
  faCircleSort: faCircleSort,
  faSortCircle: faSortCircle,
  faTableCells: faTableCells,
  faTh: faTh,
  faFilePdf: faFilePdf,
  faSiren: faSiren,
  faArrowUpToDottedLine: faArrowUpToDottedLine,
  faImageLandscape: faImageLandscape,
  faLandscape: faLandscape,
  faTankWater: faTankWater,
  faCurlingStone: faCurlingStone,
  faCurling: faCurling,
  faGamepadModern: faGamepadModern,
  faGamepadAlt: faGamepadAlt,
  faMessagesQuestion: faMessagesQuestion,
  faBookBible: faBookBible,
  faBible: faBible,
  faO: faO,
  faSuitcaseMedical: faSuitcaseMedical,
  faMedkit: faMedkit,
  faBriefcaseArrowRight: faBriefcaseArrowRight,
  faExpandWide: faExpandWide,
  faClockElevenThirty: faClockElevenThirty,
  faRv: faRv,
  faUserSecret: faUserSecret,
  faOtter: faOtter,
  faDreidel: faDreidel,
  faPersonDress: faPersonDress,
  faFemale: faFemale,
  faCommentDollar: faCommentDollar,
  faBusinessTime: faBusinessTime,
  faBriefcaseClock: faBriefcaseClock,
  faFlowerTulip: faFlowerTulip,
  faPeoplePantsSimple: faPeoplePantsSimple,
  faCloudDrizzle: faCloudDrizzle,
  faTableCellsLarge: faTableCellsLarge,
  faThLarge: faThLarge,
  faBookTanakh: faBookTanakh,
  faTanakh: faTanakh,
  faSolarSystem: faSolarSystem,
  faSealQuestion: faSealQuestion,
  faPhoneVolume: faPhoneVolume,
  faVolumeControlPhone: faVolumeControlPhone,
  faDiscDrive: faDiscDrive,
  faHatCowboySide: faHatCowboySide,
  faTableRows: faTableRows,
  faRows: faRows,
  faLocationExclamation: faLocationExclamation,
  faMapMarkerExclamation: faMapMarkerExclamation,
  faFaceFearful: faFaceFearful,
  faClipboardUser: faClipboardUser,
  faBusSchool: faBusSchool,
  faFilmSlash: faFilmSlash,
  faSquareArrowDownRight: faSquareArrowDownRight,
  faBookSparkles: faBookSparkles,
  faBookSpells: faBookSpells,
  faWashingMachine: faWashingMachine,
  faWasher: faWasher,
  faChild: faChild,
  faLiraSign: faLiraSign,
  faUserVisor: faUserVisor,
  faFilePlusMinus: faFilePlusMinus,
  faChessClockFlip: faChessClockFlip,
  faChessClockAlt: faChessClockAlt,
  faSatellite: faSatellite,
  faPlaneLock: faPlaneLock,
  faSteeringWheel: faSteeringWheel,
  faTag: faTag,
  faStretcher: faStretcher,
  faBookSection: faBookSection,
  faBookLaw: faBookLaw,
  faInboxes: faInboxes,
  faCoffeeBean: faCoffeeBean,
  faCircleYen: faCircleYen,
  faBracketsCurly: faBracketsCurly,
  faEllipsisStrokeVertical: faEllipsisStrokeVertical,
  faEllipsisVAlt: faEllipsisVAlt,
  faComment: faComment,
  faSquare1: faSquare1,
  faCakeCandles: faCakeCandles,
  faBirthdayCake: faBirthdayCake,
  faCake: faCake,
  faHeadSide: faHeadSide,
  faEnvelope: faEnvelope,
  faDollyEmpty: faDollyEmpty,
  faFaceTissue: faFaceTissue,
  faAnglesUp: faAnglesUp,
  faAngleDoubleUp: faAngleDoubleUp,
  faBinRecycle: faBinRecycle,
  faPaperclip: faPaperclip,
  faChartLineDown: faChartLineDown,
  faArrowRightToCity: faArrowRightToCity,
  faLockA: faLockA,
  faRibbon: faRibbon,
  faLungs: faLungs,
  faPersonPinball: faPersonPinball,
  faArrowUp91: faArrowUp91,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faAppleCore: faAppleCore,
  faCircleY: faCircleY,
  faH6: faH6,
  faLitecoinSign: faLitecoinSign,
  faCircleSmall: faCircleSmall,
  faBorderNone: faBorderNone,
  faArrowTurnDownLeft: faArrowTurnDownLeft,
  faCircleNodes: faCircleNodes,
  faParachuteBox: faParachuteBox,
  faMessageMedical: faMessageMedical,
  faCommentAltMedical: faCommentAltMedical,
  faRugbyBall: faRugbyBall,
  faCommentMusic: faCommentMusic,
  faIndent: faIndent,
  faTreeDeciduous: faTreeDeciduous,
  faTreeAlt: faTreeAlt,
  faPuzzlePieceSimple: faPuzzlePieceSimple,
  faPuzzlePieceAlt: faPuzzlePieceAlt,
  faTruckFieldUn: faTruckFieldUn,
  faNfcTrash: faNfcTrash,
  faHourglass: faHourglass,
  faHourglassEmpty: faHourglassEmpty,
  faMountain: faMountain,
  faFileXmark: faFileXmark,
  faFileTimes: faFileTimes,
  faHouseHeart: faHouseHeart,
  faHomeHeart: faHomeHeart,
  faHouseChimneyBlank: faHouseChimneyBlank,
  faMeterBolt: faMeterBolt,
  faUserDoctor: faUserDoctor,
  faUserMd: faUserMd,
  faSlashBack: faSlashBack,
  faCircleInfo: faCircleInfo,
  faInfoCircle: faInfoCircle,
  faFishingRod: faFishingRod,
  faHammerCrash: faHammerCrash,
  faMessageHeart: faMessageHeart,
  faCloudMeatball: faCloudMeatball,
  faCameraPolaroid: faCameraPolaroid,
  faCamera: faCamera,
  faCameraAlt: faCameraAlt,
  faSquareVirus: faSquareVirus,
  faCartArrowUp: faCartArrowUp,
  faMeteor: faMeteor,
  faCarOn: faCarOn,
  faSleigh: faSleigh,
  faArrowDown19: faArrowDown19,
  faSortNumericAsc: faSortNumericAsc,
  faSortNumericDown: faSortNumericDown,
  faBuoyMooring: faBuoyMooring,
  faSquare4: faSquare4,
  faHandHoldingDroplet: faHandHoldingDroplet,
  faHandHoldingWater: faHandHoldingWater,
  faTricycleAdult: faTricycleAdult,
  faWaveform: faWaveform,
  faWater: faWater,
  faStarSharpHalfStroke: faStarSharpHalfStroke,
  faStarSharpHalfAlt: faStarSharpHalfAlt,
  faNfcSignal: faNfcSignal,
  faPlaneProp: faPlaneProp,
  faCalendarCheck: faCalendarCheck,
  faClockDesk: faClockDesk,
  faCalendarClock: faCalendarClock,
  faCalendarTime: faCalendarTime,
  faBraille: faBraille,
  faPrescriptionBottleMedical: faPrescriptionBottleMedical,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPlateUtensils: faPlateUtensils,
  faFamilyPants: faFamilyPants,
  faHoseReel: faHoseReel,
  faHouseWindow: faHouseWindow,
  faLandmark: faLandmark,
  faTruck: faTruck,
  faCrosshairs: faCrosshairs,
  faCloudRainbow: faCloudRainbow,
  faPersonCane: faPersonCane,
  faAlien: faAlien,
  faTent: faTent,
  faLaptopBinary: faLaptopBinary,
  faVestPatches: faVestPatches,
  faPeopleDressSimple: faPeopleDressSimple,
  faCheckDouble: faCheckDouble,
  faArrowDownAZ: faArrowDownAZ,
  faSortAlphaAsc: faSortAlphaAsc,
  faSortAlphaDown: faSortAlphaDown,
  faBowlingBallPin: faBowlingBallPin,
  faBellSchoolSlash: faBellSchoolSlash,
  faPlusLarge: faPlusLarge,
  faMoneyBillWheat: faMoneyBillWheat,
  faCameraViewfinder: faCameraViewfinder,
  faScreenshot: faScreenshot,
  faMessageMusic: faMessageMusic,
  faCommentAltMusic: faCommentAltMusic,
  faCarBuilding: faCarBuilding,
  faBorderBottomRight: faBorderBottomRight,
  faBorderStyleAlt: faBorderStyleAlt,
  faOctagon: faOctagon,
  faCommentArrowUpRight: faCommentArrowUpRight,
  faOctagonDivide: faOctagonDivide,
  faCookie: faCookie,
  faArrowRotateLeft: faArrowRotateLeft,
  faArrowLeftRotate: faArrowLeftRotate,
  faArrowRotateBack: faArrowRotateBack,
  faArrowRotateBackward: faArrowRotateBackward,
  faUndo: faUndo,
  faTvMusic: faTvMusic,
  faHardDrive: faHardDrive,
  faHdd: faHdd,
  faReel: faReel,
  faFaceGrinSquintTears: faFaceGrinSquintTears,
  faGrinSquintTears: faGrinSquintTears,
  faDumbbell: faDumbbell,
  faRectangleList: faRectangleList,
  faListAlt: faListAlt,
  faTarpDroplet: faTarpDroplet,
  faAlarmExclamation: faAlarmExclamation,
  faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
  faTrafficCone: faTrafficCone,
  faGrate: faGrate,
  faArrowDownRight: faArrowDownRight,
  faPersonSkiingNordic: faPersonSkiingNordic,
  faSkiingNordic: faSkiingNordic,
  faCalendarPlus: faCalendarPlus,
  faPersonFromPortal: faPersonFromPortal,
  faPortalExit: faPortalExit,
  faPlaneArrival: faPlaneArrival,
  faCowbellCirclePlus: faCowbellCirclePlus,
  faCowbellMore: faCowbellMore,
  faCircleLeft: faCircleLeft,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faDistributeSpacingVertical: faDistributeSpacingVertical,
  faSignalBarsFair: faSignalBarsFair,
  faSignalAlt2: faSignalAlt2,
  faSportsball: faSportsball,
  faGameConsoleHandheldCrank: faGameConsoleHandheldCrank,
  faTrainSubway: faTrainSubway,
  faSubway: faSubway,
  faChartGantt: faChartGantt,
  faFaceSmileUpsideDown: faFaceSmileUpsideDown,
  faBallPile: faBallPile,
  faBadgeDollar: faBadgeDollar,
  faMoneyBillsSimple: faMoneyBillsSimple,
  faMoneyBillsAlt: faMoneyBillsAlt,
  faListTimeline: faListTimeline,
  faIndianRupeeSign: faIndianRupeeSign,
  faIndianRupee: faIndianRupee,
  faInr: faInr,
  faCropSimple: faCropSimple,
  faCropAlt: faCropAlt,
  faMoneyBill1: faMoneyBill1,
  faMoneyBillAlt: faMoneyBillAlt,
  faLeftLong: faLeftLong,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faKeyboardDown: faKeyboardDown,
  faCircleUpRight: faCircleUpRight,
  faCloudBoltMoon: faCloudBoltMoon,
  faThunderstormMoon: faThunderstormMoon,
  faDna: faDna,
  faVirusSlash: faVirusSlash,
  faBracketRoundRight: faBracketRoundRight,
  faCircleSterling: faCircleSterling,
  faCircle5: faCircle5,
  faMinus: faMinus,
  faSubtract: faSubtract,
  faFireFlame: faFireFlame,
  faFlame: faFlame,
  faRightToLine: faRightToLine,
  faArrowAltToRight: faArrowAltToRight,
  faGif: faGif,
  faChess: faChess,
  faTrashSlash: faTrashSlash,
  faArrowLeftLong: faArrowLeftLong,
  faLongArrowLeft: faLongArrowLeft,
  faPlugCircleCheck: faPlugCircleCheck,
  faFontCase: faFontCase,
  faStreetView: faStreetView,
  faArrowDownLeft: faArrowDownLeft,
  faFrancSign: faFrancSign,
  faFlaskRoundPoison: faFlaskRoundPoison,
  faFlaskPoison: faFlaskPoison,
  faVolumeOff: faVolumeOff,
  faBookCircleArrowRight: faBookCircleArrowRight,
  faChartUser: faChartUser,
  faUserChart: faUserChart,
  faHandsAslInterpreting: faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAslInterpreting: faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen: faPresentationScreen,
  faPresentation: faPresentation,
  faCircleBolt: faCircleBolt,
  faFaceSmileHalo: faFaceSmileHalo,
  faCartCircleArrowDown: faCartCircleArrowDown,
  faHousePersonReturn: faHousePersonReturn,
  faHousePersonArrive: faHousePersonArrive,
  faHouseReturn: faHouseReturn,
  faMessageXmark: faMessageXmark,
  faCommentAltTimes: faCommentAltTimes,
  faMessageTimes: faMessageTimes,
  faFileCertificate: faFileCertificate,
  faFileAward: faFileAward,
  faUserDoctorHairLong: faUserDoctorHairLong,
  faCameraSecurity: faCameraSecurity,
  faCameraHome: faCameraHome,
  faGear: faGear,
  faCog: faCog,
  faDropletSlash: faDropletSlash,
  faTintSlash: faTintSlash,
  faBookHeart: faBookHeart,
  faMosque: faMosque,
  faDuck: faDuck,
  faMosquito: faMosquito,
  faStarOfDavid: faStarOfDavid,
  faFlagSwallowtail: faFlagSwallowtail,
  faFlagAlt: faFlagAlt,
  faPersonMilitaryRifle: faPersonMilitaryRifle,
  faCarGarage: faCarGarage,
  faCartShopping: faCartShopping,
  faShoppingCart: faShoppingCart,
  faBookFont: faBookFont,
  faShieldPlus: faShieldPlus,
  faVials: faVials,
  faEyeDropperFull: faEyeDropperFull,
  faDistributeSpacingHorizontal: faDistributeSpacingHorizontal,
  faTabletRugged: faTabletRugged,
  faTemperatureSnow: faTemperatureSnow,
  faTemperatureFrigid: faTemperatureFrigid,
  faMoped: faMoped,
  faFaceSmilePlus: faFaceSmilePlus,
  faSmilePlus: faSmilePlus,
  faRadioTuner: faRadioTuner,
  faRadioAlt: faRadioAlt,
  faFaceSwear: faFaceSwear,
  faWaterArrowDown: faWaterArrowDown,
  faWaterLower: faWaterLower,
  faScannerTouchscreen: faScannerTouchscreen,
  faCircle7: faCircle7,
  faPlugCirclePlus: faPlugCirclePlus,
  faPersonSkiJumping: faPersonSkiJumping,
  faSkiJump: faSkiJump,
  faPlaceOfWorship: faPlaceOfWorship,
  faWaterArrowUp: faWaterArrowUp,
  faWaterRise: faWaterRise,
  faWaveformLines: faWaveformLines,
  faWaveformPath: faWaveformPath,
  faSplit: faSplit,
  faFilmCanister: faFilmCanister,
  faFilmCannister: faFilmCannister,
  faFolderXmark: faFolderXmark,
  faFolderTimes: faFolderTimes,
  faToiletPaperBlank: faToiletPaperBlank,
  faToiletPaperAlt: faToiletPaperAlt,
  faTabletScreen: faTabletScreen,
  faTabletAndroidAlt: faTabletAndroidAlt,
  faHexagonVerticalNftSlanted: faHexagonVerticalNftSlanted,
  faFolderMusic: faFolderMusic,
  faDisplayMedical: faDisplayMedical,
  faDesktopMedical: faDesktopMedical,
  faShareAll: faShareAll,
  faPeapod: faPeapod,
  faChessClock: faChessClock,
  faAxe: faAxe,
  faSquareD: faSquareD,
  faGripVertical: faGripVertical,
  faMobileSignalOut: faMobileSignalOut,
  faArrowTurnUp: faArrowTurnUp,
  faLevelUp: faLevelUp,
  faU: faU,
  faArrowUpFromDottedLine: faArrowUpFromDottedLine,
  faSquareRootVariable: faSquareRootVariable,
  faSquareRootAlt: faSquareRootAlt,
  faLightSwitchOn: faLightSwitchOn,
  faArrowDownArrowUp: faArrowDownArrowUp,
  faSortAlt: faSortAlt,
  faRaindrops: faRaindrops,
  faDash: faDash,
  faMinusLarge: faMinusLarge,
  faClock: faClock,
  faClockFour: faClockFour,
  faInputNumeric: faInputNumeric,
  faTruckTow: faTruckTow,
  faBackwardStep: faBackwardStep,
  faStepBackward: faStepBackward,
  faPallet: faPallet,
  faCarBolt: faCarBolt,
  faArrowsMaximize: faArrowsMaximize,
  faExpandArrows: faExpandArrows,
  faFaucet: faFaucet,
  faCloudSleet: faCloudSleet,
  faLampStreet: faLampStreet,
  faListRadio: faListRadio,
  faPenNibSlash: faPenNibSlash,
  faBaseballBatBall: faBaseballBatBall,
  faSquareUpLeft: faSquareUpLeft,
  faOverline: faOverline,
  faS: faS,
  faTimeline: faTimeline,
  faKeyboard: faKeyboard,
  faArrowsFromDottedLine: faArrowsFromDottedLine,
  faUsbDrive: faUsbDrive,
  faBallot: faBallot,
  faCaretDown: faCaretDown,
  faLocationDotSlash: faLocationDotSlash,
  faMapMarkerAltSlash: faMapMarkerAltSlash,
  faCards: faCards,
  faHouseChimneyMedical: faHouseChimneyMedical,
  faClinicMedical: faClinicMedical,
  faBoxingGlove: faBoxingGlove,
  faGloveBoxing: faGloveBoxing,
  faTemperatureThreeQuarters: faTemperatureThreeQuarters,
  faTemperature3: faTemperature3,
  faThermometer3: faThermometer3,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faBellSchool: faBellSchool,
  faMobileScreen: faMobileScreen,
  faMobileAndroidAlt: faMobileAndroidAlt,
  faPlaneUp: faPlaneUp,
  faFolderHeart: faFolderHeart,
  faCircleLocationArrow: faCircleLocationArrow,
  faLocationCircle: faLocationCircle,
  faFaceHeadBandage: faFaceHeadBandage,
  faSushiRoll: faSushiRoll,
  faMakiRoll: faMakiRoll,
  faMakizushi: faMakizushi,
  faCarBump: faCarBump,
  faPiggyBank: faPiggyBank,
  faRacquet: faRacquet,
  faCarMirrors: faCarMirrors,
  faIndustryWindows: faIndustryWindows,
  faIndustryAlt: faIndustryAlt,
  faBoltAuto: faBoltAuto,
  faBatteryHalf: faBatteryHalf,
  faBattery3: faBattery3,
  faFluxCapacitor: faFluxCapacitor,
  faMountainCity: faMountainCity,
  faCoins: faCoins,
  faHoneyPot: faHoneyPot,
  faOlive: faOlive,
  faKhanda: faKhanda,
  faFilterList: faFilterList,
  faOutlet: faOutlet,
  faSliders: faSliders,
  faSlidersH: faSlidersH,
  faCauldron: faCauldron,
  faPeople: faPeople,
  faFolderTree: faFolderTree,
  faNetworkWired: faNetworkWired,
  faCroissant: faCroissant,
  faMapPin: faMapPin,
  faHamsa: faHamsa,
  faCentSign: faCentSign,
  faSwordsLaser: faSwordsLaser,
  faFlask: faFlask,
  faPersonPregnant: faPersonPregnant,
  faSquareU: faSquareU,
  faWandSparkles: faWandSparkles,
  faRouter: faRouter,
  faEllipsisVertical: faEllipsisVertical,
  faEllipsisV: faEllipsisV,
  faSwordLaserAlt: faSwordLaserAlt,
  faTicket: faTicket,
  faPowerOff: faPowerOff,
  faCoin: faCoin,
  faLaptopSlash: faLaptopSlash,
  faRightLong: faRightLong,
  faLongArrowAltRight: faLongArrowAltRight,
  faCircleB: faCircleB,
  faPersonDressSimple: faPersonDressSimple,
  faPipeCollar: faPipeCollar,
  faLightsHoliday: faLightsHoliday,
  faCitrus: faCitrus,
  faFlagUsa: faFlagUsa,
  faLaptopFile: faLaptopFile,
  faTty: faTty,
  faTeletype: faTeletype,
  faChartTreeMap: faChartTreeMap,
  faDiagramNext: faDiagramNext,
  faPersonRifle: faPersonRifle,
  faClockFiveThirty: faClockFiveThirty,
  faPipeValve: faPipeValve,
  faArrowUpFromArc: faArrowUpFromArc,
  faFaceSpiralEyes: faFaceSpiralEyes,
  faCompressWide: faCompressWide,
  faCirclePhoneHangup: faCirclePhoneHangup,
  faPhoneCircleDown: faPhoneCircleDown,
  faGearComplexCode: faGearComplexCode,
  faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
  faBadminton: faBadminton,
  faClosedCaptioning: faClosedCaptioning,
  faPersonHiking: faPersonHiking,
  faHiking: faHiking,
  faRightFromLine: faRightFromLine,
  faArrowAltFromLeft: faArrowAltFromLeft,
  faVenusDouble: faVenusDouble,
  faImages: faImages,
  faCalculator: faCalculator,
  faShuttlecock: faShuttlecock,
  faUserHair: faUserHair,
  faEyeEvil: faEyeEvil,
  faPeoplePulling: faPeoplePulling,
  faN: faN,
  faSwap: faSwap,
  faGarage: faGarage,
  faCableCar: faCableCar,
  faTram: faTram,
  faShovelSnow: faShovelSnow,
  faCloudRain: faCloudRain,
  faFaceLying: faFaceLying,
  faSprinkler: faSprinkler,
  faBuildingCircleXmark: faBuildingCircleXmark,
  faPersonSledding: faPersonSledding,
  faSledding: faSledding,
  faGameConsoleHandheld: faGameConsoleHandheld,
  faShip: faShip,
  faClockSixThirty: faClockSixThirty,
  faBatterySlash: faBatterySlash,
  faTugrikSign: faTugrikSign,
  faArrowsDownToLine: faArrowsDownToLine,
  faDownload: faDownload,
  faAnglesUpDown: faAnglesUpDown,
  faShelves: faShelves,
  faInventory: faInventory,
  faCloudSnow: faCloudSnow,
  faFaceGrin: faFaceGrin,
  faGrin: faGrin,
  faDeleteLeft: faDeleteLeft,
  faBackspace: faBackspace,
  faOven: faOven,
  faCloudBinary: faCloudBinary,
  faEyeDropper: faEyeDropper,
  faEyeDropperEmpty: faEyeDropperEmpty,
  faEyedropper: faEyedropper,
  faCommentCaptions: faCommentCaptions,
  faCommentsQuestion: faCommentsQuestion,
  faScribble: faScribble,
  faRotateExclamation: faRotateExclamation,
  faFileCircleCheck: faFileCircleCheck,
  faGlass: faGlass,
  faLoader: faLoader,
  faForward: faForward,
  faUserPilot: faUserPilot,
  faMobile: faMobile,
  faMobileAndroid: faMobileAndroid,
  faMobilePhone: faMobilePhone,
  faCodePullRequestClosed: faCodePullRequestClosed,
  faFaceMeh: faFaceMeh,
  faMeh: faMeh,
  faAlignCenter: faAlignCenter,
  faBookSkull: faBookSkull,
  faBookDead: faBookDead,
  faIdCard: faIdCard,
  faDriversLicense: faDriversLicense,
  faFaceDotted: faFaceDotted,
  faFaceWorried: faFaceWorried,
  faOutdent: faOutdent,
  faDedent: faDedent,
  faHeartCircleExclamation: faHeartCircleExclamation,
  faHouse: faHouse,
  faHome: faHome,
  faHomeAlt: faHomeAlt,
  faHomeLgAlt: faHomeLgAlt,
  faVectorCircle: faVectorCircle,
  faCarCircleBolt: faCarCircleBolt,
  faCalendarWeek: faCalendarWeek,
  faFlyingDisc: faFlyingDisc,
  faLaptopMedical: faLaptopMedical,
  faSquareDownRight: faSquareDownRight,
  faB: faB,
  faSeatAirline: faSeatAirline,
  faMoonOverSun: faMoonOverSun,
  faEclipseAlt: faEclipseAlt,
  faPipe: faPipe,
  faFileMedical: faFileMedical,
  faPotato: faPotato,
  faDiceOne: faDiceOne,
  faCircleA: faCircleA,
  faHelmetBattle: faHelmetBattle,
  faButter: faButter,
  faBlanketFire: faBlanketFire,
  faKiwiBird: faKiwiBird,
  faCastle: faCastle,
  faGolfClub: faGolfClub,
  faArrowRightArrowLeft: faArrowRightArrowLeft,
  faExchange: faExchange,
  faRotateRight: faRotateRight,
  faRedoAlt: faRedoAlt,
  faRotateForward: faRotateForward,
  faUtensils: faUtensils,
  faCutlery: faCutlery,
  faArrowUpWideShort: faArrowUpWideShort,
  faSortAmountUp: faSortAmountUp,
  faChartPieSimpleCircleDollar: faChartPieSimpleCircleDollar,
  faBalloons: faBalloons,
  faMillSign: faMillSign,
  faBowlRice: faBowlRice,
  faTimelineArrow: faTimelineArrow,
  faSkull: faSkull,
  faGameBoardSimple: faGameBoardSimple,
  faGameBoardAlt: faGameBoardAlt,
  faCircleVideo: faCircleVideo,
  faVideoCircle: faVideoCircle,
  faChartScatterBubble: faChartScatterBubble,
  faHouseTurret: faHouseTurret,
  faBanana: faBanana,
  faHandHoldingSkull: faHandHoldingSkull,
  faPeopleDress: faPeopleDress,
  faLoveseat: faLoveseat,
  faCouchSmall: faCouchSmall,
  faTowerBroadcast: faTowerBroadcast,
  faBroadcastTower: faBroadcastTower,
  faTruckPickup: faTruckPickup,
  faBlockQuote: faBlockQuote,
  faUpLong: faUpLong,
  faLongArrowAltUp: faLongArrowAltUp,
  faStop: faStop,
  faCodeMerge: faCodeMerge,
  faMoneyCheckDollarPen: faMoneyCheckDollarPen,
  faMoneyCheckEditAlt: faMoneyCheckEditAlt,
  faUpFromLine: faUpFromLine,
  faArrowAltFromBottom: faArrowAltFromBottom,
  faUpload: faUpload,
  faHurricane: faHurricane,
  faGridRound2Plus: faGridRound2Plus,
  faPeoplePants: faPeoplePants,
  faMound: faMound,
  faWindsock: faWindsock,
  faCircleHalf: faCircleHalf,
  faBrakeWarning: faBrakeWarning,
  faToiletPortable: faToiletPortable,
  faCompactDisc: faCompactDisc,
  faFileArrowDown: faFileArrowDown,
  faFileDownload: faFileDownload,
  faSaxophoneFire: faSaxophoneFire,
  faSaxHot: faSaxHot,
  faCameraWebSlash: faCameraWebSlash,
  faWebcamSlash: faWebcamSlash,
  faFolderMedical: faFolderMedical,
  faFolderGear: faFolderGear,
  faFolderCog: faFolderCog,
  faHandWave: faHandWave,
  faArrowUpArrowDown: faArrowUpArrowDown,
  faSortUpDown: faSortUpDown,
  faCaravan: faCaravan,
  faShieldCat: faShieldCat,
  faMessageSlash: faMessageSlash,
  faCommentAltSlash: faCommentAltSlash,
  faBolt: faBolt,
  faZap: faZap,
  faTrashCanCheck: faTrashCanCheck,
  faGlassWater: faGlassWater,
  faOilWell: faOilWell,
  faPersonSimple: faPersonSimple,
  faVault: faVault,
  faMars: faMars,
  faToilet: faToilet,
  faPlaneCircleXmark: faPlaneCircleXmark,
  faYenSign: faYenSign,
  faCny: faCny,
  faJpy: faJpy,
  faRmb: faRmb,
  faYen: faYen,
  faGearCode: faGearCode,
  faNotes: faNotes,
  faRubleSign: faRubleSign,
  faRouble: faRouble,
  faRub: faRub,
  faRuble: faRuble,
  faTrashUndo: faTrashUndo,
  faTrashArrowTurnLeft: faTrashArrowTurnLeft,
  faChampagneGlass: faChampagneGlass,
  faGlassChampagne: faGlassChampagne,
  faObjectsAlignCenterHorizontal: faObjectsAlignCenterHorizontal,
  faSun: faSun,
  faTrashCanSlash: faTrashCanSlash,
  faTrashAltSlash: faTrashAltSlash,
  faScreenUsers: faScreenUsers,
  faUsersClass: faUsersClass,
  faGuitar: faGuitar,
  faSquareArrowLeft: faSquareArrowLeft,
  faArrowSquareLeft: faArrowSquareLeft,
  faSquare8: faSquare8,
  faFaceSmileHearts: faFaceSmileHearts,
  faBracketsSquare: faBracketsSquare,
  faBrackets: faBrackets,
  faLaptopArrowDown: faLaptopArrowDown,
  faHockeyStickPuck: faHockeyStickPuck,
  faHouseTree: faHouseTree,
  faSignalFair: faSignalFair,
  faSignal2: faSignal2,
  faFaceLaughWink: faFaceLaughWink,
  faLaughWink: faLaughWink,
  faCircleDollar: faCircleDollar,
  faDollarCircle: faDollarCircle,
  faUsdCircle: faUsdCircle,
  faHorseHead: faHorseHead,
  faArrowsRepeat: faArrowsRepeat,
  faRepeatAlt: faRepeatAlt,
  faBoreHole: faBoreHole,
  faIndustry: faIndustry,
  faImagePolaroid: faImagePolaroid,
  faWaveTriangle: faWaveTriangle,
  faPersonRunningFast: faPersonRunningFast,
  faCircleDown: faCircleDown,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faGrill: faGrill,
  faArrowsTurnToDots: faArrowsTurnToDots,
  faChartMixed: faChartMixed,
  faAnalytics: faAnalytics,
  faFlorinSign: faFlorinSign,
  faArrowDownShortWide: faArrowDownShortWide,
  faSortAmountDesc: faSortAmountDesc,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faLessThan: faLessThan,
  faDisplayCode: faDisplayCode,
  faDesktopCode: faDesktopCode,
  faFaceDrooling: faFaceDrooling,
  faOilTemperature: faOilTemperature,
  faOilTemp: faOilTemp,
  faSquareQuestion: faSquareQuestion,
  faQuestionSquare: faQuestionSquare,
  faAirConditioner: faAirConditioner,
  faAngleDown: faAngleDown,
  faMountains: faMountains,
  faOmega: faOmega,
  faCarTunnel: faCarTunnel,
  faPersonDollyEmpty: faPersonDollyEmpty,
  faPanFood: faPanFood,
  faHeadSideCough: faHeadSideCough,
  faGripLines: faGripLines,
  faThumbsDown: faThumbsDown,
  faUserLock: faUserLock,
  faArrowRightLong: faArrowRightLong,
  faLongArrowRight: faLongArrowRight,
  faTicketsAirline: faTicketsAirline,
  faAnchorCircleXmark: faAnchorCircleXmark,
  faEllipsis: faEllipsis,
  faEllipsisH: faEllipsisH,
  faNfcSlash: faNfcSlash,
  faChessPawn: faChessPawn,
  faKitMedical: faKitMedical,
  faFirstAid: faFirstAid,
  faGrid2Plus: faGrid2Plus,
  faBells: faBells,
  faPersonThroughWindow: faPersonThroughWindow,
  faToolbox: faToolbox,
  faEnvelopeDot: faEnvelopeDot,
  faEnvelopeBadge: faEnvelopeBadge,
  faHandsHoldingCircle: faHandsHoldingCircle,
  faBug: faBug,
  faBowlChopsticks: faBowlChopsticks,
  faCreditCard: faCreditCard,
  faCreditCardAlt: faCreditCardAlt,
  faCircleS: faCircleS,
  faBoxBallot: faBoxBallot,
  faCar: faCar,
  faAutomobile: faAutomobile,
  faHandHoldingHand: faHandHoldingHand,
  faUserTieHair: faUserTieHair,
  faPodiumStar: faPodiumStar,
  faUserHairMullet: faUserHairMullet,
  faBusinessFront: faBusinessFront,
  faPartyBack: faPartyBack,
  faTrianBalbot: faTrianBalbot,
  faMicrophoneStand: faMicrophoneStand,
  faBookOpenReader: faBookOpenReader,
  faBookReader: faBookReader,
  faFamilyDress: faFamilyDress,
  faCircleX: faCircleX,
  faCabin: faCabin,
  faMountainSun: faMountainSun,
  faChartSimpleHorizontal: faChartSimpleHorizontal,
  faBluetooth: faBluetooth,
  faArrowsLeftRightToLine: faArrowsLeftRightToLine,
  faHandBackPointLeft: faHandBackPointLeft,
  faMessageDots: faMessageDots,
  faCommentAltDots: faCommentAltDots,
  faMessaging: faMessaging,
  faFileHeart: faFileHeart,
  faBeerMug: faBeerMug,
  faBeerFoam: faBeerFoam,
  faDiceD20: faDiceD20,
  faDrone: faDrone,
  faTruckDroplet: faTruckDroplet,
  faFileCircleXmark: faFileCircleXmark,
  faTemperatureArrowUp: faTemperatureArrowUp,
  faTemperatureUp: faTemperatureUp,
  faMedal: faMedal,
  faPersonFairy: faPersonFairy,
  faBed: faBed,
  faBookCopy: faBookCopy,
  faSquareH: faSquareH,
  faHSquare: faHSquare,
  faSquareC: faSquareC,
  faClockTwo: faClockTwo,
  faSquareEllipsisVertical: faSquareEllipsisVertical,
  faCalendarUsers: faCalendarUsers,
  faPodcast: faPodcast,
  faBee: faBee,
  faTemperatureFull: faTemperatureFull,
  faTemperature4: faTemperature4,
  faThermometer4: faThermometer4,
  faThermometerFull: faThermometerFull,
  faBell: faBell,
  faCandyBar: faCandyBar,
  faChocolateBar: faChocolateBar,
  faXmarkLarge: faXmarkLarge,
  faPinata: faPinata,
  faArrowsFromLine: faArrowsFromLine,
  faSuperscript: faSuperscript,
  faBowlSpoon: faBowlSpoon,
  faHexagonCheck: faHexagonCheck,
  faPlugCircleXmark: faPlugCircleXmark,
  faStarOfLife: faStarOfLife,
  faPhoneSlash: faPhoneSlash,
  faTrafficLightStop: faTrafficLightStop,
  faPaintRoller: faPaintRoller,
  faAccentGrave: faAccentGrave,
  faHandshakeAngle: faHandshakeAngle,
  faHandsHelping: faHandsHelping,
  faCircle0: faCircle0,
  faDialMedLow: faDialMedLow,
  faLocationDot: faLocationDot,
  faMapMarkerAlt: faMapMarkerAlt,
  faCrab: faCrab,
  faBoxOpenFull: faBoxOpenFull,
  faBoxFull: faBoxFull,
  faFile: faFile,
  faGreaterThan: faGreaterThan,
  faQuotes: faQuotes,
  faPretzel: faPretzel,
  faPersonSwimming: faPersonSwimming,
  faSwimmer: faSwimmer,
  faArrowDown: faArrowDown,
  faUserRobotXmarks: faUserRobotXmarks,
  faMessageQuote: faMessageQuote,
  faCommentAltQuote: faCommentAltQuote,
  faCandyCorn: faCandyCorn,
  faFolderMagnifyingGlass: faFolderMagnifyingGlass,
  faFolderSearch: faFolderSearch,
  faNotebook: faNotebook,
  faDroplet: faDroplet,
  faTint: faTint,
  faBullseyePointer: faBullseyePointer,
  faEraser: faEraser,
  faHexagonImage: faHexagonImage,
  faEarthAmericas: faEarthAmericas,
  faEarth: faEarth,
  faEarthAmerica: faEarthAmerica,
  faGlobeAmericas: faGlobeAmericas,
  faCrateApple: faCrateApple,
  faAppleCrate: faAppleCrate,
  faPersonBurst: faPersonBurst,
  faGameBoard: faGameBoard,
  faHatChef: faHatChef,
  faHandBackPointRight: faHandBackPointRight,
  faDove: faDove,
  faSnowflakeDroplets: faSnowflakeDroplets,
  faBatteryEmpty: faBatteryEmpty,
  faBattery0: faBattery0,
  faGrid4: faGrid4,
  faSocks: faSocks,
  faFaceSunglasses: faFaceSunglasses,
  faInbox: faInbox,
  faSquare0: faSquare0,
  faSection: faSection,
  faSquareThisWayUp: faSquareThisWayUp,
  faBoxUp: faBoxUp,
  faGaugeHigh: faGaugeHigh,
  faTachometerAlt: faTachometerAlt,
  faTachometerAltFast: faTachometerAltFast,
  faSquareAmpersand: faSquareAmpersand,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faLampDesk: faLampDesk,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalWide: faHospitalWide,
  faPollPeople: faPollPeople,
  faWhiskeyGlassIce: faWhiskeyGlassIce,
  faGlassWhiskeyRocks: faGlassWhiskeyRocks,
  faWineBottle: faWineBottle,
  faChessRook: faChessRook,
  faUserBountyHunter: faUserBountyHunter,
  faBarsStaggered: faBarsStaggered,
  faReorder: faReorder,
  faStream: faStream,
  faDiagramSankey: faDiagramSankey,
  faCloudHailMixed: faCloudHailMixed,
  faCircleUpLeft: faCircleUpLeft,
  faDharmachakra: faDharmachakra,
  faObjectsAlignLeft: faObjectsAlignLeft,
  faOilCanDrip: faOilCanDrip,
  faFaceSmilingHands: faFaceSmilingHands,
  faBroccoli: faBroccoli,
  faRouteInterstate: faRouteInterstate,
  faEarMuffs: faEarMuffs,
  faHotdog: faHotdog,
  faTransporterEmpty: faTransporterEmpty,
  faPersonWalkingWithCane: faPersonWalkingWithCane,
  faBlind: faBlind,
  faAngle90: faAngle90,
  faRectangleTerminal: faRectangleTerminal,
  faKite: faKite,
  faDrum: faDrum,
  faScrubber: faScrubber,
  faIceCream: faIceCream,
  faHeartCircleBolt: faHeartCircleBolt,
  faFishBones: faFishBones,
  faDeerRudolph: faDeerRudolph,
  faFax: faFax,
  faParagraph: faParagraph,
  faHeadSideHeart: faHeadSideHeart,
  faSquareE: faSquareE,
  faMeterFire: faMeterFire,
  faCloudHail: faCloudHail,
  faCheckToSlot: faCheckToSlot,
  faVoteYea: faVoteYea,
  faMoneyFromBracket: faMoneyFromBracket,
  faStarHalf: faStarHalf,
  faCarBus: faCarBus,
  faSpeaker: faSpeaker,
  faTimer: faTimer,
  faBoxesStacked: faBoxesStacked,
  faBoxes: faBoxes,
  faBoxesAlt: faBoxesAlt,
  faGrillHot: faGrillHot,
  faBallotCheck: faBallotCheck,
  faLink: faLink,
  faChain: faChain,
  faEarListen: faEarListen,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faFileMinus: faFileMinus,
  faTreeCity: faTreeCity,
  faPlay: faPlay,
  faFont: faFont,
  faCupTogo: faCupTogo,
  faCoffeeTogo: faCoffeeTogo,
  faSquareDownLeft: faSquareDownLeft,
  faBurgerLettuce: faBurgerLettuce,
  faRupiahSign: faRupiahSign,
  faMagnifyingGlass: faMagnifyingGlass,
  faSearch: faSearch,
  faTableTennisPaddleBall: faTableTennisPaddleBall,
  faPingPongPaddleBall: faPingPongPaddleBall,
  faTableTennis: faTableTennis,
  faPersonDotsFromLine: faPersonDotsFromLine,
  faDiagnoses: faDiagnoses,
  faChevronsDown: faChevronsDown,
  faChevronDoubleDown: faChevronDoubleDown,
  faTrashCanArrowUp: faTrashCanArrowUp,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faSignalGood: faSignalGood,
  faSignal3: faSignal3,
  faLocationQuestion: faLocationQuestion,
  faMapMarkerQuestion: faMapMarkerQuestion,
  faFloppyDiskCircleXmark: faFloppyDiskCircleXmark,
  faFloppyDiskTimes: faFloppyDiskTimes,
  faSaveCircleXmark: faSaveCircleXmark,
  faSaveTimes: faSaveTimes,
  faNairaSign: faNairaSign,
  faPeach: faPeach,
  faTaxiBus: faTaxiBus,
  faBracketCurly: faBracketCurly,
  faBracketCurlyLeft: faBracketCurlyLeft,
  faLobster: faLobster,
  faCartFlatbedEmpty: faCartFlatbedEmpty,
  faDollyFlatbedEmpty: faDollyFlatbedEmpty,
  faColon: faColon,
  faCartArrowDown: faCartArrowDown,
  faWand: faWand,
  faWalkieTalkie: faWalkieTalkie,
  faFilePen: faFilePen,
  faFileEdit: faFileEdit,
  faReceipt: faReceipt,
  faTablePicnic: faTablePicnic,
  faSquarePen: faSquarePen,
  faPenSquare: faPenSquare,
  faPencilSquare: faPencilSquare,
  faCircleMicrophoneLines: faCircleMicrophoneLines,
  faMicrophoneCircleAlt: faMicrophoneCircleAlt,
  faDisplaySlash: faDisplaySlash,
  faDesktopSlash: faDesktopSlash,
  faSuitcaseRolling: faSuitcaseRolling,
  faPersonCircleExclamation: faPersonCircleExclamation,
  faTransporter2: faTransporter2,
  faHandsHoldingDiamond: faHandsHoldingDiamond,
  faHandReceiving: faHandReceiving,
  faMoneyBillSimpleWave: faMoneyBillSimpleWave,
  faChevronDown: faChevronDown,
  faBatteryFull: faBatteryFull,
  faBattery: faBattery,
  faBattery5: faBattery5,
  faBellPlus: faBellPlus,
  faBookArrowRight: faBookArrowRight,
  faHospitals: faHospitals,
  faClub: faClub,
  faSkullCrossbones: faSkullCrossbones,
  faDropletDegree: faDropletDegree,
  faDewpoint: faDewpoint,
  faCodeCompare: faCodeCompare,
  faListUl: faListUl,
  faListDots: faListDots,
  faHandHoldingMagic: faHandHoldingMagic,
  faWatermelonSlice: faWatermelonSlice,
  faCircleEllipsis: faCircleEllipsis,
  faSchoolLock: faSchoolLock,
  faTowerCell: faTowerCell,
  faSdCards: faSdCards,
  faJugBottle: faJugBottle,
  faDownLong: faDownLong,
  faLongArrowAltDown: faLongArrowAltDown,
  faEnvelopes: faEnvelopes,
  faPhoneOffice: faPhoneOffice,
  faRankingStar: faRankingStar,
  faChessKing: faChessKing,
  faNfcPen: faNfcPen,
  faPersonHarassing: faPersonHarassing,
  faHatWinter: faHatWinter,
  faBrazilianRealSign: faBrazilianRealSign,
  faLandmarkDome: faLandmarkDome,
  faLandmarkAlt: faLandmarkAlt,
  faBoneBreak: faBoneBreak,
  faArrowUp: faArrowUp,
  faDownFromDottedLine: faDownFromDottedLine,
  faTv: faTv,
  faTelevision: faTelevision,
  faTvAlt: faTvAlt,
  faBorderLeft: faBorderLeft,
  faCircleDivide: faCircleDivide,
  faShrimp: faShrimp,
  faListCheck: faListCheck,
  faTasks: faTasks,
  faDiagramSubtask: faDiagramSubtask,
  faJugDetergent: faJugDetergent,
  faCircleUser: faCircleUser,
  faUserCircle: faUserCircle,
  faSquareY: faSquareY,
  faUserDoctorHair: faUserDoctorHair,
  faPlanetRinged: faPlanetRinged,
  faMushroom: faMushroom,
  faUserShield: faUserShield,
  faMegaphone: faMegaphone,
  faWreathLaurel: faWreathLaurel,
  faCircleExclamationCheck: faCircleExclamationCheck,
  faWind: faWind,
  faBoxDollar: faBoxDollar,
  faBoxUsd: faBoxUsd,
  faCarBurst: faCarBurst,
  faCarCrash: faCarCrash,
  faY: faY,
  faUserHeadset: faUserHeadset,
  faArrowsRetweet: faArrowsRetweet,
  faRetweetAlt: faRetweetAlt,
  faPersonSnowboarding: faPersonSnowboarding,
  faSnowboarding: faSnowboarding,
  faSquareChevronRight: faSquareChevronRight,
  faChevronSquareRight: faChevronSquareRight,
  faLacrosseStickBall: faLacrosseStickBall,
  faTruckFast: faTruckFast,
  faShippingFast: faShippingFast,
  faUserMagnifyingGlass: faUserMagnifyingGlass,
  faStarSharp: faStarSharp,
  faCommentHeart: faCommentHeart,
  faCircle1: faCircle1,
  faCircleStar: faCircleStar,
  faStarCircle: faStarCircle,
  faFish: faFish,
  faCloudFog: faCloudFog,
  faFog: faFog,
  faWaffle: faWaffle,
  faMusicNote: faMusicNote,
  faMusicAlt: faMusicAlt,
  faHexagonExclamation: faHexagonExclamation,
  faCartShoppingFast: faCartShoppingFast,
  faObjectUnion: faObjectUnion,
  faUserGraduate: faUserGraduate,
  faStarfighter: faStarfighter,
  faCircleHalfStroke: faCircleHalfStroke,
  faAdjust: faAdjust,
  faArrowRightLongToLine: faArrowRightLongToLine,
  faSquareArrowDown: faSquareArrowDown,
  faArrowSquareDown: faArrowSquareDown,
  faDiamondHalfStroke: faDiamondHalfStroke,
  faClapperboard: faClapperboard,
  faSquareChevronLeft: faSquareChevronLeft,
  faChevronSquareLeft: faChevronSquareLeft,
  faPhoneIntercom: faPhoneIntercom,
  faLinkHorizontal: faLinkHorizontal,
  faChainHorizontal: faChainHorizontal,
  faMango: faMango,
  faMusicNoteSlash: faMusicNoteSlash,
  faMusicAltSlash: faMusicAltSlash,
  faCircleRadiation: faCircleRadiation,
  faRadiationAlt: faRadiationAlt,
  faFaceTongueSweat: faFaceTongueSweat,
  faGlobeStand: faGlobeStand,
  faBaseball: faBaseball,
  faBaseballBall: faBaseballBall,
  faCircleP: faCircleP,
  faAwardSimple: faAwardSimple,
  faJetFighterUp: faJetFighterUp,
  faDiagramProject: faDiagramProject,
  faProjectDiagram: faProjectDiagram,
  faPedestal: faPedestal,
  faChartPyramid: faChartPyramid,
  faSidebar: faSidebar,
  faSnowmanHead: faSnowmanHead,
  faFrostyHead: faFrostyHead,
  faCopy: faCopy,
  faBurgerGlass: faBurgerGlass,
  faVolumeXmark: faVolumeXmark,
  faVolumeMute: faVolumeMute,
  faVolumeTimes: faVolumeTimes,
  faHandSparkles: faHandSparkles,
  faBarsFilter: faBarsFilter,
  faPaintbrushPencil: faPaintbrushPencil,
  faPartyBell: faPartyBell,
  faUserVneckHair: faUserVneckHair,
  faJackOLantern: faJackOLantern,
  faGrip: faGrip,
  faGripHorizontal: faGripHorizontal,
  faShareFromSquare: faShareFromSquare,
  faShareSquare: faShareSquare,
  faKeynote: faKeynote,
  faChildCombatant: faChildCombatant,
  faChildRifle: faChildRifle,
  faGun: faGun,
  faSquarePhone: faSquarePhone,
  faPhoneSquare: faPhoneSquare,
  faHatBeach: faHatBeach,
  faPlus: faPlus,
  faAdd: faAdd,
  faExpand: faExpand,
  faComputer: faComputer,
  faFort: faFort,
  faCloudCheck: faCloudCheck,
  faXmark: faXmark,
  faClose: faClose,
  faMultiply: faMultiply,
  faRemove: faRemove,
  faTimes: faTimes,
  faFaceSmirking: faFaceSmirking,
  faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
  faArrows: faArrows,
  faChalkboardUser: faChalkboardUser,
  faChalkboardTeacher: faChalkboardTeacher,
  faRhombus: faRhombus,
  faClawMarks: faClawMarks,
  faPesoSign: faPesoSign,
  faFaceSmileTongue: faFaceSmileTongue,
  faCartCircleXmark: faCartCircleXmark,
  faBuildingShield: faBuildingShield,
  faCirclePhoneFlip: faCirclePhoneFlip,
  faPhoneCircleAlt: faPhoneCircleAlt,
  faBaby: faBaby,
  faUsersLine: faUsersLine,
  faQuoteLeft: faQuoteLeft,
  faQuoteLeftAlt: faQuoteLeftAlt,
  faTractor: faTractor,
  faKeySkeleton: faKeySkeleton,
  faTrashArrowUp: faTrashArrowUp,
  faTrashRestore: faTrashRestore,
  faArrowDownUpLock: faArrowDownUpLock,
  faArrowDownToBracket: faArrowDownToBracket,
  faLinesLeaning: faLinesLeaning,
  faSquareQ: faSquareQ,
  faRulerCombined: faRulerCombined,
  faSymbols: faSymbols,
  faIconsAlt: faIconsAlt,
  faCopyright: faCopyright,
  faFlaskGear: faFlaskGear,
  faHighlighterLine: faHighlighterLine,
  faBracketSquare: faBracketSquare,
  faBracket: faBracket,
  faBracketLeft: faBracketLeft,
  faIslandTropical: faIslandTropical,
  faIslandTreePalm: faIslandTreePalm,
  faArrowRightFromLine: faArrowRightFromLine,
  faArrowFromLeft: faArrowFromLeft,
  faH2: faH2,
  faEquals: faEquals,
  faCakeSlice: faCakeSlice,
  faShortcake: faShortcake,
  faPeanut: faPeanut,
  faWrenchSimple: faWrenchSimple,
  faBlender: faBlender,
  faTeeth: faTeeth,
  faTally2: faTally2,
  faShekelSign: faShekelSign,
  faIls: faIls,
  faShekel: faShekel,
  faSheqel: faSheqel,
  faSheqelSign: faSheqelSign,
  faCars: faCars,
  faAxeBattle: faAxeBattle,
  faUserHairLong: faUserHairLong,
  faMap: faMap,
  faArrowLeftFromArc: faArrowLeftFromArc,
  faFileCircleInfo: faFileCircleInfo,
  faFaceDisappointed: faFaceDisappointed,
  faLassoSparkles: faLassoSparkles,
  faClockEleven: faClockEleven,
  faRocket: faRocket,
  faSirenOn: faSirenOn,
  faClockTen: faClockTen,
  faCandleHolder: faCandleHolder,
  faVideoArrowDownLeft: faVideoArrowDownLeft,
  faPhotoFilm: faPhotoFilm,
  faPhotoVideo: faPhotoVideo,
  faFloppyDiskCircleArrowRight: faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight: faSaveCircleArrowRight,
  faFolderMinus: faFolderMinus,
  faPlanetMoon: faPlanetMoon,
  faFaceEyesXmarks: faFaceEyesXmarks,
  faChartScatter: faChartScatter,
  faDisplayArrowDown: faDisplayArrowDown,
  faStore: faStore,
  faArrowTrendUp: faArrowTrendUp,
  faPlugCircleMinus: faPlugCircleMinus,
  faOliveBranch: faOliveBranch,
  faAngle: faAngle,
  faVacuumRobot: faVacuumRobot,
  faSignHanging: faSignHanging,
  faSign: faSign,
  faSquareDivide: faSquareDivide,
  faSignalStreamSlash: faSignalStreamSlash,
  faBezierCurve: faBezierCurve,
  faEyeDropperHalf: faEyeDropperHalf,
  faStoreLock: faStoreLock,
  faBellSlash: faBellSlash,
  faCloudBoltSun: faCloudBoltSun,
  faThunderstormSun: faThunderstormSun,
  faCameraSlash: faCameraSlash,
  faCommentQuote: faCommentQuote,
  faTablet: faTablet,
  faTabletAndroid: faTabletAndroid,
  faSchoolFlag: faSchoolFlag,
  faMessageCode: faMessageCode,
  faGlassHalf: faGlassHalf,
  faGlassHalfEmpty: faGlassHalfEmpty,
  faGlassHalfFull: faGlassHalfFull,
  faFill: faFill,
  faMessageMinus: faMessageMinus,
  faCommentAltMinus: faCommentAltMinus,
  faAngleUp: faAngleUp,
  faDinosaur: faDinosaur,
  faDrumstickBite: faDrumstickBite,
  faLinkHorizontalSlash: faLinkHorizontalSlash,
  faChainHorizontalSlash: faChainHorizontalSlash,
  faHollyBerry: faHollyBerry,
  faNose: faNose,
  faArrowLeftToArc: faArrowLeftToArc,
  faChevronLeft: faChevronLeft,
  faBacteria: faBacteria,
  faClouds: faClouds,
  faMoneyBillSimple: faMoneyBillSimple,
  faHandLizard: faHandLizard,
  faTablePivot: faTablePivot,
  faFilterSlash: faFilterSlash,
  faTrashCanUndo: faTrashCanUndo,
  faTrashCanArrowTurnLeft: faTrashCanArrowTurnLeft,
  faTrashUndoAlt: faTrashUndoAlt,
  faNotdef: faNotdef,
  faDisease: faDisease,
  faPersonToDoor: faPersonToDoor,
  faTurntable: faTurntable,
  faBriefcaseMedical: faBriefcaseMedical,
  faGenderless: faGenderless,
  faChevronRight: faChevronRight,
  faSignalWeak: faSignalWeak,
  faSignal1: faSignal1,
  faClockFive: faClockFive,
  faRetweet: faRetweet,
  faCarRear: faCarRear,
  faCarAlt: faCarAlt,
  faPumpSoap: faPumpSoap,
  faComputerClassic: faComputerClassic,
  faFrame: faFrame,
  faVideoSlash: faVideoSlash,
  faBatteryQuarter: faBatteryQuarter,
  faBattery2: faBattery2,
  faEllipsisStroke: faEllipsisStroke,
  faEllipsisHAlt: faEllipsisHAlt,
  faRadio: faRadio,
  faBabyCarriage: faBabyCarriage,
  faCarriageBaby: faCarriageBaby,
  faFaceExpressionless: faFaceExpressionless,
  faDownToDottedLine: faDownToDottedLine,
  faCloudMusic: faCloudMusic,
  faTrafficLight: faTrafficLight,
  faCloudMinus: faCloudMinus,
  faThermometer: faThermometer,
  faShieldMinus: faShieldMinus,
  faVrCardboard: faVrCardboard,
  faCarTilt: faCarTilt,
  faGaugeCircleMinus: faGaugeCircleMinus,
  faBrightnessLow: faBrightnessLow,
  faHandMiddleFinger: faHandMiddleFinger,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faTruckMoving: faTruckMoving,
  faGlassWaterDroplet: faGlassWaterDroplet,
  faConveyorBelt: faConveyorBelt,
  faLocationCheck: faLocationCheck,
  faMapMarkerCheck: faMapMarkerCheck,
  faCoinVertical: faCoinVertical,
  faDisplay: faDisplay,
  faPersonSign: faPersonSign,
  faFaceSmile: faFaceSmile,
  faSmile: faSmile,
  faPhoneHangup: faPhoneHangup,
  faSignatureSlash: faSignatureSlash,
  faThumbtack: faThumbtack,
  faThumbTack: faThumbTack,
  faWheatSlash: faWheatSlash,
  faTrophy: faTrophy,
  faCloudsSun: faCloudsSun,
  faPersonPraying: faPersonPraying,
  faPray: faPray,
  faHammer: faHammer,
  faFaceVomit: faFaceVomit,
  faSpeakers: faSpeakers,
  faTtyAnswer: faTtyAnswer,
  faTeletypeAnswer: faTeletypeAnswer,
  faMugTeaSaucer: faMugTeaSaucer,
  faDiagramLeanCanvas: faDiagramLeanCanvas,
  faAlt: faAlt,
  faDial: faDial,
  faDialMedHigh: faDialMedHigh,
  faHandPeace: faHandPeace,
  faCircleTrash: faCircleTrash,
  faTrashCircle: faTrashCircle,
  faRotate: faRotate,
  faSyncAlt: faSyncAlt,
  faCircleQuarters: faCircleQuarters,
  faSpinner: faSpinner,
  faTowerControl: faTowerControl,
  faArrowUpTriangleSquare: faArrowUpTriangleSquare,
  faSortShapesUp: faSortShapesUp,
  faWhale: faWhale,
  faRobot: faRobot,
  faPeace: faPeace,
  faPartyHorn: faPartyHorn,
  faGears: faGears,
  faCogs: faCogs,
  faSunBright: faSunBright,
  faSunAlt: faSunAlt,
  faWarehouse: faWarehouse,
  faConveyorBeltArm: faConveyorBeltArm,
  faLockKeyholeOpen: faLockKeyholeOpen,
  faLockOpenAlt: faLockOpenAlt,
  faSquareFragile: faSquareFragile,
  faBoxFragile: faBoxFragile,
  faSquareWineGlassCrack: faSquareWineGlassCrack,
  faArrowUpRightDots: faArrowUpRightDots,
  faSquareN: faSquareN,
  faSplotch: faSplotch,
  faFaceGrinHearts: faFaceGrinHearts,
  faGrinHearts: faGrinHearts,
  faMeter: faMeter,
  faMandolin: faMandolin,
  faDiceFour: faDiceFour,
  faSimCard: faSimCard,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faMercury: faMercury,
  faUpFromBracket: faUpFromBracket,
  faKnifeKitchen: faKnifeKitchen,
  faBorderRight: faBorderRight,
  faArrowTurnDown: faArrowTurnDown,
  faLevelDown: faLevelDown,
  faSpade: faSpade,
  faCardSpade: faCardSpade,
  faLineColumns: faLineColumns,
  faArrowRightToLine: faArrowRightToLine,
  faArrowToRight: faArrowToRight,
  faPersonFallingBurst: faPersonFallingBurst,
  faFlagPennant: faFlagPennant,
  faPennant: faPennant,
  faConveyorBeltEmpty: faConveyorBeltEmpty,
  faUserGroupSimple: faUserGroupSimple,
  faAward: faAward,
  faTicketSimple: faTicketSimple,
  faTicketAlt: faTicketAlt,
  faBuilding: faBuilding,
  faAnglesLeft: faAnglesLeft,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faCamcorder: faCamcorder,
  faVideoHandheld: faVideoHandheld,
  faPancakes: faPancakes,
  faAlbumCircleUser: faAlbumCircleUser,
  faSubtitlesSlash: faSubtitlesSlash,
  faQrcode: faQrcode,
  faDiceD10: faDiceD10,
  faFireplace: faFireplace,
  faBrowser: faBrowser,
  faPenPaintbrush: faPenPaintbrush,
  faPencilPaintbrush: faPencilPaintbrush,
  faFishCooked: faFishCooked,
  faChairOffice: faChairOffice,
  faNestingDolls: faNestingDolls,
  faClockRotateLeft: faClockRotateLeft,
  faHistory: faHistory,
  faTrumpet: faTrumpet,
  faFaceGrinBeamSweat: faFaceGrinBeamSweat,
  faGrinBeamSweat: faGrinBeamSweat,
  faFireSmoke: faFireSmoke,
  faPhoneMissed: faPhoneMissed,
  faFileExport: faFileExport,
  faArrowRightFromFile: faArrowRightFromFile,
  faShield: faShield,
  faShieldBlank: faShieldBlank,
  faArrowUpShortWide: faArrowUpShortWide,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faArrowsRepeat1: faArrowsRepeat1,
  faRepeat1Alt: faRepeat1Alt,
  faGunSlash: faGunSlash,
  faAvocado: faAvocado,
  faBinary: faBinary,
  faGlassesRound: faGlassesRound,
  faGlassesAlt: faGlassesAlt,
  faPhonePlus: faPhonePlus,
  faDitto: faDitto,
  faPersonSeat: faPersonSeat,
  faHouseMedical: faHouseMedical,
  faGolfBallTee: faGolfBallTee,
  faGolfBall: faGolfBall,
  faCircleChevronLeft: faCircleChevronLeft,
  faChevronCircleLeft: faChevronCircleLeft,
  faHouseChimneyWindow: faHouseChimneyWindow,
  faScythe: faScythe,
  faPenNib: faPenNib,
  faBanParking: faBanParking,
  faParkingCircleSlash: faParkingCircleSlash,
  faTentArrowTurnLeft: faTentArrowTurnLeft,
  faFaceDiagonalMouth: faFaceDiagonalMouth,
  faDiagramCells: faDiagramCells,
  faCricketBatBall: faCricketBatBall,
  faCricket: faCricket,
  faTents: faTents,
  faWandMagic: faWandMagic,
  faMagic: faMagic,
  faDog: faDog,
  faPenLine: faPenLine,
  faAtomSimple: faAtomSimple,
  faAtomAlt: faAtomAlt,
  faAmpersand: faAmpersand,
  faCarrot: faCarrot,
  faArrowUpFromLine: faArrowUpFromLine,
  faArrowFromBottom: faArrowFromBottom,
  faMoon: faMoon,
  faPenSlash: faPenSlash,
  faWineGlassEmpty: faWineGlassEmpty,
  faWineGlassAlt: faWineGlassAlt,
  faSquareStar: faSquareStar,
  faCheese: faCheese,
  faSendBackward: faSendBackward,
  faYinYang: faYinYang,
  faMusic: faMusic,
  faCompassSlash: faCompassSlash,
  faClockOne: faClockOne,
  faFileMusic: faFileMusic,
  faCodeCommit: faCodeCommit,
  faTemperatureLow: faTemperatureLow,
  faPersonBiking: faPersonBiking,
  faBiking: faBiking,
  faDisplayChartUpCircleCurrency: faDisplayChartUpCircleCurrency,
  faSkeleton: faSkeleton,
  faCircleG: faCircleG,
  faCircleArrowUpLeft: faCircleArrowUpLeft,
  faCoinBlank: faCoinBlank,
  faBroom: faBroom,
  faVacuum: faVacuum,
  faShieldHeart: faShieldHeart,
  faCardHeart: faCardHeart,
  faLightbulbCflOn: faLightbulbCflOn,
  faMelon: faMelon,
  faGopuram: faGopuram,
  faEarthOceania: faEarthOceania,
  faGlobeOceania: faGlobeOceania,
  faContainerStorage: faContainerStorage,
  faFacePouting: faFacePouting,
  faSquareXmark: faSquareXmark,
  faTimesSquare: faTimesSquare,
  faXmarkSquare: faXmarkSquare,
  faFaceExplode: faFaceExplode,
  faExplodingHead: faExplodingHead,
  faHashtag: faHashtag,
  faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
  faExpandAlt: faExpandAlt,
  faOilCan: faOilCan,
  faT: faT,
  faTransformerBolt: faTransformerBolt,
  faHippo: faHippo,
  faChartColumn: faChartColumn,
  faCassetteVhs: faCassetteVhs,
  faVhs: faVhs,
  faInfinity: faInfinity,
  faVialCircleCheck: faVialCircleCheck,
  faChimney: faChimney,
  faObjectIntersect: faObjectIntersect,
  faPersonArrowDownToLine: faPersonArrowDownToLine,
  faVoicemail: faVoicemail,
  faBlockBrick: faBlockBrick,
  faWallBrick: faWallBrick,
  faFan: faFan,
  faBagsShopping: faBagsShopping,
  faParagraphLeft: faParagraphLeft,
  faParagraphRtl: faParagraphRtl,
  faPersonWalkingLuggage: faPersonWalkingLuggage,
  faCaravanSimple: faCaravanSimple,
  faCaravanAlt: faCaravanAlt,
  faTurtle: faTurtle,
  faPencilMechanical: faPencilMechanical,
  faUpDown: faUpDown,
  faArrowsAltV: faArrowsAltV,
  faCloudMoonRain: faCloudMoonRain,
  faBoothCurtain: faBoothCurtain,
  faCalendar: faCalendar,
  faBoxHeart: faBoxHeart,
  faTrailer: faTrailer,
  faUserDoctorMessage: faUserDoctorMessage,
  faUserMdChat: faUserMdChat,
  faBahai: faBahai,
  faHaykal: faHaykal,
  faLighthouse: faLighthouse,
  faAmpGuitar: faAmpGuitar,
  faSdCard: faSdCard,
  faVolumeSlash: faVolumeSlash,
  faBorderBottom: faBorderBottom,
  faWifiWeak: faWifiWeak,
  faWifi1: faWifi1,
  faDragon: faDragon,
  faShoePrints: faShoePrints,
  faCirclePlus: faCirclePlus,
  faPlusCircle: faPlusCircle,
  faFaceGrinTongueWink: faFaceGrinTongueWink,
  faGrinTongueWink: faGrinTongueWink,
  faHandHolding: faHandHolding,
  faPlugCircleExclamation: faPlugCircleExclamation,
  faLinkSlash: faLinkSlash,
  faChainBroken: faChainBroken,
  faChainSlash: faChainSlash,
  faUnlink: faUnlink,
  faClone: faClone,
  faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
  faArrowUpZA: faArrowUpZA,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faFireFlameCurved: faFireFlameCurved,
  faFireAlt: faFireAlt,
  faTornado: faTornado,
  faFileCirclePlus: faFileCirclePlus,
  faDeleteRight: faDeleteRight,
  faBookQuran: faBookQuran,
  faQuran: faQuran,
  faCircleQuarter: faCircleQuarter,
  faAnchor: faAnchor,
  faBorderAll: faBorderAll,
  faFunction: faFunction,
  faFaceAngry: faFaceAngry,
  faAngry: faAngry,
  faPeopleSimple: faPeopleSimple,
  faCookieBite: faCookieBite,
  faArrowTrendDown: faArrowTrendDown,
  faRss: faRss,
  faFeed: faFeed,
  faFaceMonocle: faFaceMonocle,
  faDrawPolygon: faDrawPolygon,
  faScaleBalanced: faScaleBalanced,
  faBalanceScale: faBalanceScale,
  faCalendarLines: faCalendarLines,
  faCalendarNote: faCalendarNote,
  faArrowDownBigSmall: faArrowDownBigSmall,
  faSortSizeDown: faSortSizeDown,
  faGaugeSimpleHigh: faGaugeSimpleHigh,
  faTachometer: faTachometer,
  faTachometerFast: faTachometerFast,
  faDoNotEnter: faDoNotEnter,
  faShower: faShower,
  faDiceD8: faDiceD8,
  faDesktop: faDesktop,
  faDesktopAlt: faDesktopAlt,
  faM: faM,
  faGripDotsVertical: faGripDotsVertical,
  faFaceViewfinder: faFaceViewfinder,
  faSoftServe: faSoftServe,
  faCreemee: faCreemee,
  faH5: faH5,
  faHandBackPointDown: faHandBackPointDown,
  faTableList: faTableList,
  faThList: faThList,
  faCommentSms: faCommentSms,
  faSms: faSms,
  faRectangle: faRectangle,
  faRectangleLandscape: faRectangleLandscape,
  faClipboardListCheck: faClipboardListCheck,
  faTurkey: faTurkey,
  faBook: faBook,
  faUserPlus: faUserPlus,
  faIceSkate: faIceSkate,
  faCheck: faCheck,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBattery4: faBattery4,
  faTomato: faTomato,
  faSwordLaser: faSwordLaser,
  faHouseCircleCheck: faHouseCircleCheck,
  faBuildings: faBuildings,
  faAngleLeft: faAngleLeft,
  faCartFlatbedBoxes: faCartFlatbedBoxes,
  faDollyFlatbedAlt: faDollyFlatbedAlt,
  faDiagramSuccessor: faDiagramSuccessor,
  faTruckArrowRight: faTruckArrowRight,
  faSquareW: faSquareW,
  faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
  faLamp: faLamp,
  faAirplay: faAirplay,
  faHandFist: faHandFist,
  faFistRaised: faFistRaised,
  faShieldQuartered: faShieldQuartered,
  faSlashForward: faSlashForward,
  faLocationPen: faLocationPen,
  faMapMarkerEdit: faMapMarkerEdit,
  faCloudMoon: faCloudMoon,
  faPotFood: faPotFood,
  faBriefcase: faBriefcase,
  faPersonFalling: faPersonFalling,
  faImagePortrait: faImagePortrait,
  faPortrait: faPortrait,
  faUserTag: faUserTag,
  faRug: faRug,
  faPrintSlash: faPrintSlash,
  faEarthEurope: faEarthEurope,
  faGlobeEurope: faGlobeEurope,
  faCartFlatbedSuitcase: faCartFlatbedSuitcase,
  faLuggageCart: faLuggageCart,
  faHandBackPointRibbon: faHandBackPointRibbon,
  faRectangleXmark: faRectangleXmark,
  faRectangleTimes: faRectangleTimes,
  faTimesRectangle: faTimesRectangle,
  faWindowClose: faWindowClose,
  faTireRugged: faTireRugged,
  faLightbulbDollar: faLightbulbDollar,
  faCowbell: faCowbell,
  faBahtSign: faBahtSign,
  faCorner: faCorner,
  faChevronsRight: faChevronsRight,
  faChevronDoubleRight: faChevronDoubleRight,
  faBookOpen: faBookOpen,
  faBookJournalWhills: faBookJournalWhills,
  faJournalWhills: faJournalWhills,
  faInhaler: faInhaler,
  faHandcuffs: faHandcuffs,
  faSnake: faSnake,
  faTriangleExclamation: faTriangleExclamation,
  faExclamationTriangle: faExclamationTriangle,
  faWarning: faWarning,
  faNoteMedical: faNoteMedical,
  faDatabase: faDatabase,
  faDownLeft: faDownLeft,
  faShare: faShare,
  faArrowTurnRight: faArrowTurnRight,
  faMailForward: faMailForward,
  faFaceThinking: faFaceThinking,
  faTurnDownRight: faTurnDownRight,
  faBottleDroplet: faBottleDroplet,
  faMaskFace: faMaskFace,
  faHillRockslide: faHillRockslide,
  faScannerKeyboard: faScannerKeyboard,
  faCircleO: faCircleO,
  faGridHorizontal: faGridHorizontal,
  faMessageDollar: faMessageDollar,
  faCommentAltDollar: faCommentAltDollar,
  faRightLeft: faRightLeft,
  faExchangeAlt: faExchangeAlt,
  faColumns3: faColumns3,
  faPaperPlane: faPaperPlane,
  faRoadCircleExclamation: faRoadCircleExclamation,
  faDungeon: faDungeon,
  faHandHoldingBox: faHandHoldingBox,
  faInputText: faInputText,
  faWindowFlip: faWindowFlip,
  faWindowAlt: faWindowAlt,
  faAlignRight: faAlignRight,
  faScannerGun: faScannerGun,
  faScanner: faScanner,
  faTire: faTire,
  faEngine: faEngine,
  faMoneyBill1Wave: faMoneyBill1Wave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faLifeRing: faLifeRing,
  faHands: faHands,
  faSignLanguage: faSignLanguage,
  faSigning: faSigning,
  faCircleCaretRight: faCircleCaretRight,
  faCaretCircleRight: faCaretCircleRight,
  faWheat: faWheat,
  faFileSpreadsheet: faFileSpreadsheet,
  faAudioDescriptionSlash: faAudioDescriptionSlash,
  faCalendarDay: faCalendarDay,
  faWaterLadder: faWaterLadder,
  faLadderWater: faLadderWater,
  faSwimmingPool: faSwimmingPool,
  faArrowsUpDown: faArrowsUpDown,
  faArrowsV: faArrowsV,
  faChessPawnPiece: faChessPawnPiece,
  faChessPawnAlt: faChessPawnAlt,
  faFaceGrimace: faFaceGrimace,
  faGrimace: faGrimace,
  faWheelchairMove: faWheelchairMove,
  faWheelchairAlt: faWheelchairAlt,
  faTurnDown: faTurnDown,
  faLevelDownAlt: faLevelDownAlt,
  faSquareS: faSquareS,
  faRectangleBarcode: faRectangleBarcode,
  faBarcodeAlt: faBarcodeAlt,
  faPersonWalkingArrowRight: faPersonWalkingArrowRight,
  faSquareEnvelope: faSquareEnvelope,
  faEnvelopeSquare: faEnvelopeSquare,
  faDice: faDice,
  faUnicorn: faUnicorn,
  faBowlingBall: faBowlingBall,
  faPompebled: faPompebled,
  faBrain: faBrain,
  faWatchSmart: faWatchSmart,
  faBookUser: faBookUser,
  faSensorCloud: faSensorCloud,
  faSensorSmoke: faSensorSmoke,
  faClapperboardPlay: faClapperboardPlay,
  faBandage: faBandage,
  faBandAid: faBandAid,
  faCalendarMinus: faCalendarMinus,
  faCircleXmark: faCircleXmark,
  faTimesCircle: faTimesCircle,
  faXmarkCircle: faXmarkCircle,
  faCircle4: faCircle4,
  faGifts: faGifts,
  faAlbumCollection: faAlbumCollection,
  faHotel: faHotel,
  faEarthAsia: faEarthAsia,
  faGlobeAsia: faGlobeAsia,
  faIdCardClip: faIdCardClip,
  faIdCardAlt: faIdCardAlt,
  faMagnifyingGlassPlus: faMagnifyingGlassPlus,
  faSearchPlus: faSearchPlus,
  faThumbsUp: faThumbsUp,
  faCloudShowers: faCloudShowers,
  faUserClock: faUserClock,
  faOnion: faOnion,
  faClockTwelveThirty: faClockTwelveThirty,
  faArrowDownToDottedLine: faArrowDownToDottedLine,
  faHandDots: faHandDots,
  faAllergies: faAllergies,
  faFileInvoice: faFileInvoice,
  faWindowMinimize: faWindowMinimize,
  faRectangleWide: faRectangleWide,
  faCommentArrowUp: faCommentArrowUp,
  faGarlic: faGarlic,
  faMugSaucer: faMugSaucer,
  faCoffee: faCoffee,
  faBrush: faBrush,
  faTreeDecorated: faTreeDecorated,
  faMask: faMask,
  faCalendarHeart: faCalendarHeart,
  faMagnifyingGlassMinus: faMagnifyingGlassMinus,
  faSearchMinus: faSearchMinus,
  faFlower: faFlower,
  faArrowDownFromArc: faArrowDownFromArc,
  faRightLeftLarge: faRightLeftLarge,
  faRulerVertical: faRulerVertical,
  faCirclesOverlap: faCirclesOverlap,
  faUserLarge: faUserLarge,
  faUserAlt: faUserAlt,
  faStarshipFreighter: faStarshipFreighter,
  faTrainTram: faTrainTram,
  faBridgeSuspension: faBridgeSuspension,
  faTrashCheck: faTrashCheck,
  faUserNurse: faUserNurse,
  faBoombox: faBoombox,
  faSyringe: faSyringe,
  faCloudSun: faCloudSun,
  faShieldExclamation: faShieldExclamation,
  faStopwatch20: faStopwatch20,
  faSquareFull: faSquareFull,
  faGripDots: faGripDots,
  faCommentExclamation: faCommentExclamation,
  faPenSwirl: faPenSwirl,
  faFalafel: faFalafel,
  faCircle2: faCircle2,
  faMagnet: faMagnet,
  faJar: faJar,
  faGramophone: faGramophone,
  faDiceD12: faDiceD12,
  faNoteSticky: faNoteSticky,
  faStickyNote: faStickyNote,
  faDown: faDown,
  faArrowAltDown: faArrowAltDown,
  faHundredPoints: faHundredPoints,
  fa100: fa100,
  faPaperclipVertical: faPaperclipVertical,
  faWindWarning: faWindWarning,
  faWindCircleExclamation: faWindCircleExclamation,
  faLocationPinSlash: faLocationPinSlash,
  faMapMarkerSlash: faMapMarkerSlash,
  faFaceSadSweat: faFaceSadSweat,
  faBugSlash: faBugSlash,
  faCupcake: faCupcake,
  faLightSwitchOff: faLightSwitchOff,
  faToggleLargeOff: faToggleLargeOff,
  faPenFancySlash: faPenFancySlash,
  faTruckContainer: faTruckContainer,
  faBoot: faBoot,
  faArrowUpFromWaterPump: faArrowUpFromWaterPump,
  faFileCheck: faFileCheck,
  faBone: faBone,
  faCardsBlank: faCardsBlank,
  faCircle3: faCircle3,
  faBenchTree: faBenchTree,
  faKeyboardBrightnessLow: faKeyboardBrightnessLow,
  faSkiBootSki: faSkiBootSki,
  faBrainCircuit: faBrainCircuit,
  faUserInjured: faUserInjured,
  faBlockBrickFire: faBlockBrickFire,
  faFirewall: faFirewall,
  faFaceSadTear: faFaceSadTear,
  faSadTear: faSadTear,
  faPlane: faPlane,
  faTentArrowsDown: faTentArrowsDown,
  faExclamation: faExclamation,
  faArrowsSpin: faArrowsSpin,
  faFaceSmileRelaxed: faFaceSmileRelaxed,
  faCommentXmark: faCommentXmark,
  faCommentTimes: faCommentTimes,
  faPrint: faPrint,
  faTurkishLiraSign: faTurkishLiraSign,
  faTry: faTry,
  faTurkishLira: faTurkishLira,
  faFaceNoseSteam: faFaceNoseSteam,
  faCircleWaveformLines: faCircleWaveformLines,
  faWaveformCircle: faWaveformCircle,
  faDollarSign: faDollarSign,
  faDollar: faDollar,
  faUsd: faUsd,
  faFerrisWheel: faFerrisWheel,
  faComputerSpeaker: faComputerSpeaker,
  faSkullCow: faSkullCow,
  faX: faX,
  faMagnifyingGlassDollar: faMagnifyingGlassDollar,
  faSearchDollar: faSearchDollar,
  faUsersGear: faUsersGear,
  faUsersCog: faUsersCog,
  faPersonMilitaryPointing: faPersonMilitaryPointing,
  faBuildingColumns: faBuildingColumns,
  faBank: faBank,
  faInstitution: faInstitution,
  faMuseum: faMuseum,
  faUniversity: faUniversity,
  faCircleT: faCircleT,
  faSack: faSack,
  faGrid2: faGrid2,
  faCameraCctv: faCameraCctv,
  faCctv: faCctv,
  faUmbrella: faUmbrella,
  faTrowel: faTrowel,
  faHorizontalRule: faHorizontalRule,
  faBedFront: faBedFront,
  faBedAlt: faBedAlt,
  faD: faD,
  faStapler: faStapler,
  faMasksTheater: faMasksTheater,
  faTheaterMasks: faTheaterMasks,
  faKipSign: faKipSign,
  faFaceWoozy: faFaceWoozy,
  faCloudQuestion: faCloudQuestion,
  faPineapple: faPineapple,
  faHandPointLeft: faHandPointLeft,
  faGalleryThumbnails: faGalleryThumbnails,
  faCircleJ: faCircleJ,
  faEyes: faEyes,
  faHandshakeSimple: faHandshakeSimple,
  faHandshakeAlt: faHandshakeAlt,
  faPageCaretUp: faPageCaretUp,
  faFileCaretUp: faFileCaretUp,
  faJetFighter: faJetFighter,
  faFighterJet: faFighterJet,
  faComet: faComet,
  faSquareShareNodes: faSquareShareNodes,
  faShareAltSquare: faShareAltSquare,
  faShieldKeyhole: faShieldKeyhole,
  faBarcode: faBarcode,
  faPlusMinus: faPlusMinus,
  faSquareSlidersVertical: faSquareSlidersVertical,
  faSlidersVSquare: faSlidersVSquare,
  faVideo: faVideo,
  faVideoCamera: faVideoCamera,
  faMessageMiddle: faMessageMiddle,
  faCommentMiddleAlt: faCommentMiddleAlt,
  faGraduationCap: faGraduationCap,
  faMortarBoard: faMortarBoard,
  faHandHoldingMedical: faHandHoldingMedical,
  faPersonCircleCheck: faPersonCircleCheck,
  faSquareZ: faSquareZ,
  faMessageText: faMessageText,
  faCommentAltText: faCommentAltText,
  faTurnUp: faTurnUp,
  faLevelUpAlt: faLevelUpAlt
};




/***/ }),

/***/ 94789:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Wo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_computed_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71646);
/* harmony import */ var _hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94192);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73781);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19946);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16723);
/* harmony import */ var _hooks_use_latest_value_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(3855);
/* harmony import */ var _hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39650);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14157);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_tree_walker_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(31591);
/* harmony import */ var _utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11497);
/* harmony import */ var _utils_disposables_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(9362);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12351);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(64103);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32984);
/* harmony import */ var _utils_form_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18689);
/* harmony import */ var _utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84575);
/* harmony import */ var _internal_hidden_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46045);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16567);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61363);
/* harmony import */ var _hooks_use_controllable_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31147);
/* harmony import */ var _hooks_use_watch_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96599);
/* harmony import */ var _hooks_use_tracked_pointer_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(40476);
/* harmony import */ var _utils_platform_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(78657);
var ke=(e=>(e[e.Open=0]="Open",e[e.Closed=1]="Closed",e))(ke||{}),we=(e=>(e[e.Single=0]="Single",e[e.Multi=1]="Multi",e))(we||{}),Ue=(e=>(e[e.Pointer=0]="Pointer",e[e.Other=1]="Other",e))(Ue||{}),He=(n=>(n[n.OpenCombobox=0]="OpenCombobox",n[n.CloseCombobox=1]="CloseCombobox",n[n.GoToOption=2]="GoToOption",n[n.RegisterOption=3]="RegisterOption",n[n.UnregisterOption=4]="UnregisterOption",n[n.RegisterLabel=5]="RegisterLabel",n))(He||{});function ae(t,l=e=>e){let e=t.activeOptionIndex!==null?t.options[t.activeOptionIndex]:null,r=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .sortByDomNode */ .z2)(l(t.options.slice()),b=>b.dataRef.current.domRef.current),a=e?r.indexOf(e):null;return a===-1&&(a=null),{options:r,activeOptionIndex:a}}let Ne={[1](t){var l;return(l=t.dataRef.current)!=null&&l.disabled||t.comboboxState===1?t:{...t,activeOptionIndex:null,comboboxState:1}},[0](t){var e;if((e=t.dataRef.current)!=null&&e.disabled||t.comboboxState===0)return t;let l=t.activeOptionIndex;if(t.dataRef.current){let{isSelected:r}=t.dataRef.current,a=t.options.findIndex(b=>r(b.dataRef.current.value));a!==-1&&(l=a)}return{...t,comboboxState:0,activeOptionIndex:l}},[2](t,l){var a,b,n,d;if((a=t.dataRef.current)!=null&&a.disabled||(b=t.dataRef.current)!=null&&b.optionsRef.current&&!((n=t.dataRef.current)!=null&&n.optionsPropsRef.current.static)&&t.comboboxState===1)return t;let e=ae(t);if(e.activeOptionIndex===null){let o=e.options.findIndex(i=>!i.dataRef.current.disabled);o!==-1&&(e.activeOptionIndex=o)}let r=(0,_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .calculateActiveIndex */ .d)(l,{resolveItems:()=>e.options,resolveActiveIndex:()=>e.activeOptionIndex,resolveId:o=>o.id,resolveDisabled:o=>o.dataRef.current.disabled});return{...t,...e,activeOptionIndex:r,activationTrigger:(d=l.trigger)!=null?d:1}},[3]:(t,l)=>{var b,n;let e={id:l.id,dataRef:l.dataRef},r=ae(t,d=>[...d,e]);t.activeOptionIndex===null&&(b=t.dataRef.current)!=null&&b.isSelected(l.dataRef.current.value)&&(r.activeOptionIndex=r.options.indexOf(e));let a={...t,...r,activationTrigger:1};return(n=t.dataRef.current)!=null&&n.__demoMode&&t.dataRef.current.value===void 0&&(a.activeOptionIndex=0),a},[4]:(t,l)=>{let e=ae(t,r=>{let a=r.findIndex(b=>b.id===l.id);return a!==-1&&r.splice(a,1),r});return{...t,...e,activationTrigger:1}},[5]:(t,l)=>({...t,labelId:l.id})},le=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);le.displayName="ComboboxActionsContext";function q(t){let l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(le);if(l===null){let e=new Error(`<${t} /> is missing a parent <Combobox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(e,q),e}return l}let ie=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);ie.displayName="ComboboxDataContext";function G(t){let l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ie);if(l===null){let e=new Error(`<${t} /> is missing a parent <Combobox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(e,G),e}return l}function Ge(t,l){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(l.type,Ne,t,l)}let Xe=react__WEBPACK_IMPORTED_MODULE_0__.Fragment;function je(t,l){let{value:e,defaultValue:r,onChange:a,form:b,name:n,by:d=(p,m)=>p===m,disabled:o=!1,__demoMode:i=!1,nullable:E=!1,multiple:f=!1,...A}=t,[T=f?[]:void 0,g]=(0,_hooks_use_controllable_js__WEBPACK_IMPORTED_MODULE_4__/* .useControllable */ .q)(e,a,r),[c,x]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Ge,{dataRef:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),comboboxState:i?0:1,options:[],activeOptionIndex:null,activationTrigger:1,labelId:null}),L=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1),D=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({static:!1,hold:!1}),B=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),k=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),w=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),X=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),F=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(typeof d=="string"?(p,m)=>{let R=d;return(p==null?void 0:p[R])===(m==null?void 0:m[R])}:d),M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(p=>(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(s.mode,{[1]:()=>T.some(m=>F(m,p)),[0]:()=>F(T,p)}),[T]),s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({...c,optionsPropsRef:D,labelRef:B,inputRef:k,buttonRef:w,optionsRef:X,value:T,defaultValue:r,disabled:o,mode:f?1:0,get activeOptionIndex(){if(L.current&&c.activeOptionIndex===null&&c.options.length>0){let p=c.options.findIndex(m=>!m.dataRef.current.disabled);if(p!==-1)return p}return c.activeOptionIndex},compare:F,isSelected:M,nullable:E,__demoMode:i}),[T,r,o,f,E,i,c]),O=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(s.activeOptionIndex!==null?s.options[s.activeOptionIndex]:null);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{let p=s.activeOptionIndex!==null?s.options[s.activeOptionIndex]:null;O.current!==p&&(O.current=p)}),(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(()=>{c.dataRef.current=s},[s]),(0,_hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_7__/* .useOutsideClick */ .O)([s.buttonRef,s.inputRef,s.optionsRef],()=>te.closeCombobox(),s.comboboxState===0);let S=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:s.comboboxState===0,disabled:o,activeIndex:s.activeOptionIndex,activeOption:s.activeOptionIndex===null?null:s.options[s.activeOptionIndex].dataRef.current.value,value:T}),[s,o,T]),u=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(p=>{let m=s.options.find(R=>R.id===p);m&&J(m.dataRef.current.value)}),_=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{if(s.activeOptionIndex!==null){let{dataRef:p,id:m}=s.options[s.activeOptionIndex];J(p.current.value),te.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,m)}}),I=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{x({type:0}),L.current=!0}),j=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{x({type:1}),L.current=!1}),Q=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)((p,m,R)=>(L.current=!1,p===_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific?x({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,id:m,trigger:R}):x({type:2,focus:p,trigger:R}))),Y=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)((p,m)=>(x({type:3,id:p,dataRef:m}),()=>{var R;((R=O.current)==null?void 0:R.id)===p&&(L.current=!0),x({type:4,id:p})})),Z=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(p=>(x({type:5,id:p}),()=>x({type:5,id:null}))),J=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(p=>(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(s.mode,{[0](){return g==null?void 0:g(p)},[1](){let m=s.value.slice(),R=m.findIndex(K=>F(K,p));return R===-1?m.push(p):m.splice(R,1),g==null?void 0:g(m)}})),te=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({onChange:J,registerOption:Y,registerLabel:Z,goToOption:Q,closeCombobox:j,openCombobox:I,selectActiveOption:_,selectOption:u}),[]),Te=l===null?{}:{ref:l},z=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),me=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_8__/* .useDisposables */ .G)();return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{z.current&&r!==void 0&&me.addEventListener(z.current,"reset",()=>{J(r)})},[z,J]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(le.Provider,{value:te},react__WEBPACK_IMPORTED_MODULE_0__.createElement(ie.Provider,{value:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_9__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(s.comboboxState,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_9__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_9__/* .State.Closed */ .ZM.Closed})},n!=null&&T!=null&&(0,_utils_form_js__WEBPACK_IMPORTED_MODULE_10__/* .objectToFormEntries */ .t)({[n]:T}).map(([p,m],R)=>react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_11__/* .Hidden */ ._,{features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_11__/* .Features.Hidden */ .A.Hidden,ref:R===0?K=>{var ue;z.current=(ue=K==null?void 0:K.closest("form"))!=null?ue:null}:void 0,...(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .compact */ .oA)({key:p,as:"input",type:"hidden",hidden:!0,readOnly:!0,form:b,name:p,value:m})})),(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:Te,theirProps:A,slot:S,defaultTag:Xe,name:"Combobox"}))))}let Je="input";function Ke(t,l){var M,s,O,S;let e=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:r=`headlessui-combobox-input-${e}`,onChange:a,displayValue:b,type:n="text",...d}=t,o=G("Combobox.Input"),i=q("Combobox.Input"),E=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_14__/* .useSyncRefs */ .T)(o.inputRef,l),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1),A=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_8__/* .useDisposables */ .G)(),T=function(){var u;return typeof b=="function"&&o.value!==void 0?(u=b(o.value))!=null?u:"":typeof o.value=="string"?o.value:""}();(0,_hooks_use_watch_js__WEBPACK_IMPORTED_MODULE_15__/* .useWatch */ .q)(([u,_],[I,j])=>{f.current||o.inputRef.current&&(j===0&&_===1||u!==I)&&(o.inputRef.current.value=u)},[T,o.comboboxState]),(0,_hooks_use_watch_js__WEBPACK_IMPORTED_MODULE_15__/* .useWatch */ .q)(([u],[_])=>{if(u===0&&_===1){let I=o.inputRef.current;if(!I)return;let j=I.value,{selectionStart:Q,selectionEnd:Y,selectionDirection:Z}=I;I.value="",I.value=j,Z!==null?I.setSelectionRange(Q,Y,Z):I.setSelectionRange(Q,Y)}},[o.comboboxState]);let g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1),c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),x=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{g.current=!0}),L=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{A.nextFrame(()=>{g.current=!1,c.current&&(i.openCombobox(),a==null||a(c.current),c.current=null)})}),D=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(u=>{switch(f.current=!0,u.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.Backspace */ .R.Backspace:case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.Delete */ .R.Delete:if(o.mode!==0||!o.nullable)return;let _=u.currentTarget;A.requestAnimationFrame(()=>{_.value===""&&(i.onChange(null),o.optionsRef.current&&(o.optionsRef.current.scrollTop=0),i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Nothing */ .T.Nothing))});break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.Enter */ .R.Enter:if(f.current=!1,o.comboboxState!==0||g.current)return;if(u.preventDefault(),u.stopPropagation(),o.activeOptionIndex===null){i.closeCombobox();return}i.selectActiveOption(),o.mode===0&&i.closeCombobox();break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.ArrowDown */ .R.ArrowDown:return f.current=!1,u.preventDefault(),u.stopPropagation(),(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(o.comboboxState,{[0]:()=>{i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Next */ .T.Next)},[1]:()=>{i.openCombobox()}});case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.ArrowUp */ .R.ArrowUp:return f.current=!1,u.preventDefault(),u.stopPropagation(),(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(o.comboboxState,{[0]:()=>{i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Previous */ .T.Previous)},[1]:()=>{i.openCombobox(),A.nextFrame(()=>{o.value||i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last)})}});case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.Home */ .R.Home:if(u.shiftKey)break;return f.current=!1,u.preventDefault(),u.stopPropagation(),i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.First */ .T.First);case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.PageUp */ .R.PageUp:return f.current=!1,u.preventDefault(),u.stopPropagation(),i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.First */ .T.First);case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.End */ .R.End:if(u.shiftKey)break;return f.current=!1,u.preventDefault(),u.stopPropagation(),i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last);case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.PageDown */ .R.PageDown:return f.current=!1,u.preventDefault(),u.stopPropagation(),i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last);case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.Escape */ .R.Escape:return f.current=!1,o.comboboxState!==0?void 0:(u.preventDefault(),o.optionsRef.current&&!o.optionsPropsRef.current.static&&u.stopPropagation(),i.closeCombobox());case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.Tab */ .R.Tab:if(f.current=!1,o.comboboxState!==0)return;o.mode===0&&i.selectActiveOption(),i.closeCombobox();break}}),B=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(u=>{if(g.current){c.current=u;return}i.openCombobox(),a==null||a(u)}),k=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{f.current=!1}),w=(0,_hooks_use_computed_js__WEBPACK_IMPORTED_MODULE_17__/* .useComputed */ .v)(()=>{if(o.labelId)return[o.labelId].join(" ")},[o.labelId]),X=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:o.comboboxState===0,disabled:o.disabled}),[o]),F={ref:E,id:r,role:"combobox",type:n,"aria-controls":(M=o.optionsRef.current)==null?void 0:M.id,"aria-expanded":o.disabled?void 0:o.comboboxState===0,"aria-activedescendant":o.activeOptionIndex===null||(s=o.options[o.activeOptionIndex])==null?void 0:s.id,"aria-labelledby":w,"aria-autocomplete":"list",defaultValue:(S=(O=t.defaultValue)!=null?O:o.defaultValue!==void 0?b==null?void 0:b(o.defaultValue):null)!=null?S:o.defaultValue,disabled:o.disabled,onCompositionStart:x,onCompositionEnd:L,onKeyDown:D,onChange:B,onBlur:k};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:F,theirProps:d,slot:X,defaultTag:Je,name:"Combobox.Input"})}let We="button";function $e(t,l){var g;let e=G("Combobox.Button"),r=q("Combobox.Button"),a=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_14__/* .useSyncRefs */ .T)(e.buttonRef,l),b=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:n=`headlessui-combobox-button-${b}`,...d}=t,o=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_8__/* .useDisposables */ .G)(),i=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(c=>{switch(c.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.ArrowDown */ .R.ArrowDown:return c.preventDefault(),c.stopPropagation(),e.comboboxState===1&&r.openCombobox(),o.nextFrame(()=>{var x;return(x=e.inputRef.current)==null?void 0:x.focus({preventScroll:!0})});case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.ArrowUp */ .R.ArrowUp:return c.preventDefault(),c.stopPropagation(),e.comboboxState===1&&(r.openCombobox(),o.nextFrame(()=>{e.value||r.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last)})),o.nextFrame(()=>{var x;return(x=e.inputRef.current)==null?void 0:x.focus({preventScroll:!0})});case _keyboard_js__WEBPACK_IMPORTED_MODULE_16__/* .Keys.Escape */ .R.Escape:return e.comboboxState!==0?void 0:(c.preventDefault(),e.optionsRef.current&&!e.optionsPropsRef.current.static&&c.stopPropagation(),r.closeCombobox(),o.nextFrame(()=>{var x;return(x=e.inputRef.current)==null?void 0:x.focus({preventScroll:!0})}));default:return}}),E=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(c=>{if((0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_18__/* .isDisabledReactIssue7711 */ .P)(c.currentTarget))return c.preventDefault();e.comboboxState===0?r.closeCombobox():(c.preventDefault(),r.openCombobox()),o.nextFrame(()=>{var x;return(x=e.inputRef.current)==null?void 0:x.focus({preventScroll:!0})})}),f=(0,_hooks_use_computed_js__WEBPACK_IMPORTED_MODULE_17__/* .useComputed */ .v)(()=>{if(e.labelId)return[e.labelId,n].join(" ")},[e.labelId,n]),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:e.comboboxState===0,disabled:e.disabled,value:e.value}),[e]),T={ref:a,id:n,type:(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_19__/* .useResolveButtonType */ .f)(t,e.buttonRef),tabIndex:-1,"aria-haspopup":"listbox","aria-controls":(g=e.optionsRef.current)==null?void 0:g.id,"aria-expanded":e.disabled?void 0:e.comboboxState===0,"aria-labelledby":f,disabled:e.disabled,onClick:E,onKeyDown:i};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:T,theirProps:d,slot:A,defaultTag:We,name:"Combobox.Button"})}let qe="label";function Qe(t,l){let e=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:r=`headlessui-combobox-label-${e}`,...a}=t,b=G("Combobox.Label"),n=q("Combobox.Label"),d=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_14__/* .useSyncRefs */ .T)(b.labelRef,l);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(()=>n.registerLabel(r),[r]);let o=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{var f;return(f=b.inputRef.current)==null?void 0:f.focus({preventScroll:!0})}),i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:b.comboboxState===0,disabled:b.disabled}),[b]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:{ref:d,id:r,onClick:o},theirProps:a,slot:i,defaultTag:qe,name:"Combobox.Label"})}let Ye="ul",Ze=_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .Features.Static */ .AN.Static;function ze(t,l){let e=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:r=`headlessui-combobox-options-${e}`,hold:a=!1,...b}=t,n=G("Combobox.Options"),d=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_14__/* .useSyncRefs */ .T)(n.optionsRef,l),o=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_9__/* .useOpenClosed */ .oJ)(),i=(()=>o!==null?(o&_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_9__/* .State.Open */ .ZM.Open)===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_9__/* .State.Open */ .ZM.Open:n.comboboxState===0)();(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(()=>{var T;n.optionsPropsRef.current.static=(T=t.static)!=null?T:!1},[n.optionsPropsRef,t.static]),(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(()=>{n.optionsPropsRef.current.hold=a},[n.optionsPropsRef,a]),(0,_hooks_use_tree_walker_js__WEBPACK_IMPORTED_MODULE_20__/* .useTreeWalker */ .B)({container:n.optionsRef.current,enabled:n.comboboxState===0,accept(T){return T.getAttribute("role")==="option"?NodeFilter.FILTER_REJECT:T.hasAttribute("role")?NodeFilter.FILTER_SKIP:NodeFilter.FILTER_ACCEPT},walk(T){T.setAttribute("role","none")}});let E=(0,_hooks_use_computed_js__WEBPACK_IMPORTED_MODULE_17__/* .useComputed */ .v)(()=>{var T,g;return(g=n.labelId)!=null?g:(T=n.buttonRef.current)==null?void 0:T.id},[n.labelId,n.buttonRef.current]),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:n.comboboxState===0}),[n]),A={"aria-labelledby":E,role:"listbox","aria-multiselectable":n.mode===1?!0:void 0,id:r,ref:d};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:A,theirProps:b,slot:f,defaultTag:Ye,features:Ze,visible:i,name:"Combobox.Options"})}let eo="li";function oo(t,l){var M,s;let e=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:r=`headlessui-combobox-option-${e}`,disabled:a=!1,value:b,...n}=t,d=G("Combobox.Option"),o=q("Combobox.Option"),i=d.activeOptionIndex!==null?d.options[d.activeOptionIndex].id===r:!1,E=d.isSelected(b),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),A=(0,_hooks_use_latest_value_js__WEBPACK_IMPORTED_MODULE_21__/* .useLatestValue */ .E)({disabled:a,value:b,domRef:f,textValue:(s=(M=f.current)==null?void 0:M.textContent)==null?void 0:s.toLowerCase()}),T=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_14__/* .useSyncRefs */ .T)(l,f),g=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>o.selectOption(r));(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(()=>o.registerOption(r,A),[A,r]);let c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!d.__demoMode);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(()=>{if(!d.__demoMode)return;let O=(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_22__/* .disposables */ .k)();return O.requestAnimationFrame(()=>{c.current=!0}),O.dispose},[]),(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_6__/* .useIsoMorphicEffect */ .e)(()=>{if(d.comboboxState!==0||!i||!c.current||d.activationTrigger===0)return;let O=(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_22__/* .disposables */ .k)();return O.requestAnimationFrame(()=>{var S,u;(u=(S=f.current)==null?void 0:S.scrollIntoView)==null||u.call(S,{block:"nearest"})}),O.dispose},[f,i,d.comboboxState,d.activationTrigger,d.activeOptionIndex]);let x=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(O=>{if(a)return O.preventDefault();g(),d.mode===0&&o.closeCombobox(),(0,_utils_platform_js__WEBPACK_IMPORTED_MODULE_23__/* .isMobile */ .tq)()||requestAnimationFrame(()=>{var S;return(S=d.inputRef.current)==null?void 0:S.focus()})}),L=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(()=>{if(a)return o.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Nothing */ .T.Nothing);o.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,r)}),D=(0,_hooks_use_tracked_pointer_js__WEBPACK_IMPORTED_MODULE_24__/* .useTrackedPointer */ .g)(),B=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(O=>D.update(O)),k=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(O=>{D.wasMoved(O)&&(a||i||o.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,r,0))}),w=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_5__/* .useEvent */ .z)(O=>{D.wasMoved(O)&&(a||i&&(d.optionsPropsRef.current.hold||o.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Nothing */ .T.Nothing)))}),X=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({active:i,selected:E,disabled:a}),[i,E,a]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:{id:r,ref:T,role:"option",tabIndex:a===!0?void 0:-1,"aria-disabled":a===!0?!0:void 0,"aria-selected":E,disabled:void 0,onClick:x,onFocus:L,onPointerEnter:B,onMouseEnter:B,onPointerMove:k,onMouseMove:k,onPointerLeave:w,onMouseLeave:w},theirProps:n,slot:X,defaultTag:eo,name:"Combobox.Option"})}let to=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(je),no=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)($e),ro=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(Ke),ao=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(Qe),lo=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(ze),io=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(oo),Wo=Object.assign(to,{Input:ro,Button:no,Label:ao,Options:lo,Option:io});


/***/ }),

/***/ 39516:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ b; },
/* harmony export */   "f": function() { return /* binding */ M; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19946);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16723);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73781);
let d=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);function f(){let r=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(d);if(r===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,f),t}return r}function M(){let[r,t]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);return[r.length>0?r.join(" "):void 0,(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>function(e){let i=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(s=>(t(o=>[...o,s]),()=>t(o=>{let p=o.slice(),c=p.indexOf(s);return c!==-1&&p.splice(c,1),p}))),n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(d.Provider,{value:n},e.children)},[t])]}let S="p";function h(r,t){let a=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_2__/* .useId */ .M)(),{id:e=`headlessui-description-${a}`,...i}=r,n=f(),s=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(t);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_4__/* .useIsoMorphicEffect */ .e)(()=>n.register(e),[e,n.register]);let o={ref:s,...n.props,id:e};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_5__/* .render */ .sY)({ourProps:o,theirProps:i,slot:n.slot||{},defaultTag:S,name:n.name||"Description"})}let y=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_5__/* .forwardRefWithAs */ .yV)(h),b=Object.assign(y,{});


/***/ }),

/***/ 69737:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ _t; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(32984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(61363);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(64103);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(19946);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(82180);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/hidden.js
var internal_hidden = __webpack_require__(46045);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(84575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction = __webpack_require__(45662);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
var use_is_mounted = __webpack_require__(14879);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-owner.js
var use_owner = __webpack_require__(51074);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event-listener.js
var use_event_listener = __webpack_require__(14007);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/micro-task.js
var micro_task = __webpack_require__(81021);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-watch.js
var use_watch = __webpack_require__(96599);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(94192);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/document-ready.js
function t(n){function e(){document.readyState!=="loading"&&(n(),document.removeEventListener("DOMContentLoaded",e))}typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("DOMContentLoaded",e),e())}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-on-unmount.js
var use_on_unmount = __webpack_require__(61595);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js
function P(t){if(!t)return new Set;if(typeof t=="function")return new Set(t());let r=new Set;for(let e of t.current)e.current instanceof HTMLElement&&r.add(e.current);return r}let J="div";var h=(n=>(n[n.None=1]="None",n[n.InitialFocus=2]="InitialFocus",n[n.TabLock=4]="TabLock",n[n.FocusLock=8]="FocusLock",n[n.RestoreFocus=16]="RestoreFocus",n[n.All=30]="All",n))(h||{});function X(t,r){let e=(0,react.useRef)(null),o=(0,use_sync_refs/* useSyncRefs */.T)(e,r),{initialFocus:u,containers:i,features:n=30,...l}=t;(0,use_server_handoff_complete/* useServerHandoffComplete */.H)()||(n=1);let m=(0,use_owner/* useOwnerDocument */.i)(e);Y({ownerDocument:m},Boolean(n&16));let c=Z({ownerDocument:m,container:e,initialFocus:u},Boolean(n&2));$({ownerDocument:m,container:e,containers:i,previousActiveElement:c},Boolean(n&8));let v=(0,use_tab_direction/* useTabDirection */.l)(),y=(0,use_event/* useEvent */.z)(s=>{let T=e.current;if(!T)return;(B=>B())(()=>{(0,match/* match */.E)(v.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:()=>{(0,focus_management/* focusIn */.jA)(T,focus_management/* Focus.First */.TO.First,{skipElements:[s.relatedTarget]})},[use_tab_direction/* Direction.Backwards */.N.Backwards]:()=>{(0,focus_management/* focusIn */.jA)(T,focus_management/* Focus.Last */.TO.Last,{skipElements:[s.relatedTarget]})}})})}),_=(0,use_disposables/* useDisposables */.G)(),b=(0,react.useRef)(!1),j={ref:o,onKeyDown(s){s.key=="Tab"&&(b.current=!0,_.requestAnimationFrame(()=>{b.current=!1}))},onBlur(s){let T=P(i);e.current instanceof HTMLElement&&T.add(e.current);let d=s.relatedTarget;d instanceof HTMLElement&&d.dataset.headlessuiFocusGuard!=="true"&&(S(T,d)||(b.current?(0,focus_management/* focusIn */.jA)(e.current,(0,match/* match */.E)(v.current,{[use_tab_direction/* Direction.Forwards */.N.Forwards]:()=>focus_management/* Focus.Next */.TO.Next,[use_tab_direction/* Direction.Backwards */.N.Backwards]:()=>focus_management/* Focus.Previous */.TO.Previous})|focus_management/* Focus.WrapAround */.TO.WrapAround,{relativeTo:s.target}):s.target instanceof HTMLElement&&(0,focus_management/* focusElement */.C5)(s.target)))}};return react.createElement(react.Fragment,null,Boolean(n&4)&&react.createElement(internal_hidden/* Hidden */._,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:y,features:internal_hidden/* Features.Focusable */.A.Focusable}),(0,render/* render */.sY)({ourProps:j,theirProps:l,defaultTag:J,name:"FocusTrap"}),Boolean(n&4)&&react.createElement(internal_hidden/* Hidden */._,{as:"button",type:"button","data-headlessui-focus-guard":!0,onFocus:y,features:internal_hidden/* Features.Focusable */.A.Focusable}))}let z=(0,render/* forwardRefWithAs */.yV)(X),focus_trap_ge=Object.assign(z,{features:h}),a=[];t(()=>{function t(r){r.target instanceof HTMLElement&&r.target!==document.body&&a[0]!==r.target&&(a.unshift(r.target),a=a.filter(e=>e!=null&&e.isConnected),a.splice(10))}window.addEventListener("click",t,{capture:!0}),window.addEventListener("mousedown",t,{capture:!0}),window.addEventListener("focus",t,{capture:!0}),document.body.addEventListener("click",t,{capture:!0}),document.body.addEventListener("mousedown",t,{capture:!0}),document.body.addEventListener("focus",t,{capture:!0})});function Q(t=!0){let r=(0,react.useRef)(a.slice());return (0,use_watch/* useWatch */.q)(([e],[o])=>{o===!0&&e===!1&&(0,micro_task/* microTask */.Y)(()=>{r.current.splice(0)}),o===!1&&e===!0&&(r.current=a.slice())},[t,a,r]),(0,use_event/* useEvent */.z)(()=>{var e;return(e=r.current.find(o=>o!=null&&o.isConnected))!=null?e:null})}function Y({ownerDocument:t},r){let e=Q(r);(0,use_watch/* useWatch */.q)(()=>{r||(t==null?void 0:t.activeElement)===(t==null?void 0:t.body)&&(0,focus_management/* focusElement */.C5)(e())},[r]),(0,use_on_unmount/* useOnUnmount */.L)(()=>{r&&(0,focus_management/* focusElement */.C5)(e())})}function Z({ownerDocument:t,container:r,initialFocus:e},o){let u=(0,react.useRef)(null),i=(0,use_is_mounted/* useIsMounted */.t)();return (0,use_watch/* useWatch */.q)(()=>{if(!o)return;let n=r.current;n&&(0,micro_task/* microTask */.Y)(()=>{if(!i.current)return;let l=t==null?void 0:t.activeElement;if(e!=null&&e.current){if((e==null?void 0:e.current)===l){u.current=l;return}}else if(n.contains(l)){u.current=l;return}e!=null&&e.current?(0,focus_management/* focusElement */.C5)(e.current):(0,focus_management/* focusIn */.jA)(n,focus_management/* Focus.First */.TO.First)===focus_management/* FocusResult.Error */.fE.Error&&console.warn("There are no focusable elements inside the <FocusTrap />"),u.current=t==null?void 0:t.activeElement})},[o]),u}function $({ownerDocument:t,container:r,containers:e,previousActiveElement:o},u){let i=(0,use_is_mounted/* useIsMounted */.t)();(0,use_event_listener/* useEventListener */.O)(t==null?void 0:t.defaultView,"focus",n=>{if(!u||!i.current)return;let l=P(e);r.current instanceof HTMLElement&&l.add(r.current);let m=o.current;if(!m)return;let c=n.target;c&&c instanceof HTMLElement?S(l,c)?(o.current=c,(0,focus_management/* focusElement */.C5)(c)):(n.preventDefault(),n.stopPropagation(),(0,focus_management/* focusElement */.C5)(m)):(0,focus_management/* focusElement */.C5)(o.current)},!0)}function S(t,r){for(let e of t)if(e.contains(r))return!0;return!1}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/portal/portal.js
var portal = __webpack_require__(2740);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/portal-force-root.js
var portal_force_root = __webpack_require__(31438);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/description/description.js
var description = __webpack_require__(39516);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/internal/stack-context.js
let stack_context_a=(0,react.createContext)(()=>{});stack_context_a.displayName="StackContext";var stack_context_s=(e=>(e[e.Add=0]="Add",e[e.Remove=1]="Remove",e))(stack_context_s||{});function x(){return (0,react.useContext)(stack_context_a)}function stack_context_M({children:i,onUpdate:r,type:e,element:n,enabled:u}){let l=x(),o=(0,use_event/* useEvent */.z)((...t)=>{r==null||r(...t),l(...t)});return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{let t=u===void 0||u===!0;return t&&o(0,e,n),()=>{t&&o(1,e,n)}},[o,e,n,u]),react.createElement(stack_context_a.Provider,{value:o},i)}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js + 1 modules
var use_outside_click = __webpack_require__(39650);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimClient.js
function i(e,t){return e===t&&(e!==0||1/e===1/t)||e!==e&&t!==t}const d=typeof Object.is=="function"?Object.is:i,{useState:u,useEffect:useSyncExternalStoreShimClient_h,useLayoutEffect:f,useDebugValue:p}=react_namespaceObject;let useSyncExternalStoreShimClient_S=(/* unused pure expression or super */ null && (!1)),_=(/* unused pure expression or super */ null && (!1));function y(e,t,c){const a=t(),[{inst:n},o]=u({inst:{value:a,getSnapshot:t}});return f(()=>{n.value=a,n.getSnapshot=t,r(n)&&o({inst:n})},[e,a,t]),useSyncExternalStoreShimClient_h(()=>(r(n)&&o({inst:n}),e(()=>{r(n)&&o({inst:n})})),[e]),p(a),a}function r(e){const t=e.getSnapshot,c=e.value;try{const a=t();return!d(c,a)}catch{return!0}}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/use-sync-external-store-shim/useSyncExternalStoreShimServer.js
function useSyncExternalStoreShimServer_t(r,e,n){return e()}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/use-sync-external-store-shim/index.js
const use_sync_external_store_shim_r=typeof window!="undefined"&&typeof window.document!="undefined"&&typeof window.document.createElement!="undefined",s=!use_sync_external_store_shim_r,c=s?useSyncExternalStoreShimServer_t:y,use_sync_external_store_shim_a= true?(n=>n.useSyncExternalStore)(react_namespaceObject):c;

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-store.js
function use_store_S(t){return use_sync_external_store_shim_a(t.subscribe,t.getSnapshot,t.getSnapshot)}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js
var disposables = __webpack_require__(9362);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/store.js
function store_a(o,r){let t=o(),n=new Set;return{getSnapshot(){return t},subscribe(e){return n.add(e),()=>n.delete(e)},dispatch(e,...s){let i=r[e].call(t,...s);i&&(t=i,n.forEach(c=>c()))}}}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/document-overflow/adjust-scrollbar-padding.js
function adjust_scrollbar_padding_c(){let o;return{before({doc:e}){var l;let n=e.documentElement;o=((l=e.defaultView)!=null?l:window).innerWidth-n.clientWidth},after({doc:e,d:n}){let t=e.documentElement,l=t.clientWidth-t.offsetWidth,r=o-l;n.style(t,"paddingRight",`${r}px`)}}}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/platform.js
var platform = __webpack_require__(78657);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/document-overflow/handle-ios-locking.js
function handle_ios_locking_p(){if(!(0,platform/* isIOS */.gn)())return{};let o;return{before(){o=window.pageYOffset},after({doc:r,d:l,meta:s}){function i(e){return s.containers.flatMap(t=>t()).some(t=>t.contains(e))}l.style(r.body,"marginTop",`-${o}px`),window.scrollTo(0,0);let n=null;l.addEventListener(r,"click",e=>{if(e.target instanceof HTMLElement)try{let t=e.target.closest("a");if(!t)return;let{hash:c}=new URL(t.href),a=r.querySelector(c);a&&!i(a)&&(n=a)}catch{}},!0),l.addEventListener(r,"touchmove",e=>{e.target instanceof HTMLElement&&!i(e.target)&&e.preventDefault()},{passive:!1}),l.add(()=>{window.scrollTo(0,window.pageYOffset+o),n&&n.isConnected&&(n.scrollIntoView({block:"nearest"}),n=null)})}}}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/document-overflow/prevent-scroll.js
function l(){return{before({doc:e,d:o}){o.style(e.documentElement,"overflow","hidden")}}}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/document-overflow/overflow-store.js
function m(e){let n={};for(let t of e)Object.assign(n,t(n));return n}let overflow_store_a=store_a(()=>new Map,{PUSH(e,n){var o;let t=(o=this.get(e))!=null?o:{doc:e,count:0,d:(0,disposables/* disposables */.k)(),meta:new Set};return t.count++,t.meta.add(n),this.set(e,t),this},POP(e,n){let t=this.get(e);return t&&(t.count--,t.meta.delete(n)),this},SCROLL_PREVENT({doc:e,d:n,meta:t}){let o={doc:e,d:n,meta:m(t)},c=[handle_ios_locking_p(),adjust_scrollbar_padding_c(),l()];c.forEach(({before:r})=>r==null?void 0:r(o)),c.forEach(({after:r})=>r==null?void 0:r(o))},SCROLL_ALLOW({d:e}){e.dispose()},TEARDOWN({doc:e}){this.delete(e)}});overflow_store_a.subscribe(()=>{let e=overflow_store_a.getSnapshot(),n=new Map;for(let[t]of e)n.set(t,t.documentElement.style.overflow);for(let t of e.values()){let o=n.get(t.doc)==="hidden",c=t.count!==0;(c&&!o||!c&&o)&&overflow_store_a.dispatch(t.count>0?"SCROLL_PREVENT":"SCROLL_ALLOW",t),t.count===0&&overflow_store_a.dispatch("TEARDOWN",t)}});

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/document-overflow/use-document-overflow.js
function use_document_overflow_p(e,r,n){let f=use_store_S(overflow_store_a),o=e?f.get(e):void 0,i=o?o.count>0:!1;return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(!(!e||!r))return overflow_store_a.dispatch("PUSH",e,n),()=>overflow_store_a.dispatch("POP",e,n)},[r,e]),i}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-inert.js
let use_inert_u=new Map,use_inert_t=new Map;function use_inert_h(r,l=!0){(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{var o;if(!l)return;let e=typeof r=="function"?r():r.current;if(!e)return;function a(){var d;if(!e)return;let i=(d=use_inert_t.get(e))!=null?d:1;if(i===1?use_inert_t.delete(e):use_inert_t.set(e,i-1),i!==1)return;let n=use_inert_u.get(e);n&&(n["aria-hidden"]===null?e.removeAttribute("aria-hidden"):e.setAttribute("aria-hidden",n["aria-hidden"]),e.inert=n.inert,use_inert_u.delete(e))}let f=(o=use_inert_t.get(e))!=null?o:0;return use_inert_t.set(e,f+1),f!==0||(use_inert_u.set(e,{"aria-hidden":e.getAttribute("aria-hidden"),inert:e.inert}),e.setAttribute("aria-hidden","true"),e.inert=!0),a},[r,l])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-root-containers.js
var use_root_containers = __webpack_require__(65958);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js
var _e=(o=>(o[o.Open=0]="Open",o[o.Closed=1]="Closed",o))(_e||{}),Ie=(e=>(e[e.SetTitleId=0]="SetTitleId",e))(Ie||{});let Me={[0](t,e){return t.titleId===e.id?t:{...t,titleId:e.id}}},I=(0,react.createContext)(null);I.displayName="DialogContext";function b(t){let e=(0,react.useContext)(I);if(e===null){let o=new Error(`<${t} /> is missing a parent <Dialog /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(o,b),o}return e}function we(t,e,o=()=>[document.body]){use_document_overflow_p(t,e,i=>{var n;return{containers:[...(n=i.containers)!=null?n:[],o]}})}function Be(t,e){return (0,match/* match */.E)(e.type,Me,t,e)}let He="div",Ge=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static;function Ne(t,e){var X;let o=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-${o}`,open:n,onClose:l,initialFocus:s,__demoMode:g=!1,...T}=t,[m,h]=(0,react.useState)(0),a=(0,open_closed/* useOpenClosed */.oJ)();n===void 0&&a!==null&&(n=(a&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open);let D=(0,react.useRef)(null),Q=(0,use_sync_refs/* useSyncRefs */.T)(D,e),f=(0,use_owner/* useOwnerDocument */.i)(D),N=t.hasOwnProperty("open")||a!==null,U=t.hasOwnProperty("onClose");if(!N&&!U)throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");if(!N)throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");if(!U)throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");if(typeof n!="boolean")throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);if(typeof l!="function")throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);let p=n?0:1,[S,Z]=(0,react.useReducer)(Be,{titleId:null,descriptionId:null,panelRef:(0,react.createRef)()}),P=(0,use_event/* useEvent */.z)(()=>l(!1)),W=(0,use_event/* useEvent */.z)(r=>Z({type:0,id:r})),L=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)()?g?!1:p===0:!1,F=m>1,Y=(0,react.useContext)(I)!==null,[ee,te]=(0,portal/* useNestedPortals */.k)(),{resolveContainers:M,mainTreeNodeRef:k,MainTreeNode:oe}=(0,use_root_containers/* useRootContainers */.v)({portals:ee,defaultContainers:[(X=S.panelRef.current)!=null?X:D.current]}),re=F?"parent":"leaf",$=a!==null?(a&open_closed/* State.Closing */.ZM.Closing)===open_closed/* State.Closing */.ZM.Closing:!1,ne=(()=>Y||$?!1:L)(),le=(0,react.useCallback)(()=>{var r,c;return(c=Array.from((r=f==null?void 0:f.querySelectorAll("body > *"))!=null?r:[]).find(d=>d.id==="headlessui-portal-root"?!1:d.contains(k.current)&&d instanceof HTMLElement))!=null?c:null},[k]);use_inert_h(le,ne);let ae=(()=>F?!0:L)(),ie=(0,react.useCallback)(()=>{var r,c;return(c=Array.from((r=f==null?void 0:f.querySelectorAll("[data-headlessui-portal]"))!=null?r:[]).find(d=>d.contains(k.current)&&d instanceof HTMLElement))!=null?c:null},[k]);use_inert_h(ie,ae);let se=(()=>!(!L||F))();(0,use_outside_click/* useOutsideClick */.O)(M,P,se);let pe=(()=>!(F||p!==0))();(0,use_event_listener/* useEventListener */.O)(f==null?void 0:f.defaultView,"keydown",r=>{pe&&(r.defaultPrevented||r.key===keyboard/* Keys.Escape */.R.Escape&&(r.preventDefault(),r.stopPropagation(),P()))});let de=(()=>!($||p!==0||Y))();we(f,de,M),(0,react.useEffect)(()=>{if(p!==0||!D.current)return;let r=new ResizeObserver(c=>{for(let d of c){let x=d.target.getBoundingClientRect();x.x===0&&x.y===0&&x.width===0&&x.height===0&&P()}});return r.observe(D.current),()=>r.disconnect()},[p,D,P]);let[ue,fe]=(0,description/* useDescriptions */.f)(),ge=(0,react.useMemo)(()=>[{dialogState:p,close:P,setTitleId:W},S],[p,S,P,W]),J=(0,react.useMemo)(()=>({open:p===0}),[p]),Te={ref:Q,id:i,role:"dialog","aria-modal":p===0?!0:void 0,"aria-labelledby":S.titleId,"aria-describedby":ue};return react.createElement(stack_context_M,{type:"Dialog",enabled:p===0,element:D,onUpdate:(0,use_event/* useEvent */.z)((r,c)=>{c==="Dialog"&&(0,match/* match */.E)(r,{[stack_context_s.Add]:()=>h(d=>d+1),[stack_context_s.Remove]:()=>h(d=>d-1)})})},react.createElement(portal_force_root/* ForcePortalRoot */.O,{force:!0},react.createElement(portal/* Portal */.h,null,react.createElement(I.Provider,{value:ge},react.createElement(portal/* Portal.Group */.h.Group,{target:D},react.createElement(portal_force_root/* ForcePortalRoot */.O,{force:!1},react.createElement(fe,{slot:J,name:"Dialog.Description"},react.createElement(focus_trap_ge,{initialFocus:s,containers:M,features:L?(0,match/* match */.E)(re,{parent:focus_trap_ge.features.RestoreFocus,leaf:focus_trap_ge.features.All&~focus_trap_ge.features.FocusLock}):focus_trap_ge.features.None},react.createElement(te,null,(0,render/* render */.sY)({ourProps:Te,theirProps:T,slot:J,defaultTag:He,features:Ge,visible:p===0,name:"Dialog"}))))))))),react.createElement(oe,null))}let Ue="div";function We(t,e){let o=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-overlay-${o}`,...n}=t,[{dialogState:l,close:s}]=b("Dialog.Overlay"),g=(0,use_sync_refs/* useSyncRefs */.T)(e),T=(0,use_event/* useEvent */.z)(a=>{if(a.target===a.currentTarget){if((0,bugs/* isDisabledReactIssue7711 */.P)(a.currentTarget))return a.preventDefault();a.preventDefault(),a.stopPropagation(),s()}}),m=(0,react.useMemo)(()=>({open:l===0}),[l]);return (0,render/* render */.sY)({ourProps:{ref:g,id:i,"aria-hidden":!0,onClick:T},theirProps:n,slot:m,defaultTag:Ue,name:"Dialog.Overlay"})}let Ye="div";function $e(t,e){let o=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-backdrop-${o}`,...n}=t,[{dialogState:l},s]=b("Dialog.Backdrop"),g=(0,use_sync_refs/* useSyncRefs */.T)(e);(0,react.useEffect)(()=>{if(s.panelRef.current===null)throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.")},[s.panelRef]);let T=(0,react.useMemo)(()=>({open:l===0}),[l]);return react.createElement(portal_force_root/* ForcePortalRoot */.O,{force:!0},react.createElement(portal/* Portal */.h,null,(0,render/* render */.sY)({ourProps:{ref:g,id:i,"aria-hidden":!0},theirProps:n,slot:T,defaultTag:Ye,name:"Dialog.Backdrop"})))}let Je="div";function Xe(t,e){let o=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-panel-${o}`,...n}=t,[{dialogState:l},s]=b("Dialog.Panel"),g=(0,use_sync_refs/* useSyncRefs */.T)(e,s.panelRef),T=(0,react.useMemo)(()=>({open:l===0}),[l]),m=(0,use_event/* useEvent */.z)(a=>{a.stopPropagation()});return (0,render/* render */.sY)({ourProps:{ref:g,id:i,onClick:m},theirProps:n,slot:T,defaultTag:Je,name:"Dialog.Panel"})}let je="h2";function Ke(t,e){let o=(0,use_id/* useId */.M)(),{id:i=`headlessui-dialog-title-${o}`,...n}=t,[{dialogState:l,setTitleId:s}]=b("Dialog.Title"),g=(0,use_sync_refs/* useSyncRefs */.T)(e);(0,react.useEffect)(()=>(s(i),()=>s(null)),[i,s]);let T=(0,react.useMemo)(()=>({open:l===0}),[l]);return (0,render/* render */.sY)({ourProps:{ref:g,id:i},theirProps:n,slot:T,defaultTag:je,name:"Dialog.Title"})}let Ve=(0,render/* forwardRefWithAs */.yV)(Ne),qe=(0,render/* forwardRefWithAs */.yV)($e),ze=(0,render/* forwardRefWithAs */.yV)(Xe),Qe=(0,render/* forwardRefWithAs */.yV)(We),Ze=(0,render/* forwardRefWithAs */.yV)(Ke),_t=Object.assign(Ve,{Backdrop:qe,Panel:ze,Overlay:Qe,Title:Ze,Description:description/* Description */.d});


/***/ }),

/***/ 61363:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ o; }
/* harmony export */ });
var o=(r=>(r.Space=" ",r.Enter="Enter",r.Escape="Escape",r.Backspace="Backspace",r.Delete="Delete",r.ArrowLeft="ArrowLeft",r.ArrowUp="ArrowUp",r.ArrowRight="ArrowRight",r.ArrowDown="ArrowDown",r.Home="Home",r.End="End",r.PageUp="PageUp",r.PageDown="PageDown",r.Tab="Tab",r))(o||{});


/***/ }),

/***/ 64729:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ Nt; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94192);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19946);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16723);
/* harmony import */ var _hooks_use_computed_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71646);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23784);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12351);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32984);
/* harmony import */ var _utils_disposables_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9362);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61363);
/* harmony import */ var _utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11497);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64103);
/* harmony import */ var _utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84575);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14157);
/* harmony import */ var _hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39650);
/* harmony import */ var _internal_hidden_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46045);
/* harmony import */ var _utils_form_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18689);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73781);
/* harmony import */ var _hooks_use_controllable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31147);
/* harmony import */ var _hooks_use_latest_value_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(3855);
/* harmony import */ var _hooks_use_tracked_pointer_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(40476);
/* harmony import */ var _hooks_use_text_value_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(55918);
var Be=(n=>(n[n.Open=0]="Open",n[n.Closed=1]="Closed",n))(Be||{}),He=(n=>(n[n.Single=0]="Single",n[n.Multi=1]="Multi",n))(He||{}),Ge=(n=>(n[n.Pointer=0]="Pointer",n[n.Other=1]="Other",n))(Ge||{}),Ne=(i=>(i[i.OpenListbox=0]="OpenListbox",i[i.CloseListbox=1]="CloseListbox",i[i.GoToOption=2]="GoToOption",i[i.Search=3]="Search",i[i.ClearSearch=4]="ClearSearch",i[i.RegisterOption=5]="RegisterOption",i[i.UnregisterOption=6]="UnregisterOption",i[i.RegisterLabel=7]="RegisterLabel",i))(Ne||{});function z(e,a=n=>n){let n=e.activeOptionIndex!==null?e.options[e.activeOptionIndex]:null,r=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .sortByDomNode */ .z2)(a(e.options.slice()),t=>t.dataRef.current.domRef.current),l=n?r.indexOf(n):null;return l===-1&&(l=null),{options:r,activeOptionIndex:l}}let je={[1](e){return e.dataRef.current.disabled||e.listboxState===1?e:{...e,activeOptionIndex:null,listboxState:1}},[0](e){if(e.dataRef.current.disabled||e.listboxState===0)return e;let a=e.activeOptionIndex,{isSelected:n}=e.dataRef.current,r=e.options.findIndex(l=>n(l.dataRef.current.value));return r!==-1&&(a=r),{...e,listboxState:0,activeOptionIndex:a}},[2](e,a){var l;if(e.dataRef.current.disabled||e.listboxState===1)return e;let n=z(e),r=(0,_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .calculateActiveIndex */ .d)(a,{resolveItems:()=>n.options,resolveActiveIndex:()=>n.activeOptionIndex,resolveId:t=>t.id,resolveDisabled:t=>t.dataRef.current.disabled});return{...e,...n,searchQuery:"",activeOptionIndex:r,activationTrigger:(l=a.trigger)!=null?l:1}},[3]:(e,a)=>{if(e.dataRef.current.disabled||e.listboxState===1)return e;let r=e.searchQuery!==""?0:1,l=e.searchQuery+a.value.toLowerCase(),p=(e.activeOptionIndex!==null?e.options.slice(e.activeOptionIndex+r).concat(e.options.slice(0,e.activeOptionIndex+r)):e.options).find(i=>{var b;return!i.dataRef.current.disabled&&((b=i.dataRef.current.textValue)==null?void 0:b.startsWith(l))}),u=p?e.options.indexOf(p):-1;return u===-1||u===e.activeOptionIndex?{...e,searchQuery:l}:{...e,searchQuery:l,activeOptionIndex:u,activationTrigger:1}},[4](e){return e.dataRef.current.disabled||e.listboxState===1||e.searchQuery===""?e:{...e,searchQuery:""}},[5]:(e,a)=>{let n={id:a.id,dataRef:a.dataRef},r=z(e,l=>[...l,n]);return e.activeOptionIndex===null&&e.dataRef.current.isSelected(a.dataRef.current.value)&&(r.activeOptionIndex=r.options.indexOf(n)),{...e,...r}},[6]:(e,a)=>{let n=z(e,r=>{let l=r.findIndex(t=>t.id===a.id);return l!==-1&&r.splice(l,1),r});return{...e,...n,activationTrigger:1}},[7]:(e,a)=>({...e,labelId:a.id})},J=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);J.displayName="ListboxActionsContext";function U(e){let a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(J);if(a===null){let n=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,U),n}return a}let q=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);q.displayName="ListboxDataContext";function B(e){let a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(q);if(a===null){let n=new Error(`<${e} /> is missing a parent <Listbox /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(n,B),n}return a}function Ve(e,a){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(a.type,je,e,a)}let Ke=react__WEBPACK_IMPORTED_MODULE_0__.Fragment;function Qe(e,a){let{value:n,defaultValue:r,form:l,name:t,onChange:p,by:u=(s,c)=>s===c,disabled:i=!1,horizontal:b=!1,multiple:m=!1,...L}=e;const P=b?"horizontal":"vertical";let S=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(a),[g=m?[]:void 0,R]=(0,_hooks_use_controllable_js__WEBPACK_IMPORTED_MODULE_5__/* .useControllable */ .q)(n,p,r),[T,o]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Ve,{dataRef:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),listboxState:1,options:[],searchQuery:"",labelId:null,activeOptionIndex:null,activationTrigger:1}),x=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({static:!1,hold:!1}),E=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),H=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),X=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),C=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(typeof u=="string"?(s,c)=>{let O=u;return(s==null?void 0:s[O])===(c==null?void 0:c[O])}:u),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(s=>(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(d.mode,{[1]:()=>g.some(c=>C(c,s)),[0]:()=>C(g,s)}),[g]),d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({...T,value:g,disabled:i,mode:m?1:0,orientation:P,compare:C,isSelected:A,optionsPropsRef:x,labelRef:E,buttonRef:H,optionsRef:X}),[g,i,m,T]);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>{T.dataRef.current=d},[d]),(0,_hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_8__/* .useOutsideClick */ .O)([d.buttonRef,d.optionsRef],(s,c)=>{var O;o({type:1}),(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .isFocusableElement */ .sP)(c,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .FocusableMode.Loose */ .tJ.Loose)||(s.preventDefault(),(O=d.buttonRef.current)==null||O.focus())},d.listboxState===0);let G=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:d.listboxState===0,disabled:i,value:g}),[d,i,g]),ie=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>{let c=d.options.find(O=>O.id===s);c&&F(c.dataRef.current.value)}),re=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{if(d.activeOptionIndex!==null){let{dataRef:s,id:c}=d.options[d.activeOptionIndex];F(s.current.value),o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,id:c})}}),ae=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>o({type:0})),le=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>o({type:1})),se=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)((s,c,O)=>s===_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific?o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,id:c,trigger:O}):o({type:2,focus:s,trigger:O})),pe=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)((s,c)=>(o({type:5,id:s,dataRef:c}),()=>o({type:6,id:s}))),ue=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>(o({type:7,id:s}),()=>o({type:7,id:null}))),F=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(d.mode,{[0](){return R==null?void 0:R(s)},[1](){let c=d.value.slice(),O=c.findIndex(M=>C(M,s));return O===-1?c.push(s):c.splice(O,1),R==null?void 0:R(c)}})),de=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>o({type:3,value:s})),ce=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>o({type:4})),fe=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({onChange:F,registerOption:pe,registerLabel:ue,goToOption:se,closeListbox:le,openListbox:ae,selectActiveOption:re,selectOption:ie,search:de,clearSearch:ce}),[]),Te={ref:S},N=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),be=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_9__/* .useDisposables */ .G)();return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{N.current&&r!==void 0&&be.addEventListener(N.current,"reset",()=>{F(r)})},[N,F]),react__WEBPACK_IMPORTED_MODULE_0__.createElement(J.Provider,{value:fe},react__WEBPACK_IMPORTED_MODULE_0__.createElement(q.Provider,{value:d},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(d.listboxState,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Closed */ .ZM.Closed})},t!=null&&g!=null&&(0,_utils_form_js__WEBPACK_IMPORTED_MODULE_11__/* .objectToFormEntries */ .t)({[t]:g}).map(([s,c],O)=>react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_12__/* .Hidden */ ._,{features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_12__/* .Features.Hidden */ .A.Hidden,ref:O===0?M=>{var Y;N.current=(Y=M==null?void 0:M.closest("form"))!=null?Y:null}:void 0,...(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .compact */ .oA)({key:s,as:"input",type:"hidden",hidden:!0,readOnly:!0,form:l,name:s,value:c})})),(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .render */ .sY)({ourProps:Te,theirProps:L,slot:G,defaultTag:Ke,name:"Listbox"}))))}let We="button";function Xe(e,a){var R;let n=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_14__/* .useId */ .M)(),{id:r=`headlessui-listbox-button-${n}`,...l}=e,t=B("Listbox.Button"),p=U("Listbox.Button"),u=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(t.buttonRef,a),i=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_9__/* .useDisposables */ .G)(),b=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(T=>{switch(T.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Enter */ .R.Enter:case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.ArrowDown */ .R.ArrowDown:T.preventDefault(),p.openListbox(),i.nextFrame(()=>{t.value||p.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.First */ .T.First)});break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.ArrowUp */ .R.ArrowUp:T.preventDefault(),p.openListbox(),i.nextFrame(()=>{t.value||p.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last)});break}}),m=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(T=>{switch(T.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Space */ .R.Space:T.preventDefault();break}}),L=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(T=>{if((0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_16__/* .isDisabledReactIssue7711 */ .P)(T.currentTarget))return T.preventDefault();t.listboxState===0?(p.closeListbox(),i.nextFrame(()=>{var o;return(o=t.buttonRef.current)==null?void 0:o.focus({preventScroll:!0})})):(T.preventDefault(),p.openListbox())}),P=(0,_hooks_use_computed_js__WEBPACK_IMPORTED_MODULE_17__/* .useComputed */ .v)(()=>{if(t.labelId)return[t.labelId,r].join(" ")},[t.labelId,r]),S=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.listboxState===0,disabled:t.disabled,value:t.value}),[t]),g={ref:u,id:r,type:(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_18__/* .useResolveButtonType */ .f)(e,t.buttonRef),"aria-haspopup":"listbox","aria-controls":(R=t.optionsRef.current)==null?void 0:R.id,"aria-expanded":t.disabled?void 0:t.listboxState===0,"aria-labelledby":P,disabled:t.disabled,onKeyDown:b,onKeyUp:m,onClick:L};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .render */ .sY)({ourProps:g,theirProps:l,slot:S,defaultTag:We,name:"Listbox.Button"})}let $e="label";function ze(e,a){let n=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_14__/* .useId */ .M)(),{id:r=`headlessui-listbox-label-${n}`,...l}=e,t=B("Listbox.Label"),p=U("Listbox.Label"),u=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(t.labelRef,a);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>p.registerLabel(r),[r]);let i=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{var L;return(L=t.buttonRef.current)==null?void 0:L.focus({preventScroll:!0})}),b=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.listboxState===0,disabled:t.disabled}),[t]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .render */ .sY)({ourProps:{ref:u,id:r,onClick:i},theirProps:l,slot:b,defaultTag:$e,name:"Listbox.Label"})}let Je="ul",qe=_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .Features.Static */ .AN.Static;function Ye(e,a){var T;let n=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_14__/* .useId */ .M)(),{id:r=`headlessui-listbox-options-${n}`,...l}=e,t=B("Listbox.Options"),p=U("Listbox.Options"),u=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(t.optionsRef,a),i=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_9__/* .useDisposables */ .G)(),b=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_9__/* .useDisposables */ .G)(),m=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .useOpenClosed */ .oJ)(),L=(()=>m!==null?(m&_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open)===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open:t.listboxState===0)();(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{var x;let o=t.optionsRef.current;o&&t.listboxState===0&&o!==((x=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_19__/* .getOwnerDocument */ .r)(o))==null?void 0:x.activeElement)&&o.focus({preventScroll:!0})},[t.listboxState,t.optionsRef]);let P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(o=>{switch(b.dispose(),o.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Space */ .R.Space:if(t.searchQuery!=="")return o.preventDefault(),o.stopPropagation(),p.search(o.key);case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Enter */ .R.Enter:if(o.preventDefault(),o.stopPropagation(),t.activeOptionIndex!==null){let{dataRef:x}=t.options[t.activeOptionIndex];p.onChange(x.current.value)}t.mode===0&&(p.closeListbox(),(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_20__/* .disposables */ .k)().nextFrame(()=>{var x;return(x=t.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})}));break;case (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(t.orientation,{vertical:_keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.ArrowDown */ .R.ArrowDown,horizontal:_keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.ArrowRight */ .R.ArrowRight}):return o.preventDefault(),o.stopPropagation(),p.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Next */ .T.Next);case (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(t.orientation,{vertical:_keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.ArrowUp */ .R.ArrowUp,horizontal:_keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.ArrowLeft */ .R.ArrowLeft}):return o.preventDefault(),o.stopPropagation(),p.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Previous */ .T.Previous);case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Home */ .R.Home:case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.PageUp */ .R.PageUp:return o.preventDefault(),o.stopPropagation(),p.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.First */ .T.First);case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.End */ .R.End:case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.PageDown */ .R.PageDown:return o.preventDefault(),o.stopPropagation(),p.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last);case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Escape */ .R.Escape:return o.preventDefault(),o.stopPropagation(),p.closeListbox(),i.nextFrame(()=>{var x;return(x=t.buttonRef.current)==null?void 0:x.focus({preventScroll:!0})});case _keyboard_js__WEBPACK_IMPORTED_MODULE_15__/* .Keys.Tab */ .R.Tab:o.preventDefault(),o.stopPropagation();break;default:o.key.length===1&&(p.search(o.key),b.setTimeout(()=>p.clearSearch(),350));break}}),S=(0,_hooks_use_computed_js__WEBPACK_IMPORTED_MODULE_17__/* .useComputed */ .v)(()=>{var o,x,E;return(E=(o=t.labelRef.current)==null?void 0:o.id)!=null?E:(x=t.buttonRef.current)==null?void 0:x.id},[t.labelRef.current,t.buttonRef.current]),g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.listboxState===0}),[t]),R={"aria-activedescendant":t.activeOptionIndex===null||(T=t.options[t.activeOptionIndex])==null?void 0:T.id,"aria-multiselectable":t.mode===1?!0:void 0,"aria-labelledby":S,"aria-orientation":t.orientation,id:r,onKeyDown:P,role:"listbox",tabIndex:0,ref:u};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .render */ .sY)({ourProps:R,theirProps:l,slot:g,defaultTag:Je,features:qe,visible:L,name:"Listbox.Options"})}let Ze="li";function et(e,a){let n=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_14__/* .useId */ .M)(),{id:r=`headlessui-listbox-option-${n}`,disabled:l=!1,value:t,...p}=e,u=B("Listbox.Option"),i=U("Listbox.Option"),b=u.activeOptionIndex!==null?u.options[u.activeOptionIndex].id===r:!1,m=u.isSelected(t),L=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),P=(0,_hooks_use_text_value_js__WEBPACK_IMPORTED_MODULE_21__/* .useTextValue */ .x)(L),S=(0,_hooks_use_latest_value_js__WEBPACK_IMPORTED_MODULE_22__/* .useLatestValue */ .E)({disabled:l,value:t,domRef:L,get textValue(){return P()}}),g=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(a,L);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>{if(u.listboxState!==0||!b||u.activationTrigger===0)return;let A=(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_20__/* .disposables */ .k)();return A.requestAnimationFrame(()=>{var d,G;(G=(d=L.current)==null?void 0:d.scrollIntoView)==null||G.call(d,{block:"nearest"})}),A.dispose},[L,b,u.listboxState,u.activationTrigger,u.activeOptionIndex]),(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>i.registerOption(r,S),[S,r]);let R=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(A=>{if(l)return A.preventDefault();i.onChange(t),u.mode===0&&(i.closeListbox(),(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_20__/* .disposables */ .k)().nextFrame(()=>{var d;return(d=u.buttonRef.current)==null?void 0:d.focus({preventScroll:!0})}))}),T=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{if(l)return i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Nothing */ .T.Nothing);i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,r)}),o=(0,_hooks_use_tracked_pointer_js__WEBPACK_IMPORTED_MODULE_23__/* .useTrackedPointer */ .g)(),x=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(A=>o.update(A)),E=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(A=>{o.wasMoved(A)&&(l||b||i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,r,0))}),H=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(A=>{o.wasMoved(A)&&(l||b&&i.goToOption(_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Nothing */ .T.Nothing))}),X=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({active:b,selected:m,disabled:l}),[b,m,l]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .render */ .sY)({ourProps:{id:r,ref:g,role:"option",tabIndex:l===!0?void 0:-1,"aria-disabled":l===!0?!0:void 0,"aria-selected":m,disabled:void 0,onClick:R,onFocus:T,onPointerEnter:x,onMouseEnter:x,onPointerMove:E,onMouseMove:E,onPointerLeave:H,onMouseLeave:H},theirProps:p,slot:X,defaultTag:Ze,name:"Listbox.Option"})}let tt=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .forwardRefWithAs */ .yV)(Qe),ot=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .forwardRefWithAs */ .yV)(Xe),nt=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .forwardRefWithAs */ .yV)(ze),it=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .forwardRefWithAs */ .yV)(Ye),rt=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_13__/* .forwardRefWithAs */ .yV)(et),Nt=Object.assign(tt,{Button:ot,Label:nt,Options:it,Option:rt});


/***/ }),

/***/ 72510:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ it; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12351);
/* harmony import */ var _utils_disposables_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9362);
/* harmony import */ var _hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94192);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16723);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61363);
/* harmony import */ var _utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11497);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64103);
/* harmony import */ var _utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84575);
/* harmony import */ var _hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39650);
/* harmony import */ var _hooks_use_tree_walker_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31591);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14157);
/* harmony import */ var _hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51074);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73781);
/* harmony import */ var _hooks_use_tracked_pointer_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(40476);
/* harmony import */ var _hooks_use_text_value_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(55918);
var me=(r=>(r[r.Open=0]="Open",r[r.Closed=1]="Closed",r))(me||{}),de=(r=>(r[r.Pointer=0]="Pointer",r[r.Other=1]="Other",r))(de||{}),fe=(a=>(a[a.OpenMenu=0]="OpenMenu",a[a.CloseMenu=1]="CloseMenu",a[a.GoToItem=2]="GoToItem",a[a.Search=3]="Search",a[a.ClearSearch=4]="ClearSearch",a[a.RegisterItem=5]="RegisterItem",a[a.UnregisterItem=6]="UnregisterItem",a))(fe||{});function w(e,u=r=>r){let r=e.activeItemIndex!==null?e.items[e.activeItemIndex]:null,i=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .sortByDomNode */ .z2)(u(e.items.slice()),t=>t.dataRef.current.domRef.current),s=r?i.indexOf(r):null;return s===-1&&(s=null),{items:i,activeItemIndex:s}}let Te={[1](e){return e.menuState===1?e:{...e,activeItemIndex:null,menuState:1}},[0](e){return e.menuState===0?e:{...e,__demoMode:!1,menuState:0}},[2]:(e,u)=>{var s;let r=w(e),i=(0,_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .calculateActiveIndex */ .d)(u,{resolveItems:()=>r.items,resolveActiveIndex:()=>r.activeItemIndex,resolveId:t=>t.id,resolveDisabled:t=>t.dataRef.current.disabled});return{...e,...r,searchQuery:"",activeItemIndex:i,activationTrigger:(s=u.trigger)!=null?s:1}},[3]:(e,u)=>{let i=e.searchQuery!==""?0:1,s=e.searchQuery+u.value.toLowerCase(),o=(e.activeItemIndex!==null?e.items.slice(e.activeItemIndex+i).concat(e.items.slice(0,e.activeItemIndex+i)):e.items).find(l=>{var m;return((m=l.dataRef.current.textValue)==null?void 0:m.startsWith(s))&&!l.dataRef.current.disabled}),a=o?e.items.indexOf(o):-1;return a===-1||a===e.activeItemIndex?{...e,searchQuery:s}:{...e,searchQuery:s,activeItemIndex:a,activationTrigger:1}},[4](e){return e.searchQuery===""?e:{...e,searchQuery:"",searchActiveItemIndex:null}},[5]:(e,u)=>{let r=w(e,i=>[...i,{id:u.id,dataRef:u.dataRef}]);return{...e,...r}},[6]:(e,u)=>{let r=w(e,i=>{let s=i.findIndex(t=>t.id===u.id);return s!==-1&&i.splice(s,1),i});return{...e,...r,activationTrigger:1}}},U=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);U.displayName="MenuContext";function O(e){let u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(U);if(u===null){let r=new Error(`<${e} /> is missing a parent <Menu /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(r,O),r}return u}function ye(e,u){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(u.type,Te,e,u)}let Ie=react__WEBPACK_IMPORTED_MODULE_0__.Fragment;function Me(e,u){let{__demoMode:r=!1,...i}=e,s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(ye,{__demoMode:r,menuState:r?0:1,buttonRef:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),itemsRef:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),items:[],searchQuery:"",activeItemIndex:null,activationTrigger:1}),[{menuState:t,itemsRef:o,buttonRef:a},l]=s,m=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(u);(0,_hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_5__/* .useOutsideClick */ .O)([a,o],(g,R)=>{var p;l({type:1}),(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .isFocusableElement */ .sP)(R,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .FocusableMode.Loose */ .tJ.Loose)||(g.preventDefault(),(p=a.current)==null||p.focus())},t===0);let I=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{l({type:1})}),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t===0,close:I}),[t,I]),f={ref:m};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(U.Provider,{value:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_3__/* .match */ .E)(t,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .render */ .sY)({ourProps:f,theirProps:i,slot:A,defaultTag:Ie,name:"Menu"})))}let ge="button";function Re(e,u){var R;let r=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_9__/* .useId */ .M)(),{id:i=`headlessui-menu-button-${r}`,...s}=e,[t,o]=O("Menu.Button"),a=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(t.buttonRef,u),l=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_10__/* .useDisposables */ .G)(),m=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(p=>{switch(p.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Enter */ .R.Enter:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.ArrowDown */ .R.ArrowDown:p.preventDefault(),p.stopPropagation(),o({type:0}),l.nextFrame(()=>o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.First */ .T.First}));break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.ArrowUp */ .R.ArrowUp:p.preventDefault(),p.stopPropagation(),o({type:0}),l.nextFrame(()=>o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last}));break}}),I=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(p=>{switch(p.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:p.preventDefault();break}}),A=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(p=>{if((0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__/* .isDisabledReactIssue7711 */ .P)(p.currentTarget))return p.preventDefault();e.disabled||(t.menuState===0?(o({type:1}),l.nextFrame(()=>{var M;return(M=t.buttonRef.current)==null?void 0:M.focus({preventScroll:!0})})):(p.preventDefault(),o({type:0})))}),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.menuState===0}),[t]),g={ref:a,id:i,type:(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_13__/* .useResolveButtonType */ .f)(e,t.buttonRef),"aria-haspopup":"menu","aria-controls":(R=t.itemsRef.current)==null?void 0:R.id,"aria-expanded":e.disabled?void 0:t.menuState===0,onKeyDown:m,onKeyUp:I,onClick:A};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .render */ .sY)({ourProps:g,theirProps:s,slot:f,defaultTag:ge,name:"Menu.Button"})}let Ae="div",be=_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .Features.Static */ .AN.Static;function Ee(e,u){var M,b;let r=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_9__/* .useId */ .M)(),{id:i=`headlessui-menu-items-${r}`,...s}=e,[t,o]=O("Menu.Items"),a=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(t.itemsRef,u),l=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_14__/* .useOwnerDocument */ .i)(t.itemsRef),m=(0,_hooks_use_disposables_js__WEBPACK_IMPORTED_MODULE_10__/* .useDisposables */ .G)(),I=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .useOpenClosed */ .oJ)(),A=(()=>I!==null?(I&_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .State.Open */ .ZM.Open)===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_7__/* .State.Open */ .ZM.Open:t.menuState===0)();(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{let n=t.itemsRef.current;n&&t.menuState===0&&n!==(l==null?void 0:l.activeElement)&&n.focus({preventScroll:!0})},[t.menuState,t.itemsRef,l]),(0,_hooks_use_tree_walker_js__WEBPACK_IMPORTED_MODULE_15__/* .useTreeWalker */ .B)({container:t.itemsRef.current,enabled:t.menuState===0,accept(n){return n.getAttribute("role")==="menuitem"?NodeFilter.FILTER_REJECT:n.hasAttribute("role")?NodeFilter.FILTER_SKIP:NodeFilter.FILTER_ACCEPT},walk(n){n.setAttribute("role","none")}});let f=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(n=>{var E,P;switch(m.dispose(),n.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:if(t.searchQuery!=="")return n.preventDefault(),n.stopPropagation(),o({type:3,value:n.key});case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Enter */ .R.Enter:if(n.preventDefault(),n.stopPropagation(),o({type:1}),t.activeItemIndex!==null){let{dataRef:S}=t.items[t.activeItemIndex];(P=(E=S.current)==null?void 0:E.domRef.current)==null||P.click()}(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .restoreFocusIfNecessary */ .wI)(t.buttonRef.current);break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.ArrowDown */ .R.ArrowDown:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Next */ .T.Next});case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.ArrowUp */ .R.ArrowUp:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Previous */ .T.Previous});case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Home */ .R.Home:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.PageUp */ .R.PageUp:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.First */ .T.First});case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.End */ .R.End:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.PageDown */ .R.PageDown:return n.preventDefault(),n.stopPropagation(),o({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Last */ .T.Last});case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Escape */ .R.Escape:n.preventDefault(),n.stopPropagation(),o({type:1}),(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_16__/* .disposables */ .k)().nextFrame(()=>{var S;return(S=t.buttonRef.current)==null?void 0:S.focus({preventScroll:!0})});break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Tab */ .R.Tab:n.preventDefault(),n.stopPropagation(),o({type:1}),(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_16__/* .disposables */ .k)().nextFrame(()=>{(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .focusFrom */ .EO)(t.buttonRef.current,n.shiftKey?_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .Focus.Previous */ .TO.Previous:_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .Focus.Next */ .TO.Next)});break;default:n.key.length===1&&(o({type:3,value:n.key}),m.setTimeout(()=>o({type:4}),350));break}}),g=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(n=>{switch(n.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:n.preventDefault();break}}),R=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.menuState===0}),[t]),p={"aria-activedescendant":t.activeItemIndex===null||(M=t.items[t.activeItemIndex])==null?void 0:M.id,"aria-labelledby":(b=t.buttonRef.current)==null?void 0:b.id,id:i,onKeyDown:f,onKeyUp:g,role:"menu",tabIndex:0,ref:a};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .render */ .sY)({ourProps:p,theirProps:s,slot:R,defaultTag:Ae,features:be,visible:A,name:"Menu.Items"})}let Se=react__WEBPACK_IMPORTED_MODULE_0__.Fragment;function Pe(e,u){let r=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_9__/* .useId */ .M)(),{id:i=`headlessui-menu-item-${r}`,disabled:s=!1,...t}=e,[o,a]=O("Menu.Item"),l=o.activeItemIndex!==null?o.items[o.activeItemIndex].id===i:!1,m=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),I=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(u,m);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_17__/* .useIsoMorphicEffect */ .e)(()=>{if(o.__demoMode||o.menuState!==0||!l||o.activationTrigger===0)return;let T=(0,_utils_disposables_js__WEBPACK_IMPORTED_MODULE_16__/* .disposables */ .k)();return T.requestAnimationFrame(()=>{var v,B;(B=(v=m.current)==null?void 0:v.scrollIntoView)==null||B.call(v,{block:"nearest"})}),T.dispose},[o.__demoMode,m,l,o.menuState,o.activationTrigger,o.activeItemIndex]);let A=(0,_hooks_use_text_value_js__WEBPACK_IMPORTED_MODULE_18__/* .useTextValue */ .x)(m),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({disabled:s,domRef:m,get textValue(){return A()}});(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_17__/* .useIsoMorphicEffect */ .e)(()=>{f.current.disabled=s},[f,s]),(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_17__/* .useIsoMorphicEffect */ .e)(()=>(a({type:5,id:i,dataRef:f}),()=>a({type:6,id:i})),[f,i]);let g=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{a({type:1})}),R=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(T=>{if(s)return T.preventDefault();a({type:1}),(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_1__/* .restoreFocusIfNecessary */ .wI)(o.buttonRef.current)}),p=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{if(s)return a({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Nothing */ .T.Nothing});a({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,id:i})}),M=(0,_hooks_use_tracked_pointer_js__WEBPACK_IMPORTED_MODULE_19__/* .useTrackedPointer */ .g)(),b=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(T=>M.update(T)),n=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(T=>{M.wasMoved(T)&&(s||l||a({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Specific */ .T.Specific,id:i,trigger:0}))}),E=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(T=>{M.wasMoved(T)&&(s||l&&a({type:2,focus:_utils_calculate_active_index_js__WEBPACK_IMPORTED_MODULE_2__/* .Focus.Nothing */ .T.Nothing}))}),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({active:l,disabled:s,close:g}),[l,s,g]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .render */ .sY)({ourProps:{id:i,ref:I,role:"menuitem",tabIndex:s===!0?void 0:-1,"aria-disabled":s===!0?!0:void 0,disabled:void 0,onClick:R,onFocus:p,onPointerEnter:b,onMouseEnter:b,onPointerMove:n,onMouseMove:n,onPointerLeave:E,onMouseLeave:E},theirProps:t,slot:P,defaultTag:Se,name:"Menu.Item"})}let ve=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .forwardRefWithAs */ .yV)(Me),xe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .forwardRefWithAs */ .yV)(Re),he=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .forwardRefWithAs */ .yV)(Ee),De=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_8__/* .forwardRefWithAs */ .yV)(Pe),it=Object.assign(ve,{Button:xe,Items:he,Item:De});


/***/ }),

/***/ 86215:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ kt; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64103);
/* harmony import */ var _utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84575);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14157);
/* harmony import */ var _hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39650);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51074);
/* harmony import */ var _hooks_use_event_listener_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14007);
/* harmony import */ var _internal_hidden_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(46045);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73781);
/* harmony import */ var _hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45662);
/* harmony import */ var _hooks_use_latest_value_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3855);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16723);
/* harmony import */ var _hooks_use_root_containers_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65958);
/* harmony import */ var _components_portal_portal_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2740);
var De=(u=>(u[u.Open=0]="Open",u[u.Closed=1]="Closed",u))(De||{}),he=(e=>(e[e.TogglePopover=0]="TogglePopover",e[e.ClosePopover=1]="ClosePopover",e[e.SetButton=2]="SetButton",e[e.SetButtonId=3]="SetButtonId",e[e.SetPanel=4]="SetPanel",e[e.SetPanelId=5]="SetPanelId",e))(he||{});let He={[0]:t=>{let o={...t,popoverState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(t.popoverState,{[0]:1,[1]:0})};return o.popoverState===0&&(o.__demoMode=!1),o},[1](t){return t.popoverState===1?t:{...t,popoverState:1}},[2](t,o){return t.button===o.button?t:{...t,button:o.button}},[3](t,o){return t.buttonId===o.buttonId?t:{...t,buttonId:o.buttonId}},[4](t,o){return t.panel===o.panel?t:{...t,panel:o.panel}},[5](t,o){return t.panelId===o.panelId?t:{...t,panelId:o.panelId}}},ue=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);ue.displayName="PopoverContext";function oe(t){let o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ue);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,oe),u}return o}let ie=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);ie.displayName="PopoverAPIContext";function fe(t){let o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ie);if(o===null){let u=new Error(`<${t} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(u,fe),u}return o}let Pe=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);Pe.displayName="PopoverGroupContext";function Ee(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Pe)}let re=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);re.displayName="PopoverPanelContext";function _e(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(re)}function Ge(t,o){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(o.type,He,t,o)}let ke="div";function we(t,o){var I;let{__demoMode:u=!1,...A}=t,O=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),n=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__/* .useSyncRefs */ .T)(o,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__/* .optionalRef */ .h)(l=>{O.current=l})),e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]),T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Ge,{__demoMode:u,popoverState:u?0:1,buttons:e,button:null,buttonId:null,panel:null,panelId:null,beforePanelSentinel:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),afterPanelSentinel:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)()}),[{popoverState:P,button:p,buttonId:F,panel:a,panelId:m,beforePanelSentinel:y,afterPanelSentinel:s},i]=T,d=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__/* .useOwnerDocument */ .i)((I=O.current)!=null?I:p),g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!p||!a)return!1;for(let K of document.querySelectorAll("body > *"))if(Number(K==null?void 0:K.contains(p))^Number(K==null?void 0:K.contains(a)))return!0;let l=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .getFocusableElements */ .GO)(),R=l.indexOf(p),q=(R+l.length-1)%l.length,W=(R+1)%l.length,z=l[q],ge=l[W];return!a.contains(z)&&!a.contains(ge)},[p,a]),L=(0,_hooks_use_latest_value_js__WEBPACK_IMPORTED_MODULE_5__/* .useLatestValue */ .E)(F),h=(0,_hooks_use_latest_value_js__WEBPACK_IMPORTED_MODULE_5__/* .useLatestValue */ .E)(m),_=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({buttonId:L,panelId:h,close:()=>i({type:1})}),[L,h,i]),B=Ee(),D=B==null?void 0:B.registerPopover,f=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{var l;return(l=B==null?void 0:B.isFocusWithinPopoverGroup())!=null?l:(d==null?void 0:d.activeElement)&&((p==null?void 0:p.contains(d.activeElement))||(a==null?void 0:a.contains(d.activeElement)))});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>D==null?void 0:D(_),[D,_]);let[E,b]=(0,_components_portal_portal_js__WEBPACK_IMPORTED_MODULE_7__/* .useNestedPortals */ .k)(),c=(0,_hooks_use_root_containers_js__WEBPACK_IMPORTED_MODULE_8__/* .useRootContainers */ .v)({portals:E,defaultContainers:[p,a]});(0,_hooks_use_event_listener_js__WEBPACK_IMPORTED_MODULE_9__/* .useEventListener */ .O)(d==null?void 0:d.defaultView,"focus",l=>{var R,q,W,z;l.target!==window&&l.target instanceof HTMLElement&&P===0&&(f()||p&&a&&(c.contains(l.target)||(q=(R=y.current)==null?void 0:R.contains)!=null&&q.call(R,l.target)||(z=(W=s.current)==null?void 0:W.contains)!=null&&z.call(W,l.target)||i({type:1})))},!0),(0,_hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_10__/* .useOutsideClick */ .O)(c.resolveContainers,(l,R)=>{i({type:1}),(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .isFocusableElement */ .sP)(R,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .FocusableMode.Loose */ .tJ.Loose)||(l.preventDefault(),p==null||p.focus())},P===0);let M=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(l=>{i({type:1});let R=(()=>l?l instanceof HTMLElement?l:"current"in l&&l.current instanceof HTMLElement?l.current:p:p)();R==null||R.focus()}),r=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:M,isPortalled:g}),[M,g]),v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:P===0,close:M}),[P,M]),x={ref:n};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(re.Provider,{value:null},react__WEBPACK_IMPORTED_MODULE_0__.createElement(ue.Provider,{value:T},react__WEBPACK_IMPORTED_MODULE_0__.createElement(ie.Provider,{value:r},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(P,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .State.Closed */ .ZM.Closed})},react__WEBPACK_IMPORTED_MODULE_0__.createElement(b,null,(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:x,theirProps:A,slot:v,defaultTag:ke,name:"Popover"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement(c.MainTreeNode,null))))))}let Ne="button";function Ue(t,o){let u=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:A=`headlessui-popover-button-${u}`,...O}=t,[n,e]=oe("Popover.Button"),{isPortalled:T}=fe("Popover.Button"),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),p=`headlessui-focus-sentinel-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)()}`,F=Ee(),a=F==null?void 0:F.closeOthers,y=_e()!==null;(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!y)return e({type:3,buttonId:A}),()=>{e({type:3,buttonId:null})}},[y,A,e]);let[s]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>Symbol()),i=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__/* .useSyncRefs */ .T)(P,o,y?null:r=>{if(r)n.buttons.current.push(s);else{let v=n.buttons.current.indexOf(s);v!==-1&&n.buttons.current.splice(v,1)}n.buttons.current.length>1&&console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."),r&&e({type:2,button:r})}),d=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__/* .useSyncRefs */ .T)(P,o),g=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__/* .useOwnerDocument */ .i)(P),L=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(r=>{var v,x,I;if(y){if(n.popoverState===1)return;switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_14__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_14__/* .Keys.Enter */ .R.Enter:r.preventDefault(),(x=(v=r.target).click)==null||x.call(v),e({type:1}),(I=n.button)==null||I.focus();break}}else switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_14__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_14__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),n.popoverState===1&&(a==null||a(n.buttonId)),e({type:0});break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_14__/* .Keys.Escape */ .R.Escape:if(n.popoverState!==0)return a==null?void 0:a(n.buttonId);if(!P.current||g!=null&&g.activeElement&&!P.current.contains(g.activeElement))return;r.preventDefault(),r.stopPropagation(),e({type:1});break}}),h=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(r=>{y||r.key===_keyboard_js__WEBPACK_IMPORTED_MODULE_14__/* .Keys.Space */ .R.Space&&r.preventDefault()}),_=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(r=>{var v,x;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_15__/* .isDisabledReactIssue7711 */ .P)(r.currentTarget)||t.disabled||(y?(e({type:1}),(v=n.button)==null||v.focus()):(r.preventDefault(),r.stopPropagation(),n.popoverState===1&&(a==null||a(n.buttonId)),e({type:0}),(x=n.button)==null||x.focus()))}),B=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(r=>{r.preventDefault(),r.stopPropagation()}),D=n.popoverState===0,f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:D}),[D]),E=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_16__/* .useResolveButtonType */ .f)(t,P),b=y?{ref:d,type:E,onKeyDown:L,onClick:_}:{ref:i,id:n.buttonId,type:E,"aria-expanded":t.disabled?void 0:n.popoverState===0,"aria-controls":n.panel?n.panelId:void 0,onKeyDown:L,onKeyUp:h,onClick:_,onMouseDown:B},c=(0,_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .useTabDirection */ .l)(),M=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{let r=n.panel;if(!r)return;function v(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(c.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Forwards */ .N.Forwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .focusIn */ .jA)(r,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.First */ .TO.First),[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Backwards */ .N.Backwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .focusIn */ .jA)(r,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.Last */ .TO.Last)})===_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .FocusResult.Error */ .fE.Error&&(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .focusIn */ .jA)((0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .getFocusableElements */ .GO)().filter(I=>I.dataset.headlessuiFocusGuard!=="true"),(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(c.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Forwards */ .N.Forwards]:_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.Next */ .TO.Next,[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Backwards */ .N.Backwards]:_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.Previous */ .TO.Previous}),{relativeTo:n.button})}v()});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:b,theirProps:O,slot:f,defaultTag:Ne,name:"Popover.Button"}),D&&!y&&T&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_18__/* .Hidden */ ._,{id:p,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_18__/* .Features.Focusable */ .A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:M}))}let We="div",Ke=_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .Features.Static */ .AN.Static;function je(t,o){let u=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:A=`headlessui-popover-overlay-${u}`,...O}=t,[{popoverState:n},e]=oe("Popover.Overlay"),T=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__/* .useSyncRefs */ .T)(o),P=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .useOpenClosed */ .oJ)(),p=(()=>P!==null?(P&_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .State.Open */ .ZM.Open)===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .State.Open */ .ZM.Open:n===0)(),F=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(y=>{if((0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_15__/* .isDisabledReactIssue7711 */ .P)(y.currentTarget))return y.preventDefault();e({type:1})}),a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:n===0}),[n]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:{ref:T,id:A,"aria-hidden":!0,onClick:F},theirProps:O,slot:a,defaultTag:We,features:Ke,visible:p,name:"Popover.Overlay"})}let Ve="div",$e=_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .Features.Static */ .AN.Static;function Je(t,o){let u=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)(),{id:A=`headlessui-popover-panel-${u}`,focus:O=!1,...n}=t,[e,T]=oe("Popover.Panel"),{close:P,isPortalled:p}=fe("Popover.Panel"),F=`headlessui-focus-sentinel-before-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)()}`,a=`headlessui-focus-sentinel-after-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_13__/* .useId */ .M)()}`,m=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),y=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__/* .useSyncRefs */ .T)(m,o,f=>{T({type:4,panel:f})}),s=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__/* .useOwnerDocument */ .i)(m);(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_19__/* .useIsoMorphicEffect */ .e)(()=>(T({type:5,panelId:A}),()=>{T({type:5,panelId:null})}),[A,T]);let i=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .useOpenClosed */ .oJ)(),d=(()=>i!==null?(i&_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .State.Open */ .ZM.Open)===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_11__/* .State.Open */ .ZM.Open:e.popoverState===0)(),g=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(f=>{var E;switch(f.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_14__/* .Keys.Escape */ .R.Escape:if(e.popoverState!==0||!m.current||s!=null&&s.activeElement&&!m.current.contains(s.activeElement))return;f.preventDefault(),f.stopPropagation(),T({type:1}),(E=e.button)==null||E.focus();break}});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{var f;t.static||e.popoverState===1&&((f=t.unmount)==null||f)&&T({type:4,panel:null})},[e.popoverState,t.unmount,t.static,T]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(e.__demoMode||!O||e.popoverState!==0||!m.current)return;let f=s==null?void 0:s.activeElement;m.current.contains(f)||(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .focusIn */ .jA)(m.current,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.First */ .TO.First)},[e.__demoMode,O,m,e.popoverState]);let L=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:e.popoverState===0,close:P}),[e,P]),h={ref:y,id:A,onKeyDown:g,onBlur:O&&e.popoverState===0?f=>{var b,c,M,r,v;let E=f.relatedTarget;E&&m.current&&((b=m.current)!=null&&b.contains(E)||(T({type:1}),((M=(c=e.beforePanelSentinel.current)==null?void 0:c.contains)!=null&&M.call(c,E)||(v=(r=e.afterPanelSentinel.current)==null?void 0:r.contains)!=null&&v.call(r,E))&&E.focus({preventScroll:!0})))}:void 0,tabIndex:-1},_=(0,_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .useTabDirection */ .l)(),B=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{let f=m.current;if(!f)return;function E(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(_.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Forwards */ .N.Forwards]:()=>{var c;(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .focusIn */ .jA)(f,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.First */ .TO.First)===_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .FocusResult.Error */ .fE.Error&&((c=e.afterPanelSentinel.current)==null||c.focus())},[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Backwards */ .N.Backwards]:()=>{var b;(b=e.button)==null||b.focus({preventScroll:!0})}})}E()}),D=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{let f=m.current;if(!f)return;function E(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(_.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Forwards */ .N.Forwards]:()=>{var x;if(!e.button)return;let b=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .getFocusableElements */ .GO)(),c=b.indexOf(e.button),M=b.slice(0,c+1),v=[...b.slice(c+1),...M];for(let I of v.slice())if(I.dataset.headlessuiFocusGuard==="true"||(x=e.panel)!=null&&x.contains(I)){let l=v.indexOf(I);l!==-1&&v.splice(l,1)}(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .focusIn */ .jA)(v,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.First */ .TO.First,{sorted:!1})},[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_17__/* .Direction.Backwards */ .N.Backwards]:()=>{var c;(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .focusIn */ .jA)(f,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .Focus.Previous */ .TO.Previous)===_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_4__/* .FocusResult.Error */ .fE.Error&&((c=e.button)==null||c.focus())}})}E()});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(re.Provider,{value:A},d&&p&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_18__/* .Hidden */ ._,{id:F,ref:e.beforePanelSentinel,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_18__/* .Features.Focusable */ .A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:B}),(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:h,theirProps:n,slot:L,defaultTag:Ve,features:$e,visible:d,name:"Popover.Panel"}),d&&p&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_18__/* .Hidden */ ._,{id:a,ref:e.afterPanelSentinel,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_18__/* .Features.Focusable */ .A.Focusable,"data-headlessui-focus-guard":!0,as:"button",type:"button",onFocus:D}))}let Xe="div";function Ye(t,o){let u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),A=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_2__/* .useSyncRefs */ .T)(u,o),[O,n]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),e=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>{n(i=>{let d=i.indexOf(s);if(d!==-1){let g=i.slice();return g.splice(d,1),g}return i})}),T=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>(n(i=>[...i,s]),()=>e(s))),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(()=>{var d;let s=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_20__/* .getOwnerDocument */ .r)(u);if(!s)return!1;let i=s.activeElement;return(d=u.current)!=null&&d.contains(i)?!0:O.some(g=>{var L,h;return((L=s.getElementById(g.buttonId.current))==null?void 0:L.contains(i))||((h=s.getElementById(g.panelId.current))==null?void 0:h.contains(i))})}),p=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_6__/* .useEvent */ .z)(s=>{for(let i of O)i.buttonId.current!==s&&i.close()}),F=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({registerPopover:T,unregisterPopover:e,isFocusWithinPopoverGroup:P,closeOthers:p}),[T,e,P,p]),a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({}),[]),m=t,y={ref:A};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Pe.Provider,{value:F},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .render */ .sY)({ourProps:y,theirProps:m,slot:a,defaultTag:Xe,name:"Popover.Group"}))}let qe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(we),ze=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(Ue),Qe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(je),Ze=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(Je),et=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_12__/* .forwardRefWithAs */ .yV)(Ye),kt=Object.assign(qe,{Button:ze,Overlay:Qe,Panel:Ze,Group:et});


/***/ }),

/***/ 2740:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ pe; },
/* harmony export */   "k": function() { return /* binding */ ae; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16723);
/* harmony import */ var _internal_portal_force_root_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31438);
/* harmony import */ var _hooks_use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82180);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_on_unmount_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61595);
/* harmony import */ var _hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51074);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77896);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73781);
function F(p){let l=(0,_internal_portal_force_root_js__WEBPACK_IMPORTED_MODULE_2__/* .usePortalRoot */ .n)(),n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(v),e=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__/* .useOwnerDocument */ .i)(p),[a,o]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{if(!l&&n!==null||_utils_env_js__WEBPACK_IMPORTED_MODULE_4__/* .env.isServer */ .O.isServer)return null;let t=e==null?void 0:e.getElementById("headlessui-portal-root");if(t)return t;if(e===null)return null;let r=e.createElement("div");return r.setAttribute("id","headlessui-portal-root"),e.body.appendChild(r)});return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{a!==null&&(e!=null&&e.body.contains(a)||e==null||e.body.appendChild(a))},[a,e]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{l||n!==null&&o(n.current)},[n,o,l]),a}let U=react__WEBPACK_IMPORTED_MODULE_0__.Fragment;function N(p,l){let n=p,e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),a=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__/* .useSyncRefs */ .T)((0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__/* .optionalRef */ .h)(u=>{e.current=u}),l),o=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_3__/* .useOwnerDocument */ .i)(e),t=F(e),[r]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{var u;return _utils_env_js__WEBPACK_IMPORTED_MODULE_4__/* .env.isServer */ .O.isServer?null:(u=o==null?void 0:o.createElement("div"))!=null?u:null}),i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(f),C=(0,_hooks_use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_6__/* .useServerHandoffComplete */ .H)();return (0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>{!t||!r||t.contains(r)||(r.setAttribute("data-headlessui-portal",""),t.appendChild(r))},[t,r]),(0,_hooks_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_7__/* .useIsoMorphicEffect */ .e)(()=>{if(r&&i)return i.register(r)},[i,r]),(0,_hooks_use_on_unmount_js__WEBPACK_IMPORTED_MODULE_8__/* .useOnUnmount */ .L)(()=>{var u;!t||!r||(r instanceof Node&&t.contains(r)&&t.removeChild(r),t.childNodes.length<=0&&((u=t.parentElement)==null||u.removeChild(t)))}),C?!t||!r?null:(0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)((0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .render */ .sY)({ourProps:{ref:a},theirProps:n,defaultTag:U,name:"Portal"}),r):null}let S=react__WEBPACK_IMPORTED_MODULE_0__.Fragment,v=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);function j(p,l){let{target:n,...e}=p,o={ref:(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_5__/* .useSyncRefs */ .T)(l)};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(v.Provider,{value:n},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .render */ .sY)({ourProps:o,theirProps:e,defaultTag:S,name:"Popover.Group"}))}let f=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);function ae(){let p=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(f),l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]),n=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_10__/* .useEvent */ .z)(o=>(l.current.push(o),p&&p.register(o),()=>e(o))),e=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_10__/* .useEvent */ .z)(o=>{let t=l.current.indexOf(o);t!==-1&&l.current.splice(t,1),p&&p.unregister(o)}),a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({register:n,unregister:e,portals:l}),[n,e,l]);return[l,(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>function({children:t}){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(f.Provider,{value:a},t)},[a])]}let D=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .forwardRefWithAs */ .yV)(N),I=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_9__/* .forwardRefWithAs */ .yV)(j),pe=Object.assign(D,{Group:I});


/***/ }),

/***/ 44080:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ $e; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(12351);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(32984);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
var use_is_mounted = __webpack_require__(14879);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(16723);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(82180);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(23784);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/once.js
function once_l(r){let e={called:!1};return(...t)=>{if(!e.called)return e.called=!0,r(...t)}}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.js
var disposables = __webpack_require__(9362);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/utils/transition.js
function d(t,...e){t&&e.length>0&&t.classList.add(...e)}function v(t,...e){t&&e.length>0&&t.classList.remove(...e)}function F(t,e){let n=(0,disposables/* disposables */.k)();if(!t)return n.dispose;let{transitionDuration:m,transitionDelay:o}=getComputedStyle(t),[u,p]=[m,o].map(a=>{let[r=0]=a.split(",").filter(Boolean).map(i=>i.includes("ms")?parseFloat(i):parseFloat(i)*1e3).sort((i,f)=>f-i);return r}),l=u+p;if(l!==0){n.group(r=>{r.setTimeout(()=>{e(),r.dispose()},l),r.addEventListener(t,"transitionrun",i=>{i.target===i.currentTarget&&r.dispose()})});let a=n.addEventListener(t,"transitionend",r=>{r.target===r.currentTarget&&(e(),a())})}else e();return n.add(()=>e()),n.dispose}function y(t,e,n,m){let o=n?"enter":"leave",u=(0,disposables/* disposables */.k)(),p=m!==void 0?once_l(m):()=>{};o==="enter"&&(t.removeAttribute("hidden"),t.style.display="");let l=(0,match/* match */.E)(o,{enter:()=>e.enter,leave:()=>e.leave}),a=(0,match/* match */.E)(o,{enter:()=>e.enterTo,leave:()=>e.leaveTo}),r=(0,match/* match */.E)(o,{enter:()=>e.enterFrom,leave:()=>e.leaveFrom});return v(t,...e.enter,...e.enterTo,...e.enterFrom,...e.leave,...e.leaveFrom,...e.leaveTo,...e.entered),d(t,...l,...r),u.nextFrame(()=>{v(t,...r),d(t,...a),F(t,()=>(v(t,...l),d(t,...e.entered),p()))}),u.dispose}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-disposables.js
var use_disposables = __webpack_require__(94192);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-transition.js
function use_transition_D({container:i,direction:t,classes:o,onStart:s,onStop:u}){let a=(0,use_is_mounted/* useIsMounted */.t)(),c=(0,use_disposables/* useDisposables */.G)(),r=(0,use_latest_value/* useLatestValue */.E)(t);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{let e=(0,disposables/* disposables */.k)();c.add(e.dispose);let n=i.current;if(n&&r.current!=="idle"&&a.current)return e.dispose(),s.current(r.current),e.add(y(n,o.current,r.current==="enter",()=>{e.dispose(),u.current(r.current)})),e.dispose},[t])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/class-names.js
var class_names = __webpack_require__(44067);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-flags.js
function c(a=0){let[l,r]=(0,react.useState)(a),t=(0,use_is_mounted/* useIsMounted */.t)(),o=(0,react.useCallback)(e=>{t.current&&r(u=>u|e)},[l,t]),m=(0,react.useCallback)(e=>Boolean(l&e),[l]),s=(0,react.useCallback)(e=>{t.current&&r(u=>u&~e)},[r,t]),g=(0,react.useCallback)(e=>{t.current&&r(u=>u^e)},[r]);return{flags:l,addFlag:o,hasFlag:m,removeFlag:s,toggleFlag:g}}

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js
function x(t=""){return t.split(" ").filter(n=>n.trim().length>1)}let I=(0,react.createContext)(null);I.displayName="TransitionContext";var Ce=(r=>(r.Visible="visible",r.Hidden="hidden",r))(Ce||{});function Ee(){let t=(0,react.useContext)(I);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}function be(){let t=(0,react.useContext)(_);if(t===null)throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");return t}let _=(0,react.createContext)(null);_.displayName="NestingContext";function M(t){return"children"in t?M(t.children):t.current.filter(({el:n})=>n.current!==null).filter(({state:n})=>n==="visible").length>0}function re(t,n){let r=(0,use_latest_value/* useLatestValue */.E)(t),o=(0,react.useRef)([]),N=(0,use_is_mounted/* useIsMounted */.t)(),H=(0,use_disposables/* useDisposables */.G)(),p=(0,use_event/* useEvent */.z)((s,e=render/* RenderStrategy.Hidden */.l4.Hidden)=>{let a=o.current.findIndex(({el:i})=>i===s);a!==-1&&((0,match/* match */.E)(e,{[render/* RenderStrategy.Unmount */.l4.Unmount](){o.current.splice(a,1)},[render/* RenderStrategy.Hidden */.l4.Hidden](){o.current[a].state="hidden"}}),H.microTask(()=>{var i;!M(o)&&N.current&&((i=r.current)==null||i.call(r))}))}),P=(0,use_event/* useEvent */.z)(s=>{let e=o.current.find(({el:a})=>a===s);return e?e.state!=="visible"&&(e.state="visible"):o.current.push({el:s,state:"visible"}),()=>p(s,render/* RenderStrategy.Unmount */.l4.Unmount)}),h=(0,react.useRef)([]),v=(0,react.useRef)(Promise.resolve()),T=(0,react.useRef)({enter:[],leave:[],idle:[]}),g=(0,use_event/* useEvent */.z)((s,e,a)=>{h.current.splice(0),n&&(n.chains.current[e]=n.chains.current[e].filter(([i])=>i!==s)),n==null||n.chains.current[e].push([s,new Promise(i=>{h.current.push(i)})]),n==null||n.chains.current[e].push([s,new Promise(i=>{Promise.all(T.current[e].map(([l,R])=>R)).then(()=>i())})]),e==="enter"?v.current=v.current.then(()=>n==null?void 0:n.wait.current).then(()=>a(e)):a(e)}),f=(0,use_event/* useEvent */.z)((s,e,a)=>{Promise.all(T.current[e].splice(0).map(([i,l])=>l)).then(()=>{var i;(i=h.current.shift())==null||i()}).then(()=>a(e))});return (0,react.useMemo)(()=>({children:o,register:P,unregister:p,onStart:g,onStop:f,wait:v,chains:T}),[P,p,o,g,f,T,v])}function Se(){}let xe=["beforeEnter","afterEnter","beforeLeave","afterLeave"];function ie(t){var r;let n={};for(let o of xe)n[o]=(r=t[o])!=null?r:Se;return n}function Pe(t){let n=(0,react.useRef)(ie(t));return (0,react.useEffect)(()=>{n.current=ie(t)},[t]),n}let Re="div",oe=render/* Features.RenderStrategy */.AN.RenderStrategy;function ye(t,n){let{beforeEnter:r,afterEnter:o,beforeLeave:N,afterLeave:H,enter:p,enterFrom:P,enterTo:h,entered:v,leave:T,leaveFrom:g,leaveTo:f,...s}=t,e=(0,react.useRef)(null),a=(0,use_sync_refs/* useSyncRefs */.T)(e,n),i=s.unmount?render/* RenderStrategy.Unmount */.l4.Unmount:render/* RenderStrategy.Hidden */.l4.Hidden,{show:l,appear:R,initial:d}=Ee(),[u,U]=(0,react.useState)(l?"visible":"hidden"),K=be(),{register:L,unregister:w}=K,j=(0,react.useRef)(null);(0,react.useEffect)(()=>L(e),[L,e]),(0,react.useEffect)(()=>{if(i===render/* RenderStrategy.Hidden */.l4.Hidden&&e.current){if(l&&u!=="visible"){U("visible");return}return (0,match/* match */.E)(u,{["hidden"]:()=>w(e),["visible"]:()=>L(e)})}},[u,e,L,w,l,i]);let k=(0,use_latest_value/* useLatestValue */.E)({enter:x(p),enterFrom:x(P),enterTo:x(h),entered:x(v),leave:x(T),leaveFrom:x(g),leaveTo:x(f)}),O=Pe({beforeEnter:r,afterEnter:o,beforeLeave:N,afterLeave:H}),G=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();(0,react.useEffect)(()=>{if(G&&u==="visible"&&e.current===null)throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")},[e,u,G]);let B=d&&!R,ae=(()=>!G||B||j.current===l?"idle":l?"enter":"leave")(),D=c(0),le=(0,use_event/* useEvent */.z)(C=>(0,match/* match */.E)(C,{enter:()=>{D.addFlag(open_closed/* State.Opening */.ZM.Opening),O.current.beforeEnter()},leave:()=>{D.addFlag(open_closed/* State.Closing */.ZM.Closing),O.current.beforeLeave()},idle:()=>{}})),ue=(0,use_event/* useEvent */.z)(C=>(0,match/* match */.E)(C,{enter:()=>{D.removeFlag(open_closed/* State.Opening */.ZM.Opening),O.current.afterEnter()},leave:()=>{D.removeFlag(open_closed/* State.Closing */.ZM.Closing),O.current.afterLeave()},idle:()=>{}})),V=re(()=>{U("hidden"),w(e)},K);use_transition_D({container:e,classes:k,direction:ae,onStart:(0,use_latest_value/* useLatestValue */.E)(C=>{V.onStart(e,C,le)}),onStop:(0,use_latest_value/* useLatestValue */.E)(C=>{V.onStop(e,C,ue),C==="leave"&&!M(V)&&(U("hidden"),w(e))})}),(0,react.useEffect)(()=>{B&&(i===render/* RenderStrategy.Hidden */.l4.Hidden?j.current=null:j.current=l)},[l,B,u]);let J=s,Te={ref:a};return R&&l&&d&&(J={...J,className:(0,class_names/* classNames */.A)(s.className,...k.current.enter,...k.current.enterFrom)}),react.createElement(_.Provider,{value:V},react.createElement(open_closed/* OpenClosedProvider */.up,{value:(0,match/* match */.E)(u,{["visible"]:open_closed/* State.Open */.ZM.Open,["hidden"]:open_closed/* State.Closed */.ZM.Closed})|D.flags},(0,render/* render */.sY)({ourProps:Te,theirProps:J,defaultTag:Re,features:oe,visible:u==="visible",name:"Transition.Child"})))}function Ne(t,n){let{show:r,appear:o=!1,unmount:N,...H}=t,p=(0,react.useRef)(null),P=(0,use_sync_refs/* useSyncRefs */.T)(p,n);(0,use_server_handoff_complete/* useServerHandoffComplete */.H)();let h=(0,open_closed/* useOpenClosed */.oJ)();if(r===void 0&&h!==null&&(r=(h&open_closed/* State.Open */.ZM.Open)===open_closed/* State.Open */.ZM.Open),![!0,!1].includes(r))throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");let[v,T]=(0,react.useState)(r?"visible":"hidden"),g=re(()=>{T("hidden")}),[f,s]=(0,react.useState)(!0),e=(0,react.useRef)([r]);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{f!==!1&&e.current[e.current.length-1]!==r&&(e.current.push(r),s(!1))},[e,r]);let a=(0,react.useMemo)(()=>({show:r,appear:o,initial:f}),[r,o,f]);(0,react.useEffect)(()=>{if(r)T("visible");else if(!M(g))T("hidden");else{let d=p.current;if(!d)return;let u=d.getBoundingClientRect();u.x===0&&u.y===0&&u.width===0&&u.height===0&&T("hidden")}},[r,g]);let i={unmount:N},l=(0,use_event/* useEvent */.z)(()=>{var d;f&&s(!1),(d=t.beforeEnter)==null||d.call(t)}),R=(0,use_event/* useEvent */.z)(()=>{var d;f&&s(!1),(d=t.beforeLeave)==null||d.call(t)});return react.createElement(_.Provider,{value:g},react.createElement(I.Provider,{value:a},(0,render/* render */.sY)({ourProps:{...i,as:react.Fragment,children:react.createElement(se,{ref:P,...i,...H,beforeEnter:l,beforeLeave:R})},theirProps:{},defaultTag:react.Fragment,features:oe,visible:v==="visible",name:"Transition"})))}function He(t,n){let r=(0,react.useContext)(I)!==null,o=(0,open_closed/* useOpenClosed */.oJ)()!==null;return react.createElement(react.Fragment,null,!r&&o?react.createElement(z,{ref:n,...t}):react.createElement(se,{ref:n,...t}))}let z=(0,render/* forwardRefWithAs */.yV)(Ne),se=(0,render/* forwardRefWithAs */.yV)(ye),De=(0,render/* forwardRefWithAs */.yV)(He),$e=Object.assign(z,{Child:De,Root:z});


/***/ }),

/***/ 71646:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ i; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16723);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3855);
function i(e,o){let[u,t]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(e),r=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(e);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_2__/* .useIsoMorphicEffect */ .e)(()=>t(r.current),[r,t,...o]),u}


/***/ }),

/***/ 31147:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ T; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73781);
function T(l,r,c){let[i,s]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(c),e=l!==void 0,t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1),d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);return e&&!t.current&&!u.current?(u.current=!0,t.current=e,console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")):!e&&t.current&&!d.current&&(d.current=!0,t.current=e,console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")),[e?l:i,(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(n=>(e||s(n),r==null?void 0:r(n)))]}


/***/ }),

/***/ 94192:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_disposables_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9362);
function p(){let[e]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_utils_disposables_js__WEBPACK_IMPORTED_MODULE_1__/* .disposables */ .k);return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>()=>e.dispose(),[e]),e}


/***/ }),

/***/ 14007:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3855);
function E(n,e,a,t){let i=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(a);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}


/***/ }),

/***/ 73781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3855);
let o=function(t){let e=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(t);return react__WEBPACK_IMPORTED_MODULE_0__.useCallback((...r)=>e.current(...r),[e])};


/***/ }),

/***/ 19946:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ I; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16723);
/* harmony import */ var _use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82180);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77896);
var o;let I=(o=react__WEBPACK_IMPORTED_MODULE_0__.useId)!=null?o:function(){let n=(0,_use_server_handoff_complete_js__WEBPACK_IMPORTED_MODULE_1__/* .useServerHandoffComplete */ .H)(),[e,u]=react__WEBPACK_IMPORTED_MODULE_0__.useState(n?()=>_utils_env_js__WEBPACK_IMPORTED_MODULE_2__/* .env.nextId */ .O.nextId():null);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_3__/* .useIsoMorphicEffect */ .e)(()=>{e===null&&u(_utils_env_js__WEBPACK_IMPORTED_MODULE_2__/* .env.nextId */ .O.nextId())},[e]),e!=null?""+e:void 0};


/***/ }),

/***/ 14879:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ f; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16723);
function f(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>(e.current=!0,()=>{e.current=!1}),[]),e}


/***/ }),

/***/ 16723:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77896);
let l=(e,f)=>{_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.isServer */ .O.isServer?(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(e,f):(0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(e,f)};


/***/ }),

/***/ 3855:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16723);
function s(e){let r=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e);return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{r.current=e},[e]),r}


/***/ }),

/***/ 61595:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_micro_task_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81021);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73781);
function c(t){let r=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(t),e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(e.current=!1,()=>{e.current=!0,(0,_utils_micro_task_js__WEBPACK_IMPORTED_MODULE_2__/* .microTask */ .Y)(()=>{e.current&&r()})}),[r])}


/***/ }),

/***/ 39650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ H; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(84575);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(3855);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-document-event.js
function d(e,r,n){let o=(0,use_latest_value/* useLatestValue */.E)(r);(0,react.useEffect)(()=>{function t(u){o.current(u)}return document.addEventListener(e,t,n),()=>document.removeEventListener(e,t,n)},[e,n])}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-window-event.js
var use_window_event = __webpack_require__(7815);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-outside-click.js
function H(s,m,i=!0){let l=(0,react.useRef)(!1);(0,react.useEffect)(()=>{requestAnimationFrame(()=>{l.current=i})},[i]);function a(e,o){if(!l.current||e.defaultPrevented)return;let n=o(e);if(n===null||!n.getRootNode().contains(n))return;let E=function r(t){return typeof t=="function"?r(t()):Array.isArray(t)||t instanceof Set?t:[t]}(s);for(let r of E){if(r===null)continue;let t=r instanceof HTMLElement?r:r.current;if(t!=null&&t.contains(n)||e.composed&&e.composedPath().includes(t))return}return!(0,focus_management/* isFocusableElement */.sP)(n,focus_management/* FocusableMode.Loose */.tJ.Loose)&&n.tabIndex!==-1&&e.preventDefault(),m(e,n)}let u=(0,react.useRef)(null);d("mousedown",e=>{var o,n;l.current&&(u.current=((n=(o=e.composedPath)==null?void 0:o.call(e))==null?void 0:n[0])||e.target)},!0),d("click",e=>{u.current&&(a(e,()=>u.current),u.current=null)},!0),(0,use_window_event/* useWindowEvent */.s)("blur",e=>a(e,()=>window.document.activeElement instanceof HTMLIFrameElement?window.document.activeElement:null),!0)}


/***/ }),

/***/ 51074:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15466);
function n(...e){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_1__/* .getOwnerDocument */ .r)(...e),[...e])}


/***/ }),

/***/ 14157:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16723);
function i(t){var n;if(t.type)return t.type;let e=(n=t.as)!=null?n:"button";if(typeof e=="string"&&e.toLowerCase()==="button")return"button"}function s(t,e){let[n,u]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>i(t));return (0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{u(i(t))},[t.type,t.as]),(0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{n||e.current&&e.current instanceof HTMLButtonElement&&!e.current.hasAttribute("type")&&u("button")},[n,e]),n}


/***/ }),

/***/ 65958:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46045);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73781);
/* harmony import */ var _use_owner_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51074);
function p({defaultContainers:f=[],portals:o}={}){let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),i=(0,_use_owner_js__WEBPACK_IMPORTED_MODULE_1__/* .useOwnerDocument */ .i)(t),u=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_2__/* .useEvent */ .z)(()=>{var r;let n=[];for(let e of f)e!==null&&(e instanceof HTMLElement?n.push(e):"current"in e&&e.current instanceof HTMLElement&&n.push(e.current));if(o!=null&&o.current)for(let e of o.current)n.push(e);for(let e of(r=i==null?void 0:i.querySelectorAll("html > *, body > *"))!=null?r:[])e!==document.body&&e!==document.head&&e instanceof HTMLElement&&e.id!=="headlessui-portal-root"&&(e.contains(t.current)||n.some(c=>e.contains(c))||n.push(e));return n});return{resolveContainers:u,contains:(0,_use_event_js__WEBPACK_IMPORTED_MODULE_2__/* .useEvent */ .z)(n=>u().some(r=>r.contains(n))),mainTreeNodeRef:t,MainTreeNode:(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__/* .Hidden */ ._,{features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_3__/* .Features.Hidden */ .A.Hidden,ref:t})},[t])}}


/***/ }),

/***/ 82180:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_env_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77896);
function l(){let[e,f]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.isHandoffComplete */ .O.isHandoffComplete);return e&&_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.isHandoffComplete */ .O.isHandoffComplete===!1&&f(!1),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{e!==!0&&f(!0)},[e]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>_utils_env_js__WEBPACK_IMPORTED_MODULE_1__/* .env.handoff */ .O.handoff(),[]),e}


/***/ }),

/***/ 23784:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ y; },
/* harmony export */   "h": function() { return /* binding */ T; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73781);
let u=Symbol();function T(t,n=!0){return Object.assign(t,{[u]:n})}function y(...t){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{n.current=t},[t]);let c=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(e=>{for(let o of n.current)o!=null&&(typeof o=="function"?o(e):o.current=e)});return t.every(e=>e==null||(e==null?void 0:e[u]))?void 0:c}


/***/ }),

/***/ 45662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ s; },
/* harmony export */   "l": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_window_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7815);
var s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(s||{});function n(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);return (0,_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}


/***/ }),

/***/ 55918:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ b; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/get-text-value.js
let a=/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;function o(e){var r,i;let n=(r=e.innerText)!=null?r:"",t=e.cloneNode(!0);if(!(t instanceof HTMLElement))return n;let u=!1;for(let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(),u=!0;let l=u?(i=t.innerText)!=null?i:"":n;return a.test(l)&&(l=l.replace(a,"")),l}function g(e){let n=e.getAttribute("aria-label");if(typeof n=="string")return n.trim();let t=e.getAttribute("aria-labelledby");if(t){let u=t.split(" ").map(l=>{let r=document.getElementById(l);if(r){let i=r.getAttribute("aria-label");return typeof i=="string"?i.trim():o(r).trim()}return null}).filter(Boolean);if(u.length>0)return u.join(", ")}return o(e).trim()}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(73781);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-text-value.js
function b(c){let t=(0,react.useRef)(""),r=(0,react.useRef)("");return (0,use_event/* useEvent */.z)(()=>{let e=c.current;if(!e)return"";let u=e.innerText;if(t.current===u)return r.current;let n=g(e).trim().toLowerCase();return t.current=u,r.current=n,n})}


/***/ }),

/***/ 40476:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function t(e){return[e.screenX,e.screenY]}function u(){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([-1,-1]);return{wasMoved(r){let n=t(r);return e.current[0]===n[0]&&e.current[1]===n[1]?!1:(e.current=n,!0)},update(r){e.current=t(r)}}}


/***/ }),

/***/ 31591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ F; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16723);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15466);
function F({container:e,accept:t,walk:r,enabled:c=!0}){let o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(t),l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(r);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{o.current=t,l.current=r},[t,r]),(0,_use_iso_morphic_effect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsoMorphicEffect */ .e)(()=>{if(!e||!c)return;let n=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_2__/* .getOwnerDocument */ .r)(e);if(!n)return;let f=o.current,p=l.current,d=Object.assign(i=>f(i),{acceptNode:f}),u=n.createTreeWalker(e,NodeFilter.SHOW_ELEMENT,d,!1);for(;u.nextNode();)p(u.currentNode)},[e,c,o,l])}


/***/ }),

/***/ 96599:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ m; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73781);
function m(u,t){let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]),r=(0,_use_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useEvent */ .z)(u);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{let o=[...e.current];for(let[n,a]of t.entries())if(e.current[n]!==a){let l=r(t,o);return e.current=t,l}},[r,...t])}


/***/ }),

/***/ 7815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3855);
function s(e,r,n){let o=(0,_use_latest_value_js__WEBPACK_IMPORTED_MODULE_1__/* .useLatestValue */ .E)(r);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{function t(i){o.current(i)}return window.addEventListener(e,t,n),()=>window.removeEventListener(e,t,n)},[e,n])}


/***/ }),

/***/ 46045:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ p; },
/* harmony export */   "_": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12351);
let a="div";var p=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(p||{});function s(t,o){let{features:n=1,...e}=t,d={ref:o,"aria-hidden":(n&2)===2?!0:void 0,style:{position:"fixed",top:1,left:1,width:1,height:0,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(n&4)===4&&(n&2)!==2&&{display:"none"}}};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .render */ .sY)({ourProps:d,theirProps:e,slot:{},defaultTag:a,name:"Hidden"})}let c=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_0__/* .forwardRefWithAs */ .yV)(s);


/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZM": function() { return /* binding */ d; },
/* harmony export */   "oJ": function() { return /* binding */ C; },
/* harmony export */   "up": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);n.displayName="OpenClosedContext";var d=(e=>(e[e.Open=1]="Open",e[e.Closed=2]="Closed",e[e.Closing=4]="Closing",e[e.Opening=8]="Opening",e))(d||{});function C(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(n)}function c({value:o,children:r}){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(n.Provider,{value:o},r)}


/***/ }),

/***/ 31438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ P; },
/* harmony export */   "n": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
let e=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(!1);function l(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(e)}function P(o){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(e.Provider,{value:o.force},o.children)}


/***/ }),

/***/ 64103:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ r; }
/* harmony export */ });
function r(n){let e=n.parentElement,l=null;for(;e&&!(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement&&(l=e),e=e.parentElement;let t=(e==null?void 0:e.getAttribute("disabled"))==="";return t&&i(l)?!1:t}function i(n){if(!n)return!1;let e=n.previousElementSibling;for(;e!==null;){if(e instanceof HTMLLegendElement)return!1;e=e.previousElementSibling}return!0}


/***/ }),

/***/ 11497:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ a; },
/* harmony export */   "d": function() { return /* binding */ x; }
/* harmony export */ });
function f(r){throw new Error("Unexpected object: "+r)}var a=(e=>(e[e.First=0]="First",e[e.Previous=1]="Previous",e[e.Next=2]="Next",e[e.Last=3]="Last",e[e.Specific=4]="Specific",e[e.Nothing=5]="Nothing",e))(a||{});function x(r,n){let t=n.resolveItems();if(t.length<=0)return null;let l=n.resolveActiveIndex(),s=l!=null?l:-1,d=(()=>{switch(r.focus){case 0:return t.findIndex(e=>!n.resolveDisabled(e));case 1:{let e=t.slice().reverse().findIndex((i,c,u)=>s!==-1&&u.length-c-1>=s?!1:!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 2:return t.findIndex((e,i)=>i<=s?!1:!n.resolveDisabled(e));case 3:{let e=t.slice().reverse().findIndex(i=>!n.resolveDisabled(i));return e===-1?e:t.length-1-e}case 4:return t.findIndex(e=>n.resolveId(e)===r.id);case 5:return null;default:f(r)}})();return d===-1?l:d}


/***/ }),

/***/ 44067:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ e; }
/* harmony export */ });
function e(...n){return n.filter(Boolean).join(" ")}


/***/ }),

/***/ 9362:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var _micro_task_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81021);
function o(){let n=[],r={addEventListener(e,t,s,a){return e.addEventListener(t,s,a),r.add(()=>e.removeEventListener(t,s,a))},requestAnimationFrame(...e){let t=requestAnimationFrame(...e);return r.add(()=>cancelAnimationFrame(t))},nextFrame(...e){return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e))},setTimeout(...e){let t=setTimeout(...e);return r.add(()=>clearTimeout(t))},microTask(...e){let t={current:!0};return (0,_micro_task_js__WEBPACK_IMPORTED_MODULE_0__/* .microTask */ .Y)(()=>{t.current&&e[0]()}),r.add(()=>{t.current=!1})},style(e,t,s){let a=e.style.getPropertyValue(t);return Object.assign(e.style,{[t]:s}),this.add(()=>{Object.assign(e.style,{[t]:a})})},group(e){let t=o();return e(t),this.add(()=>t.dispose())},add(e){return n.push(e),()=>{let t=n.indexOf(e);if(t>=0)for(let s of n.splice(t,1))s()}},dispose(){for(let e of n.splice(0))e()}};return r}


/***/ }),

/***/ 77896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ s; }
/* harmony export */ });
var i=Object.defineProperty;var d=(t,e,n)=>e in t?i(t,e,{enumerable:!0,configurable:!0,writable:!0,value:n}):t[e]=n;var r=(t,e,n)=>(d(t,typeof e!="symbol"?e+"":e,n),n);class o{constructor(){r(this,"current",this.detect());r(this,"handoffState","pending");r(this,"currentId",0)}set(e){this.current!==e&&(this.handoffState="pending",this.currentId=0,this.current=e)}reset(){this.set(this.detect())}nextId(){return++this.currentId}get isServer(){return this.current==="server"}get isClient(){return this.current==="client"}detect(){return typeof window=="undefined"||typeof document=="undefined"?"server":"client"}handoff(){this.handoffState==="pending"&&(this.handoffState="complete")}get isHandoffComplete(){return this.handoffState==="complete"}}let s=new o;


/***/ }),

/***/ 84575:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ y; },
/* harmony export */   "EO": function() { return /* binding */ _; },
/* harmony export */   "GO": function() { return /* binding */ f; },
/* harmony export */   "TO": function() { return /* binding */ M; },
/* harmony export */   "fE": function() { return /* binding */ N; },
/* harmony export */   "jA": function() { return /* binding */ O; },
/* harmony export */   "sP": function() { return /* binding */ h; },
/* harmony export */   "tJ": function() { return /* binding */ T; },
/* harmony export */   "wI": function() { return /* binding */ D; },
/* harmony export */   "z2": function() { return /* binding */ I; }
/* harmony export */ });
/* harmony import */ var _disposables_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9362);
/* harmony import */ var _match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _owner_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15466);
let c=["[contentEditable=true]","[tabindex]","a[href]","area[href]","button:not([disabled])","iframe","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].map(e=>`${e}:not([tabindex='-1'])`).join(",");var M=(n=>(n[n.First=1]="First",n[n.Previous=2]="Previous",n[n.Next=4]="Next",n[n.Last=8]="Last",n[n.WrapAround=16]="WrapAround",n[n.NoScroll=32]="NoScroll",n))(M||{}),N=(o=>(o[o.Error=0]="Error",o[o.Overflow=1]="Overflow",o[o.Success=2]="Success",o[o.Underflow=3]="Underflow",o))(N||{}),F=(t=>(t[t.Previous=-1]="Previous",t[t.Next=1]="Next",t))(F||{});function f(e=document.body){return e==null?[]:Array.from(e.querySelectorAll(c)).sort((r,t)=>Math.sign((r.tabIndex||Number.MAX_SAFE_INTEGER)-(t.tabIndex||Number.MAX_SAFE_INTEGER)))}var T=(t=>(t[t.Strict=0]="Strict",t[t.Loose=1]="Loose",t))(T||{});function h(e,r=0){var t;return e===((t=(0,_owner_js__WEBPACK_IMPORTED_MODULE_0__/* .getOwnerDocument */ .r)(e))==null?void 0:t.body)?!1:(0,_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(r,{[0](){return e.matches(c)},[1](){let l=e;for(;l!==null;){if(l.matches(c))return!0;l=l.parentElement}return!1}})}function D(e){let r=(0,_owner_js__WEBPACK_IMPORTED_MODULE_0__/* .getOwnerDocument */ .r)(e);(0,_disposables_js__WEBPACK_IMPORTED_MODULE_2__/* .disposables */ .k)().nextFrame(()=>{r&&!h(r.activeElement,0)&&y(e)})}var w=(t=>(t[t.Keyboard=0]="Keyboard",t[t.Mouse=1]="Mouse",t))(w||{});typeof window!="undefined"&&typeof document!="undefined"&&(document.addEventListener("keydown",e=>{e.metaKey||e.altKey||e.ctrlKey||(document.documentElement.dataset.headlessuiFocusVisible="")},!0),document.addEventListener("click",e=>{e.detail===1?delete document.documentElement.dataset.headlessuiFocusVisible:e.detail===0&&(document.documentElement.dataset.headlessuiFocusVisible="")},!0));function y(e){e==null||e.focus({preventScroll:!0})}let S=["textarea","input"].join(",");function H(e){var r,t;return(t=(r=e==null?void 0:e.matches)==null?void 0:r.call(e,S))!=null?t:!1}function I(e,r=t=>t){return e.slice().sort((t,l)=>{let o=r(t),i=r(l);if(o===null||i===null)return 0;let n=o.compareDocumentPosition(i);return n&Node.DOCUMENT_POSITION_FOLLOWING?-1:n&Node.DOCUMENT_POSITION_PRECEDING?1:0})}function _(e,r){return O(f(),r,{relativeTo:e})}function O(e,r,{sorted:t=!0,relativeTo:l=null,skipElements:o=[]}={}){let i=Array.isArray(e)?e.length>0?e[0].ownerDocument:document:e.ownerDocument,n=Array.isArray(e)?t?I(e):e:f(e);o.length>0&&n.length>1&&(n=n.filter(s=>!o.includes(s))),l=l!=null?l:i.activeElement;let E=(()=>{if(r&5)return 1;if(r&10)return-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),x=(()=>{if(r&1)return 0;if(r&2)return Math.max(0,n.indexOf(l))-1;if(r&4)return Math.max(0,n.indexOf(l))+1;if(r&8)return n.length-1;throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")})(),p=r&32?{preventScroll:!0}:{},d=0,a=n.length,u;do{if(d>=a||d+a<=0)return 0;let s=x+d;if(r&16)s=(s+a)%a;else{if(s<0)return 3;if(s>=a)return 1}u=n[s],u==null||u.focus(p),d+=E}while(u!==i.activeElement);return r&6&&H(u)&&u.select(),2}


/***/ }),

/***/ 18689:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ p; },
/* harmony export */   "t": function() { return /* binding */ e; }
/* harmony export */ });
function e(n={},r=null,t=[]){for(let[i,o]of Object.entries(n))f(t,s(r,i),o);return t}function s(n,r){return n?n+"["+r+"]":r}function f(n,r,t){if(Array.isArray(t))for(let[i,o]of t.entries())f(n,s(r,i.toString()),o);else t instanceof Date?n.push([r,t.toISOString()]):typeof t=="boolean"?n.push([r,t?"1":"0"]):typeof t=="string"?n.push([r,t]):typeof t=="number"?n.push([r,`${t}`]):t==null?n.push([r,""]):e(t,r,n)}function p(n){var t;let r=(t=n==null?void 0:n.form)!=null?t:n.closest("form");if(r){for(let i of r.elements)if(i.tagName==="INPUT"&&i.type==="submit"||i.tagName==="BUTTON"&&i.type==="submit"||i.nodeName==="INPUT"&&i.type==="image"){i.click();return}}}


/***/ }),

/***/ 32984:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ u; }
/* harmony export */ });
function u(r,n,...a){if(r in n){let e=n[r];return typeof e=="function"?e(...a):e}let t=new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map(e=>`"${e}"`).join(", ")}.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,u),t}


/***/ }),

/***/ 81021:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ t; }
/* harmony export */ });
function t(e){typeof queueMicrotask=="function"?queueMicrotask(e):Promise.resolve().then(e).catch(o=>setTimeout(()=>{throw o}))}


/***/ }),

/***/ 15466:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ e; }
/* harmony export */ });
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77896);
function e(r){return _env_js__WEBPACK_IMPORTED_MODULE_0__/* .env.isServer */ .O.isServer?null:r instanceof Node?r.ownerDocument:r!=null&&r.hasOwnProperty("current")&&r.current instanceof Node?r.current.ownerDocument:document}


/***/ }),

/***/ 78657:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gn": function() { return /* binding */ t; },
/* harmony export */   "tq": function() { return /* binding */ n; }
/* harmony export */ });
/* unused harmony export isAndroid */
function t(){return/iPhone/gi.test(window.navigator.platform)||/Mac/gi.test(window.navigator.platform)&&window.navigator.maxTouchPoints>0}function i(){return/Android/gi.test(window.navigator.userAgent)}function n(){return t()||i()}


/***/ }),

/***/ 12351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ S; },
/* harmony export */   "l4": function() { return /* binding */ j; },
/* harmony export */   "oA": function() { return /* binding */ R; },
/* harmony export */   "sY": function() { return /* binding */ X; },
/* harmony export */   "yV": function() { return /* binding */ D; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _class_names_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44067);
/* harmony import */ var _match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
var S=(a=>(a[a.None=0]="None",a[a.RenderStrategy=1]="RenderStrategy",a[a.Static=2]="Static",a))(S||{}),j=(e=>(e[e.Unmount=0]="Unmount",e[e.Hidden=1]="Hidden",e))(j||{});function X({ourProps:r,theirProps:t,slot:e,defaultTag:a,features:s,visible:n=!0,name:f}){let o=N(t,r);if(n)return c(o,e,a,f);let u=s!=null?s:0;if(u&2){let{static:l=!1,...p}=o;if(l)return c(p,e,a,f)}if(u&1){let{unmount:l=!0,...p}=o;return (0,_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(l?0:1,{[0](){return null},[1](){return c({...p,hidden:!0,style:{display:"none"}},e,a,f)}})}return c(o,e,a,f)}function c(r,t={},e,a){let{as:s=e,children:n,refName:f="ref",...o}=g(r,["unmount","static"]),u=r.ref!==void 0?{[f]:r.ref}:{},l=typeof n=="function"?n(t):n;"className"in o&&o.className&&typeof o.className=="function"&&(o.className=o.className(t));let p={};if(t){let i=!1,m=[];for(let[y,d]of Object.entries(t))typeof d=="boolean"&&(i=!0),d===!0&&m.push(y);i&&(p["data-headlessui-state"]=m.join(" "))}if(s===react__WEBPACK_IMPORTED_MODULE_0__.Fragment&&Object.keys(R(o)).length>0){if(!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(l)||Array.isArray(l)&&l.length>1)throw new Error(['Passing props on "Fragment"!',"",`The current component <${a} /> is rendering a "Fragment".`,"However we need to passthrough the following props:",Object.keys(o).map(d=>`  - ${d}`).join(`
`),"","You can apply a few solutions:",['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',"Render a single element as the child so that we can forward the props onto that element."].map(d=>`  - ${d}`).join(`
`)].join(`
`));let i=l.props,m=typeof(i==null?void 0:i.className)=="function"?(...d)=>(0,_class_names_js__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .A)(i==null?void 0:i.className(...d),o.className):(0,_class_names_js__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .A)(i==null?void 0:i.className,o.className),y=m?{className:m}:{};return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(l,Object.assign({},N(l.props,R(g(o,["ref"]))),p,u,w(l.ref,u.ref),y))}return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(s,Object.assign({},g(o,["ref"]),s!==react__WEBPACK_IMPORTED_MODULE_0__.Fragment&&u,s!==react__WEBPACK_IMPORTED_MODULE_0__.Fragment&&p),l)}function w(...r){return{ref:r.every(t=>t==null)?void 0:t=>{for(let e of r)e!=null&&(typeof e=="function"?e(t):e.current=t)}}}function N(...r){var a;if(r.length===0)return{};if(r.length===1)return r[0];let t={},e={};for(let s of r)for(let n in s)n.startsWith("on")&&typeof s[n]=="function"?((a=e[n])!=null||(e[n]=[]),e[n].push(s[n])):t[n]=s[n];if(t.disabled||t["aria-disabled"])return Object.assign(t,Object.fromEntries(Object.keys(e).map(s=>[s,void 0])));for(let s in e)Object.assign(t,{[s](n,...f){let o=e[s];for(let u of o){if((n instanceof Event||(n==null?void 0:n.nativeEvent)instanceof Event)&&n.defaultPrevented)return;u(n,...f)}}});return t}function D(r){var t;return Object.assign((0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(r),{displayName:(t=r.displayName)!=null?t:r.name})}function R(r){let t=Object.assign({},r);for(let e in t)t[e]===void 0&&delete t[e];return t}function g(r,t=[]){let e=Object.assign({},r);for(let a of t)a in e&&delete e[a];return e}


/***/ }),

/***/ 36609:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ instance; },
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* unused harmony exports changeLanguage, createInstance, dir, exists, getFixedT, hasLoadedNamespace, init, loadLanguages, loadNamespaces, loadResources, reloadResources, setDefaultNamespace, use */
const consoleLogger = {
  type: 'logger',
  log(args) {
    this.output('log', args);
  },
  warn(args) {
    this.output('warn', args);
  },
  error(args) {
    this.output('error', args);
  },
  output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
class Logger {
  constructor(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.init(concreteLogger, options);
  }
  init(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return this.forward(args, 'log', '', true);
  }
  warn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return this.forward(args, 'warn', '', true);
  }
  error() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return this.forward(args, 'error', '');
  }
  deprecate() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();

class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(' ').forEach(event => {
      this.observers[event] = this.observers[event] || [];
      this.observers[event].push(listener);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event] = this.observers[event].filter(l => l !== listener);
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (this.observers[event]) {
      const cloned = [].concat(this.observers[event]);
      cloned.forEach(observer => {
        observer(...args);
      });
    }
    if (this.observers['*']) {
      const cloned = [].concat(this.observers['*']);
      cloned.forEach(observer => {
        observer.apply(observer, [event, ...args]);
      });
    }
  }
}

function defer() {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  const stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    const key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  const value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (const prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }
  return data;
}
const chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = new RegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  const paths = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      let j = 2;
      let p = paths.slice(i, i + j).join(keySeparator);
      let mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      const joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}
function getCleanedCode(code) {
  if (code && code.indexOf('_') > 0) return code.replace('_', '-');
  return code;
}

class ResourceStore extends EventEmitter {
  constructor(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    if (this.options.ignoreJSONStructure === undefined) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }
    const result = getPath(this.data, path);
    if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
    return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
  }
  addResource(lng, ns, key, value) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      silent: false
    };
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  }
  addResources(lng, ns, resources) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      silent: false
    };
    for (const m in resources) {
      if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
      silent: false
    };
    let path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath(this.data, path) || {};
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    if (this.options.compatibilityAPI === 'v1') return {
      ...{},
      ...this.getResource(lng, ns)
    };
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}

var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach(processor => {
      if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

const checkedLoadedFor = {};
class Translator extends EventEmitter {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    this.logger = baseLogger.create('translator');
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    if (key === undefined || key === null) {
      return false;
    }
    const resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  }
  extractFromKey(key, options) {
    let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let namespaces = options.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];
    return {
      key,
      namespaces
    };
  }
  translate(keys, options, lastKey) {
    if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) {
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof options === 'object') options = {
      ...options
    };
    if (!options) options = {};
    if (keys === undefined || keys === null) return '';
    if (!Array.isArray(keys)) keys = [String(keys)];
    const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], options);
    const namespace = namespaces[namespaces.length - 1];
    const lng = options.lng || this.language;
    const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        const nsSeparator = options.nsSeparator || this.options.nsSeparator;
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, options);
    let res = resolved && resolved.res;
    const resUsedKey = resolved && resolved.usedKey || key;
    const resExactUsedKey = resolved && resolved.exactUsedKey || key;
    const resType = Object.prototype.toString.apply(res);
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
          ...options,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = resType === '[object Array]';
        const copy = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            copy[m] = this.translate(deepKey, {
              ...options,
              ...{
                joinArrays: false,
                ns: namespaces
              }
            });
            if (copy[m] === deepKey) copy[m] = res[m];
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      const hasDefaultValue = Translator.hasDefaultValue(options);
      const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
      const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
        ordinal: false
      }) : '';
      const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...options,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
          }
          this.emit('missingKey', l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(language => {
              this.pluralResolver.getSuffixes(language, options).forEach(suffix => {
                send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, options, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        if (this.options.compatibilityAPI !== 'v1') {
          res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        } else {
          res = this.options.parseMissingKeyHandler(res);
        }
      }
    }
    if (returnDetails) {
      resolved.res = res;
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, options, resolved, lastKey) {
    var _this = this;
    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...options
      }, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!options.skipInterpolation) {
      if (options.interpolation) this.interpolator.init({
        ...options,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...options.interpolation
          }
        }
      });
      const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) options.nest = false;
      }
      if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (lastKey && lastKey[0] === args[0] && !options.context) {
          _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return _this.translate(...args, key);
      }, options);
      if (options.interpolation) this.interpolator.reset();
    }
    const postProcess = options.postProcess || this.options.postProcess;
    const postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: resolved,
        ...options
      } : options, this);
    }
    return res;
  }
  resolve(keys) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (typeof keys === 'string') keys = [keys];
    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, options);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
      const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
      const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        }
        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              finalKeys.push(key + pluralSuffix);
              if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                finalKeys.push(contextKey + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  }
  getResource(code, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  static hasDefaultValue(options) {
    const prefix = 'defaultValue';
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
        return true;
      }
    }
    return false;
  }
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === 'x') return null;
    return this.formatLanguageCode(p.join('-'));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      const specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      let p = code.split('-');
      if (this.options.lowerCaseLng) {
        p = p.map(part => part.toLowerCase());
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }
      return p.join('-');
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach(code => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach(code => {
        if (found) return;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find(supportedLng => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
          if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = c => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}

let sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
let _rulesPluralsTypes = {
  1: function (n) {
    return Number(n > 1);
  },
  2: function (n) {
    return Number(n != 1);
  },
  3: function (n) {
    return 0;
  },
  4: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function (n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function (n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function (n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function (n) {
    return Number(n >= 2);
  },
  10: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function (n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function (n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function (n) {
    return Number(n !== 0);
  },
  14: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function (n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function (n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function (n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function (n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function (n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
const nonIntlVersions = ['v1', 'v2', 'v3'];
const intlVersions = ['v4'];
const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  const rules = {};
  sets.forEach(set => {
    set.lngs.forEach(l => {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
class PluralResolver {
  constructor(languageUtils) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  addRule(lng, obj) {
    this.rules[lng] = obj;
  }
  getRule(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      try {
        return new Intl.PluralRules(getCleanedCode(code), {
          type: options.ordinal ? 'ordinal' : 'cardinal'
        });
      } catch {
        return;
      }
    }
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  }
  needsPlural(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (this.shouldUseIntlApi()) {
      return rule && rule.resolvedOptions().pluralCategories.length > 1;
    }
    return rule && rule.numbers.length > 1;
  }
  getPluralFormsOfKey(code, key) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
  }
  getSuffixes(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (!rule) {
      return [];
    }
    if (this.shouldUseIntlApi()) {
      return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    return rule.numbers.map(number => this.getSuffix(code, number, options));
  }
  getSuffix(code, count) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const rule = this.getRule(code, options);
    if (rule) {
      if (this.shouldUseIntlApi()) {
        return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
      }
      return this.getSuffixRetroCompatible(rule, count);
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return '';
  }
  getSuffixRetroCompatible(rule, count) {
    const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
    let suffix = rule.numbers[idx];
    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      if (suffix === 2) {
        suffix = 'plural';
      } else if (suffix === 1) {
        suffix = '';
      }
    }
    const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
    if (this.options.compatibilityJSON === 'v1') {
      if (suffix === 1) return '';
      if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
      return returnSuffix();
    } else if (this.options.compatibilityJSON === 'v2') {
      return returnSuffix();
    } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      return returnSuffix();
    }
    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
  }
  shouldUseIntlApi() {
    return !nonIntlVersions.includes(this.options.compatibilityJSON);
  }
}

function deepFindWithDefaults(data, defaultData, key) {
  let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
class Interpolator {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || (value => value);
    this.init(options);
  }
  init() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const iOpts = options.interpolation;
    this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
    this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
    this.regexp = new RegExp(regexpStr, 'g');
    const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
    const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }
    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, undefined, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: val => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach(todo => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            const temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = '';
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let match;
    let value;
    let clonedOptions;
    function handleHasOptions(key, inheritedOptions) {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${sep}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      delete clonedOptions.defaultValue;
      return key;
    }
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      let doReduce = false;
      if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
        const r = match[1].split(this.formatSeparator).map(elem => elem.trim());
        match[1] = r.shift();
        formatters = r;
        doReduce = true;
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && typeof value !== 'string') return value;
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }
      if (doReduce) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}

function parseFormatStr(formatStr) {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    const p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(';');
      opts.forEach(opt => {
        if (!opt) return;
        const [key, ...rest] = opt.split(':');
        const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
}
function createCachedFormatter(fn) {
  const cache = {};
  return function invokeFormatter(val, lng, options) {
    const key = lng + JSON.stringify(options);
    let formatter = cache[key];
    if (!formatter) {
      formatter = fn(getCleanedCode(lng), options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
class Formatter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      currency: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: 'currency'
        });
        return val => formatter.format(val);
      }),
      datetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      relativetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val, opt.range || 'day');
      }),
      list: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      })
    };
    this.init(options);
  }
  init(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    const iOpts = options.interpolation;
    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const formats = format.split(this.formatSeparator);
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
class Connector extends EventEmitter {
  constructor(backend, store, services) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create('backendConnector');
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    if (this.backend && this.backend.init) {
      this.backend.init(services, options.backend, options);
    }
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          if (pending[name] === undefined) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === undefined) pending[name] = true;
          if (toLoad[name] === undefined) toLoad[name] = true;
          if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit('failedLoading', lng, ns, err);
    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }
    this.state[name] = err ? -1 : 2;
    const loaded = {};
    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach(n => {
              if (loaded[l][n] === undefined) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit('loaded', loaded);
    this.queue = this.queue.filter(q => !q.done);
  }
  read(lng, ns, fcName) {
    let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
    let callback = arguments.length > 5 ? arguments[5] : undefined;
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === 'function') {
          r.then(data => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let callback = arguments.length > 3 ? arguments[3] : undefined;
    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : () => {};
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    }
    if (key === undefined || key === null || key === '') return;
    if (this.backend && this.backend.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === 'function') {
            r.then(data => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: false,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      let ret = {};
      if (typeof args[1] === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (typeof args[2] === 'object' || typeof args[3] === 'object') {
        const options = args[3] || args[2];
        Object.keys(options).forEach(key => {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: (value, format, lng, options) => value,
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}

function noop() {}
function bindMemberFunctions(inst) {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(mem => {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
class I18n extends EventEmitter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initImmediate) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init() {
    var _this = this;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options.defaultNS && options.defaultNS !== false && options.ns) {
      if (typeof options.ns === 'string') {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf('translation') < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    if (this.options.compatibilityAPI !== 'v1') {
      this.options.interpolation = {
        ...defOpts.interpolation,
        ...this.options.interpolation
      };
    }
    if (options.keySeparator !== undefined) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== undefined) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else if (typeof Intl !== 'undefined') {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this.emit(event, ...args);
      });
      this.modules.external.forEach(m => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    }
    const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(fcName => {
      this[fcName] = function () {
        return _this.store[fcName](...arguments);
      };
    });
    const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
    storeApiChained.forEach(fcName => {
      this[fcName] = function () {
        _this.store[fcName](...arguments);
        return _this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t) => {
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t);
        callback(err, t);
      };
      if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    let usedCallback = callback;
    const usedLng = typeof language === 'string' ? language : this.language;
    if (typeof language === 'function') usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
      const toLoad = [];
      const append = lng => {
        if (!lng) return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      }
      if (this.options.preload) {
        this.options.preload.forEach(l => append(l));
      }
      this.services.backendConnector.load(toLoad, this.options.ns, e => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
    if (module.type === 'backend') {
      this.modules.backend = module;
    }
    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }
    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }
    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === 'formatter') {
      this.modules.formatter = module;
    }
    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (['cimode', 'dev'].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
  }
  changeLanguage(lng, callback) {
    var _this2 = this;
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit('languageChanging', lng);
    const setLngProps = l => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = undefined;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        setLngProps(l);
        this.translator.changeLanguage(l);
        this.isLanguageChangingTo = undefined;
        this.emit('languageChanged', l);
        this.logger.log('languageChanged', l);
      } else {
        this.isLanguageChangingTo = undefined;
      }
      deferred.resolve(function () {
        return _this2.t(...arguments);
      });
      if (callback) callback(err, function () {
        return _this2.t(...arguments);
      });
    };
    const setLng = lngs => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
      }
      this.loadResources(l, err => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    var _this3 = this;
    const fixedT = function (key, opts) {
      let options;
      if (typeof opts !== 'object') {
        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }
        options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        options = {
          ...opts
        };
      }
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const keySeparator = _this3.options.keySeparator || '.';
      let resultKey;
      if (options.keyPrefix && Array.isArray(key)) {
        resultKey = key.map(k => `${options.keyPrefix}${keySeparator}${k}`);
      } else {
        resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
      }
      return _this3.t(resultKey, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== undefined) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (typeof ns === 'string') ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (typeof lngs === 'string') lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0);
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
    if (!lng) return 'rtl';
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
    const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
  }
  static createInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
  }
  cloneInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== undefined || options.prefix !== undefined) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      clone.store = new ResourceStore(this.store.data, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

const createInstance = instance.createInstance;
const dir = instance.dir;
const init = instance.init;
const loadResources = instance.loadResources;
const reloadResources = instance.reloadResources;
const use = instance.use;
const changeLanguage = instance.changeLanguage;
const getFixedT = instance.getFixedT;
const t = instance.t;
const exists = instance.exists;
const setDefaultNamespace = instance.setDefaultNamespace;
const hasLoadedNamespace = instance.hasLoadedNamespace;
const loadNamespaces = instance.loadNamespaces;
const loadLanguages = instance.loadLanguages;




/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 10748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 37247:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 45959:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 63553:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14027);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10748);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 67421:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Db": function() { return /* reexport */ initReactI18next; },
  "$G": function() { return /* reexport */ useTranslation_useTranslation; }
});

// UNUSED EXPORTS: I18nContext, I18nextProvider, Trans, TransWithoutContext, Translation, composeInitialProps, date, getDefaults, getI18n, getInitialProps, number, plural, select, selectOrdinal, setDefaults, setI18n, time, useSSR, withSSR, withTranslation

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/void-elements/index.js
var void_elements = __webpack_require__(71739);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ var html_parse_stringify_module = ((/* unused pure expression or super */ null && (c)));
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function utils_warn() {
  if (console && console.warn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
    console.warn(...args);
  }
}
const alreadyWarned = {};
function utils_warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  utils_warn(...args);
}
const loadedClb = (i18n, cb) => () => {
  if (i18n.isInitialized) {
    cb();
  } else {
    const initialized = () => {
      setTimeout(() => {
        i18n.off('initialized', initialized);
      }, 0);
      cb();
    };
    i18n.on('initialized', initialized);
  }
};
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(n => {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const lng = i18n.languages[0];
  const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  const lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  const loadNotPending = (l, n) => {
    const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    utils_warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: (i18nInstance, loadNotPending) => {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function utils_getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
const unescapeHtmlEntity = m => htmlEntities[m];
const unescape_unescape = text => text.replace(matchHtmlEntity, unescapeHtmlEntity);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/defaults.js

let defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
function setDefaults() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = {
    ...defaultOptions,
    ...options
  };
}
function defaults_getDefaults() {
  return defaultOptions;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/TransWithoutContext.js





function hasChildren(node, checkLength) {
  if (!node) return false;
  const base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}
function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}
function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(child => isValidElement(child));
}
function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}
function mergeProps(source, target) {
  const newTarget = {
    ...target
  };
  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}
function nodesToString(children, i18nOptions) {
  if (!children) return '';
  let stringNode = '';
  const childrenArray = getAsArray(children);
  const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach((child, childIndex) => {
    if (typeof child === 'string') {
      stringNode += `${child}`;
    } else if (isValidElement(child)) {
      const childPropsCount = Object.keys(child.props).length;
      const shouldKeepChild = keepArray.indexOf(child.type) > -1;
      const childChildren = child.props.children;
      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += `<${child.type}/>`;
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (child.props.i18nIsDynamicList) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += `<${child.type}>${childChildren}</${child.type}>`;
      } else {
        const content = nodesToString(childChildren, i18nOptions);
        stringNode += `<${childIndex}>${content}</${childIndex}>`;
      }
    } else if (child === null) {
      warn(`Trans: the passed in value is invalid - seems you passed in a null child.`);
    } else if (typeof child === 'object') {
      const {
        format,
        ...clone
      } = child;
      const keys = Object.keys(clone);
      if (keys.length === 1) {
        const value = format ? `${keys[0]}, ${format}` : keys[0];
        stringNode += `{{${value}}}`;
      } else {
        warn(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
      }
    } else {
      warn(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    }
  });
  return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  const data = {};
  function getData(childs) {
    const childrenArray = getAsArray(childs);
    childrenArray.forEach(child => {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (typeof child === 'object' && !isValidElement(child)) Object.assign(data, child);
    });
  }
  getData(children);
  const ast = HTML.parse(`<0>${targetString}</0>`);
  const opts = {
    ...data,
    ...combinedTOpts
  };
  function renderInner(child, node, rootReactNode) {
    const childs = getChildren(child);
    const mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }
  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(cloneElement(child, {
      ...child.props,
      key: i
    }, isVoid ? undefined : inner));
  }
  function mapAST(reactNode, astNode, rootReactNode) {
    const reactNodes = getAsArray(reactNode);
    const astNodes = getAsArray(astNode);
    return astNodes.reduce((mem, node, i) => {
      const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
      if (node.type === 'tag') {
        let tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        const child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        const isElement = isValidElement(child);
        const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === 'object' && child.dummy && !isElement;
        const isKnownComponent = typeof children === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
        if (typeof child === 'string') {
          const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
          const inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (isEmptyTransWithHTML) {
          const inner = mapAST(reactNodes, node.children, rootReactNode);
          mem.push(cloneElement(child, {
            ...child.props,
            key: i
          }, inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            const inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: `${node.name}-${i}`
              }));
            } else {
              const inner = mapAST(reactNodes, node.children, rootReactNode);
              mem.push(createElement(node.name, {
                key: `${node.name}-${i}`
              }, inner));
            }
          } else if (node.voidElement) {
            mem.push(`<${node.name} />`);
          } else {
            const inner = mapAST(reactNodes, node.children, rootReactNode);
            mem.push(`<${node.name}>${inner}</${node.name}>`);
          }
        } else if (typeof child === 'object' && !isElement) {
          const content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(cloneElement(child, {
            ...child.props,
            key: i
          }, translationContent));
        } else {
          mem.push(cloneElement(child, {
            ...child.props,
            key: i
          }));
        }
      } else if (node.type === 'text') {
        const wrapTextNodes = i18nOptions.transWrapTextNodes;
        const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: `${node.name}-${i}`
          }, content));
        } else {
          mem.push(content);
        }
      }
      return mem;
    }, []);
  }
  const result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}
function Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const i18n = i18nFromProps || getI18n();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }
  const t = tFromProps || i18n.t.bind(i18n) || (k => k);
  if (context) tOptions.context = context;
  const reactI18nextOptions = {
    ...getDefaults(),
    ...(i18n.options && i18n.options.react)
  };
  let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  const defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  const {
    hashTransKey
  } = reactI18nextOptions;
  const key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  const interpolationOverride = values ? tOptions.interpolation : {
    interpolation: {
      ...tOptions.interpolation,
      prefix: '#$?',
      suffix: '?$#'
    }
  };
  const combinedTOpts = {
    ...tOptions,
    count,
    ...values,
    ...interpolationOverride,
    defaultValue,
    ns: namespaces
  };
  const translation = key ? t(key, combinedTOpts) : defaultValue;
  const content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/i18nInstance.js
let i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function i18nInstance_getI18n() {
  return i18nInstance;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/initReactI18next.js


const initReactI18next = {
  type: '3rdParty',
  init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js





const context_I18nContext = (0,react.createContext)();
class ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(namespaces) {
    namespaces.forEach(ns => {
      if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function context_composeInitialProps(ForComponent) {
  return ctx => new Promise(resolve => {
    const i18nInitialProps = getInitialProps();
    if (ForComponent.getInitialProps) {
      ForComponent.getInitialProps(ctx).then(componentsInitialProps => {
        resolve({
          ...componentsInitialProps,
          ...i18nInitialProps
        });
      });
    } else {
      resolve(i18nInitialProps);
    }
  });
}
function getInitialProps() {
  const i18n = getI18n();
  const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  const ret = {};
  const initialI18nStore = {};
  i18n.languages.forEach(l => {
    initialI18nStore[l] = {};
    namespaces.forEach(ns => {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Trans.js




function Trans_Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  const t = tFromProps || i18n && i18n.t.bind(i18n);
  return TransWithoutContext({
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions,
    values,
    defaults,
    components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  });
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



const usePrevious = (value, ignore) => {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation_useTranslation(ns) {
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = (0,react.useContext)(context_I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || i18nInstance_getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    utils_warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    const notReadyT = (k, optsOrDefaultValue) => {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    const retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) utils_warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  const i18nOptions = {
    ...defaults_getDefaults(),
    ...i18n.options.react,
    ...props
  };
  const {
    useSuspense,
    keyPrefix
  } = i18nOptions;
  let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(n => hasLoadedNamespace(n, i18n, i18nOptions));
  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  const [t, setT] = (0,react.useState)(getT);
  let joinedNS = namespaces.join();
  if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
  const previousJoinedNS = usePrevious(joinedNS);
  const isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    const {
      bindI18n,
      bindI18nStore
    } = i18nOptions;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      }
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return () => {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(e => i18n.off(e, boundReset));
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(e => i18n.store.off(e, boundReset));
    };
  }, [i18n, joinedNS]);
  const isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n, keyPrefix]);
  const ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(resolve => {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, () => resolve());
    } else {
      loadNamespaces(i18n, namespaces, () => resolve());
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js



function withTranslation(ns) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      let {
        forwardedRef,
        ...rest
      } = _ref;
      const [t, i18n, ready] = useTranslation(ns, {
        ...rest,
        keyPrefix: options.keyPrefix
      });
      const passDownProps = {
        ...rest,
        t,
        i18n,
        tReady: ready
      };
      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }
      return createElement(WrappedComponent, passDownProps);
    }
    I18nextWithTranslation.displayName = `withI18nextTranslation(${getDisplayName(WrappedComponent)})`;
    I18nextWithTranslation.WrappedComponent = WrappedComponent;
    const forwardRef = (props, ref) => createElement(I18nextWithTranslation, Object.assign({}, props, {
      forwardedRef: ref
    }));
    return options.withRef ? forwardRefReact(forwardRef) : I18nextWithTranslation;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Translation.js

function Translation(props) {
  const {
    ns,
    children,
    ...options
  } = props;
  const [t, i18n, ready] = useTranslation(ns, options);
  return children(t, {
    i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  let {
    i18n,
    defaultNS,
    children
  } = _ref;
  const value = useMemo(() => ({
    i18n,
    defaultNS
  }), [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useSSR.js


function useSSR_useSSR(initialI18nStore, initialLanguage) {
  let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;
  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources) => {
      Object.keys(lngResources).forEach(ns => {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }
  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withSSR.js




function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      let {
        initialI18nStore,
        initialLanguage,
        ...rest
      } = _ref;
      useSSR(initialI18nStore, initialLanguage);
      return createElement(WrappedComponent, {
        ...rest
      });
    }
    I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
    I18nextWithSSR.displayName = `withI18nextSSR(${getDisplayName(WrappedComponent)})`;
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/index.js












const date = () => '';
const time = () => '';
const number = () => '';
const es_select = () => '';
const plural = () => '';
const selectOrdinal = () => '';

/***/ }),

/***/ 84917:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"ENVIRONMENTS":"{\\"PROD\\":\\"https://app.qure.ai\\",\\"ALPHA\\":\\"https://alpha-app.qure.ai\\",\\"BETA\\":\\"https://beta-app.qure.ai\\"}"}');

/***/ }),

/***/ 53765:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');

/***/ }),

/***/ 19794:
/***/ (function(module) {

"use strict";
module.exports = {"version":"1.0.34"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(91118), __webpack_exec__(69898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);